"use client"
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField2 = (obj, key, value) => {
  __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg2) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg2);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = (obj, member, setter, getter) => ({
  set _(value) {
    __privateSet(obj, member, value, setter);
  },
  get _() {
    return __privateGet(obj, member, getter);
  }
});
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _a2, _b2, _c, _d, _e, _f;
import * as mapboxgl from "mapbox-gl";
import mapboxgl__default from "mapbox-gl";
import * as React from "react";
import React__default, { useState, useCallback, useContext, useMemo, useLayoutEffect as useLayoutEffect$1, useEffect, forwardRef, useRef, useImperativeHandle, cloneElement, useDebugValue, isValidElement, PureComponent, Component as Component$1, createRef as createRef$1, useReducer, createContext, createElement } from "react";
import require$$0$2, { createPortal } from "react-dom";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import Icon, { CloseOutlined, DownOutlined, PushpinFilled, UpOutlined, CaretUpOutlined, CaretDownOutlined, FileImageOutlined, EyeInvisibleOutlined, SaveOutlined, QuestionCircleOutlined, RightCircleFilled, CloseCircleFilled, PaperClipOutlined, DownloadOutlined, UploadOutlined, CheckCircleFilled, EnvironmentOutlined, LeftOutlined, DeleteOutlined, CheckOutlined, PlusOutlined, RightOutlined, AppstoreOutlined, EditOutlined, StarOutlined, MoreOutlined, AimOutlined, UnderlineOutlined, SettingOutlined, EyeOutlined, CaretDownFilled, DragOutlined, CaretRightOutlined, BuildOutlined, FilterOutlined, SwapRightOutlined, ExclamationCircleFilled, SearchOutlined, StarFilled, ExclamationCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, HomeFilled, ArrowLeftOutlined } from "@ant-design/icons";
import { message as message$1, Space, Input as Input$2, Dropdown, Button, Layout, Menu, Form, Modal as Modal$1, Typography, Tooltip as Tooltip$1, Upload, theme as theme$2, InputNumber as InputNumber$1, ConfigProvider, Select as Select$1, Card, Row, Col, Slider as Slider$1, Flex, Image as Image$1, Checkbox, Divider, Switch as Switch$1, ColorPicker, Empty, Radio, Progress, List as List$3, Alert, Badge, Popover, Tree, Breadcrumb, Avatar, Spin, Collapse, Tag, Tabs, Pagination } from "antd";
import moment from "moment";
import { useQuery, useQueries } from "@tanstack/react-query";
import "echarts-for-react";
import dayjs from "dayjs";
function _mergeNamespaces(n2, m2) {
  for (var i2 = 0; i2 < m2.length; i2++) {
    const e3 = m2[i2];
    if (typeof e3 !== "string" && !Array.isArray(e3)) {
      for (const k2 in e3) {
        if (k2 !== "default" && !(k2 in n2)) {
          const d2 = Object.getOwnPropertyDescriptor(e3, k2);
          if (d2) {
            Object.defineProperty(n2, k2, d2.get ? d2 : {
              enumerable: true,
              get: () => e3[k2]
            });
          }
        }
      }
    }
  }
  return Object.freeze(Object.defineProperty(n2, Symbol.toStringTag, { value: "Module" }));
}
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$1(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a2 = function a3() {
      if (this instanceof a3) {
        var args = [null];
        args.push.apply(args, arguments);
        var Ctor = Function.bind.apply(f2, args);
        return new Ctor();
      }
      return f2.apply(this, arguments);
    };
    a2.prototype = f2.prototype;
  } else
    a2 = {};
  Object.defineProperty(a2, "__esModule", {
    value: true
  });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var eveExports$1 = {};
var eve$2 = {
  get exports() {
    return eveExports$1;
  },
  set exports(v5) {
    eveExports$1 = v5;
  }
};
(function(module2) {
  (function(glob) {
    var version2 = "0.5.4", has2 = "hasOwnProperty", separator = /[\.\/]/, comaseparator = /\s*,\s*/, wildcard = "*", numsort = function(a2, b2) {
      return a2 - b2;
    }, current_event, stop, events2 = { n: {} }, firstDefined = function() {
      for (var i2 = 0, ii2 = this.length; i2 < ii2; i2++) {
        if (typeof this[i2] != "undefined") {
          return this[i2];
        }
      }
    }, lastDefined = function() {
      var i2 = this.length;
      while (--i2) {
        if (typeof this[i2] != "undefined") {
          return this[i2];
        }
      }
    }, objtos = Object.prototype.toString, Str = String, isArray3 = Array.isArray || function(ar2) {
      return ar2 instanceof Array || objtos.call(ar2) == "[object Array]";
    }, eve2 = function(name2, scope) {
      var oldstop = stop, args = Array.prototype.slice.call(arguments, 2), listeners2 = eve2.listeners(name2), z2 = 0, l2, indexed = [], queue = {}, out = [], ce2 = current_event;
      out.firstDefined = firstDefined;
      out.lastDefined = lastDefined;
      current_event = name2;
      stop = 0;
      for (var i2 = 0, ii2 = listeners2.length; i2 < ii2; i2++)
        if ("zIndex" in listeners2[i2]) {
          indexed.push(listeners2[i2].zIndex);
          if (listeners2[i2].zIndex < 0) {
            queue[listeners2[i2].zIndex] = listeners2[i2];
          }
        }
      indexed.sort(numsort);
      while (indexed[z2] < 0) {
        l2 = queue[indexed[z2++]];
        out.push(l2.apply(scope, args));
        if (stop) {
          stop = oldstop;
          return out;
        }
      }
      for (i2 = 0; i2 < ii2; i2++) {
        l2 = listeners2[i2];
        if ("zIndex" in l2) {
          if (l2.zIndex == indexed[z2]) {
            out.push(l2.apply(scope, args));
            if (stop) {
              break;
            }
            do {
              z2++;
              l2 = queue[indexed[z2]];
              l2 && out.push(l2.apply(scope, args));
              if (stop) {
                break;
              }
            } while (l2);
          } else {
            queue[l2.zIndex] = l2;
          }
        } else {
          out.push(l2.apply(scope, args));
          if (stop) {
            break;
          }
        }
      }
      stop = oldstop;
      current_event = ce2;
      return out;
    };
    eve2._events = events2;
    eve2.listeners = function(name2) {
      var names2 = isArray3(name2) ? name2 : name2.split(separator), e3 = events2, item, items, k2, i2, ii2, j2, jj, nes, es2 = [e3], out = [];
      for (i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
        nes = [];
        for (j2 = 0, jj = es2.length; j2 < jj; j2++) {
          e3 = es2[j2].n;
          items = [e3[names2[i2]], e3[wildcard]];
          k2 = 2;
          while (k2--) {
            item = items[k2];
            if (item) {
              nes.push(item);
              out = out.concat(item.f || []);
            }
          }
        }
        es2 = nes;
      }
      return out;
    };
    eve2.separator = function(sep) {
      if (sep) {
        sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
        sep = "[" + sep + "]";
        separator = new RegExp(sep);
      } else {
        separator = /[\.\/]/;
      }
    };
    eve2.on = function(name2, f2) {
      if (typeof f2 != "function") {
        return function() {
        };
      }
      var names2 = isArray3(name2) ? isArray3(name2[0]) ? name2 : [name2] : Str(name2).split(comaseparator);
      for (var i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
        (function(name3) {
          var names3 = isArray3(name3) ? name3 : Str(name3).split(separator), e3 = events2, exist;
          for (var i3 = 0, ii3 = names3.length; i3 < ii3; i3++) {
            e3 = e3.n;
            e3 = e3.hasOwnProperty(names3[i3]) && e3[names3[i3]] || (e3[names3[i3]] = { n: {} });
          }
          e3.f = e3.f || [];
          for (i3 = 0, ii3 = e3.f.length; i3 < ii3; i3++)
            if (e3.f[i3] == f2) {
              exist = true;
              break;
            }
          !exist && e3.f.push(f2);
        })(names2[i2]);
      }
      return function(zIndex) {
        if (+zIndex == +zIndex) {
          f2.zIndex = +zIndex;
        }
      };
    };
    eve2.f = function(event) {
      var attrs = [].slice.call(arguments, 1);
      return function() {
        eve2.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
      };
    };
    eve2.stop = function() {
      stop = 1;
    };
    eve2.nt = function(subname) {
      var cur = isArray3(current_event) ? current_event.join(".") : current_event;
      if (subname) {
        return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
      }
      return cur;
    };
    eve2.nts = function() {
      return isArray3(current_event) ? current_event : current_event.split(separator);
    };
    eve2.off = eve2.unbind = function(name2, f2) {
      if (!name2) {
        eve2._events = events2 = { n: {} };
        return;
      }
      var names2 = isArray3(name2) ? isArray3(name2[0]) ? name2 : [name2] : Str(name2).split(comaseparator);
      if (names2.length > 1) {
        for (var i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
          eve2.off(names2[i2], f2);
        }
        return;
      }
      names2 = isArray3(name2) ? name2 : Str(name2).split(separator);
      var e3, key, splice2, i2, ii2, j2, jj, cur = [events2], inodes = [];
      for (i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
        for (j2 = 0; j2 < cur.length; j2 += splice2.length - 2) {
          splice2 = [j2, 1];
          e3 = cur[j2].n;
          if (names2[i2] != wildcard) {
            if (e3[names2[i2]]) {
              splice2.push(e3[names2[i2]]);
              inodes.unshift({
                n: e3,
                name: names2[i2]
              });
            }
          } else {
            for (key in e3)
              if (e3[has2](key)) {
                splice2.push(e3[key]);
                inodes.unshift({
                  n: e3,
                  name: key
                });
              }
          }
          cur.splice.apply(cur, splice2);
        }
      }
      for (i2 = 0, ii2 = cur.length; i2 < ii2; i2++) {
        e3 = cur[i2];
        while (e3.n) {
          if (f2) {
            if (e3.f) {
              for (j2 = 0, jj = e3.f.length; j2 < jj; j2++)
                if (e3.f[j2] == f2) {
                  e3.f.splice(j2, 1);
                  break;
                }
              !e3.f.length && delete e3.f;
            }
            for (key in e3.n)
              if (e3.n[has2](key) && e3.n[key].f) {
                var funcs = e3.n[key].f;
                for (j2 = 0, jj = funcs.length; j2 < jj; j2++)
                  if (funcs[j2] == f2) {
                    funcs.splice(j2, 1);
                    break;
                  }
                !funcs.length && delete e3.n[key].f;
              }
          } else {
            delete e3.f;
            for (key in e3.n)
              if (e3.n[has2](key) && e3.n[key].f) {
                delete e3.n[key].f;
              }
          }
          e3 = e3.n;
        }
      }
      prune:
        for (i2 = 0, ii2 = inodes.length; i2 < ii2; i2++) {
          e3 = inodes[i2];
          for (key in e3.n[e3.name].f) {
            continue prune;
          }
          for (key in e3.n[e3.name].n) {
            continue prune;
          }
          delete e3.n[e3.name];
        }
    };
    eve2.once = function(name2, f2) {
      var f22 = function() {
        eve2.off(name2, f22);
        return f2.apply(this, arguments);
      };
      return eve2.on(name2, f22);
    };
    eve2.version = version2;
    eve2.toString = function() {
      return "You are running Eve " + version2;
    };
    glob.eve = eve2;
    module2.exports ? module2.exports = eve2 : glob.eve = eve2;
  })(typeof window != "undefined" ? window : commonjsGlobal$1);
})(eve$2);
var snap_svgExports$1 = {};
var snap_svg$2 = {
  get exports() {
    return snap_svgExports$1;
  },
  set exports(v5) {
    snap_svgExports$1 = v5;
  }
};
(function(module2, exports2) {
  (function(glob) {
    var version2 = "0.5.0", has2 = "hasOwnProperty", separator = /[\.\/]/, comaseparator = /\s*,\s*/, wildcard = "*", numsort = function(a2, b2) {
      return a2 - b2;
    }, current_event, stop, events2 = { n: {} }, firstDefined = function() {
      for (var i2 = 0, ii2 = this.length; i2 < ii2; i2++) {
        if (typeof this[i2] != "undefined") {
          return this[i2];
        }
      }
    }, lastDefined = function() {
      var i2 = this.length;
      while (--i2) {
        if (typeof this[i2] != "undefined") {
          return this[i2];
        }
      }
    }, objtos = Object.prototype.toString, Str = String, isArray3 = Array.isArray || function(ar2) {
      return ar2 instanceof Array || objtos.call(ar2) == "[object Array]";
    };
    eve = function(name2, scope) {
      var oldstop = stop, args = Array.prototype.slice.call(arguments, 2), listeners2 = eve.listeners(name2), z2 = 0, l2, indexed = [], queue = {}, out = [], ce2 = current_event;
      out.firstDefined = firstDefined;
      out.lastDefined = lastDefined;
      current_event = name2;
      stop = 0;
      for (var i2 = 0, ii2 = listeners2.length; i2 < ii2; i2++)
        if ("zIndex" in listeners2[i2]) {
          indexed.push(listeners2[i2].zIndex);
          if (listeners2[i2].zIndex < 0) {
            queue[listeners2[i2].zIndex] = listeners2[i2];
          }
        }
      indexed.sort(numsort);
      while (indexed[z2] < 0) {
        l2 = queue[indexed[z2++]];
        out.push(l2.apply(scope, args));
        if (stop) {
          stop = oldstop;
          return out;
        }
      }
      for (i2 = 0; i2 < ii2; i2++) {
        l2 = listeners2[i2];
        if ("zIndex" in l2) {
          if (l2.zIndex == indexed[z2]) {
            out.push(l2.apply(scope, args));
            if (stop) {
              break;
            }
            do {
              z2++;
              l2 = queue[indexed[z2]];
              l2 && out.push(l2.apply(scope, args));
              if (stop) {
                break;
              }
            } while (l2);
          } else {
            queue[l2.zIndex] = l2;
          }
        } else {
          out.push(l2.apply(scope, args));
          if (stop) {
            break;
          }
        }
      }
      stop = oldstop;
      current_event = ce2;
      return out;
    };
    eve._events = events2;
    eve.listeners = function(name2) {
      var names2 = isArray3(name2) ? name2 : name2.split(separator), e3 = events2, item, items, k2, i2, ii2, j2, jj, nes, es2 = [e3], out = [];
      for (i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
        nes = [];
        for (j2 = 0, jj = es2.length; j2 < jj; j2++) {
          e3 = es2[j2].n;
          items = [e3[names2[i2]], e3[wildcard]];
          k2 = 2;
          while (k2--) {
            item = items[k2];
            if (item) {
              nes.push(item);
              out = out.concat(item.f || []);
            }
          }
        }
        es2 = nes;
      }
      return out;
    };
    eve.separator = function(sep) {
      if (sep) {
        sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
        sep = "[" + sep + "]";
        separator = new RegExp(sep);
      } else {
        separator = /[\.\/]/;
      }
    };
    eve.on = function(name2, f2) {
      if (typeof f2 != "function") {
        return function() {
        };
      }
      var names2 = isArray3(name2) ? isArray3(name2[0]) ? name2 : [name2] : Str(name2).split(comaseparator);
      for (var i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
        (function(name3) {
          var names3 = isArray3(name3) ? name3 : Str(name3).split(separator), e3 = events2, exist;
          for (var i3 = 0, ii3 = names3.length; i3 < ii3; i3++) {
            e3 = e3.n;
            e3 = e3.hasOwnProperty(names3[i3]) && e3[names3[i3]] || (e3[names3[i3]] = { n: {} });
          }
          e3.f = e3.f || [];
          for (i3 = 0, ii3 = e3.f.length; i3 < ii3; i3++)
            if (e3.f[i3] == f2) {
              exist = true;
              break;
            }
          !exist && e3.f.push(f2);
        })(names2[i2]);
      }
      return function(zIndex) {
        if (+zIndex == +zIndex) {
          f2.zIndex = +zIndex;
        }
      };
    };
    eve.f = function(event) {
      var attrs = [].slice.call(arguments, 1);
      return function() {
        eve.apply(null, [event, null].concat(attrs).concat([].slice.call(arguments, 0)));
      };
    };
    eve.stop = function() {
      stop = 1;
    };
    eve.nt = function(subname) {
      var cur = isArray3(current_event) ? current_event.join(".") : current_event;
      if (subname) {
        return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
      }
      return cur;
    };
    eve.nts = function() {
      return isArray3(current_event) ? current_event : current_event.split(separator);
    };
    eve.off = eve.unbind = function(name2, f2) {
      if (!name2) {
        eve._events = events2 = { n: {} };
        return;
      }
      var names2 = isArray3(name2) ? isArray3(name2[0]) ? name2 : [name2] : Str(name2).split(comaseparator);
      if (names2.length > 1) {
        for (var i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
          eve.off(names2[i2], f2);
        }
        return;
      }
      names2 = isArray3(name2) ? name2 : Str(name2).split(separator);
      var e3, key, splice2, i2, ii2, j2, jj, cur = [events2], inodes = [];
      for (i2 = 0, ii2 = names2.length; i2 < ii2; i2++) {
        for (j2 = 0; j2 < cur.length; j2 += splice2.length - 2) {
          splice2 = [j2, 1];
          e3 = cur[j2].n;
          if (names2[i2] != wildcard) {
            if (e3[names2[i2]]) {
              splice2.push(e3[names2[i2]]);
              inodes.unshift({
                n: e3,
                name: names2[i2]
              });
            }
          } else {
            for (key in e3)
              if (e3[has2](key)) {
                splice2.push(e3[key]);
                inodes.unshift({
                  n: e3,
                  name: key
                });
              }
          }
          cur.splice.apply(cur, splice2);
        }
      }
      for (i2 = 0, ii2 = cur.length; i2 < ii2; i2++) {
        e3 = cur[i2];
        while (e3.n) {
          if (f2) {
            if (e3.f) {
              for (j2 = 0, jj = e3.f.length; j2 < jj; j2++)
                if (e3.f[j2] == f2) {
                  e3.f.splice(j2, 1);
                  break;
                }
              !e3.f.length && delete e3.f;
            }
            for (key in e3.n)
              if (e3.n[has2](key) && e3.n[key].f) {
                var funcs = e3.n[key].f;
                for (j2 = 0, jj = funcs.length; j2 < jj; j2++)
                  if (funcs[j2] == f2) {
                    funcs.splice(j2, 1);
                    break;
                  }
                !funcs.length && delete e3.n[key].f;
              }
          } else {
            delete e3.f;
            for (key in e3.n)
              if (e3.n[has2](key) && e3.n[key].f) {
                delete e3.n[key].f;
              }
          }
          e3 = e3.n;
        }
      }
      prune:
        for (i2 = 0, ii2 = inodes.length; i2 < ii2; i2++) {
          e3 = inodes[i2];
          for (key in e3.n[e3.name].f) {
            continue prune;
          }
          for (key in e3.n[e3.name].n) {
            continue prune;
          }
          delete e3.n[e3.name];
        }
    };
    eve.once = function(name2, f2) {
      var f22 = function() {
        eve.off(name2, f22);
        return f2.apply(this, arguments);
      };
      return eve.on(name2, f22);
    };
    eve.version = version2;
    eve.toString = function() {
      return "You are running Eve " + version2;
    };
    module2.exports ? module2.exports = eve : glob.eve = eve;
  })(commonjsGlobal$1);
  (function(glob, factory) {
    {
      var eve2 = eveExports$1;
      module2.exports = factory(glob, eve2);
    }
  })(window || commonjsGlobal$1, function(window2, eve2) {
    var mina = function(eve3) {
      var animations = {}, requestAnimFrame = window2.requestAnimationFrame || window2.webkitRequestAnimationFrame || window2.mozRequestAnimationFrame || window2.oRequestAnimationFrame || window2.msRequestAnimationFrame || function(callback) {
        setTimeout(callback, 16, (/* @__PURE__ */ new Date()).getTime());
        return true;
      }, requestID, isArray3 = Array.isArray || function(a2) {
        return a2 instanceof Array || Object.prototype.toString.call(a2) == "[object Array]";
      }, idgen = 0, idprefix = "M" + (+/* @__PURE__ */ new Date()).toString(36), ID2 = function() {
        return idprefix + (idgen++).toString(36);
      }, timer = Date.now || function() {
        return +/* @__PURE__ */ new Date();
      }, sta = function(val) {
        var a2 = this;
        if (val == null) {
          return a2.s;
        }
        var ds = a2.s - val;
        a2.b += a2.dur * ds;
        a2.B += a2.dur * ds;
        a2.s = val;
      }, speed = function(val) {
        var a2 = this;
        if (val == null) {
          return a2.spd;
        }
        a2.spd = val;
      }, duration = function(val) {
        var a2 = this;
        if (val == null) {
          return a2.dur;
        }
        a2.s = a2.s * val / a2.dur;
        a2.dur = val;
      }, stopit = function() {
        var a2 = this;
        delete animations[a2.id];
        a2.update();
        eve3("mina.stop." + a2.id, a2);
      }, pause = function() {
        var a2 = this;
        if (a2.pdif) {
          return;
        }
        delete animations[a2.id];
        a2.update();
        a2.pdif = a2.get() - a2.b;
      }, resume = function() {
        var a2 = this;
        if (!a2.pdif) {
          return;
        }
        a2.b = a2.get() - a2.pdif;
        delete a2.pdif;
        animations[a2.id] = a2;
        frame();
      }, update = function() {
        var a2 = this, res;
        if (isArray3(a2.start)) {
          res = [];
          for (var j2 = 0, jj = a2.start.length; j2 < jj; j2++) {
            res[j2] = +a2.start[j2] + (a2.end[j2] - a2.start[j2]) * a2.easing(a2.s);
          }
        } else {
          res = +a2.start + (a2.end - a2.start) * a2.easing(a2.s);
        }
        a2.set(res);
      }, frame = function(timeStamp) {
        if (!timeStamp) {
          if (!requestID) {
            requestID = requestAnimFrame(frame);
          }
          return;
        }
        var len2 = 0;
        for (var i2 in animations)
          if (animations.hasOwnProperty(i2)) {
            var a2 = animations[i2], b2 = a2.get();
            len2++;
            a2.s = (b2 - a2.b) / (a2.dur / a2.spd);
            if (a2.s >= 1) {
              delete animations[i2];
              a2.s = 1;
              len2--;
              (function(a3) {
                setTimeout(function() {
                  eve3("mina.finish." + a3.id, a3);
                });
              })(a2);
            }
            a2.update();
          }
        requestID = len2 ? requestAnimFrame(frame) : false;
      }, mina2 = function(a2, A2, b2, B2, get6, set, easing) {
        var anim = {
          id: ID2(),
          start: a2,
          end: A2,
          b: b2,
          s: 0,
          dur: B2 - b2,
          spd: 1,
          get: get6,
          set,
          easing: easing || mina2.linear,
          status: sta,
          speed,
          duration,
          stop: stopit,
          pause,
          resume,
          update
        };
        animations[anim.id] = anim;
        var len2 = 0, i2;
        for (i2 in animations)
          if (animations.hasOwnProperty(i2)) {
            len2++;
            if (len2 == 2) {
              break;
            }
          }
        len2 == 1 && frame();
        return anim;
      };
      mina2.time = timer;
      mina2.getById = function(id) {
        return animations[id] || null;
      };
      mina2.linear = function(n2) {
        return n2;
      };
      mina2.easeout = function(n2) {
        return Math.pow(n2, 1.7);
      };
      mina2.easein = function(n2) {
        return Math.pow(n2, 0.48);
      };
      mina2.easeinout = function(n2) {
        if (n2 == 1) {
          return 1;
        }
        if (n2 == 0) {
          return 0;
        }
        var q2 = 0.48 - n2 / 1.04, Q2 = Math.sqrt(0.1734 + q2 * q2), x2 = Q2 - q2, X2 = Math.pow(Math.abs(x2), 1 / 3) * (x2 < 0 ? -1 : 1), y2 = -Q2 - q2, Y2 = Math.pow(Math.abs(y2), 1 / 3) * (y2 < 0 ? -1 : 1), t2 = X2 + Y2 + 0.5;
        return (1 - t2) * 3 * t2 * t2 + t2 * t2 * t2;
      };
      mina2.backin = function(n2) {
        if (n2 == 1) {
          return 1;
        }
        var s2 = 1.70158;
        return n2 * n2 * ((s2 + 1) * n2 - s2);
      };
      mina2.backout = function(n2) {
        if (n2 == 0) {
          return 0;
        }
        n2 = n2 - 1;
        var s2 = 1.70158;
        return n2 * n2 * ((s2 + 1) * n2 + s2) + 1;
      };
      mina2.elastic = function(n2) {
        if (n2 == !!n2) {
          return n2;
        }
        return Math.pow(2, -10 * n2) * Math.sin((n2 - 0.075) * (2 * Math.PI) / 0.3) + 1;
      };
      mina2.bounce = function(n2) {
        var s2 = 7.5625, p2 = 2.75, l2;
        if (n2 < 1 / p2) {
          l2 = s2 * n2 * n2;
        } else {
          if (n2 < 2 / p2) {
            n2 -= 1.5 / p2;
            l2 = s2 * n2 * n2 + 0.75;
          } else {
            if (n2 < 2.5 / p2) {
              n2 -= 2.25 / p2;
              l2 = s2 * n2 * n2 + 0.9375;
            } else {
              n2 -= 2.625 / p2;
              l2 = s2 * n2 * n2 + 0.984375;
            }
          }
        }
        return l2;
      };
      window2.mina = mina2;
      return mina2;
    }(typeof eve2 == "undefined" ? function() {
    } : eve2);
    var Snap = function(root2) {
      Snap2.version = "0.5.1";
      function Snap2(w2, h2) {
        if (w2) {
          if (w2.nodeType) {
            return wrap2(w2);
          }
          if (is3(w2, "array") && Snap2.set) {
            return Snap2.set.apply(Snap2, w2);
          }
          if (w2 instanceof Element2) {
            return w2;
          }
          if (h2 == null) {
            w2 = glob.doc.querySelector(String(w2));
            return wrap2(w2);
          }
        }
        w2 = w2 == null ? "100%" : w2;
        h2 = h2 == null ? "100%" : h2;
        return new Paper(w2, h2);
      }
      Snap2.toString = function() {
        return "Snap v" + this.version;
      };
      Snap2._ = {};
      var glob = {
        win: root2.window,
        doc: root2.window.document
      };
      Snap2._.glob = glob;
      var has2 = "hasOwnProperty", Str = String, toFloat = parseFloat, toInt3 = parseInt, math2 = Math, mmax = math2.max, mmin = math2.min, abs3 = math2.abs, PI2 = math2.PI, E3 = "", objectToString2 = Object.prototype.toString, colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i;
      Snap2._.separator = /[,\s]+/;
      var commaSpaces = /[\s]*,[\s]*/, hsrg = { hs: 1, rg: 1 }, pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig, tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig, pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig, idgen = 0, idprefix = "S" + (+/* @__PURE__ */ new Date()).toString(36), ID2 = function(el) {
        return (el && el.type ? el.type : E3) + idprefix + (idgen++).toString(36);
      }, xlink = "http://www.w3.org/1999/xlink", xmlns = "http://www.w3.org/2000/svg", hub = {};
      Snap2.url = function(url2) {
        return "url('#" + url2 + "')";
      };
      function $(el, attr2) {
        if (attr2) {
          if (el == "#text") {
            el = glob.doc.createTextNode(attr2.text || attr2["#text"] || "");
          }
          if (el == "#comment") {
            el = glob.doc.createComment(attr2.text || attr2["#text"] || "");
          }
          if (typeof el == "string") {
            el = $(el);
          }
          if (typeof attr2 == "string") {
            if (el.nodeType == 1) {
              if (attr2.substring(0, 6) == "xlink:") {
                return el.getAttributeNS(xlink, attr2.substring(6));
              }
              if (attr2.substring(0, 4) == "xml:") {
                return el.getAttributeNS(xmlns, attr2.substring(4));
              }
              return el.getAttribute(attr2);
            } else if (attr2 == "text") {
              return el.nodeValue;
            } else {
              return null;
            }
          }
          if (el.nodeType == 1) {
            for (var key in attr2)
              if (attr2[has2](key)) {
                var val = Str(attr2[key]);
                if (val) {
                  if (key.substring(0, 6) == "xlink:") {
                    el.setAttributeNS(xlink, key.substring(6), val);
                  } else if (key.substring(0, 4) == "xml:") {
                    el.setAttributeNS(xmlns, key.substring(4), val);
                  } else {
                    el.setAttribute(key, val);
                  }
                } else {
                  el.removeAttribute(key);
                }
              }
          } else if ("text" in attr2) {
            el.nodeValue = attr2.text;
          }
        } else {
          el = glob.doc.createElementNS(xmlns, el);
        }
        return el;
      }
      Snap2._.$ = $;
      Snap2._.id = ID2;
      function is3(o2, type) {
        type = Str.prototype.toLowerCase.call(type);
        if (type == "finite") {
          return isFinite(o2);
        }
        if (type == "array" && (o2 instanceof Array || Array.isArray && Array.isArray(o2))) {
          return true;
        }
        return type == "null" && o2 === null || type == typeof o2 && o2 !== null || type == "object" && o2 === Object(o2) || objectToString2.call(o2).slice(8, -1).toLowerCase() == type;
      }
      Snap2.format = function() {
        var tokenRegex = /\{([^\}]+)\}/g, objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, replacer = function(all, key, obj) {
          var res = obj;
          key.replace(objNotationRegex, function(all2, name2, quote, quotedName, isFunc) {
            name2 = name2 || quotedName;
            if (res) {
              if (name2 in res) {
                res = res[name2];
              }
              typeof res == "function" && isFunc && (res = res());
            }
          });
          res = (res == null || res == obj ? all : res) + "";
          return res;
        };
        return function(str, obj) {
          return Str(str).replace(tokenRegex, function(all, key) {
            return replacer(all, key, obj);
          });
        };
      }();
      function clone8(obj) {
        if (typeof obj == "function" || Object(obj) !== obj) {
          return obj;
        }
        var res = new obj.constructor();
        for (var key in obj)
          if (obj[has2](key)) {
            res[key] = clone8(obj[key]);
          }
        return res;
      }
      Snap2._.clone = clone8;
      function repush(array2, item) {
        for (var i2 = 0, ii2 = array2.length; i2 < ii2; i2++)
          if (array2[i2] === item) {
            return array2.push(array2.splice(i2, 1)[0]);
          }
      }
      function cacher(f2, scope, postprocessor) {
        function newf() {
          var arg = Array.prototype.slice.call(arguments, 0), args = arg.join("␀"), cache2 = newf.cache = newf.cache || {}, count3 = newf.count = newf.count || [];
          if (cache2[has2](args)) {
            repush(count3, args);
            return postprocessor ? postprocessor(cache2[args]) : cache2[args];
          }
          count3.length >= 1e3 && delete cache2[count3.shift()];
          count3.push(args);
          cache2[args] = f2.apply(scope, arg);
          return postprocessor ? postprocessor(cache2[args]) : cache2[args];
        }
        return newf;
      }
      Snap2._.cacher = cacher;
      function angle4(x12, y12, x2, y2, x3, y3) {
        if (x3 == null) {
          var x4 = x12 - x2, y4 = y12 - y2;
          if (!x4 && !y4) {
            return 0;
          }
          return (180 + math2.atan2(-y4, -x4) * 180 / PI2 + 360) % 360;
        } else {
          return angle4(x12, y12, x3, y3) - angle4(x2, y2, x3, y3);
        }
      }
      function rad2(deg2) {
        return deg2 % 360 * PI2 / 180;
      }
      function deg(rad3) {
        return rad3 * 180 / PI2 % 360;
      }
      Snap2.rad = rad2;
      Snap2.deg = deg;
      Snap2.sin = function(angle5) {
        return math2.sin(Snap2.rad(angle5));
      };
      Snap2.tan = function(angle5) {
        return math2.tan(Snap2.rad(angle5));
      };
      Snap2.cos = function(angle5) {
        return math2.cos(Snap2.rad(angle5));
      };
      Snap2.asin = function(num) {
        return Snap2.deg(math2.asin(num));
      };
      Snap2.acos = function(num) {
        return Snap2.deg(math2.acos(num));
      };
      Snap2.atan = function(num) {
        return Snap2.deg(math2.atan(num));
      };
      Snap2.atan2 = function(num) {
        return Snap2.deg(math2.atan2(num));
      };
      Snap2.angle = angle4;
      Snap2.len = function(x12, y12, x2, y2) {
        return Math.sqrt(Snap2.len2(x12, y12, x2, y2));
      };
      Snap2.len2 = function(x12, y12, x2, y2) {
        return (x12 - x2) * (x12 - x2) + (y12 - y2) * (y12 - y2);
      };
      Snap2.closestPoint = function(path2, x2, y2) {
        function distance22(p2) {
          var dx = p2.x - x2, dy = p2.y - y2;
          return dx * dx + dy * dy;
        }
        var pathNode = path2.node, pathLength = pathNode.getTotalLength(), precision = pathLength / pathNode.pathSegList.numberOfItems * 0.125, best, bestLength, bestDistance = Infinity;
        for (var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision) {
          if ((scanDistance = distance22(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
            best = scan;
            bestLength = scanLength;
            bestDistance = scanDistance;
          }
        }
        precision *= 0.5;
        while (precision > 0.5) {
          var before, after, beforeLength, afterLength, beforeDistance, afterDistance;
          if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance22(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
            best = before;
            bestLength = beforeLength;
            bestDistance = beforeDistance;
          } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance22(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
            best = after;
            bestLength = afterLength;
            bestDistance = afterDistance;
          } else {
            precision *= 0.5;
          }
        }
        best = {
          x: best.x,
          y: best.y,
          length: bestLength,
          distance: Math.sqrt(bestDistance)
        };
        return best;
      };
      Snap2.is = is3;
      Snap2.snapTo = function(values4, value, tolerance) {
        tolerance = is3(tolerance, "finite") ? tolerance : 10;
        if (is3(values4, "array")) {
          var i2 = values4.length;
          while (i2--)
            if (abs3(values4[i2] - value) <= tolerance) {
              return values4[i2];
            }
        } else {
          values4 = +values4;
          var rem = value % values4;
          if (rem < tolerance) {
            return value - rem;
          }
          if (rem > values4 - tolerance) {
            return value - rem + values4;
          }
        }
        return value;
      };
      Snap2.getRGB = cacher(function(colour) {
        if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) {
          return { r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString };
        }
        if (colour == "none") {
          return { r: -1, g: -1, b: -1, hex: "none", toString: rgbtoString };
        }
        !(hsrg[has2](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex3(colour));
        if (!colour) {
          return { r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString };
        }
        var red2, green2, blue2, opacity, t2, values4, rgb = colour.match(colourRegExp);
        if (rgb) {
          if (rgb[2]) {
            blue2 = toInt3(rgb[2].substring(5), 16);
            green2 = toInt3(rgb[2].substring(3, 5), 16);
            red2 = toInt3(rgb[2].substring(1, 3), 16);
          }
          if (rgb[3]) {
            blue2 = toInt3((t2 = rgb[3].charAt(3)) + t2, 16);
            green2 = toInt3((t2 = rgb[3].charAt(2)) + t2, 16);
            red2 = toInt3((t2 = rgb[3].charAt(1)) + t2, 16);
          }
          if (rgb[4]) {
            values4 = rgb[4].split(commaSpaces);
            red2 = toFloat(values4[0]);
            values4[0].slice(-1) == "%" && (red2 *= 2.55);
            green2 = toFloat(values4[1]);
            values4[1].slice(-1) == "%" && (green2 *= 2.55);
            blue2 = toFloat(values4[2]);
            values4[2].slice(-1) == "%" && (blue2 *= 2.55);
            rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values4[3]));
            values4[3] && values4[3].slice(-1) == "%" && (opacity /= 100);
          }
          if (rgb[5]) {
            values4 = rgb[5].split(commaSpaces);
            red2 = toFloat(values4[0]);
            values4[0].slice(-1) == "%" && (red2 /= 100);
            green2 = toFloat(values4[1]);
            values4[1].slice(-1) == "%" && (green2 /= 100);
            blue2 = toFloat(values4[2]);
            values4[2].slice(-1) == "%" && (blue2 /= 100);
            (values4[0].slice(-3) == "deg" || values4[0].slice(-1) == "°") && (red2 /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values4[3]));
            values4[3] && values4[3].slice(-1) == "%" && (opacity /= 100);
            return Snap2.hsb2rgb(red2, green2, blue2, opacity);
          }
          if (rgb[6]) {
            values4 = rgb[6].split(commaSpaces);
            red2 = toFloat(values4[0]);
            values4[0].slice(-1) == "%" && (red2 /= 100);
            green2 = toFloat(values4[1]);
            values4[1].slice(-1) == "%" && (green2 /= 100);
            blue2 = toFloat(values4[2]);
            values4[2].slice(-1) == "%" && (blue2 /= 100);
            (values4[0].slice(-3) == "deg" || values4[0].slice(-1) == "°") && (red2 /= 360);
            rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values4[3]));
            values4[3] && values4[3].slice(-1) == "%" && (opacity /= 100);
            return Snap2.hsl2rgb(red2, green2, blue2, opacity);
          }
          red2 = mmin(math2.round(red2), 255);
          green2 = mmin(math2.round(green2), 255);
          blue2 = mmin(math2.round(blue2), 255);
          opacity = mmin(mmax(opacity, 0), 1);
          rgb = { r: red2, g: green2, b: blue2, toString: rgbtoString };
          rgb.hex = "#" + (16777216 | blue2 | green2 << 8 | red2 << 16).toString(16).slice(1);
          rgb.opacity = is3(opacity, "finite") ? opacity : 1;
          return rgb;
        }
        return { r: -1, g: -1, b: -1, hex: "none", error: 1, toString: rgbtoString };
      }, Snap2);
      Snap2.hsb = cacher(function(h2, s2, b2) {
        return Snap2.hsb2rgb(h2, s2, b2).hex;
      });
      Snap2.hsl = cacher(function(h2, s2, l2) {
        return Snap2.hsl2rgb(h2, s2, l2).hex;
      });
      Snap2.rgb = cacher(function(r2, g2, b2, o2) {
        if (is3(o2, "finite")) {
          var round2 = math2.round;
          return "rgba(" + [round2(r2), round2(g2), round2(b2), +o2.toFixed(2)] + ")";
        }
        return "#" + (16777216 | b2 | g2 << 8 | r2 << 16).toString(16).slice(1);
      });
      var toHex3 = function(color) {
        var i2 = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0], red2 = "rgb(255, 0, 0)";
        toHex3 = cacher(function(color2) {
          if (color2.toLowerCase() == "red") {
            return red2;
          }
          i2.style.color = red2;
          i2.style.color = color2;
          var out = glob.doc.defaultView.getComputedStyle(i2, E3).getPropertyValue("color");
          return out == red2 ? null : out;
        });
        return toHex3(color);
      }, hsbtoString = function() {
        return "hsb(" + [this.h, this.s, this.b] + ")";
      }, hsltoString = function() {
        return "hsl(" + [this.h, this.s, this.l] + ")";
      }, rgbtoString = function() {
        return this.opacity == 1 || this.opacity == null ? this.hex : "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
      }, prepareRGB = function(r2, g2, b2) {
        if (g2 == null && is3(r2, "object") && "r" in r2 && "g" in r2 && "b" in r2) {
          b2 = r2.b;
          g2 = r2.g;
          r2 = r2.r;
        }
        if (g2 == null && is3(r2, string)) {
          var clr = Snap2.getRGB(r2);
          r2 = clr.r;
          g2 = clr.g;
          b2 = clr.b;
        }
        if (r2 > 1 || g2 > 1 || b2 > 1) {
          r2 /= 255;
          g2 /= 255;
          b2 /= 255;
        }
        return [r2, g2, b2];
      }, packageRGB = function(r2, g2, b2, o2) {
        r2 = math2.round(r2 * 255);
        g2 = math2.round(g2 * 255);
        b2 = math2.round(b2 * 255);
        var rgb = {
          r: r2,
          g: g2,
          b: b2,
          opacity: is3(o2, "finite") ? o2 : 1,
          hex: Snap2.rgb(r2, g2, b2),
          toString: rgbtoString
        };
        is3(o2, "finite") && (rgb.opacity = o2);
        return rgb;
      };
      Snap2.color = function(clr) {
        var rgb;
        if (is3(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
          rgb = Snap2.hsb2rgb(clr);
          clr.r = rgb.r;
          clr.g = rgb.g;
          clr.b = rgb.b;
          clr.opacity = 1;
          clr.hex = rgb.hex;
        } else if (is3(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
          rgb = Snap2.hsl2rgb(clr);
          clr.r = rgb.r;
          clr.g = rgb.g;
          clr.b = rgb.b;
          clr.opacity = 1;
          clr.hex = rgb.hex;
        } else {
          if (is3(clr, "string")) {
            clr = Snap2.getRGB(clr);
          }
          if (is3(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
            rgb = Snap2.rgb2hsl(clr);
            clr.h = rgb.h;
            clr.s = rgb.s;
            clr.l = rgb.l;
            rgb = Snap2.rgb2hsb(clr);
            clr.v = rgb.b;
          } else {
            clr = { hex: "none" };
            clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
            clr.error = 1;
          }
        }
        clr.toString = rgbtoString;
        return clr;
      };
      Snap2.hsb2rgb = function(h2, s2, v5, o2) {
        if (is3(h2, "object") && "h" in h2 && "s" in h2 && "b" in h2) {
          v5 = h2.b;
          s2 = h2.s;
          o2 = h2.o;
          h2 = h2.h;
        }
        h2 *= 360;
        var R2, G2, B2, X2, C2;
        h2 = h2 % 360 / 60;
        C2 = v5 * s2;
        X2 = C2 * (1 - abs3(h2 % 2 - 1));
        R2 = G2 = B2 = v5 - C2;
        h2 = ~~h2;
        R2 += [C2, X2, 0, 0, X2, C2][h2];
        G2 += [X2, C2, C2, X2, 0, 0][h2];
        B2 += [0, 0, X2, C2, C2, X2][h2];
        return packageRGB(R2, G2, B2, o2);
      };
      Snap2.hsl2rgb = function(h2, s2, l2, o2) {
        if (is3(h2, "object") && "h" in h2 && "s" in h2 && "l" in h2) {
          l2 = h2.l;
          s2 = h2.s;
          h2 = h2.h;
        }
        if (h2 > 1 || s2 > 1 || l2 > 1) {
          h2 /= 360;
          s2 /= 100;
          l2 /= 100;
        }
        h2 *= 360;
        var R2, G2, B2, X2, C2;
        h2 = h2 % 360 / 60;
        C2 = 2 * s2 * (l2 < 0.5 ? l2 : 1 - l2);
        X2 = C2 * (1 - abs3(h2 % 2 - 1));
        R2 = G2 = B2 = l2 - C2 / 2;
        h2 = ~~h2;
        R2 += [C2, X2, 0, 0, X2, C2][h2];
        G2 += [X2, C2, C2, X2, 0, 0][h2];
        B2 += [0, 0, X2, C2, C2, X2][h2];
        return packageRGB(R2, G2, B2, o2);
      };
      Snap2.rgb2hsb = function(r2, g2, b2) {
        b2 = prepareRGB(r2, g2, b2);
        r2 = b2[0];
        g2 = b2[1];
        b2 = b2[2];
        var H2, S2, V2, C2;
        V2 = mmax(r2, g2, b2);
        C2 = V2 - mmin(r2, g2, b2);
        H2 = C2 == 0 ? null : V2 == r2 ? (g2 - b2) / C2 : V2 == g2 ? (b2 - r2) / C2 + 2 : (r2 - g2) / C2 + 4;
        H2 = (H2 + 360) % 6 * 60 / 360;
        S2 = C2 == 0 ? 0 : C2 / V2;
        return { h: H2, s: S2, b: V2, toString: hsbtoString };
      };
      Snap2.rgb2hsl = function(r2, g2, b2) {
        b2 = prepareRGB(r2, g2, b2);
        r2 = b2[0];
        g2 = b2[1];
        b2 = b2[2];
        var H2, S2, L2, M2, m2, C2;
        M2 = mmax(r2, g2, b2);
        m2 = mmin(r2, g2, b2);
        C2 = M2 - m2;
        H2 = C2 == 0 ? null : M2 == r2 ? (g2 - b2) / C2 : M2 == g2 ? (b2 - r2) / C2 + 2 : (r2 - g2) / C2 + 4;
        H2 = (H2 + 360) % 6 * 60 / 360;
        L2 = (M2 + m2) / 2;
        S2 = C2 == 0 ? 0 : L2 < 0.5 ? C2 / (2 * L2) : C2 / (2 - 2 * L2);
        return { h: H2, s: S2, l: L2, toString: hsltoString };
      };
      Snap2.parsePathString = function(pathString) {
        if (!pathString) {
          return null;
        }
        var pth = Snap2.path(pathString);
        if (pth.arr) {
          return Snap2.path.clone(pth.arr);
        }
        var paramCounts = { a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0 }, data2 = [];
        if (is3(pathString, "array") && is3(pathString[0], "array")) {
          data2 = Snap2.path.clone(pathString);
        }
        if (!data2.length) {
          Str(pathString).replace(pathCommand, function(a2, b2, c2) {
            var params2 = [], name2 = b2.toLowerCase();
            c2.replace(pathValues, function(a3, b3) {
              b3 && params2.push(+b3);
            });
            if (name2 == "m" && params2.length > 2) {
              data2.push([b2].concat(params2.splice(0, 2)));
              name2 = "l";
              b2 = b2 == "m" ? "l" : "L";
            }
            if (name2 == "o" && params2.length == 1) {
              data2.push([b2, params2[0]]);
            }
            if (name2 == "r") {
              data2.push([b2].concat(params2));
            } else
              while (params2.length >= paramCounts[name2]) {
                data2.push([b2].concat(params2.splice(0, paramCounts[name2])));
                if (!paramCounts[name2]) {
                  break;
                }
              }
          });
        }
        data2.toString = Snap2.path.toString;
        pth.arr = Snap2.path.clone(data2);
        return data2;
      };
      var parseTransformString = Snap2.parseTransformString = function(TString) {
        if (!TString) {
          return null;
        }
        var data2 = [];
        if (is3(TString, "array") && is3(TString[0], "array")) {
          data2 = Snap2.path.clone(TString);
        }
        if (!data2.length) {
          Str(TString).replace(tCommand, function(a2, b2, c2) {
            var params2 = [];
            b2.toLowerCase();
            c2.replace(pathValues, function(a3, b3) {
              b3 && params2.push(+b3);
            });
            data2.push([b2].concat(params2));
          });
        }
        data2.toString = Snap2.path.toString;
        return data2;
      };
      function svgTransform2string(tstr) {
        var res = [];
        tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function(all, name2, params2) {
          params2 = params2.split(/\s*,\s*|\s+/);
          if (name2 == "rotate" && params2.length == 1) {
            params2.push(0, 0);
          }
          if (name2 == "scale") {
            if (params2.length > 2) {
              params2 = params2.slice(0, 2);
            } else if (params2.length == 2) {
              params2.push(0, 0);
            }
            if (params2.length == 1) {
              params2.push(params2[0], 0, 0);
            }
          }
          if (name2 == "skewX") {
            res.push(["m", 1, 0, math2.tan(rad2(params2[0])), 1, 0, 0]);
          } else if (name2 == "skewY") {
            res.push(["m", 1, math2.tan(rad2(params2[0])), 0, 1, 0, 0]);
          } else {
            res.push([name2.charAt(0)].concat(params2));
          }
          return all;
        });
        return res;
      }
      Snap2._.svgTransform2string = svgTransform2string;
      Snap2._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
      function transform2matrix(tstr, bbox2) {
        var tdata = parseTransformString(tstr), m2 = new Snap2.Matrix();
        if (tdata) {
          for (var i2 = 0, ii2 = tdata.length; i2 < ii2; i2++) {
            var t2 = tdata[i2], tlen = t2.length, command = Str(t2[0]).toLowerCase(), absolute2 = t2[0] != command, inver = absolute2 ? m2.invert() : 0, x12, y12, x2, y2, bb2;
            if (command == "t" && tlen == 2) {
              m2.translate(t2[1], 0);
            } else if (command == "t" && tlen == 3) {
              if (absolute2) {
                x12 = inver.x(0, 0);
                y12 = inver.y(0, 0);
                x2 = inver.x(t2[1], t2[2]);
                y2 = inver.y(t2[1], t2[2]);
                m2.translate(x2 - x12, y2 - y12);
              } else {
                m2.translate(t2[1], t2[2]);
              }
            } else if (command == "r") {
              if (tlen == 2) {
                bb2 = bb2 || bbox2;
                m2.rotate(t2[1], bb2.x + bb2.width / 2, bb2.y + bb2.height / 2);
              } else if (tlen == 4) {
                if (absolute2) {
                  x2 = inver.x(t2[2], t2[3]);
                  y2 = inver.y(t2[2], t2[3]);
                  m2.rotate(t2[1], x2, y2);
                } else {
                  m2.rotate(t2[1], t2[2], t2[3]);
                }
              }
            } else if (command == "s") {
              if (tlen == 2 || tlen == 3) {
                bb2 = bb2 || bbox2;
                m2.scale(t2[1], t2[tlen - 1], bb2.x + bb2.width / 2, bb2.y + bb2.height / 2);
              } else if (tlen == 4) {
                if (absolute2) {
                  x2 = inver.x(t2[2], t2[3]);
                  y2 = inver.y(t2[2], t2[3]);
                  m2.scale(t2[1], t2[1], x2, y2);
                } else {
                  m2.scale(t2[1], t2[1], t2[2], t2[3]);
                }
              } else if (tlen == 5) {
                if (absolute2) {
                  x2 = inver.x(t2[3], t2[4]);
                  y2 = inver.y(t2[3], t2[4]);
                  m2.scale(t2[1], t2[2], x2, y2);
                } else {
                  m2.scale(t2[1], t2[2], t2[3], t2[4]);
                }
              }
            } else if (command == "m" && tlen == 7) {
              m2.add(t2[1], t2[2], t2[3], t2[4], t2[5], t2[6]);
            }
          }
        }
        return m2;
      }
      Snap2._.transform2matrix = transform2matrix;
      Snap2._unit2px = unit2px;
      glob.doc.contains || glob.doc.compareDocumentPosition ? function(a2, b2) {
        var adown = a2.nodeType == 9 ? a2.documentElement : a2, bup = b2 && b2.parentNode;
        return a2 == bup || !!(bup && bup.nodeType == 1 && (adown.contains ? adown.contains(bup) : a2.compareDocumentPosition && a2.compareDocumentPosition(bup) & 16));
      } : function(a2, b2) {
        if (b2) {
          while (b2) {
            b2 = b2.parentNode;
            if (b2 == a2) {
              return true;
            }
          }
        }
        return false;
      };
      function getSomeDefs(el) {
        var p2 = el.node.ownerSVGElement && wrap2(el.node.ownerSVGElement) || el.node.parentNode && wrap2(el.node.parentNode) || Snap2.select("svg") || Snap2(0, 0), pdefs = p2.select("defs"), defs2 = pdefs == null ? false : pdefs.node;
        if (!defs2) {
          defs2 = make("defs", p2.node).node;
        }
        return defs2;
      }
      function getSomeSVG(el) {
        return el.node.ownerSVGElement && wrap2(el.node.ownerSVGElement) || Snap2.select("svg");
      }
      Snap2._.getSomeDefs = getSomeDefs;
      Snap2._.getSomeSVG = getSomeSVG;
      function unit2px(el, name2, value) {
        var svg = getSomeSVG(el).node, out = {}, mgr = svg.querySelector(".svg---mgr");
        if (!mgr) {
          mgr = $("rect");
          $(mgr, { x: -9e9, y: -9e9, width: 10, height: 10, "class": "svg---mgr", fill: "none" });
          svg.appendChild(mgr);
        }
        function getW(val) {
          if (val == null) {
            return E3;
          }
          if (val == +val) {
            return val;
          }
          $(mgr, { width: val });
          try {
            return mgr.getBBox().width;
          } catch (e3) {
            return 0;
          }
        }
        function getH(val) {
          if (val == null) {
            return E3;
          }
          if (val == +val) {
            return val;
          }
          $(mgr, { height: val });
          try {
            return mgr.getBBox().height;
          } catch (e3) {
            return 0;
          }
        }
        function set(nam, f2) {
          if (name2 == null) {
            out[nam] = f2(el.attr(nam) || 0);
          } else if (nam == name2) {
            out = f2(value == null ? el.attr(nam) || 0 : value);
          }
        }
        switch (el.type) {
          case "rect":
            set("rx", getW);
            set("ry", getH);
          case "image":
            set("width", getW);
            set("height", getH);
          case "text":
            set("x", getW);
            set("y", getH);
            break;
          case "circle":
            set("cx", getW);
            set("cy", getH);
            set("r", getW);
            break;
          case "ellipse":
            set("cx", getW);
            set("cy", getH);
            set("rx", getW);
            set("ry", getH);
            break;
          case "line":
            set("x1", getW);
            set("x2", getW);
            set("y1", getH);
            set("y2", getH);
            break;
          case "marker":
            set("refX", getW);
            set("markerWidth", getW);
            set("refY", getH);
            set("markerHeight", getH);
            break;
          case "radialGradient":
            set("fx", getW);
            set("fy", getH);
            break;
          case "tspan":
            set("dx", getW);
            set("dy", getH);
            break;
          default:
            set(name2, getW);
        }
        svg.removeChild(mgr);
        return out;
      }
      Snap2.select = function(query6) {
        query6 = Str(query6).replace(/([^\\]):/g, "$1\\:");
        return wrap2(glob.doc.querySelector(query6));
      };
      Snap2.selectAll = function(query6) {
        var nodelist = glob.doc.querySelectorAll(query6), set = (Snap2.set || Array)();
        for (var i2 = 0; i2 < nodelist.length; i2++) {
          set.push(wrap2(nodelist[i2]));
        }
        return set;
      };
      function add2group(list2) {
        if (!is3(list2, "array")) {
          list2 = Array.prototype.slice.call(arguments, 0);
        }
        var i2 = 0, j2 = 0, node = this.node;
        while (this[i2])
          delete this[i2++];
        for (i2 = 0; i2 < list2.length; i2++) {
          if (list2[i2].type == "set") {
            list2[i2].forEach(function(el) {
              node.appendChild(el.node);
            });
          } else {
            node.appendChild(list2[i2].node);
          }
        }
        var children = node.childNodes;
        for (i2 = 0; i2 < children.length; i2++) {
          this[j2++] = wrap2(children[i2]);
        }
        return this;
      }
      setInterval(function() {
        for (var key in hub)
          if (hub[has2](key)) {
            var el = hub[key], node = el.node;
            if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) {
              delete hub[key];
            }
          }
      }, 1e4);
      function Element2(el) {
        if (el.snap in hub) {
          return hub[el.snap];
        }
        var svg;
        try {
          svg = el.ownerSVGElement;
        } catch (e3) {
        }
        this.node = el;
        if (svg) {
          this.paper = new Paper(svg);
        }
        this.type = el.tagName || el.nodeName;
        var id = this.id = ID2(this);
        this.anims = {};
        this._ = {
          transform: []
        };
        el.snap = id;
        hub[id] = this;
        if (this.type == "g") {
          this.add = add2group;
        }
        if (this.type in { g: 1, mask: 1, pattern: 1, symbol: 1 }) {
          for (var method in Paper.prototype)
            if (Paper.prototype[has2](method)) {
              this[method] = Paper.prototype[method];
            }
        }
      }
      Element2.prototype.attr = function(params2, value) {
        var el = this, node = el.node;
        if (!params2) {
          if (node.nodeType != 1) {
            return {
              text: node.nodeValue
            };
          }
          var attr2 = node.attributes, out = {};
          for (var i2 = 0, ii2 = attr2.length; i2 < ii2; i2++) {
            out[attr2[i2].nodeName] = attr2[i2].nodeValue;
          }
          return out;
        }
        if (is3(params2, "string")) {
          if (arguments.length > 1) {
            var json = {};
            json[params2] = value;
            params2 = json;
          } else {
            return eve2("snap.util.getattr." + params2, el).firstDefined();
          }
        }
        for (var att in params2) {
          if (params2[has2](att)) {
            eve2("snap.util.attr." + att, el, params2[att]);
          }
        }
        return el;
      };
      Snap2.parse = function(svg) {
        var f2 = glob.doc.createDocumentFragment(), full = true, div = glob.doc.createElement("div");
        svg = Str(svg);
        if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
          svg = "<svg>" + svg + "</svg>";
          full = false;
        }
        div.innerHTML = svg;
        svg = div.getElementsByTagName("svg")[0];
        if (svg) {
          if (full) {
            f2 = svg;
          } else {
            while (svg.firstChild) {
              f2.appendChild(svg.firstChild);
            }
          }
        }
        return new Fragment2(f2);
      };
      function Fragment2(frag) {
        this.node = frag;
      }
      Snap2.fragment = function() {
        var args = Array.prototype.slice.call(arguments, 0), f2 = glob.doc.createDocumentFragment();
        for (var i2 = 0, ii2 = args.length; i2 < ii2; i2++) {
          var item = args[i2];
          if (item.node && item.node.nodeType) {
            f2.appendChild(item.node);
          }
          if (item.nodeType) {
            f2.appendChild(item);
          }
          if (typeof item == "string") {
            f2.appendChild(Snap2.parse(item).node);
          }
        }
        return new Fragment2(f2);
      };
      function make(name2, parent) {
        var res = $(name2);
        parent.appendChild(res);
        var el = wrap2(res);
        return el;
      }
      function Paper(w2, h2) {
        var res, desc, defs2, proto = Paper.prototype;
        if (w2 && w2.tagName && w2.tagName.toLowerCase() == "svg") {
          if (w2.snap in hub) {
            return hub[w2.snap];
          }
          var doc = w2.ownerDocument;
          res = new Element2(w2);
          desc = w2.getElementsByTagName("desc")[0];
          defs2 = w2.getElementsByTagName("defs")[0];
          if (!desc) {
            desc = $("desc");
            desc.appendChild(doc.createTextNode("Created with Snap"));
            res.node.appendChild(desc);
          }
          if (!defs2) {
            defs2 = $("defs");
            res.node.appendChild(defs2);
          }
          res.defs = defs2;
          for (var key in proto)
            if (proto[has2](key)) {
              res[key] = proto[key];
            }
          res.paper = res.root = res;
        } else {
          res = make("svg", glob.doc.body);
          $(res.node, {
            height: h2,
            version: 1.1,
            width: w2,
            xmlns
          });
        }
        return res;
      }
      function wrap2(dom) {
        if (!dom) {
          return dom;
        }
        if (dom instanceof Element2 || dom instanceof Fragment2) {
          return dom;
        }
        if (dom.tagName && dom.tagName.toLowerCase() == "svg") {
          return new Paper(dom);
        }
        if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") {
          return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
        }
        return new Element2(dom);
      }
      Snap2._.make = make;
      Snap2._.wrap = wrap2;
      Paper.prototype.el = function(name2, attr2) {
        var el = make(name2, this.node);
        attr2 && el.attr(attr2);
        return el;
      };
      Element2.prototype.children = function() {
        var out = [], ch2 = this.node.childNodes;
        for (var i2 = 0, ii2 = ch2.length; i2 < ii2; i2++) {
          out[i2] = Snap2(ch2[i2]);
        }
        return out;
      };
      function jsonFiller(root3, o2) {
        for (var i2 = 0, ii2 = root3.length; i2 < ii2; i2++) {
          var item = {
            type: root3[i2].type,
            attr: root3[i2].attr()
          }, children = root3[i2].children();
          o2.push(item);
          if (children.length) {
            jsonFiller(children, item.childNodes = []);
          }
        }
      }
      Element2.prototype.toJSON = function() {
        var out = [];
        jsonFiller([this], out);
        return out[0];
      };
      eve2.on("snap.util.getattr", function() {
        var att = eve2.nt();
        att = att.substring(att.lastIndexOf(".") + 1);
        var css = att.replace(/[A-Z]/g, function(letter) {
          return "-" + letter.toLowerCase();
        });
        if (cssAttr[has2](css)) {
          return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
        } else {
          return $(this.node, att);
        }
      });
      var cssAttr = {
        "alignment-baseline": 0,
        "baseline-shift": 0,
        "clip": 0,
        "clip-path": 0,
        "clip-rule": 0,
        "color": 0,
        "color-interpolation": 0,
        "color-interpolation-filters": 0,
        "color-profile": 0,
        "color-rendering": 0,
        "cursor": 0,
        "direction": 0,
        "display": 0,
        "dominant-baseline": 0,
        "enable-background": 0,
        "fill": 0,
        "fill-opacity": 0,
        "fill-rule": 0,
        "filter": 0,
        "flood-color": 0,
        "flood-opacity": 0,
        "font": 0,
        "font-family": 0,
        "font-size": 0,
        "font-size-adjust": 0,
        "font-stretch": 0,
        "font-style": 0,
        "font-variant": 0,
        "font-weight": 0,
        "glyph-orientation-horizontal": 0,
        "glyph-orientation-vertical": 0,
        "image-rendering": 0,
        "kerning": 0,
        "letter-spacing": 0,
        "lighting-color": 0,
        "marker": 0,
        "marker-end": 0,
        "marker-mid": 0,
        "marker-start": 0,
        "mask": 0,
        "opacity": 0,
        "overflow": 0,
        "pointer-events": 0,
        "shape-rendering": 0,
        "stop-color": 0,
        "stop-opacity": 0,
        "stroke": 0,
        "stroke-dasharray": 0,
        "stroke-dashoffset": 0,
        "stroke-linecap": 0,
        "stroke-linejoin": 0,
        "stroke-miterlimit": 0,
        "stroke-opacity": 0,
        "stroke-width": 0,
        "text-anchor": 0,
        "text-decoration": 0,
        "text-rendering": 0,
        "unicode-bidi": 0,
        "visibility": 0,
        "word-spacing": 0,
        "writing-mode": 0
      };
      eve2.on("snap.util.attr", function(value) {
        var att = eve2.nt(), attr2 = {};
        att = att.substring(att.lastIndexOf(".") + 1);
        attr2[att] = value;
        var style2 = att.replace(/-(\w)/gi, function(all, letter) {
          return letter.toUpperCase();
        }), css = att.replace(/[A-Z]/g, function(letter) {
          return "-" + letter.toLowerCase();
        });
        if (cssAttr[has2](css)) {
          this.node.style[style2] = value == null ? E3 : value;
        } else {
          $(this.node, attr2);
        }
      });
      Snap2.ajax = function(url2, postData, callback, scope) {
        var req = new XMLHttpRequest(), id = ID2();
        if (req) {
          if (is3(postData, "function")) {
            scope = callback;
            callback = postData;
            postData = null;
          } else if (is3(postData, "object")) {
            var pd = [];
            for (var key in postData)
              if (postData.hasOwnProperty(key)) {
                pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
              }
            postData = pd.join("&");
          }
          req.open(postData ? "POST" : "GET", url2, true);
          if (postData) {
            req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
          }
          if (callback) {
            eve2.once("snap.ajax." + id + ".0", callback);
            eve2.once("snap.ajax." + id + ".200", callback);
            eve2.once("snap.ajax." + id + ".304", callback);
          }
          req.onreadystatechange = function() {
            if (req.readyState != 4)
              return;
            eve2("snap.ajax." + id + "." + req.status, scope, req);
          };
          if (req.readyState == 4) {
            return req;
          }
          req.send(postData);
          return req;
        }
      };
      Snap2.load = function(url2, callback, scope) {
        Snap2.ajax(url2, function(req) {
          var f2 = Snap2.parse(req.responseText);
          scope ? callback.call(scope, f2) : callback(f2);
        });
      };
      var getOffset2 = function(elem) {
        var box = elem.getBoundingClientRect(), doc = elem.ownerDocument, body = doc.body, docElem = doc.documentElement, clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0, top = box.top + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop) - clientTop, left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
        return {
          y: top,
          x: left
        };
      };
      Snap2.getElementByPoint = function(x2, y2) {
        var paper = this;
        paper.canvas;
        var target = glob.doc.elementFromPoint(x2, y2);
        if (glob.win.opera && target.tagName == "svg") {
          var so = getOffset2(target), sr = target.createSVGRect();
          sr.x = x2 - so.x;
          sr.y = y2 - so.y;
          sr.width = sr.height = 1;
          var hits = target.getIntersectionList(sr, null);
          if (hits.length) {
            target = hits[hits.length - 1];
          }
        }
        if (!target) {
          return null;
        }
        return wrap2(target);
      };
      Snap2.plugin = function(f2) {
        f2(Snap2, Element2, Paper, glob, Fragment2);
      };
      glob.win.Snap = Snap2;
      return Snap2;
    }(window2 || this);
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var elproto = Element2.prototype, is3 = Snap2.is, Str = String, unit2px = Snap2._unit2px, $ = Snap2._.$, make = Snap2._.make, getSomeDefs = Snap2._.getSomeDefs, has2 = "hasOwnProperty", wrap2 = Snap2._.wrap;
      elproto.getBBox = function(isWithoutTransform) {
        if (this.type == "tspan") {
          return Snap2._.box(this.node.getClientRects().item(0));
        }
        if (!Snap2.Matrix || !Snap2.path) {
          return this.node.getBBox();
        }
        var el = this, m2 = new Snap2.Matrix();
        if (el.removed) {
          return Snap2._.box();
        }
        while (el.type == "use") {
          if (!isWithoutTransform) {
            m2 = m2.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
          }
          if (el.original) {
            el = el.original;
          } else {
            var href = el.attr("xlink:href");
            el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
          }
        }
        var _2 = el._, pathfinder = Snap2.path.get[el.type] || Snap2.path.get.deflt;
        try {
          if (isWithoutTransform) {
            _2.bboxwt = pathfinder ? Snap2.path.getBBox(el.realPath = pathfinder(el)) : Snap2._.box(el.node.getBBox());
            return Snap2._.box(_2.bboxwt);
          } else {
            el.realPath = pathfinder(el);
            el.matrix = el.transform().localMatrix;
            _2.bbox = Snap2.path.getBBox(Snap2.path.map(el.realPath, m2.add(el.matrix)));
            return Snap2._.box(_2.bbox);
          }
        } catch (e3) {
          return Snap2._.box();
        }
      };
      var propString = function() {
        return this.string;
      };
      function extractTransform(el, tstr) {
        if (tstr == null) {
          var doReturn = true;
          if (el.type == "linearGradient" || el.type == "radialGradient") {
            tstr = el.node.getAttribute("gradientTransform");
          } else if (el.type == "pattern") {
            tstr = el.node.getAttribute("patternTransform");
          } else {
            tstr = el.node.getAttribute("transform");
          }
          if (!tstr) {
            return new Snap2.Matrix();
          }
          tstr = Snap2._.svgTransform2string(tstr);
        } else {
          if (!Snap2._.rgTransform.test(tstr)) {
            tstr = Snap2._.svgTransform2string(tstr);
          } else {
            tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
          }
          if (is3(tstr, "array")) {
            tstr = Snap2.path ? Snap2.path.toString.call(tstr) : Str(tstr);
          }
          el._.transform = tstr;
        }
        var m2 = Snap2._.transform2matrix(tstr, el.getBBox(1));
        if (doReturn) {
          return m2;
        } else {
          el.matrix = m2;
        }
      }
      elproto.transform = function(tstr) {
        var _2 = this._;
        if (tstr == null) {
          var papa = this, global2 = new Snap2.Matrix(this.node.getCTM()), local = extractTransform(this), ms = [local], m2 = new Snap2.Matrix(), i2, localString = local.toTransformString(), string3 = Str(local) == Str(this.matrix) ? Str(_2.transform) : localString;
          while (papa.type != "svg" && (papa = papa.parent())) {
            ms.push(extractTransform(papa));
          }
          i2 = ms.length;
          while (i2--) {
            m2.add(ms[i2]);
          }
          return {
            string: string3,
            globalMatrix: global2,
            totalMatrix: m2,
            localMatrix: local,
            diffMatrix: global2.clone().add(local.invert()),
            global: global2.toTransformString(),
            total: m2.toTransformString(),
            local: localString,
            toString: propString
          };
        }
        if (tstr instanceof Snap2.Matrix) {
          this.matrix = tstr;
          this._.transform = tstr.toTransformString();
        } else {
          extractTransform(this, tstr);
        }
        if (this.node) {
          if (this.type == "linearGradient" || this.type == "radialGradient") {
            $(this.node, { gradientTransform: this.matrix });
          } else if (this.type == "pattern") {
            $(this.node, { patternTransform: this.matrix });
          } else {
            $(this.node, { transform: this.matrix });
          }
        }
        return this;
      };
      elproto.parent = function() {
        return wrap2(this.node.parentNode);
      };
      elproto.append = elproto.add = function(el) {
        if (el) {
          if (el.type == "set") {
            var it = this;
            el.forEach(function(el2) {
              it.add(el2);
            });
            return this;
          }
          el = wrap2(el);
          this.node.appendChild(el.node);
          el.paper = this.paper;
        }
        return this;
      };
      elproto.appendTo = function(el) {
        if (el) {
          el = wrap2(el);
          el.append(this);
        }
        return this;
      };
      elproto.prepend = function(el) {
        if (el) {
          if (el.type == "set") {
            var it = this, first;
            el.forEach(function(el2) {
              if (first) {
                first.after(el2);
              } else {
                it.prepend(el2);
              }
              first = el2;
            });
            return this;
          }
          el = wrap2(el);
          var parent = el.parent();
          this.node.insertBefore(el.node, this.node.firstChild);
          this.add && this.add();
          el.paper = this.paper;
          this.parent() && this.parent().add();
          parent && parent.add();
        }
        return this;
      };
      elproto.prependTo = function(el) {
        el = wrap2(el);
        el.prepend(this);
        return this;
      };
      elproto.before = function(el) {
        if (el.type == "set") {
          var it = this;
          el.forEach(function(el2) {
            var parent2 = el2.parent();
            it.node.parentNode.insertBefore(el2.node, it.node);
            parent2 && parent2.add();
          });
          this.parent().add();
          return this;
        }
        el = wrap2(el);
        var parent = el.parent();
        this.node.parentNode.insertBefore(el.node, this.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
      };
      elproto.after = function(el) {
        el = wrap2(el);
        var parent = el.parent();
        if (this.node.nextSibling) {
          this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
        } else {
          this.node.parentNode.appendChild(el.node);
        }
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
      };
      elproto.insertBefore = function(el) {
        el = wrap2(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
      };
      elproto.insertAfter = function(el) {
        el = wrap2(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
      };
      elproto.remove = function() {
        var parent = this.parent();
        this.node.parentNode && this.node.parentNode.removeChild(this.node);
        delete this.paper;
        this.removed = true;
        parent && parent.add();
        return this;
      };
      elproto.select = function(query6) {
        return wrap2(this.node.querySelector(query6));
      };
      elproto.selectAll = function(query6) {
        var nodelist = this.node.querySelectorAll(query6), set = (Snap2.set || Array)();
        for (var i2 = 0; i2 < nodelist.length; i2++) {
          set.push(wrap2(nodelist[i2]));
        }
        return set;
      };
      elproto.asPX = function(attr2, value) {
        if (value == null) {
          value = this.attr(attr2);
        }
        return +unit2px(this, attr2, value);
      };
      elproto.use = function() {
        var use, id = this.node.id;
        if (!id) {
          id = this.id;
          $(this.node, {
            id
          });
        }
        if (this.type == "linearGradient" || this.type == "radialGradient" || this.type == "pattern") {
          use = make(this.type, this.node.parentNode);
        } else {
          use = make("use", this.node.parentNode);
        }
        $(use.node, {
          "xlink:href": "#" + id
        });
        use.original = this;
        return use;
      };
      function fixids(el) {
        var els = el.selectAll("*"), it, url2 = /^\s*url\(("|'|)(.*)\1\)\s*$/, ids = [], uses = {};
        function urltest(it2, name2) {
          var val = $(it2.node, name2);
          val = val && val.match(url2);
          val = val && val[2];
          if (val && val.charAt() == "#") {
            val = val.substring(1);
          } else {
            return;
          }
          if (val) {
            uses[val] = (uses[val] || []).concat(function(id) {
              var attr2 = {};
              attr2[name2] = Snap2.url(id);
              $(it2.node, attr2);
            });
          }
        }
        function linktest(it2) {
          var val = $(it2.node, "xlink:href");
          if (val && val.charAt() == "#") {
            val = val.substring(1);
          } else {
            return;
          }
          if (val) {
            uses[val] = (uses[val] || []).concat(function(id) {
              it2.attr("xlink:href", "#" + id);
            });
          }
        }
        for (var i2 = 0, ii2 = els.length; i2 < ii2; i2++) {
          it = els[i2];
          urltest(it, "fill");
          urltest(it, "stroke");
          urltest(it, "filter");
          urltest(it, "mask");
          urltest(it, "clip-path");
          linktest(it);
          var oldid = $(it.node, "id");
          if (oldid) {
            $(it.node, { id: it.id });
            ids.push({
              old: oldid,
              id: it.id
            });
          }
        }
        for (i2 = 0, ii2 = ids.length; i2 < ii2; i2++) {
          var fs2 = uses[ids[i2].old];
          if (fs2) {
            for (var j2 = 0, jj = fs2.length; j2 < jj; j2++) {
              fs2[j2](ids[i2].id);
            }
          }
        }
      }
      elproto.clone = function() {
        var clone8 = wrap2(this.node.cloneNode(true));
        if ($(clone8.node, "id")) {
          $(clone8.node, { id: clone8.id });
        }
        fixids(clone8);
        clone8.insertAfter(this);
        return clone8;
      };
      elproto.toDefs = function() {
        var defs2 = getSomeDefs(this);
        defs2.appendChild(this.node);
        return this;
      };
      elproto.pattern = elproto.toPattern = function(x2, y2, width, height) {
        var p2 = make("pattern", getSomeDefs(this));
        if (x2 == null) {
          x2 = this.getBBox();
        }
        if (is3(x2, "object") && "x" in x2) {
          y2 = x2.y;
          width = x2.width;
          height = x2.height;
          x2 = x2.x;
        }
        $(p2.node, {
          x: x2,
          y: y2,
          width,
          height,
          patternUnits: "userSpaceOnUse",
          id: p2.id,
          viewBox: [x2, y2, width, height].join(" ")
        });
        p2.node.appendChild(this.node);
        return p2;
      };
      elproto.marker = function(x2, y2, width, height, refX, refY) {
        var p2 = make("marker", getSomeDefs(this));
        if (x2 == null) {
          x2 = this.getBBox();
        }
        if (is3(x2, "object") && "x" in x2) {
          y2 = x2.y;
          width = x2.width;
          height = x2.height;
          refX = x2.refX || x2.cx;
          refY = x2.refY || x2.cy;
          x2 = x2.x;
        }
        $(p2.node, {
          viewBox: [x2, y2, width, height].join(" "),
          markerWidth: width,
          markerHeight: height,
          orient: "auto",
          refX: refX || 0,
          refY: refY || 0,
          id: p2.id
        });
        p2.node.appendChild(this.node);
        return p2;
      };
      var eldata = {};
      elproto.data = function(key, value) {
        var data2 = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0) {
          eve2("snap.data.get." + this.id, this, data2, null);
          return data2;
        }
        if (arguments.length == 1) {
          if (Snap2.is(key, "object")) {
            for (var i2 in key)
              if (key[has2](i2)) {
                this.data(i2, key[i2]);
              }
            return this;
          }
          eve2("snap.data.get." + this.id, this, data2[key], key);
          return data2[key];
        }
        data2[key] = value;
        eve2("snap.data.set." + this.id, this, value, key);
        return this;
      };
      elproto.removeData = function(key) {
        if (key == null) {
          eldata[this.id] = {};
        } else {
          eldata[this.id] && delete eldata[this.id][key];
        }
        return this;
      };
      elproto.outerSVG = elproto.toString = toString29(1);
      elproto.innerSVG = toString29();
      function toString29(type) {
        return function() {
          var res = type ? "<" + this.type : "", attr2 = this.node.attributes, chld = this.node.childNodes;
          if (type) {
            for (var i2 = 0, ii2 = attr2.length; i2 < ii2; i2++) {
              res += " " + attr2[i2].name + '="' + attr2[i2].value.replace(/"/g, '\\"') + '"';
            }
          }
          if (chld.length) {
            type && (res += ">");
            for (i2 = 0, ii2 = chld.length; i2 < ii2; i2++) {
              if (chld[i2].nodeType == 3) {
                res += chld[i2].nodeValue;
              } else if (chld[i2].nodeType == 1) {
                res += wrap2(chld[i2]).toString();
              }
            }
            type && (res += "</" + this.type + ">");
          } else {
            type && (res += "/>");
          }
          return res;
        };
      }
      elproto.toDataURL = function() {
        if (window2 && window2.btoa) {
          var bb2 = this.getBBox(), svg = Snap2.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
            x: +bb2.x.toFixed(3),
            y: +bb2.y.toFixed(3),
            width: +bb2.width.toFixed(3),
            height: +bb2.height.toFixed(3),
            contents: this.outerSVG()
          });
          return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        }
      };
      Fragment2.prototype.select = elproto.select;
      Fragment2.prototype.selectAll = elproto.selectAll;
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var elproto = Element2.prototype, is3 = Snap2.is, Str = String, has2 = "hasOwnProperty";
      function slice2(from, to, f2) {
        return function(arr) {
          var res = arr.slice(from, to);
          if (res.length == 1) {
            res = res[0];
          }
          return f2 ? f2(res) : res;
        };
      }
      var Animation = function(attr2, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
          callback = easing;
          easing = mina.linear;
        }
        this.attr = attr2;
        this.dur = ms;
        easing && (this.easing = easing);
        callback && (this.callback = callback);
      };
      Snap2._.Animation = Animation;
      Snap2.animation = function(attr2, ms, easing, callback) {
        return new Animation(attr2, ms, easing, callback);
      };
      elproto.inAnim = function() {
        var el = this, res = [];
        for (var id in el.anims)
          if (el.anims[has2](id)) {
            (function(a2) {
              res.push({
                anim: new Animation(a2._attrs, a2.dur, a2.easing, a2._callback),
                mina: a2,
                curStatus: a2.status(),
                status: function(val) {
                  return a2.status(val);
                },
                stop: function() {
                  a2.stop();
                }
              });
            })(el.anims[id]);
          }
        return res;
      };
      Snap2.animate = function(from, to, setter, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
          callback = easing;
          easing = mina.linear;
        }
        var now2 = mina.time(), anim = mina(from, to, now2, now2 + ms, mina.time, setter, easing);
        callback && eve2.once("mina.finish." + anim.id, callback);
        return anim;
      };
      elproto.stop = function() {
        var anims = this.inAnim();
        for (var i2 = 0, ii2 = anims.length; i2 < ii2; i2++) {
          anims[i2].stop();
        }
        return this;
      };
      elproto.animate = function(attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
          callback = easing;
          easing = mina.linear;
        }
        if (attrs instanceof Animation) {
          callback = attrs.callback;
          easing = attrs.easing;
          ms = attrs.dur;
          attrs = attrs.attr;
        }
        var fkeys = [], tkeys = [], keys4 = {}, from, to, f2, eq2, el = this;
        for (var key in attrs)
          if (attrs[has2](key)) {
            if (el.equal) {
              eq2 = el.equal(key, Str(attrs[key]));
              from = eq2.from;
              to = eq2.to;
              f2 = eq2.f;
            } else {
              from = +el.attr(key);
              to = +attrs[key];
            }
            var len2 = is3(from, "array") ? from.length : 1;
            keys4[key] = slice2(fkeys.length, fkeys.length + len2, f2);
            fkeys = fkeys.concat(from);
            tkeys = tkeys.concat(to);
          }
        var now2 = mina.time(), anim = mina(fkeys, tkeys, now2, now2 + ms, mina.time, function(val) {
          var attr2 = {};
          for (var key2 in keys4)
            if (keys4[has2](key2)) {
              attr2[key2] = keys4[key2](val);
            }
          el.attr(attr2);
        }, easing);
        el.anims[anim.id] = anim;
        anim._attrs = attrs;
        anim._callback = callback;
        eve2("snap.animcreated." + el.id, anim);
        eve2.once("mina.finish." + anim.id, function() {
          eve2.off("mina.*." + anim.id);
          delete el.anims[anim.id];
          callback && callback.call(el);
        });
        eve2.once("mina.stop." + anim.id, function() {
          eve2.off("mina.*." + anim.id);
          delete el.anims[anim.id];
        });
        return el;
      };
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var objectToString2 = Object.prototype.toString, Str = String, math2 = Math, E3 = "";
      function Matrix2(a2, b2, c2, d2, e3, f2) {
        if (b2 == null && objectToString2.call(a2) == "[object SVGMatrix]") {
          this.a = a2.a;
          this.b = a2.b;
          this.c = a2.c;
          this.d = a2.d;
          this.e = a2.e;
          this.f = a2.f;
          return;
        }
        if (a2 != null) {
          this.a = +a2;
          this.b = +b2;
          this.c = +c2;
          this.d = +d2;
          this.e = +e3;
          this.f = +f2;
        } else {
          this.a = 1;
          this.b = 0;
          this.c = 0;
          this.d = 1;
          this.e = 0;
          this.f = 0;
        }
      }
      (function(matrixproto) {
        matrixproto.add = function(a2, b2, c2, d2, e3, f2) {
          if (a2 && a2 instanceof Matrix2) {
            return this.add(a2.a, a2.b, a2.c, a2.d, a2.e, a2.f);
          }
          var aNew = a2 * this.a + b2 * this.c, bNew = a2 * this.b + b2 * this.d;
          this.e += e3 * this.a + f2 * this.c;
          this.f += e3 * this.b + f2 * this.d;
          this.c = c2 * this.a + d2 * this.c;
          this.d = c2 * this.b + d2 * this.d;
          this.a = aNew;
          this.b = bNew;
          return this;
        };
        Matrix2.prototype.multLeft = function(a2, b2, c2, d2, e3, f2) {
          if (a2 && a2 instanceof Matrix2) {
            return this.multLeft(a2.a, a2.b, a2.c, a2.d, a2.e, a2.f);
          }
          var aNew = a2 * this.a + c2 * this.b, cNew = a2 * this.c + c2 * this.d, eNew = a2 * this.e + c2 * this.f + e3;
          this.b = b2 * this.a + d2 * this.b;
          this.d = b2 * this.c + d2 * this.d;
          this.f = b2 * this.e + d2 * this.f + f2;
          this.a = aNew;
          this.c = cNew;
          this.e = eNew;
          return this;
        };
        matrixproto.invert = function() {
          var me = this, x2 = me.a * me.d - me.b * me.c;
          return new Matrix2(me.d / x2, -me.b / x2, -me.c / x2, me.a / x2, (me.c * me.f - me.d * me.e) / x2, (me.b * me.e - me.a * me.f) / x2);
        };
        matrixproto.clone = function() {
          return new Matrix2(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        matrixproto.translate = function(x2, y2) {
          this.e += x2 * this.a + y2 * this.c;
          this.f += x2 * this.b + y2 * this.d;
          return this;
        };
        matrixproto.scale = function(x2, y2, cx, cy) {
          y2 == null && (y2 = x2);
          (cx || cy) && this.translate(cx, cy);
          this.a *= x2;
          this.b *= x2;
          this.c *= y2;
          this.d *= y2;
          (cx || cy) && this.translate(-cx, -cy);
          return this;
        };
        matrixproto.rotate = function(a2, x2, y2) {
          a2 = Snap2.rad(a2);
          x2 = x2 || 0;
          y2 = y2 || 0;
          var cos2 = +math2.cos(a2).toFixed(9), sin2 = +math2.sin(a2).toFixed(9);
          this.add(cos2, sin2, -sin2, cos2, x2, y2);
          return this.add(1, 0, 0, 1, -x2, -y2);
        };
        matrixproto.skewX = function(x2) {
          return this.skew(x2, 0);
        };
        matrixproto.skewY = function(y2) {
          return this.skew(0, y2);
        };
        matrixproto.skew = function(x2, y2) {
          x2 = x2 || 0;
          y2 = y2 || 0;
          x2 = Snap2.rad(x2);
          y2 = Snap2.rad(y2);
          var c2 = math2.tan(x2).toFixed(9);
          var b2 = math2.tan(y2).toFixed(9);
          return this.add(1, b2, c2, 1, 0, 0);
        };
        matrixproto.x = function(x2, y2) {
          return x2 * this.a + y2 * this.c + this.e;
        };
        matrixproto.y = function(x2, y2) {
          return x2 * this.b + y2 * this.d + this.f;
        };
        matrixproto.get = function(i2) {
          return +this[Str.fromCharCode(97 + i2)].toFixed(4);
        };
        matrixproto.toString = function() {
          return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
        };
        matrixproto.offset = function() {
          return [this.e.toFixed(4), this.f.toFixed(4)];
        };
        function norm2(a2) {
          return a2[0] * a2[0] + a2[1] * a2[1];
        }
        function normalize5(a2) {
          var mag = math2.sqrt(norm2(a2));
          a2[0] && (a2[0] /= mag);
          a2[1] && (a2[1] /= mag);
        }
        matrixproto.determinant = function() {
          return this.a * this.d - this.b * this.c;
        };
        matrixproto.split = function() {
          var out = {};
          out.dx = this.e;
          out.dy = this.f;
          var row = [[this.a, this.b], [this.c, this.d]];
          out.scalex = math2.sqrt(norm2(row[0]));
          normalize5(row[0]);
          out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
          row[1] = [row[1][0] - row[0][0] * out.shear, row[1][1] - row[0][1] * out.shear];
          out.scaley = math2.sqrt(norm2(row[1]));
          normalize5(row[1]);
          out.shear /= out.scaley;
          if (this.determinant() < 0) {
            out.scalex = -out.scalex;
          }
          var sin2 = row[0][1], cos2 = row[1][1];
          if (cos2 < 0) {
            out.rotate = Snap2.deg(math2.acos(cos2));
            if (sin2 < 0) {
              out.rotate = 360 - out.rotate;
            }
          } else {
            out.rotate = Snap2.deg(math2.asin(sin2));
          }
          out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
          out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
          out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
          return out;
        };
        matrixproto.toTransformString = function(shorter) {
          var s2 = shorter || this.split();
          if (!+s2.shear.toFixed(9)) {
            s2.scalex = +s2.scalex.toFixed(4);
            s2.scaley = +s2.scaley.toFixed(4);
            s2.rotate = +s2.rotate.toFixed(4);
            return (s2.dx || s2.dy ? "t" + [+s2.dx.toFixed(4), +s2.dy.toFixed(4)] : E3) + (s2.rotate ? "r" + [+s2.rotate.toFixed(4), 0, 0] : E3) + (s2.scalex != 1 || s2.scaley != 1 ? "s" + [s2.scalex, s2.scaley, 0, 0] : E3);
          } else {
            return "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)];
          }
        };
      })(Matrix2.prototype);
      Snap2.Matrix = Matrix2;
      Snap2.matrix = function(a2, b2, c2, d2, e3, f2) {
        return new Matrix2(a2, b2, c2, d2, e3, f2);
      };
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var make = Snap2._.make, wrap2 = Snap2._.wrap, is3 = Snap2.is, getSomeDefs = Snap2._.getSomeDefs, reURLValue = /^url\((['"]?)([^)]+)\1\)$/, $ = Snap2._.$, URL2 = Snap2.url, Str = String, separator = Snap2._.separator, E3 = "";
      Snap2.deurl = function(value) {
        var res = String(value).match(reURLValue);
        return res ? res[2] : value;
      };
      eve2.on("snap.util.attr.mask", function(value) {
        if (value instanceof Element2 || value instanceof Fragment2) {
          eve2.stop();
          if (value instanceof Fragment2 && value.node.childNodes.length == 1) {
            value = value.node.firstChild;
            getSomeDefs(this).appendChild(value);
            value = wrap2(value);
          }
          if (value.type == "mask") {
            var mask = value;
          } else {
            mask = make("mask", getSomeDefs(this));
            mask.node.appendChild(value.node);
          }
          !mask.node.id && $(mask.node, {
            id: mask.id
          });
          $(this.node, {
            mask: URL2(mask.id)
          });
        }
      });
      (function(clipIt) {
        eve2.on("snap.util.attr.clip", clipIt);
        eve2.on("snap.util.attr.clip-path", clipIt);
        eve2.on("snap.util.attr.clipPath", clipIt);
      })(function(value) {
        if (value instanceof Element2 || value instanceof Fragment2) {
          eve2.stop();
          var clip2, node = value.node;
          while (node) {
            if (node.nodeName === "clipPath") {
              clip2 = new Element2(node);
              break;
            }
            if (node.nodeName === "svg") {
              clip2 = void 0;
              break;
            }
            node = node.parentNode;
          }
          if (!clip2) {
            clip2 = make("clipPath", getSomeDefs(this));
            clip2.node.appendChild(value.node);
            !clip2.node.id && $(clip2.node, {
              id: clip2.id
            });
          }
          $(this.node, {
            "clip-path": URL2(clip2.node.id || clip2.id)
          });
        }
      });
      function fillStroke(name2) {
        return function(value) {
          eve2.stop();
          if (value instanceof Fragment2 && value.node.childNodes.length == 1 && (value.node.firstChild.tagName == "radialGradient" || value.node.firstChild.tagName == "linearGradient" || value.node.firstChild.tagName == "pattern")) {
            value = value.node.firstChild;
            getSomeDefs(this).appendChild(value);
            value = wrap2(value);
          }
          if (value instanceof Element2) {
            if (value.type == "radialGradient" || value.type == "linearGradient" || value.type == "pattern") {
              if (!value.node.id) {
                $(value.node, {
                  id: value.id
                });
              }
              var fill = URL2(value.node.id);
            } else {
              fill = value.attr(name2);
            }
          } else {
            fill = Snap2.color(value);
            if (fill.error) {
              var grad = Snap2(getSomeDefs(this).ownerSVGElement).gradient(value);
              if (grad) {
                if (!grad.node.id) {
                  $(grad.node, {
                    id: grad.id
                  });
                }
                fill = URL2(grad.node.id);
              } else {
                fill = value;
              }
            } else {
              fill = Str(fill);
            }
          }
          var attrs = {};
          attrs[name2] = fill;
          $(this.node, attrs);
          this.node.style[name2] = E3;
        };
      }
      eve2.on("snap.util.attr.fill", fillStroke("fill"));
      eve2.on("snap.util.attr.stroke", fillStroke("stroke"));
      var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
      eve2.on("snap.util.grad.parse", function parseGrad(string3) {
        string3 = Str(string3);
        var tokens = string3.match(gradrg);
        if (!tokens) {
          return null;
        }
        var type = tokens[1], params2 = tokens[2], stops = tokens[3];
        params2 = params2.split(/\s*,\s*/).map(function(el) {
          return +el == el ? +el : el;
        });
        if (params2.length == 1 && params2[0] == 0) {
          params2 = [];
        }
        stops = stops.split("-");
        stops = stops.map(function(el) {
          el = el.split(":");
          var out = {
            color: el[0]
          };
          if (el[1]) {
            out.offset = parseFloat(el[1]);
          }
          return out;
        });
        var len2 = stops.length, start2 = 0, j2 = 0;
        function seed(i3, end) {
          var step = (end - start2) / (i3 - j2);
          for (var k2 = j2; k2 < i3; k2++) {
            stops[k2].offset = +(+start2 + step * (k2 - j2)).toFixed(2);
          }
          j2 = i3;
          start2 = end;
        }
        len2--;
        for (var i2 = 0; i2 < len2; i2++)
          if ("offset" in stops[i2]) {
            seed(i2, stops[i2].offset);
          }
        stops[len2].offset = stops[len2].offset || 100;
        seed(len2, stops[len2].offset);
        return {
          type,
          params: params2,
          stops
        };
      });
      eve2.on("snap.util.attr.d", function(value) {
        eve2.stop();
        if (is3(value, "array") && is3(value[0], "array")) {
          value = Snap2.path.toString.call(value);
        }
        value = Str(value);
        if (value.match(/[ruo]/i)) {
          value = Snap2.path.toAbsolute(value);
        }
        $(this.node, { d: value });
      })(-1);
      eve2.on("snap.util.attr.#text", function(value) {
        eve2.stop();
        value = Str(value);
        var txt = glob.doc.createTextNode(value);
        while (this.node.firstChild) {
          this.node.removeChild(this.node.firstChild);
        }
        this.node.appendChild(txt);
      })(-1);
      eve2.on("snap.util.attr.path", function(value) {
        eve2.stop();
        this.attr({ d: value });
      })(-1);
      eve2.on("snap.util.attr.class", function(value) {
        eve2.stop();
        this.node.className.baseVal = value;
      })(-1);
      eve2.on("snap.util.attr.viewBox", function(value) {
        var vb;
        if (is3(value, "object") && "x" in value) {
          vb = [value.x, value.y, value.width, value.height].join(" ");
        } else if (is3(value, "array")) {
          vb = value.join(" ");
        } else {
          vb = value;
        }
        $(this.node, {
          viewBox: vb
        });
        eve2.stop();
      })(-1);
      eve2.on("snap.util.attr.transform", function(value) {
        this.transform(value);
        eve2.stop();
      })(-1);
      eve2.on("snap.util.attr.r", function(value) {
        if (this.type == "rect") {
          eve2.stop();
          $(this.node, {
            rx: value,
            ry: value
          });
        }
      })(-1);
      eve2.on("snap.util.attr.textpath", function(value) {
        eve2.stop();
        if (this.type == "text") {
          var id, tp, node;
          if (!value && this.textPath) {
            tp = this.textPath;
            while (tp.node.firstChild) {
              this.node.appendChild(tp.node.firstChild);
            }
            tp.remove();
            delete this.textPath;
            return;
          }
          if (is3(value, "string")) {
            var defs2 = getSomeDefs(this), path2 = wrap2(defs2.parentNode).path(value);
            defs2.appendChild(path2.node);
            id = path2.id;
            path2.attr({ id });
          } else {
            value = wrap2(value);
            if (value instanceof Element2) {
              id = value.attr("id");
              if (!id) {
                id = value.id;
                value.attr({ id });
              }
            }
          }
          if (id) {
            tp = this.textPath;
            node = this.node;
            if (tp) {
              tp.attr({ "xlink:href": "#" + id });
            } else {
              tp = $("textPath", {
                "xlink:href": "#" + id
              });
              while (node.firstChild) {
                tp.appendChild(node.firstChild);
              }
              node.appendChild(tp);
              this.textPath = wrap2(tp);
            }
          }
        }
      })(-1);
      eve2.on("snap.util.attr.text", function(value) {
        if (this.type == "text") {
          var node = this.node, tuner = function(chunk) {
            var out = $("tspan");
            if (is3(chunk, "array")) {
              for (var i2 = 0; i2 < chunk.length; i2++) {
                out.appendChild(tuner(chunk[i2]));
              }
            } else {
              out.appendChild(glob.doc.createTextNode(chunk));
            }
            out.normalize && out.normalize();
            return out;
          };
          while (node.firstChild) {
            node.removeChild(node.firstChild);
          }
          var tuned = tuner(value);
          while (tuned.firstChild) {
            node.appendChild(tuned.firstChild);
          }
        }
        eve2.stop();
      })(-1);
      function setFontSize(value) {
        eve2.stop();
        if (value == +value) {
          value += "px";
        }
        this.node.style.fontSize = value;
      }
      eve2.on("snap.util.attr.fontSize", setFontSize)(-1);
      eve2.on("snap.util.attr.font-size", setFontSize)(-1);
      eve2.on("snap.util.getattr.transform", function() {
        eve2.stop();
        return this.transform();
      })(-1);
      eve2.on("snap.util.getattr.textpath", function() {
        eve2.stop();
        return this.textPath;
      })(-1);
      (function() {
        function getter(end) {
          return function() {
            eve2.stop();
            var style2 = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
            if (style2 == "none") {
              return style2;
            } else {
              return Snap2(glob.doc.getElementById(style2.match(reURLValue)[1]));
            }
          };
        }
        function setter(end) {
          return function(value) {
            eve2.stop();
            var name2 = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
            if (value == "" || !value) {
              this.node.style[name2] = "none";
              return;
            }
            if (value.type == "marker") {
              var id = value.node.id;
              if (!id) {
                $(value.node, { id: value.id });
              }
              this.node.style[name2] = URL2(id);
              return;
            }
          };
        }
        eve2.on("snap.util.getattr.marker-end", getter("end"))(-1);
        eve2.on("snap.util.getattr.markerEnd", getter("end"))(-1);
        eve2.on("snap.util.getattr.marker-start", getter("start"))(-1);
        eve2.on("snap.util.getattr.markerStart", getter("start"))(-1);
        eve2.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
        eve2.on("snap.util.getattr.markerMid", getter("mid"))(-1);
        eve2.on("snap.util.attr.marker-end", setter("end"))(-1);
        eve2.on("snap.util.attr.markerEnd", setter("end"))(-1);
        eve2.on("snap.util.attr.marker-start", setter("start"))(-1);
        eve2.on("snap.util.attr.markerStart", setter("start"))(-1);
        eve2.on("snap.util.attr.marker-mid", setter("mid"))(-1);
        eve2.on("snap.util.attr.markerMid", setter("mid"))(-1);
      })();
      eve2.on("snap.util.getattr.r", function() {
        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
          eve2.stop();
          return $(this.node, "rx");
        }
      })(-1);
      function textExtract(node) {
        var out = [];
        var children = node.childNodes;
        for (var i2 = 0, ii2 = children.length; i2 < ii2; i2++) {
          var chi = children[i2];
          if (chi.nodeType == 3) {
            out.push(chi.nodeValue);
          }
          if (chi.tagName == "tspan") {
            if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) {
              out.push(chi.firstChild.nodeValue);
            } else {
              out.push(textExtract(chi));
            }
          }
        }
        return out;
      }
      eve2.on("snap.util.getattr.text", function() {
        if (this.type == "text" || this.type == "tspan") {
          eve2.stop();
          var out = textExtract(this.node);
          return out.length == 1 ? out[0] : out;
        }
      })(-1);
      eve2.on("snap.util.getattr.#text", function() {
        return this.node.textContent;
      })(-1);
      eve2.on("snap.util.getattr.fill", function(internal) {
        if (internal) {
          return;
        }
        eve2.stop();
        var value = eve2("snap.util.getattr.fill", this, true).firstDefined();
        return Snap2(Snap2.deurl(value)) || value;
      })(-1);
      eve2.on("snap.util.getattr.stroke", function(internal) {
        if (internal) {
          return;
        }
        eve2.stop();
        var value = eve2("snap.util.getattr.stroke", this, true).firstDefined();
        return Snap2(Snap2.deurl(value)) || value;
      })(-1);
      eve2.on("snap.util.getattr.viewBox", function() {
        eve2.stop();
        var vb = $(this.node, "viewBox");
        if (vb) {
          vb = vb.split(separator);
          return Snap2._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
        } else {
          return;
        }
      })(-1);
      eve2.on("snap.util.getattr.points", function() {
        var p2 = $(this.node, "points");
        eve2.stop();
        if (p2) {
          return p2.split(separator);
        } else {
          return;
        }
      })(-1);
      eve2.on("snap.util.getattr.path", function() {
        var p2 = $(this.node, "d");
        eve2.stop();
        return p2;
      })(-1);
      eve2.on("snap.util.getattr.class", function() {
        return this.node.className.baseVal;
      })(-1);
      function getFontSize() {
        eve2.stop();
        return this.node.style.fontSize;
      }
      eve2.on("snap.util.getattr.fontSize", getFontSize)(-1);
      eve2.on("snap.util.getattr.font-size", getFontSize)(-1);
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var rgNotSpace = /\S+/g, Str = String, elproto = Element2.prototype;
      elproto.addClass = function(value) {
        var classes2 = Str(value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j2, pos, clazz, finalValue;
        if (classes2.length) {
          j2 = 0;
          while (clazz = classes2[j2++]) {
            pos = curClasses.indexOf(clazz);
            if (!~pos) {
              curClasses.push(clazz);
            }
          }
          finalValue = curClasses.join(" ");
          if (className != finalValue) {
            elem.className.baseVal = finalValue;
          }
        }
        return this;
      };
      elproto.removeClass = function(value) {
        var classes2 = Str(value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j2, pos, clazz, finalValue;
        if (curClasses.length) {
          j2 = 0;
          while (clazz = classes2[j2++]) {
            pos = curClasses.indexOf(clazz);
            if (~pos) {
              curClasses.splice(pos, 1);
            }
          }
          finalValue = curClasses.join(" ");
          if (className != finalValue) {
            elem.className.baseVal = finalValue;
          }
        }
        return this;
      };
      elproto.hasClass = function(value) {
        var elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [];
        return !!~curClasses.indexOf(value);
      };
      elproto.toggleClass = function(value, flag) {
        if (flag != null) {
          if (flag) {
            return this.addClass(value);
          } else {
            return this.removeClass(value);
          }
        }
        var classes2 = (value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j2, pos, clazz, finalValue;
        j2 = 0;
        while (clazz = classes2[j2++]) {
          pos = curClasses.indexOf(clazz);
          if (~pos) {
            curClasses.splice(pos, 1);
          } else {
            curClasses.push(clazz);
          }
        }
        finalValue = curClasses.join(" ");
        if (className != finalValue) {
          elem.className.baseVal = finalValue;
        }
        return this;
      };
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var operators = {
        "+": function(x2, y2) {
          return x2 + y2;
        },
        "-": function(x2, y2) {
          return x2 - y2;
        },
        "/": function(x2, y2) {
          return x2 / y2;
        },
        "*": function(x2, y2) {
          return x2 * y2;
        }
      }, Str = String, reUnit = /[a-z]+$/i, reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
      function getNumber(val) {
        return val;
      }
      function getUnit(unit) {
        return function(val) {
          return +val.toFixed(3) + unit;
        };
      }
      eve2.on("snap.util.attr", function(val) {
        var plus = Str(val).match(reAddon);
        if (plus) {
          var evnt = eve2.nt(), name2 = evnt.substring(evnt.lastIndexOf(".") + 1), a2 = this.attr(name2), atr = {};
          eve2.stop();
          var unit = plus[3] || "", aUnit = a2.match(reUnit), op = operators[plus[1]];
          if (aUnit && aUnit == unit) {
            val = op(parseFloat(a2), +plus[2]);
          } else {
            a2 = this.asPX(name2);
            val = op(this.asPX(name2), this.asPX(name2, plus[2] + unit));
          }
          if (isNaN(a2) || isNaN(val)) {
            return;
          }
          atr[name2] = val;
          this.attr(atr);
        }
      })(-10);
      eve2.on("snap.util.equal", function(name2, b2) {
        var a2 = Str(this.attr(name2) || ""), bplus = Str(b2).match(reAddon);
        if (bplus) {
          eve2.stop();
          var unit = bplus[3] || "", aUnit = a2.match(reUnit), op = operators[bplus[1]];
          if (aUnit && aUnit == unit) {
            return {
              from: parseFloat(a2),
              to: op(parseFloat(a2), +bplus[2]),
              f: getUnit(aUnit)
            };
          } else {
            a2 = this.asPX(name2);
            return {
              from: a2,
              to: op(a2, this.asPX(name2, bplus[2] + unit)),
              f: getNumber
            };
          }
        }
      })(-10);
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var proto = Paper.prototype, is3 = Snap2.is;
      proto.rect = function(x2, y2, w2, h2, rx, ry) {
        var attr2;
        if (ry == null) {
          ry = rx;
        }
        if (is3(x2, "object") && x2 == "[object Object]") {
          attr2 = x2;
        } else if (x2 != null) {
          attr2 = {
            x: x2,
            y: y2,
            width: w2,
            height: h2
          };
          if (rx != null) {
            attr2.rx = rx;
            attr2.ry = ry;
          }
        }
        return this.el("rect", attr2);
      };
      proto.circle = function(cx, cy, r2) {
        var attr2;
        if (is3(cx, "object") && cx == "[object Object]") {
          attr2 = cx;
        } else if (cx != null) {
          attr2 = {
            cx,
            cy,
            r: r2
          };
        }
        return this.el("circle", attr2);
      };
      var preload2 = function() {
        function onerror() {
          this.parentNode.removeChild(this);
        }
        return function(src2, f2) {
          var img = glob.doc.createElement("img"), body = glob.doc.body;
          img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
          img.onload = function() {
            f2.call(img);
            img.onload = img.onerror = null;
            body.removeChild(img);
          };
          img.onerror = onerror;
          body.appendChild(img);
          img.src = src2;
        };
      }();
      proto.image = function(src2, x2, y2, width, height) {
        var el = this.el("image");
        if (is3(src2, "object") && "src" in src2) {
          el.attr(src2);
        } else if (src2 != null) {
          var set = {
            "xlink:href": src2,
            preserveAspectRatio: "none"
          };
          if (x2 != null && y2 != null) {
            set.x = x2;
            set.y = y2;
          }
          if (width != null && height != null) {
            set.width = width;
            set.height = height;
          } else {
            preload2(src2, function() {
              Snap2._.$(el.node, {
                width: this.offsetWidth,
                height: this.offsetHeight
              });
            });
          }
          Snap2._.$(el.node, set);
        }
        return el;
      };
      proto.ellipse = function(cx, cy, rx, ry) {
        var attr2;
        if (is3(cx, "object") && cx == "[object Object]") {
          attr2 = cx;
        } else if (cx != null) {
          attr2 = {
            cx,
            cy,
            rx,
            ry
          };
        }
        return this.el("ellipse", attr2);
      };
      proto.path = function(d2) {
        var attr2;
        if (is3(d2, "object") && !is3(d2, "array")) {
          attr2 = d2;
        } else if (d2) {
          attr2 = { d: d2 };
        }
        return this.el("path", attr2);
      };
      proto.group = proto.g = function(first) {
        var el = this.el("g");
        if (arguments.length == 1 && first && !first.type) {
          el.attr(first);
        } else if (arguments.length) {
          el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
      };
      proto.svg = function(x2, y2, width, height, vbx, vby, vbw, vbh) {
        var attrs = {};
        if (is3(x2, "object") && y2 == null) {
          attrs = x2;
        } else {
          if (x2 != null) {
            attrs.x = x2;
          }
          if (y2 != null) {
            attrs.y = y2;
          }
          if (width != null) {
            attrs.width = width;
          }
          if (height != null) {
            attrs.height = height;
          }
          if (vbx != null && vby != null && vbw != null && vbh != null) {
            attrs.viewBox = [vbx, vby, vbw, vbh];
          }
        }
        return this.el("svg", attrs);
      };
      proto.mask = function(first) {
        var el = this.el("mask");
        if (arguments.length == 1 && first && !first.type) {
          el.attr(first);
        } else if (arguments.length) {
          el.add(Array.prototype.slice.call(arguments, 0));
        }
        return el;
      };
      proto.ptrn = function(x2, y2, width, height, vx, vy, vw, vh) {
        if (is3(x2, "object")) {
          var attr2 = x2;
        } else {
          attr2 = { patternUnits: "userSpaceOnUse" };
          if (x2) {
            attr2.x = x2;
          }
          if (y2) {
            attr2.y = y2;
          }
          if (width != null) {
            attr2.width = width;
          }
          if (height != null) {
            attr2.height = height;
          }
          if (vx != null && vy != null && vw != null && vh != null) {
            attr2.viewBox = [vx, vy, vw, vh];
          } else {
            attr2.viewBox = [x2 || 0, y2 || 0, width || 0, height || 0];
          }
        }
        return this.el("pattern", attr2);
      };
      proto.use = function(id) {
        if (id != null) {
          if (id instanceof Element2) {
            if (!id.attr("id")) {
              id.attr({ id: Snap2._.id(id) });
            }
            id = id.attr("id");
          }
          if (String(id).charAt() == "#") {
            id = id.substring(1);
          }
          return this.el("use", { "xlink:href": "#" + id });
        } else {
          return Element2.prototype.use.call(this);
        }
      };
      proto.symbol = function(vx, vy, vw, vh) {
        var attr2 = {};
        if (vx != null && vy != null && vw != null && vh != null) {
          attr2.viewBox = [vx, vy, vw, vh];
        }
        return this.el("symbol", attr2);
      };
      proto.text = function(x2, y2, text) {
        var attr2 = {};
        if (is3(x2, "object")) {
          attr2 = x2;
        } else if (x2 != null) {
          attr2 = {
            x: x2,
            y: y2,
            text: text || ""
          };
        }
        return this.el("text", attr2);
      };
      proto.line = function(x12, y12, x2, y2) {
        var attr2 = {};
        if (is3(x12, "object")) {
          attr2 = x12;
        } else if (x12 != null) {
          attr2 = {
            x1: x12,
            x2,
            y1: y12,
            y2
          };
        }
        return this.el("line", attr2);
      };
      proto.polyline = function(points2) {
        if (arguments.length > 1) {
          points2 = Array.prototype.slice.call(arguments, 0);
        }
        var attr2 = {};
        if (is3(points2, "object") && !is3(points2, "array")) {
          attr2 = points2;
        } else if (points2 != null) {
          attr2 = { points: points2 };
        }
        return this.el("polyline", attr2);
      };
      proto.polygon = function(points2) {
        if (arguments.length > 1) {
          points2 = Array.prototype.slice.call(arguments, 0);
        }
        var attr2 = {};
        if (is3(points2, "object") && !is3(points2, "array")) {
          attr2 = points2;
        } else if (points2 != null) {
          attr2 = { points: points2 };
        }
        return this.el("polygon", attr2);
      };
      (function() {
        var $ = Snap2._.$;
        function Gstops() {
          return this.selectAll("stop");
        }
        function GaddStop(color, offset) {
          var stop = $("stop"), attr2 = {
            offset: +offset + "%"
          };
          color = Snap2.color(color);
          attr2["stop-color"] = color.hex;
          if (color.opacity < 1) {
            attr2["stop-opacity"] = color.opacity;
          }
          $(stop, attr2);
          var stops = this.stops(), inserted;
          for (var i2 = 0; i2 < stops.length; i2++) {
            var stopOffset = parseFloat(stops[i2].attr("offset"));
            if (stopOffset > offset) {
              this.node.insertBefore(stop, stops[i2].node);
              inserted = true;
              break;
            }
          }
          if (!inserted) {
            this.node.appendChild(stop);
          }
          return this;
        }
        function GgetBBox() {
          if (this.type == "linearGradient") {
            var x12 = $(this.node, "x1") || 0, x2 = $(this.node, "x2") || 1, y12 = $(this.node, "y1") || 0, y2 = $(this.node, "y2") || 0;
            return Snap2._.box(x12, y12, math.abs(x2 - x12), math.abs(y2 - y12));
          } else {
            var cx = this.node.cx || 0.5, cy = this.node.cy || 0.5, r2 = this.node.r || 0;
            return Snap2._.box(cx - r2, cy - r2, r2 * 2, r2 * 2);
          }
        }
        function GsetStops(str) {
          var grad = str, stops = this.stops();
          if (typeof str == "string") {
            grad = eve2("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
          }
          if (!Snap2.is(grad, "array")) {
            return;
          }
          for (var i2 = 0; i2 < stops.length; i2++) {
            if (grad[i2]) {
              var color = Snap2.color(grad[i2].color), attr2 = { "offset": grad[i2].offset + "%" };
              attr2["stop-color"] = color.hex;
              if (color.opacity < 1) {
                attr2["stop-opacity"] = color.opacity;
              }
              stops[i2].attr(attr2);
            } else {
              stops[i2].remove();
            }
          }
          for (i2 = stops.length; i2 < grad.length; i2++) {
            this.addStop(grad[i2].color, grad[i2].offset);
          }
          return this;
        }
        function gradient(defs2, str) {
          var grad = eve2("snap.util.grad.parse", null, str).firstDefined(), el;
          if (!grad) {
            return null;
          }
          grad.params.unshift(defs2);
          if (grad.type.toLowerCase() == "l") {
            el = gradientLinear.apply(0, grad.params);
          } else {
            el = gradientRadial.apply(0, grad.params);
          }
          if (grad.type != grad.type.toLowerCase()) {
            $(el.node, {
              gradientUnits: "userSpaceOnUse"
            });
          }
          var stops = grad.stops, len2 = stops.length;
          for (var i2 = 0; i2 < len2; i2++) {
            var stop = stops[i2];
            el.addStop(stop.color, stop.offset);
          }
          return el;
        }
        function gradientLinear(defs2, x12, y12, x2, y2) {
          var el = Snap2._.make("linearGradient", defs2);
          el.stops = Gstops;
          el.addStop = GaddStop;
          el.getBBox = GgetBBox;
          el.setStops = GsetStops;
          if (x12 != null) {
            $(el.node, {
              x1: x12,
              y1: y12,
              x2,
              y2
            });
          }
          return el;
        }
        function gradientRadial(defs2, cx, cy, r2, fx, fy) {
          var el = Snap2._.make("radialGradient", defs2);
          el.stops = Gstops;
          el.addStop = GaddStop;
          el.getBBox = GgetBBox;
          if (cx != null) {
            $(el.node, {
              cx,
              cy,
              r: r2
            });
          }
          if (fx != null && fy != null) {
            $(el.node, {
              fx,
              fy
            });
          }
          return el;
        }
        proto.gradient = function(str) {
          return gradient(this.defs, str);
        };
        proto.gradientLinear = function(x12, y12, x2, y2) {
          return gradientLinear(this.defs, x12, y12, x2, y2);
        };
        proto.gradientRadial = function(cx, cy, r2, fx, fy) {
          return gradientRadial(this.defs, cx, cy, r2, fx, fy);
        };
        proto.toString = function() {
          var doc = this.node.ownerDocument, f2 = doc.createDocumentFragment(), d2 = doc.createElement("div"), svg = this.node.cloneNode(true), res;
          f2.appendChild(d2);
          d2.appendChild(svg);
          Snap2._.$(svg, { xmlns: "http://www.w3.org/2000/svg" });
          res = d2.innerHTML;
          f2.removeChild(f2.firstChild);
          return res;
        };
        proto.toDataURL = function() {
          if (window2 && window2.btoa) {
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
          }
        };
        proto.clear = function() {
          var node = this.node.firstChild, next5;
          while (node) {
            next5 = node.nextSibling;
            if (node.tagName != "defs") {
              node.parentNode.removeChild(node);
            } else {
              proto.clear.call({ node });
            }
            node = next5;
          }
        };
      })();
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob) {
      var elproto = Element2.prototype, is3 = Snap2.is, clone8 = Snap2._.clone, has2 = "hasOwnProperty", p2s = /,?([a-z]),?/gi, toFloat = parseFloat, math2 = Math, PI2 = math2.PI, mmin = math2.min, mmax = math2.max, pow2 = math2.pow, abs3 = math2.abs;
      function paths(ps) {
        var p2 = paths.ps = paths.ps || {};
        if (p2[ps]) {
          p2[ps].sleep = 100;
        } else {
          p2[ps] = {
            sleep: 100
          };
        }
        setTimeout(function() {
          for (var key in p2)
            if (p2[has2](key) && key != ps) {
              p2[key].sleep--;
              !p2[key].sleep && delete p2[key];
            }
        });
        return p2[ps];
      }
      function box(x2, y2, width, height) {
        if (x2 == null) {
          x2 = y2 = width = height = 0;
        }
        if (y2 == null) {
          y2 = x2.y;
          width = x2.width;
          height = x2.height;
          x2 = x2.x;
        }
        return {
          x: x2,
          y: y2,
          width,
          w: width,
          height,
          h: height,
          x2: x2 + width,
          y2: y2 + height,
          cx: x2 + width / 2,
          cy: y2 + height / 2,
          r1: math2.min(width, height) / 2,
          r2: math2.max(width, height) / 2,
          r0: math2.sqrt(width * width + height * height) / 2,
          path: rectPath(x2, y2, width, height),
          vb: [x2, y2, width, height].join(" ")
        };
      }
      function toString29() {
        return this.join(",").replace(p2s, "$1");
      }
      function pathClone(pathArray) {
        var res = clone8(pathArray);
        res.toString = toString29;
        return res;
      }
      function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length2) {
        if (length2 == null) {
          return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        } else {
          return findDotsAtSegment(
            p1x,
            p1y,
            c1x,
            c1y,
            c2x,
            c2y,
            p2x,
            p2y,
            getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length2)
          );
        }
      }
      function getLengthFactory(istotal, subpath) {
        function O2(val) {
          return +(+val).toFixed(3);
        }
        return Snap2._.cacher(function(path2, length2, onlystart) {
          if (path2 instanceof Element2) {
            path2 = path2.attr("d");
          }
          path2 = path2curve(path2);
          var x2, y2, p2, l2, sp = "", subpaths = {}, point4, len2 = 0;
          for (var i2 = 0, ii2 = path2.length; i2 < ii2; i2++) {
            p2 = path2[i2];
            if (p2[0] == "M") {
              x2 = +p2[1];
              y2 = +p2[2];
            } else {
              l2 = getPointAtSegmentLength(x2, y2, p2[1], p2[2], p2[3], p2[4], p2[5], p2[6]);
              if (len2 + l2 > length2) {
                if (subpath && !subpaths.start) {
                  point4 = getPointAtSegmentLength(x2, y2, p2[1], p2[2], p2[3], p2[4], p2[5], p2[6], length2 - len2);
                  sp += [
                    "C" + O2(point4.start.x),
                    O2(point4.start.y),
                    O2(point4.m.x),
                    O2(point4.m.y),
                    O2(point4.x),
                    O2(point4.y)
                  ];
                  if (onlystart) {
                    return sp;
                  }
                  subpaths.start = sp;
                  sp = [
                    "M" + O2(point4.x),
                    O2(point4.y) + "C" + O2(point4.n.x),
                    O2(point4.n.y),
                    O2(point4.end.x),
                    O2(point4.end.y),
                    O2(p2[5]),
                    O2(p2[6])
                  ].join();
                  len2 += l2;
                  x2 = +p2[5];
                  y2 = +p2[6];
                  continue;
                }
                if (!istotal && !subpath) {
                  point4 = getPointAtSegmentLength(x2, y2, p2[1], p2[2], p2[3], p2[4], p2[5], p2[6], length2 - len2);
                  return point4;
                }
              }
              len2 += l2;
              x2 = +p2[5];
              y2 = +p2[6];
            }
            sp += p2.shift() + p2;
          }
          subpaths.end = sp;
          point4 = istotal ? len2 : subpath ? subpaths : findDotsAtSegment(x2, y2, p2[0], p2[1], p2[2], p2[3], p2[4], p2[5], 1);
          return point4;
        }, null, Snap2._.clone);
      }
      var getTotalLength = getLengthFactory(1), getPointAtLength = getLengthFactory(), getSubpathsAtLength = getLengthFactory(0, 1);
      function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t2) {
        var t1 = 1 - t2, t13 = pow2(t1, 3), t12 = pow2(t1, 2), t22 = t2 * t2, t3 = t22 * t2, x2 = t13 * p1x + t12 * 3 * t2 * c1x + t1 * 3 * t2 * t2 * c2x + t3 * p2x, y2 = t13 * p1y + t12 * 3 * t2 * c1y + t1 * 3 * t2 * t2 * c2y + t3 * p2y, mx = p1x + 2 * t2 * (c1x - p1x) + t22 * (c2x - 2 * c1x + p1x), my = p1y + 2 * t2 * (c1y - p1y) + t22 * (c2y - 2 * c1y + p1y), nx = c1x + 2 * t2 * (c2x - c1x) + t22 * (p2x - 2 * c2x + c1x), ny = c1y + 2 * t2 * (c2y - c1y) + t22 * (p2y - 2 * c2y + c1y), ax2 = t1 * p1x + t2 * c1x, ay2 = t1 * p1y + t2 * c1y, cx = t1 * c2x + t2 * p2x, cy = t1 * c2y + t2 * p2y, alpha = 90 - math2.atan2(mx - nx, my - ny) * 180 / PI2;
        return {
          x: x2,
          y: y2,
          m: { x: mx, y: my },
          n: { x: nx, y: ny },
          start: { x: ax2, y: ay2 },
          end: { x: cx, y: cy },
          alpha
        };
      }
      function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!Snap2.is(p1x, "array")) {
          p1x = [p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y];
        }
        var bbox2 = curveDim.apply(null, p1x);
        return box(
          bbox2.min.x,
          bbox2.min.y,
          bbox2.max.x - bbox2.min.x,
          bbox2.max.y - bbox2.min.y
        );
      }
      function isPointInsideBBox(bbox2, x2, y2) {
        return x2 >= bbox2.x && x2 <= bbox2.x + bbox2.width && y2 >= bbox2.y && y2 <= bbox2.y + bbox2.height;
      }
      function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2) || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x) && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
      }
      function base3(t2, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4, t22 = t2 * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t2 * t22 - 3 * p1 + 3 * p2;
      }
      function bezlen(x12, y12, x2, y2, x3, y3, x4, y4, z2) {
        if (z2 == null) {
          z2 = 1;
        }
        z2 = z2 > 1 ? 1 : z2 < 0 ? 0 : z2;
        var z22 = z2 / 2, n2 = 12, Tvalues = [-0.1252, 0.1252, -0.3678, 0.3678, -0.5873, 0.5873, -0.7699, 0.7699, -0.9041, 0.9041, -0.9816, 0.9816], Cvalues = [0.2491, 0.2491, 0.2335, 0.2335, 0.2032, 0.2032, 0.1601, 0.1601, 0.1069, 0.1069, 0.0472, 0.0472], sum2 = 0;
        for (var i2 = 0; i2 < n2; i2++) {
          var ct = z22 * Tvalues[i2] + z22, xbase = base3(ct, x12, x2, x3, x4), ybase = base3(ct, y12, y2, y3, y4), comb = xbase * xbase + ybase * ybase;
          sum2 += Cvalues[i2] * math2.sqrt(comb);
        }
        return z22 * sum2;
      }
      function getTotLen(x12, y12, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x12, y12, x2, y2, x3, y3, x4, y4) < ll) {
          return;
        }
        var t2 = 1, step = t2 / 2, t22 = t2 - step, l2, e3 = 0.01;
        l2 = bezlen(x12, y12, x2, y2, x3, y3, x4, y4, t22);
        while (abs3(l2 - ll) > e3) {
          step /= 2;
          t22 += (l2 < ll ? 1 : -1) * step;
          l2 = bezlen(x12, y12, x2, y2, x3, y3, x4, y4, t22);
        }
        return t22;
      }
      function intersect2(x12, y12, x2, y2, x3, y3, x4, y4) {
        if (mmax(x12, x2) < mmin(x3, x4) || mmin(x12, x2) > mmax(x3, x4) || mmax(y12, y2) < mmin(y3, y4) || mmin(y12, y2) > mmax(y3, y4)) {
          return;
        }
        var nx = (x12 * y2 - y12 * x2) * (x3 - x4) - (x12 - x2) * (x3 * y4 - y3 * x4), ny = (x12 * y2 - y12 * x2) * (y3 - y4) - (y12 - y2) * (x3 * y4 - y3 * x4), denominator = (x12 - x2) * (y3 - y4) - (y12 - y2) * (x3 - x4);
        if (!denominator) {
          return;
        }
        var px2 = nx / denominator, py2 = ny / denominator, px22 = +px2.toFixed(2), py22 = +py2.toFixed(2);
        if (px22 < +mmin(x12, x2).toFixed(2) || px22 > +mmax(x12, x2).toFixed(2) || px22 < +mmin(x3, x4).toFixed(2) || px22 > +mmax(x3, x4).toFixed(2) || py22 < +mmin(y12, y2).toFixed(2) || py22 > +mmax(y12, y2).toFixed(2) || py22 < +mmin(y3, y4).toFixed(2) || py22 > +mmax(y3, y4).toFixed(2)) {
          return;
        }
        return { x: px2, y: py2 };
      }
      function interHelper(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1), bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) {
          return justCount ? 0 : [];
        }
        var l1 = bezlen.apply(0, bez1), l2 = bezlen.apply(0, bez2), n1 = ~~(l1 / 8), n2 = ~~(l2 / 8), dots1 = [], dots2 = [], xy = {}, res = justCount ? 0 : [];
        for (var i2 = 0; i2 < n1 + 1; i2++) {
          var p2 = findDotsAtSegment.apply(0, bez1.concat(i2 / n1));
          dots1.push({ x: p2.x, y: p2.y, t: i2 / n1 });
        }
        for (i2 = 0; i2 < n2 + 1; i2++) {
          p2 = findDotsAtSegment.apply(0, bez2.concat(i2 / n2));
          dots2.push({ x: p2.x, y: p2.y, t: i2 / n2 });
        }
        for (i2 = 0; i2 < n1; i2++) {
          for (var j2 = 0; j2 < n2; j2++) {
            var di = dots1[i2], di1 = dots1[i2 + 1], dj = dots2[j2], dj1 = dots2[j2 + 1], ci2 = abs3(di1.x - di.x) < 1e-3 ? "y" : "x", cj2 = abs3(dj1.x - dj.x) < 1e-3 ? "y" : "x", is4 = intersect2(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
            if (is4) {
              if (xy[is4.x.toFixed(4)] == is4.y.toFixed(4)) {
                continue;
              }
              xy[is4.x.toFixed(4)] = is4.y.toFixed(4);
              var t1 = di.t + abs3((is4[ci2] - di[ci2]) / (di1[ci2] - di[ci2])) * (di1.t - di.t), t2 = dj.t + abs3((is4[cj2] - dj[cj2]) / (dj1[cj2] - dj[cj2])) * (dj1.t - dj.t);
              if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                if (justCount) {
                  res++;
                } else {
                  res.push({
                    x: is4.x,
                    y: is4.y,
                    t1,
                    t2
                  });
                }
              }
            }
          }
        }
        return res;
      }
      function pathIntersection(path1, path2) {
        return interPathHelper(path1, path2);
      }
      function pathIntersectionNumber(path1, path2) {
        return interPathHelper(path1, path2, 1);
      }
      function interPathHelper(path1, path2, justCount) {
        path1 = path2curve(path1);
        path2 = path2curve(path2);
        var x12, y12, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2, res = justCount ? 0 : [];
        for (var i2 = 0, ii2 = path1.length; i2 < ii2; i2++) {
          var pi2 = path1[i2];
          if (pi2[0] == "M") {
            x12 = x1m = pi2[1];
            y12 = y1m = pi2[2];
          } else {
            if (pi2[0] == "C") {
              bez1 = [x12, y12].concat(pi2.slice(1));
              x12 = bez1[6];
              y12 = bez1[7];
            } else {
              bez1 = [x12, y12, x12, y12, x1m, y1m, x1m, y1m];
              x12 = x1m;
              y12 = y1m;
            }
            for (var j2 = 0, jj = path2.length; j2 < jj; j2++) {
              var pj = path2[j2];
              if (pj[0] == "M") {
                x2 = x2m = pj[1];
                y2 = y2m = pj[2];
              } else {
                if (pj[0] == "C") {
                  bez2 = [x2, y2].concat(pj.slice(1));
                  x2 = bez2[6];
                  y2 = bez2[7];
                } else {
                  bez2 = [x2, y2, x2, y2, x2m, y2m, x2m, y2m];
                  x2 = x2m;
                  y2 = y2m;
                }
                var intr = interHelper(bez1, bez2, justCount);
                if (justCount) {
                  res += intr;
                } else {
                  for (var k2 = 0, kk = intr.length; k2 < kk; k2++) {
                    intr[k2].segment1 = i2;
                    intr[k2].segment2 = j2;
                    intr[k2].bez1 = bez1;
                    intr[k2].bez2 = bez2;
                  }
                  res = res.concat(intr);
                }
              }
            }
          }
        }
        return res;
      }
      function isPointInsidePath(path2, x2, y2) {
        var bbox2 = pathBBox(path2);
        return isPointInsideBBox(bbox2, x2, y2) && interPathHelper(path2, [["M", x2, y2], ["H", bbox2.x2 + 10]], 1) % 2 == 1;
      }
      function pathBBox(path2) {
        var pth = paths(path2);
        if (pth.bbox) {
          return clone8(pth.bbox);
        }
        if (!path2) {
          return box();
        }
        path2 = path2curve(path2);
        var x2 = 0, y2 = 0, X2 = [], Y2 = [], p2;
        for (var i2 = 0, ii2 = path2.length; i2 < ii2; i2++) {
          p2 = path2[i2];
          if (p2[0] == "M") {
            x2 = p2[1];
            y2 = p2[2];
            X2.push(x2);
            Y2.push(y2);
          } else {
            var dim = curveDim(x2, y2, p2[1], p2[2], p2[3], p2[4], p2[5], p2[6]);
            X2 = X2.concat(dim.min.x, dim.max.x);
            Y2 = Y2.concat(dim.min.y, dim.max.y);
            x2 = p2[5];
            y2 = p2[6];
          }
        }
        var xmin = mmin.apply(0, X2), ymin = mmin.apply(0, Y2), xmax = mmax.apply(0, X2), ymax = mmax.apply(0, Y2), bb2 = box(xmin, ymin, xmax - xmin, ymax - ymin);
        pth.bbox = clone8(bb2);
        return bb2;
      }
      function rectPath(x2, y2, w2, h2, r2) {
        if (r2) {
          return [
            ["M", +x2 + +r2, y2],
            ["l", w2 - r2 * 2, 0],
            ["a", r2, r2, 0, 0, 1, r2, r2],
            ["l", 0, h2 - r2 * 2],
            ["a", r2, r2, 0, 0, 1, -r2, r2],
            ["l", r2 * 2 - w2, 0],
            ["a", r2, r2, 0, 0, 1, -r2, -r2],
            ["l", 0, r2 * 2 - h2],
            ["a", r2, r2, 0, 0, 1, r2, -r2],
            ["z"]
          ];
        }
        var res = [["M", x2, y2], ["l", w2, 0], ["l", 0, h2], ["l", -w2, 0], ["z"]];
        res.toString = toString29;
        return res;
      }
      function ellipsePath(x2, y2, rx, ry, a2) {
        if (a2 == null && ry == null) {
          ry = rx;
        }
        x2 = +x2;
        y2 = +y2;
        rx = +rx;
        ry = +ry;
        if (a2 != null) {
          var rad2 = Math.PI / 180, x12 = x2 + rx * Math.cos(-ry * rad2), x22 = x2 + rx * Math.cos(-a2 * rad2), y12 = y2 + rx * Math.sin(-ry * rad2), y22 = y2 + rx * Math.sin(-a2 * rad2), res = [["M", x12, y12], ["A", rx, rx, 0, +(a2 - ry > 180), 0, x22, y22]];
        } else {
          res = [
            ["M", x2, y2],
            ["m", 0, -ry],
            ["a", rx, ry, 0, 1, 1, 0, 2 * ry],
            ["a", rx, ry, 0, 1, 1, 0, -2 * ry],
            ["z"]
          ];
        }
        res.toString = toString29;
        return res;
      }
      var unit2px = Snap2._unit2px, getPath = {
        path: function(el) {
          return el.attr("path");
        },
        circle: function(el) {
          var attr2 = unit2px(el);
          return ellipsePath(attr2.cx, attr2.cy, attr2.r);
        },
        ellipse: function(el) {
          var attr2 = unit2px(el);
          return ellipsePath(attr2.cx || 0, attr2.cy || 0, attr2.rx, attr2.ry);
        },
        rect: function(el) {
          var attr2 = unit2px(el);
          return rectPath(attr2.x || 0, attr2.y || 0, attr2.width, attr2.height, attr2.rx, attr2.ry);
        },
        image: function(el) {
          var attr2 = unit2px(el);
          return rectPath(attr2.x || 0, attr2.y || 0, attr2.width, attr2.height);
        },
        line: function(el) {
          return "M" + [el.attr("x1") || 0, el.attr("y1") || 0, el.attr("x2"), el.attr("y2")];
        },
        polyline: function(el) {
          return "M" + el.attr("points");
        },
        polygon: function(el) {
          return "M" + el.attr("points") + "z";
        },
        deflt: function(el) {
          var bbox2 = el.node.getBBox();
          return rectPath(bbox2.x, bbox2.y, bbox2.width, bbox2.height);
        }
      };
      function pathToRelative(pathArray) {
        var pth = paths(pathArray), lowerCase = String.prototype.toLowerCase;
        if (pth.rel) {
          return pathClone(pth.rel);
        }
        if (!Snap2.is(pathArray, "array") || !Snap2.is(pathArray && pathArray[0], "array")) {
          pathArray = Snap2.parsePathString(pathArray);
        }
        var res = [], x2 = 0, y2 = 0, mx = 0, my = 0, start2 = 0;
        if (pathArray[0][0] == "M") {
          x2 = pathArray[0][1];
          y2 = pathArray[0][2];
          mx = x2;
          my = y2;
          start2++;
          res.push(["M", x2, y2]);
        }
        for (var i2 = start2, ii2 = pathArray.length; i2 < ii2; i2++) {
          var r2 = res[i2] = [], pa = pathArray[i2];
          if (pa[0] != lowerCase.call(pa[0])) {
            r2[0] = lowerCase.call(pa[0]);
            switch (r2[0]) {
              case "a":
                r2[1] = pa[1];
                r2[2] = pa[2];
                r2[3] = pa[3];
                r2[4] = pa[4];
                r2[5] = pa[5];
                r2[6] = +(pa[6] - x2).toFixed(3);
                r2[7] = +(pa[7] - y2).toFixed(3);
                break;
              case "v":
                r2[1] = +(pa[1] - y2).toFixed(3);
                break;
              case "m":
                mx = pa[1];
                my = pa[2];
              default:
                for (var j2 = 1, jj = pa.length; j2 < jj; j2++) {
                  r2[j2] = +(pa[j2] - (j2 % 2 ? x2 : y2)).toFixed(3);
                }
            }
          } else {
            r2 = res[i2] = [];
            if (pa[0] == "m") {
              mx = pa[1] + x2;
              my = pa[2] + y2;
            }
            for (var k2 = 0, kk = pa.length; k2 < kk; k2++) {
              res[i2][k2] = pa[k2];
            }
          }
          var len2 = res[i2].length;
          switch (res[i2][0]) {
            case "z":
              x2 = mx;
              y2 = my;
              break;
            case "h":
              x2 += +res[i2][len2 - 1];
              break;
            case "v":
              y2 += +res[i2][len2 - 1];
              break;
            default:
              x2 += +res[i2][len2 - 2];
              y2 += +res[i2][len2 - 1];
          }
        }
        res.toString = toString29;
        pth.rel = pathClone(res);
        return res;
      }
      function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) {
          return pathClone(pth.abs);
        }
        if (!is3(pathArray, "array") || !is3(pathArray && pathArray[0], "array")) {
          pathArray = Snap2.parsePathString(pathArray);
        }
        if (!pathArray || !pathArray.length) {
          return [["M", 0, 0]];
        }
        var res = [], x2 = 0, y2 = 0, mx = 0, my = 0, start2 = 0, pa0;
        if (pathArray[0][0] == "M") {
          x2 = +pathArray[0][1];
          y2 = +pathArray[0][2];
          mx = x2;
          my = y2;
          start2++;
          res[0] = ["M", x2, y2];
        }
        var crz = pathArray.length == 3 && pathArray[0][0] == "M" && pathArray[1][0].toUpperCase() == "R" && pathArray[2][0].toUpperCase() == "Z";
        for (var r2, pa, i2 = start2, ii2 = pathArray.length; i2 < ii2; i2++) {
          res.push(r2 = []);
          pa = pathArray[i2];
          pa0 = pa[0];
          if (pa0 != pa0.toUpperCase()) {
            r2[0] = pa0.toUpperCase();
            switch (r2[0]) {
              case "A":
                r2[1] = pa[1];
                r2[2] = pa[2];
                r2[3] = pa[3];
                r2[4] = pa[4];
                r2[5] = pa[5];
                r2[6] = +pa[6] + x2;
                r2[7] = +pa[7] + y2;
                break;
              case "V":
                r2[1] = +pa[1] + y2;
                break;
              case "H":
                r2[1] = +pa[1] + x2;
                break;
              case "R":
                var dots = [x2, y2].concat(pa.slice(1));
                for (var j2 = 2, jj = dots.length; j2 < jj; j2++) {
                  dots[j2] = +dots[j2] + x2;
                  dots[++j2] = +dots[j2] + y2;
                }
                res.pop();
                res = res.concat(catmullRom2bezier(dots, crz));
                break;
              case "O":
                res.pop();
                dots = ellipsePath(x2, y2, pa[1], pa[2]);
                dots.push(dots[0]);
                res = res.concat(dots);
                break;
              case "U":
                res.pop();
                res = res.concat(ellipsePath(x2, y2, pa[1], pa[2], pa[3]));
                r2 = ["U"].concat(res[res.length - 1].slice(-2));
                break;
              case "M":
                mx = +pa[1] + x2;
                my = +pa[2] + y2;
              default:
                for (j2 = 1, jj = pa.length; j2 < jj; j2++) {
                  r2[j2] = +pa[j2] + (j2 % 2 ? x2 : y2);
                }
            }
          } else if (pa0 == "R") {
            dots = [x2, y2].concat(pa.slice(1));
            res.pop();
            res = res.concat(catmullRom2bezier(dots, crz));
            r2 = ["R"].concat(pa.slice(-2));
          } else if (pa0 == "O") {
            res.pop();
            dots = ellipsePath(x2, y2, pa[1], pa[2]);
            dots.push(dots[0]);
            res = res.concat(dots);
          } else if (pa0 == "U") {
            res.pop();
            res = res.concat(ellipsePath(x2, y2, pa[1], pa[2], pa[3]));
            r2 = ["U"].concat(res[res.length - 1].slice(-2));
          } else {
            for (var k2 = 0, kk = pa.length; k2 < kk; k2++) {
              r2[k2] = pa[k2];
            }
          }
          pa0 = pa0.toUpperCase();
          if (pa0 != "O") {
            switch (r2[0]) {
              case "Z":
                x2 = +mx;
                y2 = +my;
                break;
              case "H":
                x2 = r2[1];
                break;
              case "V":
                y2 = r2[1];
                break;
              case "M":
                mx = r2[r2.length - 2];
                my = r2[r2.length - 1];
              default:
                x2 = r2[r2.length - 2];
                y2 = r2[r2.length - 1];
            }
          }
        }
        res.toString = toString29;
        pth.abs = pathClone(res);
        return res;
      }
      function l2c(x12, y12, x2, y2) {
        return [x12, y12, x2, y2, x2, y2];
      }
      function q2c(x12, y12, ax2, ay2, x2, y2) {
        var _13 = 1 / 3, _23 = 2 / 3;
        return [
          _13 * x12 + _23 * ax2,
          _13 * y12 + _23 * ay2,
          _13 * x2 + _23 * ax2,
          _13 * y2 + _23 * ay2,
          x2,
          y2
        ];
      }
      function a2c(x12, y12, rx, ry, angle4, large_arc_flag, sweep_flag, x2, y2, recursive) {
        var _120 = PI2 * 120 / 180, rad2 = PI2 / 180 * (+angle4 || 0), res = [], xy, rotate3 = Snap2._.cacher(function(x4, y4, rad3) {
          var X2 = x4 * math2.cos(rad3) - y4 * math2.sin(rad3), Y2 = x4 * math2.sin(rad3) + y4 * math2.cos(rad3);
          return { x: X2, y: Y2 };
        });
        if (!rx || !ry) {
          return [x12, y12, x2, y2, x2, y2];
        }
        if (!recursive) {
          xy = rotate3(x12, y12, -rad2);
          x12 = xy.x;
          y12 = xy.y;
          xy = rotate3(x2, y2, -rad2);
          x2 = xy.x;
          y2 = xy.y;
          var x3 = (x12 - x2) / 2, y3 = (y12 - y2) / 2;
          var h2 = x3 * x3 / (rx * rx) + y3 * y3 / (ry * ry);
          if (h2 > 1) {
            h2 = math2.sqrt(h2);
            rx = h2 * rx;
            ry = h2 * ry;
          }
          var rx2 = rx * rx, ry2 = ry * ry, k2 = (large_arc_flag == sweep_flag ? -1 : 1) * math2.sqrt(abs3((rx2 * ry2 - rx2 * y3 * y3 - ry2 * x3 * x3) / (rx2 * y3 * y3 + ry2 * x3 * x3))), cx = k2 * rx * y3 / ry + (x12 + x2) / 2, cy = k2 * -ry * x3 / rx + (y12 + y2) / 2, f1 = math2.asin(((y12 - cy) / ry).toFixed(9)), f2 = math2.asin(((y2 - cy) / ry).toFixed(9));
          f1 = x12 < cx ? PI2 - f1 : f1;
          f2 = x2 < cx ? PI2 - f2 : f2;
          f1 < 0 && (f1 = PI2 * 2 + f1);
          f2 < 0 && (f2 = PI2 * 2 + f2);
          if (sweep_flag && f1 > f2) {
            f1 = f1 - PI2 * 2;
          }
          if (!sweep_flag && f2 > f1) {
            f2 = f2 - PI2 * 2;
          }
        } else {
          f1 = recursive[0];
          f2 = recursive[1];
          cx = recursive[2];
          cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs3(df) > _120) {
          var f2old = f2, x2old = x2, y2old = y2;
          f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
          x2 = cx + rx * math2.cos(f2);
          y2 = cy + ry * math2.sin(f2);
          res = a2c(x2, y2, rx, ry, angle4, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy]);
        }
        df = f2 - f1;
        var c1 = math2.cos(f1), s1 = math2.sin(f1), c2 = math2.cos(f2), s2 = math2.sin(f2), t2 = math2.tan(df / 4), hx = 4 / 3 * rx * t2, hy = 4 / 3 * ry * t2, m1 = [x12, y12], m2 = [x12 + hx * s1, y12 - hy * c1], m3 = [x2 + hx * s2, y2 - hy * c2], m4 = [x2, y2];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) {
          return [m2, m3, m4].concat(res);
        } else {
          res = [m2, m3, m4].concat(res).join().split(",");
          var newres = [];
          for (var i2 = 0, ii2 = res.length; i2 < ii2; i2++) {
            newres[i2] = i2 % 2 ? rotate3(res[i2 - 1], res[i2], rad2).y : rotate3(res[i2], res[i2 + 1], rad2).x;
          }
          return newres;
        }
      }
      function curveDim(x02, y02, x12, y12, x2, y2, x3, y3) {
        var tvalues = [], bounds = [[], []], a2, b2, c2, t2, t1, t22, b2ac, sqrtb2ac;
        for (var i2 = 0; i2 < 2; ++i2) {
          if (i2 == 0) {
            b2 = 6 * x02 - 12 * x12 + 6 * x2;
            a2 = -3 * x02 + 9 * x12 - 9 * x2 + 3 * x3;
            c2 = 3 * x12 - 3 * x02;
          } else {
            b2 = 6 * y02 - 12 * y12 + 6 * y2;
            a2 = -3 * y02 + 9 * y12 - 9 * y2 + 3 * y3;
            c2 = 3 * y12 - 3 * y02;
          }
          if (abs3(a2) < 1e-12) {
            if (abs3(b2) < 1e-12) {
              continue;
            }
            t2 = -c2 / b2;
            if (0 < t2 && t2 < 1) {
              tvalues.push(t2);
            }
            continue;
          }
          b2ac = b2 * b2 - 4 * c2 * a2;
          sqrtb2ac = math2.sqrt(b2ac);
          if (b2ac < 0) {
            continue;
          }
          t1 = (-b2 + sqrtb2ac) / (2 * a2);
          if (0 < t1 && t1 < 1) {
            tvalues.push(t1);
          }
          t22 = (-b2 - sqrtb2ac) / (2 * a2);
          if (0 < t22 && t22 < 1) {
            tvalues.push(t22);
          }
        }
        var j2 = tvalues.length, jlen = j2, mt;
        while (j2--) {
          t2 = tvalues[j2];
          mt = 1 - t2;
          bounds[0][j2] = mt * mt * mt * x02 + 3 * mt * mt * t2 * x12 + 3 * mt * t2 * t2 * x2 + t2 * t2 * t2 * x3;
          bounds[1][j2] = mt * mt * mt * y02 + 3 * mt * mt * t2 * y12 + 3 * mt * t2 * t2 * y2 + t2 * t2 * t2 * y3;
        }
        bounds[0][jlen] = x02;
        bounds[1][jlen] = y02;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;
        return {
          min: { x: mmin.apply(0, bounds[0]), y: mmin.apply(0, bounds[1]) },
          max: { x: mmax.apply(0, bounds[0]), y: mmax.apply(0, bounds[1]) }
        };
      }
      function path2curve(path2, path22) {
        var pth = !path22 && paths(path2);
        if (!path22 && pth.curve) {
          return pathClone(pth.curve);
        }
        var p2 = pathToAbsolute(path2), p22 = path22 && pathToAbsolute(path22), attrs = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null }, attrs2 = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null }, processPath = function(path3, d2, pcom2) {
          var nx, ny;
          if (!path3) {
            return ["C", d2.x, d2.y, d2.x, d2.y, d2.x, d2.y];
          }
          !(path3[0] in { T: 1, Q: 1 }) && (d2.qx = d2.qy = null);
          switch (path3[0]) {
            case "M":
              d2.X = path3[1];
              d2.Y = path3[2];
              break;
            case "A":
              path3 = ["C"].concat(a2c.apply(0, [d2.x, d2.y].concat(path3.slice(1))));
              break;
            case "S":
              if (pcom2 == "C" || pcom2 == "S") {
                nx = d2.x * 2 - d2.bx;
                ny = d2.y * 2 - d2.by;
              } else {
                nx = d2.x;
                ny = d2.y;
              }
              path3 = ["C", nx, ny].concat(path3.slice(1));
              break;
            case "T":
              if (pcom2 == "Q" || pcom2 == "T") {
                d2.qx = d2.x * 2 - d2.qx;
                d2.qy = d2.y * 2 - d2.qy;
              } else {
                d2.qx = d2.x;
                d2.qy = d2.y;
              }
              path3 = ["C"].concat(q2c(d2.x, d2.y, d2.qx, d2.qy, path3[1], path3[2]));
              break;
            case "Q":
              d2.qx = path3[1];
              d2.qy = path3[2];
              path3 = ["C"].concat(q2c(d2.x, d2.y, path3[1], path3[2], path3[3], path3[4]));
              break;
            case "L":
              path3 = ["C"].concat(l2c(d2.x, d2.y, path3[1], path3[2]));
              break;
            case "H":
              path3 = ["C"].concat(l2c(d2.x, d2.y, path3[1], d2.y));
              break;
            case "V":
              path3 = ["C"].concat(l2c(d2.x, d2.y, d2.x, path3[1]));
              break;
            case "Z":
              path3 = ["C"].concat(l2c(d2.x, d2.y, d2.X, d2.Y));
              break;
          }
          return path3;
        }, fixArc = function(pp, i3) {
          if (pp[i3].length > 7) {
            pp[i3].shift();
            var pi2 = pp[i3];
            while (pi2.length) {
              pcoms1[i3] = "A";
              p22 && (pcoms2[i3] = "A");
              pp.splice(i3++, 0, ["C"].concat(pi2.splice(0, 6)));
            }
            pp.splice(i3, 1);
            ii2 = mmax(p2.length, p22 && p22.length || 0);
          }
        }, fixM = function(path1, path23, a1, a2, i3) {
          if (path1 && path23 && path1[i3][0] == "M" && path23[i3][0] != "M") {
            path23.splice(i3, 0, ["M", a2.x, a2.y]);
            a1.bx = 0;
            a1.by = 0;
            a1.x = path1[i3][1];
            a1.y = path1[i3][2];
            ii2 = mmax(p2.length, p22 && p22.length || 0);
          }
        }, pcoms1 = [], pcoms2 = [], pfirst = "", pcom = "";
        for (var i2 = 0, ii2 = mmax(p2.length, p22 && p22.length || 0); i2 < ii2; i2++) {
          p2[i2] && (pfirst = p2[i2][0]);
          if (pfirst != "C") {
            pcoms1[i2] = pfirst;
            i2 && (pcom = pcoms1[i2 - 1]);
          }
          p2[i2] = processPath(p2[i2], attrs, pcom);
          if (pcoms1[i2] != "A" && pfirst == "C")
            pcoms1[i2] = "C";
          fixArc(p2, i2);
          if (p22) {
            p22[i2] && (pfirst = p22[i2][0]);
            if (pfirst != "C") {
              pcoms2[i2] = pfirst;
              i2 && (pcom = pcoms2[i2 - 1]);
            }
            p22[i2] = processPath(p22[i2], attrs2, pcom);
            if (pcoms2[i2] != "A" && pfirst == "C") {
              pcoms2[i2] = "C";
            }
            fixArc(p22, i2);
          }
          fixM(p2, p22, attrs, attrs2, i2);
          fixM(p22, p2, attrs2, attrs, i2);
          var seg = p2[i2], seg2 = p22 && p22[i2], seglen = seg.length, seg2len = p22 && seg2.length;
          attrs.x = seg[seglen - 2];
          attrs.y = seg[seglen - 1];
          attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
          attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
          attrs2.bx = p22 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
          attrs2.by = p22 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
          attrs2.x = p22 && seg2[seg2len - 2];
          attrs2.y = p22 && seg2[seg2len - 1];
        }
        if (!p22) {
          pth.curve = pathClone(p2);
        }
        return p22 ? [p2, p22] : p2;
      }
      function mapPath(path2, matrix) {
        if (!matrix) {
          return path2;
        }
        var x2, y2, i2, j2, ii2, jj, pathi;
        path2 = path2curve(path2);
        for (i2 = 0, ii2 = path2.length; i2 < ii2; i2++) {
          pathi = path2[i2];
          for (j2 = 1, jj = pathi.length; j2 < jj; j2 += 2) {
            x2 = matrix.x(pathi[j2], pathi[j2 + 1]);
            y2 = matrix.y(pathi[j2], pathi[j2 + 1]);
            pathi[j2] = x2;
            pathi[j2 + 1] = y2;
          }
        }
        return path2;
      }
      function catmullRom2bezier(crp, z2) {
        var d2 = [];
        for (var i2 = 0, iLen = crp.length; iLen - 2 * !z2 > i2; i2 += 2) {
          var p2 = [
            { x: +crp[i2 - 2], y: +crp[i2 - 1] },
            { x: +crp[i2], y: +crp[i2 + 1] },
            { x: +crp[i2 + 2], y: +crp[i2 + 3] },
            { x: +crp[i2 + 4], y: +crp[i2 + 5] }
          ];
          if (z2) {
            if (!i2) {
              p2[0] = { x: +crp[iLen - 2], y: +crp[iLen - 1] };
            } else if (iLen - 4 == i2) {
              p2[3] = { x: +crp[0], y: +crp[1] };
            } else if (iLen - 2 == i2) {
              p2[2] = { x: +crp[0], y: +crp[1] };
              p2[3] = { x: +crp[2], y: +crp[3] };
            }
          } else {
            if (iLen - 4 == i2) {
              p2[3] = p2[2];
            } else if (!i2) {
              p2[0] = { x: +crp[i2], y: +crp[i2 + 1] };
            }
          }
          d2.push([
            "C",
            (-p2[0].x + 6 * p2[1].x + p2[2].x) / 6,
            (-p2[0].y + 6 * p2[1].y + p2[2].y) / 6,
            (p2[1].x + 6 * p2[2].x - p2[3].x) / 6,
            (p2[1].y + 6 * p2[2].y - p2[3].y) / 6,
            p2[2].x,
            p2[2].y
          ]);
        }
        return d2;
      }
      Snap2.path = paths;
      Snap2.path.getTotalLength = getTotalLength;
      Snap2.path.getPointAtLength = getPointAtLength;
      Snap2.path.getSubpath = function(path2, from, to) {
        if (this.getTotalLength(path2) - to < 1e-6) {
          return getSubpathsAtLength(path2, from).end;
        }
        var a2 = getSubpathsAtLength(path2, to, 1);
        return from ? getSubpathsAtLength(a2, from).end : a2;
      };
      elproto.getTotalLength = function() {
        if (this.node.getTotalLength) {
          return this.node.getTotalLength();
        }
      };
      elproto.getPointAtLength = function(length2) {
        return getPointAtLength(this.attr("d"), length2);
      };
      elproto.getSubpath = function(from, to) {
        return Snap2.path.getSubpath(this.attr("d"), from, to);
      };
      Snap2._.box = box;
      Snap2.path.findDotsAtSegment = findDotsAtSegment;
      Snap2.path.bezierBBox = bezierBBox;
      Snap2.path.isPointInsideBBox = isPointInsideBBox;
      Snap2.closest = function(x2, y2, X2, Y2) {
        var r2 = 100, b2 = box(x2 - r2 / 2, y2 - r2 / 2, r2, r2), inside = [], getter = X2[0].hasOwnProperty("x") ? function(i3) {
          return {
            x: X2[i3].x,
            y: X2[i3].y
          };
        } : function(i3) {
          return {
            x: X2[i3],
            y: Y2[i3]
          };
        }, found = 0;
        while (r2 <= 1e6 && !found) {
          for (var i2 = 0, ii2 = X2.length; i2 < ii2; i2++) {
            var xy = getter(i2);
            if (isPointInsideBBox(b2, xy.x, xy.y)) {
              found++;
              inside.push(xy);
              break;
            }
          }
          if (!found) {
            r2 *= 2;
            b2 = box(x2 - r2 / 2, y2 - r2 / 2, r2, r2);
          }
        }
        if (r2 == 1e6) {
          return;
        }
        var len2 = Infinity, res;
        for (i2 = 0, ii2 = inside.length; i2 < ii2; i2++) {
          var l2 = Snap2.len(x2, y2, inside[i2].x, inside[i2].y);
          if (len2 > l2) {
            len2 = l2;
            inside[i2].len = l2;
            res = inside[i2];
          }
        }
        return res;
      };
      Snap2.path.isBBoxIntersect = isBBoxIntersect;
      Snap2.path.intersection = pathIntersection;
      Snap2.path.intersectionNumber = pathIntersectionNumber;
      Snap2.path.isPointInside = isPointInsidePath;
      Snap2.path.getBBox = pathBBox;
      Snap2.path.get = getPath;
      Snap2.path.toRelative = pathToRelative;
      Snap2.path.toAbsolute = pathToAbsolute;
      Snap2.path.toCubic = path2curve;
      Snap2.path.map = mapPath;
      Snap2.path.toString = toString29;
      Snap2.path.clone = pathClone;
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob) {
      var mmax = Math.max, mmin = Math.min;
      var Set2 = function(items) {
        this.items = [];
        this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
          for (var i2 = 0, ii2 = items.length; i2 < ii2; i2++) {
            if (items[i2]) {
              this[this.items.length] = this.items[this.items.length] = items[i2];
              this.length++;
            }
          }
        }
      }, setproto = Set2.prototype;
      setproto.push = function() {
        var item, len2;
        for (var i2 = 0, ii2 = arguments.length; i2 < ii2; i2++) {
          item = arguments[i2];
          if (item) {
            len2 = this.items.length;
            this[len2] = this.items[len2] = item;
            this.length++;
          }
        }
        return this;
      };
      setproto.pop = function() {
        this.length && delete this[this.length--];
        return this.items.pop();
      };
      setproto.forEach = function(callback, thisArg) {
        for (var i2 = 0, ii2 = this.items.length; i2 < ii2; i2++) {
          if (callback.call(thisArg, this.items[i2], i2) === false) {
            return this;
          }
        }
        return this;
      };
      setproto.animate = function(attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
          callback = easing;
          easing = mina.linear;
        }
        if (attrs instanceof Snap2._.Animation) {
          callback = attrs.callback;
          easing = attrs.easing;
          ms = easing.dur;
          attrs = attrs.attr;
        }
        var args = arguments;
        if (Snap2.is(attrs, "array") && Snap2.is(args[args.length - 1], "array")) {
          var each = true;
        }
        var begin, handler = function() {
          if (begin) {
            this.b = begin;
          } else {
            begin = this.b;
          }
        }, cb2 = 0, set = this, callbacker = callback && function() {
          if (++cb2 == set.length) {
            callback.call(this);
          }
        };
        return this.forEach(function(el, i2) {
          eve2.once("snap.animcreated." + el.id, handler);
          if (each) {
            args[i2] && el.animate.apply(el, args[i2]);
          } else {
            el.animate(attrs, ms, easing, callbacker);
          }
        });
      };
      setproto.remove = function() {
        while (this.length) {
          this.pop().remove();
        }
        return this;
      };
      setproto.bind = function(attr2, a2, b2) {
        var data2 = {};
        if (typeof a2 == "function") {
          this.bindings[attr2] = a2;
        } else {
          var aname = b2 || attr2;
          this.bindings[attr2] = function(v5) {
            data2[aname] = v5;
            a2.attr(data2);
          };
        }
        return this;
      };
      setproto.attr = function(value) {
        var unbound = {};
        for (var k2 in value) {
          if (this.bindings[k2]) {
            this.bindings[k2](value[k2]);
          } else {
            unbound[k2] = value[k2];
          }
        }
        for (var i2 = 0, ii2 = this.items.length; i2 < ii2; i2++) {
          this.items[i2].attr(unbound);
        }
        return this;
      };
      setproto.clear = function() {
        while (this.length) {
          this.pop();
        }
      };
      setproto.splice = function(index2, count3, insertion) {
        index2 = index2 < 0 ? mmax(this.length + index2, 0) : index2;
        count3 = mmax(0, mmin(this.length - index2, count3));
        var tail = [], todel = [], args = [], i2;
        for (i2 = 2; i2 < arguments.length; i2++) {
          args.push(arguments[i2]);
        }
        for (i2 = 0; i2 < count3; i2++) {
          todel.push(this[index2 + i2]);
        }
        for (; i2 < this.length - index2; i2++) {
          tail.push(this[index2 + i2]);
        }
        var arglen = args.length;
        for (i2 = 0; i2 < arglen + tail.length; i2++) {
          this.items[index2 + i2] = this[index2 + i2] = i2 < arglen ? args[i2] : tail[i2 - arglen];
        }
        i2 = this.items.length = this.length -= count3 - arglen;
        while (this[i2]) {
          delete this[i2++];
        }
        return new Set2(todel);
      };
      setproto.exclude = function(el) {
        for (var i2 = 0, ii2 = this.length; i2 < ii2; i2++)
          if (this[i2] == el) {
            this.splice(i2, 1);
            return true;
          }
        return false;
      };
      setproto.insertAfter = function(el) {
        var i2 = this.items.length;
        while (i2--) {
          this.items[i2].insertAfter(el);
        }
        return this;
      };
      setproto.getBBox = function() {
        var x2 = [], y2 = [], x22 = [], y22 = [];
        for (var i2 = this.items.length; i2--; )
          if (!this.items[i2].removed) {
            var box = this.items[i2].getBBox();
            x2.push(box.x);
            y2.push(box.y);
            x22.push(box.x + box.width);
            y22.push(box.y + box.height);
          }
        x2 = mmin.apply(0, x2);
        y2 = mmin.apply(0, y2);
        x22 = mmax.apply(0, x22);
        y22 = mmax.apply(0, y22);
        return {
          x: x2,
          y: y2,
          x2: x22,
          y2: y22,
          width: x22 - x2,
          height: y22 - y2,
          cx: x2 + (x22 - x2) / 2,
          cy: y2 + (y22 - y2) / 2
        };
      };
      setproto.clone = function(s2) {
        s2 = new Set2();
        for (var i2 = 0, ii2 = this.items.length; i2 < ii2; i2++) {
          s2.push(this.items[i2].clone());
        }
        return s2;
      };
      setproto.toString = function() {
        return "Snap‘s set";
      };
      setproto.type = "set";
      Snap2.Set = Set2;
      Snap2.set = function() {
        var set = new Set2();
        if (arguments.length) {
          set.push.apply(set, Array.prototype.slice.call(arguments, 0));
        }
        return set;
      };
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob) {
      var names2 = {}, reUnit = /[%a-z]+$/i, Str = String;
      names2.stroke = names2.fill = "colour";
      function getEmpty(item) {
        var l2 = item[0];
        switch (l2.toLowerCase()) {
          case "t":
            return [l2, 0, 0];
          case "m":
            return [l2, 1, 0, 0, 1, 0, 0];
          case "r":
            if (item.length == 4) {
              return [l2, 0, item[2], item[3]];
            } else {
              return [l2, 0];
            }
          case "s":
            if (item.length == 5) {
              return [l2, 1, 1, item[3], item[4]];
            } else if (item.length == 3) {
              return [l2, 1, 1];
            } else {
              return [l2, 1];
            }
        }
      }
      function equaliseTransform(t1, t2, getBBox) {
        t1 = t1 || new Snap2.Matrix();
        t2 = t2 || new Snap2.Matrix();
        t1 = Snap2.parseTransformString(t1.toTransformString()) || [];
        t2 = Snap2.parseTransformString(t2.toTransformString()) || [];
        var maxlength = Math.max(t1.length, t2.length), from = [], to = [], i2 = 0, j2, jj, tt1, tt2;
        for (; i2 < maxlength; i2++) {
          tt1 = t1[i2] || getEmpty(t2[i2]);
          tt2 = t2[i2] || getEmpty(tt1);
          if (tt1[0] != tt2[0] || tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) || tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])) {
            t1 = Snap2._.transform2matrix(t1, getBBox());
            t2 = Snap2._.transform2matrix(t2, getBBox());
            from = [["m", t1.a, t1.b, t1.c, t1.d, t1.e, t1.f]];
            to = [["m", t2.a, t2.b, t2.c, t2.d, t2.e, t2.f]];
            break;
          }
          from[i2] = [];
          to[i2] = [];
          for (j2 = 0, jj = Math.max(tt1.length, tt2.length); j2 < jj; j2++) {
            j2 in tt1 && (from[i2][j2] = tt1[j2]);
            j2 in tt2 && (to[i2][j2] = tt2[j2]);
          }
        }
        return {
          from: path2array(from),
          to: path2array(to),
          f: getPath(from)
        };
      }
      function getNumber(val) {
        return val;
      }
      function getUnit(unit) {
        return function(val) {
          return +val.toFixed(3) + unit;
        };
      }
      function getViewBox(val) {
        return val.join(" ");
      }
      function getColour(clr) {
        return Snap2.rgb(clr[0], clr[1], clr[2], clr[3]);
      }
      function getPath(path2) {
        var k2 = 0, i2, ii2, j2, jj, out, a2, b2 = [];
        for (i2 = 0, ii2 = path2.length; i2 < ii2; i2++) {
          out = "[";
          a2 = ['"' + path2[i2][0] + '"'];
          for (j2 = 1, jj = path2[i2].length; j2 < jj; j2++) {
            a2[j2] = "val[" + k2++ + "]";
          }
          out += a2 + "]";
          b2[i2] = out;
        }
        return Function("val", "return Snap.path.toString.call([" + b2 + "])");
      }
      function path2array(path2) {
        var out = [];
        for (var i2 = 0, ii2 = path2.length; i2 < ii2; i2++) {
          for (var j2 = 1, jj = path2[i2].length; j2 < jj; j2++) {
            out.push(path2[i2][j2]);
          }
        }
        return out;
      }
      function isNumeric(obj) {
        return isFinite(obj);
      }
      function arrayEqual2(arr1, arr2) {
        if (!Snap2.is(arr1, "array") || !Snap2.is(arr2, "array")) {
          return false;
        }
        return arr1.toString() == arr2.toString();
      }
      Element2.prototype.equal = function(name2, b2) {
        return eve2("snap.util.equal", this, name2, b2).firstDefined();
      };
      eve2.on("snap.util.equal", function(name2, b2) {
        var A2, B2, a2 = Str(this.attr(name2) || ""), el = this;
        if (names2[name2] == "colour") {
          A2 = Snap2.color(a2);
          B2 = Snap2.color(b2);
          return {
            from: [A2.r, A2.g, A2.b, A2.opacity],
            to: [B2.r, B2.g, B2.b, B2.opacity],
            f: getColour
          };
        }
        if (name2 == "viewBox") {
          A2 = this.attr(name2).vb.split(" ").map(Number);
          B2 = b2.split(" ").map(Number);
          return {
            from: A2,
            to: B2,
            f: getViewBox
          };
        }
        if (name2 == "transform" || name2 == "gradientTransform" || name2 == "patternTransform") {
          if (typeof b2 == "string") {
            b2 = Str(b2).replace(/\.{3}|\u2026/g, a2);
          }
          a2 = this.matrix;
          if (!Snap2._.rgTransform.test(b2)) {
            b2 = Snap2._.transform2matrix(Snap2._.svgTransform2string(b2), this.getBBox());
          } else {
            b2 = Snap2._.transform2matrix(b2, this.getBBox());
          }
          return equaliseTransform(a2, b2, function() {
            return el.getBBox(1);
          });
        }
        if (name2 == "d" || name2 == "path") {
          A2 = Snap2.path.toCubic(a2, b2);
          return {
            from: path2array(A2[0]),
            to: path2array(A2[1]),
            f: getPath(A2[0])
          };
        }
        if (name2 == "points") {
          A2 = Str(a2).split(Snap2._.separator);
          B2 = Str(b2).split(Snap2._.separator);
          return {
            from: A2,
            to: B2,
            f: function(val) {
              return val;
            }
          };
        }
        if (isNumeric(a2) && isNumeric(b2)) {
          return {
            from: parseFloat(a2),
            to: parseFloat(b2),
            f: getNumber
          };
        }
        var aUnit = a2.match(reUnit), bUnit = Str(b2).match(reUnit);
        if (aUnit && arrayEqual2(aUnit, bUnit)) {
          return {
            from: parseFloat(a2),
            to: parseFloat(b2),
            f: getUnit(aUnit)
          };
        } else {
          return {
            from: this.asPX(name2),
            to: this.asPX(name2, b2),
            f: getNumber
          };
        }
      });
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob) {
      var elproto = Element2.prototype, has2 = "hasOwnProperty", supportsTouch = "createTouch" in glob.doc, events2 = [
        "click",
        "dblclick",
        "mousedown",
        "mousemove",
        "mouseout",
        "mouseover",
        "mouseup",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel"
      ], touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
      }, getScroll = function(xy, el) {
        var name2 = xy == "y" ? "scrollTop" : "scrollLeft", doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name2 in doc.documentElement ? "documentElement" : "body"][name2];
      }, preventTouch = function() {
        return this.originalEvent.preventDefault();
      }, stopTouch = function() {
        return this.originalEvent.stopPropagation();
      }, addEvent = function(obj, type, fn2, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type, f2 = function(e3) {
          var scrollY = getScroll("y", element), scrollX = getScroll("x", element);
          if (supportsTouch && touchMap[has2](type)) {
            for (var i3 = 0, ii2 = e3.targetTouches && e3.targetTouches.length; i3 < ii2; i3++) {
              if (e3.targetTouches[i3].target == obj || obj.contains(e3.targetTouches[i3].target)) {
                var olde = e3;
                e3 = e3.targetTouches[i3];
                e3.originalEvent = olde;
                e3.preventDefault = preventTouch;
                e3.stopPropagation = stopTouch;
                break;
              }
            }
          }
          var x2 = e3.clientX + scrollX, y2 = e3.clientY + scrollY;
          return fn2.call(element, e3, x2, y2);
        };
        if (type !== realName) {
          obj.addEventListener(type, f2, false);
        }
        obj.addEventListener(realName, f2, false);
        return function() {
          if (type !== realName) {
            obj.removeEventListener(type, f2, false);
          }
          obj.removeEventListener(realName, f2, false);
          return true;
        };
      }, drag = [], dragMove = function(e3) {
        var x2 = e3.clientX, y2 = e3.clientY, scrollY = getScroll("y"), scrollX = getScroll("x"), dragi, j2 = drag.length;
        while (j2--) {
          dragi = drag[j2];
          if (supportsTouch) {
            var i3 = e3.touches && e3.touches.length, touch;
            while (i3--) {
              touch = e3.touches[i3];
              if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                x2 = touch.clientX;
                y2 = touch.clientY;
                (e3.originalEvent ? e3.originalEvent : e3).preventDefault();
                break;
              }
            }
          } else {
            e3.preventDefault();
          }
          var node = dragi.el.node;
          node.nextSibling;
          node.parentNode;
          node.style.display;
          x2 += scrollX;
          y2 += scrollY;
          eve2("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x2 - dragi.el._drag.x, y2 - dragi.el._drag.y, x2, y2, e3);
        }
      }, dragUp = function(e3) {
        Snap2.unmousemove(dragMove).unmouseup(dragUp);
        var i3 = drag.length, dragi;
        while (i3--) {
          dragi = drag[i3];
          dragi.el._drag = {};
          eve2("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e3);
          eve2.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
      };
      for (var i2 = events2.length; i2--; ) {
        (function(eventName) {
          Snap2[eventName] = elproto[eventName] = function(fn2, scope) {
            if (Snap2.is(fn2, "function")) {
              this.events = this.events || [];
              this.events.push({
                name: eventName,
                f: fn2,
                unbind: addEvent(this.node || document, eventName, fn2, scope || this)
              });
            } else {
              for (var i3 = 0, ii2 = this.events.length; i3 < ii2; i3++)
                if (this.events[i3].name == eventName) {
                  try {
                    this.events[i3].f.call(this);
                  } catch (e3) {
                  }
                }
            }
            return this;
          };
          Snap2["un" + eventName] = elproto["un" + eventName] = function(fn2) {
            var events3 = this.events || [], l2 = events3.length;
            while (l2--)
              if (events3[l2].name == eventName && (events3[l2].f == fn2 || !fn2)) {
                events3[l2].unbind();
                events3.splice(l2, 1);
                !events3.length && delete this.events;
                return this;
              }
            return this;
          };
        })(events2[i2]);
      }
      elproto.hover = function(f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
      };
      elproto.unhover = function(f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
      };
      var draggable = [];
      elproto.drag = function(onmove, onstart, onend, move_scope, start_scope, end_scope) {
        var el = this;
        if (!arguments.length) {
          var origTransform;
          return el.drag(function(dx, dy) {
            this.attr({
              transform: origTransform + (origTransform ? "T" : "t") + [dx, dy]
            });
          }, function() {
            origTransform = this.transform().local;
          });
        }
        function start2(e3, x2, y2) {
          (e3.originalEvent || e3).preventDefault();
          el._drag.x = x2;
          el._drag.y = y2;
          el._drag.id = e3.identifier;
          !drag.length && Snap2.mousemove(dragMove).mouseup(dragUp);
          drag.push({ el, move_scope, start_scope, end_scope });
          onstart && eve2.on("snap.drag.start." + el.id, onstart);
          onmove && eve2.on("snap.drag.move." + el.id, onmove);
          onend && eve2.on("snap.drag.end." + el.id, onend);
          eve2("snap.drag.start." + el.id, start_scope || move_scope || el, x2, y2, e3);
        }
        function init9(e3, x2, y2) {
          eve2("snap.draginit." + el.id, el, e3, x2, y2);
        }
        eve2.on("snap.draginit." + el.id, start2);
        el._drag = {};
        draggable.push({ el, start: start2, init: init9 });
        el.mousedown(init9);
        return el;
      };
      elproto.undrag = function() {
        var i3 = draggable.length;
        while (i3--)
          if (draggable[i3].el == this) {
            this.unmousedown(draggable[i3].init);
            draggable.splice(i3, 1);
            eve2.unbind("snap.drag.*." + this.id);
            eve2.unbind("snap.draginit." + this.id);
          }
        !draggable.length && Snap2.unmousemove(dragMove).unmouseup(dragUp);
        return this;
      };
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob) {
      Element2.prototype;
      var pproto = Paper.prototype, rgurl = /^\s*url\((.+)\)/, Str = String, $ = Snap2._.$;
      Snap2.filter = {};
      pproto.filter = function(filstr) {
        var paper = this;
        if (paper.type != "svg") {
          paper = paper.paper;
        }
        var f2 = Snap2.parse(Str(filstr)), id = Snap2._.id();
        paper.node.offsetWidth;
        paper.node.offsetHeight;
        var filter17 = $("filter");
        $(filter17, {
          id,
          filterUnits: "userSpaceOnUse"
        });
        filter17.appendChild(f2.node);
        paper.defs.appendChild(filter17);
        return new Element2(filter17);
      };
      eve2.on("snap.util.getattr.filter", function() {
        eve2.stop();
        var p2 = $(this.node, "filter");
        if (p2) {
          var match2 = Str(p2).match(rgurl);
          return match2 && Snap2.select(match2[1]);
        }
      });
      eve2.on("snap.util.attr.filter", function(value) {
        if (value instanceof Element2 && value.type == "filter") {
          eve2.stop();
          var id = value.node.id;
          if (!id) {
            $(value.node, { id: value.id });
            id = value.id;
          }
          $(this.node, {
            filter: Snap2.url(id)
          });
        }
        if (!value || value == "none") {
          eve2.stop();
          this.node.removeAttribute("filter");
        }
      });
      Snap2.filter.blur = function(x2, y2) {
        if (x2 == null) {
          x2 = 2;
        }
        var def = y2 == null ? x2 : [x2, y2];
        return Snap2.format('<feGaussianBlur stdDeviation="{def}"/>', {
          def
        });
      };
      Snap2.filter.blur.toString = function() {
        return this();
      };
      Snap2.filter.shadow = function(dx, dy, blur, color, opacity) {
        if (opacity == null) {
          if (color == null) {
            opacity = blur;
            blur = 4;
            color = "#000";
          } else {
            opacity = color;
            color = blur;
            blur = 4;
          }
        }
        if (blur == null) {
          blur = 4;
        }
        if (opacity == null) {
          opacity = 1;
        }
        if (dx == null) {
          dx = 0;
          dy = 2;
        }
        if (dy == null) {
          dy = dx;
        }
        color = Snap2.color(color);
        return Snap2.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
          color,
          dx,
          dy,
          blur,
          opacity
        });
      };
      Snap2.filter.shadow.toString = function() {
        return this();
      };
      Snap2.filter.grayscale = function(amount) {
        if (amount == null) {
          amount = 1;
        }
        return Snap2.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
          a: 0.2126 + 0.7874 * (1 - amount),
          b: 0.7152 - 0.7152 * (1 - amount),
          c: 0.0722 - 0.0722 * (1 - amount),
          d: 0.2126 - 0.2126 * (1 - amount),
          e: 0.7152 + 0.2848 * (1 - amount),
          f: 0.0722 - 0.0722 * (1 - amount),
          g: 0.2126 - 0.2126 * (1 - amount),
          h: 0.0722 + 0.9278 * (1 - amount)
        });
      };
      Snap2.filter.grayscale.toString = function() {
        return this();
      };
      Snap2.filter.sepia = function(amount) {
        if (amount == null) {
          amount = 1;
        }
        return Snap2.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
          a: 0.393 + 0.607 * (1 - amount),
          b: 0.769 - 0.769 * (1 - amount),
          c: 0.189 - 0.189 * (1 - amount),
          d: 0.349 - 0.349 * (1 - amount),
          e: 0.686 + 0.314 * (1 - amount),
          f: 0.168 - 0.168 * (1 - amount),
          g: 0.272 - 0.272 * (1 - amount),
          h: 0.534 - 0.534 * (1 - amount),
          i: 0.131 + 0.869 * (1 - amount)
        });
      };
      Snap2.filter.sepia.toString = function() {
        return this();
      };
      Snap2.filter.saturate = function(amount) {
        if (amount == null) {
          amount = 1;
        }
        return Snap2.format('<feColorMatrix type="saturate" values="{amount}"/>', {
          amount: 1 - amount
        });
      };
      Snap2.filter.saturate.toString = function() {
        return this();
      };
      Snap2.filter.hueRotate = function(angle4) {
        angle4 = angle4 || 0;
        return Snap2.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
          angle: angle4
        });
      };
      Snap2.filter.hueRotate.toString = function() {
        return this();
      };
      Snap2.filter.invert = function(amount) {
        if (amount == null) {
          amount = 1;
        }
        return Snap2.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
          amount,
          amount2: 1 - amount
        });
      };
      Snap2.filter.invert.toString = function() {
        return this();
      };
      Snap2.filter.brightness = function(amount) {
        if (amount == null) {
          amount = 1;
        }
        return Snap2.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
          amount
        });
      };
      Snap2.filter.brightness.toString = function() {
        return this();
      };
      Snap2.filter.contrast = function(amount) {
        if (amount == null) {
          amount = 1;
        }
        return Snap2.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
          amount,
          amount2: 0.5 - amount / 2
        });
      };
      Snap2.filter.contrast.toString = function() {
        return this();
      };
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob, Fragment2) {
      var box = Snap2._.box, is3 = Snap2.is, firstLetter = /^[^a-z]*([tbmlrc])/i, toString29 = function() {
        return "T" + this.dx + "," + this.dy;
      };
      Element2.prototype.getAlign = function(el, way) {
        if (way == null && is3(el, "string")) {
          way = el;
          el = null;
        }
        el = el || this.paper;
        var bx2 = el.getBBox ? el.getBBox() : box(el), bb2 = this.getBBox(), out = {};
        way = way && way.match(firstLetter);
        way = way ? way[1].toLowerCase() : "c";
        switch (way) {
          case "t":
            out.dx = 0;
            out.dy = bx2.y - bb2.y;
            break;
          case "b":
            out.dx = 0;
            out.dy = bx2.y2 - bb2.y2;
            break;
          case "m":
            out.dx = 0;
            out.dy = bx2.cy - bb2.cy;
            break;
          case "l":
            out.dx = bx2.x - bb2.x;
            out.dy = 0;
            break;
          case "r":
            out.dx = bx2.x2 - bb2.x2;
            out.dy = 0;
            break;
          default:
            out.dx = bx2.cx - bb2.cx;
            out.dy = 0;
            break;
        }
        out.toString = toString29;
        return out;
      };
      Element2.prototype.align = function(el, way) {
        return this.transform("..." + this.getAlign(el, way));
      };
    });
    Snap.plugin(function(Snap2, Element2, Paper, glob) {
      var red2 = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000", pink2 = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162", purple2 = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF", deeppurple = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA", indigo2 = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE", blue2 = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF", lightblue = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA", cyan2 = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4", teal2 = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5", green2 = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853", lightgreen = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17", lime2 = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00", yellow2 = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600", amber2 = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00", orange2 = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00", deeporange = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00", brown2 = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723", grey = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121", bluegrey = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
      Snap2.mui = {};
      Snap2.flat = {};
      function saveColor(colors) {
        colors = colors.split(/(?=#)/);
        var color = new String(colors[5]);
        color[50] = colors[0];
        color[100] = colors[1];
        color[200] = colors[2];
        color[300] = colors[3];
        color[400] = colors[4];
        color[500] = colors[5];
        color[600] = colors[6];
        color[700] = colors[7];
        color[800] = colors[8];
        color[900] = colors[9];
        if (colors[10]) {
          color.A100 = colors[10];
          color.A200 = colors[11];
          color.A400 = colors[12];
          color.A700 = colors[13];
        }
        return color;
      }
      Snap2.mui.red = saveColor(red2);
      Snap2.mui.pink = saveColor(pink2);
      Snap2.mui.purple = saveColor(purple2);
      Snap2.mui.deeppurple = saveColor(deeppurple);
      Snap2.mui.indigo = saveColor(indigo2);
      Snap2.mui.blue = saveColor(blue2);
      Snap2.mui.lightblue = saveColor(lightblue);
      Snap2.mui.cyan = saveColor(cyan2);
      Snap2.mui.teal = saveColor(teal2);
      Snap2.mui.green = saveColor(green2);
      Snap2.mui.lightgreen = saveColor(lightgreen);
      Snap2.mui.lime = saveColor(lime2);
      Snap2.mui.yellow = saveColor(yellow2);
      Snap2.mui.amber = saveColor(amber2);
      Snap2.mui.orange = saveColor(orange2);
      Snap2.mui.deeporange = saveColor(deeporange);
      Snap2.mui.brown = saveColor(brown2);
      Snap2.mui.grey = saveColor(grey);
      Snap2.mui.bluegrey = saveColor(bluegrey);
      Snap2.flat.turquoise = "#1abc9c";
      Snap2.flat.greensea = "#16a085";
      Snap2.flat.sunflower = "#f1c40f";
      Snap2.flat.orange = "#f39c12";
      Snap2.flat.emerland = "#2ecc71";
      Snap2.flat.nephritis = "#27ae60";
      Snap2.flat.carrot = "#e67e22";
      Snap2.flat.pumpkin = "#d35400";
      Snap2.flat.peterriver = "#3498db";
      Snap2.flat.belizehole = "#2980b9";
      Snap2.flat.alizarin = "#e74c3c";
      Snap2.flat.pomegranate = "#c0392b";
      Snap2.flat.amethyst = "#9b59b6";
      Snap2.flat.wisteria = "#8e44ad";
      Snap2.flat.clouds = "#ecf0f1";
      Snap2.flat.silver = "#bdc3c7";
      Snap2.flat.wetasphalt = "#34495e";
      Snap2.flat.midnightblue = "#2c3e50";
      Snap2.flat.concrete = "#95a5a6";
      Snap2.flat.asbestos = "#7f8c8d";
      Snap2.importMUIColors = function() {
        for (var color in Snap2.mui) {
          if (Snap2.mui.hasOwnProperty(color)) {
            window2[color] = Snap2.mui[color];
          }
        }
      };
    });
    return Snap;
  });
})(snap_svg$2);
const snap_svg$1 = snap_svgExports$1;
const MountedMapsContext = React.createContext(null);
const MapProvider$1 = (props) => {
  const [maps, setMaps] = useState({});
  const onMapMount = useCallback((map5, id = "default") => {
    setMaps((currMaps) => {
      if (id === "current") {
        throw new Error("'current' cannot be used as map id");
      }
      if (currMaps[id]) {
        throw new Error(`Multiple maps with the same id: ${id}`);
      }
      return { ...currMaps, [id]: map5 };
    });
  }, []);
  const onMapUnmount = useCallback((id = "default") => {
    setMaps((currMaps) => {
      if (currMaps[id]) {
        const nextMaps = { ...currMaps };
        delete nextMaps[id];
        return nextMaps;
      }
      return currMaps;
    });
  }, []);
  return React.createElement(MountedMapsContext.Provider, { value: {
    maps,
    onMapMount,
    onMapUnmount
  } }, props.children);
};
function useMap() {
  var _a3;
  const maps = (_a3 = useContext(MountedMapsContext)) === null || _a3 === void 0 ? void 0 : _a3.maps;
  const currentMap = useContext(MapContext);
  const mapsWithCurrent = useMemo(() => {
    return { ...maps, current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map };
  }, [maps, currentMap]);
  return mapsWithCurrent;
}
function cloneTransform(tr) {
  const newTransform = tr.clone();
  newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
  return newTransform;
}
function transformToViewState(tr) {
  return {
    longitude: tr.center.lng,
    latitude: tr.center.lat,
    zoom: tr.zoom,
    pitch: tr.pitch,
    bearing: tr.bearing,
    padding: tr.padding
  };
}
function applyViewStateToTransform(tr, props) {
  const v5 = props.viewState || props;
  let changed = false;
  if ("longitude" in v5 && "latitude" in v5) {
    const center2 = tr.center;
    tr.center = new center2.constructor(v5.longitude, v5.latitude);
    changed = changed || center2 !== tr.center;
  }
  if ("zoom" in v5) {
    const zoom2 = tr.zoom;
    tr.zoom = v5.zoom;
    changed = changed || zoom2 !== tr.zoom;
  }
  if ("bearing" in v5) {
    const bearing2 = tr.bearing;
    tr.bearing = v5.bearing;
    changed = changed || bearing2 !== tr.bearing;
  }
  if ("pitch" in v5) {
    const pitch = tr.pitch;
    tr.pitch = v5.pitch;
    changed = changed || pitch !== tr.pitch;
  }
  if (v5.padding && !tr.isPaddingEqual(v5.padding)) {
    changed = true;
    tr.padding = v5.padding;
  }
  return changed;
}
const refProps = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"];
function normalizeStyle(style2) {
  if (!style2) {
    return null;
  }
  if (typeof style2 === "string") {
    return style2;
  }
  if ("toJS" in style2) {
    style2 = style2.toJS();
  }
  if (!style2.layers) {
    return style2;
  }
  const layerIndex = {};
  for (const layer of style2.layers) {
    layerIndex[layer.id] = layer;
  }
  const layers = style2.layers.map((layer) => {
    const layerRef = layerIndex[layer.ref];
    let normalizedLayer = null;
    if ("interactive" in layer) {
      normalizedLayer = { ...layer };
      delete normalizedLayer.interactive;
    }
    if (layerRef) {
      normalizedLayer = normalizedLayer || { ...layer };
      delete normalizedLayer.ref;
      for (const propName2 of refProps) {
        if (propName2 in layerRef) {
          normalizedLayer[propName2] = layerRef[propName2];
        }
      }
    }
    return normalizedLayer || layer;
  });
  return { ...style2, layers };
}
function arePointsEqual(a2, b2) {
  const ax2 = Array.isArray(a2) ? a2[0] : a2 ? a2.x : 0;
  const ay2 = Array.isArray(a2) ? a2[1] : a2 ? a2.y : 0;
  const bx2 = Array.isArray(b2) ? b2[0] : b2 ? b2.x : 0;
  const by2 = Array.isArray(b2) ? b2[1] : b2 ? b2.y : 0;
  return ax2 === bx2 && ay2 === by2;
}
function deepEqual$4(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (!a2 || !b2) {
    return false;
  }
  if (Array.isArray(a2)) {
    if (!Array.isArray(b2) || a2.length !== b2.length) {
      return false;
    }
    for (let i2 = 0; i2 < a2.length; i2++) {
      if (!deepEqual$4(a2[i2], b2[i2])) {
        return false;
      }
    }
    return true;
  } else if (Array.isArray(b2)) {
    return false;
  }
  if (typeof a2 === "object" && typeof b2 === "object") {
    const aKeys = Object.keys(a2);
    const bKeys = Object.keys(b2);
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    for (const key of aKeys) {
      if (!b2.hasOwnProperty(key)) {
        return false;
      }
      if (!deepEqual$4(a2[key], b2[key])) {
        return false;
      }
    }
    return true;
  }
  return false;
}
const pointerEvents = {
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  click: "onClick",
  dblclick: "onDblClick",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  mouseout: "onMouseOut",
  contextmenu: "onContextMenu",
  touchstart: "onTouchStart",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchcancel: "onTouchCancel"
};
const cameraEvents = {
  movestart: "onMoveStart",
  move: "onMove",
  moveend: "onMoveEnd",
  dragstart: "onDragStart",
  drag: "onDrag",
  dragend: "onDragEnd",
  zoomstart: "onZoomStart",
  zoom: "onZoom",
  zoomend: "onZoomEnd",
  rotatestart: "onRotateStart",
  rotate: "onRotate",
  rotateend: "onRotateEnd",
  pitchstart: "onPitchStart",
  pitch: "onPitch",
  pitchend: "onPitchEnd"
};
const otherEvents = {
  wheel: "onWheel",
  boxzoomstart: "onBoxZoomStart",
  boxzoomend: "onBoxZoomEnd",
  boxzoomcancel: "onBoxZoomCancel",
  resize: "onResize",
  load: "onLoad",
  render: "onRender",
  idle: "onIdle",
  remove: "onRemove",
  data: "onData",
  styledata: "onStyleData",
  sourcedata: "onSourceData",
  error: "onError"
};
const settingNames = [
  "minZoom",
  "maxZoom",
  "minPitch",
  "maxPitch",
  "maxBounds",
  "projection",
  "renderWorldCopies"
];
const handlerNames = [
  "scrollZoom",
  "boxZoom",
  "dragRotate",
  "dragPan",
  "keyboard",
  "doubleClickZoom",
  "touchZoomRotate",
  "touchPitch"
];
class Mapbox {
  constructor(MapClass, props, container) {
    this._map = null;
    this._internalUpdate = false;
    this._inRender = false;
    this._hoveredFeatures = null;
    this._deferredEvents = {
      move: false,
      zoom: false,
      pitch: false,
      rotate: false
    };
    this._onEvent = (e3) => {
      const cb2 = this.props[otherEvents[e3.type]];
      if (cb2) {
        cb2(e3);
      }
    };
    this._onPointerEvent = (e3) => {
      if (e3.type === "mousemove" || e3.type === "mouseout") {
        this._updateHover(e3);
      }
      const cb2 = this.props[pointerEvents[e3.type]];
      if (cb2) {
        if (this.props.interactiveLayerIds && e3.type !== "mouseover" && e3.type !== "mouseout") {
          const features = this._hoveredFeatures || this._map.queryRenderedFeatures(e3.point, {
            layers: this.props.interactiveLayerIds
          });
          e3.features = features;
        }
        cb2(e3);
        delete e3.features;
      }
    };
    this._onCameraEvent = (e3) => {
      if (!this._internalUpdate) {
        const cb2 = this.props[cameraEvents[e3.type]];
        if (cb2) {
          cb2(e3);
        }
      }
      if (e3.type in this._deferredEvents) {
        this._deferredEvents[e3.type] = false;
      }
    };
    this._MapClass = MapClass;
    this.props = props;
    this._initialize(container);
  }
  get map() {
    return this._map;
  }
  get transform() {
    return this._renderTransform;
  }
  setProps(props) {
    const oldProps = this.props;
    this.props = props;
    const settingsChanged = this._updateSettings(props, oldProps);
    if (settingsChanged) {
      this._createShadowTransform(this._map);
    }
    const sizeChanged = this._updateSize(props);
    const viewStateChanged = this._updateViewState(props, true);
    this._updateStyle(props, oldProps);
    this._updateStyleComponents(props, oldProps);
    this._updateHandlers(props, oldProps);
    if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) {
      this.redraw();
    }
  }
  static reuse(props, container) {
    const that = Mapbox.savedMaps.pop();
    if (!that) {
      return null;
    }
    const map5 = that.map;
    const oldContainer = map5.getContainer();
    container.className = oldContainer.className;
    while (oldContainer.childNodes.length > 0) {
      container.appendChild(oldContainer.childNodes[0]);
    }
    map5._container = container;
    that.setProps({ ...props, styleDiffing: false });
    map5.resize();
    const { initialViewState } = props;
    if (initialViewState) {
      if (initialViewState.bounds) {
        map5.fitBounds(initialViewState.bounds, { ...initialViewState.fitBoundsOptions, duration: 0 });
      } else {
        that._updateViewState(initialViewState, false);
      }
    }
    if (map5.isStyleLoaded()) {
      map5.fire("load");
    } else {
      map5.once("styledata", () => map5.fire("load"));
    }
    return that;
  }
  /* eslint-disable complexity,max-statements */
  _initialize(container) {
    const { props } = this;
    const mapOptions = {
      ...props,
      ...props.initialViewState,
      accessToken: props.mapboxAccessToken || getAccessTokenFromEnv() || null,
      container,
      style: normalizeStyle(props.mapStyle)
    };
    const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
    Object.assign(mapOptions, {
      center: [viewState.longitude || 0, viewState.latitude || 0],
      zoom: viewState.zoom || 0,
      pitch: viewState.pitch || 0,
      bearing: viewState.bearing || 0
    });
    if (props.gl) {
      const getContext2 = HTMLCanvasElement.prototype.getContext;
      HTMLCanvasElement.prototype.getContext = () => {
        HTMLCanvasElement.prototype.getContext = getContext2;
        return props.gl;
      };
    }
    const map5 = new this._MapClass(mapOptions);
    if (viewState.padding) {
      map5.setPadding(viewState.padding);
    }
    if (props.cursor) {
      map5.getCanvas().style.cursor = props.cursor;
    }
    this._createShadowTransform(map5);
    const renderMap = map5._render;
    map5._render = (arg) => {
      this._inRender = true;
      renderMap.call(map5, arg);
      this._inRender = false;
    };
    const runRenderTaskQueue = map5._renderTaskQueue.run;
    map5._renderTaskQueue.run = (arg) => {
      runRenderTaskQueue.call(map5._renderTaskQueue, arg);
      this._onBeforeRepaint();
    };
    map5.on("render", () => this._onAfterRepaint());
    const fireEvent = map5.fire;
    map5.fire = this._fireEvent.bind(this, fireEvent);
    map5.on("resize", () => {
      this._renderTransform.resize(map5.transform.width, map5.transform.height);
    });
    map5.on("styledata", () => this._updateStyleComponents(this.props, {}));
    map5.on("sourcedata", () => this._updateStyleComponents(this.props, {}));
    for (const eventName in pointerEvents) {
      map5.on(eventName, this._onPointerEvent);
    }
    for (const eventName in cameraEvents) {
      map5.on(eventName, this._onCameraEvent);
    }
    for (const eventName in otherEvents) {
      map5.on(eventName, this._onEvent);
    }
    this._map = map5;
  }
  /* eslint-enable complexity,max-statements */
  recycle() {
    const container = this.map.getContainer();
    const children = container.querySelector("[mapboxgl-children]");
    children === null || children === void 0 ? void 0 : children.remove();
    Mapbox.savedMaps.push(this);
  }
  destroy() {
    this._map.remove();
  }
  // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
  // render cycle, which is managed by Mapbox's animation loop.
  // This removes the synchronization issue caused by requestAnimationFrame.
  redraw() {
    const map5 = this._map;
    if (!this._inRender && map5.style) {
      if (map5._frame) {
        map5._frame.cancel();
        map5._frame = null;
      }
      map5._render();
    }
  }
  _createShadowTransform(map5) {
    const renderTransform = cloneTransform(map5.transform);
    map5.painter.transform = renderTransform;
    this._renderTransform = renderTransform;
  }
  /* Trigger map resize if size is controlled
     @param {object} nextProps
     @returns {bool} true if size has changed
   */
  _updateSize(nextProps) {
    const { viewState } = nextProps;
    if (viewState) {
      const map5 = this._map;
      if (viewState.width !== map5.transform.width || viewState.height !== map5.transform.height) {
        map5.resize();
        return true;
      }
    }
    return false;
  }
  // Adapted from map.jumpTo
  /* Update camera to match props
     @param {object} nextProps
     @param {bool} triggerEvents - should fire camera events
     @returns {bool} true if anything is changed
   */
  _updateViewState(nextProps, triggerEvents) {
    if (this._internalUpdate) {
      return false;
    }
    const map5 = this._map;
    const tr = this._renderTransform;
    const { zoom: zoom2, pitch, bearing: bearing2 } = tr;
    const isMoving = map5.isMoving();
    if (isMoving) {
      tr.cameraElevationReference = "sea";
    }
    const changed = applyViewStateToTransform(tr, {
      ...transformToViewState(map5.transform),
      ...nextProps
    });
    if (isMoving) {
      tr.cameraElevationReference = "ground";
    }
    if (changed && triggerEvents) {
      const deferredEvents = this._deferredEvents;
      deferredEvents.move = true;
      deferredEvents.zoom || (deferredEvents.zoom = zoom2 !== tr.zoom);
      deferredEvents.rotate || (deferredEvents.rotate = bearing2 !== tr.bearing);
      deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
    }
    if (!isMoving) {
      applyViewStateToTransform(map5.transform, nextProps);
    }
    return changed;
  }
  /* Update camera constraints and projection settings to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateSettings(nextProps, currProps) {
    const map5 = this._map;
    let changed = false;
    for (const propName2 of settingNames) {
      if (propName2 in nextProps && !deepEqual$4(nextProps[propName2], currProps[propName2])) {
        changed = true;
        map5[`set${propName2[0].toUpperCase()}${propName2.slice(1)}`](nextProps[propName2]);
      }
    }
    return changed;
  }
  /* Update map style to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if style is changed
   */
  _updateStyle(nextProps, currProps) {
    if (nextProps.cursor !== currProps.cursor) {
      this._map.getCanvas().style.cursor = nextProps.cursor;
    }
    if (nextProps.mapStyle !== currProps.mapStyle) {
      const options2 = {
        diff: nextProps.styleDiffing
      };
      if ("localIdeographFontFamily" in nextProps) {
        options2.localIdeographFontFamily = nextProps.localIdeographFontFamily;
      }
      this._map.setStyle(normalizeStyle(nextProps.mapStyle), options2);
      return true;
    }
    return false;
  }
  /* Update fog, light and terrain to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateStyleComponents(nextProps, currProps) {
    const map5 = this._map;
    let changed = false;
    if (map5.style.loaded()) {
      if ("light" in nextProps && !deepEqual$4(nextProps.light, currProps.light)) {
        changed = true;
        map5.setLight(nextProps.light);
      }
      if ("fog" in nextProps && !deepEqual$4(nextProps.fog, currProps.fog)) {
        changed = true;
        map5.setFog(nextProps.fog);
      }
      if ("terrain" in nextProps && !deepEqual$4(nextProps.terrain, currProps.terrain)) {
        if (!nextProps.terrain || map5.getSource(nextProps.terrain.source)) {
          changed = true;
          map5.setTerrain(nextProps.terrain);
        }
      }
    }
    return changed;
  }
  /* Update interaction handlers to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateHandlers(nextProps, currProps) {
    const map5 = this._map;
    let changed = false;
    for (const propName2 of handlerNames) {
      const newValue = nextProps[propName2];
      if (!deepEqual$4(newValue, currProps[propName2])) {
        changed = true;
        if (newValue) {
          map5[propName2].enable(newValue);
        } else {
          map5[propName2].disable();
        }
      }
    }
    return changed;
  }
  _updateHover(e3) {
    var _a3;
    const { props } = this;
    const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
    if (shouldTrackHoveredFeatures) {
      const eventType = e3.type;
      const wasHovering = ((_a3 = this._hoveredFeatures) === null || _a3 === void 0 ? void 0 : _a3.length) > 0;
      let features;
      if (eventType === "mousemove") {
        try {
          features = this._map.queryRenderedFeatures(e3.point, {
            layers: props.interactiveLayerIds
          });
        } catch (_b3) {
          features = [];
        }
      } else {
        features = [];
      }
      const isHovering = features.length > 0;
      if (!isHovering && wasHovering) {
        e3.type = "mouseleave";
        this._onPointerEvent(e3);
      }
      this._hoveredFeatures = features;
      if (isHovering && !wasHovering) {
        e3.type = "mouseenter";
        this._onPointerEvent(e3);
      }
      e3.type = eventType;
    } else {
      this._hoveredFeatures = null;
    }
  }
  _fireEvent(baseFire, event, properties) {
    const map5 = this._map;
    const tr = map5.transform;
    const eventType = typeof event === "string" ? event : event.type;
    if (eventType === "move") {
      this._updateViewState(this.props, false);
    }
    if (eventType in cameraEvents) {
      if (typeof event === "object") {
        event.viewState = transformToViewState(tr);
      }
      if (this._map.isMoving()) {
        map5.transform = this._renderTransform;
        baseFire.call(map5, event, properties);
        map5.transform = tr;
        return map5;
      }
    }
    baseFire.call(map5, event, properties);
    return map5;
  }
  // All camera manipulations are complete, ready to repaint
  _onBeforeRepaint() {
    const map5 = this._map;
    this._internalUpdate = true;
    for (const eventType in this._deferredEvents) {
      if (this._deferredEvents[eventType]) {
        map5.fire(eventType);
      }
    }
    this._internalUpdate = false;
    const tr = this._map.transform;
    this._map.transform = this._renderTransform;
    this._onAfterRepaint = () => {
      this._map.transform = tr;
    };
  }
}
Mapbox.savedMaps = [];
function getAccessTokenFromEnv() {
  let accessToken = null;
  if (typeof location !== "undefined") {
    const match2 = /access_token=([^&\/]*)/.exec(location.search);
    accessToken = match2 && match2[1];
  }
  try {
    accessToken = accessToken || process.env.MapboxAccessToken;
  } catch (_a3) {
  }
  try {
    accessToken = accessToken || process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
  } catch (_b3) {
  }
  return accessToken;
}
const skipMethods = [
  "setMaxBounds",
  "setMinZoom",
  "setMaxZoom",
  "setMinPitch",
  "setMaxPitch",
  "setRenderWorldCopies",
  "setProjection",
  "setStyle",
  "addSource",
  "removeSource",
  "addLayer",
  "removeLayer",
  "setLayerZoomRange",
  "setFilter",
  "setPaintProperty",
  "setLayoutProperty",
  "setLight",
  "setTerrain",
  "setFog",
  "remove"
];
function createRef(mapInstance, mapLib) {
  if (!mapInstance) {
    return null;
  }
  const map5 = mapInstance.map;
  const result = {
    getMap: () => map5,
    // Overwrite getters to use our shadow transform
    getCenter: () => mapInstance.transform.center,
    getZoom: () => mapInstance.transform.zoom,
    getBearing: () => mapInstance.transform.bearing,
    getPitch: () => mapInstance.transform.pitch,
    getPadding: () => mapInstance.transform.padding,
    getBounds: () => mapInstance.transform.getBounds(),
    project: (lnglat) => {
      return mapInstance.transform.locationPoint(mapLib.LngLat.convert(lnglat));
    },
    unproject: (point4) => {
      return mapInstance.transform.pointLocation(mapLib.Point.convert(point4));
    },
    queryTerrainElevation: (lnglat, options2) => {
      const tr = map5.transform;
      map5.transform = mapInstance.transform;
      const result2 = map5.queryTerrainElevation(lnglat, options2);
      map5.transform = tr;
      return result2;
    }
  };
  for (const key of getMethodNames(map5)) {
    if (!(key in result) && !skipMethods.includes(key)) {
      result[key] = map5[key].bind(map5);
    }
  }
  return result;
}
function getMethodNames(obj) {
  const result = /* @__PURE__ */ new Set();
  let proto = obj;
  while (proto) {
    for (const key of Object.getOwnPropertyNames(proto)) {
      if (key[0] !== "_" && typeof obj[key] === "function" && key !== "fire" && key !== "setEventedParent") {
        result.add(key);
      }
    }
    proto = Object.getPrototypeOf(proto);
  }
  return Array.from(result);
}
const useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? useLayoutEffect$1 : useEffect;
const globalSettings = [
  "baseApiUrl",
  "maxParallelImageRequests",
  "workerClass",
  "workerCount",
  "workerUrl"
];
function setGlobals(mapLib, props) {
  for (const key of globalSettings) {
    if (key in props) {
      mapLib[key] = props[key];
    }
  }
  if (props.RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === "unavailable") {
    mapLib.setRTLTextPlugin(props.RTLTextPlugin, (error2) => {
      if (error2) {
        console.error(error2);
      }
    }, false);
  }
}
const MapContext = React.createContext(null);
const defaultProps$s = {
  // Constraints
  minZoom: 0,
  maxZoom: 22,
  minPitch: 0,
  maxPitch: 60,
  // Interaction handlers
  scrollZoom: true,
  boxZoom: true,
  dragRotate: true,
  dragPan: true,
  keyboard: true,
  doubleClickZoom: true,
  touchZoomRotate: true,
  touchPitch: true,
  // Style
  mapStyle: { version: 8, sources: {}, layers: [] },
  styleDiffing: true,
  projection: "mercator",
  renderWorldCopies: true,
  // Callbacks
  onError: (e3) => console.error(e3.error),
  // Globals
  RTLTextPlugin: "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js"
};
const Map$7 = forwardRef((props, ref) => {
  const mountedMapsContext = useContext(MountedMapsContext);
  const [mapInstance, setMapInstance] = useState(null);
  const containerRef = useRef();
  const { current: contextValue } = useRef({ mapLib: null, map: null });
  useEffect(() => {
    const mapLib = props.mapLib;
    let isMounted = true;
    let mapbox;
    Promise.resolve(mapLib || import("mapbox-gl")).then((mapboxgl2) => {
      if (!isMounted) {
        return;
      }
      if (!mapboxgl2.Map) {
        mapboxgl2 = mapboxgl2.default;
      }
      if (!mapboxgl2 || !mapboxgl2.Map) {
        throw new Error("Invalid mapLib");
      }
      if (mapboxgl2.supported(props)) {
        setGlobals(mapboxgl2, props);
        if (props.reuseMaps) {
          mapbox = Mapbox.reuse(props, containerRef.current);
        }
        if (!mapbox) {
          mapbox = new Mapbox(mapboxgl2.Map, props, containerRef.current);
        }
        contextValue.map = createRef(mapbox, mapboxgl2);
        contextValue.mapLib = mapboxgl2;
        setMapInstance(mapbox);
        mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapMount(contextValue.map, props.id);
      } else {
        throw new Error("Map is not supported by this browser");
      }
    }).catch((error2) => {
      props.onError({
        type: "error",
        target: null,
        originalEvent: null,
        error: error2
      });
    });
    return () => {
      isMounted = false;
      if (mapbox) {
        mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapUnmount(props.id);
        if (props.reuseMaps) {
          mapbox.recycle();
        } else {
          mapbox.destroy();
        }
      }
    };
  }, []);
  useIsomorphicLayoutEffect$2(() => {
    if (mapInstance) {
      mapInstance.setProps(props);
    }
  });
  useImperativeHandle(ref, () => contextValue.map, [mapInstance]);
  const style2 = useMemo(() => ({
    position: "relative",
    width: "100%",
    height: "100%",
    ...props.style
  }), [props.style]);
  return React.createElement("div", { id: props.id, ref: containerRef, style: style2 }, mapInstance && React.createElement(
    MapContext.Provider,
    { value: contextValue },
    React.createElement("div", { "mapboxgl-children": "" }, props.children)
  ));
});
Map$7.displayName = "Map";
Map$7.defaultProps = defaultProps$s;
const unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function applyReactStyle(element, styles2) {
  if (!element || !styles2) {
    return;
  }
  const style2 = element.style;
  for (const key in styles2) {
    const value = styles2[key];
    if (Number.isFinite(value) && !unitlessNumber.test(key)) {
      style2[key] = `${value}px`;
    } else {
      style2[key] = value;
    }
  }
}
const defaultProps$r = {
  draggable: false,
  popup: null,
  rotation: 0,
  rotationAlignment: "auto",
  pitchAlignment: "auto"
};
function Marker(props) {
  const { map: map5, mapLib } = useContext(MapContext);
  const thisRef = useRef({ props });
  thisRef.current.props = props;
  const marker2 = useMemo(() => {
    let hasChildren = false;
    React.Children.forEach(props.children, (el) => {
      if (el) {
        hasChildren = true;
      }
    });
    const options2 = {
      ...props,
      element: hasChildren ? document.createElement("div") : null
    };
    const mk = new mapLib.Marker(options2).setLngLat([props.longitude, props.latitude]);
    mk.getElement().addEventListener("click", (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onClick) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, {
        type: "click",
        target: mk,
        originalEvent: e3
      });
    });
    mk.on("dragstart", (e3) => {
      var _a3, _b3;
      const evt = e3;
      evt.lngLat = marker2.getLngLat();
      (_b3 = (_a3 = thisRef.current.props).onDragStart) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, evt);
    });
    mk.on("drag", (e3) => {
      var _a3, _b3;
      const evt = e3;
      evt.lngLat = marker2.getLngLat();
      (_b3 = (_a3 = thisRef.current.props).onDrag) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, evt);
    });
    mk.on("dragend", (e3) => {
      var _a3, _b3;
      const evt = e3;
      evt.lngLat = marker2.getLngLat();
      (_b3 = (_a3 = thisRef.current.props).onDragEnd) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, evt);
    });
    return mk;
  }, []);
  useEffect(() => {
    marker2.addTo(map5.getMap());
    return () => {
      marker2.remove();
    };
  }, []);
  useEffect(() => {
    applyReactStyle(marker2.getElement(), props.style);
  }, [props.style]);
  if (marker2.getLngLat().lng !== props.longitude || marker2.getLngLat().lat !== props.latitude) {
    marker2.setLngLat([props.longitude, props.latitude]);
  }
  if (props.offset && !arePointsEqual(marker2.getOffset(), props.offset)) {
    marker2.setOffset(props.offset);
  }
  if (marker2.isDraggable() !== props.draggable) {
    marker2.setDraggable(props.draggable);
  }
  if (marker2.getRotation() !== props.rotation) {
    marker2.setRotation(props.rotation);
  }
  if (marker2.getRotationAlignment() !== props.rotationAlignment) {
    marker2.setRotationAlignment(props.rotationAlignment);
  }
  if (marker2.getPitchAlignment() !== props.pitchAlignment) {
    marker2.setPitchAlignment(props.pitchAlignment);
  }
  if (marker2.getPopup() !== props.popup) {
    marker2.setPopup(props.popup);
  }
  return createPortal(props.children, marker2.getElement());
}
Marker.defaultProps = defaultProps$r;
const Marker$1 = React.memo(Marker);
function getClassList(className) {
  return new Set(className ? className.trim().split(/\s+/) : []);
}
function Popup(props) {
  const { map: map5, mapLib } = useContext(MapContext);
  const container = useMemo(() => {
    return document.createElement("div");
  }, []);
  const thisRef = useRef({ props });
  thisRef.current.props = props;
  const popup2 = useMemo(() => {
    const options2 = { ...props };
    const pp = new mapLib.Popup(options2).setLngLat([props.longitude, props.latitude]);
    pp.once("open", (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onOpen) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, e3);
    });
    return pp;
  }, []);
  useEffect(() => {
    const onClose = (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onClose) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, e3);
    };
    popup2.on("close", onClose);
    popup2.setDOMContent(container).addTo(map5.getMap());
    return () => {
      popup2.off("close", onClose);
      if (popup2.isOpen()) {
        popup2.remove();
      }
    };
  }, []);
  useEffect(() => {
    applyReactStyle(popup2.getElement(), props.style);
  }, [props.style]);
  if (popup2.isOpen()) {
    if (popup2.getLngLat().lng !== props.longitude || popup2.getLngLat().lat !== props.latitude) {
      popup2.setLngLat([props.longitude, props.latitude]);
    }
    if (props.offset && !deepEqual$4(popup2.options.offset, props.offset)) {
      popup2.setOffset(props.offset);
    }
    if (popup2.options.anchor !== props.anchor || popup2.options.maxWidth !== props.maxWidth) {
      popup2.options.anchor = props.anchor;
      popup2.setMaxWidth(props.maxWidth);
    }
    if (popup2.options.className !== props.className) {
      const prevClassList = getClassList(popup2.options.className);
      const nextClassList = getClassList(props.className);
      for (const c2 of prevClassList) {
        if (!nextClassList.has(c2)) {
          popup2.removeClassName(c2);
        }
      }
      for (const c2 of nextClassList) {
        if (!prevClassList.has(c2)) {
          popup2.addClassName(c2);
        }
      }
      popup2.options.className = props.className;
    }
  }
  return createPortal(props.children, container);
}
const popup = React.memo(Popup);
function useControl(onCreate, arg1, arg2, arg3) {
  const context2 = useContext(MapContext);
  const ctrl = useMemo(() => onCreate(context2), []);
  useEffect(() => {
    const opts = arg3 || arg2 || arg1;
    const onAdd = typeof arg1 === "function" && typeof arg2 === "function" ? arg1 : null;
    const onRemove = typeof arg2 === "function" ? arg2 : typeof arg1 === "function" ? arg1 : null;
    const { map: map5 } = context2;
    if (!map5.hasControl(ctrl)) {
      map5.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
      if (onAdd) {
        onAdd(context2);
      }
    }
    return () => {
      if (onRemove) {
        onRemove(context2);
      }
      if (map5.hasControl(ctrl)) {
        map5.removeControl(ctrl);
      }
    };
  }, []);
  return ctrl;
}
function AttributionControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.AttributionControl(props), {
    position: props.position
  });
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
}
const AttributionControl$1 = React.memo(AttributionControl);
function FullscreenControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.FullscreenControl({
    container: props.containerId && document.getElementById(props.containerId)
  }), { position: props.position });
  useEffect(() => {
    applyReactStyle(ctrl._controlContainer, props.style);
  }, [props.style]);
  return null;
}
const FullscreenControl$1 = React.memo(FullscreenControl);
const GeolocateControl = forwardRef((props, ref) => {
  const thisRef = useRef({ props });
  const ctrl = useControl(({ mapLib }) => {
    const gc = new mapLib.GeolocateControl(props);
    const setupUI = gc._setupUI;
    gc._setupUI = (args) => {
      if (!gc._container.hasChildNodes()) {
        setupUI(args);
      }
    };
    gc.on("geolocate", (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onGeolocate) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, e3);
    });
    gc.on("error", (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onError) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, e3);
    });
    gc.on("outofmaxbounds", (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onOutOfMaxBounds) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, e3);
    });
    gc.on("trackuserlocationstart", (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onTrackUserLocationStart) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, e3);
    });
    gc.on("trackuserlocationend", (e3) => {
      var _a3, _b3;
      (_b3 = (_a3 = thisRef.current.props).onTrackUserLocationEnd) === null || _b3 === void 0 ? void 0 : _b3.call(_a3, e3);
    });
    return gc;
  }, { position: props.position });
  thisRef.current.props = props;
  useImperativeHandle(ref, () => ({
    trigger: () => ctrl.trigger()
  }), []);
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
});
GeolocateControl.displayName = "GeolocateControl";
const geolocateControl = React.memo(GeolocateControl);
function NavigationControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.NavigationControl(props), {
    position: props.position
  });
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
}
const NavigationControl$1 = React.memo(NavigationControl);
const defaultProps$q = {
  unit: "metric",
  maxWidth: 100
};
function ScaleControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.ScaleControl(props), {
    position: props.position
  });
  if (ctrl.options.unit !== props.unit || ctrl.options.maxWidth !== props.maxWidth) {
    ctrl.options.maxWidth = props.maxWidth;
    ctrl.setUnit(props.unit);
  }
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
}
ScaleControl.defaultProps = defaultProps$q;
const ScaleControl$1 = React.memo(ScaleControl);
function assert$f(condition, message2) {
  if (!condition) {
    throw new Error(message2);
  }
}
let sourceCounter = 0;
function createSource(map5, id, props) {
  if (map5.style && map5.style._loaded) {
    const options2 = { ...props };
    delete options2.id;
    delete options2.children;
    map5.addSource(id, options2);
    return map5.getSource(id);
  }
  return null;
}
function updateSource(source, props, prevProps) {
  assert$f(props.id === prevProps.id, "source id changed");
  assert$f(props.type === prevProps.type, "source type changed");
  let changedKey = "";
  let changedKeyCount = 0;
  for (const key in props) {
    if (key !== "children" && key !== "id" && !deepEqual$4(prevProps[key], props[key])) {
      changedKey = key;
      changedKeyCount++;
    }
  }
  if (!changedKeyCount) {
    return;
  }
  const type = props.type;
  if (type === "geojson") {
    source.setData(props.data);
  } else if (type === "image") {
    source.updateImage({ url: props.url, coordinates: props.coordinates });
  } else if ((type === "canvas" || type === "video") && changedKeyCount === 1 && changedKey === "coordinates") {
    source.setCoordinates(props.coordinates);
  } else if (type === "vector" && "setUrl" in source) {
    switch (changedKey) {
      case "url":
        source.setUrl(props.url);
        break;
      case "tiles":
        source.setTiles(props.tiles);
        break;
    }
  } else {
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
  }
}
function Source$1(props) {
  const map5 = useContext(MapContext).map.getMap();
  const propsRef = useRef(props);
  const [, setStyleLoaded] = useState(0);
  const id = useMemo(() => props.id || `jsx-source-${sourceCounter++}`, []);
  useEffect(() => {
    if (map5) {
      const forceUpdate = () => setTimeout(() => setStyleLoaded((version2) => version2 + 1), 0);
      map5.on("styledata", forceUpdate);
      forceUpdate();
      return () => {
        var _a3;
        map5.off("styledata", forceUpdate);
        if (map5.style && map5.style._loaded && map5.getSource(id)) {
          const allLayers = (_a3 = map5.getStyle()) === null || _a3 === void 0 ? void 0 : _a3.layers;
          if (allLayers) {
            for (const layer of allLayers) {
              if (layer.source === id) {
                map5.removeLayer(layer.id);
              }
            }
          }
          map5.removeSource(id);
        }
      };
    }
    return void 0;
  }, [map5]);
  let source = map5 && map5.style && map5.getSource(id);
  if (source) {
    updateSource(source, props, propsRef.current);
  } else {
    source = createSource(map5, id, props);
  }
  propsRef.current = props;
  return source && React.Children.map(props.children, (child) => child && cloneElement(child, {
    source: id
  })) || null;
}
function updateLayer$1(map5, id, props, prevProps) {
  assert$f(props.id === prevProps.id, "layer id changed");
  assert$f(props.type === prevProps.type, "layer type changed");
  if (props.type === "custom" || prevProps.type === "custom") {
    return;
  }
  const { layout = {}, paint = {}, filter: filter17, minzoom, maxzoom, beforeId } = props;
  if (beforeId !== prevProps.beforeId) {
    map5.moveLayer(id, beforeId);
  }
  if (layout !== prevProps.layout) {
    const prevLayout = prevProps.layout || {};
    for (const key in layout) {
      if (!deepEqual$4(layout[key], prevLayout[key])) {
        map5.setLayoutProperty(id, key, layout[key]);
      }
    }
    for (const key in prevLayout) {
      if (!layout.hasOwnProperty(key)) {
        map5.setLayoutProperty(id, key, void 0);
      }
    }
  }
  if (paint !== prevProps.paint) {
    const prevPaint = prevProps.paint || {};
    for (const key in paint) {
      if (!deepEqual$4(paint[key], prevPaint[key])) {
        map5.setPaintProperty(id, key, paint[key]);
      }
    }
    for (const key in prevPaint) {
      if (!paint.hasOwnProperty(key)) {
        map5.setPaintProperty(id, key, void 0);
      }
    }
  }
  if (!deepEqual$4(filter17, prevProps.filter)) {
    map5.setFilter(id, filter17);
  }
  if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) {
    map5.setLayerZoomRange(id, minzoom, maxzoom);
  }
}
function createLayer(map5, id, props) {
  if (map5.style && map5.style._loaded && (!("source" in props) || map5.getSource(props.source))) {
    const options2 = { ...props, id };
    delete options2.beforeId;
    map5.addLayer(options2, props.beforeId);
  }
}
let layerCounter = 0;
function Layer$1(props) {
  const map5 = useContext(MapContext).map.getMap();
  const propsRef = useRef(props);
  const [, setStyleLoaded] = useState(0);
  const id = useMemo(() => props.id || `jsx-layer-${layerCounter++}`, []);
  useEffect(() => {
    if (map5) {
      const forceUpdate = () => setStyleLoaded((version2) => version2 + 1);
      map5.on("styledata", forceUpdate);
      forceUpdate();
      return () => {
        map5.off("styledata", forceUpdate);
        if (map5.style && map5.style._loaded && map5.getLayer(id)) {
          map5.removeLayer(id);
        }
      };
    }
    return void 0;
  }, [map5]);
  const layer = map5 && map5.style && map5.getLayer(id);
  if (layer) {
    try {
      updateLayer$1(map5, id, props, propsRef.current);
    } catch (error2) {
      console.warn(error2);
    }
  } else {
    createLayer(map5, id, props);
  }
  propsRef.current = props;
  return null;
}
const index$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AttributionControl: AttributionControl$1,
  FullscreenControl: FullscreenControl$1,
  GeolocateControl: geolocateControl,
  Layer: Layer$1,
  Map: Map$7,
  MapProvider: MapProvider$1,
  Marker: Marker$1,
  NavigationControl: NavigationControl$1,
  Popup: popup,
  ScaleControl: ScaleControl$1,
  Source: Source$1,
  default: Map$7,
  useControl,
  useMap
}, Symbol.toStringTag, { value: "Module" }));
var propTypesExports$1 = {};
var propTypes$1 = {
  get exports() {
    return propTypesExports$1;
  },
  set exports(v5) {
    propTypesExports$1 = v5;
  }
};
var reactIsExports = {};
var reactIs$1 = {
  get exports() {
    return reactIsExports;
  },
  set exports(v5) {
    reactIsExports = v5;
  }
};
var reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e3 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g2 = b2 ? Symbol.for("react.profiler") : 60114, h2 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v5 = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e3:
            case g2:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A2(a2) {
    return z2(a2) === m2;
  }
  reactIs_production_min$1.AsyncMode = l2;
  reactIs_production_min$1.ConcurrentMode = m2;
  reactIs_production_min$1.ContextConsumer = k2;
  reactIs_production_min$1.ContextProvider = h2;
  reactIs_production_min$1.Element = c2;
  reactIs_production_min$1.ForwardRef = n2;
  reactIs_production_min$1.Fragment = e3;
  reactIs_production_min$1.Lazy = t2;
  reactIs_production_min$1.Memo = r2;
  reactIs_production_min$1.Portal = d2;
  reactIs_production_min$1.Profiler = g2;
  reactIs_production_min$1.StrictMode = f2;
  reactIs_production_min$1.Suspense = p2;
  reactIs_production_min$1.isAsyncMode = function(a2) {
    return A2(a2) || z2(a2) === l2;
  };
  reactIs_production_min$1.isConcurrentMode = A2;
  reactIs_production_min$1.isContextConsumer = function(a2) {
    return z2(a2) === k2;
  };
  reactIs_production_min$1.isContextProvider = function(a2) {
    return z2(a2) === h2;
  };
  reactIs_production_min$1.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min$1.isForwardRef = function(a2) {
    return z2(a2) === n2;
  };
  reactIs_production_min$1.isFragment = function(a2) {
    return z2(a2) === e3;
  };
  reactIs_production_min$1.isLazy = function(a2) {
    return z2(a2) === t2;
  };
  reactIs_production_min$1.isMemo = function(a2) {
    return z2(a2) === r2;
  };
  reactIs_production_min$1.isPortal = function(a2) {
    return z2(a2) === d2;
  };
  reactIs_production_min$1.isProfiler = function(a2) {
    return z2(a2) === g2;
  };
  reactIs_production_min$1.isStrictMode = function(a2) {
    return z2(a2) === f2;
  };
  reactIs_production_min$1.isSuspense = function(a2) {
    return z2(a2) === p2;
  };
  reactIs_production_min$1.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e3 || a2 === m2 || a2 === g2 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v5);
  };
  reactIs_production_min$1.typeOf = z2;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1)
    return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object2.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.AsyncMode = AsyncMode;
      reactIs_development$1.ConcurrentMode = ConcurrentMode;
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement2;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  if (hasRequiredReactIs$1)
    return reactIsExports;
  hasRequiredReactIs$1 = 1;
  (function(module2) {
    if (process.env.NODE_ENV === "production") {
      module2.exports = requireReactIs_production_min$1();
    } else {
      module2.exports = requireReactIs_development$1();
    }
  })(reactIs$1);
  return reactIsExports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign$1;
var hasRequiredObjectAssign$1;
function requireObjectAssign$1() {
  if (hasRequiredObjectAssign$1)
    return objectAssign$1;
  hasRequiredObjectAssign$1 = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign$1 = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from, symbols[i2])) {
            to[symbols[i2]] = from[symbols[i2]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign$1;
}
var ReactPropTypesSecret_1$1;
var hasRequiredReactPropTypesSecret$1;
function requireReactPropTypesSecret$1() {
  if (hasRequiredReactPropTypesSecret$1)
    return ReactPropTypesSecret_1$1;
  hasRequiredReactPropTypesSecret$1 = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1$1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1$1;
}
var has$3;
var hasRequiredHas$1;
function requireHas$1() {
  if (hasRequiredHas$1)
    return has$3;
  hasRequiredHas$1 = 1;
  has$3 = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$3;
}
var checkPropTypes_1$1;
var hasRequiredCheckPropTypes$1;
function requireCheckPropTypes$1() {
  if (hasRequiredCheckPropTypes$1)
    return checkPropTypes_1$1;
  hasRequiredCheckPropTypes$1 = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret$1();
    var loggedTypeFailures = {};
    var has2 = requireHas$1();
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values4, location2, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values4, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack2 = getStack ? getStack() : "";
            printWarning(
              "Failed " + location2 + " type: " + error2.message + (stack2 != null ? stack2 : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1$1 = checkPropTypes;
  return checkPropTypes_1$1;
}
var factoryWithTypeCheckers$1;
var hasRequiredFactoryWithTypeCheckers$1;
function requireFactoryWithTypeCheckers$1() {
  if (hasRequiredFactoryWithTypeCheckers$1)
    return factoryWithTypeCheckers$1;
  hasRequiredFactoryWithTypeCheckers$1 = 1;
  var ReactIs2 = requireReactIs$1();
  var assign3 = requireObjectAssign$1();
  var ReactPropTypesSecret = requireReactPropTypesSecret$1();
  var has2 = requireHas$1();
  var checkPropTypes = requireCheckPropTypes$1();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers$1 = function(isValidElement2, throwOnDirectAccess2) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is3(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message2, data2) {
      this.message = message2;
      this.data = data2 && typeof data2 === "object" ? data2 : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate2) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName2, componentName, location2, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName2;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess2) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName2;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName2] == null) {
          if (isRequired) {
            if (props[propName2] === null) {
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate2(props, propName2, componentName, location2, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate2(props, propName2, componentName, location2, propFullName, secret) {
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName2];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error2 = typeChecker(propValue, i2, componentName, location2, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeChecker() {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeTypeChecker() {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        if (!ReactIs2.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (!(props[propName2] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName2]);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is3(propValue, expectedValues[i2])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate2(props, propName2, componentName, location2, propFullName) {
        var expectedTypes = [];
        for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3];
          var checkerResult = checker2(props, propName2, componentName, location2, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createNodeChecker() {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (!isNode(props[propName2])) {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function invalidValidatorError(componentName, location2, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign3({}, props[propName2], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName2], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator7 = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator7.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator7.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers$1;
}
var factoryWithThrowingShims$1;
var hasRequiredFactoryWithThrowingShims$1;
function requireFactoryWithThrowingShims$1() {
  if (hasRequiredFactoryWithThrowingShims$1)
    return factoryWithThrowingShims$1;
  hasRequiredFactoryWithThrowingShims$1 = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret$1();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims$1 = function() {
    function shim2(props, propName2, componentName, location2, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims$1;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs$1 = requireReactIs$1();
  var throwOnDirectAccess$1 = true;
  propTypes$1.exports = requireFactoryWithTypeCheckers$1()(ReactIs$1.isElement, throwOnDirectAccess$1);
} else {
  propTypes$1.exports = requireFactoryWithThrowingShims$1()();
}
const editorImpl_module = {};
const createStoreImpl = (createState) => {
  let state;
  const listeners2 = /* @__PURE__ */ new Set();
  const setState = (partial, replace2) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace2 != null ? replace2 : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
      listeners2.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners2.add(listener);
    return () => listeners2.delete(listener);
  };
  const destroy2 = () => {
    if (({ "REACT_APP_MAPBOX_ACCESS_TOKEN": "pk.eyJ1IjoiYzNzcGVjdHJhaW5jIiwiYSI6ImNsbHM3ZWhycTBpOWwzZHBnOWZhMnlueTEifQ.-FvButJMxCTBG9Qft9kLGQ", "REACT_APP_CESIUM_DEFAULT_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3NGM4MGVmMi1jMjBmLTQ4ZGItYmJmZi0yYjQ0NTYyY2QzNGMiLCJpZCI6MTM5MjMxLCJpYXQiOjE2ODQzMDY1NzN9.vVbvKxCs-Gi3u5EEsbWPdw3CTstDcKG6u1sG2sFOGVc", "REACT_APP_SPECTRAAI_POSTGRES_ENDPOINT": "https://product-sai-backend-v2.development.c3spectra.com", "REACT_APP_SPECTRAAI_TEST_LOGIN": "testuser", "REACT_APP_SPECTRAAI_TEST_PASSWORD": "testuser", "REACT_APP_KEYCLOAK_CLIENT_ID": "5g-network-operations", "REACT_APP_KEYCLOAK_CLIENT_SECRET": "I9TinNYa7hvnyd4kesXcB3THhp3mbtGA", "BASE_URL": "/", "MODE": "production", "DEV": false, "PROD": true, "SSR": false } && "production") !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners2.clear();
  };
  const api2 = { setState, getState, subscribe, destroy: destroy2 };
  state = createState(setState, getState, api2);
  return api2;
};
const createStore$2 = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var withSelectorExports = {};
var withSelector = {
  get exports() {
    return withSelectorExports;
  },
  set exports(v5) {
    withSelectorExports = v5;
  }
};
var withSelector_production_min = {};
var shimExports = {};
var shim$4 = {
  get exports() {
    return shimExports;
  },
  set exports(v5) {
    shimExports = v5;
  }
};
var useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min)
    return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e3 = React__default;
  function h2(a2, b2) {
    return a2 === b2 && (0 !== a2 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }
  var k2 = "function" === typeof Object.is ? Object.is : h2, l2 = e3.useState, m2 = e3.useEffect, n2 = e3.useLayoutEffect, p2 = e3.useDebugValue;
  function q2(a2, b2) {
    var d2 = b2(), f2 = l2({ inst: { value: d2, getSnapshot: b2 } }), c2 = f2[0].inst, g2 = f2[1];
    n2(function() {
      c2.value = d2;
      c2.getSnapshot = b2;
      r2(c2) && g2({ inst: c2 });
    }, [a2, d2, b2]);
    m2(function() {
      r2(c2) && g2({ inst: c2 });
      return a2(function() {
        r2(c2) && g2({ inst: c2 });
      });
    }, [a2]);
    p2(d2);
    return d2;
  }
  function r2(a2) {
    var b2 = a2.getSnapshot;
    a2 = a2.value;
    try {
      var d2 = b2();
      return !k2(a2, d2);
    } catch (f2) {
      return true;
    }
  }
  function t2(a2, b2) {
    return b2();
  }
  var u2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t2 : q2;
  useSyncExternalStoreShim_production_min.useSyncExternalStore = void 0 !== e3.useSyncExternalStore ? e3.useSyncExternalStore : u2;
  return useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development)
    return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React2 = React__default;
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error2(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack2 = ReactDebugCurrentFrame.getStackAddendum();
          if (stack2 !== "") {
            format += "%s";
            args = args.concat([stack2]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      function is3(x2, y2) {
        return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
      }
      var objectIs2 = typeof Object.is === "function" ? Object.is : is3;
      var useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue2 = React2.useDebugValue;
      var didWarnOld18Alpha = false;
      var didWarnUncachedGetSnapshot = false;
      function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        {
          if (!didWarnOld18Alpha) {
            if (React2.startTransition !== void 0) {
              didWarnOld18Alpha = true;
              error2("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
          }
        }
        var value = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs2(value, cachedValue)) {
              error2("The result of getSnapshot should be cached to avoid an infinite loop");
              didWarnUncachedGetSnapshot = true;
            }
          }
        }
        var _useState = useState2({
          inst: {
            value,
            getSnapshot
          }
        }), inst = _useState[0].inst, forceUpdate = _useState[1];
        useLayoutEffect2(function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
        }, [subscribe, value, getSnapshot]);
        useEffect2(function() {
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
          var handleStoreChange = function() {
            if (checkIfSnapshotChanged(inst)) {
              forceUpdate({
                inst
              });
            }
          };
          return subscribe(handleStoreChange);
        }, [subscribe]);
        useDebugValue2(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs2(prevValue, nextValue);
        } catch (error3) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        return getSnapshot();
      }
      var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
      var isServerEnvironment = !canUseDOM;
      var shim2 = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
      var useSyncExternalStore$2 = React2.useSyncExternalStore !== void 0 ? React2.useSyncExternalStore : shim2;
      useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim)
    return shimExports;
  hasRequiredShim = 1;
  (function(module2) {
    if (process.env.NODE_ENV === "production") {
      module2.exports = requireUseSyncExternalStoreShim_production_min();
    } else {
      module2.exports = requireUseSyncExternalStoreShim_development();
    }
  })(shim$4);
  return shimExports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min)
    return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h2 = React__default, n2 = requireShim();
  function p2(a2, b2) {
    return a2 === b2 && (0 !== a2 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
  }
  var q2 = "function" === typeof Object.is ? Object.is : p2, r2 = n2.useSyncExternalStore, t2 = h2.useRef, u2 = h2.useEffect, v5 = h2.useMemo, w2 = h2.useDebugValue;
  withSelector_production_min.useSyncExternalStoreWithSelector = function(a2, b2, e3, l2, g2) {
    var c2 = t2(null);
    if (null === c2.current) {
      var f2 = { hasValue: false, value: null };
      c2.current = f2;
    } else
      f2 = c2.current;
    c2 = v5(function() {
      function a3(a4) {
        if (!c3) {
          c3 = true;
          d3 = a4;
          a4 = l2(a4);
          if (void 0 !== g2 && f2.hasValue) {
            var b3 = f2.value;
            if (g2(b3, a4))
              return k2 = b3;
          }
          return k2 = a4;
        }
        b3 = k2;
        if (q2(d3, a4))
          return b3;
        var e4 = l2(a4);
        if (void 0 !== g2 && g2(b3, e4))
          return b3;
        d3 = a4;
        return k2 = e4;
      }
      var c3 = false, d3, k2, m2 = void 0 === e3 ? null : e3;
      return [function() {
        return a3(b2());
      }, null === m2 ? void 0 : function() {
        return a3(m2());
      }];
    }, [b2, e3, l2, g2]);
    var d2 = r2(a2, c2[0], c2[1]);
    u2(function() {
      f2.hasValue = true;
      f2.value = d2;
    }, [d2]);
    w2(d2);
    return d2;
  };
  return withSelector_production_min;
}
var withSelector_development = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  if (hasRequiredWithSelector_development)
    return withSelector_development;
  hasRequiredWithSelector_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React2 = React__default;
      var shim2 = requireShim();
      function is3(x2, y2) {
        return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
      }
      var objectIs2 = typeof Object.is === "function" ? Object.is : is3;
      var useSyncExternalStore = shim2.useSyncExternalStore;
      var useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue2 = React2.useDebugValue;
      function useSyncExternalStoreWithSelector2(subscribe, getSnapshot, getServerSnapshot, selector, isEqual3) {
        var instRef = useRef2(null);
        var inst;
        if (instRef.current === null) {
          inst = {
            hasValue: false,
            value: null
          };
          instRef.current = inst;
        } else {
          inst = instRef.current;
        }
        var _useMemo = useMemo2(function() {
          var hasMemo = false;
          var memoizedSnapshot;
          var memoizedSelection;
          var memoizedSelector = function(nextSnapshot) {
            if (!hasMemo) {
              hasMemo = true;
              memoizedSnapshot = nextSnapshot;
              var _nextSelection = selector(nextSnapshot);
              if (isEqual3 !== void 0) {
                if (inst.hasValue) {
                  var currentSelection = inst.value;
                  if (isEqual3(currentSelection, _nextSelection)) {
                    memoizedSelection = currentSelection;
                    return currentSelection;
                  }
                }
              }
              memoizedSelection = _nextSelection;
              return _nextSelection;
            }
            var prevSnapshot = memoizedSnapshot;
            var prevSelection = memoizedSelection;
            if (objectIs2(prevSnapshot, nextSnapshot)) {
              return prevSelection;
            }
            var nextSelection = selector(nextSnapshot);
            if (isEqual3 !== void 0 && isEqual3(prevSelection, nextSelection)) {
              return prevSelection;
            }
            memoizedSnapshot = nextSnapshot;
            memoizedSelection = nextSelection;
            return nextSelection;
          };
          var maybeGetServerSnapshot = getServerSnapshot === void 0 ? null : getServerSnapshot;
          var getSnapshotWithSelector = function() {
            return memoizedSelector(getSnapshot());
          };
          var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          };
          return [getSnapshotWithSelector, getServerSnapshotWithSelector];
        }, [getSnapshot, getServerSnapshot, selector, isEqual3]), getSelection = _useMemo[0], getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect2(function() {
          inst.hasValue = true;
          inst.value = value;
        }, [value]);
        useDebugValue2(value);
        return value;
      }
      withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector2;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return withSelector_development;
}
(function(module2) {
  if (process.env.NODE_ENV === "production") {
    module2.exports = requireWithSelector_production_min();
  } else {
    module2.exports = requireWithSelector_development();
  }
})(withSelector);
const useSyncExternalStoreExports = /* @__PURE__ */ getDefaultExportFromCjs$1(withSelectorExports);
const { useSyncExternalStoreWithSelector } = useSyncExternalStoreExports;
function useStore$1(api2, selector = api2.getState, equalityFn) {
  const slice2 = useSyncExternalStoreWithSelector(
    api2.subscribe,
    api2.getState,
    api2.getServerState || api2.getState,
    selector,
    equalityFn
  );
  useDebugValue(slice2);
  return slice2;
}
const createImpl = (createState) => {
  if (({ "REACT_APP_MAPBOX_ACCESS_TOKEN": "pk.eyJ1IjoiYzNzcGVjdHJhaW5jIiwiYSI6ImNsbHM3ZWhycTBpOWwzZHBnOWZhMnlueTEifQ.-FvButJMxCTBG9Qft9kLGQ", "REACT_APP_CESIUM_DEFAULT_TOKEN": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3NGM4MGVmMi1jMjBmLTQ4ZGItYmJmZi0yYjQ0NTYyY2QzNGMiLCJpZCI6MTM5MjMxLCJpYXQiOjE2ODQzMDY1NzN9.vVbvKxCs-Gi3u5EEsbWPdw3CTstDcKG6u1sG2sFOGVc", "REACT_APP_SPECTRAAI_POSTGRES_ENDPOINT": "https://product-sai-backend-v2.development.c3spectra.com", "REACT_APP_SPECTRAAI_TEST_LOGIN": "testuser", "REACT_APP_SPECTRAAI_TEST_PASSWORD": "testuser", "REACT_APP_KEYCLOAK_CLIENT_ID": "5g-network-operations", "REACT_APP_KEYCLOAK_CLIENT_SECRET": "I9TinNYa7hvnyd4kesXcB3THhp3mbtGA", "BASE_URL": "/", "MODE": "production", "DEV": false, "PROD": true, "SSR": false } && "production") !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api2 = typeof createState === "function" ? createStore$2(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore$1(api2, selector, equalityFn);
  Object.assign(useBoundStore, api2);
  return useBoundStore;
};
const create$6 = (createState) => createState ? createImpl(createState) : createImpl;
function n$5(n2) {
  for (var r2 = arguments.length, t2 = Array(r2 > 1 ? r2 - 1 : 0), e3 = 1; e3 < r2; e3++)
    t2[e3 - 1] = arguments[e3];
  if ("production" !== process.env.NODE_ENV) {
    var i2 = Y$2[n2], o2 = i2 ? "function" == typeof i2 ? i2.apply(null, t2) : i2 : "unknown error nr: " + n2;
    throw Error("[Immer] " + o2);
  }
  throw Error("[Immer] minified error nr: " + n2 + (t2.length ? " " + t2.map(function(n3) {
    return "'" + n3 + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r$4(n2) {
  return !!n2 && !!n2[Q$1];
}
function t$3(n2) {
  var r2;
  return !!n2 && (function(n3) {
    if (!n3 || "object" != typeof n3)
      return false;
    var r3 = Object.getPrototypeOf(n3);
    if (null === r3)
      return true;
    var t2 = Object.hasOwnProperty.call(r3, "constructor") && r3.constructor;
    return t2 === Object || "function" == typeof t2 && Function.toString.call(t2) === Z$2;
  }(n2) || Array.isArray(n2) || !!n2[L$2] || !!(null === (r2 = n2.constructor) || void 0 === r2 ? void 0 : r2[L$2]) || s$2(n2) || v$4(n2));
}
function i$7(n2, r2, t2) {
  void 0 === t2 && (t2 = false), 0 === o$4(n2) ? (t2 ? Object.keys : nn)(n2).forEach(function(e3) {
    t2 && "symbol" == typeof e3 || r2(e3, n2[e3], n2);
  }) : n2.forEach(function(t3, e3) {
    return r2(e3, t3, n2);
  });
}
function o$4(n2) {
  var r2 = n2[Q$1];
  return r2 ? r2.i > 3 ? r2.i - 4 : r2.i : Array.isArray(n2) ? 1 : s$2(n2) ? 2 : v$4(n2) ? 3 : 0;
}
function u$2(n2, r2) {
  return 2 === o$4(n2) ? n2.has(r2) : Object.prototype.hasOwnProperty.call(n2, r2);
}
function a$5(n2, r2) {
  return 2 === o$4(n2) ? n2.get(r2) : n2[r2];
}
function f$3(n2, r2, t2) {
  var e3 = o$4(n2);
  2 === e3 ? n2.set(r2, t2) : 3 === e3 ? n2.add(t2) : n2[r2] = t2;
}
function c$2(n2, r2) {
  return n2 === r2 ? 0 !== n2 || 1 / n2 == 1 / r2 : n2 != n2 && r2 != r2;
}
function s$2(n2) {
  return X$3 && n2 instanceof Map;
}
function v$4(n2) {
  return q$1 && n2 instanceof Set;
}
function p$2(n2) {
  return n2.o || n2.t;
}
function l$3(n2) {
  if (Array.isArray(n2))
    return Array.prototype.slice.call(n2);
  var r2 = rn(n2);
  delete r2[Q$1];
  for (var t2 = nn(r2), e3 = 0; e3 < t2.length; e3++) {
    var i2 = t2[e3], o2 = r2[i2];
    false === o2.writable && (o2.writable = true, o2.configurable = true), (o2.get || o2.set) && (r2[i2] = { configurable: true, writable: true, enumerable: o2.enumerable, value: n2[i2] });
  }
  return Object.create(Object.getPrototypeOf(n2), r2);
}
function d$1(n2, e3) {
  return void 0 === e3 && (e3 = false), y$2(n2) || r$4(n2) || !t$3(n2) || (o$4(n2) > 1 && (n2.set = n2.add = n2.clear = n2.delete = h$1), Object.freeze(n2), e3 && i$7(n2, function(n3, r2) {
    return d$1(r2, true);
  }, true)), n2;
}
function h$1() {
  n$5(2);
}
function y$2(n2) {
  return null == n2 || "object" != typeof n2 || Object.isFrozen(n2);
}
function b$1(r2) {
  var t2 = tn[r2];
  return t2 || n$5(18, r2), t2;
}
function _$1() {
  return "production" === process.env.NODE_ENV || U$2 || n$5(0), U$2;
}
function j$3(n2, r2) {
  r2 && (b$1("Patches"), n2.u = [], n2.s = [], n2.v = r2);
}
function g$3(n2) {
  O$2(n2), n2.p.forEach(S$2), n2.p = null;
}
function O$2(n2) {
  n2 === U$2 && (U$2 = n2.l);
}
function w$1(n2) {
  return U$2 = { p: [], l: U$2, h: n2, m: true, _: 0 };
}
function S$2(n2) {
  var r2 = n2[Q$1];
  0 === r2.i || 1 === r2.i ? r2.j() : r2.g = true;
}
function P$1(r2, e3) {
  e3._ = e3.p.length;
  var i2 = e3.p[0], o2 = void 0 !== r2 && r2 !== i2;
  return e3.h.O || b$1("ES5").S(e3, r2, o2), o2 ? (i2[Q$1].P && (g$3(e3), n$5(4)), t$3(r2) && (r2 = M$1(e3, r2), e3.l || x$2(e3, r2)), e3.u && b$1("Patches").M(i2[Q$1].t, r2, e3.u, e3.s)) : r2 = M$1(e3, i2, []), g$3(e3), e3.u && e3.v(e3.u, e3.s), r2 !== H$2 ? r2 : void 0;
}
function M$1(n2, r2, t2) {
  if (y$2(r2))
    return r2;
  var e3 = r2[Q$1];
  if (!e3)
    return i$7(r2, function(i2, o3) {
      return A$2(n2, e3, r2, i2, o3, t2);
    }, true), r2;
  if (e3.A !== n2)
    return r2;
  if (!e3.P)
    return x$2(n2, e3.t, true), e3.t;
  if (!e3.I) {
    e3.I = true, e3.A._--;
    var o2 = 4 === e3.i || 5 === e3.i ? e3.o = l$3(e3.k) : e3.o, u2 = o2, a2 = false;
    3 === e3.i && (u2 = new Set(o2), o2.clear(), a2 = true), i$7(u2, function(r3, i2) {
      return A$2(n2, e3, o2, r3, i2, t2, a2);
    }), x$2(n2, o2, false), t2 && n2.u && b$1("Patches").N(e3, t2, n2.u, n2.s);
  }
  return e3.o;
}
function A$2(e3, i2, o2, a2, c2, s2, v5) {
  if ("production" !== process.env.NODE_ENV && c2 === o2 && n$5(5), r$4(c2)) {
    var p2 = M$1(e3, c2, s2 && i2 && 3 !== i2.i && !u$2(i2.R, a2) ? s2.concat(a2) : void 0);
    if (f$3(o2, a2, p2), !r$4(p2))
      return;
    e3.m = false;
  } else
    v5 && o2.add(c2);
  if (t$3(c2) && !y$2(c2)) {
    if (!e3.h.D && e3._ < 1)
      return;
    M$1(e3, c2), i2 && i2.A.l || x$2(e3, c2);
  }
}
function x$2(n2, r2, t2) {
  void 0 === t2 && (t2 = false), !n2.l && n2.h.D && n2.m && d$1(r2, t2);
}
function z$1(n2, r2) {
  var t2 = n2[Q$1];
  return (t2 ? p$2(t2) : n2)[r2];
}
function I$3(n2, r2) {
  if (r2 in n2)
    for (var t2 = Object.getPrototypeOf(n2); t2; ) {
      var e3 = Object.getOwnPropertyDescriptor(t2, r2);
      if (e3)
        return e3;
      t2 = Object.getPrototypeOf(t2);
    }
}
function k$3(n2) {
  n2.P || (n2.P = true, n2.l && k$3(n2.l));
}
function E$3(n2) {
  n2.o || (n2.o = l$3(n2.t));
}
function N$2(n2, r2, t2) {
  var e3 = s$2(r2) ? b$1("MapSet").F(r2, t2) : v$4(r2) ? b$1("MapSet").T(r2, t2) : n2.O ? function(n3, r3) {
    var t3 = Array.isArray(n3), e4 = { i: t3 ? 1 : 0, A: r3 ? r3.A : _$1(), P: false, I: false, R: {}, l: r3, t: n3, k: null, o: null, j: null, C: false }, i2 = e4, o2 = en;
    t3 && (i2 = [e4], o2 = on);
    var u2 = Proxy.revocable(i2, o2), a2 = u2.revoke, f2 = u2.proxy;
    return e4.k = f2, e4.j = a2, f2;
  }(r2, t2) : b$1("ES5").J(r2, t2);
  return (t2 ? t2.A : _$1()).p.push(e3), e3;
}
function R$2(e3) {
  return r$4(e3) || n$5(22, e3), function n2(r2) {
    if (!t$3(r2))
      return r2;
    var e4, u2 = r2[Q$1], c2 = o$4(r2);
    if (u2) {
      if (!u2.P && (u2.i < 4 || !b$1("ES5").K(u2)))
        return u2.t;
      u2.I = true, e4 = D$3(r2, c2), u2.I = false;
    } else
      e4 = D$3(r2, c2);
    return i$7(e4, function(r3, t2) {
      u2 && a$5(u2.t, r3) === t2 || f$3(e4, r3, n2(t2));
    }), 3 === c2 ? new Set(e4) : e4;
  }(e3);
}
function D$3(n2, r2) {
  switch (r2) {
    case 2:
      return new Map(n2);
    case 3:
      return Array.from(n2);
  }
  return l$3(n2);
}
var G$2, U$2, W$2 = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X$3 = "undefined" != typeof Map, q$1 = "undefined" != typeof Set, B$2 = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H$2 = W$2 ? Symbol.for("immer-nothing") : ((G$2 = {})["immer-nothing"] = true, G$2), L$2 = W$2 ? Symbol.for("immer-draftable") : "__$immer_draftable", Q$1 = W$2 ? Symbol.for("immer-state") : "__$immer_state", Y$2 = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(n2) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n2;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(n2) {
  return "Cannot apply patch, path doesn't resolve: " + n2;
}, 16: 'Sets cannot have "replace" patches.', 17: function(n2) {
  return "Unsupported patch operation: " + n2;
}, 18: function(n2) {
  return "The plugin for '" + n2 + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n2 + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(n2) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n2 + "'";
}, 22: function(n2) {
  return "'current' expects a draft, got: " + n2;
}, 23: function(n2) {
  return "'original' expects a draft, got: " + n2;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, Z$2 = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n2) {
  return Object.getOwnPropertyNames(n2).concat(Object.getOwnPropertySymbols(n2));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n2) {
  var r2 = {};
  return nn(n2).forEach(function(t2) {
    r2[t2] = Object.getOwnPropertyDescriptor(n2, t2);
  }), r2;
}, tn = {}, en = { get: function(n2, r2) {
  if (r2 === Q$1)
    return n2;
  var e3 = p$2(n2);
  if (!u$2(e3, r2))
    return function(n3, r3, t2) {
      var e4, i3 = I$3(r3, t2);
      return i3 ? "value" in i3 ? i3.value : null === (e4 = i3.get) || void 0 === e4 ? void 0 : e4.call(n3.k) : void 0;
    }(n2, e3, r2);
  var i2 = e3[r2];
  return n2.I || !t$3(i2) ? i2 : i2 === z$1(n2.t, r2) ? (E$3(n2), n2.o[r2] = N$2(n2.A.h, i2, n2)) : i2;
}, has: function(n2, r2) {
  return r2 in p$2(n2);
}, ownKeys: function(n2) {
  return Reflect.ownKeys(p$2(n2));
}, set: function(n2, r2, t2) {
  var e3 = I$3(p$2(n2), r2);
  if (null == e3 ? void 0 : e3.set)
    return e3.set.call(n2.k, t2), true;
  if (!n2.P) {
    var i2 = z$1(p$2(n2), r2), o2 = null == i2 ? void 0 : i2[Q$1];
    if (o2 && o2.t === t2)
      return n2.o[r2] = t2, n2.R[r2] = false, true;
    if (c$2(t2, i2) && (void 0 !== t2 || u$2(n2.t, r2)))
      return true;
    E$3(n2), k$3(n2);
  }
  return n2.o[r2] === t2 && (void 0 !== t2 || r2 in n2.o) || Number.isNaN(t2) && Number.isNaN(n2.o[r2]) || (n2.o[r2] = t2, n2.R[r2] = true), true;
}, deleteProperty: function(n2, r2) {
  return void 0 !== z$1(n2.t, r2) || r2 in n2.t ? (n2.R[r2] = false, E$3(n2), k$3(n2)) : delete n2.R[r2], n2.o && delete n2.o[r2], true;
}, getOwnPropertyDescriptor: function(n2, r2) {
  var t2 = p$2(n2), e3 = Reflect.getOwnPropertyDescriptor(t2, r2);
  return e3 ? { writable: true, configurable: 1 !== n2.i || "length" !== r2, enumerable: e3.enumerable, value: t2[r2] } : e3;
}, defineProperty: function() {
  n$5(11);
}, getPrototypeOf: function(n2) {
  return Object.getPrototypeOf(n2.t);
}, setPrototypeOf: function() {
  n$5(12);
} }, on = {};
i$7(en, function(n2, r2) {
  on[n2] = function() {
    return arguments[0] = arguments[0][0], r2.apply(this, arguments);
  };
}), on.deleteProperty = function(r2, t2) {
  return "production" !== process.env.NODE_ENV && isNaN(parseInt(t2)) && n$5(13), on.set.call(this, r2, t2, void 0);
}, on.set = function(r2, t2, e3) {
  return "production" !== process.env.NODE_ENV && "length" !== t2 && isNaN(parseInt(t2)) && n$5(14), en.set.call(this, r2[0], t2, e3, r2[0]);
};
var un = function() {
  function e3(r2) {
    var e4 = this;
    this.O = B$2, this.D = true, this.produce = function(r3, i3, o2) {
      if ("function" == typeof r3 && "function" != typeof i3) {
        var u2 = i3;
        i3 = r3;
        var a2 = e4;
        return function(n2) {
          var r4 = this;
          void 0 === n2 && (n2 = u2);
          for (var t2 = arguments.length, e5 = Array(t2 > 1 ? t2 - 1 : 0), o3 = 1; o3 < t2; o3++)
            e5[o3 - 1] = arguments[o3];
          return a2.produce(n2, function(n3) {
            var t3;
            return (t3 = i3).call.apply(t3, [r4, n3].concat(e5));
          });
        };
      }
      var f2;
      if ("function" != typeof i3 && n$5(6), void 0 !== o2 && "function" != typeof o2 && n$5(7), t$3(r3)) {
        var c2 = w$1(e4), s2 = N$2(e4, r3, void 0), v5 = true;
        try {
          f2 = i3(s2), v5 = false;
        } finally {
          v5 ? g$3(c2) : O$2(c2);
        }
        return "undefined" != typeof Promise && f2 instanceof Promise ? f2.then(function(n2) {
          return j$3(c2, o2), P$1(n2, c2);
        }, function(n2) {
          throw g$3(c2), n2;
        }) : (j$3(c2, o2), P$1(f2, c2));
      }
      if (!r3 || "object" != typeof r3) {
        if (void 0 === (f2 = i3(r3)) && (f2 = r3), f2 === H$2 && (f2 = void 0), e4.D && d$1(f2, true), o2) {
          var p2 = [], l2 = [];
          b$1("Patches").M(r3, f2, p2, l2), o2(p2, l2);
        }
        return f2;
      }
      n$5(21, r3);
    }, this.produceWithPatches = function(n2, r3) {
      if ("function" == typeof n2)
        return function(r4) {
          for (var t3 = arguments.length, i4 = Array(t3 > 1 ? t3 - 1 : 0), o3 = 1; o3 < t3; o3++)
            i4[o3 - 1] = arguments[o3];
          return e4.produceWithPatches(r4, function(r5) {
            return n2.apply(void 0, [r5].concat(i4));
          });
        };
      var t2, i3, o2 = e4.produce(n2, r3, function(n3, r4) {
        t2 = n3, i3 = r4;
      });
      return "undefined" != typeof Promise && o2 instanceof Promise ? o2.then(function(n3) {
        return [n3, t2, i3];
      }) : [o2, t2, i3];
    }, "boolean" == typeof (null == r2 ? void 0 : r2.useProxies) && this.setUseProxies(r2.useProxies), "boolean" == typeof (null == r2 ? void 0 : r2.autoFreeze) && this.setAutoFreeze(r2.autoFreeze);
  }
  var i2 = e3.prototype;
  return i2.createDraft = function(e4) {
    t$3(e4) || n$5(8), r$4(e4) && (e4 = R$2(e4));
    var i3 = w$1(this), o2 = N$2(this, e4, void 0);
    return o2[Q$1].C = true, O$2(i3), o2;
  }, i2.finishDraft = function(r2, t2) {
    var e4 = r2 && r2[Q$1];
    "production" !== process.env.NODE_ENV && (e4 && e4.C || n$5(9), e4.I && n$5(10));
    var i3 = e4.A;
    return j$3(i3, t2), P$1(void 0, i3);
  }, i2.setAutoFreeze = function(n2) {
    this.D = n2;
  }, i2.setUseProxies = function(r2) {
    r2 && !B$2 && n$5(20), this.O = r2;
  }, i2.applyPatches = function(n2, t2) {
    var e4;
    for (e4 = t2.length - 1; e4 >= 0; e4--) {
      var i3 = t2[e4];
      if (0 === i3.path.length && "replace" === i3.op) {
        n2 = i3.value;
        break;
      }
    }
    e4 > -1 && (t2 = t2.slice(e4 + 1));
    var o2 = b$1("Patches").$;
    return r$4(n2) ? o2(n2, t2) : this.produce(n2, function(n3) {
      return o2(n3, t2);
    });
  }, e3;
}(), an$1 = new un(), fn = an$1.produce;
an$1.produceWithPatches.bind(an$1);
an$1.setAutoFreeze.bind(an$1);
an$1.setUseProxies.bind(an$1);
an$1.applyPatches.bind(an$1);
an$1.createDraft.bind(an$1);
an$1.finishDraft.bind(an$1);
const produce = fn;
const logger = (store2, name2) => {
  if (!name2) {
    return store2;
  }
  return (set, get6, api2) => store2((args) => {
    set(args);
    console.debug(name2, get6());
  }, get6, api2);
};
const immer = (store2) => (set, get6, api2) => store2((args) => set(produce(args)), get6, api2);
const createZustandStore = (prototype2, name2) => create$6(logger(immer(prototype2), name2));
let getRandomValues$1;
const rnds8$1 = new Uint8Array(16);
function rng$1() {
  if (!getRandomValues$1) {
    getRandomValues$1 = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues$1) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues$1(rnds8$1);
}
const byteToHex$1 = [];
for (let i2 = 0; i2 < 256; ++i2) {
  byteToHex$1.push((i2 + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset = 0) {
  return byteToHex$1[arr[offset + 0]] + byteToHex$1[arr[offset + 1]] + byteToHex$1[arr[offset + 2]] + byteToHex$1[arr[offset + 3]] + "-" + byteToHex$1[arr[offset + 4]] + byteToHex$1[arr[offset + 5]] + "-" + byteToHex$1[arr[offset + 6]] + byteToHex$1[arr[offset + 7]] + "-" + byteToHex$1[arr[offset + 8]] + byteToHex$1[arr[offset + 9]] + "-" + byteToHex$1[arr[offset + 10]] + byteToHex$1[arr[offset + 11]] + byteToHex$1[arr[offset + 12]] + byteToHex$1[arr[offset + 13]] + byteToHex$1[arr[offset + 14]] + byteToHex$1[arr[offset + 15]];
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4$2(options2, buf, offset) {
  if (native.randomUUID && !buf && !options2) {
    return native.randomUUID();
  }
  options2 = options2 || {};
  const rnds = options2.random || (options2.rng || rng$1)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (let i2 = 0; i2 < 16; ++i2) {
      buf[offset + i2] = rnds[i2];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
const generateUid = () => v4$2();
const truncateDecimal = (num) => {
  if (!Number.isNaN(num)) {
    const precision = 1e6;
    const value = Math.round(num * precision) / precision;
    return value;
  }
  return null;
};
const hashCode = (str) => {
  if (!str || typeof str !== "string" || str.length === 0)
    return "0";
  let hash = 0;
  let chr;
  for (let i2 = 0; i2 < str.length; i2 += 1) {
    chr = str.charCodeAt(i2);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return `${hash}`;
};
const pushArray = (toArray3, fromArray) => {
  if (!toArray3)
    return toArray3;
  fromArray == null ? void 0 : fromArray.forEach((f2) => toArray3.push(f2));
  return toArray3;
};
const mergeArray = (array1, array2) => pushArray(pushArray([], array1), array2);
const uniqueArray = (array2) => Array.from(new Set(array2 || []));
const removeArray = (removeFrom, removeThis, comparator2 = (a2, b2) => a2 === b2) => {
  if (!(removeThis == null ? void 0 : removeThis.length))
    return removeFrom;
  if (!(removeFrom == null ? void 0 : removeFrom.length))
    return removeFrom;
  const result = pushArray([], removeFrom);
  removeThis.forEach((objThis) => {
    const index2 = removeFrom.findIndex((objFrom) => comparator2(objFrom, objThis));
    if (index2 > -1)
      result.splice(index2, 1);
  });
  return result;
};
const makeFirstLetterCapital = (str) => {
  if (!str)
    return str;
  if (typeof str !== "string")
    return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};
const makeFirstLetterSmall = (str) => {
  if (!str)
    return str;
  if (typeof str !== "string")
    return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
};
const toCamelCase = (snakeStr, tokenSeparator = "_") => {
  if (snakeStr === null || snakeStr === void 0)
    return snakeStr;
  const snakeTokens = snakeStr.split(tokenSeparator);
  const camelStr = snakeTokens.map((token) => token.charAt(0).toUpperCase() + token.slice(1).toLowerCase()).join("");
  return makeFirstLetterSmall(camelStr);
};
function parsePadding(paddingIn) {
  let padding = paddingIn;
  const sides = ["top", "right", "bottom", "left"];
  const result = {};
  if (padding) {
    padding = padding.trim();
    const parts = padding.split(/\s+/);
    if (parts.length === 1) {
      parts.push(parts[0], parts[0], parts[0]);
    } else if (parts.length === 2) {
      parts.push(parts[0], parts[1]);
    } else if (parts.length === 3) {
      parts.push(parts[1]);
    }
    sides.forEach((side, index2) => {
      const match2 = parts[index2].match(/^(-?\d*\.?\d+)([a-z%]*)$/);
      if (match2) {
        result[side] = parseFloat(match2[1]);
        result[`${side}Unit`] = match2[2] || "px";
      } else {
        throw new Error(`Invalid padding value: ${parts[index2]}`);
      }
    });
  } else {
    sides.forEach((side) => {
      result[side] = null;
      result[`${side}Unit`] = "px";
    });
  }
  return result;
}
function getFileType(data2) {
  if (!data2 || (data2 == null ? void 0 : data2.dataType) !== "dataUrl")
    return "";
  const match2 = data2 == null ? void 0 : data2.data.match(/^data:([^;]+);/);
  return match2 ? match2[1].split("/")[1] : null;
}
var earthRadius$4 = 63710088e-1;
var factors$4 = {
  centimeters: earthRadius$4 * 100,
  centimetres: earthRadius$4 * 100,
  degrees: earthRadius$4 / 111325,
  feet: earthRadius$4 * 3.28084,
  inches: earthRadius$4 * 39.37,
  kilometers: earthRadius$4 / 1e3,
  kilometres: earthRadius$4 / 1e3,
  meters: earthRadius$4,
  metres: earthRadius$4,
  miles: earthRadius$4 / 1609.344,
  millimeters: earthRadius$4 * 1e3,
  millimetres: earthRadius$4 * 1e3,
  nauticalmiles: earthRadius$4 / 1852,
  radians: 1,
  yards: earthRadius$4 * 1.0936
};
var unitsFactors$1 = {
  centimeters: 100,
  centimetres: 100,
  degrees: 1 / 111325,
  feet: 3.28084,
  inches: 39.37,
  kilometers: 1 / 1e3,
  kilometres: 1 / 1e3,
  meters: 1,
  metres: 1,
  miles: 1 / 1609.344,
  millimeters: 1e3,
  millimetres: 1e3,
  nauticalmiles: 1 / 1852,
  radians: 1 / earthRadius$4,
  yards: 1.0936133
};
var areaFactors$1 = {
  acres: 247105e-9,
  centimeters: 1e4,
  centimetres: 1e4,
  feet: 10.763910417,
  hectares: 1e-4,
  inches: 1550.003100006,
  kilometers: 1e-6,
  kilometres: 1e-6,
  meters: 1,
  metres: 1,
  miles: 386e-9,
  millimeters: 1e6,
  millimetres: 1e6,
  yards: 1.195990046
};
function feature$a(geom, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var feat = { type: "Feature" };
  if (options2.id === 0 || options2.id) {
    feat.id = options2.id;
  }
  if (options2.bbox) {
    feat.bbox = options2.bbox;
  }
  feat.properties = properties || {};
  feat.geometry = geom;
  return feat;
}
function geometry$4(type, coordinates2, _options) {
  switch (type) {
    case "Point":
      return point$5(coordinates2).geometry;
    case "LineString":
      return lineString$5(coordinates2).geometry;
    case "Polygon":
      return polygon$3(coordinates2).geometry;
    case "MultiPoint":
      return multiPoint$1(coordinates2).geometry;
    case "MultiLineString":
      return multiLineString$2(coordinates2).geometry;
    case "MultiPolygon":
      return multiPolygon$1(coordinates2).geometry;
    default:
      throw new Error(type + " is invalid");
  }
}
function point$5(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (!coordinates2) {
    throw new Error("coordinates is required");
  }
  if (!Array.isArray(coordinates2)) {
    throw new Error("coordinates must be an Array");
  }
  if (coordinates2.length < 2) {
    throw new Error("coordinates must be at least 2 numbers long");
  }
  if (!isNumber$a(coordinates2[0]) || !isNumber$a(coordinates2[1])) {
    throw new Error("coordinates must contain numbers");
  }
  var geom = {
    type: "Point",
    coordinates: coordinates2
  };
  return feature$a(geom, properties, options2);
}
function points$1(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return featureCollection$6(coordinates2.map(function(coords) {
    return point$5(coords, properties);
  }), options2);
}
function polygon$3(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  for (var _i = 0, coordinates_1 = coordinates2; _i < coordinates_1.length; _i++) {
    var ring = coordinates_1[_i];
    if (ring.length < 4) {
      throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
    }
    for (var j2 = 0; j2 < ring[ring.length - 1].length; j2++) {
      if (ring[ring.length - 1][j2] !== ring[0][j2]) {
        throw new Error("First and last Position are not equivalent.");
      }
    }
  }
  var geom = {
    type: "Polygon",
    coordinates: coordinates2
  };
  return feature$a(geom, properties, options2);
}
function polygons$1(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return featureCollection$6(coordinates2.map(function(coords) {
    return polygon$3(coords, properties);
  }), options2);
}
function lineString$5(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (coordinates2.length < 2) {
    throw new Error("coordinates must be an array of two or more positions");
  }
  var geom = {
    type: "LineString",
    coordinates: coordinates2
  };
  return feature$a(geom, properties, options2);
}
function lineStrings$1(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return featureCollection$6(coordinates2.map(function(coords) {
    return lineString$5(coords, properties);
  }), options2);
}
function featureCollection$6(features, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var fc = { type: "FeatureCollection" };
  if (options2.id) {
    fc.id = options2.id;
  }
  if (options2.bbox) {
    fc.bbox = options2.bbox;
  }
  fc.features = features;
  return fc;
}
function multiLineString$2(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = {
    type: "MultiLineString",
    coordinates: coordinates2
  };
  return feature$a(geom, properties, options2);
}
function multiPoint$1(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = {
    type: "MultiPoint",
    coordinates: coordinates2
  };
  return feature$a(geom, properties, options2);
}
function multiPolygon$1(coordinates2, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = {
    type: "MultiPolygon",
    coordinates: coordinates2
  };
  return feature$a(geom, properties, options2);
}
function geometryCollection$1(geometries, properties, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = {
    type: "GeometryCollection",
    geometries
  };
  return feature$a(geom, properties, options2);
}
function round$2(num, precision) {
  if (precision === void 0) {
    precision = 0;
  }
  if (precision && !(precision >= 0)) {
    throw new Error("precision must be a positive number");
  }
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(num * multiplier) / multiplier;
}
function radiansToLength$3(radians2, units2) {
  if (units2 === void 0) {
    units2 = "kilometers";
  }
  var factor = factors$4[units2];
  if (!factor) {
    throw new Error(units2 + " units is invalid");
  }
  return radians2 * factor;
}
function lengthToRadians$2(distance11, units2) {
  if (units2 === void 0) {
    units2 = "kilometers";
  }
  var factor = factors$4[units2];
  if (!factor) {
    throw new Error(units2 + " units is invalid");
  }
  return distance11 / factor;
}
function lengthToDegrees$1(distance11, units2) {
  return radiansToDegrees$4(lengthToRadians$2(distance11, units2));
}
function bearingToAzimuth$1(bearing2) {
  var angle4 = bearing2 % 360;
  if (angle4 < 0) {
    angle4 += 360;
  }
  return angle4;
}
function radiansToDegrees$4(radians2) {
  var degrees2 = radians2 % (2 * Math.PI);
  return degrees2 * 180 / Math.PI;
}
function degreesToRadians$4(degrees2) {
  var radians2 = degrees2 % 360;
  return radians2 * Math.PI / 180;
}
function convertLength$1(length2, originalUnit, finalUnit) {
  if (originalUnit === void 0) {
    originalUnit = "kilometers";
  }
  if (finalUnit === void 0) {
    finalUnit = "kilometers";
  }
  if (!(length2 >= 0)) {
    throw new Error("length must be a positive number");
  }
  return radiansToLength$3(lengthToRadians$2(length2, originalUnit), finalUnit);
}
function convertArea$1(area5, originalUnit, finalUnit) {
  if (originalUnit === void 0) {
    originalUnit = "meters";
  }
  if (finalUnit === void 0) {
    finalUnit = "kilometers";
  }
  if (!(area5 >= 0)) {
    throw new Error("area must be a positive number");
  }
  var startFactor = areaFactors$1[originalUnit];
  if (!startFactor) {
    throw new Error("invalid original units");
  }
  var finalFactor = areaFactors$1[finalUnit];
  if (!finalFactor) {
    throw new Error("invalid final units");
  }
  return area5 / startFactor * finalFactor;
}
function isNumber$a(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$k(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$8(bbox2) {
  if (!bbox2) {
    throw new Error("bbox is required");
  }
  if (!Array.isArray(bbox2)) {
    throw new Error("bbox must be an Array");
  }
  if (bbox2.length !== 4 && bbox2.length !== 6) {
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  }
  bbox2.forEach(function(num) {
    if (!isNumber$a(num)) {
      throw new Error("bbox must only contain numbers");
    }
  });
}
function validateId$8(id) {
  if (!id) {
    throw new Error("id is required");
  }
  if (["string", "number"].indexOf(typeof id) === -1) {
    throw new Error("id must be a number or a string");
  }
}
const es$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  areaFactors: areaFactors$1,
  bearingToAzimuth: bearingToAzimuth$1,
  convertArea: convertArea$1,
  convertLength: convertLength$1,
  degreesToRadians: degreesToRadians$4,
  earthRadius: earthRadius$4,
  factors: factors$4,
  feature: feature$a,
  featureCollection: featureCollection$6,
  geometry: geometry$4,
  geometryCollection: geometryCollection$1,
  isNumber: isNumber$a,
  isObject: isObject$k,
  lengthToDegrees: lengthToDegrees$1,
  lengthToRadians: lengthToRadians$2,
  lineString: lineString$5,
  lineStrings: lineStrings$1,
  multiLineString: multiLineString$2,
  multiPoint: multiPoint$1,
  multiPolygon: multiPolygon$1,
  point: point$5,
  points: points$1,
  polygon: polygon$3,
  polygons: polygons$1,
  radiansToDegrees: radiansToDegrees$4,
  radiansToLength: radiansToLength$3,
  round: round$2,
  unitsFactors: unitsFactors$1,
  validateBBox: validateBBox$8,
  validateId: validateId$8
}, Symbol.toStringTag, { value: "Module" }));
function coordEach(geojson, callback, excludeWrapCoord) {
  if (geojson === null)
    return;
  var j2, k2, l2, geometry2, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection2, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature2 = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature2 ? geojson.geometry : geojson;
    isGeometryCollection2 = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection2 ? geometryMaybeCollection.geometries.length : 1;
    for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
      var multiFeatureIndex = 0;
      var geometryIndex = 0;
      geometry2 = isGeometryCollection2 ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
      if (geometry2 === null)
        continue;
      coords = geometry2.coordinates;
      var geomType = geometry2.type;
      wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
      switch (geomType) {
        case null:
          break;
        case "Point":
          if (callback(
            coords,
            coordIndex,
            featureIndex,
            multiFeatureIndex,
            geometryIndex
          ) === false)
            return false;
          coordIndex++;
          multiFeatureIndex++;
          break;
        case "LineString":
        case "MultiPoint":
          for (j2 = 0; j2 < coords.length; j2++) {
            if (callback(
              coords[j2],
              coordIndex,
              featureIndex,
              multiFeatureIndex,
              geometryIndex
            ) === false)
              return false;
            coordIndex++;
            if (geomType === "MultiPoint")
              multiFeatureIndex++;
          }
          if (geomType === "LineString")
            multiFeatureIndex++;
          break;
        case "Polygon":
        case "MultiLineString":
          for (j2 = 0; j2 < coords.length; j2++) {
            for (k2 = 0; k2 < coords[j2].length - wrapShrink; k2++) {
              if (callback(
                coords[j2][k2],
                coordIndex,
                featureIndex,
                multiFeatureIndex,
                geometryIndex
              ) === false)
                return false;
              coordIndex++;
            }
            if (geomType === "MultiLineString")
              multiFeatureIndex++;
            if (geomType === "Polygon")
              geometryIndex++;
          }
          if (geomType === "Polygon")
            multiFeatureIndex++;
          break;
        case "MultiPolygon":
          for (j2 = 0; j2 < coords.length; j2++) {
            geometryIndex = 0;
            for (k2 = 0; k2 < coords[j2].length; k2++) {
              for (l2 = 0; l2 < coords[j2][k2].length - wrapShrink; l2++) {
                if (callback(
                  coords[j2][k2][l2],
                  coordIndex,
                  featureIndex,
                  multiFeatureIndex,
                  geometryIndex
                ) === false)
                  return false;
                coordIndex++;
              }
              geometryIndex++;
            }
            multiFeatureIndex++;
          }
          break;
        case "GeometryCollection":
          for (j2 = 0; j2 < geometry2.geometries.length; j2++)
            if (coordEach(geometry2.geometries[j2], callback, excludeWrapCoord) === false)
              return false;
          break;
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
  }
}
function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
  var previousValue = initialValue;
  coordEach(
    geojson,
    function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
      if (coordIndex === 0 && initialValue === void 0)
        previousValue = currentCoord;
      else
        previousValue = callback(
          previousValue,
          currentCoord,
          coordIndex,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    },
    excludeWrapCoord
  );
  return previousValue;
}
function propEach(geojson, callback) {
  var i2;
  switch (geojson.type) {
    case "FeatureCollection":
      for (i2 = 0; i2 < geojson.features.length; i2++) {
        if (callback(geojson.features[i2].properties, i2) === false)
          break;
      }
      break;
    case "Feature":
      callback(geojson.properties, 0);
      break;
  }
}
function propReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  propEach(geojson, function(currentProperties, featureIndex) {
    if (featureIndex === 0 && initialValue === void 0)
      previousValue = currentProperties;
    else
      previousValue = callback(previousValue, currentProperties, featureIndex);
  });
  return previousValue;
}
function featureEach$3(geojson, callback) {
  if (geojson.type === "Feature") {
    callback(geojson, 0);
  } else if (geojson.type === "FeatureCollection") {
    for (var i2 = 0; i2 < geojson.features.length; i2++) {
      if (callback(geojson.features[i2], i2) === false)
        break;
    }
  }
}
function featureReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  featureEach$3(geojson, function(currentFeature, featureIndex) {
    if (featureIndex === 0 && initialValue === void 0)
      previousValue = currentFeature;
    else
      previousValue = callback(previousValue, currentFeature, featureIndex);
  });
  return previousValue;
}
function coordAll(geojson) {
  var coords = [];
  coordEach(geojson, function(coord) {
    coords.push(coord);
  });
  return coords;
}
function geomEach$3(geojson, callback) {
  var i2, j2, g2, geometry2, stopG, geometryMaybeCollection, isGeometryCollection2, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature2 = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i2 = 0; i2 < stop; i2++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[i2].geometry : isFeature2 ? geojson.geometry : geojson;
    featureProperties = isFeatureCollection ? geojson.features[i2].properties : isFeature2 ? geojson.properties : {};
    featureBBox = isFeatureCollection ? geojson.features[i2].bbox : isFeature2 ? geojson.bbox : void 0;
    featureId = isFeatureCollection ? geojson.features[i2].id : isFeature2 ? geojson.id : void 0;
    isGeometryCollection2 = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection2 ? geometryMaybeCollection.geometries.length : 1;
    for (g2 = 0; g2 < stopG; g2++) {
      geometry2 = isGeometryCollection2 ? geometryMaybeCollection.geometries[g2] : geometryMaybeCollection;
      if (geometry2 === null) {
        if (callback(
          null,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        ) === false)
          return false;
        continue;
      }
      switch (geometry2.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (callback(
            geometry2,
            featureIndex,
            featureProperties,
            featureBBox,
            featureId
          ) === false)
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j2 = 0; j2 < geometry2.geometries.length; j2++) {
            if (callback(
              geometry2.geometries[j2],
              featureIndex,
              featureProperties,
              featureBBox,
              featureId
            ) === false)
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function geomReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  geomEach$3(
    geojson,
    function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
      if (featureIndex === 0 && initialValue === void 0)
        previousValue = currentGeometry;
      else
        previousValue = callback(
          previousValue,
          currentGeometry,
          featureIndex,
          featureProperties,
          featureBBox,
          featureId
        );
    }
  );
  return previousValue;
}
function flattenEach$3(geojson, callback) {
  geomEach$3(geojson, function(geometry2, featureIndex, properties, bbox2, id) {
    var type = geometry2 === null ? null : geometry2.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (callback(
          feature$a(geometry2, properties, { bbox: bbox2, id }),
          featureIndex,
          0
        ) === false)
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (var multiFeatureIndex = 0; multiFeatureIndex < geometry2.coordinates.length; multiFeatureIndex++) {
      var coordinate2 = geometry2.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate2
      };
      if (callback(feature$a(geom, properties), featureIndex, multiFeatureIndex) === false)
        return false;
    }
  });
}
function flattenReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  flattenEach$3(
    geojson,
    function(currentFeature, featureIndex, multiFeatureIndex) {
      if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0)
        previousValue = currentFeature;
      else
        previousValue = callback(
          previousValue,
          currentFeature,
          featureIndex,
          multiFeatureIndex
        );
    }
  );
  return previousValue;
}
function segmentEach(geojson, callback) {
  flattenEach$3(geojson, function(feature2, featureIndex, multiFeatureIndex) {
    var segmentIndex = 0;
    if (!feature2.geometry)
      return;
    var type = feature2.geometry.type;
    if (type === "Point" || type === "MultiPoint")
      return;
    var previousCoords;
    var previousFeatureIndex = 0;
    var previousMultiIndex = 0;
    var prevGeomIndex = 0;
    if (coordEach(
      feature2,
      function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
        if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
          previousCoords = currentCoord;
          previousFeatureIndex = featureIndex;
          previousMultiIndex = multiPartIndexCoord;
          prevGeomIndex = geometryIndex;
          segmentIndex = 0;
          return;
        }
        var currentSegment = lineString$5(
          [previousCoords, currentCoord],
          feature2.properties
        );
        if (callback(
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        ) === false)
          return false;
        segmentIndex++;
        previousCoords = currentCoord;
      }
    ) === false)
      return false;
  });
}
function segmentReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  var started = false;
  segmentEach(
    geojson,
    function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
      if (started === false && initialValue === void 0)
        previousValue = currentSegment;
      else
        previousValue = callback(
          previousValue,
          currentSegment,
          featureIndex,
          multiFeatureIndex,
          geometryIndex,
          segmentIndex
        );
      started = true;
    }
  );
  return previousValue;
}
function lineEach(geojson, callback) {
  if (!geojson)
    throw new Error("geojson is required");
  flattenEach$3(geojson, function(feature2, featureIndex, multiFeatureIndex) {
    if (feature2.geometry === null)
      return;
    var type = feature2.geometry.type;
    var coords = feature2.geometry.coordinates;
    switch (type) {
      case "LineString":
        if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false)
          return false;
        break;
      case "Polygon":
        for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
          if (callback(
            lineString$5(coords[geometryIndex], feature2.properties),
            featureIndex,
            multiFeatureIndex,
            geometryIndex
          ) === false)
            return false;
        }
        break;
    }
  });
}
function lineReduce(geojson, callback, initialValue) {
  var previousValue = initialValue;
  lineEach(
    geojson,
    function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
      if (featureIndex === 0 && initialValue === void 0)
        previousValue = currentLine;
      else
        previousValue = callback(
          previousValue,
          currentLine,
          featureIndex,
          multiFeatureIndex,
          geometryIndex
        );
    }
  );
  return previousValue;
}
function findSegment(geojson, options2) {
  options2 = options2 || {};
  if (!isObject$k(options2))
    throw new Error("options is invalid");
  var featureIndex = options2.featureIndex || 0;
  var multiFeatureIndex = options2.multiFeatureIndex || 0;
  var geometryIndex = options2.geometryIndex || 0;
  var segmentIndex = options2.segmentIndex || 0;
  var properties = options2.properties;
  var geometry2;
  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry2 = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry2 = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry2 = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (geometry2 === null)
    return null;
  var coords = geometry2.coordinates;
  switch (geometry2.type) {
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
      if (segmentIndex < 0)
        segmentIndex = coords.length + segmentIndex - 1;
      return lineString$5(
        [coords[segmentIndex], coords[segmentIndex + 1]],
        properties,
        options2
      );
    case "Polygon":
      if (geometryIndex < 0)
        geometryIndex = coords.length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
      return lineString$5(
        [
          coords[geometryIndex][segmentIndex],
          coords[geometryIndex][segmentIndex + 1]
        ],
        properties,
        options2
      );
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
      return lineString$5(
        [
          coords[multiFeatureIndex][segmentIndex],
          coords[multiFeatureIndex][segmentIndex + 1]
        ],
        properties,
        options2
      );
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (segmentIndex < 0)
        segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
      return lineString$5(
        [
          coords[multiFeatureIndex][geometryIndex][segmentIndex],
          coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
        ],
        properties,
        options2
      );
  }
  throw new Error("geojson is invalid");
}
function findPoint(geojson, options2) {
  options2 = options2 || {};
  if (!isObject$k(options2))
    throw new Error("options is invalid");
  var featureIndex = options2.featureIndex || 0;
  var multiFeatureIndex = options2.multiFeatureIndex || 0;
  var geometryIndex = options2.geometryIndex || 0;
  var coordIndex = options2.coordIndex || 0;
  var properties = options2.properties;
  var geometry2;
  switch (geojson.type) {
    case "FeatureCollection":
      if (featureIndex < 0)
        featureIndex = geojson.features.length + featureIndex;
      properties = properties || geojson.features[featureIndex].properties;
      geometry2 = geojson.features[featureIndex].geometry;
      break;
    case "Feature":
      properties = properties || geojson.properties;
      geometry2 = geojson.geometry;
      break;
    case "Point":
    case "MultiPoint":
      return null;
    case "LineString":
    case "Polygon":
    case "MultiLineString":
    case "MultiPolygon":
      geometry2 = geojson;
      break;
    default:
      throw new Error("geojson is invalid");
  }
  if (geometry2 === null)
    return null;
  var coords = geometry2.coordinates;
  switch (geometry2.type) {
    case "Point":
      return point$5(coords, properties, options2);
    case "MultiPoint":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      return point$5(coords[multiFeatureIndex], properties, options2);
    case "LineString":
      if (coordIndex < 0)
        coordIndex = coords.length + coordIndex;
      return point$5(coords[coordIndex], properties, options2);
    case "Polygon":
      if (geometryIndex < 0)
        geometryIndex = coords.length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[geometryIndex].length + coordIndex;
      return point$5(coords[geometryIndex][coordIndex], properties, options2);
    case "MultiLineString":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex].length + coordIndex;
      return point$5(coords[multiFeatureIndex][coordIndex], properties, options2);
    case "MultiPolygon":
      if (multiFeatureIndex < 0)
        multiFeatureIndex = coords.length + multiFeatureIndex;
      if (geometryIndex < 0)
        geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
      if (coordIndex < 0)
        coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
      return point$5(
        coords[multiFeatureIndex][geometryIndex][coordIndex],
        properties,
        options2
      );
  }
  throw new Error("geojson is invalid");
}
const es$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  coordAll,
  coordEach,
  coordReduce,
  featureEach: featureEach$3,
  featureReduce,
  findPoint,
  findSegment,
  flattenEach: flattenEach$3,
  flattenReduce,
  geomEach: geomEach$3,
  geomReduce,
  lineEach,
  lineReduce,
  propEach,
  propReduce,
  segmentEach,
  segmentReduce
}, Symbol.toStringTag, { value: "Module" }));
function bbox$3(geojson) {
  var result = [Infinity, Infinity, -Infinity, -Infinity];
  coordEach(geojson, function(coord) {
    if (result[0] > coord[0]) {
      result[0] = coord[0];
    }
    if (result[1] > coord[1]) {
      result[1] = coord[1];
    }
    if (result[2] < coord[0]) {
      result[2] = coord[0];
    }
    if (result[3] < coord[1]) {
      result[3] = coord[1];
    }
  });
  return result;
}
bbox$3["default"] = bbox$3;
const es$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: bbox$3
}, Symbol.toStringTag, { value: "Module" }));
function getCoord$5(coord) {
  if (!coord) {
    throw new Error("coord is required");
  }
  if (!Array.isArray(coord)) {
    if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point") {
      return coord.geometry.coordinates;
    }
    if (coord.type === "Point") {
      return coord.coordinates;
    }
  }
  if (Array.isArray(coord) && coord.length >= 2 && !Array.isArray(coord[0]) && !Array.isArray(coord[1])) {
    return coord;
  }
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords$6(coords) {
  if (Array.isArray(coords)) {
    return coords;
  }
  if (coords.type === "Feature") {
    if (coords.geometry !== null) {
      return coords.geometry.coordinates;
    }
  } else {
    if (coords.coordinates) {
      return coords.coordinates;
    }
  }
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function containsNumber$1(coordinates2) {
  if (coordinates2.length > 1 && isNumber$a(coordinates2[0]) && isNumber$a(coordinates2[1])) {
    return true;
  }
  if (Array.isArray(coordinates2[0]) && coordinates2[0].length) {
    return containsNumber$1(coordinates2[0]);
  }
  throw new Error("coordinates must only contain numbers");
}
function geojsonType(value, type, name2) {
  if (!type || !name2) {
    throw new Error("type and name required");
  }
  if (!value || value.type !== type) {
    throw new Error("Invalid input to " + name2 + ": must be a " + type + ", given " + value.type);
  }
}
function featureOf(feature2, type, name2) {
  if (!feature2) {
    throw new Error("No feature passed");
  }
  if (!name2) {
    throw new Error(".featureOf() requires a name");
  }
  if (!feature2 || feature2.type !== "Feature" || !feature2.geometry) {
    throw new Error("Invalid input to " + name2 + ", Feature with geometry required");
  }
  if (!feature2.geometry || feature2.geometry.type !== type) {
    throw new Error("Invalid input to " + name2 + ": must be a " + type + ", given " + feature2.geometry.type);
  }
}
function collectionOf(featureCollection2, type, name2) {
  if (!featureCollection2) {
    throw new Error("No featureCollection passed");
  }
  if (!name2) {
    throw new Error(".collectionOf() requires a name");
  }
  if (!featureCollection2 || featureCollection2.type !== "FeatureCollection") {
    throw new Error("Invalid input to " + name2 + ", FeatureCollection required");
  }
  for (var _i = 0, _a3 = featureCollection2.features; _i < _a3.length; _i++) {
    var feature2 = _a3[_i];
    if (!feature2 || feature2.type !== "Feature" || !feature2.geometry) {
      throw new Error("Invalid input to " + name2 + ", Feature with geometry required");
    }
    if (!feature2.geometry || feature2.geometry.type !== type) {
      throw new Error("Invalid input to " + name2 + ": must be a " + type + ", given " + feature2.geometry.type);
    }
  }
}
function getGeom(geojson) {
  if (geojson.type === "Feature") {
    return geojson.geometry;
  }
  return geojson;
}
function getType$2(geojson, _name) {
  if (geojson.type === "FeatureCollection") {
    return "FeatureCollection";
  }
  if (geojson.type === "GeometryCollection") {
    return "GeometryCollection";
  }
  if (geojson.type === "Feature" && geojson.geometry !== null) {
    return geojson.geometry.type;
  }
  return geojson.type;
}
const es$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  collectionOf,
  containsNumber: containsNumber$1,
  featureOf,
  geojsonType,
  getCoord: getCoord$5,
  getCoords: getCoords$6,
  getGeom,
  getType: getType$2
}, Symbol.toStringTag, { value: "Module" }));
function booleanPointInPolygon$2(point4, polygon4, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (!point4) {
    throw new Error("point is required");
  }
  if (!polygon4) {
    throw new Error("polygon is required");
  }
  var pt = getCoord$5(point4);
  var geom = getGeom(polygon4);
  var type = geom.type;
  var bbox2 = polygon4.bbox;
  var polys = geom.coordinates;
  if (bbox2 && inBBox$2(pt, bbox2) === false) {
    return false;
  }
  if (type === "Polygon") {
    polys = [polys];
  }
  var insidePoly = false;
  for (var i2 = 0; i2 < polys.length && !insidePoly; i2++) {
    if (inRing$2(pt, polys[i2][0], options2.ignoreBoundary)) {
      var inHole = false;
      var k2 = 1;
      while (k2 < polys[i2].length && !inHole) {
        if (inRing$2(pt, polys[i2][k2], !options2.ignoreBoundary)) {
          inHole = true;
        }
        k2++;
      }
      if (!inHole) {
        insidePoly = true;
      }
    }
  }
  return insidePoly;
}
function inRing$2(pt, ring, ignoreBoundary) {
  var isInside = false;
  if (ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1]) {
    ring = ring.slice(0, ring.length - 1);
  }
  for (var i2 = 0, j2 = ring.length - 1; i2 < ring.length; j2 = i2++) {
    var xi = ring[i2][0];
    var yi = ring[i2][1];
    var xj = ring[j2][0];
    var yj = ring[j2][1];
    var onBoundary = pt[1] * (xi - xj) + yi * (xj - pt[0]) + yj * (pt[0] - xi) === 0 && (xi - pt[0]) * (xj - pt[0]) <= 0 && (yi - pt[1]) * (yj - pt[1]) <= 0;
    if (onBoundary) {
      return !ignoreBoundary;
    }
    var intersect2 = yi > pt[1] !== yj > pt[1] && pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi;
    if (intersect2) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function inBBox$2(pt, bbox2) {
  return bbox2[0] <= pt[0] && bbox2[1] <= pt[1] && bbox2[2] >= pt[0] && bbox2[3] >= pt[1];
}
function distance$5(from, to, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var coordinates1 = getCoord$5(from);
  var coordinates2 = getCoord$5(to);
  var dLat = degreesToRadians$4(coordinates2[1] - coordinates1[1]);
  var dLon = degreesToRadians$4(coordinates2[0] - coordinates1[0]);
  var lat1 = degreesToRadians$4(coordinates1[1]);
  var lat2 = degreesToRadians$4(coordinates2[1]);
  var a2 = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
  return radiansToLength$3(2 * Math.atan2(Math.sqrt(a2), Math.sqrt(1 - a2)), options2.units);
}
const es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: distance$5
}, Symbol.toStringTag, { value: "Module" }));
function destination$3(origin, distance11, bearing2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var coordinates1 = getCoord$5(origin);
  var longitude1 = degreesToRadians$4(coordinates1[0]);
  var latitude1 = degreesToRadians$4(coordinates1[1]);
  var bearingRad = degreesToRadians$4(bearing2);
  var radians2 = lengthToRadians$2(distance11, options2.units);
  var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians2) + Math.cos(latitude1) * Math.sin(radians2) * Math.cos(bearingRad));
  var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians2) * Math.cos(latitude1), Math.cos(radians2) - Math.sin(latitude1) * Math.sin(latitude2));
  var lng = radiansToDegrees$4(longitude2);
  var lat = radiansToDegrees$4(latitude2);
  return point$5([lng, lat], options2.properties);
}
function circle$4(center2, radius, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var steps = options2.steps || 64;
  var properties = options2.properties ? options2.properties : !Array.isArray(center2) && center2.type === "Feature" && center2.properties ? center2.properties : {};
  var coordinates2 = [];
  for (var i2 = 0; i2 < steps; i2++) {
    coordinates2.push(destination$3(center2, radius, i2 * -360 / steps, options2).geometry.coordinates);
  }
  coordinates2.push(coordinates2[0]);
  return polygon$3([coordinates2], properties);
}
function bearing$2(start2, end, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (options2.final === true) {
    return calculateFinalBearing$2(start2, end);
  }
  var coordinates1 = getCoord$5(start2);
  var coordinates2 = getCoord$5(end);
  var lon1 = degreesToRadians$4(coordinates1[0]);
  var lon2 = degreesToRadians$4(coordinates2[0]);
  var lat1 = degreesToRadians$4(coordinates1[1]);
  var lat2 = degreesToRadians$4(coordinates2[1]);
  var a2 = Math.sin(lon2 - lon1) * Math.cos(lat2);
  var b2 = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
  return radiansToDegrees$4(Math.atan2(a2, b2));
}
function calculateFinalBearing$2(start2, end) {
  var bear = bearing$2(end, start2);
  bear = (bear + 180) % 360;
  return bear;
}
function destination$2(origin, distance11, bearing2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var coordinates1 = getCoord$5(origin);
  var longitude1 = degreesToRadians$4(coordinates1[0]);
  var latitude1 = degreesToRadians$4(coordinates1[1]);
  var bearingRad = degreesToRadians$4(bearing2);
  var radians2 = lengthToRadians$2(distance11, options2.units);
  var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians2) + Math.cos(latitude1) * Math.sin(radians2) * Math.cos(bearingRad));
  var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians2) * Math.cos(latitude1), Math.cos(radians2) - Math.sin(latitude1) * Math.sin(latitude2));
  var lng = radiansToDegrees$4(longitude2);
  var lat = radiansToDegrees$4(latitude2);
  return point$5([lng, lat], options2.properties);
}
function midpoint$1(point1, point22) {
  var dist2 = distance$5(point1, point22);
  var heading = bearing$2(point1, point22);
  var midpoint2 = destination$2(point1, dist2 / 2, heading);
  return midpoint2;
}
function centroid(geojson, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var xSum = 0;
  var ySum = 0;
  var len2 = 0;
  coordEach(geojson, function(coord) {
    xSum += coord[0];
    ySum += coord[1];
    len2++;
  }, true);
  return point$5([xSum / len2, ySum / len2], options2.properties);
}
var earcutExports = {};
var earcut$2 = {
  get exports() {
    return earcutExports;
  },
  set exports(v5) {
    earcutExports = v5;
  }
};
earcut$2.exports = earcut$1;
earcutExports.default = earcut$1;
function earcut$1(data2, holeIndices, dim) {
  dim = dim || 2;
  var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data2.length, outerNode = linkedList$2(data2, 0, outerLen, dim, true), triangles = [];
  if (!outerNode || outerNode.next === outerNode.prev)
    return triangles;
  var minX2, minY2, maxX2, maxY2, x2, y2, invSize;
  if (hasHoles)
    outerNode = eliminateHoles$2(data2, holeIndices, outerNode, dim);
  if (data2.length > 80 * dim) {
    minX2 = maxX2 = data2[0];
    minY2 = maxY2 = data2[1];
    for (var i2 = dim; i2 < outerLen; i2 += dim) {
      x2 = data2[i2];
      y2 = data2[i2 + 1];
      if (x2 < minX2)
        minX2 = x2;
      if (y2 < minY2)
        minY2 = y2;
      if (x2 > maxX2)
        maxX2 = x2;
      if (y2 > maxY2)
        maxY2 = y2;
    }
    invSize = Math.max(maxX2 - minX2, maxY2 - minY2);
    invSize = invSize !== 0 ? 32767 / invSize : 0;
  }
  earcutLinked$2(outerNode, triangles, dim, minX2, minY2, invSize, 0);
  return triangles;
}
function linkedList$2(data2, start2, end, dim, clockwise) {
  var i2, last;
  if (clockwise === signedArea$2(data2, start2, end, dim) > 0) {
    for (i2 = start2; i2 < end; i2 += dim)
      last = insertNode$2(i2, data2[i2], data2[i2 + 1], last);
  } else {
    for (i2 = end - dim; i2 >= start2; i2 -= dim)
      last = insertNode$2(i2, data2[i2], data2[i2 + 1], last);
  }
  if (last && equals$3(last, last.next)) {
    removeNode$2(last);
    last = last.next;
  }
  return last;
}
function filterPoints$2(start2, end) {
  if (!start2)
    return start2;
  if (!end)
    end = start2;
  var p2 = start2, again;
  do {
    again = false;
    if (!p2.steiner && (equals$3(p2, p2.next) || area$4(p2.prev, p2, p2.next) === 0)) {
      removeNode$2(p2);
      p2 = end = p2.prev;
      if (p2 === p2.next)
        break;
      again = true;
    } else {
      p2 = p2.next;
    }
  } while (again || p2 !== end);
  return end;
}
function earcutLinked$2(ear, triangles, dim, minX2, minY2, invSize, pass2) {
  if (!ear)
    return;
  if (!pass2 && invSize)
    indexCurve$2(ear, minX2, minY2, invSize);
  var stop = ear, prev, next5;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next5 = ear.next;
    if (invSize ? isEarHashed$2(ear, minX2, minY2, invSize) : isEar$2(ear)) {
      triangles.push(prev.i / dim | 0);
      triangles.push(ear.i / dim | 0);
      triangles.push(next5.i / dim | 0);
      removeNode$2(ear);
      ear = next5.next;
      stop = next5.next;
      continue;
    }
    ear = next5;
    if (ear === stop) {
      if (!pass2) {
        earcutLinked$2(filterPoints$2(ear), triangles, dim, minX2, minY2, invSize, 1);
      } else if (pass2 === 1) {
        ear = cureLocalIntersections$2(filterPoints$2(ear), triangles, dim);
        earcutLinked$2(ear, triangles, dim, minX2, minY2, invSize, 2);
      } else if (pass2 === 2) {
        splitEarcut$2(ear, triangles, dim, minX2, minY2, invSize);
      }
      break;
    }
  }
}
function isEar$2(ear) {
  var a2 = ear.prev, b2 = ear, c2 = ear.next;
  if (area$4(a2, b2, c2) >= 0)
    return false;
  var ax2 = a2.x, bx2 = b2.x, cx = c2.x, ay2 = a2.y, by2 = b2.y, cy = c2.y;
  var x02 = ax2 < bx2 ? ax2 < cx ? ax2 : cx : bx2 < cx ? bx2 : cx, y02 = ay2 < by2 ? ay2 < cy ? ay2 : cy : by2 < cy ? by2 : cy, x12 = ax2 > bx2 ? ax2 > cx ? ax2 : cx : bx2 > cx ? bx2 : cx, y12 = ay2 > by2 ? ay2 > cy ? ay2 : cy : by2 > cy ? by2 : cy;
  var p2 = c2.next;
  while (p2 !== a2) {
    if (p2.x >= x02 && p2.x <= x12 && p2.y >= y02 && p2.y <= y12 && pointInTriangle$2(ax2, ay2, bx2, by2, cx, cy, p2.x, p2.y) && area$4(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.next;
  }
  return true;
}
function isEarHashed$2(ear, minX2, minY2, invSize) {
  var a2 = ear.prev, b2 = ear, c2 = ear.next;
  if (area$4(a2, b2, c2) >= 0)
    return false;
  var ax2 = a2.x, bx2 = b2.x, cx = c2.x, ay2 = a2.y, by2 = b2.y, cy = c2.y;
  var x02 = ax2 < bx2 ? ax2 < cx ? ax2 : cx : bx2 < cx ? bx2 : cx, y02 = ay2 < by2 ? ay2 < cy ? ay2 : cy : by2 < cy ? by2 : cy, x12 = ax2 > bx2 ? ax2 > cx ? ax2 : cx : bx2 > cx ? bx2 : cx, y12 = ay2 > by2 ? ay2 > cy ? ay2 : cy : by2 > cy ? by2 : cy;
  var minZ = zOrder$2(x02, y02, minX2, minY2, invSize), maxZ = zOrder$2(x12, y12, minX2, minY2, invSize);
  var p2 = ear.prevZ, n2 = ear.nextZ;
  while (p2 && p2.z >= minZ && n2 && n2.z <= maxZ) {
    if (p2.x >= x02 && p2.x <= x12 && p2.y >= y02 && p2.y <= y12 && p2 !== a2 && p2 !== c2 && pointInTriangle$2(ax2, ay2, bx2, by2, cx, cy, p2.x, p2.y) && area$4(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
    if (n2.x >= x02 && n2.x <= x12 && n2.y >= y02 && n2.y <= y12 && n2 !== a2 && n2 !== c2 && pointInTriangle$2(ax2, ay2, bx2, by2, cx, cy, n2.x, n2.y) && area$4(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  while (p2 && p2.z >= minZ) {
    if (p2.x >= x02 && p2.x <= x12 && p2.y >= y02 && p2.y <= y12 && p2 !== a2 && p2 !== c2 && pointInTriangle$2(ax2, ay2, bx2, by2, cx, cy, p2.x, p2.y) && area$4(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
  }
  while (n2 && n2.z <= maxZ) {
    if (n2.x >= x02 && n2.x <= x12 && n2.y >= y02 && n2.y <= y12 && n2 !== a2 && n2 !== c2 && pointInTriangle$2(ax2, ay2, bx2, by2, cx, cy, n2.x, n2.y) && area$4(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  return true;
}
function cureLocalIntersections$2(start2, triangles, dim) {
  var p2 = start2;
  do {
    var a2 = p2.prev, b2 = p2.next.next;
    if (!equals$3(a2, b2) && intersects$6(a2, p2, p2.next, b2) && locallyInside$2(a2, b2) && locallyInside$2(b2, a2)) {
      triangles.push(a2.i / dim | 0);
      triangles.push(p2.i / dim | 0);
      triangles.push(b2.i / dim | 0);
      removeNode$2(p2);
      removeNode$2(p2.next);
      p2 = start2 = b2;
    }
    p2 = p2.next;
  } while (p2 !== start2);
  return filterPoints$2(p2);
}
function splitEarcut$2(start2, triangles, dim, minX2, minY2, invSize) {
  var a2 = start2;
  do {
    var b2 = a2.next.next;
    while (b2 !== a2.prev) {
      if (a2.i !== b2.i && isValidDiagonal$2(a2, b2)) {
        var c2 = splitPolygon$2(a2, b2);
        a2 = filterPoints$2(a2, a2.next);
        c2 = filterPoints$2(c2, c2.next);
        earcutLinked$2(a2, triangles, dim, minX2, minY2, invSize, 0);
        earcutLinked$2(c2, triangles, dim, minX2, minY2, invSize, 0);
        return;
      }
      b2 = b2.next;
    }
    a2 = a2.next;
  } while (a2 !== start2);
}
function eliminateHoles$2(data2, holeIndices, outerNode, dim) {
  var queue = [], i2, len2, start2, end, list2;
  for (i2 = 0, len2 = holeIndices.length; i2 < len2; i2++) {
    start2 = holeIndices[i2] * dim;
    end = i2 < len2 - 1 ? holeIndices[i2 + 1] * dim : data2.length;
    list2 = linkedList$2(data2, start2, end, dim, false);
    if (list2 === list2.next)
      list2.steiner = true;
    queue.push(getLeftmost$2(list2));
  }
  queue.sort(compareX$2);
  for (i2 = 0; i2 < queue.length; i2++) {
    outerNode = eliminateHole$2(queue[i2], outerNode);
  }
  return outerNode;
}
function compareX$2(a2, b2) {
  return a2.x - b2.x;
}
function eliminateHole$2(hole, outerNode) {
  var bridge = findHoleBridge$2(hole, outerNode);
  if (!bridge) {
    return outerNode;
  }
  var bridgeReverse = splitPolygon$2(bridge, hole);
  filterPoints$2(bridgeReverse, bridgeReverse.next);
  return filterPoints$2(bridge, bridge.next);
}
function findHoleBridge$2(hole, outerNode) {
  var p2 = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m2;
  do {
    if (hy <= p2.y && hy >= p2.next.y && p2.next.y !== p2.y) {
      var x2 = p2.x + (hy - p2.y) * (p2.next.x - p2.x) / (p2.next.y - p2.y);
      if (x2 <= hx && x2 > qx) {
        qx = x2;
        m2 = p2.x < p2.next.x ? p2 : p2.next;
        if (x2 === hx)
          return m2;
      }
    }
    p2 = p2.next;
  } while (p2 !== outerNode);
  if (!m2)
    return null;
  var stop = m2, mx = m2.x, my = m2.y, tanMin = Infinity, tan;
  p2 = m2;
  do {
    if (hx >= p2.x && p2.x >= mx && hx !== p2.x && pointInTriangle$2(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p2.x, p2.y)) {
      tan = Math.abs(hy - p2.y) / (hx - p2.x);
      if (locallyInside$2(p2, hole) && (tan < tanMin || tan === tanMin && (p2.x > m2.x || p2.x === m2.x && sectorContainsSector$2(m2, p2)))) {
        m2 = p2;
        tanMin = tan;
      }
    }
    p2 = p2.next;
  } while (p2 !== stop);
  return m2;
}
function sectorContainsSector$2(m2, p2) {
  return area$4(m2.prev, m2, p2.prev) < 0 && area$4(p2.next, m2, m2.next) < 0;
}
function indexCurve$2(start2, minX2, minY2, invSize) {
  var p2 = start2;
  do {
    if (p2.z === 0)
      p2.z = zOrder$2(p2.x, p2.y, minX2, minY2, invSize);
    p2.prevZ = p2.prev;
    p2.nextZ = p2.next;
    p2 = p2.next;
  } while (p2 !== start2);
  p2.prevZ.nextZ = null;
  p2.prevZ = null;
  sortLinked$2(p2);
}
function sortLinked$2(list2) {
  var i2, p2, q2, e3, tail, numMerges, pSize, qSize, inSize = 1;
  do {
    p2 = list2;
    list2 = null;
    tail = null;
    numMerges = 0;
    while (p2) {
      numMerges++;
      q2 = p2;
      pSize = 0;
      for (i2 = 0; i2 < inSize; i2++) {
        pSize++;
        q2 = q2.nextZ;
        if (!q2)
          break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q2) {
        if (pSize !== 0 && (qSize === 0 || !q2 || p2.z <= q2.z)) {
          e3 = p2;
          p2 = p2.nextZ;
          pSize--;
        } else {
          e3 = q2;
          q2 = q2.nextZ;
          qSize--;
        }
        if (tail)
          tail.nextZ = e3;
        else
          list2 = e3;
        e3.prevZ = tail;
        tail = e3;
      }
      p2 = q2;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list2;
}
function zOrder$2(x2, y2, minX2, minY2, invSize) {
  x2 = (x2 - minX2) * invSize | 0;
  y2 = (y2 - minY2) * invSize | 0;
  x2 = (x2 | x2 << 8) & 16711935;
  x2 = (x2 | x2 << 4) & 252645135;
  x2 = (x2 | x2 << 2) & 858993459;
  x2 = (x2 | x2 << 1) & 1431655765;
  y2 = (y2 | y2 << 8) & 16711935;
  y2 = (y2 | y2 << 4) & 252645135;
  y2 = (y2 | y2 << 2) & 858993459;
  y2 = (y2 | y2 << 1) & 1431655765;
  return x2 | y2 << 1;
}
function getLeftmost$2(start2) {
  var p2 = start2, leftmost = start2;
  do {
    if (p2.x < leftmost.x || p2.x === leftmost.x && p2.y < leftmost.y)
      leftmost = p2;
    p2 = p2.next;
  } while (p2 !== start2);
  return leftmost;
}
function pointInTriangle$2(ax2, ay2, bx2, by2, cx, cy, px2, py2) {
  return (cx - px2) * (ay2 - py2) >= (ax2 - px2) * (cy - py2) && (ax2 - px2) * (by2 - py2) >= (bx2 - px2) * (ay2 - py2) && (bx2 - px2) * (cy - py2) >= (cx - px2) * (by2 - py2);
}
function isValidDiagonal$2(a2, b2) {
  return a2.next.i !== b2.i && a2.prev.i !== b2.i && !intersectsPolygon$2(a2, b2) && // dones't intersect other edges
  (locallyInside$2(a2, b2) && locallyInside$2(b2, a2) && middleInside$2(a2, b2) && // locally visible
  (area$4(a2.prev, a2, b2.prev) || area$4(a2, b2.prev, b2)) || // does not create opposite-facing sectors
  equals$3(a2, b2) && area$4(a2.prev, a2, a2.next) > 0 && area$4(b2.prev, b2, b2.next) > 0);
}
function area$4(p2, q2, r2) {
  return (q2.y - p2.y) * (r2.x - q2.x) - (q2.x - p2.x) * (r2.y - q2.y);
}
function equals$3(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function intersects$6(p1, q1, p2, q2) {
  var o1 = sign$3(area$4(p1, q1, p2));
  var o2 = sign$3(area$4(p1, q1, q2));
  var o3 = sign$3(area$4(p2, q2, p1));
  var o4 = sign$3(area$4(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4)
    return true;
  if (o1 === 0 && onSegment$2(p1, p2, q1))
    return true;
  if (o2 === 0 && onSegment$2(p1, q2, q1))
    return true;
  if (o3 === 0 && onSegment$2(p2, p1, q2))
    return true;
  if (o4 === 0 && onSegment$2(p2, q1, q2))
    return true;
  return false;
}
function onSegment$2(p2, q2, r2) {
  return q2.x <= Math.max(p2.x, r2.x) && q2.x >= Math.min(p2.x, r2.x) && q2.y <= Math.max(p2.y, r2.y) && q2.y >= Math.min(p2.y, r2.y);
}
function sign$3(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon$2(a2, b2) {
  var p2 = a2;
  do {
    if (p2.i !== a2.i && p2.next.i !== a2.i && p2.i !== b2.i && p2.next.i !== b2.i && intersects$6(p2, p2.next, a2, b2))
      return true;
    p2 = p2.next;
  } while (p2 !== a2);
  return false;
}
function locallyInside$2(a2, b2) {
  return area$4(a2.prev, a2, a2.next) < 0 ? area$4(a2, b2, a2.next) >= 0 && area$4(a2, a2.prev, b2) >= 0 : area$4(a2, b2, a2.prev) < 0 || area$4(a2, a2.next, b2) < 0;
}
function middleInside$2(a2, b2) {
  var p2 = a2, inside = false, px2 = (a2.x + b2.x) / 2, py2 = (a2.y + b2.y) / 2;
  do {
    if (p2.y > py2 !== p2.next.y > py2 && p2.next.y !== p2.y && px2 < (p2.next.x - p2.x) * (py2 - p2.y) / (p2.next.y - p2.y) + p2.x)
      inside = !inside;
    p2 = p2.next;
  } while (p2 !== a2);
  return inside;
}
function splitPolygon$2(a2, b2) {
  var a22 = new Node$3(a2.i, a2.x, a2.y), b22 = new Node$3(b2.i, b2.x, b2.y), an2 = a2.next, bp2 = b2.prev;
  a2.next = b2;
  b2.prev = a2;
  a22.next = an2;
  an2.prev = a22;
  b22.next = a22;
  a22.prev = b22;
  bp2.next = b22;
  b22.prev = bp2;
  return b22;
}
function insertNode$2(i2, x2, y2, last) {
  var p2 = new Node$3(i2, x2, y2);
  if (!last) {
    p2.prev = p2;
    p2.next = p2;
  } else {
    p2.next = last.next;
    p2.prev = last;
    last.next.prev = p2;
    last.next = p2;
  }
  return p2;
}
function removeNode$2(p2) {
  p2.next.prev = p2.prev;
  p2.prev.next = p2.next;
  if (p2.prevZ)
    p2.prevZ.nextZ = p2.nextZ;
  if (p2.nextZ)
    p2.nextZ.prevZ = p2.prevZ;
}
function Node$3(i2, x2, y2) {
  this.i = i2;
  this.x = x2;
  this.y = y2;
  this.prev = null;
  this.next = null;
  this.z = 0;
  this.prevZ = null;
  this.nextZ = null;
  this.steiner = false;
}
earcut$1.deviation = function(data2, holeIndices, dim, triangles) {
  var hasHoles = holeIndices && holeIndices.length;
  var outerLen = hasHoles ? holeIndices[0] * dim : data2.length;
  var polygonArea2 = Math.abs(signedArea$2(data2, 0, outerLen, dim));
  if (hasHoles) {
    for (var i2 = 0, len2 = holeIndices.length; i2 < len2; i2++) {
      var start2 = holeIndices[i2] * dim;
      var end = i2 < len2 - 1 ? holeIndices[i2 + 1] * dim : data2.length;
      polygonArea2 -= Math.abs(signedArea$2(data2, start2, end, dim));
    }
  }
  var trianglesArea = 0;
  for (i2 = 0; i2 < triangles.length; i2 += 3) {
    var a2 = triangles[i2] * dim;
    var b2 = triangles[i2 + 1] * dim;
    var c2 = triangles[i2 + 2] * dim;
    trianglesArea += Math.abs(
      (data2[a2] - data2[c2]) * (data2[b2 + 1] - data2[a2 + 1]) - (data2[a2] - data2[b2]) * (data2[c2 + 1] - data2[a2 + 1])
    );
  }
  return polygonArea2 === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea2) / polygonArea2);
};
function signedArea$2(data2, start2, end, dim) {
  var sum2 = 0;
  for (var i2 = start2, j2 = end - dim; i2 < end; i2 += dim) {
    sum2 += (data2[j2] - data2[i2]) * (data2[i2 + 1] + data2[j2 + 1]);
    j2 = i2;
  }
  return sum2;
}
earcut$1.flatten = function(data2) {
  var dim = data2[0][0].length, result = { vertices: [], holes: [], dimensions: dim }, holeIndex = 0;
  for (var i2 = 0; i2 < data2.length; i2++) {
    for (var j2 = 0; j2 < data2[i2].length; j2++) {
      for (var d2 = 0; d2 < dim; d2++)
        result.vertices.push(data2[i2][j2][d2]);
    }
    if (i2 > 0) {
      holeIndex += data2[i2 - 1].length;
      result.holes.push(holeIndex);
    }
  }
  return result;
};
function lineSegment$2(geojson) {
  if (!geojson) {
    throw new Error("geojson is required");
  }
  var results = [];
  flattenEach$3(geojson, function(feature2) {
    lineSegmentFeature$2(feature2, results);
  });
  return featureCollection$6(results);
}
function lineSegmentFeature$2(geojson, results) {
  var coords = [];
  var geometry2 = geojson.geometry;
  if (geometry2 !== null) {
    switch (geometry2.type) {
      case "Polygon":
        coords = getCoords$6(geometry2);
        break;
      case "LineString":
        coords = [getCoords$6(geometry2)];
    }
    coords.forEach(function(coord) {
      var segments = createSegments$2(coord, geojson.properties);
      segments.forEach(function(segment) {
        segment.id = results.length;
        results.push(segment);
      });
    });
  }
}
function createSegments$2(coords, properties) {
  var segments = [];
  coords.reduce(function(previousCoords, currentCoords) {
    var segment = lineString$5([previousCoords, currentCoords], properties);
    segment.bbox = bbox$2(previousCoords, currentCoords);
    segments.push(segment);
    return currentCoords;
  });
  return segments;
}
function bbox$2(coords1, coords2) {
  var x12 = coords1[0];
  var y12 = coords1[1];
  var x2 = coords2[0];
  var y2 = coords2[1];
  var west = x12 < x2 ? x12 : x2;
  var south = y12 < y2 ? y12 : y2;
  var east = x12 > x2 ? x12 : x2;
  var north = y12 > y2 ? y12 : y2;
  return [west, south, east, north];
}
var geojsonRbushExports$1 = {};
var geojsonRbush$4 = {
  get exports() {
    return geojsonRbushExports$1;
  },
  set exports(v5) {
    geojsonRbushExports$1 = v5;
  }
};
var rbush_minExports$1 = {};
var rbush_min$1 = {
  get exports() {
    return rbush_minExports$1;
  },
  set exports(v5) {
    rbush_minExports$1 = v5;
  }
};
(function(module2, exports2) {
  !function(t2, i2) {
    module2.exports = i2();
  }(commonjsGlobal$1, function() {
    function t2(t3, r3, e4, a3, h3) {
      !function t4(n3, r4, e5, a4, h4) {
        for (; a4 > e5; ) {
          if (a4 - e5 > 600) {
            var o3 = a4 - e5 + 1, s3 = r4 - e5 + 1, l3 = Math.log(o3), f3 = 0.5 * Math.exp(2 * l3 / 3), u3 = 0.5 * Math.sqrt(l3 * f3 * (o3 - f3) / o3) * (s3 - o3 / 2 < 0 ? -1 : 1), m3 = Math.max(e5, Math.floor(r4 - s3 * f3 / o3 + u3)), c3 = Math.min(a4, Math.floor(r4 + (o3 - s3) * f3 / o3 + u3));
            t4(n3, r4, m3, c3, h4);
          }
          var p3 = n3[r4], d3 = e5, x2 = a4;
          for (i2(n3, e5, r4), h4(n3[a4], p3) > 0 && i2(n3, e5, a4); d3 < x2; ) {
            for (i2(n3, d3, x2), d3++, x2--; h4(n3[d3], p3) < 0; )
              d3++;
            for (; h4(n3[x2], p3) > 0; )
              x2--;
          }
          0 === h4(n3[e5], p3) ? i2(n3, e5, x2) : i2(n3, ++x2, a4), x2 <= r4 && (e5 = x2 + 1), r4 <= x2 && (a4 = x2 - 1);
        }
      }(t3, r3, e4 || 0, a3 || t3.length - 1, h3 || n2);
    }
    function i2(t3, i3, n3) {
      var r3 = t3[i3];
      t3[i3] = t3[n3], t3[n3] = r3;
    }
    function n2(t3, i3) {
      return t3 < i3 ? -1 : t3 > i3 ? 1 : 0;
    }
    var r2 = function(t3) {
      void 0 === t3 && (t3 = 9), this._maxEntries = Math.max(4, t3), this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries)), this.clear();
    };
    function e3(t3, i3, n3) {
      if (!n3)
        return i3.indexOf(t3);
      for (var r3 = 0; r3 < i3.length; r3++)
        if (n3(t3, i3[r3]))
          return r3;
      return -1;
    }
    function a2(t3, i3) {
      h2(t3, 0, t3.children.length, i3, t3);
    }
    function h2(t3, i3, n3, r3, e4) {
      e4 || (e4 = p2(null)), e4.minX = 1 / 0, e4.minY = 1 / 0, e4.maxX = -1 / 0, e4.maxY = -1 / 0;
      for (var a3 = i3; a3 < n3; a3++) {
        var h3 = t3.children[a3];
        o2(e4, t3.leaf ? r3(h3) : h3);
      }
      return e4;
    }
    function o2(t3, i3) {
      return t3.minX = Math.min(t3.minX, i3.minX), t3.minY = Math.min(t3.minY, i3.minY), t3.maxX = Math.max(t3.maxX, i3.maxX), t3.maxY = Math.max(t3.maxY, i3.maxY), t3;
    }
    function s2(t3, i3) {
      return t3.minX - i3.minX;
    }
    function l2(t3, i3) {
      return t3.minY - i3.minY;
    }
    function f2(t3) {
      return (t3.maxX - t3.minX) * (t3.maxY - t3.minY);
    }
    function u2(t3) {
      return t3.maxX - t3.minX + (t3.maxY - t3.minY);
    }
    function m2(t3, i3) {
      return t3.minX <= i3.minX && t3.minY <= i3.minY && i3.maxX <= t3.maxX && i3.maxY <= t3.maxY;
    }
    function c2(t3, i3) {
      return i3.minX <= t3.maxX && i3.minY <= t3.maxY && i3.maxX >= t3.minX && i3.maxY >= t3.minY;
    }
    function p2(t3) {
      return { children: t3, height: 1, leaf: true, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
    }
    function d2(i3, n3, r3, e4, a3) {
      for (var h3 = [n3, r3]; h3.length; )
        if (!((r3 = h3.pop()) - (n3 = h3.pop()) <= e4)) {
          var o3 = n3 + Math.ceil((r3 - n3) / e4 / 2) * e4;
          t2(i3, o3, n3, r3, a3), h3.push(n3, o3, o3, r3);
        }
    }
    return r2.prototype.all = function() {
      return this._all(this.data, []);
    }, r2.prototype.search = function(t3) {
      var i3 = this.data, n3 = [];
      if (!c2(t3, i3))
        return n3;
      for (var r3 = this.toBBox, e4 = []; i3; ) {
        for (var a3 = 0; a3 < i3.children.length; a3++) {
          var h3 = i3.children[a3], o3 = i3.leaf ? r3(h3) : h3;
          c2(t3, o3) && (i3.leaf ? n3.push(h3) : m2(t3, o3) ? this._all(h3, n3) : e4.push(h3));
        }
        i3 = e4.pop();
      }
      return n3;
    }, r2.prototype.collides = function(t3) {
      var i3 = this.data;
      if (!c2(t3, i3))
        return false;
      for (var n3 = []; i3; ) {
        for (var r3 = 0; r3 < i3.children.length; r3++) {
          var e4 = i3.children[r3], a3 = i3.leaf ? this.toBBox(e4) : e4;
          if (c2(t3, a3)) {
            if (i3.leaf || m2(t3, a3))
              return true;
            n3.push(e4);
          }
        }
        i3 = n3.pop();
      }
      return false;
    }, r2.prototype.load = function(t3) {
      if (!t3 || !t3.length)
        return this;
      if (t3.length < this._minEntries) {
        for (var i3 = 0; i3 < t3.length; i3++)
          this.insert(t3[i3]);
        return this;
      }
      var n3 = this._build(t3.slice(), 0, t3.length - 1, 0);
      if (this.data.children.length)
        if (this.data.height === n3.height)
          this._splitRoot(this.data, n3);
        else {
          if (this.data.height < n3.height) {
            var r3 = this.data;
            this.data = n3, n3 = r3;
          }
          this._insert(n3, this.data.height - n3.height - 1, true);
        }
      else
        this.data = n3;
      return this;
    }, r2.prototype.insert = function(t3) {
      return t3 && this._insert(t3, this.data.height - 1), this;
    }, r2.prototype.clear = function() {
      return this.data = p2([]), this;
    }, r2.prototype.remove = function(t3, i3) {
      if (!t3)
        return this;
      for (var n3, r3, a3, h3 = this.data, o3 = this.toBBox(t3), s3 = [], l3 = []; h3 || s3.length; ) {
        if (h3 || (h3 = s3.pop(), r3 = s3[s3.length - 1], n3 = l3.pop(), a3 = true), h3.leaf) {
          var f3 = e3(t3, h3.children, i3);
          if (-1 !== f3)
            return h3.children.splice(f3, 1), s3.push(h3), this._condense(s3), this;
        }
        a3 || h3.leaf || !m2(h3, o3) ? r3 ? (n3++, h3 = r3.children[n3], a3 = false) : h3 = null : (s3.push(h3), l3.push(n3), n3 = 0, r3 = h3, h3 = h3.children[0]);
      }
      return this;
    }, r2.prototype.toBBox = function(t3) {
      return t3;
    }, r2.prototype.compareMinX = function(t3, i3) {
      return t3.minX - i3.minX;
    }, r2.prototype.compareMinY = function(t3, i3) {
      return t3.minY - i3.minY;
    }, r2.prototype.toJSON = function() {
      return this.data;
    }, r2.prototype.fromJSON = function(t3) {
      return this.data = t3, this;
    }, r2.prototype._all = function(t3, i3) {
      for (var n3 = []; t3; )
        t3.leaf ? i3.push.apply(i3, t3.children) : n3.push.apply(n3, t3.children), t3 = n3.pop();
      return i3;
    }, r2.prototype._build = function(t3, i3, n3, r3) {
      var e4, h3 = n3 - i3 + 1, o3 = this._maxEntries;
      if (h3 <= o3)
        return a2(e4 = p2(t3.slice(i3, n3 + 1)), this.toBBox), e4;
      r3 || (r3 = Math.ceil(Math.log(h3) / Math.log(o3)), o3 = Math.ceil(h3 / Math.pow(o3, r3 - 1))), (e4 = p2([])).leaf = false, e4.height = r3;
      var s3 = Math.ceil(h3 / o3), l3 = s3 * Math.ceil(Math.sqrt(o3));
      d2(t3, i3, n3, l3, this.compareMinX);
      for (var f3 = i3; f3 <= n3; f3 += l3) {
        var u3 = Math.min(f3 + l3 - 1, n3);
        d2(t3, f3, u3, s3, this.compareMinY);
        for (var m3 = f3; m3 <= u3; m3 += s3) {
          var c3 = Math.min(m3 + s3 - 1, u3);
          e4.children.push(this._build(t3, m3, c3, r3 - 1));
        }
      }
      return a2(e4, this.toBBox), e4;
    }, r2.prototype._chooseSubtree = function(t3, i3, n3, r3) {
      for (; r3.push(i3), !i3.leaf && r3.length - 1 !== n3; ) {
        for (var e4 = 1 / 0, a3 = 1 / 0, h3 = void 0, o3 = 0; o3 < i3.children.length; o3++) {
          var s3 = i3.children[o3], l3 = f2(s3), u3 = (m3 = t3, c3 = s3, (Math.max(c3.maxX, m3.maxX) - Math.min(c3.minX, m3.minX)) * (Math.max(c3.maxY, m3.maxY) - Math.min(c3.minY, m3.minY)) - l3);
          u3 < a3 ? (a3 = u3, e4 = l3 < e4 ? l3 : e4, h3 = s3) : u3 === a3 && l3 < e4 && (e4 = l3, h3 = s3);
        }
        i3 = h3 || i3.children[0];
      }
      var m3, c3;
      return i3;
    }, r2.prototype._insert = function(t3, i3, n3) {
      var r3 = n3 ? t3 : this.toBBox(t3), e4 = [], a3 = this._chooseSubtree(r3, this.data, i3, e4);
      for (a3.children.push(t3), o2(a3, r3); i3 >= 0 && e4[i3].children.length > this._maxEntries; )
        this._split(e4, i3), i3--;
      this._adjustParentBBoxes(r3, e4, i3);
    }, r2.prototype._split = function(t3, i3) {
      var n3 = t3[i3], r3 = n3.children.length, e4 = this._minEntries;
      this._chooseSplitAxis(n3, e4, r3);
      var h3 = this._chooseSplitIndex(n3, e4, r3), o3 = p2(n3.children.splice(h3, n3.children.length - h3));
      o3.height = n3.height, o3.leaf = n3.leaf, a2(n3, this.toBBox), a2(o3, this.toBBox), i3 ? t3[i3 - 1].children.push(o3) : this._splitRoot(n3, o3);
    }, r2.prototype._splitRoot = function(t3, i3) {
      this.data = p2([t3, i3]), this.data.height = t3.height + 1, this.data.leaf = false, a2(this.data, this.toBBox);
    }, r2.prototype._chooseSplitIndex = function(t3, i3, n3) {
      for (var r3, e4, a3, o3, s3, l3, u3, m3 = 1 / 0, c3 = 1 / 0, p3 = i3; p3 <= n3 - i3; p3++) {
        var d3 = h2(t3, 0, p3, this.toBBox), x2 = h2(t3, p3, n3, this.toBBox), v5 = (e4 = d3, a3 = x2, o3 = void 0, s3 = void 0, l3 = void 0, u3 = void 0, o3 = Math.max(e4.minX, a3.minX), s3 = Math.max(e4.minY, a3.minY), l3 = Math.min(e4.maxX, a3.maxX), u3 = Math.min(e4.maxY, a3.maxY), Math.max(0, l3 - o3) * Math.max(0, u3 - s3)), M2 = f2(d3) + f2(x2);
        v5 < m3 ? (m3 = v5, r3 = p3, c3 = M2 < c3 ? M2 : c3) : v5 === m3 && M2 < c3 && (c3 = M2, r3 = p3);
      }
      return r3 || n3 - i3;
    }, r2.prototype._chooseSplitAxis = function(t3, i3, n3) {
      var r3 = t3.leaf ? this.compareMinX : s2, e4 = t3.leaf ? this.compareMinY : l2;
      this._allDistMargin(t3, i3, n3, r3) < this._allDistMargin(t3, i3, n3, e4) && t3.children.sort(r3);
    }, r2.prototype._allDistMargin = function(t3, i3, n3, r3) {
      t3.children.sort(r3);
      for (var e4 = this.toBBox, a3 = h2(t3, 0, i3, e4), s3 = h2(t3, n3 - i3, n3, e4), l3 = u2(a3) + u2(s3), f3 = i3; f3 < n3 - i3; f3++) {
        var m3 = t3.children[f3];
        o2(a3, t3.leaf ? e4(m3) : m3), l3 += u2(a3);
      }
      for (var c3 = n3 - i3 - 1; c3 >= i3; c3--) {
        var p3 = t3.children[c3];
        o2(s3, t3.leaf ? e4(p3) : p3), l3 += u2(s3);
      }
      return l3;
    }, r2.prototype._adjustParentBBoxes = function(t3, i3, n3) {
      for (var r3 = n3; r3 >= 0; r3--)
        o2(i3[r3], t3);
    }, r2.prototype._condense = function(t3) {
      for (var i3 = t3.length - 1, n3 = void 0; i3 >= 0; i3--)
        0 === t3[i3].children.length ? i3 > 0 ? (n3 = t3[i3 - 1].children).splice(n3.indexOf(t3[i3]), 1) : this.clear() : a2(t3[i3], this.toBBox);
    }, r2;
  });
})(rbush_min$1);
const require$$6 = /* @__PURE__ */ getAugmentedNamespace(es$4);
const require$$1$3 = /* @__PURE__ */ getAugmentedNamespace(es$3);
const require$$3 = /* @__PURE__ */ getAugmentedNamespace(es$2);
var rbush$2 = rbush_minExports$1;
var helpers$1 = require$$6;
var meta$2 = require$$1$3;
var turfBBox$2 = require$$3.default;
var featureEach$2 = meta$2.featureEach;
meta$2.coordEach;
helpers$1.polygon;
var featureCollection$5 = helpers$1.featureCollection;
function geojsonRbush$3(maxEntries) {
  var tree = new rbush$2(maxEntries);
  tree.insert = function(feature2) {
    if (feature2.type !== "Feature")
      throw new Error("invalid feature");
    feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$2(feature2);
    return rbush$2.prototype.insert.call(this, feature2);
  };
  tree.load = function(features) {
    var load2 = [];
    if (Array.isArray(features)) {
      features.forEach(function(feature2) {
        if (feature2.type !== "Feature")
          throw new Error("invalid features");
        feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$2(feature2);
        load2.push(feature2);
      });
    } else {
      featureEach$2(features, function(feature2) {
        if (feature2.type !== "Feature")
          throw new Error("invalid features");
        feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$2(feature2);
        load2.push(feature2);
      });
    }
    return rbush$2.prototype.load.call(this, load2);
  };
  tree.remove = function(feature2, equals12) {
    if (feature2.type !== "Feature")
      throw new Error("invalid feature");
    feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$2(feature2);
    return rbush$2.prototype.remove.call(this, feature2, equals12);
  };
  tree.clear = function() {
    return rbush$2.prototype.clear.call(this);
  };
  tree.search = function(geojson) {
    var features = rbush$2.prototype.search.call(this, this.toBBox(geojson));
    return featureCollection$5(features);
  };
  tree.collides = function(geojson) {
    return rbush$2.prototype.collides.call(this, this.toBBox(geojson));
  };
  tree.all = function() {
    var features = rbush$2.prototype.all.call(this);
    return featureCollection$5(features);
  };
  tree.toJSON = function() {
    return rbush$2.prototype.toJSON.call(this);
  };
  tree.fromJSON = function(json) {
    return rbush$2.prototype.fromJSON.call(this, json);
  };
  tree.toBBox = function(geojson) {
    var bbox2;
    if (geojson.bbox)
      bbox2 = geojson.bbox;
    else if (Array.isArray(geojson) && geojson.length === 4)
      bbox2 = geojson;
    else if (Array.isArray(geojson) && geojson.length === 6)
      bbox2 = [geojson[0], geojson[1], geojson[3], geojson[4]];
    else if (geojson.type === "Feature")
      bbox2 = turfBBox$2(geojson);
    else if (geojson.type === "FeatureCollection")
      bbox2 = turfBBox$2(geojson);
    else
      throw new Error("invalid geojson");
    return {
      minX: bbox2[0],
      minY: bbox2[1],
      maxX: bbox2[2],
      maxY: bbox2[3]
    };
  };
  return tree;
}
geojsonRbush$4.exports = geojsonRbush$3;
geojsonRbushExports$1.default = geojsonRbush$3;
function lineIntersect$2(line1, line2) {
  var unique2 = {};
  var results = [];
  if (line1.type === "LineString") {
    line1 = feature$a(line1);
  }
  if (line2.type === "LineString") {
    line2 = feature$a(line2);
  }
  if (line1.type === "Feature" && line2.type === "Feature" && line1.geometry !== null && line2.geometry !== null && line1.geometry.type === "LineString" && line2.geometry.type === "LineString" && line1.geometry.coordinates.length === 2 && line2.geometry.coordinates.length === 2) {
    var intersect2 = intersects$5(line1, line2);
    if (intersect2) {
      results.push(intersect2);
    }
    return featureCollection$6(results);
  }
  var tree = geojsonRbushExports$1();
  tree.load(lineSegment$2(line2));
  featureEach$3(lineSegment$2(line1), function(segment) {
    featureEach$3(tree.search(segment), function(match2) {
      var intersect3 = intersects$5(segment, match2);
      if (intersect3) {
        var key = getCoords$6(intersect3).join(",");
        if (!unique2[key]) {
          unique2[key] = true;
          results.push(intersect3);
        }
      }
    });
  });
  return featureCollection$6(results);
}
function intersects$5(line1, line2) {
  var coords1 = getCoords$6(line1);
  var coords2 = getCoords$6(line2);
  if (coords1.length !== 2) {
    throw new Error("<intersects> line1 must only contain 2 coordinates");
  }
  if (coords2.length !== 2) {
    throw new Error("<intersects> line2 must only contain 2 coordinates");
  }
  var x12 = coords1[0][0];
  var y12 = coords1[0][1];
  var x2 = coords1[1][0];
  var y2 = coords1[1][1];
  var x3 = coords2[0][0];
  var y3 = coords2[0][1];
  var x4 = coords2[1][0];
  var y4 = coords2[1][1];
  var denom = (y4 - y3) * (x2 - x12) - (x4 - x3) * (y2 - y12);
  var numeA = (x4 - x3) * (y12 - y3) - (y4 - y3) * (x12 - x3);
  var numeB = (x2 - x12) * (y12 - y3) - (y2 - y12) * (x12 - x3);
  if (denom === 0) {
    if (numeA === 0 && numeB === 0) {
      return null;
    }
    return null;
  }
  var uA = numeA / denom;
  var uB = numeB / denom;
  if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
    var x5 = x12 + uA * (x2 - x12);
    var y5 = y12 + uA * (y2 - y12);
    return point$5([x5, y5]);
  }
  return null;
}
function nearestPointOnLine$1(lines, pt, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var closestPt = point$5([Infinity, Infinity], {
    dist: Infinity
  });
  var length2 = 0;
  flattenEach$3(lines, function(line) {
    var coords = getCoords$6(line);
    for (var i2 = 0; i2 < coords.length - 1; i2++) {
      var start2 = point$5(coords[i2]);
      start2.properties.dist = distance$5(pt, start2, options2);
      var stop_1 = point$5(coords[i2 + 1]);
      stop_1.properties.dist = distance$5(pt, stop_1, options2);
      var sectionLength = distance$5(start2, stop_1, options2);
      var heightDistance = Math.max(start2.properties.dist, stop_1.properties.dist);
      var direction = bearing$2(start2, stop_1);
      var perpendicularPt1 = destination$3(pt, heightDistance, direction + 90, options2);
      var perpendicularPt2 = destination$3(pt, heightDistance, direction - 90, options2);
      var intersect2 = lineIntersect$2(lineString$5([
        perpendicularPt1.geometry.coordinates,
        perpendicularPt2.geometry.coordinates
      ]), lineString$5([start2.geometry.coordinates, stop_1.geometry.coordinates]));
      var intersectPt = null;
      if (intersect2.features.length > 0) {
        intersectPt = intersect2.features[0];
        intersectPt.properties.dist = distance$5(pt, intersectPt, options2);
        intersectPt.properties.location = length2 + distance$5(start2, intersectPt, options2);
      }
      if (start2.properties.dist < closestPt.properties.dist) {
        closestPt = start2;
        closestPt.properties.index = i2;
        closestPt.properties.location = length2;
      }
      if (stop_1.properties.dist < closestPt.properties.dist) {
        closestPt = stop_1;
        closestPt.properties.index = i2 + 1;
        closestPt.properties.location = length2 + sectionLength;
      }
      if (intersectPt && intersectPt.properties.dist < closestPt.properties.dist) {
        closestPt = intersectPt;
        closestPt.properties.index = i2;
      }
      length2 += sectionLength;
    }
  });
  return closestPt;
}
var RADIUS = 6378137;
function area$3(geojson) {
  return geomReduce(geojson, function(value, geom) {
    return value + calculateArea(geom);
  }, 0);
}
function calculateArea(geom) {
  var total = 0;
  var i2;
  switch (geom.type) {
    case "Polygon":
      return polygonArea$1(geom.coordinates);
    case "MultiPolygon":
      for (i2 = 0; i2 < geom.coordinates.length; i2++) {
        total += polygonArea$1(geom.coordinates[i2]);
      }
      return total;
    case "Point":
    case "MultiPoint":
    case "LineString":
    case "MultiLineString":
      return 0;
  }
  return 0;
}
function polygonArea$1(coords) {
  var total = 0;
  if (coords && coords.length > 0) {
    total += Math.abs(ringArea$1(coords[0]));
    for (var i2 = 1; i2 < coords.length; i2++) {
      total -= Math.abs(ringArea$1(coords[i2]));
    }
  }
  return total;
}
function ringArea$1(coords) {
  var p1;
  var p2;
  var p3;
  var lowerIndex;
  var middleIndex;
  var upperIndex;
  var i2;
  var total = 0;
  var coordsLength = coords.length;
  if (coordsLength > 2) {
    for (i2 = 0; i2 < coordsLength; i2++) {
      if (i2 === coordsLength - 2) {
        lowerIndex = coordsLength - 2;
        middleIndex = coordsLength - 1;
        upperIndex = 0;
      } else if (i2 === coordsLength - 1) {
        lowerIndex = coordsLength - 1;
        middleIndex = 0;
        upperIndex = 1;
      } else {
        lowerIndex = i2;
        middleIndex = i2 + 1;
        upperIndex = i2 + 2;
      }
      p1 = coords[lowerIndex];
      p2 = coords[middleIndex];
      p3 = coords[upperIndex];
      total += (rad$3(p3[0]) - rad$3(p1[0])) * Math.sin(rad$3(p2[1]));
    }
    total = total * RADIUS * RADIUS / 2;
  }
  return total;
}
function rad$3(num) {
  return num * Math.PI / 180;
}
function length$5(geojson, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return segmentReduce(geojson, function(previousValue, segment) {
    var coords = segment.geometry.coordinates;
    return previousValue + distance$5(coords[0], coords[1], options2);
  }, 0);
}
function index$2(poly2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = getGeom(poly2);
  if (!options2.properties && poly2.type === "Feature") {
    options2.properties = poly2.properties;
  }
  switch (geom.type) {
    case "Polygon":
      return polygonToLine$3(geom, options2);
    case "MultiPolygon":
      return multiPolygonToLine$1(geom, options2);
    default:
      throw new Error("invalid poly");
  }
}
function polygonToLine$3(poly2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = getGeom(poly2);
  var coords = geom.coordinates;
  var properties = options2.properties ? options2.properties : poly2.type === "Feature" ? poly2.properties : {};
  return coordsToLine$2(coords, properties);
}
function multiPolygonToLine$1(multiPoly, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = getGeom(multiPoly);
  var coords = geom.coordinates;
  var properties = options2.properties ? options2.properties : multiPoly.type === "Feature" ? multiPoly.properties : {};
  var lines = [];
  coords.forEach(function(coord) {
    lines.push(coordsToLine$2(coord, properties));
  });
  return featureCollection$6(lines);
}
function coordsToLine$2(coords, properties) {
  if (coords.length > 1) {
    return multiLineString$2(coords, properties);
  }
  return lineString$5(coords[0], properties);
}
function booleanPointOnLine(pt, line, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var ptCoords = getCoord$5(pt);
  var lineCoords = getCoords$6(line);
  for (var i2 = 0; i2 < lineCoords.length - 1; i2++) {
    var ignoreBoundary = false;
    if (options2.ignoreEndVertices) {
      if (i2 === 0) {
        ignoreBoundary = "start";
      }
      if (i2 === lineCoords.length - 2) {
        ignoreBoundary = "end";
      }
      if (i2 === 0 && i2 + 1 === lineCoords.length - 1) {
        ignoreBoundary = "both";
      }
    }
    if (isPointOnLineSegment$2(lineCoords[i2], lineCoords[i2 + 1], ptCoords, ignoreBoundary, typeof options2.epsilon === "undefined" ? null : options2.epsilon)) {
      return true;
    }
  }
  return false;
}
function isPointOnLineSegment$2(lineSegmentStart, lineSegmentEnd, pt, excludeBoundary, epsilon2) {
  var x2 = pt[0];
  var y2 = pt[1];
  var x12 = lineSegmentStart[0];
  var y12 = lineSegmentStart[1];
  var x22 = lineSegmentEnd[0];
  var y22 = lineSegmentEnd[1];
  var dxc = pt[0] - x12;
  var dyc = pt[1] - y12;
  var dxl = x22 - x12;
  var dyl = y22 - y12;
  var cross2 = dxc * dyl - dyc * dxl;
  if (epsilon2 !== null) {
    if (Math.abs(cross2) > epsilon2) {
      return false;
    }
  } else if (cross2 !== 0) {
    return false;
  }
  if (!excludeBoundary) {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x12 <= x2 && x2 <= x22 : x22 <= x2 && x2 <= x12;
    }
    return dyl > 0 ? y12 <= y2 && y2 <= y22 : y22 <= y2 && y2 <= y12;
  } else if (excludeBoundary === "start") {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x12 < x2 && x2 <= x22 : x22 <= x2 && x2 < x12;
    }
    return dyl > 0 ? y12 < y2 && y2 <= y22 : y22 <= y2 && y2 < y12;
  } else if (excludeBoundary === "end") {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x12 <= x2 && x2 < x22 : x22 < x2 && x2 <= x12;
    }
    return dyl > 0 ? y12 <= y2 && y2 < y22 : y22 < y2 && y2 <= y12;
  } else if (excludeBoundary === "both") {
    if (Math.abs(dxl) >= Math.abs(dyl)) {
      return dxl > 0 ? x12 < x2 && x2 < x22 : x22 < x2 && x2 < x12;
    }
    return dyl > 0 ? y12 < y2 && y2 < y22 : y22 < y2 && y2 < y12;
  }
  return false;
}
var toStr$3 = Object.prototype.toString;
var isArguments$7 = function isArguments2(value) {
  var str = toStr$3.call(value);
  var isArgs2 = str === "[object Arguments]";
  if (!isArgs2) {
    isArgs2 = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr$3.call(value.callee) === "[object Function]";
  }
  return isArgs2;
};
var implementation$8;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation)
    return implementation$8;
  hasRequiredImplementation = 1;
  var keysShim2;
  if (!Object.keys) {
    var has2 = Object.prototype.hasOwnProperty;
    var toStr2 = Object.prototype.toString;
    var isArgs2 = isArguments$7;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({ toString: null }, "toString");
    var hasProtoEnumBug = isEnumerable.call(function() {
    }, "prototype");
    var dontEnums = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ];
    var equalsConstructorPrototype = function(o2) {
      var ctor = o2.constructor;
      return ctor && ctor.prototype === o2;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = function() {
      if (typeof window === "undefined") {
        return false;
      }
      for (var k2 in window) {
        try {
          if (!excludedKeys["$" + k2] && has2.call(window, k2) && window[k2] !== null && typeof window[k2] === "object") {
            try {
              equalsConstructorPrototype(window[k2]);
            } catch (e3) {
              return true;
            }
          }
        } catch (e3) {
          return true;
        }
      }
      return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o2) {
      if (typeof window === "undefined" || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o2);
      }
      try {
        return equalsConstructorPrototype(o2);
      } catch (e3) {
        return false;
      }
    };
    keysShim2 = function keys4(object2) {
      var isObject2 = object2 !== null && typeof object2 === "object";
      var isFunction2 = toStr2.call(object2) === "[object Function]";
      var isArguments5 = isArgs2(object2);
      var isString2 = isObject2 && toStr2.call(object2) === "[object String]";
      var theKeys = [];
      if (!isObject2 && !isFunction2 && !isArguments5) {
        throw new TypeError("Object.keys called on a non-object");
      }
      var skipProto = hasProtoEnumBug && isFunction2;
      if (isString2 && object2.length > 0 && !has2.call(object2, 0)) {
        for (var i2 = 0; i2 < object2.length; ++i2) {
          theKeys.push(String(i2));
        }
      }
      if (isArguments5 && object2.length > 0) {
        for (var j2 = 0; j2 < object2.length; ++j2) {
          theKeys.push(String(j2));
        }
      } else {
        for (var name2 in object2) {
          if (!(skipProto && name2 === "prototype") && has2.call(object2, name2)) {
            theKeys.push(String(name2));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object2);
        for (var k2 = 0; k2 < dontEnums.length; ++k2) {
          if (!(skipConstructor && dontEnums[k2] === "constructor") && has2.call(object2, dontEnums[k2])) {
            theKeys.push(dontEnums[k2]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$8 = keysShim2;
  return implementation$8;
}
var slice$3 = Array.prototype.slice;
var isArgs = isArguments$7;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys2(o2) {
  return origKeys(o2);
} : requireImplementation();
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function() {
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys4(object2) {
        if (isArgs(object2)) {
          return originalKeys(slice$3.call(object2));
        }
        return originalKeys(object2);
      };
    }
  } else {
    Object.keys = keysShim;
  }
  return Object.keys || keysShim;
};
var objectKeys$2 = keysShim;
var shams$1 = function hasSymbols2() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var hasSymbols$3 = shams$1;
var shams = function hasToStringTagShams() {
  return hasSymbols$3() && !!Symbol.toStringTag;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams$1;
var hasSymbols$2 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var slice$2 = Array.prototype.slice;
var toStr$2 = Object.prototype.toString;
var funcType = "[object Function]";
var implementation$7 = function bind2(that) {
  var target = this;
  if (typeof target !== "function" || toStr$2.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slice$2.call(arguments, 1);
  var bound;
  var binder = function() {
    if (this instanceof bound) {
      var result = target.apply(
        this,
        args.concat(slice$2.call(arguments))
      );
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(
        that,
        args.concat(slice$2.call(arguments))
      );
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i2 = 0; i2 < boundLength; i2++) {
    boundArgs.push("$" + i2);
  }
  bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty2 = function Empty3() {
    };
    Empty2.prototype = target.prototype;
    bound.prototype = new Empty2();
    Empty2.prototype = null;
  }
  return bound;
};
var implementation$6 = implementation$7;
var functionBind = Function.prototype.bind || implementation$6;
var bind$1 = functionBind;
var src$1 = bind$1.call(Function.call, Object.prototype.hasOwnProperty);
var undefined$1;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e3) {
  }
};
var $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1) {
  try {
    $gOPD$1({}, "");
  } catch (e3) {
    $gOPD$1 = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError();
};
var ThrowTypeError = $gOPD$1 ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols$1 = hasSymbols$2();
var getProto$1 = Object.getPrototypeOf || function(x2) {
  return x2.__proto__;
};
var needsEval = {};
var TypedArray$1 = typeof Uint8Array === "undefined" ? undefined$1 : getProto$1(Uint8Array);
var INTRINSICS = {
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": RangeError,
  "%ReferenceError%": ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$1 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols$1 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray$1,
  "%TypeError%": $TypeError,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
try {
  null.error;
} catch (e3) {
  var errorProto = getProto$1(getProto$1(e3));
  INTRINSICS["%Error.prototype%"] = errorProto;
}
var doEval = function doEval2(name2) {
  var value;
  if (name2 === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name2 === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name2 === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name2 === "%AsyncGenerator%") {
    var fn2 = doEval2("%AsyncGeneratorFunction%");
    if (fn2) {
      value = fn2.prototype;
    }
  } else if (name2 === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen) {
      value = getProto$1(gen.prototype);
    }
  }
  INTRINSICS[name2] = value;
  return value;
};
var LEGACY_ALIASES = {
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind = functionBind;
var hasOwn = src$1;
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec$1 = bind.call(Function.call, RegExp.prototype.exec);
var rePropName$2 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$2 = /\\(\\)?/g;
var stringToPath$4 = function stringToPath2(string3) {
  var first = $strSlice(string3, 0, 1);
  var last = $strSlice(string3, -1);
  if (first === "%" && last !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected closing `%`");
  } else if (last === "%" && first !== "%") {
    throw new $SyntaxError("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace(string3, rePropName$2, function(match2, number2, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar$2, "$1") : number2 || match2;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
  var intrinsicName = name2;
  var alias;
  if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias[0] + "%";
  }
  if (hasOwn(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
    }
    return {
      alias,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError("intrinsic " + name2 + " does not exist!");
};
var getIntrinsic = function GetIntrinsic2(name2, allowMissing) {
  if (typeof name2 !== "string" || name2.length === 0) {
    throw new $TypeError("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError('"allowMissing" argument must be a boolean');
  }
  if ($exec$1(/^%?[^%]*%?$/, name2) === null) {
    throw new $SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath$4(name2);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }
  for (var i2 = 1, isOwn = true; i2 < parts.length; i2 += 1) {
    var part = parts[i2];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last === '"' || last === "'" || last === "`")) && first !== last) {
      throw new $SyntaxError("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError("base intrinsic for " + name2 + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD$1 && i2 + 1 >= parts.length) {
        var desc = $gOPD$1(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var callBindExports = {};
var callBind$3 = {
  get exports() {
    return callBindExports;
  },
  set exports(v5) {
    callBindExports = v5;
  }
};
(function(module2) {
  var bind5 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind5.call($call, $apply);
  var $gOPD2 = GetIntrinsic3("%Object.getOwnPropertyDescriptor%", true);
  var $defineProperty2 = GetIntrinsic3("%Object.defineProperty%", true);
  var $max = GetIntrinsic3("%Math.max%");
  if ($defineProperty2) {
    try {
      $defineProperty2({}, "a", { value: 1 });
    } catch (e3) {
      $defineProperty2 = null;
    }
  }
  module2.exports = function callBind2(originalFunction) {
    var func2 = $reflectApply(bind5, $call, arguments);
    if ($gOPD2 && $defineProperty2) {
      var desc = $gOPD2(func2, "length");
      if (desc.configurable) {
        $defineProperty2(
          func2,
          "length",
          { value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
        );
      }
    }
    return func2;
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind5, $apply, arguments);
  };
  if ($defineProperty2) {
    $defineProperty2(module2.exports, "apply", { value: applyBind });
  } else {
    module2.exports.apply = applyBind;
  }
})(callBind$3);
var GetIntrinsic$1 = getIntrinsic;
var callBind$2 = callBindExports;
var $indexOf = callBind$2(GetIntrinsic$1("String.prototype.indexOf"));
var callBound$2 = function callBoundIntrinsic(name2, allowMissing) {
  var intrinsic = GetIntrinsic$1(name2, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf(name2, ".prototype.") > -1) {
    return callBind$2(intrinsic);
  }
  return intrinsic;
};
var hasToStringTag$2 = shams();
var callBound$1 = callBound$2;
var $toString$1 = callBound$1("Object.prototype.toString");
var isStandardArguments = function isArguments3(value) {
  if (hasToStringTag$2 && value && typeof value === "object" && Symbol.toStringTag in value) {
    return false;
  }
  return $toString$1(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments4(value) {
  if (isStandardArguments(value)) {
    return true;
  }
  return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString$1(value) !== "[object Array]" && $toString$1(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments$6 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
var GetIntrinsic = getIntrinsic;
var $defineProperty = GetIntrinsic("%Object.defineProperty%", true);
var hasPropertyDescriptors$1 = function hasPropertyDescriptors2() {
  if ($defineProperty) {
    try {
      $defineProperty({}, "a", { value: 1 });
      return true;
    } catch (e3) {
      return false;
    }
  }
  return false;
};
hasPropertyDescriptors$1.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  if (!hasPropertyDescriptors$1()) {
    return null;
  }
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch (e3) {
    return true;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors$1;
var keys$7 = objectKeys$2;
var hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr$1 = Object.prototype.toString;
var concat$2 = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;
var isFunction$6 = function(fn2) {
  return typeof fn2 === "function" && toStr$1.call(fn2) === "[object Function]";
};
var hasPropertyDescriptors = hasPropertyDescriptors_1();
var supportsDescriptors$2 = origDefineProperty && hasPropertyDescriptors;
var defineProperty$5 = function(object2, name2, value, predicate) {
  if (name2 in object2) {
    if (predicate === true) {
      if (object2[name2] === value) {
        return;
      }
    } else if (!isFunction$6(predicate) || !predicate()) {
      return;
    }
  }
  if (supportsDescriptors$2) {
    origDefineProperty(object2, name2, {
      configurable: true,
      enumerable: false,
      value,
      writable: true
    });
  } else {
    object2[name2] = value;
  }
};
var defineProperties = function(object2, map5) {
  var predicates = arguments.length > 2 ? arguments[2] : {};
  var props = keys$7(map5);
  if (hasSymbols) {
    props = concat$2.call(props, Object.getOwnPropertySymbols(map5));
  }
  for (var i2 = 0; i2 < props.length; i2 += 1) {
    defineProperty$5(object2, props[i2], map5[props[i2]], predicates[props[i2]]);
  }
};
defineProperties.supportsDescriptors = !!supportsDescriptors$2;
var defineProperties_1 = defineProperties;
var numberIsNaN = function(value) {
  return value !== value;
};
var implementation$5 = function is2(a2, b2) {
  if (a2 === 0 && b2 === 0) {
    return 1 / a2 === 1 / b2;
  }
  if (a2 === b2) {
    return true;
  }
  if (numberIsNaN(a2) && numberIsNaN(b2)) {
    return true;
  }
  return false;
};
var implementation$4 = implementation$5;
var polyfill$3 = function getPolyfill2() {
  return typeof Object.is === "function" ? Object.is : implementation$4;
};
var getPolyfill$3 = polyfill$3;
var define$2 = defineProperties_1;
var shim$3 = function shimObjectIs() {
  var polyfill2 = getPolyfill$3();
  define$2(Object, { is: polyfill2 }, {
    is: function testObjectIs() {
      return Object.is !== polyfill2;
    }
  });
  return polyfill2;
};
var define$1 = defineProperties_1;
var callBind$1 = callBindExports;
var implementation$3 = implementation$5;
var getPolyfill$2 = polyfill$3;
var shim$2 = shim$3;
var polyfill$2 = callBind$1(getPolyfill$2(), Object);
define$1(polyfill$2, {
  getPolyfill: getPolyfill$2,
  implementation: implementation$3,
  shim: shim$2
});
var objectIs = polyfill$2;
var callBound = callBound$2;
var hasToStringTag$1 = shams();
var has$2;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag$1) {
  has$2 = callBound("Object.prototype.hasOwnProperty");
  $exec = callBound("RegExp.prototype.exec");
  isRegexMarker = {};
  var throwRegexMarker = function() {
    throw isRegexMarker;
  };
  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  if (typeof Symbol.toPrimitive === "symbol") {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}
var $toString = callBound("Object.prototype.toString");
var gOPD$2 = Object.getOwnPropertyDescriptor;
var regexClass = "[object RegExp]";
var isRegex$1 = hasToStringTag$1 ? function isRegex2(value) {
  if (!value || typeof value !== "object") {
    return false;
  }
  var descriptor = gOPD$2(value, "lastIndex");
  var hasLastIndexDataProperty = descriptor && has$2(descriptor, "value");
  if (!hasLastIndexDataProperty) {
    return false;
  }
  try {
    $exec(value, badStringifier);
  } catch (e3) {
    return e3 === isRegexMarker;
  }
} : function isRegex3(value) {
  if (!value || typeof value !== "object" && typeof value !== "function") {
    return false;
  }
  return $toString(value) === regexClass;
};
var implementationExports = {};
var implementation$2 = {
  get exports() {
    return implementationExports;
  },
  set exports(v5) {
    implementationExports = v5;
  }
};
var functionsHaveNames = function functionsHaveNames2() {
  return typeof function f2() {
  }.name === "string";
};
var gOPD$1 = Object.getOwnPropertyDescriptor;
if (gOPD$1) {
  try {
    gOPD$1([], "length");
  } catch (e3) {
    gOPD$1 = null;
  }
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
  if (!functionsHaveNames() || !gOPD$1) {
    return false;
  }
  var desc = gOPD$1(function() {
  }, "name");
  return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
  return functionsHaveNames() && typeof $bind === "function" && function f2() {
  }.bind().name !== "";
};
var functionsHaveNames_1 = functionsHaveNames;
(function(module2) {
  var functionsHaveConfigurableNames2 = functionsHaveNames_1.functionsHaveConfigurableNames();
  var $Object = Object;
  var $TypeError2 = TypeError;
  module2.exports = function flags2() {
    if (this != null && this !== $Object(this)) {
      throw new $TypeError2("RegExp.prototype.flags getter called on non-object");
    }
    var result = "";
    if (this.hasIndices) {
      result += "d";
    }
    if (this.global) {
      result += "g";
    }
    if (this.ignoreCase) {
      result += "i";
    }
    if (this.multiline) {
      result += "m";
    }
    if (this.dotAll) {
      result += "s";
    }
    if (this.unicode) {
      result += "u";
    }
    if (this.sticky) {
      result += "y";
    }
    return result;
  };
  if (functionsHaveConfigurableNames2 && Object.defineProperty) {
    Object.defineProperty(module2.exports, "name", { value: "get flags" });
  }
})(implementation$2);
var implementation$1 = implementationExports;
var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var polyfill$1 = function getPolyfill3() {
  if (supportsDescriptors$1 && /a/mig.flags === "gim") {
    var descriptor = $gOPD(RegExp.prototype, "flags");
    if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
      var calls = "";
      var o2 = {};
      Object.defineProperty(o2, "hasIndices", {
        get: function() {
          calls += "d";
        }
      });
      Object.defineProperty(o2, "sticky", {
        get: function() {
          calls += "y";
        }
      });
      if (calls === "dy") {
        return descriptor.get;
      }
    }
  }
  return implementation$1;
};
var supportsDescriptors = defineProperties_1.supportsDescriptors;
var getPolyfill$1 = polyfill$1;
var gOPD = Object.getOwnPropertyDescriptor;
var defineProperty$4 = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;
var shim$1 = function shimFlags() {
  if (!supportsDescriptors || !getProto) {
    throw new TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
  }
  var polyfill2 = getPolyfill$1();
  var proto = getProto(regex);
  var descriptor = gOPD(proto, "flags");
  if (!descriptor || descriptor.get !== polyfill2) {
    defineProperty$4(proto, "flags", {
      configurable: true,
      enumerable: false,
      get: polyfill2
    });
  }
  return polyfill2;
};
var define = defineProperties_1;
var callBind = callBindExports;
var implementation = implementationExports;
var getPolyfill = polyfill$1;
var shim = shim$1;
var flagsBound = callBind(getPolyfill());
define(flagsBound, {
  getPolyfill,
  implementation,
  shim
});
var regexp_prototype_flags = flagsBound;
var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
  try {
    getDay.call(value);
    return true;
  } catch (e3) {
    return false;
  }
};
var toStr = Object.prototype.toString;
var dateClass = "[object Date]";
var hasToStringTag = shams();
var isDateObject = function isDateObject2(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};
var objectKeys$1 = objectKeys$2;
var isArguments$5 = isArguments$6;
var is$1 = objectIs;
var isRegex = isRegex$1;
var flags = regexp_prototype_flags;
var isDate$1 = isDateObject;
var getTime = Date.prototype.getTime;
function deepEqual$3(actual, expected, options2) {
  var opts = options2 || {};
  if (opts.strict ? is$1(actual, expected) : actual === expected) {
    return true;
  }
  if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") {
    return opts.strict ? is$1(actual, expected) : actual == expected;
  }
  return objEquiv(actual, expected, opts);
}
function isUndefinedOrNull(value) {
  return value === null || value === void 0;
}
function isBuffer$8(x2) {
  if (!x2 || typeof x2 !== "object" || typeof x2.length !== "number") {
    return false;
  }
  if (typeof x2.copy !== "function" || typeof x2.slice !== "function") {
    return false;
  }
  if (x2.length > 0 && typeof x2[0] !== "number") {
    return false;
  }
  return true;
}
function objEquiv(a2, b2, opts) {
  var i2, key;
  if (typeof a2 !== typeof b2) {
    return false;
  }
  if (isUndefinedOrNull(a2) || isUndefinedOrNull(b2)) {
    return false;
  }
  if (a2.prototype !== b2.prototype) {
    return false;
  }
  if (isArguments$5(a2) !== isArguments$5(b2)) {
    return false;
  }
  var aIsRegex = isRegex(a2);
  var bIsRegex = isRegex(b2);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if (aIsRegex || bIsRegex) {
    return a2.source === b2.source && flags(a2) === flags(b2);
  }
  if (isDate$1(a2) && isDate$1(b2)) {
    return getTime.call(a2) === getTime.call(b2);
  }
  var aIsBuffer = isBuffer$8(a2);
  var bIsBuffer = isBuffer$8(b2);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    if (a2.length !== b2.length) {
      return false;
    }
    for (i2 = 0; i2 < a2.length; i2++) {
      if (a2[i2] !== b2[i2]) {
        return false;
      }
    }
    return true;
  }
  if (typeof a2 !== typeof b2) {
    return false;
  }
  try {
    var ka = objectKeys$1(a2);
    var kb = objectKeys$1(b2);
  } catch (e3) {
    return false;
  }
  if (ka.length !== kb.length) {
    return false;
  }
  ka.sort();
  kb.sort();
  for (i2 = ka.length - 1; i2 >= 0; i2--) {
    if (ka[i2] != kb[i2]) {
      return false;
    }
  }
  for (i2 = ka.length - 1; i2 >= 0; i2--) {
    key = ka[i2];
    if (!deepEqual$3(a2[key], b2[key], opts)) {
      return false;
    }
  }
  return true;
}
var deepEqual_1 = deepEqual$3;
function lineOverlap(line1, line2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  options2 = options2 || {};
  if (!isObject$k(options2))
    throw new Error("options is invalid");
  var tolerance = options2.tolerance || 0;
  var features = [];
  var tree = geojsonRbushExports$1();
  var line = lineSegment$2(line1);
  tree.load(line);
  var overlapSegment;
  segmentEach(line2, function(segment) {
    var doesOverlaps = false;
    if (!segment) {
      return;
    }
    featureEach$3(tree.search(segment), function(match2) {
      if (doesOverlaps === false) {
        var coordsSegment = getCoords$6(segment).sort();
        var coordsMatch = getCoords$6(match2).sort();
        if (deepEqual_1(coordsSegment, coordsMatch)) {
          doesOverlaps = true;
          if (overlapSegment)
            overlapSegment = concatSegment(overlapSegment, segment);
          else
            overlapSegment = segment;
        } else if (tolerance === 0 ? booleanPointOnLine(coordsSegment[0], match2) && booleanPointOnLine(coordsSegment[1], match2) : nearestPointOnLine$1(match2, coordsSegment[0]).properties.dist <= tolerance && nearestPointOnLine$1(match2, coordsSegment[1]).properties.dist <= tolerance) {
          doesOverlaps = true;
          if (overlapSegment)
            overlapSegment = concatSegment(overlapSegment, segment);
          else
            overlapSegment = segment;
        } else if (tolerance === 0 ? booleanPointOnLine(coordsMatch[0], segment) && booleanPointOnLine(coordsMatch[1], segment) : nearestPointOnLine$1(segment, coordsMatch[0]).properties.dist <= tolerance && nearestPointOnLine$1(segment, coordsMatch[1]).properties.dist <= tolerance) {
          if (overlapSegment)
            overlapSegment = concatSegment(overlapSegment, match2);
          else
            overlapSegment = match2;
        }
      }
    });
    if (doesOverlaps === false && overlapSegment) {
      features.push(overlapSegment);
      overlapSegment = void 0;
    }
  });
  if (overlapSegment)
    features.push(overlapSegment);
  return featureCollection$6(features);
}
function concatSegment(line, segment) {
  var coords = getCoords$6(segment);
  var lineCoords = getCoords$6(line);
  var start2 = lineCoords[0];
  var end = lineCoords[lineCoords.length - 1];
  var geom = line.geometry.coordinates;
  if (deepEqual_1(coords[0], start2))
    geom.unshift(coords[1]);
  else if (deepEqual_1(coords[0], end))
    geom.push(coords[1]);
  else if (deepEqual_1(coords[1], start2))
    geom.unshift(coords[0]);
  else if (deepEqual_1(coords[1], end))
    geom.push(coords[0]);
  return line;
}
function clone$2(geojson) {
  if (!geojson) {
    throw new Error("geojson is required");
  }
  switch (geojson.type) {
    case "Feature":
      return cloneFeature(geojson);
    case "FeatureCollection":
      return cloneFeatureCollection(geojson);
    case "Point":
    case "LineString":
    case "Polygon":
    case "MultiPoint":
    case "MultiLineString":
    case "MultiPolygon":
    case "GeometryCollection":
      return cloneGeometry(geojson);
    default:
      throw new Error("unknown GeoJSON type");
  }
}
function cloneFeature(geojson) {
  var cloned = { type: "Feature" };
  Object.keys(geojson).forEach(function(key) {
    switch (key) {
      case "type":
      case "properties":
      case "geometry":
        return;
      default:
        cloned[key] = geojson[key];
    }
  });
  cloned.properties = cloneProperties(geojson.properties);
  cloned.geometry = cloneGeometry(geojson.geometry);
  return cloned;
}
function cloneProperties(properties) {
  var cloned = {};
  if (!properties) {
    return cloned;
  }
  Object.keys(properties).forEach(function(key) {
    var value = properties[key];
    if (typeof value === "object") {
      if (value === null) {
        cloned[key] = null;
      } else if (Array.isArray(value)) {
        cloned[key] = value.map(function(item) {
          return item;
        });
      } else {
        cloned[key] = cloneProperties(value);
      }
    } else {
      cloned[key] = value;
    }
  });
  return cloned;
}
function cloneFeatureCollection(geojson) {
  var cloned = { type: "FeatureCollection" };
  Object.keys(geojson).forEach(function(key) {
    switch (key) {
      case "type":
      case "features":
        return;
      default:
        cloned[key] = geojson[key];
    }
  });
  cloned.features = geojson.features.map(function(feature2) {
    return cloneFeature(feature2);
  });
  return cloned;
}
function cloneGeometry(geometry2) {
  var geom = { type: geometry2.type };
  if (geometry2.bbox) {
    geom.bbox = geometry2.bbox;
  }
  if (geometry2.type === "GeometryCollection") {
    geom.geometries = geometry2.geometries.map(function(g2) {
      return cloneGeometry(g2);
    });
    return geom;
  }
  geom.coordinates = deepSlice(geometry2.coordinates);
  return geom;
}
function deepSlice(coords) {
  var cloned = coords;
  if (typeof cloned[0] !== "object") {
    return cloned.slice();
  }
  return cloned.map(function(coord) {
    return deepSlice(coord);
  });
}
function rhumbDestination(origin, distance11, bearing2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var wasNegativeDistance = distance11 < 0;
  var distanceInMeters = convertLength$1(Math.abs(distance11), options2.units, "meters");
  if (wasNegativeDistance)
    distanceInMeters = -Math.abs(distanceInMeters);
  var coords = getCoord$5(origin);
  var destination2 = calculateRhumbDestination(coords, distanceInMeters, bearing2);
  destination2[0] += destination2[0] - coords[0] > 180 ? -360 : coords[0] - destination2[0] > 180 ? 360 : 0;
  return point$5(destination2, options2.properties);
}
function calculateRhumbDestination(origin, distance11, bearing2, radius) {
  radius = radius === void 0 ? earthRadius$4 : Number(radius);
  var delta = distance11 / radius;
  var lambda1 = origin[0] * Math.PI / 180;
  var phi1 = degreesToRadians$4(origin[1]);
  var theta = degreesToRadians$4(bearing2);
  var DeltaPhi = delta * Math.cos(theta);
  var phi2 = phi1 + DeltaPhi;
  if (Math.abs(phi2) > Math.PI / 2) {
    phi2 = phi2 > 0 ? Math.PI - phi2 : -Math.PI - phi2;
  }
  var DeltaPsi = Math.log(Math.tan(phi2 / 2 + Math.PI / 4) / Math.tan(phi1 / 2 + Math.PI / 4));
  var q2 = Math.abs(DeltaPsi) > 1e-11 ? DeltaPhi / DeltaPsi : Math.cos(phi1);
  var DeltaLambda = delta * Math.sin(theta) / q2;
  var lambda2 = lambda1 + DeltaLambda;
  return [
    (lambda2 * 180 / Math.PI + 540) % 360 - 180,
    phi2 * 180 / Math.PI
  ];
}
function transformTranslate(geojson, distance11, direction, options2) {
  options2 = options2 || {};
  if (!isObject$k(options2))
    throw new Error("options is invalid");
  var units2 = options2.units;
  var zTranslation = options2.zTranslation;
  var mutate = options2.mutate;
  if (!geojson)
    throw new Error("geojson is required");
  if (distance11 === void 0 || distance11 === null || isNaN(distance11))
    throw new Error("distance is required");
  if (zTranslation && typeof zTranslation !== "number" && isNaN(zTranslation))
    throw new Error("zTranslation is not a number");
  zTranslation = zTranslation !== void 0 ? zTranslation : 0;
  if (distance11 === 0 && zTranslation === 0)
    return geojson;
  if (direction === void 0 || direction === null || isNaN(direction))
    throw new Error("direction is required");
  if (distance11 < 0) {
    distance11 = -distance11;
    direction = direction + 180;
  }
  if (mutate === false || mutate === void 0)
    geojson = clone$2(geojson);
  coordEach(geojson, function(pointCoords) {
    var newCoords = getCoords$6(
      rhumbDestination(pointCoords, distance11, direction, { units: units2 })
    );
    pointCoords[0] = newCoords[0];
    pointCoords[1] = newCoords[1];
    if (zTranslation && pointCoords.length === 3)
      pointCoords[2] += zTranslation;
  });
  return geojson;
}
function booleanPointInPolygon$1(point4, polygon4, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (!point4) {
    throw new Error("point is required");
  }
  if (!polygon4) {
    throw new Error("polygon is required");
  }
  var pt = getCoord$5(point4);
  var geom = getGeom(polygon4);
  var type = geom.type;
  var bbox2 = polygon4.bbox;
  var polys = geom.coordinates;
  if (bbox2 && inBBox$1(pt, bbox2) === false) {
    return false;
  }
  if (type === "Polygon") {
    polys = [polys];
  }
  var insidePoly = false;
  for (var i2 = 0; i2 < polys.length && !insidePoly; i2++) {
    if (inRing$1(pt, polys[i2][0], options2.ignoreBoundary)) {
      var inHole = false;
      var k2 = 1;
      while (k2 < polys[i2].length && !inHole) {
        if (inRing$1(pt, polys[i2][k2], !options2.ignoreBoundary)) {
          inHole = true;
        }
        k2++;
      }
      if (!inHole) {
        insidePoly = true;
      }
    }
  }
  return insidePoly;
}
function inRing$1(pt, ring, ignoreBoundary) {
  var isInside = false;
  if (ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1]) {
    ring = ring.slice(0, ring.length - 1);
  }
  for (var i2 = 0, j2 = ring.length - 1; i2 < ring.length; j2 = i2++) {
    var xi = ring[i2][0];
    var yi = ring[i2][1];
    var xj = ring[j2][0];
    var yj = ring[j2][1];
    var onBoundary = pt[1] * (xi - xj) + yi * (xj - pt[0]) + yj * (pt[0] - xi) === 0 && (xi - pt[0]) * (xj - pt[0]) <= 0 && (yi - pt[1]) * (yj - pt[1]) <= 0;
    if (onBoundary) {
      return !ignoreBoundary;
    }
    var intersect2 = yi > pt[1] !== yj > pt[1] && pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi;
    if (intersect2) {
      isInside = !isInside;
    }
  }
  return isInside;
}
function inBBox$1(pt, bbox2) {
  return bbox2[0] <= pt[0] && bbox2[1] <= pt[1] && bbox2[2] >= pt[0] && bbox2[3] >= pt[1];
}
function lineSegment$1(geojson) {
  if (!geojson) {
    throw new Error("geojson is required");
  }
  var results = [];
  flattenEach$3(geojson, function(feature2) {
    lineSegmentFeature$1(feature2, results);
  });
  return featureCollection$6(results);
}
function lineSegmentFeature$1(geojson, results) {
  var coords = [];
  var geometry2 = geojson.geometry;
  if (geometry2 !== null) {
    switch (geometry2.type) {
      case "Polygon":
        coords = getCoords$6(geometry2);
        break;
      case "LineString":
        coords = [getCoords$6(geometry2)];
    }
    coords.forEach(function(coord) {
      var segments = createSegments$1(coord, geojson.properties);
      segments.forEach(function(segment) {
        segment.id = results.length;
        results.push(segment);
      });
    });
  }
}
function createSegments$1(coords, properties) {
  var segments = [];
  coords.reduce(function(previousCoords, currentCoords) {
    var segment = lineString$5([previousCoords, currentCoords], properties);
    segment.bbox = bbox$1(previousCoords, currentCoords);
    segments.push(segment);
    return currentCoords;
  });
  return segments;
}
function bbox$1(coords1, coords2) {
  var x12 = coords1[0];
  var y12 = coords1[1];
  var x2 = coords2[0];
  var y2 = coords2[1];
  var west = x12 < x2 ? x12 : x2;
  var south = y12 < y2 ? y12 : y2;
  var east = x12 > x2 ? x12 : x2;
  var north = y12 > y2 ? y12 : y2;
  return [west, south, east, north];
}
var geojsonRbushExports = {};
var geojsonRbush$2 = {
  get exports() {
    return geojsonRbushExports;
  },
  set exports(v5) {
    geojsonRbushExports = v5;
  }
};
var rbush_minExports = {};
var rbush_min = {
  get exports() {
    return rbush_minExports;
  },
  set exports(v5) {
    rbush_minExports = v5;
  }
};
(function(module2, exports2) {
  !function(t2, i2) {
    module2.exports = i2();
  }(commonjsGlobal$1, function() {
    function t2(t3, r3, e4, a3, h3) {
      !function t4(n3, r4, e5, a4, h4) {
        for (; a4 > e5; ) {
          if (a4 - e5 > 600) {
            var o3 = a4 - e5 + 1, s3 = r4 - e5 + 1, l3 = Math.log(o3), f3 = 0.5 * Math.exp(2 * l3 / 3), u3 = 0.5 * Math.sqrt(l3 * f3 * (o3 - f3) / o3) * (s3 - o3 / 2 < 0 ? -1 : 1), m3 = Math.max(e5, Math.floor(r4 - s3 * f3 / o3 + u3)), c3 = Math.min(a4, Math.floor(r4 + (o3 - s3) * f3 / o3 + u3));
            t4(n3, r4, m3, c3, h4);
          }
          var p3 = n3[r4], d3 = e5, x2 = a4;
          for (i2(n3, e5, r4), h4(n3[a4], p3) > 0 && i2(n3, e5, a4); d3 < x2; ) {
            for (i2(n3, d3, x2), d3++, x2--; h4(n3[d3], p3) < 0; )
              d3++;
            for (; h4(n3[x2], p3) > 0; )
              x2--;
          }
          0 === h4(n3[e5], p3) ? i2(n3, e5, x2) : i2(n3, ++x2, a4), x2 <= r4 && (e5 = x2 + 1), r4 <= x2 && (a4 = x2 - 1);
        }
      }(t3, r3, e4 || 0, a3 || t3.length - 1, h3 || n2);
    }
    function i2(t3, i3, n3) {
      var r3 = t3[i3];
      t3[i3] = t3[n3], t3[n3] = r3;
    }
    function n2(t3, i3) {
      return t3 < i3 ? -1 : t3 > i3 ? 1 : 0;
    }
    var r2 = function(t3) {
      void 0 === t3 && (t3 = 9), this._maxEntries = Math.max(4, t3), this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries)), this.clear();
    };
    function e3(t3, i3, n3) {
      if (!n3)
        return i3.indexOf(t3);
      for (var r3 = 0; r3 < i3.length; r3++)
        if (n3(t3, i3[r3]))
          return r3;
      return -1;
    }
    function a2(t3, i3) {
      h2(t3, 0, t3.children.length, i3, t3);
    }
    function h2(t3, i3, n3, r3, e4) {
      e4 || (e4 = p2(null)), e4.minX = 1 / 0, e4.minY = 1 / 0, e4.maxX = -1 / 0, e4.maxY = -1 / 0;
      for (var a3 = i3; a3 < n3; a3++) {
        var h3 = t3.children[a3];
        o2(e4, t3.leaf ? r3(h3) : h3);
      }
      return e4;
    }
    function o2(t3, i3) {
      return t3.minX = Math.min(t3.minX, i3.minX), t3.minY = Math.min(t3.minY, i3.minY), t3.maxX = Math.max(t3.maxX, i3.maxX), t3.maxY = Math.max(t3.maxY, i3.maxY), t3;
    }
    function s2(t3, i3) {
      return t3.minX - i3.minX;
    }
    function l2(t3, i3) {
      return t3.minY - i3.minY;
    }
    function f2(t3) {
      return (t3.maxX - t3.minX) * (t3.maxY - t3.minY);
    }
    function u2(t3) {
      return t3.maxX - t3.minX + (t3.maxY - t3.minY);
    }
    function m2(t3, i3) {
      return t3.minX <= i3.minX && t3.minY <= i3.minY && i3.maxX <= t3.maxX && i3.maxY <= t3.maxY;
    }
    function c2(t3, i3) {
      return i3.minX <= t3.maxX && i3.minY <= t3.maxY && i3.maxX >= t3.minX && i3.maxY >= t3.minY;
    }
    function p2(t3) {
      return { children: t3, height: 1, leaf: true, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
    }
    function d2(i3, n3, r3, e4, a3) {
      for (var h3 = [n3, r3]; h3.length; )
        if (!((r3 = h3.pop()) - (n3 = h3.pop()) <= e4)) {
          var o3 = n3 + Math.ceil((r3 - n3) / e4 / 2) * e4;
          t2(i3, o3, n3, r3, a3), h3.push(n3, o3, o3, r3);
        }
    }
    return r2.prototype.all = function() {
      return this._all(this.data, []);
    }, r2.prototype.search = function(t3) {
      var i3 = this.data, n3 = [];
      if (!c2(t3, i3))
        return n3;
      for (var r3 = this.toBBox, e4 = []; i3; ) {
        for (var a3 = 0; a3 < i3.children.length; a3++) {
          var h3 = i3.children[a3], o3 = i3.leaf ? r3(h3) : h3;
          c2(t3, o3) && (i3.leaf ? n3.push(h3) : m2(t3, o3) ? this._all(h3, n3) : e4.push(h3));
        }
        i3 = e4.pop();
      }
      return n3;
    }, r2.prototype.collides = function(t3) {
      var i3 = this.data;
      if (!c2(t3, i3))
        return false;
      for (var n3 = []; i3; ) {
        for (var r3 = 0; r3 < i3.children.length; r3++) {
          var e4 = i3.children[r3], a3 = i3.leaf ? this.toBBox(e4) : e4;
          if (c2(t3, a3)) {
            if (i3.leaf || m2(t3, a3))
              return true;
            n3.push(e4);
          }
        }
        i3 = n3.pop();
      }
      return false;
    }, r2.prototype.load = function(t3) {
      if (!t3 || !t3.length)
        return this;
      if (t3.length < this._minEntries) {
        for (var i3 = 0; i3 < t3.length; i3++)
          this.insert(t3[i3]);
        return this;
      }
      var n3 = this._build(t3.slice(), 0, t3.length - 1, 0);
      if (this.data.children.length)
        if (this.data.height === n3.height)
          this._splitRoot(this.data, n3);
        else {
          if (this.data.height < n3.height) {
            var r3 = this.data;
            this.data = n3, n3 = r3;
          }
          this._insert(n3, this.data.height - n3.height - 1, true);
        }
      else
        this.data = n3;
      return this;
    }, r2.prototype.insert = function(t3) {
      return t3 && this._insert(t3, this.data.height - 1), this;
    }, r2.prototype.clear = function() {
      return this.data = p2([]), this;
    }, r2.prototype.remove = function(t3, i3) {
      if (!t3)
        return this;
      for (var n3, r3, a3, h3 = this.data, o3 = this.toBBox(t3), s3 = [], l3 = []; h3 || s3.length; ) {
        if (h3 || (h3 = s3.pop(), r3 = s3[s3.length - 1], n3 = l3.pop(), a3 = true), h3.leaf) {
          var f3 = e3(t3, h3.children, i3);
          if (-1 !== f3)
            return h3.children.splice(f3, 1), s3.push(h3), this._condense(s3), this;
        }
        a3 || h3.leaf || !m2(h3, o3) ? r3 ? (n3++, h3 = r3.children[n3], a3 = false) : h3 = null : (s3.push(h3), l3.push(n3), n3 = 0, r3 = h3, h3 = h3.children[0]);
      }
      return this;
    }, r2.prototype.toBBox = function(t3) {
      return t3;
    }, r2.prototype.compareMinX = function(t3, i3) {
      return t3.minX - i3.minX;
    }, r2.prototype.compareMinY = function(t3, i3) {
      return t3.minY - i3.minY;
    }, r2.prototype.toJSON = function() {
      return this.data;
    }, r2.prototype.fromJSON = function(t3) {
      return this.data = t3, this;
    }, r2.prototype._all = function(t3, i3) {
      for (var n3 = []; t3; )
        t3.leaf ? i3.push.apply(i3, t3.children) : n3.push.apply(n3, t3.children), t3 = n3.pop();
      return i3;
    }, r2.prototype._build = function(t3, i3, n3, r3) {
      var e4, h3 = n3 - i3 + 1, o3 = this._maxEntries;
      if (h3 <= o3)
        return a2(e4 = p2(t3.slice(i3, n3 + 1)), this.toBBox), e4;
      r3 || (r3 = Math.ceil(Math.log(h3) / Math.log(o3)), o3 = Math.ceil(h3 / Math.pow(o3, r3 - 1))), (e4 = p2([])).leaf = false, e4.height = r3;
      var s3 = Math.ceil(h3 / o3), l3 = s3 * Math.ceil(Math.sqrt(o3));
      d2(t3, i3, n3, l3, this.compareMinX);
      for (var f3 = i3; f3 <= n3; f3 += l3) {
        var u3 = Math.min(f3 + l3 - 1, n3);
        d2(t3, f3, u3, s3, this.compareMinY);
        for (var m3 = f3; m3 <= u3; m3 += s3) {
          var c3 = Math.min(m3 + s3 - 1, u3);
          e4.children.push(this._build(t3, m3, c3, r3 - 1));
        }
      }
      return a2(e4, this.toBBox), e4;
    }, r2.prototype._chooseSubtree = function(t3, i3, n3, r3) {
      for (; r3.push(i3), !i3.leaf && r3.length - 1 !== n3; ) {
        for (var e4 = 1 / 0, a3 = 1 / 0, h3 = void 0, o3 = 0; o3 < i3.children.length; o3++) {
          var s3 = i3.children[o3], l3 = f2(s3), u3 = (m3 = t3, c3 = s3, (Math.max(c3.maxX, m3.maxX) - Math.min(c3.minX, m3.minX)) * (Math.max(c3.maxY, m3.maxY) - Math.min(c3.minY, m3.minY)) - l3);
          u3 < a3 ? (a3 = u3, e4 = l3 < e4 ? l3 : e4, h3 = s3) : u3 === a3 && l3 < e4 && (e4 = l3, h3 = s3);
        }
        i3 = h3 || i3.children[0];
      }
      var m3, c3;
      return i3;
    }, r2.prototype._insert = function(t3, i3, n3) {
      var r3 = n3 ? t3 : this.toBBox(t3), e4 = [], a3 = this._chooseSubtree(r3, this.data, i3, e4);
      for (a3.children.push(t3), o2(a3, r3); i3 >= 0 && e4[i3].children.length > this._maxEntries; )
        this._split(e4, i3), i3--;
      this._adjustParentBBoxes(r3, e4, i3);
    }, r2.prototype._split = function(t3, i3) {
      var n3 = t3[i3], r3 = n3.children.length, e4 = this._minEntries;
      this._chooseSplitAxis(n3, e4, r3);
      var h3 = this._chooseSplitIndex(n3, e4, r3), o3 = p2(n3.children.splice(h3, n3.children.length - h3));
      o3.height = n3.height, o3.leaf = n3.leaf, a2(n3, this.toBBox), a2(o3, this.toBBox), i3 ? t3[i3 - 1].children.push(o3) : this._splitRoot(n3, o3);
    }, r2.prototype._splitRoot = function(t3, i3) {
      this.data = p2([t3, i3]), this.data.height = t3.height + 1, this.data.leaf = false, a2(this.data, this.toBBox);
    }, r2.prototype._chooseSplitIndex = function(t3, i3, n3) {
      for (var r3, e4, a3, o3, s3, l3, u3, m3 = 1 / 0, c3 = 1 / 0, p3 = i3; p3 <= n3 - i3; p3++) {
        var d3 = h2(t3, 0, p3, this.toBBox), x2 = h2(t3, p3, n3, this.toBBox), v5 = (e4 = d3, a3 = x2, o3 = void 0, s3 = void 0, l3 = void 0, u3 = void 0, o3 = Math.max(e4.minX, a3.minX), s3 = Math.max(e4.minY, a3.minY), l3 = Math.min(e4.maxX, a3.maxX), u3 = Math.min(e4.maxY, a3.maxY), Math.max(0, l3 - o3) * Math.max(0, u3 - s3)), M2 = f2(d3) + f2(x2);
        v5 < m3 ? (m3 = v5, r3 = p3, c3 = M2 < c3 ? M2 : c3) : v5 === m3 && M2 < c3 && (c3 = M2, r3 = p3);
      }
      return r3 || n3 - i3;
    }, r2.prototype._chooseSplitAxis = function(t3, i3, n3) {
      var r3 = t3.leaf ? this.compareMinX : s2, e4 = t3.leaf ? this.compareMinY : l2;
      this._allDistMargin(t3, i3, n3, r3) < this._allDistMargin(t3, i3, n3, e4) && t3.children.sort(r3);
    }, r2.prototype._allDistMargin = function(t3, i3, n3, r3) {
      t3.children.sort(r3);
      for (var e4 = this.toBBox, a3 = h2(t3, 0, i3, e4), s3 = h2(t3, n3 - i3, n3, e4), l3 = u2(a3) + u2(s3), f3 = i3; f3 < n3 - i3; f3++) {
        var m3 = t3.children[f3];
        o2(a3, t3.leaf ? e4(m3) : m3), l3 += u2(a3);
      }
      for (var c3 = n3 - i3 - 1; c3 >= i3; c3--) {
        var p3 = t3.children[c3];
        o2(s3, t3.leaf ? e4(p3) : p3), l3 += u2(s3);
      }
      return l3;
    }, r2.prototype._adjustParentBBoxes = function(t3, i3, n3) {
      for (var r3 = n3; r3 >= 0; r3--)
        o2(i3[r3], t3);
    }, r2.prototype._condense = function(t3) {
      for (var i3 = t3.length - 1, n3 = void 0; i3 >= 0; i3--)
        0 === t3[i3].children.length ? i3 > 0 ? (n3 = t3[i3 - 1].children).splice(n3.indexOf(t3[i3]), 1) : this.clear() : a2(t3[i3], this.toBBox);
    }, r2;
  });
})(rbush_min);
var rbush$1 = rbush_minExports;
var helpers = require$$6;
var meta$1 = require$$1$3;
var turfBBox$1 = require$$3.default;
var featureEach$1 = meta$1.featureEach;
meta$1.coordEach;
helpers.polygon;
var featureCollection$4 = helpers.featureCollection;
function geojsonRbush$1(maxEntries) {
  var tree = new rbush$1(maxEntries);
  tree.insert = function(feature2) {
    if (feature2.type !== "Feature")
      throw new Error("invalid feature");
    feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$1(feature2);
    return rbush$1.prototype.insert.call(this, feature2);
  };
  tree.load = function(features) {
    var load2 = [];
    if (Array.isArray(features)) {
      features.forEach(function(feature2) {
        if (feature2.type !== "Feature")
          throw new Error("invalid features");
        feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$1(feature2);
        load2.push(feature2);
      });
    } else {
      featureEach$1(features, function(feature2) {
        if (feature2.type !== "Feature")
          throw new Error("invalid features");
        feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$1(feature2);
        load2.push(feature2);
      });
    }
    return rbush$1.prototype.load.call(this, load2);
  };
  tree.remove = function(feature2, equals12) {
    if (feature2.type !== "Feature")
      throw new Error("invalid feature");
    feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox$1(feature2);
    return rbush$1.prototype.remove.call(this, feature2, equals12);
  };
  tree.clear = function() {
    return rbush$1.prototype.clear.call(this);
  };
  tree.search = function(geojson) {
    var features = rbush$1.prototype.search.call(this, this.toBBox(geojson));
    return featureCollection$4(features);
  };
  tree.collides = function(geojson) {
    return rbush$1.prototype.collides.call(this, this.toBBox(geojson));
  };
  tree.all = function() {
    var features = rbush$1.prototype.all.call(this);
    return featureCollection$4(features);
  };
  tree.toJSON = function() {
    return rbush$1.prototype.toJSON.call(this);
  };
  tree.fromJSON = function(json) {
    return rbush$1.prototype.fromJSON.call(this, json);
  };
  tree.toBBox = function(geojson) {
    var bbox2;
    if (geojson.bbox)
      bbox2 = geojson.bbox;
    else if (Array.isArray(geojson) && geojson.length === 4)
      bbox2 = geojson;
    else if (Array.isArray(geojson) && geojson.length === 6)
      bbox2 = [geojson[0], geojson[1], geojson[3], geojson[4]];
    else if (geojson.type === "Feature")
      bbox2 = turfBBox$1(geojson);
    else if (geojson.type === "FeatureCollection")
      bbox2 = turfBBox$1(geojson);
    else
      throw new Error("invalid geojson");
    return {
      minX: bbox2[0],
      minY: bbox2[1],
      maxX: bbox2[2],
      maxY: bbox2[3]
    };
  };
  return tree;
}
geojsonRbush$2.exports = geojsonRbush$1;
geojsonRbushExports.default = geojsonRbush$1;
function lineIntersect$1(line1, line2) {
  var unique2 = {};
  var results = [];
  if (line1.type === "LineString") {
    line1 = feature$a(line1);
  }
  if (line2.type === "LineString") {
    line2 = feature$a(line2);
  }
  if (line1.type === "Feature" && line2.type === "Feature" && line1.geometry !== null && line2.geometry !== null && line1.geometry.type === "LineString" && line2.geometry.type === "LineString" && line1.geometry.coordinates.length === 2 && line2.geometry.coordinates.length === 2) {
    var intersect2 = intersects$4(line1, line2);
    if (intersect2) {
      results.push(intersect2);
    }
    return featureCollection$6(results);
  }
  var tree = geojsonRbushExports();
  tree.load(lineSegment$1(line2));
  featureEach$3(lineSegment$1(line1), function(segment) {
    featureEach$3(tree.search(segment), function(match2) {
      var intersect3 = intersects$4(segment, match2);
      if (intersect3) {
        var key = getCoords$6(intersect3).join(",");
        if (!unique2[key]) {
          unique2[key] = true;
          results.push(intersect3);
        }
      }
    });
  });
  return featureCollection$6(results);
}
function intersects$4(line1, line2) {
  var coords1 = getCoords$6(line1);
  var coords2 = getCoords$6(line2);
  if (coords1.length !== 2) {
    throw new Error("<intersects> line1 must only contain 2 coordinates");
  }
  if (coords2.length !== 2) {
    throw new Error("<intersects> line2 must only contain 2 coordinates");
  }
  var x12 = coords1[0][0];
  var y12 = coords1[0][1];
  var x2 = coords1[1][0];
  var y2 = coords1[1][1];
  var x3 = coords2[0][0];
  var y3 = coords2[0][1];
  var x4 = coords2[1][0];
  var y4 = coords2[1][1];
  var denom = (y4 - y3) * (x2 - x12) - (x4 - x3) * (y2 - y12);
  var numeA = (x4 - x3) * (y12 - y3) - (y4 - y3) * (x12 - x3);
  var numeB = (x2 - x12) * (y12 - y3) - (y2 - y12) * (x12 - x3);
  if (denom === 0) {
    if (numeA === 0 && numeB === 0) {
      return null;
    }
    return null;
  }
  var uA = numeA / denom;
  var uB = numeB / denom;
  if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
    var x5 = x12 + uA * (x2 - x12);
    var y5 = y12 + uA * (y2 - y12);
    return point$5([x5, y5]);
  }
  return null;
}
function polygonToLine$1(poly2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = getGeom(poly2);
  if (!options2.properties && poly2.type === "Feature") {
    options2.properties = poly2.properties;
  }
  switch (geom.type) {
    case "Polygon":
      return polygonToLine$2(geom, options2);
    case "MultiPolygon":
      return multiPolygonToLine(geom, options2);
    default:
      throw new Error("invalid poly");
  }
}
function polygonToLine$2(poly2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = getGeom(poly2);
  var coords = geom.coordinates;
  var properties = options2.properties ? options2.properties : poly2.type === "Feature" ? poly2.properties : {};
  return coordsToLine$1(coords, properties);
}
function multiPolygonToLine(multiPoly, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var geom = getGeom(multiPoly);
  var coords = geom.coordinates;
  var properties = options2.properties ? options2.properties : multiPoly.type === "Feature" ? multiPoly.properties : {};
  var lines = [];
  coords.forEach(function(coord) {
    lines.push(coordsToLine$1(coord, properties));
  });
  return featureCollection$6(lines);
}
function coordsToLine$1(coords, properties) {
  if (coords.length > 1) {
    return multiLineString$2(coords, properties);
  }
  return lineString$5(coords[0], properties);
}
function booleanDisjoint$1(feature1, feature2) {
  var bool = true;
  flattenEach$3(feature1, function(flatten1) {
    flattenEach$3(feature2, function(flatten22) {
      if (bool === false) {
        return false;
      }
      bool = disjoint$1(flatten1.geometry, flatten22.geometry);
    });
  });
  return bool;
}
function disjoint$1(geom1, geom2) {
  switch (geom1.type) {
    case "Point":
      switch (geom2.type) {
        case "Point":
          return !compareCoords$1(geom1.coordinates, geom2.coordinates);
        case "LineString":
          return !isPointOnLine$1(geom2, geom1);
        case "Polygon":
          return !booleanPointInPolygon$1(geom1, geom2);
      }
      break;
    case "LineString":
      switch (geom2.type) {
        case "Point":
          return !isPointOnLine$1(geom1, geom2);
        case "LineString":
          return !isLineOnLine$1(geom1, geom2);
        case "Polygon":
          return !isLineInPoly$1(geom2, geom1);
      }
      break;
    case "Polygon":
      switch (geom2.type) {
        case "Point":
          return !booleanPointInPolygon$1(geom2, geom1);
        case "LineString":
          return !isLineInPoly$1(geom1, geom2);
        case "Polygon":
          return !isPolyInPoly$1(geom2, geom1);
      }
  }
  return false;
}
function isPointOnLine$1(lineString2, pt) {
  for (var i2 = 0; i2 < lineString2.coordinates.length - 1; i2++) {
    if (isPointOnLineSegment$1(lineString2.coordinates[i2], lineString2.coordinates[i2 + 1], pt.coordinates)) {
      return true;
    }
  }
  return false;
}
function isLineOnLine$1(lineString1, lineString2) {
  var doLinesIntersect = lineIntersect$1(lineString1, lineString2);
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isLineInPoly$1(polygon4, lineString2) {
  for (var _i = 0, _a3 = lineString2.coordinates; _i < _a3.length; _i++) {
    var coord = _a3[_i];
    if (booleanPointInPolygon$1(coord, polygon4)) {
      return true;
    }
  }
  var doLinesIntersect = lineIntersect$1(lineString2, polygonToLine$1(polygon4));
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isPolyInPoly$1(feature1, feature2) {
  for (var _i = 0, _a3 = feature1.coordinates[0]; _i < _a3.length; _i++) {
    var coord1 = _a3[_i];
    if (booleanPointInPolygon$1(coord1, feature2)) {
      return true;
    }
  }
  for (var _b3 = 0, _c2 = feature2.coordinates[0]; _b3 < _c2.length; _b3++) {
    var coord2 = _c2[_b3];
    if (booleanPointInPolygon$1(coord2, feature1)) {
      return true;
    }
  }
  var doLinesIntersect = lineIntersect$1(polygonToLine$1(feature1), polygonToLine$1(feature2));
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isPointOnLineSegment$1(lineSegmentStart, lineSegmentEnd, pt) {
  var dxc = pt[0] - lineSegmentStart[0];
  var dyc = pt[1] - lineSegmentStart[1];
  var dxl = lineSegmentEnd[0] - lineSegmentStart[0];
  var dyl = lineSegmentEnd[1] - lineSegmentStart[1];
  var cross2 = dxc * dyl - dyc * dxl;
  if (cross2 !== 0) {
    return false;
  }
  if (Math.abs(dxl) >= Math.abs(dyl)) {
    if (dxl > 0) {
      return lineSegmentStart[0] <= pt[0] && pt[0] <= lineSegmentEnd[0];
    } else {
      return lineSegmentEnd[0] <= pt[0] && pt[0] <= lineSegmentStart[0];
    }
  } else if (dyl > 0) {
    return lineSegmentStart[1] <= pt[1] && pt[1] <= lineSegmentEnd[1];
  } else {
    return lineSegmentEnd[1] <= pt[1] && pt[1] <= lineSegmentStart[1];
  }
}
function compareCoords$1(pair1, pair2) {
  return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
var deepEqual$2 = deepEqual_1;
var Equality = function(opt) {
  this.precision = opt && opt.precision ? opt.precision : 17;
  this.direction = opt && opt.direction ? opt.direction : false;
  this.pseudoNode = opt && opt.pseudoNode ? opt.pseudoNode : false;
  this.objectComparator = opt && opt.objectComparator ? opt.objectComparator : objectComparator;
};
Equality.prototype.compare = function(g1, g2) {
  if (g1.type !== g2.type || !sameLength(g1, g2))
    return false;
  switch (g1.type) {
    case "Point":
      return this.compareCoord(g1.coordinates, g2.coordinates);
    case "LineString":
      return this.compareLine(g1.coordinates, g2.coordinates, 0, false);
    case "Polygon":
      return this.comparePolygon(g1, g2);
    case "Feature":
      return this.compareFeature(g1, g2);
    default:
      if (g1.type.indexOf("Multi") === 0) {
        var context2 = this;
        var g1s = explode(g1);
        var g2s = explode(g2);
        return g1s.every(function(g1part) {
          return this.some(function(g2part) {
            return context2.compare(g1part, g2part);
          });
        }, g2s);
      }
  }
  return false;
};
function explode(g2) {
  return g2.coordinates.map(function(part) {
    return {
      type: g2.type.replace("Multi", ""),
      coordinates: part
    };
  });
}
function sameLength(g1, g2) {
  return g1.hasOwnProperty("coordinates") ? g1.coordinates.length === g2.coordinates.length : g1.length === g2.length;
}
Equality.prototype.compareCoord = function(c1, c2) {
  if (c1.length !== c2.length) {
    return false;
  }
  for (var i2 = 0; i2 < c1.length; i2++) {
    if (c1[i2].toFixed(this.precision) !== c2[i2].toFixed(this.precision)) {
      return false;
    }
  }
  return true;
};
Equality.prototype.compareLine = function(path1, path2, ind, isPoly) {
  if (!sameLength(path1, path2))
    return false;
  var p1 = this.pseudoNode ? path1 : this.removePseudo(path1);
  var p2 = this.pseudoNode ? path2 : this.removePseudo(path2);
  if (isPoly && !this.compareCoord(p1[0], p2[0])) {
    p2 = this.fixStartIndex(p2, p1);
    if (!p2)
      return;
  }
  var sameDirection = this.compareCoord(p1[ind], p2[ind]);
  if (this.direction || sameDirection) {
    return this.comparePath(p1, p2);
  } else {
    if (this.compareCoord(p1[ind], p2[p2.length - (1 + ind)])) {
      return this.comparePath(p1.slice().reverse(), p2);
    }
    return false;
  }
};
Equality.prototype.fixStartIndex = function(sourcePath, targetPath) {
  var correctPath, ind = -1;
  for (var i2 = 0; i2 < sourcePath.length; i2++) {
    if (this.compareCoord(sourcePath[i2], targetPath[0])) {
      ind = i2;
      break;
    }
  }
  if (ind >= 0) {
    correctPath = [].concat(
      sourcePath.slice(ind, sourcePath.length),
      sourcePath.slice(1, ind + 1)
    );
  }
  return correctPath;
};
Equality.prototype.comparePath = function(p1, p2) {
  var cont = this;
  return p1.every(function(c2, i2) {
    return cont.compareCoord(c2, this[i2]);
  }, p2);
};
Equality.prototype.comparePolygon = function(g1, g2) {
  if (this.compareLine(g1.coordinates[0], g2.coordinates[0], 1, true)) {
    var holes1 = g1.coordinates.slice(1, g1.coordinates.length);
    var holes2 = g2.coordinates.slice(1, g2.coordinates.length);
    var cont = this;
    return holes1.every(function(h1) {
      return this.some(function(h2) {
        return cont.compareLine(h1, h2, 1, true);
      });
    }, holes2);
  } else {
    return false;
  }
};
Equality.prototype.compareFeature = function(g1, g2) {
  if (g1.id !== g2.id || !this.objectComparator(g1.properties, g2.properties) || !this.compareBBox(g1, g2)) {
    return false;
  }
  return this.compare(g1.geometry, g2.geometry);
};
Equality.prototype.compareBBox = function(g1, g2) {
  if (!g1.bbox && !g2.bbox || g1.bbox && g2.bbox && this.compareCoord(g1.bbox, g2.bbox)) {
    return true;
  }
  return false;
};
Equality.prototype.removePseudo = function(path2) {
  return path2;
};
function objectComparator(obj1, obj2) {
  return deepEqual$2(obj1, obj2, { strict: true });
}
var geojsonEquality = Equality;
const GeojsonEquality = geojsonEquality;
function booleanOverlap(feature1, feature2) {
  var geom1 = getGeom(feature1);
  var geom2 = getGeom(feature2);
  var type1 = geom1.type;
  var type2 = geom2.type;
  if (type1 === "MultiPoint" && type2 !== "MultiPoint" || (type1 === "LineString" || type1 === "MultiLineString") && type2 !== "LineString" && type2 !== "MultiLineString" || (type1 === "Polygon" || type1 === "MultiPolygon") && type2 !== "Polygon" && type2 !== "MultiPolygon") {
    throw new Error("features must be of the same type");
  }
  if (type1 === "Point")
    throw new Error("Point geometry not supported");
  var equality = new GeojsonEquality({ precision: 6 });
  if (equality.compare(feature1, feature2))
    return false;
  var overlap2 = 0;
  switch (type1) {
    case "MultiPoint":
      for (var i2 = 0; i2 < geom1.coordinates.length; i2++) {
        for (var j2 = 0; j2 < geom2.coordinates.length; j2++) {
          var coord1 = geom1.coordinates[i2];
          var coord2 = geom2.coordinates[j2];
          if (coord1[0] === coord2[0] && coord1[1] === coord2[1]) {
            return true;
          }
        }
      }
      return false;
    case "LineString":
    case "MultiLineString":
      segmentEach(feature1, function(segment1) {
        segmentEach(feature2, function(segment2) {
          if (lineOverlap(segment1, segment2).features.length)
            overlap2++;
        });
      });
      break;
    case "Polygon":
    case "MultiPolygon":
      segmentEach(feature1, function(segment1) {
        segmentEach(feature2, function(segment2) {
          if (lineIntersect$2(segment1, segment2).features.length)
            overlap2++;
        });
      });
      break;
  }
  return overlap2 > 0;
}
function booleanIntersects(feature1, feature2) {
  var bool = false;
  flattenEach$3(feature1, function(flatten1) {
    flattenEach$3(feature2, function(flatten22) {
      if (bool === true) {
        return true;
      }
      bool = !booleanDisjoint$1(flatten1.geometry, flatten22.geometry);
    });
  });
  return bool;
}
function center(geojson, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var ext = bbox$3(geojson);
  var x2 = (ext[0] + ext[2]) / 2;
  var y2 = (ext[1] + ext[3]) / 2;
  return point$5([x2, y2], options2.properties, options2);
}
if (!("fill" in Array.prototype)) {
  Object.defineProperty(Array.prototype, "fill", {
    configurable: true,
    value: function fill(value) {
      if (this === void 0 || this === null) {
        throw new TypeError(this + " is not an object");
      }
      var arrayLike = Object(this);
      var length2 = Math.max(Math.min(arrayLike.length, 9007199254740991), 0) || 0;
      var relativeStart = 1 in arguments ? parseInt(Number(arguments[1]), 10) || 0 : 0;
      relativeStart = relativeStart < 0 ? Math.max(length2 + relativeStart, 0) : Math.min(relativeStart, length2);
      var relativeEnd = 2 in arguments && arguments[2] !== void 0 ? parseInt(Number(arguments[2]), 10) || 0 : length2;
      relativeEnd = relativeEnd < 0 ? Math.max(length2 + arguments[2], 0) : Math.min(relativeEnd, length2);
      while (relativeStart < relativeEnd) {
        arrayLike[relativeStart] = value;
        ++relativeStart;
      }
      return arrayLike;
    },
    writable: true
  });
}
Number.isFinite = Number.isFinite || function(value) {
  return typeof value === "number" && isFinite(value);
};
Number.isInteger = Number.isInteger || function(val) {
  return typeof val === "number" && isFinite(val) && Math.floor(val) === val;
};
Number.parseFloat = Number.parseFloat || parseFloat;
Number.isNaN = Number.isNaN || function(value) {
  return value !== value;
};
Math.trunc = Math.trunc || function(x2) {
  return x2 < 0 ? Math.ceil(x2) : Math.floor(x2);
};
var NumberUtil = function NumberUtil2() {
};
NumberUtil.prototype.interfaces_ = function interfaces_() {
  return [];
};
NumberUtil.prototype.getClass = function getClass() {
  return NumberUtil;
};
NumberUtil.prototype.equalsWithTolerance = function equalsWithTolerance(x12, x2, tolerance) {
  return Math.abs(x12 - x2) <= tolerance;
};
var IllegalArgumentException = function(Error2) {
  function IllegalArgumentException2(message2) {
    Error2.call(this, message2);
    this.name = "IllegalArgumentException";
    this.message = message2;
    this.stack = new Error2().stack;
  }
  if (Error2)
    IllegalArgumentException2.__proto__ = Error2;
  IllegalArgumentException2.prototype = Object.create(Error2 && Error2.prototype);
  IllegalArgumentException2.prototype.constructor = IllegalArgumentException2;
  return IllegalArgumentException2;
}(Error);
var Double = function Double2() {
};
var staticAccessors$1 = { MAX_VALUE: { configurable: true } };
Double.isNaN = function isNaN2(n2) {
  return Number.isNaN(n2);
};
Double.doubleToLongBits = function doubleToLongBits(n2) {
  return n2;
};
Double.longBitsToDouble = function longBitsToDouble(n2) {
  return n2;
};
Double.isInfinite = function isInfinite(n2) {
  return !Number.isFinite(n2);
};
staticAccessors$1.MAX_VALUE.get = function() {
  return Number.MAX_VALUE;
};
Object.defineProperties(Double, staticAccessors$1);
var Comparable = function Comparable2() {
};
var Clonable = function Clonable2() {
};
var Comparator = function Comparator2() {
};
function Serializable() {
}
var Coordinate = function Coordinate2() {
  this.x = null;
  this.y = null;
  this.z = null;
  if (arguments.length === 0) {
    this.x = 0;
    this.y = 0;
    this.z = Coordinate2.NULL_ORDINATE;
  } else if (arguments.length === 1) {
    var c2 = arguments[0];
    this.x = c2.x;
    this.y = c2.y;
    this.z = c2.z;
  } else if (arguments.length === 2) {
    this.x = arguments[0];
    this.y = arguments[1];
    this.z = Coordinate2.NULL_ORDINATE;
  } else if (arguments.length === 3) {
    this.x = arguments[0];
    this.y = arguments[1];
    this.z = arguments[2];
  }
};
var staticAccessors = { DimensionalComparator: { configurable: true }, serialVersionUID: { configurable: true }, NULL_ORDINATE: { configurable: true }, X: { configurable: true }, Y: { configurable: true }, Z: { configurable: true } };
Coordinate.prototype.setOrdinate = function setOrdinate(ordinateIndex, value) {
  switch (ordinateIndex) {
    case Coordinate.X:
      this.x = value;
      break;
    case Coordinate.Y:
      this.y = value;
      break;
    case Coordinate.Z:
      this.z = value;
      break;
    default:
      throw new IllegalArgumentException("Invalid ordinate index: " + ordinateIndex);
  }
};
Coordinate.prototype.equals2D = function equals2D() {
  if (arguments.length === 1) {
    var other = arguments[0];
    if (this.x !== other.x) {
      return false;
    }
    if (this.y !== other.y) {
      return false;
    }
    return true;
  } else if (arguments.length === 2) {
    var c2 = arguments[0];
    var tolerance = arguments[1];
    if (!NumberUtil.equalsWithTolerance(this.x, c2.x, tolerance)) {
      return false;
    }
    if (!NumberUtil.equalsWithTolerance(this.y, c2.y, tolerance)) {
      return false;
    }
    return true;
  }
};
Coordinate.prototype.getOrdinate = function getOrdinate(ordinateIndex) {
  switch (ordinateIndex) {
    case Coordinate.X:
      return this.x;
    case Coordinate.Y:
      return this.y;
    case Coordinate.Z:
      return this.z;
  }
  throw new IllegalArgumentException("Invalid ordinate index: " + ordinateIndex);
};
Coordinate.prototype.equals3D = function equals3D(other) {
  return this.x === other.x && this.y === other.y && ((this.z === other.z || Double.isNaN(this.z)) && Double.isNaN(other.z));
};
Coordinate.prototype.equals = function equals2(other) {
  if (!(other instanceof Coordinate)) {
    return false;
  }
  return this.equals2D(other);
};
Coordinate.prototype.equalInZ = function equalInZ(c2, tolerance) {
  return NumberUtil.equalsWithTolerance(this.z, c2.z, tolerance);
};
Coordinate.prototype.compareTo = function compareTo(o2) {
  var other = o2;
  if (this.x < other.x) {
    return -1;
  }
  if (this.x > other.x) {
    return 1;
  }
  if (this.y < other.y) {
    return -1;
  }
  if (this.y > other.y) {
    return 1;
  }
  return 0;
};
Coordinate.prototype.clone = function clone2() {
};
Coordinate.prototype.copy = function copy2() {
  return new Coordinate(this);
};
Coordinate.prototype.toString = function toString2() {
  return "(" + this.x + ", " + this.y + ", " + this.z + ")";
};
Coordinate.prototype.distance3D = function distance3D(c2) {
  var dx = this.x - c2.x;
  var dy = this.y - c2.y;
  var dz = this.z - c2.z;
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
};
Coordinate.prototype.distance = function distance2(c2) {
  var dx = this.x - c2.x;
  var dy = this.y - c2.y;
  return Math.sqrt(dx * dx + dy * dy);
};
Coordinate.prototype.hashCode = function hashCode2() {
  var result = 17;
  result = 37 * result + Coordinate.hashCode(this.x);
  result = 37 * result + Coordinate.hashCode(this.y);
  return result;
};
Coordinate.prototype.setCoordinate = function setCoordinate(other) {
  this.x = other.x;
  this.y = other.y;
  this.z = other.z;
};
Coordinate.prototype.interfaces_ = function interfaces_2() {
  return [Comparable, Clonable, Serializable];
};
Coordinate.prototype.getClass = function getClass2() {
  return Coordinate;
};
Coordinate.hashCode = function hashCode3() {
  if (arguments.length === 1) {
    var x2 = arguments[0];
    var f2 = Double.doubleToLongBits(x2);
    return Math.trunc((f2 ^ f2) >>> 32);
  }
};
staticAccessors.DimensionalComparator.get = function() {
  return DimensionalComparator;
};
staticAccessors.serialVersionUID.get = function() {
  return 6683108902428367e3;
};
staticAccessors.NULL_ORDINATE.get = function() {
  return Double.NaN;
};
staticAccessors.X.get = function() {
  return 0;
};
staticAccessors.Y.get = function() {
  return 1;
};
staticAccessors.Z.get = function() {
  return 2;
};
Object.defineProperties(Coordinate, staticAccessors);
var DimensionalComparator = function DimensionalComparator2(dimensionsToTest) {
  this._dimensionsToTest = 2;
  if (arguments.length === 0)
    ;
  else if (arguments.length === 1) {
    var dimensionsToTest$1 = arguments[0];
    if (dimensionsToTest$1 !== 2 && dimensionsToTest$1 !== 3) {
      throw new IllegalArgumentException("only 2 or 3 dimensions may be specified");
    }
    this._dimensionsToTest = dimensionsToTest$1;
  }
};
DimensionalComparator.prototype.compare = function compare(o1, o2) {
  var c1 = o1;
  var c2 = o2;
  var compX = DimensionalComparator.compare(c1.x, c2.x);
  if (compX !== 0) {
    return compX;
  }
  var compY = DimensionalComparator.compare(c1.y, c2.y);
  if (compY !== 0) {
    return compY;
  }
  if (this._dimensionsToTest <= 2) {
    return 0;
  }
  var compZ = DimensionalComparator.compare(c1.z, c2.z);
  return compZ;
};
DimensionalComparator.prototype.interfaces_ = function interfaces_3() {
  return [Comparator];
};
DimensionalComparator.prototype.getClass = function getClass3() {
  return DimensionalComparator;
};
DimensionalComparator.compare = function compare2(a2, b2) {
  if (a2 < b2) {
    return -1;
  }
  if (a2 > b2) {
    return 1;
  }
  if (Double.isNaN(a2)) {
    if (Double.isNaN(b2)) {
      return 0;
    }
    return -1;
  }
  if (Double.isNaN(b2)) {
    return 1;
  }
  return 0;
};
var CoordinateSequenceFactory = function CoordinateSequenceFactory2() {
};
CoordinateSequenceFactory.prototype.create = function create2() {
};
CoordinateSequenceFactory.prototype.interfaces_ = function interfaces_4() {
  return [];
};
CoordinateSequenceFactory.prototype.getClass = function getClass4() {
  return CoordinateSequenceFactory;
};
var Location = function Location2() {
};
var staticAccessors$4 = { INTERIOR: { configurable: true }, BOUNDARY: { configurable: true }, EXTERIOR: { configurable: true }, NONE: { configurable: true } };
Location.prototype.interfaces_ = function interfaces_5() {
  return [];
};
Location.prototype.getClass = function getClass5() {
  return Location;
};
Location.toLocationSymbol = function toLocationSymbol(locationValue) {
  switch (locationValue) {
    case Location.EXTERIOR:
      return "e";
    case Location.BOUNDARY:
      return "b";
    case Location.INTERIOR:
      return "i";
    case Location.NONE:
      return "-";
  }
  throw new IllegalArgumentException("Unknown location value: " + locationValue);
};
staticAccessors$4.INTERIOR.get = function() {
  return 0;
};
staticAccessors$4.BOUNDARY.get = function() {
  return 1;
};
staticAccessors$4.EXTERIOR.get = function() {
  return 2;
};
staticAccessors$4.NONE.get = function() {
  return -1;
};
Object.defineProperties(Location, staticAccessors$4);
var hasInterface = function(o2, i2) {
  return o2.interfaces_ && o2.interfaces_().indexOf(i2) > -1;
};
var MathUtil = function MathUtil2() {
};
var staticAccessors$5 = { LOG_10: { configurable: true } };
MathUtil.prototype.interfaces_ = function interfaces_6() {
  return [];
};
MathUtil.prototype.getClass = function getClass6() {
  return MathUtil;
};
MathUtil.log10 = function log10(x2) {
  var ln = Math.log(x2);
  if (Double.isInfinite(ln)) {
    return ln;
  }
  if (Double.isNaN(ln)) {
    return ln;
  }
  return ln / MathUtil.LOG_10;
};
MathUtil.min = function min(v12, v22, v32, v42) {
  var min4 = v12;
  if (v22 < min4) {
    min4 = v22;
  }
  if (v32 < min4) {
    min4 = v32;
  }
  if (v42 < min4) {
    min4 = v42;
  }
  return min4;
};
MathUtil.clamp = function clamp2() {
  if (typeof arguments[2] === "number" && (typeof arguments[0] === "number" && typeof arguments[1] === "number")) {
    var x2 = arguments[0];
    var min4 = arguments[1];
    var max3 = arguments[2];
    if (x2 < min4) {
      return min4;
    }
    if (x2 > max3) {
      return max3;
    }
    return x2;
  } else if (Number.isInteger(arguments[2]) && (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1]))) {
    var x$12 = arguments[0];
    var min$1 = arguments[1];
    var max$1 = arguments[2];
    if (x$12 < min$1) {
      return min$1;
    }
    if (x$12 > max$1) {
      return max$1;
    }
    return x$12;
  }
};
MathUtil.wrap = function wrap(index2, max3) {
  if (index2 < 0) {
    return max3 - -index2 % max3;
  }
  return index2 % max3;
};
MathUtil.max = function max() {
  if (arguments.length === 3) {
    var v12 = arguments[0];
    var v22 = arguments[1];
    var v32 = arguments[2];
    var max3 = v12;
    if (v22 > max3) {
      max3 = v22;
    }
    if (v32 > max3) {
      max3 = v32;
    }
    return max3;
  } else if (arguments.length === 4) {
    var v1$1 = arguments[0];
    var v2$1 = arguments[1];
    var v3$1 = arguments[2];
    var v42 = arguments[3];
    var max$1 = v1$1;
    if (v2$1 > max$1) {
      max$1 = v2$1;
    }
    if (v3$1 > max$1) {
      max$1 = v3$1;
    }
    if (v42 > max$1) {
      max$1 = v42;
    }
    return max$1;
  }
};
MathUtil.average = function average(x12, x2) {
  return (x12 + x2) / 2;
};
staticAccessors$5.LOG_10.get = function() {
  return Math.log(10);
};
Object.defineProperties(MathUtil, staticAccessors$5);
var StringBuffer = function StringBuffer2(str) {
  this.str = str;
};
StringBuffer.prototype.append = function append(e3) {
  this.str += e3;
};
StringBuffer.prototype.setCharAt = function setCharAt(i2, c2) {
  this.str = this.str.substr(0, i2) + c2 + this.str.substr(i2 + 1);
};
StringBuffer.prototype.toString = function toString3(e3) {
  return this.str;
};
var Integer = function Integer2(value) {
  this.value = value;
};
Integer.prototype.intValue = function intValue() {
  return this.value;
};
Integer.prototype.compareTo = function compareTo2(o2) {
  if (this.value < o2) {
    return -1;
  }
  if (this.value > o2) {
    return 1;
  }
  return 0;
};
Integer.isNaN = function isNaN3(n2) {
  return Number.isNaN(n2);
};
var Character = function Character2() {
};
Character.isWhitespace = function isWhitespace(c2) {
  return c2 <= 32 && c2 >= 0 || c2 === 127;
};
Character.toUpperCase = function toUpperCase(c2) {
  return c2.toUpperCase();
};
var DD = function DD2() {
  this._hi = 0;
  this._lo = 0;
  if (arguments.length === 0) {
    this.init(0);
  } else if (arguments.length === 1) {
    if (typeof arguments[0] === "number") {
      var x2 = arguments[0];
      this.init(x2);
    } else if (arguments[0] instanceof DD2) {
      var dd = arguments[0];
      this.init(dd);
    } else if (typeof arguments[0] === "string") {
      var str = arguments[0];
      DD2.call(this, DD2.parse(str));
    }
  } else if (arguments.length === 2) {
    var hi = arguments[0];
    var lo = arguments[1];
    this.init(hi, lo);
  }
};
var staticAccessors$7 = { PI: { configurable: true }, TWO_PI: { configurable: true }, PI_2: { configurable: true }, E: { configurable: true }, NaN: { configurable: true }, EPS: { configurable: true }, SPLIT: { configurable: true }, MAX_PRINT_DIGITS: { configurable: true }, TEN: { configurable: true }, ONE: { configurable: true }, SCI_NOT_EXPONENT_CHAR: { configurable: true }, SCI_NOT_ZERO: { configurable: true } };
DD.prototype.le = function le(y2) {
  return (this._hi < y2._hi || this._hi === y2._hi) && this._lo <= y2._lo;
};
DD.prototype.extractSignificantDigits = function extractSignificantDigits(insertDecimalPoint, magnitude2) {
  var y2 = this.abs();
  var mag = DD.magnitude(y2._hi);
  var scale5 = DD.TEN.pow(mag);
  y2 = y2.divide(scale5);
  if (y2.gt(DD.TEN)) {
    y2 = y2.divide(DD.TEN);
    mag += 1;
  } else if (y2.lt(DD.ONE)) {
    y2 = y2.multiply(DD.TEN);
    mag -= 1;
  }
  var decimalPointPos = mag + 1;
  var buf = new StringBuffer();
  var numDigits = DD.MAX_PRINT_DIGITS - 1;
  for (var i2 = 0; i2 <= numDigits; i2++) {
    if (insertDecimalPoint && i2 === decimalPointPos) {
      buf.append(".");
    }
    var digit = Math.trunc(y2._hi);
    if (digit < 0) {
      break;
    }
    var rebiasBy10 = false;
    var digitChar = 0;
    if (digit > 9) {
      rebiasBy10 = true;
      digitChar = "9";
    } else {
      digitChar = "0" + digit;
    }
    buf.append(digitChar);
    y2 = y2.subtract(DD.valueOf(digit)).multiply(DD.TEN);
    if (rebiasBy10) {
      y2.selfAdd(DD.TEN);
    }
    var continueExtractingDigits = true;
    var remMag = DD.magnitude(y2._hi);
    if (remMag < 0 && Math.abs(remMag) >= numDigits - i2) {
      continueExtractingDigits = false;
    }
    if (!continueExtractingDigits) {
      break;
    }
  }
  magnitude2[0] = mag;
  return buf.toString();
};
DD.prototype.sqr = function sqr() {
  return this.multiply(this);
};
DD.prototype.doubleValue = function doubleValue() {
  return this._hi + this._lo;
};
DD.prototype.subtract = function subtract2() {
  if (arguments[0] instanceof DD) {
    var y2 = arguments[0];
    return this.add(y2.negate());
  } else if (typeof arguments[0] === "number") {
    var y$12 = arguments[0];
    return this.add(-y$12);
  }
};
DD.prototype.equals = function equals3() {
  if (arguments.length === 1) {
    var y2 = arguments[0];
    return this._hi === y2._hi && this._lo === y2._lo;
  }
};
DD.prototype.isZero = function isZero() {
  return this._hi === 0 && this._lo === 0;
};
DD.prototype.selfSubtract = function selfSubtract() {
  if (arguments[0] instanceof DD) {
    var y2 = arguments[0];
    if (this.isNaN()) {
      return this;
    }
    return this.selfAdd(-y2._hi, -y2._lo);
  } else if (typeof arguments[0] === "number") {
    var y$12 = arguments[0];
    if (this.isNaN()) {
      return this;
    }
    return this.selfAdd(-y$12, 0);
  }
};
DD.prototype.getSpecialNumberString = function getSpecialNumberString() {
  if (this.isZero()) {
    return "0.0";
  }
  if (this.isNaN()) {
    return "NaN ";
  }
  return null;
};
DD.prototype.min = function min2(x2) {
  if (this.le(x2)) {
    return this;
  } else {
    return x2;
  }
};
DD.prototype.selfDivide = function selfDivide() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof DD) {
      var y2 = arguments[0];
      return this.selfDivide(y2._hi, y2._lo);
    } else if (typeof arguments[0] === "number") {
      var y$12 = arguments[0];
      return this.selfDivide(y$12, 0);
    }
  } else if (arguments.length === 2) {
    var yhi = arguments[0];
    var ylo = arguments[1];
    var hc = null;
    var tc = null;
    var hy = null;
    var ty = null;
    var C2 = null;
    var c2 = null;
    var U2 = null;
    var u2 = null;
    C2 = this._hi / yhi;
    c2 = DD.SPLIT * C2;
    hc = c2 - C2;
    u2 = DD.SPLIT * yhi;
    hc = c2 - hc;
    tc = C2 - hc;
    hy = u2 - yhi;
    U2 = C2 * yhi;
    hy = u2 - hy;
    ty = yhi - hy;
    u2 = hc * hy - U2 + hc * ty + tc * hy + tc * ty;
    c2 = (this._hi - U2 - u2 + this._lo - C2 * ylo) / yhi;
    u2 = C2 + c2;
    this._hi = u2;
    this._lo = C2 - u2 + c2;
    return this;
  }
};
DD.prototype.dump = function dump() {
  return "DD<" + this._hi + ", " + this._lo + ">";
};
DD.prototype.divide = function divide() {
  if (arguments[0] instanceof DD) {
    var y2 = arguments[0];
    var hc = null;
    var tc = null;
    var hy = null;
    var ty = null;
    var C2 = null;
    var c2 = null;
    var U2 = null;
    var u2 = null;
    C2 = this._hi / y2._hi;
    c2 = DD.SPLIT * C2;
    hc = c2 - C2;
    u2 = DD.SPLIT * y2._hi;
    hc = c2 - hc;
    tc = C2 - hc;
    hy = u2 - y2._hi;
    U2 = C2 * y2._hi;
    hy = u2 - hy;
    ty = y2._hi - hy;
    u2 = hc * hy - U2 + hc * ty + tc * hy + tc * ty;
    c2 = (this._hi - U2 - u2 + this._lo - C2 * y2._lo) / y2._hi;
    u2 = C2 + c2;
    var zhi = u2;
    var zlo = C2 - u2 + c2;
    return new DD(zhi, zlo);
  } else if (typeof arguments[0] === "number") {
    var y$12 = arguments[0];
    if (Double.isNaN(y$12)) {
      return DD.createNaN();
    }
    return DD.copy(this).selfDivide(y$12, 0);
  }
};
DD.prototype.ge = function ge(y2) {
  return (this._hi > y2._hi || this._hi === y2._hi) && this._lo >= y2._lo;
};
DD.prototype.pow = function pow(exp) {
  if (exp === 0) {
    return DD.valueOf(1);
  }
  var r2 = new DD(this);
  var s2 = DD.valueOf(1);
  var n2 = Math.abs(exp);
  if (n2 > 1) {
    while (n2 > 0) {
      if (n2 % 2 === 1) {
        s2.selfMultiply(r2);
      }
      n2 /= 2;
      if (n2 > 0) {
        r2 = r2.sqr();
      }
    }
  } else {
    s2 = r2;
  }
  if (exp < 0) {
    return s2.reciprocal();
  }
  return s2;
};
DD.prototype.ceil = function ceil() {
  if (this.isNaN()) {
    return DD.NaN;
  }
  var fhi = Math.ceil(this._hi);
  var flo = 0;
  if (fhi === this._hi) {
    flo = Math.ceil(this._lo);
  }
  return new DD(fhi, flo);
};
DD.prototype.compareTo = function compareTo3(o2) {
  var other = o2;
  if (this._hi < other._hi) {
    return -1;
  }
  if (this._hi > other._hi) {
    return 1;
  }
  if (this._lo < other._lo) {
    return -1;
  }
  if (this._lo > other._lo) {
    return 1;
  }
  return 0;
};
DD.prototype.rint = function rint() {
  if (this.isNaN()) {
    return this;
  }
  var plus5 = this.add(0.5);
  return plus5.floor();
};
DD.prototype.setValue = function setValue() {
  if (arguments[0] instanceof DD) {
    var value = arguments[0];
    this.init(value);
    return this;
  } else if (typeof arguments[0] === "number") {
    var value$1 = arguments[0];
    this.init(value$1);
    return this;
  }
};
DD.prototype.max = function max2(x2) {
  if (this.ge(x2)) {
    return this;
  } else {
    return x2;
  }
};
DD.prototype.sqrt = function sqrt2() {
  if (this.isZero()) {
    return DD.valueOf(0);
  }
  if (this.isNegative()) {
    return DD.NaN;
  }
  var x2 = 1 / Math.sqrt(this._hi);
  var ax2 = this._hi * x2;
  var axdd = DD.valueOf(ax2);
  var diffSq = this.subtract(axdd.sqr());
  var d2 = diffSq._hi * (x2 * 0.5);
  return axdd.add(d2);
};
DD.prototype.selfAdd = function selfAdd() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof DD) {
      var y2 = arguments[0];
      return this.selfAdd(y2._hi, y2._lo);
    } else if (typeof arguments[0] === "number") {
      var y$12 = arguments[0];
      var H2 = null;
      var h2 = null;
      var S2 = null;
      var s2 = null;
      var e3 = null;
      var f2 = null;
      S2 = this._hi + y$12;
      e3 = S2 - this._hi;
      s2 = S2 - e3;
      s2 = y$12 - e3 + (this._hi - s2);
      f2 = s2 + this._lo;
      H2 = S2 + f2;
      h2 = f2 + (S2 - H2);
      this._hi = H2 + h2;
      this._lo = h2 + (H2 - this._hi);
      return this;
    }
  } else if (arguments.length === 2) {
    var yhi = arguments[0];
    var ylo = arguments[1];
    var H$12 = null;
    var h$12 = null;
    var T2 = null;
    var t2 = null;
    var S$12 = null;
    var s$12 = null;
    var e$12 = null;
    var f$12 = null;
    S$12 = this._hi + yhi;
    T2 = this._lo + ylo;
    e$12 = S$12 - this._hi;
    f$12 = T2 - this._lo;
    s$12 = S$12 - e$12;
    t2 = T2 - f$12;
    s$12 = yhi - e$12 + (this._hi - s$12);
    t2 = ylo - f$12 + (this._lo - t2);
    e$12 = s$12 + T2;
    H$12 = S$12 + e$12;
    h$12 = e$12 + (S$12 - H$12);
    e$12 = t2 + h$12;
    var zhi = H$12 + e$12;
    var zlo = e$12 + (H$12 - zhi);
    this._hi = zhi;
    this._lo = zlo;
    return this;
  }
};
DD.prototype.selfMultiply = function selfMultiply() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof DD) {
      var y2 = arguments[0];
      return this.selfMultiply(y2._hi, y2._lo);
    } else if (typeof arguments[0] === "number") {
      var y$12 = arguments[0];
      return this.selfMultiply(y$12, 0);
    }
  } else if (arguments.length === 2) {
    var yhi = arguments[0];
    var ylo = arguments[1];
    var hx = null;
    var tx = null;
    var hy = null;
    var ty = null;
    var C2 = null;
    var c2 = null;
    C2 = DD.SPLIT * this._hi;
    hx = C2 - this._hi;
    c2 = DD.SPLIT * yhi;
    hx = C2 - hx;
    tx = this._hi - hx;
    hy = c2 - yhi;
    C2 = this._hi * yhi;
    hy = c2 - hy;
    ty = yhi - hy;
    c2 = hx * hy - C2 + hx * ty + tx * hy + tx * ty + (this._hi * ylo + this._lo * yhi);
    var zhi = C2 + c2;
    hx = C2 - zhi;
    var zlo = c2 + hx;
    this._hi = zhi;
    this._lo = zlo;
    return this;
  }
};
DD.prototype.selfSqr = function selfSqr() {
  return this.selfMultiply(this);
};
DD.prototype.floor = function floor2() {
  if (this.isNaN()) {
    return DD.NaN;
  }
  var fhi = Math.floor(this._hi);
  var flo = 0;
  if (fhi === this._hi) {
    flo = Math.floor(this._lo);
  }
  return new DD(fhi, flo);
};
DD.prototype.negate = function negate2() {
  if (this.isNaN()) {
    return this;
  }
  return new DD(-this._hi, -this._lo);
};
DD.prototype.clone = function clone3() {
};
DD.prototype.multiply = function multiply2() {
  if (arguments[0] instanceof DD) {
    var y2 = arguments[0];
    if (y2.isNaN()) {
      return DD.createNaN();
    }
    return DD.copy(this).selfMultiply(y2);
  } else if (typeof arguments[0] === "number") {
    var y$12 = arguments[0];
    if (Double.isNaN(y$12)) {
      return DD.createNaN();
    }
    return DD.copy(this).selfMultiply(y$12, 0);
  }
};
DD.prototype.isNaN = function isNaN4() {
  return Double.isNaN(this._hi);
};
DD.prototype.intValue = function intValue2() {
  return Math.trunc(this._hi);
};
DD.prototype.toString = function toString4() {
  var mag = DD.magnitude(this._hi);
  if (mag >= -3 && mag <= 20) {
    return this.toStandardNotation();
  }
  return this.toSciNotation();
};
DD.prototype.toStandardNotation = function toStandardNotation() {
  var specialStr = this.getSpecialNumberString();
  if (specialStr !== null) {
    return specialStr;
  }
  var magnitude2 = new Array(1).fill(null);
  var sigDigits = this.extractSignificantDigits(true, magnitude2);
  var decimalPointPos = magnitude2[0] + 1;
  var num = sigDigits;
  if (sigDigits.charAt(0) === ".") {
    num = "0" + sigDigits;
  } else if (decimalPointPos < 0) {
    num = "0." + DD.stringOfChar("0", -decimalPointPos) + sigDigits;
  } else if (sigDigits.indexOf(".") === -1) {
    var numZeroes = decimalPointPos - sigDigits.length;
    var zeroes = DD.stringOfChar("0", numZeroes);
    num = sigDigits + zeroes + ".0";
  }
  if (this.isNegative()) {
    return "-" + num;
  }
  return num;
};
DD.prototype.reciprocal = function reciprocal() {
  var hc = null;
  var tc = null;
  var hy = null;
  var ty = null;
  var C2 = null;
  var c2 = null;
  var U2 = null;
  var u2 = null;
  C2 = 1 / this._hi;
  c2 = DD.SPLIT * C2;
  hc = c2 - C2;
  u2 = DD.SPLIT * this._hi;
  hc = c2 - hc;
  tc = C2 - hc;
  hy = u2 - this._hi;
  U2 = C2 * this._hi;
  hy = u2 - hy;
  ty = this._hi - hy;
  u2 = hc * hy - U2 + hc * ty + tc * hy + tc * ty;
  c2 = (1 - U2 - u2 - C2 * this._lo) / this._hi;
  var zhi = C2 + c2;
  var zlo = C2 - zhi + c2;
  return new DD(zhi, zlo);
};
DD.prototype.toSciNotation = function toSciNotation() {
  if (this.isZero()) {
    return DD.SCI_NOT_ZERO;
  }
  var specialStr = this.getSpecialNumberString();
  if (specialStr !== null) {
    return specialStr;
  }
  var magnitude2 = new Array(1).fill(null);
  var digits = this.extractSignificantDigits(false, magnitude2);
  var expStr = DD.SCI_NOT_EXPONENT_CHAR + magnitude2[0];
  if (digits.charAt(0) === "0") {
    throw new Error("Found leading zero: " + digits);
  }
  var trailingDigits = "";
  if (digits.length > 1) {
    trailingDigits = digits.substring(1);
  }
  var digitsWithDecimal = digits.charAt(0) + "." + trailingDigits;
  if (this.isNegative()) {
    return "-" + digitsWithDecimal + expStr;
  }
  return digitsWithDecimal + expStr;
};
DD.prototype.abs = function abs2() {
  if (this.isNaN()) {
    return DD.NaN;
  }
  if (this.isNegative()) {
    return this.negate();
  }
  return new DD(this);
};
DD.prototype.isPositive = function isPositive() {
  return (this._hi > 0 || this._hi === 0) && this._lo > 0;
};
DD.prototype.lt = function lt(y2) {
  return (this._hi < y2._hi || this._hi === y2._hi) && this._lo < y2._lo;
};
DD.prototype.add = function add2() {
  if (arguments[0] instanceof DD) {
    var y2 = arguments[0];
    return DD.copy(this).selfAdd(y2);
  } else if (typeof arguments[0] === "number") {
    var y$12 = arguments[0];
    return DD.copy(this).selfAdd(y$12);
  }
};
DD.prototype.init = function init2() {
  if (arguments.length === 1) {
    if (typeof arguments[0] === "number") {
      var x2 = arguments[0];
      this._hi = x2;
      this._lo = 0;
    } else if (arguments[0] instanceof DD) {
      var dd = arguments[0];
      this._hi = dd._hi;
      this._lo = dd._lo;
    }
  } else if (arguments.length === 2) {
    var hi = arguments[0];
    var lo = arguments[1];
    this._hi = hi;
    this._lo = lo;
  }
};
DD.prototype.gt = function gt(y2) {
  return (this._hi > y2._hi || this._hi === y2._hi) && this._lo > y2._lo;
};
DD.prototype.isNegative = function isNegative() {
  return (this._hi < 0 || this._hi === 0) && this._lo < 0;
};
DD.prototype.trunc = function trunc() {
  if (this.isNaN()) {
    return DD.NaN;
  }
  if (this.isPositive()) {
    return this.floor();
  } else {
    return this.ceil();
  }
};
DD.prototype.signum = function signum() {
  if (this._hi > 0) {
    return 1;
  }
  if (this._hi < 0) {
    return -1;
  }
  if (this._lo > 0) {
    return 1;
  }
  if (this._lo < 0) {
    return -1;
  }
  return 0;
};
DD.prototype.interfaces_ = function interfaces_7() {
  return [Serializable, Comparable, Clonable];
};
DD.prototype.getClass = function getClass7() {
  return DD;
};
DD.sqr = function sqr2(x2) {
  return DD.valueOf(x2).selfMultiply(x2);
};
DD.valueOf = function valueOf() {
  if (typeof arguments[0] === "string") {
    var str = arguments[0];
    return DD.parse(str);
  } else if (typeof arguments[0] === "number") {
    var x2 = arguments[0];
    return new DD(x2);
  }
};
DD.sqrt = function sqrt3(x2) {
  return DD.valueOf(x2).sqrt();
};
DD.parse = function parse2(str) {
  var i2 = 0;
  var strlen = str.length;
  while (Character.isWhitespace(str.charAt(i2))) {
    i2++;
  }
  var isNegative4 = false;
  if (i2 < strlen) {
    var signCh = str.charAt(i2);
    if (signCh === "-" || signCh === "+") {
      i2++;
      if (signCh === "-") {
        isNegative4 = true;
      }
    }
  }
  var val = new DD();
  var numDigits = 0;
  var numBeforeDec = 0;
  var exp = 0;
  while (true) {
    if (i2 >= strlen) {
      break;
    }
    var ch2 = str.charAt(i2);
    i2++;
    if (Character.isDigit(ch2)) {
      var d2 = ch2 - "0";
      val.selfMultiply(DD.TEN);
      val.selfAdd(d2);
      numDigits++;
      continue;
    }
    if (ch2 === ".") {
      numBeforeDec = numDigits;
      continue;
    }
    if (ch2 === "e" || ch2 === "E") {
      var expStr = str.substring(i2);
      try {
        exp = Integer.parseInt(expStr);
      } catch (ex) {
        if (ex instanceof Error) {
          throw new Error("Invalid exponent " + expStr + " in string " + str);
        } else {
          throw ex;
        }
      } finally {
      }
      break;
    }
    throw new Error("Unexpected character '" + ch2 + "' at position " + i2 + " in string " + str);
  }
  var val2 = val;
  var numDecPlaces = numDigits - numBeforeDec - exp;
  if (numDecPlaces === 0) {
    val2 = val;
  } else if (numDecPlaces > 0) {
    var scale5 = DD.TEN.pow(numDecPlaces);
    val2 = val.divide(scale5);
  } else if (numDecPlaces < 0) {
    var scale$12 = DD.TEN.pow(-numDecPlaces);
    val2 = val.multiply(scale$12);
  }
  if (isNegative4) {
    return val2.negate();
  }
  return val2;
};
DD.createNaN = function createNaN() {
  return new DD(Double.NaN, Double.NaN);
};
DD.copy = function copy3(dd) {
  return new DD(dd);
};
DD.magnitude = function magnitude(x2) {
  var xAbs = Math.abs(x2);
  var xLog10 = Math.log(xAbs) / Math.log(10);
  var xMag = Math.trunc(Math.floor(xLog10));
  var xApprox = Math.pow(10, xMag);
  if (xApprox * 10 <= xAbs) {
    xMag += 1;
  }
  return xMag;
};
DD.stringOfChar = function stringOfChar(ch2, len2) {
  var buf = new StringBuffer();
  for (var i2 = 0; i2 < len2; i2++) {
    buf.append(ch2);
  }
  return buf.toString();
};
staticAccessors$7.PI.get = function() {
  return new DD(3.141592653589793, 12246467991473532e-32);
};
staticAccessors$7.TWO_PI.get = function() {
  return new DD(6.283185307179586, 24492935982947064e-32);
};
staticAccessors$7.PI_2.get = function() {
  return new DD(1.5707963267948966, 6123233995736766e-32);
};
staticAccessors$7.E.get = function() {
  return new DD(2.718281828459045, 14456468917292502e-32);
};
staticAccessors$7.NaN.get = function() {
  return new DD(Double.NaN, Double.NaN);
};
staticAccessors$7.EPS.get = function() {
  return 123259516440783e-46;
};
staticAccessors$7.SPLIT.get = function() {
  return 134217729;
};
staticAccessors$7.MAX_PRINT_DIGITS.get = function() {
  return 32;
};
staticAccessors$7.TEN.get = function() {
  return DD.valueOf(10);
};
staticAccessors$7.ONE.get = function() {
  return DD.valueOf(1);
};
staticAccessors$7.SCI_NOT_EXPONENT_CHAR.get = function() {
  return "E";
};
staticAccessors$7.SCI_NOT_ZERO.get = function() {
  return "0.0E0";
};
Object.defineProperties(DD, staticAccessors$7);
var CGAlgorithmsDD = function CGAlgorithmsDD2() {
};
var staticAccessors$6 = { DP_SAFE_EPSILON: { configurable: true } };
CGAlgorithmsDD.prototype.interfaces_ = function interfaces_8() {
  return [];
};
CGAlgorithmsDD.prototype.getClass = function getClass8() {
  return CGAlgorithmsDD;
};
CGAlgorithmsDD.orientationIndex = function orientationIndex(p1, p2, q2) {
  var index2 = CGAlgorithmsDD.orientationIndexFilter(p1, p2, q2);
  if (index2 <= 1) {
    return index2;
  }
  var dx1 = DD.valueOf(p2.x).selfAdd(-p1.x);
  var dy1 = DD.valueOf(p2.y).selfAdd(-p1.y);
  var dx2 = DD.valueOf(q2.x).selfAdd(-p2.x);
  var dy2 = DD.valueOf(q2.y).selfAdd(-p2.y);
  return dx1.selfMultiply(dy2).selfSubtract(dy1.selfMultiply(dx2)).signum();
};
CGAlgorithmsDD.signOfDet2x2 = function signOfDet2x2(x12, y12, x2, y2) {
  var det2 = x12.multiply(y2).selfSubtract(y12.multiply(x2));
  return det2.signum();
};
CGAlgorithmsDD.intersection = function intersection(p1, p2, q1, q2) {
  var denom1 = DD.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(DD.valueOf(p2.x).selfSubtract(p1.x));
  var denom2 = DD.valueOf(q2.x).selfSubtract(q1.x).selfMultiply(DD.valueOf(p2.y).selfSubtract(p1.y));
  var denom = denom1.subtract(denom2);
  var numx1 = DD.valueOf(q2.x).selfSubtract(q1.x).selfMultiply(DD.valueOf(p1.y).selfSubtract(q1.y));
  var numx2 = DD.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(DD.valueOf(p1.x).selfSubtract(q1.x));
  var numx = numx1.subtract(numx2);
  var fracP = numx.selfDivide(denom).doubleValue();
  var x2 = DD.valueOf(p1.x).selfAdd(DD.valueOf(p2.x).selfSubtract(p1.x).selfMultiply(fracP)).doubleValue();
  var numy1 = DD.valueOf(p2.x).selfSubtract(p1.x).selfMultiply(DD.valueOf(p1.y).selfSubtract(q1.y));
  var numy2 = DD.valueOf(p2.y).selfSubtract(p1.y).selfMultiply(DD.valueOf(p1.x).selfSubtract(q1.x));
  var numy = numy1.subtract(numy2);
  var fracQ = numy.selfDivide(denom).doubleValue();
  var y2 = DD.valueOf(q1.y).selfAdd(DD.valueOf(q2.y).selfSubtract(q1.y).selfMultiply(fracQ)).doubleValue();
  return new Coordinate(x2, y2);
};
CGAlgorithmsDD.orientationIndexFilter = function orientationIndexFilter(pa, pb, pc) {
  var detsum = null;
  var detleft = (pa.x - pc.x) * (pb.y - pc.y);
  var detright = (pa.y - pc.y) * (pb.x - pc.x);
  var det2 = detleft - detright;
  if (detleft > 0) {
    if (detright <= 0) {
      return CGAlgorithmsDD.signum(det2);
    } else {
      detsum = detleft + detright;
    }
  } else if (detleft < 0) {
    if (detright >= 0) {
      return CGAlgorithmsDD.signum(det2);
    } else {
      detsum = -detleft - detright;
    }
  } else {
    return CGAlgorithmsDD.signum(det2);
  }
  var errbound = CGAlgorithmsDD.DP_SAFE_EPSILON * detsum;
  if (det2 >= errbound || -det2 >= errbound) {
    return CGAlgorithmsDD.signum(det2);
  }
  return 2;
};
CGAlgorithmsDD.signum = function signum2(x2) {
  if (x2 > 0) {
    return 1;
  }
  if (x2 < 0) {
    return -1;
  }
  return 0;
};
staticAccessors$6.DP_SAFE_EPSILON.get = function() {
  return 1e-15;
};
Object.defineProperties(CGAlgorithmsDD, staticAccessors$6);
var CoordinateSequence = function CoordinateSequence2() {
};
var staticAccessors$8 = { X: { configurable: true }, Y: { configurable: true }, Z: { configurable: true }, M: { configurable: true } };
staticAccessors$8.X.get = function() {
  return 0;
};
staticAccessors$8.Y.get = function() {
  return 1;
};
staticAccessors$8.Z.get = function() {
  return 2;
};
staticAccessors$8.M.get = function() {
  return 3;
};
CoordinateSequence.prototype.setOrdinate = function setOrdinate2(index2, ordinateIndex, value) {
};
CoordinateSequence.prototype.size = function size2() {
};
CoordinateSequence.prototype.getOrdinate = function getOrdinate2(index2, ordinateIndex) {
};
CoordinateSequence.prototype.getCoordinate = function getCoordinate() {
};
CoordinateSequence.prototype.getCoordinateCopy = function getCoordinateCopy(i2) {
};
CoordinateSequence.prototype.getDimension = function getDimension() {
};
CoordinateSequence.prototype.getX = function getX(index2) {
};
CoordinateSequence.prototype.clone = function clone4() {
};
CoordinateSequence.prototype.expandEnvelope = function expandEnvelope(env) {
};
CoordinateSequence.prototype.copy = function copy4() {
};
CoordinateSequence.prototype.getY = function getY(index2) {
};
CoordinateSequence.prototype.toCoordinateArray = function toCoordinateArray() {
};
CoordinateSequence.prototype.interfaces_ = function interfaces_9() {
  return [Clonable];
};
CoordinateSequence.prototype.getClass = function getClass9() {
  return CoordinateSequence;
};
Object.defineProperties(CoordinateSequence, staticAccessors$8);
var Exception = function Exception2() {
};
var NotRepresentableException = function(Exception$$1) {
  function NotRepresentableException2() {
    Exception$$1.call(this, "Projective point not representable on the Cartesian plane.");
  }
  if (Exception$$1)
    NotRepresentableException2.__proto__ = Exception$$1;
  NotRepresentableException2.prototype = Object.create(Exception$$1 && Exception$$1.prototype);
  NotRepresentableException2.prototype.constructor = NotRepresentableException2;
  NotRepresentableException2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  NotRepresentableException2.prototype.getClass = function getClass169() {
    return NotRepresentableException2;
  };
  return NotRepresentableException2;
}(Exception);
var System = function System2() {
};
System.arraycopy = function arraycopy(src2, srcPos, dest, destPos, len2) {
  var c2 = 0;
  for (var i2 = srcPos; i2 < srcPos + len2; i2++) {
    dest[destPos + c2] = src2[i2];
    c2++;
  }
};
System.getProperty = function getProperty(name2) {
  return {
    "line.separator": "\n"
  }[name2];
};
var HCoordinate = function HCoordinate2() {
  this.x = null;
  this.y = null;
  this.w = null;
  if (arguments.length === 0) {
    this.x = 0;
    this.y = 0;
    this.w = 1;
  } else if (arguments.length === 1) {
    var p2 = arguments[0];
    this.x = p2.x;
    this.y = p2.y;
    this.w = 1;
  } else if (arguments.length === 2) {
    if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
      var _x2 = arguments[0];
      var _y2 = arguments[1];
      this.x = _x2;
      this.y = _y2;
      this.w = 1;
    } else if (arguments[0] instanceof HCoordinate2 && arguments[1] instanceof HCoordinate2) {
      var p1 = arguments[0];
      var p22 = arguments[1];
      this.x = p1.y * p22.w - p22.y * p1.w;
      this.y = p22.x * p1.w - p1.x * p22.w;
      this.w = p1.x * p22.y - p22.x * p1.y;
    } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Coordinate) {
      var p1$1 = arguments[0];
      var p2$1 = arguments[1];
      this.x = p1$1.y - p2$1.y;
      this.y = p2$1.x - p1$1.x;
      this.w = p1$1.x * p2$1.y - p2$1.x * p1$1.y;
    }
  } else if (arguments.length === 3) {
    var _x$1 = arguments[0];
    var _y$1 = arguments[1];
    var _w = arguments[2];
    this.x = _x$1;
    this.y = _y$1;
    this.w = _w;
  } else if (arguments.length === 4) {
    var p1$2 = arguments[0];
    var p2$2 = arguments[1];
    var q1 = arguments[2];
    var q2 = arguments[3];
    var px2 = p1$2.y - p2$2.y;
    var py2 = p2$2.x - p1$2.x;
    var pw = p1$2.x * p2$2.y - p2$2.x * p1$2.y;
    var qx = q1.y - q2.y;
    var qy = q2.x - q1.x;
    var qw = q1.x * q2.y - q2.x * q1.y;
    this.x = py2 * qw - qy * pw;
    this.y = qx * pw - px2 * qw;
    this.w = px2 * qy - qx * py2;
  }
};
HCoordinate.prototype.getY = function getY2() {
  var a2 = this.y / this.w;
  if (Double.isNaN(a2) || Double.isInfinite(a2)) {
    throw new NotRepresentableException();
  }
  return a2;
};
HCoordinate.prototype.getX = function getX2() {
  var a2 = this.x / this.w;
  if (Double.isNaN(a2) || Double.isInfinite(a2)) {
    throw new NotRepresentableException();
  }
  return a2;
};
HCoordinate.prototype.getCoordinate = function getCoordinate2() {
  var p2 = new Coordinate();
  p2.x = this.getX();
  p2.y = this.getY();
  return p2;
};
HCoordinate.prototype.interfaces_ = function interfaces_10() {
  return [];
};
HCoordinate.prototype.getClass = function getClass10() {
  return HCoordinate;
};
HCoordinate.intersection = function intersection2(p1, p2, q1, q2) {
  var px2 = p1.y - p2.y;
  var py2 = p2.x - p1.x;
  var pw = p1.x * p2.y - p2.x * p1.y;
  var qx = q1.y - q2.y;
  var qy = q2.x - q1.x;
  var qw = q1.x * q2.y - q2.x * q1.y;
  var x2 = py2 * qw - qy * pw;
  var y2 = qx * pw - px2 * qw;
  var w2 = px2 * qy - qx * py2;
  var xInt = x2 / w2;
  var yInt = y2 / w2;
  if (Double.isNaN(xInt) || (Double.isInfinite(xInt) || Double.isNaN(yInt)) || Double.isInfinite(yInt)) {
    throw new NotRepresentableException();
  }
  return new Coordinate(xInt, yInt);
};
var Envelope = function Envelope2() {
  this._minx = null;
  this._maxx = null;
  this._miny = null;
  this._maxy = null;
  if (arguments.length === 0) {
    this.init();
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Coordinate) {
      var p2 = arguments[0];
      this.init(p2.x, p2.x, p2.y, p2.y);
    } else if (arguments[0] instanceof Envelope2) {
      var env = arguments[0];
      this.init(env);
    }
  } else if (arguments.length === 2) {
    var p1 = arguments[0];
    var p22 = arguments[1];
    this.init(p1.x, p22.x, p1.y, p22.y);
  } else if (arguments.length === 4) {
    var x12 = arguments[0];
    var x2 = arguments[1];
    var y12 = arguments[2];
    var y2 = arguments[3];
    this.init(x12, x2, y12, y2);
  }
};
var staticAccessors$9 = { serialVersionUID: { configurable: true } };
Envelope.prototype.getArea = function getArea() {
  return this.getWidth() * this.getHeight();
};
Envelope.prototype.equals = function equals4(other) {
  if (!(other instanceof Envelope)) {
    return false;
  }
  var otherEnvelope = other;
  if (this.isNull()) {
    return otherEnvelope.isNull();
  }
  return this._maxx === otherEnvelope.getMaxX() && this._maxy === otherEnvelope.getMaxY() && this._minx === otherEnvelope.getMinX() && this._miny === otherEnvelope.getMinY();
};
Envelope.prototype.intersection = function intersection3(env) {
  if (this.isNull() || env.isNull() || !this.intersects(env)) {
    return new Envelope();
  }
  var intMinX = this._minx > env._minx ? this._minx : env._minx;
  var intMinY = this._miny > env._miny ? this._miny : env._miny;
  var intMaxX = this._maxx < env._maxx ? this._maxx : env._maxx;
  var intMaxY = this._maxy < env._maxy ? this._maxy : env._maxy;
  return new Envelope(intMinX, intMaxX, intMinY, intMaxY);
};
Envelope.prototype.isNull = function isNull() {
  return this._maxx < this._minx;
};
Envelope.prototype.getMaxX = function getMaxX() {
  return this._maxx;
};
Envelope.prototype.covers = function covers() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof Coordinate) {
      var p2 = arguments[0];
      return this.covers(p2.x, p2.y);
    } else if (arguments[0] instanceof Envelope) {
      var other = arguments[0];
      if (this.isNull() || other.isNull()) {
        return false;
      }
      return other.getMinX() >= this._minx && other.getMaxX() <= this._maxx && other.getMinY() >= this._miny && other.getMaxY() <= this._maxy;
    }
  } else if (arguments.length === 2) {
    var x2 = arguments[0];
    var y2 = arguments[1];
    if (this.isNull()) {
      return false;
    }
    return x2 >= this._minx && x2 <= this._maxx && y2 >= this._miny && y2 <= this._maxy;
  }
};
Envelope.prototype.intersects = function intersects2() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof Envelope) {
      var other = arguments[0];
      if (this.isNull() || other.isNull()) {
        return false;
      }
      return !(other._minx > this._maxx || other._maxx < this._minx || other._miny > this._maxy || other._maxy < this._miny);
    } else if (arguments[0] instanceof Coordinate) {
      var p2 = arguments[0];
      return this.intersects(p2.x, p2.y);
    }
  } else if (arguments.length === 2) {
    var x2 = arguments[0];
    var y2 = arguments[1];
    if (this.isNull()) {
      return false;
    }
    return !(x2 > this._maxx || x2 < this._minx || y2 > this._maxy || y2 < this._miny);
  }
};
Envelope.prototype.getMinY = function getMinY() {
  return this._miny;
};
Envelope.prototype.getMinX = function getMinX() {
  return this._minx;
};
Envelope.prototype.expandToInclude = function expandToInclude() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof Coordinate) {
      var p2 = arguments[0];
      this.expandToInclude(p2.x, p2.y);
    } else if (arguments[0] instanceof Envelope) {
      var other = arguments[0];
      if (other.isNull()) {
        return null;
      }
      if (this.isNull()) {
        this._minx = other.getMinX();
        this._maxx = other.getMaxX();
        this._miny = other.getMinY();
        this._maxy = other.getMaxY();
      } else {
        if (other._minx < this._minx) {
          this._minx = other._minx;
        }
        if (other._maxx > this._maxx) {
          this._maxx = other._maxx;
        }
        if (other._miny < this._miny) {
          this._miny = other._miny;
        }
        if (other._maxy > this._maxy) {
          this._maxy = other._maxy;
        }
      }
    }
  } else if (arguments.length === 2) {
    var x2 = arguments[0];
    var y2 = arguments[1];
    if (this.isNull()) {
      this._minx = x2;
      this._maxx = x2;
      this._miny = y2;
      this._maxy = y2;
    } else {
      if (x2 < this._minx) {
        this._minx = x2;
      }
      if (x2 > this._maxx) {
        this._maxx = x2;
      }
      if (y2 < this._miny) {
        this._miny = y2;
      }
      if (y2 > this._maxy) {
        this._maxy = y2;
      }
    }
  }
};
Envelope.prototype.minExtent = function minExtent() {
  if (this.isNull()) {
    return 0;
  }
  var w2 = this.getWidth();
  var h2 = this.getHeight();
  if (w2 < h2) {
    return w2;
  }
  return h2;
};
Envelope.prototype.getWidth = function getWidth() {
  if (this.isNull()) {
    return 0;
  }
  return this._maxx - this._minx;
};
Envelope.prototype.compareTo = function compareTo4(o2) {
  var env = o2;
  if (this.isNull()) {
    if (env.isNull()) {
      return 0;
    }
    return -1;
  } else {
    if (env.isNull()) {
      return 1;
    }
  }
  if (this._minx < env._minx) {
    return -1;
  }
  if (this._minx > env._minx) {
    return 1;
  }
  if (this._miny < env._miny) {
    return -1;
  }
  if (this._miny > env._miny) {
    return 1;
  }
  if (this._maxx < env._maxx) {
    return -1;
  }
  if (this._maxx > env._maxx) {
    return 1;
  }
  if (this._maxy < env._maxy) {
    return -1;
  }
  if (this._maxy > env._maxy) {
    return 1;
  }
  return 0;
};
Envelope.prototype.translate = function translate2(transX, transY) {
  if (this.isNull()) {
    return null;
  }
  this.init(this.getMinX() + transX, this.getMaxX() + transX, this.getMinY() + transY, this.getMaxY() + transY);
};
Envelope.prototype.toString = function toString5() {
  return "Env[" + this._minx + " : " + this._maxx + ", " + this._miny + " : " + this._maxy + "]";
};
Envelope.prototype.setToNull = function setToNull() {
  this._minx = 0;
  this._maxx = -1;
  this._miny = 0;
  this._maxy = -1;
};
Envelope.prototype.getHeight = function getHeight() {
  if (this.isNull()) {
    return 0;
  }
  return this._maxy - this._miny;
};
Envelope.prototype.maxExtent = function maxExtent() {
  if (this.isNull()) {
    return 0;
  }
  var w2 = this.getWidth();
  var h2 = this.getHeight();
  if (w2 > h2) {
    return w2;
  }
  return h2;
};
Envelope.prototype.expandBy = function expandBy() {
  if (arguments.length === 1) {
    var distance11 = arguments[0];
    this.expandBy(distance11, distance11);
  } else if (arguments.length === 2) {
    var deltaX = arguments[0];
    var deltaY = arguments[1];
    if (this.isNull()) {
      return null;
    }
    this._minx -= deltaX;
    this._maxx += deltaX;
    this._miny -= deltaY;
    this._maxy += deltaY;
    if (this._minx > this._maxx || this._miny > this._maxy) {
      this.setToNull();
    }
  }
};
Envelope.prototype.contains = function contains2() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof Envelope) {
      var other = arguments[0];
      return this.covers(other);
    } else if (arguments[0] instanceof Coordinate) {
      var p2 = arguments[0];
      return this.covers(p2);
    }
  } else if (arguments.length === 2) {
    var x2 = arguments[0];
    var y2 = arguments[1];
    return this.covers(x2, y2);
  }
};
Envelope.prototype.centre = function centre() {
  if (this.isNull()) {
    return null;
  }
  return new Coordinate((this.getMinX() + this.getMaxX()) / 2, (this.getMinY() + this.getMaxY()) / 2);
};
Envelope.prototype.init = function init3() {
  if (arguments.length === 0) {
    this.setToNull();
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Coordinate) {
      var p2 = arguments[0];
      this.init(p2.x, p2.x, p2.y, p2.y);
    } else if (arguments[0] instanceof Envelope) {
      var env = arguments[0];
      this._minx = env._minx;
      this._maxx = env._maxx;
      this._miny = env._miny;
      this._maxy = env._maxy;
    }
  } else if (arguments.length === 2) {
    var p1 = arguments[0];
    var p22 = arguments[1];
    this.init(p1.x, p22.x, p1.y, p22.y);
  } else if (arguments.length === 4) {
    var x12 = arguments[0];
    var x2 = arguments[1];
    var y12 = arguments[2];
    var y2 = arguments[3];
    if (x12 < x2) {
      this._minx = x12;
      this._maxx = x2;
    } else {
      this._minx = x2;
      this._maxx = x12;
    }
    if (y12 < y2) {
      this._miny = y12;
      this._maxy = y2;
    } else {
      this._miny = y2;
      this._maxy = y12;
    }
  }
};
Envelope.prototype.getMaxY = function getMaxY() {
  return this._maxy;
};
Envelope.prototype.distance = function distance3(env) {
  if (this.intersects(env)) {
    return 0;
  }
  var dx = 0;
  if (this._maxx < env._minx) {
    dx = env._minx - this._maxx;
  } else if (this._minx > env._maxx) {
    dx = this._minx - env._maxx;
  }
  var dy = 0;
  if (this._maxy < env._miny) {
    dy = env._miny - this._maxy;
  } else if (this._miny > env._maxy) {
    dy = this._miny - env._maxy;
  }
  if (dx === 0) {
    return dy;
  }
  if (dy === 0) {
    return dx;
  }
  return Math.sqrt(dx * dx + dy * dy);
};
Envelope.prototype.hashCode = function hashCode4() {
  var result = 17;
  result = 37 * result + Coordinate.hashCode(this._minx);
  result = 37 * result + Coordinate.hashCode(this._maxx);
  result = 37 * result + Coordinate.hashCode(this._miny);
  result = 37 * result + Coordinate.hashCode(this._maxy);
  return result;
};
Envelope.prototype.interfaces_ = function interfaces_11() {
  return [Comparable, Serializable];
};
Envelope.prototype.getClass = function getClass11() {
  return Envelope;
};
Envelope.intersects = function intersects3() {
  if (arguments.length === 3) {
    var p1 = arguments[0];
    var p2 = arguments[1];
    var q2 = arguments[2];
    if (q2.x >= (p1.x < p2.x ? p1.x : p2.x) && q2.x <= (p1.x > p2.x ? p1.x : p2.x) && (q2.y >= (p1.y < p2.y ? p1.y : p2.y) && q2.y <= (p1.y > p2.y ? p1.y : p2.y))) {
      return true;
    }
    return false;
  } else if (arguments.length === 4) {
    var p1$1 = arguments[0];
    var p2$1 = arguments[1];
    var q1 = arguments[2];
    var q22 = arguments[3];
    var minq = Math.min(q1.x, q22.x);
    var maxq = Math.max(q1.x, q22.x);
    var minp = Math.min(p1$1.x, p2$1.x);
    var maxp = Math.max(p1$1.x, p2$1.x);
    if (minp > maxq) {
      return false;
    }
    if (maxp < minq) {
      return false;
    }
    minq = Math.min(q1.y, q22.y);
    maxq = Math.max(q1.y, q22.y);
    minp = Math.min(p1$1.y, p2$1.y);
    maxp = Math.max(p1$1.y, p2$1.y);
    if (minp > maxq) {
      return false;
    }
    if (maxp < minq) {
      return false;
    }
    return true;
  }
};
staticAccessors$9.serialVersionUID.get = function() {
  return 5873921885273102e3;
};
Object.defineProperties(Envelope, staticAccessors$9);
var regExes = {
  "typeStr": /^\s*(\w+)\s*\(\s*(.*)\s*\)\s*$/,
  "emptyTypeStr": /^\s*(\w+)\s*EMPTY\s*$/,
  "spaces": /\s+/,
  "parenComma": /\)\s*,\s*\(/,
  "doubleParenComma": /\)\s*\)\s*,\s*\(\s*\(/,
  // can't use {2} here
  "trimParens": /^\s*\(?(.*?)\)?\s*$/
};
var WKTParser = function WKTParser2(geometryFactory) {
  this.geometryFactory = geometryFactory || new GeometryFactory();
};
WKTParser.prototype.read = function read(wkt2) {
  var geometry2, type, str;
  wkt2 = wkt2.replace(/[\n\r]/g, " ");
  var matches2 = regExes.typeStr.exec(wkt2);
  if (wkt2.search("EMPTY") !== -1) {
    matches2 = regExes.emptyTypeStr.exec(wkt2);
    matches2[2] = void 0;
  }
  if (matches2) {
    type = matches2[1].toLowerCase();
    str = matches2[2];
    if (parse$1$1[type]) {
      geometry2 = parse$1$1[type].apply(this, [str]);
    }
  }
  if (geometry2 === void 0) {
    throw new Error("Could not parse WKT " + wkt2);
  }
  return geometry2;
};
WKTParser.prototype.write = function write(geometry2) {
  return this.extractGeometry(geometry2);
};
WKTParser.prototype.extractGeometry = function extractGeometry(geometry2) {
  var type = geometry2.getGeometryType().toLowerCase();
  if (!extract$1[type]) {
    return null;
  }
  var wktType = type.toUpperCase();
  var data2;
  if (geometry2.isEmpty()) {
    data2 = wktType + " EMPTY";
  } else {
    data2 = wktType + "(" + extract$1[type].apply(this, [geometry2]) + ")";
  }
  return data2;
};
var extract$1 = {
  coordinate: function coordinate(coordinate$1) {
    return coordinate$1.x + " " + coordinate$1.y;
  },
  /**
   * Return a space delimited string of point coordinates.
   *
   * @param {Point}
   *          point
   * @return {String} A string of coordinates representing the point.
   */
  point: function point2(point$12) {
    return extract$1.coordinate.call(this, point$12._coordinates._coordinates[0]);
  },
  /**
   * Return a comma delimited string of point coordinates from a multipoint.
   *
   * @param {MultiPoint}
   *          multipoint
   * @return {String} A string of point coordinate strings representing the
   *         multipoint.
   */
  multipoint: function multipoint(multipoint$1) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = multipoint$1._geometries.length; i2 < len2; ++i2) {
      array2.push("(" + extract$1.point.apply(this$1$1, [multipoint$1._geometries[i2]]) + ")");
    }
    return array2.join(",");
  },
  /**
   * Return a comma delimited string of point coordinates from a line.
   *
   * @param {LineString} linestring
   * @return {String} A string of point coordinate strings representing the linestring.
   */
  linestring: function linestring(linestring$1) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = linestring$1._points._coordinates.length; i2 < len2; ++i2) {
      array2.push(extract$1.coordinate.apply(this$1$1, [linestring$1._points._coordinates[i2]]));
    }
    return array2.join(",");
  },
  linearring: function linearring2(linearring$1) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = linearring$1._points._coordinates.length; i2 < len2; ++i2) {
      array2.push(extract$1.coordinate.apply(this$1$1, [linearring$1._points._coordinates[i2]]));
    }
    return array2.join(",");
  },
  /**
   * Return a comma delimited string of linestring strings from a
   * multilinestring.
   *
   * @param {MultiLineString} multilinestring
   * @return {String} A string of of linestring strings representing the multilinestring.
   */
  multilinestring: function multilinestring(multilinestring$1) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = multilinestring$1._geometries.length; i2 < len2; ++i2) {
      array2.push("(" + extract$1.linestring.apply(this$1$1, [multilinestring$1._geometries[i2]]) + ")");
    }
    return array2.join(",");
  },
  /**
   * Return a comma delimited string of linear ring arrays from a polygon.
   *
   * @param {Polygon} polygon
   * @return {String} An array of linear ring arrays representing the polygon.
   */
  polygon: function polygon2(polygon$12) {
    var this$1$1 = this;
    var array2 = [];
    array2.push("(" + extract$1.linestring.apply(this, [polygon$12._shell]) + ")");
    for (var i2 = 0, len2 = polygon$12._holes.length; i2 < len2; ++i2) {
      array2.push("(" + extract$1.linestring.apply(this$1$1, [polygon$12._holes[i2]]) + ")");
    }
    return array2.join(",");
  },
  /**
   * Return an array of polygon arrays from a multipolygon.
   *
   * @param {MultiPolygon} multipolygon
   * @return {String} An array of polygon arrays representing the multipolygon.
   */
  multipolygon: function multipolygon(multipolygon$1) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = multipolygon$1._geometries.length; i2 < len2; ++i2) {
      array2.push("(" + extract$1.polygon.apply(this$1$1, [multipolygon$1._geometries[i2]]) + ")");
    }
    return array2.join(",");
  },
  /**
   * Return the WKT portion between 'GEOMETRYCOLLECTION(' and ')' for an
   * geometrycollection.
   *
   * @param {GeometryCollection} collection
   * @return {String} internal WKT representation of the collection.
   */
  geometrycollection: function geometrycollection(collection) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = collection._geometries.length; i2 < len2; ++i2) {
      array2.push(this$1$1.extractGeometry(collection._geometries[i2]));
    }
    return array2.join(",");
  }
};
var parse$1$1 = {
  /**
   * Return point geometry given a point WKT fragment.
   *
   * @param {String} str A WKT fragment representing the point.
   * @return {Point} A point geometry.
   * @private
   */
  point: function point3(str) {
    if (str === void 0) {
      return this.geometryFactory.createPoint();
    }
    var coords = str.trim().split(regExes.spaces);
    return this.geometryFactory.createPoint(new Coordinate(
      Number.parseFloat(coords[0]),
      Number.parseFloat(coords[1])
    ));
  },
  /**
   * Return a multipoint geometry given a multipoint WKT fragment.
   *
   * @param {String} str A WKT fragment representing the multipoint.
   * @return {Point} A multipoint feature.
   * @private
   */
  multipoint: function multipoint2(str) {
    var this$1$1 = this;
    if (str === void 0) {
      return this.geometryFactory.createMultiPoint();
    }
    var point4;
    var points2 = str.trim().split(",");
    var components = [];
    for (var i2 = 0, len2 = points2.length; i2 < len2; ++i2) {
      point4 = points2[i2].replace(regExes.trimParens, "$1");
      components.push(parse$1$1.point.apply(this$1$1, [point4]));
    }
    return this.geometryFactory.createMultiPoint(components);
  },
  /**
   * Return a linestring geometry given a linestring WKT fragment.
   *
   * @param {String} str A WKT fragment representing the linestring.
   * @return {LineString} A linestring geometry.
   * @private
   */
  linestring: function linestring2(str) {
    if (str === void 0) {
      return this.geometryFactory.createLineString();
    }
    var points2 = str.trim().split(",");
    var components = [];
    var coords;
    for (var i2 = 0, len2 = points2.length; i2 < len2; ++i2) {
      coords = points2[i2].trim().split(regExes.spaces);
      components.push(new Coordinate(Number.parseFloat(coords[0]), Number.parseFloat(coords[1])));
    }
    return this.geometryFactory.createLineString(components);
  },
  /**
   * Return a linearring geometry given a linearring WKT fragment.
   *
   * @param {String} str A WKT fragment representing the linearring.
   * @return {LinearRing} A linearring geometry.
   * @private
   */
  linearring: function linearring3(str) {
    if (str === void 0) {
      return this.geometryFactory.createLinearRing();
    }
    var points2 = str.trim().split(",");
    var components = [];
    var coords;
    for (var i2 = 0, len2 = points2.length; i2 < len2; ++i2) {
      coords = points2[i2].trim().split(regExes.spaces);
      components.push(new Coordinate(Number.parseFloat(coords[0]), Number.parseFloat(coords[1])));
    }
    return this.geometryFactory.createLinearRing(components);
  },
  /**
   * Return a multilinestring geometry given a multilinestring WKT fragment.
   *
   * @param {String} str A WKT fragment representing the multilinestring.
   * @return {MultiLineString} A multilinestring geometry.
   * @private
   */
  multilinestring: function multilinestring2(str) {
    var this$1$1 = this;
    if (str === void 0) {
      return this.geometryFactory.createMultiLineString();
    }
    var line;
    var lines = str.trim().split(regExes.parenComma);
    var components = [];
    for (var i2 = 0, len2 = lines.length; i2 < len2; ++i2) {
      line = lines[i2].replace(regExes.trimParens, "$1");
      components.push(parse$1$1.linestring.apply(this$1$1, [line]));
    }
    return this.geometryFactory.createMultiLineString(components);
  },
  /**
   * Return a polygon geometry given a polygon WKT fragment.
   *
   * @param {String} str A WKT fragment representing the polygon.
   * @return {Polygon} A polygon geometry.
   * @private
   */
  polygon: function polygon3(str) {
    var this$1$1 = this;
    if (str === void 0) {
      return this.geometryFactory.createPolygon();
    }
    var ring, linestring3, linearring4;
    var rings = str.trim().split(regExes.parenComma);
    var shell;
    var holes = [];
    for (var i2 = 0, len2 = rings.length; i2 < len2; ++i2) {
      ring = rings[i2].replace(regExes.trimParens, "$1");
      linestring3 = parse$1$1.linestring.apply(this$1$1, [ring]);
      linearring4 = this$1$1.geometryFactory.createLinearRing(linestring3._points);
      if (i2 === 0) {
        shell = linearring4;
      } else {
        holes.push(linearring4);
      }
    }
    return this.geometryFactory.createPolygon(shell, holes);
  },
  /**
   * Return a multipolygon geometry given a multipolygon WKT fragment.
   *
   * @param {String} str A WKT fragment representing the multipolygon.
   * @return {MultiPolygon} A multipolygon geometry.
   * @private
   */
  multipolygon: function multipolygon2(str) {
    var this$1$1 = this;
    if (str === void 0) {
      return this.geometryFactory.createMultiPolygon();
    }
    var polygon4;
    var polygons2 = str.trim().split(regExes.doubleParenComma);
    var components = [];
    for (var i2 = 0, len2 = polygons2.length; i2 < len2; ++i2) {
      polygon4 = polygons2[i2].replace(regExes.trimParens, "$1");
      components.push(parse$1$1.polygon.apply(this$1$1, [polygon4]));
    }
    return this.geometryFactory.createMultiPolygon(components);
  },
  /**
   * Return a geometrycollection given a geometrycollection WKT fragment.
   *
   * @param {String} str A WKT fragment representing the geometrycollection.
   * @return {GeometryCollection}
   * @private
   */
  geometrycollection: function geometrycollection2(str) {
    var this$1$1 = this;
    if (str === void 0) {
      return this.geometryFactory.createGeometryCollection();
    }
    str = str.replace(/,\s*([A-Za-z])/g, "|$1");
    var wktArray = str.trim().split("|");
    var components = [];
    for (var i2 = 0, len2 = wktArray.length; i2 < len2; ++i2) {
      components.push(this$1$1.read(wktArray[i2]));
    }
    return this.geometryFactory.createGeometryCollection(components);
  }
};
var WKTWriter = function WKTWriter2(geometryFactory) {
  this.parser = new WKTParser(geometryFactory);
};
WKTWriter.prototype.write = function write2(geometry2) {
  return this.parser.write(geometry2);
};
WKTWriter.toLineString = function toLineString(p0, p1) {
  if (arguments.length !== 2) {
    throw new Error("Not implemented");
  }
  return "LINESTRING ( " + p0.x + " " + p0.y + ", " + p1.x + " " + p1.y + " )";
};
var RuntimeException = function(Error2) {
  function RuntimeException2(message2) {
    Error2.call(this, message2);
    this.name = "RuntimeException";
    this.message = message2;
    this.stack = new Error2().stack;
  }
  if (Error2)
    RuntimeException2.__proto__ = Error2;
  RuntimeException2.prototype = Object.create(Error2 && Error2.prototype);
  RuntimeException2.prototype.constructor = RuntimeException2;
  return RuntimeException2;
}(Error);
var AssertionFailedException = function(RuntimeException$$1) {
  function AssertionFailedException2() {
    RuntimeException$$1.call(this);
    if (arguments.length === 0) {
      RuntimeException$$1.call(this);
    } else if (arguments.length === 1) {
      var message2 = arguments[0];
      RuntimeException$$1.call(this, message2);
    }
  }
  if (RuntimeException$$1)
    AssertionFailedException2.__proto__ = RuntimeException$$1;
  AssertionFailedException2.prototype = Object.create(RuntimeException$$1 && RuntimeException$$1.prototype);
  AssertionFailedException2.prototype.constructor = AssertionFailedException2;
  AssertionFailedException2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  AssertionFailedException2.prototype.getClass = function getClass169() {
    return AssertionFailedException2;
  };
  return AssertionFailedException2;
}(RuntimeException);
var Assert = function Assert2() {
};
Assert.prototype.interfaces_ = function interfaces_12() {
  return [];
};
Assert.prototype.getClass = function getClass12() {
  return Assert;
};
Assert.shouldNeverReachHere = function shouldNeverReachHere() {
  if (arguments.length === 0) {
    Assert.shouldNeverReachHere(null);
  } else if (arguments.length === 1) {
    var message2 = arguments[0];
    throw new AssertionFailedException("Should never reach here" + (message2 !== null ? ": " + message2 : ""));
  }
};
Assert.isTrue = function isTrue() {
  var assertion;
  var message2;
  if (arguments.length === 1) {
    assertion = arguments[0];
    Assert.isTrue(assertion, null);
  } else if (arguments.length === 2) {
    assertion = arguments[0];
    message2 = arguments[1];
    if (!assertion) {
      if (message2 === null) {
        throw new AssertionFailedException();
      } else {
        throw new AssertionFailedException(message2);
      }
    }
  }
};
Assert.equals = function equals5() {
  var expectedValue;
  var actualValue;
  var message2;
  if (arguments.length === 2) {
    expectedValue = arguments[0];
    actualValue = arguments[1];
    Assert.equals(expectedValue, actualValue, null);
  } else if (arguments.length === 3) {
    expectedValue = arguments[0];
    actualValue = arguments[1];
    message2 = arguments[2];
    if (!actualValue.equals(expectedValue)) {
      throw new AssertionFailedException("Expected " + expectedValue + " but encountered " + actualValue + (message2 !== null ? ": " + message2 : ""));
    }
  }
};
var LineIntersector = function LineIntersector2() {
  this._result = null;
  this._inputLines = Array(2).fill().map(function() {
    return Array(2);
  });
  this._intPt = new Array(2).fill(null);
  this._intLineIndex = null;
  this._isProper = null;
  this._pa = null;
  this._pb = null;
  this._precisionModel = null;
  this._intPt[0] = new Coordinate();
  this._intPt[1] = new Coordinate();
  this._pa = this._intPt[0];
  this._pb = this._intPt[1];
  this._result = 0;
};
var staticAccessors$10 = { DONT_INTERSECT: { configurable: true }, DO_INTERSECT: { configurable: true }, COLLINEAR: { configurable: true }, NO_INTERSECTION: { configurable: true }, POINT_INTERSECTION: { configurable: true }, COLLINEAR_INTERSECTION: { configurable: true } };
LineIntersector.prototype.getIndexAlongSegment = function getIndexAlongSegment(segmentIndex, intIndex) {
  this.computeIntLineIndex();
  return this._intLineIndex[segmentIndex][intIndex];
};
LineIntersector.prototype.getTopologySummary = function getTopologySummary() {
  var catBuf = new StringBuffer();
  if (this.isEndPoint()) {
    catBuf.append(" endpoint");
  }
  if (this._isProper) {
    catBuf.append(" proper");
  }
  if (this.isCollinear()) {
    catBuf.append(" collinear");
  }
  return catBuf.toString();
};
LineIntersector.prototype.computeIntersection = function computeIntersection(p1, p2, p3, p4) {
  this._inputLines[0][0] = p1;
  this._inputLines[0][1] = p2;
  this._inputLines[1][0] = p3;
  this._inputLines[1][1] = p4;
  this._result = this.computeIntersect(p1, p2, p3, p4);
};
LineIntersector.prototype.getIntersectionNum = function getIntersectionNum() {
  return this._result;
};
LineIntersector.prototype.computeIntLineIndex = function computeIntLineIndex() {
  if (arguments.length === 0) {
    if (this._intLineIndex === null) {
      this._intLineIndex = Array(2).fill().map(function() {
        return Array(2);
      });
      this.computeIntLineIndex(0);
      this.computeIntLineIndex(1);
    }
  } else if (arguments.length === 1) {
    var segmentIndex = arguments[0];
    var dist0 = this.getEdgeDistance(segmentIndex, 0);
    var dist1 = this.getEdgeDistance(segmentIndex, 1);
    if (dist0 > dist1) {
      this._intLineIndex[segmentIndex][0] = 0;
      this._intLineIndex[segmentIndex][1] = 1;
    } else {
      this._intLineIndex[segmentIndex][0] = 1;
      this._intLineIndex[segmentIndex][1] = 0;
    }
  }
};
LineIntersector.prototype.isProper = function isProper() {
  return this.hasIntersection() && this._isProper;
};
LineIntersector.prototype.setPrecisionModel = function setPrecisionModel(precisionModel) {
  this._precisionModel = precisionModel;
};
LineIntersector.prototype.isInteriorIntersection = function isInteriorIntersection() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    if (this.isInteriorIntersection(0)) {
      return true;
    }
    if (this.isInteriorIntersection(1)) {
      return true;
    }
    return false;
  } else if (arguments.length === 1) {
    var inputLineIndex = arguments[0];
    for (var i2 = 0; i2 < this._result; i2++) {
      if (!(this$1$1._intPt[i2].equals2D(this$1$1._inputLines[inputLineIndex][0]) || this$1$1._intPt[i2].equals2D(this$1$1._inputLines[inputLineIndex][1]))) {
        return true;
      }
    }
    return false;
  }
};
LineIntersector.prototype.getIntersection = function getIntersection(intIndex) {
  return this._intPt[intIndex];
};
LineIntersector.prototype.isEndPoint = function isEndPoint() {
  return this.hasIntersection() && !this._isProper;
};
LineIntersector.prototype.hasIntersection = function hasIntersection() {
  return this._result !== LineIntersector.NO_INTERSECTION;
};
LineIntersector.prototype.getEdgeDistance = function getEdgeDistance(segmentIndex, intIndex) {
  var dist2 = LineIntersector.computeEdgeDistance(this._intPt[intIndex], this._inputLines[segmentIndex][0], this._inputLines[segmentIndex][1]);
  return dist2;
};
LineIntersector.prototype.isCollinear = function isCollinear() {
  return this._result === LineIntersector.COLLINEAR_INTERSECTION;
};
LineIntersector.prototype.toString = function toString6() {
  return WKTWriter.toLineString(this._inputLines[0][0], this._inputLines[0][1]) + " - " + WKTWriter.toLineString(this._inputLines[1][0], this._inputLines[1][1]) + this.getTopologySummary();
};
LineIntersector.prototype.getEndpoint = function getEndpoint(segmentIndex, ptIndex) {
  return this._inputLines[segmentIndex][ptIndex];
};
LineIntersector.prototype.isIntersection = function isIntersection(pt) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this._result; i2++) {
    if (this$1$1._intPt[i2].equals2D(pt)) {
      return true;
    }
  }
  return false;
};
LineIntersector.prototype.getIntersectionAlongSegment = function getIntersectionAlongSegment(segmentIndex, intIndex) {
  this.computeIntLineIndex();
  return this._intPt[this._intLineIndex[segmentIndex][intIndex]];
};
LineIntersector.prototype.interfaces_ = function interfaces_13() {
  return [];
};
LineIntersector.prototype.getClass = function getClass13() {
  return LineIntersector;
};
LineIntersector.computeEdgeDistance = function computeEdgeDistance(p2, p0, p1) {
  var dx = Math.abs(p1.x - p0.x);
  var dy = Math.abs(p1.y - p0.y);
  var dist2 = -1;
  if (p2.equals(p0)) {
    dist2 = 0;
  } else if (p2.equals(p1)) {
    if (dx > dy) {
      dist2 = dx;
    } else {
      dist2 = dy;
    }
  } else {
    var pdx = Math.abs(p2.x - p0.x);
    var pdy = Math.abs(p2.y - p0.y);
    if (dx > dy) {
      dist2 = pdx;
    } else {
      dist2 = pdy;
    }
    if (dist2 === 0 && !p2.equals(p0)) {
      dist2 = Math.max(pdx, pdy);
    }
  }
  Assert.isTrue(!(dist2 === 0 && !p2.equals(p0)), "Bad distance calculation");
  return dist2;
};
LineIntersector.nonRobustComputeEdgeDistance = function nonRobustComputeEdgeDistance(p2, p1, p22) {
  var dx = p2.x - p1.x;
  var dy = p2.y - p1.y;
  var dist2 = Math.sqrt(dx * dx + dy * dy);
  Assert.isTrue(!(dist2 === 0 && !p2.equals(p1)), "Invalid distance calculation");
  return dist2;
};
staticAccessors$10.DONT_INTERSECT.get = function() {
  return 0;
};
staticAccessors$10.DO_INTERSECT.get = function() {
  return 1;
};
staticAccessors$10.COLLINEAR.get = function() {
  return 2;
};
staticAccessors$10.NO_INTERSECTION.get = function() {
  return 0;
};
staticAccessors$10.POINT_INTERSECTION.get = function() {
  return 1;
};
staticAccessors$10.COLLINEAR_INTERSECTION.get = function() {
  return 2;
};
Object.defineProperties(LineIntersector, staticAccessors$10);
var RobustLineIntersector = function(LineIntersector$$1) {
  function RobustLineIntersector2() {
    LineIntersector$$1.apply(this, arguments);
  }
  if (LineIntersector$$1)
    RobustLineIntersector2.__proto__ = LineIntersector$$1;
  RobustLineIntersector2.prototype = Object.create(LineIntersector$$1 && LineIntersector$$1.prototype);
  RobustLineIntersector2.prototype.constructor = RobustLineIntersector2;
  RobustLineIntersector2.prototype.isInSegmentEnvelopes = function isInSegmentEnvelopes(intPt) {
    var env0 = new Envelope(this._inputLines[0][0], this._inputLines[0][1]);
    var env1 = new Envelope(this._inputLines[1][0], this._inputLines[1][1]);
    return env0.contains(intPt) && env1.contains(intPt);
  };
  RobustLineIntersector2.prototype.computeIntersection = function computeIntersection2() {
    if (arguments.length === 3) {
      var p2 = arguments[0];
      var p1 = arguments[1];
      var p22 = arguments[2];
      this._isProper = false;
      if (Envelope.intersects(p1, p22, p2)) {
        if (CGAlgorithms.orientationIndex(p1, p22, p2) === 0 && CGAlgorithms.orientationIndex(p22, p1, p2) === 0) {
          this._isProper = true;
          if (p2.equals(p1) || p2.equals(p22)) {
            this._isProper = false;
          }
          this._result = LineIntersector$$1.POINT_INTERSECTION;
          return null;
        }
      }
      this._result = LineIntersector$$1.NO_INTERSECTION;
    } else {
      return LineIntersector$$1.prototype.computeIntersection.apply(this, arguments);
    }
  };
  RobustLineIntersector2.prototype.normalizeToMinimum = function normalizeToMinimum(n1, n2, n3, n4, normPt) {
    normPt.x = this.smallestInAbsValue(n1.x, n2.x, n3.x, n4.x);
    normPt.y = this.smallestInAbsValue(n1.y, n2.y, n3.y, n4.y);
    n1.x -= normPt.x;
    n1.y -= normPt.y;
    n2.x -= normPt.x;
    n2.y -= normPt.y;
    n3.x -= normPt.x;
    n3.y -= normPt.y;
    n4.x -= normPt.x;
    n4.y -= normPt.y;
  };
  RobustLineIntersector2.prototype.safeHCoordinateIntersection = function safeHCoordinateIntersection(p1, p2, q1, q2) {
    var intPt = null;
    try {
      intPt = HCoordinate.intersection(p1, p2, q1, q2);
    } catch (e3) {
      if (e3 instanceof NotRepresentableException) {
        intPt = RobustLineIntersector2.nearestEndpoint(p1, p2, q1, q2);
      } else {
        throw e3;
      }
    } finally {
    }
    return intPt;
  };
  RobustLineIntersector2.prototype.intersection = function intersection8(p1, p2, q1, q2) {
    var intPt = this.intersectionWithNormalization(p1, p2, q1, q2);
    if (!this.isInSegmentEnvelopes(intPt)) {
      intPt = new Coordinate(RobustLineIntersector2.nearestEndpoint(p1, p2, q1, q2));
    }
    if (this._precisionModel !== null) {
      this._precisionModel.makePrecise(intPt);
    }
    return intPt;
  };
  RobustLineIntersector2.prototype.smallestInAbsValue = function smallestInAbsValue(x12, x2, x3, x4) {
    var x5 = x12;
    var xabs = Math.abs(x5);
    if (Math.abs(x2) < xabs) {
      x5 = x2;
      xabs = Math.abs(x2);
    }
    if (Math.abs(x3) < xabs) {
      x5 = x3;
      xabs = Math.abs(x3);
    }
    if (Math.abs(x4) < xabs) {
      x5 = x4;
    }
    return x5;
  };
  RobustLineIntersector2.prototype.checkDD = function checkDD(p1, p2, q1, q2, intPt) {
    var intPtDD = CGAlgorithmsDD.intersection(p1, p2, q1, q2);
    var isIn = this.isInSegmentEnvelopes(intPtDD);
    System.out.println("DD in env = " + isIn + "  --------------------- " + intPtDD);
    if (intPt.distance(intPtDD) > 1e-4) {
      System.out.println("Distance = " + intPt.distance(intPtDD));
    }
  };
  RobustLineIntersector2.prototype.intersectionWithNormalization = function intersectionWithNormalization(p1, p2, q1, q2) {
    var n1 = new Coordinate(p1);
    var n2 = new Coordinate(p2);
    var n3 = new Coordinate(q1);
    var n4 = new Coordinate(q2);
    var normPt = new Coordinate();
    this.normalizeToEnvCentre(n1, n2, n3, n4, normPt);
    var intPt = this.safeHCoordinateIntersection(n1, n2, n3, n4);
    intPt.x += normPt.x;
    intPt.y += normPt.y;
    return intPt;
  };
  RobustLineIntersector2.prototype.computeCollinearIntersection = function computeCollinearIntersection(p1, p2, q1, q2) {
    var p1q1p2 = Envelope.intersects(p1, p2, q1);
    var p1q2p2 = Envelope.intersects(p1, p2, q2);
    var q1p1q2 = Envelope.intersects(q1, q2, p1);
    var q1p2q2 = Envelope.intersects(q1, q2, p2);
    if (p1q1p2 && p1q2p2) {
      this._intPt[0] = q1;
      this._intPt[1] = q2;
      return LineIntersector$$1.COLLINEAR_INTERSECTION;
    }
    if (q1p1q2 && q1p2q2) {
      this._intPt[0] = p1;
      this._intPt[1] = p2;
      return LineIntersector$$1.COLLINEAR_INTERSECTION;
    }
    if (p1q1p2 && q1p1q2) {
      this._intPt[0] = q1;
      this._intPt[1] = p1;
      return q1.equals(p1) && !p1q2p2 && !q1p2q2 ? LineIntersector$$1.POINT_INTERSECTION : LineIntersector$$1.COLLINEAR_INTERSECTION;
    }
    if (p1q1p2 && q1p2q2) {
      this._intPt[0] = q1;
      this._intPt[1] = p2;
      return q1.equals(p2) && !p1q2p2 && !q1p1q2 ? LineIntersector$$1.POINT_INTERSECTION : LineIntersector$$1.COLLINEAR_INTERSECTION;
    }
    if (p1q2p2 && q1p1q2) {
      this._intPt[0] = q2;
      this._intPt[1] = p1;
      return q2.equals(p1) && !p1q1p2 && !q1p2q2 ? LineIntersector$$1.POINT_INTERSECTION : LineIntersector$$1.COLLINEAR_INTERSECTION;
    }
    if (p1q2p2 && q1p2q2) {
      this._intPt[0] = q2;
      this._intPt[1] = p2;
      return q2.equals(p2) && !p1q1p2 && !q1p1q2 ? LineIntersector$$1.POINT_INTERSECTION : LineIntersector$$1.COLLINEAR_INTERSECTION;
    }
    return LineIntersector$$1.NO_INTERSECTION;
  };
  RobustLineIntersector2.prototype.normalizeToEnvCentre = function normalizeToEnvCentre(n00, n01, n10, n11, normPt) {
    var minX0 = n00.x < n01.x ? n00.x : n01.x;
    var minY0 = n00.y < n01.y ? n00.y : n01.y;
    var maxX0 = n00.x > n01.x ? n00.x : n01.x;
    var maxY0 = n00.y > n01.y ? n00.y : n01.y;
    var minX1 = n10.x < n11.x ? n10.x : n11.x;
    var minY1 = n10.y < n11.y ? n10.y : n11.y;
    var maxX1 = n10.x > n11.x ? n10.x : n11.x;
    var maxY1 = n10.y > n11.y ? n10.y : n11.y;
    var intMinX = minX0 > minX1 ? minX0 : minX1;
    var intMaxX = maxX0 < maxX1 ? maxX0 : maxX1;
    var intMinY = minY0 > minY1 ? minY0 : minY1;
    var intMaxY = maxY0 < maxY1 ? maxY0 : maxY1;
    var intMidX = (intMinX + intMaxX) / 2;
    var intMidY = (intMinY + intMaxY) / 2;
    normPt.x = intMidX;
    normPt.y = intMidY;
    n00.x -= normPt.x;
    n00.y -= normPt.y;
    n01.x -= normPt.x;
    n01.y -= normPt.y;
    n10.x -= normPt.x;
    n10.y -= normPt.y;
    n11.x -= normPt.x;
    n11.y -= normPt.y;
  };
  RobustLineIntersector2.prototype.computeIntersect = function computeIntersect(p1, p2, q1, q2) {
    this._isProper = false;
    if (!Envelope.intersects(p1, p2, q1, q2)) {
      return LineIntersector$$1.NO_INTERSECTION;
    }
    var Pq1 = CGAlgorithms.orientationIndex(p1, p2, q1);
    var Pq2 = CGAlgorithms.orientationIndex(p1, p2, q2);
    if (Pq1 > 0 && Pq2 > 0 || Pq1 < 0 && Pq2 < 0) {
      return LineIntersector$$1.NO_INTERSECTION;
    }
    var Qp1 = CGAlgorithms.orientationIndex(q1, q2, p1);
    var Qp2 = CGAlgorithms.orientationIndex(q1, q2, p2);
    if (Qp1 > 0 && Qp2 > 0 || Qp1 < 0 && Qp2 < 0) {
      return LineIntersector$$1.NO_INTERSECTION;
    }
    var collinear = Pq1 === 0 && Pq2 === 0 && Qp1 === 0 && Qp2 === 0;
    if (collinear) {
      return this.computeCollinearIntersection(p1, p2, q1, q2);
    }
    if (Pq1 === 0 || Pq2 === 0 || Qp1 === 0 || Qp2 === 0) {
      this._isProper = false;
      if (p1.equals2D(q1) || p1.equals2D(q2)) {
        this._intPt[0] = p1;
      } else if (p2.equals2D(q1) || p2.equals2D(q2)) {
        this._intPt[0] = p2;
      } else if (Pq1 === 0) {
        this._intPt[0] = new Coordinate(q1);
      } else if (Pq2 === 0) {
        this._intPt[0] = new Coordinate(q2);
      } else if (Qp1 === 0) {
        this._intPt[0] = new Coordinate(p1);
      } else if (Qp2 === 0) {
        this._intPt[0] = new Coordinate(p2);
      }
    } else {
      this._isProper = true;
      this._intPt[0] = this.intersection(p1, p2, q1, q2);
    }
    return LineIntersector$$1.POINT_INTERSECTION;
  };
  RobustLineIntersector2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  RobustLineIntersector2.prototype.getClass = function getClass169() {
    return RobustLineIntersector2;
  };
  RobustLineIntersector2.nearestEndpoint = function nearestEndpoint(p1, p2, q1, q2) {
    var nearestPt = p1;
    var minDist = CGAlgorithms.distancePointLine(p1, q1, q2);
    var dist2 = CGAlgorithms.distancePointLine(p2, q1, q2);
    if (dist2 < minDist) {
      minDist = dist2;
      nearestPt = p2;
    }
    dist2 = CGAlgorithms.distancePointLine(q1, p1, p2);
    if (dist2 < minDist) {
      minDist = dist2;
      nearestPt = q1;
    }
    dist2 = CGAlgorithms.distancePointLine(q2, p1, p2);
    if (dist2 < minDist) {
      minDist = dist2;
      nearestPt = q2;
    }
    return nearestPt;
  };
  return RobustLineIntersector2;
}(LineIntersector);
var RobustDeterminant = function RobustDeterminant2() {
};
RobustDeterminant.prototype.interfaces_ = function interfaces_14() {
  return [];
};
RobustDeterminant.prototype.getClass = function getClass14() {
  return RobustDeterminant;
};
RobustDeterminant.orientationIndex = function orientationIndex2(p1, p2, q2) {
  var dx1 = p2.x - p1.x;
  var dy1 = p2.y - p1.y;
  var dx2 = q2.x - p2.x;
  var dy2 = q2.y - p2.y;
  return RobustDeterminant.signOfDet2x2(dx1, dy1, dx2, dy2);
};
RobustDeterminant.signOfDet2x2 = function signOfDet2x22(x12, y12, x2, y2) {
  var sign2 = null;
  var swap3 = null;
  var k2 = null;
  sign2 = 1;
  if (x12 === 0 || y2 === 0) {
    if (y12 === 0 || x2 === 0) {
      return 0;
    } else if (y12 > 0) {
      if (x2 > 0) {
        return -sign2;
      } else {
        return sign2;
      }
    } else {
      if (x2 > 0) {
        return sign2;
      } else {
        return -sign2;
      }
    }
  }
  if (y12 === 0 || x2 === 0) {
    if (y2 > 0) {
      if (x12 > 0) {
        return sign2;
      } else {
        return -sign2;
      }
    } else {
      if (x12 > 0) {
        return -sign2;
      } else {
        return sign2;
      }
    }
  }
  if (y12 > 0) {
    if (y2 > 0) {
      if (y12 <= y2)
        ;
      else {
        sign2 = -sign2;
        swap3 = x12;
        x12 = x2;
        x2 = swap3;
        swap3 = y12;
        y12 = y2;
        y2 = swap3;
      }
    } else {
      if (y12 <= -y2) {
        sign2 = -sign2;
        x2 = -x2;
        y2 = -y2;
      } else {
        swap3 = x12;
        x12 = -x2;
        x2 = swap3;
        swap3 = y12;
        y12 = -y2;
        y2 = swap3;
      }
    }
  } else {
    if (y2 > 0) {
      if (-y12 <= y2) {
        sign2 = -sign2;
        x12 = -x12;
        y12 = -y12;
      } else {
        swap3 = -x12;
        x12 = x2;
        x2 = swap3;
        swap3 = -y12;
        y12 = y2;
        y2 = swap3;
      }
    } else {
      if (y12 >= y2) {
        x12 = -x12;
        y12 = -y12;
        x2 = -x2;
        y2 = -y2;
      } else {
        sign2 = -sign2;
        swap3 = -x12;
        x12 = -x2;
        x2 = swap3;
        swap3 = -y12;
        y12 = -y2;
        y2 = swap3;
      }
    }
  }
  if (x12 > 0) {
    if (x2 > 0) {
      if (x12 <= x2)
        ;
      else {
        return sign2;
      }
    } else {
      return sign2;
    }
  } else {
    if (x2 > 0) {
      return -sign2;
    } else {
      if (x12 >= x2) {
        sign2 = -sign2;
        x12 = -x12;
        x2 = -x2;
      } else {
        return -sign2;
      }
    }
  }
  while (true) {
    k2 = Math.floor(x2 / x12);
    x2 = x2 - k2 * x12;
    y2 = y2 - k2 * y12;
    if (y2 < 0) {
      return -sign2;
    }
    if (y2 > y12) {
      return sign2;
    }
    if (x12 > x2 + x2) {
      if (y12 < y2 + y2) {
        return sign2;
      }
    } else {
      if (y12 > y2 + y2) {
        return -sign2;
      } else {
        x2 = x12 - x2;
        y2 = y12 - y2;
        sign2 = -sign2;
      }
    }
    if (y2 === 0) {
      if (x2 === 0) {
        return 0;
      } else {
        return -sign2;
      }
    }
    if (x2 === 0) {
      return sign2;
    }
    k2 = Math.floor(x12 / x2);
    x12 = x12 - k2 * x2;
    y12 = y12 - k2 * y2;
    if (y12 < 0) {
      return sign2;
    }
    if (y12 > y2) {
      return -sign2;
    }
    if (x2 > x12 + x12) {
      if (y2 < y12 + y12) {
        return -sign2;
      }
    } else {
      if (y2 > y12 + y12) {
        return sign2;
      } else {
        x12 = x2 - x12;
        y12 = y2 - y12;
        sign2 = -sign2;
      }
    }
    if (y12 === 0) {
      if (x12 === 0) {
        return 0;
      } else {
        return sign2;
      }
    }
    if (x12 === 0) {
      return -sign2;
    }
  }
};
var RayCrossingCounter = function RayCrossingCounter2() {
  this._p = null;
  this._crossingCount = 0;
  this._isPointOnSegment = false;
  var p2 = arguments[0];
  this._p = p2;
};
RayCrossingCounter.prototype.countSegment = function countSegment(p1, p2) {
  if (p1.x < this._p.x && p2.x < this._p.x) {
    return null;
  }
  if (this._p.x === p2.x && this._p.y === p2.y) {
    this._isPointOnSegment = true;
    return null;
  }
  if (p1.y === this._p.y && p2.y === this._p.y) {
    var minx = p1.x;
    var maxx = p2.x;
    if (minx > maxx) {
      minx = p2.x;
      maxx = p1.x;
    }
    if (this._p.x >= minx && this._p.x <= maxx) {
      this._isPointOnSegment = true;
    }
    return null;
  }
  if (p1.y > this._p.y && p2.y <= this._p.y || p2.y > this._p.y && p1.y <= this._p.y) {
    var x12 = p1.x - this._p.x;
    var y12 = p1.y - this._p.y;
    var x2 = p2.x - this._p.x;
    var y2 = p2.y - this._p.y;
    var xIntSign = RobustDeterminant.signOfDet2x2(x12, y12, x2, y2);
    if (xIntSign === 0) {
      this._isPointOnSegment = true;
      return null;
    }
    if (y2 < y12) {
      xIntSign = -xIntSign;
    }
    if (xIntSign > 0) {
      this._crossingCount++;
    }
  }
};
RayCrossingCounter.prototype.isPointInPolygon = function isPointInPolygon() {
  return this.getLocation() !== Location.EXTERIOR;
};
RayCrossingCounter.prototype.getLocation = function getLocation() {
  if (this._isPointOnSegment) {
    return Location.BOUNDARY;
  }
  if (this._crossingCount % 2 === 1) {
    return Location.INTERIOR;
  }
  return Location.EXTERIOR;
};
RayCrossingCounter.prototype.isOnSegment = function isOnSegment() {
  return this._isPointOnSegment;
};
RayCrossingCounter.prototype.interfaces_ = function interfaces_15() {
  return [];
};
RayCrossingCounter.prototype.getClass = function getClass15() {
  return RayCrossingCounter;
};
RayCrossingCounter.locatePointInRing = function locatePointInRing() {
  if (arguments[0] instanceof Coordinate && hasInterface(arguments[1], CoordinateSequence)) {
    var p2 = arguments[0];
    var ring = arguments[1];
    var counter2 = new RayCrossingCounter(p2);
    var p1 = new Coordinate();
    var p22 = new Coordinate();
    for (var i2 = 1; i2 < ring.size(); i2++) {
      ring.getCoordinate(i2, p1);
      ring.getCoordinate(i2 - 1, p22);
      counter2.countSegment(p1, p22);
      if (counter2.isOnSegment()) {
        return counter2.getLocation();
      }
    }
    return counter2.getLocation();
  } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Array) {
    var p$12 = arguments[0];
    var ring$1 = arguments[1];
    var counter$1 = new RayCrossingCounter(p$12);
    for (var i$12 = 1; i$12 < ring$1.length; i$12++) {
      var p1$1 = ring$1[i$12];
      var p2$1 = ring$1[i$12 - 1];
      counter$1.countSegment(p1$1, p2$1);
      if (counter$1.isOnSegment()) {
        return counter$1.getLocation();
      }
    }
    return counter$1.getLocation();
  }
};
var CGAlgorithms = function CGAlgorithms2() {
};
var staticAccessors$3 = { CLOCKWISE: { configurable: true }, RIGHT: { configurable: true }, COUNTERCLOCKWISE: { configurable: true }, LEFT: { configurable: true }, COLLINEAR: { configurable: true }, STRAIGHT: { configurable: true } };
CGAlgorithms.prototype.interfaces_ = function interfaces_16() {
  return [];
};
CGAlgorithms.prototype.getClass = function getClass16() {
  return CGAlgorithms;
};
CGAlgorithms.orientationIndex = function orientationIndex3(p1, p2, q2) {
  return CGAlgorithmsDD.orientationIndex(p1, p2, q2);
};
CGAlgorithms.signedArea = function signedArea2() {
  if (arguments[0] instanceof Array) {
    var ring = arguments[0];
    if (ring.length < 3) {
      return 0;
    }
    var sum2 = 0;
    var x02 = ring[0].x;
    for (var i2 = 1; i2 < ring.length - 1; i2++) {
      var x2 = ring[i2].x - x02;
      var y12 = ring[i2 + 1].y;
      var y2 = ring[i2 - 1].y;
      sum2 += x2 * (y2 - y12);
    }
    return sum2 / 2;
  } else if (hasInterface(arguments[0], CoordinateSequence)) {
    var ring$1 = arguments[0];
    var n2 = ring$1.size();
    if (n2 < 3) {
      return 0;
    }
    var p0 = new Coordinate();
    var p1 = new Coordinate();
    var p2 = new Coordinate();
    ring$1.getCoordinate(0, p1);
    ring$1.getCoordinate(1, p2);
    var x0$1 = p1.x;
    p2.x -= x0$1;
    var sum$12 = 0;
    for (var i$12 = 1; i$12 < n2 - 1; i$12++) {
      p0.y = p1.y;
      p1.x = p2.x;
      p1.y = p2.y;
      ring$1.getCoordinate(i$12 + 1, p2);
      p2.x -= x0$1;
      sum$12 += p1.x * (p0.y - p2.y);
    }
    return sum$12 / 2;
  }
};
CGAlgorithms.distanceLineLine = function distanceLineLine(A2, B2, C2, D2) {
  if (A2.equals(B2)) {
    return CGAlgorithms.distancePointLine(A2, C2, D2);
  }
  if (C2.equals(D2)) {
    return CGAlgorithms.distancePointLine(D2, A2, B2);
  }
  var noIntersection = false;
  if (!Envelope.intersects(A2, B2, C2, D2)) {
    noIntersection = true;
  } else {
    var denom = (B2.x - A2.x) * (D2.y - C2.y) - (B2.y - A2.y) * (D2.x - C2.x);
    if (denom === 0) {
      noIntersection = true;
    } else {
      var rNumb = (A2.y - C2.y) * (D2.x - C2.x) - (A2.x - C2.x) * (D2.y - C2.y);
      var sNum = (A2.y - C2.y) * (B2.x - A2.x) - (A2.x - C2.x) * (B2.y - A2.y);
      var s2 = sNum / denom;
      var r2 = rNumb / denom;
      if (r2 < 0 || r2 > 1 || s2 < 0 || s2 > 1) {
        noIntersection = true;
      }
    }
  }
  if (noIntersection) {
    return MathUtil.min(CGAlgorithms.distancePointLine(A2, C2, D2), CGAlgorithms.distancePointLine(B2, C2, D2), CGAlgorithms.distancePointLine(C2, A2, B2), CGAlgorithms.distancePointLine(D2, A2, B2));
  }
  return 0;
};
CGAlgorithms.isPointInRing = function isPointInRing(p2, ring) {
  return CGAlgorithms.locatePointInRing(p2, ring) !== Location.EXTERIOR;
};
CGAlgorithms.computeLength = function computeLength(pts) {
  var n2 = pts.size();
  if (n2 <= 1) {
    return 0;
  }
  var len2 = 0;
  var p2 = new Coordinate();
  pts.getCoordinate(0, p2);
  var x02 = p2.x;
  var y02 = p2.y;
  for (var i2 = 1; i2 < n2; i2++) {
    pts.getCoordinate(i2, p2);
    var x12 = p2.x;
    var y12 = p2.y;
    var dx = x12 - x02;
    var dy = y12 - y02;
    len2 += Math.sqrt(dx * dx + dy * dy);
    x02 = x12;
    y02 = y12;
  }
  return len2;
};
CGAlgorithms.isCCW = function isCCW(ring) {
  var nPts = ring.length - 1;
  if (nPts < 3) {
    throw new IllegalArgumentException("Ring has fewer than 4 points, so orientation cannot be determined");
  }
  var hiPt = ring[0];
  var hiIndex = 0;
  for (var i2 = 1; i2 <= nPts; i2++) {
    var p2 = ring[i2];
    if (p2.y > hiPt.y) {
      hiPt = p2;
      hiIndex = i2;
    }
  }
  var iPrev = hiIndex;
  do {
    iPrev = iPrev - 1;
    if (iPrev < 0) {
      iPrev = nPts;
    }
  } while (ring[iPrev].equals2D(hiPt) && iPrev !== hiIndex);
  var iNext = hiIndex;
  do {
    iNext = (iNext + 1) % nPts;
  } while (ring[iNext].equals2D(hiPt) && iNext !== hiIndex);
  var prev = ring[iPrev];
  var next5 = ring[iNext];
  if (prev.equals2D(hiPt) || next5.equals2D(hiPt) || prev.equals2D(next5)) {
    return false;
  }
  var disc = CGAlgorithms.computeOrientation(prev, hiPt, next5);
  var isCCW2 = false;
  if (disc === 0) {
    isCCW2 = prev.x > next5.x;
  } else {
    isCCW2 = disc > 0;
  }
  return isCCW2;
};
CGAlgorithms.locatePointInRing = function locatePointInRing2(p2, ring) {
  return RayCrossingCounter.locatePointInRing(p2, ring);
};
CGAlgorithms.distancePointLinePerpendicular = function distancePointLinePerpendicular(p2, A2, B2) {
  var len2 = (B2.x - A2.x) * (B2.x - A2.x) + (B2.y - A2.y) * (B2.y - A2.y);
  var s2 = ((A2.y - p2.y) * (B2.x - A2.x) - (A2.x - p2.x) * (B2.y - A2.y)) / len2;
  return Math.abs(s2) * Math.sqrt(len2);
};
CGAlgorithms.computeOrientation = function computeOrientation(p1, p2, q2) {
  return CGAlgorithms.orientationIndex(p1, p2, q2);
};
CGAlgorithms.distancePointLine = function distancePointLine() {
  if (arguments.length === 2) {
    var p2 = arguments[0];
    var line = arguments[1];
    if (line.length === 0) {
      throw new IllegalArgumentException("Line array must contain at least one vertex");
    }
    var minDistance = p2.distance(line[0]);
    for (var i2 = 0; i2 < line.length - 1; i2++) {
      var dist2 = CGAlgorithms.distancePointLine(p2, line[i2], line[i2 + 1]);
      if (dist2 < minDistance) {
        minDistance = dist2;
      }
    }
    return minDistance;
  } else if (arguments.length === 3) {
    var p$12 = arguments[0];
    var A2 = arguments[1];
    var B2 = arguments[2];
    if (A2.x === B2.x && A2.y === B2.y) {
      return p$12.distance(A2);
    }
    var len2 = (B2.x - A2.x) * (B2.x - A2.x) + (B2.y - A2.y) * (B2.y - A2.y);
    var r2 = ((p$12.x - A2.x) * (B2.x - A2.x) + (p$12.y - A2.y) * (B2.y - A2.y)) / len2;
    if (r2 <= 0) {
      return p$12.distance(A2);
    }
    if (r2 >= 1) {
      return p$12.distance(B2);
    }
    var s2 = ((A2.y - p$12.y) * (B2.x - A2.x) - (A2.x - p$12.x) * (B2.y - A2.y)) / len2;
    return Math.abs(s2) * Math.sqrt(len2);
  }
};
CGAlgorithms.isOnLine = function isOnLine(p2, pt) {
  var lineIntersector = new RobustLineIntersector();
  for (var i2 = 1; i2 < pt.length; i2++) {
    var p0 = pt[i2 - 1];
    var p1 = pt[i2];
    lineIntersector.computeIntersection(p2, p0, p1);
    if (lineIntersector.hasIntersection()) {
      return true;
    }
  }
  return false;
};
staticAccessors$3.CLOCKWISE.get = function() {
  return -1;
};
staticAccessors$3.RIGHT.get = function() {
  return CGAlgorithms.CLOCKWISE;
};
staticAccessors$3.COUNTERCLOCKWISE.get = function() {
  return 1;
};
staticAccessors$3.LEFT.get = function() {
  return CGAlgorithms.COUNTERCLOCKWISE;
};
staticAccessors$3.COLLINEAR.get = function() {
  return 0;
};
staticAccessors$3.STRAIGHT.get = function() {
  return CGAlgorithms.COLLINEAR;
};
Object.defineProperties(CGAlgorithms, staticAccessors$3);
var GeometryComponentFilter = function GeometryComponentFilter2() {
};
GeometryComponentFilter.prototype.filter = function filter(geom) {
};
GeometryComponentFilter.prototype.interfaces_ = function interfaces_17() {
  return [];
};
GeometryComponentFilter.prototype.getClass = function getClass17() {
  return GeometryComponentFilter;
};
var Geometry$1 = function Geometry2() {
  var factory = arguments[0];
  this._envelope = null;
  this._factory = null;
  this._SRID = null;
  this._userData = null;
  this._factory = factory;
  this._SRID = factory.getSRID();
};
var staticAccessors$11 = { serialVersionUID: { configurable: true }, SORTINDEX_POINT: { configurable: true }, SORTINDEX_MULTIPOINT: { configurable: true }, SORTINDEX_LINESTRING: { configurable: true }, SORTINDEX_LINEARRING: { configurable: true }, SORTINDEX_MULTILINESTRING: { configurable: true }, SORTINDEX_POLYGON: { configurable: true }, SORTINDEX_MULTIPOLYGON: { configurable: true }, SORTINDEX_GEOMETRYCOLLECTION: { configurable: true }, geometryChangedFilter: { configurable: true } };
Geometry$1.prototype.isGeometryCollection = function isGeometryCollection() {
  return this.getSortIndex() === Geometry$1.SORTINDEX_GEOMETRYCOLLECTION;
};
Geometry$1.prototype.getFactory = function getFactory() {
  return this._factory;
};
Geometry$1.prototype.getGeometryN = function getGeometryN(n2) {
  return this;
};
Geometry$1.prototype.getArea = function getArea2() {
  return 0;
};
Geometry$1.prototype.isRectangle = function isRectangle() {
  return false;
};
Geometry$1.prototype.equals = function equals6() {
  if (arguments[0] instanceof Geometry$1) {
    var g$12 = arguments[0];
    if (g$12 === null) {
      return false;
    }
    return this.equalsTopo(g$12);
  } else if (arguments[0] instanceof Object) {
    var o2 = arguments[0];
    if (!(o2 instanceof Geometry$1)) {
      return false;
    }
    var g2 = o2;
    return this.equalsExact(g2);
  }
};
Geometry$1.prototype.equalsExact = function equalsExact(other) {
  return this === other || this.equalsExact(other, 0);
};
Geometry$1.prototype.geometryChanged = function geometryChanged() {
  this.apply(Geometry$1.geometryChangedFilter);
};
Geometry$1.prototype.geometryChangedAction = function geometryChangedAction() {
  this._envelope = null;
};
Geometry$1.prototype.equalsNorm = function equalsNorm(g2) {
  if (g2 === null) {
    return false;
  }
  return this.norm().equalsExact(g2.norm());
};
Geometry$1.prototype.getLength = function getLength() {
  return 0;
};
Geometry$1.prototype.getNumGeometries = function getNumGeometries() {
  return 1;
};
Geometry$1.prototype.compareTo = function compareTo5() {
  if (arguments.length === 1) {
    var o2 = arguments[0];
    var other = o2;
    if (this.getSortIndex() !== other.getSortIndex()) {
      return this.getSortIndex() - other.getSortIndex();
    }
    if (this.isEmpty() && other.isEmpty()) {
      return 0;
    }
    if (this.isEmpty()) {
      return -1;
    }
    if (other.isEmpty()) {
      return 1;
    }
    return this.compareToSameClass(o2);
  } else if (arguments.length === 2) {
    var other$1 = arguments[0];
    var comp = arguments[1];
    if (this.getSortIndex() !== other$1.getSortIndex()) {
      return this.getSortIndex() - other$1.getSortIndex();
    }
    if (this.isEmpty() && other$1.isEmpty()) {
      return 0;
    }
    if (this.isEmpty()) {
      return -1;
    }
    if (other$1.isEmpty()) {
      return 1;
    }
    return this.compareToSameClass(other$1, comp);
  }
};
Geometry$1.prototype.getUserData = function getUserData() {
  return this._userData;
};
Geometry$1.prototype.getSRID = function getSRID() {
  return this._SRID;
};
Geometry$1.prototype.getEnvelope = function getEnvelope() {
  return this.getFactory().toGeometry(this.getEnvelopeInternal());
};
Geometry$1.prototype.checkNotGeometryCollection = function checkNotGeometryCollection(g2) {
  if (g2.getSortIndex() === Geometry$1.SORTINDEX_GEOMETRYCOLLECTION) {
    throw new IllegalArgumentException("This method does not support GeometryCollection arguments");
  }
};
Geometry$1.prototype.equal = function equal(a2, b2, tolerance) {
  if (tolerance === 0) {
    return a2.equals(b2);
  }
  return a2.distance(b2) <= tolerance;
};
Geometry$1.prototype.norm = function norm() {
  var copy8 = this.copy();
  copy8.normalize();
  return copy8;
};
Geometry$1.prototype.getPrecisionModel = function getPrecisionModel() {
  return this._factory.getPrecisionModel();
};
Geometry$1.prototype.getEnvelopeInternal = function getEnvelopeInternal() {
  if (this._envelope === null) {
    this._envelope = this.computeEnvelopeInternal();
  }
  return new Envelope(this._envelope);
};
Geometry$1.prototype.setSRID = function setSRID(SRID) {
  this._SRID = SRID;
};
Geometry$1.prototype.setUserData = function setUserData(userData) {
  this._userData = userData;
};
Geometry$1.prototype.compare = function compare3(a2, b2) {
  var i2 = a2.iterator();
  var j2 = b2.iterator();
  while (i2.hasNext() && j2.hasNext()) {
    var aElement = i2.next();
    var bElement = j2.next();
    var comparison = aElement.compareTo(bElement);
    if (comparison !== 0) {
      return comparison;
    }
  }
  if (i2.hasNext()) {
    return 1;
  }
  if (j2.hasNext()) {
    return -1;
  }
  return 0;
};
Geometry$1.prototype.hashCode = function hashCode5() {
  return this.getEnvelopeInternal().hashCode();
};
Geometry$1.prototype.isGeometryCollectionOrDerived = function isGeometryCollectionOrDerived() {
  if (this.getSortIndex() === Geometry$1.SORTINDEX_GEOMETRYCOLLECTION || this.getSortIndex() === Geometry$1.SORTINDEX_MULTIPOINT || this.getSortIndex() === Geometry$1.SORTINDEX_MULTILINESTRING || this.getSortIndex() === Geometry$1.SORTINDEX_MULTIPOLYGON) {
    return true;
  }
  return false;
};
Geometry$1.prototype.interfaces_ = function interfaces_18() {
  return [Clonable, Comparable, Serializable];
};
Geometry$1.prototype.getClass = function getClass18() {
  return Geometry$1;
};
Geometry$1.hasNonEmptyElements = function hasNonEmptyElements(geometries) {
  for (var i2 = 0; i2 < geometries.length; i2++) {
    if (!geometries[i2].isEmpty()) {
      return true;
    }
  }
  return false;
};
Geometry$1.hasNullElements = function hasNullElements(array2) {
  for (var i2 = 0; i2 < array2.length; i2++) {
    if (array2[i2] === null) {
      return true;
    }
  }
  return false;
};
staticAccessors$11.serialVersionUID.get = function() {
  return 8763622679187377e3;
};
staticAccessors$11.SORTINDEX_POINT.get = function() {
  return 0;
};
staticAccessors$11.SORTINDEX_MULTIPOINT.get = function() {
  return 1;
};
staticAccessors$11.SORTINDEX_LINESTRING.get = function() {
  return 2;
};
staticAccessors$11.SORTINDEX_LINEARRING.get = function() {
  return 3;
};
staticAccessors$11.SORTINDEX_MULTILINESTRING.get = function() {
  return 4;
};
staticAccessors$11.SORTINDEX_POLYGON.get = function() {
  return 5;
};
staticAccessors$11.SORTINDEX_MULTIPOLYGON.get = function() {
  return 6;
};
staticAccessors$11.SORTINDEX_GEOMETRYCOLLECTION.get = function() {
  return 7;
};
staticAccessors$11.geometryChangedFilter.get = function() {
  return geometryChangedFilter;
};
Object.defineProperties(Geometry$1, staticAccessors$11);
var geometryChangedFilter = function geometryChangedFilter2() {
};
geometryChangedFilter.interfaces_ = function interfaces_19() {
  return [GeometryComponentFilter];
};
geometryChangedFilter.filter = function filter2(geom) {
  geom.geometryChangedAction();
};
var CoordinateFilter = function CoordinateFilter2() {
};
CoordinateFilter.prototype.filter = function filter3(coord) {
};
CoordinateFilter.prototype.interfaces_ = function interfaces_20() {
  return [];
};
CoordinateFilter.prototype.getClass = function getClass19() {
  return CoordinateFilter;
};
var BoundaryNodeRule = function BoundaryNodeRule2() {
};
var staticAccessors$12 = { Mod2BoundaryNodeRule: { configurable: true }, EndPointBoundaryNodeRule: { configurable: true }, MultiValentEndPointBoundaryNodeRule: { configurable: true }, MonoValentEndPointBoundaryNodeRule: { configurable: true }, MOD2_BOUNDARY_RULE: { configurable: true }, ENDPOINT_BOUNDARY_RULE: { configurable: true }, MULTIVALENT_ENDPOINT_BOUNDARY_RULE: { configurable: true }, MONOVALENT_ENDPOINT_BOUNDARY_RULE: { configurable: true }, OGC_SFS_BOUNDARY_RULE: { configurable: true } };
BoundaryNodeRule.prototype.isInBoundary = function isInBoundary(boundaryCount) {
};
BoundaryNodeRule.prototype.interfaces_ = function interfaces_21() {
  return [];
};
BoundaryNodeRule.prototype.getClass = function getClass20() {
  return BoundaryNodeRule;
};
staticAccessors$12.Mod2BoundaryNodeRule.get = function() {
  return Mod2BoundaryNodeRule;
};
staticAccessors$12.EndPointBoundaryNodeRule.get = function() {
  return EndPointBoundaryNodeRule;
};
staticAccessors$12.MultiValentEndPointBoundaryNodeRule.get = function() {
  return MultiValentEndPointBoundaryNodeRule;
};
staticAccessors$12.MonoValentEndPointBoundaryNodeRule.get = function() {
  return MonoValentEndPointBoundaryNodeRule;
};
staticAccessors$12.MOD2_BOUNDARY_RULE.get = function() {
  return new Mod2BoundaryNodeRule();
};
staticAccessors$12.ENDPOINT_BOUNDARY_RULE.get = function() {
  return new EndPointBoundaryNodeRule();
};
staticAccessors$12.MULTIVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
  return new MultiValentEndPointBoundaryNodeRule();
};
staticAccessors$12.MONOVALENT_ENDPOINT_BOUNDARY_RULE.get = function() {
  return new MonoValentEndPointBoundaryNodeRule();
};
staticAccessors$12.OGC_SFS_BOUNDARY_RULE.get = function() {
  return BoundaryNodeRule.MOD2_BOUNDARY_RULE;
};
Object.defineProperties(BoundaryNodeRule, staticAccessors$12);
var Mod2BoundaryNodeRule = function Mod2BoundaryNodeRule2() {
};
Mod2BoundaryNodeRule.prototype.isInBoundary = function isInBoundary2(boundaryCount) {
  return boundaryCount % 2 === 1;
};
Mod2BoundaryNodeRule.prototype.interfaces_ = function interfaces_22() {
  return [BoundaryNodeRule];
};
Mod2BoundaryNodeRule.prototype.getClass = function getClass21() {
  return Mod2BoundaryNodeRule;
};
var EndPointBoundaryNodeRule = function EndPointBoundaryNodeRule2() {
};
EndPointBoundaryNodeRule.prototype.isInBoundary = function isInBoundary3(boundaryCount) {
  return boundaryCount > 0;
};
EndPointBoundaryNodeRule.prototype.interfaces_ = function interfaces_23() {
  return [BoundaryNodeRule];
};
EndPointBoundaryNodeRule.prototype.getClass = function getClass22() {
  return EndPointBoundaryNodeRule;
};
var MultiValentEndPointBoundaryNodeRule = function MultiValentEndPointBoundaryNodeRule2() {
};
MultiValentEndPointBoundaryNodeRule.prototype.isInBoundary = function isInBoundary4(boundaryCount) {
  return boundaryCount > 1;
};
MultiValentEndPointBoundaryNodeRule.prototype.interfaces_ = function interfaces_24() {
  return [BoundaryNodeRule];
};
MultiValentEndPointBoundaryNodeRule.prototype.getClass = function getClass23() {
  return MultiValentEndPointBoundaryNodeRule;
};
var MonoValentEndPointBoundaryNodeRule = function MonoValentEndPointBoundaryNodeRule2() {
};
MonoValentEndPointBoundaryNodeRule.prototype.isInBoundary = function isInBoundary5(boundaryCount) {
  return boundaryCount === 1;
};
MonoValentEndPointBoundaryNodeRule.prototype.interfaces_ = function interfaces_25() {
  return [BoundaryNodeRule];
};
MonoValentEndPointBoundaryNodeRule.prototype.getClass = function getClass24() {
  return MonoValentEndPointBoundaryNodeRule;
};
var Collection = function Collection2() {
};
Collection.prototype.add = function add3() {
};
Collection.prototype.addAll = function addAll() {
};
Collection.prototype.isEmpty = function isEmpty() {
};
Collection.prototype.iterator = function iterator() {
};
Collection.prototype.size = function size3() {
};
Collection.prototype.toArray = function toArray2() {
};
Collection.prototype.remove = function remove() {
};
function IndexOutOfBoundsException(message2) {
  this.message = message2 || "";
}
IndexOutOfBoundsException.prototype = new Error();
IndexOutOfBoundsException.prototype.name = "IndexOutOfBoundsException";
var Iterator = function Iterator2() {
};
Iterator.prototype.hasNext = function hasNext() {
};
Iterator.prototype.next = function next() {
};
Iterator.prototype.remove = function remove2() {
};
var List$2 = function(Collection$$1) {
  function List2() {
    Collection$$1.apply(this, arguments);
  }
  if (Collection$$1)
    List2.__proto__ = Collection$$1;
  List2.prototype = Object.create(Collection$$1 && Collection$$1.prototype);
  List2.prototype.constructor = List2;
  List2.prototype.get = function get6() {
  };
  List2.prototype.set = function set() {
  };
  List2.prototype.isEmpty = function isEmpty6() {
  };
  return List2;
}(Collection);
function NoSuchElementException(message2) {
  this.message = message2 || "";
}
NoSuchElementException.prototype = new Error();
NoSuchElementException.prototype.name = "NoSuchElementException";
var ArrayList = function(List$$1) {
  function ArrayList2() {
    List$$1.call(this);
    this.array_ = [];
    if (arguments[0] instanceof Collection) {
      this.addAll(arguments[0]);
    }
  }
  if (List$$1)
    ArrayList2.__proto__ = List$$1;
  ArrayList2.prototype = Object.create(List$$1 && List$$1.prototype);
  ArrayList2.prototype.constructor = ArrayList2;
  ArrayList2.prototype.ensureCapacity = function ensureCapacity() {
  };
  ArrayList2.prototype.interfaces_ = function interfaces_170() {
    return [List$$1, Collection];
  };
  ArrayList2.prototype.add = function add18(e3) {
    if (arguments.length === 1) {
      this.array_.push(e3);
    } else {
      this.array_.splice(arguments[0], arguments[1]);
    }
    return true;
  };
  ArrayList2.prototype.clear = function clear4() {
    this.array_ = [];
  };
  ArrayList2.prototype.addAll = function addAll3(c2) {
    var this$1$1 = this;
    for (var i2 = c2.iterator(); i2.hasNext(); ) {
      this$1$1.add(i2.next());
    }
    return true;
  };
  ArrayList2.prototype.set = function set(index2, element) {
    var oldElement = this.array_[index2];
    this.array_[index2] = element;
    return oldElement;
  };
  ArrayList2.prototype.iterator = function iterator7() {
    return new Iterator_(this);
  };
  ArrayList2.prototype.get = function get6(index2) {
    if (index2 < 0 || index2 >= this.size()) {
      throw new IndexOutOfBoundsException();
    }
    return this.array_[index2];
  };
  ArrayList2.prototype.isEmpty = function isEmpty6() {
    return this.array_.length === 0;
  };
  ArrayList2.prototype.size = function size12() {
    return this.array_.length;
  };
  ArrayList2.prototype.toArray = function toArray3() {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
      array2.push(this$1$1.array_[i2]);
    }
    return array2;
  };
  ArrayList2.prototype.remove = function remove6(o2) {
    var this$1$1 = this;
    var found = false;
    for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
      if (this$1$1.array_[i2] === o2) {
        this$1$1.array_.splice(i2, 1);
        found = true;
        break;
      }
    }
    return found;
  };
  return ArrayList2;
}(List$2);
var Iterator_ = function(Iterator$$1) {
  function Iterator_2(arrayList) {
    Iterator$$1.call(this);
    this.arrayList_ = arrayList;
    this.position_ = 0;
  }
  if (Iterator$$1)
    Iterator_2.__proto__ = Iterator$$1;
  Iterator_2.prototype = Object.create(Iterator$$1 && Iterator$$1.prototype);
  Iterator_2.prototype.constructor = Iterator_2;
  Iterator_2.prototype.next = function next5() {
    if (this.position_ === this.arrayList_.size()) {
      throw new NoSuchElementException();
    }
    return this.arrayList_.get(this.position_++);
  };
  Iterator_2.prototype.hasNext = function hasNext3() {
    if (this.position_ < this.arrayList_.size()) {
      return true;
    } else {
      return false;
    }
  };
  Iterator_2.prototype.set = function set(element) {
    return this.arrayList_.set(this.position_ - 1, element);
  };
  Iterator_2.prototype.remove = function remove6() {
    this.arrayList_.remove(this.arrayList_.get(this.position_));
  };
  return Iterator_2;
}(Iterator);
var CoordinateList = function(ArrayList$$1) {
  function CoordinateList2() {
    ArrayList$$1.call(this);
    if (arguments.length === 0)
      ;
    else if (arguments.length === 1) {
      var coord = arguments[0];
      this.ensureCapacity(coord.length);
      this.add(coord, true);
    } else if (arguments.length === 2) {
      var coord$1 = arguments[0];
      var allowRepeated = arguments[1];
      this.ensureCapacity(coord$1.length);
      this.add(coord$1, allowRepeated);
    }
  }
  if (ArrayList$$1)
    CoordinateList2.__proto__ = ArrayList$$1;
  CoordinateList2.prototype = Object.create(ArrayList$$1 && ArrayList$$1.prototype);
  CoordinateList2.prototype.constructor = CoordinateList2;
  var staticAccessors2 = { coordArrayType: { configurable: true } };
  staticAccessors2.coordArrayType.get = function() {
    return new Array(0).fill(null);
  };
  CoordinateList2.prototype.getCoordinate = function getCoordinate18(i2) {
    return this.get(i2);
  };
  CoordinateList2.prototype.addAll = function addAll3() {
    var this$1$1 = this;
    if (arguments.length === 2) {
      var coll = arguments[0];
      var allowRepeated = arguments[1];
      var isChanged = false;
      for (var i2 = coll.iterator(); i2.hasNext(); ) {
        this$1$1.add(i2.next(), allowRepeated);
        isChanged = true;
      }
      return isChanged;
    } else {
      return ArrayList$$1.prototype.addAll.apply(this, arguments);
    }
  };
  CoordinateList2.prototype.clone = function clone8() {
    var this$1$1 = this;
    var clone9 = ArrayList$$1.prototype.clone.call(this);
    for (var i2 = 0; i2 < this.size(); i2++) {
      clone9.add(i2, this$1$1.get(i2).copy());
    }
    return clone9;
  };
  CoordinateList2.prototype.toCoordinateArray = function toCoordinateArray4() {
    return this.toArray(CoordinateList2.coordArrayType);
  };
  CoordinateList2.prototype.add = function add18() {
    var this$1$1 = this;
    if (arguments.length === 1) {
      var coord = arguments[0];
      ArrayList$$1.prototype.add.call(this, coord);
    } else if (arguments.length === 2) {
      if (arguments[0] instanceof Array && typeof arguments[1] === "boolean") {
        var coord$1 = arguments[0];
        var allowRepeated = arguments[1];
        this.add(coord$1, allowRepeated, true);
        return true;
      } else if (arguments[0] instanceof Coordinate && typeof arguments[1] === "boolean") {
        var coord$2 = arguments[0];
        var allowRepeated$1 = arguments[1];
        if (!allowRepeated$1) {
          if (this.size() >= 1) {
            var last = this.get(this.size() - 1);
            if (last.equals2D(coord$2)) {
              return null;
            }
          }
        }
        ArrayList$$1.prototype.add.call(this, coord$2);
      } else if (arguments[0] instanceof Object && typeof arguments[1] === "boolean") {
        var obj = arguments[0];
        var allowRepeated$2 = arguments[1];
        this.add(obj, allowRepeated$2);
        return true;
      }
    } else if (arguments.length === 3) {
      if (typeof arguments[2] === "boolean" && (arguments[0] instanceof Array && typeof arguments[1] === "boolean")) {
        var coord$3 = arguments[0];
        var allowRepeated$3 = arguments[1];
        var direction = arguments[2];
        if (direction) {
          for (var i$12 = 0; i$12 < coord$3.length; i$12++) {
            this$1$1.add(coord$3[i$12], allowRepeated$3);
          }
        } else {
          for (var i$22 = coord$3.length - 1; i$22 >= 0; i$22--) {
            this$1$1.add(coord$3[i$22], allowRepeated$3);
          }
        }
        return true;
      } else if (typeof arguments[2] === "boolean" && (Number.isInteger(arguments[0]) && arguments[1] instanceof Coordinate)) {
        var i$32 = arguments[0];
        var coord$4 = arguments[1];
        var allowRepeated$4 = arguments[2];
        if (!allowRepeated$4) {
          var size12 = this.size();
          if (size12 > 0) {
            if (i$32 > 0) {
              var prev = this.get(i$32 - 1);
              if (prev.equals2D(coord$4)) {
                return null;
              }
            }
            if (i$32 < size12) {
              var next5 = this.get(i$32);
              if (next5.equals2D(coord$4)) {
                return null;
              }
            }
          }
        }
        ArrayList$$1.prototype.add.call(this, i$32, coord$4);
      }
    } else if (arguments.length === 4) {
      var coord$5 = arguments[0];
      var allowRepeated$5 = arguments[1];
      var start2 = arguments[2];
      var end = arguments[3];
      var inc = 1;
      if (start2 > end) {
        inc = -1;
      }
      for (var i2 = start2; i2 !== end; i2 += inc) {
        this$1$1.add(coord$5[i2], allowRepeated$5);
      }
      return true;
    }
  };
  CoordinateList2.prototype.closeRing = function closeRing3() {
    if (this.size() > 0) {
      this.add(new Coordinate(this.get(0)), false);
    }
  };
  CoordinateList2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  CoordinateList2.prototype.getClass = function getClass169() {
    return CoordinateList2;
  };
  Object.defineProperties(CoordinateList2, staticAccessors2);
  return CoordinateList2;
}(ArrayList);
var CoordinateArrays = function CoordinateArrays2() {
};
var staticAccessors$13 = { ForwardComparator: { configurable: true }, BidirectionalComparator: { configurable: true }, coordArrayType: { configurable: true } };
staticAccessors$13.ForwardComparator.get = function() {
  return ForwardComparator;
};
staticAccessors$13.BidirectionalComparator.get = function() {
  return BidirectionalComparator;
};
staticAccessors$13.coordArrayType.get = function() {
  return new Array(0).fill(null);
};
CoordinateArrays.prototype.interfaces_ = function interfaces_26() {
  return [];
};
CoordinateArrays.prototype.getClass = function getClass25() {
  return CoordinateArrays;
};
CoordinateArrays.isRing = function isRing(pts) {
  if (pts.length < 4) {
    return false;
  }
  if (!pts[0].equals2D(pts[pts.length - 1])) {
    return false;
  }
  return true;
};
CoordinateArrays.ptNotInList = function ptNotInList(testPts, pts) {
  for (var i2 = 0; i2 < testPts.length; i2++) {
    var testPt = testPts[i2];
    if (CoordinateArrays.indexOf(testPt, pts) < 0) {
      return testPt;
    }
  }
  return null;
};
CoordinateArrays.scroll = function scroll(coordinates2, firstCoordinate) {
  var i2 = CoordinateArrays.indexOf(firstCoordinate, coordinates2);
  if (i2 < 0) {
    return null;
  }
  var newCoordinates = new Array(coordinates2.length).fill(null);
  System.arraycopy(coordinates2, i2, newCoordinates, 0, coordinates2.length - i2);
  System.arraycopy(coordinates2, 0, newCoordinates, coordinates2.length - i2, i2);
  System.arraycopy(newCoordinates, 0, coordinates2, 0, coordinates2.length);
};
CoordinateArrays.equals = function equals7() {
  if (arguments.length === 2) {
    var coord1 = arguments[0];
    var coord2 = arguments[1];
    if (coord1 === coord2) {
      return true;
    }
    if (coord1 === null || coord2 === null) {
      return false;
    }
    if (coord1.length !== coord2.length) {
      return false;
    }
    for (var i2 = 0; i2 < coord1.length; i2++) {
      if (!coord1[i2].equals(coord2[i2])) {
        return false;
      }
    }
    return true;
  } else if (arguments.length === 3) {
    var coord1$1 = arguments[0];
    var coord2$1 = arguments[1];
    var coordinateComparator = arguments[2];
    if (coord1$1 === coord2$1) {
      return true;
    }
    if (coord1$1 === null || coord2$1 === null) {
      return false;
    }
    if (coord1$1.length !== coord2$1.length) {
      return false;
    }
    for (var i$12 = 0; i$12 < coord1$1.length; i$12++) {
      if (coordinateComparator.compare(coord1$1[i$12], coord2$1[i$12]) !== 0) {
        return false;
      }
    }
    return true;
  }
};
CoordinateArrays.intersection = function intersection4(coordinates2, env) {
  var coordList = new CoordinateList();
  for (var i2 = 0; i2 < coordinates2.length; i2++) {
    if (env.intersects(coordinates2[i2])) {
      coordList.add(coordinates2[i2], true);
    }
  }
  return coordList.toCoordinateArray();
};
CoordinateArrays.hasRepeatedPoints = function hasRepeatedPoints(coord) {
  for (var i2 = 1; i2 < coord.length; i2++) {
    if (coord[i2 - 1].equals(coord[i2])) {
      return true;
    }
  }
  return false;
};
CoordinateArrays.removeRepeatedPoints = function removeRepeatedPoints(coord) {
  if (!CoordinateArrays.hasRepeatedPoints(coord)) {
    return coord;
  }
  var coordList = new CoordinateList(coord, false);
  return coordList.toCoordinateArray();
};
CoordinateArrays.reverse = function reverse(coord) {
  var last = coord.length - 1;
  var mid = Math.trunc(last / 2);
  for (var i2 = 0; i2 <= mid; i2++) {
    var tmp2 = coord[i2];
    coord[i2] = coord[last - i2];
    coord[last - i2] = tmp2;
  }
};
CoordinateArrays.removeNull = function removeNull(coord) {
  var nonNull = 0;
  for (var i2 = 0; i2 < coord.length; i2++) {
    if (coord[i2] !== null) {
      nonNull++;
    }
  }
  var newCoord = new Array(nonNull).fill(null);
  if (nonNull === 0) {
    return newCoord;
  }
  var j2 = 0;
  for (var i$12 = 0; i$12 < coord.length; i$12++) {
    if (coord[i$12] !== null) {
      newCoord[j2++] = coord[i$12];
    }
  }
  return newCoord;
};
CoordinateArrays.copyDeep = function copyDeep() {
  if (arguments.length === 1) {
    var coordinates2 = arguments[0];
    var copy8 = new Array(coordinates2.length).fill(null);
    for (var i2 = 0; i2 < coordinates2.length; i2++) {
      copy8[i2] = new Coordinate(coordinates2[i2]);
    }
    return copy8;
  } else if (arguments.length === 5) {
    var src2 = arguments[0];
    var srcStart = arguments[1];
    var dest = arguments[2];
    var destStart = arguments[3];
    var length2 = arguments[4];
    for (var i$12 = 0; i$12 < length2; i$12++) {
      dest[destStart + i$12] = new Coordinate(src2[srcStart + i$12]);
    }
  }
};
CoordinateArrays.isEqualReversed = function isEqualReversed(pts1, pts2) {
  for (var i2 = 0; i2 < pts1.length; i2++) {
    var p1 = pts1[i2];
    var p2 = pts2[pts1.length - i2 - 1];
    if (p1.compareTo(p2) !== 0) {
      return false;
    }
  }
  return true;
};
CoordinateArrays.envelope = function envelope(coordinates2) {
  var env = new Envelope();
  for (var i2 = 0; i2 < coordinates2.length; i2++) {
    env.expandToInclude(coordinates2[i2]);
  }
  return env;
};
CoordinateArrays.toCoordinateArray = function toCoordinateArray2(coordList) {
  return coordList.toArray(CoordinateArrays.coordArrayType);
};
CoordinateArrays.atLeastNCoordinatesOrNothing = function atLeastNCoordinatesOrNothing(n2, c2) {
  return c2.length >= n2 ? c2 : [];
};
CoordinateArrays.indexOf = function indexOf(coordinate2, coordinates2) {
  for (var i2 = 0; i2 < coordinates2.length; i2++) {
    if (coordinate2.equals(coordinates2[i2])) {
      return i2;
    }
  }
  return -1;
};
CoordinateArrays.increasingDirection = function increasingDirection(pts) {
  for (var i2 = 0; i2 < Math.trunc(pts.length / 2); i2++) {
    var j2 = pts.length - 1 - i2;
    var comp = pts[i2].compareTo(pts[j2]);
    if (comp !== 0) {
      return comp;
    }
  }
  return 1;
};
CoordinateArrays.compare = function compare4(pts1, pts2) {
  var i2 = 0;
  while (i2 < pts1.length && i2 < pts2.length) {
    var compare12 = pts1[i2].compareTo(pts2[i2]);
    if (compare12 !== 0) {
      return compare12;
    }
    i2++;
  }
  if (i2 < pts2.length) {
    return -1;
  }
  if (i2 < pts1.length) {
    return 1;
  }
  return 0;
};
CoordinateArrays.minCoordinate = function minCoordinate(coordinates2) {
  var minCoord = null;
  for (var i2 = 0; i2 < coordinates2.length; i2++) {
    if (minCoord === null || minCoord.compareTo(coordinates2[i2]) > 0) {
      minCoord = coordinates2[i2];
    }
  }
  return minCoord;
};
CoordinateArrays.extract = function extract2(pts, start2, end) {
  start2 = MathUtil.clamp(start2, 0, pts.length);
  end = MathUtil.clamp(end, -1, pts.length);
  var npts = end - start2 + 1;
  if (end < 0) {
    npts = 0;
  }
  if (start2 >= pts.length) {
    npts = 0;
  }
  if (end < start2) {
    npts = 0;
  }
  var extractPts = new Array(npts).fill(null);
  if (npts === 0) {
    return extractPts;
  }
  var iPts = 0;
  for (var i2 = start2; i2 <= end; i2++) {
    extractPts[iPts++] = pts[i2];
  }
  return extractPts;
};
Object.defineProperties(CoordinateArrays, staticAccessors$13);
var ForwardComparator = function ForwardComparator2() {
};
ForwardComparator.prototype.compare = function compare5(o1, o2) {
  var pts1 = o1;
  var pts2 = o2;
  return CoordinateArrays.compare(pts1, pts2);
};
ForwardComparator.prototype.interfaces_ = function interfaces_27() {
  return [Comparator];
};
ForwardComparator.prototype.getClass = function getClass26() {
  return ForwardComparator;
};
var BidirectionalComparator = function BidirectionalComparator2() {
};
BidirectionalComparator.prototype.compare = function compare6(o1, o2) {
  var pts1 = o1;
  var pts2 = o2;
  if (pts1.length < pts2.length) {
    return -1;
  }
  if (pts1.length > pts2.length) {
    return 1;
  }
  if (pts1.length === 0) {
    return 0;
  }
  var forwardComp = CoordinateArrays.compare(pts1, pts2);
  var isEqualRev = CoordinateArrays.isEqualReversed(pts1, pts2);
  if (isEqualRev) {
    return 0;
  }
  return forwardComp;
};
BidirectionalComparator.prototype.OLDcompare = function OLDcompare(o1, o2) {
  var pts1 = o1;
  var pts2 = o2;
  if (pts1.length < pts2.length) {
    return -1;
  }
  if (pts1.length > pts2.length) {
    return 1;
  }
  if (pts1.length === 0) {
    return 0;
  }
  var dir1 = CoordinateArrays.increasingDirection(pts1);
  var dir2 = CoordinateArrays.increasingDirection(pts2);
  var i1 = dir1 > 0 ? 0 : pts1.length - 1;
  var i2 = dir2 > 0 ? 0 : pts1.length - 1;
  for (var i3 = 0; i3 < pts1.length; i3++) {
    var comparePt = pts1[i1].compareTo(pts2[i2]);
    if (comparePt !== 0) {
      return comparePt;
    }
    i1 += dir1;
    i2 += dir2;
  }
  return 0;
};
BidirectionalComparator.prototype.interfaces_ = function interfaces_28() {
  return [Comparator];
};
BidirectionalComparator.prototype.getClass = function getClass27() {
  return BidirectionalComparator;
};
var Map$1$1 = function Map2() {
};
Map$1$1.prototype.get = function get2() {
};
Map$1$1.prototype.put = function put() {
};
Map$1$1.prototype.size = function size4() {
};
Map$1$1.prototype.values = function values() {
};
Map$1$1.prototype.entrySet = function entrySet() {
};
var SortedMap = function(Map3) {
  function SortedMap2() {
    Map3.apply(this, arguments);
  }
  if (Map3)
    SortedMap2.__proto__ = Map3;
  SortedMap2.prototype = Object.create(Map3 && Map3.prototype);
  SortedMap2.prototype.constructor = SortedMap2;
  return SortedMap2;
}(Map$1$1);
function OperationNotSupported(message2) {
  this.message = message2 || "";
}
OperationNotSupported.prototype = new Error();
OperationNotSupported.prototype.name = "OperationNotSupported";
function Set$5() {
}
Set$5.prototype = new Collection();
Set$5.prototype.contains = function() {
};
var HashSet = function(Set$$1) {
  function HashSet2() {
    Set$$1.call(this);
    this.array_ = [];
    if (arguments[0] instanceof Collection) {
      this.addAll(arguments[0]);
    }
  }
  if (Set$$1)
    HashSet2.__proto__ = Set$$1;
  HashSet2.prototype = Object.create(Set$$1 && Set$$1.prototype);
  HashSet2.prototype.constructor = HashSet2;
  HashSet2.prototype.contains = function contains3(o2) {
    var this$1$1 = this;
    for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
      var e3 = this$1$1.array_[i2];
      if (e3 === o2) {
        return true;
      }
    }
    return false;
  };
  HashSet2.prototype.add = function add18(o2) {
    if (this.contains(o2)) {
      return false;
    }
    this.array_.push(o2);
    return true;
  };
  HashSet2.prototype.addAll = function addAll3(c2) {
    var this$1$1 = this;
    for (var i2 = c2.iterator(); i2.hasNext(); ) {
      this$1$1.add(i2.next());
    }
    return true;
  };
  HashSet2.prototype.remove = function remove6(o2) {
    throw new Error();
  };
  HashSet2.prototype.size = function size12() {
    return this.array_.length;
  };
  HashSet2.prototype.isEmpty = function isEmpty6() {
    return this.array_.length === 0;
  };
  HashSet2.prototype.toArray = function toArray3() {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
      array2.push(this$1$1.array_[i2]);
    }
    return array2;
  };
  HashSet2.prototype.iterator = function iterator7() {
    return new Iterator_$1(this);
  };
  return HashSet2;
}(Set$5);
var Iterator_$1 = function(Iterator$$1) {
  function Iterator_2(hashSet2) {
    Iterator$$1.call(this);
    this.hashSet_ = hashSet2;
    this.position_ = 0;
  }
  if (Iterator$$1)
    Iterator_2.__proto__ = Iterator$$1;
  Iterator_2.prototype = Object.create(Iterator$$1 && Iterator$$1.prototype);
  Iterator_2.prototype.constructor = Iterator_2;
  Iterator_2.prototype.next = function next5() {
    if (this.position_ === this.hashSet_.size()) {
      throw new NoSuchElementException();
    }
    return this.hashSet_.array_[this.position_++];
  };
  Iterator_2.prototype.hasNext = function hasNext3() {
    if (this.position_ < this.hashSet_.size()) {
      return true;
    } else {
      return false;
    }
  };
  Iterator_2.prototype.remove = function remove6() {
    throw new OperationNotSupported();
  };
  return Iterator_2;
}(Iterator);
var BLACK = 0;
var RED = 1;
function colorOf(p2) {
  return p2 === null ? BLACK : p2.color;
}
function parentOf(p2) {
  return p2 === null ? null : p2.parent;
}
function setColor(p2, c2) {
  if (p2 !== null) {
    p2.color = c2;
  }
}
function leftOf(p2) {
  return p2 === null ? null : p2.left;
}
function rightOf(p2) {
  return p2 === null ? null : p2.right;
}
function TreeMap() {
  this.root_ = null;
  this.size_ = 0;
}
TreeMap.prototype = new SortedMap();
TreeMap.prototype.get = function(key) {
  var p2 = this.root_;
  while (p2 !== null) {
    var cmp = key["compareTo"](p2.key);
    if (cmp < 0) {
      p2 = p2.left;
    } else if (cmp > 0) {
      p2 = p2.right;
    } else {
      return p2.value;
    }
  }
  return null;
};
TreeMap.prototype.put = function(key, value) {
  if (this.root_ === null) {
    this.root_ = {
      key,
      value,
      left: null,
      right: null,
      parent: null,
      color: BLACK,
      getValue: function getValue2() {
        return this.value;
      },
      getKey: function getKey() {
        return this.key;
      }
    };
    this.size_ = 1;
    return null;
  }
  var t2 = this.root_;
  var parent;
  var cmp;
  do {
    parent = t2;
    cmp = key["compareTo"](t2.key);
    if (cmp < 0) {
      t2 = t2.left;
    } else if (cmp > 0) {
      t2 = t2.right;
    } else {
      var oldValue = t2.value;
      t2.value = value;
      return oldValue;
    }
  } while (t2 !== null);
  var e3 = {
    key,
    left: null,
    right: null,
    value,
    parent,
    color: BLACK,
    getValue: function getValue2() {
      return this.value;
    },
    getKey: function getKey() {
      return this.key;
    }
  };
  if (cmp < 0) {
    parent.left = e3;
  } else {
    parent.right = e3;
  }
  this.fixAfterInsertion(e3);
  this.size_++;
  return null;
};
TreeMap.prototype.fixAfterInsertion = function(x2) {
  var this$1$1 = this;
  x2.color = RED;
  while (x2 != null && x2 !== this.root_ && x2.parent.color === RED) {
    if (parentOf(x2) === leftOf(parentOf(parentOf(x2)))) {
      var y2 = rightOf(parentOf(parentOf(x2)));
      if (colorOf(y2) === RED) {
        setColor(parentOf(x2), BLACK);
        setColor(y2, BLACK);
        setColor(parentOf(parentOf(x2)), RED);
        x2 = parentOf(parentOf(x2));
      } else {
        if (x2 === rightOf(parentOf(x2))) {
          x2 = parentOf(x2);
          this$1$1.rotateLeft(x2);
        }
        setColor(parentOf(x2), BLACK);
        setColor(parentOf(parentOf(x2)), RED);
        this$1$1.rotateRight(parentOf(parentOf(x2)));
      }
    } else {
      var y$12 = leftOf(parentOf(parentOf(x2)));
      if (colorOf(y$12) === RED) {
        setColor(parentOf(x2), BLACK);
        setColor(y$12, BLACK);
        setColor(parentOf(parentOf(x2)), RED);
        x2 = parentOf(parentOf(x2));
      } else {
        if (x2 === leftOf(parentOf(x2))) {
          x2 = parentOf(x2);
          this$1$1.rotateRight(x2);
        }
        setColor(parentOf(x2), BLACK);
        setColor(parentOf(parentOf(x2)), RED);
        this$1$1.rotateLeft(parentOf(parentOf(x2)));
      }
    }
  }
  this.root_.color = BLACK;
};
TreeMap.prototype.values = function() {
  var arrayList = new ArrayList();
  var p2 = this.getFirstEntry();
  if (p2 !== null) {
    arrayList.add(p2.value);
    while ((p2 = TreeMap.successor(p2)) !== null) {
      arrayList.add(p2.value);
    }
  }
  return arrayList;
};
TreeMap.prototype.entrySet = function() {
  var hashSet2 = new HashSet();
  var p2 = this.getFirstEntry();
  if (p2 !== null) {
    hashSet2.add(p2);
    while ((p2 = TreeMap.successor(p2)) !== null) {
      hashSet2.add(p2);
    }
  }
  return hashSet2;
};
TreeMap.prototype.rotateLeft = function(p2) {
  if (p2 != null) {
    var r2 = p2.right;
    p2.right = r2.left;
    if (r2.left != null) {
      r2.left.parent = p2;
    }
    r2.parent = p2.parent;
    if (p2.parent === null) {
      this.root_ = r2;
    } else if (p2.parent.left === p2) {
      p2.parent.left = r2;
    } else {
      p2.parent.right = r2;
    }
    r2.left = p2;
    p2.parent = r2;
  }
};
TreeMap.prototype.rotateRight = function(p2) {
  if (p2 != null) {
    var l2 = p2.left;
    p2.left = l2.right;
    if (l2.right != null) {
      l2.right.parent = p2;
    }
    l2.parent = p2.parent;
    if (p2.parent === null) {
      this.root_ = l2;
    } else if (p2.parent.right === p2) {
      p2.parent.right = l2;
    } else {
      p2.parent.left = l2;
    }
    l2.right = p2;
    p2.parent = l2;
  }
};
TreeMap.prototype.getFirstEntry = function() {
  var p2 = this.root_;
  if (p2 != null) {
    while (p2.left != null) {
      p2 = p2.left;
    }
  }
  return p2;
};
TreeMap.successor = function(t2) {
  if (t2 === null) {
    return null;
  } else if (t2.right !== null) {
    var p2 = t2.right;
    while (p2.left !== null) {
      p2 = p2.left;
    }
    return p2;
  } else {
    var p$12 = t2.parent;
    var ch2 = t2;
    while (p$12 !== null && ch2 === p$12.right) {
      ch2 = p$12;
      p$12 = p$12.parent;
    }
    return p$12;
  }
};
TreeMap.prototype.size = function() {
  return this.size_;
};
var Lineal = function Lineal2() {
};
Lineal.prototype.interfaces_ = function interfaces_29() {
  return [];
};
Lineal.prototype.getClass = function getClass28() {
  return Lineal;
};
function SortedSet() {
}
SortedSet.prototype = new Set$5();
function TreeSet() {
  this.array_ = [];
  if (arguments[0] instanceof Collection) {
    this.addAll(arguments[0]);
  }
}
TreeSet.prototype = new SortedSet();
TreeSet.prototype.contains = function(o2) {
  var this$1$1 = this;
  for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
    var e3 = this$1$1.array_[i2];
    if (e3["compareTo"](o2) === 0) {
      return true;
    }
  }
  return false;
};
TreeSet.prototype.add = function(o2) {
  var this$1$1 = this;
  if (this.contains(o2)) {
    return false;
  }
  for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
    var e3 = this$1$1.array_[i2];
    if (e3["compareTo"](o2) === 1) {
      this$1$1.array_.splice(i2, 0, o2);
      return true;
    }
  }
  this.array_.push(o2);
  return true;
};
TreeSet.prototype.addAll = function(c2) {
  var this$1$1 = this;
  for (var i2 = c2.iterator(); i2.hasNext(); ) {
    this$1$1.add(i2.next());
  }
  return true;
};
TreeSet.prototype.remove = function(e3) {
  throw new OperationNotSupported();
};
TreeSet.prototype.size = function() {
  return this.array_.length;
};
TreeSet.prototype.isEmpty = function() {
  return this.array_.length === 0;
};
TreeSet.prototype.toArray = function() {
  var this$1$1 = this;
  var array2 = [];
  for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
    array2.push(this$1$1.array_[i2]);
  }
  return array2;
};
TreeSet.prototype.iterator = function() {
  return new Iterator_$2(this);
};
var Iterator_$2 = function(treeSet) {
  this.treeSet_ = treeSet;
  this.position_ = 0;
};
Iterator_$2.prototype.next = function() {
  if (this.position_ === this.treeSet_.size()) {
    throw new NoSuchElementException();
  }
  return this.treeSet_.array_[this.position_++];
};
Iterator_$2.prototype.hasNext = function() {
  if (this.position_ < this.treeSet_.size()) {
    return true;
  } else {
    return false;
  }
};
Iterator_$2.prototype.remove = function() {
  throw new OperationNotSupported();
};
var Arrays = function Arrays2() {
};
Arrays.sort = function sort() {
  var a2 = arguments[0];
  var i2;
  var t2;
  var comparator2;
  var compare12;
  if (arguments.length === 1) {
    compare12 = function(a3, b2) {
      return a3.compareTo(b2);
    };
    a2.sort(compare12);
  } else if (arguments.length === 2) {
    comparator2 = arguments[1];
    compare12 = function(a3, b2) {
      return comparator2["compare"](a3, b2);
    };
    a2.sort(compare12);
  } else if (arguments.length === 3) {
    t2 = a2.slice(arguments[1], arguments[2]);
    t2.sort();
    var r2 = a2.slice(0, arguments[1]).concat(t2, a2.slice(arguments[2], a2.length));
    a2.splice(0, a2.length);
    for (i2 = 0; i2 < r2.length; i2++) {
      a2.push(r2[i2]);
    }
  } else if (arguments.length === 4) {
    t2 = a2.slice(arguments[1], arguments[2]);
    comparator2 = arguments[3];
    compare12 = function(a3, b2) {
      return comparator2["compare"](a3, b2);
    };
    t2.sort(compare12);
    r2 = a2.slice(0, arguments[1]).concat(t2, a2.slice(arguments[2], a2.length));
    a2.splice(0, a2.length);
    for (i2 = 0; i2 < r2.length; i2++) {
      a2.push(r2[i2]);
    }
  }
};
Arrays.asList = function asList(array2) {
  var arrayList = new ArrayList();
  for (var i2 = 0, len2 = array2.length; i2 < len2; i2++) {
    arrayList.add(array2[i2]);
  }
  return arrayList;
};
var Dimension = function Dimension2() {
};
var staticAccessors$14 = { P: { configurable: true }, L: { configurable: true }, A: { configurable: true }, FALSE: { configurable: true }, TRUE: { configurable: true }, DONTCARE: { configurable: true }, SYM_FALSE: { configurable: true }, SYM_TRUE: { configurable: true }, SYM_DONTCARE: { configurable: true }, SYM_P: { configurable: true }, SYM_L: { configurable: true }, SYM_A: { configurable: true } };
staticAccessors$14.P.get = function() {
  return 0;
};
staticAccessors$14.L.get = function() {
  return 1;
};
staticAccessors$14.A.get = function() {
  return 2;
};
staticAccessors$14.FALSE.get = function() {
  return -1;
};
staticAccessors$14.TRUE.get = function() {
  return -2;
};
staticAccessors$14.DONTCARE.get = function() {
  return -3;
};
staticAccessors$14.SYM_FALSE.get = function() {
  return "F";
};
staticAccessors$14.SYM_TRUE.get = function() {
  return "T";
};
staticAccessors$14.SYM_DONTCARE.get = function() {
  return "*";
};
staticAccessors$14.SYM_P.get = function() {
  return "0";
};
staticAccessors$14.SYM_L.get = function() {
  return "1";
};
staticAccessors$14.SYM_A.get = function() {
  return "2";
};
Dimension.prototype.interfaces_ = function interfaces_30() {
  return [];
};
Dimension.prototype.getClass = function getClass29() {
  return Dimension;
};
Dimension.toDimensionSymbol = function toDimensionSymbol(dimensionValue) {
  switch (dimensionValue) {
    case Dimension.FALSE:
      return Dimension.SYM_FALSE;
    case Dimension.TRUE:
      return Dimension.SYM_TRUE;
    case Dimension.DONTCARE:
      return Dimension.SYM_DONTCARE;
    case Dimension.P:
      return Dimension.SYM_P;
    case Dimension.L:
      return Dimension.SYM_L;
    case Dimension.A:
      return Dimension.SYM_A;
  }
  throw new IllegalArgumentException("Unknown dimension value: " + dimensionValue);
};
Dimension.toDimensionValue = function toDimensionValue(dimensionSymbol) {
  switch (Character.toUpperCase(dimensionSymbol)) {
    case Dimension.SYM_FALSE:
      return Dimension.FALSE;
    case Dimension.SYM_TRUE:
      return Dimension.TRUE;
    case Dimension.SYM_DONTCARE:
      return Dimension.DONTCARE;
    case Dimension.SYM_P:
      return Dimension.P;
    case Dimension.SYM_L:
      return Dimension.L;
    case Dimension.SYM_A:
      return Dimension.A;
  }
  throw new IllegalArgumentException("Unknown dimension symbol: " + dimensionSymbol);
};
Object.defineProperties(Dimension, staticAccessors$14);
var GeometryFilter = function GeometryFilter2() {
};
GeometryFilter.prototype.filter = function filter4(geom) {
};
GeometryFilter.prototype.interfaces_ = function interfaces_31() {
  return [];
};
GeometryFilter.prototype.getClass = function getClass30() {
  return GeometryFilter;
};
var CoordinateSequenceFilter = function CoordinateSequenceFilter2() {
};
CoordinateSequenceFilter.prototype.filter = function filter5(seq, i2) {
};
CoordinateSequenceFilter.prototype.isDone = function isDone() {
};
CoordinateSequenceFilter.prototype.isGeometryChanged = function isGeometryChanged() {
};
CoordinateSequenceFilter.prototype.interfaces_ = function interfaces_32() {
  return [];
};
CoordinateSequenceFilter.prototype.getClass = function getClass31() {
  return CoordinateSequenceFilter;
};
var GeometryCollection = function(Geometry$$1) {
  function GeometryCollection2(geometries, factory) {
    Geometry$$1.call(this, factory);
    this._geometries = geometries || [];
    if (Geometry$$1.hasNullElements(this._geometries)) {
      throw new IllegalArgumentException("geometries must not contain null elements");
    }
  }
  if (Geometry$$1)
    GeometryCollection2.__proto__ = Geometry$$1;
  GeometryCollection2.prototype = Object.create(Geometry$$1 && Geometry$$1.prototype);
  GeometryCollection2.prototype.constructor = GeometryCollection2;
  var staticAccessors2 = { serialVersionUID: { configurable: true } };
  GeometryCollection2.prototype.computeEnvelopeInternal = function computeEnvelopeInternal() {
    var this$1$1 = this;
    var envelope2 = new Envelope();
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      envelope2.expandToInclude(this$1$1._geometries[i2].getEnvelopeInternal());
    }
    return envelope2;
  };
  GeometryCollection2.prototype.getGeometryN = function getGeometryN2(n2) {
    return this._geometries[n2];
  };
  GeometryCollection2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$$1.SORTINDEX_GEOMETRYCOLLECTION;
  };
  GeometryCollection2.prototype.getCoordinates = function getCoordinates12() {
    var this$1$1 = this;
    var coordinates2 = new Array(this.getNumPoints()).fill(null);
    var k2 = -1;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      var childCoordinates = this$1$1._geometries[i2].getCoordinates();
      for (var j2 = 0; j2 < childCoordinates.length; j2++) {
        k2++;
        coordinates2[k2] = childCoordinates[j2];
      }
    }
    return coordinates2;
  };
  GeometryCollection2.prototype.getArea = function getArea3() {
    var this$1$1 = this;
    var area5 = 0;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      area5 += this$1$1._geometries[i2].getArea();
    }
    return area5;
  };
  GeometryCollection2.prototype.equalsExact = function equalsExact2() {
    var this$1$1 = this;
    if (arguments.length === 2) {
      var other = arguments[0];
      var tolerance = arguments[1];
      if (!this.isEquivalentClass(other)) {
        return false;
      }
      var otherCollection = other;
      if (this._geometries.length !== otherCollection._geometries.length) {
        return false;
      }
      for (var i2 = 0; i2 < this._geometries.length; i2++) {
        if (!this$1$1._geometries[i2].equalsExact(otherCollection._geometries[i2], tolerance)) {
          return false;
        }
      }
      return true;
    } else {
      return Geometry$$1.prototype.equalsExact.apply(this, arguments);
    }
  };
  GeometryCollection2.prototype.normalize = function normalize5() {
    var this$1$1 = this;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      this$1$1._geometries[i2].normalize();
    }
    Arrays.sort(this._geometries);
  };
  GeometryCollection2.prototype.getCoordinate = function getCoordinate18() {
    if (this.isEmpty()) {
      return null;
    }
    return this._geometries[0].getCoordinate();
  };
  GeometryCollection2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    var this$1$1 = this;
    var dimension = Dimension.FALSE;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      dimension = Math.max(dimension, this$1$1._geometries[i2].getBoundaryDimension());
    }
    return dimension;
  };
  GeometryCollection2.prototype.getDimension = function getDimension3() {
    var this$1$1 = this;
    var dimension = Dimension.FALSE;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      dimension = Math.max(dimension, this$1$1._geometries[i2].getDimension());
    }
    return dimension;
  };
  GeometryCollection2.prototype.getLength = function getLength3() {
    var this$1$1 = this;
    var sum2 = 0;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      sum2 += this$1$1._geometries[i2].getLength();
    }
    return sum2;
  };
  GeometryCollection2.prototype.getNumPoints = function getNumPoints() {
    var this$1$1 = this;
    var numPoints = 0;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      numPoints += this$1$1._geometries[i2].getNumPoints();
    }
    return numPoints;
  };
  GeometryCollection2.prototype.getNumGeometries = function getNumGeometries2() {
    return this._geometries.length;
  };
  GeometryCollection2.prototype.reverse = function reverse4() {
    var this$1$1 = this;
    var n2 = this._geometries.length;
    var revGeoms = new Array(n2).fill(null);
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      revGeoms[i2] = this$1$1._geometries[i2].reverse();
    }
    return this.getFactory().createGeometryCollection(revGeoms);
  };
  GeometryCollection2.prototype.compareToSameClass = function compareToSameClass() {
    var this$1$1 = this;
    if (arguments.length === 1) {
      var o2 = arguments[0];
      var theseElements = new TreeSet(Arrays.asList(this._geometries));
      var otherElements = new TreeSet(Arrays.asList(o2._geometries));
      return this.compare(theseElements, otherElements);
    } else if (arguments.length === 2) {
      var o$12 = arguments[0];
      var comp = arguments[1];
      var gc = o$12;
      var n1 = this.getNumGeometries();
      var n2 = gc.getNumGeometries();
      var i2 = 0;
      while (i2 < n1 && i2 < n2) {
        var thisGeom = this$1$1.getGeometryN(i2);
        var otherGeom = gc.getGeometryN(i2);
        var holeComp = thisGeom.compareToSameClass(otherGeom, comp);
        if (holeComp !== 0) {
          return holeComp;
        }
        i2++;
      }
      if (i2 < n1) {
        return 1;
      }
      if (i2 < n2) {
        return -1;
      }
      return 0;
    }
  };
  GeometryCollection2.prototype.apply = function apply2() {
    var this$1$1 = this;
    if (hasInterface(arguments[0], CoordinateFilter)) {
      var filter17 = arguments[0];
      for (var i2 = 0; i2 < this._geometries.length; i2++) {
        this$1$1._geometries[i2].apply(filter17);
      }
    } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
      var filter$1 = arguments[0];
      if (this._geometries.length === 0) {
        return null;
      }
      for (var i$12 = 0; i$12 < this._geometries.length; i$12++) {
        this$1$1._geometries[i$12].apply(filter$1);
        if (filter$1.isDone()) {
          break;
        }
      }
      if (filter$1.isGeometryChanged()) {
        this.geometryChanged();
      }
    } else if (hasInterface(arguments[0], GeometryFilter)) {
      var filter$2 = arguments[0];
      filter$2.filter(this);
      for (var i$22 = 0; i$22 < this._geometries.length; i$22++) {
        this$1$1._geometries[i$22].apply(filter$2);
      }
    } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
      var filter$3 = arguments[0];
      filter$3.filter(this);
      for (var i$32 = 0; i$32 < this._geometries.length; i$32++) {
        this$1$1._geometries[i$32].apply(filter$3);
      }
    }
  };
  GeometryCollection2.prototype.getBoundary = function getBoundary3() {
    this.checkNotGeometryCollection(this);
    Assert.shouldNeverReachHere();
    return null;
  };
  GeometryCollection2.prototype.clone = function clone8() {
    var this$1$1 = this;
    var gc = Geometry$$1.prototype.clone.call(this);
    gc._geometries = new Array(this._geometries.length).fill(null);
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      gc._geometries[i2] = this$1$1._geometries[i2].clone();
    }
    return gc;
  };
  GeometryCollection2.prototype.getGeometryType = function getGeometryType() {
    return "GeometryCollection";
  };
  GeometryCollection2.prototype.copy = function copy8() {
    var this$1$1 = this;
    var geometries = new Array(this._geometries.length).fill(null);
    for (var i2 = 0; i2 < geometries.length; i2++) {
      geometries[i2] = this$1$1._geometries[i2].copy();
    }
    return new GeometryCollection2(geometries, this._factory);
  };
  GeometryCollection2.prototype.isEmpty = function isEmpty6() {
    var this$1$1 = this;
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      if (!this$1$1._geometries[i2].isEmpty()) {
        return false;
      }
    }
    return true;
  };
  GeometryCollection2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  GeometryCollection2.prototype.getClass = function getClass169() {
    return GeometryCollection2;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return -5694727726395021e3;
  };
  Object.defineProperties(GeometryCollection2, staticAccessors2);
  return GeometryCollection2;
}(Geometry$1);
var MultiLineString$1 = function(GeometryCollection$$1) {
  function MultiLineString2() {
    GeometryCollection$$1.apply(this, arguments);
  }
  if (GeometryCollection$$1)
    MultiLineString2.__proto__ = GeometryCollection$$1;
  MultiLineString2.prototype = Object.create(GeometryCollection$$1 && GeometryCollection$$1.prototype);
  MultiLineString2.prototype.constructor = MultiLineString2;
  var staticAccessors2 = { serialVersionUID: { configurable: true } };
  MultiLineString2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$1.SORTINDEX_MULTILINESTRING;
  };
  MultiLineString2.prototype.equalsExact = function equalsExact2() {
    if (arguments.length === 2) {
      var other = arguments[0];
      var tolerance = arguments[1];
      if (!this.isEquivalentClass(other)) {
        return false;
      }
      return GeometryCollection$$1.prototype.equalsExact.call(this, other, tolerance);
    } else {
      return GeometryCollection$$1.prototype.equalsExact.apply(this, arguments);
    }
  };
  MultiLineString2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    if (this.isClosed()) {
      return Dimension.FALSE;
    }
    return 0;
  };
  MultiLineString2.prototype.isClosed = function isClosed5() {
    var this$1$1 = this;
    if (this.isEmpty()) {
      return false;
    }
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      if (!this$1$1._geometries[i2].isClosed()) {
        return false;
      }
    }
    return true;
  };
  MultiLineString2.prototype.getDimension = function getDimension3() {
    return 1;
  };
  MultiLineString2.prototype.reverse = function reverse4() {
    var this$1$1 = this;
    var nLines = this._geometries.length;
    var revLines = new Array(nLines).fill(null);
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      revLines[nLines - 1 - i2] = this$1$1._geometries[i2].reverse();
    }
    return this.getFactory().createMultiLineString(revLines);
  };
  MultiLineString2.prototype.getBoundary = function getBoundary3() {
    return new BoundaryOp(this).getBoundary();
  };
  MultiLineString2.prototype.getGeometryType = function getGeometryType() {
    return "MultiLineString";
  };
  MultiLineString2.prototype.copy = function copy8() {
    var this$1$1 = this;
    var lineStrings2 = new Array(this._geometries.length).fill(null);
    for (var i2 = 0; i2 < lineStrings2.length; i2++) {
      lineStrings2[i2] = this$1$1._geometries[i2].copy();
    }
    return new MultiLineString2(lineStrings2, this._factory);
  };
  MultiLineString2.prototype.interfaces_ = function interfaces_170() {
    return [Lineal];
  };
  MultiLineString2.prototype.getClass = function getClass169() {
    return MultiLineString2;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return 8166665132445434e3;
  };
  Object.defineProperties(MultiLineString2, staticAccessors2);
  return MultiLineString2;
}(GeometryCollection);
var BoundaryOp = function BoundaryOp2() {
  this._geom = null;
  this._geomFact = null;
  this._bnRule = null;
  this._endpointMap = null;
  if (arguments.length === 1) {
    var geom = arguments[0];
    var bnRule = BoundaryNodeRule.MOD2_BOUNDARY_RULE;
    this._geom = geom;
    this._geomFact = geom.getFactory();
    this._bnRule = bnRule;
  } else if (arguments.length === 2) {
    var geom$1 = arguments[0];
    var bnRule$1 = arguments[1];
    this._geom = geom$1;
    this._geomFact = geom$1.getFactory();
    this._bnRule = bnRule$1;
  }
};
BoundaryOp.prototype.boundaryMultiLineString = function boundaryMultiLineString(mLine) {
  if (this._geom.isEmpty()) {
    return this.getEmptyMultiPoint();
  }
  var bdyPts = this.computeBoundaryCoordinates(mLine);
  if (bdyPts.length === 1) {
    return this._geomFact.createPoint(bdyPts[0]);
  }
  return this._geomFact.createMultiPointFromCoords(bdyPts);
};
BoundaryOp.prototype.getBoundary = function getBoundary() {
  if (this._geom instanceof LineString$4) {
    return this.boundaryLineString(this._geom);
  }
  if (this._geom instanceof MultiLineString$1) {
    return this.boundaryMultiLineString(this._geom);
  }
  return this._geom.getBoundary();
};
BoundaryOp.prototype.boundaryLineString = function boundaryLineString(line) {
  if (this._geom.isEmpty()) {
    return this.getEmptyMultiPoint();
  }
  if (line.isClosed()) {
    var closedEndpointOnBoundary = this._bnRule.isInBoundary(2);
    if (closedEndpointOnBoundary) {
      return line.getStartPoint();
    } else {
      return this._geomFact.createMultiPoint();
    }
  }
  return this._geomFact.createMultiPoint([line.getStartPoint(), line.getEndPoint()]);
};
BoundaryOp.prototype.getEmptyMultiPoint = function getEmptyMultiPoint() {
  return this._geomFact.createMultiPoint();
};
BoundaryOp.prototype.computeBoundaryCoordinates = function computeBoundaryCoordinates(mLine) {
  var this$1$1 = this;
  var bdyPts = new ArrayList();
  this._endpointMap = new TreeMap();
  for (var i2 = 0; i2 < mLine.getNumGeometries(); i2++) {
    var line = mLine.getGeometryN(i2);
    if (line.getNumPoints() === 0) {
      continue;
    }
    this$1$1.addEndpoint(line.getCoordinateN(0));
    this$1$1.addEndpoint(line.getCoordinateN(line.getNumPoints() - 1));
  }
  for (var it = this._endpointMap.entrySet().iterator(); it.hasNext(); ) {
    var entry = it.next();
    var counter2 = entry.getValue();
    var valence = counter2.count;
    if (this$1$1._bnRule.isInBoundary(valence)) {
      bdyPts.add(entry.getKey());
    }
  }
  return CoordinateArrays.toCoordinateArray(bdyPts);
};
BoundaryOp.prototype.addEndpoint = function addEndpoint(pt) {
  var counter2 = this._endpointMap.get(pt);
  if (counter2 === null) {
    counter2 = new Counter();
    this._endpointMap.put(pt, counter2);
  }
  counter2.count++;
};
BoundaryOp.prototype.interfaces_ = function interfaces_33() {
  return [];
};
BoundaryOp.prototype.getClass = function getClass32() {
  return BoundaryOp;
};
BoundaryOp.getBoundary = function getBoundary2() {
  if (arguments.length === 1) {
    var g2 = arguments[0];
    var bop = new BoundaryOp(g2);
    return bop.getBoundary();
  } else if (arguments.length === 2) {
    var g$12 = arguments[0];
    var bnRule = arguments[1];
    var bop$1 = new BoundaryOp(g$12, bnRule);
    return bop$1.getBoundary();
  }
};
var Counter = function Counter2() {
  this.count = null;
};
Counter.prototype.interfaces_ = function interfaces_34() {
  return [];
};
Counter.prototype.getClass = function getClass33() {
  return Counter;
};
function PrintStream() {
}
function StringReader() {
}
var DecimalFormat = function DecimalFormat2() {
};
function ByteArrayOutputStream() {
}
function IOException() {
}
function LineNumberReader() {
}
var StringUtil = function StringUtil2() {
};
var staticAccessors$15 = { NEWLINE: { configurable: true }, SIMPLE_ORDINATE_FORMAT: { configurable: true } };
StringUtil.prototype.interfaces_ = function interfaces_35() {
  return [];
};
StringUtil.prototype.getClass = function getClass34() {
  return StringUtil;
};
StringUtil.chars = function chars(c2, n2) {
  var ch2 = new Array(n2).fill(null);
  for (var i2 = 0; i2 < n2; i2++) {
    ch2[i2] = c2;
  }
  return String(ch2);
};
StringUtil.getStackTrace = function getStackTrace() {
  if (arguments.length === 1) {
    var t2 = arguments[0];
    var os = new ByteArrayOutputStream();
    var ps = new PrintStream();
    t2.printStackTrace(ps);
    return os.toString();
  } else if (arguments.length === 2) {
    var t$12 = arguments[0];
    var depth2 = arguments[1];
    var stackTrace = "";
    new StringReader(StringUtil.getStackTrace(t$12));
    var lineNumberReader = new LineNumberReader();
    for (var i2 = 0; i2 < depth2; i2++) {
      try {
        stackTrace += lineNumberReader.readLine() + StringUtil.NEWLINE;
      } catch (e3) {
        if (e3 instanceof IOException) {
          Assert.shouldNeverReachHere();
        } else {
          throw e3;
        }
      } finally {
      }
    }
    return stackTrace;
  }
};
StringUtil.split = function split(s2, separator) {
  var separatorlen = separator.length;
  var tokenList = new ArrayList();
  var tmpString = "" + s2;
  var pos = tmpString.indexOf(separator);
  while (pos >= 0) {
    var token = tmpString.substring(0, pos);
    tokenList.add(token);
    tmpString = tmpString.substring(pos + separatorlen);
    pos = tmpString.indexOf(separator);
  }
  if (tmpString.length > 0) {
    tokenList.add(tmpString);
  }
  var res = new Array(tokenList.size()).fill(null);
  for (var i2 = 0; i2 < res.length; i2++) {
    res[i2] = tokenList.get(i2);
  }
  return res;
};
StringUtil.toString = function toString7() {
  if (arguments.length === 1) {
    var d2 = arguments[0];
    return StringUtil.SIMPLE_ORDINATE_FORMAT.format(d2);
  }
};
StringUtil.spaces = function spaces(n2) {
  return StringUtil.chars(" ", n2);
};
staticAccessors$15.NEWLINE.get = function() {
  return System.getProperty("line.separator");
};
staticAccessors$15.SIMPLE_ORDINATE_FORMAT.get = function() {
  return new DecimalFormat();
};
Object.defineProperties(StringUtil, staticAccessors$15);
var CoordinateSequences = function CoordinateSequences2() {
};
CoordinateSequences.prototype.interfaces_ = function interfaces_36() {
  return [];
};
CoordinateSequences.prototype.getClass = function getClass35() {
  return CoordinateSequences;
};
CoordinateSequences.copyCoord = function copyCoord(src2, srcPos, dest, destPos) {
  var minDim = Math.min(src2.getDimension(), dest.getDimension());
  for (var dim = 0; dim < minDim; dim++) {
    dest.setOrdinate(destPos, dim, src2.getOrdinate(srcPos, dim));
  }
};
CoordinateSequences.isRing = function isRing2(seq) {
  var n2 = seq.size();
  if (n2 === 0) {
    return true;
  }
  if (n2 <= 3) {
    return false;
  }
  return seq.getOrdinate(0, CoordinateSequence.X) === seq.getOrdinate(n2 - 1, CoordinateSequence.X) && seq.getOrdinate(0, CoordinateSequence.Y) === seq.getOrdinate(n2 - 1, CoordinateSequence.Y);
};
CoordinateSequences.isEqual = function isEqual2(cs1, cs2) {
  var cs1Size = cs1.size();
  var cs2Size = cs2.size();
  if (cs1Size !== cs2Size) {
    return false;
  }
  var dim = Math.min(cs1.getDimension(), cs2.getDimension());
  for (var i2 = 0; i2 < cs1Size; i2++) {
    for (var d2 = 0; d2 < dim; d2++) {
      var v12 = cs1.getOrdinate(i2, d2);
      var v22 = cs2.getOrdinate(i2, d2);
      if (cs1.getOrdinate(i2, d2) === cs2.getOrdinate(i2, d2)) {
        continue;
      }
      if (Double.isNaN(v12) && Double.isNaN(v22)) {
        continue;
      }
      return false;
    }
  }
  return true;
};
CoordinateSequences.extend = function extend2(fact, seq, size12) {
  var newseq = fact.create(size12, seq.getDimension());
  var n2 = seq.size();
  CoordinateSequences.copy(seq, 0, newseq, 0, n2);
  if (n2 > 0) {
    for (var i2 = n2; i2 < size12; i2++) {
      CoordinateSequences.copy(seq, n2 - 1, newseq, i2, 1);
    }
  }
  return newseq;
};
CoordinateSequences.reverse = function reverse2(seq) {
  var last = seq.size() - 1;
  var mid = Math.trunc(last / 2);
  for (var i2 = 0; i2 <= mid; i2++) {
    CoordinateSequences.swap(seq, i2, last - i2);
  }
};
CoordinateSequences.swap = function swap2(seq, i2, j2) {
  if (i2 === j2) {
    return null;
  }
  for (var dim = 0; dim < seq.getDimension(); dim++) {
    var tmp2 = seq.getOrdinate(i2, dim);
    seq.setOrdinate(i2, dim, seq.getOrdinate(j2, dim));
    seq.setOrdinate(j2, dim, tmp2);
  }
};
CoordinateSequences.copy = function copy5(src2, srcPos, dest, destPos, length2) {
  for (var i2 = 0; i2 < length2; i2++) {
    CoordinateSequences.copyCoord(src2, srcPos + i2, dest, destPos + i2);
  }
};
CoordinateSequences.toString = function toString8() {
  if (arguments.length === 1) {
    var cs = arguments[0];
    var size12 = cs.size();
    if (size12 === 0) {
      return "()";
    }
    var dim = cs.getDimension();
    var buf = new StringBuffer();
    buf.append("(");
    for (var i2 = 0; i2 < size12; i2++) {
      if (i2 > 0) {
        buf.append(" ");
      }
      for (var d2 = 0; d2 < dim; d2++) {
        if (d2 > 0) {
          buf.append(",");
        }
        buf.append(StringUtil.toString(cs.getOrdinate(i2, d2)));
      }
    }
    buf.append(")");
    return buf.toString();
  }
};
CoordinateSequences.ensureValidRing = function ensureValidRing(fact, seq) {
  var n2 = seq.size();
  if (n2 === 0) {
    return seq;
  }
  if (n2 <= 3) {
    return CoordinateSequences.createClosedRing(fact, seq, 4);
  }
  var isClosed5 = seq.getOrdinate(0, CoordinateSequence.X) === seq.getOrdinate(n2 - 1, CoordinateSequence.X) && seq.getOrdinate(0, CoordinateSequence.Y) === seq.getOrdinate(n2 - 1, CoordinateSequence.Y);
  if (isClosed5) {
    return seq;
  }
  return CoordinateSequences.createClosedRing(fact, seq, n2 + 1);
};
CoordinateSequences.createClosedRing = function createClosedRing(fact, seq, size12) {
  var newseq = fact.create(size12, seq.getDimension());
  var n2 = seq.size();
  CoordinateSequences.copy(seq, 0, newseq, 0, n2);
  for (var i2 = n2; i2 < size12; i2++) {
    CoordinateSequences.copy(seq, 0, newseq, i2, 1);
  }
  return newseq;
};
var LineString$4 = function(Geometry$$1) {
  function LineString2(points2, factory) {
    Geometry$$1.call(this, factory);
    this._points = null;
    this.init(points2);
  }
  if (Geometry$$1)
    LineString2.__proto__ = Geometry$$1;
  LineString2.prototype = Object.create(Geometry$$1 && Geometry$$1.prototype);
  LineString2.prototype.constructor = LineString2;
  var staticAccessors2 = { serialVersionUID: { configurable: true } };
  LineString2.prototype.computeEnvelopeInternal = function computeEnvelopeInternal() {
    if (this.isEmpty()) {
      return new Envelope();
    }
    return this._points.expandEnvelope(new Envelope());
  };
  LineString2.prototype.isRing = function isRing3() {
    return this.isClosed() && this.isSimple();
  };
  LineString2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$$1.SORTINDEX_LINESTRING;
  };
  LineString2.prototype.getCoordinates = function getCoordinates12() {
    return this._points.toCoordinateArray();
  };
  LineString2.prototype.equalsExact = function equalsExact2() {
    var this$1$1 = this;
    if (arguments.length === 2) {
      var other = arguments[0];
      var tolerance = arguments[1];
      if (!this.isEquivalentClass(other)) {
        return false;
      }
      var otherLineString = other;
      if (this._points.size() !== otherLineString._points.size()) {
        return false;
      }
      for (var i2 = 0; i2 < this._points.size(); i2++) {
        if (!this$1$1.equal(this$1$1._points.getCoordinate(i2), otherLineString._points.getCoordinate(i2), tolerance)) {
          return false;
        }
      }
      return true;
    } else {
      return Geometry$$1.prototype.equalsExact.apply(this, arguments);
    }
  };
  LineString2.prototype.normalize = function normalize5() {
    var this$1$1 = this;
    for (var i2 = 0; i2 < Math.trunc(this._points.size() / 2); i2++) {
      var j2 = this$1$1._points.size() - 1 - i2;
      if (!this$1$1._points.getCoordinate(i2).equals(this$1$1._points.getCoordinate(j2))) {
        if (this$1$1._points.getCoordinate(i2).compareTo(this$1$1._points.getCoordinate(j2)) > 0) {
          CoordinateSequences.reverse(this$1$1._points);
        }
        return null;
      }
    }
  };
  LineString2.prototype.getCoordinate = function getCoordinate18() {
    if (this.isEmpty()) {
      return null;
    }
    return this._points.getCoordinate(0);
  };
  LineString2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    if (this.isClosed()) {
      return Dimension.FALSE;
    }
    return 0;
  };
  LineString2.prototype.isClosed = function isClosed5() {
    if (this.isEmpty()) {
      return false;
    }
    return this.getCoordinateN(0).equals2D(this.getCoordinateN(this.getNumPoints() - 1));
  };
  LineString2.prototype.getEndPoint = function getEndPoint() {
    if (this.isEmpty()) {
      return null;
    }
    return this.getPointN(this.getNumPoints() - 1);
  };
  LineString2.prototype.getDimension = function getDimension3() {
    return 1;
  };
  LineString2.prototype.getLength = function getLength3() {
    return CGAlgorithms.computeLength(this._points);
  };
  LineString2.prototype.getNumPoints = function getNumPoints() {
    return this._points.size();
  };
  LineString2.prototype.reverse = function reverse4() {
    var seq = this._points.copy();
    CoordinateSequences.reverse(seq);
    var revLine = this.getFactory().createLineString(seq);
    return revLine;
  };
  LineString2.prototype.compareToSameClass = function compareToSameClass() {
    var this$1$1 = this;
    if (arguments.length === 1) {
      var o2 = arguments[0];
      var line = o2;
      var i2 = 0;
      var j2 = 0;
      while (i2 < this._points.size() && j2 < line._points.size()) {
        var comparison = this$1$1._points.getCoordinate(i2).compareTo(line._points.getCoordinate(j2));
        if (comparison !== 0) {
          return comparison;
        }
        i2++;
        j2++;
      }
      if (i2 < this._points.size()) {
        return 1;
      }
      if (j2 < line._points.size()) {
        return -1;
      }
      return 0;
    } else if (arguments.length === 2) {
      var o$12 = arguments[0];
      var comp = arguments[1];
      var line$1 = o$12;
      return comp.compare(this._points, line$1._points);
    }
  };
  LineString2.prototype.apply = function apply2() {
    var this$1$1 = this;
    if (hasInterface(arguments[0], CoordinateFilter)) {
      var filter17 = arguments[0];
      for (var i2 = 0; i2 < this._points.size(); i2++) {
        filter17.filter(this$1$1._points.getCoordinate(i2));
      }
    } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
      var filter$1 = arguments[0];
      if (this._points.size() === 0) {
        return null;
      }
      for (var i$12 = 0; i$12 < this._points.size(); i$12++) {
        filter$1.filter(this$1$1._points, i$12);
        if (filter$1.isDone()) {
          break;
        }
      }
      if (filter$1.isGeometryChanged()) {
        this.geometryChanged();
      }
    } else if (hasInterface(arguments[0], GeometryFilter)) {
      var filter$2 = arguments[0];
      filter$2.filter(this);
    } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
      var filter$3 = arguments[0];
      filter$3.filter(this);
    }
  };
  LineString2.prototype.getBoundary = function getBoundary3() {
    return new BoundaryOp(this).getBoundary();
  };
  LineString2.prototype.isEquivalentClass = function isEquivalentClass(other) {
    return other instanceof LineString2;
  };
  LineString2.prototype.clone = function clone8() {
    var ls = Geometry$$1.prototype.clone.call(this);
    ls._points = this._points.clone();
    return ls;
  };
  LineString2.prototype.getCoordinateN = function getCoordinateN(n2) {
    return this._points.getCoordinate(n2);
  };
  LineString2.prototype.getGeometryType = function getGeometryType() {
    return "LineString";
  };
  LineString2.prototype.copy = function copy8() {
    return new LineString2(this._points.copy(), this._factory);
  };
  LineString2.prototype.getCoordinateSequence = function getCoordinateSequence() {
    return this._points;
  };
  LineString2.prototype.isEmpty = function isEmpty6() {
    return this._points.size() === 0;
  };
  LineString2.prototype.init = function init9(points2) {
    if (points2 === null) {
      points2 = this.getFactory().getCoordinateSequenceFactory().create([]);
    }
    if (points2.size() === 1) {
      throw new IllegalArgumentException("Invalid number of points in LineString (found " + points2.size() + " - must be 0 or >= 2)");
    }
    this._points = points2;
  };
  LineString2.prototype.isCoordinate = function isCoordinate(pt) {
    var this$1$1 = this;
    for (var i2 = 0; i2 < this._points.size(); i2++) {
      if (this$1$1._points.getCoordinate(i2).equals(pt)) {
        return true;
      }
    }
    return false;
  };
  LineString2.prototype.getStartPoint = function getStartPoint() {
    if (this.isEmpty()) {
      return null;
    }
    return this.getPointN(0);
  };
  LineString2.prototype.getPointN = function getPointN(n2) {
    return this.getFactory().createPoint(this._points.getCoordinate(n2));
  };
  LineString2.prototype.interfaces_ = function interfaces_170() {
    return [Lineal];
  };
  LineString2.prototype.getClass = function getClass169() {
    return LineString2;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return 3110669828065365500;
  };
  Object.defineProperties(LineString2, staticAccessors2);
  return LineString2;
}(Geometry$1);
var Puntal = function Puntal2() {
};
Puntal.prototype.interfaces_ = function interfaces_37() {
  return [];
};
Puntal.prototype.getClass = function getClass36() {
  return Puntal;
};
var Point$7 = function(Geometry$$1) {
  function Point2(coordinates2, factory) {
    Geometry$$1.call(this, factory);
    this._coordinates = coordinates2 || null;
    this.init(this._coordinates);
  }
  if (Geometry$$1)
    Point2.__proto__ = Geometry$$1;
  Point2.prototype = Object.create(Geometry$$1 && Geometry$$1.prototype);
  Point2.prototype.constructor = Point2;
  var staticAccessors2 = { serialVersionUID: { configurable: true } };
  Point2.prototype.computeEnvelopeInternal = function computeEnvelopeInternal() {
    if (this.isEmpty()) {
      return new Envelope();
    }
    var env = new Envelope();
    env.expandToInclude(this._coordinates.getX(0), this._coordinates.getY(0));
    return env;
  };
  Point2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$$1.SORTINDEX_POINT;
  };
  Point2.prototype.getCoordinates = function getCoordinates12() {
    return this.isEmpty() ? [] : [this.getCoordinate()];
  };
  Point2.prototype.equalsExact = function equalsExact2() {
    if (arguments.length === 2) {
      var other = arguments[0];
      var tolerance = arguments[1];
      if (!this.isEquivalentClass(other)) {
        return false;
      }
      if (this.isEmpty() && other.isEmpty()) {
        return true;
      }
      if (this.isEmpty() !== other.isEmpty()) {
        return false;
      }
      return this.equal(other.getCoordinate(), this.getCoordinate(), tolerance);
    } else {
      return Geometry$$1.prototype.equalsExact.apply(this, arguments);
    }
  };
  Point2.prototype.normalize = function normalize5() {
  };
  Point2.prototype.getCoordinate = function getCoordinate18() {
    return this._coordinates.size() !== 0 ? this._coordinates.getCoordinate(0) : null;
  };
  Point2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    return Dimension.FALSE;
  };
  Point2.prototype.getDimension = function getDimension3() {
    return 0;
  };
  Point2.prototype.getNumPoints = function getNumPoints() {
    return this.isEmpty() ? 0 : 1;
  };
  Point2.prototype.reverse = function reverse4() {
    return this.copy();
  };
  Point2.prototype.getX = function getX4() {
    if (this.getCoordinate() === null) {
      throw new Error("getX called on empty Point");
    }
    return this.getCoordinate().x;
  };
  Point2.prototype.compareToSameClass = function compareToSameClass() {
    if (arguments.length === 1) {
      var other = arguments[0];
      var point$12 = other;
      return this.getCoordinate().compareTo(point$12.getCoordinate());
    } else if (arguments.length === 2) {
      var other$1 = arguments[0];
      var comp = arguments[1];
      var point4 = other$1;
      return comp.compare(this._coordinates, point4._coordinates);
    }
  };
  Point2.prototype.apply = function apply2() {
    if (hasInterface(arguments[0], CoordinateFilter)) {
      var filter17 = arguments[0];
      if (this.isEmpty()) {
        return null;
      }
      filter17.filter(this.getCoordinate());
    } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
      var filter$1 = arguments[0];
      if (this.isEmpty()) {
        return null;
      }
      filter$1.filter(this._coordinates, 0);
      if (filter$1.isGeometryChanged()) {
        this.geometryChanged();
      }
    } else if (hasInterface(arguments[0], GeometryFilter)) {
      var filter$2 = arguments[0];
      filter$2.filter(this);
    } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
      var filter$3 = arguments[0];
      filter$3.filter(this);
    }
  };
  Point2.prototype.getBoundary = function getBoundary3() {
    return this.getFactory().createGeometryCollection(null);
  };
  Point2.prototype.clone = function clone8() {
    var p2 = Geometry$$1.prototype.clone.call(this);
    p2._coordinates = this._coordinates.clone();
    return p2;
  };
  Point2.prototype.getGeometryType = function getGeometryType() {
    return "Point";
  };
  Point2.prototype.copy = function copy8() {
    return new Point2(this._coordinates.copy(), this._factory);
  };
  Point2.prototype.getCoordinateSequence = function getCoordinateSequence() {
    return this._coordinates;
  };
  Point2.prototype.getY = function getY4() {
    if (this.getCoordinate() === null) {
      throw new Error("getY called on empty Point");
    }
    return this.getCoordinate().y;
  };
  Point2.prototype.isEmpty = function isEmpty6() {
    return this._coordinates.size() === 0;
  };
  Point2.prototype.init = function init9(coordinates2) {
    if (coordinates2 === null) {
      coordinates2 = this.getFactory().getCoordinateSequenceFactory().create([]);
    }
    Assert.isTrue(coordinates2.size() <= 1);
    this._coordinates = coordinates2;
  };
  Point2.prototype.isSimple = function isSimple2() {
    return true;
  };
  Point2.prototype.interfaces_ = function interfaces_170() {
    return [Puntal];
  };
  Point2.prototype.getClass = function getClass169() {
    return Point2;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return 4902022702746615e3;
  };
  Object.defineProperties(Point2, staticAccessors2);
  return Point2;
}(Geometry$1);
var Polygonal = function Polygonal2() {
};
Polygonal.prototype.interfaces_ = function interfaces_38() {
  return [];
};
Polygonal.prototype.getClass = function getClass37() {
  return Polygonal;
};
var Polygon$5 = function(Geometry$$1) {
  function Polygon2(shell, holes, factory) {
    Geometry$$1.call(this, factory);
    this._shell = null;
    this._holes = null;
    if (shell === null) {
      shell = this.getFactory().createLinearRing();
    }
    if (holes === null) {
      holes = [];
    }
    if (Geometry$$1.hasNullElements(holes)) {
      throw new IllegalArgumentException("holes must not contain null elements");
    }
    if (shell.isEmpty() && Geometry$$1.hasNonEmptyElements(holes)) {
      throw new IllegalArgumentException("shell is empty but holes are not");
    }
    this._shell = shell;
    this._holes = holes;
  }
  if (Geometry$$1)
    Polygon2.__proto__ = Geometry$$1;
  Polygon2.prototype = Object.create(Geometry$$1 && Geometry$$1.prototype);
  Polygon2.prototype.constructor = Polygon2;
  var staticAccessors2 = { serialVersionUID: { configurable: true } };
  Polygon2.prototype.computeEnvelopeInternal = function computeEnvelopeInternal() {
    return this._shell.getEnvelopeInternal();
  };
  Polygon2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$$1.SORTINDEX_POLYGON;
  };
  Polygon2.prototype.getCoordinates = function getCoordinates12() {
    var this$1$1 = this;
    if (this.isEmpty()) {
      return [];
    }
    var coordinates2 = new Array(this.getNumPoints()).fill(null);
    var k2 = -1;
    var shellCoordinates = this._shell.getCoordinates();
    for (var x2 = 0; x2 < shellCoordinates.length; x2++) {
      k2++;
      coordinates2[k2] = shellCoordinates[x2];
    }
    for (var i2 = 0; i2 < this._holes.length; i2++) {
      var childCoordinates = this$1$1._holes[i2].getCoordinates();
      for (var j2 = 0; j2 < childCoordinates.length; j2++) {
        k2++;
        coordinates2[k2] = childCoordinates[j2];
      }
    }
    return coordinates2;
  };
  Polygon2.prototype.getArea = function getArea3() {
    var this$1$1 = this;
    var area5 = 0;
    area5 += Math.abs(CGAlgorithms.signedArea(this._shell.getCoordinateSequence()));
    for (var i2 = 0; i2 < this._holes.length; i2++) {
      area5 -= Math.abs(CGAlgorithms.signedArea(this$1$1._holes[i2].getCoordinateSequence()));
    }
    return area5;
  };
  Polygon2.prototype.isRectangle = function isRectangle2() {
    if (this.getNumInteriorRing() !== 0) {
      return false;
    }
    if (this._shell === null) {
      return false;
    }
    if (this._shell.getNumPoints() !== 5) {
      return false;
    }
    var seq = this._shell.getCoordinateSequence();
    var env = this.getEnvelopeInternal();
    for (var i2 = 0; i2 < 5; i2++) {
      var x2 = seq.getX(i2);
      if (!(x2 === env.getMinX() || x2 === env.getMaxX())) {
        return false;
      }
      var y2 = seq.getY(i2);
      if (!(y2 === env.getMinY() || y2 === env.getMaxY())) {
        return false;
      }
    }
    var prevX = seq.getX(0);
    var prevY = seq.getY(0);
    for (var i$12 = 1; i$12 <= 4; i$12++) {
      var x$12 = seq.getX(i$12);
      var y$12 = seq.getY(i$12);
      var xChanged = x$12 !== prevX;
      var yChanged = y$12 !== prevY;
      if (xChanged === yChanged) {
        return false;
      }
      prevX = x$12;
      prevY = y$12;
    }
    return true;
  };
  Polygon2.prototype.equalsExact = function equalsExact2() {
    var this$1$1 = this;
    if (arguments.length === 2) {
      var other = arguments[0];
      var tolerance = arguments[1];
      if (!this.isEquivalentClass(other)) {
        return false;
      }
      var otherPolygon = other;
      var thisShell = this._shell;
      var otherPolygonShell = otherPolygon._shell;
      if (!thisShell.equalsExact(otherPolygonShell, tolerance)) {
        return false;
      }
      if (this._holes.length !== otherPolygon._holes.length) {
        return false;
      }
      for (var i2 = 0; i2 < this._holes.length; i2++) {
        if (!this$1$1._holes[i2].equalsExact(otherPolygon._holes[i2], tolerance)) {
          return false;
        }
      }
      return true;
    } else {
      return Geometry$$1.prototype.equalsExact.apply(this, arguments);
    }
  };
  Polygon2.prototype.normalize = function normalize5() {
    var this$1$1 = this;
    if (arguments.length === 0) {
      this.normalize(this._shell, true);
      for (var i2 = 0; i2 < this._holes.length; i2++) {
        this$1$1.normalize(this$1$1._holes[i2], false);
      }
      Arrays.sort(this._holes);
    } else if (arguments.length === 2) {
      var ring = arguments[0];
      var clockwise = arguments[1];
      if (ring.isEmpty()) {
        return null;
      }
      var uniqueCoordinates = new Array(ring.getCoordinates().length - 1).fill(null);
      System.arraycopy(ring.getCoordinates(), 0, uniqueCoordinates, 0, uniqueCoordinates.length);
      var minCoordinate2 = CoordinateArrays.minCoordinate(ring.getCoordinates());
      CoordinateArrays.scroll(uniqueCoordinates, minCoordinate2);
      System.arraycopy(uniqueCoordinates, 0, ring.getCoordinates(), 0, uniqueCoordinates.length);
      ring.getCoordinates()[uniqueCoordinates.length] = uniqueCoordinates[0];
      if (CGAlgorithms.isCCW(ring.getCoordinates()) === clockwise) {
        CoordinateArrays.reverse(ring.getCoordinates());
      }
    }
  };
  Polygon2.prototype.getCoordinate = function getCoordinate18() {
    return this._shell.getCoordinate();
  };
  Polygon2.prototype.getNumInteriorRing = function getNumInteriorRing() {
    return this._holes.length;
  };
  Polygon2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    return 1;
  };
  Polygon2.prototype.getDimension = function getDimension3() {
    return 2;
  };
  Polygon2.prototype.getLength = function getLength3() {
    var this$1$1 = this;
    var len2 = 0;
    len2 += this._shell.getLength();
    for (var i2 = 0; i2 < this._holes.length; i2++) {
      len2 += this$1$1._holes[i2].getLength();
    }
    return len2;
  };
  Polygon2.prototype.getNumPoints = function getNumPoints() {
    var this$1$1 = this;
    var numPoints = this._shell.getNumPoints();
    for (var i2 = 0; i2 < this._holes.length; i2++) {
      numPoints += this$1$1._holes[i2].getNumPoints();
    }
    return numPoints;
  };
  Polygon2.prototype.reverse = function reverse4() {
    var this$1$1 = this;
    var poly2 = this.copy();
    poly2._shell = this._shell.copy().reverse();
    poly2._holes = new Array(this._holes.length).fill(null);
    for (var i2 = 0; i2 < this._holes.length; i2++) {
      poly2._holes[i2] = this$1$1._holes[i2].copy().reverse();
    }
    return poly2;
  };
  Polygon2.prototype.convexHull = function convexHull() {
    return this.getExteriorRing().convexHull();
  };
  Polygon2.prototype.compareToSameClass = function compareToSameClass() {
    var this$1$1 = this;
    if (arguments.length === 1) {
      var o2 = arguments[0];
      var thisShell = this._shell;
      var otherShell = o2._shell;
      return thisShell.compareToSameClass(otherShell);
    } else if (arguments.length === 2) {
      var o$12 = arguments[0];
      var comp = arguments[1];
      var poly2 = o$12;
      var thisShell$1 = this._shell;
      var otherShell$1 = poly2._shell;
      var shellComp = thisShell$1.compareToSameClass(otherShell$1, comp);
      if (shellComp !== 0) {
        return shellComp;
      }
      var nHole1 = this.getNumInteriorRing();
      var nHole2 = poly2.getNumInteriorRing();
      var i2 = 0;
      while (i2 < nHole1 && i2 < nHole2) {
        var thisHole = this$1$1.getInteriorRingN(i2);
        var otherHole = poly2.getInteriorRingN(i2);
        var holeComp = thisHole.compareToSameClass(otherHole, comp);
        if (holeComp !== 0) {
          return holeComp;
        }
        i2++;
      }
      if (i2 < nHole1) {
        return 1;
      }
      if (i2 < nHole2) {
        return -1;
      }
      return 0;
    }
  };
  Polygon2.prototype.apply = function apply2(filter17) {
    var this$1$1 = this;
    if (hasInterface(filter17, CoordinateFilter)) {
      this._shell.apply(filter17);
      for (var i$12 = 0; i$12 < this._holes.length; i$12++) {
        this$1$1._holes[i$12].apply(filter17);
      }
    } else if (hasInterface(filter17, CoordinateSequenceFilter)) {
      this._shell.apply(filter17);
      if (!filter17.isDone()) {
        for (var i$22 = 0; i$22 < this._holes.length; i$22++) {
          this$1$1._holes[i$22].apply(filter17);
          if (filter17.isDone()) {
            break;
          }
        }
      }
      if (filter17.isGeometryChanged()) {
        this.geometryChanged();
      }
    } else if (hasInterface(filter17, GeometryFilter)) {
      filter17.filter(this);
    } else if (hasInterface(filter17, GeometryComponentFilter)) {
      filter17.filter(this);
      this._shell.apply(filter17);
      for (var i2 = 0; i2 < this._holes.length; i2++) {
        this$1$1._holes[i2].apply(filter17);
      }
    }
  };
  Polygon2.prototype.getBoundary = function getBoundary3() {
    var this$1$1 = this;
    if (this.isEmpty()) {
      return this.getFactory().createMultiLineString();
    }
    var rings = new Array(this._holes.length + 1).fill(null);
    rings[0] = this._shell;
    for (var i2 = 0; i2 < this._holes.length; i2++) {
      rings[i2 + 1] = this$1$1._holes[i2];
    }
    if (rings.length <= 1) {
      return this.getFactory().createLinearRing(rings[0].getCoordinateSequence());
    }
    return this.getFactory().createMultiLineString(rings);
  };
  Polygon2.prototype.clone = function clone8() {
    var this$1$1 = this;
    var poly2 = Geometry$$1.prototype.clone.call(this);
    poly2._shell = this._shell.clone();
    poly2._holes = new Array(this._holes.length).fill(null);
    for (var i2 = 0; i2 < this._holes.length; i2++) {
      poly2._holes[i2] = this$1$1._holes[i2].clone();
    }
    return poly2;
  };
  Polygon2.prototype.getGeometryType = function getGeometryType() {
    return "Polygon";
  };
  Polygon2.prototype.copy = function copy8() {
    var this$1$1 = this;
    var shell = this._shell.copy();
    var holes = new Array(this._holes.length).fill(null);
    for (var i2 = 0; i2 < holes.length; i2++) {
      holes[i2] = this$1$1._holes[i2].copy();
    }
    return new Polygon2(shell, holes, this._factory);
  };
  Polygon2.prototype.getExteriorRing = function getExteriorRing() {
    return this._shell;
  };
  Polygon2.prototype.isEmpty = function isEmpty6() {
    return this._shell.isEmpty();
  };
  Polygon2.prototype.getInteriorRingN = function getInteriorRingN(n2) {
    return this._holes[n2];
  };
  Polygon2.prototype.interfaces_ = function interfaces_170() {
    return [Polygonal];
  };
  Polygon2.prototype.getClass = function getClass169() {
    return Polygon2;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return -3494792200821764600;
  };
  Object.defineProperties(Polygon2, staticAccessors2);
  return Polygon2;
}(Geometry$1);
var MultiPoint$1 = function(GeometryCollection$$1) {
  function MultiPoint2() {
    GeometryCollection$$1.apply(this, arguments);
  }
  if (GeometryCollection$$1)
    MultiPoint2.__proto__ = GeometryCollection$$1;
  MultiPoint2.prototype = Object.create(GeometryCollection$$1 && GeometryCollection$$1.prototype);
  MultiPoint2.prototype.constructor = MultiPoint2;
  var staticAccessors2 = { serialVersionUID: { configurable: true } };
  MultiPoint2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$1.SORTINDEX_MULTIPOINT;
  };
  MultiPoint2.prototype.isValid = function isValid8() {
    return true;
  };
  MultiPoint2.prototype.equalsExact = function equalsExact2() {
    if (arguments.length === 2) {
      var other = arguments[0];
      var tolerance = arguments[1];
      if (!this.isEquivalentClass(other)) {
        return false;
      }
      return GeometryCollection$$1.prototype.equalsExact.call(this, other, tolerance);
    } else {
      return GeometryCollection$$1.prototype.equalsExact.apply(this, arguments);
    }
  };
  MultiPoint2.prototype.getCoordinate = function getCoordinate18() {
    if (arguments.length === 1) {
      var n2 = arguments[0];
      return this._geometries[n2].getCoordinate();
    } else {
      return GeometryCollection$$1.prototype.getCoordinate.apply(this, arguments);
    }
  };
  MultiPoint2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    return Dimension.FALSE;
  };
  MultiPoint2.prototype.getDimension = function getDimension3() {
    return 0;
  };
  MultiPoint2.prototype.getBoundary = function getBoundary3() {
    return this.getFactory().createGeometryCollection(null);
  };
  MultiPoint2.prototype.getGeometryType = function getGeometryType() {
    return "MultiPoint";
  };
  MultiPoint2.prototype.copy = function copy8() {
    var this$1$1 = this;
    var points2 = new Array(this._geometries.length).fill(null);
    for (var i2 = 0; i2 < points2.length; i2++) {
      points2[i2] = this$1$1._geometries[i2].copy();
    }
    return new MultiPoint2(points2, this._factory);
  };
  MultiPoint2.prototype.interfaces_ = function interfaces_170() {
    return [Puntal];
  };
  MultiPoint2.prototype.getClass = function getClass169() {
    return MultiPoint2;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return -8048474874175356e3;
  };
  Object.defineProperties(MultiPoint2, staticAccessors2);
  return MultiPoint2;
}(GeometryCollection);
var LinearRing = function(LineString$$1) {
  function LinearRing2(points2, factory) {
    if (points2 instanceof Coordinate && factory instanceof GeometryFactory) {
      points2 = factory.getCoordinateSequenceFactory().create(points2);
    }
    LineString$$1.call(this, points2, factory);
    this.validateConstruction();
  }
  if (LineString$$1)
    LinearRing2.__proto__ = LineString$$1;
  LinearRing2.prototype = Object.create(LineString$$1 && LineString$$1.prototype);
  LinearRing2.prototype.constructor = LinearRing2;
  var staticAccessors2 = { MINIMUM_VALID_SIZE: { configurable: true }, serialVersionUID: { configurable: true } };
  LinearRing2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$1.SORTINDEX_LINEARRING;
  };
  LinearRing2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    return Dimension.FALSE;
  };
  LinearRing2.prototype.isClosed = function isClosed5() {
    if (this.isEmpty()) {
      return true;
    }
    return LineString$$1.prototype.isClosed.call(this);
  };
  LinearRing2.prototype.reverse = function reverse4() {
    var seq = this._points.copy();
    CoordinateSequences.reverse(seq);
    var rev = this.getFactory().createLinearRing(seq);
    return rev;
  };
  LinearRing2.prototype.validateConstruction = function validateConstruction() {
    if (!this.isEmpty() && !LineString$$1.prototype.isClosed.call(this)) {
      throw new IllegalArgumentException("Points of LinearRing do not form a closed linestring");
    }
    if (this.getCoordinateSequence().size() >= 1 && this.getCoordinateSequence().size() < LinearRing2.MINIMUM_VALID_SIZE) {
      throw new IllegalArgumentException("Invalid number of points in LinearRing (found " + this.getCoordinateSequence().size() + " - must be 0 or >= 4)");
    }
  };
  LinearRing2.prototype.getGeometryType = function getGeometryType() {
    return "LinearRing";
  };
  LinearRing2.prototype.copy = function copy8() {
    return new LinearRing2(this._points.copy(), this._factory);
  };
  LinearRing2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  LinearRing2.prototype.getClass = function getClass169() {
    return LinearRing2;
  };
  staticAccessors2.MINIMUM_VALID_SIZE.get = function() {
    return 4;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return -4261142084085851600;
  };
  Object.defineProperties(LinearRing2, staticAccessors2);
  return LinearRing2;
}(LineString$4);
var MultiPolygon$1 = function(GeometryCollection$$1) {
  function MultiPolygon2() {
    GeometryCollection$$1.apply(this, arguments);
  }
  if (GeometryCollection$$1)
    MultiPolygon2.__proto__ = GeometryCollection$$1;
  MultiPolygon2.prototype = Object.create(GeometryCollection$$1 && GeometryCollection$$1.prototype);
  MultiPolygon2.prototype.constructor = MultiPolygon2;
  var staticAccessors2 = { serialVersionUID: { configurable: true } };
  MultiPolygon2.prototype.getSortIndex = function getSortIndex() {
    return Geometry$1.SORTINDEX_MULTIPOLYGON;
  };
  MultiPolygon2.prototype.equalsExact = function equalsExact2() {
    if (arguments.length === 2) {
      var other = arguments[0];
      var tolerance = arguments[1];
      if (!this.isEquivalentClass(other)) {
        return false;
      }
      return GeometryCollection$$1.prototype.equalsExact.call(this, other, tolerance);
    } else {
      return GeometryCollection$$1.prototype.equalsExact.apply(this, arguments);
    }
  };
  MultiPolygon2.prototype.getBoundaryDimension = function getBoundaryDimension() {
    return 1;
  };
  MultiPolygon2.prototype.getDimension = function getDimension3() {
    return 2;
  };
  MultiPolygon2.prototype.reverse = function reverse4() {
    var this$1$1 = this;
    var n2 = this._geometries.length;
    var revGeoms = new Array(n2).fill(null);
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      revGeoms[i2] = this$1$1._geometries[i2].reverse();
    }
    return this.getFactory().createMultiPolygon(revGeoms);
  };
  MultiPolygon2.prototype.getBoundary = function getBoundary3() {
    var this$1$1 = this;
    if (this.isEmpty()) {
      return this.getFactory().createMultiLineString();
    }
    var allRings = new ArrayList();
    for (var i2 = 0; i2 < this._geometries.length; i2++) {
      var polygon4 = this$1$1._geometries[i2];
      var rings = polygon4.getBoundary();
      for (var j2 = 0; j2 < rings.getNumGeometries(); j2++) {
        allRings.add(rings.getGeometryN(j2));
      }
    }
    var allRingsArray = new Array(allRings.size()).fill(null);
    return this.getFactory().createMultiLineString(allRings.toArray(allRingsArray));
  };
  MultiPolygon2.prototype.getGeometryType = function getGeometryType() {
    return "MultiPolygon";
  };
  MultiPolygon2.prototype.copy = function copy8() {
    var this$1$1 = this;
    var polygons2 = new Array(this._geometries.length).fill(null);
    for (var i2 = 0; i2 < polygons2.length; i2++) {
      polygons2[i2] = this$1$1._geometries[i2].copy();
    }
    return new MultiPolygon2(polygons2, this._factory);
  };
  MultiPolygon2.prototype.interfaces_ = function interfaces_170() {
    return [Polygonal];
  };
  MultiPolygon2.prototype.getClass = function getClass169() {
    return MultiPolygon2;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return -551033529766975900;
  };
  Object.defineProperties(MultiPolygon2, staticAccessors2);
  return MultiPolygon2;
}(GeometryCollection);
var GeometryEditor = function GeometryEditor2(factory) {
  this._factory = factory || null;
  this._isUserDataCopied = false;
};
var staticAccessors$16 = { NoOpGeometryOperation: { configurable: true }, CoordinateOperation: { configurable: true }, CoordinateSequenceOperation: { configurable: true } };
GeometryEditor.prototype.setCopyUserData = function setCopyUserData(isUserDataCopied) {
  this._isUserDataCopied = isUserDataCopied;
};
GeometryEditor.prototype.edit = function edit(geometry2, operation) {
  if (geometry2 === null) {
    return null;
  }
  var result = this.editInternal(geometry2, operation);
  if (this._isUserDataCopied) {
    result.setUserData(geometry2.getUserData());
  }
  return result;
};
GeometryEditor.prototype.editInternal = function editInternal(geometry2, operation) {
  if (this._factory === null) {
    this._factory = geometry2.getFactory();
  }
  if (geometry2 instanceof GeometryCollection) {
    return this.editGeometryCollection(geometry2, operation);
  }
  if (geometry2 instanceof Polygon$5) {
    return this.editPolygon(geometry2, operation);
  }
  if (geometry2 instanceof Point$7) {
    return operation.edit(geometry2, this._factory);
  }
  if (geometry2 instanceof LineString$4) {
    return operation.edit(geometry2, this._factory);
  }
  Assert.shouldNeverReachHere("Unsupported Geometry class: " + geometry2.getClass().getName());
  return null;
};
GeometryEditor.prototype.editGeometryCollection = function editGeometryCollection(collection, operation) {
  var this$1$1 = this;
  var collectionForType = operation.edit(collection, this._factory);
  var geometries = new ArrayList();
  for (var i2 = 0; i2 < collectionForType.getNumGeometries(); i2++) {
    var geometry2 = this$1$1.edit(collectionForType.getGeometryN(i2), operation);
    if (geometry2 === null || geometry2.isEmpty()) {
      continue;
    }
    geometries.add(geometry2);
  }
  if (collectionForType.getClass() === MultiPoint$1) {
    return this._factory.createMultiPoint(geometries.toArray([]));
  }
  if (collectionForType.getClass() === MultiLineString$1) {
    return this._factory.createMultiLineString(geometries.toArray([]));
  }
  if (collectionForType.getClass() === MultiPolygon$1) {
    return this._factory.createMultiPolygon(geometries.toArray([]));
  }
  return this._factory.createGeometryCollection(geometries.toArray([]));
};
GeometryEditor.prototype.editPolygon = function editPolygon(polygon4, operation) {
  var this$1$1 = this;
  var newPolygon = operation.edit(polygon4, this._factory);
  if (newPolygon === null) {
    newPolygon = this._factory.createPolygon(null);
  }
  if (newPolygon.isEmpty()) {
    return newPolygon;
  }
  var shell = this.edit(newPolygon.getExteriorRing(), operation);
  if (shell === null || shell.isEmpty()) {
    return this._factory.createPolygon();
  }
  var holes = new ArrayList();
  for (var i2 = 0; i2 < newPolygon.getNumInteriorRing(); i2++) {
    var hole = this$1$1.edit(newPolygon.getInteriorRingN(i2), operation);
    if (hole === null || hole.isEmpty()) {
      continue;
    }
    holes.add(hole);
  }
  return this._factory.createPolygon(shell, holes.toArray([]));
};
GeometryEditor.prototype.interfaces_ = function interfaces_39() {
  return [];
};
GeometryEditor.prototype.getClass = function getClass38() {
  return GeometryEditor;
};
GeometryEditor.GeometryEditorOperation = function GeometryEditorOperation() {
};
staticAccessors$16.NoOpGeometryOperation.get = function() {
  return NoOpGeometryOperation;
};
staticAccessors$16.CoordinateOperation.get = function() {
  return CoordinateOperation;
};
staticAccessors$16.CoordinateSequenceOperation.get = function() {
  return CoordinateSequenceOperation;
};
Object.defineProperties(GeometryEditor, staticAccessors$16);
var NoOpGeometryOperation = function NoOpGeometryOperation2() {
};
NoOpGeometryOperation.prototype.edit = function edit2(geometry2, factory) {
  return geometry2;
};
NoOpGeometryOperation.prototype.interfaces_ = function interfaces_40() {
  return [GeometryEditor.GeometryEditorOperation];
};
NoOpGeometryOperation.prototype.getClass = function getClass39() {
  return NoOpGeometryOperation;
};
var CoordinateOperation = function CoordinateOperation2() {
};
CoordinateOperation.prototype.edit = function edit3(geometry2, factory) {
  var coords = this.editCoordinates(geometry2.getCoordinates(), geometry2);
  if (coords === null) {
    return geometry2;
  }
  if (geometry2 instanceof LinearRing) {
    return factory.createLinearRing(coords);
  }
  if (geometry2 instanceof LineString$4) {
    return factory.createLineString(coords);
  }
  if (geometry2 instanceof Point$7) {
    if (coords.length > 0) {
      return factory.createPoint(coords[0]);
    } else {
      return factory.createPoint();
    }
  }
  return geometry2;
};
CoordinateOperation.prototype.interfaces_ = function interfaces_41() {
  return [GeometryEditor.GeometryEditorOperation];
};
CoordinateOperation.prototype.getClass = function getClass40() {
  return CoordinateOperation;
};
var CoordinateSequenceOperation = function CoordinateSequenceOperation2() {
};
CoordinateSequenceOperation.prototype.edit = function edit4(geometry2, factory) {
  if (geometry2 instanceof LinearRing) {
    return factory.createLinearRing(this.edit(geometry2.getCoordinateSequence(), geometry2));
  }
  if (geometry2 instanceof LineString$4) {
    return factory.createLineString(this.edit(geometry2.getCoordinateSequence(), geometry2));
  }
  if (geometry2 instanceof Point$7) {
    return factory.createPoint(this.edit(geometry2.getCoordinateSequence(), geometry2));
  }
  return geometry2;
};
CoordinateSequenceOperation.prototype.interfaces_ = function interfaces_42() {
  return [GeometryEditor.GeometryEditorOperation];
};
CoordinateSequenceOperation.prototype.getClass = function getClass41() {
  return CoordinateSequenceOperation;
};
var CoordinateArraySequence = function CoordinateArraySequence2() {
  var this$1$1 = this;
  this._dimension = 3;
  this._coordinates = null;
  if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      this._coordinates = arguments[0];
      this._dimension = 3;
    } else if (Number.isInteger(arguments[0])) {
      var size12 = arguments[0];
      this._coordinates = new Array(size12).fill(null);
      for (var i2 = 0; i2 < size12; i2++) {
        this$1$1._coordinates[i2] = new Coordinate();
      }
    } else if (hasInterface(arguments[0], CoordinateSequence)) {
      var coordSeq = arguments[0];
      if (coordSeq === null) {
        this._coordinates = new Array(0).fill(null);
        return null;
      }
      this._dimension = coordSeq.getDimension();
      this._coordinates = new Array(coordSeq.size()).fill(null);
      for (var i$12 = 0; i$12 < this._coordinates.length; i$12++) {
        this$1$1._coordinates[i$12] = coordSeq.getCoordinateCopy(i$12);
      }
    }
  } else if (arguments.length === 2) {
    if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
      var coordinates2 = arguments[0];
      var dimension = arguments[1];
      this._coordinates = coordinates2;
      this._dimension = dimension;
      if (coordinates2 === null) {
        this._coordinates = new Array(0).fill(null);
      }
    } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
      var size$12 = arguments[0];
      var dimension$1 = arguments[1];
      this._coordinates = new Array(size$12).fill(null);
      this._dimension = dimension$1;
      for (var i$22 = 0; i$22 < size$12; i$22++) {
        this$1$1._coordinates[i$22] = new Coordinate();
      }
    }
  }
};
var staticAccessors$18 = { serialVersionUID: { configurable: true } };
CoordinateArraySequence.prototype.setOrdinate = function setOrdinate3(index2, ordinateIndex, value) {
  switch (ordinateIndex) {
    case CoordinateSequence.X:
      this._coordinates[index2].x = value;
      break;
    case CoordinateSequence.Y:
      this._coordinates[index2].y = value;
      break;
    case CoordinateSequence.Z:
      this._coordinates[index2].z = value;
      break;
    default:
      throw new IllegalArgumentException("invalid ordinateIndex");
  }
};
CoordinateArraySequence.prototype.size = function size5() {
  return this._coordinates.length;
};
CoordinateArraySequence.prototype.getOrdinate = function getOrdinate3(index2, ordinateIndex) {
  switch (ordinateIndex) {
    case CoordinateSequence.X:
      return this._coordinates[index2].x;
    case CoordinateSequence.Y:
      return this._coordinates[index2].y;
    case CoordinateSequence.Z:
      return this._coordinates[index2].z;
  }
  return Double.NaN;
};
CoordinateArraySequence.prototype.getCoordinate = function getCoordinate3() {
  if (arguments.length === 1) {
    var i2 = arguments[0];
    return this._coordinates[i2];
  } else if (arguments.length === 2) {
    var index2 = arguments[0];
    var coord = arguments[1];
    coord.x = this._coordinates[index2].x;
    coord.y = this._coordinates[index2].y;
    coord.z = this._coordinates[index2].z;
  }
};
CoordinateArraySequence.prototype.getCoordinateCopy = function getCoordinateCopy2(i2) {
  return new Coordinate(this._coordinates[i2]);
};
CoordinateArraySequence.prototype.getDimension = function getDimension2() {
  return this._dimension;
};
CoordinateArraySequence.prototype.getX = function getX3(index2) {
  return this._coordinates[index2].x;
};
CoordinateArraySequence.prototype.clone = function clone5() {
  var this$1$1 = this;
  var cloneCoordinates = new Array(this.size()).fill(null);
  for (var i2 = 0; i2 < this._coordinates.length; i2++) {
    cloneCoordinates[i2] = this$1$1._coordinates[i2].clone();
  }
  return new CoordinateArraySequence(cloneCoordinates, this._dimension);
};
CoordinateArraySequence.prototype.expandEnvelope = function expandEnvelope2(env) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this._coordinates.length; i2++) {
    env.expandToInclude(this$1$1._coordinates[i2]);
  }
  return env;
};
CoordinateArraySequence.prototype.copy = function copy6() {
  var this$1$1 = this;
  var cloneCoordinates = new Array(this.size()).fill(null);
  for (var i2 = 0; i2 < this._coordinates.length; i2++) {
    cloneCoordinates[i2] = this$1$1._coordinates[i2].copy();
  }
  return new CoordinateArraySequence(cloneCoordinates, this._dimension);
};
CoordinateArraySequence.prototype.toString = function toString9() {
  var this$1$1 = this;
  if (this._coordinates.length > 0) {
    var strBuf = new StringBuffer(17 * this._coordinates.length);
    strBuf.append("(");
    strBuf.append(this._coordinates[0]);
    for (var i2 = 1; i2 < this._coordinates.length; i2++) {
      strBuf.append(", ");
      strBuf.append(this$1$1._coordinates[i2]);
    }
    strBuf.append(")");
    return strBuf.toString();
  } else {
    return "()";
  }
};
CoordinateArraySequence.prototype.getY = function getY3(index2) {
  return this._coordinates[index2].y;
};
CoordinateArraySequence.prototype.toCoordinateArray = function toCoordinateArray3() {
  return this._coordinates;
};
CoordinateArraySequence.prototype.interfaces_ = function interfaces_43() {
  return [CoordinateSequence, Serializable];
};
CoordinateArraySequence.prototype.getClass = function getClass42() {
  return CoordinateArraySequence;
};
staticAccessors$18.serialVersionUID.get = function() {
  return -915438501601840600;
};
Object.defineProperties(CoordinateArraySequence, staticAccessors$18);
var CoordinateArraySequenceFactory = function CoordinateArraySequenceFactory2() {
};
var staticAccessors$17 = { serialVersionUID: { configurable: true }, instanceObject: { configurable: true } };
CoordinateArraySequenceFactory.prototype.readResolve = function readResolve() {
  return CoordinateArraySequenceFactory.instance();
};
CoordinateArraySequenceFactory.prototype.create = function create3() {
  if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var coordinates2 = arguments[0];
      return new CoordinateArraySequence(coordinates2);
    } else if (hasInterface(arguments[0], CoordinateSequence)) {
      var coordSeq = arguments[0];
      return new CoordinateArraySequence(coordSeq);
    }
  } else if (arguments.length === 2) {
    var size12 = arguments[0];
    var dimension = arguments[1];
    if (dimension > 3) {
      dimension = 3;
    }
    if (dimension < 2) {
      return new CoordinateArraySequence(size12);
    }
    return new CoordinateArraySequence(size12, dimension);
  }
};
CoordinateArraySequenceFactory.prototype.interfaces_ = function interfaces_44() {
  return [CoordinateSequenceFactory, Serializable];
};
CoordinateArraySequenceFactory.prototype.getClass = function getClass43() {
  return CoordinateArraySequenceFactory;
};
CoordinateArraySequenceFactory.instance = function instance() {
  return CoordinateArraySequenceFactory.instanceObject;
};
staticAccessors$17.serialVersionUID.get = function() {
  return -4099577099607551500;
};
staticAccessors$17.instanceObject.get = function() {
  return new CoordinateArraySequenceFactory();
};
Object.defineProperties(CoordinateArraySequenceFactory, staticAccessors$17);
var HashMap = function(MapInterface) {
  function HashMap2() {
    MapInterface.call(this);
    this.map_ = /* @__PURE__ */ new Map();
  }
  if (MapInterface)
    HashMap2.__proto__ = MapInterface;
  HashMap2.prototype = Object.create(MapInterface && MapInterface.prototype);
  HashMap2.prototype.constructor = HashMap2;
  HashMap2.prototype.get = function get6(key) {
    return this.map_.get(key) || null;
  };
  HashMap2.prototype.put = function put2(key, value) {
    this.map_.set(key, value);
    return value;
  };
  HashMap2.prototype.values = function values4() {
    var arrayList = new ArrayList();
    var it = this.map_.values();
    var o2 = it.next();
    while (!o2.done) {
      arrayList.add(o2.value);
      o2 = it.next();
    }
    return arrayList;
  };
  HashMap2.prototype.entrySet = function entrySet2() {
    var hashSet2 = new HashSet();
    this.map_.entries().forEach(function(entry) {
      return hashSet2.add(entry);
    });
    return hashSet2;
  };
  HashMap2.prototype.size = function size12() {
    return this.map_.size();
  };
  return HashMap2;
}(Map$1$1);
var PrecisionModel = function PrecisionModel2() {
  this._modelType = null;
  this._scale = null;
  if (arguments.length === 0) {
    this._modelType = PrecisionModel2.FLOATING;
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Type$1) {
      var modelType = arguments[0];
      this._modelType = modelType;
      if (modelType === PrecisionModel2.FIXED) {
        this.setScale(1);
      }
    } else if (typeof arguments[0] === "number") {
      var scale5 = arguments[0];
      this._modelType = PrecisionModel2.FIXED;
      this.setScale(scale5);
    } else if (arguments[0] instanceof PrecisionModel2) {
      var pm = arguments[0];
      this._modelType = pm._modelType;
      this._scale = pm._scale;
    }
  }
};
var staticAccessors$19 = { serialVersionUID: { configurable: true }, maximumPreciseValue: { configurable: true } };
PrecisionModel.prototype.equals = function equals8(other) {
  if (!(other instanceof PrecisionModel)) {
    return false;
  }
  var otherPrecisionModel = other;
  return this._modelType === otherPrecisionModel._modelType && this._scale === otherPrecisionModel._scale;
};
PrecisionModel.prototype.compareTo = function compareTo6(o2) {
  var other = o2;
  var sigDigits = this.getMaximumSignificantDigits();
  var otherSigDigits = other.getMaximumSignificantDigits();
  return new Integer(sigDigits).compareTo(new Integer(otherSigDigits));
};
PrecisionModel.prototype.getScale = function getScale2() {
  return this._scale;
};
PrecisionModel.prototype.isFloating = function isFloating() {
  return this._modelType === PrecisionModel.FLOATING || this._modelType === PrecisionModel.FLOATING_SINGLE;
};
PrecisionModel.prototype.getType = function getType2() {
  return this._modelType;
};
PrecisionModel.prototype.toString = function toString10() {
  var description2 = "UNKNOWN";
  if (this._modelType === PrecisionModel.FLOATING) {
    description2 = "Floating";
  } else if (this._modelType === PrecisionModel.FLOATING_SINGLE) {
    description2 = "Floating-Single";
  } else if (this._modelType === PrecisionModel.FIXED) {
    description2 = "Fixed (Scale=" + this.getScale() + ")";
  }
  return description2;
};
PrecisionModel.prototype.makePrecise = function makePrecise() {
  if (typeof arguments[0] === "number") {
    var val = arguments[0];
    if (Double.isNaN(val)) {
      return val;
    }
    if (this._modelType === PrecisionModel.FLOATING_SINGLE) {
      var floatSingleVal = val;
      return floatSingleVal;
    }
    if (this._modelType === PrecisionModel.FIXED) {
      return Math.round(val * this._scale) / this._scale;
    }
    return val;
  } else if (arguments[0] instanceof Coordinate) {
    var coord = arguments[0];
    if (this._modelType === PrecisionModel.FLOATING) {
      return null;
    }
    coord.x = this.makePrecise(coord.x);
    coord.y = this.makePrecise(coord.y);
  }
};
PrecisionModel.prototype.getMaximumSignificantDigits = function getMaximumSignificantDigits() {
  var maxSigDigits = 16;
  if (this._modelType === PrecisionModel.FLOATING) {
    maxSigDigits = 16;
  } else if (this._modelType === PrecisionModel.FLOATING_SINGLE) {
    maxSigDigits = 6;
  } else if (this._modelType === PrecisionModel.FIXED) {
    maxSigDigits = 1 + Math.trunc(Math.ceil(Math.log(this.getScale()) / Math.log(10)));
  }
  return maxSigDigits;
};
PrecisionModel.prototype.setScale = function setScale(scale5) {
  this._scale = Math.abs(scale5);
};
PrecisionModel.prototype.interfaces_ = function interfaces_45() {
  return [Serializable, Comparable];
};
PrecisionModel.prototype.getClass = function getClass44() {
  return PrecisionModel;
};
PrecisionModel.mostPrecise = function mostPrecise(pm1, pm2) {
  if (pm1.compareTo(pm2) >= 0) {
    return pm1;
  }
  return pm2;
};
staticAccessors$19.serialVersionUID.get = function() {
  return 7777263578777804e3;
};
staticAccessors$19.maximumPreciseValue.get = function() {
  return 9007199254740992;
};
Object.defineProperties(PrecisionModel, staticAccessors$19);
var Type$1 = function Type2(name2) {
  this._name = name2 || null;
  Type2.nameToTypeMap.put(name2, this);
};
var staticAccessors$1$1 = { serialVersionUID: { configurable: true }, nameToTypeMap: { configurable: true } };
Type$1.prototype.readResolve = function readResolve2() {
  return Type$1.nameToTypeMap.get(this._name);
};
Type$1.prototype.toString = function toString11() {
  return this._name;
};
Type$1.prototype.interfaces_ = function interfaces_46() {
  return [Serializable];
};
Type$1.prototype.getClass = function getClass45() {
  return Type$1;
};
staticAccessors$1$1.serialVersionUID.get = function() {
  return -552860263173159e4;
};
staticAccessors$1$1.nameToTypeMap.get = function() {
  return new HashMap();
};
Object.defineProperties(Type$1, staticAccessors$1$1);
PrecisionModel.Type = Type$1;
PrecisionModel.FIXED = new Type$1("FIXED");
PrecisionModel.FLOATING = new Type$1("FLOATING");
PrecisionModel.FLOATING_SINGLE = new Type$1("FLOATING SINGLE");
var GeometryFactory = function GeometryFactory2() {
  this._precisionModel = new PrecisionModel();
  this._SRID = 0;
  this._coordinateSequenceFactory = GeometryFactory2.getDefaultCoordinateSequenceFactory();
  if (arguments.length === 0)
    ;
  else if (arguments.length === 1) {
    if (hasInterface(arguments[0], CoordinateSequenceFactory)) {
      this._coordinateSequenceFactory = arguments[0];
    } else if (arguments[0] instanceof PrecisionModel) {
      this._precisionModel = arguments[0];
    }
  } else if (arguments.length === 2) {
    this._precisionModel = arguments[0];
    this._SRID = arguments[1];
  } else if (arguments.length === 3) {
    this._precisionModel = arguments[0];
    this._SRID = arguments[1];
    this._coordinateSequenceFactory = arguments[2];
  }
};
var staticAccessors$2 = { serialVersionUID: { configurable: true } };
GeometryFactory.prototype.toGeometry = function toGeometry(envelope2) {
  if (envelope2.isNull()) {
    return this.createPoint(null);
  }
  if (envelope2.getMinX() === envelope2.getMaxX() && envelope2.getMinY() === envelope2.getMaxY()) {
    return this.createPoint(new Coordinate(envelope2.getMinX(), envelope2.getMinY()));
  }
  if (envelope2.getMinX() === envelope2.getMaxX() || envelope2.getMinY() === envelope2.getMaxY()) {
    return this.createLineString([new Coordinate(envelope2.getMinX(), envelope2.getMinY()), new Coordinate(envelope2.getMaxX(), envelope2.getMaxY())]);
  }
  return this.createPolygon(this.createLinearRing([new Coordinate(envelope2.getMinX(), envelope2.getMinY()), new Coordinate(envelope2.getMinX(), envelope2.getMaxY()), new Coordinate(envelope2.getMaxX(), envelope2.getMaxY()), new Coordinate(envelope2.getMaxX(), envelope2.getMinY()), new Coordinate(envelope2.getMinX(), envelope2.getMinY())]), null);
};
GeometryFactory.prototype.createLineString = function createLineString(coordinates2) {
  if (!coordinates2) {
    return new LineString$4(this.getCoordinateSequenceFactory().create([]), this);
  } else if (coordinates2 instanceof Array) {
    return new LineString$4(this.getCoordinateSequenceFactory().create(coordinates2), this);
  } else if (hasInterface(coordinates2, CoordinateSequence)) {
    return new LineString$4(coordinates2, this);
  }
};
GeometryFactory.prototype.createMultiLineString = function createMultiLineString() {
  if (arguments.length === 0) {
    return new MultiLineString$1(null, this);
  } else if (arguments.length === 1) {
    var lineStrings2 = arguments[0];
    return new MultiLineString$1(lineStrings2, this);
  }
};
GeometryFactory.prototype.buildGeometry = function buildGeometry(geomList) {
  var geomClass = null;
  var isHeterogeneous = false;
  var hasGeometryCollection = false;
  for (var i2 = geomList.iterator(); i2.hasNext(); ) {
    var geom = i2.next();
    var partClass = geom.getClass();
    if (geomClass === null) {
      geomClass = partClass;
    }
    if (partClass !== geomClass) {
      isHeterogeneous = true;
    }
    if (geom.isGeometryCollectionOrDerived()) {
      hasGeometryCollection = true;
    }
  }
  if (geomClass === null) {
    return this.createGeometryCollection();
  }
  if (isHeterogeneous || hasGeometryCollection) {
    return this.createGeometryCollection(GeometryFactory.toGeometryArray(geomList));
  }
  var geom0 = geomList.iterator().next();
  var isCollection = geomList.size() > 1;
  if (isCollection) {
    if (geom0 instanceof Polygon$5) {
      return this.createMultiPolygon(GeometryFactory.toPolygonArray(geomList));
    } else if (geom0 instanceof LineString$4) {
      return this.createMultiLineString(GeometryFactory.toLineStringArray(geomList));
    } else if (geom0 instanceof Point$7) {
      return this.createMultiPoint(GeometryFactory.toPointArray(geomList));
    }
    Assert.shouldNeverReachHere("Unhandled class: " + geom0.getClass().getName());
  }
  return geom0;
};
GeometryFactory.prototype.createMultiPointFromCoords = function createMultiPointFromCoords(coordinates2) {
  return this.createMultiPoint(coordinates2 !== null ? this.getCoordinateSequenceFactory().create(coordinates2) : null);
};
GeometryFactory.prototype.createPoint = function createPoint() {
  if (arguments.length === 0) {
    return this.createPoint(this.getCoordinateSequenceFactory().create([]));
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Coordinate) {
      var coordinate2 = arguments[0];
      return this.createPoint(coordinate2 !== null ? this.getCoordinateSequenceFactory().create([coordinate2]) : null);
    } else if (hasInterface(arguments[0], CoordinateSequence)) {
      var coordinates2 = arguments[0];
      return new Point$7(coordinates2, this);
    }
  }
};
GeometryFactory.prototype.getCoordinateSequenceFactory = function getCoordinateSequenceFactory() {
  return this._coordinateSequenceFactory;
};
GeometryFactory.prototype.createPolygon = function createPolygon() {
  if (arguments.length === 0) {
    return new Polygon$5(null, null, this);
  } else if (arguments.length === 1) {
    if (hasInterface(arguments[0], CoordinateSequence)) {
      var coordinates2 = arguments[0];
      return this.createPolygon(this.createLinearRing(coordinates2));
    } else if (arguments[0] instanceof Array) {
      var coordinates$1 = arguments[0];
      return this.createPolygon(this.createLinearRing(coordinates$1));
    } else if (arguments[0] instanceof LinearRing) {
      var shell = arguments[0];
      return this.createPolygon(shell, null);
    }
  } else if (arguments.length === 2) {
    var shell$1 = arguments[0];
    var holes = arguments[1];
    return new Polygon$5(shell$1, holes, this);
  }
};
GeometryFactory.prototype.getSRID = function getSRID2() {
  return this._SRID;
};
GeometryFactory.prototype.createGeometryCollection = function createGeometryCollection() {
  if (arguments.length === 0) {
    return new GeometryCollection(null, this);
  } else if (arguments.length === 1) {
    var geometries = arguments[0];
    return new GeometryCollection(geometries, this);
  }
};
GeometryFactory.prototype.createGeometry = function createGeometry(g2) {
  var editor = new GeometryEditor(this);
  return editor.edit(g2, {
    edit: function() {
      if (arguments.length === 2) {
        var coordSeq = arguments[0];
        return this._coordinateSequenceFactory.create(coordSeq);
      }
    }
  });
};
GeometryFactory.prototype.getPrecisionModel = function getPrecisionModel2() {
  return this._precisionModel;
};
GeometryFactory.prototype.createLinearRing = function createLinearRing() {
  if (arguments.length === 0) {
    return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var coordinates2 = arguments[0];
      return this.createLinearRing(coordinates2 !== null ? this.getCoordinateSequenceFactory().create(coordinates2) : null);
    } else if (hasInterface(arguments[0], CoordinateSequence)) {
      var coordinates$1 = arguments[0];
      return new LinearRing(coordinates$1, this);
    }
  }
};
GeometryFactory.prototype.createMultiPolygon = function createMultiPolygon() {
  if (arguments.length === 0) {
    return new MultiPolygon$1(null, this);
  } else if (arguments.length === 1) {
    var polygons2 = arguments[0];
    return new MultiPolygon$1(polygons2, this);
  }
};
GeometryFactory.prototype.createMultiPoint = function createMultiPoint() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    return new MultiPoint$1(null, this);
  } else if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var point4 = arguments[0];
      return new MultiPoint$1(point4, this);
    } else if (arguments[0] instanceof Array) {
      var coordinates2 = arguments[0];
      return this.createMultiPoint(coordinates2 !== null ? this.getCoordinateSequenceFactory().create(coordinates2) : null);
    } else if (hasInterface(arguments[0], CoordinateSequence)) {
      var coordinates$1 = arguments[0];
      if (coordinates$1 === null) {
        return this.createMultiPoint(new Array(0).fill(null));
      }
      var points2 = new Array(coordinates$1.size()).fill(null);
      for (var i2 = 0; i2 < coordinates$1.size(); i2++) {
        var ptSeq = this$1$1.getCoordinateSequenceFactory().create(1, coordinates$1.getDimension());
        CoordinateSequences.copy(coordinates$1, i2, ptSeq, 0, 1);
        points2[i2] = this$1$1.createPoint(ptSeq);
      }
      return this.createMultiPoint(points2);
    }
  }
};
GeometryFactory.prototype.interfaces_ = function interfaces_47() {
  return [Serializable];
};
GeometryFactory.prototype.getClass = function getClass46() {
  return GeometryFactory;
};
GeometryFactory.toMultiPolygonArray = function toMultiPolygonArray(multiPolygons) {
  var multiPolygonArray = new Array(multiPolygons.size()).fill(null);
  return multiPolygons.toArray(multiPolygonArray);
};
GeometryFactory.toGeometryArray = function toGeometryArray(geometries) {
  if (geometries === null) {
    return null;
  }
  var geometryArray = new Array(geometries.size()).fill(null);
  return geometries.toArray(geometryArray);
};
GeometryFactory.getDefaultCoordinateSequenceFactory = function getDefaultCoordinateSequenceFactory() {
  return CoordinateArraySequenceFactory.instance();
};
GeometryFactory.toMultiLineStringArray = function toMultiLineStringArray(multiLineStrings) {
  var multiLineStringArray = new Array(multiLineStrings.size()).fill(null);
  return multiLineStrings.toArray(multiLineStringArray);
};
GeometryFactory.toLineStringArray = function toLineStringArray(lineStrings2) {
  var lineStringArray = new Array(lineStrings2.size()).fill(null);
  return lineStrings2.toArray(lineStringArray);
};
GeometryFactory.toMultiPointArray = function toMultiPointArray(multiPoints) {
  var multiPointArray = new Array(multiPoints.size()).fill(null);
  return multiPoints.toArray(multiPointArray);
};
GeometryFactory.toLinearRingArray = function toLinearRingArray(linearRings) {
  var linearRingArray = new Array(linearRings.size()).fill(null);
  return linearRings.toArray(linearRingArray);
};
GeometryFactory.toPointArray = function toPointArray(points2) {
  var pointArray = new Array(points2.size()).fill(null);
  return points2.toArray(pointArray);
};
GeometryFactory.toPolygonArray = function toPolygonArray(polygons2) {
  var polygonArray = new Array(polygons2.size()).fill(null);
  return polygons2.toArray(polygonArray);
};
GeometryFactory.createPointFromInternalCoord = function createPointFromInternalCoord(coord, exemplar) {
  exemplar.getPrecisionModel().makePrecise(coord);
  return exemplar.getFactory().createPoint(coord);
};
staticAccessors$2.serialVersionUID.get = function() {
  return -6820524753094096e3;
};
Object.defineProperties(GeometryFactory, staticAccessors$2);
var geometryTypes = ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon"];
var GeoJSONParser = function GeoJSONParser2(geometryFactory) {
  this.geometryFactory = geometryFactory || new GeometryFactory();
};
GeoJSONParser.prototype.read = function read2(json) {
  var obj;
  if (typeof json === "string") {
    obj = JSON.parse(json);
  } else {
    obj = json;
  }
  var type = obj.type;
  if (!parse$9[type]) {
    throw new Error("Unknown GeoJSON type: " + obj.type);
  }
  if (geometryTypes.indexOf(type) !== -1) {
    return parse$9[type].apply(this, [obj.coordinates]);
  } else if (type === "GeometryCollection") {
    return parse$9[type].apply(this, [obj.geometries]);
  }
  return parse$9[type].apply(this, [obj]);
};
GeoJSONParser.prototype.write = function write3(geometry2) {
  var type = geometry2.getGeometryType();
  if (!extract[type]) {
    throw new Error("Geometry is not supported");
  }
  return extract[type].apply(this, [geometry2]);
};
var parse$9 = {
  /**
   * Parse a GeoJSON Feature object
   *
   * @param {Object}
   *          obj Object to parse.
   *
   * @return {Object} Feature with geometry/bbox converted to JSTS Geometries.
   */
  Feature: function(obj) {
    var feature2 = {};
    for (var key in obj) {
      feature2[key] = obj[key];
    }
    if (obj.geometry) {
      var type = obj.geometry.type;
      if (!parse$9[type]) {
        throw new Error("Unknown GeoJSON type: " + obj.type);
      }
      feature2.geometry = this.read(obj.geometry);
    }
    if (obj.bbox) {
      feature2.bbox = parse$9.bbox.apply(this, [obj.bbox]);
    }
    return feature2;
  },
  /**
   * Parse a GeoJSON FeatureCollection object
   *
   * @param {Object}
   *          obj Object to parse.
   *
   * @return {Object} FeatureCollection with geometry/bbox converted to JSTS Geometries.
   */
  FeatureCollection: function(obj) {
    var this$1$1 = this;
    var featureCollection2 = {};
    if (obj.features) {
      featureCollection2.features = [];
      for (var i2 = 0; i2 < obj.features.length; ++i2) {
        featureCollection2.features.push(this$1$1.read(obj.features[i2]));
      }
    }
    if (obj.bbox) {
      featureCollection2.bbox = this.parse.bbox.apply(this, [obj.bbox]);
    }
    return featureCollection2;
  },
  /**
   * Convert the ordinates in an array to an array of Coordinates
   *
   * @param {Array}
   *          array Array with {Number}s.
   *
   * @return {Array} Array with Coordinates.
   */
  coordinates: function(array2) {
    var coordinates2 = [];
    for (var i2 = 0; i2 < array2.length; ++i2) {
      var sub2 = array2[i2];
      coordinates2.push(new Coordinate(sub2[0], sub2[1]));
    }
    return coordinates2;
  },
  /**
   * Convert the bbox to a LinearRing
   *
   * @param {Array}
   *          array Array with [xMin, yMin, xMax, yMax].
   *
   * @return {Array} Array with Coordinates.
   */
  bbox: function(array2) {
    return this.geometryFactory.createLinearRing([
      new Coordinate(array2[0], array2[1]),
      new Coordinate(array2[2], array2[1]),
      new Coordinate(array2[2], array2[3]),
      new Coordinate(array2[0], array2[3]),
      new Coordinate(array2[0], array2[1])
    ]);
  },
  /**
   * Convert an Array with ordinates to a Point
   *
   * @param {Array}
   *          array Array with ordinates.
   *
   * @return {Point} Point.
   */
  Point: function(array2) {
    var coordinate2 = new Coordinate(array2[0], array2[1]);
    return this.geometryFactory.createPoint(coordinate2);
  },
  /**
   * Convert an Array with coordinates to a MultiPoint
   *
   * @param {Array}
   *          array Array with coordinates.
   *
   * @return {MultiPoint} MultiPoint.
   */
  MultiPoint: function(array2) {
    var this$1$1 = this;
    var points2 = [];
    for (var i2 = 0; i2 < array2.length; ++i2) {
      points2.push(parse$9.Point.apply(this$1$1, [array2[i2]]));
    }
    return this.geometryFactory.createMultiPoint(points2);
  },
  /**
   * Convert an Array with coordinates to a LineString
   *
   * @param {Array}
   *          array Array with coordinates.
   *
   * @return {LineString} LineString.
   */
  LineString: function(array2) {
    var coordinates2 = parse$9.coordinates.apply(this, [array2]);
    return this.geometryFactory.createLineString(coordinates2);
  },
  /**
   * Convert an Array with coordinates to a MultiLineString
   *
   * @param {Array}
   *          array Array with coordinates.
   *
   * @return {MultiLineString} MultiLineString.
   */
  MultiLineString: function(array2) {
    var this$1$1 = this;
    var lineStrings2 = [];
    for (var i2 = 0; i2 < array2.length; ++i2) {
      lineStrings2.push(parse$9.LineString.apply(this$1$1, [array2[i2]]));
    }
    return this.geometryFactory.createMultiLineString(lineStrings2);
  },
  /**
   * Convert an Array to a Polygon
   *
   * @param {Array}
   *          array Array with shell and holes.
   *
   * @return {Polygon} Polygon.
   */
  Polygon: function(array2) {
    var this$1$1 = this;
    var shellCoordinates = parse$9.coordinates.apply(this, [array2[0]]);
    var shell = this.geometryFactory.createLinearRing(shellCoordinates);
    var holes = [];
    for (var i2 = 1; i2 < array2.length; ++i2) {
      var hole = array2[i2];
      var coordinates2 = parse$9.coordinates.apply(this$1$1, [hole]);
      var linearRing = this$1$1.geometryFactory.createLinearRing(coordinates2);
      holes.push(linearRing);
    }
    return this.geometryFactory.createPolygon(shell, holes);
  },
  /**
   * Convert an Array to a MultiPolygon
   *
   * @param {Array}
   *          array Array of arrays with shell and rings.
   *
   * @return {MultiPolygon} MultiPolygon.
   */
  MultiPolygon: function(array2) {
    var this$1$1 = this;
    var polygons2 = [];
    for (var i2 = 0; i2 < array2.length; ++i2) {
      var polygon4 = array2[i2];
      polygons2.push(parse$9.Polygon.apply(this$1$1, [polygon4]));
    }
    return this.geometryFactory.createMultiPolygon(polygons2);
  },
  /**
   * Convert an Array to a GeometryCollection
   *
   * @param {Array}
   *          array Array of GeoJSON geometries.
   *
   * @return {GeometryCollection} GeometryCollection.
   */
  GeometryCollection: function(array2) {
    var this$1$1 = this;
    var geometries = [];
    for (var i2 = 0; i2 < array2.length; ++i2) {
      var geometry2 = array2[i2];
      geometries.push(this$1$1.read(geometry2));
    }
    return this.geometryFactory.createGeometryCollection(geometries);
  }
};
var extract = {
  /**
   * Convert a Coordinate to an Array
   *
   * @param {Coordinate}
   *          coordinate Coordinate to convert.
   *
   * @return {Array} Array of ordinates.
   */
  coordinate: function(coordinate2) {
    return [coordinate2.x, coordinate2.y];
  },
  /**
   * Convert a Point to a GeoJSON object
   *
   * @param {Point}
   *          point Point to convert.
   *
   * @return {Array} Array of 2 ordinates (paired to a coordinate).
   */
  Point: function(point4) {
    var array2 = extract.coordinate.apply(this, [point4.getCoordinate()]);
    return {
      type: "Point",
      coordinates: array2
    };
  },
  /**
   * Convert a MultiPoint to a GeoJSON object
   *
   * @param {MultiPoint}
   *          multipoint MultiPoint to convert.
   *
   * @return {Array} Array of coordinates.
   */
  MultiPoint: function(multipoint3) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0; i2 < multipoint3._geometries.length; ++i2) {
      var point4 = multipoint3._geometries[i2];
      var geoJson = extract.Point.apply(this$1$1, [point4]);
      array2.push(geoJson.coordinates);
    }
    return {
      type: "MultiPoint",
      coordinates: array2
    };
  },
  /**
   * Convert a LineString to a GeoJSON object
   *
   * @param {LineString}
   *          linestring LineString to convert.
   *
   * @return {Array} Array of coordinates.
   */
  LineString: function(linestring3) {
    var this$1$1 = this;
    var array2 = [];
    var coordinates2 = linestring3.getCoordinates();
    for (var i2 = 0; i2 < coordinates2.length; ++i2) {
      var coordinate2 = coordinates2[i2];
      array2.push(extract.coordinate.apply(this$1$1, [coordinate2]));
    }
    return {
      type: "LineString",
      coordinates: array2
    };
  },
  /**
   * Convert a MultiLineString to a GeoJSON object
   *
   * @param {MultiLineString}
   *          multilinestring MultiLineString to convert.
   *
   * @return {Array} Array of Array of coordinates.
   */
  MultiLineString: function(multilinestring3) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0; i2 < multilinestring3._geometries.length; ++i2) {
      var linestring3 = multilinestring3._geometries[i2];
      var geoJson = extract.LineString.apply(this$1$1, [linestring3]);
      array2.push(geoJson.coordinates);
    }
    return {
      type: "MultiLineString",
      coordinates: array2
    };
  },
  /**
   * Convert a Polygon to a GeoJSON object
   *
   * @param {Polygon}
   *          polygon Polygon to convert.
   *
   * @return {Array} Array with shell, holes.
   */
  Polygon: function(polygon4) {
    var this$1$1 = this;
    var array2 = [];
    var shellGeoJson = extract.LineString.apply(this, [polygon4._shell]);
    array2.push(shellGeoJson.coordinates);
    for (var i2 = 0; i2 < polygon4._holes.length; ++i2) {
      var hole = polygon4._holes[i2];
      var holeGeoJson = extract.LineString.apply(this$1$1, [hole]);
      array2.push(holeGeoJson.coordinates);
    }
    return {
      type: "Polygon",
      coordinates: array2
    };
  },
  /**
   * Convert a MultiPolygon to a GeoJSON object
   *
   * @param {MultiPolygon}
   *          multipolygon MultiPolygon to convert.
   *
   * @return {Array} Array of polygons.
   */
  MultiPolygon: function(multipolygon3) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0; i2 < multipolygon3._geometries.length; ++i2) {
      var polygon4 = multipolygon3._geometries[i2];
      var geoJson = extract.Polygon.apply(this$1$1, [polygon4]);
      array2.push(geoJson.coordinates);
    }
    return {
      type: "MultiPolygon",
      coordinates: array2
    };
  },
  /**
   * Convert a GeometryCollection to a GeoJSON object
   *
   * @param {GeometryCollection}
   *          collection GeometryCollection to convert.
   *
   * @return {Array} Array of geometries.
   */
  GeometryCollection: function(collection) {
    var this$1$1 = this;
    var array2 = [];
    for (var i2 = 0; i2 < collection._geometries.length; ++i2) {
      var geometry2 = collection._geometries[i2];
      var type = geometry2.getGeometryType();
      array2.push(extract[type].apply(this$1$1, [geometry2]));
    }
    return {
      type: "GeometryCollection",
      geometries: array2
    };
  }
};
var GeoJSONReader = function GeoJSONReader2(geometryFactory) {
  this.geometryFactory = geometryFactory || new GeometryFactory();
  this.precisionModel = this.geometryFactory.getPrecisionModel();
  this.parser = new GeoJSONParser(this.geometryFactory);
};
GeoJSONReader.prototype.read = function read3(geoJson) {
  var geometry2 = this.parser.read(geoJson);
  if (this.precisionModel.getType() === PrecisionModel.FIXED) {
    this.reducePrecision(geometry2);
  }
  return geometry2;
};
GeoJSONReader.prototype.reducePrecision = function reducePrecision(geometry2) {
  var this$1$1 = this;
  var i2, len2;
  if (geometry2.coordinate) {
    this.precisionModel.makePrecise(geometry2.coordinate);
  } else if (geometry2.points) {
    for (i2 = 0, len2 = geometry2.points.length; i2 < len2; i2++) {
      this$1$1.precisionModel.makePrecise(geometry2.points[i2]);
    }
  } else if (geometry2.geometries) {
    for (i2 = 0, len2 = geometry2.geometries.length; i2 < len2; i2++) {
      this$1$1.reducePrecision(geometry2.geometries[i2]);
    }
  }
};
var GeoJSONWriter = function GeoJSONWriter2() {
  this.parser = new GeoJSONParser(this.geometryFactory);
};
GeoJSONWriter.prototype.write = function write4(geometry2) {
  return this.parser.write(geometry2);
};
var Position = function Position2() {
};
var staticAccessors$20 = { ON: { configurable: true }, LEFT: { configurable: true }, RIGHT: { configurable: true } };
Position.prototype.interfaces_ = function interfaces_48() {
  return [];
};
Position.prototype.getClass = function getClass47() {
  return Position;
};
Position.opposite = function opposite(position) {
  if (position === Position.LEFT) {
    return Position.RIGHT;
  }
  if (position === Position.RIGHT) {
    return Position.LEFT;
  }
  return position;
};
staticAccessors$20.ON.get = function() {
  return 0;
};
staticAccessors$20.LEFT.get = function() {
  return 1;
};
staticAccessors$20.RIGHT.get = function() {
  return 2;
};
Object.defineProperties(Position, staticAccessors$20);
function EmptyStackException(message2) {
  this.message = message2 || "";
}
EmptyStackException.prototype = new Error();
EmptyStackException.prototype.name = "EmptyStackException";
function Stack$5() {
  this.array_ = [];
}
Stack$5.prototype = new List$2();
Stack$5.prototype.add = function(e3) {
  this.array_.push(e3);
  return true;
};
Stack$5.prototype.get = function(index2) {
  if (index2 < 0 || index2 >= this.size()) {
    throw new Error();
  }
  return this.array_[index2];
};
Stack$5.prototype.push = function(e3) {
  this.array_.push(e3);
  return e3;
};
Stack$5.prototype.pop = function(e3) {
  if (this.array_.length === 0) {
    throw new EmptyStackException();
  }
  return this.array_.pop();
};
Stack$5.prototype.peek = function() {
  if (this.array_.length === 0) {
    throw new EmptyStackException();
  }
  return this.array_[this.array_.length - 1];
};
Stack$5.prototype.empty = function() {
  if (this.array_.length === 0) {
    return true;
  } else {
    return false;
  }
};
Stack$5.prototype.isEmpty = function() {
  return this.empty();
};
Stack$5.prototype.search = function(o2) {
  return this.array_.indexOf(o2);
};
Stack$5.prototype.size = function() {
  return this.array_.length;
};
Stack$5.prototype.toArray = function() {
  var this$1$1 = this;
  var array2 = [];
  for (var i2 = 0, len2 = this.array_.length; i2 < len2; i2++) {
    array2.push(this$1$1.array_[i2]);
  }
  return array2;
};
var RightmostEdgeFinder = function RightmostEdgeFinder2() {
  this._minIndex = -1;
  this._minCoord = null;
  this._minDe = null;
  this._orientedDe = null;
};
RightmostEdgeFinder.prototype.getCoordinate = function getCoordinate4() {
  return this._minCoord;
};
RightmostEdgeFinder.prototype.getRightmostSide = function getRightmostSide(de, index2) {
  var side = this.getRightmostSideOfSegment(de, index2);
  if (side < 0) {
    side = this.getRightmostSideOfSegment(de, index2 - 1);
  }
  if (side < 0) {
    this._minCoord = null;
    this.checkForRightmostCoordinate(de);
  }
  return side;
};
RightmostEdgeFinder.prototype.findRightmostEdgeAtVertex = function findRightmostEdgeAtVertex() {
  var pts = this._minDe.getEdge().getCoordinates();
  Assert.isTrue(this._minIndex > 0 && this._minIndex < pts.length, "rightmost point expected to be interior vertex of edge");
  var pPrev = pts[this._minIndex - 1];
  var pNext = pts[this._minIndex + 1];
  var orientation2 = CGAlgorithms.computeOrientation(this._minCoord, pNext, pPrev);
  var usePrev = false;
  if (pPrev.y < this._minCoord.y && pNext.y < this._minCoord.y && orientation2 === CGAlgorithms.COUNTERCLOCKWISE) {
    usePrev = true;
  } else if (pPrev.y > this._minCoord.y && pNext.y > this._minCoord.y && orientation2 === CGAlgorithms.CLOCKWISE) {
    usePrev = true;
  }
  if (usePrev) {
    this._minIndex = this._minIndex - 1;
  }
};
RightmostEdgeFinder.prototype.getRightmostSideOfSegment = function getRightmostSideOfSegment(de, i2) {
  var e3 = de.getEdge();
  var coord = e3.getCoordinates();
  if (i2 < 0 || i2 + 1 >= coord.length) {
    return -1;
  }
  if (coord[i2].y === coord[i2 + 1].y) {
    return -1;
  }
  var pos = Position.LEFT;
  if (coord[i2].y < coord[i2 + 1].y) {
    pos = Position.RIGHT;
  }
  return pos;
};
RightmostEdgeFinder.prototype.getEdge = function getEdge() {
  return this._orientedDe;
};
RightmostEdgeFinder.prototype.checkForRightmostCoordinate = function checkForRightmostCoordinate(de) {
  var this$1$1 = this;
  var coord = de.getEdge().getCoordinates();
  for (var i2 = 0; i2 < coord.length - 1; i2++) {
    if (this$1$1._minCoord === null || coord[i2].x > this$1$1._minCoord.x) {
      this$1$1._minDe = de;
      this$1$1._minIndex = i2;
      this$1$1._minCoord = coord[i2];
    }
  }
};
RightmostEdgeFinder.prototype.findRightmostEdgeAtNode = function findRightmostEdgeAtNode() {
  var node = this._minDe.getNode();
  var star = node.getEdges();
  this._minDe = star.getRightmostEdge();
  if (!this._minDe.isForward()) {
    this._minDe = this._minDe.getSym();
    this._minIndex = this._minDe.getEdge().getCoordinates().length - 1;
  }
};
RightmostEdgeFinder.prototype.findEdge = function findEdge(dirEdgeList) {
  var this$1$1 = this;
  for (var i2 = dirEdgeList.iterator(); i2.hasNext(); ) {
    var de = i2.next();
    if (!de.isForward()) {
      continue;
    }
    this$1$1.checkForRightmostCoordinate(de);
  }
  Assert.isTrue(this._minIndex !== 0 || this._minCoord.equals(this._minDe.getCoordinate()), "inconsistency in rightmost processing");
  if (this._minIndex === 0) {
    this.findRightmostEdgeAtNode();
  } else {
    this.findRightmostEdgeAtVertex();
  }
  this._orientedDe = this._minDe;
  var rightmostSide = this.getRightmostSide(this._minDe, this._minIndex);
  if (rightmostSide === Position.LEFT) {
    this._orientedDe = this._minDe.getSym();
  }
};
RightmostEdgeFinder.prototype.interfaces_ = function interfaces_49() {
  return [];
};
RightmostEdgeFinder.prototype.getClass = function getClass48() {
  return RightmostEdgeFinder;
};
var TopologyException = function(RuntimeException$$1) {
  function TopologyException2(msg2, pt) {
    RuntimeException$$1.call(this, TopologyException2.msgWithCoord(msg2, pt));
    this.pt = pt ? new Coordinate(pt) : null;
    this.name = "TopologyException";
  }
  if (RuntimeException$$1)
    TopologyException2.__proto__ = RuntimeException$$1;
  TopologyException2.prototype = Object.create(RuntimeException$$1 && RuntimeException$$1.prototype);
  TopologyException2.prototype.constructor = TopologyException2;
  TopologyException2.prototype.getCoordinate = function getCoordinate18() {
    return this.pt;
  };
  TopologyException2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  TopologyException2.prototype.getClass = function getClass169() {
    return TopologyException2;
  };
  TopologyException2.msgWithCoord = function msgWithCoord(msg2, pt) {
    if (!pt) {
      return msg2 + " [ " + pt + " ]";
    }
    return msg2;
  };
  return TopologyException2;
}(RuntimeException);
var LinkedList = function LinkedList2() {
  this.array_ = [];
};
LinkedList.prototype.addLast = function addLast(e3) {
  this.array_.push(e3);
};
LinkedList.prototype.removeFirst = function removeFirst() {
  return this.array_.shift();
};
LinkedList.prototype.isEmpty = function isEmpty2() {
  return this.array_.length === 0;
};
var BufferSubgraph = function BufferSubgraph2() {
  this._finder = null;
  this._dirEdgeList = new ArrayList();
  this._nodes = new ArrayList();
  this._rightMostCoord = null;
  this._env = null;
  this._finder = new RightmostEdgeFinder();
};
BufferSubgraph.prototype.clearVisitedEdges = function clearVisitedEdges() {
  for (var it = this._dirEdgeList.iterator(); it.hasNext(); ) {
    var de = it.next();
    de.setVisited(false);
  }
};
BufferSubgraph.prototype.getRightmostCoordinate = function getRightmostCoordinate() {
  return this._rightMostCoord;
};
BufferSubgraph.prototype.computeNodeDepth = function computeNodeDepth(n2) {
  var this$1$1 = this;
  var startEdge = null;
  for (var i2 = n2.getEdges().iterator(); i2.hasNext(); ) {
    var de = i2.next();
    if (de.isVisited() || de.getSym().isVisited()) {
      startEdge = de;
      break;
    }
  }
  if (startEdge === null) {
    throw new TopologyException("unable to find edge to compute depths at " + n2.getCoordinate());
  }
  n2.getEdges().computeDepths(startEdge);
  for (var i$12 = n2.getEdges().iterator(); i$12.hasNext(); ) {
    var de$1 = i$12.next();
    de$1.setVisited(true);
    this$1$1.copySymDepths(de$1);
  }
};
BufferSubgraph.prototype.computeDepth = function computeDepth(outsideDepth) {
  this.clearVisitedEdges();
  var de = this._finder.getEdge();
  de.setEdgeDepths(Position.RIGHT, outsideDepth);
  this.copySymDepths(de);
  this.computeDepths(de);
};
BufferSubgraph.prototype.create = function create4(node) {
  this.addReachable(node);
  this._finder.findEdge(this._dirEdgeList);
  this._rightMostCoord = this._finder.getCoordinate();
};
BufferSubgraph.prototype.findResultEdges = function findResultEdges() {
  for (var it = this._dirEdgeList.iterator(); it.hasNext(); ) {
    var de = it.next();
    if (de.getDepth(Position.RIGHT) >= 1 && de.getDepth(Position.LEFT) <= 0 && !de.isInteriorAreaEdge()) {
      de.setInResult(true);
    }
  }
};
BufferSubgraph.prototype.computeDepths = function computeDepths(startEdge) {
  var this$1$1 = this;
  var nodesVisited = new HashSet();
  var nodeQueue = new LinkedList();
  var startNode = startEdge.getNode();
  nodeQueue.addLast(startNode);
  nodesVisited.add(startNode);
  startEdge.setVisited(true);
  while (!nodeQueue.isEmpty()) {
    var n2 = nodeQueue.removeFirst();
    nodesVisited.add(n2);
    this$1$1.computeNodeDepth(n2);
    for (var i2 = n2.getEdges().iterator(); i2.hasNext(); ) {
      var de = i2.next();
      var sym = de.getSym();
      if (sym.isVisited()) {
        continue;
      }
      var adjNode = sym.getNode();
      if (!nodesVisited.contains(adjNode)) {
        nodeQueue.addLast(adjNode);
        nodesVisited.add(adjNode);
      }
    }
  }
};
BufferSubgraph.prototype.compareTo = function compareTo7(o2) {
  var graph = o2;
  if (this._rightMostCoord.x < graph._rightMostCoord.x) {
    return -1;
  }
  if (this._rightMostCoord.x > graph._rightMostCoord.x) {
    return 1;
  }
  return 0;
};
BufferSubgraph.prototype.getEnvelope = function getEnvelope2() {
  if (this._env === null) {
    var edgeEnv = new Envelope();
    for (var it = this._dirEdgeList.iterator(); it.hasNext(); ) {
      var dirEdge = it.next();
      var pts = dirEdge.getEdge().getCoordinates();
      for (var i2 = 0; i2 < pts.length - 1; i2++) {
        edgeEnv.expandToInclude(pts[i2]);
      }
    }
    this._env = edgeEnv;
  }
  return this._env;
};
BufferSubgraph.prototype.addReachable = function addReachable(startNode) {
  var this$1$1 = this;
  var nodeStack = new Stack$5();
  nodeStack.add(startNode);
  while (!nodeStack.empty()) {
    var node = nodeStack.pop();
    this$1$1.add(node, nodeStack);
  }
};
BufferSubgraph.prototype.copySymDepths = function copySymDepths(de) {
  var sym = de.getSym();
  sym.setDepth(Position.LEFT, de.getDepth(Position.RIGHT));
  sym.setDepth(Position.RIGHT, de.getDepth(Position.LEFT));
};
BufferSubgraph.prototype.add = function add4(node, nodeStack) {
  var this$1$1 = this;
  node.setVisited(true);
  this._nodes.add(node);
  for (var i2 = node.getEdges().iterator(); i2.hasNext(); ) {
    var de = i2.next();
    this$1$1._dirEdgeList.add(de);
    var sym = de.getSym();
    var symNode = sym.getNode();
    if (!symNode.isVisited()) {
      nodeStack.push(symNode);
    }
  }
};
BufferSubgraph.prototype.getNodes = function getNodes() {
  return this._nodes;
};
BufferSubgraph.prototype.getDirectedEdges = function getDirectedEdges() {
  return this._dirEdgeList;
};
BufferSubgraph.prototype.interfaces_ = function interfaces_50() {
  return [Comparable];
};
BufferSubgraph.prototype.getClass = function getClass49() {
  return BufferSubgraph;
};
var TopologyLocation = function TopologyLocation2() {
  var this$1$1 = this;
  this.location = null;
  if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var location2 = arguments[0];
      this.init(location2.length);
    } else if (Number.isInteger(arguments[0])) {
      var on2 = arguments[0];
      this.init(1);
      this.location[Position.ON] = on2;
    } else if (arguments[0] instanceof TopologyLocation2) {
      var gl = arguments[0];
      this.init(gl.location.length);
      if (gl !== null) {
        for (var i2 = 0; i2 < this.location.length; i2++) {
          this$1$1.location[i2] = gl.location[i2];
        }
      }
    }
  } else if (arguments.length === 3) {
    var on$1 = arguments[0];
    var left = arguments[1];
    var right = arguments[2];
    this.init(3);
    this.location[Position.ON] = on$1;
    this.location[Position.LEFT] = left;
    this.location[Position.RIGHT] = right;
  }
};
TopologyLocation.prototype.setAllLocations = function setAllLocations(locValue) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this.location.length; i2++) {
    this$1$1.location[i2] = locValue;
  }
};
TopologyLocation.prototype.isNull = function isNull2() {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this.location.length; i2++) {
    if (this$1$1.location[i2] !== Location.NONE) {
      return false;
    }
  }
  return true;
};
TopologyLocation.prototype.setAllLocationsIfNull = function setAllLocationsIfNull(locValue) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this.location.length; i2++) {
    if (this$1$1.location[i2] === Location.NONE) {
      this$1$1.location[i2] = locValue;
    }
  }
};
TopologyLocation.prototype.isLine = function isLine() {
  return this.location.length === 1;
};
TopologyLocation.prototype.merge = function merge2(gl) {
  var this$1$1 = this;
  if (gl.location.length > this.location.length) {
    var newLoc = new Array(3).fill(null);
    newLoc[Position.ON] = this.location[Position.ON];
    newLoc[Position.LEFT] = Location.NONE;
    newLoc[Position.RIGHT] = Location.NONE;
    this.location = newLoc;
  }
  for (var i2 = 0; i2 < this.location.length; i2++) {
    if (this$1$1.location[i2] === Location.NONE && i2 < gl.location.length) {
      this$1$1.location[i2] = gl.location[i2];
    }
  }
};
TopologyLocation.prototype.getLocations = function getLocations() {
  return this.location;
};
TopologyLocation.prototype.flip = function flip2() {
  if (this.location.length <= 1) {
    return null;
  }
  var temp2 = this.location[Position.LEFT];
  this.location[Position.LEFT] = this.location[Position.RIGHT];
  this.location[Position.RIGHT] = temp2;
};
TopologyLocation.prototype.toString = function toString12() {
  var buf = new StringBuffer();
  if (this.location.length > 1) {
    buf.append(Location.toLocationSymbol(this.location[Position.LEFT]));
  }
  buf.append(Location.toLocationSymbol(this.location[Position.ON]));
  if (this.location.length > 1) {
    buf.append(Location.toLocationSymbol(this.location[Position.RIGHT]));
  }
  return buf.toString();
};
TopologyLocation.prototype.setLocations = function setLocations(on2, left, right) {
  this.location[Position.ON] = on2;
  this.location[Position.LEFT] = left;
  this.location[Position.RIGHT] = right;
};
TopologyLocation.prototype.get = function get3(posIndex) {
  if (posIndex < this.location.length) {
    return this.location[posIndex];
  }
  return Location.NONE;
};
TopologyLocation.prototype.isArea = function isArea() {
  return this.location.length > 1;
};
TopologyLocation.prototype.isAnyNull = function isAnyNull() {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this.location.length; i2++) {
    if (this$1$1.location[i2] === Location.NONE) {
      return true;
    }
  }
  return false;
};
TopologyLocation.prototype.setLocation = function setLocation() {
  if (arguments.length === 1) {
    var locValue = arguments[0];
    this.setLocation(Position.ON, locValue);
  } else if (arguments.length === 2) {
    var locIndex = arguments[0];
    var locValue$1 = arguments[1];
    this.location[locIndex] = locValue$1;
  }
};
TopologyLocation.prototype.init = function init4(size12) {
  this.location = new Array(size12).fill(null);
  this.setAllLocations(Location.NONE);
};
TopologyLocation.prototype.isEqualOnSide = function isEqualOnSide(le2, locIndex) {
  return this.location[locIndex] === le2.location[locIndex];
};
TopologyLocation.prototype.allPositionsEqual = function allPositionsEqual(loc) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this.location.length; i2++) {
    if (this$1$1.location[i2] !== loc) {
      return false;
    }
  }
  return true;
};
TopologyLocation.prototype.interfaces_ = function interfaces_51() {
  return [];
};
TopologyLocation.prototype.getClass = function getClass50() {
  return TopologyLocation;
};
var Label = function Label2() {
  this.elt = new Array(2).fill(null);
  if (arguments.length === 1) {
    if (Number.isInteger(arguments[0])) {
      var onLoc = arguments[0];
      this.elt[0] = new TopologyLocation(onLoc);
      this.elt[1] = new TopologyLocation(onLoc);
    } else if (arguments[0] instanceof Label2) {
      var lbl = arguments[0];
      this.elt[0] = new TopologyLocation(lbl.elt[0]);
      this.elt[1] = new TopologyLocation(lbl.elt[1]);
    }
  } else if (arguments.length === 2) {
    var geomIndex = arguments[0];
    var onLoc$1 = arguments[1];
    this.elt[0] = new TopologyLocation(Location.NONE);
    this.elt[1] = new TopologyLocation(Location.NONE);
    this.elt[geomIndex].setLocation(onLoc$1);
  } else if (arguments.length === 3) {
    var onLoc$2 = arguments[0];
    var leftLoc = arguments[1];
    var rightLoc = arguments[2];
    this.elt[0] = new TopologyLocation(onLoc$2, leftLoc, rightLoc);
    this.elt[1] = new TopologyLocation(onLoc$2, leftLoc, rightLoc);
  } else if (arguments.length === 4) {
    var geomIndex$1 = arguments[0];
    var onLoc$3 = arguments[1];
    var leftLoc$1 = arguments[2];
    var rightLoc$1 = arguments[3];
    this.elt[0] = new TopologyLocation(Location.NONE, Location.NONE, Location.NONE);
    this.elt[1] = new TopologyLocation(Location.NONE, Location.NONE, Location.NONE);
    this.elt[geomIndex$1].setLocations(onLoc$3, leftLoc$1, rightLoc$1);
  }
};
Label.prototype.getGeometryCount = function getGeometryCount() {
  var count3 = 0;
  if (!this.elt[0].isNull()) {
    count3++;
  }
  if (!this.elt[1].isNull()) {
    count3++;
  }
  return count3;
};
Label.prototype.setAllLocations = function setAllLocations2(geomIndex, location2) {
  this.elt[geomIndex].setAllLocations(location2);
};
Label.prototype.isNull = function isNull3(geomIndex) {
  return this.elt[geomIndex].isNull();
};
Label.prototype.setAllLocationsIfNull = function setAllLocationsIfNull2() {
  if (arguments.length === 1) {
    var location2 = arguments[0];
    this.setAllLocationsIfNull(0, location2);
    this.setAllLocationsIfNull(1, location2);
  } else if (arguments.length === 2) {
    var geomIndex = arguments[0];
    var location$12 = arguments[1];
    this.elt[geomIndex].setAllLocationsIfNull(location$12);
  }
};
Label.prototype.isLine = function isLine2(geomIndex) {
  return this.elt[geomIndex].isLine();
};
Label.prototype.merge = function merge3(lbl) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < 2; i2++) {
    if (this$1$1.elt[i2] === null && lbl.elt[i2] !== null) {
      this$1$1.elt[i2] = new TopologyLocation(lbl.elt[i2]);
    } else {
      this$1$1.elt[i2].merge(lbl.elt[i2]);
    }
  }
};
Label.prototype.flip = function flip3() {
  this.elt[0].flip();
  this.elt[1].flip();
};
Label.prototype.getLocation = function getLocation2() {
  if (arguments.length === 1) {
    var geomIndex = arguments[0];
    return this.elt[geomIndex].get(Position.ON);
  } else if (arguments.length === 2) {
    var geomIndex$1 = arguments[0];
    var posIndex = arguments[1];
    return this.elt[geomIndex$1].get(posIndex);
  }
};
Label.prototype.toString = function toString13() {
  var buf = new StringBuffer();
  if (this.elt[0] !== null) {
    buf.append("A:");
    buf.append(this.elt[0].toString());
  }
  if (this.elt[1] !== null) {
    buf.append(" B:");
    buf.append(this.elt[1].toString());
  }
  return buf.toString();
};
Label.prototype.isArea = function isArea2() {
  if (arguments.length === 0) {
    return this.elt[0].isArea() || this.elt[1].isArea();
  } else if (arguments.length === 1) {
    var geomIndex = arguments[0];
    return this.elt[geomIndex].isArea();
  }
};
Label.prototype.isAnyNull = function isAnyNull2(geomIndex) {
  return this.elt[geomIndex].isAnyNull();
};
Label.prototype.setLocation = function setLocation2() {
  if (arguments.length === 2) {
    var geomIndex = arguments[0];
    var location2 = arguments[1];
    this.elt[geomIndex].setLocation(Position.ON, location2);
  } else if (arguments.length === 3) {
    var geomIndex$1 = arguments[0];
    var posIndex = arguments[1];
    var location$12 = arguments[2];
    this.elt[geomIndex$1].setLocation(posIndex, location$12);
  }
};
Label.prototype.isEqualOnSide = function isEqualOnSide2(lbl, side) {
  return this.elt[0].isEqualOnSide(lbl.elt[0], side) && this.elt[1].isEqualOnSide(lbl.elt[1], side);
};
Label.prototype.allPositionsEqual = function allPositionsEqual2(geomIndex, loc) {
  return this.elt[geomIndex].allPositionsEqual(loc);
};
Label.prototype.toLine = function toLine(geomIndex) {
  if (this.elt[geomIndex].isArea()) {
    this.elt[geomIndex] = new TopologyLocation(this.elt[geomIndex].location[0]);
  }
};
Label.prototype.interfaces_ = function interfaces_52() {
  return [];
};
Label.prototype.getClass = function getClass51() {
  return Label;
};
Label.toLineLabel = function toLineLabel(label) {
  var lineLabel = new Label(Location.NONE);
  for (var i2 = 0; i2 < 2; i2++) {
    lineLabel.setLocation(i2, label.getLocation(i2));
  }
  return lineLabel;
};
var EdgeRing = function EdgeRing2() {
  this._startDe = null;
  this._maxNodeDegree = -1;
  this._edges = new ArrayList();
  this._pts = new ArrayList();
  this._label = new Label(Location.NONE);
  this._ring = null;
  this._isHole = null;
  this._shell = null;
  this._holes = new ArrayList();
  this._geometryFactory = null;
  var start2 = arguments[0];
  var geometryFactory = arguments[1];
  this._geometryFactory = geometryFactory;
  this.computePoints(start2);
  this.computeRing();
};
EdgeRing.prototype.computeRing = function computeRing() {
  var this$1$1 = this;
  if (this._ring !== null) {
    return null;
  }
  var coord = new Array(this._pts.size()).fill(null);
  for (var i2 = 0; i2 < this._pts.size(); i2++) {
    coord[i2] = this$1$1._pts.get(i2);
  }
  this._ring = this._geometryFactory.createLinearRing(coord);
  this._isHole = CGAlgorithms.isCCW(this._ring.getCoordinates());
};
EdgeRing.prototype.isIsolated = function isIsolated() {
  return this._label.getGeometryCount() === 1;
};
EdgeRing.prototype.computePoints = function computePoints(start2) {
  var this$1$1 = this;
  this._startDe = start2;
  var de = start2;
  var isFirstEdge = true;
  do {
    if (de === null) {
      throw new TopologyException("Found null DirectedEdge");
    }
    if (de.getEdgeRing() === this$1$1) {
      throw new TopologyException("Directed Edge visited twice during ring-building at " + de.getCoordinate());
    }
    this$1$1._edges.add(de);
    var label = de.getLabel();
    Assert.isTrue(label.isArea());
    this$1$1.mergeLabel(label);
    this$1$1.addPoints(de.getEdge(), de.isForward(), isFirstEdge);
    isFirstEdge = false;
    this$1$1.setEdgeRing(de, this$1$1);
    de = this$1$1.getNext(de);
  } while (de !== this._startDe);
};
EdgeRing.prototype.getLinearRing = function getLinearRing() {
  return this._ring;
};
EdgeRing.prototype.getCoordinate = function getCoordinate5(i2) {
  return this._pts.get(i2);
};
EdgeRing.prototype.computeMaxNodeDegree = function computeMaxNodeDegree() {
  var this$1$1 = this;
  this._maxNodeDegree = 0;
  var de = this._startDe;
  do {
    var node = de.getNode();
    var degree = node.getEdges().getOutgoingDegree(this$1$1);
    if (degree > this$1$1._maxNodeDegree) {
      this$1$1._maxNodeDegree = degree;
    }
    de = this$1$1.getNext(de);
  } while (de !== this._startDe);
  this._maxNodeDegree *= 2;
};
EdgeRing.prototype.addPoints = function addPoints(edge, isForward, isFirstEdge) {
  var this$1$1 = this;
  var edgePts = edge.getCoordinates();
  if (isForward) {
    var startIndex = 1;
    if (isFirstEdge) {
      startIndex = 0;
    }
    for (var i2 = startIndex; i2 < edgePts.length; i2++) {
      this$1$1._pts.add(edgePts[i2]);
    }
  } else {
    var startIndex$1 = edgePts.length - 2;
    if (isFirstEdge) {
      startIndex$1 = edgePts.length - 1;
    }
    for (var i$12 = startIndex$1; i$12 >= 0; i$12--) {
      this$1$1._pts.add(edgePts[i$12]);
    }
  }
};
EdgeRing.prototype.isHole = function isHole() {
  return this._isHole;
};
EdgeRing.prototype.setInResult = function setInResult() {
  var de = this._startDe;
  do {
    de.getEdge().setInResult(true);
    de = de.getNext();
  } while (de !== this._startDe);
};
EdgeRing.prototype.containsPoint = function containsPoint(p2) {
  var shell = this.getLinearRing();
  var env = shell.getEnvelopeInternal();
  if (!env.contains(p2)) {
    return false;
  }
  if (!CGAlgorithms.isPointInRing(p2, shell.getCoordinates())) {
    return false;
  }
  for (var i2 = this._holes.iterator(); i2.hasNext(); ) {
    var hole = i2.next();
    if (hole.containsPoint(p2)) {
      return false;
    }
  }
  return true;
};
EdgeRing.prototype.addHole = function addHole(ring) {
  this._holes.add(ring);
};
EdgeRing.prototype.isShell = function isShell() {
  return this._shell === null;
};
EdgeRing.prototype.getLabel = function getLabel() {
  return this._label;
};
EdgeRing.prototype.getEdges = function getEdges() {
  return this._edges;
};
EdgeRing.prototype.getMaxNodeDegree = function getMaxNodeDegree() {
  if (this._maxNodeDegree < 0) {
    this.computeMaxNodeDegree();
  }
  return this._maxNodeDegree;
};
EdgeRing.prototype.getShell = function getShell() {
  return this._shell;
};
EdgeRing.prototype.mergeLabel = function mergeLabel() {
  if (arguments.length === 1) {
    var deLabel = arguments[0];
    this.mergeLabel(deLabel, 0);
    this.mergeLabel(deLabel, 1);
  } else if (arguments.length === 2) {
    var deLabel$1 = arguments[0];
    var geomIndex = arguments[1];
    var loc = deLabel$1.getLocation(geomIndex, Position.RIGHT);
    if (loc === Location.NONE) {
      return null;
    }
    if (this._label.getLocation(geomIndex) === Location.NONE) {
      this._label.setLocation(geomIndex, loc);
      return null;
    }
  }
};
EdgeRing.prototype.setShell = function setShell(shell) {
  this._shell = shell;
  if (shell !== null) {
    shell.addHole(this);
  }
};
EdgeRing.prototype.toPolygon = function toPolygon(geometryFactory) {
  var this$1$1 = this;
  var holeLR = new Array(this._holes.size()).fill(null);
  for (var i2 = 0; i2 < this._holes.size(); i2++) {
    holeLR[i2] = this$1$1._holes.get(i2).getLinearRing();
  }
  var poly2 = geometryFactory.createPolygon(this.getLinearRing(), holeLR);
  return poly2;
};
EdgeRing.prototype.interfaces_ = function interfaces_53() {
  return [];
};
EdgeRing.prototype.getClass = function getClass52() {
  return EdgeRing;
};
var MinimalEdgeRing = function(EdgeRing$$1) {
  function MinimalEdgeRing2() {
    var start2 = arguments[0];
    var geometryFactory = arguments[1];
    EdgeRing$$1.call(this, start2, geometryFactory);
  }
  if (EdgeRing$$1)
    MinimalEdgeRing2.__proto__ = EdgeRing$$1;
  MinimalEdgeRing2.prototype = Object.create(EdgeRing$$1 && EdgeRing$$1.prototype);
  MinimalEdgeRing2.prototype.constructor = MinimalEdgeRing2;
  MinimalEdgeRing2.prototype.setEdgeRing = function setEdgeRing(de, er) {
    de.setMinEdgeRing(er);
  };
  MinimalEdgeRing2.prototype.getNext = function getNext(de) {
    return de.getNextMin();
  };
  MinimalEdgeRing2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  MinimalEdgeRing2.prototype.getClass = function getClass169() {
    return MinimalEdgeRing2;
  };
  return MinimalEdgeRing2;
}(EdgeRing);
var MaximalEdgeRing = function(EdgeRing$$1) {
  function MaximalEdgeRing2() {
    var start2 = arguments[0];
    var geometryFactory = arguments[1];
    EdgeRing$$1.call(this, start2, geometryFactory);
  }
  if (EdgeRing$$1)
    MaximalEdgeRing2.__proto__ = EdgeRing$$1;
  MaximalEdgeRing2.prototype = Object.create(EdgeRing$$1 && EdgeRing$$1.prototype);
  MaximalEdgeRing2.prototype.constructor = MaximalEdgeRing2;
  MaximalEdgeRing2.prototype.buildMinimalRings = function buildMinimalRings() {
    var this$1$1 = this;
    var minEdgeRings = new ArrayList();
    var de = this._startDe;
    do {
      if (de.getMinEdgeRing() === null) {
        var minEr = new MinimalEdgeRing(de, this$1$1._geometryFactory);
        minEdgeRings.add(minEr);
      }
      de = de.getNext();
    } while (de !== this._startDe);
    return minEdgeRings;
  };
  MaximalEdgeRing2.prototype.setEdgeRing = function setEdgeRing(de, er) {
    de.setEdgeRing(er);
  };
  MaximalEdgeRing2.prototype.linkDirectedEdgesForMinimalEdgeRings = function linkDirectedEdgesForMinimalEdgeRings() {
    var this$1$1 = this;
    var de = this._startDe;
    do {
      var node = de.getNode();
      node.getEdges().linkMinimalDirectedEdges(this$1$1);
      de = de.getNext();
    } while (de !== this._startDe);
  };
  MaximalEdgeRing2.prototype.getNext = function getNext(de) {
    return de.getNext();
  };
  MaximalEdgeRing2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  MaximalEdgeRing2.prototype.getClass = function getClass169() {
    return MaximalEdgeRing2;
  };
  return MaximalEdgeRing2;
}(EdgeRing);
var GraphComponent = function GraphComponent2() {
  this._label = null;
  this._isInResult = false;
  this._isCovered = false;
  this._isCoveredSet = false;
  this._isVisited = false;
  if (arguments.length === 0)
    ;
  else if (arguments.length === 1) {
    var label = arguments[0];
    this._label = label;
  }
};
GraphComponent.prototype.setVisited = function setVisited(isVisited2) {
  this._isVisited = isVisited2;
};
GraphComponent.prototype.setInResult = function setInResult2(isInResult2) {
  this._isInResult = isInResult2;
};
GraphComponent.prototype.isCovered = function isCovered() {
  return this._isCovered;
};
GraphComponent.prototype.isCoveredSet = function isCoveredSet() {
  return this._isCoveredSet;
};
GraphComponent.prototype.setLabel = function setLabel(label) {
  this._label = label;
};
GraphComponent.prototype.getLabel = function getLabel2() {
  return this._label;
};
GraphComponent.prototype.setCovered = function setCovered(isCovered2) {
  this._isCovered = isCovered2;
  this._isCoveredSet = true;
};
GraphComponent.prototype.updateIM = function updateIM(im) {
  Assert.isTrue(this._label.getGeometryCount() >= 2, "found partial label");
  this.computeIM(im);
};
GraphComponent.prototype.isInResult = function isInResult() {
  return this._isInResult;
};
GraphComponent.prototype.isVisited = function isVisited() {
  return this._isVisited;
};
GraphComponent.prototype.interfaces_ = function interfaces_54() {
  return [];
};
GraphComponent.prototype.getClass = function getClass53() {
  return GraphComponent;
};
var Node$2 = function(GraphComponent$$1) {
  function Node2() {
    GraphComponent$$1.call(this);
    this._coord = null;
    this._edges = null;
    var coord = arguments[0];
    var edges = arguments[1];
    this._coord = coord;
    this._edges = edges;
    this._label = new Label(0, Location.NONE);
  }
  if (GraphComponent$$1)
    Node2.__proto__ = GraphComponent$$1;
  Node2.prototype = Object.create(GraphComponent$$1 && GraphComponent$$1.prototype);
  Node2.prototype.constructor = Node2;
  Node2.prototype.isIncidentEdgeInResult = function isIncidentEdgeInResult() {
    for (var it = this.getEdges().getEdges().iterator(); it.hasNext(); ) {
      var de = it.next();
      if (de.getEdge().isInResult()) {
        return true;
      }
    }
    return false;
  };
  Node2.prototype.isIsolated = function isIsolated2() {
    return this._label.getGeometryCount() === 1;
  };
  Node2.prototype.getCoordinate = function getCoordinate18() {
    return this._coord;
  };
  Node2.prototype.print = function print9(out) {
    out.println("node " + this._coord + " lbl: " + this._label);
  };
  Node2.prototype.computeIM = function computeIM(im) {
  };
  Node2.prototype.computeMergedLocation = function computeMergedLocation(label2, eltIndex) {
    var loc = Location.NONE;
    loc = this._label.getLocation(eltIndex);
    if (!label2.isNull(eltIndex)) {
      var nLoc = label2.getLocation(eltIndex);
      if (loc !== Location.BOUNDARY) {
        loc = nLoc;
      }
    }
    return loc;
  };
  Node2.prototype.setLabel = function setLabel2() {
    if (arguments.length === 2) {
      var argIndex = arguments[0];
      var onLocation = arguments[1];
      if (this._label === null) {
        this._label = new Label(argIndex, onLocation);
      } else {
        this._label.setLocation(argIndex, onLocation);
      }
    } else {
      return GraphComponent$$1.prototype.setLabel.apply(this, arguments);
    }
  };
  Node2.prototype.getEdges = function getEdges4() {
    return this._edges;
  };
  Node2.prototype.mergeLabel = function mergeLabel2() {
    var this$1$1 = this;
    if (arguments[0] instanceof Node2) {
      var n2 = arguments[0];
      this.mergeLabel(n2._label);
    } else if (arguments[0] instanceof Label) {
      var label2 = arguments[0];
      for (var i2 = 0; i2 < 2; i2++) {
        var loc = this$1$1.computeMergedLocation(label2, i2);
        var thisLoc = this$1$1._label.getLocation(i2);
        if (thisLoc === Location.NONE) {
          this$1$1._label.setLocation(i2, loc);
        }
      }
    }
  };
  Node2.prototype.add = function add18(e3) {
    this._edges.insert(e3);
    e3.setNode(this);
  };
  Node2.prototype.setLabelBoundary = function setLabelBoundary(argIndex) {
    if (this._label === null) {
      return null;
    }
    var loc = Location.NONE;
    if (this._label !== null) {
      loc = this._label.getLocation(argIndex);
    }
    var newLoc = null;
    switch (loc) {
      case Location.BOUNDARY:
        newLoc = Location.INTERIOR;
        break;
      case Location.INTERIOR:
        newLoc = Location.BOUNDARY;
        break;
      default:
        newLoc = Location.BOUNDARY;
        break;
    }
    this._label.setLocation(argIndex, newLoc);
  };
  Node2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  Node2.prototype.getClass = function getClass169() {
    return Node2;
  };
  return Node2;
}(GraphComponent);
var NodeMap = function NodeMap2() {
  this.nodeMap = new TreeMap();
  this.nodeFact = null;
  var nodeFact = arguments[0];
  this.nodeFact = nodeFact;
};
NodeMap.prototype.find = function find(coord) {
  return this.nodeMap.get(coord);
};
NodeMap.prototype.addNode = function addNode() {
  if (arguments[0] instanceof Coordinate) {
    var coord = arguments[0];
    var node = this.nodeMap.get(coord);
    if (node === null) {
      node = this.nodeFact.createNode(coord);
      this.nodeMap.put(coord, node);
    }
    return node;
  } else if (arguments[0] instanceof Node$2) {
    var n2 = arguments[0];
    var node$1 = this.nodeMap.get(n2.getCoordinate());
    if (node$1 === null) {
      this.nodeMap.put(n2.getCoordinate(), n2);
      return n2;
    }
    node$1.mergeLabel(n2);
    return node$1;
  }
};
NodeMap.prototype.print = function print(out) {
  for (var it = this.iterator(); it.hasNext(); ) {
    var n2 = it.next();
    n2.print(out);
  }
};
NodeMap.prototype.iterator = function iterator2() {
  return this.nodeMap.values().iterator();
};
NodeMap.prototype.values = function values2() {
  return this.nodeMap.values();
};
NodeMap.prototype.getBoundaryNodes = function getBoundaryNodes(geomIndex) {
  var bdyNodes = new ArrayList();
  for (var i2 = this.iterator(); i2.hasNext(); ) {
    var node = i2.next();
    if (node.getLabel().getLocation(geomIndex) === Location.BOUNDARY) {
      bdyNodes.add(node);
    }
  }
  return bdyNodes;
};
NodeMap.prototype.add = function add5(e3) {
  var p2 = e3.getCoordinate();
  var n2 = this.addNode(p2);
  n2.add(e3);
};
NodeMap.prototype.interfaces_ = function interfaces_55() {
  return [];
};
NodeMap.prototype.getClass = function getClass54() {
  return NodeMap;
};
var Quadrant = function Quadrant2() {
};
var staticAccessors$21 = { NE: { configurable: true }, NW: { configurable: true }, SW: { configurable: true }, SE: { configurable: true } };
Quadrant.prototype.interfaces_ = function interfaces_56() {
  return [];
};
Quadrant.prototype.getClass = function getClass55() {
  return Quadrant;
};
Quadrant.isNorthern = function isNorthern(quad) {
  return quad === Quadrant.NE || quad === Quadrant.NW;
};
Quadrant.isOpposite = function isOpposite(quad1, quad2) {
  if (quad1 === quad2) {
    return false;
  }
  var diff2 = (quad1 - quad2 + 4) % 4;
  if (diff2 === 2) {
    return true;
  }
  return false;
};
Quadrant.commonHalfPlane = function commonHalfPlane(quad1, quad2) {
  if (quad1 === quad2) {
    return quad1;
  }
  var diff2 = (quad1 - quad2 + 4) % 4;
  if (diff2 === 2) {
    return -1;
  }
  var min4 = quad1 < quad2 ? quad1 : quad2;
  var max3 = quad1 > quad2 ? quad1 : quad2;
  if (min4 === 0 && max3 === 3) {
    return 3;
  }
  return min4;
};
Quadrant.isInHalfPlane = function isInHalfPlane(quad, halfPlane) {
  if (halfPlane === Quadrant.SE) {
    return quad === Quadrant.SE || quad === Quadrant.SW;
  }
  return quad === halfPlane || quad === halfPlane + 1;
};
Quadrant.quadrant = function quadrant() {
  if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
    var dx = arguments[0];
    var dy = arguments[1];
    if (dx === 0 && dy === 0) {
      throw new IllegalArgumentException("Cannot compute the quadrant for point ( " + dx + ", " + dy + " )");
    }
    if (dx >= 0) {
      if (dy >= 0) {
        return Quadrant.NE;
      } else {
        return Quadrant.SE;
      }
    } else {
      if (dy >= 0) {
        return Quadrant.NW;
      } else {
        return Quadrant.SW;
      }
    }
  } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Coordinate) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    if (p1.x === p0.x && p1.y === p0.y) {
      throw new IllegalArgumentException("Cannot compute the quadrant for two identical points " + p0);
    }
    if (p1.x >= p0.x) {
      if (p1.y >= p0.y) {
        return Quadrant.NE;
      } else {
        return Quadrant.SE;
      }
    } else {
      if (p1.y >= p0.y) {
        return Quadrant.NW;
      } else {
        return Quadrant.SW;
      }
    }
  }
};
staticAccessors$21.NE.get = function() {
  return 0;
};
staticAccessors$21.NW.get = function() {
  return 1;
};
staticAccessors$21.SW.get = function() {
  return 2;
};
staticAccessors$21.SE.get = function() {
  return 3;
};
Object.defineProperties(Quadrant, staticAccessors$21);
var EdgeEnd = function EdgeEnd2() {
  this._edge = null;
  this._label = null;
  this._node = null;
  this._p0 = null;
  this._p1 = null;
  this._dx = null;
  this._dy = null;
  this._quadrant = null;
  if (arguments.length === 1) {
    var edge = arguments[0];
    this._edge = edge;
  } else if (arguments.length === 3) {
    var edge$1 = arguments[0];
    var p0 = arguments[1];
    var p1 = arguments[2];
    var label = null;
    this._edge = edge$1;
    this.init(p0, p1);
    this._label = label;
  } else if (arguments.length === 4) {
    var edge$2 = arguments[0];
    var p0$1 = arguments[1];
    var p1$1 = arguments[2];
    var label$1 = arguments[3];
    this._edge = edge$2;
    this.init(p0$1, p1$1);
    this._label = label$1;
  }
};
EdgeEnd.prototype.compareDirection = function compareDirection(e3) {
  if (this._dx === e3._dx && this._dy === e3._dy) {
    return 0;
  }
  if (this._quadrant > e3._quadrant) {
    return 1;
  }
  if (this._quadrant < e3._quadrant) {
    return -1;
  }
  return CGAlgorithms.computeOrientation(e3._p0, e3._p1, this._p1);
};
EdgeEnd.prototype.getDy = function getDy() {
  return this._dy;
};
EdgeEnd.prototype.getCoordinate = function getCoordinate6() {
  return this._p0;
};
EdgeEnd.prototype.setNode = function setNode(node) {
  this._node = node;
};
EdgeEnd.prototype.print = function print2(out) {
  var angle4 = Math.atan2(this._dy, this._dx);
  var className = this.getClass().getName();
  var lastDotPos = className.lastIndexOf(".");
  var name2 = className.substring(lastDotPos + 1);
  out.print("  " + name2 + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + angle4 + "   " + this._label);
};
EdgeEnd.prototype.compareTo = function compareTo8(obj) {
  var e3 = obj;
  return this.compareDirection(e3);
};
EdgeEnd.prototype.getDirectedCoordinate = function getDirectedCoordinate() {
  return this._p1;
};
EdgeEnd.prototype.getDx = function getDx() {
  return this._dx;
};
EdgeEnd.prototype.getLabel = function getLabel3() {
  return this._label;
};
EdgeEnd.prototype.getEdge = function getEdge2() {
  return this._edge;
};
EdgeEnd.prototype.getQuadrant = function getQuadrant() {
  return this._quadrant;
};
EdgeEnd.prototype.getNode = function getNode() {
  return this._node;
};
EdgeEnd.prototype.toString = function toString14() {
  var angle4 = Math.atan2(this._dy, this._dx);
  var className = this.getClass().getName();
  var lastDotPos = className.lastIndexOf(".");
  var name2 = className.substring(lastDotPos + 1);
  return "  " + name2 + ": " + this._p0 + " - " + this._p1 + " " + this._quadrant + ":" + angle4 + "   " + this._label;
};
EdgeEnd.prototype.computeLabel = function computeLabel(boundaryNodeRule) {
};
EdgeEnd.prototype.init = function init5(p0, p1) {
  this._p0 = p0;
  this._p1 = p1;
  this._dx = p1.x - p0.x;
  this._dy = p1.y - p0.y;
  this._quadrant = Quadrant.quadrant(this._dx, this._dy);
  Assert.isTrue(!(this._dx === 0 && this._dy === 0), "EdgeEnd with identical endpoints found");
};
EdgeEnd.prototype.interfaces_ = function interfaces_57() {
  return [Comparable];
};
EdgeEnd.prototype.getClass = function getClass56() {
  return EdgeEnd;
};
var DirectedEdge = function(EdgeEnd$$1) {
  function DirectedEdge2() {
    var edge = arguments[0];
    var isForward = arguments[1];
    EdgeEnd$$1.call(this, edge);
    this._isForward = null;
    this._isInResult = false;
    this._isVisited = false;
    this._sym = null;
    this._next = null;
    this._nextMin = null;
    this._edgeRing = null;
    this._minEdgeRing = null;
    this._depth = [0, -999, -999];
    this._isForward = isForward;
    if (isForward) {
      this.init(edge.getCoordinate(0), edge.getCoordinate(1));
    } else {
      var n2 = edge.getNumPoints() - 1;
      this.init(edge.getCoordinate(n2), edge.getCoordinate(n2 - 1));
    }
    this.computeDirectedLabel();
  }
  if (EdgeEnd$$1)
    DirectedEdge2.__proto__ = EdgeEnd$$1;
  DirectedEdge2.prototype = Object.create(EdgeEnd$$1 && EdgeEnd$$1.prototype);
  DirectedEdge2.prototype.constructor = DirectedEdge2;
  DirectedEdge2.prototype.getNextMin = function getNextMin() {
    return this._nextMin;
  };
  DirectedEdge2.prototype.getDepth = function getDepth3(position) {
    return this._depth[position];
  };
  DirectedEdge2.prototype.setVisited = function setVisited2(isVisited2) {
    this._isVisited = isVisited2;
  };
  DirectedEdge2.prototype.computeDirectedLabel = function computeDirectedLabel() {
    this._label = new Label(this._edge.getLabel());
    if (!this._isForward) {
      this._label.flip();
    }
  };
  DirectedEdge2.prototype.getNext = function getNext() {
    return this._next;
  };
  DirectedEdge2.prototype.setDepth = function setDepth2(position, depthVal) {
    if (this._depth[position] !== -999) {
      if (this._depth[position] !== depthVal) {
        throw new TopologyException("assigned depths do not match", this.getCoordinate());
      }
    }
    this._depth[position] = depthVal;
  };
  DirectedEdge2.prototype.isInteriorAreaEdge = function isInteriorAreaEdge() {
    var this$1$1 = this;
    var isInteriorAreaEdge2 = true;
    for (var i2 = 0; i2 < 2; i2++) {
      if (!(this$1$1._label.isArea(i2) && this$1$1._label.getLocation(i2, Position.LEFT) === Location.INTERIOR && this$1$1._label.getLocation(i2, Position.RIGHT) === Location.INTERIOR)) {
        isInteriorAreaEdge2 = false;
      }
    }
    return isInteriorAreaEdge2;
  };
  DirectedEdge2.prototype.setNextMin = function setNextMin(nextMin) {
    this._nextMin = nextMin;
  };
  DirectedEdge2.prototype.print = function print9(out) {
    EdgeEnd$$1.prototype.print.call(this, out);
    out.print(" " + this._depth[Position.LEFT] + "/" + this._depth[Position.RIGHT]);
    out.print(" (" + this.getDepthDelta() + ")");
    if (this._isInResult) {
      out.print(" inResult");
    }
  };
  DirectedEdge2.prototype.setMinEdgeRing = function setMinEdgeRing(minEdgeRing) {
    this._minEdgeRing = minEdgeRing;
  };
  DirectedEdge2.prototype.isLineEdge = function isLineEdge() {
    var isLine3 = this._label.isLine(0) || this._label.isLine(1);
    var isExteriorIfArea0 = !this._label.isArea(0) || this._label.allPositionsEqual(0, Location.EXTERIOR);
    var isExteriorIfArea1 = !this._label.isArea(1) || this._label.allPositionsEqual(1, Location.EXTERIOR);
    return isLine3 && isExteriorIfArea0 && isExteriorIfArea1;
  };
  DirectedEdge2.prototype.setEdgeRing = function setEdgeRing(edgeRing) {
    this._edgeRing = edgeRing;
  };
  DirectedEdge2.prototype.getMinEdgeRing = function getMinEdgeRing() {
    return this._minEdgeRing;
  };
  DirectedEdge2.prototype.getDepthDelta = function getDepthDelta() {
    var depthDelta2 = this._edge.getDepthDelta();
    if (!this._isForward) {
      depthDelta2 = -depthDelta2;
    }
    return depthDelta2;
  };
  DirectedEdge2.prototype.setInResult = function setInResult3(isInResult2) {
    this._isInResult = isInResult2;
  };
  DirectedEdge2.prototype.getSym = function getSym() {
    return this._sym;
  };
  DirectedEdge2.prototype.isForward = function isForward() {
    return this._isForward;
  };
  DirectedEdge2.prototype.getEdge = function getEdge4() {
    return this._edge;
  };
  DirectedEdge2.prototype.printEdge = function printEdge(out) {
    this.print(out);
    out.print(" ");
    if (this._isForward) {
      this._edge.print(out);
    } else {
      this._edge.printReverse(out);
    }
  };
  DirectedEdge2.prototype.setSym = function setSym(de) {
    this._sym = de;
  };
  DirectedEdge2.prototype.setVisitedEdge = function setVisitedEdge(isVisited2) {
    this.setVisited(isVisited2);
    this._sym.setVisited(isVisited2);
  };
  DirectedEdge2.prototype.setEdgeDepths = function setEdgeDepths(position, depth2) {
    var depthDelta2 = this.getEdge().getDepthDelta();
    if (!this._isForward) {
      depthDelta2 = -depthDelta2;
    }
    var directionFactor = 1;
    if (position === Position.LEFT) {
      directionFactor = -1;
    }
    var oppositePos = Position.opposite(position);
    var delta = depthDelta2 * directionFactor;
    var oppositeDepth = depth2 + delta;
    this.setDepth(position, depth2);
    this.setDepth(oppositePos, oppositeDepth);
  };
  DirectedEdge2.prototype.getEdgeRing = function getEdgeRing() {
    return this._edgeRing;
  };
  DirectedEdge2.prototype.isInResult = function isInResult2() {
    return this._isInResult;
  };
  DirectedEdge2.prototype.setNext = function setNext(next5) {
    this._next = next5;
  };
  DirectedEdge2.prototype.isVisited = function isVisited2() {
    return this._isVisited;
  };
  DirectedEdge2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  DirectedEdge2.prototype.getClass = function getClass169() {
    return DirectedEdge2;
  };
  DirectedEdge2.depthFactor = function depthFactor(currLocation, nextLocation) {
    if (currLocation === Location.EXTERIOR && nextLocation === Location.INTERIOR) {
      return 1;
    } else if (currLocation === Location.INTERIOR && nextLocation === Location.EXTERIOR) {
      return -1;
    }
    return 0;
  };
  return DirectedEdge2;
}(EdgeEnd);
var NodeFactory = function NodeFactory2() {
};
NodeFactory.prototype.createNode = function createNode2(coord) {
  return new Node$2(coord, null);
};
NodeFactory.prototype.interfaces_ = function interfaces_58() {
  return [];
};
NodeFactory.prototype.getClass = function getClass57() {
  return NodeFactory;
};
var PlanarGraph = function PlanarGraph2() {
  this._edges = new ArrayList();
  this._nodes = null;
  this._edgeEndList = new ArrayList();
  if (arguments.length === 0) {
    this._nodes = new NodeMap(new NodeFactory());
  } else if (arguments.length === 1) {
    var nodeFact = arguments[0];
    this._nodes = new NodeMap(nodeFact);
  }
};
PlanarGraph.prototype.printEdges = function printEdges(out) {
  var this$1$1 = this;
  out.println("Edges:");
  for (var i2 = 0; i2 < this._edges.size(); i2++) {
    out.println("edge " + i2 + ":");
    var e3 = this$1$1._edges.get(i2);
    e3.print(out);
    e3.eiList.print(out);
  }
};
PlanarGraph.prototype.find = function find2(coord) {
  return this._nodes.find(coord);
};
PlanarGraph.prototype.addNode = function addNode2() {
  if (arguments[0] instanceof Node$2) {
    var node = arguments[0];
    return this._nodes.addNode(node);
  } else if (arguments[0] instanceof Coordinate) {
    var coord = arguments[0];
    return this._nodes.addNode(coord);
  }
};
PlanarGraph.prototype.getNodeIterator = function getNodeIterator() {
  return this._nodes.iterator();
};
PlanarGraph.prototype.linkResultDirectedEdges = function linkResultDirectedEdges() {
  for (var nodeit = this._nodes.iterator(); nodeit.hasNext(); ) {
    var node = nodeit.next();
    node.getEdges().linkResultDirectedEdges();
  }
};
PlanarGraph.prototype.debugPrintln = function debugPrintln(o2) {
  System.out.println(o2);
};
PlanarGraph.prototype.isBoundaryNode = function isBoundaryNode(geomIndex, coord) {
  var node = this._nodes.find(coord);
  if (node === null) {
    return false;
  }
  var label = node.getLabel();
  if (label !== null && label.getLocation(geomIndex) === Location.BOUNDARY) {
    return true;
  }
  return false;
};
PlanarGraph.prototype.linkAllDirectedEdges = function linkAllDirectedEdges() {
  for (var nodeit = this._nodes.iterator(); nodeit.hasNext(); ) {
    var node = nodeit.next();
    node.getEdges().linkAllDirectedEdges();
  }
};
PlanarGraph.prototype.matchInSameDirection = function matchInSameDirection(p0, p1, ep0, ep1) {
  if (!p0.equals(ep0)) {
    return false;
  }
  if (CGAlgorithms.computeOrientation(p0, p1, ep1) === CGAlgorithms.COLLINEAR && Quadrant.quadrant(p0, p1) === Quadrant.quadrant(ep0, ep1)) {
    return true;
  }
  return false;
};
PlanarGraph.prototype.getEdgeEnds = function getEdgeEnds() {
  return this._edgeEndList;
};
PlanarGraph.prototype.debugPrint = function debugPrint(o2) {
  System.out.print(o2);
};
PlanarGraph.prototype.getEdgeIterator = function getEdgeIterator() {
  return this._edges.iterator();
};
PlanarGraph.prototype.findEdgeInSameDirection = function findEdgeInSameDirection(p0, p1) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this._edges.size(); i2++) {
    var e3 = this$1$1._edges.get(i2);
    var eCoord = e3.getCoordinates();
    if (this$1$1.matchInSameDirection(p0, p1, eCoord[0], eCoord[1])) {
      return e3;
    }
    if (this$1$1.matchInSameDirection(p0, p1, eCoord[eCoord.length - 1], eCoord[eCoord.length - 2])) {
      return e3;
    }
  }
  return null;
};
PlanarGraph.prototype.insertEdge = function insertEdge(e3) {
  this._edges.add(e3);
};
PlanarGraph.prototype.findEdgeEnd = function findEdgeEnd(e3) {
  for (var i2 = this.getEdgeEnds().iterator(); i2.hasNext(); ) {
    var ee = i2.next();
    if (ee.getEdge() === e3) {
      return ee;
    }
  }
  return null;
};
PlanarGraph.prototype.addEdges = function addEdges(edgesToAdd) {
  var this$1$1 = this;
  for (var it = edgesToAdd.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    this$1$1._edges.add(e3);
    var de1 = new DirectedEdge(e3, true);
    var de2 = new DirectedEdge(e3, false);
    de1.setSym(de2);
    de2.setSym(de1);
    this$1$1.add(de1);
    this$1$1.add(de2);
  }
};
PlanarGraph.prototype.add = function add6(e3) {
  this._nodes.add(e3);
  this._edgeEndList.add(e3);
};
PlanarGraph.prototype.getNodes = function getNodes2() {
  return this._nodes.values();
};
PlanarGraph.prototype.findEdge = function findEdge2(p0, p1) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this._edges.size(); i2++) {
    var e3 = this$1$1._edges.get(i2);
    var eCoord = e3.getCoordinates();
    if (p0.equals(eCoord[0]) && p1.equals(eCoord[1])) {
      return e3;
    }
  }
  return null;
};
PlanarGraph.prototype.interfaces_ = function interfaces_59() {
  return [];
};
PlanarGraph.prototype.getClass = function getClass58() {
  return PlanarGraph;
};
PlanarGraph.linkResultDirectedEdges = function linkResultDirectedEdges2(nodes) {
  for (var nodeit = nodes.iterator(); nodeit.hasNext(); ) {
    var node = nodeit.next();
    node.getEdges().linkResultDirectedEdges();
  }
};
var PolygonBuilder = function PolygonBuilder2() {
  this._geometryFactory = null;
  this._shellList = new ArrayList();
  var geometryFactory = arguments[0];
  this._geometryFactory = geometryFactory;
};
PolygonBuilder.prototype.sortShellsAndHoles = function sortShellsAndHoles(edgeRings, shellList, freeHoleList) {
  for (var it = edgeRings.iterator(); it.hasNext(); ) {
    var er = it.next();
    if (er.isHole()) {
      freeHoleList.add(er);
    } else {
      shellList.add(er);
    }
  }
};
PolygonBuilder.prototype.computePolygons = function computePolygons(shellList) {
  var this$1$1 = this;
  var resultPolyList = new ArrayList();
  for (var it = shellList.iterator(); it.hasNext(); ) {
    var er = it.next();
    var poly2 = er.toPolygon(this$1$1._geometryFactory);
    resultPolyList.add(poly2);
  }
  return resultPolyList;
};
PolygonBuilder.prototype.placeFreeHoles = function placeFreeHoles(shellList, freeHoleList) {
  var this$1$1 = this;
  for (var it = freeHoleList.iterator(); it.hasNext(); ) {
    var hole = it.next();
    if (hole.getShell() === null) {
      var shell = this$1$1.findEdgeRingContaining(hole, shellList);
      if (shell === null) {
        throw new TopologyException("unable to assign hole to a shell", hole.getCoordinate(0));
      }
      hole.setShell(shell);
    }
  }
};
PolygonBuilder.prototype.buildMinimalEdgeRings = function buildMinimalEdgeRings(maxEdgeRings, shellList, freeHoleList) {
  var this$1$1 = this;
  var edgeRings = new ArrayList();
  for (var it = maxEdgeRings.iterator(); it.hasNext(); ) {
    var er = it.next();
    if (er.getMaxNodeDegree() > 2) {
      er.linkDirectedEdgesForMinimalEdgeRings();
      var minEdgeRings = er.buildMinimalRings();
      var shell = this$1$1.findShell(minEdgeRings);
      if (shell !== null) {
        this$1$1.placePolygonHoles(shell, minEdgeRings);
        shellList.add(shell);
      } else {
        freeHoleList.addAll(minEdgeRings);
      }
    } else {
      edgeRings.add(er);
    }
  }
  return edgeRings;
};
PolygonBuilder.prototype.containsPoint = function containsPoint2(p2) {
  for (var it = this._shellList.iterator(); it.hasNext(); ) {
    var er = it.next();
    if (er.containsPoint(p2)) {
      return true;
    }
  }
  return false;
};
PolygonBuilder.prototype.buildMaximalEdgeRings = function buildMaximalEdgeRings(dirEdges) {
  var this$1$1 = this;
  var maxEdgeRings = new ArrayList();
  for (var it = dirEdges.iterator(); it.hasNext(); ) {
    var de = it.next();
    if (de.isInResult() && de.getLabel().isArea()) {
      if (de.getEdgeRing() === null) {
        var er = new MaximalEdgeRing(de, this$1$1._geometryFactory);
        maxEdgeRings.add(er);
        er.setInResult();
      }
    }
  }
  return maxEdgeRings;
};
PolygonBuilder.prototype.placePolygonHoles = function placePolygonHoles(shell, minEdgeRings) {
  for (var it = minEdgeRings.iterator(); it.hasNext(); ) {
    var er = it.next();
    if (er.isHole()) {
      er.setShell(shell);
    }
  }
};
PolygonBuilder.prototype.getPolygons = function getPolygons() {
  var resultPolyList = this.computePolygons(this._shellList);
  return resultPolyList;
};
PolygonBuilder.prototype.findEdgeRingContaining = function findEdgeRingContaining(testEr, shellList) {
  var testRing = testEr.getLinearRing();
  var testEnv = testRing.getEnvelopeInternal();
  var testPt = testRing.getCoordinateN(0);
  var minShell = null;
  var minEnv = null;
  for (var it = shellList.iterator(); it.hasNext(); ) {
    var tryShell = it.next();
    var tryRing = tryShell.getLinearRing();
    var tryEnv = tryRing.getEnvelopeInternal();
    if (minShell !== null) {
      minEnv = minShell.getLinearRing().getEnvelopeInternal();
    }
    var isContained = false;
    if (tryEnv.contains(testEnv) && CGAlgorithms.isPointInRing(testPt, tryRing.getCoordinates())) {
      isContained = true;
    }
    if (isContained) {
      if (minShell === null || minEnv.contains(tryEnv)) {
        minShell = tryShell;
      }
    }
  }
  return minShell;
};
PolygonBuilder.prototype.findShell = function findShell(minEdgeRings) {
  var shellCount = 0;
  var shell = null;
  for (var it = minEdgeRings.iterator(); it.hasNext(); ) {
    var er = it.next();
    if (!er.isHole()) {
      shell = er;
      shellCount++;
    }
  }
  Assert.isTrue(shellCount <= 1, "found two shells in MinimalEdgeRing list");
  return shell;
};
PolygonBuilder.prototype.add = function add7() {
  if (arguments.length === 1) {
    var graph = arguments[0];
    this.add(graph.getEdgeEnds(), graph.getNodes());
  } else if (arguments.length === 2) {
    var dirEdges = arguments[0];
    var nodes = arguments[1];
    PlanarGraph.linkResultDirectedEdges(nodes);
    var maxEdgeRings = this.buildMaximalEdgeRings(dirEdges);
    var freeHoleList = new ArrayList();
    var edgeRings = this.buildMinimalEdgeRings(maxEdgeRings, this._shellList, freeHoleList);
    this.sortShellsAndHoles(edgeRings, this._shellList, freeHoleList);
    this.placeFreeHoles(this._shellList, freeHoleList);
  }
};
PolygonBuilder.prototype.interfaces_ = function interfaces_60() {
  return [];
};
PolygonBuilder.prototype.getClass = function getClass59() {
  return PolygonBuilder;
};
var Boundable = function Boundable2() {
};
Boundable.prototype.getBounds = function getBounds2() {
};
Boundable.prototype.interfaces_ = function interfaces_61() {
  return [];
};
Boundable.prototype.getClass = function getClass60() {
  return Boundable;
};
var ItemBoundable = function ItemBoundable2() {
  this._bounds = null;
  this._item = null;
  var bounds = arguments[0];
  var item = arguments[1];
  this._bounds = bounds;
  this._item = item;
};
ItemBoundable.prototype.getItem = function getItem() {
  return this._item;
};
ItemBoundable.prototype.getBounds = function getBounds3() {
  return this._bounds;
};
ItemBoundable.prototype.interfaces_ = function interfaces_62() {
  return [Boundable, Serializable];
};
ItemBoundable.prototype.getClass = function getClass61() {
  return ItemBoundable;
};
var PriorityQueue = function PriorityQueue2() {
  this._size = null;
  this._items = null;
  this._size = 0;
  this._items = new ArrayList();
  this._items.add(null);
};
PriorityQueue.prototype.poll = function poll() {
  if (this.isEmpty()) {
    return null;
  }
  var minItem = this._items.get(1);
  this._items.set(1, this._items.get(this._size));
  this._size -= 1;
  this.reorder(1);
  return minItem;
};
PriorityQueue.prototype.size = function size6() {
  return this._size;
};
PriorityQueue.prototype.reorder = function reorder(hole) {
  var this$1$1 = this;
  var child = null;
  var tmp2 = this._items.get(hole);
  for (; hole * 2 <= this._size; hole = child) {
    child = hole * 2;
    if (child !== this$1$1._size && this$1$1._items.get(child + 1).compareTo(this$1$1._items.get(child)) < 0) {
      child++;
    }
    if (this$1$1._items.get(child).compareTo(tmp2) < 0) {
      this$1$1._items.set(hole, this$1$1._items.get(child));
    } else {
      break;
    }
  }
  this._items.set(hole, tmp2);
};
PriorityQueue.prototype.clear = function clear2() {
  this._size = 0;
  this._items.clear();
};
PriorityQueue.prototype.isEmpty = function isEmpty3() {
  return this._size === 0;
};
PriorityQueue.prototype.add = function add8(x2) {
  var this$1$1 = this;
  this._items.add(null);
  this._size += 1;
  var hole = this._size;
  this._items.set(0, x2);
  for (; x2.compareTo(this._items.get(Math.trunc(hole / 2))) < 0; hole /= 2) {
    this$1$1._items.set(hole, this$1$1._items.get(Math.trunc(hole / 2)));
  }
  this._items.set(hole, x2);
};
PriorityQueue.prototype.interfaces_ = function interfaces_63() {
  return [];
};
PriorityQueue.prototype.getClass = function getClass62() {
  return PriorityQueue;
};
var ItemVisitor = function ItemVisitor2() {
};
ItemVisitor.prototype.visitItem = function visitItem(item) {
};
ItemVisitor.prototype.interfaces_ = function interfaces_64() {
  return [];
};
ItemVisitor.prototype.getClass = function getClass63() {
  return ItemVisitor;
};
var SpatialIndex = function SpatialIndex2() {
};
SpatialIndex.prototype.insert = function insert(itemEnv, item) {
};
SpatialIndex.prototype.remove = function remove3(itemEnv, item) {
};
SpatialIndex.prototype.query = function query2() {
};
SpatialIndex.prototype.interfaces_ = function interfaces_65() {
  return [];
};
SpatialIndex.prototype.getClass = function getClass64() {
  return SpatialIndex;
};
var AbstractNode = function AbstractNode2() {
  this._childBoundables = new ArrayList();
  this._bounds = null;
  this._level = null;
  if (arguments.length === 0)
    ;
  else if (arguments.length === 1) {
    var level = arguments[0];
    this._level = level;
  }
};
var staticAccessors$22 = { serialVersionUID: { configurable: true } };
AbstractNode.prototype.getLevel = function getLevel() {
  return this._level;
};
AbstractNode.prototype.size = function size7() {
  return this._childBoundables.size();
};
AbstractNode.prototype.getChildBoundables = function getChildBoundables() {
  return this._childBoundables;
};
AbstractNode.prototype.addChildBoundable = function addChildBoundable(childBoundable) {
  Assert.isTrue(this._bounds === null);
  this._childBoundables.add(childBoundable);
};
AbstractNode.prototype.isEmpty = function isEmpty4() {
  return this._childBoundables.isEmpty();
};
AbstractNode.prototype.getBounds = function getBounds4() {
  if (this._bounds === null) {
    this._bounds = this.computeBounds();
  }
  return this._bounds;
};
AbstractNode.prototype.interfaces_ = function interfaces_66() {
  return [Boundable, Serializable];
};
AbstractNode.prototype.getClass = function getClass65() {
  return AbstractNode;
};
staticAccessors$22.serialVersionUID.get = function() {
  return 6493722185909574e3;
};
Object.defineProperties(AbstractNode, staticAccessors$22);
var Collections = function Collections2() {
};
Collections.reverseOrder = function reverseOrder() {
  return {
    compare: function compare12(a2, b2) {
      return b2.compareTo(a2);
    }
  };
};
Collections.min = function min3(l2) {
  Collections.sort(l2);
  return l2.get(0);
};
Collections.sort = function sort2(l2, c2) {
  var a2 = l2.toArray();
  if (c2) {
    Arrays.sort(a2, c2);
  } else {
    Arrays.sort(a2);
  }
  var i2 = l2.iterator();
  for (var pos = 0, alen = a2.length; pos < alen; pos++) {
    i2.next();
    i2.set(a2[pos]);
  }
};
Collections.singletonList = function singletonList(o2) {
  var arrayList = new ArrayList();
  arrayList.add(o2);
  return arrayList;
};
var BoundablePair = function BoundablePair2() {
  this._boundable1 = null;
  this._boundable2 = null;
  this._distance = null;
  this._itemDistance = null;
  var boundable1 = arguments[0];
  var boundable2 = arguments[1];
  var itemDistance = arguments[2];
  this._boundable1 = boundable1;
  this._boundable2 = boundable2;
  this._itemDistance = itemDistance;
  this._distance = this.distance();
};
BoundablePair.prototype.expandToQueue = function expandToQueue(priQ, minDistance) {
  var isComp1 = BoundablePair.isComposite(this._boundable1);
  var isComp2 = BoundablePair.isComposite(this._boundable2);
  if (isComp1 && isComp2) {
    if (BoundablePair.area(this._boundable1) > BoundablePair.area(this._boundable2)) {
      this.expand(this._boundable1, this._boundable2, priQ, minDistance);
      return null;
    } else {
      this.expand(this._boundable2, this._boundable1, priQ, minDistance);
      return null;
    }
  } else if (isComp1) {
    this.expand(this._boundable1, this._boundable2, priQ, minDistance);
    return null;
  } else if (isComp2) {
    this.expand(this._boundable2, this._boundable1, priQ, minDistance);
    return null;
  }
  throw new IllegalArgumentException("neither boundable is composite");
};
BoundablePair.prototype.isLeaves = function isLeaves() {
  return !(BoundablePair.isComposite(this._boundable1) || BoundablePair.isComposite(this._boundable2));
};
BoundablePair.prototype.compareTo = function compareTo9(o2) {
  var nd = o2;
  if (this._distance < nd._distance) {
    return -1;
  }
  if (this._distance > nd._distance) {
    return 1;
  }
  return 0;
};
BoundablePair.prototype.expand = function expand(bndComposite, bndOther, priQ, minDistance) {
  var this$1$1 = this;
  var children = bndComposite.getChildBoundables();
  for (var i2 = children.iterator(); i2.hasNext(); ) {
    var child = i2.next();
    var bp2 = new BoundablePair(child, bndOther, this$1$1._itemDistance);
    if (bp2.getDistance() < minDistance) {
      priQ.add(bp2);
    }
  }
};
BoundablePair.prototype.getBoundable = function getBoundable(i2) {
  if (i2 === 0) {
    return this._boundable1;
  }
  return this._boundable2;
};
BoundablePair.prototype.getDistance = function getDistance() {
  return this._distance;
};
BoundablePair.prototype.distance = function distance4() {
  if (this.isLeaves()) {
    return this._itemDistance.distance(this._boundable1, this._boundable2);
  }
  return this._boundable1.getBounds().distance(this._boundable2.getBounds());
};
BoundablePair.prototype.interfaces_ = function interfaces_67() {
  return [Comparable];
};
BoundablePair.prototype.getClass = function getClass66() {
  return BoundablePair;
};
BoundablePair.area = function area2(b2) {
  return b2.getBounds().getArea();
};
BoundablePair.isComposite = function isComposite(item) {
  return item instanceof AbstractNode;
};
var AbstractSTRtree = function AbstractSTRtree2() {
  this._root = null;
  this._built = false;
  this._itemBoundables = new ArrayList();
  this._nodeCapacity = null;
  if (arguments.length === 0) {
    var nodeCapacity = AbstractSTRtree2.DEFAULT_NODE_CAPACITY;
    this._nodeCapacity = nodeCapacity;
  } else if (arguments.length === 1) {
    var nodeCapacity$1 = arguments[0];
    Assert.isTrue(nodeCapacity$1 > 1, "Node capacity must be greater than 1");
    this._nodeCapacity = nodeCapacity$1;
  }
};
var staticAccessors$23 = { IntersectsOp: { configurable: true }, serialVersionUID: { configurable: true }, DEFAULT_NODE_CAPACITY: { configurable: true } };
AbstractSTRtree.prototype.getNodeCapacity = function getNodeCapacity() {
  return this._nodeCapacity;
};
AbstractSTRtree.prototype.lastNode = function lastNode(nodes) {
  return nodes.get(nodes.size() - 1);
};
AbstractSTRtree.prototype.size = function size8() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    if (this.isEmpty()) {
      return 0;
    }
    this.build();
    return this.size(this._root);
  } else if (arguments.length === 1) {
    var node = arguments[0];
    var size12 = 0;
    for (var i2 = node.getChildBoundables().iterator(); i2.hasNext(); ) {
      var childBoundable = i2.next();
      if (childBoundable instanceof AbstractNode) {
        size12 += this$1$1.size(childBoundable);
      } else if (childBoundable instanceof ItemBoundable) {
        size12 += 1;
      }
    }
    return size12;
  }
};
AbstractSTRtree.prototype.removeItem = function removeItem(node, item) {
  var childToRemove = null;
  for (var i2 = node.getChildBoundables().iterator(); i2.hasNext(); ) {
    var childBoundable = i2.next();
    if (childBoundable instanceof ItemBoundable) {
      if (childBoundable.getItem() === item) {
        childToRemove = childBoundable;
      }
    }
  }
  if (childToRemove !== null) {
    node.getChildBoundables().remove(childToRemove);
    return true;
  }
  return false;
};
AbstractSTRtree.prototype.itemsTree = function itemsTree() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    this.build();
    var valuesTree = this.itemsTree(this._root);
    if (valuesTree === null) {
      return new ArrayList();
    }
    return valuesTree;
  } else if (arguments.length === 1) {
    var node = arguments[0];
    var valuesTreeForNode = new ArrayList();
    for (var i2 = node.getChildBoundables().iterator(); i2.hasNext(); ) {
      var childBoundable = i2.next();
      if (childBoundable instanceof AbstractNode) {
        var valuesTreeForChild = this$1$1.itemsTree(childBoundable);
        if (valuesTreeForChild !== null) {
          valuesTreeForNode.add(valuesTreeForChild);
        }
      } else if (childBoundable instanceof ItemBoundable) {
        valuesTreeForNode.add(childBoundable.getItem());
      } else {
        Assert.shouldNeverReachHere();
      }
    }
    if (valuesTreeForNode.size() <= 0) {
      return null;
    }
    return valuesTreeForNode;
  }
};
AbstractSTRtree.prototype.insert = function insert2(bounds, item) {
  Assert.isTrue(!this._built, "Cannot insert items into an STR packed R-tree after it has been built.");
  this._itemBoundables.add(new ItemBoundable(bounds, item));
};
AbstractSTRtree.prototype.boundablesAtLevel = function boundablesAtLevel() {
  var this$1$1 = this;
  if (arguments.length === 1) {
    var level = arguments[0];
    var boundables = new ArrayList();
    this.boundablesAtLevel(level, this._root, boundables);
    return boundables;
  } else if (arguments.length === 3) {
    var level$1 = arguments[0];
    var top = arguments[1];
    var boundables$1 = arguments[2];
    Assert.isTrue(level$1 > -2);
    if (top.getLevel() === level$1) {
      boundables$1.add(top);
      return null;
    }
    for (var i2 = top.getChildBoundables().iterator(); i2.hasNext(); ) {
      var boundable = i2.next();
      if (boundable instanceof AbstractNode) {
        this$1$1.boundablesAtLevel(level$1, boundable, boundables$1);
      } else {
        Assert.isTrue(boundable instanceof ItemBoundable);
        if (level$1 === -1) {
          boundables$1.add(boundable);
        }
      }
    }
    return null;
  }
};
AbstractSTRtree.prototype.query = function query3() {
  var this$1$1 = this;
  if (arguments.length === 1) {
    var searchBounds = arguments[0];
    this.build();
    var matches2 = new ArrayList();
    if (this.isEmpty()) {
      return matches2;
    }
    if (this.getIntersectsOp().intersects(this._root.getBounds(), searchBounds)) {
      this.query(searchBounds, this._root, matches2);
    }
    return matches2;
  } else if (arguments.length === 2) {
    var searchBounds$1 = arguments[0];
    var visitor = arguments[1];
    this.build();
    if (this.isEmpty()) {
      return null;
    }
    if (this.getIntersectsOp().intersects(this._root.getBounds(), searchBounds$1)) {
      this.query(searchBounds$1, this._root, visitor);
    }
  } else if (arguments.length === 3) {
    if (hasInterface(arguments[2], ItemVisitor) && (arguments[0] instanceof Object && arguments[1] instanceof AbstractNode)) {
      var searchBounds$2 = arguments[0];
      var node = arguments[1];
      var visitor$1 = arguments[2];
      var childBoundables = node.getChildBoundables();
      for (var i2 = 0; i2 < childBoundables.size(); i2++) {
        var childBoundable = childBoundables.get(i2);
        if (!this$1$1.getIntersectsOp().intersects(childBoundable.getBounds(), searchBounds$2)) {
          continue;
        }
        if (childBoundable instanceof AbstractNode) {
          this$1$1.query(searchBounds$2, childBoundable, visitor$1);
        } else if (childBoundable instanceof ItemBoundable) {
          visitor$1.visitItem(childBoundable.getItem());
        } else {
          Assert.shouldNeverReachHere();
        }
      }
    } else if (hasInterface(arguments[2], List$2) && (arguments[0] instanceof Object && arguments[1] instanceof AbstractNode)) {
      var searchBounds$3 = arguments[0];
      var node$1 = arguments[1];
      var matches$12 = arguments[2];
      var childBoundables$1 = node$1.getChildBoundables();
      for (var i$12 = 0; i$12 < childBoundables$1.size(); i$12++) {
        var childBoundable$1 = childBoundables$1.get(i$12);
        if (!this$1$1.getIntersectsOp().intersects(childBoundable$1.getBounds(), searchBounds$3)) {
          continue;
        }
        if (childBoundable$1 instanceof AbstractNode) {
          this$1$1.query(searchBounds$3, childBoundable$1, matches$12);
        } else if (childBoundable$1 instanceof ItemBoundable) {
          matches$12.add(childBoundable$1.getItem());
        } else {
          Assert.shouldNeverReachHere();
        }
      }
    }
  }
};
AbstractSTRtree.prototype.build = function build2() {
  if (this._built) {
    return null;
  }
  this._root = this._itemBoundables.isEmpty() ? this.createNode(0) : this.createHigherLevels(this._itemBoundables, -1);
  this._itemBoundables = null;
  this._built = true;
};
AbstractSTRtree.prototype.getRoot = function getRoot() {
  this.build();
  return this._root;
};
AbstractSTRtree.prototype.remove = function remove4() {
  var this$1$1 = this;
  if (arguments.length === 2) {
    var searchBounds = arguments[0];
    var item = arguments[1];
    this.build();
    if (this.getIntersectsOp().intersects(this._root.getBounds(), searchBounds)) {
      return this.remove(searchBounds, this._root, item);
    }
    return false;
  } else if (arguments.length === 3) {
    var searchBounds$1 = arguments[0];
    var node = arguments[1];
    var item$1 = arguments[2];
    var found = this.removeItem(node, item$1);
    if (found) {
      return true;
    }
    var childToPrune = null;
    for (var i2 = node.getChildBoundables().iterator(); i2.hasNext(); ) {
      var childBoundable = i2.next();
      if (!this$1$1.getIntersectsOp().intersects(childBoundable.getBounds(), searchBounds$1)) {
        continue;
      }
      if (childBoundable instanceof AbstractNode) {
        found = this$1$1.remove(searchBounds$1, childBoundable, item$1);
        if (found) {
          childToPrune = childBoundable;
          break;
        }
      }
    }
    if (childToPrune !== null) {
      if (childToPrune.getChildBoundables().isEmpty()) {
        node.getChildBoundables().remove(childToPrune);
      }
    }
    return found;
  }
};
AbstractSTRtree.prototype.createHigherLevels = function createHigherLevels(boundablesOfALevel, level) {
  Assert.isTrue(!boundablesOfALevel.isEmpty());
  var parentBoundables = this.createParentBoundables(boundablesOfALevel, level + 1);
  if (parentBoundables.size() === 1) {
    return parentBoundables.get(0);
  }
  return this.createHigherLevels(parentBoundables, level + 1);
};
AbstractSTRtree.prototype.depth = function depth() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    if (this.isEmpty()) {
      return 0;
    }
    this.build();
    return this.depth(this._root);
  } else if (arguments.length === 1) {
    var node = arguments[0];
    var maxChildDepth = 0;
    for (var i2 = node.getChildBoundables().iterator(); i2.hasNext(); ) {
      var childBoundable = i2.next();
      if (childBoundable instanceof AbstractNode) {
        var childDepth = this$1$1.depth(childBoundable);
        if (childDepth > maxChildDepth) {
          maxChildDepth = childDepth;
        }
      }
    }
    return maxChildDepth + 1;
  }
};
AbstractSTRtree.prototype.createParentBoundables = function createParentBoundables(childBoundables, newLevel) {
  var this$1$1 = this;
  Assert.isTrue(!childBoundables.isEmpty());
  var parentBoundables = new ArrayList();
  parentBoundables.add(this.createNode(newLevel));
  var sortedChildBoundables = new ArrayList(childBoundables);
  Collections.sort(sortedChildBoundables, this.getComparator());
  for (var i2 = sortedChildBoundables.iterator(); i2.hasNext(); ) {
    var childBoundable = i2.next();
    if (this$1$1.lastNode(parentBoundables).getChildBoundables().size() === this$1$1.getNodeCapacity()) {
      parentBoundables.add(this$1$1.createNode(newLevel));
    }
    this$1$1.lastNode(parentBoundables).addChildBoundable(childBoundable);
  }
  return parentBoundables;
};
AbstractSTRtree.prototype.isEmpty = function isEmpty5() {
  if (!this._built) {
    return this._itemBoundables.isEmpty();
  }
  return this._root.isEmpty();
};
AbstractSTRtree.prototype.interfaces_ = function interfaces_68() {
  return [Serializable];
};
AbstractSTRtree.prototype.getClass = function getClass67() {
  return AbstractSTRtree;
};
AbstractSTRtree.compareDoubles = function compareDoubles(a2, b2) {
  return a2 > b2 ? 1 : a2 < b2 ? -1 : 0;
};
staticAccessors$23.IntersectsOp.get = function() {
  return IntersectsOp;
};
staticAccessors$23.serialVersionUID.get = function() {
  return -3886435814360241e3;
};
staticAccessors$23.DEFAULT_NODE_CAPACITY.get = function() {
  return 10;
};
Object.defineProperties(AbstractSTRtree, staticAccessors$23);
var IntersectsOp = function IntersectsOp2() {
};
var ItemDistance = function ItemDistance2() {
};
ItemDistance.prototype.distance = function distance5(item1, item2) {
};
ItemDistance.prototype.interfaces_ = function interfaces_69() {
  return [];
};
ItemDistance.prototype.getClass = function getClass68() {
  return ItemDistance;
};
var STRtree = function(AbstractSTRtree$$1) {
  function STRtree2(nodeCapacity) {
    nodeCapacity = nodeCapacity || STRtree2.DEFAULT_NODE_CAPACITY;
    AbstractSTRtree$$1.call(this, nodeCapacity);
  }
  if (AbstractSTRtree$$1)
    STRtree2.__proto__ = AbstractSTRtree$$1;
  STRtree2.prototype = Object.create(AbstractSTRtree$$1 && AbstractSTRtree$$1.prototype);
  STRtree2.prototype.constructor = STRtree2;
  var staticAccessors2 = { STRtreeNode: { configurable: true }, serialVersionUID: { configurable: true }, xComparator: { configurable: true }, yComparator: { configurable: true }, intersectsOp: { configurable: true }, DEFAULT_NODE_CAPACITY: { configurable: true } };
  STRtree2.prototype.createParentBoundablesFromVerticalSlices = function createParentBoundablesFromVerticalSlices(verticalSlices, newLevel) {
    var this$1$1 = this;
    Assert.isTrue(verticalSlices.length > 0);
    var parentBoundables = new ArrayList();
    for (var i2 = 0; i2 < verticalSlices.length; i2++) {
      parentBoundables.addAll(this$1$1.createParentBoundablesFromVerticalSlice(verticalSlices[i2], newLevel));
    }
    return parentBoundables;
  };
  STRtree2.prototype.createNode = function createNode3(level) {
    return new STRtreeNode(level);
  };
  STRtree2.prototype.size = function size12() {
    if (arguments.length === 0) {
      return AbstractSTRtree$$1.prototype.size.call(this);
    } else {
      return AbstractSTRtree$$1.prototype.size.apply(this, arguments);
    }
  };
  STRtree2.prototype.insert = function insert4() {
    if (arguments.length === 2) {
      var itemEnv = arguments[0];
      var item = arguments[1];
      if (itemEnv.isNull()) {
        return null;
      }
      AbstractSTRtree$$1.prototype.insert.call(this, itemEnv, item);
    } else {
      return AbstractSTRtree$$1.prototype.insert.apply(this, arguments);
    }
  };
  STRtree2.prototype.getIntersectsOp = function getIntersectsOp() {
    return STRtree2.intersectsOp;
  };
  STRtree2.prototype.verticalSlices = function verticalSlices(childBoundables, sliceCount) {
    var sliceCapacity = Math.trunc(Math.ceil(childBoundables.size() / sliceCount));
    var slices = new Array(sliceCount).fill(null);
    var i2 = childBoundables.iterator();
    for (var j2 = 0; j2 < sliceCount; j2++) {
      slices[j2] = new ArrayList();
      var boundablesAddedToSlice = 0;
      while (i2.hasNext() && boundablesAddedToSlice < sliceCapacity) {
        var childBoundable = i2.next();
        slices[j2].add(childBoundable);
        boundablesAddedToSlice++;
      }
    }
    return slices;
  };
  STRtree2.prototype.query = function query6() {
    if (arguments.length === 1) {
      var searchEnv = arguments[0];
      return AbstractSTRtree$$1.prototype.query.call(this, searchEnv);
    } else if (arguments.length === 2) {
      var searchEnv$1 = arguments[0];
      var visitor = arguments[1];
      AbstractSTRtree$$1.prototype.query.call(this, searchEnv$1, visitor);
    } else if (arguments.length === 3) {
      if (hasInterface(arguments[2], ItemVisitor) && (arguments[0] instanceof Object && arguments[1] instanceof AbstractNode)) {
        var searchBounds = arguments[0];
        var node = arguments[1];
        var visitor$1 = arguments[2];
        AbstractSTRtree$$1.prototype.query.call(this, searchBounds, node, visitor$1);
      } else if (hasInterface(arguments[2], List$2) && (arguments[0] instanceof Object && arguments[1] instanceof AbstractNode)) {
        var searchBounds$1 = arguments[0];
        var node$1 = arguments[1];
        var matches2 = arguments[2];
        AbstractSTRtree$$1.prototype.query.call(this, searchBounds$1, node$1, matches2);
      }
    }
  };
  STRtree2.prototype.getComparator = function getComparator() {
    return STRtree2.yComparator;
  };
  STRtree2.prototype.createParentBoundablesFromVerticalSlice = function createParentBoundablesFromVerticalSlice(childBoundables, newLevel) {
    return AbstractSTRtree$$1.prototype.createParentBoundables.call(this, childBoundables, newLevel);
  };
  STRtree2.prototype.remove = function remove6() {
    if (arguments.length === 2) {
      var itemEnv = arguments[0];
      var item = arguments[1];
      return AbstractSTRtree$$1.prototype.remove.call(this, itemEnv, item);
    } else {
      return AbstractSTRtree$$1.prototype.remove.apply(this, arguments);
    }
  };
  STRtree2.prototype.depth = function depth2() {
    if (arguments.length === 0) {
      return AbstractSTRtree$$1.prototype.depth.call(this);
    } else {
      return AbstractSTRtree$$1.prototype.depth.apply(this, arguments);
    }
  };
  STRtree2.prototype.createParentBoundables = function createParentBoundables2(childBoundables, newLevel) {
    Assert.isTrue(!childBoundables.isEmpty());
    var minLeafCount = Math.trunc(Math.ceil(childBoundables.size() / this.getNodeCapacity()));
    var sortedChildBoundables = new ArrayList(childBoundables);
    Collections.sort(sortedChildBoundables, STRtree2.xComparator);
    var verticalSlices = this.verticalSlices(sortedChildBoundables, Math.trunc(Math.ceil(Math.sqrt(minLeafCount))));
    return this.createParentBoundablesFromVerticalSlices(verticalSlices, newLevel);
  };
  STRtree2.prototype.nearestNeighbour = function nearestNeighbour() {
    if (arguments.length === 1) {
      if (hasInterface(arguments[0], ItemDistance)) {
        var itemDist = arguments[0];
        var bp2 = new BoundablePair(this.getRoot(), this.getRoot(), itemDist);
        return this.nearestNeighbour(bp2);
      } else if (arguments[0] instanceof BoundablePair) {
        var initBndPair = arguments[0];
        return this.nearestNeighbour(initBndPair, Double.POSITIVE_INFINITY);
      }
    } else if (arguments.length === 2) {
      if (arguments[0] instanceof STRtree2 && hasInterface(arguments[1], ItemDistance)) {
        var tree = arguments[0];
        var itemDist$1 = arguments[1];
        var bp$1 = new BoundablePair(this.getRoot(), tree.getRoot(), itemDist$1);
        return this.nearestNeighbour(bp$1);
      } else if (arguments[0] instanceof BoundablePair && typeof arguments[1] === "number") {
        var initBndPair$1 = arguments[0];
        var maxDistance = arguments[1];
        var distanceLowerBound = maxDistance;
        var minPair = null;
        var priQ = new PriorityQueue();
        priQ.add(initBndPair$1);
        while (!priQ.isEmpty() && distanceLowerBound > 0) {
          var bndPair = priQ.poll();
          var currentDistance = bndPair.getDistance();
          if (currentDistance >= distanceLowerBound) {
            break;
          }
          if (bndPair.isLeaves()) {
            distanceLowerBound = currentDistance;
            minPair = bndPair;
          } else {
            bndPair.expandToQueue(priQ, distanceLowerBound);
          }
        }
        return [minPair.getBoundable(0).getItem(), minPair.getBoundable(1).getItem()];
      }
    } else if (arguments.length === 3) {
      var env = arguments[0];
      var item = arguments[1];
      var itemDist$2 = arguments[2];
      var bnd = new ItemBoundable(env, item);
      var bp$2 = new BoundablePair(this.getRoot(), bnd, itemDist$2);
      return this.nearestNeighbour(bp$2)[0];
    }
  };
  STRtree2.prototype.interfaces_ = function interfaces_170() {
    return [SpatialIndex, Serializable];
  };
  STRtree2.prototype.getClass = function getClass169() {
    return STRtree2;
  };
  STRtree2.centreX = function centreX(e3) {
    return STRtree2.avg(e3.getMinX(), e3.getMaxX());
  };
  STRtree2.avg = function avg(a2, b2) {
    return (a2 + b2) / 2;
  };
  STRtree2.centreY = function centreY(e3) {
    return STRtree2.avg(e3.getMinY(), e3.getMaxY());
  };
  staticAccessors2.STRtreeNode.get = function() {
    return STRtreeNode;
  };
  staticAccessors2.serialVersionUID.get = function() {
    return 259274702368956900;
  };
  staticAccessors2.xComparator.get = function() {
    return {
      interfaces_: function() {
        return [Comparator];
      },
      compare: function(o1, o2) {
        return AbstractSTRtree$$1.compareDoubles(STRtree2.centreX(o1.getBounds()), STRtree2.centreX(o2.getBounds()));
      }
    };
  };
  staticAccessors2.yComparator.get = function() {
    return {
      interfaces_: function() {
        return [Comparator];
      },
      compare: function(o1, o2) {
        return AbstractSTRtree$$1.compareDoubles(STRtree2.centreY(o1.getBounds()), STRtree2.centreY(o2.getBounds()));
      }
    };
  };
  staticAccessors2.intersectsOp.get = function() {
    return {
      interfaces_: function() {
        return [AbstractSTRtree$$1.IntersectsOp];
      },
      intersects: function(aBounds, bBounds) {
        return aBounds.intersects(bBounds);
      }
    };
  };
  staticAccessors2.DEFAULT_NODE_CAPACITY.get = function() {
    return 10;
  };
  Object.defineProperties(STRtree2, staticAccessors2);
  return STRtree2;
}(AbstractSTRtree);
var STRtreeNode = function(AbstractNode$$1) {
  function STRtreeNode2() {
    var level = arguments[0];
    AbstractNode$$1.call(this, level);
  }
  if (AbstractNode$$1)
    STRtreeNode2.__proto__ = AbstractNode$$1;
  STRtreeNode2.prototype = Object.create(AbstractNode$$1 && AbstractNode$$1.prototype);
  STRtreeNode2.prototype.constructor = STRtreeNode2;
  STRtreeNode2.prototype.computeBounds = function computeBounds2() {
    var bounds = null;
    for (var i2 = this.getChildBoundables().iterator(); i2.hasNext(); ) {
      var childBoundable = i2.next();
      if (bounds === null) {
        bounds = new Envelope(childBoundable.getBounds());
      } else {
        bounds.expandToInclude(childBoundable.getBounds());
      }
    }
    return bounds;
  };
  STRtreeNode2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  STRtreeNode2.prototype.getClass = function getClass169() {
    return STRtreeNode2;
  };
  return STRtreeNode2;
}(AbstractNode);
var SegmentPointComparator = function SegmentPointComparator2() {
};
SegmentPointComparator.prototype.interfaces_ = function interfaces_70() {
  return [];
};
SegmentPointComparator.prototype.getClass = function getClass69() {
  return SegmentPointComparator;
};
SegmentPointComparator.relativeSign = function relativeSign(x02, x12) {
  if (x02 < x12) {
    return -1;
  }
  if (x02 > x12) {
    return 1;
  }
  return 0;
};
SegmentPointComparator.compare = function compare7(octant2, p0, p1) {
  if (p0.equals2D(p1)) {
    return 0;
  }
  var xSign = SegmentPointComparator.relativeSign(p0.x, p1.x);
  var ySign = SegmentPointComparator.relativeSign(p0.y, p1.y);
  switch (octant2) {
    case 0:
      return SegmentPointComparator.compareValue(xSign, ySign);
    case 1:
      return SegmentPointComparator.compareValue(ySign, xSign);
    case 2:
      return SegmentPointComparator.compareValue(ySign, -xSign);
    case 3:
      return SegmentPointComparator.compareValue(-xSign, ySign);
    case 4:
      return SegmentPointComparator.compareValue(-xSign, -ySign);
    case 5:
      return SegmentPointComparator.compareValue(-ySign, -xSign);
    case 6:
      return SegmentPointComparator.compareValue(-ySign, xSign);
    case 7:
      return SegmentPointComparator.compareValue(xSign, -ySign);
  }
  Assert.shouldNeverReachHere("invalid octant value");
  return 0;
};
SegmentPointComparator.compareValue = function compareValue(compareSign0, compareSign1) {
  if (compareSign0 < 0) {
    return -1;
  }
  if (compareSign0 > 0) {
    return 1;
  }
  if (compareSign1 < 0) {
    return -1;
  }
  if (compareSign1 > 0) {
    return 1;
  }
  return 0;
};
var SegmentNode = function SegmentNode2() {
  this._segString = null;
  this.coord = null;
  this.segmentIndex = null;
  this._segmentOctant = null;
  this._isInterior = null;
  var segString = arguments[0];
  var coord = arguments[1];
  var segmentIndex = arguments[2];
  var segmentOctant = arguments[3];
  this._segString = segString;
  this.coord = new Coordinate(coord);
  this.segmentIndex = segmentIndex;
  this._segmentOctant = segmentOctant;
  this._isInterior = !coord.equals2D(segString.getCoordinate(segmentIndex));
};
SegmentNode.prototype.getCoordinate = function getCoordinate7() {
  return this.coord;
};
SegmentNode.prototype.print = function print3(out) {
  out.print(this.coord);
  out.print(" seg # = " + this.segmentIndex);
};
SegmentNode.prototype.compareTo = function compareTo10(obj) {
  var other = obj;
  if (this.segmentIndex < other.segmentIndex) {
    return -1;
  }
  if (this.segmentIndex > other.segmentIndex) {
    return 1;
  }
  if (this.coord.equals2D(other.coord)) {
    return 0;
  }
  return SegmentPointComparator.compare(this._segmentOctant, this.coord, other.coord);
};
SegmentNode.prototype.isEndPoint = function isEndPoint2(maxSegmentIndex) {
  if (this.segmentIndex === 0 && !this._isInterior) {
    return true;
  }
  if (this.segmentIndex === maxSegmentIndex) {
    return true;
  }
  return false;
};
SegmentNode.prototype.isInterior = function isInterior() {
  return this._isInterior;
};
SegmentNode.prototype.interfaces_ = function interfaces_71() {
  return [Comparable];
};
SegmentNode.prototype.getClass = function getClass70() {
  return SegmentNode;
};
var SegmentNodeList = function SegmentNodeList2() {
  this._nodeMap = new TreeMap();
  this._edge = null;
  var edge = arguments[0];
  this._edge = edge;
};
SegmentNodeList.prototype.getSplitCoordinates = function getSplitCoordinates() {
  var this$1$1 = this;
  var coordList = new CoordinateList();
  this.addEndpoints();
  var it = this.iterator();
  var eiPrev = it.next();
  while (it.hasNext()) {
    var ei = it.next();
    this$1$1.addEdgeCoordinates(eiPrev, ei, coordList);
    eiPrev = ei;
  }
  return coordList.toCoordinateArray();
};
SegmentNodeList.prototype.addCollapsedNodes = function addCollapsedNodes() {
  var this$1$1 = this;
  var collapsedVertexIndexes = new ArrayList();
  this.findCollapsesFromInsertedNodes(collapsedVertexIndexes);
  this.findCollapsesFromExistingVertices(collapsedVertexIndexes);
  for (var it = collapsedVertexIndexes.iterator(); it.hasNext(); ) {
    var vertexIndex = it.next().intValue();
    this$1$1.add(this$1$1._edge.getCoordinate(vertexIndex), vertexIndex);
  }
};
SegmentNodeList.prototype.print = function print4(out) {
  out.println("Intersections:");
  for (var it = this.iterator(); it.hasNext(); ) {
    var ei = it.next();
    ei.print(out);
  }
};
SegmentNodeList.prototype.findCollapsesFromExistingVertices = function findCollapsesFromExistingVertices(collapsedVertexIndexes) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this._edge.size() - 2; i2++) {
    var p0 = this$1$1._edge.getCoordinate(i2);
    var p2 = this$1$1._edge.getCoordinate(i2 + 2);
    if (p0.equals2D(p2)) {
      collapsedVertexIndexes.add(new Integer(i2 + 1));
    }
  }
};
SegmentNodeList.prototype.addEdgeCoordinates = function addEdgeCoordinates(ei0, ei1, coordList) {
  var this$1$1 = this;
  var lastSegStartPt = this._edge.getCoordinate(ei1.segmentIndex);
  var useIntPt1 = ei1.isInterior() || !ei1.coord.equals2D(lastSegStartPt);
  coordList.add(new Coordinate(ei0.coord), false);
  for (var i2 = ei0.segmentIndex + 1; i2 <= ei1.segmentIndex; i2++) {
    coordList.add(this$1$1._edge.getCoordinate(i2));
  }
  if (useIntPt1) {
    coordList.add(new Coordinate(ei1.coord));
  }
};
SegmentNodeList.prototype.iterator = function iterator3() {
  return this._nodeMap.values().iterator();
};
SegmentNodeList.prototype.addSplitEdges = function addSplitEdges(edgeList) {
  var this$1$1 = this;
  this.addEndpoints();
  this.addCollapsedNodes();
  var it = this.iterator();
  var eiPrev = it.next();
  while (it.hasNext()) {
    var ei = it.next();
    var newEdge = this$1$1.createSplitEdge(eiPrev, ei);
    edgeList.add(newEdge);
    eiPrev = ei;
  }
};
SegmentNodeList.prototype.findCollapseIndex = function findCollapseIndex(ei0, ei1, collapsedVertexIndex) {
  if (!ei0.coord.equals2D(ei1.coord)) {
    return false;
  }
  var numVerticesBetween = ei1.segmentIndex - ei0.segmentIndex;
  if (!ei1.isInterior()) {
    numVerticesBetween--;
  }
  if (numVerticesBetween === 1) {
    collapsedVertexIndex[0] = ei0.segmentIndex + 1;
    return true;
  }
  return false;
};
SegmentNodeList.prototype.findCollapsesFromInsertedNodes = function findCollapsesFromInsertedNodes(collapsedVertexIndexes) {
  var this$1$1 = this;
  var collapsedVertexIndex = new Array(1).fill(null);
  var it = this.iterator();
  var eiPrev = it.next();
  while (it.hasNext()) {
    var ei = it.next();
    var isCollapsed = this$1$1.findCollapseIndex(eiPrev, ei, collapsedVertexIndex);
    if (isCollapsed) {
      collapsedVertexIndexes.add(new Integer(collapsedVertexIndex[0]));
    }
    eiPrev = ei;
  }
};
SegmentNodeList.prototype.getEdge = function getEdge3() {
  return this._edge;
};
SegmentNodeList.prototype.addEndpoints = function addEndpoints() {
  var maxSegIndex = this._edge.size() - 1;
  this.add(this._edge.getCoordinate(0), 0);
  this.add(this._edge.getCoordinate(maxSegIndex), maxSegIndex);
};
SegmentNodeList.prototype.createSplitEdge = function createSplitEdge(ei0, ei1) {
  var this$1$1 = this;
  var npts = ei1.segmentIndex - ei0.segmentIndex + 2;
  var lastSegStartPt = this._edge.getCoordinate(ei1.segmentIndex);
  var useIntPt1 = ei1.isInterior() || !ei1.coord.equals2D(lastSegStartPt);
  if (!useIntPt1) {
    npts--;
  }
  var pts = new Array(npts).fill(null);
  var ipt = 0;
  pts[ipt++] = new Coordinate(ei0.coord);
  for (var i2 = ei0.segmentIndex + 1; i2 <= ei1.segmentIndex; i2++) {
    pts[ipt++] = this$1$1._edge.getCoordinate(i2);
  }
  if (useIntPt1) {
    pts[ipt] = new Coordinate(ei1.coord);
  }
  return new NodedSegmentString(pts, this._edge.getData());
};
SegmentNodeList.prototype.add = function add9(intPt, segmentIndex) {
  var eiNew = new SegmentNode(this._edge, intPt, segmentIndex, this._edge.getSegmentOctant(segmentIndex));
  var ei = this._nodeMap.get(eiNew);
  if (ei !== null) {
    Assert.isTrue(ei.coord.equals2D(intPt), "Found equal nodes with different coordinates");
    return ei;
  }
  this._nodeMap.put(eiNew, eiNew);
  return eiNew;
};
SegmentNodeList.prototype.checkSplitEdgesCorrectness = function checkSplitEdgesCorrectness(splitEdges) {
  var edgePts = this._edge.getCoordinates();
  var split0 = splitEdges.get(0);
  var pt0 = split0.getCoordinate(0);
  if (!pt0.equals2D(edgePts[0])) {
    throw new RuntimeException("bad split edge start point at " + pt0);
  }
  var splitn = splitEdges.get(splitEdges.size() - 1);
  var splitnPts = splitn.getCoordinates();
  var ptn = splitnPts[splitnPts.length - 1];
  if (!ptn.equals2D(edgePts[edgePts.length - 1])) {
    throw new RuntimeException("bad split edge end point at " + ptn);
  }
};
SegmentNodeList.prototype.interfaces_ = function interfaces_72() {
  return [];
};
SegmentNodeList.prototype.getClass = function getClass71() {
  return SegmentNodeList;
};
var Octant = function Octant2() {
};
Octant.prototype.interfaces_ = function interfaces_73() {
  return [];
};
Octant.prototype.getClass = function getClass72() {
  return Octant;
};
Octant.octant = function octant() {
  if (typeof arguments[0] === "number" && typeof arguments[1] === "number") {
    var dx = arguments[0];
    var dy = arguments[1];
    if (dx === 0 && dy === 0) {
      throw new IllegalArgumentException("Cannot compute the octant for point ( " + dx + ", " + dy + " )");
    }
    var adx = Math.abs(dx);
    var ady = Math.abs(dy);
    if (dx >= 0) {
      if (dy >= 0) {
        if (adx >= ady) {
          return 0;
        } else {
          return 1;
        }
      } else {
        if (adx >= ady) {
          return 7;
        } else {
          return 6;
        }
      }
    } else {
      if (dy >= 0) {
        if (adx >= ady) {
          return 3;
        } else {
          return 2;
        }
      } else {
        if (adx >= ady) {
          return 4;
        } else {
          return 5;
        }
      }
    }
  } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Coordinate) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    var dx$1 = p1.x - p0.x;
    var dy$1 = p1.y - p0.y;
    if (dx$1 === 0 && dy$1 === 0) {
      throw new IllegalArgumentException("Cannot compute the octant for two identical points " + p0);
    }
    return Octant.octant(dx$1, dy$1);
  }
};
var SegmentString = function SegmentString2() {
};
SegmentString.prototype.getCoordinates = function getCoordinates2() {
};
SegmentString.prototype.size = function size9() {
};
SegmentString.prototype.getCoordinate = function getCoordinate8(i2) {
};
SegmentString.prototype.isClosed = function isClosed() {
};
SegmentString.prototype.setData = function setData2(data2) {
};
SegmentString.prototype.getData = function getData2() {
};
SegmentString.prototype.interfaces_ = function interfaces_74() {
  return [];
};
SegmentString.prototype.getClass = function getClass73() {
  return SegmentString;
};
var NodableSegmentString = function NodableSegmentString2() {
};
NodableSegmentString.prototype.addIntersection = function addIntersection(intPt, segmentIndex) {
};
NodableSegmentString.prototype.interfaces_ = function interfaces_75() {
  return [SegmentString];
};
NodableSegmentString.prototype.getClass = function getClass74() {
  return NodableSegmentString;
};
var NodedSegmentString = function NodedSegmentString2() {
  this._nodeList = new SegmentNodeList(this);
  this._pts = null;
  this._data = null;
  var pts = arguments[0];
  var data2 = arguments[1];
  this._pts = pts;
  this._data = data2;
};
NodedSegmentString.prototype.getCoordinates = function getCoordinates3() {
  return this._pts;
};
NodedSegmentString.prototype.size = function size10() {
  return this._pts.length;
};
NodedSegmentString.prototype.getCoordinate = function getCoordinate9(i2) {
  return this._pts[i2];
};
NodedSegmentString.prototype.isClosed = function isClosed2() {
  return this._pts[0].equals(this._pts[this._pts.length - 1]);
};
NodedSegmentString.prototype.getSegmentOctant = function getSegmentOctant(index2) {
  if (index2 === this._pts.length - 1) {
    return -1;
  }
  return this.safeOctant(this.getCoordinate(index2), this.getCoordinate(index2 + 1));
};
NodedSegmentString.prototype.setData = function setData3(data2) {
  this._data = data2;
};
NodedSegmentString.prototype.safeOctant = function safeOctant(p0, p1) {
  if (p0.equals2D(p1)) {
    return 0;
  }
  return Octant.octant(p0, p1);
};
NodedSegmentString.prototype.getData = function getData3() {
  return this._data;
};
NodedSegmentString.prototype.addIntersection = function addIntersection2() {
  if (arguments.length === 2) {
    var intPt$1 = arguments[0];
    var segmentIndex = arguments[1];
    this.addIntersectionNode(intPt$1, segmentIndex);
  } else if (arguments.length === 4) {
    var li = arguments[0];
    var segmentIndex$1 = arguments[1];
    var intIndex = arguments[3];
    var intPt = new Coordinate(li.getIntersection(intIndex));
    this.addIntersection(intPt, segmentIndex$1);
  }
};
NodedSegmentString.prototype.toString = function toString15() {
  return WKTWriter.toLineString(new CoordinateArraySequence(this._pts));
};
NodedSegmentString.prototype.getNodeList = function getNodeList() {
  return this._nodeList;
};
NodedSegmentString.prototype.addIntersectionNode = function addIntersectionNode(intPt, segmentIndex) {
  var normalizedSegmentIndex = segmentIndex;
  var nextSegIndex = normalizedSegmentIndex + 1;
  if (nextSegIndex < this._pts.length) {
    var nextPt = this._pts[nextSegIndex];
    if (intPt.equals2D(nextPt)) {
      normalizedSegmentIndex = nextSegIndex;
    }
  }
  var ei = this._nodeList.add(intPt, normalizedSegmentIndex);
  return ei;
};
NodedSegmentString.prototype.addIntersections = function addIntersections(li, segmentIndex, geomIndex) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < li.getIntersectionNum(); i2++) {
    this$1$1.addIntersection(li, segmentIndex, geomIndex, i2);
  }
};
NodedSegmentString.prototype.interfaces_ = function interfaces_76() {
  return [NodableSegmentString];
};
NodedSegmentString.prototype.getClass = function getClass75() {
  return NodedSegmentString;
};
NodedSegmentString.getNodedSubstrings = function getNodedSubstrings() {
  if (arguments.length === 1) {
    var segStrings = arguments[0];
    var resultEdgelist = new ArrayList();
    NodedSegmentString.getNodedSubstrings(segStrings, resultEdgelist);
    return resultEdgelist;
  } else if (arguments.length === 2) {
    var segStrings$1 = arguments[0];
    var resultEdgelist$1 = arguments[1];
    for (var i2 = segStrings$1.iterator(); i2.hasNext(); ) {
      var ss = i2.next();
      ss.getNodeList().addSplitEdges(resultEdgelist$1);
    }
  }
};
var LineSegment = function LineSegment2() {
  this.p0 = null;
  this.p1 = null;
  if (arguments.length === 0) {
    this.p0 = new Coordinate();
    this.p1 = new Coordinate();
  } else if (arguments.length === 1) {
    var ls = arguments[0];
    this.p0 = new Coordinate(ls.p0);
    this.p1 = new Coordinate(ls.p1);
  } else if (arguments.length === 2) {
    this.p0 = arguments[0];
    this.p1 = arguments[1];
  } else if (arguments.length === 4) {
    var x02 = arguments[0];
    var y02 = arguments[1];
    var x12 = arguments[2];
    var y12 = arguments[3];
    this.p0 = new Coordinate(x02, y02);
    this.p1 = new Coordinate(x12, y12);
  }
};
var staticAccessors$24 = { serialVersionUID: { configurable: true } };
LineSegment.prototype.minX = function minX() {
  return Math.min(this.p0.x, this.p1.x);
};
LineSegment.prototype.orientationIndex = function orientationIndex4() {
  if (arguments[0] instanceof LineSegment) {
    var seg = arguments[0];
    var orient0 = CGAlgorithms.orientationIndex(this.p0, this.p1, seg.p0);
    var orient1 = CGAlgorithms.orientationIndex(this.p0, this.p1, seg.p1);
    if (orient0 >= 0 && orient1 >= 0) {
      return Math.max(orient0, orient1);
    }
    if (orient0 <= 0 && orient1 <= 0) {
      return Math.max(orient0, orient1);
    }
    return 0;
  } else if (arguments[0] instanceof Coordinate) {
    var p2 = arguments[0];
    return CGAlgorithms.orientationIndex(this.p0, this.p1, p2);
  }
};
LineSegment.prototype.toGeometry = function toGeometry2(geomFactory) {
  return geomFactory.createLineString([this.p0, this.p1]);
};
LineSegment.prototype.isVertical = function isVertical() {
  return this.p0.x === this.p1.x;
};
LineSegment.prototype.equals = function equals9(o2) {
  if (!(o2 instanceof LineSegment)) {
    return false;
  }
  var other = o2;
  return this.p0.equals(other.p0) && this.p1.equals(other.p1);
};
LineSegment.prototype.intersection = function intersection5(line) {
  var li = new RobustLineIntersector();
  li.computeIntersection(this.p0, this.p1, line.p0, line.p1);
  if (li.hasIntersection()) {
    return li.getIntersection(0);
  }
  return null;
};
LineSegment.prototype.project = function project2() {
  if (arguments[0] instanceof Coordinate) {
    var p2 = arguments[0];
    if (p2.equals(this.p0) || p2.equals(this.p1)) {
      return new Coordinate(p2);
    }
    var r2 = this.projectionFactor(p2);
    var coord = new Coordinate();
    coord.x = this.p0.x + r2 * (this.p1.x - this.p0.x);
    coord.y = this.p0.y + r2 * (this.p1.y - this.p0.y);
    return coord;
  } else if (arguments[0] instanceof LineSegment) {
    var seg = arguments[0];
    var pf0 = this.projectionFactor(seg.p0);
    var pf1 = this.projectionFactor(seg.p1);
    if (pf0 >= 1 && pf1 >= 1) {
      return null;
    }
    if (pf0 <= 0 && pf1 <= 0) {
      return null;
    }
    var newp0 = this.project(seg.p0);
    if (pf0 < 0) {
      newp0 = this.p0;
    }
    if (pf0 > 1) {
      newp0 = this.p1;
    }
    var newp1 = this.project(seg.p1);
    if (pf1 < 0) {
      newp1 = this.p0;
    }
    if (pf1 > 1) {
      newp1 = this.p1;
    }
    return new LineSegment(newp0, newp1);
  }
};
LineSegment.prototype.normalize = function normalize2() {
  if (this.p1.compareTo(this.p0) < 0) {
    this.reverse();
  }
};
LineSegment.prototype.angle = function angle2() {
  return Math.atan2(this.p1.y - this.p0.y, this.p1.x - this.p0.x);
};
LineSegment.prototype.getCoordinate = function getCoordinate10(i2) {
  if (i2 === 0) {
    return this.p0;
  }
  return this.p1;
};
LineSegment.prototype.distancePerpendicular = function distancePerpendicular(p2) {
  return CGAlgorithms.distancePointLinePerpendicular(p2, this.p0, this.p1);
};
LineSegment.prototype.minY = function minY() {
  return Math.min(this.p0.y, this.p1.y);
};
LineSegment.prototype.midPoint = function midPoint() {
  return LineSegment.midPoint(this.p0, this.p1);
};
LineSegment.prototype.projectionFactor = function projectionFactor(p2) {
  if (p2.equals(this.p0)) {
    return 0;
  }
  if (p2.equals(this.p1)) {
    return 1;
  }
  var dx = this.p1.x - this.p0.x;
  var dy = this.p1.y - this.p0.y;
  var len2 = dx * dx + dy * dy;
  if (len2 <= 0) {
    return Double.NaN;
  }
  var r2 = ((p2.x - this.p0.x) * dx + (p2.y - this.p0.y) * dy) / len2;
  return r2;
};
LineSegment.prototype.closestPoints = function closestPoints(line) {
  var intPt = this.intersection(line);
  if (intPt !== null) {
    return [intPt, intPt];
  }
  var closestPt = new Array(2).fill(null);
  var minDistance = Double.MAX_VALUE;
  var dist2 = null;
  var close00 = this.closestPoint(line.p0);
  minDistance = close00.distance(line.p0);
  closestPt[0] = close00;
  closestPt[1] = line.p0;
  var close01 = this.closestPoint(line.p1);
  dist2 = close01.distance(line.p1);
  if (dist2 < minDistance) {
    minDistance = dist2;
    closestPt[0] = close01;
    closestPt[1] = line.p1;
  }
  var close10 = line.closestPoint(this.p0);
  dist2 = close10.distance(this.p0);
  if (dist2 < minDistance) {
    minDistance = dist2;
    closestPt[0] = this.p0;
    closestPt[1] = close10;
  }
  var close11 = line.closestPoint(this.p1);
  dist2 = close11.distance(this.p1);
  if (dist2 < minDistance) {
    minDistance = dist2;
    closestPt[0] = this.p1;
    closestPt[1] = close11;
  }
  return closestPt;
};
LineSegment.prototype.closestPoint = function closestPoint(p2) {
  var factor = this.projectionFactor(p2);
  if (factor > 0 && factor < 1) {
    return this.project(p2);
  }
  var dist0 = this.p0.distance(p2);
  var dist1 = this.p1.distance(p2);
  if (dist0 < dist1) {
    return this.p0;
  }
  return this.p1;
};
LineSegment.prototype.maxX = function maxX() {
  return Math.max(this.p0.x, this.p1.x);
};
LineSegment.prototype.getLength = function getLength2() {
  return this.p0.distance(this.p1);
};
LineSegment.prototype.compareTo = function compareTo11(o2) {
  var other = o2;
  var comp0 = this.p0.compareTo(other.p0);
  if (comp0 !== 0) {
    return comp0;
  }
  return this.p1.compareTo(other.p1);
};
LineSegment.prototype.reverse = function reverse3() {
  var temp2 = this.p0;
  this.p0 = this.p1;
  this.p1 = temp2;
};
LineSegment.prototype.equalsTopo = function equalsTopo(other) {
  return this.p0.equals(other.p0) && (this.p1.equals(other.p1) || this.p0.equals(other.p1)) && this.p1.equals(other.p0);
};
LineSegment.prototype.lineIntersection = function lineIntersection(line) {
  try {
    var intPt = HCoordinate.intersection(this.p0, this.p1, line.p0, line.p1);
    return intPt;
  } catch (ex) {
    if (ex instanceof NotRepresentableException)
      ;
    else {
      throw ex;
    }
  } finally {
  }
  return null;
};
LineSegment.prototype.maxY = function maxY() {
  return Math.max(this.p0.y, this.p1.y);
};
LineSegment.prototype.pointAlongOffset = function pointAlongOffset(segmentLengthFraction, offsetDistance) {
  var segx = this.p0.x + segmentLengthFraction * (this.p1.x - this.p0.x);
  var segy = this.p0.y + segmentLengthFraction * (this.p1.y - this.p0.y);
  var dx = this.p1.x - this.p0.x;
  var dy = this.p1.y - this.p0.y;
  var len2 = Math.sqrt(dx * dx + dy * dy);
  var ux = 0;
  var uy = 0;
  if (offsetDistance !== 0) {
    if (len2 <= 0) {
      throw new Error("Cannot compute offset from zero-length line segment");
    }
    ux = offsetDistance * dx / len2;
    uy = offsetDistance * dy / len2;
  }
  var offsetx = segx - uy;
  var offsety = segy + ux;
  var coord = new Coordinate(offsetx, offsety);
  return coord;
};
LineSegment.prototype.setCoordinates = function setCoordinates() {
  if (arguments.length === 1) {
    var ls = arguments[0];
    this.setCoordinates(ls.p0, ls.p1);
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    this.p0.x = p0.x;
    this.p0.y = p0.y;
    this.p1.x = p1.x;
    this.p1.y = p1.y;
  }
};
LineSegment.prototype.segmentFraction = function segmentFraction(inputPt) {
  var segFrac = this.projectionFactor(inputPt);
  if (segFrac < 0) {
    segFrac = 0;
  } else if (segFrac > 1 || Double.isNaN(segFrac)) {
    segFrac = 1;
  }
  return segFrac;
};
LineSegment.prototype.toString = function toString16() {
  return "LINESTRING( " + this.p0.x + " " + this.p0.y + ", " + this.p1.x + " " + this.p1.y + ")";
};
LineSegment.prototype.isHorizontal = function isHorizontal() {
  return this.p0.y === this.p1.y;
};
LineSegment.prototype.distance = function distance6() {
  if (arguments[0] instanceof LineSegment) {
    var ls = arguments[0];
    return CGAlgorithms.distanceLineLine(this.p0, this.p1, ls.p0, ls.p1);
  } else if (arguments[0] instanceof Coordinate) {
    var p2 = arguments[0];
    return CGAlgorithms.distancePointLine(p2, this.p0, this.p1);
  }
};
LineSegment.prototype.pointAlong = function pointAlong(segmentLengthFraction) {
  var coord = new Coordinate();
  coord.x = this.p0.x + segmentLengthFraction * (this.p1.x - this.p0.x);
  coord.y = this.p0.y + segmentLengthFraction * (this.p1.y - this.p0.y);
  return coord;
};
LineSegment.prototype.hashCode = function hashCode6() {
  var bits0 = Double.doubleToLongBits(this.p0.x);
  bits0 ^= Double.doubleToLongBits(this.p0.y) * 31;
  var hash0 = Math.trunc(bits0) ^ Math.trunc(bits0 >> 32);
  var bits1 = Double.doubleToLongBits(this.p1.x);
  bits1 ^= Double.doubleToLongBits(this.p1.y) * 31;
  var hash1 = Math.trunc(bits1) ^ Math.trunc(bits1 >> 32);
  return hash0 ^ hash1;
};
LineSegment.prototype.interfaces_ = function interfaces_77() {
  return [Comparable, Serializable];
};
LineSegment.prototype.getClass = function getClass76() {
  return LineSegment;
};
LineSegment.midPoint = function midPoint2(p0, p1) {
  return new Coordinate((p0.x + p1.x) / 2, (p0.y + p1.y) / 2);
};
staticAccessors$24.serialVersionUID.get = function() {
  return 3252005833466256400;
};
Object.defineProperties(LineSegment, staticAccessors$24);
var MonotoneChainOverlapAction = function MonotoneChainOverlapAction2() {
  this.tempEnv1 = new Envelope();
  this.tempEnv2 = new Envelope();
  this._overlapSeg1 = new LineSegment();
  this._overlapSeg2 = new LineSegment();
};
MonotoneChainOverlapAction.prototype.overlap = function overlap() {
  if (arguments.length === 2)
    ;
  else if (arguments.length === 4) {
    var mc1 = arguments[0];
    var start1 = arguments[1];
    var mc2 = arguments[2];
    var start2 = arguments[3];
    mc1.getLineSegment(start1, this._overlapSeg1);
    mc2.getLineSegment(start2, this._overlapSeg2);
    this.overlap(this._overlapSeg1, this._overlapSeg2);
  }
};
MonotoneChainOverlapAction.prototype.interfaces_ = function interfaces_78() {
  return [];
};
MonotoneChainOverlapAction.prototype.getClass = function getClass77() {
  return MonotoneChainOverlapAction;
};
var MonotoneChain = function MonotoneChain2() {
  this._pts = null;
  this._start = null;
  this._end = null;
  this._env = null;
  this._context = null;
  this._id = null;
  var pts = arguments[0];
  var start2 = arguments[1];
  var end = arguments[2];
  var context2 = arguments[3];
  this._pts = pts;
  this._start = start2;
  this._end = end;
  this._context = context2;
};
MonotoneChain.prototype.getLineSegment = function getLineSegment(index2, ls) {
  ls.p0 = this._pts[index2];
  ls.p1 = this._pts[index2 + 1];
};
MonotoneChain.prototype.computeSelect = function computeSelect(searchEnv, start0, end0, mcs) {
  var p0 = this._pts[start0];
  var p1 = this._pts[end0];
  mcs.tempEnv1.init(p0, p1);
  if (end0 - start0 === 1) {
    mcs.select(this, start0);
    return null;
  }
  if (!searchEnv.intersects(mcs.tempEnv1)) {
    return null;
  }
  var mid = Math.trunc((start0 + end0) / 2);
  if (start0 < mid) {
    this.computeSelect(searchEnv, start0, mid, mcs);
  }
  if (mid < end0) {
    this.computeSelect(searchEnv, mid, end0, mcs);
  }
};
MonotoneChain.prototype.getCoordinates = function getCoordinates4() {
  var this$1$1 = this;
  var coord = new Array(this._end - this._start + 1).fill(null);
  var index2 = 0;
  for (var i2 = this._start; i2 <= this._end; i2++) {
    coord[index2++] = this$1$1._pts[i2];
  }
  return coord;
};
MonotoneChain.prototype.computeOverlaps = function computeOverlaps(mc, mco) {
  this.computeOverlapsInternal(this._start, this._end, mc, mc._start, mc._end, mco);
};
MonotoneChain.prototype.setId = function setId(id) {
  this._id = id;
};
MonotoneChain.prototype.select = function select(searchEnv, mcs) {
  this.computeSelect(searchEnv, this._start, this._end, mcs);
};
MonotoneChain.prototype.getEnvelope = function getEnvelope3() {
  if (this._env === null) {
    var p0 = this._pts[this._start];
    var p1 = this._pts[this._end];
    this._env = new Envelope(p0, p1);
  }
  return this._env;
};
MonotoneChain.prototype.getEndIndex = function getEndIndex() {
  return this._end;
};
MonotoneChain.prototype.getStartIndex = function getStartIndex() {
  return this._start;
};
MonotoneChain.prototype.getContext = function getContext() {
  return this._context;
};
MonotoneChain.prototype.getId = function getId() {
  return this._id;
};
MonotoneChain.prototype.computeOverlapsInternal = function computeOverlapsInternal(start0, end0, mc, start1, end1, mco) {
  var p00 = this._pts[start0];
  var p01 = this._pts[end0];
  var p10 = mc._pts[start1];
  var p11 = mc._pts[end1];
  if (end0 - start0 === 1 && end1 - start1 === 1) {
    mco.overlap(this, start0, mc, start1);
    return null;
  }
  mco.tempEnv1.init(p00, p01);
  mco.tempEnv2.init(p10, p11);
  if (!mco.tempEnv1.intersects(mco.tempEnv2)) {
    return null;
  }
  var mid0 = Math.trunc((start0 + end0) / 2);
  var mid1 = Math.trunc((start1 + end1) / 2);
  if (start0 < mid0) {
    if (start1 < mid1) {
      this.computeOverlapsInternal(start0, mid0, mc, start1, mid1, mco);
    }
    if (mid1 < end1) {
      this.computeOverlapsInternal(start0, mid0, mc, mid1, end1, mco);
    }
  }
  if (mid0 < end0) {
    if (start1 < mid1) {
      this.computeOverlapsInternal(mid0, end0, mc, start1, mid1, mco);
    }
    if (mid1 < end1) {
      this.computeOverlapsInternal(mid0, end0, mc, mid1, end1, mco);
    }
  }
};
MonotoneChain.prototype.interfaces_ = function interfaces_79() {
  return [];
};
MonotoneChain.prototype.getClass = function getClass78() {
  return MonotoneChain;
};
var MonotoneChainBuilder = function MonotoneChainBuilder2() {
};
MonotoneChainBuilder.prototype.interfaces_ = function interfaces_80() {
  return [];
};
MonotoneChainBuilder.prototype.getClass = function getClass79() {
  return MonotoneChainBuilder;
};
MonotoneChainBuilder.getChainStartIndices = function getChainStartIndices(pts) {
  var start2 = 0;
  var startIndexList = new ArrayList();
  startIndexList.add(new Integer(start2));
  do {
    var last = MonotoneChainBuilder.findChainEnd(pts, start2);
    startIndexList.add(new Integer(last));
    start2 = last;
  } while (start2 < pts.length - 1);
  var startIndex = MonotoneChainBuilder.toIntArray(startIndexList);
  return startIndex;
};
MonotoneChainBuilder.findChainEnd = function findChainEnd(pts, start2) {
  var safeStart = start2;
  while (safeStart < pts.length - 1 && pts[safeStart].equals2D(pts[safeStart + 1])) {
    safeStart++;
  }
  if (safeStart >= pts.length - 1) {
    return pts.length - 1;
  }
  var chainQuad = Quadrant.quadrant(pts[safeStart], pts[safeStart + 1]);
  var last = start2 + 1;
  while (last < pts.length) {
    if (!pts[last - 1].equals2D(pts[last])) {
      var quad = Quadrant.quadrant(pts[last - 1], pts[last]);
      if (quad !== chainQuad) {
        break;
      }
    }
    last++;
  }
  return last - 1;
};
MonotoneChainBuilder.getChains = function getChains() {
  if (arguments.length === 1) {
    var pts = arguments[0];
    return MonotoneChainBuilder.getChains(pts, null);
  } else if (arguments.length === 2) {
    var pts$1 = arguments[0];
    var context2 = arguments[1];
    var mcList = new ArrayList();
    var startIndex = MonotoneChainBuilder.getChainStartIndices(pts$1);
    for (var i2 = 0; i2 < startIndex.length - 1; i2++) {
      var mc = new MonotoneChain(pts$1, startIndex[i2], startIndex[i2 + 1], context2);
      mcList.add(mc);
    }
    return mcList;
  }
};
MonotoneChainBuilder.toIntArray = function toIntArray(list2) {
  var array2 = new Array(list2.size()).fill(null);
  for (var i2 = 0; i2 < array2.length; i2++) {
    array2[i2] = list2.get(i2).intValue();
  }
  return array2;
};
var Noder = function Noder2() {
};
Noder.prototype.computeNodes = function computeNodes(segStrings) {
};
Noder.prototype.getNodedSubstrings = function getNodedSubstrings2() {
};
Noder.prototype.interfaces_ = function interfaces_81() {
  return [];
};
Noder.prototype.getClass = function getClass80() {
  return Noder;
};
var SinglePassNoder = function SinglePassNoder2() {
  this._segInt = null;
  if (arguments.length === 0)
    ;
  else if (arguments.length === 1) {
    var segInt = arguments[0];
    this.setSegmentIntersector(segInt);
  }
};
SinglePassNoder.prototype.setSegmentIntersector = function setSegmentIntersector(segInt) {
  this._segInt = segInt;
};
SinglePassNoder.prototype.interfaces_ = function interfaces_82() {
  return [Noder];
};
SinglePassNoder.prototype.getClass = function getClass81() {
  return SinglePassNoder;
};
var MCIndexNoder = function(SinglePassNoder$$1) {
  function MCIndexNoder2(si) {
    if (si) {
      SinglePassNoder$$1.call(this, si);
    } else {
      SinglePassNoder$$1.call(this);
    }
    this._monoChains = new ArrayList();
    this._index = new STRtree();
    this._idCounter = 0;
    this._nodedSegStrings = null;
    this._nOverlaps = 0;
  }
  if (SinglePassNoder$$1)
    MCIndexNoder2.__proto__ = SinglePassNoder$$1;
  MCIndexNoder2.prototype = Object.create(SinglePassNoder$$1 && SinglePassNoder$$1.prototype);
  MCIndexNoder2.prototype.constructor = MCIndexNoder2;
  var staticAccessors2 = { SegmentOverlapAction: { configurable: true } };
  MCIndexNoder2.prototype.getMonotoneChains = function getMonotoneChains() {
    return this._monoChains;
  };
  MCIndexNoder2.prototype.getNodedSubstrings = function getNodedSubstrings5() {
    return NodedSegmentString.getNodedSubstrings(this._nodedSegStrings);
  };
  MCIndexNoder2.prototype.getIndex = function getIndex() {
    return this._index;
  };
  MCIndexNoder2.prototype.add = function add18(segStr) {
    var this$1$1 = this;
    var segChains = MonotoneChainBuilder.getChains(segStr.getCoordinates(), segStr);
    for (var i2 = segChains.iterator(); i2.hasNext(); ) {
      var mc = i2.next();
      mc.setId(this$1$1._idCounter++);
      this$1$1._index.insert(mc.getEnvelope(), mc);
      this$1$1._monoChains.add(mc);
    }
  };
  MCIndexNoder2.prototype.computeNodes = function computeNodes4(inputSegStrings) {
    var this$1$1 = this;
    this._nodedSegStrings = inputSegStrings;
    for (var i2 = inputSegStrings.iterator(); i2.hasNext(); ) {
      this$1$1.add(i2.next());
    }
    this.intersectChains();
  };
  MCIndexNoder2.prototype.intersectChains = function intersectChains() {
    var this$1$1 = this;
    var overlapAction = new SegmentOverlapAction(this._segInt);
    for (var i2 = this._monoChains.iterator(); i2.hasNext(); ) {
      var queryChain = i2.next();
      var overlapChains = this$1$1._index.query(queryChain.getEnvelope());
      for (var j2 = overlapChains.iterator(); j2.hasNext(); ) {
        var testChain = j2.next();
        if (testChain.getId() > queryChain.getId()) {
          queryChain.computeOverlaps(testChain, overlapAction);
          this$1$1._nOverlaps++;
        }
        if (this$1$1._segInt.isDone()) {
          return null;
        }
      }
    }
  };
  MCIndexNoder2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  MCIndexNoder2.prototype.getClass = function getClass169() {
    return MCIndexNoder2;
  };
  staticAccessors2.SegmentOverlapAction.get = function() {
    return SegmentOverlapAction;
  };
  Object.defineProperties(MCIndexNoder2, staticAccessors2);
  return MCIndexNoder2;
}(SinglePassNoder);
var SegmentOverlapAction = function(MonotoneChainOverlapAction$$1) {
  function SegmentOverlapAction2() {
    MonotoneChainOverlapAction$$1.call(this);
    this._si = null;
    var si = arguments[0];
    this._si = si;
  }
  if (MonotoneChainOverlapAction$$1)
    SegmentOverlapAction2.__proto__ = MonotoneChainOverlapAction$$1;
  SegmentOverlapAction2.prototype = Object.create(MonotoneChainOverlapAction$$1 && MonotoneChainOverlapAction$$1.prototype);
  SegmentOverlapAction2.prototype.constructor = SegmentOverlapAction2;
  SegmentOverlapAction2.prototype.overlap = function overlap2() {
    if (arguments.length === 4) {
      var mc1 = arguments[0];
      var start1 = arguments[1];
      var mc2 = arguments[2];
      var start2 = arguments[3];
      var ss1 = mc1.getContext();
      var ss2 = mc2.getContext();
      this._si.processIntersections(ss1, start1, ss2, start2);
    } else {
      return MonotoneChainOverlapAction$$1.prototype.overlap.apply(this, arguments);
    }
  };
  SegmentOverlapAction2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  SegmentOverlapAction2.prototype.getClass = function getClass169() {
    return SegmentOverlapAction2;
  };
  return SegmentOverlapAction2;
}(MonotoneChainOverlapAction);
var BufferParameters = function BufferParameters2() {
  this._quadrantSegments = BufferParameters2.DEFAULT_QUADRANT_SEGMENTS;
  this._endCapStyle = BufferParameters2.CAP_ROUND;
  this._joinStyle = BufferParameters2.JOIN_ROUND;
  this._mitreLimit = BufferParameters2.DEFAULT_MITRE_LIMIT;
  this._isSingleSided = false;
  this._simplifyFactor = BufferParameters2.DEFAULT_SIMPLIFY_FACTOR;
  if (arguments.length === 0)
    ;
  else if (arguments.length === 1) {
    var quadrantSegments = arguments[0];
    this.setQuadrantSegments(quadrantSegments);
  } else if (arguments.length === 2) {
    var quadrantSegments$1 = arguments[0];
    var endCapStyle = arguments[1];
    this.setQuadrantSegments(quadrantSegments$1);
    this.setEndCapStyle(endCapStyle);
  } else if (arguments.length === 4) {
    var quadrantSegments$2 = arguments[0];
    var endCapStyle$1 = arguments[1];
    var joinStyle = arguments[2];
    var mitreLimit = arguments[3];
    this.setQuadrantSegments(quadrantSegments$2);
    this.setEndCapStyle(endCapStyle$1);
    this.setJoinStyle(joinStyle);
    this.setMitreLimit(mitreLimit);
  }
};
var staticAccessors$25 = { CAP_ROUND: { configurable: true }, CAP_FLAT: { configurable: true }, CAP_SQUARE: { configurable: true }, JOIN_ROUND: { configurable: true }, JOIN_MITRE: { configurable: true }, JOIN_BEVEL: { configurable: true }, DEFAULT_QUADRANT_SEGMENTS: { configurable: true }, DEFAULT_MITRE_LIMIT: { configurable: true }, DEFAULT_SIMPLIFY_FACTOR: { configurable: true } };
BufferParameters.prototype.getEndCapStyle = function getEndCapStyle() {
  return this._endCapStyle;
};
BufferParameters.prototype.isSingleSided = function isSingleSided() {
  return this._isSingleSided;
};
BufferParameters.prototype.setQuadrantSegments = function setQuadrantSegments(quadSegs) {
  this._quadrantSegments = quadSegs;
  if (this._quadrantSegments === 0) {
    this._joinStyle = BufferParameters.JOIN_BEVEL;
  }
  if (this._quadrantSegments < 0) {
    this._joinStyle = BufferParameters.JOIN_MITRE;
    this._mitreLimit = Math.abs(this._quadrantSegments);
  }
  if (quadSegs <= 0) {
    this._quadrantSegments = 1;
  }
  if (this._joinStyle !== BufferParameters.JOIN_ROUND) {
    this._quadrantSegments = BufferParameters.DEFAULT_QUADRANT_SEGMENTS;
  }
};
BufferParameters.prototype.getJoinStyle = function getJoinStyle() {
  return this._joinStyle;
};
BufferParameters.prototype.setJoinStyle = function setJoinStyle(joinStyle) {
  this._joinStyle = joinStyle;
};
BufferParameters.prototype.setSimplifyFactor = function setSimplifyFactor(simplifyFactor) {
  this._simplifyFactor = simplifyFactor < 0 ? 0 : simplifyFactor;
};
BufferParameters.prototype.getSimplifyFactor = function getSimplifyFactor() {
  return this._simplifyFactor;
};
BufferParameters.prototype.getQuadrantSegments = function getQuadrantSegments() {
  return this._quadrantSegments;
};
BufferParameters.prototype.setEndCapStyle = function setEndCapStyle(endCapStyle) {
  this._endCapStyle = endCapStyle;
};
BufferParameters.prototype.getMitreLimit = function getMitreLimit() {
  return this._mitreLimit;
};
BufferParameters.prototype.setMitreLimit = function setMitreLimit(mitreLimit) {
  this._mitreLimit = mitreLimit;
};
BufferParameters.prototype.setSingleSided = function setSingleSided(isSingleSided2) {
  this._isSingleSided = isSingleSided2;
};
BufferParameters.prototype.interfaces_ = function interfaces_83() {
  return [];
};
BufferParameters.prototype.getClass = function getClass82() {
  return BufferParameters;
};
BufferParameters.bufferDistanceError = function bufferDistanceError(quadSegs) {
  var alpha = Math.PI / 2 / quadSegs;
  return 1 - Math.cos(alpha / 2);
};
staticAccessors$25.CAP_ROUND.get = function() {
  return 1;
};
staticAccessors$25.CAP_FLAT.get = function() {
  return 2;
};
staticAccessors$25.CAP_SQUARE.get = function() {
  return 3;
};
staticAccessors$25.JOIN_ROUND.get = function() {
  return 1;
};
staticAccessors$25.JOIN_MITRE.get = function() {
  return 2;
};
staticAccessors$25.JOIN_BEVEL.get = function() {
  return 3;
};
staticAccessors$25.DEFAULT_QUADRANT_SEGMENTS.get = function() {
  return 8;
};
staticAccessors$25.DEFAULT_MITRE_LIMIT.get = function() {
  return 5;
};
staticAccessors$25.DEFAULT_SIMPLIFY_FACTOR.get = function() {
  return 0.01;
};
Object.defineProperties(BufferParameters, staticAccessors$25);
var BufferInputLineSimplifier = function BufferInputLineSimplifier2(inputLine) {
  this._distanceTol = null;
  this._isDeleted = null;
  this._angleOrientation = CGAlgorithms.COUNTERCLOCKWISE;
  this._inputLine = inputLine || null;
};
var staticAccessors$26 = { INIT: { configurable: true }, DELETE: { configurable: true }, KEEP: { configurable: true }, NUM_PTS_TO_CHECK: { configurable: true } };
BufferInputLineSimplifier.prototype.isDeletable = function isDeletable(i0, i1, i2, distanceTol) {
  var p0 = this._inputLine[i0];
  var p1 = this._inputLine[i1];
  var p2 = this._inputLine[i2];
  if (!this.isConcave(p0, p1, p2)) {
    return false;
  }
  if (!this.isShallow(p0, p1, p2, distanceTol)) {
    return false;
  }
  return this.isShallowSampled(p0, p1, i0, i2, distanceTol);
};
BufferInputLineSimplifier.prototype.deleteShallowConcavities = function deleteShallowConcavities() {
  var this$1$1 = this;
  var index2 = 1;
  var midIndex = this.findNextNonDeletedIndex(index2);
  var lastIndex = this.findNextNonDeletedIndex(midIndex);
  var isChanged = false;
  while (lastIndex < this._inputLine.length) {
    var isMiddleVertexDeleted = false;
    if (this$1$1.isDeletable(index2, midIndex, lastIndex, this$1$1._distanceTol)) {
      this$1$1._isDeleted[midIndex] = BufferInputLineSimplifier.DELETE;
      isMiddleVertexDeleted = true;
      isChanged = true;
    }
    if (isMiddleVertexDeleted) {
      index2 = lastIndex;
    } else {
      index2 = midIndex;
    }
    midIndex = this$1$1.findNextNonDeletedIndex(index2);
    lastIndex = this$1$1.findNextNonDeletedIndex(midIndex);
  }
  return isChanged;
};
BufferInputLineSimplifier.prototype.isShallowConcavity = function isShallowConcavity(p0, p1, p2, distanceTol) {
  var orientation2 = CGAlgorithms.computeOrientation(p0, p1, p2);
  var isAngleToSimplify = orientation2 === this._angleOrientation;
  if (!isAngleToSimplify) {
    return false;
  }
  var dist2 = CGAlgorithms.distancePointLine(p1, p0, p2);
  return dist2 < distanceTol;
};
BufferInputLineSimplifier.prototype.isShallowSampled = function isShallowSampled(p0, p2, i0, i2, distanceTol) {
  var this$1$1 = this;
  var inc = Math.trunc((i2 - i0) / BufferInputLineSimplifier.NUM_PTS_TO_CHECK);
  if (inc <= 0) {
    inc = 1;
  }
  for (var i3 = i0; i3 < i2; i3 += inc) {
    if (!this$1$1.isShallow(p0, p2, this$1$1._inputLine[i3], distanceTol)) {
      return false;
    }
  }
  return true;
};
BufferInputLineSimplifier.prototype.isConcave = function isConcave(p0, p1, p2) {
  var orientation2 = CGAlgorithms.computeOrientation(p0, p1, p2);
  var isConcave2 = orientation2 === this._angleOrientation;
  return isConcave2;
};
BufferInputLineSimplifier.prototype.simplify = function simplify(distanceTol) {
  var this$1$1 = this;
  this._distanceTol = Math.abs(distanceTol);
  if (distanceTol < 0) {
    this._angleOrientation = CGAlgorithms.CLOCKWISE;
  }
  this._isDeleted = new Array(this._inputLine.length).fill(null);
  var isChanged = false;
  do {
    isChanged = this$1$1.deleteShallowConcavities();
  } while (isChanged);
  return this.collapseLine();
};
BufferInputLineSimplifier.prototype.findNextNonDeletedIndex = function findNextNonDeletedIndex(index2) {
  var next5 = index2 + 1;
  while (next5 < this._inputLine.length && this._isDeleted[next5] === BufferInputLineSimplifier.DELETE) {
    next5++;
  }
  return next5;
};
BufferInputLineSimplifier.prototype.isShallow = function isShallow(p0, p1, p2, distanceTol) {
  var dist2 = CGAlgorithms.distancePointLine(p1, p0, p2);
  return dist2 < distanceTol;
};
BufferInputLineSimplifier.prototype.collapseLine = function collapseLine() {
  var this$1$1 = this;
  var coordList = new CoordinateList();
  for (var i2 = 0; i2 < this._inputLine.length; i2++) {
    if (this$1$1._isDeleted[i2] !== BufferInputLineSimplifier.DELETE) {
      coordList.add(this$1$1._inputLine[i2]);
    }
  }
  return coordList.toCoordinateArray();
};
BufferInputLineSimplifier.prototype.interfaces_ = function interfaces_84() {
  return [];
};
BufferInputLineSimplifier.prototype.getClass = function getClass83() {
  return BufferInputLineSimplifier;
};
BufferInputLineSimplifier.simplify = function simplify2(inputLine, distanceTol) {
  var simp = new BufferInputLineSimplifier(inputLine);
  return simp.simplify(distanceTol);
};
staticAccessors$26.INIT.get = function() {
  return 0;
};
staticAccessors$26.DELETE.get = function() {
  return 1;
};
staticAccessors$26.KEEP.get = function() {
  return 1;
};
staticAccessors$26.NUM_PTS_TO_CHECK.get = function() {
  return 10;
};
Object.defineProperties(BufferInputLineSimplifier, staticAccessors$26);
var OffsetSegmentString = function OffsetSegmentString2() {
  this._ptList = null;
  this._precisionModel = null;
  this._minimimVertexDistance = 0;
  this._ptList = new ArrayList();
};
var staticAccessors$28 = { COORDINATE_ARRAY_TYPE: { configurable: true } };
OffsetSegmentString.prototype.getCoordinates = function getCoordinates5() {
  var coord = this._ptList.toArray(OffsetSegmentString.COORDINATE_ARRAY_TYPE);
  return coord;
};
OffsetSegmentString.prototype.setPrecisionModel = function setPrecisionModel2(precisionModel) {
  this._precisionModel = precisionModel;
};
OffsetSegmentString.prototype.addPt = function addPt(pt) {
  var bufPt = new Coordinate(pt);
  this._precisionModel.makePrecise(bufPt);
  if (this.isRedundant(bufPt)) {
    return null;
  }
  this._ptList.add(bufPt);
};
OffsetSegmentString.prototype.revere = function revere() {
};
OffsetSegmentString.prototype.addPts = function addPts(pt, isForward) {
  var this$1$1 = this;
  if (isForward) {
    for (var i2 = 0; i2 < pt.length; i2++) {
      this$1$1.addPt(pt[i2]);
    }
  } else {
    for (var i$12 = pt.length - 1; i$12 >= 0; i$12--) {
      this$1$1.addPt(pt[i$12]);
    }
  }
};
OffsetSegmentString.prototype.isRedundant = function isRedundant(pt) {
  if (this._ptList.size() < 1) {
    return false;
  }
  var lastPt = this._ptList.get(this._ptList.size() - 1);
  var ptDist = pt.distance(lastPt);
  if (ptDist < this._minimimVertexDistance) {
    return true;
  }
  return false;
};
OffsetSegmentString.prototype.toString = function toString17() {
  var fact = new GeometryFactory();
  var line = fact.createLineString(this.getCoordinates());
  return line.toString();
};
OffsetSegmentString.prototype.closeRing = function closeRing() {
  if (this._ptList.size() < 1) {
    return null;
  }
  var startPt = new Coordinate(this._ptList.get(0));
  var lastPt = this._ptList.get(this._ptList.size() - 1);
  if (startPt.equals(lastPt)) {
    return null;
  }
  this._ptList.add(startPt);
};
OffsetSegmentString.prototype.setMinimumVertexDistance = function setMinimumVertexDistance(minimimVertexDistance) {
  this._minimimVertexDistance = minimimVertexDistance;
};
OffsetSegmentString.prototype.interfaces_ = function interfaces_85() {
  return [];
};
OffsetSegmentString.prototype.getClass = function getClass84() {
  return OffsetSegmentString;
};
staticAccessors$28.COORDINATE_ARRAY_TYPE.get = function() {
  return new Array(0).fill(null);
};
Object.defineProperties(OffsetSegmentString, staticAccessors$28);
var Angle = function Angle2() {
};
var staticAccessors$29 = { PI_TIMES_2: { configurable: true }, PI_OVER_2: { configurable: true }, PI_OVER_4: { configurable: true }, COUNTERCLOCKWISE: { configurable: true }, CLOCKWISE: { configurable: true }, NONE: { configurable: true } };
Angle.prototype.interfaces_ = function interfaces_86() {
  return [];
};
Angle.prototype.getClass = function getClass85() {
  return Angle;
};
Angle.toDegrees = function toDegrees2(radians2) {
  return radians2 * 180 / Math.PI;
};
Angle.normalize = function normalize3(angle4) {
  while (angle4 > Math.PI) {
    angle4 -= Angle.PI_TIMES_2;
  }
  while (angle4 <= -Math.PI) {
    angle4 += Angle.PI_TIMES_2;
  }
  return angle4;
};
Angle.angle = function angle3() {
  if (arguments.length === 1) {
    var p2 = arguments[0];
    return Math.atan2(p2.y, p2.x);
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    var dx = p1.x - p0.x;
    var dy = p1.y - p0.y;
    return Math.atan2(dy, dx);
  }
};
Angle.isAcute = function isAcute(p0, p1, p2) {
  var dx0 = p0.x - p1.x;
  var dy0 = p0.y - p1.y;
  var dx1 = p2.x - p1.x;
  var dy1 = p2.y - p1.y;
  var dotprod = dx0 * dx1 + dy0 * dy1;
  return dotprod > 0;
};
Angle.isObtuse = function isObtuse(p0, p1, p2) {
  var dx0 = p0.x - p1.x;
  var dy0 = p0.y - p1.y;
  var dx1 = p2.x - p1.x;
  var dy1 = p2.y - p1.y;
  var dotprod = dx0 * dx1 + dy0 * dy1;
  return dotprod < 0;
};
Angle.interiorAngle = function interiorAngle(p0, p1, p2) {
  var anglePrev = Angle.angle(p1, p0);
  var angleNext = Angle.angle(p1, p2);
  return Math.abs(angleNext - anglePrev);
};
Angle.normalizePositive = function normalizePositive(angle4) {
  if (angle4 < 0) {
    while (angle4 < 0) {
      angle4 += Angle.PI_TIMES_2;
    }
    if (angle4 >= Angle.PI_TIMES_2) {
      angle4 = 0;
    }
  } else {
    while (angle4 >= Angle.PI_TIMES_2) {
      angle4 -= Angle.PI_TIMES_2;
    }
    if (angle4 < 0) {
      angle4 = 0;
    }
  }
  return angle4;
};
Angle.angleBetween = function angleBetween(tip1, tail, tip2) {
  var a1 = Angle.angle(tail, tip1);
  var a2 = Angle.angle(tail, tip2);
  return Angle.diff(a1, a2);
};
Angle.diff = function diff(ang1, ang2) {
  var delAngle = null;
  if (ang1 < ang2) {
    delAngle = ang2 - ang1;
  } else {
    delAngle = ang1 - ang2;
  }
  if (delAngle > Math.PI) {
    delAngle = 2 * Math.PI - delAngle;
  }
  return delAngle;
};
Angle.toRadians = function toRadians2(angleDegrees) {
  return angleDegrees * Math.PI / 180;
};
Angle.getTurn = function getTurn(ang1, ang2) {
  var crossproduct = Math.sin(ang2 - ang1);
  if (crossproduct > 0) {
    return Angle.COUNTERCLOCKWISE;
  }
  if (crossproduct < 0) {
    return Angle.CLOCKWISE;
  }
  return Angle.NONE;
};
Angle.angleBetweenOriented = function angleBetweenOriented(tip1, tail, tip2) {
  var a1 = Angle.angle(tail, tip1);
  var a2 = Angle.angle(tail, tip2);
  var angDel = a2 - a1;
  if (angDel <= -Math.PI) {
    return angDel + Angle.PI_TIMES_2;
  }
  if (angDel > Math.PI) {
    return angDel - Angle.PI_TIMES_2;
  }
  return angDel;
};
staticAccessors$29.PI_TIMES_2.get = function() {
  return 2 * Math.PI;
};
staticAccessors$29.PI_OVER_2.get = function() {
  return Math.PI / 2;
};
staticAccessors$29.PI_OVER_4.get = function() {
  return Math.PI / 4;
};
staticAccessors$29.COUNTERCLOCKWISE.get = function() {
  return CGAlgorithms.COUNTERCLOCKWISE;
};
staticAccessors$29.CLOCKWISE.get = function() {
  return CGAlgorithms.CLOCKWISE;
};
staticAccessors$29.NONE.get = function() {
  return CGAlgorithms.COLLINEAR;
};
Object.defineProperties(Angle, staticAccessors$29);
var OffsetSegmentGenerator = function OffsetSegmentGenerator2() {
  this._maxCurveSegmentError = 0;
  this._filletAngleQuantum = null;
  this._closingSegLengthFactor = 1;
  this._segList = null;
  this._distance = 0;
  this._precisionModel = null;
  this._bufParams = null;
  this._li = null;
  this._s0 = null;
  this._s1 = null;
  this._s2 = null;
  this._seg0 = new LineSegment();
  this._seg1 = new LineSegment();
  this._offset0 = new LineSegment();
  this._offset1 = new LineSegment();
  this._side = 0;
  this._hasNarrowConcaveAngle = false;
  var precisionModel = arguments[0];
  var bufParams = arguments[1];
  var distance11 = arguments[2];
  this._precisionModel = precisionModel;
  this._bufParams = bufParams;
  this._li = new RobustLineIntersector();
  this._filletAngleQuantum = Math.PI / 2 / bufParams.getQuadrantSegments();
  if (bufParams.getQuadrantSegments() >= 8 && bufParams.getJoinStyle() === BufferParameters.JOIN_ROUND) {
    this._closingSegLengthFactor = OffsetSegmentGenerator2.MAX_CLOSING_SEG_LEN_FACTOR;
  }
  this.init(distance11);
};
var staticAccessors$27 = { OFFSET_SEGMENT_SEPARATION_FACTOR: { configurable: true }, INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR: { configurable: true }, CURVE_VERTEX_SNAP_DISTANCE_FACTOR: { configurable: true }, MAX_CLOSING_SEG_LEN_FACTOR: { configurable: true } };
OffsetSegmentGenerator.prototype.addNextSegment = function addNextSegment(p2, addStartPoint) {
  this._s0 = this._s1;
  this._s1 = this._s2;
  this._s2 = p2;
  this._seg0.setCoordinates(this._s0, this._s1);
  this.computeOffsetSegment(this._seg0, this._side, this._distance, this._offset0);
  this._seg1.setCoordinates(this._s1, this._s2);
  this.computeOffsetSegment(this._seg1, this._side, this._distance, this._offset1);
  if (this._s1.equals(this._s2)) {
    return null;
  }
  var orientation2 = CGAlgorithms.computeOrientation(this._s0, this._s1, this._s2);
  var outsideTurn = orientation2 === CGAlgorithms.CLOCKWISE && this._side === Position.LEFT || orientation2 === CGAlgorithms.COUNTERCLOCKWISE && this._side === Position.RIGHT;
  if (orientation2 === 0) {
    this.addCollinear(addStartPoint);
  } else if (outsideTurn) {
    this.addOutsideTurn(orientation2, addStartPoint);
  } else {
    this.addInsideTurn(orientation2, addStartPoint);
  }
};
OffsetSegmentGenerator.prototype.addLineEndCap = function addLineEndCap(p0, p1) {
  var seg = new LineSegment(p0, p1);
  var offsetL = new LineSegment();
  this.computeOffsetSegment(seg, Position.LEFT, this._distance, offsetL);
  var offsetR = new LineSegment();
  this.computeOffsetSegment(seg, Position.RIGHT, this._distance, offsetR);
  var dx = p1.x - p0.x;
  var dy = p1.y - p0.y;
  var angle4 = Math.atan2(dy, dx);
  switch (this._bufParams.getEndCapStyle()) {
    case BufferParameters.CAP_ROUND:
      this._segList.addPt(offsetL.p1);
      this.addFilletArc(p1, angle4 + Math.PI / 2, angle4 - Math.PI / 2, CGAlgorithms.CLOCKWISE, this._distance);
      this._segList.addPt(offsetR.p1);
      break;
    case BufferParameters.CAP_FLAT:
      this._segList.addPt(offsetL.p1);
      this._segList.addPt(offsetR.p1);
      break;
    case BufferParameters.CAP_SQUARE:
      var squareCapSideOffset = new Coordinate();
      squareCapSideOffset.x = Math.abs(this._distance) * Math.cos(angle4);
      squareCapSideOffset.y = Math.abs(this._distance) * Math.sin(angle4);
      var squareCapLOffset = new Coordinate(offsetL.p1.x + squareCapSideOffset.x, offsetL.p1.y + squareCapSideOffset.y);
      var squareCapROffset = new Coordinate(offsetR.p1.x + squareCapSideOffset.x, offsetR.p1.y + squareCapSideOffset.y);
      this._segList.addPt(squareCapLOffset);
      this._segList.addPt(squareCapROffset);
      break;
  }
};
OffsetSegmentGenerator.prototype.getCoordinates = function getCoordinates6() {
  var pts = this._segList.getCoordinates();
  return pts;
};
OffsetSegmentGenerator.prototype.addMitreJoin = function addMitreJoin(p2, offset0, offset1, distance11) {
  var isMitreWithinLimit = true;
  var intPt = null;
  try {
    intPt = HCoordinate.intersection(offset0.p0, offset0.p1, offset1.p0, offset1.p1);
    var mitreRatio = distance11 <= 0 ? 1 : intPt.distance(p2) / Math.abs(distance11);
    if (mitreRatio > this._bufParams.getMitreLimit()) {
      isMitreWithinLimit = false;
    }
  } catch (ex) {
    if (ex instanceof NotRepresentableException) {
      intPt = new Coordinate(0, 0);
      isMitreWithinLimit = false;
    } else {
      throw ex;
    }
  } finally {
  }
  if (isMitreWithinLimit) {
    this._segList.addPt(intPt);
  } else {
    this.addLimitedMitreJoin(offset0, offset1, distance11, this._bufParams.getMitreLimit());
  }
};
OffsetSegmentGenerator.prototype.addFilletCorner = function addFilletCorner(p2, p0, p1, direction, radius) {
  var dx0 = p0.x - p2.x;
  var dy0 = p0.y - p2.y;
  var startAngle = Math.atan2(dy0, dx0);
  var dx1 = p1.x - p2.x;
  var dy1 = p1.y - p2.y;
  var endAngle = Math.atan2(dy1, dx1);
  if (direction === CGAlgorithms.CLOCKWISE) {
    if (startAngle <= endAngle) {
      startAngle += 2 * Math.PI;
    }
  } else {
    if (startAngle >= endAngle) {
      startAngle -= 2 * Math.PI;
    }
  }
  this._segList.addPt(p0);
  this.addFilletArc(p2, startAngle, endAngle, direction, radius);
  this._segList.addPt(p1);
};
OffsetSegmentGenerator.prototype.addOutsideTurn = function addOutsideTurn(orientation2, addStartPoint) {
  if (this._offset0.p1.distance(this._offset1.p0) < this._distance * OffsetSegmentGenerator.OFFSET_SEGMENT_SEPARATION_FACTOR) {
    this._segList.addPt(this._offset0.p1);
    return null;
  }
  if (this._bufParams.getJoinStyle() === BufferParameters.JOIN_MITRE) {
    this.addMitreJoin(this._s1, this._offset0, this._offset1, this._distance);
  } else if (this._bufParams.getJoinStyle() === BufferParameters.JOIN_BEVEL) {
    this.addBevelJoin(this._offset0, this._offset1);
  } else {
    if (addStartPoint) {
      this._segList.addPt(this._offset0.p1);
    }
    this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, orientation2, this._distance);
    this._segList.addPt(this._offset1.p0);
  }
};
OffsetSegmentGenerator.prototype.createSquare = function createSquare(p2) {
  this._segList.addPt(new Coordinate(p2.x + this._distance, p2.y + this._distance));
  this._segList.addPt(new Coordinate(p2.x + this._distance, p2.y - this._distance));
  this._segList.addPt(new Coordinate(p2.x - this._distance, p2.y - this._distance));
  this._segList.addPt(new Coordinate(p2.x - this._distance, p2.y + this._distance));
  this._segList.closeRing();
};
OffsetSegmentGenerator.prototype.addSegments = function addSegments(pt, isForward) {
  this._segList.addPts(pt, isForward);
};
OffsetSegmentGenerator.prototype.addFirstSegment = function addFirstSegment() {
  this._segList.addPt(this._offset1.p0);
};
OffsetSegmentGenerator.prototype.addLastSegment = function addLastSegment() {
  this._segList.addPt(this._offset1.p1);
};
OffsetSegmentGenerator.prototype.initSideSegments = function initSideSegments(s1, s2, side) {
  this._s1 = s1;
  this._s2 = s2;
  this._side = side;
  this._seg1.setCoordinates(s1, s2);
  this.computeOffsetSegment(this._seg1, side, this._distance, this._offset1);
};
OffsetSegmentGenerator.prototype.addLimitedMitreJoin = function addLimitedMitreJoin(offset0, offset1, distance11, mitreLimit) {
  var basePt = this._seg0.p1;
  var ang0 = Angle.angle(basePt, this._seg0.p0);
  var angDiff = Angle.angleBetweenOriented(this._seg0.p0, basePt, this._seg1.p1);
  var angDiffHalf = angDiff / 2;
  var midAng = Angle.normalize(ang0 + angDiffHalf);
  var mitreMidAng = Angle.normalize(midAng + Math.PI);
  var mitreDist = mitreLimit * distance11;
  var bevelDelta = mitreDist * Math.abs(Math.sin(angDiffHalf));
  var bevelHalfLen = distance11 - bevelDelta;
  var bevelMidX = basePt.x + mitreDist * Math.cos(mitreMidAng);
  var bevelMidY = basePt.y + mitreDist * Math.sin(mitreMidAng);
  var bevelMidPt = new Coordinate(bevelMidX, bevelMidY);
  var mitreMidLine = new LineSegment(basePt, bevelMidPt);
  var bevelEndLeft = mitreMidLine.pointAlongOffset(1, bevelHalfLen);
  var bevelEndRight = mitreMidLine.pointAlongOffset(1, -bevelHalfLen);
  if (this._side === Position.LEFT) {
    this._segList.addPt(bevelEndLeft);
    this._segList.addPt(bevelEndRight);
  } else {
    this._segList.addPt(bevelEndRight);
    this._segList.addPt(bevelEndLeft);
  }
};
OffsetSegmentGenerator.prototype.computeOffsetSegment = function computeOffsetSegment(seg, side, distance11, offset) {
  var sideSign = side === Position.LEFT ? 1 : -1;
  var dx = seg.p1.x - seg.p0.x;
  var dy = seg.p1.y - seg.p0.y;
  var len2 = Math.sqrt(dx * dx + dy * dy);
  var ux = sideSign * distance11 * dx / len2;
  var uy = sideSign * distance11 * dy / len2;
  offset.p0.x = seg.p0.x - uy;
  offset.p0.y = seg.p0.y + ux;
  offset.p1.x = seg.p1.x - uy;
  offset.p1.y = seg.p1.y + ux;
};
OffsetSegmentGenerator.prototype.addFilletArc = function addFilletArc(p2, startAngle, endAngle, direction, radius) {
  var this$1$1 = this;
  var directionFactor = direction === CGAlgorithms.CLOCKWISE ? -1 : 1;
  var totalAngle = Math.abs(startAngle - endAngle);
  var nSegs = Math.trunc(totalAngle / this._filletAngleQuantum + 0.5);
  if (nSegs < 1) {
    return null;
  }
  var initAngle = 0;
  var currAngleInc = totalAngle / nSegs;
  var currAngle = initAngle;
  var pt = new Coordinate();
  while (currAngle < totalAngle) {
    var angle4 = startAngle + directionFactor * currAngle;
    pt.x = p2.x + radius * Math.cos(angle4);
    pt.y = p2.y + radius * Math.sin(angle4);
    this$1$1._segList.addPt(pt);
    currAngle += currAngleInc;
  }
};
OffsetSegmentGenerator.prototype.addInsideTurn = function addInsideTurn(orientation2, addStartPoint) {
  this._li.computeIntersection(this._offset0.p0, this._offset0.p1, this._offset1.p0, this._offset1.p1);
  if (this._li.hasIntersection()) {
    this._segList.addPt(this._li.getIntersection(0));
  } else {
    this._hasNarrowConcaveAngle = true;
    if (this._offset0.p1.distance(this._offset1.p0) < this._distance * OffsetSegmentGenerator.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR) {
      this._segList.addPt(this._offset0.p1);
    } else {
      this._segList.addPt(this._offset0.p1);
      if (this._closingSegLengthFactor > 0) {
        var mid0 = new Coordinate((this._closingSegLengthFactor * this._offset0.p1.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset0.p1.y + this._s1.y) / (this._closingSegLengthFactor + 1));
        this._segList.addPt(mid0);
        var mid1 = new Coordinate((this._closingSegLengthFactor * this._offset1.p0.x + this._s1.x) / (this._closingSegLengthFactor + 1), (this._closingSegLengthFactor * this._offset1.p0.y + this._s1.y) / (this._closingSegLengthFactor + 1));
        this._segList.addPt(mid1);
      } else {
        this._segList.addPt(this._s1);
      }
      this._segList.addPt(this._offset1.p0);
    }
  }
};
OffsetSegmentGenerator.prototype.createCircle = function createCircle(p2) {
  var pt = new Coordinate(p2.x + this._distance, p2.y);
  this._segList.addPt(pt);
  this.addFilletArc(p2, 0, 2 * Math.PI, -1, this._distance);
  this._segList.closeRing();
};
OffsetSegmentGenerator.prototype.addBevelJoin = function addBevelJoin(offset0, offset1) {
  this._segList.addPt(offset0.p1);
  this._segList.addPt(offset1.p0);
};
OffsetSegmentGenerator.prototype.init = function init6(distance11) {
  this._distance = distance11;
  this._maxCurveSegmentError = distance11 * (1 - Math.cos(this._filletAngleQuantum / 2));
  this._segList = new OffsetSegmentString();
  this._segList.setPrecisionModel(this._precisionModel);
  this._segList.setMinimumVertexDistance(distance11 * OffsetSegmentGenerator.CURVE_VERTEX_SNAP_DISTANCE_FACTOR);
};
OffsetSegmentGenerator.prototype.addCollinear = function addCollinear(addStartPoint) {
  this._li.computeIntersection(this._s0, this._s1, this._s1, this._s2);
  var numInt = this._li.getIntersectionNum();
  if (numInt >= 2) {
    if (this._bufParams.getJoinStyle() === BufferParameters.JOIN_BEVEL || this._bufParams.getJoinStyle() === BufferParameters.JOIN_MITRE) {
      if (addStartPoint) {
        this._segList.addPt(this._offset0.p1);
      }
      this._segList.addPt(this._offset1.p0);
    } else {
      this.addFilletCorner(this._s1, this._offset0.p1, this._offset1.p0, CGAlgorithms.CLOCKWISE, this._distance);
    }
  }
};
OffsetSegmentGenerator.prototype.closeRing = function closeRing2() {
  this._segList.closeRing();
};
OffsetSegmentGenerator.prototype.hasNarrowConcaveAngle = function hasNarrowConcaveAngle() {
  return this._hasNarrowConcaveAngle;
};
OffsetSegmentGenerator.prototype.interfaces_ = function interfaces_87() {
  return [];
};
OffsetSegmentGenerator.prototype.getClass = function getClass86() {
  return OffsetSegmentGenerator;
};
staticAccessors$27.OFFSET_SEGMENT_SEPARATION_FACTOR.get = function() {
  return 1e-3;
};
staticAccessors$27.INSIDE_TURN_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
  return 1e-3;
};
staticAccessors$27.CURVE_VERTEX_SNAP_DISTANCE_FACTOR.get = function() {
  return 1e-6;
};
staticAccessors$27.MAX_CLOSING_SEG_LEN_FACTOR.get = function() {
  return 80;
};
Object.defineProperties(OffsetSegmentGenerator, staticAccessors$27);
var OffsetCurveBuilder = function OffsetCurveBuilder2() {
  this._distance = 0;
  this._precisionModel = null;
  this._bufParams = null;
  var precisionModel = arguments[0];
  var bufParams = arguments[1];
  this._precisionModel = precisionModel;
  this._bufParams = bufParams;
};
OffsetCurveBuilder.prototype.getOffsetCurve = function getOffsetCurve(inputPts, distance11) {
  this._distance = distance11;
  if (distance11 === 0) {
    return null;
  }
  var isRightSide = distance11 < 0;
  var posDistance = Math.abs(distance11);
  var segGen = this.getSegGen(posDistance);
  if (inputPts.length <= 1) {
    this.computePointCurve(inputPts[0], segGen);
  } else {
    this.computeOffsetCurve(inputPts, isRightSide, segGen);
  }
  var curvePts = segGen.getCoordinates();
  if (isRightSide) {
    CoordinateArrays.reverse(curvePts);
  }
  return curvePts;
};
OffsetCurveBuilder.prototype.computeSingleSidedBufferCurve = function computeSingleSidedBufferCurve(inputPts, isRightSide, segGen) {
  var distTol = this.simplifyTolerance(this._distance);
  if (isRightSide) {
    segGen.addSegments(inputPts, true);
    var simp2 = BufferInputLineSimplifier.simplify(inputPts, -distTol);
    var n2 = simp2.length - 1;
    segGen.initSideSegments(simp2[n2], simp2[n2 - 1], Position.LEFT);
    segGen.addFirstSegment();
    for (var i2 = n2 - 2; i2 >= 0; i2--) {
      segGen.addNextSegment(simp2[i2], true);
    }
  } else {
    segGen.addSegments(inputPts, false);
    var simp1 = BufferInputLineSimplifier.simplify(inputPts, distTol);
    var n1 = simp1.length - 1;
    segGen.initSideSegments(simp1[0], simp1[1], Position.LEFT);
    segGen.addFirstSegment();
    for (var i$12 = 2; i$12 <= n1; i$12++) {
      segGen.addNextSegment(simp1[i$12], true);
    }
  }
  segGen.addLastSegment();
  segGen.closeRing();
};
OffsetCurveBuilder.prototype.computeRingBufferCurve = function computeRingBufferCurve(inputPts, side, segGen) {
  var distTol = this.simplifyTolerance(this._distance);
  if (side === Position.RIGHT) {
    distTol = -distTol;
  }
  var simp = BufferInputLineSimplifier.simplify(inputPts, distTol);
  var n2 = simp.length - 1;
  segGen.initSideSegments(simp[n2 - 1], simp[0], side);
  for (var i2 = 1; i2 <= n2; i2++) {
    var addStartPoint = i2 !== 1;
    segGen.addNextSegment(simp[i2], addStartPoint);
  }
  segGen.closeRing();
};
OffsetCurveBuilder.prototype.computeLineBufferCurve = function computeLineBufferCurve(inputPts, segGen) {
  var distTol = this.simplifyTolerance(this._distance);
  var simp1 = BufferInputLineSimplifier.simplify(inputPts, distTol);
  var n1 = simp1.length - 1;
  segGen.initSideSegments(simp1[0], simp1[1], Position.LEFT);
  for (var i2 = 2; i2 <= n1; i2++) {
    segGen.addNextSegment(simp1[i2], true);
  }
  segGen.addLastSegment();
  segGen.addLineEndCap(simp1[n1 - 1], simp1[n1]);
  var simp2 = BufferInputLineSimplifier.simplify(inputPts, -distTol);
  var n2 = simp2.length - 1;
  segGen.initSideSegments(simp2[n2], simp2[n2 - 1], Position.LEFT);
  for (var i$12 = n2 - 2; i$12 >= 0; i$12--) {
    segGen.addNextSegment(simp2[i$12], true);
  }
  segGen.addLastSegment();
  segGen.addLineEndCap(simp2[1], simp2[0]);
  segGen.closeRing();
};
OffsetCurveBuilder.prototype.computePointCurve = function computePointCurve(pt, segGen) {
  switch (this._bufParams.getEndCapStyle()) {
    case BufferParameters.CAP_ROUND:
      segGen.createCircle(pt);
      break;
    case BufferParameters.CAP_SQUARE:
      segGen.createSquare(pt);
      break;
  }
};
OffsetCurveBuilder.prototype.getLineCurve = function getLineCurve(inputPts, distance11) {
  this._distance = distance11;
  if (distance11 < 0 && !this._bufParams.isSingleSided()) {
    return null;
  }
  if (distance11 === 0) {
    return null;
  }
  var posDistance = Math.abs(distance11);
  var segGen = this.getSegGen(posDistance);
  if (inputPts.length <= 1) {
    this.computePointCurve(inputPts[0], segGen);
  } else {
    if (this._bufParams.isSingleSided()) {
      var isRightSide = distance11 < 0;
      this.computeSingleSidedBufferCurve(inputPts, isRightSide, segGen);
    } else {
      this.computeLineBufferCurve(inputPts, segGen);
    }
  }
  var lineCoord = segGen.getCoordinates();
  return lineCoord;
};
OffsetCurveBuilder.prototype.getBufferParameters = function getBufferParameters() {
  return this._bufParams;
};
OffsetCurveBuilder.prototype.simplifyTolerance = function simplifyTolerance(bufDistance) {
  return bufDistance * this._bufParams.getSimplifyFactor();
};
OffsetCurveBuilder.prototype.getRingCurve = function getRingCurve(inputPts, side, distance11) {
  this._distance = distance11;
  if (inputPts.length <= 2) {
    return this.getLineCurve(inputPts, distance11);
  }
  if (distance11 === 0) {
    return OffsetCurveBuilder.copyCoordinates(inputPts);
  }
  var segGen = this.getSegGen(distance11);
  this.computeRingBufferCurve(inputPts, side, segGen);
  return segGen.getCoordinates();
};
OffsetCurveBuilder.prototype.computeOffsetCurve = function computeOffsetCurve(inputPts, isRightSide, segGen) {
  var distTol = this.simplifyTolerance(this._distance);
  if (isRightSide) {
    var simp2 = BufferInputLineSimplifier.simplify(inputPts, -distTol);
    var n2 = simp2.length - 1;
    segGen.initSideSegments(simp2[n2], simp2[n2 - 1], Position.LEFT);
    segGen.addFirstSegment();
    for (var i2 = n2 - 2; i2 >= 0; i2--) {
      segGen.addNextSegment(simp2[i2], true);
    }
  } else {
    var simp1 = BufferInputLineSimplifier.simplify(inputPts, distTol);
    var n1 = simp1.length - 1;
    segGen.initSideSegments(simp1[0], simp1[1], Position.LEFT);
    segGen.addFirstSegment();
    for (var i$12 = 2; i$12 <= n1; i$12++) {
      segGen.addNextSegment(simp1[i$12], true);
    }
  }
  segGen.addLastSegment();
};
OffsetCurveBuilder.prototype.getSegGen = function getSegGen(distance11) {
  return new OffsetSegmentGenerator(this._precisionModel, this._bufParams, distance11);
};
OffsetCurveBuilder.prototype.interfaces_ = function interfaces_88() {
  return [];
};
OffsetCurveBuilder.prototype.getClass = function getClass87() {
  return OffsetCurveBuilder;
};
OffsetCurveBuilder.copyCoordinates = function copyCoordinates(pts) {
  var copy8 = new Array(pts.length).fill(null);
  for (var i2 = 0; i2 < copy8.length; i2++) {
    copy8[i2] = new Coordinate(pts[i2]);
  }
  return copy8;
};
var SubgraphDepthLocater = function SubgraphDepthLocater2() {
  this._subgraphs = null;
  this._seg = new LineSegment();
  this._cga = new CGAlgorithms();
  var subgraphs = arguments[0];
  this._subgraphs = subgraphs;
};
var staticAccessors$30 = { DepthSegment: { configurable: true } };
SubgraphDepthLocater.prototype.findStabbedSegments = function findStabbedSegments() {
  var this$1$1 = this;
  if (arguments.length === 1) {
    var stabbingRayLeftPt = arguments[0];
    var stabbedSegments = new ArrayList();
    for (var i2 = this._subgraphs.iterator(); i2.hasNext(); ) {
      var bsg = i2.next();
      var env = bsg.getEnvelope();
      if (stabbingRayLeftPt.y < env.getMinY() || stabbingRayLeftPt.y > env.getMaxY()) {
        continue;
      }
      this$1$1.findStabbedSegments(stabbingRayLeftPt, bsg.getDirectedEdges(), stabbedSegments);
    }
    return stabbedSegments;
  } else if (arguments.length === 3) {
    if (hasInterface(arguments[2], List$2) && (arguments[0] instanceof Coordinate && arguments[1] instanceof DirectedEdge)) {
      var stabbingRayLeftPt$1 = arguments[0];
      var dirEdge = arguments[1];
      var stabbedSegments$1 = arguments[2];
      var pts = dirEdge.getEdge().getCoordinates();
      for (var i$12 = 0; i$12 < pts.length - 1; i$12++) {
        this$1$1._seg.p0 = pts[i$12];
        this$1$1._seg.p1 = pts[i$12 + 1];
        if (this$1$1._seg.p0.y > this$1$1._seg.p1.y) {
          this$1$1._seg.reverse();
        }
        var maxx = Math.max(this$1$1._seg.p0.x, this$1$1._seg.p1.x);
        if (maxx < stabbingRayLeftPt$1.x) {
          continue;
        }
        if (this$1$1._seg.isHorizontal()) {
          continue;
        }
        if (stabbingRayLeftPt$1.y < this$1$1._seg.p0.y || stabbingRayLeftPt$1.y > this$1$1._seg.p1.y) {
          continue;
        }
        if (CGAlgorithms.computeOrientation(this$1$1._seg.p0, this$1$1._seg.p1, stabbingRayLeftPt$1) === CGAlgorithms.RIGHT) {
          continue;
        }
        var depth2 = dirEdge.getDepth(Position.LEFT);
        if (!this$1$1._seg.p0.equals(pts[i$12])) {
          depth2 = dirEdge.getDepth(Position.RIGHT);
        }
        var ds = new DepthSegment(this$1$1._seg, depth2);
        stabbedSegments$1.add(ds);
      }
    } else if (hasInterface(arguments[2], List$2) && (arguments[0] instanceof Coordinate && hasInterface(arguments[1], List$2))) {
      var stabbingRayLeftPt$2 = arguments[0];
      var dirEdges = arguments[1];
      var stabbedSegments$2 = arguments[2];
      for (var i$22 = dirEdges.iterator(); i$22.hasNext(); ) {
        var de = i$22.next();
        if (!de.isForward()) {
          continue;
        }
        this$1$1.findStabbedSegments(stabbingRayLeftPt$2, de, stabbedSegments$2);
      }
    }
  }
};
SubgraphDepthLocater.prototype.getDepth = function getDepth(p2) {
  var stabbedSegments = this.findStabbedSegments(p2);
  if (stabbedSegments.size() === 0) {
    return 0;
  }
  var ds = Collections.min(stabbedSegments);
  return ds._leftDepth;
};
SubgraphDepthLocater.prototype.interfaces_ = function interfaces_89() {
  return [];
};
SubgraphDepthLocater.prototype.getClass = function getClass88() {
  return SubgraphDepthLocater;
};
staticAccessors$30.DepthSegment.get = function() {
  return DepthSegment;
};
Object.defineProperties(SubgraphDepthLocater, staticAccessors$30);
var DepthSegment = function DepthSegment2() {
  this._upwardSeg = null;
  this._leftDepth = null;
  var seg = arguments[0];
  var depth2 = arguments[1];
  this._upwardSeg = new LineSegment(seg);
  this._leftDepth = depth2;
};
DepthSegment.prototype.compareTo = function compareTo12(obj) {
  var other = obj;
  if (this._upwardSeg.minX() >= other._upwardSeg.maxX()) {
    return 1;
  }
  if (this._upwardSeg.maxX() <= other._upwardSeg.minX()) {
    return -1;
  }
  var orientIndex = this._upwardSeg.orientationIndex(other._upwardSeg);
  if (orientIndex !== 0) {
    return orientIndex;
  }
  orientIndex = -1 * other._upwardSeg.orientationIndex(this._upwardSeg);
  if (orientIndex !== 0) {
    return orientIndex;
  }
  return this._upwardSeg.compareTo(other._upwardSeg);
};
DepthSegment.prototype.compareX = function compareX2(seg0, seg1) {
  var compare0 = seg0.p0.compareTo(seg1.p0);
  if (compare0 !== 0) {
    return compare0;
  }
  return seg0.p1.compareTo(seg1.p1);
};
DepthSegment.prototype.toString = function toString18() {
  return this._upwardSeg.toString();
};
DepthSegment.prototype.interfaces_ = function interfaces_90() {
  return [Comparable];
};
DepthSegment.prototype.getClass = function getClass89() {
  return DepthSegment;
};
var Triangle$1 = function Triangle2(p0, p1, p2) {
  this.p0 = p0 || null;
  this.p1 = p1 || null;
  this.p2 = p2 || null;
};
Triangle$1.prototype.area = function area3() {
  return Triangle$1.area(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.signedArea = function signedArea3() {
  return Triangle$1.signedArea(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.interpolateZ = function interpolateZ(p2) {
  if (p2 === null) {
    throw new IllegalArgumentException("Supplied point is null.");
  }
  return Triangle$1.interpolateZ(p2, this.p0, this.p1, this.p2);
};
Triangle$1.prototype.longestSideLength = function longestSideLength() {
  return Triangle$1.longestSideLength(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.isAcute = function isAcute2() {
  return Triangle$1.isAcute(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.circumcentre = function circumcentre() {
  return Triangle$1.circumcentre(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.area3D = function area3D() {
  return Triangle$1.area3D(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.centroid = function centroid2() {
  return Triangle$1.centroid(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.inCentre = function inCentre() {
  return Triangle$1.inCentre(this.p0, this.p1, this.p2);
};
Triangle$1.prototype.interfaces_ = function interfaces_91() {
  return [];
};
Triangle$1.prototype.getClass = function getClass90() {
  return Triangle$1;
};
Triangle$1.area = function area4(a2, b2, c2) {
  return Math.abs(((c2.x - a2.x) * (b2.y - a2.y) - (b2.x - a2.x) * (c2.y - a2.y)) / 2);
};
Triangle$1.signedArea = function signedArea4(a2, b2, c2) {
  return ((c2.x - a2.x) * (b2.y - a2.y) - (b2.x - a2.x) * (c2.y - a2.y)) / 2;
};
Triangle$1.det = function det(m00, m01, m10, m11) {
  return m00 * m11 - m01 * m10;
};
Triangle$1.interpolateZ = function interpolateZ2(p2, v0, v12, v22) {
  var x02 = v0.x;
  var y02 = v0.y;
  var a2 = v12.x - x02;
  var b2 = v22.x - x02;
  var c2 = v12.y - y02;
  var d2 = v22.y - y02;
  var det2 = a2 * d2 - b2 * c2;
  var dx = p2.x - x02;
  var dy = p2.y - y02;
  var t2 = (d2 * dx - b2 * dy) / det2;
  var u2 = (-c2 * dx + a2 * dy) / det2;
  var z2 = v0.z + t2 * (v12.z - v0.z) + u2 * (v22.z - v0.z);
  return z2;
};
Triangle$1.longestSideLength = function longestSideLength2(a2, b2, c2) {
  var lenAB = a2.distance(b2);
  var lenBC = b2.distance(c2);
  var lenCA = c2.distance(a2);
  var maxLen = lenAB;
  if (lenBC > maxLen) {
    maxLen = lenBC;
  }
  if (lenCA > maxLen) {
    maxLen = lenCA;
  }
  return maxLen;
};
Triangle$1.isAcute = function isAcute3(a2, b2, c2) {
  if (!Angle.isAcute(a2, b2, c2)) {
    return false;
  }
  if (!Angle.isAcute(b2, c2, a2)) {
    return false;
  }
  if (!Angle.isAcute(c2, a2, b2)) {
    return false;
  }
  return true;
};
Triangle$1.circumcentre = function circumcentre2(a2, b2, c2) {
  var cx = c2.x;
  var cy = c2.y;
  var ax2 = a2.x - cx;
  var ay2 = a2.y - cy;
  var bx2 = b2.x - cx;
  var by2 = b2.y - cy;
  var denom = 2 * Triangle$1.det(ax2, ay2, bx2, by2);
  var numx = Triangle$1.det(ay2, ax2 * ax2 + ay2 * ay2, by2, bx2 * bx2 + by2 * by2);
  var numy = Triangle$1.det(ax2, ax2 * ax2 + ay2 * ay2, bx2, bx2 * bx2 + by2 * by2);
  var ccx = cx - numx / denom;
  var ccy = cy + numy / denom;
  return new Coordinate(ccx, ccy);
};
Triangle$1.perpendicularBisector = function perpendicularBisector(a2, b2) {
  var dx = b2.x - a2.x;
  var dy = b2.y - a2.y;
  var l1 = new HCoordinate(a2.x + dx / 2, a2.y + dy / 2, 1);
  var l2 = new HCoordinate(a2.x - dy + dx / 2, a2.y + dx + dy / 2, 1);
  return new HCoordinate(l1, l2);
};
Triangle$1.angleBisector = function angleBisector(a2, b2, c2) {
  var len0 = b2.distance(a2);
  var len2 = b2.distance(c2);
  var frac = len0 / (len0 + len2);
  var dx = c2.x - a2.x;
  var dy = c2.y - a2.y;
  var splitPt = new Coordinate(a2.x + frac * dx, a2.y + frac * dy);
  return splitPt;
};
Triangle$1.area3D = function area3D2(a2, b2, c2) {
  var ux = b2.x - a2.x;
  var uy = b2.y - a2.y;
  var uz = b2.z - a2.z;
  var vx = c2.x - a2.x;
  var vy = c2.y - a2.y;
  var vz = c2.z - a2.z;
  var crossx = uy * vz - uz * vy;
  var crossy = uz * vx - ux * vz;
  var crossz = ux * vy - uy * vx;
  var absSq = crossx * crossx + crossy * crossy + crossz * crossz;
  var area3D3 = Math.sqrt(absSq) / 2;
  return area3D3;
};
Triangle$1.centroid = function centroid3(a2, b2, c2) {
  var x2 = (a2.x + b2.x + c2.x) / 3;
  var y2 = (a2.y + b2.y + c2.y) / 3;
  return new Coordinate(x2, y2);
};
Triangle$1.inCentre = function inCentre2(a2, b2, c2) {
  var len0 = b2.distance(c2);
  var len1 = a2.distance(c2);
  var len2 = a2.distance(b2);
  var circum = len0 + len1 + len2;
  var inCentreX = (len0 * a2.x + len1 * b2.x + len2 * c2.x) / circum;
  var inCentreY = (len0 * a2.y + len1 * b2.y + len2 * c2.y) / circum;
  return new Coordinate(inCentreX, inCentreY);
};
var OffsetCurveSetBuilder = function OffsetCurveSetBuilder2() {
  this._inputGeom = null;
  this._distance = null;
  this._curveBuilder = null;
  this._curveList = new ArrayList();
  var inputGeom = arguments[0];
  var distance11 = arguments[1];
  var curveBuilder = arguments[2];
  this._inputGeom = inputGeom;
  this._distance = distance11;
  this._curveBuilder = curveBuilder;
};
OffsetCurveSetBuilder.prototype.addPoint = function addPoint(p2) {
  if (this._distance <= 0) {
    return null;
  }
  var coord = p2.getCoordinates();
  var curve = this._curveBuilder.getLineCurve(coord, this._distance);
  this.addCurve(curve, Location.EXTERIOR, Location.INTERIOR);
};
OffsetCurveSetBuilder.prototype.addPolygon = function addPolygon(p2) {
  var this$1$1 = this;
  var offsetDistance = this._distance;
  var offsetSide = Position.LEFT;
  if (this._distance < 0) {
    offsetDistance = -this._distance;
    offsetSide = Position.RIGHT;
  }
  var shell = p2.getExteriorRing();
  var shellCoord = CoordinateArrays.removeRepeatedPoints(shell.getCoordinates());
  if (this._distance < 0 && this.isErodedCompletely(shell, this._distance)) {
    return null;
  }
  if (this._distance <= 0 && shellCoord.length < 3) {
    return null;
  }
  this.addPolygonRing(shellCoord, offsetDistance, offsetSide, Location.EXTERIOR, Location.INTERIOR);
  for (var i2 = 0; i2 < p2.getNumInteriorRing(); i2++) {
    var hole = p2.getInteriorRingN(i2);
    var holeCoord = CoordinateArrays.removeRepeatedPoints(hole.getCoordinates());
    if (this$1$1._distance > 0 && this$1$1.isErodedCompletely(hole, -this$1$1._distance)) {
      continue;
    }
    this$1$1.addPolygonRing(holeCoord, offsetDistance, Position.opposite(offsetSide), Location.INTERIOR, Location.EXTERIOR);
  }
};
OffsetCurveSetBuilder.prototype.isTriangleErodedCompletely = function isTriangleErodedCompletely(triangleCoord, bufferDistance) {
  var tri = new Triangle$1(triangleCoord[0], triangleCoord[1], triangleCoord[2]);
  var inCentre3 = tri.inCentre();
  var distToCentre = CGAlgorithms.distancePointLine(inCentre3, tri.p0, tri.p1);
  return distToCentre < Math.abs(bufferDistance);
};
OffsetCurveSetBuilder.prototype.addLineString = function addLineString(line) {
  if (this._distance <= 0 && !this._curveBuilder.getBufferParameters().isSingleSided()) {
    return null;
  }
  var coord = CoordinateArrays.removeRepeatedPoints(line.getCoordinates());
  var curve = this._curveBuilder.getLineCurve(coord, this._distance);
  this.addCurve(curve, Location.EXTERIOR, Location.INTERIOR);
};
OffsetCurveSetBuilder.prototype.addCurve = function addCurve(coord, leftLoc, rightLoc) {
  if (coord === null || coord.length < 2) {
    return null;
  }
  var e3 = new NodedSegmentString(coord, new Label(0, Location.BOUNDARY, leftLoc, rightLoc));
  this._curveList.add(e3);
};
OffsetCurveSetBuilder.prototype.getCurves = function getCurves() {
  this.add(this._inputGeom);
  return this._curveList;
};
OffsetCurveSetBuilder.prototype.addPolygonRing = function addPolygonRing(coord, offsetDistance, side, cwLeftLoc, cwRightLoc) {
  if (offsetDistance === 0 && coord.length < LinearRing.MINIMUM_VALID_SIZE) {
    return null;
  }
  var leftLoc = cwLeftLoc;
  var rightLoc = cwRightLoc;
  if (coord.length >= LinearRing.MINIMUM_VALID_SIZE && CGAlgorithms.isCCW(coord)) {
    leftLoc = cwRightLoc;
    rightLoc = cwLeftLoc;
    side = Position.opposite(side);
  }
  var curve = this._curveBuilder.getRingCurve(coord, side, offsetDistance);
  this.addCurve(curve, leftLoc, rightLoc);
};
OffsetCurveSetBuilder.prototype.add = function add10(g2) {
  if (g2.isEmpty()) {
    return null;
  }
  if (g2 instanceof Polygon$5) {
    this.addPolygon(g2);
  } else if (g2 instanceof LineString$4) {
    this.addLineString(g2);
  } else if (g2 instanceof Point$7) {
    this.addPoint(g2);
  } else if (g2 instanceof MultiPoint$1) {
    this.addCollection(g2);
  } else if (g2 instanceof MultiLineString$1) {
    this.addCollection(g2);
  } else if (g2 instanceof MultiPolygon$1) {
    this.addCollection(g2);
  } else if (g2 instanceof GeometryCollection) {
    this.addCollection(g2);
  }
};
OffsetCurveSetBuilder.prototype.isErodedCompletely = function isErodedCompletely(ring, bufferDistance) {
  var ringCoord = ring.getCoordinates();
  if (ringCoord.length < 4) {
    return bufferDistance < 0;
  }
  if (ringCoord.length === 4) {
    return this.isTriangleErodedCompletely(ringCoord, bufferDistance);
  }
  var env = ring.getEnvelopeInternal();
  var envMinDimension = Math.min(env.getHeight(), env.getWidth());
  if (bufferDistance < 0 && 2 * Math.abs(bufferDistance) > envMinDimension) {
    return true;
  }
  return false;
};
OffsetCurveSetBuilder.prototype.addCollection = function addCollection(gc) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < gc.getNumGeometries(); i2++) {
    var g2 = gc.getGeometryN(i2);
    this$1$1.add(g2);
  }
};
OffsetCurveSetBuilder.prototype.interfaces_ = function interfaces_92() {
  return [];
};
OffsetCurveSetBuilder.prototype.getClass = function getClass91() {
  return OffsetCurveSetBuilder;
};
var PointOnGeometryLocator = function PointOnGeometryLocator2() {
};
PointOnGeometryLocator.prototype.locate = function locate(p2) {
};
PointOnGeometryLocator.prototype.interfaces_ = function interfaces_93() {
  return [];
};
PointOnGeometryLocator.prototype.getClass = function getClass92() {
  return PointOnGeometryLocator;
};
var GeometryCollectionIterator = function GeometryCollectionIterator2() {
  this._parent = null;
  this._atStart = null;
  this._max = null;
  this._index = null;
  this._subcollectionIterator = null;
  var parent = arguments[0];
  this._parent = parent;
  this._atStart = true;
  this._index = 0;
  this._max = parent.getNumGeometries();
};
GeometryCollectionIterator.prototype.next = function next2() {
  if (this._atStart) {
    this._atStart = false;
    if (GeometryCollectionIterator.isAtomic(this._parent)) {
      this._index++;
    }
    return this._parent;
  }
  if (this._subcollectionIterator !== null) {
    if (this._subcollectionIterator.hasNext()) {
      return this._subcollectionIterator.next();
    } else {
      this._subcollectionIterator = null;
    }
  }
  if (this._index >= this._max) {
    throw new NoSuchElementException();
  }
  var obj = this._parent.getGeometryN(this._index++);
  if (obj instanceof GeometryCollection) {
    this._subcollectionIterator = new GeometryCollectionIterator(obj);
    return this._subcollectionIterator.next();
  }
  return obj;
};
GeometryCollectionIterator.prototype.remove = function remove5() {
  throw new Error(this.getClass().getName());
};
GeometryCollectionIterator.prototype.hasNext = function hasNext2() {
  if (this._atStart) {
    return true;
  }
  if (this._subcollectionIterator !== null) {
    if (this._subcollectionIterator.hasNext()) {
      return true;
    }
    this._subcollectionIterator = null;
  }
  if (this._index >= this._max) {
    return false;
  }
  return true;
};
GeometryCollectionIterator.prototype.interfaces_ = function interfaces_94() {
  return [Iterator];
};
GeometryCollectionIterator.prototype.getClass = function getClass93() {
  return GeometryCollectionIterator;
};
GeometryCollectionIterator.isAtomic = function isAtomic(geom) {
  return !(geom instanceof GeometryCollection);
};
var SimplePointInAreaLocator = function SimplePointInAreaLocator2() {
  this._geom = null;
  var geom = arguments[0];
  this._geom = geom;
};
SimplePointInAreaLocator.prototype.locate = function locate2(p2) {
  return SimplePointInAreaLocator.locate(p2, this._geom);
};
SimplePointInAreaLocator.prototype.interfaces_ = function interfaces_95() {
  return [PointOnGeometryLocator];
};
SimplePointInAreaLocator.prototype.getClass = function getClass94() {
  return SimplePointInAreaLocator;
};
SimplePointInAreaLocator.isPointInRing = function isPointInRing2(p2, ring) {
  if (!ring.getEnvelopeInternal().intersects(p2)) {
    return false;
  }
  return CGAlgorithms.isPointInRing(p2, ring.getCoordinates());
};
SimplePointInAreaLocator.containsPointInPolygon = function containsPointInPolygon(p2, poly2) {
  if (poly2.isEmpty()) {
    return false;
  }
  var shell = poly2.getExteriorRing();
  if (!SimplePointInAreaLocator.isPointInRing(p2, shell)) {
    return false;
  }
  for (var i2 = 0; i2 < poly2.getNumInteriorRing(); i2++) {
    var hole = poly2.getInteriorRingN(i2);
    if (SimplePointInAreaLocator.isPointInRing(p2, hole)) {
      return false;
    }
  }
  return true;
};
SimplePointInAreaLocator.containsPoint = function containsPoint3(p2, geom) {
  if (geom instanceof Polygon$5) {
    return SimplePointInAreaLocator.containsPointInPolygon(p2, geom);
  } else if (geom instanceof GeometryCollection) {
    var geomi = new GeometryCollectionIterator(geom);
    while (geomi.hasNext()) {
      var g2 = geomi.next();
      if (g2 !== geom) {
        if (SimplePointInAreaLocator.containsPoint(p2, g2)) {
          return true;
        }
      }
    }
  }
  return false;
};
SimplePointInAreaLocator.locate = function locate3(p2, geom) {
  if (geom.isEmpty()) {
    return Location.EXTERIOR;
  }
  if (SimplePointInAreaLocator.containsPoint(p2, geom)) {
    return Location.INTERIOR;
  }
  return Location.EXTERIOR;
};
var EdgeEndStar = function EdgeEndStar2() {
  this._edgeMap = new TreeMap();
  this._edgeList = null;
  this._ptInAreaLocation = [Location.NONE, Location.NONE];
};
EdgeEndStar.prototype.getNextCW = function getNextCW(ee) {
  this.getEdges();
  var i2 = this._edgeList.indexOf(ee);
  var iNextCW = i2 - 1;
  if (i2 === 0) {
    iNextCW = this._edgeList.size() - 1;
  }
  return this._edgeList.get(iNextCW);
};
EdgeEndStar.prototype.propagateSideLabels = function propagateSideLabels(geomIndex) {
  var startLoc = Location.NONE;
  for (var it = this.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    var label = e3.getLabel();
    if (label.isArea(geomIndex) && label.getLocation(geomIndex, Position.LEFT) !== Location.NONE) {
      startLoc = label.getLocation(geomIndex, Position.LEFT);
    }
  }
  if (startLoc === Location.NONE) {
    return null;
  }
  var currLoc = startLoc;
  for (var it$1 = this.iterator(); it$1.hasNext(); ) {
    var e$12 = it$1.next();
    var label$1 = e$12.getLabel();
    if (label$1.getLocation(geomIndex, Position.ON) === Location.NONE) {
      label$1.setLocation(geomIndex, Position.ON, currLoc);
    }
    if (label$1.isArea(geomIndex)) {
      var leftLoc = label$1.getLocation(geomIndex, Position.LEFT);
      var rightLoc = label$1.getLocation(geomIndex, Position.RIGHT);
      if (rightLoc !== Location.NONE) {
        if (rightLoc !== currLoc) {
          throw new TopologyException("side location conflict", e$12.getCoordinate());
        }
        if (leftLoc === Location.NONE) {
          Assert.shouldNeverReachHere("found single null side (at " + e$12.getCoordinate() + ")");
        }
        currLoc = leftLoc;
      } else {
        Assert.isTrue(label$1.getLocation(geomIndex, Position.LEFT) === Location.NONE, "found single null side");
        label$1.setLocation(geomIndex, Position.RIGHT, currLoc);
        label$1.setLocation(geomIndex, Position.LEFT, currLoc);
      }
    }
  }
};
EdgeEndStar.prototype.getCoordinate = function getCoordinate11() {
  var it = this.iterator();
  if (!it.hasNext()) {
    return null;
  }
  var e3 = it.next();
  return e3.getCoordinate();
};
EdgeEndStar.prototype.print = function print5(out) {
  System.out.println("EdgeEndStar:   " + this.getCoordinate());
  for (var it = this.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    e3.print(out);
  }
};
EdgeEndStar.prototype.isAreaLabelsConsistent = function isAreaLabelsConsistent(geomGraph) {
  this.computeEdgeEndLabels(geomGraph.getBoundaryNodeRule());
  return this.checkAreaLabelsConsistent(0);
};
EdgeEndStar.prototype.checkAreaLabelsConsistent = function checkAreaLabelsConsistent(geomIndex) {
  var edges = this.getEdges();
  if (edges.size() <= 0) {
    return true;
  }
  var lastEdgeIndex = edges.size() - 1;
  var startLabel = edges.get(lastEdgeIndex).getLabel();
  var startLoc = startLabel.getLocation(geomIndex, Position.LEFT);
  Assert.isTrue(startLoc !== Location.NONE, "Found unlabelled area edge");
  var currLoc = startLoc;
  for (var it = this.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    var label = e3.getLabel();
    Assert.isTrue(label.isArea(geomIndex), "Found non-area edge");
    var leftLoc = label.getLocation(geomIndex, Position.LEFT);
    var rightLoc = label.getLocation(geomIndex, Position.RIGHT);
    if (leftLoc === rightLoc) {
      return false;
    }
    if (rightLoc !== currLoc) {
      return false;
    }
    currLoc = leftLoc;
  }
  return true;
};
EdgeEndStar.prototype.findIndex = function findIndex2(eSearch) {
  var this$1$1 = this;
  this.iterator();
  for (var i2 = 0; i2 < this._edgeList.size(); i2++) {
    var e3 = this$1$1._edgeList.get(i2);
    if (e3 === eSearch) {
      return i2;
    }
  }
  return -1;
};
EdgeEndStar.prototype.iterator = function iterator4() {
  return this.getEdges().iterator();
};
EdgeEndStar.prototype.getEdges = function getEdges2() {
  if (this._edgeList === null) {
    this._edgeList = new ArrayList(this._edgeMap.values());
  }
  return this._edgeList;
};
EdgeEndStar.prototype.getLocation = function getLocation3(geomIndex, p2, geom) {
  if (this._ptInAreaLocation[geomIndex] === Location.NONE) {
    this._ptInAreaLocation[geomIndex] = SimplePointInAreaLocator.locate(p2, geom[geomIndex].getGeometry());
  }
  return this._ptInAreaLocation[geomIndex];
};
EdgeEndStar.prototype.toString = function toString19() {
  var buf = new StringBuffer();
  buf.append("EdgeEndStar:   " + this.getCoordinate());
  buf.append("\n");
  for (var it = this.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    buf.append(e3);
    buf.append("\n");
  }
  return buf.toString();
};
EdgeEndStar.prototype.computeEdgeEndLabels = function computeEdgeEndLabels(boundaryNodeRule) {
  for (var it = this.iterator(); it.hasNext(); ) {
    var ee = it.next();
    ee.computeLabel(boundaryNodeRule);
  }
};
EdgeEndStar.prototype.computeLabelling = function computeLabelling(geomGraph) {
  var this$1$1 = this;
  this.computeEdgeEndLabels(geomGraph[0].getBoundaryNodeRule());
  this.propagateSideLabels(0);
  this.propagateSideLabels(1);
  var hasDimensionalCollapseEdge = [false, false];
  for (var it = this.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    var label = e3.getLabel();
    for (var geomi = 0; geomi < 2; geomi++) {
      if (label.isLine(geomi) && label.getLocation(geomi) === Location.BOUNDARY) {
        hasDimensionalCollapseEdge[geomi] = true;
      }
    }
  }
  for (var it$1 = this.iterator(); it$1.hasNext(); ) {
    var e$12 = it$1.next();
    var label$1 = e$12.getLabel();
    for (var geomi$1 = 0; geomi$1 < 2; geomi$1++) {
      if (label$1.isAnyNull(geomi$1)) {
        var loc = Location.NONE;
        if (hasDimensionalCollapseEdge[geomi$1]) {
          loc = Location.EXTERIOR;
        } else {
          var p2 = e$12.getCoordinate();
          loc = this$1$1.getLocation(geomi$1, p2, geomGraph);
        }
        label$1.setAllLocationsIfNull(geomi$1, loc);
      }
    }
  }
};
EdgeEndStar.prototype.getDegree = function getDegree() {
  return this._edgeMap.size();
};
EdgeEndStar.prototype.insertEdgeEnd = function insertEdgeEnd(e3, obj) {
  this._edgeMap.put(e3, obj);
  this._edgeList = null;
};
EdgeEndStar.prototype.interfaces_ = function interfaces_96() {
  return [];
};
EdgeEndStar.prototype.getClass = function getClass95() {
  return EdgeEndStar;
};
var DirectedEdgeStar = function(EdgeEndStar$$1) {
  function DirectedEdgeStar2() {
    EdgeEndStar$$1.call(this);
    this._resultAreaEdgeList = null;
    this._label = null;
    this._SCANNING_FOR_INCOMING = 1;
    this._LINKING_TO_OUTGOING = 2;
  }
  if (EdgeEndStar$$1)
    DirectedEdgeStar2.__proto__ = EdgeEndStar$$1;
  DirectedEdgeStar2.prototype = Object.create(EdgeEndStar$$1 && EdgeEndStar$$1.prototype);
  DirectedEdgeStar2.prototype.constructor = DirectedEdgeStar2;
  DirectedEdgeStar2.prototype.linkResultDirectedEdges = function linkResultDirectedEdges3() {
    var this$1$1 = this;
    this.getResultAreaEdges();
    var firstOut = null;
    var incoming = null;
    var state = this._SCANNING_FOR_INCOMING;
    for (var i2 = 0; i2 < this._resultAreaEdgeList.size(); i2++) {
      var nextOut = this$1$1._resultAreaEdgeList.get(i2);
      var nextIn = nextOut.getSym();
      if (!nextOut.getLabel().isArea()) {
        continue;
      }
      if (firstOut === null && nextOut.isInResult()) {
        firstOut = nextOut;
      }
      switch (state) {
        case this$1$1._SCANNING_FOR_INCOMING:
          if (!nextIn.isInResult()) {
            continue;
          }
          incoming = nextIn;
          state = this$1$1._LINKING_TO_OUTGOING;
          break;
        case this$1$1._LINKING_TO_OUTGOING:
          if (!nextOut.isInResult()) {
            continue;
          }
          incoming.setNext(nextOut);
          state = this$1$1._SCANNING_FOR_INCOMING;
          break;
      }
    }
    if (state === this._LINKING_TO_OUTGOING) {
      if (firstOut === null) {
        throw new TopologyException("no outgoing dirEdge found", this.getCoordinate());
      }
      Assert.isTrue(firstOut.isInResult(), "unable to link last incoming dirEdge");
      incoming.setNext(firstOut);
    }
  };
  DirectedEdgeStar2.prototype.insert = function insert4(ee) {
    var de = ee;
    this.insertEdgeEnd(de, de);
  };
  DirectedEdgeStar2.prototype.getRightmostEdge = function getRightmostEdge() {
    var edges = this.getEdges();
    var size12 = edges.size();
    if (size12 < 1) {
      return null;
    }
    var de0 = edges.get(0);
    if (size12 === 1) {
      return de0;
    }
    var deLast = edges.get(size12 - 1);
    var quad0 = de0.getQuadrant();
    var quad1 = deLast.getQuadrant();
    if (Quadrant.isNorthern(quad0) && Quadrant.isNorthern(quad1)) {
      return de0;
    } else if (!Quadrant.isNorthern(quad0) && !Quadrant.isNorthern(quad1)) {
      return deLast;
    } else {
      if (de0.getDy() !== 0) {
        return de0;
      } else if (deLast.getDy() !== 0) {
        return deLast;
      }
    }
    Assert.shouldNeverReachHere("found two horizontal edges incident on node");
    return null;
  };
  DirectedEdgeStar2.prototype.print = function print9(out) {
    System.out.println("DirectedEdgeStar: " + this.getCoordinate());
    for (var it = this.iterator(); it.hasNext(); ) {
      var de = it.next();
      out.print("out ");
      de.print(out);
      out.println();
      out.print("in ");
      de.getSym().print(out);
      out.println();
    }
  };
  DirectedEdgeStar2.prototype.getResultAreaEdges = function getResultAreaEdges() {
    var this$1$1 = this;
    if (this._resultAreaEdgeList !== null) {
      return this._resultAreaEdgeList;
    }
    this._resultAreaEdgeList = new ArrayList();
    for (var it = this.iterator(); it.hasNext(); ) {
      var de = it.next();
      if (de.isInResult() || de.getSym().isInResult()) {
        this$1$1._resultAreaEdgeList.add(de);
      }
    }
    return this._resultAreaEdgeList;
  };
  DirectedEdgeStar2.prototype.updateLabelling = function updateLabelling(nodeLabel) {
    for (var it = this.iterator(); it.hasNext(); ) {
      var de = it.next();
      var label = de.getLabel();
      label.setAllLocationsIfNull(0, nodeLabel.getLocation(0));
      label.setAllLocationsIfNull(1, nodeLabel.getLocation(1));
    }
  };
  DirectedEdgeStar2.prototype.linkAllDirectedEdges = function linkAllDirectedEdges2() {
    var this$1$1 = this;
    this.getEdges();
    var prevOut = null;
    var firstIn = null;
    for (var i2 = this._edgeList.size() - 1; i2 >= 0; i2--) {
      var nextOut = this$1$1._edgeList.get(i2);
      var nextIn = nextOut.getSym();
      if (firstIn === null) {
        firstIn = nextIn;
      }
      if (prevOut !== null) {
        nextIn.setNext(prevOut);
      }
      prevOut = nextOut;
    }
    firstIn.setNext(prevOut);
  };
  DirectedEdgeStar2.prototype.computeDepths = function computeDepths2() {
    var this$1$1 = this;
    if (arguments.length === 1) {
      var de = arguments[0];
      var edgeIndex = this.findIndex(de);
      var startDepth = de.getDepth(Position.LEFT);
      var targetLastDepth = de.getDepth(Position.RIGHT);
      var nextDepth = this.computeDepths(edgeIndex + 1, this._edgeList.size(), startDepth);
      var lastDepth = this.computeDepths(0, edgeIndex, nextDepth);
      if (lastDepth !== targetLastDepth) {
        throw new TopologyException("depth mismatch at " + de.getCoordinate());
      }
    } else if (arguments.length === 3) {
      var startIndex = arguments[0];
      var endIndex = arguments[1];
      var startDepth$1 = arguments[2];
      var currDepth = startDepth$1;
      for (var i2 = startIndex; i2 < endIndex; i2++) {
        var nextDe = this$1$1._edgeList.get(i2);
        nextDe.setEdgeDepths(Position.RIGHT, currDepth);
        currDepth = nextDe.getDepth(Position.LEFT);
      }
      return currDepth;
    }
  };
  DirectedEdgeStar2.prototype.mergeSymLabels = function mergeSymLabels() {
    for (var it = this.iterator(); it.hasNext(); ) {
      var de = it.next();
      var label = de.getLabel();
      label.merge(de.getSym().getLabel());
    }
  };
  DirectedEdgeStar2.prototype.linkMinimalDirectedEdges = function linkMinimalDirectedEdges(er) {
    var this$1$1 = this;
    var firstOut = null;
    var incoming = null;
    var state = this._SCANNING_FOR_INCOMING;
    for (var i2 = this._resultAreaEdgeList.size() - 1; i2 >= 0; i2--) {
      var nextOut = this$1$1._resultAreaEdgeList.get(i2);
      var nextIn = nextOut.getSym();
      if (firstOut === null && nextOut.getEdgeRing() === er) {
        firstOut = nextOut;
      }
      switch (state) {
        case this$1$1._SCANNING_FOR_INCOMING:
          if (nextIn.getEdgeRing() !== er) {
            continue;
          }
          incoming = nextIn;
          state = this$1$1._LINKING_TO_OUTGOING;
          break;
        case this$1$1._LINKING_TO_OUTGOING:
          if (nextOut.getEdgeRing() !== er) {
            continue;
          }
          incoming.setNextMin(nextOut);
          state = this$1$1._SCANNING_FOR_INCOMING;
          break;
      }
    }
    if (state === this._LINKING_TO_OUTGOING) {
      Assert.isTrue(firstOut !== null, "found null for first outgoing dirEdge");
      Assert.isTrue(firstOut.getEdgeRing() === er, "unable to link last incoming dirEdge");
      incoming.setNextMin(firstOut);
    }
  };
  DirectedEdgeStar2.prototype.getOutgoingDegree = function getOutgoingDegree() {
    if (arguments.length === 0) {
      var degree = 0;
      for (var it = this.iterator(); it.hasNext(); ) {
        var de = it.next();
        if (de.isInResult()) {
          degree++;
        }
      }
      return degree;
    } else if (arguments.length === 1) {
      var er = arguments[0];
      var degree$1 = 0;
      for (var it$1 = this.iterator(); it$1.hasNext(); ) {
        var de$1 = it$1.next();
        if (de$1.getEdgeRing() === er) {
          degree$1++;
        }
      }
      return degree$1;
    }
  };
  DirectedEdgeStar2.prototype.getLabel = function getLabel4() {
    return this._label;
  };
  DirectedEdgeStar2.prototype.findCoveredLineEdges = function findCoveredLineEdges2() {
    var startLoc = Location.NONE;
    for (var it = this.iterator(); it.hasNext(); ) {
      var nextOut = it.next();
      var nextIn = nextOut.getSym();
      if (!nextOut.isLineEdge()) {
        if (nextOut.isInResult()) {
          startLoc = Location.INTERIOR;
          break;
        }
        if (nextIn.isInResult()) {
          startLoc = Location.EXTERIOR;
          break;
        }
      }
    }
    if (startLoc === Location.NONE) {
      return null;
    }
    var currLoc = startLoc;
    for (var it$1 = this.iterator(); it$1.hasNext(); ) {
      var nextOut$1 = it$1.next();
      var nextIn$1 = nextOut$1.getSym();
      if (nextOut$1.isLineEdge()) {
        nextOut$1.getEdge().setCovered(currLoc === Location.INTERIOR);
      } else {
        if (nextOut$1.isInResult()) {
          currLoc = Location.EXTERIOR;
        }
        if (nextIn$1.isInResult()) {
          currLoc = Location.INTERIOR;
        }
      }
    }
  };
  DirectedEdgeStar2.prototype.computeLabelling = function computeLabelling2(geom) {
    var this$1$1 = this;
    EdgeEndStar$$1.prototype.computeLabelling.call(this, geom);
    this._label = new Label(Location.NONE);
    for (var it = this.iterator(); it.hasNext(); ) {
      var ee = it.next();
      var e3 = ee.getEdge();
      var eLabel = e3.getLabel();
      for (var i2 = 0; i2 < 2; i2++) {
        var eLoc = eLabel.getLocation(i2);
        if (eLoc === Location.INTERIOR || eLoc === Location.BOUNDARY) {
          this$1$1._label.setLocation(i2, Location.INTERIOR);
        }
      }
    }
  };
  DirectedEdgeStar2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  DirectedEdgeStar2.prototype.getClass = function getClass169() {
    return DirectedEdgeStar2;
  };
  return DirectedEdgeStar2;
}(EdgeEndStar);
var OverlayNodeFactory = function(NodeFactory$$1) {
  function OverlayNodeFactory2() {
    NodeFactory$$1.apply(this, arguments);
  }
  if (NodeFactory$$1)
    OverlayNodeFactory2.__proto__ = NodeFactory$$1;
  OverlayNodeFactory2.prototype = Object.create(NodeFactory$$1 && NodeFactory$$1.prototype);
  OverlayNodeFactory2.prototype.constructor = OverlayNodeFactory2;
  OverlayNodeFactory2.prototype.createNode = function createNode3(coord) {
    return new Node$2(coord, new DirectedEdgeStar());
  };
  OverlayNodeFactory2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  OverlayNodeFactory2.prototype.getClass = function getClass169() {
    return OverlayNodeFactory2;
  };
  return OverlayNodeFactory2;
}(NodeFactory);
var OrientedCoordinateArray = function OrientedCoordinateArray2() {
  this._pts = null;
  this._orientation = null;
  var pts = arguments[0];
  this._pts = pts;
  this._orientation = OrientedCoordinateArray2.orientation(pts);
};
OrientedCoordinateArray.prototype.compareTo = function compareTo13(o1) {
  var oca = o1;
  var comp = OrientedCoordinateArray.compareOriented(this._pts, this._orientation, oca._pts, oca._orientation);
  return comp;
};
OrientedCoordinateArray.prototype.interfaces_ = function interfaces_97() {
  return [Comparable];
};
OrientedCoordinateArray.prototype.getClass = function getClass96() {
  return OrientedCoordinateArray;
};
OrientedCoordinateArray.orientation = function orientation(pts) {
  return CoordinateArrays.increasingDirection(pts) === 1;
};
OrientedCoordinateArray.compareOriented = function compareOriented(pts1, orientation1, pts2, orientation2) {
  var dir1 = orientation1 ? 1 : -1;
  var dir2 = orientation2 ? 1 : -1;
  var limit1 = orientation1 ? pts1.length : -1;
  var limit2 = orientation2 ? pts2.length : -1;
  var i1 = orientation1 ? 0 : pts1.length - 1;
  var i2 = orientation2 ? 0 : pts2.length - 1;
  while (true) {
    var compPt = pts1[i1].compareTo(pts2[i2]);
    if (compPt !== 0) {
      return compPt;
    }
    i1 += dir1;
    i2 += dir2;
    var done1 = i1 === limit1;
    var done2 = i2 === limit2;
    if (done1 && !done2) {
      return -1;
    }
    if (!done1 && done2) {
      return 1;
    }
    if (done1 && done2) {
      return 0;
    }
  }
};
var EdgeList = function EdgeList2() {
  this._edges = new ArrayList();
  this._ocaMap = new TreeMap();
};
EdgeList.prototype.print = function print6(out) {
  var this$1$1 = this;
  out.print("MULTILINESTRING ( ");
  for (var j2 = 0; j2 < this._edges.size(); j2++) {
    var e3 = this$1$1._edges.get(j2);
    if (j2 > 0) {
      out.print(",");
    }
    out.print("(");
    var pts = e3.getCoordinates();
    for (var i2 = 0; i2 < pts.length; i2++) {
      if (i2 > 0) {
        out.print(",");
      }
      out.print(pts[i2].x + " " + pts[i2].y);
    }
    out.println(")");
  }
  out.print(")  ");
};
EdgeList.prototype.addAll = function addAll2(edgeColl) {
  var this$1$1 = this;
  for (var i2 = edgeColl.iterator(); i2.hasNext(); ) {
    this$1$1.add(i2.next());
  }
};
EdgeList.prototype.findEdgeIndex = function findEdgeIndex(e3) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this._edges.size(); i2++) {
    if (this$1$1._edges.get(i2).equals(e3)) {
      return i2;
    }
  }
  return -1;
};
EdgeList.prototype.iterator = function iterator5() {
  return this._edges.iterator();
};
EdgeList.prototype.getEdges = function getEdges3() {
  return this._edges;
};
EdgeList.prototype.get = function get4(i2) {
  return this._edges.get(i2);
};
EdgeList.prototype.findEqualEdge = function findEqualEdge(e3) {
  var oca = new OrientedCoordinateArray(e3.getCoordinates());
  var matchEdge = this._ocaMap.get(oca);
  return matchEdge;
};
EdgeList.prototype.add = function add11(e3) {
  this._edges.add(e3);
  var oca = new OrientedCoordinateArray(e3.getCoordinates());
  this._ocaMap.put(oca, e3);
};
EdgeList.prototype.interfaces_ = function interfaces_98() {
  return [];
};
EdgeList.prototype.getClass = function getClass97() {
  return EdgeList;
};
var SegmentIntersector = function SegmentIntersector2() {
};
SegmentIntersector.prototype.processIntersections = function processIntersections(e0, segIndex0, e1, segIndex1) {
};
SegmentIntersector.prototype.isDone = function isDone2() {
};
SegmentIntersector.prototype.interfaces_ = function interfaces_99() {
  return [];
};
SegmentIntersector.prototype.getClass = function getClass98() {
  return SegmentIntersector;
};
var IntersectionAdder = function IntersectionAdder2() {
  this._hasIntersection = false;
  this._hasProper = false;
  this._hasProperInterior = false;
  this._hasInterior = false;
  this._properIntersectionPoint = null;
  this._li = null;
  this._isSelfIntersection = null;
  this.numIntersections = 0;
  this.numInteriorIntersections = 0;
  this.numProperIntersections = 0;
  this.numTests = 0;
  var li = arguments[0];
  this._li = li;
};
IntersectionAdder.prototype.isTrivialIntersection = function isTrivialIntersection(e0, segIndex0, e1, segIndex1) {
  if (e0 === e1) {
    if (this._li.getIntersectionNum() === 1) {
      if (IntersectionAdder.isAdjacentSegments(segIndex0, segIndex1)) {
        return true;
      }
      if (e0.isClosed()) {
        var maxSegIndex = e0.size() - 1;
        if (segIndex0 === 0 && segIndex1 === maxSegIndex || segIndex1 === 0 && segIndex0 === maxSegIndex) {
          return true;
        }
      }
    }
  }
  return false;
};
IntersectionAdder.prototype.getProperIntersectionPoint = function getProperIntersectionPoint() {
  return this._properIntersectionPoint;
};
IntersectionAdder.prototype.hasProperInteriorIntersection = function hasProperInteriorIntersection() {
  return this._hasProperInterior;
};
IntersectionAdder.prototype.getLineIntersector = function getLineIntersector() {
  return this._li;
};
IntersectionAdder.prototype.hasProperIntersection = function hasProperIntersection() {
  return this._hasProper;
};
IntersectionAdder.prototype.processIntersections = function processIntersections2(e0, segIndex0, e1, segIndex1) {
  if (e0 === e1 && segIndex0 === segIndex1) {
    return null;
  }
  this.numTests++;
  var p00 = e0.getCoordinates()[segIndex0];
  var p01 = e0.getCoordinates()[segIndex0 + 1];
  var p10 = e1.getCoordinates()[segIndex1];
  var p11 = e1.getCoordinates()[segIndex1 + 1];
  this._li.computeIntersection(p00, p01, p10, p11);
  if (this._li.hasIntersection()) {
    this.numIntersections++;
    if (this._li.isInteriorIntersection()) {
      this.numInteriorIntersections++;
      this._hasInterior = true;
    }
    if (!this.isTrivialIntersection(e0, segIndex0, e1, segIndex1)) {
      this._hasIntersection = true;
      e0.addIntersections(this._li, segIndex0, 0);
      e1.addIntersections(this._li, segIndex1, 1);
      if (this._li.isProper()) {
        this.numProperIntersections++;
        this._hasProper = true;
        this._hasProperInterior = true;
      }
    }
  }
};
IntersectionAdder.prototype.hasIntersection = function hasIntersection2() {
  return this._hasIntersection;
};
IntersectionAdder.prototype.isDone = function isDone3() {
  return false;
};
IntersectionAdder.prototype.hasInteriorIntersection = function hasInteriorIntersection() {
  return this._hasInterior;
};
IntersectionAdder.prototype.interfaces_ = function interfaces_100() {
  return [SegmentIntersector];
};
IntersectionAdder.prototype.getClass = function getClass99() {
  return IntersectionAdder;
};
IntersectionAdder.isAdjacentSegments = function isAdjacentSegments(i1, i2) {
  return Math.abs(i1 - i2) === 1;
};
var EdgeIntersection = function EdgeIntersection2() {
  this.coord = null;
  this.segmentIndex = null;
  this.dist = null;
  var coord = arguments[0];
  var segmentIndex = arguments[1];
  var dist2 = arguments[2];
  this.coord = new Coordinate(coord);
  this.segmentIndex = segmentIndex;
  this.dist = dist2;
};
EdgeIntersection.prototype.getSegmentIndex = function getSegmentIndex() {
  return this.segmentIndex;
};
EdgeIntersection.prototype.getCoordinate = function getCoordinate12() {
  return this.coord;
};
EdgeIntersection.prototype.print = function print7(out) {
  out.print(this.coord);
  out.print(" seg # = " + this.segmentIndex);
  out.println(" dist = " + this.dist);
};
EdgeIntersection.prototype.compareTo = function compareTo14(obj) {
  var other = obj;
  return this.compare(other.segmentIndex, other.dist);
};
EdgeIntersection.prototype.isEndPoint = function isEndPoint3(maxSegmentIndex) {
  if (this.segmentIndex === 0 && this.dist === 0) {
    return true;
  }
  if (this.segmentIndex === maxSegmentIndex) {
    return true;
  }
  return false;
};
EdgeIntersection.prototype.toString = function toString20() {
  return this.coord + " seg # = " + this.segmentIndex + " dist = " + this.dist;
};
EdgeIntersection.prototype.getDistance = function getDistance2() {
  return this.dist;
};
EdgeIntersection.prototype.compare = function compare8(segmentIndex, dist2) {
  if (this.segmentIndex < segmentIndex) {
    return -1;
  }
  if (this.segmentIndex > segmentIndex) {
    return 1;
  }
  if (this.dist < dist2) {
    return -1;
  }
  if (this.dist > dist2) {
    return 1;
  }
  return 0;
};
EdgeIntersection.prototype.interfaces_ = function interfaces_101() {
  return [Comparable];
};
EdgeIntersection.prototype.getClass = function getClass100() {
  return EdgeIntersection;
};
var EdgeIntersectionList = function EdgeIntersectionList2() {
  this._nodeMap = new TreeMap();
  this.edge = null;
  var edge = arguments[0];
  this.edge = edge;
};
EdgeIntersectionList.prototype.print = function print8(out) {
  out.println("Intersections:");
  for (var it = this.iterator(); it.hasNext(); ) {
    var ei = it.next();
    ei.print(out);
  }
};
EdgeIntersectionList.prototype.iterator = function iterator6() {
  return this._nodeMap.values().iterator();
};
EdgeIntersectionList.prototype.addSplitEdges = function addSplitEdges2(edgeList) {
  var this$1$1 = this;
  this.addEndpoints();
  var it = this.iterator();
  var eiPrev = it.next();
  while (it.hasNext()) {
    var ei = it.next();
    var newEdge = this$1$1.createSplitEdge(eiPrev, ei);
    edgeList.add(newEdge);
    eiPrev = ei;
  }
};
EdgeIntersectionList.prototype.addEndpoints = function addEndpoints2() {
  var maxSegIndex = this.edge.pts.length - 1;
  this.add(this.edge.pts[0], 0, 0);
  this.add(this.edge.pts[maxSegIndex], maxSegIndex, 0);
};
EdgeIntersectionList.prototype.createSplitEdge = function createSplitEdge2(ei0, ei1) {
  var this$1$1 = this;
  var npts = ei1.segmentIndex - ei0.segmentIndex + 2;
  var lastSegStartPt = this.edge.pts[ei1.segmentIndex];
  var useIntPt1 = ei1.dist > 0 || !ei1.coord.equals2D(lastSegStartPt);
  if (!useIntPt1) {
    npts--;
  }
  var pts = new Array(npts).fill(null);
  var ipt = 0;
  pts[ipt++] = new Coordinate(ei0.coord);
  for (var i2 = ei0.segmentIndex + 1; i2 <= ei1.segmentIndex; i2++) {
    pts[ipt++] = this$1$1.edge.pts[i2];
  }
  if (useIntPt1) {
    pts[ipt] = ei1.coord;
  }
  return new Edge(pts, new Label(this.edge._label));
};
EdgeIntersectionList.prototype.add = function add12(intPt, segmentIndex, dist2) {
  var eiNew = new EdgeIntersection(intPt, segmentIndex, dist2);
  var ei = this._nodeMap.get(eiNew);
  if (ei !== null) {
    return ei;
  }
  this._nodeMap.put(eiNew, eiNew);
  return eiNew;
};
EdgeIntersectionList.prototype.isIntersection = function isIntersection2(pt) {
  for (var it = this.iterator(); it.hasNext(); ) {
    var ei = it.next();
    if (ei.coord.equals(pt)) {
      return true;
    }
  }
  return false;
};
EdgeIntersectionList.prototype.interfaces_ = function interfaces_102() {
  return [];
};
EdgeIntersectionList.prototype.getClass = function getClass101() {
  return EdgeIntersectionList;
};
var MonotoneChainIndexer = function MonotoneChainIndexer2() {
};
MonotoneChainIndexer.prototype.getChainStartIndices = function getChainStartIndices2(pts) {
  var this$1$1 = this;
  var start2 = 0;
  var startIndexList = new ArrayList();
  startIndexList.add(new Integer(start2));
  do {
    var last = this$1$1.findChainEnd(pts, start2);
    startIndexList.add(new Integer(last));
    start2 = last;
  } while (start2 < pts.length - 1);
  var startIndex = MonotoneChainIndexer.toIntArray(startIndexList);
  return startIndex;
};
MonotoneChainIndexer.prototype.findChainEnd = function findChainEnd2(pts, start2) {
  var chainQuad = Quadrant.quadrant(pts[start2], pts[start2 + 1]);
  var last = start2 + 1;
  while (last < pts.length) {
    var quad = Quadrant.quadrant(pts[last - 1], pts[last]);
    if (quad !== chainQuad) {
      break;
    }
    last++;
  }
  return last - 1;
};
MonotoneChainIndexer.prototype.interfaces_ = function interfaces_103() {
  return [];
};
MonotoneChainIndexer.prototype.getClass = function getClass102() {
  return MonotoneChainIndexer;
};
MonotoneChainIndexer.toIntArray = function toIntArray2(list2) {
  var array2 = new Array(list2.size()).fill(null);
  for (var i2 = 0; i2 < array2.length; i2++) {
    array2[i2] = list2.get(i2).intValue();
  }
  return array2;
};
var MonotoneChainEdge = function MonotoneChainEdge2() {
  this.e = null;
  this.pts = null;
  this.startIndex = null;
  this.env1 = new Envelope();
  this.env2 = new Envelope();
  var e3 = arguments[0];
  this.e = e3;
  this.pts = e3.getCoordinates();
  var mcb = new MonotoneChainIndexer();
  this.startIndex = mcb.getChainStartIndices(this.pts);
};
MonotoneChainEdge.prototype.getCoordinates = function getCoordinates7() {
  return this.pts;
};
MonotoneChainEdge.prototype.getMaxX = function getMaxX2(chainIndex) {
  var x12 = this.pts[this.startIndex[chainIndex]].x;
  var x2 = this.pts[this.startIndex[chainIndex + 1]].x;
  return x12 > x2 ? x12 : x2;
};
MonotoneChainEdge.prototype.getMinX = function getMinX2(chainIndex) {
  var x12 = this.pts[this.startIndex[chainIndex]].x;
  var x2 = this.pts[this.startIndex[chainIndex + 1]].x;
  return x12 < x2 ? x12 : x2;
};
MonotoneChainEdge.prototype.computeIntersectsForChain = function computeIntersectsForChain() {
  if (arguments.length === 4) {
    var chainIndex0 = arguments[0];
    var mce = arguments[1];
    var chainIndex1 = arguments[2];
    var si = arguments[3];
    this.computeIntersectsForChain(this.startIndex[chainIndex0], this.startIndex[chainIndex0 + 1], mce, mce.startIndex[chainIndex1], mce.startIndex[chainIndex1 + 1], si);
  } else if (arguments.length === 6) {
    var start0 = arguments[0];
    var end0 = arguments[1];
    var mce$1 = arguments[2];
    var start1 = arguments[3];
    var end1 = arguments[4];
    var ei = arguments[5];
    var p00 = this.pts[start0];
    var p01 = this.pts[end0];
    var p10 = mce$1.pts[start1];
    var p11 = mce$1.pts[end1];
    if (end0 - start0 === 1 && end1 - start1 === 1) {
      ei.addIntersections(this.e, start0, mce$1.e, start1);
      return null;
    }
    this.env1.init(p00, p01);
    this.env2.init(p10, p11);
    if (!this.env1.intersects(this.env2)) {
      return null;
    }
    var mid0 = Math.trunc((start0 + end0) / 2);
    var mid1 = Math.trunc((start1 + end1) / 2);
    if (start0 < mid0) {
      if (start1 < mid1) {
        this.computeIntersectsForChain(start0, mid0, mce$1, start1, mid1, ei);
      }
      if (mid1 < end1) {
        this.computeIntersectsForChain(start0, mid0, mce$1, mid1, end1, ei);
      }
    }
    if (mid0 < end0) {
      if (start1 < mid1) {
        this.computeIntersectsForChain(mid0, end0, mce$1, start1, mid1, ei);
      }
      if (mid1 < end1) {
        this.computeIntersectsForChain(mid0, end0, mce$1, mid1, end1, ei);
      }
    }
  }
};
MonotoneChainEdge.prototype.getStartIndexes = function getStartIndexes() {
  return this.startIndex;
};
MonotoneChainEdge.prototype.computeIntersects = function computeIntersects(mce, si) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this.startIndex.length - 1; i2++) {
    for (var j2 = 0; j2 < mce.startIndex.length - 1; j2++) {
      this$1$1.computeIntersectsForChain(i2, mce, j2, si);
    }
  }
};
MonotoneChainEdge.prototype.interfaces_ = function interfaces_104() {
  return [];
};
MonotoneChainEdge.prototype.getClass = function getClass103() {
  return MonotoneChainEdge;
};
var Depth = function Depth2() {
  var this$1$1 = this;
  this._depth = Array(2).fill().map(function() {
    return Array(3);
  });
  for (var i2 = 0; i2 < 2; i2++) {
    for (var j2 = 0; j2 < 3; j2++) {
      this$1$1._depth[i2][j2] = Depth2.NULL_VALUE;
    }
  }
};
var staticAccessors$31 = { NULL_VALUE: { configurable: true } };
Depth.prototype.getDepth = function getDepth2(geomIndex, posIndex) {
  return this._depth[geomIndex][posIndex];
};
Depth.prototype.setDepth = function setDepth(geomIndex, posIndex, depthValue) {
  this._depth[geomIndex][posIndex] = depthValue;
};
Depth.prototype.isNull = function isNull4() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    for (var i2 = 0; i2 < 2; i2++) {
      for (var j2 = 0; j2 < 3; j2++) {
        if (this$1$1._depth[i2][j2] !== Depth.NULL_VALUE) {
          return false;
        }
      }
    }
    return true;
  } else if (arguments.length === 1) {
    var geomIndex = arguments[0];
    return this._depth[geomIndex][1] === Depth.NULL_VALUE;
  } else if (arguments.length === 2) {
    var geomIndex$1 = arguments[0];
    var posIndex = arguments[1];
    return this._depth[geomIndex$1][posIndex] === Depth.NULL_VALUE;
  }
};
Depth.prototype.normalize = function normalize4() {
  var this$1$1 = this;
  for (var i2 = 0; i2 < 2; i2++) {
    if (!this$1$1.isNull(i2)) {
      var minDepth = this$1$1._depth[i2][1];
      if (this$1$1._depth[i2][2] < minDepth) {
        minDepth = this$1$1._depth[i2][2];
      }
      if (minDepth < 0) {
        minDepth = 0;
      }
      for (var j2 = 1; j2 < 3; j2++) {
        var newValue = 0;
        if (this$1$1._depth[i2][j2] > minDepth) {
          newValue = 1;
        }
        this$1$1._depth[i2][j2] = newValue;
      }
    }
  }
};
Depth.prototype.getDelta = function getDelta(geomIndex) {
  return this._depth[geomIndex][Position.RIGHT] - this._depth[geomIndex][Position.LEFT];
};
Depth.prototype.getLocation = function getLocation4(geomIndex, posIndex) {
  if (this._depth[geomIndex][posIndex] <= 0) {
    return Location.EXTERIOR;
  }
  return Location.INTERIOR;
};
Depth.prototype.toString = function toString21() {
  return "A: " + this._depth[0][1] + "," + this._depth[0][2] + " B: " + this._depth[1][1] + "," + this._depth[1][2];
};
Depth.prototype.add = function add13() {
  var this$1$1 = this;
  if (arguments.length === 1) {
    var lbl = arguments[0];
    for (var i2 = 0; i2 < 2; i2++) {
      for (var j2 = 1; j2 < 3; j2++) {
        var loc = lbl.getLocation(i2, j2);
        if (loc === Location.EXTERIOR || loc === Location.INTERIOR) {
          if (this$1$1.isNull(i2, j2)) {
            this$1$1._depth[i2][j2] = Depth.depthAtLocation(loc);
          } else {
            this$1$1._depth[i2][j2] += Depth.depthAtLocation(loc);
          }
        }
      }
    }
  } else if (arguments.length === 3) {
    var geomIndex = arguments[0];
    var posIndex = arguments[1];
    var location2 = arguments[2];
    if (location2 === Location.INTERIOR) {
      this._depth[geomIndex][posIndex]++;
    }
  }
};
Depth.prototype.interfaces_ = function interfaces_105() {
  return [];
};
Depth.prototype.getClass = function getClass104() {
  return Depth;
};
Depth.depthAtLocation = function depthAtLocation(location2) {
  if (location2 === Location.EXTERIOR) {
    return 0;
  }
  if (location2 === Location.INTERIOR) {
    return 1;
  }
  return Depth.NULL_VALUE;
};
staticAccessors$31.NULL_VALUE.get = function() {
  return -1;
};
Object.defineProperties(Depth, staticAccessors$31);
var Edge = function(GraphComponent$$1) {
  function Edge2() {
    GraphComponent$$1.call(this);
    this.pts = null;
    this._env = null;
    this.eiList = new EdgeIntersectionList(this);
    this._name = null;
    this._mce = null;
    this._isIsolated = true;
    this._depth = new Depth();
    this._depthDelta = 0;
    if (arguments.length === 1) {
      var pts = arguments[0];
      Edge2.call(this, pts, null);
    } else if (arguments.length === 2) {
      var pts$1 = arguments[0];
      var label = arguments[1];
      this.pts = pts$1;
      this._label = label;
    }
  }
  if (GraphComponent$$1)
    Edge2.__proto__ = GraphComponent$$1;
  Edge2.prototype = Object.create(GraphComponent$$1 && GraphComponent$$1.prototype);
  Edge2.prototype.constructor = Edge2;
  Edge2.prototype.getDepth = function getDepth3() {
    return this._depth;
  };
  Edge2.prototype.getCollapsedEdge = function getCollapsedEdge() {
    var newPts = new Array(2).fill(null);
    newPts[0] = this.pts[0];
    newPts[1] = this.pts[1];
    var newe = new Edge2(newPts, Label.toLineLabel(this._label));
    return newe;
  };
  Edge2.prototype.isIsolated = function isIsolated2() {
    return this._isIsolated;
  };
  Edge2.prototype.getCoordinates = function getCoordinates12() {
    return this.pts;
  };
  Edge2.prototype.setIsolated = function setIsolated(isIsolated2) {
    this._isIsolated = isIsolated2;
  };
  Edge2.prototype.setName = function setName(name2) {
    this._name = name2;
  };
  Edge2.prototype.equals = function equals12(o2) {
    var this$1$1 = this;
    if (!(o2 instanceof Edge2)) {
      return false;
    }
    var e3 = o2;
    if (this.pts.length !== e3.pts.length) {
      return false;
    }
    var isEqualForward = true;
    var isEqualReverse = true;
    var iRev = this.pts.length;
    for (var i2 = 0; i2 < this.pts.length; i2++) {
      if (!this$1$1.pts[i2].equals2D(e3.pts[i2])) {
        isEqualForward = false;
      }
      if (!this$1$1.pts[i2].equals2D(e3.pts[--iRev])) {
        isEqualReverse = false;
      }
      if (!isEqualForward && !isEqualReverse) {
        return false;
      }
    }
    return true;
  };
  Edge2.prototype.getCoordinate = function getCoordinate18() {
    if (arguments.length === 0) {
      if (this.pts.length > 0) {
        return this.pts[0];
      }
      return null;
    } else if (arguments.length === 1) {
      var i2 = arguments[0];
      return this.pts[i2];
    }
  };
  Edge2.prototype.print = function print9(out) {
    var this$1$1 = this;
    out.print("edge " + this._name + ": ");
    out.print("LINESTRING (");
    for (var i2 = 0; i2 < this.pts.length; i2++) {
      if (i2 > 0) {
        out.print(",");
      }
      out.print(this$1$1.pts[i2].x + " " + this$1$1.pts[i2].y);
    }
    out.print(")  " + this._label + " " + this._depthDelta);
  };
  Edge2.prototype.computeIM = function computeIM(im) {
    Edge2.updateIM(this._label, im);
  };
  Edge2.prototype.isCollapsed = function isCollapsed() {
    if (!this._label.isArea()) {
      return false;
    }
    if (this.pts.length !== 3) {
      return false;
    }
    if (this.pts[0].equals(this.pts[2])) {
      return true;
    }
    return false;
  };
  Edge2.prototype.isClosed = function isClosed5() {
    return this.pts[0].equals(this.pts[this.pts.length - 1]);
  };
  Edge2.prototype.getMaximumSegmentIndex = function getMaximumSegmentIndex() {
    return this.pts.length - 1;
  };
  Edge2.prototype.getDepthDelta = function getDepthDelta() {
    return this._depthDelta;
  };
  Edge2.prototype.getNumPoints = function getNumPoints() {
    return this.pts.length;
  };
  Edge2.prototype.printReverse = function printReverse(out) {
    var this$1$1 = this;
    out.print("edge " + this._name + ": ");
    for (var i2 = this.pts.length - 1; i2 >= 0; i2--) {
      out.print(this$1$1.pts[i2] + " ");
    }
    out.println("");
  };
  Edge2.prototype.getMonotoneChainEdge = function getMonotoneChainEdge() {
    if (this._mce === null) {
      this._mce = new MonotoneChainEdge(this);
    }
    return this._mce;
  };
  Edge2.prototype.getEnvelope = function getEnvelope4() {
    var this$1$1 = this;
    if (this._env === null) {
      this._env = new Envelope();
      for (var i2 = 0; i2 < this.pts.length; i2++) {
        this$1$1._env.expandToInclude(this$1$1.pts[i2]);
      }
    }
    return this._env;
  };
  Edge2.prototype.addIntersection = function addIntersection3(li, segmentIndex, geomIndex, intIndex) {
    var intPt = new Coordinate(li.getIntersection(intIndex));
    var normalizedSegmentIndex = segmentIndex;
    var dist2 = li.getEdgeDistance(geomIndex, intIndex);
    var nextSegIndex = normalizedSegmentIndex + 1;
    if (nextSegIndex < this.pts.length) {
      var nextPt = this.pts[nextSegIndex];
      if (intPt.equals2D(nextPt)) {
        normalizedSegmentIndex = nextSegIndex;
        dist2 = 0;
      }
    }
    this.eiList.add(intPt, normalizedSegmentIndex, dist2);
  };
  Edge2.prototype.toString = function toString29() {
    var this$1$1 = this;
    var buf = new StringBuffer();
    buf.append("edge " + this._name + ": ");
    buf.append("LINESTRING (");
    for (var i2 = 0; i2 < this.pts.length; i2++) {
      if (i2 > 0) {
        buf.append(",");
      }
      buf.append(this$1$1.pts[i2].x + " " + this$1$1.pts[i2].y);
    }
    buf.append(")  " + this._label + " " + this._depthDelta);
    return buf.toString();
  };
  Edge2.prototype.isPointwiseEqual = function isPointwiseEqual(e3) {
    var this$1$1 = this;
    if (this.pts.length !== e3.pts.length) {
      return false;
    }
    for (var i2 = 0; i2 < this.pts.length; i2++) {
      if (!this$1$1.pts[i2].equals2D(e3.pts[i2])) {
        return false;
      }
    }
    return true;
  };
  Edge2.prototype.setDepthDelta = function setDepthDelta(depthDelta2) {
    this._depthDelta = depthDelta2;
  };
  Edge2.prototype.getEdgeIntersectionList = function getEdgeIntersectionList() {
    return this.eiList;
  };
  Edge2.prototype.addIntersections = function addIntersections3(li, segmentIndex, geomIndex) {
    var this$1$1 = this;
    for (var i2 = 0; i2 < li.getIntersectionNum(); i2++) {
      this$1$1.addIntersection(li, segmentIndex, geomIndex, i2);
    }
  };
  Edge2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  Edge2.prototype.getClass = function getClass169() {
    return Edge2;
  };
  Edge2.updateIM = function updateIM2() {
    if (arguments.length === 2) {
      var label = arguments[0];
      var im = arguments[1];
      im.setAtLeastIfValid(label.getLocation(0, Position.ON), label.getLocation(1, Position.ON), 1);
      if (label.isArea()) {
        im.setAtLeastIfValid(label.getLocation(0, Position.LEFT), label.getLocation(1, Position.LEFT), 2);
        im.setAtLeastIfValid(label.getLocation(0, Position.RIGHT), label.getLocation(1, Position.RIGHT), 2);
      }
    } else {
      return GraphComponent$$1.prototype.updateIM.apply(this, arguments);
    }
  };
  return Edge2;
}(GraphComponent);
var BufferBuilder = function BufferBuilder2(bufParams) {
  this._workingPrecisionModel = null;
  this._workingNoder = null;
  this._geomFact = null;
  this._graph = null;
  this._edgeList = new EdgeList();
  this._bufParams = bufParams || null;
};
BufferBuilder.prototype.setWorkingPrecisionModel = function setWorkingPrecisionModel(pm) {
  this._workingPrecisionModel = pm;
};
BufferBuilder.prototype.insertUniqueEdge = function insertUniqueEdge(e3) {
  var existingEdge = this._edgeList.findEqualEdge(e3);
  if (existingEdge !== null) {
    var existingLabel = existingEdge.getLabel();
    var labelToMerge = e3.getLabel();
    if (!existingEdge.isPointwiseEqual(e3)) {
      labelToMerge = new Label(e3.getLabel());
      labelToMerge.flip();
    }
    existingLabel.merge(labelToMerge);
    var mergeDelta = BufferBuilder.depthDelta(labelToMerge);
    var existingDelta = existingEdge.getDepthDelta();
    var newDelta = existingDelta + mergeDelta;
    existingEdge.setDepthDelta(newDelta);
  } else {
    this._edgeList.add(e3);
    e3.setDepthDelta(BufferBuilder.depthDelta(e3.getLabel()));
  }
};
BufferBuilder.prototype.buildSubgraphs = function buildSubgraphs(subgraphList, polyBuilder) {
  var processedGraphs = new ArrayList();
  for (var i2 = subgraphList.iterator(); i2.hasNext(); ) {
    var subgraph = i2.next();
    var p2 = subgraph.getRightmostCoordinate();
    var locater = new SubgraphDepthLocater(processedGraphs);
    var outsideDepth = locater.getDepth(p2);
    subgraph.computeDepth(outsideDepth);
    subgraph.findResultEdges();
    processedGraphs.add(subgraph);
    polyBuilder.add(subgraph.getDirectedEdges(), subgraph.getNodes());
  }
};
BufferBuilder.prototype.createSubgraphs = function createSubgraphs(graph) {
  var subgraphList = new ArrayList();
  for (var i2 = graph.getNodes().iterator(); i2.hasNext(); ) {
    var node = i2.next();
    if (!node.isVisited()) {
      var subgraph = new BufferSubgraph();
      subgraph.create(node);
      subgraphList.add(subgraph);
    }
  }
  Collections.sort(subgraphList, Collections.reverseOrder());
  return subgraphList;
};
BufferBuilder.prototype.createEmptyResultGeometry = function createEmptyResultGeometry() {
  var emptyGeom = this._geomFact.createPolygon();
  return emptyGeom;
};
BufferBuilder.prototype.getNoder = function getNoder(precisionModel) {
  if (this._workingNoder !== null) {
    return this._workingNoder;
  }
  var noder = new MCIndexNoder();
  var li = new RobustLineIntersector();
  li.setPrecisionModel(precisionModel);
  noder.setSegmentIntersector(new IntersectionAdder(li));
  return noder;
};
BufferBuilder.prototype.buffer = function buffer2(g2, distance11) {
  var precisionModel = this._workingPrecisionModel;
  if (precisionModel === null) {
    precisionModel = g2.getPrecisionModel();
  }
  this._geomFact = g2.getFactory();
  var curveBuilder = new OffsetCurveBuilder(precisionModel, this._bufParams);
  var curveSetBuilder = new OffsetCurveSetBuilder(g2, distance11, curveBuilder);
  var bufferSegStrList = curveSetBuilder.getCurves();
  if (bufferSegStrList.size() <= 0) {
    return this.createEmptyResultGeometry();
  }
  this.computeNodedEdges(bufferSegStrList, precisionModel);
  this._graph = new PlanarGraph(new OverlayNodeFactory());
  this._graph.addEdges(this._edgeList.getEdges());
  var subgraphList = this.createSubgraphs(this._graph);
  var polyBuilder = new PolygonBuilder(this._geomFact);
  this.buildSubgraphs(subgraphList, polyBuilder);
  var resultPolyList = polyBuilder.getPolygons();
  if (resultPolyList.size() <= 0) {
    return this.createEmptyResultGeometry();
  }
  var resultGeom = this._geomFact.buildGeometry(resultPolyList);
  return resultGeom;
};
BufferBuilder.prototype.computeNodedEdges = function computeNodedEdges(bufferSegStrList, precisionModel) {
  var this$1$1 = this;
  var noder = this.getNoder(precisionModel);
  noder.computeNodes(bufferSegStrList);
  var nodedSegStrings = noder.getNodedSubstrings();
  for (var i2 = nodedSegStrings.iterator(); i2.hasNext(); ) {
    var segStr = i2.next();
    var pts = segStr.getCoordinates();
    if (pts.length === 2 && pts[0].equals2D(pts[1])) {
      continue;
    }
    var oldLabel = segStr.getData();
    var edge = new Edge(segStr.getCoordinates(), new Label(oldLabel));
    this$1$1.insertUniqueEdge(edge);
  }
};
BufferBuilder.prototype.setNoder = function setNoder(noder) {
  this._workingNoder = noder;
};
BufferBuilder.prototype.interfaces_ = function interfaces_106() {
  return [];
};
BufferBuilder.prototype.getClass = function getClass105() {
  return BufferBuilder;
};
BufferBuilder.depthDelta = function depthDelta(label) {
  var lLoc = label.getLocation(0, Position.LEFT);
  var rLoc = label.getLocation(0, Position.RIGHT);
  if (lLoc === Location.INTERIOR && rLoc === Location.EXTERIOR) {
    return 1;
  } else if (lLoc === Location.EXTERIOR && rLoc === Location.INTERIOR) {
    return -1;
  }
  return 0;
};
BufferBuilder.convertSegStrings = function convertSegStrings(it) {
  var fact = new GeometryFactory();
  var lines = new ArrayList();
  while (it.hasNext()) {
    var ss = it.next();
    var line = fact.createLineString(ss.getCoordinates());
    lines.add(line);
  }
  return fact.buildGeometry(lines);
};
var ScaledNoder = function ScaledNoder2() {
  this._noder = null;
  this._scaleFactor = null;
  this._offsetX = null;
  this._offsetY = null;
  this._isScaled = false;
  if (arguments.length === 2) {
    var noder = arguments[0];
    var scaleFactor = arguments[1];
    this._noder = noder;
    this._scaleFactor = scaleFactor;
    this._offsetX = 0;
    this._offsetY = 0;
    this._isScaled = !this.isIntegerPrecision();
  } else if (arguments.length === 4) {
    var noder$1 = arguments[0];
    var scaleFactor$1 = arguments[1];
    var offsetX = arguments[2];
    var offsetY = arguments[3];
    this._noder = noder$1;
    this._scaleFactor = scaleFactor$1;
    this._offsetX = offsetX;
    this._offsetY = offsetY;
    this._isScaled = !this.isIntegerPrecision();
  }
};
ScaledNoder.prototype.rescale = function rescale() {
  var this$1$1 = this;
  if (hasInterface(arguments[0], Collection)) {
    var segStrings = arguments[0];
    for (var i2 = segStrings.iterator(); i2.hasNext(); ) {
      var ss = i2.next();
      this$1$1.rescale(ss.getCoordinates());
    }
  } else if (arguments[0] instanceof Array) {
    var pts = arguments[0];
    for (var i$12 = 0; i$12 < pts.length; i$12++) {
      pts[i$12].x = pts[i$12].x / this$1$1._scaleFactor + this$1$1._offsetX;
      pts[i$12].y = pts[i$12].y / this$1$1._scaleFactor + this$1$1._offsetY;
    }
    if (pts.length === 2 && pts[0].equals2D(pts[1])) {
      System.out.println(pts);
    }
  }
};
ScaledNoder.prototype.scale = function scale2() {
  var this$1$1 = this;
  if (hasInterface(arguments[0], Collection)) {
    var segStrings = arguments[0];
    var nodedSegmentStrings = new ArrayList();
    for (var i2 = segStrings.iterator(); i2.hasNext(); ) {
      var ss = i2.next();
      nodedSegmentStrings.add(new NodedSegmentString(this$1$1.scale(ss.getCoordinates()), ss.getData()));
    }
    return nodedSegmentStrings;
  } else if (arguments[0] instanceof Array) {
    var pts = arguments[0];
    var roundPts = new Array(pts.length).fill(null);
    for (var i$12 = 0; i$12 < pts.length; i$12++) {
      roundPts[i$12] = new Coordinate(Math.round((pts[i$12].x - this$1$1._offsetX) * this$1$1._scaleFactor), Math.round((pts[i$12].y - this$1$1._offsetY) * this$1$1._scaleFactor), pts[i$12].z);
    }
    var roundPtsNoDup = CoordinateArrays.removeRepeatedPoints(roundPts);
    return roundPtsNoDup;
  }
};
ScaledNoder.prototype.isIntegerPrecision = function isIntegerPrecision() {
  return this._scaleFactor === 1;
};
ScaledNoder.prototype.getNodedSubstrings = function getNodedSubstrings3() {
  var splitSS = this._noder.getNodedSubstrings();
  if (this._isScaled) {
    this.rescale(splitSS);
  }
  return splitSS;
};
ScaledNoder.prototype.computeNodes = function computeNodes2(inputSegStrings) {
  var intSegStrings = inputSegStrings;
  if (this._isScaled) {
    intSegStrings = this.scale(inputSegStrings);
  }
  this._noder.computeNodes(intSegStrings);
};
ScaledNoder.prototype.interfaces_ = function interfaces_107() {
  return [Noder];
};
ScaledNoder.prototype.getClass = function getClass106() {
  return ScaledNoder;
};
var NodingValidator = function NodingValidator2() {
  this._li = new RobustLineIntersector();
  this._segStrings = null;
  var segStrings = arguments[0];
  this._segStrings = segStrings;
};
var staticAccessors$33 = { fact: { configurable: true } };
NodingValidator.prototype.checkEndPtVertexIntersections = function checkEndPtVertexIntersections() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    for (var i2 = this._segStrings.iterator(); i2.hasNext(); ) {
      var ss = i2.next();
      var pts = ss.getCoordinates();
      this$1$1.checkEndPtVertexIntersections(pts[0], this$1$1._segStrings);
      this$1$1.checkEndPtVertexIntersections(pts[pts.length - 1], this$1$1._segStrings);
    }
  } else if (arguments.length === 2) {
    var testPt = arguments[0];
    var segStrings = arguments[1];
    for (var i$12 = segStrings.iterator(); i$12.hasNext(); ) {
      var ss$1 = i$12.next();
      var pts$1 = ss$1.getCoordinates();
      for (var j2 = 1; j2 < pts$1.length - 1; j2++) {
        if (pts$1[j2].equals(testPt)) {
          throw new RuntimeException("found endpt/interior pt intersection at index " + j2 + " :pt " + testPt);
        }
      }
    }
  }
};
NodingValidator.prototype.checkInteriorIntersections = function checkInteriorIntersections() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    for (var i2 = this._segStrings.iterator(); i2.hasNext(); ) {
      var ss0 = i2.next();
      for (var j2 = this._segStrings.iterator(); j2.hasNext(); ) {
        var ss1 = j2.next();
        this$1$1.checkInteriorIntersections(ss0, ss1);
      }
    }
  } else if (arguments.length === 2) {
    var ss0$1 = arguments[0];
    var ss1$1 = arguments[1];
    var pts0 = ss0$1.getCoordinates();
    var pts1 = ss1$1.getCoordinates();
    for (var i0 = 0; i0 < pts0.length - 1; i0++) {
      for (var i1 = 0; i1 < pts1.length - 1; i1++) {
        this$1$1.checkInteriorIntersections(ss0$1, i0, ss1$1, i1);
      }
    }
  } else if (arguments.length === 4) {
    var e0 = arguments[0];
    var segIndex0 = arguments[1];
    var e1 = arguments[2];
    var segIndex1 = arguments[3];
    if (e0 === e1 && segIndex0 === segIndex1) {
      return null;
    }
    var p00 = e0.getCoordinates()[segIndex0];
    var p01 = e0.getCoordinates()[segIndex0 + 1];
    var p10 = e1.getCoordinates()[segIndex1];
    var p11 = e1.getCoordinates()[segIndex1 + 1];
    this._li.computeIntersection(p00, p01, p10, p11);
    if (this._li.hasIntersection()) {
      if (this._li.isProper() || this.hasInteriorIntersection(this._li, p00, p01) || this.hasInteriorIntersection(this._li, p10, p11)) {
        throw new RuntimeException("found non-noded intersection at " + p00 + "-" + p01 + " and " + p10 + "-" + p11);
      }
    }
  }
};
NodingValidator.prototype.checkValid = function checkValid() {
  this.checkEndPtVertexIntersections();
  this.checkInteriorIntersections();
  this.checkCollapses();
};
NodingValidator.prototype.checkCollapses = function checkCollapses() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    for (var i2 = this._segStrings.iterator(); i2.hasNext(); ) {
      var ss = i2.next();
      this$1$1.checkCollapses(ss);
    }
  } else if (arguments.length === 1) {
    var ss$1 = arguments[0];
    var pts = ss$1.getCoordinates();
    for (var i$12 = 0; i$12 < pts.length - 2; i$12++) {
      this$1$1.checkCollapse(pts[i$12], pts[i$12 + 1], pts[i$12 + 2]);
    }
  }
};
NodingValidator.prototype.hasInteriorIntersection = function hasInteriorIntersection2(li, p0, p1) {
  for (var i2 = 0; i2 < li.getIntersectionNum(); i2++) {
    var intPt = li.getIntersection(i2);
    if (!(intPt.equals(p0) || intPt.equals(p1))) {
      return true;
    }
  }
  return false;
};
NodingValidator.prototype.checkCollapse = function checkCollapse(p0, p1, p2) {
  if (p0.equals(p2)) {
    throw new RuntimeException("found non-noded collapse at " + NodingValidator.fact.createLineString([p0, p1, p2]));
  }
};
NodingValidator.prototype.interfaces_ = function interfaces_108() {
  return [];
};
NodingValidator.prototype.getClass = function getClass107() {
  return NodingValidator;
};
staticAccessors$33.fact.get = function() {
  return new GeometryFactory();
};
Object.defineProperties(NodingValidator, staticAccessors$33);
var HotPixel = function HotPixel2() {
  this._li = null;
  this._pt = null;
  this._originalPt = null;
  this._ptScaled = null;
  this._p0Scaled = null;
  this._p1Scaled = null;
  this._scaleFactor = null;
  this._minx = null;
  this._maxx = null;
  this._miny = null;
  this._maxy = null;
  this._corner = new Array(4).fill(null);
  this._safeEnv = null;
  var pt = arguments[0];
  var scaleFactor = arguments[1];
  var li = arguments[2];
  this._originalPt = pt;
  this._pt = pt;
  this._scaleFactor = scaleFactor;
  this._li = li;
  if (scaleFactor <= 0) {
    throw new IllegalArgumentException("Scale factor must be non-zero");
  }
  if (scaleFactor !== 1) {
    this._pt = new Coordinate(this.scale(pt.x), this.scale(pt.y));
    this._p0Scaled = new Coordinate();
    this._p1Scaled = new Coordinate();
  }
  this.initCorners(this._pt);
};
var staticAccessors$34 = { SAFE_ENV_EXPANSION_FACTOR: { configurable: true } };
HotPixel.prototype.intersectsScaled = function intersectsScaled(p0, p1) {
  var segMinx = Math.min(p0.x, p1.x);
  var segMaxx = Math.max(p0.x, p1.x);
  var segMiny = Math.min(p0.y, p1.y);
  var segMaxy = Math.max(p0.y, p1.y);
  var isOutsidePixelEnv = this._maxx < segMinx || this._minx > segMaxx || this._maxy < segMiny || this._miny > segMaxy;
  if (isOutsidePixelEnv) {
    return false;
  }
  var intersects7 = this.intersectsToleranceSquare(p0, p1);
  Assert.isTrue(!(isOutsidePixelEnv && intersects7), "Found bad envelope test");
  return intersects7;
};
HotPixel.prototype.initCorners = function initCorners(pt) {
  var tolerance = 0.5;
  this._minx = pt.x - tolerance;
  this._maxx = pt.x + tolerance;
  this._miny = pt.y - tolerance;
  this._maxy = pt.y + tolerance;
  this._corner[0] = new Coordinate(this._maxx, this._maxy);
  this._corner[1] = new Coordinate(this._minx, this._maxy);
  this._corner[2] = new Coordinate(this._minx, this._miny);
  this._corner[3] = new Coordinate(this._maxx, this._miny);
};
HotPixel.prototype.intersects = function intersects4(p0, p1) {
  if (this._scaleFactor === 1) {
    return this.intersectsScaled(p0, p1);
  }
  this.copyScaled(p0, this._p0Scaled);
  this.copyScaled(p1, this._p1Scaled);
  return this.intersectsScaled(this._p0Scaled, this._p1Scaled);
};
HotPixel.prototype.scale = function scale3(val) {
  return Math.round(val * this._scaleFactor);
};
HotPixel.prototype.getCoordinate = function getCoordinate13() {
  return this._originalPt;
};
HotPixel.prototype.copyScaled = function copyScaled(p2, pScaled) {
  pScaled.x = this.scale(p2.x);
  pScaled.y = this.scale(p2.y);
};
HotPixel.prototype.getSafeEnvelope = function getSafeEnvelope() {
  if (this._safeEnv === null) {
    var safeTolerance = HotPixel.SAFE_ENV_EXPANSION_FACTOR / this._scaleFactor;
    this._safeEnv = new Envelope(this._originalPt.x - safeTolerance, this._originalPt.x + safeTolerance, this._originalPt.y - safeTolerance, this._originalPt.y + safeTolerance);
  }
  return this._safeEnv;
};
HotPixel.prototype.intersectsPixelClosure = function intersectsPixelClosure(p0, p1) {
  this._li.computeIntersection(p0, p1, this._corner[0], this._corner[1]);
  if (this._li.hasIntersection()) {
    return true;
  }
  this._li.computeIntersection(p0, p1, this._corner[1], this._corner[2]);
  if (this._li.hasIntersection()) {
    return true;
  }
  this._li.computeIntersection(p0, p1, this._corner[2], this._corner[3]);
  if (this._li.hasIntersection()) {
    return true;
  }
  this._li.computeIntersection(p0, p1, this._corner[3], this._corner[0]);
  if (this._li.hasIntersection()) {
    return true;
  }
  return false;
};
HotPixel.prototype.intersectsToleranceSquare = function intersectsToleranceSquare(p0, p1) {
  var intersectsLeft = false;
  var intersectsBottom = false;
  this._li.computeIntersection(p0, p1, this._corner[0], this._corner[1]);
  if (this._li.isProper()) {
    return true;
  }
  this._li.computeIntersection(p0, p1, this._corner[1], this._corner[2]);
  if (this._li.isProper()) {
    return true;
  }
  if (this._li.hasIntersection()) {
    intersectsLeft = true;
  }
  this._li.computeIntersection(p0, p1, this._corner[2], this._corner[3]);
  if (this._li.isProper()) {
    return true;
  }
  if (this._li.hasIntersection()) {
    intersectsBottom = true;
  }
  this._li.computeIntersection(p0, p1, this._corner[3], this._corner[0]);
  if (this._li.isProper()) {
    return true;
  }
  if (intersectsLeft && intersectsBottom) {
    return true;
  }
  if (p0.equals(this._pt)) {
    return true;
  }
  if (p1.equals(this._pt)) {
    return true;
  }
  return false;
};
HotPixel.prototype.addSnappedNode = function addSnappedNode(segStr, segIndex) {
  var p0 = segStr.getCoordinate(segIndex);
  var p1 = segStr.getCoordinate(segIndex + 1);
  if (this.intersects(p0, p1)) {
    segStr.addIntersection(this.getCoordinate(), segIndex);
    return true;
  }
  return false;
};
HotPixel.prototype.interfaces_ = function interfaces_109() {
  return [];
};
HotPixel.prototype.getClass = function getClass108() {
  return HotPixel;
};
staticAccessors$34.SAFE_ENV_EXPANSION_FACTOR.get = function() {
  return 0.75;
};
Object.defineProperties(HotPixel, staticAccessors$34);
var MonotoneChainSelectAction = function MonotoneChainSelectAction2() {
  this.tempEnv1 = new Envelope();
  this.selectedSegment = new LineSegment();
};
MonotoneChainSelectAction.prototype.select = function select2() {
  if (arguments.length === 1)
    ;
  else if (arguments.length === 2) {
    var mc = arguments[0];
    var startIndex = arguments[1];
    mc.getLineSegment(startIndex, this.selectedSegment);
    this.select(this.selectedSegment);
  }
};
MonotoneChainSelectAction.prototype.interfaces_ = function interfaces_110() {
  return [];
};
MonotoneChainSelectAction.prototype.getClass = function getClass109() {
  return MonotoneChainSelectAction;
};
var MCIndexPointSnapper = function MCIndexPointSnapper2() {
  this._index = null;
  var index2 = arguments[0];
  this._index = index2;
};
var staticAccessors$35 = { HotPixelSnapAction: { configurable: true } };
MCIndexPointSnapper.prototype.snap = function snap2() {
  if (arguments.length === 1) {
    var hotPixel = arguments[0];
    return this.snap(hotPixel, null, -1);
  } else if (arguments.length === 3) {
    var hotPixel$1 = arguments[0];
    var parentEdge = arguments[1];
    var hotPixelVertexIndex = arguments[2];
    var pixelEnv = hotPixel$1.getSafeEnvelope();
    var hotPixelSnapAction = new HotPixelSnapAction(hotPixel$1, parentEdge, hotPixelVertexIndex);
    this._index.query(pixelEnv, {
      interfaces_: function() {
        return [ItemVisitor];
      },
      visitItem: function(item) {
        var testChain = item;
        testChain.select(pixelEnv, hotPixelSnapAction);
      }
    });
    return hotPixelSnapAction.isNodeAdded();
  }
};
MCIndexPointSnapper.prototype.interfaces_ = function interfaces_111() {
  return [];
};
MCIndexPointSnapper.prototype.getClass = function getClass110() {
  return MCIndexPointSnapper;
};
staticAccessors$35.HotPixelSnapAction.get = function() {
  return HotPixelSnapAction;
};
Object.defineProperties(MCIndexPointSnapper, staticAccessors$35);
var HotPixelSnapAction = function(MonotoneChainSelectAction$$1) {
  function HotPixelSnapAction2() {
    MonotoneChainSelectAction$$1.call(this);
    this._hotPixel = null;
    this._parentEdge = null;
    this._hotPixelVertexIndex = null;
    this._isNodeAdded = false;
    var hotPixel = arguments[0];
    var parentEdge = arguments[1];
    var hotPixelVertexIndex = arguments[2];
    this._hotPixel = hotPixel;
    this._parentEdge = parentEdge;
    this._hotPixelVertexIndex = hotPixelVertexIndex;
  }
  if (MonotoneChainSelectAction$$1)
    HotPixelSnapAction2.__proto__ = MonotoneChainSelectAction$$1;
  HotPixelSnapAction2.prototype = Object.create(MonotoneChainSelectAction$$1 && MonotoneChainSelectAction$$1.prototype);
  HotPixelSnapAction2.prototype.constructor = HotPixelSnapAction2;
  HotPixelSnapAction2.prototype.isNodeAdded = function isNodeAdded() {
    return this._isNodeAdded;
  };
  HotPixelSnapAction2.prototype.select = function select3() {
    if (arguments.length === 2) {
      var mc = arguments[0];
      var startIndex = arguments[1];
      var ss = mc.getContext();
      if (this._parentEdge !== null) {
        if (ss === this._parentEdge && startIndex === this._hotPixelVertexIndex) {
          return null;
        }
      }
      this._isNodeAdded = this._hotPixel.addSnappedNode(ss, startIndex);
    } else {
      return MonotoneChainSelectAction$$1.prototype.select.apply(this, arguments);
    }
  };
  HotPixelSnapAction2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  HotPixelSnapAction2.prototype.getClass = function getClass169() {
    return HotPixelSnapAction2;
  };
  return HotPixelSnapAction2;
}(MonotoneChainSelectAction);
var InteriorIntersectionFinderAdder = function InteriorIntersectionFinderAdder2() {
  this._li = null;
  this._interiorIntersections = null;
  var li = arguments[0];
  this._li = li;
  this._interiorIntersections = new ArrayList();
};
InteriorIntersectionFinderAdder.prototype.processIntersections = function processIntersections3(e0, segIndex0, e1, segIndex1) {
  var this$1$1 = this;
  if (e0 === e1 && segIndex0 === segIndex1) {
    return null;
  }
  var p00 = e0.getCoordinates()[segIndex0];
  var p01 = e0.getCoordinates()[segIndex0 + 1];
  var p10 = e1.getCoordinates()[segIndex1];
  var p11 = e1.getCoordinates()[segIndex1 + 1];
  this._li.computeIntersection(p00, p01, p10, p11);
  if (this._li.hasIntersection()) {
    if (this._li.isInteriorIntersection()) {
      for (var intIndex = 0; intIndex < this._li.getIntersectionNum(); intIndex++) {
        this$1$1._interiorIntersections.add(this$1$1._li.getIntersection(intIndex));
      }
      e0.addIntersections(this._li, segIndex0, 0);
      e1.addIntersections(this._li, segIndex1, 1);
    }
  }
};
InteriorIntersectionFinderAdder.prototype.isDone = function isDone4() {
  return false;
};
InteriorIntersectionFinderAdder.prototype.getInteriorIntersections = function getInteriorIntersections() {
  return this._interiorIntersections;
};
InteriorIntersectionFinderAdder.prototype.interfaces_ = function interfaces_112() {
  return [SegmentIntersector];
};
InteriorIntersectionFinderAdder.prototype.getClass = function getClass111() {
  return InteriorIntersectionFinderAdder;
};
var MCIndexSnapRounder = function MCIndexSnapRounder2() {
  this._pm = null;
  this._li = null;
  this._scaleFactor = null;
  this._noder = null;
  this._pointSnapper = null;
  this._nodedSegStrings = null;
  var pm = arguments[0];
  this._pm = pm;
  this._li = new RobustLineIntersector();
  this._li.setPrecisionModel(pm);
  this._scaleFactor = pm.getScale();
};
MCIndexSnapRounder.prototype.checkCorrectness = function checkCorrectness(inputSegmentStrings) {
  var resultSegStrings = NodedSegmentString.getNodedSubstrings(inputSegmentStrings);
  var nv = new NodingValidator(resultSegStrings);
  try {
    nv.checkValid();
  } catch (ex) {
    if (ex instanceof Exception) {
      ex.printStackTrace();
    } else {
      throw ex;
    }
  } finally {
  }
};
MCIndexSnapRounder.prototype.getNodedSubstrings = function getNodedSubstrings4() {
  return NodedSegmentString.getNodedSubstrings(this._nodedSegStrings);
};
MCIndexSnapRounder.prototype.snapRound = function snapRound(segStrings, li) {
  var intersections = this.findInteriorIntersections(segStrings, li);
  this.computeIntersectionSnaps(intersections);
  this.computeVertexSnaps(segStrings);
};
MCIndexSnapRounder.prototype.findInteriorIntersections = function findInteriorIntersections(segStrings, li) {
  var intFinderAdder = new InteriorIntersectionFinderAdder(li);
  this._noder.setSegmentIntersector(intFinderAdder);
  this._noder.computeNodes(segStrings);
  return intFinderAdder.getInteriorIntersections();
};
MCIndexSnapRounder.prototype.computeVertexSnaps = function computeVertexSnaps() {
  var this$1$1 = this;
  if (hasInterface(arguments[0], Collection)) {
    var edges = arguments[0];
    for (var i0 = edges.iterator(); i0.hasNext(); ) {
      var edge0 = i0.next();
      this$1$1.computeVertexSnaps(edge0);
    }
  } else if (arguments[0] instanceof NodedSegmentString) {
    var e3 = arguments[0];
    var pts0 = e3.getCoordinates();
    for (var i2 = 0; i2 < pts0.length; i2++) {
      var hotPixel = new HotPixel(pts0[i2], this$1$1._scaleFactor, this$1$1._li);
      var isNodeAdded = this$1$1._pointSnapper.snap(hotPixel, e3, i2);
      if (isNodeAdded) {
        e3.addIntersection(pts0[i2], i2);
      }
    }
  }
};
MCIndexSnapRounder.prototype.computeNodes = function computeNodes3(inputSegmentStrings) {
  this._nodedSegStrings = inputSegmentStrings;
  this._noder = new MCIndexNoder();
  this._pointSnapper = new MCIndexPointSnapper(this._noder.getIndex());
  this.snapRound(inputSegmentStrings, this._li);
};
MCIndexSnapRounder.prototype.computeIntersectionSnaps = function computeIntersectionSnaps(snapPts) {
  var this$1$1 = this;
  for (var it = snapPts.iterator(); it.hasNext(); ) {
    var snapPt = it.next();
    var hotPixel = new HotPixel(snapPt, this$1$1._scaleFactor, this$1$1._li);
    this$1$1._pointSnapper.snap(hotPixel);
  }
};
MCIndexSnapRounder.prototype.interfaces_ = function interfaces_113() {
  return [Noder];
};
MCIndexSnapRounder.prototype.getClass = function getClass112() {
  return MCIndexSnapRounder;
};
var BufferOp = function BufferOp2() {
  this._argGeom = null;
  this._distance = null;
  this._bufParams = new BufferParameters();
  this._resultGeometry = null;
  this._saveException = null;
  if (arguments.length === 1) {
    var g2 = arguments[0];
    this._argGeom = g2;
  } else if (arguments.length === 2) {
    var g$12 = arguments[0];
    var bufParams = arguments[1];
    this._argGeom = g$12;
    this._bufParams = bufParams;
  }
};
var staticAccessors$32 = { CAP_ROUND: { configurable: true }, CAP_BUTT: { configurable: true }, CAP_FLAT: { configurable: true }, CAP_SQUARE: { configurable: true }, MAX_PRECISION_DIGITS: { configurable: true } };
BufferOp.prototype.bufferFixedPrecision = function bufferFixedPrecision(fixedPM) {
  var noder = new ScaledNoder(new MCIndexSnapRounder(new PrecisionModel(1)), fixedPM.getScale());
  var bufBuilder = new BufferBuilder(this._bufParams);
  bufBuilder.setWorkingPrecisionModel(fixedPM);
  bufBuilder.setNoder(noder);
  this._resultGeometry = bufBuilder.buffer(this._argGeom, this._distance);
};
BufferOp.prototype.bufferReducedPrecision = function bufferReducedPrecision() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    for (var precDigits = BufferOp.MAX_PRECISION_DIGITS; precDigits >= 0; precDigits--) {
      try {
        this$1$1.bufferReducedPrecision(precDigits);
      } catch (ex) {
        if (ex instanceof TopologyException) {
          this$1$1._saveException = ex;
        } else {
          throw ex;
        }
      } finally {
      }
      if (this$1$1._resultGeometry !== null) {
        return null;
      }
    }
    throw this._saveException;
  } else if (arguments.length === 1) {
    var precisionDigits = arguments[0];
    var sizeBasedScaleFactor = BufferOp.precisionScaleFactor(this._argGeom, this._distance, precisionDigits);
    var fixedPM = new PrecisionModel(sizeBasedScaleFactor);
    this.bufferFixedPrecision(fixedPM);
  }
};
BufferOp.prototype.computeGeometry = function computeGeometry() {
  this.bufferOriginalPrecision();
  if (this._resultGeometry !== null) {
    return null;
  }
  var argPM = this._argGeom.getFactory().getPrecisionModel();
  if (argPM.getType() === PrecisionModel.FIXED) {
    this.bufferFixedPrecision(argPM);
  } else {
    this.bufferReducedPrecision();
  }
};
BufferOp.prototype.setQuadrantSegments = function setQuadrantSegments2(quadrantSegments) {
  this._bufParams.setQuadrantSegments(quadrantSegments);
};
BufferOp.prototype.bufferOriginalPrecision = function bufferOriginalPrecision() {
  try {
    var bufBuilder = new BufferBuilder(this._bufParams);
    this._resultGeometry = bufBuilder.buffer(this._argGeom, this._distance);
  } catch (ex) {
    if (ex instanceof RuntimeException) {
      this._saveException = ex;
    } else {
      throw ex;
    }
  } finally {
  }
};
BufferOp.prototype.getResultGeometry = function getResultGeometry(distance11) {
  this._distance = distance11;
  this.computeGeometry();
  return this._resultGeometry;
};
BufferOp.prototype.setEndCapStyle = function setEndCapStyle2(endCapStyle) {
  this._bufParams.setEndCapStyle(endCapStyle);
};
BufferOp.prototype.interfaces_ = function interfaces_114() {
  return [];
};
BufferOp.prototype.getClass = function getClass113() {
  return BufferOp;
};
BufferOp.bufferOp = function bufferOp() {
  if (arguments.length === 2) {
    var g2 = arguments[0];
    var distance11 = arguments[1];
    var gBuf = new BufferOp(g2);
    var geomBuf = gBuf.getResultGeometry(distance11);
    return geomBuf;
  } else if (arguments.length === 3) {
    if (Number.isInteger(arguments[2]) && (arguments[0] instanceof Geometry$1 && typeof arguments[1] === "number")) {
      var g$12 = arguments[0];
      var distance$12 = arguments[1];
      var quadrantSegments = arguments[2];
      var bufOp = new BufferOp(g$12);
      bufOp.setQuadrantSegments(quadrantSegments);
      var geomBuf$1 = bufOp.getResultGeometry(distance$12);
      return geomBuf$1;
    } else if (arguments[2] instanceof BufferParameters && (arguments[0] instanceof Geometry$1 && typeof arguments[1] === "number")) {
      var g$22 = arguments[0];
      var distance$22 = arguments[1];
      var params2 = arguments[2];
      var bufOp$1 = new BufferOp(g$22, params2);
      var geomBuf$2 = bufOp$1.getResultGeometry(distance$22);
      return geomBuf$2;
    }
  } else if (arguments.length === 4) {
    var g$32 = arguments[0];
    var distance$32 = arguments[1];
    var quadrantSegments$1 = arguments[2];
    var endCapStyle = arguments[3];
    var bufOp$2 = new BufferOp(g$32);
    bufOp$2.setQuadrantSegments(quadrantSegments$1);
    bufOp$2.setEndCapStyle(endCapStyle);
    var geomBuf$3 = bufOp$2.getResultGeometry(distance$32);
    return geomBuf$3;
  }
};
BufferOp.precisionScaleFactor = function precisionScaleFactor(g2, distance11, maxPrecisionDigits) {
  var env = g2.getEnvelopeInternal();
  var envMax = MathUtil.max(Math.abs(env.getMaxX()), Math.abs(env.getMaxY()), Math.abs(env.getMinX()), Math.abs(env.getMinY()));
  var expandByDistance = distance11 > 0 ? distance11 : 0;
  var bufEnvMax = envMax + 2 * expandByDistance;
  var bufEnvPrecisionDigits = Math.trunc(Math.log(bufEnvMax) / Math.log(10) + 1);
  var minUnitLog10 = maxPrecisionDigits - bufEnvPrecisionDigits;
  var scaleFactor = Math.pow(10, minUnitLog10);
  return scaleFactor;
};
staticAccessors$32.CAP_ROUND.get = function() {
  return BufferParameters.CAP_ROUND;
};
staticAccessors$32.CAP_BUTT.get = function() {
  return BufferParameters.CAP_FLAT;
};
staticAccessors$32.CAP_FLAT.get = function() {
  return BufferParameters.CAP_FLAT;
};
staticAccessors$32.CAP_SQUARE.get = function() {
  return BufferParameters.CAP_SQUARE;
};
staticAccessors$32.MAX_PRECISION_DIGITS.get = function() {
  return 12;
};
Object.defineProperties(BufferOp, staticAccessors$32);
var PointPairDistance = function PointPairDistance2() {
  this._pt = [new Coordinate(), new Coordinate()];
  this._distance = Double.NaN;
  this._isNull = true;
};
PointPairDistance.prototype.getCoordinates = function getCoordinates8() {
  return this._pt;
};
PointPairDistance.prototype.getCoordinate = function getCoordinate14(i2) {
  return this._pt[i2];
};
PointPairDistance.prototype.setMinimum = function setMinimum() {
  if (arguments.length === 1) {
    var ptDist = arguments[0];
    this.setMinimum(ptDist._pt[0], ptDist._pt[1]);
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    if (this._isNull) {
      this.initialize(p0, p1);
      return null;
    }
    var dist2 = p0.distance(p1);
    if (dist2 < this._distance) {
      this.initialize(p0, p1, dist2);
    }
  }
};
PointPairDistance.prototype.initialize = function initialize() {
  if (arguments.length === 0) {
    this._isNull = true;
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    this._pt[0].setCoordinate(p0);
    this._pt[1].setCoordinate(p1);
    this._distance = p0.distance(p1);
    this._isNull = false;
  } else if (arguments.length === 3) {
    var p0$1 = arguments[0];
    var p1$1 = arguments[1];
    var distance11 = arguments[2];
    this._pt[0].setCoordinate(p0$1);
    this._pt[1].setCoordinate(p1$1);
    this._distance = distance11;
    this._isNull = false;
  }
};
PointPairDistance.prototype.getDistance = function getDistance3() {
  return this._distance;
};
PointPairDistance.prototype.setMaximum = function setMaximum() {
  if (arguments.length === 1) {
    var ptDist = arguments[0];
    this.setMaximum(ptDist._pt[0], ptDist._pt[1]);
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    if (this._isNull) {
      this.initialize(p0, p1);
      return null;
    }
    var dist2 = p0.distance(p1);
    if (dist2 > this._distance) {
      this.initialize(p0, p1, dist2);
    }
  }
};
PointPairDistance.prototype.interfaces_ = function interfaces_115() {
  return [];
};
PointPairDistance.prototype.getClass = function getClass114() {
  return PointPairDistance;
};
var DistanceToPointFinder = function DistanceToPointFinder2() {
};
DistanceToPointFinder.prototype.interfaces_ = function interfaces_116() {
  return [];
};
DistanceToPointFinder.prototype.getClass = function getClass115() {
  return DistanceToPointFinder;
};
DistanceToPointFinder.computeDistance = function computeDistance() {
  if (arguments[2] instanceof PointPairDistance && (arguments[0] instanceof LineString$4 && arguments[1] instanceof Coordinate)) {
    var line = arguments[0];
    var pt = arguments[1];
    var ptDist = arguments[2];
    var coords = line.getCoordinates();
    var tempSegment = new LineSegment();
    for (var i2 = 0; i2 < coords.length - 1; i2++) {
      tempSegment.setCoordinates(coords[i2], coords[i2 + 1]);
      var closestPt = tempSegment.closestPoint(pt);
      ptDist.setMinimum(closestPt, pt);
    }
  } else if (arguments[2] instanceof PointPairDistance && (arguments[0] instanceof Polygon$5 && arguments[1] instanceof Coordinate)) {
    var poly2 = arguments[0];
    var pt$1 = arguments[1];
    var ptDist$1 = arguments[2];
    DistanceToPointFinder.computeDistance(poly2.getExteriorRing(), pt$1, ptDist$1);
    for (var i$12 = 0; i$12 < poly2.getNumInteriorRing(); i$12++) {
      DistanceToPointFinder.computeDistance(poly2.getInteriorRingN(i$12), pt$1, ptDist$1);
    }
  } else if (arguments[2] instanceof PointPairDistance && (arguments[0] instanceof Geometry$1 && arguments[1] instanceof Coordinate)) {
    var geom = arguments[0];
    var pt$2 = arguments[1];
    var ptDist$2 = arguments[2];
    if (geom instanceof LineString$4) {
      DistanceToPointFinder.computeDistance(geom, pt$2, ptDist$2);
    } else if (geom instanceof Polygon$5) {
      DistanceToPointFinder.computeDistance(geom, pt$2, ptDist$2);
    } else if (geom instanceof GeometryCollection) {
      var gc = geom;
      for (var i$22 = 0; i$22 < gc.getNumGeometries(); i$22++) {
        var g2 = gc.getGeometryN(i$22);
        DistanceToPointFinder.computeDistance(g2, pt$2, ptDist$2);
      }
    } else {
      ptDist$2.setMinimum(geom.getCoordinate(), pt$2);
    }
  } else if (arguments[2] instanceof PointPairDistance && (arguments[0] instanceof LineSegment && arguments[1] instanceof Coordinate)) {
    var segment = arguments[0];
    var pt$3 = arguments[1];
    var ptDist$3 = arguments[2];
    var closestPt$1 = segment.closestPoint(pt$3);
    ptDist$3.setMinimum(closestPt$1, pt$3);
  }
};
var BufferCurveMaximumDistanceFinder = function BufferCurveMaximumDistanceFinder2(inputGeom) {
  this._maxPtDist = new PointPairDistance();
  this._inputGeom = inputGeom || null;
};
var staticAccessors$36 = { MaxPointDistanceFilter: { configurable: true }, MaxMidpointDistanceFilter: { configurable: true } };
BufferCurveMaximumDistanceFinder.prototype.computeMaxMidpointDistance = function computeMaxMidpointDistance(curve) {
  var distFilter = new MaxMidpointDistanceFilter(this._inputGeom);
  curve.apply(distFilter);
  this._maxPtDist.setMaximum(distFilter.getMaxPointDistance());
};
BufferCurveMaximumDistanceFinder.prototype.computeMaxVertexDistance = function computeMaxVertexDistance(curve) {
  var distFilter = new MaxPointDistanceFilter(this._inputGeom);
  curve.apply(distFilter);
  this._maxPtDist.setMaximum(distFilter.getMaxPointDistance());
};
BufferCurveMaximumDistanceFinder.prototype.findDistance = function findDistance(bufferCurve) {
  this.computeMaxVertexDistance(bufferCurve);
  this.computeMaxMidpointDistance(bufferCurve);
  return this._maxPtDist.getDistance();
};
BufferCurveMaximumDistanceFinder.prototype.getDistancePoints = function getDistancePoints() {
  return this._maxPtDist;
};
BufferCurveMaximumDistanceFinder.prototype.interfaces_ = function interfaces_117() {
  return [];
};
BufferCurveMaximumDistanceFinder.prototype.getClass = function getClass116() {
  return BufferCurveMaximumDistanceFinder;
};
staticAccessors$36.MaxPointDistanceFilter.get = function() {
  return MaxPointDistanceFilter;
};
staticAccessors$36.MaxMidpointDistanceFilter.get = function() {
  return MaxMidpointDistanceFilter;
};
Object.defineProperties(BufferCurveMaximumDistanceFinder, staticAccessors$36);
var MaxPointDistanceFilter = function MaxPointDistanceFilter2(geom) {
  this._maxPtDist = new PointPairDistance();
  this._minPtDist = new PointPairDistance();
  this._geom = geom || null;
};
MaxPointDistanceFilter.prototype.filter = function filter6(pt) {
  this._minPtDist.initialize();
  DistanceToPointFinder.computeDistance(this._geom, pt, this._minPtDist);
  this._maxPtDist.setMaximum(this._minPtDist);
};
MaxPointDistanceFilter.prototype.getMaxPointDistance = function getMaxPointDistance() {
  return this._maxPtDist;
};
MaxPointDistanceFilter.prototype.interfaces_ = function interfaces_118() {
  return [CoordinateFilter];
};
MaxPointDistanceFilter.prototype.getClass = function getClass117() {
  return MaxPointDistanceFilter;
};
var MaxMidpointDistanceFilter = function MaxMidpointDistanceFilter2(geom) {
  this._maxPtDist = new PointPairDistance();
  this._minPtDist = new PointPairDistance();
  this._geom = geom || null;
};
MaxMidpointDistanceFilter.prototype.filter = function filter7(seq, index2) {
  if (index2 === 0) {
    return null;
  }
  var p0 = seq.getCoordinate(index2 - 1);
  var p1 = seq.getCoordinate(index2);
  var midPt = new Coordinate((p0.x + p1.x) / 2, (p0.y + p1.y) / 2);
  this._minPtDist.initialize();
  DistanceToPointFinder.computeDistance(this._geom, midPt, this._minPtDist);
  this._maxPtDist.setMaximum(this._minPtDist);
};
MaxMidpointDistanceFilter.prototype.isDone = function isDone5() {
  return false;
};
MaxMidpointDistanceFilter.prototype.isGeometryChanged = function isGeometryChanged2() {
  return false;
};
MaxMidpointDistanceFilter.prototype.getMaxPointDistance = function getMaxPointDistance2() {
  return this._maxPtDist;
};
MaxMidpointDistanceFilter.prototype.interfaces_ = function interfaces_119() {
  return [CoordinateSequenceFilter];
};
MaxMidpointDistanceFilter.prototype.getClass = function getClass118() {
  return MaxMidpointDistanceFilter;
};
var PolygonExtracter = function PolygonExtracter2(comps) {
  this._comps = comps || null;
};
PolygonExtracter.prototype.filter = function filter8(geom) {
  if (geom instanceof Polygon$5) {
    this._comps.add(geom);
  }
};
PolygonExtracter.prototype.interfaces_ = function interfaces_120() {
  return [GeometryFilter];
};
PolygonExtracter.prototype.getClass = function getClass119() {
  return PolygonExtracter;
};
PolygonExtracter.getPolygons = function getPolygons2() {
  if (arguments.length === 1) {
    var geom = arguments[0];
    return PolygonExtracter.getPolygons(geom, new ArrayList());
  } else if (arguments.length === 2) {
    var geom$1 = arguments[0];
    var list2 = arguments[1];
    if (geom$1 instanceof Polygon$5) {
      list2.add(geom$1);
    } else if (geom$1 instanceof GeometryCollection) {
      geom$1.apply(new PolygonExtracter(list2));
    }
    return list2;
  }
};
var LinearComponentExtracter = function LinearComponentExtracter2() {
  this._lines = null;
  this._isForcedToLineString = false;
  if (arguments.length === 1) {
    var lines = arguments[0];
    this._lines = lines;
  } else if (arguments.length === 2) {
    var lines$1 = arguments[0];
    var isForcedToLineString = arguments[1];
    this._lines = lines$1;
    this._isForcedToLineString = isForcedToLineString;
  }
};
LinearComponentExtracter.prototype.filter = function filter9(geom) {
  if (this._isForcedToLineString && geom instanceof LinearRing) {
    var line = geom.getFactory().createLineString(geom.getCoordinateSequence());
    this._lines.add(line);
    return null;
  }
  if (geom instanceof LineString$4) {
    this._lines.add(geom);
  }
};
LinearComponentExtracter.prototype.setForceToLineString = function setForceToLineString(isForcedToLineString) {
  this._isForcedToLineString = isForcedToLineString;
};
LinearComponentExtracter.prototype.interfaces_ = function interfaces_121() {
  return [GeometryComponentFilter];
};
LinearComponentExtracter.prototype.getClass = function getClass120() {
  return LinearComponentExtracter;
};
LinearComponentExtracter.getGeometry = function getGeometry2() {
  if (arguments.length === 1) {
    var geom = arguments[0];
    return geom.getFactory().buildGeometry(LinearComponentExtracter.getLines(geom));
  } else if (arguments.length === 2) {
    var geom$1 = arguments[0];
    var forceToLineString = arguments[1];
    return geom$1.getFactory().buildGeometry(LinearComponentExtracter.getLines(geom$1, forceToLineString));
  }
};
LinearComponentExtracter.getLines = function getLines() {
  if (arguments.length === 1) {
    var geom = arguments[0];
    return LinearComponentExtracter.getLines(geom, false);
  } else if (arguments.length === 2) {
    if (hasInterface(arguments[0], Collection) && hasInterface(arguments[1], Collection)) {
      var geoms = arguments[0];
      var lines$1 = arguments[1];
      for (var i2 = geoms.iterator(); i2.hasNext(); ) {
        var g2 = i2.next();
        LinearComponentExtracter.getLines(g2, lines$1);
      }
      return lines$1;
    } else if (arguments[0] instanceof Geometry$1 && typeof arguments[1] === "boolean") {
      var geom$1 = arguments[0];
      var forceToLineString = arguments[1];
      var lines = new ArrayList();
      geom$1.apply(new LinearComponentExtracter(lines, forceToLineString));
      return lines;
    } else if (arguments[0] instanceof Geometry$1 && hasInterface(arguments[1], Collection)) {
      var geom$2 = arguments[0];
      var lines$2 = arguments[1];
      if (geom$2 instanceof LineString$4) {
        lines$2.add(geom$2);
      } else {
        geom$2.apply(new LinearComponentExtracter(lines$2));
      }
      return lines$2;
    }
  } else if (arguments.length === 3) {
    if (typeof arguments[2] === "boolean" && (hasInterface(arguments[0], Collection) && hasInterface(arguments[1], Collection))) {
      var geoms$1 = arguments[0];
      var lines$3 = arguments[1];
      var forceToLineString$1 = arguments[2];
      for (var i$12 = geoms$1.iterator(); i$12.hasNext(); ) {
        var g$12 = i$12.next();
        LinearComponentExtracter.getLines(g$12, lines$3, forceToLineString$1);
      }
      return lines$3;
    } else if (typeof arguments[2] === "boolean" && (arguments[0] instanceof Geometry$1 && hasInterface(arguments[1], Collection))) {
      var geom$3 = arguments[0];
      var lines$4 = arguments[1];
      var forceToLineString$2 = arguments[2];
      geom$3.apply(new LinearComponentExtracter(lines$4, forceToLineString$2));
      return lines$4;
    }
  }
};
var PointLocator = function PointLocator2() {
  this._boundaryRule = BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE;
  this._isIn = null;
  this._numBoundaries = null;
  if (arguments.length === 0)
    ;
  else if (arguments.length === 1) {
    var boundaryRule = arguments[0];
    if (boundaryRule === null) {
      throw new IllegalArgumentException("Rule must be non-null");
    }
    this._boundaryRule = boundaryRule;
  }
};
PointLocator.prototype.locateInternal = function locateInternal() {
  var this$1$1 = this;
  if (arguments[0] instanceof Coordinate && arguments[1] instanceof Polygon$5) {
    var p2 = arguments[0];
    var poly2 = arguments[1];
    if (poly2.isEmpty()) {
      return Location.EXTERIOR;
    }
    var shell = poly2.getExteriorRing();
    var shellLoc = this.locateInPolygonRing(p2, shell);
    if (shellLoc === Location.EXTERIOR) {
      return Location.EXTERIOR;
    }
    if (shellLoc === Location.BOUNDARY) {
      return Location.BOUNDARY;
    }
    for (var i2 = 0; i2 < poly2.getNumInteriorRing(); i2++) {
      var hole = poly2.getInteriorRingN(i2);
      var holeLoc = this$1$1.locateInPolygonRing(p2, hole);
      if (holeLoc === Location.INTERIOR) {
        return Location.EXTERIOR;
      }
      if (holeLoc === Location.BOUNDARY) {
        return Location.BOUNDARY;
      }
    }
    return Location.INTERIOR;
  } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof LineString$4) {
    var p$12 = arguments[0];
    var l2 = arguments[1];
    if (!l2.getEnvelopeInternal().intersects(p$12)) {
      return Location.EXTERIOR;
    }
    var pt = l2.getCoordinates();
    if (!l2.isClosed()) {
      if (p$12.equals(pt[0]) || p$12.equals(pt[pt.length - 1])) {
        return Location.BOUNDARY;
      }
    }
    if (CGAlgorithms.isOnLine(p$12, pt)) {
      return Location.INTERIOR;
    }
    return Location.EXTERIOR;
  } else if (arguments[0] instanceof Coordinate && arguments[1] instanceof Point$7) {
    var p$22 = arguments[0];
    var pt$1 = arguments[1];
    var ptCoord = pt$1.getCoordinate();
    if (ptCoord.equals2D(p$22)) {
      return Location.INTERIOR;
    }
    return Location.EXTERIOR;
  }
};
PointLocator.prototype.locateInPolygonRing = function locateInPolygonRing(p2, ring) {
  if (!ring.getEnvelopeInternal().intersects(p2)) {
    return Location.EXTERIOR;
  }
  return CGAlgorithms.locatePointInRing(p2, ring.getCoordinates());
};
PointLocator.prototype.intersects = function intersects5(p2, geom) {
  return this.locate(p2, geom) !== Location.EXTERIOR;
};
PointLocator.prototype.updateLocationInfo = function updateLocationInfo(loc) {
  if (loc === Location.INTERIOR) {
    this._isIn = true;
  }
  if (loc === Location.BOUNDARY) {
    this._numBoundaries++;
  }
};
PointLocator.prototype.computeLocation = function computeLocation(p2, geom) {
  var this$1$1 = this;
  if (geom instanceof Point$7) {
    this.updateLocationInfo(this.locateInternal(p2, geom));
  }
  if (geom instanceof LineString$4) {
    this.updateLocationInfo(this.locateInternal(p2, geom));
  } else if (geom instanceof Polygon$5) {
    this.updateLocationInfo(this.locateInternal(p2, geom));
  } else if (geom instanceof MultiLineString$1) {
    var ml = geom;
    for (var i2 = 0; i2 < ml.getNumGeometries(); i2++) {
      var l2 = ml.getGeometryN(i2);
      this$1$1.updateLocationInfo(this$1$1.locateInternal(p2, l2));
    }
  } else if (geom instanceof MultiPolygon$1) {
    var mpoly = geom;
    for (var i$12 = 0; i$12 < mpoly.getNumGeometries(); i$12++) {
      var poly2 = mpoly.getGeometryN(i$12);
      this$1$1.updateLocationInfo(this$1$1.locateInternal(p2, poly2));
    }
  } else if (geom instanceof GeometryCollection) {
    var geomi = new GeometryCollectionIterator(geom);
    while (geomi.hasNext()) {
      var g2 = geomi.next();
      if (g2 !== geom) {
        this$1$1.computeLocation(p2, g2);
      }
    }
  }
};
PointLocator.prototype.locate = function locate4(p2, geom) {
  if (geom.isEmpty()) {
    return Location.EXTERIOR;
  }
  if (geom instanceof LineString$4) {
    return this.locateInternal(p2, geom);
  } else if (geom instanceof Polygon$5) {
    return this.locateInternal(p2, geom);
  }
  this._isIn = false;
  this._numBoundaries = 0;
  this.computeLocation(p2, geom);
  if (this._boundaryRule.isInBoundary(this._numBoundaries)) {
    return Location.BOUNDARY;
  }
  if (this._numBoundaries > 0 || this._isIn) {
    return Location.INTERIOR;
  }
  return Location.EXTERIOR;
};
PointLocator.prototype.interfaces_ = function interfaces_122() {
  return [];
};
PointLocator.prototype.getClass = function getClass121() {
  return PointLocator;
};
var GeometryLocation = function GeometryLocation2() {
  this._component = null;
  this._segIndex = null;
  this._pt = null;
  if (arguments.length === 2) {
    var component = arguments[0];
    var pt = arguments[1];
    GeometryLocation2.call(this, component, GeometryLocation2.INSIDE_AREA, pt);
  } else if (arguments.length === 3) {
    var component$1 = arguments[0];
    var segIndex = arguments[1];
    var pt$1 = arguments[2];
    this._component = component$1;
    this._segIndex = segIndex;
    this._pt = pt$1;
  }
};
var staticAccessors$38 = { INSIDE_AREA: { configurable: true } };
GeometryLocation.prototype.isInsideArea = function isInsideArea() {
  return this._segIndex === GeometryLocation.INSIDE_AREA;
};
GeometryLocation.prototype.getCoordinate = function getCoordinate15() {
  return this._pt;
};
GeometryLocation.prototype.getGeometryComponent = function getGeometryComponent() {
  return this._component;
};
GeometryLocation.prototype.getSegmentIndex = function getSegmentIndex2() {
  return this._segIndex;
};
GeometryLocation.prototype.interfaces_ = function interfaces_123() {
  return [];
};
GeometryLocation.prototype.getClass = function getClass122() {
  return GeometryLocation;
};
staticAccessors$38.INSIDE_AREA.get = function() {
  return -1;
};
Object.defineProperties(GeometryLocation, staticAccessors$38);
var PointExtracter = function PointExtracter2(pts) {
  this._pts = pts || null;
};
PointExtracter.prototype.filter = function filter10(geom) {
  if (geom instanceof Point$7) {
    this._pts.add(geom);
  }
};
PointExtracter.prototype.interfaces_ = function interfaces_124() {
  return [GeometryFilter];
};
PointExtracter.prototype.getClass = function getClass123() {
  return PointExtracter;
};
PointExtracter.getPoints = function getPoints2() {
  if (arguments.length === 1) {
    var geom = arguments[0];
    if (geom instanceof Point$7) {
      return Collections.singletonList(geom);
    }
    return PointExtracter.getPoints(geom, new ArrayList());
  } else if (arguments.length === 2) {
    var geom$1 = arguments[0];
    var list2 = arguments[1];
    if (geom$1 instanceof Point$7) {
      list2.add(geom$1);
    } else if (geom$1 instanceof GeometryCollection) {
      geom$1.apply(new PointExtracter(list2));
    }
    return list2;
  }
};
var ConnectedElementLocationFilter = function ConnectedElementLocationFilter2() {
  this._locations = null;
  var locations = arguments[0];
  this._locations = locations;
};
ConnectedElementLocationFilter.prototype.filter = function filter11(geom) {
  if (geom instanceof Point$7 || geom instanceof LineString$4 || geom instanceof Polygon$5) {
    this._locations.add(new GeometryLocation(geom, 0, geom.getCoordinate()));
  }
};
ConnectedElementLocationFilter.prototype.interfaces_ = function interfaces_125() {
  return [GeometryFilter];
};
ConnectedElementLocationFilter.prototype.getClass = function getClass124() {
  return ConnectedElementLocationFilter;
};
ConnectedElementLocationFilter.getLocations = function getLocations2(geom) {
  var locations = new ArrayList();
  geom.apply(new ConnectedElementLocationFilter(locations));
  return locations;
};
var DistanceOp = function DistanceOp2() {
  this._geom = null;
  this._terminateDistance = 0;
  this._ptLocator = new PointLocator();
  this._minDistanceLocation = null;
  this._minDistance = Double.MAX_VALUE;
  if (arguments.length === 2) {
    var g0 = arguments[0];
    var g1 = arguments[1];
    this._geom = [g0, g1];
    this._terminateDistance = 0;
  } else if (arguments.length === 3) {
    var g0$1 = arguments[0];
    var g1$1 = arguments[1];
    var terminateDistance = arguments[2];
    this._geom = new Array(2).fill(null);
    this._geom[0] = g0$1;
    this._geom[1] = g1$1;
    this._terminateDistance = terminateDistance;
  }
};
DistanceOp.prototype.computeContainmentDistance = function computeContainmentDistance() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    var locPtPoly = new Array(2).fill(null);
    this.computeContainmentDistance(0, locPtPoly);
    if (this._minDistance <= this._terminateDistance) {
      return null;
    }
    this.computeContainmentDistance(1, locPtPoly);
  } else if (arguments.length === 2) {
    var polyGeomIndex = arguments[0];
    var locPtPoly$1 = arguments[1];
    var locationsIndex = 1 - polyGeomIndex;
    var polys = PolygonExtracter.getPolygons(this._geom[polyGeomIndex]);
    if (polys.size() > 0) {
      var insideLocs = ConnectedElementLocationFilter.getLocations(this._geom[locationsIndex]);
      this.computeContainmentDistance(insideLocs, polys, locPtPoly$1);
      if (this._minDistance <= this._terminateDistance) {
        this._minDistanceLocation[locationsIndex] = locPtPoly$1[0];
        this._minDistanceLocation[polyGeomIndex] = locPtPoly$1[1];
        return null;
      }
    }
  } else if (arguments.length === 3) {
    if (arguments[2] instanceof Array && (hasInterface(arguments[0], List$2) && hasInterface(arguments[1], List$2))) {
      var locs = arguments[0];
      var polys$1 = arguments[1];
      var locPtPoly$2 = arguments[2];
      for (var i2 = 0; i2 < locs.size(); i2++) {
        var loc = locs.get(i2);
        for (var j2 = 0; j2 < polys$1.size(); j2++) {
          this$1$1.computeContainmentDistance(loc, polys$1.get(j2), locPtPoly$2);
          if (this$1$1._minDistance <= this$1$1._terminateDistance) {
            return null;
          }
        }
      }
    } else if (arguments[2] instanceof Array && (arguments[0] instanceof GeometryLocation && arguments[1] instanceof Polygon$5)) {
      var ptLoc = arguments[0];
      var poly2 = arguments[1];
      var locPtPoly$3 = arguments[2];
      var pt = ptLoc.getCoordinate();
      if (Location.EXTERIOR !== this._ptLocator.locate(pt, poly2)) {
        this._minDistance = 0;
        locPtPoly$3[0] = ptLoc;
        locPtPoly$3[1] = new GeometryLocation(poly2, pt);
        return null;
      }
    }
  }
};
DistanceOp.prototype.computeMinDistanceLinesPoints = function computeMinDistanceLinesPoints(lines, points2, locGeom) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < lines.size(); i2++) {
    var line = lines.get(i2);
    for (var j2 = 0; j2 < points2.size(); j2++) {
      var pt = points2.get(j2);
      this$1$1.computeMinDistance(line, pt, locGeom);
      if (this$1$1._minDistance <= this$1$1._terminateDistance) {
        return null;
      }
    }
  }
};
DistanceOp.prototype.computeFacetDistance = function computeFacetDistance() {
  var locGeom = new Array(2).fill(null);
  var lines0 = LinearComponentExtracter.getLines(this._geom[0]);
  var lines1 = LinearComponentExtracter.getLines(this._geom[1]);
  var pts0 = PointExtracter.getPoints(this._geom[0]);
  var pts1 = PointExtracter.getPoints(this._geom[1]);
  this.computeMinDistanceLines(lines0, lines1, locGeom);
  this.updateMinDistance(locGeom, false);
  if (this._minDistance <= this._terminateDistance) {
    return null;
  }
  locGeom[0] = null;
  locGeom[1] = null;
  this.computeMinDistanceLinesPoints(lines0, pts1, locGeom);
  this.updateMinDistance(locGeom, false);
  if (this._minDistance <= this._terminateDistance) {
    return null;
  }
  locGeom[0] = null;
  locGeom[1] = null;
  this.computeMinDistanceLinesPoints(lines1, pts0, locGeom);
  this.updateMinDistance(locGeom, true);
  if (this._minDistance <= this._terminateDistance) {
    return null;
  }
  locGeom[0] = null;
  locGeom[1] = null;
  this.computeMinDistancePoints(pts0, pts1, locGeom);
  this.updateMinDistance(locGeom, false);
};
DistanceOp.prototype.nearestLocations = function nearestLocations() {
  this.computeMinDistance();
  return this._minDistanceLocation;
};
DistanceOp.prototype.updateMinDistance = function updateMinDistance(locGeom, flip4) {
  if (locGeom[0] === null) {
    return null;
  }
  if (flip4) {
    this._minDistanceLocation[0] = locGeom[1];
    this._minDistanceLocation[1] = locGeom[0];
  } else {
    this._minDistanceLocation[0] = locGeom[0];
    this._minDistanceLocation[1] = locGeom[1];
  }
};
DistanceOp.prototype.nearestPoints = function nearestPoints() {
  this.computeMinDistance();
  var nearestPts = [this._minDistanceLocation[0].getCoordinate(), this._minDistanceLocation[1].getCoordinate()];
  return nearestPts;
};
DistanceOp.prototype.computeMinDistance = function computeMinDistance() {
  var this$1$1 = this;
  if (arguments.length === 0) {
    if (this._minDistanceLocation !== null) {
      return null;
    }
    this._minDistanceLocation = new Array(2).fill(null);
    this.computeContainmentDistance();
    if (this._minDistance <= this._terminateDistance) {
      return null;
    }
    this.computeFacetDistance();
  } else if (arguments.length === 3) {
    if (arguments[2] instanceof Array && (arguments[0] instanceof LineString$4 && arguments[1] instanceof Point$7)) {
      var line = arguments[0];
      var pt = arguments[1];
      var locGeom = arguments[2];
      if (line.getEnvelopeInternal().distance(pt.getEnvelopeInternal()) > this._minDistance) {
        return null;
      }
      var coord0 = line.getCoordinates();
      var coord = pt.getCoordinate();
      for (var i2 = 0; i2 < coord0.length - 1; i2++) {
        var dist2 = CGAlgorithms.distancePointLine(coord, coord0[i2], coord0[i2 + 1]);
        if (dist2 < this$1$1._minDistance) {
          this$1$1._minDistance = dist2;
          var seg = new LineSegment(coord0[i2], coord0[i2 + 1]);
          var segClosestPoint = seg.closestPoint(coord);
          locGeom[0] = new GeometryLocation(line, i2, segClosestPoint);
          locGeom[1] = new GeometryLocation(pt, 0, coord);
        }
        if (this$1$1._minDistance <= this$1$1._terminateDistance) {
          return null;
        }
      }
    } else if (arguments[2] instanceof Array && (arguments[0] instanceof LineString$4 && arguments[1] instanceof LineString$4)) {
      var line0 = arguments[0];
      var line1 = arguments[1];
      var locGeom$1 = arguments[2];
      if (line0.getEnvelopeInternal().distance(line1.getEnvelopeInternal()) > this._minDistance) {
        return null;
      }
      var coord0$1 = line0.getCoordinates();
      var coord1 = line1.getCoordinates();
      for (var i$12 = 0; i$12 < coord0$1.length - 1; i$12++) {
        for (var j2 = 0; j2 < coord1.length - 1; j2++) {
          var dist$12 = CGAlgorithms.distanceLineLine(coord0$1[i$12], coord0$1[i$12 + 1], coord1[j2], coord1[j2 + 1]);
          if (dist$12 < this$1$1._minDistance) {
            this$1$1._minDistance = dist$12;
            var seg0 = new LineSegment(coord0$1[i$12], coord0$1[i$12 + 1]);
            var seg1 = new LineSegment(coord1[j2], coord1[j2 + 1]);
            var closestPt = seg0.closestPoints(seg1);
            locGeom$1[0] = new GeometryLocation(line0, i$12, closestPt[0]);
            locGeom$1[1] = new GeometryLocation(line1, j2, closestPt[1]);
          }
          if (this$1$1._minDistance <= this$1$1._terminateDistance) {
            return null;
          }
        }
      }
    }
  }
};
DistanceOp.prototype.computeMinDistancePoints = function computeMinDistancePoints(points0, points1, locGeom) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < points0.size(); i2++) {
    var pt0 = points0.get(i2);
    for (var j2 = 0; j2 < points1.size(); j2++) {
      var pt1 = points1.get(j2);
      var dist2 = pt0.getCoordinate().distance(pt1.getCoordinate());
      if (dist2 < this$1$1._minDistance) {
        this$1$1._minDistance = dist2;
        locGeom[0] = new GeometryLocation(pt0, 0, pt0.getCoordinate());
        locGeom[1] = new GeometryLocation(pt1, 0, pt1.getCoordinate());
      }
      if (this$1$1._minDistance <= this$1$1._terminateDistance) {
        return null;
      }
    }
  }
};
DistanceOp.prototype.distance = function distance7() {
  if (this._geom[0] === null || this._geom[1] === null) {
    throw new IllegalArgumentException("null geometries are not supported");
  }
  if (this._geom[0].isEmpty() || this._geom[1].isEmpty()) {
    return 0;
  }
  this.computeMinDistance();
  return this._minDistance;
};
DistanceOp.prototype.computeMinDistanceLines = function computeMinDistanceLines(lines0, lines1, locGeom) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < lines0.size(); i2++) {
    var line0 = lines0.get(i2);
    for (var j2 = 0; j2 < lines1.size(); j2++) {
      var line1 = lines1.get(j2);
      this$1$1.computeMinDistance(line0, line1, locGeom);
      if (this$1$1._minDistance <= this$1$1._terminateDistance) {
        return null;
      }
    }
  }
};
DistanceOp.prototype.interfaces_ = function interfaces_126() {
  return [];
};
DistanceOp.prototype.getClass = function getClass125() {
  return DistanceOp;
};
DistanceOp.distance = function distance8(g0, g1) {
  var distOp = new DistanceOp(g0, g1);
  return distOp.distance();
};
DistanceOp.isWithinDistance = function isWithinDistance(g0, g1, distance11) {
  var distOp = new DistanceOp(g0, g1, distance11);
  return distOp.distance() <= distance11;
};
DistanceOp.nearestPoints = function nearestPoints2(g0, g1) {
  var distOp = new DistanceOp(g0, g1);
  return distOp.nearestPoints();
};
var PointPairDistance$2 = function PointPairDistance3() {
  this._pt = [new Coordinate(), new Coordinate()];
  this._distance = Double.NaN;
  this._isNull = true;
};
PointPairDistance$2.prototype.getCoordinates = function getCoordinates9() {
  return this._pt;
};
PointPairDistance$2.prototype.getCoordinate = function getCoordinate16(i2) {
  return this._pt[i2];
};
PointPairDistance$2.prototype.setMinimum = function setMinimum2() {
  if (arguments.length === 1) {
    var ptDist = arguments[0];
    this.setMinimum(ptDist._pt[0], ptDist._pt[1]);
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    if (this._isNull) {
      this.initialize(p0, p1);
      return null;
    }
    var dist2 = p0.distance(p1);
    if (dist2 < this._distance) {
      this.initialize(p0, p1, dist2);
    }
  }
};
PointPairDistance$2.prototype.initialize = function initialize2() {
  if (arguments.length === 0) {
    this._isNull = true;
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    this._pt[0].setCoordinate(p0);
    this._pt[1].setCoordinate(p1);
    this._distance = p0.distance(p1);
    this._isNull = false;
  } else if (arguments.length === 3) {
    var p0$1 = arguments[0];
    var p1$1 = arguments[1];
    var distance11 = arguments[2];
    this._pt[0].setCoordinate(p0$1);
    this._pt[1].setCoordinate(p1$1);
    this._distance = distance11;
    this._isNull = false;
  }
};
PointPairDistance$2.prototype.toString = function toString22() {
  return WKTWriter.toLineString(this._pt[0], this._pt[1]);
};
PointPairDistance$2.prototype.getDistance = function getDistance4() {
  return this._distance;
};
PointPairDistance$2.prototype.setMaximum = function setMaximum2() {
  if (arguments.length === 1) {
    var ptDist = arguments[0];
    this.setMaximum(ptDist._pt[0], ptDist._pt[1]);
  } else if (arguments.length === 2) {
    var p0 = arguments[0];
    var p1 = arguments[1];
    if (this._isNull) {
      this.initialize(p0, p1);
      return null;
    }
    var dist2 = p0.distance(p1);
    if (dist2 > this._distance) {
      this.initialize(p0, p1, dist2);
    }
  }
};
PointPairDistance$2.prototype.interfaces_ = function interfaces_127() {
  return [];
};
PointPairDistance$2.prototype.getClass = function getClass126() {
  return PointPairDistance$2;
};
var DistanceToPoint = function DistanceToPoint2() {
};
DistanceToPoint.prototype.interfaces_ = function interfaces_128() {
  return [];
};
DistanceToPoint.prototype.getClass = function getClass127() {
  return DistanceToPoint;
};
DistanceToPoint.computeDistance = function computeDistance2() {
  if (arguments[2] instanceof PointPairDistance$2 && (arguments[0] instanceof LineString$4 && arguments[1] instanceof Coordinate)) {
    var line = arguments[0];
    var pt = arguments[1];
    var ptDist = arguments[2];
    var tempSegment = new LineSegment();
    var coords = line.getCoordinates();
    for (var i2 = 0; i2 < coords.length - 1; i2++) {
      tempSegment.setCoordinates(coords[i2], coords[i2 + 1]);
      var closestPt = tempSegment.closestPoint(pt);
      ptDist.setMinimum(closestPt, pt);
    }
  } else if (arguments[2] instanceof PointPairDistance$2 && (arguments[0] instanceof Polygon$5 && arguments[1] instanceof Coordinate)) {
    var poly2 = arguments[0];
    var pt$1 = arguments[1];
    var ptDist$1 = arguments[2];
    DistanceToPoint.computeDistance(poly2.getExteriorRing(), pt$1, ptDist$1);
    for (var i$12 = 0; i$12 < poly2.getNumInteriorRing(); i$12++) {
      DistanceToPoint.computeDistance(poly2.getInteriorRingN(i$12), pt$1, ptDist$1);
    }
  } else if (arguments[2] instanceof PointPairDistance$2 && (arguments[0] instanceof Geometry$1 && arguments[1] instanceof Coordinate)) {
    var geom = arguments[0];
    var pt$2 = arguments[1];
    var ptDist$2 = arguments[2];
    if (geom instanceof LineString$4) {
      DistanceToPoint.computeDistance(geom, pt$2, ptDist$2);
    } else if (geom instanceof Polygon$5) {
      DistanceToPoint.computeDistance(geom, pt$2, ptDist$2);
    } else if (geom instanceof GeometryCollection) {
      var gc = geom;
      for (var i$22 = 0; i$22 < gc.getNumGeometries(); i$22++) {
        var g2 = gc.getGeometryN(i$22);
        DistanceToPoint.computeDistance(g2, pt$2, ptDist$2);
      }
    } else {
      ptDist$2.setMinimum(geom.getCoordinate(), pt$2);
    }
  } else if (arguments[2] instanceof PointPairDistance$2 && (arguments[0] instanceof LineSegment && arguments[1] instanceof Coordinate)) {
    var segment = arguments[0];
    var pt$3 = arguments[1];
    var ptDist$3 = arguments[2];
    var closestPt$1 = segment.closestPoint(pt$3);
    ptDist$3.setMinimum(closestPt$1, pt$3);
  }
};
var DiscreteHausdorffDistance = function DiscreteHausdorffDistance2() {
  this._g0 = null;
  this._g1 = null;
  this._ptDist = new PointPairDistance$2();
  this._densifyFrac = 0;
  var g0 = arguments[0];
  var g1 = arguments[1];
  this._g0 = g0;
  this._g1 = g1;
};
var staticAccessors$39 = { MaxPointDistanceFilter: { configurable: true }, MaxDensifiedByFractionDistanceFilter: { configurable: true } };
DiscreteHausdorffDistance.prototype.getCoordinates = function getCoordinates10() {
  return this._ptDist.getCoordinates();
};
DiscreteHausdorffDistance.prototype.setDensifyFraction = function setDensifyFraction(densifyFrac) {
  if (densifyFrac > 1 || densifyFrac <= 0) {
    throw new IllegalArgumentException("Fraction is not in range (0.0 - 1.0]");
  }
  this._densifyFrac = densifyFrac;
};
DiscreteHausdorffDistance.prototype.compute = function compute(g0, g1) {
  this.computeOrientedDistance(g0, g1, this._ptDist);
  this.computeOrientedDistance(g1, g0, this._ptDist);
};
DiscreteHausdorffDistance.prototype.distance = function distance9() {
  this.compute(this._g0, this._g1);
  return this._ptDist.getDistance();
};
DiscreteHausdorffDistance.prototype.computeOrientedDistance = function computeOrientedDistance(discreteGeom, geom, ptDist) {
  var distFilter = new MaxPointDistanceFilter$1(geom);
  discreteGeom.apply(distFilter);
  ptDist.setMaximum(distFilter.getMaxPointDistance());
  if (this._densifyFrac > 0) {
    var fracFilter = new MaxDensifiedByFractionDistanceFilter(geom, this._densifyFrac);
    discreteGeom.apply(fracFilter);
    ptDist.setMaximum(fracFilter.getMaxPointDistance());
  }
};
DiscreteHausdorffDistance.prototype.orientedDistance = function orientedDistance() {
  this.computeOrientedDistance(this._g0, this._g1, this._ptDist);
  return this._ptDist.getDistance();
};
DiscreteHausdorffDistance.prototype.interfaces_ = function interfaces_129() {
  return [];
};
DiscreteHausdorffDistance.prototype.getClass = function getClass128() {
  return DiscreteHausdorffDistance;
};
DiscreteHausdorffDistance.distance = function distance10() {
  if (arguments.length === 2) {
    var g0 = arguments[0];
    var g1 = arguments[1];
    var dist2 = new DiscreteHausdorffDistance(g0, g1);
    return dist2.distance();
  } else if (arguments.length === 3) {
    var g0$1 = arguments[0];
    var g1$1 = arguments[1];
    var densifyFrac = arguments[2];
    var dist$12 = new DiscreteHausdorffDistance(g0$1, g1$1);
    dist$12.setDensifyFraction(densifyFrac);
    return dist$12.distance();
  }
};
staticAccessors$39.MaxPointDistanceFilter.get = function() {
  return MaxPointDistanceFilter$1;
};
staticAccessors$39.MaxDensifiedByFractionDistanceFilter.get = function() {
  return MaxDensifiedByFractionDistanceFilter;
};
Object.defineProperties(DiscreteHausdorffDistance, staticAccessors$39);
var MaxPointDistanceFilter$1 = function MaxPointDistanceFilter3() {
  this._maxPtDist = new PointPairDistance$2();
  this._minPtDist = new PointPairDistance$2();
  this._euclideanDist = new DistanceToPoint();
  this._geom = null;
  var geom = arguments[0];
  this._geom = geom;
};
MaxPointDistanceFilter$1.prototype.filter = function filter12(pt) {
  this._minPtDist.initialize();
  DistanceToPoint.computeDistance(this._geom, pt, this._minPtDist);
  this._maxPtDist.setMaximum(this._minPtDist);
};
MaxPointDistanceFilter$1.prototype.getMaxPointDistance = function getMaxPointDistance3() {
  return this._maxPtDist;
};
MaxPointDistanceFilter$1.prototype.interfaces_ = function interfaces_130() {
  return [CoordinateFilter];
};
MaxPointDistanceFilter$1.prototype.getClass = function getClass129() {
  return MaxPointDistanceFilter$1;
};
var MaxDensifiedByFractionDistanceFilter = function MaxDensifiedByFractionDistanceFilter2() {
  this._maxPtDist = new PointPairDistance$2();
  this._minPtDist = new PointPairDistance$2();
  this._geom = null;
  this._numSubSegs = 0;
  var geom = arguments[0];
  var fraction = arguments[1];
  this._geom = geom;
  this._numSubSegs = Math.trunc(Math.round(1 / fraction));
};
MaxDensifiedByFractionDistanceFilter.prototype.filter = function filter13(seq, index2) {
  var this$1$1 = this;
  if (index2 === 0) {
    return null;
  }
  var p0 = seq.getCoordinate(index2 - 1);
  var p1 = seq.getCoordinate(index2);
  var delx = (p1.x - p0.x) / this._numSubSegs;
  var dely = (p1.y - p0.y) / this._numSubSegs;
  for (var i2 = 0; i2 < this._numSubSegs; i2++) {
    var x2 = p0.x + i2 * delx;
    var y2 = p0.y + i2 * dely;
    var pt = new Coordinate(x2, y2);
    this$1$1._minPtDist.initialize();
    DistanceToPoint.computeDistance(this$1$1._geom, pt, this$1$1._minPtDist);
    this$1$1._maxPtDist.setMaximum(this$1$1._minPtDist);
  }
};
MaxDensifiedByFractionDistanceFilter.prototype.isDone = function isDone6() {
  return false;
};
MaxDensifiedByFractionDistanceFilter.prototype.isGeometryChanged = function isGeometryChanged3() {
  return false;
};
MaxDensifiedByFractionDistanceFilter.prototype.getMaxPointDistance = function getMaxPointDistance4() {
  return this._maxPtDist;
};
MaxDensifiedByFractionDistanceFilter.prototype.interfaces_ = function interfaces_131() {
  return [CoordinateSequenceFilter];
};
MaxDensifiedByFractionDistanceFilter.prototype.getClass = function getClass130() {
  return MaxDensifiedByFractionDistanceFilter;
};
var BufferDistanceValidator = function BufferDistanceValidator2(input, bufDistance, result) {
  this._minValidDistance = null;
  this._maxValidDistance = null;
  this._minDistanceFound = null;
  this._maxDistanceFound = null;
  this._isValid = true;
  this._errMsg = null;
  this._errorLocation = null;
  this._errorIndicator = null;
  this._input = input || null;
  this._bufDistance = bufDistance || null;
  this._result = result || null;
};
var staticAccessors$37 = { VERBOSE: { configurable: true }, MAX_DISTANCE_DIFF_FRAC: { configurable: true } };
BufferDistanceValidator.prototype.checkMaximumDistance = function checkMaximumDistance(input, bufCurve, maxDist) {
  var haus = new DiscreteHausdorffDistance(bufCurve, input);
  haus.setDensifyFraction(0.25);
  this._maxDistanceFound = haus.orientedDistance();
  if (this._maxDistanceFound > maxDist) {
    this._isValid = false;
    var pts = haus.getCoordinates();
    this._errorLocation = pts[1];
    this._errorIndicator = input.getFactory().createLineString(pts);
    this._errMsg = "Distance between buffer curve and input is too large (" + this._maxDistanceFound + " at " + WKTWriter.toLineString(pts[0], pts[1]) + ")";
  }
};
BufferDistanceValidator.prototype.isValid = function isValid() {
  var posDistance = Math.abs(this._bufDistance);
  var distDelta = BufferDistanceValidator.MAX_DISTANCE_DIFF_FRAC * posDistance;
  this._minValidDistance = posDistance - distDelta;
  this._maxValidDistance = posDistance + distDelta;
  if (this._input.isEmpty() || this._result.isEmpty()) {
    return true;
  }
  if (this._bufDistance > 0) {
    this.checkPositiveValid();
  } else {
    this.checkNegativeValid();
  }
  if (BufferDistanceValidator.VERBOSE) {
    System.out.println("Min Dist= " + this._minDistanceFound + "  err= " + (1 - this._minDistanceFound / this._bufDistance) + "  Max Dist= " + this._maxDistanceFound + "  err= " + (this._maxDistanceFound / this._bufDistance - 1));
  }
  return this._isValid;
};
BufferDistanceValidator.prototype.checkNegativeValid = function checkNegativeValid() {
  if (!(this._input instanceof Polygon$5 || this._input instanceof MultiPolygon$1 || this._input instanceof GeometryCollection)) {
    return null;
  }
  var inputCurve = this.getPolygonLines(this._input);
  this.checkMinimumDistance(inputCurve, this._result, this._minValidDistance);
  if (!this._isValid) {
    return null;
  }
  this.checkMaximumDistance(inputCurve, this._result, this._maxValidDistance);
};
BufferDistanceValidator.prototype.getErrorIndicator = function getErrorIndicator() {
  return this._errorIndicator;
};
BufferDistanceValidator.prototype.checkMinimumDistance = function checkMinimumDistance(g1, g2, minDist) {
  var distOp = new DistanceOp(g1, g2, minDist);
  this._minDistanceFound = distOp.distance();
  if (this._minDistanceFound < minDist) {
    this._isValid = false;
    var pts = distOp.nearestPoints();
    this._errorLocation = distOp.nearestPoints()[1];
    this._errorIndicator = g1.getFactory().createLineString(pts);
    this._errMsg = "Distance between buffer curve and input is too small (" + this._minDistanceFound + " at " + WKTWriter.toLineString(pts[0], pts[1]) + " )";
  }
};
BufferDistanceValidator.prototype.checkPositiveValid = function checkPositiveValid() {
  var bufCurve = this._result.getBoundary();
  this.checkMinimumDistance(this._input, bufCurve, this._minValidDistance);
  if (!this._isValid) {
    return null;
  }
  this.checkMaximumDistance(this._input, bufCurve, this._maxValidDistance);
};
BufferDistanceValidator.prototype.getErrorLocation = function getErrorLocation() {
  return this._errorLocation;
};
BufferDistanceValidator.prototype.getPolygonLines = function getPolygonLines(g2) {
  var lines = new ArrayList();
  var lineExtracter = new LinearComponentExtracter(lines);
  var polys = PolygonExtracter.getPolygons(g2);
  for (var i2 = polys.iterator(); i2.hasNext(); ) {
    var poly2 = i2.next();
    poly2.apply(lineExtracter);
  }
  return g2.getFactory().buildGeometry(lines);
};
BufferDistanceValidator.prototype.getErrorMessage = function getErrorMessage() {
  return this._errMsg;
};
BufferDistanceValidator.prototype.interfaces_ = function interfaces_132() {
  return [];
};
BufferDistanceValidator.prototype.getClass = function getClass131() {
  return BufferDistanceValidator;
};
staticAccessors$37.VERBOSE.get = function() {
  return false;
};
staticAccessors$37.MAX_DISTANCE_DIFF_FRAC.get = function() {
  return 0.012;
};
Object.defineProperties(BufferDistanceValidator, staticAccessors$37);
var BufferResultValidator = function BufferResultValidator2(input, distance11, result) {
  this._isValid = true;
  this._errorMsg = null;
  this._errorLocation = null;
  this._errorIndicator = null;
  this._input = input || null;
  this._distance = distance11 || null;
  this._result = result || null;
};
var staticAccessors$40 = { VERBOSE: { configurable: true }, MAX_ENV_DIFF_FRAC: { configurable: true } };
BufferResultValidator.prototype.isValid = function isValid2() {
  this.checkPolygonal();
  if (!this._isValid) {
    return this._isValid;
  }
  this.checkExpectedEmpty();
  if (!this._isValid) {
    return this._isValid;
  }
  this.checkEnvelope();
  if (!this._isValid) {
    return this._isValid;
  }
  this.checkArea();
  if (!this._isValid) {
    return this._isValid;
  }
  this.checkDistance();
  return this._isValid;
};
BufferResultValidator.prototype.checkEnvelope = function checkEnvelope() {
  if (this._distance < 0) {
    return null;
  }
  var padding = this._distance * BufferResultValidator.MAX_ENV_DIFF_FRAC;
  if (padding === 0) {
    padding = 1e-3;
  }
  var expectedEnv = new Envelope(this._input.getEnvelopeInternal());
  expectedEnv.expandBy(this._distance);
  var bufEnv = new Envelope(this._result.getEnvelopeInternal());
  bufEnv.expandBy(padding);
  if (!bufEnv.contains(expectedEnv)) {
    this._isValid = false;
    this._errorMsg = "Buffer envelope is incorrect";
    this._errorIndicator = this._input.getFactory().toGeometry(bufEnv);
  }
  this.report("Envelope");
};
BufferResultValidator.prototype.checkDistance = function checkDistance() {
  var distValid = new BufferDistanceValidator(this._input, this._distance, this._result);
  if (!distValid.isValid()) {
    this._isValid = false;
    this._errorMsg = distValid.getErrorMessage();
    this._errorLocation = distValid.getErrorLocation();
    this._errorIndicator = distValid.getErrorIndicator();
  }
  this.report("Distance");
};
BufferResultValidator.prototype.checkArea = function checkArea() {
  var inputArea = this._input.getArea();
  var resultArea = this._result.getArea();
  if (this._distance > 0 && inputArea > resultArea) {
    this._isValid = false;
    this._errorMsg = "Area of positive buffer is smaller than input";
    this._errorIndicator = this._result;
  }
  if (this._distance < 0 && inputArea < resultArea) {
    this._isValid = false;
    this._errorMsg = "Area of negative buffer is larger than input";
    this._errorIndicator = this._result;
  }
  this.report("Area");
};
BufferResultValidator.prototype.checkPolygonal = function checkPolygonal() {
  if (!(this._result instanceof Polygon$5 || this._result instanceof MultiPolygon$1)) {
    this._isValid = false;
  }
  this._errorMsg = "Result is not polygonal";
  this._errorIndicator = this._result;
  this.report("Polygonal");
};
BufferResultValidator.prototype.getErrorIndicator = function getErrorIndicator2() {
  return this._errorIndicator;
};
BufferResultValidator.prototype.getErrorLocation = function getErrorLocation2() {
  return this._errorLocation;
};
BufferResultValidator.prototype.checkExpectedEmpty = function checkExpectedEmpty() {
  if (this._input.getDimension() >= 2) {
    return null;
  }
  if (this._distance > 0) {
    return null;
  }
  if (!this._result.isEmpty()) {
    this._isValid = false;
    this._errorMsg = "Result is non-empty";
    this._errorIndicator = this._result;
  }
  this.report("ExpectedEmpty");
};
BufferResultValidator.prototype.report = function report(checkName) {
  if (!BufferResultValidator.VERBOSE) {
    return null;
  }
  System.out.println("Check " + checkName + ": " + (this._isValid ? "passed" : "FAILED"));
};
BufferResultValidator.prototype.getErrorMessage = function getErrorMessage2() {
  return this._errorMsg;
};
BufferResultValidator.prototype.interfaces_ = function interfaces_133() {
  return [];
};
BufferResultValidator.prototype.getClass = function getClass132() {
  return BufferResultValidator;
};
BufferResultValidator.isValidMsg = function isValidMsg(g2, distance11, result) {
  var validator2 = new BufferResultValidator(g2, distance11, result);
  if (!validator2.isValid()) {
    return validator2.getErrorMessage();
  }
  return null;
};
BufferResultValidator.isValid = function isValid3(g2, distance11, result) {
  var validator2 = new BufferResultValidator(g2, distance11, result);
  if (validator2.isValid()) {
    return true;
  }
  return false;
};
staticAccessors$40.VERBOSE.get = function() {
  return false;
};
staticAccessors$40.MAX_ENV_DIFF_FRAC.get = function() {
  return 0.012;
};
Object.defineProperties(BufferResultValidator, staticAccessors$40);
var BasicSegmentString = function BasicSegmentString2() {
  this._pts = null;
  this._data = null;
  var pts = arguments[0];
  var data2 = arguments[1];
  this._pts = pts;
  this._data = data2;
};
BasicSegmentString.prototype.getCoordinates = function getCoordinates11() {
  return this._pts;
};
BasicSegmentString.prototype.size = function size11() {
  return this._pts.length;
};
BasicSegmentString.prototype.getCoordinate = function getCoordinate17(i2) {
  return this._pts[i2];
};
BasicSegmentString.prototype.isClosed = function isClosed3() {
  return this._pts[0].equals(this._pts[this._pts.length - 1]);
};
BasicSegmentString.prototype.getSegmentOctant = function getSegmentOctant2(index2) {
  if (index2 === this._pts.length - 1) {
    return -1;
  }
  return Octant.octant(this.getCoordinate(index2), this.getCoordinate(index2 + 1));
};
BasicSegmentString.prototype.setData = function setData4(data2) {
  this._data = data2;
};
BasicSegmentString.prototype.getData = function getData4() {
  return this._data;
};
BasicSegmentString.prototype.toString = function toString23() {
  return WKTWriter.toLineString(new CoordinateArraySequence(this._pts));
};
BasicSegmentString.prototype.interfaces_ = function interfaces_134() {
  return [SegmentString];
};
BasicSegmentString.prototype.getClass = function getClass133() {
  return BasicSegmentString;
};
var InteriorIntersectionFinder = function InteriorIntersectionFinder2() {
  this._findAllIntersections = false;
  this._isCheckEndSegmentsOnly = false;
  this._li = null;
  this._interiorIntersection = null;
  this._intSegments = null;
  this._intersections = new ArrayList();
  this._intersectionCount = 0;
  this._keepIntersections = true;
  var li = arguments[0];
  this._li = li;
  this._interiorIntersection = null;
};
InteriorIntersectionFinder.prototype.getInteriorIntersection = function getInteriorIntersection() {
  return this._interiorIntersection;
};
InteriorIntersectionFinder.prototype.setCheckEndSegmentsOnly = function setCheckEndSegmentsOnly(isCheckEndSegmentsOnly) {
  this._isCheckEndSegmentsOnly = isCheckEndSegmentsOnly;
};
InteriorIntersectionFinder.prototype.getIntersectionSegments = function getIntersectionSegments() {
  return this._intSegments;
};
InteriorIntersectionFinder.prototype.count = function count2() {
  return this._intersectionCount;
};
InteriorIntersectionFinder.prototype.getIntersections = function getIntersections() {
  return this._intersections;
};
InteriorIntersectionFinder.prototype.setFindAllIntersections = function setFindAllIntersections(findAllIntersections) {
  this._findAllIntersections = findAllIntersections;
};
InteriorIntersectionFinder.prototype.setKeepIntersections = function setKeepIntersections(keepIntersections) {
  this._keepIntersections = keepIntersections;
};
InteriorIntersectionFinder.prototype.processIntersections = function processIntersections4(e0, segIndex0, e1, segIndex1) {
  if (!this._findAllIntersections && this.hasIntersection()) {
    return null;
  }
  if (e0 === e1 && segIndex0 === segIndex1) {
    return null;
  }
  if (this._isCheckEndSegmentsOnly) {
    var isEndSegPresent = this.isEndSegment(e0, segIndex0) || this.isEndSegment(e1, segIndex1);
    if (!isEndSegPresent) {
      return null;
    }
  }
  var p00 = e0.getCoordinates()[segIndex0];
  var p01 = e0.getCoordinates()[segIndex0 + 1];
  var p10 = e1.getCoordinates()[segIndex1];
  var p11 = e1.getCoordinates()[segIndex1 + 1];
  this._li.computeIntersection(p00, p01, p10, p11);
  if (this._li.hasIntersection()) {
    if (this._li.isInteriorIntersection()) {
      this._intSegments = new Array(4).fill(null);
      this._intSegments[0] = p00;
      this._intSegments[1] = p01;
      this._intSegments[2] = p10;
      this._intSegments[3] = p11;
      this._interiorIntersection = this._li.getIntersection(0);
      if (this._keepIntersections) {
        this._intersections.add(this._interiorIntersection);
      }
      this._intersectionCount++;
    }
  }
};
InteriorIntersectionFinder.prototype.isEndSegment = function isEndSegment(segStr, index2) {
  if (index2 === 0) {
    return true;
  }
  if (index2 >= segStr.size() - 2) {
    return true;
  }
  return false;
};
InteriorIntersectionFinder.prototype.hasIntersection = function hasIntersection3() {
  return this._interiorIntersection !== null;
};
InteriorIntersectionFinder.prototype.isDone = function isDone7() {
  if (this._findAllIntersections) {
    return false;
  }
  return this._interiorIntersection !== null;
};
InteriorIntersectionFinder.prototype.interfaces_ = function interfaces_135() {
  return [SegmentIntersector];
};
InteriorIntersectionFinder.prototype.getClass = function getClass134() {
  return InteriorIntersectionFinder;
};
InteriorIntersectionFinder.createAllIntersectionsFinder = function createAllIntersectionsFinder(li) {
  var finder = new InteriorIntersectionFinder(li);
  finder.setFindAllIntersections(true);
  return finder;
};
InteriorIntersectionFinder.createAnyIntersectionFinder = function createAnyIntersectionFinder(li) {
  return new InteriorIntersectionFinder(li);
};
InteriorIntersectionFinder.createIntersectionCounter = function createIntersectionCounter(li) {
  var finder = new InteriorIntersectionFinder(li);
  finder.setFindAllIntersections(true);
  finder.setKeepIntersections(false);
  return finder;
};
var FastNodingValidator = function FastNodingValidator2() {
  this._li = new RobustLineIntersector();
  this._segStrings = null;
  this._findAllIntersections = false;
  this._segInt = null;
  this._isValid = true;
  var segStrings = arguments[0];
  this._segStrings = segStrings;
};
FastNodingValidator.prototype.execute = function execute() {
  if (this._segInt !== null) {
    return null;
  }
  this.checkInteriorIntersections();
};
FastNodingValidator.prototype.getIntersections = function getIntersections2() {
  return this._segInt.getIntersections();
};
FastNodingValidator.prototype.isValid = function isValid4() {
  this.execute();
  return this._isValid;
};
FastNodingValidator.prototype.setFindAllIntersections = function setFindAllIntersections2(findAllIntersections) {
  this._findAllIntersections = findAllIntersections;
};
FastNodingValidator.prototype.checkInteriorIntersections = function checkInteriorIntersections2() {
  this._isValid = true;
  this._segInt = new InteriorIntersectionFinder(this._li);
  this._segInt.setFindAllIntersections(this._findAllIntersections);
  var noder = new MCIndexNoder();
  noder.setSegmentIntersector(this._segInt);
  noder.computeNodes(this._segStrings);
  if (this._segInt.hasIntersection()) {
    this._isValid = false;
    return null;
  }
};
FastNodingValidator.prototype.checkValid = function checkValid2() {
  this.execute();
  if (!this._isValid) {
    throw new TopologyException(this.getErrorMessage(), this._segInt.getInteriorIntersection());
  }
};
FastNodingValidator.prototype.getErrorMessage = function getErrorMessage3() {
  if (this._isValid) {
    return "no intersections found";
  }
  var intSegs = this._segInt.getIntersectionSegments();
  return "found non-noded intersection between " + WKTWriter.toLineString(intSegs[0], intSegs[1]) + " and " + WKTWriter.toLineString(intSegs[2], intSegs[3]);
};
FastNodingValidator.prototype.interfaces_ = function interfaces_136() {
  return [];
};
FastNodingValidator.prototype.getClass = function getClass135() {
  return FastNodingValidator;
};
FastNodingValidator.computeIntersections = function computeIntersections(segStrings) {
  var nv = new FastNodingValidator(segStrings);
  nv.setFindAllIntersections(true);
  nv.isValid();
  return nv.getIntersections();
};
var EdgeNodingValidator = function EdgeNodingValidator2() {
  this._nv = null;
  var edges = arguments[0];
  this._nv = new FastNodingValidator(EdgeNodingValidator2.toSegmentStrings(edges));
};
EdgeNodingValidator.prototype.checkValid = function checkValid3() {
  this._nv.checkValid();
};
EdgeNodingValidator.prototype.interfaces_ = function interfaces_137() {
  return [];
};
EdgeNodingValidator.prototype.getClass = function getClass136() {
  return EdgeNodingValidator;
};
EdgeNodingValidator.toSegmentStrings = function toSegmentStrings(edges) {
  var segStrings = new ArrayList();
  for (var i2 = edges.iterator(); i2.hasNext(); ) {
    var e3 = i2.next();
    segStrings.add(new BasicSegmentString(e3.getCoordinates(), e3));
  }
  return segStrings;
};
EdgeNodingValidator.checkValid = function checkValid4(edges) {
  var validator2 = new EdgeNodingValidator(edges);
  validator2.checkValid();
};
var GeometryCollectionMapper = function GeometryCollectionMapper2(mapOp) {
  this._mapOp = mapOp;
};
GeometryCollectionMapper.prototype.map = function map2(gc) {
  var this$1$1 = this;
  var mapped = new ArrayList();
  for (var i2 = 0; i2 < gc.getNumGeometries(); i2++) {
    var g2 = this$1$1._mapOp.map(gc.getGeometryN(i2));
    if (!g2.isEmpty()) {
      mapped.add(g2);
    }
  }
  return gc.getFactory().createGeometryCollection(GeometryFactory.toGeometryArray(mapped));
};
GeometryCollectionMapper.prototype.interfaces_ = function interfaces_138() {
  return [];
};
GeometryCollectionMapper.prototype.getClass = function getClass137() {
  return GeometryCollectionMapper;
};
GeometryCollectionMapper.map = function map3(gc, op) {
  var mapper = new GeometryCollectionMapper(op);
  return mapper.map(gc);
};
var LineBuilder = function LineBuilder2() {
  this._op = null;
  this._geometryFactory = null;
  this._ptLocator = null;
  this._lineEdgesList = new ArrayList();
  this._resultLineList = new ArrayList();
  var op = arguments[0];
  var geometryFactory = arguments[1];
  var ptLocator = arguments[2];
  this._op = op;
  this._geometryFactory = geometryFactory;
  this._ptLocator = ptLocator;
};
LineBuilder.prototype.collectLines = function collectLines(opCode) {
  var this$1$1 = this;
  for (var it = this._op.getGraph().getEdgeEnds().iterator(); it.hasNext(); ) {
    var de = it.next();
    this$1$1.collectLineEdge(de, opCode, this$1$1._lineEdgesList);
    this$1$1.collectBoundaryTouchEdge(de, opCode, this$1$1._lineEdgesList);
  }
};
LineBuilder.prototype.labelIsolatedLine = function labelIsolatedLine(e3, targetIndex) {
  var loc = this._ptLocator.locate(e3.getCoordinate(), this._op.getArgGeometry(targetIndex));
  e3.getLabel().setLocation(targetIndex, loc);
};
LineBuilder.prototype.build = function build3(opCode) {
  this.findCoveredLineEdges();
  this.collectLines(opCode);
  this.buildLines(opCode);
  return this._resultLineList;
};
LineBuilder.prototype.collectLineEdge = function collectLineEdge(de, opCode, edges) {
  var label = de.getLabel();
  var e3 = de.getEdge();
  if (de.isLineEdge()) {
    if (!de.isVisited() && OverlayOp.isResultOfOp(label, opCode) && !e3.isCovered()) {
      edges.add(e3);
      de.setVisitedEdge(true);
    }
  }
};
LineBuilder.prototype.findCoveredLineEdges = function findCoveredLineEdges() {
  var this$1$1 = this;
  for (var nodeit = this._op.getGraph().getNodes().iterator(); nodeit.hasNext(); ) {
    var node = nodeit.next();
    node.getEdges().findCoveredLineEdges();
  }
  for (var it = this._op.getGraph().getEdgeEnds().iterator(); it.hasNext(); ) {
    var de = it.next();
    var e3 = de.getEdge();
    if (de.isLineEdge() && !e3.isCoveredSet()) {
      var isCovered2 = this$1$1._op.isCoveredByA(de.getCoordinate());
      e3.setCovered(isCovered2);
    }
  }
};
LineBuilder.prototype.labelIsolatedLines = function labelIsolatedLines(edgesList) {
  var this$1$1 = this;
  for (var it = edgesList.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    var label = e3.getLabel();
    if (e3.isIsolated()) {
      if (label.isNull(0)) {
        this$1$1.labelIsolatedLine(e3, 0);
      } else {
        this$1$1.labelIsolatedLine(e3, 1);
      }
    }
  }
};
LineBuilder.prototype.buildLines = function buildLines(opCode) {
  var this$1$1 = this;
  for (var it = this._lineEdgesList.iterator(); it.hasNext(); ) {
    var e3 = it.next();
    var line = this$1$1._geometryFactory.createLineString(e3.getCoordinates());
    this$1$1._resultLineList.add(line);
    e3.setInResult(true);
  }
};
LineBuilder.prototype.collectBoundaryTouchEdge = function collectBoundaryTouchEdge(de, opCode, edges) {
  var label = de.getLabel();
  if (de.isLineEdge()) {
    return null;
  }
  if (de.isVisited()) {
    return null;
  }
  if (de.isInteriorAreaEdge()) {
    return null;
  }
  if (de.getEdge().isInResult()) {
    return null;
  }
  Assert.isTrue(!(de.isInResult() || de.getSym().isInResult()) || !de.getEdge().isInResult());
  if (OverlayOp.isResultOfOp(label, opCode) && opCode === OverlayOp.INTERSECTION) {
    edges.add(de.getEdge());
    de.setVisitedEdge(true);
  }
};
LineBuilder.prototype.interfaces_ = function interfaces_139() {
  return [];
};
LineBuilder.prototype.getClass = function getClass138() {
  return LineBuilder;
};
var PointBuilder = function PointBuilder2() {
  this._op = null;
  this._geometryFactory = null;
  this._resultPointList = new ArrayList();
  var op = arguments[0];
  var geometryFactory = arguments[1];
  this._op = op;
  this._geometryFactory = geometryFactory;
};
PointBuilder.prototype.filterCoveredNodeToPoint = function filterCoveredNodeToPoint(n2) {
  var coord = n2.getCoordinate();
  if (!this._op.isCoveredByLA(coord)) {
    var pt = this._geometryFactory.createPoint(coord);
    this._resultPointList.add(pt);
  }
};
PointBuilder.prototype.extractNonCoveredResultNodes = function extractNonCoveredResultNodes(opCode) {
  var this$1$1 = this;
  for (var nodeit = this._op.getGraph().getNodes().iterator(); nodeit.hasNext(); ) {
    var n2 = nodeit.next();
    if (n2.isInResult()) {
      continue;
    }
    if (n2.isIncidentEdgeInResult()) {
      continue;
    }
    if (n2.getEdges().getDegree() === 0 || opCode === OverlayOp.INTERSECTION) {
      var label = n2.getLabel();
      if (OverlayOp.isResultOfOp(label, opCode)) {
        this$1$1.filterCoveredNodeToPoint(n2);
      }
    }
  }
};
PointBuilder.prototype.build = function build4(opCode) {
  this.extractNonCoveredResultNodes(opCode);
  return this._resultPointList;
};
PointBuilder.prototype.interfaces_ = function interfaces_140() {
  return [];
};
PointBuilder.prototype.getClass = function getClass139() {
  return PointBuilder;
};
var GeometryTransformer = function GeometryTransformer2() {
  this._inputGeom = null;
  this._factory = null;
  this._pruneEmptyGeometry = true;
  this._preserveGeometryCollectionType = true;
  this._preserveCollections = false;
  this._preserveType = false;
};
GeometryTransformer.prototype.transformPoint = function transformPoint(geom, parent) {
  return this._factory.createPoint(this.transformCoordinates(geom.getCoordinateSequence(), geom));
};
GeometryTransformer.prototype.transformPolygon = function transformPolygon(geom, parent) {
  var this$1$1 = this;
  var isAllValidLinearRings = true;
  var shell = this.transformLinearRing(geom.getExteriorRing(), geom);
  if (shell === null || !(shell instanceof LinearRing) || shell.isEmpty()) {
    isAllValidLinearRings = false;
  }
  var holes = new ArrayList();
  for (var i2 = 0; i2 < geom.getNumInteriorRing(); i2++) {
    var hole = this$1$1.transformLinearRing(geom.getInteriorRingN(i2), geom);
    if (hole === null || hole.isEmpty()) {
      continue;
    }
    if (!(hole instanceof LinearRing)) {
      isAllValidLinearRings = false;
    }
    holes.add(hole);
  }
  if (isAllValidLinearRings) {
    return this._factory.createPolygon(shell, holes.toArray([]));
  } else {
    var components = new ArrayList();
    if (shell !== null) {
      components.add(shell);
    }
    components.addAll(holes);
    return this._factory.buildGeometry(components);
  }
};
GeometryTransformer.prototype.createCoordinateSequence = function createCoordinateSequence(coords) {
  return this._factory.getCoordinateSequenceFactory().create(coords);
};
GeometryTransformer.prototype.getInputGeometry = function getInputGeometry() {
  return this._inputGeom;
};
GeometryTransformer.prototype.transformMultiLineString = function transformMultiLineString(geom, parent) {
  var this$1$1 = this;
  var transGeomList = new ArrayList();
  for (var i2 = 0; i2 < geom.getNumGeometries(); i2++) {
    var transformGeom = this$1$1.transformLineString(geom.getGeometryN(i2), geom);
    if (transformGeom === null) {
      continue;
    }
    if (transformGeom.isEmpty()) {
      continue;
    }
    transGeomList.add(transformGeom);
  }
  return this._factory.buildGeometry(transGeomList);
};
GeometryTransformer.prototype.transformCoordinates = function transformCoordinates(coords, parent) {
  return this.copy(coords);
};
GeometryTransformer.prototype.transformLineString = function transformLineString(geom, parent) {
  return this._factory.createLineString(this.transformCoordinates(geom.getCoordinateSequence(), geom));
};
GeometryTransformer.prototype.transformMultiPoint = function transformMultiPoint(geom, parent) {
  var this$1$1 = this;
  var transGeomList = new ArrayList();
  for (var i2 = 0; i2 < geom.getNumGeometries(); i2++) {
    var transformGeom = this$1$1.transformPoint(geom.getGeometryN(i2), geom);
    if (transformGeom === null) {
      continue;
    }
    if (transformGeom.isEmpty()) {
      continue;
    }
    transGeomList.add(transformGeom);
  }
  return this._factory.buildGeometry(transGeomList);
};
GeometryTransformer.prototype.transformMultiPolygon = function transformMultiPolygon(geom, parent) {
  var this$1$1 = this;
  var transGeomList = new ArrayList();
  for (var i2 = 0; i2 < geom.getNumGeometries(); i2++) {
    var transformGeom = this$1$1.transformPolygon(geom.getGeometryN(i2), geom);
    if (transformGeom === null) {
      continue;
    }
    if (transformGeom.isEmpty()) {
      continue;
    }
    transGeomList.add(transformGeom);
  }
  return this._factory.buildGeometry(transGeomList);
};
GeometryTransformer.prototype.copy = function copy7(seq) {
  return seq.copy();
};
GeometryTransformer.prototype.transformGeometryCollection = function transformGeometryCollection(geom, parent) {
  var this$1$1 = this;
  var transGeomList = new ArrayList();
  for (var i2 = 0; i2 < geom.getNumGeometries(); i2++) {
    var transformGeom = this$1$1.transform(geom.getGeometryN(i2));
    if (transformGeom === null) {
      continue;
    }
    if (this$1$1._pruneEmptyGeometry && transformGeom.isEmpty()) {
      continue;
    }
    transGeomList.add(transformGeom);
  }
  if (this._preserveGeometryCollectionType) {
    return this._factory.createGeometryCollection(GeometryFactory.toGeometryArray(transGeomList));
  }
  return this._factory.buildGeometry(transGeomList);
};
GeometryTransformer.prototype.transform = function transform2(inputGeom) {
  this._inputGeom = inputGeom;
  this._factory = inputGeom.getFactory();
  if (inputGeom instanceof Point$7) {
    return this.transformPoint(inputGeom, null);
  }
  if (inputGeom instanceof MultiPoint$1) {
    return this.transformMultiPoint(inputGeom, null);
  }
  if (inputGeom instanceof LinearRing) {
    return this.transformLinearRing(inputGeom, null);
  }
  if (inputGeom instanceof LineString$4) {
    return this.transformLineString(inputGeom, null);
  }
  if (inputGeom instanceof MultiLineString$1) {
    return this.transformMultiLineString(inputGeom, null);
  }
  if (inputGeom instanceof Polygon$5) {
    return this.transformPolygon(inputGeom, null);
  }
  if (inputGeom instanceof MultiPolygon$1) {
    return this.transformMultiPolygon(inputGeom, null);
  }
  if (inputGeom instanceof GeometryCollection) {
    return this.transformGeometryCollection(inputGeom, null);
  }
  throw new IllegalArgumentException("Unknown Geometry subtype: " + inputGeom.getClass().getName());
};
GeometryTransformer.prototype.transformLinearRing = function transformLinearRing(geom, parent) {
  var seq = this.transformCoordinates(geom.getCoordinateSequence(), geom);
  if (seq === null) {
    return this._factory.createLinearRing(null);
  }
  var seqSize = seq.size();
  if (seqSize > 0 && seqSize < 4 && !this._preserveType) {
    return this._factory.createLineString(seq);
  }
  return this._factory.createLinearRing(seq);
};
GeometryTransformer.prototype.interfaces_ = function interfaces_141() {
  return [];
};
GeometryTransformer.prototype.getClass = function getClass140() {
  return GeometryTransformer;
};
var LineStringSnapper = function LineStringSnapper2() {
  this._snapTolerance = 0;
  this._srcPts = null;
  this._seg = new LineSegment();
  this._allowSnappingToSourceVertices = false;
  this._isClosed = false;
  if (arguments[0] instanceof LineString$4 && typeof arguments[1] === "number") {
    var srcLine = arguments[0];
    var snapTolerance = arguments[1];
    LineStringSnapper2.call(this, srcLine.getCoordinates(), snapTolerance);
  } else if (arguments[0] instanceof Array && typeof arguments[1] === "number") {
    var srcPts = arguments[0];
    var snapTolerance$1 = arguments[1];
    this._srcPts = srcPts;
    this._isClosed = LineStringSnapper2.isClosed(srcPts);
    this._snapTolerance = snapTolerance$1;
  }
};
LineStringSnapper.prototype.snapVertices = function snapVertices(srcCoords, snapPts) {
  var this$1$1 = this;
  var end = this._isClosed ? srcCoords.size() - 1 : srcCoords.size();
  for (var i2 = 0; i2 < end; i2++) {
    var srcPt = srcCoords.get(i2);
    var snapVert = this$1$1.findSnapForVertex(srcPt, snapPts);
    if (snapVert !== null) {
      srcCoords.set(i2, new Coordinate(snapVert));
      if (i2 === 0 && this$1$1._isClosed) {
        srcCoords.set(srcCoords.size() - 1, new Coordinate(snapVert));
      }
    }
  }
};
LineStringSnapper.prototype.findSnapForVertex = function findSnapForVertex(pt, snapPts) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < snapPts.length; i2++) {
    if (pt.equals2D(snapPts[i2])) {
      return null;
    }
    if (pt.distance(snapPts[i2]) < this$1$1._snapTolerance) {
      return snapPts[i2];
    }
  }
  return null;
};
LineStringSnapper.prototype.snapTo = function snapTo(snapPts) {
  var coordList = new CoordinateList(this._srcPts);
  this.snapVertices(coordList, snapPts);
  this.snapSegments(coordList, snapPts);
  var newPts = coordList.toCoordinateArray();
  return newPts;
};
LineStringSnapper.prototype.snapSegments = function snapSegments(srcCoords, snapPts) {
  var this$1$1 = this;
  if (snapPts.length === 0) {
    return null;
  }
  var distinctPtCount = snapPts.length;
  if (snapPts[0].equals2D(snapPts[snapPts.length - 1])) {
    distinctPtCount = snapPts.length - 1;
  }
  for (var i2 = 0; i2 < distinctPtCount; i2++) {
    var snapPt = snapPts[i2];
    var index2 = this$1$1.findSegmentIndexToSnap(snapPt, srcCoords);
    if (index2 >= 0) {
      srcCoords.add(index2 + 1, new Coordinate(snapPt), false);
    }
  }
};
LineStringSnapper.prototype.findSegmentIndexToSnap = function findSegmentIndexToSnap(snapPt, srcCoords) {
  var this$1$1 = this;
  var minDist = Double.MAX_VALUE;
  var snapIndex = -1;
  for (var i2 = 0; i2 < srcCoords.size() - 1; i2++) {
    this$1$1._seg.p0 = srcCoords.get(i2);
    this$1$1._seg.p1 = srcCoords.get(i2 + 1);
    if (this$1$1._seg.p0.equals2D(snapPt) || this$1$1._seg.p1.equals2D(snapPt)) {
      if (this$1$1._allowSnappingToSourceVertices) {
        continue;
      } else {
        return -1;
      }
    }
    var dist2 = this$1$1._seg.distance(snapPt);
    if (dist2 < this$1$1._snapTolerance && dist2 < minDist) {
      minDist = dist2;
      snapIndex = i2;
    }
  }
  return snapIndex;
};
LineStringSnapper.prototype.setAllowSnappingToSourceVertices = function setAllowSnappingToSourceVertices(allowSnappingToSourceVertices) {
  this._allowSnappingToSourceVertices = allowSnappingToSourceVertices;
};
LineStringSnapper.prototype.interfaces_ = function interfaces_142() {
  return [];
};
LineStringSnapper.prototype.getClass = function getClass141() {
  return LineStringSnapper;
};
LineStringSnapper.isClosed = function isClosed4(pts) {
  if (pts.length <= 1) {
    return false;
  }
  return pts[0].equals2D(pts[pts.length - 1]);
};
var GeometrySnapper = function GeometrySnapper2(srcGeom) {
  this._srcGeom = srcGeom || null;
};
var staticAccessors$41 = { SNAP_PRECISION_FACTOR: { configurable: true } };
GeometrySnapper.prototype.snapTo = function snapTo2(snapGeom, snapTolerance) {
  var snapPts = this.extractTargetCoordinates(snapGeom);
  var snapTrans = new SnapTransformer(snapTolerance, snapPts);
  return snapTrans.transform(this._srcGeom);
};
GeometrySnapper.prototype.snapToSelf = function snapToSelf(snapTolerance, cleanResult) {
  var snapPts = this.extractTargetCoordinates(this._srcGeom);
  var snapTrans = new SnapTransformer(snapTolerance, snapPts, true);
  var snappedGeom = snapTrans.transform(this._srcGeom);
  var result = snappedGeom;
  if (cleanResult && hasInterface(result, Polygonal)) {
    result = snappedGeom.buffer(0);
  }
  return result;
};
GeometrySnapper.prototype.computeSnapTolerance = function computeSnapTolerance(ringPts) {
  var minSegLen = this.computeMinimumSegmentLength(ringPts);
  var snapTol = minSegLen / 10;
  return snapTol;
};
GeometrySnapper.prototype.extractTargetCoordinates = function extractTargetCoordinates(g2) {
  var ptSet = new TreeSet();
  var pts = g2.getCoordinates();
  for (var i2 = 0; i2 < pts.length; i2++) {
    ptSet.add(pts[i2]);
  }
  return ptSet.toArray(new Array(0).fill(null));
};
GeometrySnapper.prototype.computeMinimumSegmentLength = function computeMinimumSegmentLength(pts) {
  var minSegLen = Double.MAX_VALUE;
  for (var i2 = 0; i2 < pts.length - 1; i2++) {
    var segLen = pts[i2].distance(pts[i2 + 1]);
    if (segLen < minSegLen) {
      minSegLen = segLen;
    }
  }
  return minSegLen;
};
GeometrySnapper.prototype.interfaces_ = function interfaces_143() {
  return [];
};
GeometrySnapper.prototype.getClass = function getClass142() {
  return GeometrySnapper;
};
GeometrySnapper.snap = function snap3(g0, g1, snapTolerance) {
  var snapGeom = new Array(2).fill(null);
  var snapper0 = new GeometrySnapper(g0);
  snapGeom[0] = snapper0.snapTo(g1, snapTolerance);
  var snapper1 = new GeometrySnapper(g1);
  snapGeom[1] = snapper1.snapTo(snapGeom[0], snapTolerance);
  return snapGeom;
};
GeometrySnapper.computeOverlaySnapTolerance = function computeOverlaySnapTolerance() {
  if (arguments.length === 1) {
    var g2 = arguments[0];
    var snapTolerance = GeometrySnapper.computeSizeBasedSnapTolerance(g2);
    var pm = g2.getPrecisionModel();
    if (pm.getType() === PrecisionModel.FIXED) {
      var fixedSnapTol = 1 / pm.getScale() * 2 / 1.415;
      if (fixedSnapTol > snapTolerance) {
        snapTolerance = fixedSnapTol;
      }
    }
    return snapTolerance;
  } else if (arguments.length === 2) {
    var g0 = arguments[0];
    var g1 = arguments[1];
    return Math.min(GeometrySnapper.computeOverlaySnapTolerance(g0), GeometrySnapper.computeOverlaySnapTolerance(g1));
  }
};
GeometrySnapper.computeSizeBasedSnapTolerance = function computeSizeBasedSnapTolerance(g2) {
  var env = g2.getEnvelopeInternal();
  var minDimension = Math.min(env.getHeight(), env.getWidth());
  var snapTol = minDimension * GeometrySnapper.SNAP_PRECISION_FACTOR;
  return snapTol;
};
GeometrySnapper.snapToSelf = function snapToSelf2(geom, snapTolerance, cleanResult) {
  var snapper0 = new GeometrySnapper(geom);
  return snapper0.snapToSelf(snapTolerance, cleanResult);
};
staticAccessors$41.SNAP_PRECISION_FACTOR.get = function() {
  return 1e-9;
};
Object.defineProperties(GeometrySnapper, staticAccessors$41);
var SnapTransformer = function(GeometryTransformer$$1) {
  function SnapTransformer2(snapTolerance, snapPts, isSelfSnap) {
    GeometryTransformer$$1.call(this);
    this._snapTolerance = snapTolerance || null;
    this._snapPts = snapPts || null;
    this._isSelfSnap = isSelfSnap !== void 0 ? isSelfSnap : false;
  }
  if (GeometryTransformer$$1)
    SnapTransformer2.__proto__ = GeometryTransformer$$1;
  SnapTransformer2.prototype = Object.create(GeometryTransformer$$1 && GeometryTransformer$$1.prototype);
  SnapTransformer2.prototype.constructor = SnapTransformer2;
  SnapTransformer2.prototype.snapLine = function snapLine(srcPts, snapPts) {
    var snapper = new LineStringSnapper(srcPts, this._snapTolerance);
    snapper.setAllowSnappingToSourceVertices(this._isSelfSnap);
    return snapper.snapTo(snapPts);
  };
  SnapTransformer2.prototype.transformCoordinates = function transformCoordinates2(coords, parent) {
    var srcPts = coords.toCoordinateArray();
    var newPts = this.snapLine(srcPts, this._snapPts);
    return this._factory.getCoordinateSequenceFactory().create(newPts);
  };
  SnapTransformer2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  SnapTransformer2.prototype.getClass = function getClass169() {
    return SnapTransformer2;
  };
  return SnapTransformer2;
}(GeometryTransformer);
var CommonBits = function CommonBits2() {
  this._isFirst = true;
  this._commonMantissaBitsCount = 53;
  this._commonBits = 0;
  this._commonSignExp = null;
};
CommonBits.prototype.getCommon = function getCommon() {
  return Double.longBitsToDouble(this._commonBits);
};
CommonBits.prototype.add = function add14(num) {
  var numBits = Double.doubleToLongBits(num);
  if (this._isFirst) {
    this._commonBits = numBits;
    this._commonSignExp = CommonBits.signExpBits(this._commonBits);
    this._isFirst = false;
    return null;
  }
  var numSignExp = CommonBits.signExpBits(numBits);
  if (numSignExp !== this._commonSignExp) {
    this._commonBits = 0;
    return null;
  }
  this._commonMantissaBitsCount = CommonBits.numCommonMostSigMantissaBits(this._commonBits, numBits);
  this._commonBits = CommonBits.zeroLowerBits(this._commonBits, 64 - (12 + this._commonMantissaBitsCount));
};
CommonBits.prototype.toString = function toString24() {
  if (arguments.length === 1) {
    var bits = arguments[0];
    var x2 = Double.longBitsToDouble(bits);
    var numStr = Double.toBinaryString(bits);
    var padStr = "0000000000000000000000000000000000000000000000000000000000000000" + numStr;
    var bitStr = padStr.substring(padStr.length - 64);
    var str = bitStr.substring(0, 1) + "  " + bitStr.substring(1, 12) + "(exp) " + bitStr.substring(12) + " [ " + x2 + " ]";
    return str;
  }
};
CommonBits.prototype.interfaces_ = function interfaces_144() {
  return [];
};
CommonBits.prototype.getClass = function getClass143() {
  return CommonBits;
};
CommonBits.getBit = function getBit(bits, i2) {
  var mask = 1 << i2;
  return (bits & mask) !== 0 ? 1 : 0;
};
CommonBits.signExpBits = function signExpBits(num) {
  return num >> 52;
};
CommonBits.zeroLowerBits = function zeroLowerBits(bits, nBits) {
  var invMask = (1 << nBits) - 1;
  var mask = ~invMask;
  var zeroed = bits & mask;
  return zeroed;
};
CommonBits.numCommonMostSigMantissaBits = function numCommonMostSigMantissaBits(num1, num2) {
  var count3 = 0;
  for (var i2 = 52; i2 >= 0; i2--) {
    if (CommonBits.getBit(num1, i2) !== CommonBits.getBit(num2, i2)) {
      return count3;
    }
    count3++;
  }
  return 52;
};
var CommonBitsRemover = function CommonBitsRemover2() {
  this._commonCoord = null;
  this._ccFilter = new CommonCoordinateFilter();
};
var staticAccessors$42 = { CommonCoordinateFilter: { configurable: true }, Translater: { configurable: true } };
CommonBitsRemover.prototype.addCommonBits = function addCommonBits(geom) {
  var trans = new Translater(this._commonCoord);
  geom.apply(trans);
  geom.geometryChanged();
};
CommonBitsRemover.prototype.removeCommonBits = function removeCommonBits(geom) {
  if (this._commonCoord.x === 0 && this._commonCoord.y === 0) {
    return geom;
  }
  var invCoord = new Coordinate(this._commonCoord);
  invCoord.x = -invCoord.x;
  invCoord.y = -invCoord.y;
  var trans = new Translater(invCoord);
  geom.apply(trans);
  geom.geometryChanged();
  return geom;
};
CommonBitsRemover.prototype.getCommonCoordinate = function getCommonCoordinate() {
  return this._commonCoord;
};
CommonBitsRemover.prototype.add = function add15(geom) {
  geom.apply(this._ccFilter);
  this._commonCoord = this._ccFilter.getCommonCoordinate();
};
CommonBitsRemover.prototype.interfaces_ = function interfaces_145() {
  return [];
};
CommonBitsRemover.prototype.getClass = function getClass144() {
  return CommonBitsRemover;
};
staticAccessors$42.CommonCoordinateFilter.get = function() {
  return CommonCoordinateFilter;
};
staticAccessors$42.Translater.get = function() {
  return Translater;
};
Object.defineProperties(CommonBitsRemover, staticAccessors$42);
var CommonCoordinateFilter = function CommonCoordinateFilter2() {
  this._commonBitsX = new CommonBits();
  this._commonBitsY = new CommonBits();
};
CommonCoordinateFilter.prototype.filter = function filter14(coord) {
  this._commonBitsX.add(coord.x);
  this._commonBitsY.add(coord.y);
};
CommonCoordinateFilter.prototype.getCommonCoordinate = function getCommonCoordinate2() {
  return new Coordinate(this._commonBitsX.getCommon(), this._commonBitsY.getCommon());
};
CommonCoordinateFilter.prototype.interfaces_ = function interfaces_146() {
  return [CoordinateFilter];
};
CommonCoordinateFilter.prototype.getClass = function getClass145() {
  return CommonCoordinateFilter;
};
var Translater = function Translater2() {
  this.trans = null;
  var trans = arguments[0];
  this.trans = trans;
};
Translater.prototype.filter = function filter15(seq, i2) {
  var xp = seq.getOrdinate(i2, 0) + this.trans.x;
  var yp = seq.getOrdinate(i2, 1) + this.trans.y;
  seq.setOrdinate(i2, 0, xp);
  seq.setOrdinate(i2, 1, yp);
};
Translater.prototype.isDone = function isDone8() {
  return false;
};
Translater.prototype.isGeometryChanged = function isGeometryChanged4() {
  return true;
};
Translater.prototype.interfaces_ = function interfaces_147() {
  return [CoordinateSequenceFilter];
};
Translater.prototype.getClass = function getClass146() {
  return Translater;
};
var SnapOverlayOp = function SnapOverlayOp2(g1, g2) {
  this._geom = new Array(2).fill(null);
  this._snapTolerance = null;
  this._cbr = null;
  this._geom[0] = g1;
  this._geom[1] = g2;
  this.computeSnapTolerance();
};
SnapOverlayOp.prototype.selfSnap = function selfSnap(geom) {
  var snapper0 = new GeometrySnapper(geom);
  var snapGeom = snapper0.snapTo(geom, this._snapTolerance);
  return snapGeom;
};
SnapOverlayOp.prototype.removeCommonBits = function removeCommonBits2(geom) {
  this._cbr = new CommonBitsRemover();
  this._cbr.add(geom[0]);
  this._cbr.add(geom[1]);
  var remGeom = new Array(2).fill(null);
  remGeom[0] = this._cbr.removeCommonBits(geom[0].copy());
  remGeom[1] = this._cbr.removeCommonBits(geom[1].copy());
  return remGeom;
};
SnapOverlayOp.prototype.prepareResult = function prepareResult(geom) {
  this._cbr.addCommonBits(geom);
  return geom;
};
SnapOverlayOp.prototype.getResultGeometry = function getResultGeometry2(opCode) {
  var prepGeom = this.snap(this._geom);
  var result = OverlayOp.overlayOp(prepGeom[0], prepGeom[1], opCode);
  return this.prepareResult(result);
};
SnapOverlayOp.prototype.checkValid = function checkValid5(g2) {
  if (!g2.isValid()) {
    System.out.println("Snapped geometry is invalid");
  }
};
SnapOverlayOp.prototype.computeSnapTolerance = function computeSnapTolerance2() {
  this._snapTolerance = GeometrySnapper.computeOverlaySnapTolerance(this._geom[0], this._geom[1]);
};
SnapOverlayOp.prototype.snap = function snap4(geom) {
  var remGeom = this.removeCommonBits(geom);
  var snapGeom = GeometrySnapper.snap(remGeom[0], remGeom[1], this._snapTolerance);
  return snapGeom;
};
SnapOverlayOp.prototype.interfaces_ = function interfaces_148() {
  return [];
};
SnapOverlayOp.prototype.getClass = function getClass147() {
  return SnapOverlayOp;
};
SnapOverlayOp.overlayOp = function overlayOp(g0, g1, opCode) {
  var op = new SnapOverlayOp(g0, g1);
  return op.getResultGeometry(opCode);
};
SnapOverlayOp.union = function union(g0, g1) {
  return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.UNION);
};
SnapOverlayOp.intersection = function intersection6(g0, g1) {
  return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.INTERSECTION);
};
SnapOverlayOp.symDifference = function symDifference(g0, g1) {
  return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.SYMDIFFERENCE);
};
SnapOverlayOp.difference = function difference(g0, g1) {
  return SnapOverlayOp.overlayOp(g0, g1, OverlayOp.DIFFERENCE);
};
var SnapIfNeededOverlayOp = function SnapIfNeededOverlayOp2(g1, g2) {
  this._geom = new Array(2).fill(null);
  this._geom[0] = g1;
  this._geom[1] = g2;
};
SnapIfNeededOverlayOp.prototype.getResultGeometry = function getResultGeometry3(opCode) {
  var result = null;
  var isSuccess = false;
  var savedException = null;
  try {
    result = OverlayOp.overlayOp(this._geom[0], this._geom[1], opCode);
    var isValid8 = true;
    if (isValid8) {
      isSuccess = true;
    }
  } catch (ex) {
    if (ex instanceof RuntimeException) {
      savedException = ex;
    } else {
      throw ex;
    }
  } finally {
  }
  if (!isSuccess) {
    try {
      result = SnapOverlayOp.overlayOp(this._geom[0], this._geom[1], opCode);
    } catch (ex) {
      if (ex instanceof RuntimeException) {
        throw savedException;
      } else {
        throw ex;
      }
    } finally {
    }
  }
  return result;
};
SnapIfNeededOverlayOp.prototype.interfaces_ = function interfaces_149() {
  return [];
};
SnapIfNeededOverlayOp.prototype.getClass = function getClass148() {
  return SnapIfNeededOverlayOp;
};
SnapIfNeededOverlayOp.overlayOp = function overlayOp2(g0, g1, opCode) {
  var op = new SnapIfNeededOverlayOp(g0, g1);
  return op.getResultGeometry(opCode);
};
SnapIfNeededOverlayOp.union = function union2(g0, g1) {
  return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.UNION);
};
SnapIfNeededOverlayOp.intersection = function intersection7(g0, g1) {
  return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.INTERSECTION);
};
SnapIfNeededOverlayOp.symDifference = function symDifference2(g0, g1) {
  return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.SYMDIFFERENCE);
};
SnapIfNeededOverlayOp.difference = function difference2(g0, g1) {
  return SnapIfNeededOverlayOp.overlayOp(g0, g1, OverlayOp.DIFFERENCE);
};
var MonotoneChain$2 = function MonotoneChain3() {
  this.mce = null;
  this.chainIndex = null;
  var mce = arguments[0];
  var chainIndex = arguments[1];
  this.mce = mce;
  this.chainIndex = chainIndex;
};
MonotoneChain$2.prototype.computeIntersections = function computeIntersections2(mc, si) {
  this.mce.computeIntersectsForChain(this.chainIndex, mc.mce, mc.chainIndex, si);
};
MonotoneChain$2.prototype.interfaces_ = function interfaces_150() {
  return [];
};
MonotoneChain$2.prototype.getClass = function getClass149() {
  return MonotoneChain$2;
};
var SweepLineEvent = function SweepLineEvent2() {
  this._label = null;
  this._xValue = null;
  this._eventType = null;
  this._insertEvent = null;
  this._deleteEventIndex = null;
  this._obj = null;
  if (arguments.length === 2) {
    var x2 = arguments[0];
    var insertEvent = arguments[1];
    this._eventType = SweepLineEvent2.DELETE;
    this._xValue = x2;
    this._insertEvent = insertEvent;
  } else if (arguments.length === 3) {
    var label = arguments[0];
    var x$12 = arguments[1];
    var obj = arguments[2];
    this._eventType = SweepLineEvent2.INSERT;
    this._label = label;
    this._xValue = x$12;
    this._obj = obj;
  }
};
var staticAccessors$43 = { INSERT: { configurable: true }, DELETE: { configurable: true } };
SweepLineEvent.prototype.isDelete = function isDelete() {
  return this._eventType === SweepLineEvent.DELETE;
};
SweepLineEvent.prototype.setDeleteEventIndex = function setDeleteEventIndex(deleteEventIndex) {
  this._deleteEventIndex = deleteEventIndex;
};
SweepLineEvent.prototype.getObject = function getObject() {
  return this._obj;
};
SweepLineEvent.prototype.compareTo = function compareTo15(o2) {
  var pe = o2;
  if (this._xValue < pe._xValue) {
    return -1;
  }
  if (this._xValue > pe._xValue) {
    return 1;
  }
  if (this._eventType < pe._eventType) {
    return -1;
  }
  if (this._eventType > pe._eventType) {
    return 1;
  }
  return 0;
};
SweepLineEvent.prototype.getInsertEvent = function getInsertEvent() {
  return this._insertEvent;
};
SweepLineEvent.prototype.isInsert = function isInsert() {
  return this._eventType === SweepLineEvent.INSERT;
};
SweepLineEvent.prototype.isSameLabel = function isSameLabel(ev) {
  if (this._label === null) {
    return false;
  }
  return this._label === ev._label;
};
SweepLineEvent.prototype.getDeleteEventIndex = function getDeleteEventIndex() {
  return this._deleteEventIndex;
};
SweepLineEvent.prototype.interfaces_ = function interfaces_151() {
  return [Comparable];
};
SweepLineEvent.prototype.getClass = function getClass150() {
  return SweepLineEvent;
};
staticAccessors$43.INSERT.get = function() {
  return 1;
};
staticAccessors$43.DELETE.get = function() {
  return 2;
};
Object.defineProperties(SweepLineEvent, staticAccessors$43);
var EdgeSetIntersector = function EdgeSetIntersector2() {
};
EdgeSetIntersector.prototype.interfaces_ = function interfaces_152() {
  return [];
};
EdgeSetIntersector.prototype.getClass = function getClass151() {
  return EdgeSetIntersector;
};
var SegmentIntersector$2 = function SegmentIntersector3() {
  this._hasIntersection = false;
  this._hasProper = false;
  this._hasProperInterior = false;
  this._properIntersectionPoint = null;
  this._li = null;
  this._includeProper = null;
  this._recordIsolated = null;
  this._isSelfIntersection = null;
  this._numIntersections = 0;
  this.numTests = 0;
  this._bdyNodes = null;
  this._isDone = false;
  this._isDoneWhenProperInt = false;
  var li = arguments[0];
  var includeProper = arguments[1];
  var recordIsolated = arguments[2];
  this._li = li;
  this._includeProper = includeProper;
  this._recordIsolated = recordIsolated;
};
SegmentIntersector$2.prototype.isTrivialIntersection = function isTrivialIntersection2(e0, segIndex0, e1, segIndex1) {
  if (e0 === e1) {
    if (this._li.getIntersectionNum() === 1) {
      if (SegmentIntersector$2.isAdjacentSegments(segIndex0, segIndex1)) {
        return true;
      }
      if (e0.isClosed()) {
        var maxSegIndex = e0.getNumPoints() - 1;
        if (segIndex0 === 0 && segIndex1 === maxSegIndex || segIndex1 === 0 && segIndex0 === maxSegIndex) {
          return true;
        }
      }
    }
  }
  return false;
};
SegmentIntersector$2.prototype.getProperIntersectionPoint = function getProperIntersectionPoint2() {
  return this._properIntersectionPoint;
};
SegmentIntersector$2.prototype.setIsDoneIfProperInt = function setIsDoneIfProperInt(isDoneWhenProperInt) {
  this._isDoneWhenProperInt = isDoneWhenProperInt;
};
SegmentIntersector$2.prototype.hasProperInteriorIntersection = function hasProperInteriorIntersection2() {
  return this._hasProperInterior;
};
SegmentIntersector$2.prototype.isBoundaryPointInternal = function isBoundaryPointInternal(li, bdyNodes) {
  for (var i2 = bdyNodes.iterator(); i2.hasNext(); ) {
    var node = i2.next();
    var pt = node.getCoordinate();
    if (li.isIntersection(pt)) {
      return true;
    }
  }
  return false;
};
SegmentIntersector$2.prototype.hasProperIntersection = function hasProperIntersection2() {
  return this._hasProper;
};
SegmentIntersector$2.prototype.hasIntersection = function hasIntersection4() {
  return this._hasIntersection;
};
SegmentIntersector$2.prototype.isDone = function isDone9() {
  return this._isDone;
};
SegmentIntersector$2.prototype.isBoundaryPoint = function isBoundaryPoint(li, bdyNodes) {
  if (bdyNodes === null) {
    return false;
  }
  if (this.isBoundaryPointInternal(li, bdyNodes[0])) {
    return true;
  }
  if (this.isBoundaryPointInternal(li, bdyNodes[1])) {
    return true;
  }
  return false;
};
SegmentIntersector$2.prototype.setBoundaryNodes = function setBoundaryNodes(bdyNodes0, bdyNodes1) {
  this._bdyNodes = new Array(2).fill(null);
  this._bdyNodes[0] = bdyNodes0;
  this._bdyNodes[1] = bdyNodes1;
};
SegmentIntersector$2.prototype.addIntersections = function addIntersections2(e0, segIndex0, e1, segIndex1) {
  if (e0 === e1 && segIndex0 === segIndex1) {
    return null;
  }
  this.numTests++;
  var p00 = e0.getCoordinates()[segIndex0];
  var p01 = e0.getCoordinates()[segIndex0 + 1];
  var p10 = e1.getCoordinates()[segIndex1];
  var p11 = e1.getCoordinates()[segIndex1 + 1];
  this._li.computeIntersection(p00, p01, p10, p11);
  if (this._li.hasIntersection()) {
    if (this._recordIsolated) {
      e0.setIsolated(false);
      e1.setIsolated(false);
    }
    this._numIntersections++;
    if (!this.isTrivialIntersection(e0, segIndex0, e1, segIndex1)) {
      this._hasIntersection = true;
      if (this._includeProper || !this._li.isProper()) {
        e0.addIntersections(this._li, segIndex0, 0);
        e1.addIntersections(this._li, segIndex1, 1);
      }
      if (this._li.isProper()) {
        this._properIntersectionPoint = this._li.getIntersection(0).copy();
        this._hasProper = true;
        if (this._isDoneWhenProperInt) {
          this._isDone = true;
        }
        if (!this.isBoundaryPoint(this._li, this._bdyNodes)) {
          this._hasProperInterior = true;
        }
      }
    }
  }
};
SegmentIntersector$2.prototype.interfaces_ = function interfaces_153() {
  return [];
};
SegmentIntersector$2.prototype.getClass = function getClass152() {
  return SegmentIntersector$2;
};
SegmentIntersector$2.isAdjacentSegments = function isAdjacentSegments2(i1, i2) {
  return Math.abs(i1 - i2) === 1;
};
var SimpleMCSweepLineIntersector = function(EdgeSetIntersector$$1) {
  function SimpleMCSweepLineIntersector2() {
    EdgeSetIntersector$$1.call(this);
    this.events = new ArrayList();
    this.nOverlaps = null;
  }
  if (EdgeSetIntersector$$1)
    SimpleMCSweepLineIntersector2.__proto__ = EdgeSetIntersector$$1;
  SimpleMCSweepLineIntersector2.prototype = Object.create(EdgeSetIntersector$$1 && EdgeSetIntersector$$1.prototype);
  SimpleMCSweepLineIntersector2.prototype.constructor = SimpleMCSweepLineIntersector2;
  SimpleMCSweepLineIntersector2.prototype.prepareEvents = function prepareEvents() {
    var this$1$1 = this;
    Collections.sort(this.events);
    for (var i2 = 0; i2 < this.events.size(); i2++) {
      var ev = this$1$1.events.get(i2);
      if (ev.isDelete()) {
        ev.getInsertEvent().setDeleteEventIndex(i2);
      }
    }
  };
  SimpleMCSweepLineIntersector2.prototype.computeIntersections = function computeIntersections3() {
    var this$1$1 = this;
    if (arguments.length === 1) {
      var si = arguments[0];
      this.nOverlaps = 0;
      this.prepareEvents();
      for (var i2 = 0; i2 < this.events.size(); i2++) {
        var ev = this$1$1.events.get(i2);
        if (ev.isInsert()) {
          this$1$1.processOverlaps(i2, ev.getDeleteEventIndex(), ev, si);
        }
        if (si.isDone()) {
          break;
        }
      }
    } else if (arguments.length === 3) {
      if (arguments[2] instanceof SegmentIntersector$2 && (hasInterface(arguments[0], List$2) && hasInterface(arguments[1], List$2))) {
        var edges0 = arguments[0];
        var edges1 = arguments[1];
        var si$1 = arguments[2];
        this.addEdges(edges0, edges0);
        this.addEdges(edges1, edges1);
        this.computeIntersections(si$1);
      } else if (typeof arguments[2] === "boolean" && (hasInterface(arguments[0], List$2) && arguments[1] instanceof SegmentIntersector$2)) {
        var edges = arguments[0];
        var si$2 = arguments[1];
        var testAllSegments = arguments[2];
        if (testAllSegments) {
          this.addEdges(edges, null);
        } else {
          this.addEdges(edges);
        }
        this.computeIntersections(si$2);
      }
    }
  };
  SimpleMCSweepLineIntersector2.prototype.addEdge = function addEdge(edge, edgeSet) {
    var this$1$1 = this;
    var mce = edge.getMonotoneChainEdge();
    var startIndex = mce.getStartIndexes();
    for (var i2 = 0; i2 < startIndex.length - 1; i2++) {
      var mc = new MonotoneChain$2(mce, i2);
      var insertEvent = new SweepLineEvent(edgeSet, mce.getMinX(i2), mc);
      this$1$1.events.add(insertEvent);
      this$1$1.events.add(new SweepLineEvent(mce.getMaxX(i2), insertEvent));
    }
  };
  SimpleMCSweepLineIntersector2.prototype.processOverlaps = function processOverlaps(start2, end, ev0, si) {
    var this$1$1 = this;
    var mc0 = ev0.getObject();
    for (var i2 = start2; i2 < end; i2++) {
      var ev1 = this$1$1.events.get(i2);
      if (ev1.isInsert()) {
        var mc1 = ev1.getObject();
        if (!ev0.isSameLabel(ev1)) {
          mc0.computeIntersections(mc1, si);
          this$1$1.nOverlaps++;
        }
      }
    }
  };
  SimpleMCSweepLineIntersector2.prototype.addEdges = function addEdges2() {
    var this$1$1 = this;
    if (arguments.length === 1) {
      var edges = arguments[0];
      for (var i2 = edges.iterator(); i2.hasNext(); ) {
        var edge = i2.next();
        this$1$1.addEdge(edge, edge);
      }
    } else if (arguments.length === 2) {
      var edges$1 = arguments[0];
      var edgeSet = arguments[1];
      for (var i$12 = edges$1.iterator(); i$12.hasNext(); ) {
        var edge$1 = i$12.next();
        this$1$1.addEdge(edge$1, edgeSet);
      }
    }
  };
  SimpleMCSweepLineIntersector2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  SimpleMCSweepLineIntersector2.prototype.getClass = function getClass169() {
    return SimpleMCSweepLineIntersector2;
  };
  return SimpleMCSweepLineIntersector2;
}(EdgeSetIntersector);
var IntervalRTreeNode = function IntervalRTreeNode2() {
  this._min = Double.POSITIVE_INFINITY;
  this._max = Double.NEGATIVE_INFINITY;
};
var staticAccessors$45 = { NodeComparator: { configurable: true } };
IntervalRTreeNode.prototype.getMin = function getMin2() {
  return this._min;
};
IntervalRTreeNode.prototype.intersects = function intersects6(queryMin, queryMax) {
  if (this._min > queryMax || this._max < queryMin) {
    return false;
  }
  return true;
};
IntervalRTreeNode.prototype.getMax = function getMax2() {
  return this._max;
};
IntervalRTreeNode.prototype.toString = function toString25() {
  return WKTWriter.toLineString(new Coordinate(this._min, 0), new Coordinate(this._max, 0));
};
IntervalRTreeNode.prototype.interfaces_ = function interfaces_154() {
  return [];
};
IntervalRTreeNode.prototype.getClass = function getClass153() {
  return IntervalRTreeNode;
};
staticAccessors$45.NodeComparator.get = function() {
  return NodeComparator;
};
Object.defineProperties(IntervalRTreeNode, staticAccessors$45);
var NodeComparator = function NodeComparator2() {
};
NodeComparator.prototype.compare = function compare9(o1, o2) {
  var n1 = o1;
  var n2 = o2;
  var mid1 = (n1._min + n1._max) / 2;
  var mid2 = (n2._min + n2._max) / 2;
  if (mid1 < mid2) {
    return -1;
  }
  if (mid1 > mid2) {
    return 1;
  }
  return 0;
};
NodeComparator.prototype.interfaces_ = function interfaces_155() {
  return [Comparator];
};
NodeComparator.prototype.getClass = function getClass154() {
  return NodeComparator;
};
var IntervalRTreeLeafNode = function(IntervalRTreeNode$$1) {
  function IntervalRTreeLeafNode2() {
    IntervalRTreeNode$$1.call(this);
    this._item = null;
    var min4 = arguments[0];
    var max3 = arguments[1];
    var item = arguments[2];
    this._min = min4;
    this._max = max3;
    this._item = item;
  }
  if (IntervalRTreeNode$$1)
    IntervalRTreeLeafNode2.__proto__ = IntervalRTreeNode$$1;
  IntervalRTreeLeafNode2.prototype = Object.create(IntervalRTreeNode$$1 && IntervalRTreeNode$$1.prototype);
  IntervalRTreeLeafNode2.prototype.constructor = IntervalRTreeLeafNode2;
  IntervalRTreeLeafNode2.prototype.query = function query6(queryMin, queryMax, visitor) {
    if (!this.intersects(queryMin, queryMax)) {
      return null;
    }
    visitor.visitItem(this._item);
  };
  IntervalRTreeLeafNode2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  IntervalRTreeLeafNode2.prototype.getClass = function getClass169() {
    return IntervalRTreeLeafNode2;
  };
  return IntervalRTreeLeafNode2;
}(IntervalRTreeNode);
var IntervalRTreeBranchNode = function(IntervalRTreeNode$$1) {
  function IntervalRTreeBranchNode2() {
    IntervalRTreeNode$$1.call(this);
    this._node1 = null;
    this._node2 = null;
    var n1 = arguments[0];
    var n2 = arguments[1];
    this._node1 = n1;
    this._node2 = n2;
    this.buildExtent(this._node1, this._node2);
  }
  if (IntervalRTreeNode$$1)
    IntervalRTreeBranchNode2.__proto__ = IntervalRTreeNode$$1;
  IntervalRTreeBranchNode2.prototype = Object.create(IntervalRTreeNode$$1 && IntervalRTreeNode$$1.prototype);
  IntervalRTreeBranchNode2.prototype.constructor = IntervalRTreeBranchNode2;
  IntervalRTreeBranchNode2.prototype.buildExtent = function buildExtent(n1, n2) {
    this._min = Math.min(n1._min, n2._min);
    this._max = Math.max(n1._max, n2._max);
  };
  IntervalRTreeBranchNode2.prototype.query = function query6(queryMin, queryMax, visitor) {
    if (!this.intersects(queryMin, queryMax)) {
      return null;
    }
    if (this._node1 !== null) {
      this._node1.query(queryMin, queryMax, visitor);
    }
    if (this._node2 !== null) {
      this._node2.query(queryMin, queryMax, visitor);
    }
  };
  IntervalRTreeBranchNode2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  IntervalRTreeBranchNode2.prototype.getClass = function getClass169() {
    return IntervalRTreeBranchNode2;
  };
  return IntervalRTreeBranchNode2;
}(IntervalRTreeNode);
var SortedPackedIntervalRTree = function SortedPackedIntervalRTree2() {
  this._leaves = new ArrayList();
  this._root = null;
  this._level = 0;
};
SortedPackedIntervalRTree.prototype.buildTree = function buildTree() {
  var this$1$1 = this;
  Collections.sort(this._leaves, new IntervalRTreeNode.NodeComparator());
  var src2 = this._leaves;
  var temp2 = null;
  var dest = new ArrayList();
  while (true) {
    this$1$1.buildLevel(src2, dest);
    if (dest.size() === 1) {
      return dest.get(0);
    }
    temp2 = src2;
    src2 = dest;
    dest = temp2;
  }
};
SortedPackedIntervalRTree.prototype.insert = function insert3(min4, max3, item) {
  if (this._root !== null) {
    throw new Error("Index cannot be added to once it has been queried");
  }
  this._leaves.add(new IntervalRTreeLeafNode(min4, max3, item));
};
SortedPackedIntervalRTree.prototype.query = function query4(min4, max3, visitor) {
  this.init();
  this._root.query(min4, max3, visitor);
};
SortedPackedIntervalRTree.prototype.buildRoot = function buildRoot() {
  if (this._root !== null) {
    return null;
  }
  this._root = this.buildTree();
};
SortedPackedIntervalRTree.prototype.printNode = function printNode(node) {
  System.out.println(WKTWriter.toLineString(new Coordinate(node._min, this._level), new Coordinate(node._max, this._level)));
};
SortedPackedIntervalRTree.prototype.init = function init7() {
  if (this._root !== null) {
    return null;
  }
  this.buildRoot();
};
SortedPackedIntervalRTree.prototype.buildLevel = function buildLevel(src2, dest) {
  this._level++;
  dest.clear();
  for (var i2 = 0; i2 < src2.size(); i2 += 2) {
    var n1 = src2.get(i2);
    var n2 = i2 + 1 < src2.size() ? src2.get(i2) : null;
    if (n2 === null) {
      dest.add(n1);
    } else {
      var node = new IntervalRTreeBranchNode(src2.get(i2), src2.get(i2 + 1));
      dest.add(node);
    }
  }
};
SortedPackedIntervalRTree.prototype.interfaces_ = function interfaces_156() {
  return [];
};
SortedPackedIntervalRTree.prototype.getClass = function getClass155() {
  return SortedPackedIntervalRTree;
};
var ArrayListVisitor = function ArrayListVisitor2() {
  this._items = new ArrayList();
};
ArrayListVisitor.prototype.visitItem = function visitItem2(item) {
  this._items.add(item);
};
ArrayListVisitor.prototype.getItems = function getItems() {
  return this._items;
};
ArrayListVisitor.prototype.interfaces_ = function interfaces_157() {
  return [ItemVisitor];
};
ArrayListVisitor.prototype.getClass = function getClass156() {
  return ArrayListVisitor;
};
var IndexedPointInAreaLocator = function IndexedPointInAreaLocator2() {
  this._index = null;
  var g2 = arguments[0];
  if (!hasInterface(g2, Polygonal)) {
    throw new IllegalArgumentException("Argument must be Polygonal");
  }
  this._index = new IntervalIndexedGeometry(g2);
};
var staticAccessors$44 = { SegmentVisitor: { configurable: true }, IntervalIndexedGeometry: { configurable: true } };
IndexedPointInAreaLocator.prototype.locate = function locate5(p2) {
  var rcc = new RayCrossingCounter(p2);
  var visitor = new SegmentVisitor(rcc);
  this._index.query(p2.y, p2.y, visitor);
  return rcc.getLocation();
};
IndexedPointInAreaLocator.prototype.interfaces_ = function interfaces_158() {
  return [PointOnGeometryLocator];
};
IndexedPointInAreaLocator.prototype.getClass = function getClass157() {
  return IndexedPointInAreaLocator;
};
staticAccessors$44.SegmentVisitor.get = function() {
  return SegmentVisitor;
};
staticAccessors$44.IntervalIndexedGeometry.get = function() {
  return IntervalIndexedGeometry;
};
Object.defineProperties(IndexedPointInAreaLocator, staticAccessors$44);
var SegmentVisitor = function SegmentVisitor2() {
  this._counter = null;
  var counter2 = arguments[0];
  this._counter = counter2;
};
SegmentVisitor.prototype.visitItem = function visitItem3(item) {
  var seg = item;
  this._counter.countSegment(seg.getCoordinate(0), seg.getCoordinate(1));
};
SegmentVisitor.prototype.interfaces_ = function interfaces_159() {
  return [ItemVisitor];
};
SegmentVisitor.prototype.getClass = function getClass158() {
  return SegmentVisitor;
};
var IntervalIndexedGeometry = function IntervalIndexedGeometry2() {
  this._index = new SortedPackedIntervalRTree();
  var geom = arguments[0];
  this.init(geom);
};
IntervalIndexedGeometry.prototype.init = function init8(geom) {
  var this$1$1 = this;
  var lines = LinearComponentExtracter.getLines(geom);
  for (var i2 = lines.iterator(); i2.hasNext(); ) {
    var line = i2.next();
    var pts = line.getCoordinates();
    this$1$1.addLine(pts);
  }
};
IntervalIndexedGeometry.prototype.addLine = function addLine(pts) {
  var this$1$1 = this;
  for (var i2 = 1; i2 < pts.length; i2++) {
    var seg = new LineSegment(pts[i2 - 1], pts[i2]);
    var min4 = Math.min(seg.p0.y, seg.p1.y);
    var max3 = Math.max(seg.p0.y, seg.p1.y);
    this$1$1._index.insert(min4, max3, seg);
  }
};
IntervalIndexedGeometry.prototype.query = function query5() {
  if (arguments.length === 2) {
    var min4 = arguments[0];
    var max3 = arguments[1];
    var visitor = new ArrayListVisitor();
    this._index.query(min4, max3, visitor);
    return visitor.getItems();
  } else if (arguments.length === 3) {
    var min$1 = arguments[0];
    var max$1 = arguments[1];
    var visitor$1 = arguments[2];
    this._index.query(min$1, max$1, visitor$1);
  }
};
IntervalIndexedGeometry.prototype.interfaces_ = function interfaces_160() {
  return [];
};
IntervalIndexedGeometry.prototype.getClass = function getClass159() {
  return IntervalIndexedGeometry;
};
var GeometryGraph = function(PlanarGraph$$1) {
  function GeometryGraph2() {
    PlanarGraph$$1.call(this);
    this._parentGeom = null;
    this._lineEdgeMap = new HashMap();
    this._boundaryNodeRule = null;
    this._useBoundaryDeterminationRule = true;
    this._argIndex = null;
    this._boundaryNodes = null;
    this._hasTooFewPoints = false;
    this._invalidPoint = null;
    this._areaPtLocator = null;
    this._ptLocator = new PointLocator();
    if (arguments.length === 2) {
      var argIndex = arguments[0];
      var parentGeom = arguments[1];
      var boundaryNodeRule = BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE;
      this._argIndex = argIndex;
      this._parentGeom = parentGeom;
      this._boundaryNodeRule = boundaryNodeRule;
      if (parentGeom !== null) {
        this.add(parentGeom);
      }
    } else if (arguments.length === 3) {
      var argIndex$1 = arguments[0];
      var parentGeom$1 = arguments[1];
      var boundaryNodeRule$1 = arguments[2];
      this._argIndex = argIndex$1;
      this._parentGeom = parentGeom$1;
      this._boundaryNodeRule = boundaryNodeRule$1;
      if (parentGeom$1 !== null) {
        this.add(parentGeom$1);
      }
    }
  }
  if (PlanarGraph$$1)
    GeometryGraph2.__proto__ = PlanarGraph$$1;
  GeometryGraph2.prototype = Object.create(PlanarGraph$$1 && PlanarGraph$$1.prototype);
  GeometryGraph2.prototype.constructor = GeometryGraph2;
  GeometryGraph2.prototype.insertBoundaryPoint = function insertBoundaryPoint(argIndex, coord) {
    var n2 = this._nodes.addNode(coord);
    var lbl = n2.getLabel();
    var boundaryCount = 1;
    var loc = Location.NONE;
    loc = lbl.getLocation(argIndex, Position.ON);
    if (loc === Location.BOUNDARY) {
      boundaryCount++;
    }
    var newLoc = GeometryGraph2.determineBoundary(this._boundaryNodeRule, boundaryCount);
    lbl.setLocation(argIndex, newLoc);
  };
  GeometryGraph2.prototype.computeSelfNodes = function computeSelfNodes() {
    if (arguments.length === 2) {
      var li = arguments[0];
      var computeRingSelfNodes = arguments[1];
      return this.computeSelfNodes(li, computeRingSelfNodes, false);
    } else if (arguments.length === 3) {
      var li$1 = arguments[0];
      var computeRingSelfNodes$1 = arguments[1];
      var isDoneIfProperInt = arguments[2];
      var si = new SegmentIntersector$2(li$1, true, false);
      si.setIsDoneIfProperInt(isDoneIfProperInt);
      var esi = this.createEdgeSetIntersector();
      var isRings = this._parentGeom instanceof LinearRing || this._parentGeom instanceof Polygon$5 || this._parentGeom instanceof MultiPolygon$1;
      var computeAllSegments = computeRingSelfNodes$1 || !isRings;
      esi.computeIntersections(this._edges, si, computeAllSegments);
      this.addSelfIntersectionNodes(this._argIndex);
      return si;
    }
  };
  GeometryGraph2.prototype.computeSplitEdges = function computeSplitEdges(edgelist) {
    for (var i2 = this._edges.iterator(); i2.hasNext(); ) {
      var e3 = i2.next();
      e3.eiList.addSplitEdges(edgelist);
    }
  };
  GeometryGraph2.prototype.computeEdgeIntersections = function computeEdgeIntersections(g2, li, includeProper) {
    var si = new SegmentIntersector$2(li, includeProper, true);
    si.setBoundaryNodes(this.getBoundaryNodes(), g2.getBoundaryNodes());
    var esi = this.createEdgeSetIntersector();
    esi.computeIntersections(this._edges, g2._edges, si);
    return si;
  };
  GeometryGraph2.prototype.getGeometry = function getGeometry4() {
    return this._parentGeom;
  };
  GeometryGraph2.prototype.getBoundaryNodeRule = function getBoundaryNodeRule() {
    return this._boundaryNodeRule;
  };
  GeometryGraph2.prototype.hasTooFewPoints = function hasTooFewPoints() {
    return this._hasTooFewPoints;
  };
  GeometryGraph2.prototype.addPoint = function addPoint2() {
    if (arguments[0] instanceof Point$7) {
      var p2 = arguments[0];
      var coord = p2.getCoordinate();
      this.insertPoint(this._argIndex, coord, Location.INTERIOR);
    } else if (arguments[0] instanceof Coordinate) {
      var pt = arguments[0];
      this.insertPoint(this._argIndex, pt, Location.INTERIOR);
    }
  };
  GeometryGraph2.prototype.addPolygon = function addPolygon2(p2) {
    var this$1$1 = this;
    this.addPolygonRing(p2.getExteriorRing(), Location.EXTERIOR, Location.INTERIOR);
    for (var i2 = 0; i2 < p2.getNumInteriorRing(); i2++) {
      var hole = p2.getInteriorRingN(i2);
      this$1$1.addPolygonRing(hole, Location.INTERIOR, Location.EXTERIOR);
    }
  };
  GeometryGraph2.prototype.addEdge = function addEdge(e3) {
    this.insertEdge(e3);
    var coord = e3.getCoordinates();
    this.insertPoint(this._argIndex, coord[0], Location.BOUNDARY);
    this.insertPoint(this._argIndex, coord[coord.length - 1], Location.BOUNDARY);
  };
  GeometryGraph2.prototype.addLineString = function addLineString2(line) {
    var coord = CoordinateArrays.removeRepeatedPoints(line.getCoordinates());
    if (coord.length < 2) {
      this._hasTooFewPoints = true;
      this._invalidPoint = coord[0];
      return null;
    }
    var e3 = new Edge(coord, new Label(this._argIndex, Location.INTERIOR));
    this._lineEdgeMap.put(line, e3);
    this.insertEdge(e3);
    Assert.isTrue(coord.length >= 2, "found LineString with single point");
    this.insertBoundaryPoint(this._argIndex, coord[0]);
    this.insertBoundaryPoint(this._argIndex, coord[coord.length - 1]);
  };
  GeometryGraph2.prototype.getInvalidPoint = function getInvalidPoint() {
    return this._invalidPoint;
  };
  GeometryGraph2.prototype.getBoundaryPoints = function getBoundaryPoints() {
    var coll = this.getBoundaryNodes();
    var pts = new Array(coll.size()).fill(null);
    var i2 = 0;
    for (var it = coll.iterator(); it.hasNext(); ) {
      var node = it.next();
      pts[i2++] = node.getCoordinate().copy();
    }
    return pts;
  };
  GeometryGraph2.prototype.getBoundaryNodes = function getBoundaryNodes2() {
    if (this._boundaryNodes === null) {
      this._boundaryNodes = this._nodes.getBoundaryNodes(this._argIndex);
    }
    return this._boundaryNodes;
  };
  GeometryGraph2.prototype.addSelfIntersectionNode = function addSelfIntersectionNode(argIndex, coord, loc) {
    if (this.isBoundaryNode(argIndex, coord)) {
      return null;
    }
    if (loc === Location.BOUNDARY && this._useBoundaryDeterminationRule) {
      this.insertBoundaryPoint(argIndex, coord);
    } else {
      this.insertPoint(argIndex, coord, loc);
    }
  };
  GeometryGraph2.prototype.addPolygonRing = function addPolygonRing2(lr, cwLeft, cwRight) {
    if (lr.isEmpty()) {
      return null;
    }
    var coord = CoordinateArrays.removeRepeatedPoints(lr.getCoordinates());
    if (coord.length < 4) {
      this._hasTooFewPoints = true;
      this._invalidPoint = coord[0];
      return null;
    }
    var left = cwLeft;
    var right = cwRight;
    if (CGAlgorithms.isCCW(coord)) {
      left = cwRight;
      right = cwLeft;
    }
    var e3 = new Edge(coord, new Label(this._argIndex, Location.BOUNDARY, left, right));
    this._lineEdgeMap.put(lr, e3);
    this.insertEdge(e3);
    this.insertPoint(this._argIndex, coord[0], Location.BOUNDARY);
  };
  GeometryGraph2.prototype.insertPoint = function insertPoint(argIndex, coord, onLocation) {
    var n2 = this._nodes.addNode(coord);
    var lbl = n2.getLabel();
    if (lbl === null) {
      n2._label = new Label(argIndex, onLocation);
    } else {
      lbl.setLocation(argIndex, onLocation);
    }
  };
  GeometryGraph2.prototype.createEdgeSetIntersector = function createEdgeSetIntersector() {
    return new SimpleMCSweepLineIntersector();
  };
  GeometryGraph2.prototype.addSelfIntersectionNodes = function addSelfIntersectionNodes(argIndex) {
    var this$1$1 = this;
    for (var i2 = this._edges.iterator(); i2.hasNext(); ) {
      var e3 = i2.next();
      var eLoc = e3.getLabel().getLocation(argIndex);
      for (var eiIt = e3.eiList.iterator(); eiIt.hasNext(); ) {
        var ei = eiIt.next();
        this$1$1.addSelfIntersectionNode(argIndex, ei.coord, eLoc);
      }
    }
  };
  GeometryGraph2.prototype.add = function add18() {
    if (arguments.length === 1) {
      var g2 = arguments[0];
      if (g2.isEmpty()) {
        return null;
      }
      if (g2 instanceof MultiPolygon$1) {
        this._useBoundaryDeterminationRule = false;
      }
      if (g2 instanceof Polygon$5) {
        this.addPolygon(g2);
      } else if (g2 instanceof LineString$4) {
        this.addLineString(g2);
      } else if (g2 instanceof Point$7) {
        this.addPoint(g2);
      } else if (g2 instanceof MultiPoint$1) {
        this.addCollection(g2);
      } else if (g2 instanceof MultiLineString$1) {
        this.addCollection(g2);
      } else if (g2 instanceof MultiPolygon$1) {
        this.addCollection(g2);
      } else if (g2 instanceof GeometryCollection) {
        this.addCollection(g2);
      } else {
        throw new Error(g2.getClass().getName());
      }
    } else {
      return PlanarGraph$$1.prototype.add.apply(this, arguments);
    }
  };
  GeometryGraph2.prototype.addCollection = function addCollection2(gc) {
    var this$1$1 = this;
    for (var i2 = 0; i2 < gc.getNumGeometries(); i2++) {
      var g2 = gc.getGeometryN(i2);
      this$1$1.add(g2);
    }
  };
  GeometryGraph2.prototype.locate = function locate6(pt) {
    if (hasInterface(this._parentGeom, Polygonal) && this._parentGeom.getNumGeometries() > 50) {
      if (this._areaPtLocator === null) {
        this._areaPtLocator = new IndexedPointInAreaLocator(this._parentGeom);
      }
      return this._areaPtLocator.locate(pt);
    }
    return this._ptLocator.locate(pt, this._parentGeom);
  };
  GeometryGraph2.prototype.findEdge = function findEdge3() {
    if (arguments.length === 1) {
      var line = arguments[0];
      return this._lineEdgeMap.get(line);
    } else {
      return PlanarGraph$$1.prototype.findEdge.apply(this, arguments);
    }
  };
  GeometryGraph2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  GeometryGraph2.prototype.getClass = function getClass169() {
    return GeometryGraph2;
  };
  GeometryGraph2.determineBoundary = function determineBoundary(boundaryNodeRule, boundaryCount) {
    return boundaryNodeRule.isInBoundary(boundaryCount) ? Location.BOUNDARY : Location.INTERIOR;
  };
  return GeometryGraph2;
}(PlanarGraph);
var GeometryGraphOp = function GeometryGraphOp2() {
  this._li = new RobustLineIntersector();
  this._resultPrecisionModel = null;
  this._arg = null;
  if (arguments.length === 1) {
    var g0 = arguments[0];
    this.setComputationPrecision(g0.getPrecisionModel());
    this._arg = new Array(1).fill(null);
    this._arg[0] = new GeometryGraph(0, g0);
  } else if (arguments.length === 2) {
    var g0$1 = arguments[0];
    var g1 = arguments[1];
    var boundaryNodeRule = BoundaryNodeRule.OGC_SFS_BOUNDARY_RULE;
    if (g0$1.getPrecisionModel().compareTo(g1.getPrecisionModel()) >= 0) {
      this.setComputationPrecision(g0$1.getPrecisionModel());
    } else {
      this.setComputationPrecision(g1.getPrecisionModel());
    }
    this._arg = new Array(2).fill(null);
    this._arg[0] = new GeometryGraph(0, g0$1, boundaryNodeRule);
    this._arg[1] = new GeometryGraph(1, g1, boundaryNodeRule);
  } else if (arguments.length === 3) {
    var g0$2 = arguments[0];
    var g1$1 = arguments[1];
    var boundaryNodeRule$1 = arguments[2];
    if (g0$2.getPrecisionModel().compareTo(g1$1.getPrecisionModel()) >= 0) {
      this.setComputationPrecision(g0$2.getPrecisionModel());
    } else {
      this.setComputationPrecision(g1$1.getPrecisionModel());
    }
    this._arg = new Array(2).fill(null);
    this._arg[0] = new GeometryGraph(0, g0$2, boundaryNodeRule$1);
    this._arg[1] = new GeometryGraph(1, g1$1, boundaryNodeRule$1);
  }
};
GeometryGraphOp.prototype.getArgGeometry = function getArgGeometry(i2) {
  return this._arg[i2].getGeometry();
};
GeometryGraphOp.prototype.setComputationPrecision = function setComputationPrecision(pm) {
  this._resultPrecisionModel = pm;
  this._li.setPrecisionModel(this._resultPrecisionModel);
};
GeometryGraphOp.prototype.interfaces_ = function interfaces_161() {
  return [];
};
GeometryGraphOp.prototype.getClass = function getClass160() {
  return GeometryGraphOp;
};
var GeometryMapper = function GeometryMapper2() {
};
GeometryMapper.prototype.interfaces_ = function interfaces_162() {
  return [];
};
GeometryMapper.prototype.getClass = function getClass161() {
  return GeometryMapper;
};
GeometryMapper.map = function map4() {
  if (arguments[0] instanceof Geometry$1 && hasInterface(arguments[1], GeometryMapper.MapOp)) {
    var geom = arguments[0];
    var op = arguments[1];
    var mapped = new ArrayList();
    for (var i2 = 0; i2 < geom.getNumGeometries(); i2++) {
      var g2 = op.map(geom.getGeometryN(i2));
      if (g2 !== null) {
        mapped.add(g2);
      }
    }
    return geom.getFactory().buildGeometry(mapped);
  } else if (hasInterface(arguments[0], Collection) && hasInterface(arguments[1], GeometryMapper.MapOp)) {
    var geoms = arguments[0];
    var op$1 = arguments[1];
    var mapped$1 = new ArrayList();
    for (var i$12 = geoms.iterator(); i$12.hasNext(); ) {
      var g$12 = i$12.next();
      var gr = op$1.map(g$12);
      if (gr !== null) {
        mapped$1.add(gr);
      }
    }
    return mapped$1;
  }
};
GeometryMapper.MapOp = function MapOp() {
};
var OverlayOp = function(GeometryGraphOp3) {
  function OverlayOp2() {
    var g0 = arguments[0];
    var g1 = arguments[1];
    GeometryGraphOp3.call(this, g0, g1);
    this._ptLocator = new PointLocator();
    this._geomFact = null;
    this._resultGeom = null;
    this._graph = null;
    this._edgeList = new EdgeList();
    this._resultPolyList = new ArrayList();
    this._resultLineList = new ArrayList();
    this._resultPointList = new ArrayList();
    this._graph = new PlanarGraph(new OverlayNodeFactory());
    this._geomFact = g0.getFactory();
  }
  if (GeometryGraphOp3)
    OverlayOp2.__proto__ = GeometryGraphOp3;
  OverlayOp2.prototype = Object.create(GeometryGraphOp3 && GeometryGraphOp3.prototype);
  OverlayOp2.prototype.constructor = OverlayOp2;
  OverlayOp2.prototype.insertUniqueEdge = function insertUniqueEdge2(e3) {
    var existingEdge = this._edgeList.findEqualEdge(e3);
    if (existingEdge !== null) {
      var existingLabel = existingEdge.getLabel();
      var labelToMerge = e3.getLabel();
      if (!existingEdge.isPointwiseEqual(e3)) {
        labelToMerge = new Label(e3.getLabel());
        labelToMerge.flip();
      }
      var depth2 = existingEdge.getDepth();
      if (depth2.isNull()) {
        depth2.add(existingLabel);
      }
      depth2.add(labelToMerge);
      existingLabel.merge(labelToMerge);
    } else {
      this._edgeList.add(e3);
    }
  };
  OverlayOp2.prototype.getGraph = function getGraph() {
    return this._graph;
  };
  OverlayOp2.prototype.cancelDuplicateResultEdges = function cancelDuplicateResultEdges() {
    for (var it = this._graph.getEdgeEnds().iterator(); it.hasNext(); ) {
      var de = it.next();
      var sym = de.getSym();
      if (de.isInResult() && sym.isInResult()) {
        de.setInResult(false);
        sym.setInResult(false);
      }
    }
  };
  OverlayOp2.prototype.isCoveredByLA = function isCoveredByLA(coord) {
    if (this.isCovered(coord, this._resultLineList)) {
      return true;
    }
    if (this.isCovered(coord, this._resultPolyList)) {
      return true;
    }
    return false;
  };
  OverlayOp2.prototype.computeGeometry = function computeGeometry2(resultPointList, resultLineList, resultPolyList, opcode) {
    var geomList = new ArrayList();
    geomList.addAll(resultPointList);
    geomList.addAll(resultLineList);
    geomList.addAll(resultPolyList);
    if (geomList.isEmpty()) {
      return OverlayOp2.createEmptyResult(opcode, this._arg[0].getGeometry(), this._arg[1].getGeometry(), this._geomFact);
    }
    return this._geomFact.buildGeometry(geomList);
  };
  OverlayOp2.prototype.mergeSymLabels = function mergeSymLabels() {
    for (var nodeit = this._graph.getNodes().iterator(); nodeit.hasNext(); ) {
      var node = nodeit.next();
      node.getEdges().mergeSymLabels();
    }
  };
  OverlayOp2.prototype.isCovered = function isCovered2(coord, geomList) {
    var this$1$1 = this;
    for (var it = geomList.iterator(); it.hasNext(); ) {
      var geom = it.next();
      var loc = this$1$1._ptLocator.locate(coord, geom);
      if (loc !== Location.EXTERIOR) {
        return true;
      }
    }
    return false;
  };
  OverlayOp2.prototype.replaceCollapsedEdges = function replaceCollapsedEdges() {
    var newEdges = new ArrayList();
    for (var it = this._edgeList.iterator(); it.hasNext(); ) {
      var e3 = it.next();
      if (e3.isCollapsed()) {
        it.remove();
        newEdges.add(e3.getCollapsedEdge());
      }
    }
    this._edgeList.addAll(newEdges);
  };
  OverlayOp2.prototype.updateNodeLabelling = function updateNodeLabelling() {
    for (var nodeit = this._graph.getNodes().iterator(); nodeit.hasNext(); ) {
      var node = nodeit.next();
      var lbl = node.getEdges().getLabel();
      node.getLabel().merge(lbl);
    }
  };
  OverlayOp2.prototype.getResultGeometry = function getResultGeometry4(overlayOpCode) {
    this.computeOverlay(overlayOpCode);
    return this._resultGeom;
  };
  OverlayOp2.prototype.insertUniqueEdges = function insertUniqueEdges(edges) {
    var this$1$1 = this;
    for (var i2 = edges.iterator(); i2.hasNext(); ) {
      var e3 = i2.next();
      this$1$1.insertUniqueEdge(e3);
    }
  };
  OverlayOp2.prototype.computeOverlay = function computeOverlay(opCode) {
    this.copyPoints(0);
    this.copyPoints(1);
    this._arg[0].computeSelfNodes(this._li, false);
    this._arg[1].computeSelfNodes(this._li, false);
    this._arg[0].computeEdgeIntersections(this._arg[1], this._li, true);
    var baseSplitEdges = new ArrayList();
    this._arg[0].computeSplitEdges(baseSplitEdges);
    this._arg[1].computeSplitEdges(baseSplitEdges);
    this.insertUniqueEdges(baseSplitEdges);
    this.computeLabelsFromDepths();
    this.replaceCollapsedEdges();
    EdgeNodingValidator.checkValid(this._edgeList.getEdges());
    this._graph.addEdges(this._edgeList.getEdges());
    this.computeLabelling();
    this.labelIncompleteNodes();
    this.findResultAreaEdges(opCode);
    this.cancelDuplicateResultEdges();
    var polyBuilder = new PolygonBuilder(this._geomFact);
    polyBuilder.add(this._graph);
    this._resultPolyList = polyBuilder.getPolygons();
    var lineBuilder = new LineBuilder(this, this._geomFact, this._ptLocator);
    this._resultLineList = lineBuilder.build(opCode);
    var pointBuilder = new PointBuilder(this, this._geomFact, this._ptLocator);
    this._resultPointList = pointBuilder.build(opCode);
    this._resultGeom = this.computeGeometry(this._resultPointList, this._resultLineList, this._resultPolyList, opCode);
  };
  OverlayOp2.prototype.labelIncompleteNode = function labelIncompleteNode(n2, targetIndex) {
    var loc = this._ptLocator.locate(n2.getCoordinate(), this._arg[targetIndex].getGeometry());
    n2.getLabel().setLocation(targetIndex, loc);
  };
  OverlayOp2.prototype.copyPoints = function copyPoints(argIndex) {
    var this$1$1 = this;
    for (var i2 = this._arg[argIndex].getNodeIterator(); i2.hasNext(); ) {
      var graphNode = i2.next();
      var newNode = this$1$1._graph.addNode(graphNode.getCoordinate());
      newNode.setLabel(argIndex, graphNode.getLabel().getLocation(argIndex));
    }
  };
  OverlayOp2.prototype.findResultAreaEdges = function findResultAreaEdges(opCode) {
    for (var it = this._graph.getEdgeEnds().iterator(); it.hasNext(); ) {
      var de = it.next();
      var label = de.getLabel();
      if (label.isArea() && !de.isInteriorAreaEdge() && OverlayOp2.isResultOfOp(label.getLocation(0, Position.RIGHT), label.getLocation(1, Position.RIGHT), opCode)) {
        de.setInResult(true);
      }
    }
  };
  OverlayOp2.prototype.computeLabelsFromDepths = function computeLabelsFromDepths() {
    for (var it = this._edgeList.iterator(); it.hasNext(); ) {
      var e3 = it.next();
      var lbl = e3.getLabel();
      var depth2 = e3.getDepth();
      if (!depth2.isNull()) {
        depth2.normalize();
        for (var i2 = 0; i2 < 2; i2++) {
          if (!lbl.isNull(i2) && lbl.isArea() && !depth2.isNull(i2)) {
            if (depth2.getDelta(i2) === 0) {
              lbl.toLine(i2);
            } else {
              Assert.isTrue(!depth2.isNull(i2, Position.LEFT), "depth of LEFT side has not been initialized");
              lbl.setLocation(i2, Position.LEFT, depth2.getLocation(i2, Position.LEFT));
              Assert.isTrue(!depth2.isNull(i2, Position.RIGHT), "depth of RIGHT side has not been initialized");
              lbl.setLocation(i2, Position.RIGHT, depth2.getLocation(i2, Position.RIGHT));
            }
          }
        }
      }
    }
  };
  OverlayOp2.prototype.computeLabelling = function computeLabelling2() {
    var this$1$1 = this;
    for (var nodeit = this._graph.getNodes().iterator(); nodeit.hasNext(); ) {
      var node = nodeit.next();
      node.getEdges().computeLabelling(this$1$1._arg);
    }
    this.mergeSymLabels();
    this.updateNodeLabelling();
  };
  OverlayOp2.prototype.labelIncompleteNodes = function labelIncompleteNodes() {
    var this$1$1 = this;
    for (var ni = this._graph.getNodes().iterator(); ni.hasNext(); ) {
      var n2 = ni.next();
      var label = n2.getLabel();
      if (n2.isIsolated()) {
        if (label.isNull(0)) {
          this$1$1.labelIncompleteNode(n2, 0);
        } else {
          this$1$1.labelIncompleteNode(n2, 1);
        }
      }
      n2.getEdges().updateLabelling(label);
    }
  };
  OverlayOp2.prototype.isCoveredByA = function isCoveredByA(coord) {
    if (this.isCovered(coord, this._resultPolyList)) {
      return true;
    }
    return false;
  };
  OverlayOp2.prototype.interfaces_ = function interfaces_170() {
    return [];
  };
  OverlayOp2.prototype.getClass = function getClass169() {
    return OverlayOp2;
  };
  return OverlayOp2;
}(GeometryGraphOp);
OverlayOp.overlayOp = function(geom0, geom1, opCode) {
  var gov = new OverlayOp(geom0, geom1);
  var geomOv = gov.getResultGeometry(opCode);
  return geomOv;
};
OverlayOp.intersection = function(g2, other) {
  if (g2.isEmpty() || other.isEmpty()) {
    return OverlayOp.createEmptyResult(OverlayOp.INTERSECTION, g2, other, g2.getFactory());
  }
  if (g2.isGeometryCollection()) {
    var g22 = other;
    return GeometryCollectionMapper.map(g2, {
      interfaces_: function() {
        return [GeometryMapper.MapOp];
      },
      map: function(g3) {
        return g3.intersection(g22);
      }
    });
  }
  g2.checkNotGeometryCollection(g2);
  g2.checkNotGeometryCollection(other);
  return SnapIfNeededOverlayOp.overlayOp(g2, other, OverlayOp.INTERSECTION);
};
OverlayOp.symDifference = function(g2, other) {
  if (g2.isEmpty() || other.isEmpty()) {
    if (g2.isEmpty() && other.isEmpty()) {
      return OverlayOp.createEmptyResult(OverlayOp.SYMDIFFERENCE, g2, other, g2.getFactory());
    }
    if (g2.isEmpty()) {
      return other.copy();
    }
    if (other.isEmpty()) {
      return g2.copy();
    }
  }
  g2.checkNotGeometryCollection(g2);
  g2.checkNotGeometryCollection(other);
  return SnapIfNeededOverlayOp.overlayOp(g2, other, OverlayOp.SYMDIFFERENCE);
};
OverlayOp.resultDimension = function(opCode, g0, g1) {
  var dim0 = g0.getDimension();
  var dim1 = g1.getDimension();
  var resultDimension = -1;
  switch (opCode) {
    case OverlayOp.INTERSECTION:
      resultDimension = Math.min(dim0, dim1);
      break;
    case OverlayOp.UNION:
      resultDimension = Math.max(dim0, dim1);
      break;
    case OverlayOp.DIFFERENCE:
      resultDimension = dim0;
      break;
    case OverlayOp.SYMDIFFERENCE:
      resultDimension = Math.max(dim0, dim1);
      break;
  }
  return resultDimension;
};
OverlayOp.createEmptyResult = function(overlayOpCode, a2, b2, geomFact) {
  var result = null;
  switch (OverlayOp.resultDimension(overlayOpCode, a2, b2)) {
    case -1:
      result = geomFact.createGeometryCollection(new Array(0).fill(null));
      break;
    case 0:
      result = geomFact.createPoint();
      break;
    case 1:
      result = geomFact.createLineString();
      break;
    case 2:
      result = geomFact.createPolygon();
      break;
  }
  return result;
};
OverlayOp.difference = function(g2, other) {
  if (g2.isEmpty()) {
    return OverlayOp.createEmptyResult(OverlayOp.DIFFERENCE, g2, other, g2.getFactory());
  }
  if (other.isEmpty()) {
    return g2.copy();
  }
  g2.checkNotGeometryCollection(g2);
  g2.checkNotGeometryCollection(other);
  return SnapIfNeededOverlayOp.overlayOp(g2, other, OverlayOp.DIFFERENCE);
};
OverlayOp.isResultOfOp = function() {
  if (arguments.length === 2) {
    var label = arguments[0];
    var opCode = arguments[1];
    var loc0 = label.getLocation(0);
    var loc1 = label.getLocation(1);
    return OverlayOp.isResultOfOp(loc0, loc1, opCode);
  } else if (arguments.length === 3) {
    var loc0$1 = arguments[0];
    var loc1$1 = arguments[1];
    var overlayOpCode = arguments[2];
    if (loc0$1 === Location.BOUNDARY) {
      loc0$1 = Location.INTERIOR;
    }
    if (loc1$1 === Location.BOUNDARY) {
      loc1$1 = Location.INTERIOR;
    }
    switch (overlayOpCode) {
      case OverlayOp.INTERSECTION:
        return loc0$1 === Location.INTERIOR && loc1$1 === Location.INTERIOR;
      case OverlayOp.UNION:
        return loc0$1 === Location.INTERIOR || loc1$1 === Location.INTERIOR;
      case OverlayOp.DIFFERENCE:
        return loc0$1 === Location.INTERIOR && loc1$1 !== Location.INTERIOR;
      case OverlayOp.SYMDIFFERENCE:
        return loc0$1 === Location.INTERIOR && loc1$1 !== Location.INTERIOR || loc0$1 !== Location.INTERIOR && loc1$1 === Location.INTERIOR;
    }
    return false;
  }
};
OverlayOp.INTERSECTION = 1;
OverlayOp.UNION = 2;
OverlayOp.DIFFERENCE = 3;
OverlayOp.SYMDIFFERENCE = 4;
var FuzzyPointLocator = function FuzzyPointLocator2() {
  this._g = null;
  this._boundaryDistanceTolerance = null;
  this._linework = null;
  this._ptLocator = new PointLocator();
  this._seg = new LineSegment();
  var g2 = arguments[0];
  var boundaryDistanceTolerance = arguments[1];
  this._g = g2;
  this._boundaryDistanceTolerance = boundaryDistanceTolerance;
  this._linework = this.extractLinework(g2);
};
FuzzyPointLocator.prototype.isWithinToleranceOfBoundary = function isWithinToleranceOfBoundary(pt) {
  var this$1$1 = this;
  for (var i2 = 0; i2 < this._linework.getNumGeometries(); i2++) {
    var line = this$1$1._linework.getGeometryN(i2);
    var seq = line.getCoordinateSequence();
    for (var j2 = 0; j2 < seq.size() - 1; j2++) {
      seq.getCoordinate(j2, this$1$1._seg.p0);
      seq.getCoordinate(j2 + 1, this$1$1._seg.p1);
      var dist2 = this$1$1._seg.distance(pt);
      if (dist2 <= this$1$1._boundaryDistanceTolerance) {
        return true;
      }
    }
  }
  return false;
};
FuzzyPointLocator.prototype.getLocation = function getLocation5(pt) {
  if (this.isWithinToleranceOfBoundary(pt)) {
    return Location.BOUNDARY;
  }
  return this._ptLocator.locate(pt, this._g);
};
FuzzyPointLocator.prototype.extractLinework = function extractLinework(g2) {
  var extracter = new PolygonalLineworkExtracter();
  g2.apply(extracter);
  var linework = extracter.getLinework();
  var lines = GeometryFactory.toLineStringArray(linework);
  return g2.getFactory().createMultiLineString(lines);
};
FuzzyPointLocator.prototype.interfaces_ = function interfaces_163() {
  return [];
};
FuzzyPointLocator.prototype.getClass = function getClass162() {
  return FuzzyPointLocator;
};
var PolygonalLineworkExtracter = function PolygonalLineworkExtracter2() {
  this._linework = null;
  this._linework = new ArrayList();
};
PolygonalLineworkExtracter.prototype.getLinework = function getLinework() {
  return this._linework;
};
PolygonalLineworkExtracter.prototype.filter = function filter16(g2) {
  var this$1$1 = this;
  if (g2 instanceof Polygon$5) {
    var poly2 = g2;
    this._linework.add(poly2.getExteriorRing());
    for (var i2 = 0; i2 < poly2.getNumInteriorRing(); i2++) {
      this$1$1._linework.add(poly2.getInteriorRingN(i2));
    }
  }
};
PolygonalLineworkExtracter.prototype.interfaces_ = function interfaces_164() {
  return [GeometryFilter];
};
PolygonalLineworkExtracter.prototype.getClass = function getClass163() {
  return PolygonalLineworkExtracter;
};
var OffsetPointGenerator = function OffsetPointGenerator2() {
  this._g = null;
  this._doLeft = true;
  this._doRight = true;
  var g2 = arguments[0];
  this._g = g2;
};
OffsetPointGenerator.prototype.extractPoints = function extractPoints(line, offsetDistance, offsetPts) {
  var this$1$1 = this;
  var pts = line.getCoordinates();
  for (var i2 = 0; i2 < pts.length - 1; i2++) {
    this$1$1.computeOffsetPoints(pts[i2], pts[i2 + 1], offsetDistance, offsetPts);
  }
};
OffsetPointGenerator.prototype.setSidesToGenerate = function setSidesToGenerate(doLeft, doRight) {
  this._doLeft = doLeft;
  this._doRight = doRight;
};
OffsetPointGenerator.prototype.getPoints = function getPoints3(offsetDistance) {
  var this$1$1 = this;
  var offsetPts = new ArrayList();
  var lines = LinearComponentExtracter.getLines(this._g);
  for (var i2 = lines.iterator(); i2.hasNext(); ) {
    var line = i2.next();
    this$1$1.extractPoints(line, offsetDistance, offsetPts);
  }
  return offsetPts;
};
OffsetPointGenerator.prototype.computeOffsetPoints = function computeOffsetPoints(p0, p1, offsetDistance, offsetPts) {
  var dx = p1.x - p0.x;
  var dy = p1.y - p0.y;
  var len2 = Math.sqrt(dx * dx + dy * dy);
  var ux = offsetDistance * dx / len2;
  var uy = offsetDistance * dy / len2;
  var midX = (p1.x + p0.x) / 2;
  var midY = (p1.y + p0.y) / 2;
  if (this._doLeft) {
    var offsetLeft = new Coordinate(midX - uy, midY + ux);
    offsetPts.add(offsetLeft);
  }
  if (this._doRight) {
    var offsetRight = new Coordinate(midX + uy, midY - ux);
    offsetPts.add(offsetRight);
  }
};
OffsetPointGenerator.prototype.interfaces_ = function interfaces_165() {
  return [];
};
OffsetPointGenerator.prototype.getClass = function getClass164() {
  return OffsetPointGenerator;
};
var OverlayResultValidator = function OverlayResultValidator2() {
  this._geom = null;
  this._locFinder = null;
  this._location = new Array(3).fill(null);
  this._invalidLocation = null;
  this._boundaryDistanceTolerance = OverlayResultValidator2.TOLERANCE;
  this._testCoords = new ArrayList();
  var a2 = arguments[0];
  var b2 = arguments[1];
  var result = arguments[2];
  this._boundaryDistanceTolerance = OverlayResultValidator2.computeBoundaryDistanceTolerance(a2, b2);
  this._geom = [a2, b2, result];
  this._locFinder = [new FuzzyPointLocator(this._geom[0], this._boundaryDistanceTolerance), new FuzzyPointLocator(this._geom[1], this._boundaryDistanceTolerance), new FuzzyPointLocator(this._geom[2], this._boundaryDistanceTolerance)];
};
var staticAccessors$46 = { TOLERANCE: { configurable: true } };
OverlayResultValidator.prototype.reportResult = function reportResult(overlayOp3, location2, expectedInterior) {
  System.out.println("Overlay result invalid - A:" + Location.toLocationSymbol(location2[0]) + " B:" + Location.toLocationSymbol(location2[1]) + " expected:" + (expectedInterior ? "i" : "e") + " actual:" + Location.toLocationSymbol(location2[2]));
};
OverlayResultValidator.prototype.isValid = function isValid5(overlayOp3) {
  this.addTestPts(this._geom[0]);
  this.addTestPts(this._geom[1]);
  var isValid8 = this.checkValid(overlayOp3);
  return isValid8;
};
OverlayResultValidator.prototype.checkValid = function checkValid6() {
  var this$1$1 = this;
  if (arguments.length === 1) {
    var overlayOp3 = arguments[0];
    for (var i2 = 0; i2 < this._testCoords.size(); i2++) {
      var pt = this$1$1._testCoords.get(i2);
      if (!this$1$1.checkValid(overlayOp3, pt)) {
        this$1$1._invalidLocation = pt;
        return false;
      }
    }
    return true;
  } else if (arguments.length === 2) {
    var overlayOp$1 = arguments[0];
    var pt$1 = arguments[1];
    this._location[0] = this._locFinder[0].getLocation(pt$1);
    this._location[1] = this._locFinder[1].getLocation(pt$1);
    this._location[2] = this._locFinder[2].getLocation(pt$1);
    if (OverlayResultValidator.hasLocation(this._location, Location.BOUNDARY)) {
      return true;
    }
    return this.isValidResult(overlayOp$1, this._location);
  }
};
OverlayResultValidator.prototype.addTestPts = function addTestPts(g2) {
  var ptGen = new OffsetPointGenerator(g2);
  this._testCoords.addAll(ptGen.getPoints(5 * this._boundaryDistanceTolerance));
};
OverlayResultValidator.prototype.isValidResult = function isValidResult(overlayOp3, location2) {
  var expectedInterior = OverlayOp.isResultOfOp(location2[0], location2[1], overlayOp3);
  var resultInInterior = location2[2] === Location.INTERIOR;
  var isValid8 = !(expectedInterior ^ resultInInterior);
  if (!isValid8) {
    this.reportResult(overlayOp3, location2, expectedInterior);
  }
  return isValid8;
};
OverlayResultValidator.prototype.getInvalidLocation = function getInvalidLocation() {
  return this._invalidLocation;
};
OverlayResultValidator.prototype.interfaces_ = function interfaces_166() {
  return [];
};
OverlayResultValidator.prototype.getClass = function getClass165() {
  return OverlayResultValidator;
};
OverlayResultValidator.hasLocation = function hasLocation(location2, loc) {
  for (var i2 = 0; i2 < 3; i2++) {
    if (location2[i2] === loc) {
      return true;
    }
  }
  return false;
};
OverlayResultValidator.computeBoundaryDistanceTolerance = function computeBoundaryDistanceTolerance(g0, g1) {
  return Math.min(GeometrySnapper.computeSizeBasedSnapTolerance(g0), GeometrySnapper.computeSizeBasedSnapTolerance(g1));
};
OverlayResultValidator.isValid = function isValid6(a2, b2, overlayOp3, result) {
  var validator2 = new OverlayResultValidator(a2, b2, result);
  return validator2.isValid(overlayOp3);
};
staticAccessors$46.TOLERANCE.get = function() {
  return 1e-6;
};
Object.defineProperties(OverlayResultValidator, staticAccessors$46);
var GeometryCombiner = function GeometryCombiner2(geoms) {
  this._geomFactory = null;
  this._skipEmpty = false;
  this._inputGeoms = null;
  this._geomFactory = GeometryCombiner2.extractFactory(geoms);
  this._inputGeoms = geoms;
};
GeometryCombiner.prototype.extractElements = function extractElements(geom, elems) {
  var this$1$1 = this;
  if (geom === null) {
    return null;
  }
  for (var i2 = 0; i2 < geom.getNumGeometries(); i2++) {
    var elemGeom = geom.getGeometryN(i2);
    if (this$1$1._skipEmpty && elemGeom.isEmpty()) {
      continue;
    }
    elems.add(elemGeom);
  }
};
GeometryCombiner.prototype.combine = function combine2() {
  var this$1$1 = this;
  var elems = new ArrayList();
  for (var i2 = this._inputGeoms.iterator(); i2.hasNext(); ) {
    var g2 = i2.next();
    this$1$1.extractElements(g2, elems);
  }
  if (elems.size() === 0) {
    if (this._geomFactory !== null) {
      return this._geomFactory.createGeometryCollection(null);
    }
    return null;
  }
  return this._geomFactory.buildGeometry(elems);
};
GeometryCombiner.prototype.interfaces_ = function interfaces_167() {
  return [];
};
GeometryCombiner.prototype.getClass = function getClass166() {
  return GeometryCombiner;
};
GeometryCombiner.combine = function combine3() {
  if (arguments.length === 1) {
    var geoms = arguments[0];
    var combiner = new GeometryCombiner(geoms);
    return combiner.combine();
  } else if (arguments.length === 2) {
    var g0 = arguments[0];
    var g1 = arguments[1];
    var combiner$1 = new GeometryCombiner(GeometryCombiner.createList(g0, g1));
    return combiner$1.combine();
  } else if (arguments.length === 3) {
    var g0$1 = arguments[0];
    var g1$1 = arguments[1];
    var g2 = arguments[2];
    var combiner$2 = new GeometryCombiner(GeometryCombiner.createList(g0$1, g1$1, g2));
    return combiner$2.combine();
  }
};
GeometryCombiner.extractFactory = function extractFactory(geoms) {
  if (geoms.isEmpty()) {
    return null;
  }
  return geoms.iterator().next().getFactory();
};
GeometryCombiner.createList = function createList() {
  if (arguments.length === 2) {
    var obj0 = arguments[0];
    var obj1 = arguments[1];
    var list2 = new ArrayList();
    list2.add(obj0);
    list2.add(obj1);
    return list2;
  } else if (arguments.length === 3) {
    var obj0$1 = arguments[0];
    var obj1$1 = arguments[1];
    var obj2 = arguments[2];
    var list$1 = new ArrayList();
    list$1.add(obj0$1);
    list$1.add(obj1$1);
    list$1.add(obj2);
    return list$1;
  }
};
var CascadedPolygonUnion = function CascadedPolygonUnion2() {
  this._inputPolys = null;
  this._geomFactory = null;
  var polys = arguments[0];
  this._inputPolys = polys;
  if (this._inputPolys === null) {
    this._inputPolys = new ArrayList();
  }
};
var staticAccessors$47 = { STRTREE_NODE_CAPACITY: { configurable: true } };
CascadedPolygonUnion.prototype.reduceToGeometries = function reduceToGeometries(geomTree) {
  var this$1$1 = this;
  var geoms = new ArrayList();
  for (var i2 = geomTree.iterator(); i2.hasNext(); ) {
    var o2 = i2.next();
    var geom = null;
    if (hasInterface(o2, List$2)) {
      geom = this$1$1.unionTree(o2);
    } else if (o2 instanceof Geometry$1) {
      geom = o2;
    }
    geoms.add(geom);
  }
  return geoms;
};
CascadedPolygonUnion.prototype.extractByEnvelope = function extractByEnvelope(env, geom, disjointGeoms) {
  var intersectingGeoms = new ArrayList();
  for (var i2 = 0; i2 < geom.getNumGeometries(); i2++) {
    var elem = geom.getGeometryN(i2);
    if (elem.getEnvelopeInternal().intersects(env)) {
      intersectingGeoms.add(elem);
    } else {
      disjointGeoms.add(elem);
    }
  }
  return this._geomFactory.buildGeometry(intersectingGeoms);
};
CascadedPolygonUnion.prototype.unionOptimized = function unionOptimized(g0, g1) {
  var g0Env = g0.getEnvelopeInternal();
  var g1Env = g1.getEnvelopeInternal();
  if (!g0Env.intersects(g1Env)) {
    var combo = GeometryCombiner.combine(g0, g1);
    return combo;
  }
  if (g0.getNumGeometries() <= 1 && g1.getNumGeometries() <= 1) {
    return this.unionActual(g0, g1);
  }
  var commonEnv = g0Env.intersection(g1Env);
  return this.unionUsingEnvelopeIntersection(g0, g1, commonEnv);
};
CascadedPolygonUnion.prototype.union = function union3() {
  if (this._inputPolys === null) {
    throw new Error("union() method cannot be called twice");
  }
  if (this._inputPolys.isEmpty()) {
    return null;
  }
  this._geomFactory = this._inputPolys.iterator().next().getFactory();
  var index2 = new STRtree(CascadedPolygonUnion.STRTREE_NODE_CAPACITY);
  for (var i2 = this._inputPolys.iterator(); i2.hasNext(); ) {
    var item = i2.next();
    index2.insert(item.getEnvelopeInternal(), item);
  }
  this._inputPolys = null;
  var itemTree = index2.itemsTree();
  var unionAll = this.unionTree(itemTree);
  return unionAll;
};
CascadedPolygonUnion.prototype.binaryUnion = function binaryUnion() {
  if (arguments.length === 1) {
    var geoms = arguments[0];
    return this.binaryUnion(geoms, 0, geoms.size());
  } else if (arguments.length === 3) {
    var geoms$1 = arguments[0];
    var start2 = arguments[1];
    var end = arguments[2];
    if (end - start2 <= 1) {
      var g0 = CascadedPolygonUnion.getGeometry(geoms$1, start2);
      return this.unionSafe(g0, null);
    } else if (end - start2 === 2) {
      return this.unionSafe(CascadedPolygonUnion.getGeometry(geoms$1, start2), CascadedPolygonUnion.getGeometry(geoms$1, start2 + 1));
    } else {
      var mid = Math.trunc((end + start2) / 2);
      var g0$1 = this.binaryUnion(geoms$1, start2, mid);
      var g1 = this.binaryUnion(geoms$1, mid, end);
      return this.unionSafe(g0$1, g1);
    }
  }
};
CascadedPolygonUnion.prototype.repeatedUnion = function repeatedUnion(geoms) {
  var union6 = null;
  for (var i2 = geoms.iterator(); i2.hasNext(); ) {
    var g2 = i2.next();
    if (union6 === null) {
      union6 = g2.copy();
    } else {
      union6 = union6.union(g2);
    }
  }
  return union6;
};
CascadedPolygonUnion.prototype.unionSafe = function unionSafe(g0, g1) {
  if (g0 === null && g1 === null) {
    return null;
  }
  if (g0 === null) {
    return g1.copy();
  }
  if (g1 === null) {
    return g0.copy();
  }
  return this.unionOptimized(g0, g1);
};
CascadedPolygonUnion.prototype.unionActual = function unionActual(g0, g1) {
  return CascadedPolygonUnion.restrictToPolygons(g0.union(g1));
};
CascadedPolygonUnion.prototype.unionTree = function unionTree(geomTree) {
  var geoms = this.reduceToGeometries(geomTree);
  var union6 = this.binaryUnion(geoms);
  return union6;
};
CascadedPolygonUnion.prototype.unionUsingEnvelopeIntersection = function unionUsingEnvelopeIntersection(g0, g1, common2) {
  var disjointPolys = new ArrayList();
  var g0Int = this.extractByEnvelope(common2, g0, disjointPolys);
  var g1Int = this.extractByEnvelope(common2, g1, disjointPolys);
  var union6 = this.unionActual(g0Int, g1Int);
  disjointPolys.add(union6);
  var overallUnion = GeometryCombiner.combine(disjointPolys);
  return overallUnion;
};
CascadedPolygonUnion.prototype.bufferUnion = function bufferUnion() {
  if (arguments.length === 1) {
    var geoms = arguments[0];
    var factory = geoms.get(0).getFactory();
    var gColl = factory.buildGeometry(geoms);
    var unionAll = gColl.buffer(0);
    return unionAll;
  } else if (arguments.length === 2) {
    var g0 = arguments[0];
    var g1 = arguments[1];
    var factory$1 = g0.getFactory();
    var gColl$1 = factory$1.createGeometryCollection([g0, g1]);
    var unionAll$1 = gColl$1.buffer(0);
    return unionAll$1;
  }
};
CascadedPolygonUnion.prototype.interfaces_ = function interfaces_168() {
  return [];
};
CascadedPolygonUnion.prototype.getClass = function getClass167() {
  return CascadedPolygonUnion;
};
CascadedPolygonUnion.restrictToPolygons = function restrictToPolygons(g2) {
  if (hasInterface(g2, Polygonal)) {
    return g2;
  }
  var polygons2 = PolygonExtracter.getPolygons(g2);
  if (polygons2.size() === 1) {
    return polygons2.get(0);
  }
  return g2.getFactory().createMultiPolygon(GeometryFactory.toPolygonArray(polygons2));
};
CascadedPolygonUnion.getGeometry = function getGeometry3(list2, index2) {
  if (index2 >= list2.size()) {
    return null;
  }
  return list2.get(index2);
};
CascadedPolygonUnion.union = function union4(polys) {
  var op = new CascadedPolygonUnion(polys);
  return op.union();
};
staticAccessors$47.STRTREE_NODE_CAPACITY.get = function() {
  return 4;
};
Object.defineProperties(CascadedPolygonUnion, staticAccessors$47);
var UnionOp = function UnionOp2() {
};
UnionOp.prototype.interfaces_ = function interfaces_169() {
  return [];
};
UnionOp.prototype.getClass = function getClass168() {
  return UnionOp;
};
UnionOp.union = function union5(g2, other) {
  if (g2.isEmpty() || other.isEmpty()) {
    if (g2.isEmpty() && other.isEmpty()) {
      return OverlayOp.createEmptyResult(OverlayOp.UNION, g2, other, g2.getFactory());
    }
    if (g2.isEmpty()) {
      return other.copy();
    }
    if (other.isEmpty()) {
      return g2.copy();
    }
  }
  g2.checkNotGeometryCollection(g2);
  g2.checkNotGeometryCollection(other);
  return SnapIfNeededOverlayOp.overlayOp(g2, other, OverlayOp.UNION);
};
function adder() {
  return new Adder();
}
function Adder() {
  this.reset();
}
Adder.prototype = {
  constructor: Adder,
  reset: function() {
    this.s = // rounded value
    this.t = 0;
  },
  add: function(y2) {
    add$5(temp, y2, this.t);
    add$5(this, temp.s, this.s);
    if (this.s)
      this.t += temp.t;
    else
      this.s = temp.t;
  },
  valueOf: function() {
    return this.s;
  }
};
var temp = new Adder();
function add$5(adder2, a2, b2) {
  var x2 = adder2.s = a2 + b2, bv2 = x2 - a2, av2 = x2 - bv2;
  adder2.t = a2 - av2 + (b2 - bv2);
}
var epsilon$1 = 1e-6;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees$1 = 180 / pi;
var radians$1 = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var sin = Math.sin;
var sqrt = Math.sqrt;
function acos(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi : Math.acos(x2);
}
function asin(x2) {
  return x2 > 1 ? halfPi : x2 < -1 ? -halfPi : Math.asin(x2);
}
function noop$7() {
}
function streamGeometry(geometry2, stream2) {
  if (geometry2 && streamGeometryType.hasOwnProperty(geometry2.type)) {
    streamGeometryType[geometry2.type](geometry2, stream2);
  }
}
var streamObjectType = {
  Feature: function(object2, stream2) {
    streamGeometry(object2.geometry, stream2);
  },
  FeatureCollection: function(object2, stream2) {
    var features = object2.features, i2 = -1, n2 = features.length;
    while (++i2 < n2)
      streamGeometry(features[i2].geometry, stream2);
  }
};
var streamGeometryType = {
  Sphere: function(object2, stream2) {
    stream2.sphere();
  },
  Point: function(object2, stream2) {
    object2 = object2.coordinates;
    stream2.point(object2[0], object2[1], object2[2]);
  },
  MultiPoint: function(object2, stream2) {
    var coordinates2 = object2.coordinates, i2 = -1, n2 = coordinates2.length;
    while (++i2 < n2)
      object2 = coordinates2[i2], stream2.point(object2[0], object2[1], object2[2]);
  },
  LineString: function(object2, stream2) {
    streamLine(object2.coordinates, stream2, 0);
  },
  MultiLineString: function(object2, stream2) {
    var coordinates2 = object2.coordinates, i2 = -1, n2 = coordinates2.length;
    while (++i2 < n2)
      streamLine(coordinates2[i2], stream2, 0);
  },
  Polygon: function(object2, stream2) {
    streamPolygon(object2.coordinates, stream2);
  },
  MultiPolygon: function(object2, stream2) {
    var coordinates2 = object2.coordinates, i2 = -1, n2 = coordinates2.length;
    while (++i2 < n2)
      streamPolygon(coordinates2[i2], stream2);
  },
  GeometryCollection: function(object2, stream2) {
    var geometries = object2.geometries, i2 = -1, n2 = geometries.length;
    while (++i2 < n2)
      streamGeometry(geometries[i2], stream2);
  }
};
function streamLine(coordinates2, stream2, closed) {
  var i2 = -1, n2 = coordinates2.length - closed, coordinate2;
  stream2.lineStart();
  while (++i2 < n2)
    coordinate2 = coordinates2[i2], stream2.point(coordinate2[0], coordinate2[1], coordinate2[2]);
  stream2.lineEnd();
}
function streamPolygon(coordinates2, stream2) {
  var i2 = -1, n2 = coordinates2.length;
  stream2.polygonStart();
  while (++i2 < n2)
    streamLine(coordinates2[i2], stream2, 1);
  stream2.polygonEnd();
}
function geoStream(object2, stream2) {
  if (object2 && streamObjectType.hasOwnProperty(object2.type)) {
    streamObjectType[object2.type](object2, stream2);
  } else {
    streamGeometry(object2, stream2);
  }
}
adder();
adder();
function spherical(cartesian2) {
  return [atan2(cartesian2[1], cartesian2[0]), asin(cartesian2[2])];
}
function cartesian(spherical2) {
  var lambda = spherical2[0], phi = spherical2[1], cosPhi = cos(phi);
  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
}
function cartesianDot(a2, b2) {
  return a2[0] * b2[0] + a2[1] * b2[1] + a2[2] * b2[2];
}
function cartesianCross(a2, b2) {
  return [a2[1] * b2[2] - a2[2] * b2[1], a2[2] * b2[0] - a2[0] * b2[2], a2[0] * b2[1] - a2[1] * b2[0]];
}
function cartesianAddInPlace(a2, b2) {
  a2[0] += b2[0], a2[1] += b2[1], a2[2] += b2[2];
}
function cartesianScale(vector, k2) {
  return [vector[0] * k2, vector[1] * k2, vector[2] * k2];
}
function cartesianNormalizeInPlace(d2) {
  var l2 = sqrt(d2[0] * d2[0] + d2[1] * d2[1] + d2[2] * d2[2]);
  d2[0] /= l2, d2[1] /= l2, d2[2] /= l2;
}
adder();
function compose(a2, b2) {
  function compose2(x2, y2) {
    return x2 = a2(x2, y2), b2(x2[0], x2[1]);
  }
  if (a2.invert && b2.invert)
    compose2.invert = function(x2, y2) {
      return x2 = b2.invert(x2, y2), x2 && a2.invert(x2[0], x2[1]);
    };
  return compose2;
}
function rotationIdentity(lambda, phi) {
  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
  return (deltaLambda %= tau) ? deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
  return function(lambda, phi) {
    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
  };
}
function rotationLambda(deltaLambda) {
  var rotation = forwardRotationLambda(deltaLambda);
  rotation.invert = forwardRotationLambda(-deltaLambda);
  return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
  var cosDeltaPhi = cos(deltaPhi), sinDeltaPhi = sin(deltaPhi), cosDeltaGamma = cos(deltaGamma), sinDeltaGamma = sin(deltaGamma);
  function rotation(lambda, phi) {
    var cosPhi = cos(phi), x2 = cos(lambda) * cosPhi, y2 = sin(lambda) * cosPhi, z2 = sin(phi), k2 = z2 * cosDeltaPhi + x2 * sinDeltaPhi;
    return [
      atan2(y2 * cosDeltaGamma - k2 * sinDeltaGamma, x2 * cosDeltaPhi - z2 * sinDeltaPhi),
      asin(k2 * cosDeltaGamma + y2 * sinDeltaGamma)
    ];
  }
  rotation.invert = function(lambda, phi) {
    var cosPhi = cos(phi), x2 = cos(lambda) * cosPhi, y2 = sin(lambda) * cosPhi, z2 = sin(phi), k2 = z2 * cosDeltaGamma - y2 * sinDeltaGamma;
    return [
      atan2(y2 * cosDeltaGamma + z2 * sinDeltaGamma, x2 * cosDeltaPhi + k2 * sinDeltaPhi),
      asin(k2 * cosDeltaPhi - x2 * sinDeltaPhi)
    ];
  };
  return rotation;
}
function circleStream(stream2, radius, delta, direction, t0, t1) {
  if (!delta)
    return;
  var cosRadius = cos(radius), sinRadius = sin(radius), step = direction * delta;
  if (t0 == null) {
    t0 = radius + direction * tau;
    t1 = radius - step / 2;
  } else {
    t0 = circleRadius(cosRadius, t0);
    t1 = circleRadius(cosRadius, t1);
    if (direction > 0 ? t0 < t1 : t0 > t1)
      t0 += direction * tau;
  }
  for (var point4, t2 = t0; direction > 0 ? t2 > t1 : t2 < t1; t2 -= step) {
    point4 = spherical([cosRadius, -sinRadius * cos(t2), -sinRadius * sin(t2)]);
    stream2.point(point4[0], point4[1]);
  }
}
function circleRadius(cosRadius, point4) {
  point4 = cartesian(point4), point4[0] -= cosRadius;
  cartesianNormalizeInPlace(point4);
  var radius = acos(-point4[1]);
  return ((-point4[2] < 0 ? -radius : radius) + tau - epsilon$1) % tau;
}
function clipBuffer() {
  var lines = [], line;
  return {
    point: function(x2, y2) {
      line.push([x2, y2]);
    },
    lineStart: function() {
      lines.push(line = []);
    },
    lineEnd: noop$7,
    rejoin: function() {
      if (lines.length > 1)
        lines.push(lines.pop().concat(lines.shift()));
    },
    result: function() {
      var result = lines;
      lines = [];
      line = null;
      return result;
    }
  };
}
function clipLine(a2, b2, x02, y02, x12, y12) {
  var ax2 = a2[0], ay2 = a2[1], bx2 = b2[0], by2 = b2[1], t0 = 0, t1 = 1, dx = bx2 - ax2, dy = by2 - ay2, r2;
  r2 = x02 - ax2;
  if (!dx && r2 > 0)
    return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 < t0)
      return;
    if (r2 < t1)
      t1 = r2;
  } else if (dx > 0) {
    if (r2 > t1)
      return;
    if (r2 > t0)
      t0 = r2;
  }
  r2 = x12 - ax2;
  if (!dx && r2 < 0)
    return;
  r2 /= dx;
  if (dx < 0) {
    if (r2 > t1)
      return;
    if (r2 > t0)
      t0 = r2;
  } else if (dx > 0) {
    if (r2 < t0)
      return;
    if (r2 < t1)
      t1 = r2;
  }
  r2 = y02 - ay2;
  if (!dy && r2 > 0)
    return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 < t0)
      return;
    if (r2 < t1)
      t1 = r2;
  } else if (dy > 0) {
    if (r2 > t1)
      return;
    if (r2 > t0)
      t0 = r2;
  }
  r2 = y12 - ay2;
  if (!dy && r2 < 0)
    return;
  r2 /= dy;
  if (dy < 0) {
    if (r2 > t1)
      return;
    if (r2 > t0)
      t0 = r2;
  } else if (dy > 0) {
    if (r2 < t0)
      return;
    if (r2 < t1)
      t1 = r2;
  }
  if (t0 > 0)
    a2[0] = ax2 + t0 * dx, a2[1] = ay2 + t0 * dy;
  if (t1 < 1)
    b2[0] = ax2 + t1 * dx, b2[1] = ay2 + t1 * dy;
  return true;
}
function pointEqual(a2, b2) {
  return abs(a2[0] - b2[0]) < epsilon$1 && abs(a2[1] - b2[1]) < epsilon$1;
}
function Intersection(point4, points2, other, entry) {
  this.x = point4;
  this.z = points2;
  this.o = other;
  this.e = entry;
  this.v = false;
  this.n = this.p = null;
}
function clipPolygon(segments, compareIntersection2, startInside, interpolate2, stream2) {
  var subject = [], clip2 = [], i2, n2;
  segments.forEach(function(segment) {
    if ((n3 = segment.length - 1) <= 0)
      return;
    var n3, p0 = segment[0], p1 = segment[n3], x2;
    if (pointEqual(p0, p1)) {
      stream2.lineStart();
      for (i2 = 0; i2 < n3; ++i2)
        stream2.point((p0 = segment[i2])[0], p0[1]);
      stream2.lineEnd();
      return;
    }
    subject.push(x2 = new Intersection(p0, segment, null, true));
    clip2.push(x2.o = new Intersection(p0, null, x2, false));
    subject.push(x2 = new Intersection(p1, segment, null, false));
    clip2.push(x2.o = new Intersection(p1, null, x2, true));
  });
  if (!subject.length)
    return;
  clip2.sort(compareIntersection2);
  link(subject);
  link(clip2);
  for (i2 = 0, n2 = clip2.length; i2 < n2; ++i2) {
    clip2[i2].e = startInside = !startInside;
  }
  var start2 = subject[0], points2, point4;
  while (1) {
    var current = start2, isSubject = true;
    while (current.v)
      if ((current = current.n) === start2)
        return;
    points2 = current.z;
    stream2.lineStart();
    do {
      current.v = current.o.v = true;
      if (current.e) {
        if (isSubject) {
          for (i2 = 0, n2 = points2.length; i2 < n2; ++i2)
            stream2.point((point4 = points2[i2])[0], point4[1]);
        } else {
          interpolate2(current.x, current.n.x, 1, stream2);
        }
        current = current.n;
      } else {
        if (isSubject) {
          points2 = current.p.z;
          for (i2 = points2.length - 1; i2 >= 0; --i2)
            stream2.point((point4 = points2[i2])[0], point4[1]);
        } else {
          interpolate2(current.x, current.p.x, -1, stream2);
        }
        current = current.p;
      }
      current = current.o;
      points2 = current.z;
      isSubject = !isSubject;
    } while (!current.v);
    stream2.lineEnd();
  }
}
function link(array2) {
  if (!(n2 = array2.length))
    return;
  var n2, i2 = 0, a2 = array2[0], b2;
  while (++i2 < n2) {
    a2.n = b2 = array2[i2];
    b2.p = a2;
    a2 = b2;
  }
  a2.n = b2 = array2[0];
  b2.p = a2;
}
function ascending$2(a2, b2) {
  return a2 < b2 ? -1 : a2 > b2 ? 1 : a2 >= b2 ? 0 : NaN;
}
function bisector(compare12) {
  if (compare12.length === 1)
    compare12 = ascendingComparator(compare12);
  return {
    left: function(a2, x2, lo, hi) {
      if (lo == null)
        lo = 0;
      if (hi == null)
        hi = a2.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare12(a2[mid], x2) < 0)
          lo = mid + 1;
        else
          hi = mid;
      }
      return lo;
    },
    right: function(a2, x2, lo, hi) {
      if (lo == null)
        lo = 0;
      if (hi == null)
        hi = a2.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare12(a2[mid], x2) > 0)
          hi = mid;
        else
          lo = mid + 1;
      }
      return lo;
    }
  };
}
function ascendingComparator(f2) {
  return function(d2, x2) {
    return ascending$2(f2(d2), x2);
  };
}
bisector(ascending$2);
function merge$2(arrays) {
  var n2 = arrays.length, m2, i2 = -1, j2 = 0, merged, array2;
  while (++i2 < n2)
    j2 += arrays[i2].length;
  merged = new Array(j2);
  while (--n2 >= 0) {
    array2 = arrays[n2];
    m2 = array2.length;
    while (--m2 >= 0) {
      merged[--j2] = array2[m2];
    }
  }
  return merged;
}
var clipMax = 1e9, clipMin = -clipMax;
function clipExtent(x02, y02, x12, y12) {
  function visible(x2, y2) {
    return x02 <= x2 && x2 <= x12 && y02 <= y2 && y2 <= y12;
  }
  function interpolate2(from, to, direction, stream2) {
    var a2 = 0, a1 = 0;
    if (from == null || (a2 = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) {
      do
        stream2.point(a2 === 0 || a2 === 3 ? x02 : x12, a2 > 1 ? y12 : y02);
      while ((a2 = (a2 + direction + 4) % 4) !== a1);
    } else {
      stream2.point(to[0], to[1]);
    }
  }
  function corner(p2, direction) {
    return abs(p2[0] - x02) < epsilon$1 ? direction > 0 ? 0 : 3 : abs(p2[0] - x12) < epsilon$1 ? direction > 0 ? 2 : 1 : abs(p2[1] - y02) < epsilon$1 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
  }
  function compareIntersection2(a2, b2) {
    return comparePoint(a2.x, b2.x);
  }
  function comparePoint(a2, b2) {
    var ca2 = corner(a2, 1), cb2 = corner(b2, 1);
    return ca2 !== cb2 ? ca2 - cb2 : ca2 === 0 ? b2[1] - a2[1] : ca2 === 1 ? a2[0] - b2[0] : ca2 === 2 ? a2[1] - b2[1] : b2[0] - a2[0];
  }
  return function(stream2) {
    var activeStream = stream2, bufferStream = clipBuffer(), segments, polygon4, ring, x__, y__, v__, x_, y_, v_, first, clean;
    var clipStream = {
      point: point4,
      lineStart,
      lineEnd,
      polygonStart,
      polygonEnd
    };
    function point4(x2, y2) {
      if (visible(x2, y2))
        activeStream.point(x2, y2);
    }
    function polygonInside() {
      var winding = 0;
      for (var i2 = 0, n2 = polygon4.length; i2 < n2; ++i2) {
        for (var ring2 = polygon4[i2], j2 = 1, m2 = ring2.length, point5 = ring2[0], a0, a1, b0 = point5[0], b1 = point5[1]; j2 < m2; ++j2) {
          a0 = b0, a1 = b1, point5 = ring2[j2], b0 = point5[0], b1 = point5[1];
          if (a1 <= y12) {
            if (b1 > y12 && (b0 - a0) * (y12 - a1) > (b1 - a1) * (x02 - a0))
              ++winding;
          } else {
            if (b1 <= y12 && (b0 - a0) * (y12 - a1) < (b1 - a1) * (x02 - a0))
              --winding;
          }
        }
      }
      return winding;
    }
    function polygonStart() {
      activeStream = bufferStream, segments = [], polygon4 = [], clean = true;
    }
    function polygonEnd() {
      var startInside = polygonInside(), cleanInside = clean && startInside, visible2 = (segments = merge$2(segments)).length;
      if (cleanInside || visible2) {
        stream2.polygonStart();
        if (cleanInside) {
          stream2.lineStart();
          interpolate2(null, null, 1, stream2);
          stream2.lineEnd();
        }
        if (visible2) {
          clipPolygon(segments, compareIntersection2, startInside, interpolate2, stream2);
        }
        stream2.polygonEnd();
      }
      activeStream = stream2, segments = polygon4 = ring = null;
    }
    function lineStart() {
      clipStream.point = linePoint;
      if (polygon4)
        polygon4.push(ring = []);
      first = true;
      v_ = false;
      x_ = y_ = NaN;
    }
    function lineEnd() {
      if (segments) {
        linePoint(x__, y__);
        if (v__ && v_)
          bufferStream.rejoin();
        segments.push(bufferStream.result());
      }
      clipStream.point = point4;
      if (v_)
        activeStream.lineEnd();
    }
    function linePoint(x2, y2) {
      var v5 = visible(x2, y2);
      if (polygon4)
        ring.push([x2, y2]);
      if (first) {
        x__ = x2, y__ = y2, v__ = v5;
        first = false;
        if (v5) {
          activeStream.lineStart();
          activeStream.point(x2, y2);
        }
      } else {
        if (v5 && v_)
          activeStream.point(x2, y2);
        else {
          var a2 = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))], b2 = [x2 = Math.max(clipMin, Math.min(clipMax, x2)), y2 = Math.max(clipMin, Math.min(clipMax, y2))];
          if (clipLine(a2, b2, x02, y02, x12, y12)) {
            if (!v_) {
              activeStream.lineStart();
              activeStream.point(a2[0], a2[1]);
            }
            activeStream.point(b2[0], b2[1]);
            if (!v5)
              activeStream.lineEnd();
            clean = false;
          } else if (v5) {
            activeStream.lineStart();
            activeStream.point(x2, y2);
            clean = false;
          }
        }
      }
      x_ = x2, y_ = y2, v_ = v5;
    }
    return clipStream;
  };
}
var sum$1 = adder();
function polygonContains(polygon4, point4) {
  var lambda = point4[0], phi = point4[1], normal = [sin(lambda), -cos(lambda), 0], angle4 = 0, winding = 0;
  sum$1.reset();
  for (var i2 = 0, n2 = polygon4.length; i2 < n2; ++i2) {
    if (!(m2 = (ring = polygon4[i2]).length))
      continue;
    var ring, m2, point0 = ring[m2 - 1], lambda0 = point0[0], phi0 = point0[1] / 2 + quarterPi, sinPhi0 = sin(phi0), cosPhi0 = cos(phi0);
    for (var j2 = 0; j2 < m2; ++j2, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
      var point1 = ring[j2], lambda1 = point1[0], phi1 = point1[1] / 2 + quarterPi, sinPhi1 = sin(phi1), cosPhi1 = cos(phi1), delta = lambda1 - lambda0, sign2 = delta >= 0 ? 1 : -1, absDelta = sign2 * delta, antimeridian = absDelta > pi, k2 = sinPhi0 * sinPhi1;
      sum$1.add(atan2(k2 * sign2 * sin(absDelta), cosPhi0 * cosPhi1 + k2 * cos(absDelta)));
      angle4 += antimeridian ? delta + sign2 * tau : delta;
      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
        var arc = cartesianCross(cartesian(point0), cartesian(point1));
        cartesianNormalizeInPlace(arc);
        var intersection8 = cartesianCross(normal, arc);
        cartesianNormalizeInPlace(intersection8);
        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection8[2]);
        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
          winding += antimeridian ^ delta >= 0 ? 1 : -1;
        }
      }
    }
  }
  return (angle4 < -epsilon$1 || angle4 < epsilon$1 && sum$1 < -epsilon$1) ^ winding & 1;
}
adder();
function identity$9(x2) {
  return x2;
}
adder();
adder();
var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
var boundsStream = {
  point: boundsPoint,
  lineStart: noop$7,
  lineEnd: noop$7,
  polygonStart: noop$7,
  polygonEnd: noop$7,
  result: function() {
    var bounds = [[x0, y0], [x1, y1]];
    x1 = y1 = -(y0 = x0 = Infinity);
    return bounds;
  }
};
function boundsPoint(x2, y2) {
  if (x2 < x0)
    x0 = x2;
  if (x2 > x1)
    x1 = x2;
  if (y2 < y0)
    y0 = y2;
  if (y2 > y1)
    y1 = y2;
}
adder();
function clip(pointVisible, clipLine2, interpolate2, start2) {
  return function(rotate3, sink) {
    var line = clipLine2(sink), rotatedStart = rotate3.invert(start2[0], start2[1]), ringBuffer = clipBuffer(), ringSink = clipLine2(ringBuffer), polygonStarted = false, polygon4, segments, ring;
    var clip2 = {
      point: point4,
      lineStart,
      lineEnd,
      polygonStart: function() {
        clip2.point = pointRing;
        clip2.lineStart = ringStart;
        clip2.lineEnd = ringEnd;
        segments = [];
        polygon4 = [];
      },
      polygonEnd: function() {
        clip2.point = point4;
        clip2.lineStart = lineStart;
        clip2.lineEnd = lineEnd;
        segments = merge$2(segments);
        var startInside = polygonContains(polygon4, rotatedStart);
        if (segments.length) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          clipPolygon(segments, compareIntersection, startInside, interpolate2, sink);
        } else if (startInside) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          interpolate2(null, null, 1, sink);
          sink.lineEnd();
        }
        if (polygonStarted)
          sink.polygonEnd(), polygonStarted = false;
        segments = polygon4 = null;
      },
      sphere: function() {
        sink.polygonStart();
        sink.lineStart();
        interpolate2(null, null, 1, sink);
        sink.lineEnd();
        sink.polygonEnd();
      }
    };
    function point4(lambda, phi) {
      var point5 = rotate3(lambda, phi);
      if (pointVisible(lambda = point5[0], phi = point5[1]))
        sink.point(lambda, phi);
    }
    function pointLine(lambda, phi) {
      var point5 = rotate3(lambda, phi);
      line.point(point5[0], point5[1]);
    }
    function lineStart() {
      clip2.point = pointLine;
      line.lineStart();
    }
    function lineEnd() {
      clip2.point = point4;
      line.lineEnd();
    }
    function pointRing(lambda, phi) {
      ring.push([lambda, phi]);
      var point5 = rotate3(lambda, phi);
      ringSink.point(point5[0], point5[1]);
    }
    function ringStart() {
      ringSink.lineStart();
      ring = [];
    }
    function ringEnd() {
      pointRing(ring[0][0], ring[0][1]);
      ringSink.lineEnd();
      var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i2, n2 = ringSegments.length, m2, segment, point5;
      ring.pop();
      polygon4.push(ring);
      ring = null;
      if (!n2)
        return;
      if (clean & 1) {
        segment = ringSegments[0];
        if ((m2 = segment.length - 1) > 0) {
          if (!polygonStarted)
            sink.polygonStart(), polygonStarted = true;
          sink.lineStart();
          for (i2 = 0; i2 < m2; ++i2)
            sink.point((point5 = segment[i2])[0], point5[1]);
          sink.lineEnd();
        }
        return;
      }
      if (n2 > 1 && clean & 2)
        ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
      segments.push(ringSegments.filter(validSegment));
    }
    return clip2;
  };
}
function validSegment(segment) {
  return segment.length > 1;
}
function compareIntersection(a2, b2) {
  return ((a2 = a2.x)[0] < 0 ? a2[1] - halfPi - epsilon$1 : halfPi - a2[1]) - ((b2 = b2.x)[0] < 0 ? b2[1] - halfPi - epsilon$1 : halfPi - b2[1]);
}
const clipAntimeridian = clip(
  function() {
    return true;
  },
  clipAntimeridianLine,
  clipAntimeridianInterpolate,
  [-pi, -halfPi]
);
function clipAntimeridianLine(stream2) {
  var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean;
  return {
    lineStart: function() {
      stream2.lineStart();
      clean = 1;
    },
    point: function(lambda1, phi1) {
      var sign1 = lambda1 > 0 ? pi : -pi, delta = abs(lambda1 - lambda0);
      if (abs(delta - pi) < epsilon$1) {
        stream2.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
        stream2.point(sign0, phi0);
        stream2.lineEnd();
        stream2.lineStart();
        stream2.point(sign1, phi0);
        stream2.point(lambda1, phi0);
        clean = 0;
      } else if (sign0 !== sign1 && delta >= pi) {
        if (abs(lambda0 - sign0) < epsilon$1)
          lambda0 -= sign0 * epsilon$1;
        if (abs(lambda1 - sign1) < epsilon$1)
          lambda1 -= sign1 * epsilon$1;
        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
        stream2.point(sign0, phi0);
        stream2.lineEnd();
        stream2.lineStart();
        stream2.point(sign1, phi0);
        clean = 0;
      }
      stream2.point(lambda0 = lambda1, phi0 = phi1);
      sign0 = sign1;
    },
    lineEnd: function() {
      stream2.lineEnd();
      lambda0 = phi0 = NaN;
    },
    clean: function() {
      return 2 - clean;
    }
  };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
  var cosPhi0, cosPhi1, sinLambda0Lambda1 = sin(lambda0 - lambda1);
  return abs(sinLambda0Lambda1) > epsilon$1 ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1) - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream2) {
  var phi;
  if (from == null) {
    phi = direction * halfPi;
    stream2.point(-pi, phi);
    stream2.point(0, phi);
    stream2.point(pi, phi);
    stream2.point(pi, 0);
    stream2.point(pi, -phi);
    stream2.point(0, -phi);
    stream2.point(-pi, -phi);
    stream2.point(-pi, 0);
    stream2.point(-pi, phi);
  } else if (abs(from[0] - to[0]) > epsilon$1) {
    var lambda = from[0] < to[0] ? pi : -pi;
    phi = direction * lambda / 2;
    stream2.point(-lambda, phi);
    stream2.point(0, phi);
    stream2.point(lambda, phi);
  } else {
    stream2.point(to[0], to[1]);
  }
}
function clipCircle(radius, delta) {
  var cr = cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > epsilon$1;
  function interpolate2(from, to, direction, stream2) {
    circleStream(stream2, radius, delta, direction, from, to);
  }
  function visible(lambda, phi) {
    return cos(lambda) * cos(phi) > cr;
  }
  function clipLine2(stream2) {
    var point0, c0, v0, v00, clean;
    return {
      lineStart: function() {
        v00 = v0 = false;
        clean = 1;
      },
      point: function(lambda, phi) {
        var point1 = [lambda, phi], point22, v5 = visible(lambda, phi), c2 = smallRadius ? v5 ? 0 : code(lambda, phi) : v5 ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
        if (!point0 && (v00 = v0 = v5))
          stream2.lineStart();
        if (v5 !== v0) {
          point22 = intersect2(point0, point1);
          if (!point22 || pointEqual(point0, point22) || pointEqual(point1, point22)) {
            point1[0] += epsilon$1;
            point1[1] += epsilon$1;
            v5 = visible(point1[0], point1[1]);
          }
        }
        if (v5 !== v0) {
          clean = 0;
          if (v5) {
            stream2.lineStart();
            point22 = intersect2(point1, point0);
            stream2.point(point22[0], point22[1]);
          } else {
            point22 = intersect2(point0, point1);
            stream2.point(point22[0], point22[1]);
            stream2.lineEnd();
          }
          point0 = point22;
        } else if (notHemisphere && point0 && smallRadius ^ v5) {
          var t2;
          if (!(c2 & c0) && (t2 = intersect2(point1, point0, true))) {
            clean = 0;
            if (smallRadius) {
              stream2.lineStart();
              stream2.point(t2[0][0], t2[0][1]);
              stream2.point(t2[1][0], t2[1][1]);
              stream2.lineEnd();
            } else {
              stream2.point(t2[1][0], t2[1][1]);
              stream2.lineEnd();
              stream2.lineStart();
              stream2.point(t2[0][0], t2[0][1]);
            }
          }
        }
        if (v5 && (!point0 || !pointEqual(point0, point1))) {
          stream2.point(point1[0], point1[1]);
        }
        point0 = point1, v0 = v5, c0 = c2;
      },
      lineEnd: function() {
        if (v0)
          stream2.lineEnd();
        point0 = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return clean | (v00 && v0) << 1;
      }
    };
  }
  function intersect2(a2, b2, two) {
    var pa = cartesian(a2), pb = cartesian(b2);
    var n1 = [1, 0, 0], n2 = cartesianCross(pa, pb), n2n2 = cartesianDot(n2, n2), n1n2 = n2[0], determinant2 = n2n2 - n1n2 * n1n2;
    if (!determinant2)
      return !two && a2;
    var c1 = cr * n2n2 / determinant2, c2 = -cr * n1n2 / determinant2, n1xn2 = cartesianCross(n1, n2), A2 = cartesianScale(n1, c1), B2 = cartesianScale(n2, c2);
    cartesianAddInPlace(A2, B2);
    var u2 = n1xn2, w2 = cartesianDot(A2, u2), uu = cartesianDot(u2, u2), t2 = w2 * w2 - uu * (cartesianDot(A2, A2) - 1);
    if (t2 < 0)
      return;
    var t3 = sqrt(t2), q2 = cartesianScale(u2, (-w2 - t3) / uu);
    cartesianAddInPlace(q2, A2);
    q2 = spherical(q2);
    if (!two)
      return q2;
    var lambda0 = a2[0], lambda1 = b2[0], phi0 = a2[1], phi1 = b2[1], z2;
    if (lambda1 < lambda0)
      z2 = lambda0, lambda0 = lambda1, lambda1 = z2;
    var delta2 = lambda1 - lambda0, polar = abs(delta2 - pi) < epsilon$1, meridian = polar || delta2 < epsilon$1;
    if (!polar && phi1 < phi0)
      z2 = phi0, phi0 = phi1, phi1 = z2;
    if (meridian ? polar ? phi0 + phi1 > 0 ^ q2[1] < (abs(q2[0] - lambda0) < epsilon$1 ? phi0 : phi1) : phi0 <= q2[1] && q2[1] <= phi1 : delta2 > pi ^ (lambda0 <= q2[0] && q2[0] <= lambda1)) {
      var q1 = cartesianScale(u2, (-w2 + t3) / uu);
      cartesianAddInPlace(q1, A2);
      return [q2, spherical(q1)];
    }
  }
  function code(lambda, phi) {
    var r2 = smallRadius ? radius : pi - radius, code2 = 0;
    if (lambda < -r2)
      code2 |= 1;
    else if (lambda > r2)
      code2 |= 2;
    if (phi < -r2)
      code2 |= 4;
    else if (phi > r2)
      code2 |= 8;
    return code2;
  }
  return clip(visible, clipLine2, interpolate2, smallRadius ? [0, -radius] : [-pi, radius - pi]);
}
function transformer$1(methods2) {
  return function(stream2) {
    var s2 = new TransformStream();
    for (var key in methods2)
      s2[key] = methods2[key];
    s2.stream = stream2;
    return s2;
  };
}
function TransformStream() {
}
TransformStream.prototype = {
  constructor: TransformStream,
  point: function(x2, y2) {
    this.stream.point(x2, y2);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function fitExtent(projection2, extent2, object2) {
  var w2 = extent2[1][0] - extent2[0][0], h2 = extent2[1][1] - extent2[0][1], clip2 = projection2.clipExtent && projection2.clipExtent();
  projection2.scale(150).translate([0, 0]);
  if (clip2 != null)
    projection2.clipExtent(null);
  geoStream(object2, projection2.stream(boundsStream));
  var b2 = boundsStream.result(), k2 = Math.min(w2 / (b2[1][0] - b2[0][0]), h2 / (b2[1][1] - b2[0][1])), x2 = +extent2[0][0] + (w2 - k2 * (b2[1][0] + b2[0][0])) / 2, y2 = +extent2[0][1] + (h2 - k2 * (b2[1][1] + b2[0][1])) / 2;
  if (clip2 != null)
    projection2.clipExtent(clip2);
  return projection2.scale(k2 * 150).translate([x2, y2]);
}
function fitSize(projection2, size12, object2) {
  return fitExtent(projection2, [[0, 0], size12], object2);
}
var maxDepth = 16, cosMinDistance = cos(30 * radians$1);
function resample$1(project3, delta2) {
  return +delta2 ? resample$2(project3, delta2) : resampleNone(project3);
}
function resampleNone(project3) {
  return transformer$1({
    point: function(x2, y2) {
      x2 = project3(x2, y2);
      this.stream.point(x2[0], x2[1]);
    }
  });
}
function resample$2(project3, delta2) {
  function resampleLineTo(x02, y02, lambda0, a0, b0, c0, x12, y12, lambda1, a1, b1, c1, depth2, stream2) {
    var dx = x12 - x02, dy = y12 - y02, d2 = dx * dx + dy * dy;
    if (d2 > 4 * delta2 && depth2--) {
      var a2 = a0 + a1, b2 = b0 + b1, c2 = c0 + c1, m2 = sqrt(a2 * a2 + b2 * b2 + c2 * c2), phi2 = asin(c2 /= m2), lambda2 = abs(abs(c2) - 1) < epsilon$1 || abs(lambda0 - lambda1) < epsilon$1 ? (lambda0 + lambda1) / 2 : atan2(b2, a2), p2 = project3(lambda2, phi2), x2 = p2[0], y2 = p2[1], dx2 = x2 - x02, dy2 = y2 - y02, dz = dy * dx2 - dx * dy2;
      if (dz * dz / d2 > delta2 || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
        resampleLineTo(x02, y02, lambda0, a0, b0, c0, x2, y2, lambda2, a2 /= m2, b2 /= m2, c2, depth2, stream2);
        stream2.point(x2, y2);
        resampleLineTo(x2, y2, lambda2, a2, b2, c2, x12, y12, lambda1, a1, b1, c1, depth2, stream2);
      }
    }
  }
  return function(stream2) {
    var lambda00, x00, y00, a00, b00, c00, lambda0, x02, y02, a0, b0, c0;
    var resampleStream = {
      point: point4,
      lineStart,
      lineEnd,
      polygonStart: function() {
        stream2.polygonStart();
        resampleStream.lineStart = ringStart;
      },
      polygonEnd: function() {
        stream2.polygonEnd();
        resampleStream.lineStart = lineStart;
      }
    };
    function point4(x2, y2) {
      x2 = project3(x2, y2);
      stream2.point(x2[0], x2[1]);
    }
    function lineStart() {
      x02 = NaN;
      resampleStream.point = linePoint;
      stream2.lineStart();
    }
    function linePoint(lambda, phi) {
      var c2 = cartesian([lambda, phi]), p2 = project3(lambda, phi);
      resampleLineTo(x02, y02, lambda0, a0, b0, c0, x02 = p2[0], y02 = p2[1], lambda0 = lambda, a0 = c2[0], b0 = c2[1], c0 = c2[2], maxDepth, stream2);
      stream2.point(x02, y02);
    }
    function lineEnd() {
      resampleStream.point = point4;
      stream2.lineEnd();
    }
    function ringStart() {
      lineStart();
      resampleStream.point = ringPoint;
      resampleStream.lineEnd = ringEnd;
    }
    function ringPoint(lambda, phi) {
      linePoint(lambda00 = lambda, phi), x00 = x02, y00 = y02, a00 = a0, b00 = b0, c00 = c0;
      resampleStream.point = linePoint;
    }
    function ringEnd() {
      resampleLineTo(x02, y02, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream2);
      resampleStream.lineEnd = lineEnd;
      lineEnd();
    }
    return resampleStream;
  };
}
var transformRadians = transformer$1({
  point: function(x2, y2) {
    this.stream.point(x2 * radians$1, y2 * radians$1);
  }
});
function projection(project3) {
  return projectionMutator(function() {
    return project3;
  })();
}
function projectionMutator(projectAt) {
  var project3, k2 = 150, x2 = 480, y2 = 250, dx, dy, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate3, projectRotate, theta = null, preclip = clipAntimeridian, x02 = null, y02, x12, y12, postclip = identity$9, delta2 = 0.5, projectResample = resample$1(projectTransform, delta2), cache2, cacheStream;
  function projection2(point4) {
    point4 = projectRotate(point4[0] * radians$1, point4[1] * radians$1);
    return [point4[0] * k2 + dx, dy - point4[1] * k2];
  }
  function invert2(point4) {
    point4 = projectRotate.invert((point4[0] - dx) / k2, (dy - point4[1]) / k2);
    return point4 && [point4[0] * degrees$1, point4[1] * degrees$1];
  }
  function projectTransform(x3, y3) {
    return x3 = project3(x3, y3), [x3[0] * k2 + dx, dy - x3[1] * k2];
  }
  projection2.stream = function(stream2) {
    return cache2 && cacheStream === stream2 ? cache2 : cache2 = transformRadians(preclip(rotate3, projectResample(postclip(cacheStream = stream2))));
  };
  projection2.clipAngle = function(_2) {
    return arguments.length ? (preclip = +_2 ? clipCircle(theta = _2 * radians$1, 6 * radians$1) : (theta = null, clipAntimeridian), reset2()) : theta * degrees$1;
  };
  projection2.clipExtent = function(_2) {
    return arguments.length ? (postclip = _2 == null ? (x02 = y02 = x12 = y12 = null, identity$9) : clipExtent(x02 = +_2[0][0], y02 = +_2[0][1], x12 = +_2[1][0], y12 = +_2[1][1]), reset2()) : x02 == null ? null : [[x02, y02], [x12, y12]];
  };
  projection2.scale = function(_2) {
    return arguments.length ? (k2 = +_2, recenter()) : k2;
  };
  projection2.translate = function(_2) {
    return arguments.length ? (x2 = +_2[0], y2 = +_2[1], recenter()) : [x2, y2];
  };
  projection2.center = function(_2) {
    return arguments.length ? (lambda = _2[0] % 360 * radians$1, phi = _2[1] % 360 * radians$1, recenter()) : [lambda * degrees$1, phi * degrees$1];
  };
  projection2.rotate = function(_2) {
    return arguments.length ? (deltaLambda = _2[0] % 360 * radians$1, deltaPhi = _2[1] % 360 * radians$1, deltaGamma = _2.length > 2 ? _2[2] % 360 * radians$1 : 0, recenter()) : [deltaLambda * degrees$1, deltaPhi * degrees$1, deltaGamma * degrees$1];
  };
  projection2.precision = function(_2) {
    return arguments.length ? (projectResample = resample$1(projectTransform, delta2 = _2 * _2), reset2()) : sqrt(delta2);
  };
  projection2.fitExtent = function(extent2, object2) {
    return fitExtent(projection2, extent2, object2);
  };
  projection2.fitSize = function(size12, object2) {
    return fitSize(projection2, size12, object2);
  };
  function recenter() {
    projectRotate = compose(rotate3 = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project3);
    var center2 = project3(lambda, phi);
    dx = x2 - center2[0] * k2;
    dy = y2 + center2[1] * k2;
    return reset2();
  }
  function reset2() {
    cache2 = cacheStream = null;
    return projection2;
  }
  return function() {
    project3 = projectAt.apply(this, arguments);
    projection2.invert = project3.invert && invert2;
    return recenter();
  };
}
function azimuthalRaw(scale5) {
  return function(x2, y2) {
    var cx = cos(x2), cy = cos(y2), k2 = scale5(cx * cy);
    return [
      k2 * cy * sin(x2),
      k2 * sin(y2)
    ];
  };
}
function azimuthalInvert(angle4) {
  return function(x2, y2) {
    var z2 = sqrt(x2 * x2 + y2 * y2), c2 = angle4(z2), sc = sin(c2), cc2 = cos(c2);
    return [
      atan2(x2 * sc, z2 * cc2),
      asin(z2 && y2 * sc / z2)
    ];
  };
}
var azimuthalEquidistantRaw = azimuthalRaw(function(c2) {
  return (c2 = acos(c2)) && c2 / sin(c2);
});
azimuthalEquidistantRaw.invert = azimuthalInvert(function(z2) {
  return z2;
});
function geoAzimuthalEquidistant() {
  return projection(azimuthalEquidistantRaw).scale(79.4188).clipAngle(180 - 1e-3);
}
function equirectangularRaw(lambda, phi) {
  return [lambda, phi];
}
equirectangularRaw.invert = equirectangularRaw;
function buffer$1(geojson, radius, options2) {
  options2 = options2 || {};
  var units2 = options2.units || "kilometers";
  var steps = options2.steps || 8;
  if (!geojson)
    throw new Error("geojson is required");
  if (typeof options2 !== "object")
    throw new Error("options must be an object");
  if (typeof steps !== "number")
    throw new Error("steps must be an number");
  if (radius === void 0)
    throw new Error("radius is required");
  if (steps <= 0)
    throw new Error("steps must be greater than 0");
  var results = [];
  switch (geojson.type) {
    case "GeometryCollection":
      geomEach$3(geojson, function(geometry2) {
        var buffered = bufferFeature(geometry2, radius, units2, steps);
        if (buffered)
          results.push(buffered);
      });
      return featureCollection$6(results);
    case "FeatureCollection":
      featureEach$3(geojson, function(feature2) {
        var multiBuffered = bufferFeature(feature2, radius, units2, steps);
        if (multiBuffered) {
          featureEach$3(multiBuffered, function(buffered) {
            if (buffered)
              results.push(buffered);
          });
        }
      });
      return featureCollection$6(results);
  }
  return bufferFeature(geojson, radius, units2, steps);
}
function bufferFeature(geojson, radius, units2, steps) {
  var properties = geojson.properties || {};
  var geometry2 = geojson.type === "Feature" ? geojson.geometry : geojson;
  if (geometry2.type === "GeometryCollection") {
    var results = [];
    geomEach$3(geojson, function(geometry3) {
      var buffered2 = bufferFeature(geometry3, radius, units2, steps);
      if (buffered2)
        results.push(buffered2);
    });
    return featureCollection$6(results);
  }
  var projection2 = defineProjection(geometry2);
  var projected = {
    type: geometry2.type,
    coordinates: projectCoords(geometry2.coordinates, projection2)
  };
  var reader = new GeoJSONReader();
  var geom = reader.read(projected);
  var distance11 = radiansToLength$3(lengthToRadians$2(radius, units2), "meters");
  var buffered = BufferOp.bufferOp(geom, distance11, steps);
  var writer = new GeoJSONWriter();
  buffered = writer.write(buffered);
  if (coordsIsNaN(buffered.coordinates))
    return void 0;
  var result = {
    type: buffered.type,
    coordinates: unprojectCoords(buffered.coordinates, projection2)
  };
  return feature$a(result, properties);
}
function coordsIsNaN(coords) {
  if (Array.isArray(coords[0]))
    return coordsIsNaN(coords[0]);
  return isNaN(coords[0]);
}
function projectCoords(coords, proj) {
  if (typeof coords[0] !== "object")
    return proj(coords);
  return coords.map(function(coord) {
    return projectCoords(coord, proj);
  });
}
function unprojectCoords(coords, proj) {
  if (typeof coords[0] !== "object")
    return proj.invert(coords);
  return coords.map(function(coord) {
    return unprojectCoords(coord, proj);
  });
}
function defineProjection(geojson) {
  var coords = center(geojson).geometry.coordinates;
  var rotation = [-coords[0], -coords[1]];
  return geoAzimuthalEquidistant().rotate(rotation).scale(earthRadius$4);
}
const DEG2RAD$2 = Math.PI / 180;
const RAD2DEG$1 = 180 / Math.PI;
class CoordinateUtil {
  static degreeToRadian(angle4) {
    return DEG2RAD$2 * angle4;
  }
  static radianToDegree(angle4) {
    return RAD2DEG$1 * angle4;
  }
  static toLngLat(coord) {
    const array2 = CoordinateUtil.toArray(coord);
    if (!array2)
      return null;
    const [x2, y2, z2] = array2;
    const merc2 = new mapboxgl.MercatorCoordinate(x2, y2, z2);
    return merc2.toLngLat();
  }
  static toMercator(coord) {
    const array2 = CoordinateUtil.toArray(coord);
    if (!array2)
      return null;
    const [lng, lat, alt] = array2;
    if (lng && lat) {
      return mapboxgl.MercatorCoordinate.fromLngLat({
        lng,
        lat
      }, alt || 0);
    }
    return null;
  }
  static toArray(coord) {
    if (!coord)
      return null;
    let x2 = null;
    let y2 = null;
    let z2 = null;
    if (Array.isArray(coord)) {
      x2 = coord[0];
      y2 = coord[1];
      z2 = coord[2];
    } else if (typeof coord === "object") {
      x2 = coord.longitude || coord.lng || coord.x;
      y2 = coord.latitude || coord.lat || coord.y;
      z2 = coord.elevation || coord.altitude || coord.z;
    }
    return [x2, y2, z2];
  }
}
const NESTED_SEPARATOR = "/";
class GeoUtil {
  static getGeoJson(object2) {
    const type = object2 == null ? void 0 : object2.type;
    if (!type || type === "FeatureCollection")
      return object2;
    if (type === "Feature") {
      return {
        type: "FeatureCollection",
        features: [object2]
      };
    }
    if (GeoUtil.isGeometry(type)) {
      return {
        type: "FeatureCollection",
        features: [{
          type: "Feature",
          geometry: object2,
          properties: {}
        }]
      };
    }
    console.error("Unsupported GeoJson type", type);
    return object2;
  }
  static getFeature(object2) {
    var _a3, _b3;
    if (!object2)
      return object2;
    const type = object2 == null ? void 0 : object2.type;
    if (type === "FeatureCollection") {
      if (((_a3 = object2.features) == null ? void 0 : _a3.length) > 1) {
        console.error("Ignoring features other than first in the FeatureCollection");
      }
      return (_b3 = object2.features) == null ? void 0 : _b3[0];
    }
    if (type === "Feature") {
      return object2;
    }
    if (GeoUtil.isGeometry(type)) {
      return {
        type: "Feature",
        geometry: object2,
        properties: {}
      };
    }
    console.error("Unsupported GeoJson type", type);
    return object2;
  }
  static isGeometry(object2) {
    const type = typeof object2 === "string" ? object2 : object2 == null ? void 0 : object2.type;
    const geometryTypes2 = ["Polygon", "MultiPolygon", "Point", "LineString", "MultiLineString", "GeometryCollection"];
    return geometryTypes2.includes(type);
  }
  static getGeometry(object2) {
    var _a3;
    if (GeoUtil.isGeometry(object2))
      return object2;
    return (_a3 = GeoUtil.getFeature(object2)) == null ? void 0 : _a3.geometry;
  }
  static getCuratedGeometry(object2) {
    let geometry2 = GeoUtil.getGeometry(object2);
    if (!geometry2)
      return null;
    if (["Point", "LineString", "Polygon"].includes(geometry2.type))
      return geometry2;
    geometry2 = GeoUtil.getPolygon(geometry2);
    if (geometry2)
      return geometry2;
    return GeoUtil.getLineString(geometry2);
  }
  static getProjectedGeoJson(geojson, projection2 = (coord) => coord) {
    if (!geojson)
      return geojson;
    let features = [];
    if (geojson.type === "Feature") {
      features = [geojson];
    } else if (geojson.type === "FeatureCollection") {
      features = geojson.features;
    }
    let hasInvalid = false;
    const transformPoint2 = (coord) => {
      const coordinates2 = projection2(coord);
      const invalidateCoord = (x2, limit) => Number.isNaN(x2) || !Number.isFinite(x2) || x2 < -limit || x2 > limit;
      const longitude = coordinates2[0];
      const latitude = coordinates2[1];
      if (invalidateCoord(longitude, 180) || invalidateCoord(latitude, 90)) {
        console.warn("Invalid coordinates found");
        hasInvalid = true;
        return null;
      }
      return coordinates2;
    };
    const validFeatures = [];
    features.forEach((feature2) => {
      hasInvalid = false;
      switch (feature2.geometry.type) {
        case "Point":
          feature2.geometry.coordinates = transformPoint2(feature2.geometry.coordinates);
          break;
        case "LineString":
          feature2.geometry.coordinates = feature2.geometry.coordinates.map(transformPoint2);
          break;
        case "Polygon":
          feature2.geometry.coordinates = feature2.geometry.coordinates.map((loop2) => loop2.map(transformPoint2));
          break;
        case "MultiLineString":
          feature2.geometry.coordinates = feature2.geometry.coordinates.map((loop2) => loop2.map(transformPoint2));
          break;
        case "MultiPolygon":
          feature2.geometry.coordinates = feature2.geometry.coordinates.map((polygon4) => polygon4.map((loop2) => loop2.map(transformPoint2)));
          break;
        default:
          console.warn("Unsupported type", feature2.geometry.type);
          break;
      }
      if (!hasInvalid) {
        validFeatures.push(feature2);
      }
    });
    if (geojson.type === "Feature") {
      return validFeatures[0];
    }
    if (geojson.type === "FeatureCollection") {
      geojson.features = validFeatures;
      return geojson;
    }
    return null;
  }
  static getCuratedGeojson(geojson) {
    if (!geojson)
      return null;
    let collection = geojson;
    if (geojson.type === "Feature") {
      collection = {
        type: "FeatureCollection",
        features: [geojson]
      };
    } else if (geojson.type !== "FeatureCollection") {
      return null;
    }
    const features = [];
    collection.features.forEach((feature2) => {
      var _a3;
      const type = (_a3 = feature2.geometry) == null ? void 0 : _a3.type;
      if (!type)
        return;
      let geometries = null;
      if (["Point", "LineString", "Polygon"].includes(type)) {
        features.push(feature2);
        return;
      }
      if (type === "MultiPolygon") {
        geometries = GeoUtil.getPolygons(feature2.geometry);
      } else if (type === "GeometryCollection") {
        console.warn("skipping GeometryCollection");
        return;
      } else if (type === "MultiLineString") {
        geometries = GeoUtil.getLineStrings(feature2.geometry);
      }
      geometries == null ? void 0 : geometries.forEach((geometry2) => {
        if (geometry2) {
          features.push({
            type: "Feature",
            geometry: geometry2,
            properties: {
              ...feature2.properties
            }
          });
        }
      });
    });
    if (!features.length)
      return null;
    collection.features = features;
    return collection;
  }
  static getPolygon(object2) {
    const geometry2 = GeoUtil.getGeometry(object2);
    if ((geometry2 == null ? void 0 : geometry2.type) === "Polygon")
      return geometry2;
    if ((geometry2 == null ? void 0 : geometry2.type) === "MultiPolygon") {
      const polygons2 = GeoUtil.getPolygons(object2);
      if (polygons2.length > 1) {
        console.warn("Ignoring other Polygon(s) in MultiPolygon");
        const [maxLenIndex] = polygons2.reduce((previous, current, index2) => {
          const len2 = GeoUtil.length(current);
          if (!previous || previous[1] < len2)
            return [index2, len2];
          return previous;
        }, null);
        if (maxLenIndex > -1)
          return polygons2 == null ? void 0 : polygons2[maxLenIndex];
      } else if (polygons2.length === 1) {
        return polygons2[0];
      }
    }
    return null;
  }
  static getPolygons(object2) {
    var _a3;
    const geometry2 = GeoUtil.getGeometry(object2);
    if (!geometry2)
      return null;
    if (geometry2.type === "Polygon")
      return [geometry2];
    if (geometry2.type === "MultiPolygon") {
      const polygons2 = [];
      (_a3 = geometry2.coordinates) == null ? void 0 : _a3.forEach((loop2) => {
        const poly2 = {
          type: "Polygon",
          coordinates: [...loop2]
        };
        polygons2.push(poly2);
      });
      if (polygons2.length > 0)
        return polygons2;
    }
    return null;
  }
  static getLineStrings(object2) {
    var _a3;
    const geometry2 = GeoUtil.getGeometry(object2);
    if (!geometry2)
      return null;
    if (geometry2.type === "LineString")
      return [geometry2];
    if (geometry2.type === "Polygon" || geometry2.type === "MultiLineString") {
      const lineStrings2 = [];
      (_a3 = geometry2.coordinates) == null ? void 0 : _a3.forEach((loop2) => {
        const line = {
          type: "LineString",
          coordinates: [...loop2]
        };
        lineStrings2.push(line);
      });
      if (lineStrings2.length > 0)
        return lineStrings2;
    }
    return null;
  }
  static getLineString(object2) {
    const lineStrings2 = GeoUtil.getLineStrings(object2);
    if (!lineStrings2 || lineStrings2.length === 0)
      return null;
    if (lineStrings2.length > 1)
      console.warn("Ignoring other LineString(s)");
    return lineStrings2[0];
  }
  static getTurfCircle(center2, radiusInMeter = 5, steps = 10) {
    const options2 = {
      steps,
      units: "kilometers"
    };
    return circle$4(center2, radiusInMeter * 1e-3, options2);
  }
  static isPointInsidePolygon(coord, geometry2) {
    const feature2 = GeoUtil.getTurfPolygon(GeoUtil.getPolygon(geometry2));
    return booleanPointInPolygon$2(GeoUtil.getTurfPoint(coord), feature2);
  }
  static isPolygonIntersectingAnyPolygons(geometry2, geometryArray) {
    const feature2 = GeoUtil.getTurfPolygon(GeoUtil.getPolygon(geometry2));
    for (let i2 = 0; i2 < geometryArray.length; i2 += 1) {
      const geom = GeoUtil.getTurfPolygon(GeoUtil.getPolygon(geometryArray[i2]));
      if (booleanIntersects(geom, feature2))
        return true;
    }
    return false;
  }
  static isPolygonIntersectingAllPoints(geometry2, points2) {
    const feature2 = GeoUtil.getTurfPolygon(GeoUtil.getPolygon(geometry2));
    for (let i2 = 0; i2 < points2.length; i2 += 1) {
      const geom = GeoUtil.getTurfCircle(points2[i2]);
      if (!booleanIntersects(geom, feature2))
        return false;
    }
    return true;
  }
  static getMatchingFeatureFromTracePoints(object2, points2) {
    const json = GeoUtil.getGeoJson(object2);
    for (let i2 = 0; i2 < (json == null ? void 0 : json.features.length); i2 += 1) {
      if (GeoUtil.isPolygonIntersectingAllPoints(json.features[i2], points2))
        return json.features[i2];
    }
    return null;
  }
  static isPolygonInsidePolygon(polygon4, geometry2) {
    const feature2 = GeoUtil.getTurfPolygon(GeoUtil.getPolygon(geometry2));
    return GeoUtil.getPolygon(polygon4).coordinates[0].every((coord) => booleanPointInPolygon$2(GeoUtil.getTurfPoint(coord), feature2));
  }
  static getTurfPoint(coord) {
    return point$5(coord);
  }
  static getTurfPolygon(object2) {
    if (!object2)
      return null;
    const geometry2 = GeoUtil.getGeometry(object2);
    if (!geometry2 || geometry2.type !== "Polygon" || !geometry2.coordinates)
      return null;
    return polygon$3(geometry2.coordinates);
  }
  static intersectRadially(coord, polygons2, distance11 = 100, theta = 5) {
    const createLine = (point4, distance12, azimuth, options2) => {
      const offsetPoint = transformTranslate(point4, distance12, azimuth, options2);
      return lineString$5([point4.geometry.coordinates, offsetPoint.geometry.coordinates]);
    };
    const tPolygons = polygons2.map((polygon4) => GeoUtil.getTurfPolygon(polygon4));
    const tPoint = GeoUtil.getTurfPoint(coord);
    const result = [];
    let angle4 = 0;
    while (angle4 < 360) {
      const tLine = createLine(tPoint, distance11, angle4);
      const intersections = [];
      tPolygons.forEach((tPolygon) => {
        const intersects7 = lineIntersect$2(tLine, tPolygon).features;
        if (intersects7)
          intersections.push(...intersects7);
      });
      if (intersections.length) {
        let nearestIntersection = null;
        let nearestIntersectionDistance = 0;
        intersections.forEach((feature2) => {
          const distance12 = distance$5(tPoint, feature2);
          if (!nearestIntersection || distance12 < nearestIntersectionDistance) {
            nearestIntersection = feature2.geometry.coordinates;
            nearestIntersectionDistance = distance12;
          }
        });
        result.push({
          angle: angle4,
          point: nearestIntersection,
          distance: nearestIntersectionDistance
        });
      }
      angle4 += theta;
    }
    return result;
  }
  static thicken(feature2, radiusInMeter, retainFeatureAttributes = true) {
    let polygon4 = null;
    const radiusInKm = radiusInMeter / 1e3;
    if (feature2.geometry.type === "LineString" || feature2.geometry.type === "Point") {
      polygon4 = buffer$1(feature2, radiusInKm, {
        units: "kilometers"
      });
    } else if (feature2.geometry.type === "Polygon") {
      const boundaryLine = index$2(feature2);
      polygon4 = buffer$1(boundaryLine, radiusInKm, {
        units: "kilometers"
      });
    }
    if (retainFeatureAttributes) {
      polygon4 = {
        ...feature2,
        geometry: polygon4.geometry
      };
    }
    return polygon4;
  }
  static length(object2) {
    const json = GeoUtil.getGeoJson(object2);
    const lineFeatures = [];
    json == null ? void 0 : json.features.forEach((feature2) => {
      const lines = GeoUtil.getLineStrings(feature2.geometry);
      lines == null ? void 0 : lines.forEach((l2) => {
        lineFeatures.push(GeoUtil.getFeature(l2));
      });
    });
    const lineCollection = GeoUtil.getGeoJson({
      type: "FeatureCollection",
      features: lineFeatures
    });
    return length$5(lineCollection, {
      units: "kilometers"
    }) * 1e3;
  }
  static distance(coord1, coord2) {
    const tPoint1 = GeoUtil.getTurfPoint(coord1);
    const tPoint2 = GeoUtil.getTurfPoint(coord2);
    const distance11 = distance$5(tPoint1, tPoint2, {
      units: "kilometers"
    }) * 1e3;
    return distance11;
  }
  static area(object2) {
    const json = GeoUtil.getGeoJson(object2);
    return area$3(json);
  }
  static centroid(object2) {
    try {
      const json = GeoUtil.getGeoJson(object2);
      return centroid(json);
    } catch (error2) {
      console.error(error2);
    }
    return null;
  }
  static unFlattenedProperties(object2) {
    return Object.keys(object2).reduce((res, fullKey) => {
      fullKey.split(NESTED_SEPARATOR).reduce((obj, splitKey, index2, splittedKeys) => {
        let value = obj[splitKey];
        if (value)
          return value;
        if (Number.isNaN(Number(splittedKeys[index2 + 1]))) {
          if (splittedKeys.length - 1 === index2) {
            value = object2[fullKey];
          } else {
            value = {};
          }
        } else {
          value = [];
        }
        obj[splitKey] = value;
        return value;
      }, res);
      return res;
    }, {});
  }
  static flattenedProperties(object2, parentKey, skipKnown, knownProperties) {
    if (!object2)
      return [];
    const flattened = [];
    Object.entries(object2).forEach(([key, value]) => {
      if (skipKnown && (knownProperties == null ? void 0 : knownProperties.includes(key)))
        return;
      if (typeof value === "undefined")
        return;
      if (typeof value !== "number" && !value)
        return;
      const fullKey = parentKey ? parentKey + NESTED_SEPARATOR + key : key;
      if (typeof value !== "object") {
        flattened.push({
          key: fullKey,
          value
        });
      } else {
        const more = GeoUtil.flattenedProperties(value, fullKey, skipKnown, knownProperties);
        flattened.push(...more);
      }
    });
    return flattened;
  }
  static getBoundingBox(object2) {
    const json = GeoUtil.getGeoJson(object2);
    return bbox$3(json);
  }
  static computeRectangle(coordinates2) {
    if (!coordinates2)
      return null;
    let west;
    let east;
    let south;
    let north;
    coordinates2.forEach((coord, index2) => {
      const [lng, lat] = coord;
      if (index2) {
        if (lng < west)
          west = lng;
        if (lng > east)
          east = lng;
        if (lat < south)
          south = lat;
        if (lat > north)
          north = lat;
      } else {
        west = lng;
        east = lng;
        south = lat;
        north = lat;
      }
    });
    return [west, south, east, north];
  }
  static combineRectangles(rectangles) {
    if (!(rectangles == null ? void 0 : rectangles.length))
      return null;
    if (rectangles.length === 1) {
      return rectangles[0];
    }
    let west;
    let east;
    let south;
    let north;
    rectangles.forEach((rect, index2) => {
      const [w2, s2, e3, n2] = rect;
      if (index2) {
        if (w2 < west)
          west = w2;
        if (e3 > east)
          east = e3;
        if (s2 < south)
          south = s2;
        if (n2 > north)
          north = n2;
      } else {
        west = w2;
        east = e3;
        south = s2;
        north = n2;
      }
    });
    return [west, south, east, north];
  }
  static performScaling(object2, scale5 = [1, 1], anchor = null) {
    var _a3, _b3;
    const geojson = GeoUtil.getGeoJson(object2);
    if (!geojson)
      return null;
    const centerCoords = (_b3 = (_a3 = GeoUtil.centroid(geojson)) == null ? void 0 : _a3.geometry) == null ? void 0 : _b3.coordinates;
    if (!centerCoords)
      return null;
    const centerMercArray = CoordinateUtil.toArray(CoordinateUtil.toMercator(centerCoords));
    const anchorMercArray = anchor ? CoordinateUtil.toArray(CoordinateUtil.toMercator(anchor)) : centerMercArray;
    featureEach$3(geojson, (feature2) => {
      coordEach(feature2, (coord) => {
        if (coord.visited)
          return;
        coord.visited = true;
        const point4 = CoordinateUtil.toArray(CoordinateUtil.toMercator(coord));
        point4[0] = centerMercArray[0] + scale5[0] * (point4[0] - centerMercArray[0]) + (anchorMercArray[0] - centerMercArray[0]);
        point4[1] = centerMercArray[1] + scale5[1] * (point4[1] - centerMercArray[1]) + (anchorMercArray[1] - centerMercArray[1]);
        const tmpCoord = CoordinateUtil.toArray(CoordinateUtil.toLngLat(point4));
        coord[0] = tmpCoord[0];
        coord[1] = tmpCoord[1];
      });
    });
    featureEach$3(geojson, (feature2) => {
      coordEach(feature2, (coord) => {
        delete coord.visited;
      });
    });
    return geojson;
  }
  static getAngleBetweenRefLines(fromRefLine, toRefLine, angleInRadian = true) {
    if (!(fromRefLine == null ? void 0 : fromRefLine.startPoint) || !(fromRefLine == null ? void 0 : fromRefLine.endPoint) || !(toRefLine == null ? void 0 : toRefLine.startPoint) || !(toRefLine == null ? void 0 : toRefLine.endPoint))
      return null;
    const snapPoints = [fromRefLine.startPoint, fromRefLine.endPoint, toRefLine.startPoint, toRefLine.endPoint];
    const mercArray = snapPoints == null ? void 0 : snapPoints.map((xyz) => CoordinateUtil.toArray(CoordinateUtil.toMercator(xyz)));
    const [leftStartCoord, leftEndCoord, rightStartCoord, rightEndCoord] = mercArray;
    const fromVec = [leftEndCoord[0] - leftStartCoord[0], leftEndCoord[1] - leftStartCoord[1]];
    const toVec = [rightEndCoord[0] - rightStartCoord[0], rightEndCoord[1] - rightStartCoord[1]];
    const magFromVec = (fromVec[0] ** 2 + fromVec[1] ** 2) ** 0.5;
    const magToVec = (toVec[0] ** 2 + toVec[1] ** 2) ** 0.5;
    let angleR = Math.acos((fromVec[0] * toVec[0] + fromVec[1] * toVec[1]) / (magFromVec * magToVec));
    const cross2 = fromVec[0] * toVec[1] - fromVec[1] * toVec[0];
    angleR = cross2 >= 0 ? angleR : 2 * Math.PI - angleR;
    if (angleInRadian)
      return angleR;
    return angleR * 180 / Math.PI;
  }
  static performPlacing(object2, fromRefLine, toRefLine) {
    const geojson = GeoUtil.getGeoJson(object2);
    if (!geojson || !(fromRefLine == null ? void 0 : fromRefLine.startPoint) || !(fromRefLine == null ? void 0 : fromRefLine.endPoint) || !(toRefLine == null ? void 0 : toRefLine.startPoint) || !(toRefLine == null ? void 0 : toRefLine.endPoint))
      return null;
    const snapPoints = [fromRefLine.startPoint, fromRefLine.endPoint, toRefLine.startPoint, toRefLine.endPoint];
    const mercArray = snapPoints == null ? void 0 : snapPoints.map((xyz) => CoordinateUtil.toArray(CoordinateUtil.toMercator(xyz)));
    const [leftStartCoord, _2, rightStartCoord] = mercArray;
    const angleR = GeoUtil.getAngleBetweenRefLines(fromRefLine, toRefLine);
    const scaledP0 = [leftStartCoord[0], leftStartCoord[1]];
    const transformCoord = (lngLat) => {
      const scaledCoord = CoordinateUtil.toArray(CoordinateUtil.toMercator(lngLat));
      const localCoord = [scaledCoord[0] - scaledP0[0], scaledCoord[1] - scaledP0[1]];
      const localRotatedCoord = [localCoord[0] * Math.cos(angleR) - localCoord[1] * Math.sin(angleR), localCoord[0] * Math.sin(angleR) + localCoord[1] * Math.cos(angleR)];
      const translatedCoord = [localRotatedCoord[0] + rightStartCoord[0], localRotatedCoord[1] + rightStartCoord[1]];
      const newCoord = CoordinateUtil.toArray(CoordinateUtil.toLngLat(translatedCoord));
      return [newCoord[0], newCoord[1]];
    };
    featureEach$3(geojson, (feature2) => {
      coordEach(feature2, (coord) => {
        if (coord.visited)
          return;
        coord.visited = true;
        const newCoord = transformCoord(coord);
        coord[0] = newCoord[0];
        coord[1] = newCoord[1];
      });
    });
    featureEach$3(geojson, (feature2) => {
      coordEach(feature2, (coord) => {
        delete coord.visited;
      });
    });
    if (geojson.features.length === 1 && object2.type === "Feature")
      return geojson.features[0];
    return geojson;
  }
  static midpoint(startCoord, endCoord) {
    try {
      const tStart = GeoUtil.getTurfPoint(startCoord);
      const tEnd = GeoUtil.getTurfPoint(endCoord);
      return midpoint$1(tStart, tEnd).geometry.coordinates;
    } catch (error2) {
      console.error(error2);
    }
    return null;
  }
  static destination(startCoord, distanceInM, bearing2) {
    var _a3, _b3;
    try {
      const distanceInKm = distanceInM / 1e3;
      const tStart = GeoUtil.getTurfPoint(startCoord);
      return (_b3 = (_a3 = destination$3(tStart, distanceInKm, bearing2, {
        units: "kilometers"
      })) == null ? void 0 : _a3.geometry) == null ? void 0 : _b3.coordinates;
    } catch (error2) {
      console.error(error2);
    }
    return null;
  }
  static booleanOverlap(pt1, pt2) {
    return booleanOverlap(pt1, pt2);
  }
  static getAzimuth(coord1, coord2) {
    const point1 = point$5(coord1);
    const point22 = point$5(coord2);
    const bearing2 = bearing$2(point1, point22);
    const azimuth = bearingToAzimuth$1(bearing2);
    return azimuth;
  }
}
const DEFAULT_VISIBLE_PROPERTY_KEYS = [];
const COLLECTION_TYPES = ["country", "region", "market", "cluster", "venue", "building", "level", "zone", "orphan"];
const REGION_PARENTS = ["country"];
const MARKET_PARENTS = ["country", "region"];
const CLUSTER_PARENTS = ["country", "region", "market"];
const VENUE_PARENTS = ["country", "region", "market", "cluster"];
const BUILDING_PARENTS = ["venue"];
const LEVEL_PARENTS = ["building"];
const ACCESS_POINT_PARENTS = ["level", "venue", "cluster"];
const ZONE_PARENTS = ["level", "venue", "cluster"];
const parentType2CollectionName = (parentType) => parentType === "country" ? "countries" : `${parentType}s`;
const parentType2ParentIdName = (parentType) => `${parentType}Id`;
class SiteStoreHelper {
  static getObjectDetail(idOrItem, collectionTypeIn, state) {
    var _a3, _b3, _c2, _d2, _e2;
    if (!idOrItem)
      return {};
    let collectionItem = idOrItem;
    let collectionType = collectionTypeIn;
    if (typeof idOrItem === "string") {
      const found = SiteStoreHelper.getObjectById(idOrItem, false, state);
      collectionItem = found.collectionItem;
      collectionType = found.collectionType;
    } else {
      collectionType = collectionTypeIn || (collectionItem == null ? void 0 : collectionItem.collectionType) || (collectionItem == null ? void 0 : collectionItem.type);
    }
    if (!collectionType || !collectionItem)
      return {};
    let center2 = collectionItem == null ? void 0 : collectionItem.center;
    if (!center2 && ((_a3 = collectionItem == null ? void 0 : collectionItem.features) == null ? void 0 : _a3.length)) {
      try {
        const geojson = {
          type: "FeatureCollection",
          features: collectionItem.features
        };
        center2 = (_c2 = (_b3 = GeoUtil.centroid(geojson)) == null ? void 0 : _b3.geometry) == null ? void 0 : _c2.coordinates;
      } catch (error2) {
        console.error(error2);
      }
    }
    const info = {
      center: center2 || (state == null ? void 0 : state.defaultCenter),
      collectionItem,
      collectionType
    };
    if (collectionType === "orphan") {
      info.orphanId = collectionItem.id;
    } else {
      const items = [collectionItem];
      if (["level", "zone"].includes(collectionType)) {
        const levelId = info.levelId || collectionItem.levelId;
        if (collectionType === "zone" && levelId) {
          const level = (_d2 = state == null ? void 0 : state.levels) == null ? void 0 : _d2.find((l2) => levelId === l2.id);
          if (level) {
            items.push(level);
            info.levelId = level.id;
            info.buildingId = level.buildingId;
          }
        }
        const buildingId = info.buildingId || collectionItem.buildingId;
        if (buildingId) {
          const building = (_e2 = state == null ? void 0 : state.buildings) == null ? void 0 : _e2.find((b2) => buildingId === b2.id);
          if (building) {
            items.push(building);
            info.buildingId = building.id;
            if (collectionType === "level") {
              info.center = building.center;
            }
          }
        }
      }
      COLLECTION_TYPES.some((parentType) => {
        if (parentType === "orphan")
          return false;
        const parentIdKey = parentType2ParentIdName(parentType);
        if (parentType === collectionType) {
          info[parentIdKey] = collectionItem.id;
          return true;
        }
        items.some((item) => {
          var _a4, _b4, _c3;
          info[parentIdKey] = item[parentIdKey] || ((_c3 = (_b4 = (_a4 = item == null ? void 0 : item.features) == null ? void 0 : _a4[0]) == null ? void 0 : _b4.properties) == null ? void 0 : _c3[parentIdKey]);
          return !!info[parentIdKey];
        });
        return false;
      });
    }
    return info;
  }
  static getObjectById(featureId, detailed, state, seed = {}) {
    if (!featureId)
      return {};
    let found = null;
    const {
      parentType: objectType,
      parentId: objectId
    } = seed || {};
    COLLECTION_TYPES.some((parentType) => {
      if (objectType && parentType !== objectType)
        return !!found;
      const collectionName = parentType2CollectionName(parentType);
      const collection = state == null ? void 0 : state[collectionName];
      collection == null ? void 0 : collection.some((item) => {
        var _a3;
        if (objectId && item.id !== objectId)
          return !!found;
        if (item.id === featureId) {
          found = {
            collectionType: parentType,
            collectionItem: item
          };
        } else {
          const theFoundIndex = (_a3 = item == null ? void 0 : item.indices) == null ? void 0 : _a3[featureId];
          if (theFoundIndex >= 0) {
            found = {
              feature: item.features[theFoundIndex],
              collectionType: parentType,
              collectionItem: item
            };
          }
        }
        return !!found;
      });
      return !!found;
    });
    if (found && detailed) {
      found = {
        ...found,
        ...SiteStoreHelper.getObjectDetail(found.collectionItem, found.collectionType, state)
      };
    }
    return found || {};
  }
  static getAllSiteFeatures(state) {
    const features = [];
    COLLECTION_TYPES.forEach((parentType) => {
      const collectionName = parentType2CollectionName(parentType);
      const collection = state == null ? void 0 : state[collectionName];
      collection == null ? void 0 : collection.forEach((item) => {
        pushArray(features, item == null ? void 0 : item.features);
      });
    });
    return features;
  }
  static getObjectFeatures(idOrItem, collectionTypeIn, recursive, state) {
    var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h, _i;
    const item = SiteStoreHelper.getObjectDetail(idOrItem, collectionTypeIn, state);
    let {
      collectionItem,
      collectionType,
      countryId,
      marketId,
      clusterId,
      regionId,
      venueId,
      buildingId,
      zoneId
    } = item;
    if (!collectionItem)
      return {};
    const features = [];
    if (collectionType === "zone") {
      if (!zoneId && collectionTypeIn === "zone")
        zoneId = collectionItem == null ? void 0 : collectionItem.id;
      collectionItem = (_a3 = SiteStoreHelper.getObjectDetail(zoneId, collectionType, state)) == null ? void 0 : _a3.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = recursive ? "level" : "";
    }
    if (collectionType === "level") {
      pushArray(features, collectionItem.features);
      collectionType = recursive ? "building" : "";
    }
    if (collectionType === "building") {
      if (!buildingId && collectionTypeIn === "building")
        buildingId = collectionItem == null ? void 0 : collectionItem.id;
      collectionItem = (_b3 = SiteStoreHelper.getObjectDetail(buildingId, collectionType, state)) == null ? void 0 : _b3.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = recursive ? "venue" : "";
    }
    if (collectionType === "venue") {
      if (!venueId && collectionTypeIn === "venue")
        venueId = collectionItem == null ? void 0 : collectionItem.id;
      collectionItem = (_c2 = SiteStoreHelper.getObjectDetail(venueId, collectionType, state)) == null ? void 0 : _c2.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = recursive ? "cluster" : "";
    }
    if (collectionType === "cluster") {
      if (!clusterId && collectionTypeIn === "cluster")
        clusterId = collectionItem == null ? void 0 : collectionItem.id;
      collectionItem = (_d2 = SiteStoreHelper.getObjectDetail(clusterId, collectionType, state)) == null ? void 0 : _d2.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = recursive ? "market" : "";
    }
    if (collectionType === "market") {
      if (!marketId && collectionTypeIn === "market")
        marketId = collectionItem == null ? void 0 : collectionItem.id;
      collectionItem = (_e2 = SiteStoreHelper.getObjectDetail(marketId, collectionType, state)) == null ? void 0 : _e2.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = recursive ? "region" : "";
    }
    if (collectionType === "region") {
      if (!regionId && collectionTypeIn === "region")
        regionId = collectionItem == null ? void 0 : collectionItem.id;
      collectionItem = (_f3 = SiteStoreHelper.getObjectDetail(regionId, collectionType, state)) == null ? void 0 : _f3.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = recursive ? "country" : "";
    }
    if (collectionType === "country") {
      if (!countryId && collectionTypeIn === "country")
        countryId = collectionItem == null ? void 0 : collectionItem.id;
      collectionItem = (_g = SiteStoreHelper.getObjectDetail(countryId, collectionType, state)) == null ? void 0 : _g.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = recursive ? "orphan" : "";
    }
    if (collectionType === "orphan") {
      collectionItem = (_i = SiteStoreHelper.getObjectDetail((_h = state.orphans) == null ? void 0 : _h[0], collectionType, state)) == null ? void 0 : _i.collectionItem;
      pushArray(features, collectionItem == null ? void 0 : collectionItem.features);
      collectionType = "";
    }
    return {
      features
      /* images */
    };
  }
  // static getGeometryType(category, state) {
  //   const firstCutType = (category) => {
  //     switch (category) {
  //       case 'custom':
  //         return 'any'
  //       case 'Polygon':
  //       case 'polygon':
  //       case 'footprint':
  //         // case 'room':
  //         return 'Polygon'
  //       case 'LineString':
  //       case 'line':
  //         // case 'wall':
  //         return 'LineString'
  //       case 'Point':
  //       case 'point':
  //       case 'accessPoint':
  //       case 'marker':
  //       case 'symbol':
  //       case 'location':
  //         return 'Point'
  //       default:
  //         return ''
  //     }
  //   }
  //   const type = firstCutType(category)
  //   if (type) return type
  //   // Next, traverse feature to enforce type of the featue
  //   let found = ''
  //   state.levels?.some((level) => {
  //     level?.features?.some((feature) => {
  //       if (feature?.properties?.category === category) {
  //         found = feature.geometry?.type
  //       }
  //       return !!found
  //     })
  //     return !!found
  //   })
  //   return found || 'any'
  // }
  // Non-reactive method
  static getDrawMode(categoryOrGeometryType, defaultValue2) {
    switch (categoryOrGeometryType) {
      case "custom":
        return "any";
      case "Polygon":
      case "polygon":
      case "footprint":
      case "room":
        return "polygon";
      case "LineString":
      case "line":
      case "wall":
        return "line";
      case "Point":
      case "point":
      case "accessPoint":
      case "marker":
      case "symbol":
      case "location":
        return "point";
      default:
        return defaultValue2;
    }
  }
  // Non-reactive method
  static getFeatureCategoryByKey(lowerKey) {
    if (lowerKey) {
      if (lowerKey.endsWith("footprint")) {
        return "footprint";
      }
      if (lowerKey.endsWith("room")) {
        return "room";
      }
      if (lowerKey.endsWith("wall")) {
        return "wall";
      }
      if (lowerKey.endsWith("accesspoint")) {
        return "accessPoint";
      }
      if (lowerKey.endsWith("marker")) {
        return "marker";
      }
      if (lowerKey.endsWith("point")) {
        return "point";
      }
      if (lowerKey.endsWith("custom")) {
        return "custom";
      }
    }
    return "";
  }
  static hasSubHierarchy(type, id, state) {
    const typeIndex = COLLECTION_TYPES.findIndex((t2) => t2 === type);
    const parentIdKey = SiteStoreHelper.parentType2ParentIdName(type);
    let found = false;
    COLLECTION_TYPES.some((parentType, index2) => {
      if (index2 <= typeIndex)
        return found;
      const collectionName = parentType2CollectionName(parentType);
      const collection = state == null ? void 0 : state[collectionName];
      collection == null ? void 0 : collection.some((item) => {
        if (item[parentIdKey] === id || item.parentId === id) {
          found = !!item;
        }
        return found;
      });
      return found;
    });
    if (!found && typeIndex > -1) {
      const typeCollectionName = parentType2CollectionName(type);
      const item = state == null ? void 0 : state[typeCollectionName].find((itr) => itr.id === id);
      if (item == null ? void 0 : item.numBuildings) {
        return true;
      }
      if (item == null ? void 0 : item.numLevelsInUse) {
        return true;
      }
      if (ACCESS_POINT_PARENTS.includes(type) && item) {
        const hasApsOrLayer = item.features.some((itr) => {
          var _a3, _b3;
          return ((_a3 = itr == null ? void 0 : itr.properties) == null ? void 0 : _a3.category) === "accessPoint" || !!((_b3 = itr == null ? void 0 : itr.properties) == null ? void 0 : _b3.layer);
        });
        if (hasApsOrLayer)
          return true;
      }
    }
    return found;
  }
}
SiteStoreHelper.REGION_PARENTS = REGION_PARENTS;
SiteStoreHelper.MARKET_PARENTS = MARKET_PARENTS;
SiteStoreHelper.CLUSTER_PARENTS = CLUSTER_PARENTS;
SiteStoreHelper.VENUE_PARENTS = VENUE_PARENTS;
SiteStoreHelper.BUILDING_PARENTS = BUILDING_PARENTS;
SiteStoreHelper.LEVEL_PARENTS = LEVEL_PARENTS;
SiteStoreHelper.ZONE_PARENTS = ZONE_PARENTS;
SiteStoreHelper.ACCESS_POINT_PARENTS = ACCESS_POINT_PARENTS;
SiteStoreHelper.DEFAULT_VISIBLE_PROPERTY_KEYS = DEFAULT_VISIBLE_PROPERTY_KEYS;
SiteStoreHelper.COLLECTION_TYPES = COLLECTION_TYPES;
SiteStoreHelper.parentType2CollectionName = parentType2CollectionName;
SiteStoreHelper.parentType2ParentIdName = parentType2ParentIdName;
class AssetHelper {
  static getAssetFromImageFeature(feature2) {
    var _a3;
    if (!((_a3 = feature2.properties) == null ? void 0 : _a3["ground-overlay"]))
      return null;
    const asset = {
      id: feature2.id || generateUid(),
      sourceFile: {
        data: feature2.properties["ground-overlay"],
        dataType: "dataUrl"
      },
      box: feature2.properties["ground-overlay-box"],
      opacity: feature2.properties["ground-overlay-opacity"],
      visible: feature2.properties.visible,
      parentId: feature2.properties.parentId,
      parentType: feature2.properties.parentType,
      name: feature2.properties.name,
      type: "IMAGE"
    };
    return asset;
  }
  static getImageFeature(asset) {
    var _a3, _b3;
    if (!["dataUrl", "text"].includes((_a3 = asset == null ? void 0 : asset.sourceFile) == null ? void 0 : _a3.dataType))
      return null;
    if (!((_b3 = asset == null ? void 0 : asset.sourceFile) == null ? void 0 : _b3.data) || asset.type !== "IMAGE" || !asset.box)
      return null;
    const feature2 = {
      id: asset.id,
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [asset.box]
      },
      properties: {
        category: "asset",
        assetType: asset.type,
        "ground-overlay": asset.sourceFile.data,
        "ground-overlay-box": asset.box,
        "ground-overlay-opacity": asset.opacity,
        parentId: asset.parentId,
        parentType: asset.parentType,
        visible: asset.visible,
        name: asset.name
      }
    };
    return feature2;
  }
  static getModelFeature(asset) {
    var _a3, _b3;
    if (!["dataUrl", "text"].includes((_a3 = asset == null ? void 0 : asset.sourceFile) == null ? void 0 : _a3.dataType))
      return null;
    if (!((_b3 = asset == null ? void 0 : asset.sourceFile) == null ? void 0 : _b3.data) || asset.type !== "GLTF" || !asset.center)
      return null;
    const feature2 = {
      id: asset.id,
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [...asset.center]
      },
      properties: {
        category: "asset",
        assetType: asset.type,
        model: asset.sourceFile.data,
        "model-type": asset.sourceFile.extension,
        "model-azimuth": asset.azimuth,
        "model-dip": asset.dip,
        "model-head": asset.head,
        "model-opacity": asset.opacity,
        parentId: asset.parentId,
        parentType: asset.parentType,
        name: asset.name
      }
    };
    return feature2;
  }
  static getIonFeature(asset) {
    if (asset.type !== "ION")
      return null;
    const content = JSON.stringify({
      type: "3DTILES",
      id: asset.id
    });
    const feature2 = {
      id: asset.id,
      type: "Feature",
      geometry: null,
      properties: {
        category: "asset",
        assetType: asset.type,
        model: `data:text/plain;base64,${btoa(content)}`,
        "model-type": "ion",
        "model-opacity": asset.opacity,
        parentId: asset.parentId,
        parentType: asset.parentType,
        name: asset.name
      }
    };
    return feature2;
  }
  static getAssetFeature(asset, onlyVisible) {
    var _a3;
    if (["IMAGE", "GLTF", "ION"].includes(asset.type)) {
      if (onlyVisible && !asset.visible)
        return null;
      let feature2 = null;
      if (asset.type === "IMAGE") {
        feature2 = AssetHelper.getImageFeature(asset);
      } else if (asset.type === "GLTF") {
        feature2 = AssetHelper.getModelFeature(asset);
      } else if (asset.type === "ION") {
        feature2 = AssetHelper.getIonFeature(asset);
      }
      return feature2;
    }
    console.warn(`${(_a3 = asset.sourceFile) == null ? void 0 : _a3.dataType} : Unsupported type for geoJson export`);
    return null;
  }
}
const STYLE_PROPS = ["fill", "fill-opacity", "stroke", "stroke-opacity", "stroke-width", "stroke-dasharray", "text-color", "text-opacity", "marker-symbol", "marker-size", "hide-when-zoomed-in"];
const STYLE_MAP = {
  point: ["fill", "fill-opacity", "stroke", "stroke-opacity", "stroke-width", "text-color", "text-opacity", "marker-symbol", "marker-size"],
  line: ["stroke", "stroke-opacity", "stroke-width", "stroke-dasharray"],
  polygon: ["fill", "fill-opacity", "stroke", "stroke-opacity", "stroke-width", "stroke-dasharray"]
};
const getFeatureStyle = (feature2) => {
  var _a3;
  const properties = feature2 == null ? void 0 : feature2.properties;
  if (!properties || Object.keys(properties).length === 0)
    return {};
  const style2 = {};
  if (!["Point", "MultiPoint"].includes((_a3 = feature2.geometry) == null ? void 0 : _a3.type)) {
    style2["stroke-dasharray"] = [1, 0];
  }
  STYLE_PROPS.forEach((key) => {
    if (typeof properties[key] === "string" || typeof properties[key] === "number") {
      style2[key] = properties[key];
    } else if (key === "stroke-dasharray" && Array.isArray(properties[key])) {
      style2[key] = properties[key];
    }
  });
  return style2;
};
const applyFeatureStyle = (feature2, style2) => {
  if (!feature2 || !style2)
    return;
  STYLE_PROPS.forEach((key) => {
    if (typeof style2[key] === "string" || typeof style2[key] === "number") {
      feature2.properties[key] = style2[key];
    } else if (key === "stroke-dasharray" && Array.isArray(style2[key])) {
      feature2.properties[key] = style2[key];
    }
  });
};
const DRAW_POINT_STYLE = {
  fill: "#FAB03C",
  // Hard coded '#FAB03C' '#0166FF'
  stroke: "#FFFFFF",
  "fill-opacity": 1,
  "stroke-opacity": 1,
  "stroke-width": 2,
  "circle-radius": 5
};
const DRAW_POLYGON_STYLE = {
  fill: "#0166FF",
  "fill-opacity": 0.6,
  stroke: "#0166FF",
  "stroke-opacity": 1,
  "stroke-width": 1,
  "stroke-dasharray": [1, 0]
};
const styleToPaint = (style2, type) => {
  const propertyNames = STYLE_MAP[type];
  const paint = {};
  propertyNames == null ? void 0 : propertyNames.forEach((key) => {
    const value = style2[key];
    if (!value)
      return;
    switch (key) {
      case "fill":
        if (type === "polygon") {
          paint["fill-color"] = value;
          paint["circle-color"] = DRAW_POINT_STYLE.fill;
        } else if (type === "point") {
          paint["circle-color"] = DRAW_POINT_STYLE.fill;
          paint["icon-color"] = value;
        }
        break;
      case "fill-opacity":
        if (type === "polygon") {
          paint["fill-opacity"] = value;
          paint["circle-opacity"] = DRAW_POINT_STYLE["fill-opacity"];
        } else if (type === "point") {
          paint["circle-opacity"] = DRAW_POINT_STYLE["fill-opacity"];
          paint["icon-opacity"] = value;
        }
        break;
      case "stroke":
        if (type === "line") {
          paint["line-color"] = value;
          paint["circle-stroke-color"] = DRAW_POINT_STYLE.stroke;
        } else if (type === "point") {
          paint["circle-stroke-color"] = DRAW_POINT_STYLE.stroke;
        }
        break;
      case "stroke-opacity":
        if (type === "line") {
          paint["line-opacity"] = value;
          paint["circle-stroke-opacity"] = DRAW_POINT_STYLE["stroke-opacity"];
        } else if (type === "point") {
          paint["circle-stroke-opacity"] = DRAW_POINT_STYLE["stroke-opacity"];
        }
        break;
      case "stroke-width":
        if (type === "line") {
          paint["line-width"] = value;
          paint["circle-stroke-width"] = DRAW_POINT_STYLE["stroke-width"];
          paint["circle-radius"] = DRAW_POINT_STYLE["circle-radius"];
        } else if (type === "point") {
          paint["circle-stroke-width"] = DRAW_POINT_STYLE["stroke-width"];
          paint["circle-radius"] = DRAW_POINT_STYLE["circle-radius"];
        }
        break;
      case "stroke-dasharray":
        if (type === "line") {
          paint["line-dasharray"] = value;
        }
        break;
      case "text-color":
        if (type === "point") {
          paint["text-color"] = value;
        }
        break;
      case "text-opacity":
        if (type === "point") {
          paint["text-opacity"] = value;
        }
        break;
    }
  });
  return paint;
};
const updatePaintInLayer = (layers, layerId, paint) => {
  const layerObject = layers.find((l2) => l2.id === layerId);
  Object.keys(paint).forEach((key) => {
    try {
      if (layerObject.paint[key]) {
        layerObject.paint[key] = paint[key];
      } else if (key === "line-dasharray" && layerObject.type === "line" && layerObject.id.includes("stroke")) {
        layerObject.paint[key] = paint[key];
      }
      return true;
    } catch (error2) {
      return false;
    }
  });
};
const applyPaintInLayer = (map5, layerId, paint) => {
  Object.keys(paint).forEach((key) => {
    try {
      map5.setPaintProperty(layerId, key, paint[key]);
      return true;
    } catch (error2) {
      return false;
    }
  });
};
const getTypeFromLayerName = (layerName) => {
  let type = null;
  Object.keys(STYLE_MAP).some((k2) => {
    const prefix = `gl-draw-${k2}`;
    if (layerName.includes(prefix)) {
      if (layerName.includes(`${prefix}-fill`)) {
        type = "polygon";
      } else if (layerName.includes(`${prefix}-stroke`)) {
        type = "line";
      } else {
        type = k2;
      }
      return true;
    }
    return false;
  });
  return type;
};
const applyPaintProperty = (mapOrLayers, style2, filter17) => {
  if (!mapOrLayers || !style2)
    return;
  const layerObjs = Array.isArray(mapOrLayers) ? mapOrLayers : mapOrLayers.getStyle().layers;
  const apply2 = Array.isArray(mapOrLayers) ? updatePaintInLayer : applyPaintInLayer;
  layerObjs.forEach((layerObj) => {
    const l2 = layerObj.id;
    if (filter17 && !filter17(l2))
      return;
    const type = getTypeFromLayerName(l2);
    if (!type)
      return;
    const paint = styleToPaint(style2, type);
    apply2(mapOrLayers, l2, paint);
  });
};
const humanize = (str) => str.replace(/^[\s_]+|[\s_]+$/g, "").replace(/[-_\s]+/g, " ").replace(/^[a-z]/, (m2) => m2.toUpperCase());
class ImportUtil {
  static curateJsonForImport(dataIn, isGeoJsonIn, options2) {
    var _a3;
    const curateFeature = (feature2, options3) => {
      const {
        parentId,
        parentType,
        category
      } = options3 || {};
      if (feature2.properties.parentType === "project")
        return;
      const finalParentId = feature2.parentId || feature2.properties.parentId || parentId;
      if (finalParentId) {
        feature2.parentId = finalParentId;
        feature2.properties.parentType = parentType;
      }
      if (!feature2.properties.parentType && parentType)
        feature2.properties.parentType = parentType;
      if (!feature2.properties.category) {
        feature2.properties.category = category || "custom";
      }
    };
    const objectOrString = (dataIn == null ? void 0 : dataIn.data) || dataIn;
    const jsonData = typeof objectOrString === "string" ? JSON.parse(objectOrString) : objectOrString;
    if (jsonData) {
      let isGeoJson = isGeoJsonIn;
      if (typeof isGeoJson === "undefined") {
        isGeoJson = ["Feature", "FeatureCollection"].includes(jsonData.type);
      }
      if (isGeoJson) {
        if (jsonData.type === "Feature")
          curateFeature(jsonData, options2);
        else {
          let hasDefaultCenter = false;
          (_a3 = jsonData.features) == null ? void 0 : _a3.forEach((feature2) => {
            curateFeature(feature2, options2);
            if (!hasDefaultCenter && feature2.properties.category === "default-center")
              hasDefaultCenter = true;
          });
          if (!hasDefaultCenter && (options2 == null ? void 0 : options2.extractSite)) {
            const center2 = GeoUtil.centroid(jsonData);
            if (center2) {
              center2.properties.category = "default-center";
              jsonData.features.push(center2);
            }
          }
        }
      }
      return {
        jsonData,
        isGeoJson
      };
    }
    return {};
  }
  static importSiteFromJson(json, geojson, state) {
    var _a3, _b3;
    if (!json)
      return null;
    let result = {};
    const orphan = (_a3 = state == null ? void 0 : state.orphans) == null ? void 0 : _a3[0];
    if (geojson) {
      const addAssetToResult = (asset) => {
        if (!result.assets)
          result.assets = [];
        result.assets.push(asset);
      };
      const addToResult = (collectionName, item) => {
        if (!result[collectionName])
          result[collectionName] = [];
        const collection = result[collectionName];
        if (collectionName === "orphans") {
          const existing = result[collectionName][0];
          if (existing) {
            result[collectionName][0] = {
              ...existing,
              ...item,
              features: mergeArray(existing.features, item.features)
            };
          } else {
            result[collectionName].push(item);
          }
        } else if (collection.find((el) => el.id === item.id)) {
          console.warn("skipping import of duplicate item:", item);
        } else {
          result[collectionName].push(item);
        }
      };
      const fixParentIds = (feature2) => {
        var _a4, _b4;
        let currentParentId = feature2 == null ? void 0 : feature2.parentId;
        let currentParent = null;
        while (currentParentId) {
          currentParent = features.find((f2) => f2.id === currentParentId);
          if (currentParent) {
            const parentIdKey = SiteStoreHelper.parentType2ParentIdName((_a4 = currentParent == null ? void 0 : currentParent.properties) == null ? void 0 : _a4.category);
            feature2.properties[parentIdKey] = currentParent == null ? void 0 : currentParent.id;
            currentParentId = (_b4 = currentParent == null ? void 0 : currentParent.properties) == null ? void 0 : _b4.parentId;
          } else {
            if (feature2.parentId === currentParentId)
              feature2.properties.orphanId = currentParentId;
            currentParentId = null;
          }
        }
        feature2 == null ? true : delete feature2.parentId;
      };
      let counter2 = 0;
      const features = json.type === "Feature" ? [json] : json.features || [];
      features.forEach((feature2) => {
        var _a4, _b4, _c2, _d2, _e2, _f3, _g, _h, _i;
        if (!feature2)
          return;
        if (((_a4 = feature2.properties) == null ? void 0 : _a4.parentType) === "project")
          return;
        const category = (_b4 = feature2.properties) == null ? void 0 : _b4.category;
        if (SiteStoreHelper.COLLECTION_TYPES.includes(category)) {
          const cloned = {};
          cloned.id = feature2.id;
          cloned.type = category;
          cloned.features = [];
          let footprint = null;
          if (feature2.geometry && feature2.geometry.type !== "Point") {
            footprint = {
              id: generateUid(),
              name: `footprint_${counter2}`,
              type: "Feature",
              geometry: feature2.geometry,
              properties: {
                category: "footprint",
                [SiteStoreHelper.parentType2ParentIdName(category)]: feature2.id
              },
              parentId: feature2.id
            };
            if (category === "country") {
              footprint.properties = {
                territoryType: "country",
                ...feature2.properties || {},
                ...footprint.properties || {}
              };
            }
            fixParentIds(footprint);
            counter2 += 1;
          }
          Object.keys(feature2.properties).forEach((key) => {
            if (key === "category")
              return;
            if (STYLE_PROPS.includes(key)) {
              if (footprint)
                footprint.properties[key] = feature2.properties[key];
            } else {
              cloned[key] = feature2.properties[key];
            }
          });
          if (footprint)
            cloned.features.push(footprint);
          const collectionName = SiteStoreHelper.parentType2CollectionName(category);
          addToResult(collectionName, cloned);
        } else if (category === "default-center") {
          result.defaultCenter = (_c2 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _c2.coordinates;
        } else if (((_d2 = feature2.properties) == null ? void 0 : _d2["ground-overlay"]) && !feature2.geometry) {
          const asset = AssetHelper.getAssetFromImageFeature(feature2);
          if (asset) {
            const id = ((_e2 = feature2.properties) == null ? void 0 : _e2.parentId) || (orphan == null ? void 0 : orphan.id);
            const {
              collectionItem: parent,
              collectionType: parentType
              // center,
            } = SiteStoreHelper.getObjectDetail(id, state);
            const parentId = parent == null ? void 0 : parent.id;
            asset.parentId = parentId;
            asset.parentType = parentType;
            addAssetToResult(asset);
            const collectionName = SiteStoreHelper.parentType2CollectionName(parentType);
            const currentParent = (_f3 = state == null ? void 0 : state[collectionName]) == null ? void 0 : _f3.find((f2) => f2.id === parentId);
            addToResult(collectionName, {
              ...currentParent
            });
          }
        } else if (category === "asset")
          ;
        else if ((_g = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _g.layer) {
          const fCount = ((_i = (_h = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _h.geometries) == null ? void 0 : _i.length) || 0;
          if (fCount > 0) {
            feature2.geometry.geometries.forEach((g2) => {
              var _a5;
              const cloned = {
                ...feature2,
                properties: {
                  ...feature2.properties || {}
                },
                geometry: {
                  ...g2,
                  coordinates: [...g2.coordinates]
                }
              };
              cloned.name = `feature_${((_a5 = result == null ? void 0 : result.realFeatures) == null ? void 0 : _a5.length) || 0}`;
              cloned.parentId = cloned.properties.parentId;
              delete cloned.properties.name;
              delete cloned.properties.parentId;
              if (category && category !== "custom") {
                const style2 = {
                  id: category,
                  label: humanize(category)
                };
                addToResult("categories", style2);
              } else {
                cloned.properties.category = "custom";
              }
              cloned.geometry = GeoUtil.getCuratedGeometry(cloned.geometry);
              cloned.id = generateUid();
              addToResult("realFeatures", cloned);
            });
          }
        } else {
          const cloned = {
            ...feature2,
            properties: {
              ...feature2.properties || {}
            }
          };
          if (!cloned.properties.parentId) {
            cloned.properties.parentId = orphan == null ? void 0 : orphan.id;
            if (cloned.properties.parentId && orphan) {
              addToResult("orphans", {
                ...orphan,
                features: mergeArray(orphan.features, [cloned])
              });
            }
          }
          cloned.name = cloned.properties.name;
          cloned.parentId = cloned.properties.parentId;
          delete cloned.properties.name;
          delete cloned.properties.parentId;
          if (category && category !== "custom") {
            const style2 = {
              id: category,
              label: humanize(category)
            };
            addToResult("categories", style2);
          } else {
            cloned.properties.category = "custom";
          }
          cloned.geometry = GeoUtil.getCuratedGeometry(cloned.geometry);
          if (typeof cloned.id === "undefined")
            cloned.id = generateUid();
          addToResult("realFeatures", cloned);
        }
      });
      const findObjectById = (id) => {
        let found = null;
        SiteStoreHelper.COLLECTION_TYPES.some((parentType) => {
          const collectionName = SiteStoreHelper.parentType2CollectionName(parentType);
          const collection = result[collectionName];
          collection == null ? void 0 : collection.some((el) => {
            if (el.id === id)
              found = el;
            return !!found;
          });
          return !!found;
        });
        return found;
      };
      const fixParentId = (object2) => {
        const {
          parentId
        } = object2;
        const parent = findObjectById(parentId);
        if (parent == null ? void 0 : parent.type) {
          const parentIdKey = SiteStoreHelper.parentType2ParentIdName(parent.type);
          object2[parentIdKey] = parentId;
          delete object2.parentId;
          return {
            parent,
            parentIdKey
          };
        }
        return {
          parent
        };
      };
      SiteStoreHelper.COLLECTION_TYPES.forEach((parentType) => {
        const collectionName = SiteStoreHelper.parentType2CollectionName(parentType);
        const collection = result[collectionName];
        if (collection)
          collection.forEach(fixParentId);
      });
      (_b3 = result.realFeatures) == null ? void 0 : _b3.forEach((feature2) => {
        const parent = findObjectById(feature2 == null ? void 0 : feature2.parentId);
        if (parent) {
          fixParentIds(feature2);
          parent.features = mergeArray(parent.features, [feature2]);
        }
      });
    } else {
      result = json;
    }
    return result;
  }
  static getVisible(feature2) {
    var _a3;
    if (typeof ((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.visible) === "boolean") {
      return feature2.properties.visible;
    }
    return true;
  }
  static importAssetsFromJson(json, geojson) {
    if (!json)
      return [];
    let assets = [];
    if (geojson) {
      const getFromImageFeature = (f2) => {
        var _a3, _b3;
        if (!((_a3 = f2.properties) == null ? void 0 : _a3["ground-overlay"]))
          return null;
        const asset = {
          id: f2.id || generateUid(),
          type: "IMAGE",
          displayMode: "2d",
          sourceFile: {
            data: (_b3 = f2.properties) == null ? void 0 : _b3["ground-overlay"],
            dataType: "dataUrl"
          },
          box: f2.properties["ground-overlay-box"],
          // allow undefined / null
          opacity: Number(f2.properties["ground-overlay-opacity"]) ? Number(f2.properties["ground-overlay-opacity"]) : 1,
          parentId: f2.properties.parentId,
          parentType: f2.properties.parentType,
          visible: ImportUtil.getVisible(f2)
        };
        return asset;
      };
      const getFromModelFeature = (f2) => {
        var _a3, _b3, _c2, _d2, _e2, _f3;
        const extension = (_a3 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a3["model-type"];
        if (!((_b3 = f2.properties) == null ? void 0 : _b3.model) || !["glb", "gltf", "dxf"].includes(extension)) {
          return null;
        }
        const asset = {
          id: f2.id || generateUid(),
          type: extension === "dxf" ? "DXF" : "GLTF",
          displayMode: extension === "dxf" ? "2d" : "3d",
          sourceFile: {
            dataType: "dataUrl",
            data: (_c2 = f2.properties) == null ? void 0 : _c2.model,
            extension: (_d2 = f2.properties) == null ? void 0 : _d2["model-type"]
          },
          center: ((_e2 = f2.geometry) == null ? void 0 : _e2.type) === "Point" ? (_f3 = f2.geometry) == null ? void 0 : _f3.coordinates : null,
          // allow undefined / null
          azimuth: f2.properties["model-azimuth"],
          dip: f2.properties["model-dip"],
          head: f2.properties["model-head"],
          opacity: Number(f2.properties["model-opacity"]) ? Number(f2.properties["model-opacity"]) : 1,
          parentId: f2.properties.parentId,
          parentType: f2.properties.parentType,
          visible: ImportUtil.getVisible(f2)
        };
        return asset;
      };
      const getFromIonFeature = (f2) => {
        var _a3, _b3, _c2;
        const extension = (_a3 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a3["model-type"];
        if (!((_b3 = f2.properties) == null ? void 0 : _b3.model) || extension !== "ion") {
          return null;
        }
        const dataUrl = (_c2 = f2.properties) == null ? void 0 : _c2.model;
        const data2 = JSON.parse(atob(dataUrl.replace(/^data:text\/plain;base64,/, "")));
        const asset = {
          id: data2.id,
          type: "ION",
          displayMode: "3d",
          opacity: Number(f2.properties["model-opacity"]) ? Number(f2.properties["model-opacity"]) : 1,
          parentId: f2.properties.parentId,
          parentType: f2.properties.parentType,
          visible: ImportUtil.getVisible(f2)
        };
        return asset;
      };
      const features = json.type === "FeatureCollection" ? json.features : [json];
      features.forEach((f2) => {
        var _a3, _b3, _c2;
        if (((_a3 = f2.properties) == null ? void 0 : _a3.category) === "asset") {
          let asset = getFromImageFeature(f2);
          if (!asset)
            asset = getFromModelFeature(f2);
          if (!asset)
            asset = getFromIonFeature(f2);
          if (asset) {
            assets.push(asset);
          } else {
            console.warn(`${(_c2 = (_b3 = f2.properties) == null ? void 0 : _b3.sourceFile) == null ? void 0 : _c2.dataType} : Unsupported type for geoJson import`);
          }
        }
      });
    } else if (typeof json === "object") {
      assets = json.assets;
    }
    return assets;
  }
  static importProjectFromJson(json, geojson) {
    if (!json)
      return null;
    const getCategoryType = (feature2) => {
      var _a3;
      const geometryType = (_a3 = feature2.geometry) == null ? void 0 : _a3.type;
      const isRaster = !!feature2.properties["ground-overlay"] && !!feature2.properties["ground-overlay-box"];
      if (isRaster)
        return "raster";
      if (geometryType === "Point" || geometryType === "MultiPoint") {
        return "point";
      }
      if (geometryType === "LineString" || geometryType === "MultiLineString") {
        return "line";
      }
      if (geometryType === "Polygon" || geometryType === "MultiPolygon") {
        return "polygon";
      }
      return "";
    };
    const projects = [];
    if (geojson) {
      const features = json.type === "Feature" ? [json] : json.features || [];
      features.forEach((feature2) => {
        if (!feature2)
          return;
        const {
          parentId,
          parentType,
          category,
          visible
        } = feature2.properties || {};
        if (parentType !== "project" || !category || !parentId)
          return;
        let project3 = projects.find((item) => item.name === parentId);
        if (!project3) {
          project3 = {
            id: generateUid(),
            name: parentId,
            type: "project",
            categories: []
          };
          projects.push(project3);
        }
        const categoryType = getCategoryType(feature2);
        let group = project3.categories.find((item) => item.name === category && item.type === categoryType);
        if (!group) {
          group = {
            id: generateUid(),
            name: category,
            show: typeof visible === "boolean" ? visible : true,
            features: [],
            type: categoryType,
            fileName: category
          };
          project3.categories.push(group);
        }
        if (categoryType === "raster") {
          const asset = AssetHelper.getAssetFromImageFeature(feature2);
          if (asset) {
            asset.properties = {};
            group.features.push(asset);
          }
        } else {
          const properties = {
            ...feature2.properties
          };
          delete properties.parentId;
          delete properties.parentType;
          delete properties.category;
          delete properties.visible;
          group.features.push({
            ...feature2,
            properties
          });
        }
      });
    }
    return projects;
  }
}
function commonjsRequire(path2) {
  throw new Error('Could not dynamically require "' + path2 + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var jszip_minExports = {};
var jszip_min = {
  get exports() {
    return jszip_minExports;
  },
  set exports(v5) {
    jszip_minExports = v5;
  }
};
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/
(function(module2, exports2) {
  !function(e3) {
    module2.exports = e3();
  }(function() {
    return function s2(a2, o2, h2) {
      function u2(r2, e4) {
        if (!o2[r2]) {
          if (!a2[r2]) {
            var t2 = "function" == typeof commonjsRequire && commonjsRequire;
            if (!e4 && t2)
              return t2(r2, true);
            if (l2)
              return l2(r2, true);
            var n2 = new Error("Cannot find module '" + r2 + "'");
            throw n2.code = "MODULE_NOT_FOUND", n2;
          }
          var i2 = o2[r2] = { exports: {} };
          a2[r2][0].call(i2.exports, function(e5) {
            var t3 = a2[r2][1][e5];
            return u2(t3 || e5);
          }, i2, i2.exports, s2, a2, o2, h2);
        }
        return o2[r2].exports;
      }
      for (var l2 = "function" == typeof commonjsRequire && commonjsRequire, e3 = 0; e3 < h2.length; e3++)
        u2(h2[e3]);
      return u2;
    }({ 1: [function(e3, t2, r2) {
      var d2 = e3("./utils"), c2 = e3("./support"), p2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      r2.encode = function(e4) {
        for (var t3, r3, n2, i2, s2, a2, o2, h2 = [], u2 = 0, l2 = e4.length, f2 = l2, c3 = "string" !== d2.getTypeOf(e4); u2 < e4.length; )
          f2 = l2 - u2, n2 = c3 ? (t3 = e4[u2++], r3 = u2 < l2 ? e4[u2++] : 0, u2 < l2 ? e4[u2++] : 0) : (t3 = e4.charCodeAt(u2++), r3 = u2 < l2 ? e4.charCodeAt(u2++) : 0, u2 < l2 ? e4.charCodeAt(u2++) : 0), i2 = t3 >> 2, s2 = (3 & t3) << 4 | r3 >> 4, a2 = 1 < f2 ? (15 & r3) << 2 | n2 >> 6 : 64, o2 = 2 < f2 ? 63 & n2 : 64, h2.push(p2.charAt(i2) + p2.charAt(s2) + p2.charAt(a2) + p2.charAt(o2));
        return h2.join("");
      }, r2.decode = function(e4) {
        var t3, r3, n2, i2, s2, a2, o2 = 0, h2 = 0, u2 = "data:";
        if (e4.substr(0, u2.length) === u2)
          throw new Error("Invalid base64 input, it looks like a data url.");
        var l2, f2 = 3 * (e4 = e4.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
        if (e4.charAt(e4.length - 1) === p2.charAt(64) && f2--, e4.charAt(e4.length - 2) === p2.charAt(64) && f2--, f2 % 1 != 0)
          throw new Error("Invalid base64 input, bad content length.");
        for (l2 = c2.uint8array ? new Uint8Array(0 | f2) : new Array(0 | f2); o2 < e4.length; )
          t3 = p2.indexOf(e4.charAt(o2++)) << 2 | (i2 = p2.indexOf(e4.charAt(o2++))) >> 4, r3 = (15 & i2) << 4 | (s2 = p2.indexOf(e4.charAt(o2++))) >> 2, n2 = (3 & s2) << 6 | (a2 = p2.indexOf(e4.charAt(o2++))), l2[h2++] = t3, 64 !== s2 && (l2[h2++] = r3), 64 !== a2 && (l2[h2++] = n2);
        return l2;
      };
    }, { "./support": 30, "./utils": 32 }], 2: [function(e3, t2, r2) {
      var n2 = e3("./external"), i2 = e3("./stream/DataWorker"), s2 = e3("./stream/Crc32Probe"), a2 = e3("./stream/DataLengthProbe");
      function o2(e4, t3, r3, n3, i3) {
        this.compressedSize = e4, this.uncompressedSize = t3, this.crc32 = r3, this.compression = n3, this.compressedContent = i3;
      }
      o2.prototype = { getContentWorker: function() {
        var e4 = new i2(n2.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a2("data_length")), t3 = this;
        return e4.on("end", function() {
          if (this.streamInfo.data_length !== t3.uncompressedSize)
            throw new Error("Bug : uncompressed data size mismatch");
        }), e4;
      }, getCompressedWorker: function() {
        return new i2(n2.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
      } }, o2.createWorkerFrom = function(e4, t3, r3) {
        return e4.pipe(new s2()).pipe(new a2("uncompressedSize")).pipe(t3.compressWorker(r3)).pipe(new a2("compressedSize")).withStreamInfo("compression", t3);
      }, t2.exports = o2;
    }, { "./external": 6, "./stream/Crc32Probe": 25, "./stream/DataLengthProbe": 26, "./stream/DataWorker": 27 }], 3: [function(e3, t2, r2) {
      var n2 = e3("./stream/GenericWorker");
      r2.STORE = { magic: "\0\0", compressWorker: function() {
        return new n2("STORE compression");
      }, uncompressWorker: function() {
        return new n2("STORE decompression");
      } }, r2.DEFLATE = e3("./flate");
    }, { "./flate": 7, "./stream/GenericWorker": 28 }], 4: [function(e3, t2, r2) {
      var n2 = e3("./utils");
      var o2 = function() {
        for (var e4, t3 = [], r3 = 0; r3 < 256; r3++) {
          e4 = r3;
          for (var n3 = 0; n3 < 8; n3++)
            e4 = 1 & e4 ? 3988292384 ^ e4 >>> 1 : e4 >>> 1;
          t3[r3] = e4;
        }
        return t3;
      }();
      t2.exports = function(e4, t3) {
        return void 0 !== e4 && e4.length ? "string" !== n2.getTypeOf(e4) ? function(e5, t4, r3, n3) {
          var i2 = o2, s2 = n3 + r3;
          e5 ^= -1;
          for (var a2 = n3; a2 < s2; a2++)
            e5 = e5 >>> 8 ^ i2[255 & (e5 ^ t4[a2])];
          return -1 ^ e5;
        }(0 | t3, e4, e4.length, 0) : function(e5, t4, r3, n3) {
          var i2 = o2, s2 = n3 + r3;
          e5 ^= -1;
          for (var a2 = n3; a2 < s2; a2++)
            e5 = e5 >>> 8 ^ i2[255 & (e5 ^ t4.charCodeAt(a2))];
          return -1 ^ e5;
        }(0 | t3, e4, e4.length, 0) : 0;
      };
    }, { "./utils": 32 }], 5: [function(e3, t2, r2) {
      r2.base64 = false, r2.binary = false, r2.dir = false, r2.createFolders = true, r2.date = null, r2.compression = null, r2.compressionOptions = null, r2.comment = null, r2.unixPermissions = null, r2.dosPermissions = null;
    }, {}], 6: [function(e3, t2, r2) {
      var n2 = null;
      n2 = "undefined" != typeof Promise ? Promise : e3("lie"), t2.exports = { Promise: n2 };
    }, { lie: 37 }], 7: [function(e3, t2, r2) {
      var n2 = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i2 = e3("pako"), s2 = e3("./utils"), a2 = e3("./stream/GenericWorker"), o2 = n2 ? "uint8array" : "array";
      function h2(e4, t3) {
        a2.call(this, "FlateWorker/" + e4), this._pako = null, this._pakoAction = e4, this._pakoOptions = t3, this.meta = {};
      }
      r2.magic = "\b\0", s2.inherits(h2, a2), h2.prototype.processChunk = function(e4) {
        this.meta = e4.meta, null === this._pako && this._createPako(), this._pako.push(s2.transformTo(o2, e4.data), false);
      }, h2.prototype.flush = function() {
        a2.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], true);
      }, h2.prototype.cleanUp = function() {
        a2.prototype.cleanUp.call(this), this._pako = null;
      }, h2.prototype._createPako = function() {
        this._pako = new i2[this._pakoAction]({ raw: true, level: this._pakoOptions.level || -1 });
        var t3 = this;
        this._pako.onData = function(e4) {
          t3.push({ data: e4, meta: t3.meta });
        };
      }, r2.compressWorker = function(e4) {
        return new h2("Deflate", e4);
      }, r2.uncompressWorker = function() {
        return new h2("Inflate", {});
      };
    }, { "./stream/GenericWorker": 28, "./utils": 32, pako: 38 }], 8: [function(e3, t2, r2) {
      function A2(e4, t3) {
        var r3, n3 = "";
        for (r3 = 0; r3 < t3; r3++)
          n3 += String.fromCharCode(255 & e4), e4 >>>= 8;
        return n3;
      }
      function n2(e4, t3, r3, n3, i3, s3) {
        var a2, o2, h2 = e4.file, u2 = e4.compression, l2 = s3 !== O2.utf8encode, f2 = I2.transformTo("string", s3(h2.name)), c2 = I2.transformTo("string", O2.utf8encode(h2.name)), d2 = h2.comment, p2 = I2.transformTo("string", s3(d2)), m2 = I2.transformTo("string", O2.utf8encode(d2)), _2 = c2.length !== h2.name.length, g2 = m2.length !== d2.length, b2 = "", v5 = "", y2 = "", w2 = h2.dir, k2 = h2.date, x2 = { crc32: 0, compressedSize: 0, uncompressedSize: 0 };
        t3 && !r3 || (x2.crc32 = e4.crc32, x2.compressedSize = e4.compressedSize, x2.uncompressedSize = e4.uncompressedSize);
        var S2 = 0;
        t3 && (S2 |= 8), l2 || !_2 && !g2 || (S2 |= 2048);
        var z2 = 0, C2 = 0;
        w2 && (z2 |= 16), "UNIX" === i3 ? (C2 = 798, z2 |= function(e5, t4) {
          var r4 = e5;
          return e5 || (r4 = t4 ? 16893 : 33204), (65535 & r4) << 16;
        }(h2.unixPermissions, w2)) : (C2 = 20, z2 |= function(e5) {
          return 63 & (e5 || 0);
        }(h2.dosPermissions)), a2 = k2.getUTCHours(), a2 <<= 6, a2 |= k2.getUTCMinutes(), a2 <<= 5, a2 |= k2.getUTCSeconds() / 2, o2 = k2.getUTCFullYear() - 1980, o2 <<= 4, o2 |= k2.getUTCMonth() + 1, o2 <<= 5, o2 |= k2.getUTCDate(), _2 && (v5 = A2(1, 1) + A2(B2(f2), 4) + c2, b2 += "up" + A2(v5.length, 2) + v5), g2 && (y2 = A2(1, 1) + A2(B2(p2), 4) + m2, b2 += "uc" + A2(y2.length, 2) + y2);
        var E3 = "";
        return E3 += "\n\0", E3 += A2(S2, 2), E3 += u2.magic, E3 += A2(a2, 2), E3 += A2(o2, 2), E3 += A2(x2.crc32, 4), E3 += A2(x2.compressedSize, 4), E3 += A2(x2.uncompressedSize, 4), E3 += A2(f2.length, 2), E3 += A2(b2.length, 2), { fileRecord: R2.LOCAL_FILE_HEADER + E3 + f2 + b2, dirRecord: R2.CENTRAL_FILE_HEADER + A2(C2, 2) + E3 + A2(p2.length, 2) + "\0\0\0\0" + A2(z2, 4) + A2(n3, 4) + f2 + b2 + p2 };
      }
      var I2 = e3("../utils"), i2 = e3("../stream/GenericWorker"), O2 = e3("../utf8"), B2 = e3("../crc32"), R2 = e3("../signature");
      function s2(e4, t3, r3, n3) {
        i2.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t3, this.zipPlatform = r3, this.encodeFileName = n3, this.streamFiles = e4, this.accumulate = false, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
      }
      I2.inherits(s2, i2), s2.prototype.push = function(e4) {
        var t3 = e4.meta.percent || 0, r3 = this.entriesCount, n3 = this._sources.length;
        this.accumulate ? this.contentBuffer.push(e4) : (this.bytesWritten += e4.data.length, i2.prototype.push.call(this, { data: e4.data, meta: { currentFile: this.currentFile, percent: r3 ? (t3 + 100 * (r3 - n3 - 1)) / r3 : 100 } }));
      }, s2.prototype.openedSource = function(e4) {
        this.currentSourceOffset = this.bytesWritten, this.currentFile = e4.file.name;
        var t3 = this.streamFiles && !e4.file.dir;
        if (t3) {
          var r3 = n2(e4, t3, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({ data: r3.fileRecord, meta: { percent: 0 } });
        } else
          this.accumulate = true;
      }, s2.prototype.closedSource = function(e4) {
        this.accumulate = false;
        var t3 = this.streamFiles && !e4.file.dir, r3 = n2(e4, t3, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        if (this.dirRecords.push(r3.dirRecord), t3)
          this.push({ data: function(e5) {
            return R2.DATA_DESCRIPTOR + A2(e5.crc32, 4) + A2(e5.compressedSize, 4) + A2(e5.uncompressedSize, 4);
          }(e4), meta: { percent: 100 } });
        else
          for (this.push({ data: r3.fileRecord, meta: { percent: 0 } }); this.contentBuffer.length; )
            this.push(this.contentBuffer.shift());
        this.currentFile = null;
      }, s2.prototype.flush = function() {
        for (var e4 = this.bytesWritten, t3 = 0; t3 < this.dirRecords.length; t3++)
          this.push({ data: this.dirRecords[t3], meta: { percent: 100 } });
        var r3 = this.bytesWritten - e4, n3 = function(e5, t4, r4, n4, i3) {
          var s3 = I2.transformTo("string", i3(n4));
          return R2.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A2(e5, 2) + A2(e5, 2) + A2(t4, 4) + A2(r4, 4) + A2(s3.length, 2) + s3;
        }(this.dirRecords.length, r3, e4, this.zipComment, this.encodeFileName);
        this.push({ data: n3, meta: { percent: 100 } });
      }, s2.prototype.prepareNextSource = function() {
        this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
      }, s2.prototype.registerPrevious = function(e4) {
        this._sources.push(e4);
        var t3 = this;
        return e4.on("data", function(e5) {
          t3.processChunk(e5);
        }), e4.on("end", function() {
          t3.closedSource(t3.previous.streamInfo), t3._sources.length ? t3.prepareNextSource() : t3.end();
        }), e4.on("error", function(e5) {
          t3.error(e5);
        }), this;
      }, s2.prototype.resume = function() {
        return !!i2.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), true) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), true));
      }, s2.prototype.error = function(e4) {
        var t3 = this._sources;
        if (!i2.prototype.error.call(this, e4))
          return false;
        for (var r3 = 0; r3 < t3.length; r3++)
          try {
            t3[r3].error(e4);
          } catch (e5) {
          }
        return true;
      }, s2.prototype.lock = function() {
        i2.prototype.lock.call(this);
        for (var e4 = this._sources, t3 = 0; t3 < e4.length; t3++)
          e4[t3].lock();
      }, t2.exports = s2;
    }, { "../crc32": 4, "../signature": 23, "../stream/GenericWorker": 28, "../utf8": 31, "../utils": 32 }], 9: [function(e3, t2, r2) {
      var u2 = e3("../compressions"), n2 = e3("./ZipFileWorker");
      r2.generateWorker = function(e4, a2, t3) {
        var o2 = new n2(a2.streamFiles, t3, a2.platform, a2.encodeFileName), h2 = 0;
        try {
          e4.forEach(function(e5, t4) {
            h2++;
            var r3 = function(e6, t5) {
              var r4 = e6 || t5, n4 = u2[r4];
              if (!n4)
                throw new Error(r4 + " is not a valid compression method !");
              return n4;
            }(t4.options.compression, a2.compression), n3 = t4.options.compressionOptions || a2.compressionOptions || {}, i2 = t4.dir, s2 = t4.date;
            t4._compressWorker(r3, n3).withStreamInfo("file", { name: e5, dir: i2, date: s2, comment: t4.comment || "", unixPermissions: t4.unixPermissions, dosPermissions: t4.dosPermissions }).pipe(o2);
          }), o2.entriesCount = h2;
        } catch (e5) {
          o2.error(e5);
        }
        return o2;
      };
    }, { "../compressions": 3, "./ZipFileWorker": 8 }], 10: [function(e3, t2, r2) {
      function n2() {
        if (!(this instanceof n2))
          return new n2();
        if (arguments.length)
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
          var e4 = new n2();
          for (var t3 in this)
            "function" != typeof this[t3] && (e4[t3] = this[t3]);
          return e4;
        };
      }
      (n2.prototype = e3("./object")).loadAsync = e3("./load"), n2.support = e3("./support"), n2.defaults = e3("./defaults"), n2.version = "3.10.1", n2.loadAsync = function(e4, t3) {
        return new n2().loadAsync(e4, t3);
      }, n2.external = e3("./external"), t2.exports = n2;
    }, { "./defaults": 5, "./external": 6, "./load": 11, "./object": 15, "./support": 30 }], 11: [function(e3, t2, r2) {
      var u2 = e3("./utils"), i2 = e3("./external"), n2 = e3("./utf8"), s2 = e3("./zipEntries"), a2 = e3("./stream/Crc32Probe"), l2 = e3("./nodejsUtils");
      function f2(n3) {
        return new i2.Promise(function(e4, t3) {
          var r3 = n3.decompressed.getContentWorker().pipe(new a2());
          r3.on("error", function(e5) {
            t3(e5);
          }).on("end", function() {
            r3.streamInfo.crc32 !== n3.decompressed.crc32 ? t3(new Error("Corrupted zip : CRC32 mismatch")) : e4();
          }).resume();
        });
      }
      t2.exports = function(e4, o2) {
        var h2 = this;
        return o2 = u2.extend(o2 || {}, { base64: false, checkCRC32: false, optimizedBinaryString: false, createFolders: false, decodeFileName: n2.utf8decode }), l2.isNode && l2.isStream(e4) ? i2.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u2.prepareContent("the loaded zip file", e4, true, o2.optimizedBinaryString, o2.base64).then(function(e5) {
          var t3 = new s2(o2);
          return t3.load(e5), t3;
        }).then(function(e5) {
          var t3 = [i2.Promise.resolve(e5)], r3 = e5.files;
          if (o2.checkCRC32)
            for (var n3 = 0; n3 < r3.length; n3++)
              t3.push(f2(r3[n3]));
          return i2.Promise.all(t3);
        }).then(function(e5) {
          for (var t3 = e5.shift(), r3 = t3.files, n3 = 0; n3 < r3.length; n3++) {
            var i3 = r3[n3], s3 = i3.fileNameStr, a3 = u2.resolve(i3.fileNameStr);
            h2.file(a3, i3.decompressed, { binary: true, optimizedBinaryString: true, date: i3.date, dir: i3.dir, comment: i3.fileCommentStr.length ? i3.fileCommentStr : null, unixPermissions: i3.unixPermissions, dosPermissions: i3.dosPermissions, createFolders: o2.createFolders }), i3.dir || (h2.file(a3).unsafeOriginalName = s3);
          }
          return t3.zipComment.length && (h2.comment = t3.zipComment), h2;
        });
      };
    }, { "./external": 6, "./nodejsUtils": 14, "./stream/Crc32Probe": 25, "./utf8": 31, "./utils": 32, "./zipEntries": 33 }], 12: [function(e3, t2, r2) {
      var n2 = e3("../utils"), i2 = e3("../stream/GenericWorker");
      function s2(e4, t3) {
        i2.call(this, "Nodejs stream input adapter for " + e4), this._upstreamEnded = false, this._bindStream(t3);
      }
      n2.inherits(s2, i2), s2.prototype._bindStream = function(e4) {
        var t3 = this;
        (this._stream = e4).pause(), e4.on("data", function(e5) {
          t3.push({ data: e5, meta: { percent: 0 } });
        }).on("error", function(e5) {
          t3.isPaused ? this.generatedError = e5 : t3.error(e5);
        }).on("end", function() {
          t3.isPaused ? t3._upstreamEnded = true : t3.end();
        });
      }, s2.prototype.pause = function() {
        return !!i2.prototype.pause.call(this) && (this._stream.pause(), true);
      }, s2.prototype.resume = function() {
        return !!i2.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), true);
      }, t2.exports = s2;
    }, { "../stream/GenericWorker": 28, "../utils": 32 }], 13: [function(e3, t2, r2) {
      var i2 = e3("readable-stream").Readable;
      function n2(e4, t3, r3) {
        i2.call(this, t3), this._helper = e4;
        var n3 = this;
        e4.on("data", function(e5, t4) {
          n3.push(e5) || n3._helper.pause(), r3 && r3(t4);
        }).on("error", function(e5) {
          n3.emit("error", e5);
        }).on("end", function() {
          n3.push(null);
        });
      }
      e3("../utils").inherits(n2, i2), n2.prototype._read = function() {
        this._helper.resume();
      }, t2.exports = n2;
    }, { "../utils": 32, "readable-stream": 16 }], 14: [function(e3, t2, r2) {
      t2.exports = { isNode: "undefined" != typeof Buffer, newBufferFrom: function(e4, t3) {
        if (Buffer.from && Buffer.from !== Uint8Array.from)
          return Buffer.from(e4, t3);
        if ("number" == typeof e4)
          throw new Error('The "data" argument must not be a number');
        return new Buffer(e4, t3);
      }, allocBuffer: function(e4) {
        if (Buffer.alloc)
          return Buffer.alloc(e4);
        var t3 = new Buffer(e4);
        return t3.fill(0), t3;
      }, isBuffer: function(e4) {
        return Buffer.isBuffer(e4);
      }, isStream: function(e4) {
        return e4 && "function" == typeof e4.on && "function" == typeof e4.pause && "function" == typeof e4.resume;
      } };
    }, {}], 15: [function(e3, t2, r2) {
      function s2(e4, t3, r3) {
        var n3, i3 = u2.getTypeOf(t3), s3 = u2.extend(r3 || {}, f2);
        s3.date = s3.date || /* @__PURE__ */ new Date(), null !== s3.compression && (s3.compression = s3.compression.toUpperCase()), "string" == typeof s3.unixPermissions && (s3.unixPermissions = parseInt(s3.unixPermissions, 8)), s3.unixPermissions && 16384 & s3.unixPermissions && (s3.dir = true), s3.dosPermissions && 16 & s3.dosPermissions && (s3.dir = true), s3.dir && (e4 = g2(e4)), s3.createFolders && (n3 = _2(e4)) && b2.call(this, n3, true);
        var a3 = "string" === i3 && false === s3.binary && false === s3.base64;
        r3 && void 0 !== r3.binary || (s3.binary = !a3), (t3 instanceof c2 && 0 === t3.uncompressedSize || s3.dir || !t3 || 0 === t3.length) && (s3.base64 = false, s3.binary = true, t3 = "", s3.compression = "STORE", i3 = "string");
        var o3 = null;
        o3 = t3 instanceof c2 || t3 instanceof l2 ? t3 : p2.isNode && p2.isStream(t3) ? new m2(e4, t3) : u2.prepareContent(e4, t3, s3.binary, s3.optimizedBinaryString, s3.base64);
        var h3 = new d2(e4, o3, s3);
        this.files[e4] = h3;
      }
      var i2 = e3("./utf8"), u2 = e3("./utils"), l2 = e3("./stream/GenericWorker"), a2 = e3("./stream/StreamHelper"), f2 = e3("./defaults"), c2 = e3("./compressedObject"), d2 = e3("./zipObject"), o2 = e3("./generate"), p2 = e3("./nodejsUtils"), m2 = e3("./nodejs/NodejsStreamInputAdapter"), _2 = function(e4) {
        "/" === e4.slice(-1) && (e4 = e4.substring(0, e4.length - 1));
        var t3 = e4.lastIndexOf("/");
        return 0 < t3 ? e4.substring(0, t3) : "";
      }, g2 = function(e4) {
        return "/" !== e4.slice(-1) && (e4 += "/"), e4;
      }, b2 = function(e4, t3) {
        return t3 = void 0 !== t3 ? t3 : f2.createFolders, e4 = g2(e4), this.files[e4] || s2.call(this, e4, null, { dir: true, createFolders: t3 }), this.files[e4];
      };
      function h2(e4) {
        return "[object RegExp]" === Object.prototype.toString.call(e4);
      }
      var n2 = { load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, forEach: function(e4) {
        var t3, r3, n3;
        for (t3 in this.files)
          n3 = this.files[t3], (r3 = t3.slice(this.root.length, t3.length)) && t3.slice(0, this.root.length) === this.root && e4(r3, n3);
      }, filter: function(r3) {
        var n3 = [];
        return this.forEach(function(e4, t3) {
          r3(e4, t3) && n3.push(t3);
        }), n3;
      }, file: function(e4, t3, r3) {
        if (1 !== arguments.length)
          return e4 = this.root + e4, s2.call(this, e4, t3, r3), this;
        if (h2(e4)) {
          var n3 = e4;
          return this.filter(function(e5, t4) {
            return !t4.dir && n3.test(e5);
          });
        }
        var i3 = this.files[this.root + e4];
        return i3 && !i3.dir ? i3 : null;
      }, folder: function(r3) {
        if (!r3)
          return this;
        if (h2(r3))
          return this.filter(function(e5, t4) {
            return t4.dir && r3.test(e5);
          });
        var e4 = this.root + r3, t3 = b2.call(this, e4), n3 = this.clone();
        return n3.root = t3.name, n3;
      }, remove: function(r3) {
        r3 = this.root + r3;
        var e4 = this.files[r3];
        if (e4 || ("/" !== r3.slice(-1) && (r3 += "/"), e4 = this.files[r3]), e4 && !e4.dir)
          delete this.files[r3];
        else
          for (var t3 = this.filter(function(e5, t4) {
            return t4.name.slice(0, r3.length) === r3;
          }), n3 = 0; n3 < t3.length; n3++)
            delete this.files[t3[n3].name];
        return this;
      }, generate: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, generateInternalStream: function(e4) {
        var t3, r3 = {};
        try {
          if ((r3 = u2.extend(e4 || {}, { streamFiles: false, compression: "STORE", compressionOptions: null, type: "", platform: "DOS", comment: null, mimeType: "application/zip", encodeFileName: i2.utf8encode })).type = r3.type.toLowerCase(), r3.compression = r3.compression.toUpperCase(), "binarystring" === r3.type && (r3.type = "string"), !r3.type)
            throw new Error("No output type specified.");
          u2.checkSupport(r3.type), "darwin" !== r3.platform && "freebsd" !== r3.platform && "linux" !== r3.platform && "sunos" !== r3.platform || (r3.platform = "UNIX"), "win32" === r3.platform && (r3.platform = "DOS");
          var n3 = r3.comment || this.comment || "";
          t3 = o2.generateWorker(this, r3, n3);
        } catch (e5) {
          (t3 = new l2("error")).error(e5);
        }
        return new a2(t3, r3.type || "string", r3.mimeType);
      }, generateAsync: function(e4, t3) {
        return this.generateInternalStream(e4).accumulate(t3);
      }, generateNodeStream: function(e4, t3) {
        return (e4 = e4 || {}).type || (e4.type = "nodebuffer"), this.generateInternalStream(e4).toNodejsStream(t3);
      } };
      t2.exports = n2;
    }, { "./compressedObject": 2, "./defaults": 5, "./generate": 9, "./nodejs/NodejsStreamInputAdapter": 12, "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31, "./utils": 32, "./zipObject": 35 }], 16: [function(e3, t2, r2) {
      t2.exports = e3("stream");
    }, { stream: void 0 }], 17: [function(e3, t2, r2) {
      var n2 = e3("./DataReader");
      function i2(e4) {
        n2.call(this, e4);
        for (var t3 = 0; t3 < this.data.length; t3++)
          e4[t3] = 255 & e4[t3];
      }
      e3("../utils").inherits(i2, n2), i2.prototype.byteAt = function(e4) {
        return this.data[this.zero + e4];
      }, i2.prototype.lastIndexOfSignature = function(e4) {
        for (var t3 = e4.charCodeAt(0), r3 = e4.charCodeAt(1), n3 = e4.charCodeAt(2), i3 = e4.charCodeAt(3), s2 = this.length - 4; 0 <= s2; --s2)
          if (this.data[s2] === t3 && this.data[s2 + 1] === r3 && this.data[s2 + 2] === n3 && this.data[s2 + 3] === i3)
            return s2 - this.zero;
        return -1;
      }, i2.prototype.readAndCheckSignature = function(e4) {
        var t3 = e4.charCodeAt(0), r3 = e4.charCodeAt(1), n3 = e4.charCodeAt(2), i3 = e4.charCodeAt(3), s2 = this.readData(4);
        return t3 === s2[0] && r3 === s2[1] && n3 === s2[2] && i3 === s2[3];
      }, i2.prototype.readData = function(e4) {
        if (this.checkOffset(e4), 0 === e4)
          return [];
        var t3 = this.data.slice(this.zero + this.index, this.zero + this.index + e4);
        return this.index += e4, t3;
      }, t2.exports = i2;
    }, { "../utils": 32, "./DataReader": 18 }], 18: [function(e3, t2, r2) {
      var n2 = e3("../utils");
      function i2(e4) {
        this.data = e4, this.length = e4.length, this.index = 0, this.zero = 0;
      }
      i2.prototype = { checkOffset: function(e4) {
        this.checkIndex(this.index + e4);
      }, checkIndex: function(e4) {
        if (this.length < this.zero + e4 || e4 < 0)
          throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e4 + "). Corrupted zip ?");
      }, setIndex: function(e4) {
        this.checkIndex(e4), this.index = e4;
      }, skip: function(e4) {
        this.setIndex(this.index + e4);
      }, byteAt: function() {
      }, readInt: function(e4) {
        var t3, r3 = 0;
        for (this.checkOffset(e4), t3 = this.index + e4 - 1; t3 >= this.index; t3--)
          r3 = (r3 << 8) + this.byteAt(t3);
        return this.index += e4, r3;
      }, readString: function(e4) {
        return n2.transformTo("string", this.readData(e4));
      }, readData: function() {
      }, lastIndexOfSignature: function() {
      }, readAndCheckSignature: function() {
      }, readDate: function() {
        var e4 = this.readInt(4);
        return new Date(Date.UTC(1980 + (e4 >> 25 & 127), (e4 >> 21 & 15) - 1, e4 >> 16 & 31, e4 >> 11 & 31, e4 >> 5 & 63, (31 & e4) << 1));
      } }, t2.exports = i2;
    }, { "../utils": 32 }], 19: [function(e3, t2, r2) {
      var n2 = e3("./Uint8ArrayReader");
      function i2(e4) {
        n2.call(this, e4);
      }
      e3("../utils").inherits(i2, n2), i2.prototype.readData = function(e4) {
        this.checkOffset(e4);
        var t3 = this.data.slice(this.zero + this.index, this.zero + this.index + e4);
        return this.index += e4, t3;
      }, t2.exports = i2;
    }, { "../utils": 32, "./Uint8ArrayReader": 21 }], 20: [function(e3, t2, r2) {
      var n2 = e3("./DataReader");
      function i2(e4) {
        n2.call(this, e4);
      }
      e3("../utils").inherits(i2, n2), i2.prototype.byteAt = function(e4) {
        return this.data.charCodeAt(this.zero + e4);
      }, i2.prototype.lastIndexOfSignature = function(e4) {
        return this.data.lastIndexOf(e4) - this.zero;
      }, i2.prototype.readAndCheckSignature = function(e4) {
        return e4 === this.readData(4);
      }, i2.prototype.readData = function(e4) {
        this.checkOffset(e4);
        var t3 = this.data.slice(this.zero + this.index, this.zero + this.index + e4);
        return this.index += e4, t3;
      }, t2.exports = i2;
    }, { "../utils": 32, "./DataReader": 18 }], 21: [function(e3, t2, r2) {
      var n2 = e3("./ArrayReader");
      function i2(e4) {
        n2.call(this, e4);
      }
      e3("../utils").inherits(i2, n2), i2.prototype.readData = function(e4) {
        if (this.checkOffset(e4), 0 === e4)
          return new Uint8Array(0);
        var t3 = this.data.subarray(this.zero + this.index, this.zero + this.index + e4);
        return this.index += e4, t3;
      }, t2.exports = i2;
    }, { "../utils": 32, "./ArrayReader": 17 }], 22: [function(e3, t2, r2) {
      var n2 = e3("../utils"), i2 = e3("../support"), s2 = e3("./ArrayReader"), a2 = e3("./StringReader"), o2 = e3("./NodeBufferReader"), h2 = e3("./Uint8ArrayReader");
      t2.exports = function(e4) {
        var t3 = n2.getTypeOf(e4);
        return n2.checkSupport(t3), "string" !== t3 || i2.uint8array ? "nodebuffer" === t3 ? new o2(e4) : i2.uint8array ? new h2(n2.transformTo("uint8array", e4)) : new s2(n2.transformTo("array", e4)) : new a2(e4);
      };
    }, { "../support": 30, "../utils": 32, "./ArrayReader": 17, "./NodeBufferReader": 19, "./StringReader": 20, "./Uint8ArrayReader": 21 }], 23: [function(e3, t2, r2) {
      r2.LOCAL_FILE_HEADER = "PK", r2.CENTRAL_FILE_HEADER = "PK", r2.CENTRAL_DIRECTORY_END = "PK", r2.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x07", r2.ZIP64_CENTRAL_DIRECTORY_END = "PK", r2.DATA_DESCRIPTOR = "PK\x07\b";
    }, {}], 24: [function(e3, t2, r2) {
      var n2 = e3("./GenericWorker"), i2 = e3("../utils");
      function s2(e4) {
        n2.call(this, "ConvertWorker to " + e4), this.destType = e4;
      }
      i2.inherits(s2, n2), s2.prototype.processChunk = function(e4) {
        this.push({ data: i2.transformTo(this.destType, e4.data), meta: e4.meta });
      }, t2.exports = s2;
    }, { "../utils": 32, "./GenericWorker": 28 }], 25: [function(e3, t2, r2) {
      var n2 = e3("./GenericWorker"), i2 = e3("../crc32");
      function s2() {
        n2.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
      }
      e3("../utils").inherits(s2, n2), s2.prototype.processChunk = function(e4) {
        this.streamInfo.crc32 = i2(e4.data, this.streamInfo.crc32 || 0), this.push(e4);
      }, t2.exports = s2;
    }, { "../crc32": 4, "../utils": 32, "./GenericWorker": 28 }], 26: [function(e3, t2, r2) {
      var n2 = e3("../utils"), i2 = e3("./GenericWorker");
      function s2(e4) {
        i2.call(this, "DataLengthProbe for " + e4), this.propName = e4, this.withStreamInfo(e4, 0);
      }
      n2.inherits(s2, i2), s2.prototype.processChunk = function(e4) {
        if (e4) {
          var t3 = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = t3 + e4.data.length;
        }
        i2.prototype.processChunk.call(this, e4);
      }, t2.exports = s2;
    }, { "../utils": 32, "./GenericWorker": 28 }], 27: [function(e3, t2, r2) {
      var n2 = e3("../utils"), i2 = e3("./GenericWorker");
      function s2(e4) {
        i2.call(this, "DataWorker");
        var t3 = this;
        this.dataIsReady = false, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = false, e4.then(function(e5) {
          t3.dataIsReady = true, t3.data = e5, t3.max = e5 && e5.length || 0, t3.type = n2.getTypeOf(e5), t3.isPaused || t3._tickAndRepeat();
        }, function(e5) {
          t3.error(e5);
        });
      }
      n2.inherits(s2, i2), s2.prototype.cleanUp = function() {
        i2.prototype.cleanUp.call(this), this.data = null;
      }, s2.prototype.resume = function() {
        return !!i2.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = true, n2.delay(this._tickAndRepeat, [], this)), true);
      }, s2.prototype._tickAndRepeat = function() {
        this._tickScheduled = false, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n2.delay(this._tickAndRepeat, [], this), this._tickScheduled = true));
      }, s2.prototype._tick = function() {
        if (this.isPaused || this.isFinished)
          return false;
        var e4 = null, t3 = Math.min(this.max, this.index + 16384);
        if (this.index >= this.max)
          return this.end();
        switch (this.type) {
          case "string":
            e4 = this.data.substring(this.index, t3);
            break;
          case "uint8array":
            e4 = this.data.subarray(this.index, t3);
            break;
          case "array":
          case "nodebuffer":
            e4 = this.data.slice(this.index, t3);
        }
        return this.index = t3, this.push({ data: e4, meta: { percent: this.max ? this.index / this.max * 100 : 0 } });
      }, t2.exports = s2;
    }, { "../utils": 32, "./GenericWorker": 28 }], 28: [function(e3, t2, r2) {
      function n2(e4) {
        this.name = e4 || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = true, this.isFinished = false, this.isLocked = false, this._listeners = { data: [], end: [], error: [] }, this.previous = null;
      }
      n2.prototype = { push: function(e4) {
        this.emit("data", e4);
      }, end: function() {
        if (this.isFinished)
          return false;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = true;
        } catch (e4) {
          this.emit("error", e4);
        }
        return true;
      }, error: function(e4) {
        return !this.isFinished && (this.isPaused ? this.generatedError = e4 : (this.isFinished = true, this.emit("error", e4), this.previous && this.previous.error(e4), this.cleanUp()), true);
      }, on: function(e4, t3) {
        return this._listeners[e4].push(t3), this;
      }, cleanUp: function() {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
      }, emit: function(e4, t3) {
        if (this._listeners[e4])
          for (var r3 = 0; r3 < this._listeners[e4].length; r3++)
            this._listeners[e4][r3].call(this, t3);
      }, pipe: function(e4) {
        return e4.registerPrevious(this);
      }, registerPrevious: function(e4) {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = e4.streamInfo, this.mergeStreamInfo(), this.previous = e4;
        var t3 = this;
        return e4.on("data", function(e5) {
          t3.processChunk(e5);
        }), e4.on("end", function() {
          t3.end();
        }), e4.on("error", function(e5) {
          t3.error(e5);
        }), this;
      }, pause: function() {
        return !this.isPaused && !this.isFinished && (this.isPaused = true, this.previous && this.previous.pause(), true);
      }, resume: function() {
        if (!this.isPaused || this.isFinished)
          return false;
        var e4 = this.isPaused = false;
        return this.generatedError && (this.error(this.generatedError), e4 = true), this.previous && this.previous.resume(), !e4;
      }, flush: function() {
      }, processChunk: function(e4) {
        this.push(e4);
      }, withStreamInfo: function(e4, t3) {
        return this.extraStreamInfo[e4] = t3, this.mergeStreamInfo(), this;
      }, mergeStreamInfo: function() {
        for (var e4 in this.extraStreamInfo)
          Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e4) && (this.streamInfo[e4] = this.extraStreamInfo[e4]);
      }, lock: function() {
        if (this.isLocked)
          throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = true, this.previous && this.previous.lock();
      }, toString: function() {
        var e4 = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + e4 : e4;
      } }, t2.exports = n2;
    }, {}], 29: [function(e3, t2, r2) {
      var h2 = e3("../utils"), i2 = e3("./ConvertWorker"), s2 = e3("./GenericWorker"), u2 = e3("../base64"), n2 = e3("../support"), a2 = e3("../external"), o2 = null;
      if (n2.nodestream)
        try {
          o2 = e3("../nodejs/NodejsStreamOutputAdapter");
        } catch (e4) {
        }
      function l2(e4, o3) {
        return new a2.Promise(function(t3, r3) {
          var n3 = [], i3 = e4._internalType, s3 = e4._outputType, a3 = e4._mimeType;
          e4.on("data", function(e5, t4) {
            n3.push(e5), o3 && o3(t4);
          }).on("error", function(e5) {
            n3 = [], r3(e5);
          }).on("end", function() {
            try {
              var e5 = function(e6, t4, r4) {
                switch (e6) {
                  case "blob":
                    return h2.newBlob(h2.transformTo("arraybuffer", t4), r4);
                  case "base64":
                    return u2.encode(t4);
                  default:
                    return h2.transformTo(e6, t4);
                }
              }(s3, function(e6, t4) {
                var r4, n4 = 0, i4 = null, s4 = 0;
                for (r4 = 0; r4 < t4.length; r4++)
                  s4 += t4[r4].length;
                switch (e6) {
                  case "string":
                    return t4.join("");
                  case "array":
                    return Array.prototype.concat.apply([], t4);
                  case "uint8array":
                    for (i4 = new Uint8Array(s4), r4 = 0; r4 < t4.length; r4++)
                      i4.set(t4[r4], n4), n4 += t4[r4].length;
                    return i4;
                  case "nodebuffer":
                    return Buffer.concat(t4);
                  default:
                    throw new Error("concat : unsupported type '" + e6 + "'");
                }
              }(i3, n3), a3);
              t3(e5);
            } catch (e6) {
              r3(e6);
            }
            n3 = [];
          }).resume();
        });
      }
      function f2(e4, t3, r3) {
        var n3 = t3;
        switch (t3) {
          case "blob":
          case "arraybuffer":
            n3 = "uint8array";
            break;
          case "base64":
            n3 = "string";
        }
        try {
          this._internalType = n3, this._outputType = t3, this._mimeType = r3, h2.checkSupport(n3), this._worker = e4.pipe(new i2(n3)), e4.lock();
        } catch (e5) {
          this._worker = new s2("error"), this._worker.error(e5);
        }
      }
      f2.prototype = { accumulate: function(e4) {
        return l2(this, e4);
      }, on: function(e4, t3) {
        var r3 = this;
        return "data" === e4 ? this._worker.on(e4, function(e5) {
          t3.call(r3, e5.data, e5.meta);
        }) : this._worker.on(e4, function() {
          h2.delay(t3, arguments, r3);
        }), this;
      }, resume: function() {
        return h2.delay(this._worker.resume, [], this._worker), this;
      }, pause: function() {
        return this._worker.pause(), this;
      }, toNodejsStream: function(e4) {
        if (h2.checkSupport("nodestream"), "nodebuffer" !== this._outputType)
          throw new Error(this._outputType + " is not supported by this method");
        return new o2(this, { objectMode: "nodebuffer" !== this._outputType }, e4);
      } }, t2.exports = f2;
    }, { "../base64": 1, "../external": 6, "../nodejs/NodejsStreamOutputAdapter": 13, "../support": 30, "../utils": 32, "./ConvertWorker": 24, "./GenericWorker": 28 }], 30: [function(e3, t2, r2) {
      if (r2.base64 = true, r2.array = true, r2.string = true, r2.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r2.nodebuffer = "undefined" != typeof Buffer, r2.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer)
        r2.blob = false;
      else {
        var n2 = new ArrayBuffer(0);
        try {
          r2.blob = 0 === new Blob([n2], { type: "application/zip" }).size;
        } catch (e4) {
          try {
            var i2 = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            i2.append(n2), r2.blob = 0 === i2.getBlob("application/zip").size;
          } catch (e5) {
            r2.blob = false;
          }
        }
      }
      try {
        r2.nodestream = !!e3("readable-stream").Readable;
      } catch (e4) {
        r2.nodestream = false;
      }
    }, { "readable-stream": 16 }], 31: [function(e3, t2, s2) {
      for (var o2 = e3("./utils"), h2 = e3("./support"), r2 = e3("./nodejsUtils"), n2 = e3("./stream/GenericWorker"), u2 = new Array(256), i2 = 0; i2 < 256; i2++)
        u2[i2] = 252 <= i2 ? 6 : 248 <= i2 ? 5 : 240 <= i2 ? 4 : 224 <= i2 ? 3 : 192 <= i2 ? 2 : 1;
      u2[254] = u2[254] = 1;
      function a2() {
        n2.call(this, "utf-8 decode"), this.leftOver = null;
      }
      function l2() {
        n2.call(this, "utf-8 encode");
      }
      s2.utf8encode = function(e4) {
        return h2.nodebuffer ? r2.newBufferFrom(e4, "utf-8") : function(e5) {
          var t3, r3, n3, i3, s3, a3 = e5.length, o3 = 0;
          for (i3 = 0; i3 < a3; i3++)
            55296 == (64512 & (r3 = e5.charCodeAt(i3))) && i3 + 1 < a3 && 56320 == (64512 & (n3 = e5.charCodeAt(i3 + 1))) && (r3 = 65536 + (r3 - 55296 << 10) + (n3 - 56320), i3++), o3 += r3 < 128 ? 1 : r3 < 2048 ? 2 : r3 < 65536 ? 3 : 4;
          for (t3 = h2.uint8array ? new Uint8Array(o3) : new Array(o3), i3 = s3 = 0; s3 < o3; i3++)
            55296 == (64512 & (r3 = e5.charCodeAt(i3))) && i3 + 1 < a3 && 56320 == (64512 & (n3 = e5.charCodeAt(i3 + 1))) && (r3 = 65536 + (r3 - 55296 << 10) + (n3 - 56320), i3++), r3 < 128 ? t3[s3++] = r3 : (r3 < 2048 ? t3[s3++] = 192 | r3 >>> 6 : (r3 < 65536 ? t3[s3++] = 224 | r3 >>> 12 : (t3[s3++] = 240 | r3 >>> 18, t3[s3++] = 128 | r3 >>> 12 & 63), t3[s3++] = 128 | r3 >>> 6 & 63), t3[s3++] = 128 | 63 & r3);
          return t3;
        }(e4);
      }, s2.utf8decode = function(e4) {
        return h2.nodebuffer ? o2.transformTo("nodebuffer", e4).toString("utf-8") : function(e5) {
          var t3, r3, n3, i3, s3 = e5.length, a3 = new Array(2 * s3);
          for (t3 = r3 = 0; t3 < s3; )
            if ((n3 = e5[t3++]) < 128)
              a3[r3++] = n3;
            else if (4 < (i3 = u2[n3]))
              a3[r3++] = 65533, t3 += i3 - 1;
            else {
              for (n3 &= 2 === i3 ? 31 : 3 === i3 ? 15 : 7; 1 < i3 && t3 < s3; )
                n3 = n3 << 6 | 63 & e5[t3++], i3--;
              1 < i3 ? a3[r3++] = 65533 : n3 < 65536 ? a3[r3++] = n3 : (n3 -= 65536, a3[r3++] = 55296 | n3 >> 10 & 1023, a3[r3++] = 56320 | 1023 & n3);
            }
          return a3.length !== r3 && (a3.subarray ? a3 = a3.subarray(0, r3) : a3.length = r3), o2.applyFromCharCode(a3);
        }(e4 = o2.transformTo(h2.uint8array ? "uint8array" : "array", e4));
      }, o2.inherits(a2, n2), a2.prototype.processChunk = function(e4) {
        var t3 = o2.transformTo(h2.uint8array ? "uint8array" : "array", e4.data);
        if (this.leftOver && this.leftOver.length) {
          if (h2.uint8array) {
            var r3 = t3;
            (t3 = new Uint8Array(r3.length + this.leftOver.length)).set(this.leftOver, 0), t3.set(r3, this.leftOver.length);
          } else
            t3 = this.leftOver.concat(t3);
          this.leftOver = null;
        }
        var n3 = function(e5, t4) {
          var r4;
          for ((t4 = t4 || e5.length) > e5.length && (t4 = e5.length), r4 = t4 - 1; 0 <= r4 && 128 == (192 & e5[r4]); )
            r4--;
          return r4 < 0 ? t4 : 0 === r4 ? t4 : r4 + u2[e5[r4]] > t4 ? r4 : t4;
        }(t3), i3 = t3;
        n3 !== t3.length && (h2.uint8array ? (i3 = t3.subarray(0, n3), this.leftOver = t3.subarray(n3, t3.length)) : (i3 = t3.slice(0, n3), this.leftOver = t3.slice(n3, t3.length))), this.push({ data: s2.utf8decode(i3), meta: e4.meta });
      }, a2.prototype.flush = function() {
        this.leftOver && this.leftOver.length && (this.push({ data: s2.utf8decode(this.leftOver), meta: {} }), this.leftOver = null);
      }, s2.Utf8DecodeWorker = a2, o2.inherits(l2, n2), l2.prototype.processChunk = function(e4) {
        this.push({ data: s2.utf8encode(e4.data), meta: e4.meta });
      }, s2.Utf8EncodeWorker = l2;
    }, { "./nodejsUtils": 14, "./stream/GenericWorker": 28, "./support": 30, "./utils": 32 }], 32: [function(e3, t2, a2) {
      var o2 = e3("./support"), h2 = e3("./base64"), r2 = e3("./nodejsUtils"), u2 = e3("./external");
      function n2(e4) {
        return e4;
      }
      function l2(e4, t3) {
        for (var r3 = 0; r3 < e4.length; ++r3)
          t3[r3] = 255 & e4.charCodeAt(r3);
        return t3;
      }
      e3("setimmediate"), a2.newBlob = function(t3, r3) {
        a2.checkSupport("blob");
        try {
          return new Blob([t3], { type: r3 });
        } catch (e4) {
          try {
            var n3 = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder)();
            return n3.append(t3), n3.getBlob(r3);
          } catch (e5) {
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      var i2 = { stringifyByChunk: function(e4, t3, r3) {
        var n3 = [], i3 = 0, s3 = e4.length;
        if (s3 <= r3)
          return String.fromCharCode.apply(null, e4);
        for (; i3 < s3; )
          "array" === t3 || "nodebuffer" === t3 ? n3.push(String.fromCharCode.apply(null, e4.slice(i3, Math.min(i3 + r3, s3)))) : n3.push(String.fromCharCode.apply(null, e4.subarray(i3, Math.min(i3 + r3, s3)))), i3 += r3;
        return n3.join("");
      }, stringifyByChar: function(e4) {
        for (var t3 = "", r3 = 0; r3 < e4.length; r3++)
          t3 += String.fromCharCode(e4[r3]);
        return t3;
      }, applyCanBeUsed: { uint8array: function() {
        try {
          return o2.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
        } catch (e4) {
          return false;
        }
      }(), nodebuffer: function() {
        try {
          return o2.nodebuffer && 1 === String.fromCharCode.apply(null, r2.allocBuffer(1)).length;
        } catch (e4) {
          return false;
        }
      }() } };
      function s2(e4) {
        var t3 = 65536, r3 = a2.getTypeOf(e4), n3 = true;
        if ("uint8array" === r3 ? n3 = i2.applyCanBeUsed.uint8array : "nodebuffer" === r3 && (n3 = i2.applyCanBeUsed.nodebuffer), n3)
          for (; 1 < t3; )
            try {
              return i2.stringifyByChunk(e4, r3, t3);
            } catch (e5) {
              t3 = Math.floor(t3 / 2);
            }
        return i2.stringifyByChar(e4);
      }
      function f2(e4, t3) {
        for (var r3 = 0; r3 < e4.length; r3++)
          t3[r3] = e4[r3];
        return t3;
      }
      a2.applyFromCharCode = s2;
      var c2 = {};
      c2.string = { string: n2, array: function(e4) {
        return l2(e4, new Array(e4.length));
      }, arraybuffer: function(e4) {
        return c2.string.uint8array(e4).buffer;
      }, uint8array: function(e4) {
        return l2(e4, new Uint8Array(e4.length));
      }, nodebuffer: function(e4) {
        return l2(e4, r2.allocBuffer(e4.length));
      } }, c2.array = { string: s2, array: n2, arraybuffer: function(e4) {
        return new Uint8Array(e4).buffer;
      }, uint8array: function(e4) {
        return new Uint8Array(e4);
      }, nodebuffer: function(e4) {
        return r2.newBufferFrom(e4);
      } }, c2.arraybuffer = { string: function(e4) {
        return s2(new Uint8Array(e4));
      }, array: function(e4) {
        return f2(new Uint8Array(e4), new Array(e4.byteLength));
      }, arraybuffer: n2, uint8array: function(e4) {
        return new Uint8Array(e4);
      }, nodebuffer: function(e4) {
        return r2.newBufferFrom(new Uint8Array(e4));
      } }, c2.uint8array = { string: s2, array: function(e4) {
        return f2(e4, new Array(e4.length));
      }, arraybuffer: function(e4) {
        return e4.buffer;
      }, uint8array: n2, nodebuffer: function(e4) {
        return r2.newBufferFrom(e4);
      } }, c2.nodebuffer = { string: s2, array: function(e4) {
        return f2(e4, new Array(e4.length));
      }, arraybuffer: function(e4) {
        return c2.nodebuffer.uint8array(e4).buffer;
      }, uint8array: function(e4) {
        return f2(e4, new Uint8Array(e4.length));
      }, nodebuffer: n2 }, a2.transformTo = function(e4, t3) {
        if (t3 = t3 || "", !e4)
          return t3;
        a2.checkSupport(e4);
        var r3 = a2.getTypeOf(t3);
        return c2[r3][e4](t3);
      }, a2.resolve = function(e4) {
        for (var t3 = e4.split("/"), r3 = [], n3 = 0; n3 < t3.length; n3++) {
          var i3 = t3[n3];
          "." === i3 || "" === i3 && 0 !== n3 && n3 !== t3.length - 1 || (".." === i3 ? r3.pop() : r3.push(i3));
        }
        return r3.join("/");
      }, a2.getTypeOf = function(e4) {
        return "string" == typeof e4 ? "string" : "[object Array]" === Object.prototype.toString.call(e4) ? "array" : o2.nodebuffer && r2.isBuffer(e4) ? "nodebuffer" : o2.uint8array && e4 instanceof Uint8Array ? "uint8array" : o2.arraybuffer && e4 instanceof ArrayBuffer ? "arraybuffer" : void 0;
      }, a2.checkSupport = function(e4) {
        if (!o2[e4.toLowerCase()])
          throw new Error(e4 + " is not supported by this platform");
      }, a2.MAX_VALUE_16BITS = 65535, a2.MAX_VALUE_32BITS = -1, a2.pretty = function(e4) {
        var t3, r3, n3 = "";
        for (r3 = 0; r3 < (e4 || "").length; r3++)
          n3 += "\\x" + ((t3 = e4.charCodeAt(r3)) < 16 ? "0" : "") + t3.toString(16).toUpperCase();
        return n3;
      }, a2.delay = function(e4, t3, r3) {
        setImmediate(function() {
          e4.apply(r3 || null, t3 || []);
        });
      }, a2.inherits = function(e4, t3) {
        function r3() {
        }
        r3.prototype = t3.prototype, e4.prototype = new r3();
      }, a2.extend = function() {
        var e4, t3, r3 = {};
        for (e4 = 0; e4 < arguments.length; e4++)
          for (t3 in arguments[e4])
            Object.prototype.hasOwnProperty.call(arguments[e4], t3) && void 0 === r3[t3] && (r3[t3] = arguments[e4][t3]);
        return r3;
      }, a2.prepareContent = function(r3, e4, n3, i3, s3) {
        return u2.Promise.resolve(e4).then(function(n4) {
          return o2.blob && (n4 instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(n4))) && "undefined" != typeof FileReader ? new u2.Promise(function(t3, r4) {
            var e5 = new FileReader();
            e5.onload = function(e6) {
              t3(e6.target.result);
            }, e5.onerror = function(e6) {
              r4(e6.target.error);
            }, e5.readAsArrayBuffer(n4);
          }) : n4;
        }).then(function(e5) {
          var t3 = a2.getTypeOf(e5);
          return t3 ? ("arraybuffer" === t3 ? e5 = a2.transformTo("uint8array", e5) : "string" === t3 && (s3 ? e5 = h2.decode(e5) : n3 && true !== i3 && (e5 = function(e6) {
            return l2(e6, o2.uint8array ? new Uint8Array(e6.length) : new Array(e6.length));
          }(e5))), e5) : u2.Promise.reject(new Error("Can't read the data of '" + r3 + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
        });
      };
    }, { "./base64": 1, "./external": 6, "./nodejsUtils": 14, "./support": 30, setimmediate: 54 }], 33: [function(e3, t2, r2) {
      var n2 = e3("./reader/readerFor"), i2 = e3("./utils"), s2 = e3("./signature"), a2 = e3("./zipEntry"), o2 = e3("./support");
      function h2(e4) {
        this.files = [], this.loadOptions = e4;
      }
      h2.prototype = { checkSignature: function(e4) {
        if (!this.reader.readAndCheckSignature(e4)) {
          this.reader.index -= 4;
          var t3 = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + i2.pretty(t3) + ", expected " + i2.pretty(e4) + ")");
        }
      }, isSignature: function(e4, t3) {
        var r3 = this.reader.index;
        this.reader.setIndex(e4);
        var n3 = this.reader.readString(4) === t3;
        return this.reader.setIndex(r3), n3;
      }, readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var e4 = this.reader.readData(this.zipCommentLength), t3 = o2.uint8array ? "uint8array" : "array", r3 = i2.transformTo(t3, e4);
        this.zipComment = this.loadOptions.decodeFileName(r3);
      }, readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var e4, t3, r3, n3 = this.zip64EndOfCentralSize - 44; 0 < n3; )
          e4 = this.reader.readInt(2), t3 = this.reader.readInt(4), r3 = this.reader.readData(t3), this.zip64ExtensibleData[e4] = { id: e4, length: t3, value: r3 };
      }, readBlockZip64EndOfCentralLocator: function() {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount)
          throw new Error("Multi-volumes zip are not supported");
      }, readLocalFiles: function() {
        var e4, t3;
        for (e4 = 0; e4 < this.files.length; e4++)
          t3 = this.files[e4], this.reader.setIndex(t3.localHeaderOffset), this.checkSignature(s2.LOCAL_FILE_HEADER), t3.readLocalPart(this.reader), t3.handleUTF8(), t3.processAttributes();
      }, readCentralDir: function() {
        var e4;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s2.CENTRAL_FILE_HEADER); )
          (e4 = new a2({ zip64: this.zip64 }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e4);
        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length)
          throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
      }, readEndOfCentral: function() {
        var e4 = this.reader.lastIndexOfSignature(s2.CENTRAL_DIRECTORY_END);
        if (e4 < 0)
          throw !this.isSignature(0, s2.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
        this.reader.setIndex(e4);
        var t3 = e4;
        if (this.checkSignature(s2.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i2.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i2.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i2.MAX_VALUE_16BITS || this.centralDirRecords === i2.MAX_VALUE_16BITS || this.centralDirSize === i2.MAX_VALUE_32BITS || this.centralDirOffset === i2.MAX_VALUE_32BITS) {
          if (this.zip64 = true, (e4 = this.reader.lastIndexOfSignature(s2.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0)
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(e4), this.checkSignature(s2.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s2.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s2.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0))
            throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s2.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
        }
        var r3 = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (r3 += 20, r3 += 12 + this.zip64EndOfCentralSize);
        var n3 = t3 - r3;
        if (0 < n3)
          this.isSignature(t3, s2.CENTRAL_FILE_HEADER) || (this.reader.zero = n3);
        else if (n3 < 0)
          throw new Error("Corrupted zip: missing " + Math.abs(n3) + " bytes.");
      }, prepareReader: function(e4) {
        this.reader = n2(e4);
      }, load: function(e4) {
        this.prepareReader(e4), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
      } }, t2.exports = h2;
    }, { "./reader/readerFor": 22, "./signature": 23, "./support": 30, "./utils": 32, "./zipEntry": 34 }], 34: [function(e3, t2, r2) {
      var n2 = e3("./reader/readerFor"), s2 = e3("./utils"), i2 = e3("./compressedObject"), a2 = e3("./crc32"), o2 = e3("./utf8"), h2 = e3("./compressions"), u2 = e3("./support");
      function l2(e4, t3) {
        this.options = e4, this.loadOptions = t3;
      }
      l2.prototype = { isEncrypted: function() {
        return 1 == (1 & this.bitFlag);
      }, useUTF8: function() {
        return 2048 == (2048 & this.bitFlag);
      }, readLocalPart: function(e4) {
        var t3, r3;
        if (e4.skip(22), this.fileNameLength = e4.readInt(2), r3 = e4.readInt(2), this.fileName = e4.readData(this.fileNameLength), e4.skip(r3), -1 === this.compressedSize || -1 === this.uncompressedSize)
          throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if (null === (t3 = function(e5) {
          for (var t4 in h2)
            if (Object.prototype.hasOwnProperty.call(h2, t4) && h2[t4].magic === e5)
              return h2[t4];
          return null;
        }(this.compressionMethod)))
          throw new Error("Corrupted zip : compression " + s2.pretty(this.compressionMethod) + " unknown (inner file : " + s2.transformTo("string", this.fileName) + ")");
        this.decompressed = new i2(this.compressedSize, this.uncompressedSize, this.crc32, t3, e4.readData(this.compressedSize));
      }, readCentralPart: function(e4) {
        this.versionMadeBy = e4.readInt(2), e4.skip(2), this.bitFlag = e4.readInt(2), this.compressionMethod = e4.readString(2), this.date = e4.readDate(), this.crc32 = e4.readInt(4), this.compressedSize = e4.readInt(4), this.uncompressedSize = e4.readInt(4);
        var t3 = e4.readInt(2);
        if (this.extraFieldsLength = e4.readInt(2), this.fileCommentLength = e4.readInt(2), this.diskNumberStart = e4.readInt(2), this.internalFileAttributes = e4.readInt(2), this.externalFileAttributes = e4.readInt(4), this.localHeaderOffset = e4.readInt(4), this.isEncrypted())
          throw new Error("Encrypted zip are not supported");
        e4.skip(t3), this.readExtraFields(e4), this.parseZIP64ExtraField(e4), this.fileComment = e4.readData(this.fileCommentLength);
      }, processAttributes: function() {
        this.unixPermissions = null, this.dosPermissions = null;
        var e4 = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), 0 == e4 && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e4 && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = true);
      }, parseZIP64ExtraField: function() {
        if (this.extraFields[1]) {
          var e4 = n2(this.extraFields[1].value);
          this.uncompressedSize === s2.MAX_VALUE_32BITS && (this.uncompressedSize = e4.readInt(8)), this.compressedSize === s2.MAX_VALUE_32BITS && (this.compressedSize = e4.readInt(8)), this.localHeaderOffset === s2.MAX_VALUE_32BITS && (this.localHeaderOffset = e4.readInt(8)), this.diskNumberStart === s2.MAX_VALUE_32BITS && (this.diskNumberStart = e4.readInt(4));
        }
      }, readExtraFields: function(e4) {
        var t3, r3, n3, i3 = e4.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); e4.index + 4 < i3; )
          t3 = e4.readInt(2), r3 = e4.readInt(2), n3 = e4.readData(r3), this.extraFields[t3] = { id: t3, length: r3, value: n3 };
        e4.setIndex(i3);
      }, handleUTF8: function() {
        var e4 = u2.uint8array ? "uint8array" : "array";
        if (this.useUTF8())
          this.fileNameStr = o2.utf8decode(this.fileName), this.fileCommentStr = o2.utf8decode(this.fileComment);
        else {
          var t3 = this.findExtraFieldUnicodePath();
          if (null !== t3)
            this.fileNameStr = t3;
          else {
            var r3 = s2.transformTo(e4, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(r3);
          }
          var n3 = this.findExtraFieldUnicodeComment();
          if (null !== n3)
            this.fileCommentStr = n3;
          else {
            var i3 = s2.transformTo(e4, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(i3);
          }
        }
      }, findExtraFieldUnicodePath: function() {
        var e4 = this.extraFields[28789];
        if (e4) {
          var t3 = n2(e4.value);
          return 1 !== t3.readInt(1) ? null : a2(this.fileName) !== t3.readInt(4) ? null : o2.utf8decode(t3.readData(e4.length - 5));
        }
        return null;
      }, findExtraFieldUnicodeComment: function() {
        var e4 = this.extraFields[25461];
        if (e4) {
          var t3 = n2(e4.value);
          return 1 !== t3.readInt(1) ? null : a2(this.fileComment) !== t3.readInt(4) ? null : o2.utf8decode(t3.readData(e4.length - 5));
        }
        return null;
      } }, t2.exports = l2;
    }, { "./compressedObject": 2, "./compressions": 3, "./crc32": 4, "./reader/readerFor": 22, "./support": 30, "./utf8": 31, "./utils": 32 }], 35: [function(e3, t2, r2) {
      function n2(e4, t3, r3) {
        this.name = e4, this.dir = r3.dir, this.date = r3.date, this.comment = r3.comment, this.unixPermissions = r3.unixPermissions, this.dosPermissions = r3.dosPermissions, this._data = t3, this._dataBinary = r3.binary, this.options = { compression: r3.compression, compressionOptions: r3.compressionOptions };
      }
      var s2 = e3("./stream/StreamHelper"), i2 = e3("./stream/DataWorker"), a2 = e3("./utf8"), o2 = e3("./compressedObject"), h2 = e3("./stream/GenericWorker");
      n2.prototype = { internalStream: function(e4) {
        var t3 = null, r3 = "string";
        try {
          if (!e4)
            throw new Error("No output type specified.");
          var n3 = "string" === (r3 = e4.toLowerCase()) || "text" === r3;
          "binarystring" !== r3 && "text" !== r3 || (r3 = "string"), t3 = this._decompressWorker();
          var i3 = !this._dataBinary;
          i3 && !n3 && (t3 = t3.pipe(new a2.Utf8EncodeWorker())), !i3 && n3 && (t3 = t3.pipe(new a2.Utf8DecodeWorker()));
        } catch (e5) {
          (t3 = new h2("error")).error(e5);
        }
        return new s2(t3, r3, "");
      }, async: function(e4, t3) {
        return this.internalStream(e4).accumulate(t3);
      }, nodeStream: function(e4, t3) {
        return this.internalStream(e4 || "nodebuffer").toNodejsStream(t3);
      }, _compressWorker: function(e4, t3) {
        if (this._data instanceof o2 && this._data.compression.magic === e4.magic)
          return this._data.getCompressedWorker();
        var r3 = this._decompressWorker();
        return this._dataBinary || (r3 = r3.pipe(new a2.Utf8EncodeWorker())), o2.createWorkerFrom(r3, e4, t3);
      }, _decompressWorker: function() {
        return this._data instanceof o2 ? this._data.getContentWorker() : this._data instanceof h2 ? this._data : new i2(this._data);
      } };
      for (var u2 = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], l2 = function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      }, f2 = 0; f2 < u2.length; f2++)
        n2.prototype[u2[f2]] = l2;
      t2.exports = n2;
    }, { "./compressedObject": 2, "./stream/DataWorker": 27, "./stream/GenericWorker": 28, "./stream/StreamHelper": 29, "./utf8": 31 }], 36: [function(e3, l2, t2) {
      (function(t3) {
        var r2, n2, e4 = t3.MutationObserver || t3.WebKitMutationObserver;
        if (e4) {
          var i2 = 0, s2 = new e4(u2), a2 = t3.document.createTextNode("");
          s2.observe(a2, { characterData: true }), r2 = function() {
            a2.data = i2 = ++i2 % 2;
          };
        } else if (t3.setImmediate || void 0 === t3.MessageChannel)
          r2 = "document" in t3 && "onreadystatechange" in t3.document.createElement("script") ? function() {
            var e5 = t3.document.createElement("script");
            e5.onreadystatechange = function() {
              u2(), e5.onreadystatechange = null, e5.parentNode.removeChild(e5), e5 = null;
            }, t3.document.documentElement.appendChild(e5);
          } : function() {
            setTimeout(u2, 0);
          };
        else {
          var o2 = new t3.MessageChannel();
          o2.port1.onmessage = u2, r2 = function() {
            o2.port2.postMessage(0);
          };
        }
        var h2 = [];
        function u2() {
          var e5, t4;
          n2 = true;
          for (var r3 = h2.length; r3; ) {
            for (t4 = h2, h2 = [], e5 = -1; ++e5 < r3; )
              t4[e5]();
            r3 = h2.length;
          }
          n2 = false;
        }
        l2.exports = function(e5) {
          1 !== h2.push(e5) || n2 || r2();
        };
      }).call(this, "undefined" != typeof commonjsGlobal$1 ? commonjsGlobal$1 : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {}], 37: [function(e3, t2, r2) {
      var i2 = e3("immediate");
      function u2() {
      }
      var l2 = {}, s2 = ["REJECTED"], a2 = ["FULFILLED"], n2 = ["PENDING"];
      function o2(e4) {
        if ("function" != typeof e4)
          throw new TypeError("resolver must be a function");
        this.state = n2, this.queue = [], this.outcome = void 0, e4 !== u2 && d2(this, e4);
      }
      function h2(e4, t3, r3) {
        this.promise = e4, "function" == typeof t3 && (this.onFulfilled = t3, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r3 && (this.onRejected = r3, this.callRejected = this.otherCallRejected);
      }
      function f2(t3, r3, n3) {
        i2(function() {
          var e4;
          try {
            e4 = r3(n3);
          } catch (e5) {
            return l2.reject(t3, e5);
          }
          e4 === t3 ? l2.reject(t3, new TypeError("Cannot resolve promise with itself")) : l2.resolve(t3, e4);
        });
      }
      function c2(e4) {
        var t3 = e4 && e4.then;
        if (e4 && ("object" == typeof e4 || "function" == typeof e4) && "function" == typeof t3)
          return function() {
            t3.apply(e4, arguments);
          };
      }
      function d2(t3, e4) {
        var r3 = false;
        function n3(e5) {
          r3 || (r3 = true, l2.reject(t3, e5));
        }
        function i3(e5) {
          r3 || (r3 = true, l2.resolve(t3, e5));
        }
        var s3 = p2(function() {
          e4(i3, n3);
        });
        "error" === s3.status && n3(s3.value);
      }
      function p2(e4, t3) {
        var r3 = {};
        try {
          r3.value = e4(t3), r3.status = "success";
        } catch (e5) {
          r3.status = "error", r3.value = e5;
        }
        return r3;
      }
      (t2.exports = o2).prototype.finally = function(t3) {
        if ("function" != typeof t3)
          return this;
        var r3 = this.constructor;
        return this.then(function(e4) {
          return r3.resolve(t3()).then(function() {
            return e4;
          });
        }, function(e4) {
          return r3.resolve(t3()).then(function() {
            throw e4;
          });
        });
      }, o2.prototype.catch = function(e4) {
        return this.then(null, e4);
      }, o2.prototype.then = function(e4, t3) {
        if ("function" != typeof e4 && this.state === a2 || "function" != typeof t3 && this.state === s2)
          return this;
        var r3 = new this.constructor(u2);
        this.state !== n2 ? f2(r3, this.state === a2 ? e4 : t3, this.outcome) : this.queue.push(new h2(r3, e4, t3));
        return r3;
      }, h2.prototype.callFulfilled = function(e4) {
        l2.resolve(this.promise, e4);
      }, h2.prototype.otherCallFulfilled = function(e4) {
        f2(this.promise, this.onFulfilled, e4);
      }, h2.prototype.callRejected = function(e4) {
        l2.reject(this.promise, e4);
      }, h2.prototype.otherCallRejected = function(e4) {
        f2(this.promise, this.onRejected, e4);
      }, l2.resolve = function(e4, t3) {
        var r3 = p2(c2, t3);
        if ("error" === r3.status)
          return l2.reject(e4, r3.value);
        var n3 = r3.value;
        if (n3)
          d2(e4, n3);
        else {
          e4.state = a2, e4.outcome = t3;
          for (var i3 = -1, s3 = e4.queue.length; ++i3 < s3; )
            e4.queue[i3].callFulfilled(t3);
        }
        return e4;
      }, l2.reject = function(e4, t3) {
        e4.state = s2, e4.outcome = t3;
        for (var r3 = -1, n3 = e4.queue.length; ++r3 < n3; )
          e4.queue[r3].callRejected(t3);
        return e4;
      }, o2.resolve = function(e4) {
        if (e4 instanceof this)
          return e4;
        return l2.resolve(new this(u2), e4);
      }, o2.reject = function(e4) {
        var t3 = new this(u2);
        return l2.reject(t3, e4);
      }, o2.all = function(e4) {
        var r3 = this;
        if ("[object Array]" !== Object.prototype.toString.call(e4))
          return this.reject(new TypeError("must be an array"));
        var n3 = e4.length, i3 = false;
        if (!n3)
          return this.resolve([]);
        var s3 = new Array(n3), a3 = 0, t3 = -1, o3 = new this(u2);
        for (; ++t3 < n3; )
          h3(e4[t3], t3);
        return o3;
        function h3(e5, t4) {
          r3.resolve(e5).then(function(e6) {
            s3[t4] = e6, ++a3 !== n3 || i3 || (i3 = true, l2.resolve(o3, s3));
          }, function(e6) {
            i3 || (i3 = true, l2.reject(o3, e6));
          });
        }
      }, o2.race = function(e4) {
        var t3 = this;
        if ("[object Array]" !== Object.prototype.toString.call(e4))
          return this.reject(new TypeError("must be an array"));
        var r3 = e4.length, n3 = false;
        if (!r3)
          return this.resolve([]);
        var i3 = -1, s3 = new this(u2);
        for (; ++i3 < r3; )
          a3 = e4[i3], t3.resolve(a3).then(function(e5) {
            n3 || (n3 = true, l2.resolve(s3, e5));
          }, function(e5) {
            n3 || (n3 = true, l2.reject(s3, e5));
          });
        var a3;
        return s3;
      };
    }, { immediate: 36 }], 38: [function(e3, t2, r2) {
      var n2 = {};
      (0, e3("./lib/utils/common").assign)(n2, e3("./lib/deflate"), e3("./lib/inflate"), e3("./lib/zlib/constants")), t2.exports = n2;
    }, { "./lib/deflate": 39, "./lib/inflate": 40, "./lib/utils/common": 41, "./lib/zlib/constants": 44 }], 39: [function(e3, t2, r2) {
      var a2 = e3("./zlib/deflate"), o2 = e3("./utils/common"), h2 = e3("./utils/strings"), i2 = e3("./zlib/messages"), s2 = e3("./zlib/zstream"), u2 = Object.prototype.toString, l2 = 0, f2 = -1, c2 = 0, d2 = 8;
      function p2(e4) {
        if (!(this instanceof p2))
          return new p2(e4);
        this.options = o2.assign({ level: f2, method: d2, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: c2, to: "" }, e4 || {});
        var t3 = this.options;
        t3.raw && 0 < t3.windowBits ? t3.windowBits = -t3.windowBits : t3.gzip && 0 < t3.windowBits && t3.windowBits < 16 && (t3.windowBits += 16), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new s2(), this.strm.avail_out = 0;
        var r3 = a2.deflateInit2(this.strm, t3.level, t3.method, t3.windowBits, t3.memLevel, t3.strategy);
        if (r3 !== l2)
          throw new Error(i2[r3]);
        if (t3.header && a2.deflateSetHeader(this.strm, t3.header), t3.dictionary) {
          var n3;
          if (n3 = "string" == typeof t3.dictionary ? h2.string2buf(t3.dictionary) : "[object ArrayBuffer]" === u2.call(t3.dictionary) ? new Uint8Array(t3.dictionary) : t3.dictionary, (r3 = a2.deflateSetDictionary(this.strm, n3)) !== l2)
            throw new Error(i2[r3]);
          this._dict_set = true;
        }
      }
      function n2(e4, t3) {
        var r3 = new p2(t3);
        if (r3.push(e4, true), r3.err)
          throw r3.msg || i2[r3.err];
        return r3.result;
      }
      p2.prototype.push = function(e4, t3) {
        var r3, n3, i3 = this.strm, s3 = this.options.chunkSize;
        if (this.ended)
          return false;
        n3 = t3 === ~~t3 ? t3 : true === t3 ? 4 : 0, "string" == typeof e4 ? i3.input = h2.string2buf(e4) : "[object ArrayBuffer]" === u2.call(e4) ? i3.input = new Uint8Array(e4) : i3.input = e4, i3.next_in = 0, i3.avail_in = i3.input.length;
        do {
          if (0 === i3.avail_out && (i3.output = new o2.Buf8(s3), i3.next_out = 0, i3.avail_out = s3), 1 !== (r3 = a2.deflate(i3, n3)) && r3 !== l2)
            return this.onEnd(r3), !(this.ended = true);
          0 !== i3.avail_out && (0 !== i3.avail_in || 4 !== n3 && 2 !== n3) || ("string" === this.options.to ? this.onData(h2.buf2binstring(o2.shrinkBuf(i3.output, i3.next_out))) : this.onData(o2.shrinkBuf(i3.output, i3.next_out)));
        } while ((0 < i3.avail_in || 0 === i3.avail_out) && 1 !== r3);
        return 4 === n3 ? (r3 = a2.deflateEnd(this.strm), this.onEnd(r3), this.ended = true, r3 === l2) : 2 !== n3 || (this.onEnd(l2), !(i3.avail_out = 0));
      }, p2.prototype.onData = function(e4) {
        this.chunks.push(e4);
      }, p2.prototype.onEnd = function(e4) {
        e4 === l2 && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o2.flattenChunks(this.chunks)), this.chunks = [], this.err = e4, this.msg = this.strm.msg;
      }, r2.Deflate = p2, r2.deflate = n2, r2.deflateRaw = function(e4, t3) {
        return (t3 = t3 || {}).raw = true, n2(e4, t3);
      }, r2.gzip = function(e4, t3) {
        return (t3 = t3 || {}).gzip = true, n2(e4, t3);
      };
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/deflate": 46, "./zlib/messages": 51, "./zlib/zstream": 53 }], 40: [function(e3, t2, r2) {
      var c2 = e3("./zlib/inflate"), d2 = e3("./utils/common"), p2 = e3("./utils/strings"), m2 = e3("./zlib/constants"), n2 = e3("./zlib/messages"), i2 = e3("./zlib/zstream"), s2 = e3("./zlib/gzheader"), _2 = Object.prototype.toString;
      function a2(e4) {
        if (!(this instanceof a2))
          return new a2(e4);
        this.options = d2.assign({ chunkSize: 16384, windowBits: 0, to: "" }, e4 || {});
        var t3 = this.options;
        t3.raw && 0 <= t3.windowBits && t3.windowBits < 16 && (t3.windowBits = -t3.windowBits, 0 === t3.windowBits && (t3.windowBits = -15)), !(0 <= t3.windowBits && t3.windowBits < 16) || e4 && e4.windowBits || (t3.windowBits += 32), 15 < t3.windowBits && t3.windowBits < 48 && 0 == (15 & t3.windowBits) && (t3.windowBits |= 15), this.err = 0, this.msg = "", this.ended = false, this.chunks = [], this.strm = new i2(), this.strm.avail_out = 0;
        var r3 = c2.inflateInit2(this.strm, t3.windowBits);
        if (r3 !== m2.Z_OK)
          throw new Error(n2[r3]);
        this.header = new s2(), c2.inflateGetHeader(this.strm, this.header);
      }
      function o2(e4, t3) {
        var r3 = new a2(t3);
        if (r3.push(e4, true), r3.err)
          throw r3.msg || n2[r3.err];
        return r3.result;
      }
      a2.prototype.push = function(e4, t3) {
        var r3, n3, i3, s3, a3, o3, h2 = this.strm, u2 = this.options.chunkSize, l2 = this.options.dictionary, f2 = false;
        if (this.ended)
          return false;
        n3 = t3 === ~~t3 ? t3 : true === t3 ? m2.Z_FINISH : m2.Z_NO_FLUSH, "string" == typeof e4 ? h2.input = p2.binstring2buf(e4) : "[object ArrayBuffer]" === _2.call(e4) ? h2.input = new Uint8Array(e4) : h2.input = e4, h2.next_in = 0, h2.avail_in = h2.input.length;
        do {
          if (0 === h2.avail_out && (h2.output = new d2.Buf8(u2), h2.next_out = 0, h2.avail_out = u2), (r3 = c2.inflate(h2, m2.Z_NO_FLUSH)) === m2.Z_NEED_DICT && l2 && (o3 = "string" == typeof l2 ? p2.string2buf(l2) : "[object ArrayBuffer]" === _2.call(l2) ? new Uint8Array(l2) : l2, r3 = c2.inflateSetDictionary(this.strm, o3)), r3 === m2.Z_BUF_ERROR && true === f2 && (r3 = m2.Z_OK, f2 = false), r3 !== m2.Z_STREAM_END && r3 !== m2.Z_OK)
            return this.onEnd(r3), !(this.ended = true);
          h2.next_out && (0 !== h2.avail_out && r3 !== m2.Z_STREAM_END && (0 !== h2.avail_in || n3 !== m2.Z_FINISH && n3 !== m2.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i3 = p2.utf8border(h2.output, h2.next_out), s3 = h2.next_out - i3, a3 = p2.buf2string(h2.output, i3), h2.next_out = s3, h2.avail_out = u2 - s3, s3 && d2.arraySet(h2.output, h2.output, i3, s3, 0), this.onData(a3)) : this.onData(d2.shrinkBuf(h2.output, h2.next_out)))), 0 === h2.avail_in && 0 === h2.avail_out && (f2 = true);
        } while ((0 < h2.avail_in || 0 === h2.avail_out) && r3 !== m2.Z_STREAM_END);
        return r3 === m2.Z_STREAM_END && (n3 = m2.Z_FINISH), n3 === m2.Z_FINISH ? (r3 = c2.inflateEnd(this.strm), this.onEnd(r3), this.ended = true, r3 === m2.Z_OK) : n3 !== m2.Z_SYNC_FLUSH || (this.onEnd(m2.Z_OK), !(h2.avail_out = 0));
      }, a2.prototype.onData = function(e4) {
        this.chunks.push(e4);
      }, a2.prototype.onEnd = function(e4) {
        e4 === m2.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d2.flattenChunks(this.chunks)), this.chunks = [], this.err = e4, this.msg = this.strm.msg;
      }, r2.Inflate = a2, r2.inflate = o2, r2.inflateRaw = function(e4, t3) {
        return (t3 = t3 || {}).raw = true, o2(e4, t3);
      }, r2.ungzip = o2;
    }, { "./utils/common": 41, "./utils/strings": 42, "./zlib/constants": 44, "./zlib/gzheader": 47, "./zlib/inflate": 49, "./zlib/messages": 51, "./zlib/zstream": 53 }], 41: [function(e3, t2, r2) {
      var n2 = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
      r2.assign = function(e4) {
        for (var t3 = Array.prototype.slice.call(arguments, 1); t3.length; ) {
          var r3 = t3.shift();
          if (r3) {
            if ("object" != typeof r3)
              throw new TypeError(r3 + "must be non-object");
            for (var n3 in r3)
              r3.hasOwnProperty(n3) && (e4[n3] = r3[n3]);
          }
        }
        return e4;
      }, r2.shrinkBuf = function(e4, t3) {
        return e4.length === t3 ? e4 : e4.subarray ? e4.subarray(0, t3) : (e4.length = t3, e4);
      };
      var i2 = { arraySet: function(e4, t3, r3, n3, i3) {
        if (t3.subarray && e4.subarray)
          e4.set(t3.subarray(r3, r3 + n3), i3);
        else
          for (var s3 = 0; s3 < n3; s3++)
            e4[i3 + s3] = t3[r3 + s3];
      }, flattenChunks: function(e4) {
        var t3, r3, n3, i3, s3, a2;
        for (t3 = n3 = 0, r3 = e4.length; t3 < r3; t3++)
          n3 += e4[t3].length;
        for (a2 = new Uint8Array(n3), t3 = i3 = 0, r3 = e4.length; t3 < r3; t3++)
          s3 = e4[t3], a2.set(s3, i3), i3 += s3.length;
        return a2;
      } }, s2 = { arraySet: function(e4, t3, r3, n3, i3) {
        for (var s3 = 0; s3 < n3; s3++)
          e4[i3 + s3] = t3[r3 + s3];
      }, flattenChunks: function(e4) {
        return [].concat.apply([], e4);
      } };
      r2.setTyped = function(e4) {
        e4 ? (r2.Buf8 = Uint8Array, r2.Buf16 = Uint16Array, r2.Buf32 = Int32Array, r2.assign(r2, i2)) : (r2.Buf8 = Array, r2.Buf16 = Array, r2.Buf32 = Array, r2.assign(r2, s2));
      }, r2.setTyped(n2);
    }, {}], 42: [function(e3, t2, r2) {
      var h2 = e3("./common"), i2 = true, s2 = true;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch (e4) {
        i2 = false;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (e4) {
        s2 = false;
      }
      for (var u2 = new h2.Buf8(256), n2 = 0; n2 < 256; n2++)
        u2[n2] = 252 <= n2 ? 6 : 248 <= n2 ? 5 : 240 <= n2 ? 4 : 224 <= n2 ? 3 : 192 <= n2 ? 2 : 1;
      function l2(e4, t3) {
        if (t3 < 65537 && (e4.subarray && s2 || !e4.subarray && i2))
          return String.fromCharCode.apply(null, h2.shrinkBuf(e4, t3));
        for (var r3 = "", n3 = 0; n3 < t3; n3++)
          r3 += String.fromCharCode(e4[n3]);
        return r3;
      }
      u2[254] = u2[254] = 1, r2.string2buf = function(e4) {
        var t3, r3, n3, i3, s3, a2 = e4.length, o2 = 0;
        for (i3 = 0; i3 < a2; i3++)
          55296 == (64512 & (r3 = e4.charCodeAt(i3))) && i3 + 1 < a2 && 56320 == (64512 & (n3 = e4.charCodeAt(i3 + 1))) && (r3 = 65536 + (r3 - 55296 << 10) + (n3 - 56320), i3++), o2 += r3 < 128 ? 1 : r3 < 2048 ? 2 : r3 < 65536 ? 3 : 4;
        for (t3 = new h2.Buf8(o2), i3 = s3 = 0; s3 < o2; i3++)
          55296 == (64512 & (r3 = e4.charCodeAt(i3))) && i3 + 1 < a2 && 56320 == (64512 & (n3 = e4.charCodeAt(i3 + 1))) && (r3 = 65536 + (r3 - 55296 << 10) + (n3 - 56320), i3++), r3 < 128 ? t3[s3++] = r3 : (r3 < 2048 ? t3[s3++] = 192 | r3 >>> 6 : (r3 < 65536 ? t3[s3++] = 224 | r3 >>> 12 : (t3[s3++] = 240 | r3 >>> 18, t3[s3++] = 128 | r3 >>> 12 & 63), t3[s3++] = 128 | r3 >>> 6 & 63), t3[s3++] = 128 | 63 & r3);
        return t3;
      }, r2.buf2binstring = function(e4) {
        return l2(e4, e4.length);
      }, r2.binstring2buf = function(e4) {
        for (var t3 = new h2.Buf8(e4.length), r3 = 0, n3 = t3.length; r3 < n3; r3++)
          t3[r3] = e4.charCodeAt(r3);
        return t3;
      }, r2.buf2string = function(e4, t3) {
        var r3, n3, i3, s3, a2 = t3 || e4.length, o2 = new Array(2 * a2);
        for (r3 = n3 = 0; r3 < a2; )
          if ((i3 = e4[r3++]) < 128)
            o2[n3++] = i3;
          else if (4 < (s3 = u2[i3]))
            o2[n3++] = 65533, r3 += s3 - 1;
          else {
            for (i3 &= 2 === s3 ? 31 : 3 === s3 ? 15 : 7; 1 < s3 && r3 < a2; )
              i3 = i3 << 6 | 63 & e4[r3++], s3--;
            1 < s3 ? o2[n3++] = 65533 : i3 < 65536 ? o2[n3++] = i3 : (i3 -= 65536, o2[n3++] = 55296 | i3 >> 10 & 1023, o2[n3++] = 56320 | 1023 & i3);
          }
        return l2(o2, n3);
      }, r2.utf8border = function(e4, t3) {
        var r3;
        for ((t3 = t3 || e4.length) > e4.length && (t3 = e4.length), r3 = t3 - 1; 0 <= r3 && 128 == (192 & e4[r3]); )
          r3--;
        return r3 < 0 ? t3 : 0 === r3 ? t3 : r3 + u2[e4[r3]] > t3 ? r3 : t3;
      };
    }, { "./common": 41 }], 43: [function(e3, t2, r2) {
      t2.exports = function(e4, t3, r3, n2) {
        for (var i2 = 65535 & e4 | 0, s2 = e4 >>> 16 & 65535 | 0, a2 = 0; 0 !== r3; ) {
          for (r3 -= a2 = 2e3 < r3 ? 2e3 : r3; s2 = s2 + (i2 = i2 + t3[n2++] | 0) | 0, --a2; )
            ;
          i2 %= 65521, s2 %= 65521;
        }
        return i2 | s2 << 16 | 0;
      };
    }, {}], 44: [function(e3, t2, r2) {
      t2.exports = { Z_NO_FLUSH: 0, Z_PARTIAL_FLUSH: 1, Z_SYNC_FLUSH: 2, Z_FULL_FLUSH: 3, Z_FINISH: 4, Z_BLOCK: 5, Z_TREES: 6, Z_OK: 0, Z_STREAM_END: 1, Z_NEED_DICT: 2, Z_ERRNO: -1, Z_STREAM_ERROR: -2, Z_DATA_ERROR: -3, Z_BUF_ERROR: -5, Z_NO_COMPRESSION: 0, Z_BEST_SPEED: 1, Z_BEST_COMPRESSION: 9, Z_DEFAULT_COMPRESSION: -1, Z_FILTERED: 1, Z_HUFFMAN_ONLY: 2, Z_RLE: 3, Z_FIXED: 4, Z_DEFAULT_STRATEGY: 0, Z_BINARY: 0, Z_TEXT: 1, Z_UNKNOWN: 2, Z_DEFLATED: 8 };
    }, {}], 45: [function(e3, t2, r2) {
      var o2 = function() {
        for (var e4, t3 = [], r3 = 0; r3 < 256; r3++) {
          e4 = r3;
          for (var n2 = 0; n2 < 8; n2++)
            e4 = 1 & e4 ? 3988292384 ^ e4 >>> 1 : e4 >>> 1;
          t3[r3] = e4;
        }
        return t3;
      }();
      t2.exports = function(e4, t3, r3, n2) {
        var i2 = o2, s2 = n2 + r3;
        e4 ^= -1;
        for (var a2 = n2; a2 < s2; a2++)
          e4 = e4 >>> 8 ^ i2[255 & (e4 ^ t3[a2])];
        return -1 ^ e4;
      };
    }, {}], 46: [function(e3, t2, r2) {
      var h2, c2 = e3("../utils/common"), u2 = e3("./trees"), d2 = e3("./adler32"), p2 = e3("./crc32"), n2 = e3("./messages"), l2 = 0, f2 = 4, m2 = 0, _2 = -2, g2 = -1, b2 = 4, i2 = 2, v5 = 8, y2 = 9, s2 = 286, a2 = 30, o2 = 19, w2 = 2 * s2 + 1, k2 = 15, x2 = 3, S2 = 258, z2 = S2 + x2 + 1, C2 = 42, E3 = 113, A2 = 1, I2 = 2, O2 = 3, B2 = 4;
      function R2(e4, t3) {
        return e4.msg = n2[t3], t3;
      }
      function T2(e4) {
        return (e4 << 1) - (4 < e4 ? 9 : 0);
      }
      function D2(e4) {
        for (var t3 = e4.length; 0 <= --t3; )
          e4[t3] = 0;
      }
      function F2(e4) {
        var t3 = e4.state, r3 = t3.pending;
        r3 > e4.avail_out && (r3 = e4.avail_out), 0 !== r3 && (c2.arraySet(e4.output, t3.pending_buf, t3.pending_out, r3, e4.next_out), e4.next_out += r3, t3.pending_out += r3, e4.total_out += r3, e4.avail_out -= r3, t3.pending -= r3, 0 === t3.pending && (t3.pending_out = 0));
      }
      function N2(e4, t3) {
        u2._tr_flush_block(e4, 0 <= e4.block_start ? e4.block_start : -1, e4.strstart - e4.block_start, t3), e4.block_start = e4.strstart, F2(e4.strm);
      }
      function U2(e4, t3) {
        e4.pending_buf[e4.pending++] = t3;
      }
      function P2(e4, t3) {
        e4.pending_buf[e4.pending++] = t3 >>> 8 & 255, e4.pending_buf[e4.pending++] = 255 & t3;
      }
      function L2(e4, t3) {
        var r3, n3, i3 = e4.max_chain_length, s3 = e4.strstart, a3 = e4.prev_length, o3 = e4.nice_match, h3 = e4.strstart > e4.w_size - z2 ? e4.strstart - (e4.w_size - z2) : 0, u3 = e4.window, l3 = e4.w_mask, f3 = e4.prev, c3 = e4.strstart + S2, d3 = u3[s3 + a3 - 1], p3 = u3[s3 + a3];
        e4.prev_length >= e4.good_match && (i3 >>= 2), o3 > e4.lookahead && (o3 = e4.lookahead);
        do {
          if (u3[(r3 = t3) + a3] === p3 && u3[r3 + a3 - 1] === d3 && u3[r3] === u3[s3] && u3[++r3] === u3[s3 + 1]) {
            s3 += 2, r3++;
            do {
            } while (u3[++s3] === u3[++r3] && u3[++s3] === u3[++r3] && u3[++s3] === u3[++r3] && u3[++s3] === u3[++r3] && u3[++s3] === u3[++r3] && u3[++s3] === u3[++r3] && u3[++s3] === u3[++r3] && u3[++s3] === u3[++r3] && s3 < c3);
            if (n3 = S2 - (c3 - s3), s3 = c3 - S2, a3 < n3) {
              if (e4.match_start = t3, o3 <= (a3 = n3))
                break;
              d3 = u3[s3 + a3 - 1], p3 = u3[s3 + a3];
            }
          }
        } while ((t3 = f3[t3 & l3]) > h3 && 0 != --i3);
        return a3 <= e4.lookahead ? a3 : e4.lookahead;
      }
      function j2(e4) {
        var t3, r3, n3, i3, s3, a3, o3, h3, u3, l3, f3 = e4.w_size;
        do {
          if (i3 = e4.window_size - e4.lookahead - e4.strstart, e4.strstart >= f3 + (f3 - z2)) {
            for (c2.arraySet(e4.window, e4.window, f3, f3, 0), e4.match_start -= f3, e4.strstart -= f3, e4.block_start -= f3, t3 = r3 = e4.hash_size; n3 = e4.head[--t3], e4.head[t3] = f3 <= n3 ? n3 - f3 : 0, --r3; )
              ;
            for (t3 = r3 = f3; n3 = e4.prev[--t3], e4.prev[t3] = f3 <= n3 ? n3 - f3 : 0, --r3; )
              ;
            i3 += f3;
          }
          if (0 === e4.strm.avail_in)
            break;
          if (a3 = e4.strm, o3 = e4.window, h3 = e4.strstart + e4.lookahead, u3 = i3, l3 = void 0, l3 = a3.avail_in, u3 < l3 && (l3 = u3), r3 = 0 === l3 ? 0 : (a3.avail_in -= l3, c2.arraySet(o3, a3.input, a3.next_in, l3, h3), 1 === a3.state.wrap ? a3.adler = d2(a3.adler, o3, l3, h3) : 2 === a3.state.wrap && (a3.adler = p2(a3.adler, o3, l3, h3)), a3.next_in += l3, a3.total_in += l3, l3), e4.lookahead += r3, e4.lookahead + e4.insert >= x2)
            for (s3 = e4.strstart - e4.insert, e4.ins_h = e4.window[s3], e4.ins_h = (e4.ins_h << e4.hash_shift ^ e4.window[s3 + 1]) & e4.hash_mask; e4.insert && (e4.ins_h = (e4.ins_h << e4.hash_shift ^ e4.window[s3 + x2 - 1]) & e4.hash_mask, e4.prev[s3 & e4.w_mask] = e4.head[e4.ins_h], e4.head[e4.ins_h] = s3, s3++, e4.insert--, !(e4.lookahead + e4.insert < x2)); )
              ;
        } while (e4.lookahead < z2 && 0 !== e4.strm.avail_in);
      }
      function Z2(e4, t3) {
        for (var r3, n3; ; ) {
          if (e4.lookahead < z2) {
            if (j2(e4), e4.lookahead < z2 && t3 === l2)
              return A2;
            if (0 === e4.lookahead)
              break;
          }
          if (r3 = 0, e4.lookahead >= x2 && (e4.ins_h = (e4.ins_h << e4.hash_shift ^ e4.window[e4.strstart + x2 - 1]) & e4.hash_mask, r3 = e4.prev[e4.strstart & e4.w_mask] = e4.head[e4.ins_h], e4.head[e4.ins_h] = e4.strstart), 0 !== r3 && e4.strstart - r3 <= e4.w_size - z2 && (e4.match_length = L2(e4, r3)), e4.match_length >= x2)
            if (n3 = u2._tr_tally(e4, e4.strstart - e4.match_start, e4.match_length - x2), e4.lookahead -= e4.match_length, e4.match_length <= e4.max_lazy_match && e4.lookahead >= x2) {
              for (e4.match_length--; e4.strstart++, e4.ins_h = (e4.ins_h << e4.hash_shift ^ e4.window[e4.strstart + x2 - 1]) & e4.hash_mask, r3 = e4.prev[e4.strstart & e4.w_mask] = e4.head[e4.ins_h], e4.head[e4.ins_h] = e4.strstart, 0 != --e4.match_length; )
                ;
              e4.strstart++;
            } else
              e4.strstart += e4.match_length, e4.match_length = 0, e4.ins_h = e4.window[e4.strstart], e4.ins_h = (e4.ins_h << e4.hash_shift ^ e4.window[e4.strstart + 1]) & e4.hash_mask;
          else
            n3 = u2._tr_tally(e4, 0, e4.window[e4.strstart]), e4.lookahead--, e4.strstart++;
          if (n3 && (N2(e4, false), 0 === e4.strm.avail_out))
            return A2;
        }
        return e4.insert = e4.strstart < x2 - 1 ? e4.strstart : x2 - 1, t3 === f2 ? (N2(e4, true), 0 === e4.strm.avail_out ? O2 : B2) : e4.last_lit && (N2(e4, false), 0 === e4.strm.avail_out) ? A2 : I2;
      }
      function W2(e4, t3) {
        for (var r3, n3, i3; ; ) {
          if (e4.lookahead < z2) {
            if (j2(e4), e4.lookahead < z2 && t3 === l2)
              return A2;
            if (0 === e4.lookahead)
              break;
          }
          if (r3 = 0, e4.lookahead >= x2 && (e4.ins_h = (e4.ins_h << e4.hash_shift ^ e4.window[e4.strstart + x2 - 1]) & e4.hash_mask, r3 = e4.prev[e4.strstart & e4.w_mask] = e4.head[e4.ins_h], e4.head[e4.ins_h] = e4.strstart), e4.prev_length = e4.match_length, e4.prev_match = e4.match_start, e4.match_length = x2 - 1, 0 !== r3 && e4.prev_length < e4.max_lazy_match && e4.strstart - r3 <= e4.w_size - z2 && (e4.match_length = L2(e4, r3), e4.match_length <= 5 && (1 === e4.strategy || e4.match_length === x2 && 4096 < e4.strstart - e4.match_start) && (e4.match_length = x2 - 1)), e4.prev_length >= x2 && e4.match_length <= e4.prev_length) {
            for (i3 = e4.strstart + e4.lookahead - x2, n3 = u2._tr_tally(e4, e4.strstart - 1 - e4.prev_match, e4.prev_length - x2), e4.lookahead -= e4.prev_length - 1, e4.prev_length -= 2; ++e4.strstart <= i3 && (e4.ins_h = (e4.ins_h << e4.hash_shift ^ e4.window[e4.strstart + x2 - 1]) & e4.hash_mask, r3 = e4.prev[e4.strstart & e4.w_mask] = e4.head[e4.ins_h], e4.head[e4.ins_h] = e4.strstart), 0 != --e4.prev_length; )
              ;
            if (e4.match_available = 0, e4.match_length = x2 - 1, e4.strstart++, n3 && (N2(e4, false), 0 === e4.strm.avail_out))
              return A2;
          } else if (e4.match_available) {
            if ((n3 = u2._tr_tally(e4, 0, e4.window[e4.strstart - 1])) && N2(e4, false), e4.strstart++, e4.lookahead--, 0 === e4.strm.avail_out)
              return A2;
          } else
            e4.match_available = 1, e4.strstart++, e4.lookahead--;
        }
        return e4.match_available && (n3 = u2._tr_tally(e4, 0, e4.window[e4.strstart - 1]), e4.match_available = 0), e4.insert = e4.strstart < x2 - 1 ? e4.strstart : x2 - 1, t3 === f2 ? (N2(e4, true), 0 === e4.strm.avail_out ? O2 : B2) : e4.last_lit && (N2(e4, false), 0 === e4.strm.avail_out) ? A2 : I2;
      }
      function M2(e4, t3, r3, n3, i3) {
        this.good_length = e4, this.max_lazy = t3, this.nice_length = r3, this.max_chain = n3, this.func = i3;
      }
      function H2() {
        this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v5, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c2.Buf16(2 * w2), this.dyn_dtree = new c2.Buf16(2 * (2 * a2 + 1)), this.bl_tree = new c2.Buf16(2 * (2 * o2 + 1)), D2(this.dyn_ltree), D2(this.dyn_dtree), D2(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c2.Buf16(k2 + 1), this.heap = new c2.Buf16(2 * s2 + 1), D2(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c2.Buf16(2 * s2 + 1), D2(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
      }
      function G2(e4) {
        var t3;
        return e4 && e4.state ? (e4.total_in = e4.total_out = 0, e4.data_type = i2, (t3 = e4.state).pending = 0, t3.pending_out = 0, t3.wrap < 0 && (t3.wrap = -t3.wrap), t3.status = t3.wrap ? C2 : E3, e4.adler = 2 === t3.wrap ? 0 : 1, t3.last_flush = l2, u2._tr_init(t3), m2) : R2(e4, _2);
      }
      function K2(e4) {
        var t3 = G2(e4);
        return t3 === m2 && function(e5) {
          e5.window_size = 2 * e5.w_size, D2(e5.head), e5.max_lazy_match = h2[e5.level].max_lazy, e5.good_match = h2[e5.level].good_length, e5.nice_match = h2[e5.level].nice_length, e5.max_chain_length = h2[e5.level].max_chain, e5.strstart = 0, e5.block_start = 0, e5.lookahead = 0, e5.insert = 0, e5.match_length = e5.prev_length = x2 - 1, e5.match_available = 0, e5.ins_h = 0;
        }(e4.state), t3;
      }
      function Y2(e4, t3, r3, n3, i3, s3) {
        if (!e4)
          return _2;
        var a3 = 1;
        if (t3 === g2 && (t3 = 6), n3 < 0 ? (a3 = 0, n3 = -n3) : 15 < n3 && (a3 = 2, n3 -= 16), i3 < 1 || y2 < i3 || r3 !== v5 || n3 < 8 || 15 < n3 || t3 < 0 || 9 < t3 || s3 < 0 || b2 < s3)
          return R2(e4, _2);
        8 === n3 && (n3 = 9);
        var o3 = new H2();
        return (e4.state = o3).strm = e4, o3.wrap = a3, o3.gzhead = null, o3.w_bits = n3, o3.w_size = 1 << o3.w_bits, o3.w_mask = o3.w_size - 1, o3.hash_bits = i3 + 7, o3.hash_size = 1 << o3.hash_bits, o3.hash_mask = o3.hash_size - 1, o3.hash_shift = ~~((o3.hash_bits + x2 - 1) / x2), o3.window = new c2.Buf8(2 * o3.w_size), o3.head = new c2.Buf16(o3.hash_size), o3.prev = new c2.Buf16(o3.w_size), o3.lit_bufsize = 1 << i3 + 6, o3.pending_buf_size = 4 * o3.lit_bufsize, o3.pending_buf = new c2.Buf8(o3.pending_buf_size), o3.d_buf = 1 * o3.lit_bufsize, o3.l_buf = 3 * o3.lit_bufsize, o3.level = t3, o3.strategy = s3, o3.method = r3, K2(e4);
      }
      h2 = [new M2(0, 0, 0, 0, function(e4, t3) {
        var r3 = 65535;
        for (r3 > e4.pending_buf_size - 5 && (r3 = e4.pending_buf_size - 5); ; ) {
          if (e4.lookahead <= 1) {
            if (j2(e4), 0 === e4.lookahead && t3 === l2)
              return A2;
            if (0 === e4.lookahead)
              break;
          }
          e4.strstart += e4.lookahead, e4.lookahead = 0;
          var n3 = e4.block_start + r3;
          if ((0 === e4.strstart || e4.strstart >= n3) && (e4.lookahead = e4.strstart - n3, e4.strstart = n3, N2(e4, false), 0 === e4.strm.avail_out))
            return A2;
          if (e4.strstart - e4.block_start >= e4.w_size - z2 && (N2(e4, false), 0 === e4.strm.avail_out))
            return A2;
        }
        return e4.insert = 0, t3 === f2 ? (N2(e4, true), 0 === e4.strm.avail_out ? O2 : B2) : (e4.strstart > e4.block_start && (N2(e4, false), e4.strm.avail_out), A2);
      }), new M2(4, 4, 8, 4, Z2), new M2(4, 5, 16, 8, Z2), new M2(4, 6, 32, 32, Z2), new M2(4, 4, 16, 16, W2), new M2(8, 16, 32, 32, W2), new M2(8, 16, 128, 128, W2), new M2(8, 32, 128, 256, W2), new M2(32, 128, 258, 1024, W2), new M2(32, 258, 258, 4096, W2)], r2.deflateInit = function(e4, t3) {
        return Y2(e4, t3, v5, 15, 8, 0);
      }, r2.deflateInit2 = Y2, r2.deflateReset = K2, r2.deflateResetKeep = G2, r2.deflateSetHeader = function(e4, t3) {
        return e4 && e4.state ? 2 !== e4.state.wrap ? _2 : (e4.state.gzhead = t3, m2) : _2;
      }, r2.deflate = function(e4, t3) {
        var r3, n3, i3, s3;
        if (!e4 || !e4.state || 5 < t3 || t3 < 0)
          return e4 ? R2(e4, _2) : _2;
        if (n3 = e4.state, !e4.output || !e4.input && 0 !== e4.avail_in || 666 === n3.status && t3 !== f2)
          return R2(e4, 0 === e4.avail_out ? -5 : _2);
        if (n3.strm = e4, r3 = n3.last_flush, n3.last_flush = t3, n3.status === C2)
          if (2 === n3.wrap)
            e4.adler = 0, U2(n3, 31), U2(n3, 139), U2(n3, 8), n3.gzhead ? (U2(n3, (n3.gzhead.text ? 1 : 0) + (n3.gzhead.hcrc ? 2 : 0) + (n3.gzhead.extra ? 4 : 0) + (n3.gzhead.name ? 8 : 0) + (n3.gzhead.comment ? 16 : 0)), U2(n3, 255 & n3.gzhead.time), U2(n3, n3.gzhead.time >> 8 & 255), U2(n3, n3.gzhead.time >> 16 & 255), U2(n3, n3.gzhead.time >> 24 & 255), U2(n3, 9 === n3.level ? 2 : 2 <= n3.strategy || n3.level < 2 ? 4 : 0), U2(n3, 255 & n3.gzhead.os), n3.gzhead.extra && n3.gzhead.extra.length && (U2(n3, 255 & n3.gzhead.extra.length), U2(n3, n3.gzhead.extra.length >> 8 & 255)), n3.gzhead.hcrc && (e4.adler = p2(e4.adler, n3.pending_buf, n3.pending, 0)), n3.gzindex = 0, n3.status = 69) : (U2(n3, 0), U2(n3, 0), U2(n3, 0), U2(n3, 0), U2(n3, 0), U2(n3, 9 === n3.level ? 2 : 2 <= n3.strategy || n3.level < 2 ? 4 : 0), U2(n3, 3), n3.status = E3);
          else {
            var a3 = v5 + (n3.w_bits - 8 << 4) << 8;
            a3 |= (2 <= n3.strategy || n3.level < 2 ? 0 : n3.level < 6 ? 1 : 6 === n3.level ? 2 : 3) << 6, 0 !== n3.strstart && (a3 |= 32), a3 += 31 - a3 % 31, n3.status = E3, P2(n3, a3), 0 !== n3.strstart && (P2(n3, e4.adler >>> 16), P2(n3, 65535 & e4.adler)), e4.adler = 1;
          }
        if (69 === n3.status)
          if (n3.gzhead.extra) {
            for (i3 = n3.pending; n3.gzindex < (65535 & n3.gzhead.extra.length) && (n3.pending !== n3.pending_buf_size || (n3.gzhead.hcrc && n3.pending > i3 && (e4.adler = p2(e4.adler, n3.pending_buf, n3.pending - i3, i3)), F2(e4), i3 = n3.pending, n3.pending !== n3.pending_buf_size)); )
              U2(n3, 255 & n3.gzhead.extra[n3.gzindex]), n3.gzindex++;
            n3.gzhead.hcrc && n3.pending > i3 && (e4.adler = p2(e4.adler, n3.pending_buf, n3.pending - i3, i3)), n3.gzindex === n3.gzhead.extra.length && (n3.gzindex = 0, n3.status = 73);
          } else
            n3.status = 73;
        if (73 === n3.status)
          if (n3.gzhead.name) {
            i3 = n3.pending;
            do {
              if (n3.pending === n3.pending_buf_size && (n3.gzhead.hcrc && n3.pending > i3 && (e4.adler = p2(e4.adler, n3.pending_buf, n3.pending - i3, i3)), F2(e4), i3 = n3.pending, n3.pending === n3.pending_buf_size)) {
                s3 = 1;
                break;
              }
              s3 = n3.gzindex < n3.gzhead.name.length ? 255 & n3.gzhead.name.charCodeAt(n3.gzindex++) : 0, U2(n3, s3);
            } while (0 !== s3);
            n3.gzhead.hcrc && n3.pending > i3 && (e4.adler = p2(e4.adler, n3.pending_buf, n3.pending - i3, i3)), 0 === s3 && (n3.gzindex = 0, n3.status = 91);
          } else
            n3.status = 91;
        if (91 === n3.status)
          if (n3.gzhead.comment) {
            i3 = n3.pending;
            do {
              if (n3.pending === n3.pending_buf_size && (n3.gzhead.hcrc && n3.pending > i3 && (e4.adler = p2(e4.adler, n3.pending_buf, n3.pending - i3, i3)), F2(e4), i3 = n3.pending, n3.pending === n3.pending_buf_size)) {
                s3 = 1;
                break;
              }
              s3 = n3.gzindex < n3.gzhead.comment.length ? 255 & n3.gzhead.comment.charCodeAt(n3.gzindex++) : 0, U2(n3, s3);
            } while (0 !== s3);
            n3.gzhead.hcrc && n3.pending > i3 && (e4.adler = p2(e4.adler, n3.pending_buf, n3.pending - i3, i3)), 0 === s3 && (n3.status = 103);
          } else
            n3.status = 103;
        if (103 === n3.status && (n3.gzhead.hcrc ? (n3.pending + 2 > n3.pending_buf_size && F2(e4), n3.pending + 2 <= n3.pending_buf_size && (U2(n3, 255 & e4.adler), U2(n3, e4.adler >> 8 & 255), e4.adler = 0, n3.status = E3)) : n3.status = E3), 0 !== n3.pending) {
          if (F2(e4), 0 === e4.avail_out)
            return n3.last_flush = -1, m2;
        } else if (0 === e4.avail_in && T2(t3) <= T2(r3) && t3 !== f2)
          return R2(e4, -5);
        if (666 === n3.status && 0 !== e4.avail_in)
          return R2(e4, -5);
        if (0 !== e4.avail_in || 0 !== n3.lookahead || t3 !== l2 && 666 !== n3.status) {
          var o3 = 2 === n3.strategy ? function(e5, t4) {
            for (var r4; ; ) {
              if (0 === e5.lookahead && (j2(e5), 0 === e5.lookahead)) {
                if (t4 === l2)
                  return A2;
                break;
              }
              if (e5.match_length = 0, r4 = u2._tr_tally(e5, 0, e5.window[e5.strstart]), e5.lookahead--, e5.strstart++, r4 && (N2(e5, false), 0 === e5.strm.avail_out))
                return A2;
            }
            return e5.insert = 0, t4 === f2 ? (N2(e5, true), 0 === e5.strm.avail_out ? O2 : B2) : e5.last_lit && (N2(e5, false), 0 === e5.strm.avail_out) ? A2 : I2;
          }(n3, t3) : 3 === n3.strategy ? function(e5, t4) {
            for (var r4, n4, i4, s4, a4 = e5.window; ; ) {
              if (e5.lookahead <= S2) {
                if (j2(e5), e5.lookahead <= S2 && t4 === l2)
                  return A2;
                if (0 === e5.lookahead)
                  break;
              }
              if (e5.match_length = 0, e5.lookahead >= x2 && 0 < e5.strstart && (n4 = a4[i4 = e5.strstart - 1]) === a4[++i4] && n4 === a4[++i4] && n4 === a4[++i4]) {
                s4 = e5.strstart + S2;
                do {
                } while (n4 === a4[++i4] && n4 === a4[++i4] && n4 === a4[++i4] && n4 === a4[++i4] && n4 === a4[++i4] && n4 === a4[++i4] && n4 === a4[++i4] && n4 === a4[++i4] && i4 < s4);
                e5.match_length = S2 - (s4 - i4), e5.match_length > e5.lookahead && (e5.match_length = e5.lookahead);
              }
              if (e5.match_length >= x2 ? (r4 = u2._tr_tally(e5, 1, e5.match_length - x2), e5.lookahead -= e5.match_length, e5.strstart += e5.match_length, e5.match_length = 0) : (r4 = u2._tr_tally(e5, 0, e5.window[e5.strstart]), e5.lookahead--, e5.strstart++), r4 && (N2(e5, false), 0 === e5.strm.avail_out))
                return A2;
            }
            return e5.insert = 0, t4 === f2 ? (N2(e5, true), 0 === e5.strm.avail_out ? O2 : B2) : e5.last_lit && (N2(e5, false), 0 === e5.strm.avail_out) ? A2 : I2;
          }(n3, t3) : h2[n3.level].func(n3, t3);
          if (o3 !== O2 && o3 !== B2 || (n3.status = 666), o3 === A2 || o3 === O2)
            return 0 === e4.avail_out && (n3.last_flush = -1), m2;
          if (o3 === I2 && (1 === t3 ? u2._tr_align(n3) : 5 !== t3 && (u2._tr_stored_block(n3, 0, 0, false), 3 === t3 && (D2(n3.head), 0 === n3.lookahead && (n3.strstart = 0, n3.block_start = 0, n3.insert = 0))), F2(e4), 0 === e4.avail_out))
            return n3.last_flush = -1, m2;
        }
        return t3 !== f2 ? m2 : n3.wrap <= 0 ? 1 : (2 === n3.wrap ? (U2(n3, 255 & e4.adler), U2(n3, e4.adler >> 8 & 255), U2(n3, e4.adler >> 16 & 255), U2(n3, e4.adler >> 24 & 255), U2(n3, 255 & e4.total_in), U2(n3, e4.total_in >> 8 & 255), U2(n3, e4.total_in >> 16 & 255), U2(n3, e4.total_in >> 24 & 255)) : (P2(n3, e4.adler >>> 16), P2(n3, 65535 & e4.adler)), F2(e4), 0 < n3.wrap && (n3.wrap = -n3.wrap), 0 !== n3.pending ? m2 : 1);
      }, r2.deflateEnd = function(e4) {
        var t3;
        return e4 && e4.state ? (t3 = e4.state.status) !== C2 && 69 !== t3 && 73 !== t3 && 91 !== t3 && 103 !== t3 && t3 !== E3 && 666 !== t3 ? R2(e4, _2) : (e4.state = null, t3 === E3 ? R2(e4, -3) : m2) : _2;
      }, r2.deflateSetDictionary = function(e4, t3) {
        var r3, n3, i3, s3, a3, o3, h3, u3, l3 = t3.length;
        if (!e4 || !e4.state)
          return _2;
        if (2 === (s3 = (r3 = e4.state).wrap) || 1 === s3 && r3.status !== C2 || r3.lookahead)
          return _2;
        for (1 === s3 && (e4.adler = d2(e4.adler, t3, l3, 0)), r3.wrap = 0, l3 >= r3.w_size && (0 === s3 && (D2(r3.head), r3.strstart = 0, r3.block_start = 0, r3.insert = 0), u3 = new c2.Buf8(r3.w_size), c2.arraySet(u3, t3, l3 - r3.w_size, r3.w_size, 0), t3 = u3, l3 = r3.w_size), a3 = e4.avail_in, o3 = e4.next_in, h3 = e4.input, e4.avail_in = l3, e4.next_in = 0, e4.input = t3, j2(r3); r3.lookahead >= x2; ) {
          for (n3 = r3.strstart, i3 = r3.lookahead - (x2 - 1); r3.ins_h = (r3.ins_h << r3.hash_shift ^ r3.window[n3 + x2 - 1]) & r3.hash_mask, r3.prev[n3 & r3.w_mask] = r3.head[r3.ins_h], r3.head[r3.ins_h] = n3, n3++, --i3; )
            ;
          r3.strstart = n3, r3.lookahead = x2 - 1, j2(r3);
        }
        return r3.strstart += r3.lookahead, r3.block_start = r3.strstart, r3.insert = r3.lookahead, r3.lookahead = 0, r3.match_length = r3.prev_length = x2 - 1, r3.match_available = 0, e4.next_in = o3, e4.input = h3, e4.avail_in = a3, r3.wrap = s3, m2;
      }, r2.deflateInfo = "pako deflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./messages": 51, "./trees": 52 }], 47: [function(e3, t2, r2) {
      t2.exports = function() {
        this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = false;
      };
    }, {}], 48: [function(e3, t2, r2) {
      t2.exports = function(e4, t3) {
        var r3, n2, i2, s2, a2, o2, h2, u2, l2, f2, c2, d2, p2, m2, _2, g2, b2, v5, y2, w2, k2, x2, S2, z2, C2;
        r3 = e4.state, n2 = e4.next_in, z2 = e4.input, i2 = n2 + (e4.avail_in - 5), s2 = e4.next_out, C2 = e4.output, a2 = s2 - (t3 - e4.avail_out), o2 = s2 + (e4.avail_out - 257), h2 = r3.dmax, u2 = r3.wsize, l2 = r3.whave, f2 = r3.wnext, c2 = r3.window, d2 = r3.hold, p2 = r3.bits, m2 = r3.lencode, _2 = r3.distcode, g2 = (1 << r3.lenbits) - 1, b2 = (1 << r3.distbits) - 1;
        e:
          do {
            p2 < 15 && (d2 += z2[n2++] << p2, p2 += 8, d2 += z2[n2++] << p2, p2 += 8), v5 = m2[d2 & g2];
            t:
              for (; ; ) {
                if (d2 >>>= y2 = v5 >>> 24, p2 -= y2, 0 === (y2 = v5 >>> 16 & 255))
                  C2[s2++] = 65535 & v5;
                else {
                  if (!(16 & y2)) {
                    if (0 == (64 & y2)) {
                      v5 = m2[(65535 & v5) + (d2 & (1 << y2) - 1)];
                      continue t;
                    }
                    if (32 & y2) {
                      r3.mode = 12;
                      break e;
                    }
                    e4.msg = "invalid literal/length code", r3.mode = 30;
                    break e;
                  }
                  w2 = 65535 & v5, (y2 &= 15) && (p2 < y2 && (d2 += z2[n2++] << p2, p2 += 8), w2 += d2 & (1 << y2) - 1, d2 >>>= y2, p2 -= y2), p2 < 15 && (d2 += z2[n2++] << p2, p2 += 8, d2 += z2[n2++] << p2, p2 += 8), v5 = _2[d2 & b2];
                  r:
                    for (; ; ) {
                      if (d2 >>>= y2 = v5 >>> 24, p2 -= y2, !(16 & (y2 = v5 >>> 16 & 255))) {
                        if (0 == (64 & y2)) {
                          v5 = _2[(65535 & v5) + (d2 & (1 << y2) - 1)];
                          continue r;
                        }
                        e4.msg = "invalid distance code", r3.mode = 30;
                        break e;
                      }
                      if (k2 = 65535 & v5, p2 < (y2 &= 15) && (d2 += z2[n2++] << p2, (p2 += 8) < y2 && (d2 += z2[n2++] << p2, p2 += 8)), h2 < (k2 += d2 & (1 << y2) - 1)) {
                        e4.msg = "invalid distance too far back", r3.mode = 30;
                        break e;
                      }
                      if (d2 >>>= y2, p2 -= y2, (y2 = s2 - a2) < k2) {
                        if (l2 < (y2 = k2 - y2) && r3.sane) {
                          e4.msg = "invalid distance too far back", r3.mode = 30;
                          break e;
                        }
                        if (S2 = c2, (x2 = 0) === f2) {
                          if (x2 += u2 - y2, y2 < w2) {
                            for (w2 -= y2; C2[s2++] = c2[x2++], --y2; )
                              ;
                            x2 = s2 - k2, S2 = C2;
                          }
                        } else if (f2 < y2) {
                          if (x2 += u2 + f2 - y2, (y2 -= f2) < w2) {
                            for (w2 -= y2; C2[s2++] = c2[x2++], --y2; )
                              ;
                            if (x2 = 0, f2 < w2) {
                              for (w2 -= y2 = f2; C2[s2++] = c2[x2++], --y2; )
                                ;
                              x2 = s2 - k2, S2 = C2;
                            }
                          }
                        } else if (x2 += f2 - y2, y2 < w2) {
                          for (w2 -= y2; C2[s2++] = c2[x2++], --y2; )
                            ;
                          x2 = s2 - k2, S2 = C2;
                        }
                        for (; 2 < w2; )
                          C2[s2++] = S2[x2++], C2[s2++] = S2[x2++], C2[s2++] = S2[x2++], w2 -= 3;
                        w2 && (C2[s2++] = S2[x2++], 1 < w2 && (C2[s2++] = S2[x2++]));
                      } else {
                        for (x2 = s2 - k2; C2[s2++] = C2[x2++], C2[s2++] = C2[x2++], C2[s2++] = C2[x2++], 2 < (w2 -= 3); )
                          ;
                        w2 && (C2[s2++] = C2[x2++], 1 < w2 && (C2[s2++] = C2[x2++]));
                      }
                      break;
                    }
                }
                break;
              }
          } while (n2 < i2 && s2 < o2);
        n2 -= w2 = p2 >> 3, d2 &= (1 << (p2 -= w2 << 3)) - 1, e4.next_in = n2, e4.next_out = s2, e4.avail_in = n2 < i2 ? i2 - n2 + 5 : 5 - (n2 - i2), e4.avail_out = s2 < o2 ? o2 - s2 + 257 : 257 - (s2 - o2), r3.hold = d2, r3.bits = p2;
      };
    }, {}], 49: [function(e3, t2, r2) {
      var I2 = e3("../utils/common"), O2 = e3("./adler32"), B2 = e3("./crc32"), R2 = e3("./inffast"), T2 = e3("./inftrees"), D2 = 1, F2 = 2, N2 = 0, U2 = -2, P2 = 1, n2 = 852, i2 = 592;
      function L2(e4) {
        return (e4 >>> 24 & 255) + (e4 >>> 8 & 65280) + ((65280 & e4) << 8) + ((255 & e4) << 24);
      }
      function s2() {
        this.mode = 0, this.last = false, this.wrap = 0, this.havedict = false, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I2.Buf16(320), this.work = new I2.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
      }
      function a2(e4) {
        var t3;
        return e4 && e4.state ? (t3 = e4.state, e4.total_in = e4.total_out = t3.total = 0, e4.msg = "", t3.wrap && (e4.adler = 1 & t3.wrap), t3.mode = P2, t3.last = 0, t3.havedict = 0, t3.dmax = 32768, t3.head = null, t3.hold = 0, t3.bits = 0, t3.lencode = t3.lendyn = new I2.Buf32(n2), t3.distcode = t3.distdyn = new I2.Buf32(i2), t3.sane = 1, t3.back = -1, N2) : U2;
      }
      function o2(e4) {
        var t3;
        return e4 && e4.state ? ((t3 = e4.state).wsize = 0, t3.whave = 0, t3.wnext = 0, a2(e4)) : U2;
      }
      function h2(e4, t3) {
        var r3, n3;
        return e4 && e4.state ? (n3 = e4.state, t3 < 0 ? (r3 = 0, t3 = -t3) : (r3 = 1 + (t3 >> 4), t3 < 48 && (t3 &= 15)), t3 && (t3 < 8 || 15 < t3) ? U2 : (null !== n3.window && n3.wbits !== t3 && (n3.window = null), n3.wrap = r3, n3.wbits = t3, o2(e4))) : U2;
      }
      function u2(e4, t3) {
        var r3, n3;
        return e4 ? (n3 = new s2(), (e4.state = n3).window = null, (r3 = h2(e4, t3)) !== N2 && (e4.state = null), r3) : U2;
      }
      var l2, f2, c2 = true;
      function j2(e4) {
        if (c2) {
          var t3;
          for (l2 = new I2.Buf32(512), f2 = new I2.Buf32(32), t3 = 0; t3 < 144; )
            e4.lens[t3++] = 8;
          for (; t3 < 256; )
            e4.lens[t3++] = 9;
          for (; t3 < 280; )
            e4.lens[t3++] = 7;
          for (; t3 < 288; )
            e4.lens[t3++] = 8;
          for (T2(D2, e4.lens, 0, 288, l2, 0, e4.work, { bits: 9 }), t3 = 0; t3 < 32; )
            e4.lens[t3++] = 5;
          T2(F2, e4.lens, 0, 32, f2, 0, e4.work, { bits: 5 }), c2 = false;
        }
        e4.lencode = l2, e4.lenbits = 9, e4.distcode = f2, e4.distbits = 5;
      }
      function Z2(e4, t3, r3, n3) {
        var i3, s3 = e4.state;
        return null === s3.window && (s3.wsize = 1 << s3.wbits, s3.wnext = 0, s3.whave = 0, s3.window = new I2.Buf8(s3.wsize)), n3 >= s3.wsize ? (I2.arraySet(s3.window, t3, r3 - s3.wsize, s3.wsize, 0), s3.wnext = 0, s3.whave = s3.wsize) : (n3 < (i3 = s3.wsize - s3.wnext) && (i3 = n3), I2.arraySet(s3.window, t3, r3 - n3, i3, s3.wnext), (n3 -= i3) ? (I2.arraySet(s3.window, t3, r3 - n3, n3, 0), s3.wnext = n3, s3.whave = s3.wsize) : (s3.wnext += i3, s3.wnext === s3.wsize && (s3.wnext = 0), s3.whave < s3.wsize && (s3.whave += i3))), 0;
      }
      r2.inflateReset = o2, r2.inflateReset2 = h2, r2.inflateResetKeep = a2, r2.inflateInit = function(e4) {
        return u2(e4, 15);
      }, r2.inflateInit2 = u2, r2.inflate = function(e4, t3) {
        var r3, n3, i3, s3, a3, o3, h3, u3, l3, f3, c3, d2, p2, m2, _2, g2, b2, v5, y2, w2, k2, x2, S2, z2, C2 = 0, E3 = new I2.Buf8(4), A2 = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!e4 || !e4.state || !e4.output || !e4.input && 0 !== e4.avail_in)
          return U2;
        12 === (r3 = e4.state).mode && (r3.mode = 13), a3 = e4.next_out, i3 = e4.output, h3 = e4.avail_out, s3 = e4.next_in, n3 = e4.input, o3 = e4.avail_in, u3 = r3.hold, l3 = r3.bits, f3 = o3, c3 = h3, x2 = N2;
        e:
          for (; ; )
            switch (r3.mode) {
              case P2:
                if (0 === r3.wrap) {
                  r3.mode = 13;
                  break;
                }
                for (; l3 < 16; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                if (2 & r3.wrap && 35615 === u3) {
                  E3[r3.check = 0] = 255 & u3, E3[1] = u3 >>> 8 & 255, r3.check = B2(r3.check, E3, 2, 0), l3 = u3 = 0, r3.mode = 2;
                  break;
                }
                if (r3.flags = 0, r3.head && (r3.head.done = false), !(1 & r3.wrap) || (((255 & u3) << 8) + (u3 >> 8)) % 31) {
                  e4.msg = "incorrect header check", r3.mode = 30;
                  break;
                }
                if (8 != (15 & u3)) {
                  e4.msg = "unknown compression method", r3.mode = 30;
                  break;
                }
                if (l3 -= 4, k2 = 8 + (15 & (u3 >>>= 4)), 0 === r3.wbits)
                  r3.wbits = k2;
                else if (k2 > r3.wbits) {
                  e4.msg = "invalid window size", r3.mode = 30;
                  break;
                }
                r3.dmax = 1 << k2, e4.adler = r3.check = 1, r3.mode = 512 & u3 ? 10 : 12, l3 = u3 = 0;
                break;
              case 2:
                for (; l3 < 16; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                if (r3.flags = u3, 8 != (255 & r3.flags)) {
                  e4.msg = "unknown compression method", r3.mode = 30;
                  break;
                }
                if (57344 & r3.flags) {
                  e4.msg = "unknown header flags set", r3.mode = 30;
                  break;
                }
                r3.head && (r3.head.text = u3 >> 8 & 1), 512 & r3.flags && (E3[0] = 255 & u3, E3[1] = u3 >>> 8 & 255, r3.check = B2(r3.check, E3, 2, 0)), l3 = u3 = 0, r3.mode = 3;
              case 3:
                for (; l3 < 32; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                r3.head && (r3.head.time = u3), 512 & r3.flags && (E3[0] = 255 & u3, E3[1] = u3 >>> 8 & 255, E3[2] = u3 >>> 16 & 255, E3[3] = u3 >>> 24 & 255, r3.check = B2(r3.check, E3, 4, 0)), l3 = u3 = 0, r3.mode = 4;
              case 4:
                for (; l3 < 16; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                r3.head && (r3.head.xflags = 255 & u3, r3.head.os = u3 >> 8), 512 & r3.flags && (E3[0] = 255 & u3, E3[1] = u3 >>> 8 & 255, r3.check = B2(r3.check, E3, 2, 0)), l3 = u3 = 0, r3.mode = 5;
              case 5:
                if (1024 & r3.flags) {
                  for (; l3 < 16; ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  r3.length = u3, r3.head && (r3.head.extra_len = u3), 512 & r3.flags && (E3[0] = 255 & u3, E3[1] = u3 >>> 8 & 255, r3.check = B2(r3.check, E3, 2, 0)), l3 = u3 = 0;
                } else
                  r3.head && (r3.head.extra = null);
                r3.mode = 6;
              case 6:
                if (1024 & r3.flags && (o3 < (d2 = r3.length) && (d2 = o3), d2 && (r3.head && (k2 = r3.head.extra_len - r3.length, r3.head.extra || (r3.head.extra = new Array(r3.head.extra_len)), I2.arraySet(r3.head.extra, n3, s3, d2, k2)), 512 & r3.flags && (r3.check = B2(r3.check, n3, d2, s3)), o3 -= d2, s3 += d2, r3.length -= d2), r3.length))
                  break e;
                r3.length = 0, r3.mode = 7;
              case 7:
                if (2048 & r3.flags) {
                  if (0 === o3)
                    break e;
                  for (d2 = 0; k2 = n3[s3 + d2++], r3.head && k2 && r3.length < 65536 && (r3.head.name += String.fromCharCode(k2)), k2 && d2 < o3; )
                    ;
                  if (512 & r3.flags && (r3.check = B2(r3.check, n3, d2, s3)), o3 -= d2, s3 += d2, k2)
                    break e;
                } else
                  r3.head && (r3.head.name = null);
                r3.length = 0, r3.mode = 8;
              case 8:
                if (4096 & r3.flags) {
                  if (0 === o3)
                    break e;
                  for (d2 = 0; k2 = n3[s3 + d2++], r3.head && k2 && r3.length < 65536 && (r3.head.comment += String.fromCharCode(k2)), k2 && d2 < o3; )
                    ;
                  if (512 & r3.flags && (r3.check = B2(r3.check, n3, d2, s3)), o3 -= d2, s3 += d2, k2)
                    break e;
                } else
                  r3.head && (r3.head.comment = null);
                r3.mode = 9;
              case 9:
                if (512 & r3.flags) {
                  for (; l3 < 16; ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  if (u3 !== (65535 & r3.check)) {
                    e4.msg = "header crc mismatch", r3.mode = 30;
                    break;
                  }
                  l3 = u3 = 0;
                }
                r3.head && (r3.head.hcrc = r3.flags >> 9 & 1, r3.head.done = true), e4.adler = r3.check = 0, r3.mode = 12;
                break;
              case 10:
                for (; l3 < 32; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                e4.adler = r3.check = L2(u3), l3 = u3 = 0, r3.mode = 11;
              case 11:
                if (0 === r3.havedict)
                  return e4.next_out = a3, e4.avail_out = h3, e4.next_in = s3, e4.avail_in = o3, r3.hold = u3, r3.bits = l3, 2;
                e4.adler = r3.check = 1, r3.mode = 12;
              case 12:
                if (5 === t3 || 6 === t3)
                  break e;
              case 13:
                if (r3.last) {
                  u3 >>>= 7 & l3, l3 -= 7 & l3, r3.mode = 27;
                  break;
                }
                for (; l3 < 3; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                switch (r3.last = 1 & u3, l3 -= 1, 3 & (u3 >>>= 1)) {
                  case 0:
                    r3.mode = 14;
                    break;
                  case 1:
                    if (j2(r3), r3.mode = 20, 6 !== t3)
                      break;
                    u3 >>>= 2, l3 -= 2;
                    break e;
                  case 2:
                    r3.mode = 17;
                    break;
                  case 3:
                    e4.msg = "invalid block type", r3.mode = 30;
                }
                u3 >>>= 2, l3 -= 2;
                break;
              case 14:
                for (u3 >>>= 7 & l3, l3 -= 7 & l3; l3 < 32; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                if ((65535 & u3) != (u3 >>> 16 ^ 65535)) {
                  e4.msg = "invalid stored block lengths", r3.mode = 30;
                  break;
                }
                if (r3.length = 65535 & u3, l3 = u3 = 0, r3.mode = 15, 6 === t3)
                  break e;
              case 15:
                r3.mode = 16;
              case 16:
                if (d2 = r3.length) {
                  if (o3 < d2 && (d2 = o3), h3 < d2 && (d2 = h3), 0 === d2)
                    break e;
                  I2.arraySet(i3, n3, s3, d2, a3), o3 -= d2, s3 += d2, h3 -= d2, a3 += d2, r3.length -= d2;
                  break;
                }
                r3.mode = 12;
                break;
              case 17:
                for (; l3 < 14; ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                if (r3.nlen = 257 + (31 & u3), u3 >>>= 5, l3 -= 5, r3.ndist = 1 + (31 & u3), u3 >>>= 5, l3 -= 5, r3.ncode = 4 + (15 & u3), u3 >>>= 4, l3 -= 4, 286 < r3.nlen || 30 < r3.ndist) {
                  e4.msg = "too many length or distance symbols", r3.mode = 30;
                  break;
                }
                r3.have = 0, r3.mode = 18;
              case 18:
                for (; r3.have < r3.ncode; ) {
                  for (; l3 < 3; ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  r3.lens[A2[r3.have++]] = 7 & u3, u3 >>>= 3, l3 -= 3;
                }
                for (; r3.have < 19; )
                  r3.lens[A2[r3.have++]] = 0;
                if (r3.lencode = r3.lendyn, r3.lenbits = 7, S2 = { bits: r3.lenbits }, x2 = T2(0, r3.lens, 0, 19, r3.lencode, 0, r3.work, S2), r3.lenbits = S2.bits, x2) {
                  e4.msg = "invalid code lengths set", r3.mode = 30;
                  break;
                }
                r3.have = 0, r3.mode = 19;
              case 19:
                for (; r3.have < r3.nlen + r3.ndist; ) {
                  for (; g2 = (C2 = r3.lencode[u3 & (1 << r3.lenbits) - 1]) >>> 16 & 255, b2 = 65535 & C2, !((_2 = C2 >>> 24) <= l3); ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  if (b2 < 16)
                    u3 >>>= _2, l3 -= _2, r3.lens[r3.have++] = b2;
                  else {
                    if (16 === b2) {
                      for (z2 = _2 + 2; l3 < z2; ) {
                        if (0 === o3)
                          break e;
                        o3--, u3 += n3[s3++] << l3, l3 += 8;
                      }
                      if (u3 >>>= _2, l3 -= _2, 0 === r3.have) {
                        e4.msg = "invalid bit length repeat", r3.mode = 30;
                        break;
                      }
                      k2 = r3.lens[r3.have - 1], d2 = 3 + (3 & u3), u3 >>>= 2, l3 -= 2;
                    } else if (17 === b2) {
                      for (z2 = _2 + 3; l3 < z2; ) {
                        if (0 === o3)
                          break e;
                        o3--, u3 += n3[s3++] << l3, l3 += 8;
                      }
                      l3 -= _2, k2 = 0, d2 = 3 + (7 & (u3 >>>= _2)), u3 >>>= 3, l3 -= 3;
                    } else {
                      for (z2 = _2 + 7; l3 < z2; ) {
                        if (0 === o3)
                          break e;
                        o3--, u3 += n3[s3++] << l3, l3 += 8;
                      }
                      l3 -= _2, k2 = 0, d2 = 11 + (127 & (u3 >>>= _2)), u3 >>>= 7, l3 -= 7;
                    }
                    if (r3.have + d2 > r3.nlen + r3.ndist) {
                      e4.msg = "invalid bit length repeat", r3.mode = 30;
                      break;
                    }
                    for (; d2--; )
                      r3.lens[r3.have++] = k2;
                  }
                }
                if (30 === r3.mode)
                  break;
                if (0 === r3.lens[256]) {
                  e4.msg = "invalid code -- missing end-of-block", r3.mode = 30;
                  break;
                }
                if (r3.lenbits = 9, S2 = { bits: r3.lenbits }, x2 = T2(D2, r3.lens, 0, r3.nlen, r3.lencode, 0, r3.work, S2), r3.lenbits = S2.bits, x2) {
                  e4.msg = "invalid literal/lengths set", r3.mode = 30;
                  break;
                }
                if (r3.distbits = 6, r3.distcode = r3.distdyn, S2 = { bits: r3.distbits }, x2 = T2(F2, r3.lens, r3.nlen, r3.ndist, r3.distcode, 0, r3.work, S2), r3.distbits = S2.bits, x2) {
                  e4.msg = "invalid distances set", r3.mode = 30;
                  break;
                }
                if (r3.mode = 20, 6 === t3)
                  break e;
              case 20:
                r3.mode = 21;
              case 21:
                if (6 <= o3 && 258 <= h3) {
                  e4.next_out = a3, e4.avail_out = h3, e4.next_in = s3, e4.avail_in = o3, r3.hold = u3, r3.bits = l3, R2(e4, c3), a3 = e4.next_out, i3 = e4.output, h3 = e4.avail_out, s3 = e4.next_in, n3 = e4.input, o3 = e4.avail_in, u3 = r3.hold, l3 = r3.bits, 12 === r3.mode && (r3.back = -1);
                  break;
                }
                for (r3.back = 0; g2 = (C2 = r3.lencode[u3 & (1 << r3.lenbits) - 1]) >>> 16 & 255, b2 = 65535 & C2, !((_2 = C2 >>> 24) <= l3); ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                if (g2 && 0 == (240 & g2)) {
                  for (v5 = _2, y2 = g2, w2 = b2; g2 = (C2 = r3.lencode[w2 + ((u3 & (1 << v5 + y2) - 1) >> v5)]) >>> 16 & 255, b2 = 65535 & C2, !(v5 + (_2 = C2 >>> 24) <= l3); ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  u3 >>>= v5, l3 -= v5, r3.back += v5;
                }
                if (u3 >>>= _2, l3 -= _2, r3.back += _2, r3.length = b2, 0 === g2) {
                  r3.mode = 26;
                  break;
                }
                if (32 & g2) {
                  r3.back = -1, r3.mode = 12;
                  break;
                }
                if (64 & g2) {
                  e4.msg = "invalid literal/length code", r3.mode = 30;
                  break;
                }
                r3.extra = 15 & g2, r3.mode = 22;
              case 22:
                if (r3.extra) {
                  for (z2 = r3.extra; l3 < z2; ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  r3.length += u3 & (1 << r3.extra) - 1, u3 >>>= r3.extra, l3 -= r3.extra, r3.back += r3.extra;
                }
                r3.was = r3.length, r3.mode = 23;
              case 23:
                for (; g2 = (C2 = r3.distcode[u3 & (1 << r3.distbits) - 1]) >>> 16 & 255, b2 = 65535 & C2, !((_2 = C2 >>> 24) <= l3); ) {
                  if (0 === o3)
                    break e;
                  o3--, u3 += n3[s3++] << l3, l3 += 8;
                }
                if (0 == (240 & g2)) {
                  for (v5 = _2, y2 = g2, w2 = b2; g2 = (C2 = r3.distcode[w2 + ((u3 & (1 << v5 + y2) - 1) >> v5)]) >>> 16 & 255, b2 = 65535 & C2, !(v5 + (_2 = C2 >>> 24) <= l3); ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  u3 >>>= v5, l3 -= v5, r3.back += v5;
                }
                if (u3 >>>= _2, l3 -= _2, r3.back += _2, 64 & g2) {
                  e4.msg = "invalid distance code", r3.mode = 30;
                  break;
                }
                r3.offset = b2, r3.extra = 15 & g2, r3.mode = 24;
              case 24:
                if (r3.extra) {
                  for (z2 = r3.extra; l3 < z2; ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  r3.offset += u3 & (1 << r3.extra) - 1, u3 >>>= r3.extra, l3 -= r3.extra, r3.back += r3.extra;
                }
                if (r3.offset > r3.dmax) {
                  e4.msg = "invalid distance too far back", r3.mode = 30;
                  break;
                }
                r3.mode = 25;
              case 25:
                if (0 === h3)
                  break e;
                if (d2 = c3 - h3, r3.offset > d2) {
                  if ((d2 = r3.offset - d2) > r3.whave && r3.sane) {
                    e4.msg = "invalid distance too far back", r3.mode = 30;
                    break;
                  }
                  p2 = d2 > r3.wnext ? (d2 -= r3.wnext, r3.wsize - d2) : r3.wnext - d2, d2 > r3.length && (d2 = r3.length), m2 = r3.window;
                } else
                  m2 = i3, p2 = a3 - r3.offset, d2 = r3.length;
                for (h3 < d2 && (d2 = h3), h3 -= d2, r3.length -= d2; i3[a3++] = m2[p2++], --d2; )
                  ;
                0 === r3.length && (r3.mode = 21);
                break;
              case 26:
                if (0 === h3)
                  break e;
                i3[a3++] = r3.length, h3--, r3.mode = 21;
                break;
              case 27:
                if (r3.wrap) {
                  for (; l3 < 32; ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 |= n3[s3++] << l3, l3 += 8;
                  }
                  if (c3 -= h3, e4.total_out += c3, r3.total += c3, c3 && (e4.adler = r3.check = r3.flags ? B2(r3.check, i3, c3, a3 - c3) : O2(r3.check, i3, c3, a3 - c3)), c3 = h3, (r3.flags ? u3 : L2(u3)) !== r3.check) {
                    e4.msg = "incorrect data check", r3.mode = 30;
                    break;
                  }
                  l3 = u3 = 0;
                }
                r3.mode = 28;
              case 28:
                if (r3.wrap && r3.flags) {
                  for (; l3 < 32; ) {
                    if (0 === o3)
                      break e;
                    o3--, u3 += n3[s3++] << l3, l3 += 8;
                  }
                  if (u3 !== (4294967295 & r3.total)) {
                    e4.msg = "incorrect length check", r3.mode = 30;
                    break;
                  }
                  l3 = u3 = 0;
                }
                r3.mode = 29;
              case 29:
                x2 = 1;
                break e;
              case 30:
                x2 = -3;
                break e;
              case 31:
                return -4;
              case 32:
              default:
                return U2;
            }
        return e4.next_out = a3, e4.avail_out = h3, e4.next_in = s3, e4.avail_in = o3, r3.hold = u3, r3.bits = l3, (r3.wsize || c3 !== e4.avail_out && r3.mode < 30 && (r3.mode < 27 || 4 !== t3)) && Z2(e4, e4.output, e4.next_out, c3 - e4.avail_out) ? (r3.mode = 31, -4) : (f3 -= e4.avail_in, c3 -= e4.avail_out, e4.total_in += f3, e4.total_out += c3, r3.total += c3, r3.wrap && c3 && (e4.adler = r3.check = r3.flags ? B2(r3.check, i3, c3, e4.next_out - c3) : O2(r3.check, i3, c3, e4.next_out - c3)), e4.data_type = r3.bits + (r3.last ? 64 : 0) + (12 === r3.mode ? 128 : 0) + (20 === r3.mode || 15 === r3.mode ? 256 : 0), (0 == f3 && 0 === c3 || 4 === t3) && x2 === N2 && (x2 = -5), x2);
      }, r2.inflateEnd = function(e4) {
        if (!e4 || !e4.state)
          return U2;
        var t3 = e4.state;
        return t3.window && (t3.window = null), e4.state = null, N2;
      }, r2.inflateGetHeader = function(e4, t3) {
        var r3;
        return e4 && e4.state ? 0 == (2 & (r3 = e4.state).wrap) ? U2 : ((r3.head = t3).done = false, N2) : U2;
      }, r2.inflateSetDictionary = function(e4, t3) {
        var r3, n3 = t3.length;
        return e4 && e4.state ? 0 !== (r3 = e4.state).wrap && 11 !== r3.mode ? U2 : 11 === r3.mode && O2(1, t3, n3, 0) !== r3.check ? -3 : Z2(e4, t3, n3, n3) ? (r3.mode = 31, -4) : (r3.havedict = 1, N2) : U2;
      }, r2.inflateInfo = "pako inflate (from Nodeca project)";
    }, { "../utils/common": 41, "./adler32": 43, "./crc32": 45, "./inffast": 48, "./inftrees": 50 }], 50: [function(e3, t2, r2) {
      var D2 = e3("../utils/common"), F2 = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0], N2 = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78], U2 = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0], P2 = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      t2.exports = function(e4, t3, r3, n2, i2, s2, a2, o2) {
        var h2, u2, l2, f2, c2, d2, p2, m2, _2, g2 = o2.bits, b2 = 0, v5 = 0, y2 = 0, w2 = 0, k2 = 0, x2 = 0, S2 = 0, z2 = 0, C2 = 0, E3 = 0, A2 = null, I2 = 0, O2 = new D2.Buf16(16), B2 = new D2.Buf16(16), R2 = null, T2 = 0;
        for (b2 = 0; b2 <= 15; b2++)
          O2[b2] = 0;
        for (v5 = 0; v5 < n2; v5++)
          O2[t3[r3 + v5]]++;
        for (k2 = g2, w2 = 15; 1 <= w2 && 0 === O2[w2]; w2--)
          ;
        if (w2 < k2 && (k2 = w2), 0 === w2)
          return i2[s2++] = 20971520, i2[s2++] = 20971520, o2.bits = 1, 0;
        for (y2 = 1; y2 < w2 && 0 === O2[y2]; y2++)
          ;
        for (k2 < y2 && (k2 = y2), b2 = z2 = 1; b2 <= 15; b2++)
          if (z2 <<= 1, (z2 -= O2[b2]) < 0)
            return -1;
        if (0 < z2 && (0 === e4 || 1 !== w2))
          return -1;
        for (B2[1] = 0, b2 = 1; b2 < 15; b2++)
          B2[b2 + 1] = B2[b2] + O2[b2];
        for (v5 = 0; v5 < n2; v5++)
          0 !== t3[r3 + v5] && (a2[B2[t3[r3 + v5]]++] = v5);
        if (d2 = 0 === e4 ? (A2 = R2 = a2, 19) : 1 === e4 ? (A2 = F2, I2 -= 257, R2 = N2, T2 -= 257, 256) : (A2 = U2, R2 = P2, -1), b2 = y2, c2 = s2, S2 = v5 = E3 = 0, l2 = -1, f2 = (C2 = 1 << (x2 = k2)) - 1, 1 === e4 && 852 < C2 || 2 === e4 && 592 < C2)
          return 1;
        for (; ; ) {
          for (p2 = b2 - S2, _2 = a2[v5] < d2 ? (m2 = 0, a2[v5]) : a2[v5] > d2 ? (m2 = R2[T2 + a2[v5]], A2[I2 + a2[v5]]) : (m2 = 96, 0), h2 = 1 << b2 - S2, y2 = u2 = 1 << x2; i2[c2 + (E3 >> S2) + (u2 -= h2)] = p2 << 24 | m2 << 16 | _2 | 0, 0 !== u2; )
            ;
          for (h2 = 1 << b2 - 1; E3 & h2; )
            h2 >>= 1;
          if (0 !== h2 ? (E3 &= h2 - 1, E3 += h2) : E3 = 0, v5++, 0 == --O2[b2]) {
            if (b2 === w2)
              break;
            b2 = t3[r3 + a2[v5]];
          }
          if (k2 < b2 && (E3 & f2) !== l2) {
            for (0 === S2 && (S2 = k2), c2 += y2, z2 = 1 << (x2 = b2 - S2); x2 + S2 < w2 && !((z2 -= O2[x2 + S2]) <= 0); )
              x2++, z2 <<= 1;
            if (C2 += 1 << x2, 1 === e4 && 852 < C2 || 2 === e4 && 592 < C2)
              return 1;
            i2[l2 = E3 & f2] = k2 << 24 | x2 << 16 | c2 - s2 | 0;
          }
        }
        return 0 !== E3 && (i2[c2 + E3] = b2 - S2 << 24 | 64 << 16 | 0), o2.bits = k2, 0;
      };
    }, { "../utils/common": 41 }], 51: [function(e3, t2, r2) {
      t2.exports = { 2: "need dictionary", 1: "stream end", 0: "", "-1": "file error", "-2": "stream error", "-3": "data error", "-4": "insufficient memory", "-5": "buffer error", "-6": "incompatible version" };
    }, {}], 52: [function(e3, t2, r2) {
      var i2 = e3("../utils/common"), o2 = 0, h2 = 1;
      function n2(e4) {
        for (var t3 = e4.length; 0 <= --t3; )
          e4[t3] = 0;
      }
      var s2 = 0, a2 = 29, u2 = 256, l2 = u2 + 1 + a2, f2 = 30, c2 = 19, _2 = 2 * l2 + 1, g2 = 15, d2 = 16, p2 = 7, m2 = 256, b2 = 16, v5 = 17, y2 = 18, w2 = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0], k2 = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13], x2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7], S2 = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], z2 = new Array(2 * (l2 + 2));
      n2(z2);
      var C2 = new Array(2 * f2);
      n2(C2);
      var E3 = new Array(512);
      n2(E3);
      var A2 = new Array(256);
      n2(A2);
      var I2 = new Array(a2);
      n2(I2);
      var O2, B2, R2, T2 = new Array(f2);
      function D2(e4, t3, r3, n3, i3) {
        this.static_tree = e4, this.extra_bits = t3, this.extra_base = r3, this.elems = n3, this.max_length = i3, this.has_stree = e4 && e4.length;
      }
      function F2(e4, t3) {
        this.dyn_tree = e4, this.max_code = 0, this.stat_desc = t3;
      }
      function N2(e4) {
        return e4 < 256 ? E3[e4] : E3[256 + (e4 >>> 7)];
      }
      function U2(e4, t3) {
        e4.pending_buf[e4.pending++] = 255 & t3, e4.pending_buf[e4.pending++] = t3 >>> 8 & 255;
      }
      function P2(e4, t3, r3) {
        e4.bi_valid > d2 - r3 ? (e4.bi_buf |= t3 << e4.bi_valid & 65535, U2(e4, e4.bi_buf), e4.bi_buf = t3 >> d2 - e4.bi_valid, e4.bi_valid += r3 - d2) : (e4.bi_buf |= t3 << e4.bi_valid & 65535, e4.bi_valid += r3);
      }
      function L2(e4, t3, r3) {
        P2(e4, r3[2 * t3], r3[2 * t3 + 1]);
      }
      function j2(e4, t3) {
        for (var r3 = 0; r3 |= 1 & e4, e4 >>>= 1, r3 <<= 1, 0 < --t3; )
          ;
        return r3 >>> 1;
      }
      function Z2(e4, t3, r3) {
        var n3, i3, s3 = new Array(g2 + 1), a3 = 0;
        for (n3 = 1; n3 <= g2; n3++)
          s3[n3] = a3 = a3 + r3[n3 - 1] << 1;
        for (i3 = 0; i3 <= t3; i3++) {
          var o3 = e4[2 * i3 + 1];
          0 !== o3 && (e4[2 * i3] = j2(s3[o3]++, o3));
        }
      }
      function W2(e4) {
        var t3;
        for (t3 = 0; t3 < l2; t3++)
          e4.dyn_ltree[2 * t3] = 0;
        for (t3 = 0; t3 < f2; t3++)
          e4.dyn_dtree[2 * t3] = 0;
        for (t3 = 0; t3 < c2; t3++)
          e4.bl_tree[2 * t3] = 0;
        e4.dyn_ltree[2 * m2] = 1, e4.opt_len = e4.static_len = 0, e4.last_lit = e4.matches = 0;
      }
      function M2(e4) {
        8 < e4.bi_valid ? U2(e4, e4.bi_buf) : 0 < e4.bi_valid && (e4.pending_buf[e4.pending++] = e4.bi_buf), e4.bi_buf = 0, e4.bi_valid = 0;
      }
      function H2(e4, t3, r3, n3) {
        var i3 = 2 * t3, s3 = 2 * r3;
        return e4[i3] < e4[s3] || e4[i3] === e4[s3] && n3[t3] <= n3[r3];
      }
      function G2(e4, t3, r3) {
        for (var n3 = e4.heap[r3], i3 = r3 << 1; i3 <= e4.heap_len && (i3 < e4.heap_len && H2(t3, e4.heap[i3 + 1], e4.heap[i3], e4.depth) && i3++, !H2(t3, n3, e4.heap[i3], e4.depth)); )
          e4.heap[r3] = e4.heap[i3], r3 = i3, i3 <<= 1;
        e4.heap[r3] = n3;
      }
      function K2(e4, t3, r3) {
        var n3, i3, s3, a3, o3 = 0;
        if (0 !== e4.last_lit)
          for (; n3 = e4.pending_buf[e4.d_buf + 2 * o3] << 8 | e4.pending_buf[e4.d_buf + 2 * o3 + 1], i3 = e4.pending_buf[e4.l_buf + o3], o3++, 0 === n3 ? L2(e4, i3, t3) : (L2(e4, (s3 = A2[i3]) + u2 + 1, t3), 0 !== (a3 = w2[s3]) && P2(e4, i3 -= I2[s3], a3), L2(e4, s3 = N2(--n3), r3), 0 !== (a3 = k2[s3]) && P2(e4, n3 -= T2[s3], a3)), o3 < e4.last_lit; )
            ;
        L2(e4, m2, t3);
      }
      function Y2(e4, t3) {
        var r3, n3, i3, s3 = t3.dyn_tree, a3 = t3.stat_desc.static_tree, o3 = t3.stat_desc.has_stree, h3 = t3.stat_desc.elems, u3 = -1;
        for (e4.heap_len = 0, e4.heap_max = _2, r3 = 0; r3 < h3; r3++)
          0 !== s3[2 * r3] ? (e4.heap[++e4.heap_len] = u3 = r3, e4.depth[r3] = 0) : s3[2 * r3 + 1] = 0;
        for (; e4.heap_len < 2; )
          s3[2 * (i3 = e4.heap[++e4.heap_len] = u3 < 2 ? ++u3 : 0)] = 1, e4.depth[i3] = 0, e4.opt_len--, o3 && (e4.static_len -= a3[2 * i3 + 1]);
        for (t3.max_code = u3, r3 = e4.heap_len >> 1; 1 <= r3; r3--)
          G2(e4, s3, r3);
        for (i3 = h3; r3 = e4.heap[1], e4.heap[1] = e4.heap[e4.heap_len--], G2(e4, s3, 1), n3 = e4.heap[1], e4.heap[--e4.heap_max] = r3, e4.heap[--e4.heap_max] = n3, s3[2 * i3] = s3[2 * r3] + s3[2 * n3], e4.depth[i3] = (e4.depth[r3] >= e4.depth[n3] ? e4.depth[r3] : e4.depth[n3]) + 1, s3[2 * r3 + 1] = s3[2 * n3 + 1] = i3, e4.heap[1] = i3++, G2(e4, s3, 1), 2 <= e4.heap_len; )
          ;
        e4.heap[--e4.heap_max] = e4.heap[1], function(e5, t4) {
          var r4, n4, i4, s4, a4, o4, h4 = t4.dyn_tree, u4 = t4.max_code, l3 = t4.stat_desc.static_tree, f3 = t4.stat_desc.has_stree, c3 = t4.stat_desc.extra_bits, d3 = t4.stat_desc.extra_base, p3 = t4.stat_desc.max_length, m3 = 0;
          for (s4 = 0; s4 <= g2; s4++)
            e5.bl_count[s4] = 0;
          for (h4[2 * e5.heap[e5.heap_max] + 1] = 0, r4 = e5.heap_max + 1; r4 < _2; r4++)
            p3 < (s4 = h4[2 * h4[2 * (n4 = e5.heap[r4]) + 1] + 1] + 1) && (s4 = p3, m3++), h4[2 * n4 + 1] = s4, u4 < n4 || (e5.bl_count[s4]++, a4 = 0, d3 <= n4 && (a4 = c3[n4 - d3]), o4 = h4[2 * n4], e5.opt_len += o4 * (s4 + a4), f3 && (e5.static_len += o4 * (l3[2 * n4 + 1] + a4)));
          if (0 !== m3) {
            do {
              for (s4 = p3 - 1; 0 === e5.bl_count[s4]; )
                s4--;
              e5.bl_count[s4]--, e5.bl_count[s4 + 1] += 2, e5.bl_count[p3]--, m3 -= 2;
            } while (0 < m3);
            for (s4 = p3; 0 !== s4; s4--)
              for (n4 = e5.bl_count[s4]; 0 !== n4; )
                u4 < (i4 = e5.heap[--r4]) || (h4[2 * i4 + 1] !== s4 && (e5.opt_len += (s4 - h4[2 * i4 + 1]) * h4[2 * i4], h4[2 * i4 + 1] = s4), n4--);
          }
        }(e4, t3), Z2(s3, u3, e4.bl_count);
      }
      function X2(e4, t3, r3) {
        var n3, i3, s3 = -1, a3 = t3[1], o3 = 0, h3 = 7, u3 = 4;
        for (0 === a3 && (h3 = 138, u3 = 3), t3[2 * (r3 + 1) + 1] = 65535, n3 = 0; n3 <= r3; n3++)
          i3 = a3, a3 = t3[2 * (n3 + 1) + 1], ++o3 < h3 && i3 === a3 || (o3 < u3 ? e4.bl_tree[2 * i3] += o3 : 0 !== i3 ? (i3 !== s3 && e4.bl_tree[2 * i3]++, e4.bl_tree[2 * b2]++) : o3 <= 10 ? e4.bl_tree[2 * v5]++ : e4.bl_tree[2 * y2]++, s3 = i3, u3 = (o3 = 0) === a3 ? (h3 = 138, 3) : i3 === a3 ? (h3 = 6, 3) : (h3 = 7, 4));
      }
      function V2(e4, t3, r3) {
        var n3, i3, s3 = -1, a3 = t3[1], o3 = 0, h3 = 7, u3 = 4;
        for (0 === a3 && (h3 = 138, u3 = 3), n3 = 0; n3 <= r3; n3++)
          if (i3 = a3, a3 = t3[2 * (n3 + 1) + 1], !(++o3 < h3 && i3 === a3)) {
            if (o3 < u3)
              for (; L2(e4, i3, e4.bl_tree), 0 != --o3; )
                ;
            else
              0 !== i3 ? (i3 !== s3 && (L2(e4, i3, e4.bl_tree), o3--), L2(e4, b2, e4.bl_tree), P2(e4, o3 - 3, 2)) : o3 <= 10 ? (L2(e4, v5, e4.bl_tree), P2(e4, o3 - 3, 3)) : (L2(e4, y2, e4.bl_tree), P2(e4, o3 - 11, 7));
            s3 = i3, u3 = (o3 = 0) === a3 ? (h3 = 138, 3) : i3 === a3 ? (h3 = 6, 3) : (h3 = 7, 4);
          }
      }
      n2(T2);
      var q2 = false;
      function J2(e4, t3, r3, n3) {
        P2(e4, (s2 << 1) + (n3 ? 1 : 0), 3), function(e5, t4, r4, n4) {
          M2(e5), n4 && (U2(e5, r4), U2(e5, ~r4)), i2.arraySet(e5.pending_buf, e5.window, t4, r4, e5.pending), e5.pending += r4;
        }(e4, t3, r3, true);
      }
      r2._tr_init = function(e4) {
        q2 || (function() {
          var e5, t3, r3, n3, i3, s3 = new Array(g2 + 1);
          for (n3 = r3 = 0; n3 < a2 - 1; n3++)
            for (I2[n3] = r3, e5 = 0; e5 < 1 << w2[n3]; e5++)
              A2[r3++] = n3;
          for (A2[r3 - 1] = n3, n3 = i3 = 0; n3 < 16; n3++)
            for (T2[n3] = i3, e5 = 0; e5 < 1 << k2[n3]; e5++)
              E3[i3++] = n3;
          for (i3 >>= 7; n3 < f2; n3++)
            for (T2[n3] = i3 << 7, e5 = 0; e5 < 1 << k2[n3] - 7; e5++)
              E3[256 + i3++] = n3;
          for (t3 = 0; t3 <= g2; t3++)
            s3[t3] = 0;
          for (e5 = 0; e5 <= 143; )
            z2[2 * e5 + 1] = 8, e5++, s3[8]++;
          for (; e5 <= 255; )
            z2[2 * e5 + 1] = 9, e5++, s3[9]++;
          for (; e5 <= 279; )
            z2[2 * e5 + 1] = 7, e5++, s3[7]++;
          for (; e5 <= 287; )
            z2[2 * e5 + 1] = 8, e5++, s3[8]++;
          for (Z2(z2, l2 + 1, s3), e5 = 0; e5 < f2; e5++)
            C2[2 * e5 + 1] = 5, C2[2 * e5] = j2(e5, 5);
          O2 = new D2(z2, w2, u2 + 1, l2, g2), B2 = new D2(C2, k2, 0, f2, g2), R2 = new D2(new Array(0), x2, 0, c2, p2);
        }(), q2 = true), e4.l_desc = new F2(e4.dyn_ltree, O2), e4.d_desc = new F2(e4.dyn_dtree, B2), e4.bl_desc = new F2(e4.bl_tree, R2), e4.bi_buf = 0, e4.bi_valid = 0, W2(e4);
      }, r2._tr_stored_block = J2, r2._tr_flush_block = function(e4, t3, r3, n3) {
        var i3, s3, a3 = 0;
        0 < e4.level ? (2 === e4.strm.data_type && (e4.strm.data_type = function(e5) {
          var t4, r4 = 4093624447;
          for (t4 = 0; t4 <= 31; t4++, r4 >>>= 1)
            if (1 & r4 && 0 !== e5.dyn_ltree[2 * t4])
              return o2;
          if (0 !== e5.dyn_ltree[18] || 0 !== e5.dyn_ltree[20] || 0 !== e5.dyn_ltree[26])
            return h2;
          for (t4 = 32; t4 < u2; t4++)
            if (0 !== e5.dyn_ltree[2 * t4])
              return h2;
          return o2;
        }(e4)), Y2(e4, e4.l_desc), Y2(e4, e4.d_desc), a3 = function(e5) {
          var t4;
          for (X2(e5, e5.dyn_ltree, e5.l_desc.max_code), X2(e5, e5.dyn_dtree, e5.d_desc.max_code), Y2(e5, e5.bl_desc), t4 = c2 - 1; 3 <= t4 && 0 === e5.bl_tree[2 * S2[t4] + 1]; t4--)
            ;
          return e5.opt_len += 3 * (t4 + 1) + 5 + 5 + 4, t4;
        }(e4), i3 = e4.opt_len + 3 + 7 >>> 3, (s3 = e4.static_len + 3 + 7 >>> 3) <= i3 && (i3 = s3)) : i3 = s3 = r3 + 5, r3 + 4 <= i3 && -1 !== t3 ? J2(e4, t3, r3, n3) : 4 === e4.strategy || s3 === i3 ? (P2(e4, 2 + (n3 ? 1 : 0), 3), K2(e4, z2, C2)) : (P2(e4, 4 + (n3 ? 1 : 0), 3), function(e5, t4, r4, n4) {
          var i4;
          for (P2(e5, t4 - 257, 5), P2(e5, r4 - 1, 5), P2(e5, n4 - 4, 4), i4 = 0; i4 < n4; i4++)
            P2(e5, e5.bl_tree[2 * S2[i4] + 1], 3);
          V2(e5, e5.dyn_ltree, t4 - 1), V2(e5, e5.dyn_dtree, r4 - 1);
        }(e4, e4.l_desc.max_code + 1, e4.d_desc.max_code + 1, a3 + 1), K2(e4, e4.dyn_ltree, e4.dyn_dtree)), W2(e4), n3 && M2(e4);
      }, r2._tr_tally = function(e4, t3, r3) {
        return e4.pending_buf[e4.d_buf + 2 * e4.last_lit] = t3 >>> 8 & 255, e4.pending_buf[e4.d_buf + 2 * e4.last_lit + 1] = 255 & t3, e4.pending_buf[e4.l_buf + e4.last_lit] = 255 & r3, e4.last_lit++, 0 === t3 ? e4.dyn_ltree[2 * r3]++ : (e4.matches++, t3--, e4.dyn_ltree[2 * (A2[r3] + u2 + 1)]++, e4.dyn_dtree[2 * N2(t3)]++), e4.last_lit === e4.lit_bufsize - 1;
      }, r2._tr_align = function(e4) {
        P2(e4, 2, 3), L2(e4, m2, z2), function(e5) {
          16 === e5.bi_valid ? (U2(e5, e5.bi_buf), e5.bi_buf = 0, e5.bi_valid = 0) : 8 <= e5.bi_valid && (e5.pending_buf[e5.pending++] = 255 & e5.bi_buf, e5.bi_buf >>= 8, e5.bi_valid -= 8);
        }(e4);
      };
    }, { "../utils/common": 41 }], 53: [function(e3, t2, r2) {
      t2.exports = function() {
        this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
      };
    }, {}], 54: [function(e3, t2, r2) {
      (function(e4) {
        !function(r3, n2) {
          if (!r3.setImmediate) {
            var i2, s2, t3, a2, o2 = 1, h2 = {}, u2 = false, l2 = r3.document, e5 = Object.getPrototypeOf && Object.getPrototypeOf(r3);
            e5 = e5 && e5.setTimeout ? e5 : r3, i2 = "[object process]" === {}.toString.call(r3.process) ? function(e6) {
              process.nextTick(function() {
                c2(e6);
              });
            } : function() {
              if (r3.postMessage && !r3.importScripts) {
                var e6 = true, t4 = r3.onmessage;
                return r3.onmessage = function() {
                  e6 = false;
                }, r3.postMessage("", "*"), r3.onmessage = t4, e6;
              }
            }() ? (a2 = "setImmediate$" + Math.random() + "$", r3.addEventListener ? r3.addEventListener("message", d2, false) : r3.attachEvent("onmessage", d2), function(e6) {
              r3.postMessage(a2 + e6, "*");
            }) : r3.MessageChannel ? ((t3 = new MessageChannel()).port1.onmessage = function(e6) {
              c2(e6.data);
            }, function(e6) {
              t3.port2.postMessage(e6);
            }) : l2 && "onreadystatechange" in l2.createElement("script") ? (s2 = l2.documentElement, function(e6) {
              var t4 = l2.createElement("script");
              t4.onreadystatechange = function() {
                c2(e6), t4.onreadystatechange = null, s2.removeChild(t4), t4 = null;
              }, s2.appendChild(t4);
            }) : function(e6) {
              setTimeout(c2, 0, e6);
            }, e5.setImmediate = function(e6) {
              "function" != typeof e6 && (e6 = new Function("" + e6));
              for (var t4 = new Array(arguments.length - 1), r4 = 0; r4 < t4.length; r4++)
                t4[r4] = arguments[r4 + 1];
              var n3 = { callback: e6, args: t4 };
              return h2[o2] = n3, i2(o2), o2++;
            }, e5.clearImmediate = f2;
          }
          function f2(e6) {
            delete h2[e6];
          }
          function c2(e6) {
            if (u2)
              setTimeout(c2, 0, e6);
            else {
              var t4 = h2[e6];
              if (t4) {
                u2 = true;
                try {
                  !function(e7) {
                    var t5 = e7.callback, r4 = e7.args;
                    switch (r4.length) {
                      case 0:
                        t5();
                        break;
                      case 1:
                        t5(r4[0]);
                        break;
                      case 2:
                        t5(r4[0], r4[1]);
                        break;
                      case 3:
                        t5(r4[0], r4[1], r4[2]);
                        break;
                      default:
                        t5.apply(n2, r4);
                    }
                  }(t4);
                } finally {
                  f2(e6), u2 = false;
                }
              }
            }
          }
          function d2(e6) {
            e6.source === r3 && "string" == typeof e6.data && 0 === e6.data.indexOf(a2) && c2(+e6.data.slice(a2.length));
          }
        }("undefined" == typeof self ? void 0 === e4 ? this : e4 : self);
      }).call(this, "undefined" != typeof commonjsGlobal$1 ? commonjsGlobal$1 : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
    }, {}] }, {}, [10])(10);
  });
})(jszip_min);
const SUPPORTED_CAD_FORMATS = ["dxf", "glb", "gltf", "dwg"];
const SUPPORTED_IMAGE_FORMATS = ["png", "jpg", "jpeg"];
const SUPPORTED_FILE_FORMATS = ["json", "geojson", "kml", "kmz", "shp", "zip", "pdf", "tiff", "tif", "csv", ...SUPPORTED_IMAGE_FORMATS, ...SUPPORTED_CAD_FORMATS];
const PREFERRED_READER_TYPES = {
  png: "dataUrl",
  jpg: "dataUrl",
  jpeg: "dataUrl",
  tif: "buffer",
  tiff: "buffer",
  json: "text",
  geojson: "text",
  kml: "text",
  kmz: "buffer",
  shp: "buffer",
  zip: "buffer",
  pdf: "dataUrl",
  csv: "text",
  glb: "dataUrl",
  // 'buffer',
  gltf: "dataUrl",
  // 'buffer',
  dxf: "blobUrl",
  // buffer
  dwg: "file",
  txt: "text"
};
const EXTENSION_MIME_TYPES = {
  png: "image/png",
  jpg: "image/jpg",
  jpeg: "image/jpg",
  tif: "image/tiff",
  tiff: "image/tiff",
  json: "application/json",
  geojson: "application/geo+json",
  kml: "application/vnd.google-earth.kml+xml",
  kmz: "application/vnd.google-earth.kmz",
  shp: "application/vnd.shp",
  dbf: "application/x-dbf",
  shx: "application/vnd.shx",
  prj: "text/plain",
  zip: "application/x-zip-compressed",
  glb: "model/gltf-binary",
  gltf: "model/gltf+json",
  dxf: "application/dxf",
  dwg: "application/dwg",
  txt: "text/plain"
};
class FileUtil {
  static async importFromUrl(url2, outputType) {
    if (!url2)
      return new Error("Invalid Url");
    const response = await fetch(url2);
    const blob = await response.blob();
    const result = await FileUtil.importFromFile(blob, outputType);
    return result;
  }
  static async importFromFile(file2, outputType) {
    var _a3, _b3;
    if (!file2)
      return new Error("Invalid file");
    const data2 = await FileUtil.readFile((file2 == null ? void 0 : file2.originFileObj) || file2, outputType);
    const filename2 = file2 == null ? void 0 : file2.name;
    const extension = (_b3 = (_a3 = filename2 == null ? void 0 : filename2.split(".")) == null ? void 0 : _a3.pop()) == null ? void 0 : _b3.toLowerCase();
    return {
      data: data2,
      filename: filename2,
      extension,
      dataType: outputType
    };
  }
  static async importTextFromUrl(url2) {
    const response = await fetch(url2);
    const text = await response.text();
    return text;
  }
  static readFile(file2, outputType) {
    return new Promise((resolve2, reject) => {
      if (outputType === "file" || outputType === "blob") {
        resolve2(file2);
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        let output2 = event.target.result;
        if (outputType === "blobUrl") {
          const buffer3 = output2;
          const blob = new Blob([new Uint8Array(buffer3)], {
            type: "data:application/octet-stream"
          });
          output2 = URL.createObjectURL(blob);
        }
        resolve2(output2);
      };
      fileReader.onerror = () => reject(new Error("Failed to load data"));
      if (outputType === "buffer" || outputType === "blobUrl")
        fileReader.readAsArrayBuffer(file2);
      else if (outputType === "dataUrl")
        fileReader.readAsDataURL(file2);
      else if (outputType === "text")
        fileReader.readAsText(file2);
      else
        reject(new Error("Unknown output type!"));
    });
  }
  static textToUrl(content, type = "text/plain", dataUrl = false) {
    if (!dataUrl) {
      const blob = new Blob([content], {
        type
      });
      const url2 = URL.createObjectURL(blob);
      return url2;
    }
    const b64 = window.btoa(window.unescape(window.encodeURIComponent(content)));
    return `data:${type};base64,${b64}`;
  }
  static async writeTextFile(content, filename2, type = "text/plain") {
    return new Promise((resolve2, reject) => {
      const url2 = FileUtil.textToUrl(content, type);
      if (!url2)
        reject(new Error("Unable to create url"));
      else {
        const a2 = document.createElement("a");
        document.body.appendChild(a2);
        a2.style = "display: none";
        a2.href = url2;
        a2.download = filename2;
        a2.click();
        setTimeout(() => {
          URL.revokeObjectURL(url2);
        }, 1500);
        resolve2(url2);
      }
    });
  }
  static async writeBlobFile(blob, filename2) {
    return await new Promise((resolve2, reject) => {
      const url2 = URL.createObjectURL(blob);
      if (!url2)
        reject(new Error("Unable to create url"));
      else {
        const a2 = document.createElement("a");
        document.body.appendChild(a2);
        a2.style = "display: none";
        a2.href = url2;
        a2.download = filename2 || "";
        a2.click();
        setTimeout(() => {
          URL.revokeObjectURL(url2);
        }, 1500);
        resolve2(url2);
      }
    });
  }
  static async getFilesFromZip(data2) {
    try {
      const zip = new jszip_minExports();
      const zipData = await zip.loadAsync(data2);
      const promises = Object.keys(zipData.files).map(async (fileName) => {
        var _a3, _b3;
        const readBase64 = /.+\.((jpg)|(jpeg)|(png)|(shp)|(kmz)|(glb)|(gltf)|(dxf)|(dwg))$/i.test(fileName);
        const file2 = zipData.file(fileName);
        if (!file2)
          return null;
        let fileContent = await file2.async(readBase64 ? "base64" : "text");
        const extension = ((_b3 = (_a3 = fileName.split(".")) == null ? void 0 : _a3.pop()) == null ? void 0 : _b3.toLowerCase()) || "";
        if (readBase64) {
          fileContent = `data:image/${extension || "png"};base64,${fileContent}`;
        }
        return {
          content: fileContent,
          name: fileName,
          extension,
          type: readBase64 ? "dataUrl" : "text"
        };
      });
      const files2 = await Promise.all(promises);
      return (files2 == null ? void 0 : files2.filter((f2) => !!f2)) || [];
    } catch (error2) {
      console.error("Error in extracting files from kmz:", error2);
    }
    return [];
  }
  static async downloadStringAsFile(str, filename2) {
    const blob = new Blob([str]);
    await FileUtil.downloadBlob(blob, filename2);
  }
  static async downloadBlob(blob, filename2) {
    await new Promise((resolve2, reject) => {
      const url2 = URL.createObjectURL(blob);
      if (!url2)
        reject(new Error("Unable to create url"));
      else {
        const a2 = document.createElement("a");
        document.body.appendChild(a2);
        a2.style = "display: none";
        a2.href = url2;
        a2.download = filename2 || "";
        a2.click();
        setTimeout(() => {
          URL.revokeObjectURL(url2);
        }, 1500);
        resolve2(url2);
      }
    });
  }
  static async parseCSVtoJSON(file2) {
    return new Promise((resolve2, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result;
        const lines = text.split("\n").filter((line) => line.trim() !== "");
        if (lines.length < 2) {
          reject(new Error("CSV file must have at least one row of data."));
          return;
        }
        const headers = lines[0].split(",").map((header) => header.trim());
        const jsonData = lines.slice(1).map((line) => {
          const values4 = line.match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g);
          if (!values4)
            return null;
          const obj = headers.reduce((acc, header, index2) => {
            acc[header] = values4[index2] ? values4[index2].replace(/(^"|"$)/g, "").trim() : null;
            return acc;
          }, {});
          return obj;
        }).filter((item) => item);
        resolve2(jsonData);
      };
      reader.onerror = () => {
        reject(reader.error);
      };
      reader.readAsText(file2);
    });
  }
  static async downloadFile(url2, filename2) {
    const response = await fetch(url2);
    const blob = await response.blob();
    await FileUtil.downloadBlob(blob, filename2);
  }
  static dataUriToFile(dataUrl, filename2) {
    if (!dataUrl)
      return null;
    const arr = dataUrl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let len2 = bstr.length;
    const u8arr = new Uint8Array(len2);
    while (len2--) {
      u8arr[len2] = bstr.charCodeAt(len2);
    }
    const blob = new Blob([u8arr], {
      type: mime
    });
    return new File([blob], filename2 || "", {
      type: mime
    });
  }
}
FileUtil.SUPPORTED_CAD_FORMATS = SUPPORTED_CAD_FORMATS;
FileUtil.SUPPORTED_IMAGE_FORMATS = SUPPORTED_IMAGE_FORMATS;
FileUtil.SUPPORTED_FILE_FORMATS = SUPPORTED_FILE_FORMATS;
FileUtil.PREFERRED_READER_TYPES = PREFERRED_READER_TYPES;
FileUtil.EXTENSION_MIME_TYPES = EXTENSION_MIME_TYPES;
var strxml$1 = {};
strxml$1.attr = attr;
strxml$1.tagClose = tagClose;
strxml$1.tag = tag$1;
strxml$1.encode = encode$a;
function attr(_2) {
  return _2 && _2.length ? " " + _2.map(function(a2) {
    return a2[0] + '="' + a2[1] + '"';
  }).join(" ") : "";
}
function tagClose(el, attributes) {
  return "<" + el + attr(attributes) + "/>";
}
function tag$1(el, contents, attributes) {
  return "<" + el + attr(attributes) + ">" + contents + "</" + el + ">";
}
function encode$a(_2) {
  return (_2 === null ? "" : _2.toString()).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
var strxml = strxml$1, tag = strxml.tag, encode$9 = strxml.encode;
var tokml = function tokml2(geojson, options2) {
  options2 = options2 || {
    documentName: void 0,
    documentDescription: void 0,
    name: "name",
    description: "description",
    simplestyle: false,
    timestamp: "timestamp"
  };
  return '<?xml version="1.0" encoding="UTF-8"?>' + tag(
    "kml",
    tag(
      "Document",
      documentName(options2) + documentDescription(options2) + root$c(geojson, options2)
    ),
    [["xmlns", "http://www.opengis.net/kml/2.2"]]
  );
};
function feature$9(options2, styleHashesArray) {
  return function(_2) {
    if (!_2.properties || !geometry$3.valid(_2.geometry))
      return "";
    var geometryString = geometry$3.any(_2.geometry);
    if (!geometryString)
      return "";
    var styleDefinition = "", styleReference = "";
    if (options2.simplestyle) {
      var styleHash = hashStyle(_2.properties);
      if (styleHash) {
        if (geometry$3.isPoint(_2.geometry) && hasMarkerStyle(_2.properties)) {
          if (styleHashesArray.indexOf(styleHash) === -1) {
            styleDefinition = markerStyle(_2.properties, styleHash);
            styleHashesArray.push(styleHash);
          }
          styleReference = tag("styleUrl", "#" + styleHash);
        } else if ((geometry$3.isPolygon(_2.geometry) || geometry$3.isLine(_2.geometry)) && hasPolygonAndLineStyle(_2.properties)) {
          if (styleHashesArray.indexOf(styleHash) === -1) {
            styleDefinition = polygonAndLineStyle(_2.properties, styleHash);
            styleHashesArray.push(styleHash);
          }
          styleReference = tag("styleUrl", "#" + styleHash);
        }
      }
    }
    return styleDefinition + tag(
      "Placemark",
      name$o(_2.properties, options2) + description$1(_2.properties, options2) + extendeddata(_2.properties) + timestamp(_2.properties, options2) + geometryString + styleReference
    );
  };
}
function root$c(_2, options2) {
  if (!_2.type)
    return "";
  var styleHashesArray = [];
  switch (_2.type) {
    case "FeatureCollection":
      if (!_2.features)
        return "";
      return _2.features.map(feature$9(options2, styleHashesArray)).join("");
    case "Feature":
      return feature$9(options2, styleHashesArray)(_2);
    default:
      return feature$9(options2, styleHashesArray)({
        type: "Feature",
        geometry: _2,
        properties: {}
      });
  }
}
function documentName(options2) {
  return options2.documentName !== void 0 ? tag("name", options2.documentName) : "";
}
function documentDescription(options2) {
  return options2.documentDescription !== void 0 ? tag("description", options2.documentDescription) : "";
}
function name$o(_2, options2) {
  return _2[options2.name] ? tag("name", encode$9(_2[options2.name])) : "";
}
function description$1(_2, options2) {
  return _2[options2.description] ? tag("description", encode$9(_2[options2.description])) : "";
}
function timestamp(_2, options2) {
  return _2[options2.timestamp] ? tag("TimeStamp", tag("when", encode$9(_2[options2.timestamp]))) : "";
}
var geometry$3 = {
  Point: function(_2) {
    return tag("Point", tag("coordinates", _2.coordinates.join(",")));
  },
  LineString: function(_2) {
    return tag("LineString", tag("coordinates", linearring(_2.coordinates)));
  },
  Polygon: function(_2) {
    if (!_2.coordinates.length)
      return "";
    var outer = _2.coordinates[0], inner = _2.coordinates.slice(1), outerRing = tag(
      "outerBoundaryIs",
      tag("LinearRing", tag("coordinates", linearring(outer)))
    ), innerRings = inner.map(function(i2) {
      return tag(
        "innerBoundaryIs",
        tag("LinearRing", tag("coordinates", linearring(i2)))
      );
    }).join("");
    return tag("Polygon", outerRing + innerRings);
  },
  MultiPoint: function(_2) {
    if (!_2.coordinates.length)
      return "";
    return tag("MultiGeometry", _2.coordinates.map(function(c2) {
      return geometry$3.Point({ coordinates: c2 });
    }).join(""));
  },
  MultiPolygon: function(_2) {
    if (!_2.coordinates.length)
      return "";
    return tag("MultiGeometry", _2.coordinates.map(function(c2) {
      return geometry$3.Polygon({ coordinates: c2 });
    }).join(""));
  },
  MultiLineString: function(_2) {
    if (!_2.coordinates.length)
      return "";
    return tag("MultiGeometry", _2.coordinates.map(function(c2) {
      return geometry$3.LineString({ coordinates: c2 });
    }).join(""));
  },
  GeometryCollection: function(_2) {
    return tag(
      "MultiGeometry",
      _2.geometries.map(geometry$3.any).join("")
    );
  },
  valid: function(_2) {
    return _2 && _2.type && (_2.coordinates || _2.type === "GeometryCollection" && _2.geometries && _2.geometries.every(geometry$3.valid));
  },
  any: function(_2) {
    if (geometry$3[_2.type]) {
      return geometry$3[_2.type](_2);
    } else {
      return "";
    }
  },
  isPoint: function(_2) {
    return _2.type === "Point" || _2.type === "MultiPoint";
  },
  isPolygon: function(_2) {
    return _2.type === "Polygon" || _2.type === "MultiPolygon";
  },
  isLine: function(_2) {
    return _2.type === "LineString" || _2.type === "MultiLineString";
  }
};
function linearring(_2) {
  return _2.map(function(cds) {
    return cds.join(",");
  }).join(" ");
}
function extendeddata(_2) {
  return tag("ExtendedData", pairs(_2).map(data).join(""));
}
function data(_2) {
  return tag("Data", tag("value", encode$9(_2[1])), [["name", encode$9(_2[0])]]);
}
function hasMarkerStyle(_2) {
  return !!(_2["marker-size"] || _2["marker-symbol"] || _2["marker-color"]);
}
function markerStyle(_2, styleHash) {
  return tag(
    "Style",
    tag(
      "IconStyle",
      tag(
        "Icon",
        tag("href", iconUrl(_2))
      )
    ) + iconSize(),
    [["id", styleHash]]
  );
}
function iconUrl(_2) {
  var size12 = _2["marker-size"] || "medium", symbol = _2["marker-symbol"] ? "-" + _2["marker-symbol"] : "", color = (_2["marker-color"] || "7e7e7e").replace("#", "");
  return "https://api.tiles.mapbox.com/v3/marker/pin-" + size12.charAt(0) + symbol + "+" + color + ".png";
}
function iconSize(_2) {
  return tag("hotSpot", "", [
    ["xunits", "fraction"],
    ["yunits", "fraction"],
    ["x", 0.5],
    ["y", 0.5]
  ]);
}
function hasPolygonAndLineStyle(_2) {
  for (var key in _2) {
    if ({
      "stroke": true,
      "stroke-opacity": true,
      "stroke-width": true,
      "fill": true,
      "fill-opacity": true
    }[key])
      return true;
  }
}
function polygonAndLineStyle(_2, styleHash) {
  var lineStyle = tag("LineStyle", [
    tag("color", hexToKmlColor(_2["stroke"], _2["stroke-opacity"]) || "ff555555") + tag("width", _2["stroke-width"] === void 0 ? 2 : _2["stroke-width"])
  ]);
  var polyStyle = "";
  if (_2["fill"] || _2["fill-opacity"]) {
    polyStyle = tag("PolyStyle", [
      tag("color", hexToKmlColor(_2["fill"], _2["fill-opacity"]) || "88555555")
    ]);
  }
  return tag("Style", lineStyle + polyStyle, [["id", styleHash]]);
}
function hashStyle(_2) {
  var hash = "";
  if (_2["marker-symbol"])
    hash = hash + "ms" + _2["marker-symbol"];
  if (_2["marker-color"])
    hash = hash + "mc" + _2["marker-color"].replace("#", "");
  if (_2["marker-size"])
    hash = hash + "ms" + _2["marker-size"];
  if (_2["stroke"])
    hash = hash + "s" + _2["stroke"].replace("#", "");
  if (_2["stroke-width"])
    hash = hash + "sw" + _2["stroke-width"].toString().replace(".", "");
  if (_2["stroke-opacity"])
    hash = hash + "mo" + _2["stroke-opacity"].toString().replace(".", "");
  if (_2["fill"])
    hash = hash + "f" + _2["fill"].replace("#", "");
  if (_2["fill-opacity"])
    hash = hash + "fo" + _2["fill-opacity"].toString().replace(".", "");
  return hash;
}
function hexToKmlColor(hexColor, opacity) {
  if (typeof hexColor !== "string")
    return "";
  hexColor = hexColor.replace("#", "").toLowerCase();
  if (hexColor.length === 3) {
    hexColor = hexColor[0] + hexColor[0] + hexColor[1] + hexColor[1] + hexColor[2] + hexColor[2];
  } else if (hexColor.length !== 6) {
    return "";
  }
  var r2 = hexColor[0] + hexColor[1];
  var g2 = hexColor[2] + hexColor[3];
  var b2 = hexColor[4] + hexColor[5];
  var o2 = "ff";
  if (typeof opacity === "number" && opacity >= 0 && opacity <= 1) {
    o2 = (opacity * 255).toString(16);
    if (o2.indexOf(".") > -1)
      o2 = o2.substr(0, o2.indexOf("."));
    if (o2.length < 2)
      o2 = "0" + o2;
  }
  return o2 + b2 + g2 + r2;
}
function pairs(_2) {
  var o2 = [];
  for (var i2 in _2)
    o2.push([i2, _2[i2]]);
  return o2;
}
var togeojsonExports = {};
var togeojson = {
  get exports() {
    return togeojsonExports;
  },
  set exports(v5) {
    togeojsonExports = v5;
  }
};
const zlib = {};
const __viteBrowserExternal = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zlib
}, Symbol.toStringTag, { value: "Module" }));
const require$$1$2 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal);
(function(module2, exports2) {
  var toGeoJSON = function() {
    var removeSpace = /\s*/g, trimSpace = /^\s*|\s*$/g, splitSpace = /\s+/;
    function okhash(x2) {
      if (!x2 || !x2.length)
        return 0;
      for (var i2 = 0, h2 = 0; i2 < x2.length; i2++) {
        h2 = (h2 << 5) - h2 + x2.charCodeAt(i2) | 0;
      }
      return h2;
    }
    function get6(x2, y2) {
      return x2.getElementsByTagName(y2);
    }
    function attr2(x2, y2) {
      return x2.getAttribute(y2);
    }
    function attrf(x2, y2) {
      return parseFloat(attr2(x2, y2));
    }
    function get1(x2, y2) {
      var n2 = get6(x2, y2);
      return n2.length ? n2[0] : null;
    }
    function norm2(el) {
      if (el.normalize) {
        el.normalize();
      }
      return el;
    }
    function numarray(x2) {
      for (var j2 = 0, o2 = []; j2 < x2.length; j2++) {
        o2[j2] = parseFloat(x2[j2]);
      }
      return o2;
    }
    function nodeVal(x2) {
      if (x2) {
        norm2(x2);
      }
      return x2 && x2.textContent || "";
    }
    function getMulti(x2, ys) {
      var o2 = {}, n2, k2;
      for (k2 = 0; k2 < ys.length; k2++) {
        n2 = get1(x2, ys[k2]);
        if (n2)
          o2[ys[k2]] = nodeVal(n2);
      }
      return o2;
    }
    function extend4(x2, y2) {
      for (var k2 in y2)
        x2[k2] = y2[k2];
    }
    function coord1(v5) {
      return numarray(v5.replace(removeSpace, "").split(","));
    }
    function coord(v5) {
      var coords = v5.replace(trimSpace, "").split(splitSpace), o2 = [];
      for (var i2 = 0; i2 < coords.length; i2++) {
        o2.push(coord1(coords[i2]));
      }
      return o2;
    }
    function coordPair(x2) {
      var ll = [attrf(x2, "lon"), attrf(x2, "lat")], ele = get1(x2, "ele"), heartRate = get1(x2, "gpxtpx:hr") || get1(x2, "hr"), time2 = get1(x2, "time"), e3;
      if (ele) {
        e3 = parseFloat(nodeVal(ele));
        if (!isNaN(e3)) {
          ll.push(e3);
        }
      }
      return {
        coordinates: ll,
        time: time2 ? nodeVal(time2) : null,
        heartRate: heartRate ? parseFloat(nodeVal(heartRate)) : null
      };
    }
    function fc() {
      return {
        type: "FeatureCollection",
        features: []
      };
    }
    var serializer;
    if (typeof XMLSerializer !== "undefined") {
      serializer = new XMLSerializer();
    } else {
      var isNodeEnv = typeof process === "object" && !process.browser;
      var isTitaniumEnv = typeof Titanium === "object";
      if (isNodeEnv || isTitaniumEnv) {
        // throw new Error("Unable to initialize serializer");
      } else {
        throw new Error("Unable to initialize serializer");
      }
    }
    function xml2str(str) {
      if (str.xml !== void 0)
        return str.xml;
      return serializer.serializeToString(str);
    }
    var t2 = {
      kml: function(doc) {
        var gj = fc(), styleIndex = {}, styleByHash = {}, styleMapIndex = {}, geotypes = ["Polygon", "LineString", "Point", "Track", "gx:Track"], placemarks = get6(doc, "Placemark"), styles2 = get6(doc, "Style"), styleMaps = get6(doc, "StyleMap");
        for (var k2 = 0; k2 < styles2.length; k2++) {
          var hash = okhash(xml2str(styles2[k2])).toString(16);
          styleIndex["#" + attr2(styles2[k2], "id")] = hash;
          styleByHash[hash] = styles2[k2];
        }
        for (var l2 = 0; l2 < styleMaps.length; l2++) {
          styleIndex["#" + attr2(styleMaps[l2], "id")] = okhash(xml2str(styleMaps[l2])).toString(16);
          var pairs2 = get6(styleMaps[l2], "Pair");
          var pairsMap = {};
          for (var m2 = 0; m2 < pairs2.length; m2++) {
            pairsMap[nodeVal(get1(pairs2[m2], "key"))] = nodeVal(get1(pairs2[m2], "styleUrl"));
          }
          styleMapIndex["#" + attr2(styleMaps[l2], "id")] = pairsMap;
        }
        for (var j2 = 0; j2 < placemarks.length; j2++) {
          gj.features = gj.features.concat(getPlacemark(placemarks[j2]));
        }
        function kmlColor(v5) {
          var color, opacity;
          v5 = v5 || "";
          if (v5.substr(0, 1) === "#") {
            v5 = v5.substr(1);
          }
          if (v5.length === 6 || v5.length === 3) {
            color = v5;
          }
          if (v5.length === 8) {
            opacity = parseInt(v5.substr(0, 2), 16) / 255;
            color = "#" + v5.substr(6, 2) + v5.substr(4, 2) + v5.substr(2, 2);
          }
          return [color, isNaN(opacity) ? void 0 : opacity];
        }
        function gxCoord(v5) {
          return numarray(v5.split(" "));
        }
        function gxCoords(root2) {
          var elems = get6(root2, "coord"), coords = [], times = [];
          if (elems.length === 0)
            elems = get6(root2, "gx:coord");
          for (var i2 = 0; i2 < elems.length; i2++)
            coords.push(gxCoord(nodeVal(elems[i2])));
          var timeElems = get6(root2, "when");
          for (var j3 = 0; j3 < timeElems.length; j3++)
            times.push(nodeVal(timeElems[j3]));
          return {
            coords,
            times
          };
        }
        function getGeometry4(root2) {
          var geomNode, geomNodes, i2, j3, k3, geoms = [], coordTimes = [];
          if (get1(root2, "MultiGeometry")) {
            return getGeometry4(get1(root2, "MultiGeometry"));
          }
          if (get1(root2, "MultiTrack")) {
            return getGeometry4(get1(root2, "MultiTrack"));
          }
          if (get1(root2, "gx:MultiTrack")) {
            return getGeometry4(get1(root2, "gx:MultiTrack"));
          }
          for (i2 = 0; i2 < geotypes.length; i2++) {
            geomNodes = get6(root2, geotypes[i2]);
            if (geomNodes) {
              for (j3 = 0; j3 < geomNodes.length; j3++) {
                geomNode = geomNodes[j3];
                if (geotypes[i2] === "Point") {
                  geoms.push({
                    type: "Point",
                    coordinates: coord1(nodeVal(get1(geomNode, "coordinates")))
                  });
                } else if (geotypes[i2] === "LineString") {
                  geoms.push({
                    type: "LineString",
                    coordinates: coord(nodeVal(get1(geomNode, "coordinates")))
                  });
                } else if (geotypes[i2] === "Polygon") {
                  var rings = get6(geomNode, "LinearRing"), coords = [];
                  for (k3 = 0; k3 < rings.length; k3++) {
                    coords.push(coord(nodeVal(get1(rings[k3], "coordinates"))));
                  }
                  geoms.push({
                    type: "Polygon",
                    coordinates: coords
                  });
                } else if (geotypes[i2] === "Track" || geotypes[i2] === "gx:Track") {
                  var track = gxCoords(geomNode);
                  geoms.push({
                    type: "LineString",
                    coordinates: track.coords
                  });
                  if (track.times.length)
                    coordTimes.push(track.times);
                }
              }
            }
          }
          return {
            geoms,
            coordTimes
          };
        }
        function getPlacemark(root2) {
          var geomsAndTimes = getGeometry4(root2), i2, properties = {}, name2 = nodeVal(get1(root2, "name")), address = nodeVal(get1(root2, "address")), styleUrl = nodeVal(get1(root2, "styleUrl")), description2 = nodeVal(get1(root2, "description")), timeSpan = get1(root2, "TimeSpan"), timeStamp = get1(root2, "TimeStamp"), extendedData = get1(root2, "ExtendedData"), lineStyle = get1(root2, "LineStyle"), polyStyle = get1(root2, "PolyStyle"), visibility = get1(root2, "visibility");
          if (!geomsAndTimes.geoms.length)
            return [];
          if (name2)
            properties.name = name2;
          if (address)
            properties.address = address;
          if (styleUrl) {
            if (styleUrl[0] !== "#") {
              styleUrl = "#" + styleUrl;
            }
            properties.styleUrl = styleUrl;
            if (styleIndex[styleUrl]) {
              properties.styleHash = styleIndex[styleUrl];
            }
            if (styleMapIndex[styleUrl]) {
              properties.styleMapHash = styleMapIndex[styleUrl];
              properties.styleHash = styleIndex[styleMapIndex[styleUrl].normal];
            }
            var style2 = styleByHash[properties.styleHash];
            if (style2) {
              if (!lineStyle)
                lineStyle = get1(style2, "LineStyle");
              if (!polyStyle)
                polyStyle = get1(style2, "PolyStyle");
              var iconStyle = get1(style2, "IconStyle");
              if (iconStyle) {
                var icon = get1(iconStyle, "Icon");
                if (icon) {
                  var href = nodeVal(get1(icon, "href"));
                  if (href)
                    properties.icon = href;
                }
              }
            }
          }
          if (description2)
            properties.description = description2;
          if (timeSpan) {
            var begin = nodeVal(get1(timeSpan, "begin"));
            var end = nodeVal(get1(timeSpan, "end"));
            properties.timespan = { begin, end };
          }
          if (timeStamp) {
            properties.timestamp = nodeVal(get1(timeStamp, "when"));
          }
          if (lineStyle) {
            var linestyles = kmlColor(nodeVal(get1(lineStyle, "color"))), color = linestyles[0], opacity = linestyles[1], width = parseFloat(nodeVal(get1(lineStyle, "width")));
            if (color)
              properties.stroke = color;
            if (!isNaN(opacity))
              properties["stroke-opacity"] = opacity;
            if (!isNaN(width))
              properties["stroke-width"] = width;
          }
          if (polyStyle) {
            var polystyles = kmlColor(nodeVal(get1(polyStyle, "color"))), pcolor = polystyles[0], popacity = polystyles[1], fill = nodeVal(get1(polyStyle, "fill")), outline = nodeVal(get1(polyStyle, "outline"));
            if (pcolor)
              properties.fill = pcolor;
            if (!isNaN(popacity))
              properties["fill-opacity"] = popacity;
            if (fill)
              properties["fill-opacity"] = fill === "1" ? properties["fill-opacity"] || 1 : 0;
            if (outline)
              properties["stroke-opacity"] = outline === "1" ? properties["stroke-opacity"] || 1 : 0;
          }
          if (extendedData) {
            var datas = get6(extendedData, "Data"), simpleDatas = get6(extendedData, "SimpleData");
            for (i2 = 0; i2 < datas.length; i2++) {
              properties[datas[i2].getAttribute("name")] = nodeVal(get1(datas[i2], "value"));
            }
            for (i2 = 0; i2 < simpleDatas.length; i2++) {
              properties[simpleDatas[i2].getAttribute("name")] = nodeVal(simpleDatas[i2]);
            }
          }
          if (visibility) {
            properties.visibility = nodeVal(visibility);
          }
          if (geomsAndTimes.coordTimes.length) {
            properties.coordTimes = geomsAndTimes.coordTimes.length === 1 ? geomsAndTimes.coordTimes[0] : geomsAndTimes.coordTimes;
          }
          var feature2 = {
            type: "Feature",
            geometry: geomsAndTimes.geoms.length === 1 ? geomsAndTimes.geoms[0] : {
              type: "GeometryCollection",
              geometries: geomsAndTimes.geoms
            },
            properties
          };
          if (attr2(root2, "id"))
            feature2.id = attr2(root2, "id");
          return [feature2];
        }
        return gj;
      },
      gpx: function(doc) {
        var i2, tracks = get6(doc, "trk"), routes = get6(doc, "rte"), waypoints = get6(doc, "wpt"), gj = fc(), feature2;
        for (i2 = 0; i2 < tracks.length; i2++) {
          feature2 = getTrack(tracks[i2]);
          if (feature2)
            gj.features.push(feature2);
        }
        for (i2 = 0; i2 < routes.length; i2++) {
          feature2 = getRoute(routes[i2]);
          if (feature2)
            gj.features.push(feature2);
        }
        for (i2 = 0; i2 < waypoints.length; i2++) {
          gj.features.push(getPoint(waypoints[i2]));
        }
        function initializeArray(arr, size12) {
          for (var h2 = 0; h2 < size12; h2++) {
            arr.push(null);
          }
          return arr;
        }
        function getPoints4(node, pointname) {
          var pts = get6(node, pointname), line = [], times = [], heartRates = [], l2 = pts.length;
          if (l2 < 2)
            return {};
          for (var i3 = 0; i3 < l2; i3++) {
            var c2 = coordPair(pts[i3]);
            line.push(c2.coordinates);
            if (c2.time)
              times.push(c2.time);
            if (c2.heartRate || heartRates.length) {
              if (!heartRates.length)
                initializeArray(heartRates, i3);
              heartRates.push(c2.heartRate || null);
            }
          }
          return {
            line,
            times,
            heartRates
          };
        }
        function getTrack(node) {
          var segments = get6(node, "trkseg"), track = [], times = [], heartRates = [], line;
          for (var i3 = 0; i3 < segments.length; i3++) {
            line = getPoints4(segments[i3], "trkpt");
            if (line) {
              if (line.line)
                track.push(line.line);
              if (line.times && line.times.length)
                times.push(line.times);
              if (heartRates.length || line.heartRates && line.heartRates.length) {
                if (!heartRates.length) {
                  for (var s2 = 0; s2 < i3; s2++) {
                    heartRates.push(initializeArray([], track[s2].length));
                  }
                }
                if (line.heartRates && line.heartRates.length) {
                  heartRates.push(line.heartRates);
                } else {
                  heartRates.push(initializeArray([], line.line.length || 0));
                }
              }
            }
          }
          if (track.length === 0)
            return;
          var properties = getProperties(node);
          extend4(properties, getLineStyle(get1(node, "extensions")));
          if (times.length)
            properties.coordTimes = track.length === 1 ? times[0] : times;
          if (heartRates.length)
            properties.heartRates = track.length === 1 ? heartRates[0] : heartRates;
          return {
            type: "Feature",
            properties,
            geometry: {
              type: track.length === 1 ? "LineString" : "MultiLineString",
              coordinates: track.length === 1 ? track[0] : track
            }
          };
        }
        function getRoute(node) {
          var line = getPoints4(node, "rtept");
          if (!line.line)
            return;
          var prop = getProperties(node);
          extend4(prop, getLineStyle(get1(node, "extensions")));
          var routeObj = {
            type: "Feature",
            properties: prop,
            geometry: {
              type: "LineString",
              coordinates: line.line
            }
          };
          return routeObj;
        }
        function getPoint(node) {
          var prop = getProperties(node);
          extend4(prop, getMulti(node, ["sym"]));
          return {
            type: "Feature",
            properties: prop,
            geometry: {
              type: "Point",
              coordinates: coordPair(node).coordinates
            }
          };
        }
        function getLineStyle(extensions) {
          var style2 = {};
          if (extensions) {
            var lineStyle = get1(extensions, "line");
            if (lineStyle) {
              var color = nodeVal(get1(lineStyle, "color")), opacity = parseFloat(nodeVal(get1(lineStyle, "opacity"))), width = parseFloat(nodeVal(get1(lineStyle, "width")));
              if (color)
                style2.stroke = color;
              if (!isNaN(opacity))
                style2["stroke-opacity"] = opacity;
              if (!isNaN(width))
                style2["stroke-width"] = width * 96 / 25.4;
            }
          }
          return style2;
        }
        function getProperties(node) {
          var prop = getMulti(node, ["name", "cmt", "desc", "type", "time", "keywords"]), links = get6(node, "link");
          if (links.length)
            prop.links = [];
          for (var i3 = 0, link2; i3 < links.length; i3++) {
            link2 = { href: attr2(links[i3], "href") };
            extend4(link2, getMulti(links[i3], ["text", "type"]));
            prop.links.push(link2);
          }
          return prop;
        }
        return gj;
      }
    };
    return t2;
  }();
  module2.exports = toGeoJSON;
})(togeojson);
let ImageUtil$1 = class ImageUtil2 {
  static utf8ToBase64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  }
  static svgToUri(str, base642) {
    if (base642)
      return `data:image/svg+xml;base64,${ImageUtil2.utf8ToBase64(str)}`;
    return `data:image/svg+xml;utf8,${str}`;
  }
  static async svgToPng(str, size12) {
    const url2 = ImageUtil2.svgToUri(str, true);
    const png = await ImageUtil2.convertToPng(url2, size12);
    return png;
  }
  static async svgToCanvas(str, size12) {
    const url2 = ImageUtil2.svgToUri(str, true);
    const canvas2 = await ImageUtil2.convertToCanvas(url2, size12);
    return canvas2;
  }
  static async imageFromUrl(url2) {
    return new Promise((resolve2, reject) => {
      const img = new Image();
      img.src = url2;
      img.onload = () => {
        resolve2(img);
      };
      img.onerror = () => {
        reject();
      };
    });
  }
  static async convertToCanvas(url2, size12 = 40) {
    const image = await ImageUtil2.imageFromUrl(url2);
    const canvas2 = document.createElement("canvas");
    const factor = size12 / image.width;
    canvas2.width = size12;
    canvas2.height = image.height * factor;
    const context2 = canvas2.getContext("2d", {
      alpha: true
    });
    context2.imageSmoothingEnabled = false;
    context2.drawImage(image, 0, 0, canvas2.width, canvas2.height);
    return canvas2;
  }
  static async convertToPng(url2, size12 = 40) {
    const canvas2 = await ImageUtil2.convertToCanvas(url2, size12);
    return canvas2.toDataURL();
  }
  static rotateImage(inputCanvas, degrees2) {
    if (!inputCanvas)
      return null;
    const radians2 = degrees2 * Math.PI / 180;
    const cos2 = Math.abs(Math.cos(radians2));
    const sin2 = Math.abs(Math.sin(radians2));
    const newWidth = inputCanvas.width * cos2 + inputCanvas.height * sin2;
    const newHeight = inputCanvas.width * sin2 + inputCanvas.height * cos2;
    const canvas2 = document.createElement("canvas");
    canvas2.width = newWidth;
    canvas2.height = newHeight;
    const context2 = canvas2.getContext("2d", {
      alpha: true
    });
    context2.clearRect(0, 0, newWidth, newHeight);
    context2.save();
    context2.translate(newWidth / 2, newHeight / 2);
    context2.rotate(radians2);
    const x2 = -inputCanvas.width / 2;
    const y2 = -inputCanvas.height / 2;
    context2.imageSmoothingEnabled = false;
    context2.drawImage(inputCanvas, x2, y2);
    context2.restore();
    return canvas2;
  }
  static async convertToCanonicalImage(url2, box) {
    const computeAzimuth = (coordinates2) => {
      if (!coordinates2 || coordinates2.length !== 4)
        return 0;
      const axes = [];
      coordinates2.forEach((coord, index2, array2) => {
        if (index2 % 2 !== 0)
          return;
        const nextIdx = index2 + 1;
        const next5 = array2[nextIdx];
        axes.push([(coord[0] + next5[0]) / 2, (coord[1] + next5[1]) / 2]);
      });
      if (axes.length !== 2)
        return 0;
      const azimuth = GeoUtil.getAzimuth(axes[1], axes[0]);
      return azimuth;
    };
    const canonicalBox = GeoUtil.computeRectangle(box);
    if (canonicalBox && url2) {
      const azimuth = computeAzimuth(box);
      const image = await ImageUtil2.imageFromUrl(url2);
      const canvas2 = ImageUtil2.rotateImage(image, azimuth);
      const imageUrl = (canvas2 == null ? void 0 : canvas2.toDataURL()) || url2;
      return {
        box: canonicalBox,
        url: imageUrl
      };
    }
    return null;
  }
  static computeBox(center2, size12 = [0.02, 0.02], translate3 = [0, 0]) {
    if (!center2)
      return null;
    const box = [];
    const halfSize = [size12[0] * 0.5, size12[1] * 0.5];
    box.push([center2[0] - halfSize[0] + translate3[0], center2[1] - halfSize[1] + translate3[1]]);
    box.push([center2[0] + halfSize[0] + translate3[0], center2[1] - halfSize[1] + translate3[1]]);
    box.push([center2[0] + halfSize[0] + translate3[0], center2[1] + halfSize[1] + translate3[1]]);
    box.push([center2[0] - halfSize[0] + translate3[0], center2[1] + halfSize[1] + translate3[1]]);
    return box;
  }
  static async computeImageBox(url2, center2) {
    if (!url2)
      return null;
    const image = await ImageUtil2.imageFromUrl(url2);
    if (!image)
      return null;
    const aspect2 = image.width / image.height;
    const centerMerc = CoordinateUtil.toArray(CoordinateUtil.toMercator(center2));
    const factor = 1e-4;
    const box = ImageUtil2.computeBox(centerMerc, [factor * aspect2, factor]);
    return box == null ? void 0 : box.map((xyz) => {
      const v5 = CoordinateUtil.toArray(CoordinateUtil.toLngLat(xyz));
      return [v5[0], v5[1]];
    });
  }
  static computeScaledBox(center2, sizeInMeter = [5, 5]) {
    if (!center2)
      return null;
    const centerMerc = CoordinateUtil.toMercator(center2);
    const centerMercArray = CoordinateUtil.toArray(centerMerc);
    const sizeInMerc = [centerMerc.meterInMercatorCoordinateUnits() * sizeInMeter[0], centerMerc.meterInMercatorCoordinateUnits() * sizeInMeter[1]];
    const box = ImageUtil2.computeBox(centerMercArray, [sizeInMerc[0], sizeInMerc[1]]);
    return box == null ? void 0 : box.map((xyz) => {
      const v5 = CoordinateUtil.toArray(CoordinateUtil.toLngLat(xyz));
      return [v5[0], v5[1]];
    });
  }
  static generateCircleImage(width, height, {
    radius: radiusIn,
    fill,
    stroke = "white",
    strokeWidth: strokeWidth2 = 2
  }) {
    const canvas2 = document.createElement("canvas");
    canvas2.width = width;
    canvas2.height = height;
    const context2 = canvas2.getContext("2d", {
      alpha: true
    });
    const radius = radiusIn || width / 2;
    context2.beginPath();
    context2.arc(width / 2, height / 2, radius, 0, Math.PI * 2);
    context2.fillStyle = fill;
    context2.strokeStyle = stroke;
    context2.lineWidth = strokeWidth2;
    context2.fill();
    context2.stroke();
    context2.closePath();
    return canvas2;
  }
};
const CONVERSION_ID_KEY = "converter_temp_id";
const GEOJSON_KNOWN_PROPERTIES = {
  fill: ["fill", "color"],
  // polystyle.color
  fillOpacity: ["fill-opacity", "opacity", "fillOpacity"],
  stroke: ["stroke"],
  // linestyle.color
  strokeOpacity: ["stroke-opacity", "strokeOpacity"],
  strokeWidth: ["stroke-width", "strokeWidth"],
  strokeDashArray: ["stroke-dasharray", "strokeDashArray", "strokeDasharray"],
  groundOverlay: ["imageOverlay", "ground-overlay", "groundOverlay"],
  // groundOverlay
  groundOverlayBox: ["ground-overlay-box", "groundOverlayBox"],
  groundOverlayOpacity: ["ground-overlay-opacity", "groundOverlayOpacity"],
  markerSymbol: ["icon", "marker-symbol", "markerSymbol"],
  // icon information
  markerSize: ["marker-size", "markerSize"],
  textColor: ["text-color", "textColor"],
  textOpacity: ["text-opacity", "textOpacity"]
};
class KmlUtil {
  static async convertToGeoJson(data2, extension) {
    if (extension === "kml") {
      return KmlUtil.getGeoJsonFromKml(data2, []);
    }
    if (extension === "kmz") {
      const files2 = await FileUtil.getFilesFromZip(data2);
      if (!files2.length)
        return null;
      const kmlFile = files2.find((file2) => file2.extension === "kml");
      if (!kmlFile) {
        console.error("No kml found in kmz");
        return null;
      }
      const imageFiles = files2.filter((file2) => ["png", "jpg", "jpeg"].includes(file2.extension));
      return KmlUtil.getGeoJsonFromKml(kmlFile.content, imageFiles || []);
    }
    return null;
  }
  static async getGeoJsonFromKml(kmlString, imageFiles) {
    try {
      const kmlDoc = new DOMParser().parseFromString(kmlString, "text/xml");
      if (!kmlDoc)
        return null;
      const geojsonData = GeoUtil.getCuratedGeojson(togeojsonExports.kml(kmlDoc));
      const center2 = GeoUtil.centroid(geojsonData);
      if (center2) {
        center2.properties.category = "default-center";
        geojsonData.features.push(center2);
      }
      geojsonData.features.forEach((feature2) => {
        if (feature2.properties) {
          feature2.properties = GeoUtil.unFlattenedProperties(feature2.properties);
          if (Array.isArray(feature2.properties.center)) {
            feature2.properties.center[0] = Number(feature2.properties.center[0]);
            feature2.properties.center[1] = Number(feature2.properties.center[1]);
          }
        } else {
          feature2.properties = {};
        }
      });
      if (!(imageFiles == null ? void 0 : imageFiles.length))
        return geojsonData;
      const groundOverlays = kmlDoc.getElementsByTagName("GroundOverlay");
      Array.from(groundOverlays).forEach((groundOverlay) => {
        var _a3, _b3, _c2, _d2, _e2;
        const featureId = groundOverlay.getAttribute("id");
        if (typeof featureId === "undefined")
          return;
        const theFeature = geojsonData.features.find((feature2) => feature2.id === featureId);
        if (!theFeature)
          return;
        const imagePath = (_a3 = groundOverlay.querySelector("Icon href")) == null ? void 0 : _a3.textContent;
        if (!imagePath)
          return;
        const imageFile = imageFiles.find((image) => image.name === imagePath);
        if (!imageFile)
          return;
        const latLonBoxElement = groundOverlay.querySelector("LatLonBox");
        if (!latLonBoxElement)
          return;
        const north = parseFloat((_b3 = latLonBoxElement.querySelector("north")) == null ? void 0 : _b3.textContent);
        const south = parseFloat((_c2 = latLonBoxElement.querySelector("south")) == null ? void 0 : _c2.textContent);
        const east = parseFloat((_d2 = latLonBoxElement.querySelector("east")) == null ? void 0 : _d2.textContent);
        const west = parseFloat((_e2 = latLonBoxElement.querySelector("west")) == null ? void 0 : _e2.textContent);
        if (Number.isNaN(north) || Number.isNaN(south) || Number.isNaN(east) || Number.isNaN(west))
          return;
        theFeature.properties["ground-overlay"] = imageFile.content;
        theFeature.properties["ground-overlay-box"] = [[west, north], [east, north], [east, south], [west, south]];
      });
      const placemarks = kmlDoc.getElementsByTagName("Placemark");
      Array.from(placemarks).forEach((placemark) => {
        var _a3;
        const featureId = placemark.getAttribute("id");
        if (typeof featureId === "undefined")
          return;
        const theFeature = geojsonData.features.find((feature2) => feature2.id === featureId);
        if (!theFeature)
          return;
        const imagePath = (_a3 = placemark.querySelector("Icon href")) == null ? void 0 : _a3.textContent;
        if (!imagePath)
          return;
        if (imagePath.startsWith("files/image")) {
          const imageFile = imageFiles.find((image) => image.name === imagePath);
          if (!imageFile)
            return;
          theFeature.properties["marker-symbol"] = imageFile.content;
        } else if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
          theFeature.properties["marker-symbol"] = imagePath;
        }
      });
      return geojsonData;
    } catch (error2) {
      console.error("Error converting KML to GeoJSON:", error2);
    }
    return null;
  }
  static async convertToKml(geojson) {
    var _a3;
    if (geojson && geojson.features) {
      let counter2 = 0;
      geojson.features.forEach((feature2) => {
        feature2.properties[CONVERSION_ID_KEY] = `${counter2}`;
        counter2 += 1;
      });
      geojson.features.forEach((feature2) => {
        Object.keys(feature2.properties).forEach((key) => {
          if (feature2.properties[key] === void 0 || feature2.properties[key] === null) {
            delete feature2.properties[key];
          }
        });
      });
      const images = [];
      const kml = new DOMParser().parseFromString(tokml(geojson), "text/xml");
      const placemarks = Array.from(kml.getElementsByTagName("Placemark"));
      for await (const placemark of placemarks) {
        const conversionIdElement = Array.from(placemark.getElementsByTagName("Data")).find((data2) => data2.getAttribute("name") === "converter_temp_id");
        const conversionId = (_a3 = conversionIdElement == null ? void 0 : conversionIdElement.getElementsByTagName("value")[0]) == null ? void 0 : _a3.textContent;
        const feature2 = geojson.features.find((f2) => f2.properties[CONVERSION_ID_KEY] === conversionId);
        await KmlUtil.processCustomProperties({
          feature: feature2,
          placemark,
          geojson,
          kml,
          images
        });
      }
      const tempIdElements = Array.from(kml.getElementsByTagName(CONVERSION_ID_KEY));
      tempIdElements.forEach((element) => {
        element.parentNode.removeChild(element);
      });
      return {
        kml: new XMLSerializer().serializeToString(kml),
        images
      };
    }
    return null;
  }
  static async processCustomProperties(data2) {
    const firstExtendedData = data2.placemark.getElementsByTagName("ExtendedData")[0];
    if (firstExtendedData) {
      firstExtendedData.parentNode.removeChild(firstExtendedData);
    }
    await KmlUtil.processImageOverlay(data2);
    await KmlUtil.processStyling(data2);
    await KmlUtil.processIcon(data2);
    await KmlUtil.processText(data2);
    await KmlUtil.processExtendedData(data2);
  }
  static getGeoJsonProperty(key, feature2) {
    if (!(feature2 == null ? void 0 : feature2.properties))
      return null;
    const allKeys = GEOJSON_KNOWN_PROPERTIES[key] || [key];
    let value;
    allKeys.some((key2) => {
      value = feature2.properties[key2];
      return value !== void 0;
    });
    return value;
  }
  static removeGeoJsonProperty(key, feature2) {
    if (!(feature2 == null ? void 0 : feature2.properties))
      return null;
    const allKeys = GEOJSON_KNOWN_PROPERTIES[key] || [key];
    allKeys.forEach((key2) => {
      delete feature2.properties[key2];
    });
    return feature2;
  }
  // for checking if the geojson data contains image overlay or not
  static hasImageOverlay(geojson) {
    var _a3;
    return (_a3 = geojson == null ? void 0 : geojson.features) == null ? void 0 : _a3.some((feature2) => {
      const groundOverlay = KmlUtil.getGeoJsonProperty("groundOverlay", feature2);
      return typeof groundOverlay === "string" && !!groundOverlay;
    });
  }
  static async getCanonicalGroundOverlay(dataUrl, boundingBox) {
    if (typeof dataUrl !== "string")
      return null;
    if (!boundingBox || !Array.isArray(boundingBox))
      return null;
    const coord = boundingBox[0];
    if (!Array.isArray(coord))
      return null;
    const result = await ImageUtil$1.convertToCanonicalImage(dataUrl, boundingBox);
    return result;
  }
  static getOrCreateStyleXml({
    placemark,
    kml
  }) {
    var _a3;
    let style2 = (_a3 = placemark.getElementsByTagName("Style")) == null ? void 0 : _a3[0];
    if (!style2) {
      style2 = kml.createElement("Style");
    }
    return style2;
  }
  // specifically for handling image overlay
  static async processImageOverlay({
    feature: feature2,
    placemark,
    kml: kmlXml,
    images
  }) {
    if (!feature2 || !feature2.properties) {
      return;
    }
    const canonical = await KmlUtil.getCanonicalGroundOverlay(KmlUtil.getGeoJsonProperty("groundOverlay", feature2), KmlUtil.getGeoJsonProperty("groundOverlayBox", feature2));
    if (!canonical)
      return;
    const {
      box,
      url: url2
    } = canonical;
    images.push(atob(url2.replace(/^data:image\/\w+;base64,/, "")));
    const [west, south, east, north] = box;
    const groundOverlay = kmlXml.createElement("GroundOverlay");
    const nameValue = KmlUtil.getGeoJsonProperty("name", feature2);
    if (nameValue) {
      const nameElement = kmlXml.createElement("name");
      nameElement.textContent = nameValue;
      groundOverlay.appendChild(nameElement);
      delete feature2.properties.name;
    }
    if (feature2.id) {
      groundOverlay.setAttribute("id", feature2.id);
    }
    const icon = kmlXml.createElement("Icon");
    const href = kmlXml.createElement("href");
    href.textContent = `files/image${images.length - 1}.jpg`;
    icon.appendChild(href);
    const latLonBox = kmlXml.createElement("LatLonBox");
    latLonBox.appendChild(kmlXml.createElement("north")).textContent = north;
    latLonBox.appendChild(kmlXml.createElement("south")).textContent = south;
    latLonBox.appendChild(kmlXml.createElement("east")).textContent = east;
    latLonBox.appendChild(kmlXml.createElement("west")).textContent = west;
    groundOverlay.appendChild(icon);
    groundOverlay.appendChild(latLonBox);
    const {
      parentNode
    } = placemark;
    const {
      nextSibling
    } = placemark;
    if (nextSibling) {
      parentNode.insertBefore(groundOverlay, nextSibling);
    } else {
      parentNode.appendChild(groundOverlay);
    }
  }
  // specifically for icon-specific information
  static async processIcon({
    feature: feature2,
    placemark,
    kml: kmlXml,
    images
  }) {
    let url2 = KmlUtil.getGeoJsonProperty("markerSymbol", feature2);
    if (!url2)
      return;
    if (url2.startsWith("http://") || url2.startsWith("https://")) {
      const result = await FileUtil.importFromUrl(url2, "dataUrl");
      url2 = result == null ? void 0 : result.data;
    }
    if (url2.startsWith("data:image")) {
      images.push(atob(url2.replace(/^data:image\/\w+;base64,/, "")));
    } else {
      return;
    }
    const style2 = await KmlUtil.getOrCreateStyleXml({
      placemark,
      kml: kmlXml
    });
    const iconStyle = kmlXml.createElement("IconStyle");
    const icon = kmlXml.createElement("Icon");
    const href = kmlXml.createElement("href");
    href.textContent = `files/image${images.length - 1}.jpg`;
    icon.appendChild(href);
    iconStyle.appendChild(icon);
    style2.appendChild(iconStyle);
    placemark.appendChild(style2);
  }
  // specifically for text or label
  static async processText({
    placemark,
    feature: feature2,
    kml: kmlXml
  }) {
    if (!feature2 || !feature2.properties) {
      return;
    }
    const textColor2 = KmlUtil.getGeoJsonProperty("textColor", feature2);
    const textOpacity = KmlUtil.getGeoJsonProperty("textOpacity", feature2);
    const style2 = await KmlUtil.getOrCreateStyleXml({
      placemark,
      kml: kmlXml
    });
    let hasText = false;
    if (textColor2 !== void 0) {
      const fillAlpha = KmlUtil.getOpacity(textOpacity);
      const fillHexColor = KmlUtil.getColorHex(textColor2);
      const labelStyle = kmlXml.createElement("LabelStyle");
      labelStyle.appendChild(kmlXml.createElement("color")).textContent = fillAlpha + fillHexColor;
      hasText = true;
      style2.appendChild(labelStyle);
    }
    if (hasText) {
      placemark.appendChild(style2);
    }
  }
  // specifically for color-specific information
  static async processStyling({
    feature: feature2,
    placemark,
    kml: kmlXml
  }) {
    if (!feature2 || !feature2.properties) {
      return;
    }
    const fillOpacity = KmlUtil.getGeoJsonProperty("fillOpacity", feature2);
    const strokeOpacity = KmlUtil.getGeoJsonProperty("strokeOpacity", feature2);
    const fill = KmlUtil.getGeoJsonProperty("fill", feature2);
    const stroke = KmlUtil.getGeoJsonProperty("stroke", feature2);
    const strokeWidth2 = KmlUtil.getGeoJsonProperty("strokeWidth", feature2);
    const style2 = await KmlUtil.getOrCreateStyleXml({
      placemark,
      kml: kmlXml
    });
    let hasColor = false;
    if (stroke !== void 0) {
      const strokeAlpha = KmlUtil.getOpacity(strokeOpacity);
      const strokeHexColor = KmlUtil.getColorHex(stroke);
      const lineStyle = kmlXml.createElement("LineStyle");
      lineStyle.appendChild(kmlXml.createElement("color")).textContent = strokeAlpha + strokeHexColor;
      lineStyle.appendChild(kmlXml.createElement("width")).textContent = `${strokeWidth2}` || "1";
      lineStyle.appendChild(kmlXml.createElement("colorMode")).textContent = "normal";
      hasColor = true;
      style2.appendChild(lineStyle);
    }
    if (fill !== void 0) {
      const fillAlpha = KmlUtil.getOpacity(fillOpacity);
      const fillHexColor = KmlUtil.getColorHex(fill);
      const polyStyle = kmlXml.createElement("PolyStyle");
      polyStyle.appendChild(kmlXml.createElement("color")).textContent = fillAlpha + fillHexColor;
      polyStyle.appendChild(kmlXml.createElement("outline")).textContent = "1";
      polyStyle.appendChild(kmlXml.createElement("colorMode")).textContent = "normal";
      hasColor = true;
      style2.appendChild(polyStyle);
    }
    if (hasColor) {
      placemark.appendChild(style2);
    }
  }
  // for handling additional information
  static async processExtendedData({
    feature: feature2,
    placemark,
    kml: kmlXml
  }) {
    if (!feature2 || !feature2.properties) {
      return;
    }
    if (feature2.id)
      placemark.setAttribute("id", feature2.id);
    const knownProperties = Object.values(GEOJSON_KNOWN_PROPERTIES).flat();
    knownProperties.push(CONVERSION_ID_KEY);
    const appendKeyValueToParent = (key, value, parentData) => {
      const data2 = kmlXml.createElement("Data");
      data2.setAttribute("name", key);
      const dataValue = kmlXml.createElement("value");
      dataValue.textContent = value;
      data2.appendChild(dataValue);
      parentData.appendChild(data2);
    };
    const extendedData = kmlXml.createElement("ExtendedData");
    const flattenedKeyValues = GeoUtil.flattenedProperties(feature2.properties, null, true, knownProperties);
    flattenedKeyValues.forEach(({
      key,
      value
    }) => {
      appendKeyValueToParent(key, value, extendedData);
    });
    if (extendedData.childElementCount > 0) {
      placemark.appendChild(extendedData);
    }
  }
  static getColorHex(color) {
    if (color.startsWith("#")) {
      color = color.slice(1);
    }
    if (color.length === 3) {
      color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
    }
    const red2 = color.slice(0, 2);
    const green2 = color.slice(2, 4);
    const blue2 = color.slice(4, 6);
    return blue2 + green2 + red2;
  }
  static getOpacity(opacity) {
    if (opacity === void 0 || opacity === null) {
      return "FF";
    }
    if (typeof opacity === "string") {
      if (opacity.startsWith("#")) {
        return parseInt(opacity.slice(1, 3), 16).toString(16).padStart(2, "0");
      }
      return parseFloat(opacity).toString(16).padStart(2, "0");
    }
    if (typeof opacity === "number") {
      const decimalOpacity = Math.round(opacity * 255);
      const hexOpacity = decimalOpacity.toString(16).padStart(2, "0");
      return hexOpacity;
    }
    return opacity;
  }
  static async downloadAsKmz(kmlData, images) {
    const zip = new jszip_minExports();
    const filesFolder = zip.folder("files");
    images == null ? void 0 : images.forEach((imageData, index2) => {
      filesFolder.file(`image${index2}.jpg`, imageData, {
        binary: true
      });
    });
    zip.file("doc.kml", kmlData, {
      binary: true
    });
    const content = await zip.generateAsync({
      type: "blob"
    });
    return content;
  }
}
class ExportUtil {
  static async exportToFormat(siteState, assetState, projectState, format, activeId, allowedCollectionTypes) {
    const getGeojsonData = () => ExportUtil.exportToJson(siteState, assetState, projectState, true, activeId, true, true, allowedCollectionTypes);
    const getJsonData = () => ExportUtil.exportToJson(siteState, assetState, projectState, false, activeId, true, true, allowedCollectionTypes);
    const getKmlData = async () => {
      const geojsonData = getGeojsonData();
      const {
        kml: kmlData,
        images
      } = await KmlUtil.convertToKml(geojsonData);
      if (images == null ? void 0 : images.length) {
        const kmzContent = await KmlUtil.downloadAsKmz(kmlData, images);
        return {
          data: kmzContent,
          type: FileUtil.EXTENSION_MIME_TYPES.kmz
        };
      }
      return {
        data: kmlData,
        type: FileUtil.EXTENSION_MIME_TYPES.kml
      };
    };
    const type = FileUtil.EXTENSION_MIME_TYPES.txt;
    if (format === "geojson")
      return {
        data: getGeojsonData(),
        type
      };
    if (format === "json")
      return {
        data: getJsonData(),
        type
      };
    if (format === "kml/kmz")
      return await getKmlData();
    return null;
  }
  static exportToJson(siteState, assetState, projectState, isGeoJson, activeId = null, onlyVisible = true, skipChildren = true, allowedCollectionTypes = null) {
    const selectedIds = ExportUtil.getSelectedIds(siteState, activeId, skipChildren, allowedCollectionTypes);
    const geoJson = ExportUtil.exportSiteToJson(siteState, isGeoJson, selectedIds);
    const assetFeatures = ExportUtil.exportAssetsToJson(assetState, isGeoJson, onlyVisible, selectedIds);
    const projectSelectedIds = activeId ? [activeId] : null;
    const projectFeatures = ExportUtil.exportProjectsToJson(projectState, isGeoJson, projectSelectedIds);
    if (isGeoJson) {
      const result = geoJson || {
        type: "FeatureCollection",
        features: []
      };
      result.features.push(...assetFeatures || []);
      result.features.push(...projectFeatures || []);
      return result;
    }
    return {
      ...geoJson || {},
      assets: assetFeatures || {},
      projectFeatures
    };
  }
  static exportSiteToJson(state, isGeojson, selectedIds = []) {
    const {
      defaultCenter,
      categories: categories2,
      visiblePropertyKeys,
      deletedObjectIds
    } = state;
    if (isGeojson) {
      const SKIP_CATEGORIES = ["default-center", "orphan", "marker"];
      const SKIP_PROPERTIES = ["indices", "zoneId", "levelId", "buildingId", "venueId", "countryId", "marketId", "clusterId", "regionId", "orphanId"];
      const features = [];
      if (!SKIP_CATEGORIES.includes("default-center") && defaultCenter) {
        features.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: defaultCenter
          },
          properties: {
            category: "default-center"
          }
        });
      }
      const getParentAttribute = (item, parentAttribute = "center") => {
        let found = null;
        SiteStoreHelper.COLLECTION_TYPES.some((parentType) => {
          var _a3, _b3;
          const parentIdKey = SiteStoreHelper.parentType2ParentIdName(parentType);
          if (item[parentIdKey]) {
            found = (_b3 = (_a3 = SiteStoreHelper.getObjectById(item[parentIdKey], false, state)) == null ? void 0 : _a3.collectionItem) == null ? void 0 : _b3[parentAttribute];
            return !!found;
          }
          return !!found;
        });
        return found;
      };
      const curateFeature = (cloned) => {
        if (cloned.properties.category === "orphan" || cloned.properties.category === "country") {
          delete cloned.properties.parentId;
        } else {
          cloned.properties.parentId = (cloned.properties.category === "zone" ? null : cloned.properties.zoneId) || (cloned.properties.category === "level" ? null : cloned.properties.levelId) || (cloned.properties.category === "building" ? null : cloned.properties.buildingId) || (cloned.properties.category === "venue" ? null : cloned.properties.venueId) || (cloned.properties.category === "cluster" ? null : cloned.properties.clusterId) || (cloned.properties.category === "market" ? null : cloned.properties.marketId) || (cloned.properties.category === "region" ? null : cloned.properties.regionId) || (cloned.properties.category === "country" ? null : cloned.properties.countryId);
        }
        cloned.properties.name = cloned.name;
        delete cloned.name;
        delete cloned.parentId;
        SKIP_PROPERTIES.forEach((key) => {
          delete cloned.properties[key];
        });
        return cloned;
      };
      SiteStoreHelper.COLLECTION_TYPES.forEach((parentType) => {
        if (SKIP_CATEGORIES.includes(parentType))
          return;
        const collectionName = SiteStoreHelper.parentType2CollectionName(parentType);
        const collection = state[collectionName];
        const exportFootprintOnly = true;
        collection == null ? void 0 : collection.forEach((item) => {
          var _a3;
          let skipFootprint = false;
          const layers = {};
          (_a3 = item == null ? void 0 : item.features) == null ? void 0 : _a3.forEach((f2) => {
            var _a4, _b3;
            if (SKIP_CATEGORIES.includes(f2.properties.category))
              return;
            if (!selectedIds.includes(f2.id))
              return;
            const layerName = (_a4 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a4.layer;
            if (layerName) {
              if (!layers[layerName])
                layers[layerName] = {
                  geometries: [],
                  feature: {
                    ...f2,
                    properties: {
                      ...f2.properties || {}
                    }
                  }
                };
              layers[layerName].geometries.push(f2.geometry);
            } else if (((_b3 = f2.properties) == null ? void 0 : _b3.category) === "footprint") {
              if (!skipFootprint) {
                const cloned = {
                  ...f2,
                  properties: {
                    ...f2.properties || {}
                  }
                };
                cloned.properties.category = parentType;
                cloned.id = item.id;
                cloned.name = item.name;
                Object.keys(item).forEach((key) => {
                  if (key === "features" || key === "type" || key === "id")
                    return;
                  const mappedKey = key;
                  cloned.properties[mappedKey] = item[key];
                });
                features.push(curateFeature(cloned));
                skipFootprint = true;
              }
            } else {
              const cloned = {
                ...f2,
                properties: {
                  ...f2.properties || {}
                }
              };
              features.push(curateFeature(cloned));
            }
          });
          if (!skipFootprint && exportFootprintOnly && selectedIds.includes(item.id)) {
            const cloned = {
              type: "Feature",
              properties: {}
            };
            if (item.center)
              cloned.geometry = {
                type: "Point",
                coordinates: item.center
              };
            else {
              const parentCenter = getParentAttribute(item, "center");
              if (parentCenter)
                cloned.geometry = {
                  type: "Point",
                  coordinates: parentCenter
                };
              else {
                cloned.geometry = {
                  type: "Point",
                  coordinates: defaultCenter
                };
                console.error("No geometry for level");
              }
            }
            cloned.properties.category = parentType;
            cloned.id = item.id;
            cloned.name = item.name;
            Object.keys(item).forEach((key) => {
              if (key === "features" || key === "type" || key === "id")
                return;
              const mappedKey = key;
              cloned.properties[mappedKey] = item[key];
            });
            features.push(curateFeature(cloned));
          }
          Object.keys(layers).forEach((layer) => {
            var _a4, _b3;
            const singleFeature = {
              ...curateFeature((_a4 = layers[layer]) == null ? void 0 : _a4.feature) || {}
            };
            singleFeature.geometry = {
              type: "GeometryCollection",
              geometries: (_b3 = layers[layer]) == null ? void 0 : _b3.geometries
            };
            features.push(singleFeature);
          });
        });
      });
      if (deletedObjectIds == null ? void 0 : deletedObjectIds.length) {
        features.push({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: defaultCenter || [0, 0]
          },
          properties: {
            category: "deleted",
            deletedObjectIds
          }
        });
      }
      const data2 = {
        type: "FeatureCollection",
        features
      };
      return data2;
    }
    const selected = {};
    SiteStoreHelper.COLLECTION_TYPES.forEach((parentType) => {
      const collectionName = SiteStoreHelper.parentType2CollectionName(parentType);
      selected[collectionName] = [];
      const collection = state[collectionName];
      collection == null ? void 0 : collection.forEach((item) => {
        var _a3;
        if (!selectedIds.includes(item.id))
          return;
        const selectedFeatures = [];
        (_a3 = item == null ? void 0 : item.features) == null ? void 0 : _a3.forEach((f2) => {
          if (selectedIds.includes(f2.id))
            selectedFeatures.push(f2);
        });
        selected[collectionName].push({
          ...item,
          features: selectedFeatures
        });
      });
    });
    return {
      // defaultCenter,
      orphans: selected.orphans,
      buildings: selected.buildings,
      levels: selected.levels,
      venues: selected.venues,
      regions: selected.regions,
      clusters: selected.clusters,
      markets: selected.markets,
      zones: selected.zones,
      categories: categories2,
      visiblePropertyKeys
    };
  }
  static exportAssetsToJson(state, isGeoJson, onlyVisible = true, selectedIds = []) {
    const {
      assets
    } = state || {};
    if (!isGeoJson)
      return assets.filter((asset) => selectedIds.includes(asset.parentId));
    const features = [];
    assets == null ? void 0 : assets.forEach((asset) => {
      if (!selectedIds.includes(asset.parentId))
        return;
      const feature2 = AssetHelper.getAssetFeature(asset, onlyVisible);
      if (feature2) {
        features.push(feature2);
      }
    });
    return features;
  }
  static exportProjectsToJson(projectState, isGeoJson, selectedIds) {
    const {
      projects
    } = projectState || {};
    const exporteAllFeautes = !selectedIds || (selectedIds == null ? void 0 : selectedIds.length) === 0;
    if (isGeoJson) {
      const features = [];
      projects == null ? void 0 : projects.forEach((project3) => {
        var _a3;
        (_a3 = project3.categories) == null ? void 0 : _a3.forEach((category) => {
          var _a4, _b3;
          if (exporteAllFeautes || (selectedIds == null ? void 0 : selectedIds.includes(category.id))) {
            if (category.type === "raster") {
              (_a4 = category.features) == null ? void 0 : _a4.forEach((asset) => {
                let feature2 = AssetHelper.getAssetFeature(asset, false);
                if (!feature2)
                  return;
                feature2 = {
                  ...feature2,
                  properties: {
                    ...feature2.properties || {},
                    // project attributes
                    parentId: project3.name,
                    parentType: "project",
                    category: category.name,
                    // name of the group given by the user
                    visible: category.show
                  }
                };
                features.push(feature2);
              });
            } else {
              (_b3 = category.features) == null ? void 0 : _b3.forEach((f2) => {
                const feature2 = {
                  ...f2,
                  properties: {
                    ...f2.properties || {},
                    // project attributes
                    parentId: project3.name,
                    parentType: "project",
                    category: category.name,
                    // name of the group given by the user
                    visible: category.show
                  }
                };
                features.push(feature2);
              });
            }
          }
        });
      });
      return features;
    }
    return null;
  }
  static getSelectedIds(siteState, activeId, skipChildren = false, allowedCollectionTypes = null) {
    const selectedIds = activeId ? [activeId] : [];
    const isSelected = (object2) => {
      var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h, _i;
      if (!activeId) {
        selectedIds.push(object2.id);
        return true;
      }
      if (selectedIds.includes(object2 == null ? void 0 : object2.id))
        return true;
      if (selectedIds.includes(object2 == null ? void 0 : object2.parentId) || selectedIds.includes((_a3 = object2 == null ? void 0 : object2.properties) == null ? void 0 : _a3.parentId)) {
        if (object2 == null ? void 0 : object2.id)
          selectedIds.push(object2.id);
        return true;
      }
      if (!skipChildren) {
        if (selectedIds.includes(object2 == null ? void 0 : object2.countryId) || selectedIds.includes((_b3 = object2 == null ? void 0 : object2.properties) == null ? void 0 : _b3.countryId) || selectedIds.includes(object2 == null ? void 0 : object2.regionId) || selectedIds.includes((_c2 = object2 == null ? void 0 : object2.properties) == null ? void 0 : _c2.regionId) || selectedIds.includes(object2 == null ? void 0 : object2.marketId) || selectedIds.includes((_d2 = object2 == null ? void 0 : object2.properties) == null ? void 0 : _d2.marketId) || selectedIds.includes(object2 == null ? void 0 : object2.clusterId) || selectedIds.includes((_e2 = object2 == null ? void 0 : object2.properties) == null ? void 0 : _e2.clusterId) || selectedIds.includes(object2 == null ? void 0 : object2.venueId) || selectedIds.includes((_f3 = object2 == null ? void 0 : object2.properties) == null ? void 0 : _f3.venueId) || selectedIds.includes(object2 == null ? void 0 : object2.buildingId) || selectedIds.includes((_g = object2 == null ? void 0 : object2.properties) == null ? void 0 : _g.buildingId) || selectedIds.includes(object2 == null ? void 0 : object2.levelId) || selectedIds.includes((_h = object2 == null ? void 0 : object2.properties) == null ? void 0 : _h.levelId) || selectedIds.includes(object2 == null ? void 0 : object2.zoneId) || selectedIds.includes((_i = object2 == null ? void 0 : object2.properties) == null ? void 0 : _i.zoneId)) {
          if (object2 == null ? void 0 : object2.id)
            selectedIds.push(object2.id);
          return true;
        }
      }
      return false;
    };
    SiteStoreHelper.COLLECTION_TYPES.filter((parenType) => {
      if (!allowedCollectionTypes)
        return true;
      return allowedCollectionTypes.includes(parenType);
    }).forEach((parentType) => {
      const collectionName = SiteStoreHelper.parentType2CollectionName(parentType);
      const collection = siteState[collectionName];
      collection == null ? void 0 : collection.forEach((item) => {
        var _a3;
        if (!isSelected(item))
          return;
        (_a3 = item == null ? void 0 : item.features) == null ? void 0 : _a3.forEach((f2) => isSelected(f2));
      });
    });
    return selectedIds;
  }
}
const useAssetStore = createZustandStore((set, get6) => ({
  editAssetQueue: [],
  // Id of asset which needs to be georeferenced
  editAssetId: null,
  // Id of asset which is currently under georeferencing
  setEditAssetId: (id) => {
    set((state) => {
      if (id) {
        if (!state.editAssetId) {
          state.editAssetId = id;
        } else {
          state.editAssetQueue.push(id);
        }
      } else {
        state.editAssetId = state.editAssetQueue.shift();
      }
    });
  },
  assets: [],
  addAsset: (asset) => {
    set((state) => {
      if (asset) {
        const index2 = state.assets.findIndex((item) => item.id === asset.id);
        if (!(index2 > -1)) {
          state.assets.push({
            ...asset,
            visible: true
          });
        }
      }
    });
  },
  // Non-reactive
  getAsset: (assetId) => {
    if (assetId) {
      assetId = typeof assetId === "object" ? assetId.id : assetId;
      const index2 = get6().assets.findIndex((item) => item.id === assetId);
      if (index2 > -1) {
        return get6().assets[index2];
      }
    }
    return null;
  },
  removeAsset: (assetId) => {
    set((state) => {
      if (assetId) {
        assetId = typeof assetId === "object" ? assetId.id : assetId;
        const index2 = state.assets.findIndex((item) => item.id === assetId);
        if (index2 > -1) {
          const {
            assets
          } = get6();
          state.assets = [...assets.slice(0, index2), ...assets.slice(index2 + 1, assets.length)];
        }
      }
    });
  },
  updateAsset: (data2) => {
    const {
      id,
      ...rest
    } = data2 || {};
    const {
      assets
    } = get6();
    const index2 = assets.findIndex((item) => item.id === id);
    if (index2 > -1) {
      set((state) => {
        const asset = assets[index2];
        state.assets = [...assets.slice(0, index2), {
          ...asset,
          ...rest
        }, ...assets.slice(index2 + 1, assets.length)];
      });
    }
  },
  setVisibility: (data2, visiblity) => {
    const {
      id
    } = data2 || {};
    const {
      assets
    } = get6();
    const index2 = assets.findIndex((item) => item.id === id);
    if (index2 > -1) {
      set((state) => {
        const asset = assets[index2];
        state.assets = [...assets.slice(0, index2), {
          ...asset,
          visible: !!visiblity
        }, ...assets.slice(index2 + 1, assets.length)];
      });
    }
  },
  setOpacity: (data2, opacity) => {
    const {
      id
    } = data2 || {};
    const {
      assets
    } = get6();
    const index2 = assets.findIndex((item) => item.id === id);
    if (index2 > -1) {
      set((state) => {
        const asset = assets[index2];
        state.assets = [...assets.slice(0, index2), {
          ...asset,
          opacity: opacity || 0
        }, ...assets.slice(index2 + 1, assets.length)];
      });
    }
  },
  addAssets: (assets) => {
    assets == null ? void 0 : assets.forEach((asset) => {
      const existing = get6().assets;
      const found = existing.find((a2) => a2.id === asset.id);
      if (!found)
        get6().addAsset(asset);
    });
  },
  saveToJson: (geojson, onlyVisible = true, selectedIds = []) => ExportUtil.exportAssetsToJson(get6(), geojson, onlyVisible, selectedIds),
  loadUpdate: (result) => {
    const {
      assets
    } = result || {};
    if (assets == null ? void 0 : assets.length) {
      get6().addAssets(assets);
    }
  },
  loadFromJson: (json, geojson) => {
    const assets = ImportUtil.importAssetsFromJson(json, geojson);
    get6().loadUpdate({
      assets
    });
    return assets;
  }
}), "AssetStore");
var SelectorType;
(function(SelectorType2) {
  SelectorType2["ENV"] = "env";
  SelectorType2["CONFIG"] = "shared config entry";
})(SelectorType || (SelectorType = {}));
const DEFAULT_USE_DUALSTACK_ENDPOINT = false;
const DEFAULT_USE_FIPS_ENDPOINT = false;
const normalizeProvider = (input) => {
  if (typeof input === "function")
    return input;
  const promisified = Promise.resolve(input);
  return () => promisified;
};
const isFipsRegion = (region) => typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));
const getRealRegion = (region) => isFipsRegion(region) ? ["fips-aws-global", "aws-fips"].includes(region) ? "us-east-1" : region.replace(/fips-(dkr-|prod-)?|-fips/, "") : region;
const resolveRegionConfig = (input) => {
  const { region, useFipsEndpoint } = input;
  if (!region) {
    throw new Error("Region is missing");
  }
  return {
    ...input,
    region: async () => {
      if (typeof region === "string") {
        return getRealRegion(region);
      }
      const providedRegion = await region();
      return getRealRegion(providedRegion);
    },
    useFipsEndpoint: async () => {
      const providedRegion = typeof region === "string" ? region : await region();
      if (isFipsRegion(providedRegion)) {
        return true;
      }
      return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
    }
  };
};
const resolveEventStreamSerdeConfig = (input) => ({
  ...input,
  eventStreamMarshaller: input.eventStreamSerdeProvider(input)
});
var FieldPosition$1;
(function(FieldPosition2) {
  FieldPosition2[FieldPosition2["HEADER"] = 0] = "HEADER";
  FieldPosition2[FieldPosition2["TRAILER"] = 1] = "TRAILER";
})(FieldPosition$1 || (FieldPosition$1 = {}));
let HttpRequest$1 = class HttpRequest2 {
  constructor(options2) {
    this.method = options2.method || "GET";
    this.hostname = options2.hostname || "localhost";
    this.port = options2.port;
    this.query = options2.query || {};
    this.headers = options2.headers || {};
    this.body = options2.body;
    this.protocol = options2.protocol ? options2.protocol.slice(-1) !== ":" ? `${options2.protocol}:` : options2.protocol : "https:";
    this.path = options2.path ? options2.path.charAt(0) !== "/" ? `/${options2.path}` : options2.path : "/";
  }
  static isInstance(request) {
    if (!request)
      return false;
    const req = request;
    return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
  }
  clone() {
    const cloned = new HttpRequest2({
      ...this,
      headers: { ...this.headers }
    });
    if (cloned.query)
      cloned.query = cloneQuery$2(cloned.query);
    return cloned;
  }
};
function cloneQuery$2(query6) {
  return Object.keys(query6).reduce((carry, paramName) => {
    const param = query6[paramName];
    return {
      ...carry,
      [paramName]: Array.isArray(param) ? [...param] : param
    };
  }, {});
}
class HttpResponse {
  constructor(options2) {
    this.statusCode = options2.statusCode;
    this.headers = options2.headers || {};
    this.body = options2.body;
  }
  static isInstance(response) {
    if (!response)
      return false;
    const resp = response;
    return typeof resp.statusCode === "number" && typeof resp.headers === "object";
  }
}
const CONTENT_LENGTH_HEADER$1 = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
  return (next5) => async (args) => {
    const request = args.request;
    if (HttpRequest$1.isInstance(request)) {
      const { body, headers } = request;
      if (body && Object.keys(headers).map((str) => str.toLowerCase()).indexOf(CONTENT_LENGTH_HEADER$1) === -1) {
        try {
          const length2 = bodyLengthChecker(body);
          request.headers = {
            ...request.headers,
            [CONTENT_LENGTH_HEADER$1]: String(length2)
          };
        } catch (error2) {
        }
      }
    }
    return next5({
      ...args,
      request
    });
  };
}
const contentLengthMiddlewareOptions = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware",
  override: true
};
const getContentLengthPlugin = (options2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(contentLengthMiddleware(options2.bodyLengthChecker), contentLengthMiddlewareOptions);
  }
});
const resolveParamsForS3 = async (endpointParams) => {
  const bucket = (endpointParams == null ? void 0 : endpointParams.Bucket) || "";
  if (typeof endpointParams.Bucket === "string") {
    endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
  }
  if (isArnBucketName(bucket)) {
    if (endpointParams.ForcePathStyle === true) {
      throw new Error("Path-style addressing cannot be used with ARN buckets");
    }
  } else if (!isDnsCompatibleBucketName(bucket) || bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:") || bucket.toLowerCase() !== bucket || bucket.length < 3) {
    endpointParams.ForcePathStyle = true;
  }
  if (endpointParams.DisableMultiRegionAccessPoints) {
    endpointParams.disableMultiRegionAccessPoints = true;
    endpointParams.DisableMRAP = true;
  }
  return endpointParams;
};
const DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const DOTS_PATTERN = /\.\./;
const isDnsCompatibleBucketName = (bucketName) => DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
const isArnBucketName = (bucketName) => {
  const [arn, partition2, service, region, account, typeOrId] = bucketName.split(":");
  const isArn = arn === "arn" && bucketName.split(":").length >= 6;
  const isValidArn = [arn, partition2, service, account, typeOrId].filter(Boolean).length === 5;
  if (isArn && !isValidArn) {
    throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
  }
  return arn === "arn" && !!partition2 && !!service && !!account && !!typeOrId;
};
const createConfigValueProvider = (configKey, canonicalEndpointParamKey, config2) => {
  const configProvider = async () => {
    const configValue = config2[configKey] ?? config2[canonicalEndpointParamKey];
    if (typeof configValue === "function") {
      return configValue();
    }
    return configValue;
  };
  if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") {
    return async () => {
      const endpoint = await configProvider();
      if (endpoint && typeof endpoint === "object") {
        if ("url" in endpoint) {
          return endpoint.url.href;
        }
        if ("hostname" in endpoint) {
          const { protocol, hostname, port, path: path2 } = endpoint;
          return `${protocol}//${hostname}${port ? ":" + port : ""}${path2}`;
        }
      }
      return endpoint;
    };
  }
  return configProvider;
};
const getEndpointFromInstructions = async (commandInput, instructionsSupplier, clientConfig, context2) => {
  const endpointParams = await resolveParams(commandInput, instructionsSupplier, clientConfig);
  if (typeof clientConfig.endpointProvider !== "function") {
    throw new Error("config.endpointProvider is not set.");
  }
  const endpoint = clientConfig.endpointProvider(endpointParams, context2);
  return endpoint;
};
const resolveParams = async (commandInput, instructionsSupplier, clientConfig) => {
  var _a3;
  const endpointParams = {};
  const instructions = ((_a3 = instructionsSupplier == null ? void 0 : instructionsSupplier.getEndpointParameterInstructions) == null ? void 0 : _a3.call(instructionsSupplier)) || {};
  for (const [name2, instruction] of Object.entries(instructions)) {
    switch (instruction.type) {
      case "staticContextParams":
        endpointParams[name2] = instruction.value;
        break;
      case "contextParams":
        endpointParams[name2] = commandInput[instruction.name];
        break;
      case "clientContextParams":
      case "builtInParams":
        endpointParams[name2] = await createConfigValueProvider(instruction.name, name2, clientConfig)();
        break;
      default:
        throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
    }
  }
  if (Object.keys(instructions).length === 0) {
    Object.assign(endpointParams, clientConfig);
  }
  if (String(clientConfig.serviceId).toLowerCase() === "s3") {
    await resolveParamsForS3(endpointParams);
  }
  return endpointParams;
};
function parseQueryString(querystring) {
  const query6 = {};
  querystring = querystring.replace(/^\?/, "");
  if (querystring) {
    for (const pair of querystring.split("&")) {
      let [key, value = null] = pair.split("=");
      key = decodeURIComponent(key);
      if (value) {
        value = decodeURIComponent(value);
      }
      if (!(key in query6)) {
        query6[key] = value;
      } else if (Array.isArray(query6[key])) {
        query6[key].push(value);
      } else {
        query6[key] = [query6[key], value];
      }
    }
  }
  return query6;
}
const parseUrl = (url2) => {
  if (typeof url2 === "string") {
    return parseUrl(new URL(url2));
  }
  const { hostname, pathname, port, protocol, search } = url2;
  let query6;
  if (search) {
    query6 = parseQueryString(search);
  }
  return {
    hostname,
    port: port ? parseInt(port) : void 0,
    protocol,
    path: pathname,
    query: query6
  };
};
const toEndpointV1 = (endpoint) => {
  if (typeof endpoint === "object") {
    if ("url" in endpoint) {
      return parseUrl(endpoint.url);
    }
    return endpoint;
  }
  return parseUrl(endpoint);
};
const endpointMiddleware = ({ config: config2, instructions }) => {
  return (next5, context2) => async (args) => {
    var _a3, _b3;
    const endpoint = await getEndpointFromInstructions(args.input, {
      getEndpointParameterInstructions() {
        return instructions;
      }
    }, { ...config2 }, context2);
    context2.endpointV2 = endpoint;
    context2.authSchemes = (_a3 = endpoint.properties) == null ? void 0 : _a3.authSchemes;
    const authScheme = (_b3 = context2.authSchemes) == null ? void 0 : _b3[0];
    if (authScheme) {
      context2["signing_region"] = authScheme.signingRegion;
      context2["signing_service"] = authScheme.signingName;
    }
    return next5({
      ...args
    });
  };
};
const deserializerMiddleware = (options2, deserializer) => (next5, context2) => async (args) => {
  const { response } = await next5(args);
  try {
    const parsed = await deserializer(response, options2);
    return {
      response,
      output: parsed
    };
  } catch (error2) {
    Object.defineProperty(error2, "$response", {
      value: response
    });
    if (!("$metadata" in error2)) {
      const hint2 = `Deserialization error: to see the raw response, inspect the hidden field {error}.$response on this object.`;
      error2.message += "\n  " + hint2;
    }
    throw error2;
  }
};
const serializerMiddleware = (options2, serializer) => (next5, context2) => async (args) => {
  var _a3;
  const endpoint = ((_a3 = context2.endpointV2) == null ? void 0 : _a3.url) && options2.urlParser ? async () => options2.urlParser(context2.endpointV2.url) : options2.endpoint;
  if (!endpoint) {
    throw new Error("No valid endpoint provider available.");
  }
  const request = await serializer(args.input, { ...options2, endpoint });
  return next5({
    ...args,
    request
  });
};
const deserializerMiddlewareOption = {
  name: "deserializerMiddleware",
  step: "deserialize",
  tags: ["DESERIALIZER"],
  override: true
};
const serializerMiddlewareOption = {
  name: "serializerMiddleware",
  step: "serialize",
  tags: ["SERIALIZER"],
  override: true
};
function getSerdePlugin(config2, serializer, deserializer) {
  return {
    applyToStack: (commandStack) => {
      commandStack.add(deserializerMiddleware(config2, deserializer), deserializerMiddlewareOption);
      commandStack.add(serializerMiddleware(config2, serializer), serializerMiddlewareOption);
    }
  };
}
const endpointMiddlewareOptions = {
  step: "serialize",
  tags: ["ENDPOINT_PARAMETERS", "ENDPOINT_V2", "ENDPOINT"],
  name: "endpointV2Middleware",
  override: true,
  relation: "before",
  toMiddleware: serializerMiddlewareOption.name
};
const getEndpointPlugin = (config2, instructions) => ({
  applyToStack: (clientStack) => {
    clientStack.addRelativeTo(endpointMiddleware({
      config: config2,
      instructions
    }), endpointMiddlewareOptions);
  }
});
const resolveEndpointConfig = (input) => {
  const tls = input.tls ?? true;
  const { endpoint } = input;
  const customEndpointProvider = endpoint != null ? async () => toEndpointV1(await normalizeProvider(endpoint)()) : void 0;
  const isCustomEndpoint = !!endpoint;
  return {
    ...input,
    endpoint: customEndpointProvider,
    tls,
    isCustomEndpoint,
    useDualstackEndpoint: normalizeProvider(input.useDualstackEndpoint ?? false),
    useFipsEndpoint: normalizeProvider(input.useFipsEndpoint ?? false)
  };
};
function addExpectContinueMiddleware(options2) {
  return (next5) => async (args) => {
    const { request } = args;
    if (HttpRequest$1.isInstance(request) && request.body && options2.runtime === "node") {
      request.headers = {
        ...request.headers,
        Expect: "100-continue"
      };
    }
    return next5({
      ...args,
      request
    });
  };
}
const addExpectContinueMiddlewareOptions = {
  step: "build",
  tags: ["SET_EXPECT_HEADER", "EXPECT_HEADER"],
  name: "addExpectContinueMiddleware",
  override: true
};
const getAddExpectContinuePlugin = (options2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(addExpectContinueMiddleware(options2), addExpectContinueMiddlewareOptions);
  }
});
function resolveHostHeaderConfig(input) {
  return input;
}
const hostHeaderMiddleware = (options2) => (next5) => async (args) => {
  if (!HttpRequest$1.isInstance(args.request))
    return next5(args);
  const { request } = args;
  const { handlerProtocol = "" } = options2.requestHandler.metadata || {};
  if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
    delete request.headers["host"];
    request.headers[":authority"] = "";
  } else if (!request.headers["host"]) {
    let host = request.hostname;
    if (request.port != null)
      host += `:${request.port}`;
    request.headers["host"] = host;
  }
  return next5(args);
};
const hostHeaderMiddlewareOptions = {
  name: "hostHeaderMiddleware",
  step: "build",
  priority: "low",
  tags: ["HOST"],
  override: true
};
const getHostHeaderPlugin = (options2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(hostHeaderMiddleware(options2), hostHeaderMiddlewareOptions);
  }
});
const loggerMiddleware = () => (next5, context2) => async (args) => {
  var _a3, _b3;
  try {
    const response = await next5(args);
    const { clientName, commandName, logger: logger2, dynamoDbDocumentClientOptions = {} } = context2;
    const { overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
    const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context2.inputFilterSensitiveLog;
    const outputFilterSensitiveLog = overrideOutputFilterSensitiveLog ?? context2.outputFilterSensitiveLog;
    const { $metadata, ...outputWithoutMetadata } = response.output;
    (_a3 = logger2 == null ? void 0 : logger2.info) == null ? void 0 : _a3.call(logger2, {
      clientName,
      commandName,
      input: inputFilterSensitiveLog(args.input),
      output: outputFilterSensitiveLog(outputWithoutMetadata),
      metadata: $metadata
    });
    return response;
  } catch (error2) {
    const { clientName, commandName, logger: logger2, dynamoDbDocumentClientOptions = {} } = context2;
    const { overrideInputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
    const inputFilterSensitiveLog = overrideInputFilterSensitiveLog ?? context2.inputFilterSensitiveLog;
    (_b3 = logger2 == null ? void 0 : logger2.error) == null ? void 0 : _b3.call(logger2, {
      clientName,
      commandName,
      input: inputFilterSensitiveLog(args.input),
      error: error2,
      metadata: error2.$metadata
    });
    throw error2;
  }
};
const loggerMiddlewareOptions = {
  name: "loggerMiddleware",
  tags: ["LOGGER"],
  step: "initialize",
  override: true
};
const getLoggerPlugin = (options2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
  }
});
const TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const recursionDetectionMiddleware = (options2) => (next5) => async (args) => {
  const { request } = args;
  if (!HttpRequest$1.isInstance(request) || options2.runtime !== "node" || request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME)) {
    return next5(args);
  }
  const functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
  const traceId = process.env[ENV_TRACE_ID];
  const nonEmptyString = (str) => typeof str === "string" && str.length > 0;
  if (nonEmptyString(functionName) && nonEmptyString(traceId)) {
    request.headers[TRACE_ID_HEADER_NAME] = traceId;
  }
  return next5({
    ...args,
    request
  });
};
const addRecursionDetectionMiddlewareOptions = {
  step: "build",
  tags: ["RECURSION_DETECTION"],
  name: "recursionDetectionMiddleware",
  override: true,
  priority: "low"
};
const getRecursionDetectionPlugin = (options2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(recursionDetectionMiddleware(options2), addRecursionDetectionMiddlewareOptions);
  }
});
var RETRY_MODES;
(function(RETRY_MODES2) {
  RETRY_MODES2["STANDARD"] = "standard";
  RETRY_MODES2["ADAPTIVE"] = "adaptive";
})(RETRY_MODES || (RETRY_MODES = {}));
const DEFAULT_MAX_ATTEMPTS = 3;
const DEFAULT_RETRY_MODE = RETRY_MODES.STANDARD;
const THROTTLING_ERROR_CODES = [
  "BandwidthLimitExceeded",
  "EC2ThrottledException",
  "LimitExceededException",
  "PriorRequestNotComplete",
  "ProvisionedThroughputExceededException",
  "RequestLimitExceeded",
  "RequestThrottled",
  "RequestThrottledException",
  "SlowDown",
  "ThrottledException",
  "Throttling",
  "ThrottlingException",
  "TooManyRequestsException",
  "TransactionInProgressException"
];
const TRANSIENT_ERROR_CODES = ["AbortError", "TimeoutError", "RequestTimeout", "RequestTimeoutException"];
const TRANSIENT_ERROR_STATUS_CODES = [500, 502, 503, 504];
const NODEJS_TIMEOUT_ERROR_CODES = ["ECONNRESET", "ECONNREFUSED", "EPIPE", "ETIMEDOUT"];
const isThrottlingError = (error2) => {
  var _a3, _b3;
  return ((_a3 = error2.$metadata) == null ? void 0 : _a3.httpStatusCode) === 429 || THROTTLING_ERROR_CODES.includes(error2.name) || ((_b3 = error2.$retryable) == null ? void 0 : _b3.throttling) == true;
};
const isTransientError = (error2) => {
  var _a3;
  return TRANSIENT_ERROR_CODES.includes(error2.name) || NODEJS_TIMEOUT_ERROR_CODES.includes((error2 == null ? void 0 : error2.code) || "") || TRANSIENT_ERROR_STATUS_CODES.includes(((_a3 = error2.$metadata) == null ? void 0 : _a3.httpStatusCode) || 0);
};
const isServerError = (error2) => {
  var _a3;
  if (((_a3 = error2.$metadata) == null ? void 0 : _a3.httpStatusCode) !== void 0) {
    const statusCode = error2.$metadata.httpStatusCode;
    if (500 <= statusCode && statusCode <= 599 && !isTransientError(error2)) {
      return true;
    }
    return false;
  }
  return false;
};
class DefaultRateLimiter {
  constructor(options2) {
    this.currentCapacity = 0;
    this.enabled = false;
    this.lastMaxRate = 0;
    this.measuredTxRate = 0;
    this.requestCount = 0;
    this.lastTimestamp = 0;
    this.timeWindow = 0;
    this.beta = (options2 == null ? void 0 : options2.beta) ?? 0.7;
    this.minCapacity = (options2 == null ? void 0 : options2.minCapacity) ?? 1;
    this.minFillRate = (options2 == null ? void 0 : options2.minFillRate) ?? 0.5;
    this.scaleConstant = (options2 == null ? void 0 : options2.scaleConstant) ?? 0.4;
    this.smooth = (options2 == null ? void 0 : options2.smooth) ?? 0.8;
    const currentTimeInSeconds = this.getCurrentTimeInSeconds();
    this.lastThrottleTime = currentTimeInSeconds;
    this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
    this.fillRate = this.minFillRate;
    this.maxCapacity = this.minCapacity;
  }
  getCurrentTimeInSeconds() {
    return Date.now() / 1e3;
  }
  async getSendToken() {
    return this.acquireTokenBucket(1);
  }
  async acquireTokenBucket(amount) {
    if (!this.enabled) {
      return;
    }
    this.refillTokenBucket();
    if (amount > this.currentCapacity) {
      const delay = (amount - this.currentCapacity) / this.fillRate * 1e3;
      await new Promise((resolve2) => setTimeout(resolve2, delay));
    }
    this.currentCapacity = this.currentCapacity - amount;
  }
  refillTokenBucket() {
    const timestamp2 = this.getCurrentTimeInSeconds();
    if (!this.lastTimestamp) {
      this.lastTimestamp = timestamp2;
      return;
    }
    const fillAmount = (timestamp2 - this.lastTimestamp) * this.fillRate;
    this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
    this.lastTimestamp = timestamp2;
  }
  updateClientSendingRate(response) {
    let calculatedRate;
    this.updateMeasuredRate();
    if (isThrottlingError(response)) {
      const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
      this.lastMaxRate = rateToUse;
      this.calculateTimeWindow();
      this.lastThrottleTime = this.getCurrentTimeInSeconds();
      calculatedRate = this.cubicThrottle(rateToUse);
      this.enableTokenBucket();
    } else {
      this.calculateTimeWindow();
      calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
    }
    const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
    this.updateTokenBucketRate(newRate);
  }
  calculateTimeWindow() {
    this.timeWindow = this.getPrecise(Math.pow(this.lastMaxRate * (1 - this.beta) / this.scaleConstant, 1 / 3));
  }
  cubicThrottle(rateToUse) {
    return this.getPrecise(rateToUse * this.beta);
  }
  cubicSuccess(timestamp2) {
    return this.getPrecise(this.scaleConstant * Math.pow(timestamp2 - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
  }
  enableTokenBucket() {
    this.enabled = true;
  }
  updateTokenBucketRate(newRate) {
    this.refillTokenBucket();
    this.fillRate = Math.max(newRate, this.minFillRate);
    this.maxCapacity = Math.max(newRate, this.minCapacity);
    this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
  }
  updateMeasuredRate() {
    const t2 = this.getCurrentTimeInSeconds();
    const timeBucket = Math.floor(t2 * 2) / 2;
    this.requestCount++;
    if (timeBucket > this.lastTxRateBucket) {
      const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
      this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
      this.requestCount = 0;
      this.lastTxRateBucket = timeBucket;
    }
  }
  getPrecise(num) {
    return parseFloat(num.toFixed(8));
  }
}
const DEFAULT_RETRY_DELAY_BASE = 100;
const MAXIMUM_RETRY_DELAY = 20 * 1e3;
const THROTTLING_RETRY_DELAY_BASE = 500;
const INITIAL_RETRY_TOKENS = 500;
const RETRY_COST = 5;
const TIMEOUT_RETRY_COST = 10;
const NO_RETRY_INCREMENT = 1;
const INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
const REQUEST_HEADER = "amz-sdk-request";
const getDefaultRetryBackoffStrategy = () => {
  let delayBase = DEFAULT_RETRY_DELAY_BASE;
  const computeNextBackoffDelay = (attempts) => {
    return Math.floor(Math.min(MAXIMUM_RETRY_DELAY, Math.random() * 2 ** attempts * delayBase));
  };
  const setDelayBase = (delay) => {
    delayBase = delay;
  };
  return {
    computeNextBackoffDelay,
    setDelayBase
  };
};
const getDefaultRetryToken = (initialRetryTokens, initialRetryDelay, initialRetryCount, options2) => {
  const MAX_CAPACITY = initialRetryTokens;
  const retryCost = (options2 == null ? void 0 : options2.retryCost) ?? RETRY_COST;
  const timeoutRetryCost = (options2 == null ? void 0 : options2.timeoutRetryCost) ?? TIMEOUT_RETRY_COST;
  const retryBackoffStrategy = (options2 == null ? void 0 : options2.retryBackoffStrategy) ?? getDefaultRetryBackoffStrategy();
  let availableCapacity = initialRetryTokens;
  let retryDelay = Math.min(MAXIMUM_RETRY_DELAY, initialRetryDelay);
  let lastRetryCost = void 0;
  let retryCount = initialRetryCount ?? 0;
  const getCapacityAmount = (errorType) => errorType === "TRANSIENT" ? timeoutRetryCost : retryCost;
  const getRetryCount = () => retryCount;
  const getRetryDelay = () => retryDelay;
  const getLastRetryCost = () => lastRetryCost;
  const hasRetryTokens = (errorType) => getCapacityAmount(errorType) <= availableCapacity;
  const getRetryTokenCount = (errorInfo) => {
    const errorType = errorInfo.errorType;
    if (!hasRetryTokens(errorType)) {
      throw new Error("No retry token available");
    }
    const capacityAmount = getCapacityAmount(errorType);
    const delayBase = errorType === "THROTTLING" ? THROTTLING_RETRY_DELAY_BASE : DEFAULT_RETRY_DELAY_BASE;
    retryBackoffStrategy.setDelayBase(delayBase);
    const delayFromErrorType = retryBackoffStrategy.computeNextBackoffDelay(retryCount);
    if (errorInfo.retryAfterHint) {
      const delayFromRetryAfterHint = errorInfo.retryAfterHint.getTime() - Date.now();
      retryDelay = Math.max(delayFromRetryAfterHint || 0, delayFromErrorType);
    } else {
      retryDelay = delayFromErrorType;
    }
    retryCount++;
    lastRetryCost = capacityAmount;
    availableCapacity -= capacityAmount;
    return capacityAmount;
  };
  const releaseRetryTokens = (releaseAmount) => {
    availableCapacity += releaseAmount ?? NO_RETRY_INCREMENT;
    availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
  };
  return {
    getRetryCount,
    getRetryDelay,
    getLastRetryCost,
    hasRetryTokens,
    getRetryTokenCount,
    releaseRetryTokens
  };
};
class StandardRetryStrategy {
  constructor(maxAttempts) {
    this.maxAttempts = maxAttempts;
    this.mode = RETRY_MODES.STANDARD;
    this.retryToken = getDefaultRetryToken(INITIAL_RETRY_TOKENS, DEFAULT_RETRY_DELAY_BASE);
    this.maxAttemptsProvider = typeof maxAttempts === "function" ? maxAttempts : async () => maxAttempts;
  }
  async acquireInitialRetryToken(retryTokenScope) {
    return this.retryToken;
  }
  async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
    const maxAttempts = await this.getMaxAttempts();
    if (this.shouldRetry(tokenToRenew, errorInfo, maxAttempts)) {
      tokenToRenew.getRetryTokenCount(errorInfo);
      return tokenToRenew;
    }
    throw new Error("No retry token available");
  }
  recordSuccess(token) {
    this.retryToken.releaseRetryTokens(token.getLastRetryCost());
  }
  async getMaxAttempts() {
    try {
      return await this.maxAttemptsProvider();
    } catch (error2) {
      console.warn(`Max attempts provider could not resolve. Using default of ${DEFAULT_MAX_ATTEMPTS}`);
      return DEFAULT_MAX_ATTEMPTS;
    }
  }
  shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
    const attempts = tokenToRenew.getRetryCount();
    return attempts < maxAttempts && tokenToRenew.hasRetryTokens(errorInfo.errorType) && this.isRetryableError(errorInfo.errorType);
  }
  isRetryableError(errorType) {
    return errorType === "THROTTLING" || errorType === "TRANSIENT";
  }
}
class AdaptiveRetryStrategy {
  constructor(maxAttemptsProvider, options2) {
    this.maxAttemptsProvider = maxAttemptsProvider;
    this.mode = RETRY_MODES.ADAPTIVE;
    const { rateLimiter } = options2 ?? {};
    this.rateLimiter = rateLimiter ?? new DefaultRateLimiter();
    this.standardRetryStrategy = new StandardRetryStrategy(maxAttemptsProvider);
  }
  async acquireInitialRetryToken(retryTokenScope) {
    await this.rateLimiter.getSendToken();
    return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
  }
  async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
    this.rateLimiter.updateClientSendingRate(errorInfo);
    return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
  }
  recordSuccess(token) {
    this.rateLimiter.updateClientSendingRate({});
    this.standardRetryStrategy.recordSuccess(token);
  }
}
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const REGEX$1 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate$3(uuid) {
  return typeof uuid === "string" && REGEX$1.test(uuid);
}
var byteToHex = [];
for (var i$6 = 0; i$6 < 256; ++i$6) {
  byteToHex.push((i$6 + 256).toString(16).substr(1));
}
function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
  if (!validate$3(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
function v4$1(options2, buf, offset) {
  options2 = options2 || {};
  var rnds = options2.random || (options2.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (var i2 = 0; i2 < 16; ++i2) {
      buf[offset + i2] = rnds[i2];
    }
    return buf;
  }
  return stringify(rnds);
}
const asSdkError = (error2) => {
  if (error2 instanceof Error)
    return error2;
  if (error2 instanceof Object)
    return Object.assign(new Error(), error2);
  if (typeof error2 === "string")
    return new Error(error2);
  return new Error(`AWS SDK error wrapper for ${error2}`);
};
const resolveRetryConfig = (input) => {
  const { retryStrategy } = input;
  const maxAttempts = normalizeProvider(input.maxAttempts ?? DEFAULT_MAX_ATTEMPTS);
  return {
    ...input,
    maxAttempts,
    retryStrategy: async () => {
      if (retryStrategy) {
        return retryStrategy;
      }
      const retryMode = await normalizeProvider(input.retryMode)();
      if (retryMode === RETRY_MODES.ADAPTIVE) {
        return new AdaptiveRetryStrategy(maxAttempts);
      }
      return new StandardRetryStrategy(maxAttempts);
    }
  };
};
const retryMiddleware = (options2) => (next5, context2) => async (args) => {
  let retryStrategy = await options2.retryStrategy();
  const maxAttempts = await options2.maxAttempts();
  if (isRetryStrategyV2(retryStrategy)) {
    retryStrategy = retryStrategy;
    let retryToken = await retryStrategy.acquireInitialRetryToken(context2["partition_id"]);
    let lastError = new Error();
    let attempts = 0;
    let totalRetryDelay = 0;
    const { request } = args;
    if (HttpRequest$1.isInstance(request)) {
      request.headers[INVOCATION_ID_HEADER] = v4$1();
    }
    while (true) {
      try {
        if (HttpRequest$1.isInstance(request)) {
          request.headers[REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
        }
        const { response, output: output2 } = await next5(args);
        retryStrategy.recordSuccess(retryToken);
        output2.$metadata.attempts = attempts + 1;
        output2.$metadata.totalRetryDelay = totalRetryDelay;
        return { response, output: output2 };
      } catch (e3) {
        const retryErrorInfo = getRetryErrorInfo(e3);
        lastError = asSdkError(e3);
        try {
          retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
        } catch (refreshError) {
          if (!lastError.$metadata) {
            lastError.$metadata = {};
          }
          lastError.$metadata.attempts = attempts + 1;
          lastError.$metadata.totalRetryDelay = totalRetryDelay;
          throw lastError;
        }
        attempts = retryToken.getRetryCount();
        const delay = retryToken.getRetryDelay();
        totalRetryDelay += delay;
        await new Promise((resolve2) => setTimeout(resolve2, delay));
      }
    }
  } else {
    retryStrategy = retryStrategy;
    if (retryStrategy == null ? void 0 : retryStrategy.mode)
      context2.userAgent = [...context2.userAgent || [], ["cfg/retry-mode", retryStrategy.mode]];
    return retryStrategy.retry(next5, args);
  }
};
const isRetryStrategyV2 = (retryStrategy) => typeof retryStrategy.acquireInitialRetryToken !== "undefined" && typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" && typeof retryStrategy.recordSuccess !== "undefined";
const getRetryErrorInfo = (error2) => {
  const errorInfo = {
    errorType: getRetryErrorType(error2)
  };
  const retryAfterHint = getRetryAfterHint(error2.$response);
  if (retryAfterHint) {
    errorInfo.retryAfterHint = retryAfterHint;
  }
  return errorInfo;
};
const getRetryErrorType = (error2) => {
  if (isThrottlingError(error2))
    return "THROTTLING";
  if (isTransientError(error2))
    return "TRANSIENT";
  if (isServerError(error2))
    return "SERVER_ERROR";
  return "CLIENT_ERROR";
};
const retryMiddlewareOptions = {
  name: "retryMiddleware",
  tags: ["RETRY"],
  step: "finalizeRequest",
  priority: "high",
  override: true
};
const getRetryPlugin = (options2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(retryMiddleware(options2), retryMiddlewareOptions);
  }
});
const getRetryAfterHint = (response) => {
  if (!HttpResponse.isInstance(response))
    return;
  const retryAfterHeaderName = Object.keys(response.headers).find((key) => key.toLowerCase() === "retry-after");
  if (!retryAfterHeaderName)
    return;
  const retryAfter = response.headers[retryAfterHeaderName];
  const retryAfterSeconds = Number(retryAfter);
  if (!Number.isNaN(retryAfterSeconds))
    return new Date(retryAfterSeconds * 1e3);
  const retryAfterDate = new Date(retryAfter);
  return retryAfterDate;
};
const CONTENT_LENGTH_HEADER = "content-length";
function checkContentLengthHeader() {
  return (next5, context2) => async (args) => {
    var _a3;
    const { request } = args;
    if (HttpRequest$1.isInstance(request)) {
      if (!request.headers[CONTENT_LENGTH_HEADER]) {
        const message2 = `Are you using a Stream of unknown length as the Body of a PutObject request? Consider using Upload instead from @aws-sdk/lib-storage.`;
        if (typeof ((_a3 = context2 == null ? void 0 : context2.logger) == null ? void 0 : _a3.warn) === "function") {
          context2.logger.warn(message2);
        } else {
          console.warn(message2);
        }
      }
    }
    return next5({ ...args });
  };
}
const checkContentLengthHeaderMiddlewareOptions = {
  step: "finalizeRequest",
  tags: ["CHECK_CONTENT_LENGTH_HEADER"],
  name: "getCheckContentLengthHeaderPlugin",
  override: true
};
const getCheckContentLengthHeaderPlugin = (unused) => ({
  applyToStack: (clientStack) => {
    clientStack.add(checkContentLengthHeader(), checkContentLengthHeaderMiddlewareOptions);
  }
});
const resolveS3Config = (input) => ({
  ...input,
  forcePathStyle: input.forcePathStyle ?? false,
  useAccelerateEndpoint: input.useAccelerateEndpoint ?? false,
  disableMultiregionAccessPoints: input.disableMultiregionAccessPoints ?? false
});
const validate$2 = (str) => typeof str === "string" && str.indexOf("arn:") === 0 && str.split(":").length >= 6;
function validateBucketNameMiddleware() {
  return (next5) => async (args) => {
    const { input: { Bucket } } = args;
    if (typeof Bucket === "string" && !validate$2(Bucket) && Bucket.indexOf("/") >= 0) {
      const err = new Error(`Bucket name shouldn't contain '/', received '${Bucket}'`);
      err.name = "InvalidBucketName";
      throw err;
    }
    return next5({ ...args });
  };
}
const validateBucketNameMiddlewareOptions = {
  step: "initialize",
  tags: ["VALIDATE_BUCKET_NAME"],
  name: "validateBucketNameMiddleware",
  override: true
};
const getValidateBucketNamePlugin = (unused) => ({
  applyToStack: (clientStack) => {
    clientStack.add(validateBucketNameMiddleware(), validateBucketNameMiddlewareOptions);
  }
});
const memoize$5 = (provider, isExpired2, requiresRefresh) => {
  let resolved;
  let pending;
  let hasResult;
  let isConstant = false;
  const coalesceProvider = async () => {
    if (!pending) {
      pending = provider();
    }
    try {
      resolved = await pending;
      hasResult = true;
      isConstant = false;
    } finally {
      pending = void 0;
    }
    return resolved;
  };
  if (isExpired2 === void 0) {
    return async (options2) => {
      if (!hasResult || (options2 == null ? void 0 : options2.forceRefresh)) {
        resolved = await coalesceProvider();
      }
      return resolved;
    };
  }
  return async (options2) => {
    if (!hasResult || (options2 == null ? void 0 : options2.forceRefresh)) {
      resolved = await coalesceProvider();
    }
    if (isConstant) {
      return resolved;
    }
    if (requiresRefresh && !requiresRefresh(resolved)) {
      isConstant = true;
      return resolved;
    }
    if (isExpired2(resolved)) {
      await coalesceProvider();
      return resolved;
    }
    return resolved;
  };
};
const SHORT_TO_HEX = {};
const HEX_TO_SHORT = {};
for (let i2 = 0; i2 < 256; i2++) {
  let encodedByte = i2.toString(16).toLowerCase();
  if (encodedByte.length === 1) {
    encodedByte = `0${encodedByte}`;
  }
  SHORT_TO_HEX[i2] = encodedByte;
  HEX_TO_SHORT[encodedByte] = i2;
}
function fromHex(encoded) {
  if (encoded.length % 2 !== 0) {
    throw new Error("Hex encoded strings must have an even number length");
  }
  const out = new Uint8Array(encoded.length / 2);
  for (let i2 = 0; i2 < encoded.length; i2 += 2) {
    const encodedByte = encoded.slice(i2, i2 + 2).toLowerCase();
    if (encodedByte in HEX_TO_SHORT) {
      out[i2 / 2] = HEX_TO_SHORT[encodedByte];
    } else {
      throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
    }
  }
  return out;
}
function toHex(bytes) {
  let out = "";
  for (let i2 = 0; i2 < bytes.byteLength; i2++) {
    out += SHORT_TO_HEX[bytes[i2]];
  }
  return out;
}
const fromUtf8$3 = (input) => new TextEncoder().encode(input);
const toUint8Array = (data2) => {
  if (typeof data2 === "string") {
    return fromUtf8$3(data2);
  }
  if (ArrayBuffer.isView(data2)) {
    return new Uint8Array(data2.buffer, data2.byteOffset, data2.byteLength / Uint8Array.BYTES_PER_ELEMENT);
  }
  return new Uint8Array(data2);
};
const toUtf8$3 = (input) => new TextDecoder("utf-8").decode(input);
const ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
const CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
const AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
const SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
const EXPIRES_QUERY_PARAM = "X-Amz-Expires";
const SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
const TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
const AUTH_HEADER = "authorization";
const AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
const DATE_HEADER = "date";
const GENERATED_HEADERS = [AUTH_HEADER, AMZ_DATE_HEADER, DATE_HEADER];
const SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
const SHA256_HEADER = "x-amz-content-sha256";
const TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
const ALWAYS_UNSIGNABLE_HEADERS = {
  authorization: true,
  "cache-control": true,
  connection: true,
  expect: true,
  from: true,
  "keep-alive": true,
  "max-forwards": true,
  pragma: true,
  referer: true,
  te: true,
  trailer: true,
  "transfer-encoding": true,
  upgrade: true,
  "user-agent": true,
  "x-amzn-trace-id": true
};
const PROXY_HEADER_PATTERN = /^proxy-/;
const SEC_HEADER_PATTERN = /^sec-/;
const ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
const EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
const UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
const MAX_CACHE_SIZE = 50;
const KEY_TYPE_IDENTIFIER = "aws4_request";
const MAX_PRESIGNED_TTL = 60 * 60 * 24 * 7;
const signingKeyCache = {};
const cacheQueue = [];
const createScope = (shortDate, region, service) => `${shortDate}/${region}/${service}/${KEY_TYPE_IDENTIFIER}`;
const getSigningKey = async (sha256Constructor, credentials, shortDate, region, service) => {
  const credsHash = await hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
  const cacheKey = `${shortDate}:${region}:${service}:${toHex(credsHash)}:${credentials.sessionToken}`;
  if (cacheKey in signingKeyCache) {
    return signingKeyCache[cacheKey];
  }
  cacheQueue.push(cacheKey);
  while (cacheQueue.length > MAX_CACHE_SIZE) {
    delete signingKeyCache[cacheQueue.shift()];
  }
  let key = `AWS4${credentials.secretAccessKey}`;
  for (const signable of [shortDate, region, service, KEY_TYPE_IDENTIFIER]) {
    key = await hmac(sha256Constructor, key, signable);
  }
  return signingKeyCache[cacheKey] = key;
};
const hmac = (ctor, secret, data2) => {
  const hash = new ctor(secret);
  hash.update(toUint8Array(data2));
  return hash.digest();
};
const getCanonicalHeaders = ({ headers }, unsignableHeaders, signableHeaders) => {
  const canonical = {};
  for (const headerName of Object.keys(headers).sort()) {
    if (headers[headerName] == void 0) {
      continue;
    }
    const canonicalHeaderName = headerName.toLowerCase();
    if (canonicalHeaderName in ALWAYS_UNSIGNABLE_HEADERS || (unsignableHeaders == null ? void 0 : unsignableHeaders.has(canonicalHeaderName)) || PROXY_HEADER_PATTERN.test(canonicalHeaderName) || SEC_HEADER_PATTERN.test(canonicalHeaderName)) {
      if (!signableHeaders || signableHeaders && !signableHeaders.has(canonicalHeaderName)) {
        continue;
      }
    }
    canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
  }
  return canonical;
};
const escapeUri = (uri) => encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
const hexEncode = (c2) => `%${c2.charCodeAt(0).toString(16).toUpperCase()}`;
const getCanonicalQuery = ({ query: query6 = {} }) => {
  const keys4 = [];
  const serialized = {};
  for (const key of Object.keys(query6).sort()) {
    if (key.toLowerCase() === SIGNATURE_HEADER) {
      continue;
    }
    keys4.push(key);
    const value = query6[key];
    if (typeof value === "string") {
      serialized[key] = `${escapeUri(key)}=${escapeUri(value)}`;
    } else if (Array.isArray(value)) {
      serialized[key] = value.slice(0).sort().reduce((encoded, value2) => encoded.concat([`${escapeUri(key)}=${escapeUri(value2)}`]), []).join("&");
    }
  }
  return keys4.map((key) => serialized[key]).filter((serialized2) => serialized2).join("&");
};
const isArrayBuffer = (arg) => typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer || Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
const getPayloadHash = async ({ headers, body }, hashConstructor) => {
  for (const headerName of Object.keys(headers)) {
    if (headerName.toLowerCase() === SHA256_HEADER) {
      return headers[headerName];
    }
  }
  if (body == void 0) {
    return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
  } else if (typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer(body)) {
    const hashCtor = new hashConstructor();
    hashCtor.update(toUint8Array(body));
    return toHex(await hashCtor.digest());
  }
  return UNSIGNED_PAYLOAD;
};
const hasHeader$1 = (soughtHeader, headers) => {
  soughtHeader = soughtHeader.toLowerCase();
  for (const headerName of Object.keys(headers)) {
    if (soughtHeader === headerName.toLowerCase()) {
      return true;
    }
  }
  return false;
};
const cloneRequest = ({ headers, query: query6, ...rest }) => ({
  ...rest,
  headers: { ...headers },
  query: query6 ? cloneQuery$1(query6) : void 0
});
const cloneQuery$1 = (query6) => Object.keys(query6).reduce((carry, paramName) => {
  const param = query6[paramName];
  return {
    ...carry,
    [paramName]: Array.isArray(param) ? [...param] : param
  };
}, {});
const moveHeadersToQuery = (request, options2 = {}) => {
  var _a3;
  const { headers, query: query6 = {} } = typeof request.clone === "function" ? request.clone() : cloneRequest(request);
  for (const name2 of Object.keys(headers)) {
    const lname = name2.toLowerCase();
    if (lname.slice(0, 6) === "x-amz-" && !((_a3 = options2.unhoistableHeaders) == null ? void 0 : _a3.has(lname))) {
      query6[name2] = headers[name2];
      delete headers[name2];
    }
  }
  return {
    ...request,
    headers,
    query: query6
  };
};
const prepareRequest = (request) => {
  request = typeof request.clone === "function" ? request.clone() : cloneRequest(request);
  for (const headerName of Object.keys(request.headers)) {
    if (GENERATED_HEADERS.indexOf(headerName.toLowerCase()) > -1) {
      delete request.headers[headerName];
    }
  }
  return request;
};
const iso8601 = (time2) => toDate(time2).toISOString().replace(/\.\d{3}Z$/, "Z");
const toDate = (time2) => {
  if (typeof time2 === "number") {
    return new Date(time2 * 1e3);
  }
  if (typeof time2 === "string") {
    if (Number(time2)) {
      return new Date(Number(time2) * 1e3);
    }
    return new Date(time2);
  }
  return time2;
};
class SignatureV4 {
  constructor({ applyChecksum, credentials, region, service, sha256, uriEscapePath = true }) {
    this.service = service;
    this.sha256 = sha256;
    this.uriEscapePath = uriEscapePath;
    this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
    this.regionProvider = normalizeProvider(region);
    this.credentialProvider = normalizeProvider(credentials);
  }
  async presign(originalRequest, options2 = {}) {
    const { signingDate = /* @__PURE__ */ new Date(), expiresIn = 3600, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService } = options2;
    const credentials = await this.credentialProvider();
    this.validateResolvedCredentials(credentials);
    const region = signingRegion ?? await this.regionProvider();
    const { longDate, shortDate } = formatDate(signingDate);
    if (expiresIn > MAX_PRESIGNED_TTL) {
      return Promise.reject("Signature version 4 presigned URLs must have an expiration date less than one week in the future");
    }
    const scope = createScope(shortDate, region, signingService ?? this.service);
    const request = moveHeadersToQuery(prepareRequest(originalRequest), { unhoistableHeaders });
    if (credentials.sessionToken) {
      request.query[TOKEN_QUERY_PARAM] = credentials.sessionToken;
    }
    request.query[ALGORITHM_QUERY_PARAM] = ALGORITHM_IDENTIFIER;
    request.query[CREDENTIAL_QUERY_PARAM] = `${credentials.accessKeyId}/${scope}`;
    request.query[AMZ_DATE_QUERY_PARAM] = longDate;
    request.query[EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
    const canonicalHeaders = getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
    request.query[SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
    request.query[SIGNATURE_QUERY_PARAM] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await getPayloadHash(originalRequest, this.sha256)));
    return request;
  }
  async sign(toSign, options2) {
    if (typeof toSign === "string") {
      return this.signString(toSign, options2);
    } else if (toSign.headers && toSign.payload) {
      return this.signEvent(toSign, options2);
    } else {
      return this.signRequest(toSign, options2);
    }
  }
  async signEvent({ headers, payload }, { signingDate = /* @__PURE__ */ new Date(), priorSignature, signingRegion, signingService }) {
    const region = signingRegion ?? await this.regionProvider();
    const { shortDate, longDate } = formatDate(signingDate);
    const scope = createScope(shortDate, region, signingService ?? this.service);
    const hashedPayload = await getPayloadHash({ headers: {}, body: payload }, this.sha256);
    const hash = new this.sha256();
    hash.update(headers);
    const hashedHeaders = toHex(await hash.digest());
    const stringToSign = [
      EVENT_ALGORITHM_IDENTIFIER,
      longDate,
      scope,
      priorSignature,
      hashedHeaders,
      hashedPayload
    ].join("\n");
    return this.signString(stringToSign, { signingDate, signingRegion: region, signingService });
  }
  async signString(stringToSign, { signingDate = /* @__PURE__ */ new Date(), signingRegion, signingService } = {}) {
    const credentials = await this.credentialProvider();
    this.validateResolvedCredentials(credentials);
    const region = signingRegion ?? await this.regionProvider();
    const { shortDate } = formatDate(signingDate);
    const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
    hash.update(toUint8Array(stringToSign));
    return toHex(await hash.digest());
  }
  async signRequest(requestToSign, { signingDate = /* @__PURE__ */ new Date(), signableHeaders, unsignableHeaders, signingRegion, signingService } = {}) {
    const credentials = await this.credentialProvider();
    this.validateResolvedCredentials(credentials);
    const region = signingRegion ?? await this.regionProvider();
    const request = prepareRequest(requestToSign);
    const { longDate, shortDate } = formatDate(signingDate);
    const scope = createScope(shortDate, region, signingService ?? this.service);
    request.headers[AMZ_DATE_HEADER] = longDate;
    if (credentials.sessionToken) {
      request.headers[TOKEN_HEADER] = credentials.sessionToken;
    }
    const payloadHash = await getPayloadHash(request, this.sha256);
    if (!hasHeader$1(SHA256_HEADER, request.headers) && this.applyChecksum) {
      request.headers[SHA256_HEADER] = payloadHash;
    }
    const canonicalHeaders = getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
    const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
    request.headers[AUTH_HEADER] = `${ALGORITHM_IDENTIFIER} Credential=${credentials.accessKeyId}/${scope}, SignedHeaders=${getCanonicalHeaderList(canonicalHeaders)}, Signature=${signature}`;
    return request;
  }
  createCanonicalRequest(request, canonicalHeaders, payloadHash) {
    const sortedHeaders = Object.keys(canonicalHeaders).sort();
    return `${request.method}
${this.getCanonicalPath(request)}
${getCanonicalQuery(request)}
${sortedHeaders.map((name2) => `${name2}:${canonicalHeaders[name2]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
  }
  async createStringToSign(longDate, credentialScope, canonicalRequest) {
    const hash = new this.sha256();
    hash.update(toUint8Array(canonicalRequest));
    const hashedRequest = await hash.digest();
    return `${ALGORITHM_IDENTIFIER}
${longDate}
${credentialScope}
${toHex(hashedRequest)}`;
  }
  getCanonicalPath({ path: path2 }) {
    if (this.uriEscapePath) {
      const normalizedPathSegments = [];
      for (const pathSegment of path2.split("/")) {
        if ((pathSegment == null ? void 0 : pathSegment.length) === 0)
          continue;
        if (pathSegment === ".")
          continue;
        if (pathSegment === "..") {
          normalizedPathSegments.pop();
        } else {
          normalizedPathSegments.push(pathSegment);
        }
      }
      const normalizedPath = `${(path2 == null ? void 0 : path2.startsWith("/")) ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && (path2 == null ? void 0 : path2.endsWith("/")) ? "/" : ""}`;
      const doubleEncoded = encodeURIComponent(normalizedPath);
      return doubleEncoded.replace(/%2F/g, "/");
    }
    return path2;
  }
  async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
    const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
    const hash = new this.sha256(await keyPromise);
    hash.update(toUint8Array(stringToSign));
    return toHex(await hash.digest());
  }
  getSigningKey(credentials, region, shortDate, service) {
    return getSigningKey(this.sha256, credentials, shortDate, region, service || this.service);
  }
  validateResolvedCredentials(credentials) {
    if (typeof credentials !== "object" || typeof credentials.accessKeyId !== "string" || typeof credentials.secretAccessKey !== "string") {
      throw new Error("Resolved credential object is not valid");
    }
  }
}
const formatDate = (now2) => {
  const longDate = iso8601(now2).replace(/[\-:]/g, "");
  return {
    longDate,
    shortDate: longDate.slice(0, 8)
  };
};
const getCanonicalHeaderList = (headers) => Object.keys(headers).sort().join(";");
const CREDENTIAL_EXPIRE_WINDOW = 3e5;
const resolveAwsAuthConfig = (input) => {
  const normalizedCreds = input.credentials ? normalizeCredentialProvider(input.credentials) : input.credentialDefaultProvider(input);
  const { signingEscapePath = true, systemClockOffset = input.systemClockOffset || 0, sha256 } = input;
  let signer;
  if (input.signer) {
    signer = normalizeProvider(input.signer);
  } else if (input.regionInfoProvider) {
    signer = () => normalizeProvider(input.region)().then(async (region) => [
      await input.regionInfoProvider(region, {
        useFipsEndpoint: await input.useFipsEndpoint(),
        useDualstackEndpoint: await input.useDualstackEndpoint()
      }) || {},
      region
    ]).then(([regionInfo, region]) => {
      const { signingRegion, signingService } = regionInfo;
      input.signingRegion = input.signingRegion || signingRegion || region;
      input.signingName = input.signingName || signingService || input.serviceId;
      const params2 = {
        ...input,
        credentials: normalizedCreds,
        region: input.signingRegion,
        service: input.signingName,
        sha256,
        uriEscapePath: signingEscapePath
      };
      const SignerCtor = input.signerConstructor || SignatureV4;
      return new SignerCtor(params2);
    });
  } else {
    signer = async (authScheme) => {
      authScheme = Object.assign({}, {
        name: "sigv4",
        signingName: input.signingName || input.defaultSigningName,
        signingRegion: await normalizeProvider(input.region)(),
        properties: {}
      }, authScheme);
      const signingRegion = authScheme.signingRegion;
      const signingService = authScheme.signingName;
      input.signingRegion = input.signingRegion || signingRegion;
      input.signingName = input.signingName || signingService || input.serviceId;
      const params2 = {
        ...input,
        credentials: normalizedCreds,
        region: input.signingRegion,
        service: input.signingName,
        sha256,
        uriEscapePath: signingEscapePath
      };
      const SignerCtor = input.signerConstructor || SignatureV4;
      return new SignerCtor(params2);
    };
  }
  return {
    ...input,
    systemClockOffset,
    signingEscapePath,
    credentials: normalizedCreds,
    signer
  };
};
const normalizeCredentialProvider = (credentials) => {
  if (typeof credentials === "function") {
    return memoize$5(credentials, (credentials2) => credentials2.expiration !== void 0 && credentials2.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW, (credentials2) => credentials2.expiration !== void 0);
  }
  return normalizeProvider(credentials);
};
const getSkewCorrectedDate = (systemClockOffset) => new Date(Date.now() + systemClockOffset);
const isClockSkewed = (clockTime, systemClockOffset) => Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - clockTime) >= 3e5;
const getUpdatedSystemClockOffset = (clockTime, currentSystemClockOffset) => {
  const clockTimeInMs = Date.parse(clockTime);
  if (isClockSkewed(clockTimeInMs, currentSystemClockOffset)) {
    return clockTimeInMs - Date.now();
  }
  return currentSystemClockOffset;
};
const awsAuthMiddleware = (options2) => (next5, context2) => async function(args) {
  var _a3, _b3, _c2, _d2;
  if (!HttpRequest$1.isInstance(args.request))
    return next5(args);
  const authScheme = (_c2 = (_b3 = (_a3 = context2.endpointV2) == null ? void 0 : _a3.properties) == null ? void 0 : _b3.authSchemes) == null ? void 0 : _c2[0];
  const multiRegionOverride = (authScheme == null ? void 0 : authScheme.name) === "sigv4a" ? (_d2 = authScheme == null ? void 0 : authScheme.signingRegionSet) == null ? void 0 : _d2.join(",") : void 0;
  const signer = await options2.signer(authScheme);
  const output2 = await next5({
    ...args,
    request: await signer.sign(args.request, {
      signingDate: getSkewCorrectedDate(options2.systemClockOffset),
      signingRegion: multiRegionOverride || context2["signing_region"],
      signingService: context2["signing_service"]
    })
  }).catch((error2) => {
    const serverTime = error2.ServerTime ?? getDateHeader(error2.$response);
    if (serverTime) {
      options2.systemClockOffset = getUpdatedSystemClockOffset(serverTime, options2.systemClockOffset);
    }
    throw error2;
  });
  const dateHeader = getDateHeader(output2.response);
  if (dateHeader) {
    options2.systemClockOffset = getUpdatedSystemClockOffset(dateHeader, options2.systemClockOffset);
  }
  return output2;
};
const getDateHeader = (response) => {
  var _a3, _b3;
  return HttpResponse.isInstance(response) ? ((_a3 = response.headers) == null ? void 0 : _a3.date) ?? ((_b3 = response.headers) == null ? void 0 : _b3.Date) : void 0;
};
const awsAuthMiddlewareOptions = {
  name: "awsAuthMiddleware",
  tags: ["SIGNATURE", "AWSAUTH"],
  relation: "after",
  toMiddleware: "retryMiddleware",
  override: true
};
const getAwsAuthPlugin = (options2) => ({
  applyToStack: (clientStack) => {
    clientStack.addRelativeTo(awsAuthMiddleware(options2), awsAuthMiddlewareOptions);
  }
});
function resolveUserAgentConfig(input) {
  return {
    ...input,
    customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent
  };
}
const partitions = [
  {
    id: "aws",
    outputs: {
      dnsSuffix: "amazonaws.com",
      dualStackDnsSuffix: "api.aws",
      name: "aws",
      supportsDualStack: true,
      supportsFIPS: true
    },
    regionRegex: "^(us|eu|ap|sa|ca|me|af)\\-\\w+\\-\\d+$",
    regions: {
      "af-south-1": {
        description: "Africa (Cape Town)"
      },
      "ap-east-1": {
        description: "Asia Pacific (Hong Kong)"
      },
      "ap-northeast-1": {
        description: "Asia Pacific (Tokyo)"
      },
      "ap-northeast-2": {
        description: "Asia Pacific (Seoul)"
      },
      "ap-northeast-3": {
        description: "Asia Pacific (Osaka)"
      },
      "ap-south-1": {
        description: "Asia Pacific (Mumbai)"
      },
      "ap-south-2": {
        description: "Asia Pacific (Hyderabad)"
      },
      "ap-southeast-1": {
        description: "Asia Pacific (Singapore)"
      },
      "ap-southeast-2": {
        description: "Asia Pacific (Sydney)"
      },
      "ap-southeast-3": {
        description: "Asia Pacific (Jakarta)"
      },
      "ap-southeast-4": {
        description: "Asia Pacific (Melbourne)"
      },
      "aws-global": {
        description: "AWS Standard global region"
      },
      "ca-central-1": {
        description: "Canada (Central)"
      },
      "eu-central-1": {
        description: "Europe (Frankfurt)"
      },
      "eu-central-2": {
        description: "Europe (Zurich)"
      },
      "eu-north-1": {
        description: "Europe (Stockholm)"
      },
      "eu-south-1": {
        description: "Europe (Milan)"
      },
      "eu-south-2": {
        description: "Europe (Spain)"
      },
      "eu-west-1": {
        description: "Europe (Ireland)"
      },
      "eu-west-2": {
        description: "Europe (London)"
      },
      "eu-west-3": {
        description: "Europe (Paris)"
      },
      "me-central-1": {
        description: "Middle East (UAE)"
      },
      "me-south-1": {
        description: "Middle East (Bahrain)"
      },
      "sa-east-1": {
        description: "South America (Sao Paulo)"
      },
      "us-east-1": {
        description: "US East (N. Virginia)"
      },
      "us-east-2": {
        description: "US East (Ohio)"
      },
      "us-west-1": {
        description: "US West (N. California)"
      },
      "us-west-2": {
        description: "US West (Oregon)"
      }
    }
  },
  {
    id: "aws-cn",
    outputs: {
      dnsSuffix: "amazonaws.com.cn",
      dualStackDnsSuffix: "api.amazonwebservices.com.cn",
      name: "aws-cn",
      supportsDualStack: true,
      supportsFIPS: true
    },
    regionRegex: "^cn\\-\\w+\\-\\d+$",
    regions: {
      "aws-cn-global": {
        description: "AWS China global region"
      },
      "cn-north-1": {
        description: "China (Beijing)"
      },
      "cn-northwest-1": {
        description: "China (Ningxia)"
      }
    }
  },
  {
    id: "aws-us-gov",
    outputs: {
      dnsSuffix: "amazonaws.com",
      dualStackDnsSuffix: "api.aws",
      name: "aws-us-gov",
      supportsDualStack: true,
      supportsFIPS: true
    },
    regionRegex: "^us\\-gov\\-\\w+\\-\\d+$",
    regions: {
      "aws-us-gov-global": {
        description: "AWS GovCloud (US) global region"
      },
      "us-gov-east-1": {
        description: "AWS GovCloud (US-East)"
      },
      "us-gov-west-1": {
        description: "AWS GovCloud (US-West)"
      }
    }
  },
  {
    id: "aws-iso",
    outputs: {
      dnsSuffix: "c2s.ic.gov",
      dualStackDnsSuffix: "c2s.ic.gov",
      name: "aws-iso",
      supportsDualStack: false,
      supportsFIPS: true
    },
    regionRegex: "^us\\-iso\\-\\w+\\-\\d+$",
    regions: {
      "aws-iso-global": {
        description: "AWS ISO (US) global region"
      },
      "us-iso-east-1": {
        description: "US ISO East"
      },
      "us-iso-west-1": {
        description: "US ISO WEST"
      }
    }
  },
  {
    id: "aws-iso-b",
    outputs: {
      dnsSuffix: "sc2s.sgov.gov",
      dualStackDnsSuffix: "sc2s.sgov.gov",
      name: "aws-iso-b",
      supportsDualStack: false,
      supportsFIPS: true
    },
    regionRegex: "^us\\-isob\\-\\w+\\-\\d+$",
    regions: {
      "aws-iso-b-global": {
        description: "AWS ISOB (US) global region"
      },
      "us-isob-east-1": {
        description: "US ISOB East (Ohio)"
      }
    }
  },
  {
    id: "aws-iso-e",
    outputs: {
      dnsSuffix: "cloud.adc-e.uk",
      dualStackDnsSuffix: "cloud.adc-e.uk",
      name: "aws-iso-e",
      supportsDualStack: false,
      supportsFIPS: true
    },
    regionRegex: "^eu\\-isoe\\-\\w+\\-\\d+$",
    regions: {}
  }
];
const version$1 = "1.1";
const partitionsInfo = {
  partitions,
  version: version$1
};
let selectedPartitionsInfo = partitionsInfo;
let selectedUserAgentPrefix = "";
const partition = (value) => {
  const { partitions: partitions2 } = selectedPartitionsInfo;
  for (const partition2 of partitions2) {
    const { regions, outputs } = partition2;
    for (const [region, regionData] of Object.entries(regions)) {
      if (region === value) {
        return {
          ...outputs,
          ...regionData
        };
      }
    }
  }
  for (const partition2 of partitions2) {
    const { regionRegex, outputs } = partition2;
    if (new RegExp(regionRegex).test(value)) {
      return {
        ...outputs
      };
    }
  }
  const DEFAULT_PARTITION = partitions2.find((partition2) => partition2.id === "aws");
  if (!DEFAULT_PARTITION) {
    throw new Error("Provided region was not found in the partition array or regex, and default partition with id 'aws' doesn't exist.");
  }
  return {
    ...DEFAULT_PARTITION.outputs
  };
};
const setPartitionInfo = (partitionsInfo2, userAgentPrefix = "") => {
  selectedPartitionsInfo = partitionsInfo2;
  selectedUserAgentPrefix = userAgentPrefix;
};
const useDefaultPartitionInfo = () => {
  setPartitionInfo(partitionsInfo, "");
};
const getUserAgentPrefix = () => selectedUserAgentPrefix;
const debugId = "endpoints";
function toDebugString(input) {
  if (typeof input !== "object" || input == null) {
    return input;
  }
  if ("ref" in input) {
    return `$${toDebugString(input.ref)}`;
  }
  if ("fn" in input) {
    return `${input.fn}(${(input.argv || []).map(toDebugString).join(", ")})`;
  }
  return JSON.stringify(input, null, 2);
}
class EndpointError extends Error {
  constructor(message2) {
    super(message2);
    this.name = "EndpointError";
  }
}
const IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const isIpAddress = (value) => IP_V4_REGEX.test(value) || value.startsWith("[") && value.endsWith("]");
const VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const isValidHostLabel = (value, allowSubDomains = false) => {
  if (!allowSubDomains) {
    return VALID_HOST_LABEL_REGEX.test(value);
  }
  const labels = value.split(".");
  for (const label of labels) {
    if (!isValidHostLabel(label)) {
      return false;
    }
  }
  return true;
};
const isVirtualHostableS3Bucket = (value, allowSubDomains = false) => {
  if (allowSubDomains) {
    for (const label of value.split(".")) {
      if (!isVirtualHostableS3Bucket(label)) {
        return false;
      }
    }
    return true;
  }
  if (!isValidHostLabel(value)) {
    return false;
  }
  if (value.length < 3 || value.length > 63) {
    return false;
  }
  if (value !== value.toLowerCase()) {
    return false;
  }
  if (isIpAddress(value)) {
    return false;
  }
  return true;
};
const parseArn = (value) => {
  const segments = value.split(":");
  if (segments.length < 6)
    return null;
  const [arn, partition2, service, region, accountId, ...resourceId] = segments;
  if (arn !== "arn" || partition2 === "" || service === "" || resourceId[0] === "")
    return null;
  return {
    partition: partition2,
    service,
    region,
    accountId,
    resourceId: resourceId[0].includes("/") ? resourceId[0].split("/") : resourceId
  };
};
const index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getUserAgentPrefix,
  isVirtualHostableS3Bucket,
  parseArn,
  partition,
  setPartitionInfo,
  useDefaultPartitionInfo
}, Symbol.toStringTag, { value: "Module" }));
const booleanEquals = (value1, value2) => value1 === value2;
const getAttrPathList = (path2) => {
  const parts = path2.split(".");
  const pathList = [];
  for (const part of parts) {
    const squareBracketIndex = part.indexOf("[");
    if (squareBracketIndex !== -1) {
      if (part.indexOf("]") !== part.length - 1) {
        throw new EndpointError(`Path: '${path2}' does not end with ']'`);
      }
      const arrayIndex = part.slice(squareBracketIndex + 1, -1);
      if (Number.isNaN(parseInt(arrayIndex))) {
        throw new EndpointError(`Invalid array index: '${arrayIndex}' in path: '${path2}'`);
      }
      if (squareBracketIndex !== 0) {
        pathList.push(part.slice(0, squareBracketIndex));
      }
      pathList.push(arrayIndex);
    } else {
      pathList.push(part);
    }
  }
  return pathList;
};
const getAttr = (value, path2) => getAttrPathList(path2).reduce((acc, index2) => {
  if (typeof acc !== "object") {
    throw new EndpointError(`Index '${index2}' in '${path2}' not found in '${JSON.stringify(value)}'`);
  } else if (Array.isArray(acc)) {
    return acc[parseInt(index2)];
  }
  return acc[index2];
}, value);
const isSet$2 = (value) => value != null;
const not = (value) => !value;
var HttpAuthLocation;
(function(HttpAuthLocation2) {
  HttpAuthLocation2["HEADER"] = "header";
  HttpAuthLocation2["QUERY"] = "query";
})(HttpAuthLocation || (HttpAuthLocation = {}));
var HostAddressType;
(function(HostAddressType2) {
  HostAddressType2["AAAA"] = "AAAA";
  HostAddressType2["A"] = "A";
})(HostAddressType || (HostAddressType = {}));
var EndpointURLScheme;
(function(EndpointURLScheme2) {
  EndpointURLScheme2["HTTP"] = "http";
  EndpointURLScheme2["HTTPS"] = "https";
})(EndpointURLScheme || (EndpointURLScheme = {}));
var RequestHandlerProtocol;
(function(RequestHandlerProtocol2) {
  RequestHandlerProtocol2["HTTP_0_9"] = "http/0.9";
  RequestHandlerProtocol2["HTTP_1_0"] = "http/1.0";
  RequestHandlerProtocol2["TDS_8_0"] = "tds/8.0";
})(RequestHandlerProtocol || (RequestHandlerProtocol = {}));
const DEFAULT_PORTS = {
  [EndpointURLScheme.HTTP]: 80,
  [EndpointURLScheme.HTTPS]: 443
};
const parseURL = (value) => {
  const whatwgURL = (() => {
    try {
      if (value instanceof URL) {
        return value;
      }
      if (typeof value === "object" && "hostname" in value) {
        const { hostname: hostname2, port, protocol: protocol2 = "", path: path2 = "", query: query6 = {} } = value;
        const url2 = new URL(`${protocol2}//${hostname2}${port ? `:${port}` : ""}${path2}`);
        url2.search = Object.entries(query6).map(([k2, v5]) => `${k2}=${v5}`).join("&");
        return url2;
      }
      return new URL(value);
    } catch (error2) {
      return null;
    }
  })();
  if (!whatwgURL) {
    console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
    return null;
  }
  const urlString = whatwgURL.href;
  const { host, hostname, pathname, protocol, search } = whatwgURL;
  if (search) {
    return null;
  }
  const scheme = protocol.slice(0, -1);
  if (!Object.values(EndpointURLScheme).includes(scheme)) {
    return null;
  }
  const isIp = isIpAddress(hostname);
  const inputContainsDefaultPort = urlString.includes(`${host}:${DEFAULT_PORTS[scheme]}`) || typeof value === "string" && value.includes(`${host}:${DEFAULT_PORTS[scheme]}`);
  const authority = `${host}${inputContainsDefaultPort ? `:${DEFAULT_PORTS[scheme]}` : ``}`;
  return {
    scheme,
    authority,
    path: pathname,
    normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
    isIp
  };
};
const stringEquals = (value1, value2) => value1 === value2;
const substring = (input, start2, stop, reverse4) => {
  if (start2 >= stop || input.length < stop) {
    return null;
  }
  if (!reverse4) {
    return input.substring(start2, stop);
  }
  return input.substring(input.length - stop, input.length - start2);
};
const uriEncode = (value) => encodeURIComponent(value).replace(/[!*'()]/g, (c2) => `%${c2.charCodeAt(0).toString(16).toUpperCase()}`);
const lib$5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  aws: index$1,
  booleanEquals,
  getAttr,
  isSet: isSet$2,
  isValidHostLabel,
  not,
  parseURL,
  stringEquals,
  substring,
  uriEncode
}, Symbol.toStringTag, { value: "Module" }));
const evaluateTemplate = (template, options2) => {
  const evaluatedTemplateArr = [];
  const templateContext = {
    ...options2.endpointParams,
    ...options2.referenceRecord
  };
  let currentIndex = 0;
  while (currentIndex < template.length) {
    const openingBraceIndex = template.indexOf("{", currentIndex);
    if (openingBraceIndex === -1) {
      evaluatedTemplateArr.push(template.slice(currentIndex));
      break;
    }
    evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
    const closingBraceIndex = template.indexOf("}", openingBraceIndex);
    if (closingBraceIndex === -1) {
      evaluatedTemplateArr.push(template.slice(openingBraceIndex));
      break;
    }
    if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
      evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
      currentIndex = closingBraceIndex + 2;
    }
    const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
    if (parameterName.includes("#")) {
      const [refName, attrName] = parameterName.split("#");
      evaluatedTemplateArr.push(getAttr(templateContext[refName], attrName));
    } else {
      evaluatedTemplateArr.push(templateContext[parameterName]);
    }
    currentIndex = closingBraceIndex + 1;
  }
  return evaluatedTemplateArr.join("");
};
const getReferenceValue = ({ ref }, options2) => {
  const referenceRecord = {
    ...options2.endpointParams,
    ...options2.referenceRecord
  };
  return referenceRecord[ref];
};
const evaluateExpression = (obj, keyName, options2) => {
  if (typeof obj === "string") {
    return evaluateTemplate(obj, options2);
  } else if (obj["fn"]) {
    return callFunction(obj, options2);
  } else if (obj["ref"]) {
    return getReferenceValue(obj, options2);
  }
  throw new EndpointError(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};
const callFunction = ({ fn: fn2, argv }, options2) => {
  const evaluatedArgs = argv.map((arg) => ["boolean", "number"].includes(typeof arg) ? arg : evaluateExpression(arg, "arg", options2));
  return fn2.split(".").reduce((acc, key) => acc[key], lib$5)(...evaluatedArgs);
};
const evaluateCondition = ({ assign: assign3, ...fnArgs }, options2) => {
  var _a3, _b3;
  if (assign3 && assign3 in options2.referenceRecord) {
    throw new EndpointError(`'${assign3}' is already defined in Reference Record.`);
  }
  const value = callFunction(fnArgs, options2);
  (_b3 = (_a3 = options2.logger) == null ? void 0 : _a3.debug) == null ? void 0 : _b3.call(_a3, debugId, `evaluateCondition: ${toDebugString(fnArgs)} = ${toDebugString(value)}`);
  return {
    result: value === "" ? true : !!value,
    ...assign3 != null && { toAssign: { name: assign3, value } }
  };
};
const evaluateConditions = (conditions = [], options2) => {
  var _a3, _b3;
  const conditionsReferenceRecord = {};
  for (const condition of conditions) {
    const { result, toAssign } = evaluateCondition(condition, {
      ...options2,
      referenceRecord: {
        ...options2.referenceRecord,
        ...conditionsReferenceRecord
      }
    });
    if (!result) {
      return { result };
    }
    if (toAssign) {
      conditionsReferenceRecord[toAssign.name] = toAssign.value;
      (_b3 = (_a3 = options2.logger) == null ? void 0 : _a3.debug) == null ? void 0 : _b3.call(_a3, debugId, `assign: ${toAssign.name} := ${toDebugString(toAssign.value)}`);
    }
  }
  return { result: true, referenceRecord: conditionsReferenceRecord };
};
const getEndpointHeaders = (headers, options2) => Object.entries(headers).reduce((acc, [headerKey, headerVal]) => ({
  ...acc,
  [headerKey]: headerVal.map((headerValEntry) => {
    const processedExpr = evaluateExpression(headerValEntry, "Header value entry", options2);
    if (typeof processedExpr !== "string") {
      throw new EndpointError(`Header '${headerKey}' value '${processedExpr}' is not a string`);
    }
    return processedExpr;
  })
}), {});
const getEndpointProperty = (property2, options2) => {
  if (Array.isArray(property2)) {
    return property2.map((propertyEntry) => getEndpointProperty(propertyEntry, options2));
  }
  switch (typeof property2) {
    case "string":
      return evaluateTemplate(property2, options2);
    case "object":
      if (property2 === null) {
        throw new EndpointError(`Unexpected endpoint property: ${property2}`);
      }
      return getEndpointProperties(property2, options2);
    case "boolean":
      return property2;
    default:
      throw new EndpointError(`Unexpected endpoint property type: ${typeof property2}`);
  }
};
const getEndpointProperties = (properties, options2) => Object.entries(properties).reduce((acc, [propertyKey, propertyVal]) => ({
  ...acc,
  [propertyKey]: getEndpointProperty(propertyVal, options2)
}), {});
const getEndpointUrl = (endpointUrl, options2) => {
  const expression = evaluateExpression(endpointUrl, "Endpoint URL", options2);
  if (typeof expression === "string") {
    try {
      return new URL(expression);
    } catch (error2) {
      console.error(`Failed to construct URL with ${expression}`, error2);
      throw error2;
    }
  }
  throw new EndpointError(`Endpoint URL must be a string, got ${typeof expression}`);
};
const evaluateEndpointRule = (endpointRule, options2) => {
  var _a3, _b3;
  const { conditions, endpoint } = endpointRule;
  const { result, referenceRecord } = evaluateConditions(conditions, options2);
  if (!result) {
    return;
  }
  const endpointRuleOptions = {
    ...options2,
    referenceRecord: { ...options2.referenceRecord, ...referenceRecord }
  };
  const { url: url2, properties, headers } = endpoint;
  (_b3 = (_a3 = options2.logger) == null ? void 0 : _a3.debug) == null ? void 0 : _b3.call(_a3, debugId, `Resolving endpoint from template: ${toDebugString(endpoint)}`);
  return {
    ...headers != void 0 && {
      headers: getEndpointHeaders(headers, endpointRuleOptions)
    },
    ...properties != void 0 && {
      properties: getEndpointProperties(properties, endpointRuleOptions)
    },
    url: getEndpointUrl(url2, endpointRuleOptions)
  };
};
const evaluateErrorRule = (errorRule, options2) => {
  const { conditions, error: error2 } = errorRule;
  const { result, referenceRecord } = evaluateConditions(conditions, options2);
  if (!result) {
    return;
  }
  throw new EndpointError(evaluateExpression(error2, "Error", {
    ...options2,
    referenceRecord: { ...options2.referenceRecord, ...referenceRecord }
  }));
};
const evaluateTreeRule = (treeRule, options2) => {
  const { conditions, rules } = treeRule;
  const { result, referenceRecord } = evaluateConditions(conditions, options2);
  if (!result) {
    return;
  }
  return evaluateRules(rules, {
    ...options2,
    referenceRecord: { ...options2.referenceRecord, ...referenceRecord }
  });
};
const evaluateRules = (rules, options2) => {
  for (const rule of rules) {
    if (rule.type === "endpoint") {
      const endpointOrUndefined = evaluateEndpointRule(rule, options2);
      if (endpointOrUndefined) {
        return endpointOrUndefined;
      }
    } else if (rule.type === "error") {
      evaluateErrorRule(rule, options2);
    } else if (rule.type === "tree") {
      const endpointOrUndefined = evaluateTreeRule(rule, options2);
      if (endpointOrUndefined) {
        return endpointOrUndefined;
      }
    } else {
      throw new EndpointError(`Unknown endpoint rule: ${rule}`);
    }
  }
  throw new EndpointError(`Rules evaluation failed`);
};
const resolveEndpoint = (ruleSetObject, options2) => {
  var _a3, _b3, _c2, _d2, _e2;
  const { endpointParams, logger: logger2 } = options2;
  const { parameters, rules } = ruleSetObject;
  (_b3 = (_a3 = options2.logger) == null ? void 0 : _a3.debug) == null ? void 0 : _b3.call(_a3, `${debugId} Initial EndpointParams: ${toDebugString(endpointParams)}`);
  const paramsWithDefault = Object.entries(parameters).filter(([, v5]) => v5.default != null).map(([k2, v5]) => [k2, v5.default]);
  if (paramsWithDefault.length > 0) {
    for (const [paramKey, paramDefaultValue] of paramsWithDefault) {
      endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
    }
  }
  const requiredParams = Object.entries(parameters).filter(([, v5]) => v5.required).map(([k2]) => k2);
  for (const requiredParam of requiredParams) {
    if (endpointParams[requiredParam] == null) {
      throw new EndpointError(`Missing required parameter: '${requiredParam}'`);
    }
  }
  const endpoint = evaluateRules(rules, { endpointParams, logger: logger2, referenceRecord: {} });
  if ((_c2 = options2.endpointParams) == null ? void 0 : _c2.Endpoint) {
    try {
      const givenEndpoint = new URL(options2.endpointParams.Endpoint);
      const { protocol, port } = givenEndpoint;
      endpoint.url.protocol = protocol;
      endpoint.url.port = port;
    } catch (e3) {
    }
  }
  (_e2 = (_d2 = options2.logger) == null ? void 0 : _d2.debug) == null ? void 0 : _e2.call(_d2, `${debugId} Resolved endpoint: ${toDebugString(endpoint)}`);
  return endpoint;
};
const USER_AGENT = "user-agent";
const X_AMZ_USER_AGENT = "x-amz-user-agent";
const SPACE = " ";
const UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
const userAgentMiddleware = (options2) => (next5, context2) => async (args) => {
  var _a3, _b3;
  const { request } = args;
  if (!HttpRequest$1.isInstance(request))
    return next5(args);
  const { headers } = request;
  const userAgent2 = ((_a3 = context2 == null ? void 0 : context2.userAgent) == null ? void 0 : _a3.map(escapeUserAgent)) || [];
  const defaultUserAgent2 = (await options2.defaultUserAgentProvider()).map(escapeUserAgent);
  const customUserAgent = ((_b3 = options2 == null ? void 0 : options2.customUserAgent) == null ? void 0 : _b3.map(escapeUserAgent)) || [];
  const prefix = getUserAgentPrefix();
  const sdkUserAgentValue = (prefix ? [prefix] : []).concat([...defaultUserAgent2, ...userAgent2, ...customUserAgent]).join(SPACE);
  const normalUAValue = [
    ...defaultUserAgent2.filter((section) => section.startsWith("aws-sdk-")),
    ...customUserAgent
  ].join(SPACE);
  if (options2.runtime !== "browser") {
    if (normalUAValue) {
      headers[X_AMZ_USER_AGENT] = headers[X_AMZ_USER_AGENT] ? `${headers[USER_AGENT]} ${normalUAValue}` : normalUAValue;
    }
    headers[USER_AGENT] = sdkUserAgentValue;
  } else {
    headers[X_AMZ_USER_AGENT] = sdkUserAgentValue;
  }
  return next5({
    ...args,
    request
  });
};
const escapeUserAgent = ([name2, version2]) => {
  const prefixSeparatorIndex = name2.indexOf("/");
  const prefix = name2.substring(0, prefixSeparatorIndex);
  let uaName = name2.substring(prefixSeparatorIndex + 1);
  if (prefix === "api") {
    uaName = uaName.toLowerCase();
  }
  return [prefix, uaName, version2].filter((item) => item && item.length > 0).map((item) => item == null ? void 0 : item.replace(UA_ESCAPE_REGEX, "_")).join("/");
};
const getUserAgentMiddlewareOptions = {
  name: "getUserAgentMiddleware",
  step: "build",
  priority: "low",
  tags: ["SET_USER_AGENT", "USER_AGENT"],
  override: true
};
const getUserAgentPlugin = (config2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(userAgentMiddleware(config2), getUserAgentMiddlewareOptions);
  }
});
class NoOpLogger {
  trace() {
  }
  debug() {
  }
  info() {
  }
  warn() {
  }
  error() {
  }
}
const constructStack = () => {
  let absoluteEntries = [];
  let relativeEntries = [];
  const entriesNameSet = /* @__PURE__ */ new Set();
  const sort3 = (entries) => entries.sort((a2, b2) => stepWeights[b2.step] - stepWeights[a2.step] || priorityWeights[b2.priority || "normal"] - priorityWeights[a2.priority || "normal"]);
  const removeByName = (toRemove) => {
    let isRemoved = false;
    const filterCb = (entry) => {
      if (entry.name && entry.name === toRemove) {
        isRemoved = true;
        entriesNameSet.delete(toRemove);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  const removeByReference = (toRemove) => {
    let isRemoved = false;
    const filterCb = (entry) => {
      if (entry.middleware === toRemove) {
        isRemoved = true;
        if (entry.name)
          entriesNameSet.delete(entry.name);
        return false;
      }
      return true;
    };
    absoluteEntries = absoluteEntries.filter(filterCb);
    relativeEntries = relativeEntries.filter(filterCb);
    return isRemoved;
  };
  const cloneTo = (toStack) => {
    absoluteEntries.forEach((entry) => {
      toStack.add(entry.middleware, { ...entry });
    });
    relativeEntries.forEach((entry) => {
      toStack.addRelativeTo(entry.middleware, { ...entry });
    });
    return toStack;
  };
  const expandRelativeMiddlewareList = (from) => {
    const expandedMiddlewareList = [];
    from.before.forEach((entry) => {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
      }
    });
    expandedMiddlewareList.push(from);
    from.after.reverse().forEach((entry) => {
      if (entry.before.length === 0 && entry.after.length === 0) {
        expandedMiddlewareList.push(entry);
      } else {
        expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
      }
    });
    return expandedMiddlewareList;
  };
  const getMiddlewareList = (debug2 = false) => {
    const normalizedAbsoluteEntries = [];
    const normalizedRelativeEntries = [];
    const normalizedEntriesNameMap = {};
    absoluteEntries.forEach((entry) => {
      const normalizedEntry = {
        ...entry,
        before: [],
        after: []
      };
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedAbsoluteEntries.push(normalizedEntry);
    });
    relativeEntries.forEach((entry) => {
      const normalizedEntry = {
        ...entry,
        before: [],
        after: []
      };
      if (normalizedEntry.name)
        normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
      normalizedRelativeEntries.push(normalizedEntry);
    });
    normalizedRelativeEntries.forEach((entry) => {
      if (entry.toMiddleware) {
        const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
        if (toMiddleware === void 0) {
          if (debug2) {
            return;
          }
          throw new Error(`${entry.toMiddleware} is not found when adding ${entry.name || "anonymous"} middleware ${entry.relation} ${entry.toMiddleware}`);
        }
        if (entry.relation === "after") {
          toMiddleware.after.push(entry);
        }
        if (entry.relation === "before") {
          toMiddleware.before.push(entry);
        }
      }
    });
    const mainChain = sort3(normalizedAbsoluteEntries).map(expandRelativeMiddlewareList).reduce((wholeList, expendedMiddlewareList) => {
      wholeList.push(...expendedMiddlewareList);
      return wholeList;
    }, []);
    return mainChain;
  };
  const stack2 = {
    add: (middleware, options2 = {}) => {
      const { name: name2, override } = options2;
      const entry = {
        step: "initialize",
        priority: "normal",
        middleware,
        ...options2
      };
      if (name2) {
        if (entriesNameSet.has(name2)) {
          if (!override)
            throw new Error(`Duplicate middleware name '${name2}'`);
          const toOverrideIndex = absoluteEntries.findIndex((entry2) => entry2.name === name2);
          const toOverride = absoluteEntries[toOverrideIndex];
          if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) {
            throw new Error(`"${name2}" middleware with ${toOverride.priority} priority in ${toOverride.step} step cannot be overridden by same-name middleware with ${entry.priority} priority in ${entry.step} step.`);
          }
          absoluteEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name2);
      }
      absoluteEntries.push(entry);
    },
    addRelativeTo: (middleware, options2) => {
      const { name: name2, override } = options2;
      const entry = {
        middleware,
        ...options2
      };
      if (name2) {
        if (entriesNameSet.has(name2)) {
          if (!override)
            throw new Error(`Duplicate middleware name '${name2}'`);
          const toOverrideIndex = relativeEntries.findIndex((entry2) => entry2.name === name2);
          const toOverride = relativeEntries[toOverrideIndex];
          if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
            throw new Error(`"${name2}" middleware ${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden by same-name middleware ${entry.relation} "${entry.toMiddleware}" middleware.`);
          }
          relativeEntries.splice(toOverrideIndex, 1);
        }
        entriesNameSet.add(name2);
      }
      relativeEntries.push(entry);
    },
    clone: () => cloneTo(constructStack()),
    use: (plugin) => {
      plugin.applyToStack(stack2);
    },
    remove: (toRemove) => {
      if (typeof toRemove === "string")
        return removeByName(toRemove);
      else
        return removeByReference(toRemove);
    },
    removeByTag: (toRemove) => {
      let isRemoved = false;
      const filterCb = (entry) => {
        const { tags, name: name2 } = entry;
        if (tags && tags.includes(toRemove)) {
          if (name2)
            entriesNameSet.delete(name2);
          isRemoved = true;
          return false;
        }
        return true;
      };
      absoluteEntries = absoluteEntries.filter(filterCb);
      relativeEntries = relativeEntries.filter(filterCb);
      return isRemoved;
    },
    concat: (from) => {
      const cloned = cloneTo(constructStack());
      cloned.use(from);
      return cloned;
    },
    applyToStack: cloneTo,
    identify: () => {
      return getMiddlewareList(true).map((mw) => {
        return mw.name + ": " + (mw.tags || []).join(",");
      });
    },
    resolve: (handler, context2) => {
      for (const middleware of getMiddlewareList().map((entry) => entry.middleware).reverse()) {
        handler = middleware(handler, context2);
      }
      return handler;
    }
  };
  return stack2;
};
const stepWeights = {
  initialize: 5,
  serialize: 4,
  build: 3,
  finalizeRequest: 2,
  deserialize: 1
};
const priorityWeights = {
  high: 3,
  normal: 2,
  low: 1
};
class Client {
  constructor(config2) {
    this.middlewareStack = constructStack();
    this.config = config2;
  }
  send(command, optionsOrCb, cb2) {
    const options2 = typeof optionsOrCb !== "function" ? optionsOrCb : void 0;
    const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb2;
    const handler = command.resolveMiddleware(this.middlewareStack, this.config, options2);
    if (callback) {
      handler(command).then((result) => callback(null, result.output), (err) => callback(err)).catch(() => {
      });
    } else {
      return handler(command).then((result) => result.output);
    }
  }
  destroy() {
    if (this.config.requestHandler.destroy)
      this.config.requestHandler.destroy();
  }
}
class Command {
  constructor() {
    this.middlewareStack = constructStack();
  }
}
const SENSITIVE_STRING = "***SensitiveInformation***";
const parseBoolean = (value) => {
  switch (value) {
    case "true":
      return true;
    case "false":
      return false;
    default:
      throw new Error(`Unable to parse boolean value "${value}"`);
  }
};
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function dateToUtcString(date2) {
  const year = date2.getUTCFullYear();
  const month = date2.getUTCMonth();
  const dayOfWeek = date2.getUTCDay();
  const dayOfMonthInt = date2.getUTCDate();
  const hoursInt = date2.getUTCHours();
  const minutesInt = date2.getUTCMinutes();
  const secondsInt = date2.getUTCSeconds();
  const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
  const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
  const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
  const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
  return `${DAYS[dayOfWeek]}, ${dayOfMonthString} ${MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
class ServiceException extends Error {
  constructor(options2) {
    super(options2.message);
    Object.setPrototypeOf(this, ServiceException.prototype);
    this.name = options2.name;
    this.$fault = options2.$fault;
    this.$metadata = options2.$metadata;
  }
}
const decorateServiceException = (exception, additions = {}) => {
  Object.entries(additions).filter(([, v5]) => v5 !== void 0).forEach(([k2, v5]) => {
    if (exception[k2] == void 0 || exception[k2] === "") {
      exception[k2] = v5;
    }
  });
  const message2 = exception.message || exception.Message || "UnknownError";
  exception.message = message2;
  delete exception.Message;
  return exception;
};
const throwDefaultError$1 = ({ output: output2, parsedBody, exceptionCtor, errorCode }) => {
  const $metadata = deserializeMetadata$1(output2);
  const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : void 0;
  const response = new exceptionCtor({
    name: (parsedBody == null ? void 0 : parsedBody.code) || (parsedBody == null ? void 0 : parsedBody.Code) || errorCode || statusCode || "UnknownError",
    $fault: "client",
    $metadata
  });
  throw decorateServiceException(response, parsedBody);
};
const withBaseException = (ExceptionCtor) => {
  return ({ output: output2, parsedBody, errorCode }) => {
    throwDefaultError$1({ output: output2, parsedBody, exceptionCtor: ExceptionCtor, errorCode });
  };
};
const deserializeMetadata$1 = (output2) => ({
  httpStatusCode: output2.statusCode,
  requestId: output2.headers["x-amzn-requestid"] ?? output2.headers["x-amzn-request-id"] ?? output2.headers["x-amz-request-id"],
  extendedRequestId: output2.headers["x-amz-id-2"],
  cfId: output2.headers["x-amz-cf-id"]
});
const loadConfigsForDefaultMode = (mode2) => {
  switch (mode2) {
    case "standard":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "in-region":
      return {
        retryMode: "standard",
        connectionTimeout: 1100
      };
    case "cross-region":
      return {
        retryMode: "standard",
        connectionTimeout: 3100
      };
    case "mobile":
      return {
        retryMode: "standard",
        connectionTimeout: 3e4
      };
    default:
      return {};
  }
};
function extendedEncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function(c2) {
    return "%" + c2.charCodeAt(0).toString(16).toUpperCase();
  });
}
const getValueFromTextNode = (obj) => {
  const textNodeName = "#text";
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== void 0) {
      obj[key] = obj[key][textNodeName];
    } else if (typeof obj[key] === "object" && obj[key] !== null) {
      obj[key] = getValueFromTextNode(obj[key]);
    }
  }
  return obj;
};
const StringWrapper = function() {
  const Class = Object.getPrototypeOf(this).constructor;
  const Constructor = Function.bind.apply(String, [null, ...arguments]);
  const instance2 = new Constructor();
  Object.setPrototypeOf(instance2, Class.prototype);
  return instance2;
};
StringWrapper.prototype = Object.create(String.prototype, {
  constructor: {
    value: StringWrapper,
    enumerable: false,
    writable: true,
    configurable: true
  }
});
Object.setPrototypeOf(StringWrapper, String);
function map$4(arg0, arg1, arg2) {
  let target;
  let filter17;
  let instructions;
  if (typeof arg1 === "undefined" && typeof arg2 === "undefined") {
    target = {};
    instructions = arg0;
  } else {
    target = arg0;
    if (typeof arg1 === "function") {
      filter17 = arg1;
      instructions = arg2;
      return mapWithFilter(target, filter17, instructions);
    } else {
      instructions = arg1;
    }
  }
  for (const key of Object.keys(instructions)) {
    if (!Array.isArray(instructions[key])) {
      target[key] = instructions[key];
      continue;
    }
    applyInstruction(target, null, instructions, key);
  }
  return target;
}
const mapWithFilter = (target, filter17, instructions) => {
  return map$4(target, Object.entries(instructions).reduce((_instructions, [key, value]) => {
    if (Array.isArray(value)) {
      _instructions[key] = value;
    } else {
      if (typeof value === "function") {
        _instructions[key] = [filter17, value()];
      } else {
        _instructions[key] = [filter17, value];
      }
    }
    return _instructions;
  }, {}));
};
const applyInstruction = (target, source, instructions, targetKey) => {
  if (source !== null) {
    let instruction = instructions[targetKey];
    if (typeof instruction === "function") {
      instruction = [, instruction];
    }
    const [filter18 = nonNullish, valueFn = pass, sourceKey = targetKey] = instruction;
    if (typeof filter18 === "function" && filter18(source[sourceKey]) || typeof filter18 !== "function" && !!filter18) {
      target[targetKey] = valueFn(source[sourceKey]);
    }
    return;
  }
  let [filter17, value] = instructions[targetKey];
  if (typeof value === "function") {
    let _value;
    const defaultFilterPassed = filter17 === void 0 && (_value = value()) != null;
    const customFilterPassed = typeof filter17 === "function" && !!filter17(void 0) || typeof filter17 !== "function" && !!filter17;
    if (defaultFilterPassed) {
      target[targetKey] = _value;
    } else if (customFilterPassed) {
      target[targetKey] = value();
    }
  } else {
    const defaultFilterPassed = filter17 === void 0 && value != null;
    const customFilterPassed = typeof filter17 === "function" && !!filter17(value) || typeof filter17 !== "function" && !!filter17;
    if (defaultFilterPassed || customFilterPassed) {
      target[targetKey] = value;
    }
  }
};
const nonNullish = (_2) => _2 != null;
const pass = (_2) => _2;
const resolvedPath = (resolvedPath2, input, memberName, labelValueProvider, uriLabel, isGreedyLabel) => {
  if (input != null && input[memberName] !== void 0) {
    const labelValue = labelValueProvider();
    if (labelValue.length <= 0) {
      throw new Error("Empty value provided for input HTTP label: " + memberName + ".");
    }
    resolvedPath2 = resolvedPath2.replace(uriLabel, isGreedyLabel ? labelValue.split("/").map((segment) => extendedEncodeURIComponent(segment)).join("/") : extendedEncodeURIComponent(labelValue));
  } else {
    throw new Error("No value provided for input HTTP label: " + memberName + ".");
  }
  return resolvedPath2;
};
const resolveClientEndpointParameters = (options2) => {
  return {
    ...options2,
    useFipsEndpoint: options2.useFipsEndpoint ?? false,
    useDualstackEndpoint: options2.useDualstackEndpoint ?? false,
    useAccelerateEndpoint: options2.useAccelerateEndpoint ?? false,
    useGlobalEndpoint: options2.useGlobalEndpoint ?? false,
    disableMultiregionAccessPoints: options2.disableMultiregionAccessPoints ?? false,
    defaultSigningName: "s3"
  };
};
const name$n = "@aws-sdk/client-s3";
const description = "AWS SDK for JavaScript S3 Client for Node.js, Browser and React Native";
const version = "3.338.0";
const scripts = {
  build: "concurrently 'yarn:build:cjs' 'yarn:build:es' 'yarn:build:types'",
  "build:cjs": "tsc -p tsconfig.cjs.json",
  "build:docs": "typedoc",
  "build:es": "tsc -p tsconfig.es.json",
  "build:include:deps": "lerna run --scope $npm_package_name --include-dependencies build",
  "build:types": "tsc -p tsconfig.types.json",
  "build:types:downlevel": "downlevel-dts dist-types dist-types/ts3.4",
  clean: "rimraf ./dist-* && rimraf *.tsbuildinfo",
  "extract:docs": "api-extractor run --local",
  "generate:client": "node ../../scripts/generate-clients/single-service --solo s3",
  test: "yarn test:unit",
  "test:e2e": "ts-mocha test/**/*.ispec.ts && karma start karma.conf.js",
  "test:unit": "ts-mocha test/**/*.spec.ts"
};
const main$1 = "./dist-cjs/index.js";
const types$3 = "./dist-types/index.d.ts";
const module$1 = "./dist-es/index.js";
const sideEffects = false;
const dependencies = {
  "@aws-crypto/sha1-browser": "3.0.0",
  "@aws-crypto/sha256-browser": "3.0.0",
  "@aws-crypto/sha256-js": "3.0.0",
  "@aws-sdk/client-sts": "3.338.0",
  "@aws-sdk/config-resolver": "3.338.0",
  "@aws-sdk/credential-provider-node": "3.338.0",
  "@aws-sdk/eventstream-serde-browser": "3.338.0",
  "@aws-sdk/eventstream-serde-config-resolver": "3.338.0",
  "@aws-sdk/eventstream-serde-node": "3.338.0",
  "@aws-sdk/fetch-http-handler": "3.338.0",
  "@aws-sdk/hash-blob-browser": "3.338.0",
  "@aws-sdk/hash-node": "3.338.0",
  "@aws-sdk/hash-stream-node": "3.338.0",
  "@aws-sdk/invalid-dependency": "3.338.0",
  "@aws-sdk/md5-js": "3.338.0",
  "@aws-sdk/middleware-bucket-endpoint": "3.338.0",
  "@aws-sdk/middleware-content-length": "3.338.0",
  "@aws-sdk/middleware-endpoint": "3.338.0",
  "@aws-sdk/middleware-expect-continue": "3.338.0",
  "@aws-sdk/middleware-flexible-checksums": "3.338.0",
  "@aws-sdk/middleware-host-header": "3.338.0",
  "@aws-sdk/middleware-location-constraint": "3.338.0",
  "@aws-sdk/middleware-logger": "3.338.0",
  "@aws-sdk/middleware-recursion-detection": "3.338.0",
  "@aws-sdk/middleware-retry": "3.338.0",
  "@aws-sdk/middleware-sdk-s3": "3.338.0",
  "@aws-sdk/middleware-serde": "3.338.0",
  "@aws-sdk/middleware-signing": "3.338.0",
  "@aws-sdk/middleware-ssec": "3.338.0",
  "@aws-sdk/middleware-stack": "3.338.0",
  "@aws-sdk/middleware-user-agent": "3.338.0",
  "@aws-sdk/node-config-provider": "3.338.0",
  "@aws-sdk/node-http-handler": "3.338.0",
  "@aws-sdk/signature-v4-multi-region": "3.338.0",
  "@aws-sdk/smithy-client": "3.338.0",
  "@aws-sdk/types": "3.338.0",
  "@aws-sdk/url-parser": "3.338.0",
  "@aws-sdk/util-base64": "3.310.0",
  "@aws-sdk/util-body-length-browser": "3.310.0",
  "@aws-sdk/util-body-length-node": "3.310.0",
  "@aws-sdk/util-defaults-mode-browser": "3.338.0",
  "@aws-sdk/util-defaults-mode-node": "3.338.0",
  "@aws-sdk/util-endpoints": "3.338.0",
  "@aws-sdk/util-retry": "3.338.0",
  "@aws-sdk/util-stream-browser": "3.338.0",
  "@aws-sdk/util-stream-node": "3.338.0",
  "@aws-sdk/util-user-agent-browser": "3.338.0",
  "@aws-sdk/util-user-agent-node": "3.338.0",
  "@aws-sdk/util-utf8": "3.310.0",
  "@aws-sdk/util-waiter": "3.338.0",
  "@aws-sdk/xml-builder": "3.310.0",
  "@smithy/protocol-http": "^1.0.1",
  "@smithy/types": "^1.0.0",
  "fast-xml-parser": "4.1.2",
  tslib: "^2.5.0"
};
const devDependencies = {
  "@aws-sdk/service-client-documentation-generator": "3.310.0",
  "@tsconfig/node14": "1.0.3",
  "@types/chai": "^4.2.11",
  "@types/mocha": "^8.0.4",
  "@types/node": "^14.14.31",
  concurrently: "7.0.0",
  "downlevel-dts": "0.10.1",
  rimraf: "3.0.2",
  typedoc: "0.23.23",
  typescript: "~4.9.5"
};
const engines = {
  node: ">=14.0.0"
};
const typesVersions = {
  "<4.0": {
    "dist-types/*": [
      "dist-types/ts3.4/*"
    ]
  }
};
const files = [
  "dist-*/**"
];
const author = {
  name: "AWS SDK for JavaScript Team",
  url: "https://aws.amazon.com/javascript/"
};
const license = "Apache-2.0";
const browser$2 = {
  "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.browser"
};
const homepage = "https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-s3";
const repository = {
  type: "git",
  url: "https://github.com/aws/aws-sdk-js-v3.git",
  directory: "clients/client-s3"
};
const packageInfo = {
  name: name$n,
  description,
  version,
  scripts,
  main: main$1,
  types: types$3,
  module: module$1,
  sideEffects,
  dependencies,
  devDependencies,
  engines,
  typesVersions,
  files,
  author,
  license,
  browser: browser$2,
  "react-native": {
    "./dist-es/runtimeConfig": "./dist-es/runtimeConfig.native"
  },
  homepage,
  repository
};
var build$7 = {};
var tslibExports$6 = {};
var tslib$6 = {
  get exports() {
    return tslibExports$6;
  },
  set exports(v5) {
    tslibExports$6 = v5;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
(function(module2) {
  var __extends;
  var __assign2;
  var __rest2;
  var __decorate;
  var __param;
  var __metadata;
  var __awaiter;
  var __generator;
  var __exportStar;
  var __values;
  var __read;
  var __spread;
  var __spreadArrays;
  var __await;
  var __asyncGenerator;
  var __asyncDelegator;
  var __asyncValues;
  var __makeTemplateObject;
  var __importStar;
  var __importDefault2;
  var __classPrivateFieldGet;
  var __classPrivateFieldSet;
  var __createBinding;
  (function(factory) {
    var root2 = typeof commonjsGlobal$1 === "object" ? commonjsGlobal$1 : typeof self === "object" ? self : typeof this === "object" ? this : {};
    {
      factory(createExporter(root2, createExporter(module2.exports)));
    }
    function createExporter(exports2, previous) {
      if (exports2 !== root2) {
        if (typeof Object.create === "function") {
          Object.defineProperty(exports2, "__esModule", { value: true });
        } else {
          exports2.__esModule = true;
        }
      }
      return function(id, v5) {
        return exports2[id] = previous ? previous(id, v5) : v5;
      };
    }
  })(function(exporter) {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p2 in b2)
        if (b2.hasOwnProperty(p2))
          d2[p2] = b2[p2];
    };
    __extends = function(d2, b2) {
      extendStatics(d2, b2);
      function __() {
        this.constructor = d2;
      }
      d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
    __assign2 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    __rest2 = function(s2, e3) {
      var t2 = {};
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
          t2[p2] = s2[p2];
      if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
          if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
            t2[p2[i2]] = s2[p2[i2]];
        }
      return t2;
    };
    __decorate = function(decorators, target, key, desc) {
      var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r2 = Reflect.decorate(decorators, target, key, desc);
      else
        for (var i2 = decorators.length - 1; i2 >= 0; i2--)
          if (d2 = decorators[i2])
            r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
      return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
    };
    __param = function(paramIndex, decorator) {
      return function(target, key) {
        decorator(target, key, paramIndex);
      };
    };
    __metadata = function(metadataKey, metadataValue) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(metadataKey, metadataValue);
    };
    __awaiter = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e3) {
            reject(e3);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e3) {
            reject(e3);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    __generator = function(thisArg, body) {
      var _2 = { label: 0, sent: function() {
        if (t2[0] & 1)
          throw t2[1];
        return t2[1];
      }, trys: [], ops: [] }, f2, y2, t2, g2;
      return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
        return this;
      }), g2;
      function verb(n2) {
        return function(v5) {
          return step([n2, v5]);
        };
      }
      function step(op) {
        if (f2)
          throw new TypeError("Generator is already executing.");
        while (_2)
          try {
            if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
              return t2;
            if (y2 = 0, t2)
              op = [op[0] & 2, t2.value];
            switch (op[0]) {
              case 0:
              case 1:
                t2 = op;
                break;
              case 4:
                _2.label++;
                return { value: op[1], done: false };
              case 5:
                _2.label++;
                y2 = op[1];
                op = [0];
                continue;
              case 7:
                op = _2.ops.pop();
                _2.trys.pop();
                continue;
              default:
                if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _2 = 0;
                  continue;
                }
                if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                  _2.label = op[1];
                  break;
                }
                if (op[0] === 6 && _2.label < t2[1]) {
                  _2.label = t2[1];
                  t2 = op;
                  break;
                }
                if (t2 && _2.label < t2[2]) {
                  _2.label = t2[2];
                  _2.ops.push(op);
                  break;
                }
                if (t2[2])
                  _2.ops.pop();
                _2.trys.pop();
                continue;
            }
            op = body.call(thisArg, _2);
          } catch (e3) {
            op = [6, e3];
            y2 = 0;
          } finally {
            f2 = t2 = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    __createBinding = function(o2, m2, k2, k22) {
      if (k22 === void 0)
        k22 = k2;
      o2[k22] = m2[k2];
    };
    __exportStar = function(m2, exports2) {
      for (var p2 in m2)
        if (p2 !== "default" && !exports2.hasOwnProperty(p2))
          exports2[p2] = m2[p2];
    };
    __values = function(o2) {
      var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
      if (m2)
        return m2.call(o2);
      if (o2 && typeof o2.length === "number")
        return {
          next: function() {
            if (o2 && i2 >= o2.length)
              o2 = void 0;
            return { value: o2 && o2[i2++], done: !o2 };
          }
        };
      throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    __read = function(o2, n2) {
      var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
      if (!m2)
        return o2;
      var i2 = m2.call(o2), r2, ar2 = [], e3;
      try {
        while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
          ar2.push(r2.value);
      } catch (error2) {
        e3 = { error: error2 };
      } finally {
        try {
          if (r2 && !r2.done && (m2 = i2["return"]))
            m2.call(i2);
        } finally {
          if (e3)
            throw e3.error;
        }
      }
      return ar2;
    };
    __spread = function() {
      for (var ar2 = [], i2 = 0; i2 < arguments.length; i2++)
        ar2 = ar2.concat(__read(arguments[i2]));
      return ar2;
    };
    __spreadArrays = function() {
      for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
        s2 += arguments[i2].length;
      for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
        for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
          r2[k2] = a2[j2];
      return r2;
    };
    __await = function(v5) {
      return this instanceof __await ? (this.v = v5, this) : new __await(v5);
    };
    __asyncGenerator = function(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
      return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2;
      function verb(n2) {
        if (g2[n2])
          i2[n2] = function(v5) {
            return new Promise(function(a2, b2) {
              q2.push([n2, v5, a2, b2]) > 1 || resume(n2, v5);
            });
          };
      }
      function resume(n2, v5) {
        try {
          step(g2[n2](v5));
        } catch (e3) {
          settle(q2[0][3], e3);
        }
      }
      function step(r2) {
        r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
      }
      function fulfill(value) {
        resume("next", value);
      }
      function reject(value) {
        resume("throw", value);
      }
      function settle(f2, v5) {
        if (f2(v5), q2.shift(), q2.length)
          resume(q2[0][0], q2[0][1]);
      }
    };
    __asyncDelegator = function(o2) {
      var i2, p2;
      return i2 = {}, verb("next"), verb("throw", function(e3) {
        throw e3;
      }), verb("return"), i2[Symbol.iterator] = function() {
        return this;
      }, i2;
      function verb(n2, f2) {
        i2[n2] = o2[n2] ? function(v5) {
          return (p2 = !p2) ? { value: __await(o2[n2](v5)), done: n2 === "return" } : f2 ? f2(v5) : v5;
        } : f2;
      }
    };
    __asyncValues = function(o2) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var m2 = o2[Symbol.asyncIterator], i2;
      return m2 ? m2.call(o2) : (o2 = typeof __values === "function" ? __values(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2);
      function verb(n2) {
        i2[n2] = o2[n2] && function(v5) {
          return new Promise(function(resolve2, reject) {
            v5 = o2[n2](v5), settle(resolve2, reject, v5.done, v5.value);
          });
        };
      }
      function settle(resolve2, reject, d2, v5) {
        Promise.resolve(v5).then(function(v6) {
          resolve2({ value: v6, done: d2 });
        }, reject);
      }
    };
    __makeTemplateObject = function(cooked, raw) {
      if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
      } else {
        cooked.raw = raw;
      }
      return cooked;
    };
    __importStar = function(mod2) {
      if (mod2 && mod2.__esModule)
        return mod2;
      var result = {};
      if (mod2 != null) {
        for (var k2 in mod2)
          if (Object.hasOwnProperty.call(mod2, k2))
            result[k2] = mod2[k2];
      }
      result["default"] = mod2;
      return result;
    };
    __importDefault2 = function(mod2) {
      return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
    };
    __classPrivateFieldGet = function(receiver, privateMap) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
      }
      return privateMap.get(receiver);
    };
    __classPrivateFieldSet = function(receiver, privateMap, value) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
      }
      privateMap.set(receiver, value);
      return value;
    };
    exporter("__extends", __extends);
    exporter("__assign", __assign2);
    exporter("__rest", __rest2);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault2);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
  });
})(tslib$6);
var crossPlatformSha1 = {};
var ie11Sha1 = {};
var isEmptyData$3 = {};
var hasRequiredIsEmptyData$2;
function requireIsEmptyData$2() {
  if (hasRequiredIsEmptyData$2)
    return isEmptyData$3;
  hasRequiredIsEmptyData$2 = 1;
  Object.defineProperty(isEmptyData$3, "__esModule", { value: true });
  isEmptyData$3.isEmptyData = void 0;
  function isEmptyData2(data2) {
    if (typeof data2 === "string") {
      return data2.length === 0;
    }
    return data2.byteLength === 0;
  }
  isEmptyData$3.isEmptyData = isEmptyData2;
  return isEmptyData$3;
}
var constants$9 = {};
var hasRequiredConstants$2;
function requireConstants$2() {
  if (hasRequiredConstants$2)
    return constants$9;
  hasRequiredConstants$2 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.EMPTY_DATA_SHA_1 = exports2.SHA_1_HMAC_ALGO = exports2.SHA_1_HASH = void 0;
    exports2.SHA_1_HASH = { name: "SHA-1" };
    exports2.SHA_1_HMAC_ALGO = {
      name: "HMAC",
      hash: exports2.SHA_1_HASH
    };
    exports2.EMPTY_DATA_SHA_1 = new Uint8Array([
      218,
      57,
      163,
      238,
      94,
      107,
      75,
      13,
      50,
      85,
      191,
      239,
      149,
      96,
      24,
      144,
      175,
      216,
      7,
      9
    ]);
  })(constants$9);
  return constants$9;
}
const fromUtf8$2 = (input) => {
  const bytes = [];
  for (let i2 = 0, len2 = input.length; i2 < len2; i2++) {
    const value = input.charCodeAt(i2);
    if (value < 128) {
      bytes.push(value);
    } else if (value < 2048) {
      bytes.push(value >> 6 | 192, value & 63 | 128);
    } else if (i2 + 1 < input.length && (value & 64512) === 55296 && (input.charCodeAt(i2 + 1) & 64512) === 56320) {
      const surrogatePair = 65536 + ((value & 1023) << 10) + (input.charCodeAt(++i2) & 1023);
      bytes.push(surrogatePair >> 18 | 240, surrogatePair >> 12 & 63 | 128, surrogatePair >> 6 & 63 | 128, surrogatePair & 63 | 128);
    } else {
      bytes.push(value >> 12 | 224, value >> 6 & 63 | 128, value & 63 | 128);
    }
  }
  return Uint8Array.from(bytes);
};
const toUtf8$2 = (input) => {
  let decoded = "";
  for (let i2 = 0, len2 = input.length; i2 < len2; i2++) {
    const byte = input[i2];
    if (byte < 128) {
      decoded += String.fromCharCode(byte);
    } else if (192 <= byte && byte < 224) {
      const nextByte = input[++i2];
      decoded += String.fromCharCode((byte & 31) << 6 | nextByte & 63);
    } else if (240 <= byte && byte < 365) {
      const surrogatePair = [byte, input[++i2], input[++i2], input[++i2]];
      const encoded = "%" + surrogatePair.map((byteValue) => byteValue.toString(16)).join("%");
      decoded += decodeURIComponent(encoded);
    } else {
      decoded += String.fromCharCode((byte & 15) << 12 | (input[++i2] & 63) << 6 | input[++i2] & 63);
    }
  }
  return decoded;
};
function fromUtf8$1(input) {
  return new TextEncoder().encode(input);
}
function toUtf8$1(input) {
  return new TextDecoder("utf-8").decode(input);
}
const fromUtf8 = (input) => typeof TextEncoder === "function" ? fromUtf8$1(input) : fromUtf8$2(input);
const toUtf8 = (input) => typeof TextDecoder === "function" ? toUtf8$1(input) : toUtf8$2(input);
const distEs$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fromUtf8,
  toUtf8
}, Symbol.toStringTag, { value: "Module" }));
const require$$2 = /* @__PURE__ */ getAugmentedNamespace(distEs$1);
const fallbackWindow = {};
function locateWindow() {
  if (typeof window !== "undefined") {
    return window;
  } else if (typeof self !== "undefined") {
    return self;
  }
  return fallbackWindow;
}
const distEs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  locateWindow
}, Symbol.toStringTag, { value: "Module" }));
const require$$5 = /* @__PURE__ */ getAugmentedNamespace(distEs);
var hasRequiredIe11Sha1;
function requireIe11Sha1() {
  if (hasRequiredIe11Sha1)
    return ie11Sha1;
  hasRequiredIe11Sha1 = 1;
  Object.defineProperty(ie11Sha1, "__esModule", { value: true });
  ie11Sha1.Sha1 = void 0;
  var isEmptyData_1 = requireIsEmptyData$2();
  var constants_1 = requireConstants$2();
  var util_utf8_browser_1 = require$$2;
  var util_locate_window_1 = require$$5;
  var Sha1 = (
    /** @class */
    function() {
      function Sha12(secret) {
        this.secret = secret;
        this.reset();
      }
      Sha12.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) {
          return;
        }
        this.operation = this.operation.then(function(operation) {
          operation.onerror = function() {
            _this.operation = Promise.reject(new Error("Error encountered updating hash"));
          };
          operation.process(toArrayBufferView(toHash));
          return operation;
        });
        this.operation.catch(function() {
        });
      };
      Sha12.prototype.digest = function() {
        return this.operation.then(function(operation) {
          return new Promise(function(resolve2, reject) {
            operation.onerror = function() {
              reject(new Error("Error encountered finalizing hash"));
            };
            operation.oncomplete = function() {
              if (operation.result) {
                resolve2(new Uint8Array(operation.result));
              }
              reject(new Error("Error encountered finalizing hash"));
            };
            operation.finish();
          });
        });
      };
      Sha12.prototype.reset = function() {
        if (this.secret) {
          this.operation = getKeyPromise(this.secret).then(function(keyData) {
            return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_1_HMAC_ALGO, keyData);
          });
          this.operation.catch(function() {
          });
        } else {
          this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-1"));
        }
      };
      return Sha12;
    }()
  );
  ie11Sha1.Sha1 = Sha1;
  function getKeyPromise(secret) {
    return new Promise(function(resolve2, reject) {
      var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_1_HMAC_ALGO, false, ["sign"]);
      keyOperation.oncomplete = function() {
        if (keyOperation.result) {
          resolve2(keyOperation.result);
        }
        reject(new Error("ImportKey completed without importing key."));
      };
      keyOperation.onerror = function() {
        reject(new Error("ImportKey failed to import key."));
      };
    });
  }
  function toArrayBufferView(data2) {
    if (typeof data2 === "string") {
      return (0, util_utf8_browser_1.fromUtf8)(data2);
    }
    if (ArrayBuffer.isView(data2)) {
      return new Uint8Array(data2.buffer, data2.byteOffset, data2.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data2);
  }
  return ie11Sha1;
}
var webCryptoSha1 = {};
var hasRequiredWebCryptoSha1;
function requireWebCryptoSha1() {
  if (hasRequiredWebCryptoSha1)
    return webCryptoSha1;
  hasRequiredWebCryptoSha1 = 1;
  Object.defineProperty(webCryptoSha1, "__esModule", { value: true });
  webCryptoSha1.Sha1 = void 0;
  var util_utf8_browser_1 = require$$2;
  var isEmptyData_1 = requireIsEmptyData$2();
  var constants_1 = requireConstants$2();
  var util_locate_window_1 = require$$5;
  var Sha1 = (
    /** @class */
    function() {
      function Sha12(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
          this.key = new Promise(function(resolve2, reject) {
            (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", convertToBuffer2(secret), constants_1.SHA_1_HMAC_ALGO, false, ["sign"]).then(resolve2, reject);
          });
          this.key.catch(function() {
          });
        }
      }
      Sha12.prototype.update = function(data2) {
        if ((0, isEmptyData_1.isEmptyData)(data2)) {
          return;
        }
        var update = convertToBuffer2(data2);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
      };
      Sha12.prototype.digest = function() {
        var _this = this;
        if (this.key) {
          return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_1_HMAC_ALGO, key, _this.toHash).then(function(data2) {
              return new Uint8Array(data2);
            });
          });
        }
        if ((0, isEmptyData_1.isEmptyData)(this.toHash)) {
          return Promise.resolve(constants_1.EMPTY_DATA_SHA_1);
        }
        return Promise.resolve().then(function() {
          return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_1_HASH, _this.toHash);
        }).then(function(data2) {
          return Promise.resolve(new Uint8Array(data2));
        });
      };
      Sha12.prototype.reset = function() {
        this.toHash = new Uint8Array(0);
      };
      return Sha12;
    }()
  );
  webCryptoSha1.Sha1 = Sha1;
  function convertToBuffer2(data2) {
    if (typeof data2 === "string") {
      return (0, util_utf8_browser_1.fromUtf8)(data2);
    }
    if (ArrayBuffer.isView(data2)) {
      return new Uint8Array(data2.buffer, data2.byteOffset, data2.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data2);
  }
  return webCryptoSha1;
}
var build$6 = {};
var tslibExports$5 = {};
var tslib$5 = {
  get exports() {
    return tslibExports$5;
  },
  set exports(v5) {
    tslibExports$5 = v5;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var hasRequiredTslib$2;
function requireTslib$2() {
  if (hasRequiredTslib$2)
    return tslibExports$5;
  hasRequiredTslib$2 = 1;
  (function(module2) {
    var __extends;
    var __assign2;
    var __rest2;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter;
    var __generator;
    var __exportStar;
    var __values;
    var __read;
    var __spread;
    var __spreadArrays;
    var __await;
    var __asyncGenerator;
    var __asyncDelegator;
    var __asyncValues;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault2;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory) {
      var root2 = typeof commonjsGlobal$1 === "object" ? commonjsGlobal$1 : typeof self === "object" ? self : typeof this === "object" ? this : {};
      {
        factory(createExporter(root2, createExporter(module2.exports)));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root2) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v5) {
          return exports2[id] = previous ? previous(id, v5) : v5;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends = function(d2, b2) {
        extendStatics(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign2 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest2 = function(s2, e3) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve2) {
            resolve2(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve2, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e3) {
              reject(e3);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e3) {
              reject(e3);
            }
          }
          function step(result) {
            result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v5) {
            return step([n2, v5]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e3) {
              op = [6, e3];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar2 = [], e3;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar2.push(r2.value);
        } catch (error2) {
          e3 = { error: error2 };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e3)
              throw e3.error;
          }
        }
        return ar2;
      };
      __spread = function() {
        for (var ar2 = [], i2 = 0; i2 < arguments.length; i2++)
          ar2 = ar2.concat(__read(arguments[i2]));
        return ar2;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await = function(v5) {
        return this instanceof __await ? (this.v = v5, this) : new __await(v5);
      };
      __asyncGenerator = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v5) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v5, a2, b2]) > 1 || resume(n2, v5);
              });
            };
        }
        function resume(n2, v5) {
          try {
            step(g2[n2](v5));
          } catch (e3) {
            settle(q2[0][3], e3);
          }
        }
        function step(r2) {
          r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v5) {
          if (f2(v5), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e3) {
          throw e3;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v5) {
            return (p2 = !p2) ? { value: __await(o2[n2](v5)), done: n2 === "return" } : f2 ? f2(v5) : v5;
          } : f2;
        }
      };
      __asyncValues = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values === "function" ? __values(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v5) {
            return new Promise(function(resolve2, reject) {
              v5 = o2[n2](v5), settle(resolve2, reject, v5.done, v5.value);
            });
          };
        }
        function settle(resolve2, reject, d2, v5) {
          Promise.resolve(v5).then(function(v6) {
            resolve2({ value: v6, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod2) {
        if (mod2 && mod2.__esModule)
          return mod2;
        var result = {};
        if (mod2 != null) {
          for (var k2 in mod2)
            if (Object.hasOwnProperty.call(mod2, k2))
              result[k2] = mod2[k2];
        }
        result["default"] = mod2;
        return result;
      };
      __importDefault2 = function(mod2) {
        return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter);
      exporter("__generator", __generator);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values);
      exporter("__read", __read);
      exporter("__spread", __spread);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await);
      exporter("__asyncGenerator", __asyncGenerator);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  })(tslib$5);
  return tslibExports$5;
}
var supportsWebCrypto = {};
var hasRequiredSupportsWebCrypto;
function requireSupportsWebCrypto() {
  if (hasRequiredSupportsWebCrypto)
    return supportsWebCrypto;
  hasRequiredSupportsWebCrypto = 1;
  Object.defineProperty(supportsWebCrypto, "__esModule", { value: true });
  supportsWebCrypto.supportsZeroByteGCM = supportsWebCrypto.supportsSubtleCrypto = supportsWebCrypto.supportsSecureRandom = supportsWebCrypto.supportsWebCrypto = void 0;
  var tslib_1 = requireTslib$2();
  var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
  ];
  function supportsWebCrypto$1(window2) {
    if (supportsSecureRandom(window2) && typeof window2.crypto.subtle === "object") {
      var subtle = window2.crypto.subtle;
      return supportsSubtleCrypto(subtle);
    }
    return false;
  }
  supportsWebCrypto.supportsWebCrypto = supportsWebCrypto$1;
  function supportsSecureRandom(window2) {
    if (typeof window2 === "object" && typeof window2.crypto === "object") {
      var getRandomValues2 = window2.crypto.getRandomValues;
      return typeof getRandomValues2 === "function";
    }
    return false;
  }
  supportsWebCrypto.supportsSecureRandom = supportsSecureRandom;
  function supportsSubtleCrypto(subtle) {
    return subtle && subtleCryptoMethods.every(function(methodName) {
      return typeof subtle[methodName] === "function";
    });
  }
  supportsWebCrypto.supportsSubtleCrypto = supportsSubtleCrypto;
  function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function() {
      var key, zeroByteAuthTag;
      return tslib_1.__generator(this, function(_b3) {
        switch (_b3.label) {
          case 0:
            if (!supportsSubtleCrypto(subtle))
              return [2, false];
            _b3.label = 1;
          case 1:
            _b3.trys.push([1, 4, , 5]);
            return [4, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
          case 2:
            key = _b3.sent();
            return [4, subtle.encrypt({
              name: "AES-GCM",
              iv: new Uint8Array(Array(12)),
              additionalData: new Uint8Array(Array(16)),
              tagLength: 128
            }, key, new Uint8Array(0))];
          case 3:
            zeroByteAuthTag = _b3.sent();
            return [2, zeroByteAuthTag.byteLength === 16];
          case 4:
            _b3.sent();
            return [2, false];
          case 5:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  supportsWebCrypto.supportsZeroByteGCM = supportsZeroByteGCM;
  return supportsWebCrypto;
}
var hasRequiredBuild$5;
function requireBuild$5() {
  if (hasRequiredBuild$5)
    return build$6;
  hasRequiredBuild$5 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    var tslib_1 = requireTslib$2();
    tslib_1.__exportStar(requireSupportsWebCrypto(), exports2);
  })(build$6);
  return build$6;
}
var build$5 = {};
var tslibExports$4 = {};
var tslib$4 = {
  get exports() {
    return tslibExports$4;
  },
  set exports(v5) {
    tslibExports$4 = v5;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var hasRequiredTslib$1;
function requireTslib$1() {
  if (hasRequiredTslib$1)
    return tslibExports$4;
  hasRequiredTslib$1 = 1;
  (function(module2) {
    var __extends;
    var __assign2;
    var __rest2;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter;
    var __generator;
    var __exportStar;
    var __values;
    var __read;
    var __spread;
    var __spreadArrays;
    var __await;
    var __asyncGenerator;
    var __asyncDelegator;
    var __asyncValues;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault2;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory) {
      var root2 = typeof commonjsGlobal$1 === "object" ? commonjsGlobal$1 : typeof self === "object" ? self : typeof this === "object" ? this : {};
      {
        factory(createExporter(root2, createExporter(module2.exports)));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root2) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v5) {
          return exports2[id] = previous ? previous(id, v5) : v5;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends = function(d2, b2) {
        extendStatics(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign2 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest2 = function(s2, e3) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve2) {
            resolve2(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve2, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e3) {
              reject(e3);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e3) {
              reject(e3);
            }
          }
          function step(result) {
            result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v5) {
            return step([n2, v5]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e3) {
              op = [6, e3];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar2 = [], e3;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar2.push(r2.value);
        } catch (error2) {
          e3 = { error: error2 };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e3)
              throw e3.error;
          }
        }
        return ar2;
      };
      __spread = function() {
        for (var ar2 = [], i2 = 0; i2 < arguments.length; i2++)
          ar2 = ar2.concat(__read(arguments[i2]));
        return ar2;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await = function(v5) {
        return this instanceof __await ? (this.v = v5, this) : new __await(v5);
      };
      __asyncGenerator = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v5) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v5, a2, b2]) > 1 || resume(n2, v5);
              });
            };
        }
        function resume(n2, v5) {
          try {
            step(g2[n2](v5));
          } catch (e3) {
            settle(q2[0][3], e3);
          }
        }
        function step(r2) {
          r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v5) {
          if (f2(v5), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e3) {
          throw e3;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v5) {
            return (p2 = !p2) ? { value: __await(o2[n2](v5)), done: n2 === "return" } : f2 ? f2(v5) : v5;
          } : f2;
        }
      };
      __asyncValues = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values === "function" ? __values(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v5) {
            return new Promise(function(resolve2, reject) {
              v5 = o2[n2](v5), settle(resolve2, reject, v5.done, v5.value);
            });
          };
        }
        function settle(resolve2, reject, d2, v5) {
          Promise.resolve(v5).then(function(v6) {
            resolve2({ value: v6, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod2) {
        if (mod2 && mod2.__esModule)
          return mod2;
        var result = {};
        if (mod2 != null) {
          for (var k2 in mod2)
            if (Object.hasOwnProperty.call(mod2, k2))
              result[k2] = mod2[k2];
        }
        result["default"] = mod2;
        return result;
      };
      __importDefault2 = function(mod2) {
        return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter);
      exporter("__generator", __generator);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values);
      exporter("__read", __read);
      exporter("__spread", __spread);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await);
      exporter("__asyncGenerator", __asyncGenerator);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  })(tslib$4);
  return tslibExports$4;
}
var CryptoOperation = {};
var hasRequiredCryptoOperation;
function requireCryptoOperation() {
  if (hasRequiredCryptoOperation)
    return CryptoOperation;
  hasRequiredCryptoOperation = 1;
  Object.defineProperty(CryptoOperation, "__esModule", { value: true });
  return CryptoOperation;
}
var Key = {};
var hasRequiredKey;
function requireKey() {
  if (hasRequiredKey)
    return Key;
  hasRequiredKey = 1;
  Object.defineProperty(Key, "__esModule", { value: true });
  return Key;
}
var KeyOperation = {};
var hasRequiredKeyOperation;
function requireKeyOperation() {
  if (hasRequiredKeyOperation)
    return KeyOperation;
  hasRequiredKeyOperation = 1;
  Object.defineProperty(KeyOperation, "__esModule", { value: true });
  return KeyOperation;
}
var MsSubtleCrypto = {};
var hasRequiredMsSubtleCrypto;
function requireMsSubtleCrypto() {
  if (hasRequiredMsSubtleCrypto)
    return MsSubtleCrypto;
  hasRequiredMsSubtleCrypto = 1;
  Object.defineProperty(MsSubtleCrypto, "__esModule", { value: true });
  return MsSubtleCrypto;
}
var MsWindow = {};
var hasRequiredMsWindow;
function requireMsWindow() {
  if (hasRequiredMsWindow)
    return MsWindow;
  hasRequiredMsWindow = 1;
  Object.defineProperty(MsWindow, "__esModule", { value: true });
  MsWindow.isMsWindow = void 0;
  var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
  ];
  function quacksLikeAnMsWindow(window2) {
    return "MSInputMethodContext" in window2 && "msCrypto" in window2;
  }
  function isMsWindow(window2) {
    if (quacksLikeAnMsWindow(window2) && window2.msCrypto.subtle !== void 0) {
      var _a3 = window2.msCrypto, getRandomValues2 = _a3.getRandomValues, subtle_1 = _a3.subtle;
      return msSubtleCryptoMethods.map(function(methodName) {
        return subtle_1[methodName];
      }).concat(getRandomValues2).every(function(method) {
        return typeof method === "function";
      });
    }
    return false;
  }
  MsWindow.isMsWindow = isMsWindow;
  return MsWindow;
}
var hasRequiredBuild$4;
function requireBuild$4() {
  if (hasRequiredBuild$4)
    return build$5;
  hasRequiredBuild$4 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    var tslib_1 = requireTslib$1();
    tslib_1.__exportStar(requireCryptoOperation(), exports2);
    tslib_1.__exportStar(requireKey(), exports2);
    tslib_1.__exportStar(requireKeyOperation(), exports2);
    tslib_1.__exportStar(requireMsSubtleCrypto(), exports2);
    tslib_1.__exportStar(requireMsWindow(), exports2);
  })(build$5);
  return build$5;
}
var build$4 = {};
var convertToBuffer$1 = {};
var hasRequiredConvertToBuffer;
function requireConvertToBuffer() {
  if (hasRequiredConvertToBuffer)
    return convertToBuffer$1;
  hasRequiredConvertToBuffer = 1;
  Object.defineProperty(convertToBuffer$1, "__esModule", { value: true });
  convertToBuffer$1.convertToBuffer = void 0;
  var util_utf8_browser_1 = require$$2;
  var fromUtf82 = typeof Buffer !== "undefined" && Buffer.from ? function(input) {
    return Buffer.from(input, "utf8");
  } : util_utf8_browser_1.fromUtf8;
  function convertToBuffer2(data2) {
    if (data2 instanceof Uint8Array)
      return data2;
    if (typeof data2 === "string") {
      return fromUtf82(data2);
    }
    if (ArrayBuffer.isView(data2)) {
      return new Uint8Array(data2.buffer, data2.byteOffset, data2.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data2);
  }
  convertToBuffer$1.convertToBuffer = convertToBuffer2;
  return convertToBuffer$1;
}
var isEmptyData$2 = {};
var hasRequiredIsEmptyData$1;
function requireIsEmptyData$1() {
  if (hasRequiredIsEmptyData$1)
    return isEmptyData$2;
  hasRequiredIsEmptyData$1 = 1;
  Object.defineProperty(isEmptyData$2, "__esModule", { value: true });
  isEmptyData$2.isEmptyData = void 0;
  function isEmptyData2(data2) {
    if (typeof data2 === "string") {
      return data2.length === 0;
    }
    return data2.byteLength === 0;
  }
  isEmptyData$2.isEmptyData = isEmptyData2;
  return isEmptyData$2;
}
var numToUint8 = {};
var hasRequiredNumToUint8;
function requireNumToUint8() {
  if (hasRequiredNumToUint8)
    return numToUint8;
  hasRequiredNumToUint8 = 1;
  Object.defineProperty(numToUint8, "__esModule", { value: true });
  numToUint8.numToUint8 = void 0;
  function numToUint8$1(num) {
    return new Uint8Array([
      (num & 4278190080) >> 24,
      (num & 16711680) >> 16,
      (num & 65280) >> 8,
      num & 255
    ]);
  }
  numToUint8.numToUint8 = numToUint8$1;
  return numToUint8;
}
var uint32ArrayFrom = {};
var hasRequiredUint32ArrayFrom;
function requireUint32ArrayFrom() {
  if (hasRequiredUint32ArrayFrom)
    return uint32ArrayFrom;
  hasRequiredUint32ArrayFrom = 1;
  Object.defineProperty(uint32ArrayFrom, "__esModule", { value: true });
  uint32ArrayFrom.uint32ArrayFrom = void 0;
  function uint32ArrayFrom$1(a_lookUpTable) {
    if (!Uint32Array.from) {
      var return_array = new Uint32Array(a_lookUpTable.length);
      var a_index = 0;
      while (a_index < a_lookUpTable.length) {
        return_array[a_index] = a_lookUpTable[a_index];
        a_index += 1;
      }
      return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
  }
  uint32ArrayFrom.uint32ArrayFrom = uint32ArrayFrom$1;
  return uint32ArrayFrom;
}
var hasRequiredBuild$3;
function requireBuild$3() {
  if (hasRequiredBuild$3)
    return build$4;
  hasRequiredBuild$3 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.uint32ArrayFrom = exports2.numToUint8 = exports2.isEmptyData = exports2.convertToBuffer = void 0;
    var convertToBuffer_1 = requireConvertToBuffer();
    Object.defineProperty(exports2, "convertToBuffer", { enumerable: true, get: function() {
      return convertToBuffer_1.convertToBuffer;
    } });
    var isEmptyData_1 = requireIsEmptyData$1();
    Object.defineProperty(exports2, "isEmptyData", { enumerable: true, get: function() {
      return isEmptyData_1.isEmptyData;
    } });
    var numToUint8_1 = requireNumToUint8();
    Object.defineProperty(exports2, "numToUint8", { enumerable: true, get: function() {
      return numToUint8_1.numToUint8;
    } });
    var uint32ArrayFrom_1 = requireUint32ArrayFrom();
    Object.defineProperty(exports2, "uint32ArrayFrom", { enumerable: true, get: function() {
      return uint32ArrayFrom_1.uint32ArrayFrom;
    } });
  })(build$4);
  return build$4;
}
var hasRequiredCrossPlatformSha1;
function requireCrossPlatformSha1() {
  if (hasRequiredCrossPlatformSha1)
    return crossPlatformSha1;
  hasRequiredCrossPlatformSha1 = 1;
  Object.defineProperty(crossPlatformSha1, "__esModule", { value: true });
  crossPlatformSha1.Sha1 = void 0;
  var ie11Sha1_1 = requireIe11Sha1();
  var webCryptoSha1_1 = requireWebCryptoSha1();
  var supports_web_crypto_1 = requireBuild$5();
  var ie11_detection_1 = requireBuild$4();
  var util_locate_window_1 = require$$5;
  var util_1 = requireBuild$3();
  var Sha1 = (
    /** @class */
    function() {
      function Sha12(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
          this.hash = new webCryptoSha1_1.Sha1(secret);
        } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
          this.hash = new ie11Sha1_1.Sha1(secret);
        } else {
          throw new Error("SHA1 not supported");
        }
      }
      Sha12.prototype.update = function(data2, encoding) {
        this.hash.update((0, util_1.convertToBuffer)(data2));
      };
      Sha12.prototype.digest = function() {
        return this.hash.digest();
      };
      Sha12.prototype.reset = function() {
        this.hash.reset();
      };
      return Sha12;
    }()
  );
  crossPlatformSha1.Sha1 = Sha1;
  return crossPlatformSha1;
}
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", { value: true });
  exports2.WebCryptoSha1 = exports2.Ie11Sha1 = void 0;
  var tslib_1 = tslibExports$6;
  tslib_1.__exportStar(requireCrossPlatformSha1(), exports2);
  var ie11Sha1_1 = requireIe11Sha1();
  Object.defineProperty(exports2, "Ie11Sha1", { enumerable: true, get: function() {
    return ie11Sha1_1.Sha1;
  } });
  var webCryptoSha1_1 = requireWebCryptoSha1();
  Object.defineProperty(exports2, "WebCryptoSha1", { enumerable: true, get: function() {
    return webCryptoSha1_1.Sha1;
  } });
})(build$7);
var build$3 = {};
var tslibExports$3 = {};
var tslib$3 = {
  get exports() {
    return tslibExports$3;
  },
  set exports(v5) {
    tslibExports$3 = v5;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
(function(module2) {
  var __extends;
  var __assign2;
  var __rest2;
  var __decorate;
  var __param;
  var __metadata;
  var __awaiter;
  var __generator;
  var __exportStar;
  var __values;
  var __read;
  var __spread;
  var __spreadArrays;
  var __await;
  var __asyncGenerator;
  var __asyncDelegator;
  var __asyncValues;
  var __makeTemplateObject;
  var __importStar;
  var __importDefault2;
  var __classPrivateFieldGet;
  var __classPrivateFieldSet;
  var __createBinding;
  (function(factory) {
    var root2 = typeof commonjsGlobal$1 === "object" ? commonjsGlobal$1 : typeof self === "object" ? self : typeof this === "object" ? this : {};
    {
      factory(createExporter(root2, createExporter(module2.exports)));
    }
    function createExporter(exports2, previous) {
      if (exports2 !== root2) {
        if (typeof Object.create === "function") {
          Object.defineProperty(exports2, "__esModule", { value: true });
        } else {
          exports2.__esModule = true;
        }
      }
      return function(id, v5) {
        return exports2[id] = previous ? previous(id, v5) : v5;
      };
    }
  })(function(exporter) {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p2 in b2)
        if (b2.hasOwnProperty(p2))
          d2[p2] = b2[p2];
    };
    __extends = function(d2, b2) {
      extendStatics(d2, b2);
      function __() {
        this.constructor = d2;
      }
      d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
    __assign2 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    __rest2 = function(s2, e3) {
      var t2 = {};
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
          t2[p2] = s2[p2];
      if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
          if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
            t2[p2[i2]] = s2[p2[i2]];
        }
      return t2;
    };
    __decorate = function(decorators, target, key, desc) {
      var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r2 = Reflect.decorate(decorators, target, key, desc);
      else
        for (var i2 = decorators.length - 1; i2 >= 0; i2--)
          if (d2 = decorators[i2])
            r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
      return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
    };
    __param = function(paramIndex, decorator) {
      return function(target, key) {
        decorator(target, key, paramIndex);
      };
    };
    __metadata = function(metadataKey, metadataValue) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(metadataKey, metadataValue);
    };
    __awaiter = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e3) {
            reject(e3);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e3) {
            reject(e3);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    __generator = function(thisArg, body) {
      var _2 = { label: 0, sent: function() {
        if (t2[0] & 1)
          throw t2[1];
        return t2[1];
      }, trys: [], ops: [] }, f2, y2, t2, g2;
      return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
        return this;
      }), g2;
      function verb(n2) {
        return function(v5) {
          return step([n2, v5]);
        };
      }
      function step(op) {
        if (f2)
          throw new TypeError("Generator is already executing.");
        while (_2)
          try {
            if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
              return t2;
            if (y2 = 0, t2)
              op = [op[0] & 2, t2.value];
            switch (op[0]) {
              case 0:
              case 1:
                t2 = op;
                break;
              case 4:
                _2.label++;
                return { value: op[1], done: false };
              case 5:
                _2.label++;
                y2 = op[1];
                op = [0];
                continue;
              case 7:
                op = _2.ops.pop();
                _2.trys.pop();
                continue;
              default:
                if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _2 = 0;
                  continue;
                }
                if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                  _2.label = op[1];
                  break;
                }
                if (op[0] === 6 && _2.label < t2[1]) {
                  _2.label = t2[1];
                  t2 = op;
                  break;
                }
                if (t2 && _2.label < t2[2]) {
                  _2.label = t2[2];
                  _2.ops.push(op);
                  break;
                }
                if (t2[2])
                  _2.ops.pop();
                _2.trys.pop();
                continue;
            }
            op = body.call(thisArg, _2);
          } catch (e3) {
            op = [6, e3];
            y2 = 0;
          } finally {
            f2 = t2 = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    __createBinding = function(o2, m2, k2, k22) {
      if (k22 === void 0)
        k22 = k2;
      o2[k22] = m2[k2];
    };
    __exportStar = function(m2, exports2) {
      for (var p2 in m2)
        if (p2 !== "default" && !exports2.hasOwnProperty(p2))
          exports2[p2] = m2[p2];
    };
    __values = function(o2) {
      var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
      if (m2)
        return m2.call(o2);
      if (o2 && typeof o2.length === "number")
        return {
          next: function() {
            if (o2 && i2 >= o2.length)
              o2 = void 0;
            return { value: o2 && o2[i2++], done: !o2 };
          }
        };
      throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    __read = function(o2, n2) {
      var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
      if (!m2)
        return o2;
      var i2 = m2.call(o2), r2, ar2 = [], e3;
      try {
        while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
          ar2.push(r2.value);
      } catch (error2) {
        e3 = { error: error2 };
      } finally {
        try {
          if (r2 && !r2.done && (m2 = i2["return"]))
            m2.call(i2);
        } finally {
          if (e3)
            throw e3.error;
        }
      }
      return ar2;
    };
    __spread = function() {
      for (var ar2 = [], i2 = 0; i2 < arguments.length; i2++)
        ar2 = ar2.concat(__read(arguments[i2]));
      return ar2;
    };
    __spreadArrays = function() {
      for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
        s2 += arguments[i2].length;
      for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
        for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
          r2[k2] = a2[j2];
      return r2;
    };
    __await = function(v5) {
      return this instanceof __await ? (this.v = v5, this) : new __await(v5);
    };
    __asyncGenerator = function(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
      return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2;
      function verb(n2) {
        if (g2[n2])
          i2[n2] = function(v5) {
            return new Promise(function(a2, b2) {
              q2.push([n2, v5, a2, b2]) > 1 || resume(n2, v5);
            });
          };
      }
      function resume(n2, v5) {
        try {
          step(g2[n2](v5));
        } catch (e3) {
          settle(q2[0][3], e3);
        }
      }
      function step(r2) {
        r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
      }
      function fulfill(value) {
        resume("next", value);
      }
      function reject(value) {
        resume("throw", value);
      }
      function settle(f2, v5) {
        if (f2(v5), q2.shift(), q2.length)
          resume(q2[0][0], q2[0][1]);
      }
    };
    __asyncDelegator = function(o2) {
      var i2, p2;
      return i2 = {}, verb("next"), verb("throw", function(e3) {
        throw e3;
      }), verb("return"), i2[Symbol.iterator] = function() {
        return this;
      }, i2;
      function verb(n2, f2) {
        i2[n2] = o2[n2] ? function(v5) {
          return (p2 = !p2) ? { value: __await(o2[n2](v5)), done: n2 === "return" } : f2 ? f2(v5) : v5;
        } : f2;
      }
    };
    __asyncValues = function(o2) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var m2 = o2[Symbol.asyncIterator], i2;
      return m2 ? m2.call(o2) : (o2 = typeof __values === "function" ? __values(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2);
      function verb(n2) {
        i2[n2] = o2[n2] && function(v5) {
          return new Promise(function(resolve2, reject) {
            v5 = o2[n2](v5), settle(resolve2, reject, v5.done, v5.value);
          });
        };
      }
      function settle(resolve2, reject, d2, v5) {
        Promise.resolve(v5).then(function(v6) {
          resolve2({ value: v6, done: d2 });
        }, reject);
      }
    };
    __makeTemplateObject = function(cooked, raw) {
      if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
      } else {
        cooked.raw = raw;
      }
      return cooked;
    };
    __importStar = function(mod2) {
      if (mod2 && mod2.__esModule)
        return mod2;
      var result = {};
      if (mod2 != null) {
        for (var k2 in mod2)
          if (Object.hasOwnProperty.call(mod2, k2))
            result[k2] = mod2[k2];
      }
      result["default"] = mod2;
      return result;
    };
    __importDefault2 = function(mod2) {
      return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
    };
    __classPrivateFieldGet = function(receiver, privateMap) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
      }
      return privateMap.get(receiver);
    };
    __classPrivateFieldSet = function(receiver, privateMap, value) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
      }
      privateMap.set(receiver, value);
      return value;
    };
    exporter("__extends", __extends);
    exporter("__assign", __assign2);
    exporter("__rest", __rest2);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault2);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
  });
})(tslib$3);
var crossPlatformSha256 = {};
var ie11Sha256 = {};
var isEmptyData$1 = {};
var hasRequiredIsEmptyData;
function requireIsEmptyData() {
  if (hasRequiredIsEmptyData)
    return isEmptyData$1;
  hasRequiredIsEmptyData = 1;
  Object.defineProperty(isEmptyData$1, "__esModule", { value: true });
  isEmptyData$1.isEmptyData = void 0;
  function isEmptyData2(data2) {
    if (typeof data2 === "string") {
      return data2.length === 0;
    }
    return data2.byteLength === 0;
  }
  isEmptyData$1.isEmptyData = isEmptyData2;
  return isEmptyData$1;
}
var constants$8 = {};
var hasRequiredConstants$1;
function requireConstants$1() {
  if (hasRequiredConstants$1)
    return constants$8;
  hasRequiredConstants$1 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.EMPTY_DATA_SHA_256 = exports2.SHA_256_HMAC_ALGO = exports2.SHA_256_HASH = void 0;
    exports2.SHA_256_HASH = { name: "SHA-256" };
    exports2.SHA_256_HMAC_ALGO = {
      name: "HMAC",
      hash: exports2.SHA_256_HASH
    };
    exports2.EMPTY_DATA_SHA_256 = new Uint8Array([
      227,
      176,
      196,
      66,
      152,
      252,
      28,
      20,
      154,
      251,
      244,
      200,
      153,
      111,
      185,
      36,
      39,
      174,
      65,
      228,
      100,
      155,
      147,
      76,
      164,
      149,
      153,
      27,
      120,
      82,
      184,
      85
    ]);
  })(constants$8);
  return constants$8;
}
var hasRequiredIe11Sha256;
function requireIe11Sha256() {
  if (hasRequiredIe11Sha256)
    return ie11Sha256;
  hasRequiredIe11Sha256 = 1;
  Object.defineProperty(ie11Sha256, "__esModule", { value: true });
  ie11Sha256.Sha256 = void 0;
  var isEmptyData_1 = requireIsEmptyData();
  var constants_1 = requireConstants$1();
  var util_utf8_browser_1 = require$$2;
  var util_locate_window_1 = require$$5;
  var Sha256 = (
    /** @class */
    function() {
      function Sha2562(secret) {
        this.secret = secret;
        this.reset();
      }
      Sha2562.prototype.update = function(toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) {
          return;
        }
        this.operation = this.operation.then(function(operation) {
          operation.onerror = function() {
            _this.operation = Promise.reject(new Error("Error encountered updating hash"));
          };
          operation.process(toArrayBufferView(toHash));
          return operation;
        });
        this.operation.catch(function() {
        });
      };
      Sha2562.prototype.digest = function() {
        return this.operation.then(function(operation) {
          return new Promise(function(resolve2, reject) {
            operation.onerror = function() {
              reject(new Error("Error encountered finalizing hash"));
            };
            operation.oncomplete = function() {
              if (operation.result) {
                resolve2(new Uint8Array(operation.result));
              }
              reject(new Error("Error encountered finalizing hash"));
            };
            operation.finish();
          });
        });
      };
      Sha2562.prototype.reset = function() {
        if (this.secret) {
          this.operation = getKeyPromise(this.secret).then(function(keyData) {
            return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
          });
          this.operation.catch(function() {
          });
        } else {
          this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
        }
      };
      return Sha2562;
    }()
  );
  ie11Sha256.Sha256 = Sha256;
  function getKeyPromise(secret) {
    return new Promise(function(resolve2, reject) {
      var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
      keyOperation.oncomplete = function() {
        if (keyOperation.result) {
          resolve2(keyOperation.result);
        }
        reject(new Error("ImportKey completed without importing key."));
      };
      keyOperation.onerror = function() {
        reject(new Error("ImportKey failed to import key."));
      };
    });
  }
  function toArrayBufferView(data2) {
    if (typeof data2 === "string") {
      return (0, util_utf8_browser_1.fromUtf8)(data2);
    }
    if (ArrayBuffer.isView(data2)) {
      return new Uint8Array(data2.buffer, data2.byteOffset, data2.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data2);
  }
  return ie11Sha256;
}
var webCryptoSha256 = {};
var hasRequiredWebCryptoSha256;
function requireWebCryptoSha256() {
  if (hasRequiredWebCryptoSha256)
    return webCryptoSha256;
  hasRequiredWebCryptoSha256 = 1;
  Object.defineProperty(webCryptoSha256, "__esModule", { value: true });
  webCryptoSha256.Sha256 = void 0;
  var util_1 = requireBuild$3();
  var constants_1 = requireConstants$1();
  var util_locate_window_1 = require$$5;
  var Sha256 = (
    /** @class */
    function() {
      function Sha2562(secret) {
        this.toHash = new Uint8Array(0);
        this.secret = secret;
        this.reset();
      }
      Sha2562.prototype.update = function(data2) {
        if ((0, util_1.isEmptyData)(data2)) {
          return;
        }
        var update = (0, util_1.convertToBuffer)(data2);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
      };
      Sha2562.prototype.digest = function() {
        var _this = this;
        if (this.key) {
          return this.key.then(function(key) {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash).then(function(data2) {
              return new Uint8Array(data2);
            });
          });
        }
        if ((0, util_1.isEmptyData)(this.toHash)) {
          return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        }
        return Promise.resolve().then(function() {
          return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        }).then(function(data2) {
          return Promise.resolve(new Uint8Array(data2));
        });
      };
      Sha2562.prototype.reset = function() {
        var _this = this;
        this.toHash = new Uint8Array(0);
        if (this.secret && this.secret !== void 0) {
          this.key = new Promise(function(resolve2, reject) {
            (0, util_locate_window_1.locateWindow)().crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(_this.secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]).then(resolve2, reject);
          });
          this.key.catch(function() {
          });
        }
      };
      return Sha2562;
    }()
  );
  webCryptoSha256.Sha256 = Sha256;
  return webCryptoSha256;
}
var build$2 = {};
var tslibExports$2 = {};
var tslib$2 = {
  get exports() {
    return tslibExports$2;
  },
  set exports(v5) {
    tslibExports$2 = v5;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var hasRequiredTslib;
function requireTslib() {
  if (hasRequiredTslib)
    return tslibExports$2;
  hasRequiredTslib = 1;
  (function(module2) {
    var __extends;
    var __assign2;
    var __rest2;
    var __decorate;
    var __param;
    var __metadata;
    var __awaiter;
    var __generator;
    var __exportStar;
    var __values;
    var __read;
    var __spread;
    var __spreadArrays;
    var __await;
    var __asyncGenerator;
    var __asyncDelegator;
    var __asyncValues;
    var __makeTemplateObject;
    var __importStar;
    var __importDefault2;
    var __classPrivateFieldGet;
    var __classPrivateFieldSet;
    var __createBinding;
    (function(factory) {
      var root2 = typeof commonjsGlobal$1 === "object" ? commonjsGlobal$1 : typeof self === "object" ? self : typeof this === "object" ? this : {};
      {
        factory(createExporter(root2, createExporter(module2.exports)));
      }
      function createExporter(exports2, previous) {
        if (exports2 !== root2) {
          if (typeof Object.create === "function") {
            Object.defineProperty(exports2, "__esModule", { value: true });
          } else {
            exports2.__esModule = true;
          }
        }
        return function(id, v5) {
          return exports2[id] = previous ? previous(id, v5) : v5;
        };
      }
    })(function(exporter) {
      var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
        d2.__proto__ = b2;
      } || function(d2, b2) {
        for (var p2 in b2)
          if (b2.hasOwnProperty(p2))
            d2[p2] = b2[p2];
      };
      __extends = function(d2, b2) {
        extendStatics(d2, b2);
        function __() {
          this.constructor = d2;
        }
        d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
      };
      __assign2 = Object.assign || function(t2) {
        for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
          s2 = arguments[i2];
          for (var p2 in s2)
            if (Object.prototype.hasOwnProperty.call(s2, p2))
              t2[p2] = s2[p2];
        }
        return t2;
      };
      __rest2 = function(s2, e3) {
        var t2 = {};
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
            t2[p2] = s2[p2];
        if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
            if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
              t2[p2[i2]] = s2[p2[i2]];
          }
        return t2;
      };
      __decorate = function(decorators, target, key, desc) {
        var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
          r2 = Reflect.decorate(decorators, target, key, desc);
        else
          for (var i2 = decorators.length - 1; i2 >= 0; i2--)
            if (d2 = decorators[i2])
              r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
        return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
      };
      __param = function(paramIndex, decorator) {
        return function(target, key) {
          decorator(target, key, paramIndex);
        };
      };
      __metadata = function(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
          return Reflect.metadata(metadataKey, metadataValue);
      };
      __awaiter = function(thisArg, _arguments, P2, generator) {
        function adopt(value) {
          return value instanceof P2 ? value : new P2(function(resolve2) {
            resolve2(value);
          });
        }
        return new (P2 || (P2 = Promise))(function(resolve2, reject) {
          function fulfilled(value) {
            try {
              step(generator.next(value));
            } catch (e3) {
              reject(e3);
            }
          }
          function rejected(value) {
            try {
              step(generator["throw"](value));
            } catch (e3) {
              reject(e3);
            }
          }
          function step(result) {
            result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
          }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
      };
      __generator = function(thisArg, body) {
        var _2 = { label: 0, sent: function() {
          if (t2[0] & 1)
            throw t2[1];
          return t2[1];
        }, trys: [], ops: [] }, f2, y2, t2, g2;
        return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
          return this;
        }), g2;
        function verb(n2) {
          return function(v5) {
            return step([n2, v5]);
          };
        }
        function step(op) {
          if (f2)
            throw new TypeError("Generator is already executing.");
          while (_2)
            try {
              if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
                return t2;
              if (y2 = 0, t2)
                op = [op[0] & 2, t2.value];
              switch (op[0]) {
                case 0:
                case 1:
                  t2 = op;
                  break;
                case 4:
                  _2.label++;
                  return { value: op[1], done: false };
                case 5:
                  _2.label++;
                  y2 = op[1];
                  op = [0];
                  continue;
                case 7:
                  op = _2.ops.pop();
                  _2.trys.pop();
                  continue;
                default:
                  if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                    _2 = 0;
                    continue;
                  }
                  if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                    _2.label = op[1];
                    break;
                  }
                  if (op[0] === 6 && _2.label < t2[1]) {
                    _2.label = t2[1];
                    t2 = op;
                    break;
                  }
                  if (t2 && _2.label < t2[2]) {
                    _2.label = t2[2];
                    _2.ops.push(op);
                    break;
                  }
                  if (t2[2])
                    _2.ops.pop();
                  _2.trys.pop();
                  continue;
              }
              op = body.call(thisArg, _2);
            } catch (e3) {
              op = [6, e3];
              y2 = 0;
            } finally {
              f2 = t2 = 0;
            }
          if (op[0] & 5)
            throw op[1];
          return { value: op[0] ? op[1] : void 0, done: true };
        }
      };
      __createBinding = function(o2, m2, k2, k22) {
        if (k22 === void 0)
          k22 = k2;
        o2[k22] = m2[k2];
      };
      __exportStar = function(m2, exports2) {
        for (var p2 in m2)
          if (p2 !== "default" && !exports2.hasOwnProperty(p2))
            exports2[p2] = m2[p2];
      };
      __values = function(o2) {
        var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
        if (m2)
          return m2.call(o2);
        if (o2 && typeof o2.length === "number")
          return {
            next: function() {
              if (o2 && i2 >= o2.length)
                o2 = void 0;
              return { value: o2 && o2[i2++], done: !o2 };
            }
          };
        throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
      };
      __read = function(o2, n2) {
        var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
        if (!m2)
          return o2;
        var i2 = m2.call(o2), r2, ar2 = [], e3;
        try {
          while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
            ar2.push(r2.value);
        } catch (error2) {
          e3 = { error: error2 };
        } finally {
          try {
            if (r2 && !r2.done && (m2 = i2["return"]))
              m2.call(i2);
          } finally {
            if (e3)
              throw e3.error;
          }
        }
        return ar2;
      };
      __spread = function() {
        for (var ar2 = [], i2 = 0; i2 < arguments.length; i2++)
          ar2 = ar2.concat(__read(arguments[i2]));
        return ar2;
      };
      __spreadArrays = function() {
        for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
          s2 += arguments[i2].length;
        for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
          for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
            r2[k2] = a2[j2];
        return r2;
      };
      __await = function(v5) {
        return this instanceof __await ? (this.v = v5, this) : new __await(v5);
      };
      __asyncGenerator = function(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
        return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2;
        function verb(n2) {
          if (g2[n2])
            i2[n2] = function(v5) {
              return new Promise(function(a2, b2) {
                q2.push([n2, v5, a2, b2]) > 1 || resume(n2, v5);
              });
            };
        }
        function resume(n2, v5) {
          try {
            step(g2[n2](v5));
          } catch (e3) {
            settle(q2[0][3], e3);
          }
        }
        function step(r2) {
          r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
        }
        function fulfill(value) {
          resume("next", value);
        }
        function reject(value) {
          resume("throw", value);
        }
        function settle(f2, v5) {
          if (f2(v5), q2.shift(), q2.length)
            resume(q2[0][0], q2[0][1]);
        }
      };
      __asyncDelegator = function(o2) {
        var i2, p2;
        return i2 = {}, verb("next"), verb("throw", function(e3) {
          throw e3;
        }), verb("return"), i2[Symbol.iterator] = function() {
          return this;
        }, i2;
        function verb(n2, f2) {
          i2[n2] = o2[n2] ? function(v5) {
            return (p2 = !p2) ? { value: __await(o2[n2](v5)), done: n2 === "return" } : f2 ? f2(v5) : v5;
          } : f2;
        }
      };
      __asyncValues = function(o2) {
        if (!Symbol.asyncIterator)
          throw new TypeError("Symbol.asyncIterator is not defined.");
        var m2 = o2[Symbol.asyncIterator], i2;
        return m2 ? m2.call(o2) : (o2 = typeof __values === "function" ? __values(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
          return this;
        }, i2);
        function verb(n2) {
          i2[n2] = o2[n2] && function(v5) {
            return new Promise(function(resolve2, reject) {
              v5 = o2[n2](v5), settle(resolve2, reject, v5.done, v5.value);
            });
          };
        }
        function settle(resolve2, reject, d2, v5) {
          Promise.resolve(v5).then(function(v6) {
            resolve2({ value: v6, done: d2 });
          }, reject);
        }
      };
      __makeTemplateObject = function(cooked, raw) {
        if (Object.defineProperty) {
          Object.defineProperty(cooked, "raw", { value: raw });
        } else {
          cooked.raw = raw;
        }
        return cooked;
      };
      __importStar = function(mod2) {
        if (mod2 && mod2.__esModule)
          return mod2;
        var result = {};
        if (mod2 != null) {
          for (var k2 in mod2)
            if (Object.hasOwnProperty.call(mod2, k2))
              result[k2] = mod2[k2];
        }
        result["default"] = mod2;
        return result;
      };
      __importDefault2 = function(mod2) {
        return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
      };
      __classPrivateFieldGet = function(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
      };
      __classPrivateFieldSet = function(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
          throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
      };
      exporter("__extends", __extends);
      exporter("__assign", __assign2);
      exporter("__rest", __rest2);
      exporter("__decorate", __decorate);
      exporter("__param", __param);
      exporter("__metadata", __metadata);
      exporter("__awaiter", __awaiter);
      exporter("__generator", __generator);
      exporter("__exportStar", __exportStar);
      exporter("__createBinding", __createBinding);
      exporter("__values", __values);
      exporter("__read", __read);
      exporter("__spread", __spread);
      exporter("__spreadArrays", __spreadArrays);
      exporter("__await", __await);
      exporter("__asyncGenerator", __asyncGenerator);
      exporter("__asyncDelegator", __asyncDelegator);
      exporter("__asyncValues", __asyncValues);
      exporter("__makeTemplateObject", __makeTemplateObject);
      exporter("__importStar", __importStar);
      exporter("__importDefault", __importDefault2);
      exporter("__classPrivateFieldGet", __classPrivateFieldGet);
      exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    });
  })(tslib$2);
  return tslibExports$2;
}
var jsSha256 = {};
var constants$7 = {};
var hasRequiredConstants;
function requireConstants() {
  if (hasRequiredConstants)
    return constants$7;
  hasRequiredConstants = 1;
  Object.defineProperty(constants$7, "__esModule", { value: true });
  constants$7.MAX_HASHABLE_LENGTH = constants$7.INIT = constants$7.KEY = constants$7.DIGEST_LENGTH = constants$7.BLOCK_SIZE = void 0;
  constants$7.BLOCK_SIZE = 64;
  constants$7.DIGEST_LENGTH = 32;
  constants$7.KEY = new Uint32Array([
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ]);
  constants$7.INIT = [
    1779033703,
    3144134277,
    1013904242,
    2773480762,
    1359893119,
    2600822924,
    528734635,
    1541459225
  ];
  constants$7.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
  return constants$7;
}
var RawSha256 = {};
var hasRequiredRawSha256;
function requireRawSha256() {
  if (hasRequiredRawSha256)
    return RawSha256;
  hasRequiredRawSha256 = 1;
  Object.defineProperty(RawSha256, "__esModule", { value: true });
  RawSha256.RawSha256 = void 0;
  var constants_1 = requireConstants();
  var RawSha256$1 = (
    /** @class */
    function() {
      function RawSha2562() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        this.finished = false;
      }
      RawSha2562.prototype.update = function(data2) {
        if (this.finished) {
          throw new Error("Attempted to update an already finished hash.");
        }
        var position = 0;
        var byteLength = data2.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
          throw new Error("Cannot hash more than 2^53 - 1 bits");
        }
        while (byteLength > 0) {
          this.buffer[this.bufferLength++] = data2[position++];
          byteLength--;
          if (this.bufferLength === constants_1.BLOCK_SIZE) {
            this.hashBuffer();
            this.bufferLength = 0;
          }
        }
      };
      RawSha2562.prototype.digest = function() {
        if (!this.finished) {
          var bitsHashed = this.bytesHashed * 8;
          var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
          var undecoratedLength = this.bufferLength;
          bufferView.setUint8(this.bufferLength++, 128);
          if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
            for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE; i2++) {
              bufferView.setUint8(i2, 0);
            }
            this.hashBuffer();
            this.bufferLength = 0;
          }
          for (var i2 = this.bufferLength; i2 < constants_1.BLOCK_SIZE - 8; i2++) {
            bufferView.setUint8(i2, 0);
          }
          bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 4294967296), true);
          bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
          this.hashBuffer();
          this.finished = true;
        }
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for (var i2 = 0; i2 < 8; i2++) {
          out[i2 * 4] = this.state[i2] >>> 24 & 255;
          out[i2 * 4 + 1] = this.state[i2] >>> 16 & 255;
          out[i2 * 4 + 2] = this.state[i2] >>> 8 & 255;
          out[i2 * 4 + 3] = this.state[i2] >>> 0 & 255;
        }
        return out;
      };
      RawSha2562.prototype.hashBuffer = function() {
        var _a3 = this, buffer3 = _a3.buffer, state = _a3.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
          if (i2 < 16) {
            this.temp[i2] = (buffer3[i2 * 4] & 255) << 24 | (buffer3[i2 * 4 + 1] & 255) << 16 | (buffer3[i2 * 4 + 2] & 255) << 8 | buffer3[i2 * 4 + 3] & 255;
          } else {
            var u2 = this.temp[i2 - 2];
            var t1_1 = (u2 >>> 17 | u2 << 15) ^ (u2 >>> 19 | u2 << 13) ^ u2 >>> 10;
            u2 = this.temp[i2 - 15];
            var t2_1 = (u2 >>> 7 | u2 << 25) ^ (u2 >>> 18 | u2 << 14) ^ u2 >>> 3;
            this.temp[i2] = (t1_1 + this.temp[i2 - 7] | 0) + (t2_1 + this.temp[i2 - 16] | 0);
          }
          var t1 = (((state4 >>> 6 | state4 << 26) ^ (state4 >>> 11 | state4 << 21) ^ (state4 >>> 25 | state4 << 7)) + (state4 & state5 ^ ~state4 & state6) | 0) + (state7 + (constants_1.KEY[i2] + this.temp[i2] | 0) | 0) | 0;
          var t2 = ((state0 >>> 2 | state0 << 30) ^ (state0 >>> 13 | state0 << 19) ^ (state0 >>> 22 | state0 << 10)) + (state0 & state1 ^ state0 & state2 ^ state1 & state2) | 0;
          state7 = state6;
          state6 = state5;
          state5 = state4;
          state4 = state3 + t1 | 0;
          state3 = state2;
          state2 = state1;
          state1 = state0;
          state0 = t1 + t2 | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
      };
      return RawSha2562;
    }()
  );
  RawSha256.RawSha256 = RawSha256$1;
  return RawSha256;
}
var hasRequiredJsSha256;
function requireJsSha256() {
  if (hasRequiredJsSha256)
    return jsSha256;
  hasRequiredJsSha256 = 1;
  Object.defineProperty(jsSha256, "__esModule", { value: true });
  jsSha256.Sha256 = void 0;
  var tslib_1 = requireTslib();
  var constants_1 = requireConstants();
  var RawSha256_1 = requireRawSha256();
  var util_1 = requireBuild$3();
  var Sha256 = (
    /** @class */
    function() {
      function Sha2562(secret) {
        this.secret = secret;
        this.hash = new RawSha256_1.RawSha256();
        this.reset();
      }
      Sha2562.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) {
          return;
        }
        try {
          this.hash.update((0, util_1.convertToBuffer)(toHash));
        } catch (e3) {
          this.error = e3;
        }
      };
      Sha2562.prototype.digestSync = function() {
        if (this.error) {
          throw this.error;
        }
        if (this.outer) {
          if (!this.outer.finished) {
            this.outer.update(this.hash.digest());
          }
          return this.outer.digest();
        }
        return this.hash.digest();
      };
      Sha2562.prototype.digest = function() {
        return tslib_1.__awaiter(this, void 0, void 0, function() {
          return tslib_1.__generator(this, function(_a3) {
            return [2, this.digestSync()];
          });
        });
      };
      Sha2562.prototype.reset = function() {
        this.hash = new RawSha256_1.RawSha256();
        if (this.secret) {
          this.outer = new RawSha256_1.RawSha256();
          var inner = bufferFromSecret(this.secret);
          var outer = new Uint8Array(constants_1.BLOCK_SIZE);
          outer.set(inner);
          for (var i2 = 0; i2 < constants_1.BLOCK_SIZE; i2++) {
            inner[i2] ^= 54;
            outer[i2] ^= 92;
          }
          this.hash.update(inner);
          this.outer.update(outer);
          for (var i2 = 0; i2 < inner.byteLength; i2++) {
            inner[i2] = 0;
          }
        }
      };
      return Sha2562;
    }()
  );
  jsSha256.Sha256 = Sha256;
  function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
      var bufferHash = new RawSha256_1.RawSha256();
      bufferHash.update(input);
      input = bufferHash.digest();
    }
    var buffer3 = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer3.set(input);
    return buffer3;
  }
  return jsSha256;
}
var hasRequiredBuild$2;
function requireBuild$2() {
  if (hasRequiredBuild$2)
    return build$2;
  hasRequiredBuild$2 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    var tslib_1 = requireTslib();
    tslib_1.__exportStar(requireJsSha256(), exports2);
  })(build$2);
  return build$2;
}
var hasRequiredCrossPlatformSha256;
function requireCrossPlatformSha256() {
  if (hasRequiredCrossPlatformSha256)
    return crossPlatformSha256;
  hasRequiredCrossPlatformSha256 = 1;
  Object.defineProperty(crossPlatformSha256, "__esModule", { value: true });
  crossPlatformSha256.Sha256 = void 0;
  var ie11Sha256_1 = requireIe11Sha256();
  var webCryptoSha256_1 = requireWebCryptoSha256();
  var sha256_js_1 = requireBuild$2();
  var supports_web_crypto_1 = requireBuild$5();
  var ie11_detection_1 = requireBuild$4();
  var util_locate_window_1 = require$$5;
  var util_1 = requireBuild$3();
  var Sha256 = (
    /** @class */
    function() {
      function Sha2562(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
          this.hash = new webCryptoSha256_1.Sha256(secret);
        } else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
          this.hash = new ie11Sha256_1.Sha256(secret);
        } else {
          this.hash = new sha256_js_1.Sha256(secret);
        }
      }
      Sha2562.prototype.update = function(data2, encoding) {
        this.hash.update((0, util_1.convertToBuffer)(data2));
      };
      Sha2562.prototype.digest = function() {
        return this.hash.digest();
      };
      Sha2562.prototype.reset = function() {
        this.hash.reset();
      };
      return Sha2562;
    }()
  );
  crossPlatformSha256.Sha256 = Sha256;
  return crossPlatformSha256;
}
(function(exports2) {
  Object.defineProperty(exports2, "__esModule", { value: true });
  exports2.WebCryptoSha256 = exports2.Ie11Sha256 = void 0;
  var tslib_1 = tslibExports$3;
  tslib_1.__exportStar(requireCrossPlatformSha256(), exports2);
  var ie11Sha256_1 = requireIe11Sha256();
  Object.defineProperty(exports2, "Ie11Sha256", { enumerable: true, get: function() {
    return ie11Sha256_1.Sha256;
  } });
  var webCryptoSha256_1 = requireWebCryptoSha256();
  Object.defineProperty(exports2, "WebCryptoSha256", { enumerable: true, get: function() {
    return webCryptoSha256_1.Sha256;
  } });
})(build$3);
var build$1 = {};
var tslibExports$1 = {};
var tslib$1 = {
  get exports() {
    return tslibExports$1;
  },
  set exports(v5) {
    tslibExports$1 = v5;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
(function(module2) {
  var __extends;
  var __assign2;
  var __rest2;
  var __decorate;
  var __param;
  var __metadata;
  var __awaiter;
  var __generator;
  var __exportStar;
  var __values;
  var __read;
  var __spread;
  var __spreadArrays;
  var __await;
  var __asyncGenerator;
  var __asyncDelegator;
  var __asyncValues;
  var __makeTemplateObject;
  var __importStar;
  var __importDefault2;
  var __classPrivateFieldGet;
  var __classPrivateFieldSet;
  var __createBinding;
  (function(factory) {
    var root2 = typeof commonjsGlobal$1 === "object" ? commonjsGlobal$1 : typeof self === "object" ? self : typeof this === "object" ? this : {};
    {
      factory(createExporter(root2, createExporter(module2.exports)));
    }
    function createExporter(exports2, previous) {
      if (exports2 !== root2) {
        if (typeof Object.create === "function") {
          Object.defineProperty(exports2, "__esModule", { value: true });
        } else {
          exports2.__esModule = true;
        }
      }
      return function(id, v5) {
        return exports2[id] = previous ? previous(id, v5) : v5;
      };
    }
  })(function(exporter) {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p2 in b2)
        if (b2.hasOwnProperty(p2))
          d2[p2] = b2[p2];
    };
    __extends = function(d2, b2) {
      extendStatics(d2, b2);
      function __() {
        this.constructor = d2;
      }
      d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
    __assign2 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    __rest2 = function(s2, e3) {
      var t2 = {};
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
          t2[p2] = s2[p2];
      if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
          if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
            t2[p2[i2]] = s2[p2[i2]];
        }
      return t2;
    };
    __decorate = function(decorators, target, key, desc) {
      var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r2 = Reflect.decorate(decorators, target, key, desc);
      else
        for (var i2 = decorators.length - 1; i2 >= 0; i2--)
          if (d2 = decorators[i2])
            r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
      return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
    };
    __param = function(paramIndex, decorator) {
      return function(target, key) {
        decorator(target, key, paramIndex);
      };
    };
    __metadata = function(metadataKey, metadataValue) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(metadataKey, metadataValue);
    };
    __awaiter = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e3) {
            reject(e3);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e3) {
            reject(e3);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    __generator = function(thisArg, body) {
      var _2 = { label: 0, sent: function() {
        if (t2[0] & 1)
          throw t2[1];
        return t2[1];
      }, trys: [], ops: [] }, f2, y2, t2, g2;
      return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
        return this;
      }), g2;
      function verb(n2) {
        return function(v5) {
          return step([n2, v5]);
        };
      }
      function step(op) {
        if (f2)
          throw new TypeError("Generator is already executing.");
        while (_2)
          try {
            if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
              return t2;
            if (y2 = 0, t2)
              op = [op[0] & 2, t2.value];
            switch (op[0]) {
              case 0:
              case 1:
                t2 = op;
                break;
              case 4:
                _2.label++;
                return { value: op[1], done: false };
              case 5:
                _2.label++;
                y2 = op[1];
                op = [0];
                continue;
              case 7:
                op = _2.ops.pop();
                _2.trys.pop();
                continue;
              default:
                if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _2 = 0;
                  continue;
                }
                if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                  _2.label = op[1];
                  break;
                }
                if (op[0] === 6 && _2.label < t2[1]) {
                  _2.label = t2[1];
                  t2 = op;
                  break;
                }
                if (t2 && _2.label < t2[2]) {
                  _2.label = t2[2];
                  _2.ops.push(op);
                  break;
                }
                if (t2[2])
                  _2.ops.pop();
                _2.trys.pop();
                continue;
            }
            op = body.call(thisArg, _2);
          } catch (e3) {
            op = [6, e3];
            y2 = 0;
          } finally {
            f2 = t2 = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    __createBinding = function(o2, m2, k2, k22) {
      if (k22 === void 0)
        k22 = k2;
      o2[k22] = m2[k2];
    };
    __exportStar = function(m2, exports2) {
      for (var p2 in m2)
        if (p2 !== "default" && !exports2.hasOwnProperty(p2))
          exports2[p2] = m2[p2];
    };
    __values = function(o2) {
      var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
      if (m2)
        return m2.call(o2);
      if (o2 && typeof o2.length === "number")
        return {
          next: function() {
            if (o2 && i2 >= o2.length)
              o2 = void 0;
            return { value: o2 && o2[i2++], done: !o2 };
          }
        };
      throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    __read = function(o2, n2) {
      var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
      if (!m2)
        return o2;
      var i2 = m2.call(o2), r2, ar2 = [], e3;
      try {
        while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
          ar2.push(r2.value);
      } catch (error2) {
        e3 = { error: error2 };
      } finally {
        try {
          if (r2 && !r2.done && (m2 = i2["return"]))
            m2.call(i2);
        } finally {
          if (e3)
            throw e3.error;
        }
      }
      return ar2;
    };
    __spread = function() {
      for (var ar2 = [], i2 = 0; i2 < arguments.length; i2++)
        ar2 = ar2.concat(__read(arguments[i2]));
      return ar2;
    };
    __spreadArrays = function() {
      for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
        s2 += arguments[i2].length;
      for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
        for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
          r2[k2] = a2[j2];
      return r2;
    };
    __await = function(v5) {
      return this instanceof __await ? (this.v = v5, this) : new __await(v5);
    };
    __asyncGenerator = function(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
      return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2;
      function verb(n2) {
        if (g2[n2])
          i2[n2] = function(v5) {
            return new Promise(function(a2, b2) {
              q2.push([n2, v5, a2, b2]) > 1 || resume(n2, v5);
            });
          };
      }
      function resume(n2, v5) {
        try {
          step(g2[n2](v5));
        } catch (e3) {
          settle(q2[0][3], e3);
        }
      }
      function step(r2) {
        r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
      }
      function fulfill(value) {
        resume("next", value);
      }
      function reject(value) {
        resume("throw", value);
      }
      function settle(f2, v5) {
        if (f2(v5), q2.shift(), q2.length)
          resume(q2[0][0], q2[0][1]);
      }
    };
    __asyncDelegator = function(o2) {
      var i2, p2;
      return i2 = {}, verb("next"), verb("throw", function(e3) {
        throw e3;
      }), verb("return"), i2[Symbol.iterator] = function() {
        return this;
      }, i2;
      function verb(n2, f2) {
        i2[n2] = o2[n2] ? function(v5) {
          return (p2 = !p2) ? { value: __await(o2[n2](v5)), done: n2 === "return" } : f2 ? f2(v5) : v5;
        } : f2;
      }
    };
    __asyncValues = function(o2) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var m2 = o2[Symbol.asyncIterator], i2;
      return m2 ? m2.call(o2) : (o2 = typeof __values === "function" ? __values(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2);
      function verb(n2) {
        i2[n2] = o2[n2] && function(v5) {
          return new Promise(function(resolve2, reject) {
            v5 = o2[n2](v5), settle(resolve2, reject, v5.done, v5.value);
          });
        };
      }
      function settle(resolve2, reject, d2, v5) {
        Promise.resolve(v5).then(function(v6) {
          resolve2({ value: v6, done: d2 });
        }, reject);
      }
    };
    __makeTemplateObject = function(cooked, raw) {
      if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
      } else {
        cooked.raw = raw;
      }
      return cooked;
    };
    __importStar = function(mod2) {
      if (mod2 && mod2.__esModule)
        return mod2;
      var result = {};
      if (mod2 != null) {
        for (var k2 in mod2)
          if (Object.hasOwnProperty.call(mod2, k2))
            result[k2] = mod2[k2];
      }
      result["default"] = mod2;
      return result;
    };
    __importDefault2 = function(mod2) {
      return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
    };
    __classPrivateFieldGet = function(receiver, privateMap) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
      }
      return privateMap.get(receiver);
    };
    __classPrivateFieldSet = function(receiver, privateMap, value) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
      }
      privateMap.set(receiver, value);
      return value;
    };
    exporter("__extends", __extends);
    exporter("__assign", __assign2);
    exporter("__rest", __rest2);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault2);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
  });
})(tslib$1);
var aws_crc32 = {};
var hasRequiredAws_crc32;
function requireAws_crc32() {
  if (hasRequiredAws_crc32)
    return aws_crc32;
  hasRequiredAws_crc32 = 1;
  Object.defineProperty(aws_crc32, "__esModule", { value: true });
  aws_crc32.AwsCrc32 = void 0;
  var tslib_1 = tslibExports$1;
  var util_1 = requireBuild$3();
  var index_1 = requireBuild$1();
  var AwsCrc32 = (
    /** @class */
    function() {
      function AwsCrc322() {
        this.crc32 = new index_1.Crc32();
      }
      AwsCrc322.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash))
          return;
        this.crc32.update((0, util_1.convertToBuffer)(toHash));
      };
      AwsCrc322.prototype.digest = function() {
        return tslib_1.__awaiter(this, void 0, void 0, function() {
          return tslib_1.__generator(this, function(_a3) {
            return [2, (0, util_1.numToUint8)(this.crc32.digest())];
          });
        });
      };
      AwsCrc322.prototype.reset = function() {
        this.crc32 = new index_1.Crc32();
      };
      return AwsCrc322;
    }()
  );
  aws_crc32.AwsCrc32 = AwsCrc32;
  return aws_crc32;
}
var hasRequiredBuild$1;
function requireBuild$1() {
  if (hasRequiredBuild$1)
    return build$1;
  hasRequiredBuild$1 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AwsCrc32 = exports2.Crc32 = exports2.crc32 = void 0;
    var tslib_1 = tslibExports$1;
    var util_1 = requireBuild$3();
    function crc32(data2) {
      return new Crc32().update(data2).digest();
    }
    exports2.crc32 = crc32;
    var Crc32 = (
      /** @class */
      function() {
        function Crc322() {
          this.checksum = 4294967295;
        }
        Crc322.prototype.update = function(data2) {
          var e_1, _a3;
          try {
            for (var data_1 = tslib_1.__values(data2), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
              var byte = data_1_1.value;
              this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 255];
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (data_1_1 && !data_1_1.done && (_a3 = data_1.return))
                _a3.call(data_1);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          return this;
        };
        Crc322.prototype.digest = function() {
          return (this.checksum ^ 4294967295) >>> 0;
        };
        return Crc322;
      }()
    );
    exports2.Crc32 = Crc32;
    var a_lookUpTable = [
      0,
      1996959894,
      3993919788,
      2567524794,
      124634137,
      1886057615,
      3915621685,
      2657392035,
      249268274,
      2044508324,
      3772115230,
      2547177864,
      162941995,
      2125561021,
      3887607047,
      2428444049,
      498536548,
      1789927666,
      4089016648,
      2227061214,
      450548861,
      1843258603,
      4107580753,
      2211677639,
      325883990,
      1684777152,
      4251122042,
      2321926636,
      335633487,
      1661365465,
      4195302755,
      2366115317,
      997073096,
      1281953886,
      3579855332,
      2724688242,
      1006888145,
      1258607687,
      3524101629,
      2768942443,
      901097722,
      1119000684,
      3686517206,
      2898065728,
      853044451,
      1172266101,
      3705015759,
      2882616665,
      651767980,
      1373503546,
      3369554304,
      3218104598,
      565507253,
      1454621731,
      3485111705,
      3099436303,
      671266974,
      1594198024,
      3322730930,
      2970347812,
      795835527,
      1483230225,
      3244367275,
      3060149565,
      1994146192,
      31158534,
      2563907772,
      4023717930,
      1907459465,
      112637215,
      2680153253,
      3904427059,
      2013776290,
      251722036,
      2517215374,
      3775830040,
      2137656763,
      141376813,
      2439277719,
      3865271297,
      1802195444,
      476864866,
      2238001368,
      4066508878,
      1812370925,
      453092731,
      2181625025,
      4111451223,
      1706088902,
      314042704,
      2344532202,
      4240017532,
      1658658271,
      366619977,
      2362670323,
      4224994405,
      1303535960,
      984961486,
      2747007092,
      3569037538,
      1256170817,
      1037604311,
      2765210733,
      3554079995,
      1131014506,
      879679996,
      2909243462,
      3663771856,
      1141124467,
      855842277,
      2852801631,
      3708648649,
      1342533948,
      654459306,
      3188396048,
      3373015174,
      1466479909,
      544179635,
      3110523913,
      3462522015,
      1591671054,
      702138776,
      2966460450,
      3352799412,
      1504918807,
      783551873,
      3082640443,
      3233442989,
      3988292384,
      2596254646,
      62317068,
      1957810842,
      3939845945,
      2647816111,
      81470997,
      1943803523,
      3814918930,
      2489596804,
      225274430,
      2053790376,
      3826175755,
      2466906013,
      167816743,
      2097651377,
      4027552580,
      2265490386,
      503444072,
      1762050814,
      4150417245,
      2154129355,
      426522225,
      1852507879,
      4275313526,
      2312317920,
      282753626,
      1742555852,
      4189708143,
      2394877945,
      397917763,
      1622183637,
      3604390888,
      2714866558,
      953729732,
      1340076626,
      3518719985,
      2797360999,
      1068828381,
      1219638859,
      3624741850,
      2936675148,
      906185462,
      1090812512,
      3747672003,
      2825379669,
      829329135,
      1181335161,
      3412177804,
      3160834842,
      628085408,
      1382605366,
      3423369109,
      3138078467,
      570562233,
      1426400815,
      3317316542,
      2998733608,
      733239954,
      1555261956,
      3268935591,
      3050360625,
      752459403,
      1541320221,
      2607071920,
      3965973030,
      1969922972,
      40735498,
      2617837225,
      3943577151,
      1913087877,
      83908371,
      2512341634,
      3803740692,
      2075208622,
      213261112,
      2463272603,
      3855990285,
      2094854071,
      198958881,
      2262029012,
      4057260610,
      1759359992,
      534414190,
      2176718541,
      4139329115,
      1873836001,
      414664567,
      2282248934,
      4279200368,
      1711684554,
      285281116,
      2405801727,
      4167216745,
      1634467795,
      376229701,
      2685067896,
      3608007406,
      1308918612,
      956543938,
      2808555105,
      3495958263,
      1231636301,
      1047427035,
      2932959818,
      3654703836,
      1088359270,
      936918e3,
      2847714899,
      3736837829,
      1202900863,
      817233897,
      3183342108,
      3401237130,
      1404277552,
      615818150,
      3134207493,
      3453421203,
      1423857449,
      601450431,
      3009837614,
      3294710456,
      1567103746,
      711928724,
      3020668471,
      3272380065,
      1510334235,
      755167117
    ];
    var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookUpTable);
    var aws_crc32_1 = requireAws_crc32();
    Object.defineProperty(exports2, "AwsCrc32", { enumerable: true, get: function() {
      return aws_crc32_1.AwsCrc32;
    } });
  })(build$1);
  return build$1;
}
var buildExports$1 = requireBuild$1();
class Int64 {
  constructor(bytes) {
    this.bytes = bytes;
    if (bytes.byteLength !== 8) {
      throw new Error("Int64 buffers must be exactly 8 bytes");
    }
  }
  static fromNumber(number2) {
    if (number2 > 9223372036854776e3 || number2 < -9223372036854776e3) {
      throw new Error(`${number2} is too large (or, if negative, too small) to represent as an Int64`);
    }
    const bytes = new Uint8Array(8);
    for (let i2 = 7, remaining = Math.abs(Math.round(number2)); i2 > -1 && remaining > 0; i2--, remaining /= 256) {
      bytes[i2] = remaining;
    }
    if (number2 < 0) {
      negate$2(bytes);
    }
    return new Int64(bytes);
  }
  valueOf() {
    const bytes = this.bytes.slice(0);
    const negative = bytes[0] & 128;
    if (negative) {
      negate$2(bytes);
    }
    return parseInt(toHex(bytes), 16) * (negative ? -1 : 1);
  }
  toString() {
    return String(this.valueOf());
  }
}
function negate$2(bytes) {
  for (let i2 = 0; i2 < 8; i2++) {
    bytes[i2] ^= 255;
  }
  for (let i2 = 7; i2 > -1; i2--) {
    bytes[i2]++;
    if (bytes[i2] !== 0)
      break;
  }
}
class HeaderMarshaller {
  constructor(toUtf82, fromUtf82) {
    this.toUtf8 = toUtf82;
    this.fromUtf8 = fromUtf82;
  }
  format(headers) {
    const chunks = [];
    for (const headerName of Object.keys(headers)) {
      const bytes = this.fromUtf8(headerName);
      chunks.push(Uint8Array.from([bytes.byteLength]), bytes, this.formatHeaderValue(headers[headerName]));
    }
    const out = new Uint8Array(chunks.reduce((carry, bytes) => carry + bytes.byteLength, 0));
    let position = 0;
    for (const chunk of chunks) {
      out.set(chunk, position);
      position += chunk.byteLength;
    }
    return out;
  }
  formatHeaderValue(header) {
    switch (header.type) {
      case "boolean":
        return Uint8Array.from([header.value ? 0 : 1]);
      case "byte":
        return Uint8Array.from([2, header.value]);
      case "short":
        const shortView = new DataView(new ArrayBuffer(3));
        shortView.setUint8(0, 3);
        shortView.setInt16(1, header.value, false);
        return new Uint8Array(shortView.buffer);
      case "integer":
        const intView = new DataView(new ArrayBuffer(5));
        intView.setUint8(0, 4);
        intView.setInt32(1, header.value, false);
        return new Uint8Array(intView.buffer);
      case "long":
        const longBytes = new Uint8Array(9);
        longBytes[0] = 5;
        longBytes.set(header.value.bytes, 1);
        return longBytes;
      case "binary":
        const binView = new DataView(new ArrayBuffer(3 + header.value.byteLength));
        binView.setUint8(0, 6);
        binView.setUint16(1, header.value.byteLength, false);
        const binBytes = new Uint8Array(binView.buffer);
        binBytes.set(header.value, 3);
        return binBytes;
      case "string":
        const utf8Bytes = this.fromUtf8(header.value);
        const strView = new DataView(new ArrayBuffer(3 + utf8Bytes.byteLength));
        strView.setUint8(0, 7);
        strView.setUint16(1, utf8Bytes.byteLength, false);
        const strBytes = new Uint8Array(strView.buffer);
        strBytes.set(utf8Bytes, 3);
        return strBytes;
      case "timestamp":
        const tsBytes = new Uint8Array(9);
        tsBytes[0] = 8;
        tsBytes.set(Int64.fromNumber(header.value.valueOf()).bytes, 1);
        return tsBytes;
      case "uuid":
        if (!UUID_PATTERN.test(header.value)) {
          throw new Error(`Invalid UUID received: ${header.value}`);
        }
        const uuidBytes = new Uint8Array(17);
        uuidBytes[0] = 9;
        uuidBytes.set(fromHex(header.value.replace(/\-/g, "")), 1);
        return uuidBytes;
    }
  }
  parse(headers) {
    const out = {};
    let position = 0;
    while (position < headers.byteLength) {
      const nameLength = headers.getUint8(position++);
      const name2 = this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, nameLength));
      position += nameLength;
      switch (headers.getUint8(position++)) {
        case 0:
          out[name2] = {
            type: BOOLEAN_TAG,
            value: true
          };
          break;
        case 1:
          out[name2] = {
            type: BOOLEAN_TAG,
            value: false
          };
          break;
        case 2:
          out[name2] = {
            type: BYTE_TAG,
            value: headers.getInt8(position++)
          };
          break;
        case 3:
          out[name2] = {
            type: SHORT_TAG,
            value: headers.getInt16(position, false)
          };
          position += 2;
          break;
        case 4:
          out[name2] = {
            type: INT_TAG,
            value: headers.getInt32(position, false)
          };
          position += 4;
          break;
        case 5:
          out[name2] = {
            type: LONG_TAG,
            value: new Int64(new Uint8Array(headers.buffer, headers.byteOffset + position, 8))
          };
          position += 8;
          break;
        case 6:
          const binaryLength = headers.getUint16(position, false);
          position += 2;
          out[name2] = {
            type: BINARY_TAG,
            value: new Uint8Array(headers.buffer, headers.byteOffset + position, binaryLength)
          };
          position += binaryLength;
          break;
        case 7:
          const stringLength = headers.getUint16(position, false);
          position += 2;
          out[name2] = {
            type: STRING_TAG,
            value: this.toUtf8(new Uint8Array(headers.buffer, headers.byteOffset + position, stringLength))
          };
          position += stringLength;
          break;
        case 8:
          out[name2] = {
            type: TIMESTAMP_TAG,
            value: new Date(new Int64(new Uint8Array(headers.buffer, headers.byteOffset + position, 8)).valueOf())
          };
          position += 8;
          break;
        case 9:
          const uuidBytes = new Uint8Array(headers.buffer, headers.byteOffset + position, 16);
          position += 16;
          out[name2] = {
            type: UUID_TAG,
            value: `${toHex(uuidBytes.subarray(0, 4))}-${toHex(uuidBytes.subarray(4, 6))}-${toHex(uuidBytes.subarray(6, 8))}-${toHex(uuidBytes.subarray(8, 10))}-${toHex(uuidBytes.subarray(10))}`
          };
          break;
        default:
          throw new Error(`Unrecognized header type tag`);
      }
    }
    return out;
  }
}
var HEADER_VALUE_TYPE;
(function(HEADER_VALUE_TYPE2) {
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["boolTrue"] = 0] = "boolTrue";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["boolFalse"] = 1] = "boolFalse";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["byte"] = 2] = "byte";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["short"] = 3] = "short";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["integer"] = 4] = "integer";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["long"] = 5] = "long";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["byteArray"] = 6] = "byteArray";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["string"] = 7] = "string";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["timestamp"] = 8] = "timestamp";
  HEADER_VALUE_TYPE2[HEADER_VALUE_TYPE2["uuid"] = 9] = "uuid";
})(HEADER_VALUE_TYPE || (HEADER_VALUE_TYPE = {}));
const BOOLEAN_TAG = "boolean";
const BYTE_TAG = "byte";
const SHORT_TAG = "short";
const INT_TAG = "integer";
const LONG_TAG = "long";
const BINARY_TAG = "binary";
const STRING_TAG = "string";
const TIMESTAMP_TAG = "timestamp";
const UUID_TAG = "uuid";
const UUID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/;
const PRELUDE_MEMBER_LENGTH = 4;
const PRELUDE_LENGTH = PRELUDE_MEMBER_LENGTH * 2;
const CHECKSUM_LENGTH = 4;
const MINIMUM_MESSAGE_LENGTH = PRELUDE_LENGTH + CHECKSUM_LENGTH * 2;
function splitMessage({ byteLength, byteOffset, buffer: buffer3 }) {
  if (byteLength < MINIMUM_MESSAGE_LENGTH) {
    throw new Error("Provided message too short to accommodate event stream message overhead");
  }
  const view2 = new DataView(buffer3, byteOffset, byteLength);
  const messageLength = view2.getUint32(0, false);
  if (byteLength !== messageLength) {
    throw new Error("Reported message length does not match received message length");
  }
  const headerLength = view2.getUint32(PRELUDE_MEMBER_LENGTH, false);
  const expectedPreludeChecksum = view2.getUint32(PRELUDE_LENGTH, false);
  const expectedMessageChecksum = view2.getUint32(byteLength - CHECKSUM_LENGTH, false);
  const checksummer = new buildExports$1.Crc32().update(new Uint8Array(buffer3, byteOffset, PRELUDE_LENGTH));
  if (expectedPreludeChecksum !== checksummer.digest()) {
    throw new Error(`The prelude checksum specified in the message (${expectedPreludeChecksum}) does not match the calculated CRC32 checksum (${checksummer.digest()})`);
  }
  checksummer.update(new Uint8Array(buffer3, byteOffset + PRELUDE_LENGTH, byteLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH)));
  if (expectedMessageChecksum !== checksummer.digest()) {
    throw new Error(`The message checksum (${checksummer.digest()}) did not match the expected value of ${expectedMessageChecksum}`);
  }
  return {
    headers: new DataView(buffer3, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH, headerLength),
    body: new Uint8Array(buffer3, byteOffset + PRELUDE_LENGTH + CHECKSUM_LENGTH + headerLength, messageLength - headerLength - (PRELUDE_LENGTH + CHECKSUM_LENGTH + CHECKSUM_LENGTH))
  };
}
class EventStreamCodec {
  constructor(toUtf82, fromUtf82) {
    this.headerMarshaller = new HeaderMarshaller(toUtf82, fromUtf82);
  }
  encode({ headers: rawHeaders, body }) {
    const headers = this.headerMarshaller.format(rawHeaders);
    const length2 = headers.byteLength + body.byteLength + 16;
    const out = new Uint8Array(length2);
    const view2 = new DataView(out.buffer, out.byteOffset, out.byteLength);
    const checksum = new buildExports$1.Crc32();
    view2.setUint32(0, length2, false);
    view2.setUint32(4, headers.byteLength, false);
    view2.setUint32(8, checksum.update(out.subarray(0, 8)).digest(), false);
    out.set(headers, 12);
    out.set(body, headers.byteLength + 12);
    view2.setUint32(length2 - 4, checksum.update(out.subarray(8, length2 - 4)).digest(), false);
    return out;
  }
  decode(message2) {
    const { headers, body } = splitMessage(message2);
    return { headers: this.headerMarshaller.parse(headers), body };
  }
  formatHeaders(rawHeaders) {
    return this.headerMarshaller.format(rawHeaders);
  }
}
function getChunkedStream(source) {
  let currentMessageTotalLength = 0;
  let currentMessagePendingLength = 0;
  let currentMessage = null;
  let messageLengthBuffer = null;
  const allocateMessage = (size12) => {
    if (typeof size12 !== "number") {
      throw new Error("Attempted to allocate an event message where size was not a number: " + size12);
    }
    currentMessageTotalLength = size12;
    currentMessagePendingLength = 4;
    currentMessage = new Uint8Array(size12);
    const currentMessageView = new DataView(currentMessage.buffer);
    currentMessageView.setUint32(0, size12, false);
  };
  const iterator7 = async function* () {
    const sourceIterator = source[Symbol.asyncIterator]();
    while (true) {
      const { value, done } = await sourceIterator.next();
      if (done) {
        if (!currentMessageTotalLength) {
          return;
        } else if (currentMessageTotalLength === currentMessagePendingLength) {
          yield currentMessage;
        } else {
          throw new Error("Truncated event message received.");
        }
        return;
      }
      const chunkLength = value.length;
      let currentOffset = 0;
      while (currentOffset < chunkLength) {
        if (!currentMessage) {
          const bytesRemaining = chunkLength - currentOffset;
          if (!messageLengthBuffer) {
            messageLengthBuffer = new Uint8Array(4);
          }
          const numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining);
          messageLengthBuffer.set(value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
          currentMessagePendingLength += numBytesForTotal;
          currentOffset += numBytesForTotal;
          if (currentMessagePendingLength < 4) {
            break;
          }
          allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
          messageLengthBuffer = null;
        }
        const numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset);
        currentMessage.set(value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
        currentMessagePendingLength += numBytesToWrite;
        currentOffset += numBytesToWrite;
        if (currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength) {
          yield currentMessage;
          currentMessage = null;
          currentMessageTotalLength = 0;
          currentMessagePendingLength = 0;
        }
      }
    }
  };
  return {
    [Symbol.asyncIterator]: iterator7
  };
}
function getUnmarshalledStream(source, options2) {
  return {
    [Symbol.asyncIterator]: async function* () {
      for await (const chunk of source) {
        const message2 = options2.eventStreamCodec.decode(chunk);
        const { value: messageType } = message2.headers[":message-type"];
        if (messageType === "error") {
          const unmodeledError = new Error(message2.headers[":error-message"].value || "UnknownError");
          unmodeledError.name = message2.headers[":error-code"].value;
          throw unmodeledError;
        } else if (messageType === "exception") {
          const code = message2.headers[":exception-type"].value;
          const exception = { [code]: message2 };
          const deserializedException = await options2.deserializer(exception);
          if (deserializedException.$unknown) {
            const error2 = new Error(options2.toUtf8(message2.body));
            error2.name = code;
            throw error2;
          }
          throw deserializedException[code];
        } else if (messageType === "event") {
          const event = {
            [message2.headers[":event-type"].value]: message2
          };
          const deserialized = await options2.deserializer(event);
          if (deserialized.$unknown)
            continue;
          yield deserialized;
        } else {
          throw Error(`Unrecognizable event type: ${message2.headers[":event-type"].value}`);
        }
      }
    }
  };
}
let EventStreamMarshaller$1 = class EventStreamMarshaller2 {
  constructor({ utf8Encoder, utf8Decoder }) {
    this.eventStreamCodec = new EventStreamCodec(utf8Encoder, utf8Decoder);
    this.utfEncoder = utf8Encoder;
  }
  deserialize(body, deserializer) {
    const chunkedStream = getChunkedStream(body);
    const unmarshalledStream = getUnmarshalledStream(chunkedStream, {
      eventStreamCodec: this.eventStreamCodec,
      deserializer,
      toUtf8: this.utfEncoder
    });
    return unmarshalledStream;
  }
  serialize(input, serializer) {
    const self2 = this;
    const serializedIterator = async function* () {
      for await (const chunk of input) {
        const payloadBuf = self2.eventStreamCodec.encode(serializer(chunk));
        yield payloadBuf;
      }
      yield new Uint8Array(0);
    };
    return {
      [Symbol.asyncIterator]: serializedIterator
    };
  }
};
const readableStreamtoIterable = (readableStream) => ({
  [Symbol.asyncIterator]: async function* () {
    const reader = readableStream.getReader();
    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done)
          return;
        yield value;
      }
    } finally {
      reader.releaseLock();
    }
  }
});
const iterableToReadableStream = (asyncIterable) => {
  const iterator7 = asyncIterable[Symbol.asyncIterator]();
  return new ReadableStream({
    async pull(controller) {
      const { done, value } = await iterator7.next();
      if (done) {
        return controller.close();
      }
      controller.enqueue(value);
    }
  });
};
class EventStreamMarshaller {
  constructor({ utf8Encoder, utf8Decoder }) {
    this.universalMarshaller = new EventStreamMarshaller$1({
      utf8Decoder,
      utf8Encoder
    });
  }
  deserialize(body, deserializer) {
    const bodyIterable = isReadableStream$1(body) ? readableStreamtoIterable(body) : body;
    return this.universalMarshaller.deserialize(bodyIterable, deserializer);
  }
  serialize(input, serializer) {
    const serialziedIterable = this.universalMarshaller.serialize(input, serializer);
    return typeof ReadableStream === "function" ? iterableToReadableStream(serialziedIterable) : serialziedIterable;
  }
}
const isReadableStream$1 = (body) => typeof ReadableStream === "function" && body instanceof ReadableStream;
const eventStreamSerdeProvider = (options2) => new EventStreamMarshaller(options2);
function buildQueryString(query6) {
  const parts = [];
  for (let key of Object.keys(query6).sort()) {
    const value = query6[key];
    key = escapeUri(key);
    if (Array.isArray(value)) {
      for (let i2 = 0, iLen = value.length; i2 < iLen; i2++) {
        parts.push(`${key}=${escapeUri(value[i2])}`);
      }
    } else {
      let qsEntry = key;
      if (value || typeof value === "string") {
        qsEntry += `=${escapeUri(value)}`;
      }
      parts.push(qsEntry);
    }
  }
  return parts.join("&");
}
function requestTimeout(timeoutInMs = 0) {
  return new Promise((resolve2, reject) => {
    if (timeoutInMs) {
      setTimeout(() => {
        const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
        timeoutError.name = "TimeoutError";
        reject(timeoutError);
      }, timeoutInMs);
    }
  });
}
class FetchHttpHandler {
  constructor(options2) {
    if (typeof options2 === "function") {
      this.configProvider = options2().then((opts) => opts || {});
    } else {
      this.config = options2 ?? {};
      this.configProvider = Promise.resolve(this.config);
    }
  }
  destroy() {
  }
  async handle(request, { abortSignal } = {}) {
    if (!this.config) {
      this.config = await this.configProvider;
    }
    const requestTimeoutInMs = this.config.requestTimeout;
    if (abortSignal == null ? void 0 : abortSignal.aborted) {
      const abortError = new Error("Request aborted");
      abortError.name = "AbortError";
      return Promise.reject(abortError);
    }
    let path2 = request.path;
    if (request.query) {
      const queryString = buildQueryString(request.query);
      if (queryString) {
        path2 += `?${queryString}`;
      }
    }
    const { port, method } = request;
    const url2 = `${request.protocol}//${request.hostname}${port ? `:${port}` : ""}${path2}`;
    const body = method === "GET" || method === "HEAD" ? void 0 : request.body;
    const requestOptions = {
      body,
      headers: new Headers(request.headers),
      method
    };
    if (typeof AbortController !== "undefined") {
      requestOptions["signal"] = abortSignal;
    }
    const fetchRequest = new Request(url2, requestOptions);
    const raceOfPromises = [
      fetch(fetchRequest).then((response) => {
        const fetchHeaders = response.headers;
        const transformedHeaders = {};
        for (const pair of fetchHeaders.entries()) {
          transformedHeaders[pair[0]] = pair[1];
        }
        const hasReadableStream = response.body != void 0;
        if (!hasReadableStream) {
          return response.blob().then((body2) => ({
            response: new HttpResponse({
              headers: transformedHeaders,
              statusCode: response.status,
              body: body2
            })
          }));
        }
        return {
          response: new HttpResponse({
            headers: transformedHeaders,
            statusCode: response.status,
            body: response.body
          })
        };
      }),
      requestTimeout(requestTimeoutInMs)
    ];
    if (abortSignal) {
      raceOfPromises.push(new Promise((resolve2, reject) => {
        abortSignal.onabort = () => {
          const abortError = new Error("Request aborted");
          abortError.name = "AbortError";
          reject(abortError);
        };
      }));
    }
    return Promise.race(raceOfPromises);
  }
}
const alphabetByEncoding = {};
const alphabetByValue = new Array(64);
for (let i2 = 0, start2 = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i2 + start2 <= limit; i2++) {
  const char = String.fromCharCode(i2 + start2);
  alphabetByEncoding[char] = i2;
  alphabetByValue[i2] = char;
}
for (let i2 = 0, start2 = "a".charCodeAt(0), limit = "z".charCodeAt(0); i2 + start2 <= limit; i2++) {
  const char = String.fromCharCode(i2 + start2);
  const index2 = i2 + 26;
  alphabetByEncoding[char] = index2;
  alphabetByValue[index2] = char;
}
for (let i2 = 0; i2 < 10; i2++) {
  alphabetByEncoding[i2.toString(10)] = i2 + 52;
  const char = i2.toString(10);
  const index2 = i2 + 52;
  alphabetByEncoding[char] = index2;
  alphabetByValue[index2] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
const bitsPerLetter = 6;
const bitsPerByte = 8;
const maxLetterValue = 63;
const fromBase64 = (input) => {
  let totalByteLength = input.length / 4 * 3;
  if (input.slice(-2) === "==") {
    totalByteLength -= 2;
  } else if (input.slice(-1) === "=") {
    totalByteLength--;
  }
  const out = new ArrayBuffer(totalByteLength);
  const dataView = new DataView(out);
  for (let i2 = 0; i2 < input.length; i2 += 4) {
    let bits = 0;
    let bitLength = 0;
    for (let j2 = i2, limit = i2 + 3; j2 <= limit; j2++) {
      if (input[j2] !== "=") {
        if (!(input[j2] in alphabetByEncoding)) {
          throw new TypeError(`Invalid character ${input[j2]} in base64 string.`);
        }
        bits |= alphabetByEncoding[input[j2]] << (limit - j2) * bitsPerLetter;
        bitLength += bitsPerLetter;
      } else {
        bits >>= bitsPerLetter;
      }
    }
    const chunkOffset = i2 / 4 * 3;
    bits >>= bitLength % bitsPerByte;
    const byteLength = Math.floor(bitLength / bitsPerByte);
    for (let k2 = 0; k2 < byteLength; k2++) {
      const offset = (byteLength - k2 - 1) * bitsPerByte;
      dataView.setUint8(chunkOffset + k2, (bits & 255 << offset) >> offset);
    }
  }
  return new Uint8Array(out);
};
function toBase64(input) {
  let str = "";
  for (let i2 = 0; i2 < input.length; i2 += 3) {
    let bits = 0;
    let bitLength = 0;
    for (let j2 = i2, limit = Math.min(i2 + 3, input.length); j2 < limit; j2++) {
      bits |= input[j2] << (limit - j2 - 1) * bitsPerByte;
      bitLength += bitsPerByte;
    }
    const bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
    bits <<= bitClusterCount * bitsPerLetter - bitLength;
    for (let k2 = 1; k2 <= bitClusterCount; k2++) {
      const offset = (bitClusterCount - k2) * bitsPerLetter;
      str += alphabetByValue[(bits & maxLetterValue << offset) >> offset];
    }
    str += "==".slice(0, 4 - bitClusterCount);
  }
  return str;
}
const streamCollector = (stream2) => {
  if (typeof Blob === "function" && stream2 instanceof Blob) {
    return collectBlob(stream2);
  }
  return collectStream(stream2);
};
async function collectBlob(blob) {
  const base642 = await readToBase64(blob);
  const arrayBuffer2 = fromBase64(base642);
  return new Uint8Array(arrayBuffer2);
}
async function collectStream(stream2) {
  let res = new Uint8Array(0);
  const reader = stream2.getReader();
  let isDone10 = false;
  while (!isDone10) {
    const { done, value } = await reader.read();
    if (value) {
      const prior = res;
      res = new Uint8Array(prior.length + value.length);
      res.set(prior);
      res.set(value, prior.length);
    }
    isDone10 = done;
  }
  return res;
}
function readToBase64(blob) {
  return new Promise((resolve2, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.readyState !== 2) {
        return reject(new Error("Reader aborted too early"));
      }
      const result = reader.result ?? "";
      const commaIndex = result.indexOf(",");
      const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
      resolve2(result.substring(dataOffset));
    };
    reader.onabort = () => reject(new Error("Read aborted"));
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}
function blobReader(blob, onChunk, chunkSize = 1024 * 1024) {
  return new Promise((resolve2, reject) => {
    const fileReader = new FileReader();
    fileReader.addEventListener("error", reject);
    fileReader.addEventListener("abort", reject);
    const size12 = blob.size;
    let totalBytesRead = 0;
    function read4() {
      if (totalBytesRead >= size12) {
        resolve2();
        return;
      }
      fileReader.readAsArrayBuffer(blob.slice(totalBytesRead, Math.min(size12, totalBytesRead + chunkSize)));
    }
    fileReader.addEventListener("load", (event) => {
      const result = event.target.result;
      onChunk(new Uint8Array(result));
      totalBytesRead += result.byteLength;
      read4();
    });
    read4();
  });
}
const blobHasher = async function blobHasher2(hashCtor, blob) {
  const hash = new hashCtor();
  await blobReader(blob, (chunk) => {
    hash.update(chunk);
  });
  return hash.digest();
};
const invalidProvider = (message2) => () => Promise.reject(message2);
const BLOCK_SIZE = 64;
const DIGEST_LENGTH = 16;
const INIT = [1732584193, 4023233417, 2562383102, 271733878];
class Md5 {
  constructor() {
    this.reset();
  }
  update(sourceData) {
    if (isEmptyData(sourceData)) {
      return;
    } else if (this.finished) {
      throw new Error("Attempted to update an already finished hash.");
    }
    const data2 = convertToBuffer(sourceData);
    let position = 0;
    let { byteLength } = data2;
    this.bytesHashed += byteLength;
    while (byteLength > 0) {
      this.buffer.setUint8(this.bufferLength++, data2[position++]);
      byteLength--;
      if (this.bufferLength === BLOCK_SIZE) {
        this.hashBuffer();
        this.bufferLength = 0;
      }
    }
  }
  async digest() {
    if (!this.finished) {
      const { buffer: buffer3, bufferLength: undecoratedLength, bytesHashed } = this;
      const bitsHashed = bytesHashed * 8;
      buffer3.setUint8(this.bufferLength++, 128);
      if (undecoratedLength % BLOCK_SIZE >= BLOCK_SIZE - 8) {
        for (let i2 = this.bufferLength; i2 < BLOCK_SIZE; i2++) {
          buffer3.setUint8(i2, 0);
        }
        this.hashBuffer();
        this.bufferLength = 0;
      }
      for (let i2 = this.bufferLength; i2 < BLOCK_SIZE - 8; i2++) {
        buffer3.setUint8(i2, 0);
      }
      buffer3.setUint32(BLOCK_SIZE - 8, bitsHashed >>> 0, true);
      buffer3.setUint32(BLOCK_SIZE - 4, Math.floor(bitsHashed / 4294967296), true);
      this.hashBuffer();
      this.finished = true;
    }
    const out = new DataView(new ArrayBuffer(DIGEST_LENGTH));
    for (let i2 = 0; i2 < 4; i2++) {
      out.setUint32(i2 * 4, this.state[i2], true);
    }
    return new Uint8Array(out.buffer, out.byteOffset, out.byteLength);
  }
  hashBuffer() {
    const { buffer: buffer3, state } = this;
    let a2 = state[0], b2 = state[1], c2 = state[2], d2 = state[3];
    a2 = ff(a2, b2, c2, d2, buffer3.getUint32(0, true), 7, 3614090360);
    d2 = ff(d2, a2, b2, c2, buffer3.getUint32(4, true), 12, 3905402710);
    c2 = ff(c2, d2, a2, b2, buffer3.getUint32(8, true), 17, 606105819);
    b2 = ff(b2, c2, d2, a2, buffer3.getUint32(12, true), 22, 3250441966);
    a2 = ff(a2, b2, c2, d2, buffer3.getUint32(16, true), 7, 4118548399);
    d2 = ff(d2, a2, b2, c2, buffer3.getUint32(20, true), 12, 1200080426);
    c2 = ff(c2, d2, a2, b2, buffer3.getUint32(24, true), 17, 2821735955);
    b2 = ff(b2, c2, d2, a2, buffer3.getUint32(28, true), 22, 4249261313);
    a2 = ff(a2, b2, c2, d2, buffer3.getUint32(32, true), 7, 1770035416);
    d2 = ff(d2, a2, b2, c2, buffer3.getUint32(36, true), 12, 2336552879);
    c2 = ff(c2, d2, a2, b2, buffer3.getUint32(40, true), 17, 4294925233);
    b2 = ff(b2, c2, d2, a2, buffer3.getUint32(44, true), 22, 2304563134);
    a2 = ff(a2, b2, c2, d2, buffer3.getUint32(48, true), 7, 1804603682);
    d2 = ff(d2, a2, b2, c2, buffer3.getUint32(52, true), 12, 4254626195);
    c2 = ff(c2, d2, a2, b2, buffer3.getUint32(56, true), 17, 2792965006);
    b2 = ff(b2, c2, d2, a2, buffer3.getUint32(60, true), 22, 1236535329);
    a2 = gg(a2, b2, c2, d2, buffer3.getUint32(4, true), 5, 4129170786);
    d2 = gg(d2, a2, b2, c2, buffer3.getUint32(24, true), 9, 3225465664);
    c2 = gg(c2, d2, a2, b2, buffer3.getUint32(44, true), 14, 643717713);
    b2 = gg(b2, c2, d2, a2, buffer3.getUint32(0, true), 20, 3921069994);
    a2 = gg(a2, b2, c2, d2, buffer3.getUint32(20, true), 5, 3593408605);
    d2 = gg(d2, a2, b2, c2, buffer3.getUint32(40, true), 9, 38016083);
    c2 = gg(c2, d2, a2, b2, buffer3.getUint32(60, true), 14, 3634488961);
    b2 = gg(b2, c2, d2, a2, buffer3.getUint32(16, true), 20, 3889429448);
    a2 = gg(a2, b2, c2, d2, buffer3.getUint32(36, true), 5, 568446438);
    d2 = gg(d2, a2, b2, c2, buffer3.getUint32(56, true), 9, 3275163606);
    c2 = gg(c2, d2, a2, b2, buffer3.getUint32(12, true), 14, 4107603335);
    b2 = gg(b2, c2, d2, a2, buffer3.getUint32(32, true), 20, 1163531501);
    a2 = gg(a2, b2, c2, d2, buffer3.getUint32(52, true), 5, 2850285829);
    d2 = gg(d2, a2, b2, c2, buffer3.getUint32(8, true), 9, 4243563512);
    c2 = gg(c2, d2, a2, b2, buffer3.getUint32(28, true), 14, 1735328473);
    b2 = gg(b2, c2, d2, a2, buffer3.getUint32(48, true), 20, 2368359562);
    a2 = hh(a2, b2, c2, d2, buffer3.getUint32(20, true), 4, 4294588738);
    d2 = hh(d2, a2, b2, c2, buffer3.getUint32(32, true), 11, 2272392833);
    c2 = hh(c2, d2, a2, b2, buffer3.getUint32(44, true), 16, 1839030562);
    b2 = hh(b2, c2, d2, a2, buffer3.getUint32(56, true), 23, 4259657740);
    a2 = hh(a2, b2, c2, d2, buffer3.getUint32(4, true), 4, 2763975236);
    d2 = hh(d2, a2, b2, c2, buffer3.getUint32(16, true), 11, 1272893353);
    c2 = hh(c2, d2, a2, b2, buffer3.getUint32(28, true), 16, 4139469664);
    b2 = hh(b2, c2, d2, a2, buffer3.getUint32(40, true), 23, 3200236656);
    a2 = hh(a2, b2, c2, d2, buffer3.getUint32(52, true), 4, 681279174);
    d2 = hh(d2, a2, b2, c2, buffer3.getUint32(0, true), 11, 3936430074);
    c2 = hh(c2, d2, a2, b2, buffer3.getUint32(12, true), 16, 3572445317);
    b2 = hh(b2, c2, d2, a2, buffer3.getUint32(24, true), 23, 76029189);
    a2 = hh(a2, b2, c2, d2, buffer3.getUint32(36, true), 4, 3654602809);
    d2 = hh(d2, a2, b2, c2, buffer3.getUint32(48, true), 11, 3873151461);
    c2 = hh(c2, d2, a2, b2, buffer3.getUint32(60, true), 16, 530742520);
    b2 = hh(b2, c2, d2, a2, buffer3.getUint32(8, true), 23, 3299628645);
    a2 = ii(a2, b2, c2, d2, buffer3.getUint32(0, true), 6, 4096336452);
    d2 = ii(d2, a2, b2, c2, buffer3.getUint32(28, true), 10, 1126891415);
    c2 = ii(c2, d2, a2, b2, buffer3.getUint32(56, true), 15, 2878612391);
    b2 = ii(b2, c2, d2, a2, buffer3.getUint32(20, true), 21, 4237533241);
    a2 = ii(a2, b2, c2, d2, buffer3.getUint32(48, true), 6, 1700485571);
    d2 = ii(d2, a2, b2, c2, buffer3.getUint32(12, true), 10, 2399980690);
    c2 = ii(c2, d2, a2, b2, buffer3.getUint32(40, true), 15, 4293915773);
    b2 = ii(b2, c2, d2, a2, buffer3.getUint32(4, true), 21, 2240044497);
    a2 = ii(a2, b2, c2, d2, buffer3.getUint32(32, true), 6, 1873313359);
    d2 = ii(d2, a2, b2, c2, buffer3.getUint32(60, true), 10, 4264355552);
    c2 = ii(c2, d2, a2, b2, buffer3.getUint32(24, true), 15, 2734768916);
    b2 = ii(b2, c2, d2, a2, buffer3.getUint32(52, true), 21, 1309151649);
    a2 = ii(a2, b2, c2, d2, buffer3.getUint32(16, true), 6, 4149444226);
    d2 = ii(d2, a2, b2, c2, buffer3.getUint32(44, true), 10, 3174756917);
    c2 = ii(c2, d2, a2, b2, buffer3.getUint32(8, true), 15, 718787259);
    b2 = ii(b2, c2, d2, a2, buffer3.getUint32(36, true), 21, 3951481745);
    state[0] = a2 + state[0] & 4294967295;
    state[1] = b2 + state[1] & 4294967295;
    state[2] = c2 + state[2] & 4294967295;
    state[3] = d2 + state[3] & 4294967295;
  }
  reset() {
    this.state = Uint32Array.from(INIT);
    this.buffer = new DataView(new ArrayBuffer(BLOCK_SIZE));
    this.bufferLength = 0;
    this.bytesHashed = 0;
    this.finished = false;
  }
}
function cmn(q2, a2, b2, x2, s2, t2) {
  a2 = (a2 + q2 & 4294967295) + (x2 + t2 & 4294967295) & 4294967295;
  return (a2 << s2 | a2 >>> 32 - s2) + b2 & 4294967295;
}
function ff(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(b2 & c2 | ~b2 & d2, a2, b2, x2, s2, t2);
}
function gg(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(b2 & d2 | c2 & ~d2, a2, b2, x2, s2, t2);
}
function hh(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(b2 ^ c2 ^ d2, a2, b2, x2, s2, t2);
}
function ii(a2, b2, c2, d2, x2, s2, t2) {
  return cmn(c2 ^ (b2 | ~d2), a2, b2, x2, s2, t2);
}
function isEmptyData(data2) {
  if (typeof data2 === "string") {
    return data2.length === 0;
  }
  return data2.byteLength === 0;
}
function convertToBuffer(data2) {
  if (typeof data2 === "string") {
    return fromUtf8$3(data2);
  }
  if (ArrayBuffer.isView(data2)) {
    return new Uint8Array(data2.buffer, data2.byteOffset, data2.byteLength / Uint8Array.BYTES_PER_ELEMENT);
  }
  return new Uint8Array(data2);
}
const calculateBodyLength = (body) => {
  if (typeof body === "string") {
    let len2 = body.length;
    for (let i2 = len2 - 1; i2 >= 0; i2--) {
      const code = body.charCodeAt(i2);
      if (code > 127 && code <= 2047)
        len2++;
      else if (code > 2047 && code <= 65535)
        len2 += 2;
      if (code >= 56320 && code <= 57343)
        i2--;
    }
    return len2;
  } else if (typeof body.byteLength === "number") {
    return body.byteLength;
  } else if (typeof body.size === "number") {
    return body.size;
  }
  throw new Error(`Body Length computation failed for ${body}`);
};
const getAwsChunkedEncodingStream = (readableStream, options2) => {
  const { base64Encoder, bodyLengthChecker, checksumAlgorithmFn, checksumLocationName, streamHasher } = options2;
  const checksumRequired = base64Encoder !== void 0 && bodyLengthChecker !== void 0 && checksumAlgorithmFn !== void 0 && checksumLocationName !== void 0 && streamHasher !== void 0;
  const digest = checksumRequired ? streamHasher(checksumAlgorithmFn, readableStream) : void 0;
  const reader = readableStream.getReader();
  return new ReadableStream({
    async pull(controller) {
      const { value, done } = await reader.read();
      if (done) {
        controller.enqueue(`0\r
`);
        if (checksumRequired) {
          const checksum = base64Encoder(await digest);
          controller.enqueue(`${checksumLocationName}:${checksum}\r
`);
          controller.enqueue(`\r
`);
        }
        controller.close();
      } else {
        controller.enqueue(`${(bodyLengthChecker(value) || 0).toString(16)}\r
${value}\r
`);
      }
    }
  });
};
const ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED = "The stream has already been transformed.";
const sdkStreamMixin = (stream2) => {
  var _a3, _b3;
  if (!isBlobInstance(stream2) && !isReadableStreamInstance(stream2)) {
    const name2 = ((_b3 = (_a3 = stream2 == null ? void 0 : stream2.__proto__) == null ? void 0 : _a3.constructor) == null ? void 0 : _b3.name) || stream2;
    throw new Error(`Unexpected stream implementation, expect Blob or ReadableStream, got ${name2}`);
  }
  let transformed = false;
  const transformToByteArray = async () => {
    if (transformed) {
      throw new Error(ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
    }
    transformed = true;
    return await streamCollector(stream2);
  };
  const blobToWebStream = (blob) => {
    if (typeof blob.stream !== "function") {
      throw new Error("Cannot transform payload Blob to web stream. Please make sure the Blob.stream() is polyfilled.\nIf you are using React Native, this API is not yet supported, see: https://react-native.canny.io/feature-requests/p/fetch-streaming-body");
    }
    return blob.stream();
  };
  return Object.assign(stream2, {
    transformToByteArray,
    transformToString: async (encoding) => {
      const buf = await transformToByteArray();
      if (encoding === "base64") {
        return toBase64(buf);
      } else if (encoding === "hex") {
        return toHex(buf);
      } else if (encoding === void 0 || encoding === "utf8" || encoding === "utf-8") {
        return toUtf8$3(buf);
      } else if (typeof TextDecoder === "function") {
        return new TextDecoder(encoding).decode(buf);
      } else {
        throw new Error("TextDecoder is not available, please make sure polyfill is provided.");
      }
    },
    transformToWebStream: () => {
      if (transformed) {
        throw new Error(ERR_MSG_STREAM_HAS_BEEN_TRANSFORMED);
      }
      transformed = true;
      if (isBlobInstance(stream2)) {
        return blobToWebStream(stream2);
      } else if (isReadableStreamInstance(stream2)) {
        return stream2;
      } else {
        throw new Error(`Cannot transform payload to web stream, got ${stream2}`);
      }
    }
  });
};
const isBlobInstance = (stream2) => typeof Blob === "function" && stream2 instanceof Blob;
const isReadableStreamInstance = (stream2) => typeof ReadableStream === "function" && stream2 instanceof ReadableStream;
const BROWSER_ALIASES_MAP = {
  "Amazon Silk": "amazon_silk",
  "Android Browser": "android",
  Bada: "bada",
  BlackBerry: "blackberry",
  Chrome: "chrome",
  Chromium: "chromium",
  Electron: "electron",
  Epiphany: "epiphany",
  Firefox: "firefox",
  Focus: "focus",
  Generic: "generic",
  "Google Search": "google_search",
  Googlebot: "googlebot",
  "Internet Explorer": "ie",
  "K-Meleon": "k_meleon",
  Maxthon: "maxthon",
  "Microsoft Edge": "edge",
  "MZ Browser": "mz",
  "NAVER Whale Browser": "naver",
  Opera: "opera",
  "Opera Coast": "opera_coast",
  PhantomJS: "phantomjs",
  Puffin: "puffin",
  QupZilla: "qupzilla",
  QQ: "qq",
  QQLite: "qqlite",
  Safari: "safari",
  Sailfish: "sailfish",
  "Samsung Internet for Android": "samsung_internet",
  SeaMonkey: "seamonkey",
  Sleipnir: "sleipnir",
  Swing: "swing",
  Tizen: "tizen",
  "UC Browser": "uc",
  Vivaldi: "vivaldi",
  "WebOS Browser": "webos",
  WeChat: "wechat",
  "Yandex Browser": "yandex",
  Roku: "roku"
};
const BROWSER_MAP = {
  amazon_silk: "Amazon Silk",
  android: "Android Browser",
  bada: "Bada",
  blackberry: "BlackBerry",
  chrome: "Chrome",
  chromium: "Chromium",
  electron: "Electron",
  epiphany: "Epiphany",
  firefox: "Firefox",
  focus: "Focus",
  generic: "Generic",
  googlebot: "Googlebot",
  google_search: "Google Search",
  ie: "Internet Explorer",
  k_meleon: "K-Meleon",
  maxthon: "Maxthon",
  edge: "Microsoft Edge",
  mz: "MZ Browser",
  naver: "NAVER Whale Browser",
  opera: "Opera",
  opera_coast: "Opera Coast",
  phantomjs: "PhantomJS",
  puffin: "Puffin",
  qupzilla: "QupZilla",
  qq: "QQ Browser",
  qqlite: "QQ Browser Lite",
  safari: "Safari",
  sailfish: "Sailfish",
  samsung_internet: "Samsung Internet for Android",
  seamonkey: "SeaMonkey",
  sleipnir: "Sleipnir",
  swing: "Swing",
  tizen: "Tizen",
  uc: "UC Browser",
  vivaldi: "Vivaldi",
  webos: "WebOS Browser",
  wechat: "WeChat",
  yandex: "Yandex Browser"
};
const PLATFORMS_MAP = {
  tablet: "tablet",
  mobile: "mobile",
  desktop: "desktop",
  tv: "tv"
};
const OS_MAP = {
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MacOS: "macOS",
  iOS: "iOS",
  Android: "Android",
  WebOS: "WebOS",
  BlackBerry: "BlackBerry",
  Bada: "Bada",
  Tizen: "Tizen",
  Linux: "Linux",
  ChromeOS: "Chrome OS",
  PlayStation4: "PlayStation 4",
  Roku: "Roku"
};
const ENGINE_MAP = {
  EdgeHTML: "EdgeHTML",
  Blink: "Blink",
  Trident: "Trident",
  Presto: "Presto",
  Gecko: "Gecko",
  WebKit: "WebKit"
};
class Utils {
  /**
   * Get first matched item for a string
   * @param {RegExp} regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getFirstMatch(regexp, ua) {
    const match2 = ua.match(regexp);
    return match2 && match2.length > 0 && match2[1] || "";
  }
  /**
   * Get second matched item for a string
   * @param regexp
   * @param {String} ua
   * @return {Array|{index: number, input: string}|*|boolean|string}
   */
  static getSecondMatch(regexp, ua) {
    const match2 = ua.match(regexp);
    return match2 && match2.length > 1 && match2[2] || "";
  }
  /**
   * Match a regexp and return a constant or undefined
   * @param {RegExp} regexp
   * @param {String} ua
   * @param {*} _const Any const that will be returned if regexp matches the string
   * @return {*}
   */
  static matchAndReturnConst(regexp, ua, _const) {
    if (regexp.test(ua)) {
      return _const;
    }
    return void 0;
  }
  static getWindowsVersionName(version2) {
    switch (version2) {
      case "NT":
        return "NT";
      case "XP":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.1":
        return "XP";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return void 0;
    }
  }
  /**
   * Get macOS version name
   *    10.5 - Leopard
   *    10.6 - Snow Leopard
   *    10.7 - Lion
   *    10.8 - Mountain Lion
   *    10.9 - Mavericks
   *    10.10 - Yosemite
   *    10.11 - El Capitan
   *    10.12 - Sierra
   *    10.13 - High Sierra
   *    10.14 - Mojave
   *    10.15 - Catalina
   *
   * @example
   *   getMacOSVersionName("10.14") // 'Mojave'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getMacOSVersionName(version2) {
    const v5 = version2.split(".").splice(0, 2).map((s2) => parseInt(s2, 10) || 0);
    v5.push(0);
    if (v5[0] !== 10)
      return void 0;
    switch (v5[1]) {
      case 5:
        return "Leopard";
      case 6:
        return "Snow Leopard";
      case 7:
        return "Lion";
      case 8:
        return "Mountain Lion";
      case 9:
        return "Mavericks";
      case 10:
        return "Yosemite";
      case 11:
        return "El Capitan";
      case 12:
        return "Sierra";
      case 13:
        return "High Sierra";
      case 14:
        return "Mojave";
      case 15:
        return "Catalina";
      default:
        return void 0;
    }
  }
  /**
   * Get Android version name
   *    1.5 - Cupcake
   *    1.6 - Donut
   *    2.0 - Eclair
   *    2.1 - Eclair
   *    2.2 - Froyo
   *    2.x - Gingerbread
   *    3.x - Honeycomb
   *    4.0 - Ice Cream Sandwich
   *    4.1 - Jelly Bean
   *    4.4 - KitKat
   *    5.x - Lollipop
   *    6.x - Marshmallow
   *    7.x - Nougat
   *    8.x - Oreo
   *    9.x - Pie
   *
   * @example
   *   getAndroidVersionName("7.0") // 'Nougat'
   *
   * @param  {string} version
   * @return {string} versionName
   */
  static getAndroidVersionName(version2) {
    const v5 = version2.split(".").splice(0, 2).map((s2) => parseInt(s2, 10) || 0);
    v5.push(0);
    if (v5[0] === 1 && v5[1] < 5)
      return void 0;
    if (v5[0] === 1 && v5[1] < 6)
      return "Cupcake";
    if (v5[0] === 1 && v5[1] >= 6)
      return "Donut";
    if (v5[0] === 2 && v5[1] < 2)
      return "Eclair";
    if (v5[0] === 2 && v5[1] === 2)
      return "Froyo";
    if (v5[0] === 2 && v5[1] > 2)
      return "Gingerbread";
    if (v5[0] === 3)
      return "Honeycomb";
    if (v5[0] === 4 && v5[1] < 1)
      return "Ice Cream Sandwich";
    if (v5[0] === 4 && v5[1] < 4)
      return "Jelly Bean";
    if (v5[0] === 4 && v5[1] >= 4)
      return "KitKat";
    if (v5[0] === 5)
      return "Lollipop";
    if (v5[0] === 6)
      return "Marshmallow";
    if (v5[0] === 7)
      return "Nougat";
    if (v5[0] === 8)
      return "Oreo";
    if (v5[0] === 9)
      return "Pie";
    return void 0;
  }
  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  static getVersionPrecision(version2) {
    return version2.split(".").length;
  }
  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions('1.10.2.1',  '1.8.2.1.90')    // 1
   *   compareVersions('1.010.2.1', '1.09.2.1.90');  // 1
   *   compareVersions('1.10.2.1',  '1.10.2.1');     // 0
   *   compareVersions('1.10.2.1',  '1.0800.2');     // -1
   *   compareVersions('1.10.2.1',  '1.10',  true);  // 0
   *
   * @param {String} versionA versions versions to compare
   * @param {String} versionB versions versions to compare
   * @param {boolean} [isLoose] enable loose comparison
   * @return {Number} comparison result: -1 when versionA is lower,
   * 1 when versionA is bigger, 0 when both equal
   */
  /* eslint consistent-return: 1 */
  static compareVersions(versionA, versionB, isLoose = false) {
    const versionAPrecision = Utils.getVersionPrecision(versionA);
    const versionBPrecision = Utils.getVersionPrecision(versionB);
    let precision = Math.max(versionAPrecision, versionBPrecision);
    let lastPrecision = 0;
    const chunks = Utils.map([versionA, versionB], (version2) => {
      const delta = precision - Utils.getVersionPrecision(version2);
      const _version = version2 + new Array(delta + 1).join(".0");
      return Utils.map(_version.split("."), (chunk) => new Array(20 - chunk.length).join("0") + chunk).reverse();
    });
    if (isLoose) {
      lastPrecision = precision - Math.min(versionAPrecision, versionBPrecision);
    }
    precision -= 1;
    while (precision >= lastPrecision) {
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === lastPrecision) {
          return 0;
        }
        precision -= 1;
      } else if (chunks[0][precision] < chunks[1][precision]) {
        return -1;
      }
    }
    return void 0;
  }
  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  static map(arr, iterator7) {
    const result = [];
    let i2;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator7);
    }
    for (i2 = 0; i2 < arr.length; i2 += 1) {
      result.push(iterator7(arr[i2]));
    }
    return result;
  }
  /**
   * Array::find polyfill
   *
   * @param  {Array} arr
   * @param  {Function} predicate
   * @return {Array}
   */
  static find(arr, predicate) {
    let i2;
    let l2;
    if (Array.prototype.find) {
      return Array.prototype.find.call(arr, predicate);
    }
    for (i2 = 0, l2 = arr.length; i2 < l2; i2 += 1) {
      const value = arr[i2];
      if (predicate(value, i2)) {
        return value;
      }
    }
    return void 0;
  }
  /**
   * Object::assign polyfill
   *
   * @param  {Object} obj
   * @param  {Object} ...objs
   * @return {Object}
   */
  static assign(obj, ...assigners) {
    const result = obj;
    let i2;
    let l2;
    if (Object.assign) {
      return Object.assign(obj, ...assigners);
    }
    for (i2 = 0, l2 = assigners.length; i2 < l2; i2 += 1) {
      const assigner = assigners[i2];
      if (typeof assigner === "object" && assigner !== null) {
        const keys4 = Object.keys(assigner);
        keys4.forEach((key) => {
          result[key] = assigner[key];
        });
      }
    }
    return obj;
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('Microsoft Edge') // edge
   *
   * @param  {string} browserName
   * @return {string}
   */
  static getBrowserAlias(browserName) {
    return BROWSER_ALIASES_MAP[browserName];
  }
  /**
   * Get short version/alias for a browser name
   *
   * @example
   *   getBrowserAlias('edge') // Microsoft Edge
   *
   * @param  {string} browserAlias
   * @return {string}
   */
  static getBrowserTypeByAlias(browserAlias) {
    return BROWSER_MAP[browserAlias] || "";
  }
}
const commonVersionIdentifier = /version\/(\d+(\.?_?\d+)+)/i;
const browsersList = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe(ua) {
      const browser2 = {
        name: "Googlebot"
      };
      const version2 = Utils.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  /* Opera < 13.0 */
  {
    test: [/opera/i],
    describe(ua) {
      const browser2 = {
        name: "Opera"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  /* Opera > 13.0 */
  {
    test: [/opr\/|opios/i],
    describe(ua) {
      const browser2 = {
        name: "Opera"
      };
      const version2 = Utils.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/SamsungBrowser/i],
    describe(ua) {
      const browser2 = {
        name: "Samsung Internet for Android"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/Whale/i],
    describe(ua) {
      const browser2 = {
        name: "NAVER Whale Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/MZBrowser/i],
    describe(ua) {
      const browser2 = {
        name: "MZ Browser"
      };
      const version2 = Utils.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/focus/i],
    describe(ua) {
      const browser2 = {
        name: "Focus"
      };
      const version2 = Utils.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/swing/i],
    describe(ua) {
      const browser2 = {
        name: "Swing"
      };
      const version2 = Utils.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/coast/i],
    describe(ua) {
      const browser2 = {
        name: "Opera Coast"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/opt\/\d+(?:.?_?\d+)+/i],
    describe(ua) {
      const browser2 = {
        name: "Opera Touch"
      };
      const version2 = Utils.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/yabrowser/i],
    describe(ua) {
      const browser2 = {
        name: "Yandex Browser"
      };
      const version2 = Utils.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/ucbrowser/i],
    describe(ua) {
      const browser2 = {
        name: "UC Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/Maxthon|mxios/i],
    describe(ua) {
      const browser2 = {
        name: "Maxthon"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/epiphany/i],
    describe(ua) {
      const browser2 = {
        name: "Epiphany"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/puffin/i],
    describe(ua) {
      const browser2 = {
        name: "Puffin"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/sleipnir/i],
    describe(ua) {
      const browser2 = {
        name: "Sleipnir"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/k-meleon/i],
    describe(ua) {
      const browser2 = {
        name: "K-Meleon"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/micromessenger/i],
    describe(ua) {
      const browser2 = {
        name: "WeChat"
      };
      const version2 = Utils.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/qqbrowser/i],
    describe(ua) {
      const browser2 = {
        name: /qqbrowserlite/i.test(ua) ? "QQ Browser Lite" : "QQ Browser"
      };
      const version2 = Utils.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/msie|trident/i],
    describe(ua) {
      const browser2 = {
        name: "Internet Explorer"
      };
      const version2 = Utils.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/\sedg\//i],
    describe(ua) {
      const browser2 = {
        name: "Microsoft Edge"
      };
      const version2 = Utils.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/edg([ea]|ios)/i],
    describe(ua) {
      const browser2 = {
        name: "Microsoft Edge"
      };
      const version2 = Utils.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/vivaldi/i],
    describe(ua) {
      const browser2 = {
        name: "Vivaldi"
      };
      const version2 = Utils.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/seamonkey/i],
    describe(ua) {
      const browser2 = {
        name: "SeaMonkey"
      };
      const version2 = Utils.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/sailfish/i],
    describe(ua) {
      const browser2 = {
        name: "Sailfish"
      };
      const version2 = Utils.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/silk/i],
    describe(ua) {
      const browser2 = {
        name: "Amazon Silk"
      };
      const version2 = Utils.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/phantom/i],
    describe(ua) {
      const browser2 = {
        name: "PhantomJS"
      };
      const version2 = Utils.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/slimerjs/i],
    describe(ua) {
      const browser2 = {
        name: "SlimerJS"
      };
      const version2 = Utils.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const browser2 = {
        name: "BlackBerry"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const browser2 = {
        name: "WebOS Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua) || Utils.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/bada/i],
    describe(ua) {
      const browser2 = {
        name: "Bada"
      };
      const version2 = Utils.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/tizen/i],
    describe(ua) {
      const browser2 = {
        name: "Tizen"
      };
      const version2 = Utils.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/qupzilla/i],
    describe(ua) {
      const browser2 = {
        name: "QupZilla"
      };
      const version2 = Utils.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/firefox|iceweasel|fxios/i],
    describe(ua) {
      const browser2 = {
        name: "Firefox"
      };
      const version2 = Utils.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/electron/i],
    describe(ua) {
      const browser2 = {
        name: "Electron"
      };
      const version2 = Utils.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/MiuiBrowser/i],
    describe(ua) {
      const browser2 = {
        name: "Miui"
      };
      const version2 = Utils.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/chromium/i],
    describe(ua) {
      const browser2 = {
        name: "Chromium"
      };
      const version2 = Utils.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, ua) || Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/chrome|crios|crmo/i],
    describe(ua) {
      const browser2 = {
        name: "Chrome"
      };
      const version2 = Utils.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  {
    test: [/GSA/i],
    describe(ua) {
      const browser2 = {
        name: "Google Search"
      };
      const version2 = Utils.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  /* Android Browser */
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const browser2 = {
        name: "Android Browser"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  /* PlayStation 4 */
  {
    test: [/playstation 4/i],
    describe(ua) {
      const browser2 = {
        name: "PlayStation 4"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  /* Safari */
  {
    test: [/safari|applewebkit/i],
    describe(ua) {
      const browser2 = {
        name: "Safari"
      };
      const version2 = Utils.getFirstMatch(commonVersionIdentifier, ua);
      if (version2) {
        browser2.version = version2;
      }
      return browser2;
    }
  },
  /* Something else */
  {
    test: [/.*/i],
    describe(ua) {
      const regexpWithoutDeviceSpec = /^(.*)\/(.*) /;
      const regexpWithDeviceSpec = /^(.*)\/(.*)[ \t]\((.*)/;
      const hasDeviceSpec = ua.search("\\(") !== -1;
      const regexp = hasDeviceSpec ? regexpWithDeviceSpec : regexpWithoutDeviceSpec;
      return {
        name: Utils.getFirstMatch(regexp, ua),
        version: Utils.getSecondMatch(regexp, ua)
      };
    }
  }
];
const osParsersList = [
  /* Roku */
  {
    test: [/Roku\/DVP/],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, ua);
      return {
        name: OS_MAP.Roku,
        version: version2
      };
    }
  },
  /* Windows Phone */
  {
    test: [/windows phone/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.WindowsPhone,
        version: version2
      };
    }
  },
  /* Windows */
  {
    test: [/windows /i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
      const versionName = Utils.getWindowsVersionName(version2);
      return {
        name: OS_MAP.Windows,
        version: version2,
        versionName
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe(ua) {
      const result = {
        name: OS_MAP.iOS
      };
      const version2 = Utils.getSecondMatch(/(Version\/)(\d[\d.]+)/, ua);
      if (version2) {
        result.version = version2;
      }
      return result;
    }
  },
  /* macOS */
  {
    test: [/macintosh/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, ".");
      const versionName = Utils.getMacOSVersionName(version2);
      const os = {
        name: OS_MAP.MacOS,
        version: version2
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  /* iOS */
  {
    test: [/(ipod|iphone|ipad)/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, ".");
      return {
        name: OS_MAP.iOS,
        version: version2
      };
    }
  },
  /* Android */
  {
    test(parser) {
      const notLikeAndroid = !parser.test(/like android/i);
      const butAndroid = parser.test(/android/i);
      return notLikeAndroid && butAndroid;
    },
    describe(ua) {
      const version2 = Utils.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
      const versionName = Utils.getAndroidVersionName(version2);
      const os = {
        name: OS_MAP.Android,
        version: version2
      };
      if (versionName) {
        os.versionName = versionName;
      }
      return os;
    }
  },
  /* WebOS */
  {
    test: [/(web|hpw)[o0]s/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, ua);
      const os = {
        name: OS_MAP.WebOS
      };
      if (version2 && version2.length) {
        os.version = version2;
      }
      return os;
    }
  },
  /* BlackBerry */
  {
    test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, ua) || Utils.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, ua) || Utils.getFirstMatch(/\bbb(\d+)/i, ua);
      return {
        name: OS_MAP.BlackBerry,
        version: version2
      };
    }
  },
  /* Bada */
  {
    test: [/bada/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Bada,
        version: version2
      };
    }
  },
  /* Tizen */
  {
    test: [/tizen/i],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.Tizen,
        version: version2
      };
    }
  },
  /* Linux */
  {
    test: [/linux/i],
    describe() {
      return {
        name: OS_MAP.Linux
      };
    }
  },
  /* Chrome OS */
  {
    test: [/CrOS/],
    describe() {
      return {
        name: OS_MAP.ChromeOS
      };
    }
  },
  /* Playstation 4 */
  {
    test: [/PlayStation 4/],
    describe(ua) {
      const version2 = Utils.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, ua);
      return {
        name: OS_MAP.PlayStation4,
        version: version2
      };
    }
  }
];
const platformParsersList = [
  /* Googlebot */
  {
    test: [/googlebot/i],
    describe() {
      return {
        type: "bot",
        vendor: "Google"
      };
    }
  },
  /* Huawei */
  {
    test: [/huawei/i],
    describe(ua) {
      const model = Utils.getFirstMatch(/(can-l01)/i, ua) && "Nova";
      const platform = {
        type: PLATFORMS_MAP.mobile,
        vendor: "Huawei"
      };
      if (model) {
        platform.model = model;
      }
      return platform;
    }
  },
  /* Nexus Tablet */
  {
    test: [/nexus\s*(?:7|8|9|10).*/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Nexus"
      };
    }
  },
  /* iPad */
  {
    test: [/ipad/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Firefox on iPad */
  {
    test: [/Macintosh(.*?) FxiOS(.*?)\//],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Apple",
        model: "iPad"
      };
    }
  },
  /* Amazon Kindle Fire */
  {
    test: [/kftt build/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon",
        model: "Kindle Fire HD 7"
      };
    }
  },
  /* Another Amazon Tablet with Silk */
  {
    test: [/silk/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet,
        vendor: "Amazon"
      };
    }
  },
  /* Tablet */
  {
    test: [/tablet(?! pc)/i],
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  /* iPod/iPhone */
  {
    test(parser) {
      const iDevice = parser.test(/ipod|iphone/i);
      const likeIDevice = parser.test(/like (ipod|iphone)/i);
      return iDevice && !likeIDevice;
    },
    describe(ua) {
      const model = Utils.getFirstMatch(/(ipod|iphone)/i, ua);
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Apple",
        model
      };
    }
  },
  /* Nexus Mobile */
  {
    test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Nexus"
      };
    }
  },
  /* Mobile */
  {
    test: [/[^-]mobi/i],
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* BlackBerry */
  {
    test(parser) {
      return parser.getBrowserName(true) === "blackberry";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "BlackBerry"
      };
    }
  },
  /* Bada */
  {
    test(parser) {
      return parser.getBrowserName(true) === "bada";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* Windows Phone */
  {
    test(parser) {
      return parser.getBrowserName() === "windows phone";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile,
        vendor: "Microsoft"
      };
    }
  },
  /* Android Tablet */
  {
    test(parser) {
      const osMajorVersion = Number(String(parser.getOSVersion()).split(".")[0]);
      return parser.getOSName(true) === "android" && osMajorVersion >= 3;
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tablet
      };
    }
  },
  /* Android Mobile */
  {
    test(parser) {
      return parser.getOSName(true) === "android";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.mobile
      };
    }
  },
  /* desktop */
  {
    test(parser) {
      return parser.getOSName(true) === "macos";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop,
        vendor: "Apple"
      };
    }
  },
  /* Windows */
  {
    test(parser) {
      return parser.getOSName(true) === "windows";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  /* Linux */
  {
    test(parser) {
      return parser.getOSName(true) === "linux";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.desktop
      };
    }
  },
  /* PlayStation 4 */
  {
    test(parser) {
      return parser.getOSName(true) === "playstation 4";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  },
  /* Roku */
  {
    test(parser) {
      return parser.getOSName(true) === "roku";
    },
    describe() {
      return {
        type: PLATFORMS_MAP.tv
      };
    }
  }
];
const enginesParsersList = [
  /* EdgeHTML */
  {
    test(parser) {
      return parser.getBrowserName(true) === "microsoft edge";
    },
    describe(ua) {
      const isBlinkBased = /\sedg\//i.test(ua);
      if (isBlinkBased) {
        return {
          name: ENGINE_MAP.Blink
        };
      }
      const version2 = Utils.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, ua);
      return {
        name: ENGINE_MAP.EdgeHTML,
        version: version2
      };
    }
  },
  /* Trident */
  {
    test: [/trident/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Trident
      };
      const version2 = Utils.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  },
  /* Presto */
  {
    test(parser) {
      return parser.test(/presto/i);
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Presto
      };
      const version2 = Utils.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  },
  /* Gecko */
  {
    test(parser) {
      const isGecko = parser.test(/gecko/i);
      const likeGecko = parser.test(/like gecko/i);
      return isGecko && !likeGecko;
    },
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.Gecko
      };
      const version2 = Utils.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  },
  /* Blink */
  {
    test: [/(apple)?webkit\/537\.36/i],
    describe() {
      return {
        name: ENGINE_MAP.Blink
      };
    }
  },
  /* WebKit */
  {
    test: [/(apple)?webkit/i],
    describe(ua) {
      const engine = {
        name: ENGINE_MAP.WebKit
      };
      const version2 = Utils.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, ua);
      if (version2) {
        engine.version = version2;
      }
      return engine;
    }
  }
];
let Parser$1 = class Parser2 {
  /**
   * Create instance of Parser
   *
   * @param {String} UA User-Agent string
   * @param {Boolean} [skipParsing=false] parser can skip parsing in purpose of performance
   * improvements if you need to make a more particular parsing
   * like {@link Parser#parseBrowser} or {@link Parser#parsePlatform}
   *
   * @throw {Error} in case of empty UA String
   *
   * @constructor
   */
  constructor(UA, skipParsing = false) {
    if (UA === void 0 || UA === null || UA === "") {
      throw new Error("UserAgent parameter can't be empty");
    }
    this._ua = UA;
    this.parsedResult = {};
    if (skipParsing !== true) {
      this.parse();
    }
  }
  /**
   * Get UserAgent string of current Parser instance
   * @return {String} User-Agent String of the current <Parser> object
   *
   * @public
   */
  getUA() {
    return this._ua;
  }
  /**
   * Test a UA string for a regexp
   * @param {RegExp} regex
   * @return {Boolean}
   */
  test(regex2) {
    return regex2.test(this._ua);
  }
  /**
   * Get parsed browser object
   * @return {Object}
   */
  parseBrowser() {
    this.parsedResult.browser = {};
    const browserDescriptor = Utils.find(browsersList, (_browser) => {
      if (typeof _browser.test === "function") {
        return _browser.test(this);
      }
      if (_browser.test instanceof Array) {
        return _browser.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (browserDescriptor) {
      this.parsedResult.browser = browserDescriptor.describe(this.getUA());
    }
    return this.parsedResult.browser;
  }
  /**
   * Get parsed browser object
   * @return {Object}
   *
   * @public
   */
  getBrowser() {
    if (this.parsedResult.browser) {
      return this.parsedResult.browser;
    }
    return this.parseBrowser();
  }
  /**
   * Get browser's name
   * @return {String} Browser's name or an empty string
   *
   * @public
   */
  getBrowserName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getBrowser().name).toLowerCase() || "";
    }
    return this.getBrowser().name || "";
  }
  /**
   * Get browser's version
   * @return {String} version of browser
   *
   * @public
   */
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  /**
   * Get OS
   * @return {Object}
   *
   * @example
   * this.getOS();
   * {
   *   name: 'macOS',
   *   version: '10.11.12'
   * }
   */
  getOS() {
    if (this.parsedResult.os) {
      return this.parsedResult.os;
    }
    return this.parseOS();
  }
  /**
   * Parse OS and save it to this.parsedResult.os
   * @return {*|{}}
   */
  parseOS() {
    this.parsedResult.os = {};
    const os = Utils.find(osParsersList, (_os) => {
      if (typeof _os.test === "function") {
        return _os.test(this);
      }
      if (_os.test instanceof Array) {
        return _os.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (os) {
      this.parsedResult.os = os.describe(this.getUA());
    }
    return this.parsedResult.os;
  }
  /**
   * Get OS name
   * @param {Boolean} [toLowerCase] return lower-cased value
   * @return {String} name of the OS — macOS, Windows, Linux, etc.
   */
  getOSName(toLowerCase) {
    const { name: name2 } = this.getOS();
    if (toLowerCase) {
      return String(name2).toLowerCase() || "";
    }
    return name2 || "";
  }
  /**
   * Get OS version
   * @return {String} full version with dots ('10.11.12', '5.6', etc)
   */
  getOSVersion() {
    return this.getOS().version;
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  getPlatform() {
    if (this.parsedResult.platform) {
      return this.parsedResult.platform;
    }
    return this.parsePlatform();
  }
  /**
   * Get platform name
   * @param {Boolean} [toLowerCase=false]
   * @return {*}
   */
  getPlatformType(toLowerCase = false) {
    const { type } = this.getPlatform();
    if (toLowerCase) {
      return String(type).toLowerCase() || "";
    }
    return type || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parsePlatform() {
    this.parsedResult.platform = {};
    const platform = Utils.find(platformParsersList, (_platform) => {
      if (typeof _platform.test === "function") {
        return _platform.test(this);
      }
      if (_platform.test instanceof Array) {
        return _platform.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (platform) {
      this.parsedResult.platform = platform.describe(this.getUA());
    }
    return this.parsedResult.platform;
  }
  /**
   * Get parsed engine
   * @return {{}}
   */
  getEngine() {
    if (this.parsedResult.engine) {
      return this.parsedResult.engine;
    }
    return this.parseEngine();
  }
  /**
   * Get engines's name
   * @return {String} Engines's name or an empty string
   *
   * @public
   */
  getEngineName(toLowerCase) {
    if (toLowerCase) {
      return String(this.getEngine().name).toLowerCase() || "";
    }
    return this.getEngine().name || "";
  }
  /**
   * Get parsed platform
   * @return {{}}
   */
  parseEngine() {
    this.parsedResult.engine = {};
    const engine = Utils.find(enginesParsersList, (_engine) => {
      if (typeof _engine.test === "function") {
        return _engine.test(this);
      }
      if (_engine.test instanceof Array) {
        return _engine.test.some((condition) => this.test(condition));
      }
      throw new Error("Browser's test function is not valid");
    });
    if (engine) {
      this.parsedResult.engine = engine.describe(this.getUA());
    }
    return this.parsedResult.engine;
  }
  /**
   * Parse full information about the browser
   * @returns {Parser}
   */
  parse() {
    this.parseBrowser();
    this.parseOS();
    this.parsePlatform();
    this.parseEngine();
    return this;
  }
  /**
   * Get parsed result
   * @return {ParsedResult}
   */
  getResult() {
    return Utils.assign({}, this.parsedResult);
  }
  /**
   * Check if parsed browser matches certain conditions
   *
   * @param {Object} checkTree It's one or two layered object,
   * which can include a platform or an OS on the first layer
   * and should have browsers specs on the bottom-laying layer
   *
   * @returns {Boolean|undefined} Whether the browser satisfies the set conditions or not.
   * Returns `undefined` when the browser is no described in the checkTree object.
   *
   * @example
   * const browser = Bowser.getParser(window.navigator.userAgent);
   * if (browser.satisfies({chrome: '>118.01.1322' }))
   * // or with os
   * if (browser.satisfies({windows: { chrome: '>118.01.1322' } }))
   * // or with platforms
   * if (browser.satisfies({desktop: { chrome: '>118.01.1322' } }))
   */
  satisfies(checkTree) {
    const platformsAndOSes = {};
    let platformsAndOSCounter = 0;
    const browsers = {};
    let browsersCounter = 0;
    const allDefinitions = Object.keys(checkTree);
    allDefinitions.forEach((key) => {
      const currentDefinition = checkTree[key];
      if (typeof currentDefinition === "string") {
        browsers[key] = currentDefinition;
        browsersCounter += 1;
      } else if (typeof currentDefinition === "object") {
        platformsAndOSes[key] = currentDefinition;
        platformsAndOSCounter += 1;
      }
    });
    if (platformsAndOSCounter > 0) {
      const platformsAndOSNames = Object.keys(platformsAndOSes);
      const OSMatchingDefinition = Utils.find(platformsAndOSNames, (name2) => this.isOS(name2));
      if (OSMatchingDefinition) {
        const osResult = this.satisfies(platformsAndOSes[OSMatchingDefinition]);
        if (osResult !== void 0) {
          return osResult;
        }
      }
      const platformMatchingDefinition = Utils.find(
        platformsAndOSNames,
        (name2) => this.isPlatform(name2)
      );
      if (platformMatchingDefinition) {
        const platformResult = this.satisfies(platformsAndOSes[platformMatchingDefinition]);
        if (platformResult !== void 0) {
          return platformResult;
        }
      }
    }
    if (browsersCounter > 0) {
      const browserNames = Object.keys(browsers);
      const matchingDefinition = Utils.find(browserNames, (name2) => this.isBrowser(name2, true));
      if (matchingDefinition !== void 0) {
        return this.compareVersion(browsers[matchingDefinition]);
      }
    }
    return void 0;
  }
  /**
   * Check if the browser name equals the passed string
   * @param browserName The string to compare with the browser name
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {boolean}
   */
  isBrowser(browserName, includingAlias = false) {
    const defaultBrowserName = this.getBrowserName().toLowerCase();
    let browserNameLower = browserName.toLowerCase();
    const alias = Utils.getBrowserTypeByAlias(browserNameLower);
    if (includingAlias && alias) {
      browserNameLower = alias.toLowerCase();
    }
    return browserNameLower === defaultBrowserName;
  }
  compareVersion(version2) {
    let expectedResults = [0];
    let comparableVersion = version2;
    let isLoose = false;
    const currentBrowserVersion = this.getBrowserVersion();
    if (typeof currentBrowserVersion !== "string") {
      return void 0;
    }
    if (version2[0] === ">" || version2[0] === "<") {
      comparableVersion = version2.substr(1);
      if (version2[1] === "=") {
        isLoose = true;
        comparableVersion = version2.substr(2);
      } else {
        expectedResults = [];
      }
      if (version2[0] === ">") {
        expectedResults.push(1);
      } else {
        expectedResults.push(-1);
      }
    } else if (version2[0] === "=") {
      comparableVersion = version2.substr(1);
    } else if (version2[0] === "~") {
      isLoose = true;
      comparableVersion = version2.substr(1);
    }
    return expectedResults.indexOf(
      Utils.compareVersions(currentBrowserVersion, comparableVersion, isLoose)
    ) > -1;
  }
  isOS(osName) {
    return this.getOSName(true) === String(osName).toLowerCase();
  }
  isPlatform(platformType) {
    return this.getPlatformType(true) === String(platformType).toLowerCase();
  }
  isEngine(engineName) {
    return this.getEngineName(true) === String(engineName).toLowerCase();
  }
  /**
   * Is anything? Check if the browser is called "anything",
   * the OS called "anything" or the platform called "anything"
   * @param {String} anything
   * @param [includingAlias=false] The flag showing whether alias will be included into comparison
   * @returns {Boolean}
   */
  is(anything, includingAlias = false) {
    return this.isBrowser(anything, includingAlias) || this.isOS(anything) || this.isPlatform(anything);
  }
  /**
   * Check if any of the given values satisfies this.is(anything)
   * @param {String[]} anythings
   * @returns {Boolean}
   */
  some(anythings = []) {
    return anythings.some((anything) => this.is(anything));
  }
};
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class Bowser {
  /**
   * Creates a {@link Parser} instance
   *
   * @param {String} UA UserAgent string
   * @param {Boolean} [skipParsing=false] Will make the Parser postpone parsing until you ask it
   * explicitly. Same as `skipParsing` for {@link Parser}.
   * @returns {Parser}
   * @throws {Error} when UA is not a String
   *
   * @example
   * const parser = Bowser.getParser(window.navigator.userAgent);
   * const result = parser.getResult();
   */
  static getParser(UA, skipParsing = false) {
    if (typeof UA !== "string") {
      throw new Error("UserAgent should be a string");
    }
    return new Parser$1(UA, skipParsing);
  }
  /**
   * Creates a {@link Parser} instance and runs {@link Parser.getResult} immediately
   *
   * @param UA
   * @return {ParsedResult}
   *
   * @example
   * const result = Bowser.parse(window.navigator.userAgent);
   */
  static parse(UA) {
    return new Parser$1(UA).getResult();
  }
  static get BROWSER_MAP() {
    return BROWSER_MAP;
  }
  static get ENGINE_MAP() {
    return ENGINE_MAP;
  }
  static get OS_MAP() {
    return OS_MAP;
  }
  static get PLATFORMS_MAP() {
    return PLATFORMS_MAP;
  }
}
const defaultUserAgent = ({ serviceId, clientVersion }) => async () => {
  var _a3, _b3, _c2, _d2, _e2;
  const parsedUA = typeof window !== "undefined" && ((_a3 = window == null ? void 0 : window.navigator) == null ? void 0 : _a3.userAgent) ? Bowser.parse(window.navigator.userAgent) : void 0;
  const sections = [
    ["aws-sdk-js", clientVersion],
    [`os/${((_b3 = parsedUA == null ? void 0 : parsedUA.os) == null ? void 0 : _b3.name) || "other"}`, (_c2 = parsedUA == null ? void 0 : parsedUA.os) == null ? void 0 : _c2.version],
    ["lang/js"],
    ["md/browser", `${((_d2 = parsedUA == null ? void 0 : parsedUA.browser) == null ? void 0 : _d2.name) ?? "unknown"}_${((_e2 = parsedUA == null ? void 0 : parsedUA.browser) == null ? void 0 : _e2.version) ?? "unknown"}`]
  ];
  if (serviceId) {
    sections.push([`api/${serviceId}`, clientVersion]);
  }
  return sections;
};
class SignatureV4MultiRegion {
  constructor(options2) {
    this.sigv4Signer = new SignatureV4(options2);
    this.signerOptions = options2;
  }
  async sign(requestToSign, options2 = {}) {
    if (options2.signingRegion === "*") {
      if (this.signerOptions.runtime !== "node")
        throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
      return this.getSigv4aSigner().sign(requestToSign, options2);
    }
    return this.sigv4Signer.sign(requestToSign, options2);
  }
  async presign(originalRequest, options2 = {}) {
    if (options2.signingRegion === "*") {
      if (this.signerOptions.runtime !== "node")
        throw new Error("This request requires signing with SigV4Asymmetric algorithm. It's only available in Node.js");
      return this.getSigv4aSigner().presign(originalRequest, options2);
    }
    return this.sigv4Signer.presign(originalRequest, options2);
  }
  getSigv4aSigner() {
    if (!this.sigv4aSigner) {
      let CrtSignerV4;
      try {
        CrtSignerV4 = typeof require === "function" && require("@aws-sdk/signature-v4-crt").CrtSignerV4;
        if (typeof CrtSignerV4 !== "function")
          throw new Error();
      } catch (e3) {
        e3.message = `${e3.message}
Please check if you have installed "@aws-sdk/signature-v4-crt" package explicitly. 
For more information please go to https://github.com/aws/aws-sdk-js-v3#functionality-requiring-aws-common-runtime-crt`;
        throw e3;
      }
      this.sigv4aSigner = new CrtSignerV4({
        ...this.signerOptions,
        signingAlgorithm: 1
      });
    }
    return this.sigv4aSigner;
  }
}
const bV = "required", bW = "type", bX = "rules", bY = "conditions", bZ = "fn", ca = "argv", cb = "ref", cc = "assign", cd = "url", ce = "properties", cf = "authSchemes", cg = "disableDoubleEncoding", ch = "signingName", ci = "signingRegion", cj = "headers";
const a$4 = false, b = true, c$1 = "tree", d = "isSet", e$1 = "substring", f$2 = "hardwareType", g$2 = "regionPrefix", h = "abbaSuffix", i$5 = "outpostId", j$2 = "aws.partition", k$2 = "stringEquals", l$2 = "isValidHostLabel", m$2 = "not", n$4 = "error", o$3 = "parseURL", p$1 = "s3-outposts", q = "endpoint", r$3 = "booleanEquals", s$1 = "aws.parseArn", t$2 = "s3", u$1 = "aws.isVirtualHostableS3Bucket", v$3 = "getAttr", w = "name", x$1 = "Host override cannot be combined with Dualstack, FIPS, or S3 Accelerate", y$1 = "https://{Bucket}.s3.{partitionResult#dnsSuffix}", z = "bucketArn", A$1 = "arnType", B$1 = "", C$1 = "s3-object-lambda", D$2 = "accesspoint", E$2 = "accessPointName", F$1 = "{url#scheme}://{accessPointName}-{bucketArn#accountId}.{url#authority}{url#path}", G$1 = "mrapPartition", H$1 = "outpostType", I$2 = "arnPrefix", J = "{url#scheme}://{url#authority}{url#path}", K = "https://s3.{partitionResult#dnsSuffix}", L$1 = { [bV]: false, [bW]: "String" }, M = { [bV]: true, "default": false, [bW]: "Boolean" }, N$1 = { [bV]: false, [bW]: "Boolean" }, O$1 = { [bZ]: d, [ca]: [{ [cb]: "Bucket" }] }, P = { [cb]: "Bucket" }, Q = { [cb]: f$2 }, R$1 = { [bY]: [{ [bZ]: m$2, [ca]: [{ [bZ]: d, [ca]: [{ [cb]: "Endpoint" }] }] }], [n$4]: "Expected a endpoint to be specified but no endpoint was found", [bW]: n$4 }, S$1 = { [bZ]: m$2, [ca]: [{ [bZ]: d, [ca]: [{ [cb]: "Endpoint" }] }] }, T = { [bZ]: d, [ca]: [{ [cb]: "Endpoint" }] }, U$1 = { [bZ]: o$3, [ca]: [{ [cb]: "Endpoint" }], [cc]: "url" }, V$3 = { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: p$1, [ci]: "{Region}" }] }, W$1 = {}, X$2 = { [cb]: "ForcePathStyle" }, Y$1 = { [bY]: [{ [bZ]: "uriEncode", [ca]: [P], [cc]: "uri_encoded_bucket" }], [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, T], [n$4]: "Cannot set dual-stack in combination with a custom endpoint.", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: j$2, [ca]: [{ [cb]: "Region" }], [cc]: "partitionResult" }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "Accelerate" }, false] }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, true] }], [bW]: c$1, [bX]: [{ [q]: { [cd]: "https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }] }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, false] }], [q]: { [cd]: "https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, true] }], [bW]: c$1, [bX]: [{ [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }] }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, false] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3-fips.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3-fips.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, true] }], [bW]: c$1, [bX]: [{ [q]: { [cd]: "https://s3-fips.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }] }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, false] }], [q]: { [cd]: "https://s3-fips.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, true] }], [bW]: c$1, [bX]: [{ [q]: { [cd]: "https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }] }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, false] }], [q]: { [cd]: "https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, true] }], [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "us-east-1"] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }, { [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }] }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, T, U$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, false] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, true] }], [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "us-east-1"] }], [q]: { [cd]: "https://s3.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }, { [q]: { [cd]: "https://s3.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }] }, { [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, S$1, { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, false] }], [q]: { [cd]: "https://s3.{Region}.{partitionResult#dnsSuffix}/{uri_encoded_bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, [cj]: {} }, [bW]: q }] }] }, { [n$4]: "Path-style addressing cannot be used with S3 Accelerate", [bW]: n$4 }] }] }, { [n$4]: "A valid partition could not be determined", [bW]: n$4 }] }] }, Z$1 = { [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, true] }, aa = { [bZ]: r$3, [ca]: [{ [cb]: "Accelerate" }, false] }, ab = { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, true] }, ac = { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }] }, ad = { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, true] }, ae = { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{Region}" }] }, af = { [bZ]: r$3, [ca]: [{ [cb]: "UseGlobalEndpoint" }, false] }, ag = { [bZ]: r$3, [ca]: [{ [cb]: "UseDualStack" }, false] }, ah = { [bZ]: r$3, [ca]: [{ [cb]: "UseFIPS" }, false] }, ai = { [n$4]: "A valid partition could not be determined", [bW]: n$4 }, aj = { [bY]: [ab, { [bZ]: k$2, [ca]: [{ [bZ]: v$3, [ca]: [{ [cb]: "partitionResult" }, w] }, "aws-cn"] }], [n$4]: "Partition does not support FIPS", [bW]: n$4 }, ak = { [bZ]: k$2, [ca]: [{ [bZ]: v$3, [ca]: [{ [cb]: "partitionResult" }, w] }, "aws-cn"] }, al = { [bZ]: r$3, [ca]: [{ [cb]: "Accelerate" }, true] }, am = { [bY]: [Z$1, ab, aa, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://{Bucket}.s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, an = { [cd]: "https://{Bucket}.s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, ao = { [bY]: [ag, ab, aa, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://{Bucket}.s3-fips.us-east-1.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, ap = { [cd]: "https://{Bucket}.s3-fips.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, aq = { [bY]: [Z$1, ah, al, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://{Bucket}.s3-accelerate.dualstack.us-east-1.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, ar = { [cd]: "https://{Bucket}.s3-accelerate.dualstack.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, as = { [bY]: [Z$1, ah, aa, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://{Bucket}.s3.dualstack.us-east-1.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, at = { [cd]: "https://{Bucket}.s3.dualstack.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, au = { [bY]: [ag, ah, aa, T, U$1, { [bZ]: r$3, [ca]: [{ [bZ]: v$3, [ca]: [{ [cb]: "url" }, "isIp"] }, true] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{Bucket}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, av = { [bZ]: r$3, [ca]: [{ [bZ]: v$3, [ca]: [{ [cb]: "url" }, "isIp"] }, true] }, aw = { [cb]: "url" }, ax = { [bY]: [ag, ah, aa, T, U$1, { [bZ]: r$3, [ca]: [{ [bZ]: v$3, [ca]: [aw, "isIp"] }, false] }, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "{url#scheme}://{Bucket}.{url#authority}{url#path}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, ay = { [bZ]: r$3, [ca]: [{ [bZ]: v$3, [ca]: [aw, "isIp"] }, false] }, az = { [cd]: "{url#scheme}://{url#authority}{url#normalizedPath}{Bucket}", [ce]: ae, [cj]: {} }, aA = { [cd]: "{url#scheme}://{Bucket}.{url#authority}{url#path}", [ce]: ae, [cj]: {} }, aB = { [q]: aA, [bW]: q }, aC = { [bY]: [ag, ah, al, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://{Bucket}.s3-accelerate.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, aD = { [cd]: "https://{Bucket}.s3-accelerate.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, aE = { [bY]: [ag, ah, aa, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: y$1, [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, aF = { [cd]: "https://{Bucket}.s3.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, aG = { [n$4]: "Invalid region: region was not a valid DNS name.", [bW]: n$4 }, aH = { [cb]: z }, aI = { [cb]: A$1 }, aJ = { [bZ]: v$3, [ca]: [aH, "service"] }, aK = { [cb]: E$2 }, aL = { [bY]: [Z$1], [n$4]: "S3 Object Lambda does not support Dual-stack", [bW]: n$4 }, aM = { [bY]: [al], [n$4]: "S3 Object Lambda does not support S3 Accelerate", [bW]: n$4 }, aN = { [bY]: [{ [bZ]: d, [ca]: [{ [cb]: "DisableAccessPoints" }] }, { [bZ]: r$3, [ca]: [{ [cb]: "DisableAccessPoints" }, true] }], [n$4]: "Access points are not supported for this operation", [bW]: n$4 }, aO = { [bY]: [{ [bZ]: d, [ca]: [{ [cb]: "UseArnRegion" }] }, { [bZ]: r$3, [ca]: [{ [cb]: "UseArnRegion" }, false] }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [bZ]: v$3, [ca]: [aH, "region"] }, "{Region}"] }] }], [n$4]: "Invalid configuration: region from ARN `{bucketArn#region}` does not match client region `{Region}` and UseArnRegion is `false`", [bW]: n$4 }, aP = { [bZ]: v$3, [ca]: [{ [cb]: "bucketPartition" }, w] }, aQ = { [bZ]: v$3, [ca]: [aH, "accountId"] }, aR = { [bY]: [ab, { [bZ]: k$2, [ca]: [aP, "aws-cn"] }], [n$4]: "Partition does not support FIPS", [bW]: n$4 }, aS = { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: C$1, [ci]: "{bucketArn#region}" }] }, aT = { [n$4]: "Invalid ARN: The access point name may only contain a-z, A-Z, 0-9 and `-`. Found: `{accessPointName}`", [bW]: n$4 }, aU = { [n$4]: "Invalid ARN: The account id may only contain a-z, A-Z, 0-9 and `-`. Found: `{bucketArn#accountId}`", [bW]: n$4 }, aV = { [n$4]: "Invalid region in ARN: `{bucketArn#region}` (invalid DNS name)", [bW]: n$4 }, aW = { [n$4]: "Client was configured for partition `{partitionResult#name}` but ARN (`{Bucket}`) has `{bucketPartition#name}`", [bW]: n$4 }, aX = { [n$4]: "Could not load partition for ARN region `{bucketArn#region}`", [bW]: n$4 }, aY = { [n$4]: "Invalid ARN: The ARN may only contain a single resource component after `accesspoint`.", [bW]: n$4 }, aZ = { [n$4]: "Invalid ARN: bucket ARN is missing a region", [bW]: n$4 }, ba = { [n$4]: "Invalid ARN: Expected a resource of the format `accesspoint:<accesspoint name>` but no name was provided", [bW]: n$4 }, bb = { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "{bucketArn#region}" }] }, bc = { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: p$1, [ci]: "{bucketArn#region}" }] }, bd = { [cb]: "UseObjectLambdaEndpoint" }, be = { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: C$1, [ci]: "{Region}" }] }, bf = { [bY]: [ab, Z$1, T, U$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: J, [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, bg = { [q]: { [cd]: J, [ce]: ae, [cj]: {} }, [bW]: q }, bh = { [cd]: J, [ce]: ae, [cj]: {} }, bi = { [bY]: [ab, Z$1, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3-fips.dualstack.us-east-1.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, bj = { [cd]: "https://s3-fips.dualstack.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, bk = { [bY]: [ab, ag, T, U$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: J, [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, bl = { [bY]: [ab, ag, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3-fips.us-east-1.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, bm = { [cd]: "https://s3-fips.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, bn = { [bY]: [ah, Z$1, T, U$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: J, [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, bo = { [bY]: [ah, Z$1, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: "https://s3.dualstack.us-east-1.{partitionResult#dnsSuffix}", [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, bp = { [cd]: "https://s3.dualstack.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, bq = { [bY]: [ah, ag, T, U$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: J, [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, br = { [bY]: [ah, ag, S$1, { [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "aws-global"] }], [q]: { [cd]: K, [ce]: { [cf]: [{ [cg]: true, [w]: "sigv4", [ch]: t$2, [ci]: "us-east-1" }] }, [cj]: {} }, [bW]: q }, bs = { [cd]: "https://s3.{Region}.{partitionResult#dnsSuffix}", [ce]: ae, [cj]: {} }, bt = [{ [cb]: "Region" }], bu = [P], bv = [{ [bZ]: l$2, [ca]: [{ [cb]: i$5 }, false] }], bw = [{ [bZ]: k$2, [ca]: [{ [cb]: g$2 }, "beta"] }], bx = [{ [cb]: "Endpoint" }], by = [T, U$1], bz = [O$1], bA = [{ [bZ]: s$1, [ca]: [P] }], bB = [Z$1, T], bC = [{ [bZ]: j$2, [ca]: bt, [cc]: "partitionResult" }], bD = [{ [bZ]: k$2, [ca]: [{ [cb]: "Region" }, "us-east-1"] }], bE = [{ [bZ]: l$2, [ca]: [{ [cb]: "Region" }, false] }], bF = [{ [bZ]: k$2, [ca]: [aI, D$2] }], bG = [{ [bZ]: v$3, [ca]: [aH, "resourceId[1]"], [cc]: E$2 }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [aK, B$1] }] }], bH = [aH, "resourceId[1]"], bI = [Z$1], bJ = [al], bK = [{ [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [{ [bZ]: v$3, [ca]: [aH, "region"] }, B$1] }] }], bL = [{ [bZ]: m$2, [ca]: [{ [bZ]: d, [ca]: [{ [bZ]: v$3, [ca]: [aH, "resourceId[2]"] }] }] }], bM = [aH, "resourceId[2]"], bN = [{ [bZ]: j$2, [ca]: [{ [bZ]: v$3, [ca]: [aH, "region"] }], [cc]: "bucketPartition" }], bO = [{ [bZ]: k$2, [ca]: [aP, { [bZ]: v$3, [ca]: [{ [cb]: "partitionResult" }, w] }] }], bP = [{ [bZ]: l$2, [ca]: [{ [bZ]: v$3, [ca]: [aH, "region"] }, true] }], bQ = [{ [bZ]: l$2, [ca]: [aQ, false] }], bR = [{ [bZ]: l$2, [ca]: [aK, false] }], bS = [ab], bT = [{ [bZ]: l$2, [ca]: [{ [cb]: "Region" }, true] }], bU = [bg];
const _data = { version: "1.0", parameters: { Bucket: L$1, Region: L$1, UseFIPS: M, UseDualStack: M, Endpoint: L$1, ForcePathStyle: N$1, Accelerate: M, UseGlobalEndpoint: M, UseObjectLambdaEndpoint: N$1, DisableAccessPoints: N$1, DisableMultiRegionAccessPoints: M, UseArnRegion: N$1 }, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: d, [ca]: bt }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [O$1, { [bZ]: e$1, [ca]: [P, 49, 50, b], [cc]: f$2 }, { [bZ]: e$1, [ca]: [P, 8, 12, b], [cc]: g$2 }, { [bZ]: e$1, [ca]: [P, 0, 7, b], [cc]: h }, { [bZ]: e$1, [ca]: [P, 32, 49, b], [cc]: i$5 }, { [bZ]: j$2, [ca]: bt, [cc]: "regionPartition" }, { [bZ]: k$2, [ca]: [{ [cb]: h }, "--op-s3"] }], [bW]: c$1, [bX]: [{ [bY]: bv, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [Q, "e"] }], [bW]: c$1, [bX]: [{ [bY]: bw, [bW]: c$1, [bX]: [R$1, { [bY]: by, endpoint: { [cd]: "https://{Bucket}.ec2.{url#authority}", [ce]: V$3, [cj]: W$1 }, [bW]: q }] }, { endpoint: { [cd]: "https://{Bucket}.ec2.s3-outposts.{Region}.{regionPartition#dnsSuffix}", [ce]: V$3, [cj]: W$1 }, [bW]: q }] }, { [bY]: [{ [bZ]: k$2, [ca]: [Q, "o"] }], [bW]: c$1, [bX]: [{ [bY]: bw, [bW]: c$1, [bX]: [R$1, { [bY]: by, endpoint: { [cd]: "https://{Bucket}.op-{outpostId}.{url#authority}", [ce]: V$3, [cj]: W$1 }, [bW]: q }] }, { endpoint: { [cd]: "https://{Bucket}.op-{outpostId}.s3-outposts.{Region}.{regionPartition#dnsSuffix}", [ce]: V$3, [cj]: W$1 }, [bW]: q }] }, { error: 'Unrecognized hardware type: "Expected hardware type o or e but got {hardwareType}"', [bW]: n$4 }] }] }, { error: "Invalid ARN: The outpost Id must only contain a-z, A-Z, 0-9 and `-`.", [bW]: n$4 }] }, { [bY]: bz, [bW]: c$1, [bX]: [{ [bY]: [T, { [bZ]: m$2, [ca]: [{ [bZ]: d, [ca]: [{ [bZ]: o$3, [ca]: bx }] }] }], error: "Custom endpoint `{Endpoint}` was not a valid URI", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: d, [ca]: [X$2] }, { [bZ]: r$3, [ca]: [X$2, b] }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bA, error: "Path-style addressing cannot be used with ARN buckets", [bW]: n$4 }, Y$1] }] }, { [bY]: [{ [bZ]: u$1, [ca]: [P, a$4] }], [bW]: c$1, [bX]: [{ [bY]: bC, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bE, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aj, { [bW]: c$1, [bX]: [{ [bY]: [al, ab], error: "Accelerate cannot be used with FIPS", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [al, ak], error: "S3 Accelerate cannot be used in this region", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [T, Z$1], error: x$1, [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [T, ab], error: x$1, [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [T, al], error: x$1, [bW]: n$4 }, { [bW]: c$1, [bX]: [am, am, { [bY]: [Z$1, ab, aa, S$1, ac, ad], [bW]: c$1, [bX]: [{ endpoint: an, [bW]: q }] }, { [bY]: [Z$1, ab, aa, S$1, ac, af], endpoint: an, [bW]: q }, ao, ao, { [bY]: [ag, ab, aa, S$1, ac, ad], [bW]: c$1, [bX]: [{ endpoint: ap, [bW]: q }] }, { [bY]: [ag, ab, aa, S$1, ac, af], endpoint: ap, [bW]: q }, aq, aq, { [bY]: [Z$1, ah, al, S$1, ac, ad], [bW]: c$1, [bX]: [{ endpoint: ar, [bW]: q }] }, { [bY]: [Z$1, ah, al, S$1, ac, af], endpoint: ar, [bW]: q }, as, as, { [bY]: [Z$1, ah, aa, S$1, ac, ad], [bW]: c$1, [bX]: [{ endpoint: at, [bW]: q }] }, { [bY]: [Z$1, ah, aa, S$1, ac, af], endpoint: at, [bW]: q }, au, ax, au, ax, { [bY]: [ag, ah, aa, T, U$1, av, ac, ad], [bW]: c$1, [bX]: [{ [bY]: bD, endpoint: az, [bW]: q }, { endpoint: az, [bW]: q }] }, { [bY]: [ag, ah, aa, T, U$1, ay, ac, ad], [bW]: c$1, [bX]: [{ [bY]: bD, endpoint: aA, [bW]: q }, aB] }, { [bY]: [ag, ah, aa, T, U$1, av, ac, af], endpoint: az, [bW]: q }, { [bY]: [ag, ah, aa, T, U$1, ay, ac, af], endpoint: aA, [bW]: q }, aC, aC, { [bY]: [ag, ah, al, S$1, ac, ad], [bW]: c$1, [bX]: [{ [bY]: bD, endpoint: aD, [bW]: q }, { endpoint: aD, [bW]: q }] }, { [bY]: [ag, ah, al, S$1, ac, af], endpoint: aD, [bW]: q }, aE, aE, { [bY]: [ag, ah, aa, S$1, ac, ad], [bW]: c$1, [bX]: [{ [bY]: bD, endpoint: { [cd]: y$1, [ce]: ae, [cj]: W$1 }, [bW]: q }, { endpoint: aF, [bW]: q }] }, { [bY]: [ag, ah, aa, S$1, ac, af], endpoint: aF, [bW]: q }] }] }] }] }] }] }] }] }, aG] }] }, ai] }, { [bY]: [T, U$1, { [bZ]: k$2, [ca]: [{ [bZ]: v$3, [ca]: [aw, "scheme"] }, "http"] }, { [bZ]: u$1, [ca]: [P, b] }, ah, ag, aa], [bW]: c$1, [bX]: [{ [bY]: bC, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bE, [bW]: c$1, [bX]: [aB] }, aG] }] }, ai] }, { [bY]: [{ [bZ]: s$1, [ca]: bu, [cc]: z }], [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: v$3, [ca]: [aH, "resourceId[0]"], [cc]: A$1 }, { [bZ]: m$2, [ca]: [{ [bZ]: k$2, [ca]: [aI, B$1] }] }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [aJ, C$1] }], [bW]: c$1, [bX]: [{ [bY]: bF, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bG, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aL, { [bW]: c$1, [bX]: [aM, { [bW]: c$1, [bX]: [{ [bY]: bK, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aN, { [bW]: c$1, [bX]: [{ [bY]: bL, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aO, { [bW]: c$1, [bX]: [{ [bY]: bN, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bC, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bO, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bP, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [aQ, B$1] }], error: "Invalid ARN: Missing account id", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: bQ, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bR, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aR, { [bW]: c$1, [bX]: [{ [bY]: by, endpoint: { [cd]: F$1, [ce]: aS, [cj]: W$1 }, [bW]: q }, { [bY]: bS, endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.s3-object-lambda-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}", [ce]: aS, [cj]: W$1 }, [bW]: q }, { endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.s3-object-lambda.{bucketArn#region}.{bucketPartition#dnsSuffix}", [ce]: aS, [cj]: W$1 }, [bW]: q }] }] }] }, aT] }] }, aU] }] }] }, aV] }] }, aW] }] }, ai] }] }, aX] }] }] }, aY] }] }] }, aZ] }] }] }] }, ba] }] }, { error: "Invalid ARN: Object Lambda ARNs only support `accesspoint` arn types, but found: `{arnType}`", [bW]: n$4 }] }, { [bY]: bF, [bW]: c$1, [bX]: [{ [bY]: bG, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bK, [bW]: c$1, [bX]: [{ [bY]: bF, [bW]: c$1, [bX]: [{ [bY]: bK, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aN, { [bW]: c$1, [bX]: [{ [bY]: bL, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aO, { [bW]: c$1, [bX]: [{ [bY]: bN, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bC, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [aP, "{partitionResult#name}"] }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bP, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [aJ, t$2] }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bQ, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bR, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bJ, error: "Access Points do not support S3 Accelerate", [bW]: n$4 }, { [bW]: c$1, [bX]: [aR, { [bW]: c$1, [bX]: [{ [bY]: bB, error: "DualStack cannot be combined with a Host override (PrivateLink)", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [ab, Z$1], endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint-fips.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}", [ce]: bb, [cj]: W$1 }, [bW]: q }, { [bY]: [ab, ag], endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint-fips.{bucketArn#region}.{bucketPartition#dnsSuffix}", [ce]: bb, [cj]: W$1 }, [bW]: q }, { [bY]: [ah, Z$1], endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint.dualstack.{bucketArn#region}.{bucketPartition#dnsSuffix}", [ce]: bb, [cj]: W$1 }, [bW]: q }, { [bY]: [ah, ag, T, U$1], endpoint: { [cd]: F$1, [ce]: bb, [cj]: W$1 }, [bW]: q }, { [bY]: [ah, ag], endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.s3-accesspoint.{bucketArn#region}.{bucketPartition#dnsSuffix}", [ce]: bb, [cj]: W$1 }, [bW]: q }] }] }] }] }] }, aT] }] }, aU] }] }, { error: "Invalid ARN: The ARN was not for the S3 service, found: {bucketArn#service}", [bW]: n$4 }] }] }, aV] }] }, aW] }] }, ai] }] }, aX] }] }] }, aY] }] }] }, aZ] }] }, { [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: l$2, [ca]: [aK, b] }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bI, error: "S3 MRAP does not support dual-stack", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: bS, error: "S3 MRAP does not support FIPS", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: bJ, error: "S3 MRAP does not support S3 Accelerate", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: r$3, [ca]: [{ [cb]: "DisableMultiRegionAccessPoints" }, b] }], error: "Invalid configuration: Multi-Region Access Point ARNs are disabled.", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: j$2, [ca]: bt, [cc]: G$1 }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [{ [bZ]: v$3, [ca]: [{ [cb]: G$1 }, w] }, { [bZ]: v$3, [ca]: [aH, "partition"] }] }], [bW]: c$1, [bX]: [{ endpoint: { [cd]: "https://{accessPointName}.accesspoint.s3-global.{mrapPartition#dnsSuffix}", [ce]: { [cf]: [{ [cg]: b, name: "sigv4a", [ch]: t$2, signingRegionSet: ["*"] }] }, [cj]: W$1 }, [bW]: q }] }, { error: "Client was configured for partition `{mrapPartition#name}` but bucket referred to partition `{bucketArn#partition}`", [bW]: n$4 }] }] }, { error: "{Region} was not a valid region", [bW]: n$4 }] }] }] }] }] }] }, { error: "Invalid Access Point Name", [bW]: n$4 }] }] }] }, ba] }, { [bY]: [{ [bZ]: k$2, [ca]: [aJ, p$1] }], [bW]: c$1, [bX]: [{ [bY]: bI, error: "S3 Outposts does not support Dual-stack", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: bS, error: "S3 Outposts does not support FIPS", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: bJ, error: "S3 Outposts does not support S3 Accelerate", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: d, [ca]: [{ [bZ]: v$3, [ca]: [aH, "resourceId[4]"] }] }], error: "Invalid Arn: Outpost Access Point ARN contains sub resources", [bW]: n$4 }, { [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: v$3, [ca]: bH, [cc]: i$5 }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bv, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aO, { [bW]: c$1, [bX]: [{ [bY]: bN, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bC, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bO, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bP, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bQ, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: v$3, [ca]: bM, [cc]: H$1 }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: v$3, [ca]: [aH, "resourceId[3]"], [cc]: E$2 }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: [{ [bZ]: k$2, [ca]: [{ [cb]: H$1 }, D$2] }], [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: by, endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.{outpostId}.{url#authority}", [ce]: bc, [cj]: W$1 }, [bW]: q }, { endpoint: { [cd]: "https://{accessPointName}-{bucketArn#accountId}.{outpostId}.s3-outposts.{bucketArn#region}.{bucketPartition#dnsSuffix}", [ce]: bc, [cj]: W$1 }, [bW]: q }] }] }, { error: "Expected an outpost type `accesspoint`, found {outpostType}", [bW]: n$4 }] }] }, { error: "Invalid ARN: expected an access point name", [bW]: n$4 }] }] }, { error: "Invalid ARN: Expected a 4-component resource", [bW]: n$4 }] }] }, aU] }] }, aV] }] }, aW] }] }, ai] }] }, { error: "Could not load partition for ARN region {bucketArn#region}", [bW]: n$4 }] }] }] }, { error: "Invalid ARN: The outpost Id may only contain a-z, A-Z, 0-9 and `-`. Found: `{outpostId}`", [bW]: n$4 }] }] }, { error: "Invalid ARN: The Outpost Id was not set", [bW]: n$4 }] }] }] }] }] }, { error: "Invalid ARN: Unrecognized format: {Bucket} (type: {arnType})", [bW]: n$4 }] }] }, { error: "Invalid ARN: No ARN type specified", [bW]: n$4 }] }, { [bY]: [{ [bZ]: e$1, [ca]: [P, 0, 4, a$4], [cc]: I$2 }, { [bZ]: k$2, [ca]: [{ [cb]: I$2 }, "arn:"] }, { [bZ]: m$2, [ca]: [{ [bZ]: d, [ca]: bA }] }], error: "Invalid ARN: `{Bucket}` was not a valid ARN", [bW]: n$4 }, Y$1] }] }, { [bY]: [{ [bZ]: d, [ca]: [bd] }, { [bZ]: r$3, [ca]: [bd, b] }], [bW]: c$1, [bX]: [{ [bY]: bC, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bT, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aL, { [bW]: c$1, [bX]: [aM, { [bW]: c$1, [bX]: [aj, { [bW]: c$1, [bX]: [{ [bY]: by, endpoint: { [cd]: J, [ce]: be, [cj]: W$1 }, [bW]: q }, { [bY]: bS, endpoint: { [cd]: "https://s3-object-lambda-fips.{Region}.{partitionResult#dnsSuffix}", [ce]: be, [cj]: W$1 }, [bW]: q }, { endpoint: { [cd]: "https://s3-object-lambda.{Region}.{partitionResult#dnsSuffix}", [ce]: be, [cj]: W$1 }, [bW]: q }] }] }] }] }] }, aG] }] }, ai] }, { [bY]: [{ [bZ]: m$2, [ca]: bz }], [bW]: c$1, [bX]: [{ [bY]: bC, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [{ [bY]: bT, [bW]: c$1, [bX]: [{ [bW]: c$1, [bX]: [aj, { [bW]: c$1, [bX]: [bf, bf, { [bY]: [ab, Z$1, T, U$1, ac, ad], [bW]: c$1, [bX]: bU }, { [bY]: [ab, Z$1, T, U$1, ac, af], endpoint: bh, [bW]: q }, bi, bi, { [bY]: [ab, Z$1, S$1, ac, ad], [bW]: c$1, [bX]: [{ endpoint: bj, [bW]: q }] }, { [bY]: [ab, Z$1, S$1, ac, af], endpoint: bj, [bW]: q }, bk, bk, { [bY]: [ab, ag, T, U$1, ac, ad], [bW]: c$1, [bX]: bU }, { [bY]: [ab, ag, T, U$1, ac, af], endpoint: bh, [bW]: q }, bl, bl, { [bY]: [ab, ag, S$1, ac, ad], [bW]: c$1, [bX]: [{ endpoint: bm, [bW]: q }] }, { [bY]: [ab, ag, S$1, ac, af], endpoint: bm, [bW]: q }, bn, bn, { [bY]: [ah, Z$1, T, U$1, ac, ad], [bW]: c$1, [bX]: bU }, { [bY]: [ah, Z$1, T, U$1, ac, af], endpoint: bh, [bW]: q }, bo, bo, { [bY]: [ah, Z$1, S$1, ac, ad], [bW]: c$1, [bX]: [{ endpoint: bp, [bW]: q }] }, { [bY]: [ah, Z$1, S$1, ac, af], endpoint: bp, [bW]: q }, bq, bq, { [bY]: [ah, ag, T, U$1, ac, ad], [bW]: c$1, [bX]: [{ [bY]: bD, endpoint: bh, [bW]: q }, bg] }, { [bY]: [ah, ag, T, U$1, ac, af], endpoint: bh, [bW]: q }, br, br, { [bY]: [ah, ag, S$1, ac, ad], [bW]: c$1, [bX]: [{ [bY]: bD, endpoint: { [cd]: K, [ce]: ae, [cj]: W$1 }, [bW]: q }, { endpoint: bs, [bW]: q }] }, { [bY]: [ah, ag, S$1, ac, af], endpoint: bs, [bW]: q }] }] }] }, aG] }] }, ai] }] }] }, { error: "A region must be set when sending requests to S3.", [bW]: n$4 }] }] };
const ruleSet = _data;
const defaultEndpointResolver = (endpointParams, context2 = {}) => {
  return resolveEndpoint(ruleSet, {
    endpointParams,
    logger: context2.logger
  });
};
const getRuntimeConfig$1 = (config2) => ({
  apiVersion: "2006-03-01",
  base64Decoder: (config2 == null ? void 0 : config2.base64Decoder) ?? fromBase64,
  base64Encoder: (config2 == null ? void 0 : config2.base64Encoder) ?? toBase64,
  disableHostPrefix: (config2 == null ? void 0 : config2.disableHostPrefix) ?? false,
  endpointProvider: (config2 == null ? void 0 : config2.endpointProvider) ?? defaultEndpointResolver,
  logger: (config2 == null ? void 0 : config2.logger) ?? new NoOpLogger(),
  serviceId: (config2 == null ? void 0 : config2.serviceId) ?? "S3",
  signerConstructor: (config2 == null ? void 0 : config2.signerConstructor) ?? SignatureV4MultiRegion,
  signingEscapePath: (config2 == null ? void 0 : config2.signingEscapePath) ?? false,
  urlParser: (config2 == null ? void 0 : config2.urlParser) ?? parseUrl,
  useArnRegion: (config2 == null ? void 0 : config2.useArnRegion) ?? false,
  utf8Decoder: (config2 == null ? void 0 : config2.utf8Decoder) ?? fromUtf8$3,
  utf8Encoder: (config2 == null ? void 0 : config2.utf8Encoder) ?? toUtf8$3
});
const DEFAULTS_MODE_OPTIONS = ["in-region", "cross-region", "mobile", "standard", "legacy"];
const resolveDefaultsModeConfig = ({ defaultsMode } = {}) => memoize$5(async () => {
  const mode2 = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
  switch (mode2 == null ? void 0 : mode2.toLowerCase()) {
    case "auto":
      return Promise.resolve(isMobileBrowser() ? "mobile" : "standard");
    case "mobile":
    case "in-region":
    case "cross-region":
    case "standard":
    case "legacy":
      return Promise.resolve(mode2 == null ? void 0 : mode2.toLocaleLowerCase());
    case void 0:
      return Promise.resolve("legacy");
    default:
      throw new Error(`Invalid parameter for "defaultsMode", expect ${DEFAULTS_MODE_OPTIONS.join(", ")}, got ${mode2}`);
  }
});
const isMobileBrowser = () => {
  var _a3, _b3;
  const parsedUA = typeof window !== "undefined" && ((_a3 = window == null ? void 0 : window.navigator) == null ? void 0 : _a3.userAgent) ? Bowser.parse(window.navigator.userAgent) : void 0;
  const platform = (_b3 = parsedUA == null ? void 0 : parsedUA.platform) == null ? void 0 : _b3.type;
  return platform === "tablet" || platform === "mobile";
};
const getRuntimeConfig = (config2) => {
  const defaultsMode = resolveDefaultsModeConfig(config2);
  const defaultConfigProvider = () => defaultsMode().then(loadConfigsForDefaultMode);
  const clientSharedValues = getRuntimeConfig$1(config2);
  return {
    ...clientSharedValues,
    ...config2,
    runtime: "browser",
    defaultsMode,
    bodyLengthChecker: (config2 == null ? void 0 : config2.bodyLengthChecker) ?? calculateBodyLength,
    credentialDefaultProvider: (config2 == null ? void 0 : config2.credentialDefaultProvider) ?? ((_2) => () => Promise.reject(new Error("Credential is missing"))),
    defaultUserAgentProvider: (config2 == null ? void 0 : config2.defaultUserAgentProvider) ?? defaultUserAgent({ serviceId: clientSharedValues.serviceId, clientVersion: packageInfo.version }),
    eventStreamSerdeProvider: (config2 == null ? void 0 : config2.eventStreamSerdeProvider) ?? eventStreamSerdeProvider,
    getAwsChunkedEncodingStream: (config2 == null ? void 0 : config2.getAwsChunkedEncodingStream) ?? getAwsChunkedEncodingStream,
    maxAttempts: (config2 == null ? void 0 : config2.maxAttempts) ?? DEFAULT_MAX_ATTEMPTS,
    md5: (config2 == null ? void 0 : config2.md5) ?? Md5,
    region: (config2 == null ? void 0 : config2.region) ?? invalidProvider("Region is missing"),
    requestHandler: (config2 == null ? void 0 : config2.requestHandler) ?? new FetchHttpHandler(defaultConfigProvider),
    retryMode: (config2 == null ? void 0 : config2.retryMode) ?? (async () => (await defaultConfigProvider()).retryMode || DEFAULT_RETRY_MODE),
    sdkStreamMixin: (config2 == null ? void 0 : config2.sdkStreamMixin) ?? sdkStreamMixin,
    sha1: (config2 == null ? void 0 : config2.sha1) ?? build$7.Sha1,
    sha256: (config2 == null ? void 0 : config2.sha256) ?? build$3.Sha256,
    streamCollector: (config2 == null ? void 0 : config2.streamCollector) ?? streamCollector,
    streamHasher: (config2 == null ? void 0 : config2.streamHasher) ?? blobHasher,
    useDualstackEndpoint: (config2 == null ? void 0 : config2.useDualstackEndpoint) ?? (() => Promise.resolve(DEFAULT_USE_DUALSTACK_ENDPOINT)),
    useFipsEndpoint: (config2 == null ? void 0 : config2.useFipsEndpoint) ?? (() => Promise.resolve(DEFAULT_USE_FIPS_ENDPOINT))
  };
};
class S3Client extends Client {
  constructor(configuration) {
    const _config_0 = getRuntimeConfig(configuration);
    const _config_1 = resolveClientEndpointParameters(_config_0);
    const _config_2 = resolveRegionConfig(_config_1);
    const _config_3 = resolveEndpointConfig(_config_2);
    const _config_4 = resolveRetryConfig(_config_3);
    const _config_5 = resolveHostHeaderConfig(_config_4);
    const _config_6 = resolveAwsAuthConfig(_config_5);
    const _config_7 = resolveS3Config(_config_6);
    const _config_8 = resolveUserAgentConfig(_config_7);
    const _config_9 = resolveEventStreamSerdeConfig(_config_8);
    super(_config_9);
    this.config = _config_9;
    this.middlewareStack.use(getRetryPlugin(this.config));
    this.middlewareStack.use(getContentLengthPlugin(this.config));
    this.middlewareStack.use(getHostHeaderPlugin(this.config));
    this.middlewareStack.use(getLoggerPlugin(this.config));
    this.middlewareStack.use(getRecursionDetectionPlugin(this.config));
    this.middlewareStack.use(getAwsAuthPlugin(this.config));
    this.middlewareStack.use(getValidateBucketNamePlugin(this.config));
    this.middlewareStack.use(getAddExpectContinuePlugin(this.config));
    this.middlewareStack.use(getUserAgentPlugin(this.config));
  }
  destroy() {
    super.destroy();
  }
}
var FieldPosition;
(function(FieldPosition2) {
  FieldPosition2[FieldPosition2["HEADER"] = 0] = "HEADER";
  FieldPosition2[FieldPosition2["TRAILER"] = 1] = "TRAILER";
})(FieldPosition || (FieldPosition = {}));
class HttpRequest {
  constructor(options2) {
    this.method = options2.method || "GET";
    this.hostname = options2.hostname || "localhost";
    this.port = options2.port;
    this.query = options2.query || {};
    this.headers = options2.headers || {};
    this.body = options2.body;
    this.protocol = options2.protocol ? options2.protocol.slice(-1) !== ":" ? `${options2.protocol}:` : options2.protocol : "https:";
    this.path = options2.path ? options2.path.charAt(0) !== "/" ? `/${options2.path}` : options2.path : "/";
  }
  static isInstance(request) {
    if (!request)
      return false;
    const req = request;
    return "method" in req && "protocol" in req && "hostname" in req && "path" in req && typeof req["query"] === "object" && typeof req["headers"] === "object";
  }
  clone() {
    const cloned = new HttpRequest({
      ...this,
      headers: { ...this.headers }
    });
    if (cloned.query)
      cloned.query = cloneQuery(cloned.query);
    return cloned;
  }
}
function cloneQuery(query6) {
  return Object.keys(query6).reduce((carry, paramName) => {
    const param = query6[paramName];
    return {
      ...carry,
      [paramName]: Array.isArray(param) ? [...param] : param
    };
  }, {});
}
var validator$3 = {};
var util$2 = {};
(function(exports2) {
  const nameStartChar = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
  const nameChar = nameStartChar + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
  const nameRegexp = "[" + nameStartChar + "][" + nameChar + "]*";
  const regexName = new RegExp("^" + nameRegexp + "$");
  const getAllMatches = function(string3, regex2) {
    const matches2 = [];
    let match2 = regex2.exec(string3);
    while (match2) {
      const allmatches = [];
      allmatches.startIndex = regex2.lastIndex - match2[0].length;
      const len2 = match2.length;
      for (let index2 = 0; index2 < len2; index2++) {
        allmatches.push(match2[index2]);
      }
      matches2.push(allmatches);
      match2 = regex2.exec(string3);
    }
    return matches2;
  };
  const isName = function(string3) {
    const match2 = regexName.exec(string3);
    return !(match2 === null || typeof match2 === "undefined");
  };
  exports2.isExist = function(v5) {
    return typeof v5 !== "undefined";
  };
  exports2.isEmptyObject = function(obj) {
    return Object.keys(obj).length === 0;
  };
  exports2.merge = function(target, a2, arrayMode) {
    if (a2) {
      const keys4 = Object.keys(a2);
      const len2 = keys4.length;
      for (let i2 = 0; i2 < len2; i2++) {
        if (arrayMode === "strict") {
          target[keys4[i2]] = [a2[keys4[i2]]];
        } else {
          target[keys4[i2]] = a2[keys4[i2]];
        }
      }
    }
  };
  exports2.getValue = function(v5) {
    if (exports2.isExist(v5)) {
      return v5;
    } else {
      return "";
    }
  };
  exports2.isName = isName;
  exports2.getAllMatches = getAllMatches;
  exports2.nameRegexp = nameRegexp;
})(util$2);
const util$1 = util$2;
const defaultOptions$4 = {
  allowBooleanAttributes: false,
  //A tag can have attributes without any value
  unpairedTags: []
};
validator$3.validate = function(xmlData, options2) {
  options2 = Object.assign({}, defaultOptions$4, options2);
  const tags = [];
  let tagFound = false;
  let reachedRoot = false;
  if (xmlData[0] === "\uFEFF") {
    xmlData = xmlData.substr(1);
  }
  for (let i2 = 0; i2 < xmlData.length; i2++) {
    if (xmlData[i2] === "<" && xmlData[i2 + 1] === "?") {
      i2 += 2;
      i2 = readPI(xmlData, i2);
      if (i2.err)
        return i2;
    } else if (xmlData[i2] === "<") {
      let tagStartPos = i2;
      i2++;
      if (xmlData[i2] === "!") {
        i2 = readCommentAndCDATA(xmlData, i2);
        continue;
      } else {
        let closingTag = false;
        if (xmlData[i2] === "/") {
          closingTag = true;
          i2++;
        }
        let tagName = "";
        for (; i2 < xmlData.length && xmlData[i2] !== ">" && xmlData[i2] !== " " && xmlData[i2] !== "	" && xmlData[i2] !== "\n" && xmlData[i2] !== "\r"; i2++) {
          tagName += xmlData[i2];
        }
        tagName = tagName.trim();
        if (tagName[tagName.length - 1] === "/") {
          tagName = tagName.substring(0, tagName.length - 1);
          i2--;
        }
        if (!validateTagName(tagName)) {
          let msg2;
          if (tagName.trim().length === 0) {
            msg2 = "Invalid space after '<'.";
          } else {
            msg2 = "Tag '" + tagName + "' is an invalid name.";
          }
          return getErrorObject("InvalidTag", msg2, getLineNumberForPosition(xmlData, i2));
        }
        const result = readAttributeStr(xmlData, i2);
        if (result === false) {
          return getErrorObject("InvalidAttr", "Attributes for '" + tagName + "' have open quote.", getLineNumberForPosition(xmlData, i2));
        }
        let attrStr = result.value;
        i2 = result.index;
        if (attrStr[attrStr.length - 1] === "/") {
          const attrStrStart = i2 - attrStr.length;
          attrStr = attrStr.substring(0, attrStr.length - 1);
          const isValid8 = validateAttributeString(attrStr, options2);
          if (isValid8 === true) {
            tagFound = true;
          } else {
            return getErrorObject(isValid8.err.code, isValid8.err.msg, getLineNumberForPosition(xmlData, attrStrStart + isValid8.err.line));
          }
        } else if (closingTag) {
          if (!result.tagClosed) {
            return getErrorObject("InvalidTag", "Closing tag '" + tagName + "' doesn't have proper closing.", getLineNumberForPosition(xmlData, i2));
          } else if (attrStr.trim().length > 0) {
            return getErrorObject("InvalidTag", "Closing tag '" + tagName + "' can't have attributes or invalid starting.", getLineNumberForPosition(xmlData, tagStartPos));
          } else {
            const otg = tags.pop();
            if (tagName !== otg.tagName) {
              let openPos = getLineNumberForPosition(xmlData, otg.tagStartPos);
              return getErrorObject(
                "InvalidTag",
                "Expected closing tag '" + otg.tagName + "' (opened in line " + openPos.line + ", col " + openPos.col + ") instead of closing tag '" + tagName + "'.",
                getLineNumberForPosition(xmlData, tagStartPos)
              );
            }
            if (tags.length == 0) {
              reachedRoot = true;
            }
          }
        } else {
          const isValid8 = validateAttributeString(attrStr, options2);
          if (isValid8 !== true) {
            return getErrorObject(isValid8.err.code, isValid8.err.msg, getLineNumberForPosition(xmlData, i2 - attrStr.length + isValid8.err.line));
          }
          if (reachedRoot === true) {
            return getErrorObject("InvalidXml", "Multiple possible root nodes found.", getLineNumberForPosition(xmlData, i2));
          } else if (options2.unpairedTags.indexOf(tagName) !== -1)
            ;
          else {
            tags.push({ tagName, tagStartPos });
          }
          tagFound = true;
        }
        for (i2++; i2 < xmlData.length; i2++) {
          if (xmlData[i2] === "<") {
            if (xmlData[i2 + 1] === "!") {
              i2++;
              i2 = readCommentAndCDATA(xmlData, i2);
              continue;
            } else if (xmlData[i2 + 1] === "?") {
              i2 = readPI(xmlData, ++i2);
              if (i2.err)
                return i2;
            } else {
              break;
            }
          } else if (xmlData[i2] === "&") {
            const afterAmp = validateAmpersand(xmlData, i2);
            if (afterAmp == -1)
              return getErrorObject("InvalidChar", "char '&' is not expected.", getLineNumberForPosition(xmlData, i2));
            i2 = afterAmp;
          } else {
            if (reachedRoot === true && !isWhiteSpace(xmlData[i2])) {
              return getErrorObject("InvalidXml", "Extra text at the end", getLineNumberForPosition(xmlData, i2));
            }
          }
        }
        if (xmlData[i2] === "<") {
          i2--;
        }
      }
    } else {
      if (isWhiteSpace(xmlData[i2])) {
        continue;
      }
      return getErrorObject("InvalidChar", "char '" + xmlData[i2] + "' is not expected.", getLineNumberForPosition(xmlData, i2));
    }
  }
  if (!tagFound) {
    return getErrorObject("InvalidXml", "Start tag expected.", 1);
  } else if (tags.length == 1) {
    return getErrorObject("InvalidTag", "Unclosed tag '" + tags[0].tagName + "'.", getLineNumberForPosition(xmlData, tags[0].tagStartPos));
  } else if (tags.length > 0) {
    return getErrorObject("InvalidXml", "Invalid '" + JSON.stringify(tags.map((t2) => t2.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  }
  return true;
};
function isWhiteSpace(char) {
  return char === " " || char === "	" || char === "\n" || char === "\r";
}
function readPI(xmlData, i2) {
  const start2 = i2;
  for (; i2 < xmlData.length; i2++) {
    if (xmlData[i2] == "?" || xmlData[i2] == " ") {
      const tagname = xmlData.substr(start2, i2 - start2);
      if (i2 > 5 && tagname === "xml") {
        return getErrorObject("InvalidXml", "XML declaration allowed only at the start of the document.", getLineNumberForPosition(xmlData, i2));
      } else if (xmlData[i2] == "?" && xmlData[i2 + 1] == ">") {
        i2++;
        break;
      } else {
        continue;
      }
    }
  }
  return i2;
}
function readCommentAndCDATA(xmlData, i2) {
  if (xmlData.length > i2 + 5 && xmlData[i2 + 1] === "-" && xmlData[i2 + 2] === "-") {
    for (i2 += 3; i2 < xmlData.length; i2++) {
      if (xmlData[i2] === "-" && xmlData[i2 + 1] === "-" && xmlData[i2 + 2] === ">") {
        i2 += 2;
        break;
      }
    }
  } else if (xmlData.length > i2 + 8 && xmlData[i2 + 1] === "D" && xmlData[i2 + 2] === "O" && xmlData[i2 + 3] === "C" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "Y" && xmlData[i2 + 6] === "P" && xmlData[i2 + 7] === "E") {
    let angleBracketsCount = 1;
    for (i2 += 8; i2 < xmlData.length; i2++) {
      if (xmlData[i2] === "<") {
        angleBracketsCount++;
      } else if (xmlData[i2] === ">") {
        angleBracketsCount--;
        if (angleBracketsCount === 0) {
          break;
        }
      }
    }
  } else if (xmlData.length > i2 + 9 && xmlData[i2 + 1] === "[" && xmlData[i2 + 2] === "C" && xmlData[i2 + 3] === "D" && xmlData[i2 + 4] === "A" && xmlData[i2 + 5] === "T" && xmlData[i2 + 6] === "A" && xmlData[i2 + 7] === "[") {
    for (i2 += 8; i2 < xmlData.length; i2++) {
      if (xmlData[i2] === "]" && xmlData[i2 + 1] === "]" && xmlData[i2 + 2] === ">") {
        i2 += 2;
        break;
      }
    }
  }
  return i2;
}
const doubleQuote = '"';
const singleQuote = "'";
function readAttributeStr(xmlData, i2) {
  let attrStr = "";
  let startChar = "";
  let tagClosed = false;
  for (; i2 < xmlData.length; i2++) {
    if (xmlData[i2] === doubleQuote || xmlData[i2] === singleQuote) {
      if (startChar === "") {
        startChar = xmlData[i2];
      } else if (startChar !== xmlData[i2])
        ;
      else {
        startChar = "";
      }
    } else if (xmlData[i2] === ">") {
      if (startChar === "") {
        tagClosed = true;
        break;
      }
    }
    attrStr += xmlData[i2];
  }
  if (startChar !== "") {
    return false;
  }
  return {
    value: attrStr,
    index: i2,
    tagClosed
  };
}
const validAttrStrRegxp = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function validateAttributeString(attrStr, options2) {
  const matches2 = util$1.getAllMatches(attrStr, validAttrStrRegxp);
  const attrNames = {};
  for (let i2 = 0; i2 < matches2.length; i2++) {
    if (matches2[i2][1].length === 0) {
      return getErrorObject("InvalidAttr", "Attribute '" + matches2[i2][2] + "' has no space in starting.", getPositionFromMatch(matches2[i2]));
    } else if (matches2[i2][3] !== void 0 && matches2[i2][4] === void 0) {
      return getErrorObject("InvalidAttr", "Attribute '" + matches2[i2][2] + "' is without value.", getPositionFromMatch(matches2[i2]));
    } else if (matches2[i2][3] === void 0 && !options2.allowBooleanAttributes) {
      return getErrorObject("InvalidAttr", "boolean attribute '" + matches2[i2][2] + "' is not allowed.", getPositionFromMatch(matches2[i2]));
    }
    const attrName = matches2[i2][2];
    if (!validateAttrName(attrName)) {
      return getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is an invalid name.", getPositionFromMatch(matches2[i2]));
    }
    if (!attrNames.hasOwnProperty(attrName)) {
      attrNames[attrName] = 1;
    } else {
      return getErrorObject("InvalidAttr", "Attribute '" + attrName + "' is repeated.", getPositionFromMatch(matches2[i2]));
    }
  }
  return true;
}
function validateNumberAmpersand(xmlData, i2) {
  let re = /\d/;
  if (xmlData[i2] === "x") {
    i2++;
    re = /[\da-fA-F]/;
  }
  for (; i2 < xmlData.length; i2++) {
    if (xmlData[i2] === ";")
      return i2;
    if (!xmlData[i2].match(re))
      break;
  }
  return -1;
}
function validateAmpersand(xmlData, i2) {
  i2++;
  if (xmlData[i2] === ";")
    return -1;
  if (xmlData[i2] === "#") {
    i2++;
    return validateNumberAmpersand(xmlData, i2);
  }
  let count3 = 0;
  for (; i2 < xmlData.length; i2++, count3++) {
    if (xmlData[i2].match(/\w/) && count3 < 20)
      continue;
    if (xmlData[i2] === ";")
      break;
    return -1;
  }
  return i2;
}
function getErrorObject(code, message2, lineNumber) {
  return {
    err: {
      code,
      msg: message2,
      line: lineNumber.line || lineNumber,
      col: lineNumber.col
    }
  };
}
function validateAttrName(attrName) {
  return util$1.isName(attrName);
}
function validateTagName(tagname) {
  return util$1.isName(tagname);
}
function getLineNumberForPosition(xmlData, index2) {
  const lines = xmlData.substring(0, index2).split(/\r?\n/);
  return {
    line: lines.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: lines[lines.length - 1].length + 1
  };
}
function getPositionFromMatch(match2) {
  return match2.startIndex + match2[1].length;
}
var OptionsBuilder = {};
const defaultOptions$3 = {
  preserveOrder: false,
  attributeNamePrefix: "@_",
  attributesGroupName: false,
  textNodeName: "#text",
  ignoreAttributes: true,
  removeNSPrefix: false,
  // remove NS from tag name or attribute name if true
  allowBooleanAttributes: false,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseTagValue: true,
  parseAttributeValue: false,
  trimValues: true,
  //Trim string values of tag and attributes
  cdataPropName: false,
  numberParseOptions: {
    hex: true,
    leadingZeros: true,
    eNotation: true
  },
  tagValueProcessor: function(tagName, val) {
    return val;
  },
  attributeValueProcessor: function(attrName, val) {
    return val;
  },
  stopNodes: [],
  //nested tags will not be parsed even for errors
  alwaysCreateTextNode: false,
  isArray: () => false,
  commentPropName: false,
  unpairedTags: [],
  processEntities: true,
  htmlEntities: false,
  ignoreDeclaration: false,
  ignorePiTags: false,
  transformTagName: false,
  transformAttributeName: false
};
const buildOptions$1 = function(options2) {
  return Object.assign({}, defaultOptions$3, options2);
};
OptionsBuilder.buildOptions = buildOptions$1;
OptionsBuilder.defaultOptions = defaultOptions$3;
class XmlNode {
  constructor(tagname) {
    this.tagname = tagname;
    this.child = [];
    this[":@"] = {};
  }
  add(key, val) {
    if (key === "__proto__")
      key = "#__proto__";
    this.child.push({ [key]: val });
  }
  addChild(node) {
    if (node.tagname === "__proto__")
      node.tagname = "#__proto__";
    if (node[":@"] && Object.keys(node[":@"]).length > 0) {
      this.child.push({ [node.tagname]: node.child, [":@"]: node[":@"] });
    } else {
      this.child.push({ [node.tagname]: node.child });
    }
  }
}
var xmlNode$1 = XmlNode;
function readDocType$1(xmlData, i2) {
  const entities = {};
  if (xmlData[i2 + 3] === "O" && xmlData[i2 + 4] === "C" && xmlData[i2 + 5] === "T" && xmlData[i2 + 6] === "Y" && xmlData[i2 + 7] === "P" && xmlData[i2 + 8] === "E") {
    i2 = i2 + 9;
    let angleBracketsCount = 1;
    let hasBody = false, entity = false, comment = false;
    let exp = "";
    for (; i2 < xmlData.length; i2++) {
      if (xmlData[i2] === "<" && !comment) {
        if (hasBody && xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "E" && xmlData[i2 + 3] === "N" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "I" && xmlData[i2 + 6] === "T" && xmlData[i2 + 7] === "Y") {
          i2 += 7;
          entity = true;
        } else if (hasBody && xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "E" && xmlData[i2 + 3] === "L" && xmlData[i2 + 4] === "E" && xmlData[i2 + 5] === "M" && xmlData[i2 + 6] === "E" && xmlData[i2 + 7] === "N" && xmlData[i2 + 8] === "T") {
          i2 += 8;
        } else if (hasBody && xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "A" && xmlData[i2 + 3] === "T" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "L" && xmlData[i2 + 6] === "I" && xmlData[i2 + 7] === "S" && xmlData[i2 + 8] === "T") {
          i2 += 8;
        } else if (hasBody && xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "N" && xmlData[i2 + 3] === "O" && xmlData[i2 + 4] === "T" && xmlData[i2 + 5] === "A" && xmlData[i2 + 6] === "T" && xmlData[i2 + 7] === "I" && xmlData[i2 + 8] === "O" && xmlData[i2 + 9] === "N") {
          i2 += 9;
        } else if (
          //comment
          xmlData[i2 + 1] === "!" && xmlData[i2 + 2] === "-" && xmlData[i2 + 3] === "-"
        ) {
          comment = true;
        } else {
          throw new Error("Invalid DOCTYPE");
        }
        angleBracketsCount++;
        exp = "";
      } else if (xmlData[i2] === ">") {
        if (comment) {
          if (xmlData[i2 - 1] === "-" && xmlData[i2 - 2] === "-") {
            comment = false;
            angleBracketsCount--;
          }
        } else {
          if (entity) {
            parseEntityExp(exp, entities);
            entity = false;
          }
          angleBracketsCount--;
        }
        if (angleBracketsCount === 0) {
          break;
        }
      } else if (xmlData[i2] === "[") {
        hasBody = true;
      } else {
        exp += xmlData[i2];
      }
    }
    if (angleBracketsCount !== 0) {
      throw new Error(`Unclosed DOCTYPE`);
    }
  } else {
    throw new Error(`Invalid Tag instead of DOCTYPE`);
  }
  return { entities, i: i2 };
}
const entityRegex = RegExp(`^\\s([a-zA-z0-0]+)[ 	](['"])([^&]+)\\2`);
function parseEntityExp(exp, entities) {
  const match2 = entityRegex.exec(exp);
  if (match2) {
    entities[match2[1]] = {
      regx: RegExp(`&${match2[1]};`, "g"),
      val: match2[3]
    };
  }
}
var DocTypeReader = readDocType$1;
const hexRegex = /^[-+]?0x[a-fA-F0-9]+$/;
const numRegex = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
if (!Number.parseInt && window.parseInt) {
  Number.parseInt = window.parseInt;
}
if (!Number.parseFloat && window.parseFloat) {
  Number.parseFloat = window.parseFloat;
}
const consider = {
  hex: true,
  leadingZeros: true,
  decimalPoint: ".",
  eNotation: true
  //skipLike: /regex/
};
function toNumber$3(str, options2 = {}) {
  options2 = Object.assign({}, consider, options2);
  if (!str || typeof str !== "string")
    return str;
  let trimmedStr = str.trim();
  if (options2.skipLike !== void 0 && options2.skipLike.test(trimmedStr))
    return str;
  else if (options2.hex && hexRegex.test(trimmedStr)) {
    return Number.parseInt(trimmedStr, 16);
  } else {
    const match2 = numRegex.exec(trimmedStr);
    if (match2) {
      const sign2 = match2[1];
      const leadingZeros = match2[2];
      let numTrimmedByZeros = trimZeros(match2[3]);
      const eNotation = match2[4] || match2[6];
      if (!options2.leadingZeros && leadingZeros.length > 0 && sign2 && trimmedStr[2] !== ".")
        return str;
      else if (!options2.leadingZeros && leadingZeros.length > 0 && !sign2 && trimmedStr[1] !== ".")
        return str;
      else {
        const num = Number(trimmedStr);
        const numStr = "" + num;
        if (numStr.search(/[eE]/) !== -1) {
          if (options2.eNotation)
            return num;
          else
            return str;
        } else if (eNotation) {
          if (options2.eNotation)
            return num;
          else
            return str;
        } else if (trimmedStr.indexOf(".") !== -1) {
          if (numStr === "0" && numTrimmedByZeros === "")
            return num;
          else if (numStr === numTrimmedByZeros)
            return num;
          else if (sign2 && numStr === "-" + numTrimmedByZeros)
            return num;
          else
            return str;
        }
        if (leadingZeros) {
          if (numTrimmedByZeros === numStr)
            return num;
          else if (sign2 + numTrimmedByZeros === numStr)
            return num;
          else
            return str;
        }
        if (trimmedStr === numStr)
          return num;
        else if (trimmedStr === sign2 + numStr)
          return num;
        return str;
      }
    } else {
      return str;
    }
  }
}
function trimZeros(numStr) {
  if (numStr && numStr.indexOf(".") !== -1) {
    numStr = numStr.replace(/0+$/, "");
    if (numStr === ".")
      numStr = "0";
    else if (numStr[0] === ".")
      numStr = "0" + numStr;
    else if (numStr[numStr.length - 1] === ".")
      numStr = numStr.substr(0, numStr.length - 1);
    return numStr;
  }
  return numStr;
}
var strnum = toNumber$3;
const util = util$2;
const xmlNode = xmlNode$1;
const readDocType = DocTypeReader;
const toNumber$2 = strnum;
"<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, util.nameRegexp);
let OrderedObjParser$1 = class OrderedObjParser2 {
  constructor(options2) {
    this.options = options2;
    this.currentNode = null;
    this.tagsNodeStack = [];
    this.docTypeEntities = {};
    this.lastEntities = {
      "apos": { regex: /&(apos|#39|#x27);/g, val: "'" },
      "gt": { regex: /&(gt|#62|#x3E);/g, val: ">" },
      "lt": { regex: /&(lt|#60|#x3C);/g, val: "<" },
      "quot": { regex: /&(quot|#34|#x22);/g, val: '"' }
    };
    this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" };
    this.htmlEntities = {
      "space": { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      "cent": { regex: /&(cent|#162);/g, val: "¢" },
      "pound": { regex: /&(pound|#163);/g, val: "£" },
      "yen": { regex: /&(yen|#165);/g, val: "¥" },
      "euro": { regex: /&(euro|#8364);/g, val: "€" },
      "copyright": { regex: /&(copy|#169);/g, val: "©" },
      "reg": { regex: /&(reg|#174);/g, val: "®" },
      "inr": { regex: /&(inr|#8377);/g, val: "₹" }
    };
    this.addExternalEntities = addExternalEntities;
    this.parseXml = parseXml;
    this.parseTextData = parseTextData;
    this.resolveNameSpace = resolveNameSpace;
    this.buildAttributesMap = buildAttributesMap;
    this.isItStopNode = isItStopNode;
    this.replaceEntitiesValue = replaceEntitiesValue$1;
    this.readStopNodeData = readStopNodeData;
    this.saveTextToParentTag = saveTextToParentTag;
  }
};
function addExternalEntities(externalEntities) {
  const entKeys = Object.keys(externalEntities);
  for (let i2 = 0; i2 < entKeys.length; i2++) {
    const ent = entKeys[i2];
    this.lastEntities[ent] = {
      regex: new RegExp("&" + ent + ";", "g"),
      val: externalEntities[ent]
    };
  }
}
function parseTextData(val, tagName, jPath, dontTrim, hasAttributes, isLeafNode, escapeEntities) {
  if (val !== void 0) {
    if (this.options.trimValues && !dontTrim) {
      val = val.trim();
    }
    if (val.length > 0) {
      if (!escapeEntities)
        val = this.replaceEntitiesValue(val);
      const newval = this.options.tagValueProcessor(tagName, val, jPath, hasAttributes, isLeafNode);
      if (newval === null || newval === void 0) {
        return val;
      } else if (typeof newval !== typeof val || newval !== val) {
        return newval;
      } else if (this.options.trimValues) {
        return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
      } else {
        const trimmedVal = val.trim();
        if (trimmedVal === val) {
          return parseValue(val, this.options.parseTagValue, this.options.numberParseOptions);
        } else {
          return val;
        }
      }
    }
  }
}
function resolveNameSpace(tagname) {
  if (this.options.removeNSPrefix) {
    const tags = tagname.split(":");
    const prefix = tagname.charAt(0) === "/" ? "/" : "";
    if (tags[0] === "xmlns") {
      return "";
    }
    if (tags.length === 2) {
      tagname = prefix + tags[1];
    }
  }
  return tagname;
}
const attrsRegx = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
function buildAttributesMap(attrStr, jPath) {
  if (!this.options.ignoreAttributes && typeof attrStr === "string") {
    const matches2 = util.getAllMatches(attrStr, attrsRegx);
    const len2 = matches2.length;
    const attrs = {};
    for (let i2 = 0; i2 < len2; i2++) {
      const attrName = this.resolveNameSpace(matches2[i2][1]);
      let oldVal = matches2[i2][4];
      let aName = this.options.attributeNamePrefix + attrName;
      if (attrName.length) {
        if (this.options.transformAttributeName) {
          aName = this.options.transformAttributeName(aName);
        }
        if (aName === "__proto__")
          aName = "#__proto__";
        if (oldVal !== void 0) {
          if (this.options.trimValues) {
            oldVal = oldVal.trim();
          }
          oldVal = this.replaceEntitiesValue(oldVal);
          const newVal = this.options.attributeValueProcessor(attrName, oldVal, jPath);
          if (newVal === null || newVal === void 0) {
            attrs[aName] = oldVal;
          } else if (typeof newVal !== typeof oldVal || newVal !== oldVal) {
            attrs[aName] = newVal;
          } else {
            attrs[aName] = parseValue(
              oldVal,
              this.options.parseAttributeValue,
              this.options.numberParseOptions
            );
          }
        } else if (this.options.allowBooleanAttributes) {
          attrs[aName] = true;
        }
      }
    }
    if (!Object.keys(attrs).length) {
      return;
    }
    if (this.options.attributesGroupName) {
      const attrCollection = {};
      attrCollection[this.options.attributesGroupName] = attrs;
      return attrCollection;
    }
    return attrs;
  }
}
const parseXml = function(xmlData) {
  xmlData = xmlData.replace(/\r\n?/g, "\n");
  const xmlObj = new xmlNode("!xml");
  let currentNode = xmlObj;
  let textData = "";
  let jPath = "";
  for (let i2 = 0; i2 < xmlData.length; i2++) {
    const ch2 = xmlData[i2];
    if (ch2 === "<") {
      if (xmlData[i2 + 1] === "/") {
        const closeIndex = findClosingIndex(xmlData, ">", i2, "Closing Tag is not closed.");
        let tagName = xmlData.substring(i2 + 2, closeIndex).trim();
        if (this.options.removeNSPrefix) {
          const colonIndex = tagName.indexOf(":");
          if (colonIndex !== -1) {
            tagName = tagName.substr(colonIndex + 1);
          }
        }
        if (this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }
        if (currentNode) {
          textData = this.saveTextToParentTag(textData, currentNode, jPath);
        }
        jPath = jPath.substr(0, jPath.lastIndexOf("."));
        currentNode = this.tagsNodeStack.pop();
        textData = "";
        i2 = closeIndex;
      } else if (xmlData[i2 + 1] === "?") {
        let tagData = readTagExp(xmlData, i2, false, "?>");
        if (!tagData)
          throw new Error("Pi Tag is not closed.");
        textData = this.saveTextToParentTag(textData, currentNode, jPath);
        if (this.options.ignoreDeclaration && tagData.tagName === "?xml" || this.options.ignorePiTags)
          ;
        else {
          const childNode = new xmlNode(tagData.tagName);
          childNode.add(this.options.textNodeName, "");
          if (tagData.tagName !== tagData.tagExp && tagData.attrExpPresent) {
            childNode[":@"] = this.buildAttributesMap(tagData.tagExp, jPath);
          }
          currentNode.addChild(childNode);
        }
        i2 = tagData.closeIndex + 1;
      } else if (xmlData.substr(i2 + 1, 3) === "!--") {
        const endIndex = findClosingIndex(xmlData, "-->", i2 + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          const comment = xmlData.substring(i2 + 4, endIndex - 2);
          textData = this.saveTextToParentTag(textData, currentNode, jPath);
          currentNode.add(this.options.commentPropName, [{ [this.options.textNodeName]: comment }]);
        }
        i2 = endIndex;
      } else if (xmlData.substr(i2 + 1, 2) === "!D") {
        const result = readDocType(xmlData, i2);
        this.docTypeEntities = result.entities;
        i2 = result.i;
      } else if (xmlData.substr(i2 + 1, 2) === "![") {
        const closeIndex = findClosingIndex(xmlData, "]]>", i2, "CDATA is not closed.") - 2;
        const tagExp = xmlData.substring(i2 + 9, closeIndex);
        textData = this.saveTextToParentTag(textData, currentNode, jPath);
        if (this.options.cdataPropName) {
          currentNode.add(this.options.cdataPropName, [{ [this.options.textNodeName]: tagExp }]);
        } else {
          let val = this.parseTextData(tagExp, currentNode.tagname, jPath, true, false, true);
          if (val == void 0)
            val = "";
          currentNode.add(this.options.textNodeName, val);
        }
        i2 = closeIndex + 2;
      } else {
        let result = readTagExp(xmlData, i2, this.options.removeNSPrefix);
        let tagName = result.tagName;
        let tagExp = result.tagExp;
        let attrExpPresent = result.attrExpPresent;
        let closeIndex = result.closeIndex;
        if (this.options.transformTagName) {
          tagName = this.options.transformTagName(tagName);
        }
        if (currentNode && textData) {
          if (currentNode.tagname !== "!xml") {
            textData = this.saveTextToParentTag(textData, currentNode, jPath, false);
          }
        }
        if (tagName !== xmlObj.tagname) {
          jPath += jPath ? "." + tagName : tagName;
        }
        const lastTag = currentNode;
        if (lastTag && this.options.unpairedTags.indexOf(lastTag.tagname) !== -1) {
          currentNode = this.tagsNodeStack.pop();
        }
        if (this.isItStopNode(this.options.stopNodes, jPath, tagName)) {
          let tagContent = "";
          if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
            i2 = result.closeIndex;
          } else if (this.options.unpairedTags.indexOf(tagName) !== -1) {
            i2 = result.closeIndex;
          } else {
            const result2 = this.readStopNodeData(xmlData, tagName, closeIndex + 1);
            if (!result2)
              throw new Error(`Unexpected end of ${tagName}`);
            i2 = result2.i;
            tagContent = result2.tagContent;
          }
          const childNode = new xmlNode(tagName);
          if (tagName !== tagExp && attrExpPresent) {
            childNode[":@"] = this.buildAttributesMap(tagExp, jPath);
          }
          if (tagContent) {
            tagContent = this.parseTextData(tagContent, tagName, jPath, true, attrExpPresent, true, true);
          }
          jPath = jPath.substr(0, jPath.lastIndexOf("."));
          childNode.add(this.options.textNodeName, tagContent);
          currentNode.addChild(childNode);
        } else {
          if (tagExp.length > 0 && tagExp.lastIndexOf("/") === tagExp.length - 1) {
            if (tagName[tagName.length - 1] === "/") {
              tagName = tagName.substr(0, tagName.length - 1);
              tagExp = tagName;
            } else {
              tagExp = tagExp.substr(0, tagExp.length - 1);
            }
            if (this.options.transformTagName) {
              tagName = this.options.transformTagName(tagName);
            }
            const childNode = new xmlNode(tagName);
            if (tagName !== tagExp && attrExpPresent) {
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath);
            }
            jPath = jPath.substr(0, jPath.lastIndexOf("."));
            currentNode.addChild(childNode);
          } else {
            const childNode = new xmlNode(tagName);
            this.tagsNodeStack.push(currentNode);
            if (tagName !== tagExp && attrExpPresent) {
              childNode[":@"] = this.buildAttributesMap(tagExp, jPath);
            }
            currentNode.addChild(childNode);
            currentNode = childNode;
          }
          textData = "";
          i2 = closeIndex;
        }
      }
    } else {
      textData += xmlData[i2];
    }
  }
  return xmlObj.child;
};
const replaceEntitiesValue$1 = function(val) {
  if (this.options.processEntities) {
    for (let entityName in this.docTypeEntities) {
      const entity = this.docTypeEntities[entityName];
      val = val.replace(entity.regx, entity.val);
    }
    for (let entityName in this.lastEntities) {
      const entity = this.lastEntities[entityName];
      val = val.replace(entity.regex, entity.val);
    }
    if (this.options.htmlEntities) {
      for (let entityName in this.htmlEntities) {
        const entity = this.htmlEntities[entityName];
        val = val.replace(entity.regex, entity.val);
      }
    }
    val = val.replace(this.ampEntity.regex, this.ampEntity.val);
  }
  return val;
};
function saveTextToParentTag(textData, currentNode, jPath, isLeafNode) {
  if (textData) {
    if (isLeafNode === void 0)
      isLeafNode = Object.keys(currentNode.child).length === 0;
    textData = this.parseTextData(
      textData,
      currentNode.tagname,
      jPath,
      false,
      currentNode[":@"] ? Object.keys(currentNode[":@"]).length !== 0 : false,
      isLeafNode
    );
    if (textData !== void 0 && textData !== "")
      currentNode.add(this.options.textNodeName, textData);
    textData = "";
  }
  return textData;
}
function isItStopNode(stopNodes, jPath, currentTagName) {
  const allNodesExp = "*." + currentTagName;
  for (const stopNodePath in stopNodes) {
    const stopNodeExp = stopNodes[stopNodePath];
    if (allNodesExp === stopNodeExp || jPath === stopNodeExp)
      return true;
  }
  return false;
}
function tagExpWithClosingIndex(xmlData, i2, closingChar = ">") {
  let attrBoundary;
  let tagExp = "";
  for (let index2 = i2; index2 < xmlData.length; index2++) {
    let ch2 = xmlData[index2];
    if (attrBoundary) {
      if (ch2 === attrBoundary)
        attrBoundary = "";
    } else if (ch2 === '"' || ch2 === "'") {
      attrBoundary = ch2;
    } else if (ch2 === closingChar[0]) {
      if (closingChar[1]) {
        if (xmlData[index2 + 1] === closingChar[1]) {
          return {
            data: tagExp,
            index: index2
          };
        }
      } else {
        return {
          data: tagExp,
          index: index2
        };
      }
    } else if (ch2 === "	") {
      ch2 = " ";
    }
    tagExp += ch2;
  }
}
function findClosingIndex(xmlData, str, i2, errMsg) {
  const closingIndex = xmlData.indexOf(str, i2);
  if (closingIndex === -1) {
    throw new Error(errMsg);
  } else {
    return closingIndex + str.length - 1;
  }
}
function readTagExp(xmlData, i2, removeNSPrefix, closingChar = ">") {
  const result = tagExpWithClosingIndex(xmlData, i2 + 1, closingChar);
  if (!result)
    return;
  let tagExp = result.data;
  const closeIndex = result.index;
  const separatorIndex = tagExp.search(/\s/);
  let tagName = tagExp;
  let attrExpPresent = true;
  if (separatorIndex !== -1) {
    tagName = tagExp.substr(0, separatorIndex).replace(/\s\s*$/, "");
    tagExp = tagExp.substr(separatorIndex + 1);
  }
  if (removeNSPrefix) {
    const colonIndex = tagName.indexOf(":");
    if (colonIndex !== -1) {
      tagName = tagName.substr(colonIndex + 1);
      attrExpPresent = tagName !== result.data.substr(colonIndex + 1);
    }
  }
  return {
    tagName,
    tagExp,
    closeIndex,
    attrExpPresent
  };
}
function readStopNodeData(xmlData, tagName, i2) {
  const startIndex = i2;
  let openTagCount = 1;
  for (; i2 < xmlData.length; i2++) {
    if (xmlData[i2] === "<") {
      if (xmlData[i2 + 1] === "/") {
        const closeIndex = findClosingIndex(xmlData, ">", i2, `${tagName} is not closed`);
        let closeTagName = xmlData.substring(i2 + 2, closeIndex).trim();
        if (closeTagName === tagName) {
          openTagCount--;
          if (openTagCount === 0) {
            return {
              tagContent: xmlData.substring(startIndex, i2),
              i: closeIndex
            };
          }
        }
        i2 = closeIndex;
      } else if (xmlData[i2 + 1] === "?") {
        const closeIndex = findClosingIndex(xmlData, "?>", i2 + 1, "StopNode is not closed.");
        i2 = closeIndex;
      } else if (xmlData.substr(i2 + 1, 3) === "!--") {
        const closeIndex = findClosingIndex(xmlData, "-->", i2 + 3, "StopNode is not closed.");
        i2 = closeIndex;
      } else if (xmlData.substr(i2 + 1, 2) === "![") {
        const closeIndex = findClosingIndex(xmlData, "]]>", i2, "StopNode is not closed.") - 2;
        i2 = closeIndex;
      } else {
        const tagData = readTagExp(xmlData, i2, ">");
        if (tagData) {
          const openTagName = tagData && tagData.tagName;
          if (openTagName === tagName && tagData.tagExp[tagData.tagExp.length - 1] !== "/") {
            openTagCount++;
          }
          i2 = tagData.closeIndex;
        }
      }
    }
  }
}
function parseValue(val, shouldParse, options2) {
  if (shouldParse && typeof val === "string") {
    const newval = val.trim();
    if (newval === "true")
      return true;
    else if (newval === "false")
      return false;
    else
      return toNumber$2(val, options2);
  } else {
    if (util.isExist(val)) {
      return val;
    } else {
      return "";
    }
  }
}
var OrderedObjParser_1 = OrderedObjParser$1;
var node2json = {};
function prettify$1(node, options2) {
  return compress(node, options2);
}
function compress(arr, options2, jPath) {
  let text;
  const compressedObj = {};
  for (let i2 = 0; i2 < arr.length; i2++) {
    const tagObj = arr[i2];
    const property2 = propName$1(tagObj);
    let newJpath = "";
    if (jPath === void 0)
      newJpath = property2;
    else
      newJpath = jPath + "." + property2;
    if (property2 === options2.textNodeName) {
      if (text === void 0)
        text = tagObj[property2];
      else
        text += "" + tagObj[property2];
    } else if (property2 === void 0) {
      continue;
    } else if (tagObj[property2]) {
      let val = compress(tagObj[property2], options2, newJpath);
      const isLeaf = isLeafTag(val, options2);
      if (tagObj[":@"]) {
        assignAttributes(val, tagObj[":@"], newJpath, options2);
      } else if (Object.keys(val).length === 1 && val[options2.textNodeName] !== void 0 && !options2.alwaysCreateTextNode) {
        val = val[options2.textNodeName];
      } else if (Object.keys(val).length === 0) {
        if (options2.alwaysCreateTextNode)
          val[options2.textNodeName] = "";
        else
          val = "";
      }
      if (compressedObj[property2] !== void 0 && compressedObj.hasOwnProperty(property2)) {
        if (!Array.isArray(compressedObj[property2])) {
          compressedObj[property2] = [compressedObj[property2]];
        }
        compressedObj[property2].push(val);
      } else {
        if (options2.isArray(property2, newJpath, isLeaf)) {
          compressedObj[property2] = [val];
        } else {
          compressedObj[property2] = val;
        }
      }
    }
  }
  if (typeof text === "string") {
    if (text.length > 0)
      compressedObj[options2.textNodeName] = text;
  } else if (text !== void 0)
    compressedObj[options2.textNodeName] = text;
  return compressedObj;
}
function propName$1(obj) {
  const keys4 = Object.keys(obj);
  for (let i2 = 0; i2 < keys4.length; i2++) {
    const key = keys4[i2];
    if (key !== ":@")
      return key;
  }
}
function assignAttributes(obj, attrMap, jpath, options2) {
  if (attrMap) {
    const keys4 = Object.keys(attrMap);
    const len2 = keys4.length;
    for (let i2 = 0; i2 < len2; i2++) {
      const atrrName = keys4[i2];
      if (options2.isArray(atrrName, jpath + "." + atrrName, true, true)) {
        obj[atrrName] = [attrMap[atrrName]];
      } else {
        obj[atrrName] = attrMap[atrrName];
      }
    }
  }
}
function isLeafTag(obj, options2) {
  const propCount = Object.keys(obj).length;
  if (propCount === 0 || propCount === 1 && obj[options2.textNodeName])
    return true;
  return false;
}
node2json.prettify = prettify$1;
const { buildOptions } = OptionsBuilder;
const OrderedObjParser = OrderedObjParser_1;
const { prettify } = node2json;
const validator$2 = validator$3;
let XMLParser$1 = class XMLParser2 {
  constructor(options2) {
    this.externalEntities = {};
    this.options = buildOptions(options2);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Buffer} xmlData 
   * @param {boolean|Object} validationOption 
   */
  parse(xmlData, validationOption) {
    if (typeof xmlData === "string")
      ;
    else if (xmlData.toString) {
      xmlData = xmlData.toString();
    } else {
      throw new Error("XML data is accepted in String or Bytes[] form.");
    }
    if (validationOption) {
      if (validationOption === true)
        validationOption = {};
      const result = validator$2.validate(xmlData, validationOption);
      if (result !== true) {
        throw Error(`${result.err.msg}:${result.err.line}:${result.err.col}`);
      }
    }
    const orderedObjParser = new OrderedObjParser(this.options);
    orderedObjParser.addExternalEntities(this.externalEntities);
    const orderedResult = orderedObjParser.parseXml(xmlData);
    if (this.options.preserveOrder || orderedResult === void 0)
      return orderedResult;
    else
      return prettify(orderedResult, this.options);
  }
  /**
   * Add Entity which is not by default supported by this library
   * @param {string} key 
   * @param {string} value 
   */
  addEntity(key, value) {
    if (value.indexOf("&") !== -1) {
      throw new Error("Entity value can't have '&'");
    } else if (key.indexOf("&") !== -1 || key.indexOf(";") !== -1) {
      throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
    } else if (value === "&") {
      throw new Error("An entity with value '&' is not permitted");
    } else {
      this.externalEntities[key] = value;
    }
  }
};
var XMLParser_1 = XMLParser$1;
const EOL = "\n";
function toXml(jArray, options2) {
  let indentation = "";
  if (options2.format && options2.indentBy.length > 0) {
    indentation = EOL;
  }
  return arrToStr(jArray, options2, "", indentation);
}
function arrToStr(arr, options2, jPath, indentation) {
  let xmlStr = "";
  let isPreviousElementTag = false;
  for (let i2 = 0; i2 < arr.length; i2++) {
    const tagObj = arr[i2];
    const tagName = propName(tagObj);
    let newJPath = "";
    if (jPath.length === 0)
      newJPath = tagName;
    else
      newJPath = `${jPath}.${tagName}`;
    if (tagName === options2.textNodeName) {
      let tagText = tagObj[tagName];
      if (!isStopNode(newJPath, options2)) {
        tagText = options2.tagValueProcessor(tagName, tagText);
        tagText = replaceEntitiesValue(tagText, options2);
      }
      if (isPreviousElementTag) {
        xmlStr += indentation;
      }
      xmlStr += tagText;
      isPreviousElementTag = false;
      continue;
    } else if (tagName === options2.cdataPropName) {
      if (isPreviousElementTag) {
        xmlStr += indentation;
      }
      xmlStr += `<![CDATA[${tagObj[tagName][0][options2.textNodeName]}]]>`;
      isPreviousElementTag = false;
      continue;
    } else if (tagName === options2.commentPropName) {
      xmlStr += indentation + `<!--${tagObj[tagName][0][options2.textNodeName]}-->`;
      isPreviousElementTag = true;
      continue;
    } else if (tagName[0] === "?") {
      const attStr2 = attr_to_str(tagObj[":@"], options2);
      const tempInd = tagName === "?xml" ? "" : indentation;
      let piTextNodeName = tagObj[tagName][0][options2.textNodeName];
      piTextNodeName = piTextNodeName.length !== 0 ? " " + piTextNodeName : "";
      xmlStr += tempInd + `<${tagName}${piTextNodeName}${attStr2}?>`;
      isPreviousElementTag = true;
      continue;
    }
    let newIdentation = indentation;
    if (newIdentation !== "") {
      newIdentation += options2.indentBy;
    }
    const attStr = attr_to_str(tagObj[":@"], options2);
    const tagStart = indentation + `<${tagName}${attStr}`;
    const tagValue = arrToStr(tagObj[tagName], options2, newJPath, newIdentation);
    if (options2.unpairedTags.indexOf(tagName) !== -1) {
      if (options2.suppressUnpairedNode)
        xmlStr += tagStart + ">";
      else
        xmlStr += tagStart + "/>";
    } else if ((!tagValue || tagValue.length === 0) && options2.suppressEmptyNode) {
      xmlStr += tagStart + "/>";
    } else if (tagValue && tagValue.endsWith(">")) {
      xmlStr += tagStart + `>${tagValue}${indentation}</${tagName}>`;
    } else {
      xmlStr += tagStart + ">";
      if (tagValue && indentation !== "" && (tagValue.includes("/>") || tagValue.includes("</"))) {
        xmlStr += indentation + options2.indentBy + tagValue + indentation;
      } else {
        xmlStr += tagValue;
      }
      xmlStr += `</${tagName}>`;
    }
    isPreviousElementTag = true;
  }
  return xmlStr;
}
function propName(obj) {
  const keys4 = Object.keys(obj);
  for (let i2 = 0; i2 < keys4.length; i2++) {
    const key = keys4[i2];
    if (key !== ":@")
      return key;
  }
}
function attr_to_str(attrMap, options2) {
  let attrStr = "";
  if (attrMap && !options2.ignoreAttributes) {
    for (let attr2 in attrMap) {
      let attrVal = options2.attributeValueProcessor(attr2, attrMap[attr2]);
      attrVal = replaceEntitiesValue(attrVal, options2);
      if (attrVal === true && options2.suppressBooleanAttributes) {
        attrStr += ` ${attr2.substr(options2.attributeNamePrefix.length)}`;
      } else {
        attrStr += ` ${attr2.substr(options2.attributeNamePrefix.length)}="${attrVal}"`;
      }
    }
  }
  return attrStr;
}
function isStopNode(jPath, options2) {
  jPath = jPath.substr(0, jPath.length - options2.textNodeName.length - 1);
  let tagName = jPath.substr(jPath.lastIndexOf(".") + 1);
  for (let index2 in options2.stopNodes) {
    if (options2.stopNodes[index2] === jPath || options2.stopNodes[index2] === "*." + tagName)
      return true;
  }
  return false;
}
function replaceEntitiesValue(textValue, options2) {
  if (textValue && textValue.length > 0 && options2.processEntities) {
    for (let i2 = 0; i2 < options2.entities.length; i2++) {
      const entity = options2.entities[i2];
      textValue = textValue.replace(entity.regex, entity.val);
    }
  }
  return textValue;
}
var orderedJs2Xml = toXml;
const buildFromOrderedJs = orderedJs2Xml;
const defaultOptions$2 = {
  attributeNamePrefix: "@_",
  attributesGroupName: false,
  textNodeName: "#text",
  ignoreAttributes: true,
  cdataPropName: false,
  format: false,
  indentBy: "  ",
  suppressEmptyNode: false,
  suppressUnpairedNode: true,
  suppressBooleanAttributes: true,
  tagValueProcessor: function(key, a2) {
    return a2;
  },
  attributeValueProcessor: function(attrName, a2) {
    return a2;
  },
  preserveOrder: false,
  commentPropName: false,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },
    //it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("'", "g"), val: "&apos;" },
    { regex: new RegExp('"', "g"), val: "&quot;" }
  ],
  processEntities: true,
  stopNodes: []
  // transformTagName: false,
  // transformAttributeName: false,
};
function Builder(options2) {
  this.options = Object.assign({}, defaultOptions$2, options2);
  if (this.options.ignoreAttributes || this.options.attributesGroupName) {
    this.isAttribute = function() {
      return false;
    };
  } else {
    this.attrPrefixLen = this.options.attributeNamePrefix.length;
    this.isAttribute = isAttribute;
  }
  this.processTextOrObjNode = processTextOrObjNode;
  if (this.options.format) {
    this.indentate = indentate;
    this.tagEndChar = ">\n";
    this.newLine = "\n";
  } else {
    this.indentate = function() {
      return "";
    };
    this.tagEndChar = ">";
    this.newLine = "";
  }
}
Builder.prototype.build = function(jObj) {
  if (this.options.preserveOrder) {
    return buildFromOrderedJs(jObj, this.options);
  } else {
    if (Array.isArray(jObj) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1) {
      jObj = {
        [this.options.arrayNodeName]: jObj
      };
    }
    return this.j2x(jObj, 0).val;
  }
};
Builder.prototype.j2x = function(jObj, level) {
  let attrStr = "";
  let val = "";
  for (let key in jObj) {
    if (typeof jObj[key] === "undefined")
      ;
    else if (jObj[key] === null) {
      if (key[0] === "?")
        val += this.indentate(level) + "<" + key + "?" + this.tagEndChar;
      else
        val += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
    } else if (jObj[key] instanceof Date) {
      val += this.buildTextValNode(jObj[key], key, "", level);
    } else if (typeof jObj[key] !== "object") {
      const attr2 = this.isAttribute(key);
      if (attr2) {
        attrStr += this.buildAttrPairStr(attr2, "" + jObj[key]);
      } else {
        if (key === this.options.textNodeName) {
          let newval = this.options.tagValueProcessor(key, "" + jObj[key]);
          val += this.replaceEntitiesValue(newval);
        } else {
          val += this.buildTextValNode(jObj[key], key, "", level);
        }
      }
    } else if (Array.isArray(jObj[key])) {
      const arrLen = jObj[key].length;
      for (let j2 = 0; j2 < arrLen; j2++) {
        const item = jObj[key][j2];
        if (typeof item === "undefined")
          ;
        else if (item === null) {
          if (key[0] === "?")
            val += this.indentate(level) + "<" + key + "?" + this.tagEndChar;
          else
            val += this.indentate(level) + "<" + key + "/" + this.tagEndChar;
        } else if (typeof item === "object") {
          val += this.processTextOrObjNode(item, key, level);
        } else {
          val += this.buildTextValNode(item, key, "", level);
        }
      }
    } else {
      if (this.options.attributesGroupName && key === this.options.attributesGroupName) {
        const Ks = Object.keys(jObj[key]);
        const L2 = Ks.length;
        for (let j2 = 0; j2 < L2; j2++) {
          attrStr += this.buildAttrPairStr(Ks[j2], "" + jObj[key][Ks[j2]]);
        }
      } else {
        val += this.processTextOrObjNode(jObj[key], key, level);
      }
    }
  }
  return { attrStr, val };
};
Builder.prototype.buildAttrPairStr = function(attrName, val) {
  val = this.options.attributeValueProcessor(attrName, "" + val);
  val = this.replaceEntitiesValue(val);
  if (this.options.suppressBooleanAttributes && val === "true") {
    return " " + attrName;
  } else
    return " " + attrName + '="' + val + '"';
};
function processTextOrObjNode(object2, key, level) {
  const result = this.j2x(object2, level + 1);
  if (object2[this.options.textNodeName] !== void 0 && Object.keys(object2).length === 1) {
    return this.buildTextValNode(object2[this.options.textNodeName], key, result.attrStr, level);
  } else {
    return this.buildObjectNode(result.val, key, result.attrStr, level);
  }
}
Builder.prototype.buildObjectNode = function(val, key, attrStr, level) {
  if (val === "") {
    if (key[0] === "?")
      return this.indentate(level) + "<" + key + attrStr + "?" + this.tagEndChar;
    else {
      return this.indentate(level) + "<" + key + attrStr + this.closeTag(key) + this.tagEndChar;
    }
  } else {
    let tagEndExp = "</" + key + this.tagEndChar;
    let piClosingChar = "";
    if (key[0] === "?") {
      piClosingChar = "?";
      tagEndExp = "";
    }
    if (attrStr && val.indexOf("<") === -1) {
      return this.indentate(level) + "<" + key + attrStr + piClosingChar + ">" + val + tagEndExp;
    } else if (this.options.commentPropName !== false && key === this.options.commentPropName && piClosingChar.length === 0) {
      return this.indentate(level) + `<!--${val}-->` + this.newLine;
    } else {
      return this.indentate(level) + "<" + key + attrStr + piClosingChar + this.tagEndChar + val + this.indentate(level) + tagEndExp;
    }
  }
};
Builder.prototype.closeTag = function(key) {
  let closeTag = "";
  if (this.options.unpairedTags.indexOf(key) !== -1) {
    if (!this.options.suppressUnpairedNode)
      closeTag = "/";
  } else if (this.options.suppressEmptyNode) {
    closeTag = "/";
  } else {
    closeTag = `></${key}`;
  }
  return closeTag;
};
Builder.prototype.buildTextValNode = function(val, key, attrStr, level) {
  if (this.options.cdataPropName !== false && key === this.options.cdataPropName) {
    return this.indentate(level) + `<![CDATA[${val}]]>` + this.newLine;
  } else if (this.options.commentPropName !== false && key === this.options.commentPropName) {
    return this.indentate(level) + `<!--${val}-->` + this.newLine;
  } else if (key[0] === "?") {
    return this.indentate(level) + "<" + key + attrStr + "?" + this.tagEndChar;
  } else {
    let textValue = this.options.tagValueProcessor(key, val);
    textValue = this.replaceEntitiesValue(textValue);
    if (textValue === "") {
      return this.indentate(level) + "<" + key + attrStr + this.closeTag(key) + this.tagEndChar;
    } else {
      return this.indentate(level) + "<" + key + attrStr + ">" + textValue + "</" + key + this.tagEndChar;
    }
  }
};
Builder.prototype.replaceEntitiesValue = function(textValue) {
  if (textValue && textValue.length > 0 && this.options.processEntities) {
    for (let i2 = 0; i2 < this.options.entities.length; i2++) {
      const entity = this.options.entities[i2];
      textValue = textValue.replace(entity.regex, entity.val);
    }
  }
  return textValue;
};
function indentate(level) {
  return this.options.indentBy.repeat(level);
}
function isAttribute(name2) {
  if (name2.startsWith(this.options.attributeNamePrefix)) {
    return name2.substr(this.attrPrefixLen);
  } else {
    return false;
  }
}
var json2xml = Builder;
const validator$1 = validator$3;
const XMLParser = XMLParser_1;
const XMLBuilder = json2xml;
var fxp = {
  XMLParser,
  XMLValidator: validator$1,
  XMLBuilder
};
class S3ServiceException extends ServiceException {
  constructor(options2) {
    super(options2);
    Object.setPrototypeOf(this, S3ServiceException.prototype);
  }
}
var AnalyticsFilter;
(function(AnalyticsFilter2) {
  AnalyticsFilter2.visit = (value, visitor) => {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
})(AnalyticsFilter || (AnalyticsFilter = {}));
var LifecycleRuleFilter;
(function(LifecycleRuleFilter2) {
  LifecycleRuleFilter2.visit = (value, visitor) => {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.ObjectSizeGreaterThan !== void 0)
      return visitor.ObjectSizeGreaterThan(value.ObjectSizeGreaterThan);
    if (value.ObjectSizeLessThan !== void 0)
      return visitor.ObjectSizeLessThan(value.ObjectSizeLessThan);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
})(LifecycleRuleFilter || (LifecycleRuleFilter = {}));
var MetricsFilter;
(function(MetricsFilter2) {
  MetricsFilter2.visit = (value, visitor) => {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.AccessPointArn !== void 0)
      return visitor.AccessPointArn(value.AccessPointArn);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
})(MetricsFilter || (MetricsFilter = {}));
var ReplicationRuleFilter;
(function(ReplicationRuleFilter2) {
  ReplicationRuleFilter2.visit = (value, visitor) => {
    if (value.Prefix !== void 0)
      return visitor.Prefix(value.Prefix);
    if (value.Tag !== void 0)
      return visitor.Tag(value.Tag);
    if (value.And !== void 0)
      return visitor.And(value.And);
    return visitor._(value.$unknown[0], value.$unknown[1]);
  };
})(ReplicationRuleFilter || (ReplicationRuleFilter = {}));
const PutObjectOutputFilterSensitiveLog = (obj) => ({
  ...obj,
  ...obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING },
  ...obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING }
});
const PutObjectRequestFilterSensitiveLog = (obj) => ({
  ...obj,
  ...obj.SSECustomerKey && { SSECustomerKey: SENSITIVE_STRING },
  ...obj.SSEKMSKeyId && { SSEKMSKeyId: SENSITIVE_STRING },
  ...obj.SSEKMSEncryptionContext && { SSEKMSEncryptionContext: SENSITIVE_STRING }
});
const se_PutObjectCommand = async (input, context2) => {
  const { hostname, protocol = "https", port, path: basePath } = await context2.endpoint();
  const headers = map$4({}, isSerializableHeaderValue, {
    "content-type": input.ContentType || "application/octet-stream",
    "x-amz-acl": input.ACL,
    "cache-control": input.CacheControl,
    "content-disposition": input.ContentDisposition,
    "content-encoding": input.ContentEncoding,
    "content-language": input.ContentLanguage,
    "content-length": [() => isSerializableHeaderValue(input.ContentLength), () => input.ContentLength.toString()],
    "content-md5": input.ContentMD5,
    "x-amz-sdk-checksum-algorithm": input.ChecksumAlgorithm,
    "x-amz-checksum-crc32": input.ChecksumCRC32,
    "x-amz-checksum-crc32c": input.ChecksumCRC32C,
    "x-amz-checksum-sha1": input.ChecksumSHA1,
    "x-amz-checksum-sha256": input.ChecksumSHA256,
    expires: [() => isSerializableHeaderValue(input.Expires), () => dateToUtcString(input.Expires).toString()],
    "x-amz-grant-full-control": input.GrantFullControl,
    "x-amz-grant-read": input.GrantRead,
    "x-amz-grant-read-acp": input.GrantReadACP,
    "x-amz-grant-write-acp": input.GrantWriteACP,
    "x-amz-server-side-encryption": input.ServerSideEncryption,
    "x-amz-storage-class": input.StorageClass,
    "x-amz-website-redirect-location": input.WebsiteRedirectLocation,
    "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm,
    "x-amz-server-side-encryption-customer-key": input.SSECustomerKey,
    "x-amz-server-side-encryption-customer-key-md5": input.SSECustomerKeyMD5,
    "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId,
    "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext,
    "x-amz-server-side-encryption-bucket-key-enabled": [
      () => isSerializableHeaderValue(input.BucketKeyEnabled),
      () => input.BucketKeyEnabled.toString()
    ],
    "x-amz-request-payer": input.RequestPayer,
    "x-amz-tagging": input.Tagging,
    "x-amz-object-lock-mode": input.ObjectLockMode,
    "x-amz-object-lock-retain-until-date": [
      () => isSerializableHeaderValue(input.ObjectLockRetainUntilDate),
      () => (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
    ],
    "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus,
    "x-amz-expected-bucket-owner": input.ExpectedBucketOwner,
    ...input.Metadata !== void 0 && Object.keys(input.Metadata).reduce((acc, suffix) => {
      acc[`x-amz-meta-${suffix.toLowerCase()}`] = input.Metadata[suffix];
      return acc;
    }, {})
  });
  let resolvedPath$1 = `${(basePath == null ? void 0 : basePath.endsWith("/")) ? basePath.slice(0, -1) : basePath || ""}/{Key+}`;
  resolvedPath$1 = resolvedPath(resolvedPath$1, input, "Bucket", () => input.Bucket, "{Bucket}", false);
  resolvedPath$1 = resolvedPath(resolvedPath$1, input, "Key", () => input.Key, "{Key+}", true);
  const query6 = map$4({
    "x-id": [, "PutObject"]
  });
  let body;
  if (input.Body !== void 0) {
    body = input.Body;
  }
  let contents;
  if (input.Body !== void 0) {
    contents = input.Body;
    body = contents;
  }
  return new HttpRequest({
    protocol,
    hostname,
    port,
    method: "PUT",
    headers,
    path: resolvedPath$1,
    query: query6,
    body
  });
};
const de_PutObjectCommand = async (output2, context2) => {
  if (output2.statusCode !== 200 && output2.statusCode >= 300) {
    return de_PutObjectCommandError(output2, context2);
  }
  const contents = map$4({
    $metadata: deserializeMetadata(output2),
    Expiration: [, output2.headers["x-amz-expiration"]],
    ETag: [, output2.headers["etag"]],
    ChecksumCRC32: [, output2.headers["x-amz-checksum-crc32"]],
    ChecksumCRC32C: [, output2.headers["x-amz-checksum-crc32c"]],
    ChecksumSHA1: [, output2.headers["x-amz-checksum-sha1"]],
    ChecksumSHA256: [, output2.headers["x-amz-checksum-sha256"]],
    ServerSideEncryption: [, output2.headers["x-amz-server-side-encryption"]],
    VersionId: [, output2.headers["x-amz-version-id"]],
    SSECustomerAlgorithm: [, output2.headers["x-amz-server-side-encryption-customer-algorithm"]],
    SSECustomerKeyMD5: [, output2.headers["x-amz-server-side-encryption-customer-key-md5"]],
    SSEKMSKeyId: [, output2.headers["x-amz-server-side-encryption-aws-kms-key-id"]],
    SSEKMSEncryptionContext: [, output2.headers["x-amz-server-side-encryption-context"]],
    BucketKeyEnabled: [
      () => void 0 !== output2.headers["x-amz-server-side-encryption-bucket-key-enabled"],
      () => parseBoolean(output2.headers["x-amz-server-side-encryption-bucket-key-enabled"])
    ],
    RequestCharged: [, output2.headers["x-amz-request-charged"]]
  });
  await collectBody(output2.body, context2);
  return contents;
};
const de_PutObjectCommandError = async (output2, context2) => {
  const parsedOutput = {
    ...output2,
    body: await parseErrorBody(output2.body, context2)
  };
  const errorCode = loadRestXmlErrorCode(output2, parsedOutput.body);
  const parsedBody = parsedOutput.body;
  return throwDefaultError({
    output: output2,
    parsedBody,
    errorCode
  });
};
const throwDefaultError = withBaseException(S3ServiceException);
const deserializeMetadata = (output2) => ({
  httpStatusCode: output2.statusCode,
  requestId: output2.headers["x-amzn-requestid"] ?? output2.headers["x-amzn-request-id"] ?? output2.headers["x-amz-request-id"],
  extendedRequestId: output2.headers["x-amz-id-2"],
  cfId: output2.headers["x-amz-cf-id"]
});
const collectBody = (streamBody = new Uint8Array(), context2) => {
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context2.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
const collectBodyString = (streamBody, context2) => collectBody(streamBody, context2).then((body) => context2.utf8Encoder(body));
const isSerializableHeaderValue = (value) => value !== void 0 && value !== null && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
const parseBody = (streamBody, context2) => collectBodyString(streamBody, context2).then((encoded) => {
  if (encoded.length) {
    const parser = new fxp.XMLParser({
      attributeNamePrefix: "",
      htmlEntities: true,
      ignoreAttributes: false,
      ignoreDeclaration: true,
      parseTagValue: false,
      trimValues: false,
      tagValueProcessor: (_2, val) => val.trim() === "" && val.includes("\n") ? "" : void 0
    });
    parser.addEntity("#xD", "\r");
    parser.addEntity("#10", "\n");
    const parsedObj = parser.parse(encoded);
    const textNodeName = "#text";
    const key = Object.keys(parsedObj)[0];
    const parsedObjToReturn = parsedObj[key];
    if (parsedObjToReturn[textNodeName]) {
      parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
      delete parsedObjToReturn[textNodeName];
    }
    return getValueFromTextNode(parsedObjToReturn);
  }
  return {};
});
const parseErrorBody = async (errorBody, context2) => {
  const value = await parseBody(errorBody, context2);
  if (value.Error) {
    value.Error.message = value.Error.message ?? value.Error.Message;
  }
  return value;
};
const loadRestXmlErrorCode = (output2, data2) => {
  if ((data2 == null ? void 0 : data2.Code) !== void 0) {
    return data2.Code;
  }
  if (output2.statusCode == 404) {
    return "NotFound";
  }
};
function ssecMiddleware(options2) {
  return (next5) => async (args) => {
    let input = { ...args.input };
    const properties = [
      {
        target: "SSECustomerKey",
        hash: "SSECustomerKeyMD5"
      },
      {
        target: "CopySourceSSECustomerKey",
        hash: "CopySourceSSECustomerKeyMD5"
      }
    ];
    for (const prop of properties) {
      const value = input[prop.target];
      if (value) {
        const valueView = ArrayBuffer.isView(value) ? new Uint8Array(value.buffer, value.byteOffset, value.byteLength) : typeof value === "string" ? options2.utf8Decoder(value) : new Uint8Array(value);
        const encoded = options2.base64Encoder(valueView);
        const hash = new options2.md5();
        hash.update(valueView);
        input = {
          ...input,
          [prop.target]: encoded,
          [prop.hash]: options2.base64Encoder(await hash.digest())
        };
      }
    }
    return next5({
      ...args,
      input
    });
  };
}
const ssecMiddlewareOptions = {
  name: "ssecMiddleware",
  step: "initialize",
  tags: ["SSE"],
  override: true
};
const getSsecPlugin = (config2) => ({
  applyToStack: (clientStack) => {
    clientStack.add(ssecMiddleware(config2), ssecMiddlewareOptions);
  }
});
var ChecksumAlgorithm;
(function(ChecksumAlgorithm2) {
  ChecksumAlgorithm2["MD5"] = "MD5";
  ChecksumAlgorithm2["CRC32"] = "CRC32";
  ChecksumAlgorithm2["CRC32C"] = "CRC32C";
  ChecksumAlgorithm2["SHA1"] = "SHA1";
  ChecksumAlgorithm2["SHA256"] = "SHA256";
})(ChecksumAlgorithm || (ChecksumAlgorithm = {}));
var ChecksumLocation;
(function(ChecksumLocation2) {
  ChecksumLocation2["HEADER"] = "header";
  ChecksumLocation2["TRAILER"] = "trailer";
})(ChecksumLocation || (ChecksumLocation = {}));
const CLIENT_SUPPORTED_ALGORITHMS = [
  ChecksumAlgorithm.CRC32,
  ChecksumAlgorithm.CRC32C,
  ChecksumAlgorithm.SHA1,
  ChecksumAlgorithm.SHA256
];
const PRIORITY_ORDER_ALGORITHMS = [
  ChecksumAlgorithm.CRC32,
  ChecksumAlgorithm.CRC32C,
  ChecksumAlgorithm.SHA1,
  ChecksumAlgorithm.SHA256
];
const getChecksumAlgorithmForRequest = (input, { requestChecksumRequired, requestAlgorithmMember }) => {
  if (!requestAlgorithmMember || !input[requestAlgorithmMember]) {
    return requestChecksumRequired ? ChecksumAlgorithm.MD5 : void 0;
  }
  const checksumAlgorithm = input[requestAlgorithmMember];
  if (!CLIENT_SUPPORTED_ALGORITHMS.includes(checksumAlgorithm)) {
    throw new Error(`The checksum algorithm "${checksumAlgorithm}" is not supported by the client. Select one of ${CLIENT_SUPPORTED_ALGORITHMS}.`);
  }
  return checksumAlgorithm;
};
const getChecksumLocationName = (algorithm) => algorithm === ChecksumAlgorithm.MD5 ? "content-md5" : `x-amz-checksum-${algorithm.toLowerCase()}`;
const hasHeader = (header, headers) => {
  const soughtHeader = header.toLowerCase();
  for (const headerName of Object.keys(headers)) {
    if (soughtHeader === headerName.toLowerCase()) {
      return true;
    }
  }
  return false;
};
const isStreaming = (body) => body !== void 0 && typeof body !== "string" && !ArrayBuffer.isView(body) && !isArrayBuffer(body);
var build = {};
var tslibExports = {};
var tslib = {
  get exports() {
    return tslibExports;
  },
  set exports(v5) {
    tslibExports = v5;
  }
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
(function(module2) {
  var __extends;
  var __assign2;
  var __rest2;
  var __decorate;
  var __param;
  var __metadata;
  var __awaiter;
  var __generator;
  var __exportStar;
  var __values;
  var __read;
  var __spread;
  var __spreadArrays;
  var __await;
  var __asyncGenerator;
  var __asyncDelegator;
  var __asyncValues;
  var __makeTemplateObject;
  var __importStar;
  var __importDefault2;
  var __classPrivateFieldGet;
  var __classPrivateFieldSet;
  var __createBinding;
  (function(factory) {
    var root2 = typeof commonjsGlobal$1 === "object" ? commonjsGlobal$1 : typeof self === "object" ? self : typeof this === "object" ? this : {};
    {
      factory(createExporter(root2, createExporter(module2.exports)));
    }
    function createExporter(exports2, previous) {
      if (exports2 !== root2) {
        if (typeof Object.create === "function") {
          Object.defineProperty(exports2, "__esModule", { value: true });
        } else {
          exports2.__esModule = true;
        }
      }
      return function(id, v5) {
        return exports2[id] = previous ? previous(id, v5) : v5;
      };
    }
  })(function(exporter) {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p2 in b2)
        if (b2.hasOwnProperty(p2))
          d2[p2] = b2[p2];
    };
    __extends = function(d2, b2) {
      extendStatics(d2, b2);
      function __() {
        this.constructor = d2;
      }
      d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
    };
    __assign2 = Object.assign || function(t2) {
      for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
        s2 = arguments[i2];
        for (var p2 in s2)
          if (Object.prototype.hasOwnProperty.call(s2, p2))
            t2[p2] = s2[p2];
      }
      return t2;
    };
    __rest2 = function(s2, e3) {
      var t2 = {};
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
          t2[p2] = s2[p2];
      if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
          if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
            t2[p2[i2]] = s2[p2[i2]];
        }
      return t2;
    };
    __decorate = function(decorators, target, key, desc) {
      var c2 = arguments.length, r2 = c2 < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d2;
      if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r2 = Reflect.decorate(decorators, target, key, desc);
      else
        for (var i2 = decorators.length - 1; i2 >= 0; i2--)
          if (d2 = decorators[i2])
            r2 = (c2 < 3 ? d2(r2) : c2 > 3 ? d2(target, key, r2) : d2(target, key)) || r2;
      return c2 > 3 && r2 && Object.defineProperty(target, key, r2), r2;
    };
    __param = function(paramIndex, decorator) {
      return function(target, key) {
        decorator(target, key, paramIndex);
      };
    };
    __metadata = function(metadataKey, metadataValue) {
      if (typeof Reflect === "object" && typeof Reflect.metadata === "function")
        return Reflect.metadata(metadataKey, metadataValue);
    };
    __awaiter = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e3) {
            reject(e3);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e3) {
            reject(e3);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    __generator = function(thisArg, body) {
      var _2 = { label: 0, sent: function() {
        if (t2[0] & 1)
          throw t2[1];
        return t2[1];
      }, trys: [], ops: [] }, f2, y2, t2, g2;
      return g2 = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g2[Symbol.iterator] = function() {
        return this;
      }), g2;
      function verb(n2) {
        return function(v5) {
          return step([n2, v5]);
        };
      }
      function step(op) {
        if (f2)
          throw new TypeError("Generator is already executing.");
        while (_2)
          try {
            if (f2 = 1, y2 && (t2 = op[0] & 2 ? y2["return"] : op[0] ? y2["throw"] || ((t2 = y2["return"]) && t2.call(y2), 0) : y2.next) && !(t2 = t2.call(y2, op[1])).done)
              return t2;
            if (y2 = 0, t2)
              op = [op[0] & 2, t2.value];
            switch (op[0]) {
              case 0:
              case 1:
                t2 = op;
                break;
              case 4:
                _2.label++;
                return { value: op[1], done: false };
              case 5:
                _2.label++;
                y2 = op[1];
                op = [0];
                continue;
              case 7:
                op = _2.ops.pop();
                _2.trys.pop();
                continue;
              default:
                if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _2 = 0;
                  continue;
                }
                if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
                  _2.label = op[1];
                  break;
                }
                if (op[0] === 6 && _2.label < t2[1]) {
                  _2.label = t2[1];
                  t2 = op;
                  break;
                }
                if (t2 && _2.label < t2[2]) {
                  _2.label = t2[2];
                  _2.ops.push(op);
                  break;
                }
                if (t2[2])
                  _2.ops.pop();
                _2.trys.pop();
                continue;
            }
            op = body.call(thisArg, _2);
          } catch (e3) {
            op = [6, e3];
            y2 = 0;
          } finally {
            f2 = t2 = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    __createBinding = function(o2, m2, k2, k22) {
      if (k22 === void 0)
        k22 = k2;
      o2[k22] = m2[k2];
    };
    __exportStar = function(m2, exports2) {
      for (var p2 in m2)
        if (p2 !== "default" && !exports2.hasOwnProperty(p2))
          exports2[p2] = m2[p2];
    };
    __values = function(o2) {
      var s2 = typeof Symbol === "function" && Symbol.iterator, m2 = s2 && o2[s2], i2 = 0;
      if (m2)
        return m2.call(o2);
      if (o2 && typeof o2.length === "number")
        return {
          next: function() {
            if (o2 && i2 >= o2.length)
              o2 = void 0;
            return { value: o2 && o2[i2++], done: !o2 };
          }
        };
      throw new TypeError(s2 ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    __read = function(o2, n2) {
      var m2 = typeof Symbol === "function" && o2[Symbol.iterator];
      if (!m2)
        return o2;
      var i2 = m2.call(o2), r2, ar2 = [], e3;
      try {
        while ((n2 === void 0 || n2-- > 0) && !(r2 = i2.next()).done)
          ar2.push(r2.value);
      } catch (error2) {
        e3 = { error: error2 };
      } finally {
        try {
          if (r2 && !r2.done && (m2 = i2["return"]))
            m2.call(i2);
        } finally {
          if (e3)
            throw e3.error;
        }
      }
      return ar2;
    };
    __spread = function() {
      for (var ar2 = [], i2 = 0; i2 < arguments.length; i2++)
        ar2 = ar2.concat(__read(arguments[i2]));
      return ar2;
    };
    __spreadArrays = function() {
      for (var s2 = 0, i2 = 0, il = arguments.length; i2 < il; i2++)
        s2 += arguments[i2].length;
      for (var r2 = Array(s2), k2 = 0, i2 = 0; i2 < il; i2++)
        for (var a2 = arguments[i2], j2 = 0, jl = a2.length; j2 < jl; j2++, k2++)
          r2[k2] = a2[j2];
      return r2;
    };
    __await = function(v5) {
      return this instanceof __await ? (this.v = v5, this) : new __await(v5);
    };
    __asyncGenerator = function(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var g2 = generator.apply(thisArg, _arguments || []), i2, q2 = [];
      return i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2;
      function verb(n2) {
        if (g2[n2])
          i2[n2] = function(v5) {
            return new Promise(function(a2, b2) {
              q2.push([n2, v5, a2, b2]) > 1 || resume(n2, v5);
            });
          };
      }
      function resume(n2, v5) {
        try {
          step(g2[n2](v5));
        } catch (e3) {
          settle(q2[0][3], e3);
        }
      }
      function step(r2) {
        r2.value instanceof __await ? Promise.resolve(r2.value.v).then(fulfill, reject) : settle(q2[0][2], r2);
      }
      function fulfill(value) {
        resume("next", value);
      }
      function reject(value) {
        resume("throw", value);
      }
      function settle(f2, v5) {
        if (f2(v5), q2.shift(), q2.length)
          resume(q2[0][0], q2[0][1]);
      }
    };
    __asyncDelegator = function(o2) {
      var i2, p2;
      return i2 = {}, verb("next"), verb("throw", function(e3) {
        throw e3;
      }), verb("return"), i2[Symbol.iterator] = function() {
        return this;
      }, i2;
      function verb(n2, f2) {
        i2[n2] = o2[n2] ? function(v5) {
          return (p2 = !p2) ? { value: __await(o2[n2](v5)), done: n2 === "return" } : f2 ? f2(v5) : v5;
        } : f2;
      }
    };
    __asyncValues = function(o2) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var m2 = o2[Symbol.asyncIterator], i2;
      return m2 ? m2.call(o2) : (o2 = typeof __values === "function" ? __values(o2) : o2[Symbol.iterator](), i2 = {}, verb("next"), verb("throw"), verb("return"), i2[Symbol.asyncIterator] = function() {
        return this;
      }, i2);
      function verb(n2) {
        i2[n2] = o2[n2] && function(v5) {
          return new Promise(function(resolve2, reject) {
            v5 = o2[n2](v5), settle(resolve2, reject, v5.done, v5.value);
          });
        };
      }
      function settle(resolve2, reject, d2, v5) {
        Promise.resolve(v5).then(function(v6) {
          resolve2({ value: v6, done: d2 });
        }, reject);
      }
    };
    __makeTemplateObject = function(cooked, raw) {
      if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
      } else {
        cooked.raw = raw;
      }
      return cooked;
    };
    __importStar = function(mod2) {
      if (mod2 && mod2.__esModule)
        return mod2;
      var result = {};
      if (mod2 != null) {
        for (var k2 in mod2)
          if (Object.hasOwnProperty.call(mod2, k2))
            result[k2] = mod2[k2];
      }
      result["default"] = mod2;
      return result;
    };
    __importDefault2 = function(mod2) {
      return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
    };
    __classPrivateFieldGet = function(receiver, privateMap) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
      }
      return privateMap.get(receiver);
    };
    __classPrivateFieldSet = function(receiver, privateMap, value) {
      if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
      }
      privateMap.set(receiver, value);
      return value;
    };
    exporter("__extends", __extends);
    exporter("__assign", __assign2);
    exporter("__rest", __rest2);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault2);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
  });
})(tslib);
var aws_crc32c = {};
var hasRequiredAws_crc32c;
function requireAws_crc32c() {
  if (hasRequiredAws_crc32c)
    return aws_crc32c;
  hasRequiredAws_crc32c = 1;
  Object.defineProperty(aws_crc32c, "__esModule", { value: true });
  aws_crc32c.AwsCrc32c = void 0;
  var tslib_1 = tslibExports;
  var util_1 = requireBuild$3();
  var index_1 = requireBuild();
  var AwsCrc32c = (
    /** @class */
    function() {
      function AwsCrc32c2() {
        this.crc32c = new index_1.Crc32c();
      }
      AwsCrc32c2.prototype.update = function(toHash) {
        if ((0, util_1.isEmptyData)(toHash))
          return;
        this.crc32c.update((0, util_1.convertToBuffer)(toHash));
      };
      AwsCrc32c2.prototype.digest = function() {
        return tslib_1.__awaiter(this, void 0, void 0, function() {
          return tslib_1.__generator(this, function(_a3) {
            return [2, (0, util_1.numToUint8)(this.crc32c.digest())];
          });
        });
      };
      AwsCrc32c2.prototype.reset = function() {
        this.crc32c = new index_1.Crc32c();
      };
      return AwsCrc32c2;
    }()
  );
  aws_crc32c.AwsCrc32c = AwsCrc32c;
  return aws_crc32c;
}
var hasRequiredBuild;
function requireBuild() {
  if (hasRequiredBuild)
    return build;
  hasRequiredBuild = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.AwsCrc32c = exports2.Crc32c = exports2.crc32c = void 0;
    var tslib_1 = tslibExports;
    var util_1 = requireBuild$3();
    function crc32c(data2) {
      return new Crc32c().update(data2).digest();
    }
    exports2.crc32c = crc32c;
    var Crc32c = (
      /** @class */
      function() {
        function Crc32c2() {
          this.checksum = 4294967295;
        }
        Crc32c2.prototype.update = function(data2) {
          var e_1, _a3;
          try {
            for (var data_1 = tslib_1.__values(data2), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
              var byte = data_1_1.value;
              this.checksum = this.checksum >>> 8 ^ lookupTable[(this.checksum ^ byte) & 255];
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (data_1_1 && !data_1_1.done && (_a3 = data_1.return))
                _a3.call(data_1);
            } finally {
              if (e_1)
                throw e_1.error;
            }
          }
          return this;
        };
        Crc32c2.prototype.digest = function() {
          return (this.checksum ^ 4294967295) >>> 0;
        };
        return Crc32c2;
      }()
    );
    exports2.Crc32c = Crc32c;
    var a_lookupTable = [
      0,
      4067132163,
      3778769143,
      324072436,
      3348797215,
      904991772,
      648144872,
      3570033899,
      2329499855,
      2024987596,
      1809983544,
      2575936315,
      1296289744,
      3207089363,
      2893594407,
      1578318884,
      274646895,
      3795141740,
      4049975192,
      51262619,
      3619967088,
      632279923,
      922689671,
      3298075524,
      2592579488,
      1760304291,
      2075979607,
      2312596564,
      1562183871,
      2943781820,
      3156637768,
      1313733451,
      549293790,
      3537243613,
      3246849577,
      871202090,
      3878099393,
      357341890,
      102525238,
      4101499445,
      2858735121,
      1477399826,
      1264559846,
      3107202533,
      1845379342,
      2677391885,
      2361733625,
      2125378298,
      820201905,
      3263744690,
      3520608582,
      598981189,
      4151959214,
      85089709,
      373468761,
      3827903834,
      3124367742,
      1213305469,
      1526817161,
      2842354314,
      2107672161,
      2412447074,
      2627466902,
      1861252501,
      1098587580,
      3004210879,
      2688576843,
      1378610760,
      2262928035,
      1955203488,
      1742404180,
      2511436119,
      3416409459,
      969524848,
      714683780,
      3639785095,
      205050476,
      4266873199,
      3976438427,
      526918040,
      1361435347,
      2739821008,
      2954799652,
      1114974503,
      2529119692,
      1691668175,
      2005155131,
      2247081528,
      3690758684,
      697762079,
      986182379,
      3366744552,
      476452099,
      3993867776,
      4250756596,
      255256311,
      1640403810,
      2477592673,
      2164122517,
      1922457750,
      2791048317,
      1412925310,
      1197962378,
      3037525897,
      3944729517,
      427051182,
      170179418,
      4165941337,
      746937522,
      3740196785,
      3451792453,
      1070968646,
      1905808397,
      2213795598,
      2426610938,
      1657317369,
      3053634322,
      1147748369,
      1463399397,
      2773627110,
      4215344322,
      153784257,
      444234805,
      3893493558,
      1021025245,
      3467647198,
      3722505002,
      797665321,
      2197175160,
      1889384571,
      1674398607,
      2443626636,
      1164749927,
      3070701412,
      2757221520,
      1446797203,
      137323447,
      4198817972,
      3910406976,
      461344835,
      3484808360,
      1037989803,
      781091935,
      3705997148,
      2460548119,
      1623424788,
      1939049696,
      2180517859,
      1429367560,
      2807687179,
      3020495871,
      1180866812,
      410100952,
      3927582683,
      4182430767,
      186734380,
      3756733383,
      763408580,
      1053836080,
      3434856499,
      2722870694,
      1344288421,
      1131464017,
      2971354706,
      1708204729,
      2545590714,
      2229949006,
      1988219213,
      680717673,
      3673779818,
      3383336350,
      1002577565,
      4010310262,
      493091189,
      238226049,
      4233660802,
      2987750089,
      1082061258,
      1395524158,
      2705686845,
      1972364758,
      2279892693,
      2494862625,
      1725896226,
      952904198,
      3399985413,
      3656866545,
      731699698,
      4283874585,
      222117402,
      510512622,
      3959836397,
      3280807620,
      837199303,
      582374963,
      3504198960,
      68661723,
      4135334616,
      3844915500,
      390545967,
      1230274059,
      3141532936,
      2825850620,
      1510247935,
      2395924756,
      2091215383,
      1878366691,
      2644384480,
      3553878443,
      565732008,
      854102364,
      3229815391,
      340358836,
      3861050807,
      4117890627,
      119113024,
      1493875044,
      2875275879,
      3090270611,
      1247431312,
      2660249211,
      1828433272,
      2141937292,
      2378227087,
      3811616794,
      291187481,
      34330861,
      4032846830,
      615137029,
      3603020806,
      3314634738,
      939183345,
      1776939221,
      2609017814,
      2295496738,
      2058945313,
      2926798794,
      1545135305,
      1330124605,
      3173225534,
      4084100981,
      17165430,
      307568514,
      3762199681,
      888469610,
      3332340585,
      3587147933,
      665062302,
      2042050490,
      2346497209,
      2559330125,
      1793573966,
      3190661285,
      1279665062,
      1595330642,
      2910671697
    ];
    var lookupTable = (0, util_1.uint32ArrayFrom)(a_lookupTable);
    var aws_crc32c_1 = requireAws_crc32c();
    Object.defineProperty(exports2, "AwsCrc32c", { enumerable: true, get: function() {
      return aws_crc32c_1.AwsCrc32c;
    } });
  })(build);
  return build;
}
var buildExports = requireBuild();
const selectChecksumAlgorithmFunction = (checksumAlgorithm, config2) => ({
  [ChecksumAlgorithm.MD5]: config2.md5,
  [ChecksumAlgorithm.CRC32]: buildExports$1.AwsCrc32,
  [ChecksumAlgorithm.CRC32C]: buildExports.AwsCrc32c,
  [ChecksumAlgorithm.SHA1]: config2.sha1,
  [ChecksumAlgorithm.SHA256]: config2.sha256
})[checksumAlgorithm];
const stringHasher = (checksumAlgorithmFn, body) => {
  const hash = new checksumAlgorithmFn();
  hash.update(toUint8Array(body || ""));
  return hash.digest();
};
const getChecksum = async (body, { streamHasher, checksumAlgorithmFn, base64Encoder }) => {
  const digest = isStreaming(body) ? streamHasher(checksumAlgorithmFn, body) : stringHasher(checksumAlgorithmFn, body);
  return base64Encoder(await digest);
};
const getChecksumAlgorithmListForResponse = (responseAlgorithms = []) => {
  const validChecksumAlgorithms = [];
  for (const algorithm of PRIORITY_ORDER_ALGORITHMS) {
    if (!responseAlgorithms.includes(algorithm) || !CLIENT_SUPPORTED_ALGORITHMS.includes(algorithm)) {
      continue;
    }
    validChecksumAlgorithms.push(algorithm);
  }
  return validChecksumAlgorithms;
};
const validateChecksumFromResponse = async (response, { config: config2, responseAlgorithms }) => {
  const checksumAlgorithms = getChecksumAlgorithmListForResponse(responseAlgorithms);
  const { body: responseBody, headers: responseHeaders } = response;
  for (const algorithm of checksumAlgorithms) {
    const responseHeader = getChecksumLocationName(algorithm);
    const checksumFromResponse = responseHeaders[responseHeader];
    if (checksumFromResponse) {
      const checksumAlgorithmFn = selectChecksumAlgorithmFunction(algorithm, config2);
      const { streamHasher, base64Encoder } = config2;
      const checksum = await getChecksum(responseBody, { streamHasher, checksumAlgorithmFn, base64Encoder });
      if (checksum === checksumFromResponse) {
        break;
      }
      throw new Error(`Checksum mismatch: expected "${checksum}" but received "${checksumFromResponse}" in response header "${responseHeader}".`);
    }
  }
};
const flexibleChecksumsMiddleware = (config2, middlewareConfig) => (next5) => async (args) => {
  if (!HttpRequest$1.isInstance(args.request)) {
    return next5(args);
  }
  const { request } = args;
  const { body: requestBody, headers } = request;
  const { base64Encoder, streamHasher } = config2;
  const { input, requestChecksumRequired, requestAlgorithmMember } = middlewareConfig;
  const checksumAlgorithm = getChecksumAlgorithmForRequest(input, {
    requestChecksumRequired,
    requestAlgorithmMember
  });
  let updatedBody = requestBody;
  let updatedHeaders = headers;
  if (checksumAlgorithm) {
    const checksumLocationName = getChecksumLocationName(checksumAlgorithm);
    const checksumAlgorithmFn = selectChecksumAlgorithmFunction(checksumAlgorithm, config2);
    if (isStreaming(requestBody)) {
      const { getAwsChunkedEncodingStream: getAwsChunkedEncodingStream2, bodyLengthChecker } = config2;
      updatedBody = getAwsChunkedEncodingStream2(requestBody, {
        base64Encoder,
        bodyLengthChecker,
        checksumLocationName,
        checksumAlgorithmFn,
        streamHasher
      });
      updatedHeaders = {
        ...headers,
        "content-encoding": headers["content-encoding"] ? `${headers["content-encoding"]},aws-chunked` : "aws-chunked",
        "transfer-encoding": "chunked",
        "x-amz-decoded-content-length": headers["content-length"],
        "x-amz-content-sha256": "STREAMING-UNSIGNED-PAYLOAD-TRAILER",
        "x-amz-trailer": checksumLocationName
      };
      delete updatedHeaders["content-length"];
    } else if (!hasHeader(checksumLocationName, headers)) {
      const rawChecksum = await stringHasher(checksumAlgorithmFn, requestBody);
      updatedHeaders = {
        ...headers,
        [checksumLocationName]: base64Encoder(rawChecksum)
      };
    }
  }
  const result = await next5({
    ...args,
    request: {
      ...request,
      headers: updatedHeaders,
      body: updatedBody
    }
  });
  const { requestValidationModeMember, responseAlgorithms } = middlewareConfig;
  if (requestValidationModeMember && input[requestValidationModeMember] === "ENABLED") {
    validateChecksumFromResponse(result.response, {
      config: config2,
      responseAlgorithms
    });
  }
  return result;
};
const flexibleChecksumsMiddlewareOptions = {
  name: "flexibleChecksumsMiddleware",
  step: "build",
  tags: ["BODY_CHECKSUM"],
  override: true
};
const getFlexibleChecksumsPlugin = (config2, middlewareConfig) => ({
  applyToStack: (clientStack) => {
    clientStack.add(flexibleChecksumsMiddleware(config2, middlewareConfig), flexibleChecksumsMiddlewareOptions);
  }
});
class PutObjectCommand extends Command {
  static getEndpointParameterInstructions() {
    return {
      Bucket: { type: "contextParams", name: "Bucket" },
      ForcePathStyle: { type: "clientContextParams", name: "forcePathStyle" },
      UseArnRegion: { type: "clientContextParams", name: "useArnRegion" },
      DisableMultiRegionAccessPoints: { type: "clientContextParams", name: "disableMultiregionAccessPoints" },
      Accelerate: { type: "clientContextParams", name: "useAccelerateEndpoint" },
      UseGlobalEndpoint: { type: "builtInParams", name: "useGlobalEndpoint" },
      UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
      Endpoint: { type: "builtInParams", name: "endpoint" },
      Region: { type: "builtInParams", name: "region" },
      UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" }
    };
  }
  constructor(input) {
    super();
    this.input = input;
  }
  resolveMiddleware(clientStack, configuration, options2) {
    this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
    this.middlewareStack.use(getEndpointPlugin(configuration, PutObjectCommand.getEndpointParameterInstructions()));
    this.middlewareStack.use(getCheckContentLengthHeaderPlugin());
    this.middlewareStack.use(getSsecPlugin(configuration));
    this.middlewareStack.use(getFlexibleChecksumsPlugin(configuration, {
      input: this.input,
      requestAlgorithmMember: "ChecksumAlgorithm",
      requestChecksumRequired: false
    }));
    const stack2 = clientStack.concat(this.middlewareStack);
    const { logger: logger2 } = configuration;
    const clientName = "S3Client";
    const commandName = "PutObjectCommand";
    const handlerExecutionContext = {
      logger: logger2,
      clientName,
      commandName,
      inputFilterSensitiveLog: PutObjectRequestFilterSensitiveLog,
      outputFilterSensitiveLog: PutObjectOutputFilterSensitiveLog
    };
    const { requestHandler } = configuration;
    return stack2.resolve((request) => requestHandler.handle(request.request, options2 || {}), handlerExecutionContext);
  }
  serialize(input, context2) {
    return se_PutObjectCommand(input, context2);
  }
  deserialize(output2, context2) {
    return de_PutObjectCommand(output2, context2);
  }
}
const useEnvStore = create$6((set) => ({
  env: {},
  setEnv: (env) => {
    set((state) => ({
      env: {
        ...state.env,
        ...env || {}
      }
    }));
  }
}));
const BASE_URL = "https://api.cesium.com/v1";
class CesiumIonUtil {
  static getToken() {
    return useEnvStore.getState().env.cesiumToken;
  }
  static async getAsset(id) {
    const url2 = `${BASE_URL}/assets/${id}/endpoint`;
    const token = CesiumIonUtil.getToken();
    if (!token) {
      throw new Error("No valid token found for fetching ion asset");
    }
    const response = await fetch(url2, {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    if (!(response == null ? void 0 : response.ok))
      throw new Error(`Failed to fetch ion asset: ${id}`);
    const result = await response.json();
    return result;
  }
  static onProgressUpdate(onProgress, startPercent, endPercent) {
    return (data2) => {
      if (data2 && onProgress) {
        const updates = {
          ...data2,
          percentComplete: startPercent + (endPercent - startPercent) * data2.percentComplete / 100
        };
        onProgress(updates);
      }
    };
  }
  static async createAssetTiles(file2, options2, onProgress) {
    try {
      const response = await CesiumIonUtil.uploadAssetRequest(file2, options2, CesiumIonUtil.onProgressUpdate(onProgress, 0, 10));
      await CesiumIonUtil.uploadAssetToS3(file2, response.uploadLocation, CesiumIonUtil.onProgressUpdate(onProgress, 10, 20));
      await CesiumIonUtil.startTilingForAsset(response.onComplete, CesiumIonUtil.onProgressUpdate(onProgress, 20, 30));
      let tilingDone = false;
      const cesiumAssetId = response.assetMetadata.id;
      if (cesiumAssetId) {
        tilingDone = await CesiumIonUtil.waitForTiles(cesiumAssetId, CesiumIonUtil.onProgressUpdate(onProgress, 30, 100));
      }
      return [cesiumAssetId, tilingDone];
    } catch (error2) {
      console.error(error2);
    }
    return [];
  }
  static async uploadAssetRequest(file2, options2, onProgress) {
    var _a3, _b3;
    const url2 = `${BASE_URL}/assets`;
    const token = CesiumIonUtil.getToken();
    if (!token) {
      throw new Error("No valid token found for fetching ion asset");
    }
    const filename2 = file2.originalname || file2.filename;
    const extension = (_a3 = filename2 == null ? void 0 : filename2.split(".")) == null ? void 0 : _a3.pop().toLowerCase();
    const assetName = ((_b3 = filename2 == null ? void 0 : filename2.split(".")) == null ? void 0 : _b3[0]) || filename2;
    const sourceType = CesiumIonUtil.getCesiumModelType(extension);
    if (!sourceType || !assetName) {
      throw new Error(`Unsupported file format ${extension}`);
    }
    const {
      description: description2,
      type,
      longitude,
      latitude,
      height,
      ...restProps
    } = options2 || {};
    const body = {
      name: assetName,
      description: description2 || "",
      type: type || "3DTILES",
      options: {
        sourceType
      }
    };
    if (longitude && latitude)
      body.options.position = [Number(longitude), Number(latitude), Number(height || 0)];
    Object.keys(restProps).forEach((key) => {
      body.options[key] = restProps[key];
    });
    const response = await fetch(url2, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    });
    if (!(response == null ? void 0 : response.ok))
      throw new Error(`Failed to invoke upload asset request: ${assetName}`);
    onProgress({
      type: "info",
      message: "Provisioning an asset",
      percentComplete: 10
    });
    const result = await response.json();
    onProgress({
      type: "info",
      message: "Asset provisioned",
      percentComplete: 100
    });
    return result;
  }
  static async uploadAssetToS3(file2, uploadLocation, onProgress) {
    if (!file2 || !uploadLocation) {
      throw new Error("Invalid upload to S3");
    }
    onProgress({
      type: "info",
      message: "Uploading data",
      percentComplete: 10
    });
    const filename2 = file2.originalname || file2.filename;
    await CesiumIonUtil.uploadFileToS3({
      ...uploadLocation,
      key: `${uploadLocation.prefix}${filename2}`
    }, file2.data);
    onProgress({
      type: "info",
      message: "Data upload completed",
      percentComplete: 100
    });
  }
  static async startTilingForAsset(onComplete, onProgress) {
    const token = CesiumIonUtil.getToken();
    if (!token) {
      throw new Error("No valid token found for fetching ion asset");
    }
    onProgress({
      type: "info",
      message: "Triggering tiling pipeline",
      percentComplete: 10
    });
    await fetch(onComplete.url, {
      method: onComplete.method,
      headers: {
        Authorization: `Bearer ${token}`
      },
      body: onComplete.fields
    });
  }
  static async waitUntilDoneOrAbort(callback, timeoutInMs = 1e4, maxChecks = 30) {
    let done = false;
    while (!done && maxChecks-- > 0) {
      const result = await callback();
      done = result.done;
      if (result.abort)
        break;
      await new Promise((resolve2) => setTimeout(resolve2, timeoutInMs));
    }
    return done;
  }
  static async waitForTiles(assetId, onProgress) {
    const token = CesiumIonUtil.getToken();
    if (!token) {
      throw new Error("No valid token found for fetching ion asset");
    }
    const isDone10 = await CesiumIonUtil.waitUntilDoneOrAbort(async () => {
      const response = await fetch(`${BASE_URL}/assets/${assetId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      if (!(response == null ? void 0 : response.ok))
        throw new Error(`Failed to fetch asset metadata: ${assetId}`);
      const assetMetadata = await response.json();
      const {
        status
      } = assetMetadata;
      if (status === "COMPLETE") {
        onProgress({
          percentComplete: 100,
          message: "Asset tiled successfully",
          type: "info"
        });
        return {
          done: true
        };
      }
      if (status === "DATA_ERROR") {
        onProgress({
          percentComplete: 100,
          message: "ION detected an error",
          type: "error"
        });
        return {
          abort: true
        };
      }
      if (status === "ERROR") {
        onProgress({
          percentComplete: 100,
          message: "ION error occurred",
          type: "error"
        });
        return {
          abort: true
        };
      }
      if (status === "NOT_STARTED") {
        onProgress({
          percentComplete: 5,
          message: "Tiling pipeline initializing",
          type: "info"
        });
      } else if (status === "IN_PROGRESS") {
        onProgress({
          percentComplete: assetMetadata.percentComplete,
          message: "Tiling in progress",
          type: "info"
        });
      } else {
        onProgress({
          percentComplete: 100,
          message: "ION error occurred",
          type: "error"
        });
        return {
          abort: true
        };
      }
      return {};
    });
    return isDone10;
  }
  static getCesiumModelType(extension) {
    if (extension) {
      const type = extension.toUpperCase();
      switch (type) {
        case "GLTF":
        case "GLB":
        case "OBJ":
        case "FBX":
        case "DAE":
          return "3D_MODEL";
        case "LAS":
        case "LAZ":
          return "POINT_CLOUD";
        default:
          return type;
      }
    }
    return "";
  }
  static getS3Client({
    accessKey,
    secretAccessKey,
    sessionToken
  }) {
    return new S3Client({
      apiVersion: "2006-03-01",
      region: "us-east-1",
      credentials: {
        accessKeyId: accessKey,
        secretAccessKey,
        sessionToken
      }
    });
  }
  static async uploadFileToS3(config2, stream2) {
    const client2 = CesiumIonUtil.getS3Client(config2);
    const command = new PutObjectCommand({
      Body: stream2,
      Bucket: config2.bucket,
      Key: config2.key
    });
    const response = await client2.send(command);
    return response.$metadata.httpStatusCode;
  }
}
class ColorUtil {
  static convertToRGB(hex, alpha = 1) {
    if (typeof hex === "string") {
      const hexRgb = hex.replace("#", "").match(/.{1,2}/g);
      const result = {
        r: parseInt(hexRgb[0] || 0, 16),
        g: parseInt(hexRgb[1] || 0, 16),
        b: parseInt(hexRgb[2] || 0, 16),
        a: alpha
      };
      return result;
    }
    if (Array.isArray(hex)) {
      if (hex.length === 3 || hex.length === 4) {
        const result = {
          r: Number(hex[0]),
          g: Number(hex[1]),
          b: Number(hex[2]),
          a: parseFloat(hex[3])
        };
        if (result.a > 1)
          result.a /= 255;
        return result;
      }
    }
    return hex;
  }
  static convertToArray(color, alpha) {
    const rgba = ColorUtil.convertToRGB(color, alpha);
    const {
      r: r2,
      g: g2,
      b: b2,
      a: a2
    } = rgba;
    if (a2 === 1) {
      return [r2, g2, b2];
    }
    return [r2, g2, b2, Math.round(rgba.a * 255)];
  }
  static convertToRGBAString(color, alp) {
    const rgba = ColorUtil.convertToRGB(color, alp);
    const {
      r: r2,
      g: g2,
      b: b2,
      a: a2
    } = rgba;
    if (a2 === 1) {
      return `rgb(${r2},${g2},${b2})`;
    }
    const alpha = Math.round(rgba.a * 100) / 100;
    return `rgba(${r2},${g2},${b2},${alpha})`;
  }
  static convertToHex(rgb) {
    rgb = ColorUtil.convertToRGB(rgb);
    const componentToHex = (c2) => {
      const hex = c2.toString(16);
      return hex.length === 1 ? `0${hex}` : hex;
    };
    const alphaToHex = (a2) => {
      if (typeof a2 !== "number")
        return "";
      if (a2 === 0)
        return "00";
      if (a2 === 1)
        return "";
      a2 = Math.round(a2 * 255);
      if (a2 === 255)
        return "";
      return componentToHex(a2);
    };
    const result = `#${componentToHex(rgb.r || 0)}${componentToHex(rgb.g || 0)}${componentToHex(rgb.b || 0)}${alphaToHex(rgb.a)}`;
    return result;
  }
  static rgbToHsv(r2, g2, b2) {
    r2 /= 255;
    g2 /= 255;
    b2 /= 255;
    const max3 = Math.max(r2, g2, b2);
    const min4 = Math.min(r2, g2, b2);
    let h2;
    let s2;
    const v5 = max3;
    const delta = max3 - min4;
    if (max3 === 0) {
      s2 = 0;
    } else {
      s2 = delta / max3;
    }
    if (max3 === min4) {
      h2 = 0;
    } else {
      switch (max3) {
        case r2:
          h2 = (g2 - b2) / delta;
          if (g2 < b2)
            h2 += 6;
          break;
        case g2:
          h2 = (b2 - r2) / delta + 2;
          break;
        case b2:
          h2 = (r2 - g2) / delta + 4;
          break;
      }
      h2 /= 6;
    }
    return {
      h: Math.round(h2 * 360),
      s: Math.round(s2 * 100),
      v: Math.round(v5 * 100)
    };
  }
  static getInterpolatedColor(normalizedValue, sortedKeys, colorMapArray) {
    const endIndex = sortedKeys.findIndex((val) => Number(val) > normalizedValue);
    if (endIndex < 0)
      return colorMapArray[0];
    const startIndex = endIndex < 1 ? 0 : endIndex - 1;
    const startColor = colorMapArray[startIndex];
    const endColor = colorMapArray[endIndex];
    const startValue = parseFloat(sortedKeys[startIndex], 10);
    const endValue = parseFloat(sortedKeys[endIndex], 10);
    const delta = endValue - startValue;
    const remainder = (normalizedValue - startValue) % delta;
    const percent = remainder / delta;
    const interpolate2 = (i2, start2, end) => Math.round(start2 + i2 * (end - start2));
    const finalColor = startColor.map((s2, index2) => interpolate2(percent, s2, endColor[index2]));
    return finalColor;
  }
}
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const REVISION = "139";
const MOUSE = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 };
const TOUCH = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 };
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const FlatShading = 1;
const SmoothShading = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const RepeatWrapping = 1e3;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedInt248Type = 1020;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBAIntegerFormat = 1033;
const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const LinearEncoding = 3e3;
const sRGBEncoding = 3001;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;
const NoColorSpace = "";
const SRGBColorSpace = "srgb";
const LinearSRGBColorSpace = "srgb-linear";
const ZeroStencilOp = 0;
const KeepStencilOp = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;
const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc = 519;
const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;
const GLSL1 = "100";
const GLSL3 = "300 es";
const _SRGBAFormat = 1035;
let EventDispatcher$1 = class EventDispatcher2 {
  addEventListener(type, listener) {
    if (this._listeners === void 0)
      this._listeners = {};
    const listeners2 = this._listeners;
    if (listeners2[type] === void 0) {
      listeners2[type] = [];
    }
    if (listeners2[type].indexOf(listener) === -1) {
      listeners2[type].push(listener);
    }
  }
  hasEventListener(type, listener) {
    if (this._listeners === void 0)
      return false;
    const listeners2 = this._listeners;
    return listeners2[type] !== void 0 && listeners2[type].indexOf(listener) !== -1;
  }
  removeEventListener(type, listener) {
    if (this._listeners === void 0)
      return;
    const listeners2 = this._listeners;
    const listenerArray = listeners2[type];
    if (listenerArray !== void 0) {
      const index2 = listenerArray.indexOf(listener);
      if (index2 !== -1) {
        listenerArray.splice(index2, 1);
      }
    }
  }
  dispatchEvent(event) {
    if (this._listeners === void 0)
      return;
    const listeners2 = this._listeners;
    const listenerArray = listeners2[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array2 = listenerArray.slice(0);
      for (let i2 = 0, l2 = array2.length; i2 < l2; i2++) {
        array2[i2].call(this, event);
      }
      event.target = null;
    }
  }
};
const _lut = [];
for (let i2 = 0; i2 < 256; i2++) {
  _lut[i2] = (i2 < 16 ? "0" : "") + i2.toString(16);
}
let _seed = 1234567;
const DEG2RAD$1 = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;
function generateUUID() {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  const uuid = _lut[d0 & 255] + _lut[d0 >> 8 & 255] + _lut[d0 >> 16 & 255] + _lut[d0 >> 24 & 255] + "-" + _lut[d1 & 255] + _lut[d1 >> 8 & 255] + "-" + _lut[d1 >> 16 & 15 | 64] + _lut[d1 >> 24 & 255] + "-" + _lut[d2 & 63 | 128] + _lut[d2 >> 8 & 255] + "-" + _lut[d2 >> 16 & 255] + _lut[d2 >> 24 & 255] + _lut[d3 & 255] + _lut[d3 >> 8 & 255] + _lut[d3 >> 16 & 255] + _lut[d3 >> 24 & 255];
  return uuid.toLowerCase();
}
function clamp$5(value, min4, max3) {
  return Math.max(min4, Math.min(max3, value));
}
function euclideanModulo(n2, m2) {
  return (n2 % m2 + m2) % m2;
}
function mapLinear(x2, a1, a2, b1, b2) {
  return b1 + (x2 - a1) * (b2 - b1) / (a2 - a1);
}
function inverseLerp(x2, y2, value) {
  if (x2 !== y2) {
    return (value - x2) / (y2 - x2);
  } else {
    return 0;
  }
}
function lerp$6(x2, y2, t2) {
  return (1 - t2) * x2 + t2 * y2;
}
function damp(x2, y2, lambda, dt) {
  return lerp$6(x2, y2, 1 - Math.exp(-lambda * dt));
}
function pingpong(x2, length2 = 1) {
  return length2 - Math.abs(euclideanModulo(x2, length2 * 2) - length2);
}
function smoothstep(x2, min4, max3) {
  if (x2 <= min4)
    return 0;
  if (x2 >= max3)
    return 1;
  x2 = (x2 - min4) / (max3 - min4);
  return x2 * x2 * (3 - 2 * x2);
}
function smootherstep(x2, min4, max3) {
  if (x2 <= min4)
    return 0;
  if (x2 >= max3)
    return 1;
  x2 = (x2 - min4) / (max3 - min4);
  return x2 * x2 * x2 * (x2 * (x2 * 6 - 15) + 10);
}
function randInt(low, high) {
  return low + Math.floor(Math.random() * (high - low + 1));
}
function randFloat(low, high) {
  return low + Math.random() * (high - low);
}
function randFloatSpread(range2) {
  return range2 * (0.5 - Math.random());
}
function seededRandom(s2) {
  if (s2 !== void 0)
    _seed = s2;
  let t2 = _seed += 1831565813;
  t2 = Math.imul(t2 ^ t2 >>> 15, t2 | 1);
  t2 ^= t2 + Math.imul(t2 ^ t2 >>> 7, t2 | 61);
  return ((t2 ^ t2 >>> 14) >>> 0) / 4294967296;
}
function degToRad$1(degrees2) {
  return degrees2 * DEG2RAD$1;
}
function radToDeg$1(radians2) {
  return radians2 * RAD2DEG;
}
function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}
function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function floorPowerOfTwo(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function setQuaternionFromProperEuler(q2, a2, b2, c2, order) {
  const cos2 = Math.cos;
  const sin2 = Math.sin;
  const c22 = cos2(b2 / 2);
  const s2 = sin2(b2 / 2);
  const c13 = cos2((a2 + c2) / 2);
  const s13 = sin2((a2 + c2) / 2);
  const c1_3 = cos2((a2 - c2) / 2);
  const s1_3 = sin2((a2 - c2) / 2);
  const c3_1 = cos2((c2 - a2) / 2);
  const s3_1 = sin2((c2 - a2) / 2);
  switch (order) {
    case "XYX":
      q2.set(c22 * s13, s2 * c1_3, s2 * s1_3, c22 * c13);
      break;
    case "YZY":
      q2.set(s2 * s1_3, c22 * s13, s2 * c1_3, c22 * c13);
      break;
    case "ZXZ":
      q2.set(s2 * c1_3, s2 * s1_3, c22 * s13, c22 * c13);
      break;
    case "XZX":
      q2.set(c22 * s13, s2 * s3_1, s2 * c3_1, c22 * c13);
      break;
    case "YXY":
      q2.set(s2 * c3_1, c22 * s13, s2 * s3_1, c22 * c13);
      break;
    case "ZYZ":
      q2.set(s2 * s3_1, s2 * c3_1, c22 * s13, c22 * c13);
      break;
    default:
      console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + order);
  }
}
function denormalize$1(value, array2) {
  switch (array2.constructor) {
    case Float32Array:
      return value;
    case Uint16Array:
      return value / 65535;
    case Uint8Array:
      return value / 255;
    case Int16Array:
      return Math.max(value / 32767, -1);
    case Int8Array:
      return Math.max(value / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function normalize$6(value, array2) {
  switch (array2.constructor) {
    case Float32Array:
      return value;
    case Uint16Array:
      return Math.round(value * 65535);
    case Uint8Array:
      return Math.round(value * 255);
    case Int16Array:
      return Math.round(value * 32767);
    case Int8Array:
      return Math.round(value * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
var MathUtils = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DEG2RAD: DEG2RAD$1,
  RAD2DEG,
  generateUUID,
  clamp: clamp$5,
  euclideanModulo,
  mapLinear,
  inverseLerp,
  lerp: lerp$6,
  damp,
  pingpong,
  smoothstep,
  smootherstep,
  randInt,
  randFloat,
  randFloatSpread,
  seededRandom,
  degToRad: degToRad$1,
  radToDeg: radToDeg$1,
  isPowerOfTwo,
  ceilPowerOfTwo,
  floorPowerOfTwo,
  setQuaternionFromProperEuler,
  normalize: normalize$6,
  denormalize: denormalize$1
});
let Vector2$1 = class Vector22 {
  constructor(x2 = 0, y2 = 0) {
    this.x = x2;
    this.y = y2;
  }
  get width() {
    return this.x;
  }
  set width(value) {
    this.x = value;
  }
  get height() {
    return this.y;
  }
  set height(value) {
    this.y = value;
  }
  set(x2, y2) {
    this.x = x2;
    this.y = y2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    return this;
  }
  setX(x2) {
    this.x = x2;
    return this;
  }
  setY(y2) {
    this.y = y2;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(v5) {
    this.x = v5.x;
    this.y = v5.y;
    return this;
  }
  add(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v5, w2);
    }
    this.x += v5.x;
    this.y += v5.y;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    return this;
  }
  addVectors(a2, b2) {
    this.x = a2.x + b2.x;
    this.y = a2.y + b2.y;
    return this;
  }
  addScaledVector(v5, s2) {
    this.x += v5.x * s2;
    this.y += v5.y * s2;
    return this;
  }
  sub(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v5, w2);
    }
    this.x -= v5.x;
    this.y -= v5.y;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    return this;
  }
  subVectors(a2, b2) {
    this.x = a2.x - b2.x;
    this.y = a2.y - b2.y;
    return this;
  }
  multiply(v5) {
    this.x *= v5.x;
    this.y *= v5.y;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    return this;
  }
  divide(v5) {
    this.x /= v5.x;
    this.y /= v5.y;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  applyMatrix3(m2) {
    const x2 = this.x, y2 = this.y;
    const e3 = m2.elements;
    this.x = e3[0] * x2 + e3[3] * y2 + e3[6];
    this.y = e3[1] * x2 + e3[4] * y2 + e3[7];
    return this;
  }
  min(v5) {
    this.x = Math.min(this.x, v5.x);
    this.y = Math.min(this.y, v5.y);
    return this;
  }
  max(v5) {
    this.x = Math.max(this.x, v5.x);
    this.y = Math.max(this.y, v5.y);
    return this;
  }
  clamp(min4, max3) {
    this.x = Math.max(min4.x, Math.min(max3.x, this.x));
    this.y = Math.max(min4.y, Math.min(max3.y, this.y));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    return this;
  }
  clampLength(min4, max3) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(Math.max(min4, Math.min(max3, length2)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    return this;
  }
  dot(v5) {
    return this.x * v5.x + this.y * v5.y;
  }
  cross(v5) {
    return this.x * v5.y - this.y * v5.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    const angle4 = Math.atan2(-this.y, -this.x) + Math.PI;
    return angle4;
  }
  distanceTo(v5) {
    return Math.sqrt(this.distanceToSquared(v5));
  }
  distanceToSquared(v5) {
    const dx = this.x - v5.x, dy = this.y - v5.y;
    return dx * dx + dy * dy;
  }
  manhattanDistanceTo(v5) {
    return Math.abs(this.x - v5.x) + Math.abs(this.y - v5.y);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v5, alpha) {
    this.x += (v5.x - this.x) * alpha;
    this.y += (v5.y - this.y) * alpha;
    return this;
  }
  lerpVectors(v12, v22, alpha) {
    this.x = v12.x + (v22.x - v12.x) * alpha;
    this.y = v12.y + (v22.y - v12.y) * alpha;
    return this;
  }
  equals(v5) {
    return v5.x === this.x && v5.y === this.y;
  }
  fromArray(array2, offset = 0) {
    this.x = array2[offset];
    this.y = array2[offset + 1];
    return this;
  }
  toArray(array2 = [], offset = 0) {
    array2[offset] = this.x;
    array2[offset + 1] = this.y;
    return array2;
  }
  fromBufferAttribute(attribute, index2, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    return this;
  }
  rotateAround(center2, angle4) {
    const c2 = Math.cos(angle4), s2 = Math.sin(angle4);
    const x2 = this.x - center2.x;
    const y2 = this.y - center2.y;
    this.x = x2 * c2 - y2 * s2 + center2.x;
    this.y = x2 * s2 + y2 * c2 + center2.y;
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
  }
};
Vector2$1.prototype.isVector2 = true;
let Matrix3$1 = class Matrix32 {
  constructor() {
    this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ];
    if (arguments.length > 0) {
      console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
    }
  }
  set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
    const te = this.elements;
    te[0] = n11;
    te[1] = n21;
    te[2] = n31;
    te[3] = n12;
    te[4] = n22;
    te[5] = n32;
    te[6] = n13;
    te[7] = n23;
    te[8] = n33;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    );
    return this;
  }
  copy(m2) {
    const te = this.elements;
    const me = m2.elements;
    te[0] = me[0];
    te[1] = me[1];
    te[2] = me[2];
    te[3] = me[3];
    te[4] = me[4];
    te[5] = me[5];
    te[6] = me[6];
    te[7] = me[7];
    te[8] = me[8];
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrix3Column(this, 0);
    yAxis.setFromMatrix3Column(this, 1);
    zAxis.setFromMatrix3Column(this, 2);
    return this;
  }
  setFromMatrix4(m2) {
    const me = m2.elements;
    this.set(
      me[0],
      me[4],
      me[8],
      me[1],
      me[5],
      me[9],
      me[2],
      me[6],
      me[10]
    );
    return this;
  }
  multiply(m2) {
    return this.multiplyMatrices(this, m2);
  }
  premultiply(m2) {
    return this.multiplyMatrices(m2, this);
  }
  multiplyMatrices(a2, b2) {
    const ae2 = a2.elements;
    const be2 = b2.elements;
    const te = this.elements;
    const a11 = ae2[0], a12 = ae2[3], a13 = ae2[6];
    const a21 = ae2[1], a22 = ae2[4], a23 = ae2[7];
    const a31 = ae2[2], a32 = ae2[5], a33 = ae2[8];
    const b11 = be2[0], b12 = be2[3], b13 = be2[6];
    const b21 = be2[1], b22 = be2[4], b23 = be2[7];
    const b31 = be2[2], b32 = be2[5], b33 = be2[8];
    te[0] = a11 * b11 + a12 * b21 + a13 * b31;
    te[3] = a11 * b12 + a12 * b22 + a13 * b32;
    te[6] = a11 * b13 + a12 * b23 + a13 * b33;
    te[1] = a21 * b11 + a22 * b21 + a23 * b31;
    te[4] = a21 * b12 + a22 * b22 + a23 * b32;
    te[7] = a21 * b13 + a22 * b23 + a23 * b33;
    te[2] = a31 * b11 + a32 * b21 + a33 * b31;
    te[5] = a31 * b12 + a32 * b22 + a33 * b32;
    te[8] = a31 * b13 + a32 * b23 + a33 * b33;
    return this;
  }
  multiplyScalar(s2) {
    const te = this.elements;
    te[0] *= s2;
    te[3] *= s2;
    te[6] *= s2;
    te[1] *= s2;
    te[4] *= s2;
    te[7] *= s2;
    te[2] *= s2;
    te[5] *= s2;
    te[8] *= s2;
    return this;
  }
  determinant() {
    const te = this.elements;
    const a2 = te[0], b2 = te[1], c2 = te[2], d2 = te[3], e3 = te[4], f2 = te[5], g2 = te[6], h2 = te[7], i2 = te[8];
    return a2 * e3 * i2 - a2 * f2 * h2 - b2 * d2 * i2 + b2 * f2 * g2 + c2 * d2 * h2 - c2 * e3 * g2;
  }
  invert() {
    const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det2 = n11 * t11 + n21 * t12 + n31 * t13;
    if (det2 === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det2;
    te[0] = t11 * detInv;
    te[1] = (n31 * n23 - n33 * n21) * detInv;
    te[2] = (n32 * n21 - n31 * n22) * detInv;
    te[3] = t12 * detInv;
    te[4] = (n33 * n11 - n31 * n13) * detInv;
    te[5] = (n31 * n12 - n32 * n11) * detInv;
    te[6] = t13 * detInv;
    te[7] = (n21 * n13 - n23 * n11) * detInv;
    te[8] = (n22 * n11 - n21 * n12) * detInv;
    return this;
  }
  transpose() {
    let tmp2;
    const m2 = this.elements;
    tmp2 = m2[1];
    m2[1] = m2[3];
    m2[3] = tmp2;
    tmp2 = m2[2];
    m2[2] = m2[6];
    m2[6] = tmp2;
    tmp2 = m2[5];
    m2[5] = m2[7];
    m2[7] = tmp2;
    return this;
  }
  getNormalMatrix(matrix4) {
    return this.setFromMatrix4(matrix4).invert().transpose();
  }
  transposeIntoArray(r2) {
    const m2 = this.elements;
    r2[0] = m2[0];
    r2[1] = m2[3];
    r2[2] = m2[6];
    r2[3] = m2[1];
    r2[4] = m2[4];
    r2[5] = m2[7];
    r2[6] = m2[2];
    r2[7] = m2[5];
    r2[8] = m2[8];
    return this;
  }
  setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
    const c2 = Math.cos(rotation);
    const s2 = Math.sin(rotation);
    this.set(
      sx * c2,
      sx * s2,
      -sx * (c2 * cx + s2 * cy) + cx + tx,
      -sy * s2,
      sy * c2,
      -sy * (-s2 * cx + c2 * cy) + cy + ty,
      0,
      0,
      1
    );
    return this;
  }
  scale(sx, sy) {
    const te = this.elements;
    te[0] *= sx;
    te[3] *= sx;
    te[6] *= sx;
    te[1] *= sy;
    te[4] *= sy;
    te[7] *= sy;
    return this;
  }
  rotate(theta) {
    const c2 = Math.cos(theta);
    const s2 = Math.sin(theta);
    const te = this.elements;
    const a11 = te[0], a12 = te[3], a13 = te[6];
    const a21 = te[1], a22 = te[4], a23 = te[7];
    te[0] = c2 * a11 + s2 * a21;
    te[3] = c2 * a12 + s2 * a22;
    te[6] = c2 * a13 + s2 * a23;
    te[1] = -s2 * a11 + c2 * a21;
    te[4] = -s2 * a12 + c2 * a22;
    te[7] = -s2 * a13 + c2 * a23;
    return this;
  }
  translate(tx, ty) {
    const te = this.elements;
    te[0] += tx * te[2];
    te[3] += tx * te[5];
    te[6] += tx * te[8];
    te[1] += ty * te[2];
    te[4] += ty * te[5];
    te[7] += ty * te[8];
    return this;
  }
  equals(matrix) {
    const te = this.elements;
    const me = matrix.elements;
    for (let i2 = 0; i2 < 9; i2++) {
      if (te[i2] !== me[i2])
        return false;
    }
    return true;
  }
  fromArray(array2, offset = 0) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.elements[i2] = array2[i2 + offset];
    }
    return this;
  }
  toArray(array2 = [], offset = 0) {
    const te = this.elements;
    array2[offset] = te[0];
    array2[offset + 1] = te[1];
    array2[offset + 2] = te[2];
    array2[offset + 3] = te[3];
    array2[offset + 4] = te[4];
    array2[offset + 5] = te[5];
    array2[offset + 6] = te[6];
    array2[offset + 7] = te[7];
    array2[offset + 8] = te[8];
    return array2;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
};
Matrix3$1.prototype.isMatrix3 = true;
function arrayNeedsUint32(array2) {
  for (let i2 = array2.length - 1; i2 >= 0; --i2) {
    if (array2[i2] > 65535)
      return true;
  }
  return false;
}
const TYPED_ARRAYS = {
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array
};
function getTypedArray(type, buffer3) {
  return new TYPED_ARRAYS[type](buffer3);
}
function createElementNS(name2) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", name2);
}
function SRGBToLinear(c2) {
  return c2 < 0.04045 ? c2 * 0.0773993808 : Math.pow(c2 * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c2) {
  return c2 < 31308e-7 ? c2 * 12.92 : 1.055 * Math.pow(c2, 0.41666) - 0.055;
}
const FN = {
  [SRGBColorSpace]: { [LinearSRGBColorSpace]: SRGBToLinear },
  [LinearSRGBColorSpace]: { [SRGBColorSpace]: LinearToSRGB }
};
const ColorManagement = {
  legacyMode: true,
  get workingColorSpace() {
    return LinearSRGBColorSpace;
  },
  set workingColorSpace(colorSpace) {
    console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
  },
  convert: function(color, sourceColorSpace, targetColorSpace) {
    if (this.legacyMode || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
      return color;
    }
    if (FN[sourceColorSpace] && FN[sourceColorSpace][targetColorSpace] !== void 0) {
      const fn2 = FN[sourceColorSpace][targetColorSpace];
      color.r = fn2(color.r);
      color.g = fn2(color.g);
      color.b = fn2(color.b);
      return color;
    }
    throw new Error("Unsupported color space conversion.");
  },
  fromWorkingColorSpace: function(color, targetColorSpace) {
    return this.convert(color, this.workingColorSpace, targetColorSpace);
  },
  toWorkingColorSpace: function(color, sourceColorSpace) {
    return this.convert(color, sourceColorSpace, this.workingColorSpace);
  }
};
const _colorKeywords = {
  "aliceblue": 15792383,
  "antiquewhite": 16444375,
  "aqua": 65535,
  "aquamarine": 8388564,
  "azure": 15794175,
  "beige": 16119260,
  "bisque": 16770244,
  "black": 0,
  "blanchedalmond": 16772045,
  "blue": 255,
  "blueviolet": 9055202,
  "brown": 10824234,
  "burlywood": 14596231,
  "cadetblue": 6266528,
  "chartreuse": 8388352,
  "chocolate": 13789470,
  "coral": 16744272,
  "cornflowerblue": 6591981,
  "cornsilk": 16775388,
  "crimson": 14423100,
  "cyan": 65535,
  "darkblue": 139,
  "darkcyan": 35723,
  "darkgoldenrod": 12092939,
  "darkgray": 11119017,
  "darkgreen": 25600,
  "darkgrey": 11119017,
  "darkkhaki": 12433259,
  "darkmagenta": 9109643,
  "darkolivegreen": 5597999,
  "darkorange": 16747520,
  "darkorchid": 10040012,
  "darkred": 9109504,
  "darksalmon": 15308410,
  "darkseagreen": 9419919,
  "darkslateblue": 4734347,
  "darkslategray": 3100495,
  "darkslategrey": 3100495,
  "darkturquoise": 52945,
  "darkviolet": 9699539,
  "deeppink": 16716947,
  "deepskyblue": 49151,
  "dimgray": 6908265,
  "dimgrey": 6908265,
  "dodgerblue": 2003199,
  "firebrick": 11674146,
  "floralwhite": 16775920,
  "forestgreen": 2263842,
  "fuchsia": 16711935,
  "gainsboro": 14474460,
  "ghostwhite": 16316671,
  "gold": 16766720,
  "goldenrod": 14329120,
  "gray": 8421504,
  "green": 32768,
  "greenyellow": 11403055,
  "grey": 8421504,
  "honeydew": 15794160,
  "hotpink": 16738740,
  "indianred": 13458524,
  "indigo": 4915330,
  "ivory": 16777200,
  "khaki": 15787660,
  "lavender": 15132410,
  "lavenderblush": 16773365,
  "lawngreen": 8190976,
  "lemonchiffon": 16775885,
  "lightblue": 11393254,
  "lightcoral": 15761536,
  "lightcyan": 14745599,
  "lightgoldenrodyellow": 16448210,
  "lightgray": 13882323,
  "lightgreen": 9498256,
  "lightgrey": 13882323,
  "lightpink": 16758465,
  "lightsalmon": 16752762,
  "lightseagreen": 2142890,
  "lightskyblue": 8900346,
  "lightslategray": 7833753,
  "lightslategrey": 7833753,
  "lightsteelblue": 11584734,
  "lightyellow": 16777184,
  "lime": 65280,
  "limegreen": 3329330,
  "linen": 16445670,
  "magenta": 16711935,
  "maroon": 8388608,
  "mediumaquamarine": 6737322,
  "mediumblue": 205,
  "mediumorchid": 12211667,
  "mediumpurple": 9662683,
  "mediumseagreen": 3978097,
  "mediumslateblue": 8087790,
  "mediumspringgreen": 64154,
  "mediumturquoise": 4772300,
  "mediumvioletred": 13047173,
  "midnightblue": 1644912,
  "mintcream": 16121850,
  "mistyrose": 16770273,
  "moccasin": 16770229,
  "navajowhite": 16768685,
  "navy": 128,
  "oldlace": 16643558,
  "olive": 8421376,
  "olivedrab": 7048739,
  "orange": 16753920,
  "orangered": 16729344,
  "orchid": 14315734,
  "palegoldenrod": 15657130,
  "palegreen": 10025880,
  "paleturquoise": 11529966,
  "palevioletred": 14381203,
  "papayawhip": 16773077,
  "peachpuff": 16767673,
  "peru": 13468991,
  "pink": 16761035,
  "plum": 14524637,
  "powderblue": 11591910,
  "purple": 8388736,
  "rebeccapurple": 6697881,
  "red": 16711680,
  "rosybrown": 12357519,
  "royalblue": 4286945,
  "saddlebrown": 9127187,
  "salmon": 16416882,
  "sandybrown": 16032864,
  "seagreen": 3050327,
  "seashell": 16774638,
  "sienna": 10506797,
  "silver": 12632256,
  "skyblue": 8900331,
  "slateblue": 6970061,
  "slategray": 7372944,
  "slategrey": 7372944,
  "snow": 16775930,
  "springgreen": 65407,
  "steelblue": 4620980,
  "tan": 13808780,
  "teal": 32896,
  "thistle": 14204888,
  "tomato": 16737095,
  "turquoise": 4251856,
  "violet": 15631086,
  "wheat": 16113331,
  "white": 16777215,
  "whitesmoke": 16119285,
  "yellow": 16776960,
  "yellowgreen": 10145074
};
const _rgb = { r: 0, g: 0, b: 0 };
const _hslA = { h: 0, s: 0, l: 0 };
const _hslB = { h: 0, s: 0, l: 0 };
function hue2rgb(p2, q2, t2) {
  if (t2 < 0)
    t2 += 1;
  if (t2 > 1)
    t2 -= 1;
  if (t2 < 1 / 6)
    return p2 + (q2 - p2) * 6 * t2;
  if (t2 < 1 / 2)
    return q2;
  if (t2 < 2 / 3)
    return p2 + (q2 - p2) * 6 * (2 / 3 - t2);
  return p2;
}
function toComponents(source, target) {
  target.r = source.r;
  target.g = source.g;
  target.b = source.b;
  return target;
}
class Color {
  constructor(r2, g2, b2) {
    if (g2 === void 0 && b2 === void 0) {
      return this.set(r2);
    }
    return this.setRGB(r2, g2, b2);
  }
  set(value) {
    if (value && value.isColor) {
      this.copy(value);
    } else if (typeof value === "number") {
      this.setHex(value);
    } else if (typeof value === "string") {
      this.setStyle(value);
    }
    return this;
  }
  setScalar(scalar) {
    this.r = scalar;
    this.g = scalar;
    this.b = scalar;
    return this;
  }
  setHex(hex, colorSpace = SRGBColorSpace) {
    hex = Math.floor(hex);
    this.r = (hex >> 16 & 255) / 255;
    this.g = (hex >> 8 & 255) / 255;
    this.b = (hex & 255) / 255;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setRGB(r2, g2, b2, colorSpace = LinearSRGBColorSpace) {
    this.r = r2;
    this.g = g2;
    this.b = b2;
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setHSL(h2, s2, l2, colorSpace = LinearSRGBColorSpace) {
    h2 = euclideanModulo(h2, 1);
    s2 = clamp$5(s2, 0, 1);
    l2 = clamp$5(l2, 0, 1);
    if (s2 === 0) {
      this.r = this.g = this.b = l2;
    } else {
      const p2 = l2 <= 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
      const q2 = 2 * l2 - p2;
      this.r = hue2rgb(q2, p2, h2 + 1 / 3);
      this.g = hue2rgb(q2, p2, h2);
      this.b = hue2rgb(q2, p2, h2 - 1 / 3);
    }
    ColorManagement.toWorkingColorSpace(this, colorSpace);
    return this;
  }
  setStyle(style2, colorSpace = SRGBColorSpace) {
    function handleAlpha(string3) {
      if (string3 === void 0)
        return;
      if (parseFloat(string3) < 1) {
        console.warn("THREE.Color: Alpha component of " + style2 + " will be ignored.");
      }
    }
    let m2;
    if (m2 = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style2)) {
      let color;
      const name2 = m2[1];
      const components = m2[2];
      switch (name2) {
        case "rgb":
        case "rgba":
          if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            this.r = Math.min(255, parseInt(color[1], 10)) / 255;
            this.g = Math.min(255, parseInt(color[2], 10)) / 255;
            this.b = Math.min(255, parseInt(color[3], 10)) / 255;
            ColorManagement.toWorkingColorSpace(this, colorSpace);
            handleAlpha(color[4]);
            return this;
          }
          if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            this.r = Math.min(100, parseInt(color[1], 10)) / 100;
            this.g = Math.min(100, parseInt(color[2], 10)) / 100;
            this.b = Math.min(100, parseInt(color[3], 10)) / 100;
            ColorManagement.toWorkingColorSpace(this, colorSpace);
            handleAlpha(color[4]);
            return this;
          }
          break;
        case "hsl":
        case "hsla":
          if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
            const h2 = parseFloat(color[1]) / 360;
            const s2 = parseInt(color[2], 10) / 100;
            const l2 = parseInt(color[3], 10) / 100;
            handleAlpha(color[4]);
            return this.setHSL(h2, s2, l2, colorSpace);
          }
          break;
      }
    } else if (m2 = /^\#([A-Fa-f\d]+)$/.exec(style2)) {
      const hex = m2[1];
      const size12 = hex.length;
      if (size12 === 3) {
        this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
        this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
        this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
        ColorManagement.toWorkingColorSpace(this, colorSpace);
        return this;
      } else if (size12 === 6) {
        this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
        this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
        this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
        ColorManagement.toWorkingColorSpace(this, colorSpace);
        return this;
      }
    }
    if (style2 && style2.length > 0) {
      return this.setColorName(style2, colorSpace);
    }
    return this;
  }
  setColorName(style2, colorSpace = SRGBColorSpace) {
    const hex = _colorKeywords[style2.toLowerCase()];
    if (hex !== void 0) {
      this.setHex(hex, colorSpace);
    } else {
      console.warn("THREE.Color: Unknown color " + style2);
    }
    return this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(color) {
    this.r = color.r;
    this.g = color.g;
    this.b = color.b;
    return this;
  }
  copySRGBToLinear(color) {
    this.r = SRGBToLinear(color.r);
    this.g = SRGBToLinear(color.g);
    this.b = SRGBToLinear(color.b);
    return this;
  }
  copyLinearToSRGB(color) {
    this.r = LinearToSRGB(color.r);
    this.g = LinearToSRGB(color.g);
    this.b = LinearToSRGB(color.b);
    return this;
  }
  convertSRGBToLinear() {
    this.copySRGBToLinear(this);
    return this;
  }
  convertLinearToSRGB() {
    this.copyLinearToSRGB(this);
    return this;
  }
  getHex(colorSpace = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);
    return clamp$5(_rgb.r * 255, 0, 255) << 16 ^ clamp$5(_rgb.g * 255, 0, 255) << 8 ^ clamp$5(_rgb.b * 255, 0, 255) << 0;
  }
  getHexString(colorSpace = SRGBColorSpace) {
    return ("000000" + this.getHex(colorSpace).toString(16)).slice(-6);
  }
  getHSL(target, colorSpace = LinearSRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);
    const r2 = _rgb.r, g2 = _rgb.g, b2 = _rgb.b;
    const max3 = Math.max(r2, g2, b2);
    const min4 = Math.min(r2, g2, b2);
    let hue, saturation;
    const lightness = (min4 + max3) / 2;
    if (min4 === max3) {
      hue = 0;
      saturation = 0;
    } else {
      const delta = max3 - min4;
      saturation = lightness <= 0.5 ? delta / (max3 + min4) : delta / (2 - max3 - min4);
      switch (max3) {
        case r2:
          hue = (g2 - b2) / delta + (g2 < b2 ? 6 : 0);
          break;
        case g2:
          hue = (b2 - r2) / delta + 2;
          break;
        case b2:
          hue = (r2 - g2) / delta + 4;
          break;
      }
      hue /= 6;
    }
    target.h = hue;
    target.s = saturation;
    target.l = lightness;
    return target;
  }
  getRGB(target, colorSpace = LinearSRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);
    target.r = _rgb.r;
    target.g = _rgb.g;
    target.b = _rgb.b;
    return target;
  }
  getStyle(colorSpace = SRGBColorSpace) {
    ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);
    if (colorSpace !== SRGBColorSpace) {
      return `color(${colorSpace} ${_rgb.r} ${_rgb.g} ${_rgb.b})`;
    }
    return `rgb(${_rgb.r * 255 | 0},${_rgb.g * 255 | 0},${_rgb.b * 255 | 0})`;
  }
  offsetHSL(h2, s2, l2) {
    this.getHSL(_hslA);
    _hslA.h += h2;
    _hslA.s += s2;
    _hslA.l += l2;
    this.setHSL(_hslA.h, _hslA.s, _hslA.l);
    return this;
  }
  add(color) {
    this.r += color.r;
    this.g += color.g;
    this.b += color.b;
    return this;
  }
  addColors(color1, color2) {
    this.r = color1.r + color2.r;
    this.g = color1.g + color2.g;
    this.b = color1.b + color2.b;
    return this;
  }
  addScalar(s2) {
    this.r += s2;
    this.g += s2;
    this.b += s2;
    return this;
  }
  sub(color) {
    this.r = Math.max(0, this.r - color.r);
    this.g = Math.max(0, this.g - color.g);
    this.b = Math.max(0, this.b - color.b);
    return this;
  }
  multiply(color) {
    this.r *= color.r;
    this.g *= color.g;
    this.b *= color.b;
    return this;
  }
  multiplyScalar(s2) {
    this.r *= s2;
    this.g *= s2;
    this.b *= s2;
    return this;
  }
  lerp(color, alpha) {
    this.r += (color.r - this.r) * alpha;
    this.g += (color.g - this.g) * alpha;
    this.b += (color.b - this.b) * alpha;
    return this;
  }
  lerpColors(color1, color2, alpha) {
    this.r = color1.r + (color2.r - color1.r) * alpha;
    this.g = color1.g + (color2.g - color1.g) * alpha;
    this.b = color1.b + (color2.b - color1.b) * alpha;
    return this;
  }
  lerpHSL(color, alpha) {
    this.getHSL(_hslA);
    color.getHSL(_hslB);
    const h2 = lerp$6(_hslA.h, _hslB.h, alpha);
    const s2 = lerp$6(_hslA.s, _hslB.s, alpha);
    const l2 = lerp$6(_hslA.l, _hslB.l, alpha);
    this.setHSL(h2, s2, l2);
    return this;
  }
  equals(c2) {
    return c2.r === this.r && c2.g === this.g && c2.b === this.b;
  }
  fromArray(array2, offset = 0) {
    this.r = array2[offset];
    this.g = array2[offset + 1];
    this.b = array2[offset + 2];
    return this;
  }
  toArray(array2 = [], offset = 0) {
    array2[offset] = this.r;
    array2[offset + 1] = this.g;
    array2[offset + 2] = this.b;
    return array2;
  }
  fromBufferAttribute(attribute, index2) {
    this.r = attribute.getX(index2);
    this.g = attribute.getY(index2);
    this.b = attribute.getZ(index2);
    if (attribute.normalized === true) {
      this.r /= 255;
      this.g /= 255;
      this.b /= 255;
    }
    return this;
  }
  toJSON() {
    return this.getHex();
  }
}
Color.NAMES = _colorKeywords;
Color.prototype.isColor = true;
Color.prototype.r = 1;
Color.prototype.g = 1;
Color.prototype.b = 1;
let _canvas;
class ImageUtils {
  static getDataURL(image) {
    if (/^data:/i.test(image.src)) {
      return image.src;
    }
    if (typeof HTMLCanvasElement == "undefined") {
      return image.src;
    }
    let canvas2;
    if (image instanceof HTMLCanvasElement) {
      canvas2 = image;
    } else {
      if (_canvas === void 0)
        _canvas = createElementNS("canvas");
      _canvas.width = image.width;
      _canvas.height = image.height;
      const context2 = _canvas.getContext("2d");
      if (image instanceof ImageData) {
        context2.putImageData(image, 0, 0);
      } else {
        context2.drawImage(image, 0, 0, image.width, image.height);
      }
      canvas2 = _canvas;
    }
    if (canvas2.width > 2048 || canvas2.height > 2048) {
      console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", image);
      return canvas2.toDataURL("image/jpeg", 0.6);
    } else {
      return canvas2.toDataURL("image/png");
    }
  }
  static sRGBToLinear(image) {
    if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
      const canvas2 = createElementNS("canvas");
      canvas2.width = image.width;
      canvas2.height = image.height;
      const context2 = canvas2.getContext("2d");
      context2.drawImage(image, 0, 0, image.width, image.height);
      const imageData = context2.getImageData(0, 0, image.width, image.height);
      const data2 = imageData.data;
      for (let i2 = 0; i2 < data2.length; i2++) {
        data2[i2] = SRGBToLinear(data2[i2] / 255) * 255;
      }
      context2.putImageData(imageData, 0, 0);
      return canvas2;
    } else if (image.data) {
      const data2 = image.data.slice(0);
      for (let i2 = 0; i2 < data2.length; i2++) {
        if (data2 instanceof Uint8Array || data2 instanceof Uint8ClampedArray) {
          data2[i2] = Math.floor(SRGBToLinear(data2[i2] / 255) * 255);
        } else {
          data2[i2] = SRGBToLinear(data2[i2]);
        }
      }
      return {
        data: data2,
        width: image.width,
        height: image.height
      };
    } else {
      console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.");
      return image;
    }
  }
}
class Source {
  constructor(data2 = null) {
    this.uuid = generateUUID();
    this.data = data2;
    this.version = 0;
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
  toJSON(meta2) {
    const isRootObject = meta2 === void 0 || typeof meta2 === "string";
    if (!isRootObject && meta2.images[this.uuid] !== void 0) {
      return meta2.images[this.uuid];
    }
    const output2 = {
      uuid: this.uuid,
      url: ""
    };
    const data2 = this.data;
    if (data2 !== null) {
      let url2;
      if (Array.isArray(data2)) {
        url2 = [];
        for (let i2 = 0, l2 = data2.length; i2 < l2; i2++) {
          if (data2[i2].isDataTexture) {
            url2.push(serializeImage(data2[i2].image));
          } else {
            url2.push(serializeImage(data2[i2]));
          }
        }
      } else {
        url2 = serializeImage(data2);
      }
      output2.url = url2;
    }
    if (!isRootObject) {
      meta2.images[this.uuid] = output2;
    }
    return output2;
  }
}
function serializeImage(image) {
  if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return ImageUtils.getDataURL(image);
  } else {
    if (image.data) {
      return {
        data: Array.prototype.slice.call(image.data),
        width: image.width,
        height: image.height,
        type: image.data.constructor.name
      };
    } else {
      console.warn("THREE.Texture: Unable to serialize Texture.");
      return {};
    }
  }
}
Source.prototype.isSource = true;
let textureId = 0;
let Texture$1 = class Texture2 extends EventDispatcher$1 {
  constructor(image = Texture2.DEFAULT_IMAGE, mapping = Texture2.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = 1, encoding = LinearEncoding) {
    super();
    Object.defineProperty(this, "id", { value: textureId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.source = new Source(image);
    this.mipmaps = [];
    this.mapping = mapping;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2$1(0, 0);
    this.repeat = new Vector2$1(1, 1);
    this.center = new Vector2$1(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3$1();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4;
    this.encoding = encoding;
    this.userData = {};
    this.version = 0;
    this.onUpdate = null;
    this.isRenderTargetTexture = false;
    this.needsPMREMUpdate = false;
  }
  get image() {
    return this.source.data;
  }
  set image(value) {
    this.source.data = value;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.source = source.source;
    this.mipmaps = source.mipmaps.slice(0);
    this.mapping = source.mapping;
    this.wrapS = source.wrapS;
    this.wrapT = source.wrapT;
    this.magFilter = source.magFilter;
    this.minFilter = source.minFilter;
    this.anisotropy = source.anisotropy;
    this.format = source.format;
    this.internalFormat = source.internalFormat;
    this.type = source.type;
    this.offset.copy(source.offset);
    this.repeat.copy(source.repeat);
    this.center.copy(source.center);
    this.rotation = source.rotation;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrix.copy(source.matrix);
    this.generateMipmaps = source.generateMipmaps;
    this.premultiplyAlpha = source.premultiplyAlpha;
    this.flipY = source.flipY;
    this.unpackAlignment = source.unpackAlignment;
    this.encoding = source.encoding;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    this.needsUpdate = true;
    return this;
  }
  toJSON(meta2) {
    const isRootObject = meta2 === void 0 || typeof meta2 === "string";
    if (!isRootObject && meta2.textures[this.uuid] !== void 0) {
      return meta2.textures[this.uuid];
    }
    const output2 = {
      metadata: {
        version: 4.5,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(meta2).uuid,
      mapping: this.mapping,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      type: this.type,
      encoding: this.encoding,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    if (JSON.stringify(this.userData) !== "{}")
      output2.userData = this.userData;
    if (!isRootObject) {
      meta2.textures[this.uuid] = output2;
    }
    return output2;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(uv) {
    if (this.mapping !== UVMapping)
      return uv;
    uv.applyMatrix3(this.matrix);
    if (uv.x < 0 || uv.x > 1) {
      switch (this.wrapS) {
        case RepeatWrapping:
          uv.x = uv.x - Math.floor(uv.x);
          break;
        case ClampToEdgeWrapping:
          uv.x = uv.x < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.x) % 2) === 1) {
            uv.x = Math.ceil(uv.x) - uv.x;
          } else {
            uv.x = uv.x - Math.floor(uv.x);
          }
          break;
      }
    }
    if (uv.y < 0 || uv.y > 1) {
      switch (this.wrapT) {
        case RepeatWrapping:
          uv.y = uv.y - Math.floor(uv.y);
          break;
        case ClampToEdgeWrapping:
          uv.y = uv.y < 0 ? 0 : 1;
          break;
        case MirroredRepeatWrapping:
          if (Math.abs(Math.floor(uv.y) % 2) === 1) {
            uv.y = Math.ceil(uv.y) - uv.y;
          } else {
            uv.y = uv.y - Math.floor(uv.y);
          }
          break;
      }
    }
    if (this.flipY) {
      uv.y = 1 - uv.y;
    }
    return uv;
  }
  set needsUpdate(value) {
    if (value === true) {
      this.version++;
      this.source.needsUpdate = true;
    }
  }
};
Texture$1.DEFAULT_IMAGE = null;
Texture$1.DEFAULT_MAPPING = UVMapping;
Texture$1.prototype.isTexture = true;
let Vector4$1 = class Vector42 {
  constructor(x2 = 0, y2 = 0, z2 = 0, w2 = 1) {
    this.x = x2;
    this.y = y2;
    this.z = z2;
    this.w = w2;
  }
  get width() {
    return this.z;
  }
  set width(value) {
    this.z = value;
  }
  get height() {
    return this.w;
  }
  set height(value) {
    this.w = value;
  }
  set(x2, y2, z2, w2) {
    this.x = x2;
    this.y = y2;
    this.z = z2;
    this.w = w2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    this.w = scalar;
    return this;
  }
  setX(x2) {
    this.x = x2;
    return this;
  }
  setY(y2) {
    this.y = y2;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setW(w2) {
    this.w = w2;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      case 3:
        this.w = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(v5) {
    this.x = v5.x;
    this.y = v5.y;
    this.z = v5.z;
    this.w = v5.w !== void 0 ? v5.w : 1;
    return this;
  }
  add(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v5, w2);
    }
    this.x += v5.x;
    this.y += v5.y;
    this.z += v5.z;
    this.w += v5.w;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    this.w += s2;
    return this;
  }
  addVectors(a2, b2) {
    this.x = a2.x + b2.x;
    this.y = a2.y + b2.y;
    this.z = a2.z + b2.z;
    this.w = a2.w + b2.w;
    return this;
  }
  addScaledVector(v5, s2) {
    this.x += v5.x * s2;
    this.y += v5.y * s2;
    this.z += v5.z * s2;
    this.w += v5.w * s2;
    return this;
  }
  sub(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v5, w2);
    }
    this.x -= v5.x;
    this.y -= v5.y;
    this.z -= v5.z;
    this.w -= v5.w;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    this.w -= s2;
    return this;
  }
  subVectors(a2, b2) {
    this.x = a2.x - b2.x;
    this.y = a2.y - b2.y;
    this.z = a2.z - b2.z;
    this.w = a2.w - b2.w;
    return this;
  }
  multiply(v5) {
    this.x *= v5.x;
    this.y *= v5.y;
    this.z *= v5.z;
    this.w *= v5.w;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    this.w *= scalar;
    return this;
  }
  applyMatrix4(m2) {
    const x2 = this.x, y2 = this.y, z2 = this.z, w2 = this.w;
    const e3 = m2.elements;
    this.x = e3[0] * x2 + e3[4] * y2 + e3[8] * z2 + e3[12] * w2;
    this.y = e3[1] * x2 + e3[5] * y2 + e3[9] * z2 + e3[13] * w2;
    this.z = e3[2] * x2 + e3[6] * y2 + e3[10] * z2 + e3[14] * w2;
    this.w = e3[3] * x2 + e3[7] * y2 + e3[11] * z2 + e3[15] * w2;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  setAxisAngleFromQuaternion(q2) {
    this.w = 2 * Math.acos(q2.w);
    const s2 = Math.sqrt(1 - q2.w * q2.w);
    if (s2 < 1e-4) {
      this.x = 1;
      this.y = 0;
      this.z = 0;
    } else {
      this.x = q2.x / s2;
      this.y = q2.y / s2;
      this.z = q2.z / s2;
    }
    return this;
  }
  setAxisAngleFromRotationMatrix(m2) {
    let angle4, x2, y2, z2;
    const epsilon2 = 0.01, epsilon22 = 0.1, te = m2.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
    if (Math.abs(m12 - m21) < epsilon2 && Math.abs(m13 - m31) < epsilon2 && Math.abs(m23 - m32) < epsilon2) {
      if (Math.abs(m12 + m21) < epsilon22 && Math.abs(m13 + m31) < epsilon22 && Math.abs(m23 + m32) < epsilon22 && Math.abs(m11 + m22 + m33 - 3) < epsilon22) {
        this.set(1, 0, 0, 0);
        return this;
      }
      angle4 = Math.PI;
      const xx = (m11 + 1) / 2;
      const yy = (m22 + 1) / 2;
      const zz = (m33 + 1) / 2;
      const xy = (m12 + m21) / 4;
      const xz = (m13 + m31) / 4;
      const yz = (m23 + m32) / 4;
      if (xx > yy && xx > zz) {
        if (xx < epsilon2) {
          x2 = 0;
          y2 = 0.707106781;
          z2 = 0.707106781;
        } else {
          x2 = Math.sqrt(xx);
          y2 = xy / x2;
          z2 = xz / x2;
        }
      } else if (yy > zz) {
        if (yy < epsilon2) {
          x2 = 0.707106781;
          y2 = 0;
          z2 = 0.707106781;
        } else {
          y2 = Math.sqrt(yy);
          x2 = xy / y2;
          z2 = yz / y2;
        }
      } else {
        if (zz < epsilon2) {
          x2 = 0.707106781;
          y2 = 0.707106781;
          z2 = 0;
        } else {
          z2 = Math.sqrt(zz);
          x2 = xz / z2;
          y2 = yz / z2;
        }
      }
      this.set(x2, y2, z2, angle4);
      return this;
    }
    let s2 = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12));
    if (Math.abs(s2) < 1e-3)
      s2 = 1;
    this.x = (m32 - m23) / s2;
    this.y = (m13 - m31) / s2;
    this.z = (m21 - m12) / s2;
    this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
    return this;
  }
  min(v5) {
    this.x = Math.min(this.x, v5.x);
    this.y = Math.min(this.y, v5.y);
    this.z = Math.min(this.z, v5.z);
    this.w = Math.min(this.w, v5.w);
    return this;
  }
  max(v5) {
    this.x = Math.max(this.x, v5.x);
    this.y = Math.max(this.y, v5.y);
    this.z = Math.max(this.z, v5.z);
    this.w = Math.max(this.w, v5.w);
    return this;
  }
  clamp(min4, max3) {
    this.x = Math.max(min4.x, Math.min(max3.x, this.x));
    this.y = Math.max(min4.y, Math.min(max3.y, this.y));
    this.z = Math.max(min4.z, Math.min(max3.z, this.z));
    this.w = Math.max(min4.w, Math.min(max3.w, this.w));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    this.z = Math.max(minVal, Math.min(maxVal, this.z));
    this.w = Math.max(minVal, Math.min(maxVal, this.w));
    return this;
  }
  clampLength(min4, max3) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(Math.max(min4, Math.min(max3, length2)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    this.w = Math.floor(this.w);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    this.w = Math.ceil(this.w);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    this.w = Math.round(this.w);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
    this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    this.w = -this.w;
    return this;
  }
  dot(v5) {
    return this.x * v5.x + this.y * v5.y + this.z * v5.z + this.w * v5.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v5, alpha) {
    this.x += (v5.x - this.x) * alpha;
    this.y += (v5.y - this.y) * alpha;
    this.z += (v5.z - this.z) * alpha;
    this.w += (v5.w - this.w) * alpha;
    return this;
  }
  lerpVectors(v12, v22, alpha) {
    this.x = v12.x + (v22.x - v12.x) * alpha;
    this.y = v12.y + (v22.y - v12.y) * alpha;
    this.z = v12.z + (v22.z - v12.z) * alpha;
    this.w = v12.w + (v22.w - v12.w) * alpha;
    return this;
  }
  equals(v5) {
    return v5.x === this.x && v5.y === this.y && v5.z === this.z && v5.w === this.w;
  }
  fromArray(array2, offset = 0) {
    this.x = array2[offset];
    this.y = array2[offset + 1];
    this.z = array2[offset + 2];
    this.w = array2[offset + 3];
    return this;
  }
  toArray(array2 = [], offset = 0) {
    array2[offset] = this.x;
    array2[offset + 1] = this.y;
    array2[offset + 2] = this.z;
    array2[offset + 3] = this.w;
    return array2;
  }
  fromBufferAttribute(attribute, index2, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    this.z = attribute.getZ(index2);
    this.w = attribute.getW(index2);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    this.w = Math.random();
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
    yield this.w;
  }
};
Vector4$1.prototype.isVector4 = true;
class WebGLRenderTarget extends EventDispatcher$1 {
  constructor(width, height, options2 = {}) {
    super();
    this.width = width;
    this.height = height;
    this.depth = 1;
    this.scissor = new Vector4$1(0, 0, width, height);
    this.scissorTest = false;
    this.viewport = new Vector4$1(0, 0, width, height);
    const image = { width, height, depth: 1 };
    this.texture = new Texture$1(image, options2.mapping, options2.wrapS, options2.wrapT, options2.magFilter, options2.minFilter, options2.format, options2.type, options2.anisotropy, options2.encoding);
    this.texture.isRenderTargetTexture = true;
    this.texture.flipY = false;
    this.texture.generateMipmaps = options2.generateMipmaps !== void 0 ? options2.generateMipmaps : false;
    this.texture.internalFormat = options2.internalFormat !== void 0 ? options2.internalFormat : null;
    this.texture.minFilter = options2.minFilter !== void 0 ? options2.minFilter : LinearFilter;
    this.depthBuffer = options2.depthBuffer !== void 0 ? options2.depthBuffer : true;
    this.stencilBuffer = options2.stencilBuffer !== void 0 ? options2.stencilBuffer : false;
    this.depthTexture = options2.depthTexture !== void 0 ? options2.depthTexture : null;
    this.samples = options2.samples !== void 0 ? options2.samples : 0;
  }
  setSize(width, height, depth2 = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth2) {
      this.width = width;
      this.height = height;
      this.depth = depth2;
      this.texture.image.width = width;
      this.texture.image.height = height;
      this.texture.image.depth = depth2;
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.viewport.copy(source.viewport);
    this.texture = source.texture.clone();
    this.texture.isRenderTargetTexture = true;
    this.texture.image = Object.assign({}, source.texture.image);
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    if (source.depthTexture !== null)
      this.depthTexture = source.depthTexture.clone();
    this.samples = source.samples;
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
WebGLRenderTarget.prototype.isWebGLRenderTarget = true;
class DataArrayTexture extends Texture$1 {
  constructor(data2 = null, width = 1, height = 1, depth2 = 1) {
    super(null);
    this.image = { data: data2, width, height, depth: depth2 };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
}
DataArrayTexture.prototype.isDataArrayTexture = true;
class WebGLArrayRenderTarget extends WebGLRenderTarget {
  constructor(width, height, depth2) {
    super(width, height);
    this.depth = depth2;
    this.texture = new DataArrayTexture(null, width, height, depth2);
    this.texture.isRenderTargetTexture = true;
  }
}
WebGLArrayRenderTarget.prototype.isWebGLArrayRenderTarget = true;
class Data3DTexture extends Texture$1 {
  constructor(data2 = null, width = 1, height = 1, depth2 = 1) {
    super(null);
    this.image = { data: data2, width, height, depth: depth2 };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
}
Data3DTexture.prototype.isData3DTexture = true;
class WebGL3DRenderTarget extends WebGLRenderTarget {
  constructor(width, height, depth2) {
    super(width, height);
    this.depth = depth2;
    this.texture = new Data3DTexture(null, width, height, depth2);
    this.texture.isRenderTargetTexture = true;
  }
}
WebGL3DRenderTarget.prototype.isWebGL3DRenderTarget = true;
class WebGLMultipleRenderTargets extends WebGLRenderTarget {
  constructor(width, height, count3, options2 = {}) {
    super(width, height, options2);
    const texture = this.texture;
    this.texture = [];
    for (let i2 = 0; i2 < count3; i2++) {
      this.texture[i2] = texture.clone();
      this.texture[i2].isRenderTargetTexture = true;
    }
  }
  setSize(width, height, depth2 = 1) {
    if (this.width !== width || this.height !== height || this.depth !== depth2) {
      this.width = width;
      this.height = height;
      this.depth = depth2;
      for (let i2 = 0, il = this.texture.length; i2 < il; i2++) {
        this.texture[i2].image.width = width;
        this.texture[i2].image.height = height;
        this.texture[i2].image.depth = depth2;
      }
      this.dispose();
    }
    this.viewport.set(0, 0, width, height);
    this.scissor.set(0, 0, width, height);
    return this;
  }
  copy(source) {
    this.dispose();
    this.width = source.width;
    this.height = source.height;
    this.depth = source.depth;
    this.viewport.set(0, 0, this.width, this.height);
    this.scissor.set(0, 0, this.width, this.height);
    this.depthBuffer = source.depthBuffer;
    this.stencilBuffer = source.stencilBuffer;
    this.depthTexture = source.depthTexture;
    this.texture.length = 0;
    for (let i2 = 0, il = source.texture.length; i2 < il; i2++) {
      this.texture[i2] = source.texture[i2].clone();
    }
    return this;
  }
}
WebGLMultipleRenderTargets.prototype.isWebGLMultipleRenderTargets = true;
let Quaternion$1 = class Quaternion2 {
  constructor(x2 = 0, y2 = 0, z2 = 0, w2 = 1) {
    this._x = x2;
    this._y = y2;
    this._z = z2;
    this._w = w2;
  }
  static slerp(qa, qb, qm, t2) {
    console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.");
    return qm.slerpQuaternions(qa, qb, t2);
  }
  static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t2) {
    let x02 = src0[srcOffset0 + 0], y02 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
    const x12 = src1[srcOffset1 + 0], y12 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
    if (t2 === 0) {
      dst[dstOffset + 0] = x02;
      dst[dstOffset + 1] = y02;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
      return;
    }
    if (t2 === 1) {
      dst[dstOffset + 0] = x12;
      dst[dstOffset + 1] = y12;
      dst[dstOffset + 2] = z1;
      dst[dstOffset + 3] = w1;
      return;
    }
    if (w0 !== w1 || x02 !== x12 || y02 !== y12 || z0 !== z1) {
      let s2 = 1 - t2;
      const cos2 = x02 * x12 + y02 * y12 + z0 * z1 + w0 * w1, dir = cos2 >= 0 ? 1 : -1, sqrSin = 1 - cos2 * cos2;
      if (sqrSin > Number.EPSILON) {
        const sin2 = Math.sqrt(sqrSin), len2 = Math.atan2(sin2, cos2 * dir);
        s2 = Math.sin(s2 * len2) / sin2;
        t2 = Math.sin(t2 * len2) / sin2;
      }
      const tDir = t2 * dir;
      x02 = x02 * s2 + x12 * tDir;
      y02 = y02 * s2 + y12 * tDir;
      z0 = z0 * s2 + z1 * tDir;
      w0 = w0 * s2 + w1 * tDir;
      if (s2 === 1 - t2) {
        const f2 = 1 / Math.sqrt(x02 * x02 + y02 * y02 + z0 * z0 + w0 * w0);
        x02 *= f2;
        y02 *= f2;
        z0 *= f2;
        w0 *= f2;
      }
    }
    dst[dstOffset] = x02;
    dst[dstOffset + 1] = y02;
    dst[dstOffset + 2] = z0;
    dst[dstOffset + 3] = w0;
  }
  static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
    const x02 = src0[srcOffset0];
    const y02 = src0[srcOffset0 + 1];
    const z0 = src0[srcOffset0 + 2];
    const w0 = src0[srcOffset0 + 3];
    const x12 = src1[srcOffset1];
    const y12 = src1[srcOffset1 + 1];
    const z1 = src1[srcOffset1 + 2];
    const w1 = src1[srcOffset1 + 3];
    dst[dstOffset] = x02 * w1 + w0 * x12 + y02 * z1 - z0 * y12;
    dst[dstOffset + 1] = y02 * w1 + w0 * y12 + z0 * x12 - x02 * z1;
    dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x02 * y12 - y02 * x12;
    dst[dstOffset + 3] = w0 * w1 - x02 * x12 - y02 * y12 - z0 * z1;
    return dst;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(value) {
    this._w = value;
    this._onChangeCallback();
  }
  set(x2, y2, z2, w2) {
    this._x = x2;
    this._y = y2;
    this._z = z2;
    this._w = w2;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(quaternion2) {
    this._x = quaternion2.x;
    this._y = quaternion2.y;
    this._z = quaternion2.z;
    this._w = quaternion2.w;
    this._onChangeCallback();
    return this;
  }
  setFromEuler(euler, update) {
    if (!(euler && euler.isEuler)) {
      throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
    }
    const x2 = euler._x, y2 = euler._y, z2 = euler._z, order = euler._order;
    const cos2 = Math.cos;
    const sin2 = Math.sin;
    const c1 = cos2(x2 / 2);
    const c2 = cos2(y2 / 2);
    const c3 = cos2(z2 / 2);
    const s1 = sin2(x2 / 2);
    const s2 = sin2(y2 / 2);
    const s3 = sin2(z2 / 2);
    switch (order) {
      case "XYZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "YXZ":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "ZXY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "ZYX":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      case "YZX":
        this._x = s1 * c2 * c3 + c1 * s2 * s3;
        this._y = c1 * s2 * c3 + s1 * c2 * s3;
        this._z = c1 * c2 * s3 - s1 * s2 * c3;
        this._w = c1 * c2 * c3 - s1 * s2 * s3;
        break;
      case "XZY":
        this._x = s1 * c2 * c3 - c1 * s2 * s3;
        this._y = c1 * s2 * c3 - s1 * c2 * s3;
        this._z = c1 * c2 * s3 + s1 * s2 * c3;
        this._w = c1 * c2 * c3 + s1 * s2 * s3;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + order);
    }
    if (update !== false)
      this._onChangeCallback();
    return this;
  }
  setFromAxisAngle(axis, angle4) {
    const halfAngle = angle4 / 2, s2 = Math.sin(halfAngle);
    this._x = axis.x * s2;
    this._y = axis.y * s2;
    this._z = axis.z * s2;
    this._w = Math.cos(halfAngle);
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m2) {
    const te = m2.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
    if (trace > 0) {
      const s2 = 0.5 / Math.sqrt(trace + 1);
      this._w = 0.25 / s2;
      this._x = (m32 - m23) * s2;
      this._y = (m13 - m31) * s2;
      this._z = (m21 - m12) * s2;
    } else if (m11 > m22 && m11 > m33) {
      const s2 = 2 * Math.sqrt(1 + m11 - m22 - m33);
      this._w = (m32 - m23) / s2;
      this._x = 0.25 * s2;
      this._y = (m12 + m21) / s2;
      this._z = (m13 + m31) / s2;
    } else if (m22 > m33) {
      const s2 = 2 * Math.sqrt(1 + m22 - m11 - m33);
      this._w = (m13 - m31) / s2;
      this._x = (m12 + m21) / s2;
      this._y = 0.25 * s2;
      this._z = (m23 + m32) / s2;
    } else {
      const s2 = 2 * Math.sqrt(1 + m33 - m11 - m22);
      this._w = (m21 - m12) / s2;
      this._x = (m13 + m31) / s2;
      this._y = (m23 + m32) / s2;
      this._z = 0.25 * s2;
    }
    this._onChangeCallback();
    return this;
  }
  setFromUnitVectors(vFrom, vTo) {
    let r2 = vFrom.dot(vTo) + 1;
    if (r2 < Number.EPSILON) {
      r2 = 0;
      if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
        this._x = -vFrom.y;
        this._y = vFrom.x;
        this._z = 0;
        this._w = r2;
      } else {
        this._x = 0;
        this._y = -vFrom.z;
        this._z = vFrom.y;
        this._w = r2;
      }
    } else {
      this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
      this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
      this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
      this._w = r2;
    }
    return this.normalize();
  }
  angleTo(q2) {
    return 2 * Math.acos(Math.abs(clamp$5(this.dot(q2), -1, 1)));
  }
  rotateTowards(q2, step) {
    const angle4 = this.angleTo(q2);
    if (angle4 === 0)
      return this;
    const t2 = Math.min(1, step / angle4);
    this.slerp(q2, t2);
    return this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    this._x *= -1;
    this._y *= -1;
    this._z *= -1;
    this._onChangeCallback();
    return this;
  }
  dot(v5) {
    return this._x * v5._x + this._y * v5._y + this._z * v5._z + this._w * v5._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let l2 = this.length();
    if (l2 === 0) {
      this._x = 0;
      this._y = 0;
      this._z = 0;
      this._w = 1;
    } else {
      l2 = 1 / l2;
      this._x = this._x * l2;
      this._y = this._y * l2;
      this._z = this._z * l2;
      this._w = this._w * l2;
    }
    this._onChangeCallback();
    return this;
  }
  multiply(q2, p2) {
    if (p2 !== void 0) {
      console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.");
      return this.multiplyQuaternions(q2, p2);
    }
    return this.multiplyQuaternions(this, q2);
  }
  premultiply(q2) {
    return this.multiplyQuaternions(q2, this);
  }
  multiplyQuaternions(a2, b2) {
    const qax = a2._x, qay = a2._y, qaz = a2._z, qaw = a2._w;
    const qbx = b2._x, qby = b2._y, qbz = b2._z, qbw = b2._w;
    this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
    this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
    this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
    this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
    this._onChangeCallback();
    return this;
  }
  slerp(qb, t2) {
    if (t2 === 0)
      return this;
    if (t2 === 1)
      return this.copy(qb);
    const x2 = this._x, y2 = this._y, z2 = this._z, w2 = this._w;
    let cosHalfTheta = w2 * qb._w + x2 * qb._x + y2 * qb._y + z2 * qb._z;
    if (cosHalfTheta < 0) {
      this._w = -qb._w;
      this._x = -qb._x;
      this._y = -qb._y;
      this._z = -qb._z;
      cosHalfTheta = -cosHalfTheta;
    } else {
      this.copy(qb);
    }
    if (cosHalfTheta >= 1) {
      this._w = w2;
      this._x = x2;
      this._y = y2;
      this._z = z2;
      return this;
    }
    const sqrSinHalfTheta = 1 - cosHalfTheta * cosHalfTheta;
    if (sqrSinHalfTheta <= Number.EPSILON) {
      const s2 = 1 - t2;
      this._w = s2 * w2 + t2 * this._w;
      this._x = s2 * x2 + t2 * this._x;
      this._y = s2 * y2 + t2 * this._y;
      this._z = s2 * z2 + t2 * this._z;
      this.normalize();
      this._onChangeCallback();
      return this;
    }
    const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
    const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
    const ratioA = Math.sin((1 - t2) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t2 * halfTheta) / sinHalfTheta;
    this._w = w2 * ratioA + this._w * ratioB;
    this._x = x2 * ratioA + this._x * ratioB;
    this._y = y2 * ratioA + this._y * ratioB;
    this._z = z2 * ratioA + this._z * ratioB;
    this._onChangeCallback();
    return this;
  }
  slerpQuaternions(qa, qb, t2) {
    return this.copy(qa).slerp(qb, t2);
  }
  random() {
    const u1 = Math.random();
    const sqrt1u1 = Math.sqrt(1 - u1);
    const sqrtu1 = Math.sqrt(u1);
    const u2 = 2 * Math.PI * Math.random();
    const u3 = 2 * Math.PI * Math.random();
    return this.set(
      sqrt1u1 * Math.cos(u2),
      sqrtu1 * Math.sin(u3),
      sqrtu1 * Math.cos(u3),
      sqrt1u1 * Math.sin(u2)
    );
  }
  equals(quaternion2) {
    return quaternion2._x === this._x && quaternion2._y === this._y && quaternion2._z === this._z && quaternion2._w === this._w;
  }
  fromArray(array2, offset = 0) {
    this._x = array2[offset];
    this._y = array2[offset + 1];
    this._z = array2[offset + 2];
    this._w = array2[offset + 3];
    this._onChangeCallback();
    return this;
  }
  toArray(array2 = [], offset = 0) {
    array2[offset] = this._x;
    array2[offset + 1] = this._y;
    array2[offset + 2] = this._z;
    array2[offset + 3] = this._w;
    return array2;
  }
  fromBufferAttribute(attribute, index2) {
    this._x = attribute.getX(index2);
    this._y = attribute.getY(index2);
    this._z = attribute.getZ(index2);
    this._w = attribute.getW(index2);
    return this;
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
};
Quaternion$1.prototype.isQuaternion = true;
let Vector3$1 = class Vector32 {
  constructor(x2 = 0, y2 = 0, z2 = 0) {
    this.x = x2;
    this.y = y2;
    this.z = z2;
  }
  set(x2, y2, z2) {
    if (z2 === void 0)
      z2 = this.z;
    this.x = x2;
    this.y = y2;
    this.z = z2;
    return this;
  }
  setScalar(scalar) {
    this.x = scalar;
    this.y = scalar;
    this.z = scalar;
    return this;
  }
  setX(x2) {
    this.x = x2;
    return this;
  }
  setY(y2) {
    this.y = y2;
    return this;
  }
  setZ(z2) {
    this.z = z2;
    return this;
  }
  setComponent(index2, value) {
    switch (index2) {
      case 0:
        this.x = value;
        break;
      case 1:
        this.y = value;
        break;
      case 2:
        this.z = value;
        break;
      default:
        throw new Error("index is out of range: " + index2);
    }
    return this;
  }
  getComponent(index2) {
    switch (index2) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + index2);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(v5) {
    this.x = v5.x;
    this.y = v5.y;
    this.z = v5.z;
    return this;
  }
  add(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.");
      return this.addVectors(v5, w2);
    }
    this.x += v5.x;
    this.y += v5.y;
    this.z += v5.z;
    return this;
  }
  addScalar(s2) {
    this.x += s2;
    this.y += s2;
    this.z += s2;
    return this;
  }
  addVectors(a2, b2) {
    this.x = a2.x + b2.x;
    this.y = a2.y + b2.y;
    this.z = a2.z + b2.z;
    return this;
  }
  addScaledVector(v5, s2) {
    this.x += v5.x * s2;
    this.y += v5.y * s2;
    this.z += v5.z * s2;
    return this;
  }
  sub(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.");
      return this.subVectors(v5, w2);
    }
    this.x -= v5.x;
    this.y -= v5.y;
    this.z -= v5.z;
    return this;
  }
  subScalar(s2) {
    this.x -= s2;
    this.y -= s2;
    this.z -= s2;
    return this;
  }
  subVectors(a2, b2) {
    this.x = a2.x - b2.x;
    this.y = a2.y - b2.y;
    this.z = a2.z - b2.z;
    return this;
  }
  multiply(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.");
      return this.multiplyVectors(v5, w2);
    }
    this.x *= v5.x;
    this.y *= v5.y;
    this.z *= v5.z;
    return this;
  }
  multiplyScalar(scalar) {
    this.x *= scalar;
    this.y *= scalar;
    this.z *= scalar;
    return this;
  }
  multiplyVectors(a2, b2) {
    this.x = a2.x * b2.x;
    this.y = a2.y * b2.y;
    this.z = a2.z * b2.z;
    return this;
  }
  applyEuler(euler) {
    if (!(euler && euler.isEuler)) {
      console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.");
    }
    return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
  }
  applyAxisAngle(axis, angle4) {
    return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle4));
  }
  applyMatrix3(m2) {
    const x2 = this.x, y2 = this.y, z2 = this.z;
    const e3 = m2.elements;
    this.x = e3[0] * x2 + e3[3] * y2 + e3[6] * z2;
    this.y = e3[1] * x2 + e3[4] * y2 + e3[7] * z2;
    this.z = e3[2] * x2 + e3[5] * y2 + e3[8] * z2;
    return this;
  }
  applyNormalMatrix(m2) {
    return this.applyMatrix3(m2).normalize();
  }
  applyMatrix4(m2) {
    const x2 = this.x, y2 = this.y, z2 = this.z;
    const e3 = m2.elements;
    const w2 = 1 / (e3[3] * x2 + e3[7] * y2 + e3[11] * z2 + e3[15]);
    this.x = (e3[0] * x2 + e3[4] * y2 + e3[8] * z2 + e3[12]) * w2;
    this.y = (e3[1] * x2 + e3[5] * y2 + e3[9] * z2 + e3[13]) * w2;
    this.z = (e3[2] * x2 + e3[6] * y2 + e3[10] * z2 + e3[14]) * w2;
    return this;
  }
  applyQuaternion(q2) {
    const x2 = this.x, y2 = this.y, z2 = this.z;
    const qx = q2.x, qy = q2.y, qz = q2.z, qw = q2.w;
    const ix = qw * x2 + qy * z2 - qz * y2;
    const iy = qw * y2 + qz * x2 - qx * z2;
    const iz = qw * z2 + qx * y2 - qy * x2;
    const iw = -qx * x2 - qy * y2 - qz * z2;
    this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    return this;
  }
  project(camera) {
    return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
  }
  unproject(camera) {
    return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
  }
  transformDirection(m2) {
    const x2 = this.x, y2 = this.y, z2 = this.z;
    const e3 = m2.elements;
    this.x = e3[0] * x2 + e3[4] * y2 + e3[8] * z2;
    this.y = e3[1] * x2 + e3[5] * y2 + e3[9] * z2;
    this.z = e3[2] * x2 + e3[6] * y2 + e3[10] * z2;
    return this.normalize();
  }
  divide(v5) {
    this.x /= v5.x;
    this.y /= v5.y;
    this.z /= v5.z;
    return this;
  }
  divideScalar(scalar) {
    return this.multiplyScalar(1 / scalar);
  }
  min(v5) {
    this.x = Math.min(this.x, v5.x);
    this.y = Math.min(this.y, v5.y);
    this.z = Math.min(this.z, v5.z);
    return this;
  }
  max(v5) {
    this.x = Math.max(this.x, v5.x);
    this.y = Math.max(this.y, v5.y);
    this.z = Math.max(this.z, v5.z);
    return this;
  }
  clamp(min4, max3) {
    this.x = Math.max(min4.x, Math.min(max3.x, this.x));
    this.y = Math.max(min4.y, Math.min(max3.y, this.y));
    this.z = Math.max(min4.z, Math.min(max3.z, this.z));
    return this;
  }
  clampScalar(minVal, maxVal) {
    this.x = Math.max(minVal, Math.min(maxVal, this.x));
    this.y = Math.max(minVal, Math.min(maxVal, this.y));
    this.z = Math.max(minVal, Math.min(maxVal, this.z));
    return this;
  }
  clampLength(min4, max3) {
    const length2 = this.length();
    return this.divideScalar(length2 || 1).multiplyScalar(Math.max(min4, Math.min(max3, length2)));
  }
  floor() {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    this.z = Math.floor(this.z);
    return this;
  }
  ceil() {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    this.z = Math.ceil(this.z);
    return this;
  }
  round() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    this.z = Math.round(this.z);
    return this;
  }
  roundToZero() {
    this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
    this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
    this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
    return this;
  }
  negate() {
    this.x = -this.x;
    this.y = -this.y;
    this.z = -this.z;
    return this;
  }
  dot(v5) {
    return this.x * v5.x + this.y * v5.y + this.z * v5.z;
  }
  // TODO lengthSquared?
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(length2) {
    return this.normalize().multiplyScalar(length2);
  }
  lerp(v5, alpha) {
    this.x += (v5.x - this.x) * alpha;
    this.y += (v5.y - this.y) * alpha;
    this.z += (v5.z - this.z) * alpha;
    return this;
  }
  lerpVectors(v12, v22, alpha) {
    this.x = v12.x + (v22.x - v12.x) * alpha;
    this.y = v12.y + (v22.y - v12.y) * alpha;
    this.z = v12.z + (v22.z - v12.z) * alpha;
    return this;
  }
  cross(v5, w2) {
    if (w2 !== void 0) {
      console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.");
      return this.crossVectors(v5, w2);
    }
    return this.crossVectors(this, v5);
  }
  crossVectors(a2, b2) {
    const ax2 = a2.x, ay2 = a2.y, az2 = a2.z;
    const bx2 = b2.x, by2 = b2.y, bz2 = b2.z;
    this.x = ay2 * bz2 - az2 * by2;
    this.y = az2 * bx2 - ax2 * bz2;
    this.z = ax2 * by2 - ay2 * bx2;
    return this;
  }
  projectOnVector(v5) {
    const denominator = v5.lengthSq();
    if (denominator === 0)
      return this.set(0, 0, 0);
    const scalar = v5.dot(this) / denominator;
    return this.copy(v5).multiplyScalar(scalar);
  }
  projectOnPlane(planeNormal) {
    _vector$c.copy(this).projectOnVector(planeNormal);
    return this.sub(_vector$c);
  }
  reflect(normal) {
    return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
  }
  angleTo(v5) {
    const denominator = Math.sqrt(this.lengthSq() * v5.lengthSq());
    if (denominator === 0)
      return Math.PI / 2;
    const theta = this.dot(v5) / denominator;
    return Math.acos(clamp$5(theta, -1, 1));
  }
  distanceTo(v5) {
    return Math.sqrt(this.distanceToSquared(v5));
  }
  distanceToSquared(v5) {
    const dx = this.x - v5.x, dy = this.y - v5.y, dz = this.z - v5.z;
    return dx * dx + dy * dy + dz * dz;
  }
  manhattanDistanceTo(v5) {
    return Math.abs(this.x - v5.x) + Math.abs(this.y - v5.y) + Math.abs(this.z - v5.z);
  }
  setFromSpherical(s2) {
    return this.setFromSphericalCoords(s2.radius, s2.phi, s2.theta);
  }
  setFromSphericalCoords(radius, phi, theta) {
    const sinPhiRadius = Math.sin(phi) * radius;
    this.x = sinPhiRadius * Math.sin(theta);
    this.y = Math.cos(phi) * radius;
    this.z = sinPhiRadius * Math.cos(theta);
    return this;
  }
  setFromCylindrical(c2) {
    return this.setFromCylindricalCoords(c2.radius, c2.theta, c2.y);
  }
  setFromCylindricalCoords(radius, theta, y2) {
    this.x = radius * Math.sin(theta);
    this.y = y2;
    this.z = radius * Math.cos(theta);
    return this;
  }
  setFromMatrixPosition(m2) {
    const e3 = m2.elements;
    this.x = e3[12];
    this.y = e3[13];
    this.z = e3[14];
    return this;
  }
  setFromMatrixScale(m2) {
    const sx = this.setFromMatrixColumn(m2, 0).length();
    const sy = this.setFromMatrixColumn(m2, 1).length();
    const sz = this.setFromMatrixColumn(m2, 2).length();
    this.x = sx;
    this.y = sy;
    this.z = sz;
    return this;
  }
  setFromMatrixColumn(m2, index2) {
    return this.fromArray(m2.elements, index2 * 4);
  }
  setFromMatrix3Column(m2, index2) {
    return this.fromArray(m2.elements, index2 * 3);
  }
  setFromEuler(e3) {
    this.x = e3._x;
    this.y = e3._y;
    this.z = e3._z;
    return this;
  }
  equals(v5) {
    return v5.x === this.x && v5.y === this.y && v5.z === this.z;
  }
  fromArray(array2, offset = 0) {
    this.x = array2[offset];
    this.y = array2[offset + 1];
    this.z = array2[offset + 2];
    return this;
  }
  toArray(array2 = [], offset = 0) {
    array2[offset] = this.x;
    array2[offset + 1] = this.y;
    array2[offset + 2] = this.z;
    return array2;
  }
  fromBufferAttribute(attribute, index2, offset) {
    if (offset !== void 0) {
      console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute().");
    }
    this.x = attribute.getX(index2);
    this.y = attribute.getY(index2);
    this.z = attribute.getZ(index2);
    return this;
  }
  random() {
    this.x = Math.random();
    this.y = Math.random();
    this.z = Math.random();
    return this;
  }
  randomDirection() {
    const u2 = (Math.random() - 0.5) * 2;
    const t2 = Math.random() * Math.PI * 2;
    const f2 = Math.sqrt(1 - u2 ** 2);
    this.x = f2 * Math.cos(t2);
    this.y = f2 * Math.sin(t2);
    this.z = u2;
    return this;
  }
  *[Symbol.iterator]() {
    yield this.x;
    yield this.y;
    yield this.z;
  }
};
Vector3$1.prototype.isVector3 = true;
const _vector$c = /* @__PURE__ */ new Vector3$1();
const _quaternion$4 = /* @__PURE__ */ new Quaternion$1();
class Box3 {
  constructor(min4 = new Vector3$1(Infinity, Infinity, Infinity), max3 = new Vector3$1(-Infinity, -Infinity, -Infinity)) {
    this.min = min4;
    this.max = max3;
  }
  set(min4, max3) {
    this.min.copy(min4);
    this.max.copy(max3);
    return this;
  }
  setFromArray(array2) {
    let minX2 = Infinity;
    let minY2 = Infinity;
    let minZ = Infinity;
    let maxX2 = -Infinity;
    let maxY2 = -Infinity;
    let maxZ = -Infinity;
    for (let i2 = 0, l2 = array2.length; i2 < l2; i2 += 3) {
      const x2 = array2[i2];
      const y2 = array2[i2 + 1];
      const z2 = array2[i2 + 2];
      if (x2 < minX2)
        minX2 = x2;
      if (y2 < minY2)
        minY2 = y2;
      if (z2 < minZ)
        minZ = z2;
      if (x2 > maxX2)
        maxX2 = x2;
      if (y2 > maxY2)
        maxY2 = y2;
      if (z2 > maxZ)
        maxZ = z2;
    }
    this.min.set(minX2, minY2, minZ);
    this.max.set(maxX2, maxY2, maxZ);
    return this;
  }
  setFromBufferAttribute(attribute) {
    let minX2 = Infinity;
    let minY2 = Infinity;
    let minZ = Infinity;
    let maxX2 = -Infinity;
    let maxY2 = -Infinity;
    let maxZ = -Infinity;
    for (let i2 = 0, l2 = attribute.count; i2 < l2; i2++) {
      const x2 = attribute.getX(i2);
      const y2 = attribute.getY(i2);
      const z2 = attribute.getZ(i2);
      if (x2 < minX2)
        minX2 = x2;
      if (y2 < minY2)
        minY2 = y2;
      if (z2 < minZ)
        minZ = z2;
      if (x2 > maxX2)
        maxX2 = x2;
      if (y2 > maxY2)
        maxY2 = y2;
      if (z2 > maxZ)
        maxZ = z2;
    }
    this.min.set(minX2, minY2, minZ);
    this.max.set(maxX2, maxY2, maxZ);
    return this;
  }
  setFromPoints(points2) {
    this.makeEmpty();
    for (let i2 = 0, il = points2.length; i2 < il; i2++) {
      this.expandByPoint(points2[i2]);
    }
    return this;
  }
  setFromCenterAndSize(center2, size12) {
    const halfSize = _vector$b.copy(size12).multiplyScalar(0.5);
    this.min.copy(center2).sub(halfSize);
    this.max.copy(center2).add(halfSize);
    return this;
  }
  setFromObject(object2, precise = false) {
    this.makeEmpty();
    return this.expandByObject(object2, precise);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = this.min.z = Infinity;
    this.max.x = this.max.y = this.max.z = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point4) {
    this.min.min(point4);
    this.max.max(point4);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  expandByObject(object2, precise = false) {
    object2.updateWorldMatrix(false, false);
    const geometry2 = object2.geometry;
    if (geometry2 !== void 0) {
      if (precise && geometry2.attributes != void 0 && geometry2.attributes.position !== void 0) {
        const position = geometry2.attributes.position;
        for (let i2 = 0, l2 = position.count; i2 < l2; i2++) {
          _vector$b.fromBufferAttribute(position, i2).applyMatrix4(object2.matrixWorld);
          this.expandByPoint(_vector$b);
        }
      } else {
        if (geometry2.boundingBox === null) {
          geometry2.computeBoundingBox();
        }
        _box$3.copy(geometry2.boundingBox);
        _box$3.applyMatrix4(object2.matrixWorld);
        this.union(_box$3);
      }
    }
    const children = object2.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      this.expandByObject(children[i2], precise);
    }
    return this;
  }
  containsPoint(point4) {
    return point4.x < this.min.x || point4.x > this.max.x || point4.y < this.min.y || point4.y > this.max.y || point4.z < this.min.z || point4.z > this.max.z ? false : true;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
  }
  getParameter(point4, target) {
    return target.set(
      (point4.x - this.min.x) / (this.max.x - this.min.x),
      (point4.y - this.min.y) / (this.max.y - this.min.y),
      (point4.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(box) {
    return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
  }
  intersectsSphere(sphere2) {
    this.clampPoint(sphere2.center, _vector$b);
    return _vector$b.distanceToSquared(sphere2.center) <= sphere2.radius * sphere2.radius;
  }
  intersectsPlane(plane) {
    let min4, max3;
    if (plane.normal.x > 0) {
      min4 = plane.normal.x * this.min.x;
      max3 = plane.normal.x * this.max.x;
    } else {
      min4 = plane.normal.x * this.max.x;
      max3 = plane.normal.x * this.min.x;
    }
    if (plane.normal.y > 0) {
      min4 += plane.normal.y * this.min.y;
      max3 += plane.normal.y * this.max.y;
    } else {
      min4 += plane.normal.y * this.max.y;
      max3 += plane.normal.y * this.min.y;
    }
    if (plane.normal.z > 0) {
      min4 += plane.normal.z * this.min.z;
      max3 += plane.normal.z * this.max.z;
    } else {
      min4 += plane.normal.z * this.max.z;
      max3 += plane.normal.z * this.min.z;
    }
    return min4 <= -plane.constant && max3 >= -plane.constant;
  }
  intersectsTriangle(triangle) {
    if (this.isEmpty()) {
      return false;
    }
    this.getCenter(_center);
    _extents.subVectors(this.max, _center);
    _v0$2.subVectors(triangle.a, _center);
    _v1$7.subVectors(triangle.b, _center);
    _v2$3.subVectors(triangle.c, _center);
    _f0.subVectors(_v1$7, _v0$2);
    _f1.subVectors(_v2$3, _v1$7);
    _f2.subVectors(_v0$2, _v2$3);
    let axes = [
      0,
      -_f0.z,
      _f0.y,
      0,
      -_f1.z,
      _f1.y,
      0,
      -_f2.z,
      _f2.y,
      _f0.z,
      0,
      -_f0.x,
      _f1.z,
      0,
      -_f1.x,
      _f2.z,
      0,
      -_f2.x,
      -_f0.y,
      _f0.x,
      0,
      -_f1.y,
      _f1.x,
      0,
      -_f2.y,
      _f2.x,
      0
    ];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
      return false;
    }
    axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];
    if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
      return false;
    }
    _triangleNormal.crossVectors(_f0, _f1);
    axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
    return satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents);
  }
  clampPoint(point4, target) {
    return target.copy(point4).clamp(this.min, this.max);
  }
  distanceToPoint(point4) {
    const clampedPoint = _vector$b.copy(point4).clamp(this.min, this.max);
    return clampedPoint.sub(point4).length();
  }
  getBoundingSphere(target) {
    this.getCenter(target.center);
    target.radius = this.getSize(_vector$b).length() * 0.5;
    return target;
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    if (this.isEmpty())
      this.makeEmpty();
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  applyMatrix4(matrix) {
    if (this.isEmpty())
      return this;
    _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix);
    _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix);
    _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix);
    _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix);
    _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix);
    _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix);
    _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix);
    _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix);
    this.setFromPoints(_points);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
Box3.prototype.isBox3 = true;
const _points = [
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1(),
  /* @__PURE__ */ new Vector3$1()
];
const _vector$b = /* @__PURE__ */ new Vector3$1();
const _box$3 = /* @__PURE__ */ new Box3();
const _v0$2 = /* @__PURE__ */ new Vector3$1();
const _v1$7 = /* @__PURE__ */ new Vector3$1();
const _v2$3 = /* @__PURE__ */ new Vector3$1();
const _f0 = /* @__PURE__ */ new Vector3$1();
const _f1 = /* @__PURE__ */ new Vector3$1();
const _f2 = /* @__PURE__ */ new Vector3$1();
const _center = /* @__PURE__ */ new Vector3$1();
const _extents = /* @__PURE__ */ new Vector3$1();
const _triangleNormal = /* @__PURE__ */ new Vector3$1();
const _testAxis = /* @__PURE__ */ new Vector3$1();
function satForAxes(axes, v0, v12, v22, extents) {
  for (let i2 = 0, j2 = axes.length - 3; i2 <= j2; i2 += 3) {
    _testAxis.fromArray(axes, i2);
    const r2 = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
    const p0 = v0.dot(_testAxis);
    const p1 = v12.dot(_testAxis);
    const p2 = v22.dot(_testAxis);
    if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r2) {
      return false;
    }
  }
  return true;
}
const _box$2 = /* @__PURE__ */ new Box3();
const _v1$6 = /* @__PURE__ */ new Vector3$1();
const _toFarthestPoint = /* @__PURE__ */ new Vector3$1();
const _toPoint = /* @__PURE__ */ new Vector3$1();
class Sphere {
  constructor(center2 = new Vector3$1(), radius = -1) {
    this.center = center2;
    this.radius = radius;
  }
  set(center2, radius) {
    this.center.copy(center2);
    this.radius = radius;
    return this;
  }
  setFromPoints(points2, optionalCenter) {
    const center2 = this.center;
    if (optionalCenter !== void 0) {
      center2.copy(optionalCenter);
    } else {
      _box$2.setFromPoints(points2).getCenter(center2);
    }
    let maxRadiusSq = 0;
    for (let i2 = 0, il = points2.length; i2 < il; i2++) {
      maxRadiusSq = Math.max(maxRadiusSq, center2.distanceToSquared(points2[i2]));
    }
    this.radius = Math.sqrt(maxRadiusSq);
    return this;
  }
  copy(sphere2) {
    this.center.copy(sphere2.center);
    this.radius = sphere2.radius;
    return this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    this.center.set(0, 0, 0);
    this.radius = -1;
    return this;
  }
  containsPoint(point4) {
    return point4.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(point4) {
    return point4.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(sphere2) {
    const radiusSum = this.radius + sphere2.radius;
    return sphere2.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
  }
  intersectsBox(box) {
    return box.intersectsSphere(this);
  }
  intersectsPlane(plane) {
    return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(point4, target) {
    const deltaLengthSq = this.center.distanceToSquared(point4);
    target.copy(point4);
    if (deltaLengthSq > this.radius * this.radius) {
      target.sub(this.center).normalize();
      target.multiplyScalar(this.radius).add(this.center);
    }
    return target;
  }
  getBoundingBox(target) {
    if (this.isEmpty()) {
      target.makeEmpty();
      return target;
    }
    target.set(this.center, this.center);
    target.expandByScalar(this.radius);
    return target;
  }
  applyMatrix4(matrix) {
    this.center.applyMatrix4(matrix);
    this.radius = this.radius * matrix.getMaxScaleOnAxis();
    return this;
  }
  translate(offset) {
    this.center.add(offset);
    return this;
  }
  expandByPoint(point4) {
    _toPoint.subVectors(point4, this.center);
    const lengthSq = _toPoint.lengthSq();
    if (lengthSq > this.radius * this.radius) {
      const length2 = Math.sqrt(lengthSq);
      const missingRadiusHalf = (length2 - this.radius) * 0.5;
      this.center.add(_toPoint.multiplyScalar(missingRadiusHalf / length2));
      this.radius += missingRadiusHalf;
    }
    return this;
  }
  union(sphere2) {
    if (this.center.equals(sphere2.center) === true) {
      _toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere2.radius);
    } else {
      _toFarthestPoint.subVectors(sphere2.center, this.center).normalize().multiplyScalar(sphere2.radius);
    }
    this.expandByPoint(_v1$6.copy(sphere2.center).add(_toFarthestPoint));
    this.expandByPoint(_v1$6.copy(sphere2.center).sub(_toFarthestPoint));
    return this;
  }
  equals(sphere2) {
    return sphere2.center.equals(this.center) && sphere2.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$a = /* @__PURE__ */ new Vector3$1();
const _segCenter = /* @__PURE__ */ new Vector3$1();
const _segDir = /* @__PURE__ */ new Vector3$1();
const _diff = /* @__PURE__ */ new Vector3$1();
const _edge1 = /* @__PURE__ */ new Vector3$1();
const _edge2 = /* @__PURE__ */ new Vector3$1();
const _normal$1 = /* @__PURE__ */ new Vector3$1();
class Ray {
  constructor(origin = new Vector3$1(), direction = new Vector3$1(0, 0, -1)) {
    this.origin = origin;
    this.direction = direction;
  }
  set(origin, direction) {
    this.origin.copy(origin);
    this.direction.copy(direction);
    return this;
  }
  copy(ray) {
    this.origin.copy(ray.origin);
    this.direction.copy(ray.direction);
    return this;
  }
  at(t2, target) {
    return target.copy(this.direction).multiplyScalar(t2).add(this.origin);
  }
  lookAt(v5) {
    this.direction.copy(v5).sub(this.origin).normalize();
    return this;
  }
  recast(t2) {
    this.origin.copy(this.at(t2, _vector$a));
    return this;
  }
  closestPointToPoint(point4, target) {
    target.subVectors(point4, this.origin);
    const directionDistance = target.dot(this.direction);
    if (directionDistance < 0) {
      return target.copy(this.origin);
    }
    return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
  }
  distanceToPoint(point4) {
    return Math.sqrt(this.distanceSqToPoint(point4));
  }
  distanceSqToPoint(point4) {
    const directionDistance = _vector$a.subVectors(point4, this.origin).dot(this.direction);
    if (directionDistance < 0) {
      return this.origin.distanceToSquared(point4);
    }
    _vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    return _vector$a.distanceToSquared(point4);
  }
  distanceSqToSegment(v0, v12, optionalPointOnRay, optionalPointOnSegment) {
    _segCenter.copy(v0).add(v12).multiplyScalar(0.5);
    _segDir.copy(v12).sub(v0).normalize();
    _diff.copy(this.origin).sub(_segCenter);
    const segExtent = v0.distanceTo(v12) * 0.5;
    const a01 = -this.direction.dot(_segDir);
    const b0 = _diff.dot(this.direction);
    const b1 = -_diff.dot(_segDir);
    const c2 = _diff.lengthSq();
    const det2 = Math.abs(1 - a01 * a01);
    let s0, s1, sqrDist, extDet;
    if (det2 > 0) {
      s0 = a01 * b1 - b0;
      s1 = a01 * b0 - b1;
      extDet = segExtent * det2;
      if (s0 >= 0) {
        if (s1 >= -extDet) {
          if (s1 <= extDet) {
            const invDet = 1 / det2;
            s0 *= invDet;
            s1 *= invDet;
            sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c2;
          } else {
            s1 = segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
          }
        } else {
          s1 = -segExtent;
          s0 = Math.max(0, -(a01 * s1 + b0));
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      } else {
        if (s1 <= -extDet) {
          s0 = Math.max(0, -(-a01 * segExtent + b0));
          s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        } else if (s1 <= extDet) {
          s0 = 0;
          s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = s1 * (s1 + 2 * b1) + c2;
        } else {
          s0 = Math.max(0, -(a01 * segExtent + b0));
          s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
          sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
        }
      }
    } else {
      s1 = a01 > 0 ? -segExtent : segExtent;
      s0 = Math.max(0, -(a01 * s1 + b0));
      sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c2;
    }
    if (optionalPointOnRay) {
      optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
    }
    if (optionalPointOnSegment) {
      optionalPointOnSegment.copy(_segDir).multiplyScalar(s1).add(_segCenter);
    }
    return sqrDist;
  }
  intersectSphere(sphere2, target) {
    _vector$a.subVectors(sphere2.center, this.origin);
    const tca = _vector$a.dot(this.direction);
    const d2 = _vector$a.dot(_vector$a) - tca * tca;
    const radius2 = sphere2.radius * sphere2.radius;
    if (d2 > radius2)
      return null;
    const thc = Math.sqrt(radius2 - d2);
    const t0 = tca - thc;
    const t1 = tca + thc;
    if (t0 < 0 && t1 < 0)
      return null;
    if (t0 < 0)
      return this.at(t1, target);
    return this.at(t0, target);
  }
  intersectsSphere(sphere2) {
    return this.distanceSqToPoint(sphere2.center) <= sphere2.radius * sphere2.radius;
  }
  distanceToPlane(plane) {
    const denominator = plane.normal.dot(this.direction);
    if (denominator === 0) {
      if (plane.distanceToPoint(this.origin) === 0) {
        return 0;
      }
      return null;
    }
    const t2 = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
    return t2 >= 0 ? t2 : null;
  }
  intersectPlane(plane, target) {
    const t2 = this.distanceToPlane(plane);
    if (t2 === null) {
      return null;
    }
    return this.at(t2, target);
  }
  intersectsPlane(plane) {
    const distToPoint = plane.distanceToPoint(this.origin);
    if (distToPoint === 0) {
      return true;
    }
    const denominator = plane.normal.dot(this.direction);
    if (denominator * distToPoint < 0) {
      return true;
    }
    return false;
  }
  intersectBox(box, target) {
    let tmin, tmax, tymin, tymax, tzmin, tzmax;
    const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
    const origin = this.origin;
    if (invdirx >= 0) {
      tmin = (box.min.x - origin.x) * invdirx;
      tmax = (box.max.x - origin.x) * invdirx;
    } else {
      tmin = (box.max.x - origin.x) * invdirx;
      tmax = (box.min.x - origin.x) * invdirx;
    }
    if (invdiry >= 0) {
      tymin = (box.min.y - origin.y) * invdiry;
      tymax = (box.max.y - origin.y) * invdiry;
    } else {
      tymin = (box.max.y - origin.y) * invdiry;
      tymax = (box.min.y - origin.y) * invdiry;
    }
    if (tmin > tymax || tymin > tmax)
      return null;
    if (tymin > tmin || tmin !== tmin)
      tmin = tymin;
    if (tymax < tmax || tmax !== tmax)
      tmax = tymax;
    if (invdirz >= 0) {
      tzmin = (box.min.z - origin.z) * invdirz;
      tzmax = (box.max.z - origin.z) * invdirz;
    } else {
      tzmin = (box.max.z - origin.z) * invdirz;
      tzmax = (box.min.z - origin.z) * invdirz;
    }
    if (tmin > tzmax || tzmin > tmax)
      return null;
    if (tzmin > tmin || tmin !== tmin)
      tmin = tzmin;
    if (tzmax < tmax || tmax !== tmax)
      tmax = tzmax;
    if (tmax < 0)
      return null;
    return this.at(tmin >= 0 ? tmin : tmax, target);
  }
  intersectsBox(box) {
    return this.intersectBox(box, _vector$a) !== null;
  }
  intersectTriangle(a2, b2, c2, backfaceCulling, target) {
    _edge1.subVectors(b2, a2);
    _edge2.subVectors(c2, a2);
    _normal$1.crossVectors(_edge1, _edge2);
    let DdN = this.direction.dot(_normal$1);
    let sign2;
    if (DdN > 0) {
      if (backfaceCulling)
        return null;
      sign2 = 1;
    } else if (DdN < 0) {
      sign2 = -1;
      DdN = -DdN;
    } else {
      return null;
    }
    _diff.subVectors(this.origin, a2);
    const DdQxE2 = sign2 * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
    if (DdQxE2 < 0) {
      return null;
    }
    const DdE1xQ = sign2 * this.direction.dot(_edge1.cross(_diff));
    if (DdE1xQ < 0) {
      return null;
    }
    if (DdQxE2 + DdE1xQ > DdN) {
      return null;
    }
    const QdN = -sign2 * _diff.dot(_normal$1);
    if (QdN < 0) {
      return null;
    }
    return this.at(QdN / DdN, target);
  }
  applyMatrix4(matrix4) {
    this.origin.applyMatrix4(matrix4);
    this.direction.transformDirection(matrix4);
    return this;
  }
  equals(ray) {
    return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
let Matrix4$1 = class Matrix42 {
  constructor() {
    this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ];
    if (arguments.length > 0) {
      console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
    }
  }
  set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
    const te = this.elements;
    te[0] = n11;
    te[4] = n12;
    te[8] = n13;
    te[12] = n14;
    te[1] = n21;
    te[5] = n22;
    te[9] = n23;
    te[13] = n24;
    te[2] = n31;
    te[6] = n32;
    te[10] = n33;
    te[14] = n34;
    te[3] = n41;
    te[7] = n42;
    te[11] = n43;
    te[15] = n44;
    return this;
  }
  identity() {
    this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  clone() {
    return new Matrix42().fromArray(this.elements);
  }
  copy(m2) {
    const te = this.elements;
    const me = m2.elements;
    te[0] = me[0];
    te[1] = me[1];
    te[2] = me[2];
    te[3] = me[3];
    te[4] = me[4];
    te[5] = me[5];
    te[6] = me[6];
    te[7] = me[7];
    te[8] = me[8];
    te[9] = me[9];
    te[10] = me[10];
    te[11] = me[11];
    te[12] = me[12];
    te[13] = me[13];
    te[14] = me[14];
    te[15] = me[15];
    return this;
  }
  copyPosition(m2) {
    const te = this.elements, me = m2.elements;
    te[12] = me[12];
    te[13] = me[13];
    te[14] = me[14];
    return this;
  }
  setFromMatrix3(m2) {
    const me = m2.elements;
    this.set(
      me[0],
      me[3],
      me[6],
      0,
      me[1],
      me[4],
      me[7],
      0,
      me[2],
      me[5],
      me[8],
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractBasis(xAxis, yAxis, zAxis) {
    xAxis.setFromMatrixColumn(this, 0);
    yAxis.setFromMatrixColumn(this, 1);
    zAxis.setFromMatrixColumn(this, 2);
    return this;
  }
  makeBasis(xAxis, yAxis, zAxis) {
    this.set(
      xAxis.x,
      yAxis.x,
      zAxis.x,
      0,
      xAxis.y,
      yAxis.y,
      zAxis.y,
      0,
      xAxis.z,
      yAxis.z,
      zAxis.z,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  extractRotation(m2) {
    const te = this.elements;
    const me = m2.elements;
    const scaleX3 = 1 / _v1$5.setFromMatrixColumn(m2, 0).length();
    const scaleY3 = 1 / _v1$5.setFromMatrixColumn(m2, 1).length();
    const scaleZ = 1 / _v1$5.setFromMatrixColumn(m2, 2).length();
    te[0] = me[0] * scaleX3;
    te[1] = me[1] * scaleX3;
    te[2] = me[2] * scaleX3;
    te[3] = 0;
    te[4] = me[4] * scaleY3;
    te[5] = me[5] * scaleY3;
    te[6] = me[6] * scaleY3;
    te[7] = 0;
    te[8] = me[8] * scaleZ;
    te[9] = me[9] * scaleZ;
    te[10] = me[10] * scaleZ;
    te[11] = 0;
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;
    return this;
  }
  makeRotationFromEuler(euler) {
    if (!(euler && euler.isEuler)) {
      console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
    }
    const te = this.elements;
    const x2 = euler.x, y2 = euler.y, z2 = euler.z;
    const a2 = Math.cos(x2), b2 = Math.sin(x2);
    const c2 = Math.cos(y2), d2 = Math.sin(y2);
    const e3 = Math.cos(z2), f2 = Math.sin(z2);
    if (euler.order === "XYZ") {
      const ae2 = a2 * e3, af2 = a2 * f2, be2 = b2 * e3, bf2 = b2 * f2;
      te[0] = c2 * e3;
      te[4] = -c2 * f2;
      te[8] = d2;
      te[1] = af2 + be2 * d2;
      te[5] = ae2 - bf2 * d2;
      te[9] = -b2 * c2;
      te[2] = bf2 - ae2 * d2;
      te[6] = be2 + af2 * d2;
      te[10] = a2 * c2;
    } else if (euler.order === "YXZ") {
      const ce2 = c2 * e3, cf2 = c2 * f2, de = d2 * e3, df = d2 * f2;
      te[0] = ce2 + df * b2;
      te[4] = de * b2 - cf2;
      te[8] = a2 * d2;
      te[1] = a2 * f2;
      te[5] = a2 * e3;
      te[9] = -b2;
      te[2] = cf2 * b2 - de;
      te[6] = df + ce2 * b2;
      te[10] = a2 * c2;
    } else if (euler.order === "ZXY") {
      const ce2 = c2 * e3, cf2 = c2 * f2, de = d2 * e3, df = d2 * f2;
      te[0] = ce2 - df * b2;
      te[4] = -a2 * f2;
      te[8] = de + cf2 * b2;
      te[1] = cf2 + de * b2;
      te[5] = a2 * e3;
      te[9] = df - ce2 * b2;
      te[2] = -a2 * d2;
      te[6] = b2;
      te[10] = a2 * c2;
    } else if (euler.order === "ZYX") {
      const ae2 = a2 * e3, af2 = a2 * f2, be2 = b2 * e3, bf2 = b2 * f2;
      te[0] = c2 * e3;
      te[4] = be2 * d2 - af2;
      te[8] = ae2 * d2 + bf2;
      te[1] = c2 * f2;
      te[5] = bf2 * d2 + ae2;
      te[9] = af2 * d2 - be2;
      te[2] = -d2;
      te[6] = b2 * c2;
      te[10] = a2 * c2;
    } else if (euler.order === "YZX") {
      const ac2 = a2 * c2, ad2 = a2 * d2, bc2 = b2 * c2, bd2 = b2 * d2;
      te[0] = c2 * e3;
      te[4] = bd2 - ac2 * f2;
      te[8] = bc2 * f2 + ad2;
      te[1] = f2;
      te[5] = a2 * e3;
      te[9] = -b2 * e3;
      te[2] = -d2 * e3;
      te[6] = ad2 * f2 + bc2;
      te[10] = ac2 - bd2 * f2;
    } else if (euler.order === "XZY") {
      const ac2 = a2 * c2, ad2 = a2 * d2, bc2 = b2 * c2, bd2 = b2 * d2;
      te[0] = c2 * e3;
      te[4] = -f2;
      te[8] = d2 * e3;
      te[1] = ac2 * f2 + bd2;
      te[5] = a2 * e3;
      te[9] = ad2 * f2 - bc2;
      te[2] = bc2 * f2 - ad2;
      te[6] = b2 * e3;
      te[10] = bd2 * f2 + ac2;
    }
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;
    te[12] = 0;
    te[13] = 0;
    te[14] = 0;
    te[15] = 1;
    return this;
  }
  makeRotationFromQuaternion(q2) {
    return this.compose(_zero, q2, _one);
  }
  lookAt(eye, target, up) {
    const te = this.elements;
    _z.subVectors(eye, target);
    if (_z.lengthSq() === 0) {
      _z.z = 1;
    }
    _z.normalize();
    _x.crossVectors(up, _z);
    if (_x.lengthSq() === 0) {
      if (Math.abs(up.z) === 1) {
        _z.x += 1e-4;
      } else {
        _z.z += 1e-4;
      }
      _z.normalize();
      _x.crossVectors(up, _z);
    }
    _x.normalize();
    _y.crossVectors(_z, _x);
    te[0] = _x.x;
    te[4] = _y.x;
    te[8] = _z.x;
    te[1] = _x.y;
    te[5] = _y.y;
    te[9] = _z.y;
    te[2] = _x.z;
    te[6] = _y.z;
    te[10] = _z.z;
    return this;
  }
  multiply(m2, n2) {
    if (n2 !== void 0) {
      console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.");
      return this.multiplyMatrices(m2, n2);
    }
    return this.multiplyMatrices(this, m2);
  }
  premultiply(m2) {
    return this.multiplyMatrices(m2, this);
  }
  multiplyMatrices(a2, b2) {
    const ae2 = a2.elements;
    const be2 = b2.elements;
    const te = this.elements;
    const a11 = ae2[0], a12 = ae2[4], a13 = ae2[8], a14 = ae2[12];
    const a21 = ae2[1], a22 = ae2[5], a23 = ae2[9], a24 = ae2[13];
    const a31 = ae2[2], a32 = ae2[6], a33 = ae2[10], a34 = ae2[14];
    const a41 = ae2[3], a42 = ae2[7], a43 = ae2[11], a44 = ae2[15];
    const b11 = be2[0], b12 = be2[4], b13 = be2[8], b14 = be2[12];
    const b21 = be2[1], b22 = be2[5], b23 = be2[9], b24 = be2[13];
    const b31 = be2[2], b32 = be2[6], b33 = be2[10], b34 = be2[14];
    const b41 = be2[3], b42 = be2[7], b43 = be2[11], b44 = be2[15];
    te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
    return this;
  }
  multiplyScalar(s2) {
    const te = this.elements;
    te[0] *= s2;
    te[4] *= s2;
    te[8] *= s2;
    te[12] *= s2;
    te[1] *= s2;
    te[5] *= s2;
    te[9] *= s2;
    te[13] *= s2;
    te[2] *= s2;
    te[6] *= s2;
    te[10] *= s2;
    te[14] *= s2;
    te[3] *= s2;
    te[7] *= s2;
    te[11] *= s2;
    te[15] *= s2;
    return this;
  }
  determinant() {
    const te = this.elements;
    const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
    const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
    const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
    const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
    return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
  }
  transpose() {
    const te = this.elements;
    let tmp2;
    tmp2 = te[1];
    te[1] = te[4];
    te[4] = tmp2;
    tmp2 = te[2];
    te[2] = te[8];
    te[8] = tmp2;
    tmp2 = te[6];
    te[6] = te[9];
    te[9] = tmp2;
    tmp2 = te[3];
    te[3] = te[12];
    te[12] = tmp2;
    tmp2 = te[7];
    te[7] = te[13];
    te[13] = tmp2;
    tmp2 = te[11];
    te[11] = te[14];
    te[14] = tmp2;
    return this;
  }
  setPosition(x2, y2, z2) {
    const te = this.elements;
    if (x2.isVector3) {
      te[12] = x2.x;
      te[13] = x2.y;
      te[14] = x2.z;
    } else {
      te[12] = x2;
      te[13] = y2;
      te[14] = z2;
    }
    return this;
  }
  invert() {
    const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
    const det2 = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
    if (det2 === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const detInv = 1 / det2;
    te[0] = t11 * detInv;
    te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
    te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
    te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
    te[4] = t12 * detInv;
    te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
    te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
    te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
    te[8] = t13 * detInv;
    te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
    te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
    te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
    te[12] = t14 * detInv;
    te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
    te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
    te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
    return this;
  }
  scale(v5) {
    const te = this.elements;
    const x2 = v5.x, y2 = v5.y, z2 = v5.z;
    te[0] *= x2;
    te[4] *= y2;
    te[8] *= z2;
    te[1] *= x2;
    te[5] *= y2;
    te[9] *= z2;
    te[2] *= x2;
    te[6] *= y2;
    te[10] *= z2;
    te[3] *= x2;
    te[7] *= y2;
    te[11] *= z2;
    return this;
  }
  getMaxScaleOnAxis() {
    const te = this.elements;
    const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
    const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
    const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
    return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
  }
  makeTranslation(x2, y2, z2) {
    this.set(
      1,
      0,
      0,
      x2,
      0,
      1,
      0,
      y2,
      0,
      0,
      1,
      z2,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationX(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      1,
      0,
      0,
      0,
      0,
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationY(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      0,
      s2,
      0,
      0,
      1,
      0,
      0,
      -s2,
      0,
      c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationZ(theta) {
    const c2 = Math.cos(theta), s2 = Math.sin(theta);
    this.set(
      c2,
      -s2,
      0,
      0,
      s2,
      c2,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeRotationAxis(axis, angle4) {
    const c2 = Math.cos(angle4);
    const s2 = Math.sin(angle4);
    const t2 = 1 - c2;
    const x2 = axis.x, y2 = axis.y, z2 = axis.z;
    const tx = t2 * x2, ty = t2 * y2;
    this.set(
      tx * x2 + c2,
      tx * y2 - s2 * z2,
      tx * z2 + s2 * y2,
      0,
      tx * y2 + s2 * z2,
      ty * y2 + c2,
      ty * z2 - s2 * x2,
      0,
      tx * z2 - s2 * y2,
      ty * z2 + s2 * x2,
      t2 * z2 * z2 + c2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeScale(x2, y2, z2) {
    this.set(
      x2,
      0,
      0,
      0,
      0,
      y2,
      0,
      0,
      0,
      0,
      z2,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  makeShear(xy, xz, yx, yz, zx, zy) {
    this.set(
      1,
      yx,
      zx,
      0,
      xy,
      1,
      zy,
      0,
      xz,
      yz,
      1,
      0,
      0,
      0,
      0,
      1
    );
    return this;
  }
  compose(position, quaternion2, scale5) {
    const te = this.elements;
    const x2 = quaternion2._x, y2 = quaternion2._y, z2 = quaternion2._z, w2 = quaternion2._w;
    const x22 = x2 + x2, y22 = y2 + y2, z22 = z2 + z2;
    const xx = x2 * x22, xy = x2 * y22, xz = x2 * z22;
    const yy = y2 * y22, yz = y2 * z22, zz = z2 * z22;
    const wx = w2 * x22, wy = w2 * y22, wz = w2 * z22;
    const sx = scale5.x, sy = scale5.y, sz = scale5.z;
    te[0] = (1 - (yy + zz)) * sx;
    te[1] = (xy + wz) * sx;
    te[2] = (xz - wy) * sx;
    te[3] = 0;
    te[4] = (xy - wz) * sy;
    te[5] = (1 - (xx + zz)) * sy;
    te[6] = (yz + wx) * sy;
    te[7] = 0;
    te[8] = (xz + wy) * sz;
    te[9] = (yz - wx) * sz;
    te[10] = (1 - (xx + yy)) * sz;
    te[11] = 0;
    te[12] = position.x;
    te[13] = position.y;
    te[14] = position.z;
    te[15] = 1;
    return this;
  }
  decompose(position, quaternion2, scale5) {
    const te = this.elements;
    let sx = _v1$5.set(te[0], te[1], te[2]).length();
    const sy = _v1$5.set(te[4], te[5], te[6]).length();
    const sz = _v1$5.set(te[8], te[9], te[10]).length();
    const det2 = this.determinant();
    if (det2 < 0)
      sx = -sx;
    position.x = te[12];
    position.y = te[13];
    position.z = te[14];
    _m1$2.copy(this);
    const invSX = 1 / sx;
    const invSY = 1 / sy;
    const invSZ = 1 / sz;
    _m1$2.elements[0] *= invSX;
    _m1$2.elements[1] *= invSX;
    _m1$2.elements[2] *= invSX;
    _m1$2.elements[4] *= invSY;
    _m1$2.elements[5] *= invSY;
    _m1$2.elements[6] *= invSY;
    _m1$2.elements[8] *= invSZ;
    _m1$2.elements[9] *= invSZ;
    _m1$2.elements[10] *= invSZ;
    quaternion2.setFromRotationMatrix(_m1$2);
    scale5.x = sx;
    scale5.y = sy;
    scale5.z = sz;
    return this;
  }
  makePerspective(left, right, top, bottom, near, far) {
    if (far === void 0) {
      console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
    }
    const te = this.elements;
    const x2 = 2 * near / (right - left);
    const y2 = 2 * near / (top - bottom);
    const a2 = (right + left) / (right - left);
    const b2 = (top + bottom) / (top - bottom);
    const c2 = -(far + near) / (far - near);
    const d2 = -2 * far * near / (far - near);
    te[0] = x2;
    te[4] = 0;
    te[8] = a2;
    te[12] = 0;
    te[1] = 0;
    te[5] = y2;
    te[9] = b2;
    te[13] = 0;
    te[2] = 0;
    te[6] = 0;
    te[10] = c2;
    te[14] = d2;
    te[3] = 0;
    te[7] = 0;
    te[11] = -1;
    te[15] = 0;
    return this;
  }
  makeOrthographic(left, right, top, bottom, near, far) {
    const te = this.elements;
    const w2 = 1 / (right - left);
    const h2 = 1 / (top - bottom);
    const p2 = 1 / (far - near);
    const x2 = (right + left) * w2;
    const y2 = (top + bottom) * h2;
    const z2 = (far + near) * p2;
    te[0] = 2 * w2;
    te[4] = 0;
    te[8] = 0;
    te[12] = -x2;
    te[1] = 0;
    te[5] = 2 * h2;
    te[9] = 0;
    te[13] = -y2;
    te[2] = 0;
    te[6] = 0;
    te[10] = -2 * p2;
    te[14] = -z2;
    te[3] = 0;
    te[7] = 0;
    te[11] = 0;
    te[15] = 1;
    return this;
  }
  equals(matrix) {
    const te = this.elements;
    const me = matrix.elements;
    for (let i2 = 0; i2 < 16; i2++) {
      if (te[i2] !== me[i2])
        return false;
    }
    return true;
  }
  fromArray(array2, offset = 0) {
    for (let i2 = 0; i2 < 16; i2++) {
      this.elements[i2] = array2[i2 + offset];
    }
    return this;
  }
  toArray(array2 = [], offset = 0) {
    const te = this.elements;
    array2[offset] = te[0];
    array2[offset + 1] = te[1];
    array2[offset + 2] = te[2];
    array2[offset + 3] = te[3];
    array2[offset + 4] = te[4];
    array2[offset + 5] = te[5];
    array2[offset + 6] = te[6];
    array2[offset + 7] = te[7];
    array2[offset + 8] = te[8];
    array2[offset + 9] = te[9];
    array2[offset + 10] = te[10];
    array2[offset + 11] = te[11];
    array2[offset + 12] = te[12];
    array2[offset + 13] = te[13];
    array2[offset + 14] = te[14];
    array2[offset + 15] = te[15];
    return array2;
  }
};
Matrix4$1.prototype.isMatrix4 = true;
const _v1$5 = /* @__PURE__ */ new Vector3$1();
const _m1$2 = /* @__PURE__ */ new Matrix4$1();
const _zero = /* @__PURE__ */ new Vector3$1(0, 0, 0);
const _one = /* @__PURE__ */ new Vector3$1(1, 1, 1);
const _x = /* @__PURE__ */ new Vector3$1();
const _y = /* @__PURE__ */ new Vector3$1();
const _z = /* @__PURE__ */ new Vector3$1();
const _matrix$1 = /* @__PURE__ */ new Matrix4$1();
const _quaternion$3 = /* @__PURE__ */ new Quaternion$1();
class Euler {
  constructor(x2 = 0, y2 = 0, z2 = 0, order = Euler.DefaultOrder) {
    this._x = x2;
    this._y = y2;
    this._z = z2;
    this._order = order;
  }
  get x() {
    return this._x;
  }
  set x(value) {
    this._x = value;
    this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(value) {
    this._y = value;
    this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(value) {
    this._z = value;
    this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(value) {
    this._order = value;
    this._onChangeCallback();
  }
  set(x2, y2, z2, order = this._order) {
    this._x = x2;
    this._y = y2;
    this._z = z2;
    this._order = order;
    this._onChangeCallback();
    return this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(euler) {
    this._x = euler._x;
    this._y = euler._y;
    this._z = euler._z;
    this._order = euler._order;
    this._onChangeCallback();
    return this;
  }
  setFromRotationMatrix(m2, order = this._order, update = true) {
    const te = m2.elements;
    const m11 = te[0], m12 = te[4], m13 = te[8];
    const m21 = te[1], m22 = te[5], m23 = te[9];
    const m31 = te[2], m32 = te[6], m33 = te[10];
    switch (order) {
      case "XYZ":
        this._y = Math.asin(clamp$5(m13, -1, 1));
        if (Math.abs(m13) < 0.9999999) {
          this._x = Math.atan2(-m23, m33);
          this._z = Math.atan2(-m12, m11);
        } else {
          this._x = Math.atan2(m32, m22);
          this._z = 0;
        }
        break;
      case "YXZ":
        this._x = Math.asin(-clamp$5(m23, -1, 1));
        if (Math.abs(m23) < 0.9999999) {
          this._y = Math.atan2(m13, m33);
          this._z = Math.atan2(m21, m22);
        } else {
          this._y = Math.atan2(-m31, m11);
          this._z = 0;
        }
        break;
      case "ZXY":
        this._x = Math.asin(clamp$5(m32, -1, 1));
        if (Math.abs(m32) < 0.9999999) {
          this._y = Math.atan2(-m31, m33);
          this._z = Math.atan2(-m12, m22);
        } else {
          this._y = 0;
          this._z = Math.atan2(m21, m11);
        }
        break;
      case "ZYX":
        this._y = Math.asin(-clamp$5(m31, -1, 1));
        if (Math.abs(m31) < 0.9999999) {
          this._x = Math.atan2(m32, m33);
          this._z = Math.atan2(m21, m11);
        } else {
          this._x = 0;
          this._z = Math.atan2(-m12, m22);
        }
        break;
      case "YZX":
        this._z = Math.asin(clamp$5(m21, -1, 1));
        if (Math.abs(m21) < 0.9999999) {
          this._x = Math.atan2(-m23, m22);
          this._y = Math.atan2(-m31, m11);
        } else {
          this._x = 0;
          this._y = Math.atan2(m13, m33);
        }
        break;
      case "XZY":
        this._z = Math.asin(-clamp$5(m12, -1, 1));
        if (Math.abs(m12) < 0.9999999) {
          this._x = Math.atan2(m32, m22);
          this._y = Math.atan2(m13, m11);
        } else {
          this._x = Math.atan2(-m23, m33);
          this._y = 0;
        }
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + order);
    }
    this._order = order;
    if (update === true)
      this._onChangeCallback();
    return this;
  }
  setFromQuaternion(q2, order, update) {
    _matrix$1.makeRotationFromQuaternion(q2);
    return this.setFromRotationMatrix(_matrix$1, order, update);
  }
  setFromVector3(v5, order = this._order) {
    return this.set(v5.x, v5.y, v5.z, order);
  }
  reorder(newOrder) {
    _quaternion$3.setFromEuler(this);
    return this.setFromQuaternion(_quaternion$3, newOrder);
  }
  equals(euler) {
    return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
  }
  fromArray(array2) {
    this._x = array2[0];
    this._y = array2[1];
    this._z = array2[2];
    if (array2[3] !== void 0)
      this._order = array2[3];
    this._onChangeCallback();
    return this;
  }
  toArray(array2 = [], offset = 0) {
    array2[offset] = this._x;
    array2[offset + 1] = this._y;
    array2[offset + 2] = this._z;
    array2[offset + 3] = this._order;
    return array2;
  }
  _onChange(callback) {
    this._onChangeCallback = callback;
    return this;
  }
  _onChangeCallback() {
  }
}
Euler.prototype.isEuler = true;
Euler.DefaultOrder = "XYZ";
Euler.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];
class Layers {
  constructor() {
    this.mask = 1 | 0;
  }
  set(channel) {
    this.mask = (1 << channel | 0) >>> 0;
  }
  enable(channel) {
    this.mask |= 1 << channel | 0;
  }
  enableAll() {
    this.mask = 4294967295 | 0;
  }
  toggle(channel) {
    this.mask ^= 1 << channel | 0;
  }
  disable(channel) {
    this.mask &= ~(1 << channel | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(layers) {
    return (this.mask & layers.mask) !== 0;
  }
  isEnabled(channel) {
    return (this.mask & (1 << channel | 0)) !== 0;
  }
}
let _object3DId = 0;
const _v1$4 = /* @__PURE__ */ new Vector3$1();
const _q1 = /* @__PURE__ */ new Quaternion$1();
const _m1$1 = /* @__PURE__ */ new Matrix4$1();
const _target = /* @__PURE__ */ new Vector3$1();
const _position$3 = /* @__PURE__ */ new Vector3$1();
const _scale$2 = /* @__PURE__ */ new Vector3$1();
const _quaternion$2 = /* @__PURE__ */ new Quaternion$1();
const _xAxis = /* @__PURE__ */ new Vector3$1(1, 0, 0);
const _yAxis = /* @__PURE__ */ new Vector3$1(0, 1, 0);
const _zAxis = /* @__PURE__ */ new Vector3$1(0, 0, 1);
const _addedEvent = { type: "added" };
const _removedEvent = { type: "removed" };
class Object3D extends EventDispatcher$1 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: _object3DId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.type = "Object3D";
    this.parent = null;
    this.children = [];
    this.up = Object3D.DefaultUp.clone();
    const position = new Vector3$1();
    const rotation = new Euler();
    const quaternion2 = new Quaternion$1();
    const scale5 = new Vector3$1(1, 1, 1);
    function onRotationChange() {
      quaternion2.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
      rotation.setFromQuaternion(quaternion2, void 0, false);
    }
    rotation._onChange(onRotationChange);
    quaternion2._onChange(onQuaternionChange);
    Object.defineProperties(this, {
      position: {
        configurable: true,
        enumerable: true,
        value: position
      },
      rotation: {
        configurable: true,
        enumerable: true,
        value: rotation
      },
      quaternion: {
        configurable: true,
        enumerable: true,
        value: quaternion2
      },
      scale: {
        configurable: true,
        enumerable: true,
        value: scale5
      },
      modelViewMatrix: {
        value: new Matrix4$1()
      },
      normalMatrix: {
        value: new Matrix3$1()
      }
    });
    this.matrix = new Matrix4$1();
    this.matrixWorld = new Matrix4$1();
    this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.userData = {};
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(matrix) {
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    this.matrix.premultiply(matrix);
    this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(q2) {
    this.quaternion.premultiply(q2);
    return this;
  }
  setRotationFromAxisAngle(axis, angle4) {
    this.quaternion.setFromAxisAngle(axis, angle4);
  }
  setRotationFromEuler(euler) {
    this.quaternion.setFromEuler(euler, true);
  }
  setRotationFromMatrix(m2) {
    this.quaternion.setFromRotationMatrix(m2);
  }
  setRotationFromQuaternion(q2) {
    this.quaternion.copy(q2);
  }
  rotateOnAxis(axis, angle4) {
    _q1.setFromAxisAngle(axis, angle4);
    this.quaternion.multiply(_q1);
    return this;
  }
  rotateOnWorldAxis(axis, angle4) {
    _q1.setFromAxisAngle(axis, angle4);
    this.quaternion.premultiply(_q1);
    return this;
  }
  rotateX(angle4) {
    return this.rotateOnAxis(_xAxis, angle4);
  }
  rotateY(angle4) {
    return this.rotateOnAxis(_yAxis, angle4);
  }
  rotateZ(angle4) {
    return this.rotateOnAxis(_zAxis, angle4);
  }
  translateOnAxis(axis, distance11) {
    _v1$4.copy(axis).applyQuaternion(this.quaternion);
    this.position.add(_v1$4.multiplyScalar(distance11));
    return this;
  }
  translateX(distance11) {
    return this.translateOnAxis(_xAxis, distance11);
  }
  translateY(distance11) {
    return this.translateOnAxis(_yAxis, distance11);
  }
  translateZ(distance11) {
    return this.translateOnAxis(_zAxis, distance11);
  }
  localToWorld(vector) {
    return vector.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(vector) {
    return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
  }
  lookAt(x2, y2, z2) {
    if (x2.isVector3) {
      _target.copy(x2);
    } else {
      _target.set(x2, y2, z2);
    }
    const parent = this.parent;
    this.updateWorldMatrix(true, false);
    _position$3.setFromMatrixPosition(this.matrixWorld);
    if (this.isCamera || this.isLight) {
      _m1$1.lookAt(_position$3, _target, this.up);
    } else {
      _m1$1.lookAt(_target, _position$3, this.up);
    }
    this.quaternion.setFromRotationMatrix(_m1$1);
    if (parent) {
      _m1$1.extractRotation(parent.matrixWorld);
      _q1.setFromRotationMatrix(_m1$1);
      this.quaternion.premultiply(_q1.invert());
    }
  }
  add(object2) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.add(arguments[i2]);
      }
      return this;
    }
    if (object2 === this) {
      console.error("THREE.Object3D.add: object can't be added as a child of itself.", object2);
      return this;
    }
    if (object2 && object2.isObject3D) {
      if (object2.parent !== null) {
        object2.parent.remove(object2);
      }
      object2.parent = this;
      this.children.push(object2);
      object2.dispatchEvent(_addedEvent);
    } else {
      console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", object2);
    }
    return this;
  }
  remove(object2) {
    if (arguments.length > 1) {
      for (let i2 = 0; i2 < arguments.length; i2++) {
        this.remove(arguments[i2]);
      }
      return this;
    }
    const index2 = this.children.indexOf(object2);
    if (index2 !== -1) {
      object2.parent = null;
      this.children.splice(index2, 1);
      object2.dispatchEvent(_removedEvent);
    }
    return this;
  }
  removeFromParent() {
    const parent = this.parent;
    if (parent !== null) {
      parent.remove(this);
    }
    return this;
  }
  clear() {
    for (let i2 = 0; i2 < this.children.length; i2++) {
      const object2 = this.children[i2];
      object2.parent = null;
      object2.dispatchEvent(_removedEvent);
    }
    this.children.length = 0;
    return this;
  }
  attach(object2) {
    this.updateWorldMatrix(true, false);
    _m1$1.copy(this.matrixWorld).invert();
    if (object2.parent !== null) {
      object2.parent.updateWorldMatrix(true, false);
      _m1$1.multiply(object2.parent.matrixWorld);
    }
    object2.applyMatrix4(_m1$1);
    this.add(object2);
    object2.updateWorldMatrix(false, true);
    return this;
  }
  getObjectById(id) {
    return this.getObjectByProperty("id", id);
  }
  getObjectByName(name2) {
    return this.getObjectByProperty("name", name2);
  }
  getObjectByProperty(name2, value) {
    if (this[name2] === value)
      return this;
    for (let i2 = 0, l2 = this.children.length; i2 < l2; i2++) {
      const child = this.children[i2];
      const object2 = child.getObjectByProperty(name2, value);
      if (object2 !== void 0) {
        return object2;
      }
    }
    return void 0;
  }
  getWorldPosition(target) {
    this.updateWorldMatrix(true, false);
    return target.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, target, _scale$2);
    return target;
  }
  getWorldScale(target) {
    this.updateWorldMatrix(true, false);
    this.matrixWorld.decompose(_position$3, _quaternion$2, target);
    return target;
  }
  getWorldDirection(target) {
    this.updateWorldMatrix(true, false);
    const e3 = this.matrixWorld.elements;
    return target.set(e3[8], e3[9], e3[10]).normalize();
  }
  raycast() {
  }
  traverse(callback) {
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverse(callback);
    }
  }
  traverseVisible(callback) {
    if (this.visible === false)
      return;
    callback(this);
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].traverseVisible(callback);
    }
  }
  traverseAncestors(callback) {
    const parent = this.parent;
    if (parent !== null) {
      callback(parent);
      parent.traverseAncestors(callback);
    }
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale);
    this.matrixWorldNeedsUpdate = true;
  }
  updateMatrixWorld(force) {
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    if (this.matrixWorldNeedsUpdate || force) {
      if (this.parent === null) {
        this.matrixWorld.copy(this.matrix);
      } else {
        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
      }
      this.matrixWorldNeedsUpdate = false;
      force = true;
    }
    const children = this.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      children[i2].updateMatrixWorld(force);
    }
  }
  updateWorldMatrix(updateParents, updateChildren) {
    const parent = this.parent;
    if (updateParents === true && parent !== null) {
      parent.updateWorldMatrix(true, false);
    }
    if (this.matrixAutoUpdate)
      this.updateMatrix();
    if (this.parent === null) {
      this.matrixWorld.copy(this.matrix);
    } else {
      this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
    }
    if (updateChildren === true) {
      const children = this.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        children[i2].updateWorldMatrix(false, true);
      }
    }
  }
  toJSON(meta2) {
    const isRootObject = meta2 === void 0 || typeof meta2 === "string";
    const output2 = {};
    if (isRootObject) {
      meta2 = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {}
      };
      output2.metadata = {
        version: 4.5,
        type: "Object",
        generator: "Object3D.toJSON"
      };
    }
    const object2 = {};
    object2.uuid = this.uuid;
    object2.type = this.type;
    if (this.name !== "")
      object2.name = this.name;
    if (this.castShadow === true)
      object2.castShadow = true;
    if (this.receiveShadow === true)
      object2.receiveShadow = true;
    if (this.visible === false)
      object2.visible = false;
    if (this.frustumCulled === false)
      object2.frustumCulled = false;
    if (this.renderOrder !== 0)
      object2.renderOrder = this.renderOrder;
    if (JSON.stringify(this.userData) !== "{}")
      object2.userData = this.userData;
    object2.layers = this.layers.mask;
    object2.matrix = this.matrix.toArray();
    if (this.matrixAutoUpdate === false)
      object2.matrixAutoUpdate = false;
    if (this.isInstancedMesh) {
      object2.type = "InstancedMesh";
      object2.count = this.count;
      object2.instanceMatrix = this.instanceMatrix.toJSON();
      if (this.instanceColor !== null)
        object2.instanceColor = this.instanceColor.toJSON();
    }
    function serialize(library, element) {
      if (library[element.uuid] === void 0) {
        library[element.uuid] = element.toJSON(meta2);
      }
      return element.uuid;
    }
    if (this.isScene) {
      if (this.background) {
        if (this.background.isColor) {
          object2.background = this.background.toJSON();
        } else if (this.background.isTexture) {
          object2.background = this.background.toJSON(meta2).uuid;
        }
      }
      if (this.environment && this.environment.isTexture) {
        object2.environment = this.environment.toJSON(meta2).uuid;
      }
    } else if (this.isMesh || this.isLine || this.isPoints) {
      object2.geometry = serialize(meta2.geometries, this.geometry);
      const parameters = this.geometry.parameters;
      if (parameters !== void 0 && parameters.shapes !== void 0) {
        const shapes = parameters.shapes;
        if (Array.isArray(shapes)) {
          for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
            const shape2 = shapes[i2];
            serialize(meta2.shapes, shape2);
          }
        } else {
          serialize(meta2.shapes, shapes);
        }
      }
    }
    if (this.isSkinnedMesh) {
      object2.bindMode = this.bindMode;
      object2.bindMatrix = this.bindMatrix.toArray();
      if (this.skeleton !== void 0) {
        serialize(meta2.skeletons, this.skeleton);
        object2.skeleton = this.skeleton.uuid;
      }
    }
    if (this.material !== void 0) {
      if (Array.isArray(this.material)) {
        const uuids = [];
        for (let i2 = 0, l2 = this.material.length; i2 < l2; i2++) {
          uuids.push(serialize(meta2.materials, this.material[i2]));
        }
        object2.material = uuids;
      } else {
        object2.material = serialize(meta2.materials, this.material);
      }
    }
    if (this.children.length > 0) {
      object2.children = [];
      for (let i2 = 0; i2 < this.children.length; i2++) {
        object2.children.push(this.children[i2].toJSON(meta2).object);
      }
    }
    if (this.animations.length > 0) {
      object2.animations = [];
      for (let i2 = 0; i2 < this.animations.length; i2++) {
        const animation = this.animations[i2];
        object2.animations.push(serialize(meta2.animations, animation));
      }
    }
    if (isRootObject) {
      const geometries = extractFromCache(meta2.geometries);
      const materials = extractFromCache(meta2.materials);
      const textures = extractFromCache(meta2.textures);
      const images = extractFromCache(meta2.images);
      const shapes = extractFromCache(meta2.shapes);
      const skeletons = extractFromCache(meta2.skeletons);
      const animations = extractFromCache(meta2.animations);
      const nodes = extractFromCache(meta2.nodes);
      if (geometries.length > 0)
        output2.geometries = geometries;
      if (materials.length > 0)
        output2.materials = materials;
      if (textures.length > 0)
        output2.textures = textures;
      if (images.length > 0)
        output2.images = images;
      if (shapes.length > 0)
        output2.shapes = shapes;
      if (skeletons.length > 0)
        output2.skeletons = skeletons;
      if (animations.length > 0)
        output2.animations = animations;
      if (nodes.length > 0)
        output2.nodes = nodes;
    }
    output2.object = object2;
    return output2;
    function extractFromCache(cache2) {
      const values4 = [];
      for (const key in cache2) {
        const data2 = cache2[key];
        delete data2.metadata;
        values4.push(data2);
      }
      return values4;
    }
  }
  clone(recursive) {
    return new this.constructor().copy(this, recursive);
  }
  copy(source, recursive = true) {
    this.name = source.name;
    this.up.copy(source.up);
    this.position.copy(source.position);
    this.rotation.order = source.rotation.order;
    this.quaternion.copy(source.quaternion);
    this.scale.copy(source.scale);
    this.matrix.copy(source.matrix);
    this.matrixWorld.copy(source.matrixWorld);
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
    this.layers.mask = source.layers.mask;
    this.visible = source.visible;
    this.castShadow = source.castShadow;
    this.receiveShadow = source.receiveShadow;
    this.frustumCulled = source.frustumCulled;
    this.renderOrder = source.renderOrder;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    if (recursive === true) {
      for (let i2 = 0; i2 < source.children.length; i2++) {
        const child = source.children[i2];
        this.add(child.clone());
      }
    }
    return this;
  }
}
Object3D.DefaultUp = new Vector3$1(0, 1, 0);
Object3D.DefaultMatrixAutoUpdate = true;
Object3D.prototype.isObject3D = true;
const _v0$1 = /* @__PURE__ */ new Vector3$1();
const _v1$3 = /* @__PURE__ */ new Vector3$1();
const _v2$2 = /* @__PURE__ */ new Vector3$1();
const _v3$1 = /* @__PURE__ */ new Vector3$1();
const _vab = /* @__PURE__ */ new Vector3$1();
const _vac = /* @__PURE__ */ new Vector3$1();
const _vbc = /* @__PURE__ */ new Vector3$1();
const _vap = /* @__PURE__ */ new Vector3$1();
const _vbp = /* @__PURE__ */ new Vector3$1();
const _vcp = /* @__PURE__ */ new Vector3$1();
class Triangle {
  constructor(a2 = new Vector3$1(), b2 = new Vector3$1(), c2 = new Vector3$1()) {
    this.a = a2;
    this.b = b2;
    this.c = c2;
  }
  static getNormal(a2, b2, c2, target) {
    target.subVectors(c2, b2);
    _v0$1.subVectors(a2, b2);
    target.cross(_v0$1);
    const targetLengthSq = target.lengthSq();
    if (targetLengthSq > 0) {
      return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
    }
    return target.set(0, 0, 0);
  }
  // static/instance method to calculate barycentric coordinates
  // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
  static getBarycoord(point4, a2, b2, c2, target) {
    _v0$1.subVectors(c2, a2);
    _v1$3.subVectors(b2, a2);
    _v2$2.subVectors(point4, a2);
    const dot00 = _v0$1.dot(_v0$1);
    const dot01 = _v0$1.dot(_v1$3);
    const dot02 = _v0$1.dot(_v2$2);
    const dot11 = _v1$3.dot(_v1$3);
    const dot12 = _v1$3.dot(_v2$2);
    const denom = dot00 * dot11 - dot01 * dot01;
    if (denom === 0) {
      return target.set(-2, -1, -1);
    }
    const invDenom = 1 / denom;
    const u2 = (dot11 * dot02 - dot01 * dot12) * invDenom;
    const v5 = (dot00 * dot12 - dot01 * dot02) * invDenom;
    return target.set(1 - u2 - v5, v5, u2);
  }
  static containsPoint(point4, a2, b2, c2) {
    this.getBarycoord(point4, a2, b2, c2, _v3$1);
    return _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
  }
  static getUV(point4, p1, p2, p3, uv1, uv2, uv3, target) {
    this.getBarycoord(point4, p1, p2, p3, _v3$1);
    target.set(0, 0);
    target.addScaledVector(uv1, _v3$1.x);
    target.addScaledVector(uv2, _v3$1.y);
    target.addScaledVector(uv3, _v3$1.z);
    return target;
  }
  static isFrontFacing(a2, b2, c2, direction) {
    _v0$1.subVectors(c2, b2);
    _v1$3.subVectors(a2, b2);
    return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
  }
  set(a2, b2, c2) {
    this.a.copy(a2);
    this.b.copy(b2);
    this.c.copy(c2);
    return this;
  }
  setFromPointsAndIndices(points2, i0, i1, i2) {
    this.a.copy(points2[i0]);
    this.b.copy(points2[i1]);
    this.c.copy(points2[i2]);
    return this;
  }
  setFromAttributeAndIndices(attribute, i0, i1, i2) {
    this.a.fromBufferAttribute(attribute, i0);
    this.b.fromBufferAttribute(attribute, i1);
    this.c.fromBufferAttribute(attribute, i2);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(triangle) {
    this.a.copy(triangle.a);
    this.b.copy(triangle.b);
    this.c.copy(triangle.c);
    return this;
  }
  getArea() {
    _v0$1.subVectors(this.c, this.b);
    _v1$3.subVectors(this.a, this.b);
    return _v0$1.cross(_v1$3).length() * 0.5;
  }
  getMidpoint(target) {
    return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(target) {
    return Triangle.getNormal(this.a, this.b, this.c, target);
  }
  getPlane(target) {
    return target.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(point4, target) {
    return Triangle.getBarycoord(point4, this.a, this.b, this.c, target);
  }
  getUV(point4, uv1, uv2, uv3, target) {
    return Triangle.getUV(point4, this.a, this.b, this.c, uv1, uv2, uv3, target);
  }
  containsPoint(point4) {
    return Triangle.containsPoint(point4, this.a, this.b, this.c);
  }
  isFrontFacing(direction) {
    return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
  }
  intersectsBox(box) {
    return box.intersectsTriangle(this);
  }
  closestPointToPoint(p2, target) {
    const a2 = this.a, b2 = this.b, c2 = this.c;
    let v5, w2;
    _vab.subVectors(b2, a2);
    _vac.subVectors(c2, a2);
    _vap.subVectors(p2, a2);
    const d1 = _vab.dot(_vap);
    const d2 = _vac.dot(_vap);
    if (d1 <= 0 && d2 <= 0) {
      return target.copy(a2);
    }
    _vbp.subVectors(p2, b2);
    const d3 = _vab.dot(_vbp);
    const d4 = _vac.dot(_vbp);
    if (d3 >= 0 && d4 <= d3) {
      return target.copy(b2);
    }
    const vc = d1 * d4 - d3 * d2;
    if (vc <= 0 && d1 >= 0 && d3 <= 0) {
      v5 = d1 / (d1 - d3);
      return target.copy(a2).addScaledVector(_vab, v5);
    }
    _vcp.subVectors(p2, c2);
    const d5 = _vab.dot(_vcp);
    const d6 = _vac.dot(_vcp);
    if (d6 >= 0 && d5 <= d6) {
      return target.copy(c2);
    }
    const vb = d5 * d2 - d1 * d6;
    if (vb <= 0 && d2 >= 0 && d6 <= 0) {
      w2 = d2 / (d2 - d6);
      return target.copy(a2).addScaledVector(_vac, w2);
    }
    const va = d3 * d6 - d5 * d4;
    if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
      _vbc.subVectors(c2, b2);
      w2 = (d4 - d3) / (d4 - d3 + (d5 - d6));
      return target.copy(b2).addScaledVector(_vbc, w2);
    }
    const denom = 1 / (va + vb + vc);
    v5 = vb * denom;
    w2 = vc * denom;
    return target.copy(a2).addScaledVector(_vab, v5).addScaledVector(_vac, w2);
  }
  equals(triangle) {
    return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
  }
}
let materialId = 0;
let Material$1 = class Material2 extends EventDispatcher$1 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: materialId++ });
    this.uuid = generateUUID();
    this.name = "";
    this.type = "Material";
    this.fog = true;
    this.blending = NormalBlending;
    this.side = FrontSide;
    this.vertexColors = false;
    this.opacity = 1;
    this.transparent = false;
    this.blendSrc = SrcAlphaFactor;
    this.blendDst = OneMinusSrcAlphaFactor;
    this.blendEquation = AddEquation;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.depthFunc = LessEqualDepth;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 255;
    this.stencilFunc = AlwaysStencilFunc;
    this.stencilRef = 0;
    this.stencilFuncMask = 255;
    this.stencilFail = KeepStencilOp;
    this.stencilZFail = KeepStencilOp;
    this.stencilZPass = KeepStencilOp;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null;
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaToCoverage = false;
    this.premultipliedAlpha = false;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
    this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(value) {
    if (this._alphaTest > 0 !== value > 0) {
      this.version++;
    }
    this._alphaTest = value;
  }
  onBuild() {
  }
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(values4) {
    if (values4 === void 0)
      return;
    for (const key in values4) {
      const newValue = values4[key];
      if (newValue === void 0) {
        console.warn("THREE.Material: '" + key + "' parameter is undefined.");
        continue;
      }
      if (key === "shading") {
        console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
        this.flatShading = newValue === FlatShading ? true : false;
        continue;
      }
      const currentValue = this[key];
      if (currentValue === void 0) {
        console.warn("THREE." + this.type + ": '" + key + "' is not a property of this material.");
        continue;
      }
      if (currentValue && currentValue.isColor) {
        currentValue.set(newValue);
      } else if (currentValue && currentValue.isVector3 && (newValue && newValue.isVector3)) {
        currentValue.copy(newValue);
      } else {
        this[key] = newValue;
      }
    }
  }
  toJSON(meta2) {
    const isRootObject = meta2 === void 0 || typeof meta2 === "string";
    if (isRootObject) {
      meta2 = {
        textures: {},
        images: {}
      };
    }
    const data2 = {
      metadata: {
        version: 4.5,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    data2.uuid = this.uuid;
    data2.type = this.type;
    if (this.name !== "")
      data2.name = this.name;
    if (this.color && this.color.isColor)
      data2.color = this.color.getHex();
    if (this.roughness !== void 0)
      data2.roughness = this.roughness;
    if (this.metalness !== void 0)
      data2.metalness = this.metalness;
    if (this.sheen !== void 0)
      data2.sheen = this.sheen;
    if (this.sheenColor && this.sheenColor.isColor)
      data2.sheenColor = this.sheenColor.getHex();
    if (this.sheenRoughness !== void 0)
      data2.sheenRoughness = this.sheenRoughness;
    if (this.emissive && this.emissive.isColor)
      data2.emissive = this.emissive.getHex();
    if (this.emissiveIntensity && this.emissiveIntensity !== 1)
      data2.emissiveIntensity = this.emissiveIntensity;
    if (this.specular && this.specular.isColor)
      data2.specular = this.specular.getHex();
    if (this.specularIntensity !== void 0)
      data2.specularIntensity = this.specularIntensity;
    if (this.specularColor && this.specularColor.isColor)
      data2.specularColor = this.specularColor.getHex();
    if (this.shininess !== void 0)
      data2.shininess = this.shininess;
    if (this.clearcoat !== void 0)
      data2.clearcoat = this.clearcoat;
    if (this.clearcoatRoughness !== void 0)
      data2.clearcoatRoughness = this.clearcoatRoughness;
    if (this.clearcoatMap && this.clearcoatMap.isTexture) {
      data2.clearcoatMap = this.clearcoatMap.toJSON(meta2).uuid;
    }
    if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
      data2.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta2).uuid;
    }
    if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
      data2.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta2).uuid;
      data2.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
    }
    if (this.map && this.map.isTexture)
      data2.map = this.map.toJSON(meta2).uuid;
    if (this.matcap && this.matcap.isTexture)
      data2.matcap = this.matcap.toJSON(meta2).uuid;
    if (this.alphaMap && this.alphaMap.isTexture)
      data2.alphaMap = this.alphaMap.toJSON(meta2).uuid;
    if (this.lightMap && this.lightMap.isTexture) {
      data2.lightMap = this.lightMap.toJSON(meta2).uuid;
      data2.lightMapIntensity = this.lightMapIntensity;
    }
    if (this.aoMap && this.aoMap.isTexture) {
      data2.aoMap = this.aoMap.toJSON(meta2).uuid;
      data2.aoMapIntensity = this.aoMapIntensity;
    }
    if (this.bumpMap && this.bumpMap.isTexture) {
      data2.bumpMap = this.bumpMap.toJSON(meta2).uuid;
      data2.bumpScale = this.bumpScale;
    }
    if (this.normalMap && this.normalMap.isTexture) {
      data2.normalMap = this.normalMap.toJSON(meta2).uuid;
      data2.normalMapType = this.normalMapType;
      data2.normalScale = this.normalScale.toArray();
    }
    if (this.displacementMap && this.displacementMap.isTexture) {
      data2.displacementMap = this.displacementMap.toJSON(meta2).uuid;
      data2.displacementScale = this.displacementScale;
      data2.displacementBias = this.displacementBias;
    }
    if (this.roughnessMap && this.roughnessMap.isTexture)
      data2.roughnessMap = this.roughnessMap.toJSON(meta2).uuid;
    if (this.metalnessMap && this.metalnessMap.isTexture)
      data2.metalnessMap = this.metalnessMap.toJSON(meta2).uuid;
    if (this.emissiveMap && this.emissiveMap.isTexture)
      data2.emissiveMap = this.emissiveMap.toJSON(meta2).uuid;
    if (this.specularMap && this.specularMap.isTexture)
      data2.specularMap = this.specularMap.toJSON(meta2).uuid;
    if (this.specularIntensityMap && this.specularIntensityMap.isTexture)
      data2.specularIntensityMap = this.specularIntensityMap.toJSON(meta2).uuid;
    if (this.specularColorMap && this.specularColorMap.isTexture)
      data2.specularColorMap = this.specularColorMap.toJSON(meta2).uuid;
    if (this.envMap && this.envMap.isTexture) {
      data2.envMap = this.envMap.toJSON(meta2).uuid;
      if (this.combine !== void 0)
        data2.combine = this.combine;
    }
    if (this.envMapIntensity !== void 0)
      data2.envMapIntensity = this.envMapIntensity;
    if (this.reflectivity !== void 0)
      data2.reflectivity = this.reflectivity;
    if (this.refractionRatio !== void 0)
      data2.refractionRatio = this.refractionRatio;
    if (this.gradientMap && this.gradientMap.isTexture) {
      data2.gradientMap = this.gradientMap.toJSON(meta2).uuid;
    }
    if (this.transmission !== void 0)
      data2.transmission = this.transmission;
    if (this.transmissionMap && this.transmissionMap.isTexture)
      data2.transmissionMap = this.transmissionMap.toJSON(meta2).uuid;
    if (this.thickness !== void 0)
      data2.thickness = this.thickness;
    if (this.thicknessMap && this.thicknessMap.isTexture)
      data2.thicknessMap = this.thicknessMap.toJSON(meta2).uuid;
    if (this.attenuationDistance !== void 0)
      data2.attenuationDistance = this.attenuationDistance;
    if (this.attenuationColor !== void 0)
      data2.attenuationColor = this.attenuationColor.getHex();
    if (this.size !== void 0)
      data2.size = this.size;
    if (this.shadowSide !== null)
      data2.shadowSide = this.shadowSide;
    if (this.sizeAttenuation !== void 0)
      data2.sizeAttenuation = this.sizeAttenuation;
    if (this.blending !== NormalBlending)
      data2.blending = this.blending;
    if (this.side !== FrontSide)
      data2.side = this.side;
    if (this.vertexColors)
      data2.vertexColors = true;
    if (this.opacity < 1)
      data2.opacity = this.opacity;
    if (this.transparent === true)
      data2.transparent = this.transparent;
    data2.depthFunc = this.depthFunc;
    data2.depthTest = this.depthTest;
    data2.depthWrite = this.depthWrite;
    data2.colorWrite = this.colorWrite;
    data2.stencilWrite = this.stencilWrite;
    data2.stencilWriteMask = this.stencilWriteMask;
    data2.stencilFunc = this.stencilFunc;
    data2.stencilRef = this.stencilRef;
    data2.stencilFuncMask = this.stencilFuncMask;
    data2.stencilFail = this.stencilFail;
    data2.stencilZFail = this.stencilZFail;
    data2.stencilZPass = this.stencilZPass;
    if (this.rotation !== void 0 && this.rotation !== 0)
      data2.rotation = this.rotation;
    if (this.polygonOffset === true)
      data2.polygonOffset = true;
    if (this.polygonOffsetFactor !== 0)
      data2.polygonOffsetFactor = this.polygonOffsetFactor;
    if (this.polygonOffsetUnits !== 0)
      data2.polygonOffsetUnits = this.polygonOffsetUnits;
    if (this.linewidth !== void 0 && this.linewidth !== 1)
      data2.linewidth = this.linewidth;
    if (this.dashSize !== void 0)
      data2.dashSize = this.dashSize;
    if (this.gapSize !== void 0)
      data2.gapSize = this.gapSize;
    if (this.scale !== void 0)
      data2.scale = this.scale;
    if (this.dithering === true)
      data2.dithering = true;
    if (this.alphaTest > 0)
      data2.alphaTest = this.alphaTest;
    if (this.alphaToCoverage === true)
      data2.alphaToCoverage = this.alphaToCoverage;
    if (this.premultipliedAlpha === true)
      data2.premultipliedAlpha = this.premultipliedAlpha;
    if (this.wireframe === true)
      data2.wireframe = this.wireframe;
    if (this.wireframeLinewidth > 1)
      data2.wireframeLinewidth = this.wireframeLinewidth;
    if (this.wireframeLinecap !== "round")
      data2.wireframeLinecap = this.wireframeLinecap;
    if (this.wireframeLinejoin !== "round")
      data2.wireframeLinejoin = this.wireframeLinejoin;
    if (this.flatShading === true)
      data2.flatShading = this.flatShading;
    if (this.visible === false)
      data2.visible = false;
    if (this.toneMapped === false)
      data2.toneMapped = false;
    if (JSON.stringify(this.userData) !== "{}")
      data2.userData = this.userData;
    function extractFromCache(cache2) {
      const values4 = [];
      for (const key in cache2) {
        const data3 = cache2[key];
        delete data3.metadata;
        values4.push(data3);
      }
      return values4;
    }
    if (isRootObject) {
      const textures = extractFromCache(meta2.textures);
      const images = extractFromCache(meta2.images);
      if (textures.length > 0)
        data2.textures = textures;
      if (images.length > 0)
        data2.images = images;
    }
    return data2;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.name = source.name;
    this.fog = source.fog;
    this.blending = source.blending;
    this.side = source.side;
    this.vertexColors = source.vertexColors;
    this.opacity = source.opacity;
    this.transparent = source.transparent;
    this.blendSrc = source.blendSrc;
    this.blendDst = source.blendDst;
    this.blendEquation = source.blendEquation;
    this.blendSrcAlpha = source.blendSrcAlpha;
    this.blendDstAlpha = source.blendDstAlpha;
    this.blendEquationAlpha = source.blendEquationAlpha;
    this.depthFunc = source.depthFunc;
    this.depthTest = source.depthTest;
    this.depthWrite = source.depthWrite;
    this.stencilWriteMask = source.stencilWriteMask;
    this.stencilFunc = source.stencilFunc;
    this.stencilRef = source.stencilRef;
    this.stencilFuncMask = source.stencilFuncMask;
    this.stencilFail = source.stencilFail;
    this.stencilZFail = source.stencilZFail;
    this.stencilZPass = source.stencilZPass;
    this.stencilWrite = source.stencilWrite;
    const srcPlanes = source.clippingPlanes;
    let dstPlanes = null;
    if (srcPlanes !== null) {
      const n2 = srcPlanes.length;
      dstPlanes = new Array(n2);
      for (let i2 = 0; i2 !== n2; ++i2) {
        dstPlanes[i2] = srcPlanes[i2].clone();
      }
    }
    this.clippingPlanes = dstPlanes;
    this.clipIntersection = source.clipIntersection;
    this.clipShadows = source.clipShadows;
    this.shadowSide = source.shadowSide;
    this.colorWrite = source.colorWrite;
    this.precision = source.precision;
    this.polygonOffset = source.polygonOffset;
    this.polygonOffsetFactor = source.polygonOffsetFactor;
    this.polygonOffsetUnits = source.polygonOffsetUnits;
    this.dithering = source.dithering;
    this.alphaTest = source.alphaTest;
    this.alphaToCoverage = source.alphaToCoverage;
    this.premultipliedAlpha = source.premultipliedAlpha;
    this.visible = source.visible;
    this.toneMapped = source.toneMapped;
    this.userData = JSON.parse(JSON.stringify(source.userData));
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
};
Material$1.prototype.isMaterial = true;
Material$1.fromType = function() {
  return null;
};
class MeshBasicMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "MeshBasicMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    return this;
  }
}
MeshBasicMaterial.prototype.isMeshBasicMaterial = true;
const _vector$9 = /* @__PURE__ */ new Vector3$1();
const _vector2$1 = /* @__PURE__ */ new Vector2$1();
class BufferAttribute {
  constructor(array2, itemSize, normalized) {
    if (Array.isArray(array2)) {
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    }
    this.name = "";
    this.array = array2;
    this.itemSize = itemSize;
    this.count = array2 !== void 0 ? array2.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.updateRange = { offset: 0, count: -1 };
    this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  copy(source) {
    this.name = source.name;
    this.array = new source.array.constructor(source.array);
    this.itemSize = source.itemSize;
    this.count = source.count;
    this.normalized = source.normalized;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.itemSize;
    index2 *= attribute.itemSize;
    for (let i2 = 0, l2 = this.itemSize; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  copyArray(array2) {
    this.array.set(array2);
    return this;
  }
  copyColorsArray(colors) {
    const array2 = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = colors.length; i2 < l2; i2++) {
      let color = colors[i2];
      if (color === void 0) {
        console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", i2);
        color = new Color();
      }
      array2[offset++] = color.r;
      array2[offset++] = color.g;
      array2[offset++] = color.b;
    }
    return this;
  }
  copyVector2sArray(vectors) {
    const array2 = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = vectors.length; i2 < l2; i2++) {
      let vector = vectors[i2];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", i2);
        vector = new Vector2$1();
      }
      array2[offset++] = vector.x;
      array2[offset++] = vector.y;
    }
    return this;
  }
  copyVector3sArray(vectors) {
    const array2 = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = vectors.length; i2 < l2; i2++) {
      let vector = vectors[i2];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", i2);
        vector = new Vector3$1();
      }
      array2[offset++] = vector.x;
      array2[offset++] = vector.y;
      array2[offset++] = vector.z;
    }
    return this;
  }
  copyVector4sArray(vectors) {
    const array2 = this.array;
    let offset = 0;
    for (let i2 = 0, l2 = vectors.length; i2 < l2; i2++) {
      let vector = vectors[i2];
      if (vector === void 0) {
        console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", i2);
        vector = new Vector4$1();
      }
      array2[offset++] = vector.x;
      array2[offset++] = vector.y;
      array2[offset++] = vector.z;
      array2[offset++] = vector.w;
    }
    return this;
  }
  applyMatrix3(m2) {
    if (this.itemSize === 2) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector2$1.fromBufferAttribute(this, i2);
        _vector2$1.applyMatrix3(m2);
        this.setXY(i2, _vector2$1.x, _vector2$1.y);
      }
    } else if (this.itemSize === 3) {
      for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
        _vector$9.fromBufferAttribute(this, i2);
        _vector$9.applyMatrix3(m2);
        this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
      }
    }
    return this;
  }
  applyMatrix4(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.fromBufferAttribute(this, i2);
      _vector$9.applyMatrix4(m2);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  applyNormalMatrix(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.fromBufferAttribute(this, i2);
      _vector$9.applyNormalMatrix(m2);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  transformDirection(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$9.fromBufferAttribute(this, i2);
      _vector$9.transformDirection(m2);
      this.setXYZ(i2, _vector$9.x, _vector$9.y, _vector$9.z);
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  getX(index2) {
    return this.array[index2 * this.itemSize];
  }
  setX(index2, x2) {
    this.array[index2 * this.itemSize] = x2;
    return this;
  }
  getY(index2) {
    return this.array[index2 * this.itemSize + 1];
  }
  setY(index2, y2) {
    this.array[index2 * this.itemSize + 1] = y2;
    return this;
  }
  getZ(index2) {
    return this.array[index2 * this.itemSize + 2];
  }
  setZ(index2, z2) {
    this.array[index2 * this.itemSize + 2] = z2;
    return this;
  }
  getW(index2) {
    return this.array[index2 * this.itemSize + 3];
  }
  setW(index2, w2) {
    this.array[index2 * this.itemSize + 3] = w2;
    return this;
  }
  setXY(index2, x2, y2) {
    index2 *= this.itemSize;
    this.array[index2 + 0] = x2;
    this.array[index2 + 1] = y2;
    return this;
  }
  setXYZ(index2, x2, y2, z2) {
    index2 *= this.itemSize;
    this.array[index2 + 0] = x2;
    this.array[index2 + 1] = y2;
    this.array[index2 + 2] = z2;
    return this;
  }
  setXYZW(index2, x2, y2, z2, w2) {
    index2 *= this.itemSize;
    this.array[index2 + 0] = x2;
    this.array[index2 + 1] = y2;
    this.array[index2 + 2] = z2;
    this.array[index2 + 3] = w2;
    return this;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const data2 = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.prototype.slice.call(this.array),
      normalized: this.normalized
    };
    if (this.name !== "")
      data2.name = this.name;
    if (this.usage !== StaticDrawUsage)
      data2.usage = this.usage;
    if (this.updateRange.offset !== 0 || this.updateRange.count !== -1)
      data2.updateRange = this.updateRange;
    return data2;
  }
}
BufferAttribute.prototype.isBufferAttribute = true;
class Int8BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Int8Array(array2), itemSize, normalized);
  }
}
class Uint8BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Uint8Array(array2), itemSize, normalized);
  }
}
class Uint8ClampedBufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Uint8ClampedArray(array2), itemSize, normalized);
  }
}
class Int16BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Int16Array(array2), itemSize, normalized);
  }
}
class Uint16BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Uint16Array(array2), itemSize, normalized);
  }
}
class Int32BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Int32Array(array2), itemSize, normalized);
  }
}
class Uint32BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Uint32Array(array2), itemSize, normalized);
  }
}
class Float16BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Uint16Array(array2), itemSize, normalized);
  }
}
Float16BufferAttribute.prototype.isFloat16BufferAttribute = true;
class Float32BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Float32Array(array2), itemSize, normalized);
  }
}
class Float64BufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized) {
    super(new Float64Array(array2), itemSize, normalized);
  }
}
let _id$1 = 0;
const _m1 = /* @__PURE__ */ new Matrix4$1();
const _obj = /* @__PURE__ */ new Object3D();
const _offset = /* @__PURE__ */ new Vector3$1();
const _box$1 = /* @__PURE__ */ new Box3();
const _boxMorphTargets = /* @__PURE__ */ new Box3();
const _vector$8 = /* @__PURE__ */ new Vector3$1();
class BufferGeometry extends EventDispatcher$1 {
  constructor() {
    super();
    Object.defineProperty(this, "id", { value: _id$1++ });
    this.uuid = generateUUID();
    this.name = "";
    this.type = "BufferGeometry";
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = { start: 0, count: Infinity };
    this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(index2) {
    if (Array.isArray(index2)) {
      this.index = new (arrayNeedsUint32(index2) ? Uint32BufferAttribute : Uint16BufferAttribute)(index2, 1);
    } else {
      this.index = index2;
    }
    return this;
  }
  getAttribute(name2) {
    return this.attributes[name2];
  }
  setAttribute(name2, attribute) {
    this.attributes[name2] = attribute;
    return this;
  }
  deleteAttribute(name2) {
    delete this.attributes[name2];
    return this;
  }
  hasAttribute(name2) {
    return this.attributes[name2] !== void 0;
  }
  addGroup(start2, count3, materialIndex = 0) {
    this.groups.push({
      start: start2,
      count: count3,
      materialIndex
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(start2, count3) {
    this.drawRange.start = start2;
    this.drawRange.count = count3;
  }
  applyMatrix4(matrix) {
    const position = this.attributes.position;
    if (position !== void 0) {
      position.applyMatrix4(matrix);
      position.needsUpdate = true;
    }
    const normal = this.attributes.normal;
    if (normal !== void 0) {
      const normalMatrix = new Matrix3$1().getNormalMatrix(matrix);
      normal.applyNormalMatrix(normalMatrix);
      normal.needsUpdate = true;
    }
    const tangent = this.attributes.tangent;
    if (tangent !== void 0) {
      tangent.transformDirection(matrix);
      tangent.needsUpdate = true;
    }
    if (this.boundingBox !== null) {
      this.computeBoundingBox();
    }
    if (this.boundingSphere !== null) {
      this.computeBoundingSphere();
    }
    return this;
  }
  applyQuaternion(q2) {
    _m1.makeRotationFromQuaternion(q2);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateX(angle4) {
    _m1.makeRotationX(angle4);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateY(angle4) {
    _m1.makeRotationY(angle4);
    this.applyMatrix4(_m1);
    return this;
  }
  rotateZ(angle4) {
    _m1.makeRotationZ(angle4);
    this.applyMatrix4(_m1);
    return this;
  }
  translate(x2, y2, z2) {
    _m1.makeTranslation(x2, y2, z2);
    this.applyMatrix4(_m1);
    return this;
  }
  scale(x2, y2, z2) {
    _m1.makeScale(x2, y2, z2);
    this.applyMatrix4(_m1);
    return this;
  }
  lookAt(vector) {
    _obj.lookAt(vector);
    _obj.updateMatrix();
    this.applyMatrix4(_obj.matrix);
    return this;
  }
  center() {
    this.computeBoundingBox();
    this.boundingBox.getCenter(_offset).negate();
    this.translate(_offset.x, _offset.y, _offset.z);
    return this;
  }
  setFromPoints(points2) {
    const position = [];
    for (let i2 = 0, l2 = points2.length; i2 < l2; i2++) {
      const point4 = points2[i2];
      position.push(point4.x, point4.y, point4.z || 0);
    }
    this.setAttribute("position", new Float32BufferAttribute(position, 3));
    return this;
  }
  computeBoundingBox() {
    if (this.boundingBox === null) {
      this.boundingBox = new Box3();
    }
    const position = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position && position.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
      this.boundingBox.set(
        new Vector3$1(-Infinity, -Infinity, -Infinity),
        new Vector3$1(Infinity, Infinity, Infinity)
      );
      return;
    }
    if (position !== void 0) {
      this.boundingBox.setFromBufferAttribute(position);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _box$1.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(this.boundingBox.min, _box$1.min);
            this.boundingBox.expandByPoint(_vector$8);
            _vector$8.addVectors(this.boundingBox.max, _box$1.max);
            this.boundingBox.expandByPoint(_vector$8);
          } else {
            this.boundingBox.expandByPoint(_box$1.min);
            this.boundingBox.expandByPoint(_box$1.max);
          }
        }
      }
    } else {
      this.boundingBox.makeEmpty();
    }
    if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeBoundingSphere() {
    if (this.boundingSphere === null) {
      this.boundingSphere = new Sphere();
    }
    const position = this.attributes.position;
    const morphAttributesPosition = this.morphAttributes.position;
    if (position && position.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
      this.boundingSphere.set(new Vector3$1(), Infinity);
      return;
    }
    if (position) {
      const center2 = this.boundingSphere.center;
      _box$1.setFromBufferAttribute(position);
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          _boxMorphTargets.setFromBufferAttribute(morphAttribute);
          if (this.morphTargetsRelative) {
            _vector$8.addVectors(_box$1.min, _boxMorphTargets.min);
            _box$1.expandByPoint(_vector$8);
            _vector$8.addVectors(_box$1.max, _boxMorphTargets.max);
            _box$1.expandByPoint(_vector$8);
          } else {
            _box$1.expandByPoint(_boxMorphTargets.min);
            _box$1.expandByPoint(_boxMorphTargets.max);
          }
        }
      }
      _box$1.getCenter(center2);
      let maxRadiusSq = 0;
      for (let i2 = 0, il = position.count; i2 < il; i2++) {
        _vector$8.fromBufferAttribute(position, i2);
        maxRadiusSq = Math.max(maxRadiusSq, center2.distanceToSquared(_vector$8));
      }
      if (morphAttributesPosition) {
        for (let i2 = 0, il = morphAttributesPosition.length; i2 < il; i2++) {
          const morphAttribute = morphAttributesPosition[i2];
          const morphTargetsRelative = this.morphTargetsRelative;
          for (let j2 = 0, jl = morphAttribute.count; j2 < jl; j2++) {
            _vector$8.fromBufferAttribute(morphAttribute, j2);
            if (morphTargetsRelative) {
              _offset.fromBufferAttribute(position, j2);
              _vector$8.add(_offset);
            }
            maxRadiusSq = Math.max(maxRadiusSq, center2.distanceToSquared(_vector$8));
          }
        }
      }
      this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
      if (isNaN(this.boundingSphere.radius)) {
        console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }
  computeTangents() {
    const index2 = this.index;
    const attributes = this.attributes;
    if (index2 === null || attributes.position === void 0 || attributes.normal === void 0 || attributes.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const indices = index2.array;
    const positions = attributes.position.array;
    const normals = attributes.normal.array;
    const uvs = attributes.uv.array;
    const nVertices = positions.length / 3;
    if (this.hasAttribute("tangent") === false) {
      this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * nVertices), 4));
    }
    const tangents = this.getAttribute("tangent").array;
    const tan1 = [], tan2 = [];
    for (let i2 = 0; i2 < nVertices; i2++) {
      tan1[i2] = new Vector3$1();
      tan2[i2] = new Vector3$1();
    }
    const vA = new Vector3$1(), vB = new Vector3$1(), vC = new Vector3$1(), uvA = new Vector2$1(), uvB = new Vector2$1(), uvC = new Vector2$1(), sdir = new Vector3$1(), tdir = new Vector3$1();
    function handleTriangle(a2, b2, c2) {
      vA.fromArray(positions, a2 * 3);
      vB.fromArray(positions, b2 * 3);
      vC.fromArray(positions, c2 * 3);
      uvA.fromArray(uvs, a2 * 2);
      uvB.fromArray(uvs, b2 * 2);
      uvC.fromArray(uvs, c2 * 2);
      vB.sub(vA);
      vC.sub(vA);
      uvB.sub(uvA);
      uvC.sub(uvA);
      const r2 = 1 / (uvB.x * uvC.y - uvC.x * uvB.y);
      if (!isFinite(r2))
        return;
      sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r2);
      tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r2);
      tan1[a2].add(sdir);
      tan1[b2].add(sdir);
      tan1[c2].add(sdir);
      tan2[a2].add(tdir);
      tan2[b2].add(tdir);
      tan2[c2].add(tdir);
    }
    let groups = this.groups;
    if (groups.length === 0) {
      groups = [{
        start: 0,
        count: indices.length
      }];
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start2 = group.start;
      const count3 = group.count;
      for (let j2 = start2, jl = start2 + count3; j2 < jl; j2 += 3) {
        handleTriangle(
          indices[j2 + 0],
          indices[j2 + 1],
          indices[j2 + 2]
        );
      }
    }
    const tmp2 = new Vector3$1(), tmp22 = new Vector3$1();
    const n2 = new Vector3$1(), n22 = new Vector3$1();
    function handleVertex(v5) {
      n2.fromArray(normals, v5 * 3);
      n22.copy(n2);
      const t2 = tan1[v5];
      tmp2.copy(t2);
      tmp2.sub(n2.multiplyScalar(n2.dot(t2))).normalize();
      tmp22.crossVectors(n22, t2);
      const test = tmp22.dot(tan2[v5]);
      const w2 = test < 0 ? -1 : 1;
      tangents[v5 * 4] = tmp2.x;
      tangents[v5 * 4 + 1] = tmp2.y;
      tangents[v5 * 4 + 2] = tmp2.z;
      tangents[v5 * 4 + 3] = w2;
    }
    for (let i2 = 0, il = groups.length; i2 < il; ++i2) {
      const group = groups[i2];
      const start2 = group.start;
      const count3 = group.count;
      for (let j2 = start2, jl = start2 + count3; j2 < jl; j2 += 3) {
        handleVertex(indices[j2 + 0]);
        handleVertex(indices[j2 + 1]);
        handleVertex(indices[j2 + 2]);
      }
    }
  }
  computeVertexNormals() {
    const index2 = this.index;
    const positionAttribute = this.getAttribute("position");
    if (positionAttribute !== void 0) {
      let normalAttribute = this.getAttribute("normal");
      if (normalAttribute === void 0) {
        normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
        this.setAttribute("normal", normalAttribute);
      } else {
        for (let i2 = 0, il = normalAttribute.count; i2 < il; i2++) {
          normalAttribute.setXYZ(i2, 0, 0, 0);
        }
      }
      const pA = new Vector3$1(), pB = new Vector3$1(), pC = new Vector3$1();
      const nA = new Vector3$1(), nB = new Vector3$1(), nC = new Vector3$1();
      const cb2 = new Vector3$1(), ab2 = new Vector3$1();
      if (index2) {
        for (let i2 = 0, il = index2.count; i2 < il; i2 += 3) {
          const vA = index2.getX(i2 + 0);
          const vB = index2.getX(i2 + 1);
          const vC = index2.getX(i2 + 2);
          pA.fromBufferAttribute(positionAttribute, vA);
          pB.fromBufferAttribute(positionAttribute, vB);
          pC.fromBufferAttribute(positionAttribute, vC);
          cb2.subVectors(pC, pB);
          ab2.subVectors(pA, pB);
          cb2.cross(ab2);
          nA.fromBufferAttribute(normalAttribute, vA);
          nB.fromBufferAttribute(normalAttribute, vB);
          nC.fromBufferAttribute(normalAttribute, vC);
          nA.add(cb2);
          nB.add(cb2);
          nC.add(cb2);
          normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
          normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
          normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
        }
      } else {
        for (let i2 = 0, il = positionAttribute.count; i2 < il; i2 += 3) {
          pA.fromBufferAttribute(positionAttribute, i2 + 0);
          pB.fromBufferAttribute(positionAttribute, i2 + 1);
          pC.fromBufferAttribute(positionAttribute, i2 + 2);
          cb2.subVectors(pC, pB);
          ab2.subVectors(pA, pB);
          cb2.cross(ab2);
          normalAttribute.setXYZ(i2 + 0, cb2.x, cb2.y, cb2.z);
          normalAttribute.setXYZ(i2 + 1, cb2.x, cb2.y, cb2.z);
          normalAttribute.setXYZ(i2 + 2, cb2.x, cb2.y, cb2.z);
        }
      }
      this.normalizeNormals();
      normalAttribute.needsUpdate = true;
    }
  }
  merge(geometry2, offset) {
    if (!(geometry2 && geometry2.isBufferGeometry)) {
      console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", geometry2);
      return;
    }
    if (offset === void 0) {
      offset = 0;
      console.warn(
        "THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."
      );
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      if (geometry2.attributes[key] === void 0)
        continue;
      const attribute1 = attributes[key];
      const attributeArray1 = attribute1.array;
      const attribute2 = geometry2.attributes[key];
      const attributeArray2 = attribute2.array;
      const attributeOffset = attribute2.itemSize * offset;
      const length2 = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
      for (let i2 = 0, j2 = attributeOffset; i2 < length2; i2++, j2++) {
        attributeArray1[j2] = attributeArray2[i2];
      }
    }
    return this;
  }
  normalizeNormals() {
    const normals = this.attributes.normal;
    for (let i2 = 0, il = normals.count; i2 < il; i2++) {
      _vector$8.fromBufferAttribute(normals, i2);
      _vector$8.normalize();
      normals.setXYZ(i2, _vector$8.x, _vector$8.y, _vector$8.z);
    }
  }
  toNonIndexed() {
    function convertBufferAttribute(attribute, indices2) {
      const array2 = attribute.array;
      const itemSize = attribute.itemSize;
      const normalized = attribute.normalized;
      const array22 = new array2.constructor(indices2.length * itemSize);
      let index2 = 0, index22 = 0;
      for (let i2 = 0, l2 = indices2.length; i2 < l2; i2++) {
        if (attribute.isInterleavedBufferAttribute) {
          index2 = indices2[i2] * attribute.data.stride + attribute.offset;
        } else {
          index2 = indices2[i2] * itemSize;
        }
        for (let j2 = 0; j2 < itemSize; j2++) {
          array22[index22++] = array2[index2++];
        }
      }
      return new BufferAttribute(array22, itemSize, normalized);
    }
    if (this.index === null) {
      console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.");
      return this;
    }
    const geometry2 = new BufferGeometry();
    const indices = this.index.array;
    const attributes = this.attributes;
    for (const name2 in attributes) {
      const attribute = attributes[name2];
      const newAttribute = convertBufferAttribute(attribute, indices);
      geometry2.setAttribute(name2, newAttribute);
    }
    const morphAttributes = this.morphAttributes;
    for (const name2 in morphAttributes) {
      const morphArray = [];
      const morphAttribute = morphAttributes[name2];
      for (let i2 = 0, il = morphAttribute.length; i2 < il; i2++) {
        const attribute = morphAttribute[i2];
        const newAttribute = convertBufferAttribute(attribute, indices);
        morphArray.push(newAttribute);
      }
      geometry2.morphAttributes[name2] = morphArray;
    }
    geometry2.morphTargetsRelative = this.morphTargetsRelative;
    const groups = this.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      geometry2.addGroup(group.start, group.count, group.materialIndex);
    }
    return geometry2;
  }
  toJSON() {
    const data2 = {
      metadata: {
        version: 4.5,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    data2.uuid = this.uuid;
    data2.type = this.type;
    if (this.name !== "")
      data2.name = this.name;
    if (Object.keys(this.userData).length > 0)
      data2.userData = this.userData;
    if (this.parameters !== void 0) {
      const parameters = this.parameters;
      for (const key in parameters) {
        if (parameters[key] !== void 0)
          data2[key] = parameters[key];
      }
      return data2;
    }
    data2.data = { attributes: {} };
    const index2 = this.index;
    if (index2 !== null) {
      data2.data.index = {
        type: index2.array.constructor.name,
        array: Array.prototype.slice.call(index2.array)
      };
    }
    const attributes = this.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      data2.data.attributes[key] = attribute.toJSON(data2.data);
    }
    const morphAttributes = {};
    let hasMorphAttributes = false;
    for (const key in this.morphAttributes) {
      const attributeArray = this.morphAttributes[key];
      const array2 = [];
      for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
        const attribute = attributeArray[i2];
        array2.push(attribute.toJSON(data2.data));
      }
      if (array2.length > 0) {
        morphAttributes[key] = array2;
        hasMorphAttributes = true;
      }
    }
    if (hasMorphAttributes) {
      data2.data.morphAttributes = morphAttributes;
      data2.data.morphTargetsRelative = this.morphTargetsRelative;
    }
    const groups = this.groups;
    if (groups.length > 0) {
      data2.data.groups = JSON.parse(JSON.stringify(groups));
    }
    const boundingSphere = this.boundingSphere;
    if (boundingSphere !== null) {
      data2.data.boundingSphere = {
        center: boundingSphere.center.toArray(),
        radius: boundingSphere.radius
      };
    }
    return data2;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    const data2 = {};
    this.name = source.name;
    const index2 = source.index;
    if (index2 !== null) {
      this.setIndex(index2.clone(data2));
    }
    const attributes = source.attributes;
    for (const name2 in attributes) {
      const attribute = attributes[name2];
      this.setAttribute(name2, attribute.clone(data2));
    }
    const morphAttributes = source.morphAttributes;
    for (const name2 in morphAttributes) {
      const array2 = [];
      const morphAttribute = morphAttributes[name2];
      for (let i2 = 0, l2 = morphAttribute.length; i2 < l2; i2++) {
        array2.push(morphAttribute[i2].clone(data2));
      }
      this.morphAttributes[name2] = array2;
    }
    this.morphTargetsRelative = source.morphTargetsRelative;
    const groups = source.groups;
    for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
      const group = groups[i2];
      this.addGroup(group.start, group.count, group.materialIndex);
    }
    const boundingBox = source.boundingBox;
    if (boundingBox !== null) {
      this.boundingBox = boundingBox.clone();
    }
    const boundingSphere = source.boundingSphere;
    if (boundingSphere !== null) {
      this.boundingSphere = boundingSphere.clone();
    }
    this.drawRange.start = source.drawRange.start;
    this.drawRange.count = source.drawRange.count;
    this.userData = source.userData;
    if (source.parameters !== void 0)
      this.parameters = Object.assign({}, source.parameters);
    return this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
BufferGeometry.prototype.isBufferGeometry = true;
const _inverseMatrix$2 = /* @__PURE__ */ new Matrix4$1();
const _ray$2 = /* @__PURE__ */ new Ray();
const _sphere$3 = /* @__PURE__ */ new Sphere();
const _vA$1 = /* @__PURE__ */ new Vector3$1();
const _vB$1 = /* @__PURE__ */ new Vector3$1();
const _vC$1 = /* @__PURE__ */ new Vector3$1();
const _tempA = /* @__PURE__ */ new Vector3$1();
const _tempB = /* @__PURE__ */ new Vector3$1();
const _tempC = /* @__PURE__ */ new Vector3$1();
const _morphA = /* @__PURE__ */ new Vector3$1();
const _morphB = /* @__PURE__ */ new Vector3$1();
const _morphC = /* @__PURE__ */ new Vector3$1();
const _uvA$1 = /* @__PURE__ */ new Vector2$1();
const _uvB$1 = /* @__PURE__ */ new Vector2$1();
const _uvC$1 = /* @__PURE__ */ new Vector2$1();
const _intersectionPoint = /* @__PURE__ */ new Vector3$1();
const _intersectionPointWorld = /* @__PURE__ */ new Vector3$1();
class Mesh extends Object3D {
  constructor(geometry2 = new BufferGeometry(), material = new MeshBasicMaterial()) {
    super();
    this.type = "Mesh";
    this.geometry = geometry2;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    if (source.morphTargetInfluences !== void 0) {
      this.morphTargetInfluences = source.morphTargetInfluences.slice();
    }
    if (source.morphTargetDictionary !== void 0) {
      this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
    }
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  updateMorphTargets() {
    const geometry2 = this.geometry;
    if (geometry2.isBufferGeometry) {
      const morphAttributes = geometry2.morphAttributes;
      const keys4 = Object.keys(morphAttributes);
      if (keys4.length > 0) {
        const morphAttribute = morphAttributes[keys4[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m2 = 0, ml = morphAttribute.length; m2 < ml; m2++) {
            const name2 = morphAttribute[m2].name || String(m2);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name2] = m2;
          }
        }
      }
    } else {
      const morphTargets = geometry2.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
  raycast(raycaster, intersects7) {
    const geometry2 = this.geometry;
    const material = this.material;
    const matrixWorld = this.matrixWorld;
    if (material === void 0)
      return;
    if (geometry2.boundingSphere === null)
      geometry2.computeBoundingSphere();
    _sphere$3.copy(geometry2.boundingSphere);
    _sphere$3.applyMatrix4(matrixWorld);
    if (raycaster.ray.intersectsSphere(_sphere$3) === false)
      return;
    _inverseMatrix$2.copy(matrixWorld).invert();
    _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
    if (geometry2.boundingBox !== null) {
      if (_ray$2.intersectsBox(geometry2.boundingBox) === false)
        return;
    }
    let intersection8;
    if (geometry2.isBufferGeometry) {
      const index2 = geometry2.index;
      const position = geometry2.attributes.position;
      const morphPosition = geometry2.morphAttributes.position;
      const morphTargetsRelative = geometry2.morphTargetsRelative;
      const uv = geometry2.attributes.uv;
      const uv2 = geometry2.attributes.uv2;
      const groups = geometry2.groups;
      const drawRange = geometry2.drawRange;
      if (index2 !== null) {
        if (Array.isArray(material)) {
          for (let i2 = 0, il = groups.length; i2 < il; i2++) {
            const group = groups[i2];
            const groupMaterial = material[group.materialIndex];
            const start2 = Math.max(group.start, drawRange.start);
            const end = Math.min(index2.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
            for (let j2 = start2, jl = end; j2 < jl; j2 += 3) {
              const a2 = index2.getX(j2);
              const b2 = index2.getX(j2 + 1);
              const c2 = index2.getX(j2 + 2);
              intersection8 = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a2, b2, c2);
              if (intersection8) {
                intersection8.faceIndex = Math.floor(j2 / 3);
                intersection8.face.materialIndex = group.materialIndex;
                intersects7.push(intersection8);
              }
            }
          }
        } else {
          const start2 = Math.max(0, drawRange.start);
          const end = Math.min(index2.count, drawRange.start + drawRange.count);
          for (let i2 = start2, il = end; i2 < il; i2 += 3) {
            const a2 = index2.getX(i2);
            const b2 = index2.getX(i2 + 1);
            const c2 = index2.getX(i2 + 2);
            intersection8 = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a2, b2, c2);
            if (intersection8) {
              intersection8.faceIndex = Math.floor(i2 / 3);
              intersects7.push(intersection8);
            }
          }
        }
      } else if (position !== void 0) {
        if (Array.isArray(material)) {
          for (let i2 = 0, il = groups.length; i2 < il; i2++) {
            const group = groups[i2];
            const groupMaterial = material[group.materialIndex];
            const start2 = Math.max(group.start, drawRange.start);
            const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
            for (let j2 = start2, jl = end; j2 < jl; j2 += 3) {
              const a2 = j2;
              const b2 = j2 + 1;
              const c2 = j2 + 2;
              intersection8 = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a2, b2, c2);
              if (intersection8) {
                intersection8.faceIndex = Math.floor(j2 / 3);
                intersection8.face.materialIndex = group.materialIndex;
                intersects7.push(intersection8);
              }
            }
          }
        } else {
          const start2 = Math.max(0, drawRange.start);
          const end = Math.min(position.count, drawRange.start + drawRange.count);
          for (let i2 = start2, il = end; i2 < il; i2 += 3) {
            const a2 = i2;
            const b2 = i2 + 1;
            const c2 = i2 + 2;
            intersection8 = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a2, b2, c2);
            if (intersection8) {
              intersection8.faceIndex = Math.floor(i2 / 3);
              intersects7.push(intersection8);
            }
          }
        }
      }
    } else if (geometry2.isGeometry) {
      console.error("THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
}
Mesh.prototype.isMesh = true;
function checkIntersection(object2, material, raycaster, ray, pA, pB, pC, point4) {
  let intersect2;
  if (material.side === BackSide) {
    intersect2 = ray.intersectTriangle(pC, pB, pA, true, point4);
  } else {
    intersect2 = ray.intersectTriangle(pA, pB, pC, material.side !== DoubleSide, point4);
  }
  if (intersect2 === null)
    return null;
  _intersectionPointWorld.copy(point4);
  _intersectionPointWorld.applyMatrix4(object2.matrixWorld);
  const distance11 = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
  if (distance11 < raycaster.near || distance11 > raycaster.far)
    return null;
  return {
    distance: distance11,
    point: _intersectionPointWorld.clone(),
    object: object2
  };
}
function checkBufferGeometryIntersection(object2, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a2, b2, c2) {
  _vA$1.fromBufferAttribute(position, a2);
  _vB$1.fromBufferAttribute(position, b2);
  _vC$1.fromBufferAttribute(position, c2);
  const morphInfluences = object2.morphTargetInfluences;
  if (morphPosition && morphInfluences) {
    _morphA.set(0, 0, 0);
    _morphB.set(0, 0, 0);
    _morphC.set(0, 0, 0);
    for (let i2 = 0, il = morphPosition.length; i2 < il; i2++) {
      const influence = morphInfluences[i2];
      const morphAttribute = morphPosition[i2];
      if (influence === 0)
        continue;
      _tempA.fromBufferAttribute(morphAttribute, a2);
      _tempB.fromBufferAttribute(morphAttribute, b2);
      _tempC.fromBufferAttribute(morphAttribute, c2);
      if (morphTargetsRelative) {
        _morphA.addScaledVector(_tempA, influence);
        _morphB.addScaledVector(_tempB, influence);
        _morphC.addScaledVector(_tempC, influence);
      } else {
        _morphA.addScaledVector(_tempA.sub(_vA$1), influence);
        _morphB.addScaledVector(_tempB.sub(_vB$1), influence);
        _morphC.addScaledVector(_tempC.sub(_vC$1), influence);
      }
    }
    _vA$1.add(_morphA);
    _vB$1.add(_morphB);
    _vC$1.add(_morphC);
  }
  if (object2.isSkinnedMesh) {
    object2.boneTransform(a2, _vA$1);
    object2.boneTransform(b2, _vB$1);
    object2.boneTransform(c2, _vC$1);
  }
  const intersection8 = checkIntersection(object2, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);
  if (intersection8) {
    if (uv) {
      _uvA$1.fromBufferAttribute(uv, a2);
      _uvB$1.fromBufferAttribute(uv, b2);
      _uvC$1.fromBufferAttribute(uv, c2);
      intersection8.uv = Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2$1());
    }
    if (uv2) {
      _uvA$1.fromBufferAttribute(uv2, a2);
      _uvB$1.fromBufferAttribute(uv2, b2);
      _uvC$1.fromBufferAttribute(uv2, c2);
      intersection8.uv2 = Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2$1());
    }
    const face = {
      a: a2,
      b: b2,
      c: c2,
      normal: new Vector3$1(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
    intersection8.face = face;
  }
  return intersection8;
}
class BoxGeometry extends BufferGeometry {
  constructor(width = 1, height = 1, depth2 = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1) {
    super();
    this.type = "BoxGeometry";
    this.parameters = {
      width,
      height,
      depth: depth2,
      widthSegments,
      heightSegments,
      depthSegments
    };
    const scope = this;
    widthSegments = Math.floor(widthSegments);
    heightSegments = Math.floor(heightSegments);
    depthSegments = Math.floor(depthSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let numberOfVertices = 0;
    let groupStart = 0;
    buildPlane("z", "y", "x", -1, -1, depth2, height, width, depthSegments, heightSegments, 0);
    buildPlane("z", "y", "x", 1, -1, depth2, height, -width, depthSegments, heightSegments, 1);
    buildPlane("x", "z", "y", 1, 1, width, depth2, height, widthSegments, depthSegments, 2);
    buildPlane("x", "z", "y", 1, -1, width, depth2, -height, widthSegments, depthSegments, 3);
    buildPlane("x", "y", "z", 1, -1, width, height, depth2, widthSegments, heightSegments, 4);
    buildPlane("x", "y", "z", -1, -1, width, height, -depth2, widthSegments, heightSegments, 5);
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function buildPlane(u2, v5, w2, udir, vdir, width2, height2, depth3, gridX, gridY, materialIndex) {
      const segmentWidth = width2 / gridX;
      const segmentHeight = height2 / gridY;
      const widthHalf = width2 / 2;
      const heightHalf = height2 / 2;
      const depthHalf = depth3 / 2;
      const gridX1 = gridX + 1;
      const gridY1 = gridY + 1;
      let vertexCounter = 0;
      let groupCount = 0;
      const vector = new Vector3$1();
      for (let iy = 0; iy < gridY1; iy++) {
        const y2 = iy * segmentHeight - heightHalf;
        for (let ix = 0; ix < gridX1; ix++) {
          const x2 = ix * segmentWidth - widthHalf;
          vector[u2] = x2 * udir;
          vector[v5] = y2 * vdir;
          vector[w2] = depthHalf;
          vertices.push(vector.x, vector.y, vector.z);
          vector[u2] = 0;
          vector[v5] = 0;
          vector[w2] = depth3 > 0 ? 1 : -1;
          normals.push(vector.x, vector.y, vector.z);
          uvs.push(ix / gridX);
          uvs.push(1 - iy / gridY);
          vertexCounter += 1;
        }
      }
      for (let iy = 0; iy < gridY; iy++) {
        for (let ix = 0; ix < gridX; ix++) {
          const a2 = numberOfVertices + ix + gridX1 * iy;
          const b2 = numberOfVertices + ix + gridX1 * (iy + 1);
          const c2 = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
          const d2 = numberOfVertices + (ix + 1) + gridX1 * iy;
          indices.push(a2, b2, d2);
          indices.push(b2, c2, d2);
          groupCount += 6;
        }
      }
      scope.addGroup(groupStart, groupCount, materialIndex);
      groupStart += groupCount;
      numberOfVertices += vertexCounter;
    }
  }
  static fromJSON(data2) {
    return new BoxGeometry(data2.width, data2.height, data2.depth, data2.widthSegments, data2.heightSegments, data2.depthSegments);
  }
}
function cloneUniforms(src2) {
  const dst = {};
  for (const u2 in src2) {
    dst[u2] = {};
    for (const p2 in src2[u2]) {
      const property2 = src2[u2][p2];
      if (property2 && (property2.isColor || property2.isMatrix3 || property2.isMatrix4 || property2.isVector2 || property2.isVector3 || property2.isVector4 || property2.isTexture || property2.isQuaternion)) {
        dst[u2][p2] = property2.clone();
      } else if (Array.isArray(property2)) {
        dst[u2][p2] = property2.slice();
      } else {
        dst[u2][p2] = property2;
      }
    }
  }
  return dst;
}
function mergeUniforms(uniforms) {
  const merged = {};
  for (let u2 = 0; u2 < uniforms.length; u2++) {
    const tmp2 = cloneUniforms(uniforms[u2]);
    for (const p2 in tmp2) {
      merged[p2] = tmp2[p2];
    }
  }
  return merged;
}
const UniformsUtils = { clone: cloneUniforms, merge: mergeUniforms };
var default_vertex = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class ShaderMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "ShaderMaterial";
    this.defines = {};
    this.uniforms = {};
    this.vertexShader = default_vertex;
    this.fragmentShader = default_fragment;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.lights = false;
    this.clipping = false;
    this.extensions = {
      derivatives: false,
      // set to use derivatives
      fragDepth: false,
      // set to use fragment depth values
      drawBuffers: false,
      // set to use draw buffers
      shaderTextureLOD: false
      // set to use shader texture LOD
    };
    this.defaultAttributeValues = {
      "color": [1, 1, 1],
      "uv": [0, 0],
      "uv2": [0, 0]
    };
    this.index0AttributeName = void 0;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (parameters !== void 0) {
      if (parameters.attributes !== void 0) {
        console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.");
      }
      this.setValues(parameters);
    }
  }
  copy(source) {
    super.copy(source);
    this.fragmentShader = source.fragmentShader;
    this.vertexShader = source.vertexShader;
    this.uniforms = cloneUniforms(source.uniforms);
    this.defines = Object.assign({}, source.defines);
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.lights = source.lights;
    this.clipping = source.clipping;
    this.extensions = Object.assign({}, source.extensions);
    this.glslVersion = source.glslVersion;
    return this;
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    data2.glslVersion = this.glslVersion;
    data2.uniforms = {};
    for (const name2 in this.uniforms) {
      const uniform = this.uniforms[name2];
      const value = uniform.value;
      if (value && value.isTexture) {
        data2.uniforms[name2] = {
          type: "t",
          value: value.toJSON(meta2).uuid
        };
      } else if (value && value.isColor) {
        data2.uniforms[name2] = {
          type: "c",
          value: value.getHex()
        };
      } else if (value && value.isVector2) {
        data2.uniforms[name2] = {
          type: "v2",
          value: value.toArray()
        };
      } else if (value && value.isVector3) {
        data2.uniforms[name2] = {
          type: "v3",
          value: value.toArray()
        };
      } else if (value && value.isVector4) {
        data2.uniforms[name2] = {
          type: "v4",
          value: value.toArray()
        };
      } else if (value && value.isMatrix3) {
        data2.uniforms[name2] = {
          type: "m3",
          value: value.toArray()
        };
      } else if (value && value.isMatrix4) {
        data2.uniforms[name2] = {
          type: "m4",
          value: value.toArray()
        };
      } else {
        data2.uniforms[name2] = {
          value
        };
      }
    }
    if (Object.keys(this.defines).length > 0)
      data2.defines = this.defines;
    data2.vertexShader = this.vertexShader;
    data2.fragmentShader = this.fragmentShader;
    const extensions = {};
    for (const key in this.extensions) {
      if (this.extensions[key] === true)
        extensions[key] = true;
    }
    if (Object.keys(extensions).length > 0)
      data2.extensions = extensions;
    return data2;
  }
}
ShaderMaterial.prototype.isShaderMaterial = true;
class Camera extends Object3D {
  constructor() {
    super();
    this.type = "Camera";
    this.matrixWorldInverse = new Matrix4$1();
    this.projectionMatrix = new Matrix4$1();
    this.projectionMatrixInverse = new Matrix4$1();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.matrixWorldInverse.copy(source.matrixWorldInverse);
    this.projectionMatrix.copy(source.projectionMatrix);
    this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
    return this;
  }
  getWorldDirection(target) {
    this.updateWorldMatrix(true, false);
    const e3 = this.matrixWorld.elements;
    return target.set(-e3[8], -e3[9], -e3[10]).normalize();
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(updateParents, updateChildren) {
    super.updateWorldMatrix(updateParents, updateChildren);
    this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
Camera.prototype.isCamera = true;
class PerspectiveCamera extends Camera {
  constructor(fov2 = 50, aspect2 = 1, near = 0.1, far = 2e3) {
    super();
    this.type = "PerspectiveCamera";
    this.fov = fov2;
    this.zoom = 1;
    this.near = near;
    this.far = far;
    this.focus = 10;
    this.aspect = aspect2;
    this.view = null;
    this.filmGauge = 35;
    this.filmOffset = 0;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.fov = source.fov;
    this.zoom = source.zoom;
    this.near = source.near;
    this.far = source.far;
    this.focus = source.focus;
    this.aspect = source.aspect;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    this.filmGauge = source.filmGauge;
    this.filmOffset = source.filmOffset;
    return this;
  }
  /**
   * Sets the FOV by focal length in respect to the current .filmGauge.
   *
   * The default film gauge is 35, so that the focal length can be specified for
   * a 35mm (full frame) camera.
   *
   * Values for focal length and film gauge must have the same unit.
   */
  setFocalLength(focalLength) {
    const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
    this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
    this.updateProjectionMatrix();
  }
  /**
   * Calculates the focal length from the current .fov and .filmGauge.
   */
  getFocalLength() {
    const vExtentSlope = Math.tan(DEG2RAD$1 * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / vExtentSlope;
  }
  getEffectiveFOV() {
    return RAD2DEG * 2 * Math.atan(
      Math.tan(DEG2RAD$1 * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  /**
   * Sets an offset in a larger frustum. This is useful for multi-window or
   * multi-monitor/multi-machine setups.
   *
   * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
   * the monitors are in grid like this
   *
   *   +---+---+---+
   *   | A | B | C |
   *   +---+---+---+
   *   | D | E | F |
   *   +---+---+---+
   *
   * then for each monitor you would call it like this
   *
   *   const w = 1920;
   *   const h = 1080;
   *   const fullWidth = w * 3;
   *   const fullHeight = h * 2;
   *
   *   --A--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
   *   --B--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
   *   --C--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
   *   --D--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
   *   --E--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
   *   --F--
   *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
   *
   *   Note there is no reason monitors have to be the same size or in a grid.
   */
  setViewOffset(fullWidth, fullHeight, x2, y2, width, height) {
    this.aspect = fullWidth / fullHeight;
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x2;
    this.view.offsetY = y2;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const near = this.near;
    let top = near * Math.tan(DEG2RAD$1 * 0.5 * this.fov) / this.zoom;
    let height = 2 * top;
    let width = this.aspect * height;
    let left = -0.5 * width;
    const view2 = this.view;
    if (this.view !== null && this.view.enabled) {
      const fullWidth = view2.fullWidth, fullHeight = view2.fullHeight;
      left += view2.offsetX * width / fullWidth;
      top -= view2.offsetY * height / fullHeight;
      width *= view2.width / fullWidth;
      height *= view2.height / fullHeight;
    }
    const skew = this.filmOffset;
    if (skew !== 0)
      left += near * skew / this.getFilmWidth();
    this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    data2.object.fov = this.fov;
    data2.object.zoom = this.zoom;
    data2.object.near = this.near;
    data2.object.far = this.far;
    data2.object.focus = this.focus;
    data2.object.aspect = this.aspect;
    if (this.view !== null)
      data2.object.view = Object.assign({}, this.view);
    data2.object.filmGauge = this.filmGauge;
    data2.object.filmOffset = this.filmOffset;
    return data2;
  }
}
PerspectiveCamera.prototype.isPerspectiveCamera = true;
const fov = 90, aspect = 1;
class CubeCamera extends Object3D {
  constructor(near, far, renderTarget) {
    super();
    this.type = "CubeCamera";
    if (renderTarget.isWebGLCubeRenderTarget !== true) {
      console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
      return;
    }
    this.renderTarget = renderTarget;
    const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
    cameraPX.layers = this.layers;
    cameraPX.up.set(0, -1, 0);
    cameraPX.lookAt(new Vector3$1(1, 0, 0));
    this.add(cameraPX);
    const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
    cameraNX.layers = this.layers;
    cameraNX.up.set(0, -1, 0);
    cameraNX.lookAt(new Vector3$1(-1, 0, 0));
    this.add(cameraNX);
    const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
    cameraPY.layers = this.layers;
    cameraPY.up.set(0, 0, 1);
    cameraPY.lookAt(new Vector3$1(0, 1, 0));
    this.add(cameraPY);
    const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
    cameraNY.layers = this.layers;
    cameraNY.up.set(0, 0, -1);
    cameraNY.lookAt(new Vector3$1(0, -1, 0));
    this.add(cameraNY);
    const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraPZ.layers = this.layers;
    cameraPZ.up.set(0, -1, 0);
    cameraPZ.lookAt(new Vector3$1(0, 0, 1));
    this.add(cameraPZ);
    const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraNZ.layers = this.layers;
    cameraNZ.up.set(0, -1, 0);
    cameraNZ.lookAt(new Vector3$1(0, 0, -1));
    this.add(cameraNZ);
  }
  update(renderer, scene) {
    if (this.parent === null)
      this.updateMatrixWorld();
    const renderTarget = this.renderTarget;
    const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
    const currentRenderTarget = renderer.getRenderTarget();
    const currentOutputEncoding = renderer.outputEncoding;
    const currentToneMapping = renderer.toneMapping;
    const currentXrEnabled = renderer.xr.enabled;
    renderer.outputEncoding = LinearEncoding;
    renderer.toneMapping = NoToneMapping;
    renderer.xr.enabled = false;
    const generateMipmaps = renderTarget.texture.generateMipmaps;
    renderTarget.texture.generateMipmaps = false;
    renderer.setRenderTarget(renderTarget, 0);
    renderer.render(scene, cameraPX);
    renderer.setRenderTarget(renderTarget, 1);
    renderer.render(scene, cameraNX);
    renderer.setRenderTarget(renderTarget, 2);
    renderer.render(scene, cameraPY);
    renderer.setRenderTarget(renderTarget, 3);
    renderer.render(scene, cameraNY);
    renderer.setRenderTarget(renderTarget, 4);
    renderer.render(scene, cameraPZ);
    renderTarget.texture.generateMipmaps = generateMipmaps;
    renderer.setRenderTarget(renderTarget, 5);
    renderer.render(scene, cameraNZ);
    renderer.setRenderTarget(currentRenderTarget);
    renderer.outputEncoding = currentOutputEncoding;
    renderer.toneMapping = currentToneMapping;
    renderer.xr.enabled = currentXrEnabled;
    renderTarget.texture.needsPMREMUpdate = true;
  }
}
class CubeTexture extends Texture$1 {
  constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    images = images !== void 0 ? images : [];
    mapping = mapping !== void 0 ? mapping : CubeReflectionMapping;
    super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.flipY = false;
  }
  get images() {
    return this.image;
  }
  set images(value) {
    this.image = value;
  }
}
CubeTexture.prototype.isCubeTexture = true;
class WebGLCubeRenderTarget extends WebGLRenderTarget {
  constructor(size12, options2 = {}) {
    super(size12, size12, options2);
    const image = { width: size12, height: size12, depth: 1 };
    const images = [image, image, image, image, image, image];
    this.texture = new CubeTexture(images, options2.mapping, options2.wrapS, options2.wrapT, options2.magFilter, options2.minFilter, options2.format, options2.type, options2.anisotropy, options2.encoding);
    this.texture.isRenderTargetTexture = true;
    this.texture.generateMipmaps = options2.generateMipmaps !== void 0 ? options2.generateMipmaps : false;
    this.texture.minFilter = options2.minFilter !== void 0 ? options2.minFilter : LinearFilter;
  }
  fromEquirectangularTexture(renderer, texture) {
    this.texture.type = texture.type;
    this.texture.encoding = texture.encoding;
    this.texture.generateMipmaps = texture.generateMipmaps;
    this.texture.minFilter = texture.minFilter;
    this.texture.magFilter = texture.magFilter;
    const shader = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: (
        /* glsl */
        `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`
      ),
      fragmentShader: (
        /* glsl */
        `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
      )
    };
    const geometry2 = new BoxGeometry(5, 5, 5);
    const material = new ShaderMaterial({
      name: "CubemapFromEquirect",
      uniforms: cloneUniforms(shader.uniforms),
      vertexShader: shader.vertexShader,
      fragmentShader: shader.fragmentShader,
      side: BackSide,
      blending: NoBlending
    });
    material.uniforms.tEquirect.value = texture;
    const mesh = new Mesh(geometry2, material);
    const currentMinFilter = texture.minFilter;
    if (texture.minFilter === LinearMipmapLinearFilter)
      texture.minFilter = LinearFilter;
    const camera = new CubeCamera(1, 10, this);
    camera.update(renderer, mesh);
    texture.minFilter = currentMinFilter;
    mesh.geometry.dispose();
    mesh.material.dispose();
    return this;
  }
  clear(renderer, color, depth2, stencil) {
    const currentRenderTarget = renderer.getRenderTarget();
    for (let i2 = 0; i2 < 6; i2++) {
      renderer.setRenderTarget(this, i2);
      renderer.clear(color, depth2, stencil);
    }
    renderer.setRenderTarget(currentRenderTarget);
  }
}
WebGLCubeRenderTarget.prototype.isWebGLCubeRenderTarget = true;
const _vector1 = /* @__PURE__ */ new Vector3$1();
const _vector2 = /* @__PURE__ */ new Vector3$1();
const _normalMatrix = /* @__PURE__ */ new Matrix3$1();
let Plane$1 = class Plane2 {
  constructor(normal = new Vector3$1(1, 0, 0), constant2 = 0) {
    this.normal = normal;
    this.constant = constant2;
  }
  set(normal, constant2) {
    this.normal.copy(normal);
    this.constant = constant2;
    return this;
  }
  setComponents(x2, y2, z2, w2) {
    this.normal.set(x2, y2, z2);
    this.constant = w2;
    return this;
  }
  setFromNormalAndCoplanarPoint(normal, point4) {
    this.normal.copy(normal);
    this.constant = -point4.dot(this.normal);
    return this;
  }
  setFromCoplanarPoints(a2, b2, c2) {
    const normal = _vector1.subVectors(c2, b2).cross(_vector2.subVectors(a2, b2)).normalize();
    this.setFromNormalAndCoplanarPoint(normal, a2);
    return this;
  }
  copy(plane) {
    this.normal.copy(plane.normal);
    this.constant = plane.constant;
    return this;
  }
  normalize() {
    const inverseNormalLength = 1 / this.normal.length();
    this.normal.multiplyScalar(inverseNormalLength);
    this.constant *= inverseNormalLength;
    return this;
  }
  negate() {
    this.constant *= -1;
    this.normal.negate();
    return this;
  }
  distanceToPoint(point4) {
    return this.normal.dot(point4) + this.constant;
  }
  distanceToSphere(sphere2) {
    return this.distanceToPoint(sphere2.center) - sphere2.radius;
  }
  projectPoint(point4, target) {
    return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point4)).add(point4);
  }
  intersectLine(line, target) {
    const direction = line.delta(_vector1);
    const denominator = this.normal.dot(direction);
    if (denominator === 0) {
      if (this.distanceToPoint(line.start) === 0) {
        return target.copy(line.start);
      }
      return null;
    }
    const t2 = -(line.start.dot(this.normal) + this.constant) / denominator;
    if (t2 < 0 || t2 > 1) {
      return null;
    }
    return target.copy(direction).multiplyScalar(t2).add(line.start);
  }
  intersectsLine(line) {
    const startSign = this.distanceToPoint(line.start);
    const endSign = this.distanceToPoint(line.end);
    return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
  }
  intersectsBox(box) {
    return box.intersectsPlane(this);
  }
  intersectsSphere(sphere2) {
    return sphere2.intersectsPlane(this);
  }
  coplanarPoint(target) {
    return target.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(matrix, optionalNormalMatrix) {
    const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
    const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
    const normal = this.normal.applyMatrix3(normalMatrix).normalize();
    this.constant = -referencePoint.dot(normal);
    return this;
  }
  translate(offset) {
    this.constant -= offset.dot(this.normal);
    return this;
  }
  equals(plane) {
    return plane.normal.equals(this.normal) && plane.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
};
Plane$1.prototype.isPlane = true;
const _sphere$2 = /* @__PURE__ */ new Sphere();
const _vector$7 = /* @__PURE__ */ new Vector3$1();
class Frustum {
  constructor(p0 = new Plane$1(), p1 = new Plane$1(), p2 = new Plane$1(), p3 = new Plane$1(), p4 = new Plane$1(), p5 = new Plane$1()) {
    this.planes = [p0, p1, p2, p3, p4, p5];
  }
  set(p0, p1, p2, p3, p4, p5) {
    const planes = this.planes;
    planes[0].copy(p0);
    planes[1].copy(p1);
    planes[2].copy(p2);
    planes[3].copy(p3);
    planes[4].copy(p4);
    planes[5].copy(p5);
    return this;
  }
  copy(frustum2) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      planes[i2].copy(frustum2.planes[i2]);
    }
    return this;
  }
  setFromProjectionMatrix(m2) {
    const planes = this.planes;
    const me = m2.elements;
    const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
    const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
    const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
    const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
    planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
    planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
    planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
    planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
    planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
    planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
    return this;
  }
  intersectsObject(object2) {
    const geometry2 = object2.geometry;
    if (geometry2.boundingSphere === null)
      geometry2.computeBoundingSphere();
    _sphere$2.copy(geometry2.boundingSphere).applyMatrix4(object2.matrixWorld);
    return this.intersectsSphere(_sphere$2);
  }
  intersectsSprite(sprite) {
    _sphere$2.center.set(0, 0, 0);
    _sphere$2.radius = 0.7071067811865476;
    _sphere$2.applyMatrix4(sprite.matrixWorld);
    return this.intersectsSphere(_sphere$2);
  }
  intersectsSphere(sphere2) {
    const planes = this.planes;
    const center2 = sphere2.center;
    const negRadius = -sphere2.radius;
    for (let i2 = 0; i2 < 6; i2++) {
      const distance11 = planes[i2].distanceToPoint(center2);
      if (distance11 < negRadius) {
        return false;
      }
    }
    return true;
  }
  intersectsBox(box) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      const plane = planes[i2];
      _vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
      _vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
      _vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;
      if (plane.distanceToPoint(_vector$7) < 0) {
        return false;
      }
    }
    return true;
  }
  containsPoint(point4) {
    const planes = this.planes;
    for (let i2 = 0; i2 < 6; i2++) {
      if (planes[i2].distanceToPoint(point4) < 0) {
        return false;
      }
    }
    return true;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function WebGLAnimation() {
  let context2 = null;
  let isAnimating = false;
  let animationLoop = null;
  let requestId2 = null;
  function onAnimationFrame(time2, frame) {
    animationLoop(time2, frame);
    requestId2 = context2.requestAnimationFrame(onAnimationFrame);
  }
  return {
    start: function() {
      if (isAnimating === true)
        return;
      if (animationLoop === null)
        return;
      requestId2 = context2.requestAnimationFrame(onAnimationFrame);
      isAnimating = true;
    },
    stop: function() {
      context2.cancelAnimationFrame(requestId2);
      isAnimating = false;
    },
    setAnimationLoop: function(callback) {
      animationLoop = callback;
    },
    setContext: function(value) {
      context2 = value;
    }
  };
}
function WebGLAttributes(gl, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  const buffers = /* @__PURE__ */ new WeakMap();
  function createBuffer(attribute, bufferType) {
    const array2 = attribute.array;
    const usage = attribute.usage;
    const buffer3 = gl.createBuffer();
    gl.bindBuffer(bufferType, buffer3);
    gl.bufferData(bufferType, array2, usage);
    attribute.onUploadCallback();
    let type;
    if (array2 instanceof Float32Array) {
      type = 5126;
    } else if (array2 instanceof Uint16Array) {
      if (attribute.isFloat16BufferAttribute) {
        if (isWebGL2) {
          type = 5131;
        } else {
          throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
        }
      } else {
        type = 5123;
      }
    } else if (array2 instanceof Int16Array) {
      type = 5122;
    } else if (array2 instanceof Uint32Array) {
      type = 5125;
    } else if (array2 instanceof Int32Array) {
      type = 5124;
    } else if (array2 instanceof Int8Array) {
      type = 5120;
    } else if (array2 instanceof Uint8Array) {
      type = 5121;
    } else if (array2 instanceof Uint8ClampedArray) {
      type = 5121;
    } else {
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + array2);
    }
    return {
      buffer: buffer3,
      type,
      bytesPerElement: array2.BYTES_PER_ELEMENT,
      version: attribute.version
    };
  }
  function updateBuffer(buffer3, attribute, bufferType) {
    const array2 = attribute.array;
    const updateRange = attribute.updateRange;
    gl.bindBuffer(bufferType, buffer3);
    if (updateRange.count === -1) {
      gl.bufferSubData(bufferType, 0, array2);
    } else {
      if (isWebGL2) {
        gl.bufferSubData(
          bufferType,
          updateRange.offset * array2.BYTES_PER_ELEMENT,
          array2,
          updateRange.offset,
          updateRange.count
        );
      } else {
        gl.bufferSubData(
          bufferType,
          updateRange.offset * array2.BYTES_PER_ELEMENT,
          array2.subarray(updateRange.offset, updateRange.offset + updateRange.count)
        );
      }
      updateRange.count = -1;
    }
  }
  function get6(attribute) {
    if (attribute.isInterleavedBufferAttribute)
      attribute = attribute.data;
    return buffers.get(attribute);
  }
  function remove6(attribute) {
    if (attribute.isInterleavedBufferAttribute)
      attribute = attribute.data;
    const data2 = buffers.get(attribute);
    if (data2) {
      gl.deleteBuffer(data2.buffer);
      buffers.delete(attribute);
    }
  }
  function update(attribute, bufferType) {
    if (attribute.isGLBufferAttribute) {
      const cached = buffers.get(attribute);
      if (!cached || cached.version < attribute.version) {
        buffers.set(attribute, {
          buffer: attribute.buffer,
          type: attribute.type,
          bytesPerElement: attribute.elementSize,
          version: attribute.version
        });
      }
      return;
    }
    if (attribute.isInterleavedBufferAttribute)
      attribute = attribute.data;
    const data2 = buffers.get(attribute);
    if (data2 === void 0) {
      buffers.set(attribute, createBuffer(attribute, bufferType));
    } else if (data2.version < attribute.version) {
      updateBuffer(data2.buffer, attribute, bufferType);
      data2.version = attribute.version;
    }
  }
  return {
    get: get6,
    remove: remove6,
    update
  };
}
class PlaneGeometry extends BufferGeometry {
  constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1) {
    super();
    this.type = "PlaneGeometry";
    this.parameters = {
      width,
      height,
      widthSegments,
      heightSegments
    };
    const width_half = width / 2;
    const height_half = height / 2;
    const gridX = Math.floor(widthSegments);
    const gridY = Math.floor(heightSegments);
    const gridX1 = gridX + 1;
    const gridY1 = gridY + 1;
    const segment_width = width / gridX;
    const segment_height = height / gridY;
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy < gridY1; iy++) {
      const y2 = iy * segment_height - height_half;
      for (let ix = 0; ix < gridX1; ix++) {
        const x2 = ix * segment_width - width_half;
        vertices.push(x2, -y2, 0);
        normals.push(0, 0, 1);
        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);
      }
    }
    for (let iy = 0; iy < gridY; iy++) {
      for (let ix = 0; ix < gridX; ix++) {
        const a2 = ix + gridX1 * iy;
        const b2 = ix + gridX1 * (iy + 1);
        const c2 = ix + 1 + gridX1 * (iy + 1);
        const d2 = ix + 1 + gridX1 * iy;
        indices.push(a2, b2, d2);
        indices.push(b2, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  static fromJSON(data2) {
    return new PlaneGeometry(data2.width, data2.height, data2.widthSegments, data2.heightSegments);
  }
}
var alphamap_fragment = "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif";
var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n	float D = D_GGX( alpha, dotNH );\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vUv );\n		vec2 dSTdy = dFdy( vUv );\n		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif";
var common$1 = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\nstruct GeometricContext {\n	vec3 position;\n	vec3 normal;\n	vec3 viewDir;\n#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n	return dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		vec2 uv = getUV( direction, face ) * ( faceSize - 1.0 ) + 0.5;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define r0 1.0\n	#define v0 0.339\n	#define m0 - 2.0\n	#define r1 0.8\n	#define v1 0.276\n	#define m1 - 1.0\n	#define r4 0.4\n	#define v4 0.046\n	#define m4 2.0\n	#define r5 0.305\n	#define v5 0.016\n	#define m5 3.0\n	#define r6 0.21\n	#define v6 0.0038\n	#define m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= r1 ) {\n			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n		} else if ( roughness >= r4 ) {\n			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n		} else if ( roughness >= r5 ) {\n			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n		} else if ( roughness >= r6 ) {\n			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif";
var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n	#endif\n}";
var lightmap_fragment = "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif";
var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n	vLightBack = vec3( 0.0 );\n	vIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		getPointLightInfo( pointLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		getSpotLightInfo( spotLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n		dotNL = dot( geometry.normal, directLight.direction );\n		directLightColor_Diffuse = directLight.color;\n		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n		#ifdef DOUBLE_SIDED\n			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		#ifdef DOUBLE_SIDED\n			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n		#endif\n	}\n	#pragma unroll_loop_end\n#endif";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#else\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometry.position;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif";
var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#if defined( ENVMAP_TYPE_CUBE_UV )\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )	(0)";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )	(0)";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	#ifdef SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULARINTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n		#endif\n		#ifdef USE_SPECULARCOLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEENCOLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEENROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n	#endif\n#endif";
var lights_physical_pars_fragment = "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	vec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometry.normal;\n		vec3 viewDir = geometry.viewDir;\n		vec3 position = geometry.position;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	vec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n	geometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, geometry, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometry.normal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif";
var map_fragment = "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	uniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vUv );\n	metalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif";
var morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif";
var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	#ifdef USE_TANGENT\n		vec3 tangent = normalize( vTangent );\n		vec3 bitangent = normalize( vBitangent );\n		#ifdef DOUBLE_SIDED\n			tangent = tangent * faceDirection;\n			bitangent = bitangent * faceDirection;\n		#endif\n		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n			mat3 vTBN = mat3( tangent, bitangent, normal );\n		#endif\n	#endif\n#endif\nvec3 geometryNormal = normal;";
var normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	#ifdef USE_TANGENT\n		normal = normalize( vTBN * mapN );\n	#else\n		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n	#endif\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normal_pars_fragment = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_pars_vertex = "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif";
var normal_vertex = "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n		vec2 st0 = dFdx( vUv.st );\n		vec2 st1 = dFdy( vUv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n	}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = geometryNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	#ifdef USE_TANGENT\n		clearcoatNormal = normalize( vTBN * clearcoatMapN );\n	#else\n		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n	#endif\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif";
var output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n	return linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vUv );\n	roughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n		bool inFrustum = all( inFrustumVec );\n		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n		bool frustumTest = all( frustumTestVec );\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif";
var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif";
var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		vec4 shadowWorldPosition;\n	#endif\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n	#endif\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	#ifdef BONE_TEXTURE\n		uniform highp sampler2D boneTexture;\n		uniform int boneTextureSize;\n		mat4 getBoneMatrix( const in float i ) {\n			float j = i * 4.0;\n			float x = mod( j, float( boneTextureSize ) );\n			float y = floor( j / float( boneTextureSize ) );\n			float dx = 1.0 / float( boneTextureSize );\n			float dy = 1.0 / float( boneTextureSize );\n			y = dy * ( y + 0.5 );\n			vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n			vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n			vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n			vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n			mat4 bone = mat4( v1, v2, v3, v4 );\n			return bone;\n		}\n	#else\n		uniform mat4 boneMatrices[ MAX_BONES ];\n		mat4 getBoneMatrix( const in float i ) {\n			mat4 bone = boneMatrices[ int(i) ];\n			return bone;\n		}\n	#endif\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment = "#ifdef USE_TRANSMISSION\n	float transmissionAlpha = 1.0;\n	float transmissionFactor = transmission;\n	float thicknessFactor = thickness;\n	#ifdef USE_TRANSMISSIONMAP\n		transmissionFactor *= texture2D( transmissionMap, vUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		thicknessFactor *= texture2D( thicknessMap, vUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmission = getIBLVolumeRefraction(\n		n, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n		attenuationColor, attenuationDistance );\n	totalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n	transmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif";
var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		#ifdef texture2DLodEXT\n			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#else\n			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n		#endif\n	}\n	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( attenuationDistance == 0.0 ) {\n			return radiance;\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n	}\n#endif";
var uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n	varying vec2 vUv;\n#endif";
var uv_pars_vertex = "#ifdef USE_UV\n	#ifdef UVS_VERTEX_ONLY\n		vec2 vUv;\n	#else\n		varying vec2 vUv;\n	#endif\n	uniform mat3 uvTransform;\n#endif";
var uv_vertex = "#ifdef USE_UV\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	varying vec2 vUv2;\n#endif";
var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	attribute vec2 uv2;\n	varying vec2 vUv2;\n	uniform mat3 uv2Transform;\n#endif";
var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif";
const vertex$g = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const fragment$g = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n	gl_FragColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		gl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );\n	#endif\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}";
const fragment$f = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	vec3 vReflect = vWorldDirection;\n	#include <envmap_fragment>\n	gl_FragColor = envColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}";
const fragment$e = "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}";
const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}";
const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}";
const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}";
const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n}";
const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vUv2 );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$9 = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <lights_lambert_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$9 = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n	varying vec3 vLightBack;\n	varying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <emissivemap_fragment>\n	#ifdef DOUBLE_SIDED\n		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n	#else\n		reflectedLight.indirectDiffuse += vIndirectFront;\n	#endif\n	#include <lightmap_fragment>\n	reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n	#ifdef DOUBLE_SIDED\n		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n	#else\n		reflectedLight.directDiffuse = vLightFront;\n	#endif\n	reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}";
const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}";
const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}";
const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}";
const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULARINTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n	#ifdef USE_SPECULARCOLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEENCOLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEENROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n	#endif\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <uv2_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}";
const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}";
const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}";
const vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}";
const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}";
const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <output_fragment>\n	#include <tonemapping_fragment>\n	#include <encodings_fragment>\n	#include <fog_fragment>\n}";
const ShaderChunk = {
  alphamap_fragment,
  alphamap_pars_fragment,
  alphatest_fragment,
  alphatest_pars_fragment,
  aomap_fragment,
  aomap_pars_fragment,
  begin_vertex,
  beginnormal_vertex,
  bsdfs,
  bumpmap_pars_fragment,
  clipping_planes_fragment,
  clipping_planes_pars_fragment,
  clipping_planes_pars_vertex,
  clipping_planes_vertex,
  color_fragment,
  color_pars_fragment,
  color_pars_vertex,
  color_vertex,
  common: common$1,
  cube_uv_reflection_fragment,
  defaultnormal_vertex,
  displacementmap_pars_vertex,
  displacementmap_vertex,
  emissivemap_fragment,
  emissivemap_pars_fragment,
  encodings_fragment,
  encodings_pars_fragment,
  envmap_fragment,
  envmap_common_pars_fragment,
  envmap_pars_fragment,
  envmap_pars_vertex,
  envmap_physical_pars_fragment,
  envmap_vertex,
  fog_vertex,
  fog_pars_vertex,
  fog_fragment,
  fog_pars_fragment,
  gradientmap_pars_fragment,
  lightmap_fragment,
  lightmap_pars_fragment,
  lights_lambert_vertex,
  lights_pars_begin,
  lights_toon_fragment,
  lights_toon_pars_fragment,
  lights_phong_fragment,
  lights_phong_pars_fragment,
  lights_physical_fragment,
  lights_physical_pars_fragment,
  lights_fragment_begin,
  lights_fragment_maps,
  lights_fragment_end,
  logdepthbuf_fragment,
  logdepthbuf_pars_fragment,
  logdepthbuf_pars_vertex,
  logdepthbuf_vertex,
  map_fragment,
  map_pars_fragment,
  map_particle_fragment,
  map_particle_pars_fragment,
  metalnessmap_fragment,
  metalnessmap_pars_fragment,
  morphcolor_vertex,
  morphnormal_vertex,
  morphtarget_pars_vertex,
  morphtarget_vertex,
  normal_fragment_begin,
  normal_fragment_maps,
  normal_pars_fragment,
  normal_pars_vertex,
  normal_vertex,
  normalmap_pars_fragment,
  clearcoat_normal_fragment_begin,
  clearcoat_normal_fragment_maps,
  clearcoat_pars_fragment,
  output_fragment,
  packing,
  premultiplied_alpha_fragment,
  project_vertex,
  dithering_fragment,
  dithering_pars_fragment,
  roughnessmap_fragment,
  roughnessmap_pars_fragment,
  shadowmap_pars_fragment,
  shadowmap_pars_vertex,
  shadowmap_vertex,
  shadowmask_pars_fragment,
  skinbase_vertex,
  skinning_pars_vertex,
  skinning_vertex,
  skinnormal_vertex,
  specularmap_fragment,
  specularmap_pars_fragment,
  tonemapping_fragment,
  tonemapping_pars_fragment,
  transmission_fragment,
  transmission_pars_fragment,
  uv_pars_fragment,
  uv_pars_vertex,
  uv_vertex,
  uv2_pars_fragment,
  uv2_pars_vertex,
  uv2_vertex,
  worldpos_vertex,
  background_vert: vertex$g,
  background_frag: fragment$g,
  cube_vert: vertex$f,
  cube_frag: fragment$f,
  depth_vert: vertex$e,
  depth_frag: fragment$e,
  distanceRGBA_vert: vertex$d,
  distanceRGBA_frag: fragment$d,
  equirect_vert: vertex$c,
  equirect_frag: fragment$c,
  linedashed_vert: vertex$b,
  linedashed_frag: fragment$b,
  meshbasic_vert: vertex$a,
  meshbasic_frag: fragment$a,
  meshlambert_vert: vertex$9,
  meshlambert_frag: fragment$9,
  meshmatcap_vert: vertex$8,
  meshmatcap_frag: fragment$8,
  meshnormal_vert: vertex$7,
  meshnormal_frag: fragment$7,
  meshphong_vert: vertex$6,
  meshphong_frag: fragment$6,
  meshphysical_vert: vertex$5,
  meshphysical_frag: fragment$5,
  meshtoon_vert: vertex$4,
  meshtoon_frag: fragment$4,
  points_vert: vertex$3,
  points_frag: fragment$3,
  shadow_vert: vertex$2,
  shadow_frag: fragment$2,
  sprite_vert: vertex$1,
  sprite_frag: fragment$1
};
const UniformsLib = {
  common: {
    diffuse: { value: new Color(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    uvTransform: { value: new Matrix3$1() },
    uv2Transform: { value: new Matrix3$1() },
    alphaMap: { value: null },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null }
  },
  envmap: {
    envMap: { value: null },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    // basic, lambert, phong
    ior: { value: 1.5 },
    // physical
    refractionRatio: { value: 0.98 }
    // basic, lambert, phong
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 }
  },
  emissivemap: {
    emissiveMap: { value: null }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalScale: { value: new Vector2$1(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  roughnessmap: {
    roughnessMap: { value: null }
  },
  metalnessmap: {
    metalnessMap: { value: null }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: new Color(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotShadowMap: { value: [] },
    spotShadowMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: new Color(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: new Matrix3$1() }
  },
  sprite: {
    diffuse: { value: new Color(16777215) },
    opacity: { value: 1 },
    center: { value: new Vector2$1(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: new Matrix3$1() }
  }
};
const ShaderLib = {
  basic: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.meshbasic_vert,
    fragmentShader: ShaderChunk.meshbasic_frag
  },
  lambert: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshlambert_vert,
    fragmentShader: ShaderChunk.meshlambert_frag
  },
  phong: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.specularmap,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) },
        specular: { value: new Color(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: ShaderChunk.meshphong_vert,
    fragmentShader: ShaderChunk.meshphong_frag
  },
  standard: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.envmap,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.roughnessmap,
      UniformsLib.metalnessmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
        // temporary
      }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  },
  toon: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.aomap,
      UniformsLib.lightmap,
      UniformsLib.emissivemap,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.gradientmap,
      UniformsLib.fog,
      UniformsLib.lights,
      {
        emissive: { value: new Color(0) }
      }
    ]),
    vertexShader: ShaderChunk.meshtoon_vert,
    fragmentShader: ShaderChunk.meshtoon_frag
  },
  matcap: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      UniformsLib.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: ShaderChunk.meshmatcap_vert,
    fragmentShader: ShaderChunk.meshmatcap_frag
  },
  points: {
    uniforms: mergeUniforms([
      UniformsLib.points,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.points_vert,
    fragmentShader: ShaderChunk.points_frag
  },
  dashed: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: ShaderChunk.linedashed_vert,
    fragmentShader: ShaderChunk.linedashed_frag
  },
  depth: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap
    ]),
    vertexShader: ShaderChunk.depth_vert,
    fragmentShader: ShaderChunk.depth_frag
  },
  normal: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.bumpmap,
      UniformsLib.normalmap,
      UniformsLib.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.meshnormal_vert,
    fragmentShader: ShaderChunk.meshnormal_frag
  },
  sprite: {
    uniforms: mergeUniforms([
      UniformsLib.sprite,
      UniformsLib.fog
    ]),
    vertexShader: ShaderChunk.sprite_vert,
    fragmentShader: ShaderChunk.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: new Matrix3$1() },
      t2D: { value: null }
    },
    vertexShader: ShaderChunk.background_vert,
    fragmentShader: ShaderChunk.background_frag
  },
  /* -------------------------------------------------------------------------
  //	Cube map shader
   ------------------------------------------------------------------------- */
  cube: {
    uniforms: mergeUniforms([
      UniformsLib.envmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.cube_vert,
    fragmentShader: ShaderChunk.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: ShaderChunk.equirect_vert,
    fragmentShader: ShaderChunk.equirect_frag
  },
  distanceRGBA: {
    uniforms: mergeUniforms([
      UniformsLib.common,
      UniformsLib.displacementmap,
      {
        referencePosition: { value: new Vector3$1() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: ShaderChunk.distanceRGBA_vert,
    fragmentShader: ShaderChunk.distanceRGBA_frag
  },
  shadow: {
    uniforms: mergeUniforms([
      UniformsLib.lights,
      UniformsLib.fog,
      {
        color: { value: new Color(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: ShaderChunk.shadow_vert,
    fragmentShader: ShaderChunk.shadow_frag
  }
};
ShaderLib.physical = {
  uniforms: mergeUniforms([
    ShaderLib.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatNormalScale: { value: new Vector2$1(1, 1) },
      clearcoatNormalMap: { value: null },
      sheen: { value: 0 },
      sheenColor: { value: new Color(0) },
      sheenColorMap: { value: null },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionSamplerSize: { value: new Vector2$1() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: new Color(0) },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularColor: { value: new Color(1, 1, 1) },
      specularColorMap: { value: null }
    }
  ]),
  vertexShader: ShaderChunk.meshphysical_vert,
  fragmentShader: ShaderChunk.meshphysical_frag
};
function WebGLBackground(renderer, cubemaps, state, objects, alpha, premultipliedAlpha) {
  const clearColor = new Color(0);
  let clearAlpha = alpha === true ? 0 : 1;
  let planeMesh;
  let boxMesh;
  let currentBackground = null;
  let currentBackgroundVersion = 0;
  let currentTonemapping = null;
  function render5(renderList, scene) {
    let forceClear = false;
    let background = scene.isScene === true ? scene.background : null;
    if (background && background.isTexture) {
      background = cubemaps.get(background);
    }
    const xr = renderer.xr;
    const session = xr.getSession && xr.getSession();
    if (session && session.environmentBlendMode === "additive") {
      background = null;
    }
    if (background === null) {
      setClear(clearColor, clearAlpha);
    } else if (background && background.isColor) {
      setClear(background, 1);
      forceClear = true;
    }
    if (renderer.autoClear || forceClear) {
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }
    if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {
      if (boxMesh === void 0) {
        boxMesh = new Mesh(
          new BoxGeometry(1, 1, 1),
          new ShaderMaterial({
            name: "BackgroundCubeMaterial",
            uniforms: cloneUniforms(ShaderLib.cube.uniforms),
            vertexShader: ShaderLib.cube.vertexShader,
            fragmentShader: ShaderLib.cube.fragmentShader,
            side: BackSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        boxMesh.geometry.deleteAttribute("normal");
        boxMesh.geometry.deleteAttribute("uv");
        boxMesh.onBeforeRender = function(renderer2, scene2, camera) {
          this.matrixWorld.copyPosition(camera.matrixWorld);
        };
        Object.defineProperty(boxMesh.material, "envMap", {
          get: function() {
            return this.uniforms.envMap.value;
          }
        });
        objects.update(boxMesh);
      }
      boxMesh.material.uniforms.envMap.value = background;
      boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        boxMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
    } else if (background && background.isTexture) {
      if (planeMesh === void 0) {
        planeMesh = new Mesh(
          new PlaneGeometry(2, 2),
          new ShaderMaterial({
            name: "BackgroundMaterial",
            uniforms: cloneUniforms(ShaderLib.background.uniforms),
            vertexShader: ShaderLib.background.vertexShader,
            fragmentShader: ShaderLib.background.fragmentShader,
            side: FrontSide,
            depthTest: false,
            depthWrite: false,
            fog: false
          })
        );
        planeMesh.geometry.deleteAttribute("normal");
        Object.defineProperty(planeMesh.material, "map", {
          get: function() {
            return this.uniforms.t2D.value;
          }
        });
        objects.update(planeMesh);
      }
      planeMesh.material.uniforms.t2D.value = background;
      if (background.matrixAutoUpdate === true) {
        background.updateMatrix();
      }
      planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        planeMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }
      renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
    }
  }
  function setClear(color, alpha2) {
    state.buffers.color.setClear(color.r, color.g, color.b, alpha2, premultipliedAlpha);
  }
  return {
    getClearColor: function() {
      return clearColor;
    },
    setClearColor: function(color, alpha2 = 1) {
      clearColor.set(color);
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    getClearAlpha: function() {
      return clearAlpha;
    },
    setClearAlpha: function(alpha2) {
      clearAlpha = alpha2;
      setClear(clearColor, clearAlpha);
    },
    render: render5
  };
}
function WebGLBindingStates(gl, extensions, attributes, capabilities) {
  const maxVertexAttributes = gl.getParameter(34921);
  const extension = capabilities.isWebGL2 ? null : extensions.get("OES_vertex_array_object");
  const vaoAvailable = capabilities.isWebGL2 || extension !== null;
  const bindingStates = {};
  const defaultState = createBindingState(null);
  let currentState = defaultState;
  let forceUpdate = false;
  function setup2(object2, material, program, geometry2, index2) {
    let updateBuffers = false;
    if (vaoAvailable) {
      const state = getBindingState(geometry2, program, material);
      if (currentState !== state) {
        currentState = state;
        bindVertexArrayObject(currentState.object);
      }
      updateBuffers = needsUpdate(geometry2, index2);
      if (updateBuffers)
        saveCache(geometry2, index2);
    } else {
      const wireframe = material.wireframe === true;
      if (currentState.geometry !== geometry2.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
        currentState.geometry = geometry2.id;
        currentState.program = program.id;
        currentState.wireframe = wireframe;
        updateBuffers = true;
      }
    }
    if (object2.isInstancedMesh === true) {
      updateBuffers = true;
    }
    if (index2 !== null) {
      attributes.update(index2, 34963);
    }
    if (updateBuffers || forceUpdate) {
      forceUpdate = false;
      setupVertexAttributes(object2, material, program, geometry2);
      if (index2 !== null) {
        gl.bindBuffer(34963, attributes.get(index2).buffer);
      }
    }
  }
  function createVertexArrayObject() {
    if (capabilities.isWebGL2)
      return gl.createVertexArray();
    return extension.createVertexArrayOES();
  }
  function bindVertexArrayObject(vao) {
    if (capabilities.isWebGL2)
      return gl.bindVertexArray(vao);
    return extension.bindVertexArrayOES(vao);
  }
  function deleteVertexArrayObject(vao) {
    if (capabilities.isWebGL2)
      return gl.deleteVertexArray(vao);
    return extension.deleteVertexArrayOES(vao);
  }
  function getBindingState(geometry2, program, material) {
    const wireframe = material.wireframe === true;
    let programMap = bindingStates[geometry2.id];
    if (programMap === void 0) {
      programMap = {};
      bindingStates[geometry2.id] = programMap;
    }
    let stateMap = programMap[program.id];
    if (stateMap === void 0) {
      stateMap = {};
      programMap[program.id] = stateMap;
    }
    let state = stateMap[wireframe];
    if (state === void 0) {
      state = createBindingState(createVertexArrayObject());
      stateMap[wireframe] = state;
    }
    return state;
  }
  function createBindingState(vao) {
    const newAttributes = [];
    const enabledAttributes = [];
    const attributeDivisors = [];
    for (let i2 = 0; i2 < maxVertexAttributes; i2++) {
      newAttributes[i2] = 0;
      enabledAttributes[i2] = 0;
      attributeDivisors[i2] = 0;
    }
    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes,
      enabledAttributes,
      attributeDivisors,
      object: vao,
      attributes: {},
      index: null
    };
  }
  function needsUpdate(geometry2, index2) {
    const cachedAttributes = currentState.attributes;
    const geometryAttributes = geometry2.attributes;
    let attributesNum = 0;
    for (const key in geometryAttributes) {
      const cachedAttribute = cachedAttributes[key];
      const geometryAttribute = geometryAttributes[key];
      if (cachedAttribute === void 0)
        return true;
      if (cachedAttribute.attribute !== geometryAttribute)
        return true;
      if (cachedAttribute.data !== geometryAttribute.data)
        return true;
      attributesNum++;
    }
    if (currentState.attributesNum !== attributesNum)
      return true;
    if (currentState.index !== index2)
      return true;
    return false;
  }
  function saveCache(geometry2, index2) {
    const cache2 = {};
    const attributes2 = geometry2.attributes;
    let attributesNum = 0;
    for (const key in attributes2) {
      const attribute = attributes2[key];
      const data2 = {};
      data2.attribute = attribute;
      if (attribute.data) {
        data2.data = attribute.data;
      }
      cache2[key] = data2;
      attributesNum++;
    }
    currentState.attributes = cache2;
    currentState.attributesNum = attributesNum;
    currentState.index = index2;
  }
  function initAttributes() {
    const newAttributes = currentState.newAttributes;
    for (let i2 = 0, il = newAttributes.length; i2 < il; i2++) {
      newAttributes[i2] = 0;
    }
  }
  function enableAttribute(attribute) {
    enableAttributeAndDivisor(attribute, 0);
  }
  function enableAttributeAndDivisor(attribute, meshPerAttribute) {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    const attributeDivisors = currentState.attributeDivisors;
    newAttributes[attribute] = 1;
    if (enabledAttributes[attribute] === 0) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }
    if (attributeDivisors[attribute] !== meshPerAttribute) {
      const extension2 = capabilities.isWebGL2 ? gl : extensions.get("ANGLE_instanced_arrays");
      extension2[capabilities.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](attribute, meshPerAttribute);
      attributeDivisors[attribute] = meshPerAttribute;
    }
  }
  function disableUnusedAttributes() {
    const newAttributes = currentState.newAttributes;
    const enabledAttributes = currentState.enabledAttributes;
    for (let i2 = 0, il = enabledAttributes.length; i2 < il; i2++) {
      if (enabledAttributes[i2] !== newAttributes[i2]) {
        gl.disableVertexAttribArray(i2);
        enabledAttributes[i2] = 0;
      }
    }
  }
  function vertexAttribPointer(index2, size12, type, normalized, stride, offset) {
    if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) {
      gl.vertexAttribIPointer(index2, size12, type, stride, offset);
    } else {
      gl.vertexAttribPointer(index2, size12, type, normalized, stride, offset);
    }
  }
  function setupVertexAttributes(object2, material, program, geometry2) {
    if (capabilities.isWebGL2 === false && (object2.isInstancedMesh || geometry2.isInstancedBufferGeometry)) {
      if (extensions.get("ANGLE_instanced_arrays") === null)
        return;
    }
    initAttributes();
    const geometryAttributes = geometry2.attributes;
    const programAttributes = program.getAttributes();
    const materialDefaultAttributeValues = material.defaultAttributeValues;
    for (const name2 in programAttributes) {
      const programAttribute = programAttributes[name2];
      if (programAttribute.location >= 0) {
        let geometryAttribute = geometryAttributes[name2];
        if (geometryAttribute === void 0) {
          if (name2 === "instanceMatrix" && object2.instanceMatrix)
            geometryAttribute = object2.instanceMatrix;
          if (name2 === "instanceColor" && object2.instanceColor)
            geometryAttribute = object2.instanceColor;
        }
        if (geometryAttribute !== void 0) {
          const normalized = geometryAttribute.normalized;
          const size12 = geometryAttribute.itemSize;
          const attribute = attributes.get(geometryAttribute);
          if (attribute === void 0)
            continue;
          const buffer3 = attribute.buffer;
          const type = attribute.type;
          const bytesPerElement = attribute.bytesPerElement;
          if (geometryAttribute.isInterleavedBufferAttribute) {
            const data2 = geometryAttribute.data;
            const stride = data2.stride;
            const offset = geometryAttribute.offset;
            if (data2.isInstancedInterleavedBuffer) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, data2.meshPerAttribute);
              }
              if (object2.isInstancedMesh !== true && geometry2._maxInstanceCount === void 0) {
                geometry2._maxInstanceCount = data2.meshPerAttribute * data2.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(34962, buffer3);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size12 / programAttribute.locationSize,
                type,
                normalized,
                stride * bytesPerElement,
                (offset + size12 / programAttribute.locationSize * i2) * bytesPerElement
              );
            }
          } else {
            if (geometryAttribute.isInstancedBufferAttribute) {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttributeAndDivisor(programAttribute.location + i2, geometryAttribute.meshPerAttribute);
              }
              if (object2.isInstancedMesh !== true && geometry2._maxInstanceCount === void 0) {
                geometry2._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
              }
            } else {
              for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
                enableAttribute(programAttribute.location + i2);
              }
            }
            gl.bindBuffer(34962, buffer3);
            for (let i2 = 0; i2 < programAttribute.locationSize; i2++) {
              vertexAttribPointer(
                programAttribute.location + i2,
                size12 / programAttribute.locationSize,
                type,
                normalized,
                size12 * bytesPerElement,
                size12 / programAttribute.locationSize * i2 * bytesPerElement
              );
            }
          }
        } else if (materialDefaultAttributeValues !== void 0) {
          const value = materialDefaultAttributeValues[name2];
          if (value !== void 0) {
            switch (value.length) {
              case 2:
                gl.vertexAttrib2fv(programAttribute.location, value);
                break;
              case 3:
                gl.vertexAttrib3fv(programAttribute.location, value);
                break;
              case 4:
                gl.vertexAttrib4fv(programAttribute.location, value);
                break;
              default:
                gl.vertexAttrib1fv(programAttribute.location, value);
            }
          }
        }
      }
    }
    disableUnusedAttributes();
  }
  function dispose2() {
    reset2();
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      for (const programId in programMap) {
        const stateMap = programMap[programId];
        for (const wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }
        delete programMap[programId];
      }
      delete bindingStates[geometryId];
    }
  }
  function releaseStatesOfGeometry(geometry2) {
    if (bindingStates[geometry2.id] === void 0)
      return;
    const programMap = bindingStates[geometry2.id];
    for (const programId in programMap) {
      const stateMap = programMap[programId];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[programId];
    }
    delete bindingStates[geometry2.id];
  }
  function releaseStatesOfProgram(program) {
    for (const geometryId in bindingStates) {
      const programMap = bindingStates[geometryId];
      if (programMap[program.id] === void 0)
        continue;
      const stateMap = programMap[program.id];
      for (const wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }
      delete programMap[program.id];
    }
  }
  function reset2() {
    resetDefaultState();
    forceUpdate = true;
    if (currentState === defaultState)
      return;
    currentState = defaultState;
    bindVertexArrayObject(currentState.object);
  }
  function resetDefaultState() {
    defaultState.geometry = null;
    defaultState.program = null;
    defaultState.wireframe = false;
  }
  return {
    setup: setup2,
    reset: reset2,
    resetDefaultState,
    dispose: dispose2,
    releaseStatesOfGeometry,
    releaseStatesOfProgram,
    initAttributes,
    enableAttribute,
    disableUnusedAttributes
  };
}
function WebGLBufferRenderer(gl, extensions, info, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  let mode2;
  function setMode(value) {
    mode2 = value;
  }
  function render5(start2, count3) {
    gl.drawArrays(mode2, start2, count3);
    info.update(count3, mode2, 1);
  }
  function renderInstances(start2, count3, primcount) {
    if (primcount === 0)
      return;
    let extension, methodName;
    if (isWebGL2) {
      extension = gl;
      methodName = "drawArraysInstanced";
    } else {
      extension = extensions.get("ANGLE_instanced_arrays");
      methodName = "drawArraysInstancedANGLE";
      if (extension === null) {
        console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        return;
      }
    }
    extension[methodName](mode2, start2, count3, primcount);
    info.update(count3, mode2, primcount);
  }
  this.setMode = setMode;
  this.render = render5;
  this.renderInstances = renderInstances;
}
function WebGLCapabilities(gl, extensions, parameters) {
  let maxAnisotropy;
  function getMaxAnisotropy() {
    if (maxAnisotropy !== void 0)
      return maxAnisotropy;
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      maxAnisotropy = 0;
    }
    return maxAnisotropy;
  }
  function getMaxPrecision(precision2) {
    if (precision2 === "highp") {
      if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) {
        return "highp";
      }
      precision2 = "mediump";
    }
    if (precision2 === "mediump") {
      if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) {
        return "mediump";
      }
    }
    return "lowp";
  }
  const isWebGL2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== "undefined" && gl instanceof WebGL2ComputeRenderingContext;
  let precision = parameters.precision !== void 0 ? parameters.precision : "highp";
  const maxPrecision = getMaxPrecision(precision);
  if (maxPrecision !== precision) {
    console.warn("THREE.WebGLRenderer:", precision, "not supported, using", maxPrecision, "instead.");
    precision = maxPrecision;
  }
  const drawBuffers = isWebGL2 || extensions.has("WEBGL_draw_buffers");
  const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
  const maxTextures = gl.getParameter(34930);
  const maxVertexTextures = gl.getParameter(35660);
  const maxTextureSize = gl.getParameter(3379);
  const maxCubemapSize = gl.getParameter(34076);
  const maxAttributes = gl.getParameter(34921);
  const maxVertexUniforms = gl.getParameter(36347);
  const maxVaryings = gl.getParameter(36348);
  const maxFragmentUniforms = gl.getParameter(36349);
  const vertexTextures = maxVertexTextures > 0;
  const floatFragmentTextures = isWebGL2 || extensions.has("OES_texture_float");
  const floatVertexTextures = vertexTextures && floatFragmentTextures;
  const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
  return {
    isWebGL2,
    drawBuffers,
    getMaxAnisotropy,
    getMaxPrecision,
    precision,
    logarithmicDepthBuffer,
    maxTextures,
    maxVertexTextures,
    maxTextureSize,
    maxCubemapSize,
    maxAttributes,
    maxVertexUniforms,
    maxVaryings,
    maxFragmentUniforms,
    vertexTextures,
    floatFragmentTextures,
    floatVertexTextures,
    maxSamples
  };
}
function WebGLClipping(properties) {
  const scope = this;
  let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
  const plane = new Plane$1(), viewNormalMatrix = new Matrix3$1(), uniform = { value: null, needsUpdate: false };
  this.uniform = uniform;
  this.numPlanes = 0;
  this.numIntersection = 0;
  this.init = function(planes, enableLocalClipping, camera) {
    const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    numGlobalPlanes !== 0 || localClippingEnabled;
    localClippingEnabled = enableLocalClipping;
    globalState = projectPlanes(planes, camera, 0);
    numGlobalPlanes = planes.length;
    return enabled;
  };
  this.beginShadows = function() {
    renderingShadows = true;
    projectPlanes(null);
  };
  this.endShadows = function() {
    renderingShadows = false;
    resetGlobalState();
  };
  this.setState = function(material, camera, useCache) {
    const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
    const materialProperties = properties.get(material);
    if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
      if (renderingShadows) {
        projectPlanes(null);
      } else {
        resetGlobalState();
      }
    } else {
      const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
      let dstArray = materialProperties.clippingState || null;
      uniform.value = dstArray;
      dstArray = projectPlanes(planes, camera, lGlobal, useCache);
      for (let i2 = 0; i2 !== lGlobal; ++i2) {
        dstArray[i2] = globalState[i2];
      }
      materialProperties.clippingState = dstArray;
      this.numIntersection = clipIntersection ? this.numPlanes : 0;
      this.numPlanes += nGlobal;
    }
  };
  function resetGlobalState() {
    if (uniform.value !== globalState) {
      uniform.value = globalState;
      uniform.needsUpdate = numGlobalPlanes > 0;
    }
    scope.numPlanes = numGlobalPlanes;
    scope.numIntersection = 0;
  }
  function projectPlanes(planes, camera, dstOffset, skipTransform) {
    const nPlanes = planes !== null ? planes.length : 0;
    let dstArray = null;
    if (nPlanes !== 0) {
      dstArray = uniform.value;
      if (skipTransform !== true || dstArray === null) {
        const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
        viewNormalMatrix.getNormalMatrix(viewMatrix);
        if (dstArray === null || dstArray.length < flatSize) {
          dstArray = new Float32Array(flatSize);
        }
        for (let i2 = 0, i4 = dstOffset; i2 !== nPlanes; ++i2, i4 += 4) {
          plane.copy(planes[i2]).applyMatrix4(viewMatrix, viewNormalMatrix);
          plane.normal.toArray(dstArray, i4);
          dstArray[i4 + 3] = plane.constant;
        }
      }
      uniform.value = dstArray;
      uniform.needsUpdate = true;
    }
    scope.numPlanes = nPlanes;
    scope.numIntersection = 0;
    return dstArray;
  }
}
function WebGLCubeMaps(renderer) {
  let cubemaps = /* @__PURE__ */ new WeakMap();
  function mapTextureMapping(texture, mapping) {
    if (mapping === EquirectangularReflectionMapping) {
      texture.mapping = CubeReflectionMapping;
    } else if (mapping === EquirectangularRefractionMapping) {
      texture.mapping = CubeRefractionMapping;
    }
    return texture;
  }
  function get6(texture) {
    if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
      const mapping = texture.mapping;
      if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
        if (cubemaps.has(texture)) {
          const cubemap = cubemaps.get(texture).texture;
          return mapTextureMapping(cubemap, texture.mapping);
        } else {
          const image = texture.image;
          if (image && image.height > 0) {
            const renderTarget = new WebGLCubeRenderTarget(image.height / 2);
            renderTarget.fromEquirectangularTexture(renderer, texture);
            cubemaps.set(texture, renderTarget);
            texture.addEventListener("dispose", onTextureDispose);
            return mapTextureMapping(renderTarget.texture, texture.mapping);
          } else {
            return null;
          }
        }
      }
    }
    return texture;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemap = cubemaps.get(texture);
    if (cubemap !== void 0) {
      cubemaps.delete(texture);
      cubemap.dispose();
    }
  }
  function dispose2() {
    cubemaps = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: get6,
    dispose: dispose2
  };
}
class OrthographicCamera extends Camera {
  constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2e3) {
    super();
    this.type = "OrthographicCamera";
    this.zoom = 1;
    this.view = null;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.near = near;
    this.far = far;
    this.updateProjectionMatrix();
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    this.left = source.left;
    this.right = source.right;
    this.top = source.top;
    this.bottom = source.bottom;
    this.near = source.near;
    this.far = source.far;
    this.zoom = source.zoom;
    this.view = source.view === null ? null : Object.assign({}, source.view);
    return this;
  }
  setViewOffset(fullWidth, fullHeight, x2, y2, width, height) {
    if (this.view === null) {
      this.view = {
        enabled: true,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1
      };
    }
    this.view.enabled = true;
    this.view.fullWidth = fullWidth;
    this.view.fullHeight = fullHeight;
    this.view.offsetX = x2;
    this.view.offsetY = y2;
    this.view.width = width;
    this.view.height = height;
    this.updateProjectionMatrix();
  }
  clearViewOffset() {
    if (this.view !== null) {
      this.view.enabled = false;
    }
    this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const dx = (this.right - this.left) / (2 * this.zoom);
    const dy = (this.top - this.bottom) / (2 * this.zoom);
    const cx = (this.right + this.left) / 2;
    const cy = (this.top + this.bottom) / 2;
    let left = cx - dx;
    let right = cx + dx;
    let top = cy + dy;
    let bottom = cy - dy;
    if (this.view !== null && this.view.enabled) {
      const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
      const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      left += scaleW * this.view.offsetX;
      right = left + scaleW * this.view.width;
      top -= scaleH * this.view.offsetY;
      bottom = top - scaleH * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
    this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    data2.object.zoom = this.zoom;
    data2.object.left = this.left;
    data2.object.right = this.right;
    data2.object.top = this.top;
    data2.object.bottom = this.bottom;
    data2.object.near = this.near;
    data2.object.far = this.far;
    if (this.view !== null)
      data2.object.view = Object.assign({}, this.view);
    return data2;
  }
}
OrthographicCamera.prototype.isOrthographicCamera = true;
const LOD_MIN = 4;
const EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582];
const MAX_SAMPLES = 20;
const _flatCamera = /* @__PURE__ */ new OrthographicCamera();
const _clearColor = /* @__PURE__ */ new Color();
let _oldTarget = null;
const PHI = (1 + Math.sqrt(5)) / 2;
const INV_PHI = 1 / PHI;
const _axisDirections = [
  /* @__PURE__ */ new Vector3$1(1, 1, 1),
  /* @__PURE__ */ new Vector3$1(-1, 1, 1),
  /* @__PURE__ */ new Vector3$1(1, 1, -1),
  /* @__PURE__ */ new Vector3$1(-1, 1, -1),
  /* @__PURE__ */ new Vector3$1(0, PHI, INV_PHI),
  /* @__PURE__ */ new Vector3$1(0, PHI, -INV_PHI),
  /* @__PURE__ */ new Vector3$1(INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3$1(-INV_PHI, 0, PHI),
  /* @__PURE__ */ new Vector3$1(PHI, INV_PHI, 0),
  /* @__PURE__ */ new Vector3$1(-PHI, INV_PHI, 0)
];
class PMREMGenerator {
  constructor(renderer) {
    this._renderer = renderer;
    this._pingPongRenderTarget = null;
    this._lodMax = 0;
    this._cubeSize = 0;
    this._lodPlanes = [];
    this._sizeLods = [];
    this._sigmas = [];
    this._blurMaterial = null;
    this._cubemapMaterial = null;
    this._equirectMaterial = null;
    this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   */
  fromScene(scene, sigma = 0, near = 0.1, far = 100) {
    _oldTarget = this._renderer.getRenderTarget();
    this._setSize(256);
    const cubeUVRenderTarget = this._allocateTargets();
    cubeUVRenderTarget.depthBuffer = true;
    this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
    if (sigma > 0) {
      this._blur(cubeUVRenderTarget, 0, 0, sigma);
    }
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  /**
   * Generates a PMREM from an equirectangular texture, which can be either LDR
   * or HDR. The ideal input image size is 1k (1024 x 512),
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromEquirectangular(equirectangular, renderTarget = null) {
    return this._fromTexture(equirectangular, renderTarget);
  }
  /**
   * Generates a PMREM from an cubemap texture, which can be either LDR
   * or HDR. The ideal input cube size is 256 x 256,
   * as this matches best with the 256 x 256 cubemap output.
   */
  fromCubemap(cubemap, renderTarget = null) {
    return this._fromTexture(cubemap, renderTarget);
  }
  /**
   * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileCubemapShader() {
    if (this._cubemapMaterial === null) {
      this._cubemapMaterial = _getCubemapMaterial();
      this._compileMaterial(this._cubemapMaterial);
    }
  }
  /**
   * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
   * your texture's network fetch for increased concurrency.
   */
  compileEquirectangularShader() {
    if (this._equirectMaterial === null) {
      this._equirectMaterial = _getEquirectMaterial();
      this._compileMaterial(this._equirectMaterial);
    }
  }
  /**
   * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
   * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
   * one of them will cause any others to also become unusable.
   */
  dispose() {
    this._dispose();
    if (this._cubemapMaterial !== null)
      this._cubemapMaterial.dispose();
    if (this._equirectMaterial !== null)
      this._equirectMaterial.dispose();
  }
  // private interface
  _setSize(cubeSize) {
    this._lodMax = Math.floor(Math.log2(cubeSize));
    this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    if (this._blurMaterial !== null)
      this._blurMaterial.dispose();
    if (this._pingPongRenderTarget !== null)
      this._pingPongRenderTarget.dispose();
    for (let i2 = 0; i2 < this._lodPlanes.length; i2++) {
      this._lodPlanes[i2].dispose();
    }
  }
  _cleanup(outputTarget) {
    this._renderer.setRenderTarget(_oldTarget);
    outputTarget.scissorTest = false;
    _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
  }
  _fromTexture(texture, renderTarget) {
    if (texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping) {
      this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
    } else {
      this._setSize(texture.image.width / 4);
    }
    _oldTarget = this._renderer.getRenderTarget();
    const cubeUVRenderTarget = renderTarget || this._allocateTargets();
    this._textureToCubeUV(texture, cubeUVRenderTarget);
    this._applyPMREM(cubeUVRenderTarget);
    this._cleanup(cubeUVRenderTarget);
    return cubeUVRenderTarget;
  }
  _allocateTargets() {
    const width = 3 * Math.max(this._cubeSize, 16 * 7);
    const height = 4 * this._cubeSize - 32;
    const params2 = {
      magFilter: LinearFilter,
      minFilter: LinearFilter,
      generateMipmaps: false,
      type: HalfFloatType,
      format: RGBAFormat,
      encoding: LinearEncoding,
      depthBuffer: false
    };
    const cubeUVRenderTarget = _createRenderTarget(width, height, params2);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width) {
      if (this._pingPongRenderTarget !== null) {
        this._dispose();
      }
      this._pingPongRenderTarget = _createRenderTarget(width, height, params2);
      const { _lodMax } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _createPlanes(_lodMax));
      this._blurMaterial = _getBlurShader(_lodMax, width, height);
    }
    return cubeUVRenderTarget;
  }
  _compileMaterial(material) {
    const tmpMesh = new Mesh(this._lodPlanes[0], material);
    this._renderer.compile(tmpMesh, _flatCamera);
  }
  _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
    const fov2 = 90;
    const aspect2 = 1;
    const cubeCamera = new PerspectiveCamera(fov2, aspect2, near, far);
    const upSign = [1, -1, 1, 1, 1, 1];
    const forwardSign = [1, 1, 1, -1, -1, -1];
    const renderer = this._renderer;
    const originalAutoClear = renderer.autoClear;
    const toneMapping = renderer.toneMapping;
    renderer.getClearColor(_clearColor);
    renderer.toneMapping = NoToneMapping;
    renderer.autoClear = false;
    const backgroundMaterial = new MeshBasicMaterial({
      name: "PMREM.Background",
      side: BackSide,
      depthWrite: false,
      depthTest: false
    });
    const backgroundBox = new Mesh(new BoxGeometry(), backgroundMaterial);
    let useSolidColor = false;
    const background = scene.background;
    if (background) {
      if (background.isColor) {
        backgroundMaterial.color.copy(background);
        scene.background = null;
        useSolidColor = true;
      }
    } else {
      backgroundMaterial.color.copy(_clearColor);
      useSolidColor = true;
    }
    for (let i2 = 0; i2 < 6; i2++) {
      const col = i2 % 3;
      if (col === 0) {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(forwardSign[i2], 0, 0);
      } else if (col === 1) {
        cubeCamera.up.set(0, 0, upSign[i2]);
        cubeCamera.lookAt(0, forwardSign[i2], 0);
      } else {
        cubeCamera.up.set(0, upSign[i2], 0);
        cubeCamera.lookAt(0, 0, forwardSign[i2]);
      }
      const size12 = this._cubeSize;
      _setViewport(cubeUVRenderTarget, col * size12, i2 > 2 ? size12 : 0, size12, size12);
      renderer.setRenderTarget(cubeUVRenderTarget);
      if (useSolidColor) {
        renderer.render(backgroundBox, cubeCamera);
      }
      renderer.render(scene, cubeCamera);
    }
    backgroundBox.geometry.dispose();
    backgroundBox.material.dispose();
    renderer.toneMapping = toneMapping;
    renderer.autoClear = originalAutoClear;
    scene.background = background;
  }
  _textureToCubeUV(texture, cubeUVRenderTarget) {
    const renderer = this._renderer;
    const isCubeTexture = texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping;
    if (isCubeTexture) {
      if (this._cubemapMaterial === null) {
        this._cubemapMaterial = _getCubemapMaterial();
      }
      this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
    } else {
      if (this._equirectMaterial === null) {
        this._equirectMaterial = _getEquirectMaterial();
      }
    }
    const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
    const mesh = new Mesh(this._lodPlanes[0], material);
    const uniforms = material.uniforms;
    uniforms["envMap"].value = texture;
    const size12 = this._cubeSize;
    _setViewport(cubeUVRenderTarget, 0, 0, 3 * size12, 2 * size12);
    renderer.setRenderTarget(cubeUVRenderTarget);
    renderer.render(mesh, _flatCamera);
  }
  _applyPMREM(cubeUVRenderTarget) {
    const renderer = this._renderer;
    const autoClear = renderer.autoClear;
    renderer.autoClear = false;
    for (let i2 = 1; i2 < this._lodPlanes.length; i2++) {
      const sigma = Math.sqrt(this._sigmas[i2] * this._sigmas[i2] - this._sigmas[i2 - 1] * this._sigmas[i2 - 1]);
      const poleAxis = _axisDirections[(i2 - 1) % _axisDirections.length];
      this._blur(cubeUVRenderTarget, i2 - 1, i2, sigma, poleAxis);
    }
    renderer.autoClear = autoClear;
  }
  /**
   * This is a two-pass Gaussian blur for a cubemap. Normally this is done
   * vertically and horizontally, but this breaks down on a cube. Here we apply
   * the blur latitudinally (around the poles), and then longitudinally (towards
   * the poles) to approximate the orthogonally-separable blur. It is least
   * accurate at the poles, but still does a decent job.
   */
  _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
    const pingPongRenderTarget = this._pingPongRenderTarget;
    this._halfBlur(
      cubeUVRenderTarget,
      pingPongRenderTarget,
      lodIn,
      lodOut,
      sigma,
      "latitudinal",
      poleAxis
    );
    this._halfBlur(
      pingPongRenderTarget,
      cubeUVRenderTarget,
      lodOut,
      lodOut,
      sigma,
      "longitudinal",
      poleAxis
    );
  }
  _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
    const renderer = this._renderer;
    const blurMaterial = this._blurMaterial;
    if (direction !== "latitudinal" && direction !== "longitudinal") {
      console.error(
        "blur direction must be either latitudinal or longitudinal!"
      );
    }
    const STANDARD_DEVIATIONS = 3;
    const blurMesh = new Mesh(this._lodPlanes[lodOut], blurMaterial);
    const blurUniforms = blurMaterial.uniforms;
    const pixels = this._sizeLods[lodIn] - 1;
    const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
    const sigmaPixels = sigmaRadians / radiansPerPixel;
    const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
    if (samples > MAX_SAMPLES) {
      console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
    }
    const weights = [];
    let sum2 = 0;
    for (let i2 = 0; i2 < MAX_SAMPLES; ++i2) {
      const x3 = i2 / sigmaPixels;
      const weight = Math.exp(-x3 * x3 / 2);
      weights.push(weight);
      if (i2 === 0) {
        sum2 += weight;
      } else if (i2 < samples) {
        sum2 += 2 * weight;
      }
    }
    for (let i2 = 0; i2 < weights.length; i2++) {
      weights[i2] = weights[i2] / sum2;
    }
    blurUniforms["envMap"].value = targetIn.texture;
    blurUniforms["samples"].value = samples;
    blurUniforms["weights"].value = weights;
    blurUniforms["latitudinal"].value = direction === "latitudinal";
    if (poleAxis) {
      blurUniforms["poleAxis"].value = poleAxis;
    }
    const { _lodMax } = this;
    blurUniforms["dTheta"].value = radiansPerPixel;
    blurUniforms["mipInt"].value = _lodMax - lodIn;
    const outputSize = this._sizeLods[lodOut];
    const x2 = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
    const y2 = 4 * (this._cubeSize - outputSize);
    _setViewport(targetOut, x2, y2, 3 * outputSize, 2 * outputSize);
    renderer.setRenderTarget(targetOut);
    renderer.render(blurMesh, _flatCamera);
  }
}
function _createPlanes(lodMax) {
  const lodPlanes = [];
  const sizeLods = [];
  const sigmas = [];
  let lod = lodMax;
  const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
  for (let i2 = 0; i2 < totalLods; i2++) {
    const sizeLod = Math.pow(2, lod);
    sizeLods.push(sizeLod);
    let sigma = 1 / sizeLod;
    if (i2 > lodMax - LOD_MIN) {
      sigma = EXTRA_LOD_SIGMA[i2 - lodMax + LOD_MIN - 1];
    } else if (i2 === 0) {
      sigma = 0;
    }
    sigmas.push(sigma);
    const texelSize = 1 / (sizeLod - 1);
    const min4 = -texelSize / 2;
    const max3 = 1 + texelSize / 2;
    const uv1 = [min4, min4, max3, min4, max3, max3, min4, min4, max3, max3, min4, max3];
    const cubeFaces = 6;
    const vertices = 6;
    const positionSize = 3;
    const uvSize = 2;
    const faceIndexSize = 1;
    const position = new Float32Array(positionSize * vertices * cubeFaces);
    const uv = new Float32Array(uvSize * vertices * cubeFaces);
    const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
    for (let face = 0; face < cubeFaces; face++) {
      const x2 = face % 3 * 2 / 3 - 1;
      const y2 = face > 2 ? 0 : -1;
      const coordinates2 = [
        x2,
        y2,
        0,
        x2 + 2 / 3,
        y2,
        0,
        x2 + 2 / 3,
        y2 + 1,
        0,
        x2,
        y2,
        0,
        x2 + 2 / 3,
        y2 + 1,
        0,
        x2,
        y2 + 1,
        0
      ];
      position.set(coordinates2, positionSize * vertices * face);
      uv.set(uv1, uvSize * vertices * face);
      const fill = [face, face, face, face, face, face];
      faceIndex.set(fill, faceIndexSize * vertices * face);
    }
    const planes = new BufferGeometry();
    planes.setAttribute("position", new BufferAttribute(position, positionSize));
    planes.setAttribute("uv", new BufferAttribute(uv, uvSize));
    planes.setAttribute("faceIndex", new BufferAttribute(faceIndex, faceIndexSize));
    lodPlanes.push(planes);
    if (lod > LOD_MIN) {
      lod--;
    }
  }
  return { lodPlanes, sizeLods, sigmas };
}
function _createRenderTarget(width, height, params2) {
  const cubeUVRenderTarget = new WebGLRenderTarget(width, height, params2);
  cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
  cubeUVRenderTarget.texture.name = "PMREM.cubeUv";
  cubeUVRenderTarget.scissorTest = true;
  return cubeUVRenderTarget;
}
function _setViewport(target, x2, y2, width, height) {
  target.viewport.set(x2, y2, width, height);
  target.scissor.set(x2, y2, width, height);
}
function _getBlurShader(lodMax, width, height) {
  const weights = new Float32Array(MAX_SAMPLES);
  const poleAxis = new Vector3$1(0, 1, 0);
  const shaderMaterial = new ShaderMaterial({
    name: "SphericalGaussianBlur",
    defines: {
      "n": MAX_SAMPLES,
      "CUBEUV_TEXEL_WIDTH": 1 / width,
      "CUBEUV_TEXEL_HEIGHT": 1 / height,
      "CUBEUV_MAX_MIP": `${lodMax}.0`
    },
    uniforms: {
      "envMap": { value: null },
      "samples": { value: 1 },
      "weights": { value: weights },
      "latitudinal": { value: false },
      "dTheta": { value: 0 },
      "mipInt": { value: 0 },
      "poleAxis": { value: poleAxis }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}
function _getEquirectMaterial() {
  return new ShaderMaterial({
    name: "EquirectangularToCubeUV",
    uniforms: {
      "envMap": { value: null }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}
function _getCubemapMaterial() {
  return new ShaderMaterial({
    name: "CubemapToCubeUV",
    uniforms: {
      "envMap": { value: null },
      "flipEnvMap": { value: -1 }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader: (
      /* glsl */
      `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`
    ),
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}
function _getCommonVertexShader() {
  return (
    /* glsl */
    `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
  );
}
function WebGLCubeUVMaps(renderer) {
  let cubeUVmaps = /* @__PURE__ */ new WeakMap();
  let pmremGenerator = null;
  function get6(texture) {
    if (texture && texture.isTexture) {
      const mapping = texture.mapping;
      const isEquirectMap = mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping;
      const isCubeMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping;
      if (isEquirectMap || isCubeMap) {
        if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
          texture.needsPMREMUpdate = false;
          let renderTarget = cubeUVmaps.get(texture);
          if (pmremGenerator === null)
            pmremGenerator = new PMREMGenerator(renderer);
          renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
          cubeUVmaps.set(texture, renderTarget);
          return renderTarget.texture;
        } else {
          if (cubeUVmaps.has(texture)) {
            return cubeUVmaps.get(texture).texture;
          } else {
            const image = texture.image;
            if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
              if (pmremGenerator === null)
                pmremGenerator = new PMREMGenerator(renderer);
              const renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
              cubeUVmaps.set(texture, renderTarget);
              texture.addEventListener("dispose", onTextureDispose);
              return renderTarget.texture;
            } else {
              return null;
            }
          }
        }
      }
    }
    return texture;
  }
  function isCubeTextureComplete(image) {
    let count3 = 0;
    const length2 = 6;
    for (let i2 = 0; i2 < length2; i2++) {
      if (image[i2] !== void 0)
        count3++;
    }
    return count3 === length2;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    const cubemapUV = cubeUVmaps.get(texture);
    if (cubemapUV !== void 0) {
      cubeUVmaps.delete(texture);
      cubemapUV.dispose();
    }
  }
  function dispose2() {
    cubeUVmaps = /* @__PURE__ */ new WeakMap();
    if (pmremGenerator !== null) {
      pmremGenerator.dispose();
      pmremGenerator = null;
    }
  }
  return {
    get: get6,
    dispose: dispose2
  };
}
function WebGLExtensions(gl) {
  const extensions = {};
  function getExtension(name2) {
    if (extensions[name2] !== void 0) {
      return extensions[name2];
    }
    let extension;
    switch (name2) {
      case "WEBGL_depth_texture":
        extension = gl.getExtension("WEBGL_depth_texture") || gl.getExtension("MOZ_WEBGL_depth_texture") || gl.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        extension = gl.getExtension("EXT_texture_filter_anisotropic") || gl.getExtension("MOZ_EXT_texture_filter_anisotropic") || gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        extension = gl.getExtension("WEBGL_compressed_texture_s3tc") || gl.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        extension = gl.getExtension("WEBGL_compressed_texture_pvrtc") || gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        extension = gl.getExtension(name2);
    }
    extensions[name2] = extension;
    return extension;
  }
  return {
    has: function(name2) {
      return getExtension(name2) !== null;
    },
    init: function(capabilities) {
      if (capabilities.isWebGL2) {
        getExtension("EXT_color_buffer_float");
      } else {
        getExtension("WEBGL_depth_texture");
        getExtension("OES_texture_float");
        getExtension("OES_texture_half_float");
        getExtension("OES_texture_half_float_linear");
        getExtension("OES_standard_derivatives");
        getExtension("OES_element_index_uint");
        getExtension("OES_vertex_array_object");
        getExtension("ANGLE_instanced_arrays");
      }
      getExtension("OES_texture_float_linear");
      getExtension("EXT_color_buffer_half_float");
      getExtension("WEBGL_multisampled_render_to_texture");
    },
    get: function(name2) {
      const extension = getExtension(name2);
      if (extension === null) {
        console.warn("THREE.WebGLRenderer: " + name2 + " extension not supported.");
      }
      return extension;
    }
  };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
  const geometries = {};
  const wireframeAttributes = /* @__PURE__ */ new WeakMap();
  function onGeometryDispose(event) {
    const geometry2 = event.target;
    if (geometry2.index !== null) {
      attributes.remove(geometry2.index);
    }
    for (const name2 in geometry2.attributes) {
      attributes.remove(geometry2.attributes[name2]);
    }
    geometry2.removeEventListener("dispose", onGeometryDispose);
    delete geometries[geometry2.id];
    const attribute = wireframeAttributes.get(geometry2);
    if (attribute) {
      attributes.remove(attribute);
      wireframeAttributes.delete(geometry2);
    }
    bindingStates.releaseStatesOfGeometry(geometry2);
    if (geometry2.isInstancedBufferGeometry === true) {
      delete geometry2._maxInstanceCount;
    }
    info.memory.geometries--;
  }
  function get6(object2, geometry2) {
    if (geometries[geometry2.id] === true)
      return geometry2;
    geometry2.addEventListener("dispose", onGeometryDispose);
    geometries[geometry2.id] = true;
    info.memory.geometries++;
    return geometry2;
  }
  function update(geometry2) {
    const geometryAttributes = geometry2.attributes;
    for (const name2 in geometryAttributes) {
      attributes.update(geometryAttributes[name2], 34962);
    }
    const morphAttributes = geometry2.morphAttributes;
    for (const name2 in morphAttributes) {
      const array2 = morphAttributes[name2];
      for (let i2 = 0, l2 = array2.length; i2 < l2; i2++) {
        attributes.update(array2[i2], 34962);
      }
    }
  }
  function updateWireframeAttribute(geometry2) {
    const indices = [];
    const geometryIndex = geometry2.index;
    const geometryPosition = geometry2.attributes.position;
    let version2 = 0;
    if (geometryIndex !== null) {
      const array2 = geometryIndex.array;
      version2 = geometryIndex.version;
      for (let i2 = 0, l2 = array2.length; i2 < l2; i2 += 3) {
        const a2 = array2[i2 + 0];
        const b2 = array2[i2 + 1];
        const c2 = array2[i2 + 2];
        indices.push(a2, b2, b2, c2, c2, a2);
      }
    } else {
      const array2 = geometryPosition.array;
      version2 = geometryPosition.version;
      for (let i2 = 0, l2 = array2.length / 3 - 1; i2 < l2; i2 += 3) {
        const a2 = i2 + 0;
        const b2 = i2 + 1;
        const c2 = i2 + 2;
        indices.push(a2, b2, b2, c2, c2, a2);
      }
    }
    const attribute = new (arrayNeedsUint32(indices) ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
    attribute.version = version2;
    const previousAttribute = wireframeAttributes.get(geometry2);
    if (previousAttribute)
      attributes.remove(previousAttribute);
    wireframeAttributes.set(geometry2, attribute);
  }
  function getWireframeAttribute(geometry2) {
    const currentAttribute = wireframeAttributes.get(geometry2);
    if (currentAttribute) {
      const geometryIndex = geometry2.index;
      if (geometryIndex !== null) {
        if (currentAttribute.version < geometryIndex.version) {
          updateWireframeAttribute(geometry2);
        }
      }
    } else {
      updateWireframeAttribute(geometry2);
    }
    return wireframeAttributes.get(geometry2);
  }
  return {
    get: get6,
    update,
    getWireframeAttribute
  };
}
function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  let mode2;
  function setMode(value) {
    mode2 = value;
  }
  let type, bytesPerElement;
  function setIndex(value) {
    type = value.type;
    bytesPerElement = value.bytesPerElement;
  }
  function render5(start2, count3) {
    gl.drawElements(mode2, count3, type, start2 * bytesPerElement);
    info.update(count3, mode2, 1);
  }
  function renderInstances(start2, count3, primcount) {
    if (primcount === 0)
      return;
    let extension, methodName;
    if (isWebGL2) {
      extension = gl;
      methodName = "drawElementsInstanced";
    } else {
      extension = extensions.get("ANGLE_instanced_arrays");
      methodName = "drawElementsInstancedANGLE";
      if (extension === null) {
        console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
        return;
      }
    }
    extension[methodName](mode2, count3, type, start2 * bytesPerElement, primcount);
    info.update(count3, mode2, primcount);
  }
  this.setMode = setMode;
  this.setIndex = setIndex;
  this.render = render5;
  this.renderInstances = renderInstances;
}
function WebGLInfo(gl) {
  const memory = {
    geometries: 0,
    textures: 0
  };
  const render5 = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function update(count3, mode2, instanceCount) {
    render5.calls++;
    switch (mode2) {
      case 4:
        render5.triangles += instanceCount * (count3 / 3);
        break;
      case 1:
        render5.lines += instanceCount * (count3 / 2);
        break;
      case 3:
        render5.lines += instanceCount * (count3 - 1);
        break;
      case 2:
        render5.lines += instanceCount * count3;
        break;
      case 0:
        render5.points += instanceCount * count3;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", mode2);
        break;
    }
  }
  function reset2() {
    render5.frame++;
    render5.calls = 0;
    render5.triangles = 0;
    render5.points = 0;
    render5.lines = 0;
  }
  return {
    memory,
    render: render5,
    programs: null,
    autoReset: true,
    reset: reset2,
    update
  };
}
function numericalSort(a2, b2) {
  return a2[0] - b2[0];
}
function absNumericalSort(a2, b2) {
  return Math.abs(b2[1]) - Math.abs(a2[1]);
}
function denormalize(morph, attribute) {
  let denominator = 1;
  const array2 = attribute.isInterleavedBufferAttribute ? attribute.data.array : attribute.array;
  if (array2 instanceof Int8Array)
    denominator = 127;
  else if (array2 instanceof Int16Array)
    denominator = 32767;
  else if (array2 instanceof Int32Array)
    denominator = 2147483647;
  else
    console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", array2);
  morph.divideScalar(denominator);
}
function WebGLMorphtargets(gl, capabilities, textures) {
  const influencesList = {};
  const morphInfluences = new Float32Array(8);
  const morphTextures = /* @__PURE__ */ new WeakMap();
  const morph = new Vector4$1();
  const workInfluences = [];
  for (let i2 = 0; i2 < 8; i2++) {
    workInfluences[i2] = [i2, 0];
  }
  function update(object2, geometry2, material, program) {
    const objectInfluences = object2.morphTargetInfluences;
    if (capabilities.isWebGL2 === true) {
      const morphAttribute = geometry2.morphAttributes.position || geometry2.morphAttributes.normal || geometry2.morphAttributes.color;
      const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
      let entry = morphTextures.get(geometry2);
      if (entry === void 0 || entry.count !== morphTargetsCount) {
        let disposeTexture = function() {
          texture.dispose();
          morphTextures.delete(geometry2);
          geometry2.removeEventListener("dispose", disposeTexture);
        };
        if (entry !== void 0)
          entry.texture.dispose();
        const hasMorphPosition = geometry2.morphAttributes.position !== void 0;
        const hasMorphNormals = geometry2.morphAttributes.normal !== void 0;
        const hasMorphColors = geometry2.morphAttributes.color !== void 0;
        const morphTargets = geometry2.morphAttributes.position || [];
        const morphNormals = geometry2.morphAttributes.normal || [];
        const morphColors = geometry2.morphAttributes.color || [];
        let vertexDataCount = 0;
        if (hasMorphPosition === true)
          vertexDataCount = 1;
        if (hasMorphNormals === true)
          vertexDataCount = 2;
        if (hasMorphColors === true)
          vertexDataCount = 3;
        let width = geometry2.attributes.position.count * vertexDataCount;
        let height = 1;
        if (width > capabilities.maxTextureSize) {
          height = Math.ceil(width / capabilities.maxTextureSize);
          width = capabilities.maxTextureSize;
        }
        const buffer3 = new Float32Array(width * height * 4 * morphTargetsCount);
        const texture = new DataArrayTexture(buffer3, width, height, morphTargetsCount);
        texture.type = FloatType;
        texture.needsUpdate = true;
        const vertexDataStride = vertexDataCount * 4;
        for (let i2 = 0; i2 < morphTargetsCount; i2++) {
          const morphTarget = morphTargets[i2];
          const morphNormal = morphNormals[i2];
          const morphColor = morphColors[i2];
          const offset = width * height * 4 * i2;
          for (let j2 = 0; j2 < morphTarget.count; j2++) {
            const stride = j2 * vertexDataStride;
            if (hasMorphPosition === true) {
              morph.fromBufferAttribute(morphTarget, j2);
              if (morphTarget.normalized === true)
                denormalize(morph, morphTarget);
              buffer3[offset + stride + 0] = morph.x;
              buffer3[offset + stride + 1] = morph.y;
              buffer3[offset + stride + 2] = morph.z;
              buffer3[offset + stride + 3] = 0;
            }
            if (hasMorphNormals === true) {
              morph.fromBufferAttribute(morphNormal, j2);
              if (morphNormal.normalized === true)
                denormalize(morph, morphNormal);
              buffer3[offset + stride + 4] = morph.x;
              buffer3[offset + stride + 5] = morph.y;
              buffer3[offset + stride + 6] = morph.z;
              buffer3[offset + stride + 7] = 0;
            }
            if (hasMorphColors === true) {
              morph.fromBufferAttribute(morphColor, j2);
              if (morphColor.normalized === true)
                denormalize(morph, morphColor);
              buffer3[offset + stride + 8] = morph.x;
              buffer3[offset + stride + 9] = morph.y;
              buffer3[offset + stride + 10] = morph.z;
              buffer3[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
            }
          }
        }
        entry = {
          count: morphTargetsCount,
          texture,
          size: new Vector2$1(width, height)
        };
        morphTextures.set(geometry2, entry);
        geometry2.addEventListener("dispose", disposeTexture);
      }
      let morphInfluencesSum = 0;
      for (let i2 = 0; i2 < objectInfluences.length; i2++) {
        morphInfluencesSum += objectInfluences[i2];
      }
      const morphBaseInfluence = geometry2.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
      program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
      program.getUniforms().setValue(gl, "morphTargetInfluences", objectInfluences);
      program.getUniforms().setValue(gl, "morphTargetsTexture", entry.texture, textures);
      program.getUniforms().setValue(gl, "morphTargetsTextureSize", entry.size);
    } else {
      const length2 = objectInfluences === void 0 ? 0 : objectInfluences.length;
      let influences = influencesList[geometry2.id];
      if (influences === void 0 || influences.length !== length2) {
        influences = [];
        for (let i2 = 0; i2 < length2; i2++) {
          influences[i2] = [i2, 0];
        }
        influencesList[geometry2.id] = influences;
      }
      for (let i2 = 0; i2 < length2; i2++) {
        const influence = influences[i2];
        influence[0] = i2;
        influence[1] = objectInfluences[i2];
      }
      influences.sort(absNumericalSort);
      for (let i2 = 0; i2 < 8; i2++) {
        if (i2 < length2 && influences[i2][1]) {
          workInfluences[i2][0] = influences[i2][0];
          workInfluences[i2][1] = influences[i2][1];
        } else {
          workInfluences[i2][0] = Number.MAX_SAFE_INTEGER;
          workInfluences[i2][1] = 0;
        }
      }
      workInfluences.sort(numericalSort);
      const morphTargets = geometry2.morphAttributes.position;
      const morphNormals = geometry2.morphAttributes.normal;
      let morphInfluencesSum = 0;
      for (let i2 = 0; i2 < 8; i2++) {
        const influence = workInfluences[i2];
        const index2 = influence[0];
        const value = influence[1];
        if (index2 !== Number.MAX_SAFE_INTEGER && value) {
          if (morphTargets && geometry2.getAttribute("morphTarget" + i2) !== morphTargets[index2]) {
            geometry2.setAttribute("morphTarget" + i2, morphTargets[index2]);
          }
          if (morphNormals && geometry2.getAttribute("morphNormal" + i2) !== morphNormals[index2]) {
            geometry2.setAttribute("morphNormal" + i2, morphNormals[index2]);
          }
          morphInfluences[i2] = value;
          morphInfluencesSum += value;
        } else {
          if (morphTargets && geometry2.hasAttribute("morphTarget" + i2) === true) {
            geometry2.deleteAttribute("morphTarget" + i2);
          }
          if (morphNormals && geometry2.hasAttribute("morphNormal" + i2) === true) {
            geometry2.deleteAttribute("morphNormal" + i2);
          }
          morphInfluences[i2] = 0;
        }
      }
      const morphBaseInfluence = geometry2.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
      program.getUniforms().setValue(gl, "morphTargetBaseInfluence", morphBaseInfluence);
      program.getUniforms().setValue(gl, "morphTargetInfluences", morphInfluences);
    }
  }
  return {
    update
  };
}
function WebGLObjects(gl, geometries, attributes, info) {
  let updateMap = /* @__PURE__ */ new WeakMap();
  function update(object2) {
    const frame = info.render.frame;
    const geometry2 = object2.geometry;
    const buffergeometry = geometries.get(object2, geometry2);
    if (updateMap.get(buffergeometry) !== frame) {
      geometries.update(buffergeometry);
      updateMap.set(buffergeometry, frame);
    }
    if (object2.isInstancedMesh) {
      if (object2.hasEventListener("dispose", onInstancedMeshDispose) === false) {
        object2.addEventListener("dispose", onInstancedMeshDispose);
      }
      attributes.update(object2.instanceMatrix, 34962);
      if (object2.instanceColor !== null) {
        attributes.update(object2.instanceColor, 34962);
      }
    }
    return buffergeometry;
  }
  function dispose2() {
    updateMap = /* @__PURE__ */ new WeakMap();
  }
  function onInstancedMeshDispose(event) {
    const instancedMesh = event.target;
    instancedMesh.removeEventListener("dispose", onInstancedMeshDispose);
    attributes.remove(instancedMesh.instanceMatrix);
    if (instancedMesh.instanceColor !== null)
      attributes.remove(instancedMesh.instanceColor);
  }
  return {
    update,
    dispose: dispose2
  };
}
const emptyTexture = new Texture$1();
const emptyArrayTexture = new DataArrayTexture();
const empty3dTexture = new Data3DTexture();
const emptyCubeTexture = new CubeTexture();
const arrayCacheF32 = [];
const arrayCacheI32 = [];
const mat4array = new Float32Array(16);
const mat3array = new Float32Array(9);
const mat2array = new Float32Array(4);
function flatten$3(array2, nBlocks, blockSize) {
  const firstElem = array2[0];
  if (firstElem <= 0 || firstElem > 0)
    return array2;
  const n2 = nBlocks * blockSize;
  let r2 = arrayCacheF32[n2];
  if (r2 === void 0) {
    r2 = new Float32Array(n2);
    arrayCacheF32[n2] = r2;
  }
  if (nBlocks !== 0) {
    firstElem.toArray(r2, 0);
    for (let i2 = 1, offset = 0; i2 !== nBlocks; ++i2) {
      offset += blockSize;
      array2[i2].toArray(r2, offset);
    }
  }
  return r2;
}
function arraysEqual(a2, b2) {
  if (a2.length !== b2.length)
    return false;
  for (let i2 = 0, l2 = a2.length; i2 < l2; i2++) {
    if (a2[i2] !== b2[i2])
      return false;
  }
  return true;
}
function copyArray$3(a2, b2) {
  for (let i2 = 0, l2 = b2.length; i2 < l2; i2++) {
    a2[i2] = b2[i2];
  }
}
function allocTexUnits(textures, n2) {
  let r2 = arrayCacheI32[n2];
  if (r2 === void 0) {
    r2 = new Int32Array(n2);
    arrayCacheI32[n2] = r2;
  }
  for (let i2 = 0; i2 !== n2; ++i2) {
    r2[i2] = textures.allocateTextureUnit();
  }
  return r2;
}
function setValueV1f(gl, v5) {
  const cache2 = this.cache;
  if (cache2[0] === v5)
    return;
  gl.uniform1f(this.addr, v5);
  cache2[0] = v5;
}
function setValueV2f(gl, v5) {
  const cache2 = this.cache;
  if (v5.x !== void 0) {
    if (cache2[0] !== v5.x || cache2[1] !== v5.y) {
      gl.uniform2f(this.addr, v5.x, v5.y);
      cache2[0] = v5.x;
      cache2[1] = v5.y;
    }
  } else {
    if (arraysEqual(cache2, v5))
      return;
    gl.uniform2fv(this.addr, v5);
    copyArray$3(cache2, v5);
  }
}
function setValueV3f(gl, v5) {
  const cache2 = this.cache;
  if (v5.x !== void 0) {
    if (cache2[0] !== v5.x || cache2[1] !== v5.y || cache2[2] !== v5.z) {
      gl.uniform3f(this.addr, v5.x, v5.y, v5.z);
      cache2[0] = v5.x;
      cache2[1] = v5.y;
      cache2[2] = v5.z;
    }
  } else if (v5.r !== void 0) {
    if (cache2[0] !== v5.r || cache2[1] !== v5.g || cache2[2] !== v5.b) {
      gl.uniform3f(this.addr, v5.r, v5.g, v5.b);
      cache2[0] = v5.r;
      cache2[1] = v5.g;
      cache2[2] = v5.b;
    }
  } else {
    if (arraysEqual(cache2, v5))
      return;
    gl.uniform3fv(this.addr, v5);
    copyArray$3(cache2, v5);
  }
}
function setValueV4f(gl, v5) {
  const cache2 = this.cache;
  if (v5.x !== void 0) {
    if (cache2[0] !== v5.x || cache2[1] !== v5.y || cache2[2] !== v5.z || cache2[3] !== v5.w) {
      gl.uniform4f(this.addr, v5.x, v5.y, v5.z, v5.w);
      cache2[0] = v5.x;
      cache2[1] = v5.y;
      cache2[2] = v5.z;
      cache2[3] = v5.w;
    }
  } else {
    if (arraysEqual(cache2, v5))
      return;
    gl.uniform4fv(this.addr, v5);
    copyArray$3(cache2, v5);
  }
}
function setValueM2(gl, v5) {
  const cache2 = this.cache;
  const elements = v5.elements;
  if (elements === void 0) {
    if (arraysEqual(cache2, v5))
      return;
    gl.uniformMatrix2fv(this.addr, false, v5);
    copyArray$3(cache2, v5);
  } else {
    if (arraysEqual(cache2, elements))
      return;
    mat2array.set(elements);
    gl.uniformMatrix2fv(this.addr, false, mat2array);
    copyArray$3(cache2, elements);
  }
}
function setValueM3(gl, v5) {
  const cache2 = this.cache;
  const elements = v5.elements;
  if (elements === void 0) {
    if (arraysEqual(cache2, v5))
      return;
    gl.uniformMatrix3fv(this.addr, false, v5);
    copyArray$3(cache2, v5);
  } else {
    if (arraysEqual(cache2, elements))
      return;
    mat3array.set(elements);
    gl.uniformMatrix3fv(this.addr, false, mat3array);
    copyArray$3(cache2, elements);
  }
}
function setValueM4(gl, v5) {
  const cache2 = this.cache;
  const elements = v5.elements;
  if (elements === void 0) {
    if (arraysEqual(cache2, v5))
      return;
    gl.uniformMatrix4fv(this.addr, false, v5);
    copyArray$3(cache2, v5);
  } else {
    if (arraysEqual(cache2, elements))
      return;
    mat4array.set(elements);
    gl.uniformMatrix4fv(this.addr, false, mat4array);
    copyArray$3(cache2, elements);
  }
}
function setValueV1i(gl, v5) {
  const cache2 = this.cache;
  if (cache2[0] === v5)
    return;
  gl.uniform1i(this.addr, v5);
  cache2[0] = v5;
}
function setValueV2i(gl, v5) {
  const cache2 = this.cache;
  if (arraysEqual(cache2, v5))
    return;
  gl.uniform2iv(this.addr, v5);
  copyArray$3(cache2, v5);
}
function setValueV3i(gl, v5) {
  const cache2 = this.cache;
  if (arraysEqual(cache2, v5))
    return;
  gl.uniform3iv(this.addr, v5);
  copyArray$3(cache2, v5);
}
function setValueV4i(gl, v5) {
  const cache2 = this.cache;
  if (arraysEqual(cache2, v5))
    return;
  gl.uniform4iv(this.addr, v5);
  copyArray$3(cache2, v5);
}
function setValueV1ui(gl, v5) {
  const cache2 = this.cache;
  if (cache2[0] === v5)
    return;
  gl.uniform1ui(this.addr, v5);
  cache2[0] = v5;
}
function setValueV2ui(gl, v5) {
  const cache2 = this.cache;
  if (arraysEqual(cache2, v5))
    return;
  gl.uniform2uiv(this.addr, v5);
  copyArray$3(cache2, v5);
}
function setValueV3ui(gl, v5) {
  const cache2 = this.cache;
  if (arraysEqual(cache2, v5))
    return;
  gl.uniform3uiv(this.addr, v5);
  copyArray$3(cache2, v5);
}
function setValueV4ui(gl, v5) {
  const cache2 = this.cache;
  if (arraysEqual(cache2, v5))
    return;
  gl.uniform4uiv(this.addr, v5);
  copyArray$3(cache2, v5);
}
function setValueT1(gl, v5, textures) {
  const cache2 = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache2[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache2[0] = unit;
  }
  textures.setTexture2D(v5 || emptyTexture, unit);
}
function setValueT3D1(gl, v5, textures) {
  const cache2 = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache2[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache2[0] = unit;
  }
  textures.setTexture3D(v5 || empty3dTexture, unit);
}
function setValueT6(gl, v5, textures) {
  const cache2 = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache2[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache2[0] = unit;
  }
  textures.setTextureCube(v5 || emptyCubeTexture, unit);
}
function setValueT2DArray1(gl, v5, textures) {
  const cache2 = this.cache;
  const unit = textures.allocateTextureUnit();
  if (cache2[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache2[0] = unit;
  }
  textures.setTexture2DArray(v5 || emptyArrayTexture, unit);
}
function getSingularSetter(type) {
  switch (type) {
    case 5126:
      return setValueV1f;
    case 35664:
      return setValueV2f;
    case 35665:
      return setValueV3f;
    case 35666:
      return setValueV4f;
    case 35674:
      return setValueM2;
    case 35675:
      return setValueM3;
    case 35676:
      return setValueM4;
    case 5124:
    case 35670:
      return setValueV1i;
    case 35667:
    case 35671:
      return setValueV2i;
    case 35668:
    case 35672:
      return setValueV3i;
    case 35669:
    case 35673:
      return setValueV4i;
    case 5125:
      return setValueV1ui;
    case 36294:
      return setValueV2ui;
    case 36295:
      return setValueV3ui;
    case 36296:
      return setValueV4ui;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3D1;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArray1;
  }
}
function setValueV1fArray(gl, v5) {
  gl.uniform1fv(this.addr, v5);
}
function setValueV2fArray(gl, v5) {
  const data2 = flatten$3(v5, this.size, 2);
  gl.uniform2fv(this.addr, data2);
}
function setValueV3fArray(gl, v5) {
  const data2 = flatten$3(v5, this.size, 3);
  gl.uniform3fv(this.addr, data2);
}
function setValueV4fArray(gl, v5) {
  const data2 = flatten$3(v5, this.size, 4);
  gl.uniform4fv(this.addr, data2);
}
function setValueM2Array(gl, v5) {
  const data2 = flatten$3(v5, this.size, 4);
  gl.uniformMatrix2fv(this.addr, false, data2);
}
function setValueM3Array(gl, v5) {
  const data2 = flatten$3(v5, this.size, 9);
  gl.uniformMatrix3fv(this.addr, false, data2);
}
function setValueM4Array(gl, v5) {
  const data2 = flatten$3(v5, this.size, 16);
  gl.uniformMatrix4fv(this.addr, false, data2);
}
function setValueV1iArray(gl, v5) {
  gl.uniform1iv(this.addr, v5);
}
function setValueV2iArray(gl, v5) {
  gl.uniform2iv(this.addr, v5);
}
function setValueV3iArray(gl, v5) {
  gl.uniform3iv(this.addr, v5);
}
function setValueV4iArray(gl, v5) {
  gl.uniform4iv(this.addr, v5);
}
function setValueV1uiArray(gl, v5) {
  gl.uniform1uiv(this.addr, v5);
}
function setValueV2uiArray(gl, v5) {
  gl.uniform2uiv(this.addr, v5);
}
function setValueV3uiArray(gl, v5) {
  gl.uniform3uiv(this.addr, v5);
}
function setValueV4uiArray(gl, v5) {
  gl.uniform4uiv(this.addr, v5);
}
function setValueT1Array(gl, v5, textures) {
  const n2 = v5.length;
  const units2 = allocTexUnits(textures, n2);
  gl.uniform1iv(this.addr, units2);
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture2D(v5[i2] || emptyTexture, units2[i2]);
  }
}
function setValueT3DArray(gl, v5, textures) {
  const n2 = v5.length;
  const units2 = allocTexUnits(textures, n2);
  gl.uniform1iv(this.addr, units2);
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture3D(v5[i2] || empty3dTexture, units2[i2]);
  }
}
function setValueT6Array(gl, v5, textures) {
  const n2 = v5.length;
  const units2 = allocTexUnits(textures, n2);
  gl.uniform1iv(this.addr, units2);
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTextureCube(v5[i2] || emptyCubeTexture, units2[i2]);
  }
}
function setValueT2DArrayArray(gl, v5, textures) {
  const n2 = v5.length;
  const units2 = allocTexUnits(textures, n2);
  gl.uniform1iv(this.addr, units2);
  for (let i2 = 0; i2 !== n2; ++i2) {
    textures.setTexture2DArray(v5[i2] || emptyArrayTexture, units2[i2]);
  }
}
function getPureArraySetter(type) {
  switch (type) {
    case 5126:
      return setValueV1fArray;
    case 35664:
      return setValueV2fArray;
    case 35665:
      return setValueV3fArray;
    case 35666:
      return setValueV4fArray;
    case 35674:
      return setValueM2Array;
    case 35675:
      return setValueM3Array;
    case 35676:
      return setValueM4Array;
    case 5124:
    case 35670:
      return setValueV1iArray;
    case 35667:
    case 35671:
      return setValueV2iArray;
    case 35668:
    case 35672:
      return setValueV3iArray;
    case 35669:
    case 35673:
      return setValueV4iArray;
    case 5125:
      return setValueV1uiArray;
    case 36294:
      return setValueV2uiArray;
    case 36295:
      return setValueV3uiArray;
    case 36296:
      return setValueV4uiArray;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return setValueT1Array;
    case 35679:
    case 36299:
    case 36307:
      return setValueT3DArray;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return setValueT6Array;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return setValueT2DArrayArray;
  }
}
function SingleUniform(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.setValue = getSingularSetter(activeInfo.type);
}
function PureArrayUniform(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.size = activeInfo.size;
  this.setValue = getPureArraySetter(activeInfo.type);
}
PureArrayUniform.prototype.updateCache = function(data2) {
  const cache2 = this.cache;
  if (data2 instanceof Float32Array && cache2.length !== data2.length) {
    this.cache = new Float32Array(data2.length);
  }
  copyArray$3(cache2, data2);
};
function StructuredUniform(id) {
  this.id = id;
  this.seq = [];
  this.map = {};
}
StructuredUniform.prototype.setValue = function(gl, value, textures) {
  const seq = this.seq;
  for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
    const u2 = seq[i2];
    u2.setValue(gl, value[u2.id], textures);
  }
};
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
function addUniform(container, uniformObject) {
  container.seq.push(uniformObject);
  container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
  const path2 = activeInfo.name, pathLength = path2.length;
  RePathPart.lastIndex = 0;
  while (true) {
    const match2 = RePathPart.exec(path2), matchEnd = RePathPart.lastIndex;
    let id = match2[1];
    const idIsIndex = match2[2] === "]", subscript = match2[3];
    if (idIsIndex)
      id = id | 0;
    if (subscript === void 0 || subscript === "[" && matchEnd + 2 === pathLength) {
      addUniform(container, subscript === void 0 ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
      break;
    } else {
      const map5 = container.map;
      let next5 = map5[id];
      if (next5 === void 0) {
        next5 = new StructuredUniform(id);
        addUniform(container, next5);
      }
      container = next5;
    }
  }
}
function WebGLUniforms(gl, program) {
  this.seq = [];
  this.map = {};
  const n2 = gl.getProgramParameter(program, 35718);
  for (let i2 = 0; i2 < n2; ++i2) {
    const info = gl.getActiveUniform(program, i2), addr = gl.getUniformLocation(program, info.name);
    parseUniform(info, addr, this);
  }
}
WebGLUniforms.prototype.setValue = function(gl, name2, value, textures) {
  const u2 = this.map[name2];
  if (u2 !== void 0)
    u2.setValue(gl, value, textures);
};
WebGLUniforms.prototype.setOptional = function(gl, object2, name2) {
  const v5 = object2[name2];
  if (v5 !== void 0)
    this.setValue(gl, name2, v5);
};
WebGLUniforms.upload = function(gl, seq, values4, textures) {
  for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
    const u2 = seq[i2], v5 = values4[u2.id];
    if (v5.needsUpdate !== false) {
      u2.setValue(gl, v5.value, textures);
    }
  }
};
WebGLUniforms.seqWithValue = function(seq, values4) {
  const r2 = [];
  for (let i2 = 0, n2 = seq.length; i2 !== n2; ++i2) {
    const u2 = seq[i2];
    if (u2.id in values4)
      r2.push(u2);
  }
  return r2;
};
function WebGLShader(gl, type, string3) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, string3);
  gl.compileShader(shader);
  return shader;
}
let programIdCount = 0;
function handleSource(string3, errorLine) {
  const lines = string3.split("\n");
  const lines2 = [];
  const from = Math.max(errorLine - 6, 0);
  const to = Math.min(errorLine + 6, lines.length);
  for (let i2 = from; i2 < to; i2++) {
    lines2.push(i2 + 1 + ": " + lines[i2]);
  }
  return lines2.join("\n");
}
function getEncodingComponents(encoding) {
  switch (encoding) {
    case LinearEncoding:
      return ["Linear", "( value )"];
    case sRGBEncoding:
      return ["sRGB", "( value )"];
    default:
      console.warn("THREE.WebGLProgram: Unsupported encoding:", encoding);
      return ["Linear", "( value )"];
  }
}
function getShaderErrors(gl, shader, type) {
  const status = gl.getShaderParameter(shader, 35713);
  const errors = gl.getShaderInfoLog(shader).trim();
  if (status && errors === "")
    return "";
  const errorLine = parseInt(/ERROR: 0:(\d+)/.exec(errors)[1]);
  return type.toUpperCase() + "\n\n" + errors + "\n\n" + handleSource(gl.getShaderSource(shader), errorLine);
}
function getTexelEncodingFunction(functionName, encoding) {
  const components = getEncodingComponents(encoding);
  return "vec4 " + functionName + "( vec4 value ) { return LinearTo" + components[0] + components[1] + "; }";
}
function getToneMappingFunction(functionName, toneMapping) {
  let toneMappingName;
  switch (toneMapping) {
    case LinearToneMapping:
      toneMappingName = "Linear";
      break;
    case ReinhardToneMapping:
      toneMappingName = "Reinhard";
      break;
    case CineonToneMapping:
      toneMappingName = "OptimizedCineon";
      break;
    case ACESFilmicToneMapping:
      toneMappingName = "ACESFilmic";
      break;
    case CustomToneMapping:
      toneMappingName = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", toneMapping);
      toneMappingName = "Linear";
  }
  return "vec3 " + functionName + "( vec3 color ) { return " + toneMappingName + "ToneMapping( color ); }";
}
function generateExtensions(parameters) {
  const chunks = [
    parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
    (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
    parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
    (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
  ];
  return chunks.filter(filterEmptyLine).join("\n");
}
function generateDefines(defines2) {
  const chunks = [];
  for (const name2 in defines2) {
    const value = defines2[name2];
    if (value === false)
      continue;
    chunks.push("#define " + name2 + " " + value);
  }
  return chunks.join("\n");
}
function fetchAttributeLocations(gl, program) {
  const attributes = {};
  const n2 = gl.getProgramParameter(program, 35721);
  for (let i2 = 0; i2 < n2; i2++) {
    const info = gl.getActiveAttrib(program, i2);
    const name2 = info.name;
    let locationSize = 1;
    if (info.type === 35674)
      locationSize = 2;
    if (info.type === 35675)
      locationSize = 3;
    if (info.type === 35676)
      locationSize = 4;
    attributes[name2] = {
      type: info.type,
      location: gl.getAttribLocation(program, name2),
      locationSize
    };
  }
  return attributes;
}
function filterEmptyLine(string3) {
  return string3 !== "";
}
function replaceLightNums(string3, parameters) {
  return string3.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string3, parameters) {
  return string3.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(string3) {
  return string3.replace(includePattern, includeReplacer);
}
function includeReplacer(match2, include) {
  const string3 = ShaderChunk[include];
  if (string3 === void 0) {
    throw new Error("Can not resolve #include <" + include + ">");
  }
  return resolveIncludes(string3);
}
const deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(string3) {
  return string3.replace(unrollLoopPattern, loopReplacer).replace(deprecatedUnrollLoopPattern, deprecatedLoopReplacer);
}
function deprecatedLoopReplacer(match2, start2, end, snippet) {
  console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.");
  return loopReplacer(match2, start2, end, snippet);
}
function loopReplacer(match2, start2, end, snippet) {
  let string3 = "";
  for (let i2 = parseInt(start2); i2 < parseInt(end); i2++) {
    string3 += snippet.replace(/\[\s*i\s*\]/g, "[ " + i2 + " ]").replace(/UNROLLED_LOOP_INDEX/g, i2);
  }
  return string3;
}
function generatePrecision(parameters) {
  let precisionstring = "precision " + parameters.precision + " float;\nprecision " + parameters.precision + " int;";
  if (parameters.precision === "highp") {
    precisionstring += "\n#define HIGH_PRECISION";
  } else if (parameters.precision === "mediump") {
    precisionstring += "\n#define MEDIUM_PRECISION";
  } else if (parameters.precision === "lowp") {
    precisionstring += "\n#define LOW_PRECISION";
  }
  return precisionstring;
}
function generateShadowMapTypeDefine(parameters) {
  let shadowMapTypeDefine = "SHADOWMAP_TYPE_BASIC";
  if (parameters.shadowMapType === PCFShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF";
  } else if (parameters.shadowMapType === PCFSoftShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_PCF_SOFT";
  } else if (parameters.shadowMapType === VSMShadowMap) {
    shadowMapTypeDefine = "SHADOWMAP_TYPE_VSM";
  }
  return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine(parameters) {
  let envMapTypeDefine = "ENVMAP_TYPE_CUBE";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeReflectionMapping:
      case CubeRefractionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE";
        break;
      case CubeUVReflectionMapping:
        envMapTypeDefine = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  }
  return envMapTypeDefine;
}
function generateEnvMapModeDefine(parameters) {
  let envMapModeDefine = "ENVMAP_MODE_REFLECTION";
  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeRefractionMapping:
        envMapModeDefine = "ENVMAP_MODE_REFRACTION";
        break;
    }
  }
  return envMapModeDefine;
}
function generateEnvMapBlendingDefine(parameters) {
  let envMapBlendingDefine = "ENVMAP_BLENDING_NONE";
  if (parameters.envMap) {
    switch (parameters.combine) {
      case MultiplyOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case MixOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_MIX";
        break;
      case AddOperation:
        envMapBlendingDefine = "ENVMAP_BLENDING_ADD";
        break;
    }
  }
  return envMapBlendingDefine;
}
function generateCubeUVSize(parameters) {
  const imageHeight = parameters.envMapCubeUVHeight;
  if (imageHeight === null)
    return null;
  const maxMip = Math.log2(imageHeight / 32 + 1) + 3;
  const texelHeight = 1 / imageHeight;
  const texelWidth = 1 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));
  return { texelWidth, texelHeight, maxMip };
}
function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
  const gl = renderer.getContext();
  const defines2 = parameters.defines;
  let vertexShader = parameters.vertexShader;
  let fragmentShader = parameters.fragmentShader;
  const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
  const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
  const envMapModeDefine = generateEnvMapModeDefine(parameters);
  const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
  const envMapCubeUVSize = generateCubeUVSize(parameters);
  const customExtensions = parameters.isWebGL2 ? "" : generateExtensions(parameters);
  const customDefines = generateDefines(defines2);
  const program = gl.createProgram();
  let prefixVertex, prefixFragment;
  let versionString = parameters.glslVersion ? "#version " + parameters.glslVersion + "\n" : "";
  if (parameters.isRawShaderMaterial) {
    prefixVertex = [
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixVertex.length > 0) {
      prefixVertex += "\n";
    }
    prefixFragment = [
      customExtensions,
      customDefines
    ].filter(filterEmptyLine).join("\n");
    if (prefixFragment.length > 0) {
      prefixFragment += "\n";
    }
  } else {
    prefixVertex = [
      generatePrecision(parameters),
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.instancing ? "#define USE_INSTANCING" : "",
      parameters.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
      parameters.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
      "#define MAX_BONES " + parameters.maxBones,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
      parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.displacementMap && parameters.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
      parameters.vertexTangents ? "#define USE_TANGENT" : "",
      parameters.vertexColors ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUvs ? "#define USE_UV" : "",
      parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.skinning ? "#define USE_SKINNING" : "",
      parameters.useVertexTexture ? "#define BONE_TEXTURE" : "",
      parameters.morphTargets ? "#define USE_MORPHTARGETS" : "",
      parameters.morphNormals && parameters.flatShading === false ? "#define USE_MORPHNORMALS" : "",
      parameters.morphColors && parameters.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
      parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
      parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + parameters.morphTextureStride : "",
      parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? "#define MORPHTARGETS_COUNT " + parameters.morphTargetsCount : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
      "uniform mat4 modelMatrix;",
      "uniform mat4 modelViewMatrix;",
      "uniform mat4 projectionMatrix;",
      "uniform mat4 viewMatrix;",
      "uniform mat3 normalMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      "#ifdef USE_INSTANCING",
      "	attribute mat4 instanceMatrix;",
      "#endif",
      "#ifdef USE_INSTANCING_COLOR",
      "	attribute vec3 instanceColor;",
      "#endif",
      "attribute vec3 position;",
      "attribute vec3 normal;",
      "attribute vec2 uv;",
      "#ifdef USE_TANGENT",
      "	attribute vec4 tangent;",
      "#endif",
      "#if defined( USE_COLOR_ALPHA )",
      "	attribute vec4 color;",
      "#elif defined( USE_COLOR )",
      "	attribute vec3 color;",
      "#endif",
      "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
      "	attribute vec3 morphTarget0;",
      "	attribute vec3 morphTarget1;",
      "	attribute vec3 morphTarget2;",
      "	attribute vec3 morphTarget3;",
      "	#ifdef USE_MORPHNORMALS",
      "		attribute vec3 morphNormal0;",
      "		attribute vec3 morphNormal1;",
      "		attribute vec3 morphNormal2;",
      "		attribute vec3 morphNormal3;",
      "	#else",
      "		attribute vec3 morphTarget4;",
      "		attribute vec3 morphTarget5;",
      "		attribute vec3 morphTarget6;",
      "		attribute vec3 morphTarget7;",
      "	#endif",
      "#endif",
      "#ifdef USE_SKINNING",
      "	attribute vec4 skinIndex;",
      "	attribute vec4 skinWeight;",
      "#endif",
      "\n"
    ].filter(filterEmptyLine).join("\n");
    prefixFragment = [
      customExtensions,
      generatePrecision(parameters),
      "#define SHADER_NAME " + parameters.shaderName,
      customDefines,
      parameters.useFog && parameters.fog ? "#define USE_FOG" : "",
      parameters.useFog && parameters.fogExp2 ? "#define FOG_EXP2" : "",
      parameters.map ? "#define USE_MAP" : "",
      parameters.matcap ? "#define USE_MATCAP" : "",
      parameters.envMap ? "#define USE_ENVMAP" : "",
      parameters.envMap ? "#define " + envMapTypeDefine : "",
      parameters.envMap ? "#define " + envMapModeDefine : "",
      parameters.envMap ? "#define " + envMapBlendingDefine : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_WIDTH " + envMapCubeUVSize.texelWidth : "",
      envMapCubeUVSize ? "#define CUBEUV_TEXEL_HEIGHT " + envMapCubeUVSize.texelHeight : "",
      envMapCubeUVSize ? "#define CUBEUV_MAX_MIP " + envMapCubeUVSize.maxMip + ".0" : "",
      parameters.lightMap ? "#define USE_LIGHTMAP" : "",
      parameters.aoMap ? "#define USE_AOMAP" : "",
      parameters.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
      parameters.bumpMap ? "#define USE_BUMPMAP" : "",
      parameters.normalMap ? "#define USE_NORMALMAP" : "",
      parameters.normalMap && parameters.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
      parameters.normalMap && parameters.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
      parameters.clearcoat ? "#define USE_CLEARCOAT" : "",
      parameters.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
      parameters.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
      parameters.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
      parameters.specularMap ? "#define USE_SPECULARMAP" : "",
      parameters.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
      parameters.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
      parameters.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
      parameters.metalnessMap ? "#define USE_METALNESSMAP" : "",
      parameters.alphaMap ? "#define USE_ALPHAMAP" : "",
      parameters.alphaTest ? "#define USE_ALPHATEST" : "",
      parameters.sheen ? "#define USE_SHEEN" : "",
      parameters.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
      parameters.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
      parameters.transmission ? "#define USE_TRANSMISSION" : "",
      parameters.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
      parameters.thicknessMap ? "#define USE_THICKNESSMAP" : "",
      parameters.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
      parameters.vertexTangents ? "#define USE_TANGENT" : "",
      parameters.vertexColors || parameters.instancingColor ? "#define USE_COLOR" : "",
      parameters.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
      parameters.vertexUvs ? "#define USE_UV" : "",
      parameters.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
      parameters.gradientMap ? "#define USE_GRADIENTMAP" : "",
      parameters.flatShading ? "#define FLAT_SHADED" : "",
      parameters.doubleSided ? "#define DOUBLE_SIDED" : "",
      parameters.flipSided ? "#define FLIP_SIDED" : "",
      parameters.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
      parameters.shadowMapEnabled ? "#define " + shadowMapTypeDefine : "",
      parameters.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
      parameters.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
      parameters.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
      parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
      "uniform mat4 viewMatrix;",
      "uniform vec3 cameraPosition;",
      "uniform bool isOrthographic;",
      parameters.toneMapping !== NoToneMapping ? "#define TONE_MAPPING" : "",
      parameters.toneMapping !== NoToneMapping ? ShaderChunk["tonemapping_pars_fragment"] : "",
      // this code is required here because it is used by the toneMapping() function defined below
      parameters.toneMapping !== NoToneMapping ? getToneMappingFunction("toneMapping", parameters.toneMapping) : "",
      parameters.dithering ? "#define DITHERING" : "",
      parameters.opaque ? "#define OPAQUE" : "",
      ShaderChunk["encodings_pars_fragment"],
      // this code is required here because it is used by the various encoding/decoding function defined below
      getTexelEncodingFunction("linearToOutputTexel", parameters.outputEncoding),
      parameters.depthPacking ? "#define DEPTH_PACKING " + parameters.depthPacking : "",
      "\n"
    ].filter(filterEmptyLine).join("\n");
  }
  vertexShader = resolveIncludes(vertexShader);
  vertexShader = replaceLightNums(vertexShader, parameters);
  vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
  fragmentShader = resolveIncludes(fragmentShader);
  fragmentShader = replaceLightNums(fragmentShader, parameters);
  fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
  vertexShader = unrollLoops(vertexShader);
  fragmentShader = unrollLoops(fragmentShader);
  if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
    versionString = "#version 300 es\n";
    prefixVertex = [
      "precision mediump sampler2DArray;",
      "#define attribute in",
      "#define varying out",
      "#define texture2D texture"
    ].join("\n") + "\n" + prefixVertex;
    prefixFragment = [
      "#define varying in",
      parameters.glslVersion === GLSL3 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
      parameters.glslVersion === GLSL3 ? "" : "#define gl_FragColor pc_fragColor",
      "#define gl_FragDepthEXT gl_FragDepth",
      "#define texture2D texture",
      "#define textureCube texture",
      "#define texture2DProj textureProj",
      "#define texture2DLodEXT textureLod",
      "#define texture2DProjLodEXT textureProjLod",
      "#define textureCubeLodEXT textureLod",
      "#define texture2DGradEXT textureGrad",
      "#define texture2DProjGradEXT textureProjGrad",
      "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + prefixFragment;
  }
  const vertexGlsl = versionString + prefixVertex + vertexShader;
  const fragmentGlsl = versionString + prefixFragment + fragmentShader;
  const glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
  const glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);
  gl.attachShader(program, glVertexShader);
  gl.attachShader(program, glFragmentShader);
  if (parameters.index0AttributeName !== void 0) {
    gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
  } else if (parameters.morphTargets === true) {
    gl.bindAttribLocation(program, 0, "position");
  }
  gl.linkProgram(program);
  if (renderer.debug.checkShaderErrors) {
    const programLog = gl.getProgramInfoLog(program).trim();
    const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
    const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
    let runnable = true;
    let haveDiagnostics = true;
    if (gl.getProgramParameter(program, 35714) === false) {
      runnable = false;
      const vertexErrors = getShaderErrors(gl, glVertexShader, "vertex");
      const fragmentErrors = getShaderErrors(gl, glFragmentShader, "fragment");
      console.error(
        "THREE.WebGLProgram: Shader Error " + gl.getError() + " - VALIDATE_STATUS " + gl.getProgramParameter(program, 35715) + "\n\nProgram Info Log: " + programLog + "\n" + vertexErrors + "\n" + fragmentErrors
      );
    } else if (programLog !== "") {
      console.warn("THREE.WebGLProgram: Program Info Log:", programLog);
    } else if (vertexLog === "" || fragmentLog === "") {
      haveDiagnostics = false;
    }
    if (haveDiagnostics) {
      this.diagnostics = {
        runnable,
        programLog,
        vertexShader: {
          log: vertexLog,
          prefix: prefixVertex
        },
        fragmentShader: {
          log: fragmentLog,
          prefix: prefixFragment
        }
      };
    }
  }
  gl.deleteShader(glVertexShader);
  gl.deleteShader(glFragmentShader);
  let cachedUniforms;
  this.getUniforms = function() {
    if (cachedUniforms === void 0) {
      cachedUniforms = new WebGLUniforms(gl, program);
    }
    return cachedUniforms;
  };
  let cachedAttributes;
  this.getAttributes = function() {
    if (cachedAttributes === void 0) {
      cachedAttributes = fetchAttributeLocations(gl, program);
    }
    return cachedAttributes;
  };
  this.destroy = function() {
    bindingStates.releaseStatesOfProgram(this);
    gl.deleteProgram(program);
    this.program = void 0;
  };
  this.name = parameters.shaderName;
  this.id = programIdCount++;
  this.cacheKey = cacheKey;
  this.usedTimes = 1;
  this.program = program;
  this.vertexShader = glVertexShader;
  this.fragmentShader = glFragmentShader;
  return this;
}
let _id = 0;
class WebGLShaderCache {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map();
    this.materialCache = /* @__PURE__ */ new Map();
  }
  update(material) {
    const vertexShader = material.vertexShader;
    const fragmentShader = material.fragmentShader;
    const vertexShaderStage = this._getShaderStage(vertexShader);
    const fragmentShaderStage = this._getShaderStage(fragmentShader);
    const materialShaders = this._getShaderCacheForMaterial(material);
    if (materialShaders.has(vertexShaderStage) === false) {
      materialShaders.add(vertexShaderStage);
      vertexShaderStage.usedTimes++;
    }
    if (materialShaders.has(fragmentShaderStage) === false) {
      materialShaders.add(fragmentShaderStage);
      fragmentShaderStage.usedTimes++;
    }
    return this;
  }
  remove(material) {
    const materialShaders = this.materialCache.get(material);
    for (const shaderStage of materialShaders) {
      shaderStage.usedTimes--;
      if (shaderStage.usedTimes === 0)
        this.shaderCache.delete(shaderStage.code);
    }
    this.materialCache.delete(material);
    return this;
  }
  getVertexShaderID(material) {
    return this._getShaderStage(material.vertexShader).id;
  }
  getFragmentShaderID(material) {
    return this._getShaderStage(material.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear();
    this.materialCache.clear();
  }
  _getShaderCacheForMaterial(material) {
    const cache2 = this.materialCache;
    if (cache2.has(material) === false) {
      cache2.set(material, /* @__PURE__ */ new Set());
    }
    return cache2.get(material);
  }
  _getShaderStage(code) {
    const cache2 = this.shaderCache;
    if (cache2.has(code) === false) {
      const stage = new WebGLShaderStage(code);
      cache2.set(code, stage);
    }
    return cache2.get(code);
  }
}
class WebGLShaderStage {
  constructor(code) {
    this.id = _id++;
    this.code = code;
    this.usedTimes = 0;
  }
}
function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
  const _programLayers = new Layers();
  const _customShaders = new WebGLShaderCache();
  const programs = [];
  const isWebGL2 = capabilities.isWebGL2;
  const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
  const floatVertexTextures = capabilities.floatVertexTextures;
  const maxVertexUniforms = capabilities.maxVertexUniforms;
  const vertexTextures = capabilities.vertexTextures;
  let precision = capabilities.precision;
  const shaderIDs = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function getMaxBones(object2) {
    const skeleton = object2.skeleton;
    const bones = skeleton.bones;
    if (floatVertexTextures) {
      return 1024;
    } else {
      const nVertexUniforms = maxVertexUniforms;
      const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
      const maxBones = Math.min(nVertexMatrices, bones.length);
      if (maxBones < bones.length) {
        console.warn("THREE.WebGLRenderer: Skeleton has " + bones.length + " bones. This GPU supports " + maxBones + ".");
        return 0;
      }
      return maxBones;
    }
  }
  function getParameters(material, lights2, shadows, scene, object2) {
    const fog2 = scene.fog;
    const geometry2 = object2.geometry;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    const envMapCubeUVHeight = !!envMap && envMap.mapping === CubeUVReflectionMapping ? envMap.image.height : null;
    const shaderID = shaderIDs[material.type];
    const maxBones = object2.isSkinnedMesh ? getMaxBones(object2) : 0;
    if (material.precision !== null) {
      precision = capabilities.getMaxPrecision(material.precision);
      if (precision !== material.precision) {
        console.warn("THREE.WebGLProgram.getParameters:", material.precision, "not supported, using", precision, "instead.");
      }
    }
    const morphAttribute = geometry2.morphAttributes.position || geometry2.morphAttributes.normal || geometry2.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    let morphTextureStride = 0;
    if (geometry2.morphAttributes.position !== void 0)
      morphTextureStride = 1;
    if (geometry2.morphAttributes.normal !== void 0)
      morphTextureStride = 2;
    if (geometry2.morphAttributes.color !== void 0)
      morphTextureStride = 3;
    let vertexShader, fragmentShader;
    let customVertexShaderID, customFragmentShaderID;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      vertexShader = shader.vertexShader;
      fragmentShader = shader.fragmentShader;
    } else {
      vertexShader = material.vertexShader;
      fragmentShader = material.fragmentShader;
      _customShaders.update(material);
      customVertexShaderID = _customShaders.getVertexShaderID(material);
      customFragmentShaderID = _customShaders.getFragmentShaderID(material);
    }
    const currentRenderTarget = renderer.getRenderTarget();
    const useAlphaTest = material.alphaTest > 0;
    const useClearcoat = material.clearcoat > 0;
    const parameters = {
      isWebGL2,
      shaderID,
      shaderName: material.type,
      vertexShader,
      fragmentShader,
      defines: material.defines,
      customVertexShaderID,
      customFragmentShaderID,
      isRawShaderMaterial: material.isRawShaderMaterial === true,
      glslVersion: material.glslVersion,
      precision,
      instancing: object2.isInstancedMesh === true,
      instancingColor: object2.isInstancedMesh === true && object2.instanceColor !== null,
      supportsVertexTextures: vertexTextures,
      outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : LinearEncoding,
      map: !!material.map,
      matcap: !!material.matcap,
      envMap: !!envMap,
      envMapMode: envMap && envMap.mapping,
      envMapCubeUVHeight,
      lightMap: !!material.lightMap,
      aoMap: !!material.aoMap,
      emissiveMap: !!material.emissiveMap,
      bumpMap: !!material.bumpMap,
      normalMap: !!material.normalMap,
      objectSpaceNormalMap: material.normalMapType === ObjectSpaceNormalMap,
      tangentSpaceNormalMap: material.normalMapType === TangentSpaceNormalMap,
      decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === sRGBEncoding,
      clearcoat: useClearcoat,
      clearcoatMap: useClearcoat && !!material.clearcoatMap,
      clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
      clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
      displacementMap: !!material.displacementMap,
      roughnessMap: !!material.roughnessMap,
      metalnessMap: !!material.metalnessMap,
      specularMap: !!material.specularMap,
      specularIntensityMap: !!material.specularIntensityMap,
      specularColorMap: !!material.specularColorMap,
      opaque: material.transparent === false && material.blending === NormalBlending,
      alphaMap: !!material.alphaMap,
      alphaTest: useAlphaTest,
      gradientMap: !!material.gradientMap,
      sheen: material.sheen > 0,
      sheenColorMap: !!material.sheenColorMap,
      sheenRoughnessMap: !!material.sheenRoughnessMap,
      transmission: material.transmission > 0,
      transmissionMap: !!material.transmissionMap,
      thicknessMap: !!material.thicknessMap,
      combine: material.combine,
      vertexTangents: !!material.normalMap && !!geometry2.attributes.tangent,
      vertexColors: material.vertexColors,
      vertexAlphas: material.vertexColors === true && !!geometry2.attributes.color && geometry2.attributes.color.itemSize === 4,
      vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
      uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
      fog: !!fog2,
      useFog: material.fog,
      fogExp2: fog2 && fog2.isFogExp2,
      flatShading: !!material.flatShading,
      sizeAttenuation: material.sizeAttenuation,
      logarithmicDepthBuffer,
      skinning: object2.isSkinnedMesh === true && maxBones > 0,
      maxBones,
      useVertexTexture: floatVertexTextures,
      morphTargets: geometry2.morphAttributes.position !== void 0,
      morphNormals: geometry2.morphAttributes.normal !== void 0,
      morphColors: geometry2.morphAttributes.color !== void 0,
      morphTargetsCount,
      morphTextureStride,
      numDirLights: lights2.directional.length,
      numPointLights: lights2.point.length,
      numSpotLights: lights2.spot.length,
      numRectAreaLights: lights2.rectArea.length,
      numHemiLights: lights2.hemi.length,
      numDirLightShadows: lights2.directionalShadowMap.length,
      numPointLightShadows: lights2.pointShadowMap.length,
      numSpotLightShadows: lights2.spotShadowMap.length,
      numClippingPlanes: clipping.numPlanes,
      numClipIntersection: clipping.numIntersection,
      dithering: material.dithering,
      shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
      shadowMapType: renderer.shadowMap.type,
      toneMapping: material.toneMapped ? renderer.toneMapping : NoToneMapping,
      physicallyCorrectLights: renderer.physicallyCorrectLights,
      premultipliedAlpha: material.premultipliedAlpha,
      doubleSided: material.side === DoubleSide,
      flipSided: material.side === BackSide,
      depthPacking: material.depthPacking !== void 0 ? material.depthPacking : false,
      index0AttributeName: material.index0AttributeName,
      extensionDerivatives: material.extensions && material.extensions.derivatives,
      extensionFragDepth: material.extensions && material.extensions.fragDepth,
      extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
      extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
      rendererExtensionFragDepth: isWebGL2 || extensions.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: isWebGL2 || extensions.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: isWebGL2 || extensions.has("EXT_shader_texture_lod"),
      customProgramCacheKey: material.customProgramCacheKey()
    };
    return parameters;
  }
  function getProgramCacheKey(parameters) {
    const array2 = [];
    if (parameters.shaderID) {
      array2.push(parameters.shaderID);
    } else {
      array2.push(parameters.customVertexShaderID);
      array2.push(parameters.customFragmentShaderID);
    }
    if (parameters.defines !== void 0) {
      for (const name2 in parameters.defines) {
        array2.push(name2);
        array2.push(parameters.defines[name2]);
      }
    }
    if (parameters.isRawShaderMaterial === false) {
      getProgramCacheKeyParameters(array2, parameters);
      getProgramCacheKeyBooleans(array2, parameters);
      array2.push(renderer.outputEncoding);
    }
    array2.push(parameters.customProgramCacheKey);
    return array2.join();
  }
  function getProgramCacheKeyParameters(array2, parameters) {
    array2.push(parameters.precision);
    array2.push(parameters.outputEncoding);
    array2.push(parameters.envMapMode);
    array2.push(parameters.envMapCubeUVHeight);
    array2.push(parameters.combine);
    array2.push(parameters.vertexUvs);
    array2.push(parameters.fogExp2);
    array2.push(parameters.sizeAttenuation);
    array2.push(parameters.maxBones);
    array2.push(parameters.morphTargetsCount);
    array2.push(parameters.morphAttributeCount);
    array2.push(parameters.numDirLights);
    array2.push(parameters.numPointLights);
    array2.push(parameters.numSpotLights);
    array2.push(parameters.numHemiLights);
    array2.push(parameters.numRectAreaLights);
    array2.push(parameters.numDirLightShadows);
    array2.push(parameters.numPointLightShadows);
    array2.push(parameters.numSpotLightShadows);
    array2.push(parameters.shadowMapType);
    array2.push(parameters.toneMapping);
    array2.push(parameters.numClippingPlanes);
    array2.push(parameters.numClipIntersection);
  }
  function getProgramCacheKeyBooleans(array2, parameters) {
    _programLayers.disableAll();
    if (parameters.isWebGL2)
      _programLayers.enable(0);
    if (parameters.supportsVertexTextures)
      _programLayers.enable(1);
    if (parameters.instancing)
      _programLayers.enable(2);
    if (parameters.instancingColor)
      _programLayers.enable(3);
    if (parameters.map)
      _programLayers.enable(4);
    if (parameters.matcap)
      _programLayers.enable(5);
    if (parameters.envMap)
      _programLayers.enable(6);
    if (parameters.lightMap)
      _programLayers.enable(7);
    if (parameters.aoMap)
      _programLayers.enable(8);
    if (parameters.emissiveMap)
      _programLayers.enable(9);
    if (parameters.bumpMap)
      _programLayers.enable(10);
    if (parameters.normalMap)
      _programLayers.enable(11);
    if (parameters.objectSpaceNormalMap)
      _programLayers.enable(12);
    if (parameters.tangentSpaceNormalMap)
      _programLayers.enable(13);
    if (parameters.clearcoat)
      _programLayers.enable(14);
    if (parameters.clearcoatMap)
      _programLayers.enable(15);
    if (parameters.clearcoatRoughnessMap)
      _programLayers.enable(16);
    if (parameters.clearcoatNormalMap)
      _programLayers.enable(17);
    if (parameters.displacementMap)
      _programLayers.enable(18);
    if (parameters.specularMap)
      _programLayers.enable(19);
    if (parameters.roughnessMap)
      _programLayers.enable(20);
    if (parameters.metalnessMap)
      _programLayers.enable(21);
    if (parameters.gradientMap)
      _programLayers.enable(22);
    if (parameters.alphaMap)
      _programLayers.enable(23);
    if (parameters.alphaTest)
      _programLayers.enable(24);
    if (parameters.vertexColors)
      _programLayers.enable(25);
    if (parameters.vertexAlphas)
      _programLayers.enable(26);
    if (parameters.vertexUvs)
      _programLayers.enable(27);
    if (parameters.vertexTangents)
      _programLayers.enable(28);
    if (parameters.uvsVertexOnly)
      _programLayers.enable(29);
    if (parameters.fog)
      _programLayers.enable(30);
    array2.push(_programLayers.mask);
    _programLayers.disableAll();
    if (parameters.useFog)
      _programLayers.enable(0);
    if (parameters.flatShading)
      _programLayers.enable(1);
    if (parameters.logarithmicDepthBuffer)
      _programLayers.enable(2);
    if (parameters.skinning)
      _programLayers.enable(3);
    if (parameters.useVertexTexture)
      _programLayers.enable(4);
    if (parameters.morphTargets)
      _programLayers.enable(5);
    if (parameters.morphNormals)
      _programLayers.enable(6);
    if (parameters.morphColors)
      _programLayers.enable(7);
    if (parameters.premultipliedAlpha)
      _programLayers.enable(8);
    if (parameters.shadowMapEnabled)
      _programLayers.enable(9);
    if (parameters.physicallyCorrectLights)
      _programLayers.enable(10);
    if (parameters.doubleSided)
      _programLayers.enable(11);
    if (parameters.flipSided)
      _programLayers.enable(12);
    if (parameters.depthPacking)
      _programLayers.enable(13);
    if (parameters.dithering)
      _programLayers.enable(14);
    if (parameters.specularIntensityMap)
      _programLayers.enable(15);
    if (parameters.specularColorMap)
      _programLayers.enable(16);
    if (parameters.transmission)
      _programLayers.enable(17);
    if (parameters.transmissionMap)
      _programLayers.enable(18);
    if (parameters.thicknessMap)
      _programLayers.enable(19);
    if (parameters.sheen)
      _programLayers.enable(20);
    if (parameters.sheenColorMap)
      _programLayers.enable(21);
    if (parameters.sheenRoughnessMap)
      _programLayers.enable(22);
    if (parameters.decodeVideoTexture)
      _programLayers.enable(23);
    if (parameters.opaque)
      _programLayers.enable(24);
    array2.push(_programLayers.mask);
  }
  function getUniforms2(material) {
    const shaderID = shaderIDs[material.type];
    let uniforms;
    if (shaderID) {
      const shader = ShaderLib[shaderID];
      uniforms = UniformsUtils.clone(shader.uniforms);
    } else {
      uniforms = material.uniforms;
    }
    return uniforms;
  }
  function acquireProgram(parameters, cacheKey) {
    let program;
    for (let p2 = 0, pl = programs.length; p2 < pl; p2++) {
      const preexistingProgram = programs[p2];
      if (preexistingProgram.cacheKey === cacheKey) {
        program = preexistingProgram;
        ++program.usedTimes;
        break;
      }
    }
    if (program === void 0) {
      program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
      programs.push(program);
    }
    return program;
  }
  function releaseProgram(program) {
    if (--program.usedTimes === 0) {
      const i2 = programs.indexOf(program);
      programs[i2] = programs[programs.length - 1];
      programs.pop();
      program.destroy();
    }
  }
  function releaseShaderCache(material) {
    _customShaders.remove(material);
  }
  function dispose2() {
    _customShaders.dispose();
  }
  return {
    getParameters,
    getProgramCacheKey,
    getUniforms: getUniforms2,
    acquireProgram,
    releaseProgram,
    releaseShaderCache,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs,
    dispose: dispose2
  };
}
function WebGLProperties() {
  let properties = /* @__PURE__ */ new WeakMap();
  function get6(object2) {
    let map5 = properties.get(object2);
    if (map5 === void 0) {
      map5 = {};
      properties.set(object2, map5);
    }
    return map5;
  }
  function remove6(object2) {
    properties.delete(object2);
  }
  function update(object2, key, value) {
    properties.get(object2)[key] = value;
  }
  function dispose2() {
    properties = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: get6,
    remove: remove6,
    update,
    dispose: dispose2
  };
}
function painterSortStable(a2, b2) {
  if (a2.groupOrder !== b2.groupOrder) {
    return a2.groupOrder - b2.groupOrder;
  } else if (a2.renderOrder !== b2.renderOrder) {
    return a2.renderOrder - b2.renderOrder;
  } else if (a2.material.id !== b2.material.id) {
    return a2.material.id - b2.material.id;
  } else if (a2.z !== b2.z) {
    return a2.z - b2.z;
  } else {
    return a2.id - b2.id;
  }
}
function reversePainterSortStable(a2, b2) {
  if (a2.groupOrder !== b2.groupOrder) {
    return a2.groupOrder - b2.groupOrder;
  } else if (a2.renderOrder !== b2.renderOrder) {
    return a2.renderOrder - b2.renderOrder;
  } else if (a2.z !== b2.z) {
    return b2.z - a2.z;
  } else {
    return a2.id - b2.id;
  }
}
function WebGLRenderList() {
  const renderItems = [];
  let renderItemsIndex = 0;
  const opaque = [];
  const transmissive = [];
  const transparent = [];
  function init9() {
    renderItemsIndex = 0;
    opaque.length = 0;
    transmissive.length = 0;
    transparent.length = 0;
  }
  function getNextRenderItem(object2, geometry2, material, groupOrder, z2, group) {
    let renderItem = renderItems[renderItemsIndex];
    if (renderItem === void 0) {
      renderItem = {
        id: object2.id,
        object: object2,
        geometry: geometry2,
        material,
        groupOrder,
        renderOrder: object2.renderOrder,
        z: z2,
        group
      };
      renderItems[renderItemsIndex] = renderItem;
    } else {
      renderItem.id = object2.id;
      renderItem.object = object2;
      renderItem.geometry = geometry2;
      renderItem.material = material;
      renderItem.groupOrder = groupOrder;
      renderItem.renderOrder = object2.renderOrder;
      renderItem.z = z2;
      renderItem.group = group;
    }
    renderItemsIndex++;
    return renderItem;
  }
  function push2(object2, geometry2, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object2, geometry2, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.push(renderItem);
    } else if (material.transparent === true) {
      transparent.push(renderItem);
    } else {
      opaque.push(renderItem);
    }
  }
  function unshift(object2, geometry2, material, groupOrder, z2, group) {
    const renderItem = getNextRenderItem(object2, geometry2, material, groupOrder, z2, group);
    if (material.transmission > 0) {
      transmissive.unshift(renderItem);
    } else if (material.transparent === true) {
      transparent.unshift(renderItem);
    } else {
      opaque.unshift(renderItem);
    }
  }
  function sort3(customOpaqueSort, customTransparentSort) {
    if (opaque.length > 1)
      opaque.sort(customOpaqueSort || painterSortStable);
    if (transmissive.length > 1)
      transmissive.sort(customTransparentSort || reversePainterSortStable);
    if (transparent.length > 1)
      transparent.sort(customTransparentSort || reversePainterSortStable);
  }
  function finish() {
    for (let i2 = renderItemsIndex, il = renderItems.length; i2 < il; i2++) {
      const renderItem = renderItems[i2];
      if (renderItem.id === null)
        break;
      renderItem.id = null;
      renderItem.object = null;
      renderItem.geometry = null;
      renderItem.material = null;
      renderItem.group = null;
    }
  }
  return {
    opaque,
    transmissive,
    transparent,
    init: init9,
    push: push2,
    unshift,
    finish,
    sort: sort3
  };
}
function WebGLRenderLists() {
  let lists = /* @__PURE__ */ new WeakMap();
  function get6(scene, renderCallDepth) {
    let list2;
    if (lists.has(scene) === false) {
      list2 = new WebGLRenderList();
      lists.set(scene, [list2]);
    } else {
      if (renderCallDepth >= lists.get(scene).length) {
        list2 = new WebGLRenderList();
        lists.get(scene).push(list2);
      } else {
        list2 = lists.get(scene)[renderCallDepth];
      }
    }
    return list2;
  }
  function dispose2() {
    lists = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: get6,
    dispose: dispose2
  };
}
function UniformsCache() {
  const lights2 = {};
  return {
    get: function(light) {
      if (lights2[light.id] !== void 0) {
        return lights2[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            direction: new Vector3$1(),
            color: new Color()
          };
          break;
        case "SpotLight":
          uniforms = {
            position: new Vector3$1(),
            direction: new Vector3$1(),
            color: new Color(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          uniforms = {
            position: new Vector3$1(),
            color: new Color(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          uniforms = {
            direction: new Vector3$1(),
            skyColor: new Color(),
            groundColor: new Color()
          };
          break;
        case "RectAreaLight":
          uniforms = {
            color: new Color(),
            position: new Vector3$1(),
            halfWidth: new Vector3$1(),
            halfHeight: new Vector3$1()
          };
          break;
      }
      lights2[light.id] = uniforms;
      return uniforms;
    }
  };
}
function ShadowUniformsCache() {
  const lights2 = {};
  return {
    get: function(light) {
      if (lights2[light.id] !== void 0) {
        return lights2[light.id];
      }
      let uniforms;
      switch (light.type) {
        case "DirectionalLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1()
          };
          break;
        case "SpotLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1()
          };
          break;
        case "PointLight":
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2$1(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      lights2[light.id] = uniforms;
      return uniforms;
    }
  };
}
let nextVersion = 0;
function shadowCastingLightsFirst(lightA, lightB) {
  return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function WebGLLights(extensions, capabilities) {
  const cache2 = new UniformsCache();
  const shadowCache = ShadowUniformsCache();
  const state = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotShadow: [],
    spotShadowMap: [],
    spotShadowMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: []
  };
  for (let i2 = 0; i2 < 9; i2++)
    state.probe.push(new Vector3$1());
  const vector3 = new Vector3$1();
  const matrix4 = new Matrix4$1();
  const matrix42 = new Matrix4$1();
  function setup2(lights2, physicallyCorrectLights) {
    let r2 = 0, g2 = 0, b2 = 0;
    for (let i2 = 0; i2 < 9; i2++)
      state.probe[i2].set(0, 0, 0);
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    let numDirectionalShadows = 0;
    let numPointShadows = 0;
    let numSpotShadows = 0;
    lights2.sort(shadowCastingLightsFirst);
    const scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;
    for (let i2 = 0, l2 = lights2.length; i2 < l2; i2++) {
      const light = lights2[i2];
      const color = light.color;
      const intensity = light.intensity;
      const distance11 = light.distance;
      const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
      if (light.isAmbientLight) {
        r2 += color.r * intensity * scaleFactor;
        g2 += color.g * intensity * scaleFactor;
        b2 += color.b * intensity * scaleFactor;
      } else if (light.isLightProbe) {
        for (let j2 = 0; j2 < 9; j2++) {
          state.probe[j2].addScaledVector(light.sh.coefficients[j2], intensity);
        }
      } else if (light.isDirectionalLight) {
        const uniforms = cache2.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
        if (light.castShadow) {
          const shadow2 = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow2.bias;
          shadowUniforms.shadowNormalBias = shadow2.normalBias;
          shadowUniforms.shadowRadius = shadow2.radius;
          shadowUniforms.shadowMapSize = shadow2.mapSize;
          state.directionalShadow[directionalLength] = shadowUniforms;
          state.directionalShadowMap[directionalLength] = shadowMap;
          state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
          numDirectionalShadows++;
        }
        state.directional[directionalLength] = uniforms;
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = cache2.get(light);
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);
        uniforms.distance = distance11;
        uniforms.coneCos = Math.cos(light.angle);
        uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow2 = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow2.bias;
          shadowUniforms.shadowNormalBias = shadow2.normalBias;
          shadowUniforms.shadowRadius = shadow2.radius;
          shadowUniforms.shadowMapSize = shadow2.mapSize;
          state.spotShadow[spotLength] = shadowUniforms;
          state.spotShadowMap[spotLength] = shadowMap;
          state.spotShadowMatrix[spotLength] = light.shadow.matrix;
          numSpotShadows++;
        }
        state.spot[spotLength] = uniforms;
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = cache2.get(light);
        uniforms.color.copy(color).multiplyScalar(intensity);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        state.rectArea[rectAreaLength] = uniforms;
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = cache2.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);
        uniforms.distance = light.distance;
        uniforms.decay = light.decay;
        if (light.castShadow) {
          const shadow2 = light.shadow;
          const shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow2.bias;
          shadowUniforms.shadowNormalBias = shadow2.normalBias;
          shadowUniforms.shadowRadius = shadow2.radius;
          shadowUniforms.shadowMapSize = shadow2.mapSize;
          shadowUniforms.shadowCameraNear = shadow2.camera.near;
          shadowUniforms.shadowCameraFar = shadow2.camera.far;
          state.pointShadow[pointLength] = shadowUniforms;
          state.pointShadowMap[pointLength] = shadowMap;
          state.pointShadowMatrix[pointLength] = light.shadow.matrix;
          numPointShadows++;
        }
        state.point[pointLength] = uniforms;
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = cache2.get(light);
        uniforms.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);
        uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);
        state.hemi[hemiLength] = uniforms;
        hemiLength++;
      }
    }
    if (rectAreaLength > 0) {
      if (capabilities.isWebGL2) {
        state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
        state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
      } else {
        if (extensions.has("OES_texture_float_linear") === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
          state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
        } else if (extensions.has("OES_texture_half_float_linear") === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
          state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
        } else {
          console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.");
        }
      }
    }
    state.ambient[0] = r2;
    state.ambient[1] = g2;
    state.ambient[2] = b2;
    const hash = state.hash;
    if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
      state.directional.length = directionalLength;
      state.spot.length = spotLength;
      state.rectArea.length = rectAreaLength;
      state.point.length = pointLength;
      state.hemi.length = hemiLength;
      state.directionalShadow.length = numDirectionalShadows;
      state.directionalShadowMap.length = numDirectionalShadows;
      state.pointShadow.length = numPointShadows;
      state.pointShadowMap.length = numPointShadows;
      state.spotShadow.length = numSpotShadows;
      state.spotShadowMap.length = numSpotShadows;
      state.directionalShadowMatrix.length = numDirectionalShadows;
      state.pointShadowMatrix.length = numPointShadows;
      state.spotShadowMatrix.length = numSpotShadows;
      hash.directionalLength = directionalLength;
      hash.pointLength = pointLength;
      hash.spotLength = spotLength;
      hash.rectAreaLength = rectAreaLength;
      hash.hemiLength = hemiLength;
      hash.numDirectionalShadows = numDirectionalShadows;
      hash.numPointShadows = numPointShadows;
      hash.numSpotShadows = numSpotShadows;
      state.version = nextVersion++;
    }
  }
  function setupView(lights2, camera) {
    let directionalLength = 0;
    let pointLength = 0;
    let spotLength = 0;
    let rectAreaLength = 0;
    let hemiLength = 0;
    const viewMatrix = camera.matrixWorldInverse;
    for (let i2 = 0, l2 = lights2.length; i2 < l2; i2++) {
      const light = lights2[i2];
      if (light.isDirectionalLight) {
        const uniforms = state.directional[directionalLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        directionalLength++;
      } else if (light.isSpotLight) {
        const uniforms = state.spot[spotLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        spotLength++;
      } else if (light.isRectAreaLight) {
        const uniforms = state.rectArea[rectAreaLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        matrix42.identity();
        matrix4.copy(light.matrixWorld);
        matrix4.premultiply(viewMatrix);
        matrix42.extractRotation(matrix4);
        uniforms.halfWidth.set(light.width * 0.5, 0, 0);
        uniforms.halfHeight.set(0, light.height * 0.5, 0);
        uniforms.halfWidth.applyMatrix4(matrix42);
        uniforms.halfHeight.applyMatrix4(matrix42);
        rectAreaLength++;
      } else if (light.isPointLight) {
        const uniforms = state.point[pointLength];
        uniforms.position.setFromMatrixPosition(light.matrixWorld);
        uniforms.position.applyMatrix4(viewMatrix);
        pointLength++;
      } else if (light.isHemisphereLight) {
        const uniforms = state.hemi[hemiLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        uniforms.direction.transformDirection(viewMatrix);
        uniforms.direction.normalize();
        hemiLength++;
      }
    }
  }
  return {
    setup: setup2,
    setupView,
    state
  };
}
function WebGLRenderState(extensions, capabilities) {
  const lights2 = new WebGLLights(extensions, capabilities);
  const lightsArray = [];
  const shadowsArray = [];
  function init9() {
    lightsArray.length = 0;
    shadowsArray.length = 0;
  }
  function pushLight(light) {
    lightsArray.push(light);
  }
  function pushShadow(shadowLight) {
    shadowsArray.push(shadowLight);
  }
  function setupLights(physicallyCorrectLights) {
    lights2.setup(lightsArray, physicallyCorrectLights);
  }
  function setupLightsView(camera) {
    lights2.setupView(lightsArray, camera);
  }
  const state = {
    lightsArray,
    shadowsArray,
    lights: lights2
  };
  return {
    init: init9,
    state,
    setupLights,
    setupLightsView,
    pushLight,
    pushShadow
  };
}
function WebGLRenderStates(extensions, capabilities) {
  let renderStates = /* @__PURE__ */ new WeakMap();
  function get6(scene, renderCallDepth = 0) {
    let renderState;
    if (renderStates.has(scene) === false) {
      renderState = new WebGLRenderState(extensions, capabilities);
      renderStates.set(scene, [renderState]);
    } else {
      if (renderCallDepth >= renderStates.get(scene).length) {
        renderState = new WebGLRenderState(extensions, capabilities);
        renderStates.get(scene).push(renderState);
      } else {
        renderState = renderStates.get(scene)[renderCallDepth];
      }
    }
    return renderState;
  }
  function dispose2() {
    renderStates = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: get6,
    dispose: dispose2
  };
}
class MeshDepthMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "MeshDepthMaterial";
    this.depthPacking = BasicDepthPacking;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.depthPacking = source.depthPacking;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    return this;
  }
}
MeshDepthMaterial.prototype.isMeshDepthMaterial = true;
class MeshDistanceMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "MeshDistanceMaterial";
    this.referencePosition = new Vector3$1();
    this.nearDistance = 1;
    this.farDistance = 1e3;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.fog = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.referencePosition.copy(source.referencePosition);
    this.nearDistance = source.nearDistance;
    this.farDistance = source.farDistance;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    return this;
  }
}
MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;
const vertex = "void main() {\n	gl_Position = vec4( position, 1.0 );\n}";
const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function WebGLShadowMap(_renderer, _objects, _capabilities) {
  let _frustum = new Frustum();
  const _shadowMapSize = new Vector2$1(), _viewportSize = new Vector2$1(), _viewport = new Vector4$1(), _depthMaterial = new MeshDepthMaterial({ depthPacking: RGBADepthPacking }), _distanceMaterial = new MeshDistanceMaterial(), _materialCache = {}, _maxTextureSize = _capabilities.maxTextureSize;
  const shadowSide = { 0: BackSide, 1: FrontSide, 2: DoubleSide };
  const shadowMaterialVertical = new ShaderMaterial({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Vector2$1() },
      radius: { value: 4 }
    },
    vertexShader: vertex,
    fragmentShader: fragment
  });
  const shadowMaterialHorizontal = shadowMaterialVertical.clone();
  shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
  const fullScreenTri = new BufferGeometry();
  fullScreenTri.setAttribute(
    "position",
    new BufferAttribute(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
  const scope = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = PCFShadowMap;
  this.render = function(lights2, scene, camera) {
    if (scope.enabled === false)
      return;
    if (scope.autoUpdate === false && scope.needsUpdate === false)
      return;
    if (lights2.length === 0)
      return;
    const currentRenderTarget = _renderer.getRenderTarget();
    const activeCubeFace = _renderer.getActiveCubeFace();
    const activeMipmapLevel = _renderer.getActiveMipmapLevel();
    const _state = _renderer.state;
    _state.setBlending(NoBlending);
    _state.buffers.color.setClear(1, 1, 1, 1);
    _state.buffers.depth.setTest(true);
    _state.setScissorTest(false);
    for (let i2 = 0, il = lights2.length; i2 < il; i2++) {
      const light = lights2[i2];
      const shadow2 = light.shadow;
      if (shadow2 === void 0) {
        console.warn("THREE.WebGLShadowMap:", light, "has no shadow.");
        continue;
      }
      if (shadow2.autoUpdate === false && shadow2.needsUpdate === false)
        continue;
      _shadowMapSize.copy(shadow2.mapSize);
      const shadowFrameExtents = shadow2.getFrameExtents();
      _shadowMapSize.multiply(shadowFrameExtents);
      _viewportSize.copy(shadow2.mapSize);
      if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
        if (_shadowMapSize.x > _maxTextureSize) {
          _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
          _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
          shadow2.mapSize.x = _viewportSize.x;
        }
        if (_shadowMapSize.y > _maxTextureSize) {
          _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
          _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
          shadow2.mapSize.y = _viewportSize.y;
        }
      }
      if (shadow2.map === null && !shadow2.isPointLightShadow && this.type === VSMShadowMap) {
        shadow2.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
        shadow2.map.texture.name = light.name + ".shadowMap";
        shadow2.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
        shadow2.camera.updateProjectionMatrix();
      }
      if (shadow2.map === null) {
        const pars = { minFilter: NearestFilter, magFilter: NearestFilter, format: RGBAFormat };
        shadow2.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow2.map.texture.name = light.name + ".shadowMap";
        shadow2.camera.updateProjectionMatrix();
      }
      _renderer.setRenderTarget(shadow2.map);
      _renderer.clear();
      const viewportCount = shadow2.getViewportCount();
      for (let vp = 0; vp < viewportCount; vp++) {
        const viewport = shadow2.getViewport(vp);
        _viewport.set(
          _viewportSize.x * viewport.x,
          _viewportSize.y * viewport.y,
          _viewportSize.x * viewport.z,
          _viewportSize.y * viewport.w
        );
        _state.viewport(_viewport);
        shadow2.updateMatrices(light, vp);
        _frustum = shadow2.getFrustum();
        renderObject(scene, camera, shadow2.camera, light, this.type);
      }
      if (!shadow2.isPointLightShadow && this.type === VSMShadowMap) {
        VSMPass(shadow2, camera);
      }
      shadow2.needsUpdate = false;
    }
    scope.needsUpdate = false;
    _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
  };
  function VSMPass(shadow2, camera) {
    const geometry2 = _objects.update(fullScreenMesh);
    if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow2.blurSamples) {
      shadowMaterialVertical.defines.VSM_SAMPLES = shadow2.blurSamples;
      shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow2.blurSamples;
      shadowMaterialVertical.needsUpdate = true;
      shadowMaterialHorizontal.needsUpdate = true;
    }
    shadowMaterialVertical.uniforms.shadow_pass.value = shadow2.map.texture;
    shadowMaterialVertical.uniforms.resolution.value = shadow2.mapSize;
    shadowMaterialVertical.uniforms.radius.value = shadow2.radius;
    _renderer.setRenderTarget(shadow2.mapPass);
    _renderer.clear();
    _renderer.renderBufferDirect(camera, null, geometry2, shadowMaterialVertical, fullScreenMesh, null);
    shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow2.mapPass.texture;
    shadowMaterialHorizontal.uniforms.resolution.value = shadow2.mapSize;
    shadowMaterialHorizontal.uniforms.radius.value = shadow2.radius;
    _renderer.setRenderTarget(shadow2.map);
    _renderer.clear();
    _renderer.renderBufferDirect(camera, null, geometry2, shadowMaterialHorizontal, fullScreenMesh, null);
  }
  function getDepthMaterial(object2, material, light, shadowCameraNear, shadowCameraFar, type) {
    let result = null;
    const customMaterial = light.isPointLight === true ? object2.customDistanceMaterial : object2.customDepthMaterial;
    if (customMaterial !== void 0) {
      result = customMaterial;
    } else {
      result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
    }
    if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
      const keyA = result.uuid, keyB = material.uuid;
      let materialsForVariant = _materialCache[keyA];
      if (materialsForVariant === void 0) {
        materialsForVariant = {};
        _materialCache[keyA] = materialsForVariant;
      }
      let cachedMaterial = materialsForVariant[keyB];
      if (cachedMaterial === void 0) {
        cachedMaterial = result.clone();
        materialsForVariant[keyB] = cachedMaterial;
      }
      result = cachedMaterial;
    }
    result.visible = material.visible;
    result.wireframe = material.wireframe;
    if (type === VSMShadowMap) {
      result.side = material.shadowSide !== null ? material.shadowSide : material.side;
    } else {
      result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
    }
    result.alphaMap = material.alphaMap;
    result.alphaTest = material.alphaTest;
    result.clipShadows = material.clipShadows;
    result.clippingPlanes = material.clippingPlanes;
    result.clipIntersection = material.clipIntersection;
    result.displacementMap = material.displacementMap;
    result.displacementScale = material.displacementScale;
    result.displacementBias = material.displacementBias;
    result.wireframeLinewidth = material.wireframeLinewidth;
    result.linewidth = material.linewidth;
    if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
      result.referencePosition.setFromMatrixPosition(light.matrixWorld);
      result.nearDistance = shadowCameraNear;
      result.farDistance = shadowCameraFar;
    }
    return result;
  }
  function renderObject(object2, camera, shadowCamera, light, type) {
    if (object2.visible === false)
      return;
    const visible = object2.layers.test(camera.layers);
    if (visible && (object2.isMesh || object2.isLine || object2.isPoints)) {
      if ((object2.castShadow || object2.receiveShadow && type === VSMShadowMap) && (!object2.frustumCulled || _frustum.intersectsObject(object2))) {
        object2.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object2.matrixWorld);
        const geometry2 = _objects.update(object2);
        const material = object2.material;
        if (Array.isArray(material)) {
          const groups = geometry2.groups;
          for (let k2 = 0, kl = groups.length; k2 < kl; k2++) {
            const group = groups[k2];
            const groupMaterial = material[group.materialIndex];
            if (groupMaterial && groupMaterial.visible) {
              const depthMaterial = getDepthMaterial(object2, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
              _renderer.renderBufferDirect(shadowCamera, null, geometry2, depthMaterial, object2, group);
            }
          }
        } else if (material.visible) {
          const depthMaterial = getDepthMaterial(object2, material, light, shadowCamera.near, shadowCamera.far, type);
          _renderer.renderBufferDirect(shadowCamera, null, geometry2, depthMaterial, object2, null);
        }
      }
    }
    const children = object2.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      renderObject(children[i2], camera, shadowCamera, light, type);
    }
  }
}
function WebGLState(gl, extensions, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  function ColorBuffer() {
    let locked = false;
    const color = new Vector4$1();
    let currentColorMask = null;
    const currentColorClear = new Vector4$1(0, 0, 0, 0);
    return {
      setMask: function(colorMask) {
        if (currentColorMask !== colorMask && !locked) {
          gl.colorMask(colorMask, colorMask, colorMask, colorMask);
          currentColorMask = colorMask;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(r2, g2, b2, a2, premultipliedAlpha) {
        if (premultipliedAlpha === true) {
          r2 *= a2;
          g2 *= a2;
          b2 *= a2;
        }
        color.set(r2, g2, b2, a2);
        if (currentColorClear.equals(color) === false) {
          gl.clearColor(r2, g2, b2, a2);
          currentColorClear.copy(color);
        }
      },
      reset: function() {
        locked = false;
        currentColorMask = null;
        currentColorClear.set(-1, 0, 0, 0);
      }
    };
  }
  function DepthBuffer() {
    let locked = false;
    let currentDepthMask = null;
    let currentDepthFunc = null;
    let currentDepthClear = null;
    return {
      setTest: function(depthTest) {
        if (depthTest) {
          enable4(2929);
        } else {
          disable3(2929);
        }
      },
      setMask: function(depthMask) {
        if (currentDepthMask !== depthMask && !locked) {
          gl.depthMask(depthMask);
          currentDepthMask = depthMask;
        }
      },
      setFunc: function(depthFunc) {
        if (currentDepthFunc !== depthFunc) {
          if (depthFunc) {
            switch (depthFunc) {
              case NeverDepth:
                gl.depthFunc(512);
                break;
              case AlwaysDepth:
                gl.depthFunc(519);
                break;
              case LessDepth:
                gl.depthFunc(513);
                break;
              case LessEqualDepth:
                gl.depthFunc(515);
                break;
              case EqualDepth:
                gl.depthFunc(514);
                break;
              case GreaterEqualDepth:
                gl.depthFunc(518);
                break;
              case GreaterDepth:
                gl.depthFunc(516);
                break;
              case NotEqualDepth:
                gl.depthFunc(517);
                break;
              default:
                gl.depthFunc(515);
            }
          } else {
            gl.depthFunc(515);
          }
          currentDepthFunc = depthFunc;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(depth2) {
        if (currentDepthClear !== depth2) {
          gl.clearDepth(depth2);
          currentDepthClear = depth2;
        }
      },
      reset: function() {
        locked = false;
        currentDepthMask = null;
        currentDepthFunc = null;
        currentDepthClear = null;
      }
    };
  }
  function StencilBuffer() {
    let locked = false;
    let currentStencilMask = null;
    let currentStencilFunc = null;
    let currentStencilRef = null;
    let currentStencilFuncMask = null;
    let currentStencilFail = null;
    let currentStencilZFail = null;
    let currentStencilZPass = null;
    let currentStencilClear = null;
    return {
      setTest: function(stencilTest) {
        if (!locked) {
          if (stencilTest) {
            enable4(2960);
          } else {
            disable3(2960);
          }
        }
      },
      setMask: function(stencilMask) {
        if (currentStencilMask !== stencilMask && !locked) {
          gl.stencilMask(stencilMask);
          currentStencilMask = stencilMask;
        }
      },
      setFunc: function(stencilFunc, stencilRef, stencilMask) {
        if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
          gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
          currentStencilFunc = stencilFunc;
          currentStencilRef = stencilRef;
          currentStencilFuncMask = stencilMask;
        }
      },
      setOp: function(stencilFail, stencilZFail, stencilZPass) {
        if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
          gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
          currentStencilFail = stencilFail;
          currentStencilZFail = stencilZFail;
          currentStencilZPass = stencilZPass;
        }
      },
      setLocked: function(lock) {
        locked = lock;
      },
      setClear: function(stencil) {
        if (currentStencilClear !== stencil) {
          gl.clearStencil(stencil);
          currentStencilClear = stencil;
        }
      },
      reset: function() {
        locked = false;
        currentStencilMask = null;
        currentStencilFunc = null;
        currentStencilRef = null;
        currentStencilFuncMask = null;
        currentStencilFail = null;
        currentStencilZFail = null;
        currentStencilZPass = null;
        currentStencilClear = null;
      }
    };
  }
  const colorBuffer = new ColorBuffer();
  const depthBuffer = new DepthBuffer();
  const stencilBuffer = new StencilBuffer();
  let enabledCapabilities = {};
  let currentBoundFramebuffers = {};
  let currentDrawbuffers = /* @__PURE__ */ new WeakMap();
  let defaultDrawbuffers = [];
  let currentProgram = null;
  let currentBlendingEnabled = false;
  let currentBlending = null;
  let currentBlendEquation = null;
  let currentBlendSrc = null;
  let currentBlendDst = null;
  let currentBlendEquationAlpha = null;
  let currentBlendSrcAlpha = null;
  let currentBlendDstAlpha = null;
  let currentPremultipledAlpha = false;
  let currentFlipSided = null;
  let currentCullFace = null;
  let currentLineWidth = null;
  let currentPolygonOffsetFactor = null;
  let currentPolygonOffsetUnits = null;
  const maxTextures = gl.getParameter(35661);
  let lineWidthAvailable = false;
  let version2 = 0;
  const glVersion = gl.getParameter(7938);
  if (glVersion.indexOf("WebGL") !== -1) {
    version2 = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version2 >= 1;
  } else if (glVersion.indexOf("OpenGL ES") !== -1) {
    version2 = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version2 >= 2;
  }
  let currentTextureSlot = null;
  let currentBoundTextures = {};
  const scissorParam = gl.getParameter(3088);
  const viewportParam = gl.getParameter(2978);
  const currentScissor = new Vector4$1().fromArray(scissorParam);
  const currentViewport = new Vector4$1().fromArray(viewportParam);
  function createTexture2(type, target, count3) {
    const data2 = new Uint8Array(4);
    const texture = gl.createTexture();
    gl.bindTexture(type, texture);
    gl.texParameteri(type, 10241, 9728);
    gl.texParameteri(type, 10240, 9728);
    for (let i2 = 0; i2 < count3; i2++) {
      gl.texImage2D(target + i2, 0, 6408, 1, 1, 0, 6408, 5121, data2);
    }
    return texture;
  }
  const emptyTextures = {};
  emptyTextures[3553] = createTexture2(3553, 3553, 1);
  emptyTextures[34067] = createTexture2(34067, 34069, 6);
  colorBuffer.setClear(0, 0, 0, 1);
  depthBuffer.setClear(1);
  stencilBuffer.setClear(0);
  enable4(2929);
  depthBuffer.setFunc(LessEqualDepth);
  setFlipSided(false);
  setCullFace(CullFaceBack);
  enable4(2884);
  setBlending(NoBlending);
  function enable4(id) {
    if (enabledCapabilities[id] !== true) {
      gl.enable(id);
      enabledCapabilities[id] = true;
    }
  }
  function disable3(id) {
    if (enabledCapabilities[id] !== false) {
      gl.disable(id);
      enabledCapabilities[id] = false;
    }
  }
  function bindFramebuffer2(target, framebuffer) {
    if (currentBoundFramebuffers[target] !== framebuffer) {
      gl.bindFramebuffer(target, framebuffer);
      currentBoundFramebuffers[target] = framebuffer;
      if (isWebGL2) {
        if (target === 36009) {
          currentBoundFramebuffers[36160] = framebuffer;
        }
        if (target === 36160) {
          currentBoundFramebuffers[36009] = framebuffer;
        }
      }
      return true;
    }
    return false;
  }
  function drawBuffers(renderTarget, framebuffer) {
    let drawBuffers2 = defaultDrawbuffers;
    let needsUpdate = false;
    if (renderTarget) {
      drawBuffers2 = currentDrawbuffers.get(framebuffer);
      if (drawBuffers2 === void 0) {
        drawBuffers2 = [];
        currentDrawbuffers.set(framebuffer, drawBuffers2);
      }
      if (renderTarget.isWebGLMultipleRenderTargets) {
        const textures = renderTarget.texture;
        if (drawBuffers2.length !== textures.length || drawBuffers2[0] !== 36064) {
          for (let i2 = 0, il = textures.length; i2 < il; i2++) {
            drawBuffers2[i2] = 36064 + i2;
          }
          drawBuffers2.length = textures.length;
          needsUpdate = true;
        }
      } else {
        if (drawBuffers2[0] !== 36064) {
          drawBuffers2[0] = 36064;
          needsUpdate = true;
        }
      }
    } else {
      if (drawBuffers2[0] !== 1029) {
        drawBuffers2[0] = 1029;
        needsUpdate = true;
      }
    }
    if (needsUpdate) {
      if (capabilities.isWebGL2) {
        gl.drawBuffers(drawBuffers2);
      } else {
        extensions.get("WEBGL_draw_buffers").drawBuffersWEBGL(drawBuffers2);
      }
    }
  }
  function useProgram(program) {
    if (currentProgram !== program) {
      gl.useProgram(program);
      currentProgram = program;
      return true;
    }
    return false;
  }
  const equationToGL = {
    [AddEquation]: 32774,
    [SubtractEquation]: 32778,
    [ReverseSubtractEquation]: 32779
  };
  if (isWebGL2) {
    equationToGL[MinEquation] = 32775;
    equationToGL[MaxEquation] = 32776;
  } else {
    const extension = extensions.get("EXT_blend_minmax");
    if (extension !== null) {
      equationToGL[MinEquation] = extension.MIN_EXT;
      equationToGL[MaxEquation] = extension.MAX_EXT;
    }
  }
  const factorToGL = {
    [ZeroFactor]: 0,
    [OneFactor]: 1,
    [SrcColorFactor]: 768,
    [SrcAlphaFactor]: 770,
    [SrcAlphaSaturateFactor]: 776,
    [DstColorFactor]: 774,
    [DstAlphaFactor]: 772,
    [OneMinusSrcColorFactor]: 769,
    [OneMinusSrcAlphaFactor]: 771,
    [OneMinusDstColorFactor]: 775,
    [OneMinusDstAlphaFactor]: 773
  };
  function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
    if (blending === NoBlending) {
      if (currentBlendingEnabled === true) {
        disable3(3042);
        currentBlendingEnabled = false;
      }
      return;
    }
    if (currentBlendingEnabled === false) {
      enable4(3042);
      currentBlendingEnabled = true;
    }
    if (blending !== CustomBlending) {
      if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
        if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
          gl.blendEquation(32774);
          currentBlendEquation = AddEquation;
          currentBlendEquationAlpha = AddEquation;
        }
        if (premultipliedAlpha) {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(1, 771, 1, 771);
              break;
            case AdditiveBlending:
              gl.blendFunc(1, 1);
              break;
            case SubtractiveBlending:
              gl.blendFuncSeparate(0, 769, 0, 1);
              break;
            case MultiplyBlending:
              gl.blendFuncSeparate(0, 768, 0, 770);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        } else {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(770, 771, 1, 771);
              break;
            case AdditiveBlending:
              gl.blendFunc(770, 1);
              break;
            case SubtractiveBlending:
              gl.blendFuncSeparate(0, 769, 0, 1);
              break;
            case MultiplyBlending:
              gl.blendFunc(0, 768);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", blending);
              break;
          }
        }
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlending = blending;
        currentPremultipledAlpha = premultipliedAlpha;
      }
      return;
    }
    blendEquationAlpha = blendEquationAlpha || blendEquation;
    blendSrcAlpha = blendSrcAlpha || blendSrc;
    blendDstAlpha = blendDstAlpha || blendDst;
    if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
      gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
      currentBlendEquation = blendEquation;
      currentBlendEquationAlpha = blendEquationAlpha;
    }
    if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
      gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
      currentBlendSrc = blendSrc;
      currentBlendDst = blendDst;
      currentBlendSrcAlpha = blendSrcAlpha;
      currentBlendDstAlpha = blendDstAlpha;
    }
    currentBlending = blending;
    currentPremultipledAlpha = null;
  }
  function setMaterial(material, frontFaceCW) {
    material.side === DoubleSide ? disable3(2884) : enable4(2884);
    let flipSided = material.side === BackSide;
    if (frontFaceCW)
      flipSided = !flipSided;
    setFlipSided(flipSided);
    material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
    depthBuffer.setFunc(material.depthFunc);
    depthBuffer.setTest(material.depthTest);
    depthBuffer.setMask(material.depthWrite);
    colorBuffer.setMask(material.colorWrite);
    const stencilWrite = material.stencilWrite;
    stencilBuffer.setTest(stencilWrite);
    if (stencilWrite) {
      stencilBuffer.setMask(material.stencilWriteMask);
      stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
      stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
    }
    setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    material.alphaToCoverage === true ? enable4(32926) : disable3(32926);
  }
  function setFlipSided(flipSided) {
    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(2304);
      } else {
        gl.frontFace(2305);
      }
      currentFlipSided = flipSided;
    }
  }
  function setCullFace(cullFace) {
    if (cullFace !== CullFaceNone) {
      enable4(2884);
      if (cullFace !== currentCullFace) {
        if (cullFace === CullFaceBack) {
          gl.cullFace(1029);
        } else if (cullFace === CullFaceFront) {
          gl.cullFace(1028);
        } else {
          gl.cullFace(1032);
        }
      }
    } else {
      disable3(2884);
    }
    currentCullFace = cullFace;
  }
  function setLineWidth(width) {
    if (width !== currentLineWidth) {
      if (lineWidthAvailable)
        gl.lineWidth(width);
      currentLineWidth = width;
    }
  }
  function setPolygonOffset(polygonOffset, factor, units2) {
    if (polygonOffset) {
      enable4(32823);
      if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units2) {
        gl.polygonOffset(factor, units2);
        currentPolygonOffsetFactor = factor;
        currentPolygonOffsetUnits = units2;
      }
    } else {
      disable3(32823);
    }
  }
  function setScissorTest(scissorTest) {
    if (scissorTest) {
      enable4(3089);
    } else {
      disable3(3089);
    }
  }
  function activeTexture(webglSlot) {
    if (webglSlot === void 0)
      webglSlot = 33984 + maxTextures - 1;
    if (currentTextureSlot !== webglSlot) {
      gl.activeTexture(webglSlot);
      currentTextureSlot = webglSlot;
    }
  }
  function bindTexture(webglType, webglTexture) {
    if (currentTextureSlot === null) {
      activeTexture();
    }
    let boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture === void 0) {
      boundTexture = { type: void 0, texture: void 0 };
      currentBoundTextures[currentTextureSlot] = boundTexture;
    }
    if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
      gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
      boundTexture.type = webglType;
      boundTexture.texture = webglTexture;
    }
  }
  function unbindTexture() {
    const boundTexture = currentBoundTextures[currentTextureSlot];
    if (boundTexture !== void 0 && boundTexture.type !== void 0) {
      gl.bindTexture(boundTexture.type, null);
      boundTexture.type = void 0;
      boundTexture.texture = void 0;
    }
  }
  function compressedTexImage2D() {
    try {
      gl.compressedTexImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texSubImage2D() {
    try {
      gl.texSubImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texSubImage3D() {
    try {
      gl.texSubImage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function compressedTexSubImage2D() {
    try {
      gl.compressedTexSubImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texStorage2D() {
    try {
      gl.texStorage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texStorage3D() {
    try {
      gl.texStorage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texImage2D() {
    try {
      gl.texImage2D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function texImage3D() {
    try {
      gl.texImage3D.apply(gl, arguments);
    } catch (error2) {
      console.error("THREE.WebGLState:", error2);
    }
  }
  function scissor(scissor2) {
    if (currentScissor.equals(scissor2) === false) {
      gl.scissor(scissor2.x, scissor2.y, scissor2.z, scissor2.w);
      currentScissor.copy(scissor2);
    }
  }
  function viewport(viewport2) {
    if (currentViewport.equals(viewport2) === false) {
      gl.viewport(viewport2.x, viewport2.y, viewport2.z, viewport2.w);
      currentViewport.copy(viewport2);
    }
  }
  function reset2() {
    gl.disable(3042);
    gl.disable(2884);
    gl.disable(2929);
    gl.disable(32823);
    gl.disable(3089);
    gl.disable(2960);
    gl.disable(32926);
    gl.blendEquation(32774);
    gl.blendFunc(1, 0);
    gl.blendFuncSeparate(1, 0, 1, 0);
    gl.colorMask(true, true, true, true);
    gl.clearColor(0, 0, 0, 0);
    gl.depthMask(true);
    gl.depthFunc(513);
    gl.clearDepth(1);
    gl.stencilMask(4294967295);
    gl.stencilFunc(519, 0, 4294967295);
    gl.stencilOp(7680, 7680, 7680);
    gl.clearStencil(0);
    gl.cullFace(1029);
    gl.frontFace(2305);
    gl.polygonOffset(0, 0);
    gl.activeTexture(33984);
    gl.bindFramebuffer(36160, null);
    if (isWebGL2 === true) {
      gl.bindFramebuffer(36009, null);
      gl.bindFramebuffer(36008, null);
    }
    gl.useProgram(null);
    gl.lineWidth(1);
    gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
    enabledCapabilities = {};
    currentTextureSlot = null;
    currentBoundTextures = {};
    currentBoundFramebuffers = {};
    currentDrawbuffers = /* @__PURE__ */ new WeakMap();
    defaultDrawbuffers = [];
    currentProgram = null;
    currentBlendingEnabled = false;
    currentBlending = null;
    currentBlendEquation = null;
    currentBlendSrc = null;
    currentBlendDst = null;
    currentBlendEquationAlpha = null;
    currentBlendSrcAlpha = null;
    currentBlendDstAlpha = null;
    currentPremultipledAlpha = false;
    currentFlipSided = null;
    currentCullFace = null;
    currentLineWidth = null;
    currentPolygonOffsetFactor = null;
    currentPolygonOffsetUnits = null;
    currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
    currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
    colorBuffer.reset();
    depthBuffer.reset();
    stencilBuffer.reset();
  }
  return {
    buffers: {
      color: colorBuffer,
      depth: depthBuffer,
      stencil: stencilBuffer
    },
    enable: enable4,
    disable: disable3,
    bindFramebuffer: bindFramebuffer2,
    drawBuffers,
    useProgram,
    setBlending,
    setMaterial,
    setFlipSided,
    setCullFace,
    setLineWidth,
    setPolygonOffset,
    setScissorTest,
    activeTexture,
    bindTexture,
    unbindTexture,
    compressedTexImage2D,
    texImage2D,
    texImage3D,
    texStorage2D,
    texStorage3D,
    texSubImage2D,
    texSubImage3D,
    compressedTexSubImage2D,
    scissor,
    viewport,
    reset: reset2
  };
}
function WebGLTextures(_gl, extensions, state, properties, capabilities, utils2, info) {
  const isWebGL2 = capabilities.isWebGL2;
  const maxTextures = capabilities.maxTextures;
  const maxCubemapSize = capabilities.maxCubemapSize;
  const maxTextureSize = capabilities.maxTextureSize;
  const maxSamples = capabilities.maxSamples;
  const multisampledRTTExt = extensions.has("WEBGL_multisampled_render_to_texture") ? extensions.get("WEBGL_multisampled_render_to_texture") : null;
  const supportsInvalidateFramebuffer = /OculusBrowser/g.test(navigator.userAgent);
  const _videoTextures = /* @__PURE__ */ new WeakMap();
  let _canvas2;
  const _sources = /* @__PURE__ */ new WeakMap();
  let useOffscreenCanvas = false;
  try {
    useOffscreenCanvas = typeof OffscreenCanvas !== "undefined" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch (err) {
  }
  function createCanvas2(width, height) {
    return useOffscreenCanvas ? (
      // eslint-disable-next-line compat/compat
      new OffscreenCanvas(width, height)
    ) : createElementNS("canvas");
  }
  function resizeImage2(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
    let scale5 = 1;
    if (image.width > maxSize || image.height > maxSize) {
      scale5 = maxSize / Math.max(image.width, image.height);
    }
    if (scale5 < 1 || needsPowerOfTwo === true) {
      if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
        const floor3 = needsPowerOfTwo ? floorPowerOfTwo : Math.floor;
        const width = floor3(scale5 * image.width);
        const height = floor3(scale5 * image.height);
        if (_canvas2 === void 0)
          _canvas2 = createCanvas2(width, height);
        const canvas2 = needsNewCanvas ? createCanvas2(width, height) : _canvas2;
        canvas2.width = width;
        canvas2.height = height;
        const context2 = canvas2.getContext("2d");
        context2.drawImage(image, 0, 0, width, height);
        console.warn("THREE.WebGLRenderer: Texture has been resized from (" + image.width + "x" + image.height + ") to (" + width + "x" + height + ").");
        return canvas2;
      } else {
        if ("data" in image) {
          console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + image.width + "x" + image.height + ").");
        }
        return image;
      }
    }
    return image;
  }
  function isPowerOfTwo$1(image) {
    return isPowerOfTwo(image.width) && isPowerOfTwo(image.height);
  }
  function textureNeedsPowerOfTwo(texture) {
    if (isWebGL2)
      return false;
    return texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping || texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
  }
  function textureNeedsGenerateMipmaps(texture, supportsMips) {
    return texture.generateMipmaps && supportsMips && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
  }
  function generateMipmap(target) {
    _gl.generateMipmap(target);
  }
  function getInternalFormat(internalFormatName, glFormat, glType, encoding, isVideoTexture = false) {
    if (isWebGL2 === false)
      return glFormat;
    if (internalFormatName !== null) {
      if (_gl[internalFormatName] !== void 0)
        return _gl[internalFormatName];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + internalFormatName + "'");
    }
    let internalFormat = glFormat;
    if (glFormat === 6403) {
      if (glType === 5126)
        internalFormat = 33326;
      if (glType === 5131)
        internalFormat = 33325;
      if (glType === 5121)
        internalFormat = 33321;
    }
    if (glFormat === 33319) {
      if (glType === 5126)
        internalFormat = 33328;
      if (glType === 5131)
        internalFormat = 33327;
      if (glType === 5121)
        internalFormat = 33323;
    }
    if (glFormat === 6408) {
      if (glType === 5126)
        internalFormat = 34836;
      if (glType === 5131)
        internalFormat = 34842;
      if (glType === 5121)
        internalFormat = encoding === sRGBEncoding && isVideoTexture === false ? 35907 : 32856;
      if (glType === 32819)
        internalFormat = 32854;
      if (glType === 32820)
        internalFormat = 32855;
    }
    if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) {
      extensions.get("EXT_color_buffer_float");
    }
    return internalFormat;
  }
  function getMipLevels(texture, image, supportsMips) {
    if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
      return Math.log2(Math.max(image.width, image.height)) + 1;
    } else if (texture.mipmaps !== void 0 && texture.mipmaps.length > 0) {
      return texture.mipmaps.length;
    } else if (texture.isCompressedTexture && Array.isArray(texture.image)) {
      return image.mipmaps.length;
    } else {
      return 1;
    }
  }
  function filterFallback(f2) {
    if (f2 === NearestFilter || f2 === NearestMipmapNearestFilter || f2 === NearestMipmapLinearFilter) {
      return 9728;
    }
    return 9729;
  }
  function onTextureDispose(event) {
    const texture = event.target;
    texture.removeEventListener("dispose", onTextureDispose);
    deallocateTexture(texture);
    if (texture.isVideoTexture) {
      _videoTextures.delete(texture);
    }
  }
  function onRenderTargetDispose(event) {
    const renderTarget = event.target;
    renderTarget.removeEventListener("dispose", onRenderTargetDispose);
    deallocateRenderTarget(renderTarget);
  }
  function deallocateTexture(texture) {
    const textureProperties = properties.get(texture);
    if (textureProperties.__webglInit === void 0)
      return;
    const source = texture.source;
    const webglTextures = _sources.get(source);
    if (webglTextures) {
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      webglTexture.usedTimes--;
      if (webglTexture.usedTimes === 0) {
        deleteTexture(texture);
      }
      if (Object.keys(webglTextures).length === 0) {
        _sources.delete(source);
      }
    }
    properties.remove(texture);
  }
  function deleteTexture(texture) {
    const textureProperties = properties.get(texture);
    _gl.deleteTexture(textureProperties.__webglTexture);
    const source = texture.source;
    const webglTextures = _sources.get(source);
    delete webglTextures[textureProperties.__cacheKey];
    info.memory.textures--;
  }
  function deallocateRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    if (textureProperties.__webglTexture !== void 0) {
      _gl.deleteTexture(textureProperties.__webglTexture);
      info.memory.textures--;
    }
    if (renderTarget.depthTexture) {
      renderTarget.depthTexture.dispose();
    }
    if (renderTarget.isWebGLCubeRenderTarget) {
      for (let i2 = 0; i2 < 6; i2++) {
        _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i2]);
        if (renderTargetProperties.__webglDepthbuffer)
          _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i2]);
      }
    } else {
      _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
      if (renderTargetProperties.__webglDepthbuffer)
        _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
      if (renderTargetProperties.__webglMultisampledFramebuffer)
        _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
      if (renderTargetProperties.__webglColorRenderbuffer)
        _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
      if (renderTargetProperties.__webglDepthRenderbuffer)
        _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
    }
    if (renderTarget.isWebGLMultipleRenderTargets) {
      for (let i2 = 0, il = texture.length; i2 < il; i2++) {
        const attachmentProperties = properties.get(texture[i2]);
        if (attachmentProperties.__webglTexture) {
          _gl.deleteTexture(attachmentProperties.__webglTexture);
          info.memory.textures--;
        }
        properties.remove(texture[i2]);
      }
    }
    properties.remove(texture);
    properties.remove(renderTarget);
  }
  let textureUnits = 0;
  function resetTextureUnits() {
    textureUnits = 0;
  }
  function allocateTextureUnit() {
    const textureUnit = textureUnits;
    if (textureUnit >= maxTextures) {
      console.warn("THREE.WebGLTextures: Trying to use " + textureUnit + " texture units while this GPU supports only " + maxTextures);
    }
    textureUnits += 1;
    return textureUnit;
  }
  function getTextureCacheKey(texture) {
    const array2 = [];
    array2.push(texture.wrapS);
    array2.push(texture.wrapT);
    array2.push(texture.magFilter);
    array2.push(texture.minFilter);
    array2.push(texture.anisotropy);
    array2.push(texture.internalFormat);
    array2.push(texture.format);
    array2.push(texture.type);
    array2.push(texture.generateMipmaps);
    array2.push(texture.premultiplyAlpha);
    array2.push(texture.flipY);
    array2.push(texture.unpackAlignment);
    array2.push(texture.encoding);
    return array2.join();
  }
  function setTexture2D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.isVideoTexture)
      updateVideoTexture(texture);
    if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
      const image = texture.image;
      if (image === null) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      } else if (image.complete === false) {
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      } else {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(3553, textureProperties.__webglTexture);
  }
  function setTexture2DArray(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(35866, textureProperties.__webglTexture);
  }
  function setTexture3D(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(32879, textureProperties.__webglTexture);
  }
  function setTextureCube(texture, slot) {
    const textureProperties = properties.get(texture);
    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadCubeTexture(textureProperties, texture, slot);
      return;
    }
    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);
  }
  const wrappingToGL = {
    [RepeatWrapping]: 10497,
    [ClampToEdgeWrapping]: 33071,
    [MirroredRepeatWrapping]: 33648
  };
  const filterToGL = {
    [NearestFilter]: 9728,
    [NearestMipmapNearestFilter]: 9984,
    [NearestMipmapLinearFilter]: 9986,
    [LinearFilter]: 9729,
    [LinearMipmapNearestFilter]: 9985,
    [LinearMipmapLinearFilter]: 9987
  };
  function setTextureParameters(textureType, texture, supportsMips) {
    if (supportsMips) {
      _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
      _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
      }
      _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
      _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
    } else {
      _gl.texParameteri(textureType, 10242, 33071);
      _gl.texParameteri(textureType, 10243, 33071);
      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, 33071);
      }
      if (texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping) {
        console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.");
      }
      _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
      _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
      if (texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
        console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.");
      }
    }
    if (extensions.has("EXT_texture_filter_anisotropic") === true) {
      const extension = extensions.get("EXT_texture_filter_anisotropic");
      if (texture.type === FloatType && extensions.has("OES_texture_float_linear") === false)
        return;
      if (isWebGL2 === false && (texture.type === HalfFloatType && extensions.has("OES_texture_half_float_linear") === false))
        return;
      if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
        _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
        properties.get(texture).__currentAnisotropy = texture.anisotropy;
      }
    }
  }
  function initTexture(textureProperties, texture) {
    let forceUpload = false;
    if (textureProperties.__webglInit === void 0) {
      textureProperties.__webglInit = true;
      texture.addEventListener("dispose", onTextureDispose);
    }
    const source = texture.source;
    let webglTextures = _sources.get(source);
    if (webglTextures === void 0) {
      webglTextures = {};
      _sources.set(source, webglTextures);
    }
    const textureCacheKey = getTextureCacheKey(texture);
    if (textureCacheKey !== textureProperties.__cacheKey) {
      if (webglTextures[textureCacheKey] === void 0) {
        webglTextures[textureCacheKey] = {
          texture: _gl.createTexture(),
          usedTimes: 0
        };
        info.memory.textures++;
        forceUpload = true;
      }
      webglTextures[textureCacheKey].usedTimes++;
      const webglTexture = webglTextures[textureProperties.__cacheKey];
      if (webglTexture !== void 0) {
        webglTextures[textureProperties.__cacheKey].usedTimes--;
        if (webglTexture.usedTimes === 0) {
          deleteTexture(texture);
        }
      }
      textureProperties.__cacheKey = textureCacheKey;
      textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
    }
    return forceUpload;
  }
  function uploadTexture(textureProperties, texture, slot) {
    let textureType = 3553;
    if (texture.isDataArrayTexture)
      textureType = 35866;
    if (texture.isData3DTexture)
      textureType = 32879;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.activeTexture(33984 + slot);
    state.bindTexture(textureType, textureProperties.__webglTexture);
    if (source.version !== source.__currentVersion || forceUpload === true) {
      _gl.pixelStorei(37440, texture.flipY);
      _gl.pixelStorei(37441, texture.premultiplyAlpha);
      _gl.pixelStorei(3317, texture.unpackAlignment);
      _gl.pixelStorei(37443, 0);
      const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
      let image = resizeImage2(texture.image, needsPowerOfTwo, false, maxTextureSize);
      image = verifyColorSpace(texture, image);
      const supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils2.convert(texture.format, texture.encoding);
      let glType = utils2.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
      setTextureParameters(textureType, texture, supportsMips);
      let mipmap;
      const mipmaps = texture.mipmaps;
      const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
      const allocateMemory = textureProperties.__version === void 0;
      const levels = getMipLevels(texture, image, supportsMips);
      if (texture.isDepthTexture) {
        glInternalFormat = 6402;
        if (isWebGL2) {
          if (texture.type === FloatType) {
            glInternalFormat = 36012;
          } else if (texture.type === UnsignedIntType) {
            glInternalFormat = 33190;
          } else if (texture.type === UnsignedInt248Type) {
            glInternalFormat = 35056;
          } else {
            glInternalFormat = 33189;
          }
        } else {
          if (texture.type === FloatType) {
            console.error("WebGLRenderer: Floating point depth texture requires WebGL2.");
          }
        }
        if (texture.format === DepthFormat && glInternalFormat === 6402) {
          if (texture.type !== UnsignedShortType && texture.type !== UnsignedIntType) {
            console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.");
            texture.type = UnsignedShortType;
            glType = utils2.convert(texture.type);
          }
        }
        if (texture.format === DepthStencilFormat && glInternalFormat === 6402) {
          glInternalFormat = 34041;
          if (texture.type !== UnsignedInt248Type) {
            console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.");
            texture.type = UnsignedInt248Type;
            glType = utils2.convert(texture.type);
          }
        }
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
        } else {
          state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        }
      } else if (texture.isDataTexture) {
        if (mipmaps.length > 0 && supportsMips) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (useTexStorage) {
              state.texSubImage2D(3553, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
            } else {
              state.texImage2D(3553, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
            }
            state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
          } else {
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
          }
        }
      } else if (texture.isCompressedTexture) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
        }
        for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
          mipmap = mipmaps[i2];
          if (texture.format !== RGBAFormat) {
            if (glFormat !== null) {
              if (useTexStorage) {
                state.compressedTexSubImage2D(3553, i2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
              } else {
                state.compressedTexImage2D(3553, i2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
              }
            } else {
              console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
            }
          } else {
            if (useTexStorage) {
              state.texSubImage2D(3553, i2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
            } else {
              state.texImage2D(3553, i2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
          }
        }
      } else if (texture.isDataArrayTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
          }
          state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else {
          state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isData3DTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
          }
          state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else {
          state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isFramebufferTexture) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
        } else {
          state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        }
      } else {
        if (mipmaps.length > 0 && supportsMips) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }
          for (let i2 = 0, il = mipmaps.length; i2 < il; i2++) {
            mipmap = mipmaps[i2];
            if (useTexStorage) {
              state.texSubImage2D(3553, i2, 0, 0, glFormat, glType, mipmap);
            } else {
              state.texImage2D(3553, i2, glInternalFormat, glFormat, glType, mipmap);
            }
          }
          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
            }
            state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
          } else {
            state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(textureType);
      }
      source.__currentVersion = source.version;
      if (texture.onUpdate)
        texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function uploadCubeTexture(textureProperties, texture, slot) {
    if (texture.image.length !== 6)
      return;
    const forceUpload = initTexture(textureProperties, texture);
    const source = texture.source;
    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);
    if (source.version !== source.__currentVersion || forceUpload === true) {
      _gl.pixelStorei(37440, texture.flipY);
      _gl.pixelStorei(37441, texture.premultiplyAlpha);
      _gl.pixelStorei(3317, texture.unpackAlignment);
      _gl.pixelStorei(37443, 0);
      const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
      const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
      const cubeImage = [];
      for (let i2 = 0; i2 < 6; i2++) {
        if (!isCompressed && !isDataTexture) {
          cubeImage[i2] = resizeImage2(texture.image[i2], false, true, maxCubemapSize);
        } else {
          cubeImage[i2] = isDataTexture ? texture.image[i2].image : texture.image[i2];
        }
        cubeImage[i2] = verifyColorSpace(texture, cubeImage[i2]);
      }
      const image = cubeImage[0], supportsMips = isPowerOfTwo$1(image) || isWebGL2, glFormat = utils2.convert(texture.format, texture.encoding), glType = utils2.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
      const useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
      const allocateMemory = textureProperties.__version === void 0;
      let levels = getMipLevels(texture, image, supportsMips);
      setTextureParameters(34067, texture, supportsMips);
      let mipmaps;
      if (isCompressed) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
        }
        for (let i2 = 0; i2 < 6; i2++) {
          mipmaps = cubeImage[i2].mipmaps;
          for (let j2 = 0; j2 < mipmaps.length; j2++) {
            const mipmap = mipmaps[j2];
            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  state.compressedTexSubImage2D(34069 + i2, j2, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                } else {
                  state.compressedTexImage2D(34069 + i2, j2, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()");
              }
            } else {
              if (useTexStorage) {
                state.texSubImage2D(34069 + i2, j2, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
              } else {
                state.texImage2D(34069 + i2, j2, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else {
        mipmaps = texture.mipmaps;
        if (useTexStorage && allocateMemory) {
          if (mipmaps.length > 0)
            levels++;
          state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
        }
        for (let i2 = 0; i2 < 6; i2++) {
          if (isDataTexture) {
            if (useTexStorage) {
              state.texSubImage2D(34069 + i2, 0, 0, 0, cubeImage[i2].width, cubeImage[i2].height, glFormat, glType, cubeImage[i2].data);
            } else {
              state.texImage2D(34069 + i2, 0, glInternalFormat, cubeImage[i2].width, cubeImage[i2].height, 0, glFormat, glType, cubeImage[i2].data);
            }
            for (let j2 = 0; j2 < mipmaps.length; j2++) {
              const mipmap = mipmaps[j2];
              const mipmapImage = mipmap.image[i2].image;
              if (useTexStorage) {
                state.texSubImage2D(34069 + i2, j2 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
              } else {
                state.texImage2D(34069 + i2, j2 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
              }
            }
          } else {
            if (useTexStorage) {
              state.texSubImage2D(34069 + i2, 0, 0, 0, glFormat, glType, cubeImage[i2]);
            } else {
              state.texImage2D(34069 + i2, 0, glInternalFormat, glFormat, glType, cubeImage[i2]);
            }
            for (let j2 = 0; j2 < mipmaps.length; j2++) {
              const mipmap = mipmaps[j2];
              if (useTexStorage) {
                state.texSubImage2D(34069 + i2, j2 + 1, 0, 0, glFormat, glType, mipmap.image[i2]);
              } else {
                state.texImage2D(34069 + i2, j2 + 1, glInternalFormat, glFormat, glType, mipmap.image[i2]);
              }
            }
          }
        }
      }
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(34067);
      }
      source.__currentVersion = source.version;
      if (texture.onUpdate)
        texture.onUpdate(texture);
    }
    textureProperties.__version = texture.version;
  }
  function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
    const glFormat = utils2.convert(texture.format, texture.encoding);
    const glType = utils2.convert(texture.type);
    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
    const renderTargetProperties = properties.get(renderTarget);
    if (!renderTargetProperties.__hasExternalTextures) {
      if (textureTarget === 32879 || textureTarget === 35866) {
        state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
      } else {
        state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
      }
    }
    state.bindFramebuffer(36160, framebuffer);
    if (useMultisampledRTT(renderTarget)) {
      multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
    } else {
      _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
    }
    state.bindFramebuffer(36160, null);
  }
  function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
    _gl.bindRenderbuffer(36161, renderbuffer);
    if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
      let glInternalFormat = 33189;
      if (isMultisample || useMultisampledRTT(renderTarget)) {
        const depthTexture = renderTarget.depthTexture;
        if (depthTexture && depthTexture.isDepthTexture) {
          if (depthTexture.type === FloatType) {
            glInternalFormat = 36012;
          } else if (depthTexture.type === UnsignedIntType) {
            glInternalFormat = 33190;
          }
        }
        const samples = getRenderTargetSamples(renderTarget);
        if (useMultisampledRTT(renderTarget)) {
          multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else {
          _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        }
      } else {
        _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
    } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
      const samples = getRenderTargetSamples(renderTarget);
      if (isMultisample && useMultisampledRTT(renderTarget) === false) {
        _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
      } else if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, 35056, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
      }
      _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
    } else {
      const texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
      const glFormat = utils2.convert(texture.format, texture.encoding);
      const glType = utils2.convert(texture.type);
      const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
      const samples = getRenderTargetSamples(renderTarget);
      if (isMultisample && useMultisampledRTT(renderTarget) === false) {
        _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
      }
    }
    _gl.bindRenderbuffer(36161, null);
  }
  function setupDepthTexture(framebuffer, renderTarget) {
    const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
    if (isCube)
      throw new Error("Depth Texture with cube render targets is not supported");
    state.bindFramebuffer(36160, framebuffer);
    if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    }
    if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
      renderTarget.depthTexture.image.width = renderTarget.width;
      renderTarget.depthTexture.image.height = renderTarget.height;
      renderTarget.depthTexture.needsUpdate = true;
    }
    setTexture2D(renderTarget.depthTexture, 0);
    const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
    const samples = getRenderTargetSamples(renderTarget);
    if (renderTarget.depthTexture.format === DepthFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
      }
    } else if (renderTarget.depthTexture.format === DepthStencilFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
      }
    } else {
      throw new Error("Unknown depthTexture format");
    }
  }
  function setupDepthRenderbuffer(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
      if (isCube)
        throw new Error("target.depthTexture not supported in Cube render targets");
      setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
    } else {
      if (isCube) {
        renderTargetProperties.__webglDepthbuffer = [];
        for (let i2 = 0; i2 < 6; i2++) {
          state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i2]);
          renderTargetProperties.__webglDepthbuffer[i2] = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i2], renderTarget, false);
        }
      } else {
        state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
        renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
        setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
      }
    }
    state.bindFramebuffer(36160, null);
  }
  function rebindTextures(renderTarget, colorTexture, depthTexture) {
    const renderTargetProperties = properties.get(renderTarget);
    if (colorTexture !== void 0) {
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
    }
    if (depthTexture !== void 0) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function setupRenderTarget(renderTarget) {
    const texture = renderTarget.texture;
    const renderTargetProperties = properties.get(renderTarget);
    const textureProperties = properties.get(texture);
    renderTarget.addEventListener("dispose", onRenderTargetDispose);
    if (renderTarget.isWebGLMultipleRenderTargets !== true) {
      if (textureProperties.__webglTexture === void 0) {
        textureProperties.__webglTexture = _gl.createTexture();
      }
      textureProperties.__version = texture.version;
      info.memory.textures++;
    }
    const isCube = renderTarget.isWebGLCubeRenderTarget === true;
    const isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
    const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
    if (isCube) {
      renderTargetProperties.__webglFramebuffer = [];
      for (let i2 = 0; i2 < 6; i2++) {
        renderTargetProperties.__webglFramebuffer[i2] = _gl.createFramebuffer();
      }
    } else {
      renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
      if (isMultipleRenderTargets) {
        if (capabilities.drawBuffers) {
          const textures = renderTarget.texture;
          for (let i2 = 0, il = textures.length; i2 < il; i2++) {
            const attachmentProperties = properties.get(textures[i2]);
            if (attachmentProperties.__webglTexture === void 0) {
              attachmentProperties.__webglTexture = _gl.createTexture();
              info.memory.textures++;
            }
          }
        } else {
          console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
        }
      } else if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
        renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
        renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
        _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
        const glFormat = utils2.convert(texture.format, texture.encoding);
        const glType = utils2.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        const samples = getRenderTargetSamples(renderTarget);
        _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
        _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
        _gl.bindRenderbuffer(36161, null);
        if (renderTarget.depthBuffer) {
          renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
        }
        state.bindFramebuffer(36160, null);
      }
    }
    if (isCube) {
      state.bindTexture(34067, textureProperties.__webglTexture);
      setTextureParameters(34067, texture, supportsMips);
      for (let i2 = 0; i2 < 6; i2++) {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i2], renderTarget, texture, 36064, 34069 + i2);
      }
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(34067);
      }
      state.unbindTexture();
    } else if (isMultipleRenderTargets) {
      const textures = renderTarget.texture;
      for (let i2 = 0, il = textures.length; i2 < il; i2++) {
        const attachment = textures[i2];
        const attachmentProperties = properties.get(attachment);
        state.bindTexture(3553, attachmentProperties.__webglTexture);
        setTextureParameters(3553, attachment, supportsMips);
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + i2, 3553);
        if (textureNeedsGenerateMipmaps(attachment, supportsMips)) {
          generateMipmap(3553);
        }
      }
      state.unbindTexture();
    } else {
      let glTextureType = 3553;
      if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
        if (isWebGL2) {
          glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
        } else {
          console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.");
        }
      }
      state.bindTexture(glTextureType, textureProperties.__webglTexture);
      setTextureParameters(glTextureType, texture, supportsMips);
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(glTextureType);
      }
      state.unbindTexture();
    }
    if (renderTarget.depthBuffer) {
      setupDepthRenderbuffer(renderTarget);
    }
  }
  function updateRenderTargetMipmap(renderTarget) {
    const supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
    const textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];
    for (let i2 = 0, il = textures.length; i2 < il; i2++) {
      const texture = textures[i2];
      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
        const webglTexture = properties.get(texture).__webglTexture;
        state.bindTexture(target, webglTexture);
        generateMipmap(target);
        state.unbindTexture();
      }
    }
  }
  function updateMultisampleRenderTarget(renderTarget) {
    if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
      const width = renderTarget.width;
      const height = renderTarget.height;
      let mask = 16384;
      const invalidationArray = [36064];
      const depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;
      if (renderTarget.depthBuffer) {
        invalidationArray.push(depthStyle);
      }
      const renderTargetProperties = properties.get(renderTarget);
      const ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== void 0 ? renderTargetProperties.__ignoreDepthValues : false;
      if (ignoreDepthValues === false) {
        if (renderTarget.depthBuffer)
          mask |= 256;
        if (renderTarget.stencilBuffer)
          mask |= 1024;
      }
      state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
      state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
      if (ignoreDepthValues === true) {
        _gl.invalidateFramebuffer(36008, [depthStyle]);
        _gl.invalidateFramebuffer(36009, [depthStyle]);
      }
      _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
      if (supportsInvalidateFramebuffer) {
        _gl.invalidateFramebuffer(36008, invalidationArray);
      }
      state.bindFramebuffer(36008, null);
      state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
    }
  }
  function getRenderTargetSamples(renderTarget) {
    return Math.min(maxSamples, renderTarget.samples);
  }
  function useMultisampledRTT(renderTarget) {
    const renderTargetProperties = properties.get(renderTarget);
    return isWebGL2 && renderTarget.samples > 0 && extensions.has("WEBGL_multisampled_render_to_texture") === true && renderTargetProperties.__useRenderToTexture !== false;
  }
  function updateVideoTexture(texture) {
    const frame = info.render.frame;
    if (_videoTextures.get(texture) !== frame) {
      _videoTextures.set(texture, frame);
      texture.update();
    }
  }
  function verifyColorSpace(texture, image) {
    const encoding = texture.encoding;
    const format = texture.format;
    const type = texture.type;
    if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === _SRGBAFormat)
      return image;
    if (encoding !== LinearEncoding) {
      if (encoding === sRGBEncoding) {
        if (isWebGL2 === false) {
          if (extensions.has("EXT_sRGB") === true && format === RGBAFormat) {
            texture.format = _SRGBAFormat;
            texture.minFilter = LinearFilter;
            texture.generateMipmaps = false;
          } else {
            image = ImageUtils.sRGBToLinear(image);
          }
        } else {
          if (format !== RGBAFormat || type !== UnsignedByteType) {
            console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.");
          }
        }
      } else {
        console.error("THREE.WebGLTextures: Unsupported texture encoding:", encoding);
      }
    }
    return image;
  }
  this.allocateTextureUnit = allocateTextureUnit;
  this.resetTextureUnits = resetTextureUnits;
  this.setTexture2D = setTexture2D;
  this.setTexture2DArray = setTexture2DArray;
  this.setTexture3D = setTexture3D;
  this.setTextureCube = setTextureCube;
  this.rebindTextures = rebindTextures;
  this.setupRenderTarget = setupRenderTarget;
  this.updateRenderTargetMipmap = updateRenderTargetMipmap;
  this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
  this.setupDepthRenderbuffer = setupDepthRenderbuffer;
  this.setupFrameBufferTexture = setupFrameBufferTexture;
  this.useMultisampledRTT = useMultisampledRTT;
}
function WebGLUtils(gl, extensions, capabilities) {
  const isWebGL2 = capabilities.isWebGL2;
  function convert(p2, encoding = null) {
    let extension;
    if (p2 === UnsignedByteType)
      return 5121;
    if (p2 === UnsignedShort4444Type)
      return 32819;
    if (p2 === UnsignedShort5551Type)
      return 32820;
    if (p2 === ByteType)
      return 5120;
    if (p2 === ShortType)
      return 5122;
    if (p2 === UnsignedShortType)
      return 5123;
    if (p2 === IntType)
      return 5124;
    if (p2 === UnsignedIntType)
      return 5125;
    if (p2 === FloatType)
      return 5126;
    if (p2 === HalfFloatType) {
      if (isWebGL2)
        return 5131;
      extension = extensions.get("OES_texture_half_float");
      if (extension !== null) {
        return extension.HALF_FLOAT_OES;
      } else {
        return null;
      }
    }
    if (p2 === AlphaFormat)
      return 6406;
    if (p2 === RGBAFormat)
      return 6408;
    if (p2 === LuminanceFormat)
      return 6409;
    if (p2 === LuminanceAlphaFormat)
      return 6410;
    if (p2 === DepthFormat)
      return 6402;
    if (p2 === DepthStencilFormat)
      return 34041;
    if (p2 === RedFormat)
      return 6403;
    if (p2 === RGBFormat) {
      console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228");
      return 6408;
    }
    if (p2 === _SRGBAFormat) {
      extension = extensions.get("EXT_sRGB");
      if (extension !== null) {
        return extension.SRGB_ALPHA_EXT;
      } else {
        return null;
      }
    }
    if (p2 === RedIntegerFormat)
      return 36244;
    if (p2 === RGFormat)
      return 33319;
    if (p2 === RGIntegerFormat)
      return 33320;
    if (p2 === RGBAIntegerFormat)
      return 36249;
    if (p2 === RGB_S3TC_DXT1_Format || p2 === RGBA_S3TC_DXT1_Format || p2 === RGBA_S3TC_DXT3_Format || p2 === RGBA_S3TC_DXT5_Format) {
      if (encoding === sRGBEncoding) {
        extension = extensions.get("WEBGL_compressed_texture_s3tc_srgb");
        if (extension !== null) {
          if (p2 === RGB_S3TC_DXT1_Format)
            return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT1_Format)
            return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT3_Format)
            return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (p2 === RGBA_S3TC_DXT5_Format)
            return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      } else {
        extension = extensions.get("WEBGL_compressed_texture_s3tc");
        if (extension !== null) {
          if (p2 === RGB_S3TC_DXT1_Format)
            return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT1_Format)
            return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (p2 === RGBA_S3TC_DXT3_Format)
            return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (p2 === RGBA_S3TC_DXT5_Format)
            return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      }
    }
    if (p2 === RGB_PVRTC_4BPPV1_Format || p2 === RGB_PVRTC_2BPPV1_Format || p2 === RGBA_PVRTC_4BPPV1_Format || p2 === RGBA_PVRTC_2BPPV1_Format) {
      extension = extensions.get("WEBGL_compressed_texture_pvrtc");
      if (extension !== null) {
        if (p2 === RGB_PVRTC_4BPPV1_Format)
          return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (p2 === RGB_PVRTC_2BPPV1_Format)
          return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (p2 === RGBA_PVRTC_4BPPV1_Format)
          return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (p2 === RGBA_PVRTC_2BPPV1_Format)
          return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else {
        return null;
      }
    }
    if (p2 === RGB_ETC1_Format) {
      extension = extensions.get("WEBGL_compressed_texture_etc1");
      if (extension !== null) {
        return extension.COMPRESSED_RGB_ETC1_WEBGL;
      } else {
        return null;
      }
    }
    if (p2 === RGB_ETC2_Format || p2 === RGBA_ETC2_EAC_Format) {
      extension = extensions.get("WEBGL_compressed_texture_etc");
      if (extension !== null) {
        if (p2 === RGB_ETC2_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
        if (p2 === RGBA_ETC2_EAC_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
      } else {
        return null;
      }
    }
    if (p2 === RGBA_ASTC_4x4_Format || p2 === RGBA_ASTC_5x4_Format || p2 === RGBA_ASTC_5x5_Format || p2 === RGBA_ASTC_6x5_Format || p2 === RGBA_ASTC_6x6_Format || p2 === RGBA_ASTC_8x5_Format || p2 === RGBA_ASTC_8x6_Format || p2 === RGBA_ASTC_8x8_Format || p2 === RGBA_ASTC_10x5_Format || p2 === RGBA_ASTC_10x6_Format || p2 === RGBA_ASTC_10x8_Format || p2 === RGBA_ASTC_10x10_Format || p2 === RGBA_ASTC_12x10_Format || p2 === RGBA_ASTC_12x12_Format) {
      extension = extensions.get("WEBGL_compressed_texture_astc");
      if (extension !== null) {
        if (p2 === RGBA_ASTC_4x4_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (p2 === RGBA_ASTC_5x4_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (p2 === RGBA_ASTC_5x5_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (p2 === RGBA_ASTC_6x5_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (p2 === RGBA_ASTC_6x6_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (p2 === RGBA_ASTC_8x5_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (p2 === RGBA_ASTC_8x6_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (p2 === RGBA_ASTC_8x8_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (p2 === RGBA_ASTC_10x5_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (p2 === RGBA_ASTC_10x6_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (p2 === RGBA_ASTC_10x8_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (p2 === RGBA_ASTC_10x10_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (p2 === RGBA_ASTC_12x10_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (p2 === RGBA_ASTC_12x12_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else {
        return null;
      }
    }
    if (p2 === RGBA_BPTC_Format) {
      extension = extensions.get("EXT_texture_compression_bptc");
      if (extension !== null) {
        if (p2 === RGBA_BPTC_Format)
          return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
      } else {
        return null;
      }
    }
    if (p2 === UnsignedInt248Type) {
      if (isWebGL2)
        return 34042;
      extension = extensions.get("WEBGL_depth_texture");
      if (extension !== null) {
        return extension.UNSIGNED_INT_24_8_WEBGL;
      } else {
        return null;
      }
    }
  }
  return { convert };
}
class ArrayCamera extends PerspectiveCamera {
  constructor(array2 = []) {
    super();
    this.cameras = array2;
  }
}
ArrayCamera.prototype.isArrayCamera = true;
class Group extends Object3D {
  constructor() {
    super();
    this.type = "Group";
  }
}
Group.prototype.isGroup = true;
const _moveEvent = { type: "move" };
class WebXRController {
  constructor() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
  }
  getHandSpace() {
    if (this._hand === null) {
      this._hand = new Group();
      this._hand.matrixAutoUpdate = false;
      this._hand.visible = false;
      this._hand.joints = {};
      this._hand.inputState = { pinching: false };
    }
    return this._hand;
  }
  getTargetRaySpace() {
    if (this._targetRay === null) {
      this._targetRay = new Group();
      this._targetRay.matrixAutoUpdate = false;
      this._targetRay.visible = false;
      this._targetRay.hasLinearVelocity = false;
      this._targetRay.linearVelocity = new Vector3$1();
      this._targetRay.hasAngularVelocity = false;
      this._targetRay.angularVelocity = new Vector3$1();
    }
    return this._targetRay;
  }
  getGripSpace() {
    if (this._grip === null) {
      this._grip = new Group();
      this._grip.matrixAutoUpdate = false;
      this._grip.visible = false;
      this._grip.hasLinearVelocity = false;
      this._grip.linearVelocity = new Vector3$1();
      this._grip.hasAngularVelocity = false;
      this._grip.angularVelocity = new Vector3$1();
    }
    return this._grip;
  }
  dispatchEvent(event) {
    if (this._targetRay !== null) {
      this._targetRay.dispatchEvent(event);
    }
    if (this._grip !== null) {
      this._grip.dispatchEvent(event);
    }
    if (this._hand !== null) {
      this._hand.dispatchEvent(event);
    }
    return this;
  }
  disconnect(inputSource) {
    this.dispatchEvent({ type: "disconnected", data: inputSource });
    if (this._targetRay !== null) {
      this._targetRay.visible = false;
    }
    if (this._grip !== null) {
      this._grip.visible = false;
    }
    if (this._hand !== null) {
      this._hand.visible = false;
    }
    return this;
  }
  update(inputSource, frame, referenceSpace) {
    let inputPose = null;
    let gripPose = null;
    let handPose = null;
    const targetRay = this._targetRay;
    const grip = this._grip;
    const hand = this._hand;
    if (inputSource && frame.session.visibilityState !== "visible-blurred") {
      if (targetRay !== null) {
        inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
        if (inputPose !== null) {
          targetRay.matrix.fromArray(inputPose.transform.matrix);
          targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
          if (inputPose.linearVelocity) {
            targetRay.hasLinearVelocity = true;
            targetRay.linearVelocity.copy(inputPose.linearVelocity);
          } else {
            targetRay.hasLinearVelocity = false;
          }
          if (inputPose.angularVelocity) {
            targetRay.hasAngularVelocity = true;
            targetRay.angularVelocity.copy(inputPose.angularVelocity);
          } else {
            targetRay.hasAngularVelocity = false;
          }
          this.dispatchEvent(_moveEvent);
        }
      }
      if (hand && inputSource.hand) {
        handPose = true;
        for (const inputjoint of inputSource.hand.values()) {
          const jointPose = frame.getJointPose(inputjoint, referenceSpace);
          if (hand.joints[inputjoint.jointName] === void 0) {
            const joint2 = new Group();
            joint2.matrixAutoUpdate = false;
            joint2.visible = false;
            hand.joints[inputjoint.jointName] = joint2;
            hand.add(joint2);
          }
          const joint = hand.joints[inputjoint.jointName];
          if (jointPose !== null) {
            joint.matrix.fromArray(jointPose.transform.matrix);
            joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
            joint.jointRadius = jointPose.radius;
          }
          joint.visible = jointPose !== null;
        }
        const indexTip = hand.joints["index-finger-tip"];
        const thumbTip = hand.joints["thumb-tip"];
        const distance11 = indexTip.position.distanceTo(thumbTip.position);
        const distanceToPinch = 0.02;
        const threshold2 = 5e-3;
        if (hand.inputState.pinching && distance11 > distanceToPinch + threshold2) {
          hand.inputState.pinching = false;
          this.dispatchEvent({
            type: "pinchend",
            handedness: inputSource.handedness,
            target: this
          });
        } else if (!hand.inputState.pinching && distance11 <= distanceToPinch - threshold2) {
          hand.inputState.pinching = true;
          this.dispatchEvent({
            type: "pinchstart",
            handedness: inputSource.handedness,
            target: this
          });
        }
      } else {
        if (grip !== null && inputSource.gripSpace) {
          gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
          if (gripPose !== null) {
            grip.matrix.fromArray(gripPose.transform.matrix);
            grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
            if (gripPose.linearVelocity) {
              grip.hasLinearVelocity = true;
              grip.linearVelocity.copy(gripPose.linearVelocity);
            } else {
              grip.hasLinearVelocity = false;
            }
            if (gripPose.angularVelocity) {
              grip.hasAngularVelocity = true;
              grip.angularVelocity.copy(gripPose.angularVelocity);
            } else {
              grip.hasAngularVelocity = false;
            }
          }
        }
      }
    }
    if (targetRay !== null) {
      targetRay.visible = inputPose !== null;
    }
    if (grip !== null) {
      grip.visible = gripPose !== null;
    }
    if (hand !== null) {
      hand.visible = handPose !== null;
    }
    return this;
  }
}
class DepthTexture extends Texture$1 {
  constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
    format = format !== void 0 ? format : DepthFormat;
    if (format !== DepthFormat && format !== DepthStencilFormat) {
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    }
    if (type === void 0 && format === DepthFormat)
      type = UnsignedShortType;
    if (type === void 0 && format === DepthStencilFormat)
      type = UnsignedInt248Type;
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.image = { width, height };
    this.magFilter = magFilter !== void 0 ? magFilter : NearestFilter;
    this.minFilter = minFilter !== void 0 ? minFilter : NearestFilter;
    this.flipY = false;
    this.generateMipmaps = false;
  }
}
DepthTexture.prototype.isDepthTexture = true;
class WebXRManager extends EventDispatcher$1 {
  constructor(renderer, gl) {
    super();
    const scope = this;
    let session = null;
    let framebufferScaleFactor = 1;
    let referenceSpace = null;
    let referenceSpaceType = "local-floor";
    let pose = null;
    let glBinding = null;
    let glProjLayer = null;
    let glBaseLayer = null;
    let xrFrame = null;
    const attributes = gl.getContextAttributes();
    let initialRenderTarget = null;
    let newRenderTarget = null;
    const controllers = [];
    const inputSourcesMap = /* @__PURE__ */ new Map();
    const cameraL = new PerspectiveCamera();
    cameraL.layers.enable(1);
    cameraL.viewport = new Vector4$1();
    const cameraR = new PerspectiveCamera();
    cameraR.layers.enable(2);
    cameraR.viewport = new Vector4$1();
    const cameras = [cameraL, cameraR];
    const cameraVR = new ArrayCamera();
    cameraVR.layers.enable(1);
    cameraVR.layers.enable(2);
    let _currentDepthNear = null;
    let _currentDepthFar = null;
    this.cameraAutoUpdate = true;
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index2] = controller;
      }
      return controller.getTargetRaySpace();
    };
    this.getControllerGrip = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index2] = controller;
      }
      return controller.getGripSpace();
    };
    this.getHand = function(index2) {
      let controller = controllers[index2];
      if (controller === void 0) {
        controller = new WebXRController();
        controllers[index2] = controller;
      }
      return controller.getHandSpace();
    };
    function onSessionEvent(event) {
      const controller = inputSourcesMap.get(event.inputSource);
      if (controller) {
        controller.dispatchEvent({ type: event.type, data: event.inputSource });
      }
    }
    function onSessionEnd() {
      inputSourcesMap.forEach(function(controller, inputSource) {
        controller.disconnect(inputSource);
      });
      inputSourcesMap.clear();
      _currentDepthNear = null;
      _currentDepthFar = null;
      renderer.setRenderTarget(initialRenderTarget);
      glBaseLayer = null;
      glProjLayer = null;
      glBinding = null;
      session = null;
      newRenderTarget = null;
      animation.stop();
      scope.isPresenting = false;
      scope.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(value) {
      framebufferScaleFactor = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
      }
    };
    this.setReferenceSpaceType = function(value) {
      referenceSpaceType = value;
      if (scope.isPresenting === true) {
        console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
      }
    };
    this.getReferenceSpace = function() {
      return referenceSpace;
    };
    this.getBaseLayer = function() {
      return glProjLayer !== null ? glProjLayer : glBaseLayer;
    };
    this.getBinding = function() {
      return glBinding;
    };
    this.getFrame = function() {
      return xrFrame;
    };
    this.getSession = function() {
      return session;
    };
    this.setSession = async function(value) {
      session = value;
      if (session !== null) {
        initialRenderTarget = renderer.getRenderTarget();
        session.addEventListener("select", onSessionEvent);
        session.addEventListener("selectstart", onSessionEvent);
        session.addEventListener("selectend", onSessionEvent);
        session.addEventListener("squeeze", onSessionEvent);
        session.addEventListener("squeezestart", onSessionEvent);
        session.addEventListener("squeezeend", onSessionEvent);
        session.addEventListener("end", onSessionEnd);
        session.addEventListener("inputsourceschange", onInputSourcesChange);
        if (attributes.xrCompatible !== true) {
          await gl.makeXRCompatible();
        }
        if (session.renderState.layers === void 0 || renderer.capabilities.isWebGL2 === false) {
          const layerInit = {
            antialias: session.renderState.layers === void 0 ? attributes.antialias : true,
            alpha: attributes.alpha,
            depth: attributes.depth,
            stencil: attributes.stencil,
            framebufferScaleFactor
          };
          glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
          session.updateRenderState({ baseLayer: glBaseLayer });
          newRenderTarget = new WebGLRenderTarget(
            glBaseLayer.framebufferWidth,
            glBaseLayer.framebufferHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              encoding: renderer.outputEncoding
            }
          );
        } else {
          let depthFormat = null;
          let depthType = null;
          let glDepthFormat = null;
          if (attributes.depth) {
            glDepthFormat = attributes.stencil ? 35056 : 33190;
            depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
            depthType = attributes.stencil ? UnsignedInt248Type : UnsignedShortType;
          }
          const projectionlayerInit = {
            colorFormat: renderer.outputEncoding === sRGBEncoding ? 35907 : 32856,
            depthFormat: glDepthFormat,
            scaleFactor: framebufferScaleFactor
          };
          glBinding = new XRWebGLBinding(session, gl);
          glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
          session.updateRenderState({ layers: [glProjLayer] });
          newRenderTarget = new WebGLRenderTarget(
            glProjLayer.textureWidth,
            glProjLayer.textureHeight,
            {
              format: RGBAFormat,
              type: UnsignedByteType,
              depthTexture: new DepthTexture(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, void 0, void 0, void 0, void 0, void 0, void 0, depthFormat),
              stencilBuffer: attributes.stencil,
              encoding: renderer.outputEncoding,
              samples: attributes.antialias ? 4 : 0
            }
          );
          const renderTargetProperties = renderer.properties.get(newRenderTarget);
          renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
        }
        newRenderTarget.isXRRenderTarget = true;
        this.setFoveation(1);
        referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
        animation.setContext(session);
        animation.start();
        scope.isPresenting = true;
        scope.dispatchEvent({ type: "sessionstart" });
      }
    };
    function onInputSourcesChange(event) {
      const inputSources = session.inputSources;
      for (let i2 = 0; i2 < controllers.length; i2++) {
        inputSourcesMap.set(inputSources[i2], controllers[i2]);
      }
      for (let i2 = 0; i2 < event.removed.length; i2++) {
        const inputSource = event.removed[i2];
        const controller = inputSourcesMap.get(inputSource);
        if (controller) {
          controller.dispatchEvent({ type: "disconnected", data: inputSource });
          inputSourcesMap.delete(inputSource);
        }
      }
      for (let i2 = 0; i2 < event.added.length; i2++) {
        const inputSource = event.added[i2];
        const controller = inputSourcesMap.get(inputSource);
        if (controller) {
          controller.dispatchEvent({ type: "connected", data: inputSource });
        }
      }
    }
    const cameraLPos = new Vector3$1();
    const cameraRPos = new Vector3$1();
    function setProjectionFromUnion(camera, cameraL2, cameraR2) {
      cameraLPos.setFromMatrixPosition(cameraL2.matrixWorld);
      cameraRPos.setFromMatrixPosition(cameraR2.matrixWorld);
      const ipd = cameraLPos.distanceTo(cameraRPos);
      const projL = cameraL2.projectionMatrix.elements;
      const projR = cameraR2.projectionMatrix.elements;
      const near = projL[14] / (projL[10] - 1);
      const far = projL[14] / (projL[10] + 1);
      const topFov = (projL[9] + 1) / projL[5];
      const bottomFov = (projL[9] - 1) / projL[5];
      const leftFov = (projL[8] - 1) / projL[0];
      const rightFov = (projR[8] + 1) / projR[0];
      const left = near * leftFov;
      const right = near * rightFov;
      const zOffset = ipd / (-leftFov + rightFov);
      const xOffset = zOffset * -leftFov;
      cameraL2.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
      camera.translateX(xOffset);
      camera.translateZ(zOffset);
      camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
      const near2 = near + zOffset;
      const far2 = far + zOffset;
      const left2 = left - xOffset;
      const right2 = right + (ipd - xOffset);
      const top2 = topFov * far / far2 * near2;
      const bottom2 = bottomFov * far / far2 * near2;
      camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
    }
    function updateCamera2(camera, parent) {
      if (parent === null) {
        camera.matrixWorld.copy(camera.matrix);
      } else {
        camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
      }
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }
    this.updateCamera = function(camera) {
      if (session === null)
        return;
      cameraVR.near = cameraR.near = cameraL.near = camera.near;
      cameraVR.far = cameraR.far = cameraL.far = camera.far;
      if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
        session.updateRenderState({
          depthNear: cameraVR.near,
          depthFar: cameraVR.far
        });
        _currentDepthNear = cameraVR.near;
        _currentDepthFar = cameraVR.far;
      }
      const parent = camera.parent;
      const cameras2 = cameraVR.cameras;
      updateCamera2(cameraVR, parent);
      for (let i2 = 0; i2 < cameras2.length; i2++) {
        updateCamera2(cameras2[i2], parent);
      }
      cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale);
      camera.position.copy(cameraVR.position);
      camera.quaternion.copy(cameraVR.quaternion);
      camera.scale.copy(cameraVR.scale);
      camera.matrix.copy(cameraVR.matrix);
      camera.matrixWorld.copy(cameraVR.matrixWorld);
      const children = camera.children;
      for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
        children[i2].updateMatrixWorld(true);
      }
      if (cameras2.length === 2) {
        setProjectionFromUnion(cameraVR, cameraL, cameraR);
      } else {
        cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
      }
    };
    this.getCamera = function() {
      return cameraVR;
    };
    this.getFoveation = function() {
      if (glProjLayer !== null) {
        return glProjLayer.fixedFoveation;
      }
      if (glBaseLayer !== null) {
        return glBaseLayer.fixedFoveation;
      }
      return void 0;
    };
    this.setFoveation = function(foveation) {
      if (glProjLayer !== null) {
        glProjLayer.fixedFoveation = foveation;
      }
      if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== void 0) {
        glBaseLayer.fixedFoveation = foveation;
      }
    };
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time2, frame) {
      pose = frame.getViewerPose(referenceSpace);
      xrFrame = frame;
      if (pose !== null) {
        const views = pose.views;
        if (glBaseLayer !== null) {
          renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
          renderer.setRenderTarget(newRenderTarget);
        }
        let cameraVRNeedsUpdate = false;
        if (views.length !== cameraVR.cameras.length) {
          cameraVR.cameras.length = 0;
          cameraVRNeedsUpdate = true;
        }
        for (let i2 = 0; i2 < views.length; i2++) {
          const view2 = views[i2];
          let viewport = null;
          if (glBaseLayer !== null) {
            viewport = glBaseLayer.getViewport(view2);
          } else {
            const glSubImage = glBinding.getViewSubImage(glProjLayer, view2);
            viewport = glSubImage.viewport;
            if (i2 === 0) {
              renderer.setRenderTargetTextures(
                newRenderTarget,
                glSubImage.colorTexture,
                glProjLayer.ignoreDepthValues ? void 0 : glSubImage.depthStencilTexture
              );
              renderer.setRenderTarget(newRenderTarget);
            }
          }
          const camera = cameras[i2];
          camera.matrix.fromArray(view2.transform.matrix);
          camera.projectionMatrix.fromArray(view2.projectionMatrix);
          camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
          if (i2 === 0) {
            cameraVR.matrix.copy(camera.matrix);
          }
          if (cameraVRNeedsUpdate === true) {
            cameraVR.cameras.push(camera);
          }
        }
      }
      const inputSources = session.inputSources;
      for (let i2 = 0; i2 < controllers.length; i2++) {
        const controller = controllers[i2];
        const inputSource = inputSources[i2];
        controller.update(inputSource, frame, referenceSpace);
      }
      if (onAnimationFrameCallback)
        onAnimationFrameCallback(time2, frame);
      xrFrame = null;
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    this.setAnimationLoop = function(callback) {
      onAnimationFrameCallback = callback;
    };
    this.dispose = function() {
    };
  }
}
function WebGLMaterials(renderer, properties) {
  function refreshFogUniforms(uniforms, fog2) {
    uniforms.fogColor.value.copy(fog2.color);
    if (fog2.isFog) {
      uniforms.fogNear.value = fog2.near;
      uniforms.fogFar.value = fog2.far;
    } else if (fog2.isFogExp2) {
      uniforms.fogDensity.value = fog2.density;
    }
  }
  function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
    if (material.isMeshBasicMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshLambertMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshToonMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsToon(uniforms, material);
    } else if (material.isMeshPhongMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsPhong(uniforms, material);
    } else if (material.isMeshStandardMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsStandard(uniforms, material);
      if (material.isMeshPhysicalMaterial) {
        refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
      }
    } else if (material.isMeshMatcapMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsMatcap(uniforms, material);
    } else if (material.isMeshDepthMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshDistanceMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDistance(uniforms, material);
    } else if (material.isMeshNormalMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isLineBasicMaterial) {
      refreshUniformsLine(uniforms, material);
      if (material.isLineDashedMaterial) {
        refreshUniformsDash(uniforms, material);
      }
    } else if (material.isPointsMaterial) {
      refreshUniformsPoints(uniforms, material, pixelRatio, height);
    } else if (material.isSpriteMaterial) {
      refreshUniformsSprites(uniforms, material);
    } else if (material.isShadowMaterial) {
      uniforms.color.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
    } else if (material.isShaderMaterial) {
      material.uniformsNeedUpdate = false;
    }
  }
  function refreshUniformsCommon(uniforms, material) {
    uniforms.opacity.value = material.opacity;
    if (material.color) {
      uniforms.diffuse.value.copy(material.color);
    }
    if (material.emissive) {
      uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
    }
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide)
        uniforms.bumpScale.value *= -1;
    }
    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }
    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }
    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide)
        uniforms.normalScale.value.negate();
    }
    if (material.specularMap) {
      uniforms.specularMap.value = material.specularMap;
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    const envMap = properties.get(material).envMap;
    if (envMap) {
      uniforms.envMap.value = envMap;
      uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      uniforms.reflectivity.value = material.reflectivity;
      uniforms.ior.value = material.ior;
      uniforms.refractionRatio.value = material.refractionRatio;
    }
    if (material.lightMap) {
      uniforms.lightMap.value = material.lightMap;
      const scaleFactor = renderer.physicallyCorrectLights !== true ? Math.PI : 1;
      uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
    }
    if (material.aoMap) {
      uniforms.aoMap.value = material.aoMap;
      uniforms.aoMapIntensity.value = material.aoMapIntensity;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.specularMap) {
      uvScaleMap = material.specularMap;
    } else if (material.displacementMap) {
      uvScaleMap = material.displacementMap;
    } else if (material.normalMap) {
      uvScaleMap = material.normalMap;
    } else if (material.bumpMap) {
      uvScaleMap = material.bumpMap;
    } else if (material.roughnessMap) {
      uvScaleMap = material.roughnessMap;
    } else if (material.metalnessMap) {
      uvScaleMap = material.metalnessMap;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    } else if (material.emissiveMap) {
      uvScaleMap = material.emissiveMap;
    } else if (material.clearcoatMap) {
      uvScaleMap = material.clearcoatMap;
    } else if (material.clearcoatNormalMap) {
      uvScaleMap = material.clearcoatNormalMap;
    } else if (material.clearcoatRoughnessMap) {
      uvScaleMap = material.clearcoatRoughnessMap;
    } else if (material.specularIntensityMap) {
      uvScaleMap = material.specularIntensityMap;
    } else if (material.specularColorMap) {
      uvScaleMap = material.specularColorMap;
    } else if (material.transmissionMap) {
      uvScaleMap = material.transmissionMap;
    } else if (material.thicknessMap) {
      uvScaleMap = material.thicknessMap;
    } else if (material.sheenColorMap) {
      uvScaleMap = material.sheenColorMap;
    } else if (material.sheenRoughnessMap) {
      uvScaleMap = material.sheenRoughnessMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.isWebGLRenderTarget) {
        uvScaleMap = uvScaleMap.texture;
      }
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
    let uv2ScaleMap;
    if (material.aoMap) {
      uv2ScaleMap = material.aoMap;
    } else if (material.lightMap) {
      uv2ScaleMap = material.lightMap;
    }
    if (uv2ScaleMap !== void 0) {
      if (uv2ScaleMap.isWebGLRenderTarget) {
        uv2ScaleMap = uv2ScaleMap.texture;
      }
      if (uv2ScaleMap.matrixAutoUpdate === true) {
        uv2ScaleMap.updateMatrix();
      }
      uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
    }
  }
  function refreshUniformsLine(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
  }
  function refreshUniformsDash(uniforms, material) {
    uniforms.dashSize.value = material.dashSize;
    uniforms.totalSize.value = material.dashSize + material.gapSize;
    uniforms.scale.value = material.scale;
  }
  function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.size.value = material.size * pixelRatio;
    uniforms.scale.value = height * 0.5;
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }
  function refreshUniformsSprites(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.rotation.value = material.rotation;
    if (material.map) {
      uniforms.map.value = material.map;
    }
    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }
    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }
    let uvScaleMap;
    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }
    if (uvScaleMap !== void 0) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }
      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }
  function refreshUniformsPhong(uniforms, material) {
    uniforms.specular.value.copy(material.specular);
    uniforms.shininess.value = Math.max(material.shininess, 1e-4);
  }
  function refreshUniformsToon(uniforms, material) {
    if (material.gradientMap) {
      uniforms.gradientMap.value = material.gradientMap;
    }
  }
  function refreshUniformsStandard(uniforms, material) {
    uniforms.roughness.value = material.roughness;
    uniforms.metalness.value = material.metalness;
    if (material.roughnessMap) {
      uniforms.roughnessMap.value = material.roughnessMap;
    }
    if (material.metalnessMap) {
      uniforms.metalnessMap.value = material.metalnessMap;
    }
    const envMap = properties.get(material).envMap;
    if (envMap) {
      uniforms.envMapIntensity.value = material.envMapIntensity;
    }
  }
  function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
    uniforms.ior.value = material.ior;
    if (material.sheen > 0) {
      uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
      uniforms.sheenRoughness.value = material.sheenRoughness;
      if (material.sheenColorMap) {
        uniforms.sheenColorMap.value = material.sheenColorMap;
      }
      if (material.sheenRoughnessMap) {
        uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
      }
    }
    if (material.clearcoat > 0) {
      uniforms.clearcoat.value = material.clearcoat;
      uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
      if (material.clearcoatMap) {
        uniforms.clearcoatMap.value = material.clearcoatMap;
      }
      if (material.clearcoatRoughnessMap) {
        uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
      }
      if (material.clearcoatNormalMap) {
        uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
        uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
        if (material.side === BackSide) {
          uniforms.clearcoatNormalScale.value.negate();
        }
      }
    }
    if (material.transmission > 0) {
      uniforms.transmission.value = material.transmission;
      uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
      uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
      if (material.transmissionMap) {
        uniforms.transmissionMap.value = material.transmissionMap;
      }
      uniforms.thickness.value = material.thickness;
      if (material.thicknessMap) {
        uniforms.thicknessMap.value = material.thicknessMap;
      }
      uniforms.attenuationDistance.value = material.attenuationDistance;
      uniforms.attenuationColor.value.copy(material.attenuationColor);
    }
    uniforms.specularIntensity.value = material.specularIntensity;
    uniforms.specularColor.value.copy(material.specularColor);
    if (material.specularIntensityMap) {
      uniforms.specularIntensityMap.value = material.specularIntensityMap;
    }
    if (material.specularColorMap) {
      uniforms.specularColorMap.value = material.specularColorMap;
    }
  }
  function refreshUniformsMatcap(uniforms, material) {
    if (material.matcap) {
      uniforms.matcap.value = material.matcap;
    }
  }
  function refreshUniformsDistance(uniforms, material) {
    uniforms.referencePosition.value.copy(material.referencePosition);
    uniforms.nearDistance.value = material.nearDistance;
    uniforms.farDistance.value = material.farDistance;
  }
  return {
    refreshFogUniforms,
    refreshMaterialUniforms
  };
}
function createCanvasElement() {
  const canvas2 = createElementNS("canvas");
  canvas2.style.display = "block";
  return canvas2;
}
function WebGLRenderer(parameters = {}) {
  const _canvas2 = parameters.canvas !== void 0 ? parameters.canvas : createCanvasElement(), _context2 = parameters.context !== void 0 ? parameters.context : null, _depth = parameters.depth !== void 0 ? parameters.depth : true, _stencil = parameters.stencil !== void 0 ? parameters.stencil : true, _antialias = parameters.antialias !== void 0 ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== void 0 ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== void 0 ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== void 0 ? parameters.powerPreference : "default", _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== void 0 ? parameters.failIfMajorPerformanceCaveat : false;
  let _alpha;
  if (parameters.context !== void 0) {
    _alpha = _context2.getContextAttributes().alpha;
  } else {
    _alpha = parameters.alpha !== void 0 ? parameters.alpha : false;
  }
  let currentRenderList = null;
  let currentRenderState = null;
  const renderListStack = [];
  const renderStateStack = [];
  this.domElement = _canvas2;
  this.debug = {
    /**
     * Enables error checking and reporting when shader programs are being compiled
     * @type {boolean}
     */
    checkShaderErrors: true
  };
  this.autoClear = true;
  this.autoClearColor = true;
  this.autoClearDepth = true;
  this.autoClearStencil = true;
  this.sortObjects = true;
  this.clippingPlanes = [];
  this.localClippingEnabled = false;
  this.outputEncoding = LinearEncoding;
  this.physicallyCorrectLights = false;
  this.toneMapping = NoToneMapping;
  this.toneMappingExposure = 1;
  const _this = this;
  let _isContextLost = false;
  let _currentActiveCubeFace = 0;
  let _currentActiveMipmapLevel = 0;
  let _currentRenderTarget = null;
  let _currentMaterialId = -1;
  let _currentCamera = null;
  const _currentViewport = new Vector4$1();
  const _currentScissor = new Vector4$1();
  let _currentScissorTest = null;
  let _width = _canvas2.width;
  let _height = _canvas2.height;
  let _pixelRatio = 1;
  let _opaqueSort = null;
  let _transparentSort = null;
  const _viewport = new Vector4$1(0, 0, _width, _height);
  const _scissor = new Vector4$1(0, 0, _width, _height);
  let _scissorTest = false;
  const _frustum = new Frustum();
  let _clippingEnabled = false;
  let _localClippingEnabled = false;
  let _transmissionRenderTarget = null;
  const _projScreenMatrix2 = new Matrix4$1();
  const _vector22 = new Vector2$1();
  const _vector3 = new Vector3$1();
  const _emptyScene = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: true };
  function getTargetPixelRatio() {
    return _currentRenderTarget === null ? _pixelRatio : 1;
  }
  let _gl = _context2;
  function getContext2(contextNames, contextAttributes) {
    for (let i2 = 0; i2 < contextNames.length; i2++) {
      const contextName = contextNames[i2];
      const context2 = _canvas2.getContext(contextName, contextAttributes);
      if (context2 !== null)
        return context2;
    }
    return null;
  }
  try {
    const contextAttributes = {
      alpha: true,
      depth: _depth,
      stencil: _stencil,
      antialias: _antialias,
      premultipliedAlpha: _premultipliedAlpha,
      preserveDrawingBuffer: _preserveDrawingBuffer,
      powerPreference: _powerPreference,
      failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
    };
    if ("setAttribute" in _canvas2)
      _canvas2.setAttribute("data-engine", `three.js r${REVISION}`);
    _canvas2.addEventListener("webglcontextlost", onContextLost, false);
    _canvas2.addEventListener("webglcontextrestored", onContextRestore, false);
    if (_gl === null) {
      const contextNames = ["webgl2", "webgl", "experimental-webgl"];
      if (_this.isWebGL1Renderer === true) {
        contextNames.shift();
      }
      _gl = getContext2(contextNames, contextAttributes);
      if (_gl === null) {
        if (getContext2(contextNames)) {
          throw new Error("Error creating WebGL context with your selected attributes.");
        } else {
          throw new Error("Error creating WebGL context.");
        }
      }
    }
    if (_gl.getShaderPrecisionFormat === void 0) {
      _gl.getShaderPrecisionFormat = function() {
        return { "rangeMin": 1, "rangeMax": 1, "precision": 1 };
      };
    }
  } catch (error2) {
    console.error("THREE.WebGLRenderer: " + error2.message);
    throw error2;
  }
  let extensions, capabilities, state, info;
  let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
  let programCache, materials, renderLists, renderStates, clipping, shadowMap;
  let background, morphtargets, bufferRenderer, indexedBufferRenderer;
  let utils2, bindingStates;
  function initGLContext() {
    extensions = new WebGLExtensions(_gl);
    capabilities = new WebGLCapabilities(_gl, extensions, parameters);
    extensions.init(capabilities);
    utils2 = new WebGLUtils(_gl, extensions, capabilities);
    state = new WebGLState(_gl, extensions, capabilities);
    info = new WebGLInfo();
    properties = new WebGLProperties();
    textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils2, info);
    cubemaps = new WebGLCubeMaps(_this);
    cubeuvmaps = new WebGLCubeUVMaps(_this);
    attributes = new WebGLAttributes(_gl, capabilities);
    bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
    geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
    objects = new WebGLObjects(_gl, geometries, attributes, info);
    morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
    clipping = new WebGLClipping(properties);
    programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
    materials = new WebGLMaterials(_this, properties);
    renderLists = new WebGLRenderLists();
    renderStates = new WebGLRenderStates(extensions, capabilities);
    background = new WebGLBackground(_this, cubemaps, state, objects, _alpha, _premultipliedAlpha);
    shadowMap = new WebGLShadowMap(_this, objects, capabilities);
    bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
    indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
    info.programs = programCache.programs;
    _this.capabilities = capabilities;
    _this.extensions = extensions;
    _this.properties = properties;
    _this.renderLists = renderLists;
    _this.shadowMap = shadowMap;
    _this.state = state;
    _this.info = info;
  }
  initGLContext();
  const xr = new WebXRManager(_this, _gl);
  this.xr = xr;
  this.getContext = function() {
    return _gl;
  };
  this.getContextAttributes = function() {
    return _gl.getContextAttributes();
  };
  this.forceContextLoss = function() {
    const extension = extensions.get("WEBGL_lose_context");
    if (extension)
      extension.loseContext();
  };
  this.forceContextRestore = function() {
    const extension = extensions.get("WEBGL_lose_context");
    if (extension)
      extension.restoreContext();
  };
  this.getPixelRatio = function() {
    return _pixelRatio;
  };
  this.setPixelRatio = function(value) {
    if (value === void 0)
      return;
    _pixelRatio = value;
    this.setSize(_width, _height, false);
  };
  this.getSize = function(target) {
    return target.set(_width, _height);
  };
  this.setSize = function(width, height, updateStyle) {
    if (xr.isPresenting) {
      console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
      return;
    }
    _width = width;
    _height = height;
    _canvas2.width = Math.floor(width * _pixelRatio);
    _canvas2.height = Math.floor(height * _pixelRatio);
    if (updateStyle !== false) {
      _canvas2.style.width = width + "px";
      _canvas2.style.height = height + "px";
    }
    this.setViewport(0, 0, width, height);
  };
  this.getDrawingBufferSize = function(target) {
    return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
  };
  this.setDrawingBufferSize = function(width, height, pixelRatio) {
    _width = width;
    _height = height;
    _pixelRatio = pixelRatio;
    _canvas2.width = Math.floor(width * pixelRatio);
    _canvas2.height = Math.floor(height * pixelRatio);
    this.setViewport(0, 0, width, height);
  };
  this.getCurrentViewport = function(target) {
    return target.copy(_currentViewport);
  };
  this.getViewport = function(target) {
    return target.copy(_viewport);
  };
  this.setViewport = function(x2, y2, width, height) {
    if (x2.isVector4) {
      _viewport.set(x2.x, x2.y, x2.z, x2.w);
    } else {
      _viewport.set(x2, y2, width, height);
    }
    state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
  };
  this.getScissor = function(target) {
    return target.copy(_scissor);
  };
  this.setScissor = function(x2, y2, width, height) {
    if (x2.isVector4) {
      _scissor.set(x2.x, x2.y, x2.z, x2.w);
    } else {
      _scissor.set(x2, y2, width, height);
    }
    state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
  };
  this.getScissorTest = function() {
    return _scissorTest;
  };
  this.setScissorTest = function(boolean2) {
    state.setScissorTest(_scissorTest = boolean2);
  };
  this.setOpaqueSort = function(method) {
    _opaqueSort = method;
  };
  this.setTransparentSort = function(method) {
    _transparentSort = method;
  };
  this.getClearColor = function(target) {
    return target.copy(background.getClearColor());
  };
  this.setClearColor = function() {
    background.setClearColor.apply(background, arguments);
  };
  this.getClearAlpha = function() {
    return background.getClearAlpha();
  };
  this.setClearAlpha = function() {
    background.setClearAlpha.apply(background, arguments);
  };
  this.clear = function(color = true, depth2 = true, stencil = true) {
    let bits = 0;
    if (color)
      bits |= 16384;
    if (depth2)
      bits |= 256;
    if (stencil)
      bits |= 1024;
    _gl.clear(bits);
  };
  this.clearColor = function() {
    this.clear(true, false, false);
  };
  this.clearDepth = function() {
    this.clear(false, true, false);
  };
  this.clearStencil = function() {
    this.clear(false, false, true);
  };
  this.dispose = function() {
    _canvas2.removeEventListener("webglcontextlost", onContextLost, false);
    _canvas2.removeEventListener("webglcontextrestored", onContextRestore, false);
    renderLists.dispose();
    renderStates.dispose();
    properties.dispose();
    cubemaps.dispose();
    cubeuvmaps.dispose();
    objects.dispose();
    bindingStates.dispose();
    programCache.dispose();
    xr.dispose();
    xr.removeEventListener("sessionstart", onXRSessionStart);
    xr.removeEventListener("sessionend", onXRSessionEnd);
    if (_transmissionRenderTarget) {
      _transmissionRenderTarget.dispose();
      _transmissionRenderTarget = null;
    }
    animation.stop();
  };
  function onContextLost(event) {
    event.preventDefault();
    console.log("THREE.WebGLRenderer: Context Lost.");
    _isContextLost = true;
  }
  function onContextRestore() {
    console.log("THREE.WebGLRenderer: Context Restored.");
    _isContextLost = false;
    const infoAutoReset = info.autoReset;
    const shadowMapEnabled = shadowMap.enabled;
    const shadowMapAutoUpdate = shadowMap.autoUpdate;
    const shadowMapNeedsUpdate = shadowMap.needsUpdate;
    const shadowMapType = shadowMap.type;
    initGLContext();
    info.autoReset = infoAutoReset;
    shadowMap.enabled = shadowMapEnabled;
    shadowMap.autoUpdate = shadowMapAutoUpdate;
    shadowMap.needsUpdate = shadowMapNeedsUpdate;
    shadowMap.type = shadowMapType;
  }
  function onMaterialDispose(event) {
    const material = event.target;
    material.removeEventListener("dispose", onMaterialDispose);
    deallocateMaterial(material);
  }
  function deallocateMaterial(material) {
    releaseMaterialProgramReferences(material);
    properties.remove(material);
  }
  function releaseMaterialProgramReferences(material) {
    const programs = properties.get(material).programs;
    if (programs !== void 0) {
      programs.forEach(function(program) {
        programCache.releaseProgram(program);
      });
      if (material.isShaderMaterial) {
        programCache.releaseShaderCache(material);
      }
    }
  }
  this.renderBufferDirect = function(camera, scene, geometry2, material, object2, group) {
    if (scene === null)
      scene = _emptyScene;
    const frontFaceCW = object2.isMesh && object2.matrixWorld.determinant() < 0;
    const program = setProgram(camera, scene, geometry2, material, object2);
    state.setMaterial(material, frontFaceCW);
    let index2 = geometry2.index;
    const position = geometry2.attributes.position;
    if (index2 === null) {
      if (position === void 0 || position.count === 0)
        return;
    } else if (index2.count === 0) {
      return;
    }
    let rangeFactor = 1;
    if (material.wireframe === true) {
      index2 = geometries.getWireframeAttribute(geometry2);
      rangeFactor = 2;
    }
    bindingStates.setup(object2, material, program, geometry2, index2);
    let attribute;
    let renderer = bufferRenderer;
    if (index2 !== null) {
      attribute = attributes.get(index2);
      renderer = indexedBufferRenderer;
      renderer.setIndex(attribute);
    }
    const dataCount = index2 !== null ? index2.count : position.count;
    const rangeStart = geometry2.drawRange.start * rangeFactor;
    const rangeCount = geometry2.drawRange.count * rangeFactor;
    const groupStart = group !== null ? group.start * rangeFactor : 0;
    const groupCount = group !== null ? group.count * rangeFactor : Infinity;
    const drawStart = Math.max(rangeStart, groupStart);
    const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
    const drawCount = Math.max(0, drawEnd - drawStart + 1);
    if (drawCount === 0)
      return;
    if (object2.isMesh) {
      if (material.wireframe === true) {
        state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
        renderer.setMode(1);
      } else {
        renderer.setMode(4);
      }
    } else if (object2.isLine) {
      let lineWidth = material.linewidth;
      if (lineWidth === void 0)
        lineWidth = 1;
      state.setLineWidth(lineWidth * getTargetPixelRatio());
      if (object2.isLineSegments) {
        renderer.setMode(1);
      } else if (object2.isLineLoop) {
        renderer.setMode(2);
      } else {
        renderer.setMode(3);
      }
    } else if (object2.isPoints) {
      renderer.setMode(0);
    } else if (object2.isSprite) {
      renderer.setMode(4);
    }
    if (object2.isInstancedMesh) {
      renderer.renderInstances(drawStart, drawCount, object2.count);
    } else if (geometry2.isInstancedBufferGeometry) {
      const instanceCount = Math.min(geometry2.instanceCount, geometry2._maxInstanceCount);
      renderer.renderInstances(drawStart, drawCount, instanceCount);
    } else {
      renderer.render(drawStart, drawCount);
    }
  };
  this.compile = function(scene, camera) {
    currentRenderState = renderStates.get(scene);
    currentRenderState.init();
    renderStateStack.push(currentRenderState);
    scene.traverseVisible(function(object2) {
      if (object2.isLight && object2.layers.test(camera.layers)) {
        currentRenderState.pushLight(object2);
        if (object2.castShadow) {
          currentRenderState.pushShadow(object2);
        }
      }
    });
    currentRenderState.setupLights(_this.physicallyCorrectLights);
    scene.traverse(function(object2) {
      const material = object2.material;
      if (material) {
        if (Array.isArray(material)) {
          for (let i2 = 0; i2 < material.length; i2++) {
            const material2 = material[i2];
            getProgram(material2, scene, object2);
          }
        } else {
          getProgram(material, scene, object2);
        }
      }
    });
    renderStateStack.pop();
    currentRenderState = null;
  };
  let onAnimationFrameCallback = null;
  function onAnimationFrame(time2) {
    if (onAnimationFrameCallback)
      onAnimationFrameCallback(time2);
  }
  function onXRSessionStart() {
    animation.stop();
  }
  function onXRSessionEnd() {
    animation.start();
  }
  const animation = new WebGLAnimation();
  animation.setAnimationLoop(onAnimationFrame);
  if (typeof self !== "undefined")
    animation.setContext(self);
  this.setAnimationLoop = function(callback) {
    onAnimationFrameCallback = callback;
    xr.setAnimationLoop(callback);
    callback === null ? animation.stop() : animation.start();
  };
  xr.addEventListener("sessionstart", onXRSessionStart);
  xr.addEventListener("sessionend", onXRSessionEnd);
  this.render = function(scene, camera) {
    if (camera !== void 0 && camera.isCamera !== true) {
      console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
      return;
    }
    if (_isContextLost === true)
      return;
    if (scene.autoUpdate === true)
      scene.updateMatrixWorld();
    if (camera.parent === null)
      camera.updateMatrixWorld();
    if (xr.enabled === true && xr.isPresenting === true) {
      if (xr.cameraAutoUpdate === true)
        xr.updateCamera(camera);
      camera = xr.getCamera();
    }
    if (scene.isScene === true)
      scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
    currentRenderState = renderStates.get(scene, renderStateStack.length);
    currentRenderState.init();
    renderStateStack.push(currentRenderState);
    _projScreenMatrix2.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    _frustum.setFromProjectionMatrix(_projScreenMatrix2);
    _localClippingEnabled = this.localClippingEnabled;
    _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
    currentRenderList = renderLists.get(scene, renderListStack.length);
    currentRenderList.init();
    renderListStack.push(currentRenderList);
    projectObject(scene, camera, 0, _this.sortObjects);
    currentRenderList.finish();
    if (_this.sortObjects === true) {
      currentRenderList.sort(_opaqueSort, _transparentSort);
    }
    if (_clippingEnabled === true)
      clipping.beginShadows();
    const shadowsArray = currentRenderState.state.shadowsArray;
    shadowMap.render(shadowsArray, scene, camera);
    if (_clippingEnabled === true)
      clipping.endShadows();
    if (this.info.autoReset === true)
      this.info.reset();
    background.render(currentRenderList, scene);
    currentRenderState.setupLights(_this.physicallyCorrectLights);
    if (camera.isArrayCamera) {
      const cameras = camera.cameras;
      for (let i2 = 0, l2 = cameras.length; i2 < l2; i2++) {
        const camera2 = cameras[i2];
        renderScene(currentRenderList, scene, camera2, camera2.viewport);
      }
    } else {
      renderScene(currentRenderList, scene, camera);
    }
    if (_currentRenderTarget !== null) {
      textures.updateMultisampleRenderTarget(_currentRenderTarget);
      textures.updateRenderTargetMipmap(_currentRenderTarget);
    }
    if (scene.isScene === true)
      scene.onAfterRender(_this, scene, camera);
    bindingStates.resetDefaultState();
    _currentMaterialId = -1;
    _currentCamera = null;
    renderStateStack.pop();
    if (renderStateStack.length > 0) {
      currentRenderState = renderStateStack[renderStateStack.length - 1];
    } else {
      currentRenderState = null;
    }
    renderListStack.pop();
    if (renderListStack.length > 0) {
      currentRenderList = renderListStack[renderListStack.length - 1];
    } else {
      currentRenderList = null;
    }
  };
  function projectObject(object2, camera, groupOrder, sortObjects) {
    if (object2.visible === false)
      return;
    const visible = object2.layers.test(camera.layers);
    if (visible) {
      if (object2.isGroup) {
        groupOrder = object2.renderOrder;
      } else if (object2.isLOD) {
        if (object2.autoUpdate === true)
          object2.update(camera);
      } else if (object2.isLight) {
        currentRenderState.pushLight(object2);
        if (object2.castShadow) {
          currentRenderState.pushShadow(object2);
        }
      } else if (object2.isSprite) {
        if (!object2.frustumCulled || _frustum.intersectsSprite(object2)) {
          if (sortObjects) {
            _vector3.setFromMatrixPosition(object2.matrixWorld).applyMatrix4(_projScreenMatrix2);
          }
          const geometry2 = objects.update(object2);
          const material = object2.material;
          if (material.visible) {
            currentRenderList.push(object2, geometry2, material, groupOrder, _vector3.z, null);
          }
        }
      } else if (object2.isMesh || object2.isLine || object2.isPoints) {
        if (object2.isSkinnedMesh) {
          if (object2.skeleton.frame !== info.render.frame) {
            object2.skeleton.update();
            object2.skeleton.frame = info.render.frame;
          }
        }
        if (!object2.frustumCulled || _frustum.intersectsObject(object2)) {
          if (sortObjects) {
            _vector3.setFromMatrixPosition(object2.matrixWorld).applyMatrix4(_projScreenMatrix2);
          }
          const geometry2 = objects.update(object2);
          const material = object2.material;
          if (Array.isArray(material)) {
            const groups = geometry2.groups;
            for (let i2 = 0, l2 = groups.length; i2 < l2; i2++) {
              const group = groups[i2];
              const groupMaterial = material[group.materialIndex];
              if (groupMaterial && groupMaterial.visible) {
                currentRenderList.push(object2, geometry2, groupMaterial, groupOrder, _vector3.z, group);
              }
            }
          } else if (material.visible) {
            currentRenderList.push(object2, geometry2, material, groupOrder, _vector3.z, null);
          }
        }
      }
    }
    const children = object2.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      projectObject(children[i2], camera, groupOrder, sortObjects);
    }
  }
  function renderScene(currentRenderList2, scene, camera, viewport) {
    const opaqueObjects = currentRenderList2.opaque;
    const transmissiveObjects = currentRenderList2.transmissive;
    const transparentObjects = currentRenderList2.transparent;
    currentRenderState.setupLightsView(camera);
    if (transmissiveObjects.length > 0)
      renderTransmissionPass(opaqueObjects, scene, camera);
    if (viewport)
      state.viewport(_currentViewport.copy(viewport));
    if (opaqueObjects.length > 0)
      renderObjects(opaqueObjects, scene, camera);
    if (transmissiveObjects.length > 0)
      renderObjects(transmissiveObjects, scene, camera);
    if (transparentObjects.length > 0)
      renderObjects(transparentObjects, scene, camera);
    state.buffers.depth.setTest(true);
    state.buffers.depth.setMask(true);
    state.buffers.color.setMask(true);
    state.setPolygonOffset(false);
  }
  function renderTransmissionPass(opaqueObjects, scene, camera) {
    const isWebGL2 = capabilities.isWebGL2;
    if (_transmissionRenderTarget === null) {
      _transmissionRenderTarget = new WebGLRenderTarget(1, 1, {
        generateMipmaps: true,
        type: utils2.convert(HalfFloatType) !== null ? HalfFloatType : UnsignedByteType,
        minFilter: LinearMipmapLinearFilter,
        samples: isWebGL2 && _antialias === true ? 4 : 0
      });
    }
    _this.getDrawingBufferSize(_vector22);
    if (isWebGL2) {
      _transmissionRenderTarget.setSize(_vector22.x, _vector22.y);
    } else {
      _transmissionRenderTarget.setSize(floorPowerOfTwo(_vector22.x), floorPowerOfTwo(_vector22.y));
    }
    const currentRenderTarget = _this.getRenderTarget();
    _this.setRenderTarget(_transmissionRenderTarget);
    _this.clear();
    const currentToneMapping = _this.toneMapping;
    _this.toneMapping = NoToneMapping;
    renderObjects(opaqueObjects, scene, camera);
    _this.toneMapping = currentToneMapping;
    textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
    textures.updateRenderTargetMipmap(_transmissionRenderTarget);
    _this.setRenderTarget(currentRenderTarget);
  }
  function renderObjects(renderList, scene, camera) {
    const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
    for (let i2 = 0, l2 = renderList.length; i2 < l2; i2++) {
      const renderItem = renderList[i2];
      const object2 = renderItem.object;
      const geometry2 = renderItem.geometry;
      const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
      const group = renderItem.group;
      if (object2.layers.test(camera.layers)) {
        renderObject(object2, scene, camera, geometry2, material, group);
      }
    }
  }
  function renderObject(object2, scene, camera, geometry2, material, group) {
    object2.onBeforeRender(_this, scene, camera, geometry2, material, group);
    object2.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object2.matrixWorld);
    object2.normalMatrix.getNormalMatrix(object2.modelViewMatrix);
    material.onBeforeRender(_this, scene, camera, geometry2, object2, group);
    if (material.transparent === true && material.side === DoubleSide) {
      material.side = BackSide;
      material.needsUpdate = true;
      _this.renderBufferDirect(camera, scene, geometry2, material, object2, group);
      material.side = FrontSide;
      material.needsUpdate = true;
      _this.renderBufferDirect(camera, scene, geometry2, material, object2, group);
      material.side = DoubleSide;
    } else {
      _this.renderBufferDirect(camera, scene, geometry2, material, object2, group);
    }
    object2.onAfterRender(_this, scene, camera, geometry2, material, group);
  }
  function getProgram(material, scene, object2) {
    if (scene.isScene !== true)
      scene = _emptyScene;
    const materialProperties = properties.get(material);
    const lights2 = currentRenderState.state.lights;
    const shadowsArray = currentRenderState.state.shadowsArray;
    const lightsStateVersion = lights2.state.version;
    const parameters2 = programCache.getParameters(material, lights2.state, shadowsArray, scene, object2);
    const programCacheKey = programCache.getProgramCacheKey(parameters2);
    let programs = materialProperties.programs;
    materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
    materialProperties.fog = scene.fog;
    materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
    if (programs === void 0) {
      material.addEventListener("dispose", onMaterialDispose);
      programs = /* @__PURE__ */ new Map();
      materialProperties.programs = programs;
    }
    let program = programs.get(programCacheKey);
    if (program !== void 0) {
      if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
        updateCommonMaterialProperties(material, parameters2);
        return program;
      }
    } else {
      parameters2.uniforms = programCache.getUniforms(material);
      material.onBuild(object2, parameters2, _this);
      material.onBeforeCompile(parameters2, _this);
      program = programCache.acquireProgram(parameters2, programCacheKey);
      programs.set(programCacheKey, program);
      materialProperties.uniforms = parameters2.uniforms;
    }
    const uniforms = materialProperties.uniforms;
    if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
      uniforms.clippingPlanes = clipping.uniform;
    }
    updateCommonMaterialProperties(material, parameters2);
    materialProperties.needsLights = materialNeedsLights(material);
    materialProperties.lightsStateVersion = lightsStateVersion;
    if (materialProperties.needsLights) {
      uniforms.ambientLightColor.value = lights2.state.ambient;
      uniforms.lightProbe.value = lights2.state.probe;
      uniforms.directionalLights.value = lights2.state.directional;
      uniforms.directionalLightShadows.value = lights2.state.directionalShadow;
      uniforms.spotLights.value = lights2.state.spot;
      uniforms.spotLightShadows.value = lights2.state.spotShadow;
      uniforms.rectAreaLights.value = lights2.state.rectArea;
      uniforms.ltc_1.value = lights2.state.rectAreaLTC1;
      uniforms.ltc_2.value = lights2.state.rectAreaLTC2;
      uniforms.pointLights.value = lights2.state.point;
      uniforms.pointLightShadows.value = lights2.state.pointShadow;
      uniforms.hemisphereLights.value = lights2.state.hemi;
      uniforms.directionalShadowMap.value = lights2.state.directionalShadowMap;
      uniforms.directionalShadowMatrix.value = lights2.state.directionalShadowMatrix;
      uniforms.spotShadowMap.value = lights2.state.spotShadowMap;
      uniforms.spotShadowMatrix.value = lights2.state.spotShadowMatrix;
      uniforms.pointShadowMap.value = lights2.state.pointShadowMap;
      uniforms.pointShadowMatrix.value = lights2.state.pointShadowMatrix;
    }
    const progUniforms = program.getUniforms();
    const uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
    materialProperties.currentProgram = program;
    materialProperties.uniformsList = uniformsList;
    return program;
  }
  function updateCommonMaterialProperties(material, parameters2) {
    const materialProperties = properties.get(material);
    materialProperties.outputEncoding = parameters2.outputEncoding;
    materialProperties.instancing = parameters2.instancing;
    materialProperties.skinning = parameters2.skinning;
    materialProperties.morphTargets = parameters2.morphTargets;
    materialProperties.morphNormals = parameters2.morphNormals;
    materialProperties.morphColors = parameters2.morphColors;
    materialProperties.morphTargetsCount = parameters2.morphTargetsCount;
    materialProperties.numClippingPlanes = parameters2.numClippingPlanes;
    materialProperties.numIntersection = parameters2.numClipIntersection;
    materialProperties.vertexAlphas = parameters2.vertexAlphas;
    materialProperties.vertexTangents = parameters2.vertexTangents;
    materialProperties.toneMapping = parameters2.toneMapping;
  }
  function setProgram(camera, scene, geometry2, material, object2) {
    if (scene.isScene !== true)
      scene = _emptyScene;
    textures.resetTextureUnits();
    const fog2 = scene.fog;
    const environment = material.isMeshStandardMaterial ? scene.environment : null;
    const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : LinearEncoding;
    const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    const vertexAlphas = material.vertexColors === true && !!geometry2.attributes.color && geometry2.attributes.color.itemSize === 4;
    const vertexTangents = !!material.normalMap && !!geometry2.attributes.tangent;
    const morphTargets = !!geometry2.morphAttributes.position;
    const morphNormals = !!geometry2.morphAttributes.normal;
    const morphColors = !!geometry2.morphAttributes.color;
    const toneMapping = material.toneMapped ? _this.toneMapping : NoToneMapping;
    const morphAttribute = geometry2.morphAttributes.position || geometry2.morphAttributes.normal || geometry2.morphAttributes.color;
    const morphTargetsCount = morphAttribute !== void 0 ? morphAttribute.length : 0;
    const materialProperties = properties.get(material);
    const lights2 = currentRenderState.state.lights;
    if (_clippingEnabled === true) {
      if (_localClippingEnabled === true || camera !== _currentCamera) {
        const useCache = camera === _currentCamera && material.id === _currentMaterialId;
        clipping.setState(material, camera, useCache);
      }
    }
    let needsProgramChange = false;
    if (material.version === materialProperties.__version) {
      if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights2.state.version) {
        needsProgramChange = true;
      } else if (materialProperties.outputEncoding !== encoding) {
        needsProgramChange = true;
      } else if (object2.isInstancedMesh && materialProperties.instancing === false) {
        needsProgramChange = true;
      } else if (!object2.isInstancedMesh && materialProperties.instancing === true) {
        needsProgramChange = true;
      } else if (object2.isSkinnedMesh && materialProperties.skinning === false) {
        needsProgramChange = true;
      } else if (!object2.isSkinnedMesh && materialProperties.skinning === true) {
        needsProgramChange = true;
      } else if (materialProperties.envMap !== envMap) {
        needsProgramChange = true;
      } else if (material.fog && materialProperties.fog !== fog2) {
        needsProgramChange = true;
      } else if (materialProperties.numClippingPlanes !== void 0 && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
        needsProgramChange = true;
      } else if (materialProperties.vertexAlphas !== vertexAlphas) {
        needsProgramChange = true;
      } else if (materialProperties.vertexTangents !== vertexTangents) {
        needsProgramChange = true;
      } else if (materialProperties.morphTargets !== morphTargets) {
        needsProgramChange = true;
      } else if (materialProperties.morphNormals !== morphNormals) {
        needsProgramChange = true;
      } else if (materialProperties.morphColors !== morphColors) {
        needsProgramChange = true;
      } else if (materialProperties.toneMapping !== toneMapping) {
        needsProgramChange = true;
      } else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) {
        needsProgramChange = true;
      }
    } else {
      needsProgramChange = true;
      materialProperties.__version = material.version;
    }
    let program = materialProperties.currentProgram;
    if (needsProgramChange === true) {
      program = getProgram(material, scene, object2);
    }
    let refreshProgram = false;
    let refreshMaterial = false;
    let refreshLights = false;
    const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
    if (state.useProgram(program.program)) {
      refreshProgram = true;
      refreshMaterial = true;
      refreshLights = true;
    }
    if (material.id !== _currentMaterialId) {
      _currentMaterialId = material.id;
      refreshMaterial = true;
    }
    if (refreshProgram || _currentCamera !== camera) {
      p_uniforms.setValue(_gl, "projectionMatrix", camera.projectionMatrix);
      if (capabilities.logarithmicDepthBuffer) {
        p_uniforms.setValue(
          _gl,
          "logDepthBufFC",
          2 / (Math.log(camera.far + 1) / Math.LN2)
        );
      }
      if (_currentCamera !== camera) {
        _currentCamera = camera;
        refreshMaterial = true;
        refreshLights = true;
      }
      if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
        const uCamPos = p_uniforms.map.cameraPosition;
        if (uCamPos !== void 0) {
          uCamPos.setValue(
            _gl,
            _vector3.setFromMatrixPosition(camera.matrixWorld)
          );
        }
      }
      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
        p_uniforms.setValue(_gl, "isOrthographic", camera.isOrthographicCamera === true);
      }
      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object2.isSkinnedMesh) {
        p_uniforms.setValue(_gl, "viewMatrix", camera.matrixWorldInverse);
      }
    }
    if (object2.isSkinnedMesh) {
      p_uniforms.setOptional(_gl, object2, "bindMatrix");
      p_uniforms.setOptional(_gl, object2, "bindMatrixInverse");
      const skeleton = object2.skeleton;
      if (skeleton) {
        if (capabilities.floatVertexTextures) {
          if (skeleton.boneTexture === null)
            skeleton.computeBoneTexture();
          p_uniforms.setValue(_gl, "boneTexture", skeleton.boneTexture, textures);
          p_uniforms.setValue(_gl, "boneTextureSize", skeleton.boneTextureSize);
        } else {
          p_uniforms.setOptional(_gl, skeleton, "boneMatrices");
        }
      }
    }
    const morphAttributes = geometry2.morphAttributes;
    if (morphAttributes.position !== void 0 || morphAttributes.normal !== void 0 || morphAttributes.color !== void 0 && capabilities.isWebGL2 === true) {
      morphtargets.update(object2, geometry2, material, program);
    }
    if (refreshMaterial || materialProperties.receiveShadow !== object2.receiveShadow) {
      materialProperties.receiveShadow = object2.receiveShadow;
      p_uniforms.setValue(_gl, "receiveShadow", object2.receiveShadow);
    }
    if (refreshMaterial) {
      p_uniforms.setValue(_gl, "toneMappingExposure", _this.toneMappingExposure);
      if (materialProperties.needsLights) {
        markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
      }
      if (fog2 && material.fog) {
        materials.refreshFogUniforms(m_uniforms, fog2);
      }
      materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
      WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
    }
    if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
      WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
      material.uniformsNeedUpdate = false;
    }
    if (material.isSpriteMaterial) {
      p_uniforms.setValue(_gl, "center", object2.center);
    }
    p_uniforms.setValue(_gl, "modelViewMatrix", object2.modelViewMatrix);
    p_uniforms.setValue(_gl, "normalMatrix", object2.normalMatrix);
    p_uniforms.setValue(_gl, "modelMatrix", object2.matrixWorld);
    return program;
  }
  function markUniformsLightsNeedsUpdate(uniforms, value) {
    uniforms.ambientLightColor.needsUpdate = value;
    uniforms.lightProbe.needsUpdate = value;
    uniforms.directionalLights.needsUpdate = value;
    uniforms.directionalLightShadows.needsUpdate = value;
    uniforms.pointLights.needsUpdate = value;
    uniforms.pointLightShadows.needsUpdate = value;
    uniforms.spotLights.needsUpdate = value;
    uniforms.spotLightShadows.needsUpdate = value;
    uniforms.rectAreaLights.needsUpdate = value;
    uniforms.hemisphereLights.needsUpdate = value;
  }
  function materialNeedsLights(material) {
    return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
  }
  this.getActiveCubeFace = function() {
    return _currentActiveCubeFace;
  };
  this.getActiveMipmapLevel = function() {
    return _currentActiveMipmapLevel;
  };
  this.getRenderTarget = function() {
    return _currentRenderTarget;
  };
  this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
    properties.get(renderTarget.texture).__webglTexture = colorTexture;
    properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
    const renderTargetProperties = properties.get(renderTarget);
    renderTargetProperties.__hasExternalTextures = true;
    if (renderTargetProperties.__hasExternalTextures) {
      renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === void 0;
      if (!renderTargetProperties.__autoAllocateDepthBuffer) {
        if (extensions.has("WEBGL_multisampled_render_to_texture") === true) {
          console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided");
          renderTargetProperties.__useRenderToTexture = false;
        }
      }
    }
  };
  this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
    const renderTargetProperties = properties.get(renderTarget);
    renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
    renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === void 0;
  };
  this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
    _currentRenderTarget = renderTarget;
    _currentActiveCubeFace = activeCubeFace;
    _currentActiveMipmapLevel = activeMipmapLevel;
    let useDefaultFramebuffer = true;
    if (renderTarget) {
      const renderTargetProperties = properties.get(renderTarget);
      if (renderTargetProperties.__useDefaultFramebuffer !== void 0) {
        state.bindFramebuffer(36160, null);
        useDefaultFramebuffer = false;
      } else if (renderTargetProperties.__webglFramebuffer === void 0) {
        textures.setupRenderTarget(renderTarget);
      } else if (renderTargetProperties.__hasExternalTextures) {
        textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
      }
    }
    let framebuffer = null;
    let isCube = false;
    let isRenderTarget3D = false;
    if (renderTarget) {
      const texture = renderTarget.texture;
      if (texture.isData3DTexture || texture.isDataArrayTexture) {
        isRenderTarget3D = true;
      }
      const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
      if (renderTarget.isWebGLCubeRenderTarget) {
        framebuffer = __webglFramebuffer[activeCubeFace];
        isCube = true;
      } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {
        framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
      } else {
        framebuffer = __webglFramebuffer;
      }
      _currentViewport.copy(renderTarget.viewport);
      _currentScissor.copy(renderTarget.scissor);
      _currentScissorTest = renderTarget.scissorTest;
    } else {
      _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
      _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
      _currentScissorTest = _scissorTest;
    }
    const framebufferBound = state.bindFramebuffer(36160, framebuffer);
    if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) {
      state.drawBuffers(renderTarget, framebuffer);
    }
    state.viewport(_currentViewport);
    state.scissor(_currentScissor);
    state.setScissorTest(_currentScissorTest);
    if (isCube) {
      const textureProperties = properties.get(renderTarget.texture);
      _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
    } else if (isRenderTarget3D) {
      const textureProperties = properties.get(renderTarget.texture);
      const layer = activeCubeFace || 0;
      _gl.framebufferTextureLayer(36160, 36064, textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
    }
    _currentMaterialId = -1;
  };
  this.readRenderTargetPixels = function(renderTarget, x2, y2, width, height, buffer3, activeCubeFaceIndex) {
    if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
      console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      return;
    }
    let framebuffer = properties.get(renderTarget).__webglFramebuffer;
    if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== void 0) {
      framebuffer = framebuffer[activeCubeFaceIndex];
    }
    if (framebuffer) {
      state.bindFramebuffer(36160, framebuffer);
      try {
        const texture = renderTarget.texture;
        const textureFormat = texture.format;
        const textureType = texture.type;
        if (textureFormat !== RGBAFormat && utils2.convert(textureFormat) !== _gl.getParameter(35739)) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
          return;
        }
        const halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has("EXT_color_buffer_half_float") || capabilities.isWebGL2 && extensions.has("EXT_color_buffer_float"));
        if (textureType !== UnsignedByteType && utils2.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
        !(textureType === FloatType && (capabilities.isWebGL2 || extensions.has("OES_texture_float") || extensions.has("WEBGL_color_buffer_float"))) && // Chrome Mac >= 52 and Firefox
        !halfFloatSupportedByExt) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
          return;
        }
        if (x2 >= 0 && x2 <= renderTarget.width - width && (y2 >= 0 && y2 <= renderTarget.height - height)) {
          _gl.readPixels(x2, y2, width, height, utils2.convert(textureFormat), utils2.convert(textureType), buffer3);
        }
      } finally {
        const framebuffer2 = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
        state.bindFramebuffer(36160, framebuffer2);
      }
    }
  };
  this.copyFramebufferToTexture = function(position, texture, level = 0) {
    if (texture.isFramebufferTexture !== true) {
      console.error("THREE.WebGLRenderer: copyFramebufferToTexture() can only be used with FramebufferTexture.");
      return;
    }
    const levelScale = Math.pow(2, -level);
    const width = Math.floor(texture.image.width * levelScale);
    const height = Math.floor(texture.image.height * levelScale);
    textures.setTexture2D(texture, 0);
    _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);
    state.unbindTexture();
  };
  this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
    const width = srcTexture.image.width;
    const height = srcTexture.image.height;
    const glFormat = utils2.convert(dstTexture.format);
    const glType = utils2.convert(dstTexture.type);
    textures.setTexture2D(dstTexture, 0);
    _gl.pixelStorei(37440, dstTexture.flipY);
    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
    _gl.pixelStorei(3317, dstTexture.unpackAlignment);
    if (srcTexture.isDataTexture) {
      _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
    } else {
      if (srcTexture.isCompressedTexture) {
        _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
      } else {
        _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
      }
    }
    if (level === 0 && dstTexture.generateMipmaps)
      _gl.generateMipmap(3553);
    state.unbindTexture();
  };
  this.copyTextureToTexture3D = function(sourceBox, position, srcTexture, dstTexture, level = 0) {
    if (_this.isWebGL1Renderer) {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
      return;
    }
    const width = sourceBox.max.x - sourceBox.min.x + 1;
    const height = sourceBox.max.y - sourceBox.min.y + 1;
    const depth2 = sourceBox.max.z - sourceBox.min.z + 1;
    const glFormat = utils2.convert(dstTexture.format);
    const glType = utils2.convert(dstTexture.type);
    let glTarget;
    if (dstTexture.isData3DTexture) {
      textures.setTexture3D(dstTexture, 0);
      glTarget = 32879;
    } else if (dstTexture.isDataArrayTexture) {
      textures.setTexture2DArray(dstTexture, 0);
      glTarget = 35866;
    } else {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
      return;
    }
    _gl.pixelStorei(37440, dstTexture.flipY);
    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
    _gl.pixelStorei(3317, dstTexture.unpackAlignment);
    const unpackRowLen = _gl.getParameter(3314);
    const unpackImageHeight = _gl.getParameter(32878);
    const unpackSkipPixels = _gl.getParameter(3316);
    const unpackSkipRows = _gl.getParameter(3315);
    const unpackSkipImages = _gl.getParameter(32877);
    const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;
    _gl.pixelStorei(3314, image.width);
    _gl.pixelStorei(32878, image.height);
    _gl.pixelStorei(3316, sourceBox.min.x);
    _gl.pixelStorei(3315, sourceBox.min.y);
    _gl.pixelStorei(32877, sourceBox.min.z);
    if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {
      _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth2, glFormat, glType, image.data);
    } else {
      if (srcTexture.isCompressedTexture) {
        console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.");
        _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth2, glFormat, image.data);
      } else {
        _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth2, glFormat, glType, image);
      }
    }
    _gl.pixelStorei(3314, unpackRowLen);
    _gl.pixelStorei(32878, unpackImageHeight);
    _gl.pixelStorei(3316, unpackSkipPixels);
    _gl.pixelStorei(3315, unpackSkipRows);
    _gl.pixelStorei(32877, unpackSkipImages);
    if (level === 0 && dstTexture.generateMipmaps)
      _gl.generateMipmap(glTarget);
    state.unbindTexture();
  };
  this.initTexture = function(texture) {
    textures.setTexture2D(texture, 0);
    state.unbindTexture();
  };
  this.resetState = function() {
    _currentActiveCubeFace = 0;
    _currentActiveMipmapLevel = 0;
    _currentRenderTarget = null;
    state.reset();
    bindingStates.reset();
  };
  if (typeof __THREE_DEVTOOLS__ !== "undefined") {
    __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
  }
}
WebGLRenderer.prototype.isWebGLRenderer = true;
class WebGL1Renderer extends WebGLRenderer {
}
WebGL1Renderer.prototype.isWebGL1Renderer = true;
class FogExp2 {
  constructor(color, density = 25e-5) {
    this.name = "";
    this.color = new Color(color);
    this.density = density;
  }
  clone() {
    return new FogExp2(this.color, this.density);
  }
  toJSON() {
    return {
      type: "FogExp2",
      color: this.color.getHex(),
      density: this.density
    };
  }
}
FogExp2.prototype.isFogExp2 = true;
class Fog {
  constructor(color, near = 1, far = 1e3) {
    this.name = "";
    this.color = new Color(color);
    this.near = near;
    this.far = far;
  }
  clone() {
    return new Fog(this.color, this.near, this.far);
  }
  toJSON() {
    return {
      type: "Fog",
      color: this.color.getHex(),
      near: this.near,
      far: this.far
    };
  }
}
Fog.prototype.isFog = true;
class Scene extends Object3D {
  constructor() {
    super();
    this.type = "Scene";
    this.background = null;
    this.environment = null;
    this.fog = null;
    this.overrideMaterial = null;
    this.autoUpdate = true;
    if (typeof __THREE_DEVTOOLS__ !== "undefined") {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
  }
  copy(source, recursive) {
    super.copy(source, recursive);
    if (source.background !== null)
      this.background = source.background.clone();
    if (source.environment !== null)
      this.environment = source.environment.clone();
    if (source.fog !== null)
      this.fog = source.fog.clone();
    if (source.overrideMaterial !== null)
      this.overrideMaterial = source.overrideMaterial.clone();
    this.autoUpdate = source.autoUpdate;
    this.matrixAutoUpdate = source.matrixAutoUpdate;
    return this;
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    if (this.fog !== null)
      data2.object.fog = this.fog.toJSON();
    return data2;
  }
}
Scene.prototype.isScene = true;
class InterleavedBuffer {
  constructor(array2, stride) {
    this.array = array2;
    this.stride = stride;
    this.count = array2 !== void 0 ? array2.length / stride : 0;
    this.usage = StaticDrawUsage;
    this.updateRange = { offset: 0, count: -1 };
    this.version = 0;
    this.uuid = generateUUID();
  }
  onUploadCallback() {
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
  setUsage(value) {
    this.usage = value;
    return this;
  }
  copy(source) {
    this.array = new source.array.constructor(source.array);
    this.count = source.count;
    this.stride = source.stride;
    this.usage = source.usage;
    return this;
  }
  copyAt(index1, attribute, index2) {
    index1 *= this.stride;
    index2 *= attribute.stride;
    for (let i2 = 0, l2 = this.stride; i2 < l2; i2++) {
      this.array[index1 + i2] = attribute.array[index2 + i2];
    }
    return this;
  }
  set(value, offset = 0) {
    this.array.set(value, offset);
    return this;
  }
  clone(data2) {
    if (data2.arrayBuffers === void 0) {
      data2.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID();
    }
    if (data2.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data2.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
    }
    const array2 = new this.array.constructor(data2.arrayBuffers[this.array.buffer._uuid]);
    const ib = new this.constructor(array2, this.stride);
    ib.setUsage(this.usage);
    return ib;
  }
  onUpload(callback) {
    this.onUploadCallback = callback;
    return this;
  }
  toJSON(data2) {
    if (data2.arrayBuffers === void 0) {
      data2.arrayBuffers = {};
    }
    if (this.array.buffer._uuid === void 0) {
      this.array.buffer._uuid = generateUUID();
    }
    if (data2.arrayBuffers[this.array.buffer._uuid] === void 0) {
      data2.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
    }
    return {
      uuid: this.uuid,
      buffer: this.array.buffer._uuid,
      type: this.array.constructor.name,
      stride: this.stride
    };
  }
}
InterleavedBuffer.prototype.isInterleavedBuffer = true;
const _vector$6 = /* @__PURE__ */ new Vector3$1();
class InterleavedBufferAttribute {
  constructor(interleavedBuffer, itemSize, offset, normalized = false) {
    this.name = "";
    this.data = interleavedBuffer;
    this.itemSize = itemSize;
    this.offset = offset;
    this.normalized = normalized === true;
  }
  get count() {
    return this.data.count;
  }
  get array() {
    return this.data.array;
  }
  set needsUpdate(value) {
    this.data.needsUpdate = value;
  }
  applyMatrix4(m2) {
    for (let i2 = 0, l2 = this.data.count; i2 < l2; i2++) {
      _vector$6.fromBufferAttribute(this, i2);
      _vector$6.applyMatrix4(m2);
      this.setXYZ(i2, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  applyNormalMatrix(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$6.fromBufferAttribute(this, i2);
      _vector$6.applyNormalMatrix(m2);
      this.setXYZ(i2, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  transformDirection(m2) {
    for (let i2 = 0, l2 = this.count; i2 < l2; i2++) {
      _vector$6.fromBufferAttribute(this, i2);
      _vector$6.transformDirection(m2);
      this.setXYZ(i2, _vector$6.x, _vector$6.y, _vector$6.z);
    }
    return this;
  }
  setX(index2, x2) {
    this.data.array[index2 * this.data.stride + this.offset] = x2;
    return this;
  }
  setY(index2, y2) {
    this.data.array[index2 * this.data.stride + this.offset + 1] = y2;
    return this;
  }
  setZ(index2, z2) {
    this.data.array[index2 * this.data.stride + this.offset + 2] = z2;
    return this;
  }
  setW(index2, w2) {
    this.data.array[index2 * this.data.stride + this.offset + 3] = w2;
    return this;
  }
  getX(index2) {
    return this.data.array[index2 * this.data.stride + this.offset];
  }
  getY(index2) {
    return this.data.array[index2 * this.data.stride + this.offset + 1];
  }
  getZ(index2) {
    return this.data.array[index2 * this.data.stride + this.offset + 2];
  }
  getW(index2) {
    return this.data.array[index2 * this.data.stride + this.offset + 3];
  }
  setXY(index2, x2, y2) {
    index2 = index2 * this.data.stride + this.offset;
    this.data.array[index2 + 0] = x2;
    this.data.array[index2 + 1] = y2;
    return this;
  }
  setXYZ(index2, x2, y2, z2) {
    index2 = index2 * this.data.stride + this.offset;
    this.data.array[index2 + 0] = x2;
    this.data.array[index2 + 1] = y2;
    this.data.array[index2 + 2] = z2;
    return this;
  }
  setXYZW(index2, x2, y2, z2, w2) {
    index2 = index2 * this.data.stride + this.offset;
    this.data.array[index2 + 0] = x2;
    this.data.array[index2 + 1] = y2;
    this.data.array[index2 + 2] = z2;
    this.data.array[index2 + 3] = w2;
    return this;
  }
  clone(data2) {
    if (data2 === void 0) {
      console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.");
      const array2 = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index2 = i2 * this.data.stride + this.offset;
        for (let j2 = 0; j2 < this.itemSize; j2++) {
          array2.push(this.data.array[index2 + j2]);
        }
      }
      return new BufferAttribute(new this.array.constructor(array2), this.itemSize, this.normalized);
    } else {
      if (data2.interleavedBuffers === void 0) {
        data2.interleavedBuffers = {};
      }
      if (data2.interleavedBuffers[this.data.uuid] === void 0) {
        data2.interleavedBuffers[this.data.uuid] = this.data.clone(data2);
      }
      return new InterleavedBufferAttribute(data2.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
  }
  toJSON(data2) {
    if (data2 === void 0) {
      console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.");
      const array2 = [];
      for (let i2 = 0; i2 < this.count; i2++) {
        const index2 = i2 * this.data.stride + this.offset;
        for (let j2 = 0; j2 < this.itemSize; j2++) {
          array2.push(this.data.array[index2 + j2]);
        }
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: array2,
        normalized: this.normalized
      };
    } else {
      if (data2.interleavedBuffers === void 0) {
        data2.interleavedBuffers = {};
      }
      if (data2.interleavedBuffers[this.data.uuid] === void 0) {
        data2.interleavedBuffers[this.data.uuid] = this.data.toJSON(data2);
      }
      return {
        isInterleavedBufferAttribute: true,
        itemSize: this.itemSize,
        data: this.data.uuid,
        offset: this.offset,
        normalized: this.normalized
      };
    }
  }
}
InterleavedBufferAttribute.prototype.isInterleavedBufferAttribute = true;
class SpriteMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "SpriteMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
  }
}
SpriteMaterial.prototype.isSpriteMaterial = true;
let _geometry;
const _intersectPoint = /* @__PURE__ */ new Vector3$1();
const _worldScale = /* @__PURE__ */ new Vector3$1();
const _mvPosition = /* @__PURE__ */ new Vector3$1();
const _alignedPosition = /* @__PURE__ */ new Vector2$1();
const _rotatedPosition = /* @__PURE__ */ new Vector2$1();
const _viewWorldMatrix = /* @__PURE__ */ new Matrix4$1();
const _vA = /* @__PURE__ */ new Vector3$1();
const _vB = /* @__PURE__ */ new Vector3$1();
const _vC = /* @__PURE__ */ new Vector3$1();
const _uvA = /* @__PURE__ */ new Vector2$1();
const _uvB = /* @__PURE__ */ new Vector2$1();
const _uvC = /* @__PURE__ */ new Vector2$1();
class Sprite extends Object3D {
  constructor(material) {
    super();
    this.type = "Sprite";
    if (_geometry === void 0) {
      _geometry = new BufferGeometry();
      const float32Array = new Float32Array([
        -0.5,
        -0.5,
        0,
        0,
        0,
        0.5,
        -0.5,
        0,
        1,
        0,
        0.5,
        0.5,
        0,
        1,
        1,
        -0.5,
        0.5,
        0,
        0,
        1
      ]);
      const interleavedBuffer = new InterleavedBuffer(float32Array, 5);
      _geometry.setIndex([0, 1, 2, 0, 2, 3]);
      _geometry.setAttribute("position", new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
      _geometry.setAttribute("uv", new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
    }
    this.geometry = _geometry;
    this.material = material !== void 0 ? material : new SpriteMaterial();
    this.center = new Vector2$1(0.5, 0.5);
  }
  raycast(raycaster, intersects7) {
    if (raycaster.camera === null) {
      console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
    }
    _worldScale.setFromMatrixScale(this.matrixWorld);
    _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
    this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
    _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
    if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) {
      _worldScale.multiplyScalar(-_mvPosition.z);
    }
    const rotation = this.material.rotation;
    let sin2, cos2;
    if (rotation !== 0) {
      cos2 = Math.cos(rotation);
      sin2 = Math.sin(rotation);
    }
    const center2 = this.center;
    transformVertex(_vA.set(-0.5, -0.5, 0), _mvPosition, center2, _worldScale, sin2, cos2);
    transformVertex(_vB.set(0.5, -0.5, 0), _mvPosition, center2, _worldScale, sin2, cos2);
    transformVertex(_vC.set(0.5, 0.5, 0), _mvPosition, center2, _worldScale, sin2, cos2);
    _uvA.set(0, 0);
    _uvB.set(1, 0);
    _uvC.set(1, 1);
    let intersect2 = raycaster.ray.intersectTriangle(_vA, _vB, _vC, false, _intersectPoint);
    if (intersect2 === null) {
      transformVertex(_vB.set(-0.5, 0.5, 0), _mvPosition, center2, _worldScale, sin2, cos2);
      _uvB.set(0, 1);
      intersect2 = raycaster.ray.intersectTriangle(_vA, _vC, _vB, false, _intersectPoint);
      if (intersect2 === null) {
        return;
      }
    }
    const distance11 = raycaster.ray.origin.distanceTo(_intersectPoint);
    if (distance11 < raycaster.near || distance11 > raycaster.far)
      return;
    intersects7.push({
      distance: distance11,
      point: _intersectPoint.clone(),
      uv: Triangle.getUV(_intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2$1()),
      face: null,
      object: this
    });
  }
  copy(source) {
    super.copy(source);
    if (source.center !== void 0)
      this.center.copy(source.center);
    this.material = source.material;
    return this;
  }
}
Sprite.prototype.isSprite = true;
function transformVertex(vertexPosition, mvPosition, center2, scale5, sin2, cos2) {
  _alignedPosition.subVectors(vertexPosition, center2).addScalar(0.5).multiply(scale5);
  if (sin2 !== void 0) {
    _rotatedPosition.x = cos2 * _alignedPosition.x - sin2 * _alignedPosition.y;
    _rotatedPosition.y = sin2 * _alignedPosition.x + cos2 * _alignedPosition.y;
  } else {
    _rotatedPosition.copy(_alignedPosition);
  }
  vertexPosition.copy(mvPosition);
  vertexPosition.x += _rotatedPosition.x;
  vertexPosition.y += _rotatedPosition.y;
  vertexPosition.applyMatrix4(_viewWorldMatrix);
}
const _v1$2 = /* @__PURE__ */ new Vector3$1();
const _v2$1 = /* @__PURE__ */ new Vector3$1();
class LOD extends Object3D {
  constructor() {
    super();
    this._currentLevel = 0;
    this.type = "LOD";
    Object.defineProperties(this, {
      levels: {
        enumerable: true,
        value: []
      },
      isLOD: {
        value: true
      }
    });
    this.autoUpdate = true;
  }
  copy(source) {
    super.copy(source, false);
    const levels = source.levels;
    for (let i2 = 0, l2 = levels.length; i2 < l2; i2++) {
      const level = levels[i2];
      this.addLevel(level.object.clone(), level.distance);
    }
    this.autoUpdate = source.autoUpdate;
    return this;
  }
  addLevel(object2, distance11 = 0) {
    distance11 = Math.abs(distance11);
    const levels = this.levels;
    let l2;
    for (l2 = 0; l2 < levels.length; l2++) {
      if (distance11 < levels[l2].distance) {
        break;
      }
    }
    levels.splice(l2, 0, { distance: distance11, object: object2 });
    this.add(object2);
    return this;
  }
  getCurrentLevel() {
    return this._currentLevel;
  }
  getObjectForDistance(distance11) {
    const levels = this.levels;
    if (levels.length > 0) {
      let i2, l2;
      for (i2 = 1, l2 = levels.length; i2 < l2; i2++) {
        if (distance11 < levels[i2].distance) {
          break;
        }
      }
      return levels[i2 - 1].object;
    }
    return null;
  }
  raycast(raycaster, intersects7) {
    const levels = this.levels;
    if (levels.length > 0) {
      _v1$2.setFromMatrixPosition(this.matrixWorld);
      const distance11 = raycaster.ray.origin.distanceTo(_v1$2);
      this.getObjectForDistance(distance11).raycast(raycaster, intersects7);
    }
  }
  update(camera) {
    const levels = this.levels;
    if (levels.length > 1) {
      _v1$2.setFromMatrixPosition(camera.matrixWorld);
      _v2$1.setFromMatrixPosition(this.matrixWorld);
      const distance11 = _v1$2.distanceTo(_v2$1) / camera.zoom;
      levels[0].object.visible = true;
      let i2, l2;
      for (i2 = 1, l2 = levels.length; i2 < l2; i2++) {
        if (distance11 >= levels[i2].distance) {
          levels[i2 - 1].object.visible = false;
          levels[i2].object.visible = true;
        } else {
          break;
        }
      }
      this._currentLevel = i2 - 1;
      for (; i2 < l2; i2++) {
        levels[i2].object.visible = false;
      }
    }
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    if (this.autoUpdate === false)
      data2.object.autoUpdate = false;
    data2.object.levels = [];
    const levels = this.levels;
    for (let i2 = 0, l2 = levels.length; i2 < l2; i2++) {
      const level = levels[i2];
      data2.object.levels.push({
        object: level.object.uuid,
        distance: level.distance
      });
    }
    return data2;
  }
}
const _basePosition = /* @__PURE__ */ new Vector3$1();
const _skinIndex = /* @__PURE__ */ new Vector4$1();
const _skinWeight = /* @__PURE__ */ new Vector4$1();
const _vector$5 = /* @__PURE__ */ new Vector3$1();
const _matrix = /* @__PURE__ */ new Matrix4$1();
class SkinnedMesh extends Mesh {
  constructor(geometry2, material) {
    super(geometry2, material);
    this.type = "SkinnedMesh";
    this.bindMode = "attached";
    this.bindMatrix = new Matrix4$1();
    this.bindMatrixInverse = new Matrix4$1();
  }
  copy(source) {
    super.copy(source);
    this.bindMode = source.bindMode;
    this.bindMatrix.copy(source.bindMatrix);
    this.bindMatrixInverse.copy(source.bindMatrixInverse);
    this.skeleton = source.skeleton;
    return this;
  }
  bind(skeleton, bindMatrix) {
    this.skeleton = skeleton;
    if (bindMatrix === void 0) {
      this.updateMatrixWorld(true);
      this.skeleton.calculateInverses();
      bindMatrix = this.matrixWorld;
    }
    this.bindMatrix.copy(bindMatrix);
    this.bindMatrixInverse.copy(bindMatrix).invert();
  }
  pose() {
    this.skeleton.pose();
  }
  normalizeSkinWeights() {
    const vector = new Vector4$1();
    const skinWeight = this.geometry.attributes.skinWeight;
    for (let i2 = 0, l2 = skinWeight.count; i2 < l2; i2++) {
      vector.fromBufferAttribute(skinWeight, i2);
      const scale5 = 1 / vector.manhattanLength();
      if (scale5 !== Infinity) {
        vector.multiplyScalar(scale5);
      } else {
        vector.set(1, 0, 0, 0);
      }
      skinWeight.setXYZW(i2, vector.x, vector.y, vector.z, vector.w);
    }
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.bindMode === "attached") {
      this.bindMatrixInverse.copy(this.matrixWorld).invert();
    } else if (this.bindMode === "detached") {
      this.bindMatrixInverse.copy(this.bindMatrix).invert();
    } else {
      console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
    }
  }
  boneTransform(index2, target) {
    const skeleton = this.skeleton;
    const geometry2 = this.geometry;
    _skinIndex.fromBufferAttribute(geometry2.attributes.skinIndex, index2);
    _skinWeight.fromBufferAttribute(geometry2.attributes.skinWeight, index2);
    _basePosition.copy(target).applyMatrix4(this.bindMatrix);
    target.set(0, 0, 0);
    for (let i2 = 0; i2 < 4; i2++) {
      const weight = _skinWeight.getComponent(i2);
      if (weight !== 0) {
        const boneIndex = _skinIndex.getComponent(i2);
        _matrix.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
        target.addScaledVector(_vector$5.copy(_basePosition).applyMatrix4(_matrix), weight);
      }
    }
    return target.applyMatrix4(this.bindMatrixInverse);
  }
}
SkinnedMesh.prototype.isSkinnedMesh = true;
class Bone extends Object3D {
  constructor() {
    super();
    this.type = "Bone";
  }
}
Bone.prototype.isBone = true;
class DataTexture extends Texture$1 {
  constructor(data2 = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, encoding) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = { data: data2, width, height };
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
  }
}
DataTexture.prototype.isDataTexture = true;
const _offsetMatrix = /* @__PURE__ */ new Matrix4$1();
const _identityMatrix = /* @__PURE__ */ new Matrix4$1();
class Skeleton {
  constructor(bones = [], boneInverses = []) {
    this.uuid = generateUUID();
    this.bones = bones.slice(0);
    this.boneInverses = boneInverses;
    this.boneMatrices = null;
    this.boneTexture = null;
    this.boneTextureSize = 0;
    this.frame = -1;
    this.init();
  }
  init() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    this.boneMatrices = new Float32Array(bones.length * 16);
    if (boneInverses.length === 0) {
      this.calculateInverses();
    } else {
      if (bones.length !== boneInverses.length) {
        console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.");
        this.boneInverses = [];
        for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
          this.boneInverses.push(new Matrix4$1());
        }
      }
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0;
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const inverse2 = new Matrix4$1();
      if (this.bones[i2]) {
        inverse2.copy(this.bones[i2].matrixWorld).invert();
      }
      this.boneInverses.push(inverse2);
    }
  }
  pose() {
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone) {
        bone.matrixWorld.copy(this.boneInverses[i2]).invert();
      }
    }
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone) {
        if (bone.parent && bone.parent.isBone) {
          bone.matrix.copy(bone.parent.matrixWorld).invert();
          bone.matrix.multiply(bone.matrixWorld);
        } else {
          bone.matrix.copy(bone.matrixWorld);
        }
        bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
      }
    }
  }
  update() {
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    const boneMatrices = this.boneMatrices;
    const boneTexture = this.boneTexture;
    for (let i2 = 0, il = bones.length; i2 < il; i2++) {
      const matrix = bones[i2] ? bones[i2].matrixWorld : _identityMatrix;
      _offsetMatrix.multiplyMatrices(matrix, boneInverses[i2]);
      _offsetMatrix.toArray(boneMatrices, i2 * 16);
    }
    if (boneTexture !== null) {
      boneTexture.needsUpdate = true;
    }
  }
  clone() {
    return new Skeleton(this.bones, this.boneInverses);
  }
  computeBoneTexture() {
    let size12 = Math.sqrt(this.bones.length * 4);
    size12 = ceilPowerOfTwo(size12);
    size12 = Math.max(size12, 4);
    const boneMatrices = new Float32Array(size12 * size12 * 4);
    boneMatrices.set(this.boneMatrices);
    const boneTexture = new DataTexture(boneMatrices, size12, size12, RGBAFormat, FloatType);
    boneTexture.needsUpdate = true;
    this.boneMatrices = boneMatrices;
    this.boneTexture = boneTexture;
    this.boneTextureSize = size12;
    return this;
  }
  getBoneByName(name2) {
    for (let i2 = 0, il = this.bones.length; i2 < il; i2++) {
      const bone = this.bones[i2];
      if (bone.name === name2) {
        return bone;
      }
    }
    return void 0;
  }
  dispose() {
    if (this.boneTexture !== null) {
      this.boneTexture.dispose();
      this.boneTexture = null;
    }
  }
  fromJSON(json, bones) {
    this.uuid = json.uuid;
    for (let i2 = 0, l2 = json.bones.length; i2 < l2; i2++) {
      const uuid = json.bones[i2];
      let bone = bones[uuid];
      if (bone === void 0) {
        console.warn("THREE.Skeleton: No bone found with UUID:", uuid);
        bone = new Bone();
      }
      this.bones.push(bone);
      this.boneInverses.push(new Matrix4$1().fromArray(json.boneInverses[i2]));
    }
    this.init();
    return this;
  }
  toJSON() {
    const data2 = {
      metadata: {
        version: 4.5,
        type: "Skeleton",
        generator: "Skeleton.toJSON"
      },
      bones: [],
      boneInverses: []
    };
    data2.uuid = this.uuid;
    const bones = this.bones;
    const boneInverses = this.boneInverses;
    for (let i2 = 0, l2 = bones.length; i2 < l2; i2++) {
      const bone = bones[i2];
      data2.bones.push(bone.uuid);
      const boneInverse = boneInverses[i2];
      data2.boneInverses.push(boneInverse.toArray());
    }
    return data2;
  }
}
class InstancedBufferAttribute extends BufferAttribute {
  constructor(array2, itemSize, normalized, meshPerAttribute = 1) {
    if (typeof normalized === "number") {
      meshPerAttribute = normalized;
      normalized = false;
      console.error("THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.");
    }
    super(array2, itemSize, normalized);
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.meshPerAttribute = this.meshPerAttribute;
    data2.isInstancedBufferAttribute = true;
    return data2;
  }
}
InstancedBufferAttribute.prototype.isInstancedBufferAttribute = true;
const _instanceLocalMatrix = /* @__PURE__ */ new Matrix4$1();
const _instanceWorldMatrix = /* @__PURE__ */ new Matrix4$1();
const _instanceIntersects = [];
const _mesh = /* @__PURE__ */ new Mesh();
class InstancedMesh extends Mesh {
  constructor(geometry2, material, count3) {
    super(geometry2, material);
    this.instanceMatrix = new InstancedBufferAttribute(new Float32Array(count3 * 16), 16);
    this.instanceColor = null;
    this.count = count3;
    this.frustumCulled = false;
  }
  copy(source) {
    super.copy(source);
    this.instanceMatrix.copy(source.instanceMatrix);
    if (source.instanceColor !== null)
      this.instanceColor = source.instanceColor.clone();
    this.count = source.count;
    return this;
  }
  getColorAt(index2, color) {
    color.fromArray(this.instanceColor.array, index2 * 3);
  }
  getMatrixAt(index2, matrix) {
    matrix.fromArray(this.instanceMatrix.array, index2 * 16);
  }
  raycast(raycaster, intersects7) {
    const matrixWorld = this.matrixWorld;
    const raycastTimes = this.count;
    _mesh.geometry = this.geometry;
    _mesh.material = this.material;
    if (_mesh.material === void 0)
      return;
    for (let instanceId = 0; instanceId < raycastTimes; instanceId++) {
      this.getMatrixAt(instanceId, _instanceLocalMatrix);
      _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
      _mesh.matrixWorld = _instanceWorldMatrix;
      _mesh.raycast(raycaster, _instanceIntersects);
      for (let i2 = 0, l2 = _instanceIntersects.length; i2 < l2; i2++) {
        const intersect2 = _instanceIntersects[i2];
        intersect2.instanceId = instanceId;
        intersect2.object = this;
        intersects7.push(intersect2);
      }
      _instanceIntersects.length = 0;
    }
  }
  setColorAt(index2, color) {
    if (this.instanceColor === null) {
      this.instanceColor = new InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3), 3);
    }
    color.toArray(this.instanceColor.array, index2 * 3);
  }
  setMatrixAt(index2, matrix) {
    matrix.toArray(this.instanceMatrix.array, index2 * 16);
  }
  updateMorphTargets() {
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
InstancedMesh.prototype.isInstancedMesh = true;
class LineBasicMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "LineBasicMaterial";
    this.color = new Color(16777215);
    this.linewidth = 1;
    this.linecap = "round";
    this.linejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.linewidth = source.linewidth;
    this.linecap = source.linecap;
    this.linejoin = source.linejoin;
    return this;
  }
}
LineBasicMaterial.prototype.isLineBasicMaterial = true;
const _start$1 = /* @__PURE__ */ new Vector3$1();
const _end$1 = /* @__PURE__ */ new Vector3$1();
const _inverseMatrix$1 = /* @__PURE__ */ new Matrix4$1();
const _ray$1 = /* @__PURE__ */ new Ray();
const _sphere$1 = /* @__PURE__ */ new Sphere();
class Line extends Object3D {
  constructor(geometry2 = new BufferGeometry(), material = new LineBasicMaterial()) {
    super();
    this.type = "Line";
    this.geometry = geometry2;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  computeLineDistances() {
    const geometry2 = this.geometry;
    if (geometry2.isBufferGeometry) {
      if (geometry2.index === null) {
        const positionAttribute = geometry2.attributes.position;
        const lineDistances = [0];
        for (let i2 = 1, l2 = positionAttribute.count; i2 < l2; i2++) {
          _start$1.fromBufferAttribute(positionAttribute, i2 - 1);
          _end$1.fromBufferAttribute(positionAttribute, i2);
          lineDistances[i2] = lineDistances[i2 - 1];
          lineDistances[i2] += _start$1.distanceTo(_end$1);
        }
        geometry2.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
      } else {
        console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
    } else if (geometry2.isGeometry) {
      console.error("THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    return this;
  }
  raycast(raycaster, intersects7) {
    const geometry2 = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold2 = raycaster.params.Line.threshold;
    const drawRange = geometry2.drawRange;
    if (geometry2.boundingSphere === null)
      geometry2.computeBoundingSphere();
    _sphere$1.copy(geometry2.boundingSphere);
    _sphere$1.applyMatrix4(matrixWorld);
    _sphere$1.radius += threshold2;
    if (raycaster.ray.intersectsSphere(_sphere$1) === false)
      return;
    _inverseMatrix$1.copy(matrixWorld).invert();
    _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
    const localThreshold = threshold2 / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    const vStart = new Vector3$1();
    const vEnd = new Vector3$1();
    const interSegment = new Vector3$1();
    const interRay = new Vector3$1();
    const step = this.isLineSegments ? 2 : 1;
    if (geometry2.isBufferGeometry) {
      const index2 = geometry2.index;
      const attributes = geometry2.attributes;
      const positionAttribute = attributes.position;
      if (index2 !== null) {
        const start2 = Math.max(0, drawRange.start);
        const end = Math.min(index2.count, drawRange.start + drawRange.count);
        for (let i2 = start2, l2 = end - 1; i2 < l2; i2 += step) {
          const a2 = index2.getX(i2);
          const b2 = index2.getX(i2 + 1);
          vStart.fromBufferAttribute(positionAttribute, a2);
          vEnd.fromBufferAttribute(positionAttribute, b2);
          const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
          if (distSq > localThresholdSq)
            continue;
          interRay.applyMatrix4(this.matrixWorld);
          const distance11 = raycaster.ray.origin.distanceTo(interRay);
          if (distance11 < raycaster.near || distance11 > raycaster.far)
            continue;
          intersects7.push({
            distance: distance11,
            // What do we want? intersection point on the ray or on the segment??
            // point: raycaster.ray.at( distance ),
            point: interSegment.clone().applyMatrix4(this.matrixWorld),
            index: i2,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      } else {
        const start2 = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i2 = start2, l2 = end - 1; i2 < l2; i2 += step) {
          vStart.fromBufferAttribute(positionAttribute, i2);
          vEnd.fromBufferAttribute(positionAttribute, i2 + 1);
          const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
          if (distSq > localThresholdSq)
            continue;
          interRay.applyMatrix4(this.matrixWorld);
          const distance11 = raycaster.ray.origin.distanceTo(interRay);
          if (distance11 < raycaster.near || distance11 > raycaster.far)
            continue;
          intersects7.push({
            distance: distance11,
            // What do we want? intersection point on the ray or on the segment??
            // point: raycaster.ray.at( distance ),
            point: interSegment.clone().applyMatrix4(this.matrixWorld),
            index: i2,
            face: null,
            faceIndex: null,
            object: this
          });
        }
      }
    } else if (geometry2.isGeometry) {
      console.error("THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
  updateMorphTargets() {
    const geometry2 = this.geometry;
    if (geometry2.isBufferGeometry) {
      const morphAttributes = geometry2.morphAttributes;
      const keys4 = Object.keys(morphAttributes);
      if (keys4.length > 0) {
        const morphAttribute = morphAttributes[keys4[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m2 = 0, ml = morphAttribute.length; m2 < ml; m2++) {
            const name2 = morphAttribute[m2].name || String(m2);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name2] = m2;
          }
        }
      }
    } else {
      const morphTargets = geometry2.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
}
Line.prototype.isLine = true;
const _start = /* @__PURE__ */ new Vector3$1();
const _end = /* @__PURE__ */ new Vector3$1();
class LineSegments extends Line {
  constructor(geometry2, material) {
    super(geometry2, material);
    this.type = "LineSegments";
  }
  computeLineDistances() {
    const geometry2 = this.geometry;
    if (geometry2.isBufferGeometry) {
      if (geometry2.index === null) {
        const positionAttribute = geometry2.attributes.position;
        const lineDistances = [];
        for (let i2 = 0, l2 = positionAttribute.count; i2 < l2; i2 += 2) {
          _start.fromBufferAttribute(positionAttribute, i2);
          _end.fromBufferAttribute(positionAttribute, i2 + 1);
          lineDistances[i2] = i2 === 0 ? 0 : lineDistances[i2 - 1];
          lineDistances[i2 + 1] = lineDistances[i2] + _start.distanceTo(_end);
        }
        geometry2.setAttribute("lineDistance", new Float32BufferAttribute(lineDistances, 1));
      } else {
        console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
      }
    } else if (geometry2.isGeometry) {
      console.error("THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
    return this;
  }
}
LineSegments.prototype.isLineSegments = true;
class LineLoop extends Line {
  constructor(geometry2, material) {
    super(geometry2, material);
    this.type = "LineLoop";
  }
}
LineLoop.prototype.isLineLoop = true;
class PointsMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "PointsMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.alphaMap = null;
    this.size = 1;
    this.sizeAttenuation = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.size = source.size;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
  }
}
PointsMaterial.prototype.isPointsMaterial = true;
const _inverseMatrix = /* @__PURE__ */ new Matrix4$1();
const _ray$3 = /* @__PURE__ */ new Ray();
const _sphere = /* @__PURE__ */ new Sphere();
const _position$2 = /* @__PURE__ */ new Vector3$1();
class Points extends Object3D {
  constructor(geometry2 = new BufferGeometry(), material = new PointsMaterial()) {
    super();
    this.type = "Points";
    this.geometry = geometry2;
    this.material = material;
    this.updateMorphTargets();
  }
  copy(source) {
    super.copy(source);
    this.material = source.material;
    this.geometry = source.geometry;
    return this;
  }
  raycast(raycaster, intersects7) {
    const geometry2 = this.geometry;
    const matrixWorld = this.matrixWorld;
    const threshold2 = raycaster.params.Points.threshold;
    const drawRange = geometry2.drawRange;
    if (geometry2.boundingSphere === null)
      geometry2.computeBoundingSphere();
    _sphere.copy(geometry2.boundingSphere);
    _sphere.applyMatrix4(matrixWorld);
    _sphere.radius += threshold2;
    if (raycaster.ray.intersectsSphere(_sphere) === false)
      return;
    _inverseMatrix.copy(matrixWorld).invert();
    _ray$3.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
    const localThreshold = threshold2 / ((this.scale.x + this.scale.y + this.scale.z) / 3);
    const localThresholdSq = localThreshold * localThreshold;
    if (geometry2.isBufferGeometry) {
      const index2 = geometry2.index;
      const attributes = geometry2.attributes;
      const positionAttribute = attributes.position;
      if (index2 !== null) {
        const start2 = Math.max(0, drawRange.start);
        const end = Math.min(index2.count, drawRange.start + drawRange.count);
        for (let i2 = start2, il = end; i2 < il; i2++) {
          const a2 = index2.getX(i2);
          _position$2.fromBufferAttribute(positionAttribute, a2);
          testPoint(_position$2, a2, localThresholdSq, matrixWorld, raycaster, intersects7, this);
        }
      } else {
        const start2 = Math.max(0, drawRange.start);
        const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
        for (let i2 = start2, l2 = end; i2 < l2; i2++) {
          _position$2.fromBufferAttribute(positionAttribute, i2);
          testPoint(_position$2, i2, localThresholdSq, matrixWorld, raycaster, intersects7, this);
        }
      }
    } else {
      console.error("THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.");
    }
  }
  updateMorphTargets() {
    const geometry2 = this.geometry;
    if (geometry2.isBufferGeometry) {
      const morphAttributes = geometry2.morphAttributes;
      const keys4 = Object.keys(morphAttributes);
      if (keys4.length > 0) {
        const morphAttribute = morphAttributes[keys4[0]];
        if (morphAttribute !== void 0) {
          this.morphTargetInfluences = [];
          this.morphTargetDictionary = {};
          for (let m2 = 0, ml = morphAttribute.length; m2 < ml; m2++) {
            const name2 = morphAttribute[m2].name || String(m2);
            this.morphTargetInfluences.push(0);
            this.morphTargetDictionary[name2] = m2;
          }
        }
      }
    } else {
      const morphTargets = geometry2.morphTargets;
      if (morphTargets !== void 0 && morphTargets.length > 0) {
        console.error("THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.");
      }
    }
  }
}
Points.prototype.isPoints = true;
function testPoint(point4, index2, localThresholdSq, matrixWorld, raycaster, intersects7, object2) {
  const rayPointDistanceSq = _ray$3.distanceSqToPoint(point4);
  if (rayPointDistanceSq < localThresholdSq) {
    const intersectPoint = new Vector3$1();
    _ray$3.closestPointToPoint(point4, intersectPoint);
    intersectPoint.applyMatrix4(matrixWorld);
    const distance11 = raycaster.ray.origin.distanceTo(intersectPoint);
    if (distance11 < raycaster.near || distance11 > raycaster.far)
      return;
    intersects7.push({
      distance: distance11,
      distanceToRay: Math.sqrt(rayPointDistanceSq),
      point: intersectPoint,
      index: index2,
      face: null,
      object: object2
    });
  }
}
class VideoTexture extends Texture$1 {
  constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.minFilter = minFilter !== void 0 ? minFilter : LinearFilter;
    this.magFilter = magFilter !== void 0 ? magFilter : LinearFilter;
    this.generateMipmaps = false;
    const scope = this;
    function updateVideo() {
      scope.needsUpdate = true;
      video.requestVideoFrameCallback(updateVideo);
    }
    if ("requestVideoFrameCallback" in video) {
      video.requestVideoFrameCallback(updateVideo);
    }
  }
  clone() {
    return new this.constructor(this.image).copy(this);
  }
  update() {
    const video = this.image;
    const hasVideoFrameCallback = "requestVideoFrameCallback" in video;
    if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {
      this.needsUpdate = true;
    }
  }
}
VideoTexture.prototype.isVideoTexture = true;
class FramebufferTexture extends Texture$1 {
  constructor(width, height, format) {
    super({ width, height });
    this.format = format;
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.generateMipmaps = false;
    this.needsUpdate = true;
  }
}
FramebufferTexture.prototype.isFramebufferTexture = true;
class CompressedTexture extends Texture$1 {
  constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = { width, height };
    this.mipmaps = mipmaps;
    this.flipY = false;
    this.generateMipmaps = false;
  }
}
CompressedTexture.prototype.isCompressedTexture = true;
class CanvasTexture extends Texture$1 {
  constructor(canvas2, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    super(canvas2, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.needsUpdate = true;
  }
}
CanvasTexture.prototype.isCanvasTexture = true;
class Curve {
  constructor() {
    this.type = "Curve";
    this.arcLengthDivisions = 200;
  }
  // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]
  getPoint() {
    console.warn("THREE.Curve: .getPoint() not implemented.");
    return null;
  }
  // Get point at relative position in curve according to arc length
  // - u [0 .. 1]
  getPointAt(u2, optionalTarget) {
    const t2 = this.getUtoTmapping(u2);
    return this.getPoint(t2, optionalTarget);
  }
  // Get sequence of points using getPoint( t )
  getPoints(divisions = 5) {
    const points2 = [];
    for (let d2 = 0; d2 <= divisions; d2++) {
      points2.push(this.getPoint(d2 / divisions));
    }
    return points2;
  }
  // Get sequence of points using getPointAt( u )
  getSpacedPoints(divisions = 5) {
    const points2 = [];
    for (let d2 = 0; d2 <= divisions; d2++) {
      points2.push(this.getPointAt(d2 / divisions));
    }
    return points2;
  }
  // Get total curve arc length
  getLength() {
    const lengths = this.getLengths();
    return lengths[lengths.length - 1];
  }
  // Get list of cumulative segment lengths
  getLengths(divisions = this.arcLengthDivisions) {
    if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
      return this.cacheArcLengths;
    }
    this.needsUpdate = false;
    const cache2 = [];
    let current, last = this.getPoint(0);
    let sum2 = 0;
    cache2.push(0);
    for (let p2 = 1; p2 <= divisions; p2++) {
      current = this.getPoint(p2 / divisions);
      sum2 += current.distanceTo(last);
      cache2.push(sum2);
      last = current;
    }
    this.cacheArcLengths = cache2;
    return cache2;
  }
  updateArcLengths() {
    this.needsUpdate = true;
    this.getLengths();
  }
  // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
  getUtoTmapping(u2, distance11) {
    const arcLengths = this.getLengths();
    let i2 = 0;
    const il = arcLengths.length;
    let targetArcLength;
    if (distance11) {
      targetArcLength = distance11;
    } else {
      targetArcLength = u2 * arcLengths[il - 1];
    }
    let low = 0, high = il - 1, comparison;
    while (low <= high) {
      i2 = Math.floor(low + (high - low) / 2);
      comparison = arcLengths[i2] - targetArcLength;
      if (comparison < 0) {
        low = i2 + 1;
      } else if (comparison > 0) {
        high = i2 - 1;
      } else {
        high = i2;
        break;
      }
    }
    i2 = high;
    if (arcLengths[i2] === targetArcLength) {
      return i2 / (il - 1);
    }
    const lengthBefore = arcLengths[i2];
    const lengthAfter = arcLengths[i2 + 1];
    const segmentLength = lengthAfter - lengthBefore;
    const segmentFraction2 = (targetArcLength - lengthBefore) / segmentLength;
    const t2 = (i2 + segmentFraction2) / (il - 1);
    return t2;
  }
  // Returns a unit vector tangent at t
  // In case any sub curve does not implement its tangent derivation,
  // 2 points a small delta apart will be used to find its gradient
  // which seems to give a reasonable approximation
  getTangent(t2, optionalTarget) {
    const delta = 1e-4;
    let t1 = t2 - delta;
    let t22 = t2 + delta;
    if (t1 < 0)
      t1 = 0;
    if (t22 > 1)
      t22 = 1;
    const pt1 = this.getPoint(t1);
    const pt2 = this.getPoint(t22);
    const tangent = optionalTarget || (pt1.isVector2 ? new Vector2$1() : new Vector3$1());
    tangent.copy(pt2).sub(pt1).normalize();
    return tangent;
  }
  getTangentAt(u2, optionalTarget) {
    const t2 = this.getUtoTmapping(u2);
    return this.getTangent(t2, optionalTarget);
  }
  computeFrenetFrames(segments, closed) {
    const normal = new Vector3$1();
    const tangents = [];
    const normals = [];
    const binormals = [];
    const vec = new Vector3$1();
    const mat = new Matrix4$1();
    for (let i2 = 0; i2 <= segments; i2++) {
      const u2 = i2 / segments;
      tangents[i2] = this.getTangentAt(u2, new Vector3$1());
    }
    normals[0] = new Vector3$1();
    binormals[0] = new Vector3$1();
    let min4 = Number.MAX_VALUE;
    const tx = Math.abs(tangents[0].x);
    const ty = Math.abs(tangents[0].y);
    const tz = Math.abs(tangents[0].z);
    if (tx <= min4) {
      min4 = tx;
      normal.set(1, 0, 0);
    }
    if (ty <= min4) {
      min4 = ty;
      normal.set(0, 1, 0);
    }
    if (tz <= min4) {
      normal.set(0, 0, 1);
    }
    vec.crossVectors(tangents[0], normal).normalize();
    normals[0].crossVectors(tangents[0], vec);
    binormals[0].crossVectors(tangents[0], normals[0]);
    for (let i2 = 1; i2 <= segments; i2++) {
      normals[i2] = normals[i2 - 1].clone();
      binormals[i2] = binormals[i2 - 1].clone();
      vec.crossVectors(tangents[i2 - 1], tangents[i2]);
      if (vec.length() > Number.EPSILON) {
        vec.normalize();
        const theta = Math.acos(clamp$5(tangents[i2 - 1].dot(tangents[i2]), -1, 1));
        normals[i2].applyMatrix4(mat.makeRotationAxis(vec, theta));
      }
      binormals[i2].crossVectors(tangents[i2], normals[i2]);
    }
    if (closed === true) {
      let theta = Math.acos(clamp$5(normals[0].dot(normals[segments]), -1, 1));
      theta /= segments;
      if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
        theta = -theta;
      }
      for (let i2 = 1; i2 <= segments; i2++) {
        normals[i2].applyMatrix4(mat.makeRotationAxis(tangents[i2], theta * i2));
        binormals[i2].crossVectors(tangents[i2], normals[i2]);
      }
    }
    return {
      tangents,
      normals,
      binormals
    };
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(source) {
    this.arcLengthDivisions = source.arcLengthDivisions;
    return this;
  }
  toJSON() {
    const data2 = {
      metadata: {
        version: 4.5,
        type: "Curve",
        generator: "Curve.toJSON"
      }
    };
    data2.arcLengthDivisions = this.arcLengthDivisions;
    data2.type = this.type;
    return data2;
  }
  fromJSON(json) {
    this.arcLengthDivisions = json.arcLengthDivisions;
    return this;
  }
}
class EllipseCurve extends Curve {
  constructor(aX2 = 0, aY2 = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0) {
    super();
    this.type = "EllipseCurve";
    this.aX = aX2;
    this.aY = aY2;
    this.xRadius = xRadius;
    this.yRadius = yRadius;
    this.aStartAngle = aStartAngle;
    this.aEndAngle = aEndAngle;
    this.aClockwise = aClockwise;
    this.aRotation = aRotation;
  }
  getPoint(t2, optionalTarget) {
    const point4 = optionalTarget || new Vector2$1();
    const twoPi = Math.PI * 2;
    let deltaAngle = this.aEndAngle - this.aStartAngle;
    const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
    while (deltaAngle < 0)
      deltaAngle += twoPi;
    while (deltaAngle > twoPi)
      deltaAngle -= twoPi;
    if (deltaAngle < Number.EPSILON) {
      if (samePoints) {
        deltaAngle = 0;
      } else {
        deltaAngle = twoPi;
      }
    }
    if (this.aClockwise === true && !samePoints) {
      if (deltaAngle === twoPi) {
        deltaAngle = -twoPi;
      } else {
        deltaAngle = deltaAngle - twoPi;
      }
    }
    const angle4 = this.aStartAngle + t2 * deltaAngle;
    let x2 = this.aX + this.xRadius * Math.cos(angle4);
    let y2 = this.aY + this.yRadius * Math.sin(angle4);
    if (this.aRotation !== 0) {
      const cos2 = Math.cos(this.aRotation);
      const sin2 = Math.sin(this.aRotation);
      const tx = x2 - this.aX;
      const ty = y2 - this.aY;
      x2 = tx * cos2 - ty * sin2 + this.aX;
      y2 = tx * sin2 + ty * cos2 + this.aY;
    }
    return point4.set(x2, y2);
  }
  copy(source) {
    super.copy(source);
    this.aX = source.aX;
    this.aY = source.aY;
    this.xRadius = source.xRadius;
    this.yRadius = source.yRadius;
    this.aStartAngle = source.aStartAngle;
    this.aEndAngle = source.aEndAngle;
    this.aClockwise = source.aClockwise;
    this.aRotation = source.aRotation;
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.aX = this.aX;
    data2.aY = this.aY;
    data2.xRadius = this.xRadius;
    data2.yRadius = this.yRadius;
    data2.aStartAngle = this.aStartAngle;
    data2.aEndAngle = this.aEndAngle;
    data2.aClockwise = this.aClockwise;
    data2.aRotation = this.aRotation;
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.aX = json.aX;
    this.aY = json.aY;
    this.xRadius = json.xRadius;
    this.yRadius = json.yRadius;
    this.aStartAngle = json.aStartAngle;
    this.aEndAngle = json.aEndAngle;
    this.aClockwise = json.aClockwise;
    this.aRotation = json.aRotation;
    return this;
  }
}
EllipseCurve.prototype.isEllipseCurve = true;
class ArcCurve extends EllipseCurve {
  constructor(aX2, aY2, aRadius, aStartAngle, aEndAngle, aClockwise) {
    super(aX2, aY2, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    this.type = "ArcCurve";
  }
}
ArcCurve.prototype.isArcCurve = true;
function CubicPoly() {
  let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
  function init9(x02, x12, t0, t1) {
    c0 = x02;
    c1 = t0;
    c2 = -3 * x02 + 3 * x12 - 2 * t0 - t1;
    c3 = 2 * x02 - 2 * x12 + t0 + t1;
  }
  return {
    initCatmullRom: function(x02, x12, x2, x3, tension) {
      init9(x12, x2, tension * (x2 - x02), tension * (x3 - x12));
    },
    initNonuniformCatmullRom: function(x02, x12, x2, x3, dt0, dt1, dt2) {
      let t1 = (x12 - x02) / dt0 - (x2 - x02) / (dt0 + dt1) + (x2 - x12) / dt1;
      let t2 = (x2 - x12) / dt1 - (x3 - x12) / (dt1 + dt2) + (x3 - x2) / dt2;
      t1 *= dt1;
      t2 *= dt1;
      init9(x12, x2, t1, t2);
    },
    calc: function(t2) {
      const t22 = t2 * t2;
      const t3 = t22 * t2;
      return c0 + c1 * t2 + c2 * t22 + c3 * t3;
    }
  };
}
const tmp = new Vector3$1();
const px = new CubicPoly(), py = new CubicPoly(), pz = new CubicPoly();
class CatmullRomCurve3 extends Curve {
  constructor(points2 = [], closed = false, curveType = "centripetal", tension = 0.5) {
    super();
    this.type = "CatmullRomCurve3";
    this.points = points2;
    this.closed = closed;
    this.curveType = curveType;
    this.tension = tension;
  }
  getPoint(t2, optionalTarget = new Vector3$1()) {
    const point4 = optionalTarget;
    const points2 = this.points;
    const l2 = points2.length;
    const p2 = (l2 - (this.closed ? 0 : 1)) * t2;
    let intPoint = Math.floor(p2);
    let weight = p2 - intPoint;
    if (this.closed) {
      intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l2) + 1) * l2;
    } else if (weight === 0 && intPoint === l2 - 1) {
      intPoint = l2 - 2;
      weight = 1;
    }
    let p0, p3;
    if (this.closed || intPoint > 0) {
      p0 = points2[(intPoint - 1) % l2];
    } else {
      tmp.subVectors(points2[0], points2[1]).add(points2[0]);
      p0 = tmp;
    }
    const p1 = points2[intPoint % l2];
    const p22 = points2[(intPoint + 1) % l2];
    if (this.closed || intPoint + 2 < l2) {
      p3 = points2[(intPoint + 2) % l2];
    } else {
      tmp.subVectors(points2[l2 - 1], points2[l2 - 2]).add(points2[l2 - 1]);
      p3 = tmp;
    }
    if (this.curveType === "centripetal" || this.curveType === "chordal") {
      const pow2 = this.curveType === "chordal" ? 0.5 : 0.25;
      let dt0 = Math.pow(p0.distanceToSquared(p1), pow2);
      let dt1 = Math.pow(p1.distanceToSquared(p22), pow2);
      let dt2 = Math.pow(p22.distanceToSquared(p3), pow2);
      if (dt1 < 1e-4)
        dt1 = 1;
      if (dt0 < 1e-4)
        dt0 = dt1;
      if (dt2 < 1e-4)
        dt2 = dt1;
      px.initNonuniformCatmullRom(p0.x, p1.x, p22.x, p3.x, dt0, dt1, dt2);
      py.initNonuniformCatmullRom(p0.y, p1.y, p22.y, p3.y, dt0, dt1, dt2);
      pz.initNonuniformCatmullRom(p0.z, p1.z, p22.z, p3.z, dt0, dt1, dt2);
    } else if (this.curveType === "catmullrom") {
      px.initCatmullRom(p0.x, p1.x, p22.x, p3.x, this.tension);
      py.initCatmullRom(p0.y, p1.y, p22.y, p3.y, this.tension);
      pz.initCatmullRom(p0.z, p1.z, p22.z, p3.z, this.tension);
    }
    point4.set(
      px.calc(weight),
      py.calc(weight),
      pz.calc(weight)
    );
    return point4;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point4 = source.points[i2];
      this.points.push(point4.clone());
    }
    this.closed = source.closed;
    this.curveType = source.curveType;
    this.tension = source.tension;
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point4 = this.points[i2];
      data2.points.push(point4.toArray());
    }
    data2.closed = this.closed;
    data2.curveType = this.curveType;
    data2.tension = this.tension;
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point4 = json.points[i2];
      this.points.push(new Vector3$1().fromArray(point4));
    }
    this.closed = json.closed;
    this.curveType = json.curveType;
    this.tension = json.tension;
    return this;
  }
}
CatmullRomCurve3.prototype.isCatmullRomCurve3 = true;
function CatmullRom(t2, p0, p1, p2, p3) {
  const v0 = (p2 - p0) * 0.5;
  const v12 = (p3 - p1) * 0.5;
  const t22 = t2 * t2;
  const t3 = t2 * t22;
  return (2 * p1 - 2 * p2 + v0 + v12) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v12) * t22 + v0 * t2 + p1;
}
function QuadraticBezierP0(t2, p2) {
  const k2 = 1 - t2;
  return k2 * k2 * p2;
}
function QuadraticBezierP1(t2, p2) {
  return 2 * (1 - t2) * t2 * p2;
}
function QuadraticBezierP2(t2, p2) {
  return t2 * t2 * p2;
}
function QuadraticBezier(t2, p0, p1, p2) {
  return QuadraticBezierP0(t2, p0) + QuadraticBezierP1(t2, p1) + QuadraticBezierP2(t2, p2);
}
function CubicBezierP0(t2, p2) {
  const k2 = 1 - t2;
  return k2 * k2 * k2 * p2;
}
function CubicBezierP1(t2, p2) {
  const k2 = 1 - t2;
  return 3 * k2 * k2 * t2 * p2;
}
function CubicBezierP2(t2, p2) {
  return 3 * (1 - t2) * t2 * t2 * p2;
}
function CubicBezierP3(t2, p2) {
  return t2 * t2 * t2 * p2;
}
function CubicBezier(t2, p0, p1, p2, p3) {
  return CubicBezierP0(t2, p0) + CubicBezierP1(t2, p1) + CubicBezierP2(t2, p2) + CubicBezierP3(t2, p3);
}
class CubicBezierCurve extends Curve {
  constructor(v0 = new Vector2$1(), v12 = new Vector2$1(), v22 = new Vector2$1(), v32 = new Vector2$1()) {
    super();
    this.type = "CubicBezierCurve";
    this.v0 = v0;
    this.v1 = v12;
    this.v2 = v22;
    this.v3 = v32;
  }
  getPoint(t2, optionalTarget = new Vector2$1()) {
    const point4 = optionalTarget;
    const v0 = this.v0, v12 = this.v1, v22 = this.v2, v32 = this.v3;
    point4.set(
      CubicBezier(t2, v0.x, v12.x, v22.x, v32.x),
      CubicBezier(t2, v0.y, v12.y, v22.y, v32.y)
    );
    return point4;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.v0 = this.v0.toArray();
    data2.v1 = this.v1.toArray();
    data2.v2 = this.v2.toArray();
    data2.v3 = this.v3.toArray();
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
CubicBezierCurve.prototype.isCubicBezierCurve = true;
class CubicBezierCurve3 extends Curve {
  constructor(v0 = new Vector3$1(), v12 = new Vector3$1(), v22 = new Vector3$1(), v32 = new Vector3$1()) {
    super();
    this.type = "CubicBezierCurve3";
    this.v0 = v0;
    this.v1 = v12;
    this.v2 = v22;
    this.v3 = v32;
  }
  getPoint(t2, optionalTarget = new Vector3$1()) {
    const point4 = optionalTarget;
    const v0 = this.v0, v12 = this.v1, v22 = this.v2, v32 = this.v3;
    point4.set(
      CubicBezier(t2, v0.x, v12.x, v22.x, v32.x),
      CubicBezier(t2, v0.y, v12.y, v22.y, v32.y),
      CubicBezier(t2, v0.z, v12.z, v22.z, v32.z)
    );
    return point4;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.v0 = this.v0.toArray();
    data2.v1 = this.v1.toArray();
    data2.v2 = this.v2.toArray();
    data2.v3 = this.v3.toArray();
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
  }
}
CubicBezierCurve3.prototype.isCubicBezierCurve3 = true;
class LineCurve extends Curve {
  constructor(v12 = new Vector2$1(), v22 = new Vector2$1()) {
    super();
    this.type = "LineCurve";
    this.v1 = v12;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector2$1()) {
    const point4 = optionalTarget;
    if (t2 === 1) {
      point4.copy(this.v2);
    } else {
      point4.copy(this.v2).sub(this.v1);
      point4.multiplyScalar(t2).add(this.v1);
    }
    return point4;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u2, optionalTarget) {
    return this.getPoint(u2, optionalTarget);
  }
  getTangent(t2, optionalTarget) {
    const tangent = optionalTarget || new Vector2$1();
    tangent.copy(this.v2).sub(this.v1).normalize();
    return tangent;
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.v1 = this.v1.toArray();
    data2.v2 = this.v2.toArray();
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
LineCurve.prototype.isLineCurve = true;
class LineCurve3 extends Curve {
  constructor(v12 = new Vector3$1(), v22 = new Vector3$1()) {
    super();
    this.type = "LineCurve3";
    this.isLineCurve3 = true;
    this.v1 = v12;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector3$1()) {
    const point4 = optionalTarget;
    if (t2 === 1) {
      point4.copy(this.v2);
    } else {
      point4.copy(this.v2).sub(this.v1);
      point4.multiplyScalar(t2).add(this.v1);
    }
    return point4;
  }
  // Line curve is linear, so we can overwrite default getPointAt
  getPointAt(u2, optionalTarget) {
    return this.getPoint(u2, optionalTarget);
  }
  copy(source) {
    super.copy(source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.v1 = this.v1.toArray();
    data2.v2 = this.v2.toArray();
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
class QuadraticBezierCurve extends Curve {
  constructor(v0 = new Vector2$1(), v12 = new Vector2$1(), v22 = new Vector2$1()) {
    super();
    this.type = "QuadraticBezierCurve";
    this.v0 = v0;
    this.v1 = v12;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector2$1()) {
    const point4 = optionalTarget;
    const v0 = this.v0, v12 = this.v1, v22 = this.v2;
    point4.set(
      QuadraticBezier(t2, v0.x, v12.x, v22.x),
      QuadraticBezier(t2, v0.y, v12.y, v22.y)
    );
    return point4;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.v0 = this.v0.toArray();
    data2.v1 = this.v1.toArray();
    data2.v2 = this.v2.toArray();
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
QuadraticBezierCurve.prototype.isQuadraticBezierCurve = true;
class QuadraticBezierCurve3 extends Curve {
  constructor(v0 = new Vector3$1(), v12 = new Vector3$1(), v22 = new Vector3$1()) {
    super();
    this.type = "QuadraticBezierCurve3";
    this.v0 = v0;
    this.v1 = v12;
    this.v2 = v22;
  }
  getPoint(t2, optionalTarget = new Vector3$1()) {
    const point4 = optionalTarget;
    const v0 = this.v0, v12 = this.v1, v22 = this.v2;
    point4.set(
      QuadraticBezier(t2, v0.x, v12.x, v22.x),
      QuadraticBezier(t2, v0.y, v12.y, v22.y),
      QuadraticBezier(t2, v0.z, v12.z, v22.z)
    );
    return point4;
  }
  copy(source) {
    super.copy(source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.v0 = this.v0.toArray();
    data2.v1 = this.v1.toArray();
    data2.v2 = this.v2.toArray();
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
  }
}
QuadraticBezierCurve3.prototype.isQuadraticBezierCurve3 = true;
class SplineCurve extends Curve {
  constructor(points2 = []) {
    super();
    this.type = "SplineCurve";
    this.points = points2;
  }
  getPoint(t2, optionalTarget = new Vector2$1()) {
    const point4 = optionalTarget;
    const points2 = this.points;
    const p2 = (points2.length - 1) * t2;
    const intPoint = Math.floor(p2);
    const weight = p2 - intPoint;
    const p0 = points2[intPoint === 0 ? intPoint : intPoint - 1];
    const p1 = points2[intPoint];
    const p22 = points2[intPoint > points2.length - 2 ? points2.length - 1 : intPoint + 1];
    const p3 = points2[intPoint > points2.length - 3 ? points2.length - 1 : intPoint + 2];
    point4.set(
      CatmullRom(weight, p0.x, p1.x, p22.x, p3.x),
      CatmullRom(weight, p0.y, p1.y, p22.y, p3.y)
    );
    return point4;
  }
  copy(source) {
    super.copy(source);
    this.points = [];
    for (let i2 = 0, l2 = source.points.length; i2 < l2; i2++) {
      const point4 = source.points[i2];
      this.points.push(point4.clone());
    }
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.points = [];
    for (let i2 = 0, l2 = this.points.length; i2 < l2; i2++) {
      const point4 = this.points[i2];
      data2.points.push(point4.toArray());
    }
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.points = [];
    for (let i2 = 0, l2 = json.points.length; i2 < l2; i2++) {
      const point4 = json.points[i2];
      this.points.push(new Vector2$1().fromArray(point4));
    }
    return this;
  }
}
SplineCurve.prototype.isSplineCurve = true;
var Curves = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcCurve,
  CatmullRomCurve3,
  CubicBezierCurve,
  CubicBezierCurve3,
  EllipseCurve,
  LineCurve,
  LineCurve3,
  QuadraticBezierCurve,
  QuadraticBezierCurve3,
  SplineCurve
});
class CurvePath extends Curve {
  constructor() {
    super();
    this.type = "CurvePath";
    this.curves = [];
    this.autoClose = false;
  }
  add(curve) {
    this.curves.push(curve);
  }
  closePath() {
    const startPoint = this.curves[0].getPoint(0);
    const endPoint = this.curves[this.curves.length - 1].getPoint(1);
    if (!startPoint.equals(endPoint)) {
      this.curves.push(new LineCurve(endPoint, startPoint));
    }
  }
  // To get accurate point with reference to
  // entire path distance at time t,
  // following has to be done:
  // 1. Length of each sub path have to be known
  // 2. Locate and identify type of curve
  // 3. Get t for the curve
  // 4. Return curve.getPointAt(t')
  getPoint(t2, optionalTarget) {
    const d2 = t2 * this.getLength();
    const curveLengths = this.getCurveLengths();
    let i2 = 0;
    while (i2 < curveLengths.length) {
      if (curveLengths[i2] >= d2) {
        const diff2 = curveLengths[i2] - d2;
        const curve = this.curves[i2];
        const segmentLength = curve.getLength();
        const u2 = segmentLength === 0 ? 0 : 1 - diff2 / segmentLength;
        return curve.getPointAt(u2, optionalTarget);
      }
      i2++;
    }
    return null;
  }
  // We cannot use the default THREE.Curve getPoint() with getLength() because in
  // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
  // getPoint() depends on getLength
  getLength() {
    const lens = this.getCurveLengths();
    return lens[lens.length - 1];
  }
  // cacheLengths must be recalculated.
  updateArcLengths() {
    this.needsUpdate = true;
    this.cacheLengths = null;
    this.getCurveLengths();
  }
  // Compute lengths and cache them
  // We cannot overwrite getLengths() because UtoT mapping uses it.
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
      return this.cacheLengths;
    }
    const lengths = [];
    let sums = 0;
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      sums += this.curves[i2].getLength();
      lengths.push(sums);
    }
    this.cacheLengths = lengths;
    return lengths;
  }
  getSpacedPoints(divisions = 40) {
    const points2 = [];
    for (let i2 = 0; i2 <= divisions; i2++) {
      points2.push(this.getPoint(i2 / divisions));
    }
    if (this.autoClose) {
      points2.push(points2[0]);
    }
    return points2;
  }
  getPoints(divisions = 12) {
    const points2 = [];
    let last;
    for (let i2 = 0, curves = this.curves; i2 < curves.length; i2++) {
      const curve = curves[i2];
      const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
      const pts = curve.getPoints(resolution);
      for (let j2 = 0; j2 < pts.length; j2++) {
        const point4 = pts[j2];
        if (last && last.equals(point4))
          continue;
        points2.push(point4);
        last = point4;
      }
    }
    if (this.autoClose && points2.length > 1 && !points2[points2.length - 1].equals(points2[0])) {
      points2.push(points2[0]);
    }
    return points2;
  }
  copy(source) {
    super.copy(source);
    this.curves = [];
    for (let i2 = 0, l2 = source.curves.length; i2 < l2; i2++) {
      const curve = source.curves[i2];
      this.curves.push(curve.clone());
    }
    this.autoClose = source.autoClose;
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.autoClose = this.autoClose;
    data2.curves = [];
    for (let i2 = 0, l2 = this.curves.length; i2 < l2; i2++) {
      const curve = this.curves[i2];
      data2.curves.push(curve.toJSON());
    }
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.autoClose = json.autoClose;
    this.curves = [];
    for (let i2 = 0, l2 = json.curves.length; i2 < l2; i2++) {
      const curve = json.curves[i2];
      this.curves.push(new Curves[curve.type]().fromJSON(curve));
    }
    return this;
  }
}
class Path extends CurvePath {
  constructor(points2) {
    super();
    this.type = "Path";
    this.currentPoint = new Vector2$1();
    if (points2) {
      this.setFromPoints(points2);
    }
  }
  setFromPoints(points2) {
    this.moveTo(points2[0].x, points2[0].y);
    for (let i2 = 1, l2 = points2.length; i2 < l2; i2++) {
      this.lineTo(points2[i2].x, points2[i2].y);
    }
    return this;
  }
  moveTo(x2, y2) {
    this.currentPoint.set(x2, y2);
    return this;
  }
  lineTo(x2, y2) {
    const curve = new LineCurve(this.currentPoint.clone(), new Vector2$1(x2, y2));
    this.curves.push(curve);
    this.currentPoint.set(x2, y2);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX2, aY2) {
    const curve = new QuadraticBezierCurve(
      this.currentPoint.clone(),
      new Vector2$1(aCPx, aCPy),
      new Vector2$1(aX2, aY2)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX2, aY2);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX2, aY2) {
    const curve = new CubicBezierCurve(
      this.currentPoint.clone(),
      new Vector2$1(aCP1x, aCP1y),
      new Vector2$1(aCP2x, aCP2y),
      new Vector2$1(aX2, aY2)
    );
    this.curves.push(curve);
    this.currentPoint.set(aX2, aY2);
    return this;
  }
  splineThru(pts) {
    const npts = [this.currentPoint.clone()].concat(pts);
    const curve = new SplineCurve(npts);
    this.curves.push(curve);
    this.currentPoint.copy(pts[pts.length - 1]);
    return this;
  }
  arc(aX2, aY2, aRadius, aStartAngle, aEndAngle, aClockwise) {
    const x02 = this.currentPoint.x;
    const y02 = this.currentPoint.y;
    this.absarc(
      aX2 + x02,
      aY2 + y02,
      aRadius,
      aStartAngle,
      aEndAngle,
      aClockwise
    );
    return this;
  }
  absarc(aX2, aY2, aRadius, aStartAngle, aEndAngle, aClockwise) {
    this.absellipse(aX2, aY2, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    return this;
  }
  ellipse(aX2, aY2, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const x02 = this.currentPoint.x;
    const y02 = this.currentPoint.y;
    this.absellipse(aX2 + x02, aY2 + y02, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    return this;
  }
  absellipse(aX2, aY2, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    const curve = new EllipseCurve(aX2, aY2, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
    if (this.curves.length > 0) {
      const firstPoint = curve.getPoint(0);
      if (!firstPoint.equals(this.currentPoint)) {
        this.lineTo(firstPoint.x, firstPoint.y);
      }
    }
    this.curves.push(curve);
    const lastPoint = curve.getPoint(1);
    this.currentPoint.copy(lastPoint);
    return this;
  }
  copy(source) {
    super.copy(source);
    this.currentPoint.copy(source.currentPoint);
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.currentPoint = this.currentPoint.toArray();
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.currentPoint.fromArray(json.currentPoint);
    return this;
  }
}
class LatheGeometry extends BufferGeometry {
  constructor(points2 = [new Vector2$1(0, 0.5), new Vector2$1(0.5, 0), new Vector2$1(0, -0.5)], segments = 12, phiStart = 0, phiLength = Math.PI * 2) {
    super();
    this.type = "LatheGeometry";
    this.parameters = {
      points: points2,
      segments,
      phiStart,
      phiLength
    };
    segments = Math.floor(segments);
    phiLength = clamp$5(phiLength, 0, Math.PI * 2);
    const indices = [];
    const vertices = [];
    const uvs = [];
    const initNormals = [];
    const normals = [];
    const inverseSegments = 1 / segments;
    const vertex2 = new Vector3$1();
    const uv = new Vector2$1();
    const normal = new Vector3$1();
    const curNormal = new Vector3$1();
    const prevNormal = new Vector3$1();
    let dx = 0;
    let dy = 0;
    for (let j2 = 0; j2 <= points2.length - 1; j2++) {
      switch (j2) {
        case 0:
          dx = points2[j2 + 1].x - points2[j2].x;
          dy = points2[j2 + 1].y - points2[j2].y;
          normal.x = dy * 1;
          normal.y = -dx;
          normal.z = dy * 0;
          prevNormal.copy(normal);
          normal.normalize();
          initNormals.push(normal.x, normal.y, normal.z);
          break;
        case points2.length - 1:
          initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
          break;
        default:
          dx = points2[j2 + 1].x - points2[j2].x;
          dy = points2[j2 + 1].y - points2[j2].y;
          normal.x = dy * 1;
          normal.y = -dx;
          normal.z = dy * 0;
          curNormal.copy(normal);
          normal.x += prevNormal.x;
          normal.y += prevNormal.y;
          normal.z += prevNormal.z;
          normal.normalize();
          initNormals.push(normal.x, normal.y, normal.z);
          prevNormal.copy(curNormal);
      }
    }
    for (let i2 = 0; i2 <= segments; i2++) {
      const phi = phiStart + i2 * inverseSegments * phiLength;
      const sin2 = Math.sin(phi);
      const cos2 = Math.cos(phi);
      for (let j2 = 0; j2 <= points2.length - 1; j2++) {
        vertex2.x = points2[j2].x * sin2;
        vertex2.y = points2[j2].y;
        vertex2.z = points2[j2].x * cos2;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        uv.x = i2 / segments;
        uv.y = j2 / (points2.length - 1);
        uvs.push(uv.x, uv.y);
        const x2 = initNormals[3 * j2 + 0] * sin2;
        const y2 = initNormals[3 * j2 + 1];
        const z2 = initNormals[3 * j2 + 0] * cos2;
        normals.push(x2, y2, z2);
      }
    }
    for (let i2 = 0; i2 < segments; i2++) {
      for (let j2 = 0; j2 < points2.length - 1; j2++) {
        const base = j2 + i2 * points2.length;
        const a2 = base;
        const b2 = base + points2.length;
        const c2 = base + points2.length + 1;
        const d2 = base + 1;
        indices.push(a2, b2, d2);
        indices.push(c2, d2, b2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
  }
  static fromJSON(data2) {
    return new LatheGeometry(data2.points, data2.segments, data2.phiStart, data2.phiLength);
  }
}
class CapsuleGeometry extends LatheGeometry {
  constructor(radius = 1, length2 = 1, capSegments = 4, radialSegments = 8) {
    const path2 = new Path();
    path2.absarc(0, -length2 / 2, radius, Math.PI * 1.5, 0);
    path2.absarc(0, length2 / 2, radius, 0, Math.PI * 0.5);
    super(path2.getPoints(capSegments), radialSegments);
    this.type = "CapsuleGeometry";
    this.parameters = {
      radius,
      height: length2,
      capSegments,
      radialSegments
    };
  }
  static fromJSON(data2) {
    return new CapsuleGeometry(data2.radius, data2.length, data2.capSegments, data2.radialSegments);
  }
}
class CircleGeometry extends BufferGeometry {
  constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "CircleGeometry";
    this.parameters = {
      radius,
      segments,
      thetaStart,
      thetaLength
    };
    segments = Math.max(3, segments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const vertex2 = new Vector3$1();
    const uv = new Vector2$1();
    vertices.push(0, 0, 0);
    normals.push(0, 0, 1);
    uvs.push(0.5, 0.5);
    for (let s2 = 0, i2 = 3; s2 <= segments; s2++, i2 += 3) {
      const segment = thetaStart + s2 / segments * thetaLength;
      vertex2.x = radius * Math.cos(segment);
      vertex2.y = radius * Math.sin(segment);
      vertices.push(vertex2.x, vertex2.y, vertex2.z);
      normals.push(0, 0, 1);
      uv.x = (vertices[i2] / radius + 1) / 2;
      uv.y = (vertices[i2 + 1] / radius + 1) / 2;
      uvs.push(uv.x, uv.y);
    }
    for (let i2 = 1; i2 <= segments; i2++) {
      indices.push(i2, i2 + 1, 0);
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  static fromJSON(data2) {
    return new CircleGeometry(data2.radius, data2.segments, data2.thetaStart, data2.thetaLength);
  }
}
class CylinderGeometry extends BufferGeometry {
  constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "CylinderGeometry";
    this.parameters = {
      radiusTop,
      radiusBottom,
      height,
      radialSegments,
      heightSegments,
      openEnded,
      thetaStart,
      thetaLength
    };
    const scope = this;
    radialSegments = Math.floor(radialSegments);
    heightSegments = Math.floor(heightSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let index2 = 0;
    const indexArray = [];
    const halfHeight = height / 2;
    let groupStart = 0;
    generateTorso();
    if (openEnded === false) {
      if (radiusTop > 0)
        generateCap(true);
      if (radiusBottom > 0)
        generateCap(false);
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function generateTorso() {
      const normal = new Vector3$1();
      const vertex2 = new Vector3$1();
      let groupCount = 0;
      const slope = (radiusBottom - radiusTop) / height;
      for (let y2 = 0; y2 <= heightSegments; y2++) {
        const indexRow = [];
        const v5 = y2 / heightSegments;
        const radius = v5 * (radiusBottom - radiusTop) + radiusTop;
        for (let x2 = 0; x2 <= radialSegments; x2++) {
          const u2 = x2 / radialSegments;
          const theta = u2 * thetaLength + thetaStart;
          const sinTheta = Math.sin(theta);
          const cosTheta = Math.cos(theta);
          vertex2.x = radius * sinTheta;
          vertex2.y = -v5 * height + halfHeight;
          vertex2.z = radius * cosTheta;
          vertices.push(vertex2.x, vertex2.y, vertex2.z);
          normal.set(sinTheta, slope, cosTheta).normalize();
          normals.push(normal.x, normal.y, normal.z);
          uvs.push(u2, 1 - v5);
          indexRow.push(index2++);
        }
        indexArray.push(indexRow);
      }
      for (let x2 = 0; x2 < radialSegments; x2++) {
        for (let y2 = 0; y2 < heightSegments; y2++) {
          const a2 = indexArray[y2][x2];
          const b2 = indexArray[y2 + 1][x2];
          const c2 = indexArray[y2 + 1][x2 + 1];
          const d2 = indexArray[y2][x2 + 1];
          indices.push(a2, b2, d2);
          indices.push(b2, c2, d2);
          groupCount += 6;
        }
      }
      scope.addGroup(groupStart, groupCount, 0);
      groupStart += groupCount;
    }
    function generateCap(top) {
      const centerIndexStart = index2;
      const uv = new Vector2$1();
      const vertex2 = new Vector3$1();
      let groupCount = 0;
      const radius = top === true ? radiusTop : radiusBottom;
      const sign2 = top === true ? 1 : -1;
      for (let x2 = 1; x2 <= radialSegments; x2++) {
        vertices.push(0, halfHeight * sign2, 0);
        normals.push(0, sign2, 0);
        uvs.push(0.5, 0.5);
        index2++;
      }
      const centerIndexEnd = index2;
      for (let x2 = 0; x2 <= radialSegments; x2++) {
        const u2 = x2 / radialSegments;
        const theta = u2 * thetaLength + thetaStart;
        const cosTheta = Math.cos(theta);
        const sinTheta = Math.sin(theta);
        vertex2.x = radius * sinTheta;
        vertex2.y = halfHeight * sign2;
        vertex2.z = radius * cosTheta;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normals.push(0, sign2, 0);
        uv.x = cosTheta * 0.5 + 0.5;
        uv.y = sinTheta * 0.5 * sign2 + 0.5;
        uvs.push(uv.x, uv.y);
        index2++;
      }
      for (let x2 = 0; x2 < radialSegments; x2++) {
        const c2 = centerIndexStart + x2;
        const i2 = centerIndexEnd + x2;
        if (top === true) {
          indices.push(i2, i2 + 1, c2);
        } else {
          indices.push(i2 + 1, i2, c2);
        }
        groupCount += 3;
      }
      scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
      groupStart += groupCount;
    }
  }
  static fromJSON(data2) {
    return new CylinderGeometry(data2.radiusTop, data2.radiusBottom, data2.height, data2.radialSegments, data2.heightSegments, data2.openEnded, data2.thetaStart, data2.thetaLength);
  }
}
class ConeGeometry extends CylinderGeometry {
  constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
    super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
    this.type = "ConeGeometry";
    this.parameters = {
      radius,
      height,
      radialSegments,
      heightSegments,
      openEnded,
      thetaStart,
      thetaLength
    };
  }
  static fromJSON(data2) {
    return new ConeGeometry(data2.radius, data2.height, data2.radialSegments, data2.heightSegments, data2.openEnded, data2.thetaStart, data2.thetaLength);
  }
}
class PolyhedronGeometry extends BufferGeometry {
  constructor(vertices = [], indices = [], radius = 1, detail = 0) {
    super();
    this.type = "PolyhedronGeometry";
    this.parameters = {
      vertices,
      indices,
      radius,
      detail
    };
    const vertexBuffer = [];
    const uvBuffer = [];
    subdivide(detail);
    applyRadius(radius);
    generateUVs();
    this.setAttribute("position", new Float32BufferAttribute(vertexBuffer, 3));
    this.setAttribute("normal", new Float32BufferAttribute(vertexBuffer.slice(), 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvBuffer, 2));
    if (detail === 0) {
      this.computeVertexNormals();
    } else {
      this.normalizeNormals();
    }
    function subdivide(detail2) {
      const a2 = new Vector3$1();
      const b2 = new Vector3$1();
      const c2 = new Vector3$1();
      for (let i2 = 0; i2 < indices.length; i2 += 3) {
        getVertexByIndex(indices[i2 + 0], a2);
        getVertexByIndex(indices[i2 + 1], b2);
        getVertexByIndex(indices[i2 + 2], c2);
        subdivideFace(a2, b2, c2, detail2);
      }
    }
    function subdivideFace(a2, b2, c2, detail2) {
      const cols = detail2 + 1;
      const v5 = [];
      for (let i2 = 0; i2 <= cols; i2++) {
        v5[i2] = [];
        const aj2 = a2.clone().lerp(c2, i2 / cols);
        const bj2 = b2.clone().lerp(c2, i2 / cols);
        const rows = cols - i2;
        for (let j2 = 0; j2 <= rows; j2++) {
          if (j2 === 0 && i2 === cols) {
            v5[i2][j2] = aj2;
          } else {
            v5[i2][j2] = aj2.clone().lerp(bj2, j2 / rows);
          }
        }
      }
      for (let i2 = 0; i2 < cols; i2++) {
        for (let j2 = 0; j2 < 2 * (cols - i2) - 1; j2++) {
          const k2 = Math.floor(j2 / 2);
          if (j2 % 2 === 0) {
            pushVertex(v5[i2][k2 + 1]);
            pushVertex(v5[i2 + 1][k2]);
            pushVertex(v5[i2][k2]);
          } else {
            pushVertex(v5[i2][k2 + 1]);
            pushVertex(v5[i2 + 1][k2 + 1]);
            pushVertex(v5[i2 + 1][k2]);
          }
        }
      }
    }
    function applyRadius(radius2) {
      const vertex2 = new Vector3$1();
      for (let i2 = 0; i2 < vertexBuffer.length; i2 += 3) {
        vertex2.x = vertexBuffer[i2 + 0];
        vertex2.y = vertexBuffer[i2 + 1];
        vertex2.z = vertexBuffer[i2 + 2];
        vertex2.normalize().multiplyScalar(radius2);
        vertexBuffer[i2 + 0] = vertex2.x;
        vertexBuffer[i2 + 1] = vertex2.y;
        vertexBuffer[i2 + 2] = vertex2.z;
      }
    }
    function generateUVs() {
      const vertex2 = new Vector3$1();
      for (let i2 = 0; i2 < vertexBuffer.length; i2 += 3) {
        vertex2.x = vertexBuffer[i2 + 0];
        vertex2.y = vertexBuffer[i2 + 1];
        vertex2.z = vertexBuffer[i2 + 2];
        const u2 = azimuth(vertex2) / 2 / Math.PI + 0.5;
        const v5 = inclination(vertex2) / Math.PI + 0.5;
        uvBuffer.push(u2, 1 - v5);
      }
      correctUVs();
      correctSeam();
    }
    function correctSeam() {
      for (let i2 = 0; i2 < uvBuffer.length; i2 += 6) {
        const x02 = uvBuffer[i2 + 0];
        const x12 = uvBuffer[i2 + 2];
        const x2 = uvBuffer[i2 + 4];
        const max3 = Math.max(x02, x12, x2);
        const min4 = Math.min(x02, x12, x2);
        if (max3 > 0.9 && min4 < 0.1) {
          if (x02 < 0.2)
            uvBuffer[i2 + 0] += 1;
          if (x12 < 0.2)
            uvBuffer[i2 + 2] += 1;
          if (x2 < 0.2)
            uvBuffer[i2 + 4] += 1;
        }
      }
    }
    function pushVertex(vertex2) {
      vertexBuffer.push(vertex2.x, vertex2.y, vertex2.z);
    }
    function getVertexByIndex(index2, vertex2) {
      const stride = index2 * 3;
      vertex2.x = vertices[stride + 0];
      vertex2.y = vertices[stride + 1];
      vertex2.z = vertices[stride + 2];
    }
    function correctUVs() {
      const a2 = new Vector3$1();
      const b2 = new Vector3$1();
      const c2 = new Vector3$1();
      const centroid4 = new Vector3$1();
      const uvA = new Vector2$1();
      const uvB = new Vector2$1();
      const uvC = new Vector2$1();
      for (let i2 = 0, j2 = 0; i2 < vertexBuffer.length; i2 += 9, j2 += 6) {
        a2.set(vertexBuffer[i2 + 0], vertexBuffer[i2 + 1], vertexBuffer[i2 + 2]);
        b2.set(vertexBuffer[i2 + 3], vertexBuffer[i2 + 4], vertexBuffer[i2 + 5]);
        c2.set(vertexBuffer[i2 + 6], vertexBuffer[i2 + 7], vertexBuffer[i2 + 8]);
        uvA.set(uvBuffer[j2 + 0], uvBuffer[j2 + 1]);
        uvB.set(uvBuffer[j2 + 2], uvBuffer[j2 + 3]);
        uvC.set(uvBuffer[j2 + 4], uvBuffer[j2 + 5]);
        centroid4.copy(a2).add(b2).add(c2).divideScalar(3);
        const azi = azimuth(centroid4);
        correctUV(uvA, j2 + 0, a2, azi);
        correctUV(uvB, j2 + 2, b2, azi);
        correctUV(uvC, j2 + 4, c2, azi);
      }
    }
    function correctUV(uv, stride, vector, azimuth2) {
      if (azimuth2 < 0 && uv.x === 1) {
        uvBuffer[stride] = uv.x - 1;
      }
      if (vector.x === 0 && vector.z === 0) {
        uvBuffer[stride] = azimuth2 / 2 / Math.PI + 0.5;
      }
    }
    function azimuth(vector) {
      return Math.atan2(vector.z, -vector.x);
    }
    function inclination(vector) {
      return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
    }
  }
  static fromJSON(data2) {
    return new PolyhedronGeometry(data2.vertices, data2.indices, data2.radius, data2.details);
  }
}
class DodecahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const t2 = (1 + Math.sqrt(5)) / 2;
    const r2 = 1 / t2;
    const vertices = [
      // (±1, ±1, ±1)
      -1,
      -1,
      -1,
      -1,
      -1,
      1,
      -1,
      1,
      -1,
      -1,
      1,
      1,
      1,
      -1,
      -1,
      1,
      -1,
      1,
      1,
      1,
      -1,
      1,
      1,
      1,
      // (0, ±1/φ, ±φ)
      0,
      -r2,
      -t2,
      0,
      -r2,
      t2,
      0,
      r2,
      -t2,
      0,
      r2,
      t2,
      // (±1/φ, ±φ, 0)
      -r2,
      -t2,
      0,
      -r2,
      t2,
      0,
      r2,
      -t2,
      0,
      r2,
      t2,
      0,
      // (±φ, 0, ±1/φ)
      -t2,
      0,
      -r2,
      t2,
      0,
      -r2,
      -t2,
      0,
      r2,
      t2,
      0,
      r2
    ];
    const indices = [
      3,
      11,
      7,
      3,
      7,
      15,
      3,
      15,
      13,
      7,
      19,
      17,
      7,
      17,
      6,
      7,
      6,
      15,
      17,
      4,
      8,
      17,
      8,
      10,
      17,
      10,
      6,
      8,
      0,
      16,
      8,
      16,
      2,
      8,
      2,
      10,
      0,
      12,
      1,
      0,
      1,
      18,
      0,
      18,
      16,
      6,
      10,
      2,
      6,
      2,
      13,
      6,
      13,
      15,
      2,
      16,
      18,
      2,
      18,
      3,
      2,
      3,
      13,
      18,
      1,
      9,
      18,
      9,
      11,
      18,
      11,
      3,
      4,
      14,
      12,
      4,
      12,
      0,
      4,
      0,
      8,
      11,
      9,
      5,
      11,
      5,
      19,
      11,
      19,
      7,
      19,
      5,
      14,
      19,
      14,
      4,
      19,
      4,
      17,
      1,
      12,
      14,
      1,
      14,
      5,
      1,
      5,
      9
    ];
    super(vertices, indices, radius, detail);
    this.type = "DodecahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data2) {
    return new DodecahedronGeometry(data2.radius, data2.detail);
  }
}
const _v0 = new Vector3$1();
const _v1$1 = new Vector3$1();
const _normal = new Vector3$1();
const _triangle = new Triangle();
class EdgesGeometry extends BufferGeometry {
  constructor(geometry2 = null, thresholdAngle = 1) {
    super();
    this.type = "EdgesGeometry";
    this.parameters = {
      geometry: geometry2,
      thresholdAngle
    };
    if (geometry2 !== null) {
      const precisionPoints = 4;
      const precision = Math.pow(10, precisionPoints);
      const thresholdDot = Math.cos(DEG2RAD$1 * thresholdAngle);
      const indexAttr = geometry2.getIndex();
      const positionAttr = geometry2.getAttribute("position");
      const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
      const indexArr = [0, 0, 0];
      const vertKeys = ["a", "b", "c"];
      const hashes = new Array(3);
      const edgeData = {};
      const vertices = [];
      for (let i2 = 0; i2 < indexCount; i2 += 3) {
        if (indexAttr) {
          indexArr[0] = indexAttr.getX(i2);
          indexArr[1] = indexAttr.getX(i2 + 1);
          indexArr[2] = indexAttr.getX(i2 + 2);
        } else {
          indexArr[0] = i2;
          indexArr[1] = i2 + 1;
          indexArr[2] = i2 + 2;
        }
        const { a: a2, b: b2, c: c2 } = _triangle;
        a2.fromBufferAttribute(positionAttr, indexArr[0]);
        b2.fromBufferAttribute(positionAttr, indexArr[1]);
        c2.fromBufferAttribute(positionAttr, indexArr[2]);
        _triangle.getNormal(_normal);
        hashes[0] = `${Math.round(a2.x * precision)},${Math.round(a2.y * precision)},${Math.round(a2.z * precision)}`;
        hashes[1] = `${Math.round(b2.x * precision)},${Math.round(b2.y * precision)},${Math.round(b2.z * precision)}`;
        hashes[2] = `${Math.round(c2.x * precision)},${Math.round(c2.y * precision)},${Math.round(c2.z * precision)}`;
        if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) {
          continue;
        }
        for (let j2 = 0; j2 < 3; j2++) {
          const jNext = (j2 + 1) % 3;
          const vecHash0 = hashes[j2];
          const vecHash1 = hashes[jNext];
          const v0 = _triangle[vertKeys[j2]];
          const v12 = _triangle[vertKeys[jNext]];
          const hash = `${vecHash0}_${vecHash1}`;
          const reverseHash = `${vecHash1}_${vecHash0}`;
          if (reverseHash in edgeData && edgeData[reverseHash]) {
            if (_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
              vertices.push(v0.x, v0.y, v0.z);
              vertices.push(v12.x, v12.y, v12.z);
            }
            edgeData[reverseHash] = null;
          } else if (!(hash in edgeData)) {
            edgeData[hash] = {
              index0: indexArr[j2],
              index1: indexArr[jNext],
              normal: _normal.clone()
            };
          }
        }
      }
      for (const key in edgeData) {
        if (edgeData[key]) {
          const { index0, index1 } = edgeData[key];
          _v0.fromBufferAttribute(positionAttr, index0);
          _v1$1.fromBufferAttribute(positionAttr, index1);
          vertices.push(_v0.x, _v0.y, _v0.z);
          vertices.push(_v1$1.x, _v1$1.y, _v1$1.z);
        }
      }
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    }
  }
}
class Shape extends Path {
  constructor(points2) {
    super(points2);
    this.uuid = generateUUID();
    this.type = "Shape";
    this.holes = [];
  }
  getPointsHoles(divisions) {
    const holesPts = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      holesPts[i2] = this.holes[i2].getPoints(divisions);
    }
    return holesPts;
  }
  // get points of shape and holes (keypoints based on segments parameter)
  extractPoints(divisions) {
    return {
      shape: this.getPoints(divisions),
      holes: this.getPointsHoles(divisions)
    };
  }
  copy(source) {
    super.copy(source);
    this.holes = [];
    for (let i2 = 0, l2 = source.holes.length; i2 < l2; i2++) {
      const hole = source.holes[i2];
      this.holes.push(hole.clone());
    }
    return this;
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.uuid = this.uuid;
    data2.holes = [];
    for (let i2 = 0, l2 = this.holes.length; i2 < l2; i2++) {
      const hole = this.holes[i2];
      data2.holes.push(hole.toJSON());
    }
    return data2;
  }
  fromJSON(json) {
    super.fromJSON(json);
    this.uuid = json.uuid;
    this.holes = [];
    for (let i2 = 0, l2 = json.holes.length; i2 < l2; i2++) {
      const hole = json.holes[i2];
      this.holes.push(new Path().fromJSON(hole));
    }
    return this;
  }
}
const Earcut = {
  triangulate: function(data2, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data2.length;
    let outerNode = linkedList$1(data2, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev)
      return triangles;
    let minX2, minY2, maxX2, maxY2, x2, y2, invSize;
    if (hasHoles)
      outerNode = eliminateHoles$1(data2, holeIndices, outerNode, dim);
    if (data2.length > 80 * dim) {
      minX2 = maxX2 = data2[0];
      minY2 = maxY2 = data2[1];
      for (let i2 = dim; i2 < outerLen; i2 += dim) {
        x2 = data2[i2];
        y2 = data2[i2 + 1];
        if (x2 < minX2)
          minX2 = x2;
        if (y2 < minY2)
          minY2 = y2;
        if (x2 > maxX2)
          maxX2 = x2;
        if (y2 > maxY2)
          maxY2 = y2;
      }
      invSize = Math.max(maxX2 - minX2, maxY2 - minY2);
      invSize = invSize !== 0 ? 1 / invSize : 0;
    }
    earcutLinked$1(outerNode, triangles, dim, minX2, minY2, invSize);
    return triangles;
  }
};
function linkedList$1(data2, start2, end, dim, clockwise) {
  let i2, last;
  if (clockwise === signedArea$1(data2, start2, end, dim) > 0) {
    for (i2 = start2; i2 < end; i2 += dim)
      last = insertNode$1(i2, data2[i2], data2[i2 + 1], last);
  } else {
    for (i2 = end - dim; i2 >= start2; i2 -= dim)
      last = insertNode$1(i2, data2[i2], data2[i2 + 1], last);
  }
  if (last && equals$2(last, last.next)) {
    removeNode$1(last);
    last = last.next;
  }
  return last;
}
function filterPoints$1(start2, end) {
  if (!start2)
    return start2;
  if (!end)
    end = start2;
  let p2 = start2, again;
  do {
    again = false;
    if (!p2.steiner && (equals$2(p2, p2.next) || area$2(p2.prev, p2, p2.next) === 0)) {
      removeNode$1(p2);
      p2 = end = p2.prev;
      if (p2 === p2.next)
        break;
      again = true;
    } else {
      p2 = p2.next;
    }
  } while (again || p2 !== end);
  return end;
}
function earcutLinked$1(ear, triangles, dim, minX2, minY2, invSize, pass2) {
  if (!ear)
    return;
  if (!pass2 && invSize)
    indexCurve$1(ear, minX2, minY2, invSize);
  let stop = ear, prev, next5;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next5 = ear.next;
    if (invSize ? isEarHashed$1(ear, minX2, minY2, invSize) : isEar$1(ear)) {
      triangles.push(prev.i / dim);
      triangles.push(ear.i / dim);
      triangles.push(next5.i / dim);
      removeNode$1(ear);
      ear = next5.next;
      stop = next5.next;
      continue;
    }
    ear = next5;
    if (ear === stop) {
      if (!pass2) {
        earcutLinked$1(filterPoints$1(ear), triangles, dim, minX2, minY2, invSize, 1);
      } else if (pass2 === 1) {
        ear = cureLocalIntersections$1(filterPoints$1(ear), triangles, dim);
        earcutLinked$1(ear, triangles, dim, minX2, minY2, invSize, 2);
      } else if (pass2 === 2) {
        splitEarcut$1(ear, triangles, dim, minX2, minY2, invSize);
      }
      break;
    }
  }
}
function isEar$1(ear) {
  const a2 = ear.prev, b2 = ear, c2 = ear.next;
  if (area$2(a2, b2, c2) >= 0)
    return false;
  let p2 = ear.next.next;
  while (p2 !== ear.prev) {
    if (pointInTriangle$1(a2.x, a2.y, b2.x, b2.y, c2.x, c2.y, p2.x, p2.y) && area$2(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.next;
  }
  return true;
}
function isEarHashed$1(ear, minX2, minY2, invSize) {
  const a2 = ear.prev, b2 = ear, c2 = ear.next;
  if (area$2(a2, b2, c2) >= 0)
    return false;
  const minTX = a2.x < b2.x ? a2.x < c2.x ? a2.x : c2.x : b2.x < c2.x ? b2.x : c2.x, minTY = a2.y < b2.y ? a2.y < c2.y ? a2.y : c2.y : b2.y < c2.y ? b2.y : c2.y, maxTX = a2.x > b2.x ? a2.x > c2.x ? a2.x : c2.x : b2.x > c2.x ? b2.x : c2.x, maxTY = a2.y > b2.y ? a2.y > c2.y ? a2.y : c2.y : b2.y > c2.y ? b2.y : c2.y;
  const minZ = zOrder$1(minTX, minTY, minX2, minY2, invSize), maxZ = zOrder$1(maxTX, maxTY, minX2, minY2, invSize);
  let p2 = ear.prevZ, n2 = ear.nextZ;
  while (p2 && p2.z >= minZ && n2 && n2.z <= maxZ) {
    if (p2 !== ear.prev && p2 !== ear.next && pointInTriangle$1(a2.x, a2.y, b2.x, b2.y, c2.x, c2.y, p2.x, p2.y) && area$2(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
    if (n2 !== ear.prev && n2 !== ear.next && pointInTriangle$1(a2.x, a2.y, b2.x, b2.y, c2.x, c2.y, n2.x, n2.y) && area$2(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  while (p2 && p2.z >= minZ) {
    if (p2 !== ear.prev && p2 !== ear.next && pointInTriangle$1(a2.x, a2.y, b2.x, b2.y, c2.x, c2.y, p2.x, p2.y) && area$2(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
  }
  while (n2 && n2.z <= maxZ) {
    if (n2 !== ear.prev && n2 !== ear.next && pointInTriangle$1(a2.x, a2.y, b2.x, b2.y, c2.x, c2.y, n2.x, n2.y) && area$2(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  return true;
}
function cureLocalIntersections$1(start2, triangles, dim) {
  let p2 = start2;
  do {
    const a2 = p2.prev, b2 = p2.next.next;
    if (!equals$2(a2, b2) && intersects$3(a2, p2, p2.next, b2) && locallyInside$1(a2, b2) && locallyInside$1(b2, a2)) {
      triangles.push(a2.i / dim);
      triangles.push(p2.i / dim);
      triangles.push(b2.i / dim);
      removeNode$1(p2);
      removeNode$1(p2.next);
      p2 = start2 = b2;
    }
    p2 = p2.next;
  } while (p2 !== start2);
  return filterPoints$1(p2);
}
function splitEarcut$1(start2, triangles, dim, minX2, minY2, invSize) {
  let a2 = start2;
  do {
    let b2 = a2.next.next;
    while (b2 !== a2.prev) {
      if (a2.i !== b2.i && isValidDiagonal$1(a2, b2)) {
        let c2 = splitPolygon$1(a2, b2);
        a2 = filterPoints$1(a2, a2.next);
        c2 = filterPoints$1(c2, c2.next);
        earcutLinked$1(a2, triangles, dim, minX2, minY2, invSize);
        earcutLinked$1(c2, triangles, dim, minX2, minY2, invSize);
        return;
      }
      b2 = b2.next;
    }
    a2 = a2.next;
  } while (a2 !== start2);
}
function eliminateHoles$1(data2, holeIndices, outerNode, dim) {
  const queue = [];
  let i2, len2, start2, end, list2;
  for (i2 = 0, len2 = holeIndices.length; i2 < len2; i2++) {
    start2 = holeIndices[i2] * dim;
    end = i2 < len2 - 1 ? holeIndices[i2 + 1] * dim : data2.length;
    list2 = linkedList$1(data2, start2, end, dim, false);
    if (list2 === list2.next)
      list2.steiner = true;
    queue.push(getLeftmost$1(list2));
  }
  queue.sort(compareX$1);
  for (i2 = 0; i2 < queue.length; i2++) {
    eliminateHole$1(queue[i2], outerNode);
    outerNode = filterPoints$1(outerNode, outerNode.next);
  }
  return outerNode;
}
function compareX$1(a2, b2) {
  return a2.x - b2.x;
}
function eliminateHole$1(hole, outerNode) {
  outerNode = findHoleBridge$1(hole, outerNode);
  if (outerNode) {
    const b2 = splitPolygon$1(outerNode, hole);
    filterPoints$1(outerNode, outerNode.next);
    filterPoints$1(b2, b2.next);
  }
}
function findHoleBridge$1(hole, outerNode) {
  let p2 = outerNode;
  const hx = hole.x;
  const hy = hole.y;
  let qx = -Infinity, m2;
  do {
    if (hy <= p2.y && hy >= p2.next.y && p2.next.y !== p2.y) {
      const x2 = p2.x + (hy - p2.y) * (p2.next.x - p2.x) / (p2.next.y - p2.y);
      if (x2 <= hx && x2 > qx) {
        qx = x2;
        if (x2 === hx) {
          if (hy === p2.y)
            return p2;
          if (hy === p2.next.y)
            return p2.next;
        }
        m2 = p2.x < p2.next.x ? p2 : p2.next;
      }
    }
    p2 = p2.next;
  } while (p2 !== outerNode);
  if (!m2)
    return null;
  if (hx === qx)
    return m2;
  const stop = m2, mx = m2.x, my = m2.y;
  let tanMin = Infinity, tan;
  p2 = m2;
  do {
    if (hx >= p2.x && p2.x >= mx && hx !== p2.x && pointInTriangle$1(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p2.x, p2.y)) {
      tan = Math.abs(hy - p2.y) / (hx - p2.x);
      if (locallyInside$1(p2, hole) && (tan < tanMin || tan === tanMin && (p2.x > m2.x || p2.x === m2.x && sectorContainsSector$1(m2, p2)))) {
        m2 = p2;
        tanMin = tan;
      }
    }
    p2 = p2.next;
  } while (p2 !== stop);
  return m2;
}
function sectorContainsSector$1(m2, p2) {
  return area$2(m2.prev, m2, p2.prev) < 0 && area$2(p2.next, m2, m2.next) < 0;
}
function indexCurve$1(start2, minX2, minY2, invSize) {
  let p2 = start2;
  do {
    if (p2.z === null)
      p2.z = zOrder$1(p2.x, p2.y, minX2, minY2, invSize);
    p2.prevZ = p2.prev;
    p2.nextZ = p2.next;
    p2 = p2.next;
  } while (p2 !== start2);
  p2.prevZ.nextZ = null;
  p2.prevZ = null;
  sortLinked$1(p2);
}
function sortLinked$1(list2) {
  let i2, p2, q2, e3, tail, numMerges, pSize, qSize, inSize = 1;
  do {
    p2 = list2;
    list2 = null;
    tail = null;
    numMerges = 0;
    while (p2) {
      numMerges++;
      q2 = p2;
      pSize = 0;
      for (i2 = 0; i2 < inSize; i2++) {
        pSize++;
        q2 = q2.nextZ;
        if (!q2)
          break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q2) {
        if (pSize !== 0 && (qSize === 0 || !q2 || p2.z <= q2.z)) {
          e3 = p2;
          p2 = p2.nextZ;
          pSize--;
        } else {
          e3 = q2;
          q2 = q2.nextZ;
          qSize--;
        }
        if (tail)
          tail.nextZ = e3;
        else
          list2 = e3;
        e3.prevZ = tail;
        tail = e3;
      }
      p2 = q2;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list2;
}
function zOrder$1(x2, y2, minX2, minY2, invSize) {
  x2 = 32767 * (x2 - minX2) * invSize;
  y2 = 32767 * (y2 - minY2) * invSize;
  x2 = (x2 | x2 << 8) & 16711935;
  x2 = (x2 | x2 << 4) & 252645135;
  x2 = (x2 | x2 << 2) & 858993459;
  x2 = (x2 | x2 << 1) & 1431655765;
  y2 = (y2 | y2 << 8) & 16711935;
  y2 = (y2 | y2 << 4) & 252645135;
  y2 = (y2 | y2 << 2) & 858993459;
  y2 = (y2 | y2 << 1) & 1431655765;
  return x2 | y2 << 1;
}
function getLeftmost$1(start2) {
  let p2 = start2, leftmost = start2;
  do {
    if (p2.x < leftmost.x || p2.x === leftmost.x && p2.y < leftmost.y)
      leftmost = p2;
    p2 = p2.next;
  } while (p2 !== start2);
  return leftmost;
}
function pointInTriangle$1(ax2, ay2, bx2, by2, cx, cy, px2, py2) {
  return (cx - px2) * (ay2 - py2) - (ax2 - px2) * (cy - py2) >= 0 && (ax2 - px2) * (by2 - py2) - (bx2 - px2) * (ay2 - py2) >= 0 && (bx2 - px2) * (cy - py2) - (cx - px2) * (by2 - py2) >= 0;
}
function isValidDiagonal$1(a2, b2) {
  return a2.next.i !== b2.i && a2.prev.i !== b2.i && !intersectsPolygon$1(a2, b2) && // doesn't intersect other edges
  (locallyInside$1(a2, b2) && locallyInside$1(b2, a2) && middleInside$1(a2, b2) && // locally visible
  (area$2(a2.prev, a2, b2.prev) || area$2(a2, b2.prev, b2)) || // does not create opposite-facing sectors
  equals$2(a2, b2) && area$2(a2.prev, a2, a2.next) > 0 && area$2(b2.prev, b2, b2.next) > 0);
}
function area$2(p2, q2, r2) {
  return (q2.y - p2.y) * (r2.x - q2.x) - (q2.x - p2.x) * (r2.y - q2.y);
}
function equals$2(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function intersects$3(p1, q1, p2, q2) {
  const o1 = sign$2(area$2(p1, q1, p2));
  const o2 = sign$2(area$2(p1, q1, q2));
  const o3 = sign$2(area$2(p2, q2, p1));
  const o4 = sign$2(area$2(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4)
    return true;
  if (o1 === 0 && onSegment$1(p1, p2, q1))
    return true;
  if (o2 === 0 && onSegment$1(p1, q2, q1))
    return true;
  if (o3 === 0 && onSegment$1(p2, p1, q2))
    return true;
  if (o4 === 0 && onSegment$1(p2, q1, q2))
    return true;
  return false;
}
function onSegment$1(p2, q2, r2) {
  return q2.x <= Math.max(p2.x, r2.x) && q2.x >= Math.min(p2.x, r2.x) && q2.y <= Math.max(p2.y, r2.y) && q2.y >= Math.min(p2.y, r2.y);
}
function sign$2(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon$1(a2, b2) {
  let p2 = a2;
  do {
    if (p2.i !== a2.i && p2.next.i !== a2.i && p2.i !== b2.i && p2.next.i !== b2.i && intersects$3(p2, p2.next, a2, b2))
      return true;
    p2 = p2.next;
  } while (p2 !== a2);
  return false;
}
function locallyInside$1(a2, b2) {
  return area$2(a2.prev, a2, a2.next) < 0 ? area$2(a2, b2, a2.next) >= 0 && area$2(a2, a2.prev, b2) >= 0 : area$2(a2, b2, a2.prev) < 0 || area$2(a2, a2.next, b2) < 0;
}
function middleInside$1(a2, b2) {
  let p2 = a2, inside = false;
  const px2 = (a2.x + b2.x) / 2, py2 = (a2.y + b2.y) / 2;
  do {
    if (p2.y > py2 !== p2.next.y > py2 && p2.next.y !== p2.y && px2 < (p2.next.x - p2.x) * (py2 - p2.y) / (p2.next.y - p2.y) + p2.x)
      inside = !inside;
    p2 = p2.next;
  } while (p2 !== a2);
  return inside;
}
function splitPolygon$1(a2, b2) {
  const a22 = new Node$1(a2.i, a2.x, a2.y), b22 = new Node$1(b2.i, b2.x, b2.y), an2 = a2.next, bp2 = b2.prev;
  a2.next = b2;
  b2.prev = a2;
  a22.next = an2;
  an2.prev = a22;
  b22.next = a22;
  a22.prev = b22;
  bp2.next = b22;
  b22.prev = bp2;
  return b22;
}
function insertNode$1(i2, x2, y2, last) {
  const p2 = new Node$1(i2, x2, y2);
  if (!last) {
    p2.prev = p2;
    p2.next = p2;
  } else {
    p2.next = last.next;
    p2.prev = last;
    last.next.prev = p2;
    last.next = p2;
  }
  return p2;
}
function removeNode$1(p2) {
  p2.next.prev = p2.prev;
  p2.prev.next = p2.next;
  if (p2.prevZ)
    p2.prevZ.nextZ = p2.nextZ;
  if (p2.nextZ)
    p2.nextZ.prevZ = p2.prevZ;
}
function Node$1(i2, x2, y2) {
  this.i = i2;
  this.x = x2;
  this.y = y2;
  this.prev = null;
  this.next = null;
  this.z = null;
  this.prevZ = null;
  this.nextZ = null;
  this.steiner = false;
}
function signedArea$1(data2, start2, end, dim) {
  let sum2 = 0;
  for (let i2 = start2, j2 = end - dim; i2 < end; i2 += dim) {
    sum2 += (data2[j2] - data2[i2]) * (data2[i2 + 1] + data2[j2 + 1]);
    j2 = i2;
  }
  return sum2;
}
class ShapeUtils {
  // calculate area of the contour polygon
  static area(contour) {
    const n2 = contour.length;
    let a2 = 0;
    for (let p2 = n2 - 1, q2 = 0; q2 < n2; p2 = q2++) {
      a2 += contour[p2].x * contour[q2].y - contour[q2].x * contour[p2].y;
    }
    return a2 * 0.5;
  }
  static isClockWise(pts) {
    return ShapeUtils.area(pts) < 0;
  }
  static triangulateShape(contour, holes) {
    const vertices = [];
    const holeIndices = [];
    const faces2 = [];
    removeDupEndPts(contour);
    addContour(vertices, contour);
    let holeIndex = contour.length;
    holes.forEach(removeDupEndPts);
    for (let i2 = 0; i2 < holes.length; i2++) {
      holeIndices.push(holeIndex);
      holeIndex += holes[i2].length;
      addContour(vertices, holes[i2]);
    }
    const triangles = Earcut.triangulate(vertices, holeIndices);
    for (let i2 = 0; i2 < triangles.length; i2 += 3) {
      faces2.push(triangles.slice(i2, i2 + 3));
    }
    return faces2;
  }
}
function removeDupEndPts(points2) {
  const l2 = points2.length;
  if (l2 > 2 && points2[l2 - 1].equals(points2[0])) {
    points2.pop();
  }
}
function addContour(vertices, contour) {
  for (let i2 = 0; i2 < contour.length; i2++) {
    vertices.push(contour[i2].x);
    vertices.push(contour[i2].y);
  }
}
class ExtrudeGeometry extends BufferGeometry {
  constructor(shapes = new Shape([new Vector2$1(0.5, 0.5), new Vector2$1(-0.5, 0.5), new Vector2$1(-0.5, -0.5), new Vector2$1(0.5, -0.5)]), options2 = {}) {
    super();
    this.type = "ExtrudeGeometry";
    this.parameters = {
      shapes,
      options: options2
    };
    shapes = Array.isArray(shapes) ? shapes : [shapes];
    const scope = this;
    const verticesArray = [];
    const uvArray = [];
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape2 = shapes[i2];
      addShape(shape2);
    }
    this.setAttribute("position", new Float32BufferAttribute(verticesArray, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvArray, 2));
    this.computeVertexNormals();
    function addShape(shape2) {
      const placeholder2 = [];
      const curveSegments = options2.curveSegments !== void 0 ? options2.curveSegments : 12;
      const steps = options2.steps !== void 0 ? options2.steps : 1;
      let depth2 = options2.depth !== void 0 ? options2.depth : 1;
      let bevelEnabled = options2.bevelEnabled !== void 0 ? options2.bevelEnabled : true;
      let bevelThickness = options2.bevelThickness !== void 0 ? options2.bevelThickness : 0.2;
      let bevelSize = options2.bevelSize !== void 0 ? options2.bevelSize : bevelThickness - 0.1;
      let bevelOffset = options2.bevelOffset !== void 0 ? options2.bevelOffset : 0;
      let bevelSegments = options2.bevelSegments !== void 0 ? options2.bevelSegments : 3;
      const extrudePath = options2.extrudePath;
      const uvgen = options2.UVGenerator !== void 0 ? options2.UVGenerator : WorldUVGenerator;
      if (options2.amount !== void 0) {
        console.warn("THREE.ExtrudeBufferGeometry: amount has been renamed to depth.");
        depth2 = options2.amount;
      }
      let extrudePts, extrudeByPath = false;
      let splineTube, binormal, normal, position2;
      if (extrudePath) {
        extrudePts = extrudePath.getSpacedPoints(steps);
        extrudeByPath = true;
        bevelEnabled = false;
        splineTube = extrudePath.computeFrenetFrames(steps, false);
        binormal = new Vector3$1();
        normal = new Vector3$1();
        position2 = new Vector3$1();
      }
      if (!bevelEnabled) {
        bevelSegments = 0;
        bevelThickness = 0;
        bevelSize = 0;
        bevelOffset = 0;
      }
      const shapePoints = shape2.extractPoints(curveSegments);
      let vertices = shapePoints.shape;
      const holes = shapePoints.holes;
      const reverse4 = !ShapeUtils.isClockWise(vertices);
      if (reverse4) {
        vertices = vertices.reverse();
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          if (ShapeUtils.isClockWise(ahole)) {
            holes[h2] = ahole.reverse();
          }
        }
      }
      const faces2 = ShapeUtils.triangulateShape(vertices, holes);
      const contour = vertices;
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        vertices = vertices.concat(ahole);
      }
      function scalePt2(pt, vec, size12) {
        if (!vec)
          console.error("THREE.ExtrudeGeometry: vec does not exist");
        return vec.clone().multiplyScalar(size12).add(pt);
      }
      const vlen = vertices.length, flen = faces2.length;
      function getBevelVec(inPt, inPrev, inNext) {
        let v_trans_x, v_trans_y, shrink_by;
        const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
        const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
        const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
        const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
        if (Math.abs(collinear0) > Number.EPSILON) {
          const v_prev_len = Math.sqrt(v_prev_lensq);
          const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
          const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
          const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
          const ptNextShift_x = inNext.x - v_next_y / v_next_len;
          const ptNextShift_y = inNext.y + v_next_x / v_next_len;
          const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
          v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
          v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
          const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
          if (v_trans_lensq <= 2) {
            return new Vector2$1(v_trans_x, v_trans_y);
          } else {
            shrink_by = Math.sqrt(v_trans_lensq / 2);
          }
        } else {
          let direction_eq = false;
          if (v_prev_x > Number.EPSILON) {
            if (v_next_x > Number.EPSILON) {
              direction_eq = true;
            }
          } else {
            if (v_prev_x < -Number.EPSILON) {
              if (v_next_x < -Number.EPSILON) {
                direction_eq = true;
              }
            } else {
              if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                direction_eq = true;
              }
            }
          }
          if (direction_eq) {
            v_trans_x = -v_prev_y;
            v_trans_y = v_prev_x;
            shrink_by = Math.sqrt(v_prev_lensq);
          } else {
            v_trans_x = v_prev_x;
            v_trans_y = v_prev_y;
            shrink_by = Math.sqrt(v_prev_lensq / 2);
          }
        }
        return new Vector2$1(v_trans_x / shrink_by, v_trans_y / shrink_by);
      }
      const contourMovements = [];
      for (let i2 = 0, il = contour.length, j2 = il - 1, k2 = i2 + 1; i2 < il; i2++, j2++, k2++) {
        if (j2 === il)
          j2 = 0;
        if (k2 === il)
          k2 = 0;
        contourMovements[i2] = getBevelVec(contour[i2], contour[j2], contour[k2]);
      }
      const holesMovements = [];
      let oneHoleMovements, verticesMovements = contourMovements.concat();
      for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
        const ahole = holes[h2];
        oneHoleMovements = [];
        for (let i2 = 0, il = ahole.length, j2 = il - 1, k2 = i2 + 1; i2 < il; i2++, j2++, k2++) {
          if (j2 === il)
            j2 = 0;
          if (k2 === il)
            k2 = 0;
          oneHoleMovements[i2] = getBevelVec(ahole[i2], ahole[j2], ahole[k2]);
        }
        holesMovements.push(oneHoleMovements);
        verticesMovements = verticesMovements.concat(oneHoleMovements);
      }
      for (let b2 = 0; b2 < bevelSegments; b2++) {
        const t2 = b2 / bevelSegments;
        const z2 = bevelThickness * Math.cos(t2 * Math.PI / 2);
        const bs3 = bevelSize * Math.sin(t2 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs3);
          v5(vert.x, vert.y, -z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs3);
            v5(vert.x, vert.y, -z2);
          }
        }
      }
      const bs2 = bevelSize + bevelOffset;
      for (let i2 = 0; i2 < vlen; i2++) {
        const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs2) : vertices[i2];
        if (!extrudeByPath) {
          v5(vert.x, vert.y, 0);
        } else {
          normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
          binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
          position2.copy(extrudePts[0]).add(normal).add(binormal);
          v5(position2.x, position2.y, position2.z);
        }
      }
      for (let s2 = 1; s2 <= steps; s2++) {
        for (let i2 = 0; i2 < vlen; i2++) {
          const vert = bevelEnabled ? scalePt2(vertices[i2], verticesMovements[i2], bs2) : vertices[i2];
          if (!extrudeByPath) {
            v5(vert.x, vert.y, depth2 / steps * s2);
          } else {
            normal.copy(splineTube.normals[s2]).multiplyScalar(vert.x);
            binormal.copy(splineTube.binormals[s2]).multiplyScalar(vert.y);
            position2.copy(extrudePts[s2]).add(normal).add(binormal);
            v5(position2.x, position2.y, position2.z);
          }
        }
      }
      for (let b2 = bevelSegments - 1; b2 >= 0; b2--) {
        const t2 = b2 / bevelSegments;
        const z2 = bevelThickness * Math.cos(t2 * Math.PI / 2);
        const bs3 = bevelSize * Math.sin(t2 * Math.PI / 2) + bevelOffset;
        for (let i2 = 0, il = contour.length; i2 < il; i2++) {
          const vert = scalePt2(contour[i2], contourMovements[i2], bs3);
          v5(vert.x, vert.y, depth2 + z2);
        }
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          oneHoleMovements = holesMovements[h2];
          for (let i2 = 0, il = ahole.length; i2 < il; i2++) {
            const vert = scalePt2(ahole[i2], oneHoleMovements[i2], bs3);
            if (!extrudeByPath) {
              v5(vert.x, vert.y, depth2 + z2);
            } else {
              v5(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z2);
            }
          }
        }
      }
      buildLidFaces();
      buildSideFaces();
      function buildLidFaces() {
        const start2 = verticesArray.length / 3;
        if (bevelEnabled) {
          let layer = 0;
          let offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces2[i2];
            f3(face[2] + offset, face[1] + offset, face[0] + offset);
          }
          layer = steps + bevelSegments * 2;
          offset = vlen * layer;
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces2[i2];
            f3(face[0] + offset, face[1] + offset, face[2] + offset);
          }
        } else {
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces2[i2];
            f3(face[2], face[1], face[0]);
          }
          for (let i2 = 0; i2 < flen; i2++) {
            const face = faces2[i2];
            f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
          }
        }
        scope.addGroup(start2, verticesArray.length / 3 - start2, 0);
      }
      function buildSideFaces() {
        const start2 = verticesArray.length / 3;
        let layeroffset = 0;
        sidewalls(contour, layeroffset);
        layeroffset += contour.length;
        for (let h2 = 0, hl = holes.length; h2 < hl; h2++) {
          const ahole = holes[h2];
          sidewalls(ahole, layeroffset);
          layeroffset += ahole.length;
        }
        scope.addGroup(start2, verticesArray.length / 3 - start2, 1);
      }
      function sidewalls(contour2, layeroffset) {
        let i2 = contour2.length;
        while (--i2 >= 0) {
          const j2 = i2;
          let k2 = i2 - 1;
          if (k2 < 0)
            k2 = contour2.length - 1;
          for (let s2 = 0, sl = steps + bevelSegments * 2; s2 < sl; s2++) {
            const slen1 = vlen * s2;
            const slen2 = vlen * (s2 + 1);
            const a2 = layeroffset + j2 + slen1, b2 = layeroffset + k2 + slen1, c2 = layeroffset + k2 + slen2, d2 = layeroffset + j2 + slen2;
            f4(a2, b2, c2, d2);
          }
        }
      }
      function v5(x2, y2, z2) {
        placeholder2.push(x2);
        placeholder2.push(y2);
        placeholder2.push(z2);
      }
      function f3(a2, b2, c2) {
        addVertex(a2);
        addVertex(b2);
        addVertex(c2);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[2]);
      }
      function f4(a2, b2, c2, d2) {
        addVertex(a2);
        addVertex(b2);
        addVertex(d2);
        addVertex(b2);
        addVertex(c2);
        addVertex(d2);
        const nextIndex = verticesArray.length / 3;
        const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[3]);
        addUV(uvs[1]);
        addUV(uvs[2]);
        addUV(uvs[3]);
      }
      function addVertex(index2) {
        verticesArray.push(placeholder2[index2 * 3 + 0]);
        verticesArray.push(placeholder2[index2 * 3 + 1]);
        verticesArray.push(placeholder2[index2 * 3 + 2]);
      }
      function addUV(vector2) {
        uvArray.push(vector2.x);
        uvArray.push(vector2.y);
      }
    }
  }
  toJSON() {
    const data2 = super.toJSON();
    const shapes = this.parameters.shapes;
    const options2 = this.parameters.options;
    return toJSON$1(shapes, options2, data2);
  }
  static fromJSON(data2, shapes) {
    const geometryShapes = [];
    for (let j2 = 0, jl = data2.shapes.length; j2 < jl; j2++) {
      const shape2 = shapes[data2.shapes[j2]];
      geometryShapes.push(shape2);
    }
    const extrudePath = data2.options.extrudePath;
    if (extrudePath !== void 0) {
      data2.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
    }
    return new ExtrudeGeometry(geometryShapes, data2.options);
  }
}
const WorldUVGenerator = {
  generateTopUV: function(geometry2, vertices, indexA, indexB, indexC) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    return [
      new Vector2$1(a_x, a_y),
      new Vector2$1(b_x, b_y),
      new Vector2$1(c_x, c_y)
    ];
  },
  generateSideWallUV: function(geometry2, vertices, indexA, indexB, indexC, indexD) {
    const a_x = vertices[indexA * 3];
    const a_y = vertices[indexA * 3 + 1];
    const a_z = vertices[indexA * 3 + 2];
    const b_x = vertices[indexB * 3];
    const b_y = vertices[indexB * 3 + 1];
    const b_z = vertices[indexB * 3 + 2];
    const c_x = vertices[indexC * 3];
    const c_y = vertices[indexC * 3 + 1];
    const c_z = vertices[indexC * 3 + 2];
    const d_x = vertices[indexD * 3];
    const d_y = vertices[indexD * 3 + 1];
    const d_z = vertices[indexD * 3 + 2];
    if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
      return [
        new Vector2$1(a_x, 1 - a_z),
        new Vector2$1(b_x, 1 - b_z),
        new Vector2$1(c_x, 1 - c_z),
        new Vector2$1(d_x, 1 - d_z)
      ];
    } else {
      return [
        new Vector2$1(a_y, 1 - a_z),
        new Vector2$1(b_y, 1 - b_z),
        new Vector2$1(c_y, 1 - c_z),
        new Vector2$1(d_y, 1 - d_z)
      ];
    }
  }
};
function toJSON$1(shapes, options2, data2) {
  data2.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape2 = shapes[i2];
      data2.shapes.push(shape2.uuid);
    }
  } else {
    data2.shapes.push(shapes.uuid);
  }
  if (options2.extrudePath !== void 0)
    data2.options.extrudePath = options2.extrudePath.toJSON();
  return data2;
}
class IcosahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const t2 = (1 + Math.sqrt(5)) / 2;
    const vertices = [
      -1,
      t2,
      0,
      1,
      t2,
      0,
      -1,
      -t2,
      0,
      1,
      -t2,
      0,
      0,
      -1,
      t2,
      0,
      1,
      t2,
      0,
      -1,
      -t2,
      0,
      1,
      -t2,
      t2,
      0,
      -1,
      t2,
      0,
      1,
      -t2,
      0,
      -1,
      -t2,
      0,
      1
    ];
    const indices = [
      0,
      11,
      5,
      0,
      5,
      1,
      0,
      1,
      7,
      0,
      7,
      10,
      0,
      10,
      11,
      1,
      5,
      9,
      5,
      11,
      4,
      11,
      10,
      2,
      10,
      7,
      6,
      7,
      1,
      8,
      3,
      9,
      4,
      3,
      4,
      2,
      3,
      2,
      6,
      3,
      6,
      8,
      3,
      8,
      9,
      4,
      9,
      5,
      2,
      4,
      11,
      6,
      2,
      10,
      8,
      6,
      7,
      9,
      8,
      1
    ];
    super(vertices, indices, radius, detail);
    this.type = "IcosahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data2) {
    return new IcosahedronGeometry(data2.radius, data2.detail);
  }
}
class OctahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const vertices = [
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1,
      0,
      0,
      0,
      1,
      0,
      0,
      -1
    ];
    const indices = [
      0,
      2,
      4,
      0,
      4,
      3,
      0,
      3,
      5,
      0,
      5,
      2,
      1,
      2,
      5,
      1,
      5,
      3,
      1,
      3,
      4,
      1,
      4,
      2
    ];
    super(vertices, indices, radius, detail);
    this.type = "OctahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data2) {
    return new OctahedronGeometry(data2.radius, data2.detail);
  }
}
class RingGeometry extends BufferGeometry {
  constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2) {
    super();
    this.type = "RingGeometry";
    this.parameters = {
      innerRadius,
      outerRadius,
      thetaSegments,
      phiSegments,
      thetaStart,
      thetaLength
    };
    thetaSegments = Math.max(3, thetaSegments);
    phiSegments = Math.max(1, phiSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let radius = innerRadius;
    const radiusStep = (outerRadius - innerRadius) / phiSegments;
    const vertex2 = new Vector3$1();
    const uv = new Vector2$1();
    for (let j2 = 0; j2 <= phiSegments; j2++) {
      for (let i2 = 0; i2 <= thetaSegments; i2++) {
        const segment = thetaStart + i2 / thetaSegments * thetaLength;
        vertex2.x = radius * Math.cos(segment);
        vertex2.y = radius * Math.sin(segment);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normals.push(0, 0, 1);
        uv.x = (vertex2.x / outerRadius + 1) / 2;
        uv.y = (vertex2.y / outerRadius + 1) / 2;
        uvs.push(uv.x, uv.y);
      }
      radius += radiusStep;
    }
    for (let j2 = 0; j2 < phiSegments; j2++) {
      const thetaSegmentLevel = j2 * (thetaSegments + 1);
      for (let i2 = 0; i2 < thetaSegments; i2++) {
        const segment = i2 + thetaSegmentLevel;
        const a2 = segment;
        const b2 = segment + thetaSegments + 1;
        const c2 = segment + thetaSegments + 2;
        const d2 = segment + 1;
        indices.push(a2, b2, d2);
        indices.push(b2, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  static fromJSON(data2) {
    return new RingGeometry(data2.innerRadius, data2.outerRadius, data2.thetaSegments, data2.phiSegments, data2.thetaStart, data2.thetaLength);
  }
}
class ShapeGeometry extends BufferGeometry {
  constructor(shapes = new Shape([new Vector2$1(0, 0.5), new Vector2$1(-0.5, -0.5), new Vector2$1(0.5, -0.5)]), curveSegments = 12) {
    super();
    this.type = "ShapeGeometry";
    this.parameters = {
      shapes,
      curveSegments
    };
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let groupStart = 0;
    let groupCount = 0;
    if (Array.isArray(shapes) === false) {
      addShape(shapes);
    } else {
      for (let i2 = 0; i2 < shapes.length; i2++) {
        addShape(shapes[i2]);
        this.addGroup(groupStart, groupCount, i2);
        groupStart += groupCount;
        groupCount = 0;
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function addShape(shape2) {
      const indexOffset = vertices.length / 3;
      const points2 = shape2.extractPoints(curveSegments);
      let shapeVertices = points2.shape;
      const shapeHoles = points2.holes;
      if (ShapeUtils.isClockWise(shapeVertices) === false) {
        shapeVertices = shapeVertices.reverse();
      }
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        if (ShapeUtils.isClockWise(shapeHole) === true) {
          shapeHoles[i2] = shapeHole.reverse();
        }
      }
      const faces2 = ShapeUtils.triangulateShape(shapeVertices, shapeHoles);
      for (let i2 = 0, l2 = shapeHoles.length; i2 < l2; i2++) {
        const shapeHole = shapeHoles[i2];
        shapeVertices = shapeVertices.concat(shapeHole);
      }
      for (let i2 = 0, l2 = shapeVertices.length; i2 < l2; i2++) {
        const vertex2 = shapeVertices[i2];
        vertices.push(vertex2.x, vertex2.y, 0);
        normals.push(0, 0, 1);
        uvs.push(vertex2.x, vertex2.y);
      }
      for (let i2 = 0, l2 = faces2.length; i2 < l2; i2++) {
        const face = faces2[i2];
        const a2 = face[0] + indexOffset;
        const b2 = face[1] + indexOffset;
        const c2 = face[2] + indexOffset;
        indices.push(a2, b2, c2);
        groupCount += 3;
      }
    }
  }
  toJSON() {
    const data2 = super.toJSON();
    const shapes = this.parameters.shapes;
    return toJSON(shapes, data2);
  }
  static fromJSON(data2, shapes) {
    const geometryShapes = [];
    for (let j2 = 0, jl = data2.shapes.length; j2 < jl; j2++) {
      const shape2 = shapes[data2.shapes[j2]];
      geometryShapes.push(shape2);
    }
    return new ShapeGeometry(geometryShapes, data2.curveSegments);
  }
}
function toJSON(shapes, data2) {
  data2.shapes = [];
  if (Array.isArray(shapes)) {
    for (let i2 = 0, l2 = shapes.length; i2 < l2; i2++) {
      const shape2 = shapes[i2];
      data2.shapes.push(shape2.uuid);
    }
  } else {
    data2.shapes.push(shapes.uuid);
  }
  return data2;
}
class SphereGeometry extends BufferGeometry {
  constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI) {
    super();
    this.type = "SphereGeometry";
    this.parameters = {
      radius,
      widthSegments,
      heightSegments,
      phiStart,
      phiLength,
      thetaStart,
      thetaLength
    };
    widthSegments = Math.max(3, Math.floor(widthSegments));
    heightSegments = Math.max(2, Math.floor(heightSegments));
    const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
    let index2 = 0;
    const grid = [];
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    for (let iy = 0; iy <= heightSegments; iy++) {
      const verticesRow = [];
      const v5 = iy / heightSegments;
      let uOffset = 0;
      if (iy == 0 && thetaStart == 0) {
        uOffset = 0.5 / widthSegments;
      } else if (iy == heightSegments && thetaEnd == Math.PI) {
        uOffset = -0.5 / widthSegments;
      }
      for (let ix = 0; ix <= widthSegments; ix++) {
        const u2 = ix / widthSegments;
        vertex2.x = -radius * Math.cos(phiStart + u2 * phiLength) * Math.sin(thetaStart + v5 * thetaLength);
        vertex2.y = radius * Math.cos(thetaStart + v5 * thetaLength);
        vertex2.z = radius * Math.sin(phiStart + u2 * phiLength) * Math.sin(thetaStart + v5 * thetaLength);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normal.copy(vertex2).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(u2 + uOffset, 1 - v5);
        verticesRow.push(index2++);
      }
      grid.push(verticesRow);
    }
    for (let iy = 0; iy < heightSegments; iy++) {
      for (let ix = 0; ix < widthSegments; ix++) {
        const a2 = grid[iy][ix + 1];
        const b2 = grid[iy][ix];
        const c2 = grid[iy + 1][ix];
        const d2 = grid[iy + 1][ix + 1];
        if (iy !== 0 || thetaStart > 0)
          indices.push(a2, b2, d2);
        if (iy !== heightSegments - 1 || thetaEnd < Math.PI)
          indices.push(b2, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  static fromJSON(data2) {
    return new SphereGeometry(data2.radius, data2.widthSegments, data2.heightSegments, data2.phiStart, data2.phiLength, data2.thetaStart, data2.thetaLength);
  }
}
class TetrahedronGeometry extends PolyhedronGeometry {
  constructor(radius = 1, detail = 0) {
    const vertices = [
      1,
      1,
      1,
      -1,
      -1,
      1,
      -1,
      1,
      -1,
      1,
      -1,
      -1
    ];
    const indices = [
      2,
      1,
      0,
      0,
      3,
      2,
      1,
      3,
      0,
      2,
      3,
      1
    ];
    super(vertices, indices, radius, detail);
    this.type = "TetrahedronGeometry";
    this.parameters = {
      radius,
      detail
    };
  }
  static fromJSON(data2) {
    return new TetrahedronGeometry(data2.radius, data2.detail);
  }
}
class TorusGeometry extends BufferGeometry {
  constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2) {
    super();
    this.type = "TorusGeometry";
    this.parameters = {
      radius,
      tube,
      radialSegments,
      tubularSegments,
      arc
    };
    radialSegments = Math.floor(radialSegments);
    tubularSegments = Math.floor(tubularSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const center2 = new Vector3$1();
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    for (let j2 = 0; j2 <= radialSegments; j2++) {
      for (let i2 = 0; i2 <= tubularSegments; i2++) {
        const u2 = i2 / tubularSegments * arc;
        const v5 = j2 / radialSegments * Math.PI * 2;
        vertex2.x = (radius + tube * Math.cos(v5)) * Math.cos(u2);
        vertex2.y = (radius + tube * Math.cos(v5)) * Math.sin(u2);
        vertex2.z = tube * Math.sin(v5);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        center2.x = radius * Math.cos(u2);
        center2.y = radius * Math.sin(u2);
        normal.subVectors(vertex2, center2).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(i2 / tubularSegments);
        uvs.push(j2 / radialSegments);
      }
    }
    for (let j2 = 1; j2 <= radialSegments; j2++) {
      for (let i2 = 1; i2 <= tubularSegments; i2++) {
        const a2 = (tubularSegments + 1) * j2 + i2 - 1;
        const b2 = (tubularSegments + 1) * (j2 - 1) + i2 - 1;
        const c2 = (tubularSegments + 1) * (j2 - 1) + i2;
        const d2 = (tubularSegments + 1) * j2 + i2;
        indices.push(a2, b2, d2);
        indices.push(b2, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
  }
  static fromJSON(data2) {
    return new TorusGeometry(data2.radius, data2.tube, data2.radialSegments, data2.tubularSegments, data2.arc);
  }
}
class TorusKnotGeometry extends BufferGeometry {
  constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p2 = 2, q2 = 3) {
    super();
    this.type = "TorusKnotGeometry";
    this.parameters = {
      radius,
      tube,
      tubularSegments,
      radialSegments,
      p: p2,
      q: q2
    };
    tubularSegments = Math.floor(tubularSegments);
    radialSegments = Math.floor(radialSegments);
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    const P1 = new Vector3$1();
    const P2 = new Vector3$1();
    const B2 = new Vector3$1();
    const T2 = new Vector3$1();
    const N2 = new Vector3$1();
    for (let i2 = 0; i2 <= tubularSegments; ++i2) {
      const u2 = i2 / tubularSegments * p2 * Math.PI * 2;
      calculatePositionOnCurve(u2, p2, q2, radius, P1);
      calculatePositionOnCurve(u2 + 0.01, p2, q2, radius, P2);
      T2.subVectors(P2, P1);
      N2.addVectors(P2, P1);
      B2.crossVectors(T2, N2);
      N2.crossVectors(B2, T2);
      B2.normalize();
      N2.normalize();
      for (let j2 = 0; j2 <= radialSegments; ++j2) {
        const v5 = j2 / radialSegments * Math.PI * 2;
        const cx = -tube * Math.cos(v5);
        const cy = tube * Math.sin(v5);
        vertex2.x = P1.x + (cx * N2.x + cy * B2.x);
        vertex2.y = P1.y + (cx * N2.y + cy * B2.y);
        vertex2.z = P1.z + (cx * N2.z + cy * B2.z);
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
        normal.subVectors(vertex2, P1).normalize();
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(i2 / tubularSegments);
        uvs.push(j2 / radialSegments);
      }
    }
    for (let j2 = 1; j2 <= tubularSegments; j2++) {
      for (let i2 = 1; i2 <= radialSegments; i2++) {
        const a2 = (radialSegments + 1) * (j2 - 1) + (i2 - 1);
        const b2 = (radialSegments + 1) * j2 + (i2 - 1);
        const c2 = (radialSegments + 1) * j2 + i2;
        const d2 = (radialSegments + 1) * (j2 - 1) + i2;
        indices.push(a2, b2, d2);
        indices.push(b2, c2, d2);
      }
    }
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function calculatePositionOnCurve(u2, p3, q3, radius2, position) {
      const cu = Math.cos(u2);
      const su = Math.sin(u2);
      const quOverP = q3 / p3 * u2;
      const cs = Math.cos(quOverP);
      position.x = radius2 * (2 + cs) * 0.5 * cu;
      position.y = radius2 * (2 + cs) * su * 0.5;
      position.z = radius2 * Math.sin(quOverP) * 0.5;
    }
  }
  static fromJSON(data2) {
    return new TorusKnotGeometry(data2.radius, data2.tube, data2.tubularSegments, data2.radialSegments, data2.p, data2.q);
  }
}
class TubeGeometry extends BufferGeometry {
  constructor(path2 = new QuadraticBezierCurve3(new Vector3$1(-1, -1, 0), new Vector3$1(-1, 1, 0), new Vector3$1(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false) {
    super();
    this.type = "TubeGeometry";
    this.parameters = {
      path: path2,
      tubularSegments,
      radius,
      radialSegments,
      closed
    };
    const frames = path2.computeFrenetFrames(tubularSegments, closed);
    this.tangents = frames.tangents;
    this.normals = frames.normals;
    this.binormals = frames.binormals;
    const vertex2 = new Vector3$1();
    const normal = new Vector3$1();
    const uv = new Vector2$1();
    let P2 = new Vector3$1();
    const vertices = [];
    const normals = [];
    const uvs = [];
    const indices = [];
    generateBufferData();
    this.setIndex(indices);
    this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    this.setAttribute("normal", new Float32BufferAttribute(normals, 3));
    this.setAttribute("uv", new Float32BufferAttribute(uvs, 2));
    function generateBufferData() {
      for (let i2 = 0; i2 < tubularSegments; i2++) {
        generateSegment(i2);
      }
      generateSegment(closed === false ? tubularSegments : 0);
      generateUVs();
      generateIndices();
    }
    function generateSegment(i2) {
      P2 = path2.getPointAt(i2 / tubularSegments, P2);
      const N2 = frames.normals[i2];
      const B2 = frames.binormals[i2];
      for (let j2 = 0; j2 <= radialSegments; j2++) {
        const v5 = j2 / radialSegments * Math.PI * 2;
        const sin2 = Math.sin(v5);
        const cos2 = -Math.cos(v5);
        normal.x = cos2 * N2.x + sin2 * B2.x;
        normal.y = cos2 * N2.y + sin2 * B2.y;
        normal.z = cos2 * N2.z + sin2 * B2.z;
        normal.normalize();
        normals.push(normal.x, normal.y, normal.z);
        vertex2.x = P2.x + radius * normal.x;
        vertex2.y = P2.y + radius * normal.y;
        vertex2.z = P2.z + radius * normal.z;
        vertices.push(vertex2.x, vertex2.y, vertex2.z);
      }
    }
    function generateIndices() {
      for (let j2 = 1; j2 <= tubularSegments; j2++) {
        for (let i2 = 1; i2 <= radialSegments; i2++) {
          const a2 = (radialSegments + 1) * (j2 - 1) + (i2 - 1);
          const b2 = (radialSegments + 1) * j2 + (i2 - 1);
          const c2 = (radialSegments + 1) * j2 + i2;
          const d2 = (radialSegments + 1) * (j2 - 1) + i2;
          indices.push(a2, b2, d2);
          indices.push(b2, c2, d2);
        }
      }
    }
    function generateUVs() {
      for (let i2 = 0; i2 <= tubularSegments; i2++) {
        for (let j2 = 0; j2 <= radialSegments; j2++) {
          uv.x = i2 / tubularSegments;
          uv.y = j2 / radialSegments;
          uvs.push(uv.x, uv.y);
        }
      }
    }
  }
  toJSON() {
    const data2 = super.toJSON();
    data2.path = this.parameters.path.toJSON();
    return data2;
  }
  static fromJSON(data2) {
    return new TubeGeometry(
      new Curves[data2.path.type]().fromJSON(data2.path),
      data2.tubularSegments,
      data2.radius,
      data2.radialSegments,
      data2.closed
    );
  }
}
class WireframeGeometry extends BufferGeometry {
  constructor(geometry2 = null) {
    super();
    this.type = "WireframeGeometry";
    this.parameters = {
      geometry: geometry2
    };
    if (geometry2 !== null) {
      const vertices = [];
      const edges = /* @__PURE__ */ new Set();
      const start2 = new Vector3$1();
      const end = new Vector3$1();
      if (geometry2.index !== null) {
        const position = geometry2.attributes.position;
        const indices = geometry2.index;
        let groups = geometry2.groups;
        if (groups.length === 0) {
          groups = [{ start: 0, count: indices.count, materialIndex: 0 }];
        }
        for (let o2 = 0, ol = groups.length; o2 < ol; ++o2) {
          const group = groups[o2];
          const groupStart = group.start;
          const groupCount = group.count;
          for (let i2 = groupStart, l2 = groupStart + groupCount; i2 < l2; i2 += 3) {
            for (let j2 = 0; j2 < 3; j2++) {
              const index1 = indices.getX(i2 + j2);
              const index2 = indices.getX(i2 + (j2 + 1) % 3);
              start2.fromBufferAttribute(position, index1);
              end.fromBufferAttribute(position, index2);
              if (isUniqueEdge(start2, end, edges) === true) {
                vertices.push(start2.x, start2.y, start2.z);
                vertices.push(end.x, end.y, end.z);
              }
            }
          }
        }
      } else {
        const position = geometry2.attributes.position;
        for (let i2 = 0, l2 = position.count / 3; i2 < l2; i2++) {
          for (let j2 = 0; j2 < 3; j2++) {
            const index1 = 3 * i2 + j2;
            const index2 = 3 * i2 + (j2 + 1) % 3;
            start2.fromBufferAttribute(position, index1);
            end.fromBufferAttribute(position, index2);
            if (isUniqueEdge(start2, end, edges) === true) {
              vertices.push(start2.x, start2.y, start2.z);
              vertices.push(end.x, end.y, end.z);
            }
          }
        }
      }
      this.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    }
  }
}
function isUniqueEdge(start2, end, edges) {
  const hash1 = `${start2.x},${start2.y},${start2.z}-${end.x},${end.y},${end.z}`;
  const hash2 = `${end.x},${end.y},${end.z}-${start2.x},${start2.y},${start2.z}`;
  if (edges.has(hash1) === true || edges.has(hash2) === true) {
    return false;
  } else {
    edges.add(hash1);
    edges.add(hash2);
    return true;
  }
}
var Geometries = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BoxGeometry,
  BoxBufferGeometry: BoxGeometry,
  CapsuleGeometry,
  CapsuleBufferGeometry: CapsuleGeometry,
  CircleGeometry,
  CircleBufferGeometry: CircleGeometry,
  ConeGeometry,
  ConeBufferGeometry: ConeGeometry,
  CylinderGeometry,
  CylinderBufferGeometry: CylinderGeometry,
  DodecahedronGeometry,
  DodecahedronBufferGeometry: DodecahedronGeometry,
  EdgesGeometry,
  ExtrudeGeometry,
  ExtrudeBufferGeometry: ExtrudeGeometry,
  IcosahedronGeometry,
  IcosahedronBufferGeometry: IcosahedronGeometry,
  LatheGeometry,
  LatheBufferGeometry: LatheGeometry,
  OctahedronGeometry,
  OctahedronBufferGeometry: OctahedronGeometry,
  PlaneGeometry,
  PlaneBufferGeometry: PlaneGeometry,
  PolyhedronGeometry,
  PolyhedronBufferGeometry: PolyhedronGeometry,
  RingGeometry,
  RingBufferGeometry: RingGeometry,
  ShapeGeometry,
  ShapeBufferGeometry: ShapeGeometry,
  SphereGeometry,
  SphereBufferGeometry: SphereGeometry,
  TetrahedronGeometry,
  TetrahedronBufferGeometry: TetrahedronGeometry,
  TorusGeometry,
  TorusBufferGeometry: TorusGeometry,
  TorusKnotGeometry,
  TorusKnotBufferGeometry: TorusKnotGeometry,
  TubeGeometry,
  TubeBufferGeometry: TubeGeometry,
  WireframeGeometry
});
class ShadowMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "ShadowMaterial";
    this.color = new Color(0);
    this.transparent = true;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    return this;
  }
}
ShadowMaterial.prototype.isShadowMaterial = true;
class RawShaderMaterial extends ShaderMaterial {
  constructor(parameters) {
    super(parameters);
    this.type = "RawShaderMaterial";
  }
}
RawShaderMaterial.prototype.isRawShaderMaterial = true;
class MeshStandardMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.defines = { "STANDARD": "" };
    this.type = "MeshStandardMaterial";
    this.color = new Color(16777215);
    this.roughness = 1;
    this.metalness = 0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapIntensity = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "STANDARD": "" };
    this.color.copy(source.color);
    this.roughness = source.roughness;
    this.metalness = source.metalness;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.roughnessMap = source.roughnessMap;
    this.metalnessMap = source.metalnessMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapIntensity = source.envMapIntensity;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshStandardMaterial.prototype.isMeshStandardMaterial = true;
class MeshPhysicalMaterial extends MeshStandardMaterial {
  constructor(parameters) {
    super();
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.type = "MeshPhysicalMaterial";
    this.clearcoatMap = null;
    this.clearcoatRoughness = 0;
    this.clearcoatRoughnessMap = null;
    this.clearcoatNormalScale = new Vector2$1(1, 1);
    this.clearcoatNormalMap = null;
    this.ior = 1.5;
    Object.defineProperty(this, "reflectivity", {
      get: function() {
        return clamp$5(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(reflectivity) {
        this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
      }
    });
    this.sheenColor = new Color(0);
    this.sheenColorMap = null;
    this.sheenRoughness = 1;
    this.sheenRoughnessMap = null;
    this.transmissionMap = null;
    this.thickness = 0;
    this.thicknessMap = null;
    this.attenuationDistance = 0;
    this.attenuationColor = new Color(1, 1, 1);
    this.specularIntensity = 1;
    this.specularIntensityMap = null;
    this.specularColor = new Color(1, 1, 1);
    this.specularColorMap = null;
    this._sheen = 0;
    this._clearcoat = 0;
    this._transmission = 0;
    this.setValues(parameters);
  }
  get sheen() {
    return this._sheen;
  }
  set sheen(value) {
    if (this._sheen > 0 !== value > 0) {
      this.version++;
    }
    this._sheen = value;
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(value) {
    if (this._clearcoat > 0 !== value > 0) {
      this.version++;
    }
    this._clearcoat = value;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(value) {
    if (this._transmission > 0 !== value > 0) {
      this.version++;
    }
    this._transmission = value;
  }
  copy(source) {
    super.copy(source);
    this.defines = {
      "STANDARD": "",
      "PHYSICAL": ""
    };
    this.clearcoat = source.clearcoat;
    this.clearcoatMap = source.clearcoatMap;
    this.clearcoatRoughness = source.clearcoatRoughness;
    this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
    this.clearcoatNormalMap = source.clearcoatNormalMap;
    this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
    this.ior = source.ior;
    this.sheen = source.sheen;
    this.sheenColor.copy(source.sheenColor);
    this.sheenColorMap = source.sheenColorMap;
    this.sheenRoughness = source.sheenRoughness;
    this.sheenRoughnessMap = source.sheenRoughnessMap;
    this.transmission = source.transmission;
    this.transmissionMap = source.transmissionMap;
    this.thickness = source.thickness;
    this.thicknessMap = source.thicknessMap;
    this.attenuationDistance = source.attenuationDistance;
    this.attenuationColor.copy(source.attenuationColor);
    this.specularIntensity = source.specularIntensity;
    this.specularIntensityMap = source.specularIntensityMap;
    this.specularColor.copy(source.specularColor);
    this.specularColorMap = source.specularColorMap;
    return this;
  }
}
MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;
class MeshPhongMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "MeshPhongMaterial";
    this.color = new Color(16777215);
    this.specular = new Color(1118481);
    this.shininess = 30;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.specular.copy(source.specular);
    this.shininess = source.shininess;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshPhongMaterial.prototype.isMeshPhongMaterial = true;
class MeshToonMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.defines = { "TOON": "" };
    this.type = "MeshToonMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.gradientMap = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.gradientMap = source.gradientMap;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    return this;
  }
}
MeshToonMaterial.prototype.isMeshToonMaterial = true;
class MeshNormalMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "MeshNormalMaterial";
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshNormalMaterial.prototype.isMeshNormalMaterial = true;
class MeshLambertMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.type = "MeshLambertMaterial";
    this.color = new Color(16777215);
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1;
    this.aoMap = null;
    this.aoMapIntensity = 1;
    this.emissive = new Color(0);
    this.emissiveIntensity = 1;
    this.emissiveMap = null;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = "round";
    this.wireframeLinejoin = "round";
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    return this;
  }
}
MeshLambertMaterial.prototype.isMeshLambertMaterial = true;
class MeshMatcapMaterial extends Material$1 {
  constructor(parameters) {
    super();
    this.defines = { "MATCAP": "" };
    this.type = "MeshMatcapMaterial";
    this.color = new Color(16777215);
    this.matcap = null;
    this.map = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2$1(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.flatShading = false;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.defines = { "MATCAP": "" };
    this.color.copy(source.color);
    this.matcap = source.matcap;
    this.map = source.map;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.flatShading = source.flatShading;
    return this;
  }
}
MeshMatcapMaterial.prototype.isMeshMatcapMaterial = true;
class LineDashedMaterial extends LineBasicMaterial {
  constructor(parameters) {
    super();
    this.type = "LineDashedMaterial";
    this.scale = 1;
    this.dashSize = 3;
    this.gapSize = 1;
    this.setValues(parameters);
  }
  copy(source) {
    super.copy(source);
    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
  }
}
LineDashedMaterial.prototype.isLineDashedMaterial = true;
const materialLib = {
  ShadowMaterial,
  SpriteMaterial,
  RawShaderMaterial,
  ShaderMaterial,
  PointsMaterial,
  MeshPhysicalMaterial,
  MeshStandardMaterial,
  MeshPhongMaterial,
  MeshToonMaterial,
  MeshNormalMaterial,
  MeshLambertMaterial,
  MeshDepthMaterial,
  MeshDistanceMaterial,
  MeshBasicMaterial,
  MeshMatcapMaterial,
  LineDashedMaterial,
  LineBasicMaterial,
  Material: Material$1
};
Material$1.fromType = function(type) {
  return new materialLib[type]();
};
const AnimationUtils = {
  // same as Array.prototype.slice, but also works on typed arrays
  arraySlice: function(array2, from, to) {
    if (AnimationUtils.isTypedArray(array2)) {
      return new array2.constructor(array2.subarray(from, to !== void 0 ? to : array2.length));
    }
    return array2.slice(from, to);
  },
  // converts an array to a specific type
  convertArray: function(array2, type, forceClone) {
    if (!array2 || // let 'undefined' and 'null' pass
    !forceClone && array2.constructor === type)
      return array2;
    if (typeof type.BYTES_PER_ELEMENT === "number") {
      return new type(array2);
    }
    return Array.prototype.slice.call(array2);
  },
  isTypedArray: function(object2) {
    return ArrayBuffer.isView(object2) && !(object2 instanceof DataView);
  },
  // returns an array by which times and values can be sorted
  getKeyframeOrder: function(times) {
    function compareTime(i2, j2) {
      return times[i2] - times[j2];
    }
    const n2 = times.length;
    const result = new Array(n2);
    for (let i2 = 0; i2 !== n2; ++i2)
      result[i2] = i2;
    result.sort(compareTime);
    return result;
  },
  // uses the array previously returned by 'getKeyframeOrder' to sort data
  sortedArray: function(values4, stride, order) {
    const nValues = values4.length;
    const result = new values4.constructor(nValues);
    for (let i2 = 0, dstOffset = 0; dstOffset !== nValues; ++i2) {
      const srcOffset = order[i2] * stride;
      for (let j2 = 0; j2 !== stride; ++j2) {
        result[dstOffset++] = values4[srcOffset + j2];
      }
    }
    return result;
  },
  // function for parsing AOS keyframe formats
  flattenJSON: function(jsonKeys, times, values4, valuePropertyName) {
    let i2 = 1, key = jsonKeys[0];
    while (key !== void 0 && key[valuePropertyName] === void 0) {
      key = jsonKeys[i2++];
    }
    if (key === void 0)
      return;
    let value = key[valuePropertyName];
    if (value === void 0)
      return;
    if (Array.isArray(value)) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          values4.push.apply(values4, value);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    } else if (value.toArray !== void 0) {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          value.toArray(values4, values4.length);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    } else {
      do {
        value = key[valuePropertyName];
        if (value !== void 0) {
          times.push(key.time);
          values4.push(value);
        }
        key = jsonKeys[i2++];
      } while (key !== void 0);
    }
  },
  subclip: function(sourceClip, name2, startFrame, endFrame, fps = 30) {
    const clip2 = sourceClip.clone();
    clip2.name = name2;
    const tracks = [];
    for (let i2 = 0; i2 < clip2.tracks.length; ++i2) {
      const track = clip2.tracks[i2];
      const valueSize = track.getValueSize();
      const times = [];
      const values4 = [];
      for (let j2 = 0; j2 < track.times.length; ++j2) {
        const frame = track.times[j2] * fps;
        if (frame < startFrame || frame >= endFrame)
          continue;
        times.push(track.times[j2]);
        for (let k2 = 0; k2 < valueSize; ++k2) {
          values4.push(track.values[j2 * valueSize + k2]);
        }
      }
      if (times.length === 0)
        continue;
      track.times = AnimationUtils.convertArray(times, track.times.constructor);
      track.values = AnimationUtils.convertArray(values4, track.values.constructor);
      tracks.push(track);
    }
    clip2.tracks = tracks;
    let minStartTime = Infinity;
    for (let i2 = 0; i2 < clip2.tracks.length; ++i2) {
      if (minStartTime > clip2.tracks[i2].times[0]) {
        minStartTime = clip2.tracks[i2].times[0];
      }
    }
    for (let i2 = 0; i2 < clip2.tracks.length; ++i2) {
      clip2.tracks[i2].shift(-1 * minStartTime);
    }
    clip2.resetDuration();
    return clip2;
  },
  makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0)
      fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    for (let i2 = 0; i2 < numTracks; ++i2) {
      const referenceTrack = referenceClip.tracks[i2];
      const referenceTrackType = referenceTrack.ValueTypeName;
      if (referenceTrackType === "bool" || referenceTrackType === "string")
        continue;
      const targetTrack = targetClip.tracks.find(function(track) {
        return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
      });
      if (targetTrack === void 0)
        continue;
      let referenceOffset = 0;
      const referenceValueSize = referenceTrack.getValueSize();
      if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
        referenceOffset = referenceValueSize / 3;
      }
      let targetOffset = 0;
      const targetValueSize = targetTrack.getValueSize();
      if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
        targetOffset = targetValueSize / 3;
      }
      const lastIndex = referenceTrack.times.length - 1;
      let referenceValue;
      if (referenceTime <= referenceTrack.times[0]) {
        const startIndex = referenceOffset;
        const endIndex = referenceValueSize - referenceOffset;
        referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
      } else if (referenceTime >= referenceTrack.times[lastIndex]) {
        const startIndex = lastIndex * referenceValueSize + referenceOffset;
        const endIndex = startIndex + referenceValueSize - referenceOffset;
        referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
      } else {
        const interpolant = referenceTrack.createInterpolant();
        const startIndex = referenceOffset;
        const endIndex = referenceValueSize - referenceOffset;
        interpolant.evaluate(referenceTime);
        referenceValue = AnimationUtils.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
      }
      if (referenceTrackType === "quaternion") {
        const referenceQuat = new Quaternion$1().fromArray(referenceValue).normalize().conjugate();
        referenceQuat.toArray(referenceValue);
      }
      const numTimes = targetTrack.times.length;
      for (let j2 = 0; j2 < numTimes; ++j2) {
        const valueStart = j2 * targetValueSize + targetOffset;
        if (referenceTrackType === "quaternion") {
          Quaternion$1.multiplyQuaternionsFlat(
            targetTrack.values,
            valueStart,
            referenceValue,
            0,
            targetTrack.values,
            valueStart
          );
        } else {
          const valueEnd = targetValueSize - targetOffset * 2;
          for (let k2 = 0; k2 < valueEnd; ++k2) {
            targetTrack.values[valueStart + k2] -= referenceValue[k2];
          }
        }
      }
    }
    targetClip.blendMode = AdditiveAnimationBlendMode;
    return targetClip;
  }
};
class Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== void 0 ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
    this.settings = null;
    this.DefaultSettings_ = {};
  }
  evaluate(t2) {
    const pp = this.parameterPositions;
    let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
    validate_interval: {
      seek: {
        let right;
        linear_scan: {
          forward_scan:
            if (!(t2 < t1)) {
              for (let giveUpAt = i1 + 2; ; ) {
                if (t1 === void 0) {
                  if (t2 < t0)
                    break forward_scan;
                  i1 = pp.length;
                  this._cachedIndex = i1;
                  return this.afterEnd_(i1 - 1, t2, t0);
                }
                if (i1 === giveUpAt)
                  break;
                t0 = t1;
                t1 = pp[++i1];
                if (t2 < t1) {
                  break seek;
                }
              }
              right = pp.length;
              break linear_scan;
            }
          if (!(t2 >= t0)) {
            const t1global = pp[1];
            if (t2 < t1global) {
              i1 = 2;
              t0 = t1global;
            }
            for (let giveUpAt = i1 - 2; ; ) {
              if (t0 === void 0) {
                this._cachedIndex = 0;
                return this.beforeStart_(0, t2, t1);
              }
              if (i1 === giveUpAt)
                break;
              t1 = t0;
              t0 = pp[--i1 - 1];
              if (t2 >= t0) {
                break seek;
              }
            }
            right = i1;
            i1 = 0;
            break linear_scan;
          }
          break validate_interval;
        }
        while (i1 < right) {
          const mid = i1 + right >>> 1;
          if (t2 < pp[mid]) {
            right = mid;
          } else {
            i1 = mid + 1;
          }
        }
        t1 = pp[i1];
        t0 = pp[i1 - 1];
        if (t0 === void 0) {
          this._cachedIndex = 0;
          return this.beforeStart_(0, t2, t1);
        }
        if (t1 === void 0) {
          i1 = pp.length;
          this._cachedIndex = i1;
          return this.afterEnd_(i1 - 1, t0, t2);
        }
      }
      this._cachedIndex = i1;
      this.intervalChanged_(i1, t0, t1);
    }
    return this.interpolate_(i1, t0, t2, t1);
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_;
  }
  copySampleValue_(index2) {
    const result = this.resultBuffer, values4 = this.sampleValues, stride = this.valueSize, offset = index2 * stride;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values4[offset + i2];
    }
    return result;
  }
  // Template methods for derived classes:
  interpolate_() {
    throw new Error("call to abstract method");
  }
  intervalChanged_() {
  }
}
Interpolant.prototype.beforeStart_ = Interpolant.prototype.copySampleValue_;
Interpolant.prototype.afterEnd_ = Interpolant.prototype.copySampleValue_;
class CubicInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
    this.DefaultSettings_ = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
  }
  intervalChanged_(i1, t0, t1) {
    const pp = this.parameterPositions;
    let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
    if (tPrev === void 0) {
      switch (this.getSettings_().endingStart) {
        case ZeroSlopeEnding:
          iPrev = i1;
          tPrev = 2 * t0 - t1;
          break;
        case WrapAroundEnding:
          iPrev = pp.length - 2;
          tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
          break;
        default:
          iPrev = i1;
          tPrev = t1;
      }
    }
    if (tNext === void 0) {
      switch (this.getSettings_().endingEnd) {
        case ZeroSlopeEnding:
          iNext = i1;
          tNext = 2 * t1 - t0;
          break;
        case WrapAroundEnding:
          iNext = 1;
          tNext = t1 + pp[1] - pp[0];
          break;
        default:
          iNext = i1 - 1;
          tNext = t0;
      }
    }
    const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
    this._weightPrev = halfDt / (t0 - tPrev);
    this._weightNext = halfDt / (tNext - t1);
    this._offsetPrev = iPrev * stride;
    this._offsetNext = iNext * stride;
  }
  interpolate_(i1, t0, t2, t1) {
    const result = this.resultBuffer, values4 = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p2 = (t2 - t0) / (t1 - t0), pp = p2 * p2, ppp = pp * p2;
    const sP = -wP * ppp + 2 * wP * pp - wP * p2;
    const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p2 + 1;
    const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p2;
    const sN = wN * ppp - wN * pp;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = sP * values4[oP + i2] + s0 * values4[o0 + i2] + s1 * values4[o1 + i2] + sN * values4[oN + i2];
    }
    return result;
  }
}
class LinearInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t2, t1) {
    const result = this.resultBuffer, values4 = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t2 - t0) / (t1 - t0), weight0 = 1 - weight1;
    for (let i2 = 0; i2 !== stride; ++i2) {
      result[i2] = values4[offset0 + i2] * weight0 + values4[offset1 + i2] * weight1;
    }
    return result;
  }
}
class DiscreteInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1) {
    return this.copySampleValue_(i1 - 1);
  }
}
class KeyframeTrack {
  constructor(name2, times, values4, interpolation) {
    if (name2 === void 0)
      throw new Error("THREE.KeyframeTrack: track name is undefined");
    if (times === void 0 || times.length === 0)
      throw new Error("THREE.KeyframeTrack: no keyframes in track named " + name2);
    this.name = name2;
    this.times = AnimationUtils.convertArray(times, this.TimeBufferType);
    this.values = AnimationUtils.convertArray(values4, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
  }
  // Serialization (in static context, because of constructor invocation
  // and automatic invocation of .toJSON):
  static toJSON(track) {
    const trackType = track.constructor;
    let json;
    if (trackType.toJSON !== this.toJSON) {
      json = trackType.toJSON(track);
    } else {
      json = {
        "name": track.name,
        "times": AnimationUtils.convertArray(track.times, Array),
        "values": AnimationUtils.convertArray(track.values, Array)
      };
      const interpolation = track.getInterpolation();
      if (interpolation !== track.DefaultInterpolation) {
        json.interpolation = interpolation;
      }
    }
    json.type = track.ValueTypeName;
    return json;
  }
  InterpolantFactoryMethodDiscrete(result) {
    return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodLinear(result) {
    return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  InterpolantFactoryMethodSmooth(result) {
    return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
  }
  setInterpolation(interpolation) {
    let factoryMethod;
    switch (interpolation) {
      case InterpolateDiscrete:
        factoryMethod = this.InterpolantFactoryMethodDiscrete;
        break;
      case InterpolateLinear:
        factoryMethod = this.InterpolantFactoryMethodLinear;
        break;
      case InterpolateSmooth:
        factoryMethod = this.InterpolantFactoryMethodSmooth;
        break;
    }
    if (factoryMethod === void 0) {
      const message2 = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
      if (this.createInterpolant === void 0) {
        if (interpolation !== this.DefaultInterpolation) {
          this.setInterpolation(this.DefaultInterpolation);
        } else {
          throw new Error(message2);
        }
      }
      console.warn("THREE.KeyframeTrack:", message2);
      return this;
    }
    this.createInterpolant = factoryMethod;
    return this;
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return InterpolateDiscrete;
      case this.InterpolantFactoryMethodLinear:
        return InterpolateLinear;
      case this.InterpolantFactoryMethodSmooth:
        return InterpolateSmooth;
    }
  }
  getValueSize() {
    return this.values.length / this.times.length;
  }
  // move all keyframes either forwards or backwards in time
  shift(timeOffset) {
    if (timeOffset !== 0) {
      const times = this.times;
      for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
        times[i2] += timeOffset;
      }
    }
    return this;
  }
  // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
  scale(timeScale) {
    if (timeScale !== 1) {
      const times = this.times;
      for (let i2 = 0, n2 = times.length; i2 !== n2; ++i2) {
        times[i2] *= timeScale;
      }
    }
    return this;
  }
  // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
  // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
  trim(startTime, endTime) {
    const times = this.times, nKeys = times.length;
    let from = 0, to = nKeys - 1;
    while (from !== nKeys && times[from] < startTime) {
      ++from;
    }
    while (to !== -1 && times[to] > endTime) {
      --to;
    }
    ++to;
    if (from !== 0 || to !== nKeys) {
      if (from >= to) {
        to = Math.max(to, 1);
        from = to - 1;
      }
      const stride = this.getValueSize();
      this.times = AnimationUtils.arraySlice(times, from, to);
      this.values = AnimationUtils.arraySlice(this.values, from * stride, to * stride);
    }
    return this;
  }
  // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
  validate() {
    let valid = true;
    const valueSize = this.getValueSize();
    if (valueSize - Math.floor(valueSize) !== 0) {
      console.error("THREE.KeyframeTrack: Invalid value size in track.", this);
      valid = false;
    }
    const times = this.times, values4 = this.values, nKeys = times.length;
    if (nKeys === 0) {
      console.error("THREE.KeyframeTrack: Track is empty.", this);
      valid = false;
    }
    let prevTime = null;
    for (let i2 = 0; i2 !== nKeys; i2++) {
      const currTime = times[i2];
      if (typeof currTime === "number" && isNaN(currTime)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, i2, currTime);
        valid = false;
        break;
      }
      if (prevTime !== null && prevTime > currTime) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, i2, currTime, prevTime);
        valid = false;
        break;
      }
      prevTime = currTime;
    }
    if (values4 !== void 0) {
      if (AnimationUtils.isTypedArray(values4)) {
        for (let i2 = 0, n2 = values4.length; i2 !== n2; ++i2) {
          const value = values4[i2];
          if (isNaN(value)) {
            console.error("THREE.KeyframeTrack: Value is not a valid number.", this, i2, value);
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  }
  // removes equivalent sequential keys as common in morph target sequences
  // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
  optimize() {
    const times = AnimationUtils.arraySlice(this.times), values4 = AnimationUtils.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
    let writeIndex = 1;
    for (let i2 = 1; i2 < lastIndex; ++i2) {
      let keep = false;
      const time2 = times[i2];
      const timeNext = times[i2 + 1];
      if (time2 !== timeNext && (i2 !== 1 || time2 !== times[0])) {
        if (!smoothInterpolation) {
          const offset = i2 * stride, offsetP = offset - stride, offsetN = offset + stride;
          for (let j2 = 0; j2 !== stride; ++j2) {
            const value = values4[offset + j2];
            if (value !== values4[offsetP + j2] || value !== values4[offsetN + j2]) {
              keep = true;
              break;
            }
          }
        } else {
          keep = true;
        }
      }
      if (keep) {
        if (i2 !== writeIndex) {
          times[writeIndex] = times[i2];
          const readOffset = i2 * stride, writeOffset = writeIndex * stride;
          for (let j2 = 0; j2 !== stride; ++j2) {
            values4[writeOffset + j2] = values4[readOffset + j2];
          }
        }
        ++writeIndex;
      }
    }
    if (lastIndex > 0) {
      times[writeIndex] = times[lastIndex];
      for (let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j2 = 0; j2 !== stride; ++j2) {
        values4[writeOffset + j2] = values4[readOffset + j2];
      }
      ++writeIndex;
    }
    if (writeIndex !== times.length) {
      this.times = AnimationUtils.arraySlice(times, 0, writeIndex);
      this.values = AnimationUtils.arraySlice(values4, 0, writeIndex * stride);
    } else {
      this.times = times;
      this.values = values4;
    }
    return this;
  }
  clone() {
    const times = AnimationUtils.arraySlice(this.times, 0);
    const values4 = AnimationUtils.arraySlice(this.values, 0);
    const TypedKeyframeTrack = this.constructor;
    const track = new TypedKeyframeTrack(this.name, times, values4);
    track.createInterpolant = this.createInterpolant;
    return track;
  }
}
KeyframeTrack.prototype.TimeBufferType = Float32Array;
KeyframeTrack.prototype.ValueBufferType = Float32Array;
KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
class BooleanKeyframeTrack extends KeyframeTrack {
}
BooleanKeyframeTrack.prototype.ValueTypeName = "bool";
BooleanKeyframeTrack.prototype.ValueBufferType = Array;
BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class ColorKeyframeTrack extends KeyframeTrack {
}
ColorKeyframeTrack.prototype.ValueTypeName = "color";
class NumberKeyframeTrack extends KeyframeTrack {
}
NumberKeyframeTrack.prototype.ValueTypeName = "number";
class QuaternionLinearInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  interpolate_(i1, t0, t2, t1) {
    const result = this.resultBuffer, values4 = this.sampleValues, stride = this.valueSize, alpha = (t2 - t0) / (t1 - t0);
    let offset = i1 * stride;
    for (let end = offset + stride; offset !== end; offset += 4) {
      Quaternion$1.slerpFlat(result, 0, values4, offset - stride, values4, offset, alpha);
    }
    return result;
  }
}
class QuaternionKeyframeTrack extends KeyframeTrack {
  InterpolantFactoryMethodLinear(result) {
    return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
  }
}
QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion";
QuaternionKeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class StringKeyframeTrack extends KeyframeTrack {
}
StringKeyframeTrack.prototype.ValueTypeName = "string";
StringKeyframeTrack.prototype.ValueBufferType = Array;
StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
class VectorKeyframeTrack extends KeyframeTrack {
}
VectorKeyframeTrack.prototype.ValueTypeName = "vector";
class AnimationClip {
  constructor(name2, duration = -1, tracks, blendMode = NormalAnimationBlendMode) {
    this.name = name2;
    this.tracks = tracks;
    this.duration = duration;
    this.blendMode = blendMode;
    this.uuid = generateUUID();
    if (this.duration < 0) {
      this.resetDuration();
    }
  }
  static parse(json) {
    const tracks = [], jsonTracks = json.tracks, frameTime = 1 / (json.fps || 1);
    for (let i2 = 0, n2 = jsonTracks.length; i2 !== n2; ++i2) {
      tracks.push(parseKeyframeTrack(jsonTracks[i2]).scale(frameTime));
    }
    const clip2 = new this(json.name, json.duration, tracks, json.blendMode);
    clip2.uuid = json.uuid;
    return clip2;
  }
  static toJSON(clip2) {
    const tracks = [], clipTracks = clip2.tracks;
    const json = {
      "name": clip2.name,
      "duration": clip2.duration,
      "tracks": tracks,
      "uuid": clip2.uuid,
      "blendMode": clip2.blendMode
    };
    for (let i2 = 0, n2 = clipTracks.length; i2 !== n2; ++i2) {
      tracks.push(KeyframeTrack.toJSON(clipTracks[i2]));
    }
    return json;
  }
  static CreateFromMorphTargetSequence(name2, morphTargetSequence, fps, noLoop) {
    const numMorphTargets = morphTargetSequence.length;
    const tracks = [];
    for (let i2 = 0; i2 < numMorphTargets; i2++) {
      let times = [];
      let values4 = [];
      times.push(
        (i2 + numMorphTargets - 1) % numMorphTargets,
        i2,
        (i2 + 1) % numMorphTargets
      );
      values4.push(0, 1, 0);
      const order = AnimationUtils.getKeyframeOrder(times);
      times = AnimationUtils.sortedArray(times, 1, order);
      values4 = AnimationUtils.sortedArray(values4, 1, order);
      if (!noLoop && times[0] === 0) {
        times.push(numMorphTargets);
        values4.push(values4[0]);
      }
      tracks.push(
        new NumberKeyframeTrack(
          ".morphTargetInfluences[" + morphTargetSequence[i2].name + "]",
          times,
          values4
        ).scale(1 / fps)
      );
    }
    return new this(name2, -1, tracks);
  }
  static findByName(objectOrClipArray, name2) {
    let clipArray = objectOrClipArray;
    if (!Array.isArray(objectOrClipArray)) {
      const o2 = objectOrClipArray;
      clipArray = o2.geometry && o2.geometry.animations || o2.animations;
    }
    for (let i2 = 0; i2 < clipArray.length; i2++) {
      if (clipArray[i2].name === name2) {
        return clipArray[i2];
      }
    }
    return null;
  }
  static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
    const animationToMorphTargets = {};
    const pattern = /^([\w-]*?)([\d]+)$/;
    for (let i2 = 0, il = morphTargets.length; i2 < il; i2++) {
      const morphTarget = morphTargets[i2];
      const parts = morphTarget.name.match(pattern);
      if (parts && parts.length > 1) {
        const name2 = parts[1];
        let animationMorphTargets = animationToMorphTargets[name2];
        if (!animationMorphTargets) {
          animationToMorphTargets[name2] = animationMorphTargets = [];
        }
        animationMorphTargets.push(morphTarget);
      }
    }
    const clips = [];
    for (const name2 in animationToMorphTargets) {
      clips.push(this.CreateFromMorphTargetSequence(name2, animationToMorphTargets[name2], fps, noLoop));
    }
    return clips;
  }
  // parse the animation.hierarchy format
  static parseAnimation(animation, bones) {
    if (!animation) {
      console.error("THREE.AnimationClip: No animation in JSONLoader data.");
      return null;
    }
    const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
      if (animationKeys.length !== 0) {
        const times = [];
        const values4 = [];
        AnimationUtils.flattenJSON(animationKeys, times, values4, propertyName);
        if (times.length !== 0) {
          destTracks.push(new trackType(trackName, times, values4));
        }
      }
    };
    const tracks = [];
    const clipName = animation.name || "default";
    const fps = animation.fps || 30;
    const blendMode = animation.blendMode;
    let duration = animation.length || -1;
    const hierarchyTracks = animation.hierarchy || [];
    for (let h2 = 0; h2 < hierarchyTracks.length; h2++) {
      const animationKeys = hierarchyTracks[h2].keys;
      if (!animationKeys || animationKeys.length === 0)
        continue;
      if (animationKeys[0].morphTargets) {
        const morphTargetNames = {};
        let k2;
        for (k2 = 0; k2 < animationKeys.length; k2++) {
          if (animationKeys[k2].morphTargets) {
            for (let m2 = 0; m2 < animationKeys[k2].morphTargets.length; m2++) {
              morphTargetNames[animationKeys[k2].morphTargets[m2]] = -1;
            }
          }
        }
        for (const morphTargetName in morphTargetNames) {
          const times = [];
          const values4 = [];
          for (let m2 = 0; m2 !== animationKeys[k2].morphTargets.length; ++m2) {
            const animationKey = animationKeys[k2];
            times.push(animationKey.time);
            values4.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
          }
          tracks.push(new NumberKeyframeTrack(".morphTargetInfluence[" + morphTargetName + "]", times, values4));
        }
        duration = morphTargetNames.length * fps;
      } else {
        const boneName = ".bones[" + bones[h2].name + "]";
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".position",
          animationKeys,
          "pos",
          tracks
        );
        addNonemptyTrack(
          QuaternionKeyframeTrack,
          boneName + ".quaternion",
          animationKeys,
          "rot",
          tracks
        );
        addNonemptyTrack(
          VectorKeyframeTrack,
          boneName + ".scale",
          animationKeys,
          "scl",
          tracks
        );
      }
    }
    if (tracks.length === 0) {
      return null;
    }
    const clip2 = new this(clipName, duration, tracks, blendMode);
    return clip2;
  }
  resetDuration() {
    const tracks = this.tracks;
    let duration = 0;
    for (let i2 = 0, n2 = tracks.length; i2 !== n2; ++i2) {
      const track = this.tracks[i2];
      duration = Math.max(duration, track.times[track.times.length - 1]);
    }
    this.duration = duration;
    return this;
  }
  trim() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].trim(0, this.duration);
    }
    return this;
  }
  validate() {
    let valid = true;
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      valid = valid && this.tracks[i2].validate();
    }
    return valid;
  }
  optimize() {
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      this.tracks[i2].optimize();
    }
    return this;
  }
  clone() {
    const tracks = [];
    for (let i2 = 0; i2 < this.tracks.length; i2++) {
      tracks.push(this.tracks[i2].clone());
    }
    return new this.constructor(this.name, this.duration, tracks, this.blendMode);
  }
  toJSON() {
    return this.constructor.toJSON(this);
  }
}
function getTrackTypeForValueTypeName(typeName) {
  switch (typeName.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return NumberKeyframeTrack;
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return VectorKeyframeTrack;
    case "color":
      return ColorKeyframeTrack;
    case "quaternion":
      return QuaternionKeyframeTrack;
    case "bool":
    case "boolean":
      return BooleanKeyframeTrack;
    case "string":
      return StringKeyframeTrack;
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + typeName);
}
function parseKeyframeTrack(json) {
  if (json.type === void 0) {
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
  }
  const trackType = getTrackTypeForValueTypeName(json.type);
  if (json.times === void 0) {
    const times = [], values4 = [];
    AnimationUtils.flattenJSON(json.keys, times, values4, "value");
    json.times = times;
    json.values = values4;
  }
  if (trackType.parse !== void 0) {
    return trackType.parse(json);
  } else {
    return new trackType(json.name, json.times, json.values, json.interpolation);
  }
}
const Cache = {
  enabled: false,
  files: {},
  add: function(key, file2) {
    if (this.enabled === false)
      return;
    this.files[key] = file2;
  },
  get: function(key) {
    if (this.enabled === false)
      return;
    return this.files[key];
  },
  remove: function(key) {
    delete this.files[key];
  },
  clear: function() {
    this.files = {};
  }
};
class LoadingManager {
  constructor(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = void 0;
    const handlers2 = [];
    this.onStart = void 0;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url2) {
      itemsTotal++;
      if (isLoading === false) {
        if (scope.onStart !== void 0) {
          scope.onStart(url2, itemsLoaded, itemsTotal);
        }
      }
      isLoading = true;
    };
    this.itemEnd = function(url2) {
      itemsLoaded++;
      if (scope.onProgress !== void 0) {
        scope.onProgress(url2, itemsLoaded, itemsTotal);
      }
      if (itemsLoaded === itemsTotal) {
        isLoading = false;
        if (scope.onLoad !== void 0) {
          scope.onLoad();
        }
      }
    };
    this.itemError = function(url2) {
      if (scope.onError !== void 0) {
        scope.onError(url2);
      }
    };
    this.resolveURL = function(url2) {
      if (urlModifier) {
        return urlModifier(url2);
      }
      return url2;
    };
    this.setURLModifier = function(transform4) {
      urlModifier = transform4;
      return this;
    };
    this.addHandler = function(regex2, loader2) {
      handlers2.push(regex2, loader2);
      return this;
    };
    this.removeHandler = function(regex2) {
      const index2 = handlers2.indexOf(regex2);
      if (index2 !== -1) {
        handlers2.splice(index2, 2);
      }
      return this;
    };
    this.getHandler = function(file2) {
      for (let i2 = 0, l2 = handlers2.length; i2 < l2; i2 += 2) {
        const regex2 = handlers2[i2];
        const loader2 = handlers2[i2 + 1];
        if (regex2.global)
          regex2.lastIndex = 0;
        if (regex2.test(file2)) {
          return loader2;
        }
      }
      return null;
    };
  }
}
const DefaultLoadingManager = new LoadingManager();
class Loader {
  constructor(manager) {
    this.manager = manager !== void 0 ? manager : DefaultLoadingManager;
    this.crossOrigin = "anonymous";
    this.withCredentials = false;
    this.path = "";
    this.resourcePath = "";
    this.requestHeader = {};
  }
  load() {
  }
  loadAsync(url2, onProgress) {
    const scope = this;
    return new Promise(function(resolve2, reject) {
      scope.load(url2, resolve2, onProgress, reject);
    });
  }
  parse() {
  }
  setCrossOrigin(crossOrigin) {
    this.crossOrigin = crossOrigin;
    return this;
  }
  setWithCredentials(value) {
    this.withCredentials = value;
    return this;
  }
  setPath(path2) {
    this.path = path2;
    return this;
  }
  setResourcePath(resourcePath) {
    this.resourcePath = resourcePath;
    return this;
  }
  setRequestHeader(requestHeader) {
    this.requestHeader = requestHeader;
    return this;
  }
}
const loading = {};
class FileLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    if (url2 === void 0)
      url2 = "";
    if (this.path !== void 0)
      url2 = this.path + url2;
    url2 = this.manager.resolveURL(url2);
    const cached = Cache.get(url2);
    if (cached !== void 0) {
      this.manager.itemStart(url2);
      setTimeout(() => {
        if (onLoad)
          onLoad(cached);
        this.manager.itemEnd(url2);
      }, 0);
      return cached;
    }
    if (loading[url2] !== void 0) {
      loading[url2].push({
        onLoad,
        onProgress,
        onError
      });
      return;
    }
    loading[url2] = [];
    loading[url2].push({
      onLoad,
      onProgress,
      onError
    });
    const req = new Request(url2, {
      headers: new Headers(this.requestHeader),
      credentials: this.withCredentials ? "include" : "same-origin"
      // An abort controller could be added within a future PR
    });
    const mimeType = this.mimeType;
    const responseType = this.responseType;
    fetch(req).then((response) => {
      if (response.status === 200 || response.status === 0) {
        if (response.status === 0) {
          console.warn("THREE.FileLoader: HTTP Status 0 received.");
        }
        if (typeof ReadableStream === "undefined" || response.body === void 0 || response.body.getReader === void 0) {
          return response;
        }
        const callbacks2 = loading[url2];
        const reader = response.body.getReader();
        const contentLength = response.headers.get("Content-Length");
        const total = contentLength ? parseInt(contentLength) : 0;
        const lengthComputable = total !== 0;
        let loaded = 0;
        const stream2 = new ReadableStream({
          start(controller) {
            readData();
            function readData() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                } else {
                  loaded += value.byteLength;
                  const event = new ProgressEvent("progress", { lengthComputable, loaded, total });
                  for (let i2 = 0, il = callbacks2.length; i2 < il; i2++) {
                    const callback = callbacks2[i2];
                    if (callback.onProgress)
                      callback.onProgress(event);
                  }
                  controller.enqueue(value);
                  readData();
                }
              });
            }
          }
        });
        return new Response(stream2);
      } else {
        throw Error(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`);
      }
    }).then((response) => {
      switch (responseType) {
        case "arraybuffer":
          return response.arrayBuffer();
        case "blob":
          return response.blob();
        case "document":
          return response.text().then((text) => {
            const parser = new DOMParser();
            return parser.parseFromString(text, mimeType);
          });
        case "json":
          return response.json();
        default:
          if (mimeType === void 0) {
            return response.text();
          } else {
            const re = /charset="?([^;"\s]*)"?/i;
            const exec = re.exec(mimeType);
            const label = exec && exec[1] ? exec[1].toLowerCase() : void 0;
            const decoder = new TextDecoder(label);
            return response.arrayBuffer().then((ab2) => decoder.decode(ab2));
          }
      }
    }).then((data2) => {
      Cache.add(url2, data2);
      const callbacks2 = loading[url2];
      delete loading[url2];
      for (let i2 = 0, il = callbacks2.length; i2 < il; i2++) {
        const callback = callbacks2[i2];
        if (callback.onLoad)
          callback.onLoad(data2);
      }
    }).catch((err) => {
      const callbacks2 = loading[url2];
      if (callbacks2 === void 0) {
        this.manager.itemError(url2);
        throw err;
      }
      delete loading[url2];
      for (let i2 = 0, il = callbacks2.length; i2 < il; i2++) {
        const callback = callbacks2[i2];
        if (callback.onError)
          callback.onError(err);
      }
      this.manager.itemError(url2);
    }).finally(() => {
      this.manager.itemEnd(url2);
    });
    this.manager.itemStart(url2);
  }
  setResponseType(value) {
    this.responseType = value;
    return this;
  }
  setMimeType(value) {
    this.mimeType = value;
    return this;
  }
}
class AnimationLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(url2, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e3) {
        if (onError) {
          onError(e3);
        } else {
          console.error(e3);
        }
        scope.manager.itemError(url2);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const animations = [];
    for (let i2 = 0; i2 < json.length; i2++) {
      const clip2 = AnimationClip.parse(json[i2]);
      animations.push(clip2);
    }
    return animations;
  }
}
class CompressedTextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const images = [];
    const texture = new CompressedTexture();
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setResponseType("arraybuffer");
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(scope.withCredentials);
    let loaded = 0;
    function loadTexture(i2) {
      loader2.load(url2[i2], function(buffer3) {
        const texDatas = scope.parse(buffer3, true);
        images[i2] = {
          width: texDatas.width,
          height: texDatas.height,
          format: texDatas.format,
          mipmaps: texDatas.mipmaps
        };
        loaded += 1;
        if (loaded === 6) {
          if (texDatas.mipmapCount === 1)
            texture.minFilter = LinearFilter;
          texture.image = images;
          texture.format = texDatas.format;
          texture.needsUpdate = true;
          if (onLoad)
            onLoad(texture);
        }
      }, onProgress, onError);
    }
    if (Array.isArray(url2)) {
      for (let i2 = 0, il = url2.length; i2 < il; ++i2) {
        loadTexture(i2);
      }
    } else {
      loader2.load(url2, function(buffer3) {
        const texDatas = scope.parse(buffer3, true);
        if (texDatas.isCubemap) {
          const faces2 = texDatas.mipmaps.length / texDatas.mipmapCount;
          for (let f2 = 0; f2 < faces2; f2++) {
            images[f2] = { mipmaps: [] };
            for (let i2 = 0; i2 < texDatas.mipmapCount; i2++) {
              images[f2].mipmaps.push(texDatas.mipmaps[f2 * texDatas.mipmapCount + i2]);
              images[f2].format = texDatas.format;
              images[f2].width = texDatas.width;
              images[f2].height = texDatas.height;
            }
          }
          texture.image = images;
        } else {
          texture.image.width = texDatas.width;
          texture.image.height = texDatas.height;
          texture.mipmaps = texDatas.mipmaps;
        }
        if (texDatas.mipmapCount === 1) {
          texture.minFilter = LinearFilter;
        }
        texture.format = texDatas.format;
        texture.needsUpdate = true;
        if (onLoad)
          onLoad(texture);
      }, onProgress, onError);
    }
    return texture;
  }
}
let ImageLoader$2 = class ImageLoader2 extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    if (this.path !== void 0)
      url2 = this.path + url2;
    url2 = this.manager.resolveURL(url2);
    const scope = this;
    const cached = Cache.get(url2);
    if (cached !== void 0) {
      scope.manager.itemStart(url2);
      setTimeout(function() {
        if (onLoad)
          onLoad(cached);
        scope.manager.itemEnd(url2);
      }, 0);
      return cached;
    }
    const image = createElementNS("img");
    function onImageLoad() {
      removeEventListeners();
      Cache.add(url2, this);
      if (onLoad)
        onLoad(this);
      scope.manager.itemEnd(url2);
    }
    function onImageError(event) {
      removeEventListeners();
      if (onError)
        onError(event);
      scope.manager.itemError(url2);
      scope.manager.itemEnd(url2);
    }
    function removeEventListeners() {
      image.removeEventListener("load", onImageLoad, false);
      image.removeEventListener("error", onImageError, false);
    }
    image.addEventListener("load", onImageLoad, false);
    image.addEventListener("error", onImageError, false);
    if (url2.slice(0, 5) !== "data:") {
      if (this.crossOrigin !== void 0)
        image.crossOrigin = this.crossOrigin;
    }
    scope.manager.itemStart(url2);
    image.src = url2;
    return image;
  }
};
class CubeTextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(urls, onLoad, onProgress, onError) {
    const texture = new CubeTexture();
    const loader2 = new ImageLoader$2(this.manager);
    loader2.setCrossOrigin(this.crossOrigin);
    loader2.setPath(this.path);
    let loaded = 0;
    function loadTexture(i2) {
      loader2.load(urls[i2], function(image) {
        texture.images[i2] = image;
        loaded++;
        if (loaded === 6) {
          texture.needsUpdate = true;
          if (onLoad)
            onLoad(texture);
        }
      }, void 0, onError);
    }
    for (let i2 = 0; i2 < urls.length; ++i2) {
      loadTexture(i2);
    }
    return texture;
  }
}
class DataTextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const texture = new DataTexture();
    const loader2 = new FileLoader(this.manager);
    loader2.setResponseType("arraybuffer");
    loader2.setRequestHeader(this.requestHeader);
    loader2.setPath(this.path);
    loader2.setWithCredentials(scope.withCredentials);
    loader2.load(url2, function(buffer3) {
      const texData = scope.parse(buffer3);
      if (!texData)
        return;
      if (texData.image !== void 0) {
        texture.image = texData.image;
      } else if (texData.data !== void 0) {
        texture.image.width = texData.width;
        texture.image.height = texData.height;
        texture.image.data = texData.data;
      }
      texture.wrapS = texData.wrapS !== void 0 ? texData.wrapS : ClampToEdgeWrapping;
      texture.wrapT = texData.wrapT !== void 0 ? texData.wrapT : ClampToEdgeWrapping;
      texture.magFilter = texData.magFilter !== void 0 ? texData.magFilter : LinearFilter;
      texture.minFilter = texData.minFilter !== void 0 ? texData.minFilter : LinearFilter;
      texture.anisotropy = texData.anisotropy !== void 0 ? texData.anisotropy : 1;
      if (texData.encoding !== void 0) {
        texture.encoding = texData.encoding;
      }
      if (texData.flipY !== void 0) {
        texture.flipY = texData.flipY;
      }
      if (texData.format !== void 0) {
        texture.format = texData.format;
      }
      if (texData.type !== void 0) {
        texture.type = texData.type;
      }
      if (texData.mipmaps !== void 0) {
        texture.mipmaps = texData.mipmaps;
        texture.minFilter = LinearMipmapLinearFilter;
      }
      if (texData.mipmapCount === 1) {
        texture.minFilter = LinearFilter;
      }
      if (texData.generateMipmaps !== void 0) {
        texture.generateMipmaps = texData.generateMipmaps;
      }
      texture.needsUpdate = true;
      if (onLoad)
        onLoad(texture, texData);
    }, onProgress, onError);
    return texture;
  }
}
class TextureLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const texture = new Texture$1();
    const loader2 = new ImageLoader$2(this.manager);
    loader2.setCrossOrigin(this.crossOrigin);
    loader2.setPath(this.path);
    loader2.load(url2, function(image) {
      texture.image = image;
      texture.needsUpdate = true;
      if (onLoad !== void 0) {
        onLoad(texture);
      }
    }, onProgress, onError);
    return texture;
  }
}
class Light extends Object3D {
  constructor(color, intensity = 1) {
    super();
    this.type = "Light";
    this.color = new Color(color);
    this.intensity = intensity;
  }
  dispose() {
  }
  copy(source) {
    super.copy(source);
    this.color.copy(source.color);
    this.intensity = source.intensity;
    return this;
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    data2.object.color = this.color.getHex();
    data2.object.intensity = this.intensity;
    if (this.groundColor !== void 0)
      data2.object.groundColor = this.groundColor.getHex();
    if (this.distance !== void 0)
      data2.object.distance = this.distance;
    if (this.angle !== void 0)
      data2.object.angle = this.angle;
    if (this.decay !== void 0)
      data2.object.decay = this.decay;
    if (this.penumbra !== void 0)
      data2.object.penumbra = this.penumbra;
    if (this.shadow !== void 0)
      data2.object.shadow = this.shadow.toJSON();
    return data2;
  }
}
Light.prototype.isLight = true;
class HemisphereLight extends Light {
  constructor(skyColor, groundColor, intensity) {
    super(skyColor, intensity);
    this.type = "HemisphereLight";
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.groundColor = new Color(groundColor);
  }
  copy(source) {
    Light.prototype.copy.call(this, source);
    this.groundColor.copy(source.groundColor);
    return this;
  }
}
HemisphereLight.prototype.isHemisphereLight = true;
const _projScreenMatrix$1 = /* @__PURE__ */ new Matrix4$1();
const _lightPositionWorld$1 = /* @__PURE__ */ new Vector3$1();
const _lookTarget$1 = /* @__PURE__ */ new Vector3$1();
class LightShadow {
  constructor(camera) {
    this.camera = camera;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.blurSamples = 8;
    this.mapSize = new Vector2$1(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix4$1();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum();
    this._frameExtents = new Vector2$1(1, 1);
    this._viewportCount = 1;
    this._viewports = [
      new Vector4$1(0, 0, 1, 1)
    ];
  }
  getViewportCount() {
    return this._viewportCount;
  }
  getFrustum() {
    return this._frustum;
  }
  updateMatrices(light) {
    const shadowCamera = this.camera;
    const shadowMatrix = this.matrix;
    _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
    shadowCamera.position.copy(_lightPositionWorld$1);
    _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
    shadowCamera.lookAt(_lookTarget$1);
    shadowCamera.updateMatrixWorld();
    _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);
    shadowMatrix.set(
      0.5,
      0,
      0,
      0.5,
      0,
      0.5,
      0,
      0.5,
      0,
      0,
      0.5,
      0.5,
      0,
      0,
      0,
      1
    );
    shadowMatrix.multiply(shadowCamera.projectionMatrix);
    shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
  }
  getViewport(viewportIndex) {
    return this._viewports[viewportIndex];
  }
  getFrameExtents() {
    return this._frameExtents;
  }
  dispose() {
    if (this.map) {
      this.map.dispose();
    }
    if (this.mapPass) {
      this.mapPass.dispose();
    }
  }
  copy(source) {
    this.camera = source.camera.clone();
    this.bias = source.bias;
    this.radius = source.radius;
    this.mapSize.copy(source.mapSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const object2 = {};
    if (this.bias !== 0)
      object2.bias = this.bias;
    if (this.normalBias !== 0)
      object2.normalBias = this.normalBias;
    if (this.radius !== 1)
      object2.radius = this.radius;
    if (this.mapSize.x !== 512 || this.mapSize.y !== 512)
      object2.mapSize = this.mapSize.toArray();
    object2.camera = this.camera.toJSON(false).object;
    delete object2.camera.matrix;
    return object2;
  }
}
class SpotLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera(50, 1, 0.5, 500));
    this.focus = 1;
  }
  updateMatrices(light) {
    const camera = this.camera;
    const fov2 = RAD2DEG * 2 * light.angle * this.focus;
    const aspect2 = this.mapSize.width / this.mapSize.height;
    const far = light.distance || camera.far;
    if (fov2 !== camera.fov || aspect2 !== camera.aspect || far !== camera.far) {
      camera.fov = fov2;
      camera.aspect = aspect2;
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    super.updateMatrices(light);
  }
  copy(source) {
    super.copy(source);
    this.focus = source.focus;
    return this;
  }
}
SpotLightShadow.prototype.isSpotLightShadow = true;
class SpotLight extends Light {
  constructor(color, intensity, distance11 = 0, angle4 = Math.PI / 3, penumbra = 0, decay = 1) {
    super(color, intensity);
    this.type = "SpotLight";
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    this.distance = distance11;
    this.angle = angle4;
    this.penumbra = penumbra;
    this.decay = decay;
    this.shadow = new SpotLightShadow();
  }
  get power() {
    return this.intensity * Math.PI;
  }
  set power(power) {
    this.intensity = power / Math.PI;
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.distance = source.distance;
    this.angle = source.angle;
    this.penumbra = source.penumbra;
    this.decay = source.decay;
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
}
SpotLight.prototype.isSpotLight = true;
const _projScreenMatrix = /* @__PURE__ */ new Matrix4$1();
const _lightPositionWorld = /* @__PURE__ */ new Vector3$1();
const _lookTarget = /* @__PURE__ */ new Vector3$1();
class PointLightShadow extends LightShadow {
  constructor() {
    super(new PerspectiveCamera(90, 1, 0.5, 500));
    this._frameExtents = new Vector2$1(4, 2);
    this._viewportCount = 6;
    this._viewports = [
      // These viewports map a cube-map onto a 2D texture with the
      // following orientation:
      //
      //  xzXZ
      //   y Y
      //
      // X - Positive x direction
      // x - Negative x direction
      // Y - Positive y direction
      // y - Negative y direction
      // Z - Positive z direction
      // z - Negative z direction
      // positive X
      new Vector4$1(2, 1, 1, 1),
      // negative X
      new Vector4$1(0, 1, 1, 1),
      // positive Z
      new Vector4$1(3, 1, 1, 1),
      // negative Z
      new Vector4$1(1, 1, 1, 1),
      // positive Y
      new Vector4$1(3, 0, 1, 1),
      // negative Y
      new Vector4$1(1, 0, 1, 1)
    ];
    this._cubeDirections = [
      new Vector3$1(1, 0, 0),
      new Vector3$1(-1, 0, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, -1, 0)
    ];
    this._cubeUps = [
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 1, 0),
      new Vector3$1(0, 0, 1),
      new Vector3$1(0, 0, -1)
    ];
  }
  updateMatrices(light, viewportIndex = 0) {
    const camera = this.camera;
    const shadowMatrix = this.matrix;
    const far = light.distance || camera.far;
    if (far !== camera.far) {
      camera.far = far;
      camera.updateProjectionMatrix();
    }
    _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
    camera.position.copy(_lightPositionWorld);
    _lookTarget.copy(camera.position);
    _lookTarget.add(this._cubeDirections[viewportIndex]);
    camera.up.copy(this._cubeUps[viewportIndex]);
    camera.lookAt(_lookTarget);
    camera.updateMatrixWorld();
    shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
    _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
    this._frustum.setFromProjectionMatrix(_projScreenMatrix);
  }
}
PointLightShadow.prototype.isPointLightShadow = true;
class PointLight extends Light {
  constructor(color, intensity, distance11 = 0, decay = 1) {
    super(color, intensity);
    this.type = "PointLight";
    this.distance = distance11;
    this.decay = decay;
    this.shadow = new PointLightShadow();
  }
  get power() {
    return this.intensity * 4 * Math.PI;
  }
  set power(power) {
    this.intensity = power / (4 * Math.PI);
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.distance = source.distance;
    this.decay = source.decay;
    this.shadow = source.shadow.clone();
    return this;
  }
}
PointLight.prototype.isPointLight = true;
class DirectionalLightShadow extends LightShadow {
  constructor() {
    super(new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
  }
}
DirectionalLightShadow.prototype.isDirectionalLightShadow = true;
let DirectionalLight$1 = class DirectionalLight2 extends Light {
  constructor(color, intensity) {
    super(color, intensity);
    this.type = "DirectionalLight";
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    this.shadow = new DirectionalLightShadow();
  }
  dispose() {
    this.shadow.dispose();
  }
  copy(source) {
    super.copy(source);
    this.target = source.target.clone();
    this.shadow = source.shadow.clone();
    return this;
  }
};
DirectionalLight$1.prototype.isDirectionalLight = true;
let AmbientLight$1 = class AmbientLight2 extends Light {
  constructor(color, intensity) {
    super(color, intensity);
    this.type = "AmbientLight";
  }
};
AmbientLight$1.prototype.isAmbientLight = true;
class RectAreaLight extends Light {
  constructor(color, intensity, width = 10, height = 10) {
    super(color, intensity);
    this.type = "RectAreaLight";
    this.width = width;
    this.height = height;
  }
  get power() {
    return this.intensity * this.width * this.height * Math.PI;
  }
  set power(power) {
    this.intensity = power / (this.width * this.height * Math.PI);
  }
  copy(source) {
    super.copy(source);
    this.width = source.width;
    this.height = source.height;
    return this;
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    data2.object.width = this.width;
    data2.object.height = this.height;
    return data2;
  }
}
RectAreaLight.prototype.isRectAreaLight = true;
class SphericalHarmonics3 {
  constructor() {
    this.coefficients = [];
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients.push(new Vector3$1());
    }
  }
  set(coefficients) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].copy(coefficients[i2]);
    }
    return this;
  }
  zero() {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].set(0, 0, 0);
    }
    return this;
  }
  // get the radiance in the direction of the normal
  // target is a Vector3
  getAt(normal, target) {
    const x2 = normal.x, y2 = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.282095);
    target.addScaledVector(coeff[1], 0.488603 * y2);
    target.addScaledVector(coeff[2], 0.488603 * z2);
    target.addScaledVector(coeff[3], 0.488603 * x2);
    target.addScaledVector(coeff[4], 1.092548 * (x2 * y2));
    target.addScaledVector(coeff[5], 1.092548 * (y2 * z2));
    target.addScaledVector(coeff[6], 0.315392 * (3 * z2 * z2 - 1));
    target.addScaledVector(coeff[7], 1.092548 * (x2 * z2));
    target.addScaledVector(coeff[8], 0.546274 * (x2 * x2 - y2 * y2));
    return target;
  }
  // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
  // target is a Vector3
  // https://graphics.stanford.edu/papers/envmap/envmap.pdf
  getIrradianceAt(normal, target) {
    const x2 = normal.x, y2 = normal.y, z2 = normal.z;
    const coeff = this.coefficients;
    target.copy(coeff[0]).multiplyScalar(0.886227);
    target.addScaledVector(coeff[1], 2 * 0.511664 * y2);
    target.addScaledVector(coeff[2], 2 * 0.511664 * z2);
    target.addScaledVector(coeff[3], 2 * 0.511664 * x2);
    target.addScaledVector(coeff[4], 2 * 0.429043 * x2 * y2);
    target.addScaledVector(coeff[5], 2 * 0.429043 * y2 * z2);
    target.addScaledVector(coeff[6], 0.743125 * z2 * z2 - 0.247708);
    target.addScaledVector(coeff[7], 2 * 0.429043 * x2 * z2);
    target.addScaledVector(coeff[8], 0.429043 * (x2 * x2 - y2 * y2));
    return target;
  }
  add(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].add(sh.coefficients[i2]);
    }
    return this;
  }
  addScaledSH(sh, s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].addScaledVector(sh.coefficients[i2], s2);
    }
    return this;
  }
  scale(s2) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].multiplyScalar(s2);
    }
    return this;
  }
  lerp(sh, alpha) {
    for (let i2 = 0; i2 < 9; i2++) {
      this.coefficients[i2].lerp(sh.coefficients[i2], alpha);
    }
    return this;
  }
  equals(sh) {
    for (let i2 = 0; i2 < 9; i2++) {
      if (!this.coefficients[i2].equals(sh.coefficients[i2])) {
        return false;
      }
    }
    return true;
  }
  copy(sh) {
    return this.set(sh.coefficients);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(array2, offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].fromArray(array2, offset + i2 * 3);
    }
    return this;
  }
  toArray(array2 = [], offset = 0) {
    const coefficients = this.coefficients;
    for (let i2 = 0; i2 < 9; i2++) {
      coefficients[i2].toArray(array2, offset + i2 * 3);
    }
    return array2;
  }
  // evaluate the basis functions
  // shBasis is an Array[ 9 ]
  static getBasisAt(normal, shBasis) {
    const x2 = normal.x, y2 = normal.y, z2 = normal.z;
    shBasis[0] = 0.282095;
    shBasis[1] = 0.488603 * y2;
    shBasis[2] = 0.488603 * z2;
    shBasis[3] = 0.488603 * x2;
    shBasis[4] = 1.092548 * x2 * y2;
    shBasis[5] = 1.092548 * y2 * z2;
    shBasis[6] = 0.315392 * (3 * z2 * z2 - 1);
    shBasis[7] = 1.092548 * x2 * z2;
    shBasis[8] = 0.546274 * (x2 * x2 - y2 * y2);
  }
}
SphericalHarmonics3.prototype.isSphericalHarmonics3 = true;
class LightProbe extends Light {
  constructor(sh = new SphericalHarmonics3(), intensity = 1) {
    super(void 0, intensity);
    this.sh = sh;
  }
  copy(source) {
    super.copy(source);
    this.sh.copy(source.sh);
    return this;
  }
  fromJSON(json) {
    this.intensity = json.intensity;
    this.sh.fromArray(json.sh);
    return this;
  }
  toJSON(meta2) {
    const data2 = super.toJSON(meta2);
    data2.object.sh = this.sh.toArray();
    return data2;
  }
}
LightProbe.prototype.isLightProbe = true;
class MaterialLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.textures = {};
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const loader2 = new FileLoader(scope.manager);
    loader2.setPath(scope.path);
    loader2.setRequestHeader(scope.requestHeader);
    loader2.setWithCredentials(scope.withCredentials);
    loader2.load(url2, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e3) {
        if (onError) {
          onError(e3);
        } else {
          console.error(e3);
        }
        scope.manager.itemError(url2);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const textures = this.textures;
    function getTexture2(name2) {
      if (textures[name2] === void 0) {
        console.warn("THREE.MaterialLoader: Undefined texture", name2);
      }
      return textures[name2];
    }
    const material = Material$1.fromType(json.type);
    if (json.uuid !== void 0)
      material.uuid = json.uuid;
    if (json.name !== void 0)
      material.name = json.name;
    if (json.color !== void 0 && material.color !== void 0)
      material.color.setHex(json.color);
    if (json.roughness !== void 0)
      material.roughness = json.roughness;
    if (json.metalness !== void 0)
      material.metalness = json.metalness;
    if (json.sheen !== void 0)
      material.sheen = json.sheen;
    if (json.sheenColor !== void 0)
      material.sheenColor = new Color().setHex(json.sheenColor);
    if (json.sheenRoughness !== void 0)
      material.sheenRoughness = json.sheenRoughness;
    if (json.emissive !== void 0 && material.emissive !== void 0)
      material.emissive.setHex(json.emissive);
    if (json.specular !== void 0 && material.specular !== void 0)
      material.specular.setHex(json.specular);
    if (json.specularIntensity !== void 0)
      material.specularIntensity = json.specularIntensity;
    if (json.specularColor !== void 0 && material.specularColor !== void 0)
      material.specularColor.setHex(json.specularColor);
    if (json.shininess !== void 0)
      material.shininess = json.shininess;
    if (json.clearcoat !== void 0)
      material.clearcoat = json.clearcoat;
    if (json.clearcoatRoughness !== void 0)
      material.clearcoatRoughness = json.clearcoatRoughness;
    if (json.transmission !== void 0)
      material.transmission = json.transmission;
    if (json.thickness !== void 0)
      material.thickness = json.thickness;
    if (json.attenuationDistance !== void 0)
      material.attenuationDistance = json.attenuationDistance;
    if (json.attenuationColor !== void 0 && material.attenuationColor !== void 0)
      material.attenuationColor.setHex(json.attenuationColor);
    if (json.fog !== void 0)
      material.fog = json.fog;
    if (json.flatShading !== void 0)
      material.flatShading = json.flatShading;
    if (json.blending !== void 0)
      material.blending = json.blending;
    if (json.combine !== void 0)
      material.combine = json.combine;
    if (json.side !== void 0)
      material.side = json.side;
    if (json.shadowSide !== void 0)
      material.shadowSide = json.shadowSide;
    if (json.opacity !== void 0)
      material.opacity = json.opacity;
    if (json.transparent !== void 0)
      material.transparent = json.transparent;
    if (json.alphaTest !== void 0)
      material.alphaTest = json.alphaTest;
    if (json.depthTest !== void 0)
      material.depthTest = json.depthTest;
    if (json.depthWrite !== void 0)
      material.depthWrite = json.depthWrite;
    if (json.colorWrite !== void 0)
      material.colorWrite = json.colorWrite;
    if (json.stencilWrite !== void 0)
      material.stencilWrite = json.stencilWrite;
    if (json.stencilWriteMask !== void 0)
      material.stencilWriteMask = json.stencilWriteMask;
    if (json.stencilFunc !== void 0)
      material.stencilFunc = json.stencilFunc;
    if (json.stencilRef !== void 0)
      material.stencilRef = json.stencilRef;
    if (json.stencilFuncMask !== void 0)
      material.stencilFuncMask = json.stencilFuncMask;
    if (json.stencilFail !== void 0)
      material.stencilFail = json.stencilFail;
    if (json.stencilZFail !== void 0)
      material.stencilZFail = json.stencilZFail;
    if (json.stencilZPass !== void 0)
      material.stencilZPass = json.stencilZPass;
    if (json.wireframe !== void 0)
      material.wireframe = json.wireframe;
    if (json.wireframeLinewidth !== void 0)
      material.wireframeLinewidth = json.wireframeLinewidth;
    if (json.wireframeLinecap !== void 0)
      material.wireframeLinecap = json.wireframeLinecap;
    if (json.wireframeLinejoin !== void 0)
      material.wireframeLinejoin = json.wireframeLinejoin;
    if (json.rotation !== void 0)
      material.rotation = json.rotation;
    if (json.linewidth !== 1)
      material.linewidth = json.linewidth;
    if (json.dashSize !== void 0)
      material.dashSize = json.dashSize;
    if (json.gapSize !== void 0)
      material.gapSize = json.gapSize;
    if (json.scale !== void 0)
      material.scale = json.scale;
    if (json.polygonOffset !== void 0)
      material.polygonOffset = json.polygonOffset;
    if (json.polygonOffsetFactor !== void 0)
      material.polygonOffsetFactor = json.polygonOffsetFactor;
    if (json.polygonOffsetUnits !== void 0)
      material.polygonOffsetUnits = json.polygonOffsetUnits;
    if (json.dithering !== void 0)
      material.dithering = json.dithering;
    if (json.alphaToCoverage !== void 0)
      material.alphaToCoverage = json.alphaToCoverage;
    if (json.premultipliedAlpha !== void 0)
      material.premultipliedAlpha = json.premultipliedAlpha;
    if (json.visible !== void 0)
      material.visible = json.visible;
    if (json.toneMapped !== void 0)
      material.toneMapped = json.toneMapped;
    if (json.userData !== void 0)
      material.userData = json.userData;
    if (json.vertexColors !== void 0) {
      if (typeof json.vertexColors === "number") {
        material.vertexColors = json.vertexColors > 0 ? true : false;
      } else {
        material.vertexColors = json.vertexColors;
      }
    }
    if (json.uniforms !== void 0) {
      for (const name2 in json.uniforms) {
        const uniform = json.uniforms[name2];
        material.uniforms[name2] = {};
        switch (uniform.type) {
          case "t":
            material.uniforms[name2].value = getTexture2(uniform.value);
            break;
          case "c":
            material.uniforms[name2].value = new Color().setHex(uniform.value);
            break;
          case "v2":
            material.uniforms[name2].value = new Vector2$1().fromArray(uniform.value);
            break;
          case "v3":
            material.uniforms[name2].value = new Vector3$1().fromArray(uniform.value);
            break;
          case "v4":
            material.uniforms[name2].value = new Vector4$1().fromArray(uniform.value);
            break;
          case "m3":
            material.uniforms[name2].value = new Matrix3$1().fromArray(uniform.value);
            break;
          case "m4":
            material.uniforms[name2].value = new Matrix4$1().fromArray(uniform.value);
            break;
          default:
            material.uniforms[name2].value = uniform.value;
        }
      }
    }
    if (json.defines !== void 0)
      material.defines = json.defines;
    if (json.vertexShader !== void 0)
      material.vertexShader = json.vertexShader;
    if (json.fragmentShader !== void 0)
      material.fragmentShader = json.fragmentShader;
    if (json.extensions !== void 0) {
      for (const key in json.extensions) {
        material.extensions[key] = json.extensions[key];
      }
    }
    if (json.shading !== void 0)
      material.flatShading = json.shading === 1;
    if (json.size !== void 0)
      material.size = json.size;
    if (json.sizeAttenuation !== void 0)
      material.sizeAttenuation = json.sizeAttenuation;
    if (json.map !== void 0)
      material.map = getTexture2(json.map);
    if (json.matcap !== void 0)
      material.matcap = getTexture2(json.matcap);
    if (json.alphaMap !== void 0)
      material.alphaMap = getTexture2(json.alphaMap);
    if (json.bumpMap !== void 0)
      material.bumpMap = getTexture2(json.bumpMap);
    if (json.bumpScale !== void 0)
      material.bumpScale = json.bumpScale;
    if (json.normalMap !== void 0)
      material.normalMap = getTexture2(json.normalMap);
    if (json.normalMapType !== void 0)
      material.normalMapType = json.normalMapType;
    if (json.normalScale !== void 0) {
      let normalScale = json.normalScale;
      if (Array.isArray(normalScale) === false) {
        normalScale = [normalScale, normalScale];
      }
      material.normalScale = new Vector2$1().fromArray(normalScale);
    }
    if (json.displacementMap !== void 0)
      material.displacementMap = getTexture2(json.displacementMap);
    if (json.displacementScale !== void 0)
      material.displacementScale = json.displacementScale;
    if (json.displacementBias !== void 0)
      material.displacementBias = json.displacementBias;
    if (json.roughnessMap !== void 0)
      material.roughnessMap = getTexture2(json.roughnessMap);
    if (json.metalnessMap !== void 0)
      material.metalnessMap = getTexture2(json.metalnessMap);
    if (json.emissiveMap !== void 0)
      material.emissiveMap = getTexture2(json.emissiveMap);
    if (json.emissiveIntensity !== void 0)
      material.emissiveIntensity = json.emissiveIntensity;
    if (json.specularMap !== void 0)
      material.specularMap = getTexture2(json.specularMap);
    if (json.specularIntensityMap !== void 0)
      material.specularIntensityMap = getTexture2(json.specularIntensityMap);
    if (json.specularColorMap !== void 0)
      material.specularColorMap = getTexture2(json.specularColorMap);
    if (json.envMap !== void 0)
      material.envMap = getTexture2(json.envMap);
    if (json.envMapIntensity !== void 0)
      material.envMapIntensity = json.envMapIntensity;
    if (json.reflectivity !== void 0)
      material.reflectivity = json.reflectivity;
    if (json.refractionRatio !== void 0)
      material.refractionRatio = json.refractionRatio;
    if (json.lightMap !== void 0)
      material.lightMap = getTexture2(json.lightMap);
    if (json.lightMapIntensity !== void 0)
      material.lightMapIntensity = json.lightMapIntensity;
    if (json.aoMap !== void 0)
      material.aoMap = getTexture2(json.aoMap);
    if (json.aoMapIntensity !== void 0)
      material.aoMapIntensity = json.aoMapIntensity;
    if (json.gradientMap !== void 0)
      material.gradientMap = getTexture2(json.gradientMap);
    if (json.clearcoatMap !== void 0)
      material.clearcoatMap = getTexture2(json.clearcoatMap);
    if (json.clearcoatRoughnessMap !== void 0)
      material.clearcoatRoughnessMap = getTexture2(json.clearcoatRoughnessMap);
    if (json.clearcoatNormalMap !== void 0)
      material.clearcoatNormalMap = getTexture2(json.clearcoatNormalMap);
    if (json.clearcoatNormalScale !== void 0)
      material.clearcoatNormalScale = new Vector2$1().fromArray(json.clearcoatNormalScale);
    if (json.transmissionMap !== void 0)
      material.transmissionMap = getTexture2(json.transmissionMap);
    if (json.thicknessMap !== void 0)
      material.thicknessMap = getTexture2(json.thicknessMap);
    if (json.sheenColorMap !== void 0)
      material.sheenColorMap = getTexture2(json.sheenColorMap);
    if (json.sheenRoughnessMap !== void 0)
      material.sheenRoughnessMap = getTexture2(json.sheenRoughnessMap);
    return material;
  }
  setTextures(value) {
    this.textures = value;
    return this;
  }
}
class LoaderUtils {
  static decodeText(array2) {
    if (typeof TextDecoder !== "undefined") {
      return new TextDecoder().decode(array2);
    }
    let s2 = "";
    for (let i2 = 0, il = array2.length; i2 < il; i2++) {
      s2 += String.fromCharCode(array2[i2]);
    }
    try {
      return decodeURIComponent(escape(s2));
    } catch (e3) {
      return s2;
    }
  }
  static extractUrlBase(url2) {
    const index2 = url2.lastIndexOf("/");
    if (index2 === -1)
      return "./";
    return url2.slice(0, index2 + 1);
  }
  static resolveURL(url2, path2) {
    if (typeof url2 !== "string" || url2 === "")
      return "";
    if (/^https?:\/\//i.test(path2) && /^\//.test(url2)) {
      path2 = path2.replace(/(^https?:\/\/[^\/]+).*/i, "$1");
    }
    if (/^(https?:)?\/\//i.test(url2))
      return url2;
    if (/^data:.*,.*$/i.test(url2))
      return url2;
    if (/^blob:.*$/i.test(url2))
      return url2;
    return path2 + url2;
  }
}
class InstancedBufferGeometry extends BufferGeometry {
  constructor() {
    super();
    this.type = "InstancedBufferGeometry";
    this.instanceCount = Infinity;
  }
  copy(source) {
    super.copy(source);
    this.instanceCount = source.instanceCount;
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  toJSON() {
    const data2 = super.toJSON(this);
    data2.instanceCount = this.instanceCount;
    data2.isInstancedBufferGeometry = true;
    return data2;
  }
}
InstancedBufferGeometry.prototype.isInstancedBufferGeometry = true;
class BufferGeometryLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const loader2 = new FileLoader(scope.manager);
    loader2.setPath(scope.path);
    loader2.setRequestHeader(scope.requestHeader);
    loader2.setWithCredentials(scope.withCredentials);
    loader2.load(url2, function(text) {
      try {
        onLoad(scope.parse(JSON.parse(text)));
      } catch (e3) {
        if (onError) {
          onError(e3);
        } else {
          console.error(e3);
        }
        scope.manager.itemError(url2);
      }
    }, onProgress, onError);
  }
  parse(json) {
    const interleavedBufferMap = {};
    const arrayBufferMap = {};
    function getInterleavedBuffer(json2, uuid) {
      if (interleavedBufferMap[uuid] !== void 0)
        return interleavedBufferMap[uuid];
      const interleavedBuffers = json2.interleavedBuffers;
      const interleavedBuffer = interleavedBuffers[uuid];
      const buffer3 = getArrayBuffer(json2, interleavedBuffer.buffer);
      const array2 = getTypedArray(interleavedBuffer.type, buffer3);
      const ib = new InterleavedBuffer(array2, interleavedBuffer.stride);
      ib.uuid = interleavedBuffer.uuid;
      interleavedBufferMap[uuid] = ib;
      return ib;
    }
    function getArrayBuffer(json2, uuid) {
      if (arrayBufferMap[uuid] !== void 0)
        return arrayBufferMap[uuid];
      const arrayBuffers = json2.arrayBuffers;
      const arrayBuffer2 = arrayBuffers[uuid];
      const ab2 = new Uint32Array(arrayBuffer2).buffer;
      arrayBufferMap[uuid] = ab2;
      return ab2;
    }
    const geometry2 = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();
    const index2 = json.data.index;
    if (index2 !== void 0) {
      const typedArray = getTypedArray(index2.type, index2.array);
      geometry2.setIndex(new BufferAttribute(typedArray, 1));
    }
    const attributes = json.data.attributes;
    for (const key in attributes) {
      const attribute = attributes[key];
      let bufferAttribute;
      if (attribute.isInterleavedBufferAttribute) {
        const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
        bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
      } else {
        const typedArray = getTypedArray(attribute.type, attribute.array);
        const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
        bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
      }
      if (attribute.name !== void 0)
        bufferAttribute.name = attribute.name;
      if (attribute.usage !== void 0)
        bufferAttribute.setUsage(attribute.usage);
      if (attribute.updateRange !== void 0) {
        bufferAttribute.updateRange.offset = attribute.updateRange.offset;
        bufferAttribute.updateRange.count = attribute.updateRange.count;
      }
      geometry2.setAttribute(key, bufferAttribute);
    }
    const morphAttributes = json.data.morphAttributes;
    if (morphAttributes) {
      for (const key in morphAttributes) {
        const attributeArray = morphAttributes[key];
        const array2 = [];
        for (let i2 = 0, il = attributeArray.length; i2 < il; i2++) {
          const attribute = attributeArray[i2];
          let bufferAttribute;
          if (attribute.isInterleavedBufferAttribute) {
            const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
            bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
          } else {
            const typedArray = getTypedArray(attribute.type, attribute.array);
            bufferAttribute = new BufferAttribute(typedArray, attribute.itemSize, attribute.normalized);
          }
          if (attribute.name !== void 0)
            bufferAttribute.name = attribute.name;
          array2.push(bufferAttribute);
        }
        geometry2.morphAttributes[key] = array2;
      }
    }
    const morphTargetsRelative = json.data.morphTargetsRelative;
    if (morphTargetsRelative) {
      geometry2.morphTargetsRelative = true;
    }
    const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
    if (groups !== void 0) {
      for (let i2 = 0, n2 = groups.length; i2 !== n2; ++i2) {
        const group = groups[i2];
        geometry2.addGroup(group.start, group.count, group.materialIndex);
      }
    }
    const boundingSphere = json.data.boundingSphere;
    if (boundingSphere !== void 0) {
      const center2 = new Vector3$1();
      if (boundingSphere.center !== void 0) {
        center2.fromArray(boundingSphere.center);
      }
      geometry2.boundingSphere = new Sphere(center2, boundingSphere.radius);
    }
    if (json.name)
      geometry2.name = json.name;
    if (json.userData)
      geometry2.userData = json.userData;
    return geometry2;
  }
}
class ObjectLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const path2 = this.path === "" ? LoaderUtils.extractUrlBase(url2) : this.path;
    this.resourcePath = this.resourcePath || path2;
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(url2, function(text) {
      let json = null;
      try {
        json = JSON.parse(text);
      } catch (error2) {
        if (onError !== void 0)
          onError(error2);
        console.error("THREE:ObjectLoader: Can't parse " + url2 + ".", error2.message);
        return;
      }
      const metadata = json.metadata;
      if (metadata === void 0 || metadata.type === void 0 || metadata.type.toLowerCase() === "geometry") {
        console.error("THREE.ObjectLoader: Can't load " + url2);
        return;
      }
      scope.parse(json, onLoad);
    }, onProgress, onError);
  }
  async loadAsync(url2, onProgress) {
    const scope = this;
    const path2 = this.path === "" ? LoaderUtils.extractUrlBase(url2) : this.path;
    this.resourcePath = this.resourcePath || path2;
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    const text = await loader2.loadAsync(url2, onProgress);
    const json = JSON.parse(text);
    const metadata = json.metadata;
    if (metadata === void 0 || metadata.type === void 0 || metadata.type.toLowerCase() === "geometry") {
      throw new Error("THREE.ObjectLoader: Can't load " + url2);
    }
    return await scope.parseAsync(json);
  }
  parse(json, onLoad) {
    const animations = this.parseAnimations(json.animations);
    const shapes = this.parseShapes(json.shapes);
    const geometries = this.parseGeometries(json.geometries, shapes);
    const images = this.parseImages(json.images, function() {
      if (onLoad !== void 0)
        onLoad(object2);
    });
    const textures = this.parseTextures(json.textures, images);
    const materials = this.parseMaterials(json.materials, textures);
    const object2 = this.parseObject(json.object, geometries, materials, textures, animations);
    const skeletons = this.parseSkeletons(json.skeletons, object2);
    this.bindSkeletons(object2, skeletons);
    if (onLoad !== void 0) {
      let hasImages = false;
      for (const uuid in images) {
        if (images[uuid] instanceof HTMLImageElement) {
          hasImages = true;
          break;
        }
      }
      if (hasImages === false)
        onLoad(object2);
    }
    return object2;
  }
  async parseAsync(json) {
    const animations = this.parseAnimations(json.animations);
    const shapes = this.parseShapes(json.shapes);
    const geometries = this.parseGeometries(json.geometries, shapes);
    const images = await this.parseImagesAsync(json.images);
    const textures = this.parseTextures(json.textures, images);
    const materials = this.parseMaterials(json.materials, textures);
    const object2 = this.parseObject(json.object, geometries, materials, textures, animations);
    const skeletons = this.parseSkeletons(json.skeletons, object2);
    this.bindSkeletons(object2, skeletons);
    return object2;
  }
  parseShapes(json) {
    const shapes = {};
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const shape2 = new Shape().fromJSON(json[i2]);
        shapes[shape2.uuid] = shape2;
      }
    }
    return shapes;
  }
  parseSkeletons(json, object2) {
    const skeletons = {};
    const bones = {};
    object2.traverse(function(child) {
      if (child.isBone)
        bones[child.uuid] = child;
    });
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const skeleton = new Skeleton().fromJSON(json[i2], bones);
        skeletons[skeleton.uuid] = skeleton;
      }
    }
    return skeletons;
  }
  parseGeometries(json, shapes) {
    const geometries = {};
    if (json !== void 0) {
      const bufferGeometryLoader = new BufferGeometryLoader();
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        let geometry2;
        const data2 = json[i2];
        switch (data2.type) {
          case "BufferGeometry":
          case "InstancedBufferGeometry":
            geometry2 = bufferGeometryLoader.parse(data2);
            break;
          case "Geometry":
            console.error("THREE.ObjectLoader: The legacy Geometry type is no longer supported.");
            break;
          default:
            if (data2.type in Geometries) {
              geometry2 = Geometries[data2.type].fromJSON(data2, shapes);
            } else {
              console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data2.type}"`);
            }
        }
        geometry2.uuid = data2.uuid;
        if (data2.name !== void 0)
          geometry2.name = data2.name;
        if (geometry2.isBufferGeometry === true && data2.userData !== void 0)
          geometry2.userData = data2.userData;
        geometries[data2.uuid] = geometry2;
      }
    }
    return geometries;
  }
  parseMaterials(json, textures) {
    const cache2 = {};
    const materials = {};
    if (json !== void 0) {
      const loader2 = new MaterialLoader();
      loader2.setTextures(textures);
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const data2 = json[i2];
        if (data2.type === "MultiMaterial") {
          const array2 = [];
          for (let j2 = 0; j2 < data2.materials.length; j2++) {
            const material = data2.materials[j2];
            if (cache2[material.uuid] === void 0) {
              cache2[material.uuid] = loader2.parse(material);
            }
            array2.push(cache2[material.uuid]);
          }
          materials[data2.uuid] = array2;
        } else {
          if (cache2[data2.uuid] === void 0) {
            cache2[data2.uuid] = loader2.parse(data2);
          }
          materials[data2.uuid] = cache2[data2.uuid];
        }
      }
    }
    return materials;
  }
  parseAnimations(json) {
    const animations = {};
    if (json !== void 0) {
      for (let i2 = 0; i2 < json.length; i2++) {
        const data2 = json[i2];
        const clip2 = AnimationClip.parse(data2);
        animations[clip2.uuid] = clip2;
      }
    }
    return animations;
  }
  parseImages(json, onLoad) {
    const scope = this;
    const images = {};
    let loader2;
    function loadImage2(url2) {
      scope.manager.itemStart(url2);
      return loader2.load(url2, function() {
        scope.manager.itemEnd(url2);
      }, void 0, function() {
        scope.manager.itemError(url2);
        scope.manager.itemEnd(url2);
      });
    }
    function deserializeImage(image) {
      if (typeof image === "string") {
        const url2 = image;
        const path2 = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url2) ? url2 : scope.resourcePath + url2;
        return loadImage2(path2);
      } else {
        if (image.data) {
          return {
            data: getTypedArray(image.type, image.data),
            width: image.width,
            height: image.height
          };
        } else {
          return null;
        }
      }
    }
    if (json !== void 0 && json.length > 0) {
      const manager = new LoadingManager(onLoad);
      loader2 = new ImageLoader$2(manager);
      loader2.setCrossOrigin(this.crossOrigin);
      for (let i2 = 0, il = json.length; i2 < il; i2++) {
        const image = json[i2];
        const url2 = image.url;
        if (Array.isArray(url2)) {
          const imageArray = [];
          for (let j2 = 0, jl = url2.length; j2 < jl; j2++) {
            const currentUrl = url2[j2];
            const deserializedImage = deserializeImage(currentUrl);
            if (deserializedImage !== null) {
              if (deserializedImage instanceof HTMLImageElement) {
                imageArray.push(deserializedImage);
              } else {
                imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
              }
            }
          }
          images[image.uuid] = new Source(imageArray);
        } else {
          const deserializedImage = deserializeImage(image.url);
          images[image.uuid] = new Source(deserializedImage);
        }
      }
    }
    return images;
  }
  async parseImagesAsync(json) {
    const scope = this;
    const images = {};
    let loader2;
    async function deserializeImage(image) {
      if (typeof image === "string") {
        const url2 = image;
        const path2 = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url2) ? url2 : scope.resourcePath + url2;
        return await loader2.loadAsync(path2);
      } else {
        if (image.data) {
          return {
            data: getTypedArray(image.type, image.data),
            width: image.width,
            height: image.height
          };
        } else {
          return null;
        }
      }
    }
    if (json !== void 0 && json.length > 0) {
      loader2 = new ImageLoader$2(this.manager);
      loader2.setCrossOrigin(this.crossOrigin);
      for (let i2 = 0, il = json.length; i2 < il; i2++) {
        const image = json[i2];
        const url2 = image.url;
        if (Array.isArray(url2)) {
          const imageArray = [];
          for (let j2 = 0, jl = url2.length; j2 < jl; j2++) {
            const currentUrl = url2[j2];
            const deserializedImage = await deserializeImage(currentUrl);
            if (deserializedImage !== null) {
              if (deserializedImage instanceof HTMLImageElement) {
                imageArray.push(deserializedImage);
              } else {
                imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
              }
            }
          }
          images[image.uuid] = new Source(imageArray);
        } else {
          const deserializedImage = await deserializeImage(image.url);
          images[image.uuid] = new Source(deserializedImage);
        }
      }
    }
    return images;
  }
  parseTextures(json, images) {
    function parseConstant(value, type) {
      if (typeof value === "number")
        return value;
      console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", value);
      return type[value];
    }
    const textures = {};
    if (json !== void 0) {
      for (let i2 = 0, l2 = json.length; i2 < l2; i2++) {
        const data2 = json[i2];
        if (data2.image === void 0) {
          console.warn('THREE.ObjectLoader: No "image" specified for', data2.uuid);
        }
        if (images[data2.image] === void 0) {
          console.warn("THREE.ObjectLoader: Undefined image", data2.image);
        }
        const source = images[data2.image];
        const image = source.data;
        let texture;
        if (Array.isArray(image)) {
          texture = new CubeTexture();
          if (image.length === 6)
            texture.needsUpdate = true;
        } else {
          if (image && image.data) {
            texture = new DataTexture();
          } else {
            texture = new Texture$1();
          }
          if (image)
            texture.needsUpdate = true;
        }
        texture.source = source;
        texture.uuid = data2.uuid;
        if (data2.name !== void 0)
          texture.name = data2.name;
        if (data2.mapping !== void 0)
          texture.mapping = parseConstant(data2.mapping, TEXTURE_MAPPING);
        if (data2.offset !== void 0)
          texture.offset.fromArray(data2.offset);
        if (data2.repeat !== void 0)
          texture.repeat.fromArray(data2.repeat);
        if (data2.center !== void 0)
          texture.center.fromArray(data2.center);
        if (data2.rotation !== void 0)
          texture.rotation = data2.rotation;
        if (data2.wrap !== void 0) {
          texture.wrapS = parseConstant(data2.wrap[0], TEXTURE_WRAPPING);
          texture.wrapT = parseConstant(data2.wrap[1], TEXTURE_WRAPPING);
        }
        if (data2.format !== void 0)
          texture.format = data2.format;
        if (data2.type !== void 0)
          texture.type = data2.type;
        if (data2.encoding !== void 0)
          texture.encoding = data2.encoding;
        if (data2.minFilter !== void 0)
          texture.minFilter = parseConstant(data2.minFilter, TEXTURE_FILTER);
        if (data2.magFilter !== void 0)
          texture.magFilter = parseConstant(data2.magFilter, TEXTURE_FILTER);
        if (data2.anisotropy !== void 0)
          texture.anisotropy = data2.anisotropy;
        if (data2.flipY !== void 0)
          texture.flipY = data2.flipY;
        if (data2.premultiplyAlpha !== void 0)
          texture.premultiplyAlpha = data2.premultiplyAlpha;
        if (data2.unpackAlignment !== void 0)
          texture.unpackAlignment = data2.unpackAlignment;
        if (data2.userData !== void 0)
          texture.userData = data2.userData;
        textures[data2.uuid] = texture;
      }
    }
    return textures;
  }
  parseObject(data2, geometries, materials, textures, animations) {
    let object2;
    function getGeometry4(name2) {
      if (geometries[name2] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined geometry", name2);
      }
      return geometries[name2];
    }
    function getMaterial(name2) {
      if (name2 === void 0)
        return void 0;
      if (Array.isArray(name2)) {
        const array2 = [];
        for (let i2 = 0, l2 = name2.length; i2 < l2; i2++) {
          const uuid = name2[i2];
          if (materials[uuid] === void 0) {
            console.warn("THREE.ObjectLoader: Undefined material", uuid);
          }
          array2.push(materials[uuid]);
        }
        return array2;
      }
      if (materials[name2] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined material", name2);
      }
      return materials[name2];
    }
    function getTexture2(uuid) {
      if (textures[uuid] === void 0) {
        console.warn("THREE.ObjectLoader: Undefined texture", uuid);
      }
      return textures[uuid];
    }
    let geometry2, material;
    switch (data2.type) {
      case "Scene":
        object2 = new Scene();
        if (data2.background !== void 0) {
          if (Number.isInteger(data2.background)) {
            object2.background = new Color(data2.background);
          } else {
            object2.background = getTexture2(data2.background);
          }
        }
        if (data2.environment !== void 0) {
          object2.environment = getTexture2(data2.environment);
        }
        if (data2.fog !== void 0) {
          if (data2.fog.type === "Fog") {
            object2.fog = new Fog(data2.fog.color, data2.fog.near, data2.fog.far);
          } else if (data2.fog.type === "FogExp2") {
            object2.fog = new FogExp2(data2.fog.color, data2.fog.density);
          }
        }
        break;
      case "PerspectiveCamera":
        object2 = new PerspectiveCamera(data2.fov, data2.aspect, data2.near, data2.far);
        if (data2.focus !== void 0)
          object2.focus = data2.focus;
        if (data2.zoom !== void 0)
          object2.zoom = data2.zoom;
        if (data2.filmGauge !== void 0)
          object2.filmGauge = data2.filmGauge;
        if (data2.filmOffset !== void 0)
          object2.filmOffset = data2.filmOffset;
        if (data2.view !== void 0)
          object2.view = Object.assign({}, data2.view);
        break;
      case "OrthographicCamera":
        object2 = new OrthographicCamera(data2.left, data2.right, data2.top, data2.bottom, data2.near, data2.far);
        if (data2.zoom !== void 0)
          object2.zoom = data2.zoom;
        if (data2.view !== void 0)
          object2.view = Object.assign({}, data2.view);
        break;
      case "AmbientLight":
        object2 = new AmbientLight$1(data2.color, data2.intensity);
        break;
      case "DirectionalLight":
        object2 = new DirectionalLight$1(data2.color, data2.intensity);
        break;
      case "PointLight":
        object2 = new PointLight(data2.color, data2.intensity, data2.distance, data2.decay);
        break;
      case "RectAreaLight":
        object2 = new RectAreaLight(data2.color, data2.intensity, data2.width, data2.height);
        break;
      case "SpotLight":
        object2 = new SpotLight(data2.color, data2.intensity, data2.distance, data2.angle, data2.penumbra, data2.decay);
        break;
      case "HemisphereLight":
        object2 = new HemisphereLight(data2.color, data2.groundColor, data2.intensity);
        break;
      case "LightProbe":
        object2 = new LightProbe().fromJSON(data2);
        break;
      case "SkinnedMesh":
        geometry2 = getGeometry4(data2.geometry);
        material = getMaterial(data2.material);
        object2 = new SkinnedMesh(geometry2, material);
        if (data2.bindMode !== void 0)
          object2.bindMode = data2.bindMode;
        if (data2.bindMatrix !== void 0)
          object2.bindMatrix.fromArray(data2.bindMatrix);
        if (data2.skeleton !== void 0)
          object2.skeleton = data2.skeleton;
        break;
      case "Mesh":
        geometry2 = getGeometry4(data2.geometry);
        material = getMaterial(data2.material);
        object2 = new Mesh(geometry2, material);
        break;
      case "InstancedMesh":
        geometry2 = getGeometry4(data2.geometry);
        material = getMaterial(data2.material);
        const count3 = data2.count;
        const instanceMatrix = data2.instanceMatrix;
        const instanceColor = data2.instanceColor;
        object2 = new InstancedMesh(geometry2, material, count3);
        object2.instanceMatrix = new InstancedBufferAttribute(new Float32Array(instanceMatrix.array), 16);
        if (instanceColor !== void 0)
          object2.instanceColor = new InstancedBufferAttribute(new Float32Array(instanceColor.array), instanceColor.itemSize);
        break;
      case "LOD":
        object2 = new LOD();
        break;
      case "Line":
        object2 = new Line(getGeometry4(data2.geometry), getMaterial(data2.material));
        break;
      case "LineLoop":
        object2 = new LineLoop(getGeometry4(data2.geometry), getMaterial(data2.material));
        break;
      case "LineSegments":
        object2 = new LineSegments(getGeometry4(data2.geometry), getMaterial(data2.material));
        break;
      case "PointCloud":
      case "Points":
        object2 = new Points(getGeometry4(data2.geometry), getMaterial(data2.material));
        break;
      case "Sprite":
        object2 = new Sprite(getMaterial(data2.material));
        break;
      case "Group":
        object2 = new Group();
        break;
      case "Bone":
        object2 = new Bone();
        break;
      default:
        object2 = new Object3D();
    }
    object2.uuid = data2.uuid;
    if (data2.name !== void 0)
      object2.name = data2.name;
    if (data2.matrix !== void 0) {
      object2.matrix.fromArray(data2.matrix);
      if (data2.matrixAutoUpdate !== void 0)
        object2.matrixAutoUpdate = data2.matrixAutoUpdate;
      if (object2.matrixAutoUpdate)
        object2.matrix.decompose(object2.position, object2.quaternion, object2.scale);
    } else {
      if (data2.position !== void 0)
        object2.position.fromArray(data2.position);
      if (data2.rotation !== void 0)
        object2.rotation.fromArray(data2.rotation);
      if (data2.quaternion !== void 0)
        object2.quaternion.fromArray(data2.quaternion);
      if (data2.scale !== void 0)
        object2.scale.fromArray(data2.scale);
    }
    if (data2.castShadow !== void 0)
      object2.castShadow = data2.castShadow;
    if (data2.receiveShadow !== void 0)
      object2.receiveShadow = data2.receiveShadow;
    if (data2.shadow) {
      if (data2.shadow.bias !== void 0)
        object2.shadow.bias = data2.shadow.bias;
      if (data2.shadow.normalBias !== void 0)
        object2.shadow.normalBias = data2.shadow.normalBias;
      if (data2.shadow.radius !== void 0)
        object2.shadow.radius = data2.shadow.radius;
      if (data2.shadow.mapSize !== void 0)
        object2.shadow.mapSize.fromArray(data2.shadow.mapSize);
      if (data2.shadow.camera !== void 0)
        object2.shadow.camera = this.parseObject(data2.shadow.camera);
    }
    if (data2.visible !== void 0)
      object2.visible = data2.visible;
    if (data2.frustumCulled !== void 0)
      object2.frustumCulled = data2.frustumCulled;
    if (data2.renderOrder !== void 0)
      object2.renderOrder = data2.renderOrder;
    if (data2.userData !== void 0)
      object2.userData = data2.userData;
    if (data2.layers !== void 0)
      object2.layers.mask = data2.layers;
    if (data2.children !== void 0) {
      const children = data2.children;
      for (let i2 = 0; i2 < children.length; i2++) {
        object2.add(this.parseObject(children[i2], geometries, materials, textures, animations));
      }
    }
    if (data2.animations !== void 0) {
      const objectAnimations = data2.animations;
      for (let i2 = 0; i2 < objectAnimations.length; i2++) {
        const uuid = objectAnimations[i2];
        object2.animations.push(animations[uuid]);
      }
    }
    if (data2.type === "LOD") {
      if (data2.autoUpdate !== void 0)
        object2.autoUpdate = data2.autoUpdate;
      const levels = data2.levels;
      for (let l2 = 0; l2 < levels.length; l2++) {
        const level = levels[l2];
        const child = object2.getObjectByProperty("uuid", level.object);
        if (child !== void 0) {
          object2.addLevel(child, level.distance);
        }
      }
    }
    return object2;
  }
  bindSkeletons(object2, skeletons) {
    if (Object.keys(skeletons).length === 0)
      return;
    object2.traverse(function(child) {
      if (child.isSkinnedMesh === true && child.skeleton !== void 0) {
        const skeleton = skeletons[child.skeleton];
        if (skeleton === void 0) {
          console.warn("THREE.ObjectLoader: No skeleton found with UUID:", child.skeleton);
        } else {
          child.bind(skeleton, child.bindMatrix);
        }
      }
    });
  }
  /* DEPRECATED */
  setTexturePath(value) {
    console.warn("THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().");
    return this.setResourcePath(value);
  }
}
const TEXTURE_MAPPING = {
  UVMapping,
  CubeReflectionMapping,
  CubeRefractionMapping,
  EquirectangularReflectionMapping,
  EquirectangularRefractionMapping,
  CubeUVReflectionMapping
};
const TEXTURE_WRAPPING = {
  RepeatWrapping,
  ClampToEdgeWrapping,
  MirroredRepeatWrapping
};
const TEXTURE_FILTER = {
  NearestFilter,
  NearestMipmapNearestFilter,
  NearestMipmapLinearFilter,
  LinearFilter,
  LinearMipmapNearestFilter,
  LinearMipmapLinearFilter
};
class ImageBitmapLoader extends Loader {
  constructor(manager) {
    super(manager);
    if (typeof createImageBitmap === "undefined") {
      console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported.");
    }
    if (typeof fetch === "undefined") {
      console.warn("THREE.ImageBitmapLoader: fetch() not supported.");
    }
    this.options = { premultiplyAlpha: "none" };
  }
  setOptions(options2) {
    this.options = options2;
    return this;
  }
  load(url2, onLoad, onProgress, onError) {
    if (url2 === void 0)
      url2 = "";
    if (this.path !== void 0)
      url2 = this.path + url2;
    url2 = this.manager.resolveURL(url2);
    const scope = this;
    const cached = Cache.get(url2);
    if (cached !== void 0) {
      scope.manager.itemStart(url2);
      setTimeout(function() {
        if (onLoad)
          onLoad(cached);
        scope.manager.itemEnd(url2);
      }, 0);
      return cached;
    }
    const fetchOptions = {};
    fetchOptions.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include";
    fetchOptions.headers = this.requestHeader;
    fetch(url2, fetchOptions).then(function(res) {
      return res.blob();
    }).then(function(blob) {
      return createImageBitmap(blob, Object.assign(scope.options, { colorSpaceConversion: "none" }));
    }).then(function(imageBitmap) {
      Cache.add(url2, imageBitmap);
      if (onLoad)
        onLoad(imageBitmap);
      scope.manager.itemEnd(url2);
    }).catch(function(e3) {
      if (onError)
        onError(e3);
      scope.manager.itemError(url2);
      scope.manager.itemEnd(url2);
    });
    scope.manager.itemStart(url2);
  }
}
ImageBitmapLoader.prototype.isImageBitmapLoader = true;
let _context;
const AudioContext = {
  getContext: function() {
    if (_context === void 0) {
      _context = new (window.AudioContext || window.webkitAudioContext)();
    }
    return _context;
  },
  setContext: function(value) {
    _context = value;
  }
};
class AudioLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const loader2 = new FileLoader(this.manager);
    loader2.setResponseType("arraybuffer");
    loader2.setPath(this.path);
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(url2, function(buffer3) {
      try {
        const bufferCopy = buffer3.slice(0);
        const context2 = AudioContext.getContext();
        context2.decodeAudioData(bufferCopy, function(audioBuffer) {
          onLoad(audioBuffer);
        });
      } catch (e3) {
        if (onError) {
          onError(e3);
        } else {
          console.error(e3);
        }
        scope.manager.itemError(url2);
      }
    }, onProgress, onError);
  }
}
class HemisphereLightProbe extends LightProbe {
  constructor(skyColor, groundColor, intensity = 1) {
    super(void 0, intensity);
    const color1 = new Color().set(skyColor);
    const color2 = new Color().set(groundColor);
    const sky = new Vector3$1(color1.r, color1.g, color1.b);
    const ground = new Vector3$1(color2.r, color2.g, color2.b);
    const c0 = Math.sqrt(Math.PI);
    const c1 = c0 * Math.sqrt(0.75);
    this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
    this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
  }
}
HemisphereLightProbe.prototype.isHemisphereLightProbe = true;
class AmbientLightProbe extends LightProbe {
  constructor(color, intensity = 1) {
    super(void 0, intensity);
    const color1 = new Color().set(color);
    this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
  }
}
AmbientLightProbe.prototype.isAmbientLightProbe = true;
const _eyeRight = /* @__PURE__ */ new Matrix4$1();
const _eyeLeft = /* @__PURE__ */ new Matrix4$1();
const _projectionMatrix = /* @__PURE__ */ new Matrix4$1();
class StereoCamera {
  constructor() {
    this.type = "StereoCamera";
    this.aspect = 1;
    this.eyeSep = 0.064;
    this.cameraL = new PerspectiveCamera();
    this.cameraL.layers.enable(1);
    this.cameraL.matrixAutoUpdate = false;
    this.cameraR = new PerspectiveCamera();
    this.cameraR.layers.enable(2);
    this.cameraR.matrixAutoUpdate = false;
    this._cache = {
      focus: null,
      fov: null,
      aspect: null,
      near: null,
      far: null,
      zoom: null,
      eyeSep: null
    };
  }
  update(camera) {
    const cache2 = this._cache;
    const needsUpdate = cache2.focus !== camera.focus || cache2.fov !== camera.fov || cache2.aspect !== camera.aspect * this.aspect || cache2.near !== camera.near || cache2.far !== camera.far || cache2.zoom !== camera.zoom || cache2.eyeSep !== this.eyeSep;
    if (needsUpdate) {
      cache2.focus = camera.focus;
      cache2.fov = camera.fov;
      cache2.aspect = camera.aspect * this.aspect;
      cache2.near = camera.near;
      cache2.far = camera.far;
      cache2.zoom = camera.zoom;
      cache2.eyeSep = this.eyeSep;
      _projectionMatrix.copy(camera.projectionMatrix);
      const eyeSepHalf = cache2.eyeSep / 2;
      const eyeSepOnProjection = eyeSepHalf * cache2.near / cache2.focus;
      const ymax = cache2.near * Math.tan(DEG2RAD$1 * cache2.fov * 0.5) / cache2.zoom;
      let xmin, xmax;
      _eyeLeft.elements[12] = -eyeSepHalf;
      _eyeRight.elements[12] = eyeSepHalf;
      xmin = -ymax * cache2.aspect + eyeSepOnProjection;
      xmax = ymax * cache2.aspect + eyeSepOnProjection;
      _projectionMatrix.elements[0] = 2 * cache2.near / (xmax - xmin);
      _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
      this.cameraL.projectionMatrix.copy(_projectionMatrix);
      xmin = -ymax * cache2.aspect - eyeSepOnProjection;
      xmax = ymax * cache2.aspect - eyeSepOnProjection;
      _projectionMatrix.elements[0] = 2 * cache2.near / (xmax - xmin);
      _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
      this.cameraR.projectionMatrix.copy(_projectionMatrix);
    }
    this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
    this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
  }
}
class Clock {
  constructor(autoStart = true) {
    this.autoStart = autoStart;
    this.startTime = 0;
    this.oldTime = 0;
    this.elapsedTime = 0;
    this.running = false;
  }
  start() {
    this.startTime = now$3();
    this.oldTime = this.startTime;
    this.elapsedTime = 0;
    this.running = true;
  }
  stop() {
    this.getElapsedTime();
    this.running = false;
    this.autoStart = false;
  }
  getElapsedTime() {
    this.getDelta();
    return this.elapsedTime;
  }
  getDelta() {
    let diff2 = 0;
    if (this.autoStart && !this.running) {
      this.start();
      return 0;
    }
    if (this.running) {
      const newTime = now$3();
      diff2 = (newTime - this.oldTime) / 1e3;
      this.oldTime = newTime;
      this.elapsedTime += diff2;
    }
    return diff2;
  }
}
function now$3() {
  return (typeof performance === "undefined" ? Date : performance).now();
}
const _position$1 = /* @__PURE__ */ new Vector3$1();
const _quaternion$1 = /* @__PURE__ */ new Quaternion$1();
const _scale$1 = /* @__PURE__ */ new Vector3$1();
const _orientation$1 = /* @__PURE__ */ new Vector3$1();
class AudioListener extends Object3D {
  constructor() {
    super();
    this.type = "AudioListener";
    this.context = AudioContext.getContext();
    this.gain = this.context.createGain();
    this.gain.connect(this.context.destination);
    this.filter = null;
    this.timeDelta = 0;
    this._clock = new Clock();
  }
  getInput() {
    return this.gain;
  }
  removeFilter() {
    if (this.filter !== null) {
      this.gain.disconnect(this.filter);
      this.filter.disconnect(this.context.destination);
      this.gain.connect(this.context.destination);
      this.filter = null;
    }
    return this;
  }
  getFilter() {
    return this.filter;
  }
  setFilter(value) {
    if (this.filter !== null) {
      this.gain.disconnect(this.filter);
      this.filter.disconnect(this.context.destination);
    } else {
      this.gain.disconnect(this.context.destination);
    }
    this.filter = value;
    this.gain.connect(this.filter);
    this.filter.connect(this.context.destination);
    return this;
  }
  getMasterVolume() {
    return this.gain.gain.value;
  }
  setMasterVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    const listener = this.context.listener;
    const up = this.up;
    this.timeDelta = this._clock.getDelta();
    this.matrixWorld.decompose(_position$1, _quaternion$1, _scale$1);
    _orientation$1.set(0, 0, -1).applyQuaternion(_quaternion$1);
    if (listener.positionX) {
      const endTime = this.context.currentTime + this.timeDelta;
      listener.positionX.linearRampToValueAtTime(_position$1.x, endTime);
      listener.positionY.linearRampToValueAtTime(_position$1.y, endTime);
      listener.positionZ.linearRampToValueAtTime(_position$1.z, endTime);
      listener.forwardX.linearRampToValueAtTime(_orientation$1.x, endTime);
      listener.forwardY.linearRampToValueAtTime(_orientation$1.y, endTime);
      listener.forwardZ.linearRampToValueAtTime(_orientation$1.z, endTime);
      listener.upX.linearRampToValueAtTime(up.x, endTime);
      listener.upY.linearRampToValueAtTime(up.y, endTime);
      listener.upZ.linearRampToValueAtTime(up.z, endTime);
    } else {
      listener.setPosition(_position$1.x, _position$1.y, _position$1.z);
      listener.setOrientation(_orientation$1.x, _orientation$1.y, _orientation$1.z, up.x, up.y, up.z);
    }
  }
}
class Audio extends Object3D {
  constructor(listener) {
    super();
    this.type = "Audio";
    this.listener = listener;
    this.context = listener.context;
    this.gain = this.context.createGain();
    this.gain.connect(listener.getInput());
    this.autoplay = false;
    this.buffer = null;
    this.detune = 0;
    this.loop = false;
    this.loopStart = 0;
    this.loopEnd = 0;
    this.offset = 0;
    this.duration = void 0;
    this.playbackRate = 1;
    this.isPlaying = false;
    this.hasPlaybackControl = true;
    this.source = null;
    this.sourceType = "empty";
    this._startedAt = 0;
    this._progress = 0;
    this._connected = false;
    this.filters = [];
  }
  getOutput() {
    return this.gain;
  }
  setNodeSource(audioNode) {
    this.hasPlaybackControl = false;
    this.sourceType = "audioNode";
    this.source = audioNode;
    this.connect();
    return this;
  }
  setMediaElementSource(mediaElement) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaNode";
    this.source = this.context.createMediaElementSource(mediaElement);
    this.connect();
    return this;
  }
  setMediaStreamSource(mediaStream) {
    this.hasPlaybackControl = false;
    this.sourceType = "mediaStreamNode";
    this.source = this.context.createMediaStreamSource(mediaStream);
    this.connect();
    return this;
  }
  setBuffer(audioBuffer) {
    this.buffer = audioBuffer;
    this.sourceType = "buffer";
    if (this.autoplay)
      this.play();
    return this;
  }
  play(delay = 0) {
    if (this.isPlaying === true) {
      console.warn("THREE.Audio: Audio is already playing.");
      return;
    }
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._startedAt = this.context.currentTime + delay;
    const source = this.context.createBufferSource();
    source.buffer = this.buffer;
    source.loop = this.loop;
    source.loopStart = this.loopStart;
    source.loopEnd = this.loopEnd;
    source.onended = this.onEnded.bind(this);
    source.start(this._startedAt, this._progress + this.offset, this.duration);
    this.isPlaying = true;
    this.source = source;
    this.setDetune(this.detune);
    this.setPlaybackRate(this.playbackRate);
    return this.connect();
  }
  pause() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    if (this.isPlaying === true) {
      this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
      if (this.loop === true) {
        this._progress = this._progress % (this.duration || this.buffer.duration);
      }
      this.source.stop();
      this.source.onended = null;
      this.isPlaying = false;
    }
    return this;
  }
  stop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this._progress = 0;
    this.source.stop();
    this.source.onended = null;
    this.isPlaying = false;
    return this;
  }
  connect() {
    if (this.filters.length > 0) {
      this.source.connect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].connect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].connect(this.getOutput());
    } else {
      this.source.connect(this.getOutput());
    }
    this._connected = true;
    return this;
  }
  disconnect() {
    if (this.filters.length > 0) {
      this.source.disconnect(this.filters[0]);
      for (let i2 = 1, l2 = this.filters.length; i2 < l2; i2++) {
        this.filters[i2 - 1].disconnect(this.filters[i2]);
      }
      this.filters[this.filters.length - 1].disconnect(this.getOutput());
    } else {
      this.source.disconnect(this.getOutput());
    }
    this._connected = false;
    return this;
  }
  getFilters() {
    return this.filters;
  }
  setFilters(value) {
    if (!value)
      value = [];
    if (this._connected === true) {
      this.disconnect();
      this.filters = value.slice();
      this.connect();
    } else {
      this.filters = value.slice();
    }
    return this;
  }
  setDetune(value) {
    this.detune = value;
    if (this.source.detune === void 0)
      return;
    if (this.isPlaying === true) {
      this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
    }
    return this;
  }
  getDetune() {
    return this.detune;
  }
  getFilter() {
    return this.getFilters()[0];
  }
  setFilter(filter17) {
    return this.setFilters(filter17 ? [filter17] : []);
  }
  setPlaybackRate(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.playbackRate = value;
    if (this.isPlaying === true) {
      this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
    }
    return this;
  }
  getPlaybackRate() {
    return this.playbackRate;
  }
  onEnded() {
    this.isPlaying = false;
  }
  getLoop() {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return false;
    }
    return this.loop;
  }
  setLoop(value) {
    if (this.hasPlaybackControl === false) {
      console.warn("THREE.Audio: this Audio has no playback control.");
      return;
    }
    this.loop = value;
    if (this.isPlaying === true) {
      this.source.loop = this.loop;
    }
    return this;
  }
  setLoopStart(value) {
    this.loopStart = value;
    return this;
  }
  setLoopEnd(value) {
    this.loopEnd = value;
    return this;
  }
  getVolume() {
    return this.gain.gain.value;
  }
  setVolume(value) {
    this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
    return this;
  }
}
const _position = /* @__PURE__ */ new Vector3$1();
const _quaternion = /* @__PURE__ */ new Quaternion$1();
const _scale = /* @__PURE__ */ new Vector3$1();
const _orientation = /* @__PURE__ */ new Vector3$1();
class PositionalAudio extends Audio {
  constructor(listener) {
    super(listener);
    this.panner = this.context.createPanner();
    this.panner.panningModel = "HRTF";
    this.panner.connect(this.gain);
  }
  disconnect() {
    super.disconnect();
    this.panner.disconnect(this.gain);
  }
  getOutput() {
    return this.panner;
  }
  getRefDistance() {
    return this.panner.refDistance;
  }
  setRefDistance(value) {
    this.panner.refDistance = value;
    return this;
  }
  getRolloffFactor() {
    return this.panner.rolloffFactor;
  }
  setRolloffFactor(value) {
    this.panner.rolloffFactor = value;
    return this;
  }
  getDistanceModel() {
    return this.panner.distanceModel;
  }
  setDistanceModel(value) {
    this.panner.distanceModel = value;
    return this;
  }
  getMaxDistance() {
    return this.panner.maxDistance;
  }
  setMaxDistance(value) {
    this.panner.maxDistance = value;
    return this;
  }
  setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
    this.panner.coneInnerAngle = coneInnerAngle;
    this.panner.coneOuterAngle = coneOuterAngle;
    this.panner.coneOuterGain = coneOuterGain;
    return this;
  }
  updateMatrixWorld(force) {
    super.updateMatrixWorld(force);
    if (this.hasPlaybackControl === true && this.isPlaying === false)
      return;
    this.matrixWorld.decompose(_position, _quaternion, _scale);
    _orientation.set(0, 0, 1).applyQuaternion(_quaternion);
    const panner = this.panner;
    if (panner.positionX) {
      const endTime = this.context.currentTime + this.listener.timeDelta;
      panner.positionX.linearRampToValueAtTime(_position.x, endTime);
      panner.positionY.linearRampToValueAtTime(_position.y, endTime);
      panner.positionZ.linearRampToValueAtTime(_position.z, endTime);
      panner.orientationX.linearRampToValueAtTime(_orientation.x, endTime);
      panner.orientationY.linearRampToValueAtTime(_orientation.y, endTime);
      panner.orientationZ.linearRampToValueAtTime(_orientation.z, endTime);
    } else {
      panner.setPosition(_position.x, _position.y, _position.z);
      panner.setOrientation(_orientation.x, _orientation.y, _orientation.z);
    }
  }
}
class AudioAnalyser {
  constructor(audio, fftSize = 2048) {
    this.analyser = audio.context.createAnalyser();
    this.analyser.fftSize = fftSize;
    this.data = new Uint8Array(this.analyser.frequencyBinCount);
    audio.getOutput().connect(this.analyser);
  }
  getFrequencyData() {
    this.analyser.getByteFrequencyData(this.data);
    return this.data;
  }
  getAverageFrequency() {
    let value = 0;
    const data2 = this.getFrequencyData();
    for (let i2 = 0; i2 < data2.length; i2++) {
      value += data2[i2];
    }
    return value / data2.length;
  }
}
class PropertyMixer {
  constructor(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    switch (typeName) {
      case "quaternion":
        mixFunction = this._slerp;
        mixFunctionAdditive = this._slerpAdditive;
        setIdentity = this._setAdditiveIdentityQuaternion;
        this.buffer = new Float64Array(valueSize * 6);
        this._workIndex = 5;
        break;
      case "string":
      case "bool":
        mixFunction = this._select;
        mixFunctionAdditive = this._select;
        setIdentity = this._setAdditiveIdentityOther;
        this.buffer = new Array(valueSize * 5);
        break;
      default:
        mixFunction = this._lerp;
        mixFunctionAdditive = this._lerpAdditive;
        setIdentity = this._setAdditiveIdentityNumeric;
        this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
  }
  // accumulate data in the 'incoming' region into 'accu<i>'
  accumulate(accuIndex, weight) {
    const buffer3 = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
    let currentWeight = this.cumulativeWeight;
    if (currentWeight === 0) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer3[offset + i2] = buffer3[i2];
      }
      currentWeight = weight;
    } else {
      currentWeight += weight;
      const mix = weight / currentWeight;
      this._mixBufferRegion(buffer3, offset, 0, mix, stride);
    }
    this.cumulativeWeight = currentWeight;
  }
  // accumulate data in the 'incoming' region into 'add'
  accumulateAdditive(weight) {
    const buffer3 = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
    if (this.cumulativeWeightAdditive === 0) {
      this._setIdentity();
    }
    this._mixBufferRegionAdditive(buffer3, offset, 0, weight, stride);
    this.cumulativeWeightAdditive += weight;
  }
  // apply the state of 'accu<i>' to the binding when accus differ
  apply(accuIndex) {
    const stride = this.valueSize, buffer3 = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    if (weight < 1) {
      const originalValueOffset = stride * this._origIndex;
      this._mixBufferRegion(
        buffer3,
        offset,
        originalValueOffset,
        1 - weight,
        stride
      );
    }
    if (weightAdditive > 0) {
      this._mixBufferRegionAdditive(buffer3, offset, this._addIndex * stride, 1, stride);
    }
    for (let i2 = stride, e3 = stride + stride; i2 !== e3; ++i2) {
      if (buffer3[i2] !== buffer3[i2 + stride]) {
        binding.setValue(buffer3, offset);
        break;
      }
    }
  }
  // remember the state of the bound property and copy it to both accus
  saveOriginalState() {
    const binding = this.binding;
    const buffer3 = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
    binding.getValue(buffer3, originalValueOffset);
    for (let i2 = stride, e3 = originalValueOffset; i2 !== e3; ++i2) {
      buffer3[i2] = buffer3[originalValueOffset + i2 % stride];
    }
    this._setIdentity();
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
  }
  // apply the state previously taken via 'saveOriginalState' to the binding
  restoreOriginalState() {
    const originalValueOffset = this.valueSize * 3;
    this.binding.setValue(this.buffer, originalValueOffset);
  }
  _setAdditiveIdentityNumeric() {
    const startIndex = this._addIndex * this.valueSize;
    const endIndex = startIndex + this.valueSize;
    for (let i2 = startIndex; i2 < endIndex; i2++) {
      this.buffer[i2] = 0;
    }
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric();
    this.buffer[this._addIndex * this.valueSize + 3] = 1;
  }
  _setAdditiveIdentityOther() {
    const startIndex = this._origIndex * this.valueSize;
    const targetIndex = this._addIndex * this.valueSize;
    for (let i2 = 0; i2 < this.valueSize; i2++) {
      this.buffer[targetIndex + i2] = this.buffer[startIndex + i2];
    }
  }
  // mix functions
  _select(buffer3, dstOffset, srcOffset, t2, stride) {
    if (t2 >= 0.5) {
      for (let i2 = 0; i2 !== stride; ++i2) {
        buffer3[dstOffset + i2] = buffer3[srcOffset + i2];
      }
    }
  }
  _slerp(buffer3, dstOffset, srcOffset, t2) {
    Quaternion$1.slerpFlat(buffer3, dstOffset, buffer3, dstOffset, buffer3, srcOffset, t2);
  }
  _slerpAdditive(buffer3, dstOffset, srcOffset, t2, stride) {
    const workOffset = this._workIndex * stride;
    Quaternion$1.multiplyQuaternionsFlat(buffer3, workOffset, buffer3, dstOffset, buffer3, srcOffset);
    Quaternion$1.slerpFlat(buffer3, dstOffset, buffer3, dstOffset, buffer3, workOffset, t2);
  }
  _lerp(buffer3, dstOffset, srcOffset, t2, stride) {
    const s2 = 1 - t2;
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j2 = dstOffset + i2;
      buffer3[j2] = buffer3[j2] * s2 + buffer3[srcOffset + i2] * t2;
    }
  }
  _lerpAdditive(buffer3, dstOffset, srcOffset, t2, stride) {
    for (let i2 = 0; i2 !== stride; ++i2) {
      const j2 = dstOffset + i2;
      buffer3[j2] = buffer3[j2] + buffer3[srcOffset + i2] * t2;
    }
  }
}
const _RESERVED_CHARS_RE = "\\[\\]\\.:\\/";
const _reservedRe = new RegExp("[" + _RESERVED_CHARS_RE + "]", "g");
const _wordChar = "[^" + _RESERVED_CHARS_RE + "]";
const _wordCharOrDot = "[^" + _RESERVED_CHARS_RE.replace("\\.", "") + "]";
const _directoryRe = /((?:WC+[\/:])*)/.source.replace("WC", _wordChar);
const _nodeRe = /(WCOD+)?/.source.replace("WCOD", _wordCharOrDot);
const _objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _wordChar);
const _propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _wordChar);
const _trackRe = new RegExp(
  "^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + "$"
);
const _supportedObjectNames = ["material", "materials", "bones"];
class Composite {
  constructor(targetGroup, path2, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path2);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path2, parsedPath);
  }
  getValue(array2, offset) {
    this.bind();
    const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
    if (binding !== void 0)
      binding.getValue(array2, offset);
  }
  setValue(array2, offset) {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].setValue(array2, offset);
    }
  }
  bind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].bind();
    }
  }
  unbind() {
    const bindings = this._bindings;
    for (let i2 = this._targetGroup.nCachedObjects_, n2 = bindings.length; i2 !== n2; ++i2) {
      bindings[i2].unbind();
    }
  }
}
class PropertyBinding {
  constructor(rootNode, path2, parsedPath) {
    this.path = path2;
    this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path2);
    this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
    this.rootNode = rootNode;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
  static create(root2, path2, parsedPath) {
    if (!(root2 && root2.isAnimationObjectGroup)) {
      return new PropertyBinding(root2, path2, parsedPath);
    } else {
      return new PropertyBinding.Composite(root2, path2, parsedPath);
    }
  }
  /**
   * Replaces spaces with underscores and removes unsupported characters from
   * node names, to ensure compatibility with parseTrackName().
   *
   * @param {string} name Node name to be sanitized.
   * @return {string}
   */
  static sanitizeNodeName(name2) {
    return name2.replace(/\s/g, "_").replace(_reservedRe, "");
  }
  static parseTrackName(trackName) {
    const matches2 = _trackRe.exec(trackName);
    if (matches2 === null) {
      throw new Error("PropertyBinding: Cannot parse trackName: " + trackName);
    }
    const results = {
      // directoryName: matches[ 1 ], // (tschw) currently unused
      nodeName: matches2[2],
      objectName: matches2[3],
      objectIndex: matches2[4],
      propertyName: matches2[5],
      // required
      propertyIndex: matches2[6]
    };
    const lastDot = results.nodeName && results.nodeName.lastIndexOf(".");
    if (lastDot !== void 0 && lastDot !== -1) {
      const objectName = results.nodeName.substring(lastDot + 1);
      if (_supportedObjectNames.indexOf(objectName) !== -1) {
        results.nodeName = results.nodeName.substring(0, lastDot);
        results.objectName = objectName;
      }
    }
    if (results.propertyName === null || results.propertyName.length === 0) {
      throw new Error("PropertyBinding: can not parse propertyName from trackName: " + trackName);
    }
    return results;
  }
  static findNode(root2, nodeName) {
    if (nodeName === void 0 || nodeName === "" || nodeName === "." || nodeName === -1 || nodeName === root2.name || nodeName === root2.uuid) {
      return root2;
    }
    if (root2.skeleton) {
      const bone = root2.skeleton.getBoneByName(nodeName);
      if (bone !== void 0) {
        return bone;
      }
    }
    if (root2.children) {
      const searchNodeSubtree = function(children) {
        for (let i2 = 0; i2 < children.length; i2++) {
          const childNode = children[i2];
          if (childNode.name === nodeName || childNode.uuid === nodeName) {
            return childNode;
          }
          const result = searchNodeSubtree(childNode.children);
          if (result)
            return result;
        }
        return null;
      };
      const subTreeNode = searchNodeSubtree(root2.children);
      if (subTreeNode) {
        return subTreeNode;
      }
    }
    return null;
  }
  // these are used to "bind" a nonexistent property
  _getValue_unavailable() {
  }
  _setValue_unavailable() {
  }
  // Getters
  _getValue_direct(buffer3, offset) {
    buffer3[offset] = this.targetObject[this.propertyName];
  }
  _getValue_array(buffer3, offset) {
    const source = this.resolvedProperty;
    for (let i2 = 0, n2 = source.length; i2 !== n2; ++i2) {
      buffer3[offset++] = source[i2];
    }
  }
  _getValue_arrayElement(buffer3, offset) {
    buffer3[offset] = this.resolvedProperty[this.propertyIndex];
  }
  _getValue_toArray(buffer3, offset) {
    this.resolvedProperty.toArray(buffer3, offset);
  }
  // Direct
  _setValue_direct(buffer3, offset) {
    this.targetObject[this.propertyName] = buffer3[offset];
  }
  _setValue_direct_setNeedsUpdate(buffer3, offset) {
    this.targetObject[this.propertyName] = buffer3[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(buffer3, offset) {
    this.targetObject[this.propertyName] = buffer3[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // EntireArray
  _setValue_array(buffer3, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer3[offset++];
    }
  }
  _setValue_array_setNeedsUpdate(buffer3, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer3[offset++];
    }
    this.targetObject.needsUpdate = true;
  }
  _setValue_array_setMatrixWorldNeedsUpdate(buffer3, offset) {
    const dest = this.resolvedProperty;
    for (let i2 = 0, n2 = dest.length; i2 !== n2; ++i2) {
      dest[i2] = buffer3[offset++];
    }
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // ArrayElement
  _setValue_arrayElement(buffer3, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer3[offset];
  }
  _setValue_arrayElement_setNeedsUpdate(buffer3, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer3[offset];
    this.targetObject.needsUpdate = true;
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer3, offset) {
    this.resolvedProperty[this.propertyIndex] = buffer3[offset];
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  // HasToFromArray
  _setValue_fromArray(buffer3, offset) {
    this.resolvedProperty.fromArray(buffer3, offset);
  }
  _setValue_fromArray_setNeedsUpdate(buffer3, offset) {
    this.resolvedProperty.fromArray(buffer3, offset);
    this.targetObject.needsUpdate = true;
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer3, offset) {
    this.resolvedProperty.fromArray(buffer3, offset);
    this.targetObject.matrixWorldNeedsUpdate = true;
  }
  _getValue_unbound(targetArray, offset) {
    this.bind();
    this.getValue(targetArray, offset);
  }
  _setValue_unbound(sourceArray, offset) {
    this.bind();
    this.setValue(sourceArray, offset);
  }
  // create getter / setter pair for a property in the scene graph
  bind() {
    let targetObject = this.node;
    const parsedPath = this.parsedPath;
    const objectName = parsedPath.objectName;
    const propertyName = parsedPath.propertyName;
    let propertyIndex = parsedPath.propertyIndex;
    if (!targetObject) {
      targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
      this.node = targetObject;
    }
    this.getValue = this._getValue_unavailable;
    this.setValue = this._setValue_unavailable;
    if (!targetObject) {
      console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
      return;
    }
    if (objectName) {
      let objectIndex = parsedPath.objectIndex;
      switch (objectName) {
        case "materials":
          if (!targetObject.material) {
            console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
            return;
          }
          if (!targetObject.material.materials) {
            console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
            return;
          }
          targetObject = targetObject.material.materials;
          break;
        case "bones":
          if (!targetObject.skeleton) {
            console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
            return;
          }
          targetObject = targetObject.skeleton.bones;
          for (let i2 = 0; i2 < targetObject.length; i2++) {
            if (targetObject[i2].name === objectIndex) {
              objectIndex = i2;
              break;
            }
          }
          break;
        default:
          if (targetObject[objectName] === void 0) {
            console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
            return;
          }
          targetObject = targetObject[objectName];
      }
      if (objectIndex !== void 0) {
        if (targetObject[objectIndex] === void 0) {
          console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, targetObject);
          return;
        }
        targetObject = targetObject[objectIndex];
      }
    }
    const nodeProperty = targetObject[propertyName];
    if (nodeProperty === void 0) {
      const nodeName = parsedPath.nodeName;
      console.error("THREE.PropertyBinding: Trying to update property for track: " + nodeName + "." + propertyName + " but it wasn't found.", targetObject);
      return;
    }
    let versioning = this.Versioning.None;
    this.targetObject = targetObject;
    if (targetObject.needsUpdate !== void 0) {
      versioning = this.Versioning.NeedsUpdate;
    } else if (targetObject.matrixWorldNeedsUpdate !== void 0) {
      versioning = this.Versioning.MatrixWorldNeedsUpdate;
    }
    let bindingType = this.BindingType.Direct;
    if (propertyIndex !== void 0) {
      if (propertyName === "morphTargetInfluences") {
        if (!targetObject.geometry) {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
          return;
        }
        if (targetObject.geometry.isBufferGeometry) {
          if (!targetObject.geometry.morphAttributes) {
            console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
            return;
          }
          if (targetObject.morphTargetDictionary[propertyIndex] !== void 0) {
            propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
          }
        } else {
          console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.", this);
          return;
        }
      }
      bindingType = this.BindingType.ArrayElement;
      this.resolvedProperty = nodeProperty;
      this.propertyIndex = propertyIndex;
    } else if (nodeProperty.fromArray !== void 0 && nodeProperty.toArray !== void 0) {
      bindingType = this.BindingType.HasFromToArray;
      this.resolvedProperty = nodeProperty;
    } else if (Array.isArray(nodeProperty)) {
      bindingType = this.BindingType.EntireArray;
      this.resolvedProperty = nodeProperty;
    } else {
      this.propertyName = propertyName;
    }
    this.getValue = this.GetterByBindingType[bindingType];
    this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
  }
  unbind() {
    this.node = null;
    this.getValue = this._getValue_unbound;
    this.setValue = this._setValue_unbound;
  }
}
PropertyBinding.Composite = Composite;
PropertyBinding.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3
};
PropertyBinding.prototype.Versioning = {
  None: 0,
  NeedsUpdate: 1,
  MatrixWorldNeedsUpdate: 2
};
PropertyBinding.prototype.GetterByBindingType = [
  PropertyBinding.prototype._getValue_direct,
  PropertyBinding.prototype._getValue_array,
  PropertyBinding.prototype._getValue_arrayElement,
  PropertyBinding.prototype._getValue_toArray
];
PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
  [
    // Direct
    PropertyBinding.prototype._setValue_direct,
    PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
    PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
  ],
  [
    // EntireArray
    PropertyBinding.prototype._setValue_array,
    PropertyBinding.prototype._setValue_array_setNeedsUpdate,
    PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
  ],
  [
    // ArrayElement
    PropertyBinding.prototype._setValue_arrayElement,
    PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
    PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
  ],
  [
    // HasToFromArray
    PropertyBinding.prototype._setValue_fromArray,
    PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
    PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
  ]
];
class AnimationObjectGroup {
  constructor() {
    this.uuid = generateUUID();
    this._objects = Array.prototype.slice.call(arguments);
    this.nCachedObjects_ = 0;
    const indices = {};
    this._indicesByUUID = indices;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      indices[arguments[i2].uuid] = i2;
    }
    this._paths = [];
    this._parsedPaths = [];
    this._bindings = [];
    this._bindingsIndicesByPath = {};
    const scope = this;
    this.stats = {
      objects: {
        get total() {
          return scope._objects.length;
        },
        get inUse() {
          return this.total - scope.nCachedObjects_;
        }
      },
      get bindingsPerObject() {
        return scope._bindings.length;
      }
    };
  }
  add() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
    let knownObject = void 0, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object2 = arguments[i2], uuid = object2.uuid;
      let index2 = indicesByUUID[uuid];
      if (index2 === void 0) {
        index2 = nObjects++;
        indicesByUUID[uuid] = index2;
        objects.push(object2);
        for (let j2 = 0, m2 = nBindings; j2 !== m2; ++j2) {
          bindings[j2].push(new PropertyBinding(object2, paths[j2], parsedPaths[j2]));
        }
      } else if (index2 < nCachedObjects) {
        knownObject = objects[index2];
        const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
        indicesByUUID[lastCachedObject.uuid] = index2;
        objects[index2] = lastCachedObject;
        indicesByUUID[uuid] = firstActiveIndex;
        objects[firstActiveIndex] = object2;
        for (let j2 = 0, m2 = nBindings; j2 !== m2; ++j2) {
          const bindingsForPath = bindings[j2], lastCached = bindingsForPath[firstActiveIndex];
          let binding = bindingsForPath[index2];
          bindingsForPath[index2] = lastCached;
          if (binding === void 0) {
            binding = new PropertyBinding(object2, paths[j2], parsedPaths[j2]);
          }
          bindingsForPath[firstActiveIndex] = binding;
        }
      } else if (objects[index2] !== knownObject) {
        console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  remove() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
    let nCachedObjects = this.nCachedObjects_;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object2 = arguments[i2], uuid = object2.uuid, index2 = indicesByUUID[uuid];
      if (index2 !== void 0 && index2 >= nCachedObjects) {
        const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
        indicesByUUID[firstActiveObject.uuid] = index2;
        objects[index2] = firstActiveObject;
        indicesByUUID[uuid] = lastCachedIndex;
        objects[lastCachedIndex] = object2;
        for (let j2 = 0, m2 = nBindings; j2 !== m2; ++j2) {
          const bindingsForPath = bindings[j2], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index2];
          bindingsForPath[index2] = firstActive;
          bindingsForPath[lastCachedIndex] = binding;
        }
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  // remove & forget
  uncache() {
    const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
    let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
    for (let i2 = 0, n2 = arguments.length; i2 !== n2; ++i2) {
      const object2 = arguments[i2], uuid = object2.uuid, index2 = indicesByUUID[uuid];
      if (index2 !== void 0) {
        delete indicesByUUID[uuid];
        if (index2 < nCachedObjects) {
          const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
          indicesByUUID[lastCachedObject.uuid] = index2;
          objects[index2] = lastCachedObject;
          indicesByUUID[lastObject.uuid] = firstActiveIndex;
          objects[firstActiveIndex] = lastObject;
          objects.pop();
          for (let j2 = 0, m2 = nBindings; j2 !== m2; ++j2) {
            const bindingsForPath = bindings[j2], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
            bindingsForPath[index2] = lastCached;
            bindingsForPath[firstActiveIndex] = last;
            bindingsForPath.pop();
          }
        } else {
          const lastIndex = --nObjects, lastObject = objects[lastIndex];
          if (lastIndex > 0) {
            indicesByUUID[lastObject.uuid] = index2;
          }
          objects[index2] = lastObject;
          objects.pop();
          for (let j2 = 0, m2 = nBindings; j2 !== m2; ++j2) {
            const bindingsForPath = bindings[j2];
            bindingsForPath[index2] = bindingsForPath[lastIndex];
            bindingsForPath.pop();
          }
        }
      }
    }
    this.nCachedObjects_ = nCachedObjects;
  }
  // Internal interface used by befriended PropertyBinding.Composite:
  subscribe_(path2, parsedPath) {
    const indicesByPath = this._bindingsIndicesByPath;
    let index2 = indicesByPath[path2];
    const bindings = this._bindings;
    if (index2 !== void 0)
      return bindings[index2];
    const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
    index2 = bindings.length;
    indicesByPath[path2] = index2;
    paths.push(path2);
    parsedPaths.push(parsedPath);
    bindings.push(bindingsForPath);
    for (let i2 = nCachedObjects, n2 = objects.length; i2 !== n2; ++i2) {
      const object2 = objects[i2];
      bindingsForPath[i2] = new PropertyBinding(object2, path2, parsedPath);
    }
    return bindingsForPath;
  }
  unsubscribe_(path2) {
    const indicesByPath = this._bindingsIndicesByPath, index2 = indicesByPath[path2];
    if (index2 !== void 0) {
      const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path2[lastBindingsIndex];
      indicesByPath[lastBindingsPath] = index2;
      bindings[index2] = lastBindings;
      bindings.pop();
      parsedPaths[index2] = parsedPaths[lastBindingsIndex];
      parsedPaths.pop();
      paths[index2] = paths[lastBindingsIndex];
      paths.pop();
    }
  }
}
AnimationObjectGroup.prototype.isAnimationObjectGroup = true;
class AnimationAction {
  constructor(mixer, clip2, localRoot = null, blendMode = clip2.blendMode) {
    this._mixer = mixer;
    this._clip = clip2;
    this._localRoot = localRoot;
    this.blendMode = blendMode;
    const tracks = clip2.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
    const interpolantSettings = {
      endingStart: ZeroCurvatureEnding,
      endingEnd: ZeroCurvatureEnding
    };
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const interpolant = tracks[i2].createInterpolant(null);
      interpolants[i2] = interpolant;
      interpolant.settings = interpolantSettings;
    }
    this._interpolantSettings = interpolantSettings;
    this._interpolants = interpolants;
    this._propertyBindings = new Array(nTracks);
    this._cacheIndex = null;
    this._byClipCacheIndex = null;
    this._timeScaleInterpolant = null;
    this._weightInterpolant = null;
    this.loop = LoopRepeat;
    this._loopCount = -1;
    this._startTime = null;
    this.time = 0;
    this.timeScale = 1;
    this._effectiveTimeScale = 1;
    this.weight = 1;
    this._effectiveWeight = 1;
    this.repetitions = Infinity;
    this.paused = false;
    this.enabled = true;
    this.clampWhenFinished = false;
    this.zeroSlopeAtStart = true;
    this.zeroSlopeAtEnd = true;
  }
  // State & Scheduling
  play() {
    this._mixer._activateAction(this);
    return this;
  }
  stop() {
    this._mixer._deactivateAction(this);
    return this.reset();
  }
  reset() {
    this.paused = false;
    this.enabled = true;
    this.time = 0;
    this._loopCount = -1;
    this._startTime = null;
    return this.stopFading().stopWarping();
  }
  isRunning() {
    return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
  }
  // return true when play has been called
  isScheduled() {
    return this._mixer._isActiveAction(this);
  }
  startAt(time2) {
    this._startTime = time2;
    return this;
  }
  setLoop(mode2, repetitions) {
    this.loop = mode2;
    this.repetitions = repetitions;
    return this;
  }
  // Weight
  // set the weight stopping any scheduled fading
  // although .enabled = false yields an effective weight of zero, this
  // method does *not* change .enabled, because it would be confusing
  setEffectiveWeight(weight) {
    this.weight = weight;
    this._effectiveWeight = this.enabled ? weight : 0;
    return this.stopFading();
  }
  // return the weight considering fading and .enabled
  getEffectiveWeight() {
    return this._effectiveWeight;
  }
  fadeIn(duration) {
    return this._scheduleFading(duration, 0, 1);
  }
  fadeOut(duration) {
    return this._scheduleFading(duration, 1, 0);
  }
  crossFadeFrom(fadeOutAction, duration, warp) {
    fadeOutAction.fadeOut(duration);
    this.fadeIn(duration);
    if (warp) {
      const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
      fadeOutAction.warp(1, startEndRatio, duration);
      this.warp(endStartRatio, 1, duration);
    }
    return this;
  }
  crossFadeTo(fadeInAction, duration, warp) {
    return fadeInAction.crossFadeFrom(this, duration, warp);
  }
  stopFading() {
    const weightInterpolant = this._weightInterpolant;
    if (weightInterpolant !== null) {
      this._weightInterpolant = null;
      this._mixer._takeBackControlInterpolant(weightInterpolant);
    }
    return this;
  }
  // Time Scale Control
  // set the time scale stopping any scheduled warping
  // although .paused = true yields an effective time scale of zero, this
  // method does *not* change .paused, because it would be confusing
  setEffectiveTimeScale(timeScale) {
    this.timeScale = timeScale;
    this._effectiveTimeScale = this.paused ? 0 : timeScale;
    return this.stopWarping();
  }
  // return the time scale considering warping and .paused
  getEffectiveTimeScale() {
    return this._effectiveTimeScale;
  }
  setDuration(duration) {
    this.timeScale = this._clip.duration / duration;
    return this.stopWarping();
  }
  syncWith(action) {
    this.time = action.time;
    this.timeScale = action.timeScale;
    return this.stopWarping();
  }
  halt(duration) {
    return this.warp(this._effectiveTimeScale, 0, duration);
  }
  warp(startTimeScale, endTimeScale, duration) {
    const mixer = this._mixer, now2 = mixer.time, timeScale = this.timeScale;
    let interpolant = this._timeScaleInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._timeScaleInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values4 = interpolant.sampleValues;
    times[0] = now2;
    times[1] = now2 + duration;
    values4[0] = startTimeScale / timeScale;
    values4[1] = endTimeScale / timeScale;
    return this;
  }
  stopWarping() {
    const timeScaleInterpolant = this._timeScaleInterpolant;
    if (timeScaleInterpolant !== null) {
      this._timeScaleInterpolant = null;
      this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
    }
    return this;
  }
  // Object Accessors
  getMixer() {
    return this._mixer;
  }
  getClip() {
    return this._clip;
  }
  getRoot() {
    return this._localRoot || this._mixer._root;
  }
  // Interna
  _update(time2, deltaTime, timeDirection, accuIndex) {
    if (!this.enabled) {
      this._updateWeight(time2);
      return;
    }
    const startTime = this._startTime;
    if (startTime !== null) {
      const timeRunning = (time2 - startTime) * timeDirection;
      if (timeRunning < 0 || timeDirection === 0) {
        return;
      }
      this._startTime = null;
      deltaTime = timeDirection * timeRunning;
    }
    deltaTime *= this._updateTimeScale(time2);
    const clipTime = this._updateTime(deltaTime);
    const weight = this._updateWeight(time2);
    if (weight > 0) {
      const interpolants = this._interpolants;
      const propertyMixers = this._propertyBindings;
      switch (this.blendMode) {
        case AdditiveAnimationBlendMode:
          for (let j2 = 0, m2 = interpolants.length; j2 !== m2; ++j2) {
            interpolants[j2].evaluate(clipTime);
            propertyMixers[j2].accumulateAdditive(weight);
          }
          break;
        case NormalAnimationBlendMode:
        default:
          for (let j2 = 0, m2 = interpolants.length; j2 !== m2; ++j2) {
            interpolants[j2].evaluate(clipTime);
            propertyMixers[j2].accumulate(accuIndex, weight);
          }
      }
    }
  }
  _updateWeight(time2) {
    let weight = 0;
    if (this.enabled) {
      weight = this.weight;
      const interpolant = this._weightInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time2)[0];
        weight *= interpolantValue;
        if (time2 > interpolant.parameterPositions[1]) {
          this.stopFading();
          if (interpolantValue === 0) {
            this.enabled = false;
          }
        }
      }
    }
    this._effectiveWeight = weight;
    return weight;
  }
  _updateTimeScale(time2) {
    let timeScale = 0;
    if (!this.paused) {
      timeScale = this.timeScale;
      const interpolant = this._timeScaleInterpolant;
      if (interpolant !== null) {
        const interpolantValue = interpolant.evaluate(time2)[0];
        timeScale *= interpolantValue;
        if (time2 > interpolant.parameterPositions[1]) {
          this.stopWarping();
          if (timeScale === 0) {
            this.paused = true;
          } else {
            this.timeScale = timeScale;
          }
        }
      }
    }
    this._effectiveTimeScale = timeScale;
    return timeScale;
  }
  _updateTime(deltaTime) {
    const duration = this._clip.duration;
    const loop2 = this.loop;
    let time2 = this.time + deltaTime;
    let loopCount = this._loopCount;
    const pingPong = loop2 === LoopPingPong;
    if (deltaTime === 0) {
      if (loopCount === -1)
        return time2;
      return pingPong && (loopCount & 1) === 1 ? duration - time2 : time2;
    }
    if (loop2 === LoopOnce) {
      if (loopCount === -1) {
        this._loopCount = 0;
        this._setEndings(true, true, false);
      }
      handle_stop: {
        if (time2 >= duration) {
          time2 = duration;
        } else if (time2 < 0) {
          time2 = 0;
        } else {
          this.time = time2;
          break handle_stop;
        }
        if (this.clampWhenFinished)
          this.paused = true;
        else
          this.enabled = false;
        this.time = time2;
        this._mixer.dispatchEvent({
          type: "finished",
          action: this,
          direction: deltaTime < 0 ? -1 : 1
        });
      }
    } else {
      if (loopCount === -1) {
        if (deltaTime >= 0) {
          loopCount = 0;
          this._setEndings(true, this.repetitions === 0, pingPong);
        } else {
          this._setEndings(this.repetitions === 0, true, pingPong);
        }
      }
      if (time2 >= duration || time2 < 0) {
        const loopDelta = Math.floor(time2 / duration);
        time2 -= duration * loopDelta;
        loopCount += Math.abs(loopDelta);
        const pending = this.repetitions - loopCount;
        if (pending <= 0) {
          if (this.clampWhenFinished)
            this.paused = true;
          else
            this.enabled = false;
          time2 = deltaTime > 0 ? duration : 0;
          this.time = time2;
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: deltaTime > 0 ? 1 : -1
          });
        } else {
          if (pending === 1) {
            const atStart = deltaTime < 0;
            this._setEndings(atStart, !atStart, pingPong);
          } else {
            this._setEndings(false, false, pingPong);
          }
          this._loopCount = loopCount;
          this.time = time2;
          this._mixer.dispatchEvent({
            type: "loop",
            action: this,
            loopDelta
          });
        }
      } else {
        this.time = time2;
      }
      if (pingPong && (loopCount & 1) === 1) {
        return duration - time2;
      }
    }
    return time2;
  }
  _setEndings(atStart, atEnd, pingPong) {
    const settings = this._interpolantSettings;
    if (pingPong) {
      settings.endingStart = ZeroSlopeEnding;
      settings.endingEnd = ZeroSlopeEnding;
    } else {
      if (atStart) {
        settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingStart = WrapAroundEnding;
      }
      if (atEnd) {
        settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
      } else {
        settings.endingEnd = WrapAroundEnding;
      }
    }
  }
  _scheduleFading(duration, weightNow, weightThen) {
    const mixer = this._mixer, now2 = mixer.time;
    let interpolant = this._weightInterpolant;
    if (interpolant === null) {
      interpolant = mixer._lendControlInterpolant();
      this._weightInterpolant = interpolant;
    }
    const times = interpolant.parameterPositions, values4 = interpolant.sampleValues;
    times[0] = now2;
    values4[0] = weightNow;
    times[1] = now2 + duration;
    values4[1] = weightThen;
    return this;
  }
}
class AnimationMixer extends EventDispatcher$1 {
  constructor(root2) {
    super();
    this._root = root2;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1;
  }
  _bindAction(action, prototypeAction) {
    const root2 = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root2.uuid, bindingsByRoot = this._bindingsByRootAndName;
    let bindingsByName = bindingsByRoot[rootUuid];
    if (bindingsByName === void 0) {
      bindingsByName = {};
      bindingsByRoot[rootUuid] = bindingsByName;
    }
    for (let i2 = 0; i2 !== nTracks; ++i2) {
      const track = tracks[i2], trackName = track.name;
      let binding = bindingsByName[trackName];
      if (binding !== void 0) {
        ++binding.referenceCount;
        bindings[i2] = binding;
      } else {
        binding = bindings[i2];
        if (binding !== void 0) {
          if (binding._cacheIndex === null) {
            ++binding.referenceCount;
            this._addInactiveBinding(binding, rootUuid, trackName);
          }
          continue;
        }
        const path2 = prototypeAction && prototypeAction._propertyBindings[i2].binding.parsedPath;
        binding = new PropertyMixer(
          PropertyBinding.create(root2, trackName, path2),
          track.ValueTypeName,
          track.getValueSize()
        );
        ++binding.referenceCount;
        this._addInactiveBinding(binding, rootUuid, trackName);
        bindings[i2] = binding;
      }
      interpolants[i2].resultBuffer = binding.buffer;
    }
  }
  _activateAction(action) {
    if (!this._isActiveAction(action)) {
      if (action._cacheIndex === null) {
        const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
        this._bindAction(
          action,
          actionsForClip && actionsForClip.knownActions[0]
        );
        this._addInactiveAction(action, clipUuid, rootUuid);
      }
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (binding.useCount++ === 0) {
          this._lendBinding(binding);
          binding.saveOriginalState();
        }
      }
      this._lendAction(action);
    }
  }
  _deactivateAction(action) {
    if (this._isActiveAction(action)) {
      const bindings = action._propertyBindings;
      for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
        const binding = bindings[i2];
        if (--binding.useCount === 0) {
          binding.restoreOriginalState();
          this._takeBackBinding(binding);
        }
      }
      this._takeBackAction(action);
    }
  }
  // Memory manager
  _initMemoryManager() {
    this._actions = [];
    this._nActiveActions = 0;
    this._actionsByClip = {};
    this._bindings = [];
    this._nActiveBindings = 0;
    this._bindingsByRootAndName = {};
    this._controlInterpolants = [];
    this._nActiveControlInterpolants = 0;
    const scope = this;
    this.stats = {
      actions: {
        get total() {
          return scope._actions.length;
        },
        get inUse() {
          return scope._nActiveActions;
        }
      },
      bindings: {
        get total() {
          return scope._bindings.length;
        },
        get inUse() {
          return scope._nActiveBindings;
        }
      },
      controlInterpolants: {
        get total() {
          return scope._controlInterpolants.length;
        },
        get inUse() {
          return scope._nActiveControlInterpolants;
        }
      }
    };
  }
  // Memory management for AnimationAction objects
  _isActiveAction(action) {
    const index2 = action._cacheIndex;
    return index2 !== null && index2 < this._nActiveActions;
  }
  _addInactiveAction(action, clipUuid, rootUuid) {
    const actions = this._actions, actionsByClip = this._actionsByClip;
    let actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip === void 0) {
      actionsForClip = {
        knownActions: [action],
        actionByRoot: {}
      };
      action._byClipCacheIndex = 0;
      actionsByClip[clipUuid] = actionsForClip;
    } else {
      const knownActions = actionsForClip.knownActions;
      action._byClipCacheIndex = knownActions.length;
      knownActions.push(action);
    }
    action._cacheIndex = actions.length;
    actions.push(action);
    actionsForClip.actionByRoot[rootUuid] = action;
  }
  _removeInactiveAction(action) {
    const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
    lastInactiveAction._cacheIndex = cacheIndex;
    actions[cacheIndex] = lastInactiveAction;
    actions.pop();
    action._cacheIndex = null;
    const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
    lastKnownAction._byClipCacheIndex = byClipCacheIndex;
    knownActionsForClip[byClipCacheIndex] = lastKnownAction;
    knownActionsForClip.pop();
    action._byClipCacheIndex = null;
    const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
    delete actionByRoot[rootUuid];
    if (knownActionsForClip.length === 0) {
      delete actionsByClip[clipUuid];
    }
    this._removeInactiveBindingsForAction(action);
  }
  _removeInactiveBindingsForAction(action) {
    const bindings = action._propertyBindings;
    for (let i2 = 0, n2 = bindings.length; i2 !== n2; ++i2) {
      const binding = bindings[i2];
      if (--binding.referenceCount === 0) {
        this._removeInactiveBinding(binding);
      }
    }
  }
  _lendAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
    action._cacheIndex = lastActiveIndex;
    actions[lastActiveIndex] = action;
    firstInactiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = firstInactiveAction;
  }
  _takeBackAction(action) {
    const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
    action._cacheIndex = firstInactiveIndex;
    actions[firstInactiveIndex] = action;
    lastActiveAction._cacheIndex = prevIndex;
    actions[prevIndex] = lastActiveAction;
  }
  // Memory management for PropertyMixer objects
  _addInactiveBinding(binding, rootUuid, trackName) {
    const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
    let bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName === void 0) {
      bindingByName = {};
      bindingsByRoot[rootUuid] = bindingByName;
    }
    bindingByName[trackName] = binding;
    binding._cacheIndex = bindings.length;
    bindings.push(binding);
  }
  _removeInactiveBinding(binding) {
    const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
    lastInactiveBinding._cacheIndex = cacheIndex;
    bindings[cacheIndex] = lastInactiveBinding;
    bindings.pop();
    delete bindingByName[trackName];
    if (Object.keys(bindingByName).length === 0) {
      delete bindingsByRoot[rootUuid];
    }
  }
  _lendBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
    binding._cacheIndex = lastActiveIndex;
    bindings[lastActiveIndex] = binding;
    firstInactiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = firstInactiveBinding;
  }
  _takeBackBinding(binding) {
    const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
    binding._cacheIndex = firstInactiveIndex;
    bindings[firstInactiveIndex] = binding;
    lastActiveBinding._cacheIndex = prevIndex;
    bindings[prevIndex] = lastActiveBinding;
  }
  // Memory management of Interpolants for weight and time scale
  _lendControlInterpolant() {
    const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
    let interpolant = interpolants[lastActiveIndex];
    if (interpolant === void 0) {
      interpolant = new LinearInterpolant(
        new Float32Array(2),
        new Float32Array(2),
        1,
        this._controlInterpolantsResultBuffer
      );
      interpolant.__cacheIndex = lastActiveIndex;
      interpolants[lastActiveIndex] = interpolant;
    }
    return interpolant;
  }
  _takeBackControlInterpolant(interpolant) {
    const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
    interpolant.__cacheIndex = firstInactiveIndex;
    interpolants[firstInactiveIndex] = interpolant;
    lastActiveInterpolant.__cacheIndex = prevIndex;
    interpolants[prevIndex] = lastActiveInterpolant;
  }
  // return an action for a clip optionally using a custom root target
  // object (this method allocates a lot of dynamic memory in case a
  // previously unknown clip/root combination is specified)
  clipAction(clip2, optionalRoot, blendMode) {
    const root2 = optionalRoot || this._root, rootUuid = root2.uuid;
    let clipObject = typeof clip2 === "string" ? AnimationClip.findByName(root2, clip2) : clip2;
    const clipUuid = clipObject !== null ? clipObject.uuid : clip2;
    const actionsForClip = this._actionsByClip[clipUuid];
    let prototypeAction = null;
    if (blendMode === void 0) {
      if (clipObject !== null) {
        blendMode = clipObject.blendMode;
      } else {
        blendMode = NormalAnimationBlendMode;
      }
    }
    if (actionsForClip !== void 0) {
      const existingAction = actionsForClip.actionByRoot[rootUuid];
      if (existingAction !== void 0 && existingAction.blendMode === blendMode) {
        return existingAction;
      }
      prototypeAction = actionsForClip.knownActions[0];
      if (clipObject === null)
        clipObject = prototypeAction._clip;
    }
    if (clipObject === null)
      return null;
    const newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
    this._bindAction(newAction, prototypeAction);
    this._addInactiveAction(newAction, clipUuid, rootUuid);
    return newAction;
  }
  // get an existing action
  existingAction(clip2, optionalRoot) {
    const root2 = optionalRoot || this._root, rootUuid = root2.uuid, clipObject = typeof clip2 === "string" ? AnimationClip.findByName(root2, clip2) : clip2, clipUuid = clipObject ? clipObject.uuid : clip2, actionsForClip = this._actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      return actionsForClip.actionByRoot[rootUuid] || null;
    }
    return null;
  }
  // deactivates all previously scheduled actions
  stopAllAction() {
    const actions = this._actions, nActions = this._nActiveActions;
    for (let i2 = nActions - 1; i2 >= 0; --i2) {
      actions[i2].stop();
    }
    return this;
  }
  // advance the time and update apply the animation
  update(deltaTime) {
    deltaTime *= this.timeScale;
    const actions = this._actions, nActions = this._nActiveActions, time2 = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
    for (let i2 = 0; i2 !== nActions; ++i2) {
      const action = actions[i2];
      action._update(time2, deltaTime, timeDirection, accuIndex);
    }
    const bindings = this._bindings, nBindings = this._nActiveBindings;
    for (let i2 = 0; i2 !== nBindings; ++i2) {
      bindings[i2].apply(accuIndex);
    }
    return this;
  }
  // Allows you to seek to a specific time in an animation.
  setTime(timeInSeconds) {
    this.time = 0;
    for (let i2 = 0; i2 < this._actions.length; i2++) {
      this._actions[i2].time = 0;
    }
    return this.update(timeInSeconds);
  }
  // return this mixer's root target object
  getRoot() {
    return this._root;
  }
  // free all resources specific to a particular clip
  uncacheClip(clip2) {
    const actions = this._actions, clipUuid = clip2.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
    if (actionsForClip !== void 0) {
      const actionsToRemove = actionsForClip.knownActions;
      for (let i2 = 0, n2 = actionsToRemove.length; i2 !== n2; ++i2) {
        const action = actionsToRemove[i2];
        this._deactivateAction(action);
        const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
        action._cacheIndex = null;
        action._byClipCacheIndex = null;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        this._removeInactiveBindingsForAction(action);
      }
      delete actionsByClip[clipUuid];
    }
  }
  // free all resources specific to a particular root target object
  uncacheRoot(root2) {
    const rootUuid = root2.uuid, actionsByClip = this._actionsByClip;
    for (const clipUuid in actionsByClip) {
      const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
      if (action !== void 0) {
        this._deactivateAction(action);
        this._removeInactiveAction(action);
      }
    }
    const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
    if (bindingByName !== void 0) {
      for (const trackName in bindingByName) {
        const binding = bindingByName[trackName];
        binding.restoreOriginalState();
        this._removeInactiveBinding(binding);
      }
    }
  }
  // remove a targeted clip from the cache
  uncacheAction(clip2, optionalRoot) {
    const action = this.existingAction(clip2, optionalRoot);
    if (action !== null) {
      this._deactivateAction(action);
      this._removeInactiveAction(action);
    }
  }
}
AnimationMixer.prototype._controlInterpolantsResultBuffer = new Float32Array(1);
class Uniform {
  constructor(value) {
    if (typeof value === "string") {
      console.warn("THREE.Uniform: Type parameter is no longer needed.");
      value = arguments[1];
    }
    this.value = value;
  }
  clone() {
    return new Uniform(this.value.clone === void 0 ? this.value : this.value.clone());
  }
}
class InstancedInterleavedBuffer extends InterleavedBuffer {
  constructor(array2, stride, meshPerAttribute = 1) {
    super(array2, stride);
    this.meshPerAttribute = meshPerAttribute;
  }
  copy(source) {
    super.copy(source);
    this.meshPerAttribute = source.meshPerAttribute;
    return this;
  }
  clone(data2) {
    const ib = super.clone(data2);
    ib.meshPerAttribute = this.meshPerAttribute;
    return ib;
  }
  toJSON(data2) {
    const json = super.toJSON(data2);
    json.isInstancedInterleavedBuffer = true;
    json.meshPerAttribute = this.meshPerAttribute;
    return json;
  }
}
InstancedInterleavedBuffer.prototype.isInstancedInterleavedBuffer = true;
class GLBufferAttribute {
  constructor(buffer3, type, itemSize, elementSize, count3) {
    this.buffer = buffer3;
    this.type = type;
    this.itemSize = itemSize;
    this.elementSize = elementSize;
    this.count = count3;
    this.version = 0;
  }
  set needsUpdate(value) {
    if (value === true)
      this.version++;
  }
  setBuffer(buffer3) {
    this.buffer = buffer3;
    return this;
  }
  setType(type, elementSize) {
    this.type = type;
    this.elementSize = elementSize;
    return this;
  }
  setItemSize(itemSize) {
    this.itemSize = itemSize;
    return this;
  }
  setCount(count3) {
    this.count = count3;
    return this;
  }
}
GLBufferAttribute.prototype.isGLBufferAttribute = true;
class Raycaster {
  constructor(origin, direction, near = 0, far = Infinity) {
    this.ray = new Ray(origin, direction);
    this.near = near;
    this.far = far;
    this.camera = null;
    this.layers = new Layers();
    this.params = {
      Mesh: {},
      Line: { threshold: 1 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };
  }
  set(origin, direction) {
    this.ray.set(origin, direction);
  }
  setFromCamera(coords, camera) {
    if (camera.isPerspectiveCamera) {
      this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
      this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
      this.camera = camera;
    } else if (camera.isOrthographicCamera) {
      this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera);
      this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
      this.camera = camera;
    } else {
      console.error("THREE.Raycaster: Unsupported camera type: " + camera.type);
    }
  }
  intersectObject(object2, recursive = true, intersects7 = []) {
    intersectObject(object2, this, intersects7, recursive);
    intersects7.sort(ascSort);
    return intersects7;
  }
  intersectObjects(objects, recursive = true, intersects7 = []) {
    for (let i2 = 0, l2 = objects.length; i2 < l2; i2++) {
      intersectObject(objects[i2], this, intersects7, recursive);
    }
    intersects7.sort(ascSort);
    return intersects7;
  }
}
function ascSort(a2, b2) {
  return a2.distance - b2.distance;
}
function intersectObject(object2, raycaster, intersects7, recursive) {
  if (object2.layers.test(raycaster.layers)) {
    object2.raycast(raycaster, intersects7);
  }
  if (recursive === true) {
    const children = object2.children;
    for (let i2 = 0, l2 = children.length; i2 < l2; i2++) {
      intersectObject(children[i2], raycaster, intersects7, true);
    }
  }
}
class Spherical {
  constructor(radius = 1, phi = 0, theta = 0) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  set(radius, phi, theta) {
    this.radius = radius;
    this.phi = phi;
    this.theta = theta;
    return this;
  }
  copy(other) {
    this.radius = other.radius;
    this.phi = other.phi;
    this.theta = other.theta;
    return this;
  }
  // restrict phi to be between EPS and PI-EPS
  makeSafe() {
    const EPS = 1e-6;
    this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
    return this;
  }
  setFromVector3(v5) {
    return this.setFromCartesianCoords(v5.x, v5.y, v5.z);
  }
  setFromCartesianCoords(x2, y2, z2) {
    this.radius = Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2);
    if (this.radius === 0) {
      this.theta = 0;
      this.phi = 0;
    } else {
      this.theta = Math.atan2(x2, z2);
      this.phi = Math.acos(clamp$5(y2 / this.radius, -1, 1));
    }
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Cylindrical {
  constructor(radius = 1, theta = 0, y2 = 0) {
    this.radius = radius;
    this.theta = theta;
    this.y = y2;
    return this;
  }
  set(radius, theta, y2) {
    this.radius = radius;
    this.theta = theta;
    this.y = y2;
    return this;
  }
  copy(other) {
    this.radius = other.radius;
    this.theta = other.theta;
    this.y = other.y;
    return this;
  }
  setFromVector3(v5) {
    return this.setFromCartesianCoords(v5.x, v5.y, v5.z);
  }
  setFromCartesianCoords(x2, y2, z2) {
    this.radius = Math.sqrt(x2 * x2 + z2 * z2);
    this.theta = Math.atan2(x2, z2);
    this.y = y2;
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$4 = /* @__PURE__ */ new Vector2$1();
class Box2 {
  constructor(min4 = new Vector2$1(Infinity, Infinity), max3 = new Vector2$1(-Infinity, -Infinity)) {
    this.min = min4;
    this.max = max3;
  }
  set(min4, max3) {
    this.min.copy(min4);
    this.max.copy(max3);
    return this;
  }
  setFromPoints(points2) {
    this.makeEmpty();
    for (let i2 = 0, il = points2.length; i2 < il; i2++) {
      this.expandByPoint(points2[i2]);
    }
    return this;
  }
  setFromCenterAndSize(center2, size12) {
    const halfSize = _vector$4.copy(size12).multiplyScalar(0.5);
    this.min.copy(center2).sub(halfSize);
    this.max.copy(center2).add(halfSize);
    return this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(box) {
    this.min.copy(box.min);
    this.max.copy(box.max);
    return this;
  }
  makeEmpty() {
    this.min.x = this.min.y = Infinity;
    this.max.x = this.max.y = -Infinity;
    return this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y;
  }
  getCenter(target) {
    return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(target) {
    return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
  }
  expandByPoint(point4) {
    this.min.min(point4);
    this.max.max(point4);
    return this;
  }
  expandByVector(vector) {
    this.min.sub(vector);
    this.max.add(vector);
    return this;
  }
  expandByScalar(scalar) {
    this.min.addScalar(-scalar);
    this.max.addScalar(scalar);
    return this;
  }
  containsPoint(point4) {
    return point4.x < this.min.x || point4.x > this.max.x || point4.y < this.min.y || point4.y > this.max.y ? false : true;
  }
  containsBox(box) {
    return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
  }
  getParameter(point4, target) {
    return target.set(
      (point4.x - this.min.x) / (this.max.x - this.min.x),
      (point4.y - this.min.y) / (this.max.y - this.min.y)
    );
  }
  intersectsBox(box) {
    return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
  }
  clampPoint(point4, target) {
    return target.copy(point4).clamp(this.min, this.max);
  }
  distanceToPoint(point4) {
    const clampedPoint = _vector$4.copy(point4).clamp(this.min, this.max);
    return clampedPoint.sub(point4).length();
  }
  intersect(box) {
    this.min.max(box.min);
    this.max.min(box.max);
    return this;
  }
  union(box) {
    this.min.min(box.min);
    this.max.max(box.max);
    return this;
  }
  translate(offset) {
    this.min.add(offset);
    this.max.add(offset);
    return this;
  }
  equals(box) {
    return box.min.equals(this.min) && box.max.equals(this.max);
  }
}
Box2.prototype.isBox2 = true;
const _startP = /* @__PURE__ */ new Vector3$1();
const _startEnd = /* @__PURE__ */ new Vector3$1();
class Line3 {
  constructor(start2 = new Vector3$1(), end = new Vector3$1()) {
    this.start = start2;
    this.end = end;
  }
  set(start2, end) {
    this.start.copy(start2);
    this.end.copy(end);
    return this;
  }
  copy(line) {
    this.start.copy(line.start);
    this.end.copy(line.end);
    return this;
  }
  getCenter(target) {
    return target.addVectors(this.start, this.end).multiplyScalar(0.5);
  }
  delta(target) {
    return target.subVectors(this.end, this.start);
  }
  distanceSq() {
    return this.start.distanceToSquared(this.end);
  }
  distance() {
    return this.start.distanceTo(this.end);
  }
  at(t2, target) {
    return this.delta(target).multiplyScalar(t2).add(this.start);
  }
  closestPointToPointParameter(point4, clampToLine) {
    _startP.subVectors(point4, this.start);
    _startEnd.subVectors(this.end, this.start);
    const startEnd2 = _startEnd.dot(_startEnd);
    const startEnd_startP = _startEnd.dot(_startP);
    let t2 = startEnd_startP / startEnd2;
    if (clampToLine) {
      t2 = clamp$5(t2, 0, 1);
    }
    return t2;
  }
  closestPointToPoint(point4, clampToLine, target) {
    const t2 = this.closestPointToPointParameter(point4, clampToLine);
    return this.delta(target).multiplyScalar(t2).add(this.start);
  }
  applyMatrix4(matrix) {
    this.start.applyMatrix4(matrix);
    this.end.applyMatrix4(matrix);
    return this;
  }
  equals(line) {
    return line.start.equals(this.start) && line.end.equals(this.end);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const _vector$3 = /* @__PURE__ */ new Vector3$1();
class SpotLightHelper extends Object3D {
  constructor(light, color) {
    super();
    this.light = light;
    this.light.updateMatrixWorld();
    this.matrix = light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.color = color;
    const geometry2 = new BufferGeometry();
    const positions = [
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1,
      0,
      1,
      0,
      0,
      0,
      -1,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      1,
      0,
      0,
      0,
      0,
      -1,
      1
    ];
    for (let i2 = 0, j2 = 1, l2 = 32; i2 < l2; i2++, j2++) {
      const p1 = i2 / l2 * Math.PI * 2;
      const p2 = j2 / l2 * Math.PI * 2;
      positions.push(
        Math.cos(p1),
        Math.sin(p1),
        1,
        Math.cos(p2),
        Math.sin(p2),
        1
      );
    }
    geometry2.setAttribute("position", new Float32BufferAttribute(positions, 3));
    const material = new LineBasicMaterial({ fog: false, toneMapped: false });
    this.cone = new LineSegments(geometry2, material);
    this.add(this.cone);
    this.update();
  }
  dispose() {
    this.cone.geometry.dispose();
    this.cone.material.dispose();
  }
  update() {
    this.light.updateMatrixWorld();
    const coneLength = this.light.distance ? this.light.distance : 1e3;
    const coneWidth = coneLength * Math.tan(this.light.angle);
    this.cone.scale.set(coneWidth, coneWidth, coneLength);
    _vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
    this.cone.lookAt(_vector$3);
    if (this.color !== void 0) {
      this.cone.material.color.set(this.color);
    } else {
      this.cone.material.color.copy(this.light.color);
    }
  }
}
const _vector$2 = /* @__PURE__ */ new Vector3$1();
const _boneMatrix = /* @__PURE__ */ new Matrix4$1();
const _matrixWorldInv = /* @__PURE__ */ new Matrix4$1();
class SkeletonHelper extends LineSegments {
  constructor(object2) {
    const bones = getBoneList(object2);
    const geometry2 = new BufferGeometry();
    const vertices = [];
    const colors = [];
    const color1 = new Color(0, 0, 1);
    const color2 = new Color(0, 1, 0);
    for (let i2 = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        vertices.push(0, 0, 0);
        vertices.push(0, 0, 0);
        colors.push(color1.r, color1.g, color1.b);
        colors.push(color2.r, color2.g, color2.b);
      }
    }
    geometry2.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry2.setAttribute("color", new Float32BufferAttribute(colors, 3));
    const material = new LineBasicMaterial({ vertexColors: true, depthTest: false, depthWrite: false, toneMapped: false, transparent: true });
    super(geometry2, material);
    this.type = "SkeletonHelper";
    this.isSkeletonHelper = true;
    this.root = object2;
    this.bones = bones;
    this.matrix = object2.matrixWorld;
    this.matrixAutoUpdate = false;
  }
  updateMatrixWorld(force) {
    const bones = this.bones;
    const geometry2 = this.geometry;
    const position = geometry2.getAttribute("position");
    _matrixWorldInv.copy(this.root.matrixWorld).invert();
    for (let i2 = 0, j2 = 0; i2 < bones.length; i2++) {
      const bone = bones[i2];
      if (bone.parent && bone.parent.isBone) {
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position.setXYZ(j2, _vector$2.x, _vector$2.y, _vector$2.z);
        _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
        _vector$2.setFromMatrixPosition(_boneMatrix);
        position.setXYZ(j2 + 1, _vector$2.x, _vector$2.y, _vector$2.z);
        j2 += 2;
      }
    }
    geometry2.getAttribute("position").needsUpdate = true;
    super.updateMatrixWorld(force);
  }
}
function getBoneList(object2) {
  const boneList = [];
  if (object2.isBone === true) {
    boneList.push(object2);
  }
  for (let i2 = 0; i2 < object2.children.length; i2++) {
    boneList.push.apply(boneList, getBoneList(object2.children[i2]));
  }
  return boneList;
}
class PointLightHelper extends Mesh {
  constructor(light, sphereSize, color) {
    const geometry2 = new SphereGeometry(sphereSize, 4, 2);
    const material = new MeshBasicMaterial({ wireframe: true, fog: false, toneMapped: false });
    super(geometry2, material);
    this.light = light;
    this.light.updateMatrixWorld();
    this.color = color;
    this.type = "PointLightHelper";
    this.matrix = this.light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.update();
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
  update() {
    if (this.color !== void 0) {
      this.material.color.set(this.color);
    } else {
      this.material.color.copy(this.light.color);
    }
  }
}
const _vector$1 = /* @__PURE__ */ new Vector3$1();
const _color1 = /* @__PURE__ */ new Color();
const _color2 = /* @__PURE__ */ new Color();
class HemisphereLightHelper extends Object3D {
  constructor(light, size12, color) {
    super();
    this.light = light;
    this.light.updateMatrixWorld();
    this.matrix = light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.color = color;
    const geometry2 = new OctahedronGeometry(size12);
    geometry2.rotateY(Math.PI * 0.5);
    this.material = new MeshBasicMaterial({ wireframe: true, fog: false, toneMapped: false });
    if (this.color === void 0)
      this.material.vertexColors = true;
    const position = geometry2.getAttribute("position");
    const colors = new Float32Array(position.count * 3);
    geometry2.setAttribute("color", new BufferAttribute(colors, 3));
    this.add(new Mesh(geometry2, this.material));
    this.update();
  }
  dispose() {
    this.children[0].geometry.dispose();
    this.children[0].material.dispose();
  }
  update() {
    const mesh = this.children[0];
    if (this.color !== void 0) {
      this.material.color.set(this.color);
    } else {
      const colors = mesh.geometry.getAttribute("color");
      _color1.copy(this.light.color);
      _color2.copy(this.light.groundColor);
      for (let i2 = 0, l2 = colors.count; i2 < l2; i2++) {
        const color = i2 < l2 / 2 ? _color1 : _color2;
        colors.setXYZ(i2, color.r, color.g, color.b);
      }
      colors.needsUpdate = true;
    }
    mesh.lookAt(_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
  }
}
class GridHelper extends LineSegments {
  constructor(size12 = 10, divisions = 10, color1 = 4473924, color2 = 8947848) {
    color1 = new Color(color1);
    color2 = new Color(color2);
    const center2 = divisions / 2;
    const step = size12 / divisions;
    const halfSize = size12 / 2;
    const vertices = [], colors = [];
    for (let i2 = 0, j2 = 0, k2 = -halfSize; i2 <= divisions; i2++, k2 += step) {
      vertices.push(-halfSize, 0, k2, halfSize, 0, k2);
      vertices.push(k2, 0, -halfSize, k2, 0, halfSize);
      const color = i2 === center2 ? color1 : color2;
      color.toArray(colors, j2);
      j2 += 3;
      color.toArray(colors, j2);
      j2 += 3;
      color.toArray(colors, j2);
      j2 += 3;
      color.toArray(colors, j2);
      j2 += 3;
    }
    const geometry2 = new BufferGeometry();
    geometry2.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry2.setAttribute("color", new Float32BufferAttribute(colors, 3));
    const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });
    super(geometry2, material);
    this.type = "GridHelper";
  }
}
class PolarGridHelper extends LineSegments {
  constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 4473924, color2 = 8947848) {
    color1 = new Color(color1);
    color2 = new Color(color2);
    const vertices = [];
    const colors = [];
    for (let i2 = 0; i2 <= radials; i2++) {
      const v5 = i2 / radials * (Math.PI * 2);
      const x2 = Math.sin(v5) * radius;
      const z2 = Math.cos(v5) * radius;
      vertices.push(0, 0, 0);
      vertices.push(x2, 0, z2);
      const color = i2 & 1 ? color1 : color2;
      colors.push(color.r, color.g, color.b);
      colors.push(color.r, color.g, color.b);
    }
    for (let i2 = 0; i2 <= circles; i2++) {
      const color = i2 & 1 ? color1 : color2;
      const r2 = radius - radius / circles * i2;
      for (let j2 = 0; j2 < divisions; j2++) {
        let v5 = j2 / divisions * (Math.PI * 2);
        let x2 = Math.sin(v5) * r2;
        let z2 = Math.cos(v5) * r2;
        vertices.push(x2, 0, z2);
        colors.push(color.r, color.g, color.b);
        v5 = (j2 + 1) / divisions * (Math.PI * 2);
        x2 = Math.sin(v5) * r2;
        z2 = Math.cos(v5) * r2;
        vertices.push(x2, 0, z2);
        colors.push(color.r, color.g, color.b);
      }
    }
    const geometry2 = new BufferGeometry();
    geometry2.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry2.setAttribute("color", new Float32BufferAttribute(colors, 3));
    const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });
    super(geometry2, material);
    this.type = "PolarGridHelper";
  }
}
const _v1$8 = /* @__PURE__ */ new Vector3$1();
const _v2$4 = /* @__PURE__ */ new Vector3$1();
const _v3$2 = /* @__PURE__ */ new Vector3$1();
class DirectionalLightHelper extends Object3D {
  constructor(light, size12, color) {
    super();
    this.light = light;
    this.light.updateMatrixWorld();
    this.matrix = light.matrixWorld;
    this.matrixAutoUpdate = false;
    this.color = color;
    if (size12 === void 0)
      size12 = 1;
    let geometry2 = new BufferGeometry();
    geometry2.setAttribute("position", new Float32BufferAttribute([
      -size12,
      size12,
      0,
      size12,
      size12,
      0,
      size12,
      -size12,
      0,
      -size12,
      -size12,
      0,
      -size12,
      size12,
      0
    ], 3));
    const material = new LineBasicMaterial({ fog: false, toneMapped: false });
    this.lightPlane = new Line(geometry2, material);
    this.add(this.lightPlane);
    geometry2 = new BufferGeometry();
    geometry2.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 0, 0, 1], 3));
    this.targetLine = new Line(geometry2, material);
    this.add(this.targetLine);
    this.update();
  }
  dispose() {
    this.lightPlane.geometry.dispose();
    this.lightPlane.material.dispose();
    this.targetLine.geometry.dispose();
    this.targetLine.material.dispose();
  }
  update() {
    _v1$8.setFromMatrixPosition(this.light.matrixWorld);
    _v2$4.setFromMatrixPosition(this.light.target.matrixWorld);
    _v3$2.subVectors(_v2$4, _v1$8);
    this.lightPlane.lookAt(_v2$4);
    if (this.color !== void 0) {
      this.lightPlane.material.color.set(this.color);
      this.targetLine.material.color.set(this.color);
    } else {
      this.lightPlane.material.color.copy(this.light.color);
      this.targetLine.material.color.copy(this.light.color);
    }
    this.targetLine.lookAt(_v2$4);
    this.targetLine.scale.z = _v3$2.length();
  }
}
const _vector = /* @__PURE__ */ new Vector3$1();
const _camera = /* @__PURE__ */ new Camera();
class CameraHelper extends LineSegments {
  constructor(camera) {
    const geometry2 = new BufferGeometry();
    const material = new LineBasicMaterial({ color: 16777215, vertexColors: true, toneMapped: false });
    const vertices = [];
    const colors = [];
    const pointMap = {};
    const colorFrustum = new Color(16755200);
    const colorCone = new Color(16711680);
    const colorUp = new Color(43775);
    const colorTarget = new Color(16777215);
    const colorCross = new Color(3355443);
    addLine2("n1", "n2", colorFrustum);
    addLine2("n2", "n4", colorFrustum);
    addLine2("n4", "n3", colorFrustum);
    addLine2("n3", "n1", colorFrustum);
    addLine2("f1", "f2", colorFrustum);
    addLine2("f2", "f4", colorFrustum);
    addLine2("f4", "f3", colorFrustum);
    addLine2("f3", "f1", colorFrustum);
    addLine2("n1", "f1", colorFrustum);
    addLine2("n2", "f2", colorFrustum);
    addLine2("n3", "f3", colorFrustum);
    addLine2("n4", "f4", colorFrustum);
    addLine2("p", "n1", colorCone);
    addLine2("p", "n2", colorCone);
    addLine2("p", "n3", colorCone);
    addLine2("p", "n4", colorCone);
    addLine2("u1", "u2", colorUp);
    addLine2("u2", "u3", colorUp);
    addLine2("u3", "u1", colorUp);
    addLine2("c", "t", colorTarget);
    addLine2("p", "c", colorCross);
    addLine2("cn1", "cn2", colorCross);
    addLine2("cn3", "cn4", colorCross);
    addLine2("cf1", "cf2", colorCross);
    addLine2("cf3", "cf4", colorCross);
    function addLine2(a2, b2, color) {
      addPoint2(a2, color);
      addPoint2(b2, color);
    }
    function addPoint2(id, color) {
      vertices.push(0, 0, 0);
      colors.push(color.r, color.g, color.b);
      if (pointMap[id] === void 0) {
        pointMap[id] = [];
      }
      pointMap[id].push(vertices.length / 3 - 1);
    }
    geometry2.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry2.setAttribute("color", new Float32BufferAttribute(colors, 3));
    super(geometry2, material);
    this.type = "CameraHelper";
    this.camera = camera;
    if (this.camera.updateProjectionMatrix)
      this.camera.updateProjectionMatrix();
    this.matrix = camera.matrixWorld;
    this.matrixAutoUpdate = false;
    this.pointMap = pointMap;
    this.update();
  }
  update() {
    const geometry2 = this.geometry;
    const pointMap = this.pointMap;
    const w2 = 1, h2 = 1;
    _camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
    setPoint("c", pointMap, geometry2, _camera, 0, 0, -1);
    setPoint("t", pointMap, geometry2, _camera, 0, 0, 1);
    setPoint("n1", pointMap, geometry2, _camera, -w2, -h2, -1);
    setPoint("n2", pointMap, geometry2, _camera, w2, -h2, -1);
    setPoint("n3", pointMap, geometry2, _camera, -w2, h2, -1);
    setPoint("n4", pointMap, geometry2, _camera, w2, h2, -1);
    setPoint("f1", pointMap, geometry2, _camera, -w2, -h2, 1);
    setPoint("f2", pointMap, geometry2, _camera, w2, -h2, 1);
    setPoint("f3", pointMap, geometry2, _camera, -w2, h2, 1);
    setPoint("f4", pointMap, geometry2, _camera, w2, h2, 1);
    setPoint("u1", pointMap, geometry2, _camera, w2 * 0.7, h2 * 1.1, -1);
    setPoint("u2", pointMap, geometry2, _camera, -w2 * 0.7, h2 * 1.1, -1);
    setPoint("u3", pointMap, geometry2, _camera, 0, h2 * 2, -1);
    setPoint("cf1", pointMap, geometry2, _camera, -w2, 0, 1);
    setPoint("cf2", pointMap, geometry2, _camera, w2, 0, 1);
    setPoint("cf3", pointMap, geometry2, _camera, 0, -h2, 1);
    setPoint("cf4", pointMap, geometry2, _camera, 0, h2, 1);
    setPoint("cn1", pointMap, geometry2, _camera, -w2, 0, -1);
    setPoint("cn2", pointMap, geometry2, _camera, w2, 0, -1);
    setPoint("cn3", pointMap, geometry2, _camera, 0, -h2, -1);
    setPoint("cn4", pointMap, geometry2, _camera, 0, h2, -1);
    geometry2.getAttribute("position").needsUpdate = true;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
function setPoint(point4, pointMap, geometry2, camera, x2, y2, z2) {
  _vector.set(x2, y2, z2).unproject(camera);
  const points2 = pointMap[point4];
  if (points2 !== void 0) {
    const position = geometry2.getAttribute("position");
    for (let i2 = 0, l2 = points2.length; i2 < l2; i2++) {
      position.setXYZ(points2[i2], _vector.x, _vector.y, _vector.z);
    }
  }
}
const _box = /* @__PURE__ */ new Box3();
class BoxHelper extends LineSegments {
  constructor(object2, color = 16776960) {
    const indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
    const positions = new Float32Array(8 * 3);
    const geometry2 = new BufferGeometry();
    geometry2.setIndex(new BufferAttribute(indices, 1));
    geometry2.setAttribute("position", new BufferAttribute(positions, 3));
    super(geometry2, new LineBasicMaterial({ color, toneMapped: false }));
    this.object = object2;
    this.type = "BoxHelper";
    this.matrixAutoUpdate = false;
    this.update();
  }
  update(object2) {
    if (object2 !== void 0) {
      console.warn("THREE.BoxHelper: .update() has no longer arguments.");
    }
    if (this.object !== void 0) {
      _box.setFromObject(this.object);
    }
    if (_box.isEmpty())
      return;
    const min4 = _box.min;
    const max3 = _box.max;
    const position = this.geometry.attributes.position;
    const array2 = position.array;
    array2[0] = max3.x;
    array2[1] = max3.y;
    array2[2] = max3.z;
    array2[3] = min4.x;
    array2[4] = max3.y;
    array2[5] = max3.z;
    array2[6] = min4.x;
    array2[7] = min4.y;
    array2[8] = max3.z;
    array2[9] = max3.x;
    array2[10] = min4.y;
    array2[11] = max3.z;
    array2[12] = max3.x;
    array2[13] = max3.y;
    array2[14] = min4.z;
    array2[15] = min4.x;
    array2[16] = max3.y;
    array2[17] = min4.z;
    array2[18] = min4.x;
    array2[19] = min4.y;
    array2[20] = min4.z;
    array2[21] = max3.x;
    array2[22] = min4.y;
    array2[23] = min4.z;
    position.needsUpdate = true;
    this.geometry.computeBoundingSphere();
  }
  setFromObject(object2) {
    this.object = object2;
    this.update();
    return this;
  }
  copy(source) {
    LineSegments.prototype.copy.call(this, source);
    this.object = source.object;
    return this;
  }
}
class Box3Helper extends LineSegments {
  constructor(box, color = 16776960) {
    const indices = new Uint16Array([0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7]);
    const positions = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1];
    const geometry2 = new BufferGeometry();
    geometry2.setIndex(new BufferAttribute(indices, 1));
    geometry2.setAttribute("position", new Float32BufferAttribute(positions, 3));
    super(geometry2, new LineBasicMaterial({ color, toneMapped: false }));
    this.box = box;
    this.type = "Box3Helper";
    this.geometry.computeBoundingSphere();
  }
  updateMatrixWorld(force) {
    const box = this.box;
    if (box.isEmpty())
      return;
    box.getCenter(this.position);
    box.getSize(this.scale);
    this.scale.multiplyScalar(0.5);
    super.updateMatrixWorld(force);
  }
}
class PlaneHelper extends Line {
  constructor(plane, size12 = 1, hex = 16776960) {
    const color = hex;
    const positions = [1, -1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 0, 0, 1, 0, 0, 0];
    const geometry2 = new BufferGeometry();
    geometry2.setAttribute("position", new Float32BufferAttribute(positions, 3));
    geometry2.computeBoundingSphere();
    super(geometry2, new LineBasicMaterial({ color, toneMapped: false }));
    this.type = "PlaneHelper";
    this.plane = plane;
    this.size = size12;
    const positions2 = [1, 1, 1, -1, 1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, 1, -1, 1];
    const geometry22 = new BufferGeometry();
    geometry22.setAttribute("position", new Float32BufferAttribute(positions2, 3));
    geometry22.computeBoundingSphere();
    this.add(new Mesh(geometry22, new MeshBasicMaterial({ color, opacity: 0.2, transparent: true, depthWrite: false, toneMapped: false })));
  }
  updateMatrixWorld(force) {
    let scale5 = -this.plane.constant;
    if (Math.abs(scale5) < 1e-8)
      scale5 = 1e-8;
    this.scale.set(0.5 * this.size, 0.5 * this.size, scale5);
    this.children[0].material.side = scale5 < 0 ? BackSide : FrontSide;
    this.lookAt(this.plane.normal);
    super.updateMatrixWorld(force);
  }
}
const _axis = /* @__PURE__ */ new Vector3$1();
let _lineGeometry, _coneGeometry;
class ArrowHelper extends Object3D {
  // dir is assumed to be normalized
  constructor(dir = new Vector3$1(0, 0, 1), origin = new Vector3$1(0, 0, 0), length2 = 1, color = 16776960, headLength = length2 * 0.2, headWidth = headLength * 0.2) {
    super();
    this.type = "ArrowHelper";
    if (_lineGeometry === void 0) {
      _lineGeometry = new BufferGeometry();
      _lineGeometry.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 0, 1, 0], 3));
      _coneGeometry = new CylinderGeometry(0, 0.5, 1, 5, 1);
      _coneGeometry.translate(0, -0.5, 0);
    }
    this.position.copy(origin);
    this.line = new Line(_lineGeometry, new LineBasicMaterial({ color, toneMapped: false }));
    this.line.matrixAutoUpdate = false;
    this.add(this.line);
    this.cone = new Mesh(_coneGeometry, new MeshBasicMaterial({ color, toneMapped: false }));
    this.cone.matrixAutoUpdate = false;
    this.add(this.cone);
    this.setDirection(dir);
    this.setLength(length2, headLength, headWidth);
  }
  setDirection(dir) {
    if (dir.y > 0.99999) {
      this.quaternion.set(0, 0, 0, 1);
    } else if (dir.y < -0.99999) {
      this.quaternion.set(1, 0, 0, 0);
    } else {
      _axis.set(dir.z, 0, -dir.x).normalize();
      const radians2 = Math.acos(dir.y);
      this.quaternion.setFromAxisAngle(_axis, radians2);
    }
  }
  setLength(length2, headLength = length2 * 0.2, headWidth = headLength * 0.2) {
    this.line.scale.set(1, Math.max(1e-4, length2 - headLength), 1);
    this.line.updateMatrix();
    this.cone.scale.set(headWidth, headLength, headWidth);
    this.cone.position.y = length2;
    this.cone.updateMatrix();
  }
  setColor(color) {
    this.line.material.color.set(color);
    this.cone.material.color.set(color);
  }
  copy(source) {
    super.copy(source, false);
    this.line.copy(source.line);
    this.cone.copy(source.cone);
    return this;
  }
}
class AxesHelper extends LineSegments {
  constructor(size12 = 1) {
    const vertices = [
      0,
      0,
      0,
      size12,
      0,
      0,
      0,
      0,
      0,
      0,
      size12,
      0,
      0,
      0,
      0,
      0,
      0,
      size12
    ];
    const colors = [
      1,
      0,
      0,
      1,
      0.6,
      0,
      0,
      1,
      0,
      0.6,
      1,
      0,
      0,
      0,
      1,
      0,
      0.6,
      1
    ];
    const geometry2 = new BufferGeometry();
    geometry2.setAttribute("position", new Float32BufferAttribute(vertices, 3));
    geometry2.setAttribute("color", new Float32BufferAttribute(colors, 3));
    const material = new LineBasicMaterial({ vertexColors: true, toneMapped: false });
    super(geometry2, material);
    this.type = "AxesHelper";
  }
  setColors(xAxisColor, yAxisColor, zAxisColor) {
    const color = new Color();
    const array2 = this.geometry.attributes.color.array;
    color.set(xAxisColor);
    color.toArray(array2, 0);
    color.toArray(array2, 3);
    color.set(yAxisColor);
    color.toArray(array2, 6);
    color.toArray(array2, 9);
    color.set(zAxisColor);
    color.toArray(array2, 12);
    color.toArray(array2, 15);
    this.geometry.attributes.color.needsUpdate = true;
    return this;
  }
  dispose() {
    this.geometry.dispose();
    this.material.dispose();
  }
}
class ShapePath {
  constructor() {
    this.type = "ShapePath";
    this.color = new Color();
    this.subPaths = [];
    this.currentPath = null;
  }
  moveTo(x2, y2) {
    this.currentPath = new Path();
    this.subPaths.push(this.currentPath);
    this.currentPath.moveTo(x2, y2);
    return this;
  }
  lineTo(x2, y2) {
    this.currentPath.lineTo(x2, y2);
    return this;
  }
  quadraticCurveTo(aCPx, aCPy, aX2, aY2) {
    this.currentPath.quadraticCurveTo(aCPx, aCPy, aX2, aY2);
    return this;
  }
  bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX2, aY2) {
    this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX2, aY2);
    return this;
  }
  splineThru(pts) {
    this.currentPath.splineThru(pts);
    return this;
  }
  toShapes(isCCW2, noHoles) {
    function toShapesNoHoles(inSubpaths) {
      const shapes2 = [];
      for (let i2 = 0, l2 = inSubpaths.length; i2 < l2; i2++) {
        const tmpPath2 = inSubpaths[i2];
        const tmpShape2 = new Shape();
        tmpShape2.curves = tmpPath2.curves;
        shapes2.push(tmpShape2);
      }
      return shapes2;
    }
    function isPointInsidePolygon(inPt, inPolygon) {
      const polyLen = inPolygon.length;
      let inside = false;
      for (let p2 = polyLen - 1, q2 = 0; q2 < polyLen; p2 = q2++) {
        let edgeLowPt = inPolygon[p2];
        let edgeHighPt = inPolygon[q2];
        let edgeDx = edgeHighPt.x - edgeLowPt.x;
        let edgeDy = edgeHighPt.y - edgeLowPt.y;
        if (Math.abs(edgeDy) > Number.EPSILON) {
          if (edgeDy < 0) {
            edgeLowPt = inPolygon[q2];
            edgeDx = -edgeDx;
            edgeHighPt = inPolygon[p2];
            edgeDy = -edgeDy;
          }
          if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y)
            continue;
          if (inPt.y === edgeLowPt.y) {
            if (inPt.x === edgeLowPt.x)
              return true;
          } else {
            const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
            if (perpEdge === 0)
              return true;
            if (perpEdge < 0)
              continue;
            inside = !inside;
          }
        } else {
          if (inPt.y !== edgeLowPt.y)
            continue;
          if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x)
            return true;
        }
      }
      return inside;
    }
    const isClockWise = ShapeUtils.isClockWise;
    const subPaths = this.subPaths;
    if (subPaths.length === 0)
      return [];
    if (noHoles === true)
      return toShapesNoHoles(subPaths);
    let solid, tmpPath, tmpShape;
    const shapes = [];
    if (subPaths.length === 1) {
      tmpPath = subPaths[0];
      tmpShape = new Shape();
      tmpShape.curves = tmpPath.curves;
      shapes.push(tmpShape);
      return shapes;
    }
    let holesFirst = !isClockWise(subPaths[0].getPoints());
    holesFirst = isCCW2 ? !holesFirst : holesFirst;
    const betterShapeHoles = [];
    const newShapes = [];
    let newShapeHoles = [];
    let mainIdx = 0;
    let tmpPoints;
    newShapes[mainIdx] = void 0;
    newShapeHoles[mainIdx] = [];
    for (let i2 = 0, l2 = subPaths.length; i2 < l2; i2++) {
      tmpPath = subPaths[i2];
      tmpPoints = tmpPath.getPoints();
      solid = isClockWise(tmpPoints);
      solid = isCCW2 ? !solid : solid;
      if (solid) {
        if (!holesFirst && newShapes[mainIdx])
          mainIdx++;
        newShapes[mainIdx] = { s: new Shape(), p: tmpPoints };
        newShapes[mainIdx].s.curves = tmpPath.curves;
        if (holesFirst)
          mainIdx++;
        newShapeHoles[mainIdx] = [];
      } else {
        newShapeHoles[mainIdx].push({ h: tmpPath, p: tmpPoints[0] });
      }
    }
    if (!newShapes[0])
      return toShapesNoHoles(subPaths);
    if (newShapes.length > 1) {
      let ambiguous = false;
      let toChange = 0;
      for (let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {
        betterShapeHoles[sIdx] = [];
      }
      for (let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++) {
        const sho = newShapeHoles[sIdx];
        for (let hIdx = 0; hIdx < sho.length; hIdx++) {
          const ho = sho[hIdx];
          let hole_unassigned = true;
          for (let s2Idx = 0; s2Idx < newShapes.length; s2Idx++) {
            if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
              if (sIdx !== s2Idx)
                toChange++;
              if (hole_unassigned) {
                hole_unassigned = false;
                betterShapeHoles[s2Idx].push(ho);
              } else {
                ambiguous = true;
              }
            }
          }
          if (hole_unassigned) {
            betterShapeHoles[sIdx].push(ho);
          }
        }
      }
      if (toChange > 0 && ambiguous === false) {
        newShapeHoles = betterShapeHoles;
      }
    }
    let tmpHoles;
    for (let i2 = 0, il = newShapes.length; i2 < il; i2++) {
      tmpShape = newShapes[i2].s;
      shapes.push(tmpShape);
      tmpHoles = newShapeHoles[i2];
      for (let j2 = 0, jl = tmpHoles.length; j2 < jl; j2++) {
        tmpShape.holes.push(tmpHoles[j2].h);
      }
    }
    return shapes;
  }
}
class DataUtils {
  // float32 to float16
  static toHalfFloat(val) {
    if (Math.abs(val) > 65504)
      console.warn("THREE.DataUtils.toHalfFloat(): Value out of range.");
    val = clamp$5(val, -65504, 65504);
    _floatView[0] = val;
    const f2 = _uint32View[0];
    const e3 = f2 >> 23 & 511;
    return _baseTable[e3] + ((f2 & 8388607) >> _shiftTable[e3]);
  }
  // float16 to float32
  static fromHalfFloat(val) {
    const m2 = val >> 10;
    _uint32View[0] = _mantissaTable[_offsetTable[m2] + (val & 1023)] + _exponentTable[m2];
    return _floatView[0];
  }
}
const _buffer = new ArrayBuffer(4);
const _floatView = new Float32Array(_buffer);
const _uint32View = new Uint32Array(_buffer);
const _baseTable = new Uint32Array(512);
const _shiftTable = new Uint32Array(512);
for (let i2 = 0; i2 < 256; ++i2) {
  const e3 = i2 - 127;
  if (e3 < -27) {
    _baseTable[i2] = 0;
    _baseTable[i2 | 256] = 32768;
    _shiftTable[i2] = 24;
    _shiftTable[i2 | 256] = 24;
  } else if (e3 < -14) {
    _baseTable[i2] = 1024 >> -e3 - 14;
    _baseTable[i2 | 256] = 1024 >> -e3 - 14 | 32768;
    _shiftTable[i2] = -e3 - 1;
    _shiftTable[i2 | 256] = -e3 - 1;
  } else if (e3 <= 15) {
    _baseTable[i2] = e3 + 15 << 10;
    _baseTable[i2 | 256] = e3 + 15 << 10 | 32768;
    _shiftTable[i2] = 13;
    _shiftTable[i2 | 256] = 13;
  } else if (e3 < 128) {
    _baseTable[i2] = 31744;
    _baseTable[i2 | 256] = 64512;
    _shiftTable[i2] = 24;
    _shiftTable[i2 | 256] = 24;
  } else {
    _baseTable[i2] = 31744;
    _baseTable[i2 | 256] = 64512;
    _shiftTable[i2] = 13;
    _shiftTable[i2 | 256] = 13;
  }
}
const _mantissaTable = new Uint32Array(2048);
const _exponentTable = new Uint32Array(64);
const _offsetTable = new Uint32Array(64);
for (let i2 = 1; i2 < 1024; ++i2) {
  let m2 = i2 << 13;
  let e3 = 0;
  while ((m2 & 8388608) === 0) {
    m2 <<= 1;
    e3 -= 8388608;
  }
  m2 &= ~8388608;
  e3 += 947912704;
  _mantissaTable[i2] = m2 | e3;
}
for (let i2 = 1024; i2 < 2048; ++i2) {
  _mantissaTable[i2] = 939524096 + (i2 - 1024 << 13);
}
for (let i2 = 1; i2 < 31; ++i2) {
  _exponentTable[i2] = i2 << 23;
}
_exponentTable[31] = 1199570944;
_exponentTable[32] = 2147483648;
for (let i2 = 33; i2 < 63; ++i2) {
  _exponentTable[i2] = 2147483648 + (i2 - 32 << 23);
}
_exponentTable[63] = 3347054592;
for (let i2 = 1; i2 < 64; ++i2) {
  if (i2 !== 32) {
    _offsetTable[i2] = 1024;
  }
}
const LineStrip = 0;
const LinePieces = 1;
const NoColors = 0;
const FaceColors = 1;
const VertexColors = 2;
function MeshFaceMaterial(materials) {
  console.warn("THREE.MeshFaceMaterial has been removed. Use an Array instead.");
  return materials;
}
function MultiMaterial(materials = []) {
  console.warn("THREE.MultiMaterial has been removed. Use an Array instead.");
  materials.isMultiMaterial = true;
  materials.materials = materials;
  materials.clone = function() {
    return materials.slice();
  };
  return materials;
}
class PointCloud extends Points {
  constructor(geometry2, material) {
    console.warn("THREE.PointCloud has been renamed to THREE.Points.");
    super(geometry2, material);
  }
}
class Particle extends Sprite {
  constructor(material) {
    console.warn("THREE.Particle has been renamed to THREE.Sprite.");
    super(material);
  }
}
class ParticleSystem extends Points {
  constructor(geometry2, material) {
    console.warn("THREE.ParticleSystem has been renamed to THREE.Points.");
    super(geometry2, material);
  }
}
class PointCloudMaterial extends PointsMaterial {
  constructor(parameters) {
    console.warn("THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.");
    super(parameters);
  }
}
class ParticleBasicMaterial extends PointsMaterial {
  constructor(parameters) {
    console.warn("THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.");
    super(parameters);
  }
}
class ParticleSystemMaterial extends PointsMaterial {
  constructor(parameters) {
    console.warn("THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.");
    super(parameters);
  }
}
let Vertex$1 = class Vertex2 extends Vector3$1 {
  constructor(x2, y2, z2) {
    console.warn("THREE.Vertex has been removed. Use THREE.Vector3 instead.");
    super(x2, y2, z2);
  }
};
class DynamicBufferAttribute extends BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.");
    super(array2, itemSize);
    this.setUsage(DynamicDrawUsage);
  }
}
class Int8Attribute extends Int8BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Uint8Attribute extends Uint8BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Uint8ClampedAttribute extends Uint8ClampedBufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Int16Attribute extends Int16BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Uint16Attribute extends Uint16BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Int32Attribute extends Int32BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Uint32Attribute extends Uint32BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Float32Attribute extends Float32BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
class Float64Attribute extends Float64BufferAttribute {
  constructor(array2, itemSize) {
    console.warn("THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.");
    super(array2, itemSize);
  }
}
Curve.create = function(construct, getPoint) {
  console.log("THREE.Curve.create() has been deprecated");
  construct.prototype = Object.create(Curve.prototype);
  construct.prototype.constructor = construct;
  construct.prototype.getPoint = getPoint;
  return construct;
};
Path.prototype.fromPoints = function(points2) {
  console.warn("THREE.Path: .fromPoints() has been renamed to .setFromPoints().");
  return this.setFromPoints(points2);
};
class AxisHelper extends AxesHelper {
  constructor(size12) {
    console.warn("THREE.AxisHelper has been renamed to THREE.AxesHelper.");
    super(size12);
  }
}
class BoundingBoxHelper extends BoxHelper {
  constructor(object2, color) {
    console.warn("THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.");
    super(object2, color);
  }
}
class EdgesHelper extends LineSegments {
  constructor(object2, hex) {
    console.warn("THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.");
    super(new EdgesGeometry(object2.geometry), new LineBasicMaterial({ color: hex !== void 0 ? hex : 16777215 }));
  }
}
GridHelper.prototype.setColors = function() {
  console.error("THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.");
};
SkeletonHelper.prototype.update = function() {
  console.error("THREE.SkeletonHelper: update() no longer needs to be called.");
};
class WireframeHelper extends LineSegments {
  constructor(object2, hex) {
    console.warn("THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.");
    super(new WireframeGeometry(object2.geometry), new LineBasicMaterial({ color: hex !== void 0 ? hex : 16777215 }));
  }
}
Loader.prototype.extractUrlBase = function(url2) {
  console.warn("THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.");
  return LoaderUtils.extractUrlBase(url2);
};
Loader.Handlers = {
  add: function() {
    console.error("THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.");
  },
  get: function() {
    console.error("THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.");
  }
};
class XHRLoader extends FileLoader {
  constructor(manager) {
    console.warn("THREE.XHRLoader has been renamed to THREE.FileLoader.");
    super(manager);
  }
}
class BinaryTextureLoader extends DataTextureLoader {
  constructor(manager) {
    console.warn("THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.");
    super(manager);
  }
}
Box2.prototype.center = function(optionalTarget) {
  console.warn("THREE.Box2: .center() has been renamed to .getCenter().");
  return this.getCenter(optionalTarget);
};
Box2.prototype.empty = function() {
  console.warn("THREE.Box2: .empty() has been renamed to .isEmpty().");
  return this.isEmpty();
};
Box2.prototype.isIntersectionBox = function(box) {
  console.warn("THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().");
  return this.intersectsBox(box);
};
Box2.prototype.size = function(optionalTarget) {
  console.warn("THREE.Box2: .size() has been renamed to .getSize().");
  return this.getSize(optionalTarget);
};
Box3.prototype.center = function(optionalTarget) {
  console.warn("THREE.Box3: .center() has been renamed to .getCenter().");
  return this.getCenter(optionalTarget);
};
Box3.prototype.empty = function() {
  console.warn("THREE.Box3: .empty() has been renamed to .isEmpty().");
  return this.isEmpty();
};
Box3.prototype.isIntersectionBox = function(box) {
  console.warn("THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().");
  return this.intersectsBox(box);
};
Box3.prototype.isIntersectionSphere = function(sphere2) {
  console.warn("THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().");
  return this.intersectsSphere(sphere2);
};
Box3.prototype.size = function(optionalTarget) {
  console.warn("THREE.Box3: .size() has been renamed to .getSize().");
  return this.getSize(optionalTarget);
};
Euler.prototype.toVector3 = function() {
  console.error("THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead");
};
Sphere.prototype.empty = function() {
  console.warn("THREE.Sphere: .empty() has been renamed to .isEmpty().");
  return this.isEmpty();
};
Frustum.prototype.setFromMatrix = function(m2) {
  console.warn("THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().");
  return this.setFromProjectionMatrix(m2);
};
Line3.prototype.center = function(optionalTarget) {
  console.warn("THREE.Line3: .center() has been renamed to .getCenter().");
  return this.getCenter(optionalTarget);
};
Matrix3$1.prototype.flattenToArrayOffset = function(array2, offset) {
  console.warn("THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
  return this.toArray(array2, offset);
};
Matrix3$1.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.");
  return vector.applyMatrix3(this);
};
Matrix3$1.prototype.multiplyVector3Array = function() {
  console.error("THREE.Matrix3: .multiplyVector3Array() has been removed.");
};
Matrix3$1.prototype.applyToBufferAttribute = function(attribute) {
  console.warn("THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.");
  return attribute.applyMatrix3(this);
};
Matrix3$1.prototype.applyToVector3Array = function() {
  console.error("THREE.Matrix3: .applyToVector3Array() has been removed.");
};
Matrix3$1.prototype.getInverse = function(matrix) {
  console.warn("THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
  return this.copy(matrix).invert();
};
Matrix4$1.prototype.extractPosition = function(m2) {
  console.warn("THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().");
  return this.copyPosition(m2);
};
Matrix4$1.prototype.flattenToArrayOffset = function(array2, offset) {
  console.warn("THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.");
  return this.toArray(array2, offset);
};
Matrix4$1.prototype.getPosition = function() {
  console.warn("THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.");
  return new Vector3$1().setFromMatrixColumn(this, 3);
};
Matrix4$1.prototype.setRotationFromQuaternion = function(q2) {
  console.warn("THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().");
  return this.makeRotationFromQuaternion(q2);
};
Matrix4$1.prototype.multiplyToArray = function() {
  console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
};
Matrix4$1.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix4$1.prototype.multiplyVector4 = function(vector) {
  console.warn("THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix4$1.prototype.multiplyVector3Array = function() {
  console.error("THREE.Matrix4: .multiplyVector3Array() has been removed.");
};
Matrix4$1.prototype.rotateAxis = function(v5) {
  console.warn("THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.");
  v5.transformDirection(this);
};
Matrix4$1.prototype.crossVector = function(vector) {
  console.warn("THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.");
  return vector.applyMatrix4(this);
};
Matrix4$1.prototype.translate = function() {
  console.error("THREE.Matrix4: .translate() has been removed.");
};
Matrix4$1.prototype.rotateX = function() {
  console.error("THREE.Matrix4: .rotateX() has been removed.");
};
Matrix4$1.prototype.rotateY = function() {
  console.error("THREE.Matrix4: .rotateY() has been removed.");
};
Matrix4$1.prototype.rotateZ = function() {
  console.error("THREE.Matrix4: .rotateZ() has been removed.");
};
Matrix4$1.prototype.rotateByAxis = function() {
  console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
};
Matrix4$1.prototype.applyToBufferAttribute = function(attribute) {
  console.warn("THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.");
  return attribute.applyMatrix4(this);
};
Matrix4$1.prototype.applyToVector3Array = function() {
  console.error("THREE.Matrix4: .applyToVector3Array() has been removed.");
};
Matrix4$1.prototype.makeFrustum = function(left, right, bottom, top, near, far) {
  console.warn("THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.");
  return this.makePerspective(left, right, top, bottom, near, far);
};
Matrix4$1.prototype.getInverse = function(matrix) {
  console.warn("THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.");
  return this.copy(matrix).invert();
};
Plane$1.prototype.isIntersectionLine = function(line) {
  console.warn("THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().");
  return this.intersectsLine(line);
};
Quaternion$1.prototype.multiplyVector3 = function(vector) {
  console.warn("THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.");
  return vector.applyQuaternion(this);
};
Quaternion$1.prototype.inverse = function() {
  console.warn("THREE.Quaternion: .inverse() has been renamed to invert().");
  return this.invert();
};
Ray.prototype.isIntersectionBox = function(box) {
  console.warn("THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().");
  return this.intersectsBox(box);
};
Ray.prototype.isIntersectionPlane = function(plane) {
  console.warn("THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().");
  return this.intersectsPlane(plane);
};
Ray.prototype.isIntersectionSphere = function(sphere2) {
  console.warn("THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().");
  return this.intersectsSphere(sphere2);
};
Triangle.prototype.area = function() {
  console.warn("THREE.Triangle: .area() has been renamed to .getArea().");
  return this.getArea();
};
Triangle.prototype.barycoordFromPoint = function(point4, target) {
  console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
  return this.getBarycoord(point4, target);
};
Triangle.prototype.midpoint = function(target) {
  console.warn("THREE.Triangle: .midpoint() has been renamed to .getMidpoint().");
  return this.getMidpoint(target);
};
Triangle.prototypenormal = function(target) {
  console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
  return this.getNormal(target);
};
Triangle.prototype.plane = function(target) {
  console.warn("THREE.Triangle: .plane() has been renamed to .getPlane().");
  return this.getPlane(target);
};
Triangle.barycoordFromPoint = function(point4, a2, b2, c2, target) {
  console.warn("THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().");
  return Triangle.getBarycoord(point4, a2, b2, c2, target);
};
Triangle.normal = function(a2, b2, c2, target) {
  console.warn("THREE.Triangle: .normal() has been renamed to .getNormal().");
  return Triangle.getNormal(a2, b2, c2, target);
};
Shape.prototype.extractAllPoints = function(divisions) {
  console.warn("THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.");
  return this.extractPoints(divisions);
};
Shape.prototype.extrude = function(options2) {
  console.warn("THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.");
  return new ExtrudeGeometry(this, options2);
};
Shape.prototype.makeGeometry = function(options2) {
  console.warn("THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.");
  return new ShapeGeometry(this, options2);
};
Vector2$1.prototype.fromAttribute = function(attribute, index2, offset) {
  console.warn("THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index2, offset);
};
Vector2$1.prototype.distanceToManhattan = function(v5) {
  console.warn("THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
  return this.manhattanDistanceTo(v5);
};
Vector2$1.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Vector3$1.prototype.setEulerFromRotationMatrix = function() {
  console.error("THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.");
};
Vector3$1.prototype.setEulerFromQuaternion = function() {
  console.error("THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.");
};
Vector3$1.prototype.getPositionFromMatrix = function(m2) {
  console.warn("THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().");
  return this.setFromMatrixPosition(m2);
};
Vector3$1.prototype.getScaleFromMatrix = function(m2) {
  console.warn("THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().");
  return this.setFromMatrixScale(m2);
};
Vector3$1.prototype.getColumnFromMatrix = function(index2, matrix) {
  console.warn("THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().");
  return this.setFromMatrixColumn(matrix, index2);
};
Vector3$1.prototype.applyProjection = function(m2) {
  console.warn("THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.");
  return this.applyMatrix4(m2);
};
Vector3$1.prototype.fromAttribute = function(attribute, index2, offset) {
  console.warn("THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index2, offset);
};
Vector3$1.prototype.distanceToManhattan = function(v5) {
  console.warn("THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().");
  return this.manhattanDistanceTo(v5);
};
Vector3$1.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Vector4$1.prototype.fromAttribute = function(attribute, index2, offset) {
  console.warn("THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().");
  return this.fromBufferAttribute(attribute, index2, offset);
};
Vector4$1.prototype.lengthManhattan = function() {
  console.warn("THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().");
  return this.manhattanLength();
};
Object3D.prototype.getChildByName = function(name2) {
  console.warn("THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().");
  return this.getObjectByName(name2);
};
Object3D.prototype.renderDepth = function() {
  console.warn("THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.");
};
Object3D.prototype.translate = function(distance11, axis) {
  console.warn("THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.");
  return this.translateOnAxis(axis, distance11);
};
Object3D.prototype.getWorldRotation = function() {
  console.error("THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.");
};
Object3D.prototype.applyMatrix = function(matrix) {
  console.warn("THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().");
  return this.applyMatrix4(matrix);
};
Object.defineProperties(Object3D.prototype, {
  eulerOrder: {
    get: function() {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
      return this.rotation.order;
    },
    set: function(value) {
      console.warn("THREE.Object3D: .eulerOrder is now .rotation.order.");
      this.rotation.order = value;
    }
  },
  useQuaternion: {
    get: function() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    },
    set: function() {
      console.warn("THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.");
    }
  }
});
Mesh.prototype.setDrawMode = function() {
  console.error("THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
};
Object.defineProperties(Mesh.prototype, {
  drawMode: {
    get: function() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.");
      return TrianglesDrawMode;
    },
    set: function() {
      console.error("THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.");
    }
  }
});
SkinnedMesh.prototype.initBones = function() {
  console.error("THREE.SkinnedMesh: initBones() has been removed.");
};
PerspectiveCamera.prototype.setLens = function(focalLength, filmGauge) {
  console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
  if (filmGauge !== void 0)
    this.filmGauge = filmGauge;
  this.setFocalLength(focalLength);
};
Object.defineProperties(Light.prototype, {
  onlyShadow: {
    set: function() {
      console.warn("THREE.Light: .onlyShadow has been removed.");
    }
  },
  shadowCameraFov: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraFov is now .shadow.camera.fov.");
      this.shadow.camera.fov = value;
    }
  },
  shadowCameraLeft: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraLeft is now .shadow.camera.left.");
      this.shadow.camera.left = value;
    }
  },
  shadowCameraRight: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraRight is now .shadow.camera.right.");
      this.shadow.camera.right = value;
    }
  },
  shadowCameraTop: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraTop is now .shadow.camera.top.");
      this.shadow.camera.top = value;
    }
  },
  shadowCameraBottom: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.");
      this.shadow.camera.bottom = value;
    }
  },
  shadowCameraNear: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraNear is now .shadow.camera.near.");
      this.shadow.camera.near = value;
    }
  },
  shadowCameraFar: {
    set: function(value) {
      console.warn("THREE.Light: .shadowCameraFar is now .shadow.camera.far.");
      this.shadow.camera.far = value;
    }
  },
  shadowCameraVisible: {
    set: function() {
      console.warn("THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.");
    }
  },
  shadowBias: {
    set: function(value) {
      console.warn("THREE.Light: .shadowBias is now .shadow.bias.");
      this.shadow.bias = value;
    }
  },
  shadowDarkness: {
    set: function() {
      console.warn("THREE.Light: .shadowDarkness has been removed.");
    }
  },
  shadowMapWidth: {
    set: function(value) {
      console.warn("THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.");
      this.shadow.mapSize.width = value;
    }
  },
  shadowMapHeight: {
    set: function(value) {
      console.warn("THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.");
      this.shadow.mapSize.height = value;
    }
  }
});
Object.defineProperties(BufferAttribute.prototype, {
  length: {
    get: function() {
      console.warn("THREE.BufferAttribute: .length has been deprecated. Use .count instead.");
      return this.array.length;
    }
  },
  dynamic: {
    get: function() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
      return this.usage === DynamicDrawUsage;
    },
    set: function() {
      console.warn("THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.");
      this.setUsage(DynamicDrawUsage);
    }
  }
});
BufferAttribute.prototype.setDynamic = function(value) {
  console.warn("THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.");
  this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
  return this;
};
BufferAttribute.prototype.copyIndicesArray = function() {
  console.error("THREE.BufferAttribute: .copyIndicesArray() has been removed.");
}, BufferAttribute.prototype.setArray = function() {
  console.error("THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
BufferGeometry.prototype.addIndex = function(index2) {
  console.warn("THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().");
  this.setIndex(index2);
};
BufferGeometry.prototype.addAttribute = function(name2, attribute) {
  console.warn("THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().");
  if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
    console.warn("THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).");
    return this.setAttribute(name2, new BufferAttribute(arguments[1], arguments[2]));
  }
  if (name2 === "index") {
    console.warn("THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.");
    this.setIndex(attribute);
    return this;
  }
  return this.setAttribute(name2, attribute);
};
BufferGeometry.prototype.addDrawCall = function(start2, count3, indexOffset) {
  if (indexOffset !== void 0) {
    console.warn("THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.");
  }
  console.warn("THREE.BufferGeometry: .addDrawCall() is now .addGroup().");
  this.addGroup(start2, count3);
};
BufferGeometry.prototype.clearDrawCalls = function() {
  console.warn("THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().");
  this.clearGroups();
};
BufferGeometry.prototype.computeOffsets = function() {
  console.warn("THREE.BufferGeometry: .computeOffsets() has been removed.");
};
BufferGeometry.prototype.removeAttribute = function(name2) {
  console.warn("THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().");
  return this.deleteAttribute(name2);
};
BufferGeometry.prototype.applyMatrix = function(matrix) {
  console.warn("THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().");
  return this.applyMatrix4(matrix);
};
Object.defineProperties(BufferGeometry.prototype, {
  drawcalls: {
    get: function() {
      console.error("THREE.BufferGeometry: .drawcalls has been renamed to .groups.");
      return this.groups;
    }
  },
  offsets: {
    get: function() {
      console.warn("THREE.BufferGeometry: .offsets has been renamed to .groups.");
      return this.groups;
    }
  }
});
InterleavedBuffer.prototype.setDynamic = function(value) {
  console.warn("THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.");
  this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
  return this;
};
InterleavedBuffer.prototype.setArray = function() {
  console.error("THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers");
};
ExtrudeGeometry.prototype.getArrays = function() {
  console.error("THREE.ExtrudeGeometry: .getArrays() has been removed.");
};
ExtrudeGeometry.prototype.addShapeList = function() {
  console.error("THREE.ExtrudeGeometry: .addShapeList() has been removed.");
};
ExtrudeGeometry.prototype.addShape = function() {
  console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
};
Scene.prototype.dispose = function() {
  console.error("THREE.Scene: .dispose() has been removed.");
};
Uniform.prototype.onUpdate = function() {
  console.warn("THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.");
  return this;
};
Object.defineProperties(Material$1.prototype, {
  wrapAround: {
    get: function() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    },
    set: function() {
      console.warn("THREE.Material: .wrapAround has been removed.");
    }
  },
  overdraw: {
    get: function() {
      console.warn("THREE.Material: .overdraw has been removed.");
    },
    set: function() {
      console.warn("THREE.Material: .overdraw has been removed.");
    }
  },
  wrapRGB: {
    get: function() {
      console.warn("THREE.Material: .wrapRGB has been removed.");
      return new Color();
    }
  },
  shading: {
    get: function() {
      console.error("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
    },
    set: function(value) {
      console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead.");
      this.flatShading = value === FlatShading;
    }
  },
  stencilMask: {
    get: function() {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
      return this.stencilFuncMask;
    },
    set: function(value) {
      console.warn("THREE." + this.type + ": .stencilMask has been removed. Use .stencilFuncMask instead.");
      this.stencilFuncMask = value;
    }
  },
  vertexTangents: {
    get: function() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    },
    set: function() {
      console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
    }
  }
});
Object.defineProperties(ShaderMaterial.prototype, {
  derivatives: {
    get: function() {
      console.warn("THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
      return this.extensions.derivatives;
    },
    set: function(value) {
      console.warn("THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.");
      this.extensions.derivatives = value;
    }
  }
});
WebGLRenderer.prototype.clearTarget = function(renderTarget, color, depth2, stencil) {
  console.warn("THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.");
  this.setRenderTarget(renderTarget);
  this.clear(color, depth2, stencil);
};
WebGLRenderer.prototype.animate = function(callback) {
  console.warn("THREE.WebGLRenderer: .animate() is now .setAnimationLoop().");
  this.setAnimationLoop(callback);
};
WebGLRenderer.prototype.getCurrentRenderTarget = function() {
  console.warn("THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().");
  return this.getRenderTarget();
};
WebGLRenderer.prototype.getMaxAnisotropy = function() {
  console.warn("THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().");
  return this.capabilities.getMaxAnisotropy();
};
WebGLRenderer.prototype.getPrecision = function() {
  console.warn("THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.");
  return this.capabilities.precision;
};
WebGLRenderer.prototype.resetGLState = function() {
  console.warn("THREE.WebGLRenderer: .resetGLState() is now .state.reset().");
  return this.state.reset();
};
WebGLRenderer.prototype.supportsFloatTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' ).");
  return this.extensions.get("OES_texture_float");
};
WebGLRenderer.prototype.supportsHalfFloatTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' ).");
  return this.extensions.get("OES_texture_half_float");
};
WebGLRenderer.prototype.supportsStandardDerivatives = function() {
  console.warn("THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' ).");
  return this.extensions.get("OES_standard_derivatives");
};
WebGLRenderer.prototype.supportsCompressedTextureS3TC = function() {
  console.warn("THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' ).");
  return this.extensions.get("WEBGL_compressed_texture_s3tc");
};
WebGLRenderer.prototype.supportsCompressedTexturePVRTC = function() {
  console.warn("THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' ).");
  return this.extensions.get("WEBGL_compressed_texture_pvrtc");
};
WebGLRenderer.prototype.supportsBlendMinMax = function() {
  console.warn("THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' ).");
  return this.extensions.get("EXT_blend_minmax");
};
WebGLRenderer.prototype.supportsVertexTextures = function() {
  console.warn("THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.");
  return this.capabilities.vertexTextures;
};
WebGLRenderer.prototype.supportsInstancedArrays = function() {
  console.warn("THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' ).");
  return this.extensions.get("ANGLE_instanced_arrays");
};
WebGLRenderer.prototype.enableScissorTest = function(boolean2) {
  console.warn("THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().");
  this.setScissorTest(boolean2);
};
WebGLRenderer.prototype.initMaterial = function() {
  console.warn("THREE.WebGLRenderer: .initMaterial() has been removed.");
};
WebGLRenderer.prototype.addPrePlugin = function() {
  console.warn("THREE.WebGLRenderer: .addPrePlugin() has been removed.");
};
WebGLRenderer.prototype.addPostPlugin = function() {
  console.warn("THREE.WebGLRenderer: .addPostPlugin() has been removed.");
};
WebGLRenderer.prototype.updateShadowMap = function() {
  console.warn("THREE.WebGLRenderer: .updateShadowMap() has been removed.");
};
WebGLRenderer.prototype.setFaceCulling = function() {
  console.warn("THREE.WebGLRenderer: .setFaceCulling() has been removed.");
};
WebGLRenderer.prototype.allocTextureUnit = function() {
  console.warn("THREE.WebGLRenderer: .allocTextureUnit() has been removed.");
};
WebGLRenderer.prototype.setTexture = function() {
  console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
};
WebGLRenderer.prototype.setTexture2D = function() {
  console.warn("THREE.WebGLRenderer: .setTexture2D() has been removed.");
};
WebGLRenderer.prototype.setTextureCube = function() {
  console.warn("THREE.WebGLRenderer: .setTextureCube() has been removed.");
};
WebGLRenderer.prototype.getActiveMipMapLevel = function() {
  console.warn("THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().");
  return this.getActiveMipmapLevel();
};
Object.defineProperties(WebGLRenderer.prototype, {
  shadowMapEnabled: {
    get: function() {
      return this.shadowMap.enabled;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.");
      this.shadowMap.enabled = value;
    }
  },
  shadowMapType: {
    get: function() {
      return this.shadowMap.type;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.");
      this.shadowMap.type = value;
    }
  },
  shadowMapCullFace: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  context: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.");
      return this.getContext();
    }
  },
  vr: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .vr has been renamed to .xr");
      return this.xr;
    }
  },
  gammaInput: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
      return false;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.");
    }
  },
  gammaOutput: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
      return false;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.");
      this.outputEncoding = value === true ? sRGBEncoding : LinearEncoding;
    }
  },
  toneMappingWhitePoint: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
      return 1;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.");
    }
  },
  gammaFactor: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
      return 2;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
    }
  }
});
Object.defineProperties(WebGLShadowMap.prototype, {
  cullFace: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.");
    }
  },
  renderReverseSided: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.");
    }
  },
  renderSingleSided: {
    get: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
      return void 0;
    },
    set: function() {
      console.warn("THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.");
    }
  }
});
class WebGLRenderTargetCube extends WebGLCubeRenderTarget {
  constructor(width, height, options2) {
    console.warn("THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).");
    super(width, options2);
  }
}
Object.defineProperties(WebGLRenderTarget.prototype, {
  wrapS: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
      return this.texture.wrapS;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.");
      this.texture.wrapS = value;
    }
  },
  wrapT: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
      return this.texture.wrapT;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.");
      this.texture.wrapT = value;
    }
  },
  magFilter: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
      return this.texture.magFilter;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.");
      this.texture.magFilter = value;
    }
  },
  minFilter: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
      return this.texture.minFilter;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.");
      this.texture.minFilter = value;
    }
  },
  anisotropy: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
      return this.texture.anisotropy;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.");
      this.texture.anisotropy = value;
    }
  },
  offset: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
      return this.texture.offset;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .offset is now .texture.offset.");
      this.texture.offset = value;
    }
  },
  repeat: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
      return this.texture.repeat;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .repeat is now .texture.repeat.");
      this.texture.repeat = value;
    }
  },
  format: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
      return this.texture.format;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .format is now .texture.format.");
      this.texture.format = value;
    }
  },
  type: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
      return this.texture.type;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .type is now .texture.type.");
      this.texture.type = value;
    }
  },
  generateMipmaps: {
    get: function() {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
      return this.texture.generateMipmaps;
    },
    set: function(value) {
      console.warn("THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.");
      this.texture.generateMipmaps = value;
    }
  }
});
Audio.prototype.load = function(file2) {
  console.warn("THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.");
  const scope = this;
  const audioLoader = new AudioLoader();
  audioLoader.load(file2, function(buffer3) {
    scope.setBuffer(buffer3);
  });
  return this;
};
AudioAnalyser.prototype.getData = function() {
  console.warn("THREE.AudioAnalyser: .getData() is now .getFrequencyData().");
  return this.getFrequencyData();
};
CubeCamera.prototype.updateCubeMap = function(renderer, scene) {
  console.warn("THREE.CubeCamera: .updateCubeMap() is now .update().");
  return this.update(renderer, scene);
};
CubeCamera.prototype.clear = function(renderer, color, depth2, stencil) {
  console.warn("THREE.CubeCamera: .clear() is now .renderTarget.clear().");
  return this.renderTarget.clear(renderer, color, depth2, stencil);
};
ImageUtils.crossOrigin = void 0;
ImageUtils.loadTexture = function(url2, mapping, onLoad, onError) {
  console.warn("THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.");
  const loader2 = new TextureLoader();
  loader2.setCrossOrigin(this.crossOrigin);
  const texture = loader2.load(url2, onLoad, void 0, onError);
  if (mapping)
    texture.mapping = mapping;
  return texture;
};
ImageUtils.loadTextureCube = function(urls, mapping, onLoad, onError) {
  console.warn("THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.");
  const loader2 = new CubeTextureLoader();
  loader2.setCrossOrigin(this.crossOrigin);
  const texture = loader2.load(urls, onLoad, void 0, onError);
  if (mapping)
    texture.mapping = mapping;
  return texture;
};
ImageUtils.loadCompressedTexture = function() {
  console.error("THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.");
};
ImageUtils.loadCompressedTextureCube = function() {
  console.error("THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.");
};
function CanvasRenderer() {
  console.error("THREE.CanvasRenderer has been removed");
}
function JSONLoader() {
  console.error("THREE.JSONLoader has been removed.");
}
const SceneUtils = {
  createMultiMaterialObject: function() {
    console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
  },
  detach: function() {
    console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
  },
  attach: function() {
    console.error("THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js");
  }
};
function LensFlare() {
  console.error("THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js");
}
class ParametricGeometry extends BufferGeometry {
  constructor() {
    console.error("THREE.ParametricGeometry has been moved to /examples/jsm/geometries/ParametricGeometry.js");
    super();
  }
}
class TextGeometry extends BufferGeometry {
  constructor() {
    console.error("THREE.TextGeometry has been moved to /examples/jsm/geometries/TextGeometry.js");
    super();
  }
}
function FontLoader$2() {
  console.error("THREE.FontLoader has been moved to /examples/jsm/loaders/FontLoader.js");
}
function Font$1() {
  console.error("THREE.Font has been moved to /examples/jsm/loaders/FontLoader.js");
}
function ImmediateRenderObject() {
  console.error("THREE.ImmediateRenderObject has been removed.");
}
class WebGLMultisampleRenderTarget extends WebGLRenderTarget {
  constructor(width, height, options2) {
    console.error('THREE.WebGLMultisampleRenderTarget has been removed. Use a normal render target and set the "samples" property to greater 0 to enable multisampling.');
    super(width, height, options2);
    this.samples = 4;
  }
}
class DataTexture2DArray extends DataArrayTexture {
  constructor(data2, width, height, depth2) {
    console.warn("THREE.DataTexture2DArray has been renamed to DataArrayTexture.");
    super(data2, width, height, depth2);
  }
}
class DataTexture3D extends Data3DTexture {
  constructor(data2, width, height, depth2) {
    console.warn("THREE.DataTexture3D has been renamed to Data3DTexture.");
    super(data2, width, height, depth2);
  }
}
if (typeof __THREE_DEVTOOLS__ !== "undefined") {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
    revision: REVISION
  } }));
}
if (typeof window !== "undefined") {
  if (window.__THREE__) {
    console.warn("WARNING: Multiple instances of Three.js being imported.");
  } else {
    window.__THREE__ = REVISION;
  }
}
const THREE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACESFilmicToneMapping,
  AddEquation,
  AddOperation,
  AdditiveAnimationBlendMode,
  AdditiveBlending,
  AlphaFormat,
  AlwaysDepth,
  AlwaysStencilFunc,
  AmbientLight: AmbientLight$1,
  AmbientLightProbe,
  AnimationClip,
  AnimationLoader,
  AnimationMixer,
  AnimationObjectGroup,
  AnimationUtils,
  ArcCurve,
  ArrayCamera,
  ArrowHelper,
  Audio,
  AudioAnalyser,
  AudioContext,
  AudioListener,
  AudioLoader,
  AxesHelper,
  AxisHelper,
  BackSide,
  BasicDepthPacking,
  BasicShadowMap,
  BinaryTextureLoader,
  Bone,
  BooleanKeyframeTrack,
  BoundingBoxHelper,
  Box2,
  Box3,
  Box3Helper,
  BoxBufferGeometry: BoxGeometry,
  BoxGeometry,
  BoxHelper,
  BufferAttribute,
  BufferGeometry,
  BufferGeometryLoader,
  ByteType,
  Cache,
  Camera,
  CameraHelper,
  CanvasRenderer,
  CanvasTexture,
  CapsuleBufferGeometry: CapsuleGeometry,
  CapsuleGeometry,
  CatmullRomCurve3,
  CineonToneMapping,
  CircleBufferGeometry: CircleGeometry,
  CircleGeometry,
  ClampToEdgeWrapping,
  Clock,
  Color,
  ColorKeyframeTrack,
  ColorManagement,
  CompressedTexture,
  CompressedTextureLoader,
  ConeBufferGeometry: ConeGeometry,
  ConeGeometry,
  CubeCamera,
  CubeReflectionMapping,
  CubeRefractionMapping,
  CubeTexture,
  CubeTextureLoader,
  CubeUVReflectionMapping,
  CubicBezierCurve,
  CubicBezierCurve3,
  CubicInterpolant,
  CullFaceBack,
  CullFaceFront,
  CullFaceFrontBack,
  CullFaceNone,
  Curve,
  CurvePath,
  CustomBlending,
  CustomToneMapping,
  CylinderBufferGeometry: CylinderGeometry,
  CylinderGeometry,
  Cylindrical,
  Data3DTexture,
  DataArrayTexture,
  DataTexture,
  DataTexture2DArray,
  DataTexture3D,
  DataTextureLoader,
  DataUtils,
  DecrementStencilOp,
  DecrementWrapStencilOp,
  DefaultLoadingManager,
  DepthFormat,
  DepthStencilFormat,
  DepthTexture,
  DirectionalLight: DirectionalLight$1,
  DirectionalLightHelper,
  DiscreteInterpolant,
  DodecahedronBufferGeometry: DodecahedronGeometry,
  DodecahedronGeometry,
  DoubleSide,
  DstAlphaFactor,
  DstColorFactor,
  DynamicBufferAttribute,
  DynamicCopyUsage,
  DynamicDrawUsage,
  DynamicReadUsage,
  EdgesGeometry,
  EdgesHelper,
  EllipseCurve,
  EqualDepth,
  EqualStencilFunc,
  EquirectangularReflectionMapping,
  EquirectangularRefractionMapping,
  Euler,
  EventDispatcher: EventDispatcher$1,
  ExtrudeBufferGeometry: ExtrudeGeometry,
  ExtrudeGeometry,
  FaceColors,
  FileLoader,
  FlatShading,
  Float16BufferAttribute,
  Float32Attribute,
  Float32BufferAttribute,
  Float64Attribute,
  Float64BufferAttribute,
  FloatType,
  Fog,
  FogExp2,
  Font: Font$1,
  FontLoader: FontLoader$2,
  FramebufferTexture,
  FrontSide,
  Frustum,
  GLBufferAttribute,
  GLSL1,
  GLSL3,
  GreaterDepth,
  GreaterEqualDepth,
  GreaterEqualStencilFunc,
  GreaterStencilFunc,
  GridHelper,
  Group,
  HalfFloatType,
  HemisphereLight,
  HemisphereLightHelper,
  HemisphereLightProbe,
  IcosahedronBufferGeometry: IcosahedronGeometry,
  IcosahedronGeometry,
  ImageBitmapLoader,
  ImageLoader: ImageLoader$2,
  ImageUtils,
  ImmediateRenderObject,
  IncrementStencilOp,
  IncrementWrapStencilOp,
  InstancedBufferAttribute,
  InstancedBufferGeometry,
  InstancedInterleavedBuffer,
  InstancedMesh,
  Int16Attribute,
  Int16BufferAttribute,
  Int32Attribute,
  Int32BufferAttribute,
  Int8Attribute,
  Int8BufferAttribute,
  IntType,
  InterleavedBuffer,
  InterleavedBufferAttribute,
  Interpolant,
  InterpolateDiscrete,
  InterpolateLinear,
  InterpolateSmooth,
  InvertStencilOp,
  JSONLoader,
  KeepStencilOp,
  KeyframeTrack,
  LOD,
  LatheBufferGeometry: LatheGeometry,
  LatheGeometry,
  Layers,
  LensFlare,
  LessDepth,
  LessEqualDepth,
  LessEqualStencilFunc,
  LessStencilFunc,
  Light,
  LightProbe,
  Line,
  Line3,
  LineBasicMaterial,
  LineCurve,
  LineCurve3,
  LineDashedMaterial,
  LineLoop,
  LinePieces,
  LineSegments,
  LineStrip,
  LinearEncoding,
  LinearFilter,
  LinearInterpolant,
  LinearMipMapLinearFilter,
  LinearMipMapNearestFilter,
  LinearMipmapLinearFilter,
  LinearMipmapNearestFilter,
  LinearSRGBColorSpace,
  LinearToneMapping,
  Loader,
  LoaderUtils,
  LoadingManager,
  LoopOnce,
  LoopPingPong,
  LoopRepeat,
  LuminanceAlphaFormat,
  LuminanceFormat,
  MOUSE,
  Material: Material$1,
  MaterialLoader,
  Math: MathUtils,
  MathUtils,
  Matrix3: Matrix3$1,
  Matrix4: Matrix4$1,
  MaxEquation,
  Mesh,
  MeshBasicMaterial,
  MeshDepthMaterial,
  MeshDistanceMaterial,
  MeshFaceMaterial,
  MeshLambertMaterial,
  MeshMatcapMaterial,
  MeshNormalMaterial,
  MeshPhongMaterial,
  MeshPhysicalMaterial,
  MeshStandardMaterial,
  MeshToonMaterial,
  MinEquation,
  MirroredRepeatWrapping,
  MixOperation,
  MultiMaterial,
  MultiplyBlending,
  MultiplyOperation,
  NearestFilter,
  NearestMipMapLinearFilter,
  NearestMipMapNearestFilter,
  NearestMipmapLinearFilter,
  NearestMipmapNearestFilter,
  NeverDepth,
  NeverStencilFunc,
  NoBlending,
  NoColorSpace,
  NoColors,
  NoToneMapping,
  NormalAnimationBlendMode,
  NormalBlending,
  NotEqualDepth,
  NotEqualStencilFunc,
  NumberKeyframeTrack,
  Object3D,
  ObjectLoader,
  ObjectSpaceNormalMap,
  OctahedronBufferGeometry: OctahedronGeometry,
  OctahedronGeometry,
  OneFactor,
  OneMinusDstAlphaFactor,
  OneMinusDstColorFactor,
  OneMinusSrcAlphaFactor,
  OneMinusSrcColorFactor,
  OrthographicCamera,
  PCFShadowMap,
  PCFSoftShadowMap,
  PMREMGenerator,
  ParametricGeometry,
  Particle,
  ParticleBasicMaterial,
  ParticleSystem,
  ParticleSystemMaterial,
  Path,
  PerspectiveCamera,
  Plane: Plane$1,
  PlaneBufferGeometry: PlaneGeometry,
  PlaneGeometry,
  PlaneHelper,
  PointCloud,
  PointCloudMaterial,
  PointLight,
  PointLightHelper,
  Points,
  PointsMaterial,
  PolarGridHelper,
  PolyhedronBufferGeometry: PolyhedronGeometry,
  PolyhedronGeometry,
  PositionalAudio,
  PropertyBinding,
  PropertyMixer,
  QuadraticBezierCurve,
  QuadraticBezierCurve3,
  Quaternion: Quaternion$1,
  QuaternionKeyframeTrack,
  QuaternionLinearInterpolant,
  REVISION,
  RGBADepthPacking,
  RGBAFormat,
  RGBAIntegerFormat,
  RGBA_ASTC_10x10_Format,
  RGBA_ASTC_10x5_Format,
  RGBA_ASTC_10x6_Format,
  RGBA_ASTC_10x8_Format,
  RGBA_ASTC_12x10_Format,
  RGBA_ASTC_12x12_Format,
  RGBA_ASTC_4x4_Format,
  RGBA_ASTC_5x4_Format,
  RGBA_ASTC_5x5_Format,
  RGBA_ASTC_6x5_Format,
  RGBA_ASTC_6x6_Format,
  RGBA_ASTC_8x5_Format,
  RGBA_ASTC_8x6_Format,
  RGBA_ASTC_8x8_Format,
  RGBA_BPTC_Format,
  RGBA_ETC2_EAC_Format,
  RGBA_PVRTC_2BPPV1_Format,
  RGBA_PVRTC_4BPPV1_Format,
  RGBA_S3TC_DXT1_Format,
  RGBA_S3TC_DXT3_Format,
  RGBA_S3TC_DXT5_Format,
  RGBFormat,
  RGB_ETC1_Format,
  RGB_ETC2_Format,
  RGB_PVRTC_2BPPV1_Format,
  RGB_PVRTC_4BPPV1_Format,
  RGB_S3TC_DXT1_Format,
  RGFormat,
  RGIntegerFormat,
  RawShaderMaterial,
  Ray,
  Raycaster,
  RectAreaLight,
  RedFormat,
  RedIntegerFormat,
  ReinhardToneMapping,
  RepeatWrapping,
  ReplaceStencilOp,
  ReverseSubtractEquation,
  RingBufferGeometry: RingGeometry,
  RingGeometry,
  SRGBColorSpace,
  Scene,
  SceneUtils,
  ShaderChunk,
  ShaderLib,
  ShaderMaterial,
  ShadowMaterial,
  Shape,
  ShapeBufferGeometry: ShapeGeometry,
  ShapeGeometry,
  ShapePath,
  ShapeUtils,
  ShortType,
  Skeleton,
  SkeletonHelper,
  SkinnedMesh,
  SmoothShading,
  Source,
  Sphere,
  SphereBufferGeometry: SphereGeometry,
  SphereGeometry,
  Spherical,
  SphericalHarmonics3,
  SplineCurve,
  SpotLight,
  SpotLightHelper,
  Sprite,
  SpriteMaterial,
  SrcAlphaFactor,
  SrcAlphaSaturateFactor,
  SrcColorFactor,
  StaticCopyUsage,
  StaticDrawUsage,
  StaticReadUsage,
  StereoCamera,
  StreamCopyUsage,
  StreamDrawUsage,
  StreamReadUsage,
  StringKeyframeTrack,
  SubtractEquation,
  SubtractiveBlending,
  TOUCH,
  TangentSpaceNormalMap,
  TetrahedronBufferGeometry: TetrahedronGeometry,
  TetrahedronGeometry,
  TextGeometry,
  Texture: Texture$1,
  TextureLoader,
  TorusBufferGeometry: TorusGeometry,
  TorusGeometry,
  TorusKnotBufferGeometry: TorusKnotGeometry,
  TorusKnotGeometry,
  Triangle,
  TriangleFanDrawMode,
  TriangleStripDrawMode,
  TrianglesDrawMode,
  TubeBufferGeometry: TubeGeometry,
  TubeGeometry,
  UVMapping,
  Uint16Attribute,
  Uint16BufferAttribute,
  Uint32Attribute,
  Uint32BufferAttribute,
  Uint8Attribute,
  Uint8BufferAttribute,
  Uint8ClampedAttribute,
  Uint8ClampedBufferAttribute,
  Uniform,
  UniformsLib,
  UniformsUtils,
  UnsignedByteType,
  UnsignedInt248Type,
  UnsignedIntType,
  UnsignedShort4444Type,
  UnsignedShort5551Type,
  UnsignedShortType,
  VSMShadowMap,
  Vector2: Vector2$1,
  Vector3: Vector3$1,
  Vector4: Vector4$1,
  VectorKeyframeTrack,
  Vertex: Vertex$1,
  VertexColors,
  VideoTexture,
  WebGL1Renderer,
  WebGL3DRenderTarget,
  WebGLArrayRenderTarget,
  WebGLCubeRenderTarget,
  WebGLMultipleRenderTargets,
  WebGLMultisampleRenderTarget,
  WebGLRenderTarget,
  WebGLRenderTargetCube,
  WebGLRenderer,
  WebGLUtils,
  WireframeGeometry,
  WireframeHelper,
  WrapAroundEnding,
  XHRLoader,
  ZeroCurvatureEnding,
  ZeroFactor,
  ZeroSlopeEnding,
  ZeroStencilOp,
  _SRGBAFormat,
  sRGBEncoding
}, Symbol.toStringTag, { value: "Module" }));
class GLTFExporter {
  constructor() {
    this.pluginCallbacks = [];
    this.register(function(writer) {
      return new GLTFLightExtension(writer);
    });
    this.register(function(writer) {
      return new GLTFMaterialsUnlitExtension$1(writer);
    });
    this.register(function(writer) {
      return new GLTFMaterialsPBRSpecularGlossiness(writer);
    });
    this.register(function(writer) {
      return new GLTFMaterialsTransmissionExtension$1(writer);
    });
    this.register(function(writer) {
      return new GLTFMaterialsVolumeExtension$1(writer);
    });
    this.register(function(writer) {
      return new GLTFMaterialsClearcoatExtension$1(writer);
    });
  }
  register(callback) {
    if (this.pluginCallbacks.indexOf(callback) === -1) {
      this.pluginCallbacks.push(callback);
    }
    return this;
  }
  unregister(callback) {
    if (this.pluginCallbacks.indexOf(callback) !== -1) {
      this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
    }
    return this;
  }
  /**
   * Parse scenes and generate GLTF output
   * @param  {Scene or [THREE.Scenes]} input   Scene or Array of THREE.Scenes
   * @param  {Function} onDone  Callback on completed
   * @param  {Function} onError  Callback on errors
   * @param  {Object} options options
   */
  parse(input, onDone, onError, options2) {
    if (typeof onError === "object") {
      console.warn("THREE.GLTFExporter: parse() expects options as the fourth argument now.");
      options2 = onError;
    }
    const writer = new GLTFWriter();
    const plugins = [];
    for (let i2 = 0, il = this.pluginCallbacks.length; i2 < il; i2++) {
      plugins.push(this.pluginCallbacks[i2](writer));
    }
    writer.setPlugins(plugins);
    writer.write(input, onDone, options2).catch(onError);
  }
  parseAsync(input, options2) {
    const scope = this;
    return new Promise(function(resolve2, reject) {
      scope.parse(input, resolve2, reject, options2);
    });
  }
}
const WEBGL_CONSTANTS$1 = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  UNSIGNED_BYTE: 5121,
  UNSIGNED_SHORT: 5123,
  FLOAT: 5126,
  UNSIGNED_INT: 5125,
  ARRAY_BUFFER: 34962,
  ELEMENT_ARRAY_BUFFER: 34963,
  NEAREST: 9728,
  LINEAR: 9729,
  NEAREST_MIPMAP_NEAREST: 9984,
  LINEAR_MIPMAP_NEAREST: 9985,
  NEAREST_MIPMAP_LINEAR: 9986,
  LINEAR_MIPMAP_LINEAR: 9987,
  CLAMP_TO_EDGE: 33071,
  MIRRORED_REPEAT: 33648,
  REPEAT: 10497
};
const THREE_TO_WEBGL = {};
THREE_TO_WEBGL[NearestFilter] = WEBGL_CONSTANTS$1.NEAREST;
THREE_TO_WEBGL[NearestMipmapNearestFilter] = WEBGL_CONSTANTS$1.NEAREST_MIPMAP_NEAREST;
THREE_TO_WEBGL[NearestMipmapLinearFilter] = WEBGL_CONSTANTS$1.NEAREST_MIPMAP_LINEAR;
THREE_TO_WEBGL[LinearFilter] = WEBGL_CONSTANTS$1.LINEAR;
THREE_TO_WEBGL[LinearMipmapNearestFilter] = WEBGL_CONSTANTS$1.LINEAR_MIPMAP_NEAREST;
THREE_TO_WEBGL[LinearMipmapLinearFilter] = WEBGL_CONSTANTS$1.LINEAR_MIPMAP_LINEAR;
THREE_TO_WEBGL[ClampToEdgeWrapping] = WEBGL_CONSTANTS$1.CLAMP_TO_EDGE;
THREE_TO_WEBGL[RepeatWrapping] = WEBGL_CONSTANTS$1.REPEAT;
THREE_TO_WEBGL[MirroredRepeatWrapping] = WEBGL_CONSTANTS$1.MIRRORED_REPEAT;
const PATH_PROPERTIES$1 = {
  scale: "scale",
  position: "translation",
  quaternion: "rotation",
  morphTargetInfluences: "weights"
};
const GLB_HEADER_BYTES = 12;
const GLB_HEADER_MAGIC = 1179937895;
const GLB_VERSION = 2;
const GLB_CHUNK_PREFIX_BYTES = 8;
const GLB_CHUNK_TYPE_JSON$2 = 1313821514;
const GLB_CHUNK_TYPE_BIN$2 = 5130562;
function equalArray(array1, array2) {
  return array1.length === array2.length && array1.every(function(element, index2) {
    return element === array2[index2];
  });
}
function stringToArrayBuffer(text) {
  if (window.TextEncoder !== void 0) {
    return new TextEncoder().encode(text).buffer;
  }
  const array2 = new Uint8Array(new ArrayBuffer(text.length));
  for (let i2 = 0, il = text.length; i2 < il; i2++) {
    const value = text.charCodeAt(i2);
    array2[i2] = value > 255 ? 32 : value;
  }
  return array2.buffer;
}
function isIdentityMatrix(matrix) {
  return equalArray(matrix.elements, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
}
function getMinMax(attribute, start2, count3) {
  const output2 = {
    min: new Array(attribute.itemSize).fill(Number.POSITIVE_INFINITY),
    max: new Array(attribute.itemSize).fill(Number.NEGATIVE_INFINITY)
  };
  for (let i2 = start2; i2 < start2 + count3; i2++) {
    for (let a2 = 0; a2 < attribute.itemSize; a2++) {
      let value;
      if (attribute.itemSize > 4) {
        value = attribute.array[i2 * attribute.itemSize + a2];
      } else {
        if (a2 === 0)
          value = attribute.getX(i2);
        else if (a2 === 1)
          value = attribute.getY(i2);
        else if (a2 === 2)
          value = attribute.getZ(i2);
        else if (a2 === 3)
          value = attribute.getW(i2);
      }
      output2.min[a2] = Math.min(output2.min[a2], value);
      output2.max[a2] = Math.max(output2.max[a2], value);
    }
  }
  return output2;
}
function getPaddedBufferSize(bufferSize) {
  return Math.ceil(bufferSize / 4) * 4;
}
function getPaddedArrayBuffer(arrayBuffer2, paddingByte = 0) {
  const paddedLength = getPaddedBufferSize(arrayBuffer2.byteLength);
  if (paddedLength !== arrayBuffer2.byteLength) {
    const array2 = new Uint8Array(paddedLength);
    array2.set(new Uint8Array(arrayBuffer2));
    if (paddingByte !== 0) {
      for (let i2 = arrayBuffer2.byteLength; i2 < paddedLength; i2++) {
        array2[i2] = paddingByte;
      }
    }
    return array2.buffer;
  }
  return arrayBuffer2;
}
let cachedCanvas = null;
class GLTFWriter {
  constructor() {
    this.plugins = [];
    this.options = {};
    this.pending = [];
    this.buffers = [];
    this.byteOffset = 0;
    this.buffers = [];
    this.nodeMap = /* @__PURE__ */ new Map();
    this.skins = [];
    this.extensionsUsed = {};
    this.uids = /* @__PURE__ */ new Map();
    this.uid = 0;
    this.json = {
      asset: {
        version: "2.0",
        generator: "THREE.GLTFExporter"
      }
    };
    this.cache = {
      meshes: /* @__PURE__ */ new Map(),
      attributes: /* @__PURE__ */ new Map(),
      attributesNormalized: /* @__PURE__ */ new Map(),
      materials: /* @__PURE__ */ new Map(),
      textures: /* @__PURE__ */ new Map(),
      images: /* @__PURE__ */ new Map()
    };
  }
  setPlugins(plugins) {
    this.plugins = plugins;
  }
  /**
   * Parse scenes and generate GLTF output
   * @param  {Scene or [THREE.Scenes]} input   Scene or Array of THREE.Scenes
   * @param  {Function} onDone  Callback on completed
   * @param  {Object} options options
   */
  async write(input, onDone, options2) {
    this.options = Object.assign({}, {
      // default options
      binary: false,
      trs: false,
      onlyVisible: true,
      truncateDrawRange: true,
      embedImages: true,
      maxTextureSize: Infinity,
      animations: [],
      includeCustomExtensions: false
    }, options2);
    if (this.options.animations.length > 0) {
      this.options.trs = true;
    }
    this.processInput(input);
    await Promise.all(this.pending);
    const writer = this;
    const buffers = writer.buffers;
    const json = writer.json;
    options2 = writer.options;
    const extensionsUsed = writer.extensionsUsed;
    const blob = new Blob(buffers, { type: "application/octet-stream" });
    const extensionsUsedList = Object.keys(extensionsUsed);
    if (extensionsUsedList.length > 0)
      json.extensionsUsed = extensionsUsedList;
    if (json.buffers && json.buffers.length > 0)
      json.buffers[0].byteLength = blob.size;
    if (options2.binary === true) {
      const reader = new window.FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onloadend = function() {
        const binaryChunk = getPaddedArrayBuffer(reader.result);
        const binaryChunkPrefix = new DataView(new ArrayBuffer(GLB_CHUNK_PREFIX_BYTES));
        binaryChunkPrefix.setUint32(0, binaryChunk.byteLength, true);
        binaryChunkPrefix.setUint32(4, GLB_CHUNK_TYPE_BIN$2, true);
        const jsonChunk = getPaddedArrayBuffer(stringToArrayBuffer(JSON.stringify(json)), 32);
        const jsonChunkPrefix = new DataView(new ArrayBuffer(GLB_CHUNK_PREFIX_BYTES));
        jsonChunkPrefix.setUint32(0, jsonChunk.byteLength, true);
        jsonChunkPrefix.setUint32(4, GLB_CHUNK_TYPE_JSON$2, true);
        const header = new ArrayBuffer(GLB_HEADER_BYTES);
        const headerView = new DataView(header);
        headerView.setUint32(0, GLB_HEADER_MAGIC, true);
        headerView.setUint32(4, GLB_VERSION, true);
        const totalByteLength = GLB_HEADER_BYTES + jsonChunkPrefix.byteLength + jsonChunk.byteLength + binaryChunkPrefix.byteLength + binaryChunk.byteLength;
        headerView.setUint32(8, totalByteLength, true);
        const glbBlob = new Blob([
          header,
          jsonChunkPrefix,
          jsonChunk,
          binaryChunkPrefix,
          binaryChunk
        ], { type: "application/octet-stream" });
        const glbReader = new window.FileReader();
        glbReader.readAsArrayBuffer(glbBlob);
        glbReader.onloadend = function() {
          onDone(glbReader.result);
        };
      };
    } else {
      if (json.buffers && json.buffers.length > 0) {
        const reader = new window.FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = function() {
          const base64data = reader.result;
          json.buffers[0].uri = base64data;
          onDone(json);
        };
      } else {
        onDone(json);
      }
    }
  }
  /**
   * Serializes a userData.
   *
   * @param {THREE.Object3D|THREE.Material} object
   * @param {Object} objectDef
   */
  serializeUserData(object2, objectDef) {
    if (Object.keys(object2.userData).length === 0)
      return;
    const options2 = this.options;
    const extensionsUsed = this.extensionsUsed;
    try {
      const json = JSON.parse(JSON.stringify(object2.userData));
      if (options2.includeCustomExtensions && json.gltfExtensions) {
        if (objectDef.extensions === void 0)
          objectDef.extensions = {};
        for (const extensionName in json.gltfExtensions) {
          objectDef.extensions[extensionName] = json.gltfExtensions[extensionName];
          extensionsUsed[extensionName] = true;
        }
        delete json.gltfExtensions;
      }
      if (Object.keys(json).length > 0)
        objectDef.extras = json;
    } catch (error2) {
      console.warn("THREE.GLTFExporter: userData of '" + object2.name + "' won't be serialized because of JSON.stringify error - " + error2.message);
    }
  }
  /**
   * Assign and return a temporal unique id for an object
   * especially which doesn't have .uuid
   * @param  {Object} object
   * @return {Integer}
   */
  getUID(object2) {
    if (!this.uids.has(object2))
      this.uids.set(object2, this.uid++);
    return this.uids.get(object2);
  }
  /**
   * Checks if normal attribute values are normalized.
   *
   * @param {BufferAttribute} normal
   * @returns {Boolean}
   */
  isNormalizedNormalAttribute(normal) {
    const cache2 = this.cache;
    if (cache2.attributesNormalized.has(normal))
      return false;
    const v5 = new Vector3$1();
    for (let i2 = 0, il = normal.count; i2 < il; i2++) {
      if (Math.abs(v5.fromBufferAttribute(normal, i2).length() - 1) > 5e-4)
        return false;
    }
    return true;
  }
  /**
   * Creates normalized normal buffer attribute.
   *
   * @param {BufferAttribute} normal
   * @returns {BufferAttribute}
   *
   */
  createNormalizedNormalAttribute(normal) {
    const cache2 = this.cache;
    if (cache2.attributesNormalized.has(normal))
      return cache2.attributesNormalized.get(normal);
    const attribute = normal.clone();
    const v5 = new Vector3$1();
    for (let i2 = 0, il = attribute.count; i2 < il; i2++) {
      v5.fromBufferAttribute(attribute, i2);
      if (v5.x === 0 && v5.y === 0 && v5.z === 0) {
        v5.setX(1);
      } else {
        v5.normalize();
      }
      attribute.setXYZ(i2, v5.x, v5.y, v5.z);
    }
    cache2.attributesNormalized.set(normal, attribute);
    return attribute;
  }
  /**
   * Applies a texture transform, if present, to the map definition. Requires
   * the KHR_texture_transform extension.
   *
   * @param {Object} mapDef
   * @param {THREE.Texture} texture
   */
  applyTextureTransform(mapDef, texture) {
    let didTransform = false;
    const transformDef = {};
    if (texture.offset.x !== 0 || texture.offset.y !== 0) {
      transformDef.offset = texture.offset.toArray();
      didTransform = true;
    }
    if (texture.rotation !== 0) {
      transformDef.rotation = texture.rotation;
      didTransform = true;
    }
    if (texture.repeat.x !== 1 || texture.repeat.y !== 1) {
      transformDef.scale = texture.repeat.toArray();
      didTransform = true;
    }
    if (didTransform) {
      mapDef.extensions = mapDef.extensions || {};
      mapDef.extensions["KHR_texture_transform"] = transformDef;
      this.extensionsUsed["KHR_texture_transform"] = true;
    }
  }
  buildMetalRoughTexture(metalnessMap, roughnessMap) {
    if (metalnessMap === roughnessMap)
      return metalnessMap;
    console.warn("THREE.GLTFExporter: Merged metalnessMap and roughnessMap textures.");
    const metalness = metalnessMap == null ? void 0 : metalnessMap.image;
    const roughness = roughnessMap == null ? void 0 : roughnessMap.image;
    const width = Math.max((metalness == null ? void 0 : metalness.width) || 0, (roughness == null ? void 0 : roughness.width) || 0);
    const height = Math.max((metalness == null ? void 0 : metalness.height) || 0, (roughness == null ? void 0 : roughness.height) || 0);
    const canvas2 = document.createElement("canvas");
    canvas2.width = width;
    canvas2.height = height;
    const context2 = canvas2.getContext("2d");
    context2.fillStyle = "#00ffff";
    context2.fillRect(0, 0, width, height);
    const composite = context2.getImageData(0, 0, width, height);
    if (metalness) {
      context2.drawImage(metalness, 0, 0, width, height);
      const data2 = context2.getImageData(0, 0, width, height).data;
      for (let i2 = 2; i2 < data2.length; i2 += 4) {
        composite.data[i2] = data2[i2];
      }
    }
    if (roughness) {
      context2.drawImage(roughness, 0, 0, width, height);
      const data2 = context2.getImageData(0, 0, width, height).data;
      for (let i2 = 1; i2 < data2.length; i2 += 4) {
        composite.data[i2] = data2[i2];
      }
    }
    context2.putImageData(composite, 0, 0);
    const reference = metalnessMap || roughnessMap;
    const texture = reference.clone();
    texture.source = new Source(canvas2);
    return texture;
  }
  /**
   * Process a buffer to append to the default one.
   * @param  {ArrayBuffer} buffer
   * @return {Integer}
   */
  processBuffer(buffer3) {
    const json = this.json;
    const buffers = this.buffers;
    if (!json.buffers)
      json.buffers = [{ byteLength: 0 }];
    buffers.push(buffer3);
    return 0;
  }
  /**
   * Process and generate a BufferView
   * @param  {BufferAttribute} attribute
   * @param  {number} componentType
   * @param  {number} start
   * @param  {number} count
   * @param  {number} target (Optional) Target usage of the BufferView
   * @return {Object}
   */
  processBufferView(attribute, componentType, start2, count3, target) {
    const json = this.json;
    if (!json.bufferViews)
      json.bufferViews = [];
    let componentSize;
    if (componentType === WEBGL_CONSTANTS$1.UNSIGNED_BYTE) {
      componentSize = 1;
    } else if (componentType === WEBGL_CONSTANTS$1.UNSIGNED_SHORT) {
      componentSize = 2;
    } else {
      componentSize = 4;
    }
    const byteLength = getPaddedBufferSize(count3 * attribute.itemSize * componentSize);
    const dataView = new DataView(new ArrayBuffer(byteLength));
    let offset = 0;
    for (let i2 = start2; i2 < start2 + count3; i2++) {
      for (let a2 = 0; a2 < attribute.itemSize; a2++) {
        let value;
        if (attribute.itemSize > 4) {
          value = attribute.array[i2 * attribute.itemSize + a2];
        } else {
          if (a2 === 0)
            value = attribute.getX(i2);
          else if (a2 === 1)
            value = attribute.getY(i2);
          else if (a2 === 2)
            value = attribute.getZ(i2);
          else if (a2 === 3)
            value = attribute.getW(i2);
        }
        if (componentType === WEBGL_CONSTANTS$1.FLOAT) {
          dataView.setFloat32(offset, value, true);
        } else if (componentType === WEBGL_CONSTANTS$1.UNSIGNED_INT) {
          dataView.setUint32(offset, value, true);
        } else if (componentType === WEBGL_CONSTANTS$1.UNSIGNED_SHORT) {
          dataView.setUint16(offset, value, true);
        } else if (componentType === WEBGL_CONSTANTS$1.UNSIGNED_BYTE) {
          dataView.setUint8(offset, value);
        }
        offset += componentSize;
      }
    }
    const bufferViewDef = {
      buffer: this.processBuffer(dataView.buffer),
      byteOffset: this.byteOffset,
      byteLength
    };
    if (target !== void 0)
      bufferViewDef.target = target;
    if (target === WEBGL_CONSTANTS$1.ARRAY_BUFFER) {
      bufferViewDef.byteStride = attribute.itemSize * componentSize;
    }
    this.byteOffset += byteLength;
    json.bufferViews.push(bufferViewDef);
    const output2 = {
      id: json.bufferViews.length - 1,
      byteLength: 0
    };
    return output2;
  }
  /**
   * Process and generate a BufferView from an image Blob.
   * @param {Blob} blob
   * @return {Promise<Integer>}
   */
  processBufferViewImage(blob) {
    const writer = this;
    const json = writer.json;
    if (!json.bufferViews)
      json.bufferViews = [];
    return new Promise(function(resolve2) {
      const reader = new window.FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onloadend = function() {
        const buffer3 = getPaddedArrayBuffer(reader.result);
        const bufferViewDef = {
          buffer: writer.processBuffer(buffer3),
          byteOffset: writer.byteOffset,
          byteLength: buffer3.byteLength
        };
        writer.byteOffset += buffer3.byteLength;
        resolve2(json.bufferViews.push(bufferViewDef) - 1);
      };
    });
  }
  /**
   * Process attribute to generate an accessor
   * @param  {BufferAttribute} attribute Attribute to process
   * @param  {THREE.BufferGeometry} geometry (Optional) Geometry used for truncated draw range
   * @param  {Integer} start (Optional)
   * @param  {Integer} count (Optional)
   * @return {Integer|null} Index of the processed accessor on the "accessors" array
   */
  processAccessor(attribute, geometry2, start2, count3) {
    const options2 = this.options;
    const json = this.json;
    const types2 = {
      1: "SCALAR",
      2: "VEC2",
      3: "VEC3",
      4: "VEC4",
      16: "MAT4"
    };
    let componentType;
    if (attribute.array.constructor === Float32Array) {
      componentType = WEBGL_CONSTANTS$1.FLOAT;
    } else if (attribute.array.constructor === Uint32Array) {
      componentType = WEBGL_CONSTANTS$1.UNSIGNED_INT;
    } else if (attribute.array.constructor === Uint16Array) {
      componentType = WEBGL_CONSTANTS$1.UNSIGNED_SHORT;
    } else if (attribute.array.constructor === Uint8Array) {
      componentType = WEBGL_CONSTANTS$1.UNSIGNED_BYTE;
    } else {
      throw new Error("THREE.GLTFExporter: Unsupported bufferAttribute component type.");
    }
    if (start2 === void 0)
      start2 = 0;
    if (count3 === void 0)
      count3 = attribute.count;
    if (options2.truncateDrawRange && geometry2 !== void 0 && geometry2.index === null) {
      const end = start2 + count3;
      const end2 = geometry2.drawRange.count === Infinity ? attribute.count : geometry2.drawRange.start + geometry2.drawRange.count;
      start2 = Math.max(start2, geometry2.drawRange.start);
      count3 = Math.min(end, end2) - start2;
      if (count3 < 0)
        count3 = 0;
    }
    if (count3 === 0)
      return null;
    const minMax = getMinMax(attribute, start2, count3);
    let bufferViewTarget;
    if (geometry2 !== void 0) {
      bufferViewTarget = attribute === geometry2.index ? WEBGL_CONSTANTS$1.ELEMENT_ARRAY_BUFFER : WEBGL_CONSTANTS$1.ARRAY_BUFFER;
    }
    const bufferView = this.processBufferView(attribute, componentType, start2, count3, bufferViewTarget);
    const accessorDef = {
      bufferView: bufferView.id,
      byteOffset: bufferView.byteOffset,
      componentType,
      count: count3,
      max: minMax.max,
      min: minMax.min,
      type: types2[attribute.itemSize]
    };
    if (attribute.normalized === true)
      accessorDef.normalized = true;
    if (!json.accessors)
      json.accessors = [];
    return json.accessors.push(accessorDef) - 1;
  }
  /**
   * Process image
   * @param  {Image} image to process
   * @param  {Integer} format of the image (RGBAFormat)
   * @param  {Boolean} flipY before writing out the image
   * @param  {String} mimeType export format
   * @return {Integer}     Index of the processed texture in the "images" array
   */
  processImage(image, format, flipY, mimeType = "image/png") {
    const writer = this;
    const cache2 = writer.cache;
    const json = writer.json;
    const options2 = writer.options;
    const pending = writer.pending;
    if (!cache2.images.has(image))
      cache2.images.set(image, {});
    const cachedImages = cache2.images.get(image);
    const key = mimeType + ":flipY/" + flipY.toString();
    if (cachedImages[key] !== void 0)
      return cachedImages[key];
    if (!json.images)
      json.images = [];
    const imageDef = { mimeType };
    if (options2.embedImages) {
      const canvas2 = cachedCanvas = cachedCanvas || document.createElement("canvas");
      canvas2.width = Math.min(image.width, options2.maxTextureSize);
      canvas2.height = Math.min(image.height, options2.maxTextureSize);
      const ctx2 = canvas2.getContext("2d");
      if (flipY === true) {
        ctx2.translate(0, canvas2.height);
        ctx2.scale(1, -1);
      }
      if (typeof HTMLImageElement !== "undefined" && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== "undefined" && image instanceof HTMLCanvasElement || typeof OffscreenCanvas !== "undefined" && image instanceof OffscreenCanvas || typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
        ctx2.drawImage(image, 0, 0, canvas2.width, canvas2.height);
      } else {
        if (format !== RGBAFormat) {
          console.error("GLTFExporter: Only RGBAFormat is supported.");
        }
        if (image.width > options2.maxTextureSize || image.height > options2.maxTextureSize) {
          console.warn("GLTFExporter: Image size is bigger than maxTextureSize", image);
        }
        const data2 = new Uint8ClampedArray(image.height * image.width * 4);
        for (let i2 = 0; i2 < data2.length; i2 += 4) {
          data2[i2 + 0] = image.data[i2 + 0];
          data2[i2 + 1] = image.data[i2 + 1];
          data2[i2 + 2] = image.data[i2 + 2];
          data2[i2 + 3] = image.data[i2 + 3];
        }
        ctx2.putImageData(new ImageData(data2, image.width, image.height), 0, 0);
      }
      if (options2.binary === true) {
        pending.push(new Promise(function(resolve2) {
          canvas2.toBlob(function(blob) {
            writer.processBufferViewImage(blob).then(function(bufferViewIndex) {
              imageDef.bufferView = bufferViewIndex;
              resolve2();
            });
          }, mimeType);
        }));
      } else {
        imageDef.uri = canvas2.toDataURL(mimeType);
      }
    } else {
      imageDef.uri = image.src;
    }
    const index2 = json.images.push(imageDef) - 1;
    cachedImages[key] = index2;
    return index2;
  }
  /**
   * Process sampler
   * @param  {Texture} map Texture to process
   * @return {Integer}     Index of the processed texture in the "samplers" array
   */
  processSampler(map5) {
    const json = this.json;
    if (!json.samplers)
      json.samplers = [];
    const samplerDef = {
      magFilter: THREE_TO_WEBGL[map5.magFilter],
      minFilter: THREE_TO_WEBGL[map5.minFilter],
      wrapS: THREE_TO_WEBGL[map5.wrapS],
      wrapT: THREE_TO_WEBGL[map5.wrapT]
    };
    return json.samplers.push(samplerDef) - 1;
  }
  /**
   * Process texture
   * @param  {Texture} map Map to process
   * @return {Integer} Index of the processed texture in the "textures" array
   */
  processTexture(map5) {
    const cache2 = this.cache;
    const json = this.json;
    if (cache2.textures.has(map5))
      return cache2.textures.get(map5);
    if (!json.textures)
      json.textures = [];
    let mimeType = map5.userData.mimeType;
    if (mimeType === "image/webp")
      mimeType = "image/png";
    const textureDef = {
      sampler: this.processSampler(map5),
      source: this.processImage(map5.image, map5.format, map5.flipY, mimeType)
    };
    if (map5.name)
      textureDef.name = map5.name;
    this._invokeAll(function(ext) {
      ext.writeTexture && ext.writeTexture(map5, textureDef);
    });
    const index2 = json.textures.push(textureDef) - 1;
    cache2.textures.set(map5, index2);
    return index2;
  }
  /**
   * Process material
   * @param  {THREE.Material} material Material to process
   * @return {Integer|null} Index of the processed material in the "materials" array
   */
  processMaterial(material) {
    const cache2 = this.cache;
    const json = this.json;
    if (cache2.materials.has(material))
      return cache2.materials.get(material);
    if (material.isShaderMaterial) {
      console.warn("GLTFExporter: THREE.ShaderMaterial not supported.");
      return null;
    }
    if (!json.materials)
      json.materials = [];
    const materialDef = { pbrMetallicRoughness: {} };
    if (material.isMeshStandardMaterial !== true && material.isMeshBasicMaterial !== true) {
      console.warn("GLTFExporter: Use MeshStandardMaterial or MeshBasicMaterial for best results.");
    }
    const color = material.color.toArray().concat([material.opacity]);
    if (!equalArray(color, [1, 1, 1, 1])) {
      materialDef.pbrMetallicRoughness.baseColorFactor = color;
    }
    if (material.isMeshStandardMaterial) {
      materialDef.pbrMetallicRoughness.metallicFactor = material.metalness;
      materialDef.pbrMetallicRoughness.roughnessFactor = material.roughness;
    } else {
      materialDef.pbrMetallicRoughness.metallicFactor = 0.5;
      materialDef.pbrMetallicRoughness.roughnessFactor = 0.5;
    }
    if (material.metalnessMap || material.roughnessMap) {
      const metalRoughTexture = this.buildMetalRoughTexture(material.metalnessMap, material.roughnessMap);
      const metalRoughMapDef = { index: this.processTexture(metalRoughTexture) };
      this.applyTextureTransform(metalRoughMapDef, metalRoughTexture);
      materialDef.pbrMetallicRoughness.metallicRoughnessTexture = metalRoughMapDef;
    }
    if (material.map) {
      const baseColorMapDef = { index: this.processTexture(material.map) };
      this.applyTextureTransform(baseColorMapDef, material.map);
      materialDef.pbrMetallicRoughness.baseColorTexture = baseColorMapDef;
    }
    if (material.emissive) {
      const emissive = material.emissive.clone().multiplyScalar(material.emissiveIntensity);
      const maxEmissiveComponent = Math.max(emissive.r, emissive.g, emissive.b);
      if (maxEmissiveComponent > 1) {
        emissive.multiplyScalar(1 / maxEmissiveComponent);
        console.warn("THREE.GLTFExporter: Some emissive components exceed 1; emissive has been limited");
      }
      if (maxEmissiveComponent > 0) {
        materialDef.emissiveFactor = emissive.toArray();
      }
      if (material.emissiveMap) {
        const emissiveMapDef = { index: this.processTexture(material.emissiveMap) };
        this.applyTextureTransform(emissiveMapDef, material.emissiveMap);
        materialDef.emissiveTexture = emissiveMapDef;
      }
    }
    if (material.normalMap) {
      const normalMapDef = { index: this.processTexture(material.normalMap) };
      if (material.normalScale && material.normalScale.x !== 1) {
        normalMapDef.scale = material.normalScale.x;
      }
      this.applyTextureTransform(normalMapDef, material.normalMap);
      materialDef.normalTexture = normalMapDef;
    }
    if (material.aoMap) {
      const occlusionMapDef = {
        index: this.processTexture(material.aoMap),
        texCoord: 1
      };
      if (material.aoMapIntensity !== 1) {
        occlusionMapDef.strength = material.aoMapIntensity;
      }
      this.applyTextureTransform(occlusionMapDef, material.aoMap);
      materialDef.occlusionTexture = occlusionMapDef;
    }
    if (material.transparent) {
      materialDef.alphaMode = "BLEND";
    } else {
      if (material.alphaTest > 0) {
        materialDef.alphaMode = "MASK";
        materialDef.alphaCutoff = material.alphaTest;
      }
    }
    if (material.side === DoubleSide)
      materialDef.doubleSided = true;
    if (material.name !== "")
      materialDef.name = material.name;
    this.serializeUserData(material, materialDef);
    this._invokeAll(function(ext) {
      ext.writeMaterial && ext.writeMaterial(material, materialDef);
    });
    const index2 = json.materials.push(materialDef) - 1;
    cache2.materials.set(material, index2);
    return index2;
  }
  /**
   * Process mesh
   * @param  {THREE.Mesh} mesh Mesh to process
   * @return {Integer|null} Index of the processed mesh in the "meshes" array
   */
  processMesh(mesh) {
    const cache2 = this.cache;
    const json = this.json;
    const meshCacheKeyParts = [mesh.geometry.uuid];
    if (Array.isArray(mesh.material)) {
      for (let i2 = 0, l2 = mesh.material.length; i2 < l2; i2++) {
        meshCacheKeyParts.push(mesh.material[i2].uuid);
      }
    } else {
      meshCacheKeyParts.push(mesh.material.uuid);
    }
    const meshCacheKey = meshCacheKeyParts.join(":");
    if (cache2.meshes.has(meshCacheKey))
      return cache2.meshes.get(meshCacheKey);
    const geometry2 = mesh.geometry;
    let mode2;
    if (mesh.isLineSegments) {
      mode2 = WEBGL_CONSTANTS$1.LINES;
    } else if (mesh.isLineLoop) {
      mode2 = WEBGL_CONSTANTS$1.LINE_LOOP;
    } else if (mesh.isLine) {
      mode2 = WEBGL_CONSTANTS$1.LINE_STRIP;
    } else if (mesh.isPoints) {
      mode2 = WEBGL_CONSTANTS$1.POINTS;
    } else {
      mode2 = mesh.material.wireframe ? WEBGL_CONSTANTS$1.LINES : WEBGL_CONSTANTS$1.TRIANGLES;
    }
    if (geometry2.isBufferGeometry !== true) {
      throw new Error("THREE.GLTFExporter: Geometry is not of type THREE.BufferGeometry.");
    }
    const meshDef = {};
    const attributes = {};
    const primitives = [];
    const targets = [];
    const nameConversion = {
      uv: "TEXCOORD_0",
      uv2: "TEXCOORD_1",
      color: "COLOR_0",
      skinWeight: "WEIGHTS_0",
      skinIndex: "JOINTS_0"
    };
    const originalNormal = geometry2.getAttribute("normal");
    if (originalNormal !== void 0 && !this.isNormalizedNormalAttribute(originalNormal)) {
      console.warn("THREE.GLTFExporter: Creating normalized normal attribute from the non-normalized one.");
      geometry2.setAttribute("normal", this.createNormalizedNormalAttribute(originalNormal));
    }
    let modifiedAttribute = null;
    for (let attributeName in geometry2.attributes) {
      if (attributeName.slice(0, 5) === "morph")
        continue;
      const attribute = geometry2.attributes[attributeName];
      attributeName = nameConversion[attributeName] || attributeName.toUpperCase();
      const validVertexAttributes = /^(POSITION|NORMAL|TANGENT|TEXCOORD_\d+|COLOR_\d+|JOINTS_\d+|WEIGHTS_\d+)$/;
      if (!validVertexAttributes.test(attributeName))
        attributeName = "_" + attributeName;
      if (cache2.attributes.has(this.getUID(attribute))) {
        attributes[attributeName] = cache2.attributes.get(this.getUID(attribute));
        continue;
      }
      modifiedAttribute = null;
      const array2 = attribute.array;
      if (attributeName === "JOINTS_0" && !(array2 instanceof Uint16Array) && !(array2 instanceof Uint8Array)) {
        console.warn('GLTFExporter: Attribute "skinIndex" converted to type UNSIGNED_SHORT.');
        modifiedAttribute = new BufferAttribute(new Uint16Array(array2), attribute.itemSize, attribute.normalized);
      }
      const accessor = this.processAccessor(modifiedAttribute || attribute, geometry2);
      if (accessor !== null) {
        attributes[attributeName] = accessor;
        cache2.attributes.set(this.getUID(attribute), accessor);
      }
    }
    if (originalNormal !== void 0)
      geometry2.setAttribute("normal", originalNormal);
    if (Object.keys(attributes).length === 0)
      return null;
    if (mesh.morphTargetInfluences !== void 0 && mesh.morphTargetInfluences.length > 0) {
      const weights = [];
      const targetNames = [];
      const reverseDictionary = {};
      if (mesh.morphTargetDictionary !== void 0) {
        for (const key in mesh.morphTargetDictionary) {
          reverseDictionary[mesh.morphTargetDictionary[key]] = key;
        }
      }
      for (let i2 = 0; i2 < mesh.morphTargetInfluences.length; ++i2) {
        const target = {};
        let warned = false;
        for (const attributeName in geometry2.morphAttributes) {
          if (attributeName !== "position" && attributeName !== "normal") {
            if (!warned) {
              console.warn("GLTFExporter: Only POSITION and NORMAL morph are supported.");
              warned = true;
            }
            continue;
          }
          const attribute = geometry2.morphAttributes[attributeName][i2];
          const gltfAttributeName = attributeName.toUpperCase();
          const baseAttribute = geometry2.attributes[attributeName];
          if (cache2.attributes.has(this.getUID(attribute))) {
            target[gltfAttributeName] = cache2.attributes.get(this.getUID(attribute));
            continue;
          }
          const relativeAttribute = attribute.clone();
          if (!geometry2.morphTargetsRelative) {
            for (let j2 = 0, jl = attribute.count; j2 < jl; j2++) {
              relativeAttribute.setXYZ(
                j2,
                attribute.getX(j2) - baseAttribute.getX(j2),
                attribute.getY(j2) - baseAttribute.getY(j2),
                attribute.getZ(j2) - baseAttribute.getZ(j2)
              );
            }
          }
          target[gltfAttributeName] = this.processAccessor(relativeAttribute, geometry2);
          cache2.attributes.set(this.getUID(baseAttribute), target[gltfAttributeName]);
        }
        targets.push(target);
        weights.push(mesh.morphTargetInfluences[i2]);
        if (mesh.morphTargetDictionary !== void 0)
          targetNames.push(reverseDictionary[i2]);
      }
      meshDef.weights = weights;
      if (targetNames.length > 0) {
        meshDef.extras = {};
        meshDef.extras.targetNames = targetNames;
      }
    }
    const isMultiMaterial = Array.isArray(mesh.material);
    if (isMultiMaterial && geometry2.groups.length === 0)
      return null;
    const materials = isMultiMaterial ? mesh.material : [mesh.material];
    const groups = isMultiMaterial ? geometry2.groups : [{ materialIndex: 0, start: void 0, count: void 0 }];
    for (let i2 = 0, il = groups.length; i2 < il; i2++) {
      const primitive = {
        mode: mode2,
        attributes
      };
      this.serializeUserData(geometry2, primitive);
      if (targets.length > 0)
        primitive.targets = targets;
      if (geometry2.index !== null) {
        let cacheKey = this.getUID(geometry2.index);
        if (groups[i2].start !== void 0 || groups[i2].count !== void 0) {
          cacheKey += ":" + groups[i2].start + ":" + groups[i2].count;
        }
        if (cache2.attributes.has(cacheKey)) {
          primitive.indices = cache2.attributes.get(cacheKey);
        } else {
          primitive.indices = this.processAccessor(geometry2.index, geometry2, groups[i2].start, groups[i2].count);
          cache2.attributes.set(cacheKey, primitive.indices);
        }
        if (primitive.indices === null)
          delete primitive.indices;
      }
      const material = this.processMaterial(materials[groups[i2].materialIndex]);
      if (material !== null)
        primitive.material = material;
      primitives.push(primitive);
    }
    meshDef.primitives = primitives;
    if (!json.meshes)
      json.meshes = [];
    this._invokeAll(function(ext) {
      ext.writeMesh && ext.writeMesh(mesh, meshDef);
    });
    const index2 = json.meshes.push(meshDef) - 1;
    cache2.meshes.set(meshCacheKey, index2);
    return index2;
  }
  /**
   * Process camera
   * @param  {THREE.Camera} camera Camera to process
   * @return {Integer}      Index of the processed mesh in the "camera" array
   */
  processCamera(camera) {
    const json = this.json;
    if (!json.cameras)
      json.cameras = [];
    const isOrtho = camera.isOrthographicCamera;
    const cameraDef = {
      type: isOrtho ? "orthographic" : "perspective"
    };
    if (isOrtho) {
      cameraDef.orthographic = {
        xmag: camera.right * 2,
        ymag: camera.top * 2,
        zfar: camera.far <= 0 ? 1e-3 : camera.far,
        znear: camera.near < 0 ? 0 : camera.near
      };
    } else {
      cameraDef.perspective = {
        aspectRatio: camera.aspect,
        yfov: MathUtils.degToRad(camera.fov),
        zfar: camera.far <= 0 ? 1e-3 : camera.far,
        znear: camera.near < 0 ? 0 : camera.near
      };
    }
    if (camera.name !== "")
      cameraDef.name = camera.type;
    return json.cameras.push(cameraDef) - 1;
  }
  /**
   * Creates glTF animation entry from AnimationClip object.
   *
   * Status:
   * - Only properties listed in PATH_PROPERTIES may be animated.
   *
   * @param {THREE.AnimationClip} clip
   * @param {THREE.Object3D} root
   * @return {number|null}
   */
  processAnimation(clip2, root2) {
    const json = this.json;
    const nodeMap = this.nodeMap;
    if (!json.animations)
      json.animations = [];
    clip2 = GLTFExporter.Utils.mergeMorphTargetTracks(clip2.clone(), root2);
    const tracks = clip2.tracks;
    const channels = [];
    const samplers = [];
    for (let i2 = 0; i2 < tracks.length; ++i2) {
      const track = tracks[i2];
      const trackBinding = PropertyBinding.parseTrackName(track.name);
      let trackNode = PropertyBinding.findNode(root2, trackBinding.nodeName);
      const trackProperty = PATH_PROPERTIES$1[trackBinding.propertyName];
      if (trackBinding.objectName === "bones") {
        if (trackNode.isSkinnedMesh === true) {
          trackNode = trackNode.skeleton.getBoneByName(trackBinding.objectIndex);
        } else {
          trackNode = void 0;
        }
      }
      if (!trackNode || !trackProperty) {
        console.warn('THREE.GLTFExporter: Could not export animation track "%s".', track.name);
        return null;
      }
      const inputItemSize = 1;
      let outputItemSize = track.values.length / track.times.length;
      if (trackProperty === PATH_PROPERTIES$1.morphTargetInfluences) {
        outputItemSize /= trackNode.morphTargetInfluences.length;
      }
      let interpolation;
      if (track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline === true) {
        interpolation = "CUBICSPLINE";
        outputItemSize /= 3;
      } else if (track.getInterpolation() === InterpolateDiscrete) {
        interpolation = "STEP";
      } else {
        interpolation = "LINEAR";
      }
      samplers.push({
        input: this.processAccessor(new BufferAttribute(track.times, inputItemSize)),
        output: this.processAccessor(new BufferAttribute(track.values, outputItemSize)),
        interpolation
      });
      channels.push({
        sampler: samplers.length - 1,
        target: {
          node: nodeMap.get(trackNode),
          path: trackProperty
        }
      });
    }
    json.animations.push({
      name: clip2.name || "clip_" + json.animations.length,
      samplers,
      channels
    });
    return json.animations.length - 1;
  }
  /**
   * @param {THREE.Object3D} object
   * @return {number|null}
   */
  processSkin(object2) {
    const json = this.json;
    const nodeMap = this.nodeMap;
    const node = json.nodes[nodeMap.get(object2)];
    const skeleton = object2.skeleton;
    if (skeleton === void 0)
      return null;
    const rootJoint = object2.skeleton.bones[0];
    if (rootJoint === void 0)
      return null;
    const joints = [];
    const inverseBindMatrices = new Float32Array(skeleton.bones.length * 16);
    const temporaryBoneInverse = new Matrix4$1();
    for (let i2 = 0; i2 < skeleton.bones.length; ++i2) {
      joints.push(nodeMap.get(skeleton.bones[i2]));
      temporaryBoneInverse.copy(skeleton.boneInverses[i2]);
      temporaryBoneInverse.multiply(object2.bindMatrix).toArray(inverseBindMatrices, i2 * 16);
    }
    if (json.skins === void 0)
      json.skins = [];
    json.skins.push({
      inverseBindMatrices: this.processAccessor(new BufferAttribute(inverseBindMatrices, 16)),
      joints,
      skeleton: nodeMap.get(rootJoint)
    });
    const skinIndex = node.skin = json.skins.length - 1;
    return skinIndex;
  }
  /**
   * Process Object3D node
   * @param  {THREE.Object3D} node Object3D to processNode
   * @return {Integer} Index of the node in the nodes list
   */
  processNode(object2) {
    const json = this.json;
    const options2 = this.options;
    const nodeMap = this.nodeMap;
    if (!json.nodes)
      json.nodes = [];
    const nodeDef = {};
    if (options2.trs) {
      const rotation = object2.quaternion.toArray();
      const position = object2.position.toArray();
      const scale5 = object2.scale.toArray();
      if (!equalArray(rotation, [0, 0, 0, 1])) {
        nodeDef.rotation = rotation;
      }
      if (!equalArray(position, [0, 0, 0])) {
        nodeDef.translation = position;
      }
      if (!equalArray(scale5, [1, 1, 1])) {
        nodeDef.scale = scale5;
      }
    } else {
      if (object2.matrixAutoUpdate) {
        object2.updateMatrix();
      }
      if (isIdentityMatrix(object2.matrix) === false) {
        nodeDef.matrix = object2.matrix.elements;
      }
    }
    if (object2.name !== "")
      nodeDef.name = String(object2.name);
    this.serializeUserData(object2, nodeDef);
    if (object2.isMesh || object2.isLine || object2.isPoints) {
      const meshIndex = this.processMesh(object2);
      if (meshIndex !== null)
        nodeDef.mesh = meshIndex;
    } else if (object2.isCamera) {
      nodeDef.camera = this.processCamera(object2);
    }
    if (object2.isSkinnedMesh)
      this.skins.push(object2);
    if (object2.children.length > 0) {
      const children = [];
      for (let i2 = 0, l2 = object2.children.length; i2 < l2; i2++) {
        const child = object2.children[i2];
        if (child.visible || options2.onlyVisible === false) {
          const nodeIndex2 = this.processNode(child);
          if (nodeIndex2 !== null)
            children.push(nodeIndex2);
        }
      }
      if (children.length > 0)
        nodeDef.children = children;
    }
    this._invokeAll(function(ext) {
      ext.writeNode && ext.writeNode(object2, nodeDef);
    });
    const nodeIndex = json.nodes.push(nodeDef) - 1;
    nodeMap.set(object2, nodeIndex);
    return nodeIndex;
  }
  /**
   * Process Scene
   * @param  {Scene} node Scene to process
   */
  processScene(scene) {
    const json = this.json;
    const options2 = this.options;
    if (!json.scenes) {
      json.scenes = [];
      json.scene = 0;
    }
    const sceneDef = {};
    if (scene.name !== "")
      sceneDef.name = scene.name;
    json.scenes.push(sceneDef);
    const nodes = [];
    for (let i2 = 0, l2 = scene.children.length; i2 < l2; i2++) {
      const child = scene.children[i2];
      if (child.visible || options2.onlyVisible === false) {
        const nodeIndex = this.processNode(child);
        if (nodeIndex !== null)
          nodes.push(nodeIndex);
      }
    }
    if (nodes.length > 0)
      sceneDef.nodes = nodes;
    this.serializeUserData(scene, sceneDef);
  }
  /**
   * Creates a Scene to hold a list of objects and parse it
   * @param  {Array} objects List of objects to process
   */
  processObjects(objects) {
    const scene = new Scene();
    scene.name = "AuxScene";
    for (let i2 = 0; i2 < objects.length; i2++) {
      scene.children.push(objects[i2]);
    }
    this.processScene(scene);
  }
  /**
   * @param {THREE.Object3D|Array<THREE.Object3D>} input
   */
  processInput(input) {
    const options2 = this.options;
    input = input instanceof Array ? input : [input];
    this._invokeAll(function(ext) {
      ext.beforeParse && ext.beforeParse(input);
    });
    const objectsWithoutScene = [];
    for (let i2 = 0; i2 < input.length; i2++) {
      if (input[i2] instanceof Scene) {
        this.processScene(input[i2]);
      } else {
        objectsWithoutScene.push(input[i2]);
      }
    }
    if (objectsWithoutScene.length > 0)
      this.processObjects(objectsWithoutScene);
    for (let i2 = 0; i2 < this.skins.length; ++i2) {
      this.processSkin(this.skins[i2]);
    }
    for (let i2 = 0; i2 < options2.animations.length; ++i2) {
      this.processAnimation(options2.animations[i2], input[0]);
    }
    this._invokeAll(function(ext) {
      ext.afterParse && ext.afterParse(input);
    });
  }
  _invokeAll(func2) {
    for (let i2 = 0, il = this.plugins.length; i2 < il; i2++) {
      func2(this.plugins[i2]);
    }
  }
}
class GLTFLightExtension {
  constructor(writer) {
    this.writer = writer;
    this.name = "KHR_lights_punctual";
  }
  writeNode(light, nodeDef) {
    if (!light.isLight)
      return;
    if (!light.isDirectionalLight && !light.isPointLight && !light.isSpotLight) {
      console.warn("THREE.GLTFExporter: Only directional, point, and spot lights are supported.", light);
      return;
    }
    const writer = this.writer;
    const json = writer.json;
    const extensionsUsed = writer.extensionsUsed;
    const lightDef = {};
    if (light.name)
      lightDef.name = light.name;
    lightDef.color = light.color.toArray();
    lightDef.intensity = light.intensity;
    if (light.isDirectionalLight) {
      lightDef.type = "directional";
    } else if (light.isPointLight) {
      lightDef.type = "point";
      if (light.distance > 0)
        lightDef.range = light.distance;
    } else if (light.isSpotLight) {
      lightDef.type = "spot";
      if (light.distance > 0)
        lightDef.range = light.distance;
      lightDef.spot = {};
      lightDef.spot.innerConeAngle = (light.penumbra - 1) * light.angle * -1;
      lightDef.spot.outerConeAngle = light.angle;
    }
    if (light.decay !== void 0 && light.decay !== 2) {
      console.warn("THREE.GLTFExporter: Light decay may be lost. glTF is physically-based, and expects light.decay=2.");
    }
    if (light.target && (light.target.parent !== light || light.target.position.x !== 0 || light.target.position.y !== 0 || light.target.position.z !== -1)) {
      console.warn("THREE.GLTFExporter: Light direction may be lost. For best results, make light.target a child of the light with position 0,0,-1.");
    }
    if (!extensionsUsed[this.name]) {
      json.extensions = json.extensions || {};
      json.extensions[this.name] = { lights: [] };
      extensionsUsed[this.name] = true;
    }
    const lights2 = json.extensions[this.name].lights;
    lights2.push(lightDef);
    nodeDef.extensions = nodeDef.extensions || {};
    nodeDef.extensions[this.name] = { light: lights2.length - 1 };
  }
}
let GLTFMaterialsUnlitExtension$1 = class GLTFMaterialsUnlitExtension2 {
  constructor(writer) {
    this.writer = writer;
    this.name = "KHR_materials_unlit";
  }
  writeMaterial(material, materialDef) {
    if (!material.isMeshBasicMaterial)
      return;
    const writer = this.writer;
    const extensionsUsed = writer.extensionsUsed;
    materialDef.extensions = materialDef.extensions || {};
    materialDef.extensions[this.name] = {};
    extensionsUsed[this.name] = true;
    materialDef.pbrMetallicRoughness.metallicFactor = 0;
    materialDef.pbrMetallicRoughness.roughnessFactor = 0.9;
  }
};
class GLTFMaterialsPBRSpecularGlossiness {
  constructor(writer) {
    this.writer = writer;
    this.name = "KHR_materials_pbrSpecularGlossiness";
  }
  writeMaterial(material, materialDef) {
    if (!material.isGLTFSpecularGlossinessMaterial)
      return;
    const writer = this.writer;
    const extensionsUsed = writer.extensionsUsed;
    const extensionDef = {};
    if (materialDef.pbrMetallicRoughness.baseColorFactor) {
      extensionDef.diffuseFactor = materialDef.pbrMetallicRoughness.baseColorFactor;
    }
    const specularFactor = [1, 1, 1];
    material.specular.toArray(specularFactor, 0);
    extensionDef.specularFactor = specularFactor;
    extensionDef.glossinessFactor = material.glossiness;
    if (materialDef.pbrMetallicRoughness.baseColorTexture) {
      extensionDef.diffuseTexture = materialDef.pbrMetallicRoughness.baseColorTexture;
    }
    if (material.specularMap) {
      const specularMapDef = { index: writer.processTexture(material.specularMap) };
      writer.applyTextureTransform(specularMapDef, material.specularMap);
      extensionDef.specularGlossinessTexture = specularMapDef;
    }
    materialDef.extensions = materialDef.extensions || {};
    materialDef.extensions[this.name] = extensionDef;
    extensionsUsed[this.name] = true;
  }
}
let GLTFMaterialsClearcoatExtension$1 = class GLTFMaterialsClearcoatExtension2 {
  constructor(writer) {
    this.writer = writer;
    this.name = "KHR_materials_clearcoat";
  }
  writeMaterial(material, materialDef) {
    if (!material.isMeshPhysicalMaterial)
      return;
    const writer = this.writer;
    const extensionsUsed = writer.extensionsUsed;
    const extensionDef = {};
    extensionDef.clearcoatFactor = material.clearcoat;
    if (material.clearcoatMap) {
      const clearcoatMapDef = { index: writer.processTexture(material.clearcoatMap) };
      writer.applyTextureTransform(clearcoatMapDef, material.clearcoatMap);
      extensionDef.clearcoatTexture = clearcoatMapDef;
    }
    extensionDef.clearcoatRoughnessFactor = material.clearcoatRoughness;
    if (material.clearcoatRoughnessMap) {
      const clearcoatRoughnessMapDef = { index: writer.processTexture(material.clearcoatRoughnessMap) };
      writer.applyTextureTransform(clearcoatRoughnessMapDef, material.clearcoatRoughnessMap);
      extensionDef.clearcoatRoughnessTexture = clearcoatRoughnessMapDef;
    }
    if (material.clearcoatNormalMap) {
      const clearcoatNormalMapDef = { index: writer.processTexture(material.clearcoatNormalMap) };
      writer.applyTextureTransform(clearcoatNormalMapDef, material.clearcoatNormalMap);
      extensionDef.clearcoatNormalTexture = clearcoatNormalMapDef;
    }
    materialDef.extensions = materialDef.extensions || {};
    materialDef.extensions[this.name] = extensionDef;
    extensionsUsed[this.name] = true;
  }
};
let GLTFMaterialsTransmissionExtension$1 = class GLTFMaterialsTransmissionExtension2 {
  constructor(writer) {
    this.writer = writer;
    this.name = "KHR_materials_transmission";
  }
  writeMaterial(material, materialDef) {
    if (!material.isMeshPhysicalMaterial || material.transmission === 0)
      return;
    const writer = this.writer;
    const extensionsUsed = writer.extensionsUsed;
    const extensionDef = {};
    extensionDef.transmissionFactor = material.transmission;
    if (material.transmissionMap) {
      const transmissionMapDef = { index: writer.processTexture(material.transmissionMap) };
      writer.applyTextureTransform(transmissionMapDef, material.transmissionMap);
      extensionDef.transmissionTexture = transmissionMapDef;
    }
    materialDef.extensions = materialDef.extensions || {};
    materialDef.extensions[this.name] = extensionDef;
    extensionsUsed[this.name] = true;
  }
};
let GLTFMaterialsVolumeExtension$1 = class GLTFMaterialsVolumeExtension2 {
  constructor(writer) {
    this.writer = writer;
    this.name = "KHR_materials_volume";
  }
  writeMaterial(material, materialDef) {
    if (!material.isMeshPhysicalMaterial || material.transmission === 0)
      return;
    const writer = this.writer;
    const extensionsUsed = writer.extensionsUsed;
    const extensionDef = {};
    extensionDef.thicknessFactor = material.thickness;
    if (material.thicknessMap) {
      const thicknessMapDef = { index: writer.processTexture(material.thicknessMap) };
      writer.applyTextureTransform(thicknessMapDef, material.thicknessMap);
      extensionDef.thicknessTexture = thicknessMapDef;
    }
    extensionDef.attenuationDistance = material.attenuationDistance;
    extensionDef.attenuationColor = material.attenuationColor.toArray();
    materialDef.extensions = materialDef.extensions || {};
    materialDef.extensions[this.name] = extensionDef;
    extensionsUsed[this.name] = true;
  }
};
GLTFExporter.Utils = {
  insertKeyframe: function(track, time2) {
    const tolerance = 1e-3;
    const valueSize = track.getValueSize();
    const times = new track.TimeBufferType(track.times.length + 1);
    const values4 = new track.ValueBufferType(track.values.length + valueSize);
    const interpolant = track.createInterpolant(new track.ValueBufferType(valueSize));
    let index2;
    if (track.times.length === 0) {
      times[0] = time2;
      for (let i2 = 0; i2 < valueSize; i2++) {
        values4[i2] = 0;
      }
      index2 = 0;
    } else if (time2 < track.times[0]) {
      if (Math.abs(track.times[0] - time2) < tolerance)
        return 0;
      times[0] = time2;
      times.set(track.times, 1);
      values4.set(interpolant.evaluate(time2), 0);
      values4.set(track.values, valueSize);
      index2 = 0;
    } else if (time2 > track.times[track.times.length - 1]) {
      if (Math.abs(track.times[track.times.length - 1] - time2) < tolerance) {
        return track.times.length - 1;
      }
      times[times.length - 1] = time2;
      times.set(track.times, 0);
      values4.set(track.values, 0);
      values4.set(interpolant.evaluate(time2), track.values.length);
      index2 = times.length - 1;
    } else {
      for (let i2 = 0; i2 < track.times.length; i2++) {
        if (Math.abs(track.times[i2] - time2) < tolerance)
          return i2;
        if (track.times[i2] < time2 && track.times[i2 + 1] > time2) {
          times.set(track.times.slice(0, i2 + 1), 0);
          times[i2 + 1] = time2;
          times.set(track.times.slice(i2 + 1), i2 + 2);
          values4.set(track.values.slice(0, (i2 + 1) * valueSize), 0);
          values4.set(interpolant.evaluate(time2), (i2 + 1) * valueSize);
          values4.set(track.values.slice((i2 + 1) * valueSize), (i2 + 2) * valueSize);
          index2 = i2 + 1;
          break;
        }
      }
    }
    track.times = times;
    track.values = values4;
    return index2;
  },
  mergeMorphTargetTracks: function(clip2, root2) {
    const tracks = [];
    const mergedTracks = {};
    const sourceTracks = clip2.tracks;
    for (let i2 = 0; i2 < sourceTracks.length; ++i2) {
      let sourceTrack = sourceTracks[i2];
      const sourceTrackBinding = PropertyBinding.parseTrackName(sourceTrack.name);
      const sourceTrackNode = PropertyBinding.findNode(root2, sourceTrackBinding.nodeName);
      if (sourceTrackBinding.propertyName !== "morphTargetInfluences" || sourceTrackBinding.propertyIndex === void 0) {
        tracks.push(sourceTrack);
        continue;
      }
      if (sourceTrack.createInterpolant !== sourceTrack.InterpolantFactoryMethodDiscrete && sourceTrack.createInterpolant !== sourceTrack.InterpolantFactoryMethodLinear) {
        if (sourceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) {
          throw new Error("THREE.GLTFExporter: Cannot merge tracks with glTF CUBICSPLINE interpolation.");
        }
        console.warn("THREE.GLTFExporter: Morph target interpolation mode not yet supported. Using LINEAR instead.");
        sourceTrack = sourceTrack.clone();
        sourceTrack.setInterpolation(InterpolateLinear);
      }
      const targetCount = sourceTrackNode.morphTargetInfluences.length;
      const targetIndex = sourceTrackNode.morphTargetDictionary[sourceTrackBinding.propertyIndex];
      if (targetIndex === void 0) {
        throw new Error("THREE.GLTFExporter: Morph target name not found: " + sourceTrackBinding.propertyIndex);
      }
      let mergedTrack;
      if (mergedTracks[sourceTrackNode.uuid] === void 0) {
        mergedTrack = sourceTrack.clone();
        const values4 = new mergedTrack.ValueBufferType(targetCount * mergedTrack.times.length);
        for (let j2 = 0; j2 < mergedTrack.times.length; j2++) {
          values4[j2 * targetCount + targetIndex] = mergedTrack.values[j2];
        }
        mergedTrack.name = (sourceTrackBinding.nodeName || "") + ".morphTargetInfluences";
        mergedTrack.values = values4;
        mergedTracks[sourceTrackNode.uuid] = mergedTrack;
        tracks.push(mergedTrack);
        continue;
      }
      const sourceInterpolant = sourceTrack.createInterpolant(new sourceTrack.ValueBufferType(1));
      mergedTrack = mergedTracks[sourceTrackNode.uuid];
      for (let j2 = 0; j2 < mergedTrack.times.length; j2++) {
        mergedTrack.values[j2 * targetCount + targetIndex] = sourceInterpolant.evaluate(mergedTrack.times[j2]);
      }
      for (let j2 = 0; j2 < sourceTrack.times.length; j2++) {
        const keyframeIndex = this.insertKeyframe(mergedTrack, sourceTrack.times[j2]);
        mergedTrack.values[keyframeIndex * targetCount + targetIndex] = sourceTrack.values[j2];
      }
    }
    clip2.tracks = tracks;
    return clip2;
  }
};
class GltfUtil {
  static async exportToGlb(object2, options2) {
    if (!object2)
      return null;
    const {
      assetName,
      flipY2Z,
      isBinary
    } = options2 || {};
    object2.updateMatrix();
    object2.updateWorldMatrix(true, true);
    const clonedObject = object2.clone();
    clonedObject.parent = null;
    clonedObject.matrixWorld = new Matrix4$1();
    clonedObject.updateMatrix();
    clonedObject.updateWorldMatrix(true, true);
    const bbox2 = new Box3().setFromObject(clonedObject);
    const center2 = new Vector3$1();
    bbox2.getCenter(center2);
    clonedObject.applyMatrix4(new Matrix4$1().makeTranslation(-center2.x, flipY2Z ? -center2.y : 0, flipY2Z ? 0 : -center2.z));
    if (flipY2Z) {
      clonedObject.applyMatrix4(new Matrix4$1().makeRotationAxis(new Vector3$1(1, 0, 0), -Math.PI / 2));
    }
    clonedObject.updateMatrix();
    clonedObject.updateWorldMatrix(true, true);
    const exporter = new GLTFExporter();
    const config2 = {
      onlyVisible: true,
      binary: isBinary
    };
    const result = await new Promise((resolve2) => {
      exporter.parse([clonedObject], (model) => {
        const blob = new Blob([model], {
          type: "application/octet-stream"
        });
        const extension = isBinary ? "glb" : "gltf";
        resolve2({
          filename: `${assetName}.${extension}`,
          data: blob,
          dataType: "buffer",
          extension
        });
      }, config2);
    });
    return result;
  }
}
var pdfExports = {};
var pdf$1 = {
  get exports() {
    return pdfExports;
  },
  set exports(v5) {
    pdfExports = v5;
  }
};
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module.exports = root2.pdfjsLib = factory();
  })(globalThis, () => {
    return (
      /******/
      (() => {
        var __webpack_modules__ = [
          ,
          /* 1 */
          /***/
          (__unused_webpack_module2, exports2) => {
            var _settled;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.VerbosityLevel = exports2.Util = exports2.UnknownErrorException = exports2.UnexpectedResponseException = exports2.TextRenderingMode = exports2.RenderingIntentFlag = exports2.PromiseCapability = exports2.PermissionFlag = exports2.PasswordResponses = exports2.PasswordException = exports2.PageActionEventType = exports2.OPS = exports2.MissingPDFException = exports2.MAX_IMAGE_SIZE_TO_CACHE = exports2.LINE_FACTOR = exports2.LINE_DESCENT_FACTOR = exports2.InvalidPDFException = exports2.ImageKind = exports2.IDENTITY_MATRIX = exports2.FormatError = exports2.FeatureTest = exports2.FONT_IDENTITY_MATRIX = exports2.DocumentActionEventType = exports2.CMapCompressionType = exports2.BaseException = exports2.BASELINE_FACTOR = exports2.AnnotationType = exports2.AnnotationReplyType = exports2.AnnotationPrefix = exports2.AnnotationMode = exports2.AnnotationFlag = exports2.AnnotationFieldFlag = exports2.AnnotationEditorType = exports2.AnnotationEditorPrefix = exports2.AnnotationEditorParamsType = exports2.AnnotationBorderStyleType = exports2.AnnotationActionEventType = exports2.AbortException = void 0;
            exports2.assert = assert2;
            exports2.bytesToString = bytesToString;
            exports2.createValidAbsoluteUrl = createValidAbsoluteUrl;
            exports2.getModificationDate = getModificationDate;
            exports2.getUuid = getUuid;
            exports2.getVerbosityLevel = getVerbosityLevel;
            exports2.info = info;
            exports2.isArrayBuffer = isArrayBuffer2;
            exports2.isArrayEqual = isArrayEqual;
            exports2.isNodeJS = void 0;
            exports2.normalizeUnicode = normalizeUnicode;
            exports2.objectFromMap = objectFromMap;
            exports2.objectSize = objectSize;
            exports2.setVerbosityLevel = setVerbosityLevel;
            exports2.shadow = shadow2;
            exports2.string32 = string32;
            exports2.stringToBytes = stringToBytes2;
            exports2.stringToPDFString = stringToPDFString;
            exports2.stringToUTF8String = stringToUTF8String;
            exports2.unreachable = unreachable;
            exports2.utf8StringToString = utf8StringToString;
            exports2.warn = warn;
            const isNodeJS = typeof process === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
            exports2.isNodeJS = isNodeJS;
            const IDENTITY_MATRIX2 = [1, 0, 0, 1, 0, 0];
            exports2.IDENTITY_MATRIX = IDENTITY_MATRIX2;
            const FONT_IDENTITY_MATRIX = [1e-3, 0, 0, 1e-3, 0, 0];
            exports2.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
            const MAX_IMAGE_SIZE_TO_CACHE = 1e7;
            exports2.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
            const LINE_FACTOR = 1.35;
            exports2.LINE_FACTOR = LINE_FACTOR;
            const LINE_DESCENT_FACTOR = 0.35;
            exports2.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
            const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
            exports2.BASELINE_FACTOR = BASELINE_FACTOR;
            const RenderingIntentFlag = {
              ANY: 1,
              DISPLAY: 2,
              PRINT: 4,
              SAVE: 8,
              ANNOTATIONS_FORMS: 16,
              ANNOTATIONS_STORAGE: 32,
              ANNOTATIONS_DISABLE: 64,
              OPLIST: 256
            };
            exports2.RenderingIntentFlag = RenderingIntentFlag;
            const AnnotationMode = {
              DISABLE: 0,
              ENABLE: 1,
              ENABLE_FORMS: 2,
              ENABLE_STORAGE: 3
            };
            exports2.AnnotationMode = AnnotationMode;
            const AnnotationEditorPrefix = "pdfjs_internal_editor_";
            exports2.AnnotationEditorPrefix = AnnotationEditorPrefix;
            const AnnotationEditorType = {
              DISABLE: -1,
              NONE: 0,
              FREETEXT: 3,
              STAMP: 13,
              INK: 15
            };
            exports2.AnnotationEditorType = AnnotationEditorType;
            const AnnotationEditorParamsType = {
              RESIZE: 1,
              CREATE: 2,
              FREETEXT_SIZE: 11,
              FREETEXT_COLOR: 12,
              FREETEXT_OPACITY: 13,
              INK_COLOR: 21,
              INK_THICKNESS: 22,
              INK_OPACITY: 23
            };
            exports2.AnnotationEditorParamsType = AnnotationEditorParamsType;
            const PermissionFlag = {
              PRINT: 4,
              MODIFY_CONTENTS: 8,
              COPY: 16,
              MODIFY_ANNOTATIONS: 32,
              FILL_INTERACTIVE_FORMS: 256,
              COPY_FOR_ACCESSIBILITY: 512,
              ASSEMBLE: 1024,
              PRINT_HIGH_QUALITY: 2048
            };
            exports2.PermissionFlag = PermissionFlag;
            const TextRenderingMode = {
              FILL: 0,
              STROKE: 1,
              FILL_STROKE: 2,
              INVISIBLE: 3,
              FILL_ADD_TO_PATH: 4,
              STROKE_ADD_TO_PATH: 5,
              FILL_STROKE_ADD_TO_PATH: 6,
              ADD_TO_PATH: 7,
              FILL_STROKE_MASK: 3,
              ADD_TO_PATH_FLAG: 4
            };
            exports2.TextRenderingMode = TextRenderingMode;
            const ImageKind = {
              GRAYSCALE_1BPP: 1,
              RGB_24BPP: 2,
              RGBA_32BPP: 3
            };
            exports2.ImageKind = ImageKind;
            const AnnotationType = {
              TEXT: 1,
              LINK: 2,
              FREETEXT: 3,
              LINE: 4,
              SQUARE: 5,
              CIRCLE: 6,
              POLYGON: 7,
              POLYLINE: 8,
              HIGHLIGHT: 9,
              UNDERLINE: 10,
              SQUIGGLY: 11,
              STRIKEOUT: 12,
              STAMP: 13,
              CARET: 14,
              INK: 15,
              POPUP: 16,
              FILEATTACHMENT: 17,
              SOUND: 18,
              MOVIE: 19,
              WIDGET: 20,
              SCREEN: 21,
              PRINTERMARK: 22,
              TRAPNET: 23,
              WATERMARK: 24,
              THREED: 25,
              REDACT: 26
            };
            exports2.AnnotationType = AnnotationType;
            const AnnotationReplyType = {
              GROUP: "Group",
              REPLY: "R"
            };
            exports2.AnnotationReplyType = AnnotationReplyType;
            const AnnotationFlag = {
              INVISIBLE: 1,
              HIDDEN: 2,
              PRINT: 4,
              NOZOOM: 8,
              NOROTATE: 16,
              NOVIEW: 32,
              READONLY: 64,
              LOCKED: 128,
              TOGGLENOVIEW: 256,
              LOCKEDCONTENTS: 512
            };
            exports2.AnnotationFlag = AnnotationFlag;
            const AnnotationFieldFlag = {
              READONLY: 1,
              REQUIRED: 2,
              NOEXPORT: 4,
              MULTILINE: 4096,
              PASSWORD: 8192,
              NOTOGGLETOOFF: 16384,
              RADIO: 32768,
              PUSHBUTTON: 65536,
              COMBO: 131072,
              EDIT: 262144,
              SORT: 524288,
              FILESELECT: 1048576,
              MULTISELECT: 2097152,
              DONOTSPELLCHECK: 4194304,
              DONOTSCROLL: 8388608,
              COMB: 16777216,
              RICHTEXT: 33554432,
              RADIOSINUNISON: 33554432,
              COMMITONSELCHANGE: 67108864
            };
            exports2.AnnotationFieldFlag = AnnotationFieldFlag;
            const AnnotationBorderStyleType = {
              SOLID: 1,
              DASHED: 2,
              BEVELED: 3,
              INSET: 4,
              UNDERLINE: 5
            };
            exports2.AnnotationBorderStyleType = AnnotationBorderStyleType;
            const AnnotationActionEventType = {
              E: "Mouse Enter",
              X: "Mouse Exit",
              D: "Mouse Down",
              U: "Mouse Up",
              Fo: "Focus",
              Bl: "Blur",
              PO: "PageOpen",
              PC: "PageClose",
              PV: "PageVisible",
              PI: "PageInvisible",
              K: "Keystroke",
              F: "Format",
              V: "Validate",
              C: "Calculate"
            };
            exports2.AnnotationActionEventType = AnnotationActionEventType;
            const DocumentActionEventType = {
              WC: "WillClose",
              WS: "WillSave",
              DS: "DidSave",
              WP: "WillPrint",
              DP: "DidPrint"
            };
            exports2.DocumentActionEventType = DocumentActionEventType;
            const PageActionEventType = {
              O: "PageOpen",
              C: "PageClose"
            };
            exports2.PageActionEventType = PageActionEventType;
            const VerbosityLevel = {
              ERRORS: 0,
              WARNINGS: 1,
              INFOS: 5
            };
            exports2.VerbosityLevel = VerbosityLevel;
            const CMapCompressionType = {
              NONE: 0,
              BINARY: 1
            };
            exports2.CMapCompressionType = CMapCompressionType;
            const OPS = {
              dependency: 1,
              setLineWidth: 2,
              setLineCap: 3,
              setLineJoin: 4,
              setMiterLimit: 5,
              setDash: 6,
              setRenderingIntent: 7,
              setFlatness: 8,
              setGState: 9,
              save: 10,
              restore: 11,
              transform: 12,
              moveTo: 13,
              lineTo: 14,
              curveTo: 15,
              curveTo2: 16,
              curveTo3: 17,
              closePath: 18,
              rectangle: 19,
              stroke: 20,
              closeStroke: 21,
              fill: 22,
              eoFill: 23,
              fillStroke: 24,
              eoFillStroke: 25,
              closeFillStroke: 26,
              closeEOFillStroke: 27,
              endPath: 28,
              clip: 29,
              eoClip: 30,
              beginText: 31,
              endText: 32,
              setCharSpacing: 33,
              setWordSpacing: 34,
              setHScale: 35,
              setLeading: 36,
              setFont: 37,
              setTextRenderingMode: 38,
              setTextRise: 39,
              moveText: 40,
              setLeadingMoveText: 41,
              setTextMatrix: 42,
              nextLine: 43,
              showText: 44,
              showSpacedText: 45,
              nextLineShowText: 46,
              nextLineSetSpacingShowText: 47,
              setCharWidth: 48,
              setCharWidthAndBounds: 49,
              setStrokeColorSpace: 50,
              setFillColorSpace: 51,
              setStrokeColor: 52,
              setStrokeColorN: 53,
              setFillColor: 54,
              setFillColorN: 55,
              setStrokeGray: 56,
              setFillGray: 57,
              setStrokeRGBColor: 58,
              setFillRGBColor: 59,
              setStrokeCMYKColor: 60,
              setFillCMYKColor: 61,
              shadingFill: 62,
              beginInlineImage: 63,
              beginImageData: 64,
              endInlineImage: 65,
              paintXObject: 66,
              markPoint: 67,
              markPointProps: 68,
              beginMarkedContent: 69,
              beginMarkedContentProps: 70,
              endMarkedContent: 71,
              beginCompat: 72,
              endCompat: 73,
              paintFormXObjectBegin: 74,
              paintFormXObjectEnd: 75,
              beginGroup: 76,
              endGroup: 77,
              beginAnnotation: 80,
              endAnnotation: 81,
              paintImageMaskXObject: 83,
              paintImageMaskXObjectGroup: 84,
              paintImageXObject: 85,
              paintInlineImageXObject: 86,
              paintInlineImageXObjectGroup: 87,
              paintImageXObjectRepeat: 88,
              paintImageMaskXObjectRepeat: 89,
              paintSolidColorImageMask: 90,
              constructPath: 91
            };
            exports2.OPS = OPS;
            const PasswordResponses = {
              NEED_PASSWORD: 1,
              INCORRECT_PASSWORD: 2
            };
            exports2.PasswordResponses = PasswordResponses;
            let verbosity = VerbosityLevel.WARNINGS;
            function setVerbosityLevel(level) {
              if (Number.isInteger(level)) {
                verbosity = level;
              }
            }
            function getVerbosityLevel() {
              return verbosity;
            }
            function info(msg2) {
              if (verbosity >= VerbosityLevel.INFOS) {
                console.log(`Info: ${msg2}`);
              }
            }
            function warn(msg2) {
              if (verbosity >= VerbosityLevel.WARNINGS) {
                console.log(`Warning: ${msg2}`);
              }
            }
            function unreachable(msg2) {
              throw new Error(msg2);
            }
            function assert2(cond, msg2) {
              if (!cond) {
                unreachable(msg2);
              }
            }
            function _isValidProtocol(url2) {
              switch (url2 == null ? void 0 : url2.protocol) {
                case "http:":
                case "https:":
                case "ftp:":
                case "mailto:":
                case "tel:":
                  return true;
                default:
                  return false;
              }
            }
            function createValidAbsoluteUrl(url2, baseUrl = null, options2 = null) {
              if (!url2) {
                return null;
              }
              try {
                if (options2 && typeof url2 === "string") {
                  if (options2.addDefaultProtocol && url2.startsWith("www.")) {
                    const dots = url2.match(/\./g);
                    if ((dots == null ? void 0 : dots.length) >= 2) {
                      url2 = `http://${url2}`;
                    }
                  }
                  if (options2.tryConvertEncoding) {
                    try {
                      url2 = stringToUTF8String(url2);
                    } catch {
                    }
                  }
                }
                const absoluteUrl = baseUrl ? new URL(url2, baseUrl) : new URL(url2);
                if (_isValidProtocol(absoluteUrl)) {
                  return absoluteUrl;
                }
              } catch {
              }
              return null;
            }
            function shadow2(obj, prop, value, nonSerializable = false) {
              Object.defineProperty(obj, prop, {
                value,
                enumerable: !nonSerializable,
                configurable: true,
                writable: false
              });
              return value;
            }
            const BaseException = function BaseExceptionClosure() {
              function BaseException2(message2, name2) {
                if (this.constructor === BaseException2) {
                  unreachable("Cannot initialize BaseException.");
                }
                this.message = message2;
                this.name = name2;
              }
              BaseException2.prototype = new Error();
              BaseException2.constructor = BaseException2;
              return BaseException2;
            }();
            exports2.BaseException = BaseException;
            class PasswordException extends BaseException {
              constructor(msg2, code) {
                super(msg2, "PasswordException");
                this.code = code;
              }
            }
            exports2.PasswordException = PasswordException;
            class UnknownErrorException extends BaseException {
              constructor(msg2, details) {
                super(msg2, "UnknownErrorException");
                this.details = details;
              }
            }
            exports2.UnknownErrorException = UnknownErrorException;
            class InvalidPDFException extends BaseException {
              constructor(msg2) {
                super(msg2, "InvalidPDFException");
              }
            }
            exports2.InvalidPDFException = InvalidPDFException;
            class MissingPDFException extends BaseException {
              constructor(msg2) {
                super(msg2, "MissingPDFException");
              }
            }
            exports2.MissingPDFException = MissingPDFException;
            class UnexpectedResponseException extends BaseException {
              constructor(msg2, status) {
                super(msg2, "UnexpectedResponseException");
                this.status = status;
              }
            }
            exports2.UnexpectedResponseException = UnexpectedResponseException;
            class FormatError extends BaseException {
              constructor(msg2) {
                super(msg2, "FormatError");
              }
            }
            exports2.FormatError = FormatError;
            class AbortException extends BaseException {
              constructor(msg2) {
                super(msg2, "AbortException");
              }
            }
            exports2.AbortException = AbortException;
            function bytesToString(bytes) {
              if (typeof bytes !== "object" || (bytes == null ? void 0 : bytes.length) === void 0) {
                unreachable("Invalid argument for bytesToString");
              }
              const length2 = bytes.length;
              const MAX_ARGUMENT_COUNT = 8192;
              if (length2 < MAX_ARGUMENT_COUNT) {
                return String.fromCharCode.apply(null, bytes);
              }
              const strBuf = [];
              for (let i2 = 0; i2 < length2; i2 += MAX_ARGUMENT_COUNT) {
                const chunkEnd = Math.min(i2 + MAX_ARGUMENT_COUNT, length2);
                const chunk = bytes.subarray(i2, chunkEnd);
                strBuf.push(String.fromCharCode.apply(null, chunk));
              }
              return strBuf.join("");
            }
            function stringToBytes2(str) {
              if (typeof str !== "string") {
                unreachable("Invalid argument for stringToBytes");
              }
              const length2 = str.length;
              const bytes = new Uint8Array(length2);
              for (let i2 = 0; i2 < length2; ++i2) {
                bytes[i2] = str.charCodeAt(i2) & 255;
              }
              return bytes;
            }
            function string32(value) {
              return String.fromCharCode(value >> 24 & 255, value >> 16 & 255, value >> 8 & 255, value & 255);
            }
            function objectSize(obj) {
              return Object.keys(obj).length;
            }
            function objectFromMap(map5) {
              const obj = /* @__PURE__ */ Object.create(null);
              for (const [key, value] of map5) {
                obj[key] = value;
              }
              return obj;
            }
            function isLittleEndian() {
              const buffer8 = new Uint8Array(4);
              buffer8[0] = 1;
              const view32 = new Uint32Array(buffer8.buffer, 0, 1);
              return view32[0] === 1;
            }
            function isEvalSupported() {
              try {
                new Function("");
                return true;
              } catch {
                return false;
              }
            }
            class FeatureTest {
              static get isLittleEndian() {
                return shadow2(this, "isLittleEndian", isLittleEndian());
              }
              static get isEvalSupported() {
                return shadow2(this, "isEvalSupported", isEvalSupported());
              }
              static get isOffscreenCanvasSupported() {
                return shadow2(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
              }
              static get platform() {
                if (typeof navigator === "undefined") {
                  return shadow2(this, "platform", {
                    isWin: false,
                    isMac: false
                  });
                }
                return shadow2(this, "platform", {
                  isWin: navigator.platform.includes("Win"),
                  isMac: navigator.platform.includes("Mac")
                });
              }
              static get isCSSRoundSupported() {
                var _a3, _b3;
                return shadow2(this, "isCSSRoundSupported", (_b3 = (_a3 = globalThis.CSS) == null ? void 0 : _a3.supports) == null ? void 0 : _b3.call(_a3, "width: round(1.5px, 1px)"));
              }
            }
            exports2.FeatureTest = FeatureTest;
            const hexNumbers = [...Array(256).keys()].map((n2) => n2.toString(16).padStart(2, "0"));
            class Util {
              static makeHexColor(r2, g2, b2) {
                return `#${hexNumbers[r2]}${hexNumbers[g2]}${hexNumbers[b2]}`;
              }
              static scaleMinMax(transform4, minMax) {
                let temp2;
                if (transform4[0]) {
                  if (transform4[0] < 0) {
                    temp2 = minMax[0];
                    minMax[0] = minMax[1];
                    minMax[1] = temp2;
                  }
                  minMax[0] *= transform4[0];
                  minMax[1] *= transform4[0];
                  if (transform4[3] < 0) {
                    temp2 = minMax[2];
                    minMax[2] = minMax[3];
                    minMax[3] = temp2;
                  }
                  minMax[2] *= transform4[3];
                  minMax[3] *= transform4[3];
                } else {
                  temp2 = minMax[0];
                  minMax[0] = minMax[2];
                  minMax[2] = temp2;
                  temp2 = minMax[1];
                  minMax[1] = minMax[3];
                  minMax[3] = temp2;
                  if (transform4[1] < 0) {
                    temp2 = minMax[2];
                    minMax[2] = minMax[3];
                    minMax[3] = temp2;
                  }
                  minMax[2] *= transform4[1];
                  minMax[3] *= transform4[1];
                  if (transform4[2] < 0) {
                    temp2 = minMax[0];
                    minMax[0] = minMax[1];
                    minMax[1] = temp2;
                  }
                  minMax[0] *= transform4[2];
                  minMax[1] *= transform4[2];
                }
                minMax[0] += transform4[4];
                minMax[1] += transform4[4];
                minMax[2] += transform4[5];
                minMax[3] += transform4[5];
              }
              static transform(m1, m2) {
                return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
              }
              static applyTransform(p2, m2) {
                const xt = p2[0] * m2[0] + p2[1] * m2[2] + m2[4];
                const yt = p2[0] * m2[1] + p2[1] * m2[3] + m2[5];
                return [xt, yt];
              }
              static applyInverseTransform(p2, m2) {
                const d2 = m2[0] * m2[3] - m2[1] * m2[2];
                const xt = (p2[0] * m2[3] - p2[1] * m2[2] + m2[2] * m2[5] - m2[4] * m2[3]) / d2;
                const yt = (-p2[0] * m2[1] + p2[1] * m2[0] + m2[4] * m2[1] - m2[5] * m2[0]) / d2;
                return [xt, yt];
              }
              static getAxialAlignedBoundingBox(r2, m2) {
                const p1 = this.applyTransform(r2, m2);
                const p2 = this.applyTransform(r2.slice(2, 4), m2);
                const p3 = this.applyTransform([r2[0], r2[3]], m2);
                const p4 = this.applyTransform([r2[2], r2[1]], m2);
                return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
              }
              static inverseTransform(m2) {
                const d2 = m2[0] * m2[3] - m2[1] * m2[2];
                return [m2[3] / d2, -m2[1] / d2, -m2[2] / d2, m2[0] / d2, (m2[2] * m2[5] - m2[4] * m2[3]) / d2, (m2[4] * m2[1] - m2[5] * m2[0]) / d2];
              }
              static singularValueDecompose2dScale(m2) {
                const transpose2 = [m2[0], m2[2], m2[1], m2[3]];
                const a2 = m2[0] * transpose2[0] + m2[1] * transpose2[2];
                const b2 = m2[0] * transpose2[1] + m2[1] * transpose2[3];
                const c2 = m2[2] * transpose2[0] + m2[3] * transpose2[2];
                const d2 = m2[2] * transpose2[1] + m2[3] * transpose2[3];
                const first = (a2 + d2) / 2;
                const second = Math.sqrt((a2 + d2) ** 2 - 4 * (a2 * d2 - c2 * b2)) / 2;
                const sx = first + second || 1;
                const sy = first - second || 1;
                return [Math.sqrt(sx), Math.sqrt(sy)];
              }
              static normalizeRect(rect) {
                const r2 = rect.slice(0);
                if (rect[0] > rect[2]) {
                  r2[0] = rect[2];
                  r2[2] = rect[0];
                }
                if (rect[1] > rect[3]) {
                  r2[1] = rect[3];
                  r2[3] = rect[1];
                }
                return r2;
              }
              static intersect(rect1, rect2) {
                const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                if (xLow > xHigh) {
                  return null;
                }
                const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                if (yLow > yHigh) {
                  return null;
                }
                return [xLow, yLow, xHigh, yHigh];
              }
              static bezierBoundingBox(x02, y02, x12, y12, x2, y2, x3, y3) {
                const tvalues = [], bounds = [[], []];
                let a2, b2, c2, t2, t1, t22, b2ac, sqrtb2ac;
                for (let i2 = 0; i2 < 2; ++i2) {
                  if (i2 === 0) {
                    b2 = 6 * x02 - 12 * x12 + 6 * x2;
                    a2 = -3 * x02 + 9 * x12 - 9 * x2 + 3 * x3;
                    c2 = 3 * x12 - 3 * x02;
                  } else {
                    b2 = 6 * y02 - 12 * y12 + 6 * y2;
                    a2 = -3 * y02 + 9 * y12 - 9 * y2 + 3 * y3;
                    c2 = 3 * y12 - 3 * y02;
                  }
                  if (Math.abs(a2) < 1e-12) {
                    if (Math.abs(b2) < 1e-12) {
                      continue;
                    }
                    t2 = -c2 / b2;
                    if (0 < t2 && t2 < 1) {
                      tvalues.push(t2);
                    }
                    continue;
                  }
                  b2ac = b2 * b2 - 4 * c2 * a2;
                  sqrtb2ac = Math.sqrt(b2ac);
                  if (b2ac < 0) {
                    continue;
                  }
                  t1 = (-b2 + sqrtb2ac) / (2 * a2);
                  if (0 < t1 && t1 < 1) {
                    tvalues.push(t1);
                  }
                  t22 = (-b2 - sqrtb2ac) / (2 * a2);
                  if (0 < t22 && t22 < 1) {
                    tvalues.push(t22);
                  }
                }
                let j2 = tvalues.length, mt;
                const jlen = j2;
                while (j2--) {
                  t2 = tvalues[j2];
                  mt = 1 - t2;
                  bounds[0][j2] = mt * mt * mt * x02 + 3 * mt * mt * t2 * x12 + 3 * mt * t2 * t2 * x2 + t2 * t2 * t2 * x3;
                  bounds[1][j2] = mt * mt * mt * y02 + 3 * mt * mt * t2 * y12 + 3 * mt * t2 * t2 * y2 + t2 * t2 * t2 * y3;
                }
                bounds[0][jlen] = x02;
                bounds[1][jlen] = y02;
                bounds[0][jlen + 1] = x3;
                bounds[1][jlen + 1] = y3;
                bounds[0].length = bounds[1].length = jlen + 2;
                return [Math.min(...bounds[0]), Math.min(...bounds[1]), Math.max(...bounds[0]), Math.max(...bounds[1])];
              }
            }
            exports2.Util = Util;
            const PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
            function stringToPDFString(str) {
              if (str[0] >= "ï") {
                let encoding;
                if (str[0] === "þ" && str[1] === "ÿ") {
                  encoding = "utf-16be";
                } else if (str[0] === "ÿ" && str[1] === "þ") {
                  encoding = "utf-16le";
                } else if (str[0] === "ï" && str[1] === "»" && str[2] === "¿") {
                  encoding = "utf-8";
                }
                if (encoding) {
                  try {
                    const decoder = new TextDecoder(encoding, {
                      fatal: true
                    });
                    const buffer3 = stringToBytes2(str);
                    return decoder.decode(buffer3);
                  } catch (ex) {
                    warn(`stringToPDFString: "${ex}".`);
                  }
                }
              }
              const strBuf = [];
              for (let i2 = 0, ii2 = str.length; i2 < ii2; i2++) {
                const code = PDFStringTranslateTable[str.charCodeAt(i2)];
                strBuf.push(code ? String.fromCharCode(code) : str.charAt(i2));
              }
              return strBuf.join("");
            }
            function stringToUTF8String(str) {
              return decodeURIComponent(escape(str));
            }
            function utf8StringToString(str) {
              return unescape(encodeURIComponent(str));
            }
            function isArrayBuffer2(v5) {
              return typeof v5 === "object" && (v5 == null ? void 0 : v5.byteLength) !== void 0;
            }
            function isArrayEqual(arr1, arr2) {
              if (arr1.length !== arr2.length) {
                return false;
              }
              for (let i2 = 0, ii2 = arr1.length; i2 < ii2; i2++) {
                if (arr1[i2] !== arr2[i2]) {
                  return false;
                }
              }
              return true;
            }
            function getModificationDate(date2 = /* @__PURE__ */ new Date()) {
              const buffer3 = [date2.getUTCFullYear().toString(), (date2.getUTCMonth() + 1).toString().padStart(2, "0"), date2.getUTCDate().toString().padStart(2, "0"), date2.getUTCHours().toString().padStart(2, "0"), date2.getUTCMinutes().toString().padStart(2, "0"), date2.getUTCSeconds().toString().padStart(2, "0")];
              return buffer3.join("");
            }
            class PromiseCapability {
              constructor() {
                __privateAdd(this, _settled, false);
                this.promise = new Promise((resolve2, reject) => {
                  this.resolve = (data2) => {
                    __privateSet(this, _settled, true);
                    resolve2(data2);
                  };
                  this.reject = (reason) => {
                    __privateSet(this, _settled, true);
                    reject(reason);
                  };
                });
              }
              get settled() {
                return __privateGet(this, _settled);
              }
            }
            _settled = new WeakMap();
            exports2.PromiseCapability = PromiseCapability;
            let NormalizeRegex = null;
            let NormalizationMap = null;
            function normalizeUnicode(str) {
              if (!NormalizeRegex) {
                NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
                NormalizationMap = /* @__PURE__ */ new Map([["ﬅ", "ſt"]]);
              }
              return str.replaceAll(NormalizeRegex, (_2, p1, p2) => {
                return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
              });
            }
            function getUuid() {
              if (typeof crypto !== "undefined" && typeof (crypto == null ? void 0 : crypto.randomUUID) === "function") {
                return crypto.randomUUID();
              }
              const buf = new Uint8Array(32);
              if (typeof crypto !== "undefined" && typeof (crypto == null ? void 0 : crypto.getRandomValues) === "function") {
                crypto.getRandomValues(buf);
              } else {
                for (let i2 = 0; i2 < 32; i2++) {
                  buf[i2] = Math.floor(Math.random() * 255);
                }
              }
              return bytesToString(buf);
            }
            const AnnotationPrefix = "pdfjs_internal_id_";
            exports2.AnnotationPrefix = AnnotationPrefix;
          },
          /* 2 */
          /***/
          (__unused_webpack_module, exports, __w_pdfjs_require__) => {
            var _docId, _delayedCleanupTimeout, _pendingCleanup, _tryCleanup, tryCleanup_fn, _abortDelayedCleanup, abortDelayedCleanup_fn, _listeners2, _deferred, _a3, _workerPorts, _methodPromises, _pageCache, _pagePromises, _passwordCapability, _cacheSimpleMethod, cacheSimpleMethod_fn, _objs, _ensureObj, ensureObj_fn, _internalRenderTask, _canvasInUse;
            Object.defineProperty(exports, "__esModule", {
              value: true
            });
            exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
            Object.defineProperty(exports, "SVGGraphics", {
              enumerable: true,
              get: function() {
                return _displaySvg.SVGGraphics;
              }
            });
            exports.build = void 0;
            exports.getDocument = getDocument;
            exports.version = void 0;
            var _util = __w_pdfjs_require__(1);
            var _annotation_storage = __w_pdfjs_require__(3);
            var _display_utils = __w_pdfjs_require__(6);
            var _font_loader = __w_pdfjs_require__(9);
            var _displayNode_utils = __w_pdfjs_require__(10);
            var _canvas = __w_pdfjs_require__(11);
            var _worker_options = __w_pdfjs_require__(14);
            var _message_handler = __w_pdfjs_require__(15);
            var _metadata = __w_pdfjs_require__(16);
            var _optional_content_config = __w_pdfjs_require__(17);
            var _transport_stream = __w_pdfjs_require__(18);
            var _displayFetch_stream = __w_pdfjs_require__(19);
            var _displayNetwork = __w_pdfjs_require__(22);
            var _displayNode_stream = __w_pdfjs_require__(23);
            var _displaySvg = __w_pdfjs_require__(24);
            var _xfa_text = __w_pdfjs_require__(25);
            const DEFAULT_RANGE_CHUNK_SIZE = 65536;
            const RENDERING_CANCELLED_TIMEOUT = 100;
            const DELAYED_CLEANUP_TIMEOUT = 5e3;
            const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
            exports.DefaultCanvasFactory = DefaultCanvasFactory;
            const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
            exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
            const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
            exports.DefaultFilterFactory = DefaultFilterFactory;
            const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
            exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
            function getDocument(src2) {
              if (typeof src2 === "string" || src2 instanceof URL) {
                src2 = {
                  url: src2
                };
              } else if ((0, _util.isArrayBuffer)(src2)) {
                src2 = {
                  data: src2
                };
              }
              if (typeof src2 !== "object") {
                throw new Error("Invalid parameter in getDocument, need parameter object.");
              }
              if (!src2.url && !src2.data && !src2.range) {
                throw new Error("Invalid parameter object: need either .data, .range or .url");
              }
              const task = new PDFDocumentLoadingTask();
              const {
                docId
              } = task;
              const url2 = src2.url ? getUrlProp(src2.url) : null;
              const data2 = src2.data ? getDataProp(src2.data) : null;
              const httpHeaders = src2.httpHeaders || null;
              const withCredentials = src2.withCredentials === true;
              const password = src2.password ?? null;
              const rangeTransport = src2.range instanceof PDFDataRangeTransport ? src2.range : null;
              const rangeChunkSize = Number.isInteger(src2.rangeChunkSize) && src2.rangeChunkSize > 0 ? src2.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
              let worker2 = src2.worker instanceof PDFWorker ? src2.worker : null;
              const verbosity = src2.verbosity;
              const docBaseUrl = typeof src2.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src2.docBaseUrl) ? src2.docBaseUrl : null;
              const cMapUrl = typeof src2.cMapUrl === "string" ? src2.cMapUrl : null;
              const cMapPacked = src2.cMapPacked !== false;
              const CMapReaderFactory = src2.CMapReaderFactory || DefaultCMapReaderFactory;
              const standardFontDataUrl = typeof src2.standardFontDataUrl === "string" ? src2.standardFontDataUrl : null;
              const StandardFontDataFactory = src2.StandardFontDataFactory || DefaultStandardFontDataFactory;
              const ignoreErrors = src2.stopAtErrors !== true;
              const maxImageSize = Number.isInteger(src2.maxImageSize) && src2.maxImageSize > -1 ? src2.maxImageSize : -1;
              const isEvalSupported = src2.isEvalSupported !== false;
              const isOffscreenCanvasSupported = typeof src2.isOffscreenCanvasSupported === "boolean" ? src2.isOffscreenCanvasSupported : !_util.isNodeJS;
              const canvasMaxAreaInBytes = Number.isInteger(src2.canvasMaxAreaInBytes) ? src2.canvasMaxAreaInBytes : -1;
              const disableFontFace = typeof src2.disableFontFace === "boolean" ? src2.disableFontFace : _util.isNodeJS;
              const fontExtraProperties = src2.fontExtraProperties === true;
              const enableXfa = src2.enableXfa === true;
              const ownerDocument = src2.ownerDocument || globalThis.document;
              const disableRange = src2.disableRange === true;
              const disableStream = src2.disableStream === true;
              const disableAutoFetch = src2.disableAutoFetch === true;
              const pdfBug = src2.pdfBug === true;
              const length2 = rangeTransport ? rangeTransport.length : src2.length ?? NaN;
              const useSystemFonts = typeof src2.useSystemFonts === "boolean" ? src2.useSystemFonts : !_util.isNodeJS && !disableFontFace;
              const useWorkerFetch = typeof src2.useWorkerFetch === "boolean" ? src2.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
              const canvasFactory = src2.canvasFactory || new DefaultCanvasFactory({
                ownerDocument
              });
              const filterFactory = src2.filterFactory || new DefaultFilterFactory({
                docId,
                ownerDocument
              });
              const styleElement = null;
              (0, _util.setVerbosityLevel)(verbosity);
              const transportFactory = {
                canvasFactory,
                filterFactory
              };
              if (!useWorkerFetch) {
                transportFactory.cMapReaderFactory = new CMapReaderFactory({
                  baseUrl: cMapUrl,
                  isCompressed: cMapPacked
                });
                transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                  baseUrl: standardFontDataUrl
                });
              }
              if (!worker2) {
                const workerParams = {
                  verbosity,
                  port: _worker_options.GlobalWorkerOptions.workerPort
                };
                worker2 = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                task._worker = worker2;
              }
              const fetchDocParams = {
                docId,
                apiVersion: "3.11.174",
                data: data2,
                password,
                disableAutoFetch,
                rangeChunkSize,
                length: length2,
                docBaseUrl,
                enableXfa,
                evaluatorOptions: {
                  maxImageSize,
                  disableFontFace,
                  ignoreErrors,
                  isEvalSupported,
                  isOffscreenCanvasSupported,
                  canvasMaxAreaInBytes,
                  fontExtraProperties,
                  useSystemFonts,
                  cMapUrl: useWorkerFetch ? cMapUrl : null,
                  standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                }
              };
              const transportParams = {
                ignoreErrors,
                isEvalSupported,
                disableFontFace,
                fontExtraProperties,
                enableXfa,
                ownerDocument,
                disableAutoFetch,
                pdfBug,
                styleElement
              };
              worker2.promise.then(function() {
                if (task.destroyed) {
                  throw new Error("Loading aborted");
                }
                const workerIdPromise = _fetchDocument(worker2, fetchDocParams);
                const networkStreamPromise = new Promise(function(resolve2) {
                  let networkStream;
                  if (rangeTransport) {
                    networkStream = new _transport_stream.PDFDataTransportStream({
                      length: length2,
                      initialData: rangeTransport.initialData,
                      progressiveDone: rangeTransport.progressiveDone,
                      contentDispositionFilename: rangeTransport.contentDispositionFilename,
                      disableRange,
                      disableStream
                    }, rangeTransport);
                  } else if (!data2) {
                    const createPDFNetworkStream = (params2) => {
                      if (_util.isNodeJS) {
                        return new _displayNode_stream.PDFNodeStream(params2);
                      }
                      return (0, _display_utils.isValidFetchUrl)(params2.url) ? new _displayFetch_stream.PDFFetchStream(params2) : new _displayNetwork.PDFNetworkStream(params2);
                    };
                    networkStream = createPDFNetworkStream({
                      url: url2,
                      length: length2,
                      httpHeaders,
                      withCredentials,
                      rangeChunkSize,
                      disableRange,
                      disableStream
                    });
                  }
                  resolve2(networkStream);
                });
                return Promise.all([workerIdPromise, networkStreamPromise]).then(function([workerId, networkStream]) {
                  if (task.destroyed) {
                    throw new Error("Loading aborted");
                  }
                  const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker2.port);
                  const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                  task._transport = transport;
                  messageHandler.send("Ready", null);
                });
              }).catch(task._capability.reject);
              return task;
            }
            async function _fetchDocument(worker2, source) {
              if (worker2.destroyed) {
                throw new Error("Worker was destroyed");
              }
              const workerId = await worker2.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [source.data.buffer] : null);
              if (worker2.destroyed) {
                throw new Error("Worker was destroyed");
              }
              return workerId;
            }
            function getUrlProp(val) {
              if (val instanceof URL) {
                return val.href;
              }
              try {
                return new URL(val, window.location).href;
              } catch {
                if (_util.isNodeJS && typeof val === "string") {
                  return val;
                }
              }
              throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
            }
            function getDataProp(val) {
              if (_util.isNodeJS && typeof Buffer !== "undefined" && val instanceof Buffer) {
                throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
              }
              if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) {
                return val;
              }
              if (typeof val === "string") {
                return (0, _util.stringToBytes)(val);
              }
              if (typeof val === "object" && !isNaN(val == null ? void 0 : val.length) || (0, _util.isArrayBuffer)(val)) {
                return new Uint8Array(val);
              }
              throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
            }
            const _PDFDocumentLoadingTask = class {
              constructor() {
                this._capability = new _util.PromiseCapability();
                this._transport = null;
                this._worker = null;
                this.docId = `d${__privateWrapper(_PDFDocumentLoadingTask, _docId)._++}`;
                this.destroyed = false;
                this.onPassword = null;
                this.onProgress = null;
              }
              get promise() {
                return this._capability.promise;
              }
              async destroy() {
                var _a4, _b3, _c2;
                this.destroyed = true;
                try {
                  if ((_a4 = this._worker) == null ? void 0 : _a4.port) {
                    this._worker._pendingDestroy = true;
                  }
                  await ((_b3 = this._transport) == null ? void 0 : _b3.destroy());
                } catch (ex) {
                  if ((_c2 = this._worker) == null ? void 0 : _c2.port) {
                    delete this._worker._pendingDestroy;
                  }
                  throw ex;
                }
                this._transport = null;
                if (this._worker) {
                  this._worker.destroy();
                  this._worker = null;
                }
              }
            };
            let PDFDocumentLoadingTask = _PDFDocumentLoadingTask;
            _docId = new WeakMap();
            __privateAdd(PDFDocumentLoadingTask, _docId, 0);
            exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
            class PDFDataRangeTransport {
              constructor(length2, initialData, progressiveDone = false, contentDispositionFilename = null) {
                this.length = length2;
                this.initialData = initialData;
                this.progressiveDone = progressiveDone;
                this.contentDispositionFilename = contentDispositionFilename;
                this._rangeListeners = [];
                this._progressListeners = [];
                this._progressiveReadListeners = [];
                this._progressiveDoneListeners = [];
                this._readyCapability = new _util.PromiseCapability();
              }
              addRangeListener(listener) {
                this._rangeListeners.push(listener);
              }
              addProgressListener(listener) {
                this._progressListeners.push(listener);
              }
              addProgressiveReadListener(listener) {
                this._progressiveReadListeners.push(listener);
              }
              addProgressiveDoneListener(listener) {
                this._progressiveDoneListeners.push(listener);
              }
              onDataRange(begin, chunk) {
                for (const listener of this._rangeListeners) {
                  listener(begin, chunk);
                }
              }
              onDataProgress(loaded, total) {
                this._readyCapability.promise.then(() => {
                  for (const listener of this._progressListeners) {
                    listener(loaded, total);
                  }
                });
              }
              onDataProgressiveRead(chunk) {
                this._readyCapability.promise.then(() => {
                  for (const listener of this._progressiveReadListeners) {
                    listener(chunk);
                  }
                });
              }
              onDataProgressiveDone() {
                this._readyCapability.promise.then(() => {
                  for (const listener of this._progressiveDoneListeners) {
                    listener();
                  }
                });
              }
              transportReady() {
                this._readyCapability.resolve();
              }
              requestDataRange(begin, end) {
                (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
              }
              abort() {
              }
            }
            exports.PDFDataRangeTransport = PDFDataRangeTransport;
            class PDFDocumentProxy {
              constructor(pdfInfo, transport) {
                this._pdfInfo = pdfInfo;
                this._transport = transport;
                Object.defineProperty(this, "getJavaScript", {
                  value: () => {
                    (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                    return this.getJSActions().then((js2) => {
                      if (!js2) {
                        return js2;
                      }
                      const jsArr = [];
                      for (const name2 in js2) {
                        jsArr.push(...js2[name2]);
                      }
                      return jsArr;
                    });
                  }
                });
              }
              get annotationStorage() {
                return this._transport.annotationStorage;
              }
              get filterFactory() {
                return this._transport.filterFactory;
              }
              get numPages() {
                return this._pdfInfo.numPages;
              }
              get fingerprints() {
                return this._pdfInfo.fingerprints;
              }
              get isPureXfa() {
                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
              }
              get allXfaHtml() {
                return this._transport._htmlForXfa;
              }
              getPage(pageNumber) {
                return this._transport.getPage(pageNumber);
              }
              getPageIndex(ref) {
                return this._transport.getPageIndex(ref);
              }
              getDestinations() {
                return this._transport.getDestinations();
              }
              getDestination(id) {
                return this._transport.getDestination(id);
              }
              getPageLabels() {
                return this._transport.getPageLabels();
              }
              getPageLayout() {
                return this._transport.getPageLayout();
              }
              getPageMode() {
                return this._transport.getPageMode();
              }
              getViewerPreferences() {
                return this._transport.getViewerPreferences();
              }
              getOpenAction() {
                return this._transport.getOpenAction();
              }
              getAttachments() {
                return this._transport.getAttachments();
              }
              getJSActions() {
                return this._transport.getDocJSActions();
              }
              getOutline() {
                return this._transport.getOutline();
              }
              getOptionalContentConfig() {
                return this._transport.getOptionalContentConfig();
              }
              getPermissions() {
                return this._transport.getPermissions();
              }
              getMetadata() {
                return this._transport.getMetadata();
              }
              getMarkInfo() {
                return this._transport.getMarkInfo();
              }
              getData() {
                return this._transport.getData();
              }
              saveDocument() {
                return this._transport.saveDocument();
              }
              getDownloadInfo() {
                return this._transport.downloadInfoCapability.promise;
              }
              cleanup(keepLoadedFonts = false) {
                return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
              }
              destroy() {
                return this.loadingTask.destroy();
              }
              get loadingParams() {
                return this._transport.loadingParams;
              }
              get loadingTask() {
                return this._transport.loadingTask;
              }
              getFieldObjects() {
                return this._transport.getFieldObjects();
              }
              hasJSActions() {
                return this._transport.hasJSActions();
              }
              getCalculationOrderIds() {
                return this._transport.getCalculationOrderIds();
              }
            }
            exports.PDFDocumentProxy = PDFDocumentProxy;
            class PDFPageProxy {
              constructor(pageIndex, pageInfo, transport, pdfBug = false) {
                __privateAdd(this, _tryCleanup);
                __privateAdd(this, _abortDelayedCleanup);
                __privateAdd(this, _delayedCleanupTimeout, null);
                __privateAdd(this, _pendingCleanup, false);
                this._pageIndex = pageIndex;
                this._pageInfo = pageInfo;
                this._transport = transport;
                this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                this._pdfBug = pdfBug;
                this.commonObjs = transport.commonObjs;
                this.objs = new PDFObjects();
                this._maybeCleanupAfterRender = false;
                this._intentStates = /* @__PURE__ */ new Map();
                this.destroyed = false;
              }
              get pageNumber() {
                return this._pageIndex + 1;
              }
              get rotate() {
                return this._pageInfo.rotate;
              }
              get ref() {
                return this._pageInfo.ref;
              }
              get userUnit() {
                return this._pageInfo.userUnit;
              }
              get view() {
                return this._pageInfo.view;
              }
              getViewport({
                scale: scale5,
                rotation = this.rotate,
                offsetX = 0,
                offsetY = 0,
                dontFlip = false
              } = {}) {
                return new _display_utils.PageViewport({
                  viewBox: this.view,
                  scale: scale5,
                  rotation,
                  offsetX,
                  offsetY,
                  dontFlip
                });
              }
              getAnnotations({
                intent = "display"
              } = {}) {
                const intentArgs = this._transport.getRenderingIntent(intent);
                return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
              }
              getJSActions() {
                return this._transport.getPageJSActions(this._pageIndex);
              }
              get filterFactory() {
                return this._transport.filterFactory;
              }
              get isPureXfa() {
                return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
              }
              async getXfa() {
                var _a4;
                return ((_a4 = this._transport._htmlForXfa) == null ? void 0 : _a4.children[this._pageIndex]) || null;
              }
              render({
                canvasContext,
                viewport,
                intent = "display",
                annotationMode = _util.AnnotationMode.ENABLE,
                transform: transform4 = null,
                background = null,
                optionalContentConfigPromise = null,
                annotationCanvasMap = null,
                pageColors = null,
                printAnnotationStorage = null
              }) {
                var _a4, _b3;
                (_a4 = this._stats) == null ? void 0 : _a4.time("Overall");
                const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                __privateSet(this, _pendingCleanup, false);
                __privateMethod(this, _abortDelayedCleanup, abortDelayedCleanup_fn).call(this);
                if (!optionalContentConfigPromise) {
                  optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                }
                let intentState = this._intentStates.get(intentArgs.cacheKey);
                if (!intentState) {
                  intentState = /* @__PURE__ */ Object.create(null);
                  this._intentStates.set(intentArgs.cacheKey, intentState);
                }
                if (intentState.streamReaderCancelTimeout) {
                  clearTimeout(intentState.streamReaderCancelTimeout);
                  intentState.streamReaderCancelTimeout = null;
                }
                const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                if (!intentState.displayReadyCapability) {
                  intentState.displayReadyCapability = new _util.PromiseCapability();
                  intentState.operatorList = {
                    fnArray: [],
                    argsArray: [],
                    lastChunk: false,
                    separateAnnots: null
                  };
                  (_b3 = this._stats) == null ? void 0 : _b3.time("Page Request");
                  this._pumpOperatorList(intentArgs);
                }
                const complete = (error2) => {
                  var _a5, _b4;
                  intentState.renderTasks.delete(internalRenderTask);
                  if (this._maybeCleanupAfterRender || intentPrint) {
                    __privateSet(this, _pendingCleanup, true);
                  }
                  __privateMethod(this, _tryCleanup, tryCleanup_fn).call(this, !intentPrint);
                  if (error2) {
                    internalRenderTask.capability.reject(error2);
                    this._abortOperatorList({
                      intentState,
                      reason: error2 instanceof Error ? error2 : new Error(error2)
                    });
                  } else {
                    internalRenderTask.capability.resolve();
                  }
                  (_a5 = this._stats) == null ? void 0 : _a5.timeEnd("Rendering");
                  (_b4 = this._stats) == null ? void 0 : _b4.timeEnd("Overall");
                };
                const internalRenderTask = new InternalRenderTask({
                  callback: complete,
                  params: {
                    canvasContext,
                    viewport,
                    transform: transform4,
                    background
                  },
                  objs: this.objs,
                  commonObjs: this.commonObjs,
                  annotationCanvasMap,
                  operatorList: intentState.operatorList,
                  pageIndex: this._pageIndex,
                  canvasFactory: this._transport.canvasFactory,
                  filterFactory: this._transport.filterFactory,
                  useRequestAnimationFrame: !intentPrint,
                  pdfBug: this._pdfBug,
                  pageColors
                });
                (intentState.renderTasks || (intentState.renderTasks = /* @__PURE__ */ new Set())).add(internalRenderTask);
                const renderTask = internalRenderTask.task;
                Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(([transparency, optionalContentConfig]) => {
                  var _a5;
                  if (this.destroyed) {
                    complete();
                    return;
                  }
                  (_a5 = this._stats) == null ? void 0 : _a5.time("Rendering");
                  internalRenderTask.initializeGraphics({
                    transparency,
                    optionalContentConfig
                  });
                  internalRenderTask.operatorListChanged();
                }).catch(complete);
                return renderTask;
              }
              getOperatorList({
                intent = "display",
                annotationMode = _util.AnnotationMode.ENABLE,
                printAnnotationStorage = null
              } = {}) {
                var _a4;
                function operatorListChanged() {
                  if (intentState.operatorList.lastChunk) {
                    intentState.opListReadCapability.resolve(intentState.operatorList);
                    intentState.renderTasks.delete(opListTask);
                  }
                }
                const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                let intentState = this._intentStates.get(intentArgs.cacheKey);
                if (!intentState) {
                  intentState = /* @__PURE__ */ Object.create(null);
                  this._intentStates.set(intentArgs.cacheKey, intentState);
                }
                let opListTask;
                if (!intentState.opListReadCapability) {
                  opListTask = /* @__PURE__ */ Object.create(null);
                  opListTask.operatorListChanged = operatorListChanged;
                  intentState.opListReadCapability = new _util.PromiseCapability();
                  (intentState.renderTasks || (intentState.renderTasks = /* @__PURE__ */ new Set())).add(opListTask);
                  intentState.operatorList = {
                    fnArray: [],
                    argsArray: [],
                    lastChunk: false,
                    separateAnnots: null
                  };
                  (_a4 = this._stats) == null ? void 0 : _a4.time("Page Request");
                  this._pumpOperatorList(intentArgs);
                }
                return intentState.opListReadCapability.promise;
              }
              streamTextContent({
                includeMarkedContent = false,
                disableNormalization = false
              } = {}) {
                const TEXT_CONTENT_CHUNK_SIZE = 100;
                return this._transport.messageHandler.sendWithStream("GetTextContent", {
                  pageIndex: this._pageIndex,
                  includeMarkedContent: includeMarkedContent === true,
                  disableNormalization: disableNormalization === true
                }, {
                  highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                  size(textContent) {
                    return textContent.items.length;
                  }
                });
              }
              getTextContent(params2 = {}) {
                if (this._transport._htmlForXfa) {
                  return this.getXfa().then((xfa) => {
                    return _xfa_text.XfaText.textContent(xfa);
                  });
                }
                const readableStream = this.streamTextContent(params2);
                return new Promise(function(resolve2, reject) {
                  function pump() {
                    reader.read().then(function({
                      value,
                      done
                    }) {
                      if (done) {
                        resolve2(textContent);
                        return;
                      }
                      Object.assign(textContent.styles, value.styles);
                      textContent.items.push(...value.items);
                      pump();
                    }, reject);
                  }
                  const reader = readableStream.getReader();
                  const textContent = {
                    items: [],
                    styles: /* @__PURE__ */ Object.create(null)
                  };
                  pump();
                });
              }
              getStructTree() {
                return this._transport.getStructTree(this._pageIndex);
              }
              _destroy() {
                this.destroyed = true;
                const waitOn = [];
                for (const intentState of this._intentStates.values()) {
                  this._abortOperatorList({
                    intentState,
                    reason: new Error("Page was destroyed."),
                    force: true
                  });
                  if (intentState.opListReadCapability) {
                    continue;
                  }
                  for (const internalRenderTask of intentState.renderTasks) {
                    waitOn.push(internalRenderTask.completed);
                    internalRenderTask.cancel();
                  }
                }
                this.objs.clear();
                __privateSet(this, _pendingCleanup, false);
                __privateMethod(this, _abortDelayedCleanup, abortDelayedCleanup_fn).call(this);
                return Promise.all(waitOn);
              }
              cleanup(resetStats = false) {
                __privateSet(this, _pendingCleanup, true);
                const success = __privateMethod(this, _tryCleanup, tryCleanup_fn).call(this, false);
                if (resetStats && success) {
                  this._stats && (this._stats = new _display_utils.StatTimer());
                }
                return success;
              }
              _startRenderPage(transparency, cacheKey) {
                var _a4, _b3;
                const intentState = this._intentStates.get(cacheKey);
                if (!intentState) {
                  return;
                }
                (_a4 = this._stats) == null ? void 0 : _a4.timeEnd("Page Request");
                (_b3 = intentState.displayReadyCapability) == null ? void 0 : _b3.resolve(transparency);
              }
              _renderPageChunk(operatorListChunk, intentState) {
                for (let i2 = 0, ii2 = operatorListChunk.length; i2 < ii2; i2++) {
                  intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i2]);
                  intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i2]);
                }
                intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                for (const internalRenderTask of intentState.renderTasks) {
                  internalRenderTask.operatorListChanged();
                }
                if (operatorListChunk.lastChunk) {
                  __privateMethod(this, _tryCleanup, tryCleanup_fn).call(this, true);
                }
              }
              _pumpOperatorList({
                renderingIntent,
                cacheKey,
                annotationStorageSerializable
              }) {
                const {
                  map: map5,
                  transfers
                } = annotationStorageSerializable;
                const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                  pageIndex: this._pageIndex,
                  intent: renderingIntent,
                  cacheKey,
                  annotationStorage: map5
                }, transfers);
                const reader = readableStream.getReader();
                const intentState = this._intentStates.get(cacheKey);
                intentState.streamReader = reader;
                const pump = () => {
                  reader.read().then(({
                    value,
                    done
                  }) => {
                    if (done) {
                      intentState.streamReader = null;
                      return;
                    }
                    if (this._transport.destroyed) {
                      return;
                    }
                    this._renderPageChunk(value, intentState);
                    pump();
                  }, (reason) => {
                    intentState.streamReader = null;
                    if (this._transport.destroyed) {
                      return;
                    }
                    if (intentState.operatorList) {
                      intentState.operatorList.lastChunk = true;
                      for (const internalRenderTask of intentState.renderTasks) {
                        internalRenderTask.operatorListChanged();
                      }
                      __privateMethod(this, _tryCleanup, tryCleanup_fn).call(this, true);
                    }
                    if (intentState.displayReadyCapability) {
                      intentState.displayReadyCapability.reject(reason);
                    } else if (intentState.opListReadCapability) {
                      intentState.opListReadCapability.reject(reason);
                    } else {
                      throw reason;
                    }
                  });
                };
                pump();
              }
              _abortOperatorList({
                intentState,
                reason,
                force = false
              }) {
                if (!intentState.streamReader) {
                  return;
                }
                if (intentState.streamReaderCancelTimeout) {
                  clearTimeout(intentState.streamReaderCancelTimeout);
                  intentState.streamReaderCancelTimeout = null;
                }
                if (!force) {
                  if (intentState.renderTasks.size > 0) {
                    return;
                  }
                  if (reason instanceof _display_utils.RenderingCancelledException) {
                    let delay = RENDERING_CANCELLED_TIMEOUT;
                    if (reason.extraDelay > 0 && reason.extraDelay < 1e3) {
                      delay += reason.extraDelay;
                    }
                    intentState.streamReaderCancelTimeout = setTimeout(() => {
                      intentState.streamReaderCancelTimeout = null;
                      this._abortOperatorList({
                        intentState,
                        reason,
                        force: true
                      });
                    }, delay);
                    return;
                  }
                }
                intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(() => {
                });
                intentState.streamReader = null;
                if (this._transport.destroyed) {
                  return;
                }
                for (const [curCacheKey, curIntentState] of this._intentStates) {
                  if (curIntentState === intentState) {
                    this._intentStates.delete(curCacheKey);
                    break;
                  }
                }
                this.cleanup();
              }
              get stats() {
                return this._stats;
              }
            }
            _delayedCleanupTimeout = new WeakMap();
            _pendingCleanup = new WeakMap();
            _tryCleanup = new WeakSet();
            tryCleanup_fn = function(delayed = false) {
              __privateMethod(this, _abortDelayedCleanup, abortDelayedCleanup_fn).call(this);
              if (!__privateGet(this, _pendingCleanup) || this.destroyed) {
                return false;
              }
              if (delayed) {
                __privateSet(this, _delayedCleanupTimeout, setTimeout(() => {
                  __privateSet(this, _delayedCleanupTimeout, null);
                  __privateMethod(this, _tryCleanup, tryCleanup_fn).call(this, false);
                }, DELAYED_CLEANUP_TIMEOUT));
                return false;
              }
              for (const {
                renderTasks,
                operatorList
              } of this._intentStates.values()) {
                if (renderTasks.size > 0 || !operatorList.lastChunk) {
                  return false;
                }
              }
              this._intentStates.clear();
              this.objs.clear();
              __privateSet(this, _pendingCleanup, false);
              return true;
            };
            _abortDelayedCleanup = new WeakSet();
            abortDelayedCleanup_fn = function() {
              if (__privateGet(this, _delayedCleanupTimeout)) {
                clearTimeout(__privateGet(this, _delayedCleanupTimeout));
                __privateSet(this, _delayedCleanupTimeout, null);
              }
            };
            exports.PDFPageProxy = PDFPageProxy;
            class LoopbackPort {
              constructor() {
                __privateAdd(this, _listeners2, /* @__PURE__ */ new Set());
                __privateAdd(this, _deferred, Promise.resolve());
              }
              postMessage(obj, transfer) {
                const event = {
                  data: structuredClone(obj, transfer ? {
                    transfer
                  } : null)
                };
                __privateGet(this, _deferred).then(() => {
                  for (const listener of __privateGet(this, _listeners2)) {
                    listener.call(this, event);
                  }
                });
              }
              addEventListener(name2, listener) {
                __privateGet(this, _listeners2).add(listener);
              }
              removeEventListener(name2, listener) {
                __privateGet(this, _listeners2).delete(listener);
              }
              terminate() {
                __privateGet(this, _listeners2).clear();
              }
            }
            _listeners2 = new WeakMap();
            _deferred = new WeakMap();
            exports.LoopbackPort = LoopbackPort;
            const PDFWorkerUtil = {
              isWorkerDisabled: false,
              fallbackWorkerSrc: null,
              fakeWorkerId: 0
            };
            exports.PDFWorkerUtil = PDFWorkerUtil;
            {
              if (_util.isNodeJS && typeof commonjsRequire === "function") {
                PDFWorkerUtil.isWorkerDisabled = true;
                PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
              } else if (typeof document === "object") {
                const pdfjsFilePath = (_a3 = document == null ? void 0 : document.currentScript) == null ? void 0 : _a3.src;
                if (pdfjsFilePath) {
                  PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
              }
              PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                let base;
                try {
                  base = new URL(baseUrl);
                  if (!base.origin || base.origin === "null") {
                    return false;
                  }
                } catch {
                  return false;
                }
                const other = new URL(otherUrl, base);
                return base.origin === other.origin;
              };
              PDFWorkerUtil.createCDNWrapper = function(url2) {
                const wrapper = `importScripts("${url2}");`;
                return URL.createObjectURL(new Blob([wrapper]));
              };
            }
            const _PDFWorker = class {
              constructor({
                name: name2 = null,
                port = null,
                verbosity = (0, _util.getVerbosityLevel)()
              } = {}) {
                var _a4;
                this.name = name2;
                this.destroyed = false;
                this.verbosity = verbosity;
                this._readyCapability = new _util.PromiseCapability();
                this._port = null;
                this._webWorker = null;
                this._messageHandler = null;
                if (port) {
                  if ((_a4 = __privateGet(_PDFWorker, _workerPorts)) == null ? void 0 : _a4.has(port)) {
                    throw new Error("Cannot use more than one PDFWorker per port.");
                  }
                  (__privateGet(_PDFWorker, _workerPorts) || __privateSet(_PDFWorker, _workerPorts, /* @__PURE__ */ new WeakMap())).set(port, this);
                  this._initializeFromPort(port);
                  return;
                }
                this._initialize();
              }
              get promise() {
                return this._readyCapability.promise;
              }
              get port() {
                return this._port;
              }
              get messageHandler() {
                return this._messageHandler;
              }
              _initializeFromPort(port) {
                this._port = port;
                this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                this._messageHandler.on("ready", function() {
                });
                this._readyCapability.resolve();
                this._messageHandler.send("configure", {
                  verbosity: this.verbosity
                });
              }
              _initialize() {
                if (!PDFWorkerUtil.isWorkerDisabled && !_PDFWorker._mainThreadWorkerMessageHandler) {
                  let {
                    workerSrc
                  } = _PDFWorker;
                  try {
                    if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) {
                      workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                    }
                    const worker2 = new Worker(workerSrc);
                    const messageHandler = new _message_handler.MessageHandler("main", "worker", worker2);
                    const terminateEarly = () => {
                      worker2.removeEventListener("error", onWorkerError);
                      messageHandler.destroy();
                      worker2.terminate();
                      if (this.destroyed) {
                        this._readyCapability.reject(new Error("Worker was destroyed"));
                      } else {
                        this._setupFakeWorker();
                      }
                    };
                    const onWorkerError = () => {
                      if (!this._webWorker) {
                        terminateEarly();
                      }
                    };
                    worker2.addEventListener("error", onWorkerError);
                    messageHandler.on("test", (data2) => {
                      worker2.removeEventListener("error", onWorkerError);
                      if (this.destroyed) {
                        terminateEarly();
                        return;
                      }
                      if (data2) {
                        this._messageHandler = messageHandler;
                        this._port = worker2;
                        this._webWorker = worker2;
                        this._readyCapability.resolve();
                        messageHandler.send("configure", {
                          verbosity: this.verbosity
                        });
                      } else {
                        this._setupFakeWorker();
                        messageHandler.destroy();
                        worker2.terminate();
                      }
                    });
                    messageHandler.on("ready", (data2) => {
                      worker2.removeEventListener("error", onWorkerError);
                      if (this.destroyed) {
                        terminateEarly();
                        return;
                      }
                      try {
                        sendTest();
                      } catch {
                        this._setupFakeWorker();
                      }
                    });
                    const sendTest = () => {
                      const testObj2 = new Uint8Array();
                      messageHandler.send("test", testObj2, [testObj2.buffer]);
                    };
                    sendTest();
                    return;
                  } catch {
                    (0, _util.info)("The worker has been disabled.");
                  }
                }
                this._setupFakeWorker();
              }
              _setupFakeWorker() {
                if (!PDFWorkerUtil.isWorkerDisabled) {
                  (0, _util.warn)("Setting up fake worker.");
                  PDFWorkerUtil.isWorkerDisabled = true;
                }
                _PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler) => {
                  if (this.destroyed) {
                    this._readyCapability.reject(new Error("Worker was destroyed"));
                    return;
                  }
                  const port = new LoopbackPort();
                  this._port = port;
                  const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                  const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                  WorkerMessageHandler.setup(workerHandler, port);
                  const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                  this._messageHandler = messageHandler;
                  this._readyCapability.resolve();
                  messageHandler.send("configure", {
                    verbosity: this.verbosity
                  });
                }).catch((reason) => {
                  this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                });
              }
              destroy() {
                var _a4;
                this.destroyed = true;
                if (this._webWorker) {
                  this._webWorker.terminate();
                  this._webWorker = null;
                }
                (_a4 = __privateGet(_PDFWorker, _workerPorts)) == null ? void 0 : _a4.delete(this._port);
                this._port = null;
                if (this._messageHandler) {
                  this._messageHandler.destroy();
                  this._messageHandler = null;
                }
              }
              static fromPort(params2) {
                var _a4;
                if (!(params2 == null ? void 0 : params2.port)) {
                  throw new Error("PDFWorker.fromPort - invalid method signature.");
                }
                const cachedPort = (_a4 = __privateGet(this, _workerPorts)) == null ? void 0 : _a4.get(params2.port);
                if (cachedPort) {
                  if (cachedPort._pendingDestroy) {
                    throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                  }
                  return cachedPort;
                }
                return new _PDFWorker(params2);
              }
              static get workerSrc() {
                if (_worker_options.GlobalWorkerOptions.workerSrc) {
                  return _worker_options.GlobalWorkerOptions.workerSrc;
                }
                if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                  if (!_util.isNodeJS) {
                    (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                  }
                  return PDFWorkerUtil.fallbackWorkerSrc;
                }
                throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
              }
              static get _mainThreadWorkerMessageHandler() {
                var _a4;
                try {
                  return ((_a4 = globalThis.pdfjsWorker) == null ? void 0 : _a4.WorkerMessageHandler) || null;
                } catch {
                  return null;
                }
              }
              static get _setupFakeWorkerGlobal() {
                const loader = async () => {
                  const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                  if (mainWorkerMessageHandler) {
                    return mainWorkerMessageHandler;
                  }
                  if (_util.isNodeJS && typeof commonjsRequire === "function") {
                    const worker = eval("require")(this.workerSrc);
                    return worker.WorkerMessageHandler;
                  }
                  await (0, _display_utils.loadScript)(this.workerSrc);
                  return window.pdfjsWorker.WorkerMessageHandler;
                };
                return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
              }
            };
            let PDFWorker = _PDFWorker;
            _workerPorts = new WeakMap();
            __privateAdd(PDFWorker, _workerPorts, void 0);
            exports.PDFWorker = PDFWorker;
            class WorkerTransport {
              constructor(messageHandler, loadingTask, networkStream, params2, factory) {
                __privateAdd(this, _cacheSimpleMethod);
                __privateAdd(this, _methodPromises, /* @__PURE__ */ new Map());
                __privateAdd(this, _pageCache, /* @__PURE__ */ new Map());
                __privateAdd(this, _pagePromises, /* @__PURE__ */ new Map());
                __privateAdd(this, _passwordCapability, null);
                this.messageHandler = messageHandler;
                this.loadingTask = loadingTask;
                this.commonObjs = new PDFObjects();
                this.fontLoader = new _font_loader.FontLoader({
                  ownerDocument: params2.ownerDocument,
                  styleElement: params2.styleElement
                });
                this._params = params2;
                this.canvasFactory = factory.canvasFactory;
                this.filterFactory = factory.filterFactory;
                this.cMapReaderFactory = factory.cMapReaderFactory;
                this.standardFontDataFactory = factory.standardFontDataFactory;
                this.destroyed = false;
                this.destroyCapability = null;
                this._networkStream = networkStream;
                this._fullReader = null;
                this._lastProgress = null;
                this.downloadInfoCapability = new _util.PromiseCapability();
                this.setupMessageHandler();
              }
              get annotationStorage() {
                return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
              }
              getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                switch (intent) {
                  case "any":
                    renderingIntent = _util.RenderingIntentFlag.ANY;
                    break;
                  case "display":
                    break;
                  case "print":
                    renderingIntent = _util.RenderingIntentFlag.PRINT;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                }
                switch (annotationMode) {
                  case _util.AnnotationMode.DISABLE:
                    renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                    break;
                  case _util.AnnotationMode.ENABLE:
                    break;
                  case _util.AnnotationMode.ENABLE_FORMS:
                    renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                    break;
                  case _util.AnnotationMode.ENABLE_STORAGE:
                    renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                    const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                    annotationStorageSerializable = annotationStorage.serializable;
                    break;
                  default:
                    (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                }
                if (isOpList) {
                  renderingIntent += _util.RenderingIntentFlag.OPLIST;
                }
                return {
                  renderingIntent,
                  cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                  annotationStorageSerializable
                };
              }
              destroy() {
                var _a4;
                if (this.destroyCapability) {
                  return this.destroyCapability.promise;
                }
                this.destroyed = true;
                this.destroyCapability = new _util.PromiseCapability();
                (_a4 = __privateGet(this, _passwordCapability)) == null ? void 0 : _a4.reject(new Error("Worker was destroyed during onPassword callback"));
                const waitOn = [];
                for (const page of __privateGet(this, _pageCache).values()) {
                  waitOn.push(page._destroy());
                }
                __privateGet(this, _pageCache).clear();
                __privateGet(this, _pagePromises).clear();
                if (this.hasOwnProperty("annotationStorage")) {
                  this.annotationStorage.resetModified();
                }
                const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                waitOn.push(terminated);
                Promise.all(waitOn).then(() => {
                  var _a5;
                  this.commonObjs.clear();
                  this.fontLoader.clear();
                  __privateGet(this, _methodPromises).clear();
                  this.filterFactory.destroy();
                  (_a5 = this._networkStream) == null ? void 0 : _a5.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                  if (this.messageHandler) {
                    this.messageHandler.destroy();
                    this.messageHandler = null;
                  }
                  this.destroyCapability.resolve();
                }, this.destroyCapability.reject);
                return this.destroyCapability.promise;
              }
              setupMessageHandler() {
                const {
                  messageHandler,
                  loadingTask
                } = this;
                messageHandler.on("GetReader", (data2, sink) => {
                  (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                  this._fullReader = this._networkStream.getFullReader();
                  this._fullReader.onProgress = (evt) => {
                    this._lastProgress = {
                      loaded: evt.loaded,
                      total: evt.total
                    };
                  };
                  sink.onPull = () => {
                    this._fullReader.read().then(function({
                      value,
                      done
                    }) {
                      if (done) {
                        sink.close();
                        return;
                      }
                      (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                      sink.enqueue(new Uint8Array(value), 1, [value]);
                    }).catch((reason) => {
                      sink.error(reason);
                    });
                  };
                  sink.onCancel = (reason) => {
                    this._fullReader.cancel(reason);
                    sink.ready.catch((readyReason) => {
                      if (this.destroyed) {
                        return;
                      }
                      throw readyReason;
                    });
                  };
                });
                messageHandler.on("ReaderHeadersReady", (data2) => {
                  const headersCapability = new _util.PromiseCapability();
                  const fullReader = this._fullReader;
                  fullReader.headersReady.then(() => {
                    var _a4;
                    if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                      if (this._lastProgress) {
                        (_a4 = loadingTask.onProgress) == null ? void 0 : _a4.call(loadingTask, this._lastProgress);
                      }
                      fullReader.onProgress = (evt) => {
                        var _a5;
                        (_a5 = loadingTask.onProgress) == null ? void 0 : _a5.call(loadingTask, {
                          loaded: evt.loaded,
                          total: evt.total
                        });
                      };
                    }
                    headersCapability.resolve({
                      isStreamingSupported: fullReader.isStreamingSupported,
                      isRangeSupported: fullReader.isRangeSupported,
                      contentLength: fullReader.contentLength
                    });
                  }, headersCapability.reject);
                  return headersCapability.promise;
                });
                messageHandler.on("GetRangeReader", (data2, sink) => {
                  (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                  const rangeReader = this._networkStream.getRangeReader(data2.begin, data2.end);
                  if (!rangeReader) {
                    sink.close();
                    return;
                  }
                  sink.onPull = () => {
                    rangeReader.read().then(function({
                      value,
                      done
                    }) {
                      if (done) {
                        sink.close();
                        return;
                      }
                      (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                      sink.enqueue(new Uint8Array(value), 1, [value]);
                    }).catch((reason) => {
                      sink.error(reason);
                    });
                  };
                  sink.onCancel = (reason) => {
                    rangeReader.cancel(reason);
                    sink.ready.catch((readyReason) => {
                      if (this.destroyed) {
                        return;
                      }
                      throw readyReason;
                    });
                  };
                });
                messageHandler.on("GetDoc", ({
                  pdfInfo
                }) => {
                  this._numPages = pdfInfo.numPages;
                  this._htmlForXfa = pdfInfo.htmlForXfa;
                  delete pdfInfo.htmlForXfa;
                  loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                });
                messageHandler.on("DocException", function(ex) {
                  let reason;
                  switch (ex.name) {
                    case "PasswordException":
                      reason = new _util.PasswordException(ex.message, ex.code);
                      break;
                    case "InvalidPDFException":
                      reason = new _util.InvalidPDFException(ex.message);
                      break;
                    case "MissingPDFException":
                      reason = new _util.MissingPDFException(ex.message);
                      break;
                    case "UnexpectedResponseException":
                      reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                      break;
                    case "UnknownErrorException":
                      reason = new _util.UnknownErrorException(ex.message, ex.details);
                      break;
                    default:
                      (0, _util.unreachable)("DocException - expected a valid Error.");
                  }
                  loadingTask._capability.reject(reason);
                });
                messageHandler.on("PasswordRequest", (exception) => {
                  __privateSet(this, _passwordCapability, new _util.PromiseCapability());
                  if (loadingTask.onPassword) {
                    const updatePassword = (password) => {
                      if (password instanceof Error) {
                        __privateGet(this, _passwordCapability).reject(password);
                      } else {
                        __privateGet(this, _passwordCapability).resolve({
                          password
                        });
                      }
                    };
                    try {
                      loadingTask.onPassword(updatePassword, exception.code);
                    } catch (ex) {
                      __privateGet(this, _passwordCapability).reject(ex);
                    }
                  } else {
                    __privateGet(this, _passwordCapability).reject(new _util.PasswordException(exception.message, exception.code));
                  }
                  return __privateGet(this, _passwordCapability).promise;
                });
                messageHandler.on("DataLoaded", (data2) => {
                  var _a4;
                  (_a4 = loadingTask.onProgress) == null ? void 0 : _a4.call(loadingTask, {
                    loaded: data2.length,
                    total: data2.length
                  });
                  this.downloadInfoCapability.resolve(data2);
                });
                messageHandler.on("StartRenderPage", (data2) => {
                  if (this.destroyed) {
                    return;
                  }
                  const page = __privateGet(this, _pageCache).get(data2.pageIndex);
                  page._startRenderPage(data2.transparency, data2.cacheKey);
                });
                messageHandler.on("commonobj", ([id, type, exportedData]) => {
                  var _a4;
                  if (this.destroyed) {
                    return;
                  }
                  if (this.commonObjs.has(id)) {
                    return;
                  }
                  switch (type) {
                    case "Font":
                      const params2 = this._params;
                      if ("error" in exportedData) {
                        const exportedError = exportedData.error;
                        (0, _util.warn)(`Error during font loading: ${exportedError}`);
                        this.commonObjs.resolve(id, exportedError);
                        break;
                      }
                      const inspectFont = params2.pdfBug && ((_a4 = globalThis.FontInspector) == null ? void 0 : _a4.enabled) ? (font2, url2) => globalThis.FontInspector.fontAdded(font2, url2) : null;
                      const font = new _font_loader.FontFaceObject(exportedData, {
                        isEvalSupported: params2.isEvalSupported,
                        disableFontFace: params2.disableFontFace,
                        ignoreErrors: params2.ignoreErrors,
                        inspectFont
                      });
                      this.fontLoader.bind(font).catch((reason) => {
                        return messageHandler.sendWithPromise("FontFallback", {
                          id
                        });
                      }).finally(() => {
                        if (!params2.fontExtraProperties && font.data) {
                          font.data = null;
                        }
                        this.commonObjs.resolve(id, font);
                      });
                      break;
                    case "FontPath":
                    case "Image":
                    case "Pattern":
                      this.commonObjs.resolve(id, exportedData);
                      break;
                    default:
                      throw new Error(`Got unknown common object type ${type}`);
                  }
                });
                messageHandler.on("obj", ([id, pageIndex, type, imageData]) => {
                  var _a4;
                  if (this.destroyed) {
                    return;
                  }
                  const pageProxy = __privateGet(this, _pageCache).get(pageIndex);
                  if (pageProxy.objs.has(id)) {
                    return;
                  }
                  switch (type) {
                    case "Image":
                      pageProxy.objs.resolve(id, imageData);
                      if (imageData) {
                        let length2;
                        if (imageData.bitmap) {
                          const {
                            width,
                            height
                          } = imageData;
                          length2 = width * height * 4;
                        } else {
                          length2 = ((_a4 = imageData.data) == null ? void 0 : _a4.length) || 0;
                        }
                        if (length2 > _util.MAX_IMAGE_SIZE_TO_CACHE) {
                          pageProxy._maybeCleanupAfterRender = true;
                        }
                      }
                      break;
                    case "Pattern":
                      pageProxy.objs.resolve(id, imageData);
                      break;
                    default:
                      throw new Error(`Got unknown object type ${type}`);
                  }
                });
                messageHandler.on("DocProgress", (data2) => {
                  var _a4;
                  if (this.destroyed) {
                    return;
                  }
                  (_a4 = loadingTask.onProgress) == null ? void 0 : _a4.call(loadingTask, {
                    loaded: data2.loaded,
                    total: data2.total
                  });
                });
                messageHandler.on("FetchBuiltInCMap", (data2) => {
                  if (this.destroyed) {
                    return Promise.reject(new Error("Worker was destroyed."));
                  }
                  if (!this.cMapReaderFactory) {
                    return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                  }
                  return this.cMapReaderFactory.fetch(data2);
                });
                messageHandler.on("FetchStandardFontData", (data2) => {
                  if (this.destroyed) {
                    return Promise.reject(new Error("Worker was destroyed."));
                  }
                  if (!this.standardFontDataFactory) {
                    return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                  }
                  return this.standardFontDataFactory.fetch(data2);
                });
              }
              getData() {
                return this.messageHandler.sendWithPromise("GetData", null);
              }
              saveDocument() {
                var _a4;
                if (this.annotationStorage.size <= 0) {
                  (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                }
                const {
                  map: map5,
                  transfers
                } = this.annotationStorage.serializable;
                return this.messageHandler.sendWithPromise("SaveDocument", {
                  isPureXfa: !!this._htmlForXfa,
                  numPages: this._numPages,
                  annotationStorage: map5,
                  filename: ((_a4 = this._fullReader) == null ? void 0 : _a4.filename) ?? null
                }, transfers).finally(() => {
                  this.annotationStorage.resetModified();
                });
              }
              getPage(pageNumber) {
                if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
                  return Promise.reject(new Error("Invalid page request."));
                }
                const pageIndex = pageNumber - 1, cachedPromise = __privateGet(this, _pagePromises).get(pageIndex);
                if (cachedPromise) {
                  return cachedPromise;
                }
                const promise = this.messageHandler.sendWithPromise("GetPage", {
                  pageIndex
                }).then((pageInfo) => {
                  if (this.destroyed) {
                    throw new Error("Transport destroyed");
                  }
                  const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                  __privateGet(this, _pageCache).set(pageIndex, page);
                  return page;
                });
                __privateGet(this, _pagePromises).set(pageIndex, promise);
                return promise;
              }
              getPageIndex(ref) {
                if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) {
                  return Promise.reject(new Error("Invalid pageIndex request."));
                }
                return this.messageHandler.sendWithPromise("GetPageIndex", {
                  num: ref.num,
                  gen: ref.gen
                });
              }
              getAnnotations(pageIndex, intent) {
                return this.messageHandler.sendWithPromise("GetAnnotations", {
                  pageIndex,
                  intent
                });
              }
              getFieldObjects() {
                return __privateMethod(this, _cacheSimpleMethod, cacheSimpleMethod_fn).call(this, "GetFieldObjects");
              }
              hasJSActions() {
                return __privateMethod(this, _cacheSimpleMethod, cacheSimpleMethod_fn).call(this, "HasJSActions");
              }
              getCalculationOrderIds() {
                return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
              }
              getDestinations() {
                return this.messageHandler.sendWithPromise("GetDestinations", null);
              }
              getDestination(id) {
                if (typeof id !== "string") {
                  return Promise.reject(new Error("Invalid destination request."));
                }
                return this.messageHandler.sendWithPromise("GetDestination", {
                  id
                });
              }
              getPageLabels() {
                return this.messageHandler.sendWithPromise("GetPageLabels", null);
              }
              getPageLayout() {
                return this.messageHandler.sendWithPromise("GetPageLayout", null);
              }
              getPageMode() {
                return this.messageHandler.sendWithPromise("GetPageMode", null);
              }
              getViewerPreferences() {
                return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
              }
              getOpenAction() {
                return this.messageHandler.sendWithPromise("GetOpenAction", null);
              }
              getAttachments() {
                return this.messageHandler.sendWithPromise("GetAttachments", null);
              }
              getDocJSActions() {
                return __privateMethod(this, _cacheSimpleMethod, cacheSimpleMethod_fn).call(this, "GetDocJSActions");
              }
              getPageJSActions(pageIndex) {
                return this.messageHandler.sendWithPromise("GetPageJSActions", {
                  pageIndex
                });
              }
              getStructTree(pageIndex) {
                return this.messageHandler.sendWithPromise("GetStructTree", {
                  pageIndex
                });
              }
              getOutline() {
                return this.messageHandler.sendWithPromise("GetOutline", null);
              }
              getOptionalContentConfig() {
                return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results) => {
                  return new _optional_content_config.OptionalContentConfig(results);
                });
              }
              getPermissions() {
                return this.messageHandler.sendWithPromise("GetPermissions", null);
              }
              getMetadata() {
                const name2 = "GetMetadata", cachedPromise = __privateGet(this, _methodPromises).get(name2);
                if (cachedPromise) {
                  return cachedPromise;
                }
                const promise = this.messageHandler.sendWithPromise(name2, null).then((results) => {
                  var _a4, _b3;
                  return {
                    info: results[0],
                    metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                    contentDispositionFilename: ((_a4 = this._fullReader) == null ? void 0 : _a4.filename) ?? null,
                    contentLength: ((_b3 = this._fullReader) == null ? void 0 : _b3.contentLength) ?? null
                  };
                });
                __privateGet(this, _methodPromises).set(name2, promise);
                return promise;
              }
              getMarkInfo() {
                return this.messageHandler.sendWithPromise("GetMarkInfo", null);
              }
              async startCleanup(keepLoadedFonts = false) {
                if (this.destroyed) {
                  return;
                }
                await this.messageHandler.sendWithPromise("Cleanup", null);
                for (const page of __privateGet(this, _pageCache).values()) {
                  const cleanupSuccessful = page.cleanup();
                  if (!cleanupSuccessful) {
                    throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                  }
                }
                this.commonObjs.clear();
                if (!keepLoadedFonts) {
                  this.fontLoader.clear();
                }
                __privateGet(this, _methodPromises).clear();
                this.filterFactory.destroy(true);
              }
              get loadingParams() {
                const {
                  disableAutoFetch,
                  enableXfa
                } = this._params;
                return (0, _util.shadow)(this, "loadingParams", {
                  disableAutoFetch,
                  enableXfa
                });
              }
            }
            _methodPromises = new WeakMap();
            _pageCache = new WeakMap();
            _pagePromises = new WeakMap();
            _passwordCapability = new WeakMap();
            _cacheSimpleMethod = new WeakSet();
            cacheSimpleMethod_fn = function(name2, data2 = null) {
              const cachedPromise = __privateGet(this, _methodPromises).get(name2);
              if (cachedPromise) {
                return cachedPromise;
              }
              const promise = this.messageHandler.sendWithPromise(name2, data2);
              __privateGet(this, _methodPromises).set(name2, promise);
              return promise;
            };
            class PDFObjects {
              constructor() {
                __privateAdd(this, _ensureObj);
                __privateAdd(this, _objs, /* @__PURE__ */ Object.create(null));
              }
              get(objId, callback = null) {
                if (callback) {
                  const obj2 = __privateMethod(this, _ensureObj, ensureObj_fn).call(this, objId);
                  obj2.capability.promise.then(() => callback(obj2.data));
                  return null;
                }
                const obj = __privateGet(this, _objs)[objId];
                if (!(obj == null ? void 0 : obj.capability.settled)) {
                  throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                }
                return obj.data;
              }
              has(objId) {
                const obj = __privateGet(this, _objs)[objId];
                return (obj == null ? void 0 : obj.capability.settled) || false;
              }
              resolve(objId, data2 = null) {
                const obj = __privateMethod(this, _ensureObj, ensureObj_fn).call(this, objId);
                obj.data = data2;
                obj.capability.resolve();
              }
              clear() {
                var _a4;
                for (const objId in __privateGet(this, _objs)) {
                  const {
                    data: data2
                  } = __privateGet(this, _objs)[objId];
                  (_a4 = data2 == null ? void 0 : data2.bitmap) == null ? void 0 : _a4.close();
                }
                __privateSet(this, _objs, /* @__PURE__ */ Object.create(null));
              }
            }
            _objs = new WeakMap();
            _ensureObj = new WeakSet();
            ensureObj_fn = function(objId) {
              var _a4;
              return (_a4 = __privateGet(this, _objs))[objId] || (_a4[objId] = {
                capability: new _util.PromiseCapability(),
                data: null
              });
            };
            class RenderTask {
              constructor(internalRenderTask) {
                __privateAdd(this, _internalRenderTask, null);
                __privateSet(this, _internalRenderTask, internalRenderTask);
                this.onContinue = null;
              }
              get promise() {
                return __privateGet(this, _internalRenderTask).capability.promise;
              }
              cancel(extraDelay = 0) {
                __privateGet(this, _internalRenderTask).cancel(null, extraDelay);
              }
              get separateAnnots() {
                const {
                  separateAnnots
                } = __privateGet(this, _internalRenderTask).operatorList;
                if (!separateAnnots) {
                  return false;
                }
                const {
                  annotationCanvasMap
                } = __privateGet(this, _internalRenderTask);
                return separateAnnots.form || separateAnnots.canvas && (annotationCanvasMap == null ? void 0 : annotationCanvasMap.size) > 0;
              }
            }
            _internalRenderTask = new WeakMap();
            exports.RenderTask = RenderTask;
            const _InternalRenderTask = class {
              constructor({
                callback,
                params: params2,
                objs,
                commonObjs,
                annotationCanvasMap,
                operatorList,
                pageIndex,
                canvasFactory,
                filterFactory,
                useRequestAnimationFrame = false,
                pdfBug = false,
                pageColors = null
              }) {
                this.callback = callback;
                this.params = params2;
                this.objs = objs;
                this.commonObjs = commonObjs;
                this.annotationCanvasMap = annotationCanvasMap;
                this.operatorListIdx = null;
                this.operatorList = operatorList;
                this._pageIndex = pageIndex;
                this.canvasFactory = canvasFactory;
                this.filterFactory = filterFactory;
                this._pdfBug = pdfBug;
                this.pageColors = pageColors;
                this.running = false;
                this.graphicsReadyCallback = null;
                this.graphicsReady = false;
                this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                this.cancelled = false;
                this.capability = new _util.PromiseCapability();
                this.task = new RenderTask(this);
                this._cancelBound = this.cancel.bind(this);
                this._continueBound = this._continue.bind(this);
                this._scheduleNextBound = this._scheduleNext.bind(this);
                this._nextBound = this._next.bind(this);
                this._canvas = params2.canvasContext.canvas;
              }
              get completed() {
                return this.capability.promise.catch(function() {
                });
              }
              initializeGraphics({
                transparency = false,
                optionalContentConfig
              }) {
                var _a4, _b3;
                if (this.cancelled) {
                  return;
                }
                if (this._canvas) {
                  if (__privateGet(_InternalRenderTask, _canvasInUse).has(this._canvas)) {
                    throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                  }
                  __privateGet(_InternalRenderTask, _canvasInUse).add(this._canvas);
                }
                if (this._pdfBug && ((_a4 = globalThis.StepperManager) == null ? void 0 : _a4.enabled)) {
                  this.stepper = globalThis.StepperManager.create(this._pageIndex);
                  this.stepper.init(this.operatorList);
                  this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                }
                const {
                  canvasContext,
                  viewport,
                  transform: transform4,
                  background
                } = this.params;
                this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                  optionalContentConfig
                }, this.annotationCanvasMap, this.pageColors);
                this.gfx.beginDrawing({
                  transform: transform4,
                  viewport,
                  transparency,
                  background
                });
                this.operatorListIdx = 0;
                this.graphicsReady = true;
                (_b3 = this.graphicsReadyCallback) == null ? void 0 : _b3.call(this);
              }
              cancel(error2 = null, extraDelay = 0) {
                var _a4;
                this.running = false;
                this.cancelled = true;
                (_a4 = this.gfx) == null ? void 0 : _a4.endDrawing();
                __privateGet(_InternalRenderTask, _canvasInUse).delete(this._canvas);
                this.callback(error2 || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
              }
              operatorListChanged() {
                var _a4;
                if (!this.graphicsReady) {
                  this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                  return;
                }
                (_a4 = this.stepper) == null ? void 0 : _a4.updateOperatorList(this.operatorList);
                if (this.running) {
                  return;
                }
                this._continue();
              }
              _continue() {
                this.running = true;
                if (this.cancelled) {
                  return;
                }
                if (this.task.onContinue) {
                  this.task.onContinue(this._scheduleNextBound);
                } else {
                  this._scheduleNext();
                }
              }
              _scheduleNext() {
                if (this._useRequestAnimationFrame) {
                  window.requestAnimationFrame(() => {
                    this._nextBound().catch(this._cancelBound);
                  });
                } else {
                  Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                }
              }
              async _next() {
                if (this.cancelled) {
                  return;
                }
                this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                if (this.operatorListIdx === this.operatorList.argsArray.length) {
                  this.running = false;
                  if (this.operatorList.lastChunk) {
                    this.gfx.endDrawing();
                    __privateGet(_InternalRenderTask, _canvasInUse).delete(this._canvas);
                    this.callback();
                  }
                }
              }
            };
            let InternalRenderTask = _InternalRenderTask;
            _canvasInUse = new WeakMap();
            __privateAdd(InternalRenderTask, _canvasInUse, /* @__PURE__ */ new WeakSet());
            const version = "3.11.174";
            exports.version = version;
            const build = "ce8716743";
            exports.build = build;
          },
          /* 3 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _modified, _storage, _setModified, setModified_fn, _serializable;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.SerializableEmpty = exports2.PrintAnnotationStorage = exports2.AnnotationStorage = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _editor = __w_pdfjs_require__2(4);
            var _murmurhash = __w_pdfjs_require__2(8);
            const SerializableEmpty = Object.freeze({
              map: null,
              hash: "",
              transfers: void 0
            });
            exports2.SerializableEmpty = SerializableEmpty;
            class AnnotationStorage {
              constructor() {
                __privateAdd(this, _setModified);
                __privateAdd(this, _modified, false);
                __privateAdd(this, _storage, /* @__PURE__ */ new Map());
                this.onSetModified = null;
                this.onResetModified = null;
                this.onAnnotationEditor = null;
              }
              getValue(key, defaultValue2) {
                const value = __privateGet(this, _storage).get(key);
                if (value === void 0) {
                  return defaultValue2;
                }
                return Object.assign(defaultValue2, value);
              }
              getRawValue(key) {
                return __privateGet(this, _storage).get(key);
              }
              remove(key) {
                __privateGet(this, _storage).delete(key);
                if (__privateGet(this, _storage).size === 0) {
                  this.resetModified();
                }
                if (typeof this.onAnnotationEditor === "function") {
                  for (const value of __privateGet(this, _storage).values()) {
                    if (value instanceof _editor.AnnotationEditor) {
                      return;
                    }
                  }
                  this.onAnnotationEditor(null);
                }
              }
              setValue(key, value) {
                const obj = __privateGet(this, _storage).get(key);
                let modified = false;
                if (obj !== void 0) {
                  for (const [entry, val] of Object.entries(value)) {
                    if (obj[entry] !== val) {
                      modified = true;
                      obj[entry] = val;
                    }
                  }
                } else {
                  modified = true;
                  __privateGet(this, _storage).set(key, value);
                }
                if (modified) {
                  __privateMethod(this, _setModified, setModified_fn).call(this);
                }
                if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") {
                  this.onAnnotationEditor(value.constructor._type);
                }
              }
              has(key) {
                return __privateGet(this, _storage).has(key);
              }
              getAll() {
                return __privateGet(this, _storage).size > 0 ? (0, _util2.objectFromMap)(__privateGet(this, _storage)) : null;
              }
              setAll(obj) {
                for (const [key, val] of Object.entries(obj)) {
                  this.setValue(key, val);
                }
              }
              get size() {
                return __privateGet(this, _storage).size;
              }
              resetModified() {
                if (__privateGet(this, _modified)) {
                  __privateSet(this, _modified, false);
                  if (typeof this.onResetModified === "function") {
                    this.onResetModified();
                  }
                }
              }
              get print() {
                return new PrintAnnotationStorage(this);
              }
              get serializable() {
                if (__privateGet(this, _storage).size === 0) {
                  return SerializableEmpty;
                }
                const map5 = /* @__PURE__ */ new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                const context2 = /* @__PURE__ */ Object.create(null);
                let hasBitmap = false;
                for (const [key, val] of __privateGet(this, _storage)) {
                  const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context2) : val;
                  if (serialized) {
                    map5.set(key, serialized);
                    hash.update(`${key}:${JSON.stringify(serialized)}`);
                    hasBitmap || (hasBitmap = !!serialized.bitmap);
                  }
                }
                if (hasBitmap) {
                  for (const value of map5.values()) {
                    if (value.bitmap) {
                      transfers.push(value.bitmap);
                    }
                  }
                }
                return map5.size > 0 ? {
                  map: map5,
                  hash: hash.hexdigest(),
                  transfers
                } : SerializableEmpty;
              }
            }
            _modified = new WeakMap();
            _storage = new WeakMap();
            _setModified = new WeakSet();
            setModified_fn = function() {
              if (!__privateGet(this, _modified)) {
                __privateSet(this, _modified, true);
                if (typeof this.onSetModified === "function") {
                  this.onSetModified();
                }
              }
            };
            exports2.AnnotationStorage = AnnotationStorage;
            class PrintAnnotationStorage extends AnnotationStorage {
              constructor(parent) {
                super();
                __privateAdd(this, _serializable, void 0);
                const {
                  map: map5,
                  hash,
                  transfers
                } = parent.serializable;
                const clone8 = structuredClone(map5, transfers ? {
                  transfer: transfers
                } : null);
                __privateSet(this, _serializable, {
                  map: clone8,
                  hash,
                  transfers
                });
              }
              get print() {
                (0, _util2.unreachable)("Should not call PrintAnnotationStorage.print");
              }
              get serializable() {
                return __privateGet(this, _serializable);
              }
            }
            _serializable = new WeakMap();
            exports2.PrintAnnotationStorage = PrintAnnotationStorage;
          },
          /* 4 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _altText, _altTextDecorative, _altTextButton, _altTextTooltip, _altTextTooltipTimeout, _keepAspectRatio, _resizersDiv, _boundFocusin, _boundFocusout, _hasBeenClicked, _isEditing, _isInEditMode, _isDraggable, _zIndex, _translate, translate_fn, _getBaseTranslation, getBaseTranslation_fn, _rotatePoint, rotatePoint_fn, _getRotationMatrix, getRotationMatrix_fn, _createResizers, createResizers_fn, _resizerPointerdown, resizerPointerdown_fn, _resizerPointermove, resizerPointermove_fn, _setAltTextButtonState, setAltTextButtonState_fn, _setUpDragSession, setUpDragSession_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.AnnotationEditor = void 0;
            var _tools = __w_pdfjs_require__2(5);
            var _util2 = __w_pdfjs_require__2(1);
            var _display_utils2 = __w_pdfjs_require__2(6);
            const _AnnotationEditor = class {
              constructor(parameters) {
                __privateAdd(this, _translate);
                __privateAdd(this, _getBaseTranslation);
                __privateAdd(this, _getRotationMatrix);
                __privateAdd(this, _createResizers);
                __privateAdd(this, _resizerPointerdown);
                __privateAdd(this, _resizerPointermove);
                __privateAdd(this, _setAltTextButtonState);
                __privateAdd(this, _setUpDragSession);
                __privateAdd(this, _altText, "");
                __privateAdd(this, _altTextDecorative, false);
                __privateAdd(this, _altTextButton, null);
                __privateAdd(this, _altTextTooltip, null);
                __privateAdd(this, _altTextTooltipTimeout, null);
                __privateAdd(this, _keepAspectRatio, false);
                __privateAdd(this, _resizersDiv, null);
                __privateAdd(this, _boundFocusin, this.focusin.bind(this));
                __privateAdd(this, _boundFocusout, this.focusout.bind(this));
                __privateAdd(this, _hasBeenClicked, false);
                __privateAdd(this, _isEditing, false);
                __privateAdd(this, _isInEditMode, false);
                __publicField2(this, "_initialOptions", /* @__PURE__ */ Object.create(null));
                __publicField2(this, "_uiManager", null);
                __publicField2(this, "_focusEventsAllowed", true);
                __publicField2(this, "_l10nPromise", null);
                __privateAdd(this, _isDraggable, false);
                __privateAdd(this, _zIndex, _AnnotationEditor._zIndex++);
                if (this.constructor === _AnnotationEditor) {
                  (0, _util2.unreachable)("Cannot initialize AnnotationEditor.");
                }
                this.parent = parameters.parent;
                this.id = parameters.id;
                this.width = this.height = null;
                this.pageIndex = parameters.parent.pageIndex;
                this.name = parameters.name;
                this.div = null;
                this._uiManager = parameters.uiManager;
                this.annotationElementId = null;
                this._willKeepAspectRatio = false;
                this._initialOptions.isCentered = parameters.isCentered;
                this._structTreeParentId = null;
                const {
                  rotation,
                  rawDims: {
                    pageWidth,
                    pageHeight,
                    pageX,
                    pageY
                  }
                } = this.parent.viewport;
                this.rotation = rotation;
                this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                this.pageDimensions = [pageWidth, pageHeight];
                this.pageTranslation = [pageX, pageY];
                const [width, height] = this.parentDimensions;
                this.x = parameters.x / width;
                this.y = parameters.y / height;
                this.isAttachedToDOM = false;
                this.deleted = false;
              }
              get editorType() {
                return Object.getPrototypeOf(this).constructor._type;
              }
              static get _defaultLineColor() {
                return (0, _util2.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
              }
              static deleteAnnotationElement(editor) {
                const fakeEditor = new FakeEditor({
                  id: editor.parent.getNextId(),
                  parent: editor.parent,
                  uiManager: editor._uiManager
                });
                fakeEditor.annotationElementId = editor.annotationElementId;
                fakeEditor.deleted = true;
                fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
              }
              static initialize(l10n, options2 = null) {
                _AnnotationEditor._l10nPromise || (_AnnotationEditor._l10nPromise = new Map(["editor_alt_text_button_label", "editor_alt_text_edit_button_label", "editor_alt_text_decorative_tooltip"].map((str) => [str, l10n.get(str)])));
                if (options2 == null ? void 0 : options2.strings) {
                  for (const str of options2.strings) {
                    _AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                  }
                }
                if (_AnnotationEditor._borderLineWidth !== -1) {
                  return;
                }
                const style2 = getComputedStyle(document.documentElement);
                _AnnotationEditor._borderLineWidth = parseFloat(style2.getPropertyValue("--outline-width")) || 0;
              }
              static updateDefaultParams(_type, _value) {
              }
              static get defaultPropertiesToUpdate() {
                return [];
              }
              static isHandlingMimeForPasting(mime) {
                return false;
              }
              static paste(item, parent) {
                (0, _util2.unreachable)("Not implemented");
              }
              get propertiesToUpdate() {
                return [];
              }
              get _isDraggable() {
                return __privateGet(this, _isDraggable);
              }
              set _isDraggable(value) {
                var _a3;
                __privateSet(this, _isDraggable, value);
                (_a3 = this.div) == null ? void 0 : _a3.classList.toggle("draggable", value);
              }
              center() {
                const [pageWidth, pageHeight] = this.pageDimensions;
                switch (this.parentRotation) {
                  case 90:
                    this.x -= this.height * pageHeight / (pageWidth * 2);
                    this.y += this.width * pageWidth / (pageHeight * 2);
                    break;
                  case 180:
                    this.x += this.width / 2;
                    this.y += this.height / 2;
                    break;
                  case 270:
                    this.x += this.height * pageHeight / (pageWidth * 2);
                    this.y -= this.width * pageWidth / (pageHeight * 2);
                    break;
                  default:
                    this.x -= this.width / 2;
                    this.y -= this.height / 2;
                    break;
                }
                this.fixAndSetPosition();
              }
              addCommands(params2) {
                this._uiManager.addCommands(params2);
              }
              get currentLayer() {
                return this._uiManager.currentLayer;
              }
              setInBackground() {
                this.div.style.zIndex = 0;
              }
              setInForeground() {
                this.div.style.zIndex = __privateGet(this, _zIndex);
              }
              setParent(parent) {
                if (parent !== null) {
                  this.pageIndex = parent.pageIndex;
                  this.pageDimensions = parent.pageDimensions;
                }
                this.parent = parent;
              }
              focusin(event) {
                if (!this._focusEventsAllowed) {
                  return;
                }
                if (!__privateGet(this, _hasBeenClicked)) {
                  this.parent.setSelected(this);
                } else {
                  __privateSet(this, _hasBeenClicked, false);
                }
              }
              focusout(event) {
                var _a3;
                if (!this._focusEventsAllowed) {
                  return;
                }
                if (!this.isAttachedToDOM) {
                  return;
                }
                const target = event.relatedTarget;
                if (target == null ? void 0 : target.closest(`#${this.id}`)) {
                  return;
                }
                event.preventDefault();
                if (!((_a3 = this.parent) == null ? void 0 : _a3.isMultipleSelection)) {
                  this.commitOrRemove();
                }
              }
              commitOrRemove() {
                if (this.isEmpty()) {
                  this.remove();
                } else {
                  this.commit();
                }
              }
              commit() {
                this.addToAnnotationStorage();
              }
              addToAnnotationStorage() {
                this._uiManager.addToAnnotationStorage(this);
              }
              setAt(x2, y2, tx, ty) {
                const [width, height] = this.parentDimensions;
                [tx, ty] = this.screenToPageTranslation(tx, ty);
                this.x = (x2 + tx) / width;
                this.y = (y2 + ty) / height;
                this.fixAndSetPosition();
              }
              translate(x2, y2) {
                __privateMethod(this, _translate, translate_fn).call(this, this.parentDimensions, x2, y2);
              }
              translateInPage(x2, y2) {
                __privateMethod(this, _translate, translate_fn).call(this, this.pageDimensions, x2, y2);
                this.div.scrollIntoView({
                  block: "nearest"
                });
              }
              drag(tx, ty) {
                const [parentWidth, parentHeight] = this.parentDimensions;
                this.x += tx / parentWidth;
                this.y += ty / parentHeight;
                if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                  const {
                    x: x3,
                    y: y3
                  } = this.div.getBoundingClientRect();
                  if (this.parent.findNewParent(this, x3, y3)) {
                    this.x -= Math.floor(this.x);
                    this.y -= Math.floor(this.y);
                  }
                }
                let {
                  x: x2,
                  y: y2
                } = this;
                const [bx2, by2] = __privateMethod(this, _getBaseTranslation, getBaseTranslation_fn).call(this);
                x2 += bx2;
                y2 += by2;
                this.div.style.left = `${(100 * x2).toFixed(2)}%`;
                this.div.style.top = `${(100 * y2).toFixed(2)}%`;
                this.div.scrollIntoView({
                  block: "nearest"
                });
              }
              fixAndSetPosition() {
                const [pageWidth, pageHeight] = this.pageDimensions;
                let {
                  x: x2,
                  y: y2,
                  width,
                  height
                } = this;
                width *= pageWidth;
                height *= pageHeight;
                x2 *= pageWidth;
                y2 *= pageHeight;
                switch (this.rotation) {
                  case 0:
                    x2 = Math.max(0, Math.min(pageWidth - width, x2));
                    y2 = Math.max(0, Math.min(pageHeight - height, y2));
                    break;
                  case 90:
                    x2 = Math.max(0, Math.min(pageWidth - height, x2));
                    y2 = Math.min(pageHeight, Math.max(width, y2));
                    break;
                  case 180:
                    x2 = Math.min(pageWidth, Math.max(width, x2));
                    y2 = Math.min(pageHeight, Math.max(height, y2));
                    break;
                  case 270:
                    x2 = Math.min(pageWidth, Math.max(height, x2));
                    y2 = Math.max(0, Math.min(pageHeight - width, y2));
                    break;
                }
                this.x = x2 /= pageWidth;
                this.y = y2 /= pageHeight;
                const [bx2, by2] = __privateMethod(this, _getBaseTranslation, getBaseTranslation_fn).call(this);
                x2 += bx2;
                y2 += by2;
                const {
                  style: style2
                } = this.div;
                style2.left = `${(100 * x2).toFixed(2)}%`;
                style2.top = `${(100 * y2).toFixed(2)}%`;
                this.moveInDOM();
              }
              screenToPageTranslation(x2, y2) {
                var _a3;
                return __privateMethod(_a3 = _AnnotationEditor, _rotatePoint, rotatePoint_fn).call(_a3, x2, y2, this.parentRotation);
              }
              pageTranslationToScreen(x2, y2) {
                var _a3;
                return __privateMethod(_a3 = _AnnotationEditor, _rotatePoint, rotatePoint_fn).call(_a3, x2, y2, 360 - this.parentRotation);
              }
              get parentScale() {
                return this._uiManager.viewParameters.realScale;
              }
              get parentRotation() {
                return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
              }
              get parentDimensions() {
                const {
                  parentScale,
                  pageDimensions: [pageWidth, pageHeight]
                } = this;
                const scaledWidth = pageWidth * parentScale;
                const scaledHeight = pageHeight * parentScale;
                return _util2.FeatureTest.isCSSRoundSupported ? [Math.round(scaledWidth), Math.round(scaledHeight)] : [scaledWidth, scaledHeight];
              }
              setDims(width, height) {
                var _a3;
                const [parentWidth, parentHeight] = this.parentDimensions;
                this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                if (!__privateGet(this, _keepAspectRatio)) {
                  this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                }
                (_a3 = __privateGet(this, _altTextButton)) == null ? void 0 : _a3.classList.toggle("small", width < _AnnotationEditor.SMALL_EDITOR_SIZE || height < _AnnotationEditor.SMALL_EDITOR_SIZE);
              }
              fixDims() {
                const {
                  style: style2
                } = this.div;
                const {
                  height,
                  width
                } = style2;
                const widthPercent = width.endsWith("%");
                const heightPercent = !__privateGet(this, _keepAspectRatio) && height.endsWith("%");
                if (widthPercent && heightPercent) {
                  return;
                }
                const [parentWidth, parentHeight] = this.parentDimensions;
                if (!widthPercent) {
                  style2.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                }
                if (!__privateGet(this, _keepAspectRatio) && !heightPercent) {
                  style2.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                }
              }
              getInitialTranslation() {
                return [0, 0];
              }
              async addAltTextButton() {
                if (__privateGet(this, _altTextButton)) {
                  return;
                }
                const altText = __privateSet(this, _altTextButton, document.createElement("button"));
                altText.className = "altText";
                const msg2 = await _AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                altText.textContent = msg2;
                altText.setAttribute("aria-label", msg2);
                altText.tabIndex = "0";
                altText.addEventListener("contextmenu", _display_utils2.noContextMenu);
                altText.addEventListener("pointerdown", (event) => event.stopPropagation());
                altText.addEventListener("click", (event) => {
                  event.preventDefault();
                  this._uiManager.editAltText(this);
                }, {
                  capture: true
                });
                altText.addEventListener("keydown", (event) => {
                  if (event.target === altText && event.key === "Enter") {
                    event.preventDefault();
                    this._uiManager.editAltText(this);
                  }
                });
                __privateMethod(this, _setAltTextButtonState, setAltTextButtonState_fn).call(this);
                this.div.append(altText);
                if (!_AnnotationEditor.SMALL_EDITOR_SIZE) {
                  const PERCENT = 40;
                  _AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                }
              }
              getClientDimensions() {
                return this.div.getBoundingClientRect();
              }
              get altTextData() {
                return {
                  altText: __privateGet(this, _altText),
                  decorative: __privateGet(this, _altTextDecorative)
                };
              }
              set altTextData({
                altText,
                decorative
              }) {
                if (__privateGet(this, _altText) === altText && __privateGet(this, _altTextDecorative) === decorative) {
                  return;
                }
                __privateSet(this, _altText, altText);
                __privateSet(this, _altTextDecorative, decorative);
                __privateMethod(this, _setAltTextButtonState, setAltTextButtonState_fn).call(this);
              }
              render() {
                this.div = document.createElement("div");
                this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                this.div.className = this.name;
                this.div.setAttribute("id", this.id);
                this.div.setAttribute("tabIndex", 0);
                this.setInForeground();
                this.div.addEventListener("focusin", __privateGet(this, _boundFocusin));
                this.div.addEventListener("focusout", __privateGet(this, _boundFocusout));
                const [parentWidth, parentHeight] = this.parentDimensions;
                if (this.parentRotation % 180 !== 0) {
                  this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                  this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                }
                const [tx, ty] = this.getInitialTranslation();
                this.translate(tx, ty);
                (0, _tools.bindEvents)(this, this.div, ["pointerdown"]);
                return this.div;
              }
              pointerdown(event) {
                const {
                  isMac
                } = _util2.FeatureTest.platform;
                if (event.button !== 0 || event.ctrlKey && isMac) {
                  event.preventDefault();
                  return;
                }
                __privateSet(this, _hasBeenClicked, true);
                __privateMethod(this, _setUpDragSession, setUpDragSession_fn).call(this, event);
              }
              moveInDOM() {
                var _a3;
                (_a3 = this.parent) == null ? void 0 : _a3.moveEditorInDOM(this);
              }
              _setParentAndPosition(parent, x2, y2) {
                parent.changeParent(this);
                this.x = x2;
                this.y = y2;
                this.fixAndSetPosition();
              }
              getRect(tx, ty) {
                const scale5 = this.parentScale;
                const [pageWidth, pageHeight] = this.pageDimensions;
                const [pageX, pageY] = this.pageTranslation;
                const shiftX = tx / scale5;
                const shiftY = ty / scale5;
                const x2 = this.x * pageWidth;
                const y2 = this.y * pageHeight;
                const width = this.width * pageWidth;
                const height = this.height * pageHeight;
                switch (this.rotation) {
                  case 0:
                    return [x2 + shiftX + pageX, pageHeight - y2 - shiftY - height + pageY, x2 + shiftX + width + pageX, pageHeight - y2 - shiftY + pageY];
                  case 90:
                    return [x2 + shiftY + pageX, pageHeight - y2 + shiftX + pageY, x2 + shiftY + height + pageX, pageHeight - y2 + shiftX + width + pageY];
                  case 180:
                    return [x2 - shiftX - width + pageX, pageHeight - y2 + shiftY + pageY, x2 - shiftX + pageX, pageHeight - y2 + shiftY + height + pageY];
                  case 270:
                    return [x2 - shiftY - height + pageX, pageHeight - y2 - shiftX - width + pageY, x2 - shiftY + pageX, pageHeight - y2 - shiftX + pageY];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              getRectInCurrentCoords(rect, pageHeight) {
                const [x12, y12, x2, y2] = rect;
                const width = x2 - x12;
                const height = y2 - y12;
                switch (this.rotation) {
                  case 0:
                    return [x12, pageHeight - y2, width, height];
                  case 90:
                    return [x12, pageHeight - y12, height, width];
                  case 180:
                    return [x2, pageHeight - y12, width, height];
                  case 270:
                    return [x2, pageHeight - y2, height, width];
                  default:
                    throw new Error("Invalid rotation");
                }
              }
              onceAdded() {
              }
              isEmpty() {
                return false;
              }
              enableEditMode() {
                __privateSet(this, _isInEditMode, true);
              }
              disableEditMode() {
                __privateSet(this, _isInEditMode, false);
              }
              isInEditMode() {
                return __privateGet(this, _isInEditMode);
              }
              shouldGetKeyboardEvents() {
                return false;
              }
              needsToBeRebuilt() {
                return this.div && !this.isAttachedToDOM;
              }
              rebuild() {
                var _a3, _b3;
                (_a3 = this.div) == null ? void 0 : _a3.addEventListener("focusin", __privateGet(this, _boundFocusin));
                (_b3 = this.div) == null ? void 0 : _b3.addEventListener("focusout", __privateGet(this, _boundFocusout));
              }
              serialize(isForCopying = false, context2 = null) {
                (0, _util2.unreachable)("An editor must be serializable");
              }
              static deserialize(data2, parent, uiManager) {
                const editor = new this.prototype.constructor({
                  parent,
                  id: parent.getNextId(),
                  uiManager
                });
                editor.rotation = data2.rotation;
                const [pageWidth, pageHeight] = editor.pageDimensions;
                const [x2, y2, width, height] = editor.getRectInCurrentCoords(data2.rect, pageHeight);
                editor.x = x2 / pageWidth;
                editor.y = y2 / pageHeight;
                editor.width = width / pageWidth;
                editor.height = height / pageHeight;
                return editor;
              }
              remove() {
                var _a3;
                this.div.removeEventListener("focusin", __privateGet(this, _boundFocusin));
                this.div.removeEventListener("focusout", __privateGet(this, _boundFocusout));
                if (!this.isEmpty()) {
                  this.commit();
                }
                if (this.parent) {
                  this.parent.remove(this);
                } else {
                  this._uiManager.removeEditor(this);
                }
                (_a3 = __privateGet(this, _altTextButton)) == null ? void 0 : _a3.remove();
                __privateSet(this, _altTextButton, null);
                __privateSet(this, _altTextTooltip, null);
              }
              get isResizable() {
                return false;
              }
              makeResizable() {
                if (this.isResizable) {
                  __privateMethod(this, _createResizers, createResizers_fn).call(this);
                  __privateGet(this, _resizersDiv).classList.remove("hidden");
                }
              }
              select() {
                var _a3;
                this.makeResizable();
                (_a3 = this.div) == null ? void 0 : _a3.classList.add("selectedEditor");
              }
              unselect() {
                var _a3, _b3, _c2;
                (_a3 = __privateGet(this, _resizersDiv)) == null ? void 0 : _a3.classList.add("hidden");
                (_b3 = this.div) == null ? void 0 : _b3.classList.remove("selectedEditor");
                if ((_c2 = this.div) == null ? void 0 : _c2.contains(document.activeElement)) {
                  this._uiManager.currentLayer.div.focus();
                }
              }
              updateParams(type, value) {
              }
              disableEditing() {
                if (__privateGet(this, _altTextButton)) {
                  __privateGet(this, _altTextButton).hidden = true;
                }
              }
              enableEditing() {
                if (__privateGet(this, _altTextButton)) {
                  __privateGet(this, _altTextButton).hidden = false;
                }
              }
              enterInEditMode() {
              }
              get contentDiv() {
                return this.div;
              }
              get isEditing() {
                return __privateGet(this, _isEditing);
              }
              set isEditing(value) {
                __privateSet(this, _isEditing, value);
                if (!this.parent) {
                  return;
                }
                if (value) {
                  this.parent.setSelected(this);
                  this.parent.setActiveEditor(this);
                } else {
                  this.parent.setActiveEditor(null);
                }
              }
              setAspectRatio(width, height) {
                __privateSet(this, _keepAspectRatio, true);
                const aspectRatio = width / height;
                const {
                  style: style2
                } = this.div;
                style2.aspectRatio = aspectRatio;
                style2.height = "auto";
              }
              static get MIN_SIZE() {
                return 16;
              }
            };
            let AnnotationEditor = _AnnotationEditor;
            _altText = new WeakMap();
            _altTextDecorative = new WeakMap();
            _altTextButton = new WeakMap();
            _altTextTooltip = new WeakMap();
            _altTextTooltipTimeout = new WeakMap();
            _keepAspectRatio = new WeakMap();
            _resizersDiv = new WeakMap();
            _boundFocusin = new WeakMap();
            _boundFocusout = new WeakMap();
            _hasBeenClicked = new WeakMap();
            _isEditing = new WeakMap();
            _isInEditMode = new WeakMap();
            _isDraggable = new WeakMap();
            _zIndex = new WeakMap();
            _translate = new WeakSet();
            translate_fn = function([width, height], x2, y2) {
              [x2, y2] = this.screenToPageTranslation(x2, y2);
              this.x += x2 / width;
              this.y += y2 / height;
              this.fixAndSetPosition();
            };
            _getBaseTranslation = new WeakSet();
            getBaseTranslation_fn = function() {
              const [parentWidth, parentHeight] = this.parentDimensions;
              const {
                _borderLineWidth
              } = _AnnotationEditor;
              const x2 = _borderLineWidth / parentWidth;
              const y2 = _borderLineWidth / parentHeight;
              switch (this.rotation) {
                case 90:
                  return [-x2, y2];
                case 180:
                  return [x2, y2];
                case 270:
                  return [x2, -y2];
                default:
                  return [-x2, -y2];
              }
            };
            _rotatePoint = new WeakSet();
            rotatePoint_fn = function(x2, y2, angle4) {
              switch (angle4) {
                case 90:
                  return [y2, -x2];
                case 180:
                  return [-x2, -y2];
                case 270:
                  return [-y2, x2];
                default:
                  return [x2, y2];
              }
            };
            _getRotationMatrix = new WeakSet();
            getRotationMatrix_fn = function(rotation) {
              switch (rotation) {
                case 90: {
                  const [pageWidth, pageHeight] = this.pageDimensions;
                  return [0, -pageWidth / pageHeight, pageHeight / pageWidth, 0];
                }
                case 180:
                  return [-1, 0, 0, -1];
                case 270: {
                  const [pageWidth, pageHeight] = this.pageDimensions;
                  return [0, pageWidth / pageHeight, -pageHeight / pageWidth, 0];
                }
                default:
                  return [1, 0, 0, 1];
              }
            };
            _createResizers = new WeakSet();
            createResizers_fn = function() {
              if (__privateGet(this, _resizersDiv)) {
                return;
              }
              __privateSet(this, _resizersDiv, document.createElement("div"));
              __privateGet(this, _resizersDiv).classList.add("resizers");
              const classes2 = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
              if (!this._willKeepAspectRatio) {
                classes2.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
              }
              for (const name2 of classes2) {
                const div = document.createElement("div");
                __privateGet(this, _resizersDiv).append(div);
                div.classList.add("resizer", name2);
                div.addEventListener("pointerdown", __privateMethod(this, _resizerPointerdown, resizerPointerdown_fn).bind(this, name2));
                div.addEventListener("contextmenu", _display_utils2.noContextMenu);
              }
              this.div.prepend(__privateGet(this, _resizersDiv));
            };
            _resizerPointerdown = new WeakSet();
            resizerPointerdown_fn = function(name2, event) {
              event.preventDefault();
              const {
                isMac
              } = _util2.FeatureTest.platform;
              if (event.button !== 0 || event.ctrlKey && isMac) {
                return;
              }
              const boundResizerPointermove = __privateMethod(this, _resizerPointermove, resizerPointermove_fn).bind(this, name2);
              const savedDraggable = this._isDraggable;
              this._isDraggable = false;
              const pointerMoveOptions = {
                passive: true,
                capture: true
              };
              window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
              const savedX = this.x;
              const savedY = this.y;
              const savedWidth = this.width;
              const savedHeight = this.height;
              const savedParentCursor = this.parent.div.style.cursor;
              const savedCursor = this.div.style.cursor;
              this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
              const pointerUpCallback = () => {
                this._isDraggable = savedDraggable;
                window.removeEventListener("pointerup", pointerUpCallback);
                window.removeEventListener("blur", pointerUpCallback);
                window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                this.parent.div.style.cursor = savedParentCursor;
                this.div.style.cursor = savedCursor;
                const newX = this.x;
                const newY = this.y;
                const newWidth = this.width;
                const newHeight = this.height;
                if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) {
                  return;
                }
                this.addCommands({
                  cmd: () => {
                    this.width = newWidth;
                    this.height = newHeight;
                    this.x = newX;
                    this.y = newY;
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                    this.fixAndSetPosition();
                  },
                  undo: () => {
                    this.width = savedWidth;
                    this.height = savedHeight;
                    this.x = savedX;
                    this.y = savedY;
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                    this.fixAndSetPosition();
                  },
                  mustExec: true
                });
              };
              window.addEventListener("pointerup", pointerUpCallback);
              window.addEventListener("blur", pointerUpCallback);
            };
            _resizerPointermove = new WeakSet();
            resizerPointermove_fn = function(name2, event) {
              const [parentWidth, parentHeight] = this.parentDimensions;
              const savedX = this.x;
              const savedY = this.y;
              const savedWidth = this.width;
              const savedHeight = this.height;
              const minWidth = _AnnotationEditor.MIN_SIZE / parentWidth;
              const minHeight = _AnnotationEditor.MIN_SIZE / parentHeight;
              const round2 = (x2) => Math.round(x2 * 1e4) / 1e4;
              const rotationMatrix = __privateMethod(this, _getRotationMatrix, getRotationMatrix_fn).call(this, this.rotation);
              const transf = (x2, y2) => [rotationMatrix[0] * x2 + rotationMatrix[2] * y2, rotationMatrix[1] * x2 + rotationMatrix[3] * y2];
              const invRotationMatrix = __privateMethod(this, _getRotationMatrix, getRotationMatrix_fn).call(this, 360 - this.rotation);
              const invTransf = (x2, y2) => [invRotationMatrix[0] * x2 + invRotationMatrix[2] * y2, invRotationMatrix[1] * x2 + invRotationMatrix[3] * y2];
              let getPoint;
              let getOpposite;
              let isDiagonal = false;
              let isHorizontal2 = false;
              switch (name2) {
                case "topLeft":
                  isDiagonal = true;
                  getPoint = (w2, h2) => [0, 0];
                  getOpposite = (w2, h2) => [w2, h2];
                  break;
                case "topMiddle":
                  getPoint = (w2, h2) => [w2 / 2, 0];
                  getOpposite = (w2, h2) => [w2 / 2, h2];
                  break;
                case "topRight":
                  isDiagonal = true;
                  getPoint = (w2, h2) => [w2, 0];
                  getOpposite = (w2, h2) => [0, h2];
                  break;
                case "middleRight":
                  isHorizontal2 = true;
                  getPoint = (w2, h2) => [w2, h2 / 2];
                  getOpposite = (w2, h2) => [0, h2 / 2];
                  break;
                case "bottomRight":
                  isDiagonal = true;
                  getPoint = (w2, h2) => [w2, h2];
                  getOpposite = (w2, h2) => [0, 0];
                  break;
                case "bottomMiddle":
                  getPoint = (w2, h2) => [w2 / 2, h2];
                  getOpposite = (w2, h2) => [w2 / 2, 0];
                  break;
                case "bottomLeft":
                  isDiagonal = true;
                  getPoint = (w2, h2) => [0, h2];
                  getOpposite = (w2, h2) => [w2, 0];
                  break;
                case "middleLeft":
                  isHorizontal2 = true;
                  getPoint = (w2, h2) => [0, h2 / 2];
                  getOpposite = (w2, h2) => [w2, h2 / 2];
                  break;
              }
              const point4 = getPoint(savedWidth, savedHeight);
              const oppositePoint = getOpposite(savedWidth, savedHeight);
              let transfOppositePoint = transf(...oppositePoint);
              const oppositeX = round2(savedX + transfOppositePoint[0]);
              const oppositeY = round2(savedY + transfOppositePoint[1]);
              let ratioX = 1;
              let ratioY = 1;
              let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
              [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
              if (isDiagonal) {
                const oldDiag = Math.hypot(savedWidth, savedHeight);
                ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point4[0] - deltaX, oppositePoint[1] - point4[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
              } else if (isHorizontal2) {
                ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point4[0] - deltaX))) / savedWidth;
              } else {
                ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point4[1] - deltaY))) / savedHeight;
              }
              const newWidth = round2(savedWidth * ratioX);
              const newHeight = round2(savedHeight * ratioY);
              transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
              const newX = oppositeX - transfOppositePoint[0];
              const newY = oppositeY - transfOppositePoint[1];
              this.width = newWidth;
              this.height = newHeight;
              this.x = newX;
              this.y = newY;
              this.setDims(parentWidth * newWidth, parentHeight * newHeight);
              this.fixAndSetPosition();
            };
            _setAltTextButtonState = new WeakSet();
            setAltTextButtonState_fn = async function() {
              var _a3;
              const button = __privateGet(this, _altTextButton);
              if (!button) {
                return;
              }
              if (!__privateGet(this, _altText) && !__privateGet(this, _altTextDecorative)) {
                button.classList.remove("done");
                (_a3 = __privateGet(this, _altTextTooltip)) == null ? void 0 : _a3.remove();
                return;
              }
              _AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg2) => {
                button.setAttribute("aria-label", msg2);
              });
              let tooltip = __privateGet(this, _altTextTooltip);
              if (!tooltip) {
                __privateSet(this, _altTextTooltip, tooltip = document.createElement("span"));
                tooltip.className = "tooltip";
                tooltip.setAttribute("role", "tooltip");
                const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                button.setAttribute("aria-describedby", id);
                const DELAY_TO_SHOW_TOOLTIP = 100;
                button.addEventListener("mouseenter", () => {
                  __privateSet(this, _altTextTooltipTimeout, setTimeout(() => {
                    __privateSet(this, _altTextTooltipTimeout, null);
                    __privateGet(this, _altTextTooltip).classList.add("show");
                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                      source: this,
                      details: {
                        type: "editing",
                        subtype: this.editorType,
                        data: {
                          action: "alt_text_tooltip"
                        }
                      }
                    });
                  }, DELAY_TO_SHOW_TOOLTIP));
                });
                button.addEventListener("mouseleave", () => {
                  var _a4;
                  clearTimeout(__privateGet(this, _altTextTooltipTimeout));
                  __privateSet(this, _altTextTooltipTimeout, null);
                  (_a4 = __privateGet(this, _altTextTooltip)) == null ? void 0 : _a4.classList.remove("show");
                });
              }
              button.classList.add("done");
              tooltip.innerText = __privateGet(this, _altTextDecorative) ? await _AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : __privateGet(this, _altText);
              if (!tooltip.parentNode) {
                button.append(tooltip);
              }
            };
            _setUpDragSession = new WeakSet();
            setUpDragSession_fn = function(event) {
              if (!this._isDraggable) {
                return;
              }
              const isSelected = this._uiManager.isSelected(this);
              this._uiManager.setUpDragSession();
              let pointerMoveOptions, pointerMoveCallback;
              if (isSelected) {
                pointerMoveOptions = {
                  passive: true,
                  capture: true
                };
                pointerMoveCallback = (e3) => {
                  const [tx, ty] = this.screenToPageTranslation(e3.movementX, e3.movementY);
                  this._uiManager.dragSelectedEditors(tx, ty);
                };
                window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
              }
              const pointerUpCallback = () => {
                window.removeEventListener("pointerup", pointerUpCallback);
                window.removeEventListener("blur", pointerUpCallback);
                if (isSelected) {
                  window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                }
                __privateSet(this, _hasBeenClicked, false);
                if (!this._uiManager.endDragSession()) {
                  const {
                    isMac
                  } = _util2.FeatureTest.platform;
                  if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) {
                    this.parent.toggleSelected(this);
                  } else {
                    this.parent.setSelected(this);
                  }
                }
              };
              window.addEventListener("pointerup", pointerUpCallback);
              window.addEventListener("blur", pointerUpCallback);
            };
            __privateAdd(AnnotationEditor, _rotatePoint);
            __publicField2(AnnotationEditor, "_borderLineWidth", -1);
            __publicField2(AnnotationEditor, "_colorManager", new _tools.ColorManager());
            __publicField2(AnnotationEditor, "_zIndex", 1);
            __publicField2(AnnotationEditor, "SMALL_EDITOR_SIZE", 0);
            exports2.AnnotationEditor = AnnotationEditor;
            class FakeEditor extends AnnotationEditor {
              constructor(params2) {
                super(params2);
                this.annotationElementId = params2.annotationElementId;
                this.deleted = true;
              }
              serialize() {
                return {
                  id: this.annotationElementId,
                  deleted: true,
                  pageIndex: this.pageIndex
                };
              }
            }
          },
          /* 5 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _id2, _baseId, _id3, _cache, _get, get_fn, _commands, _locked, _maxSize, _position2, _serialize, serialize_fn, _activeEditor, _allEditors, _allLayers, _altTextManager, _annotationStorage, _commandManager, _currentPageIndex, _deletedAnnotationsElementIds, _draggingEditors, _editorTypes, _editorsToRescale, _filterFactory, _idManager, _isEnabled, _isWaiting, _lastActiveElement, _mode, _selectedEditors, _pageColors, _boundBlur, _boundFocus, _boundCopy, _boundCut, _boundPaste, _boundKeydown, _boundOnEditingAction, _boundOnPageChanging, _boundOnScaleChanging, _boundOnRotationChanging, _previousStates, _translation, _translationTimeoutId, _container, _viewer, _addFocusManager, addFocusManager_fn, _removeFocusManager, removeFocusManager_fn, _addKeyboardManager, addKeyboardManager_fn, _removeKeyboardManager, removeKeyboardManager_fn, _addCopyPasteListeners, addCopyPasteListeners_fn, _removeCopyPasteListeners, removeCopyPasteListeners_fn, _dispatchUpdateStates, dispatchUpdateStates_fn, _dispatchUpdateUI, dispatchUpdateUI_fn, _enableAll, enableAll_fn, _disableAll, disableAll_fn, _addEditorToLayer, addEditorToLayer_fn, _isEmpty, isEmpty_fn, _selectEditors, selectEditors_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.KeyboardManager = exports2.CommandManager = exports2.ColorManager = exports2.AnnotationEditorUIManager = void 0;
            exports2.bindEvents = bindEvents;
            exports2.opacityToHex = opacityToHex;
            var _util2 = __w_pdfjs_require__2(1);
            var _display_utils2 = __w_pdfjs_require__2(6);
            function bindEvents(obj, element, names2) {
              for (const name2 of names2) {
                element.addEventListener(name2, obj[name2].bind(obj));
              }
            }
            function opacityToHex(opacity) {
              return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
            }
            class IdManager {
              constructor() {
                __privateAdd(this, _id2, 0);
              }
              getId() {
                return `${_util2.AnnotationEditorPrefix}${__privateWrapper(this, _id2)._++}`;
              }
            }
            _id2 = new WeakMap();
            const _ImageManager = class {
              constructor() {
                __privateAdd(this, _get);
                __privateAdd(this, _baseId, (0, _util2.getUuid)());
                __privateAdd(this, _id3, 0);
                __privateAdd(this, _cache, null);
              }
              static get _isSVGFittingCanvas() {
                const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                const canvas2 = new OffscreenCanvas(1, 3);
                const ctx2 = canvas2.getContext("2d");
                const image = new Image();
                image.src = svg;
                const promise = image.decode().then(() => {
                  ctx2.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                  return new Uint32Array(ctx2.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                });
                return (0, _util2.shadow)(this, "_isSVGFittingCanvas", promise);
              }
              async getFromFile(file2) {
                const {
                  lastModified,
                  name: name2,
                  size: size12,
                  type
                } = file2;
                return __privateMethod(this, _get, get_fn).call(this, `${lastModified}_${name2}_${size12}_${type}`, file2);
              }
              async getFromUrl(url2) {
                return __privateMethod(this, _get, get_fn).call(this, url2, url2);
              }
              async getFromId(id) {
                __privateGet(this, _cache) || __privateSet(this, _cache, /* @__PURE__ */ new Map());
                const data2 = __privateGet(this, _cache).get(id);
                if (!data2) {
                  return null;
                }
                if (data2.bitmap) {
                  data2.refCounter += 1;
                  return data2;
                }
                if (data2.file) {
                  return this.getFromFile(data2.file);
                }
                return this.getFromUrl(data2.url);
              }
              getSvgUrl(id) {
                const data2 = __privateGet(this, _cache).get(id);
                if (!(data2 == null ? void 0 : data2.isSvg)) {
                  return null;
                }
                return data2.svgUrl;
              }
              deleteId(id) {
                __privateGet(this, _cache) || __privateSet(this, _cache, /* @__PURE__ */ new Map());
                const data2 = __privateGet(this, _cache).get(id);
                if (!data2) {
                  return;
                }
                data2.refCounter -= 1;
                if (data2.refCounter !== 0) {
                  return;
                }
                data2.bitmap = null;
              }
              isValidId(id) {
                return id.startsWith(`image_${__privateGet(this, _baseId)}_`);
              }
            };
            let ImageManager = _ImageManager;
            _baseId = new WeakMap();
            _id3 = new WeakMap();
            _cache = new WeakMap();
            _get = new WeakSet();
            get_fn = async function(key, rawData) {
              __privateGet(this, _cache) || __privateSet(this, _cache, /* @__PURE__ */ new Map());
              let data2 = __privateGet(this, _cache).get(key);
              if (data2 === null) {
                return null;
              }
              if (data2 == null ? void 0 : data2.bitmap) {
                data2.refCounter += 1;
                return data2;
              }
              try {
                data2 || (data2 = {
                  bitmap: null,
                  id: `image_${__privateGet(this, _baseId)}_${__privateWrapper(this, _id3)._++}`,
                  refCounter: 0,
                  isSvg: false
                });
                let image;
                if (typeof rawData === "string") {
                  data2.url = rawData;
                  const response = await fetch(rawData);
                  if (!response.ok) {
                    throw new Error(response.statusText);
                  }
                  image = await response.blob();
                } else {
                  image = data2.file = rawData;
                }
                if (image.type === "image/svg+xml") {
                  const mustRemoveAspectRatioPromise = _ImageManager._isSVGFittingCanvas;
                  const fileReader = new FileReader();
                  const imageElement = new Image();
                  const imagePromise = new Promise((resolve2, reject) => {
                    imageElement.onload = () => {
                      data2.bitmap = imageElement;
                      data2.isSvg = true;
                      resolve2();
                    };
                    fileReader.onload = async () => {
                      const url2 = data2.svgUrl = fileReader.result;
                      imageElement.src = await mustRemoveAspectRatioPromise ? `${url2}#svgView(preserveAspectRatio(none))` : url2;
                    };
                    imageElement.onerror = fileReader.onerror = reject;
                  });
                  fileReader.readAsDataURL(image);
                  await imagePromise;
                } else {
                  data2.bitmap = await createImageBitmap(image);
                }
                data2.refCounter = 1;
              } catch (e3) {
                console.error(e3);
                data2 = null;
              }
              __privateGet(this, _cache).set(key, data2);
              if (data2) {
                __privateGet(this, _cache).set(data2.id, data2);
              }
              return data2;
            };
            class CommandManager {
              constructor(maxSize = 128) {
                __privateAdd(this, _commands, []);
                __privateAdd(this, _locked, false);
                __privateAdd(this, _maxSize, void 0);
                __privateAdd(this, _position2, -1);
                __privateSet(this, _maxSize, maxSize);
              }
              add({
                cmd: cmd2,
                undo,
                mustExec,
                type = NaN,
                overwriteIfSameType = false,
                keepUndo = false
              }) {
                if (mustExec) {
                  cmd2();
                }
                if (__privateGet(this, _locked)) {
                  return;
                }
                const save = {
                  cmd: cmd2,
                  undo,
                  type
                };
                if (__privateGet(this, _position2) === -1) {
                  if (__privateGet(this, _commands).length > 0) {
                    __privateGet(this, _commands).length = 0;
                  }
                  __privateSet(this, _position2, 0);
                  __privateGet(this, _commands).push(save);
                  return;
                }
                if (overwriteIfSameType && __privateGet(this, _commands)[__privateGet(this, _position2)].type === type) {
                  if (keepUndo) {
                    save.undo = __privateGet(this, _commands)[__privateGet(this, _position2)].undo;
                  }
                  __privateGet(this, _commands)[__privateGet(this, _position2)] = save;
                  return;
                }
                const next5 = __privateGet(this, _position2) + 1;
                if (next5 === __privateGet(this, _maxSize)) {
                  __privateGet(this, _commands).splice(0, 1);
                } else {
                  __privateSet(this, _position2, next5);
                  if (next5 < __privateGet(this, _commands).length) {
                    __privateGet(this, _commands).splice(next5);
                  }
                }
                __privateGet(this, _commands).push(save);
              }
              undo() {
                if (__privateGet(this, _position2) === -1) {
                  return;
                }
                __privateSet(this, _locked, true);
                __privateGet(this, _commands)[__privateGet(this, _position2)].undo();
                __privateSet(this, _locked, false);
                __privateSet(this, _position2, __privateGet(this, _position2) - 1);
              }
              redo() {
                if (__privateGet(this, _position2) < __privateGet(this, _commands).length - 1) {
                  __privateSet(this, _position2, __privateGet(this, _position2) + 1);
                  __privateSet(this, _locked, true);
                  __privateGet(this, _commands)[__privateGet(this, _position2)].cmd();
                  __privateSet(this, _locked, false);
                }
              }
              hasSomethingToUndo() {
                return __privateGet(this, _position2) !== -1;
              }
              hasSomethingToRedo() {
                return __privateGet(this, _position2) < __privateGet(this, _commands).length - 1;
              }
              destroy() {
                __privateSet(this, _commands, null);
              }
            }
            _commands = new WeakMap();
            _locked = new WeakMap();
            _maxSize = new WeakMap();
            _position2 = new WeakMap();
            exports2.CommandManager = CommandManager;
            class KeyboardManager {
              constructor(callbacks2) {
                __privateAdd(this, _serialize);
                this.buffer = [];
                this.callbacks = /* @__PURE__ */ new Map();
                this.allKeys = /* @__PURE__ */ new Set();
                const {
                  isMac
                } = _util2.FeatureTest.platform;
                for (const [keys4, callback, options2 = {}] of callbacks2) {
                  for (const key of keys4) {
                    const isMacKey = key.startsWith("mac+");
                    if (isMac && isMacKey) {
                      this.callbacks.set(key.slice(4), {
                        callback,
                        options: options2
                      });
                      this.allKeys.add(key.split("+").at(-1));
                    } else if (!isMac && !isMacKey) {
                      this.callbacks.set(key, {
                        callback,
                        options: options2
                      });
                      this.allKeys.add(key.split("+").at(-1));
                    }
                  }
                }
              }
              exec(self2, event) {
                if (!this.allKeys.has(event.key)) {
                  return;
                }
                const info = this.callbacks.get(__privateMethod(this, _serialize, serialize_fn).call(this, event));
                if (!info) {
                  return;
                }
                const {
                  callback,
                  options: {
                    bubbles = false,
                    args = [],
                    checker = null
                  }
                } = info;
                if (checker && !checker(self2, event)) {
                  return;
                }
                callback.bind(self2, ...args)();
                if (!bubbles) {
                  event.stopPropagation();
                  event.preventDefault();
                }
              }
            }
            _serialize = new WeakSet();
            serialize_fn = function(event) {
              if (event.altKey) {
                this.buffer.push("alt");
              }
              if (event.ctrlKey) {
                this.buffer.push("ctrl");
              }
              if (event.metaKey) {
                this.buffer.push("meta");
              }
              if (event.shiftKey) {
                this.buffer.push("shift");
              }
              this.buffer.push(event.key);
              const str = this.buffer.join("+");
              this.buffer.length = 0;
              return str;
            };
            exports2.KeyboardManager = KeyboardManager;
            const _ColorManager = class {
              get _colors() {
                const colors = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
                (0, _display_utils2.getColorValues)(colors);
                return (0, _util2.shadow)(this, "_colors", colors);
              }
              convert(color) {
                const rgb = (0, _display_utils2.getRGB)(color);
                if (!window.matchMedia("(forced-colors: active)").matches) {
                  return rgb;
                }
                for (const [name2, RGB] of this._colors) {
                  if (RGB.every((x2, i2) => x2 === rgb[i2])) {
                    return _ColorManager._colorsMapping.get(name2);
                  }
                }
                return rgb;
              }
              getHexCode(name2) {
                const rgb = this._colors.get(name2);
                if (!rgb) {
                  return name2;
                }
                return _util2.Util.makeHexColor(...rgb);
              }
            };
            let ColorManager = _ColorManager;
            __publicField2(ColorManager, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
            exports2.ColorManager = ColorManager;
            const _AnnotationEditorUIManager = class {
              constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors) {
                __privateAdd(this, _addFocusManager);
                __privateAdd(this, _removeFocusManager);
                __privateAdd(this, _addKeyboardManager);
                __privateAdd(this, _removeKeyboardManager);
                __privateAdd(this, _addCopyPasteListeners);
                __privateAdd(this, _removeCopyPasteListeners);
                __privateAdd(this, _dispatchUpdateStates);
                __privateAdd(this, _dispatchUpdateUI);
                __privateAdd(this, _enableAll);
                __privateAdd(this, _disableAll);
                __privateAdd(this, _addEditorToLayer);
                __privateAdd(this, _isEmpty);
                __privateAdd(this, _selectEditors);
                __privateAdd(this, _activeEditor, null);
                __privateAdd(this, _allEditors, /* @__PURE__ */ new Map());
                __privateAdd(this, _allLayers, /* @__PURE__ */ new Map());
                __privateAdd(this, _altTextManager, null);
                __privateAdd(this, _annotationStorage, null);
                __privateAdd(this, _commandManager, new CommandManager());
                __privateAdd(this, _currentPageIndex, 0);
                __privateAdd(this, _deletedAnnotationsElementIds, /* @__PURE__ */ new Set());
                __privateAdd(this, _draggingEditors, null);
                __privateAdd(this, _editorTypes, null);
                __privateAdd(this, _editorsToRescale, /* @__PURE__ */ new Set());
                __privateAdd(this, _filterFactory, null);
                __privateAdd(this, _idManager, new IdManager());
                __privateAdd(this, _isEnabled, false);
                __privateAdd(this, _isWaiting, false);
                __privateAdd(this, _lastActiveElement, null);
                __privateAdd(this, _mode, _util2.AnnotationEditorType.NONE);
                __privateAdd(this, _selectedEditors, /* @__PURE__ */ new Set());
                __privateAdd(this, _pageColors, null);
                __privateAdd(this, _boundBlur, this.blur.bind(this));
                __privateAdd(this, _boundFocus, this.focus.bind(this));
                __privateAdd(this, _boundCopy, this.copy.bind(this));
                __privateAdd(this, _boundCut, this.cut.bind(this));
                __privateAdd(this, _boundPaste, this.paste.bind(this));
                __privateAdd(this, _boundKeydown, this.keydown.bind(this));
                __privateAdd(this, _boundOnEditingAction, this.onEditingAction.bind(this));
                __privateAdd(this, _boundOnPageChanging, this.onPageChanging.bind(this));
                __privateAdd(this, _boundOnScaleChanging, this.onScaleChanging.bind(this));
                __privateAdd(this, _boundOnRotationChanging, this.onRotationChanging.bind(this));
                __privateAdd(this, _previousStates, {
                  isEditing: false,
                  isEmpty: true,
                  hasSomethingToUndo: false,
                  hasSomethingToRedo: false,
                  hasSelectedEditor: false
                });
                __privateAdd(this, _translation, [0, 0]);
                __privateAdd(this, _translationTimeoutId, null);
                __privateAdd(this, _container, null);
                __privateAdd(this, _viewer, null);
                __privateSet(this, _container, container);
                __privateSet(this, _viewer, viewer);
                __privateSet(this, _altTextManager, altTextManager);
                this._eventBus = eventBus;
                this._eventBus._on("editingaction", __privateGet(this, _boundOnEditingAction));
                this._eventBus._on("pagechanging", __privateGet(this, _boundOnPageChanging));
                this._eventBus._on("scalechanging", __privateGet(this, _boundOnScaleChanging));
                this._eventBus._on("rotationchanging", __privateGet(this, _boundOnRotationChanging));
                __privateSet(this, _annotationStorage, pdfDocument.annotationStorage);
                __privateSet(this, _filterFactory, pdfDocument.filterFactory);
                __privateSet(this, _pageColors, pageColors);
                this.viewParameters = {
                  realScale: _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS,
                  rotation: 0
                };
              }
              static get _keyboardManager() {
                const proto = _AnnotationEditorUIManager.prototype;
                const arrowChecker = (self2) => {
                  const {
                    activeElement
                  } = document;
                  return activeElement && __privateGet(self2, _container).contains(activeElement) && self2.hasSomethingToControl();
                };
                const small = this.TRANSLATE_SMALL;
                const big = this.TRANSLATE_BIG;
                return (0, _util2.shadow)(this, "_keyboardManager", new KeyboardManager([[["ctrl+a", "mac+meta+a"], proto.selectAll], [["ctrl+z", "mac+meta+z"], proto.undo], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], proto.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], proto.delete], [["Escape", "mac+Escape"], proto.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], proto.translateSelectedEditors, {
                  args: [-small, 0],
                  checker: arrowChecker
                }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto.translateSelectedEditors, {
                  args: [-big, 0],
                  checker: arrowChecker
                }], [["ArrowRight", "mac+ArrowRight"], proto.translateSelectedEditors, {
                  args: [small, 0],
                  checker: arrowChecker
                }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto.translateSelectedEditors, {
                  args: [big, 0],
                  checker: arrowChecker
                }], [["ArrowUp", "mac+ArrowUp"], proto.translateSelectedEditors, {
                  args: [0, -small],
                  checker: arrowChecker
                }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto.translateSelectedEditors, {
                  args: [0, -big],
                  checker: arrowChecker
                }], [["ArrowDown", "mac+ArrowDown"], proto.translateSelectedEditors, {
                  args: [0, small],
                  checker: arrowChecker
                }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto.translateSelectedEditors, {
                  args: [0, big],
                  checker: arrowChecker
                }]]));
              }
              destroy() {
                __privateMethod(this, _removeKeyboardManager, removeKeyboardManager_fn).call(this);
                __privateMethod(this, _removeFocusManager, removeFocusManager_fn).call(this);
                this._eventBus._off("editingaction", __privateGet(this, _boundOnEditingAction));
                this._eventBus._off("pagechanging", __privateGet(this, _boundOnPageChanging));
                this._eventBus._off("scalechanging", __privateGet(this, _boundOnScaleChanging));
                this._eventBus._off("rotationchanging", __privateGet(this, _boundOnRotationChanging));
                for (const layer of __privateGet(this, _allLayers).values()) {
                  layer.destroy();
                }
                __privateGet(this, _allLayers).clear();
                __privateGet(this, _allEditors).clear();
                __privateGet(this, _editorsToRescale).clear();
                __privateSet(this, _activeEditor, null);
                __privateGet(this, _selectedEditors).clear();
                __privateGet(this, _commandManager).destroy();
                __privateGet(this, _altTextManager).destroy();
              }
              get hcmFilter() {
                return (0, _util2.shadow)(this, "hcmFilter", __privateGet(this, _pageColors) ? __privateGet(this, _filterFactory).addHCMFilter(__privateGet(this, _pageColors).foreground, __privateGet(this, _pageColors).background) : "none");
              }
              get direction() {
                return (0, _util2.shadow)(this, "direction", getComputedStyle(__privateGet(this, _container)).direction);
              }
              editAltText(editor) {
                var _a3;
                (_a3 = __privateGet(this, _altTextManager)) == null ? void 0 : _a3.editAltText(this, editor);
              }
              onPageChanging({
                pageNumber
              }) {
                __privateSet(this, _currentPageIndex, pageNumber - 1);
              }
              focusMainContainer() {
                __privateGet(this, _container).focus();
              }
              findParent(x2, y2) {
                for (const layer of __privateGet(this, _allLayers).values()) {
                  const {
                    x: layerX,
                    y: layerY,
                    width,
                    height
                  } = layer.div.getBoundingClientRect();
                  if (x2 >= layerX && x2 <= layerX + width && y2 >= layerY && y2 <= layerY + height) {
                    return layer;
                  }
                }
                return null;
              }
              disableUserSelect(value = false) {
                __privateGet(this, _viewer).classList.toggle("noUserSelect", value);
              }
              addShouldRescale(editor) {
                __privateGet(this, _editorsToRescale).add(editor);
              }
              removeShouldRescale(editor) {
                __privateGet(this, _editorsToRescale).delete(editor);
              }
              onScaleChanging({
                scale: scale5
              }) {
                this.commitOrRemove();
                this.viewParameters.realScale = scale5 * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS;
                for (const editor of __privateGet(this, _editorsToRescale)) {
                  editor.onScaleChanging();
                }
              }
              onRotationChanging({
                pagesRotation
              }) {
                this.commitOrRemove();
                this.viewParameters.rotation = pagesRotation;
              }
              addToAnnotationStorage(editor) {
                if (!editor.isEmpty() && __privateGet(this, _annotationStorage) && !__privateGet(this, _annotationStorage).has(editor.id)) {
                  __privateGet(this, _annotationStorage).setValue(editor.id, editor);
                }
              }
              blur() {
                if (!this.hasSelection) {
                  return;
                }
                const {
                  activeElement
                } = document;
                for (const editor of __privateGet(this, _selectedEditors)) {
                  if (editor.div.contains(activeElement)) {
                    __privateSet(this, _lastActiveElement, [editor, activeElement]);
                    editor._focusEventsAllowed = false;
                    break;
                  }
                }
              }
              focus() {
                if (!__privateGet(this, _lastActiveElement)) {
                  return;
                }
                const [lastEditor, lastActiveElement] = __privateGet(this, _lastActiveElement);
                __privateSet(this, _lastActiveElement, null);
                lastActiveElement.addEventListener("focusin", () => {
                  lastEditor._focusEventsAllowed = true;
                }, {
                  once: true
                });
                lastActiveElement.focus();
              }
              addEditListeners() {
                __privateMethod(this, _addKeyboardManager, addKeyboardManager_fn).call(this);
                __privateMethod(this, _addCopyPasteListeners, addCopyPasteListeners_fn).call(this);
              }
              removeEditListeners() {
                __privateMethod(this, _removeKeyboardManager, removeKeyboardManager_fn).call(this);
                __privateMethod(this, _removeCopyPasteListeners, removeCopyPasteListeners_fn).call(this);
              }
              copy(event) {
                var _a3;
                event.preventDefault();
                (_a3 = __privateGet(this, _activeEditor)) == null ? void 0 : _a3.commitOrRemove();
                if (!this.hasSelection) {
                  return;
                }
                const editors = [];
                for (const editor of __privateGet(this, _selectedEditors)) {
                  const serialized = editor.serialize(true);
                  if (serialized) {
                    editors.push(serialized);
                  }
                }
                if (editors.length === 0) {
                  return;
                }
                event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
              }
              cut(event) {
                this.copy(event);
                this.delete();
              }
              paste(event) {
                event.preventDefault();
                const {
                  clipboardData
                } = event;
                for (const item of clipboardData.items) {
                  for (const editorType of __privateGet(this, _editorTypes)) {
                    if (editorType.isHandlingMimeForPasting(item.type)) {
                      editorType.paste(item, this.currentLayer);
                      return;
                    }
                  }
                }
                let data2 = clipboardData.getData("application/pdfjs");
                if (!data2) {
                  return;
                }
                try {
                  data2 = JSON.parse(data2);
                } catch (ex) {
                  (0, _util2.warn)(`paste: "${ex.message}".`);
                  return;
                }
                if (!Array.isArray(data2)) {
                  return;
                }
                this.unselectAll();
                const layer = this.currentLayer;
                try {
                  const newEditors = [];
                  for (const editor of data2) {
                    const deserializedEditor = layer.deserialize(editor);
                    if (!deserializedEditor) {
                      return;
                    }
                    newEditors.push(deserializedEditor);
                  }
                  const cmd2 = () => {
                    for (const editor of newEditors) {
                      __privateMethod(this, _addEditorToLayer, addEditorToLayer_fn).call(this, editor);
                    }
                    __privateMethod(this, _selectEditors, selectEditors_fn).call(this, newEditors);
                  };
                  const undo = () => {
                    for (const editor of newEditors) {
                      editor.remove();
                    }
                  };
                  this.addCommands({
                    cmd: cmd2,
                    undo,
                    mustExec: true
                  });
                } catch (ex) {
                  (0, _util2.warn)(`paste: "${ex.message}".`);
                }
              }
              keydown(event) {
                var _a3;
                if (!((_a3 = this.getActive()) == null ? void 0 : _a3.shouldGetKeyboardEvents())) {
                  _AnnotationEditorUIManager._keyboardManager.exec(this, event);
                }
              }
              onEditingAction(details) {
                if (["undo", "redo", "delete", "selectAll"].includes(details.name)) {
                  this[details.name]();
                }
              }
              setEditingState(isEditing) {
                if (isEditing) {
                  __privateMethod(this, _addFocusManager, addFocusManager_fn).call(this);
                  __privateMethod(this, _addKeyboardManager, addKeyboardManager_fn).call(this);
                  __privateMethod(this, _addCopyPasteListeners, addCopyPasteListeners_fn).call(this);
                  __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                    isEditing: __privateGet(this, _mode) !== _util2.AnnotationEditorType.NONE,
                    isEmpty: __privateMethod(this, _isEmpty, isEmpty_fn).call(this),
                    hasSomethingToUndo: __privateGet(this, _commandManager).hasSomethingToUndo(),
                    hasSomethingToRedo: __privateGet(this, _commandManager).hasSomethingToRedo(),
                    hasSelectedEditor: false
                  });
                } else {
                  __privateMethod(this, _removeFocusManager, removeFocusManager_fn).call(this);
                  __privateMethod(this, _removeKeyboardManager, removeKeyboardManager_fn).call(this);
                  __privateMethod(this, _removeCopyPasteListeners, removeCopyPasteListeners_fn).call(this);
                  __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                    isEditing: false
                  });
                  this.disableUserSelect(false);
                }
              }
              registerEditorTypes(types2) {
                if (__privateGet(this, _editorTypes)) {
                  return;
                }
                __privateSet(this, _editorTypes, types2);
                for (const editorType of __privateGet(this, _editorTypes)) {
                  __privateMethod(this, _dispatchUpdateUI, dispatchUpdateUI_fn).call(this, editorType.defaultPropertiesToUpdate);
                }
              }
              getId() {
                return __privateGet(this, _idManager).getId();
              }
              get currentLayer() {
                return __privateGet(this, _allLayers).get(__privateGet(this, _currentPageIndex));
              }
              getLayer(pageIndex) {
                return __privateGet(this, _allLayers).get(pageIndex);
              }
              get currentPageIndex() {
                return __privateGet(this, _currentPageIndex);
              }
              addLayer(layer) {
                __privateGet(this, _allLayers).set(layer.pageIndex, layer);
                if (__privateGet(this, _isEnabled)) {
                  layer.enable();
                } else {
                  layer.disable();
                }
              }
              removeLayer(layer) {
                __privateGet(this, _allLayers).delete(layer.pageIndex);
              }
              updateMode(mode2, editId = null) {
                if (__privateGet(this, _mode) === mode2) {
                  return;
                }
                __privateSet(this, _mode, mode2);
                if (mode2 === _util2.AnnotationEditorType.NONE) {
                  this.setEditingState(false);
                  __privateMethod(this, _disableAll, disableAll_fn).call(this);
                  return;
                }
                this.setEditingState(true);
                __privateMethod(this, _enableAll, enableAll_fn).call(this);
                this.unselectAll();
                for (const layer of __privateGet(this, _allLayers).values()) {
                  layer.updateMode(mode2);
                }
                if (!editId) {
                  return;
                }
                for (const editor of __privateGet(this, _allEditors).values()) {
                  if (editor.annotationElementId === editId) {
                    this.setSelected(editor);
                    editor.enterInEditMode();
                    break;
                  }
                }
              }
              updateToolbar(mode2) {
                if (mode2 === __privateGet(this, _mode)) {
                  return;
                }
                this._eventBus.dispatch("switchannotationeditormode", {
                  source: this,
                  mode: mode2
                });
              }
              updateParams(type, value) {
                if (!__privateGet(this, _editorTypes)) {
                  return;
                }
                if (type === _util2.AnnotationEditorParamsType.CREATE) {
                  this.currentLayer.addNewEditor(type);
                  return;
                }
                for (const editor of __privateGet(this, _selectedEditors)) {
                  editor.updateParams(type, value);
                }
                for (const editorType of __privateGet(this, _editorTypes)) {
                  editorType.updateDefaultParams(type, value);
                }
              }
              enableWaiting(mustWait = false) {
                if (__privateGet(this, _isWaiting) === mustWait) {
                  return;
                }
                __privateSet(this, _isWaiting, mustWait);
                for (const layer of __privateGet(this, _allLayers).values()) {
                  if (mustWait) {
                    layer.disableClick();
                  } else {
                    layer.enableClick();
                  }
                  layer.div.classList.toggle("waiting", mustWait);
                }
              }
              getEditors(pageIndex) {
                const editors = [];
                for (const editor of __privateGet(this, _allEditors).values()) {
                  if (editor.pageIndex === pageIndex) {
                    editors.push(editor);
                  }
                }
                return editors;
              }
              getEditor(id) {
                return __privateGet(this, _allEditors).get(id);
              }
              addEditor(editor) {
                __privateGet(this, _allEditors).set(editor.id, editor);
              }
              removeEditor(editor) {
                var _a3;
                __privateGet(this, _allEditors).delete(editor.id);
                this.unselect(editor);
                if (!editor.annotationElementId || !__privateGet(this, _deletedAnnotationsElementIds).has(editor.annotationElementId)) {
                  (_a3 = __privateGet(this, _annotationStorage)) == null ? void 0 : _a3.remove(editor.id);
                }
              }
              addDeletedAnnotationElement(editor) {
                __privateGet(this, _deletedAnnotationsElementIds).add(editor.annotationElementId);
                editor.deleted = true;
              }
              isDeletedAnnotationElement(annotationElementId) {
                return __privateGet(this, _deletedAnnotationsElementIds).has(annotationElementId);
              }
              removeDeletedAnnotationElement(editor) {
                __privateGet(this, _deletedAnnotationsElementIds).delete(editor.annotationElementId);
                editor.deleted = false;
              }
              setActiveEditor(editor) {
                if (__privateGet(this, _activeEditor) === editor) {
                  return;
                }
                __privateSet(this, _activeEditor, editor);
                if (editor) {
                  __privateMethod(this, _dispatchUpdateUI, dispatchUpdateUI_fn).call(this, editor.propertiesToUpdate);
                }
              }
              toggleSelected(editor) {
                if (__privateGet(this, _selectedEditors).has(editor)) {
                  __privateGet(this, _selectedEditors).delete(editor);
                  editor.unselect();
                  __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                    hasSelectedEditor: this.hasSelection
                  });
                  return;
                }
                __privateGet(this, _selectedEditors).add(editor);
                editor.select();
                __privateMethod(this, _dispatchUpdateUI, dispatchUpdateUI_fn).call(this, editor.propertiesToUpdate);
                __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                  hasSelectedEditor: true
                });
              }
              setSelected(editor) {
                for (const ed of __privateGet(this, _selectedEditors)) {
                  if (ed !== editor) {
                    ed.unselect();
                  }
                }
                __privateGet(this, _selectedEditors).clear();
                __privateGet(this, _selectedEditors).add(editor);
                editor.select();
                __privateMethod(this, _dispatchUpdateUI, dispatchUpdateUI_fn).call(this, editor.propertiesToUpdate);
                __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                  hasSelectedEditor: true
                });
              }
              isSelected(editor) {
                return __privateGet(this, _selectedEditors).has(editor);
              }
              unselect(editor) {
                editor.unselect();
                __privateGet(this, _selectedEditors).delete(editor);
                __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                  hasSelectedEditor: this.hasSelection
                });
              }
              get hasSelection() {
                return __privateGet(this, _selectedEditors).size !== 0;
              }
              undo() {
                __privateGet(this, _commandManager).undo();
                __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                  hasSomethingToUndo: __privateGet(this, _commandManager).hasSomethingToUndo(),
                  hasSomethingToRedo: true,
                  isEmpty: __privateMethod(this, _isEmpty, isEmpty_fn).call(this)
                });
              }
              redo() {
                __privateGet(this, _commandManager).redo();
                __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                  hasSomethingToUndo: true,
                  hasSomethingToRedo: __privateGet(this, _commandManager).hasSomethingToRedo(),
                  isEmpty: __privateMethod(this, _isEmpty, isEmpty_fn).call(this)
                });
              }
              addCommands(params2) {
                __privateGet(this, _commandManager).add(params2);
                __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                  hasSomethingToUndo: true,
                  hasSomethingToRedo: false,
                  isEmpty: __privateMethod(this, _isEmpty, isEmpty_fn).call(this)
                });
              }
              delete() {
                this.commitOrRemove();
                if (!this.hasSelection) {
                  return;
                }
                const editors = [...__privateGet(this, _selectedEditors)];
                const cmd2 = () => {
                  for (const editor of editors) {
                    editor.remove();
                  }
                };
                const undo = () => {
                  for (const editor of editors) {
                    __privateMethod(this, _addEditorToLayer, addEditorToLayer_fn).call(this, editor);
                  }
                };
                this.addCommands({
                  cmd: cmd2,
                  undo,
                  mustExec: true
                });
              }
              commitOrRemove() {
                var _a3;
                (_a3 = __privateGet(this, _activeEditor)) == null ? void 0 : _a3.commitOrRemove();
              }
              hasSomethingToControl() {
                return __privateGet(this, _activeEditor) || this.hasSelection;
              }
              selectAll() {
                for (const editor of __privateGet(this, _selectedEditors)) {
                  editor.commit();
                }
                __privateMethod(this, _selectEditors, selectEditors_fn).call(this, __privateGet(this, _allEditors).values());
              }
              unselectAll() {
                if (__privateGet(this, _activeEditor)) {
                  __privateGet(this, _activeEditor).commitOrRemove();
                  return;
                }
                if (!this.hasSelection) {
                  return;
                }
                for (const editor of __privateGet(this, _selectedEditors)) {
                  editor.unselect();
                }
                __privateGet(this, _selectedEditors).clear();
                __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                  hasSelectedEditor: false
                });
              }
              translateSelectedEditors(x2, y2, noCommit = false) {
                if (!noCommit) {
                  this.commitOrRemove();
                }
                if (!this.hasSelection) {
                  return;
                }
                __privateGet(this, _translation)[0] += x2;
                __privateGet(this, _translation)[1] += y2;
                const [totalX, totalY] = __privateGet(this, _translation);
                const editors = [...__privateGet(this, _selectedEditors)];
                const TIME_TO_WAIT = 1e3;
                if (__privateGet(this, _translationTimeoutId)) {
                  clearTimeout(__privateGet(this, _translationTimeoutId));
                }
                __privateSet(this, _translationTimeoutId, setTimeout(() => {
                  __privateSet(this, _translationTimeoutId, null);
                  __privateGet(this, _translation)[0] = __privateGet(this, _translation)[1] = 0;
                  this.addCommands({
                    cmd: () => {
                      for (const editor of editors) {
                        if (__privateGet(this, _allEditors).has(editor.id)) {
                          editor.translateInPage(totalX, totalY);
                        }
                      }
                    },
                    undo: () => {
                      for (const editor of editors) {
                        if (__privateGet(this, _allEditors).has(editor.id)) {
                          editor.translateInPage(-totalX, -totalY);
                        }
                      }
                    },
                    mustExec: false
                  });
                }, TIME_TO_WAIT));
                for (const editor of editors) {
                  editor.translateInPage(x2, y2);
                }
              }
              setUpDragSession() {
                if (!this.hasSelection) {
                  return;
                }
                this.disableUserSelect(true);
                __privateSet(this, _draggingEditors, /* @__PURE__ */ new Map());
                for (const editor of __privateGet(this, _selectedEditors)) {
                  __privateGet(this, _draggingEditors).set(editor, {
                    savedX: editor.x,
                    savedY: editor.y,
                    savedPageIndex: editor.pageIndex,
                    newX: 0,
                    newY: 0,
                    newPageIndex: -1
                  });
                }
              }
              endDragSession() {
                if (!__privateGet(this, _draggingEditors)) {
                  return false;
                }
                this.disableUserSelect(false);
                const map5 = __privateGet(this, _draggingEditors);
                __privateSet(this, _draggingEditors, null);
                let mustBeAddedInUndoStack = false;
                for (const [{
                  x: x2,
                  y: y2,
                  pageIndex
                }, value] of map5) {
                  value.newX = x2;
                  value.newY = y2;
                  value.newPageIndex = pageIndex;
                  mustBeAddedInUndoStack || (mustBeAddedInUndoStack = x2 !== value.savedX || y2 !== value.savedY || pageIndex !== value.savedPageIndex);
                }
                if (!mustBeAddedInUndoStack) {
                  return false;
                }
                const move2 = (editor, x2, y2, pageIndex) => {
                  if (__privateGet(this, _allEditors).has(editor.id)) {
                    const parent = __privateGet(this, _allLayers).get(pageIndex);
                    if (parent) {
                      editor._setParentAndPosition(parent, x2, y2);
                    } else {
                      editor.pageIndex = pageIndex;
                      editor.x = x2;
                      editor.y = y2;
                    }
                  }
                };
                this.addCommands({
                  cmd: () => {
                    for (const [editor, {
                      newX,
                      newY,
                      newPageIndex
                    }] of map5) {
                      move2(editor, newX, newY, newPageIndex);
                    }
                  },
                  undo: () => {
                    for (const [editor, {
                      savedX,
                      savedY,
                      savedPageIndex
                    }] of map5) {
                      move2(editor, savedX, savedY, savedPageIndex);
                    }
                  },
                  mustExec: true
                });
                return true;
              }
              dragSelectedEditors(tx, ty) {
                if (!__privateGet(this, _draggingEditors)) {
                  return;
                }
                for (const editor of __privateGet(this, _draggingEditors).keys()) {
                  editor.drag(tx, ty);
                }
              }
              rebuild(editor) {
                if (editor.parent === null) {
                  const parent = this.getLayer(editor.pageIndex);
                  if (parent) {
                    parent.changeParent(editor);
                    parent.addOrRebuild(editor);
                  } else {
                    this.addEditor(editor);
                    this.addToAnnotationStorage(editor);
                    editor.rebuild();
                  }
                } else {
                  editor.parent.addOrRebuild(editor);
                }
              }
              isActive(editor) {
                return __privateGet(this, _activeEditor) === editor;
              }
              getActive() {
                return __privateGet(this, _activeEditor);
              }
              getMode() {
                return __privateGet(this, _mode);
              }
              get imageManager() {
                return (0, _util2.shadow)(this, "imageManager", new ImageManager());
              }
            };
            let AnnotationEditorUIManager = _AnnotationEditorUIManager;
            _activeEditor = new WeakMap();
            _allEditors = new WeakMap();
            _allLayers = new WeakMap();
            _altTextManager = new WeakMap();
            _annotationStorage = new WeakMap();
            _commandManager = new WeakMap();
            _currentPageIndex = new WeakMap();
            _deletedAnnotationsElementIds = new WeakMap();
            _draggingEditors = new WeakMap();
            _editorTypes = new WeakMap();
            _editorsToRescale = new WeakMap();
            _filterFactory = new WeakMap();
            _idManager = new WeakMap();
            _isEnabled = new WeakMap();
            _isWaiting = new WeakMap();
            _lastActiveElement = new WeakMap();
            _mode = new WeakMap();
            _selectedEditors = new WeakMap();
            _pageColors = new WeakMap();
            _boundBlur = new WeakMap();
            _boundFocus = new WeakMap();
            _boundCopy = new WeakMap();
            _boundCut = new WeakMap();
            _boundPaste = new WeakMap();
            _boundKeydown = new WeakMap();
            _boundOnEditingAction = new WeakMap();
            _boundOnPageChanging = new WeakMap();
            _boundOnScaleChanging = new WeakMap();
            _boundOnRotationChanging = new WeakMap();
            _previousStates = new WeakMap();
            _translation = new WeakMap();
            _translationTimeoutId = new WeakMap();
            _container = new WeakMap();
            _viewer = new WeakMap();
            _addFocusManager = new WeakSet();
            addFocusManager_fn = function() {
              window.addEventListener("focus", __privateGet(this, _boundFocus));
              window.addEventListener("blur", __privateGet(this, _boundBlur));
            };
            _removeFocusManager = new WeakSet();
            removeFocusManager_fn = function() {
              window.removeEventListener("focus", __privateGet(this, _boundFocus));
              window.removeEventListener("blur", __privateGet(this, _boundBlur));
            };
            _addKeyboardManager = new WeakSet();
            addKeyboardManager_fn = function() {
              window.addEventListener("keydown", __privateGet(this, _boundKeydown), {
                capture: true
              });
            };
            _removeKeyboardManager = new WeakSet();
            removeKeyboardManager_fn = function() {
              window.removeEventListener("keydown", __privateGet(this, _boundKeydown), {
                capture: true
              });
            };
            _addCopyPasteListeners = new WeakSet();
            addCopyPasteListeners_fn = function() {
              document.addEventListener("copy", __privateGet(this, _boundCopy));
              document.addEventListener("cut", __privateGet(this, _boundCut));
              document.addEventListener("paste", __privateGet(this, _boundPaste));
            };
            _removeCopyPasteListeners = new WeakSet();
            removeCopyPasteListeners_fn = function() {
              document.removeEventListener("copy", __privateGet(this, _boundCopy));
              document.removeEventListener("cut", __privateGet(this, _boundCut));
              document.removeEventListener("paste", __privateGet(this, _boundPaste));
            };
            _dispatchUpdateStates = new WeakSet();
            dispatchUpdateStates_fn = function(details) {
              const hasChanged = Object.entries(details).some(([key, value]) => __privateGet(this, _previousStates)[key] !== value);
              if (hasChanged) {
                this._eventBus.dispatch("annotationeditorstateschanged", {
                  source: this,
                  details: Object.assign(__privateGet(this, _previousStates), details)
                });
              }
            };
            _dispatchUpdateUI = new WeakSet();
            dispatchUpdateUI_fn = function(details) {
              this._eventBus.dispatch("annotationeditorparamschanged", {
                source: this,
                details
              });
            };
            _enableAll = new WeakSet();
            enableAll_fn = function() {
              if (!__privateGet(this, _isEnabled)) {
                __privateSet(this, _isEnabled, true);
                for (const layer of __privateGet(this, _allLayers).values()) {
                  layer.enable();
                }
              }
            };
            _disableAll = new WeakSet();
            disableAll_fn = function() {
              this.unselectAll();
              if (__privateGet(this, _isEnabled)) {
                __privateSet(this, _isEnabled, false);
                for (const layer of __privateGet(this, _allLayers).values()) {
                  layer.disable();
                }
              }
            };
            _addEditorToLayer = new WeakSet();
            addEditorToLayer_fn = function(editor) {
              const layer = __privateGet(this, _allLayers).get(editor.pageIndex);
              if (layer) {
                layer.addOrRebuild(editor);
              } else {
                this.addEditor(editor);
              }
            };
            _isEmpty = new WeakSet();
            isEmpty_fn = function() {
              if (__privateGet(this, _allEditors).size === 0) {
                return true;
              }
              if (__privateGet(this, _allEditors).size === 1) {
                for (const editor of __privateGet(this, _allEditors).values()) {
                  return editor.isEmpty();
                }
              }
              return false;
            };
            _selectEditors = new WeakSet();
            selectEditors_fn = function(editors) {
              __privateGet(this, _selectedEditors).clear();
              for (const editor of editors) {
                if (editor.isEmpty()) {
                  continue;
                }
                __privateGet(this, _selectedEditors).add(editor);
                editor.select();
              }
              __privateMethod(this, _dispatchUpdateStates, dispatchUpdateStates_fn).call(this, {
                hasSelectedEditor: true
              });
            };
            __publicField2(AnnotationEditorUIManager, "TRANSLATE_SMALL", 1);
            __publicField2(AnnotationEditorUIManager, "TRANSLATE_BIG", 10);
            exports2.AnnotationEditorUIManager = AnnotationEditorUIManager;
          },
          /* 6 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var __cache, __defs, _docId, _document, _hcmFilter, _hcmKey, _hcmUrl, _hcmHighlightFilter, _hcmHighlightKey, _hcmHighlightUrl, _id2, _cache, cache_get, _defs, defs_get, _addGrayConversion, addGrayConversion_fn, _createFilter, createFilter_fn, _appendFeFunc, appendFeFunc_fn, _addTransferMapConversion, addTransferMapConversion_fn, _getRGB, getRGB_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.StatTimer = exports2.RenderingCancelledException = exports2.PixelsPerInch = exports2.PageViewport = exports2.PDFDateString = exports2.DOMStandardFontDataFactory = exports2.DOMSVGFactory = exports2.DOMFilterFactory = exports2.DOMCanvasFactory = exports2.DOMCMapReaderFactory = void 0;
            exports2.deprecated = deprecated;
            exports2.getColorValues = getColorValues;
            exports2.getCurrentTransform = getCurrentTransform;
            exports2.getCurrentTransformInverse = getCurrentTransformInverse;
            exports2.getFilenameFromUrl = getFilenameFromUrl;
            exports2.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
            exports2.getRGB = getRGB;
            exports2.getXfaPageViewport = getXfaPageViewport;
            exports2.isDataScheme = isDataScheme;
            exports2.isPdfFile = isPdfFile;
            exports2.isValidFetchUrl = isValidFetchUrl;
            exports2.loadScript = loadScript2;
            exports2.noContextMenu = noContextMenu;
            exports2.setLayerDimensions = setLayerDimensions;
            var _base_factory = __w_pdfjs_require__2(7);
            var _util2 = __w_pdfjs_require__2(1);
            const SVG_NS = "http://www.w3.org/2000/svg";
            const _PixelsPerInch = class {
            };
            let PixelsPerInch = _PixelsPerInch;
            __publicField2(PixelsPerInch, "CSS", 96);
            __publicField2(PixelsPerInch, "PDF", 72);
            __publicField2(PixelsPerInch, "PDF_TO_CSS_UNITS", _PixelsPerInch.CSS / _PixelsPerInch.PDF);
            exports2.PixelsPerInch = PixelsPerInch;
            class DOMFilterFactory extends _base_factory.BaseFilterFactory {
              constructor({
                docId,
                ownerDocument = globalThis.document
              } = {}) {
                super();
                __privateAdd(this, _cache);
                __privateAdd(this, _defs);
                __privateAdd(this, _addGrayConversion);
                __privateAdd(this, _createFilter);
                __privateAdd(this, _appendFeFunc);
                __privateAdd(this, _addTransferMapConversion);
                __privateAdd(this, _getRGB);
                __privateAdd(this, __cache, void 0);
                __privateAdd(this, __defs, void 0);
                __privateAdd(this, _docId, void 0);
                __privateAdd(this, _document, void 0);
                __privateAdd(this, _hcmFilter, void 0);
                __privateAdd(this, _hcmKey, void 0);
                __privateAdd(this, _hcmUrl, void 0);
                __privateAdd(this, _hcmHighlightFilter, void 0);
                __privateAdd(this, _hcmHighlightKey, void 0);
                __privateAdd(this, _hcmHighlightUrl, void 0);
                __privateAdd(this, _id2, 0);
                __privateSet(this, _docId, docId);
                __privateSet(this, _document, ownerDocument);
              }
              addFilter(maps) {
                if (!maps) {
                  return "none";
                }
                let value = __privateGet(this, _cache, cache_get).get(maps);
                if (value) {
                  return value;
                }
                let tableR, tableG, tableB, key;
                if (maps.length === 1) {
                  const mapR = maps[0];
                  const buffer3 = new Array(256);
                  for (let i2 = 0; i2 < 256; i2++) {
                    buffer3[i2] = mapR[i2] / 255;
                  }
                  key = tableR = tableG = tableB = buffer3.join(",");
                } else {
                  const [mapR, mapG, mapB] = maps;
                  const bufferR = new Array(256);
                  const bufferG = new Array(256);
                  const bufferB = new Array(256);
                  for (let i2 = 0; i2 < 256; i2++) {
                    bufferR[i2] = mapR[i2] / 255;
                    bufferG[i2] = mapG[i2] / 255;
                    bufferB[i2] = mapB[i2] / 255;
                  }
                  tableR = bufferR.join(",");
                  tableG = bufferG.join(",");
                  tableB = bufferB.join(",");
                  key = `${tableR}${tableG}${tableB}`;
                }
                value = __privateGet(this, _cache, cache_get).get(key);
                if (value) {
                  __privateGet(this, _cache, cache_get).set(maps, value);
                  return value;
                }
                const id = `g_${__privateGet(this, _docId)}_transfer_map_${__privateWrapper(this, _id2)._++}`;
                const url2 = `url(#${id})`;
                __privateGet(this, _cache, cache_get).set(maps, url2);
                __privateGet(this, _cache, cache_get).set(key, url2);
                const filter17 = __privateMethod(this, _createFilter, createFilter_fn).call(this, id);
                __privateMethod(this, _addTransferMapConversion, addTransferMapConversion_fn).call(this, tableR, tableG, tableB, filter17);
                return url2;
              }
              addHCMFilter(fgColor, bgColor) {
                var _a3;
                const key = `${fgColor}-${bgColor}`;
                if (__privateGet(this, _hcmKey) === key) {
                  return __privateGet(this, _hcmUrl);
                }
                __privateSet(this, _hcmKey, key);
                __privateSet(this, _hcmUrl, "none");
                (_a3 = __privateGet(this, _hcmFilter)) == null ? void 0 : _a3.remove();
                if (!fgColor || !bgColor) {
                  return __privateGet(this, _hcmUrl);
                }
                const fgRGB = __privateMethod(this, _getRGB, getRGB_fn).call(this, fgColor);
                fgColor = _util2.Util.makeHexColor(...fgRGB);
                const bgRGB = __privateMethod(this, _getRGB, getRGB_fn).call(this, bgColor);
                bgColor = _util2.Util.makeHexColor(...bgRGB);
                __privateGet(this, _defs, defs_get).style.color = "";
                if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) {
                  return __privateGet(this, _hcmUrl);
                }
                const map5 = new Array(256);
                for (let i2 = 0; i2 <= 255; i2++) {
                  const x2 = i2 / 255;
                  map5[i2] = x2 <= 0.03928 ? x2 / 12.92 : ((x2 + 0.055) / 1.055) ** 2.4;
                }
                const table = map5.join(",");
                const id = `g_${__privateGet(this, _docId)}_hcm_filter`;
                const filter17 = __privateSet(this, _hcmHighlightFilter, __privateMethod(this, _createFilter, createFilter_fn).call(this, id));
                __privateMethod(this, _addTransferMapConversion, addTransferMapConversion_fn).call(this, table, table, table, filter17);
                __privateMethod(this, _addGrayConversion, addGrayConversion_fn).call(this, filter17);
                const getSteps = (c2, n2) => {
                  const start2 = fgRGB[c2] / 255;
                  const end = bgRGB[c2] / 255;
                  const arr = new Array(n2 + 1);
                  for (let i2 = 0; i2 <= n2; i2++) {
                    arr[i2] = start2 + i2 / n2 * (end - start2);
                  }
                  return arr.join(",");
                };
                __privateMethod(this, _addTransferMapConversion, addTransferMapConversion_fn).call(this, getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter17);
                __privateSet(this, _hcmUrl, `url(#${id})`);
                return __privateGet(this, _hcmUrl);
              }
              addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                var _a3;
                const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                if (__privateGet(this, _hcmHighlightKey) === key) {
                  return __privateGet(this, _hcmHighlightUrl);
                }
                __privateSet(this, _hcmHighlightKey, key);
                __privateSet(this, _hcmHighlightUrl, "none");
                (_a3 = __privateGet(this, _hcmHighlightFilter)) == null ? void 0 : _a3.remove();
                if (!fgColor || !bgColor) {
                  return __privateGet(this, _hcmHighlightUrl);
                }
                const [fgRGB, bgRGB] = [fgColor, bgColor].map(__privateMethod(this, _getRGB, getRGB_fn).bind(this));
                let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                let [newFgRGB, newBgRGB] = [newFgColor, newBgColor].map(__privateMethod(this, _getRGB, getRGB_fn).bind(this));
                if (bgGray < fgGray) {
                  [fgGray, bgGray, newFgRGB, newBgRGB] = [bgGray, fgGray, newBgRGB, newFgRGB];
                }
                __privateGet(this, _defs, defs_get).style.color = "";
                const getSteps = (fg, bg2, n2) => {
                  const arr = new Array(256);
                  const step = (bgGray - fgGray) / n2;
                  const newStart = fg / 255;
                  const newStep = (bg2 - fg) / (255 * n2);
                  let prev = 0;
                  for (let i2 = 0; i2 <= n2; i2++) {
                    const k2 = Math.round(fgGray + i2 * step);
                    const value = newStart + i2 * newStep;
                    for (let j2 = prev; j2 <= k2; j2++) {
                      arr[j2] = value;
                    }
                    prev = k2 + 1;
                  }
                  for (let i2 = prev; i2 < 256; i2++) {
                    arr[i2] = arr[prev - 1];
                  }
                  return arr.join(",");
                };
                const id = `g_${__privateGet(this, _docId)}_hcm_highlight_filter`;
                const filter17 = __privateSet(this, _hcmHighlightFilter, __privateMethod(this, _createFilter, createFilter_fn).call(this, id));
                __privateMethod(this, _addGrayConversion, addGrayConversion_fn).call(this, filter17);
                __privateMethod(this, _addTransferMapConversion, addTransferMapConversion_fn).call(this, getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter17);
                __privateSet(this, _hcmHighlightUrl, `url(#${id})`);
                return __privateGet(this, _hcmHighlightUrl);
              }
              destroy(keepHCM = false) {
                if (keepHCM && (__privateGet(this, _hcmUrl) || __privateGet(this, _hcmHighlightUrl))) {
                  return;
                }
                if (__privateGet(this, __defs)) {
                  __privateGet(this, __defs).parentNode.parentNode.remove();
                  __privateSet(this, __defs, null);
                }
                if (__privateGet(this, __cache)) {
                  __privateGet(this, __cache).clear();
                  __privateSet(this, __cache, null);
                }
                __privateSet(this, _id2, 0);
              }
            }
            __cache = new WeakMap();
            __defs = new WeakMap();
            _docId = new WeakMap();
            _document = new WeakMap();
            _hcmFilter = new WeakMap();
            _hcmKey = new WeakMap();
            _hcmUrl = new WeakMap();
            _hcmHighlightFilter = new WeakMap();
            _hcmHighlightKey = new WeakMap();
            _hcmHighlightUrl = new WeakMap();
            _id2 = new WeakMap();
            _cache = new WeakSet();
            cache_get = function() {
              return __privateGet(this, __cache) || __privateSet(this, __cache, /* @__PURE__ */ new Map());
            };
            _defs = new WeakSet();
            defs_get = function() {
              if (!__privateGet(this, __defs)) {
                const div = __privateGet(this, _document).createElement("div");
                const {
                  style: style2
                } = div;
                style2.visibility = "hidden";
                style2.contain = "strict";
                style2.width = style2.height = 0;
                style2.position = "absolute";
                style2.top = style2.left = 0;
                style2.zIndex = -1;
                const svg = __privateGet(this, _document).createElementNS(SVG_NS, "svg");
                svg.setAttribute("width", 0);
                svg.setAttribute("height", 0);
                __privateSet(this, __defs, __privateGet(this, _document).createElementNS(SVG_NS, "defs"));
                div.append(svg);
                svg.append(__privateGet(this, __defs));
                __privateGet(this, _document).body.append(div);
              }
              return __privateGet(this, __defs);
            };
            _addGrayConversion = new WeakSet();
            addGrayConversion_fn = function(filter17) {
              const feColorMatrix = __privateGet(this, _document).createElementNS(SVG_NS, "feColorMatrix");
              feColorMatrix.setAttribute("type", "matrix");
              feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
              filter17.append(feColorMatrix);
            };
            _createFilter = new WeakSet();
            createFilter_fn = function(id) {
              const filter17 = __privateGet(this, _document).createElementNS(SVG_NS, "filter");
              filter17.setAttribute("color-interpolation-filters", "sRGB");
              filter17.setAttribute("id", id);
              __privateGet(this, _defs, defs_get).append(filter17);
              return filter17;
            };
            _appendFeFunc = new WeakSet();
            appendFeFunc_fn = function(feComponentTransfer, func2, table) {
              const feFunc = __privateGet(this, _document).createElementNS(SVG_NS, func2);
              feFunc.setAttribute("type", "discrete");
              feFunc.setAttribute("tableValues", table);
              feComponentTransfer.append(feFunc);
            };
            _addTransferMapConversion = new WeakSet();
            addTransferMapConversion_fn = function(rTable, gTable, bTable, filter17) {
              const feComponentTransfer = __privateGet(this, _document).createElementNS(SVG_NS, "feComponentTransfer");
              filter17.append(feComponentTransfer);
              __privateMethod(this, _appendFeFunc, appendFeFunc_fn).call(this, feComponentTransfer, "feFuncR", rTable);
              __privateMethod(this, _appendFeFunc, appendFeFunc_fn).call(this, feComponentTransfer, "feFuncG", gTable);
              __privateMethod(this, _appendFeFunc, appendFeFunc_fn).call(this, feComponentTransfer, "feFuncB", bTable);
            };
            _getRGB = new WeakSet();
            getRGB_fn = function(color) {
              __privateGet(this, _defs, defs_get).style.color = color;
              return getRGB(getComputedStyle(__privateGet(this, _defs, defs_get)).getPropertyValue("color"));
            };
            exports2.DOMFilterFactory = DOMFilterFactory;
            class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
              constructor({
                ownerDocument = globalThis.document
              } = {}) {
                super();
                this._document = ownerDocument;
              }
              _createCanvas(width, height) {
                const canvas2 = this._document.createElement("canvas");
                canvas2.width = width;
                canvas2.height = height;
                return canvas2;
              }
            }
            exports2.DOMCanvasFactory = DOMCanvasFactory;
            async function fetchData(url2, asTypedArray = false) {
              if (isValidFetchUrl(url2, document.baseURI)) {
                const response = await fetch(url2);
                if (!response.ok) {
                  throw new Error(response.statusText);
                }
                return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util2.stringToBytes)(await response.text());
              }
              return new Promise((resolve2, reject) => {
                const request = new XMLHttpRequest();
                request.open("GET", url2, true);
                if (asTypedArray) {
                  request.responseType = "arraybuffer";
                }
                request.onreadystatechange = () => {
                  if (request.readyState !== XMLHttpRequest.DONE) {
                    return;
                  }
                  if (request.status === 200 || request.status === 0) {
                    let data2;
                    if (asTypedArray && request.response) {
                      data2 = new Uint8Array(request.response);
                    } else if (!asTypedArray && request.responseText) {
                      data2 = (0, _util2.stringToBytes)(request.responseText);
                    }
                    if (data2) {
                      resolve2(data2);
                      return;
                    }
                  }
                  reject(new Error(request.statusText));
                };
                request.send(null);
              });
            }
            class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
              _fetchData(url2, compressionType) {
                return fetchData(url2, this.isCompressed).then((data2) => {
                  return {
                    cMapData: data2,
                    compressionType
                  };
                });
              }
            }
            exports2.DOMCMapReaderFactory = DOMCMapReaderFactory;
            class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
              _fetchData(url2) {
                return fetchData(url2, true);
              }
            }
            exports2.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
            class DOMSVGFactory extends _base_factory.BaseSVGFactory {
              _createSVG(type) {
                return document.createElementNS(SVG_NS, type);
              }
            }
            exports2.DOMSVGFactory = DOMSVGFactory;
            class PageViewport {
              constructor({
                viewBox,
                scale: scale5,
                rotation,
                offsetX = 0,
                offsetY = 0,
                dontFlip = false
              }) {
                this.viewBox = viewBox;
                this.scale = scale5;
                this.rotation = rotation;
                this.offsetX = offsetX;
                this.offsetY = offsetY;
                const centerX = (viewBox[2] + viewBox[0]) / 2;
                const centerY = (viewBox[3] + viewBox[1]) / 2;
                let rotateA, rotateB, rotateC, rotateD;
                rotation %= 360;
                if (rotation < 0) {
                  rotation += 360;
                }
                switch (rotation) {
                  case 180:
                    rotateA = -1;
                    rotateB = 0;
                    rotateC = 0;
                    rotateD = 1;
                    break;
                  case 90:
                    rotateA = 0;
                    rotateB = 1;
                    rotateC = 1;
                    rotateD = 0;
                    break;
                  case 270:
                    rotateA = 0;
                    rotateB = -1;
                    rotateC = -1;
                    rotateD = 0;
                    break;
                  case 0:
                    rotateA = 1;
                    rotateB = 0;
                    rotateC = 0;
                    rotateD = -1;
                    break;
                  default:
                    throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                }
                if (dontFlip) {
                  rotateC = -rotateC;
                  rotateD = -rotateD;
                }
                let offsetCanvasX, offsetCanvasY;
                let width, height;
                if (rotateA === 0) {
                  offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale5 + offsetX;
                  offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale5 + offsetY;
                  width = (viewBox[3] - viewBox[1]) * scale5;
                  height = (viewBox[2] - viewBox[0]) * scale5;
                } else {
                  offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale5 + offsetX;
                  offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale5 + offsetY;
                  width = (viewBox[2] - viewBox[0]) * scale5;
                  height = (viewBox[3] - viewBox[1]) * scale5;
                }
                this.transform = [rotateA * scale5, rotateB * scale5, rotateC * scale5, rotateD * scale5, offsetCanvasX - rotateA * scale5 * centerX - rotateC * scale5 * centerY, offsetCanvasY - rotateB * scale5 * centerX - rotateD * scale5 * centerY];
                this.width = width;
                this.height = height;
              }
              get rawDims() {
                const {
                  viewBox
                } = this;
                return (0, _util2.shadow)(this, "rawDims", {
                  pageWidth: viewBox[2] - viewBox[0],
                  pageHeight: viewBox[3] - viewBox[1],
                  pageX: viewBox[0],
                  pageY: viewBox[1]
                });
              }
              clone({
                scale: scale5 = this.scale,
                rotation = this.rotation,
                offsetX = this.offsetX,
                offsetY = this.offsetY,
                dontFlip = false
              } = {}) {
                return new PageViewport({
                  viewBox: this.viewBox.slice(),
                  scale: scale5,
                  rotation,
                  offsetX,
                  offsetY,
                  dontFlip
                });
              }
              convertToViewportPoint(x2, y2) {
                return _util2.Util.applyTransform([x2, y2], this.transform);
              }
              convertToViewportRectangle(rect) {
                const topLeft = _util2.Util.applyTransform([rect[0], rect[1]], this.transform);
                const bottomRight = _util2.Util.applyTransform([rect[2], rect[3]], this.transform);
                return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
              }
              convertToPdfPoint(x2, y2) {
                return _util2.Util.applyInverseTransform([x2, y2], this.transform);
              }
            }
            exports2.PageViewport = PageViewport;
            class RenderingCancelledException extends _util2.BaseException {
              constructor(msg2, extraDelay = 0) {
                super(msg2, "RenderingCancelledException");
                this.extraDelay = extraDelay;
              }
            }
            exports2.RenderingCancelledException = RenderingCancelledException;
            function isDataScheme(url2) {
              const ii2 = url2.length;
              let i2 = 0;
              while (i2 < ii2 && url2[i2].trim() === "") {
                i2++;
              }
              return url2.substring(i2, i2 + 5).toLowerCase() === "data:";
            }
            function isPdfFile(filename2) {
              return typeof filename2 === "string" && /\.pdf$/i.test(filename2);
            }
            function getFilenameFromUrl(url2, onlyStripPath = false) {
              if (!onlyStripPath) {
                [url2] = url2.split(/[#?]/, 1);
              }
              return url2.substring(url2.lastIndexOf("/") + 1);
            }
            function getPdfFilenameFromUrl(url2, defaultFilename = "document.pdf") {
              if (typeof url2 !== "string") {
                return defaultFilename;
              }
              if (isDataScheme(url2)) {
                (0, _util2.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                return defaultFilename;
              }
              const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
              const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
              const splitURI = reURI.exec(url2);
              let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
              if (suggestedFilename) {
                suggestedFilename = suggestedFilename[0];
                if (suggestedFilename.includes("%")) {
                  try {
                    suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                  } catch {
                  }
                }
              }
              return suggestedFilename || defaultFilename;
            }
            class StatTimer {
              constructor() {
                __publicField2(this, "started", /* @__PURE__ */ Object.create(null));
                __publicField2(this, "times", []);
              }
              time(name2) {
                if (name2 in this.started) {
                  (0, _util2.warn)(`Timer is already running for ${name2}`);
                }
                this.started[name2] = Date.now();
              }
              timeEnd(name2) {
                if (!(name2 in this.started)) {
                  (0, _util2.warn)(`Timer has not been started for ${name2}`);
                }
                this.times.push({
                  name: name2,
                  start: this.started[name2],
                  end: Date.now()
                });
                delete this.started[name2];
              }
              toString() {
                const outBuf = [];
                let longest = 0;
                for (const {
                  name: name2
                } of this.times) {
                  longest = Math.max(name2.length, longest);
                }
                for (const {
                  name: name2,
                  start: start2,
                  end
                } of this.times) {
                  outBuf.push(`${name2.padEnd(longest)} ${end - start2}ms
`);
                }
                return outBuf.join("");
              }
            }
            exports2.StatTimer = StatTimer;
            function isValidFetchUrl(url2, baseUrl) {
              try {
                const {
                  protocol
                } = baseUrl ? new URL(url2, baseUrl) : new URL(url2);
                return protocol === "http:" || protocol === "https:";
              } catch {
                return false;
              }
            }
            function noContextMenu(e3) {
              e3.preventDefault();
            }
            function loadScript2(src2, removeScriptElement = false) {
              return new Promise((resolve2, reject) => {
                const script = document.createElement("script");
                script.src = src2;
                script.onload = function(evt) {
                  if (removeScriptElement) {
                    script.remove();
                  }
                  resolve2(evt);
                };
                script.onerror = function() {
                  reject(new Error(`Cannot load script at: ${script.src}`));
                };
                (document.head || document.documentElement).append(script);
              });
            }
            function deprecated(details) {
              console.log("Deprecated API usage: " + details);
            }
            let pdfDateStringRegex;
            class PDFDateString {
              static toDateObject(input) {
                if (!input || typeof input !== "string") {
                  return null;
                }
                pdfDateStringRegex || (pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
                const matches2 = pdfDateStringRegex.exec(input);
                if (!matches2) {
                  return null;
                }
                const year = parseInt(matches2[1], 10);
                let month = parseInt(matches2[2], 10);
                month = month >= 1 && month <= 12 ? month - 1 : 0;
                let day = parseInt(matches2[3], 10);
                day = day >= 1 && day <= 31 ? day : 1;
                let hour = parseInt(matches2[4], 10);
                hour = hour >= 0 && hour <= 23 ? hour : 0;
                let minute = parseInt(matches2[5], 10);
                minute = minute >= 0 && minute <= 59 ? minute : 0;
                let second = parseInt(matches2[6], 10);
                second = second >= 0 && second <= 59 ? second : 0;
                const universalTimeRelation = matches2[7] || "Z";
                let offsetHour = parseInt(matches2[8], 10);
                offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                let offsetMinute = parseInt(matches2[9], 10) || 0;
                offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                if (universalTimeRelation === "-") {
                  hour += offsetHour;
                  minute += offsetMinute;
                } else if (universalTimeRelation === "+") {
                  hour -= offsetHour;
                  minute -= offsetMinute;
                }
                return new Date(Date.UTC(year, month, day, hour, minute, second));
              }
            }
            exports2.PDFDateString = PDFDateString;
            function getXfaPageViewport(xfaPage, {
              scale: scale5 = 1,
              rotation = 0
            }) {
              const {
                width,
                height
              } = xfaPage.attributes.style;
              const viewBox = [0, 0, parseInt(width), parseInt(height)];
              return new PageViewport({
                viewBox,
                scale: scale5,
                rotation
              });
            }
            function getRGB(color) {
              if (color.startsWith("#")) {
                const colorRGB = parseInt(color.slice(1), 16);
                return [(colorRGB & 16711680) >> 16, (colorRGB & 65280) >> 8, colorRGB & 255];
              }
              if (color.startsWith("rgb(")) {
                return color.slice(4, -1).split(",").map((x2) => parseInt(x2));
              }
              if (color.startsWith("rgba(")) {
                return color.slice(5, -1).split(",").map((x2) => parseInt(x2)).slice(0, 3);
              }
              (0, _util2.warn)(`Not a valid color format: "${color}"`);
              return [0, 0, 0];
            }
            function getColorValues(colors) {
              const span = document.createElement("span");
              span.style.visibility = "hidden";
              document.body.append(span);
              for (const name2 of colors.keys()) {
                span.style.color = name2;
                const computedColor = window.getComputedStyle(span).color;
                colors.set(name2, getRGB(computedColor));
              }
              span.remove();
            }
            function getCurrentTransform(ctx2) {
              const {
                a: a2,
                b: b2,
                c: c2,
                d: d2,
                e: e3,
                f: f2
              } = ctx2.getTransform();
              return [a2, b2, c2, d2, e3, f2];
            }
            function getCurrentTransformInverse(ctx2) {
              const {
                a: a2,
                b: b2,
                c: c2,
                d: d2,
                e: e3,
                f: f2
              } = ctx2.getTransform().invertSelf();
              return [a2, b2, c2, d2, e3, f2];
            }
            function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
              if (viewport instanceof PageViewport) {
                const {
                  pageWidth,
                  pageHeight
                } = viewport.rawDims;
                const {
                  style: style2
                } = div;
                const useRound = _util2.FeatureTest.isCSSRoundSupported;
                const w2 = `var(--scale-factor) * ${pageWidth}px`, h2 = `var(--scale-factor) * ${pageHeight}px`;
                const widthStr = useRound ? `round(${w2}, 1px)` : `calc(${w2})`, heightStr = useRound ? `round(${h2}, 1px)` : `calc(${h2})`;
                if (!mustFlip || viewport.rotation % 180 === 0) {
                  style2.width = widthStr;
                  style2.height = heightStr;
                } else {
                  style2.width = heightStr;
                  style2.height = widthStr;
                }
              }
              if (mustRotate) {
                div.setAttribute("data-main-rotation", viewport.rotation);
              }
            }
          },
          /* 7 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.BaseStandardFontDataFactory = exports2.BaseSVGFactory = exports2.BaseFilterFactory = exports2.BaseCanvasFactory = exports2.BaseCMapReaderFactory = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            class BaseFilterFactory {
              constructor() {
                if (this.constructor === BaseFilterFactory) {
                  (0, _util2.unreachable)("Cannot initialize BaseFilterFactory.");
                }
              }
              addFilter(maps) {
                return "none";
              }
              addHCMFilter(fgColor, bgColor) {
                return "none";
              }
              addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                return "none";
              }
              destroy(keepHCM = false) {
              }
            }
            exports2.BaseFilterFactory = BaseFilterFactory;
            class BaseCanvasFactory {
              constructor() {
                if (this.constructor === BaseCanvasFactory) {
                  (0, _util2.unreachable)("Cannot initialize BaseCanvasFactory.");
                }
              }
              create(width, height) {
                if (width <= 0 || height <= 0) {
                  throw new Error("Invalid canvas size");
                }
                const canvas2 = this._createCanvas(width, height);
                return {
                  canvas: canvas2,
                  context: canvas2.getContext("2d")
                };
              }
              reset(canvasAndContext, width, height) {
                if (!canvasAndContext.canvas) {
                  throw new Error("Canvas is not specified");
                }
                if (width <= 0 || height <= 0) {
                  throw new Error("Invalid canvas size");
                }
                canvasAndContext.canvas.width = width;
                canvasAndContext.canvas.height = height;
              }
              destroy(canvasAndContext) {
                if (!canvasAndContext.canvas) {
                  throw new Error("Canvas is not specified");
                }
                canvasAndContext.canvas.width = 0;
                canvasAndContext.canvas.height = 0;
                canvasAndContext.canvas = null;
                canvasAndContext.context = null;
              }
              _createCanvas(width, height) {
                (0, _util2.unreachable)("Abstract method `_createCanvas` called.");
              }
            }
            exports2.BaseCanvasFactory = BaseCanvasFactory;
            class BaseCMapReaderFactory {
              constructor({
                baseUrl = null,
                isCompressed = true
              }) {
                if (this.constructor === BaseCMapReaderFactory) {
                  (0, _util2.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                }
                this.baseUrl = baseUrl;
                this.isCompressed = isCompressed;
              }
              async fetch({
                name: name2
              }) {
                if (!this.baseUrl) {
                  throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                }
                if (!name2) {
                  throw new Error("CMap name must be specified.");
                }
                const url2 = this.baseUrl + name2 + (this.isCompressed ? ".bcmap" : "");
                const compressionType = this.isCompressed ? _util2.CMapCompressionType.BINARY : _util2.CMapCompressionType.NONE;
                return this._fetchData(url2, compressionType).catch((reason) => {
                  throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url2}`);
                });
              }
              _fetchData(url2, compressionType) {
                (0, _util2.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            exports2.BaseCMapReaderFactory = BaseCMapReaderFactory;
            class BaseStandardFontDataFactory {
              constructor({
                baseUrl = null
              }) {
                if (this.constructor === BaseStandardFontDataFactory) {
                  (0, _util2.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                }
                this.baseUrl = baseUrl;
              }
              async fetch({
                filename: filename2
              }) {
                if (!this.baseUrl) {
                  throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                }
                if (!filename2) {
                  throw new Error("Font filename must be specified.");
                }
                const url2 = `${this.baseUrl}${filename2}`;
                return this._fetchData(url2).catch((reason) => {
                  throw new Error(`Unable to load font data at: ${url2}`);
                });
              }
              _fetchData(url2) {
                (0, _util2.unreachable)("Abstract method `_fetchData` called.");
              }
            }
            exports2.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
            class BaseSVGFactory {
              constructor() {
                if (this.constructor === BaseSVGFactory) {
                  (0, _util2.unreachable)("Cannot initialize BaseSVGFactory.");
                }
              }
              create(width, height, skipDimensions = false) {
                if (width <= 0 || height <= 0) {
                  throw new Error("Invalid SVG dimensions");
                }
                const svg = this._createSVG("svg:svg");
                svg.setAttribute("version", "1.1");
                if (!skipDimensions) {
                  svg.setAttribute("width", `${width}px`);
                  svg.setAttribute("height", `${height}px`);
                }
                svg.setAttribute("preserveAspectRatio", "none");
                svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                return svg;
              }
              createElement(type) {
                if (typeof type !== "string") {
                  throw new Error("Invalid SVG element type");
                }
                return this._createSVG(type);
              }
              _createSVG(type) {
                (0, _util2.unreachable)("Abstract method `_createSVG` called.");
              }
            }
            exports2.BaseSVGFactory = BaseSVGFactory;
          },
          /* 8 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.MurmurHash3_64 = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            const SEED = 3285377520;
            const MASK_HIGH = 4294901760;
            const MASK_LOW = 65535;
            class MurmurHash3_64 {
              constructor(seed) {
                this.h1 = seed ? seed & 4294967295 : SEED;
                this.h2 = seed ? seed & 4294967295 : SEED;
              }
              update(input) {
                let data2, length2;
                if (typeof input === "string") {
                  data2 = new Uint8Array(input.length * 2);
                  length2 = 0;
                  for (let i2 = 0, ii2 = input.length; i2 < ii2; i2++) {
                    const code = input.charCodeAt(i2);
                    if (code <= 255) {
                      data2[length2++] = code;
                    } else {
                      data2[length2++] = code >>> 8;
                      data2[length2++] = code & 255;
                    }
                  }
                } else if ((0, _util2.isArrayBuffer)(input)) {
                  data2 = input.slice();
                  length2 = data2.byteLength;
                } else {
                  throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                }
                const blockCounts = length2 >> 2;
                const tailLength = length2 - blockCounts * 4;
                const dataUint32 = new Uint32Array(data2.buffer, 0, blockCounts);
                let k1 = 0, k2 = 0;
                let h1 = this.h1, h2 = this.h2;
                const C12 = 3432918353, C2 = 461845907;
                const C1_LOW = C12 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                for (let i2 = 0; i2 < blockCounts; i2++) {
                  if (i2 & 1) {
                    k1 = dataUint32[i2];
                    k1 = k1 * C12 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                    k1 = k1 << 15 | k1 >>> 17;
                    k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                    h1 ^= k1;
                    h1 = h1 << 13 | h1 >>> 19;
                    h1 = h1 * 5 + 3864292196;
                  } else {
                    k2 = dataUint32[i2];
                    k2 = k2 * C12 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                    k2 = k2 << 15 | k2 >>> 17;
                    k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                    h2 ^= k2;
                    h2 = h2 << 13 | h2 >>> 19;
                    h2 = h2 * 5 + 3864292196;
                  }
                }
                k1 = 0;
                switch (tailLength) {
                  case 3:
                    k1 ^= data2[blockCounts * 4 + 2] << 16;
                  case 2:
                    k1 ^= data2[blockCounts * 4 + 1] << 8;
                  case 1:
                    k1 ^= data2[blockCounts * 4];
                    k1 = k1 * C12 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                    k1 = k1 << 15 | k1 >>> 17;
                    k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                    if (blockCounts & 1) {
                      h1 ^= k1;
                    } else {
                      h2 ^= k1;
                    }
                }
                this.h1 = h1;
                this.h2 = h2;
              }
              hexdigest() {
                let h1 = this.h1, h2 = this.h2;
                h1 ^= h2 >>> 1;
                h1 = h1 * 3981806797 & MASK_HIGH | h1 * 36045 & MASK_LOW;
                h2 = h2 * 4283543511 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 2950163797 & MASK_HIGH) >>> 16;
                h1 ^= h2 >>> 1;
                h1 = h1 * 444984403 & MASK_HIGH | h1 * 60499 & MASK_LOW;
                h2 = h2 * 3301882366 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 3120437893 & MASK_HIGH) >>> 16;
                h1 ^= h2 >>> 1;
                return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
              }
            }
            exports2.MurmurHash3_64 = MurmurHash3_64;
          },
          /* 9 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _systemFonts;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.FontLoader = exports2.FontFaceObject = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            class FontLoader2 {
              constructor({
                ownerDocument = globalThis.document,
                styleElement = null
              }) {
                __privateAdd(this, _systemFonts, /* @__PURE__ */ new Set());
                this._document = ownerDocument;
                this.nativeFontFaces = /* @__PURE__ */ new Set();
                this.styleElement = null;
                this.loadingRequests = [];
                this.loadTestFontId = 0;
              }
              addNativeFontFace(nativeFontFace) {
                this.nativeFontFaces.add(nativeFontFace);
                this._document.fonts.add(nativeFontFace);
              }
              removeNativeFontFace(nativeFontFace) {
                this.nativeFontFaces.delete(nativeFontFace);
                this._document.fonts.delete(nativeFontFace);
              }
              insertRule(rule) {
                if (!this.styleElement) {
                  this.styleElement = this._document.createElement("style");
                  this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                }
                const styleSheet = this.styleElement.sheet;
                styleSheet.insertRule(rule, styleSheet.cssRules.length);
              }
              clear() {
                for (const nativeFontFace of this.nativeFontFaces) {
                  this._document.fonts.delete(nativeFontFace);
                }
                this.nativeFontFaces.clear();
                __privateGet(this, _systemFonts).clear();
                if (this.styleElement) {
                  this.styleElement.remove();
                  this.styleElement = null;
                }
              }
              async loadSystemFont(info) {
                if (!info || __privateGet(this, _systemFonts).has(info.loadedName)) {
                  return;
                }
                (0, _util2.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                if (this.isFontLoadingAPISupported) {
                  const {
                    loadedName,
                    src: src2,
                    style: style2
                  } = info;
                  const fontFace = new FontFace(loadedName, src2, style2);
                  this.addNativeFontFace(fontFace);
                  try {
                    await fontFace.load();
                    __privateGet(this, _systemFonts).add(loadedName);
                  } catch {
                    (0, _util2.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                    this.removeNativeFontFace(fontFace);
                  }
                  return;
                }
                (0, _util2.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
              }
              async bind(font) {
                if (font.attached || font.missingFile && !font.systemFontInfo) {
                  return;
                }
                font.attached = true;
                if (font.systemFontInfo) {
                  await this.loadSystemFont(font.systemFontInfo);
                  return;
                }
                if (this.isFontLoadingAPISupported) {
                  const nativeFontFace = font.createNativeFontFace();
                  if (nativeFontFace) {
                    this.addNativeFontFace(nativeFontFace);
                    try {
                      await nativeFontFace.loaded;
                    } catch (ex) {
                      (0, _util2.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                      font.disableFontFace = true;
                      throw ex;
                    }
                  }
                  return;
                }
                const rule = font.createFontFaceRule();
                if (rule) {
                  this.insertRule(rule);
                  if (this.isSyncFontLoadingSupported) {
                    return;
                  }
                  await new Promise((resolve2) => {
                    const request = this._queueLoadingCallback(resolve2);
                    this._prepareFontLoadEvent(font, request);
                  });
                }
              }
              get isFontLoadingAPISupported() {
                var _a3;
                const hasFonts = !!((_a3 = this._document) == null ? void 0 : _a3.fonts);
                return (0, _util2.shadow)(this, "isFontLoadingAPISupported", hasFonts);
              }
              get isSyncFontLoadingSupported() {
                let supported = false;
                if (_util2.isNodeJS) {
                  supported = true;
                } else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) {
                  supported = true;
                }
                return (0, _util2.shadow)(this, "isSyncFontLoadingSupported", supported);
              }
              _queueLoadingCallback(callback) {
                function completeRequest() {
                  (0, _util2.assert)(!request.done, "completeRequest() cannot be called twice.");
                  request.done = true;
                  while (loadingRequests.length > 0 && loadingRequests[0].done) {
                    const otherRequest = loadingRequests.shift();
                    setTimeout(otherRequest.callback, 0);
                  }
                }
                const {
                  loadingRequests
                } = this;
                const request = {
                  done: false,
                  complete: completeRequest,
                  callback
                };
                loadingRequests.push(request);
                return request;
              }
              get _loadTestFont() {
                const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                return (0, _util2.shadow)(this, "_loadTestFont", testFont);
              }
              _prepareFontLoadEvent(font, request) {
                function int32(data3, offset) {
                  return data3.charCodeAt(offset) << 24 | data3.charCodeAt(offset + 1) << 16 | data3.charCodeAt(offset + 2) << 8 | data3.charCodeAt(offset + 3) & 255;
                }
                function spliceString(s2, offset, remove6, insert4) {
                  const chunk1 = s2.substring(0, offset);
                  const chunk2 = s2.substring(offset + remove6);
                  return chunk1 + insert4 + chunk2;
                }
                let i2, ii2;
                const canvas2 = this._document.createElement("canvas");
                canvas2.width = 1;
                canvas2.height = 1;
                const ctx2 = canvas2.getContext("2d");
                let called = 0;
                function isFontReady(name2, callback) {
                  if (++called > 30) {
                    (0, _util2.warn)("Load test font never loaded.");
                    callback();
                    return;
                  }
                  ctx2.font = "30px " + name2;
                  ctx2.fillText(".", 0, 20);
                  const imageData = ctx2.getImageData(0, 0, 1, 1);
                  if (imageData.data[3] > 0) {
                    callback();
                    return;
                  }
                  setTimeout(isFontReady.bind(null, name2, callback));
                }
                const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                let data2 = this._loadTestFont;
                const COMMENT_OFFSET = 976;
                data2 = spliceString(data2, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                const CFF_CHECKSUM_OFFSET = 16;
                const XXXX_VALUE = 1482184792;
                let checksum = int32(data2, CFF_CHECKSUM_OFFSET);
                for (i2 = 0, ii2 = loadTestFontId.length - 3; i2 < ii2; i2 += 4) {
                  checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i2) | 0;
                }
                if (i2 < loadTestFontId.length) {
                  checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i2) | 0;
                }
                data2 = spliceString(data2, CFF_CHECKSUM_OFFSET, 4, (0, _util2.string32)(checksum));
                const url2 = `url(data:font/opentype;base64,${btoa(data2)});`;
                const rule = `@font-face {font-family:"${loadTestFontId}";src:${url2}}`;
                this.insertRule(rule);
                const div = this._document.createElement("div");
                div.style.visibility = "hidden";
                div.style.width = div.style.height = "10px";
                div.style.position = "absolute";
                div.style.top = div.style.left = "0px";
                for (const name2 of [font.loadedName, loadTestFontId]) {
                  const span = this._document.createElement("span");
                  span.textContent = "Hi";
                  span.style.fontFamily = name2;
                  div.append(span);
                }
                this._document.body.append(div);
                isFontReady(loadTestFontId, () => {
                  div.remove();
                  request.complete();
                });
              }
            }
            _systemFonts = new WeakMap();
            exports2.FontLoader = FontLoader2;
            class FontFaceObject {
              constructor(translatedData, {
                isEvalSupported = true,
                disableFontFace = false,
                ignoreErrors = false,
                inspectFont = null
              }) {
                this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
                for (const i2 in translatedData) {
                  this[i2] = translatedData[i2];
                }
                this.isEvalSupported = isEvalSupported !== false;
                this.disableFontFace = disableFontFace === true;
                this.ignoreErrors = ignoreErrors === true;
                this._inspectFont = inspectFont;
              }
              createNativeFontFace() {
                var _a3;
                if (!this.data || this.disableFontFace) {
                  return null;
                }
                let nativeFontFace;
                if (!this.cssFontInfo) {
                  nativeFontFace = new FontFace(this.loadedName, this.data, {});
                } else {
                  const css = {
                    weight: this.cssFontInfo.fontWeight
                  };
                  if (this.cssFontInfo.italicAngle) {
                    css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                  }
                  nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                }
                (_a3 = this._inspectFont) == null ? void 0 : _a3.call(this, this);
                return nativeFontFace;
              }
              createFontFaceRule() {
                var _a3;
                if (!this.data || this.disableFontFace) {
                  return null;
                }
                const data2 = (0, _util2.bytesToString)(this.data);
                const url2 = `url(data:${this.mimetype};base64,${btoa(data2)});`;
                let rule;
                if (!this.cssFontInfo) {
                  rule = `@font-face {font-family:"${this.loadedName}";src:${url2}}`;
                } else {
                  let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
                  if (this.cssFontInfo.italicAngle) {
                    css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                  }
                  rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url2}}`;
                }
                (_a3 = this._inspectFont) == null ? void 0 : _a3.call(this, this, url2);
                return rule;
              }
              getPathGenerator(objs, character) {
                if (this.compiledGlyphs[character] !== void 0) {
                  return this.compiledGlyphs[character];
                }
                let cmds;
                try {
                  cmds = objs.get(this.loadedName + "_path_" + character);
                } catch (ex) {
                  if (!this.ignoreErrors) {
                    throw ex;
                  }
                  (0, _util2.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                  return this.compiledGlyphs[character] = function(c2, size12) {
                  };
                }
                if (this.isEvalSupported && _util2.FeatureTest.isEvalSupported) {
                  const jsBuf = [];
                  for (const current of cmds) {
                    const args = current.args !== void 0 ? current.args.join(",") : "";
                    jsBuf.push("c.", current.cmd, "(", args, ");\n");
                  }
                  return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                }
                return this.compiledGlyphs[character] = function(c2, size12) {
                  for (const current of cmds) {
                    if (current.cmd === "scale") {
                      current.args = [size12, -size12];
                    }
                    c2[current.cmd].apply(c2, current.args);
                  }
                };
              }
            }
            exports2.FontFaceObject = FontFaceObject;
          },
          /* 10 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.NodeStandardFontDataFactory = exports2.NodeFilterFactory = exports2.NodeCanvasFactory = exports2.NodeCMapReaderFactory = void 0;
            var _base_factory = __w_pdfjs_require__2(7);
            __w_pdfjs_require__2(1);
            const fetchData = function(url2) {
              return new Promise((resolve2, reject) => {
                const fs2 = require$$1$2;
                fs2.readFile(url2, (error2, data2) => {
                  if (error2 || !data2) {
                    reject(new Error(error2));
                    return;
                  }
                  resolve2(new Uint8Array(data2));
                });
              });
            };
            class NodeFilterFactory extends _base_factory.BaseFilterFactory {
            }
            exports2.NodeFilterFactory = NodeFilterFactory;
            class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
              _createCanvas(width, height) {
                const Canvas3 = require$$1$2;
                return Canvas3.createCanvas(width, height);
              }
            }
            exports2.NodeCanvasFactory = NodeCanvasFactory;
            class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
              _fetchData(url2, compressionType) {
                return fetchData(url2).then((data2) => {
                  return {
                    cMapData: data2,
                    compressionType
                  };
                });
              }
            }
            exports2.NodeCMapReaderFactory = NodeCMapReaderFactory;
            class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
              _fetchData(url2) {
                return fetchData(url2);
              }
            }
            exports2.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
          },
          /* 11 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _restoreInitialState, restoreInitialState_fn, _drawFilter, drawFilter_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.CanvasGraphics = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _display_utils2 = __w_pdfjs_require__2(6);
            var _pattern_helper = __w_pdfjs_require__2(12);
            var _image_utils = __w_pdfjs_require__2(13);
            const MIN_FONT_SIZE = 16;
            const MAX_FONT_SIZE = 100;
            const MAX_GROUP_SIZE = 4096;
            const EXECUTION_TIME = 15;
            const EXECUTION_STEPS = 10;
            const MAX_SIZE_TO_COMPILE = 1e3;
            const FULL_CHUNK_HEIGHT = 16;
            function mirrorContextOperations(ctx2, destCtx) {
              if (ctx2._removeMirroring) {
                throw new Error("Context is already forwarding operations.");
              }
              ctx2.__originalSave = ctx2.save;
              ctx2.__originalRestore = ctx2.restore;
              ctx2.__originalRotate = ctx2.rotate;
              ctx2.__originalScale = ctx2.scale;
              ctx2.__originalTranslate = ctx2.translate;
              ctx2.__originalTransform = ctx2.transform;
              ctx2.__originalSetTransform = ctx2.setTransform;
              ctx2.__originalResetTransform = ctx2.resetTransform;
              ctx2.__originalClip = ctx2.clip;
              ctx2.__originalMoveTo = ctx2.moveTo;
              ctx2.__originalLineTo = ctx2.lineTo;
              ctx2.__originalBezierCurveTo = ctx2.bezierCurveTo;
              ctx2.__originalRect = ctx2.rect;
              ctx2.__originalClosePath = ctx2.closePath;
              ctx2.__originalBeginPath = ctx2.beginPath;
              ctx2._removeMirroring = () => {
                ctx2.save = ctx2.__originalSave;
                ctx2.restore = ctx2.__originalRestore;
                ctx2.rotate = ctx2.__originalRotate;
                ctx2.scale = ctx2.__originalScale;
                ctx2.translate = ctx2.__originalTranslate;
                ctx2.transform = ctx2.__originalTransform;
                ctx2.setTransform = ctx2.__originalSetTransform;
                ctx2.resetTransform = ctx2.__originalResetTransform;
                ctx2.clip = ctx2.__originalClip;
                ctx2.moveTo = ctx2.__originalMoveTo;
                ctx2.lineTo = ctx2.__originalLineTo;
                ctx2.bezierCurveTo = ctx2.__originalBezierCurveTo;
                ctx2.rect = ctx2.__originalRect;
                ctx2.closePath = ctx2.__originalClosePath;
                ctx2.beginPath = ctx2.__originalBeginPath;
                delete ctx2._removeMirroring;
              };
              ctx2.save = function ctxSave() {
                destCtx.save();
                this.__originalSave();
              };
              ctx2.restore = function ctxRestore() {
                destCtx.restore();
                this.__originalRestore();
              };
              ctx2.translate = function ctxTranslate(x2, y2) {
                destCtx.translate(x2, y2);
                this.__originalTranslate(x2, y2);
              };
              ctx2.scale = function ctxScale(x2, y2) {
                destCtx.scale(x2, y2);
                this.__originalScale(x2, y2);
              };
              ctx2.transform = function ctxTransform(a2, b2, c2, d2, e3, f2) {
                destCtx.transform(a2, b2, c2, d2, e3, f2);
                this.__originalTransform(a2, b2, c2, d2, e3, f2);
              };
              ctx2.setTransform = function ctxSetTransform(a2, b2, c2, d2, e3, f2) {
                destCtx.setTransform(a2, b2, c2, d2, e3, f2);
                this.__originalSetTransform(a2, b2, c2, d2, e3, f2);
              };
              ctx2.resetTransform = function ctxResetTransform() {
                destCtx.resetTransform();
                this.__originalResetTransform();
              };
              ctx2.rotate = function ctxRotate(angle4) {
                destCtx.rotate(angle4);
                this.__originalRotate(angle4);
              };
              ctx2.clip = function ctxRotate(rule) {
                destCtx.clip(rule);
                this.__originalClip(rule);
              };
              ctx2.moveTo = function(x2, y2) {
                destCtx.moveTo(x2, y2);
                this.__originalMoveTo(x2, y2);
              };
              ctx2.lineTo = function(x2, y2) {
                destCtx.lineTo(x2, y2);
                this.__originalLineTo(x2, y2);
              };
              ctx2.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x2, y2) {
                destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2);
                this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x2, y2);
              };
              ctx2.rect = function(x2, y2, width, height) {
                destCtx.rect(x2, y2, width, height);
                this.__originalRect(x2, y2, width, height);
              };
              ctx2.closePath = function() {
                destCtx.closePath();
                this.__originalClosePath();
              };
              ctx2.beginPath = function() {
                destCtx.beginPath();
                this.__originalBeginPath();
              };
            }
            class CachedCanvases {
              constructor(canvasFactory) {
                this.canvasFactory = canvasFactory;
                this.cache = /* @__PURE__ */ Object.create(null);
              }
              getCanvas(id, width, height) {
                let canvasEntry;
                if (this.cache[id] !== void 0) {
                  canvasEntry = this.cache[id];
                  this.canvasFactory.reset(canvasEntry, width, height);
                } else {
                  canvasEntry = this.canvasFactory.create(width, height);
                  this.cache[id] = canvasEntry;
                }
                return canvasEntry;
              }
              delete(id) {
                delete this.cache[id];
              }
              clear() {
                for (const id in this.cache) {
                  const canvasEntry = this.cache[id];
                  this.canvasFactory.destroy(canvasEntry);
                  delete this.cache[id];
                }
              }
            }
            function drawImageAtIntegerCoords(ctx2, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
              const [a2, b2, c2, d2, tx, ty] = (0, _display_utils2.getCurrentTransform)(ctx2);
              if (b2 === 0 && c2 === 0) {
                const tlX = destX * a2 + tx;
                const rTlX = Math.round(tlX);
                const tlY = destY * d2 + ty;
                const rTlY = Math.round(tlY);
                const brX = (destX + destW) * a2 + tx;
                const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                const brY = (destY + destH) * d2 + ty;
                const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                ctx2.setTransform(Math.sign(a2), 0, 0, Math.sign(d2), rTlX, rTlY);
                ctx2.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                ctx2.setTransform(a2, b2, c2, d2, tx, ty);
                return [rWidth, rHeight];
              }
              if (a2 === 0 && d2 === 0) {
                const tlX = destY * c2 + tx;
                const rTlX = Math.round(tlX);
                const tlY = destX * b2 + ty;
                const rTlY = Math.round(tlY);
                const brX = (destY + destH) * c2 + tx;
                const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                const brY = (destX + destW) * b2 + ty;
                const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                ctx2.setTransform(0, Math.sign(b2), Math.sign(c2), 0, rTlX, rTlY);
                ctx2.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                ctx2.setTransform(a2, b2, c2, d2, tx, ty);
                return [rHeight, rWidth];
              }
              ctx2.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
              const scaleX3 = Math.hypot(a2, b2);
              const scaleY3 = Math.hypot(c2, d2);
              return [scaleX3 * destW, scaleY3 * destH];
            }
            function compileType3Glyph(imgData) {
              const {
                width,
                height
              } = imgData;
              if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) {
                return null;
              }
              const POINT_TO_PROCESS_LIMIT = 1e3;
              const POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
              const width1 = width + 1;
              let points2 = new Uint8Array(width1 * (height + 1));
              let i2, j2, j0;
              const lineSize = width + 7 & ~7;
              let data2 = new Uint8Array(lineSize * height), pos = 0;
              for (const elem of imgData.data) {
                let mask = 128;
                while (mask > 0) {
                  data2[pos++] = elem & mask ? 0 : 255;
                  mask >>= 1;
                }
              }
              let count3 = 0;
              pos = 0;
              if (data2[pos] !== 0) {
                points2[0] = 1;
                ++count3;
              }
              for (j2 = 1; j2 < width; j2++) {
                if (data2[pos] !== data2[pos + 1]) {
                  points2[j2] = data2[pos] ? 2 : 1;
                  ++count3;
                }
                pos++;
              }
              if (data2[pos] !== 0) {
                points2[j2] = 2;
                ++count3;
              }
              for (i2 = 1; i2 < height; i2++) {
                pos = i2 * lineSize;
                j0 = i2 * width1;
                if (data2[pos - lineSize] !== data2[pos]) {
                  points2[j0] = data2[pos] ? 1 : 8;
                  ++count3;
                }
                let sum2 = (data2[pos] ? 4 : 0) + (data2[pos - lineSize] ? 8 : 0);
                for (j2 = 1; j2 < width; j2++) {
                  sum2 = (sum2 >> 2) + (data2[pos + 1] ? 4 : 0) + (data2[pos - lineSize + 1] ? 8 : 0);
                  if (POINT_TYPES[sum2]) {
                    points2[j0 + j2] = POINT_TYPES[sum2];
                    ++count3;
                  }
                  pos++;
                }
                if (data2[pos - lineSize] !== data2[pos]) {
                  points2[j0 + j2] = data2[pos] ? 2 : 4;
                  ++count3;
                }
                if (count3 > POINT_TO_PROCESS_LIMIT) {
                  return null;
                }
              }
              pos = lineSize * (height - 1);
              j0 = i2 * width1;
              if (data2[pos] !== 0) {
                points2[j0] = 8;
                ++count3;
              }
              for (j2 = 1; j2 < width; j2++) {
                if (data2[pos] !== data2[pos + 1]) {
                  points2[j0 + j2] = data2[pos] ? 4 : 8;
                  ++count3;
                }
                pos++;
              }
              if (data2[pos] !== 0) {
                points2[j0 + j2] = 4;
                ++count3;
              }
              if (count3 > POINT_TO_PROCESS_LIMIT) {
                return null;
              }
              const steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
              const path2 = new Path2D();
              for (i2 = 0; count3 && i2 <= height; i2++) {
                let p2 = i2 * width1;
                const end = p2 + width;
                while (p2 < end && !points2[p2]) {
                  p2++;
                }
                if (p2 === end) {
                  continue;
                }
                path2.moveTo(p2 % width1, i2);
                const p0 = p2;
                let type = points2[p2];
                do {
                  const step = steps[type];
                  do {
                    p2 += step;
                  } while (!points2[p2]);
                  const pp = points2[p2];
                  if (pp !== 5 && pp !== 10) {
                    type = pp;
                    points2[p2] = 0;
                  } else {
                    type = pp & 51 * type >> 4;
                    points2[p2] &= type >> 2 | type << 2;
                  }
                  path2.lineTo(p2 % width1, p2 / width1 | 0);
                  if (!points2[p2]) {
                    --count3;
                  }
                } while (p0 !== p2);
                --i2;
              }
              data2 = null;
              points2 = null;
              const drawOutline = function(c2) {
                c2.save();
                c2.scale(1 / width, -1 / height);
                c2.translate(0, -height);
                c2.fill(path2);
                c2.beginPath();
                c2.restore();
              };
              return drawOutline;
            }
            class CanvasExtraState {
              constructor(width, height) {
                this.alphaIsShape = false;
                this.fontSize = 0;
                this.fontSizeScale = 1;
                this.textMatrix = _util2.IDENTITY_MATRIX;
                this.textMatrixScale = 1;
                this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
                this.leading = 0;
                this.x = 0;
                this.y = 0;
                this.lineX = 0;
                this.lineY = 0;
                this.charSpacing = 0;
                this.wordSpacing = 0;
                this.textHScale = 1;
                this.textRenderingMode = _util2.TextRenderingMode.FILL;
                this.textRise = 0;
                this.fillColor = "#000000";
                this.strokeColor = "#000000";
                this.patternFill = false;
                this.fillAlpha = 1;
                this.strokeAlpha = 1;
                this.lineWidth = 1;
                this.activeSMask = null;
                this.transferMaps = "none";
                this.startNewPathAndClipBox([0, 0, width, height]);
              }
              clone() {
                const clone8 = Object.create(this);
                clone8.clipBox = this.clipBox.slice();
                return clone8;
              }
              setCurrentPoint(x2, y2) {
                this.x = x2;
                this.y = y2;
              }
              updatePathMinMax(transform4, x2, y2) {
                [x2, y2] = _util2.Util.applyTransform([x2, y2], transform4);
                this.minX = Math.min(this.minX, x2);
                this.minY = Math.min(this.minY, y2);
                this.maxX = Math.max(this.maxX, x2);
                this.maxY = Math.max(this.maxY, y2);
              }
              updateRectMinMax(transform4, rect) {
                const p1 = _util2.Util.applyTransform(rect, transform4);
                const p2 = _util2.Util.applyTransform(rect.slice(2), transform4);
                this.minX = Math.min(this.minX, p1[0], p2[0]);
                this.minY = Math.min(this.minY, p1[1], p2[1]);
                this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                this.maxY = Math.max(this.maxY, p1[1], p2[1]);
              }
              updateScalingPathMinMax(transform4, minMax) {
                _util2.Util.scaleMinMax(transform4, minMax);
                this.minX = Math.min(this.minX, minMax[0]);
                this.maxX = Math.max(this.maxX, minMax[1]);
                this.minY = Math.min(this.minY, minMax[2]);
                this.maxY = Math.max(this.maxY, minMax[3]);
              }
              updateCurvePathMinMax(transform4, x02, y02, x12, y12, x2, y2, x3, y3, minMax) {
                const box = _util2.Util.bezierBoundingBox(x02, y02, x12, y12, x2, y2, x3, y3);
                if (minMax) {
                  minMax[0] = Math.min(minMax[0], box[0], box[2]);
                  minMax[1] = Math.max(minMax[1], box[0], box[2]);
                  minMax[2] = Math.min(minMax[2], box[1], box[3]);
                  minMax[3] = Math.max(minMax[3], box[1], box[3]);
                  return;
                }
                this.updateRectMinMax(transform4, box);
              }
              getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform4 = null) {
                const box = [this.minX, this.minY, this.maxX, this.maxY];
                if (pathType === _pattern_helper.PathType.STROKE) {
                  if (!transform4) {
                    (0, _util2.unreachable)("Stroke bounding box must include transform.");
                  }
                  const scale5 = _util2.Util.singularValueDecompose2dScale(transform4);
                  const xStrokePad = scale5[0] * this.lineWidth / 2;
                  const yStrokePad = scale5[1] * this.lineWidth / 2;
                  box[0] -= xStrokePad;
                  box[1] -= yStrokePad;
                  box[2] += xStrokePad;
                  box[3] += yStrokePad;
                }
                return box;
              }
              updateClipFromPath() {
                const intersect2 = _util2.Util.intersect(this.clipBox, this.getPathBoundingBox());
                this.startNewPathAndClipBox(intersect2 || [0, 0, 0, 0]);
              }
              isEmptyClip() {
                return this.minX === Infinity;
              }
              startNewPathAndClipBox(box) {
                this.clipBox = box;
                this.minX = Infinity;
                this.minY = Infinity;
                this.maxX = 0;
                this.maxY = 0;
              }
              getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform4 = null) {
                return _util2.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform4));
              }
            }
            function putBinaryImageData(ctx2, imgData) {
              if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                ctx2.putImageData(imgData, 0, 0);
                return;
              }
              const height = imgData.height, width = imgData.width;
              const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
              const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
              const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
              const chunkImgData = ctx2.createImageData(width, FULL_CHUNK_HEIGHT);
              let srcPos = 0, destPos;
              const src2 = imgData.data;
              const dest = chunkImgData.data;
              let i2, j2, thisChunkHeight, elemsInThisChunk;
              if (imgData.kind === _util2.ImageKind.GRAYSCALE_1BPP) {
                const srcLength = src2.byteLength;
                const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                const dest32DataLength = dest32.length;
                const fullSrcDiff = width + 7 >> 3;
                const white = 4294967295;
                const black = _util2.FeatureTest.isLittleEndian ? 4278190080 : 255;
                for (i2 = 0; i2 < totalChunks; i2++) {
                  thisChunkHeight = i2 < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                  destPos = 0;
                  for (j2 = 0; j2 < thisChunkHeight; j2++) {
                    const srcDiff = srcLength - srcPos;
                    let k2 = 0;
                    const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                    const kEndUnrolled = kEnd & ~7;
                    let mask = 0;
                    let srcByte = 0;
                    for (; k2 < kEndUnrolled; k2 += 8) {
                      srcByte = src2[srcPos++];
                      dest32[destPos++] = srcByte & 128 ? white : black;
                      dest32[destPos++] = srcByte & 64 ? white : black;
                      dest32[destPos++] = srcByte & 32 ? white : black;
                      dest32[destPos++] = srcByte & 16 ? white : black;
                      dest32[destPos++] = srcByte & 8 ? white : black;
                      dest32[destPos++] = srcByte & 4 ? white : black;
                      dest32[destPos++] = srcByte & 2 ? white : black;
                      dest32[destPos++] = srcByte & 1 ? white : black;
                    }
                    for (; k2 < kEnd; k2++) {
                      if (mask === 0) {
                        srcByte = src2[srcPos++];
                        mask = 128;
                      }
                      dest32[destPos++] = srcByte & mask ? white : black;
                      mask >>= 1;
                    }
                  }
                  while (destPos < dest32DataLength) {
                    dest32[destPos++] = 0;
                  }
                  ctx2.putImageData(chunkImgData, 0, i2 * FULL_CHUNK_HEIGHT);
                }
              } else if (imgData.kind === _util2.ImageKind.RGBA_32BPP) {
                j2 = 0;
                elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                for (i2 = 0; i2 < fullChunks; i2++) {
                  dest.set(src2.subarray(srcPos, srcPos + elemsInThisChunk));
                  srcPos += elemsInThisChunk;
                  ctx2.putImageData(chunkImgData, 0, j2);
                  j2 += FULL_CHUNK_HEIGHT;
                }
                if (i2 < totalChunks) {
                  elemsInThisChunk = width * partialChunkHeight * 4;
                  dest.set(src2.subarray(srcPos, srcPos + elemsInThisChunk));
                  ctx2.putImageData(chunkImgData, 0, j2);
                }
              } else if (imgData.kind === _util2.ImageKind.RGB_24BPP) {
                thisChunkHeight = FULL_CHUNK_HEIGHT;
                elemsInThisChunk = width * thisChunkHeight;
                for (i2 = 0; i2 < totalChunks; i2++) {
                  if (i2 >= fullChunks) {
                    thisChunkHeight = partialChunkHeight;
                    elemsInThisChunk = width * thisChunkHeight;
                  }
                  destPos = 0;
                  for (j2 = elemsInThisChunk; j2--; ) {
                    dest[destPos++] = src2[srcPos++];
                    dest[destPos++] = src2[srcPos++];
                    dest[destPos++] = src2[srcPos++];
                    dest[destPos++] = 255;
                  }
                  ctx2.putImageData(chunkImgData, 0, i2 * FULL_CHUNK_HEIGHT);
                }
              } else {
                throw new Error(`bad image kind: ${imgData.kind}`);
              }
            }
            function putBinaryImageMask(ctx2, imgData) {
              if (imgData.bitmap) {
                ctx2.drawImage(imgData.bitmap, 0, 0);
                return;
              }
              const height = imgData.height, width = imgData.width;
              const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
              const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
              const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
              const chunkImgData = ctx2.createImageData(width, FULL_CHUNK_HEIGHT);
              let srcPos = 0;
              const src2 = imgData.data;
              const dest = chunkImgData.data;
              for (let i2 = 0; i2 < totalChunks; i2++) {
                const thisChunkHeight = i2 < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                ({
                  srcPos
                } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                  src: src2,
                  srcPos,
                  dest,
                  width,
                  height: thisChunkHeight,
                  nonBlackColor: 0
                }));
                ctx2.putImageData(chunkImgData, 0, i2 * FULL_CHUNK_HEIGHT);
              }
            }
            function copyCtxState(sourceCtx, destCtx) {
              const properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
              for (const property2 of properties) {
                if (sourceCtx[property2] !== void 0) {
                  destCtx[property2] = sourceCtx[property2];
                }
              }
              if (sourceCtx.setLineDash !== void 0) {
                destCtx.setLineDash(sourceCtx.getLineDash());
                destCtx.lineDashOffset = sourceCtx.lineDashOffset;
              }
            }
            function resetCtxToDefault(ctx2) {
              ctx2.strokeStyle = ctx2.fillStyle = "#000000";
              ctx2.fillRule = "nonzero";
              ctx2.globalAlpha = 1;
              ctx2.lineWidth = 1;
              ctx2.lineCap = "butt";
              ctx2.lineJoin = "miter";
              ctx2.miterLimit = 10;
              ctx2.globalCompositeOperation = "source-over";
              ctx2.font = "10px sans-serif";
              if (ctx2.setLineDash !== void 0) {
                ctx2.setLineDash([]);
                ctx2.lineDashOffset = 0;
              }
              if (!_util2.isNodeJS) {
                const {
                  filter: filter17
                } = ctx2;
                if (filter17 !== "none" && filter17 !== "") {
                  ctx2.filter = "none";
                }
              }
            }
            function composeSMaskBackdrop(bytes, r0, g0, b0) {
              const length2 = bytes.length;
              for (let i2 = 3; i2 < length2; i2 += 4) {
                const alpha = bytes[i2];
                if (alpha === 0) {
                  bytes[i2 - 3] = r0;
                  bytes[i2 - 2] = g0;
                  bytes[i2 - 1] = b0;
                } else if (alpha < 255) {
                  const alpha_ = 255 - alpha;
                  bytes[i2 - 3] = bytes[i2 - 3] * alpha + r0 * alpha_ >> 8;
                  bytes[i2 - 2] = bytes[i2 - 2] * alpha + g0 * alpha_ >> 8;
                  bytes[i2 - 1] = bytes[i2 - 1] * alpha + b0 * alpha_ >> 8;
                }
              }
            }
            function composeSMaskAlpha(maskData, layerData, transferMap) {
              const length2 = maskData.length;
              const scale5 = 1 / 255;
              for (let i2 = 3; i2 < length2; i2 += 4) {
                const alpha = transferMap ? transferMap[maskData[i2]] : maskData[i2];
                layerData[i2] = layerData[i2] * alpha * scale5 | 0;
              }
            }
            function composeSMaskLuminosity(maskData, layerData, transferMap) {
              const length2 = maskData.length;
              for (let i2 = 3; i2 < length2; i2 += 4) {
                const y2 = maskData[i2 - 3] * 77 + maskData[i2 - 2] * 152 + maskData[i2 - 1] * 28;
                layerData[i2] = transferMap ? layerData[i2] * transferMap[y2 >> 8] >> 8 : layerData[i2] * y2 >> 16;
              }
            }
            function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
              const hasBackdrop = !!backdrop;
              const r0 = hasBackdrop ? backdrop[0] : 0;
              const g0 = hasBackdrop ? backdrop[1] : 0;
              const b0 = hasBackdrop ? backdrop[2] : 0;
              const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
              const PIXELS_TO_PROCESS = 1048576;
              const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
              for (let row = 0; row < height; row += chunkSize) {
                const chunkHeight = Math.min(chunkSize, height - row);
                const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                if (hasBackdrop) {
                  composeSMaskBackdrop(maskData.data, r0, g0, b0);
                }
                composeFn(maskData.data, layerData.data, transferMap);
                layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
              }
            }
            function composeSMask(ctx2, smask, layerCtx, layerBox) {
              const layerOffsetX = layerBox[0];
              const layerOffsetY = layerBox[1];
              const layerWidth = layerBox[2] - layerOffsetX;
              const layerHeight = layerBox[3] - layerOffsetY;
              if (layerWidth === 0 || layerHeight === 0) {
                return;
              }
              genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
              ctx2.save();
              ctx2.globalAlpha = 1;
              ctx2.globalCompositeOperation = "source-over";
              ctx2.setTransform(1, 0, 0, 1, 0, 0);
              ctx2.drawImage(layerCtx.canvas, 0, 0);
              ctx2.restore();
            }
            function getImageSmoothingEnabled(transform4, interpolate2) {
              const scale5 = _util2.Util.singularValueDecompose2dScale(transform4);
              scale5[0] = Math.fround(scale5[0]);
              scale5[1] = Math.fround(scale5[1]);
              const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS);
              if (interpolate2 !== void 0) {
                return interpolate2;
              } else if (scale5[0] <= actualScale || scale5[1] <= actualScale) {
                return true;
              }
              return false;
            }
            const LINE_CAP_STYLES = ["butt", "round", "square"];
            const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
            const NORMAL_CLIP = {};
            const EO_CLIP = {};
            const _CanvasGraphics = class {
              constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, {
                optionalContentConfig,
                markedContentStack = null
              }, annotationCanvasMap, pageColors) {
                __privateAdd(this, _restoreInitialState);
                __privateAdd(this, _drawFilter);
                this.ctx = canvasCtx;
                this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                this.stateStack = [];
                this.pendingClip = null;
                this.pendingEOFill = false;
                this.res = null;
                this.xobjs = null;
                this.commonObjs = commonObjs;
                this.objs = objs;
                this.canvasFactory = canvasFactory;
                this.filterFactory = filterFactory;
                this.groupStack = [];
                this.processingType3 = null;
                this.baseTransform = null;
                this.baseTransformStack = [];
                this.groupLevel = 0;
                this.smaskStack = [];
                this.smaskCounter = 0;
                this.tempSMask = null;
                this.suspendedCtx = null;
                this.contentVisible = true;
                this.markedContentStack = markedContentStack || [];
                this.optionalContentConfig = optionalContentConfig;
                this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                this.cachedPatterns = /* @__PURE__ */ new Map();
                this.annotationCanvasMap = annotationCanvasMap;
                this.viewportScale = 1;
                this.outputScaleX = 1;
                this.outputScaleY = 1;
                this.pageColors = pageColors;
                this._cachedScaleForStroking = [-1, 0];
                this._cachedGetSinglePixelWidth = null;
                this._cachedBitmapsMap = /* @__PURE__ */ new Map();
              }
              getObject(data2, fallback = null) {
                if (typeof data2 === "string") {
                  return data2.startsWith("g_") ? this.commonObjs.get(data2) : this.objs.get(data2);
                }
                return fallback;
              }
              beginDrawing({
                transform: transform4,
                viewport,
                transparency = false,
                background = null
              }) {
                const width = this.ctx.canvas.width;
                const height = this.ctx.canvas.height;
                const savedFillStyle = this.ctx.fillStyle;
                this.ctx.fillStyle = background || "#ffffff";
                this.ctx.fillRect(0, 0, width, height);
                this.ctx.fillStyle = savedFillStyle;
                if (transparency) {
                  const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                  this.compositeCtx = this.ctx;
                  this.transparentCanvas = transparentCanvas.canvas;
                  this.ctx = transparentCanvas.context;
                  this.ctx.save();
                  this.ctx.transform(...(0, _display_utils2.getCurrentTransform)(this.compositeCtx));
                }
                this.ctx.save();
                resetCtxToDefault(this.ctx);
                if (transform4) {
                  this.ctx.transform(...transform4);
                  this.outputScaleX = transform4[0];
                  this.outputScaleY = transform4[0];
                }
                this.ctx.transform(...viewport.transform);
                this.viewportScale = viewport.scale;
                this.baseTransform = (0, _display_utils2.getCurrentTransform)(this.ctx);
              }
              executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                const argsArray = operatorList.argsArray;
                const fnArray = operatorList.fnArray;
                let i2 = executionStartIdx || 0;
                const argsArrayLen = argsArray.length;
                if (argsArrayLen === i2) {
                  return i2;
                }
                const chunkOperations = argsArrayLen - i2 > EXECUTION_STEPS && typeof continueCallback === "function";
                const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                let steps = 0;
                const commonObjs = this.commonObjs;
                const objs = this.objs;
                let fnId;
                while (true) {
                  if (stepper !== void 0 && i2 === stepper.nextBreakPoint) {
                    stepper.breakIt(i2, continueCallback);
                    return i2;
                  }
                  fnId = fnArray[i2];
                  if (fnId !== _util2.OPS.dependency) {
                    this[fnId].apply(this, argsArray[i2]);
                  } else {
                    for (const depObjId of argsArray[i2]) {
                      const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                      if (!objsPool.has(depObjId)) {
                        objsPool.get(depObjId, continueCallback);
                        return i2;
                      }
                    }
                  }
                  i2++;
                  if (i2 === argsArrayLen) {
                    return i2;
                  }
                  if (chunkOperations && ++steps > EXECUTION_STEPS) {
                    if (Date.now() > endTime) {
                      continueCallback();
                      return i2;
                    }
                    steps = 0;
                  }
                }
              }
              endDrawing() {
                __privateMethod(this, _restoreInitialState, restoreInitialState_fn).call(this);
                this.cachedCanvases.clear();
                this.cachedPatterns.clear();
                for (const cache2 of this._cachedBitmapsMap.values()) {
                  for (const canvas2 of cache2.values()) {
                    if (typeof HTMLCanvasElement !== "undefined" && canvas2 instanceof HTMLCanvasElement) {
                      canvas2.width = canvas2.height = 0;
                    }
                  }
                  cache2.clear();
                }
                this._cachedBitmapsMap.clear();
                __privateMethod(this, _drawFilter, drawFilter_fn).call(this);
              }
              _scaleImage(img, inverseTransform) {
                const width = img.width;
                const height = img.height;
                let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                let paintWidth = width, paintHeight = height;
                let tmpCanvasId = "prescale1";
                let tmpCanvas, tmpCtx;
                while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
                  let newWidth = paintWidth, newHeight = paintHeight;
                  if (widthScale > 2 && paintWidth > 1) {
                    newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                    widthScale /= paintWidth / newWidth;
                  }
                  if (heightScale > 2 && paintHeight > 1) {
                    newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                    heightScale /= paintHeight / newHeight;
                  }
                  tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                  tmpCtx = tmpCanvas.context;
                  tmpCtx.clearRect(0, 0, newWidth, newHeight);
                  tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                  img = tmpCanvas.canvas;
                  paintWidth = newWidth;
                  paintHeight = newHeight;
                  tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                }
                return {
                  img,
                  paintWidth,
                  paintHeight
                };
              }
              _createMaskCanvas(img) {
                const ctx2 = this.ctx;
                const {
                  width,
                  height
                } = img;
                const fillColor = this.current.fillColor;
                const isPatternFill = this.current.patternFill;
                const currentTransform = (0, _display_utils2.getCurrentTransform)(ctx2);
                let cache2, cacheKey, scaled, maskCanvas;
                if ((img.bitmap || img.data) && img.count > 1) {
                  const mainKey = img.bitmap || img.data.buffer;
                  cacheKey = JSON.stringify(isPatternFill ? currentTransform : [currentTransform.slice(0, 4), fillColor]);
                  cache2 = this._cachedBitmapsMap.get(mainKey);
                  if (!cache2) {
                    cache2 = /* @__PURE__ */ new Map();
                    this._cachedBitmapsMap.set(mainKey, cache2);
                  }
                  const cachedImage = cache2.get(cacheKey);
                  if (cachedImage && !isPatternFill) {
                    const offsetX2 = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                    const offsetY2 = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                    return {
                      canvas: cachedImage,
                      offsetX: offsetX2,
                      offsetY: offsetY2
                    };
                  }
                  scaled = cachedImage;
                }
                if (!scaled) {
                  maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                  putBinaryImageMask(maskCanvas.context, img);
                }
                let maskToCanvas = _util2.Util.transform(currentTransform, [1 / width, 0, 0, -1 / height, 0, 0]);
                maskToCanvas = _util2.Util.transform(maskToCanvas, [1, 0, 0, 1, 0, -height]);
                const cord1 = _util2.Util.applyTransform([0, 0], maskToCanvas);
                const cord2 = _util2.Util.applyTransform([width, height], maskToCanvas);
                const rect = _util2.Util.normalizeRect([cord1[0], cord1[1], cord2[0], cord2[1]]);
                const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                const fillCtx = fillCanvas.context;
                const offsetX = Math.min(cord1[0], cord2[0]);
                const offsetY = Math.min(cord1[1], cord2[1]);
                fillCtx.translate(-offsetX, -offsetY);
                fillCtx.transform(...maskToCanvas);
                if (!scaled) {
                  scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils2.getCurrentTransformInverse)(fillCtx));
                  scaled = scaled.img;
                  if (cache2 && isPatternFill) {
                    cache2.set(cacheKey, scaled);
                  }
                }
                fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils2.getCurrentTransform)(fillCtx), img.interpolate);
                drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                fillCtx.globalCompositeOperation = "source-in";
                const inverse2 = _util2.Util.transform((0, _display_utils2.getCurrentTransformInverse)(fillCtx), [1, 0, 0, 1, -offsetX, -offsetY]);
                fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx2, this, inverse2, _pattern_helper.PathType.FILL) : fillColor;
                fillCtx.fillRect(0, 0, width, height);
                if (cache2 && !isPatternFill) {
                  this.cachedCanvases.delete("fillCanvas");
                  cache2.set(cacheKey, fillCanvas.canvas);
                }
                return {
                  canvas: fillCanvas.canvas,
                  offsetX: Math.round(offsetX),
                  offsetY: Math.round(offsetY)
                };
              }
              setLineWidth(width) {
                if (width !== this.current.lineWidth) {
                  this._cachedScaleForStroking[0] = -1;
                }
                this.current.lineWidth = width;
                this.ctx.lineWidth = width;
              }
              setLineCap(style2) {
                this.ctx.lineCap = LINE_CAP_STYLES[style2];
              }
              setLineJoin(style2) {
                this.ctx.lineJoin = LINE_JOIN_STYLES[style2];
              }
              setMiterLimit(limit) {
                this.ctx.miterLimit = limit;
              }
              setDash(dashArray, dashPhase) {
                const ctx2 = this.ctx;
                if (ctx2.setLineDash !== void 0) {
                  ctx2.setLineDash(dashArray);
                  ctx2.lineDashOffset = dashPhase;
                }
              }
              setRenderingIntent(intent) {
              }
              setFlatness(flatness) {
              }
              setGState(states) {
                for (const [key, value] of states) {
                  switch (key) {
                    case "LW":
                      this.setLineWidth(value);
                      break;
                    case "LC":
                      this.setLineCap(value);
                      break;
                    case "LJ":
                      this.setLineJoin(value);
                      break;
                    case "ML":
                      this.setMiterLimit(value);
                      break;
                    case "D":
                      this.setDash(value[0], value[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(value);
                      break;
                    case "FL":
                      this.setFlatness(value);
                      break;
                    case "Font":
                      this.setFont(value[0], value[1]);
                      break;
                    case "CA":
                      this.current.strokeAlpha = value;
                      break;
                    case "ca":
                      this.current.fillAlpha = value;
                      this.ctx.globalAlpha = value;
                      break;
                    case "BM":
                      this.ctx.globalCompositeOperation = value;
                      break;
                    case "SMask":
                      this.current.activeSMask = value ? this.tempSMask : null;
                      this.tempSMask = null;
                      this.checkSMaskState();
                      break;
                    case "TR":
                      this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                      break;
                  }
                }
              }
              get inSMaskMode() {
                return !!this.suspendedCtx;
              }
              checkSMaskState() {
                const inSMaskMode = this.inSMaskMode;
                if (this.current.activeSMask && !inSMaskMode) {
                  this.beginSMaskMode();
                } else if (!this.current.activeSMask && inSMaskMode) {
                  this.endSMaskMode();
                }
              }
              beginSMaskMode() {
                if (this.inSMaskMode) {
                  throw new Error("beginSMaskMode called while already in smask mode");
                }
                const drawnWidth = this.ctx.canvas.width;
                const drawnHeight = this.ctx.canvas.height;
                const cacheId = "smaskGroupAt" + this.groupLevel;
                const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                this.suspendedCtx = this.ctx;
                this.ctx = scratchCanvas.context;
                const ctx2 = this.ctx;
                ctx2.setTransform(...(0, _display_utils2.getCurrentTransform)(this.suspendedCtx));
                copyCtxState(this.suspendedCtx, ctx2);
                mirrorContextOperations(ctx2, this.suspendedCtx);
                this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
              }
              endSMaskMode() {
                if (!this.inSMaskMode) {
                  throw new Error("endSMaskMode called while not in smask mode");
                }
                this.ctx._removeMirroring();
                copyCtxState(this.ctx, this.suspendedCtx);
                this.ctx = this.suspendedCtx;
                this.suspendedCtx = null;
              }
              compose(dirtyBox) {
                if (!this.current.activeSMask) {
                  return;
                }
                if (!dirtyBox) {
                  dirtyBox = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
                } else {
                  dirtyBox[0] = Math.floor(dirtyBox[0]);
                  dirtyBox[1] = Math.floor(dirtyBox[1]);
                  dirtyBox[2] = Math.ceil(dirtyBox[2]);
                  dirtyBox[3] = Math.ceil(dirtyBox[3]);
                }
                const smask = this.current.activeSMask;
                const suspendedCtx = this.suspendedCtx;
                composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                this.ctx.save();
                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                this.ctx.restore();
              }
              save() {
                if (this.inSMaskMode) {
                  copyCtxState(this.ctx, this.suspendedCtx);
                  this.suspendedCtx.save();
                } else {
                  this.ctx.save();
                }
                const old = this.current;
                this.stateStack.push(old);
                this.current = old.clone();
              }
              restore() {
                if (this.stateStack.length === 0 && this.inSMaskMode) {
                  this.endSMaskMode();
                }
                if (this.stateStack.length !== 0) {
                  this.current = this.stateStack.pop();
                  if (this.inSMaskMode) {
                    this.suspendedCtx.restore();
                    copyCtxState(this.suspendedCtx, this.ctx);
                  } else {
                    this.ctx.restore();
                  }
                  this.checkSMaskState();
                  this.pendingClip = null;
                  this._cachedScaleForStroking[0] = -1;
                  this._cachedGetSinglePixelWidth = null;
                }
              }
              transform(a2, b2, c2, d2, e3, f2) {
                this.ctx.transform(a2, b2, c2, d2, e3, f2);
                this._cachedScaleForStroking[0] = -1;
                this._cachedGetSinglePixelWidth = null;
              }
              constructPath(ops, args, minMax) {
                const ctx2 = this.ctx;
                const current = this.current;
                let x2 = current.x, y2 = current.y;
                let startX, startY;
                const currentTransform = (0, _display_utils2.getCurrentTransform)(ctx2);
                const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                for (let i2 = 0, j2 = 0, ii2 = ops.length; i2 < ii2; i2++) {
                  switch (ops[i2] | 0) {
                    case _util2.OPS.rectangle:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      const width = args[j2++];
                      const height = args[j2++];
                      const xw = x2 + width;
                      const yh = y2 + height;
                      ctx2.moveTo(x2, y2);
                      if (width === 0 || height === 0) {
                        ctx2.lineTo(xw, yh);
                      } else {
                        ctx2.lineTo(xw, y2);
                        ctx2.lineTo(xw, yh);
                        ctx2.lineTo(x2, yh);
                      }
                      if (!isScalingMatrix) {
                        current.updateRectMinMax(currentTransform, [x2, y2, xw, yh]);
                      }
                      ctx2.closePath();
                      break;
                    case _util2.OPS.moveTo:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      ctx2.moveTo(x2, y2);
                      if (!isScalingMatrix) {
                        current.updatePathMinMax(currentTransform, x2, y2);
                      }
                      break;
                    case _util2.OPS.lineTo:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      ctx2.lineTo(x2, y2);
                      if (!isScalingMatrix) {
                        current.updatePathMinMax(currentTransform, x2, y2);
                      }
                      break;
                    case _util2.OPS.curveTo:
                      startX = x2;
                      startY = y2;
                      x2 = args[j2 + 4];
                      y2 = args[j2 + 5];
                      ctx2.bezierCurveTo(args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3], x2, y2);
                      current.updateCurvePathMinMax(currentTransform, startX, startY, args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3], x2, y2, minMaxForBezier);
                      j2 += 6;
                      break;
                    case _util2.OPS.curveTo2:
                      startX = x2;
                      startY = y2;
                      ctx2.bezierCurveTo(x2, y2, args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3]);
                      current.updateCurvePathMinMax(currentTransform, startX, startY, x2, y2, args[j2], args[j2 + 1], args[j2 + 2], args[j2 + 3], minMaxForBezier);
                      x2 = args[j2 + 2];
                      y2 = args[j2 + 3];
                      j2 += 4;
                      break;
                    case _util2.OPS.curveTo3:
                      startX = x2;
                      startY = y2;
                      x2 = args[j2 + 2];
                      y2 = args[j2 + 3];
                      ctx2.bezierCurveTo(args[j2], args[j2 + 1], x2, y2, x2, y2);
                      current.updateCurvePathMinMax(currentTransform, startX, startY, args[j2], args[j2 + 1], x2, y2, x2, y2, minMaxForBezier);
                      j2 += 4;
                      break;
                    case _util2.OPS.closePath:
                      ctx2.closePath();
                      break;
                  }
                }
                if (isScalingMatrix) {
                  current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                }
                current.setCurrentPoint(x2, y2);
              }
              closePath() {
                this.ctx.closePath();
              }
              stroke(consumePath = true) {
                const ctx2 = this.ctx;
                const strokeColor = this.current.strokeColor;
                ctx2.globalAlpha = this.current.strokeAlpha;
                if (this.contentVisible) {
                  if (typeof strokeColor === "object" && (strokeColor == null ? void 0 : strokeColor.getPattern)) {
                    ctx2.save();
                    ctx2.strokeStyle = strokeColor.getPattern(ctx2, this, (0, _display_utils2.getCurrentTransformInverse)(ctx2), _pattern_helper.PathType.STROKE);
                    this.rescaleAndStroke(false);
                    ctx2.restore();
                  } else {
                    this.rescaleAndStroke(true);
                  }
                }
                if (consumePath) {
                  this.consumePath(this.current.getClippedPathBoundingBox());
                }
                ctx2.globalAlpha = this.current.fillAlpha;
              }
              closeStroke() {
                this.closePath();
                this.stroke();
              }
              fill(consumePath = true) {
                const ctx2 = this.ctx;
                const fillColor = this.current.fillColor;
                const isPatternFill = this.current.patternFill;
                let needRestore = false;
                if (isPatternFill) {
                  ctx2.save();
                  ctx2.fillStyle = fillColor.getPattern(ctx2, this, (0, _display_utils2.getCurrentTransformInverse)(ctx2), _pattern_helper.PathType.FILL);
                  needRestore = true;
                }
                const intersect2 = this.current.getClippedPathBoundingBox();
                if (this.contentVisible && intersect2 !== null) {
                  if (this.pendingEOFill) {
                    ctx2.fill("evenodd");
                    this.pendingEOFill = false;
                  } else {
                    ctx2.fill();
                  }
                }
                if (needRestore) {
                  ctx2.restore();
                }
                if (consumePath) {
                  this.consumePath(intersect2);
                }
              }
              eoFill() {
                this.pendingEOFill = true;
                this.fill();
              }
              fillStroke() {
                this.fill(false);
                this.stroke(false);
                this.consumePath();
              }
              eoFillStroke() {
                this.pendingEOFill = true;
                this.fillStroke();
              }
              closeFillStroke() {
                this.closePath();
                this.fillStroke();
              }
              closeEOFillStroke() {
                this.pendingEOFill = true;
                this.closePath();
                this.fillStroke();
              }
              endPath() {
                this.consumePath();
              }
              clip() {
                this.pendingClip = NORMAL_CLIP;
              }
              eoClip() {
                this.pendingClip = EO_CLIP;
              }
              beginText() {
                this.current.textMatrix = _util2.IDENTITY_MATRIX;
                this.current.textMatrixScale = 1;
                this.current.x = this.current.lineX = 0;
                this.current.y = this.current.lineY = 0;
              }
              endText() {
                const paths = this.pendingTextPaths;
                const ctx2 = this.ctx;
                if (paths === void 0) {
                  ctx2.beginPath();
                  return;
                }
                ctx2.save();
                ctx2.beginPath();
                for (const path2 of paths) {
                  ctx2.setTransform(...path2.transform);
                  ctx2.translate(path2.x, path2.y);
                  path2.addToPath(ctx2, path2.fontSize);
                }
                ctx2.restore();
                ctx2.clip();
                ctx2.beginPath();
                delete this.pendingTextPaths;
              }
              setCharSpacing(spacing) {
                this.current.charSpacing = spacing;
              }
              setWordSpacing(spacing) {
                this.current.wordSpacing = spacing;
              }
              setHScale(scale5) {
                this.current.textHScale = scale5 / 100;
              }
              setLeading(leading) {
                this.current.leading = -leading;
              }
              setFont(fontRefName, size12) {
                var _a3;
                const fontObj = this.commonObjs.get(fontRefName);
                const current = this.current;
                if (!fontObj) {
                  throw new Error(`Can't find font for ${fontRefName}`);
                }
                current.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
                  (0, _util2.warn)("Invalid font matrix for font " + fontRefName);
                }
                if (size12 < 0) {
                  size12 = -size12;
                  current.fontDirection = -1;
                } else {
                  current.fontDirection = 1;
                }
                this.current.font = fontObj;
                this.current.fontSize = size12;
                if (fontObj.isType3Font) {
                  return;
                }
                const name2 = fontObj.loadedName || "sans-serif";
                const typeface = ((_a3 = fontObj.systemFontInfo) == null ? void 0 : _a3.css) || `"${name2}", ${fontObj.fallbackName}`;
                let bold = "normal";
                if (fontObj.black) {
                  bold = "900";
                } else if (fontObj.bold) {
                  bold = "bold";
                }
                const italic = fontObj.italic ? "italic" : "normal";
                let browserFontSize = size12;
                if (size12 < MIN_FONT_SIZE) {
                  browserFontSize = MIN_FONT_SIZE;
                } else if (size12 > MAX_FONT_SIZE) {
                  browserFontSize = MAX_FONT_SIZE;
                }
                this.current.fontSizeScale = size12 / browserFontSize;
                this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
              }
              setTextRenderingMode(mode2) {
                this.current.textRenderingMode = mode2;
              }
              setTextRise(rise) {
                this.current.textRise = rise;
              }
              moveText(x2, y2) {
                this.current.x = this.current.lineX += x2;
                this.current.y = this.current.lineY += y2;
              }
              setLeadingMoveText(x2, y2) {
                this.setLeading(-y2);
                this.moveText(x2, y2);
              }
              setTextMatrix(a2, b2, c2, d2, e3, f2) {
                this.current.textMatrix = [a2, b2, c2, d2, e3, f2];
                this.current.textMatrixScale = Math.hypot(a2, b2);
                this.current.x = this.current.lineX = 0;
                this.current.y = this.current.lineY = 0;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              paintChar(character, x2, y2, patternTransform) {
                const ctx2 = this.ctx;
                const current = this.current;
                const font = current.font;
                const textRenderingMode = current.textRenderingMode;
                const fontSize = current.fontSize / current.fontSizeScale;
                const fillStrokeMode = textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                const isAddToPathSet = !!(textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG);
                const patternFill = current.patternFill && !font.missingFile;
                let addToPath;
                if (font.disableFontFace || isAddToPathSet || patternFill) {
                  addToPath = font.getPathGenerator(this.commonObjs, character);
                }
                if (font.disableFontFace || patternFill) {
                  ctx2.save();
                  ctx2.translate(x2, y2);
                  ctx2.beginPath();
                  addToPath(ctx2, fontSize);
                  if (patternTransform) {
                    ctx2.setTransform(...patternTransform);
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx2.fill();
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx2.stroke();
                  }
                  ctx2.restore();
                } else {
                  if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx2.fillText(character, x2, y2);
                  }
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    ctx2.strokeText(character, x2, y2);
                  }
                }
                if (isAddToPathSet) {
                  const paths = this.pendingTextPaths || (this.pendingTextPaths = []);
                  paths.push({
                    transform: (0, _display_utils2.getCurrentTransform)(ctx2),
                    x: x2,
                    y: y2,
                    fontSize,
                    addToPath
                  });
                }
              }
              get isFontSubpixelAAEnabled() {
                const {
                  context: ctx2
                } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                ctx2.scale(1.5, 1);
                ctx2.fillText("I", 0, 10);
                const data2 = ctx2.getImageData(0, 0, 10, 10).data;
                let enabled = false;
                for (let i2 = 3; i2 < data2.length; i2 += 4) {
                  if (data2[i2] > 0 && data2[i2] < 255) {
                    enabled = true;
                    break;
                  }
                }
                return (0, _util2.shadow)(this, "isFontSubpixelAAEnabled", enabled);
              }
              showText(glyphs) {
                const current = this.current;
                const font = current.font;
                if (font.isType3Font) {
                  return this.showType3Text(glyphs);
                }
                const fontSize = current.fontSize;
                if (fontSize === 0) {
                  return void 0;
                }
                const ctx2 = this.ctx;
                const fontSizeScale = current.fontSizeScale;
                const charSpacing = current.charSpacing;
                const wordSpacing = current.wordSpacing;
                const fontDirection = current.fontDirection;
                const textHScale = current.textHScale * fontDirection;
                const glyphsLength = glyphs.length;
                const vertical = font.vertical;
                const spacingDir = vertical ? 1 : -1;
                const defaultVMetrics = font.defaultVMetrics;
                const widthAdvanceScale = fontSize * current.fontMatrix[0];
                const simpleFillText = current.textRenderingMode === _util2.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                ctx2.save();
                ctx2.transform(...current.textMatrix);
                ctx2.translate(current.x, current.y + current.textRise);
                if (fontDirection > 0) {
                  ctx2.scale(textHScale, -1);
                } else {
                  ctx2.scale(textHScale, 1);
                }
                let patternTransform;
                if (current.patternFill) {
                  ctx2.save();
                  const pattern = current.fillColor.getPattern(ctx2, this, (0, _display_utils2.getCurrentTransformInverse)(ctx2), _pattern_helper.PathType.FILL);
                  patternTransform = (0, _display_utils2.getCurrentTransform)(ctx2);
                  ctx2.restore();
                  ctx2.fillStyle = pattern;
                }
                let lineWidth = current.lineWidth;
                const scale5 = current.textMatrixScale;
                if (scale5 === 0 || lineWidth === 0) {
                  const fillStrokeMode = current.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                  if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                    lineWidth = this.getSinglePixelWidth();
                  }
                } else {
                  lineWidth /= scale5;
                }
                if (fontSizeScale !== 1) {
                  ctx2.scale(fontSizeScale, fontSizeScale);
                  lineWidth /= fontSizeScale;
                }
                ctx2.lineWidth = lineWidth;
                if (font.isInvalidPDFjsFont) {
                  const chars2 = [];
                  let width = 0;
                  for (const glyph of glyphs) {
                    chars2.push(glyph.unicode);
                    width += glyph.width;
                  }
                  ctx2.fillText(chars2.join(""), 0, 0);
                  current.x += width * widthAdvanceScale * textHScale;
                  ctx2.restore();
                  this.compose();
                  return void 0;
                }
                let x2 = 0, i2;
                for (i2 = 0; i2 < glyphsLength; ++i2) {
                  const glyph = glyphs[i2];
                  if (typeof glyph === "number") {
                    x2 += spacingDir * glyph * fontSize / 1e3;
                    continue;
                  }
                  let restoreNeeded = false;
                  const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  const character = glyph.fontChar;
                  const accent = glyph.accent;
                  let scaledX, scaledY;
                  let width = glyph.width;
                  if (vertical) {
                    const vmetric = glyph.vmetric || defaultVMetrics;
                    const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                    const vy = vmetric[2] * widthAdvanceScale;
                    width = vmetric ? -vmetric[0] : width;
                    scaledX = vx / fontSizeScale;
                    scaledY = (x2 + vy) / fontSizeScale;
                  } else {
                    scaledX = x2 / fontSizeScale;
                    scaledY = 0;
                  }
                  if (font.remeasure && width > 0) {
                    const measuredWidth = ctx2.measureText(character).width * 1e3 / fontSize * fontSizeScale;
                    if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                      const characterScaleX = width / measuredWidth;
                      restoreNeeded = true;
                      ctx2.save();
                      ctx2.scale(characterScaleX, 1);
                      scaledX /= characterScaleX;
                    } else if (width !== measuredWidth) {
                      scaledX += (width - measuredWidth) / 2e3 * fontSize / fontSizeScale;
                    }
                  }
                  if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                    if (simpleFillText && !accent) {
                      ctx2.fillText(character, scaledX, scaledY);
                    } else {
                      this.paintChar(character, scaledX, scaledY, patternTransform);
                      if (accent) {
                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                      }
                    }
                  }
                  const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                  x2 += charWidth;
                  if (restoreNeeded) {
                    ctx2.restore();
                  }
                }
                if (vertical) {
                  current.y -= x2;
                } else {
                  current.x += x2 * textHScale;
                }
                ctx2.restore();
                this.compose();
                return void 0;
              }
              showType3Text(glyphs) {
                const ctx2 = this.ctx;
                const current = this.current;
                const font = current.font;
                const fontSize = current.fontSize;
                const fontDirection = current.fontDirection;
                const spacingDir = font.vertical ? 1 : -1;
                const charSpacing = current.charSpacing;
                const wordSpacing = current.wordSpacing;
                const textHScale = current.textHScale * fontDirection;
                const fontMatrix = current.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                const glyphsLength = glyphs.length;
                const isTextInvisible = current.textRenderingMode === _util2.TextRenderingMode.INVISIBLE;
                let i2, glyph, width, spacingLength;
                if (isTextInvisible || fontSize === 0) {
                  return;
                }
                this._cachedScaleForStroking[0] = -1;
                this._cachedGetSinglePixelWidth = null;
                ctx2.save();
                ctx2.transform(...current.textMatrix);
                ctx2.translate(current.x, current.y);
                ctx2.scale(textHScale, fontDirection);
                for (i2 = 0; i2 < glyphsLength; ++i2) {
                  glyph = glyphs[i2];
                  if (typeof glyph === "number") {
                    spacingLength = spacingDir * glyph * fontSize / 1e3;
                    this.ctx.translate(spacingLength, 0);
                    current.x += spacingLength * textHScale;
                    continue;
                  }
                  const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  const operatorList = font.charProcOperatorList[glyph.operatorListId];
                  if (!operatorList) {
                    (0, _util2.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                    continue;
                  }
                  if (this.contentVisible) {
                    this.processingType3 = glyph;
                    this.save();
                    ctx2.scale(fontSize, fontSize);
                    ctx2.transform(...fontMatrix);
                    this.executeOperatorList(operatorList);
                    this.restore();
                  }
                  const transformed = _util2.Util.applyTransform([glyph.width, 0], fontMatrix);
                  width = transformed[0] * fontSize + spacing;
                  ctx2.translate(width, 0);
                  current.x += width * textHScale;
                }
                ctx2.restore();
                this.processingType3 = null;
              }
              setCharWidth(xWidth, yWidth) {
              }
              setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                this.ctx.rect(llx, lly, urx - llx, ury - lly);
                this.ctx.clip();
                this.endPath();
              }
              getColorN_Pattern(IR) {
                let pattern;
                if (IR[0] === "TilingPattern") {
                  const color = IR[1];
                  const baseTransform = this.baseTransform || (0, _display_utils2.getCurrentTransform)(this.ctx);
                  const canvasGraphicsFactory = {
                    createCanvasGraphics: (ctx2) => {
                      return new _CanvasGraphics(ctx2, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                        optionalContentConfig: this.optionalContentConfig,
                        markedContentStack: this.markedContentStack
                      });
                    }
                  };
                  pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                } else {
                  pattern = this._getPattern(IR[1], IR[2]);
                }
                return pattern;
              }
              setStrokeColorN() {
                this.current.strokeColor = this.getColorN_Pattern(arguments);
              }
              setFillColorN() {
                this.current.fillColor = this.getColorN_Pattern(arguments);
                this.current.patternFill = true;
              }
              setStrokeRGBColor(r2, g2, b2) {
                const color = _util2.Util.makeHexColor(r2, g2, b2);
                this.ctx.strokeStyle = color;
                this.current.strokeColor = color;
              }
              setFillRGBColor(r2, g2, b2) {
                const color = _util2.Util.makeHexColor(r2, g2, b2);
                this.ctx.fillStyle = color;
                this.current.fillColor = color;
                this.current.patternFill = false;
              }
              _getPattern(objId, matrix = null) {
                let pattern;
                if (this.cachedPatterns.has(objId)) {
                  pattern = this.cachedPatterns.get(objId);
                } else {
                  pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                  this.cachedPatterns.set(objId, pattern);
                }
                if (matrix) {
                  pattern.matrix = matrix;
                }
                return pattern;
              }
              shadingFill(objId) {
                if (!this.contentVisible) {
                  return;
                }
                const ctx2 = this.ctx;
                this.save();
                const pattern = this._getPattern(objId);
                ctx2.fillStyle = pattern.getPattern(ctx2, this, (0, _display_utils2.getCurrentTransformInverse)(ctx2), _pattern_helper.PathType.SHADING);
                const inv = (0, _display_utils2.getCurrentTransformInverse)(ctx2);
                if (inv) {
                  const {
                    width,
                    height
                  } = ctx2.canvas;
                  const [x02, y02, x12, y12] = _util2.Util.getAxialAlignedBoundingBox([0, 0, width, height], inv);
                  this.ctx.fillRect(x02, y02, x12 - x02, y12 - y02);
                } else {
                  this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
                }
                this.compose(this.current.getClippedPathBoundingBox());
                this.restore();
              }
              beginInlineImage() {
                (0, _util2.unreachable)("Should not call beginInlineImage");
              }
              beginImageData() {
                (0, _util2.unreachable)("Should not call beginImageData");
              }
              paintFormXObjectBegin(matrix, bbox2) {
                if (!this.contentVisible) {
                  return;
                }
                this.save();
                this.baseTransformStack.push(this.baseTransform);
                if (Array.isArray(matrix) && matrix.length === 6) {
                  this.transform(...matrix);
                }
                this.baseTransform = (0, _display_utils2.getCurrentTransform)(this.ctx);
                if (bbox2) {
                  const width = bbox2[2] - bbox2[0];
                  const height = bbox2[3] - bbox2[1];
                  this.ctx.rect(bbox2[0], bbox2[1], width, height);
                  this.current.updateRectMinMax((0, _display_utils2.getCurrentTransform)(this.ctx), bbox2);
                  this.clip();
                  this.endPath();
                }
              }
              paintFormXObjectEnd() {
                if (!this.contentVisible) {
                  return;
                }
                this.restore();
                this.baseTransform = this.baseTransformStack.pop();
              }
              beginGroup(group) {
                if (!this.contentVisible) {
                  return;
                }
                this.save();
                if (this.inSMaskMode) {
                  this.endSMaskMode();
                  this.current.activeSMask = null;
                }
                const currentCtx = this.ctx;
                if (!group.isolated) {
                  (0, _util2.info)("TODO: Support non-isolated groups.");
                }
                if (group.knockout) {
                  (0, _util2.warn)("Knockout groups not supported.");
                }
                const currentTransform = (0, _display_utils2.getCurrentTransform)(currentCtx);
                if (group.matrix) {
                  currentCtx.transform(...group.matrix);
                }
                if (!group.bbox) {
                  throw new Error("Bounding box is required.");
                }
                let bounds = _util2.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils2.getCurrentTransform)(currentCtx));
                const canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
                bounds = _util2.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
                const offsetX = Math.floor(bounds[0]);
                const offsetY = Math.floor(bounds[1]);
                let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                let scaleX3 = 1, scaleY3 = 1;
                if (drawnWidth > MAX_GROUP_SIZE) {
                  scaleX3 = drawnWidth / MAX_GROUP_SIZE;
                  drawnWidth = MAX_GROUP_SIZE;
                }
                if (drawnHeight > MAX_GROUP_SIZE) {
                  scaleY3 = drawnHeight / MAX_GROUP_SIZE;
                  drawnHeight = MAX_GROUP_SIZE;
                }
                this.current.startNewPathAndClipBox([0, 0, drawnWidth, drawnHeight]);
                let cacheId = "groupAt" + this.groupLevel;
                if (group.smask) {
                  cacheId += "_smask_" + this.smaskCounter++ % 2;
                }
                const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                const groupCtx = scratchCanvas.context;
                groupCtx.scale(1 / scaleX3, 1 / scaleY3);
                groupCtx.translate(-offsetX, -offsetY);
                groupCtx.transform(...currentTransform);
                if (group.smask) {
                  this.smaskStack.push({
                    canvas: scratchCanvas.canvas,
                    context: groupCtx,
                    offsetX,
                    offsetY,
                    scaleX: scaleX3,
                    scaleY: scaleY3,
                    subtype: group.smask.subtype,
                    backdrop: group.smask.backdrop,
                    transferMap: group.smask.transferMap || null,
                    startTransformInverse: null
                  });
                } else {
                  currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                  currentCtx.translate(offsetX, offsetY);
                  currentCtx.scale(scaleX3, scaleY3);
                  currentCtx.save();
                }
                copyCtxState(currentCtx, groupCtx);
                this.ctx = groupCtx;
                this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
                this.groupStack.push(currentCtx);
                this.groupLevel++;
              }
              endGroup(group) {
                if (!this.contentVisible) {
                  return;
                }
                this.groupLevel--;
                const groupCtx = this.ctx;
                const ctx2 = this.groupStack.pop();
                this.ctx = ctx2;
                this.ctx.imageSmoothingEnabled = false;
                if (group.smask) {
                  this.tempSMask = this.smaskStack.pop();
                  this.restore();
                } else {
                  this.ctx.restore();
                  const currentMtx = (0, _display_utils2.getCurrentTransform)(this.ctx);
                  this.restore();
                  this.ctx.save();
                  this.ctx.setTransform(...currentMtx);
                  const dirtyBox = _util2.Util.getAxialAlignedBoundingBox([0, 0, groupCtx.canvas.width, groupCtx.canvas.height], currentMtx);
                  this.ctx.drawImage(groupCtx.canvas, 0, 0);
                  this.ctx.restore();
                  this.compose(dirtyBox);
                }
              }
              beginAnnotation(id, rect, transform4, matrix, hasOwnCanvas) {
                __privateMethod(this, _restoreInitialState, restoreInitialState_fn).call(this);
                resetCtxToDefault(this.ctx);
                this.ctx.save();
                this.save();
                if (this.baseTransform) {
                  this.ctx.setTransform(...this.baseTransform);
                }
                if (Array.isArray(rect) && rect.length === 4) {
                  const width = rect[2] - rect[0];
                  const height = rect[3] - rect[1];
                  if (hasOwnCanvas && this.annotationCanvasMap) {
                    transform4 = transform4.slice();
                    transform4[4] -= rect[0];
                    transform4[5] -= rect[1];
                    rect = rect.slice();
                    rect[0] = rect[1] = 0;
                    rect[2] = width;
                    rect[3] = height;
                    const [scaleX3, scaleY3] = _util2.Util.singularValueDecompose2dScale((0, _display_utils2.getCurrentTransform)(this.ctx));
                    const {
                      viewportScale
                    } = this;
                    const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                    const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                    this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                    const {
                      canvas: canvas2,
                      context: context2
                    } = this.annotationCanvas;
                    this.annotationCanvasMap.set(id, canvas2);
                    this.annotationCanvas.savedCtx = this.ctx;
                    this.ctx = context2;
                    this.ctx.save();
                    this.ctx.setTransform(scaleX3, 0, 0, -scaleY3, 0, height * scaleY3);
                    resetCtxToDefault(this.ctx);
                  } else {
                    resetCtxToDefault(this.ctx);
                    this.ctx.rect(rect[0], rect[1], width, height);
                    this.ctx.clip();
                    this.endPath();
                  }
                }
                this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                this.transform(...transform4);
                this.transform(...matrix);
              }
              endAnnotation() {
                if (this.annotationCanvas) {
                  this.ctx.restore();
                  __privateMethod(this, _drawFilter, drawFilter_fn).call(this);
                  this.ctx = this.annotationCanvas.savedCtx;
                  delete this.annotationCanvas.savedCtx;
                  delete this.annotationCanvas;
                }
              }
              paintImageMaskXObject(img) {
                if (!this.contentVisible) {
                  return;
                }
                const count3 = img.count;
                img = this.getObject(img.data, img);
                img.count = count3;
                const ctx2 = this.ctx;
                const glyph = this.processingType3;
                if (glyph) {
                  if (glyph.compiled === void 0) {
                    glyph.compiled = compileType3Glyph(img);
                  }
                  if (glyph.compiled) {
                    glyph.compiled(ctx2);
                    return;
                  }
                }
                const mask = this._createMaskCanvas(img);
                const maskCanvas = mask.canvas;
                ctx2.save();
                ctx2.setTransform(1, 0, 0, 1, 0, 0);
                ctx2.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                ctx2.restore();
                this.compose();
              }
              paintImageMaskXObjectRepeat(img, scaleX3, skewX = 0, skewY = 0, scaleY3, positions) {
                if (!this.contentVisible) {
                  return;
                }
                img = this.getObject(img.data, img);
                const ctx2 = this.ctx;
                ctx2.save();
                const currentTransform = (0, _display_utils2.getCurrentTransform)(ctx2);
                ctx2.transform(scaleX3, skewX, skewY, scaleY3, 0, 0);
                const mask = this._createMaskCanvas(img);
                ctx2.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                for (let i2 = 0, ii2 = positions.length; i2 < ii2; i2 += 2) {
                  const trans = _util2.Util.transform(currentTransform, [scaleX3, skewX, skewY, scaleY3, positions[i2], positions[i2 + 1]]);
                  const [x2, y2] = _util2.Util.applyTransform([0, 0], trans);
                  ctx2.drawImage(mask.canvas, x2, y2);
                }
                ctx2.restore();
                this.compose();
              }
              paintImageMaskXObjectGroup(images) {
                if (!this.contentVisible) {
                  return;
                }
                const ctx2 = this.ctx;
                const fillColor = this.current.fillColor;
                const isPatternFill = this.current.patternFill;
                for (const image of images) {
                  const {
                    data: data2,
                    width,
                    height,
                    transform: transform4
                  } = image;
                  const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                  const maskCtx = maskCanvas.context;
                  maskCtx.save();
                  const img = this.getObject(data2, image);
                  putBinaryImageMask(maskCtx, img);
                  maskCtx.globalCompositeOperation = "source-in";
                  maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils2.getCurrentTransformInverse)(ctx2), _pattern_helper.PathType.FILL) : fillColor;
                  maskCtx.fillRect(0, 0, width, height);
                  maskCtx.restore();
                  ctx2.save();
                  ctx2.transform(...transform4);
                  ctx2.scale(1, -1);
                  drawImageAtIntegerCoords(ctx2, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                  ctx2.restore();
                }
                this.compose();
              }
              paintImageXObject(objId) {
                if (!this.contentVisible) {
                  return;
                }
                const imgData = this.getObject(objId);
                if (!imgData) {
                  (0, _util2.warn)("Dependent image isn't ready yet");
                  return;
                }
                this.paintInlineImageXObject(imgData);
              }
              paintImageXObjectRepeat(objId, scaleX3, scaleY3, positions) {
                if (!this.contentVisible) {
                  return;
                }
                const imgData = this.getObject(objId);
                if (!imgData) {
                  (0, _util2.warn)("Dependent image isn't ready yet");
                  return;
                }
                const width = imgData.width;
                const height = imgData.height;
                const map5 = [];
                for (let i2 = 0, ii2 = positions.length; i2 < ii2; i2 += 2) {
                  map5.push({
                    transform: [scaleX3, 0, 0, scaleY3, positions[i2], positions[i2 + 1]],
                    x: 0,
                    y: 0,
                    w: width,
                    h: height
                  });
                }
                this.paintInlineImageXObjectGroup(imgData, map5);
              }
              applyTransferMapsToCanvas(ctx2) {
                if (this.current.transferMaps !== "none") {
                  ctx2.filter = this.current.transferMaps;
                  ctx2.drawImage(ctx2.canvas, 0, 0);
                  ctx2.filter = "none";
                }
                return ctx2.canvas;
              }
              applyTransferMapsToBitmap(imgData) {
                if (this.current.transferMaps === "none") {
                  return imgData.bitmap;
                }
                const {
                  bitmap,
                  width,
                  height
                } = imgData;
                const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                const tmpCtx = tmpCanvas.context;
                tmpCtx.filter = this.current.transferMaps;
                tmpCtx.drawImage(bitmap, 0, 0);
                tmpCtx.filter = "none";
                return tmpCanvas.canvas;
              }
              paintInlineImageXObject(imgData) {
                if (!this.contentVisible) {
                  return;
                }
                const width = imgData.width;
                const height = imgData.height;
                const ctx2 = this.ctx;
                this.save();
                if (!_util2.isNodeJS) {
                  const {
                    filter: filter17
                  } = ctx2;
                  if (filter17 !== "none" && filter17 !== "") {
                    ctx2.filter = "none";
                  }
                }
                ctx2.scale(1 / width, -1 / height);
                let imgToPaint;
                if (imgData.bitmap) {
                  imgToPaint = this.applyTransferMapsToBitmap(imgData);
                } else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
                  imgToPaint = imgData;
                } else {
                  const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                  const tmpCtx = tmpCanvas.context;
                  putBinaryImageData(tmpCtx, imgData);
                  imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                }
                const scaled = this._scaleImage(imgToPaint, (0, _display_utils2.getCurrentTransformInverse)(ctx2));
                ctx2.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils2.getCurrentTransform)(ctx2), imgData.interpolate);
                drawImageAtIntegerCoords(ctx2, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                this.compose();
                this.restore();
              }
              paintInlineImageXObjectGroup(imgData, map5) {
                if (!this.contentVisible) {
                  return;
                }
                const ctx2 = this.ctx;
                let imgToPaint;
                if (imgData.bitmap) {
                  imgToPaint = imgData.bitmap;
                } else {
                  const w2 = imgData.width;
                  const h2 = imgData.height;
                  const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w2, h2);
                  const tmpCtx = tmpCanvas.context;
                  putBinaryImageData(tmpCtx, imgData);
                  imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                }
                for (const entry of map5) {
                  ctx2.save();
                  ctx2.transform(...entry.transform);
                  ctx2.scale(1, -1);
                  drawImageAtIntegerCoords(ctx2, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                  ctx2.restore();
                }
                this.compose();
              }
              paintSolidColorImageMask() {
                if (!this.contentVisible) {
                  return;
                }
                this.ctx.fillRect(0, 0, 1, 1);
                this.compose();
              }
              markPoint(tag2) {
              }
              markPointProps(tag2, properties) {
              }
              beginMarkedContent(tag2) {
                this.markedContentStack.push({
                  visible: true
                });
              }
              beginMarkedContentProps(tag2, properties) {
                if (tag2 === "OC") {
                  this.markedContentStack.push({
                    visible: this.optionalContentConfig.isVisible(properties)
                  });
                } else {
                  this.markedContentStack.push({
                    visible: true
                  });
                }
                this.contentVisible = this.isContentVisible();
              }
              endMarkedContent() {
                this.markedContentStack.pop();
                this.contentVisible = this.isContentVisible();
              }
              beginCompat() {
              }
              endCompat() {
              }
              consumePath(clipBox) {
                const isEmpty6 = this.current.isEmptyClip();
                if (this.pendingClip) {
                  this.current.updateClipFromPath();
                }
                if (!this.pendingClip) {
                  this.compose(clipBox);
                }
                const ctx2 = this.ctx;
                if (this.pendingClip) {
                  if (!isEmpty6) {
                    if (this.pendingClip === EO_CLIP) {
                      ctx2.clip("evenodd");
                    } else {
                      ctx2.clip();
                    }
                  }
                  this.pendingClip = null;
                }
                this.current.startNewPathAndClipBox(this.current.clipBox);
                ctx2.beginPath();
              }
              getSinglePixelWidth() {
                if (!this._cachedGetSinglePixelWidth) {
                  const m2 = (0, _display_utils2.getCurrentTransform)(this.ctx);
                  if (m2[1] === 0 && m2[2] === 0) {
                    this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m2[0]), Math.abs(m2[3]));
                  } else {
                    const absDet = Math.abs(m2[0] * m2[3] - m2[2] * m2[1]);
                    const normX = Math.hypot(m2[0], m2[2]);
                    const normY = Math.hypot(m2[1], m2[3]);
                    this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                  }
                }
                return this._cachedGetSinglePixelWidth;
              }
              getScaleForStroking() {
                if (this._cachedScaleForStroking[0] === -1) {
                  const {
                    lineWidth
                  } = this.current;
                  const {
                    a: a2,
                    b: b2,
                    c: c2,
                    d: d2
                  } = this.ctx.getTransform();
                  let scaleX3, scaleY3;
                  if (b2 === 0 && c2 === 0) {
                    const normX = Math.abs(a2);
                    const normY = Math.abs(d2);
                    if (normX === normY) {
                      if (lineWidth === 0) {
                        scaleX3 = scaleY3 = 1 / normX;
                      } else {
                        const scaledLineWidth = normX * lineWidth;
                        scaleX3 = scaleY3 = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                      }
                    } else if (lineWidth === 0) {
                      scaleX3 = 1 / normX;
                      scaleY3 = 1 / normY;
                    } else {
                      const scaledXLineWidth = normX * lineWidth;
                      const scaledYLineWidth = normY * lineWidth;
                      scaleX3 = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                      scaleY3 = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                    }
                  } else {
                    const absDet = Math.abs(a2 * d2 - b2 * c2);
                    const normX = Math.hypot(a2, b2);
                    const normY = Math.hypot(c2, d2);
                    if (lineWidth === 0) {
                      scaleX3 = normY / absDet;
                      scaleY3 = normX / absDet;
                    } else {
                      const baseArea = lineWidth * absDet;
                      scaleX3 = normY > baseArea ? normY / baseArea : 1;
                      scaleY3 = normX > baseArea ? normX / baseArea : 1;
                    }
                  }
                  this._cachedScaleForStroking[0] = scaleX3;
                  this._cachedScaleForStroking[1] = scaleY3;
                }
                return this._cachedScaleForStroking;
              }
              rescaleAndStroke(saveRestore) {
                const {
                  ctx: ctx2
                } = this;
                const {
                  lineWidth
                } = this.current;
                const [scaleX3, scaleY3] = this.getScaleForStroking();
                ctx2.lineWidth = lineWidth || 1;
                if (scaleX3 === 1 && scaleY3 === 1) {
                  ctx2.stroke();
                  return;
                }
                const dashes = ctx2.getLineDash();
                if (saveRestore) {
                  ctx2.save();
                }
                ctx2.scale(scaleX3, scaleY3);
                if (dashes.length > 0) {
                  const scale5 = Math.max(scaleX3, scaleY3);
                  ctx2.setLineDash(dashes.map((x2) => x2 / scale5));
                  ctx2.lineDashOffset /= scale5;
                }
                ctx2.stroke();
                if (saveRestore) {
                  ctx2.restore();
                }
              }
              isContentVisible() {
                for (let i2 = this.markedContentStack.length - 1; i2 >= 0; i2--) {
                  if (!this.markedContentStack[i2].visible) {
                    return false;
                  }
                }
                return true;
              }
            };
            let CanvasGraphics = _CanvasGraphics;
            _restoreInitialState = new WeakSet();
            restoreInitialState_fn = function() {
              while (this.stateStack.length || this.inSMaskMode) {
                this.restore();
              }
              this.ctx.restore();
              if (this.transparentCanvas) {
                this.ctx = this.compositeCtx;
                this.ctx.save();
                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                this.ctx.drawImage(this.transparentCanvas, 0, 0);
                this.ctx.restore();
                this.transparentCanvas = null;
              }
            };
            _drawFilter = new WeakSet();
            drawFilter_fn = function() {
              if (this.pageColors) {
                const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                if (hcmFilterId !== "none") {
                  const savedFilter = this.ctx.filter;
                  this.ctx.filter = hcmFilterId;
                  this.ctx.drawImage(this.ctx.canvas, 0, 0);
                  this.ctx.filter = savedFilter;
                }
              }
            };
            exports2.CanvasGraphics = CanvasGraphics;
            for (const op in _util2.OPS) {
              if (CanvasGraphics.prototype[op] !== void 0) {
                CanvasGraphics.prototype[_util2.OPS[op]] = CanvasGraphics.prototype[op];
              }
            }
          },
          /* 12 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.TilingPattern = exports2.PathType = void 0;
            exports2.getShadingPattern = getShadingPattern;
            var _util2 = __w_pdfjs_require__2(1);
            var _display_utils2 = __w_pdfjs_require__2(6);
            const PathType = {
              FILL: "Fill",
              STROKE: "Stroke",
              SHADING: "Shading"
            };
            exports2.PathType = PathType;
            function applyBoundingBox(ctx2, bbox2) {
              if (!bbox2) {
                return;
              }
              const width = bbox2[2] - bbox2[0];
              const height = bbox2[3] - bbox2[1];
              const region = new Path2D();
              region.rect(bbox2[0], bbox2[1], width, height);
              ctx2.clip(region);
            }
            class BaseShadingPattern {
              constructor() {
                if (this.constructor === BaseShadingPattern) {
                  (0, _util2.unreachable)("Cannot initialize BaseShadingPattern.");
                }
              }
              getPattern() {
                (0, _util2.unreachable)("Abstract method `getPattern` called.");
              }
            }
            class RadialAxialShadingPattern extends BaseShadingPattern {
              constructor(IR) {
                super();
                this._type = IR[1];
                this._bbox = IR[2];
                this._colorStops = IR[3];
                this._p0 = IR[4];
                this._p1 = IR[5];
                this._r0 = IR[6];
                this._r1 = IR[7];
                this.matrix = null;
              }
              _createGradient(ctx2) {
                let grad;
                if (this._type === "axial") {
                  grad = ctx2.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                } else if (this._type === "radial") {
                  grad = ctx2.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                }
                for (const colorStop of this._colorStops) {
                  grad.addColorStop(colorStop[0], colorStop[1]);
                }
                return grad;
              }
              getPattern(ctx2, owner, inverse2, pathType) {
                let pattern;
                if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                  const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils2.getCurrentTransform)(ctx2)) || [0, 0, 0, 0];
                  const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                  const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                  const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                  const tmpCtx = tmpCanvas.context;
                  tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                  tmpCtx.beginPath();
                  tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                  tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                  inverse2 = _util2.Util.transform(inverse2, [1, 0, 0, 1, ownerBBox[0], ownerBBox[1]]);
                  tmpCtx.transform(...owner.baseTransform);
                  if (this.matrix) {
                    tmpCtx.transform(...this.matrix);
                  }
                  applyBoundingBox(tmpCtx, this._bbox);
                  tmpCtx.fillStyle = this._createGradient(tmpCtx);
                  tmpCtx.fill();
                  pattern = ctx2.createPattern(tmpCanvas.canvas, "no-repeat");
                  const domMatrix = new DOMMatrix(inverse2);
                  pattern.setTransform(domMatrix);
                } else {
                  applyBoundingBox(ctx2, this._bbox);
                  pattern = this._createGradient(ctx2);
                }
                return pattern;
              }
            }
            function drawTriangle(data2, context2, p1, p2, p3, c1, c2, c3) {
              const coords = context2.coords, colors = context2.colors;
              const bytes = data2.data, rowSize = data2.width * 4;
              let tmp2;
              if (coords[p1 + 1] > coords[p2 + 1]) {
                tmp2 = p1;
                p1 = p2;
                p2 = tmp2;
                tmp2 = c1;
                c1 = c2;
                c2 = tmp2;
              }
              if (coords[p2 + 1] > coords[p3 + 1]) {
                tmp2 = p2;
                p2 = p3;
                p3 = tmp2;
                tmp2 = c2;
                c2 = c3;
                c3 = tmp2;
              }
              if (coords[p1 + 1] > coords[p2 + 1]) {
                tmp2 = p1;
                p1 = p2;
                p2 = tmp2;
                tmp2 = c1;
                c1 = c2;
                c2 = tmp2;
              }
              const x12 = (coords[p1] + context2.offsetX) * context2.scaleX;
              const y12 = (coords[p1 + 1] + context2.offsetY) * context2.scaleY;
              const x2 = (coords[p2] + context2.offsetX) * context2.scaleX;
              const y2 = (coords[p2 + 1] + context2.offsetY) * context2.scaleY;
              const x3 = (coords[p3] + context2.offsetX) * context2.scaleX;
              const y3 = (coords[p3 + 1] + context2.offsetY) * context2.scaleY;
              if (y12 >= y3) {
                return;
              }
              const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
              const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
              const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
              const minY2 = Math.round(y12), maxY2 = Math.round(y3);
              let xa, car, cag, cab;
              let xb, cbr, cbg, cbb;
              for (let y4 = minY2; y4 <= maxY2; y4++) {
                if (y4 < y2) {
                  const k3 = y4 < y12 ? 0 : (y12 - y4) / (y12 - y2);
                  xa = x12 - (x12 - x2) * k3;
                  car = c1r - (c1r - c2r) * k3;
                  cag = c1g - (c1g - c2g) * k3;
                  cab = c1b - (c1b - c2b) * k3;
                } else {
                  let k3;
                  if (y4 > y3) {
                    k3 = 1;
                  } else if (y2 === y3) {
                    k3 = 0;
                  } else {
                    k3 = (y2 - y4) / (y2 - y3);
                  }
                  xa = x2 - (x2 - x3) * k3;
                  car = c2r - (c2r - c3r) * k3;
                  cag = c2g - (c2g - c3g) * k3;
                  cab = c2b - (c2b - c3b) * k3;
                }
                let k2;
                if (y4 < y12) {
                  k2 = 0;
                } else if (y4 > y3) {
                  k2 = 1;
                } else {
                  k2 = (y12 - y4) / (y12 - y3);
                }
                xb = x12 - (x12 - x3) * k2;
                cbr = c1r - (c1r - c3r) * k2;
                cbg = c1g - (c1g - c3g) * k2;
                cbb = c1b - (c1b - c3b) * k2;
                const x1_ = Math.round(Math.min(xa, xb));
                const x2_ = Math.round(Math.max(xa, xb));
                let j2 = rowSize * y4 + x1_ * 4;
                for (let x4 = x1_; x4 <= x2_; x4++) {
                  k2 = (xa - x4) / (xa - xb);
                  if (k2 < 0) {
                    k2 = 0;
                  } else if (k2 > 1) {
                    k2 = 1;
                  }
                  bytes[j2++] = car - (car - cbr) * k2 | 0;
                  bytes[j2++] = cag - (cag - cbg) * k2 | 0;
                  bytes[j2++] = cab - (cab - cbb) * k2 | 0;
                  bytes[j2++] = 255;
                }
              }
            }
            function drawFigure(data2, figure, context2) {
              const ps = figure.coords;
              const cs = figure.colors;
              let i2, ii2;
              switch (figure.type) {
                case "lattice":
                  const verticesPerRow = figure.verticesPerRow;
                  const rows = Math.floor(ps.length / verticesPerRow) - 1;
                  const cols = verticesPerRow - 1;
                  for (i2 = 0; i2 < rows; i2++) {
                    let q2 = i2 * verticesPerRow;
                    for (let j2 = 0; j2 < cols; j2++, q2++) {
                      drawTriangle(data2, context2, ps[q2], ps[q2 + 1], ps[q2 + verticesPerRow], cs[q2], cs[q2 + 1], cs[q2 + verticesPerRow]);
                      drawTriangle(data2, context2, ps[q2 + verticesPerRow + 1], ps[q2 + 1], ps[q2 + verticesPerRow], cs[q2 + verticesPerRow + 1], cs[q2 + 1], cs[q2 + verticesPerRow]);
                    }
                  }
                  break;
                case "triangles":
                  for (i2 = 0, ii2 = ps.length; i2 < ii2; i2 += 3) {
                    drawTriangle(data2, context2, ps[i2], ps[i2 + 1], ps[i2 + 2], cs[i2], cs[i2 + 1], cs[i2 + 2]);
                  }
                  break;
                default:
                  throw new Error("illegal figure");
              }
            }
            class MeshShadingPattern extends BaseShadingPattern {
              constructor(IR) {
                super();
                this._coords = IR[2];
                this._colors = IR[3];
                this._figures = IR[4];
                this._bounds = IR[5];
                this._bbox = IR[7];
                this._background = IR[8];
                this.matrix = null;
              }
              _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                const EXPECTED_SCALE = 1.1;
                const MAX_PATTERN_SIZE = 3e3;
                const BORDER_SIZE = 2;
                const offsetX = Math.floor(this._bounds[0]);
                const offsetY = Math.floor(this._bounds[1]);
                const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                const scaleX3 = boundsWidth / width;
                const scaleY3 = boundsHeight / height;
                const context2 = {
                  coords: this._coords,
                  colors: this._colors,
                  offsetX: -offsetX,
                  offsetY: -offsetY,
                  scaleX: 1 / scaleX3,
                  scaleY: 1 / scaleY3
                };
                const paddedWidth = width + BORDER_SIZE * 2;
                const paddedHeight = height + BORDER_SIZE * 2;
                const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                const tmpCtx = tmpCanvas.context;
                const data2 = tmpCtx.createImageData(width, height);
                if (backgroundColor) {
                  const bytes = data2.data;
                  for (let i2 = 0, ii2 = bytes.length; i2 < ii2; i2 += 4) {
                    bytes[i2] = backgroundColor[0];
                    bytes[i2 + 1] = backgroundColor[1];
                    bytes[i2 + 2] = backgroundColor[2];
                    bytes[i2 + 3] = 255;
                  }
                }
                for (const figure of this._figures) {
                  drawFigure(data2, figure, context2);
                }
                tmpCtx.putImageData(data2, BORDER_SIZE, BORDER_SIZE);
                const canvas2 = tmpCanvas.canvas;
                return {
                  canvas: canvas2,
                  offsetX: offsetX - BORDER_SIZE * scaleX3,
                  offsetY: offsetY - BORDER_SIZE * scaleY3,
                  scaleX: scaleX3,
                  scaleY: scaleY3
                };
              }
              getPattern(ctx2, owner, inverse2, pathType) {
                applyBoundingBox(ctx2, this._bbox);
                let scale5;
                if (pathType === PathType.SHADING) {
                  scale5 = _util2.Util.singularValueDecompose2dScale((0, _display_utils2.getCurrentTransform)(ctx2));
                } else {
                  scale5 = _util2.Util.singularValueDecompose2dScale(owner.baseTransform);
                  if (this.matrix) {
                    const matrixScale = _util2.Util.singularValueDecompose2dScale(this.matrix);
                    scale5 = [scale5[0] * matrixScale[0], scale5[1] * matrixScale[1]];
                  }
                }
                const temporaryPatternCanvas = this._createMeshCanvas(scale5, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                if (pathType !== PathType.SHADING) {
                  ctx2.setTransform(...owner.baseTransform);
                  if (this.matrix) {
                    ctx2.transform(...this.matrix);
                  }
                }
                ctx2.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                ctx2.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                return ctx2.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
              }
            }
            class DummyShadingPattern extends BaseShadingPattern {
              getPattern() {
                return "hotpink";
              }
            }
            function getShadingPattern(IR) {
              switch (IR[0]) {
                case "RadialAxial":
                  return new RadialAxialShadingPattern(IR);
                case "Mesh":
                  return new MeshShadingPattern(IR);
                case "Dummy":
                  return new DummyShadingPattern();
              }
              throw new Error(`Unknown IR type: ${IR[0]}`);
            }
            const PaintType = {
              COLORED: 1,
              UNCOLORED: 2
            };
            const _TilingPattern = class {
              constructor(IR, color, ctx2, canvasGraphicsFactory, baseTransform) {
                this.operatorList = IR[2];
                this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
                this.bbox = IR[4];
                this.xstep = IR[5];
                this.ystep = IR[6];
                this.paintType = IR[7];
                this.tilingType = IR[8];
                this.color = color;
                this.ctx = ctx2;
                this.canvasGraphicsFactory = canvasGraphicsFactory;
                this.baseTransform = baseTransform;
              }
              createPatternCanvas(owner) {
                const operatorList = this.operatorList;
                const bbox2 = this.bbox;
                const xstep = this.xstep;
                const ystep = this.ystep;
                const paintType = this.paintType;
                const tilingType = this.tilingType;
                const color = this.color;
                const canvasGraphicsFactory = this.canvasGraphicsFactory;
                (0, _util2.info)("TilingType: " + tilingType);
                const x02 = bbox2[0], y02 = bbox2[1], x12 = bbox2[2], y12 = bbox2[3];
                const matrixScale = _util2.Util.singularValueDecompose2dScale(this.matrix);
                const curMatrixScale = _util2.Util.singularValueDecompose2dScale(this.baseTransform);
                const combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
                const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                const tmpCtx = tmpCanvas.context;
                const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                graphics.groupLevel = owner.groupLevel;
                this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                let adjustedX0 = x02;
                let adjustedY0 = y02;
                let adjustedX1 = x12;
                let adjustedY1 = y12;
                if (x02 < 0) {
                  adjustedX0 = 0;
                  adjustedX1 += Math.abs(x02);
                }
                if (y02 < 0) {
                  adjustedY0 = 0;
                  adjustedY1 += Math.abs(y02);
                }
                tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                tmpCtx.save();
                this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                graphics.baseTransform = (0, _display_utils2.getCurrentTransform)(graphics.ctx);
                graphics.executeOperatorList(operatorList);
                graphics.endDrawing();
                return {
                  canvas: tmpCanvas.canvas,
                  scaleX: dimx.scale,
                  scaleY: dimy.scale,
                  offsetX: adjustedX0,
                  offsetY: adjustedY0
                };
              }
              getSizeAndScale(step, realOutputSize, scale5) {
                step = Math.abs(step);
                const maxSize = Math.max(_TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                let size12 = Math.ceil(step * scale5);
                if (size12 >= maxSize) {
                  size12 = maxSize;
                } else {
                  scale5 = size12 / step;
                }
                return {
                  scale: scale5,
                  size: size12
                };
              }
              clipBbox(graphics, x02, y02, x12, y12) {
                const bboxWidth = x12 - x02;
                const bboxHeight = y12 - y02;
                graphics.ctx.rect(x02, y02, bboxWidth, bboxHeight);
                graphics.current.updateRectMinMax((0, _display_utils2.getCurrentTransform)(graphics.ctx), [x02, y02, x12, y12]);
                graphics.clip();
                graphics.endPath();
              }
              setFillAndStrokeStyleToContext(graphics, paintType, color) {
                const context2 = graphics.ctx, current = graphics.current;
                switch (paintType) {
                  case PaintType.COLORED:
                    const ctx2 = this.ctx;
                    context2.fillStyle = ctx2.fillStyle;
                    context2.strokeStyle = ctx2.strokeStyle;
                    current.fillColor = ctx2.fillStyle;
                    current.strokeColor = ctx2.strokeStyle;
                    break;
                  case PaintType.UNCOLORED:
                    const cssColor = _util2.Util.makeHexColor(color[0], color[1], color[2]);
                    context2.fillStyle = cssColor;
                    context2.strokeStyle = cssColor;
                    current.fillColor = cssColor;
                    current.strokeColor = cssColor;
                    break;
                  default:
                    throw new _util2.FormatError(`Unsupported paint type: ${paintType}`);
                }
              }
              getPattern(ctx2, owner, inverse2, pathType) {
                let matrix = inverse2;
                if (pathType !== PathType.SHADING) {
                  matrix = _util2.Util.transform(matrix, owner.baseTransform);
                  if (this.matrix) {
                    matrix = _util2.Util.transform(matrix, this.matrix);
                  }
                }
                const temporaryPatternCanvas = this.createPatternCanvas(owner);
                let domMatrix = new DOMMatrix(matrix);
                domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                const pattern = ctx2.createPattern(temporaryPatternCanvas.canvas, "repeat");
                pattern.setTransform(domMatrix);
                return pattern;
              }
            };
            let TilingPattern = _TilingPattern;
            __publicField2(TilingPattern, "MAX_PATTERN_SIZE", 3e3);
            exports2.TilingPattern = TilingPattern;
          },
          /* 13 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
            exports2.convertToRGBA = convertToRGBA;
            exports2.grayToRGBA = grayToRGBA;
            var _util2 = __w_pdfjs_require__2(1);
            function convertToRGBA(params2) {
              switch (params2.kind) {
                case _util2.ImageKind.GRAYSCALE_1BPP:
                  return convertBlackAndWhiteToRGBA(params2);
                case _util2.ImageKind.RGB_24BPP:
                  return convertRGBToRGBA(params2);
              }
              return null;
            }
            function convertBlackAndWhiteToRGBA({
              src: src2,
              srcPos = 0,
              dest,
              width,
              height,
              nonBlackColor = 4294967295,
              inverseDecode = false
            }) {
              const black = _util2.FeatureTest.isLittleEndian ? 4278190080 : 255;
              const [zeroMapping, oneMapping] = inverseDecode ? [nonBlackColor, black] : [black, nonBlackColor];
              const widthInSource = width >> 3;
              const widthRemainder = width & 7;
              const srcLength = src2.length;
              dest = new Uint32Array(dest.buffer);
              let destPos = 0;
              for (let i2 = 0; i2 < height; i2++) {
                for (const max3 = srcPos + widthInSource; srcPos < max3; srcPos++) {
                  const elem2 = srcPos < srcLength ? src2[srcPos] : 255;
                  dest[destPos++] = elem2 & 128 ? oneMapping : zeroMapping;
                  dest[destPos++] = elem2 & 64 ? oneMapping : zeroMapping;
                  dest[destPos++] = elem2 & 32 ? oneMapping : zeroMapping;
                  dest[destPos++] = elem2 & 16 ? oneMapping : zeroMapping;
                  dest[destPos++] = elem2 & 8 ? oneMapping : zeroMapping;
                  dest[destPos++] = elem2 & 4 ? oneMapping : zeroMapping;
                  dest[destPos++] = elem2 & 2 ? oneMapping : zeroMapping;
                  dest[destPos++] = elem2 & 1 ? oneMapping : zeroMapping;
                }
                if (widthRemainder === 0) {
                  continue;
                }
                const elem = srcPos < srcLength ? src2[srcPos++] : 255;
                for (let j2 = 0; j2 < widthRemainder; j2++) {
                  dest[destPos++] = elem & 1 << 7 - j2 ? oneMapping : zeroMapping;
                }
              }
              return {
                srcPos,
                destPos
              };
            }
            function convertRGBToRGBA({
              src: src2,
              srcPos = 0,
              dest,
              destPos = 0,
              width,
              height
            }) {
              let i2 = 0;
              const len32 = src2.length >> 2;
              const src32 = new Uint32Array(src2.buffer, srcPos, len32);
              if (_util2.FeatureTest.isLittleEndian) {
                for (; i2 < len32 - 2; i2 += 3, destPos += 4) {
                  const s1 = src32[i2];
                  const s2 = src32[i2 + 1];
                  const s3 = src32[i2 + 2];
                  dest[destPos] = s1 | 4278190080;
                  dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 4278190080;
                  dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 4278190080;
                  dest[destPos + 3] = s3 >>> 8 | 4278190080;
                }
                for (let j2 = i2 * 4, jj = src2.length; j2 < jj; j2 += 3) {
                  dest[destPos++] = src2[j2] | src2[j2 + 1] << 8 | src2[j2 + 2] << 16 | 4278190080;
                }
              } else {
                for (; i2 < len32 - 2; i2 += 3, destPos += 4) {
                  const s1 = src32[i2];
                  const s2 = src32[i2 + 1];
                  const s3 = src32[i2 + 2];
                  dest[destPos] = s1 | 255;
                  dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 255;
                  dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 255;
                  dest[destPos + 3] = s3 << 8 | 255;
                }
                for (let j2 = i2 * 4, jj = src2.length; j2 < jj; j2 += 3) {
                  dest[destPos++] = src2[j2] << 24 | src2[j2 + 1] << 16 | src2[j2 + 2] << 8 | 255;
                }
              }
              return {
                srcPos,
                destPos
              };
            }
            function grayToRGBA(src2, dest) {
              if (_util2.FeatureTest.isLittleEndian) {
                for (let i2 = 0, ii2 = src2.length; i2 < ii2; i2++) {
                  dest[i2] = src2[i2] * 65793 | 4278190080;
                }
              } else {
                for (let i2 = 0, ii2 = src2.length; i2 < ii2; i2++) {
                  dest[i2] = src2[i2] * 16843008 | 255;
                }
              }
            }
          },
          /* 14 */
          /***/
          (__unused_webpack_module2, exports2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.GlobalWorkerOptions = void 0;
            const GlobalWorkerOptions = /* @__PURE__ */ Object.create(null);
            exports2.GlobalWorkerOptions = GlobalWorkerOptions;
            GlobalWorkerOptions.workerPort = null;
            GlobalWorkerOptions.workerSrc = "";
          },
          /* 15 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _createStreamSink, createStreamSink_fn, _processStreamMessage, processStreamMessage_fn, _deleteStreamController, deleteStreamController_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.MessageHandler = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            const CallbackKind = {
              UNKNOWN: 0,
              DATA: 1,
              ERROR: 2
            };
            const StreamKind = {
              UNKNOWN: 0,
              CANCEL: 1,
              CANCEL_COMPLETE: 2,
              CLOSE: 3,
              ENQUEUE: 4,
              ERROR: 5,
              PULL: 6,
              PULL_COMPLETE: 7,
              START_COMPLETE: 8
            };
            function wrapReason(reason) {
              if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) {
                (0, _util2.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
              }
              switch (reason.name) {
                case "AbortException":
                  return new _util2.AbortException(reason.message);
                case "MissingPDFException":
                  return new _util2.MissingPDFException(reason.message);
                case "PasswordException":
                  return new _util2.PasswordException(reason.message, reason.code);
                case "UnexpectedResponseException":
                  return new _util2.UnexpectedResponseException(reason.message, reason.status);
                case "UnknownErrorException":
                  return new _util2.UnknownErrorException(reason.message, reason.details);
                default:
                  return new _util2.UnknownErrorException(reason.message, reason.toString());
              }
            }
            class MessageHandler {
              constructor(sourceName, targetName, comObj) {
                __privateAdd(this, _createStreamSink);
                __privateAdd(this, _processStreamMessage);
                __privateAdd(this, _deleteStreamController);
                this.sourceName = sourceName;
                this.targetName = targetName;
                this.comObj = comObj;
                this.callbackId = 1;
                this.streamId = 1;
                this.streamSinks = /* @__PURE__ */ Object.create(null);
                this.streamControllers = /* @__PURE__ */ Object.create(null);
                this.callbackCapabilities = /* @__PURE__ */ Object.create(null);
                this.actionHandler = /* @__PURE__ */ Object.create(null);
                this._onComObjOnMessage = (event) => {
                  const data2 = event.data;
                  if (data2.targetName !== this.sourceName) {
                    return;
                  }
                  if (data2.stream) {
                    __privateMethod(this, _processStreamMessage, processStreamMessage_fn).call(this, data2);
                    return;
                  }
                  if (data2.callback) {
                    const callbackId = data2.callbackId;
                    const capability = this.callbackCapabilities[callbackId];
                    if (!capability) {
                      throw new Error(`Cannot resolve callback ${callbackId}`);
                    }
                    delete this.callbackCapabilities[callbackId];
                    if (data2.callback === CallbackKind.DATA) {
                      capability.resolve(data2.data);
                    } else if (data2.callback === CallbackKind.ERROR) {
                      capability.reject(wrapReason(data2.reason));
                    } else {
                      throw new Error("Unexpected callback case");
                    }
                    return;
                  }
                  const action = this.actionHandler[data2.action];
                  if (!action) {
                    throw new Error(`Unknown action from worker: ${data2.action}`);
                  }
                  if (data2.callbackId) {
                    const cbSourceName = this.sourceName;
                    const cbTargetName = data2.sourceName;
                    new Promise(function(resolve2) {
                      resolve2(action(data2.data));
                    }).then(function(result) {
                      comObj.postMessage({
                        sourceName: cbSourceName,
                        targetName: cbTargetName,
                        callback: CallbackKind.DATA,
                        callbackId: data2.callbackId,
                        data: result
                      });
                    }, function(reason) {
                      comObj.postMessage({
                        sourceName: cbSourceName,
                        targetName: cbTargetName,
                        callback: CallbackKind.ERROR,
                        callbackId: data2.callbackId,
                        reason: wrapReason(reason)
                      });
                    });
                    return;
                  }
                  if (data2.streamId) {
                    __privateMethod(this, _createStreamSink, createStreamSink_fn).call(this, data2);
                    return;
                  }
                  action(data2.data);
                };
                comObj.addEventListener("message", this._onComObjOnMessage);
              }
              on(actionName, handler) {
                const ah2 = this.actionHandler;
                if (ah2[actionName]) {
                  throw new Error(`There is already an actionName called "${actionName}"`);
                }
                ah2[actionName] = handler;
              }
              send(actionName, data2, transfers) {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: actionName,
                  data: data2
                }, transfers);
              }
              sendWithPromise(actionName, data2, transfers) {
                const callbackId = this.callbackId++;
                const capability = new _util2.PromiseCapability();
                this.callbackCapabilities[callbackId] = capability;
                try {
                  this.comObj.postMessage({
                    sourceName: this.sourceName,
                    targetName: this.targetName,
                    action: actionName,
                    callbackId,
                    data: data2
                  }, transfers);
                } catch (ex) {
                  capability.reject(ex);
                }
                return capability.promise;
              }
              sendWithStream(actionName, data2, queueingStrategy, transfers) {
                const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                return new ReadableStream({
                  start: (controller) => {
                    const startCapability = new _util2.PromiseCapability();
                    this.streamControllers[streamId] = {
                      controller,
                      startCall: startCapability,
                      pullCall: null,
                      cancelCall: null,
                      isClosed: false
                    };
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      action: actionName,
                      streamId,
                      data: data2,
                      desiredSize: controller.desiredSize
                    }, transfers);
                    return startCapability.promise;
                  },
                  pull: (controller) => {
                    const pullCapability = new _util2.PromiseCapability();
                    this.streamControllers[streamId].pullCall = pullCapability;
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL,
                      streamId,
                      desiredSize: controller.desiredSize
                    });
                    return pullCapability.promise;
                  },
                  cancel: (reason) => {
                    (0, _util2.assert)(reason instanceof Error, "cancel must have a valid reason");
                    const cancelCapability = new _util2.PromiseCapability();
                    this.streamControllers[streamId].cancelCall = cancelCapability;
                    this.streamControllers[streamId].isClosed = true;
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.CANCEL,
                      streamId,
                      reason: wrapReason(reason)
                    });
                    return cancelCapability.promise;
                  }
                }, queueingStrategy);
              }
              destroy() {
                this.comObj.removeEventListener("message", this._onComObjOnMessage);
              }
            }
            _createStreamSink = new WeakSet();
            createStreamSink_fn = function(data2) {
              const streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
              const self2 = this, action = this.actionHandler[data2.action];
              const streamSink = {
                enqueue(chunk, size12 = 1, transfers) {
                  if (this.isCancelled) {
                    return;
                  }
                  const lastDesiredSize = this.desiredSize;
                  this.desiredSize -= size12;
                  if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                    this.sinkCapability = new _util2.PromiseCapability();
                    this.ready = this.sinkCapability.promise;
                  }
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.ENQUEUE,
                    streamId,
                    chunk
                  }, transfers);
                },
                close() {
                  if (this.isCancelled) {
                    return;
                  }
                  this.isCancelled = true;
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.CLOSE,
                    streamId
                  });
                  delete self2.streamSinks[streamId];
                },
                error(reason) {
                  (0, _util2.assert)(reason instanceof Error, "error must have a valid reason");
                  if (this.isCancelled) {
                    return;
                  }
                  this.isCancelled = true;
                  comObj.postMessage({
                    sourceName,
                    targetName,
                    stream: StreamKind.ERROR,
                    streamId,
                    reason: wrapReason(reason)
                  });
                },
                sinkCapability: new _util2.PromiseCapability(),
                onPull: null,
                onCancel: null,
                isCancelled: false,
                desiredSize: data2.desiredSize,
                ready: null
              };
              streamSink.sinkCapability.resolve();
              streamSink.ready = streamSink.sinkCapability.promise;
              this.streamSinks[streamId] = streamSink;
              new Promise(function(resolve2) {
                resolve2(action(data2.data, streamSink));
              }).then(function() {
                comObj.postMessage({
                  sourceName,
                  targetName,
                  stream: StreamKind.START_COMPLETE,
                  streamId,
                  success: true
                });
              }, function(reason) {
                comObj.postMessage({
                  sourceName,
                  targetName,
                  stream: StreamKind.START_COMPLETE,
                  streamId,
                  reason: wrapReason(reason)
                });
              });
            };
            _processStreamMessage = new WeakSet();
            processStreamMessage_fn = function(data2) {
              const streamId = data2.streamId, sourceName = this.sourceName, targetName = data2.sourceName, comObj = this.comObj;
              const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
              switch (data2.stream) {
                case StreamKind.START_COMPLETE:
                  if (data2.success) {
                    streamController.startCall.resolve();
                  } else {
                    streamController.startCall.reject(wrapReason(data2.reason));
                  }
                  break;
                case StreamKind.PULL_COMPLETE:
                  if (data2.success) {
                    streamController.pullCall.resolve();
                  } else {
                    streamController.pullCall.reject(wrapReason(data2.reason));
                  }
                  break;
                case StreamKind.PULL:
                  if (!streamSink) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL_COMPLETE,
                      streamId,
                      success: true
                    });
                    break;
                  }
                  if (streamSink.desiredSize <= 0 && data2.desiredSize > 0) {
                    streamSink.sinkCapability.resolve();
                  }
                  streamSink.desiredSize = data2.desiredSize;
                  new Promise(function(resolve2) {
                    var _a3;
                    resolve2((_a3 = streamSink.onPull) == null ? void 0 : _a3.call(streamSink));
                  }).then(function() {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL_COMPLETE,
                      streamId,
                      success: true
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.PULL_COMPLETE,
                      streamId,
                      reason: wrapReason(reason)
                    });
                  });
                  break;
                case StreamKind.ENQUEUE:
                  (0, _util2.assert)(streamController, "enqueue should have stream controller");
                  if (streamController.isClosed) {
                    break;
                  }
                  streamController.controller.enqueue(data2.chunk);
                  break;
                case StreamKind.CLOSE:
                  (0, _util2.assert)(streamController, "close should have stream controller");
                  if (streamController.isClosed) {
                    break;
                  }
                  streamController.isClosed = true;
                  streamController.controller.close();
                  __privateMethod(this, _deleteStreamController, deleteStreamController_fn).call(this, streamController, streamId);
                  break;
                case StreamKind.ERROR:
                  (0, _util2.assert)(streamController, "error should have stream controller");
                  streamController.controller.error(wrapReason(data2.reason));
                  __privateMethod(this, _deleteStreamController, deleteStreamController_fn).call(this, streamController, streamId);
                  break;
                case StreamKind.CANCEL_COMPLETE:
                  if (data2.success) {
                    streamController.cancelCall.resolve();
                  } else {
                    streamController.cancelCall.reject(wrapReason(data2.reason));
                  }
                  __privateMethod(this, _deleteStreamController, deleteStreamController_fn).call(this, streamController, streamId);
                  break;
                case StreamKind.CANCEL:
                  if (!streamSink) {
                    break;
                  }
                  new Promise(function(resolve2) {
                    var _a3;
                    resolve2((_a3 = streamSink.onCancel) == null ? void 0 : _a3.call(streamSink, wrapReason(data2.reason)));
                  }).then(function() {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.CANCEL_COMPLETE,
                      streamId,
                      success: true
                    });
                  }, function(reason) {
                    comObj.postMessage({
                      sourceName,
                      targetName,
                      stream: StreamKind.CANCEL_COMPLETE,
                      streamId,
                      reason: wrapReason(reason)
                    });
                  });
                  streamSink.sinkCapability.reject(wrapReason(data2.reason));
                  streamSink.isCancelled = true;
                  delete this.streamSinks[streamId];
                  break;
                default:
                  throw new Error("Unexpected stream case");
              }
            };
            _deleteStreamController = new WeakSet();
            deleteStreamController_fn = async function(streamController, streamId) {
              var _a3, _b3, _c2;
              await Promise.allSettled([(_a3 = streamController.startCall) == null ? void 0 : _a3.promise, (_b3 = streamController.pullCall) == null ? void 0 : _b3.promise, (_c2 = streamController.cancelCall) == null ? void 0 : _c2.promise]);
              delete this.streamControllers[streamId];
            };
            exports2.MessageHandler = MessageHandler;
          },
          /* 16 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _metadataMap, _data2;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.Metadata = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            class Metadata {
              constructor({
                parsedData,
                rawData
              }) {
                __privateAdd(this, _metadataMap, void 0);
                __privateAdd(this, _data2, void 0);
                __privateSet(this, _metadataMap, parsedData);
                __privateSet(this, _data2, rawData);
              }
              getRaw() {
                return __privateGet(this, _data2);
              }
              get(name2) {
                return __privateGet(this, _metadataMap).get(name2) ?? null;
              }
              getAll() {
                return (0, _util2.objectFromMap)(__privateGet(this, _metadataMap));
              }
              has(name2) {
                return __privateGet(this, _metadataMap).has(name2);
              }
            }
            _metadataMap = new WeakMap();
            _data2 = new WeakMap();
            exports2.Metadata = Metadata;
          },
          /* 17 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _visible, _cachedGetHash, _groups, _initialHash, _order, _evaluateVisibilityExpression, evaluateVisibilityExpression_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.OptionalContentConfig = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _murmurhash = __w_pdfjs_require__2(8);
            const INTERNAL = Symbol("INTERNAL");
            class OptionalContentGroup {
              constructor(name2, intent) {
                __privateAdd(this, _visible, true);
                this.name = name2;
                this.intent = intent;
              }
              get visible() {
                return __privateGet(this, _visible);
              }
              _setVisible(internal, visible) {
                if (internal !== INTERNAL) {
                  (0, _util2.unreachable)("Internal method `_setVisible` called.");
                }
                __privateSet(this, _visible, visible);
              }
            }
            _visible = new WeakMap();
            class OptionalContentConfig {
              constructor(data2) {
                __privateAdd(this, _evaluateVisibilityExpression);
                __privateAdd(this, _cachedGetHash, null);
                __privateAdd(this, _groups, /* @__PURE__ */ new Map());
                __privateAdd(this, _initialHash, null);
                __privateAdd(this, _order, null);
                this.name = null;
                this.creator = null;
                if (data2 === null) {
                  return;
                }
                this.name = data2.name;
                this.creator = data2.creator;
                __privateSet(this, _order, data2.order);
                for (const group of data2.groups) {
                  __privateGet(this, _groups).set(group.id, new OptionalContentGroup(group.name, group.intent));
                }
                if (data2.baseState === "OFF") {
                  for (const group of __privateGet(this, _groups).values()) {
                    group._setVisible(INTERNAL, false);
                  }
                }
                for (const on2 of data2.on) {
                  __privateGet(this, _groups).get(on2)._setVisible(INTERNAL, true);
                }
                for (const off of data2.off) {
                  __privateGet(this, _groups).get(off)._setVisible(INTERNAL, false);
                }
                __privateSet(this, _initialHash, this.getHash());
              }
              isVisible(group) {
                if (__privateGet(this, _groups).size === 0) {
                  return true;
                }
                if (!group) {
                  (0, _util2.warn)("Optional content group not defined.");
                  return true;
                }
                if (group.type === "OCG") {
                  if (!__privateGet(this, _groups).has(group.id)) {
                    (0, _util2.warn)(`Optional content group not found: ${group.id}`);
                    return true;
                  }
                  return __privateGet(this, _groups).get(group.id).visible;
                } else if (group.type === "OCMD") {
                  if (group.expression) {
                    return __privateMethod(this, _evaluateVisibilityExpression, evaluateVisibilityExpression_fn).call(this, group.expression);
                  }
                  if (!group.policy || group.policy === "AnyOn") {
                    for (const id of group.ids) {
                      if (!__privateGet(this, _groups).has(id)) {
                        (0, _util2.warn)(`Optional content group not found: ${id}`);
                        return true;
                      }
                      if (__privateGet(this, _groups).get(id).visible) {
                        return true;
                      }
                    }
                    return false;
                  } else if (group.policy === "AllOn") {
                    for (const id of group.ids) {
                      if (!__privateGet(this, _groups).has(id)) {
                        (0, _util2.warn)(`Optional content group not found: ${id}`);
                        return true;
                      }
                      if (!__privateGet(this, _groups).get(id).visible) {
                        return false;
                      }
                    }
                    return true;
                  } else if (group.policy === "AnyOff") {
                    for (const id of group.ids) {
                      if (!__privateGet(this, _groups).has(id)) {
                        (0, _util2.warn)(`Optional content group not found: ${id}`);
                        return true;
                      }
                      if (!__privateGet(this, _groups).get(id).visible) {
                        return true;
                      }
                    }
                    return false;
                  } else if (group.policy === "AllOff") {
                    for (const id of group.ids) {
                      if (!__privateGet(this, _groups).has(id)) {
                        (0, _util2.warn)(`Optional content group not found: ${id}`);
                        return true;
                      }
                      if (__privateGet(this, _groups).get(id).visible) {
                        return false;
                      }
                    }
                    return true;
                  }
                  (0, _util2.warn)(`Unknown optional content policy ${group.policy}.`);
                  return true;
                }
                (0, _util2.warn)(`Unknown group type ${group.type}.`);
                return true;
              }
              setVisibility(id, visible = true) {
                if (!__privateGet(this, _groups).has(id)) {
                  (0, _util2.warn)(`Optional content group not found: ${id}`);
                  return;
                }
                __privateGet(this, _groups).get(id)._setVisible(INTERNAL, !!visible);
                __privateSet(this, _cachedGetHash, null);
              }
              get hasInitialVisibility() {
                return __privateGet(this, _initialHash) === null || this.getHash() === __privateGet(this, _initialHash);
              }
              getOrder() {
                if (!__privateGet(this, _groups).size) {
                  return null;
                }
                if (__privateGet(this, _order)) {
                  return __privateGet(this, _order).slice();
                }
                return [...__privateGet(this, _groups).keys()];
              }
              getGroups() {
                return __privateGet(this, _groups).size > 0 ? (0, _util2.objectFromMap)(__privateGet(this, _groups)) : null;
              }
              getGroup(id) {
                return __privateGet(this, _groups).get(id) || null;
              }
              getHash() {
                if (__privateGet(this, _cachedGetHash) !== null) {
                  return __privateGet(this, _cachedGetHash);
                }
                const hash = new _murmurhash.MurmurHash3_64();
                for (const [id, group] of __privateGet(this, _groups)) {
                  hash.update(`${id}:${group.visible}`);
                }
                return __privateSet(this, _cachedGetHash, hash.hexdigest());
              }
            }
            _cachedGetHash = new WeakMap();
            _groups = new WeakMap();
            _initialHash = new WeakMap();
            _order = new WeakMap();
            _evaluateVisibilityExpression = new WeakSet();
            evaluateVisibilityExpression_fn = function(array2) {
              const length2 = array2.length;
              if (length2 < 2) {
                return true;
              }
              const operator = array2[0];
              for (let i2 = 1; i2 < length2; i2++) {
                const element = array2[i2];
                let state;
                if (Array.isArray(element)) {
                  state = __privateMethod(this, _evaluateVisibilityExpression, evaluateVisibilityExpression_fn).call(this, element);
                } else if (__privateGet(this, _groups).has(element)) {
                  state = __privateGet(this, _groups).get(element).visible;
                } else {
                  (0, _util2.warn)(`Optional content group not found: ${element}`);
                  return true;
                }
                switch (operator) {
                  case "And":
                    if (!state) {
                      return false;
                    }
                    break;
                  case "Or":
                    if (state) {
                      return true;
                    }
                    break;
                  case "Not":
                    return !state;
                  default:
                    return true;
                }
              }
              return operator === "And";
            };
            exports2.OptionalContentConfig = OptionalContentConfig;
          },
          /* 18 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.PDFDataTransportStream = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _display_utils2 = __w_pdfjs_require__2(6);
            class PDFDataTransportStream {
              constructor({
                length: length2,
                initialData,
                progressiveDone = false,
                contentDispositionFilename = null,
                disableRange = false,
                disableStream = false
              }, pdfDataRangeTransport) {
                (0, _util2.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                this._queuedChunks = [];
                this._progressiveDone = progressiveDone;
                this._contentDispositionFilename = contentDispositionFilename;
                if ((initialData == null ? void 0 : initialData.length) > 0) {
                  const buffer3 = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                  this._queuedChunks.push(buffer3);
                }
                this._pdfDataRangeTransport = pdfDataRangeTransport;
                this._isStreamingSupported = !disableStream;
                this._isRangeSupported = !disableRange;
                this._contentLength = length2;
                this._fullRequestReader = null;
                this._rangeReaders = [];
                this._pdfDataRangeTransport.addRangeListener((begin, chunk) => {
                  this._onReceiveData({
                    begin,
                    chunk
                  });
                });
                this._pdfDataRangeTransport.addProgressListener((loaded, total) => {
                  this._onProgress({
                    loaded,
                    total
                  });
                });
                this._pdfDataRangeTransport.addProgressiveReadListener((chunk) => {
                  this._onReceiveData({
                    chunk
                  });
                });
                this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                  this._onProgressiveDone();
                });
                this._pdfDataRangeTransport.transportReady();
              }
              _onReceiveData({
                begin,
                chunk
              }) {
                const buffer3 = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                if (begin === void 0) {
                  if (this._fullRequestReader) {
                    this._fullRequestReader._enqueue(buffer3);
                  } else {
                    this._queuedChunks.push(buffer3);
                  }
                } else {
                  const found = this._rangeReaders.some(function(rangeReader) {
                    if (rangeReader._begin !== begin) {
                      return false;
                    }
                    rangeReader._enqueue(buffer3);
                    return true;
                  });
                  (0, _util2.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                }
              }
              get _progressiveDataLength() {
                var _a3;
                return ((_a3 = this._fullRequestReader) == null ? void 0 : _a3._loaded) ?? 0;
              }
              _onProgress(evt) {
                var _a3, _b3, _c2, _d2;
                if (evt.total === void 0) {
                  (_b3 = (_a3 = this._rangeReaders[0]) == null ? void 0 : _a3.onProgress) == null ? void 0 : _b3.call(_a3, {
                    loaded: evt.loaded
                  });
                } else {
                  (_d2 = (_c2 = this._fullRequestReader) == null ? void 0 : _c2.onProgress) == null ? void 0 : _d2.call(_c2, {
                    loaded: evt.loaded,
                    total: evt.total
                  });
                }
              }
              _onProgressiveDone() {
                var _a3;
                (_a3 = this._fullRequestReader) == null ? void 0 : _a3.progressiveDone();
                this._progressiveDone = true;
              }
              _removeRangeReader(reader) {
                const i2 = this._rangeReaders.indexOf(reader);
                if (i2 >= 0) {
                  this._rangeReaders.splice(i2, 1);
                }
              }
              getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                const queuedChunks = this._queuedChunks;
                this._queuedChunks = null;
                return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
              }
              getRangeReader(begin, end) {
                if (end <= this._progressiveDataLength) {
                  return null;
                }
                const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                this._pdfDataRangeTransport.requestDataRange(begin, end);
                this._rangeReaders.push(reader);
                return reader;
              }
              cancelAllRequests(reason) {
                var _a3;
                (_a3 = this._fullRequestReader) == null ? void 0 : _a3.cancel(reason);
                for (const reader of this._rangeReaders.slice(0)) {
                  reader.cancel(reason);
                }
                this._pdfDataRangeTransport.abort();
              }
            }
            exports2.PDFDataTransportStream = PDFDataTransportStream;
            class PDFDataTransportStreamReader {
              constructor(stream2, queuedChunks, progressiveDone = false, contentDispositionFilename = null) {
                this._stream = stream2;
                this._done = progressiveDone || false;
                this._filename = (0, _display_utils2.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                this._queuedChunks = queuedChunks || [];
                this._loaded = 0;
                for (const chunk of this._queuedChunks) {
                  this._loaded += chunk.byteLength;
                }
                this._requests = [];
                this._headersReady = Promise.resolve();
                stream2._fullRequestReader = this;
                this.onProgress = null;
              }
              _enqueue(chunk) {
                if (this._done) {
                  return;
                }
                if (this._requests.length > 0) {
                  const requestCapability = this._requests.shift();
                  requestCapability.resolve({
                    value: chunk,
                    done: false
                  });
                } else {
                  this._queuedChunks.push(chunk);
                }
                this._loaded += chunk.byteLength;
              }
              get headersReady() {
                return this._headersReady;
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._stream._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._stream._isStreamingSupported;
              }
              get contentLength() {
                return this._stream._contentLength;
              }
              async read() {
                if (this._queuedChunks.length > 0) {
                  const chunk = this._queuedChunks.shift();
                  return {
                    value: chunk,
                    done: false
                  };
                }
                if (this._done) {
                  return {
                    value: void 0,
                    done: true
                  };
                }
                const requestCapability = new _util2.PromiseCapability();
                this._requests.push(requestCapability);
                return requestCapability.promise;
              }
              cancel(reason) {
                this._done = true;
                for (const requestCapability of this._requests) {
                  requestCapability.resolve({
                    value: void 0,
                    done: true
                  });
                }
                this._requests.length = 0;
              }
              progressiveDone() {
                if (this._done) {
                  return;
                }
                this._done = true;
              }
            }
            class PDFDataTransportStreamRangeReader {
              constructor(stream2, begin, end) {
                this._stream = stream2;
                this._begin = begin;
                this._end = end;
                this._queuedChunk = null;
                this._requests = [];
                this._done = false;
                this.onProgress = null;
              }
              _enqueue(chunk) {
                if (this._done) {
                  return;
                }
                if (this._requests.length === 0) {
                  this._queuedChunk = chunk;
                } else {
                  const requestsCapability = this._requests.shift();
                  requestsCapability.resolve({
                    value: chunk,
                    done: false
                  });
                  for (const requestCapability of this._requests) {
                    requestCapability.resolve({
                      value: void 0,
                      done: true
                    });
                  }
                  this._requests.length = 0;
                }
                this._done = true;
                this._stream._removeRangeReader(this);
              }
              get isStreamingSupported() {
                return false;
              }
              async read() {
                if (this._queuedChunk) {
                  const chunk = this._queuedChunk;
                  this._queuedChunk = null;
                  return {
                    value: chunk,
                    done: false
                  };
                }
                if (this._done) {
                  return {
                    value: void 0,
                    done: true
                  };
                }
                const requestCapability = new _util2.PromiseCapability();
                this._requests.push(requestCapability);
                return requestCapability.promise;
              }
              cancel(reason) {
                this._done = true;
                for (const requestCapability of this._requests) {
                  requestCapability.resolve({
                    value: void 0,
                    done: true
                  });
                }
                this._requests.length = 0;
                this._stream._removeRangeReader(this);
              }
            }
          },
          /* 19 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.PDFFetchStream = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _network_utils = __w_pdfjs_require__2(20);
            function createFetchOptions(headers, withCredentials, abortController) {
              return {
                method: "GET",
                headers,
                signal: abortController.signal,
                mode: "cors",
                credentials: withCredentials ? "include" : "same-origin",
                redirect: "follow"
              };
            }
            function createHeaders(httpHeaders) {
              const headers = new Headers();
              for (const property2 in httpHeaders) {
                const value = httpHeaders[property2];
                if (value === void 0) {
                  continue;
                }
                headers.append(property2, value);
              }
              return headers;
            }
            function getArrayBuffer(val) {
              if (val instanceof Uint8Array) {
                return val.buffer;
              }
              if (val instanceof ArrayBuffer) {
                return val;
              }
              (0, _util2.warn)(`getArrayBuffer - unexpected data format: ${val}`);
              return new Uint8Array(val).buffer;
            }
            class PDFFetchStream {
              constructor(source) {
                this.source = source;
                this.isHttp = /^https?:/i.test(source.url);
                this.httpHeaders = this.isHttp && source.httpHeaders || {};
                this._fullRequestReader = null;
                this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                var _a3;
                return ((_a3 = this._fullRequestReader) == null ? void 0 : _a3._loaded) ?? 0;
              }
              getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                this._fullRequestReader = new PDFFetchStreamReader(this);
                return this._fullRequestReader;
              }
              getRangeReader(begin, end) {
                if (end <= this._progressiveDataLength) {
                  return null;
                }
                const reader = new PDFFetchStreamRangeReader(this, begin, end);
                this._rangeRequestReaders.push(reader);
                return reader;
              }
              cancelAllRequests(reason) {
                var _a3;
                (_a3 = this._fullRequestReader) == null ? void 0 : _a3.cancel(reason);
                for (const reader of this._rangeRequestReaders.slice(0)) {
                  reader.cancel(reason);
                }
              }
            }
            exports2.PDFFetchStream = PDFFetchStream;
            class PDFFetchStreamReader {
              constructor(stream2) {
                this._stream = stream2;
                this._reader = null;
                this._loaded = 0;
                this._filename = null;
                const source = stream2.source;
                this._withCredentials = source.withCredentials || false;
                this._contentLength = source.length;
                this._headersCapability = new _util2.PromiseCapability();
                this._disableRange = source.disableRange || false;
                this._rangeChunkSize = source.rangeChunkSize;
                if (!this._rangeChunkSize && !this._disableRange) {
                  this._disableRange = true;
                }
                this._abortController = new AbortController();
                this._isStreamingSupported = !source.disableStream;
                this._isRangeSupported = !source.disableRange;
                this._headers = createHeaders(this._stream.httpHeaders);
                const url2 = source.url;
                fetch(url2, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response) => {
                  if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                    throw (0, _network_utils.createResponseStatusError)(response.status, url2);
                  }
                  this._reader = response.body.getReader();
                  this._headersCapability.resolve();
                  const getResponseHeader = (name2) => {
                    return response.headers.get(name2);
                  };
                  const {
                    allowRangeRequests,
                    suggestedLength
                  } = (0, _network_utils.validateRangeRequestCapabilities)({
                    getResponseHeader,
                    isHttp: this._stream.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = allowRangeRequests;
                  this._contentLength = suggestedLength || this._contentLength;
                  this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                  if (!this._isStreamingSupported && this._isRangeSupported) {
                    this.cancel(new _util2.AbortException("Streaming is disabled."));
                  }
                }).catch(this._headersCapability.reject);
                this.onProgress = null;
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                var _a3;
                await this._headersCapability.promise;
                const {
                  value,
                  done
                } = await this._reader.read();
                if (done) {
                  return {
                    value,
                    done
                  };
                }
                this._loaded += value.byteLength;
                (_a3 = this.onProgress) == null ? void 0 : _a3.call(this, {
                  loaded: this._loaded,
                  total: this._contentLength
                });
                return {
                  value: getArrayBuffer(value),
                  done: false
                };
              }
              cancel(reason) {
                var _a3;
                (_a3 = this._reader) == null ? void 0 : _a3.cancel(reason);
                this._abortController.abort();
              }
            }
            class PDFFetchStreamRangeReader {
              constructor(stream2, begin, end) {
                this._stream = stream2;
                this._reader = null;
                this._loaded = 0;
                const source = stream2.source;
                this._withCredentials = source.withCredentials || false;
                this._readCapability = new _util2.PromiseCapability();
                this._isStreamingSupported = !source.disableStream;
                this._abortController = new AbortController();
                this._headers = createHeaders(this._stream.httpHeaders);
                this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                const url2 = source.url;
                fetch(url2, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response) => {
                  if (!(0, _network_utils.validateResponseStatus)(response.status)) {
                    throw (0, _network_utils.createResponseStatusError)(response.status, url2);
                  }
                  this._readCapability.resolve();
                  this._reader = response.body.getReader();
                }).catch(this._readCapability.reject);
                this.onProgress = null;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                var _a3;
                await this._readCapability.promise;
                const {
                  value,
                  done
                } = await this._reader.read();
                if (done) {
                  return {
                    value,
                    done
                  };
                }
                this._loaded += value.byteLength;
                (_a3 = this.onProgress) == null ? void 0 : _a3.call(this, {
                  loaded: this._loaded
                });
                return {
                  value: getArrayBuffer(value),
                  done: false
                };
              }
              cancel(reason) {
                var _a3;
                (_a3 = this._reader) == null ? void 0 : _a3.cancel(reason);
                this._abortController.abort();
              }
            }
          },
          /* 20 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.createResponseStatusError = createResponseStatusError;
            exports2.extractFilenameFromHeader = extractFilenameFromHeader;
            exports2.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
            exports2.validateResponseStatus = validateResponseStatus;
            var _util2 = __w_pdfjs_require__2(1);
            var _content_disposition = __w_pdfjs_require__2(21);
            var _display_utils2 = __w_pdfjs_require__2(6);
            function validateRangeRequestCapabilities({
              getResponseHeader,
              isHttp,
              rangeChunkSize,
              disableRange
            }) {
              const returnValues = {
                allowRangeRequests: false,
                suggestedLength: void 0
              };
              const length2 = parseInt(getResponseHeader("Content-Length"), 10);
              if (!Number.isInteger(length2)) {
                return returnValues;
              }
              returnValues.suggestedLength = length2;
              if (length2 <= 2 * rangeChunkSize) {
                return returnValues;
              }
              if (disableRange || !isHttp) {
                return returnValues;
              }
              if (getResponseHeader("Accept-Ranges") !== "bytes") {
                return returnValues;
              }
              const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
              if (contentEncoding !== "identity") {
                return returnValues;
              }
              returnValues.allowRangeRequests = true;
              return returnValues;
            }
            function extractFilenameFromHeader(getResponseHeader) {
              const contentDisposition = getResponseHeader("Content-Disposition");
              if (contentDisposition) {
                let filename2 = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                if (filename2.includes("%")) {
                  try {
                    filename2 = decodeURIComponent(filename2);
                  } catch {
                  }
                }
                if ((0, _display_utils2.isPdfFile)(filename2)) {
                  return filename2;
                }
              }
              return null;
            }
            function createResponseStatusError(status, url2) {
              if (status === 404 || status === 0 && url2.startsWith("file:")) {
                return new _util2.MissingPDFException('Missing PDF "' + url2 + '".');
              }
              return new _util2.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url2}".`, status);
            }
            function validateResponseStatus(status) {
              return status === 200 || status === 206;
            }
          },
          /* 21 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
            var _util2 = __w_pdfjs_require__2(1);
            function getFilenameFromContentDispositionHeader(contentDisposition) {
              let needsEncodingFixup = true;
              let tmp2 = toParamRegExp("filename\\*", "i").exec(contentDisposition);
              if (tmp2) {
                tmp2 = tmp2[1];
                let filename2 = rfc2616unquote(tmp2);
                filename2 = unescape(filename2);
                filename2 = rfc5987decode(filename2);
                filename2 = rfc2047decode(filename2);
                return fixupEncoding(filename2);
              }
              tmp2 = rfc2231getparam(contentDisposition);
              if (tmp2) {
                const filename2 = rfc2047decode(tmp2);
                return fixupEncoding(filename2);
              }
              tmp2 = toParamRegExp("filename", "i").exec(contentDisposition);
              if (tmp2) {
                tmp2 = tmp2[1];
                let filename2 = rfc2616unquote(tmp2);
                filename2 = rfc2047decode(filename2);
                return fixupEncoding(filename2);
              }
              function toParamRegExp(attributePattern, flags2) {
                return new RegExp("(?:^|;)\\s*" + attributePattern + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', flags2);
              }
              function textdecode(encoding, value) {
                if (encoding) {
                  if (!/^[\x00-\xFF]+$/.test(value)) {
                    return value;
                  }
                  try {
                    const decoder = new TextDecoder(encoding, {
                      fatal: true
                    });
                    const buffer3 = (0, _util2.stringToBytes)(value);
                    value = decoder.decode(buffer3);
                    needsEncodingFixup = false;
                  } catch {
                  }
                }
                return value;
              }
              function fixupEncoding(value) {
                if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                  value = textdecode("utf-8", value);
                  if (needsEncodingFixup) {
                    value = textdecode("iso-8859-1", value);
                  }
                }
                return value;
              }
              function rfc2231getparam(contentDispositionStr) {
                const matches2 = [];
                let match2;
                const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                while ((match2 = iter.exec(contentDispositionStr)) !== null) {
                  let [, n2, quot, part] = match2;
                  n2 = parseInt(n2, 10);
                  if (n2 in matches2) {
                    if (n2 === 0) {
                      break;
                    }
                    continue;
                  }
                  matches2[n2] = [quot, part];
                }
                const parts = [];
                for (let n2 = 0; n2 < matches2.length; ++n2) {
                  if (!(n2 in matches2)) {
                    break;
                  }
                  let [quot, part] = matches2[n2];
                  part = rfc2616unquote(part);
                  if (quot) {
                    part = unescape(part);
                    if (n2 === 0) {
                      part = rfc5987decode(part);
                    }
                  }
                  parts.push(part);
                }
                return parts.join("");
              }
              function rfc2616unquote(value) {
                if (value.startsWith('"')) {
                  const parts = value.slice(1).split('\\"');
                  for (let i2 = 0; i2 < parts.length; ++i2) {
                    const quotindex = parts[i2].indexOf('"');
                    if (quotindex !== -1) {
                      parts[i2] = parts[i2].slice(0, quotindex);
                      parts.length = i2 + 1;
                    }
                    parts[i2] = parts[i2].replaceAll(/\\(.)/g, "$1");
                  }
                  value = parts.join('"');
                }
                return value;
              }
              function rfc5987decode(extvalue) {
                const encodingend = extvalue.indexOf("'");
                if (encodingend === -1) {
                  return extvalue;
                }
                const encoding = extvalue.slice(0, encodingend);
                const langvalue = extvalue.slice(encodingend + 1);
                const value = langvalue.replace(/^[^']*'/, "");
                return textdecode(encoding, value);
              }
              function rfc2047decode(value) {
                if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
                  return value;
                }
                return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches2, charset, encoding, text) {
                  if (encoding === "q" || encoding === "Q") {
                    text = text.replaceAll("_", " ");
                    text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match2, hex) {
                      return String.fromCharCode(parseInt(hex, 16));
                    });
                    return textdecode(charset, text);
                  }
                  try {
                    text = atob(text);
                  } catch {
                  }
                  return textdecode(charset, text);
                });
              }
              return "";
            }
          },
          /* 22 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.PDFNetworkStream = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _network_utils = __w_pdfjs_require__2(20);
            const OK_RESPONSE = 200;
            const PARTIAL_CONTENT_RESPONSE = 206;
            function getArrayBuffer(xhr) {
              const data2 = xhr.response;
              if (typeof data2 !== "string") {
                return data2;
              }
              return (0, _util2.stringToBytes)(data2).buffer;
            }
            class NetworkManager {
              constructor(url2, args = {}) {
                this.url = url2;
                this.isHttp = /^https?:/i.test(url2);
                this.httpHeaders = this.isHttp && args.httpHeaders || /* @__PURE__ */ Object.create(null);
                this.withCredentials = args.withCredentials || false;
                this.currXhrId = 0;
                this.pendingRequests = /* @__PURE__ */ Object.create(null);
              }
              requestRange(begin, end, listeners2) {
                const args = {
                  begin,
                  end
                };
                for (const prop in listeners2) {
                  args[prop] = listeners2[prop];
                }
                return this.request(args);
              }
              requestFull(listeners2) {
                return this.request(listeners2);
              }
              request(args) {
                const xhr = new XMLHttpRequest();
                const xhrId = this.currXhrId++;
                const pendingRequest = this.pendingRequests[xhrId] = {
                  xhr
                };
                xhr.open("GET", this.url);
                xhr.withCredentials = this.withCredentials;
                for (const property2 in this.httpHeaders) {
                  const value = this.httpHeaders[property2];
                  if (value === void 0) {
                    continue;
                  }
                  xhr.setRequestHeader(property2, value);
                }
                if (this.isHttp && "begin" in args && "end" in args) {
                  xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                  pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                } else {
                  pendingRequest.expectedStatus = OK_RESPONSE;
                }
                xhr.responseType = "arraybuffer";
                if (args.onError) {
                  xhr.onerror = function(evt) {
                    args.onError(xhr.status);
                  };
                }
                xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                xhr.onprogress = this.onProgress.bind(this, xhrId);
                pendingRequest.onHeadersReceived = args.onHeadersReceived;
                pendingRequest.onDone = args.onDone;
                pendingRequest.onError = args.onError;
                pendingRequest.onProgress = args.onProgress;
                xhr.send(null);
                return xhrId;
              }
              onProgress(xhrId, evt) {
                var _a3;
                const pendingRequest = this.pendingRequests[xhrId];
                if (!pendingRequest) {
                  return;
                }
                (_a3 = pendingRequest.onProgress) == null ? void 0 : _a3.call(pendingRequest, evt);
              }
              onStateChange(xhrId, evt) {
                var _a3, _b3, _c2;
                const pendingRequest = this.pendingRequests[xhrId];
                if (!pendingRequest) {
                  return;
                }
                const xhr = pendingRequest.xhr;
                if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                  pendingRequest.onHeadersReceived();
                  delete pendingRequest.onHeadersReceived;
                }
                if (xhr.readyState !== 4) {
                  return;
                }
                if (!(xhrId in this.pendingRequests)) {
                  return;
                }
                delete this.pendingRequests[xhrId];
                if (xhr.status === 0 && this.isHttp) {
                  (_a3 = pendingRequest.onError) == null ? void 0 : _a3.call(pendingRequest, xhr.status);
                  return;
                }
                const xhrStatus = xhr.status || OK_RESPONSE;
                const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                  (_b3 = pendingRequest.onError) == null ? void 0 : _b3.call(pendingRequest, xhr.status);
                  return;
                }
                const chunk = getArrayBuffer(xhr);
                if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                  const rangeHeader = xhr.getResponseHeader("Content-Range");
                  const matches2 = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                  pendingRequest.onDone({
                    begin: parseInt(matches2[1], 10),
                    chunk
                  });
                } else if (chunk) {
                  pendingRequest.onDone({
                    begin: 0,
                    chunk
                  });
                } else {
                  (_c2 = pendingRequest.onError) == null ? void 0 : _c2.call(pendingRequest, xhr.status);
                }
              }
              getRequestXhr(xhrId) {
                return this.pendingRequests[xhrId].xhr;
              }
              isPendingRequest(xhrId) {
                return xhrId in this.pendingRequests;
              }
              abortRequest(xhrId) {
                const xhr = this.pendingRequests[xhrId].xhr;
                delete this.pendingRequests[xhrId];
                xhr.abort();
              }
            }
            class PDFNetworkStream {
              constructor(source) {
                this._source = source;
                this._manager = new NetworkManager(source.url, {
                  httpHeaders: source.httpHeaders,
                  withCredentials: source.withCredentials
                });
                this._rangeChunkSize = source.rangeChunkSize;
                this._fullRequestReader = null;
                this._rangeRequestReaders = [];
              }
              _onRangeRequestReaderClosed(reader) {
                const i2 = this._rangeRequestReaders.indexOf(reader);
                if (i2 >= 0) {
                  this._rangeRequestReaders.splice(i2, 1);
                }
              }
              getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                return this._fullRequestReader;
              }
              getRangeReader(begin, end) {
                const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                this._rangeRequestReaders.push(reader);
                return reader;
              }
              cancelAllRequests(reason) {
                var _a3;
                (_a3 = this._fullRequestReader) == null ? void 0 : _a3.cancel(reason);
                for (const reader of this._rangeRequestReaders.slice(0)) {
                  reader.cancel(reason);
                }
              }
            }
            exports2.PDFNetworkStream = PDFNetworkStream;
            class PDFNetworkStreamFullRequestReader {
              constructor(manager, source) {
                this._manager = manager;
                const args = {
                  onHeadersReceived: this._onHeadersReceived.bind(this),
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = source.url;
                this._fullRequestId = manager.requestFull(args);
                this._headersReceivedCapability = new _util2.PromiseCapability();
                this._disableRange = source.disableRange || false;
                this._contentLength = source.length;
                this._rangeChunkSize = source.rangeChunkSize;
                if (!this._rangeChunkSize && !this._disableRange) {
                  this._disableRange = true;
                }
                this._isStreamingSupported = false;
                this._isRangeSupported = false;
                this._cachedChunks = [];
                this._requests = [];
                this._done = false;
                this._storedError = void 0;
                this._filename = null;
                this.onProgress = null;
              }
              _onHeadersReceived() {
                const fullRequestXhrId = this._fullRequestId;
                const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                const getResponseHeader = (name2) => {
                  return fullRequestXhr.getResponseHeader(name2);
                };
                const {
                  allowRangeRequests,
                  suggestedLength
                } = (0, _network_utils.validateRangeRequestCapabilities)({
                  getResponseHeader,
                  isHttp: this._manager.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                if (allowRangeRequests) {
                  this._isRangeSupported = true;
                }
                this._contentLength = suggestedLength || this._contentLength;
                this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                if (this._isRangeSupported) {
                  this._manager.abortRequest(fullRequestXhrId);
                }
                this._headersReceivedCapability.resolve();
              }
              _onDone(data2) {
                if (data2) {
                  if (this._requests.length > 0) {
                    const requestCapability = this._requests.shift();
                    requestCapability.resolve({
                      value: data2.chunk,
                      done: false
                    });
                  } else {
                    this._cachedChunks.push(data2.chunk);
                  }
                }
                this._done = true;
                if (this._cachedChunks.length > 0) {
                  return;
                }
                for (const requestCapability of this._requests) {
                  requestCapability.resolve({
                    value: void 0,
                    done: true
                  });
                }
                this._requests.length = 0;
              }
              _onError(status) {
                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                this._headersReceivedCapability.reject(this._storedError);
                for (const requestCapability of this._requests) {
                  requestCapability.reject(this._storedError);
                }
                this._requests.length = 0;
                this._cachedChunks.length = 0;
              }
              _onProgress(evt) {
                var _a3;
                (_a3 = this.onProgress) == null ? void 0 : _a3.call(this, {
                  loaded: evt.loaded,
                  total: evt.lengthComputable ? evt.total : this._contentLength
                });
              }
              get filename() {
                return this._filename;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              get contentLength() {
                return this._contentLength;
              }
              get headersReady() {
                return this._headersReceivedCapability.promise;
              }
              async read() {
                if (this._storedError) {
                  throw this._storedError;
                }
                if (this._cachedChunks.length > 0) {
                  const chunk = this._cachedChunks.shift();
                  return {
                    value: chunk,
                    done: false
                  };
                }
                if (this._done) {
                  return {
                    value: void 0,
                    done: true
                  };
                }
                const requestCapability = new _util2.PromiseCapability();
                this._requests.push(requestCapability);
                return requestCapability.promise;
              }
              cancel(reason) {
                this._done = true;
                this._headersReceivedCapability.reject(reason);
                for (const requestCapability of this._requests) {
                  requestCapability.resolve({
                    value: void 0,
                    done: true
                  });
                }
                this._requests.length = 0;
                if (this._manager.isPendingRequest(this._fullRequestId)) {
                  this._manager.abortRequest(this._fullRequestId);
                }
                this._fullRequestReader = null;
              }
            }
            class PDFNetworkStreamRangeRequestReader {
              constructor(manager, begin, end) {
                this._manager = manager;
                const args = {
                  onDone: this._onDone.bind(this),
                  onError: this._onError.bind(this),
                  onProgress: this._onProgress.bind(this)
                };
                this._url = manager.url;
                this._requestId = manager.requestRange(begin, end, args);
                this._requests = [];
                this._queuedChunk = null;
                this._done = false;
                this._storedError = void 0;
                this.onProgress = null;
                this.onClosed = null;
              }
              _close() {
                var _a3;
                (_a3 = this.onClosed) == null ? void 0 : _a3.call(this, this);
              }
              _onDone(data2) {
                const chunk = data2.chunk;
                if (this._requests.length > 0) {
                  const requestCapability = this._requests.shift();
                  requestCapability.resolve({
                    value: chunk,
                    done: false
                  });
                } else {
                  this._queuedChunk = chunk;
                }
                this._done = true;
                for (const requestCapability of this._requests) {
                  requestCapability.resolve({
                    value: void 0,
                    done: true
                  });
                }
                this._requests.length = 0;
                this._close();
              }
              _onError(status) {
                this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                for (const requestCapability of this._requests) {
                  requestCapability.reject(this._storedError);
                }
                this._requests.length = 0;
                this._queuedChunk = null;
              }
              _onProgress(evt) {
                var _a3;
                if (!this.isStreamingSupported) {
                  (_a3 = this.onProgress) == null ? void 0 : _a3.call(this, {
                    loaded: evt.loaded
                  });
                }
              }
              get isStreamingSupported() {
                return false;
              }
              async read() {
                if (this._storedError) {
                  throw this._storedError;
                }
                if (this._queuedChunk !== null) {
                  const chunk = this._queuedChunk;
                  this._queuedChunk = null;
                  return {
                    value: chunk,
                    done: false
                  };
                }
                if (this._done) {
                  return {
                    value: void 0,
                    done: true
                  };
                }
                const requestCapability = new _util2.PromiseCapability();
                this._requests.push(requestCapability);
                return requestCapability.promise;
              }
              cancel(reason) {
                this._done = true;
                for (const requestCapability of this._requests) {
                  requestCapability.resolve({
                    value: void 0,
                    done: true
                  });
                }
                this._requests.length = 0;
                if (this._manager.isPendingRequest(this._requestId)) {
                  this._manager.abortRequest(this._requestId);
                }
                this._close();
              }
            }
          },
          /* 23 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.PDFNodeStream = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _network_utils = __w_pdfjs_require__2(20);
            const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
            function parseUrl2(sourceUrl) {
              const url2 = require$$1$2;
              const parsedUrl = url2.parse(sourceUrl);
              if (parsedUrl.protocol === "file:" || parsedUrl.host) {
                return parsedUrl;
              }
              if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
                return url2.parse(`file:///${sourceUrl}`);
              }
              if (!parsedUrl.host) {
                parsedUrl.protocol = "file:";
              }
              return parsedUrl;
            }
            class PDFNodeStream {
              constructor(source) {
                this.source = source;
                this.url = parseUrl2(source.url);
                this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                this.isFsUrl = this.url.protocol === "file:";
                this.httpHeaders = this.isHttp && source.httpHeaders || {};
                this._fullRequestReader = null;
                this._rangeRequestReaders = [];
              }
              get _progressiveDataLength() {
                var _a3;
                return ((_a3 = this._fullRequestReader) == null ? void 0 : _a3._loaded) ?? 0;
              }
              getFullReader() {
                (0, _util2.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                return this._fullRequestReader;
              }
              getRangeReader(start2, end) {
                if (end <= this._progressiveDataLength) {
                  return null;
                }
                const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start2, end) : new PDFNodeStreamRangeReader(this, start2, end);
                this._rangeRequestReaders.push(rangeReader);
                return rangeReader;
              }
              cancelAllRequests(reason) {
                var _a3;
                (_a3 = this._fullRequestReader) == null ? void 0 : _a3.cancel(reason);
                for (const reader of this._rangeRequestReaders.slice(0)) {
                  reader.cancel(reason);
                }
              }
            }
            exports2.PDFNodeStream = PDFNodeStream;
            class BaseFullReader {
              constructor(stream2) {
                this._url = stream2.url;
                this._done = false;
                this._storedError = null;
                this.onProgress = null;
                const source = stream2.source;
                this._contentLength = source.length;
                this._loaded = 0;
                this._filename = null;
                this._disableRange = source.disableRange || false;
                this._rangeChunkSize = source.rangeChunkSize;
                if (!this._rangeChunkSize && !this._disableRange) {
                  this._disableRange = true;
                }
                this._isStreamingSupported = !source.disableStream;
                this._isRangeSupported = !source.disableRange;
                this._readableStream = null;
                this._readCapability = new _util2.PromiseCapability();
                this._headersCapability = new _util2.PromiseCapability();
              }
              get headersReady() {
                return this._headersCapability.promise;
              }
              get filename() {
                return this._filename;
              }
              get contentLength() {
                return this._contentLength;
              }
              get isRangeSupported() {
                return this._isRangeSupported;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                var _a3;
                await this._readCapability.promise;
                if (this._done) {
                  return {
                    value: void 0,
                    done: true
                  };
                }
                if (this._storedError) {
                  throw this._storedError;
                }
                const chunk = this._readableStream.read();
                if (chunk === null) {
                  this._readCapability = new _util2.PromiseCapability();
                  return this.read();
                }
                this._loaded += chunk.length;
                (_a3 = this.onProgress) == null ? void 0 : _a3.call(this, {
                  loaded: this._loaded,
                  total: this._contentLength
                });
                const buffer3 = new Uint8Array(chunk).buffer;
                return {
                  value: buffer3,
                  done: false
                };
              }
              cancel(reason) {
                if (!this._readableStream) {
                  this._error(reason);
                  return;
                }
                this._readableStream.destroy(reason);
              }
              _error(reason) {
                this._storedError = reason;
                this._readCapability.resolve();
              }
              _setReadableStream(readableStream) {
                this._readableStream = readableStream;
                readableStream.on("readable", () => {
                  this._readCapability.resolve();
                });
                readableStream.on("end", () => {
                  readableStream.destroy();
                  this._done = true;
                  this._readCapability.resolve();
                });
                readableStream.on("error", (reason) => {
                  this._error(reason);
                });
                if (!this._isStreamingSupported && this._isRangeSupported) {
                  this._error(new _util2.AbortException("streaming is disabled"));
                }
                if (this._storedError) {
                  this._readableStream.destroy(this._storedError);
                }
              }
            }
            class BaseRangeReader {
              constructor(stream2) {
                this._url = stream2.url;
                this._done = false;
                this._storedError = null;
                this.onProgress = null;
                this._loaded = 0;
                this._readableStream = null;
                this._readCapability = new _util2.PromiseCapability();
                const source = stream2.source;
                this._isStreamingSupported = !source.disableStream;
              }
              get isStreamingSupported() {
                return this._isStreamingSupported;
              }
              async read() {
                var _a3;
                await this._readCapability.promise;
                if (this._done) {
                  return {
                    value: void 0,
                    done: true
                  };
                }
                if (this._storedError) {
                  throw this._storedError;
                }
                const chunk = this._readableStream.read();
                if (chunk === null) {
                  this._readCapability = new _util2.PromiseCapability();
                  return this.read();
                }
                this._loaded += chunk.length;
                (_a3 = this.onProgress) == null ? void 0 : _a3.call(this, {
                  loaded: this._loaded
                });
                const buffer3 = new Uint8Array(chunk).buffer;
                return {
                  value: buffer3,
                  done: false
                };
              }
              cancel(reason) {
                if (!this._readableStream) {
                  this._error(reason);
                  return;
                }
                this._readableStream.destroy(reason);
              }
              _error(reason) {
                this._storedError = reason;
                this._readCapability.resolve();
              }
              _setReadableStream(readableStream) {
                this._readableStream = readableStream;
                readableStream.on("readable", () => {
                  this._readCapability.resolve();
                });
                readableStream.on("end", () => {
                  readableStream.destroy();
                  this._done = true;
                  this._readCapability.resolve();
                });
                readableStream.on("error", (reason) => {
                  this._error(reason);
                });
                if (this._storedError) {
                  this._readableStream.destroy(this._storedError);
                }
              }
            }
            function createRequestOptions(parsedUrl, headers) {
              return {
                protocol: parsedUrl.protocol,
                auth: parsedUrl.auth,
                host: parsedUrl.hostname,
                port: parsedUrl.port,
                path: parsedUrl.path,
                method: "GET",
                headers
              };
            }
            class PDFNodeStreamFullReader extends BaseFullReader {
              constructor(stream2) {
                super(stream2);
                const handleResponse = (response) => {
                  if (response.statusCode === 404) {
                    const error2 = new _util2.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = error2;
                    this._headersCapability.reject(error2);
                    return;
                  }
                  this._headersCapability.resolve();
                  this._setReadableStream(response);
                  const getResponseHeader = (name2) => {
                    return this._readableStream.headers[name2.toLowerCase()];
                  };
                  const {
                    allowRangeRequests,
                    suggestedLength
                  } = (0, _network_utils.validateRangeRequestCapabilities)({
                    getResponseHeader,
                    isHttp: stream2.isHttp,
                    rangeChunkSize: this._rangeChunkSize,
                    disableRange: this._disableRange
                  });
                  this._isRangeSupported = allowRangeRequests;
                  this._contentLength = suggestedLength || this._contentLength;
                  this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                };
                this._request = null;
                if (this._url.protocol === "http:") {
                  const http = require$$1$2;
                  this._request = http.request(createRequestOptions(this._url, stream2.httpHeaders), handleResponse);
                } else {
                  const https = require$$1$2;
                  this._request = https.request(createRequestOptions(this._url, stream2.httpHeaders), handleResponse);
                }
                this._request.on("error", (reason) => {
                  this._storedError = reason;
                  this._headersCapability.reject(reason);
                });
                this._request.end();
              }
            }
            class PDFNodeStreamRangeReader extends BaseRangeReader {
              constructor(stream2, start2, end) {
                super(stream2);
                this._httpHeaders = {};
                for (const property2 in stream2.httpHeaders) {
                  const value = stream2.httpHeaders[property2];
                  if (value === void 0) {
                    continue;
                  }
                  this._httpHeaders[property2] = value;
                }
                this._httpHeaders.Range = `bytes=${start2}-${end - 1}`;
                const handleResponse = (response) => {
                  if (response.statusCode === 404) {
                    const error2 = new _util2.MissingPDFException(`Missing PDF "${this._url}".`);
                    this._storedError = error2;
                    return;
                  }
                  this._setReadableStream(response);
                };
                this._request = null;
                if (this._url.protocol === "http:") {
                  const http = require$$1$2;
                  this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                } else {
                  const https = require$$1$2;
                  this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                }
                this._request.on("error", (reason) => {
                  this._storedError = reason;
                });
                this._request.end();
              }
            }
            class PDFNodeStreamFsFullReader extends BaseFullReader {
              constructor(stream2) {
                super(stream2);
                let path2 = decodeURIComponent(this._url.path);
                if (fileUriRegex.test(this._url.href)) {
                  path2 = path2.replace(/^\//, "");
                }
                const fs2 = require$$1$2;
                fs2.lstat(path2, (error2, stat) => {
                  if (error2) {
                    if (error2.code === "ENOENT") {
                      error2 = new _util2.MissingPDFException(`Missing PDF "${path2}".`);
                    }
                    this._storedError = error2;
                    this._headersCapability.reject(error2);
                    return;
                  }
                  this._contentLength = stat.size;
                  this._setReadableStream(fs2.createReadStream(path2));
                  this._headersCapability.resolve();
                });
              }
            }
            class PDFNodeStreamFsRangeReader extends BaseRangeReader {
              constructor(stream2, start2, end) {
                super(stream2);
                let path2 = decodeURIComponent(this._url.path);
                if (fileUriRegex.test(this._url.href)) {
                  path2 = path2.replace(/^\//, "");
                }
                const fs2 = require$$1$2;
                this._setReadableStream(fs2.createReadStream(path2, {
                  start: start2,
                  end: end - 1
                }));
              }
            }
          },
          /* 24 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.SVGGraphics = void 0;
            var _display_utils2 = __w_pdfjs_require__2(6);
            var _util2 = __w_pdfjs_require__2(1);
            const SVG_DEFAULTS = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            };
            const XML_NS = "http://www.w3.org/XML/1998/namespace";
            const XLINK_NS = "http://www.w3.org/1999/xlink";
            const LINE_CAP_STYLES = ["butt", "round", "square"];
            const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
            const createObjectURL = function(data2, contentType = "", forceDataSchema = false) {
              if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) {
                return URL.createObjectURL(new Blob([data2], {
                  type: contentType
                }));
              }
              const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
              let buffer3 = `data:${contentType};base64,`;
              for (let i2 = 0, ii2 = data2.length; i2 < ii2; i2 += 3) {
                const b1 = data2[i2] & 255;
                const b2 = data2[i2 + 1] & 255;
                const b3 = data2[i2 + 2] & 255;
                const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                const d3 = i2 + 1 < ii2 ? (b2 & 15) << 2 | b3 >> 6 : 64;
                const d4 = i2 + 2 < ii2 ? b3 & 63 : 64;
                buffer3 += digits[d1] + digits[d2] + digits[d3] + digits[d4];
              }
              return buffer3;
            };
            const convertImgDataToPng = function() {
              const PNG_HEADER = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]);
              const CHUNK_WRAPPER_SIZE = 12;
              const crcTable = new Int32Array(256);
              for (let i2 = 0; i2 < 256; i2++) {
                let c2 = i2;
                for (let h2 = 0; h2 < 8; h2++) {
                  c2 = c2 & 1 ? 3988292384 ^ c2 >> 1 & 2147483647 : c2 >> 1 & 2147483647;
                }
                crcTable[i2] = c2;
              }
              function crc32(data2, start2, end) {
                let crc = -1;
                for (let i2 = start2; i2 < end; i2++) {
                  const a2 = (crc ^ data2[i2]) & 255;
                  const b2 = crcTable[a2];
                  crc = crc >>> 8 ^ b2;
                }
                return crc ^ -1;
              }
              function writePngChunk(type, body, data2, offset) {
                let p2 = offset;
                const len2 = body.length;
                data2[p2] = len2 >> 24 & 255;
                data2[p2 + 1] = len2 >> 16 & 255;
                data2[p2 + 2] = len2 >> 8 & 255;
                data2[p2 + 3] = len2 & 255;
                p2 += 4;
                data2[p2] = type.charCodeAt(0) & 255;
                data2[p2 + 1] = type.charCodeAt(1) & 255;
                data2[p2 + 2] = type.charCodeAt(2) & 255;
                data2[p2 + 3] = type.charCodeAt(3) & 255;
                p2 += 4;
                data2.set(body, p2);
                p2 += body.length;
                const crc = crc32(data2, offset + 4, p2);
                data2[p2] = crc >> 24 & 255;
                data2[p2 + 1] = crc >> 16 & 255;
                data2[p2 + 2] = crc >> 8 & 255;
                data2[p2 + 3] = crc & 255;
              }
              function adler32(data2, start2, end) {
                let a2 = 1;
                let b2 = 0;
                for (let i2 = start2; i2 < end; ++i2) {
                  a2 = (a2 + (data2[i2] & 255)) % 65521;
                  b2 = (b2 + a2) % 65521;
                }
                return b2 << 16 | a2;
              }
              function deflateSync(literals) {
                if (!_util2.isNodeJS) {
                  return deflateSyncUncompressed(literals);
                }
                try {
                  const input = parseInt(process.versions.node) >= 8 ? literals : Buffer.from(literals);
                  const output2 = require$$1$2.deflateSync(input, {
                    level: 9
                  });
                  return output2 instanceof Uint8Array ? output2 : new Uint8Array(output2);
                } catch (e3) {
                  (0, _util2.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e3);
                }
                return deflateSyncUncompressed(literals);
              }
              function deflateSyncUncompressed(literals) {
                let len2 = literals.length;
                const maxBlockLength = 65535;
                const deflateBlocks = Math.ceil(len2 / maxBlockLength);
                const idat = new Uint8Array(2 + len2 + deflateBlocks * 5 + 4);
                let pi2 = 0;
                idat[pi2++] = 120;
                idat[pi2++] = 156;
                let pos = 0;
                while (len2 > maxBlockLength) {
                  idat[pi2++] = 0;
                  idat[pi2++] = 255;
                  idat[pi2++] = 255;
                  idat[pi2++] = 0;
                  idat[pi2++] = 0;
                  idat.set(literals.subarray(pos, pos + maxBlockLength), pi2);
                  pi2 += maxBlockLength;
                  pos += maxBlockLength;
                  len2 -= maxBlockLength;
                }
                idat[pi2++] = 1;
                idat[pi2++] = len2 & 255;
                idat[pi2++] = len2 >> 8 & 255;
                idat[pi2++] = ~len2 & 65535 & 255;
                idat[pi2++] = (~len2 & 65535) >> 8 & 255;
                idat.set(literals.subarray(pos), pi2);
                pi2 += literals.length - pos;
                const adler = adler32(literals, 0, literals.length);
                idat[pi2++] = adler >> 24 & 255;
                idat[pi2++] = adler >> 16 & 255;
                idat[pi2++] = adler >> 8 & 255;
                idat[pi2++] = adler & 255;
                return idat;
              }
              function encode2(imgData, kind, forceDataSchema, isMask) {
                const width = imgData.width;
                const height = imgData.height;
                let bitDepth, colorType, lineSize;
                const bytes = imgData.data;
                switch (kind) {
                  case _util2.ImageKind.GRAYSCALE_1BPP:
                    colorType = 0;
                    bitDepth = 1;
                    lineSize = width + 7 >> 3;
                    break;
                  case _util2.ImageKind.RGB_24BPP:
                    colorType = 2;
                    bitDepth = 8;
                    lineSize = width * 3;
                    break;
                  case _util2.ImageKind.RGBA_32BPP:
                    colorType = 6;
                    bitDepth = 8;
                    lineSize = width * 4;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                const literals = new Uint8Array((1 + lineSize) * height);
                let offsetLiterals = 0, offsetBytes = 0;
                for (let y2 = 0; y2 < height; ++y2) {
                  literals[offsetLiterals++] = 0;
                  literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                  offsetBytes += lineSize;
                  offsetLiterals += lineSize;
                }
                if (kind === _util2.ImageKind.GRAYSCALE_1BPP && isMask) {
                  offsetLiterals = 0;
                  for (let y2 = 0; y2 < height; y2++) {
                    offsetLiterals++;
                    for (let i2 = 0; i2 < lineSize; i2++) {
                      literals[offsetLiterals++] ^= 255;
                    }
                  }
                }
                const ihdr = new Uint8Array([width >> 24 & 255, width >> 16 & 255, width >> 8 & 255, width & 255, height >> 24 & 255, height >> 16 & 255, height >> 8 & 255, height & 255, bitDepth, colorType, 0, 0, 0]);
                const idat = deflateSync(literals);
                const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                const data2 = new Uint8Array(pngLength);
                let offset = 0;
                data2.set(PNG_HEADER, offset);
                offset += PNG_HEADER.length;
                writePngChunk("IHDR", ihdr, data2, offset);
                offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                writePngChunk("IDATA", idat, data2, offset);
                offset += CHUNK_WRAPPER_SIZE + idat.length;
                writePngChunk("IEND", new Uint8Array(0), data2, offset);
                return createObjectURL(data2, "image/png", forceDataSchema);
              }
              return function convertImgDataToPng2(imgData, forceDataSchema, isMask) {
                const kind = imgData.kind === void 0 ? _util2.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                return encode2(imgData, kind, forceDataSchema, isMask);
              };
            }();
            class SVGExtraState {
              constructor() {
                this.fontSizeScale = 1;
                this.fontWeight = SVG_DEFAULTS.fontWeight;
                this.fontSize = 0;
                this.textMatrix = _util2.IDENTITY_MATRIX;
                this.fontMatrix = _util2.FONT_IDENTITY_MATRIX;
                this.leading = 0;
                this.textRenderingMode = _util2.TextRenderingMode.FILL;
                this.textMatrixScale = 1;
                this.x = 0;
                this.y = 0;
                this.lineX = 0;
                this.lineY = 0;
                this.charSpacing = 0;
                this.wordSpacing = 0;
                this.textHScale = 1;
                this.textRise = 0;
                this.fillColor = SVG_DEFAULTS.fillColor;
                this.strokeColor = "#000000";
                this.fillAlpha = 1;
                this.strokeAlpha = 1;
                this.lineWidth = 1;
                this.lineJoin = "";
                this.lineCap = "";
                this.miterLimit = 0;
                this.dashArray = [];
                this.dashPhase = 0;
                this.dependencies = [];
                this.activeClipUrl = null;
                this.clipGroup = null;
                this.maskId = "";
              }
              clone() {
                return Object.create(this);
              }
              setCurrentPoint(x2, y2) {
                this.x = x2;
                this.y = y2;
              }
            }
            function opListToTree(opList) {
              let opTree = [];
              const tmp2 = [];
              for (const opListElement of opList) {
                if (opListElement.fn === "save") {
                  opTree.push({
                    fnId: 92,
                    fn: "group",
                    items: []
                  });
                  tmp2.push(opTree);
                  opTree = opTree.at(-1).items;
                  continue;
                }
                if (opListElement.fn === "restore") {
                  opTree = tmp2.pop();
                } else {
                  opTree.push(opListElement);
                }
              }
              return opTree;
            }
            function pf(value) {
              if (Number.isInteger(value)) {
                return value.toString();
              }
              const s2 = value.toFixed(10);
              let i2 = s2.length - 1;
              if (s2[i2] !== "0") {
                return s2;
              }
              do {
                i2--;
              } while (s2[i2] === "0");
              return s2.substring(0, s2[i2] === "." ? i2 : i2 + 1);
            }
            function pm(m2) {
              if (m2[4] === 0 && m2[5] === 0) {
                if (m2[1] === 0 && m2[2] === 0) {
                  if (m2[0] === 1 && m2[3] === 1) {
                    return "";
                  }
                  return `scale(${pf(m2[0])} ${pf(m2[3])})`;
                }
                if (m2[0] === m2[3] && m2[1] === -m2[2]) {
                  const a2 = Math.acos(m2[0]) * 180 / Math.PI;
                  return `rotate(${pf(a2)})`;
                }
              } else if (m2[0] === 1 && m2[1] === 0 && m2[2] === 0 && m2[3] === 1) {
                return `translate(${pf(m2[4])} ${pf(m2[5])})`;
              }
              return `matrix(${pf(m2[0])} ${pf(m2[1])} ${pf(m2[2])} ${pf(m2[3])} ${pf(m2[4])} ${pf(m2[5])})`;
            }
            let clipCount = 0;
            let maskCount = 0;
            let shadingCount = 0;
            class SVGGraphics {
              constructor(commonObjs, objs, forceDataSchema = false) {
                (0, _display_utils2.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                this.svgFactory = new _display_utils2.DOMSVGFactory();
                this.current = new SVGExtraState();
                this.transformMatrix = _util2.IDENTITY_MATRIX;
                this.transformStack = [];
                this.extraStack = [];
                this.commonObjs = commonObjs;
                this.objs = objs;
                this.pendingClip = null;
                this.pendingEOFill = false;
                this.embedFonts = false;
                this.embeddedFonts = /* @__PURE__ */ Object.create(null);
                this.cssStyle = null;
                this.forceDataSchema = !!forceDataSchema;
                this._operatorIdMapping = [];
                for (const op in _util2.OPS) {
                  this._operatorIdMapping[_util2.OPS[op]] = op;
                }
              }
              getObject(data2, fallback = null) {
                if (typeof data2 === "string") {
                  return data2.startsWith("g_") ? this.commonObjs.get(data2) : this.objs.get(data2);
                }
                return fallback;
              }
              save() {
                this.transformStack.push(this.transformMatrix);
                const old = this.current;
                this.extraStack.push(old);
                this.current = old.clone();
              }
              restore() {
                this.transformMatrix = this.transformStack.pop();
                this.current = this.extraStack.pop();
                this.pendingClip = null;
                this.tgrp = null;
              }
              group(items) {
                this.save();
                this.executeOpTree(items);
                this.restore();
              }
              loadDependencies(operatorList) {
                const fnArray = operatorList.fnArray;
                const argsArray = operatorList.argsArray;
                for (let i2 = 0, ii2 = fnArray.length; i2 < ii2; i2++) {
                  if (fnArray[i2] !== _util2.OPS.dependency) {
                    continue;
                  }
                  for (const obj of argsArray[i2]) {
                    const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                    const promise = new Promise((resolve2) => {
                      objsPool.get(obj, resolve2);
                    });
                    this.current.dependencies.push(promise);
                  }
                }
                return Promise.all(this.current.dependencies);
              }
              transform(a2, b2, c2, d2, e3, f2) {
                const transformMatrix = [a2, b2, c2, d2, e3, f2];
                this.transformMatrix = _util2.Util.transform(this.transformMatrix, transformMatrix);
                this.tgrp = null;
              }
              getSVG(operatorList, viewport) {
                this.viewport = viewport;
                const svgElement = this._initialize(viewport);
                return this.loadDependencies(operatorList).then(() => {
                  this.transformMatrix = _util2.IDENTITY_MATRIX;
                  this.executeOpTree(this.convertOpList(operatorList));
                  return svgElement;
                });
              }
              convertOpList(operatorList) {
                const operatorIdMapping = this._operatorIdMapping;
                const argsArray = operatorList.argsArray;
                const fnArray = operatorList.fnArray;
                const opList = [];
                for (let i2 = 0, ii2 = fnArray.length; i2 < ii2; i2++) {
                  const fnId = fnArray[i2];
                  opList.push({
                    fnId,
                    fn: operatorIdMapping[fnId],
                    args: argsArray[i2]
                  });
                }
                return opListToTree(opList);
              }
              executeOpTree(opTree) {
                for (const opTreeElement of opTree) {
                  const fn2 = opTreeElement.fn;
                  const fnId = opTreeElement.fnId;
                  const args = opTreeElement.args;
                  switch (fnId | 0) {
                    case _util2.OPS.beginText:
                      this.beginText();
                      break;
                    case _util2.OPS.dependency:
                      break;
                    case _util2.OPS.setLeading:
                      this.setLeading(args);
                      break;
                    case _util2.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(args[0], args[1]);
                      break;
                    case _util2.OPS.setFont:
                      this.setFont(args);
                      break;
                    case _util2.OPS.showText:
                      this.showText(args[0]);
                      break;
                    case _util2.OPS.showSpacedText:
                      this.showText(args[0]);
                      break;
                    case _util2.OPS.endText:
                      this.endText();
                      break;
                    case _util2.OPS.moveText:
                      this.moveText(args[0], args[1]);
                      break;
                    case _util2.OPS.setCharSpacing:
                      this.setCharSpacing(args[0]);
                      break;
                    case _util2.OPS.setWordSpacing:
                      this.setWordSpacing(args[0]);
                      break;
                    case _util2.OPS.setHScale:
                      this.setHScale(args[0]);
                      break;
                    case _util2.OPS.setTextMatrix:
                      this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                      break;
                    case _util2.OPS.setTextRise:
                      this.setTextRise(args[0]);
                      break;
                    case _util2.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(args[0]);
                      break;
                    case _util2.OPS.setLineWidth:
                      this.setLineWidth(args[0]);
                      break;
                    case _util2.OPS.setLineJoin:
                      this.setLineJoin(args[0]);
                      break;
                    case _util2.OPS.setLineCap:
                      this.setLineCap(args[0]);
                      break;
                    case _util2.OPS.setMiterLimit:
                      this.setMiterLimit(args[0]);
                      break;
                    case _util2.OPS.setFillRGBColor:
                      this.setFillRGBColor(args[0], args[1], args[2]);
                      break;
                    case _util2.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(args[0], args[1], args[2]);
                      break;
                    case _util2.OPS.setStrokeColorN:
                      this.setStrokeColorN(args);
                      break;
                    case _util2.OPS.setFillColorN:
                      this.setFillColorN(args);
                      break;
                    case _util2.OPS.shadingFill:
                      this.shadingFill(args[0]);
                      break;
                    case _util2.OPS.setDash:
                      this.setDash(args[0], args[1]);
                      break;
                    case _util2.OPS.setRenderingIntent:
                      this.setRenderingIntent(args[0]);
                      break;
                    case _util2.OPS.setFlatness:
                      this.setFlatness(args[0]);
                      break;
                    case _util2.OPS.setGState:
                      this.setGState(args[0]);
                      break;
                    case _util2.OPS.fill:
                      this.fill();
                      break;
                    case _util2.OPS.eoFill:
                      this.eoFill();
                      break;
                    case _util2.OPS.stroke:
                      this.stroke();
                      break;
                    case _util2.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case _util2.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case _util2.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case _util2.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case _util2.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case _util2.OPS.paintImageXObject:
                      this.paintImageXObject(args[0]);
                      break;
                    case _util2.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(args[0]);
                      break;
                    case _util2.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(args[0]);
                      break;
                    case _util2.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(args[0], args[1]);
                      break;
                    case _util2.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case _util2.OPS.closePath:
                      this.closePath();
                      break;
                    case _util2.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case _util2.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case _util2.OPS.closeEOFillStroke:
                      this.closeEOFillStroke();
                      break;
                    case _util2.OPS.nextLine:
                      this.nextLine();
                      break;
                    case _util2.OPS.transform:
                      this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                      break;
                    case _util2.OPS.constructPath:
                      this.constructPath(args[0], args[1]);
                      break;
                    case _util2.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(opTreeElement.items);
                      break;
                    default:
                      (0, _util2.warn)(`Unimplemented operator ${fn2}`);
                      break;
                  }
                }
              }
              setWordSpacing(wordSpacing) {
                this.current.wordSpacing = wordSpacing;
              }
              setCharSpacing(charSpacing) {
                this.current.charSpacing = charSpacing;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              setTextMatrix(a2, b2, c2, d2, e3, f2) {
                const current = this.current;
                current.textMatrix = current.lineMatrix = [a2, b2, c2, d2, e3, f2];
                current.textMatrixScale = Math.hypot(a2, b2);
                current.x = current.lineX = 0;
                current.y = current.lineY = 0;
                current.xcoords = [];
                current.ycoords = [];
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                current.txtElement = this.svgFactory.createElement("svg:text");
                current.txtElement.append(current.tspan);
              }
              beginText() {
                const current = this.current;
                current.x = current.lineX = 0;
                current.y = current.lineY = 0;
                current.textMatrix = _util2.IDENTITY_MATRIX;
                current.lineMatrix = _util2.IDENTITY_MATRIX;
                current.textMatrixScale = 1;
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.txtElement = this.svgFactory.createElement("svg:text");
                current.txtgrp = this.svgFactory.createElement("svg:g");
                current.xcoords = [];
                current.ycoords = [];
              }
              moveText(x2, y2) {
                const current = this.current;
                current.x = current.lineX += x2;
                current.y = current.lineY += y2;
                current.xcoords = [];
                current.ycoords = [];
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                current.tspan.setAttributeNS(null, "y", pf(-current.y));
              }
              showText(glyphs) {
                const current = this.current;
                const font = current.font;
                const fontSize = current.fontSize;
                if (fontSize === 0) {
                  return;
                }
                const fontSizeScale = current.fontSizeScale;
                const charSpacing = current.charSpacing;
                const wordSpacing = current.wordSpacing;
                const fontDirection = current.fontDirection;
                const textHScale = current.textHScale * fontDirection;
                const vertical = font.vertical;
                const spacingDir = vertical ? 1 : -1;
                const defaultVMetrics = font.defaultVMetrics;
                const widthAdvanceScale = fontSize * current.fontMatrix[0];
                let x2 = 0;
                for (const glyph of glyphs) {
                  if (glyph === null) {
                    x2 += fontDirection * wordSpacing;
                    continue;
                  } else if (typeof glyph === "number") {
                    x2 += spacingDir * glyph * fontSize / 1e3;
                    continue;
                  }
                  const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                  const character = glyph.fontChar;
                  let scaledX, scaledY;
                  let width = glyph.width;
                  if (vertical) {
                    let vx;
                    const vmetric = glyph.vmetric || defaultVMetrics;
                    vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                    vx = -vx * widthAdvanceScale;
                    const vy = vmetric[2] * widthAdvanceScale;
                    width = vmetric ? -vmetric[0] : width;
                    scaledX = vx / fontSizeScale;
                    scaledY = (x2 + vy) / fontSizeScale;
                  } else {
                    scaledX = x2 / fontSizeScale;
                    scaledY = 0;
                  }
                  if (glyph.isInFont || font.missingFile) {
                    current.xcoords.push(current.x + scaledX);
                    if (vertical) {
                      current.ycoords.push(-current.y + scaledY);
                    }
                    current.tspan.textContent += character;
                  }
                  const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                  x2 += charWidth;
                }
                current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                if (vertical) {
                  current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                } else {
                  current.tspan.setAttributeNS(null, "y", pf(-current.y));
                }
                if (vertical) {
                  current.y -= x2;
                } else {
                  current.x += x2 * textHScale;
                }
                current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
                  current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                }
                if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
                  current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                }
                const fillStrokeMode = current.textRenderingMode & _util2.TextRenderingMode.FILL_STROKE_MASK;
                if (fillStrokeMode === _util2.TextRenderingMode.FILL || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                  if (current.fillColor !== SVG_DEFAULTS.fillColor) {
                    current.tspan.setAttributeNS(null, "fill", current.fillColor);
                  }
                  if (current.fillAlpha < 1) {
                    current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                  }
                } else if (current.textRenderingMode === _util2.TextRenderingMode.ADD_TO_PATH) {
                  current.tspan.setAttributeNS(null, "fill", "transparent");
                } else {
                  current.tspan.setAttributeNS(null, "fill", "none");
                }
                if (fillStrokeMode === _util2.TextRenderingMode.STROKE || fillStrokeMode === _util2.TextRenderingMode.FILL_STROKE) {
                  const lineWidthScale = 1 / (current.textMatrixScale || 1);
                  this._setStrokeAttributes(current.tspan, lineWidthScale);
                }
                let textMatrix = current.textMatrix;
                if (current.textRise !== 0) {
                  textMatrix = textMatrix.slice();
                  textMatrix[5] += current.textRise;
                }
                current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                current.txtElement.append(current.tspan);
                current.txtgrp.append(current.txtElement);
                this._ensureTransformGroup().append(current.txtElement);
              }
              setLeadingMoveText(x2, y2) {
                this.setLeading(-y2);
                this.moveText(x2, y2);
              }
              addFontStyle(fontObj) {
                if (!fontObj.data) {
                  throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                }
                if (!this.cssStyle) {
                  this.cssStyle = this.svgFactory.createElement("svg:style");
                  this.cssStyle.setAttributeNS(null, "type", "text/css");
                  this.defs.append(this.cssStyle);
                }
                const url2 = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}"; src: url(${url2}); }
`;
              }
              setFont(details) {
                const current = this.current;
                const fontObj = this.commonObjs.get(details[0]);
                let size12 = details[1];
                current.font = fontObj;
                if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                  this.addFontStyle(fontObj);
                  this.embeddedFonts[fontObj.loadedName] = fontObj;
                }
                current.fontMatrix = fontObj.fontMatrix || _util2.FONT_IDENTITY_MATRIX;
                let bold = "normal";
                if (fontObj.black) {
                  bold = "900";
                } else if (fontObj.bold) {
                  bold = "bold";
                }
                const italic = fontObj.italic ? "italic" : "normal";
                if (size12 < 0) {
                  size12 = -size12;
                  current.fontDirection = -1;
                } else {
                  current.fontDirection = 1;
                }
                current.fontSize = size12;
                current.fontFamily = fontObj.loadedName;
                current.fontWeight = bold;
                current.fontStyle = italic;
                current.tspan = this.svgFactory.createElement("svg:tspan");
                current.tspan.setAttributeNS(null, "y", pf(-current.y));
                current.xcoords = [];
                current.ycoords = [];
              }
              endText() {
                var _a3;
                const current = this.current;
                if (current.textRenderingMode & _util2.TextRenderingMode.ADD_TO_PATH_FLAG && ((_a3 = current.txtElement) == null ? void 0 : _a3.hasChildNodes())) {
                  current.element = current.txtElement;
                  this.clip("nonzero");
                  this.endPath();
                }
              }
              setLineWidth(width) {
                if (width > 0) {
                  this.current.lineWidth = width;
                }
              }
              setLineCap(style2) {
                this.current.lineCap = LINE_CAP_STYLES[style2];
              }
              setLineJoin(style2) {
                this.current.lineJoin = LINE_JOIN_STYLES[style2];
              }
              setMiterLimit(limit) {
                this.current.miterLimit = limit;
              }
              setStrokeAlpha(strokeAlpha) {
                this.current.strokeAlpha = strokeAlpha;
              }
              setStrokeRGBColor(r2, g2, b2) {
                this.current.strokeColor = _util2.Util.makeHexColor(r2, g2, b2);
              }
              setFillAlpha(fillAlpha) {
                this.current.fillAlpha = fillAlpha;
              }
              setFillRGBColor(r2, g2, b2) {
                this.current.fillColor = _util2.Util.makeHexColor(r2, g2, b2);
                this.current.tspan = this.svgFactory.createElement("svg:tspan");
                this.current.xcoords = [];
                this.current.ycoords = [];
              }
              setStrokeColorN(args) {
                this.current.strokeColor = this._makeColorN_Pattern(args);
              }
              setFillColorN(args) {
                this.current.fillColor = this._makeColorN_Pattern(args);
              }
              shadingFill(args) {
                const {
                  width,
                  height
                } = this.viewport;
                const inv = _util2.Util.inverseTransform(this.transformMatrix);
                const [x02, y02, x12, y12] = _util2.Util.getAxialAlignedBoundingBox([0, 0, width, height], inv);
                const rect = this.svgFactory.createElement("svg:rect");
                rect.setAttributeNS(null, "x", x02);
                rect.setAttributeNS(null, "y", y02);
                rect.setAttributeNS(null, "width", x12 - x02);
                rect.setAttributeNS(null, "height", y12 - y02);
                rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                if (this.current.fillAlpha < 1) {
                  rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                }
                this._ensureTransformGroup().append(rect);
              }
              _makeColorN_Pattern(args) {
                if (args[0] === "TilingPattern") {
                  return this._makeTilingPattern(args);
                }
                return this._makeShadingPattern(args);
              }
              _makeTilingPattern(args) {
                const color = args[1];
                const operatorList = args[2];
                const matrix = args[3] || _util2.IDENTITY_MATRIX;
                const [x02, y02, x12, y12] = args[4];
                const xstep = args[5];
                const ystep = args[6];
                const paintType = args[7];
                const tilingId = `shading${shadingCount++}`;
                const [tx0, ty0, tx1, ty1] = _util2.Util.normalizeRect([..._util2.Util.applyTransform([x02, y02], matrix), ..._util2.Util.applyTransform([x12, y12], matrix)]);
                const [xscale, yscale] = _util2.Util.singularValueDecompose2dScale(matrix);
                const txstep = xstep * xscale;
                const tystep = ystep * yscale;
                const tiling = this.svgFactory.createElement("svg:pattern");
                tiling.setAttributeNS(null, "id", tilingId);
                tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                tiling.setAttributeNS(null, "width", txstep);
                tiling.setAttributeNS(null, "height", tystep);
                tiling.setAttributeNS(null, "x", `${tx0}`);
                tiling.setAttributeNS(null, "y", `${ty0}`);
                const svg = this.svg;
                const transformMatrix = this.transformMatrix;
                const fillColor = this.current.fillColor;
                const strokeColor = this.current.strokeColor;
                const bbox2 = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                this.svg = bbox2;
                this.transformMatrix = matrix;
                if (paintType === 2) {
                  const cssColor = _util2.Util.makeHexColor(...color);
                  this.current.fillColor = cssColor;
                  this.current.strokeColor = cssColor;
                }
                this.executeOpTree(this.convertOpList(operatorList));
                this.svg = svg;
                this.transformMatrix = transformMatrix;
                this.current.fillColor = fillColor;
                this.current.strokeColor = strokeColor;
                tiling.append(bbox2.childNodes[0]);
                this.defs.append(tiling);
                return `url(#${tilingId})`;
              }
              _makeShadingPattern(args) {
                if (typeof args === "string") {
                  args = this.objs.get(args);
                }
                switch (args[0]) {
                  case "RadialAxial":
                    const shadingId = `shading${shadingCount++}`;
                    const colorStops = args[3];
                    let gradient;
                    switch (args[1]) {
                      case "axial":
                        const point0 = args[4];
                        const point1 = args[5];
                        gradient = this.svgFactory.createElement("svg:linearGradient");
                        gradient.setAttributeNS(null, "id", shadingId);
                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                        gradient.setAttributeNS(null, "x1", point0[0]);
                        gradient.setAttributeNS(null, "y1", point0[1]);
                        gradient.setAttributeNS(null, "x2", point1[0]);
                        gradient.setAttributeNS(null, "y2", point1[1]);
                        break;
                      case "radial":
                        const focalPoint = args[4];
                        const circlePoint = args[5];
                        const focalRadius = args[6];
                        const circleRadius2 = args[7];
                        gradient = this.svgFactory.createElement("svg:radialGradient");
                        gradient.setAttributeNS(null, "id", shadingId);
                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                        gradient.setAttributeNS(null, "r", circleRadius2);
                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                        gradient.setAttributeNS(null, "fr", focalRadius);
                        break;
                      default:
                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                    }
                    for (const colorStop of colorStops) {
                      const stop = this.svgFactory.createElement("svg:stop");
                      stop.setAttributeNS(null, "offset", colorStop[0]);
                      stop.setAttributeNS(null, "stop-color", colorStop[1]);
                      gradient.append(stop);
                    }
                    this.defs.append(gradient);
                    return `url(#${shadingId})`;
                  case "Mesh":
                    (0, _util2.warn)("Unimplemented pattern Mesh");
                    return null;
                  case "Dummy":
                    return "hotpink";
                  default:
                    throw new Error(`Unknown IR type: ${args[0]}`);
                }
              }
              setDash(dashArray, dashPhase) {
                this.current.dashArray = dashArray;
                this.current.dashPhase = dashPhase;
              }
              constructPath(ops, args) {
                const current = this.current;
                let x2 = current.x, y2 = current.y;
                let d2 = [];
                let j2 = 0;
                for (const op of ops) {
                  switch (op | 0) {
                    case _util2.OPS.rectangle:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      const width = args[j2++];
                      const height = args[j2++];
                      const xw = x2 + width;
                      const yh = y2 + height;
                      d2.push("M", pf(x2), pf(y2), "L", pf(xw), pf(y2), "L", pf(xw), pf(yh), "L", pf(x2), pf(yh), "Z");
                      break;
                    case _util2.OPS.moveTo:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      d2.push("M", pf(x2), pf(y2));
                      break;
                    case _util2.OPS.lineTo:
                      x2 = args[j2++];
                      y2 = args[j2++];
                      d2.push("L", pf(x2), pf(y2));
                      break;
                    case _util2.OPS.curveTo:
                      x2 = args[j2 + 4];
                      y2 = args[j2 + 5];
                      d2.push("C", pf(args[j2]), pf(args[j2 + 1]), pf(args[j2 + 2]), pf(args[j2 + 3]), pf(x2), pf(y2));
                      j2 += 6;
                      break;
                    case _util2.OPS.curveTo2:
                      d2.push("C", pf(x2), pf(y2), pf(args[j2]), pf(args[j2 + 1]), pf(args[j2 + 2]), pf(args[j2 + 3]));
                      x2 = args[j2 + 2];
                      y2 = args[j2 + 3];
                      j2 += 4;
                      break;
                    case _util2.OPS.curveTo3:
                      x2 = args[j2 + 2];
                      y2 = args[j2 + 3];
                      d2.push("C", pf(args[j2]), pf(args[j2 + 1]), pf(x2), pf(y2), pf(x2), pf(y2));
                      j2 += 4;
                      break;
                    case _util2.OPS.closePath:
                      d2.push("Z");
                      break;
                  }
                }
                d2 = d2.join(" ");
                if (current.path && ops.length > 0 && ops[0] !== _util2.OPS.rectangle && ops[0] !== _util2.OPS.moveTo) {
                  d2 = current.path.getAttributeNS(null, "d") + d2;
                } else {
                  current.path = this.svgFactory.createElement("svg:path");
                  this._ensureTransformGroup().append(current.path);
                }
                current.path.setAttributeNS(null, "d", d2);
                current.path.setAttributeNS(null, "fill", "none");
                current.element = current.path;
                current.setCurrentPoint(x2, y2);
              }
              endPath() {
                const current = this.current;
                current.path = null;
                if (!this.pendingClip) {
                  return;
                }
                if (!current.element) {
                  this.pendingClip = null;
                  return;
                }
                const clipId = `clippath${clipCount++}`;
                const clipPath = this.svgFactory.createElement("svg:clipPath");
                clipPath.setAttributeNS(null, "id", clipId);
                clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                const clipElement = current.element.cloneNode(true);
                if (this.pendingClip === "evenodd") {
                  clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                } else {
                  clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                }
                this.pendingClip = null;
                clipPath.append(clipElement);
                this.defs.append(clipPath);
                if (current.activeClipUrl) {
                  current.clipGroup = null;
                  for (const prev of this.extraStack) {
                    prev.clipGroup = null;
                  }
                  clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                }
                current.activeClipUrl = `url(#${clipId})`;
                this.tgrp = null;
              }
              clip(type) {
                this.pendingClip = type;
              }
              closePath() {
                const current = this.current;
                if (current.path) {
                  const d2 = `${current.path.getAttributeNS(null, "d")}Z`;
                  current.path.setAttributeNS(null, "d", d2);
                }
              }
              setLeading(leading) {
                this.current.leading = -leading;
              }
              setTextRise(textRise) {
                this.current.textRise = textRise;
              }
              setTextRenderingMode(textRenderingMode) {
                this.current.textRenderingMode = textRenderingMode;
              }
              setHScale(scale5) {
                this.current.textHScale = scale5 / 100;
              }
              setRenderingIntent(intent) {
              }
              setFlatness(flatness) {
              }
              setGState(states) {
                for (const [key, value] of states) {
                  switch (key) {
                    case "LW":
                      this.setLineWidth(value);
                      break;
                    case "LC":
                      this.setLineCap(value);
                      break;
                    case "LJ":
                      this.setLineJoin(value);
                      break;
                    case "ML":
                      this.setMiterLimit(value);
                      break;
                    case "D":
                      this.setDash(value[0], value[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(value);
                      break;
                    case "FL":
                      this.setFlatness(value);
                      break;
                    case "Font":
                      this.setFont(value);
                      break;
                    case "CA":
                      this.setStrokeAlpha(value);
                      break;
                    case "ca":
                      this.setFillAlpha(value);
                      break;
                    default:
                      (0, _util2.warn)(`Unimplemented graphic state operator ${key}`);
                      break;
                  }
                }
              }
              fill() {
                const current = this.current;
                if (current.element) {
                  current.element.setAttributeNS(null, "fill", current.fillColor);
                  current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                  this.endPath();
                }
              }
              stroke() {
                const current = this.current;
                if (current.element) {
                  this._setStrokeAttributes(current.element);
                  current.element.setAttributeNS(null, "fill", "none");
                  this.endPath();
                }
              }
              _setStrokeAttributes(element, lineWidthScale = 1) {
                const current = this.current;
                let dashArray = current.dashArray;
                if (lineWidthScale !== 1 && dashArray.length > 0) {
                  dashArray = dashArray.map(function(value) {
                    return lineWidthScale * value;
                  });
                }
                element.setAttributeNS(null, "stroke", current.strokeColor);
                element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
              }
              eoFill() {
                var _a3;
                (_a3 = this.current.element) == null ? void 0 : _a3.setAttributeNS(null, "fill-rule", "evenodd");
                this.fill();
              }
              fillStroke() {
                this.stroke();
                this.fill();
              }
              eoFillStroke() {
                var _a3;
                (_a3 = this.current.element) == null ? void 0 : _a3.setAttributeNS(null, "fill-rule", "evenodd");
                this.fillStroke();
              }
              closeStroke() {
                this.closePath();
                this.stroke();
              }
              closeFillStroke() {
                this.closePath();
                this.fillStroke();
              }
              closeEOFillStroke() {
                this.closePath();
                this.eoFillStroke();
              }
              paintSolidColorImageMask() {
                const rect = this.svgFactory.createElement("svg:rect");
                rect.setAttributeNS(null, "x", "0");
                rect.setAttributeNS(null, "y", "0");
                rect.setAttributeNS(null, "width", "1px");
                rect.setAttributeNS(null, "height", "1px");
                rect.setAttributeNS(null, "fill", this.current.fillColor);
                this._ensureTransformGroup().append(rect);
              }
              paintImageXObject(objId) {
                const imgData = this.getObject(objId);
                if (!imgData) {
                  (0, _util2.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                  return;
                }
                this.paintInlineImageXObject(imgData);
              }
              paintInlineImageXObject(imgData, mask) {
                const width = imgData.width;
                const height = imgData.height;
                const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                const cliprect = this.svgFactory.createElement("svg:rect");
                cliprect.setAttributeNS(null, "x", "0");
                cliprect.setAttributeNS(null, "y", "0");
                cliprect.setAttributeNS(null, "width", pf(width));
                cliprect.setAttributeNS(null, "height", pf(height));
                this.current.element = cliprect;
                this.clip("nonzero");
                const imgEl = this.svgFactory.createElement("svg:image");
                imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                imgEl.setAttributeNS(null, "x", "0");
                imgEl.setAttributeNS(null, "y", pf(-height));
                imgEl.setAttributeNS(null, "width", pf(width) + "px");
                imgEl.setAttributeNS(null, "height", pf(height) + "px");
                imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                if (mask) {
                  mask.append(imgEl);
                } else {
                  this._ensureTransformGroup().append(imgEl);
                }
              }
              paintImageMaskXObject(img) {
                const imgData = this.getObject(img.data, img);
                if (imgData.bitmap) {
                  (0, _util2.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                  return;
                }
                const current = this.current;
                const width = imgData.width;
                const height = imgData.height;
                const fillColor = current.fillColor;
                current.maskId = `mask${maskCount++}`;
                const mask = this.svgFactory.createElement("svg:mask");
                mask.setAttributeNS(null, "id", current.maskId);
                const rect = this.svgFactory.createElement("svg:rect");
                rect.setAttributeNS(null, "x", "0");
                rect.setAttributeNS(null, "y", "0");
                rect.setAttributeNS(null, "width", pf(width));
                rect.setAttributeNS(null, "height", pf(height));
                rect.setAttributeNS(null, "fill", fillColor);
                rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                this.defs.append(mask);
                this._ensureTransformGroup().append(rect);
                this.paintInlineImageXObject(imgData, mask);
              }
              paintFormXObjectBegin(matrix, bbox2) {
                if (Array.isArray(matrix) && matrix.length === 6) {
                  this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                }
                if (bbox2) {
                  const width = bbox2[2] - bbox2[0];
                  const height = bbox2[3] - bbox2[1];
                  const cliprect = this.svgFactory.createElement("svg:rect");
                  cliprect.setAttributeNS(null, "x", bbox2[0]);
                  cliprect.setAttributeNS(null, "y", bbox2[1]);
                  cliprect.setAttributeNS(null, "width", pf(width));
                  cliprect.setAttributeNS(null, "height", pf(height));
                  this.current.element = cliprect;
                  this.clip("nonzero");
                  this.endPath();
                }
              }
              paintFormXObjectEnd() {
              }
              _initialize(viewport) {
                const svg = this.svgFactory.create(viewport.width, viewport.height);
                const definitions = this.svgFactory.createElement("svg:defs");
                svg.append(definitions);
                this.defs = definitions;
                const rootGroup = this.svgFactory.createElement("svg:g");
                rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                svg.append(rootGroup);
                this.svg = rootGroup;
                return svg;
              }
              _ensureClipGroup() {
                if (!this.current.clipGroup) {
                  const clipGroup = this.svgFactory.createElement("svg:g");
                  clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                  this.svg.append(clipGroup);
                  this.current.clipGroup = clipGroup;
                }
                return this.current.clipGroup;
              }
              _ensureTransformGroup() {
                if (!this.tgrp) {
                  this.tgrp = this.svgFactory.createElement("svg:g");
                  this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                  if (this.current.activeClipUrl) {
                    this._ensureClipGroup().append(this.tgrp);
                  } else {
                    this.svg.append(this.tgrp);
                  }
                }
                return this.tgrp;
              }
            }
            exports2.SVGGraphics = SVGGraphics;
          },
          /* 25 */
          /***/
          (__unused_webpack_module2, exports2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.XfaText = void 0;
            class XfaText {
              static textContent(xfa) {
                const items = [];
                const output2 = {
                  items,
                  styles: /* @__PURE__ */ Object.create(null)
                };
                function walk2(node) {
                  var _a3;
                  if (!node) {
                    return;
                  }
                  let str = null;
                  const name2 = node.name;
                  if (name2 === "#text") {
                    str = node.value;
                  } else if (!XfaText.shouldBuildText(name2)) {
                    return;
                  } else if ((_a3 = node == null ? void 0 : node.attributes) == null ? void 0 : _a3.textContent) {
                    str = node.attributes.textContent;
                  } else if (node.value) {
                    str = node.value;
                  }
                  if (str !== null) {
                    items.push({
                      str
                    });
                  }
                  if (!node.children) {
                    return;
                  }
                  for (const child of node.children) {
                    walk2(child);
                  }
                }
                walk2(xfa);
                return output2;
              }
              static shouldBuildText(name2) {
                return !(name2 === "textarea" || name2 === "input" || name2 === "option" || name2 === "select");
              }
            }
            exports2.XfaText = XfaText;
          },
          /* 26 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.TextLayerRenderTask = void 0;
            exports2.renderTextLayer = renderTextLayer;
            exports2.updateTextLayer = updateTextLayer;
            var _util2 = __w_pdfjs_require__2(1);
            var _display_utils2 = __w_pdfjs_require__2(6);
            const MAX_TEXT_DIVS_TO_RENDER = 1e5;
            const DEFAULT_FONT_SIZE = 30;
            const DEFAULT_FONT_ASCENT = 0.8;
            const ascentCache = /* @__PURE__ */ new Map();
            function getCtx(size12, isOffscreenCanvasSupported) {
              let ctx2;
              if (isOffscreenCanvasSupported && _util2.FeatureTest.isOffscreenCanvasSupported) {
                ctx2 = new OffscreenCanvas(size12, size12).getContext("2d", {
                  alpha: false
                });
              } else {
                const canvas2 = document.createElement("canvas");
                canvas2.width = canvas2.height = size12;
                ctx2 = canvas2.getContext("2d", {
                  alpha: false
                });
              }
              return ctx2;
            }
            function getAscent(fontFamily, isOffscreenCanvasSupported) {
              const cachedAscent = ascentCache.get(fontFamily);
              if (cachedAscent) {
                return cachedAscent;
              }
              const ctx2 = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
              ctx2.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
              const metrics = ctx2.measureText("");
              let ascent = metrics.fontBoundingBoxAscent;
              let descent = Math.abs(metrics.fontBoundingBoxDescent);
              if (ascent) {
                const ratio = ascent / (ascent + descent);
                ascentCache.set(fontFamily, ratio);
                ctx2.canvas.width = ctx2.canvas.height = 0;
                return ratio;
              }
              ctx2.strokeStyle = "red";
              ctx2.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
              ctx2.strokeText("g", 0, 0);
              let pixels = ctx2.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
              descent = 0;
              for (let i2 = pixels.length - 1 - 3; i2 >= 0; i2 -= 4) {
                if (pixels[i2] > 0) {
                  descent = Math.ceil(i2 / 4 / DEFAULT_FONT_SIZE);
                  break;
                }
              }
              ctx2.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
              ctx2.strokeText("A", 0, DEFAULT_FONT_SIZE);
              pixels = ctx2.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
              ascent = 0;
              for (let i2 = 0, ii2 = pixels.length; i2 < ii2; i2 += 4) {
                if (pixels[i2] > 0) {
                  ascent = DEFAULT_FONT_SIZE - Math.floor(i2 / 4 / DEFAULT_FONT_SIZE);
                  break;
                }
              }
              ctx2.canvas.width = ctx2.canvas.height = 0;
              if (ascent) {
                const ratio = ascent / (ascent + descent);
                ascentCache.set(fontFamily, ratio);
                return ratio;
              }
              ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
              return DEFAULT_FONT_ASCENT;
            }
            function appendText(task, geom, styles2) {
              const textDiv = document.createElement("span");
              const textDivProperties = {
                angle: 0,
                canvasWidth: 0,
                hasText: geom.str !== "",
                hasEOL: geom.hasEOL,
                fontSize: 0
              };
              task._textDivs.push(textDiv);
              const tx = _util2.Util.transform(task._transform, geom.transform);
              let angle4 = Math.atan2(tx[1], tx[0]);
              const style2 = styles2[geom.fontName];
              if (style2.vertical) {
                angle4 += Math.PI / 2;
              }
              const fontHeight = Math.hypot(tx[2], tx[3]);
              const fontAscent = fontHeight * getAscent(style2.fontFamily, task._isOffscreenCanvasSupported);
              let left, top;
              if (angle4 === 0) {
                left = tx[4];
                top = tx[5] - fontAscent;
              } else {
                left = tx[4] + fontAscent * Math.sin(angle4);
                top = tx[5] - fontAscent * Math.cos(angle4);
              }
              const scaleFactorStr = "calc(var(--scale-factor)*";
              const divStyle = textDiv.style;
              if (task._container === task._rootContainer) {
                divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
                divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
              } else {
                divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
                divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
              }
              divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
              divStyle.fontFamily = style2.fontFamily;
              textDivProperties.fontSize = fontHeight;
              textDiv.setAttribute("role", "presentation");
              textDiv.textContent = geom.str;
              textDiv.dir = geom.dir;
              if (task._fontInspectorEnabled) {
                textDiv.dataset.fontName = geom.fontName;
              }
              if (angle4 !== 0) {
                textDivProperties.angle = angle4 * (180 / Math.PI);
              }
              let shouldScaleText = false;
              if (geom.str.length > 1) {
                shouldScaleText = true;
              } else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
                  shouldScaleText = true;
                }
              }
              if (shouldScaleText) {
                textDivProperties.canvasWidth = style2.vertical ? geom.height : geom.width;
              }
              task._textDivProperties.set(textDiv, textDivProperties);
              if (task._isReadableStream) {
                task._layoutText(textDiv);
              }
            }
            function layout(params2) {
              const {
                div,
                scale: scale5,
                properties,
                ctx: ctx2,
                prevFontSize,
                prevFontFamily
              } = params2;
              const {
                style: style2
              } = div;
              let transform4 = "";
              if (properties.canvasWidth !== 0 && properties.hasText) {
                const {
                  fontFamily
                } = style2;
                const {
                  canvasWidth,
                  fontSize
                } = properties;
                if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                  ctx2.font = `${fontSize * scale5}px ${fontFamily}`;
                  params2.prevFontSize = fontSize;
                  params2.prevFontFamily = fontFamily;
                }
                const {
                  width
                } = ctx2.measureText(div.textContent);
                if (width > 0) {
                  transform4 = `scaleX(${canvasWidth * scale5 / width})`;
                }
              }
              if (properties.angle !== 0) {
                transform4 = `rotate(${properties.angle}deg) ${transform4}`;
              }
              if (transform4.length > 0) {
                style2.transform = transform4;
              }
            }
            function render5(task) {
              if (task._canceled) {
                return;
              }
              const textDivs = task._textDivs;
              const capability = task._capability;
              const textDivsLength = textDivs.length;
              if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                capability.resolve();
                return;
              }
              if (!task._isReadableStream) {
                for (const textDiv of textDivs) {
                  task._layoutText(textDiv);
                }
              }
              capability.resolve();
            }
            class TextLayerRenderTask {
              constructor({
                textContentSource,
                container,
                viewport,
                textDivs,
                textDivProperties,
                textContentItemsStr,
                isOffscreenCanvasSupported
              }) {
                var _a3;
                this._textContentSource = textContentSource;
                this._isReadableStream = textContentSource instanceof ReadableStream;
                this._container = this._rootContainer = container;
                this._textDivs = textDivs || [];
                this._textContentItemsStr = textContentItemsStr || [];
                this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                this._fontInspectorEnabled = !!((_a3 = globalThis.FontInspector) == null ? void 0 : _a3.enabled);
                this._reader = null;
                this._textDivProperties = textDivProperties || /* @__PURE__ */ new WeakMap();
                this._canceled = false;
                this._capability = new _util2.PromiseCapability();
                this._layoutTextParams = {
                  prevFontSize: null,
                  prevFontFamily: null,
                  div: null,
                  scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                  properties: null,
                  ctx: getCtx(0, isOffscreenCanvasSupported)
                };
                const {
                  pageWidth,
                  pageHeight,
                  pageX,
                  pageY
                } = viewport.rawDims;
                this._transform = [1, 0, 0, -1, -pageX, pageY + pageHeight];
                this._pageWidth = pageWidth;
                this._pageHeight = pageHeight;
                (0, _display_utils2.setLayerDimensions)(container, viewport);
                this._capability.promise.finally(() => {
                  this._layoutTextParams = null;
                }).catch(() => {
                });
              }
              get promise() {
                return this._capability.promise;
              }
              cancel() {
                this._canceled = true;
                if (this._reader) {
                  this._reader.cancel(new _util2.AbortException("TextLayer task cancelled.")).catch(() => {
                  });
                  this._reader = null;
                }
                this._capability.reject(new _util2.AbortException("TextLayer task cancelled."));
              }
              _processItems(items, styleCache) {
                for (const item of items) {
                  if (item.str === void 0) {
                    if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                      const parent = this._container;
                      this._container = document.createElement("span");
                      this._container.classList.add("markedContent");
                      if (item.id !== null) {
                        this._container.setAttribute("id", `${item.id}`);
                      }
                      parent.append(this._container);
                    } else if (item.type === "endMarkedContent") {
                      this._container = this._container.parentNode;
                    }
                    continue;
                  }
                  this._textContentItemsStr.push(item.str);
                  appendText(this, item, styleCache);
                }
              }
              _layoutText(textDiv) {
                const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                this._layoutTextParams.div = textDiv;
                layout(this._layoutTextParams);
                if (textDivProperties.hasText) {
                  this._container.append(textDiv);
                }
                if (textDivProperties.hasEOL) {
                  const br2 = document.createElement("br");
                  br2.setAttribute("role", "presentation");
                  this._container.append(br2);
                }
              }
              _render() {
                const capability = new _util2.PromiseCapability();
                let styleCache = /* @__PURE__ */ Object.create(null);
                if (this._isReadableStream) {
                  const pump = () => {
                    this._reader.read().then(({
                      value,
                      done
                    }) => {
                      if (done) {
                        capability.resolve();
                        return;
                      }
                      Object.assign(styleCache, value.styles);
                      this._processItems(value.items, styleCache);
                      pump();
                    }, capability.reject);
                  };
                  this._reader = this._textContentSource.getReader();
                  pump();
                } else if (this._textContentSource) {
                  const {
                    items,
                    styles: styles2
                  } = this._textContentSource;
                  this._processItems(items, styles2);
                  capability.resolve();
                } else {
                  throw new Error('No "textContentSource" parameter specified.');
                }
                capability.promise.then(() => {
                  styleCache = null;
                  render5(this);
                }, this._capability.reject);
              }
            }
            exports2.TextLayerRenderTask = TextLayerRenderTask;
            function renderTextLayer(params2) {
              if (!params2.textContentSource && (params2.textContent || params2.textContentStream)) {
                (0, _display_utils2.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                params2.textContentSource = params2.textContent || params2.textContentStream;
              }
              const {
                container,
                viewport
              } = params2;
              const style2 = getComputedStyle(container);
              const visibility = style2.getPropertyValue("visibility");
              const scaleFactor = parseFloat(style2.getPropertyValue("--scale-factor"));
              if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) {
                console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
              }
              const task = new TextLayerRenderTask(params2);
              task._render();
              return task;
            }
            function updateTextLayer({
              container,
              viewport,
              textDivs,
              textDivProperties,
              isOffscreenCanvasSupported,
              mustRotate = true,
              mustRescale = true
            }) {
              if (mustRotate) {
                (0, _display_utils2.setLayerDimensions)(container, {
                  rotation: viewport.rotation
                });
              }
              if (mustRescale) {
                const ctx2 = getCtx(0, isOffscreenCanvasSupported);
                const scale5 = viewport.scale * (globalThis.devicePixelRatio || 1);
                const params2 = {
                  prevFontSize: null,
                  prevFontFamily: null,
                  div: null,
                  scale: scale5,
                  properties: null,
                  ctx: ctx2
                };
                for (const div of textDivs) {
                  params2.properties = textDivProperties.get(div);
                  params2.div = div;
                  layout(params2);
                }
              }
            }
          },
          /* 27 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _accessibilityManager, _allowClick, _annotationLayer, _boundPointerup, _boundPointerdown, _editors, _hadPointerDown, _isCleaningUp, _isDisabling, _uiManager, _createNewEditor, createNewEditor_fn, _createAndAddNewEditor, createAndAddNewEditor_fn, _getCenterPoint, getCenterPoint_fn, _cleanup, cleanup_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.AnnotationEditorLayer = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _editor = __w_pdfjs_require__2(4);
            var _freetext = __w_pdfjs_require__2(28);
            var _ink = __w_pdfjs_require__2(33);
            var _display_utils2 = __w_pdfjs_require__2(6);
            var _stamp = __w_pdfjs_require__2(34);
            const _AnnotationEditorLayer = class {
              constructor({
                uiManager,
                pageIndex,
                div,
                accessibilityManager,
                annotationLayer,
                viewport,
                l10n
              }) {
                __privateAdd(this, _createNewEditor);
                __privateAdd(this, _createAndAddNewEditor);
                __privateAdd(this, _getCenterPoint);
                __privateAdd(this, _cleanup);
                __privateAdd(this, _accessibilityManager, void 0);
                __privateAdd(this, _allowClick, false);
                __privateAdd(this, _annotationLayer, null);
                __privateAdd(this, _boundPointerup, this.pointerup.bind(this));
                __privateAdd(this, _boundPointerdown, this.pointerdown.bind(this));
                __privateAdd(this, _editors, /* @__PURE__ */ new Map());
                __privateAdd(this, _hadPointerDown, false);
                __privateAdd(this, _isCleaningUp, false);
                __privateAdd(this, _isDisabling, false);
                __privateAdd(this, _uiManager, void 0);
                const editorTypes = [_freetext.FreeTextEditor, _ink.InkEditor, _stamp.StampEditor];
                if (!_AnnotationEditorLayer._initialized) {
                  _AnnotationEditorLayer._initialized = true;
                  for (const editorType of editorTypes) {
                    editorType.initialize(l10n);
                  }
                }
                uiManager.registerEditorTypes(editorTypes);
                __privateSet(this, _uiManager, uiManager);
                this.pageIndex = pageIndex;
                this.div = div;
                __privateSet(this, _accessibilityManager, accessibilityManager);
                __privateSet(this, _annotationLayer, annotationLayer);
                this.viewport = viewport;
                __privateGet(this, _uiManager).addLayer(this);
              }
              get isEmpty() {
                return __privateGet(this, _editors).size === 0;
              }
              updateToolbar(mode2) {
                __privateGet(this, _uiManager).updateToolbar(mode2);
              }
              updateMode(mode2 = __privateGet(this, _uiManager).getMode()) {
                __privateMethod(this, _cleanup, cleanup_fn).call(this);
                if (mode2 === _util2.AnnotationEditorType.INK) {
                  this.addInkEditorIfNeeded(false);
                  this.disableClick();
                } else {
                  this.enableClick();
                }
                if (mode2 !== _util2.AnnotationEditorType.NONE) {
                  this.div.classList.toggle("freeTextEditing", mode2 === _util2.AnnotationEditorType.FREETEXT);
                  this.div.classList.toggle("inkEditing", mode2 === _util2.AnnotationEditorType.INK);
                  this.div.classList.toggle("stampEditing", mode2 === _util2.AnnotationEditorType.STAMP);
                  this.div.hidden = false;
                }
              }
              addInkEditorIfNeeded(isCommitting) {
                if (!isCommitting && __privateGet(this, _uiManager).getMode() !== _util2.AnnotationEditorType.INK) {
                  return;
                }
                if (!isCommitting) {
                  for (const editor2 of __privateGet(this, _editors).values()) {
                    if (editor2.isEmpty()) {
                      editor2.setInBackground();
                      return;
                    }
                  }
                }
                const editor = __privateMethod(this, _createAndAddNewEditor, createAndAddNewEditor_fn).call(this, {
                  offsetX: 0,
                  offsetY: 0
                }, false);
                editor.setInBackground();
              }
              setEditingState(isEditing) {
                __privateGet(this, _uiManager).setEditingState(isEditing);
              }
              addCommands(params2) {
                __privateGet(this, _uiManager).addCommands(params2);
              }
              enable() {
                this.div.style.pointerEvents = "auto";
                const annotationElementIds = /* @__PURE__ */ new Set();
                for (const editor of __privateGet(this, _editors).values()) {
                  editor.enableEditing();
                  if (editor.annotationElementId) {
                    annotationElementIds.add(editor.annotationElementId);
                  }
                }
                if (!__privateGet(this, _annotationLayer)) {
                  return;
                }
                const editables = __privateGet(this, _annotationLayer).getEditableAnnotations();
                for (const editable of editables) {
                  editable.hide();
                  if (__privateGet(this, _uiManager).isDeletedAnnotationElement(editable.data.id)) {
                    continue;
                  }
                  if (annotationElementIds.has(editable.data.id)) {
                    continue;
                  }
                  const editor = this.deserialize(editable);
                  if (!editor) {
                    continue;
                  }
                  this.addOrRebuild(editor);
                  editor.enableEditing();
                }
              }
              disable() {
                var _a3;
                __privateSet(this, _isDisabling, true);
                this.div.style.pointerEvents = "none";
                const hiddenAnnotationIds = /* @__PURE__ */ new Set();
                for (const editor of __privateGet(this, _editors).values()) {
                  editor.disableEditing();
                  if (!editor.annotationElementId || editor.serialize() !== null) {
                    hiddenAnnotationIds.add(editor.annotationElementId);
                    continue;
                  }
                  (_a3 = this.getEditableAnnotation(editor.annotationElementId)) == null ? void 0 : _a3.show();
                  editor.remove();
                }
                if (__privateGet(this, _annotationLayer)) {
                  const editables = __privateGet(this, _annotationLayer).getEditableAnnotations();
                  for (const editable of editables) {
                    const {
                      id
                    } = editable.data;
                    if (hiddenAnnotationIds.has(id) || __privateGet(this, _uiManager).isDeletedAnnotationElement(id)) {
                      continue;
                    }
                    editable.show();
                  }
                }
                __privateMethod(this, _cleanup, cleanup_fn).call(this);
                if (this.isEmpty) {
                  this.div.hidden = true;
                }
                __privateSet(this, _isDisabling, false);
              }
              getEditableAnnotation(id) {
                var _a3;
                return ((_a3 = __privateGet(this, _annotationLayer)) == null ? void 0 : _a3.getEditableAnnotation(id)) || null;
              }
              setActiveEditor(editor) {
                const currentActive = __privateGet(this, _uiManager).getActive();
                if (currentActive === editor) {
                  return;
                }
                __privateGet(this, _uiManager).setActiveEditor(editor);
              }
              enableClick() {
                this.div.addEventListener("pointerdown", __privateGet(this, _boundPointerdown));
                this.div.addEventListener("pointerup", __privateGet(this, _boundPointerup));
              }
              disableClick() {
                this.div.removeEventListener("pointerdown", __privateGet(this, _boundPointerdown));
                this.div.removeEventListener("pointerup", __privateGet(this, _boundPointerup));
              }
              attach(editor) {
                __privateGet(this, _editors).set(editor.id, editor);
                const {
                  annotationElementId
                } = editor;
                if (annotationElementId && __privateGet(this, _uiManager).isDeletedAnnotationElement(annotationElementId)) {
                  __privateGet(this, _uiManager).removeDeletedAnnotationElement(editor);
                }
              }
              detach(editor) {
                var _a3;
                __privateGet(this, _editors).delete(editor.id);
                (_a3 = __privateGet(this, _accessibilityManager)) == null ? void 0 : _a3.removePointerInTextLayer(editor.contentDiv);
                if (!__privateGet(this, _isDisabling) && editor.annotationElementId) {
                  __privateGet(this, _uiManager).addDeletedAnnotationElement(editor);
                }
              }
              remove(editor) {
                this.detach(editor);
                __privateGet(this, _uiManager).removeEditor(editor);
                if (editor.div.contains(document.activeElement)) {
                  setTimeout(() => {
                    __privateGet(this, _uiManager).focusMainContainer();
                  }, 0);
                }
                editor.div.remove();
                editor.isAttachedToDOM = false;
                if (!__privateGet(this, _isCleaningUp)) {
                  this.addInkEditorIfNeeded(false);
                }
              }
              changeParent(editor) {
                var _a3;
                if (editor.parent === this) {
                  return;
                }
                if (editor.annotationElementId) {
                  __privateGet(this, _uiManager).addDeletedAnnotationElement(editor.annotationElementId);
                  _editor.AnnotationEditor.deleteAnnotationElement(editor);
                  editor.annotationElementId = null;
                }
                this.attach(editor);
                (_a3 = editor.parent) == null ? void 0 : _a3.detach(editor);
                editor.setParent(this);
                if (editor.div && editor.isAttachedToDOM) {
                  editor.div.remove();
                  this.div.append(editor.div);
                }
              }
              add(editor) {
                this.changeParent(editor);
                __privateGet(this, _uiManager).addEditor(editor);
                this.attach(editor);
                if (!editor.isAttachedToDOM) {
                  const div = editor.render();
                  this.div.append(div);
                  editor.isAttachedToDOM = true;
                }
                editor.fixAndSetPosition();
                editor.onceAdded();
                __privateGet(this, _uiManager).addToAnnotationStorage(editor);
              }
              moveEditorInDOM(editor) {
                var _a3;
                if (!editor.isAttachedToDOM) {
                  return;
                }
                const {
                  activeElement
                } = document;
                if (editor.div.contains(activeElement)) {
                  editor._focusEventsAllowed = false;
                  setTimeout(() => {
                    if (!editor.div.contains(document.activeElement)) {
                      editor.div.addEventListener("focusin", () => {
                        editor._focusEventsAllowed = true;
                      }, {
                        once: true
                      });
                      activeElement.focus();
                    } else {
                      editor._focusEventsAllowed = true;
                    }
                  }, 0);
                }
                editor._structTreeParentId = (_a3 = __privateGet(this, _accessibilityManager)) == null ? void 0 : _a3.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
              }
              addOrRebuild(editor) {
                if (editor.needsToBeRebuilt()) {
                  editor.rebuild();
                } else {
                  this.add(editor);
                }
              }
              addUndoableEditor(editor) {
                const cmd2 = () => editor._uiManager.rebuild(editor);
                const undo = () => {
                  editor.remove();
                };
                this.addCommands({
                  cmd: cmd2,
                  undo,
                  mustExec: false
                });
              }
              getNextId() {
                return __privateGet(this, _uiManager).getId();
              }
              pasteEditor(mode2, params2) {
                __privateGet(this, _uiManager).updateToolbar(mode2);
                __privateGet(this, _uiManager).updateMode(mode2);
                const {
                  offsetX,
                  offsetY
                } = __privateMethod(this, _getCenterPoint, getCenterPoint_fn).call(this);
                const id = this.getNextId();
                const editor = __privateMethod(this, _createNewEditor, createNewEditor_fn).call(this, {
                  parent: this,
                  id,
                  x: offsetX,
                  y: offsetY,
                  uiManager: __privateGet(this, _uiManager),
                  isCentered: true,
                  ...params2
                });
                if (editor) {
                  this.add(editor);
                }
              }
              deserialize(data2) {
                switch (data2.annotationType ?? data2.annotationEditorType) {
                  case _util2.AnnotationEditorType.FREETEXT:
                    return _freetext.FreeTextEditor.deserialize(data2, this, __privateGet(this, _uiManager));
                  case _util2.AnnotationEditorType.INK:
                    return _ink.InkEditor.deserialize(data2, this, __privateGet(this, _uiManager));
                  case _util2.AnnotationEditorType.STAMP:
                    return _stamp.StampEditor.deserialize(data2, this, __privateGet(this, _uiManager));
                }
                return null;
              }
              addNewEditor() {
                __privateMethod(this, _createAndAddNewEditor, createAndAddNewEditor_fn).call(this, __privateMethod(this, _getCenterPoint, getCenterPoint_fn).call(this), true);
              }
              setSelected(editor) {
                __privateGet(this, _uiManager).setSelected(editor);
              }
              toggleSelected(editor) {
                __privateGet(this, _uiManager).toggleSelected(editor);
              }
              isSelected(editor) {
                return __privateGet(this, _uiManager).isSelected(editor);
              }
              unselect(editor) {
                __privateGet(this, _uiManager).unselect(editor);
              }
              pointerup(event) {
                const {
                  isMac
                } = _util2.FeatureTest.platform;
                if (event.button !== 0 || event.ctrlKey && isMac) {
                  return;
                }
                if (event.target !== this.div) {
                  return;
                }
                if (!__privateGet(this, _hadPointerDown)) {
                  return;
                }
                __privateSet(this, _hadPointerDown, false);
                if (!__privateGet(this, _allowClick)) {
                  __privateSet(this, _allowClick, true);
                  return;
                }
                if (__privateGet(this, _uiManager).getMode() === _util2.AnnotationEditorType.STAMP) {
                  __privateGet(this, _uiManager).unselectAll();
                  return;
                }
                __privateMethod(this, _createAndAddNewEditor, createAndAddNewEditor_fn).call(this, event, false);
              }
              pointerdown(event) {
                if (__privateGet(this, _hadPointerDown)) {
                  __privateSet(this, _hadPointerDown, false);
                  return;
                }
                const {
                  isMac
                } = _util2.FeatureTest.platform;
                if (event.button !== 0 || event.ctrlKey && isMac) {
                  return;
                }
                if (event.target !== this.div) {
                  return;
                }
                __privateSet(this, _hadPointerDown, true);
                const editor = __privateGet(this, _uiManager).getActive();
                __privateSet(this, _allowClick, !editor || editor.isEmpty());
              }
              findNewParent(editor, x2, y2) {
                const layer = __privateGet(this, _uiManager).findParent(x2, y2);
                if (layer === null || layer === this) {
                  return false;
                }
                layer.changeParent(editor);
                return true;
              }
              destroy() {
                var _a3, _b3;
                if (((_a3 = __privateGet(this, _uiManager).getActive()) == null ? void 0 : _a3.parent) === this) {
                  __privateGet(this, _uiManager).commitOrRemove();
                  __privateGet(this, _uiManager).setActiveEditor(null);
                }
                for (const editor of __privateGet(this, _editors).values()) {
                  (_b3 = __privateGet(this, _accessibilityManager)) == null ? void 0 : _b3.removePointerInTextLayer(editor.contentDiv);
                  editor.setParent(null);
                  editor.isAttachedToDOM = false;
                  editor.div.remove();
                }
                this.div = null;
                __privateGet(this, _editors).clear();
                __privateGet(this, _uiManager).removeLayer(this);
              }
              render({
                viewport
              }) {
                this.viewport = viewport;
                (0, _display_utils2.setLayerDimensions)(this.div, viewport);
                for (const editor of __privateGet(this, _uiManager).getEditors(this.pageIndex)) {
                  this.add(editor);
                }
                this.updateMode();
              }
              update({
                viewport
              }) {
                __privateGet(this, _uiManager).commitOrRemove();
                this.viewport = viewport;
                (0, _display_utils2.setLayerDimensions)(this.div, {
                  rotation: viewport.rotation
                });
                this.updateMode();
              }
              get pageDimensions() {
                const {
                  pageWidth,
                  pageHeight
                } = this.viewport.rawDims;
                return [pageWidth, pageHeight];
              }
            };
            let AnnotationEditorLayer = _AnnotationEditorLayer;
            _accessibilityManager = new WeakMap();
            _allowClick = new WeakMap();
            _annotationLayer = new WeakMap();
            _boundPointerup = new WeakMap();
            _boundPointerdown = new WeakMap();
            _editors = new WeakMap();
            _hadPointerDown = new WeakMap();
            _isCleaningUp = new WeakMap();
            _isDisabling = new WeakMap();
            _uiManager = new WeakMap();
            _createNewEditor = new WeakSet();
            createNewEditor_fn = function(params2) {
              switch (__privateGet(this, _uiManager).getMode()) {
                case _util2.AnnotationEditorType.FREETEXT:
                  return new _freetext.FreeTextEditor(params2);
                case _util2.AnnotationEditorType.INK:
                  return new _ink.InkEditor(params2);
                case _util2.AnnotationEditorType.STAMP:
                  return new _stamp.StampEditor(params2);
              }
              return null;
            };
            _createAndAddNewEditor = new WeakSet();
            createAndAddNewEditor_fn = function(event, isCentered) {
              const id = this.getNextId();
              const editor = __privateMethod(this, _createNewEditor, createNewEditor_fn).call(this, {
                parent: this,
                id,
                x: event.offsetX,
                y: event.offsetY,
                uiManager: __privateGet(this, _uiManager),
                isCentered
              });
              if (editor) {
                this.add(editor);
              }
              return editor;
            };
            _getCenterPoint = new WeakSet();
            getCenterPoint_fn = function() {
              const {
                x: x2,
                y: y2,
                width,
                height
              } = this.div.getBoundingClientRect();
              const tlX = Math.max(0, x2);
              const tlY = Math.max(0, y2);
              const brX = Math.min(window.innerWidth, x2 + width);
              const brY = Math.min(window.innerHeight, y2 + height);
              const centerX = (tlX + brX) / 2 - x2;
              const centerY = (tlY + brY) / 2 - y2;
              const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [centerX, centerY] : [centerY, centerX];
              return {
                offsetX,
                offsetY
              };
            };
            _cleanup = new WeakSet();
            cleanup_fn = function() {
              __privateSet(this, _isCleaningUp, true);
              for (const editor of __privateGet(this, _editors).values()) {
                if (editor.isEmpty()) {
                  editor.remove();
                }
              }
              __privateSet(this, _isCleaningUp, false);
            };
            __publicField2(AnnotationEditorLayer, "_initialized", false);
            exports2.AnnotationEditorLayer = AnnotationEditorLayer;
          },
          /* 28 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _boundEditorDivBlur, _boundEditorDivFocus, _boundEditorDivInput, _boundEditorDivKeydown, _color, _content, _editorDivId, _fontSize, _initialData, _updateFontSize, updateFontSize_fn, _updateColor, updateColor_fn, _extractText, extractText_fn, _setEditorDimensions, setEditorDimensions_fn, _setContent, setContent_fn, _hasElementChanged, hasElementChanged_fn, _cheatInitialRect, cheatInitialRect_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.FreeTextEditor = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _tools = __w_pdfjs_require__2(5);
            var _editor = __w_pdfjs_require__2(4);
            var _annotation_layer = __w_pdfjs_require__2(29);
            const _FreeTextEditor = class extends _editor.AnnotationEditor {
              constructor(params2) {
                super({
                  ...params2,
                  name: "freeTextEditor"
                });
                __privateAdd(this, _updateFontSize);
                __privateAdd(this, _updateColor);
                __privateAdd(this, _extractText);
                __privateAdd(this, _setEditorDimensions);
                __privateAdd(this, _setContent);
                __privateAdd(this, _hasElementChanged);
                __privateAdd(this, _cheatInitialRect);
                __privateAdd(this, _boundEditorDivBlur, this.editorDivBlur.bind(this));
                __privateAdd(this, _boundEditorDivFocus, this.editorDivFocus.bind(this));
                __privateAdd(this, _boundEditorDivInput, this.editorDivInput.bind(this));
                __privateAdd(this, _boundEditorDivKeydown, this.editorDivKeydown.bind(this));
                __privateAdd(this, _color, void 0);
                __privateAdd(this, _content, "");
                __privateAdd(this, _editorDivId, `${this.id}-editor`);
                __privateAdd(this, _fontSize, void 0);
                __privateAdd(this, _initialData, null);
                __privateSet(this, _color, params2.color || _FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor);
                __privateSet(this, _fontSize, params2.fontSize || _FreeTextEditor._defaultFontSize);
              }
              static get _keyboardManager() {
                const proto = _FreeTextEditor.prototype;
                const arrowChecker = (self2) => self2.isEmpty();
                const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                return (0, _util2.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], proto.commitOrRemove, {
                  bubbles: true
                }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], proto.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], proto._translateEmpty, {
                  args: [-small, 0],
                  checker: arrowChecker
                }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto._translateEmpty, {
                  args: [-big, 0],
                  checker: arrowChecker
                }], [["ArrowRight", "mac+ArrowRight"], proto._translateEmpty, {
                  args: [small, 0],
                  checker: arrowChecker
                }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto._translateEmpty, {
                  args: [big, 0],
                  checker: arrowChecker
                }], [["ArrowUp", "mac+ArrowUp"], proto._translateEmpty, {
                  args: [0, -small],
                  checker: arrowChecker
                }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto._translateEmpty, {
                  args: [0, -big],
                  checker: arrowChecker
                }], [["ArrowDown", "mac+ArrowDown"], proto._translateEmpty, {
                  args: [0, small],
                  checker: arrowChecker
                }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto._translateEmpty, {
                  args: [0, big],
                  checker: arrowChecker
                }]]));
              }
              static initialize(l10n) {
                _editor.AnnotationEditor.initialize(l10n, {
                  strings: ["free_text2_default_content", "editor_free_text2_aria_label"]
                });
                const style2 = getComputedStyle(document.documentElement);
                this._internalPadding = parseFloat(style2.getPropertyValue("--freetext-padding"));
              }
              static updateDefaultParams(type, value) {
                switch (type) {
                  case _util2.AnnotationEditorParamsType.FREETEXT_SIZE:
                    _FreeTextEditor._defaultFontSize = value;
                    break;
                  case _util2.AnnotationEditorParamsType.FREETEXT_COLOR:
                    _FreeTextEditor._defaultColor = value;
                    break;
                }
              }
              updateParams(type, value) {
                switch (type) {
                  case _util2.AnnotationEditorParamsType.FREETEXT_SIZE:
                    __privateMethod(this, _updateFontSize, updateFontSize_fn).call(this, value);
                    break;
                  case _util2.AnnotationEditorParamsType.FREETEXT_COLOR:
                    __privateMethod(this, _updateColor, updateColor_fn).call(this, value);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[_util2.AnnotationEditorParamsType.FREETEXT_SIZE, _FreeTextEditor._defaultFontSize], [_util2.AnnotationEditorParamsType.FREETEXT_COLOR, _FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor]];
              }
              get propertiesToUpdate() {
                return [[_util2.AnnotationEditorParamsType.FREETEXT_SIZE, __privateGet(this, _fontSize)], [_util2.AnnotationEditorParamsType.FREETEXT_COLOR, __privateGet(this, _color)]];
              }
              _translateEmpty(x2, y2) {
                this._uiManager.translateSelectedEditors(x2, y2, true);
              }
              getInitialTranslation() {
                const scale5 = this.parentScale;
                return [-_FreeTextEditor._internalPadding * scale5, -(_FreeTextEditor._internalPadding + __privateGet(this, _fontSize)) * scale5];
              }
              rebuild() {
                if (!this.parent) {
                  return;
                }
                super.rebuild();
                if (this.div === null) {
                  return;
                }
                if (!this.isAttachedToDOM) {
                  this.parent.add(this);
                }
              }
              enableEditMode() {
                if (this.isInEditMode()) {
                  return;
                }
                this.parent.setEditingState(false);
                this.parent.updateToolbar(_util2.AnnotationEditorType.FREETEXT);
                super.enableEditMode();
                this.overlayDiv.classList.remove("enabled");
                this.editorDiv.contentEditable = true;
                this._isDraggable = false;
                this.div.removeAttribute("aria-activedescendant");
                this.editorDiv.addEventListener("keydown", __privateGet(this, _boundEditorDivKeydown));
                this.editorDiv.addEventListener("focus", __privateGet(this, _boundEditorDivFocus));
                this.editorDiv.addEventListener("blur", __privateGet(this, _boundEditorDivBlur));
                this.editorDiv.addEventListener("input", __privateGet(this, _boundEditorDivInput));
              }
              disableEditMode() {
                if (!this.isInEditMode()) {
                  return;
                }
                this.parent.setEditingState(true);
                super.disableEditMode();
                this.overlayDiv.classList.add("enabled");
                this.editorDiv.contentEditable = false;
                this.div.setAttribute("aria-activedescendant", __privateGet(this, _editorDivId));
                this._isDraggable = true;
                this.editorDiv.removeEventListener("keydown", __privateGet(this, _boundEditorDivKeydown));
                this.editorDiv.removeEventListener("focus", __privateGet(this, _boundEditorDivFocus));
                this.editorDiv.removeEventListener("blur", __privateGet(this, _boundEditorDivBlur));
                this.editorDiv.removeEventListener("input", __privateGet(this, _boundEditorDivInput));
                this.div.focus({
                  preventScroll: true
                });
                this.isEditing = false;
                this.parent.div.classList.add("freeTextEditing");
              }
              focusin(event) {
                if (!this._focusEventsAllowed) {
                  return;
                }
                super.focusin(event);
                if (event.target !== this.editorDiv) {
                  this.editorDiv.focus();
                }
              }
              onceAdded() {
                var _a3;
                if (this.width) {
                  __privateMethod(this, _cheatInitialRect, cheatInitialRect_fn).call(this);
                  return;
                }
                this.enableEditMode();
                this.editorDiv.focus();
                if ((_a3 = this._initialOptions) == null ? void 0 : _a3.isCentered) {
                  this.center();
                }
                this._initialOptions = null;
              }
              isEmpty() {
                return !this.editorDiv || this.editorDiv.innerText.trim() === "";
              }
              remove() {
                this.isEditing = false;
                if (this.parent) {
                  this.parent.setEditingState(true);
                  this.parent.div.classList.add("freeTextEditing");
                }
                super.remove();
              }
              commit() {
                if (!this.isInEditMode()) {
                  return;
                }
                super.commit();
                this.disableEditMode();
                const savedText = __privateGet(this, _content);
                const newText = __privateSet(this, _content, __privateMethod(this, _extractText, extractText_fn).call(this).trimEnd());
                if (savedText === newText) {
                  return;
                }
                const setText = (text) => {
                  __privateSet(this, _content, text);
                  if (!text) {
                    this.remove();
                    return;
                  }
                  __privateMethod(this, _setContent, setContent_fn).call(this);
                  this._uiManager.rebuild(this);
                  __privateMethod(this, _setEditorDimensions, setEditorDimensions_fn).call(this);
                };
                this.addCommands({
                  cmd: () => {
                    setText(newText);
                  },
                  undo: () => {
                    setText(savedText);
                  },
                  mustExec: false
                });
                __privateMethod(this, _setEditorDimensions, setEditorDimensions_fn).call(this);
              }
              shouldGetKeyboardEvents() {
                return this.isInEditMode();
              }
              enterInEditMode() {
                this.enableEditMode();
                this.editorDiv.focus();
              }
              dblclick(event) {
                this.enterInEditMode();
              }
              keydown(event) {
                if (event.target === this.div && event.key === "Enter") {
                  this.enterInEditMode();
                  event.preventDefault();
                }
              }
              editorDivKeydown(event) {
                _FreeTextEditor._keyboardManager.exec(this, event);
              }
              editorDivFocus(event) {
                this.isEditing = true;
              }
              editorDivBlur(event) {
                this.isEditing = false;
              }
              editorDivInput(event) {
                this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
              }
              disableEditing() {
                this.editorDiv.setAttribute("role", "comment");
                this.editorDiv.removeAttribute("aria-multiline");
              }
              enableEditing() {
                this.editorDiv.setAttribute("role", "textbox");
                this.editorDiv.setAttribute("aria-multiline", true);
              }
              render() {
                if (this.div) {
                  return this.div;
                }
                let baseX, baseY;
                if (this.width) {
                  baseX = this.x;
                  baseY = this.y;
                }
                super.render();
                this.editorDiv = document.createElement("div");
                this.editorDiv.className = "internal";
                this.editorDiv.setAttribute("id", __privateGet(this, _editorDivId));
                this.enableEditing();
                _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg2) => {
                  var _a3;
                  return (_a3 = this.editorDiv) == null ? void 0 : _a3.setAttribute("aria-label", msg2);
                });
                _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg2) => {
                  var _a3;
                  return (_a3 = this.editorDiv) == null ? void 0 : _a3.setAttribute("default-content", msg2);
                });
                this.editorDiv.contentEditable = true;
                const {
                  style: style2
                } = this.editorDiv;
                style2.fontSize = `calc(${__privateGet(this, _fontSize)}px * var(--scale-factor))`;
                style2.color = __privateGet(this, _color);
                this.div.append(this.editorDiv);
                this.overlayDiv = document.createElement("div");
                this.overlayDiv.classList.add("overlay", "enabled");
                this.div.append(this.overlayDiv);
                (0, _tools.bindEvents)(this, this.div, ["dblclick", "keydown"]);
                if (this.width) {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  if (this.annotationElementId) {
                    const {
                      position
                    } = __privateGet(this, _initialData);
                    let [tx, ty] = this.getInitialTranslation();
                    [tx, ty] = this.pageTranslationToScreen(tx, ty);
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    const [pageX, pageY] = this.pageTranslation;
                    let posX, posY;
                    switch (this.rotation) {
                      case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                      case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [ty, -tx];
                        break;
                      case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        [tx, ty] = [-tx, -ty];
                        break;
                      case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        [tx, ty] = [-ty, tx];
                        break;
                    }
                    this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                  } else {
                    this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                  }
                  __privateMethod(this, _setContent, setContent_fn).call(this);
                  this._isDraggable = true;
                  this.editorDiv.contentEditable = false;
                } else {
                  this._isDraggable = false;
                  this.editorDiv.contentEditable = true;
                }
                return this.div;
              }
              get contentDiv() {
                return this.editorDiv;
              }
              static deserialize(data2, parent, uiManager) {
                let initialData = null;
                if (data2 instanceof _annotation_layer.FreeTextAnnotationElement) {
                  const {
                    data: {
                      defaultAppearanceData: {
                        fontSize,
                        fontColor
                      },
                      rect,
                      rotation,
                      id
                    },
                    textContent,
                    textPosition,
                    parent: {
                      page: {
                        pageNumber
                      }
                    }
                  } = data2;
                  if (!textContent || textContent.length === 0) {
                    return null;
                  }
                  initialData = data2 = {
                    annotationType: _util2.AnnotationEditorType.FREETEXT,
                    color: Array.from(fontColor),
                    fontSize,
                    value: textContent.join("\n"),
                    position: textPosition,
                    pageIndex: pageNumber - 1,
                    rect,
                    rotation,
                    id,
                    deleted: false
                  };
                }
                const editor = super.deserialize(data2, parent, uiManager);
                __privateSet(editor, _fontSize, data2.fontSize);
                __privateSet(editor, _color, _util2.Util.makeHexColor(...data2.color));
                __privateSet(editor, _content, data2.value);
                editor.annotationElementId = data2.id || null;
                __privateSet(editor, _initialData, initialData);
                return editor;
              }
              serialize(isForCopying = false) {
                if (this.isEmpty()) {
                  return null;
                }
                if (this.deleted) {
                  return {
                    pageIndex: this.pageIndex,
                    id: this.annotationElementId,
                    deleted: true
                  };
                }
                const padding = _FreeTextEditor._internalPadding * this.parentScale;
                const rect = this.getRect(padding, padding);
                const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : __privateGet(this, _color));
                const serialized = {
                  annotationType: _util2.AnnotationEditorType.FREETEXT,
                  color,
                  fontSize: __privateGet(this, _fontSize),
                  value: __privateGet(this, _content),
                  pageIndex: this.pageIndex,
                  rect,
                  rotation: this.rotation,
                  structTreeParentId: this._structTreeParentId
                };
                if (isForCopying) {
                  return serialized;
                }
                if (this.annotationElementId && !__privateMethod(this, _hasElementChanged, hasElementChanged_fn).call(this, serialized)) {
                  return null;
                }
                serialized.id = this.annotationElementId;
                return serialized;
              }
            };
            let FreeTextEditor = _FreeTextEditor;
            _boundEditorDivBlur = new WeakMap();
            _boundEditorDivFocus = new WeakMap();
            _boundEditorDivInput = new WeakMap();
            _boundEditorDivKeydown = new WeakMap();
            _color = new WeakMap();
            _content = new WeakMap();
            _editorDivId = new WeakMap();
            _fontSize = new WeakMap();
            _initialData = new WeakMap();
            _updateFontSize = new WeakSet();
            updateFontSize_fn = function(fontSize) {
              const setFontsize = (size12) => {
                this.editorDiv.style.fontSize = `calc(${size12}px * var(--scale-factor))`;
                this.translate(0, -(size12 - __privateGet(this, _fontSize)) * this.parentScale);
                __privateSet(this, _fontSize, size12);
                __privateMethod(this, _setEditorDimensions, setEditorDimensions_fn).call(this);
              };
              const savedFontsize = __privateGet(this, _fontSize);
              this.addCommands({
                cmd: () => {
                  setFontsize(fontSize);
                },
                undo: () => {
                  setFontsize(savedFontsize);
                },
                mustExec: true,
                type: _util2.AnnotationEditorParamsType.FREETEXT_SIZE,
                overwriteIfSameType: true,
                keepUndo: true
              });
            };
            _updateColor = new WeakSet();
            updateColor_fn = function(color) {
              const savedColor = __privateGet(this, _color);
              this.addCommands({
                cmd: () => {
                  __privateSet(this, _color, this.editorDiv.style.color = color);
                },
                undo: () => {
                  __privateSet(this, _color, this.editorDiv.style.color = savedColor);
                },
                mustExec: true,
                type: _util2.AnnotationEditorParamsType.FREETEXT_COLOR,
                overwriteIfSameType: true,
                keepUndo: true
              });
            };
            _extractText = new WeakSet();
            extractText_fn = function() {
              const divs = this.editorDiv.getElementsByTagName("div");
              if (divs.length === 0) {
                return this.editorDiv.innerText;
              }
              const buffer3 = [];
              for (const div of divs) {
                buffer3.push(div.innerText.replace(/\r\n?|\n/, ""));
              }
              return buffer3.join("\n");
            };
            _setEditorDimensions = new WeakSet();
            setEditorDimensions_fn = function() {
              const [parentWidth, parentHeight] = this.parentDimensions;
              let rect;
              if (this.isAttachedToDOM) {
                rect = this.div.getBoundingClientRect();
              } else {
                const {
                  currentLayer,
                  div
                } = this;
                const savedDisplay = div.style.display;
                div.style.display = "hidden";
                currentLayer.div.append(this.div);
                rect = div.getBoundingClientRect();
                div.remove();
                div.style.display = savedDisplay;
              }
              if (this.rotation % 180 === this.parentRotation % 180) {
                this.width = rect.width / parentWidth;
                this.height = rect.height / parentHeight;
              } else {
                this.width = rect.height / parentWidth;
                this.height = rect.width / parentHeight;
              }
              this.fixAndSetPosition();
            };
            _setContent = new WeakSet();
            setContent_fn = function() {
              this.editorDiv.replaceChildren();
              if (!__privateGet(this, _content)) {
                return;
              }
              for (const line of __privateGet(this, _content).split("\n")) {
                const div = document.createElement("div");
                div.append(line ? document.createTextNode(line) : document.createElement("br"));
                this.editorDiv.append(div);
              }
            };
            _hasElementChanged = new WeakSet();
            hasElementChanged_fn = function(serialized) {
              const {
                value,
                fontSize,
                color,
                rect,
                pageIndex
              } = __privateGet(this, _initialData);
              return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x2, i2) => Math.abs(x2 - rect[i2]) >= 1) || serialized.color.some((c2, i2) => c2 !== color[i2]) || serialized.pageIndex !== pageIndex;
            };
            _cheatInitialRect = new WeakSet();
            cheatInitialRect_fn = function(delayed = false) {
              if (!this.annotationElementId) {
                return;
              }
              __privateMethod(this, _setEditorDimensions, setEditorDimensions_fn).call(this);
              if (!delayed && (this.width === 0 || this.height === 0)) {
                setTimeout(() => __privateMethod(this, _cheatInitialRect, cheatInitialRect_fn).call(this, true), 0);
                return;
              }
              const padding = _FreeTextEditor._internalPadding * this.parentScale;
              __privateGet(this, _initialData).rect = this.getRect(padding, padding);
            };
            __publicField2(FreeTextEditor, "_freeTextDefaultContent", "");
            __publicField2(FreeTextEditor, "_internalPadding", 0);
            __publicField2(FreeTextEditor, "_defaultColor", null);
            __publicField2(FreeTextEditor, "_defaultFontSize", 10);
            __publicField2(FreeTextEditor, "_type", "freetext");
            exports2.FreeTextEditor = FreeTextEditor;
          },
          /* 29 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _hasBorder, _setInternalLink, setInternalLink_fn, _bindSetOCGState, bindSetOCGState_fn, _dateTimePromise, _boundKeyDown, _boundHide, _boundShow, _boundToggle, _color, _container, _contentsObj, _elements, _parent, _parentRect, _pinned, _popup, _rect, _richText, _titleObj, _wasVisible, _keyDown, keyDown_fn, _toggle, toggle_fn, _show, show_fn, _hide, hide_fn, _line, _square, _circle, _polyline, _polylines, _trigger, _download, download_fn, _accessibilityManager, _annotationCanvasMap, _editableAnnotations, _appendElement, appendElement_fn, _setAnnotationCanvasMap, setAnnotationCanvasMap_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.StampAnnotationElement = exports2.InkAnnotationElement = exports2.FreeTextAnnotationElement = exports2.AnnotationLayer = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _display_utils2 = __w_pdfjs_require__2(6);
            var _annotation_storage2 = __w_pdfjs_require__2(3);
            var _scripting_utils = __w_pdfjs_require__2(30);
            var _displayL10n_utils = __w_pdfjs_require__2(31);
            var _xfa_layer = __w_pdfjs_require__2(32);
            const DEFAULT_TAB_INDEX = 1e3;
            const DEFAULT_FONT_SIZE = 9;
            const GetElementsByNameSet = /* @__PURE__ */ new WeakSet();
            function getRectDims(rect) {
              return {
                width: rect[2] - rect[0],
                height: rect[3] - rect[1]
              };
            }
            class AnnotationElementFactory {
              static create(parameters) {
                const subtype = parameters.data.annotationType;
                switch (subtype) {
                  case _util2.AnnotationType.LINK:
                    return new LinkAnnotationElement(parameters);
                  case _util2.AnnotationType.TEXT:
                    return new TextAnnotationElement(parameters);
                  case _util2.AnnotationType.WIDGET:
                    const fieldType = parameters.data.fieldType;
                    switch (fieldType) {
                      case "Tx":
                        return new TextWidgetAnnotationElement(parameters);
                      case "Btn":
                        if (parameters.data.radioButton) {
                          return new RadioButtonWidgetAnnotationElement(parameters);
                        } else if (parameters.data.checkBox) {
                          return new CheckboxWidgetAnnotationElement(parameters);
                        }
                        return new PushButtonWidgetAnnotationElement(parameters);
                      case "Ch":
                        return new ChoiceWidgetAnnotationElement(parameters);
                      case "Sig":
                        return new SignatureWidgetAnnotationElement(parameters);
                    }
                    return new WidgetAnnotationElement(parameters);
                  case _util2.AnnotationType.POPUP:
                    return new PopupAnnotationElement(parameters);
                  case _util2.AnnotationType.FREETEXT:
                    return new FreeTextAnnotationElement(parameters);
                  case _util2.AnnotationType.LINE:
                    return new LineAnnotationElement(parameters);
                  case _util2.AnnotationType.SQUARE:
                    return new SquareAnnotationElement(parameters);
                  case _util2.AnnotationType.CIRCLE:
                    return new CircleAnnotationElement(parameters);
                  case _util2.AnnotationType.POLYLINE:
                    return new PolylineAnnotationElement(parameters);
                  case _util2.AnnotationType.CARET:
                    return new CaretAnnotationElement(parameters);
                  case _util2.AnnotationType.INK:
                    return new InkAnnotationElement(parameters);
                  case _util2.AnnotationType.POLYGON:
                    return new PolygonAnnotationElement(parameters);
                  case _util2.AnnotationType.HIGHLIGHT:
                    return new HighlightAnnotationElement(parameters);
                  case _util2.AnnotationType.UNDERLINE:
                    return new UnderlineAnnotationElement(parameters);
                  case _util2.AnnotationType.SQUIGGLY:
                    return new SquigglyAnnotationElement(parameters);
                  case _util2.AnnotationType.STRIKEOUT:
                    return new StrikeOutAnnotationElement(parameters);
                  case _util2.AnnotationType.STAMP:
                    return new StampAnnotationElement(parameters);
                  case _util2.AnnotationType.FILEATTACHMENT:
                    return new FileAttachmentAnnotationElement(parameters);
                  default:
                    return new AnnotationElement(parameters);
                }
              }
            }
            const _AnnotationElement = class {
              constructor(parameters, {
                isRenderable = false,
                ignoreBorder = false,
                createQuadrilaterals = false
              } = {}) {
                __privateAdd(this, _hasBorder, false);
                this.isRenderable = isRenderable;
                this.data = parameters.data;
                this.layer = parameters.layer;
                this.linkService = parameters.linkService;
                this.downloadManager = parameters.downloadManager;
                this.imageResourcesPath = parameters.imageResourcesPath;
                this.renderForms = parameters.renderForms;
                this.svgFactory = parameters.svgFactory;
                this.annotationStorage = parameters.annotationStorage;
                this.enableScripting = parameters.enableScripting;
                this.hasJSActions = parameters.hasJSActions;
                this._fieldObjects = parameters.fieldObjects;
                this.parent = parameters.parent;
                if (isRenderable) {
                  this.container = this._createContainer(ignoreBorder);
                }
                if (createQuadrilaterals) {
                  this._createQuadrilaterals();
                }
              }
              static _hasPopupData({
                titleObj,
                contentsObj,
                richText
              }) {
                return !!((titleObj == null ? void 0 : titleObj.str) || (contentsObj == null ? void 0 : contentsObj.str) || (richText == null ? void 0 : richText.str));
              }
              get hasPopupData() {
                return _AnnotationElement._hasPopupData(this.data);
              }
              _createContainer(ignoreBorder) {
                const {
                  data: data2,
                  parent: {
                    page,
                    viewport
                  }
                } = this;
                const container = document.createElement("section");
                container.setAttribute("data-annotation-id", data2.id);
                if (!(this instanceof WidgetAnnotationElement)) {
                  container.tabIndex = DEFAULT_TAB_INDEX;
                }
                container.style.zIndex = this.parent.zIndex++;
                if (this.data.popupRef) {
                  container.setAttribute("aria-haspopup", "dialog");
                }
                if (data2.noRotate) {
                  container.classList.add("norotate");
                }
                const {
                  pageWidth,
                  pageHeight,
                  pageX,
                  pageY
                } = viewport.rawDims;
                if (!data2.rect || this instanceof PopupAnnotationElement) {
                  const {
                    rotation: rotation2
                  } = data2;
                  if (!data2.hasOwnCanvas && rotation2 !== 0) {
                    this.setRotation(rotation2, container);
                  }
                  return container;
                }
                const {
                  width,
                  height
                } = getRectDims(data2.rect);
                const rect = _util2.Util.normalizeRect([data2.rect[0], page.view[3] - data2.rect[1] + page.view[1], data2.rect[2], page.view[3] - data2.rect[3] + page.view[1]]);
                if (!ignoreBorder && data2.borderStyle.width > 0) {
                  container.style.borderWidth = `${data2.borderStyle.width}px`;
                  const horizontalRadius = data2.borderStyle.horizontalCornerRadius;
                  const verticalRadius = data2.borderStyle.verticalCornerRadius;
                  if (horizontalRadius > 0 || verticalRadius > 0) {
                    const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                    container.style.borderRadius = radius;
                  } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                    const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                    container.style.borderRadius = radius;
                  }
                  switch (data2.borderStyle.style) {
                    case _util2.AnnotationBorderStyleType.SOLID:
                      container.style.borderStyle = "solid";
                      break;
                    case _util2.AnnotationBorderStyleType.DASHED:
                      container.style.borderStyle = "dashed";
                      break;
                    case _util2.AnnotationBorderStyleType.BEVELED:
                      (0, _util2.warn)("Unimplemented border style: beveled");
                      break;
                    case _util2.AnnotationBorderStyleType.INSET:
                      (0, _util2.warn)("Unimplemented border style: inset");
                      break;
                    case _util2.AnnotationBorderStyleType.UNDERLINE:
                      container.style.borderBottomStyle = "solid";
                      break;
                  }
                  const borderColor = data2.borderColor || null;
                  if (borderColor) {
                    __privateSet(this, _hasBorder, true);
                    container.style.borderColor = _util2.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                  } else {
                    container.style.borderWidth = 0;
                  }
                }
                container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                const {
                  rotation
                } = data2;
                if (data2.hasOwnCanvas || rotation === 0) {
                  container.style.width = `${100 * width / pageWidth}%`;
                  container.style.height = `${100 * height / pageHeight}%`;
                } else {
                  this.setRotation(rotation, container);
                }
                return container;
              }
              setRotation(angle4, container = this.container) {
                if (!this.data.rect) {
                  return;
                }
                const {
                  pageWidth,
                  pageHeight
                } = this.parent.viewport.rawDims;
                const {
                  width,
                  height
                } = getRectDims(this.data.rect);
                let elementWidth, elementHeight;
                if (angle4 % 180 === 0) {
                  elementWidth = 100 * width / pageWidth;
                  elementHeight = 100 * height / pageHeight;
                } else {
                  elementWidth = 100 * height / pageWidth;
                  elementHeight = 100 * width / pageHeight;
                }
                container.style.width = `${elementWidth}%`;
                container.style.height = `${elementHeight}%`;
                container.setAttribute("data-main-rotation", (360 - angle4) % 360);
              }
              get _commonActions() {
                const setColor2 = (jsName, styleName, event) => {
                  const color = event.detail[jsName];
                  const colorType = color[0];
                  const colorArray = color.slice(1);
                  event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                  this.annotationStorage.setValue(this.data.id, {
                    [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                  });
                };
                return (0, _util2.shadow)(this, "_commonActions", {
                  display: (event) => {
                    const {
                      display
                    } = event.detail;
                    const hidden = display % 2 === 1;
                    this.container.style.visibility = hidden ? "hidden" : "visible";
                    this.annotationStorage.setValue(this.data.id, {
                      noView: hidden,
                      noPrint: display === 1 || display === 2
                    });
                  },
                  print: (event) => {
                    this.annotationStorage.setValue(this.data.id, {
                      noPrint: !event.detail.print
                    });
                  },
                  hidden: (event) => {
                    const {
                      hidden
                    } = event.detail;
                    this.container.style.visibility = hidden ? "hidden" : "visible";
                    this.annotationStorage.setValue(this.data.id, {
                      noPrint: hidden,
                      noView: hidden
                    });
                  },
                  focus: (event) => {
                    setTimeout(() => event.target.focus({
                      preventScroll: false
                    }), 0);
                  },
                  userName: (event) => {
                    event.target.title = event.detail.userName;
                  },
                  readonly: (event) => {
                    event.target.disabled = event.detail.readonly;
                  },
                  required: (event) => {
                    this._setRequired(event.target, event.detail.required);
                  },
                  bgColor: (event) => {
                    setColor2("bgColor", "backgroundColor", event);
                  },
                  fillColor: (event) => {
                    setColor2("fillColor", "backgroundColor", event);
                  },
                  fgColor: (event) => {
                    setColor2("fgColor", "color", event);
                  },
                  textColor: (event) => {
                    setColor2("textColor", "color", event);
                  },
                  borderColor: (event) => {
                    setColor2("borderColor", "borderColor", event);
                  },
                  strokeColor: (event) => {
                    setColor2("strokeColor", "borderColor", event);
                  },
                  rotation: (event) => {
                    const angle4 = event.detail.rotation;
                    this.setRotation(angle4);
                    this.annotationStorage.setValue(this.data.id, {
                      rotation: angle4
                    });
                  }
                });
              }
              _dispatchEventFromSandbox(actions, jsEvent) {
                const commonActions = this._commonActions;
                for (const name2 of Object.keys(jsEvent.detail)) {
                  const action = actions[name2] || commonActions[name2];
                  action == null ? void 0 : action(jsEvent);
                }
              }
              _setDefaultPropertiesFromJS(element) {
                if (!this.enableScripting) {
                  return;
                }
                const storedData = this.annotationStorage.getRawValue(this.data.id);
                if (!storedData) {
                  return;
                }
                const commonActions = this._commonActions;
                for (const [actionName, detail] of Object.entries(storedData)) {
                  const action = commonActions[actionName];
                  if (action) {
                    const eventProxy = {
                      detail: {
                        [actionName]: detail
                      },
                      target: element
                    };
                    action(eventProxy);
                    delete storedData[actionName];
                  }
                }
              }
              _createQuadrilaterals() {
                if (!this.container) {
                  return;
                }
                const {
                  quadPoints
                } = this.data;
                if (!quadPoints) {
                  return;
                }
                const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                if (quadPoints.length === 1) {
                  const [, {
                    x: trX,
                    y: trY
                  }, {
                    x: blX,
                    y: blY
                  }] = quadPoints[0];
                  if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) {
                    return;
                  }
                }
                const {
                  style: style2
                } = this.container;
                let svgBuffer;
                if (__privateGet(this, _hasBorder)) {
                  const {
                    borderColor,
                    borderWidth
                  } = style2;
                  style2.borderWidth = 0;
                  svgBuffer = ["url('data:image/svg+xml;utf8,", `<svg xmlns="http://www.w3.org/2000/svg"`, ` preserveAspectRatio="none" viewBox="0 0 1 1">`, `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`];
                  this.container.classList.add("hasBorder");
                }
                const width = rectTrX - rectBlX;
                const height = rectTrY - rectBlY;
                const {
                  svgFactory
                } = this;
                const svg = svgFactory.createElement("svg");
                svg.classList.add("quadrilateralsContainer");
                svg.setAttribute("width", 0);
                svg.setAttribute("height", 0);
                const defs2 = svgFactory.createElement("defs");
                svg.append(defs2);
                const clipPath = svgFactory.createElement("clipPath");
                const id = `clippath_${this.data.id}`;
                clipPath.setAttribute("id", id);
                clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                defs2.append(clipPath);
                for (const [, {
                  x: trX,
                  y: trY
                }, {
                  x: blX,
                  y: blY
                }] of quadPoints) {
                  const rect = svgFactory.createElement("rect");
                  const x2 = (blX - rectBlX) / width;
                  const y2 = (rectTrY - trY) / height;
                  const rectWidth = (trX - blX) / width;
                  const rectHeight = (trY - blY) / height;
                  rect.setAttribute("x", x2);
                  rect.setAttribute("y", y2);
                  rect.setAttribute("width", rectWidth);
                  rect.setAttribute("height", rectHeight);
                  clipPath.append(rect);
                  svgBuffer == null ? void 0 : svgBuffer.push(`<rect vector-effect="non-scaling-stroke" x="${x2}" y="${y2}" width="${rectWidth}" height="${rectHeight}"/>`);
                }
                if (__privateGet(this, _hasBorder)) {
                  svgBuffer.push(`</g></svg>')`);
                  style2.backgroundImage = svgBuffer.join("");
                }
                this.container.append(svg);
                this.container.style.clipPath = `url(#${id})`;
              }
              _createPopup() {
                const {
                  container,
                  data: data2
                } = this;
                container.setAttribute("aria-haspopup", "dialog");
                const popup2 = new PopupAnnotationElement({
                  data: {
                    color: data2.color,
                    titleObj: data2.titleObj,
                    modificationDate: data2.modificationDate,
                    contentsObj: data2.contentsObj,
                    richText: data2.richText,
                    parentRect: data2.rect,
                    borderStyle: 0,
                    id: `popup_${data2.id}`,
                    rotation: data2.rotation
                  },
                  parent: this.parent,
                  elements: [this]
                });
                this.parent.div.append(popup2.render());
              }
              render() {
                (0, _util2.unreachable)("Abstract method `AnnotationElement.render` called");
              }
              _getElementsByName(name2, skipId = null) {
                const fields = [];
                if (this._fieldObjects) {
                  const fieldObj = this._fieldObjects[name2];
                  if (fieldObj) {
                    for (const {
                      page,
                      id,
                      exportValues
                    } of fieldObj) {
                      if (page === -1) {
                        continue;
                      }
                      if (id === skipId) {
                        continue;
                      }
                      const exportValue = typeof exportValues === "string" ? exportValues : null;
                      const domElement = document.querySelector(`[data-element-id="${id}"]`);
                      if (domElement && !GetElementsByNameSet.has(domElement)) {
                        (0, _util2.warn)(`_getElementsByName - element not allowed: ${id}`);
                        continue;
                      }
                      fields.push({
                        id,
                        exportValue,
                        domElement
                      });
                    }
                  }
                  return fields;
                }
                for (const domElement of document.getElementsByName(name2)) {
                  const {
                    exportValue
                  } = domElement;
                  const id = domElement.getAttribute("data-element-id");
                  if (id === skipId) {
                    continue;
                  }
                  if (!GetElementsByNameSet.has(domElement)) {
                    continue;
                  }
                  fields.push({
                    id,
                    exportValue,
                    domElement
                  });
                }
                return fields;
              }
              show() {
                var _a3;
                if (this.container) {
                  this.container.hidden = false;
                }
                (_a3 = this.popup) == null ? void 0 : _a3.maybeShow();
              }
              hide() {
                var _a3;
                if (this.container) {
                  this.container.hidden = true;
                }
                (_a3 = this.popup) == null ? void 0 : _a3.forceHide();
              }
              getElementsToTriggerPopup() {
                return this.container;
              }
              addHighlightArea() {
                const triggers = this.getElementsToTriggerPopup();
                if (Array.isArray(triggers)) {
                  for (const element of triggers) {
                    element.classList.add("highlightArea");
                  }
                } else {
                  triggers.classList.add("highlightArea");
                }
              }
              _editOnDoubleClick() {
                const {
                  annotationEditorType: mode2,
                  data: {
                    id: editId
                  }
                } = this;
                this.container.addEventListener("dblclick", () => {
                  var _a3;
                  (_a3 = this.linkService.eventBus) == null ? void 0 : _a3.dispatch("switchannotationeditormode", {
                    source: this,
                    mode: mode2,
                    editId
                  });
                });
              }
            };
            let AnnotationElement = _AnnotationElement;
            _hasBorder = new WeakMap();
            class LinkAnnotationElement extends AnnotationElement {
              constructor(parameters, options2 = null) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: !!(options2 == null ? void 0 : options2.ignoreBorder),
                  createQuadrilaterals: true
                });
                __privateAdd(this, _setInternalLink);
                __privateAdd(this, _bindSetOCGState);
                this.isTooltipOnly = parameters.data.isTooltipOnly;
              }
              render() {
                const {
                  data: data2,
                  linkService
                } = this;
                const link2 = document.createElement("a");
                link2.setAttribute("data-element-id", data2.id);
                let isBound = false;
                if (data2.url) {
                  linkService.addLinkAttributes(link2, data2.url, data2.newWindow);
                  isBound = true;
                } else if (data2.action) {
                  this._bindNamedAction(link2, data2.action);
                  isBound = true;
                } else if (data2.attachment) {
                  this._bindAttachment(link2, data2.attachment);
                  isBound = true;
                } else if (data2.setOCGState) {
                  __privateMethod(this, _bindSetOCGState, bindSetOCGState_fn).call(this, link2, data2.setOCGState);
                  isBound = true;
                } else if (data2.dest) {
                  this._bindLink(link2, data2.dest);
                  isBound = true;
                } else {
                  if (data2.actions && (data2.actions.Action || data2.actions["Mouse Up"] || data2.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                    this._bindJSAction(link2, data2);
                    isBound = true;
                  }
                  if (data2.resetForm) {
                    this._bindResetFormAction(link2, data2.resetForm);
                    isBound = true;
                  } else if (this.isTooltipOnly && !isBound) {
                    this._bindLink(link2, "");
                    isBound = true;
                  }
                }
                this.container.classList.add("linkAnnotation");
                if (isBound) {
                  this.container.append(link2);
                }
                return this.container;
              }
              _bindLink(link2, destination2) {
                link2.href = this.linkService.getDestinationHash(destination2);
                link2.onclick = () => {
                  if (destination2) {
                    this.linkService.goToDestination(destination2);
                  }
                  return false;
                };
                if (destination2 || destination2 === "") {
                  __privateMethod(this, _setInternalLink, setInternalLink_fn).call(this);
                }
              }
              _bindNamedAction(link2, action) {
                link2.href = this.linkService.getAnchorUrl("");
                link2.onclick = () => {
                  this.linkService.executeNamedAction(action);
                  return false;
                };
                __privateMethod(this, _setInternalLink, setInternalLink_fn).call(this);
              }
              _bindAttachment(link2, attachment) {
                link2.href = this.linkService.getAnchorUrl("");
                link2.onclick = () => {
                  var _a3;
                  (_a3 = this.downloadManager) == null ? void 0 : _a3.openOrDownloadData(this.container, attachment.content, attachment.filename);
                  return false;
                };
                __privateMethod(this, _setInternalLink, setInternalLink_fn).call(this);
              }
              _bindJSAction(link2, data2) {
                link2.href = this.linkService.getAnchorUrl("");
                const map5 = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
                for (const name2 of Object.keys(data2.actions)) {
                  const jsName = map5.get(name2);
                  if (!jsName) {
                    continue;
                  }
                  link2[jsName] = () => {
                    var _a3;
                    (_a3 = this.linkService.eventBus) == null ? void 0 : _a3.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: data2.id,
                        name: name2
                      }
                    });
                    return false;
                  };
                }
                if (!link2.onclick) {
                  link2.onclick = () => false;
                }
                __privateMethod(this, _setInternalLink, setInternalLink_fn).call(this);
              }
              _bindResetFormAction(link2, resetForm) {
                const otherClickAction = link2.onclick;
                if (!otherClickAction) {
                  link2.href = this.linkService.getAnchorUrl("");
                }
                __privateMethod(this, _setInternalLink, setInternalLink_fn).call(this);
                if (!this._fieldObjects) {
                  (0, _util2.warn)(`_bindResetFormAction - "resetForm" action not supported, ensure that the \`fieldObjects\` parameter is provided.`);
                  if (!otherClickAction) {
                    link2.onclick = () => false;
                  }
                  return;
                }
                link2.onclick = () => {
                  var _a3;
                  otherClickAction == null ? void 0 : otherClickAction();
                  const {
                    fields: resetFormFields,
                    refs: resetFormRefs,
                    include
                  } = resetForm;
                  const allFields = [];
                  if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                    const fieldIds = new Set(resetFormRefs);
                    for (const fieldName of resetFormFields) {
                      const fields = this._fieldObjects[fieldName] || [];
                      for (const {
                        id
                      } of fields) {
                        fieldIds.add(id);
                      }
                    }
                    for (const fields of Object.values(this._fieldObjects)) {
                      for (const field of fields) {
                        if (fieldIds.has(field.id) === include) {
                          allFields.push(field);
                        }
                      }
                    }
                  } else {
                    for (const fields of Object.values(this._fieldObjects)) {
                      allFields.push(...fields);
                    }
                  }
                  const storage = this.annotationStorage;
                  const allIds = [];
                  for (const field of allFields) {
                    const {
                      id
                    } = field;
                    allIds.push(id);
                    switch (field.type) {
                      case "text": {
                        const value = field.defaultValue || "";
                        storage.setValue(id, {
                          value
                        });
                        break;
                      }
                      case "checkbox":
                      case "radiobutton": {
                        const value = field.defaultValue === field.exportValues;
                        storage.setValue(id, {
                          value
                        });
                        break;
                      }
                      case "combobox":
                      case "listbox": {
                        const value = field.defaultValue || "";
                        storage.setValue(id, {
                          value
                        });
                        break;
                      }
                      default:
                        continue;
                    }
                    const domElement = document.querySelector(`[data-element-id="${id}"]`);
                    if (!domElement) {
                      continue;
                    } else if (!GetElementsByNameSet.has(domElement)) {
                      (0, _util2.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                      continue;
                    }
                    domElement.dispatchEvent(new Event("resetform"));
                  }
                  if (this.enableScripting) {
                    (_a3 = this.linkService.eventBus) == null ? void 0 : _a3.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: "app",
                        ids: allIds,
                        name: "ResetForm"
                      }
                    });
                  }
                  return false;
                };
              }
            }
            _setInternalLink = new WeakSet();
            setInternalLink_fn = function() {
              this.container.setAttribute("data-internal-link", "");
            };
            _bindSetOCGState = new WeakSet();
            bindSetOCGState_fn = function(link2, action) {
              link2.href = this.linkService.getAnchorUrl("");
              link2.onclick = () => {
                this.linkService.executeSetOCGState(action);
                return false;
              };
              __privateMethod(this, _setInternalLink, setInternalLink_fn).call(this);
            };
            class TextAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true
                });
              }
              render() {
                this.container.classList.add("textAnnotation");
                const image = document.createElement("img");
                image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                image.alt = "[{{type}} Annotation]";
                image.dataset.l10nId = "text_annotation_type";
                image.dataset.l10nArgs = JSON.stringify({
                  type: this.data.name
                });
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                this.container.append(image);
                return this.container;
              }
            }
            class WidgetAnnotationElement extends AnnotationElement {
              render() {
                if (this.data.alternativeText) {
                  this.container.title = this.data.alternativeText;
                }
                return this.container;
              }
              showElementAndHideCanvas(element) {
                var _a3;
                if (this.data.hasOwnCanvas) {
                  if (((_a3 = element.previousSibling) == null ? void 0 : _a3.nodeName) === "CANVAS") {
                    element.previousSibling.hidden = true;
                  }
                  element.hidden = false;
                }
              }
              _getKeyModifier(event) {
                const {
                  isWin,
                  isMac
                } = _util2.FeatureTest.platform;
                return isWin && event.ctrlKey || isMac && event.metaKey;
              }
              _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                if (baseName.includes("mouse")) {
                  element.addEventListener(baseName, (event) => {
                    var _a3;
                    (_a3 = this.linkService.eventBus) == null ? void 0 : _a3.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: this.data.id,
                        name: eventName,
                        value: valueGetter(event),
                        shift: event.shiftKey,
                        modifier: this._getKeyModifier(event)
                      }
                    });
                  });
                } else {
                  element.addEventListener(baseName, (event) => {
                    var _a3;
                    if (baseName === "blur") {
                      if (!elementData.focused || !event.relatedTarget) {
                        return;
                      }
                      elementData.focused = false;
                    } else if (baseName === "focus") {
                      if (elementData.focused) {
                        return;
                      }
                      elementData.focused = true;
                    }
                    if (!valueGetter) {
                      return;
                    }
                    (_a3 = this.linkService.eventBus) == null ? void 0 : _a3.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: this.data.id,
                        name: eventName,
                        value: valueGetter(event)
                      }
                    });
                  });
                }
              }
              _setEventListeners(element, elementData, names2, getter) {
                var _a3, _b3, _c2;
                for (const [baseName, eventName] of names2) {
                  if (eventName === "Action" || ((_a3 = this.data.actions) == null ? void 0 : _a3[eventName])) {
                    if (eventName === "Focus" || eventName === "Blur") {
                      elementData || (elementData = {
                        focused: false
                      });
                    }
                    this._setEventListener(element, elementData, baseName, eventName, getter);
                    if (eventName === "Focus" && !((_b3 = this.data.actions) == null ? void 0 : _b3.Blur)) {
                      this._setEventListener(element, elementData, "blur", "Blur", null);
                    } else if (eventName === "Blur" && !((_c2 = this.data.actions) == null ? void 0 : _c2.Focus)) {
                      this._setEventListener(element, elementData, "focus", "Focus", null);
                    }
                  }
                }
              }
              _setBackgroundColor(element) {
                const color = this.data.backgroundColor || null;
                element.style.backgroundColor = color === null ? "transparent" : _util2.Util.makeHexColor(color[0], color[1], color[2]);
              }
              _setTextStyle(element) {
                const TEXT_ALIGNMENT = ["left", "center", "right"];
                const {
                  fontColor
                } = this.data.defaultAppearanceData;
                const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                const style2 = element.style;
                let computedFontSize;
                const BORDER_SIZE = 2;
                const roundToOneDecimal = (x2) => Math.round(10 * x2) / 10;
                if (this.data.multiLine) {
                  const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                  const numberOfLines = Math.round(height / (_util2.LINE_FACTOR * fontSize)) || 1;
                  const lineHeight = height / numberOfLines;
                  computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util2.LINE_FACTOR));
                } else {
                  const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                  computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util2.LINE_FACTOR));
                }
                style2.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                style2.color = _util2.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                if (this.data.textAlignment !== null) {
                  style2.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                }
              }
              _setRequired(element, isRequired) {
                if (isRequired) {
                  element.setAttribute("required", true);
                } else {
                  element.removeAttribute("required");
                }
                element.setAttribute("aria-required", isRequired);
              }
            }
            class TextWidgetAnnotationElement extends WidgetAnnotationElement {
              constructor(parameters) {
                const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                super(parameters, {
                  isRenderable
                });
              }
              setPropertyOnSiblings(base, key, value, keyInStorage) {
                const storage = this.annotationStorage;
                for (const element of this._getElementsByName(base.name, base.id)) {
                  if (element.domElement) {
                    element.domElement[key] = value;
                  }
                  storage.setValue(element.id, {
                    [keyInStorage]: value
                  });
                }
              }
              render() {
                var _a3, _b3;
                const storage = this.annotationStorage;
                const id = this.data.id;
                this.container.classList.add("textWidgetAnnotation");
                let element = null;
                if (this.renderForms) {
                  const storedData = storage.getValue(id, {
                    value: this.data.fieldValue
                  });
                  let textContent = storedData.value || "";
                  const maxLen = storage.getValue(id, {
                    charLimit: this.data.maxLen
                  }).charLimit;
                  if (maxLen && textContent.length > maxLen) {
                    textContent = textContent.slice(0, maxLen);
                  }
                  let fieldFormattedValues = storedData.formattedValue || ((_a3 = this.data.textContent) == null ? void 0 : _a3.join("\n")) || null;
                  if (fieldFormattedValues && this.data.comb) {
                    fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                  }
                  const elementData = {
                    userValue: textContent,
                    formattedValue: fieldFormattedValues,
                    lastCommittedValue: null,
                    commitKey: 1,
                    focused: false
                  };
                  if (this.data.multiLine) {
                    element = document.createElement("textarea");
                    element.textContent = fieldFormattedValues ?? textContent;
                    if (this.data.doNotScroll) {
                      element.style.overflowY = "hidden";
                    }
                  } else {
                    element = document.createElement("input");
                    element.type = "text";
                    element.setAttribute("value", fieldFormattedValues ?? textContent);
                    if (this.data.doNotScroll) {
                      element.style.overflowX = "hidden";
                    }
                  }
                  if (this.data.hasOwnCanvas) {
                    element.hidden = true;
                  }
                  GetElementsByNameSet.add(element);
                  element.setAttribute("data-element-id", id);
                  element.disabled = this.data.readOnly;
                  element.name = this.data.fieldName;
                  element.tabIndex = DEFAULT_TAB_INDEX;
                  this._setRequired(element, this.data.required);
                  if (maxLen) {
                    element.maxLength = maxLen;
                  }
                  element.addEventListener("input", (event) => {
                    storage.setValue(id, {
                      value: event.target.value
                    });
                    this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                    elementData.formattedValue = null;
                  });
                  element.addEventListener("resetform", (event) => {
                    const defaultValue2 = this.data.defaultFieldValue ?? "";
                    element.value = elementData.userValue = defaultValue2;
                    elementData.formattedValue = null;
                  });
                  let blurListener = (event) => {
                    const {
                      formattedValue
                    } = elementData;
                    if (formattedValue !== null && formattedValue !== void 0) {
                      event.target.value = formattedValue;
                    }
                    event.target.scrollLeft = 0;
                  };
                  if (this.enableScripting && this.hasJSActions) {
                    element.addEventListener("focus", (event) => {
                      if (elementData.focused) {
                        return;
                      }
                      const {
                        target
                      } = event;
                      if (elementData.userValue) {
                        target.value = elementData.userValue;
                      }
                      elementData.lastCommittedValue = target.value;
                      elementData.commitKey = 1;
                      elementData.focused = true;
                    });
                    element.addEventListener("updatefromsandbox", (jsEvent) => {
                      this.showElementAndHideCanvas(jsEvent.target);
                      const actions = {
                        value(event) {
                          elementData.userValue = event.detail.value ?? "";
                          storage.setValue(id, {
                            value: elementData.userValue.toString()
                          });
                          event.target.value = elementData.userValue;
                        },
                        formattedValue(event) {
                          const {
                            formattedValue
                          } = event.detail;
                          elementData.formattedValue = formattedValue;
                          if (formattedValue !== null && formattedValue !== void 0 && event.target !== document.activeElement) {
                            event.target.value = formattedValue;
                          }
                          storage.setValue(id, {
                            formattedValue
                          });
                        },
                        selRange(event) {
                          event.target.setSelectionRange(...event.detail.selRange);
                        },
                        charLimit: (event) => {
                          var _a4;
                          const {
                            charLimit
                          } = event.detail;
                          const {
                            target
                          } = event;
                          if (charLimit === 0) {
                            target.removeAttribute("maxLength");
                            return;
                          }
                          target.setAttribute("maxLength", charLimit);
                          let value = elementData.userValue;
                          if (!value || value.length <= charLimit) {
                            return;
                          }
                          value = value.slice(0, charLimit);
                          target.value = elementData.userValue = value;
                          storage.setValue(id, {
                            value
                          });
                          (_a4 = this.linkService.eventBus) == null ? void 0 : _a4.dispatch("dispatcheventinsandbox", {
                            source: this,
                            detail: {
                              id,
                              name: "Keystroke",
                              value,
                              willCommit: true,
                              commitKey: 1,
                              selStart: target.selectionStart,
                              selEnd: target.selectionEnd
                            }
                          });
                        }
                      };
                      this._dispatchEventFromSandbox(actions, jsEvent);
                    });
                    element.addEventListener("keydown", (event) => {
                      var _a4;
                      elementData.commitKey = 1;
                      let commitKey = -1;
                      if (event.key === "Escape") {
                        commitKey = 0;
                      } else if (event.key === "Enter" && !this.data.multiLine) {
                        commitKey = 2;
                      } else if (event.key === "Tab") {
                        elementData.commitKey = 3;
                      }
                      if (commitKey === -1) {
                        return;
                      }
                      const {
                        value
                      } = event.target;
                      if (elementData.lastCommittedValue === value) {
                        return;
                      }
                      elementData.lastCommittedValue = value;
                      elementData.userValue = value;
                      (_a4 = this.linkService.eventBus) == null ? void 0 : _a4.dispatch("dispatcheventinsandbox", {
                        source: this,
                        detail: {
                          id,
                          name: "Keystroke",
                          value,
                          willCommit: true,
                          commitKey,
                          selStart: event.target.selectionStart,
                          selEnd: event.target.selectionEnd
                        }
                      });
                    });
                    const _blurListener = blurListener;
                    blurListener = null;
                    element.addEventListener("blur", (event) => {
                      var _a4;
                      if (!elementData.focused || !event.relatedTarget) {
                        return;
                      }
                      elementData.focused = false;
                      const {
                        value
                      } = event.target;
                      elementData.userValue = value;
                      if (elementData.lastCommittedValue !== value) {
                        (_a4 = this.linkService.eventBus) == null ? void 0 : _a4.dispatch("dispatcheventinsandbox", {
                          source: this,
                          detail: {
                            id,
                            name: "Keystroke",
                            value,
                            willCommit: true,
                            commitKey: elementData.commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                          }
                        });
                      }
                      _blurListener(event);
                    });
                    if ((_b3 = this.data.actions) == null ? void 0 : _b3.Keystroke) {
                      element.addEventListener("beforeinput", (event) => {
                        var _a4;
                        elementData.lastCommittedValue = null;
                        const {
                          data: data2,
                          target
                        } = event;
                        const {
                          value,
                          selectionStart,
                          selectionEnd
                        } = target;
                        let selStart = selectionStart, selEnd = selectionEnd;
                        switch (event.inputType) {
                          case "deleteWordBackward": {
                            const match2 = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                            if (match2) {
                              selStart -= match2[0].length;
                            }
                            break;
                          }
                          case "deleteWordForward": {
                            const match2 = value.substring(selectionStart).match(/^[^\w]*\w*/);
                            if (match2) {
                              selEnd += match2[0].length;
                            }
                            break;
                          }
                          case "deleteContentBackward":
                            if (selectionStart === selectionEnd) {
                              selStart -= 1;
                            }
                            break;
                          case "deleteContentForward":
                            if (selectionStart === selectionEnd) {
                              selEnd += 1;
                            }
                            break;
                        }
                        event.preventDefault();
                        (_a4 = this.linkService.eventBus) == null ? void 0 : _a4.dispatch("dispatcheventinsandbox", {
                          source: this,
                          detail: {
                            id,
                            name: "Keystroke",
                            value,
                            change: data2 || "",
                            willCommit: false,
                            selStart,
                            selEnd
                          }
                        });
                      });
                    }
                    this._setEventListeners(element, elementData, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.value);
                  }
                  if (blurListener) {
                    element.addEventListener("blur", blurListener);
                  }
                  if (this.data.comb) {
                    const fieldWidth = this.data.rect[2] - this.data.rect[0];
                    const combWidth = fieldWidth / maxLen;
                    element.classList.add("comb");
                    element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                  }
                } else {
                  element = document.createElement("div");
                  element.textContent = this.data.fieldValue;
                  element.style.verticalAlign = "middle";
                  element.style.display = "table-cell";
                }
                this._setTextStyle(element);
                this._setBackgroundColor(element);
                this._setDefaultPropertiesFromJS(element);
                this.container.append(element);
                return this.container;
              }
            }
            class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: !!parameters.data.hasOwnCanvas
                });
              }
            }
            class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: parameters.renderForms
                });
              }
              render() {
                const storage = this.annotationStorage;
                const data2 = this.data;
                const id = data2.id;
                let value = storage.getValue(id, {
                  value: data2.exportValue === data2.fieldValue
                }).value;
                if (typeof value === "string") {
                  value = value !== "Off";
                  storage.setValue(id, {
                    value
                  });
                }
                this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                const element = document.createElement("input");
                GetElementsByNameSet.add(element);
                element.setAttribute("data-element-id", id);
                element.disabled = data2.readOnly;
                this._setRequired(element, this.data.required);
                element.type = "checkbox";
                element.name = data2.fieldName;
                if (value) {
                  element.setAttribute("checked", true);
                }
                element.setAttribute("exportValue", data2.exportValue);
                element.tabIndex = DEFAULT_TAB_INDEX;
                element.addEventListener("change", (event) => {
                  const {
                    name: name2,
                    checked
                  } = event.target;
                  for (const checkbox of this._getElementsByName(name2, id)) {
                    const curChecked = checked && checkbox.exportValue === data2.exportValue;
                    if (checkbox.domElement) {
                      checkbox.domElement.checked = curChecked;
                    }
                    storage.setValue(checkbox.id, {
                      value: curChecked
                    });
                  }
                  storage.setValue(id, {
                    value: checked
                  });
                });
                element.addEventListener("resetform", (event) => {
                  const defaultValue2 = data2.defaultFieldValue || "Off";
                  event.target.checked = defaultValue2 === data2.exportValue;
                });
                if (this.enableScripting && this.hasJSActions) {
                  element.addEventListener("updatefromsandbox", (jsEvent) => {
                    const actions = {
                      value(event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                          value: event.target.checked
                        });
                      }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                  });
                  this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.checked);
                }
                this._setBackgroundColor(element);
                this._setDefaultPropertiesFromJS(element);
                this.container.append(element);
                return this.container;
              }
            }
            class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: parameters.renderForms
                });
              }
              render() {
                this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                const storage = this.annotationStorage;
                const data2 = this.data;
                const id = data2.id;
                let value = storage.getValue(id, {
                  value: data2.fieldValue === data2.buttonValue
                }).value;
                if (typeof value === "string") {
                  value = value !== data2.buttonValue;
                  storage.setValue(id, {
                    value
                  });
                }
                const element = document.createElement("input");
                GetElementsByNameSet.add(element);
                element.setAttribute("data-element-id", id);
                element.disabled = data2.readOnly;
                this._setRequired(element, this.data.required);
                element.type = "radio";
                element.name = data2.fieldName;
                if (value) {
                  element.setAttribute("checked", true);
                }
                element.tabIndex = DEFAULT_TAB_INDEX;
                element.addEventListener("change", (event) => {
                  const {
                    name: name2,
                    checked
                  } = event.target;
                  for (const radio of this._getElementsByName(name2, id)) {
                    storage.setValue(radio.id, {
                      value: false
                    });
                  }
                  storage.setValue(id, {
                    value: checked
                  });
                });
                element.addEventListener("resetform", (event) => {
                  const defaultValue2 = data2.defaultFieldValue;
                  event.target.checked = defaultValue2 !== null && defaultValue2 !== void 0 && defaultValue2 === data2.buttonValue;
                });
                if (this.enableScripting && this.hasJSActions) {
                  const pdfButtonValue = data2.buttonValue;
                  element.addEventListener("updatefromsandbox", (jsEvent) => {
                    const actions = {
                      value: (event) => {
                        const checked = pdfButtonValue === event.detail.value;
                        for (const radio of this._getElementsByName(event.target.name)) {
                          const curChecked = checked && radio.id === id;
                          if (radio.domElement) {
                            radio.domElement.checked = curChecked;
                          }
                          storage.setValue(radio.id, {
                            value: curChecked
                          });
                        }
                      }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                  });
                  this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (event) => event.target.checked);
                }
                this._setBackgroundColor(element);
                this._setDefaultPropertiesFromJS(element);
                this.container.append(element);
                return this.container;
              }
            }
            class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  ignoreBorder: parameters.data.hasAppearance
                });
              }
              render() {
                const container = super.render();
                container.classList.add("buttonWidgetAnnotation", "pushButton");
                if (this.data.alternativeText) {
                  container.title = this.data.alternativeText;
                }
                const linkElement = container.lastChild;
                if (this.enableScripting && this.hasJSActions && linkElement) {
                  this._setDefaultPropertiesFromJS(linkElement);
                  linkElement.addEventListener("updatefromsandbox", (jsEvent) => {
                    this._dispatchEventFromSandbox({}, jsEvent);
                  });
                }
                return container;
              }
            }
            class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: parameters.renderForms
                });
              }
              render() {
                this.container.classList.add("choiceWidgetAnnotation");
                const storage = this.annotationStorage;
                const id = this.data.id;
                const storedData = storage.getValue(id, {
                  value: this.data.fieldValue
                });
                const selectElement = document.createElement("select");
                GetElementsByNameSet.add(selectElement);
                selectElement.setAttribute("data-element-id", id);
                selectElement.disabled = this.data.readOnly;
                this._setRequired(selectElement, this.data.required);
                selectElement.name = this.data.fieldName;
                selectElement.tabIndex = DEFAULT_TAB_INDEX;
                let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                if (!this.data.combo) {
                  selectElement.size = this.data.options.length;
                  if (this.data.multiSelect) {
                    selectElement.multiple = true;
                  }
                }
                selectElement.addEventListener("resetform", (event) => {
                  const defaultValue2 = this.data.defaultFieldValue;
                  for (const option of selectElement.options) {
                    option.selected = option.value === defaultValue2;
                  }
                });
                for (const option of this.data.options) {
                  const optionElement = document.createElement("option");
                  optionElement.textContent = option.displayValue;
                  optionElement.value = option.exportValue;
                  if (storedData.value.includes(option.exportValue)) {
                    optionElement.setAttribute("selected", true);
                    addAnEmptyEntry = false;
                  }
                  selectElement.append(optionElement);
                }
                let removeEmptyEntry = null;
                if (addAnEmptyEntry) {
                  const noneOptionElement = document.createElement("option");
                  noneOptionElement.value = " ";
                  noneOptionElement.setAttribute("hidden", true);
                  noneOptionElement.setAttribute("selected", true);
                  selectElement.prepend(noneOptionElement);
                  removeEmptyEntry = () => {
                    noneOptionElement.remove();
                    selectElement.removeEventListener("input", removeEmptyEntry);
                    removeEmptyEntry = null;
                  };
                  selectElement.addEventListener("input", removeEmptyEntry);
                }
                const getValue2 = (isExport) => {
                  const name2 = isExport ? "value" : "textContent";
                  const {
                    options: options2,
                    multiple
                  } = selectElement;
                  if (!multiple) {
                    return options2.selectedIndex === -1 ? null : options2[options2.selectedIndex][name2];
                  }
                  return Array.prototype.filter.call(options2, (option) => option.selected).map((option) => option[name2]);
                };
                let selectedValues = getValue2(false);
                const getItems2 = (event) => {
                  const options2 = event.target.options;
                  return Array.prototype.map.call(options2, (option) => {
                    return {
                      displayValue: option.textContent,
                      exportValue: option.value
                    };
                  });
                };
                if (this.enableScripting && this.hasJSActions) {
                  selectElement.addEventListener("updatefromsandbox", (jsEvent) => {
                    const actions = {
                      value(event) {
                        removeEmptyEntry == null ? void 0 : removeEmptyEntry();
                        const value = event.detail.value;
                        const values4 = new Set(Array.isArray(value) ? value : [value]);
                        for (const option of selectElement.options) {
                          option.selected = values4.has(option.value);
                        }
                        storage.setValue(id, {
                          value: getValue2(true)
                        });
                        selectedValues = getValue2(false);
                      },
                      multipleSelection(event) {
                        selectElement.multiple = true;
                      },
                      remove(event) {
                        const options2 = selectElement.options;
                        const index2 = event.detail.remove;
                        options2[index2].selected = false;
                        selectElement.remove(index2);
                        if (options2.length > 0) {
                          const i2 = Array.prototype.findIndex.call(options2, (option) => option.selected);
                          if (i2 === -1) {
                            options2[0].selected = true;
                          }
                        }
                        storage.setValue(id, {
                          value: getValue2(true),
                          items: getItems2(event)
                        });
                        selectedValues = getValue2(false);
                      },
                      clear(event) {
                        while (selectElement.length !== 0) {
                          selectElement.remove(0);
                        }
                        storage.setValue(id, {
                          value: null,
                          items: []
                        });
                        selectedValues = getValue2(false);
                      },
                      insert(event) {
                        const {
                          index: index2,
                          displayValue,
                          exportValue
                        } = event.detail.insert;
                        const selectChild = selectElement.children[index2];
                        const optionElement = document.createElement("option");
                        optionElement.textContent = displayValue;
                        optionElement.value = exportValue;
                        if (selectChild) {
                          selectChild.before(optionElement);
                        } else {
                          selectElement.append(optionElement);
                        }
                        storage.setValue(id, {
                          value: getValue2(true),
                          items: getItems2(event)
                        });
                        selectedValues = getValue2(false);
                      },
                      items(event) {
                        const {
                          items
                        } = event.detail;
                        while (selectElement.length !== 0) {
                          selectElement.remove(0);
                        }
                        for (const item of items) {
                          const {
                            displayValue,
                            exportValue
                          } = item;
                          const optionElement = document.createElement("option");
                          optionElement.textContent = displayValue;
                          optionElement.value = exportValue;
                          selectElement.append(optionElement);
                        }
                        if (selectElement.options.length > 0) {
                          selectElement.options[0].selected = true;
                        }
                        storage.setValue(id, {
                          value: getValue2(true),
                          items: getItems2(event)
                        });
                        selectedValues = getValue2(false);
                      },
                      indices(event) {
                        const indices = new Set(event.detail.indices);
                        for (const option of event.target.options) {
                          option.selected = indices.has(option.index);
                        }
                        storage.setValue(id, {
                          value: getValue2(true)
                        });
                        selectedValues = getValue2(false);
                      },
                      editable(event) {
                        event.target.disabled = !event.detail.editable;
                      }
                    };
                    this._dispatchEventFromSandbox(actions, jsEvent);
                  });
                  selectElement.addEventListener("input", (event) => {
                    var _a3;
                    const exportValue = getValue2(true);
                    storage.setValue(id, {
                      value: exportValue
                    });
                    event.preventDefault();
                    (_a3 = this.linkService.eventBus) == null ? void 0 : _a3.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id,
                        name: "Keystroke",
                        value: selectedValues,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                      }
                    });
                  });
                  this._setEventListeners(selectElement, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (event) => event.target.value);
                } else {
                  selectElement.addEventListener("input", function(event) {
                    storage.setValue(id, {
                      value: getValue2(true)
                    });
                  });
                }
                if (this.data.combo) {
                  this._setTextStyle(selectElement);
                }
                this._setBackgroundColor(selectElement);
                this._setDefaultPropertiesFromJS(selectElement);
                this.container.append(selectElement);
                return this.container;
              }
            }
            class PopupAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                const {
                  data: data2,
                  elements
                } = parameters;
                super(parameters, {
                  isRenderable: AnnotationElement._hasPopupData(data2)
                });
                this.elements = elements;
              }
              render() {
                this.container.classList.add("popupAnnotation");
                const popup2 = new PopupElement({
                  container: this.container,
                  color: this.data.color,
                  titleObj: this.data.titleObj,
                  modificationDate: this.data.modificationDate,
                  contentsObj: this.data.contentsObj,
                  richText: this.data.richText,
                  rect: this.data.rect,
                  parentRect: this.data.parentRect || null,
                  parent: this.parent,
                  elements: this.elements,
                  open: this.data.open
                });
                const elementIds = [];
                for (const element of this.elements) {
                  element.popup = popup2;
                  elementIds.push(element.data.id);
                  element.addHighlightArea();
                }
                this.container.setAttribute("aria-controls", elementIds.map((id) => `${_util2.AnnotationPrefix}${id}`).join(","));
                return this.container;
              }
            }
            class PopupElement {
              constructor({
                container,
                color,
                elements,
                titleObj,
                modificationDate,
                contentsObj,
                richText,
                parent,
                rect,
                parentRect,
                open: open2
              }) {
                __privateAdd(this, _keyDown);
                __privateAdd(this, _toggle);
                __privateAdd(this, _show);
                __privateAdd(this, _hide);
                __privateAdd(this, _dateTimePromise, null);
                __privateAdd(this, _boundKeyDown, __privateMethod(this, _keyDown, keyDown_fn).bind(this));
                __privateAdd(this, _boundHide, __privateMethod(this, _hide, hide_fn).bind(this));
                __privateAdd(this, _boundShow, __privateMethod(this, _show, show_fn).bind(this));
                __privateAdd(this, _boundToggle, __privateMethod(this, _toggle, toggle_fn).bind(this));
                __privateAdd(this, _color, null);
                __privateAdd(this, _container, null);
                __privateAdd(this, _contentsObj, null);
                __privateAdd(this, _elements, null);
                __privateAdd(this, _parent, null);
                __privateAdd(this, _parentRect, null);
                __privateAdd(this, _pinned, false);
                __privateAdd(this, _popup, null);
                __privateAdd(this, _rect, null);
                __privateAdd(this, _richText, null);
                __privateAdd(this, _titleObj, null);
                __privateAdd(this, _wasVisible, false);
                var _a3;
                __privateSet(this, _container, container);
                __privateSet(this, _titleObj, titleObj);
                __privateSet(this, _contentsObj, contentsObj);
                __privateSet(this, _richText, richText);
                __privateSet(this, _parent, parent);
                __privateSet(this, _color, color);
                __privateSet(this, _rect, rect);
                __privateSet(this, _parentRect, parentRect);
                __privateSet(this, _elements, elements);
                const dateObject = _display_utils2.PDFDateString.toDateObject(modificationDate);
                if (dateObject) {
                  __privateSet(this, _dateTimePromise, parent.l10n.get("annotation_date_string", {
                    date: dateObject.toLocaleDateString(),
                    time: dateObject.toLocaleTimeString()
                  }));
                }
                this.trigger = elements.flatMap((e3) => e3.getElementsToTriggerPopup());
                for (const element of this.trigger) {
                  element.addEventListener("click", __privateGet(this, _boundToggle));
                  element.addEventListener("mouseenter", __privateGet(this, _boundShow));
                  element.addEventListener("mouseleave", __privateGet(this, _boundHide));
                  element.classList.add("popupTriggerArea");
                }
                for (const element of elements) {
                  (_a3 = element.container) == null ? void 0 : _a3.addEventListener("keydown", __privateGet(this, _boundKeyDown));
                }
                __privateGet(this, _container).hidden = true;
                if (open2) {
                  __privateMethod(this, _toggle, toggle_fn).call(this);
                }
              }
              render() {
                if (__privateGet(this, _popup)) {
                  return;
                }
                const {
                  page: {
                    view: view2
                  },
                  viewport: {
                    rawDims: {
                      pageWidth,
                      pageHeight,
                      pageX,
                      pageY
                    }
                  }
                } = __privateGet(this, _parent);
                const popup2 = __privateSet(this, _popup, document.createElement("div"));
                popup2.className = "popup";
                if (__privateGet(this, _color)) {
                  const baseColor = popup2.style.outlineColor = _util2.Util.makeHexColor(...__privateGet(this, _color));
                  if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) {
                    popup2.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                  } else {
                    const BACKGROUND_ENLIGHT = 0.7;
                    popup2.style.backgroundColor = _util2.Util.makeHexColor(...__privateGet(this, _color).map((c2) => Math.floor(BACKGROUND_ENLIGHT * (255 - c2) + c2)));
                  }
                }
                const header = document.createElement("span");
                header.className = "header";
                const title = document.createElement("h1");
                header.append(title);
                ({
                  dir: title.dir,
                  str: title.textContent
                } = __privateGet(this, _titleObj));
                popup2.append(header);
                if (__privateGet(this, _dateTimePromise)) {
                  const modificationDate = document.createElement("span");
                  modificationDate.classList.add("popupDate");
                  __privateGet(this, _dateTimePromise).then((localized) => {
                    modificationDate.textContent = localized;
                  });
                  header.append(modificationDate);
                }
                const contentsObj = __privateGet(this, _contentsObj);
                const richText = __privateGet(this, _richText);
                if ((richText == null ? void 0 : richText.str) && (!(contentsObj == null ? void 0 : contentsObj.str) || contentsObj.str === richText.str)) {
                  _xfa_layer.XfaLayer.render({
                    xfaHtml: richText.html,
                    intent: "richText",
                    div: popup2
                  });
                  popup2.lastChild.classList.add("richText", "popupContent");
                } else {
                  const contents = this._formatContents(contentsObj);
                  popup2.append(contents);
                }
                let useParentRect = !!__privateGet(this, _parentRect);
                let rect = useParentRect ? __privateGet(this, _parentRect) : __privateGet(this, _rect);
                for (const element of __privateGet(this, _elements)) {
                  if (!rect || _util2.Util.intersect(element.data.rect, rect) !== null) {
                    rect = element.data.rect;
                    useParentRect = true;
                    break;
                  }
                }
                const normalizedRect = _util2.Util.normalizeRect([rect[0], view2[3] - rect[1] + view2[1], rect[2], view2[3] - rect[3] + view2[1]]);
                const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                const popupLeft = normalizedRect[0] + parentWidth;
                const popupTop = normalizedRect[1];
                const {
                  style: style2
                } = __privateGet(this, _container);
                style2.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                style2.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                __privateGet(this, _container).append(popup2);
              }
              _formatContents({
                str,
                dir
              }) {
                const p2 = document.createElement("p");
                p2.classList.add("popupContent");
                p2.dir = dir;
                const lines = str.split(/(?:\r\n?|\n)/);
                for (let i2 = 0, ii2 = lines.length; i2 < ii2; ++i2) {
                  const line = lines[i2];
                  p2.append(document.createTextNode(line));
                  if (i2 < ii2 - 1) {
                    p2.append(document.createElement("br"));
                  }
                }
                return p2;
              }
              forceHide() {
                __privateSet(this, _wasVisible, this.isVisible);
                if (!__privateGet(this, _wasVisible)) {
                  return;
                }
                __privateGet(this, _container).hidden = true;
              }
              maybeShow() {
                if (!__privateGet(this, _wasVisible)) {
                  return;
                }
                __privateSet(this, _wasVisible, false);
                __privateGet(this, _container).hidden = false;
              }
              get isVisible() {
                return __privateGet(this, _container).hidden === false;
              }
            }
            _dateTimePromise = new WeakMap();
            _boundKeyDown = new WeakMap();
            _boundHide = new WeakMap();
            _boundShow = new WeakMap();
            _boundToggle = new WeakMap();
            _color = new WeakMap();
            _container = new WeakMap();
            _contentsObj = new WeakMap();
            _elements = new WeakMap();
            _parent = new WeakMap();
            _parentRect = new WeakMap();
            _pinned = new WeakMap();
            _popup = new WeakMap();
            _rect = new WeakMap();
            _richText = new WeakMap();
            _titleObj = new WeakMap();
            _wasVisible = new WeakMap();
            _keyDown = new WeakSet();
            keyDown_fn = function(event) {
              if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) {
                return;
              }
              if (event.key === "Enter" || event.key === "Escape" && __privateGet(this, _pinned)) {
                __privateMethod(this, _toggle, toggle_fn).call(this);
              }
            };
            _toggle = new WeakSet();
            toggle_fn = function() {
              __privateSet(this, _pinned, !__privateGet(this, _pinned));
              if (__privateGet(this, _pinned)) {
                __privateMethod(this, _show, show_fn).call(this);
                __privateGet(this, _container).addEventListener("click", __privateGet(this, _boundToggle));
                __privateGet(this, _container).addEventListener("keydown", __privateGet(this, _boundKeyDown));
              } else {
                __privateMethod(this, _hide, hide_fn).call(this);
                __privateGet(this, _container).removeEventListener("click", __privateGet(this, _boundToggle));
                __privateGet(this, _container).removeEventListener("keydown", __privateGet(this, _boundKeyDown));
              }
            };
            _show = new WeakSet();
            show_fn = function() {
              if (!__privateGet(this, _popup)) {
                this.render();
              }
              if (!this.isVisible) {
                __privateGet(this, _container).hidden = false;
                __privateGet(this, _container).style.zIndex = parseInt(__privateGet(this, _container).style.zIndex) + 1e3;
              } else if (__privateGet(this, _pinned)) {
                __privateGet(this, _container).classList.add("focused");
              }
            };
            _hide = new WeakSet();
            hide_fn = function() {
              __privateGet(this, _container).classList.remove("focused");
              if (__privateGet(this, _pinned) || !this.isVisible) {
                return;
              }
              __privateGet(this, _container).hidden = true;
              __privateGet(this, _container).style.zIndex = parseInt(__privateGet(this, _container).style.zIndex) - 1e3;
            };
            class FreeTextAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
                this.textContent = parameters.data.textContent;
                this.textPosition = parameters.data.textPosition;
                this.annotationEditorType = _util2.AnnotationEditorType.FREETEXT;
              }
              render() {
                this.container.classList.add("freeTextAnnotation");
                if (this.textContent) {
                  const content = document.createElement("div");
                  content.classList.add("annotationTextContent");
                  content.setAttribute("role", "comment");
                  for (const line of this.textContent) {
                    const lineSpan = document.createElement("span");
                    lineSpan.textContent = line;
                    content.append(lineSpan);
                  }
                  this.container.append(content);
                }
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                this._editOnDoubleClick();
                return this.container;
              }
            }
            exports2.FreeTextAnnotationElement = FreeTextAnnotationElement;
            class LineAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
                __privateAdd(this, _line, null);
              }
              render() {
                this.container.classList.add("lineAnnotation");
                const data2 = this.data;
                const {
                  width,
                  height
                } = getRectDims(data2.rect);
                const svg = this.svgFactory.create(width, height, true);
                const line = __privateSet(this, _line, this.svgFactory.createElement("svg:line"));
                line.setAttribute("x1", data2.rect[2] - data2.lineCoordinates[0]);
                line.setAttribute("y1", data2.rect[3] - data2.lineCoordinates[1]);
                line.setAttribute("x2", data2.rect[2] - data2.lineCoordinates[2]);
                line.setAttribute("y2", data2.rect[3] - data2.lineCoordinates[3]);
                line.setAttribute("stroke-width", data2.borderStyle.width || 1);
                line.setAttribute("stroke", "transparent");
                line.setAttribute("fill", "transparent");
                svg.append(line);
                this.container.append(svg);
                if (!data2.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                return this.container;
              }
              getElementsToTriggerPopup() {
                return __privateGet(this, _line);
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            _line = new WeakMap();
            class SquareAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
                __privateAdd(this, _square, null);
              }
              render() {
                this.container.classList.add("squareAnnotation");
                const data2 = this.data;
                const {
                  width,
                  height
                } = getRectDims(data2.rect);
                const svg = this.svgFactory.create(width, height, true);
                const borderWidth = data2.borderStyle.width;
                const square = __privateSet(this, _square, this.svgFactory.createElement("svg:rect"));
                square.setAttribute("x", borderWidth / 2);
                square.setAttribute("y", borderWidth / 2);
                square.setAttribute("width", width - borderWidth);
                square.setAttribute("height", height - borderWidth);
                square.setAttribute("stroke-width", borderWidth || 1);
                square.setAttribute("stroke", "transparent");
                square.setAttribute("fill", "transparent");
                svg.append(square);
                this.container.append(svg);
                if (!data2.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                return this.container;
              }
              getElementsToTriggerPopup() {
                return __privateGet(this, _square);
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            _square = new WeakMap();
            class CircleAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
                __privateAdd(this, _circle, null);
              }
              render() {
                this.container.classList.add("circleAnnotation");
                const data2 = this.data;
                const {
                  width,
                  height
                } = getRectDims(data2.rect);
                const svg = this.svgFactory.create(width, height, true);
                const borderWidth = data2.borderStyle.width;
                const circle2 = __privateSet(this, _circle, this.svgFactory.createElement("svg:ellipse"));
                circle2.setAttribute("cx", width / 2);
                circle2.setAttribute("cy", height / 2);
                circle2.setAttribute("rx", width / 2 - borderWidth / 2);
                circle2.setAttribute("ry", height / 2 - borderWidth / 2);
                circle2.setAttribute("stroke-width", borderWidth || 1);
                circle2.setAttribute("stroke", "transparent");
                circle2.setAttribute("fill", "transparent");
                svg.append(circle2);
                this.container.append(svg);
                if (!data2.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                return this.container;
              }
              getElementsToTriggerPopup() {
                return __privateGet(this, _circle);
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            _circle = new WeakMap();
            class PolylineAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
                __privateAdd(this, _polyline, null);
                this.containerClassName = "polylineAnnotation";
                this.svgElementName = "svg:polyline";
              }
              render() {
                this.container.classList.add(this.containerClassName);
                const data2 = this.data;
                const {
                  width,
                  height
                } = getRectDims(data2.rect);
                const svg = this.svgFactory.create(width, height, true);
                let points2 = [];
                for (const coordinate2 of data2.vertices) {
                  const x2 = coordinate2.x - data2.rect[0];
                  const y2 = data2.rect[3] - coordinate2.y;
                  points2.push(x2 + "," + y2);
                }
                points2 = points2.join(" ");
                const polyline = __privateSet(this, _polyline, this.svgFactory.createElement(this.svgElementName));
                polyline.setAttribute("points", points2);
                polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
                polyline.setAttribute("stroke", "transparent");
                polyline.setAttribute("fill", "transparent");
                svg.append(polyline);
                this.container.append(svg);
                if (!data2.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                return this.container;
              }
              getElementsToTriggerPopup() {
                return __privateGet(this, _polyline);
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            _polyline = new WeakMap();
            class PolygonAnnotationElement extends PolylineAnnotationElement {
              constructor(parameters) {
                super(parameters);
                this.containerClassName = "polygonAnnotation";
                this.svgElementName = "svg:polygon";
              }
            }
            class CaretAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
              }
              render() {
                this.container.classList.add("caretAnnotation");
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                return this.container;
              }
            }
            class InkAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
                __privateAdd(this, _polylines, []);
                this.containerClassName = "inkAnnotation";
                this.svgElementName = "svg:polyline";
                this.annotationEditorType = _util2.AnnotationEditorType.INK;
              }
              render() {
                this.container.classList.add(this.containerClassName);
                const data2 = this.data;
                const {
                  width,
                  height
                } = getRectDims(data2.rect);
                const svg = this.svgFactory.create(width, height, true);
                for (const inkList of data2.inkLists) {
                  let points2 = [];
                  for (const coordinate2 of inkList) {
                    const x2 = coordinate2.x - data2.rect[0];
                    const y2 = data2.rect[3] - coordinate2.y;
                    points2.push(`${x2},${y2}`);
                  }
                  points2 = points2.join(" ");
                  const polyline = this.svgFactory.createElement(this.svgElementName);
                  __privateGet(this, _polylines).push(polyline);
                  polyline.setAttribute("points", points2);
                  polyline.setAttribute("stroke-width", data2.borderStyle.width || 1);
                  polyline.setAttribute("stroke", "transparent");
                  polyline.setAttribute("fill", "transparent");
                  if (!data2.popupRef && this.hasPopupData) {
                    this._createPopup();
                  }
                  svg.append(polyline);
                }
                this.container.append(svg);
                return this.container;
              }
              getElementsToTriggerPopup() {
                return __privateGet(this, _polylines);
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            _polylines = new WeakMap();
            exports2.InkAnnotationElement = InkAnnotationElement;
            class HighlightAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true,
                  createQuadrilaterals: true
                });
              }
              render() {
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                this.container.classList.add("highlightAnnotation");
                return this.container;
              }
            }
            class UnderlineAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true,
                  createQuadrilaterals: true
                });
              }
              render() {
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                this.container.classList.add("underlineAnnotation");
                return this.container;
              }
            }
            class SquigglyAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true,
                  createQuadrilaterals: true
                });
              }
              render() {
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                this.container.classList.add("squigglyAnnotation");
                return this.container;
              }
            }
            class StrikeOutAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true,
                  createQuadrilaterals: true
                });
              }
              render() {
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                this.container.classList.add("strikeoutAnnotation");
                return this.container;
              }
            }
            class StampAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                super(parameters, {
                  isRenderable: true,
                  ignoreBorder: true
                });
              }
              render() {
                this.container.classList.add("stampAnnotation");
                if (!this.data.popupRef && this.hasPopupData) {
                  this._createPopup();
                }
                return this.container;
              }
            }
            exports2.StampAnnotationElement = StampAnnotationElement;
            class FileAttachmentAnnotationElement extends AnnotationElement {
              constructor(parameters) {
                var _a3;
                super(parameters, {
                  isRenderable: true
                });
                __privateAdd(this, _download);
                __privateAdd(this, _trigger, null);
                const {
                  filename: filename2,
                  content
                } = this.data.file;
                this.filename = (0, _display_utils2.getFilenameFromUrl)(filename2, true);
                this.content = content;
                (_a3 = this.linkService.eventBus) == null ? void 0 : _a3.dispatch("fileattachmentannotation", {
                  source: this,
                  filename: filename2,
                  content
                });
              }
              render() {
                this.container.classList.add("fileAttachmentAnnotation");
                const {
                  container,
                  data: data2
                } = this;
                let trigger2;
                if (data2.hasAppearance || data2.fillAlpha === 0) {
                  trigger2 = document.createElement("div");
                } else {
                  trigger2 = document.createElement("img");
                  trigger2.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data2.name) ? "paperclip" : "pushpin"}.svg`;
                  if (data2.fillAlpha && data2.fillAlpha < 1) {
                    trigger2.style = `filter: opacity(${Math.round(data2.fillAlpha * 100)}%);`;
                  }
                }
                trigger2.addEventListener("dblclick", __privateMethod(this, _download, download_fn).bind(this));
                __privateSet(this, _trigger, trigger2);
                const {
                  isMac
                } = _util2.FeatureTest.platform;
                container.addEventListener("keydown", (evt) => {
                  if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) {
                    __privateMethod(this, _download, download_fn).call(this);
                  }
                });
                if (!data2.popupRef && this.hasPopupData) {
                  this._createPopup();
                } else {
                  trigger2.classList.add("popupTriggerArea");
                }
                container.append(trigger2);
                return container;
              }
              getElementsToTriggerPopup() {
                return __privateGet(this, _trigger);
              }
              addHighlightArea() {
                this.container.classList.add("highlightArea");
              }
            }
            _trigger = new WeakMap();
            _download = new WeakSet();
            download_fn = function() {
              var _a3;
              (_a3 = this.downloadManager) == null ? void 0 : _a3.openOrDownloadData(this.container, this.content, this.filename);
            };
            class AnnotationLayer2 {
              constructor({
                div,
                accessibilityManager,
                annotationCanvasMap,
                l10n,
                page,
                viewport
              }) {
                __privateAdd(this, _appendElement);
                __privateAdd(this, _setAnnotationCanvasMap);
                __privateAdd(this, _accessibilityManager, null);
                __privateAdd(this, _annotationCanvasMap, null);
                __privateAdd(this, _editableAnnotations, /* @__PURE__ */ new Map());
                this.div = div;
                __privateSet(this, _accessibilityManager, accessibilityManager);
                __privateSet(this, _annotationCanvasMap, annotationCanvasMap);
                this.l10n = l10n;
                this.page = page;
                this.viewport = viewport;
                this.zIndex = 0;
                this.l10n || (this.l10n = _displayL10n_utils.NullL10n);
              }
              async render(params2) {
                const {
                  annotations
                } = params2;
                const layer = this.div;
                (0, _display_utils2.setLayerDimensions)(layer, this.viewport);
                const popupToElements = /* @__PURE__ */ new Map();
                const elementParams = {
                  data: null,
                  layer,
                  linkService: params2.linkService,
                  downloadManager: params2.downloadManager,
                  imageResourcesPath: params2.imageResourcesPath || "",
                  renderForms: params2.renderForms !== false,
                  svgFactory: new _display_utils2.DOMSVGFactory(),
                  annotationStorage: params2.annotationStorage || new _annotation_storage2.AnnotationStorage(),
                  enableScripting: params2.enableScripting === true,
                  hasJSActions: params2.hasJSActions,
                  fieldObjects: params2.fieldObjects,
                  parent: this,
                  elements: null
                };
                for (const data2 of annotations) {
                  if (data2.noHTML) {
                    continue;
                  }
                  const isPopupAnnotation = data2.annotationType === _util2.AnnotationType.POPUP;
                  if (!isPopupAnnotation) {
                    const {
                      width,
                      height
                    } = getRectDims(data2.rect);
                    if (width <= 0 || height <= 0) {
                      continue;
                    }
                  } else {
                    const elements = popupToElements.get(data2.id);
                    if (!elements) {
                      continue;
                    }
                    elementParams.elements = elements;
                  }
                  elementParams.data = data2;
                  const element = AnnotationElementFactory.create(elementParams);
                  if (!element.isRenderable) {
                    continue;
                  }
                  if (!isPopupAnnotation && data2.popupRef) {
                    const elements = popupToElements.get(data2.popupRef);
                    if (!elements) {
                      popupToElements.set(data2.popupRef, [element]);
                    } else {
                      elements.push(element);
                    }
                  }
                  if (element.annotationEditorType > 0) {
                    __privateGet(this, _editableAnnotations).set(element.data.id, element);
                  }
                  const rendered = element.render();
                  if (data2.hidden) {
                    rendered.style.visibility = "hidden";
                  }
                  __privateMethod(this, _appendElement, appendElement_fn).call(this, rendered, data2.id);
                }
                __privateMethod(this, _setAnnotationCanvasMap, setAnnotationCanvasMap_fn).call(this);
                await this.l10n.translate(layer);
              }
              update({
                viewport
              }) {
                const layer = this.div;
                this.viewport = viewport;
                (0, _display_utils2.setLayerDimensions)(layer, {
                  rotation: viewport.rotation
                });
                __privateMethod(this, _setAnnotationCanvasMap, setAnnotationCanvasMap_fn).call(this);
                layer.hidden = false;
              }
              getEditableAnnotations() {
                return Array.from(__privateGet(this, _editableAnnotations).values());
              }
              getEditableAnnotation(id) {
                return __privateGet(this, _editableAnnotations).get(id);
              }
            }
            _accessibilityManager = new WeakMap();
            _annotationCanvasMap = new WeakMap();
            _editableAnnotations = new WeakMap();
            _appendElement = new WeakSet();
            appendElement_fn = function(element, id) {
              var _a3;
              const contentElement = element.firstChild || element;
              contentElement.id = `${_util2.AnnotationPrefix}${id}`;
              this.div.append(element);
              (_a3 = __privateGet(this, _accessibilityManager)) == null ? void 0 : _a3.moveElementInDOM(this.div, element, contentElement, false);
            };
            _setAnnotationCanvasMap = new WeakSet();
            setAnnotationCanvasMap_fn = function() {
              if (!__privateGet(this, _annotationCanvasMap)) {
                return;
              }
              const layer = this.div;
              for (const [id, canvas2] of __privateGet(this, _annotationCanvasMap)) {
                const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                if (!element) {
                  continue;
                }
                const {
                  firstChild
                } = element;
                if (!firstChild) {
                  element.append(canvas2);
                } else if (firstChild.nodeName === "CANVAS") {
                  firstChild.replaceWith(canvas2);
                } else {
                  firstChild.before(canvas2);
                }
              }
              __privateGet(this, _annotationCanvasMap).clear();
            };
            exports2.AnnotationLayer = AnnotationLayer2;
          },
          /* 30 */
          /***/
          (__unused_webpack_module2, exports2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.ColorConverters = void 0;
            function makeColorComp(n2) {
              return Math.floor(Math.max(0, Math.min(1, n2)) * 255).toString(16).padStart(2, "0");
            }
            function scaleAndClamp(x2) {
              return Math.max(0, Math.min(255, 255 * x2));
            }
            class ColorConverters {
              static CMYK_G([c2, y2, m2, k2]) {
                return ["G", 1 - Math.min(1, 0.3 * c2 + 0.59 * m2 + 0.11 * y2 + k2)];
              }
              static G_CMYK([g2]) {
                return ["CMYK", 0, 0, 0, 1 - g2];
              }
              static G_RGB([g2]) {
                return ["RGB", g2, g2, g2];
              }
              static G_rgb([g2]) {
                g2 = scaleAndClamp(g2);
                return [g2, g2, g2];
              }
              static G_HTML([g2]) {
                const G2 = makeColorComp(g2);
                return `#${G2}${G2}${G2}`;
              }
              static RGB_G([r2, g2, b2]) {
                return ["G", 0.3 * r2 + 0.59 * g2 + 0.11 * b2];
              }
              static RGB_rgb(color) {
                return color.map(scaleAndClamp);
              }
              static RGB_HTML(color) {
                return `#${color.map(makeColorComp).join("")}`;
              }
              static T_HTML() {
                return "#00000000";
              }
              static T_rgb() {
                return [null];
              }
              static CMYK_RGB([c2, y2, m2, k2]) {
                return ["RGB", 1 - Math.min(1, c2 + k2), 1 - Math.min(1, m2 + k2), 1 - Math.min(1, y2 + k2)];
              }
              static CMYK_rgb([c2, y2, m2, k2]) {
                return [scaleAndClamp(1 - Math.min(1, c2 + k2)), scaleAndClamp(1 - Math.min(1, m2 + k2)), scaleAndClamp(1 - Math.min(1, y2 + k2))];
              }
              static CMYK_HTML(components) {
                const rgb = this.CMYK_RGB(components).slice(1);
                return this.RGB_HTML(rgb);
              }
              static RGB_CMYK([r2, g2, b2]) {
                const c2 = 1 - r2;
                const m2 = 1 - g2;
                const y2 = 1 - b2;
                const k2 = Math.min(c2, m2, y2);
                return ["CMYK", c2, m2, y2, k2];
              }
            }
            exports2.ColorConverters = ColorConverters;
          },
          /* 31 */
          /***/
          (__unused_webpack_module2, exports2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.NullL10n = void 0;
            exports2.getL10nFallback = getL10nFallback;
            const DEFAULT_L10N_STRINGS = {
              of_pages: "of {{pagesCount}}",
              page_of_pages: "({{pageNumber}} of {{pagesCount}})",
              document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
              document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
              document_properties_date_string: "{{date}}, {{time}}",
              document_properties_page_size_unit_inches: "in",
              document_properties_page_size_unit_millimeters: "mm",
              document_properties_page_size_orientation_portrait: "portrait",
              document_properties_page_size_orientation_landscape: "landscape",
              document_properties_page_size_name_a3: "A3",
              document_properties_page_size_name_a4: "A4",
              document_properties_page_size_name_letter: "Letter",
              document_properties_page_size_name_legal: "Legal",
              document_properties_page_size_dimension_string: "{{width}} × {{height}} {{unit}} ({{orientation}})",
              document_properties_page_size_dimension_name_string: "{{width}} × {{height}} {{unit}} ({{name}}, {{orientation}})",
              document_properties_linearized_yes: "Yes",
              document_properties_linearized_no: "No",
              additional_layers: "Additional Layers",
              page_landmark: "Page {{page}}",
              thumb_page_title: "Page {{page}}",
              thumb_page_canvas: "Thumbnail of Page {{page}}",
              find_reached_top: "Reached top of document, continued from bottom",
              find_reached_bottom: "Reached end of document, continued from top",
              "find_match_count[one]": "{{current}} of {{total}} match",
              "find_match_count[other]": "{{current}} of {{total}} matches",
              "find_match_count_limit[one]": "More than {{limit}} match",
              "find_match_count_limit[other]": "More than {{limit}} matches",
              find_not_found: "Phrase not found",
              page_scale_width: "Page Width",
              page_scale_fit: "Page Fit",
              page_scale_auto: "Automatic Zoom",
              page_scale_actual: "Actual Size",
              page_scale_percent: "{{scale}}%",
              loading_error: "An error occurred while loading the PDF.",
              invalid_file_error: "Invalid or corrupted PDF file.",
              missing_file_error: "Missing PDF file.",
              unexpected_response_error: "Unexpected server response.",
              rendering_error: "An error occurred while rendering the page.",
              annotation_date_string: "{{date}}, {{time}}",
              printing_not_supported: "Warning: Printing is not fully supported by this browser.",
              printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
              web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
              free_text2_default_content: "Start typing…",
              editor_free_text2_aria_label: "Text Editor",
              editor_ink2_aria_label: "Draw Editor",
              editor_ink_canvas_aria_label: "User-created image",
              editor_alt_text_button_label: "Alt text",
              editor_alt_text_edit_button_label: "Edit alt text",
              editor_alt_text_decorative_tooltip: "Marked as decorative"
            };
            {
              DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
            }
            function getL10nFallback(key, args) {
              switch (key) {
                case "find_match_count":
                  key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                  break;
                case "find_match_count_limit":
                  key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                  break;
              }
              return DEFAULT_L10N_STRINGS[key] || "";
            }
            function formatL10nValue(text, args) {
              if (!args) {
                return text;
              }
              return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name2) => {
                return name2 in args ? args[name2] : "{{" + name2 + "}}";
              });
            }
            const NullL10n = {
              async getLanguage() {
                return "en-us";
              },
              async getDirection() {
                return "ltr";
              },
              async get(key, args = null, fallback = getL10nFallback(key, args)) {
                return formatL10nValue(fallback, args);
              },
              async translate(element) {
              }
            };
            exports2.NullL10n = NullL10n;
          },
          /* 32 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.XfaLayer = void 0;
            var _xfa_text2 = __w_pdfjs_require__2(25);
            class XfaLayer {
              static setupStorage(html, id, element, storage, intent) {
                const storedData = storage.getValue(id, {
                  value: null
                });
                switch (element.name) {
                  case "textarea":
                    if (storedData.value !== null) {
                      html.textContent = storedData.value;
                    }
                    if (intent === "print") {
                      break;
                    }
                    html.addEventListener("input", (event) => {
                      storage.setValue(id, {
                        value: event.target.value
                      });
                    });
                    break;
                  case "input":
                    if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                      if (storedData.value === element.attributes.xfaOn) {
                        html.setAttribute("checked", true);
                      } else if (storedData.value === element.attributes.xfaOff) {
                        html.removeAttribute("checked");
                      }
                      if (intent === "print") {
                        break;
                      }
                      html.addEventListener("change", (event) => {
                        storage.setValue(id, {
                          value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                      });
                    } else {
                      if (storedData.value !== null) {
                        html.setAttribute("value", storedData.value);
                      }
                      if (intent === "print") {
                        break;
                      }
                      html.addEventListener("input", (event) => {
                        storage.setValue(id, {
                          value: event.target.value
                        });
                      });
                    }
                    break;
                  case "select":
                    if (storedData.value !== null) {
                      html.setAttribute("value", storedData.value);
                      for (const option of element.children) {
                        if (option.attributes.value === storedData.value) {
                          option.attributes.selected = true;
                        } else if (option.attributes.hasOwnProperty("selected")) {
                          delete option.attributes.selected;
                        }
                      }
                    }
                    html.addEventListener("input", (event) => {
                      const options2 = event.target.options;
                      const value = options2.selectedIndex === -1 ? "" : options2[options2.selectedIndex].value;
                      storage.setValue(id, {
                        value
                      });
                    });
                    break;
                }
              }
              static setAttributes({
                html,
                element,
                storage = null,
                intent,
                linkService
              }) {
                const {
                  attributes
                } = element;
                const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                if (attributes.type === "radio") {
                  attributes.name = `${attributes.name}-${intent}`;
                }
                for (const [key, value] of Object.entries(attributes)) {
                  if (value === null || value === void 0) {
                    continue;
                  }
                  switch (key) {
                    case "class":
                      if (value.length) {
                        html.setAttribute(key, value.join(" "));
                      }
                      break;
                    case "dataId":
                      break;
                    case "id":
                      html.setAttribute("data-element-id", value);
                      break;
                    case "style":
                      Object.assign(html.style, value);
                      break;
                    case "textContent":
                      html.textContent = value;
                      break;
                    default:
                      if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") {
                        html.setAttribute(key, value);
                      }
                  }
                }
                if (isHTMLAnchorElement) {
                  linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                }
                if (storage && attributes.dataId) {
                  this.setupStorage(html, attributes.dataId, element, storage);
                }
              }
              static render(parameters) {
                var _a3;
                const storage = parameters.annotationStorage;
                const linkService = parameters.linkService;
                const root2 = parameters.xfaHtml;
                const intent = parameters.intent || "display";
                const rootHtml = document.createElement(root2.name);
                if (root2.attributes) {
                  this.setAttributes({
                    html: rootHtml,
                    element: root2,
                    intent,
                    linkService
                  });
                }
                const stack2 = [[root2, -1, rootHtml]];
                const rootDiv = parameters.div;
                rootDiv.append(rootHtml);
                if (parameters.viewport) {
                  const transform4 = `matrix(${parameters.viewport.transform.join(",")})`;
                  rootDiv.style.transform = transform4;
                }
                if (intent !== "richText") {
                  rootDiv.setAttribute("class", "xfaLayer xfaFont");
                }
                const textDivs = [];
                while (stack2.length > 0) {
                  const [parent, i2, html] = stack2.at(-1);
                  if (i2 + 1 === parent.children.length) {
                    stack2.pop();
                    continue;
                  }
                  const child = parent.children[++stack2.at(-1)[1]];
                  if (child === null) {
                    continue;
                  }
                  const {
                    name: name2
                  } = child;
                  if (name2 === "#text") {
                    const node = document.createTextNode(child.value);
                    textDivs.push(node);
                    html.append(node);
                    continue;
                  }
                  const childHtml = ((_a3 = child == null ? void 0 : child.attributes) == null ? void 0 : _a3.xmlns) ? document.createElementNS(child.attributes.xmlns, name2) : document.createElement(name2);
                  html.append(childHtml);
                  if (child.attributes) {
                    this.setAttributes({
                      html: childHtml,
                      element: child,
                      storage,
                      intent,
                      linkService
                    });
                  }
                  if (child.children && child.children.length > 0) {
                    stack2.push([child, -1, childHtml]);
                  } else if (child.value) {
                    const node = document.createTextNode(child.value);
                    if (_xfa_text2.XfaText.shouldBuildText(name2)) {
                      textDivs.push(node);
                    }
                    childHtml.append(node);
                  }
                }
                for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")) {
                  el.setAttribute("readOnly", true);
                }
                return {
                  textDivs
                };
              }
              static update(parameters) {
                const transform4 = `matrix(${parameters.viewport.transform.join(",")})`;
                parameters.div.style.transform = transform4;
                parameters.div.hidden = false;
              }
            }
            exports2.XfaLayer = XfaLayer;
          },
          /* 33 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _baseHeight, _baseWidth, _boundCanvasPointermove, _boundCanvasPointerleave, _boundCanvasPointerup, _boundCanvasPointerdown, _currentPath2D, _disableEditing, _hasSomethingToDraw, _isCanvasInitialized, _observer, _realWidth, _realHeight, _requestFrameCallback, _updateThickness, updateThickness_fn, _updateColor, updateColor_fn, _updateOpacity, updateOpacity_fn, _getInitialBBox, getInitialBBox_fn, _setStroke, setStroke_fn, _startDrawing, startDrawing_fn, _draw, draw_fn, _endPath, endPath_fn, _stopDrawing, stopDrawing_fn, _drawPoints, drawPoints_fn, _makeBezierCurve, makeBezierCurve_fn, _generateBezierPoints, generateBezierPoints_fn, _redraw, redraw_fn, _endDrawing, endDrawing_fn, _createCanvas, createCanvas_fn, _createObserver, createObserver_fn, _setCanvasDims, setCanvasDims_fn, _setScaleFactor, setScaleFactor_fn, _updateTransform, updateTransform_fn, _buildPath2D, buildPath2D_fn, _toPDFCoordinates, toPDFCoordinates_fn, _fromPDFCoordinates, fromPDFCoordinates_fn, _serializePaths, serializePaths_fn, _getBbox, getBbox_fn, _getPadding, getPadding_fn, _fitToContent, fitToContent_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.InkEditor = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _editor = __w_pdfjs_require__2(4);
            var _annotation_layer = __w_pdfjs_require__2(29);
            var _display_utils2 = __w_pdfjs_require__2(6);
            var _tools = __w_pdfjs_require__2(5);
            const _InkEditor = class extends _editor.AnnotationEditor {
              constructor(params2) {
                super({
                  ...params2,
                  name: "inkEditor"
                });
                __privateAdd(this, _updateThickness);
                __privateAdd(this, _updateColor);
                __privateAdd(this, _updateOpacity);
                __privateAdd(this, _getInitialBBox);
                __privateAdd(this, _setStroke);
                __privateAdd(this, _startDrawing);
                __privateAdd(this, _draw);
                __privateAdd(this, _endPath);
                __privateAdd(this, _stopDrawing);
                __privateAdd(this, _drawPoints);
                __privateAdd(this, _makeBezierCurve);
                __privateAdd(this, _generateBezierPoints);
                __privateAdd(this, _redraw);
                __privateAdd(this, _endDrawing);
                __privateAdd(this, _createCanvas);
                __privateAdd(this, _createObserver);
                __privateAdd(this, _setCanvasDims);
                __privateAdd(this, _setScaleFactor);
                __privateAdd(this, _updateTransform);
                __privateAdd(this, _serializePaths);
                __privateAdd(this, _getBbox);
                __privateAdd(this, _getPadding);
                __privateAdd(this, _fitToContent);
                __privateAdd(this, _baseHeight, 0);
                __privateAdd(this, _baseWidth, 0);
                __privateAdd(this, _boundCanvasPointermove, this.canvasPointermove.bind(this));
                __privateAdd(this, _boundCanvasPointerleave, this.canvasPointerleave.bind(this));
                __privateAdd(this, _boundCanvasPointerup, this.canvasPointerup.bind(this));
                __privateAdd(this, _boundCanvasPointerdown, this.canvasPointerdown.bind(this));
                __privateAdd(this, _currentPath2D, new Path2D());
                __privateAdd(this, _disableEditing, false);
                __privateAdd(this, _hasSomethingToDraw, false);
                __privateAdd(this, _isCanvasInitialized, false);
                __privateAdd(this, _observer, null);
                __privateAdd(this, _realWidth, 0);
                __privateAdd(this, _realHeight, 0);
                __privateAdd(this, _requestFrameCallback, null);
                this.color = params2.color || null;
                this.thickness = params2.thickness || null;
                this.opacity = params2.opacity || null;
                this.paths = [];
                this.bezierPath2D = [];
                this.allRawPaths = [];
                this.currentPath = [];
                this.scaleFactor = 1;
                this.translationX = this.translationY = 0;
                this.x = 0;
                this.y = 0;
                this._willKeepAspectRatio = true;
              }
              static initialize(l10n) {
                _editor.AnnotationEditor.initialize(l10n, {
                  strings: ["editor_ink_canvas_aria_label", "editor_ink2_aria_label"]
                });
              }
              static updateDefaultParams(type, value) {
                switch (type) {
                  case _util2.AnnotationEditorParamsType.INK_THICKNESS:
                    _InkEditor._defaultThickness = value;
                    break;
                  case _util2.AnnotationEditorParamsType.INK_COLOR:
                    _InkEditor._defaultColor = value;
                    break;
                  case _util2.AnnotationEditorParamsType.INK_OPACITY:
                    _InkEditor._defaultOpacity = value / 100;
                    break;
                }
              }
              updateParams(type, value) {
                switch (type) {
                  case _util2.AnnotationEditorParamsType.INK_THICKNESS:
                    __privateMethod(this, _updateThickness, updateThickness_fn).call(this, value);
                    break;
                  case _util2.AnnotationEditorParamsType.INK_COLOR:
                    __privateMethod(this, _updateColor, updateColor_fn).call(this, value);
                    break;
                  case _util2.AnnotationEditorParamsType.INK_OPACITY:
                    __privateMethod(this, _updateOpacity, updateOpacity_fn).call(this, value);
                    break;
                }
              }
              static get defaultPropertiesToUpdate() {
                return [[_util2.AnnotationEditorParamsType.INK_THICKNESS, _InkEditor._defaultThickness], [_util2.AnnotationEditorParamsType.INK_COLOR, _InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util2.AnnotationEditorParamsType.INK_OPACITY, Math.round(_InkEditor._defaultOpacity * 100)]];
              }
              get propertiesToUpdate() {
                return [[_util2.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || _InkEditor._defaultThickness], [_util2.AnnotationEditorParamsType.INK_COLOR, this.color || _InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util2.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? _InkEditor._defaultOpacity))]];
              }
              rebuild() {
                if (!this.parent) {
                  return;
                }
                super.rebuild();
                if (this.div === null) {
                  return;
                }
                if (!this.canvas) {
                  __privateMethod(this, _createCanvas, createCanvas_fn).call(this);
                  __privateMethod(this, _createObserver, createObserver_fn).call(this);
                }
                if (!this.isAttachedToDOM) {
                  this.parent.add(this);
                  __privateMethod(this, _setCanvasDims, setCanvasDims_fn).call(this);
                }
                __privateMethod(this, _fitToContent, fitToContent_fn).call(this);
              }
              remove() {
                if (this.canvas === null) {
                  return;
                }
                if (!this.isEmpty()) {
                  this.commit();
                }
                this.canvas.width = this.canvas.height = 0;
                this.canvas.remove();
                this.canvas = null;
                __privateGet(this, _observer).disconnect();
                __privateSet(this, _observer, null);
                super.remove();
              }
              setParent(parent) {
                if (!this.parent && parent) {
                  this._uiManager.removeShouldRescale(this);
                } else if (this.parent && parent === null) {
                  this._uiManager.addShouldRescale(this);
                }
                super.setParent(parent);
              }
              onScaleChanging() {
                const [parentWidth, parentHeight] = this.parentDimensions;
                const width = this.width * parentWidth;
                const height = this.height * parentHeight;
                this.setDimensions(width, height);
              }
              enableEditMode() {
                if (__privateGet(this, _disableEditing) || this.canvas === null) {
                  return;
                }
                super.enableEditMode();
                this._isDraggable = false;
                this.canvas.addEventListener("pointerdown", __privateGet(this, _boundCanvasPointerdown));
              }
              disableEditMode() {
                if (!this.isInEditMode() || this.canvas === null) {
                  return;
                }
                super.disableEditMode();
                this._isDraggable = !this.isEmpty();
                this.div.classList.remove("editing");
                this.canvas.removeEventListener("pointerdown", __privateGet(this, _boundCanvasPointerdown));
              }
              onceAdded() {
                this._isDraggable = !this.isEmpty();
              }
              isEmpty() {
                return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
              }
              commit() {
                if (__privateGet(this, _disableEditing)) {
                  return;
                }
                super.commit();
                this.isEditing = false;
                this.disableEditMode();
                this.setInForeground();
                __privateSet(this, _disableEditing, true);
                this.div.classList.add("disabled");
                __privateMethod(this, _fitToContent, fitToContent_fn).call(this, true);
                this.makeResizable();
                this.parent.addInkEditorIfNeeded(true);
                this.moveInDOM();
                this.div.focus({
                  preventScroll: true
                });
              }
              focusin(event) {
                if (!this._focusEventsAllowed) {
                  return;
                }
                super.focusin(event);
                this.enableEditMode();
              }
              canvasPointerdown(event) {
                if (event.button !== 0 || !this.isInEditMode() || __privateGet(this, _disableEditing)) {
                  return;
                }
                this.setInForeground();
                event.preventDefault();
                if (event.type !== "mouse") {
                  this.div.focus();
                }
                __privateMethod(this, _startDrawing, startDrawing_fn).call(this, event.offsetX, event.offsetY);
              }
              canvasPointermove(event) {
                event.preventDefault();
                __privateMethod(this, _draw, draw_fn).call(this, event.offsetX, event.offsetY);
              }
              canvasPointerup(event) {
                event.preventDefault();
                __privateMethod(this, _endDrawing, endDrawing_fn).call(this, event);
              }
              canvasPointerleave(event) {
                __privateMethod(this, _endDrawing, endDrawing_fn).call(this, event);
              }
              get isResizable() {
                return !this.isEmpty() && __privateGet(this, _disableEditing);
              }
              render() {
                if (this.div) {
                  return this.div;
                }
                let baseX, baseY;
                if (this.width) {
                  baseX = this.x;
                  baseY = this.y;
                }
                super.render();
                _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg2) => {
                  var _a3;
                  return (_a3 = this.div) == null ? void 0 : _a3.setAttribute("aria-label", msg2);
                });
                const [x2, y2, w2, h2] = __privateMethod(this, _getInitialBBox, getInitialBBox_fn).call(this);
                this.setAt(x2, y2, 0, 0);
                this.setDims(w2, h2);
                __privateMethod(this, _createCanvas, createCanvas_fn).call(this);
                if (this.width) {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                  this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                  __privateSet(this, _isCanvasInitialized, true);
                  __privateMethod(this, _setCanvasDims, setCanvasDims_fn).call(this);
                  this.setDims(this.width * parentWidth, this.height * parentHeight);
                  __privateMethod(this, _redraw, redraw_fn).call(this);
                  this.div.classList.add("disabled");
                } else {
                  this.div.classList.add("editing");
                  this.enableEditMode();
                }
                __privateMethod(this, _createObserver, createObserver_fn).call(this);
                return this.div;
              }
              setDimensions(width, height) {
                const roundedWidth = Math.round(width);
                const roundedHeight = Math.round(height);
                if (__privateGet(this, _realWidth) === roundedWidth && __privateGet(this, _realHeight) === roundedHeight) {
                  return;
                }
                __privateSet(this, _realWidth, roundedWidth);
                __privateSet(this, _realHeight, roundedHeight);
                this.canvas.style.visibility = "hidden";
                const [parentWidth, parentHeight] = this.parentDimensions;
                this.width = width / parentWidth;
                this.height = height / parentHeight;
                this.fixAndSetPosition();
                if (__privateGet(this, _disableEditing)) {
                  __privateMethod(this, _setScaleFactor, setScaleFactor_fn).call(this, width, height);
                }
                __privateMethod(this, _setCanvasDims, setCanvasDims_fn).call(this);
                __privateMethod(this, _redraw, redraw_fn).call(this);
                this.canvas.style.visibility = "visible";
                this.fixDims();
              }
              static deserialize(data2, parent, uiManager) {
                var _a3, _b3, _c2;
                if (data2 instanceof _annotation_layer.InkAnnotationElement) {
                  return null;
                }
                const editor = super.deserialize(data2, parent, uiManager);
                editor.thickness = data2.thickness;
                editor.color = _util2.Util.makeHexColor(...data2.color);
                editor.opacity = data2.opacity;
                const [pageWidth, pageHeight] = editor.pageDimensions;
                const width = editor.width * pageWidth;
                const height = editor.height * pageHeight;
                const scaleFactor = editor.parentScale;
                const padding = data2.thickness / 2;
                __privateSet(editor, _disableEditing, true);
                __privateSet(editor, _realWidth, Math.round(width));
                __privateSet(editor, _realHeight, Math.round(height));
                const {
                  paths,
                  rect,
                  rotation
                } = data2;
                for (let {
                  bezier
                } of paths) {
                  bezier = __privateMethod(_a3 = _InkEditor, _fromPDFCoordinates, fromPDFCoordinates_fn).call(_a3, bezier, rect, rotation);
                  const path2 = [];
                  editor.paths.push(path2);
                  let p0 = scaleFactor * (bezier[0] - padding);
                  let p1 = scaleFactor * (bezier[1] - padding);
                  for (let i2 = 2, ii2 = bezier.length; i2 < ii2; i2 += 6) {
                    const p10 = scaleFactor * (bezier[i2] - padding);
                    const p11 = scaleFactor * (bezier[i2 + 1] - padding);
                    const p20 = scaleFactor * (bezier[i2 + 2] - padding);
                    const p21 = scaleFactor * (bezier[i2 + 3] - padding);
                    const p30 = scaleFactor * (bezier[i2 + 4] - padding);
                    const p31 = scaleFactor * (bezier[i2 + 5] - padding);
                    path2.push([[p0, p1], [p10, p11], [p20, p21], [p30, p31]]);
                    p0 = p30;
                    p1 = p31;
                  }
                  const path2D = __privateMethod(this, _buildPath2D, buildPath2D_fn).call(this, path2);
                  editor.bezierPath2D.push(path2D);
                }
                const bbox2 = __privateMethod(_b3 = editor, _getBbox, getBbox_fn).call(_b3);
                __privateSet(editor, _baseWidth, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox2[2] - bbox2[0]));
                __privateSet(editor, _baseHeight, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox2[3] - bbox2[1]));
                __privateMethod(_c2 = editor, _setScaleFactor, setScaleFactor_fn).call(_c2, width, height);
                return editor;
              }
              serialize() {
                if (this.isEmpty()) {
                  return null;
                }
                const rect = this.getRect(0, 0);
                const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                return {
                  annotationType: _util2.AnnotationEditorType.INK,
                  color,
                  thickness: this.thickness,
                  opacity: this.opacity,
                  paths: __privateMethod(this, _serializePaths, serializePaths_fn).call(this, this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                  pageIndex: this.pageIndex,
                  rect,
                  rotation: this.rotation,
                  structTreeParentId: this._structTreeParentId
                };
              }
            };
            let InkEditor = _InkEditor;
            _baseHeight = new WeakMap();
            _baseWidth = new WeakMap();
            _boundCanvasPointermove = new WeakMap();
            _boundCanvasPointerleave = new WeakMap();
            _boundCanvasPointerup = new WeakMap();
            _boundCanvasPointerdown = new WeakMap();
            _currentPath2D = new WeakMap();
            _disableEditing = new WeakMap();
            _hasSomethingToDraw = new WeakMap();
            _isCanvasInitialized = new WeakMap();
            _observer = new WeakMap();
            _realWidth = new WeakMap();
            _realHeight = new WeakMap();
            _requestFrameCallback = new WeakMap();
            _updateThickness = new WeakSet();
            updateThickness_fn = function(thickness) {
              const savedThickness = this.thickness;
              this.addCommands({
                cmd: () => {
                  this.thickness = thickness;
                  __privateMethod(this, _fitToContent, fitToContent_fn).call(this);
                },
                undo: () => {
                  this.thickness = savedThickness;
                  __privateMethod(this, _fitToContent, fitToContent_fn).call(this);
                },
                mustExec: true,
                type: _util2.AnnotationEditorParamsType.INK_THICKNESS,
                overwriteIfSameType: true,
                keepUndo: true
              });
            };
            _updateColor = new WeakSet();
            updateColor_fn = function(color) {
              const savedColor = this.color;
              this.addCommands({
                cmd: () => {
                  this.color = color;
                  __privateMethod(this, _redraw, redraw_fn).call(this);
                },
                undo: () => {
                  this.color = savedColor;
                  __privateMethod(this, _redraw, redraw_fn).call(this);
                },
                mustExec: true,
                type: _util2.AnnotationEditorParamsType.INK_COLOR,
                overwriteIfSameType: true,
                keepUndo: true
              });
            };
            _updateOpacity = new WeakSet();
            updateOpacity_fn = function(opacity) {
              opacity /= 100;
              const savedOpacity = this.opacity;
              this.addCommands({
                cmd: () => {
                  this.opacity = opacity;
                  __privateMethod(this, _redraw, redraw_fn).call(this);
                },
                undo: () => {
                  this.opacity = savedOpacity;
                  __privateMethod(this, _redraw, redraw_fn).call(this);
                },
                mustExec: true,
                type: _util2.AnnotationEditorParamsType.INK_OPACITY,
                overwriteIfSameType: true,
                keepUndo: true
              });
            };
            _getInitialBBox = new WeakSet();
            getInitialBBox_fn = function() {
              const {
                parentRotation,
                parentDimensions: [width, height]
              } = this;
              switch (parentRotation) {
                case 90:
                  return [0, height, height, width];
                case 180:
                  return [width, height, width, height];
                case 270:
                  return [width, 0, height, width];
                default:
                  return [0, 0, width, height];
              }
            };
            _setStroke = new WeakSet();
            setStroke_fn = function() {
              const {
                ctx: ctx2,
                color,
                opacity,
                thickness,
                parentScale,
                scaleFactor
              } = this;
              ctx2.lineWidth = thickness * parentScale / scaleFactor;
              ctx2.lineCap = "round";
              ctx2.lineJoin = "round";
              ctx2.miterLimit = 10;
              ctx2.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
            };
            _startDrawing = new WeakSet();
            startDrawing_fn = function(x2, y2) {
              this.canvas.addEventListener("contextmenu", _display_utils2.noContextMenu);
              this.canvas.addEventListener("pointerleave", __privateGet(this, _boundCanvasPointerleave));
              this.canvas.addEventListener("pointermove", __privateGet(this, _boundCanvasPointermove));
              this.canvas.addEventListener("pointerup", __privateGet(this, _boundCanvasPointerup));
              this.canvas.removeEventListener("pointerdown", __privateGet(this, _boundCanvasPointerdown));
              this.isEditing = true;
              if (!__privateGet(this, _isCanvasInitialized)) {
                __privateSet(this, _isCanvasInitialized, true);
                __privateMethod(this, _setCanvasDims, setCanvasDims_fn).call(this);
                this.thickness || (this.thickness = _InkEditor._defaultThickness);
                this.color || (this.color = _InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor);
                this.opacity ?? (this.opacity = _InkEditor._defaultOpacity);
              }
              this.currentPath.push([x2, y2]);
              __privateSet(this, _hasSomethingToDraw, false);
              __privateMethod(this, _setStroke, setStroke_fn).call(this);
              __privateSet(this, _requestFrameCallback, () => {
                __privateMethod(this, _drawPoints, drawPoints_fn).call(this);
                if (__privateGet(this, _requestFrameCallback)) {
                  window.requestAnimationFrame(__privateGet(this, _requestFrameCallback));
                }
              });
              window.requestAnimationFrame(__privateGet(this, _requestFrameCallback));
            };
            _draw = new WeakSet();
            draw_fn = function(x2, y2) {
              const [lastX, lastY] = this.currentPath.at(-1);
              if (this.currentPath.length > 1 && x2 === lastX && y2 === lastY) {
                return;
              }
              const currentPath = this.currentPath;
              let path2D = __privateGet(this, _currentPath2D);
              currentPath.push([x2, y2]);
              __privateSet(this, _hasSomethingToDraw, true);
              if (currentPath.length <= 2) {
                path2D.moveTo(...currentPath[0]);
                path2D.lineTo(x2, y2);
                return;
              }
              if (currentPath.length === 3) {
                __privateSet(this, _currentPath2D, path2D = new Path2D());
                path2D.moveTo(...currentPath[0]);
              }
              __privateMethod(this, _makeBezierCurve, makeBezierCurve_fn).call(this, path2D, ...currentPath.at(-3), ...currentPath.at(-2), x2, y2);
            };
            _endPath = new WeakSet();
            endPath_fn = function() {
              if (this.currentPath.length === 0) {
                return;
              }
              const lastPoint = this.currentPath.at(-1);
              __privateGet(this, _currentPath2D).lineTo(...lastPoint);
            };
            _stopDrawing = new WeakSet();
            stopDrawing_fn = function(x2, y2) {
              __privateSet(this, _requestFrameCallback, null);
              x2 = Math.min(Math.max(x2, 0), this.canvas.width);
              y2 = Math.min(Math.max(y2, 0), this.canvas.height);
              __privateMethod(this, _draw, draw_fn).call(this, x2, y2);
              __privateMethod(this, _endPath, endPath_fn).call(this);
              let bezier;
              if (this.currentPath.length !== 1) {
                bezier = __privateMethod(this, _generateBezierPoints, generateBezierPoints_fn).call(this);
              } else {
                const xy = [x2, y2];
                bezier = [[xy, xy.slice(), xy.slice(), xy]];
              }
              const path2D = __privateGet(this, _currentPath2D);
              const currentPath = this.currentPath;
              this.currentPath = [];
              __privateSet(this, _currentPath2D, new Path2D());
              const cmd2 = () => {
                this.allRawPaths.push(currentPath);
                this.paths.push(bezier);
                this.bezierPath2D.push(path2D);
                this.rebuild();
              };
              const undo = () => {
                this.allRawPaths.pop();
                this.paths.pop();
                this.bezierPath2D.pop();
                if (this.paths.length === 0) {
                  this.remove();
                } else {
                  if (!this.canvas) {
                    __privateMethod(this, _createCanvas, createCanvas_fn).call(this);
                    __privateMethod(this, _createObserver, createObserver_fn).call(this);
                  }
                  __privateMethod(this, _fitToContent, fitToContent_fn).call(this);
                }
              };
              this.addCommands({
                cmd: cmd2,
                undo,
                mustExec: true
              });
            };
            _drawPoints = new WeakSet();
            drawPoints_fn = function() {
              if (!__privateGet(this, _hasSomethingToDraw)) {
                return;
              }
              __privateSet(this, _hasSomethingToDraw, false);
              const thickness = Math.ceil(this.thickness * this.parentScale);
              const lastPoints = this.currentPath.slice(-3);
              const x2 = lastPoints.map((xy) => xy[0]);
              const y2 = lastPoints.map((xy) => xy[1]);
              Math.min(...x2) - thickness;
              Math.max(...x2) + thickness;
              Math.min(...y2) - thickness;
              Math.max(...y2) + thickness;
              const {
                ctx: ctx2
              } = this;
              ctx2.save();
              ctx2.clearRect(0, 0, this.canvas.width, this.canvas.height);
              for (const path2 of this.bezierPath2D) {
                ctx2.stroke(path2);
              }
              ctx2.stroke(__privateGet(this, _currentPath2D));
              ctx2.restore();
            };
            _makeBezierCurve = new WeakSet();
            makeBezierCurve_fn = function(path2D, x02, y02, x12, y12, x2, y2) {
              const prevX = (x02 + x12) / 2;
              const prevY = (y02 + y12) / 2;
              const x3 = (x12 + x2) / 2;
              const y3 = (y12 + y2) / 2;
              path2D.bezierCurveTo(prevX + 2 * (x12 - prevX) / 3, prevY + 2 * (y12 - prevY) / 3, x3 + 2 * (x12 - x3) / 3, y3 + 2 * (y12 - y3) / 3, x3, y3);
            };
            _generateBezierPoints = new WeakSet();
            generateBezierPoints_fn = function() {
              const path2 = this.currentPath;
              if (path2.length <= 2) {
                return [[path2[0], path2[0], path2.at(-1), path2.at(-1)]];
              }
              const bezierPoints = [];
              let i2;
              let [x02, y02] = path2[0];
              for (i2 = 1; i2 < path2.length - 2; i2++) {
                const [x13, y13] = path2[i2];
                const [x22, y22] = path2[i2 + 1];
                const x3 = (x13 + x22) / 2;
                const y3 = (y13 + y22) / 2;
                const control12 = [x02 + 2 * (x13 - x02) / 3, y02 + 2 * (y13 - y02) / 3];
                const control22 = [x3 + 2 * (x13 - x3) / 3, y3 + 2 * (y13 - y3) / 3];
                bezierPoints.push([[x02, y02], control12, control22, [x3, y3]]);
                [x02, y02] = [x3, y3];
              }
              const [x12, y12] = path2[i2];
              const [x2, y2] = path2[i2 + 1];
              const control1 = [x02 + 2 * (x12 - x02) / 3, y02 + 2 * (y12 - y02) / 3];
              const control2 = [x2 + 2 * (x12 - x2) / 3, y2 + 2 * (y12 - y2) / 3];
              bezierPoints.push([[x02, y02], control1, control2, [x2, y2]]);
              return bezierPoints;
            };
            _redraw = new WeakSet();
            redraw_fn = function() {
              if (this.isEmpty()) {
                __privateMethod(this, _updateTransform, updateTransform_fn).call(this);
                return;
              }
              __privateMethod(this, _setStroke, setStroke_fn).call(this);
              const {
                canvas: canvas2,
                ctx: ctx2
              } = this;
              ctx2.setTransform(1, 0, 0, 1, 0, 0);
              ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
              __privateMethod(this, _updateTransform, updateTransform_fn).call(this);
              for (const path2 of this.bezierPath2D) {
                ctx2.stroke(path2);
              }
            };
            _endDrawing = new WeakSet();
            endDrawing_fn = function(event) {
              this.canvas.removeEventListener("pointerleave", __privateGet(this, _boundCanvasPointerleave));
              this.canvas.removeEventListener("pointermove", __privateGet(this, _boundCanvasPointermove));
              this.canvas.removeEventListener("pointerup", __privateGet(this, _boundCanvasPointerup));
              this.canvas.addEventListener("pointerdown", __privateGet(this, _boundCanvasPointerdown));
              setTimeout(() => {
                this.canvas.removeEventListener("contextmenu", _display_utils2.noContextMenu);
              }, 10);
              __privateMethod(this, _stopDrawing, stopDrawing_fn).call(this, event.offsetX, event.offsetY);
              this.addToAnnotationStorage();
              this.setInBackground();
            };
            _createCanvas = new WeakSet();
            createCanvas_fn = function() {
              this.canvas = document.createElement("canvas");
              this.canvas.width = this.canvas.height = 0;
              this.canvas.className = "inkEditorCanvas";
              _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg2) => {
                var _a3;
                return (_a3 = this.canvas) == null ? void 0 : _a3.setAttribute("aria-label", msg2);
              });
              this.div.append(this.canvas);
              this.ctx = this.canvas.getContext("2d");
            };
            _createObserver = new WeakSet();
            createObserver_fn = function() {
              __privateSet(this, _observer, new ResizeObserver((entries) => {
                const rect = entries[0].contentRect;
                if (rect.width && rect.height) {
                  this.setDimensions(rect.width, rect.height);
                }
              }));
              __privateGet(this, _observer).observe(this.div);
            };
            _setCanvasDims = new WeakSet();
            setCanvasDims_fn = function() {
              if (!__privateGet(this, _isCanvasInitialized)) {
                return;
              }
              const [parentWidth, parentHeight] = this.parentDimensions;
              this.canvas.width = Math.ceil(this.width * parentWidth);
              this.canvas.height = Math.ceil(this.height * parentHeight);
              __privateMethod(this, _updateTransform, updateTransform_fn).call(this);
            };
            _setScaleFactor = new WeakSet();
            setScaleFactor_fn = function(width, height) {
              const padding = __privateMethod(this, _getPadding, getPadding_fn).call(this);
              const scaleFactorW = (width - padding) / __privateGet(this, _baseWidth);
              const scaleFactorH = (height - padding) / __privateGet(this, _baseHeight);
              this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
            };
            _updateTransform = new WeakSet();
            updateTransform_fn = function() {
              const padding = __privateMethod(this, _getPadding, getPadding_fn).call(this) / 2;
              this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
            };
            _buildPath2D = new WeakSet();
            buildPath2D_fn = function(bezier) {
              const path2D = new Path2D();
              for (let i2 = 0, ii2 = bezier.length; i2 < ii2; i2++) {
                const [first, control1, control2, second] = bezier[i2];
                if (i2 === 0) {
                  path2D.moveTo(...first);
                }
                path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
              }
              return path2D;
            };
            _toPDFCoordinates = new WeakSet();
            toPDFCoordinates_fn = function(points2, rect, rotation) {
              const [blX, blY, trX, trY] = rect;
              switch (rotation) {
                case 0:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    points2[i2] += blX;
                    points2[i2 + 1] = trY - points2[i2 + 1];
                  }
                  break;
                case 90:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    const x2 = points2[i2];
                    points2[i2] = points2[i2 + 1] + blX;
                    points2[i2 + 1] = x2 + blY;
                  }
                  break;
                case 180:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    points2[i2] = trX - points2[i2];
                    points2[i2 + 1] += blY;
                  }
                  break;
                case 270:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    const x2 = points2[i2];
                    points2[i2] = trX - points2[i2 + 1];
                    points2[i2 + 1] = trY - x2;
                  }
                  break;
                default:
                  throw new Error("Invalid rotation");
              }
              return points2;
            };
            _fromPDFCoordinates = new WeakSet();
            fromPDFCoordinates_fn = function(points2, rect, rotation) {
              const [blX, blY, trX, trY] = rect;
              switch (rotation) {
                case 0:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    points2[i2] -= blX;
                    points2[i2 + 1] = trY - points2[i2 + 1];
                  }
                  break;
                case 90:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    const x2 = points2[i2];
                    points2[i2] = points2[i2 + 1] - blY;
                    points2[i2 + 1] = x2 - blX;
                  }
                  break;
                case 180:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    points2[i2] = trX - points2[i2];
                    points2[i2 + 1] -= blY;
                  }
                  break;
                case 270:
                  for (let i2 = 0, ii2 = points2.length; i2 < ii2; i2 += 2) {
                    const x2 = points2[i2];
                    points2[i2] = trY - points2[i2 + 1];
                    points2[i2 + 1] = trX - x2;
                  }
                  break;
                default:
                  throw new Error("Invalid rotation");
              }
              return points2;
            };
            _serializePaths = new WeakSet();
            serializePaths_fn = function(s2, tx, ty, rect) {
              var _a3, _b3;
              const paths = [];
              const padding = this.thickness / 2;
              const shiftX = s2 * tx + padding;
              const shiftY = s2 * ty + padding;
              for (const bezier of this.paths) {
                const buffer3 = [];
                const points2 = [];
                for (let j2 = 0, jj = bezier.length; j2 < jj; j2++) {
                  const [first, control1, control2, second] = bezier[j2];
                  const p10 = s2 * first[0] + shiftX;
                  const p11 = s2 * first[1] + shiftY;
                  const p20 = s2 * control1[0] + shiftX;
                  const p21 = s2 * control1[1] + shiftY;
                  const p30 = s2 * control2[0] + shiftX;
                  const p31 = s2 * control2[1] + shiftY;
                  const p40 = s2 * second[0] + shiftX;
                  const p41 = s2 * second[1] + shiftY;
                  if (j2 === 0) {
                    buffer3.push(p10, p11);
                    points2.push(p10, p11);
                  }
                  buffer3.push(p20, p21, p30, p31, p40, p41);
                  points2.push(p20, p21);
                  if (j2 === jj - 1) {
                    points2.push(p40, p41);
                  }
                }
                paths.push({
                  bezier: __privateMethod(_a3 = _InkEditor, _toPDFCoordinates, toPDFCoordinates_fn).call(_a3, buffer3, rect, this.rotation),
                  points: __privateMethod(_b3 = _InkEditor, _toPDFCoordinates, toPDFCoordinates_fn).call(_b3, points2, rect, this.rotation)
                });
              }
              return paths;
            };
            _getBbox = new WeakSet();
            getBbox_fn = function() {
              let xMin = Infinity;
              let xMax = -Infinity;
              let yMin = Infinity;
              let yMax = -Infinity;
              for (const path2 of this.paths) {
                for (const [first, control1, control2, second] of path2) {
                  const bbox2 = _util2.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                  xMin = Math.min(xMin, bbox2[0]);
                  yMin = Math.min(yMin, bbox2[1]);
                  xMax = Math.max(xMax, bbox2[2]);
                  yMax = Math.max(yMax, bbox2[3]);
                }
              }
              return [xMin, yMin, xMax, yMax];
            };
            _getPadding = new WeakSet();
            getPadding_fn = function() {
              return __privateGet(this, _disableEditing) ? Math.ceil(this.thickness * this.parentScale) : 0;
            };
            _fitToContent = new WeakSet();
            fitToContent_fn = function(firstTime = false) {
              if (this.isEmpty()) {
                return;
              }
              if (!__privateGet(this, _disableEditing)) {
                __privateMethod(this, _redraw, redraw_fn).call(this);
                return;
              }
              const bbox2 = __privateMethod(this, _getBbox, getBbox_fn).call(this);
              const padding = __privateMethod(this, _getPadding, getPadding_fn).call(this);
              __privateSet(this, _baseWidth, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox2[2] - bbox2[0]));
              __privateSet(this, _baseHeight, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox2[3] - bbox2[1]));
              const width = Math.ceil(padding + __privateGet(this, _baseWidth) * this.scaleFactor);
              const height = Math.ceil(padding + __privateGet(this, _baseHeight) * this.scaleFactor);
              const [parentWidth, parentHeight] = this.parentDimensions;
              this.width = width / parentWidth;
              this.height = height / parentHeight;
              this.setAspectRatio(width, height);
              const prevTranslationX = this.translationX;
              const prevTranslationY = this.translationY;
              this.translationX = -bbox2[0];
              this.translationY = -bbox2[1];
              __privateMethod(this, _setCanvasDims, setCanvasDims_fn).call(this);
              __privateMethod(this, _redraw, redraw_fn).call(this);
              __privateSet(this, _realWidth, width);
              __privateSet(this, _realHeight, height);
              this.setDims(width, height);
              const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
              this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
            };
            __privateAdd(InkEditor, _buildPath2D);
            __privateAdd(InkEditor, _toPDFCoordinates);
            __privateAdd(InkEditor, _fromPDFCoordinates);
            __publicField2(InkEditor, "_defaultColor", null);
            __publicField2(InkEditor, "_defaultOpacity", 1);
            __publicField2(InkEditor, "_defaultThickness", 1);
            __publicField2(InkEditor, "_type", "ink");
            exports2.InkEditor = InkEditor;
          },
          /* 34 */
          /***/
          (__unused_webpack_module2, exports2, __w_pdfjs_require__2) => {
            var _bitmap, _bitmapId, _bitmapPromise, _bitmapUrl, _bitmapFile, _canvas2, _observer, _resizeTimeoutId, _isSvg, _hasBeenAddedInUndoStack, _getBitmapFetched, getBitmapFetched_fn, _getBitmapDone, getBitmapDone_fn, _getBitmap, getBitmap_fn, _createCanvas, createCanvas_fn, _setDimensions, setDimensions_fn, _scaleBitmap, scaleBitmap_fn, _drawBitmap, drawBitmap_fn, _serializeBitmap, serializeBitmap_fn, _createObserver, createObserver_fn;
            Object.defineProperty(exports2, "__esModule", {
              value: true
            });
            exports2.StampEditor = void 0;
            var _util2 = __w_pdfjs_require__2(1);
            var _editor = __w_pdfjs_require__2(4);
            var _display_utils2 = __w_pdfjs_require__2(6);
            var _annotation_layer = __w_pdfjs_require__2(29);
            const _StampEditor = class extends _editor.AnnotationEditor {
              constructor(params2) {
                super({
                  ...params2,
                  name: "stampEditor"
                });
                __privateAdd(this, _getBitmapFetched);
                __privateAdd(this, _getBitmapDone);
                __privateAdd(this, _getBitmap);
                __privateAdd(this, _createCanvas);
                __privateAdd(this, _setDimensions);
                __privateAdd(this, _scaleBitmap);
                __privateAdd(this, _drawBitmap);
                __privateAdd(this, _serializeBitmap);
                __privateAdd(this, _createObserver);
                __privateAdd(this, _bitmap, null);
                __privateAdd(this, _bitmapId, null);
                __privateAdd(this, _bitmapPromise, null);
                __privateAdd(this, _bitmapUrl, null);
                __privateAdd(this, _bitmapFile, null);
                __privateAdd(this, _canvas2, null);
                __privateAdd(this, _observer, null);
                __privateAdd(this, _resizeTimeoutId, null);
                __privateAdd(this, _isSvg, false);
                __privateAdd(this, _hasBeenAddedInUndoStack, false);
                __privateSet(this, _bitmapUrl, params2.bitmapUrl);
                __privateSet(this, _bitmapFile, params2.bitmapFile);
              }
              static initialize(l10n) {
                _editor.AnnotationEditor.initialize(l10n);
              }
              static get supportedTypes() {
                const types2 = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
                return (0, _util2.shadow)(this, "supportedTypes", types2.map((type) => `image/${type}`));
              }
              static get supportedTypesStr() {
                return (0, _util2.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
              }
              static isHandlingMimeForPasting(mime) {
                return this.supportedTypes.includes(mime);
              }
              static paste(item, parent) {
                parent.pasteEditor(_util2.AnnotationEditorType.STAMP, {
                  bitmapFile: item.getAsFile()
                });
              }
              remove() {
                var _a3, _b3;
                if (__privateGet(this, _bitmapId)) {
                  __privateSet(this, _bitmap, null);
                  this._uiManager.imageManager.deleteId(__privateGet(this, _bitmapId));
                  (_a3 = __privateGet(this, _canvas2)) == null ? void 0 : _a3.remove();
                  __privateSet(this, _canvas2, null);
                  (_b3 = __privateGet(this, _observer)) == null ? void 0 : _b3.disconnect();
                  __privateSet(this, _observer, null);
                }
                super.remove();
              }
              rebuild() {
                if (!this.parent) {
                  if (__privateGet(this, _bitmapId)) {
                    __privateMethod(this, _getBitmap, getBitmap_fn).call(this);
                  }
                  return;
                }
                super.rebuild();
                if (this.div === null) {
                  return;
                }
                if (__privateGet(this, _bitmapId)) {
                  __privateMethod(this, _getBitmap, getBitmap_fn).call(this);
                }
                if (!this.isAttachedToDOM) {
                  this.parent.add(this);
                }
              }
              onceAdded() {
                this._isDraggable = true;
                this.div.focus();
              }
              isEmpty() {
                return !(__privateGet(this, _bitmapPromise) || __privateGet(this, _bitmap) || __privateGet(this, _bitmapUrl) || __privateGet(this, _bitmapFile));
              }
              get isResizable() {
                return true;
              }
              render() {
                if (this.div) {
                  return this.div;
                }
                let baseX, baseY;
                if (this.width) {
                  baseX = this.x;
                  baseY = this.y;
                }
                super.render();
                this.div.hidden = true;
                if (__privateGet(this, _bitmap)) {
                  __privateMethod(this, _createCanvas, createCanvas_fn).call(this);
                } else {
                  __privateMethod(this, _getBitmap, getBitmap_fn).call(this);
                }
                if (this.width) {
                  const [parentWidth, parentHeight] = this.parentDimensions;
                  this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                }
                return this.div;
              }
              static deserialize(data2, parent, uiManager) {
                if (data2 instanceof _annotation_layer.StampAnnotationElement) {
                  return null;
                }
                const editor = super.deserialize(data2, parent, uiManager);
                const {
                  rect,
                  bitmapUrl,
                  bitmapId,
                  isSvg,
                  accessibilityData
                } = data2;
                if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
                  __privateSet(editor, _bitmapId, bitmapId);
                } else {
                  __privateSet(editor, _bitmapUrl, bitmapUrl);
                }
                __privateSet(editor, _isSvg, isSvg);
                const [parentWidth, parentHeight] = editor.pageDimensions;
                editor.width = (rect[2] - rect[0]) / parentWidth;
                editor.height = (rect[3] - rect[1]) / parentHeight;
                if (accessibilityData) {
                  editor.altTextData = accessibilityData;
                }
                return editor;
              }
              serialize(isForCopying = false, context2 = null) {
                if (this.isEmpty()) {
                  return null;
                }
                const serialized = {
                  annotationType: _util2.AnnotationEditorType.STAMP,
                  bitmapId: __privateGet(this, _bitmapId),
                  pageIndex: this.pageIndex,
                  rect: this.getRect(0, 0),
                  rotation: this.rotation,
                  isSvg: __privateGet(this, _isSvg),
                  structTreeParentId: this._structTreeParentId
                };
                if (isForCopying) {
                  serialized.bitmapUrl = __privateMethod(this, _serializeBitmap, serializeBitmap_fn).call(this, true);
                  serialized.accessibilityData = this.altTextData;
                  return serialized;
                }
                const {
                  decorative,
                  altText
                } = this.altTextData;
                if (!decorative && altText) {
                  serialized.accessibilityData = {
                    type: "Figure",
                    alt: altText
                  };
                }
                if (context2 === null) {
                  return serialized;
                }
                context2.stamps || (context2.stamps = /* @__PURE__ */ new Map());
                const area5 = __privateGet(this, _isSvg) ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                if (!context2.stamps.has(__privateGet(this, _bitmapId))) {
                  context2.stamps.set(__privateGet(this, _bitmapId), {
                    area: area5,
                    serialized
                  });
                  serialized.bitmap = __privateMethod(this, _serializeBitmap, serializeBitmap_fn).call(this, false);
                } else if (__privateGet(this, _isSvg)) {
                  const prevData = context2.stamps.get(__privateGet(this, _bitmapId));
                  if (area5 > prevData.area) {
                    prevData.area = area5;
                    prevData.serialized.bitmap.close();
                    prevData.serialized.bitmap = __privateMethod(this, _serializeBitmap, serializeBitmap_fn).call(this, false);
                  }
                }
                return serialized;
              }
            };
            let StampEditor = _StampEditor;
            _bitmap = new WeakMap();
            _bitmapId = new WeakMap();
            _bitmapPromise = new WeakMap();
            _bitmapUrl = new WeakMap();
            _bitmapFile = new WeakMap();
            _canvas2 = new WeakMap();
            _observer = new WeakMap();
            _resizeTimeoutId = new WeakMap();
            _isSvg = new WeakMap();
            _hasBeenAddedInUndoStack = new WeakMap();
            _getBitmapFetched = new WeakSet();
            getBitmapFetched_fn = function(data2, fromId = false) {
              if (!data2) {
                this.remove();
                return;
              }
              __privateSet(this, _bitmap, data2.bitmap);
              if (!fromId) {
                __privateSet(this, _bitmapId, data2.id);
                __privateSet(this, _isSvg, data2.isSvg);
              }
              __privateMethod(this, _createCanvas, createCanvas_fn).call(this);
            };
            _getBitmapDone = new WeakSet();
            getBitmapDone_fn = function() {
              __privateSet(this, _bitmapPromise, null);
              this._uiManager.enableWaiting(false);
              if (__privateGet(this, _canvas2)) {
                this.div.focus();
              }
            };
            _getBitmap = new WeakSet();
            getBitmap_fn = function() {
              if (__privateGet(this, _bitmapId)) {
                this._uiManager.enableWaiting(true);
                this._uiManager.imageManager.getFromId(__privateGet(this, _bitmapId)).then((data2) => __privateMethod(this, _getBitmapFetched, getBitmapFetched_fn).call(this, data2, true)).finally(() => __privateMethod(this, _getBitmapDone, getBitmapDone_fn).call(this));
                return;
              }
              if (__privateGet(this, _bitmapUrl)) {
                const url2 = __privateGet(this, _bitmapUrl);
                __privateSet(this, _bitmapUrl, null);
                this._uiManager.enableWaiting(true);
                __privateSet(this, _bitmapPromise, this._uiManager.imageManager.getFromUrl(url2).then((data2) => __privateMethod(this, _getBitmapFetched, getBitmapFetched_fn).call(this, data2)).finally(() => __privateMethod(this, _getBitmapDone, getBitmapDone_fn).call(this)));
                return;
              }
              if (__privateGet(this, _bitmapFile)) {
                const file2 = __privateGet(this, _bitmapFile);
                __privateSet(this, _bitmapFile, null);
                this._uiManager.enableWaiting(true);
                __privateSet(this, _bitmapPromise, this._uiManager.imageManager.getFromFile(file2).then((data2) => __privateMethod(this, _getBitmapFetched, getBitmapFetched_fn).call(this, data2)).finally(() => __privateMethod(this, _getBitmapDone, getBitmapDone_fn).call(this)));
                return;
              }
              const input = document.createElement("input");
              input.type = "file";
              input.accept = _StampEditor.supportedTypesStr;
              __privateSet(this, _bitmapPromise, new Promise((resolve2) => {
                input.addEventListener("change", async () => {
                  if (!input.files || input.files.length === 0) {
                    this.remove();
                  } else {
                    this._uiManager.enableWaiting(true);
                    const data2 = await this._uiManager.imageManager.getFromFile(input.files[0]);
                    __privateMethod(this, _getBitmapFetched, getBitmapFetched_fn).call(this, data2);
                  }
                  resolve2();
                });
                input.addEventListener("cancel", () => {
                  this.remove();
                  resolve2();
                });
              }).finally(() => __privateMethod(this, _getBitmapDone, getBitmapDone_fn).call(this)));
              input.click();
            };
            _createCanvas = new WeakSet();
            createCanvas_fn = function() {
              const {
                div
              } = this;
              let {
                width,
                height
              } = __privateGet(this, _bitmap);
              const [pageWidth, pageHeight] = this.pageDimensions;
              const MAX_RATIO = 0.75;
              if (this.width) {
                width = this.width * pageWidth;
                height = this.height * pageHeight;
              } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                width *= factor;
                height *= factor;
              }
              const [parentWidth, parentHeight] = this.parentDimensions;
              this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
              this._uiManager.enableWaiting(false);
              const canvas2 = __privateSet(this, _canvas2, document.createElement("canvas"));
              div.append(canvas2);
              div.hidden = false;
              __privateMethod(this, _drawBitmap, drawBitmap_fn).call(this, width, height);
              __privateMethod(this, _createObserver, createObserver_fn).call(this);
              if (!__privateGet(this, _hasBeenAddedInUndoStack)) {
                this.parent.addUndoableEditor(this);
                __privateSet(this, _hasBeenAddedInUndoStack, true);
              }
              this._uiManager._eventBus.dispatch("reporttelemetry", {
                source: this,
                details: {
                  type: "editing",
                  subtype: this.editorType,
                  data: {
                    action: "inserted_image"
                  }
                }
              });
              this.addAltTextButton();
            };
            _setDimensions = new WeakSet();
            setDimensions_fn = function(width, height) {
              var _a3;
              const [parentWidth, parentHeight] = this.parentDimensions;
              this.width = width / parentWidth;
              this.height = height / parentHeight;
              this.setDims(width, height);
              if ((_a3 = this._initialOptions) == null ? void 0 : _a3.isCentered) {
                this.center();
              } else {
                this.fixAndSetPosition();
              }
              this._initialOptions = null;
              if (__privateGet(this, _resizeTimeoutId) !== null) {
                clearTimeout(__privateGet(this, _resizeTimeoutId));
              }
              const TIME_TO_WAIT = 200;
              __privateSet(this, _resizeTimeoutId, setTimeout(() => {
                __privateSet(this, _resizeTimeoutId, null);
                __privateMethod(this, _drawBitmap, drawBitmap_fn).call(this, width, height);
              }, TIME_TO_WAIT));
            };
            _scaleBitmap = new WeakSet();
            scaleBitmap_fn = function(width, height) {
              const {
                width: bitmapWidth,
                height: bitmapHeight
              } = __privateGet(this, _bitmap);
              let newWidth = bitmapWidth;
              let newHeight = bitmapHeight;
              let bitmap = __privateGet(this, _bitmap);
              while (newWidth > 2 * width || newHeight > 2 * height) {
                const prevWidth = newWidth;
                const prevHeight = newHeight;
                if (newWidth > 2 * width) {
                  newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                }
                if (newHeight > 2 * height) {
                  newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                }
                const offscreen = new OffscreenCanvas(newWidth, newHeight);
                const ctx2 = offscreen.getContext("2d");
                ctx2.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                bitmap = offscreen.transferToImageBitmap();
              }
              return bitmap;
            };
            _drawBitmap = new WeakSet();
            drawBitmap_fn = function(width, height) {
              width = Math.ceil(width);
              height = Math.ceil(height);
              const canvas2 = __privateGet(this, _canvas2);
              if (!canvas2 || canvas2.width === width && canvas2.height === height) {
                return;
              }
              canvas2.width = width;
              canvas2.height = height;
              const bitmap = __privateGet(this, _isSvg) ? __privateGet(this, _bitmap) : __privateMethod(this, _scaleBitmap, scaleBitmap_fn).call(this, width, height);
              const ctx2 = canvas2.getContext("2d");
              ctx2.filter = this._uiManager.hcmFilter;
              ctx2.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
            };
            _serializeBitmap = new WeakSet();
            serializeBitmap_fn = function(toUrl) {
              if (toUrl) {
                if (__privateGet(this, _isSvg)) {
                  const url2 = this._uiManager.imageManager.getSvgUrl(__privateGet(this, _bitmapId));
                  if (url2) {
                    return url2;
                  }
                }
                const canvas2 = document.createElement("canvas");
                ({
                  width: canvas2.width,
                  height: canvas2.height
                } = __privateGet(this, _bitmap));
                const ctx2 = canvas2.getContext("2d");
                ctx2.drawImage(__privateGet(this, _bitmap), 0, 0);
                return canvas2.toDataURL();
              }
              if (__privateGet(this, _isSvg)) {
                const [pageWidth, pageHeight] = this.pageDimensions;
                const width = Math.round(this.width * pageWidth * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS);
                const height = Math.round(this.height * pageHeight * _display_utils2.PixelsPerInch.PDF_TO_CSS_UNITS);
                const offscreen = new OffscreenCanvas(width, height);
                const ctx2 = offscreen.getContext("2d");
                ctx2.drawImage(__privateGet(this, _bitmap), 0, 0, __privateGet(this, _bitmap).width, __privateGet(this, _bitmap).height, 0, 0, width, height);
                return offscreen.transferToImageBitmap();
              }
              return structuredClone(__privateGet(this, _bitmap));
            };
            _createObserver = new WeakSet();
            createObserver_fn = function() {
              __privateSet(this, _observer, new ResizeObserver((entries) => {
                const rect = entries[0].contentRect;
                if (rect.width && rect.height) {
                  __privateMethod(this, _setDimensions, setDimensions_fn).call(this, rect.width, rect.height);
                }
              }));
              __privateGet(this, _observer).observe(this.div);
            };
            __publicField2(StampEditor, "_type", "stamp");
            exports2.StampEditor = StampEditor;
          }
          /******/
        ];
        var __webpack_module_cache__ = {};
        function __w_pdfjs_require__(moduleId) {
          var cachedModule = __webpack_module_cache__[moduleId];
          if (cachedModule !== void 0) {
            return cachedModule.exports;
          }
          var module2 = __webpack_module_cache__[moduleId] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          __webpack_modules__[moduleId](module2, module2.exports, __w_pdfjs_require__);
          return module2.exports;
        }
        var __webpack_exports__ = {};
        (() => {
          var exports2 = __webpack_exports__;
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          Object.defineProperty(exports2, "AbortException", {
            enumerable: true,
            get: function() {
              return _util2.AbortException;
            }
          });
          Object.defineProperty(exports2, "AnnotationEditorLayer", {
            enumerable: true,
            get: function() {
              return _annotation_editor_layer.AnnotationEditorLayer;
            }
          });
          Object.defineProperty(exports2, "AnnotationEditorParamsType", {
            enumerable: true,
            get: function() {
              return _util2.AnnotationEditorParamsType;
            }
          });
          Object.defineProperty(exports2, "AnnotationEditorType", {
            enumerable: true,
            get: function() {
              return _util2.AnnotationEditorType;
            }
          });
          Object.defineProperty(exports2, "AnnotationEditorUIManager", {
            enumerable: true,
            get: function() {
              return _tools.AnnotationEditorUIManager;
            }
          });
          Object.defineProperty(exports2, "AnnotationLayer", {
            enumerable: true,
            get: function() {
              return _annotation_layer.AnnotationLayer;
            }
          });
          Object.defineProperty(exports2, "AnnotationMode", {
            enumerable: true,
            get: function() {
              return _util2.AnnotationMode;
            }
          });
          Object.defineProperty(exports2, "CMapCompressionType", {
            enumerable: true,
            get: function() {
              return _util2.CMapCompressionType;
            }
          });
          Object.defineProperty(exports2, "DOMSVGFactory", {
            enumerable: true,
            get: function() {
              return _display_utils2.DOMSVGFactory;
            }
          });
          Object.defineProperty(exports2, "FeatureTest", {
            enumerable: true,
            get: function() {
              return _util2.FeatureTest;
            }
          });
          Object.defineProperty(exports2, "GlobalWorkerOptions", {
            enumerable: true,
            get: function() {
              return _worker_options2.GlobalWorkerOptions;
            }
          });
          Object.defineProperty(exports2, "ImageKind", {
            enumerable: true,
            get: function() {
              return _util2.ImageKind;
            }
          });
          Object.defineProperty(exports2, "InvalidPDFException", {
            enumerable: true,
            get: function() {
              return _util2.InvalidPDFException;
            }
          });
          Object.defineProperty(exports2, "MissingPDFException", {
            enumerable: true,
            get: function() {
              return _util2.MissingPDFException;
            }
          });
          Object.defineProperty(exports2, "OPS", {
            enumerable: true,
            get: function() {
              return _util2.OPS;
            }
          });
          Object.defineProperty(exports2, "PDFDataRangeTransport", {
            enumerable: true,
            get: function() {
              return _api.PDFDataRangeTransport;
            }
          });
          Object.defineProperty(exports2, "PDFDateString", {
            enumerable: true,
            get: function() {
              return _display_utils2.PDFDateString;
            }
          });
          Object.defineProperty(exports2, "PDFWorker", {
            enumerable: true,
            get: function() {
              return _api.PDFWorker;
            }
          });
          Object.defineProperty(exports2, "PasswordResponses", {
            enumerable: true,
            get: function() {
              return _util2.PasswordResponses;
            }
          });
          Object.defineProperty(exports2, "PermissionFlag", {
            enumerable: true,
            get: function() {
              return _util2.PermissionFlag;
            }
          });
          Object.defineProperty(exports2, "PixelsPerInch", {
            enumerable: true,
            get: function() {
              return _display_utils2.PixelsPerInch;
            }
          });
          Object.defineProperty(exports2, "PromiseCapability", {
            enumerable: true,
            get: function() {
              return _util2.PromiseCapability;
            }
          });
          Object.defineProperty(exports2, "RenderingCancelledException", {
            enumerable: true,
            get: function() {
              return _display_utils2.RenderingCancelledException;
            }
          });
          Object.defineProperty(exports2, "SVGGraphics", {
            enumerable: true,
            get: function() {
              return _api.SVGGraphics;
            }
          });
          Object.defineProperty(exports2, "UnexpectedResponseException", {
            enumerable: true,
            get: function() {
              return _util2.UnexpectedResponseException;
            }
          });
          Object.defineProperty(exports2, "Util", {
            enumerable: true,
            get: function() {
              return _util2.Util;
            }
          });
          Object.defineProperty(exports2, "VerbosityLevel", {
            enumerable: true,
            get: function() {
              return _util2.VerbosityLevel;
            }
          });
          Object.defineProperty(exports2, "XfaLayer", {
            enumerable: true,
            get: function() {
              return _xfa_layer.XfaLayer;
            }
          });
          Object.defineProperty(exports2, "build", {
            enumerable: true,
            get: function() {
              return _api.build;
            }
          });
          Object.defineProperty(exports2, "createValidAbsoluteUrl", {
            enumerable: true,
            get: function() {
              return _util2.createValidAbsoluteUrl;
            }
          });
          Object.defineProperty(exports2, "getDocument", {
            enumerable: true,
            get: function() {
              return _api.getDocument;
            }
          });
          Object.defineProperty(exports2, "getFilenameFromUrl", {
            enumerable: true,
            get: function() {
              return _display_utils2.getFilenameFromUrl;
            }
          });
          Object.defineProperty(exports2, "getPdfFilenameFromUrl", {
            enumerable: true,
            get: function() {
              return _display_utils2.getPdfFilenameFromUrl;
            }
          });
          Object.defineProperty(exports2, "getXfaPageViewport", {
            enumerable: true,
            get: function() {
              return _display_utils2.getXfaPageViewport;
            }
          });
          Object.defineProperty(exports2, "isDataScheme", {
            enumerable: true,
            get: function() {
              return _display_utils2.isDataScheme;
            }
          });
          Object.defineProperty(exports2, "isPdfFile", {
            enumerable: true,
            get: function() {
              return _display_utils2.isPdfFile;
            }
          });
          Object.defineProperty(exports2, "loadScript", {
            enumerable: true,
            get: function() {
              return _display_utils2.loadScript;
            }
          });
          Object.defineProperty(exports2, "noContextMenu", {
            enumerable: true,
            get: function() {
              return _display_utils2.noContextMenu;
            }
          });
          Object.defineProperty(exports2, "normalizeUnicode", {
            enumerable: true,
            get: function() {
              return _util2.normalizeUnicode;
            }
          });
          Object.defineProperty(exports2, "renderTextLayer", {
            enumerable: true,
            get: function() {
              return _text_layer.renderTextLayer;
            }
          });
          Object.defineProperty(exports2, "setLayerDimensions", {
            enumerable: true,
            get: function() {
              return _display_utils2.setLayerDimensions;
            }
          });
          Object.defineProperty(exports2, "shadow", {
            enumerable: true,
            get: function() {
              return _util2.shadow;
            }
          });
          Object.defineProperty(exports2, "updateTextLayer", {
            enumerable: true,
            get: function() {
              return _text_layer.updateTextLayer;
            }
          });
          Object.defineProperty(exports2, "version", {
            enumerable: true,
            get: function() {
              return _api.version;
            }
          });
          var _util2 = __w_pdfjs_require__(1);
          var _api = __w_pdfjs_require__(2);
          var _display_utils2 = __w_pdfjs_require__(6);
          var _text_layer = __w_pdfjs_require__(26);
          var _annotation_editor_layer = __w_pdfjs_require__(27);
          var _tools = __w_pdfjs_require__(5);
          var _annotation_layer = __w_pdfjs_require__(29);
          var _worker_options2 = __w_pdfjs_require__(14);
          var _xfa_layer = __w_pdfjs_require__(32);
        })();
        return __webpack_exports__;
      })()
    );
  });
})(pdf$1);
const pdf = /* @__PURE__ */ getDefaultExportFromCjs$1(pdfExports);
const pdfjsModule = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: pdf
}, [pdfExports]);
const pdfjs = "default" in pdfjsModule ? pdf : pdfjsModule;
const pdfjs$1 = pdfjs;
var isProduction = process.env.NODE_ENV === "production";
function warning(condition, message2) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message2;
    if (typeof console !== "undefined") {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x2) {
    }
  }
}
const isBrowser$6 = typeof document !== "undefined";
const isLocalFileSystem = isBrowser$6 && window.location.protocol === "file:";
const allowFileAccessFromFilesTip = "On Chromium based browsers, you can use --allow-file-access-from-files flag for debugging purposes.";
function displayWorkerWarning() {
  warning(!isLocalFileSystem, `Loading PDF.js worker may not work on protocols other than HTTP/HTTPS. ${allowFileAccessFromFilesTip}`);
}
displayWorkerWarning();
pdfjs$1.GlobalWorkerOptions.workerSrc = "pdf.worker.js";
const TextLayer$1 = "";
const AnnotationLayer = "";
pdfjs$1.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs$1.version}/build/pdf.worker.min.js`;
class PdfUtil {
  static async converToImages(url2) {
    try {
      const thePdf = await pdfjs$1.getDocument(url2).promise;
      if (!thePdf)
        return [];
      const pageIndices = Array.from({
        length: thePdf.numPages
      }, (_2, i2) => i2 + 1);
      const images = [];
      for await (const curPageIndex of pageIndices) {
        const page = await thePdf.getPage(curPageIndex);
        const image = await PdfUtil.handlePages(page);
        images.push(image);
      }
      return images;
    } catch (error2) {
      console.error(error2);
    }
    return [];
  }
  static async handlePages(page) {
    const viewport = page.getViewport({
      scale: 1
    });
    const canvas2 = document.createElement("canvas");
    canvas2.style.display = "block";
    const context2 = canvas2.getContext("2d", {
      alpha: true
    });
    canvas2.height = viewport.height;
    canvas2.width = viewport.width;
    await page.render({
      canvasContext: context2,
      viewport
    }).promise;
    const dataUrl = canvas2.toDataURL("image/png");
    return dataUrl;
  }
}
function e(e3) {
  this.message = e3;
}
e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";
var r$2 = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r2) {
  var t2 = String(r2).replace(/=+$/, "");
  if (t2.length % 4 == 1)
    throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n2, o2, a2 = 0, i2 = 0, c2 = ""; o2 = t2.charAt(i2++); ~o2 && (n2 = a2 % 4 ? 64 * n2 + o2 : o2, a2++ % 4) ? c2 += String.fromCharCode(255 & n2 >> (-2 * a2 & 6)) : 0)
    o2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o2);
  return c2;
};
function t$1(e3) {
  var t2 = e3.replace(/-/g, "+").replace(/_/g, "/");
  switch (t2.length % 4) {
    case 0:
      break;
    case 2:
      t2 += "==";
      break;
    case 3:
      t2 += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(e4) {
      return decodeURIComponent(r$2(e4).replace(/(.)/g, function(e5, r2) {
        var t3 = r2.charCodeAt(0).toString(16).toUpperCase();
        return t3.length < 2 && (t3 = "0" + t3), "%" + t3;
      }));
    }(t2);
  } catch (e4) {
    return r$2(t2);
  }
}
function n$3(e3) {
  this.message = e3;
}
function o$2(e3, r2) {
  if ("string" != typeof e3)
    throw new n$3("Invalid token specified");
  var o2 = true === (r2 = r2 || {}).header ? 0 : 1;
  try {
    return JSON.parse(t$1(e3.split(".")[o2]));
  } catch (e4) {
    throw new n$3("Invalid token specified: " + e4.message);
  }
}
n$3.prototype = new Error(), n$3.prototype.name = "InvalidTokenError";
const SESSION_STORAGE_TOKENS = "spectraai-tokens";
const toExpriesAt = (expriesIn) => Math.floor(Date.now() / 1e3) + expriesIn;
const isExpired = (expiresAt = 0) => Math.floor(Date.now() / 1e3) >= expiresAt;
class SpectraTokenUtil {
  static getBaseUrl(baseUrl) {
    const ep = useEnvStore.getState().env.saiPostgresEndpoint || baseUrl;
    if (!ep)
      throw new Error("Endpoint not defined");
    return ep;
  }
  static async login(loginId, password, {
    clientId = "",
    keycloakIssuer = "",
    clientSecret = ""
  }) {
    if (!loginId || !password || !clientId || !keycloakIssuer) {
      throw new Error("Invalid Credentials");
    }
    const params2 = new URLSearchParams();
    params2.append("grant_type", "password");
    params2.append("client_id", clientId);
    params2.append("username", loginId);
    params2.append("password", password);
    if (clientSecret) {
      params2.append("client_secret", clientSecret);
    }
    const keycloakUrl = `${keycloakIssuer}/protocol/openid-connect/token`;
    const response = await fetch(keycloakUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: params2.toString()
    });
    if (!response.ok) {
      throw new Error(`Login failed: ${response.statusText}`);
    }
    const json = await response.json();
    if (json.access_token && json.refresh_token) {
      const obj = {
        accessToken: json.access_token,
        refreshToken: json.refresh_token,
        expiresAt: toExpriesAt(json.expires_in),
        refreshExpiresAt: toExpriesAt(json.refresh_expires_in)
      };
      sessionStorage.setItem(SESSION_STORAGE_TOKENS, JSON.stringify(obj));
      return obj;
    }
    throw new Error("Invalid Credentials");
  }
  static async getRefreshToken({
    refreshToken,
    clientId,
    clientSecret,
    keycloakIssuer
  }) {
    if (!refreshToken || !clientId || !keycloakIssuer) {
      throw new Error("Invalid Credentials");
    }
    const params2 = new URLSearchParams();
    params2.append("grant_type", "password");
    params2.append("client_id", clientId);
    params2.append("refresh_token", refreshToken);
    if (clientSecret) {
      params2.append("client_secret", clientSecret);
    }
    const keycloakUrl = `${keycloakIssuer}/protocol/openid-connect/token`;
    const response = await fetch(keycloakUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: params2.toString()
    });
    if (!response.ok) {
      throw new Error(`Login failed: ${response.statusText}`);
    }
    const json = await response.json();
    if (json.access_token && json.refresh_token) {
      const obj = {
        accessToken: json.access_token,
        refreshToken: json.refresh_token,
        expiresAt: toExpriesAt(json.expires_in),
        refreshExpiresAt: toExpriesAt(json.refresh_expires_in)
      };
      sessionStorage.setItem(SESSION_STORAGE_TOKENS, JSON.stringify(obj));
      return obj;
    }
    throw new Error("Refresh failed");
  }
  static async getToken({
    clientId: clientIdIn = "",
    keycloakIssuer: keycloakIssuerIn = "",
    forceLogin = false,
    login: loginIn = "",
    password: passwordIn = "",
    clientSecret: clientSecretIn = ""
  }) {
    const getTokenCallback = useEnvStore.getState().env.getSaiAccessToken;
    if (typeof getTokenCallback === "function" && !forceLogin) {
      return getTokenCallback();
    }
    const saiTestCredentials = useEnvStore.getState().env.saiTestCredentials || {};
    const keycloakIssuer = keycloakIssuerIn || (saiTestCredentials == null ? void 0 : saiTestCredentials.keycloakIssuer);
    const clientId = clientIdIn || (saiTestCredentials == null ? void 0 : saiTestCredentials.clientId);
    const loginId = loginIn || (saiTestCredentials == null ? void 0 : saiTestCredentials.login);
    const password = passwordIn || (saiTestCredentials == null ? void 0 : saiTestCredentials.password);
    const clientSecret = clientSecretIn || (saiTestCredentials == null ? void 0 : saiTestCredentials.clientSecret);
    const existingTokens = sessionStorage.getItem(SESSION_STORAGE_TOKENS);
    const parsedExistingTokens = existingTokens ? JSON.parse(existingTokens) : {};
    const accessToken = parsedExistingTokens.accessToken && !isExpired(parsedExistingTokens.expiresAt) ? parsedExistingTokens.accessToken : null;
    const refreshToken = parsedExistingTokens.refreshToken && !isExpired(parsedExistingTokens.refreshExpiresAt) ? parsedExistingTokens.refreshToken : null;
    let needNewTokens = true;
    let needsRefreshTokens = false;
    if (accessToken && refreshToken) {
      const hasExpired = (currentExpiry, delayInMs = 0) => {
        let now2 = moment();
        const expiresInAsMoment = moment(currentExpiry * 1e3);
        if (delayInMs)
          now2 = now2.add(delayInMs);
        return now2.isAfter(expiresInAsMoment);
      };
      const accessTokenInfo = o$2(accessToken);
      const accessExpired = hasExpired(accessTokenInfo.exp, 500);
      if (accessExpired) {
        const refreshTokenInfo = o$2(refreshToken);
        const refreshExpired = hasExpired(refreshTokenInfo.exp);
        if (!refreshExpired) {
          needsRefreshTokens = true;
          needNewTokens = false;
        } else {
          needNewTokens = true;
          needsRefreshTokens = false;
        }
      } else {
        needNewTokens = false;
        needsRefreshTokens = false;
      }
    }
    if (needsRefreshTokens) {
      const token = await SpectraTokenUtil.getRefreshToken({
        refreshToken,
        clientId,
        clientSecret,
        keycloakIssuer
      });
      if (!(token == null ? void 0 : token.accessToken))
        throw new Error("Authentication Failed");
      return token.accessToken;
    }
    if (needNewTokens) {
      const token = await SpectraTokenUtil.login(loginId, password, {
        clientId,
        clientSecret,
        keycloakIssuer
      });
      if (!(token == null ? void 0 : token.accessToken))
        throw new Error("Authentication Failed");
      return token.accessToken;
    }
    return accessToken;
  }
}
const API_VERSION$1 = "v1";
const PATH$1 = "gis/translator";
const ACTIVITY_ID = "C3SpectraDAAutoCad.Dwg2DxfActivity+dev";
class DwgApsUtil {
  static getEndPoint(queryParams) {
    const ep = useEnvStore.getState().env.saiPostgresEndpoint;
    if (!ep)
      throw new Error("Endpoint not defined");
    return `${ep}/${API_VERSION$1}/${PATH$1}?${queryParams}`;
  }
  static isSupported() {
    const ep = useEnvStore.getState().env.saiPostgresEndpoint;
    return !!ep;
  }
  static async convertToDxf(file2) {
    if (!DwgApsUtil.isSupported())
      throw new Error("Unsupported format: dwg");
    const token = await SpectraTokenUtil.getToken();
    const form = new FormData();
    form.append("file", file2);
    const queryParams = new URLSearchParams({
      type: "DXF",
      activity_id: ACTIVITY_ID
    });
    const url2 = DwgApsUtil.getEndPoint(queryParams);
    const headers = {};
    if (token)
      headers.Authorization = `Bearer ${token}`;
    const response = await fetch(url2, {
      method: "POST",
      mode: "cors",
      headers,
      body: form
    });
    if (!(response == null ? void 0 : response.ok))
      throw new Error(`Translation failed`);
    const dxfString = await response.text();
    if (!dxfString)
      throw new Error(`Translation failed`);
    const dataUri = false;
    return FileUtil.textToUrl(dxfString, "application/dxf", dataUri);
  }
}
class FontLoader extends Loader {
  constructor(manager) {
    super(manager);
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(scope.withCredentials);
    loader2.load(url2, function(text) {
      let json;
      try {
        json = JSON.parse(text);
      } catch (e3) {
        console.warn("THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.");
        json = JSON.parse(text.substring(65, text.length - 2));
      }
      const font = scope.parse(json);
      if (onLoad)
        onLoad(font);
    }, onProgress, onError);
  }
  parse(json) {
    return new Font(json);
  }
}
class Font {
  constructor(data2) {
    this.type = "Font";
    this.data = data2;
  }
  generateShapes(text, size12 = 100) {
    const shapes = [];
    const paths = createPaths(text, size12, this.data);
    for (let p2 = 0, pl = paths.length; p2 < pl; p2++) {
      Array.prototype.push.apply(shapes, paths[p2].toShapes());
    }
    return shapes;
  }
}
function createPaths(text, size12, data2) {
  const chars2 = Array.from(text);
  const scale5 = size12 / data2.resolution;
  const line_height = (data2.boundingBox.yMax - data2.boundingBox.yMin + data2.underlineThickness) * scale5;
  const paths = [];
  let offsetX = 0, offsetY = 0;
  for (let i2 = 0; i2 < chars2.length; i2++) {
    const char = chars2[i2];
    if (char === "\n") {
      offsetX = 0;
      offsetY -= line_height;
    } else {
      const ret = createPath(char, scale5, offsetX, offsetY, data2);
      offsetX += ret.offsetX;
      paths.push(ret.path);
    }
  }
  return paths;
}
function createPath(char, scale5, offsetX, offsetY, data2) {
  const glyph = data2.glyphs[char] || data2.glyphs["?"];
  if (!glyph) {
    console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data2.familyName + ".");
    return;
  }
  const path2 = new ShapePath();
  let x2, y2, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
  if (glyph.o) {
    const outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(" "));
    for (let i2 = 0, l2 = outline.length; i2 < l2; ) {
      const action = outline[i2++];
      switch (action) {
        case "m":
          x2 = outline[i2++] * scale5 + offsetX;
          y2 = outline[i2++] * scale5 + offsetY;
          path2.moveTo(x2, y2);
          break;
        case "l":
          x2 = outline[i2++] * scale5 + offsetX;
          y2 = outline[i2++] * scale5 + offsetY;
          path2.lineTo(x2, y2);
          break;
        case "q":
          cpx = outline[i2++] * scale5 + offsetX;
          cpy = outline[i2++] * scale5 + offsetY;
          cpx1 = outline[i2++] * scale5 + offsetX;
          cpy1 = outline[i2++] * scale5 + offsetY;
          path2.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
          break;
        case "b":
          cpx = outline[i2++] * scale5 + offsetX;
          cpy = outline[i2++] * scale5 + offsetY;
          cpx1 = outline[i2++] * scale5 + offsetX;
          cpy1 = outline[i2++] * scale5 + offsetY;
          cpx2 = outline[i2++] * scale5 + offsetX;
          cpy2 = outline[i2++] * scale5 + offsetY;
          path2.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
          break;
      }
    }
  }
  return { offsetX: glyph.ha * scale5, path: path2 };
}
Font.prototype.isFont = true;
const FontLoader$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Font,
  FontLoader
}, Symbol.toStringTag, { value: "Module" }));
/*! For license information please see three-dxf-loader.js.LICENSE.txt */
var t = { 43: function(e3, t2, r2) {
  var n2, a2;
  n2 = function() {
    var e4 = function() {
    }, t3 = "undefined", r3 = typeof window !== t3 && typeof window.navigator !== t3 && /Trident\/|MSIE /.test(window.navigator.userAgent), n3 = ["trace", "debug", "info", "warn", "error"];
    function a3(e5, t4) {
      var r4 = e5[t4];
      if ("function" == typeof r4.bind)
        return r4.bind(e5);
      try {
        return Function.prototype.bind.call(r4, e5);
      } catch (t5) {
        return function() {
          return Function.prototype.apply.apply(r4, [e5, arguments]);
        };
      }
    }
    function o2() {
      console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
    }
    function i2(t4, r4) {
      for (var a4 = 0; a4 < n3.length; a4++) {
        var o3 = n3[a4];
        this[o3] = a4 < t4 ? e4 : this.methodFactory(o3, t4, r4);
      }
      this.log = this.debug;
    }
    function s2(e5, r4, n4) {
      return function() {
        typeof console !== t3 && (i2.call(this, r4, n4), this[e5].apply(this, arguments));
      };
    }
    function l2(n4, i3, l3) {
      return function(n5) {
        return "debug" === n5 && (n5 = "log"), typeof console !== t3 && ("trace" === n5 && r3 ? o2 : void 0 !== console[n5] ? a3(console, n5) : void 0 !== console.log ? a3(console, "log") : e4);
      }(n4) || s2.apply(this, arguments);
    }
    function c2(e5, r4, a4) {
      var o3, s3 = this;
      r4 = null == r4 ? "WARN" : r4;
      var c3 = "loglevel";
      function u3() {
        var e6;
        if (typeof window !== t3 && c3) {
          try {
            e6 = window.localStorage[c3];
          } catch (e7) {
          }
          if (typeof e6 === t3)
            try {
              var r5 = window.document.cookie, n4 = r5.indexOf(encodeURIComponent(c3) + "=");
              -1 !== n4 && (e6 = /^([^;]+)/.exec(r5.slice(n4))[1]);
            } catch (e7) {
            }
          return void 0 === s3.levels[e6] && (e6 = void 0), e6;
        }
      }
      "string" == typeof e5 ? c3 += ":" + e5 : "symbol" == typeof e5 && (c3 = void 0), s3.name = e5, s3.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }, s3.methodFactory = a4 || l2, s3.getLevel = function() {
        return o3;
      }, s3.setLevel = function(r5, a5) {
        if ("string" == typeof r5 && void 0 !== s3.levels[r5.toUpperCase()] && (r5 = s3.levels[r5.toUpperCase()]), !("number" == typeof r5 && r5 >= 0 && r5 <= s3.levels.SILENT))
          throw "log.setLevel() called with invalid level: " + r5;
        if (o3 = r5, false !== a5 && function(e6) {
          var r6 = (n3[e6] || "silent").toUpperCase();
          if (typeof window !== t3 && c3) {
            try {
              return void (window.localStorage[c3] = r6);
            } catch (e7) {
            }
            try {
              window.document.cookie = encodeURIComponent(c3) + "=" + r6 + ";";
            } catch (e7) {
            }
          }
        }(r5), i2.call(s3, r5, e5), typeof console === t3 && r5 < s3.levels.SILENT)
          return "No console available for logging";
      }, s3.setDefaultLevel = function(e6) {
        r4 = e6, u3() || s3.setLevel(e6, false);
      }, s3.resetLevel = function() {
        s3.setLevel(r4, false), function() {
          if (typeof window !== t3 && c3) {
            try {
              return void window.localStorage.removeItem(c3);
            } catch (e6) {
            }
            try {
              window.document.cookie = encodeURIComponent(c3) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (e6) {
            }
          }
        }();
      }, s3.enableAll = function(e6) {
        s3.setLevel(s3.levels.TRACE, e6);
      }, s3.disableAll = function(e6) {
        s3.setLevel(s3.levels.SILENT, e6);
      };
      var f3 = u3();
      null == f3 && (f3 = r4), s3.setLevel(f3, false);
    }
    var u2 = new c2(), f2 = {};
    u2.getLogger = function(e5) {
      if ("symbol" != typeof e5 && "string" != typeof e5 || "" === e5)
        throw new TypeError("You must supply a name when creating a logger.");
      var t4 = f2[e5];
      return t4 || (t4 = f2[e5] = new c2(e5, u2.getLevel(), u2.methodFactory)), t4;
    };
    var d2 = typeof window !== t3 ? window.log : void 0;
    return u2.noConflict = function() {
      return typeof window !== t3 && window.log === u2 && (window.log = d2), u2;
    }, u2.getLoggers = function() {
      return f2;
    }, u2.default = u2, u2;
  }, void 0 === (a2 = n2.call(t2, r2, t2, e3)) || (e3.exports = a2);
}, 939: (e3, t2, r2) => {
  r2.d(t2, { Z: () => o2 });
  var n2 = r2(949);
  const a2 = {};
  n2.FontLoader ? a2.FontLoader = n2.FontLoader : Promise.resolve().then(() => FontLoader$1).then((e4) => a2.FontLoader = e4.FontLoader).catch((e4) => console.error(e4)), n2.TextGeometry ? a2.TextGeometry = n2.TextGeometry : import("./TextGeometry-8af4caf0.mjs").then((e4) => a2.TextGeometry = e4.TextGeometry).catch((e4) => console.error(e4));
  const o2 = a2;
}, 949: (t2, r2, n2) => {
  var a2, o2;
  t2.exports = (a2 = { ArcCurve: () => ArcCurve, BackSide: () => BackSide, Box3: () => Box3, BufferGeometry: () => BufferGeometry, Color: () => Color, DoubleSide: () => DoubleSide, EllipseCurve: () => EllipseCurve, FileLoader: () => FileLoader, Float32BufferAttribute: () => Float32BufferAttribute, FontLoader: () => FontLoader$2, FrontSide: () => FrontSide, Group: () => Group, InstancedBufferAttribute: () => InstancedBufferAttribute, InstancedBufferGeometry: () => InstancedBufferGeometry, Line: () => Line, LineBasicMaterial: () => LineBasicMaterial, LineDashedMaterial: () => LineDashedMaterial, LinearFilter: () => LinearFilter, Loader: () => Loader, Matrix3: () => Matrix3$1, Matrix4: () => Matrix4$1, Mesh: () => Mesh, MeshBasicMaterial: () => MeshBasicMaterial, MeshDepthMaterial: () => MeshDepthMaterial, MeshDistanceMaterial: () => MeshDistanceMaterial, MeshLambertMaterial: () => MeshLambertMaterial, MeshStandardMaterial: () => MeshStandardMaterial, Object3D: () => Object3D, PlaneGeometry: () => PlaneGeometry, Points: () => Points, PointsMaterial: () => PointsMaterial, RGBADepthPacking: () => RGBADepthPacking, ShaderChunk: () => ShaderChunk, Sphere: () => Sphere, TextGeometry: () => TextGeometry, Texture: () => Texture$1, UniformsLib: () => UniformsLib, UniformsUtils: () => UniformsUtils, Vector2: () => Vector2$1, Vector3: () => Vector3$1, Vector4: () => Vector4$1, XHRLoader: () => XHRLoader }, o2 = {}, n2.d(o2, a2), o2);
} }, r$1 = {};
function n$2(e3) {
  var a2 = r$1[e3];
  if (void 0 !== a2)
    return a2.exports;
  var o2 = r$1[e3] = { exports: {} };
  return t[e3].call(o2.exports, o2, o2.exports, n$2), o2.exports;
}
n$2.n = (e3) => {
  var t2 = e3 && e3.__esModule ? () => e3.default : () => e3;
  return n$2.d(t2, { a: t2 }), t2;
}, n$2.d = (e3, t2) => {
  for (var r2 in t2)
    n$2.o(t2, r2) && !n$2.o(e3, r2) && Object.defineProperty(e3, r2, { enumerable: true, get: t2[r2] });
}, n$2.o = (e3, t2) => Object.prototype.hasOwnProperty.call(e3, t2);
var a$3 = {};
(() => {
  n$2.d(a$3, { H: () => gt2, K: () => ht.Z });
  var e3 = n$2(949);
  function t2() {
    var e4 = /* @__PURE__ */ Object.create(null);
    function t3(n2, a2) {
      var o3 = n2.id, i3 = n2.name, s3 = n2.dependencies;
      void 0 === s3 && (s3 = []);
      var l3 = n2.init;
      void 0 === l3 && (l3 = function() {
      });
      var c3 = n2.getTransferables;
      if (void 0 === c3 && (c3 = null), !e4[o3])
        try {
          s3 = s3.map(function(r4) {
            return r4 && r4.isWorkerModule && (t3(r4, function(e5) {
              if (e5 instanceof Error)
                throw e5;
            }), r4 = e4[r4.id].value), r4;
          }), l3 = r3("<" + i3 + ">.init", l3), c3 && (c3 = r3("<" + i3 + ">.getTransferables", c3));
          var u3 = null;
          "function" == typeof l3 ? u3 = l3.apply(void 0, s3) : console.error("worker module init function failed to rehydrate"), e4[o3] = { id: o3, value: u3, getTransferables: c3 }, a2(u3);
        } catch (e5) {
          e5 && e5.noLog || console.error(e5), a2(e5);
        }
    }
    function r3(e5, t4) {
      var r4 = void 0;
      self.troikaDefine = function(e6) {
        return r4 = e6;
      };
      var n2 = URL.createObjectURL(new Blob(["/** " + e5.replace(/\*/g, "") + " **/\n\ntroikaDefine(\n" + t4 + "\n)"], { type: "application/javascript" }));
      try {
        importScripts(n2);
      } catch (e6) {
        console.error(e6);
      }
      return URL.revokeObjectURL(n2), delete self.troikaDefine, r4;
    }
    self.addEventListener("message", function(r4) {
      var n2 = r4.data, a2 = n2.messageId, o3 = n2.action, i3 = n2.data;
      try {
        "registerModule" === o3 && t3(i3, function(e5) {
          e5 instanceof Error ? postMessage({ messageId: a2, success: false, error: e5.message }) : postMessage({ messageId: a2, success: true, result: { isCallable: "function" == typeof e5 } });
        }), "callModule" === o3 && function(t4, r5) {
          var n3, a3 = t4.id, o4 = t4.args;
          e4[a3] && "function" == typeof e4[a3].value || r5(new Error("Worker module " + a3 + ": not found or its 'init' did not return a function"));
          try {
            var i4 = (n3 = e4[a3]).value.apply(n3, o4);
            i4 && "function" == typeof i4.then ? i4.then(s3, function(e5) {
              return r5(e5 instanceof Error ? e5 : new Error("" + e5));
            }) : s3(i4);
          } catch (e5) {
            r5(e5);
          }
          function s3(t5) {
            try {
              var n4 = e4[a3].getTransferables && e4[a3].getTransferables(t5);
              n4 && Array.isArray(n4) && n4.length || (n4 = void 0), r5(t5, n4);
            } catch (e5) {
              console.error(e5), r5(e5);
            }
          }
        }(i3, function(e5, t4) {
          e5 instanceof Error ? postMessage({ messageId: a2, success: false, error: e5.message }) : postMessage({ messageId: a2, success: true, result: e5 }, t4 || void 0);
        });
      } catch (e5) {
        postMessage({ messageId: a2, success: false, error: e5.stack });
      }
    });
  }
  var r2 = function() {
    var e4 = false;
    if ("undefined" != typeof window && void 0 !== window.document)
      try {
        new Worker(URL.createObjectURL(new Blob([""], { type: "application/javascript" }))).terminate(), e4 = true;
      } catch (e5) {
        console.log("Troika createWorkerModule: web workers not allowed; falling back to main thread execution. Cause: [" + e5.message + "]");
      }
    return r2 = function() {
      return e4;
    }, e4;
  }, o2 = 0, i2 = 0, s2 = false, l2 = /* @__PURE__ */ Object.create(null), c2 = /* @__PURE__ */ Object.create(null), u2 = /* @__PURE__ */ Object.create(null);
  function f2(e4) {
    if (!(e4 && "function" == typeof e4.init || s2))
      throw new Error("requires `options.init` function");
    var t3 = e4.dependencies, n2 = e4.init, a2 = e4.getTransferables, i3 = e4.workerId;
    if (!r2())
      return function(e5) {
        var t4 = function() {
          for (var e6 = [], r3 = arguments.length; r3--; )
            e6[r3] = arguments[r3];
          return t4._getInitResult().then(function(t5) {
            if ("function" == typeof t5)
              return t5.apply(void 0, e6);
            throw new Error("Worker module function was called but `init` did not return a callable function");
          });
        };
        return t4._getInitResult = function() {
          var r3 = e5.dependencies, n3 = e5.init;
          r3 = Array.isArray(r3) ? r3.map(function(e6) {
            return e6 && e6._getInitResult ? e6._getInitResult() : e6;
          }) : [];
          var a3 = Promise.all(r3).then(function(e6) {
            return n3.apply(null, e6);
          });
          return t4._getInitResult = function() {
            return a3;
          }, a3;
        }, t4;
      }(e4);
    null == i3 && (i3 = "#default");
    var l3 = "workerModule" + ++o2, u3 = e4.name || l3, v6 = null;
    function p3() {
      for (var e5 = [], t4 = arguments.length; t4--; )
        e5[t4] = arguments[t4];
      if (!v6) {
        v6 = h2(i3, "registerModule", p3.workerModuleData);
        var r3 = function() {
          v6 = null, c2[i3].delete(r3);
        };
        (c2[i3] || (c2[i3] = /* @__PURE__ */ new Set())).add(r3);
      }
      return v6.then(function(t5) {
        if (t5.isCallable)
          return h2(i3, "callModule", { id: l3, args: e5 });
        throw new Error("Worker module function was called but `init` did not return a callable function");
      });
    }
    return t3 = t3 && t3.map(function(e5) {
      return "function" != typeof e5 || e5.workerModuleData || (s2 = true, e5 = f2({ workerId: i3, name: "<" + u3 + "> function dependency: " + e5.name, init: "function(){return (\n" + d2(e5) + "\n)}" }), s2 = false), e5 && e5.workerModuleData && (e5 = e5.workerModuleData), e5;
    }), p3.workerModuleData = { isWorkerModule: true, id: l3, name: u3, dependencies: t3, init: d2(n2), getTransferables: a2 && d2(a2) }, p3;
  }
  function d2(e4) {
    var t3 = e4.toString();
    return !/^function/.test(t3) && /^\w+\s*\(/.test(t3) && (t3 = "function " + t3), t3;
  }
  function h2(e4, r3, n2) {
    return new Promise(function(a2, o3) {
      var s3 = ++i2;
      u2[s3] = function(e5) {
        e5.success ? a2(e5.result) : o3(new Error("Error in worker " + r3 + " call: " + e5.error));
      }, function(e5) {
        var r4 = l2[e5];
        if (!r4) {
          var n3 = d2(t2);
          (r4 = l2[e5] = new Worker(URL.createObjectURL(new Blob(["/** Worker Module Bootstrap: " + e5.replace(/\*/g, "") + " **/\n\n;(" + n3 + ")()"], { type: "application/javascript" })))).onmessage = function(e6) {
            var t3 = e6.data, r5 = t3.messageId, n4 = u2[r5];
            if (!n4)
              throw new Error("WorkerModule response with empty or unknown messageId");
            delete u2[r5], n4(t3);
          };
        }
        return r4;
      }(e4).postMessage({ messageId: s3, action: r3, data: n2 });
    });
  }
  function v5() {
    var e4 = function(e5) {
      function t3(e6, t4, r4, n3, a3, o4, i4, s4, l4, c4) {
        var u4 = 1 - l4;
        c4.x = u4 * u4 * u4 * e6 + 3 * u4 * u4 * l4 * r4 + 3 * u4 * l4 * l4 * a3 + l4 * l4 * l4 * i4, c4.y = u4 * u4 * u4 * t4 + 3 * u4 * u4 * l4 * n3 + 3 * u4 * l4 * l4 * o4 + l4 * l4 * l4 * s4;
      }
      function r3(e6, t4) {
        for (var r4, n3, a3, o4, i4, s4 = /([MLQCZ])([^MLQCZ]*)/g; r4 = s4.exec(e6); ) {
          var l4 = r4[2].replace(/^\s*|\s*$/g, "").split(/[,\s]+/).map(function(e7) {
            return parseFloat(e7);
          });
          switch (r4[1]) {
            case "M":
              o4 = n3 = l4[0], i4 = a3 = l4[1];
              break;
            case "L":
              l4[0] === o4 && l4[1] === i4 || t4("L", o4, i4, o4 = l4[0], i4 = l4[1]);
              break;
            case "Q":
              t4("Q", o4, i4, o4 = l4[2], i4 = l4[3], l4[0], l4[1]);
              break;
            case "C":
              t4("C", o4, i4, o4 = l4[4], i4 = l4[5], l4[0], l4[1], l4[2], l4[3]);
              break;
            case "Z":
              o4 === n3 && i4 === a3 || t4("L", o4, i4, n3, a3);
          }
        }
      }
      function n2(e6, n3, a3) {
        void 0 === a3 && (a3 = 16);
        var o4 = { x: 0, y: 0 };
        r3(e6, function(e7, r4, i4, s4, l4, c4, u4, f4, d4) {
          switch (e7) {
            case "L":
              n3(r4, i4, s4, l4);
              break;
            case "Q":
              for (var h4 = r4, v7 = i4, p4 = 1; p4 < a3; p4++)
                m4 = i4, x4 = u4, k4 = l4, U4 = 1 - (w4 = p4 / (a3 - 1)), (S4 = o4).x = U4 * U4 * r4 + 2 * U4 * w4 * c4 + w4 * w4 * s4, S4.y = U4 * U4 * m4 + 2 * U4 * w4 * x4 + w4 * w4 * k4, n3(h4, v7, o4.x, o4.y), h4 = o4.x, v7 = o4.y;
              break;
            case "C":
              for (var g4 = r4, b4 = i4, y4 = 1; y4 < a3; y4++)
                t3(r4, i4, c4, u4, f4, d4, s4, l4, y4 / (a3 - 1), o4), n3(g4, b4, o4.x, o4.y), g4 = o4.x, b4 = o4.y;
          }
          var m4, x4, k4, w4, S4, U4;
        });
      }
      var a2 = "precision highp float;attribute vec2 aUV;varying vec2 vUV;void main(){vUV=aUV;gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}", o3 = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){gl_FragColor=texture2D(tex,vUV);}", i3 = /* @__PURE__ */ new WeakMap(), s3 = { premultipliedAlpha: false, preserveDrawingBuffer: true, antialias: false, depth: false };
      function l3(e6, t4) {
        var r4 = e6.getContext ? e6.getContext("webgl", s3) : e6, n3 = i3.get(r4);
        if (!n3) {
          let d4 = function(e7) {
            var t5 = o4[e7];
            if (!t5 && !(t5 = o4[e7] = r4.getExtension(e7)))
              throw new Error(e7 + " not supported");
            return t5;
          }, h4 = function(e7, t5) {
            var n4 = r4.createShader(t5);
            return r4.shaderSource(n4, e7), r4.compileShader(n4), n4;
          }, v7 = function(e7, t5, n4, o5) {
            if (!l4[e7]) {
              var i4 = {}, s4 = {}, c5 = r4.createProgram();
              r4.attachShader(c5, h4(t5, r4.VERTEX_SHADER)), r4.attachShader(c5, h4(n4, r4.FRAGMENT_SHADER)), r4.linkProgram(c5), l4[e7] = { program: c5, transaction: function(e8) {
                r4.useProgram(c5), e8({ setUniform: function(e9, t6) {
                  for (var n5 = [], a4 = arguments.length - 2; a4-- > 0; )
                    n5[a4] = arguments[a4 + 2];
                  var o6 = s4[t6] || (s4[t6] = r4.getUniformLocation(c5, t6));
                  r4["uniform" + e9].apply(r4, [o6].concat(n5));
                }, setAttribute: function(e9, t6, n5, o6, s5) {
                  var l5 = i4[e9];
                  l5 || (l5 = i4[e9] = { buf: r4.createBuffer(), loc: r4.getAttribLocation(c5, e9), data: null }), r4.bindBuffer(r4.ARRAY_BUFFER, l5.buf), r4.vertexAttribPointer(l5.loc, t6, r4.FLOAT, false, 0, 0), r4.enableVertexAttribArray(l5.loc), a3 ? r4.vertexAttribDivisor(l5.loc, o6) : d4("ANGLE_instanced_arrays").vertexAttribDivisorANGLE(l5.loc, o6), s5 !== l5.data && (r4.bufferData(r4.ARRAY_BUFFER, s5, n5), l5.data = s5);
                } });
              } };
            }
            l4[e7].transaction(o5);
          }, p4 = function(e7, t5) {
            u4++;
            try {
              r4.activeTexture(r4.TEXTURE0 + u4);
              var n4 = c4[e7];
              n4 || (n4 = c4[e7] = r4.createTexture(), r4.bindTexture(r4.TEXTURE_2D, n4), r4.texParameteri(r4.TEXTURE_2D, r4.TEXTURE_MIN_FILTER, r4.NEAREST), r4.texParameteri(r4.TEXTURE_2D, r4.TEXTURE_MAG_FILTER, r4.NEAREST)), r4.bindTexture(r4.TEXTURE_2D, n4), t5(n4, u4);
            } finally {
              u4--;
            }
          }, g4 = function(e7, t5, n4) {
            var a4 = r4.createFramebuffer();
            f4.push(a4), r4.bindFramebuffer(r4.FRAMEBUFFER, a4), r4.activeTexture(r4.TEXTURE0 + t5), r4.bindTexture(r4.TEXTURE_2D, e7), r4.framebufferTexture2D(r4.FRAMEBUFFER, r4.COLOR_ATTACHMENT0, r4.TEXTURE_2D, e7, 0);
            try {
              n4(a4);
            } finally {
              r4.deleteFramebuffer(a4), r4.bindFramebuffer(r4.FRAMEBUFFER, f4[--f4.length - 1] || null);
            }
          }, b4 = function() {
            o4 = {}, l4 = {}, c4 = {}, u4 = -1, f4.length = 0;
          };
          var a3 = "undefined" != typeof WebGL2RenderingContext && r4 instanceof WebGL2RenderingContext, o4 = {}, l4 = {}, c4 = {}, u4 = -1, f4 = [];
          r4.canvas.addEventListener("webglcontextlost", function(e7) {
            b4(), e7.preventDefault();
          }, false), i3.set(r4, n3 = { gl: r4, isWebGL2: a3, getExtension: d4, withProgram: v7, withTexture: p4, withTextureFramebuffer: g4, handleContextLoss: b4 });
        }
        t4(n3);
      }
      function c3(e6, t4, r4, n3, i4, s4, c4, u4) {
        void 0 === c4 && (c4 = 15), void 0 === u4 && (u4 = null), l3(e6, function(e7) {
          var l4 = e7.gl, f4 = e7.withProgram;
          (0, e7.withTexture)("copy", function(e8, d4) {
            l4.texImage2D(l4.TEXTURE_2D, 0, l4.RGBA, i4, s4, 0, l4.RGBA, l4.UNSIGNED_BYTE, t4), f4("copy", a2, o3, function(e9) {
              var t5 = e9.setUniform;
              (0, e9.setAttribute)("aUV", 2, l4.STATIC_DRAW, 0, new Float32Array([0, 0, 2, 0, 0, 2])), t5("1i", "image", d4), l4.bindFramebuffer(l4.FRAMEBUFFER, u4 || null), l4.disable(l4.BLEND), l4.colorMask(8 & c4, 4 & c4, 2 & c4, 1 & c4), l4.viewport(r4, n3, i4, s4), l4.scissor(r4, n3, i4, s4), l4.drawArrays(l4.TRIANGLES, 0, 3);
            });
          });
        });
      }
      var u3 = Object.freeze({ __proto__: null, withWebGLContext: l3, renderImageData: c3, resizeWebGLCanvasWithoutClearing: function(e6, t4, r4) {
        var n3 = e6.width, a3 = e6.height;
        l3(e6, function(o4) {
          var i4 = o4.gl, s4 = new Uint8Array(n3 * a3 * 4);
          i4.readPixels(0, 0, n3, a3, i4.RGBA, i4.UNSIGNED_BYTE, s4), e6.width = t4, e6.height = r4, c3(i4, s4, 0, 0, n3, a3);
        });
      } });
      function f3(e6, t4, r4, a3, o4, i4) {
        void 0 === i4 && (i4 = 1);
        var s4 = new Uint8Array(e6 * t4), l4 = a3[2] - a3[0], c4 = a3[3] - a3[1], u4 = [];
        n2(r4, function(e7, t5, r5, n3) {
          u4.push({ x1: e7, y1: t5, x2: r5, y2: n3, minX: Math.min(e7, r5), minY: Math.min(t5, n3), maxX: Math.max(e7, r5), maxY: Math.max(t5, n3) });
        }), u4.sort(function(e7, t5) {
          return e7.maxX - t5.maxX;
        });
        for (var f4 = 0; f4 < e6; f4++)
          for (var d4 = 0; d4 < t4; d4++) {
            var h4 = g4(a3[0] + l4 * (f4 + 0.5) / e6, a3[1] + c4 * (d4 + 0.5) / t4), p4 = Math.pow(1 - Math.abs(h4) / o4, i4) / 2;
            h4 < 0 && (p4 = 1 - p4), p4 = Math.max(0, Math.min(255, Math.round(255 * p4))), s4[d4 * e6 + f4] = p4;
          }
        return s4;
        function g4(e7, t5) {
          for (var r5 = 1 / 0, n3 = 1 / 0, a4 = u4.length; a4--; ) {
            var o5 = u4[a4];
            if (o5.maxX + n3 <= e7)
              break;
            if (e7 + n3 > o5.minX && t5 - n3 < o5.maxY && t5 + n3 > o5.minY) {
              var i5 = v6(e7, t5, o5.x1, o5.y1, o5.x2, o5.y2);
              i5 < r5 && (r5 = i5, n3 = Math.sqrt(r5));
            }
          }
          return function(e8, t6) {
            for (var r6 = 0, n4 = u4.length; n4--; ) {
              var a5 = u4[n4];
              if (a5.maxX <= e8)
                break;
              a5.y1 > t6 != a5.y2 > t6 && e8 < (a5.x2 - a5.x1) * (t6 - a5.y1) / (a5.y2 - a5.y1) + a5.x1 && (r6 += a5.y1 < a5.y2 ? 1 : -1);
            }
            return 0 !== r6;
          }(e7, t5) && (n3 = -n3), n3;
        }
      }
      function d3(e6, t4, r4, n3, a3, o4, i4, s4, l4, c4) {
        void 0 === o4 && (o4 = 1), void 0 === s4 && (s4 = 0), void 0 === l4 && (l4 = 0), void 0 === c4 && (c4 = 0), h3(e6, t4, r4, n3, a3, o4, i4, null, s4, l4, c4);
      }
      function h3(e6, t4, r4, n3, a3, o4, i4, s4, l4, u4, d4) {
        void 0 === o4 && (o4 = 1), void 0 === l4 && (l4 = 0), void 0 === u4 && (u4 = 0), void 0 === d4 && (d4 = 0);
        for (var h4 = f3(e6, t4, r4, n3, a3, o4), v7 = new Uint8Array(4 * h4.length), p4 = 0; p4 < h4.length; p4++)
          v7[4 * p4 + d4] = h4[p4];
        c3(i4, v7, l4, u4, e6, t4, 1 << 3 - d4, s4);
      }
      function v6(e6, t4, r4, n3, a3, o4) {
        var i4 = a3 - r4, s4 = o4 - n3, l4 = i4 * i4 + s4 * s4, c4 = l4 ? Math.max(0, Math.min(1, ((e6 - r4) * i4 + (t4 - n3) * s4) / l4)) : 0, u4 = e6 - (r4 + c4 * i4), f4 = t4 - (n3 + c4 * s4);
        return u4 * u4 + f4 * f4;
      }
      var p3 = Object.freeze({ __proto__: null, generate: f3, generateIntoCanvas: d3, generateIntoFramebuffer: h3 }), g3 = "precision highp float;uniform vec4 uGlyphBounds;attribute vec2 aUV;attribute vec4 aLineSegment;varying vec4 vLineSegment;varying vec2 vGlyphXY;void main(){vLineSegment=aLineSegment;vGlyphXY=mix(uGlyphBounds.xy,uGlyphBounds.zw,aUV);gl_Position=vec4(mix(vec2(-1.0),vec2(1.0),aUV),0.0,1.0);}", b3 = "precision highp float;uniform vec4 uGlyphBounds;uniform float uMaxDistance;uniform float uExponent;varying vec4 vLineSegment;varying vec2 vGlyphXY;float absDistToSegment(vec2 point,vec2 lineA,vec2 lineB){vec2 lineDir=lineB-lineA;float lenSq=dot(lineDir,lineDir);float t=lenSq==0.0 ? 0.0 : clamp(dot(point-lineA,lineDir)/lenSq,0.0,1.0);vec2 linePt=lineA+t*lineDir;return distance(point,linePt);}void main(){vec4 seg=vLineSegment;vec2 p=vGlyphXY;float dist=absDistToSegment(p,seg.xy,seg.zw);float val=pow(1.0-clamp(dist/uMaxDistance,0.0,1.0),uExponent)*0.5;bool crossing=(seg.y>p.y!=seg.w>p.y)&&(p.x<(seg.z-seg.x)*(p.y-seg.y)/(seg.w-seg.y)+seg.x);bool crossingUp=crossing&&vLineSegment.y<vLineSegment.w;gl_FragColor=vec4(crossingUp ? 1.0/255.0 : 0.0,crossing&&!crossingUp ? 1.0/255.0 : 0.0,0.0,val);}", y3 = "precision highp float;uniform sampler2D tex;varying vec2 vUV;void main(){vec4 color=texture2D(tex,vUV);bool inside=color.r!=color.g;float val=inside ? 1.0-color.a : color.a;gl_FragColor=vec4(val);}", m3 = new Float32Array([0, 0, 2, 0, 0, 2]), x3 = null, k3 = false, w3 = {}, S3 = /* @__PURE__ */ new WeakMap();
      function U3(e6) {
        if (!k3 && !F3(e6))
          throw new Error("WebGL generation not supported");
      }
      function T3(e6, t4, r4, n3, a3, o4, i4) {
        if (void 0 === o4 && (o4 = 1), void 0 === i4 && (i4 = null), !i4 && !(i4 = x3)) {
          var s4 = "function" == typeof OffscreenCanvas ? new OffscreenCanvas(1, 1) : "undefined" != typeof document ? document.createElement("canvas") : null;
          if (!s4)
            throw new Error("OffscreenCanvas or DOM canvas not supported");
          i4 = x3 = s4.getContext("webgl", { depth: false });
        }
        U3(i4);
        var c4 = new Uint8Array(e6 * t4 * 4);
        l3(i4, function(i5) {
          var s5 = i5.gl, l4 = i5.withTexture, u5 = i5.withTextureFramebuffer;
          l4("readable", function(i6, l5) {
            s5.texImage2D(s5.TEXTURE_2D, 0, s5.RGBA, e6, t4, 0, s5.RGBA, s5.UNSIGNED_BYTE, null), u5(i6, l5, function(i7) {
              E4(e6, t4, r4, n3, a3, o4, s5, i7, 0, 0, 0), s5.readPixels(0, 0, e6, t4, s5.RGBA, s5.UNSIGNED_BYTE, c4);
            });
          });
        });
        for (var u4 = new Uint8Array(e6 * t4), f4 = 0, d4 = 0; f4 < c4.length; f4 += 4)
          u4[d4++] = c4[f4];
        return u4;
      }
      function _3(e6, t4, r4, n3, a3, o4, i4, s4, l4, c4) {
        void 0 === o4 && (o4 = 1), void 0 === s4 && (s4 = 0), void 0 === l4 && (l4 = 0), void 0 === c4 && (c4 = 0), E4(e6, t4, r4, n3, a3, o4, i4, null, s4, l4, c4);
      }
      function E4(e6, t4, r4, o4, i4, s4, c4, u4, f4, d4, h4) {
        void 0 === s4 && (s4 = 1), void 0 === f4 && (f4 = 0), void 0 === d4 && (d4 = 0), void 0 === h4 && (h4 = 0), U3(c4);
        var v7 = [];
        n2(r4, function(e7, t5, r5, n3) {
          v7.push(e7, t5, r5, n3);
        }), v7 = new Float32Array(v7), l3(c4, function(r5) {
          var n3 = r5.gl, l4 = r5.isWebGL2, c5 = r5.getExtension, p4 = r5.withProgram, x4 = r5.withTexture, k4 = r5.withTextureFramebuffer, w4 = r5.handleContextLoss;
          if (x4("rawDistances", function(r6, x5) {
            e6 === r6._lastWidth && t4 === r6._lastHeight || n3.texImage2D(n3.TEXTURE_2D, 0, n3.RGBA, r6._lastWidth = e6, r6._lastHeight = t4, 0, n3.RGBA, n3.UNSIGNED_BYTE, null), p4("main", g3, b3, function(a3) {
              var u5 = a3.setAttribute, f5 = a3.setUniform, d5 = !l4 && c5("ANGLE_instanced_arrays"), h5 = !l4 && c5("EXT_blend_minmax");
              u5("aUV", 2, n3.STATIC_DRAW, 0, m3), u5("aLineSegment", 4, n3.DYNAMIC_DRAW, 1, v7), f5.apply(void 0, ["4f", "uGlyphBounds"].concat(o4)), f5("1f", "uMaxDistance", i4), f5("1f", "uExponent", s4), k4(r6, x5, function(r7) {
                n3.enable(n3.BLEND), n3.colorMask(true, true, true, true), n3.viewport(0, 0, e6, t4), n3.scissor(0, 0, e6, t4), n3.blendFunc(n3.ONE, n3.ONE), n3.blendEquationSeparate(n3.FUNC_ADD, l4 ? n3.MAX : h5.MAX_EXT), n3.clear(n3.COLOR_BUFFER_BIT), l4 ? n3.drawArraysInstanced(n3.TRIANGLES, 0, 3, v7.length / 4) : d5.drawArraysInstancedANGLE(n3.TRIANGLES, 0, 3, v7.length / 4);
              });
            }), p4("post", a2, y3, function(r7) {
              r7.setAttribute("aUV", 2, n3.STATIC_DRAW, 0, m3), r7.setUniform("1i", "tex", x5), n3.bindFramebuffer(n3.FRAMEBUFFER, u4), n3.disable(n3.BLEND), n3.colorMask(0 === h4, 1 === h4, 2 === h4, 3 === h4), n3.viewport(f4, d4, e6, t4), n3.scissor(f4, d4, e6, t4), n3.drawArrays(n3.TRIANGLES, 0, 3);
            });
          }), n3.isContextLost())
            throw w4(), new Error("webgl context lost");
        });
      }
      function F3(e6) {
        var t4 = e6 && e6 !== x3 ? e6.canvas || e6 : w3, r4 = S3.get(t4);
        if (void 0 === r4) {
          k3 = true;
          var n3 = null;
          try {
            var a3 = [97, 106, 97, 61, 99, 137, 118, 80, 80, 118, 137, 99, 61, 97, 106, 97], o4 = T3(4, 4, "M8,8L16,8L24,24L16,24Z", [0, 0, 32, 32], 24, 1, e6);
            (r4 = o4 && a3.length === o4.length && o4.every(function(e7, t5) {
              return e7 === a3[t5];
            })) || (n3 = "bad trial run results", console.info(a3, o4));
          } catch (e7) {
            r4 = false, n3 = e7.message;
          }
          n3 && console.warn("WebGL SDF generation not supported:", n3), k3 = false, S3.set(t4, r4);
        }
        return r4;
      }
      var C3 = Object.freeze({ __proto__: null, generate: T3, generateIntoCanvas: _3, generateIntoFramebuffer: E4, isSupported: F3 });
      return e5.forEachPathCommand = r3, e5.generate = function(e6, t4, r4, n3, a3, o4) {
        void 0 === a3 && (a3 = Math.max(n3[2] - n3[0], n3[3] - n3[1]) / 2), void 0 === o4 && (o4 = 1);
        try {
          return T3.apply(C3, arguments);
        } catch (e7) {
          return console.info("WebGL SDF generation failed, falling back to JS", e7), f3.apply(p3, arguments);
        }
      }, e5.generateIntoCanvas = function(e6, t4, r4, n3, a3, o4, i4, s4, l4, c4) {
        void 0 === a3 && (a3 = Math.max(n3[2] - n3[0], n3[3] - n3[1]) / 2), void 0 === o4 && (o4 = 1), void 0 === s4 && (s4 = 0), void 0 === l4 && (l4 = 0), void 0 === c4 && (c4 = 0);
        try {
          return _3.apply(C3, arguments);
        } catch (e7) {
          return console.info("WebGL SDF generation failed, falling back to JS", e7), d3.apply(p3, arguments);
        }
      }, e5.javascript = p3, e5.pathToLineSegments = n2, e5.webgl = C3, e5.webglUtils = u3, Object.defineProperty(e5, "__esModule", { value: true }), e5;
    }({});
    return e4;
  }
  const p2 = /\bvoid\s+main\s*\(\s*\)\s*{/g;
  function g2(t3) {
    return t3.replace(/^[ \t]*#include +<([\w\d./]+)>/gm, function(t4, r3) {
      let n2 = e3.ShaderChunk[r3];
      return n2 ? g2(n2) : t4;
    });
  }
  const b2 = [];
  for (let e4 = 0; e4 < 256; e4++)
    b2[e4] = (e4 < 16 ? "0" : "") + e4.toString(16);
  const y2 = Object.assign || function() {
    let e4 = arguments[0];
    for (let t3 = 1, r3 = arguments.length; t3 < r3; t3++) {
      let r4 = arguments[t3];
      if (r4)
        for (let t4 in r4)
          Object.prototype.hasOwnProperty.call(r4, t4) && (e4[t4] = r4[t4]);
    }
    return e4;
  }, m2 = Date.now(), x2 = /* @__PURE__ */ new WeakMap(), k2 = /* @__PURE__ */ new Map();
  let w2 = 1e10;
  function S2(t3, r3) {
    const n2 = function(e4) {
      const t4 = JSON.stringify(e4, T2);
      let r4 = E3.get(t4);
      return null == r4 && E3.set(t4, r4 = ++_2), r4;
    }(r3);
    let a2 = x2.get(t3);
    if (a2 || x2.set(t3, a2 = /* @__PURE__ */ Object.create(null)), a2[n2])
      return new a2[n2]();
    const o3 = `_onBeforeCompile${n2}`, i3 = function(e4, a3) {
      t3.onBeforeCompile.call(this, e4, a3);
      const i4 = this.customProgramCacheKey() + "|" + e4.vertexShader + "|" + e4.fragmentShader;
      let s4 = k2[i4];
      if (!s4) {
        const t4 = function(e5, { vertexShader: t5, fragmentShader: r4 }, n3, a4) {
          let { vertexDefs: o4, vertexMainIntro: i5, vertexMainOutro: s5, vertexTransform: l4, fragmentDefs: c4, fragmentMainIntro: u3, fragmentMainOutro: f3, fragmentColorTransform: d3, customRewriter: h3, timeUniform: v6 } = n3;
          if (o4 = o4 || "", i5 = i5 || "", s5 = s5 || "", c4 = c4 || "", u3 = u3 || "", f3 = f3 || "", (l4 || h3) && (t5 = g2(t5)), (d3 || h3) && (r4 = g2(r4 = r4.replace(/^[ \t]*#include <((?:tonemapping|encodings|fog|premultiplied_alpha|dithering)_fragment)>/gm, "\n//!BEGIN_POST_CHUNK $1\n$&\n//!END_POST_CHUNK\n"))), h3) {
            let e6 = h3({ vertexShader: t5, fragmentShader: r4 });
            t5 = e6.vertexShader, r4 = e6.fragmentShader;
          }
          if (d3) {
            let e6 = [];
            r4 = r4.replace(/^\/\/!BEGIN_POST_CHUNK[^]+?^\/\/!END_POST_CHUNK/gm, (t6) => (e6.push(t6), "")), f3 = `${d3}
${e6.join("\n")}
${f3}`;
          }
          if (v6) {
            const e6 = `
uniform float ${v6};
`;
            o4 = e6 + o4, c4 = e6 + c4;
          }
          return l4 && (o4 = `${o4}
void troikaVertexTransform${a4}(inout vec3 position, inout vec3 normal, inout vec2 uv) {
  ${l4}
}
`, i5 = `
troika_position_${a4} = vec3(position);
troika_normal_${a4} = vec3(normal);
troika_uv_${a4} = vec2(uv);
troikaVertexTransform${a4}(troika_position_${a4}, troika_normal_${a4}, troika_uv_${a4});
${i5}
`, t5 = (t5 = `vec3 troika_position_${a4};
vec3 troika_normal_${a4};
vec2 troika_uv_${a4};
${t5}
`).replace(/\b(position|normal|uv)\b/g, (e6, t6, r5, n4) => /\battribute\s+vec[23]\s+$/.test(n4.substr(0, r5)) ? t6 : `troika_${t6}_${a4}`), e5.map && e5.map.channel > 0 || (t5 = t5.replace(/\bMAP_UV\b/g, `troika_uv_${a4}`))), { vertexShader: t5 = U2(t5, a4, o4, i5, s5), fragmentShader: r4 = U2(r4, a4, c4, u3, f3) };
        }(this, e4, r3, n2);
        s4 = k2[i4] = t4;
      }
      e4.vertexShader = s4.vertexShader, e4.fragmentShader = s4.fragmentShader, y2(e4.uniforms, this.uniforms), r3.timeUniform && (e4.uniforms[r3.timeUniform] = { get value() {
        return Date.now() - m2;
      } }), this[o3] && this[o3](e4);
    }, s3 = function() {
      return l3(r3.chained ? t3 : t3.clone());
    }, l3 = function(e4) {
      const a3 = Object.create(e4, c3);
      return Object.defineProperty(a3, "baseMaterial", { value: t3 }), Object.defineProperty(a3, "id", { value: w2++ }), a3.uuid = function() {
        const e5 = 4294967295 * Math.random() | 0, t4 = 4294967295 * Math.random() | 0, r4 = 4294967295 * Math.random() | 0, n3 = 4294967295 * Math.random() | 0;
        return (b2[255 & e5] + b2[e5 >> 8 & 255] + b2[e5 >> 16 & 255] + b2[e5 >> 24 & 255] + "-" + b2[255 & t4] + b2[t4 >> 8 & 255] + "-" + b2[t4 >> 16 & 15 | 64] + b2[t4 >> 24 & 255] + "-" + b2[63 & r4 | 128] + b2[r4 >> 8 & 255] + "-" + b2[r4 >> 16 & 255] + b2[r4 >> 24 & 255] + b2[255 & n3] + b2[n3 >> 8 & 255] + b2[n3 >> 16 & 255] + b2[n3 >> 24 & 255]).toUpperCase();
      }(), a3.uniforms = y2({}, e4.uniforms, r3.uniforms), a3.defines = y2({}, e4.defines, r3.defines), a3.defines[`TROIKA_DERIVED_MATERIAL_${n2}`] = "", a3.extensions = y2({}, e4.extensions, r3.extensions), a3._listeners = void 0, a3;
    }, c3 = { constructor: { value: s3 }, isDerivedMaterial: { value: true }, customProgramCacheKey: { writable: true, configurable: true, value: function() {
      return t3.customProgramCacheKey() + "|" + n2;
    } }, onBeforeCompile: { get: () => i3, set(e4) {
      this[o3] = e4;
    } }, copy: { writable: true, configurable: true, value: function(r4) {
      return t3.copy.call(this, r4), t3.isShaderMaterial || t3.isDerivedMaterial || (y2(this.extensions, r4.extensions), y2(this.defines, r4.defines), y2(this.uniforms, e3.UniformsUtils.clone(r4.uniforms))), this;
    } }, clone: { writable: true, configurable: true, value: function() {
      const e4 = new t3.constructor();
      return l3(e4).copy(this);
    } }, getDepthMaterial: { writable: true, configurable: true, value: function() {
      let n3 = this._depthMaterial;
      return n3 || (n3 = this._depthMaterial = S2(t3.isDerivedMaterial ? t3.getDepthMaterial() : new e3.MeshDepthMaterial({ depthPacking: e3.RGBADepthPacking }), r3), n3.defines.IS_DEPTH_MATERIAL = "", n3.uniforms = this.uniforms), n3;
    } }, getDistanceMaterial: { writable: true, configurable: true, value: function() {
      let n3 = this._distanceMaterial;
      return n3 || (n3 = this._distanceMaterial = S2(t3.isDerivedMaterial ? t3.getDistanceMaterial() : new e3.MeshDistanceMaterial(), r3), n3.defines.IS_DISTANCE_MATERIAL = "", n3.uniforms = this.uniforms), n3;
    } }, dispose: { writable: true, configurable: true, value() {
      const { _depthMaterial: e4, _distanceMaterial: r4 } = this;
      e4 && e4.dispose(), r4 && r4.dispose(), t3.dispose.call(this);
    } } };
    return a2[n2] = s3, new s3();
  }
  function U2(e4, t3, r3, n2, a2) {
    return (n2 || a2 || r3) && (e4 = e4.replace(p2, `
${r3}
void troikaOrigMain${t3}() {`), e4 += `
void main() {
  ${n2}
  troikaOrigMain${t3}();
  ${a2}
}`), e4;
  }
  function T2(e4, t3) {
    return "uniforms" === e4 ? void 0 : "function" == typeof t3 ? t3.toString() : t3;
  }
  let _2 = 0;
  const E3 = /* @__PURE__ */ new Map();
  e3.DoubleSide;
  const F2 = f2({ name: "Typr Font Parser", dependencies: [function() {
    return "undefined" == typeof window && (self.window = self), function(e4) {
      var t3 = { parse: function(e5) {
        var r4 = t3._bin, n3 = new Uint8Array(e5);
        if ("ttcf" == r4.readASCII(n3, 0, 4)) {
          var a2 = 4;
          r4.readUshort(n3, a2), a2 += 2, r4.readUshort(n3, a2), a2 += 2;
          var o3 = r4.readUint(n3, a2);
          a2 += 4;
          for (var i3 = [], s3 = 0; s3 < o3; s3++) {
            var l3 = r4.readUint(n3, a2);
            a2 += 4, i3.push(t3._readFont(n3, l3));
          }
          return i3;
        }
        return [t3._readFont(n3, 0)];
      }, _readFont: function(e5, r4) {
        var n3 = t3._bin, a2 = r4;
        n3.readFixed(e5, r4), r4 += 4;
        var o3 = n3.readUshort(e5, r4);
        r4 += 2, n3.readUshort(e5, r4), r4 += 2, n3.readUshort(e5, r4), r4 += 2, n3.readUshort(e5, r4), r4 += 2;
        for (var i3 = ["cmap", "head", "hhea", "maxp", "hmtx", "name", "OS/2", "post", "loca", "glyf", "kern", "CFF ", "GPOS", "GSUB", "SVG "], s3 = { _data: e5, _offset: a2 }, l3 = {}, c3 = 0; c3 < o3; c3++) {
          var u3 = n3.readASCII(e5, r4, 4);
          r4 += 4, n3.readUint(e5, r4), r4 += 4;
          var f3 = n3.readUint(e5, r4);
          r4 += 4;
          var d3 = n3.readUint(e5, r4);
          r4 += 4, l3[u3] = { offset: f3, length: d3 };
        }
        for (c3 = 0; c3 < i3.length; c3++) {
          var h3 = i3[c3];
          l3[h3] && (s3[h3.trim()] = t3[h3.trim()].parse(e5, l3[h3].offset, l3[h3].length, s3));
        }
        return s3;
      }, _tabOffset: function(e5, r4, n3) {
        for (var a2 = t3._bin, o3 = a2.readUshort(e5, n3 + 4), i3 = n3 + 12, s3 = 0; s3 < o3; s3++) {
          var l3 = a2.readASCII(e5, i3, 4);
          i3 += 4, a2.readUint(e5, i3), i3 += 4;
          var c3 = a2.readUint(e5, i3);
          if (i3 += 4, a2.readUint(e5, i3), i3 += 4, l3 == r4)
            return c3;
        }
        return 0;
      } };
      t3._bin = { readFixed: function(e5, t4) {
        return (e5[t4] << 8 | e5[t4 + 1]) + (e5[t4 + 2] << 8 | e5[t4 + 3]) / 65540;
      }, readF2dot14: function(e5, r4) {
        return t3._bin.readShort(e5, r4) / 16384;
      }, readInt: function(e5, r4) {
        return t3._bin._view(e5).getInt32(r4);
      }, readInt8: function(e5, r4) {
        return t3._bin._view(e5).getInt8(r4);
      }, readShort: function(e5, r4) {
        return t3._bin._view(e5).getInt16(r4);
      }, readUshort: function(e5, r4) {
        return t3._bin._view(e5).getUint16(r4);
      }, readUshorts: function(e5, r4, n3) {
        for (var a2 = [], o3 = 0; o3 < n3; o3++)
          a2.push(t3._bin.readUshort(e5, r4 + 2 * o3));
        return a2;
      }, readUint: function(e5, r4) {
        return t3._bin._view(e5).getUint32(r4);
      }, readUint64: function(e5, r4) {
        return 4294967296 * t3._bin.readUint(e5, r4) + t3._bin.readUint(e5, r4 + 4);
      }, readASCII: function(e5, t4, r4) {
        for (var n3 = "", a2 = 0; a2 < r4; a2++)
          n3 += String.fromCharCode(e5[t4 + a2]);
        return n3;
      }, readUnicode: function(e5, t4, r4) {
        for (var n3 = "", a2 = 0; a2 < r4; a2++) {
          var o3 = e5[t4++] << 8 | e5[t4++];
          n3 += String.fromCharCode(o3);
        }
        return n3;
      }, _tdec: "undefined" != typeof window && window.TextDecoder ? new window.TextDecoder() : null, readUTF8: function(e5, r4, n3) {
        var a2 = t3._bin._tdec;
        return a2 && 0 == r4 && n3 == e5.length ? a2.decode(e5) : t3._bin.readASCII(e5, r4, n3);
      }, readBytes: function(e5, t4, r4) {
        for (var n3 = [], a2 = 0; a2 < r4; a2++)
          n3.push(e5[t4 + a2]);
        return n3;
      }, readASCIIArray: function(e5, t4, r4) {
        for (var n3 = [], a2 = 0; a2 < r4; a2++)
          n3.push(String.fromCharCode(e5[t4 + a2]));
        return n3;
      }, _view: function(e5) {
        return e5._dataView || (e5._dataView = e5.buffer ? new DataView(e5.buffer, e5.byteOffset, e5.byteLength) : new DataView(new Uint8Array(e5).buffer));
      } }, t3._lctf = {}, t3._lctf.parse = function(e5, r4, n3, a2, o3) {
        var i3 = t3._bin, s3 = {}, l3 = r4;
        i3.readFixed(e5, r4), r4 += 4;
        var c3 = i3.readUshort(e5, r4);
        r4 += 2;
        var u3 = i3.readUshort(e5, r4);
        r4 += 2;
        var f3 = i3.readUshort(e5, r4);
        return r4 += 2, s3.scriptList = t3._lctf.readScriptList(e5, l3 + c3), s3.featureList = t3._lctf.readFeatureList(e5, l3 + u3), s3.lookupList = t3._lctf.readLookupList(e5, l3 + f3, o3), s3;
      }, t3._lctf.readLookupList = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = r4, i3 = [], s3 = a2.readUshort(e5, r4);
        r4 += 2;
        for (var l3 = 0; l3 < s3; l3++) {
          var c3 = a2.readUshort(e5, r4);
          r4 += 2;
          var u3 = t3._lctf.readLookupTable(e5, o3 + c3, n3);
          i3.push(u3);
        }
        return i3;
      }, t3._lctf.readLookupTable = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = r4, i3 = { tabs: [] };
        i3.ltype = a2.readUshort(e5, r4), r4 += 2, i3.flag = a2.readUshort(e5, r4), r4 += 2;
        var s3 = a2.readUshort(e5, r4);
        r4 += 2;
        for (var l3 = i3.ltype, c3 = 0; c3 < s3; c3++) {
          var u3 = a2.readUshort(e5, r4);
          r4 += 2;
          var f3 = n3(e5, l3, o3 + u3, i3);
          i3.tabs.push(f3);
        }
        return i3;
      }, t3._lctf.numOfOnes = function(e5) {
        for (var t4 = 0, r4 = 0; r4 < 32; r4++)
          0 != (e5 >>> r4 & 1) && t4++;
        return t4;
      }, t3._lctf.readClassDef = function(e5, r4) {
        var n3 = t3._bin, a2 = [], o3 = n3.readUshort(e5, r4);
        if (r4 += 2, 1 == o3) {
          var i3 = n3.readUshort(e5, r4);
          r4 += 2;
          var s3 = n3.readUshort(e5, r4);
          r4 += 2;
          for (var l3 = 0; l3 < s3; l3++)
            a2.push(i3 + l3), a2.push(i3 + l3), a2.push(n3.readUshort(e5, r4)), r4 += 2;
        }
        if (2 == o3) {
          var c3 = n3.readUshort(e5, r4);
          for (r4 += 2, l3 = 0; l3 < c3; l3++)
            a2.push(n3.readUshort(e5, r4)), r4 += 2, a2.push(n3.readUshort(e5, r4)), r4 += 2, a2.push(n3.readUshort(e5, r4)), r4 += 2;
        }
        return a2;
      }, t3._lctf.getInterval = function(e5, t4) {
        for (var r4 = 0; r4 < e5.length; r4 += 3) {
          var n3 = e5[r4], a2 = e5[r4 + 1];
          if (e5[r4 + 2], n3 <= t4 && t4 <= a2)
            return r4;
        }
        return -1;
      }, t3._lctf.readCoverage = function(e5, r4) {
        var n3 = t3._bin, a2 = {};
        a2.fmt = n3.readUshort(e5, r4), r4 += 2;
        var o3 = n3.readUshort(e5, r4);
        return r4 += 2, 1 == a2.fmt && (a2.tab = n3.readUshorts(e5, r4, o3)), 2 == a2.fmt && (a2.tab = n3.readUshorts(e5, r4, 3 * o3)), a2;
      }, t3._lctf.coverageIndex = function(e5, r4) {
        var n3 = e5.tab;
        if (1 == e5.fmt)
          return n3.indexOf(r4);
        if (2 == e5.fmt) {
          var a2 = t3._lctf.getInterval(n3, r4);
          if (-1 != a2)
            return n3[a2 + 2] + (r4 - n3[a2]);
        }
        return -1;
      }, t3._lctf.readFeatureList = function(e5, r4) {
        var n3 = t3._bin, a2 = r4, o3 = [], i3 = n3.readUshort(e5, r4);
        r4 += 2;
        for (var s3 = 0; s3 < i3; s3++) {
          var l3 = n3.readASCII(e5, r4, 4);
          r4 += 4;
          var c3 = n3.readUshort(e5, r4);
          r4 += 2;
          var u3 = t3._lctf.readFeatureTable(e5, a2 + c3);
          u3.tag = l3.trim(), o3.push(u3);
        }
        return o3;
      }, t3._lctf.readFeatureTable = function(e5, r4) {
        var n3 = t3._bin, a2 = r4, o3 = {}, i3 = n3.readUshort(e5, r4);
        r4 += 2, i3 > 0 && (o3.featureParams = a2 + i3);
        var s3 = n3.readUshort(e5, r4);
        r4 += 2, o3.tab = [];
        for (var l3 = 0; l3 < s3; l3++)
          o3.tab.push(n3.readUshort(e5, r4 + 2 * l3));
        return o3;
      }, t3._lctf.readScriptList = function(e5, r4) {
        var n3 = t3._bin, a2 = r4, o3 = {}, i3 = n3.readUshort(e5, r4);
        r4 += 2;
        for (var s3 = 0; s3 < i3; s3++) {
          var l3 = n3.readASCII(e5, r4, 4);
          r4 += 4;
          var c3 = n3.readUshort(e5, r4);
          r4 += 2, o3[l3.trim()] = t3._lctf.readScriptTable(e5, a2 + c3);
        }
        return o3;
      }, t3._lctf.readScriptTable = function(e5, r4) {
        var n3 = t3._bin, a2 = r4, o3 = {}, i3 = n3.readUshort(e5, r4);
        r4 += 2, i3 > 0 && (o3.default = t3._lctf.readLangSysTable(e5, a2 + i3));
        var s3 = n3.readUshort(e5, r4);
        r4 += 2;
        for (var l3 = 0; l3 < s3; l3++) {
          var c3 = n3.readASCII(e5, r4, 4);
          r4 += 4;
          var u3 = n3.readUshort(e5, r4);
          r4 += 2, o3[c3.trim()] = t3._lctf.readLangSysTable(e5, a2 + u3);
        }
        return o3;
      }, t3._lctf.readLangSysTable = function(e5, r4) {
        var n3 = t3._bin, a2 = {};
        n3.readUshort(e5, r4), r4 += 2, a2.reqFeature = n3.readUshort(e5, r4), r4 += 2;
        var o3 = n3.readUshort(e5, r4);
        return r4 += 2, a2.features = n3.readUshorts(e5, r4, o3), a2;
      }, t3.CFF = {}, t3.CFF.parse = function(e5, r4, n3) {
        var a2 = t3._bin;
        (e5 = new Uint8Array(e5.buffer, r4, n3))[r4 = 0], e5[++r4], e5[++r4], e5[++r4], r4++;
        var o3 = [];
        r4 = t3.CFF.readIndex(e5, r4, o3);
        for (var i3 = [], s3 = 0; s3 < o3.length - 1; s3++)
          i3.push(a2.readASCII(e5, r4 + o3[s3], o3[s3 + 1] - o3[s3]));
        r4 += o3[o3.length - 1];
        var l3 = [];
        r4 = t3.CFF.readIndex(e5, r4, l3);
        var c3 = [];
        for (s3 = 0; s3 < l3.length - 1; s3++)
          c3.push(t3.CFF.readDict(e5, r4 + l3[s3], r4 + l3[s3 + 1]));
        r4 += l3[l3.length - 1];
        var u3 = c3[0], f3 = [];
        r4 = t3.CFF.readIndex(e5, r4, f3);
        var d3 = [];
        for (s3 = 0; s3 < f3.length - 1; s3++)
          d3.push(a2.readASCII(e5, r4 + f3[s3], f3[s3 + 1] - f3[s3]));
        if (r4 += f3[f3.length - 1], t3.CFF.readSubrs(e5, r4, u3), u3.CharStrings) {
          r4 = u3.CharStrings, f3 = [], r4 = t3.CFF.readIndex(e5, r4, f3);
          var h3 = [];
          for (s3 = 0; s3 < f3.length - 1; s3++)
            h3.push(a2.readBytes(e5, r4 + f3[s3], f3[s3 + 1] - f3[s3]));
          u3.CharStrings = h3;
        }
        if (u3.ROS) {
          r4 = u3.FDArray;
          var v6 = [];
          for (r4 = t3.CFF.readIndex(e5, r4, v6), u3.FDArray = [], s3 = 0; s3 < v6.length - 1; s3++) {
            var p3 = t3.CFF.readDict(e5, r4 + v6[s3], r4 + v6[s3 + 1]);
            t3.CFF._readFDict(e5, p3, d3), u3.FDArray.push(p3);
          }
          r4 += v6[v6.length - 1], r4 = u3.FDSelect, u3.FDSelect = [];
          var g3 = e5[r4];
          if (r4++, 3 != g3)
            throw g3;
          var b3 = a2.readUshort(e5, r4);
          for (r4 += 2, s3 = 0; s3 < b3 + 1; s3++)
            u3.FDSelect.push(a2.readUshort(e5, r4), e5[r4 + 2]), r4 += 3;
        }
        return u3.Encoding && (u3.Encoding = t3.CFF.readEncoding(e5, u3.Encoding, u3.CharStrings.length)), u3.charset && (u3.charset = t3.CFF.readCharset(e5, u3.charset, u3.CharStrings.length)), t3.CFF._readFDict(e5, u3, d3), u3;
      }, t3.CFF._readFDict = function(e5, r4, n3) {
        var a2;
        for (var o3 in r4.Private && (a2 = r4.Private[1], r4.Private = t3.CFF.readDict(e5, a2, a2 + r4.Private[0]), r4.Private.Subrs && t3.CFF.readSubrs(e5, a2 + r4.Private.Subrs, r4.Private)), r4)
          -1 != ["FamilyName", "FontName", "FullName", "Notice", "version", "Copyright"].indexOf(o3) && (r4[o3] = n3[r4[o3] - 426 + 35]);
      }, t3.CFF.readSubrs = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = [];
        r4 = t3.CFF.readIndex(e5, r4, o3);
        var i3, s3 = o3.length;
        i3 = s3 < 1240 ? 107 : s3 < 33900 ? 1131 : 32768, n3.Bias = i3, n3.Subrs = [];
        for (var l3 = 0; l3 < o3.length - 1; l3++)
          n3.Subrs.push(a2.readBytes(e5, r4 + o3[l3], o3[l3 + 1] - o3[l3]));
      }, t3.CFF.tableSE = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 0, 111, 112, 113, 114, 0, 115, 116, 117, 118, 119, 120, 121, 122, 0, 123, 0, 124, 125, 126, 127, 128, 129, 130, 131, 0, 132, 133, 0, 134, 135, 136, 137, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 138, 0, 139, 0, 0, 0, 0, 140, 141, 142, 143, 0, 0, 0, 0, 0, 144, 0, 0, 0, 145, 0, 0, 146, 147, 148, 149, 0, 0, 0, 0], t3.CFF.glyphByUnicode = function(e5, t4) {
        for (var r4 = 0; r4 < e5.charset.length; r4++)
          if (e5.charset[r4] == t4)
            return r4;
        return -1;
      }, t3.CFF.glyphBySE = function(e5, r4) {
        return r4 < 0 || r4 > 255 ? -1 : t3.CFF.glyphByUnicode(e5, t3.CFF.tableSE[r4]);
      }, t3.CFF.readEncoding = function(e5, r4, n3) {
        t3._bin;
        var a2 = [".notdef"], o3 = e5[r4];
        if (r4++, 0 != o3)
          throw "error: unknown encoding format: " + o3;
        var i3 = e5[r4];
        r4++;
        for (var s3 = 0; s3 < i3; s3++)
          a2.push(e5[r4 + s3]);
        return a2;
      }, t3.CFF.readCharset = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = [".notdef"], i3 = e5[r4];
        if (r4++, 0 == i3)
          for (var s3 = 0; s3 < n3; s3++) {
            var l3 = a2.readUshort(e5, r4);
            r4 += 2, o3.push(l3);
          }
        else {
          if (1 != i3 && 2 != i3)
            throw "error: format: " + i3;
          for (; o3.length < n3; ) {
            l3 = a2.readUshort(e5, r4), r4 += 2;
            var c3 = 0;
            for (1 == i3 ? (c3 = e5[r4], r4++) : (c3 = a2.readUshort(e5, r4), r4 += 2), s3 = 0; s3 <= c3; s3++)
              o3.push(l3), l3++;
          }
        }
        return o3;
      }, t3.CFF.readIndex = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = a2.readUshort(e5, r4) + 1, i3 = e5[r4 += 2];
        if (r4++, 1 == i3)
          for (var s3 = 0; s3 < o3; s3++)
            n3.push(e5[r4 + s3]);
        else if (2 == i3)
          for (s3 = 0; s3 < o3; s3++)
            n3.push(a2.readUshort(e5, r4 + 2 * s3));
        else if (3 == i3)
          for (s3 = 0; s3 < o3; s3++)
            n3.push(16777215 & a2.readUint(e5, r4 + 3 * s3 - 1));
        else if (1 != o3)
          throw "unsupported offset size: " + i3 + ", count: " + o3;
        return (r4 += o3 * i3) - 1;
      }, t3.CFF.getCharString = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = e5[r4], i3 = e5[r4 + 1];
        e5[r4 + 2], e5[r4 + 3], e5[r4 + 4];
        var s3 = 1, l3 = null, c3 = null;
        o3 <= 20 && (l3 = o3, s3 = 1), 12 == o3 && (l3 = 100 * o3 + i3, s3 = 2), 21 <= o3 && o3 <= 27 && (l3 = o3, s3 = 1), 28 == o3 && (c3 = a2.readShort(e5, r4 + 1), s3 = 3), 29 <= o3 && o3 <= 31 && (l3 = o3, s3 = 1), 32 <= o3 && o3 <= 246 && (c3 = o3 - 139, s3 = 1), 247 <= o3 && o3 <= 250 && (c3 = 256 * (o3 - 247) + i3 + 108, s3 = 2), 251 <= o3 && o3 <= 254 && (c3 = 256 * -(o3 - 251) - i3 - 108, s3 = 2), 255 == o3 && (c3 = a2.readInt(e5, r4 + 1) / 65535, s3 = 5), n3.val = null != c3 ? c3 : "o" + l3, n3.size = s3;
      }, t3.CFF.readCharString = function(e5, r4, n3) {
        for (var a2 = r4 + n3, o3 = t3._bin, i3 = []; r4 < a2; ) {
          var s3 = e5[r4], l3 = e5[r4 + 1];
          e5[r4 + 2], e5[r4 + 3], e5[r4 + 4];
          var c3 = 1, u3 = null, f3 = null;
          s3 <= 20 && (u3 = s3, c3 = 1), 12 == s3 && (u3 = 100 * s3 + l3, c3 = 2), 19 != s3 && 20 != s3 || (u3 = s3, c3 = 2), 21 <= s3 && s3 <= 27 && (u3 = s3, c3 = 1), 28 == s3 && (f3 = o3.readShort(e5, r4 + 1), c3 = 3), 29 <= s3 && s3 <= 31 && (u3 = s3, c3 = 1), 32 <= s3 && s3 <= 246 && (f3 = s3 - 139, c3 = 1), 247 <= s3 && s3 <= 250 && (f3 = 256 * (s3 - 247) + l3 + 108, c3 = 2), 251 <= s3 && s3 <= 254 && (f3 = 256 * -(s3 - 251) - l3 - 108, c3 = 2), 255 == s3 && (f3 = o3.readInt(e5, r4 + 1) / 65535, c3 = 5), i3.push(null != f3 ? f3 : "o" + u3), r4 += c3;
        }
        return i3;
      }, t3.CFF.readDict = function(e5, r4, n3) {
        for (var a2 = t3._bin, o3 = {}, i3 = []; r4 < n3; ) {
          var s3 = e5[r4], l3 = e5[r4 + 1];
          e5[r4 + 2], e5[r4 + 3], e5[r4 + 4];
          var c3 = 1, u3 = null, f3 = null;
          if (28 == s3 && (f3 = a2.readShort(e5, r4 + 1), c3 = 3), 29 == s3 && (f3 = a2.readInt(e5, r4 + 1), c3 = 5), 32 <= s3 && s3 <= 246 && (f3 = s3 - 139, c3 = 1), 247 <= s3 && s3 <= 250 && (f3 = 256 * (s3 - 247) + l3 + 108, c3 = 2), 251 <= s3 && s3 <= 254 && (f3 = 256 * -(s3 - 251) - l3 - 108, c3 = 2), 255 == s3)
            throw f3 = a2.readInt(e5, r4 + 1) / 65535, c3 = 5, "unknown number";
          if (30 == s3) {
            var d3 = [];
            for (c3 = 1; ; ) {
              var h3 = e5[r4 + c3];
              c3++;
              var v6 = h3 >> 4, p3 = 15 & h3;
              if (15 != v6 && d3.push(v6), 15 != p3 && d3.push(p3), 15 == p3)
                break;
            }
            for (var g3 = "", b3 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, ".", "e", "e-", "reserved", "-", "endOfNumber"], y3 = 0; y3 < d3.length; y3++)
              g3 += b3[d3[y3]];
            f3 = parseFloat(g3);
          }
          s3 <= 21 && (u3 = ["version", "Notice", "FullName", "FamilyName", "Weight", "FontBBox", "BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StdHW", "StdVW", "escape", "UniqueID", "XUID", "charset", "Encoding", "CharStrings", "Private", "Subrs", "defaultWidthX", "nominalWidthX"][s3], c3 = 1, 12 == s3 && (u3 = ["Copyright", "isFixedPitch", "ItalicAngle", "UnderlinePosition", "UnderlineThickness", "PaintType", "CharstringType", "FontMatrix", "StrokeWidth", "BlueScale", "BlueShift", "BlueFuzz", "StemSnapH", "StemSnapV", "ForceBold", 0, 0, "LanguageGroup", "ExpansionFactor", "initialRandomSeed", "SyntheticBase", "PostScript", "BaseFontName", "BaseFontBlend", 0, 0, 0, 0, 0, 0, "ROS", "CIDFontVersion", "CIDFontRevision", "CIDFontType", "CIDCount", "UIDBase", "FDArray", "FDSelect", "FontName"][l3], c3 = 2)), null != u3 ? (o3[u3] = 1 == i3.length ? i3[0] : i3, i3 = []) : i3.push(f3), r4 += c3;
        }
        return o3;
      }, t3.cmap = {}, t3.cmap.parse = function(e5, r4, n3) {
        e5 = new Uint8Array(e5.buffer, r4, n3), r4 = 0;
        var a2 = t3._bin, o3 = {};
        a2.readUshort(e5, r4), r4 += 2;
        var i3 = a2.readUshort(e5, r4);
        r4 += 2;
        var s3 = [];
        o3.tables = [];
        for (var l3 = 0; l3 < i3; l3++) {
          var c3 = a2.readUshort(e5, r4);
          r4 += 2;
          var u3 = a2.readUshort(e5, r4);
          r4 += 2;
          var f3 = a2.readUint(e5, r4);
          r4 += 4;
          var d3 = "p" + c3 + "e" + u3, h3 = s3.indexOf(f3);
          if (-1 == h3) {
            var v6;
            h3 = o3.tables.length, s3.push(f3);
            var p3 = a2.readUshort(e5, f3);
            0 == p3 ? v6 = t3.cmap.parse0(e5, f3) : 4 == p3 ? v6 = t3.cmap.parse4(e5, f3) : 6 == p3 ? v6 = t3.cmap.parse6(e5, f3) : 12 == p3 ? v6 = t3.cmap.parse12(e5, f3) : console.debug("unknown format: " + p3, c3, u3, f3), o3.tables.push(v6);
          }
          if (null != o3[d3])
            throw "multiple tables for one platform+encoding";
          o3[d3] = h3;
        }
        return o3;
      }, t3.cmap.parse0 = function(e5, r4) {
        var n3 = t3._bin, a2 = {};
        a2.format = n3.readUshort(e5, r4), r4 += 2;
        var o3 = n3.readUshort(e5, r4);
        r4 += 2, n3.readUshort(e5, r4), r4 += 2, a2.map = [];
        for (var i3 = 0; i3 < o3 - 6; i3++)
          a2.map.push(e5[r4 + i3]);
        return a2;
      }, t3.cmap.parse4 = function(e5, r4) {
        var n3 = t3._bin, a2 = r4, o3 = {};
        o3.format = n3.readUshort(e5, r4), r4 += 2;
        var i3 = n3.readUshort(e5, r4);
        r4 += 2, n3.readUshort(e5, r4), r4 += 2;
        var s3 = n3.readUshort(e5, r4);
        r4 += 2;
        var l3 = s3 / 2;
        o3.searchRange = n3.readUshort(e5, r4), r4 += 2, o3.entrySelector = n3.readUshort(e5, r4), r4 += 2, o3.rangeShift = n3.readUshort(e5, r4), r4 += 2, o3.endCount = n3.readUshorts(e5, r4, l3), r4 += 2 * l3, r4 += 2, o3.startCount = n3.readUshorts(e5, r4, l3), r4 += 2 * l3, o3.idDelta = [];
        for (var c3 = 0; c3 < l3; c3++)
          o3.idDelta.push(n3.readShort(e5, r4)), r4 += 2;
        for (o3.idRangeOffset = n3.readUshorts(e5, r4, l3), r4 += 2 * l3, o3.glyphIdArray = []; r4 < a2 + i3; )
          o3.glyphIdArray.push(n3.readUshort(e5, r4)), r4 += 2;
        return o3;
      }, t3.cmap.parse6 = function(e5, r4) {
        var n3 = t3._bin, a2 = {};
        a2.format = n3.readUshort(e5, r4), r4 += 2, n3.readUshort(e5, r4), r4 += 2, n3.readUshort(e5, r4), r4 += 2, a2.firstCode = n3.readUshort(e5, r4), r4 += 2;
        var o3 = n3.readUshort(e5, r4);
        r4 += 2, a2.glyphIdArray = [];
        for (var i3 = 0; i3 < o3; i3++)
          a2.glyphIdArray.push(n3.readUshort(e5, r4)), r4 += 2;
        return a2;
      }, t3.cmap.parse12 = function(e5, r4) {
        var n3 = t3._bin, a2 = {};
        a2.format = n3.readUshort(e5, r4), r4 += 2, r4 += 2, n3.readUint(e5, r4), r4 += 4, n3.readUint(e5, r4), r4 += 4;
        var o3 = n3.readUint(e5, r4);
        r4 += 4, a2.groups = [];
        for (var i3 = 0; i3 < o3; i3++) {
          var s3 = r4 + 12 * i3, l3 = n3.readUint(e5, s3 + 0), c3 = n3.readUint(e5, s3 + 4), u3 = n3.readUint(e5, s3 + 8);
          a2.groups.push([l3, c3, u3]);
        }
        return a2;
      }, t3.glyf = {}, t3.glyf.parse = function(e5, t4, r4, n3) {
        for (var a2 = [], o3 = 0; o3 < n3.maxp.numGlyphs; o3++)
          a2.push(null);
        return a2;
      }, t3.glyf._parseGlyf = function(e5, r4) {
        var n3 = t3._bin, a2 = e5._data, o3 = t3._tabOffset(a2, "glyf", e5._offset) + e5.loca[r4];
        if (e5.loca[r4] == e5.loca[r4 + 1])
          return null;
        var i3 = {};
        if (i3.noc = n3.readShort(a2, o3), o3 += 2, i3.xMin = n3.readShort(a2, o3), o3 += 2, i3.yMin = n3.readShort(a2, o3), o3 += 2, i3.xMax = n3.readShort(a2, o3), o3 += 2, i3.yMax = n3.readShort(a2, o3), o3 += 2, i3.xMin >= i3.xMax || i3.yMin >= i3.yMax)
          return null;
        if (i3.noc > 0) {
          i3.endPts = [];
          for (var s3 = 0; s3 < i3.noc; s3++)
            i3.endPts.push(n3.readUshort(a2, o3)), o3 += 2;
          var l3 = n3.readUshort(a2, o3);
          if (o3 += 2, a2.length - o3 < l3)
            return null;
          i3.instructions = n3.readBytes(a2, o3, l3), o3 += l3;
          var c3 = i3.endPts[i3.noc - 1] + 1;
          for (i3.flags = [], s3 = 0; s3 < c3; s3++) {
            var u3 = a2[o3];
            if (o3++, i3.flags.push(u3), 0 != (8 & u3)) {
              var f3 = a2[o3];
              o3++;
              for (var d3 = 0; d3 < f3; d3++)
                i3.flags.push(u3), s3++;
            }
          }
          for (i3.xs = [], s3 = 0; s3 < c3; s3++) {
            var h3 = 0 != (2 & i3.flags[s3]), v6 = 0 != (16 & i3.flags[s3]);
            h3 ? (i3.xs.push(v6 ? a2[o3] : -a2[o3]), o3++) : v6 ? i3.xs.push(0) : (i3.xs.push(n3.readShort(a2, o3)), o3 += 2);
          }
          for (i3.ys = [], s3 = 0; s3 < c3; s3++)
            h3 = 0 != (4 & i3.flags[s3]), v6 = 0 != (32 & i3.flags[s3]), h3 ? (i3.ys.push(v6 ? a2[o3] : -a2[o3]), o3++) : v6 ? i3.ys.push(0) : (i3.ys.push(n3.readShort(a2, o3)), o3 += 2);
          var p3 = 0, g3 = 0;
          for (s3 = 0; s3 < c3; s3++)
            p3 += i3.xs[s3], g3 += i3.ys[s3], i3.xs[s3] = p3, i3.ys[s3] = g3;
        } else {
          var b3;
          i3.parts = [];
          do {
            b3 = n3.readUshort(a2, o3), o3 += 2;
            var y3 = { m: { a: 1, b: 0, c: 0, d: 1, tx: 0, ty: 0 }, p1: -1, p2: -1 };
            if (i3.parts.push(y3), y3.glyphIndex = n3.readUshort(a2, o3), o3 += 2, 1 & b3) {
              var m3 = n3.readShort(a2, o3);
              o3 += 2;
              var x3 = n3.readShort(a2, o3);
              o3 += 2;
            } else
              m3 = n3.readInt8(a2, o3), o3++, x3 = n3.readInt8(a2, o3), o3++;
            2 & b3 ? (y3.m.tx = m3, y3.m.ty = x3) : (y3.p1 = m3, y3.p2 = x3), 8 & b3 ? (y3.m.a = y3.m.d = n3.readF2dot14(a2, o3), o3 += 2) : 64 & b3 ? (y3.m.a = n3.readF2dot14(a2, o3), o3 += 2, y3.m.d = n3.readF2dot14(a2, o3), o3 += 2) : 128 & b3 && (y3.m.a = n3.readF2dot14(a2, o3), o3 += 2, y3.m.b = n3.readF2dot14(a2, o3), o3 += 2, y3.m.c = n3.readF2dot14(a2, o3), o3 += 2, y3.m.d = n3.readF2dot14(a2, o3), o3 += 2);
          } while (32 & b3);
          if (256 & b3) {
            var k3 = n3.readUshort(a2, o3);
            for (o3 += 2, i3.instr = [], s3 = 0; s3 < k3; s3++)
              i3.instr.push(a2[o3]), o3++;
          }
        }
        return i3;
      }, t3.GPOS = {}, t3.GPOS.parse = function(e5, r4, n3, a2) {
        return t3._lctf.parse(e5, r4, n3, a2, t3.GPOS.subt);
      }, t3.GPOS.subt = function(e5, r4, n3, a2) {
        var o3 = t3._bin, i3 = n3, s3 = {};
        if (s3.fmt = o3.readUshort(e5, n3), n3 += 2, 1 == r4 || 2 == r4 || 3 == r4 || 7 == r4 || 8 == r4 && s3.fmt <= 2) {
          var l3 = o3.readUshort(e5, n3);
          n3 += 2, s3.coverage = t3._lctf.readCoverage(e5, l3 + i3);
        }
        if (1 == r4 && 1 == s3.fmt) {
          var c3 = o3.readUshort(e5, n3);
          n3 += 2;
          var u3 = t3._lctf.numOfOnes(c3);
          0 != c3 && (s3.pos = t3.GPOS.readValueRecord(e5, n3, c3));
        } else if (2 == r4 && s3.fmt >= 1 && s3.fmt <= 2) {
          c3 = o3.readUshort(e5, n3), n3 += 2;
          var f3 = o3.readUshort(e5, n3);
          n3 += 2, u3 = t3._lctf.numOfOnes(c3);
          var d3 = t3._lctf.numOfOnes(f3);
          if (1 == s3.fmt) {
            s3.pairsets = [];
            var h3 = o3.readUshort(e5, n3);
            n3 += 2;
            for (var v6 = 0; v6 < h3; v6++) {
              var p3 = i3 + o3.readUshort(e5, n3);
              n3 += 2;
              var g3 = o3.readUshort(e5, p3);
              p3 += 2;
              for (var b3 = [], y3 = 0; y3 < g3; y3++) {
                var m3 = o3.readUshort(e5, p3);
                p3 += 2, 0 != c3 && (T3 = t3.GPOS.readValueRecord(e5, p3, c3), p3 += 2 * u3), 0 != f3 && (_3 = t3.GPOS.readValueRecord(e5, p3, f3), p3 += 2 * d3), b3.push({ gid2: m3, val1: T3, val2: _3 });
              }
              s3.pairsets.push(b3);
            }
          }
          if (2 == s3.fmt) {
            var x3 = o3.readUshort(e5, n3);
            n3 += 2;
            var k3 = o3.readUshort(e5, n3);
            n3 += 2;
            var w3 = o3.readUshort(e5, n3);
            n3 += 2;
            var S3 = o3.readUshort(e5, n3);
            for (n3 += 2, s3.classDef1 = t3._lctf.readClassDef(e5, i3 + x3), s3.classDef2 = t3._lctf.readClassDef(e5, i3 + k3), s3.matrix = [], v6 = 0; v6 < w3; v6++) {
              var U3 = [];
              for (y3 = 0; y3 < S3; y3++) {
                var T3 = null, _3 = null;
                0 != c3 && (T3 = t3.GPOS.readValueRecord(e5, n3, c3), n3 += 2 * u3), 0 != f3 && (_3 = t3.GPOS.readValueRecord(e5, n3, f3), n3 += 2 * d3), U3.push({ val1: T3, val2: _3 });
              }
              s3.matrix.push(U3);
            }
          }
        } else {
          if (9 == r4 && 1 == s3.fmt) {
            var E4 = o3.readUshort(e5, n3);
            n3 += 2;
            var F3 = o3.readUint(e5, n3);
            if (n3 += 4, 9 == a2.ltype)
              a2.ltype = E4;
            else if (a2.ltype != E4)
              throw "invalid extension substitution";
            return t3.GPOS.subt(e5, a2.ltype, i3 + F3);
          }
          console.debug("unsupported GPOS table LookupType", r4, "format", s3.fmt);
        }
        return s3;
      }, t3.GPOS.readValueRecord = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = [];
        return o3.push(1 & n3 ? a2.readShort(e5, r4) : 0), r4 += 1 & n3 ? 2 : 0, o3.push(2 & n3 ? a2.readShort(e5, r4) : 0), r4 += 2 & n3 ? 2 : 0, o3.push(4 & n3 ? a2.readShort(e5, r4) : 0), r4 += 4 & n3 ? 2 : 0, o3.push(8 & n3 ? a2.readShort(e5, r4) : 0), r4 += 8 & n3 ? 2 : 0, o3;
      }, t3.GSUB = {}, t3.GSUB.parse = function(e5, r4, n3, a2) {
        return t3._lctf.parse(e5, r4, n3, a2, t3.GSUB.subt);
      }, t3.GSUB.subt = function(e5, r4, n3, a2) {
        var o3 = t3._bin, i3 = n3, s3 = {};
        if (s3.fmt = o3.readUshort(e5, n3), n3 += 2, 1 != r4 && 4 != r4 && 5 != r4 && 6 != r4)
          return null;
        if (1 == r4 || 4 == r4 || 5 == r4 && s3.fmt <= 2 || 6 == r4 && s3.fmt <= 2) {
          var l3 = o3.readUshort(e5, n3);
          n3 += 2, s3.coverage = t3._lctf.readCoverage(e5, i3 + l3);
        }
        if (1 == r4 && s3.fmt >= 1 && s3.fmt <= 2) {
          if (1 == s3.fmt)
            s3.delta = o3.readShort(e5, n3), n3 += 2;
          else if (2 == s3.fmt) {
            var c3 = o3.readUshort(e5, n3);
            n3 += 2, s3.newg = o3.readUshorts(e5, n3, c3), n3 += 2 * s3.newg.length;
          }
        } else if (4 == r4) {
          s3.vals = [], c3 = o3.readUshort(e5, n3), n3 += 2;
          for (var u3 = 0; u3 < c3; u3++) {
            var f3 = o3.readUshort(e5, n3);
            n3 += 2, s3.vals.push(t3.GSUB.readLigatureSet(e5, i3 + f3));
          }
        } else if (5 == r4 && 2 == s3.fmt) {
          if (2 == s3.fmt) {
            var d3 = o3.readUshort(e5, n3);
            n3 += 2, s3.cDef = t3._lctf.readClassDef(e5, i3 + d3), s3.scset = [];
            var h3 = o3.readUshort(e5, n3);
            for (n3 += 2, u3 = 0; u3 < h3; u3++) {
              var v6 = o3.readUshort(e5, n3);
              n3 += 2, s3.scset.push(0 == v6 ? null : t3.GSUB.readSubClassSet(e5, i3 + v6));
            }
          }
        } else if (6 == r4 && 3 == s3.fmt) {
          if (3 == s3.fmt) {
            for (u3 = 0; u3 < 3; u3++) {
              c3 = o3.readUshort(e5, n3), n3 += 2;
              for (var p3 = [], g3 = 0; g3 < c3; g3++)
                p3.push(t3._lctf.readCoverage(e5, i3 + o3.readUshort(e5, n3 + 2 * g3)));
              n3 += 2 * c3, 0 == u3 && (s3.backCvg = p3), 1 == u3 && (s3.inptCvg = p3), 2 == u3 && (s3.ahedCvg = p3);
            }
            c3 = o3.readUshort(e5, n3), n3 += 2, s3.lookupRec = t3.GSUB.readSubstLookupRecords(e5, n3, c3);
          }
        } else {
          if (7 == r4 && 1 == s3.fmt) {
            var b3 = o3.readUshort(e5, n3);
            n3 += 2;
            var y3 = o3.readUint(e5, n3);
            if (n3 += 4, 9 == a2.ltype)
              a2.ltype = b3;
            else if (a2.ltype != b3)
              throw "invalid extension substitution";
            return t3.GSUB.subt(e5, a2.ltype, i3 + y3);
          }
          console.debug("unsupported GSUB table LookupType", r4, "format", s3.fmt);
        }
        return s3;
      }, t3.GSUB.readSubClassSet = function(e5, r4) {
        var n3 = t3._bin.readUshort, a2 = r4, o3 = [], i3 = n3(e5, r4);
        r4 += 2;
        for (var s3 = 0; s3 < i3; s3++) {
          var l3 = n3(e5, r4);
          r4 += 2, o3.push(t3.GSUB.readSubClassRule(e5, a2 + l3));
        }
        return o3;
      }, t3.GSUB.readSubClassRule = function(e5, r4) {
        var n3 = t3._bin.readUshort, a2 = {}, o3 = n3(e5, r4), i3 = n3(e5, r4 += 2);
        r4 += 2, a2.input = [];
        for (var s3 = 0; s3 < o3 - 1; s3++)
          a2.input.push(n3(e5, r4)), r4 += 2;
        return a2.substLookupRecords = t3.GSUB.readSubstLookupRecords(e5, r4, i3), a2;
      }, t3.GSUB.readSubstLookupRecords = function(e5, r4, n3) {
        for (var a2 = t3._bin.readUshort, o3 = [], i3 = 0; i3 < n3; i3++)
          o3.push(a2(e5, r4), a2(e5, r4 + 2)), r4 += 4;
        return o3;
      }, t3.GSUB.readChainSubClassSet = function(e5, r4) {
        var n3 = t3._bin, a2 = r4, o3 = [], i3 = n3.readUshort(e5, r4);
        r4 += 2;
        for (var s3 = 0; s3 < i3; s3++) {
          var l3 = n3.readUshort(e5, r4);
          r4 += 2, o3.push(t3.GSUB.readChainSubClassRule(e5, a2 + l3));
        }
        return o3;
      }, t3.GSUB.readChainSubClassRule = function(e5, r4) {
        for (var n3 = t3._bin, a2 = {}, o3 = ["backtrack", "input", "lookahead"], i3 = 0; i3 < o3.length; i3++) {
          var s3 = n3.readUshort(e5, r4);
          r4 += 2, 1 == i3 && s3--, a2[o3[i3]] = n3.readUshorts(e5, r4, s3), r4 += 2 * a2[o3[i3]].length;
        }
        return s3 = n3.readUshort(e5, r4), r4 += 2, a2.subst = n3.readUshorts(e5, r4, 2 * s3), r4 += 2 * a2.subst.length, a2;
      }, t3.GSUB.readLigatureSet = function(e5, r4) {
        var n3 = t3._bin, a2 = r4, o3 = [], i3 = n3.readUshort(e5, r4);
        r4 += 2;
        for (var s3 = 0; s3 < i3; s3++) {
          var l3 = n3.readUshort(e5, r4);
          r4 += 2, o3.push(t3.GSUB.readLigature(e5, a2 + l3));
        }
        return o3;
      }, t3.GSUB.readLigature = function(e5, r4) {
        var n3 = t3._bin, a2 = { chain: [] };
        a2.nglyph = n3.readUshort(e5, r4), r4 += 2;
        var o3 = n3.readUshort(e5, r4);
        r4 += 2;
        for (var i3 = 0; i3 < o3 - 1; i3++)
          a2.chain.push(n3.readUshort(e5, r4)), r4 += 2;
        return a2;
      }, t3.head = {}, t3.head.parse = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = {};
        return a2.readFixed(e5, r4), r4 += 4, o3.fontRevision = a2.readFixed(e5, r4), r4 += 4, a2.readUint(e5, r4), r4 += 4, a2.readUint(e5, r4), r4 += 4, o3.flags = a2.readUshort(e5, r4), r4 += 2, o3.unitsPerEm = a2.readUshort(e5, r4), r4 += 2, o3.created = a2.readUint64(e5, r4), r4 += 8, o3.modified = a2.readUint64(e5, r4), r4 += 8, o3.xMin = a2.readShort(e5, r4), r4 += 2, o3.yMin = a2.readShort(e5, r4), r4 += 2, o3.xMax = a2.readShort(e5, r4), r4 += 2, o3.yMax = a2.readShort(e5, r4), r4 += 2, o3.macStyle = a2.readUshort(e5, r4), r4 += 2, o3.lowestRecPPEM = a2.readUshort(e5, r4), r4 += 2, o3.fontDirectionHint = a2.readShort(e5, r4), r4 += 2, o3.indexToLocFormat = a2.readShort(e5, r4), r4 += 2, o3.glyphDataFormat = a2.readShort(e5, r4), r4 += 2, o3;
      }, t3.hhea = {}, t3.hhea.parse = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = {};
        return a2.readFixed(e5, r4), r4 += 4, o3.ascender = a2.readShort(e5, r4), r4 += 2, o3.descender = a2.readShort(e5, r4), r4 += 2, o3.lineGap = a2.readShort(e5, r4), r4 += 2, o3.advanceWidthMax = a2.readUshort(e5, r4), r4 += 2, o3.minLeftSideBearing = a2.readShort(e5, r4), r4 += 2, o3.minRightSideBearing = a2.readShort(e5, r4), r4 += 2, o3.xMaxExtent = a2.readShort(e5, r4), r4 += 2, o3.caretSlopeRise = a2.readShort(e5, r4), r4 += 2, o3.caretSlopeRun = a2.readShort(e5, r4), r4 += 2, o3.caretOffset = a2.readShort(e5, r4), r4 += 2, r4 += 8, o3.metricDataFormat = a2.readShort(e5, r4), r4 += 2, o3.numberOfHMetrics = a2.readUshort(e5, r4), r4 += 2, o3;
      }, t3.hmtx = {}, t3.hmtx.parse = function(e5, r4, n3, a2) {
        for (var o3 = t3._bin, i3 = { aWidth: [], lsBearing: [] }, s3 = 0, l3 = 0, c3 = 0; c3 < a2.maxp.numGlyphs; c3++)
          c3 < a2.hhea.numberOfHMetrics && (s3 = o3.readUshort(e5, r4), r4 += 2, l3 = o3.readShort(e5, r4), r4 += 2), i3.aWidth.push(s3), i3.lsBearing.push(l3);
        return i3;
      }, t3.kern = {}, t3.kern.parse = function(e5, r4, n3, a2) {
        var o3 = t3._bin, i3 = o3.readUshort(e5, r4);
        if (r4 += 2, 1 == i3)
          return t3.kern.parseV1(e5, r4 - 2, n3, a2);
        var s3 = o3.readUshort(e5, r4);
        r4 += 2;
        for (var l3 = { glyph1: [], rval: [] }, c3 = 0; c3 < s3; c3++) {
          r4 += 2, n3 = o3.readUshort(e5, r4), r4 += 2;
          var u3 = o3.readUshort(e5, r4);
          r4 += 2;
          var f3 = u3 >>> 8;
          if (0 != (f3 &= 15))
            throw "unknown kern table format: " + f3;
          r4 = t3.kern.readFormat0(e5, r4, l3);
        }
        return l3;
      }, t3.kern.parseV1 = function(e5, r4, n3, a2) {
        var o3 = t3._bin;
        o3.readFixed(e5, r4), r4 += 4;
        var i3 = o3.readUint(e5, r4);
        r4 += 4;
        for (var s3 = { glyph1: [], rval: [] }, l3 = 0; l3 < i3; l3++) {
          o3.readUint(e5, r4), r4 += 4;
          var c3 = o3.readUshort(e5, r4);
          r4 += 2, o3.readUshort(e5, r4), r4 += 2;
          var u3 = c3 >>> 8;
          if (0 != (u3 &= 15))
            throw "unknown kern table format: " + u3;
          r4 = t3.kern.readFormat0(e5, r4, s3);
        }
        return s3;
      }, t3.kern.readFormat0 = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = -1, i3 = a2.readUshort(e5, r4);
        r4 += 2, a2.readUshort(e5, r4), r4 += 2, a2.readUshort(e5, r4), r4 += 2, a2.readUshort(e5, r4), r4 += 2;
        for (var s3 = 0; s3 < i3; s3++) {
          var l3 = a2.readUshort(e5, r4);
          r4 += 2;
          var c3 = a2.readUshort(e5, r4);
          r4 += 2;
          var u3 = a2.readShort(e5, r4);
          r4 += 2, l3 != o3 && (n3.glyph1.push(l3), n3.rval.push({ glyph2: [], vals: [] }));
          var f3 = n3.rval[n3.rval.length - 1];
          f3.glyph2.push(c3), f3.vals.push(u3), o3 = l3;
        }
        return r4;
      }, t3.loca = {}, t3.loca.parse = function(e5, r4, n3, a2) {
        var o3 = t3._bin, i3 = [], s3 = a2.head.indexToLocFormat, l3 = a2.maxp.numGlyphs + 1;
        if (0 == s3)
          for (var c3 = 0; c3 < l3; c3++)
            i3.push(o3.readUshort(e5, r4 + (c3 << 1)) << 1);
        if (1 == s3)
          for (c3 = 0; c3 < l3; c3++)
            i3.push(o3.readUint(e5, r4 + (c3 << 2)));
        return i3;
      }, t3.maxp = {}, t3.maxp.parse = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = {}, i3 = a2.readUint(e5, r4);
        return r4 += 4, o3.numGlyphs = a2.readUshort(e5, r4), r4 += 2, 65536 == i3 && (o3.maxPoints = a2.readUshort(e5, r4), r4 += 2, o3.maxContours = a2.readUshort(e5, r4), r4 += 2, o3.maxCompositePoints = a2.readUshort(e5, r4), r4 += 2, o3.maxCompositeContours = a2.readUshort(e5, r4), r4 += 2, o3.maxZones = a2.readUshort(e5, r4), r4 += 2, o3.maxTwilightPoints = a2.readUshort(e5, r4), r4 += 2, o3.maxStorage = a2.readUshort(e5, r4), r4 += 2, o3.maxFunctionDefs = a2.readUshort(e5, r4), r4 += 2, o3.maxInstructionDefs = a2.readUshort(e5, r4), r4 += 2, o3.maxStackElements = a2.readUshort(e5, r4), r4 += 2, o3.maxSizeOfInstructions = a2.readUshort(e5, r4), r4 += 2, o3.maxComponentElements = a2.readUshort(e5, r4), r4 += 2, o3.maxComponentDepth = a2.readUshort(e5, r4), r4 += 2), o3;
      }, t3.name = {}, t3.name.parse = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = {};
        a2.readUshort(e5, r4), r4 += 2;
        var i3 = a2.readUshort(e5, r4);
        r4 += 2, a2.readUshort(e5, r4);
        for (var s3, l3 = ["copyright", "fontFamily", "fontSubfamily", "ID", "fullName", "version", "postScriptName", "trademark", "manufacturer", "designer", "description", "urlVendor", "urlDesigner", "licence", "licenceURL", "---", "typoFamilyName", "typoSubfamilyName", "compatibleFull", "sampleText", "postScriptCID", "wwsFamilyName", "wwsSubfamilyName", "lightPalette", "darkPalette"], c3 = r4 += 2, u3 = 0; u3 < i3; u3++) {
          var f3 = a2.readUshort(e5, r4);
          r4 += 2;
          var d3 = a2.readUshort(e5, r4);
          r4 += 2;
          var h3 = a2.readUshort(e5, r4);
          r4 += 2;
          var v6 = a2.readUshort(e5, r4);
          r4 += 2;
          var p3 = a2.readUshort(e5, r4);
          r4 += 2;
          var g3 = a2.readUshort(e5, r4);
          r4 += 2;
          var b3, y3 = l3[v6], m3 = c3 + 12 * i3 + g3;
          if (0 == f3)
            b3 = a2.readUnicode(e5, m3, p3 / 2);
          else if (3 == f3 && 0 == d3)
            b3 = a2.readUnicode(e5, m3, p3 / 2);
          else if (0 == d3)
            b3 = a2.readASCII(e5, m3, p3);
          else if (1 == d3)
            b3 = a2.readUnicode(e5, m3, p3 / 2);
          else if (3 == d3)
            b3 = a2.readUnicode(e5, m3, p3 / 2);
          else {
            if (1 != f3)
              throw "unknown encoding " + d3 + ", platformID: " + f3;
            b3 = a2.readASCII(e5, m3, p3), console.debug("reading unknown MAC encoding " + d3 + " as ASCII");
          }
          var x3 = "p" + f3 + "," + h3.toString(16);
          null == o3[x3] && (o3[x3] = {}), o3[x3][void 0 !== y3 ? y3 : v6] = b3, o3[x3]._lang = h3;
        }
        for (var k3 in o3)
          if (null != o3[k3].postScriptName && 1033 == o3[k3]._lang)
            return o3[k3];
        for (var k3 in o3)
          if (null != o3[k3].postScriptName && 0 == o3[k3]._lang)
            return o3[k3];
        for (var k3 in o3)
          if (null != o3[k3].postScriptName && 3084 == o3[k3]._lang)
            return o3[k3];
        for (var k3 in o3)
          if (null != o3[k3].postScriptName)
            return o3[k3];
        for (var k3 in o3) {
          s3 = k3;
          break;
        }
        return console.debug("returning name table with languageID " + o3[s3]._lang), o3[s3];
      }, t3["OS/2"] = {}, t3["OS/2"].parse = function(e5, r4, n3) {
        var a2 = t3._bin.readUshort(e5, r4);
        r4 += 2;
        var o3 = {};
        if (0 == a2)
          t3["OS/2"].version0(e5, r4, o3);
        else if (1 == a2)
          t3["OS/2"].version1(e5, r4, o3);
        else if (2 == a2 || 3 == a2 || 4 == a2)
          t3["OS/2"].version2(e5, r4, o3);
        else {
          if (5 != a2)
            throw "unknown OS/2 table version: " + a2;
          t3["OS/2"].version5(e5, r4, o3);
        }
        return o3;
      }, t3["OS/2"].version0 = function(e5, r4, n3) {
        var a2 = t3._bin;
        return n3.xAvgCharWidth = a2.readShort(e5, r4), r4 += 2, n3.usWeightClass = a2.readUshort(e5, r4), r4 += 2, n3.usWidthClass = a2.readUshort(e5, r4), r4 += 2, n3.fsType = a2.readUshort(e5, r4), r4 += 2, n3.ySubscriptXSize = a2.readShort(e5, r4), r4 += 2, n3.ySubscriptYSize = a2.readShort(e5, r4), r4 += 2, n3.ySubscriptXOffset = a2.readShort(e5, r4), r4 += 2, n3.ySubscriptYOffset = a2.readShort(e5, r4), r4 += 2, n3.ySuperscriptXSize = a2.readShort(e5, r4), r4 += 2, n3.ySuperscriptYSize = a2.readShort(e5, r4), r4 += 2, n3.ySuperscriptXOffset = a2.readShort(e5, r4), r4 += 2, n3.ySuperscriptYOffset = a2.readShort(e5, r4), r4 += 2, n3.yStrikeoutSize = a2.readShort(e5, r4), r4 += 2, n3.yStrikeoutPosition = a2.readShort(e5, r4), r4 += 2, n3.sFamilyClass = a2.readShort(e5, r4), r4 += 2, n3.panose = a2.readBytes(e5, r4, 10), r4 += 10, n3.ulUnicodeRange1 = a2.readUint(e5, r4), r4 += 4, n3.ulUnicodeRange2 = a2.readUint(e5, r4), r4 += 4, n3.ulUnicodeRange3 = a2.readUint(e5, r4), r4 += 4, n3.ulUnicodeRange4 = a2.readUint(e5, r4), r4 += 4, n3.achVendID = [a2.readInt8(e5, r4), a2.readInt8(e5, r4 + 1), a2.readInt8(e5, r4 + 2), a2.readInt8(e5, r4 + 3)], r4 += 4, n3.fsSelection = a2.readUshort(e5, r4), r4 += 2, n3.usFirstCharIndex = a2.readUshort(e5, r4), r4 += 2, n3.usLastCharIndex = a2.readUshort(e5, r4), r4 += 2, n3.sTypoAscender = a2.readShort(e5, r4), r4 += 2, n3.sTypoDescender = a2.readShort(e5, r4), r4 += 2, n3.sTypoLineGap = a2.readShort(e5, r4), r4 += 2, n3.usWinAscent = a2.readUshort(e5, r4), r4 += 2, n3.usWinDescent = a2.readUshort(e5, r4), r4 + 2;
      }, t3["OS/2"].version1 = function(e5, r4, n3) {
        var a2 = t3._bin;
        return r4 = t3["OS/2"].version0(e5, r4, n3), n3.ulCodePageRange1 = a2.readUint(e5, r4), r4 += 4, n3.ulCodePageRange2 = a2.readUint(e5, r4), r4 + 4;
      }, t3["OS/2"].version2 = function(e5, r4, n3) {
        var a2 = t3._bin;
        return r4 = t3["OS/2"].version1(e5, r4, n3), n3.sxHeight = a2.readShort(e5, r4), r4 += 2, n3.sCapHeight = a2.readShort(e5, r4), r4 += 2, n3.usDefault = a2.readUshort(e5, r4), r4 += 2, n3.usBreak = a2.readUshort(e5, r4), r4 += 2, n3.usMaxContext = a2.readUshort(e5, r4), r4 + 2;
      }, t3["OS/2"].version5 = function(e5, r4, n3) {
        var a2 = t3._bin;
        return r4 = t3["OS/2"].version2(e5, r4, n3), n3.usLowerOpticalPointSize = a2.readUshort(e5, r4), r4 += 2, n3.usUpperOpticalPointSize = a2.readUshort(e5, r4), r4 + 2;
      }, t3.post = {}, t3.post.parse = function(e5, r4, n3) {
        var a2 = t3._bin, o3 = {};
        return o3.version = a2.readFixed(e5, r4), r4 += 4, o3.italicAngle = a2.readFixed(e5, r4), r4 += 4, o3.underlinePosition = a2.readShort(e5, r4), r4 += 2, o3.underlineThickness = a2.readShort(e5, r4), r4 += 2, o3;
      }, null == t3 && (t3 = {}), null == t3.U && (t3.U = {}), t3.U.codeToGlyph = function(e5, t4) {
        var r4 = e5.cmap, n3 = -1;
        if (null != r4.p0e4 ? n3 = r4.p0e4 : null != r4.p3e1 ? n3 = r4.p3e1 : null != r4.p1e0 ? n3 = r4.p1e0 : null != r4.p0e3 && (n3 = r4.p0e3), -1 == n3)
          throw "no familiar platform and encoding!";
        var a2 = r4.tables[n3];
        if (0 == a2.format)
          return t4 >= a2.map.length ? 0 : a2.map[t4];
        if (4 == a2.format) {
          for (var o3 = -1, i3 = 0; i3 < a2.endCount.length; i3++)
            if (t4 <= a2.endCount[i3]) {
              o3 = i3;
              break;
            }
          return -1 == o3 || a2.startCount[o3] > t4 ? 0 : 65535 & (0 != a2.idRangeOffset[o3] ? a2.glyphIdArray[t4 - a2.startCount[o3] + (a2.idRangeOffset[o3] >> 1) - (a2.idRangeOffset.length - o3)] : t4 + a2.idDelta[o3]);
        }
        if (12 == a2.format) {
          if (t4 > a2.groups[a2.groups.length - 1][1])
            return 0;
          for (i3 = 0; i3 < a2.groups.length; i3++) {
            var s3 = a2.groups[i3];
            if (s3[0] <= t4 && t4 <= s3[1])
              return s3[2] + (t4 - s3[0]);
          }
          return 0;
        }
        throw "unknown cmap table format " + a2.format;
      }, t3.U.glyphToPath = function(e5, r4) {
        var n3 = { cmds: [], crds: [] };
        if (e5.SVG && e5.SVG.entries[r4]) {
          var a2 = e5.SVG.entries[r4];
          return null == a2 ? n3 : ("string" == typeof a2 && (a2 = t3.SVG.toPath(a2), e5.SVG.entries[r4] = a2), a2);
        }
        if (e5.CFF) {
          var o3 = { x: 0, y: 0, stack: [], nStems: 0, haveWidth: false, width: e5.CFF.Private ? e5.CFF.Private.defaultWidthX : 0, open: false }, i3 = e5.CFF, s3 = e5.CFF.Private;
          if (i3.ROS) {
            for (var l3 = 0; i3.FDSelect[l3 + 2] <= r4; )
              l3 += 2;
            s3 = i3.FDArray[i3.FDSelect[l3 + 1]].Private;
          }
          t3.U._drawCFF(e5.CFF.CharStrings[r4], o3, i3, s3, n3);
        } else
          e5.glyf && t3.U._drawGlyf(r4, e5, n3);
        return n3;
      }, t3.U._drawGlyf = function(e5, r4, n3) {
        var a2 = r4.glyf[e5];
        null == a2 && (a2 = r4.glyf[e5] = t3.glyf._parseGlyf(r4, e5)), null != a2 && (a2.noc > -1 ? t3.U._simpleGlyph(a2, n3) : t3.U._compoGlyph(a2, r4, n3));
      }, t3.U._simpleGlyph = function(e5, r4) {
        for (var n3 = 0; n3 < e5.noc; n3++) {
          for (var a2 = 0 == n3 ? 0 : e5.endPts[n3 - 1] + 1, o3 = e5.endPts[n3], i3 = a2; i3 <= o3; i3++) {
            var s3 = i3 == a2 ? o3 : i3 - 1, l3 = i3 == o3 ? a2 : i3 + 1, c3 = 1 & e5.flags[i3], u3 = 1 & e5.flags[s3], f3 = 1 & e5.flags[l3], d3 = e5.xs[i3], h3 = e5.ys[i3];
            if (i3 == a2)
              if (c3) {
                if (!u3) {
                  t3.U.P.moveTo(r4, d3, h3);
                  continue;
                }
                t3.U.P.moveTo(r4, e5.xs[s3], e5.ys[s3]);
              } else
                u3 ? t3.U.P.moveTo(r4, e5.xs[s3], e5.ys[s3]) : t3.U.P.moveTo(r4, (e5.xs[s3] + d3) / 2, (e5.ys[s3] + h3) / 2);
            c3 ? u3 && t3.U.P.lineTo(r4, d3, h3) : f3 ? t3.U.P.qcurveTo(r4, d3, h3, e5.xs[l3], e5.ys[l3]) : t3.U.P.qcurveTo(r4, d3, h3, (d3 + e5.xs[l3]) / 2, (h3 + e5.ys[l3]) / 2);
          }
          t3.U.P.closePath(r4);
        }
      }, t3.U._compoGlyph = function(e5, r4, n3) {
        for (var a2 = 0; a2 < e5.parts.length; a2++) {
          var o3 = { cmds: [], crds: [] }, i3 = e5.parts[a2];
          t3.U._drawGlyf(i3.glyphIndex, r4, o3);
          for (var s3 = i3.m, l3 = 0; l3 < o3.crds.length; l3 += 2) {
            var c3 = o3.crds[l3], u3 = o3.crds[l3 + 1];
            n3.crds.push(c3 * s3.a + u3 * s3.b + s3.tx), n3.crds.push(c3 * s3.c + u3 * s3.d + s3.ty);
          }
          for (l3 = 0; l3 < o3.cmds.length; l3++)
            n3.cmds.push(o3.cmds[l3]);
        }
      }, t3.U._getGlyphClass = function(e5, r4) {
        var n3 = t3._lctf.getInterval(r4, e5);
        return -1 == n3 ? 0 : r4[n3 + 2];
      }, t3.U.getPairAdjustment = function(e5, r4, n3) {
        var a2 = false;
        if (e5.GPOS)
          for (var o3 = e5.GPOS, i3 = o3.lookupList, s3 = o3.featureList, l3 = [], c3 = 0; c3 < s3.length; c3++) {
            var u3 = s3[c3];
            if ("kern" == u3.tag) {
              a2 = true;
              for (var f3 = 0; f3 < u3.tab.length; f3++)
                if (!l3[u3.tab[f3]]) {
                  l3[u3.tab[f3]] = true;
                  for (var d3 = i3[u3.tab[f3]], h3 = 0; h3 < d3.tabs.length; h3++)
                    if (null != d3.tabs[h3]) {
                      var v6, p3 = d3.tabs[h3];
                      if (!p3.coverage || -1 != (v6 = t3._lctf.coverageIndex(p3.coverage, r4))) {
                        if (1 == d3.ltype)
                          ;
                        else if (2 == d3.ltype) {
                          var g3 = null;
                          if (1 == p3.fmt) {
                            var b3 = p3.pairsets[v6];
                            for (c3 = 0; c3 < b3.length; c3++)
                              b3[c3].gid2 == n3 && (g3 = b3[c3]);
                          } else if (2 == p3.fmt) {
                            var y3 = t3.U._getGlyphClass(r4, p3.classDef1), m3 = t3.U._getGlyphClass(n3, p3.classDef2);
                            g3 = p3.matrix[y3][m3];
                          }
                          if (g3) {
                            var x3 = 0;
                            return g3.val1 && g3.val1[2] && (x3 += g3.val1[2]), g3.val2 && g3.val2[0] && (x3 += g3.val2[0]), x3;
                          }
                        }
                      }
                    }
                }
            }
          }
        if (e5.kern && !a2) {
          var k3 = e5.kern.glyph1.indexOf(r4);
          if (-1 != k3) {
            var w3 = e5.kern.rval[k3].glyph2.indexOf(n3);
            if (-1 != w3)
              return e5.kern.rval[k3].vals[w3];
          }
        }
        return 0;
      }, t3.U._applySubs = function(e5, r4, n3, a2) {
        for (var o3 = e5.length - r4 - 1, i3 = 0; i3 < n3.tabs.length; i3++)
          if (null != n3.tabs[i3]) {
            var s3, l3 = n3.tabs[i3];
            if (!l3.coverage || -1 != (s3 = t3._lctf.coverageIndex(l3.coverage, e5[r4]))) {
              if (1 == n3.ltype)
                e5[r4], 1 == l3.fmt ? e5[r4] = e5[r4] + l3.delta : e5[r4] = l3.newg[s3];
              else if (4 == n3.ltype)
                for (var c3 = l3.vals[s3], u3 = 0; u3 < c3.length; u3++) {
                  var f3 = c3[u3], d3 = f3.chain.length;
                  if (!(d3 > o3)) {
                    for (var h3 = true, v6 = 0, p3 = 0; p3 < d3; p3++) {
                      for (; -1 == e5[r4 + v6 + (1 + p3)]; )
                        v6++;
                      f3.chain[p3] != e5[r4 + v6 + (1 + p3)] && (h3 = false);
                    }
                    if (h3) {
                      for (e5[r4] = f3.nglyph, p3 = 0; p3 < d3 + v6; p3++)
                        e5[r4 + p3 + 1] = -1;
                      break;
                    }
                  }
                }
              else if (5 == n3.ltype && 2 == l3.fmt)
                for (var g3 = t3._lctf.getInterval(l3.cDef, e5[r4]), b3 = l3.cDef[g3 + 2], y3 = l3.scset[b3], m3 = 0; m3 < y3.length; m3++) {
                  var x3 = y3[m3], k3 = x3.input;
                  if (!(k3.length > o3)) {
                    for (h3 = true, p3 = 0; p3 < k3.length; p3++) {
                      var w3 = t3._lctf.getInterval(l3.cDef, e5[r4 + 1 + p3]);
                      if (-1 == g3 && l3.cDef[w3 + 2] != k3[p3]) {
                        h3 = false;
                        break;
                      }
                    }
                    if (h3) {
                      var S3 = x3.substLookupRecords;
                      for (u3 = 0; u3 < S3.length; u3 += 2)
                        S3[u3], S3[u3 + 1];
                    }
                  }
                }
              else if (6 == n3.ltype && 3 == l3.fmt) {
                if (!t3.U._glsCovered(e5, l3.backCvg, r4 - l3.backCvg.length))
                  continue;
                if (!t3.U._glsCovered(e5, l3.inptCvg, r4))
                  continue;
                if (!t3.U._glsCovered(e5, l3.ahedCvg, r4 + l3.inptCvg.length))
                  continue;
                var U3 = l3.lookupRec;
                for (m3 = 0; m3 < U3.length; m3 += 2) {
                  g3 = U3[m3];
                  var T3 = a2[U3[m3 + 1]];
                  t3.U._applySubs(e5, r4 + g3, T3, a2);
                }
              }
            }
          }
      }, t3.U._glsCovered = function(e5, r4, n3) {
        for (var a2 = 0; a2 < r4.length; a2++)
          if (-1 == t3._lctf.coverageIndex(r4[a2], e5[n3 + a2]))
            return false;
        return true;
      }, t3.U.glyphsToPath = function(e5, r4, n3) {
        for (var a2 = { cmds: [], crds: [] }, o3 = 0, i3 = 0; i3 < r4.length; i3++) {
          var s3 = r4[i3];
          if (-1 != s3) {
            for (var l3 = i3 < r4.length - 1 && -1 != r4[i3 + 1] ? r4[i3 + 1] : 0, c3 = t3.U.glyphToPath(e5, s3), u3 = 0; u3 < c3.crds.length; u3 += 2)
              a2.crds.push(c3.crds[u3] + o3), a2.crds.push(c3.crds[u3 + 1]);
            for (n3 && a2.cmds.push(n3), u3 = 0; u3 < c3.cmds.length; u3++)
              a2.cmds.push(c3.cmds[u3]);
            n3 && a2.cmds.push("X"), o3 += e5.hmtx.aWidth[s3], i3 < r4.length - 1 && (o3 += t3.U.getPairAdjustment(e5, s3, l3));
          }
        }
        return a2;
      }, t3.U.P = {}, t3.U.P.moveTo = function(e5, t4, r4) {
        e5.cmds.push("M"), e5.crds.push(t4, r4);
      }, t3.U.P.lineTo = function(e5, t4, r4) {
        e5.cmds.push("L"), e5.crds.push(t4, r4);
      }, t3.U.P.curveTo = function(e5, t4, r4, n3, a2, o3, i3) {
        e5.cmds.push("C"), e5.crds.push(t4, r4, n3, a2, o3, i3);
      }, t3.U.P.qcurveTo = function(e5, t4, r4, n3, a2) {
        e5.cmds.push("Q"), e5.crds.push(t4, r4, n3, a2);
      }, t3.U.P.closePath = function(e5) {
        e5.cmds.push("Z");
      }, t3.U._drawCFF = function(e5, r4, n3, a2, o3) {
        for (var i3 = r4.stack, s3 = r4.nStems, l3 = r4.haveWidth, c3 = r4.width, u3 = r4.open, f3 = 0, d3 = r4.x, h3 = r4.y, v6 = 0, p3 = 0, g3 = 0, b3 = 0, y3 = 0, m3 = 0, x3 = 0, k3 = 0, w3 = 0, S3 = 0, U3 = { val: 0, size: 0 }; f3 < e5.length; ) {
          t3.CFF.getCharString(e5, f3, U3);
          var T3 = U3.val;
          if (f3 += U3.size, "o1" == T3 || "o18" == T3)
            i3.length % 2 != 0 && !l3 && (c3 = i3.shift() + a2.nominalWidthX), s3 += i3.length >> 1, i3.length = 0, l3 = true;
          else if ("o3" == T3 || "o23" == T3)
            i3.length % 2 != 0 && !l3 && (c3 = i3.shift() + a2.nominalWidthX), s3 += i3.length >> 1, i3.length = 0, l3 = true;
          else if ("o4" == T3)
            i3.length > 1 && !l3 && (c3 = i3.shift() + a2.nominalWidthX, l3 = true), u3 && t3.U.P.closePath(o3), h3 += i3.pop(), t3.U.P.moveTo(o3, d3, h3), u3 = true;
          else if ("o5" == T3)
            for (; i3.length > 0; )
              d3 += i3.shift(), h3 += i3.shift(), t3.U.P.lineTo(o3, d3, h3);
          else if ("o6" == T3 || "o7" == T3)
            for (var _3 = i3.length, E4 = "o6" == T3, F3 = 0; F3 < _3; F3++) {
              var C3 = i3.shift();
              E4 ? d3 += C3 : h3 += C3, E4 = !E4, t3.U.P.lineTo(o3, d3, h3);
            }
          else if ("o8" == T3 || "o24" == T3) {
            _3 = i3.length;
            for (var D3 = 0; D3 + 6 <= _3; )
              v6 = d3 + i3.shift(), p3 = h3 + i3.shift(), g3 = v6 + i3.shift(), b3 = p3 + i3.shift(), d3 = g3 + i3.shift(), h3 = b3 + i3.shift(), t3.U.P.curveTo(o3, v6, p3, g3, b3, d3, h3), D3 += 6;
            "o24" == T3 && (d3 += i3.shift(), h3 += i3.shift(), t3.U.P.lineTo(o3, d3, h3));
          } else {
            if ("o11" == T3)
              break;
            if ("o1234" == T3 || "o1235" == T3 || "o1236" == T3 || "o1237" == T3)
              "o1234" == T3 && (p3 = h3, g3 = (v6 = d3 + i3.shift()) + i3.shift(), S3 = b3 = p3 + i3.shift(), m3 = b3, k3 = h3, d3 = (x3 = (y3 = (w3 = g3 + i3.shift()) + i3.shift()) + i3.shift()) + i3.shift(), t3.U.P.curveTo(o3, v6, p3, g3, b3, w3, S3), t3.U.P.curveTo(o3, y3, m3, x3, k3, d3, h3)), "o1235" == T3 && (v6 = d3 + i3.shift(), p3 = h3 + i3.shift(), g3 = v6 + i3.shift(), b3 = p3 + i3.shift(), w3 = g3 + i3.shift(), S3 = b3 + i3.shift(), y3 = w3 + i3.shift(), m3 = S3 + i3.shift(), x3 = y3 + i3.shift(), k3 = m3 + i3.shift(), d3 = x3 + i3.shift(), h3 = k3 + i3.shift(), i3.shift(), t3.U.P.curveTo(o3, v6, p3, g3, b3, w3, S3), t3.U.P.curveTo(o3, y3, m3, x3, k3, d3, h3)), "o1236" == T3 && (v6 = d3 + i3.shift(), p3 = h3 + i3.shift(), g3 = v6 + i3.shift(), S3 = b3 = p3 + i3.shift(), m3 = b3, x3 = (y3 = (w3 = g3 + i3.shift()) + i3.shift()) + i3.shift(), k3 = m3 + i3.shift(), d3 = x3 + i3.shift(), t3.U.P.curveTo(o3, v6, p3, g3, b3, w3, S3), t3.U.P.curveTo(o3, y3, m3, x3, k3, d3, h3)), "o1237" == T3 && (v6 = d3 + i3.shift(), p3 = h3 + i3.shift(), g3 = v6 + i3.shift(), b3 = p3 + i3.shift(), w3 = g3 + i3.shift(), S3 = b3 + i3.shift(), y3 = w3 + i3.shift(), m3 = S3 + i3.shift(), x3 = y3 + i3.shift(), k3 = m3 + i3.shift(), Math.abs(x3 - d3) > Math.abs(k3 - h3) ? d3 = x3 + i3.shift() : h3 = k3 + i3.shift(), t3.U.P.curveTo(o3, v6, p3, g3, b3, w3, S3), t3.U.P.curveTo(o3, y3, m3, x3, k3, d3, h3));
            else if ("o14" == T3) {
              if (i3.length > 0 && !l3 && (c3 = i3.shift() + n3.nominalWidthX, l3 = true), 4 == i3.length) {
                var A3 = i3.shift(), M3 = i3.shift(), P3 = i3.shift(), I3 = i3.shift(), L3 = t3.CFF.glyphBySE(n3, P3), O3 = t3.CFF.glyphBySE(n3, I3);
                t3.U._drawCFF(n3.CharStrings[L3], r4, n3, a2, o3), r4.x = A3, r4.y = M3, t3.U._drawCFF(n3.CharStrings[O3], r4, n3, a2, o3);
              }
              u3 && (t3.U.P.closePath(o3), u3 = false);
            } else if ("o19" == T3 || "o20" == T3)
              i3.length % 2 != 0 && !l3 && (c3 = i3.shift() + a2.nominalWidthX), s3 += i3.length >> 1, i3.length = 0, l3 = true, f3 += s3 + 7 >> 3;
            else if ("o21" == T3)
              i3.length > 2 && !l3 && (c3 = i3.shift() + a2.nominalWidthX, l3 = true), h3 += i3.pop(), d3 += i3.pop(), u3 && t3.U.P.closePath(o3), t3.U.P.moveTo(o3, d3, h3), u3 = true;
            else if ("o22" == T3)
              i3.length > 1 && !l3 && (c3 = i3.shift() + a2.nominalWidthX, l3 = true), d3 += i3.pop(), u3 && t3.U.P.closePath(o3), t3.U.P.moveTo(o3, d3, h3), u3 = true;
            else if ("o25" == T3) {
              for (; i3.length > 6; )
                d3 += i3.shift(), h3 += i3.shift(), t3.U.P.lineTo(o3, d3, h3);
              v6 = d3 + i3.shift(), p3 = h3 + i3.shift(), g3 = v6 + i3.shift(), b3 = p3 + i3.shift(), d3 = g3 + i3.shift(), h3 = b3 + i3.shift(), t3.U.P.curveTo(o3, v6, p3, g3, b3, d3, h3);
            } else if ("o26" == T3)
              for (i3.length % 2 && (d3 += i3.shift()); i3.length > 0; )
                v6 = d3, p3 = h3 + i3.shift(), d3 = g3 = v6 + i3.shift(), h3 = (b3 = p3 + i3.shift()) + i3.shift(), t3.U.P.curveTo(o3, v6, p3, g3, b3, d3, h3);
            else if ("o27" == T3)
              for (i3.length % 2 && (h3 += i3.shift()); i3.length > 0; )
                p3 = h3, g3 = (v6 = d3 + i3.shift()) + i3.shift(), b3 = p3 + i3.shift(), d3 = g3 + i3.shift(), h3 = b3, t3.U.P.curveTo(o3, v6, p3, g3, b3, d3, h3);
            else if ("o10" == T3 || "o29" == T3) {
              var R3 = "o10" == T3 ? a2 : n3;
              if (0 == i3.length)
                console.debug("error: empty stack");
              else {
                var B3 = i3.pop(), G3 = R3.Subrs[B3 + R3.Bias];
                r4.x = d3, r4.y = h3, r4.nStems = s3, r4.haveWidth = l3, r4.width = c3, r4.open = u3, t3.U._drawCFF(G3, r4, n3, a2, o3), d3 = r4.x, h3 = r4.y, s3 = r4.nStems, l3 = r4.haveWidth, c3 = r4.width, u3 = r4.open;
              }
            } else if ("o30" == T3 || "o31" == T3) {
              var N3 = i3.length, z3 = (D3 = 0, "o31" == T3);
              for (D3 += N3 - (_3 = -3 & N3); D3 < _3; )
                z3 ? (p3 = h3, g3 = (v6 = d3 + i3.shift()) + i3.shift(), h3 = (b3 = p3 + i3.shift()) + i3.shift(), _3 - D3 == 5 ? (d3 = g3 + i3.shift(), D3++) : d3 = g3, z3 = false) : (v6 = d3, p3 = h3 + i3.shift(), g3 = v6 + i3.shift(), b3 = p3 + i3.shift(), d3 = g3 + i3.shift(), _3 - D3 == 5 ? (h3 = b3 + i3.shift(), D3++) : h3 = b3, z3 = true), t3.U.P.curveTo(o3, v6, p3, g3, b3, d3, h3), D3 += 4;
            } else {
              if ("o" == (T3 + "").charAt(0))
                throw console.debug("Unknown operation: " + T3, e5), T3;
              i3.push(T3);
            }
          }
        }
        r4.x = d3, r4.y = h3, r4.nStems = s3, r4.haveWidth = l3, r4.width = c3, r4.open = u3;
      };
      var r3 = t3, n2 = { Typr: r3 };
      return e4.Typr = r3, e4.default = n2, Object.defineProperty(e4, "__esModule", { value: true }), e4;
    }({}).Typr;
  }, function() {
    return function(e4) {
      var t3 = Uint8Array, r3 = Uint16Array, n2 = Uint32Array, a2 = new t3([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), o3 = new t3([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), i3 = new t3([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), s3 = function(e5, t4) {
        for (var a3 = new r3(31), o4 = 0; o4 < 31; ++o4)
          a3[o4] = t4 += 1 << e5[o4 - 1];
        var i4 = new n2(a3[30]);
        for (o4 = 1; o4 < 30; ++o4)
          for (var s4 = a3[o4]; s4 < a3[o4 + 1]; ++s4)
            i4[s4] = s4 - a3[o4] << 5 | o4;
        return [a3, i4];
      }, l3 = s3(a2, 2), c3 = l3[0], u3 = l3[1];
      c3[28] = 258, u3[258] = 28;
      for (var f3 = s3(o3, 0)[0], d3 = new r3(32768), h3 = 0; h3 < 32768; ++h3) {
        var v6 = (43690 & h3) >>> 1 | (21845 & h3) << 1;
        v6 = (61680 & (v6 = (52428 & v6) >>> 2 | (13107 & v6) << 2)) >>> 4 | (3855 & v6) << 4, d3[h3] = ((65280 & v6) >>> 8 | (255 & v6) << 8) >>> 1;
      }
      var p3 = function(e5, t4, n3) {
        for (var a3 = e5.length, o4 = 0, i4 = new r3(t4); o4 < a3; ++o4)
          ++i4[e5[o4] - 1];
        var s4, l4 = new r3(t4);
        for (o4 = 0; o4 < t4; ++o4)
          l4[o4] = l4[o4 - 1] + i4[o4 - 1] << 1;
        if (n3) {
          s4 = new r3(1 << t4);
          var c4 = 15 - t4;
          for (o4 = 0; o4 < a3; ++o4)
            if (e5[o4])
              for (var u4 = o4 << 4 | e5[o4], f4 = t4 - e5[o4], h4 = l4[e5[o4] - 1]++ << f4, v7 = h4 | (1 << f4) - 1; h4 <= v7; ++h4)
                s4[d3[h4] >>> c4] = u4;
        } else
          for (s4 = new r3(a3), o4 = 0; o4 < a3; ++o4)
            e5[o4] && (s4[o4] = d3[l4[e5[o4] - 1]++] >>> 15 - e5[o4]);
        return s4;
      }, g3 = new t3(288);
      for (h3 = 0; h3 < 144; ++h3)
        g3[h3] = 8;
      for (h3 = 144; h3 < 256; ++h3)
        g3[h3] = 9;
      for (h3 = 256; h3 < 280; ++h3)
        g3[h3] = 7;
      for (h3 = 280; h3 < 288; ++h3)
        g3[h3] = 8;
      var b3 = new t3(32);
      for (h3 = 0; h3 < 32; ++h3)
        b3[h3] = 5;
      var y3 = p3(g3, 9, 1), m3 = p3(b3, 5, 1), x3 = function(e5) {
        for (var t4 = e5[0], r4 = 1; r4 < e5.length; ++r4)
          e5[r4] > t4 && (t4 = e5[r4]);
        return t4;
      }, k3 = function(e5, t4, r4) {
        var n3 = t4 / 8 | 0;
        return (e5[n3] | e5[n3 + 1] << 8) >> (7 & t4) & r4;
      }, w3 = function(e5, t4) {
        var r4 = t4 / 8 | 0;
        return (e5[r4] | e5[r4 + 1] << 8 | e5[r4 + 2] << 16) >> (7 & t4);
      }, S3 = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler", , "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"], U3 = function(e5, t4, r4) {
        var n3 = new Error(t4 || S3[e5]);
        if (n3.code = e5, Error.captureStackTrace && Error.captureStackTrace(n3, U3), !r4)
          throw n3;
        return n3;
      }, T3 = function(e5, s4, l4) {
        var u4 = e5.length;
        if (!u4 || l4 && !l4.l && u4 < 5)
          return s4 || new t3(0);
        var d4 = !s4 || l4, h4 = !l4 || l4.i;
        l4 || (l4 = {}), s4 || (s4 = new t3(3 * u4));
        var v7, g4 = function(e6) {
          var r4 = s4.length;
          if (e6 > r4) {
            var n3 = new t3(Math.max(2 * r4, e6));
            n3.set(s4), s4 = n3;
          }
        }, b4 = l4.f || 0, S4 = l4.p || 0, T4 = l4.b || 0, _4 = l4.l, E5 = l4.d, F3 = l4.m, C3 = l4.n, D3 = 8 * u4;
        do {
          if (!_4) {
            l4.f = b4 = k3(e5, S4, 1);
            var A3 = k3(e5, S4 + 1, 3);
            if (S4 += 3, !A3) {
              var M3 = e5[(j3 = ((v7 = S4) / 8 | 0) + (7 & v7 && 1) + 4) - 4] | e5[j3 - 3] << 8, P3 = j3 + M3;
              if (P3 > u4) {
                h4 && U3(0);
                break;
              }
              d4 && g4(T4 + M3), s4.set(e5.subarray(j3, P3), T4), l4.b = T4 += M3, l4.p = S4 = 8 * P3;
              continue;
            }
            if (1 == A3)
              _4 = y3, E5 = m3, F3 = 9, C3 = 5;
            else if (2 == A3) {
              var I3 = k3(e5, S4, 31) + 257, L3 = k3(e5, S4 + 10, 15) + 4, O3 = I3 + k3(e5, S4 + 5, 31) + 1;
              S4 += 14;
              for (var R3 = new t3(O3), B3 = new t3(19), G3 = 0; G3 < L3; ++G3)
                B3[i3[G3]] = k3(e5, S4 + 3 * G3, 7);
              S4 += 3 * L3;
              var N3 = x3(B3), z3 = (1 << N3) - 1, V3 = p3(B3, N3, 1);
              for (G3 = 0; G3 < O3; ) {
                var j3, W3 = V3[k3(e5, S4, z3)];
                if (S4 += 15 & W3, (j3 = W3 >>> 4) < 16)
                  R3[G3++] = j3;
                else {
                  var H2 = 0, X3 = 0;
                  for (16 == j3 ? (X3 = 3 + k3(e5, S4, 3), S4 += 2, H2 = R3[G3 - 1]) : 17 == j3 ? (X3 = 3 + k3(e5, S4, 7), S4 += 3) : 18 == j3 && (X3 = 11 + k3(e5, S4, 127), S4 += 7); X3--; )
                    R3[G3++] = H2;
                }
              }
              var q3 = R3.subarray(0, I3), Y3 = R3.subarray(I3);
              F3 = x3(q3), C3 = x3(Y3), _4 = p3(q3, F3, 1), E5 = p3(Y3, C3, 1);
            } else
              U3(1);
            if (S4 > D3) {
              h4 && U3(0);
              break;
            }
          }
          d4 && g4(T4 + 131072);
          for (var $2 = (1 << F3) - 1, Z3 = (1 << C3) - 1, K3 = S4; ; K3 = S4) {
            var Q3 = (H2 = _4[w3(e5, S4) & $2]) >>> 4;
            if ((S4 += 15 & H2) > D3) {
              h4 && U3(0);
              break;
            }
            if (H2 || U3(2), Q3 < 256)
              s4[T4++] = Q3;
            else {
              if (256 == Q3) {
                K3 = S4, _4 = null;
                break;
              }
              var J3 = Q3 - 254;
              if (Q3 > 264) {
                var ee2 = a2[G3 = Q3 - 257];
                J3 = k3(e5, S4, (1 << ee2) - 1) + c3[G3], S4 += ee2;
              }
              var te2 = E5[w3(e5, S4) & Z3], re2 = te2 >>> 4;
              if (te2 || U3(3), S4 += 15 & te2, Y3 = f3[re2], re2 > 3 && (ee2 = o3[re2], Y3 += w3(e5, S4) & (1 << ee2) - 1, S4 += ee2), S4 > D3) {
                h4 && U3(0);
                break;
              }
              d4 && g4(T4 + 131072);
              for (var ne2 = T4 + J3; T4 < ne2; T4 += 4)
                s4[T4] = s4[T4 - Y3], s4[T4 + 1] = s4[T4 + 1 - Y3], s4[T4 + 2] = s4[T4 + 2 - Y3], s4[T4 + 3] = s4[T4 + 3 - Y3];
              T4 = ne2;
            }
          }
          l4.l = _4, l4.p = K3, l4.b = T4, _4 && (b4 = 1, l4.m = F3, l4.d = E5, l4.n = C3);
        } while (!b4);
        return T4 == s4.length ? s4 : function(e6, a3, o4) {
          (null == a3 || a3 < 0) && (a3 = 0), (null == o4 || o4 > e6.length) && (o4 = e6.length);
          var i4 = new (e6 instanceof r3 ? r3 : e6 instanceof n2 ? n2 : t3)(o4 - a3);
          return i4.set(e6.subarray(a3, o4)), i4;
        }(s4, 0, T4);
      }, _3 = new t3(0), E4 = "undefined" != typeof TextDecoder && new TextDecoder();
      try {
        E4.decode(_3, { stream: true });
      } catch (e5) {
      }
      return e4.convert_streams = function(e5) {
        var t4 = new DataView(e5), r4 = 0;
        function n3() {
          var e6 = t4.getUint16(r4);
          return r4 += 2, e6;
        }
        function a3() {
          var e6 = t4.getUint32(r4);
          return r4 += 4, e6;
        }
        function o4(e6) {
          b4.setUint16(y4, e6), y4 += 2;
        }
        function i4(e6) {
          b4.setUint32(y4, e6), y4 += 4;
        }
        for (var s4 = { signature: a3(), flavor: a3(), length: a3(), numTables: n3(), reserved: n3(), totalSfntSize: a3(), majorVersion: n3(), minorVersion: n3(), metaOffset: a3(), metaLength: a3(), metaOrigLength: a3(), privOffset: a3(), privLength: a3() }, l4 = 0; Math.pow(2, l4) <= s4.numTables; )
          l4++;
        l4--;
        for (var c4 = 16 * Math.pow(2, l4), u4 = 16 * s4.numTables - c4, f4 = 12, d4 = [], h4 = 0; h4 < s4.numTables; h4++)
          d4.push({ tag: a3(), offset: a3(), compLength: a3(), origLength: a3(), origChecksum: a3() }), f4 += 16;
        var v7, p4 = new Uint8Array(12 + 16 * d4.length + d4.reduce(function(e6, t5) {
          return e6 + t5.origLength + 4;
        }, 0)), g4 = p4.buffer, b4 = new DataView(g4), y4 = 0;
        return i4(s4.flavor), o4(s4.numTables), o4(c4), o4(l4), o4(u4), d4.forEach(function(e6) {
          i4(e6.tag), i4(e6.origChecksum), i4(f4), i4(e6.origLength), e6.outOffset = f4, (f4 += e6.origLength) % 4 != 0 && (f4 += 4 - f4 % 4);
        }), d4.forEach(function(t5) {
          var r5, n4 = e5.slice(t5.offset, t5.offset + t5.compLength);
          if (t5.compLength != t5.origLength) {
            var a4 = new Uint8Array(t5.origLength);
            r5 = new Uint8Array(n4, 2), T3(r5, a4);
          } else
            a4 = new Uint8Array(n4);
          p4.set(a4, t5.outOffset);
          var o5 = 0;
          (f4 = t5.outOffset + t5.origLength) % 4 != 0 && (o5 = 4 - f4 % 4), p4.set(new Uint8Array(o5).buffer, t5.outOffset + t5.origLength), v7 = f4 + o5;
        }), g4.slice(0, v7);
      }, Object.defineProperty(e4, "__esModule", { value: true }), e4;
    }({}).convert_streams;
  }, function(e4, t3) {
    const r3 = { M: 2, L: 2, Q: 4, C: 6, Z: 0 }, n2 = { C: "18g,ca,368,1kz", D: "17k,6,2,2+4,5+c,2+6,2+1,10+1,9+f,j+11,2+1,a,2,2+1,15+2,3,j+2,6+3,2+8,2,2,2+1,w+a,4+e,3+3,2,3+2,3+5,23+w,2f+4,3,2+9,2,b,2+3,3,1k+9,6+1,3+1,2+2,2+d,30g,p+y,1,1+1g,f+x,2,sd2+1d,jf3+4,f+3,2+4,2+2,b+3,42,2,4+2,2+1,2,3,t+1,9f+w,2,el+2,2+g,d+2,2l,2+1,5,3+1,2+1,2,3,6,16wm+1v", R: "17m+3,2,2,6+3,m,15+2,2+2,h+h,13,3+8,2,2,3+1,2,p+1,x,5+4,5,a,2,2,3,u,c+2,g+1,5,2+1,4+1,5j,6+1,2,b,2+2,f,2+1,1s+2,2,3+1,7,1ez0,2,2+1,4+4,b,4,3,b,42,2+2,4,3,2+1,2,o+3,ae,ep,x,2o+2,3+1,3,5+1,6", L: "x9u,jff,a,fd,jv", T: "4t,gj+33,7o+4,1+1,7c+18,2,2+1,2+1,2,21+a,2,1b+k,h,2u+6,3+5,3+1,2+3,y,2,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,3,7,6+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+d,1,1+1,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,ek,3+1,r+4,1e+4,6+5,2p+c,1+3,1,1+2,1+b,2db+2,3y,2p+v,ff+3,30+1,n9x,1+2,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,5s,6y+2,ea,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+9,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2,2b+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,470+8,at4+4,1o+6,t5,1s+3,2a,f5l+1,2+3,43o+2,a+7,1+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,1,gzau,v+2n,3l+6n" }, a2 = 1, o3 = 2, i3 = 4, s3 = 8, l3 = 16, c3 = 32;
    let u3;
    function f3(e5) {
      if (!u3) {
        const e6 = { R: o3, L: a2, D: i3, C: l3, U: c3, T: s3 };
        u3 = /* @__PURE__ */ new Map();
        for (let t4 in n2) {
          let r4 = 0;
          n2[t4].split(",").forEach((n3) => {
            let [a3, o4] = n3.split("+");
            a3 = parseInt(a3, 36), o4 = o4 ? parseInt(o4, 36) : 0, u3.set(r4 += a3, e6[t4]);
            for (let n4 = o4; n4--; )
              u3.set(++r4, e6[t4]);
          });
        }
      }
      return u3.get(e5) || c3;
    }
    const d3 = 1, h3 = 2, v6 = 3, p3 = 4, g3 = [null, "isol", "init", "fina", "medi"];
    function b3(e5) {
      const t4 = new Uint8Array(e5.length);
      let r4 = c3, n3 = d3, u4 = -1;
      for (let g4 = 0; g4 < e5.length; g4++) {
        const b4 = e5.codePointAt(g4);
        let y4 = 0 | f3(b4), m3 = d3;
        y4 & s3 || (r4 & (a2 | i3 | l3) ? y4 & (o3 | i3 | l3) ? (m3 = v6, n3 !== d3 && n3 !== v6 || t4[u4]++) : y4 & (a2 | c3) && (n3 !== h3 && n3 !== p3 || t4[u4]--) : r4 & (o3 | c3) && (n3 !== h3 && n3 !== p3 || t4[u4]--), n3 = t4[g4] = m3, r4 = y4, u4 = g4, b4 > 65535 && g4++);
      }
      return t4;
    }
    function y3(...e5) {
      for (let t4 = 0; t4 < e5.length; t4++)
        if ("number" == typeof e5[t4])
          return e5[t4];
    }
    return function(n3) {
      const a3 = new Uint8Array(n3, 0, 4), o4 = e4._bin.readASCII(a3, 0, 4);
      if ("wOFF" === o4)
        n3 = t3(n3);
      else if ("wOF2" === o4)
        throw new Error("woff2 fonts not supported");
      return function(t4) {
        const n4 = /* @__PURE__ */ Object.create(null), a4 = t4["OS/2"], o5 = t4.hhea, i4 = t4.head.unitsPerEm, s4 = y3(a4 && a4.sTypoAscender, o5 && o5.ascender, i4), l4 = { unitsPerEm: i4, ascender: s4, descender: y3(a4 && a4.sTypoDescender, o5 && o5.descender, 0), capHeight: y3(a4 && a4.sCapHeight, s4), xHeight: y3(a4 && a4.sxHeight, s4), lineGap: y3(a4 && a4.sTypoLineGap, o5 && o5.lineGap), supportsCodePoint: (r4) => e4.U.codeToGlyph(t4, r4) > 0, forEachGlyph(a5, o6, i5, s5) {
          let c4 = 0;
          const u4 = 1 / l4.unitsPerEm * o6, f4 = function(t5, r4) {
            const n5 = [];
            for (let a7 = 0; a7 < r4.length; a7++) {
              const o7 = r4.codePointAt(a7);
              o7 > 65535 && a7++, n5.push(e4.U.codeToGlyph(t5, o7));
            }
            const a6 = t5.GSUB;
            if (a6) {
              const { lookupList: t6, featureList: o7 } = a6;
              let i6;
              const s6 = /^(rlig|liga|mset|isol|init|fina|medi|half|pres|blws)$/, l5 = [];
              o7.forEach((a7) => {
                if (s6.test(a7.tag))
                  for (let o8 = 0; o8 < a7.tab.length; o8++) {
                    if (l5[a7.tab[o8]])
                      continue;
                    l5[a7.tab[o8]] = true;
                    const s7 = t6[a7.tab[o8]], c5 = /^(isol|init|fina|medi)$/.test(a7.tag);
                    c5 && !i6 && (i6 = b3(r4));
                    for (let r5 = 0; r5 < n5.length; r5++)
                      i6 && c5 && g3[i6[r5]] !== a7.tag || e4.U._applySubs(n5, r5, s7, t6);
                  }
              });
            }
            return n5;
          }(t4, a5);
          let d4 = 0, h4 = -1;
          return f4.forEach((l5, f5) => {
            if (-1 !== l5) {
              let a6 = n4[l5];
              if (!a6) {
                const { cmds: o7, crds: i6 } = e4.U.glyphToPath(t4, l5);
                let s6, c5, u5, f6, d5 = "", h5 = 0;
                for (let e5 = 0, t5 = o7.length; e5 < t5; e5++) {
                  const t6 = r3[o7[e5]];
                  d5 += o7[e5];
                  for (let e6 = 1; e6 <= t6; e6++)
                    d5 += (e6 > 1 ? "," : "") + i6[h5++];
                }
                if (i6.length) {
                  s6 = c5 = 1 / 0, u5 = f6 = -1 / 0;
                  for (let e5 = 0, t5 = i6.length; e5 < t5; e5 += 2) {
                    let t6 = i6[e5], r4 = i6[e5 + 1];
                    t6 < s6 && (s6 = t6), r4 < c5 && (c5 = r4), t6 > u5 && (u5 = t6), r4 > f6 && (f6 = r4);
                  }
                } else
                  s6 = u5 = c5 = f6 = 0;
                a6 = n4[l5] = { index: l5, advanceWidth: t4.hmtx.aWidth[l5], xMin: s6, yMin: c5, xMax: u5, yMax: f6, path: d5, pathCommandCount: o7.length };
              }
              -1 !== h4 && (c4 += e4.U.getPairAdjustment(t4, h4, l5) * u4), s5.call(null, a6, c4, d4), a6.advanceWidth && (c4 += a6.advanceWidth * u4), i5 && (c4 += i5 * o6), h4 = l5;
            }
            d4 += a5.codePointAt(d4) > 65535 ? 2 : 1;
          }), c4;
        } };
        return l4;
      }(e4.parse(n3)[0]);
    };
  }], init: (e4, t3, r3) => r3(e4(), t3()) }), C2 = f2({ name: "FontResolver", dependencies: [function(e4, t3) {
    const r3 = /* @__PURE__ */ Object.create(null), n2 = /* @__PURE__ */ Object.create(null);
    function a2(t4, a3) {
      let o3 = r3[t4];
      o3 ? a3(o3) : n2[t4] ? n2[t4].push(a3) : (n2[t4] = [a3], function(a4, o4) {
        const i3 = (e5) => {
          console.error(`Failure loading font ${a4}`, e5);
        };
        try {
          const o5 = new XMLHttpRequest();
          o5.open("get", a4, true), o5.responseType = "arraybuffer", o5.onload = function() {
            if (o5.status >= 400)
              i3(new Error(o5.statusText));
            else if (o5.status > 0)
              try {
                const i4 = e4(o5.response);
                i4.src = a4, ((e5) => {
                  e5.src = t4, r3[t4] = e5, n2[t4].forEach((t5) => t5(e5)), delete n2[t4];
                })(i4);
              } catch (e5) {
                i3(e5);
              }
          }, o5.onerror = i3, o5.send();
        } catch (e5) {
          i3(e5);
        }
      }(t4));
    }
    return function(e5, n3, { lang: o3, fonts: i3 = [], style: s3 = "normal", weight: l3 = "normal", unicodeFontsURL: c3 } = {}) {
      const u3 = new Uint8Array(e5.length), f3 = [];
      e5.length || p3();
      const d3 = /* @__PURE__ */ new Map(), h3 = [];
      if ("italic" !== s3 && (s3 = "normal"), "number" != typeof l3 && (l3 = "bold" === l3 ? 700 : 400), i3 && !Array.isArray(i3) && (i3 = [i3]), (i3 = i3.slice().filter((e6) => !e6.lang || e6.lang.test(o3)).reverse()).length) {
        const t4 = 1, n4 = 2;
        let o4 = 0;
        !function s4(l4 = 0) {
          for (let c4 = l4, v7 = e5.length; c4 < v7; c4++) {
            const l5 = e5.codePointAt(c4);
            if (o4 === t4 && f3[u3[c4 - 1]].supportsCodePoint(l5) || /\s/.test(e5[c4]))
              u3[c4] = u3[c4 - 1], o4 === n4 && (h3[h3.length - 1][1] = c4);
            else
              for (let e6 = u3[c4], v8 = i3.length; e6 <= v8; e6++)
                if (e6 === v8)
                  (o4 === n4 ? h3[h3.length - 1] : h3[h3.length] = [c4, c4])[1] = c4, o4 = n4;
                else {
                  u3[c4] = e6;
                  const { src: n5, unicodeRange: h4 } = i3[e6];
                  if (!h4 || g3(l5, h4)) {
                    const e7 = r3[n5];
                    if (!e7)
                      return void a2(n5, () => {
                        s4(c4);
                      });
                    if (e7.supportsCodePoint(l5)) {
                      let r4 = d3.get(e7);
                      "number" != typeof r4 && (r4 = f3.length, f3.push(e7), d3.set(e7, r4)), u3[c4] = r4, o4 = t4;
                      break;
                    }
                  }
                }
            l5 > 65535 && c4 + 1 < v7 && (u3[c4 + 1] = u3[c4], c4++, o4 === n4 && (h3[h3.length - 1][1] = c4));
          }
          v6();
        }();
      } else
        h3.push([0, e5.length - 1]), v6();
      function v6() {
        if (h3.length) {
          const r4 = h3.map((t4) => e5.substring(t4[0], t4[1] + 1)).join("\n");
          t3.getFontsForString(r4, { lang: o3 || void 0, style: s3, weight: l3, dataUrl: c3 }).then(({ fontUrls: e6, chars: t4 }) => {
            const r5 = f3.length;
            let n4 = 0;
            h3.forEach((e7) => {
              for (let a3 = 0, o5 = e7[1] - e7[0]; a3 <= o5; a3++)
                u3[e7[0] + a3] = t4[n4++] + r5;
              n4++;
            });
            let o4 = 0;
            e6.forEach((t5, n5) => {
              a2(t5, (t6) => {
                f3[n5 + r5] = t6, ++o4 === e6.length && p3();
              });
            });
          });
        } else
          p3();
      }
      function p3() {
        n3({ chars: u3, fonts: f3 });
      }
      function g3(e6, t4) {
        for (let r4 = 0; r4 < t4.length; r4++) {
          const [n4, a3 = n4] = t4[r4];
          if (n4 <= e6 && e6 <= a3)
            return true;
        }
        return false;
      }
    };
  }, F2, function() {
    return function(e4) {
      var t3 = function() {
        this.buckets = /* @__PURE__ */ new Map();
      };
      t3.prototype.add = function(e5) {
        var t4 = e5 >> 5;
        this.buckets.set(t4, (this.buckets.get(t4) || 0) | 1 << (31 & e5));
      }, t3.prototype.has = function(e5) {
        var t4 = this.buckets.get(e5 >> 5);
        return void 0 !== t4 && 0 != (t4 & 1 << (31 & e5));
      }, t3.prototype.serialize = function() {
        var e5 = [];
        return this.buckets.forEach(function(t4, r4) {
          e5.push((+r4).toString(36) + ":" + t4.toString(36));
        }), e5.join(",");
      }, t3.prototype.deserialize = function(e5) {
        var t4 = this;
        this.buckets.clear(), e5.split(",").forEach(function(e6) {
          var r4 = e6.split(":");
          t4.buckets.set(parseInt(r4[0], 36), parseInt(r4[1], 36));
        });
      };
      var r3 = Math.pow(2, 8), n2 = r3 - 1, a2 = ~n2;
      function o3(e5) {
        var t4 = function(e6) {
          return e6 & a2;
        }(e5).toString(16), n3 = function(e6) {
          return (e6 & a2) + r3 - 1;
        }(e5).toString(16);
        return "codepoint-index/plane" + (e5 >> 16) + "/" + t4 + "-" + n3 + ".json";
      }
      function i3(e5, t4) {
        var r4 = e5 & n2, a3 = t4.codePointAt(r4 / 6 | 0);
        return 0 != ((a3 = (a3 || 48) - 48) & 1 << r4 % 6);
      }
      function s3(e5, t4) {
        !function(e6, t5) {
          var r4;
          (r4 = e6, r4.replace(/U\+/gi, "").replace(/^,+|,+$/g, "").split(/,+/).map(function(e7) {
            return e7.split("-").map(function(e8) {
              return parseInt(e8.trim(), 16);
            });
          })).forEach(function(e7) {
            var r5 = e7[0], n3 = e7[1];
            void 0 === n3 && (n3 = r5), t5(r5, n3);
          });
        }(e5, function(e6, r4) {
          for (var n3 = e6; n3 <= r4; n3++)
            t4(n3);
        });
      }
      var l3 = {}, c3 = {}, u3 = /* @__PURE__ */ new WeakMap(), f3 = "https://cdn.jsdelivr.net/gh/lojjic/unicode-font-resolver@v1.0.1/packages/data";
      function d3(e5) {
        var r4 = u3.get(e5);
        return r4 || (r4 = new t3(), s3(e5.ranges, function(e6) {
          return r4.add(e6);
        }), u3.set(e5, r4)), r4;
      }
      var h3, v6 = /* @__PURE__ */ new Map();
      function p3(e5, t4, r4) {
        return e5[t4] ? t4 : e5[r4] ? r4 : function(e6) {
          for (var t5 in e6)
            return t5;
        }(e5);
      }
      function g3(e5, t4) {
        var r4 = t4;
        if (!e5.includes(r4)) {
          r4 = 1 / 0;
          for (var n3 = 0; n3 < e5.length; n3++)
            Math.abs(e5[n3] - t4) < Math.abs(r4 - t4) && (r4 = e5[n3]);
        }
        return r4;
      }
      function b3(e5) {
        return h3 || (h3 = /* @__PURE__ */ new Set(), s3("9-D,20,85,A0,1680,2000-200A,2028-202F,205F,3000", function(e6) {
          h3.add(e6);
        })), h3.has(e5);
      }
      return e4.CodePointSet = t3, e4.clearCache = function() {
        l3 = {}, c3 = {};
      }, e4.getFontsForString = function(e5, t4) {
        void 0 === t4 && (t4 = {});
        var r4, n3 = t4.lang;
        void 0 === n3 && (n3 = /\p{Script=Hangul}/u.test(r4 = e5) ? "ko" : /\p{Script=Hiragana}|\p{Script=Katakana}/u.test(r4) ? "ja" : "en");
        var a3 = t4.category;
        void 0 === a3 && (a3 = "sans-serif");
        var s4 = t4.style;
        void 0 === s4 && (s4 = "normal");
        var u4 = t4.weight;
        void 0 === u4 && (u4 = 400);
        var h4 = (t4.dataUrl || f3).replace(/\/$/g, ""), y3 = /* @__PURE__ */ new Map(), m3 = new Uint8Array(e5.length), x3 = {}, k3 = {}, w3 = new Array(e5.length), S3 = /* @__PURE__ */ new Map(), U3 = false;
        function T3(e6) {
          var t5 = v6.get(e6);
          return t5 || (t5 = fetch(h4 + "/" + e6).then(function(e7) {
            if (!e7.ok)
              throw new Error(e7.statusText);
            return e7.json().then(function(e8) {
              if (!Array.isArray(e8) || 1 !== e8[0])
                throw new Error("Incorrect schema version; need 1, got " + e8[0]);
              return e8[1];
            });
          }).catch(function(t6) {
            if (h4 !== f3)
              return U3 || (console.error('unicode-font-resolver: Failed loading from dataUrl "' + h4 + '", trying default CDN. ' + t6.message), U3 = true), h4 = f3, v6.delete(e6), T3(e6);
            throw t6;
          }), v6.set(e6, t5)), t5;
        }
        for (var _3 = function(t5) {
          var r5 = e5.codePointAt(t5), n4 = o3(r5);
          w3[t5] = n4, l3[n4] || S3.has(n4) || S3.set(n4, T3(n4).then(function(e6) {
            l3[n4] = e6;
          })), r5 > 65535 && (t5++, E4 = t5);
        }, E4 = 0; E4 < e5.length; E4++)
          _3(E4);
        return Promise.all(S3.values()).then(function() {
          S3.clear();
          for (var t5 = function(t6) {
            var a4 = e5.codePointAt(t6), o4 = null, s5 = l3[w3[t6]], u5 = void 0;
            for (var f4 in s5) {
              var d4 = k3[f4];
              if (void 0 === d4 && (d4 = k3[f4] = new RegExp(f4).test(n3 || "en")), d4) {
                for (var h5 in u5 = f4, s5[f4])
                  if (i3(a4, s5[f4][h5])) {
                    o4 = h5;
                    break;
                  }
                break;
              }
            }
            if (!o4) {
              e:
                for (var v7 in s5)
                  if (v7 !== u5) {
                    for (var p4 in s5[v7])
                      if (i3(a4, s5[v7][p4])) {
                        o4 = p4;
                        break e;
                      }
                  }
            }
            o4 || (console.debug("No font coverage for U+" + a4.toString(16)), o4 = "latin"), w3[t6] = o4, c3[o4] || S3.has(o4) || S3.set(o4, T3("font-meta/" + o4 + ".json").then(function(e6) {
              c3[o4] = e6;
            })), a4 > 65535 && (t6++, r5 = t6);
          }, r5 = 0; r5 < e5.length; r5++)
            t5(r5);
          return Promise.all(S3.values());
        }).then(function() {
          for (var t5, r5 = null, n4 = 0; n4 < e5.length; n4++) {
            var o4 = e5.codePointAt(n4);
            if (r5 && (b3(o4) || d3(r5).has(o4)))
              m3[n4] = m3[n4 - 1];
            else {
              r5 = c3[w3[n4]];
              var i4 = x3[r5.id];
              if (!i4) {
                var l4 = r5.typeforms, f4 = p3(l4, a3, "sans-serif"), v7 = p3(l4[f4], s4, "normal"), k4 = g3(null === (t5 = l4[f4]) || void 0 === t5 ? void 0 : t5[v7], u4);
                i4 = x3[r5.id] = h4 + "/font-files/" + r5.id + "/" + f4 + "." + v7 + "." + k4 + ".woff";
              }
              var S4 = y3.get(i4);
              null == S4 && (S4 = y3.size, y3.set(i4, S4)), m3[n4] = S4;
            }
            o4 > 65535 && (n4++, m3[n4] = m3[n4 - 1]);
          }
          return { fontUrls: Array.from(y3.keys()), chars: m3 };
        });
      }, Object.defineProperty(e4, "__esModule", { value: true }), e4;
    }({});
  }], init: (e4, t3, r3) => e4(t3, r3()) }), D2 = () => (self.performance || Date).now(), A2 = v5();
  let M2;
  const P2 = [];
  let I2 = 0;
  function L2() {
    const e4 = D2();
    for (; P2.length && D2() - e4 < 5; )
      P2.shift()();
    I2 = P2.length ? setTimeout(L2, 0) : 0;
  }
  const O2 = (...e4) => new Promise((t3, r3) => {
    P2.push(() => {
      const n2 = D2();
      try {
        A2.webgl.generateIntoCanvas(...e4), t3({ timing: D2() - n2 });
      } catch (e5) {
        r3(e5);
      }
    }), I2 || (I2 = setTimeout(L2, 0));
  }), R2 = 4, B2 = 2e3, G2 = {};
  let N2 = 0;
  function z2(e4, t3, r3, n2, a2, o3, i3, s3, u3, d3) {
    const h3 = "TroikaTextSDFGenerator_JS_" + N2++ % R2;
    let p3 = G2[h3];
    return p3 || (p3 = G2[h3] = { workerModule: f2({ name: h3, workerId: h3, dependencies: [v5, D2], init(e5, t4) {
      const r4 = e5().javascript.generate;
      return function(...e6) {
        const n3 = t4();
        return { textureData: r4(...e6), timing: t4() - n3 };
      };
    }, getTransferables: (e5) => [e5.textureData.buffer] }), requests: 0, idleTimer: null }), p3.requests++, clearTimeout(p3.idleTimer), p3.workerModule(e4, t3, r3, n2, a2, o3).then(({ textureData: r4, timing: n3 }) => {
      const a3 = D2(), o4 = new Uint8Array(4 * r4.length);
      for (let e5 = 0; e5 < r4.length; e5++)
        o4[4 * e5 + d3] = r4[e5];
      return A2.webglUtils.renderImageData(i3, o4, s3, u3, e4, t3, 1 << 3 - d3), n3 += D2() - a3, 0 == --p3.requests && (p3.idleTimer = setTimeout(() => {
        !function(e5) {
          c2[e5] && c2[e5].forEach(function(e6) {
            e6();
          }), l2[e5] && (l2[e5].terminate(), delete l2[e5]);
        }(h3);
      }, B2)), { timing: n3 };
    });
  }
  const V2 = A2.webglUtils.resizeWebGLCanvasWithoutClearing, j2 = { defaultFontURL: null, unicodeFontsURL: null, sdfGlyphSize: 64, sdfMargin: 1 / 16, sdfExponent: 9, textureWidth: 2048 }, W2 = new e3.Color();
  function X2() {
    return (self.performance || Date).now();
  }
  const q2 = /* @__PURE__ */ Object.create(null);
  function Y2({ path: e4, atlasIndex: t3, sdfViewBox: r3 }, { sdfGlyphSize: n2, sdfCanvas: a2, contextLost: o3 }, i3) {
    if (o3)
      return Promise.resolve({ timing: -1 });
    const { textureWidth: s3, sdfExponent: l3 } = j2, c3 = Math.max(r3[2] - r3[0], r3[3] - r3[1]), u3 = Math.floor(t3 / 4);
    return function(e5, t4, r4, n3, a3, o4, i4, s4, l4, c4, u4 = true) {
      return u4 ? O2(e5, t4, r4, n3, a3, o4, i4, s4, l4, c4).then(null, (u5) => (M2 || (console.warn("WebGL SDF generation failed, falling back to JS", u5), M2 = true), z2(e5, t4, r4, n3, a3, o4, i4, s4, l4, c4))) : z2(e5, t4, r4, n3, a3, o4, i4, s4, l4, c4);
    }(n2, n2, e4, r3, c3, l3, a2, u3 % (s3 / n2) * n2, Math.floor(u3 / (s3 / n2)) * n2, t3 % 4, i3);
  }
  let $;
  function Z2(e4) {
    return $ || ($ = "undefined" == typeof document ? {} : document.createElement("a")), $.href = e4, $.href;
  }
  function K2(e4) {
    if ("function" != typeof createImageBitmap) {
      console.info("Safari<15: applying SDF canvas workaround");
      const { sdfCanvas: t3, sdfTexture: r3 } = e4, { width: n2, height: a2 } = t3, o3 = e4.sdfCanvas.getContext("webgl");
      let i3 = r3.image.data;
      i3 && i3.length === n2 * a2 * 4 || (i3 = new Uint8Array(n2 * a2 * 4), r3.image = { width: n2, height: a2, data: i3 }, r3.flipY = false, r3.isDataTexture = true), o3.readPixels(0, 0, n2, a2, o3.RGBA, o3.UNSIGNED_BYTE, i3);
    }
  }
  const Q2 = f2({ name: "Typesetter", dependencies: [function(e4, t3) {
    const r3 = 1 / 0, n2 = /[\u00AD\u034F\u061C\u115F-\u1160\u17B4-\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8]/, a2 = "[^\\S\\u00A0]", o3 = new RegExp(`${a2}|[\\-\\u007C\\u00AD\\u2010\\u2012-\\u2014\\u2027\\u2056\\u2E17\\u2E40]`);
    function i3({ text: i4 = "", font: f4, lang: d3, sdfGlyphSize: h3 = 64, fontSize: v6 = 400, fontWeight: p3 = 1, fontStyle: g3 = "normal", letterSpacing: b3 = 0, lineHeight: y3 = "normal", maxWidth: m3 = r3, direction: x3, textAlign: k3 = "left", textIndent: w3 = 0, whiteSpace: S3 = "normal", overflowWrap: U3 = "normal", anchorX: T3 = 0, anchorY: _3 = 0, metricsOnly: E4 = false, unicodeFontsURL: F3, preResolvedFonts: C3 = null, includeCaretPositions: D3 = false, chunkedBoundsSize: A3 = 8192, colorRanges: M3 = null }, P3) {
      const I3 = c3(), L3 = { fontLoad: 0, typesetting: 0 };
      i4.indexOf("\r") > -1 && (console.info("Typesetter: got text with \\r chars; normalizing to \\n"), i4 = i4.replace(/\r\n/g, "\n").replace(/\r/g, "\n")), v6 = +v6, b3 = +b3, m3 = +m3, y3 = y3 || "normal", w3 = +w3, function({ text: t4, lang: r4, fonts: n3, style: a3, weight: o4, preResolvedFonts: i5, unicodeFontsURL: s4 }, l4) {
        const c4 = ({ chars: e5, fonts: t5 }) => {
          let r5, n4;
          const a4 = [];
          for (let o5 = 0; o5 < e5.length; o5++)
            e5[o5] !== n4 ? (n4 = e5[o5], a4.push(r5 = { start: o5, end: o5, fontObj: t5[e5[o5]] })) : r5.end = o5;
          l4(a4);
        };
        i5 ? c4(i5) : e4(t4, c4, { lang: r4, fonts: n3, style: a3, weight: o4, unicodeFontsURL: s4 });
      }({ text: i4, lang: d3, style: g3, weight: p3, fonts: "string" == typeof f4 ? [{ src: f4 }] : f4, unicodeFontsURL: F3, preResolvedFonts: C3 }, (e5) => {
        L3.fontLoad = c3() - I3;
        const f5 = isFinite(m3);
        let d4 = null, h4 = null, p4 = null, g4 = null, F4 = null, C4 = null, O3 = null, R3 = null, B3 = 0, G3 = 0, N3 = "nowrap" !== S3;
        const z3 = /* @__PURE__ */ new Map(), V3 = c3();
        let j3 = w3, W3 = 0, H2 = new u3();
        const X3 = [H2];
        e5.forEach((e6) => {
          const { fontObj: t4 } = e6, { ascender: r4, descender: s4, unitsPerEm: l4, lineGap: c4, capHeight: d5, xHeight: h5 } = t4;
          let p5 = z3.get(t4);
          if (!p5) {
            const e7 = v6 / l4, n3 = "normal" === y3 ? (r4 - s4 + c4) * e7 : y3 * v6, a3 = (n3 - (r4 - s4) * e7) / 2, o4 = Math.min(n3, (r4 - s4) * e7), i5 = (r4 + s4) / 2 * e7 + o4 / 2;
            p5 = { index: z3.size, src: t4.src, fontObj: t4, fontSizeMult: e7, unitsPerEm: l4, ascender: r4 * e7, descender: s4 * e7, capHeight: d5 * e7, xHeight: h5 * e7, lineHeight: n3, baseline: -a3 - r4 * e7, caretTop: (r4 + s4) / 2 * e7 + o4 / 2, caretBottom: i5 - o4 }, z3.set(t4, p5);
          }
          const { fontSizeMult: g5 } = p5, x4 = i4.slice(e6.start, e6.end + 1);
          let k4, S4;
          t4.forEachGlyph(x4, v6, b3, (t5, r5, s5) => {
            r5 += W3, s5 += e6.start, k4 = r5, S4 = t5;
            const l5 = i4.charAt(s5), c5 = t5.advanceWidth * g5, d6 = H2.count;
            let h6;
            if ("isEmpty" in t5 || (t5.isWhitespace = !!l5 && new RegExp(a2).test(l5), t5.canBreakAfter = !!l5 && o3.test(l5), t5.isEmpty = t5.xMin === t5.xMax || t5.yMin === t5.yMax || n2.test(l5)), t5.isWhitespace || t5.isEmpty || G3++, N3 && f5 && !t5.isWhitespace && r5 + c5 + j3 > m3 && d6) {
              if (H2.glyphAt(d6 - 1).glyphObj.canBreakAfter)
                h6 = new u3(), j3 = -r5;
              else
                for (let e7 = d6; e7--; ) {
                  if (0 === e7 && "break-word" === U3) {
                    h6 = new u3(), j3 = -r5;
                    break;
                  }
                  if (H2.glyphAt(e7).glyphObj.canBreakAfter) {
                    h6 = H2.splitAt(e7 + 1);
                    const t6 = h6.glyphAt(0).x;
                    j3 -= t6;
                    for (let e8 = h6.count; e8--; )
                      h6.glyphAt(e8).x -= t6;
                    break;
                  }
                }
              h6 && (H2.isSoftWrapped = true, H2 = h6, X3.push(H2), B3 = m3);
            }
            let y4 = H2.glyphAt(H2.count);
            y4.glyphObj = t5, y4.x = r5 + j3, y4.width = c5, y4.charIndex = s5, y4.fontData = p5, "\n" === l5 && (H2 = new u3(), X3.push(H2), j3 = -(r5 + c5 + b3 * v6) + w3);
          }), W3 = k4 + S4.advanceWidth * g5 + b3 * v6;
        });
        let q3 = 0;
        X3.forEach((e6) => {
          let t4 = true;
          for (let r4 = e6.count; r4--; ) {
            const n3 = e6.glyphAt(r4);
            t4 && !n3.glyphObj.isWhitespace && (e6.width = n3.x + n3.width, e6.width > B3 && (B3 = e6.width), t4 = false);
            let { lineHeight: a3, capHeight: o4, xHeight: i5, baseline: s4 } = n3.fontData;
            a3 > e6.lineHeight && (e6.lineHeight = a3);
            const l4 = s4 - e6.baseline;
            l4 < 0 && (e6.baseline += l4, e6.cap += l4, e6.ex += l4), e6.cap = Math.max(e6.cap, e6.baseline + o4), e6.ex = Math.max(e6.ex, e6.baseline + i5);
          }
          e6.baseline -= q3, e6.cap -= q3, e6.ex -= q3, q3 += e6.lineHeight;
        });
        let Y3 = 0, $2 = 0;
        if (T3 && ("number" == typeof T3 ? Y3 = -T3 : "string" == typeof T3 && (Y3 = -B3 * ("left" === T3 ? 0 : "center" === T3 ? 0.5 : "right" === T3 ? 1 : s3(T3)))), _3 && ("number" == typeof _3 ? $2 = -_3 : "string" == typeof _3 && ($2 = "top" === _3 ? 0 : "top-baseline" === _3 ? -X3[0].baseline : "top-cap" === _3 ? -X3[0].cap : "top-ex" === _3 ? -X3[0].ex : "middle" === _3 ? q3 / 2 : "bottom" === _3 ? q3 : "bottom-baseline" === _3 ? X3[X3.length - 1].baseline : s3(_3) * q3)), !E4) {
          const e6 = t3.getEmbeddingLevels(i4, x3);
          d4 = new Uint16Array(G3), h4 = new Uint8Array(G3), p4 = new Float32Array(2 * G3), g4 = {}, O3 = [r3, r3, -1 / 0, -1 / 0], R3 = [], D3 && (C4 = new Float32Array(4 * i4.length)), M3 && (F4 = new Uint8Array(3 * G3));
          let n3, a3, o4 = 0, s4 = -1, c4 = -1;
          if (X3.forEach((u4, f6) => {
            let { count: v7, width: b4 } = u4;
            if (v7 > 0) {
              let f7 = 0;
              for (let e7 = v7; e7-- && u4.glyphAt(e7).glyphObj.isWhitespace; )
                f7++;
              let y4 = 0, m4 = 0;
              if ("center" === k3)
                y4 = (B3 - b4) / 2;
              else if ("right" === k3)
                y4 = B3 - b4;
              else if ("justify" === k3 && u4.isSoftWrapped) {
                let e7 = 0;
                for (let t4 = v7 - f7; t4--; )
                  u4.glyphAt(t4).glyphObj.isWhitespace && e7++;
                m4 = (B3 - b4) / e7;
              }
              if (m4 || y4) {
                let e7 = 0;
                for (let t4 = 0; t4 < v7; t4++) {
                  let r4 = u4.glyphAt(t4);
                  const n4 = r4.glyphObj;
                  r4.x += y4 + e7, 0 !== m4 && n4.isWhitespace && t4 < v7 - f7 && (e7 += m4, r4.width += m4);
                }
              }
              const x4 = t3.getReorderSegments(i4, e6, u4.glyphAt(0).charIndex, u4.glyphAt(u4.count - 1).charIndex);
              for (let e7 = 0; e7 < x4.length; e7++) {
                const [t4, r4] = x4[e7];
                let n4 = 1 / 0, a4 = -1 / 0;
                for (let e8 = 0; e8 < v7; e8++)
                  if (u4.glyphAt(e8).charIndex >= t4) {
                    let t5 = e8, o5 = e8;
                    for (; o5 < v7; o5++) {
                      let e9 = u4.glyphAt(o5);
                      if (e9.charIndex > r4)
                        break;
                      o5 < v7 - f7 && (n4 = Math.min(n4, e9.x), a4 = Math.max(a4, e9.x + e9.width));
                    }
                    for (let e9 = t5; e9 < o5; e9++) {
                      const t6 = u4.glyphAt(e9);
                      t6.x = a4 - (t6.x + t6.width - n4);
                    }
                    break;
                  }
              }
              let w4;
              const S4 = (e7) => w4 = e7;
              for (let f8 = 0; f8 < v7; f8++) {
                const v8 = u4.glyphAt(f8);
                w4 = v8.glyphObj;
                const b5 = w4.index, y5 = 1 & e6.levels[v8.charIndex];
                if (y5) {
                  const e7 = t3.getMirroredCharacter(i4[v8.charIndex]);
                  e7 && v8.fontData.fontObj.forEachGlyph(e7, 0, 0, S4);
                }
                if (D3) {
                  const { charIndex: e7, fontData: t4 } = v8, r4 = v8.x + Y3, n4 = v8.x + v8.width + Y3;
                  C4[4 * e7] = y5 ? n4 : r4, C4[4 * e7 + 1] = y5 ? r4 : n4, C4[4 * e7 + 2] = u4.baseline + t4.caretBottom + $2, C4[4 * e7 + 3] = u4.baseline + t4.caretTop + $2;
                  const a4 = e7 - s4;
                  a4 > 1 && l3(C4, s4, a4), s4 = e7;
                }
                if (M3) {
                  const { charIndex: e7 } = v8;
                  for (; e7 > c4; )
                    c4++, M3.hasOwnProperty(c4) && (a3 = M3[c4]);
                }
                if (!w4.isWhitespace && !w4.isEmpty) {
                  const e7 = o4++, { fontSizeMult: t4, src: i5, index: s5 } = v8.fontData, l4 = g4[i5] || (g4[i5] = {});
                  l4[b5] || (l4[b5] = { path: w4.path, pathBounds: [w4.xMin, w4.yMin, w4.xMax, w4.yMax] });
                  const c5 = v8.x + Y3, f9 = u4.baseline + $2;
                  p4[2 * e7] = c5, p4[2 * e7 + 1] = f9;
                  const y6 = c5 + w4.xMin * t4, m5 = f9 + w4.yMin * t4, x5 = c5 + w4.xMax * t4, k4 = f9 + w4.yMax * t4;
                  y6 < O3[0] && (O3[0] = y6), m5 < O3[1] && (O3[1] = m5), x5 > O3[2] && (O3[2] = x5), k4 > O3[3] && (O3[3] = k4), e7 % A3 == 0 && (n3 = { start: e7, end: e7, rect: [r3, r3, -1 / 0, -1 / 0] }, R3.push(n3)), n3.end++;
                  const S5 = n3.rect;
                  if (y6 < S5[0] && (S5[0] = y6), m5 < S5[1] && (S5[1] = m5), x5 > S5[2] && (S5[2] = x5), k4 > S5[3] && (S5[3] = k4), d4[e7] = b5, h4[e7] = s5, M3) {
                    const t5 = 3 * e7;
                    F4[t5] = a3 >> 16 & 255, F4[t5 + 1] = a3 >> 8 & 255, F4[t5 + 2] = 255 & a3;
                  }
                }
              }
            }
          }), C4) {
            const e7 = i4.length - s4;
            e7 > 1 && l3(C4, s4, e7);
          }
        }
        const Z3 = [];
        z3.forEach(({ index: e6, src: t4, unitsPerEm: r4, ascender: n3, descender: a3, lineHeight: o4, capHeight: i5, xHeight: s4 }) => {
          Z3[e6] = { src: t4, unitsPerEm: r4, ascender: n3, descender: a3, lineHeight: o4, capHeight: i5, xHeight: s4 };
        }), L3.typesetting = c3() - V3, P3({ glyphIds: d4, glyphFontIndices: h4, glyphPositions: p4, glyphData: g4, fontData: Z3, caretPositions: C4, glyphColors: F4, chunkedBounds: R3, fontSize: v6, topBaseline: $2 + X3[0].baseline, blockBounds: [Y3, $2 - q3, Y3 + B3, $2], visibleBounds: O3, timings: L3 });
      });
    }
    function s3(e5) {
      let t4 = e5.match(/^([\d.]+)%$/), r4 = t4 ? parseFloat(t4[1]) : NaN;
      return isNaN(r4) ? 0 : r4 / 100;
    }
    function l3(e5, t4, r4) {
      const n3 = e5[4 * t4], a3 = e5[4 * t4 + 1], o4 = e5[4 * t4 + 2], i4 = e5[4 * t4 + 3], s4 = (a3 - n3) / r4;
      for (let a4 = 0; a4 < r4; a4++) {
        const r5 = 4 * (t4 + a4);
        e5[r5] = n3 + s4 * a4, e5[r5 + 1] = n3 + s4 * (a4 + 1), e5[r5 + 2] = o4, e5[r5 + 3] = i4;
      }
    }
    function c3() {
      return (self.performance || Date).now();
    }
    function u3() {
      this.data = [];
    }
    const f3 = ["glyphObj", "x", "width", "charIndex", "fontData"];
    return u3.prototype = { width: 0, lineHeight: 0, baseline: 0, cap: 0, ex: 0, isSoftWrapped: false, get count() {
      return Math.ceil(this.data.length / f3.length);
    }, glyphAt(e5) {
      let t4 = u3.flyweight;
      return t4.data = this.data, t4.index = e5, t4;
    }, splitAt(e5) {
      let t4 = new u3();
      return t4.data = this.data.splice(e5 * f3.length), t4;
    } }, u3.flyweight = f3.reduce((e5, t4, r4, n3) => (Object.defineProperty(e5, t4, { get() {
      return this.data[this.index * f3.length + r4];
    }, set(e6) {
      this.data[this.index * f3.length + r4] = e6;
    } }), e5), { data: null, index: 0 }), { typeset: i3, measure: function(e5, t4) {
      i3({ ...e5, metricsOnly: true }, (e6) => {
        const [r4, n3, a3, o4] = e6.blockBounds;
        t4({ width: a3 - r4, height: o4 - n3 });
      });
    } };
  }, C2, function() {
    return function(e4) {
      var t3 = { R: "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73", EN: "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9", ES: "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2", ET: "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj", AN: "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u", CS: "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b", B: "a,3,f+2,2v,690", S: "9,2,k", WS: "c,k,4f4,1vk+a,u,1j,335", ON: "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i", BN: "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1", NSM: "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n", AL: "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d", LRO: "6ct", RLO: "6cu", LRE: "6cq", RLE: "6cr", PDF: "6cs", LRI: "6ee", RLI: "6ef", FSI: "6eg", PDI: "6eh" }, r3 = {}, n2 = {};
      r3.L = 1, n2[1] = "L", Object.keys(t3).forEach(function(e5, t4) {
        r3[e5] = 1 << t4 + 1, n2[r3[e5]] = e5;
      }), Object.freeze(r3);
      var a2 = r3.LRI | r3.RLI | r3.FSI, o3 = r3.L | r3.R | r3.AL, i3 = r3.B | r3.S | r3.WS | r3.ON | r3.FSI | r3.LRI | r3.RLI | r3.PDI, s3 = r3.BN | r3.RLE | r3.LRE | r3.RLO | r3.LRO | r3.PDF, l3 = r3.S | r3.WS | r3.B | a2 | r3.PDI | s3, c3 = null;
      function u3(e5) {
        return function() {
          if (!c3) {
            c3 = /* @__PURE__ */ new Map();
            var e6 = function(e7) {
              if (t3.hasOwnProperty(e7)) {
                var n4 = 0;
                t3[e7].split(",").forEach(function(t4) {
                  var a3 = t4.split("+"), o4 = a3[0], i4 = a3[1];
                  o4 = parseInt(o4, 36), i4 = i4 ? parseInt(i4, 36) : 0, c3.set(n4 += o4, r3[e7]);
                  for (var s4 = 0; s4 < i4; s4++)
                    c3.set(++n4, r3[e7]);
                });
              }
            };
            for (var n3 in t3)
              e6(n3);
          }
        }(), c3.get(e5.codePointAt(0)) || r3.L;
      }
      var f3, d3, h3, v6 = { pairs: "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1", canonical: "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye" };
      function p3(e5, t4) {
        var r4, n3 = 0, a3 = /* @__PURE__ */ new Map(), o4 = t4 && /* @__PURE__ */ new Map();
        return e5.split(",").forEach(function e6(i4) {
          if (-1 !== i4.indexOf("+"))
            for (var s4 = +i4; s4--; )
              e6(r4);
          else {
            r4 = i4;
            var l4 = i4.split(">"), c4 = l4[0], u4 = l4[1];
            c4 = String.fromCodePoint(n3 += parseInt(c4, 36)), u4 = String.fromCodePoint(n3 += parseInt(u4, 36)), a3.set(c4, u4), t4 && o4.set(u4, c4);
          }
        }), { map: a3, reverseMap: o4 };
      }
      function g3() {
        if (!f3) {
          var e5 = p3(v6.pairs, true), t4 = e5.map, r4 = e5.reverseMap;
          f3 = t4, d3 = r4, h3 = p3(v6.canonical, false).map;
        }
      }
      function b3(e5) {
        return g3(), f3.get(e5) || null;
      }
      function y3(e5) {
        return g3(), d3.get(e5) || null;
      }
      function m3(e5) {
        return g3(), h3.get(e5) || null;
      }
      var x3, k3 = r3.L, w3 = r3.R, S3 = r3.EN, U3 = r3.ES, T3 = r3.ET, _3 = r3.AN, E4 = r3.CS, F3 = r3.B, C3 = r3.S, D3 = r3.ON, A3 = r3.BN, M3 = r3.NSM, P3 = r3.AL, I3 = r3.LRO, L3 = r3.RLO, O3 = r3.LRE, R3 = r3.RLE, B3 = r3.PDF, G3 = r3.LRI, N3 = r3.RLI, z3 = r3.FSI, V3 = r3.PDI;
      function j3(e5) {
        return function() {
          if (!x3) {
            var e6 = p3("14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1", true), t4 = e6.map;
            e6.reverseMap.forEach(function(e7, r4) {
              t4.set(r4, e7);
            }), x3 = t4;
          }
        }(), x3.get(e5) || null;
      }
      function W3(e5, t4, r4, n3) {
        var a3 = e5.length;
        r4 = Math.max(0, null == r4 ? 0 : +r4), n3 = Math.min(a3 - 1, null == n3 ? a3 - 1 : +n3);
        var o4 = [];
        return t4.paragraphs.forEach(function(a4) {
          var i4 = Math.max(r4, a4.start), s4 = Math.min(n3, a4.end);
          if (i4 < s4) {
            for (var c4 = t4.levels.slice(i4, s4 + 1), f4 = s4; f4 >= i4 && u3(e5[f4]) & l3; f4--)
              c4[f4] = a4.level;
            for (var d4 = a4.level, h4 = 1 / 0, v7 = 0; v7 < c4.length; v7++) {
              var p4 = c4[v7];
              p4 > d4 && (d4 = p4), p4 < h4 && (h4 = 1 | p4);
            }
            for (var g4 = d4; g4 >= h4; g4--)
              for (var b4 = 0; b4 < c4.length; b4++)
                if (c4[b4] >= g4) {
                  for (var y4 = b4; b4 + 1 < c4.length && c4[b4 + 1] >= g4; )
                    b4++;
                  b4 > y4 && o4.push([y4 + i4, b4 + i4]);
                }
          }
        }), o4;
      }
      function H2(e5, t4, r4, n3) {
        for (var a3 = W3(e5, t4, r4, n3), o4 = [], i4 = 0; i4 < e5.length; i4++)
          o4[i4] = i4;
        return a3.forEach(function(e6) {
          for (var t5 = e6[0], r5 = e6[1], n4 = o4.slice(t5, r5 + 1), a4 = n4.length; a4--; )
            o4[r5 - a4] = n4[a4];
        }), o4;
      }
      return e4.closingToOpeningBracket = y3, e4.getBidiCharType = u3, e4.getBidiCharTypeName = function(e5) {
        return n2[u3(e5)];
      }, e4.getCanonicalBracket = m3, e4.getEmbeddingLevels = function(e5, t4) {
        for (var r4 = new Uint32Array(e5.length), n3 = 0; n3 < e5.length; n3++)
          r4[n3] = u3(e5[n3]);
        var c4 = /* @__PURE__ */ new Map();
        function f4(e6, t5) {
          var n4 = r4[e6];
          r4[e6] = t5, c4.set(n4, c4.get(n4) - 1), n4 & i3 && c4.set(i3, c4.get(i3) - 1), c4.set(t5, (c4.get(t5) || 0) + 1), t5 & i3 && c4.set(i3, (c4.get(i3) || 0) + 1);
        }
        for (var d4 = new Uint8Array(e5.length), h4 = /* @__PURE__ */ new Map(), v7 = [], p4 = null, g4 = 0; g4 < e5.length; g4++)
          p4 || v7.push(p4 = { start: g4, end: e5.length - 1, level: "rtl" === t4 ? 1 : "ltr" === t4 ? 0 : zt(g4, false) }), r4[g4] & F3 && (p4.end = g4, p4 = null);
        for (var x4 = R3 | O3 | L3 | I3 | a2 | V3 | B3 | F3, j4 = function(e6) {
          return e6 + (1 & e6 ? 1 : 2);
        }, W4 = function(e6) {
          return e6 + (1 & e6 ? 2 : 1);
        }, H4 = 0; H4 < v7.length; H4++) {
          var X3 = [{ _level: (p4 = v7[H4]).level, _override: 0, _isolate: 0 }], q3 = void 0, Y3 = 0, $2 = 0, Z3 = 0;
          c4.clear();
          for (var K3 = p4.start; K3 <= p4.end; K3++) {
            var Q3 = r4[K3];
            if (q3 = X3[X3.length - 1], c4.set(Q3, (c4.get(Q3) || 0) + 1), Q3 & i3 && c4.set(i3, (c4.get(i3) || 0) + 1), Q3 & x4)
              if (Q3 & (R3 | O3)) {
                d4[K3] = q3._level;
                var J3 = (Q3 === R3 ? W4 : j4)(q3._level);
                J3 <= 125 && !Y3 && !$2 ? X3.push({ _level: J3, _override: 0, _isolate: 0 }) : Y3 || $2++;
              } else if (Q3 & (L3 | I3)) {
                d4[K3] = q3._level;
                var ee2 = (Q3 === L3 ? W4 : j4)(q3._level);
                ee2 <= 125 && !Y3 && !$2 ? X3.push({ _level: ee2, _override: Q3 & L3 ? w3 : k3, _isolate: 0 }) : Y3 || $2++;
              } else if (Q3 & a2) {
                Q3 & z3 && (Q3 = 1 === zt(K3 + 1, true) ? N3 : G3), d4[K3] = q3._level, q3._override && f4(K3, q3._override);
                var te2 = (Q3 === N3 ? W4 : j4)(q3._level);
                te2 <= 125 && 0 === Y3 && 0 === $2 ? (Z3++, X3.push({ _level: te2, _override: 0, _isolate: 1, _isolInitIndex: K3 })) : Y3++;
              } else if (Q3 & V3) {
                if (Y3 > 0)
                  Y3--;
                else if (Z3 > 0) {
                  for ($2 = 0; !X3[X3.length - 1]._isolate; )
                    X3.pop();
                  var re2 = X3[X3.length - 1]._isolInitIndex;
                  null != re2 && (h4.set(re2, K3), h4.set(K3, re2)), X3.pop(), Z3--;
                }
                q3 = X3[X3.length - 1], d4[K3] = q3._level, q3._override && f4(K3, q3._override);
              } else
                Q3 & B3 ? (0 === Y3 && ($2 > 0 ? $2-- : !q3._isolate && X3.length > 1 && (X3.pop(), q3 = X3[X3.length - 1])), d4[K3] = q3._level) : Q3 & F3 && (d4[K3] = p4.level);
            else
              d4[K3] = q3._level, q3._override && Q3 !== A3 && f4(K3, q3._override);
          }
          for (var ne2 = [], ae3 = null, oe2 = p4.start; oe2 <= p4.end; oe2++) {
            var ie2 = r4[oe2];
            if (!(ie2 & s3)) {
              var se2 = d4[oe2], le3 = ie2 & a2, ce3 = ie2 === V3;
              ae3 && se2 === ae3._level ? (ae3._end = oe2, ae3._endsWithIsolInit = le3) : ne2.push(ae3 = { _start: oe2, _end: oe2, _level: se2, _startsWithPDI: ce3, _endsWithIsolInit: le3 });
            }
          }
          for (var ue2 = [], fe2 = 0; fe2 < ne2.length; fe2++) {
            var de2 = ne2[fe2];
            if (!de2._startsWithPDI || de2._startsWithPDI && !h4.has(de2._start)) {
              for (var he2 = [ae3 = de2], ve2 = void 0; ae3 && ae3._endsWithIsolInit && null != (ve2 = h4.get(ae3._end)); )
                for (var pe2 = fe2 + 1; pe2 < ne2.length; pe2++)
                  if (ne2[pe2]._start === ve2) {
                    he2.push(ae3 = ne2[pe2]);
                    break;
                  }
              for (var ge3 = [], be3 = 0; be3 < he2.length; be3++)
                for (var ye2 = he2[be3], me2 = ye2._start; me2 <= ye2._end; me2++)
                  ge3.push(me2);
              for (var xe2 = d4[ge3[0]], ke2 = p4.level, we2 = ge3[0] - 1; we2 >= 0; we2--)
                if (!(r4[we2] & s3)) {
                  ke2 = d4[we2];
                  break;
                }
              var Se2 = ge3[ge3.length - 1], Ue2 = d4[Se2], Te2 = p4.level;
              if (!(r4[Se2] & a2)) {
                for (var _e3 = Se2 + 1; _e3 <= p4.end; _e3++)
                  if (!(r4[_e3] & s3)) {
                    Te2 = d4[_e3];
                    break;
                  }
              }
              ue2.push({ _seqIndices: ge3, _sosType: Math.max(ke2, xe2) % 2 ? w3 : k3, _eosType: Math.max(Te2, Ue2) % 2 ? w3 : k3 });
            }
          }
          for (var Ee2 = 0; Ee2 < ue2.length; Ee2++) {
            var Fe2 = ue2[Ee2], Ce2 = Fe2._seqIndices, De2 = Fe2._sosType, Ae2 = Fe2._eosType, Me2 = 1 & d4[Ce2[0]] ? w3 : k3;
            if (c4.get(M3))
              for (var Pe2 = 0; Pe2 < Ce2.length; Pe2++) {
                var Ie2 = Ce2[Pe2];
                if (r4[Ie2] & M3) {
                  for (var Le2 = De2, Oe2 = Pe2 - 1; Oe2 >= 0; Oe2--)
                    if (!(r4[Ce2[Oe2]] & s3)) {
                      Le2 = r4[Ce2[Oe2]];
                      break;
                    }
                  f4(Ie2, Le2 & (a2 | V3) ? D3 : Le2);
                }
              }
            if (c4.get(S3))
              for (var Re2 = 0; Re2 < Ce2.length; Re2++) {
                var Be2 = Ce2[Re2];
                if (r4[Be2] & S3)
                  for (var Ge2 = Re2 - 1; Ge2 >= -1; Ge2--) {
                    var Ne2 = -1 === Ge2 ? De2 : r4[Ce2[Ge2]];
                    if (Ne2 & o3) {
                      Ne2 === P3 && f4(Be2, _3);
                      break;
                    }
                  }
              }
            if (c4.get(P3))
              for (var ze2 = 0; ze2 < Ce2.length; ze2++) {
                var Ve2 = Ce2[ze2];
                r4[Ve2] & P3 && f4(Ve2, w3);
              }
            if (c4.get(U3) || c4.get(E4))
              for (var je2 = 1; je2 < Ce2.length - 1; je2++) {
                var We2 = Ce2[je2];
                if (r4[We2] & (U3 | E4)) {
                  for (var He2 = 0, Xe2 = 0, qe2 = je2 - 1; qe2 >= 0 && (He2 = r4[Ce2[qe2]]) & s3; qe2--)
                    ;
                  for (var Ye2 = je2 + 1; Ye2 < Ce2.length && (Xe2 = r4[Ce2[Ye2]]) & s3; Ye2++)
                    ;
                  He2 === Xe2 && (r4[We2] === U3 ? He2 === S3 : He2 & (S3 | _3)) && f4(We2, He2);
                }
              }
            if (c4.get(S3))
              for (var $e2 = 0; $e2 < Ce2.length; $e2++) {
                var Ze2 = Ce2[$e2];
                if (r4[Ze2] & S3) {
                  for (var Ke2 = $e2 - 1; Ke2 >= 0 && r4[Ce2[Ke2]] & (T3 | s3); Ke2--)
                    f4(Ce2[Ke2], S3);
                  for ($e2++; $e2 < Ce2.length && r4[Ce2[$e2]] & (T3 | s3 | S3); $e2++)
                    r4[Ce2[$e2]] !== S3 && f4(Ce2[$e2], S3);
                }
              }
            if (c4.get(T3) || c4.get(U3) || c4.get(E4))
              for (var Qe2 = 0; Qe2 < Ce2.length; Qe2++) {
                var Je2 = Ce2[Qe2];
                if (r4[Je2] & (T3 | U3 | E4)) {
                  f4(Je2, D3);
                  for (var et2 = Qe2 - 1; et2 >= 0 && r4[Ce2[et2]] & s3; et2--)
                    f4(Ce2[et2], D3);
                  for (var tt2 = Qe2 + 1; tt2 < Ce2.length && r4[Ce2[tt2]] & s3; tt2++)
                    f4(Ce2[tt2], D3);
                }
              }
            if (c4.get(S3))
              for (var rt2 = 0, nt2 = De2; rt2 < Ce2.length; rt2++) {
                var at3 = Ce2[rt2], ot2 = r4[at3];
                ot2 & S3 ? nt2 === k3 && f4(at3, k3) : ot2 & o3 && (nt2 = ot2);
              }
            if (c4.get(i3)) {
              for (var it2 = w3 | S3 | _3, st2 = it2 | k3, lt3 = [], ct2 = [], ut2 = 0; ut2 < Ce2.length; ut2++)
                if (r4[Ce2[ut2]] & i3) {
                  var ft2 = e5[Ce2[ut2]], dt2 = void 0;
                  if (null !== b3(ft2)) {
                    if (!(ct2.length < 63))
                      break;
                    ct2.push({ char: ft2, seqIndex: ut2 });
                  } else if (null !== (dt2 = y3(ft2)))
                    for (var ht2 = ct2.length - 1; ht2 >= 0; ht2--) {
                      var vt2 = ct2[ht2].char;
                      if (vt2 === dt2 || vt2 === y3(m3(ft2)) || b3(m3(vt2)) === ft2) {
                        lt3.push([ct2[ht2].seqIndex, ut2]), ct2.length = ht2;
                        break;
                      }
                    }
                }
              lt3.sort(function(e6, t5) {
                return e6[0] - t5[0];
              });
              for (var pt2 = 0; pt2 < lt3.length; pt2++) {
                for (var gt3 = lt3[pt2], bt2 = gt3[0], yt = gt3[1], mt = false, xt = 0, kt = bt2 + 1; kt < yt; kt++) {
                  var wt = Ce2[kt];
                  if (r4[wt] & st2) {
                    mt = true;
                    var St = r4[wt] & it2 ? w3 : k3;
                    if (St === Me2) {
                      xt = St;
                      break;
                    }
                  }
                }
                if (mt && !xt) {
                  xt = De2;
                  for (var Ut = bt2 - 1; Ut >= 0; Ut--) {
                    var Tt = Ce2[Ut];
                    if (r4[Tt] & st2) {
                      var _t = r4[Tt] & it2 ? w3 : k3;
                      xt = _t !== Me2 ? _t : Me2;
                      break;
                    }
                  }
                }
                if (xt) {
                  if (r4[Ce2[bt2]] = r4[Ce2[yt]] = xt, xt !== Me2) {
                    for (var Et = bt2 + 1; Et < Ce2.length; Et++)
                      if (!(r4[Ce2[Et]] & s3)) {
                        u3(e5[Ce2[Et]]) & M3 && (r4[Ce2[Et]] = xt);
                        break;
                      }
                  }
                  if (xt !== Me2) {
                    for (var Ft = yt + 1; Ft < Ce2.length; Ft++)
                      if (!(r4[Ce2[Ft]] & s3)) {
                        u3(e5[Ce2[Ft]]) & M3 && (r4[Ce2[Ft]] = xt);
                        break;
                      }
                  }
                }
              }
              for (var Ct = 0; Ct < Ce2.length; Ct++)
                if (r4[Ce2[Ct]] & i3) {
                  for (var Dt = Ct, At = Ct, Mt = De2, Pt = Ct - 1; Pt >= 0; Pt--) {
                    if (!(r4[Ce2[Pt]] & s3)) {
                      Mt = r4[Ce2[Pt]] & it2 ? w3 : k3;
                      break;
                    }
                    Dt = Pt;
                  }
                  for (var It = Ae2, Lt = Ct + 1; Lt < Ce2.length; Lt++) {
                    if (!(r4[Ce2[Lt]] & (i3 | s3))) {
                      It = r4[Ce2[Lt]] & it2 ? w3 : k3;
                      break;
                    }
                    At = Lt;
                  }
                  for (var Ot = Dt; Ot <= At; Ot++)
                    r4[Ce2[Ot]] = Mt === It ? Mt : Me2;
                  Ct = At;
                }
            }
          }
          for (var Rt = p4.start; Rt <= p4.end; Rt++) {
            var Bt = d4[Rt], Gt = r4[Rt];
            if (1 & Bt ? Gt & (k3 | S3 | _3) && d4[Rt]++ : Gt & w3 ? d4[Rt]++ : Gt & (_3 | S3) && (d4[Rt] += 2), Gt & s3 && (d4[Rt] = 0 === Rt ? p4.level : d4[Rt - 1]), Rt === p4.end || u3(e5[Rt]) & (C3 | F3))
              for (var Nt = Rt; Nt >= 0 && u3(e5[Nt]) & l3; Nt--)
                d4[Nt] = p4.level;
          }
        }
        return { levels: d4, paragraphs: v7 };
        function zt(t5, n4) {
          for (var o4 = t5; o4 < e5.length; o4++) {
            var i4 = r4[o4];
            if (i4 & (w3 | P3))
              return 1;
            if (i4 & (F3 | k3) || n4 && i4 === V3)
              return 0;
            if (i4 & a2) {
              var s4 = Vt(o4);
              o4 = -1 === s4 ? e5.length : s4;
            }
          }
          return 0;
        }
        function Vt(t5) {
          for (var n4 = 1, o4 = t5 + 1; o4 < e5.length; o4++) {
            var i4 = r4[o4];
            if (i4 & F3)
              break;
            if (i4 & V3) {
              if (0 == --n4)
                return o4;
            } else
              i4 & a2 && n4++;
          }
          return -1;
        }
      }, e4.getMirroredCharacter = j3, e4.getMirroredCharactersMap = function(e5, t4, r4, n3) {
        var a3 = e5.length;
        r4 = Math.max(0, null == r4 ? 0 : +r4), n3 = Math.min(a3 - 1, null == n3 ? a3 - 1 : +n3);
        for (var o4 = /* @__PURE__ */ new Map(), i4 = r4; i4 <= n3; i4++)
          if (1 & t4[i4]) {
            var s4 = j3(e5[i4]);
            null !== s4 && o4.set(i4, s4);
          }
        return o4;
      }, e4.getReorderSegments = W3, e4.getReorderedIndices = H2, e4.getReorderedString = function(e5, t4, r4, n3) {
        var a3 = H2(e5, t4, r4, n3), o4 = [].concat(e5);
        return a3.forEach(function(r5, n4) {
          o4[n4] = (1 & t4.levels[r5] ? j3(e5[r5]) : null) || e5[r5];
        }), o4.join("");
      }, e4.openingToClosingBracket = b3, Object.defineProperty(e4, "__esModule", { value: true }), e4;
    }({});
  }], init: (e4, t3, r3) => e4(t3, r3()) }), J2 = f2({ name: "Typesetter", dependencies: [Q2], init: (e4) => function(t3) {
    return new Promise((r3) => {
      e4.typeset(t3, r3);
    });
  }, getTransferables(e4) {
    const t3 = [];
    for (let r3 in e4)
      e4[r3] && e4[r3].buffer && t3.push(e4[r3].buffer);
    return t3;
  } }), ee = {}, te = "aTroikaGlyphIndex";
  class re extends e3.InstancedBufferGeometry {
    constructor() {
      super(), this.detail = 1, this.curveRadius = 0, this.groups = [{ start: 0, count: 1 / 0, materialIndex: 0 }, { start: 0, count: 1 / 0, materialIndex: 1 }], this.boundingSphere = new e3.Sphere(), this.boundingBox = new e3.Box3();
    }
    computeBoundingSphere() {
    }
    computeBoundingBox() {
    }
    setSide(t3) {
      const r3 = this.getIndex().count;
      this.setDrawRange(t3 === e3.BackSide ? r3 / 2 : 0, t3 === e3.DoubleSide ? r3 : r3 / 2);
    }
    set detail(t3) {
      if (t3 !== this._detail) {
        this._detail = t3, ("number" != typeof t3 || t3 < 1) && (t3 = 1);
        let r3 = function(t4) {
          let r4 = ee[t4];
          if (!r4) {
            const n2 = new e3.PlaneGeometry(1, 1, t4, t4), a2 = n2.clone(), o3 = n2.attributes, i3 = a2.attributes, s3 = new e3.BufferGeometry(), l3 = o3.uv.count;
            for (let e4 = 0; e4 < l3; e4++)
              i3.position.array[3 * e4] *= -1, i3.normal.array[3 * e4 + 2] *= -1;
            ["position", "normal", "uv"].forEach((t5) => {
              s3.setAttribute(t5, new e3.Float32BufferAttribute([...o3[t5].array, ...i3[t5].array], o3[t5].itemSize));
            }), s3.setIndex([...n2.index.array, ...a2.index.array.map((e4) => e4 + l3)]), s3.translate(0.5, 0.5, 0), r4 = ee[t4] = s3;
          }
          return r4;
        }(t3);
        ["position", "normal", "uv"].forEach((e4) => {
          this.attributes[e4] = r3.attributes[e4].clone();
        }), this.setIndex(r3.getIndex().clone());
      }
    }
    get detail() {
      return this._detail;
    }
    set curveRadius(e4) {
      e4 !== this._curveRadius && (this._curveRadius = e4, this._updateBounds());
    }
    get curveRadius() {
      return this._curveRadius;
    }
    updateGlyphs(e4, t3, r3, n2, a2) {
      ne(this, "aTroikaGlyphBounds", e4, 4), ne(this, te, t3, 1), ne(this, "aTroikaGlyphColor", a2, 3), this._blockBounds = r3, this._chunkedBounds = n2, this.instanceCount = t3.length, this._updateBounds();
    }
    _updateBounds() {
      const e4 = this._blockBounds;
      if (e4) {
        const { curveRadius: t3, boundingBox: r3 } = this;
        if (t3) {
          const { PI: n2, floor: a2, min: o3, max: i3, sin: s3, cos: l3 } = Math, c3 = n2 / 2, u3 = 2 * n2, f3 = Math.abs(t3), d3 = e4[0] / f3, h3 = e4[2] / f3, v6 = a2((d3 + c3) / u3) !== a2((h3 + c3) / u3) ? -f3 : o3(s3(d3) * f3, s3(h3) * f3), p3 = a2((d3 - c3) / u3) !== a2((h3 - c3) / u3) ? f3 : i3(s3(d3) * f3, s3(h3) * f3), g3 = a2((d3 + n2) / u3) !== a2((h3 + n2) / u3) ? 2 * f3 : i3(f3 - l3(d3) * f3, f3 - l3(h3) * f3);
          r3.min.set(v6, e4[1], t3 < 0 ? -g3 : 0), r3.max.set(p3, e4[3], t3 < 0 ? 0 : g3);
        } else
          r3.min.set(e4[0], e4[1], 0), r3.max.set(e4[2], e4[3], 0);
        r3.getBoundingSphere(this.boundingSphere);
      }
    }
    applyClipRect(e4) {
      let t3 = this.getAttribute(te).count, r3 = this._chunkedBounds;
      if (r3)
        for (let n2 = r3.length; n2--; ) {
          t3 = r3[n2].end;
          let a2 = r3[n2].rect;
          if (a2[1] < e4.w && a2[3] > e4.y && a2[0] < e4.z && a2[2] > e4.x)
            break;
        }
      this.instanceCount = t3;
    }
  }
  function ne(t3, r3, n2, a2) {
    const o3 = t3.getAttribute(r3);
    n2 ? o3 && o3.array.length === n2.length ? (o3.array.set(n2), o3.needsUpdate = true) : (t3.setAttribute(r3, new e3.InstancedBufferAttribute(n2, a2)), delete t3._maxInstanceCount, t3.dispose()) : o3 && t3.deleteAttribute(r3);
  }
  const ae2 = new e3.MeshBasicMaterial({ color: 16777215, side: e3.DoubleSide, transparent: true }), oe = 8421504, ie = new e3.Matrix4(), se = new e3.Vector3(), le2 = new e3.Vector3(), ce2 = [], ue = new e3.Vector3(), fe = "+x+y";
  function de(e4) {
    return Array.isArray(e4) ? e4[0] : e4;
  }
  let he = () => {
    const t3 = new e3.Mesh(new e3.PlaneGeometry(1, 1), ae2);
    return he = () => t3, t3;
  }, ve = () => {
    const t3 = new e3.Mesh(new e3.PlaneGeometry(1, 1, 32, 1), ae2);
    return ve = () => t3, t3;
  };
  const pe = { type: "syncstart" }, ge2 = { type: "synccomplete" }, be2 = ["font", "fontSize", "fontStyle", "fontWeight", "lang", "letterSpacing", "lineHeight", "maxWidth", "overflowWrap", "text", "direction", "textAlign", "textIndent", "whiteSpace", "anchorX", "anchorY", "colorRanges", "sdfGlyphSize"], ye = be2.concat("material", "color", "depthOffset", "clipRect", "curveRadius", "orientation", "glyphGeometryDetail");
  class me extends e3.Mesh {
    constructor() {
      super(new re(), null), this.text = "", this.anchorX = 0, this.anchorY = 0, this.curveRadius = 0, this.direction = "auto", this.font = null, this.unicodeFontsURL = null, this.fontSize = 0.1, this.fontWeight = "normal", this.fontStyle = "normal", this.lang = null, this.letterSpacing = 0, this.lineHeight = "normal", this.maxWidth = 1 / 0, this.overflowWrap = "normal", this.textAlign = "left", this.textIndent = 0, this.whiteSpace = "normal", this.material = null, this.color = null, this.colorRanges = null, this.outlineWidth = 0, this.outlineColor = 0, this.outlineOpacity = 1, this.outlineBlur = 0, this.outlineOffsetX = 0, this.outlineOffsetY = 0, this.strokeWidth = 0, this.strokeColor = oe, this.strokeOpacity = 1, this.fillOpacity = 1, this.depthOffset = 0, this.clipRect = null, this.orientation = fe, this.glyphGeometryDetail = 1, this.sdfGlyphSize = null, this.gpuAccelerateSDF = true, this.debugSDF = false;
    }
    sync(t3) {
      this._needsSync && (this._needsSync = false, this._isSyncing ? (this._queuedSyncs || (this._queuedSyncs = [])).push(t3) : (this._isSyncing = true, this.dispatchEvent(pe), function(t4, r3) {
        t4 = function(e4, t5) {
          for (let r4 in t5)
            t5.hasOwnProperty(r4) && (e4[r4] = t5[r4]);
          return e4;
        }({}, t4);
        const n2 = X2(), { defaultFontURL: a2 } = j2, o3 = [];
        if (a2 && o3.push({ label: "default", src: Z2(a2) }), t4.font && o3.push({ label: "user", src: Z2(t4.font) }), t4.font = o3, t4.text = "" + t4.text, t4.sdfGlyphSize = t4.sdfGlyphSize || j2.sdfGlyphSize, t4.unicodeFontsURL = t4.unicodeFontsURL || j2.unicodeFontsURL, null != t4.colorRanges) {
          let e4 = {};
          for (let r4 in t4.colorRanges)
            if (t4.colorRanges.hasOwnProperty(r4)) {
              let n3 = t4.colorRanges[r4];
              "number" != typeof n3 && (n3 = W2.set(n3).getHex()), e4[r4] = n3;
            }
          t4.colorRanges = e4;
        }
        Object.freeze(t4);
        const { textureWidth: i3, sdfExponent: s3 } = j2, { sdfGlyphSize: l3 } = t4, c3 = i3 / l3 * 4;
        let u3 = q2[l3];
        if (!u3) {
          const t5 = document.createElement("canvas");
          t5.width = i3, t5.height = 256 * l3 / c3, u3 = q2[l3] = { glyphCount: 0, sdfGlyphSize: l3, sdfCanvas: t5, sdfTexture: new e3.Texture(t5, void 0, void 0, void 0, e3.LinearFilter, e3.LinearFilter), contextLost: false, glyphsByFont: /* @__PURE__ */ new Map() }, u3.sdfTexture.generateMipmaps = false, function(e4) {
            const t6 = e4.sdfCanvas;
            t6.addEventListener("webglcontextlost", (t7) => {
              console.log("Context Lost", t7), t7.preventDefault(), e4.contextLost = true;
            }), t6.addEventListener("webglcontextrestored", (t7) => {
              console.log("Context Restored", t7), e4.contextLost = false;
              const r4 = [];
              e4.glyphsByFont.forEach((t8) => {
                t8.forEach((t9) => {
                  r4.push(Y2(t9, e4, true));
                });
              }), Promise.all(r4).then(() => {
                K2(e4), e4.sdfTexture.needsUpdate = true;
              });
            });
          }(u3);
        }
        const { sdfTexture: f3, sdfCanvas: d3 } = u3;
        J2(t4).then((e4) => {
          const { glyphIds: a3, glyphFontIndices: o4, fontData: h3, glyphPositions: v6, fontSize: p3, timings: g3 } = e4, b3 = [], y3 = new Float32Array(4 * a3.length);
          let m3 = 0, x3 = 0;
          const k3 = X2(), w3 = h3.map((e5) => {
            let t5 = u3.glyphsByFont.get(e5.src);
            return t5 || u3.glyphsByFont.set(e5.src, t5 = /* @__PURE__ */ new Map()), t5;
          });
          a3.forEach((t5, r4) => {
            const n3 = o4[r4], { src: i4, unitsPerEm: s4 } = h3[n3];
            let c4 = w3[n3].get(t5);
            if (!c4) {
              const { path: r5, pathBounds: a4 } = e4.glyphData[i4][t5], o5 = Math.max(a4[2] - a4[0], a4[3] - a4[1]) / l3 * (j2.sdfMargin * l3 + 0.5), s5 = u3.glyphCount++, f5 = [a4[0] - o5, a4[1] - o5, a4[2] + o5, a4[3] + o5];
              w3[n3].set(t5, c4 = { path: r5, atlasIndex: s5, sdfViewBox: f5 }), b3.push(c4);
            }
            const { sdfViewBox: f4 } = c4, d4 = v6[x3++], g4 = v6[x3++], k4 = p3 / s4;
            y3[m3++] = d4 + f4[0] * k4, y3[m3++] = g4 + f4[1] * k4, y3[m3++] = d4 + f4[2] * k4, y3[m3++] = g4 + f4[3] * k4, a3[r4] = c4.atlasIndex;
          }), g3.quads = (g3.quads || 0) + (X2() - k3);
          const S3 = X2();
          g3.sdf = {};
          const U3 = d3.height, T3 = Math.ceil(u3.glyphCount / c3), _3 = Math.pow(2, Math.ceil(Math.log2(T3 * l3)));
          _3 > U3 && (console.info(`Increasing SDF texture size ${U3}->${_3}`), V2(d3, i3, _3), f3.dispose()), Promise.all(b3.map((e5) => Y2(e5, u3, t4.gpuAccelerateSDF).then(({ timing: t5 }) => {
            g3.sdf[e5.atlasIndex] = t5;
          }))).then(() => {
            b3.length && !u3.contextLost && (K2(u3), f3.needsUpdate = true), g3.sdfTotal = X2() - S3, g3.total = X2() - n2, r3(Object.freeze({ parameters: t4, sdfTexture: f3, sdfGlyphSize: l3, sdfExponent: s3, glyphBounds: y3, glyphAtlasIndices: a3, glyphColors: e4.glyphColors, caretPositions: e4.caretPositions, chunkedBounds: e4.chunkedBounds, ascender: e4.ascender, descender: e4.descender, lineHeight: e4.lineHeight, capHeight: e4.capHeight, xHeight: e4.xHeight, topBaseline: e4.topBaseline, blockBounds: e4.blockBounds, visibleBounds: e4.visibleBounds, timings: e4.timings }));
          });
        }), Promise.resolve().then(() => {
          var e4;
          u3.contextLost || (e4 = d3)._warm || (A2.webgl.isSupported(e4), e4._warm = true);
        });
      }({ text: this.text, font: this.font, lang: this.lang, fontSize: this.fontSize || 0.1, fontWeight: this.fontWeight || "normal", fontStyle: this.fontStyle || "normal", letterSpacing: this.letterSpacing || 0, lineHeight: this.lineHeight || "normal", maxWidth: this.maxWidth, direction: this.direction || "auto", textAlign: this.textAlign, textIndent: this.textIndent, whiteSpace: this.whiteSpace, overflowWrap: this.overflowWrap, anchorX: this.anchorX, anchorY: this.anchorY, colorRanges: this.colorRanges, includeCaretPositions: true, sdfGlyphSize: this.sdfGlyphSize, gpuAccelerateSDF: this.gpuAccelerateSDF, unicodeFontsURL: this.unicodeFontsURL }, (e4) => {
        this._isSyncing = false, this._textRenderInfo = e4, this.geometry.updateGlyphs(e4.glyphBounds, e4.glyphAtlasIndices, e4.blockBounds, e4.chunkedBounds, e4.glyphColors);
        const r3 = this._queuedSyncs;
        r3 && (this._queuedSyncs = null, this._needsSync = true, this.sync(() => {
          r3.forEach((e5) => e5 && e5());
        })), this.dispatchEvent(ge2), t3 && t3();
      })));
    }
    onBeforeRender(t3, r3, n2, a2, o3, i3) {
      this.sync(), o3.isTroikaTextMaterial && this._prepareForRender(o3), o3._hadOwnSide = o3.hasOwnProperty("side"), this.geometry.setSide(o3._actualSide = o3.side), o3.side = e3.FrontSide;
    }
    onAfterRender(e4, t3, r3, n2, a2, o3) {
      a2._hadOwnSide ? a2.side = a2._actualSide : delete a2.side;
    }
    dispose() {
      this.geometry.dispose();
    }
    get textRenderInfo() {
      return this._textRenderInfo || null;
    }
    get material() {
      let t3 = this._derivedMaterial;
      const r3 = this._baseMaterial || this._defaultMaterial || (this._defaultMaterial = ae2.clone());
      if (t3 && t3.baseMaterial === r3 || (t3 = this._derivedMaterial = function(t4) {
        const r4 = S2(t4, { chained: true, extensions: { derivatives: true }, uniforms: { uTroikaSDFTexture: { value: null }, uTroikaSDFTextureSize: { value: new e3.Vector2() }, uTroikaSDFGlyphSize: { value: 0 }, uTroikaSDFExponent: { value: 0 }, uTroikaTotalBounds: { value: new e3.Vector4(0, 0, 0, 0) }, uTroikaClipRect: { value: new e3.Vector4(0, 0, 0, 0) }, uTroikaDistanceOffset: { value: 0 }, uTroikaOutlineOpacity: { value: 0 }, uTroikaFillOpacity: { value: 1 }, uTroikaPositionOffset: { value: new e3.Vector2() }, uTroikaCurveRadius: { value: 0 }, uTroikaBlurRadius: { value: 0 }, uTroikaStrokeWidth: { value: 0 }, uTroikaStrokeColor: { value: new e3.Color() }, uTroikaStrokeOpacity: { value: 1 }, uTroikaOrient: { value: new e3.Matrix3() }, uTroikaUseGlyphColors: { value: true }, uTroikaSDFDebug: { value: false } }, vertexDefs: "\nuniform vec2 uTroikaSDFTextureSize;\nuniform float uTroikaSDFGlyphSize;\nuniform vec4 uTroikaTotalBounds;\nuniform vec4 uTroikaClipRect;\nuniform mat3 uTroikaOrient;\nuniform bool uTroikaUseGlyphColors;\nuniform float uTroikaDistanceOffset;\nuniform float uTroikaBlurRadius;\nuniform vec2 uTroikaPositionOffset;\nuniform float uTroikaCurveRadius;\nattribute vec4 aTroikaGlyphBounds;\nattribute float aTroikaGlyphIndex;\nattribute vec3 aTroikaGlyphColor;\nvarying vec2 vTroikaGlyphUV;\nvarying vec4 vTroikaTextureUVBounds;\nvarying float vTroikaTextureChannel;\nvarying vec3 vTroikaGlyphColor;\nvarying vec2 vTroikaGlyphDimensions;\n", vertexTransform: "\nvec4 bounds = aTroikaGlyphBounds;\nbounds.xz += uTroikaPositionOffset.x;\nbounds.yw -= uTroikaPositionOffset.y;\n\nvec4 outlineBounds = vec4(\n  bounds.xy - uTroikaDistanceOffset - uTroikaBlurRadius,\n  bounds.zw + uTroikaDistanceOffset + uTroikaBlurRadius\n);\nvec4 clippedBounds = vec4(\n  clamp(outlineBounds.xy, uTroikaClipRect.xy, uTroikaClipRect.zw),\n  clamp(outlineBounds.zw, uTroikaClipRect.xy, uTroikaClipRect.zw)\n);\n\nvec2 clippedXY = (mix(clippedBounds.xy, clippedBounds.zw, position.xy) - bounds.xy) / (bounds.zw - bounds.xy);\n\nposition.xy = mix(bounds.xy, bounds.zw, clippedXY);\n\nuv = (position.xy - uTroikaTotalBounds.xy) / (uTroikaTotalBounds.zw - uTroikaTotalBounds.xy);\n\nfloat rad = uTroikaCurveRadius;\nif (rad != 0.0) {\n  float angle = position.x / rad;\n  position.xz = vec2(sin(angle) * rad, rad - cos(angle) * rad);\n  normal.xz = vec2(sin(angle), cos(angle));\n}\n  \nposition = uTroikaOrient * position;\nnormal = uTroikaOrient * normal;\n\nvTroikaGlyphUV = clippedXY.xy;\nvTroikaGlyphDimensions = vec2(bounds[2] - bounds[0], bounds[3] - bounds[1]);\n\n\nfloat txCols = uTroikaSDFTextureSize.x / uTroikaSDFGlyphSize;\nvec2 txUvPerSquare = uTroikaSDFGlyphSize / uTroikaSDFTextureSize;\nvec2 txStartUV = txUvPerSquare * vec2(\n  mod(floor(aTroikaGlyphIndex / 4.0), txCols),\n  floor(floor(aTroikaGlyphIndex / 4.0) / txCols)\n);\nvTroikaTextureUVBounds = vec4(txStartUV, vec2(txStartUV) + txUvPerSquare);\nvTroikaTextureChannel = mod(aTroikaGlyphIndex, 4.0);\n", fragmentDefs: "\nuniform sampler2D uTroikaSDFTexture;\nuniform vec2 uTroikaSDFTextureSize;\nuniform float uTroikaSDFGlyphSize;\nuniform float uTroikaSDFExponent;\nuniform float uTroikaDistanceOffset;\nuniform float uTroikaFillOpacity;\nuniform float uTroikaOutlineOpacity;\nuniform float uTroikaBlurRadius;\nuniform vec3 uTroikaStrokeColor;\nuniform float uTroikaStrokeWidth;\nuniform float uTroikaStrokeOpacity;\nuniform bool uTroikaSDFDebug;\nvarying vec2 vTroikaGlyphUV;\nvarying vec4 vTroikaTextureUVBounds;\nvarying float vTroikaTextureChannel;\nvarying vec2 vTroikaGlyphDimensions;\n\nfloat troikaSdfValueToSignedDistance(float alpha) {\n  // Inverse of exponential encoding in webgl-sdf-generator\n  \n  float maxDimension = max(vTroikaGlyphDimensions.x, vTroikaGlyphDimensions.y);\n  float absDist = (1.0 - pow(2.0 * (alpha > 0.5 ? 1.0 - alpha : alpha), 1.0 / uTroikaSDFExponent)) * maxDimension;\n  float signedDist = absDist * (alpha > 0.5 ? -1.0 : 1.0);\n  return signedDist;\n}\n\nfloat troikaGlyphUvToSdfValue(vec2 glyphUV) {\n  vec2 textureUV = mix(vTroikaTextureUVBounds.xy, vTroikaTextureUVBounds.zw, glyphUV);\n  vec4 rgba = texture2D(uTroikaSDFTexture, textureUV);\n  float ch = floor(vTroikaTextureChannel + 0.5); //NOTE: can't use round() in WebGL1\n  return ch == 0.0 ? rgba.r : ch == 1.0 ? rgba.g : ch == 2.0 ? rgba.b : rgba.a;\n}\n\nfloat troikaGlyphUvToDistance(vec2 uv) {\n  return troikaSdfValueToSignedDistance(troikaGlyphUvToSdfValue(uv));\n}\n\nfloat troikaGetAADist() {\n  \n  #if defined(GL_OES_standard_derivatives) || __VERSION__ >= 300\n  return length(fwidth(vTroikaGlyphUV * vTroikaGlyphDimensions)) * 0.5;\n  #else\n  return vTroikaGlyphDimensions.x / 64.0;\n  #endif\n}\n\nfloat troikaGetFragDistValue() {\n  vec2 clampedGlyphUV = clamp(vTroikaGlyphUV, 0.5 / uTroikaSDFGlyphSize, 1.0 - 0.5 / uTroikaSDFGlyphSize);\n  float distance = troikaGlyphUvToDistance(clampedGlyphUV);\n \n  // Extrapolate distance when outside bounds:\n  distance += clampedGlyphUV == vTroikaGlyphUV ? 0.0 : \n    length((vTroikaGlyphUV - clampedGlyphUV) * vTroikaGlyphDimensions);\n\n  \n\n  return distance;\n}\n\nfloat troikaGetEdgeAlpha(float distance, float distanceOffset, float aaDist) {\n  #if defined(IS_DEPTH_MATERIAL) || defined(IS_DISTANCE_MATERIAL)\n  float alpha = step(-distanceOffset, -distance);\n  #else\n\n  float alpha = smoothstep(\n    distanceOffset + aaDist,\n    distanceOffset - aaDist,\n    distance\n  );\n  #endif\n\n  return alpha;\n}\n", fragmentColorTransform: "\nfloat aaDist = troikaGetAADist();\nfloat fragDistance = troikaGetFragDistValue();\nfloat edgeAlpha = uTroikaSDFDebug ?\n  troikaGlyphUvToSdfValue(vTroikaGlyphUV) :\n  troikaGetEdgeAlpha(fragDistance, uTroikaDistanceOffset, max(aaDist, uTroikaBlurRadius));\n\n#if !defined(IS_DEPTH_MATERIAL) && !defined(IS_DISTANCE_MATERIAL)\nvec4 fillRGBA = gl_FragColor;\nfillRGBA.a *= uTroikaFillOpacity;\nvec4 strokeRGBA = uTroikaStrokeWidth == 0.0 ? fillRGBA : vec4(uTroikaStrokeColor, uTroikaStrokeOpacity);\nif (fillRGBA.a == 0.0) fillRGBA.rgb = strokeRGBA.rgb;\ngl_FragColor = mix(fillRGBA, strokeRGBA, smoothstep(\n  -uTroikaStrokeWidth - aaDist,\n  -uTroikaStrokeWidth + aaDist,\n  fragDistance\n));\ngl_FragColor.a *= edgeAlpha;\n#endif\n\nif (edgeAlpha == 0.0) {\n  discard;\n}\n", customRewriter({ vertexShader: e4, fragmentShader: t5 }) {
          let r5 = /\buniform\s+vec3\s+diffuse\b/;
          return r5.test(t5) && (t5 = t5.replace(r5, "varying vec3 vTroikaGlyphColor").replace(/\bdiffuse\b/g, "vTroikaGlyphColor"), r5.test(e4) || (e4 = e4.replace(p2, "uniform vec3 diffuse;\n$&\nvTroikaGlyphColor = uTroikaUseGlyphColors ? aTroikaGlyphColor / 255.0 : diffuse;\n"))), { vertexShader: e4, fragmentShader: t5 };
        } });
        return r4.transparent = true, Object.defineProperties(r4, { isTroikaTextMaterial: { value: true }, shadowSide: { get() {
          return this.side;
        }, set() {
        } } }), r4;
      }(r3), r3.addEventListener("dispose", function e4() {
        r3.removeEventListener("dispose", e4), t3.dispose();
      })), this.outlineWidth || this.outlineBlur || this.outlineOffsetX || this.outlineOffsetY) {
        let e4 = t3._outlineMtl;
        return e4 || (e4 = t3._outlineMtl = Object.create(t3, { id: { value: t3.id + 0.1 } }), e4.isTextOutlineMaterial = true, e4.depthWrite = false, e4.map = null, t3.addEventListener("dispose", function r4() {
          t3.removeEventListener("dispose", r4), e4.dispose();
        })), [e4, t3];
      }
      return t3;
    }
    set material(e4) {
      e4 && e4.isTroikaTextMaterial ? (this._derivedMaterial = e4, this._baseMaterial = e4.baseMaterial) : this._baseMaterial = e4;
    }
    get glyphGeometryDetail() {
      return this.geometry.detail;
    }
    set glyphGeometryDetail(e4) {
      this.geometry.detail = e4;
    }
    get curveRadius() {
      return this.geometry.curveRadius;
    }
    set curveRadius(e4) {
      this.geometry.curveRadius = e4;
    }
    get customDepthMaterial() {
      return de(this.material).getDepthMaterial();
    }
    get customDistanceMaterial() {
      return de(this.material).getDistanceMaterial();
    }
    _prepareForRender(t3) {
      const r3 = t3.isTextOutlineMaterial, n2 = t3.uniforms, a2 = this.textRenderInfo;
      if (a2) {
        const { sdfTexture: e4, blockBounds: t4 } = a2;
        n2.uTroikaSDFTexture.value = e4, n2.uTroikaSDFTextureSize.value.set(e4.image.width, e4.image.height), n2.uTroikaSDFGlyphSize.value = a2.sdfGlyphSize, n2.uTroikaSDFExponent.value = a2.sdfExponent, n2.uTroikaTotalBounds.value.fromArray(t4), n2.uTroikaUseGlyphColors.value = !r3 && !!a2.glyphColors;
        let o4, i4, s3, l3 = 0, c3 = 0, u3 = 0, f3 = 0, d3 = 0;
        if (r3) {
          let { outlineWidth: e5, outlineOffsetX: t5, outlineOffsetY: r4, outlineBlur: n3, outlineOpacity: a3 } = this;
          l3 = this._parsePercent(e5) || 0, c3 = Math.max(0, this._parsePercent(n3) || 0), o4 = a3, f3 = this._parsePercent(t5) || 0, d3 = this._parsePercent(r4) || 0;
        } else
          u3 = Math.max(0, this._parsePercent(this.strokeWidth) || 0), u3 && (s3 = this.strokeColor, n2.uTroikaStrokeColor.value.set(null == s3 ? oe : s3), i4 = this.strokeOpacity, null == i4 && (i4 = 1)), o4 = this.fillOpacity;
        n2.uTroikaDistanceOffset.value = l3, n2.uTroikaPositionOffset.value.set(f3, d3), n2.uTroikaBlurRadius.value = c3, n2.uTroikaStrokeWidth.value = u3, n2.uTroikaStrokeOpacity.value = i4, n2.uTroikaFillOpacity.value = null == o4 ? 1 : o4, n2.uTroikaCurveRadius.value = this.curveRadius || 0;
        let h3 = this.clipRect;
        if (h3 && Array.isArray(h3) && 4 === h3.length)
          n2.uTroikaClipRect.value.fromArray(h3);
        else {
          const e5 = 100 * (this.fontSize || 0.1);
          n2.uTroikaClipRect.value.set(t4[0] - e5, t4[1] - e5, t4[2] + e5, t4[3] + e5);
        }
        this.geometry.applyClipRect(n2.uTroikaClipRect.value);
      }
      n2.uTroikaSDFDebug.value = !!this.debugSDF, t3.polygonOffset = !!this.depthOffset, t3.polygonOffsetFactor = t3.polygonOffsetUnits = this.depthOffset || 0;
      const o3 = r3 ? this.outlineColor || 0 : this.color;
      if (null == o3)
        delete t3.color;
      else {
        const r4 = t3.hasOwnProperty("color") ? t3.color : t3.color = new e3.Color();
        o3 === r4._input && "object" != typeof o3 || r4.set(r4._input = o3);
      }
      let i3 = this.orientation || fe;
      if (i3 !== t3._orientation) {
        let e4 = n2.uTroikaOrient.value;
        i3 = i3.replace(/[^-+xyz]/g, "");
        let r4 = i3 !== fe && i3.match(/^([-+])([xyz])([-+])([xyz])$/);
        if (r4) {
          let [, t4, n3, a3, o4] = r4;
          se.set(0, 0, 0)[n3] = "-" === t4 ? 1 : -1, le2.set(0, 0, 0)[o4] = "-" === a3 ? -1 : 1, ie.lookAt(ue, se.cross(le2), le2), e4.setFromMatrix4(ie);
        } else
          e4.identity();
        t3._orientation = i3;
      }
    }
    _parsePercent(e4) {
      if ("string" == typeof e4) {
        let t3 = e4.match(/^(-?[\d.]+)%$/), r3 = t3 ? parseFloat(t3[1]) : NaN;
        e4 = (isNaN(r3) ? 0 : r3 / 100) * this.fontSize;
      }
      return e4;
    }
    localPositionToTextCoords(t3, r3 = new e3.Vector2()) {
      r3.copy(t3);
      const n2 = this.curveRadius;
      return n2 && (r3.x = Math.atan2(t3.x, Math.abs(n2) - Math.abs(t3.z)) * Math.abs(n2)), r3;
    }
    worldPositionToTextCoords(t3, r3 = new e3.Vector2()) {
      return se.copy(t3), this.localPositionToTextCoords(this.worldToLocal(se), r3);
    }
    raycast(e4, t3) {
      const { textRenderInfo: r3, curveRadius: n2 } = this;
      if (r3) {
        const a2 = r3.blockBounds, o3 = n2 ? ve() : he(), i3 = o3.geometry, { position: s3, uv: l3 } = i3.attributes;
        for (let e5 = 0; e5 < l3.count; e5++) {
          let t4 = a2[0] + l3.getX(e5) * (a2[2] - a2[0]);
          const r4 = a2[1] + l3.getY(e5) * (a2[3] - a2[1]);
          let o4 = 0;
          n2 && (o4 = n2 - Math.cos(t4 / n2) * n2, t4 = Math.sin(t4 / n2) * n2), s3.setXYZ(e5, t4, r4, o4);
        }
        i3.boundingSphere = this.geometry.boundingSphere, i3.boundingBox = this.geometry.boundingBox, o3.matrixWorld = this.matrixWorld, o3.material.side = this.material.side, ce2.length = 0, o3.raycast(e4, ce2);
        for (let e5 = 0; e5 < ce2.length; e5++)
          ce2[e5].object = this, t3.push(ce2[e5]);
      }
    }
    copy(e4) {
      const t3 = this.geometry;
      return super.copy(e4), this.geometry = t3, ye.forEach((t4) => {
        this[t4] = e4[t4];
      }), this;
    }
    clone() {
      return new this.constructor().copy(this);
    }
  }
  be2.forEach((e4) => {
    const t3 = "_private_" + e4;
    Object.defineProperty(me.prototype, e4, { get() {
      return this[t3];
    }, set(e5) {
      e5 !== this[t3] && (this[t3] = e5, this._needsSync = true);
    } });
  });
  const xe = { d: "°", c: "⌀", p: "±" }, ke = (e4, t3) => {
    e4 = e4.replace(/%%(.)/g, (e5, t4) => xe[t4] || t4);
    const r3 = t3 == null ? void 0 : t3.encoding;
    let n2, a2 = r3 instanceof TextDecoder ? r3 : void 0, o3 = "";
    const i3 = [], s3 = (e5) => {
      o3 && (i3.push(o3), o3 = ""), i3.push(e5);
    };
    for (let t4 = 0; t4 < e4.length; t4++)
      switch (n2 = e4[t4]) {
        default:
          o3 += n2;
          break;
        case "\\":
          switch (n2 = e4[++t4]) {
            default:
              o3 += n2;
              break;
            case "P":
              o3 += "\n";
              break;
            case "f":
            case "F": {
              let r4 = "";
              for (; n2 = e4[++t4]; ) {
                if (";" === n2) {
                  s3({ f: r4 });
                  break;
                }
                if ("|" === n2) {
                  const n3 = { f: r4 }, a3 = e4.indexOf(";", ++t4);
                  for (const r5 of e4.slice(t4, a3).split("|"))
                    n3[r5[0]] = +r5.slice(1);
                  t4 = a3, s3(n3);
                  break;
                }
                r4 += "\\" === n2 ? e4[++t4] : n2;
              }
              break;
            }
            case "S": {
              let r4, a3 = "", o4 = "";
              for (; n2 = e4[++t4]; ) {
                if (";" === n2) {
                  r4 && s3({ S: [a3, r4, o4] });
                  break;
                }
                "\\" === n2 ? r4 ? o4 += e4[++t4] : a3 += e4[++t4] : r4 ? o4 += n2 : "^" === n2 || "/" === n2 || "#" === n2 ? r4 = n2 : a3 += n2;
              }
              break;
            }
            case "H":
            case "W":
              const i4 = ++t4, [, l3, c3] = e4.slice(i4, t4 = e4.indexOf(";", t4)).match(/^(\d*(?:\.\d+)?)(\D*)$/);
              s3({ [n2]: [+l3, c3] });
              break;
            case "Q":
            case "A":
            case "C":
            case "T": {
              const r4 = ++t4;
              s3({ [n2]: +e4.slice(r4, t4 = e4.indexOf(";", t4)) });
              break;
            }
            case "L":
            case "O":
            case "K":
              s3({ [n2]: 1 });
              break;
            case "l":
            case "o":
            case "k":
              s3({ [n2.toUpperCase()]: 0 });
              break;
            case "U":
            case "u":
              "+" === e4[t4 + 1] ? (o3 += String.fromCodePoint(parseInt(e4.substr(t4 + 2, 4), 16)), t4 += 5) : o3 += n2;
              break;
            case "M":
            case "m":
              r3 ? "+" === e4[t4 + 1] && "1" === e4[t4 + 2] ? (o3 += (a2 = a2 || new TextDecoder(r3)).decode(new Uint8Array([parseInt(e4.substr(t4 + 3, 2), 16), parseInt(e4.substr(t4 + 5, 2), 16)])), t4 += 6) : o3 += n2 : o3 += "\\" + n2;
          }
          break;
        case "{": {
          let r4 = 1;
          const a3 = t4;
          for (; n2 = e4[++t4]; )
            if ("{" === n2)
              r4++;
            else if ("}" === n2) {
              if (0 == --r4) {
                s3(ke(e4.slice(a3 + 1, t4)));
                break;
              }
            } else
              "\\" === n2 && t4++;
          break;
        }
      }
    return o3 && i3.push(o3), i3;
  }, we = "function" == typeof atob, Se = "function" == typeof Buffer, Ue = "function" == typeof TextDecoder ? new TextDecoder() : void 0, Te = ((e4) => {
    let t3 = {};
    return e4.forEach((e5, r3) => t3[e5] = r3), t3;
  })(("function" == typeof TextEncoder && new TextEncoder(), Array.prototype.slice.call("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="))), _e2 = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, Ee = String.fromCharCode.bind(String), Fe = "function" == typeof Uint8Array.from ? Uint8Array.from.bind(Uint8Array) : (e4) => new Uint8Array(Array.prototype.slice.call(e4, 0)), Ce = (e4) => e4.replace(/[^A-Za-z0-9\+\/]/g, ""), De = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, Ae = (e4) => {
    switch (e4.length) {
      case 4:
        var t3 = ((7 & e4.charCodeAt(0)) << 18 | (63 & e4.charCodeAt(1)) << 12 | (63 & e4.charCodeAt(2)) << 6 | 63 & e4.charCodeAt(3)) - 65536;
        return Ee(55296 + (t3 >>> 10)) + Ee(56320 + (1023 & t3));
      case 3:
        return Ee((15 & e4.charCodeAt(0)) << 12 | (63 & e4.charCodeAt(1)) << 6 | 63 & e4.charCodeAt(2));
      default:
        return Ee((31 & e4.charCodeAt(0)) << 6 | 63 & e4.charCodeAt(1));
    }
  }, Me = we ? (e4) => atob(Ce(e4)) : Se ? (e4) => Buffer.from(e4, "base64").toString("binary") : (e4) => {
    if (e4 = e4.replace(/\s+/g, ""), !_e2.test(e4))
      throw new TypeError("malformed base64.");
    e4 += "==".slice(2 - (3 & e4.length));
    let t3, r3, n2, a2 = "";
    for (let o3 = 0; o3 < e4.length; )
      t3 = Te[e4.charAt(o3++)] << 18 | Te[e4.charAt(o3++)] << 12 | (r3 = Te[e4.charAt(o3++)]) << 6 | (n2 = Te[e4.charAt(o3++)]), a2 += 64 === r3 ? Ee(t3 >> 16 & 255) : 64 === n2 ? Ee(t3 >> 16 & 255, t3 >> 8 & 255) : Ee(t3 >> 16 & 255, t3 >> 8 & 255, 255 & t3);
    return a2;
  }, Pe = Se ? (e4) => Fe(Buffer.from(e4, "base64")) : (e4) => Fe(Me(e4).split("").map((e5) => e5.charCodeAt(0))), Ie = Se ? (e4) => Buffer.from(e4, "base64").toString("utf8") : Ue ? (e4) => Ue.decode(Pe(e4)) : (e4) => Me(e4).replace(De, Ae), Le = (e4) => Ie(Ce(e4.replace(/[-_]/g, (e5) => "-" == e5 ? "+" : "/")));
  class Oe {
    constructor(e4) {
      this._pointer = 0, this._eof = false, this._data = e4;
    }
    next() {
      if (!this.hasNext())
        throw this._eof ? new Error("Cannot call 'next' after EOF group has been read") : new Error("Unexpected end of input: EOF group not read before end of file. Ended on code " + this._data[this._pointer]);
      const e4 = { code: parseInt(this._data[this._pointer]) };
      return this._pointer++, e4.value = Re(e4.code, this._data[this._pointer].trim()), this._pointer++, 0 === e4.code && "EOF" === e4.value && (this._eof = true), this.lastReadGroup = e4, e4;
    }
    peek() {
      if (!this.hasNext())
        throw this._eof ? new Error("Cannot call 'next' after EOF group has been read") : new Error("Unexpected end of input: EOF group not read before end of file. Ended on code " + this._data[this._pointer]);
      const e4 = { code: parseInt(this._data[this._pointer]) };
      return e4.value = Re(e4.code, this._data[this._pointer + 1].trim()), e4;
    }
    rewind(e4 = 1) {
      this._pointer = this._pointer - 2 * e4;
    }
    hasNext() {
      return !(this._eof || this._pointer > this._data.length - 2);
    }
    isEOF() {
      return this._eof;
    }
  }
  function Re(e4, t3) {
    return e4 <= 9 ? t3 : e4 >= 10 && e4 <= 59 ? parseFloat(t3) : e4 >= 60 && e4 <= 99 ? parseInt(t3) : e4 >= 100 && e4 <= 109 ? t3 : e4 >= 110 && e4 <= 149 ? parseFloat(t3) : e4 >= 160 && e4 <= 179 ? parseInt(t3) : e4 >= 210 && e4 <= 239 ? parseFloat(t3) : e4 >= 270 && e4 <= 289 ? parseInt(t3) : e4 >= 290 && e4 <= 299 ? function(e5) {
      if ("0" === e5)
        return false;
      if ("1" === e5)
        return true;
      throw TypeError("String '" + e5 + "' cannot be cast to Boolean type");
    }(t3) : e4 >= 300 && e4 <= 369 ? t3 : e4 >= 370 && e4 <= 389 ? parseInt(t3) : e4 >= 390 && e4 <= 399 ? t3 : e4 >= 400 && e4 <= 409 ? parseInt(t3) : e4 >= 410 && e4 <= 419 ? t3 : e4 >= 420 && e4 <= 429 ? parseInt(t3) : e4 >= 430 && e4 <= 439 ? t3 : e4 >= 440 && e4 <= 459 ? parseInt(t3) : e4 >= 460 && e4 <= 469 ? parseFloat(t3) : e4 >= 470 && e4 <= 481 || 999 === e4 || e4 >= 1e3 && e4 <= 1009 ? t3 : e4 >= 1010 && e4 <= 1059 ? parseFloat(t3) : e4 >= 1060 && e4 <= 1071 ? parseInt(t3) : (console.log("WARNING: Group code does not have a defined type: %j", { code: e4, value: t3 }), t3);
  }
  const Be = [0, 16711680, 16776960, 65280, 65535, 255, 16711935, 16777215, 8421504, 12632256, 16711680, 16744319, 13369344, 13395558, 10027008, 10046540, 8323072, 8339263, 4980736, 4990502, 16727808, 16752511, 13382400, 13401958, 10036736, 10051404, 8331008, 8343359, 4985600, 4992806, 16744192, 16760703, 13395456, 13408614, 10046464, 10056268, 8339200, 8347455, 4990464, 4995366, 16760576, 16768895, 13408512, 13415014, 10056192, 10061132, 8347392, 8351551, 4995328, 4997670, 16776960, 16777087, 13421568, 13421670, 10000384, 10000460, 8355584, 8355647, 5000192, 5000230, 12582656, 14679935, 10079232, 11717734, 7510016, 8755276, 6258432, 7307071, 3755008, 4344870, 8388352, 12582783, 6736896, 10079334, 5019648, 7510092, 4161280, 6258495, 2509824, 3755046, 4194048, 10485631, 3394560, 8375398, 2529280, 6264908, 2064128, 5209919, 1264640, 3099686, 65280, 8388479, 52224, 6736998, 38912, 5019724, 32512, 4161343, 19456, 2509862, 65343, 8388511, 52275, 6737023, 38950, 5019743, 32543, 4161359, 19475, 2509871, 65407, 8388543, 52326, 6737049, 38988, 5019762, 32575, 4161375, 19494, 2509881, 65471, 8388575, 52377, 6737074, 39026, 5019781, 32607, 4161391, 19513, 2509890, 65535, 8388607, 52428, 6737100, 39064, 5019800, 32639, 4161407, 19532, 2509900, 49151, 8380415, 39372, 6730444, 29336, 5014936, 24447, 4157311, 14668, 2507340, 32767, 8372223, 26316, 6724044, 19608, 5010072, 16255, 4153215, 9804, 2505036, 16383, 8364031, 13260, 6717388, 9880, 5005208, 8063, 4149119, 4940, 2502476, 255, 8355839, 204, 6710988, 152, 5000344, 127, 4145023, 76, 2500172, 4129023, 10452991, 3342540, 8349388, 2490520, 6245528, 2031743, 5193599, 1245260, 3089996, 8323327, 12550143, 6684876, 10053324, 4980888, 7490712, 4128895, 6242175, 2490444, 3745356, 12517631, 14647295, 10027212, 11691724, 7471256, 8735896, 6226047, 7290751, 3735628, 4335180, 16711935, 16744447, 13369548, 13395660, 9961624, 9981080, 8323199, 8339327, 4980812, 4990540, 16711871, 16744415, 13369497, 13395634, 9961586, 9981061, 8323167, 8339311, 4980793, 4990530, 16711807, 16744383, 13369446, 13395609, 9961548, 9981042, 8323135, 8339295, 4980774, 4990521, 16711743, 16744351, 13369395, 13395583, 9961510, 9981023, 8323103, 8339279, 4980755, 4990511, 3355443, 5987163, 8684676, 11382189, 14079702, 16777215];
  function Ge(e4) {
    const t3 = {};
    e4.rewind();
    let r3 = e4.next(), n2 = r3.code;
    if (t3.x = r3.value, n2 += 10, r3 = e4.next(), r3.code != n2)
      throw new Error("Expected code for point value to be " + n2 + " but got " + r3.code + ".");
    return t3.y = r3.value, n2 += 10, r3 = e4.next(), r3.code != n2 ? (e4.rewind(), t3) : (t3.z = r3.value, t3);
  }
  function Ne(e4, t3, r3) {
    switch (t3.code) {
      case 0:
        e4.type = t3.value;
        break;
      case 5:
        e4.handle = t3.value;
        break;
      case 6:
        e4.lineType = t3.value;
        break;
      case 8:
        e4.layer = t3.value;
        break;
      case 48:
        e4.lineTypeScale = t3.value;
        break;
      case 60:
        e4.visible = 0 === t3.value;
        break;
      case 62:
        e4.colorIndex = t3.value, e4.color = (n2 = Math.abs(t3.value), Be[n2]);
        break;
      case 67:
        e4.inPaperSpace = 0 !== t3.value;
        break;
      case 100:
        break;
      case 101:
        for (; 0 != t3.code; )
          t3 = r3.next();
        r3.rewind();
        break;
      case 330:
        e4.ownerHandle = t3.value;
        break;
      case 347:
        e4.materialObjectHandle = t3.value;
        break;
      case 370:
        e4.lineweight = t3.value;
        break;
      case 420:
        e4.color = t3.value;
        break;
      case 1e3:
        e4.extendedData = e4.extendedData || {}, e4.extendedData.customStrings = e4.extendedData.customStrings || [], e4.extendedData.customStrings.push(t3.value);
        break;
      case 1001:
        e4.extendedData = e4.extendedData || {}, e4.extendedData.applicationName = t3.value;
        break;
      default:
        return false;
    }
    var n2;
    return true;
  }
  class ze {
    constructor() {
      this.ForEntityName = "3DFACE";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value, vertices: [] };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 70:
            r3.shape = 1 == (1 & t3.value), r3.hasContinuousLinetypePattern = 128 == (128 & t3.value);
            break;
          case 10:
            r3.vertices = Ve(e4, t3), t3 = e4.lastReadGroup;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  function Ve(e4, t3) {
    var r3 = [], n2 = false, a2 = false;
    for (let i3 = 0; i3 <= 4; i3++) {
      for (var o3 = {}; !e4.isEOF() && 0 !== t3.code && !a2; ) {
        switch (t3.code) {
          case 10:
          case 11:
          case 12:
          case 13:
            if (n2) {
              a2 = true;
              continue;
            }
            o3.x = t3.value, n2 = true;
            break;
          case 20:
          case 21:
          case 22:
          case 23:
            o3.y = t3.value;
            break;
          case 30:
          case 31:
          case 32:
          case 33:
            o3.z = t3.value;
            break;
          default:
            return r3;
        }
        t3 = e4.next();
      }
      r3.push(o3), n2 = false, a2 = false;
    }
    return e4.rewind(), r3;
  }
  class je {
    constructor() {
      this.ForEntityName = "ARC";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.center = Ge(e4);
            break;
          case 40:
            r3.radius = t3.value;
            break;
          case 50:
            r3.startAngle = Math.PI / 180 * t3.value;
            break;
          case 51:
            r3.endAngle = Math.PI / 180 * t3.value, r3.angleLength = r3.endAngle - r3.startAngle;
            break;
          case 210:
            r3.extrusionDirectionX = t3.value;
            break;
          case 220:
            r3.extrusionDirectionY = t3.value;
            break;
          case 230:
            r3.extrusionDirectionZ = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class We {
    constructor() {
      this.ForEntityName = "ATTDEF";
    }
    parseEntity(e4, t3) {
      var r3 = { type: t3.value, scale: 1, textStyle: "STANDARD" };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 1:
            r3.text = t3.value;
            break;
          case 2:
            r3.tag = t3.value;
            break;
          case 3:
            r3.prompt = t3.value;
            break;
          case 7:
            r3.textStyle = t3.value;
            break;
          case 10:
            r3.startPoint = Ge(e4);
            break;
          case 11:
            r3.endPoint = Ge(e4);
            break;
          case 39:
            r3.thickness = t3.value;
            break;
          case 40:
            r3.textHeight = t3.value;
            break;
          case 41:
            r3.scale = t3.value;
            break;
          case 50:
            r3.rotation = t3.value;
            break;
          case 51:
            r3.obliqueAngle = t3.value;
            break;
          case 70:
            r3.invisible = !!(1 & t3.value), r3.constant = !!(2 & t3.value), r3.verificationRequired = !!(4 & t3.value), r3.preset = !!(8 & t3.value);
            break;
          case 71:
            r3.backwards = !!(2 & t3.value), r3.mirrored = !!(4 & t3.value);
            break;
          case 72:
            r3.horizontalJustification = t3.value;
            break;
          case 73:
            r3.fieldLength = t3.value;
            break;
          case 74:
            r3.verticalJustification = t3.value;
            break;
          case 100:
            break;
          case 210:
            r3.extrusionDirectionX = t3.value;
            break;
          case 220:
            r3.extrusionDirectionY = t3.value;
            break;
          case 230:
            r3.extrusionDirectionZ = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class He {
    constructor() {
      this.ForEntityName = "CIRCLE";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.center = Ge(e4);
            break;
          case 40:
            r3.radius = t3.value;
            break;
          case 50:
            r3.startAngle = Math.PI / 180 * t3.value;
            break;
          case 51:
            const n2 = Math.PI / 180 * t3.value;
            n2 < r3.startAngle ? r3.angleLength = n2 + 2 * Math.PI - r3.startAngle : r3.angleLength = n2 - r3.startAngle, r3.endAngle = n2;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class Xe {
    constructor() {
      this.ForEntityName = "DIMENSION";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 2:
            r3.block = t3.value;
            break;
          case 10:
            r3.anchorPoint = Ge(e4);
            break;
          case 11:
            r3.middleOfText = Ge(e4);
            break;
          case 12:
            r3.insertionPoint = Ge(e4);
            break;
          case 13:
            r3.linearOrAngularPoint1 = Ge(e4);
            break;
          case 14:
            r3.linearOrAngularPoint2 = Ge(e4);
            break;
          case 15:
            r3.diameterOrRadiusPoint = Ge(e4);
            break;
          case 16:
            r3.arcPoint = Ge(e4);
            break;
          case 70:
            r3.dimensionType = t3.value;
            break;
          case 71:
            r3.attachmentPoint = t3.value;
            break;
          case 42:
            r3.actualMeasurement = t3.value;
            break;
          case 1:
            r3.text = t3.value;
            break;
          case 50:
            r3.angle = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class qe {
    constructor() {
      this.ForEntityName = "ELLIPSE";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.center = Ge(e4);
            break;
          case 11:
            r3.majorAxisEndPoint = Ge(e4);
            break;
          case 40:
            r3.axisRatio = t3.value;
            break;
          case 41:
            r3.startAngle = t3.value;
            break;
          case 42:
            r3.endAngle = t3.value;
            break;
          case 2:
            r3.name = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class Ye {
    constructor() {
      this.ForEntityName = "INSERT";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 2:
            r3.name = t3.value;
            break;
          case 41:
            r3.xScale = t3.value;
            break;
          case 42:
            r3.yScale = t3.value;
            break;
          case 43:
            r3.zScale = t3.value;
            break;
          case 10:
            r3.position = Ge(e4);
            break;
          case 50:
            r3.rotation = t3.value;
            break;
          case 70:
            r3.columnCount = t3.value;
            break;
          case 71:
            r3.rowCount = t3.value;
            break;
          case 44:
            r3.columnSpacing = t3.value;
            break;
          case 45:
            r3.rowSpacing = t3.value;
            break;
          case 210:
            r3.extrusionDirection = Ge(e4);
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class $e {
    constructor() {
      this.ForEntityName = "LINE";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value, vertices: [] };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.vertices.unshift(Ge(e4));
            break;
          case 11:
            r3.vertices.push(Ge(e4));
            break;
          case 210:
            r3.extrusionDirection = Ge(e4);
            break;
          case 100:
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class Ze {
    constructor() {
      this.ForEntityName = "LWPOLYLINE";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value, vertices: [] };
      let n2 = 0;
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 38:
            r3.elevation = t3.value;
            break;
          case 39:
            r3.depth = t3.value;
            break;
          case 70:
            r3.shape = 1 == (1 & t3.value), r3.hasContinuousLinetypePattern = 128 == (128 & t3.value);
            break;
          case 90:
            n2 = t3.value;
            break;
          case 10:
            r3.vertices = Ke(n2, e4);
            break;
          case 43:
            0 !== t3.value && (r3.width = t3.value);
            break;
          case 210:
            r3.extrusionDirectionX = t3.value;
            break;
          case 220:
            r3.extrusionDirectionY = t3.value;
            break;
          case 230:
            r3.extrusionDirectionZ = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  function Ke(e4, t3) {
    if (!e4 || e4 <= 0)
      throw Error("n must be greater than 0 verticies");
    const r3 = [];
    let n2 = false, a2 = false, o3 = t3.lastReadGroup;
    for (let i3 = 0; i3 < e4; i3++) {
      const e5 = {};
      for (; !t3.isEOF() && 0 !== o3.code && !a2; ) {
        switch (o3.code) {
          case 10:
            if (n2) {
              a2 = true;
              continue;
            }
            e5.x = o3.value, n2 = true;
            break;
          case 20:
            e5.y = o3.value;
            break;
          case 30:
            e5.z = o3.value;
            break;
          case 40:
            e5.startWidth = o3.value;
            break;
          case 41:
            e5.endWidth = o3.value;
            break;
          case 42:
            0 != o3.value && (e5.bulge = o3.value);
            break;
          default:
            return t3.rewind(), n2 && r3.push(e5), t3.rewind(), r3;
        }
        o3 = t3.next();
      }
      r3.push(e5), n2 = false, a2 = false;
    }
    return t3.rewind(), r3;
  }
  class Qe {
    constructor() {
      this.ForEntityName = "MTEXT";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 3:
          case 1:
            r3.text ? r3.text += t3.value : r3.text = t3.value;
            break;
          case 10:
            r3.position = Ge(e4);
            break;
          case 11:
            r3.directionVector = Ge(e4);
            break;
          case 40:
            r3.height = t3.value;
            break;
          case 41:
            r3.width = t3.value;
            break;
          case 50:
            r3.rotation = t3.value;
            break;
          case 71:
            r3.attachmentPoint = t3.value;
            break;
          case 72:
            r3.drawingDirection = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class Je {
    constructor() {
      this.ForEntityName = "POINT";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.position = Ge(e4);
            break;
          case 39:
            r3.thickness = t3.value;
            break;
          case 210:
            r3.extrusionDirection = Ge(e4);
            break;
          case 100:
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class et {
    constructor() {
      this.ForEntityName = "VERTEX";
    }
    parseEntity(e4, t3) {
      var r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.x = t3.value;
            break;
          case 20:
            r3.y = t3.value;
            break;
          case 30:
            r3.z = t3.value;
            break;
          case 40:
          case 41:
          case 50:
            break;
          case 42:
            0 != t3.value && (r3.bulge = t3.value);
            break;
          case 70:
            r3.curveFittingVertex = 0 != (1 & t3.value), r3.curveFitTangent = 0 != (2 & t3.value), r3.splineVertex = 0 != (8 & t3.value), r3.splineControlPoint = 0 != (16 & t3.value), r3.threeDPolylineVertex = 0 != (32 & t3.value), r3.threeDPolylineMesh = 0 != (64 & t3.value), r3.polyfaceMeshVertex = 0 != (128 & t3.value);
            break;
          case 71:
            r3.faceA = t3.value;
            break;
          case 72:
            r3.faceB = t3.value;
            break;
          case 73:
            r3.faceC = t3.value;
            break;
          case 74:
            r3.faceD = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class tt {
    constructor() {
      this.ForEntityName = "POLYLINE";
    }
    parseEntity(e4, t3) {
      var r3 = { type: t3.value, vertices: [] };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
          case 20:
          case 30:
          case 40:
          case 41:
          case 71:
          case 72:
          case 73:
          case 74:
          case 75:
            break;
          case 39:
            r3.thickness = t3.value;
            break;
          case 70:
            r3.shape = 0 != (1 & t3.value), r3.includesCurveFitVertices = 0 != (2 & t3.value), r3.includesSplineFitVertices = 0 != (4 & t3.value), r3.is3dPolyline = 0 != (8 & t3.value), r3.is3dPolygonMesh = 0 != (16 & t3.value), r3.is3dPolygonMeshClosed = 0 != (32 & t3.value), r3.isPolyfaceMesh = 0 != (64 & t3.value), r3.hasContinuousLinetypePattern = 0 != (128 & t3.value);
            break;
          case 210:
            r3.extrusionDirection = Ge(e4);
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3.vertices = function(e5, t4) {
        const r4 = new et(), n2 = [];
        for (; !e5.isEOF(); )
          if (0 === t4.code) {
            if ("VERTEX" === t4.value)
              n2.push(r4.parseEntity(e5, t4)), t4 = e5.lastReadGroup;
            else if ("SEQEND" === t4.value) {
              rt(e5, t4);
              break;
            }
          }
        return n2;
      }(e4, t3), r3;
    }
  }
  function rt(e4, t3) {
    const r3 = { type: t3.value };
    for (t3 = e4.next(); !e4.isEOF() && 0 != t3.code; )
      Ne(r3, t3, e4), t3 = e4.next();
    return r3;
  }
  class nt {
    constructor() {
      this.ForEntityName = "SOLID";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value, points: [] };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.points[0] = Ge(e4);
            break;
          case 11:
            r3.points[1] = Ge(e4);
            break;
          case 12:
            r3.points[2] = Ge(e4);
            break;
          case 13:
            r3.points[3] = Ge(e4);
            break;
          case 210:
            r3.extrusionDirection = Ge(e4);
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class at2 {
    constructor() {
      this.ForEntityName = "SPLINE";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.controlPoints || (r3.controlPoints = []), r3.controlPoints.push(Ge(e4));
            break;
          case 11:
            r3.fitPoints || (r3.fitPoints = []), r3.fitPoints.push(Ge(e4));
            break;
          case 12:
            r3.startTangent = Ge(e4);
            break;
          case 13:
            r3.endTangent = Ge(e4);
            break;
          case 40:
            r3.knotValues || (r3.knotValues = []), r3.knotValues.push(t3.value);
            break;
          case 70:
            0 != (1 & t3.value) && (r3.closed = true), 0 != (2 & t3.value) && (r3.periodic = true), 0 != (4 & t3.value) && (r3.rational = true), 0 != (8 & t3.value) && (r3.planar = true), 0 != (16 & t3.value) && (r3.planar = true, r3.linear = true);
            break;
          case 71:
            r3.degreeOfSplineCurve = t3.value;
            break;
          case 72:
            r3.numberOfKnots = t3.value;
            break;
          case 73:
            r3.numberOfControlPoints = t3.value;
            break;
          case 74:
            r3.numberOfFitPoints = t3.value;
            break;
          case 210:
            r3.normalVector = Ge(e4);
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  class ot {
    constructor() {
      this.ForEntityName = "TEXT";
    }
    parseEntity(e4, t3) {
      const r3 = { type: t3.value };
      for (t3 = e4.next(); !e4.isEOF() && 0 !== t3.code; ) {
        switch (t3.code) {
          case 10:
            r3.startPoint = Ge(e4);
            break;
          case 11:
            r3.endPoint = Ge(e4);
            break;
          case 40:
            r3.textHeight = t3.value;
            break;
          case 41:
            r3.xScale = t3.value;
            break;
          case 50:
            r3.rotation = t3.value;
            break;
          case 1:
            r3.text = t3.value;
            break;
          case 72:
            r3.halign = t3.value;
            break;
          case 73:
            r3.valign = t3.value;
            break;
          default:
            Ne(r3, t3, e4);
        }
        t3 = e4.next();
      }
      return r3;
    }
  }
  var it = n$2(43), st = n$2.n(it);
  function lt2(e4, t3, r3) {
    return e4.code === t3 && e4.value === r3;
  }
  function ct(e4) {
    st().debug("unhandled group " + ut(e4));
  }
  function ut(e4) {
    return e4.code + ":" + e4.value;
  }
  st().setLevel("error");
  const ft = class {
    constructor() {
      var e4;
      this._entityHandlers = {}, (e4 = this).registerEntityHandler(ze), e4.registerEntityHandler(je), e4.registerEntityHandler(We), e4.registerEntityHandler(He), e4.registerEntityHandler(Xe), e4.registerEntityHandler(qe), e4.registerEntityHandler(Ye), e4.registerEntityHandler($e), e4.registerEntityHandler(Ze), e4.registerEntityHandler(Qe), e4.registerEntityHandler(Je), e4.registerEntityHandler(tt), e4.registerEntityHandler(nt), e4.registerEntityHandler(at2), e4.registerEntityHandler(ot);
    }
    parse(e4) {
      return "string" == typeof e4 ? this._parse(e4) : (console.error("Cannot read dxf source of type `" + typeof e4), null);
    }
    registerEntityHandler(e4) {
      const t3 = new e4();
      this._entityHandlers[t3.ForEntityName] = t3;
    }
    parseSync(e4) {
      return this.parse(e4);
    }
    parseStream(e4) {
      let t3 = "";
      const r3 = this;
      return new Promise((n2, a2) => {
        e4.on("data", (e5) => {
          t3 += e5;
        }), e4.on("end", () => {
          try {
            n2(r3._parse(t3));
          } catch (e5) {
            a2(e5);
          }
        }), e4.on("error", (e5) => {
          a2(e5);
        });
      });
    }
    _parse(e4) {
      const t3 = {};
      let r3 = 0;
      const n2 = e4.split(/\r\n|\r|\n/g), a2 = new Oe(n2);
      if (!a2.hasNext())
        throw Error("Empty file");
      const o3 = this;
      let i3;
      function s3() {
        let e5 = null, t4 = null;
        const r4 = {};
        for (i3 = a2.next(); ; ) {
          if (lt2(i3, 0, "ENDSEC")) {
            e5 && (r4[e5] = t4);
            break;
          }
          9 === i3.code ? (e5 && (r4[e5] = t4), e5 = i3.value) : 10 === i3.code ? t4 = { x: i3.value } : 20 === i3.code ? t4.y = i3.value : 30 === i3.code ? t4.z = i3.value : t4 = i3.value, i3 = a2.next();
        }
        return i3 = a2.next(), r4;
      }
      function l3() {
        const e5 = {};
        for (i3 = a2.next(); "EOF" !== i3.value && !lt2(i3, 0, "ENDSEC"); )
          if (lt2(i3, 0, "BLOCK")) {
            st().debug("block {");
            const t4 = c3();
            st().debug("}"), g3(t4), t4.name ? e5[t4.name] = t4 : st().error('block with handle "' + t4.handle + '" is missing a name.');
          } else
            ct(i3), i3 = a2.next();
        return e5;
      }
      function c3() {
        const e5 = {};
        for (i3 = a2.next(); "EOF" !== i3.value; ) {
          switch (i3.code) {
            case 1:
              e5.xrefPath = i3.value, i3 = a2.next();
              break;
            case 2:
              e5.name = i3.value, i3 = a2.next();
              break;
            case 3:
              e5.name2 = i3.value, i3 = a2.next();
              break;
            case 5:
              e5.handle = i3.value, i3 = a2.next();
              break;
            case 8:
              e5.layer = i3.value, i3 = a2.next();
              break;
            case 10:
              e5.position = p3(i3), i3 = a2.next();
              break;
            case 67:
              e5.paperSpace = !(!i3.value || 1 != i3.value), i3 = a2.next();
              break;
            case 70:
              0 != i3.value && (e5.type = i3.value), i3 = a2.next();
              break;
            case 100:
              i3 = a2.next();
              break;
            case 330:
              e5.ownerHandle = i3.value, i3 = a2.next();
              break;
            case 0:
              if ("ENDBLK" == i3.value)
                break;
              e5.entities = v6(true);
              break;
            default:
              ct(i3), i3 = a2.next();
          }
          if (lt2(i3, 0, "ENDBLK")) {
            i3 = a2.next();
            break;
          }
        }
        return e5;
      }
      function u3() {
        const e5 = {};
        for (i3 = a2.next(); "EOF" !== i3.value && !lt2(i3, 0, "ENDSEC"); )
          lt2(i3, 0, "TABLE") ? (i3 = a2.next(), h3[i3.value] ? (st().debug(i3.value + " Table {"), e5[h3[i3.value].tableName] = d3(i3), st().debug("}")) : st().debug("Unhandled Table " + i3.value)) : i3 = a2.next();
        return i3 = a2.next(), e5;
      }
      const f3 = "ENDTAB";
      function d3(e5) {
        const t4 = h3[e5.value], r4 = {};
        let n3 = 0;
        for (i3 = a2.next(); !lt2(i3, 0, f3); )
          switch (i3.code) {
            case 5:
              r4.handle = i3.value, i3 = a2.next();
              break;
            case 330:
              r4.ownerHandle = i3.value, i3 = a2.next();
              break;
            case 100:
              "AcDbSymbolTable" === i3.value || ct(i3), i3 = a2.next();
              break;
            case 70:
              n3 = i3.value, i3 = a2.next();
              break;
            case 0:
              i3.value === t4.dxfSymbolName ? r4[t4.tableRecordsProperty] = t4.parseTableRecords() : (ct(i3), i3 = a2.next());
              break;
            default:
              ct(i3), i3 = a2.next();
          }
        const o4 = r4[t4.tableRecordsProperty];
        if (o4) {
          let e6 = o4.constructor === Array ? o4.length : "object" == typeof o4 ? Object.keys(o4).length : void 0;
          n3 !== e6 && st().warn("Parsed " + e6 + " " + t4.dxfSymbolName + "'s but expected " + n3);
        }
        return i3 = a2.next(), r4;
      }
      const h3 = { VPORT: { tableRecordsProperty: "viewPorts", tableName: "viewPort", dxfSymbolName: "VPORT", parseTableRecords: function() {
        const e5 = [];
        let t4 = {};
        for (st().debug("ViewPort {"), i3 = a2.next(); !lt2(i3, 0, f3); )
          switch (i3.code) {
            case 2:
              t4.name = i3.value, i3 = a2.next();
              break;
            case 10:
              t4.lowerLeftCorner = p3(i3), i3 = a2.next();
              break;
            case 11:
              t4.upperRightCorner = p3(i3), i3 = a2.next();
              break;
            case 12:
              t4.center = p3(i3), i3 = a2.next();
              break;
            case 13:
              t4.snapBasePoint = p3(i3), i3 = a2.next();
              break;
            case 14:
              t4.snapSpacing = p3(i3), i3 = a2.next();
              break;
            case 15:
              t4.gridSpacing = p3(i3), i3 = a2.next();
              break;
            case 16:
              t4.viewDirectionFromTarget = p3(i3), i3 = a2.next();
              break;
            case 17:
              t4.viewTarget = p3(i3), i3 = a2.next();
              break;
            case 42:
              t4.lensLength = i3.value, i3 = a2.next();
              break;
            case 43:
              t4.frontClippingPlane = i3.value, i3 = a2.next();
              break;
            case 44:
              t4.backClippingPlane = i3.value, i3 = a2.next();
              break;
            case 45:
              t4.viewHeight = i3.value, i3 = a2.next();
              break;
            case 50:
              t4.snapRotationAngle = i3.value, i3 = a2.next();
              break;
            case 51:
              t4.viewTwistAngle = i3.value, i3 = a2.next();
              break;
            case 79:
              t4.orthographicType = i3.value, i3 = a2.next();
              break;
            case 110:
            case 110:
              t4.ucsOrigin = p3(i3), i3 = a2.next();
              break;
            case 111:
              t4.ucsXAxis = p3(i3), i3 = a2.next();
              break;
            case 112:
              t4.ucsYAxis = p3(i3), i3 = a2.next();
              break;
            case 281:
              t4.renderMode = i3.value, i3 = a2.next();
              break;
            case 281:
              t4.defaultLightingType = i3.value, i3 = a2.next();
              break;
            case 292:
              t4.defaultLightingOn = i3.value, i3 = a2.next();
              break;
            case 330:
              t4.ownerHandle = i3.value, i3 = a2.next();
              break;
            case 63:
            case 421:
            case 431:
              t4.ambientColor = i3.value, i3 = a2.next();
              break;
            case 0:
              "VPORT" === i3.value && (st().debug("}"), e5.push(t4), st().debug("ViewPort {"), t4 = {}, i3 = a2.next());
              break;
            default:
              ct(i3), i3 = a2.next();
          }
        return st().debug("}"), e5.push(t4), e5;
      } }, LTYPE: { tableRecordsProperty: "lineTypes", tableName: "lineType", dxfSymbolName: "LTYPE", parseTableRecords: function() {
        const e5 = {};
        let t4, r4 = {}, n3 = 0;
        for (st().debug("LType {"), i3 = a2.next(); !lt2(i3, 0, "ENDTAB"); )
          switch (i3.code) {
            case 2:
              r4.name = i3.value, t4 = i3.value, i3 = a2.next();
              break;
            case 3:
              r4.description = i3.value, i3 = a2.next();
              break;
            case 73:
              n3 = i3.value, n3 > 0 && (r4.pattern = []), i3 = a2.next();
              break;
            case 40:
              r4.patternLength = i3.value, i3 = a2.next();
              break;
            case 49:
              r4.pattern.push(i3.value), i3 = a2.next();
              break;
            case 0:
              st().debug("}"), n3 > 0 && n3 !== r4.pattern.length && st().warn("lengths do not match on LTYPE pattern"), e5[t4] = r4, r4 = {}, st().debug("LType {"), i3 = a2.next();
              break;
            default:
              i3 = a2.next();
          }
        return st().debug("}"), e5[t4] = r4, e5;
      } }, LAYER: { tableRecordsProperty: "layers", tableName: "layer", dxfSymbolName: "LAYER", parseTableRecords: function() {
        const e5 = {};
        let t4, r4 = {};
        for (st().debug("Layer {"), i3 = a2.next(); !lt2(i3, 0, "ENDTAB"); )
          switch (i3.code) {
            case 2:
              r4.name = i3.value, t4 = i3.value, i3 = a2.next();
              break;
            case 62:
              r4.visible = i3.value >= 0, r4.colorIndex = Math.abs(i3.value), r4.color = (n3 = r4.colorIndex, Be[n3]), i3 = a2.next();
              break;
            case 70:
              r4.frozen = 0 != (1 & i3.value) || 0 != (2 & i3.value), i3 = a2.next();
              break;
            case 0:
              "LAYER" === i3.value && (st().debug("}"), e5[t4] = r4, st().debug("Layer {"), r4 = {}, t4 = void 0, i3 = a2.next());
              break;
            default:
              ct(i3), i3 = a2.next();
          }
        var n3;
        return st().debug("}"), e5[t4] = r4, e5;
      } } };
      function v6(e5) {
        const t4 = [], r4 = e5 ? "ENDBLK" : "ENDSEC";
        for (e5 || (i3 = a2.next()); ; )
          if (0 === i3.code) {
            if (i3.value === r4)
              break;
            const e6 = o3._entityHandlers[i3.value];
            if (null == e6) {
              st().warn("Unhandled entity " + i3.value), i3 = a2.next();
              continue;
            }
            {
              st().debug(i3.value + " {");
              const r5 = e6.parseEntity(a2, i3);
              i3 = a2.lastReadGroup, st().debug("}"), g3(r5), t4.push(r5);
            }
          } else
            i3 = a2.next();
        return "ENDSEC" == r4 && (i3 = a2.next()), t4;
      }
      function p3(e5) {
        const t4 = {};
        let r4 = e5.code;
        if (t4.x = e5.value, r4 += 10, (e5 = a2.next()).code != r4)
          throw new Error("Expected code for point value to be " + r4 + " but got " + e5.code + ".");
        return t4.y = e5.value, r4 += 10, (e5 = a2.next()).code != r4 ? (a2.rewind(), t4) : (t4.z = e5.value, t4);
      }
      function g3(e5) {
        if (!e5)
          throw new TypeError("entity cannot be undefined or null");
        e5.handle || (e5.handle = r3++);
      }
      return function() {
        for (i3 = a2.next(); !a2.isEOF(); )
          if (0 === i3.code && "SECTION" === i3.value) {
            if (i3 = a2.next(), 2 !== i3.code) {
              console.error("Unexpected code %s after 0:SECTION", ut(i3)), i3 = a2.next();
              continue;
            }
            "HEADER" === i3.value ? (st().debug("> HEADER"), t3.header = s3(), st().debug("<")) : "BLOCKS" === i3.value ? (st().debug("> BLOCKS"), t3.blocks = l3(), st().debug("<")) : "ENTITIES" === i3.value ? (st().debug("> ENTITIES"), t3.entities = v6(false), st().debug("<")) : "TABLES" === i3.value ? (st().debug("> TABLES"), t3.tables = u3(), st().debug("<")) : "EOF" === i3.value ? st().debug("EOF") : st().warn("Skipping section '%s'", i3.value);
          } else
            i3 = a2.next();
      }(), t3;
    }
  }, dt = (e4, t3, r3, n2, a2) => {
    const o3 = r3.length, i3 = r3[0].length;
    if (e4 < 0 || e4 > 1)
      throw new Error("t out of bounds [0,1]: " + e4);
    if (t3 < 1)
      throw new Error("degree must be at least 1 (linear)");
    if (t3 > o3 - 1)
      throw new Error("degree must be less than or equal to point count - 1");
    if (!a2) {
      a2 = [];
      for (let e5 = 0; e5 < o3; e5++)
        a2[e5] = 1;
    }
    if (n2) {
      if (n2.length !== o3 + t3 + 1)
        throw new Error("bad knot vector length");
    } else {
      n2 = [];
      for (let e5 = 0; e5 < o3 + t3 + 1; e5++)
        n2[e5] = e5;
    }
    const s3 = [t3, n2.length - 1 - t3], l3 = n2[s3[0]], c3 = n2[s3[1]];
    let u3;
    for (e4 = e4 * (c3 - l3) + l3, e4 = Math.max(e4, l3), e4 = Math.min(e4, c3), u3 = s3[0]; u3 < s3[1] && !(e4 >= n2[u3] && e4 <= n2[u3 + 1]); u3++)
      ;
    const f3 = [];
    for (let e5 = 0; e5 < o3; e5++) {
      f3[e5] = [];
      for (let t4 = 0; t4 < i3; t4++)
        f3[e5][t4] = r3[e5][t4] * a2[e5];
      f3[e5][i3] = a2[e5];
    }
    let d3;
    for (let r4 = 1; r4 <= t3 + 1; r4++)
      for (let a3 = u3; a3 > u3 - t3 - 1 + r4; a3--) {
        d3 = (e4 - n2[a3]) / (n2[a3 + t3 + 1 - r4] - n2[a3]);
        for (let e5 = 0; e5 < i3 + 1; e5++)
          f3[a3][e5] = (1 - d3) * f3[a3 - 1][e5] + d3 * f3[a3][e5];
      }
    const h3 = [];
    for (let e5 = 0; e5 < i3; e5++)
      h3[e5] = (v6 = f3[u3][e5] / f3[u3][i3], void 0 === (p3 = -9) || 0 == +p3 ? Math.round(v6) : (v6 = +v6, p3 = +p3, isNaN(v6) || "number" != typeof p3 || p3 % 1 != 0 ? NaN : (v6 = v6.toString().split("e"), +((v6 = (v6 = Math.round(+(v6[0] + "e" + (v6[1] ? +v6[1] - p3 : -p3)))).toString().split("e"))[0] + "e" + (v6[1] ? +v6[1] + p3 : p3)))));
    var v6, p3;
    return h3;
  };
  var ht = n$2(939);
  const vt = { Math: {} };
  function pt(t3, r3, n2, a2) {
    var o3, i3, s3, l3, c3, u3, f3, d3, h3;
    l3 = t3 ? new e3.Vector2(t3.x, t3.y) : new e3.Vector2(0, 0), c3 = r3 ? new e3.Vector2(r3.x, r3.y) : new e3.Vector2(1, 0), n2 = n2 || 1, u3 = 4 * Math.atan(n2), f3 = l3.distanceTo(c3) / 2 / Math.sin(u3 / 2), s3 = vt.Math.polar(t3, f3, vt.Math.angle2(l3, c3) + (Math.PI / 2 - u3 / 2)), a2 = a2 || Math.max(Math.abs(Math.ceil(u3 / (Math.PI / 18))), 6), d3 = vt.Math.angle2(s3, l3), h3 = u3 / a2;
    var p3 = [];
    for (p3.push(new e3.Vector3(l3.x, l3.y, 0)), i3 = 1; i3 <= a2 - 1; i3++)
      o3 = vt.Math.polar(s3, Math.abs(f3), d3 + h3 * i3), p3.push(new e3.Vector3(o3.x, o3.y, 0));
    return p3;
  }
  vt.Math.angle2 = function(t3, r3) {
    var n2 = new e3.Vector2(t3.x, t3.y), a2 = new e3.Vector2(r3.x, r3.y);
    return a2.sub(n2), a2.normalize(), a2.y < 0 ? -Math.acos(a2.x) : Math.acos(a2.x);
  }, vt.Math.polar = function(e4, t3, r3) {
    var n2 = {};
    return n2.x = e4.x + t3 * Math.cos(r3), n2.y = e4.y + t3 * Math.sin(r3), n2;
  };
  class gt2 extends e3.Loader {
    constructor(e4) {
      super(e4), this.font = null, this.enableLayer = false, this.defaultColor = 0, this.enableUnitConversion = false;
    }
    setFont(e4) {
      return this.font = e4, this;
    }
    setEnableLayer(e4) {
      return this.enableLayer = e4, this;
    }
    setDefaultColor(e4) {
      return this.defaultColor = e4, this;
    }
    setConsumeUnits(e4) {
      this.enableUnitConversion = !!e4;
    }
    load(t3, r3, n2, a2) {
      var o3, i3 = this;
      try {
        o3 = new e3.XHRLoader(i3.manager);
      } catch {
        o3 = new e3.FileLoader(i3.manager);
      }
      o3.setPath(i3.path);
      const s3 = function(e4) {
        if (e4) {
          const t4 = e4.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
          if (t4 && t4.length > 0) {
            const r4 = t4[1], n3 = e4.replace("data:" + r4 + ";", "").split(",");
            if (n3 && 2 === n3.length && "base64" === n3[0]) {
              const e5 = n3[1];
              return Le(e5);
            }
          }
        }
        return null;
      }(t3);
      s3 ? i3.loadString(s3, r3, a2) : o3.load(t3, (e4) => {
        i3.loadString(e4, r3, a2);
      }, n2, a2);
    }
    loadString(e4, t3, r3) {
      try {
        t3(this.parse(e4));
      } catch (e5) {
        r3 ? r3(e5) : console.error(e5), this.manager.itemError(e5);
      }
    }
    parse(e4) {
      var t3 = new ft().parseSync(e4);
      return this.loadEntities(t3, this);
    }
    loadEntities(t3, r3 = this) {
      var _a3, _b3;
      const { font: n2, enableLayer: a2, defaultColor: o3, enableUnitConversion: i3 } = r3 || {};
      function s3(t4, r4) {
        var a3;
        if ("CIRCLE" === t4.type || "ARC" === t4.type)
          a3 = function(t5, r5) {
            var n3, a4;
            "CIRCLE" === t5.type ? a4 = (n3 = t5.startAngle || 0) + 2 * Math.PI : (n3 = t5.startAngle, a4 = t5.endAngle);
            var o5 = new e3.ArcCurve(0, 0, t5.radius, n3, a4).getPoints(32), i4 = new e3.BufferGeometry().setFromPoints(o5), s4 = new e3.LineBasicMaterial({ color: u3(t5, r5) }), l4 = new e3.Line(i4, s4);
            return l4.position.x = t5.center.x, l4.position.y = t5.center.y, l4.position.z = t5.center.z, l4;
          }(t4, r4);
        else if ("LWPOLYLINE" === t4.type || "LINE" === t4.type || "POLYLINE" === t4.type)
          a3 = function(t5, r5) {
            let n3 = [], a4 = u3(t5, r5);
            var o5, i4, s4, l4, c4;
            if (!t5.vertices)
              return console.warn("entity missing vertices.");
            if (t5.isPolyfaceMesh)
              n3 = function(t6, r6, n4 = true) {
                const a5 = [], o6 = [], i5 = [];
                for (const r7 of t6.vertices)
                  if (r7.faceA || r7.faceB || r7.faceC || r7.faceD) {
                    const e4 = [r7.faceA, r7.faceB, r7.faceC, r7.faceD], t7 = { indices: [], hiddenEdges: [] };
                    for (const r8 of e4) {
                      if (0 == r8)
                        break;
                      t7.indices.push(r8 < 0 ? -r8 - 1 : r8 - 1), t7.hiddenEdges.push(r8 < 0);
                    }
                    3 != t7.indices.length && 4 != t7.indices.length || o6.push(t7);
                  } else
                    a5.push(new e3.Vector3(r7.x, r7.y, 0));
                const s5 = [], l5 = (e4, t7) => {
                  if (s5.length > 0) {
                    const r7 = s5[s5.length - 1];
                    if (r7.indices[r7.indices.length - 1] == e4)
                      return void r7.indices.push(t7);
                    r7.indices[0] == r7.indices[r7.indices.length - 1] && (r7.isClosed = true);
                  }
                  s5.push({ indices: [e4, t7], isClosed: false });
                };
                for (const e4 of o6)
                  if (n4)
                    for (let t7 = 0; t7 < e4.indices.length; t7++) {
                      if (e4.hiddenEdges[t7])
                        continue;
                      const r7 = t7 < e4.indices.length - 1 ? t7 + 1 : 0;
                      l5(e4.indices[t7], e4.indices[r7]);
                    }
                if (n4)
                  for (const e4 of s5)
                    for (const t7 of e4.indices)
                      i5.push(a5[t7]);
                return i5;
              }(t5);
            else {
              for (c4 = 0; c4 < t5.vertices.length; c4++)
                if (t5.vertices[c4].bulge) {
                  l4 = t5.vertices[c4].bulge;
                  let e4 = pt(t5.vertices[c4], c4 + 1 < t5.vertices.length ? t5.vertices[c4 + 1] : n3[0], l4);
                  n3.push.apply(n3, e4);
                } else
                  s4 = t5.vertices[c4], n3.push(new e3.Vector3(s4.x, s4.y, 0));
              t5.shape && n3.push(n3[0]);
            }
            t5.lineType && (i4 = r5.tables.lineType.lineTypes[t5.lineType]), o5 = i4 && i4.pattern && 0 !== i4.pattern.length ? new e3.LineDashedMaterial({ color: a4, gapSize: 4, dashSize: 4 }) : new e3.LineBasicMaterial({ linewidth: 1, color: a4 });
            var f4 = new e3.BufferGeometry().setFromPoints(n3);
            return new e3.Line(f4, o5);
          }(t4, r4);
        else if ("TEXT" === t4.type)
          a3 = function(t5, r5) {
            var a4, o5, i4;
            if (!n2)
              return console.warn("Text is not supported without a Three.js font loaded with THREE.FontLoader! Load a font of your choice and pass this into the constructor. See the sample for this repository or Three.js examples at http://threejs.org/examples/?q=text#webgl_geometry_text for more details.");
            if (!ht.Z.TextGeometry)
              return console.warn("Text is not supported without TextGeometry");
            if (a4 = new ht.Z.TextGeometry(t5.text, { font: n2, height: 0, size: t5.textHeight || 12 }), t5.rotation) {
              var s4 = t5.rotation * Math.PI / 180;
              a4.rotateZ(s4);
            }
            const l4 = u3(t5, r5);
            return o5 = new e3.MeshBasicMaterial({ color: l4 }), (i4 = new e3.Mesh(a4, o5)).position.x = t5.startPoint.x, i4.position.y = t5.startPoint.y, i4.position.z = t5.startPoint.z, i4.text = t5.text, i4.isText = true, i4.fontSize = t5.textHeight, i4.orientationZ = t5.rotation, i4.color = l4, i4;
          }(t4, r4);
        else if ("MTEXT" === t4.type)
          a3 = function(t5, r5) {
            var a4 = u3(t5, r5);
            if (!n2)
              return console.warn("font parameter not set. Ignoring text entity.");
            var o5 = l3(ke(t5.text), t5), i4 = function(t6, r6, a5, o6) {
              if (!t6)
                return null;
              let i5 = new me();
              if (i5.text = t6.replaceAll("\\P", "\n").replaceAll("\\X", "\n"), i5.isMText = true, i5.isText = true, i5.font = n2.fontUrl, i5.fontSize = r6.textHeight, i5.maxWidth = a5.width, i5.position.x = a5.position.x, i5.position.y = a5.position.y, i5.position.z = a5.position.z, i5.textAlign = r6.horizontalAlignment, i5.color = o6, a5.rotation && (i5.rotation.z = a5.rotation * Math.PI / 180), a5.directionVector) {
                var s5 = a5.directionVector;
                i5.rotation.z = new e3.Vector3(1, 0, 0).angleTo(new e3.Vector3(s5.x, s5.y, s5.z));
              }
              switch (i5.orientationZ = 180 * i5.rotation.z / Math.PI, a5.attachmentPoint) {
                case 1:
                  i5.anchorX = "left", i5.anchorY = "top";
                  break;
                case 2:
                  i5.anchorX = "center", i5.anchorY = "top";
                  break;
                case 3:
                  i5.anchorX = "right", i5.anchorY = "top";
                  break;
                case 4:
                  i5.anchorX = "left", i5.anchorY = "middle";
                  break;
                case 5:
                  i5.anchorX = "center", i5.anchorY = "middle";
                  break;
                case 6:
                  i5.anchorX = "right", i5.anchorY = "middle";
                  break;
                case 7:
                  i5.anchorX = "left", i5.anchorY = "bottom";
                  break;
                case 8:
                  i5.anchorX = "center", i5.anchorY = "bottom";
                  break;
                case 9:
                  i5.anchorX = "right", i5.anchorY = "bottom";
                  break;
                default:
                  return;
              }
              return i5.sync(() => {
                if ("left" !== i5.textAlign) {
                  i5.geometry.computeBoundingBox();
                  var e4 = i5.geometry.boundingBox.max.x - i5.geometry.boundingBox.min.x;
                  "center" === i5.textAlign && (i5.position.x += (a5.width - e4) / 2), "right" === i5.textAlign && (i5.position.x += a5.width - e4);
                }
              }), i5;
            }(o5.text, o5.style, t5, a4);
            if (!i4)
              return null;
            var s4 = new e3.Object3D();
            return s4.add(i4), s4;
          }(t4, r4);
        else if ("SOLID" === t4.type)
          a3 = function(t5, r5) {
            var n3, a4, o5 = new e3.BufferGeometry(), i4 = t5.points;
            return c3(a4 = [], i4[0], i4[1], i4[2]), c3(a4, i4[1], i4[2], i4[3]), n3 = new e3.MeshBasicMaterial({ color: u3(t5, r5) }), o5.setFromPoints(a4), new e3.Mesh(o5, n3);
          }(t4, r4);
        else if ("POINT" === t4.type)
          a3 = function(t5, r5) {
            var n3, a4;
            (n3 = new e3.BufferGeometry()).setAttribute("position", new e3.Float32BufferAttribute([t5.position.x, t5.position.y, t5.position.z], 3));
            var o5 = u3(t5, r5);
            return a4 = new e3.PointsMaterial({ size: 0.1, color: new e3.Color(o5) }), new e3.Points(n3, a4);
          }(t4, r4);
        else if ("INSERT" === t4.type)
          a3 = function(t5, r5) {
            var n3 = r5.blocks[t5.name];
            if (!n3.entities)
              return null;
            var a4 = new e3.Object3D();
            t5.xScale && (a4.scale.x = t5.xScale), t5.yScale && (a4.scale.y = t5.yScale), t5.rotation && (a4.rotation.z = t5.rotation * Math.PI / 180), t5.position && (a4.position.x = t5.position.x, a4.position.y = t5.position.y, a4.position.z = t5.position.z);
            for (var o5 = 0; o5 < n3.entities.length; o5++) {
              var i4 = s3(n3.entities[o5], r5);
              i4 && a4.add(i4);
            }
            return a4;
          }(t4, r4);
        else if ("SPLINE" === t4.type)
          a3 = function(t5, r5) {
            var n3 = u3(t5, r5), a4 = function(t6, r6, n4, a5, o6) {
              const i5 = [], s4 = t6.map(function(e4) {
                return [e4.x, e4.y];
              }), l4 = [n4[r6]], c4 = [n4[r6], n4[n4.length - 1 - r6]];
              for (let e4 = r6 + 1; e4 < n4.length - r6; ++e4)
                l4[l4.length - 1] !== n4[e4] && l4.push(n4[e4]);
              a5 = a5 || 25;
              for (let t7 = 1; t7 < l4.length; ++t7) {
                const o7 = l4[t7 - 1], u4 = l4[t7];
                for (let t8 = 0; t8 <= a5; ++t8) {
                  let l5 = (t8 / a5 * (u4 - o7) + o7 - c4[0]) / (c4[1] - c4[0]);
                  l5 = Math.max(l5, 0), l5 = Math.min(l5, 1);
                  const f4 = dt(l5, r6, s4, n4, void 0);
                  i5.push(new e3.Vector2(f4[0], f4[1]));
                }
              }
              return i5;
            }(t5.controlPoints, t5.degreeOfSplineCurve, t5.knotValues, 100), o5 = new e3.BufferGeometry().setFromPoints(a4), i4 = new e3.LineBasicMaterial({ linewidth: 1, color: n3 });
            return new e3.Line(o5, i4);
          }(t4, r4);
        else if ("ELLIPSE" === t4.type)
          a3 = function(t5, r5) {
            var n3 = u3(t5, r5), a4 = Math.sqrt(Math.pow(t5.majorAxisEndPoint.x, 2) + Math.pow(t5.majorAxisEndPoint.y, 2)), o5 = a4 * t5.axisRatio, i4 = Math.atan2(t5.majorAxisEndPoint.y, t5.majorAxisEndPoint.x), s4 = new e3.EllipseCurve(t5.center.x, t5.center.y, a4, o5, t5.startAngle, t5.endAngle, false, i4).getPoints(50), l4 = new e3.BufferGeometry().setFromPoints(s4), c4 = new e3.LineBasicMaterial({ linewidth: 1, color: n3 });
            return new e3.Line(l4, c4);
          }(t4, r4);
        else if ("DIMENSION" === t4.type) {
          var o4 = 7 & t4.dimensionType;
          0 === o4 ? a3 = function(t5, r5) {
            var n3 = r5.blocks[t5.block];
            if (!n3 || !n3.entities)
              return null;
            for (var a4 = new e3.Object3D(), o5 = 0; o5 < n3.entities.length; o5++) {
              var i4 = s3(n3.entities[o5], r5);
              i4 && a4.add(i4);
            }
            return a4;
          }(t4, r4) : console.warn("Unsupported Dimension type: " + o4);
        } else
          "3DFACE" === t4.type ? a3 = function(t5, r5) {
            let n3 = u3(t5, r5), a4 = 0 === n3 ? new e3.Color() : new e3.Color(`#${n3.toString(16)}`);
            const o5 = t5.layer || "default";
            -1 === Object.keys(r5.faceVertices).indexOf(o5) && (r5.faceVertices[o5] = [], r5.faceColors[o5] = []);
            for (let e4 = 0; e4 < 3; e4++)
              r5.faceVertices[o5].push(t5.vertices[e4].x, t5.vertices[e4].y, t5.vertices[e4].z), r5.faceColors[o5].push(a4.r, a4.g, a4.b);
            if (t5.vertices[3] && (t5.vertices[3].x !== t5.vertices[2].x || t5.vertices[3].y !== t5.vertices[2].y || t5.vertices[3].z !== t5.vertices[2].z))
              for (let e4 = 0; e4 < 4; e4++)
                1 !== e4 && (r5.faceVertices[o5].push(t5.vertices[e4].x, t5.vertices[e4].y, t5.vertices[e4].z), r5.faceColors[o5].push(a4.r, a4.g, a4.b));
            return null;
          }(t4, r4) : console.warn("Unsupported Entity Type: " + t4.type);
        return a3;
      }
      function l3(e4, t4, r4) {
        let n3 = { horizontalAlignment: "left", textHeight: t4.height };
        var a3 = [];
        for (let i4 of e4)
          if ("string" == typeof i4)
            i4.startsWith("pxq") && i4.endsWith(";") ? -1 !== i4.indexOf("c") ? n3.horizontalAlignment = "center" : -1 !== i4.indexOf("l") ? n3.horizontalAlignment = "left" : -1 !== i4.indexOf("r") ? n3.horizontalAlignment = "right" : -1 !== i4.indexOf("j") && (n3.horizontalAlignment = "justify") : a3.push(i4);
          else if (Array.isArray(i4)) {
            var o4 = l3(i4, t4);
            a3.push(o4.text);
          } else
            "object" == typeof i4 && i4.S && 3 === i4.S.length && a3.push(i4.S[0] + "/" + i4.S[2]);
        return { text: a3.join(), style: n3 };
      }
      function c3(t4, r4, n3, a3) {
        var o4 = new e3.Vector3(), i4 = new e3.Vector3();
        o4.subVectors(n3, r4), i4.subVectors(a3, r4), o4.cross(i4);
        var s4 = new e3.Vector3(r4.x, r4.y, r4.z), l4 = new e3.Vector3(n3.x, n3.y, n3.z), c4 = new e3.Vector3(a3.x, a3.y, a3.z);
        o4.z < 0 ? t4.push(c4, l4, s4) : t4.push(s4, l4, c4);
      }
      function u3(e4, t4) {
        var r4 = null;
        return e4.color ? r4 = e4.color : t4.tables && t4.tables.layer && t4.tables.layer.layers[e4.layer] && (r4 = t4.tables.layer.layers[e4.layer].color), null != r4 && 16777215 !== r4 || (r4 = t4.defaultColor), r4;
      }
      function f3(t4) {
        var r4, n3 = {}, a3 = 0;
        for (r4 = 0; r4 < t4.length; r4++)
          a3 += Math.abs(t4[r4]);
        return n3.uniforms = e3.UniformsUtils.merge([e3.UniformsLib.common, e3.UniformsLib.fog, { pattern: { type: "fv1", value: t4 }, patternLength: { type: "f", value: a3 } }]), n3.vertexShader = ["attribute float lineDistance;", "varying float vLineDistance;", e3.ShaderChunk.color_pars_vertex, "void main() {", e3.ShaderChunk.color_vertex, "vLineDistance = lineDistance;", "gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );", "}"].join("\n"), n3.fragmentShader = ["uniform vec3 diffuse;", "uniform float opacity;", "uniform float pattern[" + t4.length + "];", "uniform float patternLength;", "varying float vLineDistance;", e3.ShaderChunk.color_pars_fragment, e3.ShaderChunk.fog_pars_fragment, "void main() {", "float pos = mod(vLineDistance, patternLength);", "for ( int i = 0; i < " + t4.length + "; i++ ) {", "pos = pos - abs(pattern[i]);", "if( pos < 0.0 ) {", "if( pattern[i] > 0.0 ) {", "gl_FragColor = vec4(1.0, 0.0, 0.0, opacity );", "break;", "}", "discard;", "}", "}", e3.ShaderChunk.color_fragment, e3.ShaderChunk.fog_fragment, "}"].join("\n"), n3;
      }
      !function(e4) {
        var t4, r4;
        if (e4.tables && e4.tables.lineType) {
          var n3 = e4.tables.lineType.lineTypes;
          for (r4 in n3)
            (t4 = n3[r4]).pattern && (t4.material = f3(t4.pattern));
        }
      }(t3);
      var d3, h3, v6, p3 = [], g3 = {};
      for (t3.faceVertices = {}, t3.faceColors = {}, t3.defaultColor = o3, d3 = 0; d3 < t3.entities.length; d3++) {
        if ((v6 = s3(h3 = t3.entities[d3], t3)) && (p3.push(v6), a2 && h3.layer)) {
          let t4 = g3[h3.layer];
          t4 || (t4 = new e3.Group(), t4.name = h3.layer, g3[h3.layer] = t4), t4.add(v6);
        }
        v6 = null;
      }
      const b3 = Object.keys(t3.faceVertices);
      for (const r4 of b3) {
        const n3 = t3.faceVertices[r4], o4 = t3.faceColors[r4], i4 = new e3.BufferGeometry();
        i4.setAttribute("position", new e3.Float32BufferAttribute(n3, 3)), i4.setAttribute("color", new e3.Float32BufferAttribute(o4, 3)), i4.computeVertexNormals();
        const s4 = new e3.MeshLambertMaterial({ side: e3.DoubleSide, vertexColors: true, transparent: false }), l4 = new e3.Mesh(i4, s4);
        if (p3.push(l4), a2) {
          let t4 = g3[r4];
          t4 ? g3[r4].add(l4) : (t4 = new e3.Group(), t4.name = r4, t4.add(l4), g3[r4] = t4);
        }
      }
      delete t3.faceVertices, delete t3.faceColors, delete t3.defaultColor;
      const y3 = new e3.Group();
      if (a2 ? Object.values(g3).forEach((e4) => y3.add(e4)) : p3.forEach((e4) => y3.add(e4)), i3) {
        const e4 = (((_a3 = t3.header) == null ? void 0 : _a3.$DIMLFAC) || 1) * function(e5) {
          switch (e5) {
            case 0:
            case 6:
              return 1;
            case 1:
              return 0.0254;
            case 2:
              return 0.3048;
            case 3:
              return 1609.344;
            case 4:
              return 1e-3;
            case 5:
              return 0.01;
            case 7:
              return 1e3;
            case 8:
              return 254e-10;
            case 9:
              return 254e-7;
            case 10:
              return 0.9144;
            case 11:
              return 1e-10;
            case 12:
              return 1e-9;
            case 13:
              return 1e-6;
            case 14:
              return 0.1;
            case 15:
              return 10;
            case 16:
              return 100;
            case 17:
              return 1e9;
            case 18:
              return 149597870700;
            case 19:
              return 946073047808e4;
            case 20:
              return 308567758128e5;
          }
          return 1;
        }((_b3 = t3.header) == null ? void 0 : _b3.$INSUNITS);
        y3.scale.set(e4, e4, e4);
      }
      return { entity: y3, dxf: t3 };
    }
  }
})();
var o$1 = a$3.H;
class Object3dToGeoJson {
  static convert(threeObject, pointTransformer = (worldVec3) => [worldVec3.x, worldVec3.y], unit = "EPSG:9999", precision = 8) {
    if (!threeObject)
      return null;
    const transformPoint2 = (worldVec3) => {
      const [lng, lat] = pointTransformer(worldVec3);
      return [parseFloat(lng.toFixed(precision)), parseFloat(lat.toFixed(precision))];
    };
    const features = Object3dToGeoJson.extractFeatures(threeObject, transformPoint2);
    if (!(features == null ? void 0 : features.length))
      return null;
    return {
      type: "FeatureCollection",
      features,
      crs: {
        type: "name",
        properties: {
          name: unit
        }
      }
    };
  }
  static extractFeatures(threeGroupObject, transformPoint2) {
    if (!threeGroupObject)
      return null;
    const features = [];
    const func2 = (child) => {
      var _a3;
      if (!child)
        return;
      let childFeatures = [];
      if (child.isText) {
        childFeatures = Object3dToGeoJson.textToGeoJSON(child, transformPoint2);
      } else if (child.type === "Points") {
        childFeatures = Object3dToGeoJson.pointsToGeoJSON(child, transformPoint2);
      } else if (child.type === "Line") {
        childFeatures = Object3dToGeoJson.lineToGeoJSON(child, transformPoint2);
      } else if (child.type === "LineSegments") {
        childFeatures = Object3dToGeoJson.lineSegmentsToGeoJSON(child, transformPoint2);
      } else if (child.type === "Mesh") {
        childFeatures = Object3dToGeoJson.meshToGeoJSON(child, transformPoint2);
      } else {
        (_a3 = child == null ? void 0 : child.updateMatrix) == null ? void 0 : _a3.call(child);
        console.warn("Skipping unsupported type");
      }
      features.push(...childFeatures || []);
    };
    threeGroupObject.traverse(func2);
    return features;
  }
  static getCoordinateAt(i2, positions, matrix, transformPoint2) {
    const coord = [];
    const size12 = positions.itemSize;
    for (let j2 = 0; j2 < size12; j2 += 1) {
      coord.push(positions.array[i2 * size12 + j2]);
    }
    const vec = new Vector3$1(...coord).applyMatrix4(matrix);
    if (!transformPoint2)
      return vec;
    return transformPoint2(vec);
  }
  static textToGeoJSON(threeObject, transformPoint2) {
    var _a3, _b3;
    if (!(threeObject == null ? void 0 : threeObject.text))
      return [];
    threeObject == null ? void 0 : threeObject.updateMatrix();
    const matrix = threeObject.matrixWorld.clone();
    const positions = (_b3 = (_a3 = threeObject == null ? void 0 : threeObject.geometry) == null ? void 0 : _a3.attributes) == null ? void 0 : _b3.position;
    let coordinates2;
    if (positions == null ? void 0 : positions.count) {
      const box = new Box3();
      for (let i2 = 0; i2 < positions.count; i2 += 1) {
        const vec = Object3dToGeoJson.getCoordinateAt(i2, positions, matrix);
        box.expandByPoint(vec);
      }
      coordinates2 = transformPoint2(box.getCenter(new Vector3$1()));
    } else {
      coordinates2 = transformPoint2(threeObject.position.clone().applyMatrix4(matrix));
    }
    const colorProperties = Object3dToGeoJson.getProperties(threeObject, true, true) || {};
    const properties = {
      ...colorProperties
    };
    Object.keys(colorProperties).forEach((key) => {
      if (key === "fill" || key === "stroke") {
        properties["text-color"] = colorProperties[key];
      } else if (key === "fill-opacity" || key === "stroke-opacity") {
        properties["text-opacity"] = colorProperties[key];
      }
    });
    properties["text-value"] = threeObject.text;
    const features = [];
    features.push({
      type: "Feature",
      properties,
      geometry: {
        type: "Point",
        coordinates: coordinates2
      }
    });
    return features;
  }
  static pointsToGeoJSON(threeObject, transformPoint2) {
    if (!(threeObject instanceof Points)) {
      return [];
    }
    threeObject.updateMatrix();
    const positions = threeObject.geometry && threeObject.geometry.attributes ? threeObject.geometry.attributes.position : void 0;
    if (!positions) {
      return [];
    }
    const matrix = threeObject.matrixWorld.clone();
    const features = [];
    for (let i2 = 0; i2 < positions.count; i2 += 1) {
      const coordinates2 = Object3dToGeoJson.getCoordinateAt(i2, positions, matrix, transformPoint2);
      const colorProperties = Object3dToGeoJson.getProperties(threeObject, true);
      features.push({
        type: "Feature",
        properties: colorProperties,
        geometry: {
          type: "Point",
          coordinates: coordinates2
        }
      });
    }
    return features;
  }
  static lineToGeoJSON(threeObject, transformPoint2) {
    var _a3, _b3;
    threeObject == null ? void 0 : threeObject.updateMatrix();
    const positions = (_b3 = (_a3 = threeObject == null ? void 0 : threeObject.geometry) == null ? void 0 : _a3.attributes) == null ? void 0 : _b3.position;
    const colorProperties = Object3dToGeoJson.getProperties(threeObject, true);
    if (!positions || positions.count === 0) {
      return [];
    }
    const matrix = threeObject.matrixWorld.clone();
    const coordinates2 = [];
    for (let i2 = 0; i2 < positions.count; i2 += 1) {
      const coordinate2 = Object3dToGeoJson.getCoordinateAt(i2, positions, matrix, transformPoint2);
      coordinates2.push(coordinate2);
    }
    if (coordinates2.length === 0) {
      console.warn("No coordinates extracted from Line");
      return [];
    }
    return [{
      type: "Feature",
      properties: colorProperties,
      geometry: {
        type: "LineString",
        coordinates: coordinates2
      }
    }];
  }
  static lineSegmentsToGeoJSON(threeObject, transformPoint2) {
    var _a3, _b3;
    threeObject == null ? void 0 : threeObject.updateMatrix();
    const positions = (_b3 = (_a3 = threeObject == null ? void 0 : threeObject.geometry) == null ? void 0 : _a3.attributes) == null ? void 0 : _b3.position;
    const colorProperties = Object3dToGeoJson.getProperties(threeObject, true);
    if (!positions || positions.count === 0) {
      return [];
    }
    const matrix = threeObject.matrixWorld.clone();
    const features = [];
    for (let i2 = 0; i2 < positions.count; i2 += 2) {
      const start2 = Object3dToGeoJson.getCoordinateAt(i2, positions, matrix, transformPoint2);
      const end = Object3dToGeoJson.getCoordinateAt(i2 + 1, positions, matrix, transformPoint2);
      features.push({
        type: "Feature",
        properties: colorProperties,
        geometry: {
          type: "LineString",
          coordinates: [start2, end]
        }
      });
    }
    return features;
  }
  static meshToGeoJSON(threeObject, transformPoint2) {
    var _a3, _b3;
    threeObject == null ? void 0 : threeObject.updateMatrix();
    const positions = (_b3 = (_a3 = threeObject == null ? void 0 : threeObject.geometry) == null ? void 0 : _a3.attributes) == null ? void 0 : _b3.position;
    const colorProperties = Object3dToGeoJson.getProperties(threeObject, true, true);
    if (!positions)
      return [];
    const matrix = threeObject.matrixWorld.clone();
    const polygonCoordinates = [];
    for (let i2 = 0; i2 < positions.count; i2 += 1) {
      const coordinate2 = Object3dToGeoJson.getCoordinateAt(i2, positions, matrix, transformPoint2);
      polygonCoordinates.push(coordinate2);
    }
    if (polygonCoordinates.length > 2) {
      polygonCoordinates.push(polygonCoordinates[0]);
    }
    return [{
      type: "Feature",
      properties: colorProperties,
      geometry: {
        type: "Polygon",
        coordinates: [polygonCoordinates]
      }
    }];
  }
  static getProperties(threeObject, stroke = false, fill = false) {
    const properties = {};
    if (threeObject.material) {
      const colorHex = `#${threeObject.material.color.getHexString()}`;
      if (stroke)
        properties.stroke = colorHex;
      if (fill)
        properties.fill = colorHex;
      if (typeof threeObject.material.opacity !== "undefined") {
        if (stroke)
          properties["stroke-opacity"] = threeObject.material.opacity;
        if (fill)
          properties["fill-opacity"] = threeObject.material.opacity;
      }
    }
    return properties;
  }
}
const MERCATOR_A$1 = 6378137;
const MERCATOR_B = 63567523142e-4;
const WORLD_SIZE$2 = MERCATOR_A$1 * Math.PI * 2;
const Constants$t = {
  WORLD_SIZE: WORLD_SIZE$2,
  PROJECTION_WORLD_SIZE: WORLD_SIZE$2 / (MERCATOR_A$1 * Math.PI * 2),
  MERCATOR_A: MERCATOR_A$1,
  MERCATOR_B,
  DEG2RAD: Math.PI / 180,
  RAD2DEG: 180 / Math.PI,
  EARTH_CIRCUMFERENCE: 40075e3
  // In meters
};
const Constants$u = Constants$t;
class GeoreferenceUtil {
  static doGeoreferencing(scene, center2, scale5 = [1, 1, 1], orientation2 = {}, flipY2Z = false, recenterOnMass = true, debugBoxHelper = false, parent = {}) {
    if (!scene || !center2)
      return null;
    const {
      dip = 0,
      head = 0,
      azimuth = 0
    } = orientation2;
    let {
      anchor,
      content,
      world
    } = parent || {};
    if (!world) {
      world = new Group();
      world.name = "flatMercatorWorld";
    }
    if (!content) {
      content = new Group();
      content.name = "content";
      const position = GeoreferenceUtil.toThreePoint(center2);
      const finalMatrix = new Matrix4$1().makeScale(scale5[0], scale5[1], scale5[2]);
      const rotateX2 = new Matrix4$1().makeRotationAxis(new Vector3$1(1, 0, 0), dip * Math.PI / 180);
      const rotateY2 = new Matrix4$1().makeRotationAxis(new Vector3$1(0, 1, 0), head * Math.PI / 180);
      const rotateZ2 = new Matrix4$1().makeRotationAxis(new Vector3$1(0, 0, 1), azimuth * Math.PI / 180);
      finalMatrix.premultiply(rotateX2);
      finalMatrix.premultiply(rotateY2);
      finalMatrix.premultiply(rotateZ2);
      finalMatrix.premultiply(new Matrix4$1().makeTranslation(position.x, position.y, position.z));
      content.applyMatrix4(finalMatrix);
      world.add(content);
    }
    if (!anchor) {
      anchor = new Group();
      anchor.name = "anchor";
      const boundingBox = new Box3().setFromObject(scene);
      if (!(boundingBox == null ? void 0 : boundingBox.isEmpty())) {
        const boundingCenter = boundingBox.getCenter(new Vector3$1());
        if (recenterOnMass) {
          anchor.applyMatrix4(new Matrix4$1().makeTranslation(-boundingCenter.x, flipY2Z ? 0 : -boundingCenter.y, flipY2Z ? -boundingCenter.z : 0));
        }
        if (debugBoxHelper) {
          const helper = new Box3Helper(boundingBox, 16776960);
          anchor.add(helper);
        }
      }
      if (flipY2Z) {
        anchor.applyMatrix4(new Matrix4$1().makeRotationAxis(new Vector3$1(1, 0, 0), Math.PI / 2));
      }
      content.add(anchor);
    }
    anchor.add(scene);
    world.updateMatrixWorld();
    return {
      world,
      content,
      anchor
    };
  }
  static toThreePoint(geoPoint) {
    const deg2Rad = (angle4) => angle4 * Constants$u.DEG2RAD;
    const lng = geoPoint[0];
    let lat = geoPoint[1];
    if (lat > 89.5)
      lat = 89.5;
    if (lat < -89.5)
      lat = -89.5;
    const z2 = geoPoint[2] || 0;
    const x2 = Constants$u.MERCATOR_A * deg2Rad(lng);
    const y2 = Math.log(Math.tan(Math.PI / 4 + deg2Rad(lat) / 2)) * Constants$u.MERCATOR_A;
    const worldPosition = new Vector3$1(x2, y2, z2);
    return worldPosition;
  }
  static toGeoPoint(position) {
    const rad2Deg = (angle4) => angle4 * Constants$u.RAD2DEG;
    const {
      x: x2,
      y: y2,
      z: z2
    } = position || {};
    const lng = rad2Deg(x2 / Constants$u.MERCATOR_A);
    const lat = rad2Deg(2 * Math.atan(Math.exp(y2 / Constants$u.MERCATOR_A)) - Math.PI / 2);
    const geoPoint = [lng, lat, z2];
    return geoPoint;
  }
}
const MapPin = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAADT0lEQVR4nO2X3UsUURjGX4uCUrspqIuCNAW7CAqhIs/sWJa3WUT/QEnSdWaIsEFBUOiMVkJQF3UhhTflBxVIfmzknlmFJLsI6aI7Q8ywcs8R841zdlFbd2Z2Z7ezS8wDDwyz877n+c2ec2YGwJcvX77+G6EOO5BAPRJ4gRp8QgI/pWPH4txFrIHtkG/CU1CIGlxHAj9QA3TxPBIIYiVshXwQarAHCYynEDzRE6hBSW7DEyhFDb56CB8zgemcQeAxKEYNPnoOvwrxAXUoUg9A4FbG4bUViBtqw+uwCzVYcAj0HAnocnELV0E1atDjAPELj8BOdQAELjuEb3Koa3aAaFAHoMFLuzufQm2vTW2/mvSxEJ9tQuiutQE4blM7pRIg+fxPYTeJ715J1wGoEhKY8wxwGLbZAMyq/AdCSUNUQXUKtSdsAEJq0sdCtNiE6HGtJdBnU9ui8jmwGwks2SzG5rTBCSyJnsoAZJjY67Hdnt4rdxsdiqTFtLG/8yh6KQ0vATSozdqrhAa1ygHiEINZCB/KSXgJUAUkYwDi/vD7txBOc9s9fF9Ow0uAAJQjAeYBgKMOFZAPQg1u5v03gJPwKGyxfcFL7i/iOwFyqeAkbm4PL1YalNebFm991floeDlQ4BpeXPO68+GQqDEorxc9RC8loY1Rtt+grMmgLGRQtmhaHNd6oumSK8DEtYa/akyLY6wXGzHD7KoYI6uhg4gb2iLsnAidOHCi772dw7kzZbbhv9eV4P3QrGMPU5qNGBY7i4gFGYVvH4vuMy027D7gqp91D+NyYOP6qaNvwO6nAyn3MYUpH2yzoqWewneEoyWGxafTGjDuSPDKOoBIsDHtPqaEYDOt49GytAHknPQyoMXx7rt5nDl/YCW8OBbnvPYzKBvyArDgdUDhx/2TyE8W42JNIT7pfe+5jxlbEwtpAwjqzAblYruUzrSPYfE36QOMRvd6XQNZNWUzYjNJG2ANxEDuANiIOcrKIROJvdgIs7psTKmUpwxlQ+0Rdjrj50CiOsZYhWGxRglDGc9iYCb2fNFbjAEq9GAMN7Vb/JAZ5hcMyu+YlHXJpzXlU2LtGBb7ZlL2W1gcy/UkfpPXsC6T8tvx2oOil5LQvnz58gXZ1h8JC/UEAA50vAAAAABJRU5ErkJggg==";
const DarkMapbox = "data:image/png;base64,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";
const LightMapbox = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABLkAAAN9CAYAAAB/5avhAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAP+lSURBVHhe7P1pnxxHtt95BkHs+0qAZBVZdZe6i1pSSw973tN9DXp1M/NkutUt3UWqq6rLHfu+gyDHv275R1o6IiIjEplAAjg/fAzu4W7LscXN7Zw0M//k5s3bv872iMePH82ePXu28aso9hdHjhyZXbhwfnb8+PHx98uXL2dXr14b2uzT2S+/7NljURRFURRFURRF8c755JNPZhcvXhj1oU8//XTQgX6Z/fzzz+PxXUKuQ4cOjfqZcy4yOf766850tQMHDowOiUN80nLdtRcvXmyb/8SzjlzScJ+/RfGrA/aTu3fvzZ4/f75xtViXVsNzSAU/efJkaWUtgqHAA1IU+5V57bp1ep+0H0VRFEVRFEVRFB8o9KHHjx+PhhXnjCwxAr1LyMJFlhiQGL0c10U8Bw8efBVf4k987BaOjFbL8u9+X0YxWK0iVwx22yEedphi58ytwV9//WW0HGrsT58+Wcma2fPzzy+GcE/HiiyK/Uo6y55PP13cqRVFURRFURRFUXxIPH78ZNT7oxsx4KxijNlrYhQik/N17BGIwYpRKucQ1zQ+5/k9L/8JH4fEs51xKyR+cU3jR65ZUbRqnMV8tmj0qVwGLksNX7xoU+QePXK+ujWR/1RiUexX0t6DjkUnWBRFURRFURRF8THAoMKwkmWK+2U2F1li7JlnFFpEjEicfJjBBfaMzNiaR3RDYaIT9vHEiWNZPMtgFEt8U1wTJz/Fm7GldBm27t+/N05ZfBMOHz48Vl5R7GdaR7a1cyojV1EURVEURVEUHxP37t2b3b9//5WBhWFoP+jzMQqto6Pxb/8reWA0MkttlRlX/PT5B8NT9utyj6FsJ8atQP9cZuQyq+7hw4cbV4qdckBBP3hwf3bnzu2FlXbmzJlxk+5VOXr02OzUqZOvGkdR7FcszU1nBh1oGWiLoiiKoiiKoviYePbs+WhgMUuJTrQf9CK2CpBjO1kYidgsyC0PVqf1et4qtEkQbTbX0aNHx2tsJG9q3OohmzSmthL5c9394s048OjRw6WVP8/KuB0awJMntSdXsf/p1zzrWA4cqJlcRVEURVEURVF8XDCu9LOe9ssf/2N4Is8U8rme2VbbLUlcBWklvOObxDWPxEn2lC/Z+3SLN+PAdo0gRi5+slfXkyfLlzP6IuPPP6++CVtRvCt++WXrpoMHD9ZMrqIoiqIoiqIoPi7oRGZz2V+bjYAdgHvXulGMP+SIbcI541ZmQ/ETx+9O7BDijiGNoW8v8x8Zk540LFV8/vzZ+Lt4M1aYpmUTuhejgUuh56uL3CK0gz1oC0Wx6/SdYN9xFkVRFEVRFEVRfEwwElmR5QhGmL0w8qxLdLYYnmJ8ih4XA9dOiA7Y5zMr0vYy/7280mdfefGiliruBttq9GZkmZll9lbWonJ+ZyrjlOPHT4wNQmUVxX7GcsW+g6l95IqiKIqiKIqi+Bih29P5nz59Os7mYuDZT4YuulrsDHQ4Mi6ySSxDfjjxiC86oLgS517OZiNv5I8cWWpZvDkrWaFUwLThqAjWxt5A0HPy5KmhsRza+FUU+xPtt//C4n7owIuiKIqiKIqiKN4F9CNfWmR0QQw97xI6GmNUbxxaZIdYFfHZy0s88jo1lvmNGNX2Cnkjw7qGumIxO64tlf7s2dOhMhY3rhMnToxfWiyK/YoOZdpB1r5cRVEURVEURVF8jDC22Jvr5cumJ8XA9C4ww+rw4cPjkWHL1klvsvKGsUp8XMtnm7Qzz8DE3sHttZFP2U710eLN2HOTrE9vWr5YFPuReUYuX1gsI1dRFEVRFEVRFB8rd+7cGZctMgAx8ryJcWkdYlRjiALjVrZNAt2NPOvoazFuxaCUWVrbkeWDwu+VoU/ct2/feTVzrnhz3sjIZTnido3LfQ/Eu7L+FsUyzESczkbU0RRFURRFURRFUXystD2izGZquhJ9fi8nAsSQFGMaQ1QmJDBwxTE8rSKL++IUn2NmZnHiWcU+wR//4trt/IuLk4YZao7F7vCG2rwKaetXl3HgwCezI0eOlvGg2HfoTF6fybU3n4otiqIoiqIoiqJ4H6AnPX78eJzNldlTe63Px+jDsTFM9TTkfoxEU1yLrH18U4MZtssPfzGK8buKYWwdxJn4I1Px5rxRK826WFbeZultLhUVPvnkwLipm5lf2zWkonibtK8rbu1QPv202mhRFEVRFEVRFB83T548mT19+uSVscmsqHmGpd0gBiU2hnnGrR73Y8TqybV+1pU4p/aJpLWK0SqGMcxL800QH3vKdvkt1uONtflffnk5NP7Hs4cPH8wePHgwHB+OG9JrNCorjUIF2oh+rx6KotgJaaM9u915FUVRFEVRFEVRvG80Y1DbwypGob3Sk6QVY9J2kIUc0dviyMfR7xjL+JuHdPhZRe9rZbC5xHE7/6siHunfu3dv+LVavovV2PUpKyrfVwoePLg/VNjd0fjF+htWbbhF8TbQHqd7crXOa+NHURRFURRFURTFR4oli3fv3h2NRsgeV++ayBPDlo3lGaOWGbd66IH8rmK4YhCLYS17hu0GzXZiJlfZSHaTT/74x3+tEn0L5MHRIfQW4xj9PDTTGUVvQp9OS4Mxp6WzHQkXJzzZHCPvfoKMU5kRuSP7Ik6ePDG7dOnS2MHh0aPHs1u3bo1TR981fZ7kcREtf62Ot8vvdsxLK2W5jL4OQsq/KIqiKIqiKIr3k+PHj8/OnTs3O3To4GjkoSfRK99E59gNbIlEB1nVsDWPI0eOjFsvbaez0BWTHsPfm9DrW9999/14LHaPMnLtMVH6NeJYme35dOBAM6joGDgPJhejwE47jBgYPIA6IeklDVNNzbJb9gCTU9jIKT7+fWCAfInrXZN8bi3XT8ffuUdunV3KdVFHrNO+dOnimG9Ye37jxs19Y+RqLxN72i1eMy5b8iafLb+Mptsbpnr6tpOyROJdtl487ab9ZafFI5x246WxH9pMURRFURRFURTrQzcw1r948cLs6NGjW3TXdwkdJDoLeXZCZmbJy7z8RC/KkU5Jp34TEh896ccff9q4WuwWZeTaQxgNNGAPTjM4HRwfHHuYPXv+fPbrL21d75Ejh0dDi3umK6bD2IlhQJri1PlI29cwDnzaDBCW+jLgLOsAGFKOHj02njc5Xg6ynRgewJ8H2dqXNeY9/G8TeWz5lK/DY97I9Pz5s1flN3iYHTt6ZHbsWPLycsiDvzi8Lv/x48dmFy5cGK34YMy5du363M5LmTYjzuaMJcsdxbvbhpy0H3IdHfLy8NGj2c9DPcxLJ+3MNF3hlAG3joEp6SkzZavO0Tr+X4e283SMbx7at3YjLR+f8LEJsij3bFa52+VTFEVRFEVRFMXbgZ5w9uyZ2ZkzZ8ZzesF+mM1FFvov3WcnstCB6Dvy0uuJ4uTc58Tt/tTfTiCzOO7fb3uaF7vLp//wD//wXzbOi12kGQw8MG1GlYfi6dNnQ0O+P7t95/bs3t17s/sPHsweP36yYUz5dTQK5Mt+OzUKSNfDePjwoXEWzc1bt2Yvhwf+8DjL5tBogFj2UArL6MYId+fu3dGwoiNrhpzdXVK5E+QPzXB4eDh+OhryHg1y3r13d5D5zuzeUMaPHj56Va6ZmTSEHst0Wq7iYqBRT3BfZyO/PdJu6R4a6yqGy8S727Q2tPll0h9++GF2987dMa9x6ifu2VAOL3+xVnz2ytjF+LYqSU/9M/RZe68MPx3K+PBQ1l4c0zIJzTh6ZPbo8ePZnUFGfk8cPz6Wy05fOEVRFEVRFEVR7B/ohP4gTmdov9/9Kp/oMG8ii/DiEd45FyMX6MDRhd9UH4684rt37/47L78PkdY6i11H42WYYGzQbh8+fDT75ptvZt99/93YmJ+bVfTzi3GWy507d2Z//vO/jftADSFfGWXEsROEE/7e/Xuza9eujYYfM2q2e/DzwFlK+fjRo9nVqz/Nrl+/Pj7I24V9W7RybTOWlBPD4bfffjv77rvvxiWGT588HY16L4ayVa7fDtevXr06GsIYpYSZlqts9cYbZaccpqSzS/0IxyjJKOTeTutrGVn6x+ioLq8N9cFQ+vjJ49GZFfjk8ePxy6bXrl+bffvNt7MffvxpXCeujJQVuVYRjR/pyRsD2u3bt0dDV2Zvzat/YdJuzN56OMihvO8ObS5tZj+0m6IoiqIoiqIodo4xPd2LXkV3anrj3uhA60Au8kTv2QkxXIkjkxocXc/qmBi53pTIKK5eBy12jzJy7REeeEYVR58FZWy5dfv2aED4+quvZv/u7//d7N//+38/++u//qtxqZxlhN98+904g0bDX2Ro2Y4YHBiqnjxuSxMPftqWS7K8L7M3eN6SphlfwjJ6mBW2X4wVKRtOp/Bv33wzGn5+fvnz7Mrly7M//OEPs//wH/797O//7m9nn3/++ez5s+ezn65em92+fXfM+7zOr+Vts8Nyn5epPz+lq1wY0L7//vtx1pjZXDupq+1ocoj31yEfT8elimdOn559/fXXsz/89V/P/vZv/nZ0f/O3fzv7q7/8i9n58+dnT589Gw2TykQbIG/Lx9a8zCdLMIc6P3J0dn5olzbkP3b02NAJL5qK3Mqq7TFnD65nQ720r5S0NleGrqIoiqIoiqL4UPDH8OxdbMy/F3rQOuyWrtH0l2bcAl2TcWu3V6XEuLUbBrNiPu+2RX6ANMPE5mwjs2EYQx4/fjT7+uuvZv/5P/2nccM+nYFn5cSJk6PRgmPounrt2thpTI0xzj14vZt2KEnbdcYpM308PB5WS/v6faNEnVk7lppxzVjTNsCz1NHvkydP8f3KyME1WTancEaWXt6QdJpMm64Pm/DbkTJgdDMD7s9//vPs+lBev/nNl7P/7X/734bjb8bpszZcl9+Uq3Bms5kBlfQSn3TJOO24lEOfn+a3hVVPN2/eHA1dv4x7fDULPD99mJRv71bJZ0i5ke3Bg4fjUkQGUV82sYdbq9dD41JUS0r/+q/+avb551fGsHdu3xlneUkz+Zy6eXIpO/V/6uSJ2edXLs/Onz833G9r7rUl2UvY1macNyNf22Te0tjDQz1Yqii+1m5auGl7a+lO3RTyT9sb15d1URRFURRFURR7T9tuxz7Itklp4/t3DX2DvkI3mqdPLIJf+x9z8kHfsV2L2Wp0ctfWiW9VpGE/rmJv2P0aK1497AwG9t0yu4ax6IvPPx+NADoGhhIbuWvgLLkXL14cHy6GCTNhmkGgKfYe1rb5+NHRiGOj9GPHjo57ILnHTxR+R06nY+YPQxvnmodWB+BBtZTyyBFxtDg5aTCueaAt92OIOHGibYjfDBybxjthp7JkeVw6Av4ZQMTLD//SixOWE5YfM3+EWUSLr+2t9fjJ09nde/dmB4f8mxn36ZCmzmjc1H8o13RMZ8+enR0f0h07rOfPBtmaYabl49Aol7TbTKRNyCL/0pSf0Zg05M918T95+oQYYz5SLsk7GVNGyWfLeyujVTvfpP1yox3Jg/oAg1LL75Px6EVDoOPHjo9pQVsTB5ktqZzWgd+bsimHVn/ayNh+fm6b10srLzHGQ/kQJk75ybO2rN0cGvJo0/+0m5TfZrqbaUaOzWutHSDl2tp/X5bOU5Z7M4uuKIqiKIqiKIr52L/YpAN6Az2g6WjvFrJwdAhuEe7RH5q+Rg/c/GIiR3/BqvHtBHYCelaxN5R2uAd4UCjnpnIyQlDST548OR5ZmBmxPDz50p+Hh4J/6dLF2elTp0d/4mB4EQ+FnoLv4WrTJk2ZnI0PpXuMMfznAXQ+Lhsb4j46+PEAt4e0GRz8Zihg5ME4c2twnl3hn24Y3xiOThw/McjYDBxkESaGCPExgMgH40czVDWjW5M/X5aMIW42GqXEIT5pNkMMmZqhi//kZYpr4iGvPad0DGY1tfy1JZbKh0Gmle/LQdb25cRzZ88OZXF0CN/y0cru2HjOn47azKxsOJ9OL7LLn3P1yY8vDY4GoPGLjc2/+44tbAs/dI9jPvmRz1xPPhchr/w7/jKEZbwbrs4Ob8Qpf71LGPXsPplbmW8aivxmPI2c/JJN/bqnPLQzMmb5ZmavkVU49x0TVhkMSYz3lc34F5QxvRZHy7O6beHIM7a3589HWVJuSUM78LvN9to0RDbDl+WQrb2Rq9WPjzW0sEVRFEVRFEVR7D10AHpcPnJlPL4foHPRC+gcU1wjZ68b0aOaft70x6Yzb67wSXy7rWvQk6LDFbtPfV1xl/EAeGAYA27cuDFu3H1sOP/s0qVRKafcs9wGD5swlHjLvE6cODEq/gwans1Ph4fw5+Hhun/v/hiX/b3uP7g/GtB0LM3Ila8C6mDa8jFGIBuxnz51cnb6NMNZM+YwDjAamP1jA3yGnbvDkeHmuVllv7S0/D508NC4J5MwHnZxkJcxw9I/X9Ebv2Q4pPViyBfIng6D/DF28GcJHeObTdT9vjfkx4bp4nv5y8+DXMfH+NPBTJFPZShvlgvKw1e//c3s+PETrwxcgoljs1x1ZIcGP22GU/IgDYYjcsi/srVZut/kEU/r0JphiLFFerdu3Z7dHJzyH2Ua8qpzV9+t02z+dZZjnofyNQvrwVCe/trxyxBxX0bz8gkyyq/4Xrx4Pi5jde03X/5mI2zrgNPeyCf/t27fGstHfj+/cuWVH21I21Fn2uD49czbrT35KIIX1aEhjpND+1OfNrknn7JrM9oYoJqRT5jbQ13K3/hVx2dPR3ksCdVuGEbtDyZdpN2P6Q9+7t69N5THgyFcMxDawFI70DaOn2hfZNT+lZM8t7Z6r9XRUFfk49e9/gXFFUVRFEVRFEWxtxivN31l8w/iy3Sbtwm5ppAxLjoKeeki2+kR/ItzN/NGV6QDFXtDGbl2GQ9Bm4FyZPbjjz+Mxo3Tp0+N+3DBg+QhYYzanCXTjDJmuwjLoABHDxzDyrWrV0fjxWigePZ83FSeoYkBoc3yamGkL07Gldt37o7GBrPIpCcuhgowYtignHyxXjP6iL8ZLp6NRqHPPvtsw1DSZhY9evR4dmNjPyoPpi8ZMkKIx4wjhgnypKOIccgX9xjdxGsWFGOJ5YO+4mi/KfuHnTp5agwby3bfkbROtFndGUQYEM1U+/3vfjfey18R5L8ZpprFndzCxLAkTkZAZXf9ejNCkuXnoQwstRO3ZZC/Dv/sdWVWE6TNgDPO9hpkVl7ibbOefp2dOXN69MM4I7/2Yrtx4/q4VPXF8xct30P9uSccY6Y8ppympB2pN2GUnbSuXLk85k+eU9djvoYwD4dyvDXUDYPThfP27jo7Gq/EIe2xDob7ZHk65NmSS7P2LJ/VBpT92TNnxrbha5Xq++TJZnRN+7G/HFmUgTDi127kk7FMm7A/mHaXfJgppr6uXrs6ljvjrHCMVQxkyny8PpTThQvnN+qo1Z/2xnCnPKVhCa7yEDZ1kPa2qCyLoiiKoiiKothdmo5odUXTs+gn+2E8TocgSxzZml7VZCQ3XSQGru3o4xL2TZEufcwKlWJv2N15dx85rfG3B+vXX1+ORgQPAuMVoxc8YGZfMU7pEMwsaoYAnydtm3szUrhmWeP1G9dnf/7zn2Zm8zCkfPnll7Pf/vY3s3Pnz80eP7H5+r+Nxgb+xa2jgY3sfhnCS0caYNxhFPjp6tXxa48MFadOnZz9ZiPOs2fPjQYnhhzGLkYeRqrEbQaZcGYDmeX1my+/mP3FX/x+dvny5TGfN281YwSkqSMhD8NHDHQMGQeGQrr82Wezr776avbZEBY3b96affvtNxsd0Ot7c/nNYGXJGuPYi6FjYnxpG5y38sqSR+VK7hhmlGOWiKZfujXIyrhi9tzlzy7P/uqv/nL8YqHZT4xw33773ezWUA4YjUhDOIYps+LMzGM49DVHm91/OZQDQwt/jEaMOd99//1Yj77w+PXvvp59+cXns2PHj48GtG++/XaMt9XX4um0rQ380ow7Q37VHQOPvAhygCFozCMj0s3Z9z/8MC4htITTHm/CtKWmDGWtDrQjs7hE8MXnV0b5zTIcDaEbxjMGp59fZAnm4VEOZZx2I/z5c2dnX/32t7PfDuG1m3t320wr8mo3mdGmHfzw449jeTx+9Hic5aW9/e53vxuNv2YTZmYcw2Kr+63tTdvQ3pRl2ps2pL0xyCHP0byyLIqiKIqiKIpid2GsoYcy1tCzjN/3w1icXORoemXb35qeQMYmb1tNsqrBKn53omvwHxdMDKBvFntHzeTaRTReDxIDC2XfzBm/7Ql1+tSp8QHxkGnjT562ZXtmtcT5Uh9jSRR2M2z+7ZtvRmPF3/3d342zqhh1bL595szZcQkaY82p06dmRw7bNHxz+uX3P3w/ezY8xDa7tzzRM0w+hod//pd/GeX7na8PfvX17NQgm/2qzL5pS8LuDjIcHo0fNm5nWBrj/O770Rjx2WeXZ7/7nXBmiB0cZ+7wwwBDVsYghiYoizt3bs9u3Lw1dg4MHH/4w1+Ps8TsAXXyxBDH0AExOHngf/f1V4M/Br+tlnX5aksffx2Xrpl9ZZYRo5Q0YzAS7skgR1+uL4drjG3KtfUv9kA7Ps50unz5syGPZ8ZyV0+WZ5olZ9bW4YNtxpW4GZb4YXW/d//BGNfnX3w+7qGWTotR6+aNm+OsJYaef/fv/t1oyHHuwwOMm5bZKWNlLY55s9bAQKetyI+lgTEePnz0cDTuSINj5FEvDEnaly8imu3V0mr7rKmD2+pgkG1oAWOZ/e3f/GHMj6We6tgMKu2AHH/687/Nng1lqL2pW3F4GfzPP/5xzCNj4BdffDEaxrQteSHLvaHdKK9mNDs1ykumf/qnfx7r4evffTW2N4bCI4ePzC5dvDjW5aOhrC2LvLjx5ciQ9nbu7LnZX/7lX4zPUNrbp0NbN8vLM+S69iaNaTkWRVEURVEURbE30MM4+im9F8bj73JMTieMgYuLcYucvX65DjFUcevkjX8y0OvoRbCFDd2q2DtqJtcuoyEzqDBGeJgYj8wWYlRKI2ds+OMf/zgo//80un/8x3+c/V//1/81+6//9/89GgrMvjHr5tatm+Myuq+//no0KFDiPRQMLR4ShgkPsKVn4pfukMToT9rHxw27GdU2p2yaFeO+2UcXLl4Yr41LB8d9lV6OBgSzbUYDxtBZMQiR+Ycffhxn1phBdunShVcGGHJwlhraB8qeXo8eP+o6lV+HuJ+P6YjbzKFxueWT9gVE8jLQ2az81wWdTmTXYQnz7KlN8T8d05RvuGcG0jfffPOqXLn/+l//61iult+ZzUQexh8GnlOnTo9lpjzkQacnnRjMPhnckPqrPCJ7UEnfpv7KmdPZ2SeM0dHeVl99/dVoaFJGKSezkU6fPjOWiz2pWr4WzeRqyy51xgyAScNMuKmz+b2ZTfbTEr8ZbUmT/KkDaDNm0OlYGYkYkZSpsuH4074OH2mb5ysL127dvj2WE+MmoxhZWrtRpi9H49TRY8dHw+eRId+yZP+xa9evj3J88cXno1FLfMJJU3kzAmo3vhrZvhz56+Bna3u7cuWz19obI6lw5NDexvoay/P1siyKoiiKoiiKYvcxFm9GpKZP0XPe1Zhc2m1VT/tiIrnoUtGdybpTxCU8XWYVyNJWxbQPdpEBdHETWYq9pYxcu4iH2QNlthRF3sysQ+MMqzZjh6PEU+YtO7Rki8HhypUro2LPkOFhMKuFEcCMoSHS2flz9ikyK0bnsTnrZzwOjkFkNvQj6UsYPdwzW8mMIGmSiXxmBDE+MFQ0w0GW8Ynzk9FI9cng1+wfxieXxX/n7t3x4eSPa8vgGJfa2mvL9BjkiKAMWrhPhvhfjHHqbMYlcYM80kxHw19LezY7cvToRtjXrf+tbD8ZjTOW5Ok4GDma7K1czSqy95lyZRg0i40hSloMVvLUZGYQ2UxHeH50OONG8ZbrDTJKw9cgidI66k9Gg89oUHRvqNeUnftmf9lbzLWW980vD0rD7+eMTYP/lNGivMYpZ+G0i7/+67+e/d3f/e04qy/u7//+72f/8T/8h9mXv/ly3FPMPmsMpWTjWnm3PdcY9k6Os6EOjC8i8XKWMDpqX2aakb9t0t82fhfeRwO0G7PdtA/+W95Hicc6Zmgbl8cO7dc1JaY85c9sK/ElHMcPAxzkz7Je8Umzb2/DhcHf1vamHUzb27yyLIqiKIqiKIpi7zC+t1LFETF0vQ2k0xuU6AX0nlFXGOShG7i2G4hL3NJbBP2LHE2HahNPHBm3uJRRsbeUkWsX8Sxr0B4kM2RsjN6WETKGeCjaVEnGhrNnTo/LvCzRujAc83By4qHgMzgwzFgC5oHaNHC1TiNGAH7afkrNYp2ZXadOnhivCcIfQ4EN4n0R0GwtZgjxNiMRo8qB0Qjz6yBr6ygsOfx1lJnRTpyO12/cGJfH/fjTT+M+TT/+9OPs9q3bY2fCKGR5nnAMEm1J5ouxHOQjnYOjciJvHnbGP7I2w8dWY0XK1VJE6VjiyKAiT61cm1HKkruUq6WHlrXpaI4MZeTIj/SvX7825OGH2Q8/fD/7cciL/az+9Oc/j8tDfTWQIYjMn27IqGwYgRhWzDozSyvyt3u+Evi0zawaHOPOZhn9NB6vDWk+ejSU/yhPK9t5tM66GSeVjTQYneTJMe2Ea8bDU+PeWOqLccg+V+nwOXIxVDH4aXupA/E2t2noa8bZl+OsMGH5Zdiz/1trNydHsVOH0pF/aaC1m0NjvC9+boZDv01hRh9O+WnDvwxpj/upbcwAU5d9ezNDbtrezIZs7c1XSRki24y+oiiKoiiKoijeHsb9xuXRLaKDGO/vNdKJjkfHIEf0nBzp4rtBn78e+YxxiwxWn/BHD7LtTL5unzIq9p4ycu0qbfYN5d3SLw+Wh8Bv5xyDgcY9PgzDPQ+E+wwHJ44f3zCINcOPh4RhgsHDNb/HVDY6DA+Ox+Twhh8wWGQpGING8ytcsyZzDCPpCGIcaDO97L30bPS9+aC69mI0fDBgHPy0dRKJi0s+7ZFlSWI/I4fRjJGLUYo8DBft4W6GDum775xhpcnEjcm8wn3lxK805aoZUzJF1nUGlKGzG/JCfjIx5JnhpYxa+J/HpXf2snpw/8FohLO3mVl3L4bzZlx5ObNnlD2zQiub1mnGuKRMyUq2sSyGe2Z4Mbq8utaVEZTB+fPnBpkszZu/plvYGM5ssO83IxF5xMUw1JYWMoS29jTugzbIZVaWDx641uL5ZNy4PnVA7s06aAxexvSIYpksmRjTzC5M2Tq2dsNf2o28t/DPhzSkZWlu/LzsZpBZetnCtfzyC+WPQ0Na2pb6nLY3YaZleXBIY2t7E+/rZVkURVEURVEUxd5iLN4+ctW+GBg95G1AT4mOEBe9o+kIm7rHm5L46JW9Q9J7/PjROOFFedAtMxmg2FvUMf1/1D03rhW7RB4gDzhDgKVduWbWkeuME4wteSDtueRhtIQw+zCNHcTwDB09dmy4t2ng8hCNxpshTht2fzoc7fslHKTpC4mMBDZ2Z7yCtJ49a0YHy/yEbw+iuwxIZjj9PBpEzF5qxoq2p9a4hG3wyJBy8dLF8cuIviyYI2cjckswbTrOGCLuTz75dJwBxGjBIMVgR47GptFqnD00XD91+vRwbJbvKSnD1oE1w086FGHMVIqFXB4VnnJ13ay140M5Cnvv/r3Zt99+O54rh0sXL7U8XGl5YDQxM849s4tS7oxAOqqfh7TlT5lHzraMMgadI+OXDX2xcVpGn1/5fNwLzeb7Hj7hyZ40gqy2svl53H8Mp06eHOL3F4n2Vwn5amXRyot8KY9WUk2uAwcODu3k0as6YAhrcvdptjZKDl/lNAOREY6hcCzXF82Q1vbAam2RyNJsxrjWbhjFGKZsDs//q/Y2lP2mcawZBcWd+iJ3W9abv8BsbW8pvy1l+Xlrb1cuXxnro/3FZGs5FkVRFEVRFEWx9xj7m7HUtnbx0a9NnXUvoQ/RJ+iUzqfQLchD99gtWRKf/HGQvo+omYhgVY2yKOPW26Hplk0PNQlitKls3Ct2nQ2Fe3iwgtNNA0GzNHoo79y9M/j+dXbefkfD9Wyw7Tn0AIlLOMSQ4UGy/5PK5HJdBzM+UEPgtgdVm6HjOoOFI0NH4pOesAwiNoO33M6sJ3E22kwp/s0m8jXEtl/ToY20LYE7Nl5rM3banluMN+L0lT6/W8NrUzjR0myGHGXgqjgYKuJnPu2e8vI/+Xlvrt1rBr9PZjdv3RwNNr7mJ25GquvXb4xGNRvgM2rZ+JzcjDqjv+GcIcmm+zaQT5zq6tHjJ2PdMMi0e5sGu5SRMjkxPFwMNKkbzmwj6SgrRpl0xBvRb6EZrNr+Y4xH8nhiKPek0fy0TtqRAUl7GWeSDXn/9GBbj04u8TA0pg5iSOoNQolDeSobRzKLQ7y+TilMazdjkPEeRwzthhHt+IZhDKM8G+1NXGQJwvFnE395TBk1Xm9vjGvT9tbK8uiYn82y3K7tFEVRFEVRFEWxV5jFZFyOpivsjmFppzS95/UlhjtBXjj5gnjpsvRDR3tf22bF9eLtoW7piz6wZrsihq5WQ8Uu0ZRsBgSbrDM4jIr8i+czX6ozy6c5RpVjs2fPn437NNnU25cCz59rX62zRxFVXTw/Dw+MB8lStRgDKPWW2zEs/Par344GijzAOhVL3MTP2NEexE2HZgxpRrZxds8ReyF9MvvTn/80u//gwSifr+sxVMkTQ4L7ZJEGI5AHmYsxqxlJ7PGVpZbtwR+//Dfct/yvzfBpy/bEJ4y8MKwMP8fG6b5wU2NFylW+lAHjiL2zGM6UaSvfVq5mz12/cX12/dr12bGjx8Yv/7kuzP3798a47NsFZSgfzSjz8+zHH38aZ9oxUpmtFTnUwYMH9zeMMtl3bNPYo4xsvD7OtBo7dnuZtTLaNFhauto2W49hZl5eW5xtLy2GOb/tNdbqorUDdSZPHAOafcVsfH/61MmhHZ0bw7Qys0b+2ZiuOhCvMk6a6oFTd2SV9yzVbHGM3kbmtRt5025MyWXcE+7VUsbBL3woAPIvjLoSzx//+D9n9+7da3ENeRKX9KbtjUtZpr3xk/bWG7mKoiiKoiiKong3+Ho7Hca4ni6xG8alN4WOQF8gS9N71qPprU3/oYvJG52JjmLD/Z9++mk0bhVvF7r/Z599NvvNb74cj2wJoYxcuwjjhUZv+ZZlVJZpma7oi3dmuzQjjGVwh2Z37tyeffftt+MG2pYk/v73vx/DUtbtQ2RpH5XdRuIMCDFqiPvGjRujcUw8lgdKtxlLmoFpNGIMv8dN0l8Zx/I51U/GtO3npeNhIOL/2rXr4ywnRpxx/6fhAW7xbhqW7j+4P3vw8MGYV42IP3FcG/Jnw3ZfJfTgS1Nn4OE3C4ixSPgYXRhAyCHuUd5BbkYOe5S1fLxurHBd3i+cvzA7e+bsOOPshx9+HDqWe6/KVf7sSfXjDz/Mvv3m23GD99/+9jdjOUmLUcQG/eK3ATzZ5UEZiPunn34cN9XXCSp/4cJodBlkVUfui89G79Ju5TiU0RBG+eXLgMpN/MpEB/jNUN/K2O9myNmIvEM6ceKy19WvG4Y/RkIGrRi3yEfu7777boybn3ND+Zw5c3qUE2MH/PKXrg6a0ShlLB3y+93azi+zk6d8BdPy1V/GezFcaTfasQ5emZmpdfXqtTFPwlkWyr9w4lU24vFXDcYsafgtjm8HmW3EKE1yyZtw0pm2N3lZ1N7I1gxeRVEURVEURVG8ayzby3Y0xv7G7++ayEJHWRV+Y9hyTgekn9Fp6D/0oFqS+Hah95n8cfnyZ+N2Q6c29FaoF/XD/vLpP/zDP/yX8Wrxxmj8npum4B8bZ7B4GJ4+fTLOyOE89Nbo3rp1a/bo8aPREKCCzL5pRpRmWPAgqiRTPsVjfa89phgaKP+MLOMeUqfPjMaG9uC2cLfv3BmXMrKSic91RgkwwIiHYcl+T2b/mBGlMeiMNBJ7Rx0/fmLw3YxSBw8eGo0lvmzIcGazcPE/GMJK69bNm80wNOTFFxJhxpD82uTd8j5rYxllzJzSAHUYjowf4rIcz/TC0TD28vV9qkC2GMt0KOR9+qwdx3zcvTeWz90hzlY+n8/On7+w0fDl5eUop9l1Y/6HsJbyCctgcnuoF+eMLF9/9dWYH/K2Mjg4eziUG+MgA+KLocyVLyOLvI7GnaH+yGWJpvXoyouB0pcWb926PXv86PEoi32/5KFtlL81n+KRR7Ogbt2+tbFHVvtLyMNH5Lw3ynp/Y603A5K2pMyuDA+7PawY38gsjDq4MdSPvPR14H7SS13Iu/o01fP0OHOsGdvM4Gpt96FLY30pC+1GG5Bn+fKFR4ZGcQtnbzcGreyNpg2nrNua9RaO3KdOnR5lYOSatrcnQzib6au3Mb9DfrTdZkS0T9j8siyKoiiKoiiK4u1iTG6MTy9wpBfkD/DvkqarNyPXIr3BffoRuR35o9tw9BN7X9PtY+wq/ePtoC7ofYxaliPSbWN8VAfqhmMDsGqojFx7gGeHon5ko/DNtqHQPxgUe4YtFeDBYYU0E8vMJPswjRtuj8aJZjXWMegQGEdiJBuXIg7xXrxwcdzgXKXGaNEexsENAlD6bZKu4snB6Nbkaht+k4HBhrFAWDOpGFcYDkz3a7OEzAxrBhYNSbyWWJoF9XB4wOVFXGYXMdxocOLXuMjC+PRkkNmm6fIqHkYmcjDEMGgwgjAWnT13dgwvPvIs6jDEq2zMmpI3hiqdDWOSMiazB+CzS8rn0uhf+UemGGGU5ZMh/4yI9r3KfV8glJcvPv98zItyskxuTHcoH8LKQ5aRmvWkq2zGGbOKDo73nzACbsjF4HXw0MFxSap9vzx4DJqLjFzyN3TBo0HIzDT5JPNYnp0jm7yZpXf5yuWxPfhgAFnES2b+yHBmSLctefSSaeXRp4cxzqEMP7/SNnPPy2jM++CHzCk3eZKGZZvaztFjR2efD2Wm7cZIKdyxcZbcIM+QHnkZbNW/tqaulddnn10a60x5CDttb+pobG9DPtLelGMs94vKsiiKoiiKoiiKt4sxufF+dAjHZfrd24Segaks9C334hCZswQzjq5XvD3ojewE9tKmM/qtjuiAbAn0ZfXkGt2yjFx7RJ4ZxigzqBghLEH08Hx68NNxWZfZMhxFneGB8s740B64NtOJYWo0eOglhmsMDwwVwp0750uMDGP5mmB7OEfDwrG2RM65vaUsmzS1z4Pq/MBwnWGJH8vyxMmww6+wfjO6eYATd1sOeHi8Thpp2beL4cYMLPtemdWksUknnRkZGSQ0Rr/lETGsQD6VAwNdjFzzaZZaYY8fOzrutyUdBS4vNotnMLx48cIoT8vD81cyKQP1MS4F/aUtmWTUkr491GI4OXf23OzsWbOtZkNHxsj1YvSr3g4dHDrqIR51oayUWYws8ug6WVqVDXINsvJjmaV9wJoxp222T6ZpB6u85K8t53w5hmfwEXfvpMOwpPwvXLgw5lm6TZZWxqlzddW+GtnqQLwxcpnlp96Q9nP+/LnxtzzxRx5lK37lNpa1djJ0NGYSpt1Ig3/pp6MxI1A7YXxLPGZtCWMJp7QZ5+RHuLntbShLsjEUnh7CbrY3htiXY/0sbjNFURRFURRFUbxNqDj0mehG0Xmmus/bRNqj7rhxDjoGnYXr79EtMoHCqhSTAaJjFW8PuiLbBEcnVl/qRl3Qp+nqrrG3HBt042xj88kf//iv766lfcB4SFSKh9p+Q35T1j00KoJyzkWxbwaFpqjzywlrRhXjzxByCGfKJENR80+5F74P18LY4yjrn9tD2vy1tBkH2kbx5Gmuxc8y076MJ+4Y3qQvTnFz/G14HfNDluSDc5+BQphmmMrG4W35Zu43OTY7EzPSdCbkTcczJR2Qckm56kB5J1OTpxl6mkxteqk0NXoz7NSLsGhhWjhlYklfIIs9v8wgammSuS1PFJ8w4m4d4MvRj/KRr5R9/JGj1Vvkmj/zSDiGuFY2TcZltLjF2ww94hatvJD39Trwid2tbUZZ8pf0GMHUvfpA6p0Tb8SO/PIIcghHBtdSHvLEab+KxX1/Eflv//2/j8Y5y2O9AM30ko9V2lvK0nFRWRZFURRFURRF8W6g09Ct/DGcLmCsb8z+Lsft0UtAh5j+jqN/2HerdIy3T9P9mu6u/ZiIgqYH+lDa83HFEx3WPTon/2lboy5aRq69wwOjwPPw5AFS+IwM3CIFvQ83rbiE5fqw/GxNT5it6bmvwTTDWbvXlrc1azsYw/jtZduMsznxoMXbZvw4h1tkbsagPv1mkIH7yVdwT6PcjuTRsaWzWa5JS1yRJ/CfMH3aKQPXLLnLdR2x2UaWHaKlJY7kX7hmtJFWKxuybfpDy/tmfU3lmtLLtyHKa0g3iC91xbVw8kmerXUQo1/Y9NeMUPEbf4lPflr+l7cbZcJPDFQxrkUmbc/v77//fvbjTz/N/vZv/2acjSa+ZlRt7aOV5aYTFmTq25twRVEURVEURVHsL4zf/eHaJuGOdKboTe8SOgq9BmQxCSM6j+188sGs4t2gbszasrrIRIiQLXtUjZldjFw92pa6s9d4Gbn2kCjmy1j2AG0XflHYVdJdhT7+dfOyyH/8bHd/O9aVJywLxwDz5Zdfjg8Wf4wueVCwLOx2+erZLo+rxDGPabzz4lmnTNbJExijzEAzSw+s7H6b/SYuRjR7cvnaqC+L+qvO3/393417b5k15gWTl95ulGNRFEVRFEVRFO8G43l6lf13jfuN3Y3380ftd0X+gB69g1z56rtr79oI9zFj9t/p02fG9kI3V0/qx5LRoUWNuiWDaZtQ0vRFq6raBwHafmmj3llGrqJoeJCubGy67qHxkPgSoK8YFtuj/KyHNjPMFNKbN28OL4lfx726vEx8kdJHFHwdlFHrb/7wh3HvM+c+umD2WBmuiqIoiqIoiuLDgA5gxo0Pm5lBxcA1b8XNu4AMtqZx3A8zzD52zM6yTzZDV2baWVll9hb93Ifr6Jkxbpl1N35EbmMPbfUXXbKMXEWxQf7SYHN4D48O+P79B7Nbt25t+CiWofxY1r3IdDo3b96Y3bp9p90bXnAvh47HkWX+7Nlz435cyjj7eJWBqyiKoiiKoig+LOhVn3++OZHAuJ97F9A3GE4YRhhFsk9Y8W7QHkyUsLdWvpwYPTx7dbeVQW0v71Z/z0fDl6/+Z2bgtA7bpkFFUYy0faUabaP01ZbqFe2lkb/M6KDOnfMF0QvjFz2PHD06O33q1PhVRMYtXwjlf2p1L4qiKIqiKIriw8E4vxkkmmGLEcMMr7cNw1YzjrS9nRhRSgd5d2gD9t7K1xOnRlB1Y/YfPwxc9MwnT57OHj58ME5EUYeLJkrUTK6i2MDD4wsOZ86cftXxWq5448bN6gBXRBly+YKlKaV5obnOaMiQqEPKRvPKtsq3KIqiKIqiKD5MGC/8odtytMzUWWSg2E3En32a7LVc26O8e2LkPHbs6NAeLFE8MV5XL9pE6ovRi5ELrvs6vy1xGLe2o2ZyFcUGHiZf7uvJFxKL1WgvrBcb04CfjtNJg87J73b92fi7ZnEVRVEURVEUxYdN07PaF+HxtmZy2fvXpvK3bt0edI/Xl7UVbx9GLsZO29fEwAU6ohl/9O8TJ068MnBpN2Zu3blzZyUDF2omV1FsoLP1oFliZ9YRHj58NO4tpVMsiqIoiqIoiqIodsa5c1bNnBl1LTN2/NF7t2HIshrH0jYGkmL/YG9mbcCRsSswYB08eGic3RXjlnpk1LKqinF0nbqsaSpFsYEHyRTWHsvr3tZfGoqiKIqiKIqiKD5UGJ6yoThjRm/oeFPocr7uzihSBq79BX2acfPy5cvjHltQX1b33L17d+PLiideTTRh/GT4unbt+njO7zqU9l4UHZlCu8knw8PWrMlFURRFURRFURTFzjB7ywbwjBYMXLth6LLPr5lbd+/eG/cCzpYoxbvHhBFf3j979szs9OlTQ33bo/nAuEoqxk6zuhi3tAPtwocB1KX9t+jmrpWRqyjegDxIwcNWM7mKoiiKoiiKoijeDLqW2Tv2XqJzxbixExhJGEJsL5MvJq5rDCn2DgbM48ePjx92O3369LiRPBgl7eEMfvJVRfun2XvLzC716vdOKe29KDp+/XWr1V+fywJdFEVRFEVRFEVRvBmMHAxSZvGYTMCtY+gyG4yhLF/by4ygYv/AeGlZIuOWTeYZsxggzbLj1Pfhw4dnhw4dGv2rU3VpRh4DKD9vQhm5imIDD97re3IdeLU2uCiKoiiKoiiKotg5mc3F2NXP5lpm6Gp62ssxjK8lcuL45ZeaubVfSB2qT8sTL1w4P87kco0RMjP4GLcYwOjZrjNw+fqlGVzqdzcoI1dRdMTQNRxeceBAGbmKoiiKoiiKoih2A3sy2XfJjJ3M5loGA8nNm7dGN91eptg/mLF15crlcYliZmkxZD169GjcL83MLn5y3eytn376aTzu5my8MnIVxYRffrH5fOs4V+l0i6IoiqIoiqIoitVg0Gh7M7Uv55n9M0/nunfv/uz69RujQWw3jSDF7sJw5euJX3zx+ThLK7PyGCc5m8v7emKwh9qtW7dmt2/fHo1fu01p70Uxof/rQKZcFkVRFEVRFEVRFLsDo5Vlh4xddC5GLkd6GKOWWVv226Kb8Vuzt/Ynx44dnZ07d25comj2ljq0BNG+a7CxfJakMmreu3dvNG75YIAZfXtRr2XkKooJW41cB2Y+dVoURVEURVEURVHsDgxXMWJlYkFmcx09emQ0ftXSxP2L2VsMWwxcJ04cf7UMMXWqPhm9MmHEdYZLs/PU7V7OzCsjV1FM6DvSob+t5YpFURRFURRFURS7DL3LjJ98TS+zuSx5K/Yn6ufw4UOz06dPjV9OtBSRgYvRygwuqEfXHF1Xx/fvPxg3nudnLw1cKO29KCZsncm1OXW2KIqiKIqiKIqi2D0YP+zbRP+ic0XvyhK3Yv9AL/Z1RPtvnT9//pUxktGKoZIByzV+1J1r9t+6c+fOUM/3R39vY2ZeGbmKYsL064p9Z1sURVEURVEURVHsDgwfmdnDiJLlbZYs+l3sD+jD9tc6f/7caOQKDFmWIqrD48ePb1xt1+2/dfPmzdmTJ083rr4dqtUUxYR5a7/T2RZFURRFURRFURS7x40bN8fN5hHDFkNK6WD7A3trMW5dvvzZ7MSJ/iuJj0fdmfGrX2Jq362rV6/N7ty5+2op6tukjFxFMaH9JaHfl6stWSyKoiiKoiiKoih2FxMMfv21LWWjd0X3OnCgVtS8a06dOjm7dOniFqMjw9ajR49H4xanvtSd69ev3xiXJ9pc/l1RmntRTKiZXEVRFEVRFEVRFG8PS9oYTjLBgD526tSpcX+n4u2SOmDYOn369DhLy2+TQRivzM5SL67x67pZXbdu3Xo1u2uqT79NyshVFBN++eXlxtkmn35aj0pRFEVRFEVRFMVewHjiK3wwweCTT2xyfqQmG7xlGK7MzmLg4mLgYrjiGLXUyaFDB8dz9fbw4cNxuenDh49GA9i7NHChNPeimPDLL6bLbn0wPdhFURRFURRFURTF7kP/ykwhRhSTDD75xKyi0sXeFjFwWaJ49uyZ2eHDh8brqRtGLftzHTx4cNSZnz9/MRq4fCGTgbJt+/PuqdZSFBM8nL2Rq1mrD278KoqiKIqiKIqiKHab58+fjQYTMLg0o8rhms21x2R21okTJ2fnzp19tf8WndjsLYbHGLjAwJXliWZwPXv2bLy+XygjV1HMYWroqo61KIqiKIqiKIpi7/j555fjjCB6WIxcJ0+eGGcWFXsHXdfXEy9cODc7fvz4xlX7pD0ZjVyZvQV68v37vp54dfbo0aN9M3urp4xcRTGHly9/efXA6lxrimxRFEVRFEVRFMXewbjF0cNi5OKQY7F7KOMTJ07Mvvzyi3GT/35ih3o4duzYuMG8sveb0evGjZuz27dvb/jan5TmXhRzsPm8aZjh4MGayVUURVEURVEURbGXxMjVG7UYX+ori7uDcjUzy5LEK1cuzy5cuDD+jlFR+cdfnNlc9+7dG5cn7tfZWz1l5CqKObTN5zcf3lquWBRFURRFURRF8faxVM5X/or1YaRiwDp9+lTnTo9LQNtMrc3N5Tn+e54+fTq7d+/+7MGDh7Nnz57vewMXyshVFHPw8PZW7DJyFUVRFEVRFEVRvH3oYkeOtGVzxfYoJ19JtL8WQ5Yjw5bZW2fPnh0NXYyG0/Kc/qYTNwPXg3Fz+ejH+50ychXFHKbLFTN9syiKoiiKoiiKoni70MdqNtd86KnKh2GLO3r0yOzMmdPjZvLc2bNnxvtmxHHTCRzTGVx+M3A9fvxkXJ74888/b9x5PygjV1HMoc3k2pyK6aGPK4qiKIqiKIqiKN4ejDOMNcXr0FHtWXbp0sXR2WdruocZwxY3NWbNM3DZg+v58+ezO3fujL/fN8rIVRRz6JcrhmmnUBRFURRFURRFURTvCjO0Tpw4Prt48cLGlU3orm2p55Ets7d641av3zJuvXjx4tXMLYauMnIVxQfCy5e/jIauHh1IURRFURRFURRFsffEGBMYZBhsauLBJtlvawqjVpYnprwWGbdcY9xi5Op14L7s3ydKay+KOXig+z25cPCgmVwbP4qiKIqiKIqiKIpdZ5ERy/VTp04tvP8xEUPVp59u3Tu6XWtLE03SyL0YuKZk9hbj1nSSx/tKGbmKYg4e9mkn0GZyVYdaFEVRFEVRFEWx2zDILFs9475N1T/EFTbJe5uB9ens0KFD41cQFznGPkcz23pi4BLf1MA1vUbnzeytXvf126bz7yuf/PGP//p+zkErij1EB3Pu3NnBndu4MpvduHHzvfy6RFEURVEURVEUxX6HAebIkcOzK1eujMvs7Ak1b3bRjRs3hnsvXpuUsN+RPzOvPv304MaVTdiePvnkwKCHMna1WVinTp18ZZSaxzT//Npwvg/DD+darvsd49a88n3x4ufZ3bt3Z8+ePdu48n5RRq6iWAAj1/nz5191Brdv353dv3+vjFxFURRFURRFURS7DMPWsWNHx68DLjNyPX78eNDL7g962cuNK/sfRivOFyKPHTu2cXV7eoMVekPV1MilzMziQu4rv8zsynX6LCPXIp49ez67devmEPb9NBXVcsWiWIA+o3+wp+udi6IoiqIoiqIoit3BLKSzZ89u/FqMzdbnzYbazzBs+QLi0aNHR53ScsQ4+c45Q1Uc41SMY1yvi/bLEvvfIbO0ej8xcM0zHG7l9f2p3yfKyFUUC/j1V2uTNzuAMnIVRVEURVEURVG8e2L42e/YX+vKlcuzM2dOvzJEcYxNNnzPpu/57RiXPbPiYriKf0dlwDg2NXChN4zFwJUZXh8yZeQqigWwXqeDQG8FL4qiKIqiKIqiKHYHs7MYgsJ2hhh+LW3cz9AfDx8+Ms7KYnBypE8yWMXYNDU6Ta9v58TXG7N6AxcH/mI06/XbKfbgunv33ujeZ8rIVRQLaDO5+uWKm9bxoiiKoiiKoiiK4s1h4DpxwhLEpm+tMrGAwUg4y//2K03Gtv9WJkz0hqnQ65zr0Bu3kHhcy3XXtjNuPXz4cHb//oPx+PTp03FG2ftMGbmKYgE1k6soiqIoiqIoimJv6WcdhRiClulfR44cGb9AuF8NXfTHyCYvUyNU8hbD17K8ThGf+Kfl1pdZDFyZOdbjmg38uQcPHg7uwezJk6fjjK/3nTJyFcUCzOSaZ+Rap/MpiqIoiqIoiqIoFmMGEUPLixfNwBJ9i/4VQ85UB2O04Ri6fBXfcb9AXrO4Dh8+tHGl0RufuBio6Jzr6JnC2Ycr4SG+Prw4s0TRvR7XlPft23dGN8/P+0wZuYpiAW0m19aHfdWOpyiKoiiKoiiKoliNNqPowcavTaMNY1Fv0HE9Rhl2GY4h7NKli+P9/cCBA5/MTp48Oboe+enlJ3dYR89UHsv8Jw2GLudTHj16NBoWP1TKyFUUC9Ah9DO5UF9YLIqiKIqiKIqi2F0YsehaOWekef78+asvAjLsHD58eDzf1McYcNqsKPzmN1++8xldV65cGd3Jkyc2rjSSp+iXZPY7q4UWGaQCP/zK3zx9NNcyg2tRfGZu2X/rQ6aMXEWxAJ3C60au2perKIqiKIqiKIpiNzl4sH2JMLoWXSyGIBuhM9zE0NPrY/HH4eLFC299jy7ymHF25crlMR/LIGZzTdfsZ6iJp89byPX4XYQ4lhm4bty4OW4s/6FTRq6iWIDOYWrk0rHM63iKoiiKoiiKoiiKnXHo0OHZkSOHtxh9EJ0selm/xK+H/xiKzHZidHobZE+wM2fOLE0z+bGUsTl6ZdMthYueOdU1/XZPvhfposk7Y6BySlo9ZnDl/odOGbmKYgE6h2knkI6oKIqiKIqiKIqi2B0sVexnaUUXiwHHObdsZU2MO0ePHpkdP358Tw1dDE7Hjh0b992S1rFji2ePZZ/nXu6Wr82lhWas9csZwb90FhnAgrgSzxRx3r9/f9zzbN79D5EychXFAtKh9iyynhdFURRFURRFURTrQ8eazbbqWAxDvS7mnJEmhp9lBh/7dzE6cWZaZWbXbulyifPUqVNLjVvTPCU/8sExQDFOmWEVI1f8TPO5SO7Ew00R15MnTz74PbimlJGrKBagU2BdT0eD2ni+KIqiKIqiKIpi92CAspcVPYujf01nHbkWQ852s7k4hi5LCH11kTtx4vh4TVhpcesYvSKbcOK7cOH87PDhQ1vuve7aPWGSp94YNfUfebgNH6NbJOd2Bq6HDx/N7t69t3Hl4+GTP/7xX7dOVSmK4hW+inHp0qWxM4Rpnrdv3549ffps/F0URVEURVEURVHsHEYjM6OaAergaLTxZcUpDD2+sMjo8+zZs9cMYVP4W4Sw9+7dmz158vSVYWwZ4pK2je2nuEdu8sWY1R+n8fMnTG+sy/0+TPIbPz38LVqiCHtw0V0/RmomV1EsQefSdxw6GPtyFUVRFEVRFEVRFLtHDD05TnF9ldlcYZEBCIxMZnpdvvzZ4C6PX0Y0O8t+XlPjmH23+Dt37tzGla2QK8sOHf0mGxnNHmsz1Q6+kjn3+COjcHHy55p7ws4j6TkWr1PaelEsIR1IWKUzLYqiKIqiKIqiKFYjtproWcuMN4xA7jNETY1RU0SznaGLfteWLx4cZ5MxfJmtlWWO3KlTJ0d/tq6ZB3nIFUd/jOsNV5AO41Xy6nqLu+mZyTs/5Jvqnu6LM4aw4nXKyFUUS7DhYb6GgTJyFUVRFEVRFEVR7A5Nv9r4scEy400MQTFyLdPN3BJVr88tQ3yMS5YIZnP5LKNcBFlicOqda73LdfJG5pz317kYvabw1xvMivmUkasotuHly63LFQ8cKCNXURRFURRFURTFm2J5IB0LOTLmTGl6WDNsxWjEENQvA5yHy/zOi/NNmcZLhmWuJ3mAY/wkT1P//GSWWLGcMnIVxRJ0Pi9fbnYkOtWh+3qt0ymKoiiKoiiKoijWw35XMepEx5rOVMo9BqAYezhk+Z9jZnYlnuCn2Vy9QWonCJ4oxNUbp2KAiyNrHNkip9/yl+WM4uj9csL38NP00te/oli8Thm5imIbfv11aydbM7mKoiiKoiiKoih2jxiL5hm4GH0YiWLc4icbtTt3nwHJ0kJHYaa4xO+qSxfRjEvNWd2T9Dn3AtmOHj26ZYmjJY9xUyOc82PHjo33gvhiHOvpDVx9msViyshVFEtIh9Jz4ECzsBdFURRFURRFURQ7Y2qMikEnxHjlGINWDz3t+fPns6dPn473hI/BiXPep9HOt87oamkuM2Q1J6jJDlwfZwxT0icL9+zZs9GRi3vy5Mns8ePH45FzT/zCMog5inNaHvxEH53mfRn3798f5Hi28evjo4xcRbEEHVu/Jxd0QlxRFEVRFEVRFEWxPgw6ZjLFsONIx4oBKkv3+mV982hGql9Gw5FzfmOgYiBj7IqhLCQM1+LdNGTF2BS5lhEZkXRjkErccSFpM9olzLz0+MmxD78KOwnzIVGaelEsIZ1Qz9R6XxRFURRFURRFUawOferkyROvDDxcb5jJ7CjXVjHY8JPZXnExOJnRxdDFiXc3dDlxiCuGuRjW5rl5JFzyHlwj888/b41vHUzSWDfMh0QZuYpiCa2T2bpccdoRFUVRFEUxH8swTp8+NTtx4viWv6IH71PXDx8+NDt16uTo1z4lBw/WtgBFURQfMvp/74joVlzTvX4Zz7GugSfGLS5x9bOlGKUYvOKSzk7oDVzLZppNESaGNudTGcTT5N3Mz7rYU3qNYvvgKCNXUWzDdHNCnRFXFEVRFMVivCstEzl9+vTs5MlTrzbjnb5DDfCPHz8++uMYu44cactLPlai/PRl9ibKWFEUxX5Cf8bQE/r3AiOP+46rGo56YuDq44mhC9KSdpzf6WNXdYkD0kvcy5iGQ9INiSv53omBC4LvpOw+FEpTL4ol6BzSUYbWEdZAsyiKoiiW4a/k3pfeoYcOHZxduHB+dunSxVd7oxjYu2d8zxiWgb49Ws6dOzu4c1uUgY8B5WIWm7LzWX3lxWW2Q1EUxftO6+dsDn9k40ojfZz3Aj+rGHiEiesRNq69i1p8/RcZhcnXD/mJi/ErTtipS5wMUqsYuCA98clfe/c1o1cgE2OcI3+rxlu8Thm5imIF+k5m2iEVRVEURfE6vjB1//6D0fUw2hw/fmzjl816X86uXr22Mbj3x6XmGMauXLm84evjgNJ38eLF2eXLn41LNwMDoSWdU0WuKIrifcM+XPo4hvwQ3SrGJ845Y9Ay+GMQYnSaIiwdzrvIsY8r96QRo1X27IrhKy4zanvHv7CryBjEzb90yd3L7Ho2zo/xrNg5pakXxba0TjAcOGANdT06RVEURbEdBu6PHj2a3blzd/xtAM+dOnVqdubMmVFZCE1R2HTxSxmixHzImL3FoHf27NmFeb1w4cJrMx+KoijeFxh2zp49M/b/uvvW5zfcQ6753d+fR2ZTwR9JgrCJL+R9EiMT/xzD0tOnT185BrFcj3MtM8BiGIts+mtumt48xCNsDGpBXM+ePR/zMi2HYmeUpl4U26CP2Wrkylrq+mtqURRFUSwjSsWTJ09mN27cHH9zBvIMNvbgunjxwui8Ww3+uV5hcN3yRRvSr6JIvG/Ikz+gRWFblEfX649sRVG8j5gRpR8/cSJfU9y4MdB+b92DK8arRegvwT89LeEQIxKXfhWJf+q8o3qX6zFg9eEZwBirGL/mGb2WwQ95xNn38+LpWTW+YjH1piyKFdDZhE8/PTB2mvYPOXr02Cvn2nYdclEURVF8jHiPUgoePHjwavDunWlJYpaEoL/XKwHu25zeu5eC8KFRCk1RFB8ylij2ey/OI8YuLOsT8w7wXpkahGL86u95n8TYtV36QRqJI4aseS73ViEGrl5fTPherGUyFqtRGnlRrEDfebVB+aHxL8q9Y+j6EAfeRVEURbFbPHjwcPbo0eNxYD8P1yklBvlTheTIkcOjohRj14eC/P7yi31jXixV7IqiKN5fXl9CGPR76fu2M/C43xug+j7TO4PzHjHjKu8T5J3CxdA0L63+epY0ioebprcqkZmRq08z8fZEzjfBTLOdyPkhUUauotgGnYQOrmdep6jjmnZeRVEURVFs5f79+7MnT54uVBgy8I9i0L9X/ZHp1KmTszNnTn9Qf1hSDA8fPhyPRVEUHxp37twZ97zq+/y+b8/7wDUu54uYxsN5J3h39PfES4+zJNB1fuJi0IrrDVzTJYQ7JXFnxU/iJ1dc6OV+Ex4+fPSa8exjo4xcRbECfQe0nMWdcVEURVEUDYaumzdvjTO75mGwn0E65SCKQaCgfEgb0htnPH5shlv7fLyvSyqDuKIoivcZ/Rjji1lG+d2T/j6GIIapLDFcBe8CcU6NXD3uZRN55+K2FF5Y75kYoqaTG94EeZnmg3z6+eS52H3KyFUU2zJ/JpdNYqfYRNfSxaIoiqIoluPd6suLt27d2riyFYoAPxzlY55Bi6Er+3l9CDD6NcVnq5HLtbt3786ePXvaPBZFUbxn2JdRfz50aaPracb9NqlAX++cvhU3JcawnMfINc/vFP7Ez9hFppyTTV/r/m4Q4xkjVxB30poH+YXrw6zL+fPn3ij8h0AZuYpiG/RzL19uncml/+wM8kVRFEVR7AADfntRXb9+Y+FftfmhEGTgP1ViLlw4Pzt58uRKys1+x3Ke6ZgD8ub6LuleRVEU74R79+6PHyAZevZ2oYOxSX8fAxZjkPPeoJX3gd/+wJGZvnl/xLB05MiRV/czk4qbhzi50J/vFHJwfZriladF8ctHn89i55SaXhQr8Lq1fd5fFVpn5PqiTrQoiqIoiq0YzHvPUn7mGbrcp/zkXhSW4L17/Pix8dP0lIr3GfnMeGJKFMCiKIr3Ff2YGan2ZZySPi66lPP0+35H98r7wHuj9Zlb9S/X3OMn7w+47/3BMX5NDWDiSBpvgrhi5Ep85IiBiyv2ltLEi2Ib+s4xLOsEdWgf0tKJoiiKongbmMXkL/zPnrU9W6ZQWLyPvZejlASKyokTx8evL77v72B7cy0qg1KOiqJ433nx4ueNTeg3LnRE58ofLNLn07umRqO8E3oXv3F+x+X+1CFGrjdFHN5HU1ljkEt6y1jFT7GcMnIVxQrolKZs7Qg3OyOdmimyRVEURVGsx+PHT0YjjyWM8969rvV/2e8VE+9f+2JyDF29Eex9Qhk8f/5s49dWdkMJWwXpcCljrlfaiqIodop+3Kwm+2H1MO64x/X9Ta6h75M4uOe9kHdD+i6wF4k3cccfo1NveEqf57yPe13I3cuedKW1HQkD4YqdU0auolgBHU3f2aQjXMZ294uiKIqieJ0nT56Mm6w/evT4lWLT431MSXGMMpF3LsXEjK6LFy+8WobyPpKvK/YcOvT6fmR7ibK1nIfB8OjRo7Njx46+t+VZFMX+gtHn3r17rwxTIf27vi59uPMYqHK9v9e7GJQY0fj/5ZcWZjsnnDCO+r51+7rEo790DJFn2p8Xe0u9qYpiRdqAs53ruz75ZPnjUwPBoiiKotgZlAJfXrxz5+7Gla1EEVqmkDB0+erx+4i8UwB7Tp8+/VbzY1b6pUsXx3L0ta6zZ8+OimVRFMVuoP/WxzuG9O1cjOwxZtHDfv65zcLK/lbuxV//R4/eSO+Yc/1avyl9wqClsfzrh4sQdrqSRx7E47gqkaWMYm9GaeFFsSKts2kdjg5oow+aiw7Xl56KoiiKotgZFJ/nz5/Pbty4uVBJ4Mc972UGmCgI4cyZM+M+XdPr7ytt/LH3eTHmKSWrKIq9JAal3sgF1/X97unvNg1Sm6YL19NPeQfE6DXcedVHijfvCI7BSbyWSSb+GKHit8WxHjG09X9sSZqbedu+347cydebIK7E9zFSRq6iWJFff93aAW9a/ud3Qn1HVxRFURTF+hjoU0L8td9GxVPc75WTLGEJ3tO+umgWlPf2+4TN52/fvrPxqyEvlg0WRVF8COi37969NxqcetL3M0YxFsWQNF22zR+X8+H/V9f6d0NcT/wsur8K8wxc4ozxLHG+bXsTecrIVRTFtliuGHQaOo/tpu1/7B1MURRFUbwplASKjg3ZF311sFdUvHt7hYNxi2GIgYgy8r68lylIU8XPuON9M9YVRVEso/Xv7YMjPfrzqcFIHzj9Y8Y8+F2Ed0DcdvEsQ9jIkveKdDODKzI4rvLeWcXPqjSZNn58hJSRqyhWpO+soPM4fPjQxq/5ZM33Kp1xURRFUex3ohi8C8zkslcVhWgeUYbQKx3w24b0nK8vvi/vZOMOG/H3MNQZWxRFUXwoPHkyv3/XB6Zv5/xm6O+NXTt9LyXcTsNKf3NlT6OXM+wk/jfl4EFyfby6Z2ndRbEi0w7rwAFrxJf/RdjXiI4fPz47cqRthqgjng68i6IoiuJ9Iu+ydwFD17179zf+Uj7/L/Xe11E8+vetc+/ks2fPjBu472Ye1imTdWZiUe6mm+8bW5w+fWrjV1EUxfuPvo5Bn6ErM6F66GCuRx/T38bQNTV2Tfv+7eB3sw9PuPnhE3f8Jx0ykXlzb7BNWryrMw2/E5reuXoZfGi8mxFKUbyHmELrix59x6PTWmXpw+HDR8aN6G2Ay23nvyiKoij2I3kHMha9KygR16/fmD148GChMkAZWoYvBZrVtVswOq0a3+XLn9VMrKIoijmY0aV/v3Xr1qv+vTcqxZCUPt41Bh36mBU0/eyqnehbDEMxSk3fL3180oo/8NvPQvM7cq/KTuRdhBnLBw8uX3H0IfPJH//4r/NHB0VRbOHcufPjoPTYsdaBBh3tgwcPFw60l+Ev0i9ePB+NZ0VRFMX+w2DZtH/99HaGk4+NL774fHbt2vV3Wi7ex599dmmc3YS8ix0pF46ZEeA8911zbp+ve/fuvbre/vrdZgh455vxdevW7TGP8TOFYuIPWMePHxt/86tcenwVzB+8zp07u3FlNrt79+6Y/ioo6ynycOfOnfGPcItkexMYMs+fP7fxq+FLl75MVhRF8TbQr546dWo0Yk2JESlunpFI36iv1C/nXbAMcSQecQ5XhuPW2WHi7NNKGpCO2Wa9/1XJHz/EJY43xYdL7HX2MVJGrqJYEUYunZW/1PbLFHVsDx8+mjs9dTv4n4Zh+Jpe73/311fprIuiKIr10L8zcmTmLSOIAWf1uVthEGK0efjw4fDuWt3wwWh44EAzJnmf+ovzKviDkndkXw/q58KFC+O2APPIuxrOvUPVberT7631SjHZOBtOOPe1AZveL2oD8qI8KClnzpweFR3Lbhix5M9sbvE2palh2aXlOYvi7Jln5ELyIB4zIIxFdgtym/HWf7b/5k1GrudbxiJFURR7RfrhLDWf4l5IP9z3s+j7q/T5jpzw/CedecQv4jfo6+MQGdCntQzxCcPxnyWZb0oZuYqi2BZGLvirrsF0P5vL4NIAf5WB6nboJKcdW36/3uHpdF03o0z608F6URRFMcWsH8YIA0n997RvNeDUx58/3/r9+/fvj7NXqn99HX/4+fTTg+MyDQaoVWAYsyFu++u4Zf/Lv1QczFhq79unrxQKMMZk6wAGmczqmhLFJDMC+np//f26ec2R8Yiy8OLFpnHs1199nn7TDyg40mfo0r74Z9SbNwtBmT169HjM0zKU05UrVzZ+zUd5MDaKb7cwg4KRC1EaLSFqz8Lr5VUURbFX6EePHDk6Hs3smoc+Pi7GqPRdPdP+Pu+GML2fPl9c0/j08zFy8cNQFRkQ/+LIGCL34/q4+Skj15tTRq6iWAEd1unT7a8Hzo8etYRhcxD98uUvw8Dy4TiYfdukE0wnm98OlkKmQy2Koiga/iKcPtwMnd5gEhi5zBACYwQDwm7OkvlQaO/H0+Pg3GB6O4MNTpw4Mfif/xfzxTT/zXBkj8zN921TDqIwHJg7q4shLssJGTi9K3slYhWFIu/ZpvAI047D2Xg/kEce0b+X52FWlDJ7/vzZOJaY+h2yNJbxZ599tnFlMWaOmVk+rz3vhN7IFWXs9u3bO/qjXsLXmKQoip2iD9EfZgmj3/PIdX1x+p5cmx7R97utf2+/HcWBaTy9H2HS77rfx9eHWYZ8QTy71YeXkasoioXomGwueOzY5oayBtA62HR8aJ+9fbEvBnD6Vh3skyePX5NnuwF3URTFh46ZQ0ePttk/Dx8+GPvuKQacFy9e3PjVjGGrzlT62LAUz4wu7xtL8OC8vX8oAG/+zomSkOO671qGrYsXm9FSvXsXLoujV0xy7Jnem+cH+Yv8svcuWZpxyiyxTX/CkNEMcktnt4PBzFhkt9ppb+SCPPrSo5lc6yphypzhWH4YKdetv6Ioip5Lly4OfRI9rK1qMYu3X2UT9Ftx6I1WIf1z+ur0vTAWEG/vH+kDxdeHh7A5h/Pe4Jb448c9aeS9tFv9IyPXvNnqHwNl5CqKJeiIdDynTp3uOjdTUQ/Ojh07uuWvxf7Sb+A3T1naLxhYTvczgc7vY+wAi+JDJ/1WPd9b0a+byWW2jb9yMgxMKSPXeihLXxhMm2O08V78+ef2ZeLdQvzcuu+tdY1c67A5PtgKpYWMvTLTs538eWcvWpozD+357t17G7/eDM9IW1q6mb+2N9mztepUeG1DPpQFxauepaIo3gQTEPTjHAOXpYynTp0c3+/cOvA/752i7zIW4Pp+UD/m/YbcE0fvB4kvceedk+sJl7C7/QcA7wLvhN2M831hvRZQFB8h8zqtX355+apzCwbNOrr9DBkNMs+cOTs6SzAPHTr8Wv6KovgwsIRr1f2OPiYy4NS/m4VUvDkG0owX4eTJE+PAeq++Hmxflv1CFBVjAO9ZjgLmyLjmnHPO8JVxxXbv3ryz3xUMlFMDsA8GDDluP1ZEPvrx0X4fKxVFsf9pxvY2U9Z7Rl919eq18T207vYx3lUxPPXoo2PECvwyRgVGNnJksoN7fsewlDj0/d4B/Xsh7wR+FsnwJhB7u/fMh0rN5CqKJeiILFPcOiBrj4xOyV85+9lcOjd/ndyrQf3u8/pfw+/du7txVhTF+4y/bFKm7fOTwVaxif47S8CuXbs2Hnv0+/bkygDR5vP6990ehH4oaGsG7Wb+hJs3b732B6FVUe5RDs6fP7dxdRP31IU0KBnbQZnITC7v7ygUq9RnZOndMkNV4uX465n6jz/y5DnN0fV1EYaSpVzeFGVvU3+zsAJFsu0htvqsdeWubci7urp27Xr1SUVR7Anpl+lw3vNmd61L+mnvjb7P1r9mb8ZF9P57+ndG/Ez7fuyk31+ELxL7A1RvlPtYqJlcRbGE9vWn/jHZ7Hh0cIxaPQbOBw++/gWl/YtP57bZHvLJ+avxdFBeFMX7hQEU5dQG6x+rMinvymDRgHM1Nvv89JHF67T2RpnYOuuoH8wvwn3leu7cudEYEnfhwvnRuOWT8YwtUzeEHJdirGLgWkcOcXuX939tz1/cucxK4p8yIn1KT/6SH0ep4OJnei+KkvviEmfi79P0mzzuk2+VfPCfcnS+U8g2VbjyJctVIU9cKANXURR7hT5LH6OfZZTf6fJt/dy03+pnaC0i/ebUCZf3Rd4Pia/3t5us8s74UKnRWlEsoA12F3cOOqIMUkMGyI77FfmZdtwNHeuvo5HOXz7sO1YUxfsJRdQzrI/6WImhYpX+eF4/r4/v/5ARo8O6iJsMMVT4PS+99xV58c7Q5qZLCPPFw+BcGdi/y1/XOctFGcdsct4bk+IWGVR82dBG7cvK0j1lL15Gz/yOHJz4e5d64uK3V0B6o1bGALkWJcZxqrjkWvz34fp4+jDSJweZ4hbJ2eN3ys+y0fZO39kSQXL0iHua3jIsl45/+Xv8ePuvbxZFUbwp+lt969OnT+buu7mIvB/6fq7vw6d94qqkX5/n9orDh9sfaz5GarliUSzAINLXtwwkG/MfFQNzA0idIgziLGnxie39CDl9qclfEOZ9rjz4azMFL516URT7E880lwGZZ1qf5OgZ1id9jDBq6MezjHwKwwfjisHsjRs3hvLSH27cHFCmBof91+Us07JscRXE6/2hXsTlvB8k932v+zAgzz3ufeh7zeBitJo3kM6ytuSjlUMzciXPcK68Uj6roHwoLt61KTdxtHLPHiotXjKSzzWuV14iR8p82blw5FvnmVLvwq8SJvL1DpG3vzaVkVy51t9De5+3WWQxqKGPax7u60v6Jah48ODBuAxmFczEa0b3T8fn0NcZP9Y+qSiKt49+TP+jL/LeT783j/jlen/6zXXeT/uByOwPCw8frtZff0iUkaso5pCBHSPXJvMfFYPpLNFIh6hj0aHsxmfTdxsi6rwNvA14l8nIEEaBsNH++9SxF8WHynRwRjl1TT/EoIOmxL7ZXxw/BPRxDF2YZ5hSZvp4Bpfbt28N5dZm0QTlqq+0L1dYZuRK3eSoPsSdelkGWSQt/gxMzVLqDUT7EeVjSZzjmxKlggFkmdFliq84PnvGiLm5B4s/PsW4iHnhkGckx97Ng6GMX3W0KjFyJY1VmCdv8sOlvOf5U37kS1p9mu7du3d/fLejN9qJayqfa5TC6Z5oqxq5hL98+fLYvjH9OEFRFMXbQF/k/ZDl737HBefu6RfzhwXoHzl95fuCd0D+yOQ8ff7HRBm5imIOOjcDZZ+j3WTxo2LJhc7EANhfLA0UdSir/qXzXWAJw5MnT8eOexHGu/Iy7wtLRVG8XTIYc4xy6vmcKqZFQzkxMimreYYp1ynwp0+fHu7f25i5urUs+bl06dLGr+2NXJZmnTt3fuPKaggXI8Amn4wDU8aE/dz3fvHF5xtnb45yoGB4Jy1q02n7jnH97548G73zzHAJl9+rshMjV+RL+quQ/MQtyiMSZ+8PypGc7kt7EdoYQyGm/sQlz/ZH61nVyKU+P/vs0iujXBm5iqJ41+iPGLz8EcwfRIL+0/W+n9V/0ueW9aH7ke+//2Hj7OOljFxFMQczs17fQH7xo8LINe0YYRaU6fnLDEnvCjKbwrqdbDp2+bLc48cff9q4WhTFXqIraQr/6rM/itdh5FKO8wxT+jX9tg3PcfPmzbn9oZkoQX8urtRJjAAGy467hXjtZ2UW0Lfffrdxdf8gr2Zw7TbqI0ab3rDTymPzL+sh9SBMnGtxy0ha67yfdzorK7L3aU3zlnP0aeQciSfXp7ivvYsnx4RfZPBirCKXGQ64caM9B0lzXl2vYuRiuL1y5crGr9k4uz1prYqvOirzMowVRbGXGCsw5vfvcX1lvy/n+4D+9aefrm78+rh5fcRQFMUclg9m2xKT1wduNvw7cuTwONjcbxjwGk9nUL2I3NfRewEYcBZFsXt4xuJA+bZEjvFlnmJfrIdynVeO84wE89nqT3+uH1Q/nI3T1dluQjbi+cJv2sV+wTvtzJnTG7/WJ/WRclR2FAuz6vKbc94baryz/EWdy56RnEG9e70RZ9W6XbdsV28zW5FOn9/kL+0yeUj+MnMgeQ/b5c/1+FE24hG3eFLOfbowk8EfvQJjl+WJ/thnDLNTiBhDGcyS7H9vR2TVLhjZzJIviqLYbfQz+jx9ZNCH6pPfJ7wX7969u/GrqJlcRTGH12dybf+Y6BwtcZwOCg3qzOjS+Sz6C6YBKGfgqWNd5G83aV88+nToxNsG9KvQ5PtlXD5jE9uiKFanf84dPefzlD7KHYPy/fsPRgP6OophsZXsiWU5lr5uinvnz7elWItmclluxdgEdWGPCzaCw4ePjNf2Cl/31RauXr069reLDBtvE+84S93JtR3aeYwpaftcyG/5St74Vwf9tel5yDkFxbm66e9vhzwIs44ik2c36YXks88v+OPyhy5p9ffmHYO4OOn0aW2HMNJj4EoZx1gY+SJX4p4Xv3ogL3/qvWe7mVzSMhbKfnZ+68+EWxWb3UuX7GQxw+x9UzqLoti/pG803sreysgfGtJfLsLy6xcv/HHFO2vj4hyGZDaOrU/nfADMu2s3IQ8j137cD/pdUEauopig0/OX+U0j1+qPiL84zuu4zPLSYdoctzcoSYvfNgBtg8pmeGpfP5oOencTaRtAUvx00qtAHvLqSC3bWWfgXRQfKp6lOIMXyrOlZlParBP7AbUw2Rx+iv7As+k528s+4GOAkcsMEGU/T8Fe18j1Nmlt6dBoTGgD13fb35rxc+zY8XEmV0i7Dzl3jGFlijaddj09j0FDXnN9O4QB/+uUkbrnf16dzyN5VS+OvdxTkm/3uMgYo9EqJB2sKiOE8572h7Uwlb3PA5fyXjWd7Yxc0qc02uYAjPW2R/AcroIxmNllaQ/C3717b+Pu9qTcVi3roig+PozVjBEY1PWJ0G/6oxgdR//VzyD1By59mD/2o21Hs7lMfhnpg+Ok/fpenIGf1peTbxXIrU/WVxaNMnIVxYTWqTByMVSt93gYkFFOGbqmGNz6a3zrIFu8BtnC+Is9dJaUY0cDO24vB2mUFgYuBrhVIQ//OtR1whXF+0SUpBz1CxkE9bQBi6P7TbHP5/KR5wUGIM7XUcTfdzKg41Im/uo5b3n3XsAoc+JE+8IiI9aU3sh169atuX3u5cufDf+3dvA20d6UmffBjRvX9/x9sIjUHUVAeaU+cy/01/gnP3mjACxyPeKXz3WekTyb4hJ2VbzjhekVlHn5Cfndp4fEgRxzLygP4depQ/45aa0zg0laXG/k6kmc8RfIlr5qOxn1ZctmZVHg+n28bt26vbKBi2yeuchGkey/CLkKwmpL8qEcVi3zoig+DvQRjOlnz3qvtYkJ+sB793yI48HY5+pDfJhm6BHH+z7W5Y+P67yfdop+0DvK1gAmPzCI5R00j8yUrb5ukzJyFcUEHd/x4yd2ZOQCIxfj0bzOSMfor5nPnzN0tb1NXKPwtXSPjVZ4Havppjrcdf7yuy6McZtpbFxcEQNWslaHWrzPRJGa0iuY+gLPipmaq+CZbo8FA9fP+2IWzl6Rfq4dNo0fSBkanH366cFxE2mYkfG2+o7Wr5p9dGSBkevgMMhte5/du3fvNYWY/P3XFd8FZnPdvHlr7HPfZjtSJgy3Btj2HssfY/JMtHbeysqxL7c8K8pzHZnVV+Lq49uO9s5cbVZW2qh8OJdOZHQNabtxyatjwq1jdGllubOlh8p6kcFqHtMwZJ2H6/wpc+fyl/FG8osce7KJ/Lx74mLkyhcZxWXj+FXzYAyV9iZ+syo8m6si/wzbZ860jfSvXr32ql3Mk7coio+L1kecGPuITErQNzASGZ/0fVX6xneJ96mZrY6L+nMfxGHoKjYpI1dRTDDoY+Rqyu/6j4fOs02BbbMHpugsdUYGXfP6TeH6QXCWOu4FFDwdJoPaOn8pBvn9hXWdwXdR7Cc8422Wzu5CIfMXv3WU2fcV/R2nL8nU/+14m0YusplZx80zckV2hi5Q3vVpMe6476+97xJKv3fAnTt3xnJ7W0xn46yKdwqjk+drXcNce++29+Q64cjK/yrvMfKl3XJRGoTnpN27KcYIwqxr5BJm3XwpD26d96y0hIl80u3znGsp60V4x3PzynSZkauNoY6Pe7fBeEe7NSNxFX7zmy83znamuDGmt9kXm5il2dri3vc5RVHsbxiM9BH9UkQztPwxab/qNPpus85MhphHGblep4xcRTHBYPnoUcuNXl+atAoZUFL2Fn2ZyKDx0aPHcwePwloH3g9AdW46r3kDyjdBWvLLmLfuRvJkMYi2CX1RvG9o95ZfbaforYLnmBLHsOW56N2HgP7HbCwbrc8z3utHcsz5MgzGzGhdR9l/Ewxk9ce3b99+lSY51T0DkvtR/vt66/O1DPHwI1xmjOwmKf/23ng0lt28d8duIT+MFAbTO3k+lAVDB7eukUteOWHWCTc1cpGBE1fOuWm87i+qt0XPb+p7nTroZVknnLS4ZYpX8haXMsy9KX0bd1QefTjn0/tk7stNOzTDal65eaYoY9mX8Pr1G6O/xLkIM9vN4NJuIP4nTx6vNTZhlJ0320Hann99dFEUHy/eaz6I4Z2Rvk7/9v33P7zq7/Yr+mfvZl/A7Ul/vFcTIt5XyshVFBNslmppzZyx4cpkwGgt9XSwBR2pzoiyMm+QqBPL+uumZHwyDHKf7YlimAGhQfS6ccsH+ZftzVEU+wltvRk9jo+zTd6ENqh4PgyQ2oyH/Tw4Wkb6K32N/qDfWDxEAebeFP3For5vL6B0+6utgaw+C/KcfL9pnjbLpu25NG/GirQQv+u2l7ZnCAOJr+G29mYJ2G7TDL9tCdub/KFHeM+X9xxZU+7bkbB5tywi5emYMI4pU+Hjeqa/E24d5UD9CSOudeowdb+OkYt/MqYskjYc4/I7JJ/zyiP30J8nLfE4h/t+O6bdidPRMzx99/Nr/GLsE65da/vJLUM4/c7Fixc3rrR9vMwW72Vcxvnz58a+vS+HHs+L2RpFUXx86Be8k/QxJhKkX9Of6aPel76BbmgiRm/osiWGiROr9pUfC2XkKooJZ87kKxtv/mjkU+vzBl061qdPn43GpX4AaJCZv6ALFxf/2/1lvP311F+nN/fUWIa/mkpLfn05ZCedpOVZy2Qqiv2Ads6I4/lqMxjXQxv3/EVJ9Tz2hpP9jD4kCrK8bzVguNfuGwRmJsVeYTDmL4/rKPtvAiNX9ufZK5RdcwxRzaiTvruVu/az2U7Sp2+n/AdtN3sUCccpw91og5HRc2Fppt9vCnm1M7KtK582mLJJGaI/n8bXynir4cl53CK0deF2YuTCqvUH4ZTLvLQSn2NcfgsjT/31nuSvz+uiazmfB/mUhzxJs89ncC91Y7xgBquvRucLzYxM2pF+Vlrum4WeOlmEWe8nT54aw8IfECyJXLWPsETRHyjnlU8oI1dRfJykHzVTVF+RfkIf5j1qK4Dt+qj9BEOXPyYEM1TXeYd9LJSRqygmNCPX4oHSOhgwGvRl76spOlVGLp2TASE/Bw8eepU+pch5DFE6ZIO0DKz5NxDlx9fd8tuRkcvAk99lA1uIm0JCHkr8uhjI7mQmWFG8LTyHBgbtuJ4Rx3P38mV7lto+dG9nMNGe49Ve0fzmGGU11+C8Ka5mTBxZuwx2E30FJVZZLqLPD6dvWbUsprwNIxfImXIlb2RPH01h16e7p7+Vn/T9q+A9Ii7h09c2Y2Frl3kvrIM20dpD+9LUbkFO8ZKp5Xvxu0EZBecxcnHKJuWY+0iZOcZPWKcc5F/YVY0p4D/v2XXCSYtT55HXcXq+6F7ylTzPO19WztshDe3SGKC12WaUcxS3I6RBlqTFGJU/2DE0xVAljPbJqL2sTqQhjNmWya+ZFco2eVuEdmsZtVlcyxCXvQCX9TlFUXyYeC+bdGCZYvoYfYKZqL7cuk4/Xrw/lJGrKCbsppELBvq+3pHB9Dx0sFz8xCqfgaVp/JRz1wwmDRj5458z0MuAtMdeFgZ1URaWIbwlXNJet8MXt4EuubZLpyjeNp6LdTeY758ZA6Hst/U2MTDrn8W+/3A+7U9aH9BmY/kr37Q/2E8wclGA55F8OWTzd33fTgeijFyUb/HsNWTXX6cvtHQxfXNv0MqSUH+IWNUwkT94iE9Z9O3RQN0fG1xb1k7TblLGzQC4dZPu3cI7S97IuiiPm3W9KZeySj7yHOZ8EcKlfpcZVKZIS9h13119nfaIax7Jm/qTVmTt5e5JnuP4Sfvh9gKyxMgVpKs/cUy6yUt+k0ueGJEy3ukxgyptYF4dCsPIpb2AHxtAb/e8k0nYfMVxGcYn+pyd9iFFUbyf6Ce85z777NLY/0IfY/xhFQqdqvgwKSNXUUzYbSMXTMU3GDOAnIcOtw2WPxk73nmDWAYocUwHmhDeIDN7A/GTNN0zaGXwcm8Z4jOV98GDR0O41RUFmKFglpk9iopiv0AR3YmBK19IfFdE7n4/G8+nAZuBmr6EYsjfx4A9J+wBtBOUkb6QoetdoM7IkH4am7Oy2myuVfEHjcTF9ZhJwyC7bKNubShGP3HtJcoc8kzWvLPk2xE5uh9DSL9ccR2Ui/jWMWREFu/MaXkuQ1qcMu9J/uCY+ON6pJl0p8ce4ZTJNK3dRjpTIxdcl9cYWOehzFPP8jAPbdMXGafYW6ZfevPjjz9tnC1HmO1mcIX2RVczylav46Io3n+Mk8zgyvsI+qL21dea2fkhU0auophgWcuigdybIE5/4cxfK+dhkGgwFgws/cXf4NIgFwZp/Fk+xagVxWAewthgUXh+KD8GysuUBwa+EydOjjPA1lG++v1myGSfjnWUjaJ4U6JUtnZ/7LUZBdux7LP4bwsKZfKwqgL3MdCU1DZTaV2UqT7w/PntZ3zsBa1OGQoOvjJUxHCAdftJ7cN7YZnR46efro5lxa9liJZq7DVpu47Jn9/ePd45MeBM31f8qh/3+RMuftepb3GIa533VuTFsvdiSN6Ek54wzvt4epKHPh+urVPn4qWg7fVSO+kwcpEt+UneViH1FzcPedDHpo58DTF//LMM3N44q9SDDyT4Yuqq2MSe8W7a9oqi+HDx7rMMOkuoYfn0rVu39vyPBsW7p4xcRdFhUKdDXHVQtw4ZMGYGxjwMEg0ADTINoPltX9VqMFK51w+c+8GzNJBrfucvsGZ2SV9Y8Uz/WttDwRbOYHNVhaE3ckk/MkIcvgpWA8wPi9am2z5P6yiW6yKdTdeWqIR2bePHgPvaepbwLkP79Bc9S8Zam22zId815PYMrrIMZ7+iXnJMPfT91rrYvNpM0Z32IfpAf819V+hPtcv+L8fZq3HdPd6Up2Wp4vQ+mFee/QCeP243aM/bZp2mniNDjupp0XtknrziS5x9XOvU906MXH1+YnjKtUWu9xP5epmnrifhVzHkBGHmzbDaCb388uyYa2kjZO79rYOwykT+uGn+c891SxK3Grmej8aoaZgpDLxmIpqRuCrSUn7bxV0UxYdB+wIhA9fxV+8W74YbN26+2sal+LApI1dRdBjksfynQ9xtxGvgT7kxsJs3gDTQpnS3pST2Cmm/KUhZcpiBKeNCG6i2rynybxAnjn4QzQ8FQNriFdaAUryLlCQDSddjANgOfhZ5M/uMAYEfcj1/Xmvg3ze0Gc9H9hJKXWt7MGB4+nT9mTat/bb2LH5Gs3nET2bEtGvj4TUYwfhbhnbYNj9/Msj+ujL6LpFPzyoFcD+jD5sOFFNPXMhvZay/EWbdAabBqfoym2snaFs+Hf6u0M5jqEhby5LFZcsLFyGcWbp7obj3dRjXk7qTbu5Fhv6ozOXZs6b+tpNTXMIkTun077HtSNgYq5ah/MC/c056uY7IgV72nLvft2XX5/kL/HPkXNcQ5/2tLJLWMiK3Y5/PuPyed5xH8pX8OPIv7kXhUnc5zsOzrH0oDxiTMEYtQznYUoGBq6+r7aDY7oaRsCiK/Y9xqi8pHjtmb9K2n6D3ghlctj1YpR8t3n/KyFUUGxisGWyZAr/O4GlVxMlQdehQG/RnZtW8QaIOWKfMwNSW/W367xXyFrQp/plJleh4mU7H1dn7emMMbeQw2M6yx8QLfsT14gXj1PwXAtn5i+IqfBfFXPgjV2Z29WkW+4MoMJkZ0V+jlCyq50ePHnbt4HUPwsYoFsQb5/mTRs9G8q+IPIuQrmWK03imrLM05m2TsrBR6rukr5vQ/9Y+Fj2/ud63hSizypzTVtZh0Z4+qyDtd2nkUmZkcExf22Ybbt2QflVUgb9QC7uTNpw6TH3m9zw5cs8z5b704m+Z3PIbI1feEdshDU6a4hZuVVK+fXlEdse4/jeSXuTr8zY9z++E93ud8peW52b6bt6OPDv9O7PPw7zzedcWkTgd+ev78f5ezvmRF3I5LkLZxCXsIvgxW3PRMy4d20kwcBnLrEMZuYri40Cf5A+E/cd3vEd8nOXevbtD37a8Hyo+HMrIVRQbGLQZfPZTW3cLcRvs++uCTtdf7l0zUMtAcUozcNkwfnNg1qbnZzlA+wvydOAoPvkQZ1OA+NlULlq67ZPd/InDC4DSn8EospQme4DNQ1pmzWS2WT8InjK9bAaNeKXPFe8Gddy7oI1ob7mm/rSj/jjFDL20yb5OtRPO9PF5bX0RTaaNHytiANO+Zrqdkev5+NWv/dr2lNO6G+avS1/f885b+b/eNtQlcq2v7/QB81ybSdoMY/zH2MOtwvts5ILy8g7Q18pzm4m7dUP61fl1fFcl7Lx23NfZsvM4pD6mDupvHVm1kxjF1fU64dQXmYSblzdM85F2Kb3ccy3njn0Y9H5Tjslv0s3vnsQlfjKuijDr7K8V2aTDRb6kv8gto8+P8/zOuXRSFovKHvypJ8/0sjTFkXrs01tEvqyYtBO395F99bbJ3lzKyFUUHzbp+7wXr1y5vHG19T/Zh2udvrp4/ykjV1FsoHM0iDIoN3jbLSgyR44cHRUE5z5X2w9wsxn9NE3jQIp4m1q7rgLU0jUrjULVDzCDwWnLb9vQHoxi0uOvDVwN/LdXatoMnTY7hv/2stm4uYGk5w1uLVkwq2uVwW/xZjRlYWvdNEU7S1k3939DbxxVN20GXvuLfDN0La8v6WnX4m5tZPFzRaYm35tRRq7GvLKcXvN7kZuS57N36tVR/7Lq4DFKsXYhrD5n2jctgoHLxwFW8TtFuvbkmpe3twk5OH2qfHj+PBfKYV0yYzFl2DOvPvnNb/4jQ9x2eIaFW0dRaH+YaX9JXyecNqKcFqXX5y0u71DnU5LHtLXe8S8t6fi9KtIj5zqzsqQ1NXLNkzfXcky7ibzzwkyZ5iX5nZaB3z3km9em5kEO5dD69+UyaW9x0l0GQ1fKVb790Y2BS7D2zGyf/54ychXFh41+Qj/EwOUc+hmzQ4316vn/+CgjV1FsYKBmKvxuY8aUQaMBI4MOQ9AU9/nLID3ooA30/BViu0HhIjYVIbOtXk/bfcpqBtEGoAxxbYBrKQa3XDkx4Gz7w7wY0zD+nDcIlYd52WDkks+dKHrF6mgH2trhw/O/OtjXm3q6f//eSorOPMSjPflS5yL4mdNM3ghtLG1+Gdrbh27k4lIOjuJM/U5pz+ZWp2z631PypVjGgXWeXTLEqCpeYVcxgLzJ1y+lyeDiwyLvms1ZspT9NkNqJwNwf6BQhspv2o5jkEJfj9AO8nudstyJkUt/I6/CrBMuRi5llHbCiUtbduxJPnKUlvOUQa7PI89GwqwKGZTJOnUnjPqOAQd9nnI+L4+rQP44ee/rnluFdYxcQfnJF7lD0uvz4dqqzztDF7/6mbNnN8dm4li3fMrIVRQfNmZw+ViP/isYM9y/f3/8433x8VFGrqLYwKBpt41cBmE2STUos0TRwLYfaLqvQ45SbuBnoNjDP8OYznonSEPcFCLnBnpmWwXXzHqxV1g2m+c/yoy0DTS3wyfqGcd6I56/uE5J/rtieHWNQvP48aNXv4udoU45yqFZhD25F3LeXRpRBdsZuYTNTLDM2JiiLaHFvzWRaZq7gbazmpFr/+7JBUrjMiNX6nGeW5Z39clPzpuhJc/k/Odu3nXKPRnFpX9YpY/oIaPw2ij0NWRZ1t78RfbRo0dDWqsbSwI5yXz27NmNK+8OssRwA3tz6TvXpT3flj8+f63cUsehr0PlDteWlfcU76a0mVVR5upamHltJHI6cvxy+Z17kd+xd5E/v9OukpZr2yF+YcS1TnkIt6qRK/khn3qTTvI5j0XXQ/Le51ueF+V3lXII8hSD36rhkr8Yunr5xZHfiU/82/UZ/G5XTu5tR5RcaRZF8eHBwMUQziCevsIzf/fu3XFywar9WPFhUUauotjAYGm3jVyUbZ0uA9f0k7XSM/spSp6BMuXtxInj47XpIFFHTRHaaWctPQP5DOYpRkkj17ksX3RPUuSS9nYwcljKNh1ozzN0gZ9pVlyLApU9u4rl9HVohlZ+O3LzlIDmJf7Gw2uom97IJX57ak1ZlE6fBhalsxf4+uLBg01ZXoR2aibXfmhjeTY9Q4wWuUbZ7MvWOfp85VqeufZcbT3npsp46k26lL8ozNshTAw0wib8MgV7HuJJvuFIhmWyuM7Qdf/+g40r28OA5A8J+mHhGfP3A8n7NN/rIA7vmHXqD8JxwqyTZup9nbT62T3kTLvrHXKE+HPPuWc05QVtrX9ue1lSpv1Mqe1IWtIg46oII3/9uzTx5Lx3/TUy59o8kqe+rPmX777Oco8cO2lD89hJPQd558SRckCfB/hN3ml+1kd5bsY7D7O4tJndKJuiKPYXDFynTp0cv4yffsBYxx8x23Yv9dx/rJSRqyg2MCDbbSOXWVw6XQau/jPx0qJ4MSgZ7JlVkr/GU0YpLlNDl8GgOHTeO+207f3SvujV9sMZhprDsd2D9Mzqcs9XGPk1OLRccjuavO0v9r2iIAvzBqAZ9Pbp9yiPVibb79/xMaGMP/2UImUWjb9wt+t+T9tMT395kZ8eRd4bucS9bOkhtkbblI93QVOymrK7CO36zp27aym1b4IyJxdnuZryzHX16Hr/3KeO+vMez8TmM7R5julv4cUvzyHxug7+1XUfbkr8c55zsirjPPOr9ktJmxNeWHGJN3IsUn4Zue7evbfxazHi05cq63ZsRgBlvV+Qd+10KJHX+s1VUH4Mo/bHW1Re8xBO+awTBnmehJm2E3HmGAdh0saEy3X0ceTcMedpD8rFeeIST2Tv4wA/3E6MXML1z8iUPl99mD5f0/v5vYg+v/PO+9/Sku/+etDG13kGlyEdSGOV+JLHyOS3OPJMo78XUo/rtsPXUc5b4+65evXaEL80tpZZURTvN97r586dnR07dnx810NfcvPmzXGs4A/vxcdLGbmKYgODsd00conP9FmD7czSgoGYGVwGpQZ3MXD1g1bGL8qLQWI/cOPHbC7xCbtTxEu5aoPYlm473/zLfoxtfj98+Gi8tgxymoXy889tllhPsjBvECrbfd57KBz2A8t9vxf5/dBIWVEWoiggBpFegdgOcc0p+qUo5hi5yGAwMV362CP+efX7LiBH2vgi9sLI1cq5GYoZiVPum9ebTDG69GFC/zttvf/N5dl3nuc19M9H4uqV4578VlbwO24e2ltkEV/aBf/KMWUZP4gMPfy7Jj5Of+G3+DjIV5T2PryBq0+BJ95pHxn0Rf6QsJk3MpPvdb/vCnLLf8qwn2m3Kt4lWNfAkffPOu8RdZOy7uvFcXo+754waV+9w/Q30j7SrpyrT3Lw5/q0XcfPOkYukFGZ9OHm5SHn+S29nC8jMuYoTC+749RNka/cm9Y12ddtA4tIuYurr2fkPMfImd+pY7/VE5nFFXIv+J16fFPZ+z/69Pz0009D3PPLtCiK9w99iH6FgcsMrrzn9SG2djF7s573ooxcRbGBAdlubUqsAzbotE+VWVCUFx2uTtlfG3z10KDOMkDGr3mdcZYupfMO/DJ07fU6c4oXGYYURyPXKmlZEiRfi/aXMQDtB7hB1KvEb78u8YeE2cty2EtSFvPKJC9xy6tiEFmVReW8Dor0wYP7Y9m2WYebm3nuRvx7TT9bah6MXPfu3RuU2uX7wkzp66xX3uBa0jWFXr3Fn2Mfdh5R8tKetfU+DeHc65+BKe4nfNJ1XBQmfvkjd8JPFc7EhcTlWtomRbU3RvDbu9DL5zq/vWFBP+waR4bpzBp9qUEsgyF8sCP1nHT69II07UWYtPcLZJVnfX2+bLsqZnB5l0A5rWMkmGcUmVduyPXUi9/kdI554fq2HH9kXNZ2p6Qt9G3Ab9c5JN8pt9yXt0VlOU9e15SJ+JxzkdtxXpgp89JzrXcpF2123TojByfMNJznUNkmnZ7IPr2+DPElnZRH4unLw/2kqdzJkDrmh1/lGv/zEFaY1Nk6cvYINu/Li99//8PGWVEU7zueb87WLhcvXnz1LtAXWe1y7dq1V2OR4uOmjFxFMZDB2G4ZuQy0KB86XwaidLhmaJ06dWr4/XLcQHm7jpjiw3CUTryHssfQ1W8iv5sYhGeWAOVrFeXEYNYAleFg0UDV+HPegLcNbtt59vHqr01Rdi9ePB+P0wH/+0KUljbjZD1D1pRF5fomaF+UnRgR3ie2M3JpN4xc/TLi7cjgSrxmtZ06dWI8V4dwjJ95aM9RHFvbbo077aDHPc+cuNwTJr89Z35P00n8/DmPbH06PUkj8kBfI5y4c815fudaEGd/j4tsXE/uwT1hkzc45jxy9GF6XJ/KnjSF7fPa4jBjhAK+/wa/ZGas0xZTd6vAyMWYinX7QWXblzdSflzqtT+fkvDk7d00Tn2IOHZi5OJenxm8dZaQeOVf2rk3zVtP8tMfc30nJM/TMsj5PPwBSb4WyTiPZXlzHUm3R3+h3Ncpe+8k6aU9xi2Td1E6ytW9afmKTxo5F05dOt8pwqZeQxm5iuLDwbOtf/rii8+39ClmeduH68mTpxtXio+dMnIVxYBO04DZtNc3RVwGnGfOnB6NQ4xRBoam0lv+R5nxtR8K13aDOeM0CgJFJoPYHvEylq07G2UVvDzI6igflIjt4NdyLArldjIt2pB+Himn7ca+9j5j+Fo2EH9bZJCtTOyXRanpX8i7gST6wXzR0P4YlLNHw3Zcu3b9lWKmPDmDKEZeRuYo07k3r8y10SiY8xwlT7hesfXbc81FwXPPLCV9hWt9W05c/JMJ+hfPpn4iSqbfkRfOhRGW4dJ14bn4d6/3G5n4X0TkTNy9vElf3DFSMPz3993zzOobzXp1jxNP/MgTXBOPI7ldF95vaUuLi/ziGdMdrh0a/LvG/6KZs+8Scjdj8qdjfa76hwv5yB8iUnbb5S1lFJdrcT3i4hIvFz/a6qrIW9rTOuGEIeO8MJG3j1v9kjV5i7xcn9+d0JfB9Fxfoa35vYjIEVm04YwN1iHPONejDBCZehaFWYZy5X8d+eSpL58e+SYjP3098OdeELbvI9+ElHcZuYriw0F/e+XK5bGPClbMMHAZTxRFKCNXUQwYCOkws/TjTTCQywwse8cYKBrIuU4hZOywF9Cqg7g2IP50kO3kcP66EiIeRqg3/QvoFGXCyEWR9eKIorod8o4nT7bfX2YdQxda9igX48/XaINrbuPCwJMnj3dlwDwPZSQPlPRF+1VloB23EzaDbYbfYVQfBZ4Dz/MyI1dfJ56d/nfb24VS1hRj5+LM8+UahRqtzW1tkPOewyjjvWLb0miKnyV4P/740/jXyIsXL8x++9vfvlIyOX4hbmE4xvIff7o6ezY8n5cuXZp9+eUXrww/USSF7f1T+MR14cKF2WefXRrvJx1xC8ev44MHD2b/43/+cSM/r+fJ7EP93Nkzp2dnz52bHRv6tsSTMvMFS8sHTpw8MfuL3/9+SzoPHjyc/fDjD+Ns17/6q79ss1+H6/xwLY2mFOvjrl27Oi6FvjTIfXGQf2rk4i/y25Pjxo0bswNDHV65fHl29uzZ0W9ToF/Py7sk7UDfqa9dZ3ZuMwJulnfKze9FLvdDwgg/dSHn5BR2HWOVOuSks+p7BKlL9dzLEtlT3+J2rc/7lHnXehK/OJL3OEyPwW/vdM+1c+nEka3H/TgyJ1/cqiwyWKUs+vj8jhz8p89aBfKJJ+WxCuoKCTeFLPyIe1o2PZF1msedIM0ffvhx41dRFO8z3pHe5f2XFI0NjFX8wX9ev1N8vOz8z1pF8QHRFIzNPYfeBIoxhdYgrR+cZ7CpE16nI+bXrCgzKqbhMmikaBpoZ5C5G5Cbi9yr0rK7XKEI624G653W5NlU1nrI2Tb33nTKxZdXOPtKKaN5YeeRvGdgnnjijh5V7sdGA1efZu+EFce8NF3adJvKUe+S1+Y2/Rer09dhM35tdWZKeob0AZRIxrF8ZdQzTDGn1PfPdK+I5ZmOy7MThxxTl1PEY/nk9Rs3Zjdu3hqf977dbLaB1ibFd+v27dn169c29hbbNB7Ip/tk6cPdunV7DMMZFEoz96YIL3/+Oupc+Zw8eapzJ0eD1O0hru++/3529erV2eMNmSO39J8+ezqm9WQYiE4x6/L+/QejMUoclhlIq5dJHCCr+8qFXOjrNc8ahxs3b45leXMoywcPH47Xmp/NWXnvksgdOSL3UNNryaZ8+nLQnrXh1o5b+3avL08ubdeR077Txl3n4pdTL71bh/hfJ1/8xqV++7wlf33e+rY3dSCHvCR/ybdnJ65/zuOvL4u+DPp8zSvrPlx/HrdTxC+dvs6Tbt+2k27yneurEPnWCdOXxzzcJ48ydlyEvEzLcqdEpqIo3m+Mz4w9jNfSL+iz/fHOHwffpE8tPkzKyFUUGxgs7gYGZgaaBsk9rg3Dv6Ej3tmgqw3C58/WMtPLXzgs0dqtfKAl1ZTOVSEf1/K7PdKYk6VtIdIqctm4fVMpittUlqIUKLdci2uKSwsTA8jUmc3ypmUu/Zaf112xGsqQYcrzl6WK6oVzbepS75zBURzla5njJ8/gOgpU/EpvES9/eTkqgIxCXOSLI3PkfmZwd+/eaPh52ckUv9Pf5GYMGyQZ02CQMvsk97l5CMfA9dmlS+MeGHGff/757PLly7NzZkj9/HJ26+at2d27d1+PZ5BDuS0qq1+H+PWVd27fmd25c3v28+C3r5vRz5ywuT+tV9eeD/kzM46BWNqWMkjDvcS9HyBGL3e7tp5syVNc4lJmXN9uc95fi5+cx23HunKKH30453G9/P0zm3vT61zCLEKayffUaNX/7s8TZtVywDx/riXtaby5n7xPmVcmyW/CxV9P0gy9DPPSWUbSWVa+U5blKfCTMnG+COl6/zquK3sQv3FTURTvN8ZzNprn9IXQt3nPt9nPbz7rs/jwKCNXUewi/YDMwLnHZUr4Tjc+1qGbxcDQ1Q9kg46fIYaxKy+BNyWD0HUGmRnQMzSsinTi1oFYFFluFZox0F5Lm7OxGKqaEWtzxlfvzAQTZicbw5Ovl3HqtlMIitdRXtq3uqT0NoPlobHdt7o9OtZZM0A2wyU/zvN8amfaqWdUW81sjuksDvfmtcl5z98y+ra9rL6H1jAepX39+o0xHf4jd46cGVRmKPFjRlVQNtKKP2HAGPbo8ePxr6DK6fnzZ+NfQHt/03TC4aH8/AX17JkzszOnT4+Occu+GF9//fXs3LlzsyfDQNOMrKS9KvyqG3kWnkzO5aPPb49frvUy9zC2qU+zzeT18aNHY7xoz914+taIrL2crX21PwZwaR/pF1ZlWgbi1Y7TptOu07bdb2lvzvJbh7TlVcPFX9KKvOo3rv0xobn88SDPb+8vcSByxMkP5zz43ZdDymJaDm9K+oy47eJNHlJvKZN5rs9/yiBIQ3qL6jdlkWMfdjuE4X83wuQal3xF9l7OKfxpE47TOFdBvJZCF0Xx/qLfs13LqVOnx/cCPNtmb929e2/sR4piHmXkKj56MvjaDQzYOPHpmEMGd7Dh/E4RN2XVYH3ewFCaTdFvG8a/OespNCAjGCHWQXaa26q8rEpvOFqHZtxqm4uvg2Sk1ep2vsv9YnVSZpvluqnsGeBo3/a2U2f+qmfDcsaMGG8oRcIyIKQtwjnlr1d2/V63frTJPOPrhO3b8qJwrssXI93tO3deLbPr03IU1/Xr18c8jnkeysXt3o/ySh/Av1lSjmdOnxnL6+cXP49LBeUlfuMSz1Y2jQm9Iq0OTp0+NcbxeGPG1DocGMKpz9OnTo1LGm/dujV7+OjRljxM5VGSZJGW2Wjqs1eYzSrTDtreHSdGA5zydE+c2XPtbSEP8/pDZbjZDpuxZHH5z8cfTeQLjn3d5Poi3N/Oz5T4j4yO81zaUlyuqRdtlptnzOIv9PLlvG9/yk7dawNc9o7kB+LtZdoryJU8ok9zkYs/eSZnXOIRZ5/H9Fl9O08+t4NfJN1V6cPFLaP3N3XylTpOfZM/7X9RXoTTRqZtYxWIv25/VBTF/sEzb6/O08MYI3us2rOSHmTfzfRRRTGPMnIVHz0ZeO8WUa4NykIb6LXHzYDuTaDU2HzZ5+bnIS2zWnzdUd7enPUGlmj5XT8cvLO2uvVeYpJtBqZ2vhMSNnHNcy2PO0+jeB1l6rkxM8uMLIObU6dOzs6ePTM654wqFGT+tA3KnxmOpq2breOjDow3ZioF/qIAe/76NrWqotgj/LrtO+lEiZ3L0EcwcJ05c2ZUzmzYLlwfhug2bLe/ln6L/76vkb8odq5zrt28dWtstwaLFy+cnx0dyvf+g/vjUr6+DOTN776MGouf6QPDdbd+GcKs97Q2xHvx4sXZkaNHxmWLN2/ceJUHcrwuS2PedeHsI2b22amTQ9s5c3ZUqm2An75XenFvA8mow3nyupbyJ9+6ck3b89tAer2MzuVPOcdw5RnNLFjtNO+ipe1/IOUhX3F+e3495469YTP3UwZ+u++IGEj2ktQfUn+cdFMmMeopi8jDDzljxEqeuD5PPSl7blWm9bUqKd/IvF0cue8oTPKbupcnccpnjFvJv+uLSHzr1+PqhsCiKPYXnntjwUuXLo59SdBX+GOYvmNeH1kUoYxcxUePgVPfgb4pBlU6335A5jxKzi+/vPnacWkYyPtrxiKkx9BlhsuiWVXkWubajIcNz2vQBrNby2CneIc1w+F6Trh13n/yGdejzjZdizOuWB8Dlyh+lGAzbRhethqyTrwy3qhLS3R9QcfSEwYsU9QdGXtcZ/R98aIphsJo8z4I4Fy9eR4X4X6Us1VJmHXC5fnv88+152wzHoaoo4NCzJjHyEWxj6LGn/7DdXGdO3d2LKce6SQtzoDwsaWKjx6PxjNla4bTieMnZk+H6zdv3nyVfsJwi0j8cU+HfsiMM0rrySHuQ0PeFoWXTsL1eYa6//zKldFIdv3GzXGmGj9Tf3Clv544Xwx5vXvv3lhe8nh8yOOpU6eGvB4fyzF7hsVI/bZQHKlDMHhwZEbqaVHZLKOvL+F2Ena7MO6TS1vlGBy0YW0vhixt2bVV8pB023tic/P3GLBixMrMpfhfFX6FTxhy7cxIMp+UR8pE/EmjLwPp63vkY5oneV8nT2EnYUDm7ep5HtIjs6M8pd/i5DfnyTd/qdfkVxm4tizPrsfNg+x9+a7KoviKoti/5Hn/7LPPtvRb+lF/xNK3FMV2lJGr+KjJwK/vRN8Ug6oYeCjvx48fGwaB/pqZJQhv/pfFFk/7izUFfxEGg2Z1UWwp/l4afV7JFMVlnltnMNnTBrkvx3y/LxgLb+82B+Lc1LBWNLQxygjlhwJsCV6MWVxrj8fG2VrambLVng1ctGcGGQYsRi37LjBQREmMghiFiYO2ag+1ZiDb+hVNitYiEn4dhJnXZ5CBi8LbO9eTVns+mnL/uuLnr5eHx5lNDHdmIDlKj1+GgKvXro4GLrOUGMQgCvGkbIIyu3vn9ni8cP7CIEszLp4Y6uPApwdmN2+1Kf/i792U8SuJDx+On+lWJ2bOWS7wp//1p/ELhkePHB0HpCkDbhpP5HPcmufZ2D9dunRpduHChfH3T1evze7M28h+g4TPfceXQ5ky2g0/RgP/uKx1aGdZTknO+BVsUdy7SUur9f1o7UD9bF3i5r1AxvVpcU/LYxV6meL6tqsd9kYsLm05LvmbOnGra8+1tu6Ya57lqdFnagiJQ47rkPDihrIl+yplnDykPKbPc/qW5LPPm/O45Geap6lbl6T9NoiMyZvyjOt/T/Pch41bRtJwFN88//Kc8lc3q7BdukVR7D+8a86fPzceg7FPvqRYz3WxCmXkKj5qMlDfTQzUDNIM4jMos2m5dDL42w108gaV0qEEL+r0M1CPwsKRiWzNOGNgusht7i+2inIQyEKRyxr6j4WW740fHzjaRdqW9pT21YxX9pVqs1W4KCZDqKFNabcMPO0ZsezWMUtwuanyG+Wple9mAZNB+gy5zZhMCW9tTvuL3z5MT+ITD7cd8SffjvIk/TwfuS/OyOsYFzn6+7nWY+alTd7lp/3V8tnoT5ncu3d/HOwxBsnztP+axqdsGQwHsUbDj7jJemyjLzAjTnzCkX0KORmbvv/+h9k333z7yv3bN9/Mvv3uu3HmlDK/9NmlcfZU8hQ3j3nX5UNbuTAMbC0zZEy7evXqUPev95kJnfJOmWs3vkoZw6rr6sf5WJZDPrSpPtxek/qJEVzZy5M2LXkfIwH5+UnRrCNbX56LwiW/5Jm22/xu76p23ZHjPy5xJA3pNrk3jTvKN89uXO5FzjwP/TOQe1NyL2muS2QShzzMy1dfBpzz5Dfpx01l7q+tmqfgfl+ee8kq8gTypGwiW8Inj1PX38dO8iS8cGkzfk9xP/VFvreB5yJ/oCmKYm/xx3Ez+vMOh3eKP3r2M9uLYjvezhuiKPYpGdTuJgZmOuQsvTBYM2MqA7LdTs+AUFrLDF2gTLW9jtoMGkYIMgli1tV815QUYSnE6wwqI4v87mTA+z4iy/K9rB7eN6JUqMcYsxgRtJ8YTblcc5/f1lYoPa0dMV5pp5xltgYrbalh2ysrijH/25UfmRhWmjGjpS9dz5nnzSDIMefL2p+03I+fnHPywPVKb66FXHOE+JK+/PRyTNNahPRsDs9o9Ojxo3HWlHIyk8rMLrOxLl64MOZ5iGwjVCPxc9J8PJSzjdzNcPPsR3Zld+rkqbGPYkhbJJvrPw9183w0RD6ZPRmcrzReu3Z9DMfQduXKldnnVz4f0jg+ppm8rkPSleeLFy/MDg5l8NNPV2d3790dy28ekZfjxwzAZ0+fjQZCbXWsq+Ge9nF6GDRnBhpjkqXYb2PZYtJIeehLnTN0uXTgwOaMQ+3FvWkb2w5hOPGkLSaOPLs59m56Le08cYTEn7qNSxufOs9ynudp+xf3uiRcL9N28Csckj768ujLK26a/+Q7eevzkzzFX85XZV3/YSdphT6vfX651H9/L+W0KpFtnTBIfoRznvJOvfWQq2+vewVZ/AGFwn369OnRrVseRVGsjve2sYrxj2cN+lvv7cfDWMjWFUWxKnv3diiK9wCdqMHSXsBIZHYKRd55Bn6U8wwkdwtGghjUMlhchGS9SCwPovQ6z8BtKhNFRbwGmwZ7zZCwerch7NGj9h36uLoaVaAetquL/ULqnotBltNW1TnXjFjtS5SMGY6MWvyoX2G1kzYjq7V7RocsOeyNWb3SuQ6RT5slCwNLjBlTxcjvKKTL4DfPIwe/o0BFmcpvCMOJW3q9Qp+05+Ee+rTm88ns0yFdSxJx/8GDcQbXg/v3Z/fu3x2vGwiSaR6J34DQFwvNBDt39tx4L+1SuVlC6ujLgzaNnyeXNM6fPz/77W9/O/vLv/iL0f3F7383pq9dnD93fnbp4sWxLiD8ovyvgvJm6Lpw8cIo908//TTu+6Vsp/FGXk6bY8xTxvYeixycTehPDINmmHlmJqF2pJxb+PHWriLe1q64Vve5hiab9rBpwGltp7XH+NuO5DP4rQw5dcvlGXae9jxNI2U1dWnjaee9QXra9tP+55H4QMZ1SNn1+L2dk548ym/ykmvKwdHvaV6kxyU/kXsZkZFblcS7ThhsFy5y9E4YR3nOMe3AMW0m13qmv1dBGuvS50t5pl6cT+EndbiTtLZDvGa92tPPWCl4hoqi2H08c561EydOjs829AnGjsaRZeAq1mX9N1dRFGthAGYMZsDMAGDGFeWS0rGbgzPKh/gZ1FaFgYLBwjT87I80hbyMFQab+bLdKoNeLydh0Qajuz8Q3c9sjNf3PRnMM2JOv2joL9faKgMGgxZjlplWDArZN4vxpW0Ef38ciBiQxDA6TznZKVFqIl+eH2n0Rl5+tD3nHDmiPC1CGcQgIHziFVbcvWIfxZdb9/klByfcdmHNQGI8ss/Y/aGMbTZvFpd0L1++vDR84n/85PHs3n1GnZfj1xTlIeUiHs+7erZX1bOh3hbJxp+2YIkkg5e9s7788ovB/y/j8kCz8nqSz50gHAPm559/Pu7xZcbY7du3x3bVxzmN30xBG8u7qj2njjh+bYivDd+4cWOsT3lsBt296Ze0KW0UZm2lTJV9ZG/LFn8Z/PlDQ9s/sZV/C78K/Pb15XxqzFoGWThyaR95lpR39sJzPW0nZboTku9e3lUQbl4Y11r/tTnLNMY8eZ/mLfkiv7DCTcsn93bKOmGTr3XTW6Uc3evLpnfKxn15VTbp51LX6ee4pLUO6+Yn9Pni/CZL2t4UftJf7zbeefo7fVGPMdNepFcUHzv+cOoPVN7TwXN//Xp7ZxfFunz6D//wD/9l47woPiooQpb9GPDtJRlYGrAxQhlYUsik2xuWDEh3qjwELwRxiHM75abHoI2MXi7KZRhuDvFsDm7JTmYDvKaItb+AryIvQ1d7aVE2ds/o8T5gLLwfBsRRdijTWVbYDFptRpZrlMMoDOqVcqEdOWZGlvYbg0/aWhSTvYIM5M3Mwzwv4yylJ5bpvhhlTh79ntcuDZTsP2VWmSqJAQLCRrkTdpV8JU2sUwZkhDCcODgK5q1bt8dr58+dG4158vry55ejAZExydcDz5w5O/v97343xkHOO3fujmF9QfDcEA5kE8/NGzdGI5F8mVn3448/zX748cfZDz/8OPvxp59mt27f3qjfR+OMBUsEeqWRQYB/M6sYwt2L3L6kSN4HDx/ODg59xxh2kFdYbSMyWGZw7969se4YrVyD+4wo9snSpr7++uvxetAfken6jevjTLafh36EP+FsJC895ea36wxhDFhmaTG8jnkd8sldvXptnK3Wlsw+Gw12lFfl2/bB2p02TBYyaVvO06bE77e+tS1T/HVMu70bWnlz7Y8U9gxr7aqVo2egzapU/u0ZNrOyza7sn9tFSI8Tn/jj8qy4159z27HKM9KTPLYyXy1swnDyqWzllXMe5GvqpAFhp3lqZdzqijzO4x99O1+HyLROOOmjT387yCtcZE+ZxLnGYVomZJP/Vetgp+UwLdPt4D/1kd/Jj+uJK2UcEk6eevSJ+sx1/ugH6V+5cnnLuwb6GB/amBrbi6J4MzzDnrfLlz8b33PBM23LAu+motgJW98WRfERcfgwg87eLFXsyVIu46JmWGvGJMrK0L0P1/rfbw4lj0K7yhdIMoDt/ZGvTRk+PsrVD/TE6YVj9oN8rQrl0t4zFLNib4hSQBlsRiFfNLSXyKlx5lOrz/bRAUqBOjdwN2hn5DArixGoLS98MtRzUxooF+soK7uFdhdD3JEjm8ZgAx9GN22RXAZF7kXRWdTmkwdH4RmOwqIwy0gY5b4qwnDCrBKO37Pnzs4OHzkyLic0G8kXh6aK3hRx2zeLAUp+GanM2Jq68QuNw70jQ5tR91EUI+c8xOeeMjfTwTkj1v3BhXXKZErSFgdDn1lrv/7y69hGtdWQMuS0BXkl8qK8cjbe13eJKwaz3Z7NJU7ypy22NLIkrBm1OGnyQxnnGL88m81o1ZaPeYYN/vPc9s+uehBef8yA4VqPe/KY+J3Hb+owDuRcB/7JuGq4eWk5cpvls3VGlt+5LmzyG9fnZR6LrkNcCS+NfoZyL+uqrOt/GX25yHtfLo7kTRlKd1oufd4iV44Jtyr8S28dlpVFn7fUbZ+v+EGfL/nxex7iEr7PGxmEWRVpe970r+IRPh+C8PyYrbxOfEVRbI9nzbPruev7Ge8re3569otip5SRq/hoifFpr2HcaYM+Ck975Px1keEnCgiDAiWHUm/Q9yZyGZh5MTx9+nw0VhiYLRp0Jh33DSANil3zsjHwpFxF0aKYkZu/DFBXRRhpKAv5+1hYUOw7Rt1E4WEw1F4YJC0pzLJC1xiFMugngzYQhbdt+t6WIjEamD2iLbqvnrh+MO9cu3gbkFc7S760v/Y8tDbUb1bfZrdsKv2L5HTPbKI8VzHOKgOGPfDjHrcqOwkD4bBduMTN0HPp0sXxr5yXPvtsduH8+Vdx9IiOf+XBMTox5gn/my+/nP3mN7+Z67766rejMdSAkrFIOSbtRaScL392aawn4czI0r4g/WXhF5F+JXngvvziyzGN5y+G/myof0b8oBy4tintkzEfX3/11dx8/nZwXw33xG9ZYwxmbc+s3RkKRR5tLIYqR78ZtdoeXN49zXDhDxsx6Gj3fqedpvjEp060/yj80/N57d414fJccJEvDjlft774V5aJZxWSlnDymbpO2r3MkTvH3I9LXMvSd6+Pv0cc6eviTz04hp2UyaphpBPZHJWH/oxTLpx7ZEuetyuTuJQL17NufhA51yHpJh993lLvkYW88pM8JWyfn7j4m+YL03j5WXXmuBmjbWn+yVHGYE9AfwzxBwDvx3npFkWxMzyrnjd/bDPWC541szCNXzz3RbFTdmdkVxTvGW0gtP6AbydQbtoAzUBt61/gOR16DAxoyvvre4WsC4WqGdH8BX/xDJdFA1/XDRq9hPqlMXnp9APKVWiD07b/jAGpclkj+EcFpbtXfJR7lhn2deGetkJpTntJ+7KcL+2rN6hyrmkTjJaLlAbxue7WXg/utQN5lTczLFv+mpGOfPKy2ZYtq2pKaQxW5Fs0GOKXQWtrHpp/cY6/dpi/ddp/SFrC9m4R9uayfNEXDD/77NJocF4WxvWXQ97GJX5DO2D89FfS0xS5Oe7MoNzZB0M527hd+Sae7TAwNUDld9yXbUgT24XN/Xn+Uj6pT/JfuHB+aB+Hhvy8mP3cKa7Ca8tmrbW8nhyXbM7LJyXWvePHjm88E1kauLz8VyXxxGnPm4auTQW8GdWaH9fcy7Mr7/pIeY9TL3Hkzbl7zX9ryym3IP512Gv/gZzTsMlH8tLnOdew0zQX0aflPH2udFInO0Ucca2vagYfzu/ck7/478n11G1fJikP1+Nvv0HG5HERkb/Pm999uUzhZx7C5BmD4NuVDb/6MO/V/IExMIJ7bzDg5z0xRfikVxTFenjejGf8ESvPkXecZ46By3lRvAlv9hYviveU6V9s9wppJB0dNiVt3iAtA72mjDcDUlOQ1jMkTRFvNg9mKMjgeAoZo2wJEwfpk4fhwdKx4coQj4FoM8ativxJXzonTtgH6uhYD4wZ4mkzHrYqAB8qyZ+8pq6VQQyKbdDdZtAZfOc8M7QYd4RXnoxVGZAbGFhuaDlWZmqpe4aLGFlXZdOANL/NrELyOXXJd8s741b2CWsb3LuvvWTfrdaGn0+enSgziw1cjV/HNJpxjAGQsaApU4nPeWRblzwnU6b5jQv99fw+OJT5p8Pv4XSEvJxyMYOLsab3Px5zvvGbPOpdW1CHjFgUueS3dyk3m8lbsvh4CKOse5TdJ5PlfOISliwXzl+YnTp5cgzX9sSaKrdD/zG07wMb7Sn3cl8c9vLiL/lt7bXJCEsWGfqOHW375PTSMHC1vH46GtzIK44+n5xr0pFXfpQRx9jObUdkJm+M0MIp47TjZpC2/2Lzz0/aOZcw2iR5vBPkNa710+0PHlPZF7UzuDe9L61VEXY7/33+43eZTIuQF8hX8unaojy6ljCRYV2WySnu9m5uM+LUo/xtl1buc32Z5HeOfd1vtoHN8uNSz2kHff3Hz5Rck86qzItnHslX79ZBOqnPlG/fzvt6n8rkWspvHqmneaSsW9j55QbxG3t41+gzPLc9nkH7+mVm6zzEkec99VkUxWp4Ts0yt4WAc3hezcrmPINF8abUxvPFR4np6f3AZDoYWndQt4gMgrLMb9Ggq8egil8zFzLgXiXcMtqA2V9FmsEKi/Loeu5Jl8tvR3mJcude9m5aBWk3o1YrlzZzp81I8tt9eW5KpDQzyBZ6c8Aded4HIq96zDH5bEa+5hh6NsvDzI/mXxmrO8qBF7/lhW2JYTNcut7qd/6MrJ3CuIYYR5OPqVNP/eyUdi15bM5MM9flmXMvRj1LLOXddUhLm2Lcksd5+ZKe9iJO9+bl27UoQ+Jn+JtCTjOFco5VyzD5hDDJe+/cj5Pn/ncvH7/y+XTIr49hMGYxTLnP8RuXMPDbFxTVgY3gzVaCJTZPnj4dB5GMOsc2jFzpgzhETmVpKSCOH2t/WeXHRvdPnz4Z4z01OEaiyJP8URTHWaPPn417Z9kTS3xImhxZ3OvT15c838izTemHEOP13o90GOCU33A6Ozw8I2aeMfy5d3dj4331ePHixbFNKcu+3BLPKPPwXNnEfox3aBfaOS/CxE9zwjTX6q/VYWvXnt3NJVivG+m35oEsUe65yBfX+w2jrENc7q9C0u6RzipIS3hpbS2DrS755yAv69LKsn3QYh2S5ryyWob0VvGfuuA/DsJOy8G9HHNOvv560hRn6ruv9z4fiXcVOUPCYNVwfTo5n+em+cOqbamnz+OqSC/tY1FY9yPrlMib2b9T3PeONTs0fUiQnufU12YXpc2/9IVtH7A4MpbNTsqnKD5GPIP2ibVfrHcwPG+MymaE+4NmUewGn/zxj/+63huoKD4A8hUy6Fz78Ywxz7zB006gQFFWKexmDawLZb4tTzs87jmzbOC3ChmgmZEVo8IqSDNlYuDot3hgv4pV8GJTFvIiDoNJcWRQ6xgXpNOUg35mRvv9yy+7a9TZKxgg5JsyTBHu84coPBT+KELJ55vMonpTbNRNDgOOGDa1gRi15GPz96ZClHYyj9RnM9i1+m+zAxsx4rm/DOkwjiHlN8WeDtlzaxHSt9cV1E/KfxXkU/g+v6lb8iSvOY+M/Hj2hJNPv9P+e38gizh6ki769Fzv40g8rudc+fbXkzYXWV1zL5ChT6eXKXInDS6y8ZN4+jQTdus9eWoGHU4aCRP5ev/O+9/xSxZhp+UW/4mrDwP+tfPkhSw5z5HrEV4aias/50L62T5PqyBdsm73LASKe9+nkyd99XZIS/vXPpLXPt9xIXmMwW5VEi/Fhmwps1XIMzOt2+1QhlgnLf01OfkXjovsyXviyzlSZli1XBKv4zqGP2G4yLcKCRO5k24cpnmLexukLLZrH9qqeuV3HsLp/+0z6N0VxM845d02jyjZyxAHg3xrj+2auvYV21XroSg+Ztof386Nzzk84/o+X0Re9X1XFKtQRq7io8PAyEyAnjaQ2/jRYRCTwd9O8JcK4duysfX/OpG0HTOwo4isqzD1iItjXBBn0lgV6XoRtXgOjDNkVhmcx8BlyZzpyFOaGE02+YyiGee6Y8t2qy+DylYWbRla+735l/J3CeNPM1C2WUpRziKzcujrcSrvu5BfGaedZSYXIst2bWW7+5jmSxjXXM4SsmV5d+vYsbYnWcp0SvtrYJsFtgz5jJFLfOLq23Lyk/YXh75MUqeL6PPDvzIWp7TcI8cU19NeehLe9cgC5+35mK+Yuq9Mgt+ctLVP8QmT6+jjyTX+UkbSS9kg8WFRn5D89OlAPO6lTpOu+PhzP0zD9nI6TttF/IsrMvfwO40T03jdd0y9zWN6PeXR52kVIuuqg35tIoag4FnqywHJJyf+/jxpRU7HRTKnHJX1Mn89Scu7wHuMbFP5FiEteVT22z3XPSl/8vVpiQ99/h2Tj7Q7v6W5qD0jYfp4pOW4CgkzTWNZePdyv89XLwvX5zPwkzLsw/ZxOiau7Yi/xNXH0R9D/Dv2afBHXu9MbXF6P/CjrcP95DG4pizTxsTrjyqZPex34ubaxvLtC6cQd6v/8eeINFwzyzVtA8IrS0YuR9db+OY/kEP85Eq64vTecUxarhsbrGqgLor3iXHrhQvnx2c8z5Bn3fNTbb7YbcrIVXxU6FRPnPAFna2zmNqgY+NHhz44HfG6GEyZksu4RdlYZ2A+jzbI2pwFQt42UDIwNchrA6fsu8S/l4d0+4FsMAAzwGKI6Qdjq5CBo/QM2lb5CkqMXOT2V9ZlLzNxp9zb+Xj2Kq/y1lzz5zwk/+RpLrOiDEbbtWVpvynkUa6WbGln0rL8Tl0k7aS/l3KsgnLLgL65rUrv20RRKCPPiuMi1K893WLkmvdc3bp1e4tBZxHyaOmyWWHik+++Tvp6mtaV3305LVOCp+gblDfZE05cPX3aPfxlpkMfxnninIaB/CnbKYlPmc8L18Nv8st/0u/lyOA1CmbPvLyExJvnNsxLo0f7TZh58gsXJ43+GBJ2ngvOpYVl7XNKn9a8troIdSnsqmmlTaUckZlZcFyUN2GE5T/09xeRcGlzq4QhB0VHu+f6ut4ObUuYVcpROhz5Uga9fL28U7n9VtcpS+GlyW0nb/pTcSTd7YisfTvMtUUsutfnJX4SZ+65nnbVX5PfuHUhe9pB4nKMmzLvmeNP2WnL/fUpfZwJN03DdfJoL8mPuIP0uTt37o77CTrnTz/pDzyWUCdK1/PsT+NQjp4bM+0d+TXOEY8tJxIHv/rsNjNaX9v6ZO+e9uGYzfyQmeHNcV7+i+J9xHPtAzrZagKeHzMuzbqvtl7sNmXkKj4qDEBOnTr9auARlvWt/E4HUNvBvym5jBwMQDry3ejAxdv2f2kKzSD5eE3UBlH5MleS6tN0Ph2ki8NAK3/h3Ani81fSKAGLBmbiN/gzWKRsW5a2E9ShPMfgNT3P76G0WoCNWV9kauXTBs7tmN/t2JfNTpDH5tqgVXzq/sUL5T7f+PC2SNlsnSEXw1YzoLrfQ/6Eexu08vp5VAaihE1RTydPtuW20/Yc5m0YPG/ponz5y7wZl+rN776OWptpv/vzwH/ao3a/KmTnyN4bFlZBWpT9qcHKdc+zOKdl4p7nfJHhLwqccPPyGfr8YpqW64zZjtKa1sEyEq+0p/JPSfqOZE+Y/nrOMf3dQ8Y+zznP756U0zp1Ld2dtBFh1OcyRTf54vjlnIfpeyfnyV9+CyNvy9JaRG8gXTUsI5f6Em67uu7pjVzJZ/Lf57uXw3Vl2cu36LwndQ3lKg7pSn+ZzMJx/NgX79cV8hcZ9UEJ61p7dyweO/R5PuQ9PoTtrzHeCBvDc+RO3D2upQ3xp19qM5vmpx2EU5+OeZacy89YZkNcT588HcqtGXYs2W9jjjbekBaXcNJXBmRf1B75SzmnzXNThBVH7idPbQzV0rh925LGzY8OyItZ7uJt+1G2tiYvIfElbeHFbVsK/mLkanE0Q7P8is+7yTWySctegonDNTKAXPFXFO8zeVasoPGhh6APoh/dvXt3bP9FsduUkav4aNDRGoAwchm4rTN2yF/ZViEDGoMXih5jzjrK3nZ4WWSANw4iXxr0t8GrAVEbFLX8NX8GrU0JbHK0jGdWkzgM+gyEM/DcCeKLEkAmaU5fXPnLJRl9BTCD291CXrjUtXrL794IhpQVFzly3gxfW53r80ha/jolf9Lkvw1822bT74qUB9cbs7ShlMsykmd+lzGvnFqZbsowz4g2D3HE0EUxUhc9fp8+fXKMq9XV/HqZcvXqtVcyBnFQNHzhJ8pFk3v1NimceKZK4zLy/EpnkeFpEdKaZ7ByPfU0zYN7nu1FCrP7yX8U1WVl0PtPHfDvun6EHE2hXN2wK6x2yX/q1LXtjslz0keOSbs/5pwf557PXNsO8mHdNtLa/+r7a4F8wvRlm+uYXov/lAekpw5SnotIWHGumzdGTemsE04Yftu7Yv67MXlDzrVh6fRlknu9/8jhyCVv6/TFwiDpSNsx77jEPYU/YT2fP/z44+xl174cEk5/uEl7bizjsZl58miGA2NHDC3LuHDx4qhEti+Vtuf4xyH9Z8Nz+OUXX4zxJ+08nz3i90yTnSHm6rVrY70uT7Xl94svv5wd3qibxO+ckU9c9+/dnz1/MaQ35P/Q8J5U/77IKq/xKxwZ8qx8//33swe2Ndi4vpWhPjbiyUc6yDEPcUM5XL9+Y8y3/v7ihQujbL6iqK74EwcDlz9Q2v7g2vX5ZUAeMuqHjx71oY5jo9yMXDKpHMUl7PXr10f5Ll66NLSFl+P2DtKTX39gyWz/23dujx/usFcR/za/t4Ry+v4rivcNz4O2rn9Lv6oP9YdHW5esOwYqilWprysWHw0ZPPkrWwZNr42dlvD6QGs+DEa+uCOtVZbxrUuUyzYoNGvlSafIbCo7psDz67cXivvKIINwYV0TTwvflAH+V81rD+OO8Ik/xp5xZLshVwayBofO11E6VkGc8sRFGTHQjLHJNa7JRZFpbYIhkNxxbZCafTU2DWdo5TOevcqz+rbEwcwog+N8/bDVyduDbGRqxqyWJ8Y3Co4y36yb1QxOy/woQuWYMk1Zcwbt8u8aJx7pOqbskfM+nfhV/jHE9vfJrrzTdlel/VV+axjxqvsYZpLOOvEm3Dp1zb9wnLKb4v4il/tTGXNP2U1lcU9awszLm/vCRKZlJB3xpH8JzqdpJb3cW+aSds7lZZ6LnBy/PdJTpvKTtpn2mevJK1xblciJ5GsVIue0XpA4F7mE5fq8+x0Z+nLmJ7gmze1kTfx9nD25Nw9toE9/FZKPyNan37vkM3nOb+QovHj6uo2LXCkT11YlMiBxTWWYR/wwpvzww4+zh48ejTOGuIePHs7u3rs3fv3055e+XPp0NAT5gqn22ZZOtw9x6Ptu3LgxGqoog4xE8T/PCctgH/mUx7fffje7efPm7Py5ZjgJ/EzbvTCR3XYC3373Xdvb8Pmz8auv89Lk9Pf5qimSvjBkv3bt2uzRw0djPJzxinERY0+b7d72J4wTlvtmkH0MO/hTln3efVGWcqwcvWfkWx8u3JTEd2/Iy/fffze7ffv2kM6nswvnz49p98sHpZ/3pTr5ThncuTMayPoykIfHQx4YyMilfZ082f7wwonfkRHtz//2zeyT4Z3sY0fakPJK2UvfePTJkNYPP/40xPlorEfpay/8kaso3lc8U55PM7jSR3gOtO8HD9rzWxR7Rc3kKj4aKPnHjh0fOt2tA6E2EN74sYRpuHkY2DSDx7Fx8GSAttsYrGawbkBmRtR2kEc+vVAc4S+IMZD1+CunQZu8BGH63+tggJo9qaRFKWr7UHw67jsxTf9tI1/TGU6O7XxT0YFyUPbZ5N4tL25+20C8GXZSxm8TMsQ45+j3bqDeID51xbUyYMBaPlNHWRrER3HjV3zag7LzjHhetOl57Us60+WL5DBL0u91y7n9dXxzBoM0KRS+ttUbbNZpk+QRTnmsinJJHVGSpvkQH8dfjoFf5cI578Pyqz3OKxtpxf/0nvh7h1a/r+cpsiUd9GXgqEyVofvtOWnl6ih+x7j++jx6efs8T926ZMCdPKxCL+e6bUS4aVp9OSRux5B8KdecL8qrcO3535zR0tfBMpKm8H1agfxI+fd4doVxb7t0Ahmllb4k+Y8c0uCSXtwyOZYhLf7XqTOyTOvab7I7ik/ZTuNMHfwy3Pf+z3JFMjNwXb16dfZkeO/+3d//3ezo8JwkDXnz3DhGVkaqn376aXZi6O++/urrIe7Ffbp6EDblSLZ//Kd/GmeC/cf/8O9fGVk4afb9IIQhuzgYgv75X/7HGOflzy6NM8QWIS79u/DidpTv777/YXb9+rXRkPX5lStjHJ8Mfhm8zFC7dv367MQQ7ve//91r8ZPj//lv/32Ug4HOPj7eI0HZKEv3jX8YmP73//gfXuV/Hn/6059m3373/fguYeD6wx/+epSNsYxRzx9BlK9ryoqM//zP/zI7PNSJMjh79uyYP6hbSzAZEG+NRrMDs7/7278dx07eianTe/fuzv5piMPsrD/89V8PbaC1iYzDMpPLjLU//enP47W/GMrDDLdbt26N/momV/E+Y2ak50lfEsx49OwydBXFXlIzuYqPhjaI3BwoBYOiuGVsdx9t+nr7i6LBVwZFu4mBsHgNmg2mGAG2gxJi4Mgo5hxtpgwlY6uMBlbKStzJs6P0/HXZea6vgrik6yVntpMZZuKhCDAuJS/vksigbCgHr/5yPLyMGWJcU85NzjajQp6UqTJkLPTCflv5UP7KT1tQroyGnPZHpgyy10E7MEC31FT8yiJLOWKkbMpsU2QoBK1ej4xyqFu/HaMskZFcUE7+gu+IlGeOZJ7K3dqaY5PP3mnSS7mvg83oyT99Jv0mo7TS5tepx4SZxruMpJX8pqxSbr0cHLnlN869eWm6tqhsxJm24RgnPUhHuKQlLjL1cbnGv3BR1DhhHV2Pn8gijrik1+cRwkonjgyc5zDnkStlkrR3SspeXOuQ/K0ajn9pJc8pk74MkpfkMc41flxfhaTTk7JaBbItype4MY1LepG/v9fnmxN3XO5Ji+vzHBe5p3Fy6K9vR2RfF+EiJ6QZuVxPXtDnM3IeGfpjfXLrH4+N+TL7SF/K6JEZSJw2Ic7ky1H/azbQyZOnZl999dvRj/ji0v87Tx6TNjnNBPMOu3L58phWT19+wpJdOOfeZf4goC8/f/78aODp0+0dmXrkkYHop5+ujrOS/t3f//1oxOLPnmExIjlnwCOn/jdKcGRgBHs2vIMtcbpy5fKrfHLyIg5GMu9pBi/GIn5SDj38kIdxSrpklI641Zd+xliEbPZnFIcwjFhHpXX+3FgHmbktL5R3fxxhuGOQej70h1988fkgn35OWbZ0b9y4Ocp74cKFocw3lxBDPMak0rcBPsx4Ua81k6t43/FMevb7vse4wTPh2SiKvWZnb/6ieM/IwG8vaYOfNsBtf4FbT3laFfEmP4xFq5LBlT0k2m9fHWqK1hQD4zYradMIxl8/MCaHOPpr27NpHIHyajPf2p4a82R51zCsUDKVn3qldPhrbP4CzMDl3l6irtuA+MirgTjFwG9luU65qS/twF+u1THDk+Uw8iJfrre2tWncUNd+aw/y2oyAbb+5cenGWCaPX5UF/5SHGJWlqU0pR3FTFvrnQzsy6JmnzEepkE9hnz3bWVmTa15bJYe6lD/xc+sgTm5aB4nL9eQhrleOkfbFOefIk7inJL1FsronjaRHMYx/+Z2mN00r564LS/7kQxzCTeFfXIkjsiW9Pk3Pkfp21JZ6OThhEs9ekTwuKsNFTP37zaXM+3LnUmbylLLo88wty+868iVPIbKtijzMY145+R3/8pg2HsNHn2912te/88g5lXkZ8bdOnrDTcPGfvCaffTmlziGffR65Re1ZnK6lfByxrCziPy7h4nJ/WRxwvy8Lv6fXpiTuRS5patsMNKKyX5a24F4vKy5cuDg7cfLk6H86XmpxbeRhiIghaZq+376AeGp4F5Lbu6e/18MIJh3KNqX702EMwtjIr7Bmgpk9ZSwylyE+4wDvxva+ezL2X+Q6MbyHzSy2FFW6SXssS26CSzGWFcWHCoNzlt4Gz5s/Nuofi+JtsLpmVBTvMQaliwbwu0Ub2Le/Epr9sxfIQz+Ik9aq8NuMVmbDtM2CM2ifwq9BYdv4dDONfrPc+CGLwbyBqqP4F9HGfZvKkSOliDwGoG3T1+PjYFN5Zm+Ld0kGrvIlz60c26byjDPOUx+7hUFwDICMWQxbyocxkOEoipX6UD7zyigyN1nbzLRNY9TjURFxzb0oZa1ttYH/1ICacki8fXmkTBy1feKQX/26Js0M7MXdZmVtlpm4lCeZtKP+HoSTb/nXHsXp2nbPtHwxYNlbpuXt9XpyTTm4vy4pd0fy9AaOVj9NRo6fuJBwvb/ef3DuWtJIGC7pJc3EOY1r+jvEPyd8XO/Xb/Hzk7jiL+H6NIOynZZ5/9t5yj0yTF1Iuq4l7T7vyb/7kbuXc+oS/7x7vevjStyOSTPx8JP8zHPJ97zrcbtBHw+Z1mEadprvKa71+XBMfzC9PnU7QVzSXDdfSW9RuGle1XvqNtcSVlzyp2/h/O7LJ/nvy6Ev1yl9+eR8Xci2alj+uL4c+/zn2jokTui/7WF14IBZWyfHssm93p9329dffTXOfmJkSvnNpQuHxLNpLPp19nJjnNKXJRxvU6yH95OZJZYOHjt6bHZ//KPO4/G+up7+sWhMY+Mc3lmpd3t4OVdSBzfaSdpCz7QkFa0vYx854j1uRnIZuooPC/2HMb2Zltp4ninPhtmKxnh5Notir1nyVimKDwcdrYHrXpH4DWIYPgyA9gKDqQykvEymg6rt4J8xojc4kHkebUC31YgjnxkEuyY+v/lthhQbrjOOxWiy2stMvIwiXo5ejM05by4KrCUFHyLKUH0YaG8tg82yUD6ps3moiwzClb96GBWOV8fUTTNq8csJ1w86UsY7HYioc/XJibvJ0vYW6Y2kU6SnvfHrOEXelYXyEecgabuxAHnMLDMDq2Uw6Ek/rqc9I5tKIEcWznnqY1oviacPPw/XE2fiT7x9OMekm+u9DPmNxIE+T/zkXu+macfx34cLuR95ct77mTJN2++4PnzO+/imfnv/867FJcz0Opd4+2tJt3euJ54wbSP5nbLOs5XnK89YH8c6rBou6fdMZZ+S+ymTlEOux8nDlD499+fleSoPcj1xvy1Sl47J57y8LiJyJ58x7Ccviav3y21H729ZGHEnD4vO59Oux2/8x+XefF4Pu8jh541yMcbw3sLUT2BwsozPvlcL2SiKPo7EIx3vC3g35HrKkOPnwcOHo0Hp+DF7YJ0ejWreD/fu3Rv9JJyj36+19THN1n6MQ2IE5d/XM7WBNj7ZzJ94etzTPry//LHGH63MRNsMs307KYr9TNo4Y7I/zjqH58MYzB8c81wWxdug9uQqPnh0vAYW3JvQD2Cm+KskA4XOnCFhrzpxeTAAM4AkjgHc+rSXTCuPzKp5fVCGDPY2/2K6iby6byDLKMH53TtMi21ZOcL9DCYNJJuBy1/XNxXOzGAi/zbR7UuSB2Xa8tn2S1MnMeS4nvz2pJ4cU87agUG7OohRqRmzsmSGv1bvSVOdtvjH6Eb8Tpk/fryz2U3aA/nJLW1fqZKu9qK+pAtptbY4/nyFNPkl5zT/zsnGmHro0PK/gse4t6ph1CbAvaLiGBc5HHsXck8dpE44+e7Db86ga0s9lY1ZZL7cNRoehzBST94Td5+2c4NFMxPsLwPpcHBfuUunzdx7NHs8prm5wb14pMFvjvHfDNVb3Sjj4DZ/K9e2VCsyyW/LX/tanPjannba4hBuaI/ZhLvPC8jAKQf78JhxemijDYk3/iOr9kEeS2zH8hzCKQ/3+OEX+S3fLX9tpmCfj/4YJ/0h8EYfuUlfzuRKH5jruTePyNKeg9URbru4e1JWoQ/ruvh6l2sJl9/IUXhyT2VI3MLkfFXyrAmjDFdlUVri6l3yETevXfida4EscaGv5ym5nvxEPjjmGqcN3r17d+ybv/rtb8d78Ye01cRhBqpn3bvh1MmT43Pd+vNNIxs37bcS/nr25LpyeXbs6ObGz/wI0xMZ3COnPbkOHWx7KpKrTzdOmKQd55mMMnv58uWFz1BfvsL1+H392vXxq4P6ZbO7UydxnlN7f90a5MTvvv7dWE7o82JZoq9c2uvq0qVLY37ILpx4GNnkz3ny5Fx/rAzEeXKcSe2jRXk/escdGt+1N2/dGpdg2bfsiy++GNOMjPoo+w8pA4a1FnfLf5w0nwz95u07d2cHhrCZAaMOmjxjVopi3+M5snTXPn55pj0HxgXp94ribVJfVyw+eHS2lsNx22EAMg/9dTrtedjPwe0oS3uFwV5TMNsgPQPPndAMKc1QIJ42O+Z1pGUgax+oHv4NBMlkIO1lZhBILmXBsGITcwqjAaE4cv9NkecM8MXv+L6Q8lT2zYC3qaBsh0Gx/CrXVgabysaqZGZc6iV1Lx71056VI+NXudaJN+TrnAxsBvnaSI+8NkVB2m3G2SLEpXymkNVzkPbr9yK0S0oXA0cUi3lcvHhhzDvZlQM5hU2Y/nyKMOScPvvicI8j47/8y/8YZw+8Ju9Q/Z5HXxLLRs/ik2bSjUyMRf/jf7Qvn1nuY0YAP2M0w33u6tVr48bNFE4yWYL6qc/mDwqdzZZ98p8i1fPP//IvsztDna/6LP3ud78blxrJGyic33733ez+vfvj7yn2r7FRs02w7Ysjv8lf+gXhKYz+Evz1118PMjfDoftx8qNtXrt2bVAMtdG2/xtl+NKQr88++2w8F2/Kwwbe33///bhB9CrY5+fyEA+lNf1MEB9ZI/uqkJ2c6wz0pSVc2t928J8+JZA9YROf47RNO3cPq6YXpKlNrxNG/UtvWr7bIW/kmz5D8tS75HOK9pQ8b4c4OPnaLm/ahHKQJr/ScRTePc4Xxf78b/829kf/r//j/xjvJS+OyRu/rn3zzbezH374YZzpZH+rKdI6NPThX3z++dgPBNeV6X//x38cn5X/+B//w9i3JC1yKX9tMeUgjPQjpy8LHhjOGWc8h1PIbkzgeRMG4rg6PJeeTen74qDw0vM7f3jpGYKMsvdtVtz/7b/999mt27fGfX0unL8wXNusS+M0s7P0bwzn54c+TVrS4UAWedOn+HKhjf4Z+/R7wv7P//k/RwPYf/7P/3ncwN57iGGJPPoPfxzwhUl7bvm6o74ziFteGBF//PGn8T33N3/zh9mXQ38hzdS9+P/xn/55/IpmGyO+3h7xYqiTu0Nfpk//y7/4/ei3vq5YvE9o256ty5c/G/vB4JmyTJGhqyjeNjWTq/jg0eFyGYhNMcYzMNkY681FB75gfDIM0No+SQYkz5/v/v5MPYwPBosMSGQyA2gdBaHHYNcsF3tEDDncNh4Ghb4M24Cy7WehbAz6OOVgwGigx5DCn4GtawwTXnrN+CG9xcrIMoQxKDZQVybqwO9m9Ghx7WU9rANZlZEBLIOgvySTOW1yWd7lQT0pU0Yae4g478t2HZQReaJwqJOXL83qa5vaa8dZUshwuS7+iidfkXmR4dR9MkiTgqMtzKsvcWTGW19Orf6bMSrhFtW3cNJpypYye90oKP5+er37yicKIbcofkiDm9aHa2Tk3Pvm22/GeNrHA06PytSxwfkK2/OhThl4fBHN5+kZ+JRlEAdeDHJ9Oyi/Q481GsQ8A5CWMv3Xf/1foyJN+TszpPHZpUujgqacGYV++PHH2b1B+aI0RvEik+dSX8DfKNdwtEGzTZt9XSzyxh0Y6oWxKnJRHK9fvz7ORmNs6v36Qpm+ytfKrl67PpatZ9YzEcTTZkXcmh389OBodHSNbOrFOUPaH//1X2d/+vOfxvYvb2MZDO1Wn3JtiFv5kVWdC5NyUb6HDx3eIpd9fPRJDFr99aNH2pfcKNip/yC+1Ou0vpchjOdvu362RxikHOYRWbiUExfcFzb5kD43r20nLr8XpTcP7XTdMJFTmFXLkXzJoyOXfrTPsziTx7iUpfNVSZiU4TLcTzqRLWGSV8/Ysplcfse5xu+t27fHtq39mtkkjrinz/TRn4zPpz4kCE+Wza8rfjY+a+KM0xb7shCml5OR3IxMszCl36fLKd/jw3PtWUvZi+Pho0ejgUid6gc8R9KzB9aPP/009IHfjnJxvq4oHYa6sb/p4mEs8wcB7z3GLIoyZ3+tn65eHWXyvvn6669mv/v66zGNtGXyiMN78s9//rfRwP7b3/5m7HddTxrffff9aDzUV7RnoY2J9FXC3vQVuKGM5Unf4o8H3E9Xfxrz4o8CR4Z3ORl++5vfjGlT5o2LWvrPB/+DrEMc6lxdTOuQE8Z971/9GXlcVz9DlEWx7zG+svxY2w3adXuGy8BVvBtqJlfxwaPzNaDL4KbHoGSVQUT/V8QecZqdwOikI2+Dkr15pKTFOJJZNwb3BpAGlDtFnAwcbUC2eFaY+ww0/QuMfwNBxoEYXxblXfjpvZZ223TegNmg1eC0KQibSkwG0NvRx+9cXgxcYwwy46Pfe2mvILP2FvkZY+Q19OeLaPXQBslNKU0e3kzuKDoG1Imrl0dbiOHB7Jd1kFeGGWRZ2DJ51Sulw2BeuhQDcslnD/m0e3L1bUHU4m/O3l/bz5Dhl+LIsNHLxuCin9AepScd5b4qabfC9PGKK+3Avf/f//l/jm3j8yufzz777NJ4n5N3s/MYuRiCGKG+/PKL2V/95V+O5aE9JO/K6//8v/7r+Nz9zR/+MBpipCl+Mwf+23//x/Ha73/39Vi+fZkpI/F7jhmoUteQhnjIA34pgf/2zTfjLAlGp6nRjUt+zWr405/+NJx9MvtP/+l/H/Ns+Q344cj3x3/9X7NfhrR+MyiF8hj5HP/XEP7HH3+cnT1zdva3f/s3Yxzy76h//XZQkBnSTg+y//53vxvzFyzJFHZcmnT27Ozv//7vxnyKVxzT54fB7Kefro5lbZaHGW5TUm99v5g6c0//tyrkUH6ei3WQlnCRIelzSNkmb65rx0G+yTnN/zyEjfGD/1WRnnJaJ4x0uMjXy5b8KbOco/fjvK+XKdO8qi/xkHNVejlWDcdv6hopd9e2m8nltzJpcprJ9c1oJGnt/evx3iDVaOAO/FqK2JeHeMj7j//0T20m13/49+MyOH7Iw6mz6XtA/MppnMllFtPwzjdTy8xS96fI48HBv/jc56YzufKMSssznPeCvbt+HJ5VM1PN2jQD5PBGmZH///5//tv4jHqWzaTyjsCdu/dmf/7zn0ejmBlsZpOm/ck/GYR3TsH+f/7bf5/95ssvZ7/96rfjjC2Qlyz/7//P/3c0xP3lX/7FmJeUh37DuOqf/vmfR/+nTp4ajVlhyOns4KGDY3z6Wv2ocvNuUZz5o5vf+mNjRMspxzjG4t6sP7LcGfzpa4X5i9//bjQc1kyu4n3BM27s55lMP6HtGmv4Q6o2XhTvgtW0x6J4j9HnzhugGcxsjO92hIEU5dtRh56B6l7BWNL2VmovjCjGbeC7HgZk/mpoMGZwl9/ysojpi0qRxvg3VVKmGIQaCLaZVg3+Uy/NAPVyjEdZMngxnD140JYkGHD6K6hB6KJyFlecfMiXdOWRQcCL2DIoSyw4fwU2iPdiVo8G0Rnkz2sv8+DPX32VnbgMTsXbZqmYrbW5Z1HcPJStQTrnnBFGng0QZFVe5IFDi3c1GYOBu3KbzppyHgcyKuN1EEb+HdXfvPag/iM3f2lrypxM8q2+lGWPeJQD447yCYpSXAyi4lrlOZDuyUFhUT89Zu8IL61etlVJ+a0STvyeg1FBHNJ0bG3oyOzSJcvtLo2zMu7euTuWZeIVLm4e6sxMLeV08cL5sb2LW1hOu9bWKYxZrihu5c7xwz9/zs3qSlpmbeVe7jsKN0UYcVNYk8cW38FRWb544cKoIFIyPeeL8hOSZ/3AvfsPhjwcH2dNUC57WSicnw9KL6Wc0kjBnSrx8UsWxyTdX+P44+Qv4UN+u78uwi7Kb+TbbBOt/0r5JRyZ1HX6C87vXJ/KKxw3vT6PyJe0ViXtYLtw7stLyjhpJc/ym3bm+rK8gryL3JRcW6feEma7fPWQjdMHIvmdF4dr7if/KZPw6v4QnhF+fK70kZ3zG/PqfhHiJeM8mXqkLQ1GtD7NOPdT3q/K95Ph2Rncr8P4RH3BPWXQZnucn50f+gDP6TgmUDaDH66Pi2iM5PpmRiLPu/BmpYlD3A8fPtjSFuQnjvHMLDj1YKbns413qn6nvVufjfGaYabPFD59QMrFUX+jX2aIszyc++qr346GMzNk1Yk0/FHIGCV1aUbYEOUYhzjHscaQX+MM5SbH/AhvRpxwRfG+YUxhXO1ZznOjL7KfYBm4infN+qO0oniPMLhow6ettIHUxo8VyMAr6MwpqgaYGXz39/eClpc28MzgktFru8ERWfmPEsGJq4X3VcS2Ybm4omDMY5q9xIvtXmTuc59+2gxCBw60NNo7cWtdJF9RbshGRgprDGAGpY5eogaYiwb4kVGeOGWVQWjKgjPQ9FlvL2oGEC/u5tqnvpu/prA7Jkzuxw9jBT/Skja3COVBdgatGHlafbQ8JV9cW2ZnEN6MXU3OY2O6y+ospM1Ig0FxMU1e/tZB3GmHi/7yLA/8kVcbcIwRwnVl1eqwfZUrbQTk0QbUv/KYIrwycNwOdURxoTwJoz7J0tfVsnpbBNnXDZc2m6M2NC6XG+p23IR9cOJcJd60J0ftI2Uhbq7VffvghHw7b21r03Ce31Ok3scTl2tcD/+RufcjXcY3/cDPG/v1rYrn3ZfMtHvKrvz1svhNWfxsUEgpxK4FacdfZJmH6ymDHBf5XZekm7bKpT9y7roy4yfpRuaEn17P77jQny+q091EeqnvtNfkM3n0jHH57X78o89Tn6/pNUck3Dr0cq7DOmGmfv3u3TzIpZ4c57IR1n39dztuuI1yQY6rsopsyL0t6XJdveR+2rb3gP4dfRpjmxgcI/iY5+F+2v48Wjtqs9uce+eZlebcH8LMDkWfBnGMESjaZPIHA0sjv/32u3E2qP35/Pbe5c9yRH2nOL13NmVpBtjxXT/0qfrVOP2ouBm2GM7E097H81cNRDYoM/2Zd9pId68o3hf05/6o2483tO3795vhOH11UbwrttcIiuI9RieczjeMg7P1xoKj/+ba4M6AhMHBAMhg5W105vIh3c2lfH43pV0+m5GlKRIxtvSzk9oAblORMsBjJDIQjQP/0yV2ja2F1uJrhgjxLcMAMoZAYTKTJXWzLLx7yld4g8K2r5eBZfa02Pzym3S2kyXIn/TJkrJiXBkHtMfa7K8Yuhz7AW5/P4am5GUZBvUUe2XvyGWGGqWAkz/+IC/OmxGsGYnI2trfwUGWJmsG3a7Nk8O9ZihbrEilPLBOexZG/oWXD0qYttlk2TRUqbtm1Ngsd+nIn7Bc2tioCG3US7veZNJeR2MH5WiSjxZm61/iF6Gezebz13VGl6Tfu3Uhz8rhJmn0577cRaGyKb8leMmnY1zow41lupF3ZR1/82RSllwfn2N/fRHxt8xPzzSfvzCyDmHHGR8rzkaU1pin4dzzpu/t5Y1T92Z52CMnhrCpv2Vyuxf//XFV5C9O2hyZOOdwzP3ef5Be6yc2Zy5FrrhlTP30ca/Kdmn0cvf5yfPnGNf/7sthWrbJs+N2dfUmedpJ2D6M897JT+qYy3VIc15fFVyXT37icn34fzxfBf77dHOc4jp5+zpLneTamyC8vtX75uUvP4/9VyBjHHwN1X19gJmd0p9HZEpYvy0t1n973/sCor4h8nPa0cOHbW8wSrhw3httFtfjcezgXWJDeO3SLCz3GdOMnV7FNaa8WRPiSdvk30xzs8la2LavY/JBbG6KsN6Txiv6+JRHUbxPaO+2PDB+8gxB/+XZmvtxnaJ4B8x/qxTFBwKFKIMOY4k2UBp/7ogWduOvkUPHriM3WHpbA5XIbwC2aUjw103GmcxI2px51BTCKL7NQBBjEDIo5MTdZo40o4g8bge/q+a9H9wJR97NNNYvP+kqf3lhGMo+UK65l8FoL59Tv1eVuZWzum5GOTI7ptxXIemRqxnqzNBpXx1Uh4xCBruWnioHv6XbQ4ZmSGufd+fS7siivtoML3Uf+Tbr1sCdImCG3CIsnWjtwGBldSNXZCMLpYJBjnGLHIcPbzU6teelzVwbUhzLk5z2HlNXwvGvbFxPWSe8NNS1OKZ1C37jf54LzqVjxo+ZU1FqHDnx9v63I3Iknt4tw/2EdeTk+9MhDy9/fjl7viCf85CfzE6zF8yjQaFT3tiU5fVyiMzKXFqrQJ7EPQ/3IzeXNEflc1AMHVO32+VN2PHZGZ4P562O20y0qYN4bSSvbvmNHKuWI5b5T17ccx7XtyF14Ch95/md+MStvONi3OHcm5JrSXs7+jiS/qoI2+erd/IQJ85WF5t5dJ569Zs/4cQpj8mv9wC3rA1th3jXQdmnzrYj+e399te4lEGOcX73yHfSflOS7tRN5Znyy0baU3+pp2l9baX97sNNnevCyaO42h9Vfh2e9Qdjfbsev9AeLD/Wv41jlaHN5N4yhBPXuBfWyZPjhvKWJpvNlbw5PhvesY8ePRzbmOXZNp3vneWGcYzh3ltPhrFR/86Zh7TVp/eP2SrSaO+y2bhkazuEF9Y4TDxF8b6R54xuYblvnhVt27Nu7JE+ryjeNatpaUXxQWCguXH6BmQQx0BhsPK2YHiIstAMVm1GUwwe/nJpQ1sGFC8Y9/ylMTOF+peOQSkjBKMIxdgLK4jXi4xbBTKtA//k9RfVGFZ2A/kxs0p8ykg6GfRC/s1k2lQm37wxbPcil45BrbymXNugoBkd1Y84zN5xj8zqQ/uK3I6ZrSeMQTWn7RloW5KhDUhLOH9Za3uOnRxneXHKezsM8DnPyarKp/IlF/nIo0yFda7dOW9trO05kjxBXrVZhi31Jm354w4fPjKWl3NtUx602SBu9z0T0zrgj0yj8jQ46c5ToFzLs8x/4k/bWYe+rsQ5Tf81BpnJrXwif47i0LdQTFc1NgpLfst4zGS6cfPm7H/+zz+OG8HbqH1UKJ9vbpLOb5xyiCK6DsvKyIyJGDSUp3xqg76sdvPWzTHN7OOxarr8KWVlM8U98nDSisu1ZbKug7rh0p5Sx6ln5el+5Eh75lIW2M2ynsKv9HZKZEs+5SnPiWdRnTn6rZ27l3KR9ub7aXNZeZ9/5bJu/qcIv9M4yLkK/OUZcT6tZ8yr5+SRC+vkea6/X7fOeJ069OdTGMz1zdMwcK6eudfCb4jSX4+/3uV5gPZxcni2/QHDLKvvvv9+7KvBn3zYUP5f//iv4zWzQY5s9APb1at7ytzx3Lnzr/bm+v6H7zd8NFkfPzIWejQuX7Y5vT0I4y5durTFnTt3dqy3B8O71HE79KXXr98YDWPK1LNAjlVQDlyb0VwU7yfGe/YO7dHXt4/6vD2dqCi249N/+Id/+C8b50XxwWCg05TvrXvt7AYUbvEaXJk99LbIQLRXeOQtSl+uuxY3Tzkhu3icG2xlMN7H7dgrbIlL2J74Z8jZCQbCxrS9HOtCNoYURh2DzrapbFPoKdtkpmAlT5y8Jm+9M3h2nVuFqT/htQsKPSdPjG9w3QA31zOYb0pTG/wzRLQZV5tlof7kj3/GsoQLSbMtR2zLuhhH5DP1HX/TsD38x2+Uku2I4tdke/0rn8pU2ZullnYYgx6Fwn2yk7ltwtviQ+qsKR7tK6DjXk6Df/GIQ7uT12ag21S0nGtTBlzagkFZ8helHMpZfI6p/8BPfjsXJ5c2lLgSX+63/G4aWuC6+O0DI2z7QMHJV/G75lw8wjBW+yoa5YnfyAvy+oS+9CltykvccO3ChsLVBp33xk/ef/edvWi+m12/cX1QAB+/qgvxJmzSj/PboJUzoGU8lY/4I7Pf4dGgVFL+LFXwhTUGrW++2XDD+bfffTvKY4aVLyuSPfHBOeWXEqmvyn3wM35tbGiXDLg2sHetlz04n+dAbnE6ahvSsveZL6wxLsdv8sel35vmlz/pq4++DXFJbx7iSrtYlciNZXGD39anbBqFI9eU5DP++zYd53rimuZZW+eciyv3tpMxyFPqY50yWbUspqQcpZW0p/nPdX7FHydMX8+5voikxU/OzRbyfPgjhRlFuR8Xf0nblz/510Zv37o9fmlxkRtSHJ7pzT8GkPHGjZtjG9dP+tLZNIyvizreHdKQpmcc+g5fem1/oHk0N0yc5/LEyRNjn0JmWAboDxcPhn5M/3Pz5o3ZzcGffuH7776f/Tj0g/r1v/qrvxyNUPk6ZF8GN65fHzeP1/8xhKH3o/8aroz90/1792fnzp8br4nXl17lm9FfXxO5HJWL8Bxsbm926cvh+tGh/DIjayyD27fHfOmz/OFFv+wdLA5tht/pDK7ID3Eo92PHj42ySD/vB2hv3nlkNiNtkGr8mqR8CMvfhuhFsS/wnsy4I9CDvNs9G0Wxn9gcsRXFB0abHbI5GN6NwYKOncIMg5W3yXRwtog2AG+byLdBdDMUMPhwTfFvs4taubSBn8Fx4k5aKb9FJPybsfM4GDcMEinF6qPlieGo7ffE+YsuQ4j8KAezpwzclUP+oiqf8t/KqxmNKCKOnHgWEf9e9Jm9FKOLcO4zbPEzL5/N0CeO15U8A2n12GRfvJzMfQNjZSCP0iO/eMmjzZpNxYlvHuLgluW1J0qwvEpvTtZe0YxvvpCozBm0Wr6FD+RsRsDXl+g5FwfaHhCfjuUpjHhbXW5d/iHPyoRfdcPxL+6EnVcfgWzteW+Kf56FlKmyjkt8q5ZdzzIZVkH4Vj4tbTJ/+eWXs7/5w1/P/uZv/jAqkr///e9nV65cHuv32vVro+HpxqAIps7jluF+/5zIb4/79gRTP1cuX37lRgPS0BePiv2gcP7FIAtDXP98vCl9HsQb11/fDv6TN/5Tz+pWG0tdu5a65vdtQJZV8sBP8t7jurxpx9qzNuLZ4NK+Of7ki5Nv+fU8cimDvq33ded83bpMGOmukr+QdJaFcS91mnznOXbuKJ7kNfWc8+Qx+fz/s/ffC5Yb15rgmxK9KVaRLHr5YySdaTNPdp6hn+3e+1fPnXNnpnu658g7UqIplmGRFJ108UPkV3tlFLA3sDPLEh+5CkAgYrkIACvWDiDVP6RjlWnbt3lqkC9hIpGR832d6g/Jn5cuvTQmXw7BfThs0t61eOXy5VGffRhqD//t/Mo/2j03TGirbnNgQ3yJQHLqn/7xH09+/KMfDdf/8ydfD9e/Z9hTTz81Js1//rOfja8V6xNt+DvygWx+ev45f7XttHCAOqknxvM64qWXLo1JIeXGKJ70zwqr6JZ2VRYfSUC5R0HKnzz1gW96ua/5oabZZuX1U2M7ccc+uM4k5PN9wLMg51SWcTHUeWkYG+krapyqsmHDQwHj3f1L7Ba4Z7Y3SI77oXvDhnuJ7/zyl7/abqMbHjsIKPLrHwhczhswCPbGgOd0gm3CnoDufiGvnkUunUzm2UanOwHaEDSpK5jLyqCcq0hw2vhIpuxW8bSJgFf/WrCfVxsD7SSPBH8SScfg8uWXRt5tErUuaUhndvp4OD0kMaxmaiun2iuL7AYP55b4SgIrf0mpTTBaUmo3wbWyyhZs6ch9EobA9iSldivpGu/mZ7TjKwkz5X8+plf6qEeSUs4lgdYjfjAO1CFHG/3FHrLVsYKKPk33rMLYJYb4SFA+fvB88OUhmGCQw+dzuk2h+bclVFsftDFGp0wO6Ui/gF7K1bFlqzbq6JtmX7OZLxxDszUrutoqIMBnH7Rvvjj7elm/rYhd9EG1DOH1v//bv416+vPzb7zxxugzvMiK/+hphcSvf/PbMUH1zttvjzYHJnP/9v/7P8ax8dN//udxAqUtiv9ivzJyv3Z+2FpJ8t67741bE8B/+MmPR33UUVc77REbfvvb35389ne/O/kP/8u/jH/yn2+Vq29L78Arkl6PHKwe6wN++siKkj/88Y8nb7/91jjxbeNml0CIj349tH/vvfeGyeWVk5/97KdjGaj377/4xfhrMX/86Ec/vGOb9uRE9+wHfZ+ljlVj/srajZu3xgn3a69dHXlWvdJmDuxn36F6Fce0gYwRuk3ZWm3OuSC2KMt+yrOt5fxODnkpOwRjQ934bgnoaSzQy2RJ2yVQPzbGH6Gg2mOb89rFrlpnDmnHJ8ZbLUM5hioPyLLvvH26uvb+Nsh/6aXLpzx216nzuRacy31rv1+abPcDYyS6jLKGewW/zkPddv0l6Ql0ac/kJa+5e/W43VfJZG/6BvBB7XnpHFktyUqu+tqh+Em5j9LzyzODTexKPQh/ZXjzk1ceJQW1cTy2PbXJvrbahQ8Zxp5jP/6x2TOSH+HL4Rr9YuADdKY7Wc2u9rzx7OoR/dUj1w9qEma+O8affoizJVeMJk5Vd9R50Iu9jq2kS70NGx40xHvmP+1HxvbjpGvm+vUb4xjPvXHDhocJ9+dnyA0b7iMECC0QuVi4sUtoCJAkBxJw3U/U4PEQ4gfJl7lAiQ0J+gRkCc7AsWBOEmYKjb+A/rTgCETWMTy0bcmo747BoImj19kg9kD0bH3WbGyT9ZZI0VZiLxMKx5JO6rckXuNztw/bSg912wSlBdL2Mz7oo13s7EGPubFEz9jTdGl69DAm9JE6wB+OlWsjKZoVUuooF/hLaplspM/jpyVBdZMpmbRftyng33y0W5lGtkkDok8NmMiC+Fb/JMHYrsk2UcKPrXSJDY1v+yuU6g4lY/lS4IXIRvjO+afKRGtR20hKsTt9cwjqxE+BMjbrax9qtrLCqirJKhw/P13VmbqVel4Q2+OHQP0Kxya9km+2JnGvvPLyqINXi/IaDsz58m6c6jTKb217fdGoy0DGSB1bFWnTy459lQ6h570U0WEKOYfYZAzox7qfcT91jHre4ccnGc8Z266pukWxfYkPgjV1g+rnXmeI3mPfd9AufT7VNoiM2Jbx24/jisovdaJH5M3JjLzIqGX6xoqd9gMcvo03vulj9QL3aCuBJKTnyXf4Xh4noXSKLLxcg9NtGvkrhbb0cZ8I6HKobYh+ZEFkV9/SSx1JZK85jfeCYaLMF7VuKLCyysomPqi+rnWVO08P9xfH0T021foQH0WuY/qonwQXWHVH9/yYw0bbPDenElzgOvKsRWSM39gc2inPsz5/XIZ+0fm5554fbXasbvTdsOFBQwzlx2Rj2VgNJLc8z43XDRseRtwdOWzY8IhDkJDvIF0UBpbDDf7ZMdARqJhQPwhIYCxH+/U5q48OQfDlYSWA40PHgvB9H4ff1TsO4bs2oFOdbYJOk15JHL+2ehgneRX4FRisUFLPBNiDWt06IWRHS5S0ADWkjF8EtdohPAW7ttq1JJlfq3crS4wVbRA5VZYtPg7rpLICf0k8POfGm/bk6CN18DH2n3yy/UIt6ROw2x8lsCWTPoIWCaDmi9bPEnuHQDeJNHzmdFsCbXerz9orRfFVs6slv1I30C+tT3YfvldX+eeft1UD1afqmMBk1V364aJhLETvpah6Nv9/c/LV0Ed8kIlrYH/qmMyMTft40gWvUHQTrD4z9LkySa7KI36fQ9UVclx16kGnF1+8NE5wrRD8+OOPxz6PzH1tA/02julh35g2FqrOIRB0v//+++MfZTBGINe24/jiIrBE9x5kaxf9Q9UOPjNm3V9C6qTcVj1lS6Gv+CBUfdH7Q92+rw8h9dfoFEz5o6eKftyxI/fJKfuqLfbDc05m9Am0ib8R4NvL7X0av2qfuqEcq0NW+j2y077ysx+qvMKnLztEldc+3pX6OnN213o5Fz/U44DNjpVXOakXnlWmbepBrVOpl1Xl1PIK+niONN6t/117c/XBs9WrW/7aI/JpBN8GQ1a77xICLUb1/DWe6OLZpU6++0XuPlkbNtwPePZKGiPjPxDvWg0trt6w4WHF+mhkw4aHHIKGZ5/d/SJ3ERDgmGi0gOrB/co2xF0jLUML5JaiBVrtr9lFhoSH8rnVXLA0idZDEHk8MlFpK5j0x7PPtv7JKp+APR7ISd6oY3KfPp3SQ3JBOw/19qpCC3it2uIP8tJuyseZhJrMkyWgzUQVbKPX1Fjajbf9qwbVk0QT7AdJWE0lY60Mw1OyIYE0PfySTd6+VX9B0735Tfs53daAnq0frX777uD/lkAEx1zd65V+JF9ddsOXX07/iXZ16By6F1jri+iS8YT4woemrSTwAedgTue5csg5/M/4b9gdSmxGZFzyWfr0wDAYcWis5Lzx/8Ybr4995OP0JnuwT/cK9fCwNZHkI/uh2Kf82kfXTn75q1+Pk8x+/F80jhn79ORv1y6qySzXYhvLu+9HsW8N8G/9t6ADLxDnkcdGvmBztT+2G5NTINO5NbLV5dfaB2SRGbnKer/zqevj7DVyePxnfGqjbbvXteQMHtlCxoM2ytRrP060H1zsh8Jnil8va45iC+rL63El5yInx+ETf9imTnjl2BZB/K7P2d77yVZZytMux6mLIO1CjtMufBDYVhlTEPc4FxmRPwd/LMRzNc9X96CbNxtJXnkuecZ53voOGH6xwz3x008lyD4Ztr4jOj3mN2y4X3Af8kyyEtO1GhibfqwSE4sZN2x4WLEluTZsOADBsF/cBDsCTZPxB4UWrJ0eLECf8FkCAZq/JCToTADoQTcNK5KOWzWXSUQLMJcb5aEqWdMmA5Ia/npemxg0fXcTBqtWBIx9EOtYUCnItcKHfdpr4xcr5wSlU+S7QIhcQbD2sQXst1cZEpibVJk07c5L3OT1xh7attcmjLe28moO/CD4YAdYYcUXSchV0MFYJjNBu3YScdGDPRJYeExBe39Nig0C9si9CGSSg69fwOlHVhJ9c+Cf9g0xr8m9OPpDmUmGJGIF/Z23PQQ+qf26FEt4QxsnTZ8c+8Xft62Ms0unf4GRX9Sb0oW/kHP6wl8y+5//8/8ZfRj+2pNhy6aPr18fvwtkzHt1KuPhmElVf131cB5/8r0O9Oorr47f2rn28bWTTz/77I6OU7blXGz0AW7J51uf3Dp59733Rn2dDzn2y/Lvfv/74f711Pgqlush7Q9hSodDyBjp2zrm70zg6eEZgvhdeWhf/86BPezV5231oj964Y8rfDZu9b/z1W78yemhLHoEaTdVfw772igzBqo/4gd6aYtct3RPQifjstpxHkROdMzYJ6smkvjVuYo1OrApYyDjgL0hPogO7IvsOp7W2jw3FveBjDX14ZAc5bG52p17UNrxex2rU/zSX87tG4vx1ZxOPWo9evR9HfQ6z4H+773355HPvn67cuXy+Lq4uKTK9M3ClpR/cLHlhg0VxrxV/v6wg2sgcL0ar541GzY87FgewWzY8AjgUDC0FvhZfWDSlGDsQcKEX7x1IOY6xbo/yx4I+vgQJcATkPkoa4VgTqKGb/IXVw4FgxWSOY03PssJBJ/afv21X4W/GSaPz479kwCzvSJo4rv71XgK/CNBQu1MQE1y9rUB58kzGTJhEbQG/ABWxdHR8VdftVcEBQ0tEWM83f3XaOiNn8lBm+TN9x8fQJJZ2uKvTZuknW373HPPjHrrX6CbPja58uuxxJJ9sunY/sjCbjVF061NhrlZQM6/FwE+av21S87Zp2+2+6Df+evTTyVo28QqiUTtK9jDhvhvDnjG9osEPf3J/j//5S/jn7q3ssnH1v/9339x8v/8P/8+JqpcT2+99daoA/3jA8cZ4wEdkb6QHPOq3n/7b//95Fe/+tX4p/r94orI+7//x/8YP2pvpdyrr746+mmK51JoF/lToHP6Tp133nl7/D7N+Gf/h0mdMmNwrj1EP3804PXXro7jk7/Y8v77H4x/5p9Nv/nNb09+97vfD3X/dvKjH/5wTKSEr63+1jb3tH0y9yFtc48MX74kUyLO1nXsHHnqrQF7M/Zdr67LjAHXtntPuz/sXsVCFf0xTNmsHt6xJ2VrEb9MyYDISWKO/vZj11ofwTF6BnN+m4N61Tb78VkdA7XfQTt2sjdU7Y4ejp2LPuEz5885rKkfm9a0mbKbrnluxW52xSZkrDqO3bHTNvu9Hjm3T7/ank776la5EFsqjx77nhWuQ/fWjz66dloyDTyuXn11vDcEdPFjmfu98bBhw8MC14V7mRjB9RG0WPHWluDa8MjgiX/913/9L6f7GzY88hCMCCTqjfk8ELQ1ft8ZV4bMBUL3CybuQA26eBhJbNRvLwH7JQ78UnqMztq0RFGW65sEtYliIGhtq4C+GctD0e0QrEKiIz7tVbVlerLZJJ2NAmbbTBpynh50r5OGOTRb20QUDc0XBZ3aYU2eAD/7/NQC/DZxEyy0IH/3azVdpxJYfOIDtHjXFVZTMDbV47/mk+dGu/PNomp3vlmVCcZOr53f1JdElCTgD6u6tGsTlzahMXnXVoKul3Ee6E+sWuKs6cOn9GHfUsQGbqYvXfkj9getn9vkbs4G59Rba2O7BtpqEWMQ4cXvH37w4aiPFXqSiuOqwJs3T24O5FrVxp/Nf/OtN4dt+6tb2uEXfY2bj659NP41MUGopFHkjQnWwcxvhmvS913wTZLLPt9aHSaB5htZ/jQ+/r0MNHizBbSffjpO0PL9GPUQqMc+8CH7W4NNXrN8++23T3mc9aM+ZbdvjjmbZFBkjx+mHyaOzz//wsmrr7wytkv/N/ueOXl6oEHDMdC2cgvdHPzIf86zjXzjFvCOfZGDXF95LciHqyV1+3pkIn0aYm+2OR8K757mEN3ogNhatzlX9bGv7BDUzdgD27m2yoFdQeTRIUhZeMcXKUPQywh/qPuAZ/iuudYh8nqe+0AWvePXOVRbe7trOR4hvsoYyjZ1INt9oFcvW7tDbdNmSd0K9sChfg5VnaqtocgPBVW3Wg7RYWpsRh5UHXtk7EaHHrGptwOik+NalmOUOoF7B/LMmtPLPciH9q3Mdp8Lb88A92NxwaFxuGHD/YZY0h+q8czfjdn2Y6gf0vZdhxs2PEzYklwbHisIdEx0LgKCIJNGK0MEMgKSBw0JlCFcG4KiXRAmeOp1o7tXDv3SeAzaQ+xsICvRkYkjmJDg31ZX9ZP6NvnY9zDUV3Tn26VJLva2Pm6rpbKSqCal6EgXsqeC5h7Rmw2pT8YSfVJHe0khySFJCN9t47/mr5aoaT5swfyUvfRQ33ibSlRV0I8v2Ii0kyiyr21vt3NkKtcu/dQn88Qz9FBP8jL1QuSChMK+vl2DjAM+ip/oKHkrCbdWzs5nLTgD40Q52/AGW8dB7+ucVz53Llu+qceQNspCrhV/QUvwqE929Ny4ei5/Kc1rhHiyvfKJjL8PfCRl/PWx9An4U/Xuf/6U/tPDNWJcPPVkK/MdGMkcSbTLQwArORb+oaor+CuP2r788pUxIZVyW7qEgJrfHcol0byaGJ6gvv3or799N5Hdmfwh/e/YSjb6qq8s5zNW6IS+O9yTnn7KSsrBF4NNo32nusa2NpbbGKo6tNea26vBly+/NPKLnDrmY2PaZdvTFGK/LR1CqU+36IdSzzYURIfUOQQy6F9105a8KTinbrUTQfiEguhnm/Y5Xooqa063KfS6LEXkRccqH83ZCo77/gmfqTLAE2rZPqgXnXo9DvHQppc/hfCMvWB/SiZUftHPdm6sziE8+7rRYWpcRy/YNz5yHwwPPGNftSf7Ve8QVB/0SL18RN4zdQrauve6L7kXxT73MjGTtmK2Jdfxhg33E7vn7/N3xq34yXflPv/8s2EML79Hb9jwoPGdX/7yV4efTBs2PAIQWLhBmzhN4TSGWQzJBhNQiQu/2AlQHjQEcoIwwZGAz7HkilUJAT8oF2BZGXERwFPSweQ88MuOYC8YJ9SnK3/4mo4CubnkYJt4Pz++LrhLlt0NsWZWWuHPtvYqWj4ci9qD10O5yW/fTzuEjBn1JXXwwZtumXwqSwA8hcbjqXFyr76+kGjCR3ls6/Xuwb90gXwUfg7GuPGI+EVbOhunEkPRl27OG8dZidj0aAmUXg++c47v1MWzrehqiUP8AC9+T/LoPDAG8M7qMDLowHd8eR7+sdUYtG1J6933cAJy+QNV37E75bG9ns+2nsPbNrwck60OPdK+B13j49reOEh5+BhfRNa+RKkHGR939Bjq5UP2VQb+0Ul5ry+QE75p57gSPq4V1XL9IOfSvsq0Jcc5cD79QIe0MRZjV7YIjyTxJdWN06pnZMQ2cI5MfKJHytB5QE4oqGWV+AfYS4cloF/Go3b47AMbyYk/QJv4DHIuW+f50FYZio9yvqcKMuNbtAR4k4mMt77P5qBdxgMdp9pEb8h+1TFtpurFvtSx1QdrbIOMK+2XttPGfYou2tmyMf0enXrU+1UQe6pdkOOqXxAZlSrSprenrxcZYD/HdUyB/oCpa4GsXNfGbm0XKIu/cs9LPdvolS15fNkjsmJfhbZ4W0F67drHs32pvThFcqvGop5v7mUInw0bHjYYtxJcyL0kkOAyl5i6ZjZseJixJbk2PDYQuPhulODivBAYZYm5gETy4EEjgRwkSPIg6idK6gm0JD68GnQRwLNPcgnaer8M1UYdrSIz6RQYekD2wS9kBUv7WLJkxumJgtiS5JktXhJFfICSzOr9MxUwV4S3xFPjdba+/ifLr7Xx9z74qKwxKAGhviC4HX8xypJgkRRyrveHoJov2CeQr0nLHkk6tX5vf/nyhRck2LyiZin5jjf5Jrq7MdJeGSOvfax9B75QH5LcgHZdtRVmCXzYow7blq7CmwI+VtG0X7bbBI48OtKZD4/lPQUrIY1h/MmuyJjJ5MV59aKDY5TjUOoH9Fcv5+3zt+0+ZGKFX8ZblY1veE8h4935nqJLEJ7413bhXymoduqbfXpFnjbKjRt1jBnbiqpX5WEf9ddLyivV8/bJiA/7ur38pagyAmV4xo+OK80hySc6Rs9DMD5co5BrYw54Q119B3TK/QhsQ1B1T5/We8EhaIO0z7haArblmo8fl4AsPunHSFBty34t48MQHJJLR7L2+b5HfFLlHIL6ZEHtC77ZJ991Ft9XO9MetFUnxPdVt9SrUK+i51dR6/a8tIPo1yNtKw9t2nP6iTNJLtsQOK8u/+AfO3uknrHWAy/n+TF8e/iG4twrW9q6tv1wk2cl0MdfXpwbpxs2PGi4JqwO95cUc+8B93/fvrTdxu6GRw1bkmvDY4NMXi/iPmxyIKnjpm4CLjh50JBkEER52EhusFXi5KISWfsg4FuS5Ao8MOkn2Bu/wXM6Ka5Ikuv2bX8F7+6kDpnaCxolJwSK7dfQL8f+kdRJggsElfyjrw71l/hV4Iy3hBLePfi7Bc1tYnEIkjVspAOwOSvdWuDcJmN9Mg34gb8EzgLofcEEn7A7CS42sJ0s/GtbNuq36EEHNk2tJlPPihjjfQr6g47qsccxW+iC9uk8hcbvqbEv/VXBJOeaTVaeXXximY6uGTL5hg499EEmSOzkp7kJ0xTw1C58ImNKVkUmVsZi34/g3BSPWqZtraev7eMVXZSB/eiZ87ah1OmhPTm1zlS9ep6vkbHV152T5bhdf3cnubKNfZUgNl4EyA6lT2uZfuMP5UuRe5V2U5PtKbDN9Qd8ou0U4oPU732hbW8D6kE/bZfqB2SmT8hZCrLoqk3f3/sQG+u4D8XG9EuOgY6ojuMliI5r+pou7CNnrs960I2stMHDmAGyc0+Kr2NP7I5dleZAt4rwCtIe39itDSKv8k49iD5B+KDoXKGdc32fqJf7R3zR841f1REfhdcU6I3n3LjGG5/4u4f+/9Of3p0c32+//dbp3ln4y4sbNjzMkODyur/7TuC68kddxHf1x9MNGx4VbEmuDY8NfLC73qCPhSBHwsJkW/KlX/Fyv0EfgZlkhlVPgjdBWgvW2qtL9xp0WJPkAjpa9uzbN/S+e6WUBNbTAw9JrrtfLWxJsGeHB+3fhjoSjS0otcJKEFsnG/TzTaMpORUJXiV7rEDSPhOGCrqTbXXR0kmeIIEdEihk0C8JK7q1ZOnduhmzZAkijLd98to48AcFWlJQcsyxwJ4fK5qtLejnQ1CfrTU5CHTgQ/q174ntB/9og9oKsvUJKTxcZ5KgmdjQmY2OpyYR5wUZTe+WZCCP3RXqkK0f1K3jbCm0Y0MmX0ugDZ9os3TMAf21s9U2xymLfc6xLZR6a2XxG38s9Yk2ue6M7zXtyLKt+tqGLgrVL6j31T6wTR12HaobxB8ZZ0tRx4i28Ue2QXThv3pOGXmxbx/i+yV1K7TRds31S0e2keN+FXl4RffYUcvUIyuJjZQtAf+zbel4hPPcD7SZ80m1C7GVXWxJX6YsoHv0jz5ssq98KXq/kpExkmMUeb1+47NkKPMdQMchddTHS5uM3ZzX3vPaOXo7F90jA0GOcy79rUxbcOy6OjS+tYmN++A5Hvk9tP3oo4/GZy5eYjMruSvc66xip8uGDQ8rXE9iyHfeeWfcD9oYv7Y3xt+w4WHH9B18w4ZHDG0V1/Qvb2shaMrNvt707xUEZkkghaIDakHU02PQlMBNWQvULj4RcFGgqwcl+3xTq/elBF0LeE8LCiQY28SgTXqSeHnyyV1AiwBf3x/jnyRzKpzHK6t3TDQkLm3nAuGW4GqvHS4BGXTd6SVh88SYkDMu5yZG2ulbaN8Wm5cn4BZMZ9WUBBbCt09aqdv83iYOMDfRooNXNvGUsFoCfPjHXwnkwpdeOvsB9EOgV52QpR+UZ9XevUDrJ33U5PFbPyFq/mjjL1B2rxEd9slyDvETHfmcH21zT3AeL/3s+tNPGctsbfbfPRaXAm/y16DaVu2LLSi28DvKCsVqY+pWHktBh4y36htjANmPb5D60Xsfqm1LEd69Pypyrvomttvqa8An9oTS11P6a7sEabu0fhD9liJ2gnZszRhInzsfO6ut9mtfTdk7h8hcg/A/pi2wBem7jHXjHMVm5elbIFNfsjdjFMKr2nyMflM+8xdff/HLX44rkPpnS0CGH27+9O67J//zf/7PsS8qLzrfvHXr5P/+H//j5KNr18Zj0I7e6v/6178++eOf/jQmi6rObIzN6eMKf5nwN7/5zcnvfve7Qb/2I1+1fZ/96iE67ENvT4Vx6Q9d+Au14x8KufTi6ZkGP/r4S3S93hs2PExwnbjXWMFVrxnXvPE7t6p/w4ZHBeuilw0bHlKYpO8LbNZAUiKsDgVM50UC1UHSmcBdEOXhg+xbUZQgsQXIbQXKwx5ECcrp2QL3s7cb5S2GvDuQzK+o7MZDsKn+s8/6Jf2sL6xOwoPvaqDrnOShiYPyXdDcJrlTviNT0kld9eaC3IpqX3vlj91NTpvEtBVhU6zI0r/RbU5esyffumkf7Pb9OdXbN8N2SSE2GB+gvr9iR4akmyRWfBfEXonEJfYG/McuPJuvn70zWeMHRO4U1Hed9YlbYN8aPdaC3uFvn9/ZX2XyYb0G+X8t1tqQ8UgW+dEBGV+Z/EYf/LWhe9razpH6IVirX6DdUn+oV+tWe+qkPtv43Jb9aV9pH+hWbXad61/3EGS/3QNasgTFfwj/+Gipf5bWqwh/8th7qK/pFj3TLjpPUfhnP9AOLUF4LK2/D3iwMX3b2+l8ZNm2+9GuX6pdU8f3C4f8MWdn+td+xnrshtjB5oxXZUHszXlbiBz8obZZirSpdpFx48bNk8//+vkdWVPw7LHS4/r1G4N+Z8cZvibLH3/88clX5RkeOJZMu3Xr1snX3eph56rNtpD2/EM/ybGcA+34osqZQurtA7nuD+oG2cff886PYelLkNySgOOTvu2GDQ8b3Iv8NeIWQze49r2B8Omn09+d27DhUcKW5NrwyMMk3beEhtCjFZwTgkY3dwEKvoeCofOArARIQQvAWuLEefDgAXV3wfHDHUCxo00i27ejWh/tEBtqIKiIfRIgLcgU0Oe1hPZaUE2CKFeffwqb8Twfxn8JWG29PjmHHb/5AJUdEk76p1HrwzZm/AL8zZ1JNRun+hicE2SQEz/NQfusYoMWWLdVWhkbQDfy8JZ8koTiU2VtpdlZmzK+le+TP4fWH20Swg/ktOtF37YJfCvfTehslZNNvyA+qgm7e4G+W+m+Gxu9f3ZJiOi/BHiqP9cm51DGXOqmLMdzoCs58X+ObXs79uGQnIrwrW3sh+gdezLu4z+o5/rzlc8SxN74oFIt17fp33pujY8OYZ/e1a7Y39uL9qHaWo9t99kxde6QrIp9vHv09qRvUcr2IbJs01fpL2VrdLlXoEO1Mf2J6njuqbaJLelPVO2tdvdIO+M5uiTJQpdA+Vr0bfAf/jk92iF23MFQJbrmXM7jUZ8rI88Cz52/eyZNyKlIuyo3vjsWZ2yYQNP9bD/UNvwdUseql/wRHe02bHiY4X7lTQNvQWRcG7feckA1Ntuw4VHFvZu9b9hwn/D88y+cBpKCkNPCI/HEE7uEhcm2m78J+r1CgtMmp038kNf7mtzTb14McCyglbwZg8MDgeHDAskeNibYD+xXGxyz26+j6kveCOaVayuZWVf+ZFKh3tR3yZIMawmww/7CC0/97mFPBz6PnJx/6qmzr5q0/mrfRhPo6i8y8WgJm/YdKPViv/r5RT/19+knoZVEkQRgS+xa/ddWp0A713RpibbmP0G39urW4Fv9toqrTbKOxTff8HH7PhBbyWQTwpeNzUdtDGRSVlcr0MV5x0tfmTwed/u5Xe8tGdJPnKI3ajYeBjtiU7aV+rLwVh6CNobOvp6FlB8az4egPSJ3H6pOoap3SL+GMraz1f/hFTsPIfplX7+wG8UXtkkoI8epk/bhsRTH1J/yTShl6ePa15AtnQ/1deyJrENI/Yoqex/STv0gcpHySinLeXbmukeA55SdynLdpf0S4Kdd5K5B7JtqFx2ieyhl7KrjvVJsDt+M22pzHa/VB31fQ69ffKhd6pMbmaE1OFQ/56uMabTy6F6hjC/Sz1N19iHt9gHP/fq1OqnXI20RWyH910OdXMtgVZl+XKLnhg0PEsat5NalS749vFv1L762sjJzjg0bHnXsj243bPgWQdDSEgltGb7AJoHMvYRgVXKkUksSCIJ3v9juPhp+NlnxsEMwLynnYZoHKrCpQnLmmWf8tb1nhjYt+NdOEKlf6uqq9IutB/MU1MXHBOAQKj/6An/7YwZ+7fKdtN3rd+0vh+kDWzLaSqhdn2QywAb8JKYyEWnnW9JOgqn153xgnPFnTLCVTpKxElktiZaxm6Rfmxyn3EoqutGxwjk6SH7Fr8dAUip/FIAchB+iR/v+2Tfj6x35/szQO6M9gWTI3GTiXmAwfbS/gnz6ZvJYwa/x71Lg38Zua1cnweHDR2Rl0hu5KV/aL/H3Wixt09viWJ/VbwnlXM73/l0DfZHxYBv/IONGH6WfnAfyIj86rAVex+iu/qG+jj3n6etaZ4mOczyP8Q1UO9G+Me1aSl/ZT1/N6bTE/ikc2y59PYXYyabYWcd5qNrMRpT+da9mv33lsX2fDypSZ07HjKWMI7rRR/25Nscg/OIHftnxP2uHVdL0XmLfWqzx2RL0Poqdfb/nup1CrgX1rl599bR0w4aHG+LZF198cbhn7GJjMZo/lOB+vWHD44ItybXhkYUA48qVK6dHLcA5T2wl5nHTF9S0bxdJqvj+0S4xc9GYC8o8aARcAlcTSX+5z/ceBLX3IoC8l0jwz7c+0OqvEPkVSf8hD1wfb0XK+d+vohI/CSIlwNgeSDiBhOAc+Ikf1e3i2bsgASOwDT9ytZG8ocsnn3wybk1cdnq0VUfkqE/voE2Knhr5aScRRg9JJeW26uSvZe5Ds9/Kp7bay6osemWCY5yo0+SdfVWCTWzzVx+rHPoaWxJQB8QfBL4t4aaPW7/0cM53SviPfvRt/dI6Jq+iVh/eKzQ50xMxZfTjWzpX8Fnr17aKDtXJUK5VpLyNofYRfePQhDeTXsfK2Vv1sI/ilzU4pp020bPawob2zRmJ3ufGfWXOqaO+dseCXLbzcXxjbLheXBM1QaBe/ERm9Xf0UuacOnhqR8dj/DGFKf+E4g9t1/Y1rNFRmzXtav0eU+2V8SNb2Ynsp+/T54fstMVrqW101A7IWNoOtFsjC1I/dubaNdbbDxp3j3dyYqNtP1aVVR9UpA/ivyXA41A758nkf/sZo0t8UfvZdq4tvohdrq0c309E5iG7UmeunnJ2Z4zVe0gd33zPp3kGOO6fB4E22kLlsWHDwwjJLbG2NyYC181f/vKX8V7W37s2bHiUsd2NNzzSOBT0rENbySWYc9M3EUaSChcr5zDIb8FS++uCElzKHhasVeXzzz8bbZCE8RCVkNkFnBIBkiCfjb8k3bhxa6zD3rZ66onh4btb9SNB5Jx+WgL+q3/dkcw2qWl/0tw+XuoF5CfRRleBcB0DkjnOtcRT45nzJgpg8hFIJjkmK389M5Oiff1KtjGgnkmISRg5JlUJuo1P9VrCascrExeBSw8+b6817lbHnQd48IW+2jfJ4leTQ2NBYixJFG2X9ufFYP9Ezbm5vuFT40EfspNNdFffGEL2lWccr8Wc/+YQGVPtlCFjNBNZ45D+to7ZkzLH7bo8/r5Hn9hvjPFH+jeJkSQGnI+fej0zaYxezqsXf+PB33goq/7OdiliM9nxTSa/yiCy089VtnNrZKbuGh9HhjZL203pxZ7YGVuRsvCNj9N/1cfVz3Pgy7WIbWsx1UbZVH8a67l+4wf11K/j1dhy76xJLOdgyqf7sKZuRfyxzyfqZEymfmyGan/IMZvTFrGt79eqdXwZX+3T6aJBp+h1yBcQXXMP0e/szr0N1K33EPsZ3+GTLWT8TwFPcl599ZVR7oYNDxtcN+57Elyug8CY/vDDj+7cPzZseJywJbk2PJJoQcXuT/y7OZ/3/pzASPKivX7WgnkPB5P3e4H2EfTpwN4qIXo49/A9fOizXCd2CCIbte838a3EjITH7dt+EW/fcJJ8Qhwjx2wAAP/0SURBVM89115rqw/fFmS3RORcwNkjgW4SKvbxq6996mtJl+pn+wJbCRi6trZtxVRb6df6p/pCX7Ugl727X37VZx8+CYLJP9SvqUsWO/ilTbhacooffcCd/pUXPdo5r0ye/QWa/T5if9FBDX7k1YnEFMhM/2XyiPjmfiFm0xPxc8ZJyLH+R71v08+2QHd1KoHzte0hpG34rgWdUGzIpDaTvExwUy9jZIoOgZ7s1o98pA+NAX2aiSNSnjoQmbbV5xk3CCpv+znOfnzVU5DjahPe7O77GjmXNvjHJjKr3CWylyBtottSRE781KPaGp/2/NM2trEVzdkJ2c/xHFKn6mef3w9Bu6W+qHbaZtxnvNcxHz8AGbGZjbZ1rKKc6/2AcrwW0XcpImeqneP4lG2h6Ou8c2yH2schZbEnsnq7PBP92PPRR9dOrl37+Ax98MGH449SaxEZa3wBvW5BfMH+jDFlSBt2pk9jd/VT7O4JssVffXxS1oN8448Oa23bsOFewngUt3ql1j0h49N4zl8DreN+w4bHBdNR0oYNDzkEHQIKaDfncfdouOkLUmwFQo1nDRjv3SuLDXcHRV9/3QLPBG7nQbNhN/mVLMnrcy0wuz+3ggSj/Lr7hbxNfpVLvkgc2U8yS93AA7oF7IcnGmxmW+PRgvzsSwrZ55PGL32e8dR4k13b0olugn88GlpALRGaMdknnaDxaGNKG3XZwydTIAcPbeI3cmpyjP4I7wpl2sSuQHsUvheFxq9NmCUCySaHvzLJdFzBD2lTdbz32OnBT9GLDnSyzX70a312FtrF/3N9uBaRjXfvL8fkIDL5FBlH7RpuuiirW5R24TvFfwq9H4ynUMpzXH2lXRDZqB6DuksI4pvKu0f1EUzZD7Er2ylZtSxy0RRSHrlLUHkt6YsKbWNrbMx4qLZG5yorSPkhO+3jtVbHiqXt6dDXc9zbabxni+r5ajt+/Rit+7H1kA8qUr7EnvOg8q+2Vxsh+ve2xSfVF3M2Zr/KdGwC/O6775784Q9/uIv++Mc/nrz/wfsnn9y+fdriYkEXNoSiW9WxYWcL28aSYR+qzb3djvG6m99Z1PPaZNz0UE//+LSE7YYNDwvEppcuXRoT/4H7hAS2BJcxvWHD44iLicw3bLiPSDCR1VUT8cZqJCCEGvy2RFdLurSAaBd0tTa74LrRLhhbDsHc3W3aN8Gmk1wt2FqWpKCnxAN/tdfU6LizoQXO5wvK8Miv5xJnEhs7SmKtnecjvyDxMz3Sl0m0OUcv55MsSp/btl9TD9vOb+xuq0t2rxe1VVB/G3UCD/satNptpP/bPn9LyMXvGSNtTLRJBHl5vXAqaFBPuZVhbGCz7yIk0eh8hTLJNOPPvvp0b/Znkkt+syHgu+bLthKtgj+iR7X5okC35vc2CX3yyVwn7fogP/0c3As99oG/yMwkB3LML3yG7KfMNvtV31w/iH21D9VbY5u2qW8/PkNVRvZD8bVz8bUtHlWffYiusbH6Ib7Ivj7OGKz+ICty+22vR+RVvvbj5/AE+7V9+OGN4qMqy37qpp59wC92Rm6VDam7FNF3TTtt9rVTFooN7Ezd2DRHEDtjV0WVvw/qkHWv0OsM7OzH+RRFr9hS+zWU8Zrjvq/XIj6r+i5BdKztqu21j9PPqMpLPVvobc42tqlX+c1hzqaRv3OKe5JcInuQd1GIvrERVXunQD16sh3FFqj7PZzbxxdSp9brZVTQvX3Qe/eWwYYNDxLiA3+BXpIr49gY9haFb82KjTdseFxx7yKXDRvuEQS3Cdr2BTFrgJckggCx8rTfEiIJrAXfoVZGF9vUqUHaYQjiWhAVqnDcJwWAngL3Q9C+JRasCmpJCMkaq6g85Hwji43L9Z2GoK79FcL2SqDkDcr3T3LMFrp7sCYB1hJD7cPydKMLnTyIE6wrkwyi95I+1wdkSUhJFFWwk8/Jp8dcspCY1v+oldGxfdz9bJv2bS4BcfPjlD+NDXXY6LtUbLHSib+sqhOMaNPaJ4HbvglnvMEXX+y+r8VG4KcKcmDK7pbMvDv5dVEgk5z0K3+wl46tv63qevAf522Jyl3iypav9yHXnPq1bvNruwek/yB1cgw531PGS7ao3VN2rxza7xNaS/1Il55ie4htSQTrs5YQvjs5kPaRj9r1tqPI1CZ+Q8pyLtd2j9gfgipLWZUbfyBlMGVbb8NF4hh+2qDe3hDETlT7vaL3ce2vyOj1wyMy9iHtltTtEdsgNvVU7Qspz9ifGu/4VnurzSmP/Yf62rl956ewtn5sDXIcqraztY7nQL1q8yH7Ypfz4WuLzz7U8/ZfffXVk5/8+McnP/vpz05+/rOz9NOf/vTkBz/4wZk//rMUcz4kM7bHfjakb5cA70N2xj98shR4Ivrk2poCvePvDRseJIxB8eVLL126cz0Zt2LPTz+9PT7nN2x4nLHdhTc8cpAAEPzCTJyxGmKiloDZBS81WEGSRVlxpUqCHSTwbN9u+vs4uX/hhefHtocgaDKBlRyS6MiDKMCbTscGTBJLZGTy2r4hdRZffmmFUvsW1rHQH03XFozyDRo8NZ5PcPjXv355cuuWh6uP6be/OijZ1hIhLSB/4YXnhjIffW9JGmV86bjx3A+y+NE4mXqI60Pfc6PDEn76ei6gJQs/urHFL2N8bMWafq1gA3nxj2903bp1a+wX54wZf13SOPM9sq++avo5h6ziIiNo14C+3ZXRJwmx+C+gD35ffXW2/KKQ64Wv6KE/+d8xm/WpvoaW2HxwkLjuE5VL0Px3NmEDGXP63Xh17Dyq124bLy05k0m8NkkG66PcA9QLr2MQ+cYB0gdJYAlykWPlqcO+atchhH94I76Z46VsiT3xkfHER45zHdgHMshiT+TGFnKWyuoRv60FWcfI0ya26v+QY+fi4+pftsGUj3vsO79EX+2PsSs6pm3tQ/ZlZW9IWfoWtNef6WM/DOT4Ivsa1rRNm6rrIeCPct33fQxs0L91PLPvPP7Xlp+0Jzf3lqUQ7rhXt/hk96MV8qwygb5IxAfp4/RvEN8vwSGfLfVrZKqbMbyv79Xzce+XX375tGTDhgcDf+TopZdeGu+vgfvB9es37sRiGzY8zlj+lN6w4SFAC4bbBHkqYXMMBCVWuFh1IrASCEo4SDpJLPi4qgmx4KZNNuqvx7vJIVLu4eFj6gIhv6BINGWi1kN9K4MQvhIU2rRkR/tAOv4C4jWg66VLL47822qluxMbWUHE/m++4csWhM/j7oBQjJiVbfSXuJLEunnzk5H8pUR0/frNkSQ6Av7iwwSRklL0SWIE6NYmBe1bXUsgAGeHSVEPfZBVUoLpyFkC8vvqCXxrII6vBALoA33H1xkzFfqlfXDfJK39pUfLyvUflhnvZEjCJliRCGvfFjvbr8ZanwwDeuqjNk4vLsmV/nG9SJLq308+uT3a41hfVGQ827LhQYF8RP8lSP3s60f9XPsd8MuEnV/a2G39L+Dkj5zXx4cmTIdAl1xHyL6xZ+yH+kmzOrEF7C/1Q0UbS41X5bcP6pPVxvMuicUn1S/q4Bk/Z5v9jKFDwOcY2+DYdhXV1oyFaqtzsaPdq+f/8mRgXxlof0hP9ad8dRH2Bb2dSD+y09hnaz2nPhv0oz5lb8YtXZWzv/ogcqb0jn05H1nxteMpVL5LQVavh/1qf+Sieo2zC6WP63iOLhW178JjCdJOGz4kB+L/OUTWFNJfaK5e/JBreC3iVzymaAmqv0Lhe0inyKa/Met+HZ/l3m1fP+/j5fzlyy+dvP76a6clGzbcX0huvfzylWHc7hJcruHtLylu+Dbh+Oh6w4YHAK86zQWsx6IFNYKWlhxCkgSCbgGoh4HVTu3c3d9OmoI2CdA9S8gQNJnoJoEmWEoABh5A5DoWSNpKbMDShIA25OAteVJXpgF5AjW/zNJNwgclYeLcGkjMkAV1MrIWVkP5fhNXSNIE8ZGHsv1Dvmd7fD8FfWj88M1FgD6ot9sxHUza9CG1lU0FFpJYznsV0UdAJSXp+OKLLSkCbQLYXtWUANVPWOmzQBvnp+Tgk/F4EWAzHZD+obNJG7l0qpOq/nrNJElfPVisS3JBrZ8+nhr3bM61HToG5ManiCwy+Xduopw2S5C6dF0L7ebsis345p6aaznnEH3pzab4srcFIgvtQ+qQU/tgDSJzabvIy5adIXaHT+2/UOxcA/pFR/KOBb2W2hj/x6/pT5T7QJ47zkUv7ard/ZitPohdkbVUN0ib6GYf3/h5zsfawRpZEFnxQcYaVLko4zl2rkH8AWt1hLQhlx62dNVXU/wiaw7asBO19md5aE8GW/dzmkf4T9E+RDfbUN++P2drvPBHP475KXWnwJ/xaVD9t+P9YFctb/j2wQ8LfiyvMZZx+vHH1+/EaRs2fBtwfIS0YcN9hhu2wOSiIcEioHHjb4FLAtNd4N1ebcsHwJclnBJQCvjwy0fDW+DbkhPO45dgmX0JiCVHJKDIx2su2AoSvAIbyMnDzLkEcMrokiANX3Ilupxbah/W2tG78Zr/hfcQarPwaK+HtldI47usPJsCvVv91nc98NMUvxqYngfk8a1tDzKyApDuUzLbq5NW7LXkXpIXknDsbPp+fZqw3AXVjXb+Vrclss4G3cqTwD1P/wT0bZOB9uqjP46QsRSfkyFZq7yuPgucV9cYP88rsucBHbhibiz1iN/Sz61vdhOgKT71/D7g3Xy5S2Q5bn7crV5q9434ejdprqTNEpkVx7SBtMs9rN7HlCHnq3501g5qeSXnQ0H28Qvpi16u/Xo9aofnGqQ+GUHkxa7IrPIiq1Lto/6849gVfdei6rgPVVYwJbPaGd/Gxvh4n5/Za5yGlNex24/b6BUKL3pM2YaHdlNQX9teRuRMIeVL/Rjg2cuYIzJC8e9SpB2cp519+vKf/fTnFM/eFzkOn2rXIGk812M8N55fhsaryUD062lK16bB7vuA6tE3lPFbx60YKKRNxnJkoMpjlHNqd3w4laQF9WOLfc8+ry2Gz0WCnv6So1cjbTdsMM6Mc2PO2Mu4E/v5NMbt27fLtbthw+OP5U/NDRseMFpQMh38ngdWI+EridUCmbsfAgluTNrnAq4e6ux4CrxbUCQBkGC9lbcgiV3akN1ktMBr0HCo0xJmve2OlXuwtbotAJdgAPz8kpi27VtE35yZgLBdoEdXx3hN+bgvcqwt3uRdxIOTvglM8W0rzJqv6Ox8Wxl1t37NhgTgZydC2rUVa2w8/MH+QyC/+Vx/tURWfBzYbzaQOZ1gSruMAXXYKdGlnX3kHNgSUZNZkQP4VDnspqd+PU//ND76pdnsmPymx92vPyojkz7GHzurb7Tlk/P+Vc/zYb8/6IvYmi0/syX9piznD4H/EdsR3/BR/JRj2/Rt6qUMhc8UlEfvi0B4odjKbpSyOVnRMTZXuw6hl5tt9kNziI8ib1/doPJFsbXKTL0e1VaofRZdcq6ilk/xncPaNlPytY19tnVc95S6tuHFtvRrHcOVUjdUgVcofUvGPsSfU1AenebqTMm0fwwij52H5F4E1uoZXWKvY0RfqP2bvp1C+KR9pYuAsfPpp5+Nn4UwEfddy57qNzorvh6ejSbuN0u7WwPdvHmz8RrOaZu+ruPbMcQ/AbvSryhjW3nKUPo7+0HlRY7V+yjyLgLt9ff2CnyjFwbb9l87Gx5vGHdiM3/d09jIODQ+vSXgEyrG8kVdtxs2PAp44l//9V//y+n+hg0PLQQLXtO6yEAhMAn3q4eHgQRIDVgqPBzaaqDdL8ZzUAfPBEhTwCPBlHr2tZM4ask8dbKCq60ik+xqdTLZ3E1QkqTCL+cFPj6yjo9kSf+Qs59Eg3bIiqBeZzLZTocg+ko+fvrp57N+OwTm4WPLDkg/J8EVtARXS7BUO+hFP7+w9nrgbcWQ+hexigs/ej79dPvIOp86lkRr55tf2ZAEU+/P4Lnnnh/7SVJL/wSRkVdmA+VWs1nZFfvJ0Qfsqn5RF2/971XHY7AbZ5kI6XfjdjeJJWcKzc9t3GjbJ/rsKyfjvH1yDJrffOut/cEDdoQc97ZH12zTBuL32Nfv85U6tj0pD6VN+Ctbiqp/+BxC6rOJrMojFDurD1DaV/0rVR8Ejl0T9VyVUSlysk92jym5KPy1DXIcftnvyyK31gnw6Pusl4eULUVkhc8SVD3pU9tFh9SxTb/ZD1In/Vr7ttaLXeBeFKp+iP29/u25dLddkVHl9fvarPEj/SMHj/DJfl8WeQjWyNI+2962fYhcvlsKbdgG+9qp11N8glIW5DxKeepIFt24cePkxRdePLn00ktnni+pxw7PLcmpvw7bH/7wB3d8CWR++tlnJx99dO3k6quvjt+ajB3a89q777438vTsa8mqm2OCqifPdWNJcgeSyDIO/dAioVXr3zgl+58Pz1B/JbJiqs9iHx/3FP+RN9UWqh8r+MS3Mj3LB8mDjOXjpQf++uLVV18ZfRF/4slHdN3w7YSxILn1yiuv3LkOx2vwU99J/WT8dMaGDd827J5IGzY8pPBglzASgLhpNzo9eU5kVQp++JuIz6Eliaw+acmjfaBzS0qdnYDsg3qCKAkJH69HAjgJL4GNRI1JuSSHh5nAiS50UjcJnnzA3C984JfMfX9JUDtJsLw6JnClew1Yp0B2gizJwaV2zkECL3YgeiirmEpw0dN3ztg4pQMd9UcC1vMi/dC+29a+e6bP8K5/ZACRXZNXPfBxvvZNxk7+umKQcnYGysiQSNLnziuDJr9NRI4BPq479mKJD9nkff11JrfGbZPVI+OZn3rdwHmBPxkPCnRIP5lE0bHZfPYbQ86nfptY7b4vxIbs57iO4dRv949dcmBqrAb7zu2DdtXHS5D61QdzdscuxB7loaVQt14fc3LpxU/8RV58ly06JLdeP4Bn39+RGT9oE4qdkdfz67HGD8ExbWBfu95OW8c9UoZXxmkdyyj2A/vX6DvnLzqRXfuYnPQzOJc+WYLISrvYnz7u+zkyD/XpReOY/qbjEl9Uu9O3GefV9vi68qVXdBs8ePLMcP/D5xC+M8jJtyN7PDGck4zx3Ma1x7PiukGmlVgfXbs2JsSmyHk6V1hVLD64fv36ZJuQ7xBVn7MZZbwbBxnr9T6jzh1/7PG9Our2+lXwo0Tb008f/6yjAz5Xr7aE3Vmbmg0bvr0Qs1y+fPnMNStekzyW6Nqw4duI7/zyl79a/8TdsOE+wk37jTdev7MaxcO9PN/PBRNZSSPJgFu3PjkTOExBoCh5JODwy4igqEeCEYHloO24rwxvSSsBVAL5NZDI0V4wNaUnOR50kmL0klxYihYIPzk+FAVsvSz6C1YlcaD1QSNJHr47LwYRo5w5sMvKJ0m72K++RBHdbty4OZb18AFO+p3nF9QKAb3+m3pND4yprByTtOPPHiYg6vGzv0ZY+9Q55ZaXpwz0kXK/nAd4SLhKrLDPeeOOfvqFf9b+gocfviYmAmfjterm+x/5C4pAnnHR+s5Kl/wa3sY6PpbQu8bY1E8G2KW9um2Sce9/jSaTjRnPwEaUyU2/rw0b901meqjvusRnahzMQRv6tX5c/ooBefqjjidlIf2H7McueimzrX29BNFxyrbIidxaBm2MNHlLfMMudcmbQmTBlGwyQrFxztZj+hrI0nbquTCH2tdL5MUuchAfpjy2VrARpV0FeYfGlzZ05H92Vf8dAv1Sf2mb+INddRxXxNbYlH3o+/mQXPK0XTP2q9y58TgFbciLfkuQMYXcy2NrtRmqvbFDPMCuuWtUe/1KJ1C3148ccA5Fdm2T49ou58lOm+jm2Pk69qotPdK+6lLt3IfIopfxFP2CffewQHuyD12fLf5q/dLbhb+VZWKRJdd5hb73rLIaLsDfc9izf80Y3PD4wVsu7S8p7uIZsdu1ax+P8fKGDd9WbEmuDQ81TJAFYRIVAhtowc24e274C3YJqAUMhyBg8SChkySHSXsPr/9JGPUBVXsFsQVqEgktyGu/GJKfwG0O9BQvSV7VevhJ8mgv2Kl+Wgp2CaTY5aFIv/ZL6TejHc73SS6gu9VMkjkXBX7qwVcSR5JwsQ+itwQKPSpam2fGiRkbLmrM8EHftxV0Irv5sE14JQxrfyiXkALjLry00wf5oHvAJ9ok8QSRgW0m1WSr8+yzkl+SXW212ZyuQfNjk03PJGOHnj7jNzKNQ/2tnrHXXkdsf2ERlGWMg+S0RKREF7/RxzZoOjefoKHkTnLtokFWW4m3+yMW7KiTrR4pZ7s2VfdDIE8b2zUTkfg519+cbkHzYZPFh7W/tUV9WUV0JO+QrAo6hn90gJTV/RwbY+SRFZ/k3D60sdEmuNXeyITYWOXxJVT/H5KnDb5r+gzi/2OSXOyq13G21c7eXvuxNTbZ8kMtT1tyKtiHDt0foqO69DxUP4jvo9MSRE9tyAqUQ7Urx0HqpF09N4f4VN2lOgLb0Jq+Tj9AtQ3Sr7aVop8tWdXuOfuUa+P5Z3/J8wpFln62rbK0Dw/1QpGF2OQY4RcelRekPlqKvm749dsg9els33Zq7GZc9+UV7GSPer2cCvXwsw3UJ9+W/OvXbwzPfD+6LRtrly+/NMZeUPl+/PHHw3hoz4Z9Om14vCGukvys3+Eytt5//4MxAdrfZzZs+DZh+ybXhocaJsrt1wkBUSu7SAhIBC8m9QKYZUgSo30Hq3+ImPBnVVRFC0YENgLGXdCoXPCCnwkgm1swc9ZgbVoCpMlL/QRfeDl3bMDjAYknHlbj0EFyJcEYWeyCs4GVpMTyQP8QwjYPbFu6sLNOAiVOElDW4B9SXz26HemSSfBB6zvB62lhh5xvOjVdwTGd+NIEhG4Zdzs72XM2keJ7X+GR+mzHu+9zfCS6lDnHD+Qpr/VAGT5s0iZ9PzWOjIWMv7qKK/qmvm3b303Q6Kye8TUcDr45y9+u4/jMNSBZvON1fpDN5zs/tiQL/XId7kPza+vwNTppww+5jpZAm4xf/o5sfDK2QylLu7SJ79pYbLJTNoXwWGObNlVOv1/LgtgBOV9R7UTV1tgXVP6hvgyP+GQpqhw8liLt6HAI6lU709Y4RdXunI9N4a/cPtvqFqUu2IZ3RV9vDmm7tH4Qm6Bvk3Oxv9pq65w2VebUcaX4aU1fQ3TBg522hxA9jxlXsTk8YnfOQ3RgL0RWbD2kIz7hm3ZzyLnoQGba9P4O6jlb7VIndkQH29gbGdnuoyAyUD2mI8q5Wif8k+CLbj3UmztXEX321cu5yA5iT6PWH4d+LOE3P+6Kf+PDQKJsX+Iy8g/ZtOHRhrEhCWqrzwOv8H722aez42PDhm8LtiTXhocaJsbPPvvc+LCuD/mLgEl7+96Q1/t23x05BLpoaxJuMl4TPB40edjMvXalvYdPgrNqWw1M7CcxgBy3ZMXZIEr9fQHPWiSRMXA+tact9ZccyCQpNiAJkrbqSKA4nr5AtCCZjKx6oxMdmw+aL+qv6c1vbeJAr4vyS8AP8c8+8FGSQewwZviSD1ty6Ilx1Vz0a/28W91X0fq69Tdf4NMSkBI1Z8dZS361V5HoqWnGSkse8ZvJlbHV+lRySd2MySkk0fbXv7aEIr/jBwnYIwcyjvHnB3zta8cWq9UqVFcHRWc6tvo7fmuBD3+3FZgmsE3f5p82rudsrohttmt0aXYcngyrh9gbikzI+R50iT622sWP9dw+4EvHpfUDstKmygtNIbJAndiqLDZO2VnRy6nUI35c0sdB5NtO8dyH+ARiS2yMnSj79RxkC7Gp9mfdb9fu2WcJmkLkxTZIfW0PIW33yZhC2sUPsTllqEd8EN0is9IUwneJPUHVQ7vd828/ImtfXbZO2aus1zE2VftSx3G7j+76+RDIIZcsyfxDbXK+6klWLy/n6n7kQGxOeer0VIE/iizb2GqbfZT2ymJXT6AO+bXOFNSZOxdEJjpU1/laHwX2+cazG5s8Nyuc90kAP8jUv8rIdiuo/aU831ia08PKHs867fGakrHh0YZx5D718ssvj6v89DMYE2JKSVCxzaGxumHD445dNLVhw0OGFiDsApCLv2GfDUCWgh7tda6vxwcNCh8PGxP/lvRZBvwEYoIRr2lJ2Gjf7G0+aAkSMtpqLhNzsgQ+2l4Eml1fjfoLrNpDkk0tqdT7KokRdZ9//tnTwKqtCkpgdh6M5g8gl63E29IFf/LZTocKyUdE/4vyTUUbl8vHDf30qa12/IsSwEOzkc+mX5FSNzziA/7pE1z80gLo1jcZq8YVHq1Om4SgJHj0O7ltzE2jmbybQO6SaU3fvileSdipa78lhAVoEnptRVWP6JzEZUvG7Va3rEFs9Iopn9MhH4ong25Lx2p8s6bve2TsoNZXZyf92QJ5tX6gXN/qr4x/diDnoucaRNZa7JNVda+2Binv69lCbKm2xsZslyB8wncJwntJm+iO6A91vGa/p9rvAbvYW212beb6RH1/L9ER4oeKNW3nENsRexDbqn1zBNGr7+dgn+we4bUGqR99sj2EyNpXP3ai2te26evar+nbakfd78fLIaTdkjbqRhdyjFHPmYzVfuzWY5Q26fde19iRscvWlMd2FB3quM+5+OaQPZEF9NiHJfxAvUO8QL3oOwU8sgInryEGnlHKvH7mO0vRix8kL3xEfN9nNSTF8L10yStsjfTJhscHxoQ+femll8ZkqOsNXBtiGwku10zG/4YN32Ysi+43bHgASCCVe7WtG/dF3bsTbA2PjUHWuktBO4EHfSR2wMOnBUHrX5foga8HlYm+B5fvGkkQJKFAjmRGS5gIMO+ePBwLMhKstodl+4uCfYDX5LSkjGDYNwF8Z0pCQVKj6bUuKO/BDy2ZJlHyzKlefp3l+7+NOsYnQJYECpFJklw0jrVHgoVO7OEXtsU/7FoybtqYaKv2pgIZ/YCHcz2UGUP53hWiS/9XHKcQm7P6KmOP+H0600//tKRsW3FHD0lIY2SfL/GmL3vVUz8TqEN94Ly6/GElKP/i5VrKdTtIuMt/+6AuWiK7Ul9G/9hBrzamW1IAyNjdm5p/+WzXZ/N9lbZLfHQRiD/mqNpqG1sD7WNfP6mtPgB1Ad810C56LkXfJvb0xK7etuwbezVJkD5hU2+zY7DtfRC7p3CMXRWx4xDUiazYUSl+QOztbYbe5rl+huiZtmtxTDs6Q+ycogr1EBvnUO2tNkNsXIrotQaR0euf457YUsecPnTfrTQ3rgNtK2W8o+qL9izcJbyqf/rxUBHdovMUIhv29U+wjxeE3746FbG32hF9IH595ZWX78hWJvnlFcUK7azg8sF6PHtoy0btww+083zPuN7w6CN9bZXelSuXz/S1uM4YEeNs2LChYXtdccNDC0GAm/m9hMl2C9LOvvK2FB4y/jqjiXiCvQRu9wKCHA80CZ4Eh5IN7VWslkgYtDqXfDwlrCSW7As8JZUa/zZBZSdy3q+LSZQoU49PUEs47R7ExwBfiRJJCsmVJHkkTgRwHu4BP9BbwHysvEOQ8JOwOoY/XyQxyR4JQe7JiqolY9AvvPU1xwBv1wvb+3M9nE9grP4h0NcKsK++YvffRjl4SHoJpIP0dQU/GSeuZ20imx8bj/2JvbRH9DU2+2969SBLvXb/+PvJp59+Oo6Tvg19jdNDOgTq053ec3A+tG8iGNtR/KK86qh9yteAvGPbrGnHpthnO2VvbIutKOdzbilqu6VQP3SMbdHXfiiT/DrZR+oBOdXedg+dXrEDkeX8UmhDHsJviW2pH8Qn2u9DlRVd2Z1jPFDfz47VzbmlqHoe0q2CLsESfwTpP/6P3Nicc7kWA+cjb42s8F1rlza22q2RF721QdHZNrahOqZTJ+iPe4QvOShjvSauMh6iB5CbdilbAu2g8uqRvotO+5A+36dD+K3tt+hafWgfkff555+NPrcyJ3+MpsJfZPS8n4OYTxzxyiuv3LED/FEkbZc83zc8GjBmxDZXr746XquBuPHWrVvjHzTYsGHDDttfV9zwUMLN/Jln2ncF7iUEF889175dUP/K3VIIKvzpXgmLIUQaEzDHJMvWwgMuwWuVJ+Bhk+SdPze+1p4ggW6CU/uWwksIgOCM3JZsOXsLUVciBw+vpEl0CbQ+/fTzCwm4BvajnXndLfa3FXXrvq92DPzSyrfHyJCkk4gTqPiuBn/wUxI+xtEcX2NN3YyzGpC3/nluTORIwO0DPpJqeNFhyRihn2tEfbJ894MPTGD6eQEbp5BrORPJ9grhkyc3btxcPU61xUPykw/ji4zTmkAzPiW5emiDh/6sPPYhfaC+ffJCgAe5tiFYOtkKwtNYIav5+bB+AR2b7cv9mslY9Ifosc/W2LZGR/rhqR37lsJ4IX9Nm+hMHh17xJ7UqfVRDzaG6I/AVpm27Fv6HIg8fa2NflviR234PrIifw7q85/6FeTFn+pUH6DYqJy81F+iI5AZX/Vt5s6RFT3Jcn4Jqv5TfV1RbdQGuX+6N9NFue3cdZS2fLJ2PLJ7zfWSNnxCRzrNIXpl332XnMhi57HAgy/SX9ki992MjaX9xR52aXOov4LYRAZ5c77ItUE3Psu4yDY+ct4+Pvt00C7+Xwp8029TINvKG9seH3744aDP/nuB1Tz8HnjWsTuJsaX9sOHRgLhLn3tWBMbjjRs39r7GumHDtxXHP+02bLiHEFCcJxhbihYoWYHUAvi10F5iQlLnfugbJLgjUxAV0EcCRNDYVgm1QG4tBHt4V5/0rARfUwGYsvbtoy/GQMsWr/bK2nof9yAyH14fjsYydkrs0fteBnb6+Tz8jbMaXAOdvY5qKxgWwEz1Gx8mYVj93mxftlqC/vpB8zVBsPqIDhJIayYyQSYQ+s3YNS7AdyV8h8TExVgm4xBcc2mfVYMIL5NUk/72iq9vkbUk7Rz4rZ63jzL+M0lBudac0y4TI/7IRE0Z3ziffrLVZp8eFWm7tl2wxIdQbUXsja3IsXJ6zNladV0KdSN7DdbKgdSPnbVPjRVk7Nmmj+M/bavNxhMyvuIDfZ3+DtJ+CWITWuuTyFzrx4r4JDrXfo6dytAxqH7pMaf/sf6AKk9bdqF6HU/1M3LM9tqvc6ht1iLt1timDcQnsa1es3UsZzzXNod0JSN2I34wBmwBD8h4iA8g2zXobVqCyOzb2I8/9C1KWe3r2JVr2v5S3dfaqH7P336O6aePar/Q6aOPrg3t5hNc2ln51X/Ty7NVgus8P3BueDghnveNNdd14Bq0gmt7RXHDhmlsrytueCghUHvqqf3f7LkICCJakNgmrwKMtcDDBNvEe03AdF6Qwz8eegk4U54AR0JCEu8Y4N1PDBKMkdECxflfPqMHaknAlog5tNJoDdpf/Gvf/5LcO/TL53nAdv1sjBwbQCYAx8vkIbo2X+324+vIae2yYuas/5zTz8bfnO36ku781frEJGWZDRkDVs+5HMnYN85T3F+7junKzozX8GYr+1yHGWvOqe+crXOp37a+67Wri9prx5IQbQJDBjWqLwP6NJ3aJIiMyMs5wKPaqrxO8HrqET5TOuxD0+3u1VVLoF3axBby48ve1opqCwqfKQI86vESRB/bNT5JmylZysMXxca+b7NFQfTXr/Sp91P7Ke99MQU6kKHNUqSNbWQsgfrsq/qwK/yqH5SlvCJtY3NPQW27VkcEU22coyeeFdE9fp9D2oe0yX7k2lZ7bGNDytSH2m/79Abn+d/9cC3Im+MLsSEUu8B+T6lDp0pB9mNz7M/Yts1+/J39tCEDH/uQLUR26i+B+tqF/6F26tOBz6NLtRsqn5zPswBVe0LaL9EbLzhUbwrRN4RH3QfJCq8Zzq0WU1e8Y/Vxe57v7mEg4eHHnTqGNzz6kMx86aW2aq+OQavg/Vh5zLxlw4ZvA87eITdseAjgQe5GPvfa00XDN4Y8MPqAYS0an+UTtvOCzoJrwVkSBYFzeaVNMoBP16IFvFbB6JPTwlPgO/y/CC149lqTlUh3f8D+GOAn2dOSWkraK0z0uhdgP7WXBsP70Hx5t//w1J/8ZV+ftYRPm6RL4PRJxXattM5Jux7atTFgItl81ifKphD5+su4buPBpGg3CVKn2XMYjU+bVIAtntB4N54ScSYxZEveSXjvVie0vyyK1CEfO3ppL3FYk83IuX1jLsnFHmnfeOwmgY5zfglSj67HYGm71hft3mlrzGTyV2kO1a7YmrG+z9Zj7Kv8jmmnDTtR7ETGBKplqRf78WBXKLaGcg0i50GbqvMhqLvGrmBJm9hR68bO/lytA1M2qBP79tlYz/V89yHt6Ncj5+b4Oe9cpb7PU17RH+ODan+n/+u52k4Z9LwuCtE7VO3qxzCK/6bKwyOoNgX269hGObbdN+5rW8fRb6pP1yD8ofoC4V19Uu2sbabgfHQN2FCPK2LvHL9A++iwBvhHRg+88iwLSWooi83AB8p9lsDWceCZLLm1JbgePxgHXlPMJxrAOJQQ9RkG1+WGDRumsX2Ta8NDBzfy9pCf/o7BRUMCIN8Hunnz1mwgNIe8IuWB038r6X7Bx8gleRKgVh3oZ+J/nl97BFpkSDoAOX5tFFQdgmCsrcxr3wnymplkxEWCjIsO7tjcVi+1wNNKI349Tx8ncUNffwlnHx/XAb+JcVVTl89rG2PXuJX86oOdpn+bHNCd3+cC7QrttNFWMumLL6yQ261ec76CPr0ZqvT1XCOSZS0x2SYLfo3266Q/e62M3Mjme9vwaXJ2k67d/q58KuDT3gd9/ULewzky6BG++6A+/Wz7uvvaqs/+unrvELQxXujX97tzU1COtIFqU/b3yaejOmsC5ylZh9DGZJvE5b4VVNv6fRT/B/1+7LMNpS27DvkgUD+y1vhDfbblXrwE2uhr7fR12imfgvKc0w60IbPa3dupTf86tDrs0w+1vO4H7kepv3aM4DfVhs39OcfaIPKiWyh1YmMl5XguecZUXoi82m6f3uAc/9OP7DlEDmRfuzrujTXyoNbfh8is257qdbamz9wL6Fd1hNyTIOcjRzkZ++T0vjCmMnZtc942BLkmyCKHTcrm+lk79diRa0rbKcQe5yOnR3SJjXO85qBdfDQFPKu/xZMoPxD6Ru3lyy+N5yro4fVE32RK2w2PB4zxK1eujN/9zXWgv8Xz1659NMZ0a8fhhg3fJpzvZ5gNG+4BBAG5od8PCCJQApg1stUVRLUkw9lfDu8nBDkSHnTpgyhJGbhInzJzqal0ktgRPHo4X3SCC+5FcEdnCRgJEr+etmB5eZJiHsv6gb/0K5kgUdX3rVVP+E1NKgRImZD4E+RzwXsP7dhKng/Ne/3P9bGmz1vds5WtOOvbZxUVmaAfTcbar5SfjYnASgJ5ySr2SLAmYbpvApfregp0JHPNtaGN+uGbSeS9QHwY/chB5Opb/ZQ+rj7kCz6JXzKBOv/YvRvH8KxtpnwfG+NfdoYyUaw245exYzyY1KI6Nox/tEZfddeMDdCGnIyRpeh9Eh+wVx+j2O48GWyOXbWf99npXI/oOSW3+jw819gF6u9rk3NVtq3jlEHsTD+nb3ub52zvUe2NjB6HbCX3UJ0qh218ar8f1+od4gXsY/OhMZ86sJT3IYQ30BkBnSLjkBzna7/GL/EBVNsQmbWvl8jJWD9Ub+l4WVpvCtG78oh+wAd8EvhRUVW6P//8C5MJLvAM3BJcjx/0u/vCK6+8fGb8ugbyWup5xuOGDd8GbCu5Njx08HFFHxG/H/dvDw/JjLb8+7unk/pliQz1PYQkQgQZArIH/dARJGZ1j8SEoJeNEgwCqiWvqU0Bj7qSy4NW8mXfBy+bb58Zk0Tqeijz0aMCH3b94ou2/F8Aqr8FlOeB8dJ86AOxt8Z+AeOPv/hnzkcZbxJb+nVuZVn8LmDO5GAJ6JLJlv6ix9yrfDCIuYOpYe88XQLjgP8SjNPPt0XU4Ysa8F8k8JekdG1Pw0d8Lw16tUTIIcS/zT+t/qHrXhsJA2321VWPXzLZycSHnJD22c4hPNJmKeio/poJU3S2XTrWIEkbdqDw6RFbQ6Cusb0U4a39Gn9o55pwva1B/M+P0bkC3+hU99Mm/bZEX340ToytQ/1GTurbD7Rr95Rdf4Qq0pZOa/yPL3nkVHujQ2TFZuR82q35sLL60RFVeVVmlWUfXNdVFvna7LOVLMCnlxM6D6qO+MKSvg60MYa1d33G1kNgu7pz9fFVJ/XoRA69olvsj96gbuyxNaac1waPJYhN2mszpyPZnq3x1756eNoeuocZIxkPaVPb08mWrH7cKOcvNgfqaQvakk/f99//YJTluVnrV3hubh+Zf/xgnBjfb7315jhegpbQ/GT84wIbNmw4jC3JteGhgpu7ZIok172GZMHzzz87PEzaxK79Cro8UeXh41VAba0ueRgCDf5rWwGXSUkLqCQrBFxLg8gegjC2JtgSiO1LcqnvIS25wKcCsQe50m0tTFzykXnJH8cCjPPqL8HVgnMfif1kLNNn6Kmn2q/ZfEeW8dTLU895wS/Qr/ap/kGZMGi/RGd64asqueQseRX1EIzBjEnJayuw6Ob6JpOPyeHjNj6XJ0mWgnyy8J7yqWvj5ZcvL54A4qcP+XfpNa9NJoORz9/K45/0Vc5nq6/5rE7Scm4OVZ52S5EJe9VzCcgis47FIPbF1mp3L2+OKrTXbl/ioUeVfWgSW6FNn/hYAu3afbfZFdm2vW0h58niQ32mDLKdA9+Tpd0h28hXP/0V0LNP5E3JTVvnphJ/4WmL2ISC2HXINuXakWWrr+m4BOQaHyhtIjPUQ5l2rutqV+zJ+Ur0qsc9psoOgRw6Z9xkG9APX/28dByrb1zhlfvIEuy7F8RmPoivUyd6R479Oairj3OtTI2pKZCrDR1yvUzBea/n4n3ofs0G9atfYydKf6tHXnixIRTkGpnqI+2dtwX18A3wzbMwP4LV84GPjvPX0v7c8OjA51OuXHl5jJ/T98aEPr99+/becbxhw4Yd7v7ZdMOGBwgP/+GR3g7uIch5/nnfiWrfTvEA+fLL5d9ZsKpGW4GKZM/Sdvca9EDtr+d9MwZKAiF07CqutRAMCsYlFuggifEoJbgEFRKfLUDNr7LTk6P1uHtst/4ShO9eMRPA86FEbA1w1eVT4882QbQ6JjJ8Hx54HtJZfQGVavoITza37cUiqtDVKrT42LVnK/FFF4kvtrCfHzIh0K76Yg3Y5nqdwwE3TWLOt3TkVzpnQoNSZquO/uHnSsp6qiDzUJ9C6qz117HtIHbHXn2H4ofw7G0l03g1BkL9+UrHIO3otxb7ZMbm2s+xOf2sPTuqbdUHsct+eELKDyF1tEvbfYicHvSNzDm5OUdOb3Pf1+qxsfanMttQ+PVUZcESuyrCu/f1nMzA+an+rPej3tb0c09T6OWSxz8t/mjkWqg69/XneM8hbffpNYW0iR/6fs54oSedITKia69/T1D3l+oXvpG3D73P0ob+1S5bdsXGHKsHtU/6bfSpBFO61XagTm1DXpM//8zzupqxgs+GxwvuNT40Lw5K3+tn32fbVu1t2LAOW5Jrw0OFTNTvJQQvVnD5S38eHoKFlqha/vCQfBCIaC/AS4DysKHZ1yaQ9+MvP3ooS14g+5991l5RfFj90yPxpISIYKJ986qtXLsI4N8Cl7v9IZH21VfGU5sUQluJt/vVF4w7deikjXOSQ3zu2tH2UCBEhwT3eKjfbGz88L8I6Pb0fXQil66DFuMKmYxRidmmi4C/1Y2/6oQkCdQ+GcZPzicx2Pzc5JNRJyw9jhmfeCF8o1uT3ya9Ad4o9uc4ZXRLn6GcC+xXfktxTJtgqq2yKZvjV+dR9K8Uu2JjtRdqWW03hZxba98xbUC72Dxnd+plm/3YE1trX6de6mb/GB2DQ22rvArt+raOe7urvbbhV6naFptjPyhfCnWndNuHyj9yow/ErtjGrpZU2CU50seh+ADFB3M6RVZsd1+doqlz1VfVjkA5HOOTqTaOe1/E3mpnbIpd2aJqR/RLW/UOodbp9TsEbefaKKdH9mt/tufFrp/ZGz54hmJjtbWey36PlE/pphwfNIeMtb69tvkmJX9veLyQBFd7m2W30s8rivrdHwDasGHDcmxJrg0PDRKITAUGFwUrYCQEBDiCBK+FrV2JJXCip60EmWDn24H9/aLfJBwQNN+u+5bNEpDD94IA/ZikWksGHX9LM+wa752d9g2NfQHpGniNFObGm3LjKb/q29eGXQnGbVtS6G+n49CrIl6zaBOk+GXuWmrnW3AP5LgWmk67Sc1FIjyjm+1XX7GxBW3O2Tdemu35aPouIQD4NDKJMjlr/WU8ZEw8+WQSYs3OOpmZ8ociSbXwDnJceSP7kPLUqwR0pnudBCpLeWw6BPUq36WIrDVIfbKqzSg69DbHH2zKttpsX1lvc93HZymqjheB3pZqd2yr9vcEdOptVhZaCnUr3yWIjKXt5vTRttqNwrPnnf01fR0dlyJtIP2wBrEBsSn3gClyj0CpGx/s0zf6sRXih+qPSu5nlZTFvqXo/XoIU/021cfZVkr92FjtSz/HB8i5+AI/frU9hLSvcpdAG6g29P3sOHxzLrYDHtW29EvsdC52Btnfp2v8MFcHj/CH6FgR/6XcN1Ylt6zoSbsNjw/EKpcuXRo/C6LvA33u0xbGZhmGGzZsWIDtm1wbHhp4oF+6NP0XZC4CJsMCWR+ZloDJKpK1SCJH4kHAYSL+uEPf+IXJgxgEgf03uSSa2p+n/+547rPP2oe+++AtxwK9GjxW1DZtd3fM7/QJJbElCBT8SZCs7VcyyEQtuCQPCd73/+q6Bj6CawxaKWXs7EPViW+ffLKtHOQzNragvX0LxSuh6nvl7+mnk/i6+0/981cmc5JMdcUWOXgi/TrTNatBLzJbv7XEE1mW3k+tGJsbE4eAZxsTu0lb27Z9OviehWCxgjyBpbp1QqPNFKljq16dqCyB+4b+WNuGbmT1uu+DcUzH3qZ9cF67amcQPpWC+FvZUtsiC0lsLr3GtDNGyVrTBhkDZPWI/tkPqo1r+5os9eO3JfBLPj366/YQtAM61naxqUe7T589V/u37ocCdumzJASWgl/Rmjb6mTzov4vW61+Pycm1prz27xpUu4Pqk/gp/kj5EtCHfRkjSxC71Geb7T67nIscBLlmomtoSof4ful9J2ODTDzJil/2ocVT7Y8nLBm/ysnhDyCn9nHfzjH71Dtk8yHEj/vakxd95uyxj1d8PIX4z9Yz/8aNG+P+hscLxooE15Url8+MB+Prvff+PD6zjhmrGzZ827EluTY8FPDAF6g/88yzpyUXDwkBwb2VXB9/fP1g4DWH/LUbQUcSOY87PITvTnJJFLaVWoI1HxbXjxIuiH+1c65td4kpiQj+S70K5/VV3SKvsQnwPOwRHfq2+ldZC5aXToCzbUGncSgBI/HBvqUBfpBAdmp8+UucmRDN/7W/HRovAXnzi3HH78Yg/nyYILol5nZQP8mxpkvTh2zterAdxbeBthOmLEa7tttfwjIGTGj4gIz0JXK+JSrJW54YWAp/LdP1Wm0L9LnXH/ms2bt/op8xmUnTUpDD/3gvBV/pd3qvGYv6EmIH6IsQ/bMPqaccyFpqW3jB0kmY+nRkG1lT/TKF6Ezmkjapj/iSTfbBfqj6KVtIu9x7loJtlf8S8EXuD0v9Aa4petKxtku/9H1d+ytgW59ImgL94o+145HctW34BKpusQXhGeptOhbpLz7JuMj+FPgj9Zb2NbBt7bjKM04/p131Q/VBdFIWHU2Yl+oY3y/tMzLShl0ZJ4dkGr9078dU7KlUyyrwr31Qbc99d62vpxA/47OPlzrGb29PrgPU2zAF7fPBcfpveLxgDPjx8403Xh/HRqCvr137ePz+2oYNG47DluTa8FDAA/+lly7vDYTOCxNtSQaBiXfcj4FgrH2o++/jMuI1E5FHGfpHEkvQClbgSLag1neXxod1gstGbd/DWnkLMFv/iu20+eST22f6HA/JhgSjkh5rx4T+IUcCbQkSZ5ItqSbgYJcVQPp3aWApQDG+6NuorSqrY0Ryig/bSrfPT0uXgX5kSL5J1uiD6ps+yWWyISlJDhtfeOHF0a65CUurb/XJN3eSl0Gz5/RgJVoQ5xXh3asifJKVXM4n4LdttNsH8uuYQruy/ZMWfH3j4vPPPzttd3qiwAo4426QdJBfkEnj0vrAvxnbS8Fn7jva6bva51Ngb/Wl/aDZf3YS2IM8bdbc26rMNe0yKdZmblz2iCx6pk2VD9Xu2IuU8WOOl4L/6bim3+J/bZa2q/5Ah3SM3dqQVe2qfV0J1CcrPgLnXJOHoF3G/tSquDnk2l/Sz7FLfbraJ8/xRaH6JL6yJW8uKROdol+ljA+0FLmu9z1j8IbITb9V3aN/qEf1I//vk1dBFuSaOQRy2KQuf0Qu/ciNngF9YpPxAeoo07aHtpVH2u9b6eK8Z3quqbl6S4EfXfHZx0sdtvNdxn6P2OMcvkHKQB2+88z/6KNrY9mGxwP6WAL2rbfePDM+jGdzlOvXb5yWbNiw4RhsSa4NDxwe7m7wL7546bTk4kGGX0B9cN4EfkkwP4UkKUzO8agB2+MM/dMnuTyIBV8SGAJbSaVvvmlBZNzCP/FR7yvJGquZark4T3Jprs0StCTXyeI+TmzJRvZJdLVXLr84tWW/DsZWa9d+tc4EAj8rl5TjhY9gW8Cb1W5LQYYkEV4SZ/2kw/nYAWQg0E+g/+gxtYoLYsPg9bGtdlbD1b444IpJNN3aNS7RnFVddEkyzflgZ8vOpiq38Wo8W50cmyg0PVsytTUiV7L0iy/mX8HUXoIS0n+HcEzig38zpuLXQ6B/Jo6ZKDYf3U3hG97KIDpWmXW/Qt9r14+xQ2jj/ezKhUNQn230Mx72odqJqi/Btu5XOK5t19rm2eF6iB+XgBz2abO0nfpJChhb0bHqHnIupB3/24//0xbqPvBdkh4VS55pZLX7xMnBPqvox4fjbHvbgv54LdgSezJWalm/haz6gehIh9RJX9Y20XNNX0OSIHjFzuqPKZl8r46yOkag7lfg5TqzZdvSe5z+ArLmeFfQK+Mqzx364qN9+MQ+BNl3rieYOlYf34ypfTZ57pKtXnx5HqTfpnjFFnqpF13BvjbxQ9o7r27GG9R2ZLk2P/zww2H//PpvePDQt67JV155ZZxXBK5p3+C6efPm4ut0w4YN03jiX//1X//L6f6GDQ8EHuxeqfKQv1eQIPBAEXhY2SKAWAv6CYA9eL78cvkKn8cBHsiSEwnCrPYBASyfSFa0pIhJ/91B6hTCq69Tj9vrbe1bX/qPvPYKY5vUJQisyDiSiFuCsDA28BYI48GeffpDkljash0FAtj4DZ+nn35m5C9xZCXXVIA8B+O36XR2ZRjdyejdwGf80xJazQZ6kD0nt/HZTdTiD6gr8I4B+/FkR0tGtQk5PwxcW6VTKA+1lVtnx9OO6Nn2W71mV/vrirtxxA/GZ46n4MP9fBb7l4B/1N3Ht0d8DPvapR7dEVkpS3mAzxypp757leMlUD/bpW0geq65L8YWZFzXY7yyrfZHJ2XaOE4/zBFkq10tXwJt1vY1aAf72sXmbKutKQvCJ/qHar0lfa1+5FQsbUsW2ueTWo+sbFHumdnWOtpVWoL4gT6IHdHNGEl56kDVLxSZqVtpqqwSW7LfI3wjJ36ocoO0D69ebvgoX3OtRZ52aAmiNyJ7DtEJkVOPQ31ZtSm81an9Vamva4sPefbVmYO+gdr+IhD5ddvbGZuQ/qpjs5J6IUgZVF5rfhzb8PBCTJsPzaefjRGvpXrDwf6GDRvOh130tGHDA4KHtwnmvQQZEhKCizWBYUV0bIHKt/EBtAvEPZQFdRIvEicSQkv86lku4OTLIYa783CfQhKTqK1isurDX1Jsq4FQO3f+sUOPrAZa+ksp+xPYSvoJStqH1XevDvGJbT64LhmTZOBS5NU9uLsdnU93T8EG5S143tmybxIA+mP4d9xvq8XaX2+UgLaNDhVk7+nCCTS96MJ32jY90WmVA0h7+vEvn0hM8ivKr/rqZXxVP0xBXbrda1SdwH4be20SkzGV8tRt+rX6FcpR7mvIfsqPwZysi0Lsis0ps59zaArRLfZVm5faPcd7Hw7xnENkVbuW9HU9DmJbbL6Ivu4xJbdH5KUuqva0e0ajlIXUrce1z5eC7Dre91FFZETeIZmRE1nZj/09Kv++j6udVe4UH2XVhl5mtj2vQwiPY9uEettqf1c7Uwfiw+gO9qfsTN19vg5yjrx9UO9QnR6xI7bEnmoj6qGs19t+b2c9DzkX9LzJ9tq9VWkbHm2IY63eQsZTYLWetxvEMRs2bDg/7p61bNhwn9GCh/ZL272AYEGCxNYE+BjQUUJFELJvNczjjBpzJcDlBw/mfUkb7RIgtoRJSwSBwK4P9tRtSaxnx1+7JG0kXbwak+9QqSOoVs+3lPA+HoLVtj2UDAnIk7SiR0vyfTXqI3iRTN0FqM025+jNhrZ6aRna2LXCyGqkXbvm0+h9FvQiq+8TZb2vK9jufHR3rdhv/dZWkqGdbTChwB5omiA/48DW9c9v/HmW/zq01xKbj5mKl7LIaQnAu7HPL3NIm336OheKbdnPcfb5OZRzkGsEtfvPblVAfDmHtFuLY9vQJzZW2/ZR7IzdgA/7ksBEvc0obZdCm8hYg8jaJy/nUWyr5Y5jo+sp+6kHx/Z12kTOIaR+j75tdA/fkGOo9wWUHyXy40O77na2pt0hRL+qp20dD8hk0PWe5Hb1FYq+5Pf+dl7dyi/t5zDnj/Csx5GJ0gbSr72+h/o4qD4JzzWYaxMdUWywH7/1fY3Sz86lDUTH+DX9g6p99tlc7Q6PpdDuUBt1YltFylD0D/VltT9jb/qy9mft09jUy51CeGX8aaN95cHfV6++eke/DY8ejJ/nn39hTFi6dgL3MR+Zt92wYcPFYN3TZMOGC0Z7UN/bh3UCE7HC0lfYKujoYSSwqEHItxkJwCQTBHf7wPdeaZSw4kdJIb9WeZgL7CoSyPlLjhJG+faZj6565czWUu6bN2+d3L796Rg8Czglu84DPMim2yEYB777Zdzm9cEWuDw/jo3wUE8dfCVw+Er9BK1LgK9kVns1L3zvDtYrWjKnTZgrrCJbgsobjy+/bB+rZ48+pJM6jU4rrkAL3FsyxHjwy7RfNG0dh/950MbmF3fGGZ74G1Pzia7DE8wKY3eJnvyG6GCchVrfNl34mY+NZ5T7DGr+Wq7XeRFZx/ZBGxe7FTts1a9939YJIsReVCeIc4j/j9VzDXKfmpMVPWo/x96Q8/iwL/2ciXHsPrav17aJPfvQ24T6frStY1nZsYjt/MAnfOPa5aeUV38tGSOgfr2uDrU/1NfVH2z3vLKt9fGYu56X+H4JyFvj7/h3qk14odiln2sSK9v0NbCn+ld/OSaHndXXOeYX++EVfeZ024fYdAjxeWys6Md3bI5u+LMh/Wkb+8J3Dkt0q4isoPoGHKcvejs2PBrweqLvoxpnFTdu3BhjxENjasOGDcuxfXh+wwOFB7ZvFXlo3yv42LwkS0uufHpauhyCIH8JUJJAkkWg9m1DfCDwgwR5kjZ80qMGjAkMa/DWA3/1JVEkaTzsa8A8B3IknPSv5Bc5Vnbpq+V/XdFHx/3FzN2fqfcrG7uq7ASYbFKPPbHT1thKAOp1VuNN8k3yqyXoPt/rgykIiPiAL5YEtV6LfOaZlkjkiwq68Ms+nzb9n7zjO37Vz2lDB8ki+3RizwyrSfCrZF3z+XNjEiqyJO/I50tb4wB/stnTZK0QNgF9hyS0jN34CF+60YG9S+TQs4JNKBNACK9sEfnx6VJkjGnneloKutApOiwFWWhKFn7Z4h8ZKScn9mY7h/Awzsha08fx/yEZPfif79f4g561v2Mv3cmutmYfjtHx2L5mF334sL/2p6A+Oek3iP6x76IRH9AxPqq+YTvdq6/YpJw+7jn13CGwsed3CHwy1dfRE9X94Ji+Bvc69flkKdLX7d647D6Se2vascl+7KuIbdWOXDOHbIsc0F9TIE+99qxs41UZuxwvHff0b88Kf0V4F4fEJqRO7KY7GwL7tS8P2RaQF15zbcir1/LSsUtnbfgi0E55wD/vv//BrH83PJyQ3Lp69eqd6wOMd381U/xYx+aGDRvOj+3D8xseKAQBbRXO3QG1Z3p5rh8FgYHJtK1AKqts1sLEv31Tqf0S/20D/3l9UBIAarCWgNSD22S1TZ5MtlpyRnC8L7hTv62yaUGdpIfVW3MBJF3Uz7gh3yt9Vunom6zUWRr8g4C0rZBqryDEBqCD8+RlRZY6jsklk53OtWRqmwzQh55Wo0nmKFsDCT+814y3Kr/3Hf1cT4rn+kMfoqx4tM/ftU36U3JRIirn1AvNrTZLok19voN+Qs5eZZJQCOJ/CXF+xR/N2TEHfmmTXjzPjuW2yutunjubzq7gyDGkDf7pM1T7IVtt7K8ZD5Fvu6YdRP/ern2IbdrYz4Q0duMXxGZb5JxjbZfIVB9fbZe2Ae2i49I2QP+5+rEt9tMLRRZEz6l+7vlqF1qqYy9rKeiMgE5zwD/2Rbcgx7VsCmxJndhN1+oT94lsketOHbLds9MuPPBL0qNCeWxzLm2WQJup+uHHB+lnW2U539vjGFWdK9IW1uh4nr4mp7arvsrYRe15tutv5221D4/Y2eKk3cqz2FJt34cqQ/s5hFf6IO0Q+YdQ5SBgqzGUe1XtU3VjU+zb15/7gFewr13VrfryENSLTwJlOcaz/TDQ+mrDww39pr/eeOONsV8DcZa3Ej755JNV1/+GDRuWYUtybXhgcONvQdi9WcWFv8RUm1hn6fz6Bwk+2tPTA0qcIuBYGrA8DuADK6RsIcGhYIsbBNFOWSHDx23lzf6gWN/jqa2Eg6SYFVL6qbZrvrZtpA+SsAkEkPqZfoge64I/8kwuW/CfgNRxgmWyG8/2lxLp7DhJm2efldCyGqV9A0rSBD77rK362ueLKSRptzT4obc2fD/VRgKv9Z9JzbQuklZsTeKp+XPcPcOTLY6dSxs+h9QP6rG+bqvJvhnHThJW0SfjqvVHQ+PbdHY+vtTet7zahMaEYDfxOwT6qpsxwk6r4PR3ztmidq5NVPCu5Jxt9EaHsFTHiuiQtkvbt/5rVPsPUh5bs43NKLJC1c5KYKuN9vpoDVxjsOv/w1BPuzVtILZW22sZAjzD2zZ2OV4qT73wxWMJolfaLJWlDQJtwif25T6WbWT0iDzbaj/bQ+GPJKxyPvVD9RjSRt0eyuPjHrFjyT09MtLGtvqh2h29qr5IvewvReSi8F0CsmCNrNgUW/Rp37+o2ll14uP27Go2hvp6QWyaOtdD3egVnnPIOXWjL6Jb9mOn89lWe2s7FD1jE1uRtpBz50EvbwrORV/7S8ZuBb7aR07Kctx4th9uz2vPhnsH/WSsvvzylfGHy8B4+Pxzn9+4Nfbhhg0bLh7trr9hwwPAU0+1b1n08DxH54EHi9e2kphpQd1xDxKBhV9c8iqbiXpL6pxTyUcYu8AuwZeAsiUvJEj4ey74E7jxn5VAxgCYKHmlL7/2B1j0bFrgitoJQaQEmbaSHS3hsa5vWmKuyZYYzSSgBZAtaEb564mDVqO8Nqb+Pv5KlzFGn5a8sepr902ZNaB+JiFLkEBK/TlZ7Gh+We4b/KZ8SQb9XBepo0+b708rDZjuh7YKRn/7JVo7qy3js7HGYIK2fM3nbWy1PiaTn1vfsLfZrL722ugPSU99OTUeJNbUrb7yGmWObSvFr9mnPwpybgm0X4vKe9qn+8FW4zKTQ6QM4Rf9ewLbajOq/qhwfIx+x7abaqMMxeZqt/1aJzaE2NVTtReyXYopHfeh8p9rG/1rv6YvbR27DloCuNmdNhBbp2xR3u59dxNfZF+91O/HRKhHyqNHj7lzkVXP2Wdr9UH8EF9UHexHR9vsZ0z3NqyFNnN27cMheVN2xr6U5Rhi21Sf2U+dNXavsa3y2dem6hsoQxm7dQxnHMfeIO3JrLZWio3hf14s9Uf8AH2fxaY5pI+qL1GO8fEphPamwli04SGE8esbsz6HEOhXq/tv3fpkjIE2bNhwb7AluTY8MLj5T/9VxfM9sT382wqu9q2vBD41mDoGEhYm2Y1/C7y+Xaj9Yl/A1YLpqQRVDwGa4E7yQfKR/yQW+DWvNQYCuVAPMtKfCfzwxUN9/SMxMveB8TlIpOQ1vRZQC0pbQCIJ1srbZLG9JtAmDO0vAzb5ziVZo51XG48BPmycsn8OxiSd5tq0ZFDjPQfna/v0Z17t6+F8Szr5+L7gPRMRfdD6plGrH9ZkSCr6TtlXX30zXq8teeye0CYDVk62frh7YqM9/xpz7ftt7ePOyrXXT/whidpWaLVJRXhN+UAfJ6GZewayz05UfXMswqPaswRzsnc+3k2GQ7Ws30cB26Zshouw+RDIqPocQvRHsana1pelHKUf52zO+R7KjvFF5K5B/BGqduRayFjOuFYG6tcxHlt7e9GUPb1P4pc5+yNnKfCg61S7yt/5UBAfpD2qZfUcRO/YtNSelEfGFE1hqh7q0Z+znbJjivq+rfaF2o8B7cem2BubIe17RKeeci7bfRTkeEr/nnr09/3wpX9sQWy1zbkco2prr1e2a6gC76k6KHbar0h5T3MgI30XVJ72rQyqn3rY8HDB+NU/vmebvtavfvj0Da78cL5hw4Z7g+3D8xseCDyg/RldwUwP5zzLPQxO45RF0M6DxETZKiH7vu8k+VADhfOg6d3+ChyeJukCq8cV6QuJAg9qx6Bv2C+pcvv27bFsDppIOElktMSDlVDfGZdqS07gVbG03wUQeGbrw/P6XuCnve96HZtkunz5pYFHGzPslPyoEwbgC3KNYbLYlLHRVv61xN9azCWU9sFY9xcK/cXJ3p8VEr/OC7KmwBY21Y/2S0hqs8SXgm32W1kHtR216Oh64ZuKF17YBeptkvb1yMevnXSStIIkUtsY2Z8YkUzVFi/+sa/Nrr2PAe9swqslxp9cfE3TET/jYinIScC7pF1spL+xTl4dV85XntnGR6BMmxxD3Q8iC7RBvS+m2gXq88nc+KoIHzLbuHtq6I9l9+rYmz4N7E9RD+1qv1W758D3eGX8LAVZMDWmpuQq4wv2kYWUpW7dD2JnzpFV71VTUM81x66KJEcOtdVOe32t/hKfaMcu26mxH10iW71syYr/UWxO2Ry04499dQJyUPSYsilllZ+yjEfoz4UCMtSH+KOez1iDtMUTRUeybGNb6qVd6oWArPDuJ9hT9SH8tDU2om+t00OdXGPap+6+NoE62qRt7AbHkR/YJ8u5rJpWFgpiO17qTdUJwqOityX+78srIhOM95D6S6E9WeHTAy8f3f/ww48m7zEbHgz0vdVbYsn6mqJn3McfXx/7bM042LBhw3psSa4NDwQCgqkklzghwYIHwNJngCZWfpiQI4GECbKH/kU/SDy8mpz2YXAfjnwcYVWOpJFJvz4RZNVAju0C5T5h0UOCgq8ySRFgaqP9FNb0u77It7jIkZwhBwk+Jb4SIK8Bfv246ZNPEqnqsYUMNkpymQj4DldNRKzB2iQXHUyKoU9k9KAjXfXBFBJQ4xO/+SXSvuBsCegjWYSPPm4JQAmhJ0deVsFJDvfQZ/7KJVskTy3lr2MEv7bS64mxfdNvenIB+FnVRV7loz4e/HR2DLbvzpGxtO8y8aDLPr/3yLW0ZFKiHqoTnfRNlZn9Xo/Ym3thrTdVt5J2fJR6++xMG3pGP8fQywxVOfqdrLQFdVzjqYf69vV4CdSjI3+QhwfYkpV9CE/blNGv6ngIZEHf1/hVip3Z9ojvQzmOLtrEj8bvkrHlGol+gXZon42RpX1k0eUQYlf8D+yN37NPdrXXfu5d9d60BHTUz2ev9WlEPtum+iD6QPTLNr7XLnXq+SD8e6iTa62XHz4oOqLIynXTy8Kn8rJNm9yXIeVTtoenc54Bzlf5PcJrDnhF5yBtqk1TlLpVdraQ51r0g5zXXpltxl5va6BOz7/K79vkHNjns/Sl8Ueu47VjN6Cna8YWqn6AJ95//OOfTks2PGj4Ufill84muPTbX/7y/hAz+kvb68fBhg0b1mFLcm14IHDzn3qdrE7wPRCG/w/Cs94DX4JBoksAI4DT/l6B7ibEZAqsDq2geZQgKMuKFkiQ20+G2L3vrwbqE4kgiQ3trZrRRjA2hfhvrRsjpwawdNU/kiUXnYTMGCWPbPaTJ6hho0TbnI2HkLG8BrHVGDyEQwmr9qqf5FR7FQT4trU5vDon4BsTPmNIslQy1HEmSfq4TrIC5yQtk0A0viQR67Wl3HWnHySw+Nr53m/kSVhZhUgffxSA/PZKZ6tT7zdW6+G7JsmVMUD+3HUwBT7WLnLsh1f2A3zxV5Zy/kw9Pqv1e6gH0dG23w8iA4V/6qBMpmubqrNtJmI9Kp9Q2vY25Hy1Xb0etUy9JcBTO+PbfrXVdkpO9Mm+tkvk4ZW+DqqsisgIX3Xo5565RBbwY5I6mfDvg7r0q1g6Ga+ycg32YGOo+je2hartrtuMswrPJOB755ciOu5rU/UKgXuUlcpf8OVg3osvvnBy6dKl0fboG135Ebk23bcGdieXL18e61Y7AX/lt2756PTXw33n+XEyjJc6zrmf60M/3jivzPno9tmgm/sZv7z4wgsj/7QH9mgTOfqIDN8HUqdPckUndO3atZPvDMf46g/11aFP6vCJ1Sh5ThzCd4eYyUreJCvpig+5eNPPK1yJKfw155deenHsP+fpgNR3/tNBtjZPD/rpk+g3yjr1kfN+6Hph6LdnBj7kQXR2jM8Xp88nz0fygA+4Up8nUZE+tCUDOdYPnwzj5PmhfeqmLzIutKGP8mNAFh1jA95srvjzn/8y9itZGx4cLl168eSVV14Z+6viL3/5S/mBbsOGDfca219X3PBA4K/T9Q9omCo7hExU218/FAC1j4LfS1AzAY8g07HEgOP7gQQ8JuTx2Xlk49e+lfXsaI9jgaDgTZLB95MSbAZJhPRytVUXL1uvi33xxf7XRvE4Vn06CRwFkq3/TTraCg3+yauGF4VeT3IlZZSf5/VVrl07/tXvA/d9yIRlnz/0nyRu6phktTbLA7PGo/mqmkRHY6D1TRsbPcgli11tFWGbSNSx41VDfUwOm9Rr/dzq4N/aNFuRuuQpq4jP6domJG1SuhTa432oTeohtqEcRwfApye2qBMe/Gg/PNrKt1sntz+9PU48K5nE/XW49vDINVzlBZU/Ivf69esn3wzbJwc5aYNP0LcJfT5MGm/euHFy4+bNcfJn8qke+c6nXZD9W598Mur890Fmxqpz7JQ8vvXJrXEiXG0LpQx9M/gnstihrT/Tbhy4v8UGvKveztP3xqA7f5IVv0Vv6H2Q9unXTGzbPenuftY+fUum/kT2lYG6SNlSRA4saRedoldAh2rjFLRhm626eMX+0JzNzsXeyMlWv0/JD8/wWAo6TPELYr96IWPl/Q8+OHnvvT+ffPTRtTYeTv/Uv6SXe49xRNfYaAvqfDC0/eijD0+uXr06lkdnOkQevPvuuycfD9fYU8M48WpTdNTm2rWPRz7GsySOsZT2ricrQt57772Tvw5j+5VXXr4jP6g2kfPBBx+efDX4/MqVK+O5Xp/0lz75xS9+eXJ9sJl9zw3P8fBW3776nw96eUXOxJ1/Qh999NHJxx9/PF4/tfyLL78YryMJu4BMtuDD13x+/frHJzfH+8YnIw8JKD9UiCfIBbrzzQcffjjen65cvnzHJls6SsJ9dO3ayW9++9tBbvuMAR8Gsfn3v//9IPfDkycGGUlgwu+G8r+8//74zHD/y30j1ygZyDh23/rtIOfZZ3bxU/oyckA7dCy0xQtP1IOd7QdefXtauOG+QZ/o/5dffmUc6+kjY8HKdPeG8/T/hg0b1mFLcm2473Djn0pyOa5F/fk5pJ6ATADgAX+vk1zgwdWCnfaawqDJWH6vHmJs8+BMYB355AreWjkd2qTjEPhNciAfgg9fE2YJKT5sSYFmTw0y8SdLfUmI6INHe+WrvSqGR0uStcCw6lVVXKDuXuCL+KglNloygw4t0cWGVueigFV7FbP5ToKLvcfK4NqlYz4gl43x7yFkoiQwp2YlIF+/8qM6rWw3wVkKfmm24JXXXNoYiTxy6BM5gTpsQW3Mtw/QG6vGVSaXyDlb53dJ7jbO9H+jxksCzLZH9Tk+4bEU7Ro4O8FCdK9bFKjXfHGYKsIn+uX4009vn7w7THhNZCVmBNQhgbXJ4ifDvlUm7r1srPqQQ6foaiKnzW9+97txEnrpxRdH36RuoK42aGAwJpf+/Odhsvq+yer1k5u3hsnqIN9qCpNWfN1HtIsPwL5zf/rTn8YkwhODLKtIcl59Kyv+PEyofc9EnWpjT8OTZJywame130fXPjr58zCJdq+zkgVqX6EPhwkzvU3Sb1y/MU5cPx3ktA8ED+N3HGO7v96H2ng5m9jBt0JfsQMZ645DmTDXOtVmvHJuCdSng7b9dTWFyLANIhMFqYPCv1LqVv1tq111H492D7rbLudStyKywmMptNkHtsU+so2tP/zhjyc3btwcz1968YUxMWR1hvuJ60IS18okK3+iE+Bzexgv143R4Zp8+623Rp69ztHp/fffH+W9MIxJq9tTx3mJIcmivw1lr7766nifc54MzxmJGePV9Zlx7VwFPkg9iSNJmKtXX71Tzzn6ZVyDer/57e/Ge7Zn27NldVP6WfvY5LrgB4SX693z6PJgD5ty7vnnnh+vadc/kGcMvPvue6MfRnlDPavfxpX+w/PBajYru1wn7v+1rfuAxOOgxcnLL7985/4EzrtuJeDcE93zrly5PD476O484sff/OY3ox4vXXpplO08+t3v/zDew+iFtxVdtS9TT1uJcbKMk6y6q/Uc2+Z6Pw/wpDt+PeiJ6IQ23D/oD9foq6++Mo739I9rQaLa9bz1yYYN9xf7n/4bNlww3PhNTKce0BNFKyFAROdmtBgmzoIggUebcO+CxYuABEMm95UveQKmJKHaR9JNHtqkax/4XiAkME7CQKIOHwEze2w9kMmZgrqoJRrwySqw9vpLeJkcCiTpGl42YVv3zwv6kmkc8YNj8vkttka/i+gjiZyWzGsfNyd7zl+HQOepa+IQtDFGlgZPh/UTmE/rkhWT69Dk6f+2OovvTZDaHy2QbNEfvTx6ZiyyTRvXAVKf7/UhXdv4b/2RBGtLeLXrAC919o3nHdr5ub5o/t5Ninuq51O/R/TJNhMfx/v0q+d7vl8PPD77zITw09GnTw33In4Y6alhjA7Xt1/4vc7y/gdWJ3w1qWvI+evDJP/GMMlrH8ltr3+zkV9Rb/NXQ399dO3jk3ff+/Oox3cHPby+Y9LnvAnre4N8E3f8e+D/2TChVc/qjR7Gg4SAP1jBxjv2TZBxQibwLdsl3L4scqM3/+NrZczH1z8ej58Z7mVW1jw93DPcQ6zokAQzHiF+qD6gP1mhNuZ35Hw93tfntTx2LIV2S9vMyde+9rPjyjPHtW14Vdvji16G48qvQv0p9DyWom8X3VH6j53R50NJzps3xzEkIfTGG2+cvPnmmyO98cbrJy9eujSORWNFwiuo9gyemLWjgmajfjO2Off3v82fI8OYdF2ZSEO1L9Sjltd67tEm4/jyy+fDde9ahvgxW/fhy1eunLz11lujb94aSDLO9ffE0FaiSpIvdPW1q+PkP+3Juzn479pwP/jmb9+MSek3Xn+t1X/7rZHva6+9NujxnVEnq7K0ja6e53TwGr3kPaQ/wf1IggzY4J7T94kVrvz31PC8oHd7Nu3sRPxqVZt7BJBNRuodQq0X3Y8FXrm25uS737p3ic023B/oU2PR67h53oE+Mr6MHfeMDRs23F9sSa4N9xVu/s8+u3sInBdTbC6I9WIInkyEoE2y2oqoY6GtCbuHpkBbYiCJQQ9KAZ1tAjYBj9UKdFCmXlbfVDS+Lbnl9br2y2tLSHmd0ETWaz1zCZPaZ+oILtt3mtov8wk6ncPr9m3fzJheMXSv0D4yTlfB7hOjTxD9JEB8c8lf8ktyb7fiaB3wx0O/8N+nn97/7yxkjB0jt42R04OC1kctmRFYvaDu1JiaR2OelVT87zrB274khdV2xrHx6HiqH4wvH/E3LtOXEhbGF+J3ExmUBMS4auD021pkGQf7xt1usmCCc7o3+ufuRFZf1vjvymMDm10HbEb2USb+ZKLUX4K0AbLOYOy3NvH83ve+d/IPP/nJyT/8Q6Mf//hHJz/84Q/GCbokj1UTVqlIMkbnSmClyo0b14fzT4z3BkG6a9n52I1yzC48f/+H3499+vowWf3B978/yP/HUZcf/fCHw4T16tBnn5386d337kykq0z42+lrqLs+2UHRUHtcsfKDH/zgjn1T9Prrr5/10dD2m8FeiLzINm7++Kd3x8SGifY777wz8vjnf/rHk58Muptsw4cffDiuJsuEmo76lr3Z4pXj2udrkb6m3119vQdpB9WvEHvDE+W4R/o34zs64F3HdWyL3Mg+hDkdAf+pe1ptM9WuInViY2yox72Ntuyx6smxBIu+t7qn/UDyzPj64fe+9874F9Pcfz748KNRnvr3G98d7PAMM7GWOLYC0diLLbb7/OQcP7N5R1+PSSf3UNeZvpAgyrWKp35wbN93rl4YJvVJZkuu+IHBKqwnhmerY4Sf1x7pVceI1U/uLVZR8avrFh8/mHkF8fvf/97J66+9PuolCe15QA8khnl2IPcnqy4hOrJFAssYpZ9nBvJjQMAGsj2jnh901L8V/Bs/ahv5jhFZS1Dtje7nAX65r1TeAf7xu/hmw72HcWKMZyUg6BvPilu3bo7X0IYNG+4/7v+TecOGCex77u8/N3XyfEHEMTC5aQmf3S+Mx4A9AlcPTEkZvywKXPMR2qmgpiJ1JA4q8DHpFxALfiTjJIRMOiUIJA8ETUtBjRYAfzY8xL061L4FJLEl8WBC/KDw5Zct2ccHglG+o59EiYCWf1988fnxo7YC5brqYymeecYvv+0VVb7zzbJjsVL0HWSMCeSXYl+Ark8zvur5tkpwXXDe6u4mURmPrhN9kJVWzhlHxuNcQO58S27tkl2utZZM2CUYjDsTz6YmGS2xmXFwCHSOjfETHY2XEJ+nDt3JzoQjW8TufZjy83mB15NPfHeYMF46edakfPApci+RvJEYkmiS7Ll9+5PBh3+9Y3NstaW7fvpquD/gRVevILmuwHl2I/vOm1DeuHljXIFFxg9/+MPx1R2+dz/0qpBE18tDmQSXhBgZ5K31wTNPPzO+PhkbTZ6rvYgt+xC76e4D3pJXJuo/HHz0+muvjRNj/W37zjtvn7z55hujreMrUoMvtEtfh9KnDxrRY8qvta8znh33YKvx7LqyzdhWXpHj+HMptDumzRKEZ+wMxd6MDfbU6xdJZhiX43PSGBjq1762b4WSyaz7i7+ShscSrLX3EPAy1l95+ZXRJq/91dVcQN86Loeju8pAff4df5z65PZ47XrdcDgz+sM4qFA3hFe2U9Yp57vq57TxR2G0ufTSpfE+FZ6Bj8p7TfCpp54e+wYFEmH6VByTVVbhS1/EL2xx7/LdPjpUeB3ZONHXeUbhMdoyxExiA2NBHau5rOZMP8bH+xB9Lhp4sgX/KfALv0kYbrj3MBbdF2rcr3/Enq6pDRs2PBhsSa4N9w0tMLh7yIkV5gKGQ8GECXOQ4ORBwa82gl4QGLUkyGFYLWEynqBEAOPhiEzo1wRJ7BdEcpkgPMGOoFxyS9DqoXv9+o3x1yUB+jE+04bv43My6SqwvBdB3VrQQyLEXzw0fugnQSIpZ2sVCzIB96v8yy9fGesKdPeNN+BTATm7Myk6Dw6N8Tm01U/LJn+CL/YJ1untOhw2k6BLnfjmVdhatgxtXJiE8LVAkM76xi/z7S8ktu+iqEdHvj0W7DIG8cOXTP1NXlvB9/x4TfSIHySC0xcmR/gJVPVvCK9M1pyvWNOH2vbtlyDtlvSFcUFPZF+7N994Y7zXSOwYu/iwtfIzGfQalvpvvPnGuMris88/G9vgEx9V8vFrrzZJXr7x+usjH3X5CqWdFWUSVL5bhI5F/FDtyxY5Fwxiz6DqbWx+Otxn6ehVK/cDbfWzcYTwe+ftt8e/ljW+FjqMqdiDlqDqsxSxcUlfT8G1xJ6Q4/Cq45qNxyJ2LfVDEP+tQfyhXcYtip3tdfn2A5NyiJ227Ey/GivRHfB0LEmkrmdl7kXKM67QUHDy2tWrJ//y85+f/PM//dOiexZ9K/WgSWybQmwmi2136g1bq5n+4Sc/Hj8qb0WiVV1BtbEHHpXEL75dJ2HtPmE15rPPPj1e1z6OD9GdH+aut4qUp371Oz/z99PDM1eiOral78iilz71YxT4zpn2yHe2nnuuJaB88y98tXGvEt9IUr569dXxvqROfQ1avY+HOIg8f33RDy3hEXhOuv9JztPdx+izKkf7Q6j2gDZL2i0Bn+Z5NAXXg2+V+ZbchnsHPyCJHz1XA32Tb0f2Y2rDhg33D8dFTxs2HAEP+8f9lyWTpqwYEiizeSqoUS5Roo5VQb6FYUKeIHsfEijhkcRAAsG21L9NaDx8BTj28fTAtSJDMOsh/Lij2fzp6AP+ab5uK9j8gizovX795lhHAMufEoJWncwFogJqyRLTEv3cVu+dDzVZuBQCcmPm66/396OkUsaD8WXCR46Ezj5UXdruuuC81W318crEsq3Yat8w4z/+VldfqUffpcnhOZCFZyZk5Dbbvxzl+3W+B9n0orZrQ3tl1Q9zSL01/oGq4xrslTWUO4eM59x/Uv87o7xmGztD1U5/Nc29wutGr77yyviK1teDT28P9w6JMbyid/iOCYSvvhx96+PR4Vfl2PcK1L/8y89PfvrTfz55ZZiAHYVBZGxiH12Q/gv1dldEJ1srMP/6xV/H/eeH61p9+7UOwv9HP/rhyc8GvX0vaG2/VT5LMdUmNiljI1uN6TauzyZAtE1ipyZ3an9HRg/8p3xXkbboGH8c4h8706dsTFnVj01s65PQ1U51D8kDiSJtyOJL0C52hpTluVvLeyiLvviFHFfQDM/Ua/q2cxD+bKt2Ad94xfbK5SvjikR/oVAipvqoR/Rqclqd9oryzfHj8H74ET/4Np3vZWWyXutDdJmTk/rxlcRL+lFbryaP3wwcbMZHGRshx/Rs/bH79qRzebbhK27S9zn319Mk/pPD/ciKNPedzwafGCPGhjp4+YMd/nKiFWN9nwTuC77N5l7ID7/93e/uPGOm7E4f0jkU7OuTfZiTFX/FLz34XXKe3zdcPMSWfjysfQwSXMaf/tmwYcODw7rIZMOGc6IPJDy39z30BSNoH3K+bQQD4+Eq0EGweEwAUpHgSTAFElktqG0TspaMem6UtZuA7H5ZrhTQSbDSVqO0by1k1Zcy/BI8qoc3P3jA4m/lloQCOcoq7yWYrq5wHZ97DV2X7mv96Vf+9qFzZEIr0ZEJELK/81F79UQ7/dSPhfRDW43UXnNZ68s5YNNoGb8kakwS5mC8ec1DEo1dsVm/zY1z4qfGiPpzk4AlwE9iC296Ib7XHwnA40/n2hg+DhJ/1Kcvso9v6+u2qqyHOhXq9z6YQ+rN+fSigH9ksIuPbFv5WDyJqpe/sMgPbfJ19hs04FrIN6dMcvWNCe93n3hyXOGVJFfVBUyEucE3/vKKV4XjjCv3q/p9nr5uRfrwjI2n1ZXjkTooiLypsZzjsc5A/OH7O16DrHA+BK59/sjYrOeWQN3qszmoE3viZ7Jzb2dz+LDPdcMGVG1WJzr21GOqLDIOIW2X1g9qv+Wan7ITfzbFvthQ7a3llYL+eA6pE99XOBc9wg/F9xUp/+ija+Mfe/A9p7vpL2OcMPI5bYNiS4+cnzrnen7zzdfHa0sixivBvU5TiP+NIUkgyTGv9+kD5c89+9ywf/ZVQX6pBLkO96G3zbXno/rVzVP+rbJSFkiQ+XHPfSv6scWzxgp5sRKfeJXMKkyr1L45lSGph5VVXPSfg7EoSeY1bCu6rJTz6uIXg8zYXxH9bMnJ9QmxYynITlxXr/sKcuK3KWj3yivtr0+ukb1hPyRYx0RwiRX1hR+SJV3nruMNGzbcP2xJrg33Bed5uB56TuzOtx2yPNAFOUvlps1FwMNN0CWAFZx4GApUWiAlSGsBCZJ8sNWmR3QysUIt+G8JM6jBTUuYofa9IrK9upVXCJNAWIs06Zseweq+QZe3xFb7vhAfSGwkMdX72ooo/uO39rrb10Ng7HtoU+OnBd141FdlLwr8qp/29RW9Wr1DQVQbH2xP/zfafz063/toLTK+K+jLt7auBWPb2KSTsQ25FiTx9k089gEPMpJYDshZch3ET2vkq7/Pp1Po9dAeZeIZHyH7hyaRA8dxTBrHJnQmc2MSZ9haoWLi+8EHH4z+efGFF0+ee76tuIruyIo3rxF+9zvfHSd05Arkre4wibx165Oxf1IfnYoe+fD5nbIB4Y/aNbNLRtTju3DK44yMAepaecUWr1D15K+1ZbILk7wLogdM9XfVs+pa2y2FNrEldqWfa18rS73Ig6pL3Ue5bkJV1iGEV8XStrBPVmzsxzMKqq2VYke2sTFIvfuJyKRHaEoHZe5t/sjDu++9e/Knd/90F7373nvjauJqE1+E3wTbWWjndVsrjsDH4/0hhbl+CZxHEtvjaq1BFys3U26liu9VeS66tpTVfqzJl9Ac9J/779Q92KGySvt4pY6/Ivv88y+MPCUXyGg/6LVVpflOUlZne9XYq9XqqS+57fXpfjxW2fnAv08+fP/73x+fYRKX+cFgCvq02mufvmsQH+f6yXHvF3wjq46lQFs/iEpeTrXfsA78x49eBZVA5V/ge8ktqyHzo+KGDRseLLYk14b7gjyk7xVq/OAhZLXNk08msD47ibBPn/qwt4/WBiJz8IATGAo+/BIqyWUCKEBqSZf5yXbT32qip8fklm2W6ieB1ZJYvgHmY9w+uN1WWQjwbHNun5xD0EzbufZHsr1nSB8ioLfEVktcHf72mPMSQnxrnDz9dAswg3a++TNj6F6Amo2m9RW800Nybh+cF+zX1V7hGR9NIbJrnTld5tD0u3sC4LpoK6l2PqRjrktyMiEwsTjGx2RI9tDfdbMUrd2O9vmoIr5ZoiuelUC7UMprWT1HVuTZ0rOVOW4TSQkg39QKeTX3+vXr42tMJrIC8xeHyat7UnhFrvPuIXz/0kuXx/P6xmTXqgsrPfRXdLSdQ841/XY6Z79iik9fpp2/vuhexxYrYXryF+bYEOzTbwlGmd24QDk3ZUtAdk+1L7Ot5SmDyp9MfYuiwz7ZzoX3MVjTtsqqdsSWnnIOHMdOtrlv5N5R7USQbXgtRW13DCLvEAXDUdN9+I+t7m09qS8ZH9T2x8D17CP0zz/X/pqgj6TzY/Uf1OPIbDHE5ydPP9O+URmIP9wv8JHg1o49NY6CXkaQMlv+mNJnCjl/yCdeNbSSS7322YG/jbZ88WV7hluB5ZxEvTjQ6iv3D/GAb/E5JwGU/ghNwT3x6mtXx6TYrZs3xySiGKu3JfZNjV/YJwOci4/tVz517FQ4x7fx7xT0q4Sg9huOA7/znzFjlWD6gc+NKdeI+HGuDzZs2HB/sX4GsWHDEfDhz2eeOftdAM+H/mFd4UGx/FmRui2gqMkIwZ/VVC1h5BsO7S9+JYgI9ulyDAQmbdny3UmGOdDBN4nyGqLATFLACgskqJLoyqok58iB5q/mh9CxCC+4aL/cD9Cdf9aqzpcm+YJF44X/q/2CaHUkTxLg3yu0Ptz1QyDJdZ5fCtmzv09bgF6D4abHcfJ64G382ibRInFCnonE7rh9aPmY8afvYU2Si06ff95WQrZra/+38SqqjvHvHBk3IcfuQyhlwDf6mB+QffooNzYh/BqG/hnOuT+8++67J7/59W9Ofv2rX4/029/85uT3v//9+L2ey1cun3zve98b/2qilhlb5OJ765Nbw/br8Ts07kGgjoSXVxGt8vrk9u0zsnc6NNTy2BhyrJ/rFt2FcbzdPXFjv0nEzWGCeTdJ6rVJxkUhelc4jj45P0e9vZUAn76v9TOblSPAaynCc2kb9WNPRWyo+1MUxC5j2XXb28muamdsjL5LEF172YcQ+ybHWgd8Rzmn+6H0Ya5XNqJcuxX+Mp+J8D/94z+e/Mf/8B9O/tN//I8n//k//acz9POf/Wz8XlL1Eayxq0J7r6W98uorw9F3xtfqPhqueX4ezo51oPK3r19c118OfeP7Qp57Adt82N4ryFY+ubb0FZ7a1TGbvrwDPqzHHeLXVuVsvdqunul9Qz8rzdyrJJ38tV16fjncwz1bxFCgjtWrVrp/crt9W/DmrZsn3x187+P1+ESfffDtLt/mMzok1K2Y88PlqRGzqPbsk5NzdLfNfd+29WNLthlvU3zUJWvK7+pevfrK+E3RJdfBhrvBb8bUq+M11sDXrgurMvNHCTZs2PBwYLvTbXiA2B9QrEF7pu8e7O0VtPZtLL9Qjq/hDJMzDyHHEgVJepm83SsIOiRNBBjkzX1U2/kxYBu/t9U+Fi+wid72D4EPJmKbo9Dz6YOpRwl5vXMNjJGWZLEC7+wvn8aWYOcYvmuRPq1Bq1+sp4LYpdCV+3THW0Ctz3f9biLafsW/CJCRwN0v8Zk04S8JDRLErtME9WuAHxfpuzWJrosAn9HX5JXuJizuM/aVxafsdX/KRDETGrrPTfr5Leemrkm2WrXgVQoTaOQ1pjfffPPkp//803GyLUCnXy/DuBKo03FMghX+JkbPv/Dcyd8G3a5/3P7S2jRaG/xR7K+JADbEjpDjw3CPfOrk1VdePfnZT3968r/+5//c0X86+Zef/2y09SJR+xPZT1loqq+VA/syvu3r54z92D+F+Amm+nofarslbed0SNvYqx9jJ7IfkMkmY9m47u3scYxtaQPHttuHJ077jM6SxrE71+0ameq2H0ra2K9t7Zss41uxVM8paIuvD6T7C6eeU3/84x/HPsir9YMFY52MTfstxhgm50N73+BqMVL7IziSX8btM88+M5b7q8z6kqxK+xC9eowlQ/no645HjrXTD6lT+aSOMei1RHHSJ3T//LOx3Hf/JKW04WerV8WEXjNk7xd//WLon+FaHWIyvMjI/bfXB5Sh11577eStN98a63344UcnN24e/v5ZHf/0if8roqf7h/OuI3zjb/v6Elx7/dgB5bnmpmwgw/NAMnTDeugbf0mx+t6YsWLaCuoNGzY8XLj7TrthwwXDgxWtQQsoTg8WYld/XhY9BJeSGIIiq6z8dUPBzlodlyJBP5vIrhMDMk3qvQ5kObkkmODSe/0CsQQ1h3CR34e6SF73C4e6rn0r6PRgAbziaGXPU09ZCXg2CapP/GnxqUD1XsHYvqh+sVLJxGYOxqnJgIA5IFv5RdqMn2vDasSsHhAwun4Fk64N14BEl2tkjWz6C/S1Mcm8aOAr0M2E31aZ/ehpcmKsuPatsOoTWew/Fne3HSZOgz7uLz/+8Y9O/uEffnLyk5/8eCTHP/j+98eJDZ/Sq06elKEPP/pw1BP4z1+IskJK8I6eGWx7crDz+o3r44SX/UhbNtviG962sdkxxG+V4q8lcAmblOaDv/yN7KP0Q2zb5+PR9uG/J3zjbji2CqQidtHRGKpbFFlAXt/X6efoAvv0mYL62q/xEcTf6dtjwMY6tunCptiJ0r/HYK0vIL5ca1dk1b5jW/vhqSUM2Oj6sRUfZNyGwoNcq4V+9/vfn/z6N78ZfbJPF+20z1iovHrMlS9BdGCTj6S//vrrJ9eufXzyxz/9aeyrOVjxNf7l1GHc/undd0/+93/7t5P/+r/9byP927D/7//+7+MH9I3rv7z//qj/Wv9XxEbXkmv2i+G6s4pMefhWP3gO649vhufE80P/pI5+Qk8N/SeZb3XWJzd9k++vJ08Pz4sXXnxxbB9/5/tc7l2SEsr9GOCbW4f6JVAHfvjDH5xcffXVcRz86U/vjt8rO4TKv/edY2MSqaO/jJeqj31l+sF+vTYRXxqz6tgal7V9oK7vi73xxhunJRuWwA/Qxhm/B3wt8TsmiTds2PDQYV3ktGHDEcjDuKIFKqcHFwD88u0tr9tMoclswVECCBNsQZRfPXPuXoCMBJr5hoSJu7+SmMBaYsVKCkmIqeCkhzroopIf+3gN6nZQ72LkXgT48xBa/58eLIB+4I82IdqN3/b66e5bK/cTSTbda2RssZHfcrzEz2vRJpPfDL5ssjJpTAAv4cLkNb7OpIW6a1dq8rH7QvrXxIgulZzjD/cR+prsTyU20L0AvnSYAp2djw9Cuef1esXnElq27kF/+MMfTn7xy1+e/PsvfjHSb37z25M//+X98YcBrwIJ7CuvJwYf8ZP2dUKNdyUfwJccQCaa5wG5sau307baOAdjLpOWTB75lS2IL9PXPtpPb9vwj0z7h+Slzly/zUEbvluKqktkxf+O2VTHMjundMIj43tu7EDKImMpjmkDkT/VThlbUK7bxB/sTpvYlSSdY5Ao8J2nv37++XguOoYnUt+PUF5X+/yzz8ay6DQH5zNWDuGQP9r5u+tEP+clut584/UxGfz++x+MtsDQU6MuIeWuQ/uS4O+88/bJO2+/cxe9+eYbY6yirmQYO8g5pCvgTa8e+oOe35zeM/SHernmwttfRaanJL76kZvzVt95FVGb258O96ehrr63kqten46111P+Uqxy/tEu/kD7kDrGkxU9vs/11akPDyFtq+5Afq5B5/lh3zhRJ2NWm1zD2jmXOs7nup2COPSNYYxsOAwJLj9EZ5V5oN//+tfPZ328YcOGB4t10daGDUfAK0MexhXlGX8XPDDWPDMEDBJcHvbamhRPgQ4C3gSvIJhIsIucRzUIuQiQQy/BiYDE6z+SW+SQP34sdQj02oT/8AQtPjpQ7SCfIPzmcdYfS2Q/bDhs41kYD/rGRNjkJ2P4yy9bMOn4fr8KB2y4H8ku3y/J5FD/G6v3wl528Cl/WnEnSc3vrhPJRde274FlIroUEtdcZCXYGtDHNZj+tk+2bfYzeUhZJeWhewVy9Ed/n0oZIj+68mfV2/k2ftu9WWJLwO6bPK9dvTp+18ckzl/kQi8PE2CvQL16+pqLCX618enxtdL2rbhPbt8eeZKBf2Sgax9dG78ZdnuQx4ZjMFh3utf8gNgV3+c4uvWI7ShjbCgaV2XUNuoFfqn/y/sfjKte3BdyLj6Yk9WDbtpW3oeAd/y5D86rF59DPUbhEX9V6m1I3SU2Oqf+IR0rjmlTkf5zjwqxMb5iU8Z87EPV5krOuc9LfHhNz0pGW+XxnyStpJFvXQ3FJy9dvjzKC+8l2FfPufikd0v6cupcwFbXurom5t975+0xeXvLd6qGa7OHch9jf+bZZ4fr+42Td95+++TtQmPSa6C333p7fM1NktuqTv6KnocQe3d27chqs2Hv5ONr7fth/ipsfE2GP5jhlUD3FX8h0XfOlMdOW3zEUxJYVq45/+zQj8aD/ZC+tWJfG3bQy6chlkJ9hBeZ7otZHYufH8V6OHe2386Sc/Q0ju0rg/hsDrFfPe3StrajZ3zUQ90Wh75w5/X1DdOQDPRcTLwe+P6j56YfxA7114YNGx4MtjvbhnsKD4XyXDgID4u1zwv8BQpkeaBPPdQD/D34ewgIBFItaNitIrlIkGFFF/kSaWRJfAmO0JRe58USX6qzpN63Da1/2vdMTOAFhSnffZfr/q7kqrjX/WZstuu3Jbfa9XVcYuIQ2kft3SgE6i2I5+e2gs7Eok0u1kB7bY65jrWthE/uLfZT/iChP/YhfQeZBEHK63kTV8H6lctXxlUbb7/11l1ksut7NF4XtOprvF+OrdsKGH/VjW9MNCXt019k8JvXsD/48MOxnW/85B44iVO9liJ9Ents9/V7+s/k87lh4uyvyt3w4XrJgGHSX/Vyb7Z667PPvDrr1fazf0BlLaLjEkTPQNsQ+5IQqJPoiqky/Op4rmO6R9/2fiA6o3aPPWtnMKdb7OjtnLOxAn+v+rnf+9bS+395f0yySLZYveUvFkrw+kHKxNfrbnNY6rvB0vHON+6f2n0H9ifYzJnBxlCz5bUxkdEnOyLjk1vttT0fZm9/fa99xN3EvtFzY5lVLFcuXx5VkQyWjDqIU1siy/MT0SvlXvm78vKVcWXVBx98ePL++++f+vrGeK/485//PH4g3goatmiffg3ho5zefpix//TTvrV69tnsmD36li9svYKtPZ6HxkaQuu4FEl2XXnpp0KP9oACxzbitNvf3o4xr29hk67ivOwX19Wt8oI1tBX6133toI9G39nMA3wbwpb5r/tmNJ/52/ftRqMWH9yYm2rBhw/mx3dU23FNMPdy75/AZDM/k1cjDCEzU5h7qyj2cPPinoNx5E3l6C4Iu8sHfAo6vx19WyfCdCfselGvB5n1+XAo6zfmjog+eGo7orHuEpXashaTkOJkfWD/33O67bS2wbEHig8W8zXSOX47xjSZeI5T0zV+ZPGasLgcdm55k0dl12K7p9X8p0/Wun5r+Z1+XPgSy0/4Y391rJLDOeJzzjfO5BydITxt24YNM3E3arN4ycRfYmxyHHCN/ZfHSi5dO/vrFX8e/Zhb/SPy8NEySfffm2sDrvffea9/6ud3+2IdJq28DXb/+8ckrL78yTG6vjqtHtK3+He5qp9sJKLxj724i2R/H1uwHvd3613mvOlm95l783jCp9v0heo8f3h62Elwm2xLaJuVsjM5V90OI3KpTj9hRKbAfmxAbQykDctiGwNZkOIkOOkyhL+/l70PaLq1fedtWu3Iux72daQfkuieFYiPq+8Yxqu0h5Xghf7jACiN/dOTDYSx7RfW3v/vdsP3d+FdKP//r52NCyDeNjJ20tQXfeGqJlpZA6e2JDYhNvnNnmzq2YOuvGtLDPhm1/5qMoe3QJqh22Jeg+sH3vzcmqXyE3auYgTqfDOM7E3kJIG3iv0r0ssINuZ69ogdV5xB+44+EpQxGW4dzsZUsfnznnXdOLg/XlNe+fCj/17/+zehvr0h/fP3G6EcrzKwkjX22ofC+PNybJLf80QwJr8io9byy6P7lfnX58pVRH8j5Cq+5syP6hmpdfnv9tdfGZNfY38OzZvDK6BO8Y6/j2s5x/KE8Y9e+8tF/p36dg7r6Rls+watvF52hyq/QRr/Sf0MDn/Gj6ybfcgM+9COI51leb9+wYcPDiyf+9V//9b+c7m/YcOHIn2euMOmcw9pnhue3h3Rbht4CXg/880B7JNhAAomLAvvoSed9CbeLxP5A6XRnD7TnBz4OdkHZacFDAGbus/V4tIBHn7HZr7ZWNkmCtqDnXiZ+9mO/zYL7tnesb9g6fsdk4COou5eIP117Am6/LmeFo/LYsgaScyaCrmF8loKv6PMwgm6ZJOXYyikfhOcjE0Ln+TF22yJlzlUI2k0sTQ7feuut8Vfr1G1+b44nxxDCz6/YrodXfLh54Df6a+yzZ8aVGFZz3frk1vhB5msfXx9XZVy7dm1MmP3ohz8aJw/aVd7kSSooM3k0Ac55da0ek3SywuTq1atjWaWm3241r7aOo68VKP7ynI8ukxXoZ9/WsWLkxqA7OTdv3hr9KeElyUULvrn62tVxbFbea6HfqvyK2MCePH9QymzJRnjUfkU5B9ppk3OHgLc2PZbYmLbR6xDSZ6EkA/AJAV6xMXaSoY06ymLvIYQnTLXJeXpIgLzw/HPj8V+H57SPmbtOJAMkZSTCXhzGMj7RIbaMq7W/+vrkySeePHn16qtjEgpv59InCD779LOhrCWQJKTwCshkb0vIvHTHv3jZes3QvrauK/u9P5Q5R/fvjnJeGsc/eIZbueh6yquA2pIZP0de+uaLL9sH0d0rXOvsyHn7zn0xPCd8o08yyXe8QJ30Ze5HjoF+YxLu6WfGc/46otjIdfbWm+0VSh/8JiPtYiO+Id/uUn518HkSE6lb6/3t723lk3sB3/X80j/uF08/9fTor7yqFl6xm4wnh/uHH1Ho7tU/ftTn1d7YHN7aIsjK0ejhfPpa2SGoF73ok2PAy33aOfKr3Ap1fBPWmNjQ/GZ8Wz1oP9CPnkGeDxs2bHj48Z1f/vJXdz/tN2y4ILzwwovjg7diLsnVHs6nBwvheW1CJCDy17EER3Pf5FoLkx/BhpUkHm4XCa86eJ8/wcgxWOqvxDR9cCOBsQTaCYIuX750WnIy/nU+Qfh59L+XYGpv7zHjKzCGL11qAfvNm58Mx08MY7u9nnX79mdjAPkgUa8pNu7rl7hliS/UlWziS9fVkqD7WLRkWps05vWAfCfp2L6ju35yDfuGxlKw9/nnz/da2nlAfkiQXQPt+MM1aQsC7ySIfvjDH46dq69CFfUX+78N9bR990/vjt+X8d0dfPWBduGvL9Cg2bjC6U/v/mms5682tvJTDPq6V0oMSXa5R7DBJNFqDR86zvOg5+/4vff+PG6tCjMJtR8/sE8Cyl9Ys9IGqp548FMmao7J8h2l6x+3V6BMQiXI0g7ftHP88aCzFWjGijpW0lil4RVOY1J99UAbz5u1MM7zPMGv9m1sQdkHE2dtUOQfAtv1UdqF1xSiBxsryDIJPySTD8lSL7LC0zYE1baUOT4kI9CGLLz1tX5aAu2iDx0roofzIWUppytSnv1KkHGUNgG76jh1viZKA8fq9bID59CcHMfxR3iri/q6QcrVTx+kPRkhPOag7hzCz1hUj98dQ+VPD1vQBlKuXXSKjvadQ/FH2qeNeuTZ5nx8gSA6RWbllzpT0C7b1LN1HNl0jq2Bfs/9Tz33j8gOyFYH0a3qdwj40z/14xPXcPrBtTNlmx+U3LM9D77N4Bs/6LbVnLsV4OIfzx/PkQ0bNjwa2JJcG+4ZPGD7lVweIBPP1xFLky4V+PmVcwgZToOBNtnxUK+/Snn402fNahRJLu2+853vXviD/34muYL4nc/W+Fp9q2HoHDzsSa6K2H0eVRP4SJh4zdSv9S+84Nfd9ufmjbcHiVxXa8fEErhunnmmBcZ+7b1XMMGmvwDd6gI+tsrBODv2W2CuYQkWScmPP14enLL1Xia58M82lAkJtH5svgj6ay1JQUhdW/db+yY1KatwTwPl7pW26lb5fVv1MvkD91o6p33q5rzk2VBwpz3ERtupcmWh1MskMefJyTn79Kht6JOy6Bt5KYPYB+rwWeqgNt6ajs6jQNvwqnwqyAxFB6SuiVNWb4SmUMuNYW0906bkTYF++pqOhybK0c+YqojM9EOgbraILBR7Ur/aV+0J0h56GfvAh/qMbmxbCn1BzxobVNS+QvUY2GA/dqHoXdsE9p1H8b86+sVx+IJj/CKzh/P4ON/X0S7jMeMflM3xg3qu6rcEZJDV69Tr5XxiwOgH6mkDdRvdw5NesQlFTwiPEGRbfaEeX6R+dLSNvIpanrrRwzY8w8sWf+dC5Ffe6hi36oE6c6v58UzMqt7S6167KgPvtI3O+iLjosJ5z1qrXr/NiS4rC80psnoP9CW/+C6f/Q0bNjwa2F5X3HDP4CGRwCKYWsXl4TrxnF8ED2qJBw8ek2KTkzzM21/NqkHNLiA9BPV9k4G+eJpsX+TDTQDzoF5zW+vr+MKqmKAlES92ddujAEmTfJ/KuDI+JAwTuD9oHHsd7YeJl0msgHs3ab1otHtFCygF5XzqOmkTi+NktrH7nTGB5pfqpbprp6/Pg90YacS+UO5JCBxnIoLsZ1KTsh6ZOOZ8+OU47XuQFX7ZRg+oelRoB8qnZGVfudd1YnMmVWiuDQrUiazUCZyDtN933n6O675zISALGXfqNL13/aUs9Xs7U7+1ubtv+3a26mSMK1sCPsRvTRvQrsrfB+cjp0J5b2Psznn8Y7fjal9oCsrTTv2liJ+1X9OOnPg/iC2h2BdbQuRoF9tCfZ1ajl9NjARkpLzWtw2mZMGULIRnPT+F2Bj7ENT6lXfkR5cQ5FzaZj9tQ8rIITfnK6bahNhUz9ufQj1fbUN4oN52sNWmypiyFdTRZ9GhtrOtumqXekCu5JNtQDZ+c9C+17fynIL69Egb9XtdwHHlC/bbc9710VaQfdsgyZ+/pJi+4isre/3hkW9jzLthw6OM3R13w4YLhg+mnn2on+5cEPAzGfFw3gUlX48JGPsmxs4J3Okh+FiKFii0D9n7JSxB0kUhuj0KoOYjouo9hTFlJZN+yyt8AiBJr4cBXRx7ocj19fTT50v87EMC8Xa9tuu2XSPHDz48kyBLcvIigR/K5ALRO/eLKo8uoUyoMkFSzzZ+TjmaQ86pm3aV5tqnfKrd1IS8R+rWevFB7pHOhcI3VNvnfKXUCabqIOU96BOfz9mYts5XSt1eT+eg2tieD+0Yel6V8A3vyF0LbWLXGqTdVNuUxx40BedjS6Xqw2pXf24J1toW3kvaVTtDrtGp6zS6o/RXKOcyLmp/VppqY1tRz1Wq9fvzKavl9ivYwSa2ZbXblI09D9uM+0pszLZS5THFs1LORX5FzoWm2gb2az9mzMbe7EdOrWs//KtNkON9Nmu3T//oq07V2zGiHz0gPGGKZ4APPfDSNjZOocqxTVtyYn/gXHSInoF42ipq3yFrf9n42wM/hPk2nLdPqp/zB0jW/Ei2YcOGhwMXN2vfsKGgf3h3h2fQHtCnB6vQAjrICq7AA9xScOXhb2uim2AjaOfPlgkWsKtLvQWNvV3H4iIelsf7bcMx0Gf55ptxJQEqgTK1OvFxgqHaguL2y/pFXQM9/CVHPuZPchD/Hnut0LPp2/ouE4C1aNdZI/eOSrUs+2TmGMhGfFgnUu4rodRdAzy1C+9KuWdNoZar17dDgHdsyr62PaWueqCs54vcS6vtlceUHsEUr9SJ/MBxr8cU77SLTYH9UOqF4gOUuhD+U32bOj3q+FiC8Dm2DSKzUsrr+R7KYYmNtihtlmJtfYis6BwbULUxVM9DLQ/wY0+1sdpZ6y7FnD+i+75z4HwoOqPcH0NJokydqzKqfSEgM/0bm5WhKUSnpQifJe1SJ/WyX21i7xTF3rRN31V73YdyLwK6pd6UzbWMf+egjvNTetMNMqaW8INaP33bt6lyEGiT2FX9qhfgF9491LWSybdu+3aPK/iNvV5VrD9aivW8puiHc77csGHDo4X9d9gNG46EX4R67HtYtgf16cEKCB48sBOg9LCyy18ek5wgw681+daBY+39YoUs1YY85PALT/x9kylBxHmBX59YOwb3JwAh4/EPdJZA0sW31Px1Hau6jA/jJkHs4wy2SuzlNeC1yPU0R3j7tdR3QXzzLXRscOk6bqu32itDXj9cm5Bs96U2wcwkQl9nlYRyoGMmDSgTKvvOHbLhGH+GZ3RcCr6GtJsiYFuI3f0+sC+TxvYK89lEVtVxDaJj5CzBXJvetpB62Qf9Gao2soE97Ks2Im0jdynwi8ylmOvrHM9R9QmqY5eNqYM/u9jZ21P57MNaPwRL21W7olM9Zl/6rdrpOPXZqd8yXjNWM16ndFGG8FmLOX51DFQbeiIzdsUm8Uuo9mWAfx2vYp9QbI7d0S/y1mDKtkOotvUUW6u94Dh292MX6FH7FKU/44faz+qHAP99yLiIjnNQD6pN9KS39vXeuFQ2pL/wj19ie+TER5ETGbbapk3aAX6p24Mcf9HSqq6+3eOE2OavbHpNMWOO7/gtfzwlfbthw4ZHC+uf2hs2HIAH7gsv7D5SvhTtgXN6sADqexjXoGEOkhMm0D4SDpYl7xJevqUggGiXg7IEFgFZJuEXBQ9NtuL7KOKAu78VMO6QxIkE6OOOBMWum2NgzKwhIPPQtT2HJK1d87tAf/kjj2z3AveYHOOTiWOdPEVP1O5j665r7dfiWL9o5x4dysSJraE6kWJfnaDZZv+QDtUna3GsfRXpCzYiE8Hc99nIfufZEjv1a7V33xg8xi78otdSZHxMtXOcPkwyANlPffqzpY7dTHDxDv/z+pwsPr0XCO/0JVLGVvvAjiV2anevwZfkkdXLc66Ws0v/5Tpkj3EaquMV2GN8so2d/qCO48jM2EX7+lTdnF/jk7V+7OWg2Jwxy07fRJqyF9hS7bUN1euVHHRIt9SDJXVhrl7lBdU2qGMQUv+Q3CC2a49vfKO9ff7Cjy/6PtfGdaBO2gTqORe9erz22mt3El2PI9hlzF29+uqdewjwh+9wWcU155sNGzY8/Ng+PL/hQuGh4UH69NO7ibDn49KH5JqHqbovvvj8nQCnPtjnoI3Aw3v2gikBQmDfAx0sU87DTRsBgmMylsg5BIkRfrqIB+gFqLMX7Lcihg8CH83n82872quL3wzj8IWxT/lKwvRe98mDhGSxvz7k9cKl4/dB+KOtyMxf6GuJyEyEDmHoRv8O94onx/q59pfA/WVNfXAvOOa+UgPzvr2xiK86tpkc5biN1TYpRnVinLLKU/1grW0Iv6WI7ujQfSb12BViZ8og9rCttzO2qL/GLtBmjV0Q26rsOaiLYle1k405j8+Ufcq1gSV6RpZtBV5LQJa2S2wLYkOo2lfHLOAZW2NbTSAckok/aLdUP4heS/0QpJ1t+q7ahdwvYmO1kyx9GZKMyH7srTZHFqzxf/RTX7slUB/mZESXEPvYj6rtkQ1kswvpU/biH92SjDlkl/Pxtfr7bKIDHOIb3RH/z0Ff0je24Zn4tEI5O5Oc2ic7UIee+EeOLZ3wir/moI760NcLX7wqHEsC4c2OxwniNa9lvv7662fsZucnn3xy8vHHH5+WbNiw4VHF2Tvahg3nhNUTPtx4HnjYDv/vhTr56LwHlO1SmPxa2SVRk+8r2Xr9bG5pMhkm9U23s7JMnvvg4BAEGdis0ftBobf59u1Px18MNzRkLEmaPv/88+OydyQBK0AU8K4dHw87vEa4ZmXjkiD+ItESXC2wJzuTDBOPJX1BXfeB+9Vv7X5w971lH+JTbTKRNIkxcbLNuFMvPhDAI7ah+Ce89qHKu9eITvEJO1BsrKRcHfXZgzKxtD1kY84d09faRcel6PWoNqYfax9mshyq/WiffenPnvdazLWPj/ch+sFU3d7O2oeOkfOxccpO53o7D+k1hWPaVJk9puzyPLDVhxm3tvFl7GSfJEJWJdnPOF7Tr6kTXdZAmzU+IUv99FvsM27ZHdtjc3hrx64pm9Pn6efUz/5am6LjPiypA+rpB3URXVC1G0Hfv+yZg3Pa8+ES+8KTLqlvX5lz+5C2dMu1FsQ+FISfun7EkxB6nOAPY7300kujfQH7xbdWcW3YsOHRx/qobsOGGeThWR8a5Tl6EJIFoQPP61GWAAMECgk6DqHqI9Cy6gbwQK3sbNBni3f7iH077uH8VPkc8Fqi7xKsEHsU8K/fWGuB666Pv+0wbrwS116LM35MmNuvrM8998zJCy88PwaJL7zw3JgQzbh91FCvySVB9YOEexD19A0IXtfcJ8B9aM01HRzjlzq5qMi9hz3GTSZVIYg9sRHZ7ykTGdteR3IOUTB1LtSjltmna62f8zlX7cw5+84hes/Zh2IjrLGxP19Ry3siI/v7kDqxw376Ms9MZdE/NlZbqz21LDSFnIvsQ8BzCtofQi8r/ZixWu2E2FYTAdWu7NcyBHV/iV1B2q1pE2hXx2fsktBJUhI5p14F/dkpvggpY3fsD8Xe+KnaugTaLemvIPz7NuHDV7GbfTUBG5tR7Vv8epsd1/Le3pwPhQ+KLkuR9of6Obx7aFftRuEV+7NVx7nKhy1sZmd06aE8fql8liCy4pcpG6YQf6vf91f6JPrmHJ38eCeO0eZxgGtWgsuPkNUHElyffnp79MWGDRsefax/0m/YMIMEBD0OPYA9U+cCgTlIIiTx4sGcVV2HQIzAou0LoLLdyc+DPmW2CUZ806cFI7uHvfNLZFekzcpmDwQJ9oIW0G23jiDjwyrAzz9vqwG90md1VxszbWWRoLj9yt2+N7Lh3qEF8Gcn7Wv/OmSu/2OxVE7qua5C9IyulWodlLZAX1Rtrm0qn5wjo/LbR5XXFFW+UxRZsa1S2ofCE3Ieqo2xs2+T/bRbSmkXfpUnqvpWndTLtm+XuvUc0H1qfMU2z6BMSOfqLkH8BZF9CFOy0rbagXq/pF58M4cpO6PrlPwppF5knhe9XbGtJjmqrSHlaUen2m/ZtzVxrsmdamtvc3+8BJXfUkTn7Feb67an2Ava77M1W+cgMpfoWutE3hKE/1ybqj/ErvR19lOePobs48+mUEX0rvpPIf6yjax9OpNNL/tVbnRcgshLX0defBaeFWRKCPmRbk6/RwUSihJ2fdLOd958xsRbHYf6bcOGDY8GvvPLX/5qu5o3nBsefG0C375pFSg/9ExsD9fTg4VoD6rnxoeUv57oISzRILGw5gEl8UDHL7/0l/JOC2cgKPCghxqs4uGcJfdTAcIcPGS9IonHeWHVyb2CwIauCaLaX8D7fAwGNuxHS8YKnAWwLUAdroqxz72m8agEVO0aPnwt92imrb++zwuvinqd0vUVPP/8c+M39z799PMxoF2Cl1++PF7ra65rfZzJQvo2E4O5CYLyNjbaxMdxuy/uJmso12D0ySTFsftPylDaBqk3xecQtAHtwidtwyv3Q+cjI/s5DzmHol/llzZplzq26uRY+2pn2lR9UncJIg+qbcojO6hy7E/JUp62Iag2rEFWe5CVH2qWIM+nJB4OwXM8dgeRGXtiG8QPyu0jNhqPS+3Uhn3uiUuRNrba1f6ZQ/Tmk1wvMGVPylJekT6cowqypu4hU/eJipzPdbME4hP6kxf7qv79PlLfuAK6pLwidlXSzpYs20NgT+SsGRv6WFtylo57ukVeP6Zim63zKH1T7Y5+2eZc7A2FT/rLsa1+Q32/T0FbBNr0PsUzcvgjdVLGXnL4J3odQnSOjtG96lLhvOfmtWvXxhhwiYyHDWKwK1euDPHsC+N1GfDbhx9+NNj118Efh/trw4YNjwa2D89vuBC0B2YLwivaw/n0YAKek8c8K59+ur0mkMDbQ9kWPLSXor12d/gvJ3o4eiiq/803AlavLrQPflqZQ7b9NQ9++i8NEA/hXsYbgiq6BgLU7deuZeAiAWQCdPvGjcShj5o/SkmuXF/rIOA+3b1PEPBbaShYrRMM+hvLQ48svlb109r+qX7SNseZTFZqurZJkX3jBGXikclH2qeuJDP7WvK0JXpiq3rIsTHXktHuka1ezpORv8p2iCD6Aj0+/fTTkYfyanM7JoNurb57hl/JyaNXdKBPdEf4RAbe7Px62D499FtsRxAe7X7k21s7vkBWs7+9NnSI1HOfiy3RBTlHF2SCR9dMvlPPNjrSPRTbqu7HAG++BfyWIjaQvaRd+pm8YMrG8Kt2ph7w6VJoRy4+SxFZSLtDvo3uaROZ+lBf2q+2o9gYOyHjKTaj+GMK+M2dJwOmziXRgP9SRH/8om/sRbGx2qw89k7ZXK+RanPqR84hqEsWLG0DdKx6LUFkRV5vt21sr4htsTV2k42nNu436qQMr/RVknf4qgtLdE6dyOhtTTndnYsO0SPy+naHwMb8cFv5kNdDmfPi4Nu3b5+WPlp48cUXTy5fvnwmwQU+Mu/5tMZ3GzZsePixreTacCF44YUX7zzoA6tYDsGDdfh/FTygrMiQJDDR8pD2IWwPbEGABBi+JiPK7M8BH6eXrOzwgPTstzrEA9/KELwje5+cKfg4efuO0/lXRN2rlVyCGh8cff753Qq9Tz65/cj+kvcwwNiRPDH2BJSCK/5MotUYU+ders5bi+i0BMbFgxwaks504M8+aL1y5fJ4TrLCqs99YO+lSy+M+9rsC4DVRa6XEDRftLZ1OwX3NfcR1AO/TGJuD/e8//bf/vvJG2+8fvL973//5IXnnx/5mnw7rx7yy/Sf3n335O/DuR/96Icnr7zyysgbL/ecDz/88ORXv/7NMPba/WwffvKTH5+8/dZb470g+D//r//r5PZwL/j5z382ThzIxleCKwm1Dz748OSjjz46uX7jxp0El+eEb7y8/vprgw1vnLx06dJYHrvpxxb6/fJXvx5lv/P226NN6qgLsfPdd987+cMf/nDy7KDbz3760/G+zJ5//8UvRh7usRXxQW/z24OMf/6nfxyfIUB/bX/3u9+11Qsmlqc6qsOGq69dHXR7ZxxzEDui40WCreTizc9LZWRCzx6TY8hYrVuEZy0LtF2yWip9glxjS0GeNvp9KejHNj6hG79Hd5iyr4JNIXb1+1Nwja7xPbALer70cU75FD+ylO+LD2JT7OSP2E/WUpu1U5esffIq6J42S1D108+53g9BG0TPuiqL7NgNtjm2rYidleJ38SNd9vUrfuzVJ66h6G7sKccviSegr3K64Lt0XKsfnnNy+MC2Qrv4KX04Z0sPNuEdn8U3ynIMztuPPe7t9Ot1eRhB9zxzYhewRTzr/r5hw4bHD9tKrg3nhgerh7AHbUUfaPTwcFzzfGwPqucGWS1QcpzvH3ko5+HcAqi/3VmSrG6TdbcweuPjYXcIbVWHYLU92KNDv2JkKchuwcj5g4QJ0y4EAoL2DaldwOO7U0sD1A13o423b4Zx+vV47UjKtmvH+G0Tk6mx+qBBpRAdg+iacw8aPvb/5Zd+fb/7mmyTDxOPXVIF2GOM6wvkHoOUh0A/uSZQ4zW98gPwz2RDeWgOkTEF59oYORmTLRI7l168dHL58kvjPa7KVQ9Jnt68eXPU45VXXh4TVOrhpa5f450X/H//e987efXVV09efeWVSbpy+fLYPjrAn//yl5PPPv/85LVh4vDM08+c2rn77tnv//CHk/cGPdV5+eUrJ++8/dbJW2++Nf5YYAJ369bNk78O929+p0Ow0+/TYSL1waDXK+NHgsmuPoyd4597v3597I/XXnvtzj1dcu/F4Rnw8pWXRxtevnLl5PnBhmsff3zy5htvnLz55psnV69evWPjpUsvDnRp5Pm3QQa+v/ntb0feVwffSIIhEyW++Pqbr8cEnvrPDRNlcqNfdLxIZAyMti2QkboZo6iO14CvjRHU+nD3bAvsO39IpnpI+/BaCu2W1A9/tlTb+D/XZLUTTxQ7c00i+9Xu0BzwP8YuBH07/OZkVn/0NrM19la7Iys8Y6+tuCj7vc3aaG9f+RJok612SxAdl8pRN/2rLcT2andve2zTjq1JgsbuajsekON9qPprh799fq1tw0tdbeq5Q6CbdtGrlzPlN+eUx0+pv0SudrHLfsZIyqBukTqSg7aH3oJ40OALPyh6NsSnQHcJruvD/X1N/2zYsOHRwdmsxIYNR8Akq/8Q+ekzcS/WPFc8nCSZWqAiQGmTyAQteUjlwd7ob2Nw47z2XkVJ0msf/GlhdfJAzwM+3/vCi72Sa5JsVqxJBB3i26PpeHpwTizx9zGQEIj9wPcbzqKOkx2dnpxAxqcgy0qRlux6YhzfEiytzrh56MAu9sUGSTm6nlffJX5bjsZkSicJanKSxHLdNtpNmkL12LWdewK7c++p96BskXoQP4X2IefTdh96ftpM3X/U2C+1vTYt4fPG66+PCRyTgUZXT65efXUkSSgyYmMw6jDq0aREjxs3boyvgAwFI9933nln4P36mEh76803Tn7w/e+fvHTppZNPbt8ek2X4ahsKGv/Tg30oesQ3EmPkkWvVm+0LL74wnntmuNYk3tgbksgj2/kvh+eGJNetW7dOXnn55ZPvfe+d0Q+ShVbEvfXWWyc/+uEPx9VtLw/njZVR13sIfiej+omvTUYzXkMZs7Ud1PFayfmejkFtFx2XQttcY1O2eXbnGY6qjeqzI/a5t0rqJLGTLYrNUO0N7cOh81PQ5pAventR9mMv4ockH6JvbG4/7u2uT1v25rzjtOkpiD/XYJ9dFZHV+2LKdnamrx1HL3UAH/awq/Z138+ROUfhBUvswDd60knbKiuwryzl6bdD/k07dthWObVvp6BO2rFF2/hrH9RTX7u0hchyjDcC+miD/GCR1x0fRtBdPH9peNZ43gd8aaWpH3r2+XTDhg2PNtY/0TZsKDA592HtJa8mHoP2kBK0W9bvId5WXHnQ7ku4aOdB1oKeFvzteLWEly3k4R14GCawgPZQt3y8BVCtvAUUjX/7hRvvBDNL8Cg8XCXz8l0dOBRofVsxDK0zNPw7lh+CFS0SpcZQxqVx+rAhKrVLQsCb/fPjrN/Wga9cb647vpOwauOzKdf4tklUWzHXJoiuZ/UlFlty0QRyN5kC13TGuv0ch1wLuR5Q6hyLtD22//e1cy5+qPXsu76tkOWP3MMa7SbX2jV72TpvY/sW13dPPvro2riSzEqz1994fVxFZfWTPrDC1uosr/qRc/PmrZNbn3xyR8cp9OWpO1U/ZRkTrY+fHX/NVwZPDs8srzfSqY2bNgbS1quVElzu9xJg+XPzrlE8JP0ku773ve+dXB7OGYN1HNxr8HHty4zNuW3q5DjnUI+pMpjzd4+031fXudjAd6H4N+QYOaduQP9cf0Cmff3Vnskt0ZE6vc1oqT0VeByL3mZ2Kas2x96cqzqSHZtiX6XYGv9DtXkfqk+WIjyXtFEn/add39fVbuR8+Kofv9tO2R/bQ+rF9kP6LbVbPQT0s0925PTIeYR/xvBSWaBu6iubklNBF/LUIyu+nEJ0Uift+A6UK5tDeLpnup+7jz6MoJ8/QuP5FvCN+7sfMerrrxs2bHj8sCW5NhwND0kToamH9lTZWuQhbUIKEgIeUHhj7wPwc1Any6hNylow4lssbRUHnng7xquuRCN3F0y04Kw99AVXdweSeEuAkanuUoTFRfjqInhMgX9qkJQAasMO/NH7pI2p04MDaMnS5le+vlcJ44vCku7PNXoIzU/r7G33hUySWhCPUmYFp2RWu3e01w+t1JIAk9DJ9ay+/VD00A8CfNd5xnvKsn8IS+tVpP6x17J27Gq+v5vHXDm4R7qf5v62o/hhd+8bNG2NOmCdsXvz1q2x2osvvHjnm2GV6OlbXFZTSUIdnmw0vvRPX83ZArWvItP+nRanO1N1QL9bqcsIkzhI3Ur1Fc5afq8Q3vvGa/ou9qzVaa5+lTmH2jb1bSvlem3X4C6p0Z9LH+NX7avk3hmZtQ+jwxycJ28twnfKD9EXVXsrVZtRLbcN32pPtXv3w9rZfq52R0f8liLtov8S1DaQtrEpVPu0lte+R+GDJ3tiM4p98UW1PXr0SDlZ+6BOdJ9Dztc64Y/m4Fz0rb7YJ6v6KPzVd7yvXRDfaBeZthXhx/8QX2brvG0QubE1NiDP1RdfPPvXCh8G0FFyy/3bfmAe0f4Iypbg2rDhccf6p/yGDQM83Dw4nn764leeNN7tr7iYoEoAeCB5wJqYkusBnCTWFAQWSYoF9tuD/4nxY/HqNFn5LpJggC27No4FAyZ7tnndSVKs2o2vX4fy7YclYAOeF+2/iwK9+uCIz6pPNzRwSe+XNk5ODw4ggbD6bWydnrgA4NXG8Y7WjrklXV7lNDum7T9bb78ebQw2ct0Lyv3yb1VOVuY4J0HjHtE+Jv+d4dwzQ3ArwPVHE54bV+Foj1/uA64/9whUJ47K+75cO+bVb/bvt68ibYK0rzT8c3p2h7SLf/prFtRhF/umbGms+bndj+6mxmOq7Q582xJmXgV5YtDFCql2v27y8QofCSIflP/Jj39851XBUA9FdMvEGE3Va/KbnaGp/qxwLm2CcUXawF+zPEeqb6C2C/99ci4C+EfuvvFakTb0nhobU0ibit7f8UVPOUeWvq/XbXumt9fulOWaROxArsVcl3mm5hqd6tPYdr/ArjoWUMpQxmfsta1+iM30ZkvsZSeKzbE39dh8COrGH2gp0g7m2oXnFMX22IjS17W/1QnS19X+2t8Z39X22v4Qlvqi2j1VL+VsY0flS5+pNj3Yww716xjoEVl8BnzDD7CvXQ9tEL+lT9LONnrYZpzFx/ZThuIfqGOQL8LTvh8syHoYwK58YzG+BPpbOSz+r7Zs2LDh8cTyJ8aGDQUeZv6iYg/PPJPO8wDvvOff//XB9mBuH3uv5UvgWe2B7cEN2vu4sb/Q6IFnRUF+ta9gk/POeXiCZFuC12OxCx7O5697BbbF3qD5bhf0bNihxIJ3IAg8jQMP4GzjJYHsFHL9VZrilXrnAR5V3hKdmz+WyTX2JJ+9GubbHxJWVm4Zg/74getXHckuf6n08uVLYx1tQL1MoJB95Fpeo8fa+pAAek0biJy0s3Ud5lo8xK9OSNYiq9/c13pqr6STf1p5D/jdK+KtXZIYztjuEgS27vNXTl9lHGuMddu5iti11L74fynwreRZ4BVF++/9+c93njXph9jwIDDln0OIXedBtTf9hPgk4yavfQIdd+Nnl9jhS9dhkhohZWD8oKV9mOtzLdaOEaA/u9gT29orsc+OW6QsCQT1Ywu7q819Mked2kf24+OlqO0vEtHBNrbX5FXsV+ZYHaAP+9jJXn3MVuWxPfbv0z3n1vbzEn8cqkNmxjewg876t9p6CLE3/Pp28S0f2lefX/hMO3rSYam8tDWuyEMZu9mP/3sf5BiPiup/7VGAr28fLtXvXkJyq09wwccfXx/jfTZv2LDh8cf21xU3rIYHnQlR/wABz8D6IJzDvsDCAzhBYR+IWqFBdh7Oa+Dhi/LaYQV9ohP5Cd7yepMVIiY+4aGuRJvzCXIPBWo9rDAxGextPBYrRC9C/JCghW2WeV+0nMcJ8Y1rIGNhib/Ub772y+rd475Hu85au57WQZvT3YU4Rp5qrf5pQQfnjDevPrjOXFNPPKFyu874UCLN64dePWyvJrZxmXuF688+v4emYDyT5/ySay82zvGbQ7N3Nw565HwmC+1+czaJ0rf3FwNNfv7857+Mf9Hvq8FuQbvvRyHfGRk/mD6Qch/WxWPqrys67y9LPfnUcL8dfKzu7U8Hsi307NAX9NEXEP3+8v77w2T9i/HD8u5/A9uR1Pv97/8wtovctBt9PlC2oX5Y6E/6+euFEpgmlrGt0q1bn4z3JHq6ftpfV2yJ0Nyngc2grqSVj8hLYvG5OqmXe51y+jYdro2To1s3bw3tPx0TFF+b/A1N2grgXcIrfO4lIi9jfQm0Sbt+4jqFWr9CGd9UyphVN760j4zVTNLJrdcoVP3Vx2uJfoE20XXJtVyhzRTCjy6IjcZWYoKcR7GZbMTO2FvvSUG1fQkiY41t0RvWyCOHfepnv1Lsx5teaQPsjM3V9r6/Ib5bo1vawNLxQTdE3zn/OY9v/EWfqpPz7bnczrMLr+he9ZqTURHekRl55MTPkORU6qdebbcEaRc/hByTcciXkYm0cUyvHKcOCvzo5H69xB/3An6M9r1E/RYd6eIvCXtePCi9NmzYcP/xnV/+8lfL7pYbNpxCcsskVLKph2dKHiz70B6MpwcdWvIs39HaVcLXag1oryb5ZsoyaNsmxk+ePoDPCm/n25LufCPG5Lq9HinwaA/7lOfBrn5IwFAf9vuQwIkNF/XQ3efTY5BXwugJki83btwc9zfsxzAcRiztD8ktSU/fuDMRz9jejaez11T4XxSIOTR2m0xjfTxcDGz7Ni1YR23SJPHsOmh1TaRdd2cnQpWPMjyyv+YayrWnzZJ7SB/gL0UmLO4LuUdMTQ5QjukVOSkH7ZCyT27fPvmv//V/G+tKsoRfD4mrL4eJjCTRP/3jP46BP13wcW/9y1/+cvLvv/jFwPNkvOf1wNe9+F9+/i9j8tE9k/zcR/+P//P/HO8H//E//C/Dffnyaatmx//r//3/Gb+59Q//8JPxrw+yh76//e3vRv3P+vHv48fbf/KTn9wp1y+SaP/9v//fw6Tl+UFnE7Px1F345utvTr4Y6l999dWTn//85+M9S3v9nEkcm+HDDz88+f/+7/928tOf/vP40XiJOHVy784zQH1ldH1/0OPmYOdX4w8Swz1/4PPE4INnnn7m5OVXXj556803x0Se9tqw4ax9Fwe6sYt+SyapAd+HvEoa4DdF+Ge/gl3sRGAbW1OmDTl51i7VUTtt4sMliK7GafwRPaYQe6JjjsF+PQ/VzuxrR7+qZ5U5JV8bcG6pbRAdXa9LwYfGCLgOqv+rfbWP63FvS6g/Rtog+tU6c8CffqjXbR/IyLiv4/cQ1JeANzaiV7U5FNAnVGUCG6ud2umf2kdL+int+MA+Pziucsjv/aguMtZtkwhbMp7wFrNrhy/+1Sf7wAfRVX36ZXw5xqe3W5kfIe7nd6/imzfeeGN8Lgb8I6byY8WS/tmwYcPjg20l14ZV8BDxHS4P5R7DM2Z80JwXJlGevf3D24OLfOVWVi15QFeon2/D7EMCMKu9/v53gYXSLB/f/YoHto3v8sAVJDS++IIN69rtw0X4vsLEVzCT4IbP2zePNlw0dF0LJtsqRUFoK08g3uqELhqNL8aRdze1c2P1VdDGNWWFjevXfgvoG88W8O9WMDXsJlaQ6ywURLdadghVTvx8CPvkKMfPNpMV2zpxgar/HEVOvcdAZID70F/+8v6YGHrt6mtjokWSqZIE03efePJ0QvLkmODqV3JZ/WT1l9dB33rrrfG7WHjeIXyG7ZXLV2gwtG33KnqgfiVXxe//8IdxUlVXkGlj4vPNIFsC8zvD8Rd//evJp7c/HVeT4RPoF6uorl37eLTx9deunly+cmXSTvZ89dWXo7zzruRSL6T9M8N4feHFFwc5Lw31L5+8+MILJ88N925/nZFvr338saE6jmvyofK7F+BHuunDJc8dtqTP/v/s/VefJreVJvqmRG+r6J0ob3rm6sz+YH03PXPu+gvOb5/Zu7unZbpFSbTFoitHT534B/KpdxUqbGZWiRTfh1yFCADLAgEg8EZEVt/4jhyHlFX05+KK6E2K4nONY2zcGovYthd4ptoxPlf/UHxOOaogI/5VH0PRlbK9/m2tD2fl4ZMUEoPa3klTp0c2UKr/c+0dGfK3IPbg3coTn/CxrUJZylMnPiav5lefY0N8qvWzwSU/c7LjipyTSR/0daaQOrEreuiY0lOhLHzBms7EI/XY63iNDxJbaUi8khdUWYk15C+i30uww3r10jBXWVsHYumvV3/00cd39Zsjjjji7x93zu5HHLEAk74nTerkelZsmFvvAr0mM5Pp1sVRBT6T3hyy2GkLvGagcxtb+La8RrYFFgfg6ZUti4y/FbKgAWYuxe6I86F1g9YX6sLxfoPqJdoC9rtWbTa0MaPdLHgap+UfXnshM9eA81avKcr1iOauk7PGKvK28qeelI1sDckLLYHONp4cnhaIb7Enx2uylPvmiG+gvPrKq+MH3H/02msjOX51IE82eaVxqN2YOpBhs8brHWS8MtIrt+nll18+efGFF4a2OrRT7JxCihKLVr/lBTbkXnzxhYFePHnh+edPnnr6qbHXDxytwh1ocmxmsYdfd9HgL5leY70IVP8ca2t/HdKm2Mti/VqLM72vvPLy+HH6Dz78YNyQ05bx/X6g6olelP7pGgvJS/lU3+VrrrXQFGq91r7T/SH5ZG9F5G3lie1B9SvjS6hes4kFSKO3XpdT1PtMzl5s9a2ij4njStW3w7h6dxmK72SmHVF8DBxnY2fK94revjVExll4gA+9X+nnNS91gK742ftcSX74pJD8Od8jC6J7i2/4gJ7aJlN6AmWx1fGaPvmpE97olRcfl9Db1PPQMSXHxv9jjz0+pvca5ig/ptQNLjZ7ktQPG9Ijjjji+4f9s/QR30tYQDzyyKNjOgVz7JaJ/TyI7rwueC9gQvd0QhYCcclfb7sIWAx49cefp79XPlwExPrOhYtfM4+bXPcObiAszO79dXTRyCLXQtPCORtbnvj06lh7eqvdbOjzqH1fS/32F0uzcHfd9YvqOahD9954RXblzTHiS6Xk5WahUuoEfHBzaKM8Ps09BTAFdVCVuYQW57ZpKM7ZQPRUkeMfDjZugV/Bmz93U+xvrysub/JzUbweGOz3xNY3Q33+4CXnqSefPHnu2WfHDThPlz366OEpryXwrfWjdiMrjZ826moPSDuSK90DPEGz+/C9N3ho0Olmyl8Ss9FlI9B84Q+YeMJur76zIDbSVftlrrueErNqG7/0UcRuqRvBHKf/TmHNR/ZVG/fEpPIlRbnOQvE5/SD1ch5SN6g+I+2aNs75oa9Pj0GpH31bgW8PT60rrX4n5V/aV5rrX1mgLnvjY23f2t7Vb/qmfJ9DfNuDOR55ofgcf4P061BtawT84A+/HNPnmL9TPodyHjnOkzeH8JEXW6stPeKfelL8iXfK1hD7IX2h53POhsRG/fhMHz7xU7akU93EIaj18cfnHta6npidKrso0O2HGj/6OA7E6Pr19l3JI4444vuJezfyHPF3BX9JsU4gd2N9Yj4v3BRbECwtOC4adJksbaxdBEz2FqNkfpsxtfCpi5wj7g2y2P2uoG1Wtc0GN/82tVyn6TvcOSyC3Ty5IWiLbZRrmd94lhbbF4W5GNMdW/lUb6KySGcvu6dulnLz0GOPT2dpfzyVtoyPUzbha23DpwN5gtUG9xa54Jtq4vb1aRs3n9pNZuSMdo4xa31geW45QN1m50FORdxKXwpthboZ+ypvrxfBk089Odb/4sv2l9PuF/gtZuYS1142AFFiyVY26aPpq/iSJ+39WUNiswZ60Ja6FewIT+LPn1yT8Tc+5/oM6ORTfLaRE3Le+uDB79i41877AbEO8ZGvtb3je9/e8Q/4l7Eq+fF9CurvgfqJ4R5M8aQd+Nu3tzTtrEwdIIcvfXs7rn08ddcQ3YHzLb6RTR9daa/YOIX4B2zFJ0+bLvFVVN9qPwjiC1KPfWKFL8cpXwN+lBiSnesHxGhOjvDF13uBJ59sG1xiF7DLDw+ffnprtq8fccQRf/84bnIdsQiTmffcl2AS27AO2Ik7FyRt0eB7DIeJ/bsGsUS+EfBtR/5qGFgwWCgcFwvnQ64Tmz2hisMC8sIvpguD69BTP+2X0yfH7zm1vnLYFGg3JF6PsKDOZsnhF/UpzOWvAd9W3izE9WvH0txEtfGl9Xe29jdMuaFY8qFH6kbuViSOe0HXHF9kxvcptDqHG+uQp+20Z8bgeYhLe0rPd6z8BcJPb306xi+yWp2mywek/bUrfzHy8uXLm9sydci725dD7DJezfk7hRaDA5FR+0wl4Ntfvzn8YYGLAlkt9ndv7jiPPrHIDb6/+iimXs9xLK/e6Ne4bYH6ieFZgHctJsrjYzZxHPvGm01zqTxl6sWm3mfnynID3/s8hVq2ZmcF/Xj38ACeqnOqfeM3qps7aTM+9b6j2t4o7bbHRraFL/19K7bWrfXo4F/12XH8FhtIeyOQGpf5XMfntEuPtFVoCmzRx5D6ZCL10/+2ILZEnrarIC/59LCf3eED5fF9DYkLWYkZHeRHTnypSEzpVA+lj02B/PQ9x1D7SPxiQ/IC+V73vhe4dKl9O1KfqfCRed+bPL59cMQR32/sW30f8b1CJupuzroL/aR2fpB3kNkmUAv7dsyu8cPFF6733iI3ihYK32awMRsXYFFzPz4e+veK9NtQxZ35Fo/o29Gv2WTR6ubDppa/cpfNT3S61h2hj+TGcu3mcg6HOGxH9IRPyrYs8tlvAew4Nw54ckNUbzDYvXSjBHvsm5JzLxCfpfW4gi099TA+1e+o3U2eFJr//guRke2bW+J95f33T967cmWMKxntFcgfjt+wku9G5Mmnnjq5dPnSpE0V9JKZG7kpRD+icw9q7Py5+T/+8Y8nv//DH05u3ro15sd2RLbNhavvXx3Pn3zyyfEGfQ+ijz+1vyLnyoAv5ozcrDrONZYb1ZyjOaQ8ctegbh9DNs/Fvgf++Bg/46NrMpsazuXHZzz08ol/2dDIRk69XuNTdG21Dc7DB1v44jff0nezqZPNHL7LJ4tsfvGPn9nEEY+0/Zb2rmVn8W1rH5kCfdVv/vGV32nvyJfSyT9+1faWxv/q815/qk9TvPLZxF51c30huuXFjy1gK+JT2h2iR6qMntgG8R9Sb4uvkSXFh2JrfJlC+JSzEQ+dc2CrurFxCmnzJTkXBWsSr0L27fLhhx+N88uc30ccccT3B/d+JDriOwmTq8nKhLk00e5Yb9xGPuq+FXSYyEzK6GDbQ8Oi6e4/ff9tRCZ9E29d2Fw8ztAgHcS0LrDYfPyrimeHOM5dJ/JTplvoG3N17yXYaIHarik3Ye1mRB7SH5Bj0CdyPbK5J1gaN6ZQeZdQbUG5Acniml52sTE3HNXeajdE75L+5O/xKfLOEgc8vZ/xrYf68SnnaAp9vri4oXz77bdP3nnnnZN33n13km7c/rC6cWzaH7LzRzqeuXxp/MC8b3K9O/D/5x//OOh45+TK+1fGv7xoA8lfTvSqyWuvvTr2tfgX6lH9jI+9P5D8xGNK1hLC/9lwg3316tWT3/72dydvvPGn0Q+bduLxl7/85eQ//uM/x7g8+9xzJ0+W1/mrTXTXNkxfRWnT+C1uleJr72/OI7+WrQEvni0xmZI3xRv/4ltusuWp2+bqQ576wJb4mhv83KzTnXznyZsiSLrVtx57eKIXT9qvb1v+ZnM9FN/xxffqN8p4hRIbuub8X0LKo3MN6tMDazzxnU9p5/idtkZiohwin0/RkxhUUhaKnyF59O5BdE2BLHayn3xtkJhHX+xNG68BHx4EiUP0kBU/1Q2qPhDHLW0XPrYDO2NDr6OHMnzq0VPbaw5L9kQGu/e201bQ4dryFJc/OBJ7+OCHB9/g4vuS30ccccT3A/dmFDriO41MVCbZTOoL89pmmHS2TDx362r2ZAHQyOTdnjr6LqAtHH4wLm7uJcTurG2Fj53avS4cPMWVBdQR+7F9sdXqJfb3EnRoawtvm5pSi1KmtoXx4eYV5IXAq4iN7r6mU+esYBuKftc4coxSDs3Wpj+2hGJvFvupi4LIWUN4ttavmOOJH1N+gvwpXvmPnI7NKa9xSJ5UnfYU7N1yxngO5Z6WsAH1tk2uGbp+/foYxwoffGdHZCfmxmZ/dOCV07/O+PBDD49/wv3Nt946+ctf3hw3izwd5SP0r7z8yskLQx0ScmMSP374gD/S0TbcK2pbAvXjjeTg5yqGyjZxx350mlUR/er4QP7ly8+MY9+777178pc33xw3t958861xs+vWp7fGD+jzwWZd4sDetGPfhpFf+2LNy/xWfUQ9kkf2VNtOofJsRa8bL5/EO9T6WEvjt7T3O/6ZA5Mi8c2x/ABPaA/O498U4vN4vZxS2jU+V99rOfA7vkVf/E1+UlTbHhKDvX6Ffw8fRBfiR3znX9/uIXXjdxA/4lfvM9CVOvE5dk8htp0F1bb4xg92kxs7q37H1d608ZoN1W91w1fzp/yMPhQ+dm71WT0yUn9KRw820acuXbG1B5ny40faq8ec3fX4rCDDfOb1dk9DeqMD2OLHGvNMnr474ogjjnjgH//xH//59PiII0aYoPIofTA3QW39fpBJZ+u8Q78baE980fvAcDP1+OOPjovhPLofYqO8bzuyMMpi6dsIixIbHv4iTmCDy03wt9nu7wrWFnn6iL6vnr++eZEgU/tW8uqZV7BcX84h15XrNd9iqnlbF49ZJM/VZ0+I7nqc8j5fGsSWKj83DnM6KyITWeBvQWwQi62IDjzhr1TzciwN+NLra3+p8MvxNT+vyakfn8XdMTlfunEZeB979NHxtQ5jZcqkvplFdm5qlsiHfX1/rY33bPRNrc9GmW44/KKePsIeZCx59HQewTWOIUO5DaRnn3nm5IUXXzx5ZkiNN3jTfrEvf0X30mB7/FQv8YiecU4Y6qmjLnszXiknD4F8H8S//Mzl8XUX5XSE1JMnJm6i/En6hx5+6NS2QcDwj78c+ehQ9szgt7+u6JsweIAMqDoh8mN/zlMff/zaArL5GZlbEN8Sn+iG2Ks8xyH1KyIjFN/VjczYlbxsFKA+Bj3IDN8e32LnnNwpxF+gq/rvOFR97euEPzql1c/4LT881jJbbQQ86u/lQXOxjg/VD2niD5GR/BoDVFH97X2vNsQO11jNX0O1L/HciramPOiJnOTHzjmZ8ulPbNi9hsQwMYPoWQN9UzGeQuLCl9gW3TDnU0X8i6zkhVc+P+JLNsXC06PmRYZvBZ4HscEfwfLXbaOD+C+//GL8IcbH5o844ogjgh/8/vd/WB8Bj/jewATm2ztuWoJMUkFOzTFTE1xFeDsRi3BzZCHQbj798v7I+Eu5x5C9NlcnXjc2JrdvO7JheD825MRnT7xBLC2SnnrqiXEhAeS4kb1169PbMT/i7GiXikXheHoXvCqYJ1c++eTaae5+TF2T2taGlbbVlBbCNjDbgtiTMNNP++QmIDcjW+EXcvWnFvTRI+0JT9UnXUMW93ueNsxNgXj4BXiLb1N6nC8hehIH50H1MwRkqifNBpxzlJuMUd5QTnvkgHFmqq3IkofPca7x8KV8DanT+tGhvkOyULP1zjYGuvHgTV70KwtvfAR56uZcvcREvdiBostxfs1Pm4UgdXMc3SC/2pC6ypFzqOVQyxyTuRXkuF78mLAVeIwVdMXXJcRf8aBr3BgceAPliF85Ds8U6KsU/2sc8NvQFIvQFuQpIe2855oWDzrxpY/AnB/yxTF9BE/yUt4j/oJyx/iq33OILjHW1jX+S4hNsXEL1KXHeCDudVMtfkmnKP6nfk1jc/wN0VXz10CPvqE+27bEAk980n/5VXUpn4L8rL9inzxt4Zj+XtYU8IhNxtildlcXsVd/Vg8vPVv7S+zGN6cvNvFFmuuaXnmQ+K7pg/DF1lx/yUPy0g/lpwzoYFNAb/R7Pb36sMWeCrb5jMLzzz9/2zdwT+AewHcUyT7iiCOOCI6bXEfcgfqrdNCeqDo9GZC5actTXHu/vwVZGJscTWx+Tfdr/8cf3zmJsdPml7/Q9W2HxYrJf8+NzFnRFhCnJxuRBQQKLB584+D4Pa6Lg+uoLgIrLmqTKwvVbGq5lrRhW1xamLab+C1IPX1qzwLSwp6feKSIX1ncNlsOx5A6wOatyCLbAn8r1E+ctt5wTumJb9VHKfAt4E98XkOVlZuJyK3yocZQvrjDlD+1Xihw3J6cuptvqi47uCK72tDbm7o9f+pXXqm6oYrIEUc6at0qG6od2lh56kzVDVV54aMnqMfgHMV2iK7o3wI6tdveTa60tf7Y29aDTfEPX7V3L9IGW65RczldW+uD2Jsv1bcGWPMtyIZA+IK0SWIAicWU/2nPSjUP2vjaNkm2thtd4csmzRZU27f2q/Ak/tEVOdIe8TF1xBBf9XsOmSfqtbAEOsx16mYTZAvYxafYVvmqb/0xmkLaYYvNgesnbR87etCdtmajPoJPnJxvvR7YHb4pfeQro49M5YAv+mFPfyMrOskjK+3rvO+DdKifGPOPjMB5tfv69RvjU11b7Qn8NWdPDes3gZh88MFHJzduXN98bRxxxBHfHxw3uY4YYVLySkqdnMDEVV9fC0xcX3xhUlnuPufd5DKB2siix+RYFyPN5ifPtSFwv9BieH82uSBxKuFaBPvEOe2P/+bN9qfJa8yPOD+sBbMgrLBQ1A76vA3dLWiLWZtZbVNLW/mz2a7PLDY9peW4Ykr/FPCrS+6UjFDqpS6ER5q8KdSyLNizWN+Cs/CwE5+YuwGInVOIX+ojY5NziG/hnYoR2+T3ZUvAox+wLYjOOSjPzQa+OX+m4IPy7RtrB5v9iNHsJqfJUlbl0ufmInlJl2wVQ6gxrzKneOXZxFAvN4hLOqodfAF5OZei1EvbOEexce+NU+Tv4Ztq6zWEh53ZpI1PofgprZBXEZ9R2iQpXm1cZSjj3xYfc0OqvbbGhK60tWs6bbMEPmWTC1/6h/PeX1AnlDrswydvCjU/YwFec+RWaLNcM3vGK3rmxgNpKL5Ugvhaj6cI+CWWdC3Fo4JetLU+u9Je6b9boL71ofrh6X0Nqk+pGzvlp29tsbeCHm2B8KffBOTnmpGvXD18yaez55uD+rnW8WkX8mIDuXzpY48vtoA4K9/ib/ikQB/5vQ5Qh22xBVKnnqedHfth2l9A3IrxVfRLT49tH5ngLyl6w4P/W/w64ogjvl84bnIdMU5Qvk8irXA+9xoTmLA+/9xCbb4LnWeT6+uvvxonWpsvn33W/qx0ncjYxUaLhW872qsUJ6Mf9xPitTb3W5x4gstroYEFyaeffr5rIX7ENugH9ZpyrA3E32vC2sw3JtqNkEXlYSFuQWkzy7e08MnPwhGUQdq96tIHty6sgyxgyaCn2t10TC+a6+IYbUVdtG9F7JtagC8BnxutGhNyKkWeNHl1vOn19efqJxZ74y4WZ9n4QMbKPu6xQ8quCnajqbbqfarQp3KzuBXRP6dvDrkpFv/aBkF8kibuSemq/aP3qZ471jeiq6+7BDx7242NeNZ0Vf/oYSOqfbemZEVejlFuenNjmDqQ46T0qE9PoIytW67R8LJx6zXN/myO1bZmC8T/HPdUfcpxpeQnjY3si641pJ3x7fkhCA994rGlj1S/wlfzghxXH4GdyrIxEtQ6ve145p6WmgMd7BO/rfUTizpWxQ9pbK/nkDS+xv56XvMD+sLLTr71dbYi9mt/MiKPfD4ply+GNR7K8SBIjNcQPjrJxRMZjumf8iVxM3ZWO6fqVuDjB32AJ3qmEPvwBNFBFoRfPGxy2ZxaswN8PsU3JX0jkZ7AK4off+xD88cNriOOOGIax02u7zlMSp4eeeih+rRW2zzyWlOdVKbgFRcT9dwkc/ZNLpPhX0fbTG4mxLmJ/LuAtoH0g3FBd78hZnNhswBpr4M+MrT5YfF47drx17F7BWu+LPxsIluAut7kWQjWuHvCRr7q8lwTUnltkdvq5WmbpevVdeUaqgvVJvvOm6aksYEeC1O2pQyUh3qwQ11lW256AotqfGKwFXQhutg4B3J7Mv6xL2NL9UU5JD8+qb/Hp9hX474G9cV9axzij/ihni9+xe74BimjT/z2+JZNwj08dPMPltqrh7aKjSgy4kv8qGl0SdPGKVsCHnSWthb/vZtc8aW2zxSlLCnCw5/q29Q5qC+O9G15gib1c7MbiOUWH/Hh115b5hN2RWf1zTHUNH5V31LeX899WpFrhq6t7ZZ21h/3PImkPt8ga4HYXe2fOqcz8QhyPJWPp2/rKf974LPmEsM917b5pd9Mm0L8SizSVslPnYrYLcUHGQdAfq1TQVbioCx8fb29iA+5NsiMbWJQ7avAl74D/N9iT/iir/qyFPPYKQZ41vTV+pErr/JOIddE7IPowA94reW9fbHlWtOnnnvu2XF9Sj6Q6TMaH3300dCv1/vbEUcc8f3F/B3REX/3MBmZPO7c4LIQc4N19waX80xWQer2+TAzh64iorwu0xYCd/4K/13EVHzuJ+bUZ1GSDS7wulsWnkfcC7QbFovIdv0dnqywaGvkqYLD4lX9/BVEbSmt7eNakTcFfS/9T+qaCtWyKdBRyXUYYlu1oSL5S7KnMCdvCbEtviCxaDE7vFZUyyv6c36h3s+z+gR7eeZ0OQ9N+Rf0fBCZ0r4d0RTPGiJzD/As6VIWqu0ohd7XKdCRNnSc8xxvxZqes2DKv/iY8biNyYfrNP7jqf6A47RlbkKToup3aA+m6m+NS8/b+x7fep9rnZBzIDN+heJr/EteypO/hMjfgipvjS++hJK31NahqTYPxecpSp0gerdgq19LwBtK+/EnvkrlQcrm/I0/8S325Tzl4akgLzqhl3EexD4UH6TV1ingSzlf47vjNZCduKL4vYSqD5b0yUs5hI+MlPFxCvFbOofwoyn9QXR5gstGV3Syw+aYTbLjBtcRRxyxhuOTXB0Mrhl824fVnTs7DMiZVKT1OLzh34tMWL2sKXm17lZEViYYfxI+N9iB/PY6VH8T3SamXmfOPTLcf7hYtdjeUvrH09t8QXtipR0/+qinA9ov9fmW1Z7397cg8btfMFHD/X6Sy0KBr3kCqEK89QFPmYl14FHy4yPg9w6uBR+Z9wSduNvcsnDz1w4T83attTZSXzvWjcj6VFauMajHFfIt9iE6pFPUA5/8LJK3gs30snErsgjGM2ULxMfeb3xZ9DoPAVkpy7H6xj/p1qda1JXu8QmPGG59SiR2i0W1G+JP6uRcPeScT/rUUgyncJanstI38OzRxUb19an4UJG8+IgSe7pi5xad6Ye5WduCqnNvW9MXHjIqIrdS8vHGvpqG0i45x1PHgS3thkebpT+uxVB9/ugbFWKJf4o3PgGf6qtSQdoSpJUnvqHwSXvqoX6uZ/1/63jFP/HAv2d+xkNf4h9UX3IsRWyL770POU879m3Dzi1PwwV09DZu6SPgSS518czFMb6BY3rqNRZ/palbedRTHj+ThuZszZPPGePmQFf6LnnpE44vCvEx/Q5cF1v04E378JV9iUGP6FE/MZPSg+b4KqIPqZu2DV/ihciu8cWT/NiKb0onf9QnD1IPL9Dp+7o+Fl/f9FC9+eN7Y/7g1BMnL7zw/Glpk0Ovv6I49R1e+sjIj/beBnEfccQRR3x/cdzk6mAgRgZprxLlg85DqMZyY7qNnEwQ6KuvTE5tELdhUCe8rSDH95rcbGVCMKm0VwkP8kwwdNuEmFtkTqFNAG0S8xHHtlBovgZEycukFAL18dc8cNw2uA6Tbcsfk5GnTaxtggzUM5kNNW/bJQVxV8YWvO3Jov61nVYX/1lAZibq+4F8Y0T73k/4noFva33zTVvMVHe1iQ/3i3Eg7j7mecS9g27umn766adObt3ycf+2wSLfNeB7W488cufmcw83IVmE4gm5xnIMuV6b/JbnONfpFugfkbHneqmL5a1QHy3ZGB+rr/FNPOJzaA74+cbOrZtc0ZvF/xZEz5ZNrqqj+hdf0gY57qHuWV41AmP8Xh6xgzl75qD/xy/gK8S3UPwFMUxf3DOOZm4xP0XWFuDBu6etwxM9tQ3jo+OK+CmfLueV5qC+Ta62BtnebuzT1q7LtZjE9vxIE+DD3+tMfUgfTvx7RG/aGDlGeM7S1rnBzti4BdHFVq9BbQUe+uhBfVvnuPedT/IS+97/KajPzlp3C/BYe8y11xzw0Jk+MgXl1c+0M+rR+5jj9N89tvVxn4sFe7JujR9bdWwF2bGHHc7PEmtxxBfqwRdEF5/J5xs+erbqYx9byWJvNrqBbJR40VNBV3hTPhd7tqlHFvDJMRnQfMDfdLt/st7/6KOPx41mPwC+8MILo4wAjx+733//6mnOnSDfmvall14az61j/RXHI4444vuL4yZXQRvE2zdy8hqRQdZG1+lYPcLA3jZe2mTjsVm/GuDPkzF1cF5Dk/fVOCB7isakY7BmR5P36G15yugzEXz66a1xoliDwR8/u5599tnbE0qddMA5WxA9yDHe1FMHQeqxJ5Nl4x+LR5g0PbXSNgwPMVFXDKVkq9eenDvc8ABdTe5pxm20DPnNnNJAq/CL0Ffj4lnc7wfaYssm17anOS4K/mJm/cBnbR+bLNom7WmDyyL/00/v/3fD/p4hvIkxuJ596N81/NlnX4wbWrV8CspzXUhzLbX2PNw4JJ0CPnJSbyvOyteu6R9u2twJ1K/6qt8QG6qfUnWM13tuiMlmY/imbi560INnj0/0aK+MNfGvkjx+xL8ch8/xFpClf5Gx9cYn4FdiuxXsRj1f71uOgS+O1Rfz+LoGcrQV7PEt+unY69tcW8cfFPm9nxX0Rn+1I77jsebY8yRRePDviQe+bC7oW2t8qV/9ojP9svrtuCK+SelJeycOc9DvxR7Ef6luRdZs9IjJFqSd8RkH5uIR/6q/eKZQfUwaH/Bpt+ja6lv07uEBa0j1xXHLGAfZQEl7xV8UO3okbuqHDyV/CnlibE//FXP26X9zY6N+gJSps7Uv7IEYpL+xXXxr/wttAX/wsZetlU/fRPRVX3r9W2OIDw9e0A+d00E/3XPx0vaxJ/Gf00l+7Ab18Aexmb7ck/iY/GDhyeXLl8e1aaCuj8xfu3Zt0HmIjfuKS5cujeNTj+Mm1xFHHHHc5DpFJgw3nyYcixADq0Hy6tUPbi+0Hhzq+JXh8qXL41MyBmhlCAy26L333ju5eevTUcYSDORPPfnkOKjbjPj4409GPQZvcixQ2PPuIO+HP/jh+BSWp7tsRPhVI3YtAY8NDRMMMqHZzPDIr0nliy+/GP2n69lnnhk3RtSLXKlyFBvhxRdfGGMmBsgGjknPJBVe5Xy0aWcB/+GHHw72PzputkEmPvPglfffHx9jrjA99t6Jy+VhYvMnheHmzaGNPrg6xqI+/jwF9vzotdcGnT8YY9jsvfegl862EFm28SKgrcSVXouYvo94Wujy5RY/dZX7DlTdEDtiP/TjhnoTcLh+tEeeztRf9T/5kDoh7RdoE9dK2iZlNQ+W2o7MLKRdr1tRbdnDRxe+fsFMXtLITl4FXUvjZ/WVDAvqjMNbQCcbja8XvclV/coxsDk+OQ5NAR9d4jdXpwcecxe08XD9pidI31iyqSJ+sTE88mDNx8Sj779LILuNo/teR4ud0j3jPR59g64qI1QRH5IqT7vN+Vfz1U8/3IrwsCsbJluxtrkQHxH59WYVqu05jq+hyMVLhvZK/MMzh+iU7unHeNIft8aSX+FLPOit/lffp8Cv6vucf/LJs4ZJH97qW+zcwwPZ5KKv7//xMRRfpT3iU/wLVVvw9XnO5yAOkFhsAR36PR14ej7jX+xXRvaSDWcB+dpCyg5xlYpd+lLyt/iFL2MbJB6RBc7TzwL1EV75W68V+oz3ke0cf+xdipe6GXfoYuuUTuV0sC0gF3+At/G3TS7rUjz5ET7IK4ps82O9exRQh55aN8Dj3mBLPI444oi/Tzzwj//4j/98evy9Rm52DKAmyc+GBdL7779/8uEHH44bQgbKDOjObTB99vkX4wLigWGQHYbbYaBtiyyD+ptvvT1u6LTJyq8vvrlzN4GNMxtd6toIMmB7r5wdZFms/elPfx43IB4ebpCfeOKJcbIw4C9NSHhtcNmU4xsfffvq6tX3T955592Tj4dJgD4TG/La1LXr10/+Okw48QPIz0RiU+zK+1dObt26efLMM8/cUYds8ERQJp06kYrbW2+/PZZdvnxpyGkTq80f6TvvvDNuKIqz1xPFxwZcHzOiH3v0sTH2cOPmjdEfG5JLsUbixe4HhsmUz/drAsykranm2us8SJy1B3Isr18UATts5qqXdhIHC6QtTwYecYDwiWEocC1o84cftkjNwq0t3lxLuSYO+YdH+7VXT9pHmvKqK/lbQA/s7fe5/rfyqYsnfNL46Th1IL6FQNnaYrtCfbQnFtGvLaruJVQ98S8+Vf8iG6rs+Fp9XoJrVBy2gt7YtSd+ED4IX5XX+xkf5akffVPUA2/4p8rnEP3it7UvQvyoPLFBfuQmzfhZ82IvsDk28BvlHOGZGnvnEFv2xKLav7etM/7giYz4q6z6j0C9Crx87H1HykJkI1B3K+ilM/K2QP3wsa2HfBSb4l/Ow58y5/EjvsXf2KSuuTN1ttiaMWePb2A82MtDV/yIf4isHIeUB/yKjXxea2dERni2IDHfwxM9U3zZfIHYrM5FgnwxldKduFSwLb7BFhtSh2/hpQfmfKnneNAe0JFY7omXOrFxzkfnymockgbOxQ4rO/hrvVTruUchyw//7olsjOq78beXGSgj+7imPeKI7y+Om1wDDJIGWIOnm3+LI3+e9oOrH5z8cMh/9rlnT55+6qnx+0V+AX3owbze8tX4RBFe75b7NaIN0g+e/OXNN0+8TugXB5sqNptsTk3R+LTWMGhbKHkaqt0c2+R6eJTlCaf33rty8uVXX5488vAjI09+raI7de8mT4IN9p4uZuDGzZsnf3zjjZPPPv9s3NDzBJnHfW2yPThMIp6kujk+4tu+l0B/Jitkk+v9q1dHO737Tnad3NRpm1Zt0vfLTCYt3x969513Tx56+KGT5559dszDm02ut99+++TGjZvjU15ixqY+VujJMfXR/PaBST699967ox5P2F26fOkunpB2QKZF7dwvTu4V2mTcjs+js8U3i1SbWhZbrQ+0OKqlvdriVjv17YNHP3YMyn1XzSZnrXvENIQt1NCuDdetmGubSlmMaR/IuVgn3jXNcVv8HW4gKuir7bcV7IG9fTA2V77YkDJEfvJjn7TaWP3JcSUgy4J7D6IvMrYAT8a4qh+UsSNp9XEJVU49JidtugXq07UnDtXWrboqT38cCupxfFNXmhukSkuI7LV6FelfeLb2YfXZmHaTouTlOOfSahviW+IpzXko9VB0TG2yzCH69iA8dLFhDurEp+pj8nJefQ/iLyirkJ85tPe/IjLR1r4cW1G1YQ3RJcWT4+pjqOYjdQHfFmIXHjLEYcr3KYQHImcrrLdynQXkxc9QfAylXq3jHMhCsSX+qSOlLzorTaGOpVsQW6NzK+hhf+UjJ5sfsXuPzDUkzllPRweqqP6rx54tMal1+Jc2In+pf9X8tPUayFW3r79mY5B6bAxB5adDfnQ471Hz2lr20C9BjP34T4a4J/Zr8IO3za32kMG+dcQRRxzx94PjJtcAg2p+JbBZcP3GjZMrV94/+WYYsF968cXxtbzDJtXj40aYScjGlD9xm8nOAC8fvfvueydfDQPsSy+/NMqwSZYNlkrZ4MJvQ8JGl00LG1A2mdj25ltvjZtqg6XjIG+DYtyUYsPDD402t42u9hRaKBM+GVL2eVqKb88++8xo1/PPPz9u1NmMY4uNNO+9fzlMqmTyOSDDE2w+Dvn14PMrL7886ugnxmy2yHfjb1Jig19krl69evLoEL/nn3tuzFMnm1w280xKr7/+o5OXX3ppjC0/2VaJnXzHD3mlVL62evGFF+7iCdkg8+Td2sLhosHW0HkWXmKZmIZav2iLS/Ezuf/1r+0v+OlTFerrW9ot8OSd/vX5554i3PdL4PcJp91t7K+5rtpfBW0LxgcfzCZXFn53L+pAmfr6wZabxDmQA3t59uhJn23+NN7k1fz+uIfrjZ9bfMUvPnsWp9Werb5BdEHvW6XqY/KqH/Ftzj/10+ZbEX29rCXEtujCl7zIq+c94ctx5EFsmPJzr40QHWhPTGI/pH9UWdU/xyHXZcr46DipvIrqI2SuSF58nfM3Ovb0X4jNe+NIV7UnPkkrqRdKnRBERvU/BOEBqbrisgZ18UJkbUHVN8WnLLLrMf/C1/scAnX6uDnOjXF8T53UC6KT7D1+hYc+enq5S9CP6Yru6lNkxt+cg7pB/KrEjt5n/HO+z6HybEHsneOJn/E1x3ik4VNmTSMP4sdFoerVBnTq+3PXeHyJfzDlX4/Yn/UtnrTHEpQj+hKnOSiLXdL4IH+Jrwd94SEneRD5/AA+zMlv+a3v9OUZX6b4Ajr5oG7axLeN85bKEUcc8f1FG5mOGAbl+sTRrfHVOptJL7304jhQykOeeDFw20h59dVXxwFWefsLgyajU4GneGicrHxDpH3ovCdPz/g2FH1ep6OffE9hSQ3Ut27eGjd8PJ1lI+LWzZuj7DY5rE9KqWMD7b133xs3RH78+usnzz333O1NKmRT7Sc//vHJM89cPvl80OtDjyaM6BnrjZIOiOw6sUrbd7gOG1F78MjD7Qk2MDlm8qrELsSmYNx8GGItq056PWkraeW919iyUNkCGyhiyn5PxnnyTd/Rj/Sxw2JCe9/9LSR9vG5wsemLLz4f+zYZR9wJMdOvEvd23hZwrsdHH23ktcQsZreCrLNCu8WePUgfrHyRM0f8Dbku9R+pc9DnXG9uDtsrr+36QsrOgvTjPUhMKqofc4QvbRr/HMc/5XxpG8jNN/aFEtMlTNm2BVtkQ3yB8NS8tB+Kj/EzdTKeSrVj2tD5kp9V31bgqfatodaV8qNP+RXf8sMPcp56iG7+pL/2c3LamN8Iz17Evz1g0xxPbO8pqP6j3n956dNs4xfws/per9/a7qhHb8Mcwq8u/XsQ+dEVGaF6zfLVcerFZ8f084VPfKztHp/T1uptReKCbw/S1nN8KeuJvuqvNDQ3ZklzvtTGFc5R9G5F+LYidelge/RNtXH1u9ZF8uXFV8e1L5wH4SeTHvLFMNfQHMQ1ca59cc4e+fGXDvw5l675Ebvi/xRfdMQetuGJPynbog/wI7aSl5jjFyvINScWbOuhfvgC9cidizF9+eNf1q6+v+WHbn95EdGlzhFHHPH9xnGTq8AgOw7Cw/9uat3EDrnjQGpxYDOhbXa1v0BnUwA5P0x6/SBu4Lao/Grk9yHESr5t5bVG8jx1Y0OsLV7aB0Y//OijUbfX9zx19eCDD53qPvwVJnbXCaIiZZkAPx/IE2Se9JJvIqAHOabbx+d9M8vNfdUzhzndfOgnrz1gUybHu8kEOHXj5bwt4qf5GpkgpybcewlxMPmfB3yGPqbtvPnTFioWMHduclmEeMWz2qDNfdCzfXD++70oEML2lJZr5jRzQNsA94qn138fHccFffus/fp+97uK6K59gB9ZoOYmIjdQ6inHl+sxN0pZhOpDSz7tjdNZ4oMHTemS166Ju/2Lb8Cf+NfGiGn/5vRcNOihm64t+viYGxuIvxmDyattGD/loerjHpyVbw/Yz6/0R6k5zA8zKE8u81VZfE2bSpO3p//K3xL7HnvaLYiuOR5+5TpNH0bq1+vXMcR/bcxnc7k1iOPEA6Rz/gf8OSvWZK+h+pyn1NPm8tLmQFfak498Rmnz9PepNne+t70Slz18UHWvtbc2RfxVV740+vnEt+orqmNYfNtj5/3gUR/F1/Tpvo37cQxB4iONv2IhLim7COTagsjfAvXU1wbVhymwV7k0fVcqNrWPL0Fcqv+9PjLYISVbzABf+krqbG1DPOTQSV/aKzKjI/LTdnNQTpb6U1Dmj1/5ZrI3ZrxZ4p5I/hFHHHFExfqo+T2CwdXA/oPhJtf3tSwUvvnm63Giffxx3856Ypx4bYDZtPJUFTKIt8F7apBtMh94oH0HyeuOIa/XPfqob2a1hSp4lSyvQ34xyPULhUnHK4WevHKD7ZVBg/xo6ymtgX1Z+HgFEQ9/p+jFF188+eUvf3ny05/+dKxLPxp1ncqrUBbeHlN5W2DCoi8TdSWbDnQuQXnPh8iL7/cTic+GplqEPtY2Ye4UJC8u6Z/87Cd9/tucqfj442vDouj79y0u4Rv780inmUPvbh+Mf+D2htZjj1lk6zcXO1ReRLzTp7bA9cCvkL6QxWiu3ywsLZJRxjWkTJ21624KZ+Ghq+/jc1Av/kn5lJslfkY/P6b82xpDUHePbRV79ATRFeJLu47v3Kzje+rHJ20Wn5O3ZsOWOj1Sf28797rw9/6Ze82budnlZ2KPl29p09zc8zXtq0wcMhbusTH27W3rs/KlfflY/c9GXtpafCI71yXib93oiP9TbZ9zcrbY2fMHW+JZeWv96m9tc75qc+fKUXwmh8/84h8/q8/anb+RP2XzFKqNW+JRgW9LHIKqi199e6eNQb3qa477MSz9YAo1f69vezFlQ9/OtV9La7ljVNs413ZtY/lVduJAf3iRMvrUOwvwaQ+2kUv3XJyXgI99iUHfX+Qlny9sh/hV7VgD+/Czl7xcR3gdQ+JTgY+uxFbcejvnQBc+MtJ+sb0ieUsxjB0V3ljIppbPregLfZ0jjjjiiB7bZ+a/cxiU87rh44+1TSgfWX/jjT+Nv36aI20wtZtf3+U6LLxtHOR1ph6eGLJhZnJ5+GH1D9QWcxawFjYm/4fGTSUyDeCf3vr05OYwuF9+5plRpyew6P3q669OPvr4o/G5HTpDPWrZOHEMPvIzk74JrE6ukMnHhIicZ8J03E9N8iI/vBV8n8pfQnvKqtnA1kotjm2yH9TejSEzk/kUryfhPOW0dfK+SLD3vN+8Ek+2i3kFuYmzpH91VhuLW/W7PYn46RjvoJf794AW91wLLU9sbAzqC+21Q9ejxbdfzdsNVU8XjfPKTHvHPm2r72trfT1Ur+9cx1LXtXEGtfHvcLPUU/LPYjO+vaAv/bz3r/etjQUHu/iRRXx8JC9U/QJ5EH1bkHjuwVr8qo9pQ2l8jH3kbPExiK81bw6pszUOkPit+db7J0W54b1znL57cxK5SZKyU77z3Dih2B9/Q8DOPX4FZ23rtFcQ/1HaF/E5N/wpq/6TlRjw1Q1zbvRR2ru2/RRV5Dw2bUEvYwtv6kiR9uYvX7N+Spunj0P1Scr/+Jw0/QAiH+ShnEvJXaPISr9MfuTMgY1TOuQln7y0OX/lVdT2zXHaMzFAOYbkheaQ8tizhtgcmdWfHNe8UPL4Gj+n2lkdID/XLL/Sxmlf59VfiB6xDMKfMmlkkyMvepVtReWDtEm1ZyvwhJ+8en3neof4rT5bUXQ6Zo/4rgFPZNGT+IO8eu1UyMOrTtW3FjflqVfl9joif0o3KEucIK8fuhfLZ0Zq+RFHHHHEEo4fnh9gYM4gbbKRDsuCcXPLY7Ami1vjq4Y3x42nPPli8h7rjgN2m2BNCmS88867I4+5wcfcb968Mb4SFvKqIrme8FLfwO1Gm0xy/FLhLzx6kuvVV14ev8ml3ueffX5y/YYB/4vx4+30xQd8SdmVc2RSYM+VK1dOXnzhxfEj7PKhTjyZfPq81PWXF32rS5kPz9eJM7wV8mIHn3x43kbd1Ifn3xts8zoon1rMbo5/OTGkjIbmX1sgkKGdyKXeZo9f+yofUgevv045WDXY2xaP9xPahN1etTwPPPknXmIeaAd9iP/iw7f4J0b52HzaETwNqE1SD5/+910HF0OBPtaeyELt+kh7tCcDD4v1GqN7gdZ/24JQm22F+rmWpDmuFORarGkodeeu2SlENp17rpvoWtOTevELiVEtQ1Blxaccq5O+v6YzwEOX+lt8S/16/a2h2p/j6mfyUgdivzrxZ4qmQGb4tvgUTOnfArrw4pHGN8SWUD2Pv9FZfYrd9TjnkZu8CrLI7tum2rT3mpuSN4f4Ez/rMarHtS7wDaq/PSUe0hB+lLKtYANs5as2B+Glv/qaNBQbITLwAv74lBSkKHXreBUZKHKlzusxnhxXik1T+VXHGsITG5w77mVXxC/rufgVv0NLIHtLvQq62JFYL6G3P3CcsvgsrdTzoupX9Nfj1HOc68w5edXH1It8qLJBWY/Ikta6S1DXeok89WsbnQf4a4wga/hs3kRH6jlPXvVjKyIH+IGm+MlFsQ1t0Zd6tT+n/hRv7FFWkfav9d0Dzdl7xBFHHLGG+7LJZTDrB7RvG3KTa/Btv3o8dPLgcEMMn33++fjx9+s2p8ZNqpvjRor6jzzaXi0cpq/xvD0pZJPrnbYpM4zNPihvc6iSTRd45NH2K5fw2PzJpDJ+SPGDD8e/cvjzn/1srMO2b/76zcjrr4f4S4F1swpyLFU/xyYQfDa5Xnih/bVI+Zk8+gm8P1YX9ZtcNkUcoyngzYS2vMl1cnLlvSsnN65fHzej2Fo3BceNwSHuNiV8mN7CIHap69cer5B+9eVXbXOs4/100M0Of62RLhPnnM33CtlcqU9OnQVZFPGfPH7YxLJ5lqfULJiUg/raSRnIZ8OHH3448qaeWOIl8zTrOwl+NF8svA4Lb9dQntJqm1tZzJ0y3ickxtDfcMf2Zn+z8WDnIb8/DrQlyjWZ87QxhGdv/4++vXx4or+3O2l/DFk0BzmOb1P+RVfOt4C+6NrCG1vn6saH1JtK+3o5h8iMj/rK3vGKnnYdt76wFdWmuTjUOvSE6EueY9QfKw8SPxT/kON6njpBZIJ6FeRry6mNrNixd5OLvhpDeSFlofhY076e46D6H1+VV/9rnTlEV2RsReyM/jnEh9SPD1K8tUxaj6U9attWSj55jj29YR30g0FG1hmJQ+yQZx4zx+cHQvmxiRyptYe/Gu3HReeenHPue5Q+SaHPxF7fQR31/sCPlodXQyHypTkOHx4y/YDWPzWdNoyvjjPmVL+2oI5VW8FGtkbfFJRX3z744IPxe7M+kSBeydcu/CSnzamHbxuGH/p2dl7z4kN4pPKBva5TNvgx7tr1awNdH3S39Vxru09OYy7/+vh5D3bGlkqxXRnIm4N6Ypw4syP2nhdksAGlTeiLjviffCkf3Xt8M8ROH8e3BVUGivz4kXyUc7L9+N5ie+22PnKgj0F44gs/0sbRDeGTF3kpC8JXdWjbI4444oiz4p5vctUbzW8zjKt10DV5P/XUkydPPf3UuKkyPmX1sI2CYeIbyi2W/Mrw5BPtI+4ZtA3g/H3n3ffGp608geWj8V43vItOv8v10INeW2iLKXIM8u9fvTr+tZCnn3r65LXXXh3LxnJPKn32+TgJMcSGVSYvVBcRsQnJr5tcfFOuHn1pn9SvBJHVb3KJU2T0kCc7vFObXDC+ajf8x7bPPv3s5NKlp8c64v7wsIC6TV4XHeL1aJnoyeDXB4PcB4a4i+ljw0LnDr6BHhpk2RQkl12J0/0Ed9nraSL6z4osEtrCoi0OvPZqcaJ/ynMMjvls8zXx1iYWhRaLfbvlG3Stbqv/bQYzbZK2eOhnbTGb69B1JXWezcH73e49Wh9oi0K2SCuxv6fwwVT/tbhs19vd12GP6NlStwIPu5f6bmSj3vaaX8uTD/GBb8r0Y8fJX7O5ytoKMuvG8RYdU36Fqn9Jc4yiI21YKWXVBrx93hrwaCs85O5BbMVb/chxZIeSV0ndgJz4KtVXczMUHXv7L73Q98XYOJePL3qXoD6C6Kr+xfcpUh5+emr70o3qzWAoNkXvlliA+vSqv5UH8EQX/bG52t/7nPyglic/PsfX+AnqrF3TZFkr/OUvfzn5y5tvnTwwnPseKTnqVhvM/f/7f/8/J1fevzquabLJgdgbve+9997JH994Y/xItfWFddfvf/+HkzffepPB449+xgC6//Xf/u3knbffGdcbTwz5Dxa/q78o+ei3v/3dyVtvvTXo/HqUby6O772PkHjOlc/hLG0deyExrH6EyEba6N8Hf6zX+PHss8+MPPC73/9+bJu/ftPihq+2s3M6+naeQ3QDGbHt6gcfnPzhD384eXtoC8c2M216senq0N5jGvrg6qDrr8Pa9vnb+oPoj1zpnD2xRV9Qx3W6t33WEFvEmS7y07chcVZG/x//+MfhfuLdsfzZZ5+9zbuE1IkObYHfMThGbb3Y9EmRa8+18fbbb49/7EosyFEWG4Es+ZHBVhSoK7/aWmX1qDEI9mxykdnWgm3d51yfOOKII76/aCPePYJBxvdunnzyqZMnnmiLiG8rDK4GaBtTBnmvKXoH/IFhwDSxvPbaayc///nPTn7961+d/OIXPx8WXc+OGz42ZvBlMsnYzfeHhsH/xRdeOHn9Rz86+fHrr99B8l4YJpC2YXNoBnz024Ag9/Llp29PTOCG3YaGjRu/OGZRgCApmNig5vXgdyZxk1UmrpDz6F+SMwXxI3sN48R06oPNqJdffvnkl7/4xRDrX99Bv/rlL09efuml2xtVdUL0a68+9sorr9zFh8izUIb2BwLu/+TnF17kmjgPElP+i3Egfib1OrFrw/YU4KHt8OtfU2BfoLl3Nvk9R1vE6CvtXBfgNz/bt7UO39Wq19W3Dem7rrn8Gu6YH+C6dv0aj1AWkPL7a2rvdQn12rlIsCVjCH/iV8YWYH/1T1p96/3bA37dj3ioX/3Uhshx9Pd+Inx7fYxte/za608QPn71/tn8RrW/qlP9ja+edA71/festlXQNRWPxHcKVe9SLJUhviPH/E0Mev+BbL7xMf6n7dO/ax+fw1ligwfF7q3o41Hbu/cX1baumGrv/prudW3Bpz7NcO3auBbrQQbZfmi0AeCHN385OrGNPvXkffDhR+MNMx9895R9n/oe5fjpgPb0H6hLpnJrP0/zp40hbcrH9OvkkeczC+SJY/V5CtXGew266Jlr39qv1bF56IdUf1gpf1DJ09/+AriyFrdDO9R2jq4atyWkzaDGwhrl5q1PZY5vLFiHL9Hjw7p4Ticd2optiUGP2Jwy7RufLhJ0xE6y63mP1g7DNeCJumFdl/iyi518meKVl7KMPYkzv8TWD53ajd+Ju7WjNeVnQ7sroyMxIMt56jrXX0BdOipiZ7UV1TaumMvfA/Iff/yx8Yd83z0+4ogjvt+4J09yGawMav4aockzeb4l5K8JfjUsBDLgflsQm030GcgN3Fmwhdht88prbx9/MiyshoWYJ7XwRY6B1l8B+XLgtbFi0CXH5pUUZXIxUSQWjpEnuK68f2XI/3qc3D2afW2Y6NojxJ+ME5B6fp18/rnnx00vsjIB9kiZBcqV998/eeLJJ0abyag86vEd5OU8djn3fav6JJfyXkZg0vOrSiY2/vvVLU9y2YSwaUeGePgml9i89uorY51sCtEVanmHX3TZNT7J9cEHYxwuPX1p7HMWZJWvkjIUm+8nEit+s+Us4D9evtvMEWevRwzRH/MTH7CgrwsLffjGjfbY/xzEPsAXut/hOug+zRjAZ/60hbmFejaH2uuIie8U8MFZ435RaO3WnqxzTWg/bZZ2nbN/CnwiD+9W0Jt0jy716cJDLxL7UOIL6rApvuFzvNW/6NrbVrFNukVPQFd8i07nU37KD9JufIuv8XFKv3bf28ZikTbbyqd+2mPKlpRX/3Lj65yPadOqO/7WObG2K9rTZokxmVvBHnyI7gpl1d4geXxiX2TEdyn/Q8mb85/e6n/ya9uSX23YAvXplG7lVY+9wVT84y9SN/5N5VV/yeJfSN2UB2KwxVZ88W2pj9Ch3NM5XlO7fPny+ONW+kh88TmIf//tb8f1kfOXXnzp5MlhbZNYJLUWe+vtt8cnwl595ZWTl19+aSxzI/wjPzaON8Rt7rD++Jd/+ddxfeevTPsDRGnbOR/ZY81hLebHUD+ARt6Sn4mHOkv1evTxr0hs0rZpV6Qs5chxbIyP2lieH2/fv/r+uP4Unycef3ysZ93i6R5x42diHPvxRvcev9Lv8EfGG3/688mnQxu/9NKLJ//1v/7Xk1/8/Odj+1l3vjqsEe+gIV97JZ5k9JAXe9itbu1T8lz7oB9stX0PokN8xNq1E1ug2i3P02ve6rDO4d/ly5dGu/CxWR2yErfw0aGcf+qCc/TnP/9lfKrRRpfNQfXxRp6nIf3Q/PrrP7q9Fky/YCuiUyovY+AS1HdN0DGH+IACn4ap5wF53q55/vnnxvHBGzNPP/3U+GRhnub0h5XW7DriiCP+vjH988EOtMHrofHx7EuXLo/09NOXxqdqDIJT8GSXgciA+m2AAZGtFioG9fFVwoHYmM2Iw6+U/mJJWyR7zdAA/PXXywtSZW1ishj2JE/7S1KZnIA8ZFC2aHPza5D+05/+dPKf//nHk//4z/8c6T//+Mch788n7713ZaxvIUJ2+FGFMjr4ZxPI5OebVfJSnx0Vfhn16P1/Dvrad8Xunnx6RE5SpH3FzytkPdTLZDkl2ynb20LARmOl3FhN2SNPvNvk3ujAq/0a78UvYLaAn2yy4VshHrm52oLERpz0W3Jt9EgtbBLfLHYC/ls4LMGm4VR8yKmyLhpE9zo8tcW/p556Yhg3Hh+O/dpswX5a4TuItNFFob921pD6U22Z+Of61X+MVUh/Sll80AfdECD9Wl7GnGrXlK414D8L3xYedeILP3POx/i65KfzoPq5hj11g7PEIXrw1XbMHGduc54xJ77yK/6a79o8dPjT/SlXt/qSY3L2oJezBamfNuuhXD5b0r4ZC6H2acfKp9q6+q8s7V77+BJix5SNSzgLT/WZr+nHtb0dy1PG5/Ch2t7StHd/TU+BzjV7K+8W39J2Ps9gSg+PFLGv/WGea+MPdnz75tQXfPHP8bvvvTv698xwQ29jJv6Sk3p8RG78+UxeykDd2zadUmwhD5mX8i2u5PU8lfBGdmiqTuoF5Mpj31w769coMmIP4l/6da7pvn099YbPOtjnH0C5ejYL/dBLdmTGzpC86sMSqgyQ0jM+bT4cP/H4E6MN2if9cYr4AWISvbGh2pK6jsVOHDMOsEM5xB5w3MtLXp8/RerQwTbIWEKfY2nsiDwY12pDs/hMh09xiEvsS7upn+s6/QFqTGKn+jdvtT/iRIe+knJQDl7RZQu75CWNvFwbdCgLf4U8OtiU+nsRf7wua3M6ZOPTdb8k171H4njEEUd8PzGMAW2H3SCCMuj1yIBlEvd0SOixx9x4PjYMiG3TptLUwAfy6fRUlw2fbwMM6Hxvr5K1RZABNIsG9PDDbgzaJKTcQst3oGwuzPlKlliQL14WDRZDGfiVJUU3hsnHa5AetfVr2c9/9vPxNcmefvqTn4y/svnGhIWKiWYu5pmE2MAfmxg+xG6Cit7YYOHjSa1xgTFAvsktk19F5CL1UCbaTE4tv9WpyHlkk9VDXptYvx4WAja7Gol9m1znN6qIyyQ/xfu3BL8sbLKgqdAGW5DYZNFnw6/FsMXRE3T6bJXP/8+8UjHwLEH52EcGEq+AKNReF0SnBWdAkxU5xpaDzEb6a7tpyPWV/h3qMZX3bYR2am11fpvPIyfXvWtVX0QZlyJP3+oJ0v9y7U7ReUE2O84aI3x8RBmT4mfGq8imC9jNR+dJQ71/Z7Erevbw0gU9j3PUt6NxF/VljiG+oTY+Hp5ICi35HbookLUnHpA4Vv8q1TikvemI3fE/vvf+17avvsb3mjeH2HhRWGrvqfyl9s7mRnyJr6Hq5xRVbG278MWuJZDpdcHh4LZOfCE36Ta41PHUlfqxHcLjlSxPwzj2zS5rMMdATvoFyM/Nf9ZpqZv4VsKbY8h55KWskjqh1OtlpzztmBSZ0+s5Cl/A5sQibZ62hqq3143U87S3smyGpy6asz82Dzm38yqFv0fNi2x91FNc44baqf56TU5Rrlt1xYUtsQtVO1LfubrKITFKPZCiKgPlvM9PXsh51UEv/RAdOVcnbdra4cbJ10NZu1dqP2biiR7nzebmMwLyxAJSF7ln8Ue0rKlbWx36Laq+osQj+VNU5Tuv9SNHWcXB7gPCW+HpLOQ+kb2hyKw8/PUDvj9UYAPcH01IXI844ojvJx74p3/6H//sRtIA6sa4ThQGEpstPlptwjeAPvhgWzi2P8U/PdhsAZ42AOLd97rNRYIdJnIDp9TNdlsYfTRu+EAWFn4ZMC5//sXnY/nHw0D6zOVnTi4/c3n8xdHTQ/Grva74+clTT7ePqMurvyz0g7xyMXzv9PsSFm4+OP/88y+cXBofxX163NR6Gg3HHqO3aeH1v2cG/a39muw6sJMpHzn+4ssvRvlinjZWxhL+ekLMotDC4rnnnxt11YmuTSIfn3w99BO/iqoXX3oaqt/22SYM+Xld0ffIWn5boKjvVUqvVPqVxqSWiXqqb+Bt/ad9P8Lrih5fFh+84fu2TnL8dT3VWKWt9lwLeId/R1l8tXgB5+JBZvDpp7fG1xRd40sgs8WubSSmjcQ6aGItZHK8jNSr9dlWzyvk8UE8Wr1Wqfk7DdcoO+fqkKVsScb9AF9y3a21xRqWYiOfjlB0hsdxf33U+OS45gHenm8J6tO9p19DbKy6K6ofSauPtU6P6pNUHbz8YueczorU31I3mLJlCamvb8cXenvqfa8EubFiqzR+5lh+KDyw1zf6yduD6JvSFZlJ42f1teYnD6pP8VEZyjqnllXqsTa2zIE9czKnEH9yXNu2Uu9vCPp2zfFUe4c/+WuoOoOtvNXWuXFPmXrgRtVT7dY9r7zy8m2d/LC+eve998Y1m/LrN26cXL50adzIsj4Ftno1y5Ppz1y+fPLKy6+Mddk6/gXFYR2jXdUjWz659HpVS9163dkYVGYNpG7ltWbygyPI54P4Wiv5xISNii+GtQ1/yMiPk1WGmKj7wSALnw03T/6bB/PjKqqgI3b5zMVHH304rl9tEg2VR9lpn+gJX56Gs5b95JNBnye4T/vIH/7wHyc/HNbmXg30OhhecZ+KW2Rmbdhi0drOWlldlLpig/CHat9wLA7eWvAU17gOPW03YPsUYgd+da032TDGc4g3//DaOKMTqm72i8WtWzfHNWrkQWSy66PBx6y3kfgn37n1qDi0GFwf7dBP6co1yI74qtzGzIcf+kuSfmC+OfSXYWwa6r3xpz+NbSIGzz373FD/EG98rS9pQ33mkzHv8INhqxc91t5i8e5wPajXrpOh3w3yHx/8vW374Is+lBiEX6pf0fP++8N9wqBXzPjEN20cqCtPfX2djezyuZOPBhus18XMX67Xv9XFk9gE6Tt4A+W+06f/8kPajj8f7dceKP3liCOO+P7igf/5P/+//2xzq33ryGRo4dMGtfYNrfaKm40ug43B6CJhs4V8E7xBrsI5O+4Vmo8PjYO5Y09xGUD9emIAt3D6+uv2XSn2ed3NIHp9mLhMKmLh3XUThAFV/MgRJ4slAy358r4c+A3oPZkETGYmTTL81ZrPhsWQp+p8t6ou2MQjMfGhdRsQ9HgPffwY/emGUx3cwxN6cLDnmsllmBAy4fLNZGHSsSAk//nnnh03oviiTvhNahZE/lxzHp+e8gvZCGsTWPtF1FNE47ezHn9s3Lwzl0W2cptcX37x5cmLL750Ox6hHmwUEzS3yYWP3G8j2CW20GJ78Ifte4BH23/5pY299utke62v/aoHYqFftz8Jvi0mqrVxod0MshPSF5zmeElkrVdpCS0+hz4fmuoLAX9j6xTEBbb6f6/Aj/TfJXvXEDnSnFdKWY7jPyQ/10mILaEp4GH3Ujv0iP4luXOgKzzVn8iEHFeqiN41P+mClK8hcdhSN6h2h6/3qR5PEb0o55EB1ceUOc6iH/V+TyE27PEttu0Zv6qv9Tx5od5nlDpSiF/xM8SeXGeRlX6/FZkH98QD6ILK1/tYj6eo9z0yqr/Jc2xNUa/r1JtCZFY5S1A39lZsaXM88UP9KquSfBg3VK59Mn5nyzpLGdiseOvtt8YNDH/Y59Fh7WNzwl/C9uOgNWvwf/7Pv499H3/7S3Ht+59v/PGN8abfj3jZsJD/pz//Zaj/+clPfvzj8amvtJ/123vjxtq74wfurY097RUfbAq9//7VUbcfIJu8b07+eKrHeunmzWFdOawbnbvpNx//4HStzUabCzYgyFGPf/J/ONjgDxTRw8a0pWNrH/L8Ne/3h/WTTRIbK+NH+Af91mjxIbHHbx3w3uDLO++8O66d6B43CIa1p3sAmyuPPfrYGDebfXTrV1Nx02+sHX0jlu2jvMGOTwb729M0fx3XI9Yo6qPYkjRtK0XkvPnWW+PmpM0dsa5IvZ7IEhexFQ8/2l69Ki5t46ZtrrYn1FzT6gf88tcx/eV03yEjDyLbRspf3nxz/F6ZV1/98Sf81sR/+cubJx9c/WDczPT9XLLGH8K1x/Vr49qE/5GJD2nfd955Z5T53pXBzo8+Prkx9BP54H5AjF588YXxx2z82o9ccb4y8Ej1J3l89NquP+SUeMf+Pw+y1PUEpDYj13eDId/odc2xhw/+UmXaB9wjiKl7jitX3hs39dwjsVWP1B/qmhavjVqfV8GnXdjpG2NjHxl8FTvyvY4q5Vv6N/gh35rWj7dSMvRDG4H6qx/F2yZXe7U6490RRxxxBDzwP/7H//znDIIZmAzIJvEMWPcDnhgzNmWQy02/gbpO7BcFvtrcyq8V9ADf+e0vmXilz4T3yccfDYP/h+MEYOHhr+j4Zc274Tai2GYDbLB+5EUffPjBuGDw5JQJ1wQ0RSaBwYCTS5cuDYP2Z8Ni5coom1wLCeC/CcAAnoWoX6MeGWz+4IMPsY8LkSzuUqeCj+NkMvjLVxOWBYjFCRl+bWGnvyZkYWNSJS860z9MLDeGmJhY+DzlU+jTW5+NduUVUJOQ+D3+2OPjhD1YNcTusMll0tTMNthsWHmSqPpcwRf9A/HFpOev69jwM9mKGb6L7jcXibTr4ZrL04J32pzYz8EmIn6Lc7zkaLvKYzEhRtrgLBDL8LKX3RWxcY72QghcR/VXSTTVFwL1l8aK2Py37hP8SLsv2Vv9XqLIqmlAtpjRk2siMVRP3l4kzlsRO+dQfakEdIFz9lYfaz1+xkfHIb5KtyC6wrsGNmyVHVsr4Y1P8SvEFpTz8AA+frphi8+uzZynjSNX/bT5VtBF7x6+6GNDRWzvKfUd0+U4vsfv5KOK+BffUWIR//ld2yc6yUz5VvT61xAf6QK6yKh+K4uvtb1TD0H8iX9IW9f2htgobyuib2sfiW3RFVSdsb2n8NJJX45DzsMPH51uEths8kSRfHrGjaCrH5w8OqwrfvzjH4+vLMqzweXVpmyIWM/8v//yLyeXLl86+dFrPxqfSCLa2uW3v/3t+LTMiy+9dLu+m3XfPdUOP/npT8d1xGDoWN9TYzbMButOXnzhxTs+7cGXf/3Xfx3kfXXy3LPPjus2tpL37//+2zG1zhpfhXygfQfJj5RvvvnmyYcffnziDwnZBLDh5GZ9/Hbqgw+N6yGbAf7CoU0Aa7f0W/L59/Y775z87vd/GOd+cTLvuxY81XXt2idjnrhA4m9N63ur//Kv/zb+EEmu9ZYfGNlpQ27cyHnmmfFj5+KDzzqLP+L20hA3srWHNZ04axPrkMfZMazxhsiMT+346L8/vmSNqzx9J32ODMeQMhsybKHfWjFrW3bcSYexIXk2Ud54441xQ8oa3EafmFv/iKd28M1gfQXYIGZvD3baxGTjj3702m2bgFxrKN/HtfHiDww8MtyzyLdx86c//3ls5w8H+TZEHxrW8A8P91DW/zaFbHj5yLu1t+9dAb9tAP3v/+f/HXltZGp7m1Q2Of0FS76Is7cbrKXZpB3+7//7/zfGe8gY2883ux4e+K8O+vkxdNPb/SG6rl2/Pn4KRTvL11e1i76lbcTRpuDb77w9br76C/DpM9qCj/oNGf54Ff9tOOtrNs7YkZhmXOGHDVObaeqxY1zrPuhH2SE2w3WlTca/jjn4wL/aL1z/4t7o1th27kFqnzniiCOOmMP4uuLp8d8cFhcmozZ2+YbC08Ng+eA4AVz0gGZAzSIlcENNjafWLIz8kuHx93FDaahrc8Yj8X7lefXVV8fXCC00LYIyeBvox0l3mBhsuJiYnhwm1Fka6piM8Jk8H3rwgfEvqFy69PQoL4O9icYxOKZDuckEP/Ix0EwQFeqjHKtrUnlySG2oPTwsFsWDX771ZXGjLciJvEx2yERtITfpTyG+j/E7XcCS0XifGv3VxuSnzC+W/CbbOb2hHmP9YXE7LpCHYxMuXeTKE7PY/20GG9maGzVxT2rhKV6J31Qc5HvlN3zq2jC20RXga4vsT09zzgYx16bSe412HR42uWAuBoH6S4uf+2H3FvCjtdvyUy/qtH5+981/yvgaf7U/ebXvL/V//EvxnAK9ifNe4J2yZ8rP1vbtPH6wNf7Fxyk/p2KzBXTGxi1xUXfOpwp1oPpX/cw5UgdiQ3x1LtXG5pzq95z+xAFSfyvCuyUOQeLR80RW9b/3PeXqQvzic93QqRs7+CDx2QLy6dzDA/j21I+vvc/m7Pic8shmU3xDjnNNJ0+9KTsS48jaamt4ED1bELsr8EZn5MXHqTZOH0a1TclQDjZ5zFvWJn5483QOr6/WAAD/9ElEQVSKtdYf//jH8ab3ueeeHze58NnQ8IS4m3XrG09+2ES6+v77Jz/+yY/H9Y5NBPLdKNvkenJYL7w2rOPamtMrUJ+e/O53vxvXH57k0lbybFL8+//595MHBj9+9ctfjrbUtaNNjX/5l38Z5b3yyiujDYD333/7u/HHUk8kseNXv/rVyY9ff318/ezzId9T9Z5a8mOfzz/8+te/OvnZT386biJZm5HhySzzIL3sFEPxyl/JE5//+l/+6/itVvovD+s35eR+PcTBZy8An/7EH5tyNjp+8w//MNj0y/H7r+0v9/113MjwF9C9Iurpt2yUeNXst/9+GrfXXhvXWtpK/G1UvP6j109++ctfjPb7i4ftSaAHx7cDPFWmDcSUDX2/JgelX/nDRzZzxEl76kNDzxr8b2uDkK6ibwF+G3R884P0s8+I569P/uE3vxnjYrPPRs+N6zcGeZ6OevG2DXTZZBTrZ5+5PMZafu2PnlrS96zZfzT4r33w892mnLYSF/7//Gc/a/cIQ18gR8yt5/yVSnHziqCny/7X//pfJ48O5z//+c9b3/jx0DeGOPH3d7///bh5qQ283WBDiiywKeqH6F/+Yoj3z4Z4j39d0g/Tj4wbY+JrPWxjF8TV2s2mkWvIZ1b0tdbu7Qkx16G28kSaPD7ik//b3/1+fMpNDH/9m1+f/HqwtfX1p8cf/W1ygTw82iSxsTmW2PxyuH5+8uOfDPF9abwPsOFmQ9X1pP/xm33ksZUMbXDEEUcccRbctcllQNlDmQAuEgY6T5KRjRybdOm7CBj8Tba97REvPxOcp6VMDu0vRw4LqGGQz6O1jSzm2NsWsfLwm8g8Zt82epbJIgKPideCBZFV45yJI+Rc/uOP+6tzT95+dDpEXqieO46P9NJvU8sibJQz+Ju6qS9WkaHc4/gmKItBZDOynR+I73lsH9gqTj6g2fy988aLT8r4bjFrsdVenz3UqYhtSKzwkSuGngDLa3bfJfDFZJ9XSf0lRBufYsDf9sh//ghC+4tK0ryCYWGvrdRTP/AdLr+CWazsRWyy0JRWufcSmrxdT3f2xSzypqAPzfUXwA9z5fcL8YW9bKnnfM71nVirg7RxiJ/VVzzytyIxhT3xwLNXF8S/6mdr33k/+adcv03ZVuCDvTxswbPUz4IaQwg//5BrMTTVrmk/vuZGX5rjlFcf9vhDz16fAnzsZccayI+uEH973+M/xC828Ve+m5v4Xv1P/Qr6Ik/dvnwO+NgT/Xv4UFD9JS/U+1z56Iq/bM7N/lR7k4tva5vhSTzwbOWLfYnjGlIXBfEv+iOTTWSGYpN6zuNrj8iwCeA1Ok+3vPzSSyOfG21Pnnty5eVX2qt0g5STPw830updGtYxNhJ8LuHf/s+/jW1hY8oPevExT6U8/9zzJy+8+MI4h2oHGyBvvPGn8UktT854SuU///jGuFnmKZl/+Id/GDd+zK+1fc2vf/iP/xg3I54byOcryLNJZ8PIGukf/uE346uV7AE/zFmreEVNDGwA/PSnPx1/RAVyrWd8JNxH4Om3aZLYenIN2XizuWWDQz7QQebNGzfGp8RePd2sQDaqPFllkxCfb4+pr8yPu/SIMdhAfPa558Y1sLhpD0/l8POl040+OsXPGtKmVnSDGJm/3377nfH4hSGu7an+O69nMhJPoOtf/+3/jE+q+TSG1yBtIr3xpzfuIK/MWSNZb8Y/rzh6VdBfcP/JT34y2PrcqR3tLYZPb306bmgNFoybbmlDfeLqB1fHzTgbXDYcXZeAl02e2PJaIv9febn1Rz/Aj69FXrkybgz9t//2/xnbW2zwqUO/zUg//IqTtap28MSVzTibjK+9+sqQn8+meKLr8ZM/D7EeojP2c58OSWzJ9CShjVCy2J9ryxpav1BPHTY5TrzFUcz4bqMJUiYuNuPEXV8lnz3aTxvQ70fwPFUJ+qg46U9fff3VWKY/4LOx5RMk2sMDAWLjvkAZGv0ZZHglU75NR3muHRvRW8ewI4444og5HFYqpzB4ZQBbw9Z6e0GuQTBw7PFim11nRWRaFJnMe9sN9AbV9v736cLzKxsN7btaNhJGOp2M8avfBuI2SZBhMkSQwXyJggzokR1Z8unv87M4prtvBXKbzcOiZdwEOSy8o5c8VMucB/SEYgdy3tsulImnOuqrl2MxtFnD5vYh86/H45bX3rd33l5PzKL4sPCfQuxqcWh8SEza+eEG6bsEJrM7xI8WH08MfjEuRPjNT4sI5Akt+ep7qqu2Df7bH6LdCPw2tVwrUguZvs3vJ9KO/TW7F5HzbUKuaZR2Hcee8Ro49OOkU3RW4NWme+PKlikesowhxpKMKyH142v81CfX/HS+F/ii7yJBXq4DPoaMsW5MpBlv+/E6/hoL+3PH/KxxmCLYcw1GVuzeg6oTIqO2b/wOOU+5uvjjFx/5GuJ7SJ1Q9PY0BfX3tnF0rPEprz5P+Z32jr9AdvU37VxJ+VpbR/9ehHcr1A8qX/TH/1zH1dcKvvA1vk355xzBlIwgPpjLbAaF11z35ltvj9+b8qOcJ3WU+cQCG31iwvdN3cR71dHrab7n5Mc7dqvLLhsM6rux9uoYXZ6sGV8nHPTZNLGh8R9/+I+TK8PNvSd2PGXz6rjB1TZ2qj9e1yPvqSefGn9slKedbw76yXvuuWaD+IWPDDbRzw6bDjYC4j/gVQ+kORbnqx98OG7ksdWnLehPHXzWqfqmNawPlwO9nmLyCqEfbD1R5gdbduBX3zleG0J+pOQPmeJ288b107i1v2ZZ21n92BAk3mLBpvyV5PgH8ukNL1nWMjZN6BEXm0aOe3pksFXbJE7WSe+8/c7YD2zwIGX0Q3z0yuhXX7f+ig95Bc+5tU42YrSXFJR9NvQ/df1IHp2u8U8/ax/XtzFqvcSmwfvRF74qU5deqTx9w6uBfPNaYOJHrvIxJgPfaM9w7yPFC+rgUyfypMirpPFXPZTY+hEhT/Mn5myMnZ449Aohvz2th5ffNrj0tfYWS/uDUepHb8YGcrS3PNCOPsHimnlxiA0flVXexGa0ceBx3H7g3vcj2hFHHHHEFPatfP+GMAj6FciA6XgYDlvBDAyWBmODuQkiZFCdg4HXAGuybBO4ifCwAA9lYkcZsAPHjXcfAXkmlVDkZ5JSL2WV17mJLTzJi43JQ47V7Slylec4FHlIefyNTGRh6QmkRj4GeSBl9QYHtc2tg+w767CpldXYViTOjbfKPt2gHMq+a+CTTcApxN/EpG8nfVUf8Y2KCnF0Hbhu9H+pX5D1KfmNp10rro3UsWhxnkXI3xP+1v60dm79Osfas6eUpe5Fg9w9sUhfQekvSF/KGAXxJ2mollWSF+oRvr3Y41cQ/XxDfOJfFvG5JpKmHsR+9tbr8nB9HsbKrb5XpHyPX1XuFr60a8h59d8xSnunTvTU8WkqBvxd8n+Pb4AH8O3h7fn4EZ9q+1a/q78Qm/kT/3KcOMTf6Ov9vWjslVlj5jj+o9oHILan3aaQ8vi3ZE/VPQdzmW8DRZanbXy83UaMH2BsJpATW33LyNrNk082qeT5BAN/mjybADbLPhvzbEhoX/V8m8pTPvKthzyx44kYT0KZE30XSnzS1oiv0us3vP7mafLHbutSZtPMhpHXsGwWVbDFekXKjvEJ9sGO+Co/fcmxdWwwblbcvHl7veMv5tmIsGkS8g0o9Qbm2/Eh7+atm+MazUaOjaLar4f/B91Dnx1s57OnxuXzxTrCBgn/bFZ42j62spGv48fTB92eBvLqnyeAvDIpnv4KNz0VZJOX/MTTZqbUZpJvqXnCzVNZPXmdzpNK4deu/lCB72F5mo/s2JiYDke3j1FgQ0bfeeTRR8bNM7aITeLDf3GzdvJUYHi1wVeDf+5NPKWlPuAPqSPf01k2rsZ2GPoxP9mp7Wu/QUNLjKm1WFuzHcZdsAnoCSmvF4p3SD/wGqzNU5//iK/46PPjsetGjCrU+XzwT1t6rdfTiKBdrw/XE/1tA+/w19SDnA8RvaONs2lGnk1pOsLnmH/6RotN2+RraL4fccQRR5wXd846pzAAoTVsqXOR8CRXbsLbhtfhFyBkAkq+wVg99Q2g4VtDBuw22bSNEgN/pVbWKIM2HPgOm0pLFP7wycvCZkp25QslrxIZdePKcc7JyfkU4Z+Ti2JXtWeqzGZh6JBnEfP1oOewSIyuZmfb7GJHysPb6DQYp5BXeSNXnrLvIrbanXotLo0sMLweUCGW9TpwbPHq+sg1crhWPCaf10nv77Xdg/rehDWb1mK3Vv63QtrvrAj/njYLT12UQsZSpMz4Gko+KKv1kk9mvaalSF7K96LqPS8iC7Xr5eBjdMizqA8pk6Y+xM/Eka+hjF/xX73UDS/s8Sk8Z0F8jd85R/GtJ/nK+/MgbRyq/iuL7/E/cZqDsr3xiLz41qP6i+Jvyqq/U9T7S1/8jq+ZN3M+5XP070H1byuqviC6EX8Sg7RnrSuv1g/IrD7Ht4qeZw5TNs7BXMZGTyPZYHBDj9dmgg2QyGifjNCu7S84+9i17xLZxPEKVNoSearJBoE1Yt3ksXbwmpaNAbw2yTzdNXg2vsI2KL6j7aWJiye5zKHZNAN1yDOv+o4RHX3MPGnm6R52+EuG/KmxsUngG1PePPA92IBcfU7dLz7/fNxcygYH8jHvjz/5mOnjfG6DiZ95QmpoqdHWMR6DT2lPMWg/TH4+bkzku558pA9v/CQPjyeg6PbK2ZtvvjX+ZT7tNKbvvD3Esr2OaTPHpqVjoDvXGdCBrP+8/ikGnjbz5JBX4KbI63SeaAquX782fqzdJzyyhqGPLsf89CF6a1Cbj2mr0Y/BN+t9fCjtm/6hPb2+6mPy2ivtKVZI+3nSiR68ialj7UyXjUV61Rc3ZTZrY5/6IfFWz+bog0M7RJ98m69eG/UdOq88to2uRlfeuzLaqt/54wWxBT87hkvk9hqPPKAbfFsrG33aWLm+7btZXgX2Af/YCeHzTTo6+ZiYwqeDj2NfGnRpp/AFNlPHjWCxeeLw7d41qIP41L5H2+YwfdOG4RrhO+KII74fmLza+8Ho2wE2tQnLAN4GrLaoMDga5GyCyWvUvtGk7Hy4N7GoAzXKwqlH7DdRbUUmCjyZbENrOGvbm2wsivxK9Mgjd5K8Ru3VDm0m9Y0u/h1ILCwqGt1Z1srj2xSYXn3t6bsAT2SZtJf8BO60DcT4PX2zp19V38WxbWi1TS+Ua+U8rwN/l7AW24sAHVsWUxdlizaeav8pqNNTxqFQf+0lH4xT9EktulHGr4w3U9gzhgVksW8P1I8NvU9JjT8Zi5CxKeX4HUvZXP1sT0+0G0FpykNbfKy27QF71mKROii+BHxC8bmnNia3GEDaMn4nje+JSd/2azZOIXx7eBPr8LA7FD+ktZ2R+ilzLpXHBjKrvzlGyvgaf1Hacg5r5XMI31w85Ific39e83PM15D8ivhe23SqTydOFWRvBd7YtYTUYYtNJ08Jma+8hiYF5WlHryp6FdGrfDYtvCaY74LGX7J8q2r8oWeYB5XJ8xcMPZH19Vdtk2X8ZtFLL43z4o2bN8aNs+gLgfna5wBsmtX1phiOm0JDfn9jHV7fG7O89CkOc3KFOjZVyBk3yp566rZeT1SJoU0TT4kpa09mndIT7fVHHyPng42V8Nnosk6zqcDvtHWIzfKqzdpbXtu080pje+rGBsWbf3nz5Le/++24MejpIB//jx2+DzV4MraNv8aXTbO0x9hmg2x608+kntizueP1T9du8ucofZF9nvxju/YFuugBPogpfdpKXMXFuaf4tKU/YCReZMpn31jn6/aEWe49ApuvNiL1JRtDePAifOzTzvhs9JlnvG5rDOVbXgsMD1jX+YYqe9mZpwCNQTYU/+3//Pv4HTCyPXGVeGdj6kHtMOTTBerJ95SbjU/25/qRn/SzT9unMPIjKHtcE8Mqc7Tj0UfaHyAIT/wTAz7xEZ98vOMmrfxHW8zwVV4bztc+uTbysT/XjnjIm6fD2zlt/dr89+puXlNdovSHI4444u8fd61MMhBlMPq2wyDXJvn23vp3BZnowWQ2FW8TgXpg0rhfbbKmh11oL7C0X10scGyItU2xugn26KMHMpn1ZGFgA+wHP0BZKMeWOzd9enwX+rR27l857NH70X7xzo35gVc1i5DvCxKXub55P9u/Xt9zuEh7tsrKtcu21l/aqzAWfq6txE4/NC7lBt9xbkbO2qfIhLn2mcJZeAJtwCfEP35aJFd/M77GL/riuxvC3ndlNdaO72e/WkJilL5X/Us7I/nKq+/846ubr7qJlbLEZ4uve9uKTHE9Cx/gS3/WrnNtrRyqD/TyNW2Nqr+1vbf4PgX27fUN6Jvii7zaznxMm6LEIeeQfj3l55yurYhNa6BnS1u3WA8+DvPZF1+2j3vbZPAdrv7HzUPb/mDcpFHPuvDll1683WZ8TDuj8QmZgYctyvR5vJ5kevaZ9pfnfvazn43rSq/BXf3gg1EOxPYWzy9Obt26OT7hk3jLp8uTMTW/h02ZQdiw1rnzryEHnoTxetlj4yZBe9KLn9oNnyfa2PibX//65De/+c34lwR9O4zt/vqdPB81TxvbyMPrySAbD4kNkK1viB0decoN1Evsmj9tnhg3Hq+8N9bxWqG/YsgWuv0VPX9h0TfVXIM2eMQgPogJpA+KGXiayqbhyHP6xBik3/RUfRhtH9aGiSd9+gaddChHePgf2WOfGNofxAbUSdzG2NnMGmJg0zIy2a7f5BVA8tStNnkaUDsr1yfV8WSUJ85spuW1wMojBvqiumKQbwiz809/+tNoh7+KqK3Hdj+Nt7+y6MlAT3DZbKST3PgybgIOcjwVqB0rlHs1l+6HhxjQjc/m33Bln46ld28OjfPkEFOx8Jon+ckXa3IzBvfw1Jg6yv2FSU9RjvYNfcUTfHM0/oGH554dN6y8rtr+0NV36/7viCOOuD8YZ16D2dSkcf9B9xzdf7S43DvdJoBxwbKATBpb20ad8ExhqSxQZ64e+bFji6yLRnsl9aFhQkM2w7xihx4dF4JPPHEg55XUsUBpT4rduUGWtg7FzwON1e4pmg1fF9vuROuLLb9tarmBOdRrT7q1Y7LW+tZ3DX+L/nbR4MNc+54H2ptckFqk6usWkOMiclgAZrGpXP2MPxbN2dhwLt94s4To2gt+7/V9Kl6JIz/5lF953UggefxH6qjPr9zku2HITY9jecrW/O4hjrDHp+jYGwe60s7xW5tWv1E2d+J3ePmnned8T7tHT3Ttxd4YAl1snYqJvPTntHV+xYfEAqWv8IVfta09eRJ/z2IjnjkbLxqJR3zONZw2djzVzmxErmNtrV3Xrum09Va/Uv+sCO9ULJ2nf5vr3bTbeHr7nXfGHzN/9PqPTp46/Wt66sYWdaU+rO6VxUuXnh6f5OJ79Gn38QPjQyxsHkT3mH/z1vgkmL9y+H/9X/9tfL3KX+azUeam++rVD8bvXJEVu8m2GeEVO/IC5zdvtVe/3HzHzgo6vV5no81fL8w4lf7t2MfJybCp5696x95vfLeTz+OT8O0bYunXta2RY7qRY08rWf/QE0Suby+99fZbo26vCrIJyPctr8RN7F1PNv48Hebj/uMGy5DfdDSd4wbPEB/fUAtfa9f2rSxyETtjgz47Pvk0rOs8nRM7+/hNwdNWatkYFRd6yKUDvycBvxxiZFPEBqE8dTxxJG6O67fT0m6fXLs2vv7pu21PDG0RW8VbHCi1ccQP9WOrc9/H0s6egnKt4h1jxOchHnSqB8oQe/z1yNYOT49rXLpsKnpizvet/MVQf6iArsQb7/hk1KDHpmJiJ59/H3/08Rgb/VkfSxk941N+n3429o26WSSmvnXnx9Ncc5C2dE3oG9rqpRdfGMv44zobYzOAPn6qzybEXpuuePnn9VjfeTviiCOOuEj8MAPzXmSwWwa5e+j7gy1xF2OTCWxpo9RZaps1OWfpCz3oN5GZ2DK58SOT5La+cy/QvtuWJ8g8GXbYKLNJdiDnd1JbeMaX5kNIey5tkDXaAvyJT+MTz7agYBd7U17j2J7mOixC8Now+y6gxqjZ3fxGFcqWoLzG5LwgK5T+G9Ie6d8oizcLWZR+b8E4dXOqbmSfBb0dud6k8skVD4tbi/zc8CKLYuPPWcd+OAtf2merz+rFFynfssGROCbWkcun6rObP9Tf8LOl96HmbbVxb/0g9k5Bfm1bPqbPJAa1j6nf+x1yc8RfYGvaPHavYa9fQPZZ+PicPsy/XDdS5/LT1r0v/O7beryZnGjrepxYb0H49voW/T1fdFeftS2f097pA+qRMdW/+7Ym9yw27okDqsC7VWd44zdfa1vLI8+THfzxXSCbSS88//y4mWAzKj6LA3lkffTxR+PrVY888uhQ94XbMQO22XxqHw9/8Pa3kCCx8+2qF4cbdfoBz9OXLo2bCp4uevOtN8f4J77aweaANqryvvhisG1oF08TZUMO8KQt26uIX41PBtEXmbGZTTYK6PMaoLL06Tz9Y1MKhS8ybC545U995zXenqziq3jiCR//3nrrrXEjSJ4fBaXAzxo39UdbvtLXTk4eGNZU0R15Nmp8K4wd/NO3kXL2kIkgvHxjO9v0idHeIbahNdhIItPGiTagR/zgo48/HjfwnGtPG0QZG+geDsZzBOxEzt99p33vSn9MOyNPf9kEGr9h9WTb5EysyWQLf7Szvj3qGeDHSO2gfHyab0BioP5bb741frSfDhuc4sAO/Zf9njaL3cqQ9vA9Nn+EAF+uocRAOXttGmsv6+Dwiq2nEW2ejhtOg634kJh6rdAfOmAbmeHRZ3x3zRhk09CmMl3IDwpS7ZjvyaUdyWhPcbWP/Y+xGfKOOOKIIy4au0cW43QbkJ0Z0Jfou4/m5zIyQe1BJpE5mAgQLNXrsafuWVDlr/lcfYw/yERnojQRV8qkW0ndJaizNfaqpa3OQhatjSza7qT6SmW7WbmT8GSCj7zBmlNqsWqbZH5ptVhsG4WeWoveastBRkMfB/KyiLzfSLvHJ36wbTgdEdvTF8TPzQ2qMatPqe1BZNf+1lP6F9tCWYi39msbCaG+TuVDkRud8fEQh8Mv68ix/CXE9t5Wx9EDkZnj6InO2NATKI+9e4AP9vCFpyJtFT/518c95QjYHp/1cQv4SvLQFv97pGyrX5GzJw7qhpb8DqWd6YpP8dsNa/U5ftf2R3SRE//uJcjv+1T0py2rz7nW0sbp3/E37Ryf469UGaRu/OupYipvC8JT/VqCeqnLnymfkfz4DPG579+JQShtG7+TQmRtQY3FFj71K08QfxE5acvqN3IMqaN+7I/fY7sOKqiRj8dH5G0QpG5scEyOzQSwEeGGO/WADjG0eUSWb3XFVt9UQvKfHngBL/JEzDPPPjP64EmavNaGTxvYiBrlPdmeVALXZPR4kiv+o/hr08D8ZsPKX9yLvvjeNkf85bm2YaEXxR8ybaz4kLgPvH/wwQdj/XEj7s03T37/h/84+Y//+ONYFh/xjrEf5lq6fbDcd8Y8aWVzxJNyn3xybZTPJv0TH7QP0rePoD/5ZNvkiixPhtnI8pf+1LHh8eEQp2bXh+OGpE2M2s7ixkfHFfI8tccGPOA4/QRNgRzkO2Q2b2yuvf3Ou2Ncrg0xcf773/9+tE3f8IobWWTTGX89ySQW6tukwf8f//nH8UP+XjHkc74dhbSz1w7x5ptTkJjzc9xYGtq5PdHX+ofvd4mdeNnM0g42Z8VwPB/iN9r1OLvaj5qJub4k3my0QcbOjz/+ePz4vDbkk3WUJ9kqWEaGjSV+0YWXH/Jv3PRq7MD7yKO3N1FB37f56+k6fzGTrfralfffP/ndENOPPv5kfErvuTH2bTNOHNRhi9j4kViesrS9tlBH/x43DgcbjjjiiCMuGg/89//+T//sYOsYk3oGxu8LLDICfpt068SLnF9UTMgyYSAyMxlvQezD00MZW5dkhT8Lhx6RIc2E1qPaUOVM1a3oy6ucKcSWuXKIjCVEzpJ9kSMd/j89D7X+0BaxrU7yDkSHPnPYoGjnjfKhffkWM1B5yQzaYunOhX5bALkhbvXkZ8F4VjQ/WlvfLafZxGYLMQuk+C2vknL1H3igxaD52urFb7FLf6+8hxi0+tDnzdVPeZ8Xir31PHlzqH1ETELyUc6BrHoz6nrJsbrR6Th6Y29smUJ09YSPPsd7EH/38MW+LTzxTVr9S5v1bRTZFfQkdlOkvNJZUW3dM+YidgTJq37N+Zvz8ED86P1LWfpV8mt5j+gAfFsR+6tfS4jt8Sv81ed6nDrhk9ZrZI6qv3jIW/J/ChlrIHLXoH5sTv2aF/+S9r6G1EXA5uhH9bwfLyrNIXbAnv6Lh61rPLE9vvVIWeTlOH4HzuPrVJuDG3IbS54K8h2e3/z6V+M8lzqRR5Ybdzf7Nkdee/XVcUMM6GCDup5yuTrcnHtq5Kc/+cl4Ay6fDjf9ntSRn/l3tH0gMmwseKVx/P7PcFOv/4ybTO++O9rvu0iRZyPAJgC7fvbTn475AVmeXrHJxF4fh/dkUdaYZMUmmyuerOGLTZLERV1PUdkkuDXYZHPr448/GTeVvD42bl482F45tGlHJ5n88ZqcVzptztnsYoPX8Ww62LCh3wbhj3/8+qgLn82UPMn085/9bJzPyWpP43gNuL0K7FU5T9ORicf3nLyy6PtR2k88yE97B3QgG0K+vfbRRx+f/OQnP7791woh/YcvqIdymzs2qtjkabBr1wd7hjiKCR/F40evvTY+daT92ECWY7p9PF0b37hx/eTatevjh9r5ITbqaoMfv/767Q04G2L89bTVyy+/NG4CJtZITGxGkSlu2Vi1oSMu8sfX+gayWeSVyFuftu+w2QDz/Sl9WayBbN95w4dHm/MPnz7Adzpffe3V8bty+nHsEZ+PPvpwbLNxg2kgdtjwU+eNN94Y4yY22kpMgAyveJKrncX040Gn682mqE0/7ds2oNu1Qp9NRrGzgfXK0MfJq+0uvmRYo/50aOs8IYc/7XKvwBe2HHHEEX//eOCf/umf/nkYk84Eg9m3FdsHSRPS6eEMsnhB48JnGIyloUzAiYf0rIN0ZJsUIqdfFCwBDxlT9VO2NsCrA1M+RIZ0bjJKHWUpz3El/JWSn/rk5HgKU3p6KF/yB9KOS3GJnDkZkIUqX3rE1tau5LXzUN3wygJjDtnIanFr9uijedoL2JlfzXrEhyyC2vnd1wG7yJTm/EDtWrCx5pc6enIt5Mmz9kh868vZ1HIsL8fhCbE/eUkTuymq/OrVujnvKT73lHbDWzeneoIc59rsiR7IplNPymNnfw69nVV2zQ/C3+dvgXaI3K2gKz6C49hQjyv17Znz8AMbqq+xK8fiHR/32LsVsY9tS+MBxObwQHyLDMfIcSjl4Ykv1ef42vcvwL9mW0X0w1k2uWqsY3fK+uPqY/JyjIIpn9Wt113qRPcUorPW3wI8eBGeuXimTig+QfWr+l2PUXghvvVU23mPHz3oie6tbR378NEfyKv251gaHRUpCwXxh49SOvA7ZmPyQ4D/y6/aK6gPPfDgyauvvDzeSMtPjCA6bWp44siG0ctDXRtRqZf5NE++PP7E4yevnm4e4B83ZD797HY+ebd9GdJByGij18XcjHvVzVzvFS83/TZ9fvKTn9yhx+aFJ1xsYpHFltjDZ5sTjl9++eVRZuIZv2wC+KD305eePnn+uedub+6Bum1e9nRa+y4Yv3yg3xNCNnP8VUUf565ju+NRxzDXe0rMhopNBh8h99cWrSHo8UTUCy+8cDsG48bPzRvjhoZNl8hhB5Bvs40dNorM7zacbPr4a4ViysfEIH4EY5wHaptMN4dYf3Py+o9eGzeV2I2iL7GsCL8NQT+aee2u/UGAW+PGjya8/Mzlk1defmXcwEksE2ty49NXQ1x8gN2Gjzx2izUecc2GDV5tKI7PDrLJBflsRF7x5I92ev3Hr48yYGzr09h+OfQFdtrU8n02PnsqED+Z2iLy8CEbZOLNxs/H1zL9Aa7Hx+9a+euS2ujJwW7yAC+bx+OB2mumPxg36/JtMht27NFnbHwF+fGREv123NAc+o26roNXX3vt5MWhr5CV8UaZjTAxttnGB3ANxZdsjnpd1yaZ/iKfLaF7heMm1xFHfH/wg/ffv3rm8WQYk8aBaQ9adQNdS6P8PINaY72Tf4+4OT+S59c7xwbvikyUUmVIPQOoAX+vb3hNhJGDD5lI66S8BLwmJY9S9yDTpEXenCx1TKTKpyaCyKCHnLk6ZMTmLXZPITGlY0rGFj1r/oByNBWzgB3q1HbtkcVTJvse1V40B4vNtPkU2KLMAje6LMBsJNHBPuXSTz7xzY6xyl14ZlicXb/e/mQ4tM2zdm2SQ082uciTF+RYmj7leK7OWdHHOufSegzRz9Yau1pP/PkTn3som7t+AjKm9FSQoc6anvQ7cmLnWUAXWWTslaXf6kdzvgD5FeyXV/Ukr1IP9SvF1tAUqq4lGy8CtV3ceEzZFL/iY/pDUI+DantS9RzPjUtToCt9ZivU18b0WeAvobddLNJGoHyOKpzjC2+l+N+DrpRLt0B71XF3TnaP2zdvA8R/6jqtfqUPSoPe59gc+2OL48iamxsuCuzjmzZ3IzkXx9729BH2pT/G1/je8/TndOEN/1I7uqkFce/7P7l04nUNssnrYPHLeeKorjz1xg2xoY75Ez+5ZORHSnXcWDPbfMk++a4lvJ6Q9qFvPPJD6uG1YfHQQw+Pr5HRyfZ2w/zNyeXLl0Y+eslTH58P2LMjfSGxHDcoPv/i5Kmn2l8xRNXmgz/tm6F4EifH6pLJBk/xWAuYv22S2HAgjxx1qj/Rcf10w08Lto2ch8a64konu/ABHW2zRnxa3JRFvs0c300j1xNk5NlgSV8Sg9SNDxXkxp/4TU/ykOOMy5Eb+5TpuxAZfPO00l+/+evY17Qr/1Mn9icm0YXPE3q+Z8qPek3Qn/YEerQ1m/RP9apM9fhiI8vma/SmLRxrB7FlmbbTV+XjozvXiTzAZzPQU3Oe+PJ0nTo2VOnzLTjHbKIPAXvkjX19sJs8f91RXTL1IfbTjxJffMpH2QOfzVvH+DwlmPkBr1R9efq3fuOYfZFHVmLjFWGvs9ZNNTKUoXuF9mrtF7djesQRR/z94lybXGDQGv7fDAOtb/CYVPEaHD1Ca0DMgLwXHDjveNVu8A9gWyYZv0yxjZ6kytkcZPDORKxOJsetftFFRpABP5PnFsSGqZsgNipbk5cFz9REQ4Zyevg/NxklBqGzgA5Ex5yMNT3sTZ0lW+PPHBI7MubaU39RJr5TiC3qzMkAi4yl64GtnuCiJzb7c8rkgzJ2Or1xw69uhwUuymYYf6bipiyyku5B5FW5NW/qWFzo4k8tD2LvUt+Nf0vxJSN6poBfnanrJ7hIPfy2eJyTswexa+l6mUIW8nM28AORDdKcS3tEjpQdqB7vRdU1d21dFOjQLijXYHRXO1BFfOt9zXGPKmuPT/oLWuqfPdTPmL1lkyu2Qa7LUEV87H2V6lOJ31bQBZGxFeZNPPr91lhq36xB6GJr/K5pj+pnf4zmwDcy58aDiwKb+cW/pU2u+Fd9Tfx79H6mbTJ+BYnj3DxboX/gVb9vs9gVquBb2jm+qcOHoLcz8ah5kTvVzuFPfviSP4WU8QnhZSO+8MqrFD4IH99QyiGyq+2V+IYnslI/pE78lOYYTQFPbM45RFdt48iIvL6uVBzUrzIrwlvbEFK/ykxbRmbypMZEPJFXUeXUY0h9+tMOytPHnMc2OuXX+o7li4v6VV4QnQhSB0UGAj4kvpUv5eSKQY2PssQb5NVrK+WpEx3hJdNxZCZVFt7YWaEOOSF10h5Vx1Z5kaP+vcJxk+uII74/+MGVK1fPfaUbp/rBKsiA1l5fOgxsGfxynoHQhlcGukwyS8jrWheB+MEmv54ZrCGDbmyJT/2NhnxkwggvnkzI1ZfUTX0660RT9UHqgfzUS52k6tHtxrmHMnp6W3rgJ1u9HpFPztQCNVAOvR97wF+UeExhi54lfyCx588SyElfmMKWTa60YWyRF+SYnOiZKk/KXy47ZVtQ45DyKZDTZNT6d8YwdeJzX5c/4pdroeeHLW2kDl1z17wy19zSmLClv5BB1lxbb9GjDnuX9Kz1qejRbn61nZOzB1vsmkKuD/6SEWJ/jisSF/mOoy865+I2l78FtX/cS9BBl2uwt9d58nKMEh/XbMqD/rwi187auFNxFh719TWpjQ9gc6W5tg7SP0I5n4L8tY36KbAB1b60BXSxW9/Y0j8Sw4wFUH2Jj5Vij+MpzOUH9KE9m5NnAX8yrmQNkHZFaece7E9+5p4ln9WlBwXqafMtbcA+vEv1Y3NAvg1NduGpc2jq9cfpU8mrvjjOeY6r38YAfPRE1xLwq883OtP/Iw+Ux5YAX/qjuvhqnWpjhTr04GNf5UlZryuIrfGLXnm9rspPnpikzSKj15G+Lj8xqLKnMCVnikcdNrAlUKf2B5iSVdMpRGbaIvqTHx3yIl+Z+lLl/IU1f1ImpYsMIJ+cIPWT0qN+rQPk6HdVL1mRR37mNHlpkyB9KHm1z5IbHyuqrSlTj375VUeVp1w9OnuZ+Kod9wK+XXdRPyweccQR325cyCYXGFczuFa0x1/br3YGL492Z+IDPG3gboMoihwbWB4bxpPBrx+YLnKTC2xumQwMwOy0KG02HiaPZu/80x7q8dtA7Rixu/c5x0kzaUwNvsrp7OXMpVO2ydcOVcYUTGpszwRWQUYmvSx2ppB2pOesE1btC2IzBXXQ0sTIXnYsyYg/S9Av+Bs9sQ0SW+jbBxyHIH1jCuwhoy/v/dP3//rXpouPgXp8xV/bOfxJ9afqzxTSBkvtTM7UpmqgTnyq9lSQQc9cGyhb67tb6tDDlqVrl4yl/gT9tdiDDHrW/NGnLmqTC9JHe3n0IWBXTdkRX1PHeag/T16uq/SN5N8LrPWPi4KY0IX4k+uj+g31OLGVt6cdxR3t2figh23655Ku2ITSF1HGhdSB6luOK+lT4l71yV9CHSvX6lasXVdToCu+pX/Ed1CW82oPXcqc40WQ8mp3PT4L6NEOF91/yU0aH1GuaRS/IXnJr3lkiInxKHlzwKtunXeAf1t8DK8+kn6yBTa5QFvhib8hSBofUuYYn77V66vnOWafOKq/9RqlJ3zikLFxDeqLCX7xr4g/8aOSNkNsdA7xOUiser/Zycbk1bIp0GNdSw4+aYVyMqVk8T26LxJi5ZrnI9l0VD/OgxpXOoD8UK8jddmE4nMfmznEFyArvkzxK1cfar+iX9/Bm2N1IW3uHEV2L1+7TdlNFiK3gn6UeLCLjOhIrObaZElueO8V/CGCzz//bNCzrY2OOOKI7y7uHGHOAWNSP6gZ9Lya6GOQFgluhJEPePqGgMHQsUdHvdefVN02iLdfuMiw+eRbA8hE2ybT9qvBRcBgSwfZjptt7c+zT004S0gMpAZsxE6+IPITK2V8pSNpyirVfMehqfPzYimmsWELLqptzoPYIA2Jf0/y0z6ZgEP6WutvbQGR81ouTdsmP+dJe1sg8Zyi9I1Q+lI7b2m7nu5cgOsH7YnItrEXnhwrl0ZP7T89VXvmKL6cB+R8m3ARPsFFydmC9Kv0ufTl2l+lyU+frG2pzdNPQn3f6Sm8F4n4Ua+f6te9QI1dUOMw5XP1G//9AJ109THKuJP2Tpsrj22OYzef7h5X7m7r1K+0BnXOEo9q6xbUungTg8hBsXmq/YLkz/l9Udgbk/jAn/T92sY5lipL/YDttX1r2yqTJr/6ucXn88RliTf+xue0KT/jX2KRevLIRPExxL+UobRvpVoe1OOt6GXsRfWttm1tbxSfITrja/UZHKPeXwhvzpewVIctsQvoYMcWuXuQ+FTISyzOi8Qi8uLHnC/yUkda++US4oeYAV6Er8YxiI9IvUA9FP7YEVtTjq/2gR7xGQX42FLzoI+HenyJbfJD30Y0dy6mvxxxxBHfblzYk1wVBhETsk0jg6Qbbh/89FRWG/xOK04AbwblNmG0ATSDdZDvDrmRJ7c99WWAdb7dpejxtJnNNLwmAxsH5IPNtIcfPgz2GdTrQqKHzTKwSYYP4Uv9TAKZcMRL3Tl5oI76sWsKa7Ypg0xGU/DLknIyppDFFnvn6sQOtsbHLUiMITGD+NyXp071Z05G7OjLk07xQ8rIkda41ePwJa+vC+qg+NOXQ/rCUhs1Ge0jq+zyEfmAbBvGLS7zfUU7a7+l9skihz1ToIOc/tfnCnWaLdMLLNBX1JnTwwblMBcXdchZ0rPmT2SQP6cHtNFS347P6izZKnbacElXBb7Acc5zzL/eJnaQrVzaEyQN0j+XQBe+rbZXxG6oPkBksbsvi29n1bsE/qQfkktnXu9bgnqxdW48nAIeOvtN6ore/+hBsRGSl2NQHoL0jcwNNZZLMJdlPNqK9I2qZwtcD/pe+l98gSn/HGszBIl/dMNUP8GXeUwZvrkx4SIQO9nSxyP+QI5rWil5SeNX/M15xqeM78kP+A2xh6y945H6WecEieMSb3zBS0/GyOpXKOd9qn74QJpjMiHnwC98ickWiFH6lWu0ylsCvsQ/13ZsD5xXf1zXIXzJT53qX3+Mp8YR5LEDTX2bjVzx19Z92RzCA/xKv0HixGeyxJctaYeLwJQeOuQlZmv9bguiI9dHrp8tvsQ2YM9cDGJz+lfGVnnOleOlmz9IGYrfkDyoNqb/kQPhWYoPOepHn+P0nyByQuqwF+GXFxukkTWF3saAjeTcS3z88SfDevXTIb73Vs8RRxzxt8c92eTyap+/vmEQM2iZEKXBnk2owGYXeQZUrza2ycDA3AbU+kpjG8zboNyjjamHgZVcE7cNObz+lLSny2yWZQCm55FHDgNyJoA6qPdgq4E/Ni1hizywUFNO5hwiKxNkjzqJzk1Aa3rSDmTM1Vmzo0LdoD9G4pi4TJWj6bY+tNeaDaBOrZfj5PObP7GlrysmUuW1LGAHX1C9HnqIf9UzBX1S/C1SyfXh+aDlt9dsB8smbQH+0DFnL2hDcubs5Qs57JgDfrGJrikoz/WyFDvpUt9li/I1PXP+RA8sxUUb0YOmQAaa8zl6cqNRdSmbgvyeYqvjCrIqkZ/rcc7mKm+uTqCuWELvY29Lj5RLKwWxV16NYdUhbtqw5p0HdOVGODETr6WPd1ewUzyWrusedOGZinXikRhIe6p2xWaUmEiTp76noB2nv21FrqnI2gI217ZbAtsCMa881d96DmxRj57w7dmM4Bc+4F82JO4F2KytY3PQ+9W3dY+0QeTUcwRk6MswtYlBrvJ6/USf1wHli0e1cwr8yaZHgA9/rzOofuV6qzb0qL6pR6d60bMV2jrX2lY+9fUP+rKps4TYHz7I/AzSStop+TWNryCtMQgFkSPlW8qcs4HfU6/DK+/7wBrwJI7pV9FPlnM2rK1d9oKOOT3AJmXO59YPWxAd5DlOm++RJzb4ITZW/ujQNuoqz7ijLH2n98d56rNJXfUSi6ojPqgvX/0t7Zw+q57jnEMvp4+V8sSLXnmO5VfbArLDW0E+f+4lPvnEJtdng65tm91HHHHEdxf3ZJPrqaeeuH0TYtPIwFxxlk2uKRgkbXi11KTRFg1gALtzknBzaxKx+G7HBukM0DYFbt68NQ7MYOzNADy1yWUgVzf1e2RSSp2pgT7YIg9M8Mr7eFZEVj/xBexCc+WwpifxTnyB3sQHYgcdaKo8ac3fitge2dGTvHrMVv5Un5MGSzEL3AAsLXbpwa98Sk58pcu1MQfxF9c5PdDa0J/v9qfPpze5QGjnfFqzF9Qhf85edugPFr1LSBvM+SQm9My1QWK31nfZonxJDxlz/kQPWoqLNqIHTYEONOdzfOk3ueRD+GNLjnuEL3ZW33vb6dKv5myOHpirE6hbbzhq/dhc5cX+2Bq7U8au3t7o0FZ9DC96k0v/1HfIY0t0u75i8xL0K5Qbli2gA0/gHIlH4lYRO5ByumreEsjN94zS37ZiyzjRI77hWdKlHqR/4JFGT3QmndKPV9vh0yfW+m6QeQwfnrUx7DyIb2zlg3MUvyviZ+/7UhwryOQXfX1b01XHSHKTDzZCE8M1ffS4RqQBvlD1L8e1bjDnb6iCT7lO2dmXzwFP+uPWazSxYvOWfhU/6Ulb40kMevR+hje6tvgWndEVnuT180ugXB/Bo2wLwoOyDnIsRrC13+xF9M7p4WfsUjY1l2xBZJBHxp6xvCJ9lN3ksClQFh18mNKhLP1VHfz8kS8PT9YffbtC1a9MPSlbloCHDiCjoo+rern25aPa7vir/h50IVBHXfCAgfqnp/cE16/fGP/KcG2XI4444u8TF7rJZcPJa3+PP/74OLH6vtbUwHpRm1w9DJReOcxk5S86ZvCENuBm06k9/eXYoGpwrcB24HWD0H51HM+GNJPB1CQTmAQyyNcJYAqZVNbkKV+arNhGlnpTOpWxvZZVvyC2VDuU9fX2ILJqyg5p9TkpOI7e+FzLA3HpJ9mKtbiRvxSzYG2Ta60N44t6SxOsyX+tz5Chjk1keO65Z8cUWn9mpxgfbhh7uEaUzdkL6rB5zl5tqM7agnDNJ/7Qo85S7OibqwPaWjmaAj1kzPlzUXrwk5P4VlQd6Zs1vyL6pbGntpe0yjuPzZGD5uoEsTt66UyfjP5qp/bXR6ZsI0t7TJXNbWbhWbrm94D99JAVmcmbukGcAt9dB/1GSeIJZKLkOa7o44Yc9/rxsm3pFeEeeIxfUjautW9F7I4tW5H+hie+xn9pfIyfUmWQvC3AQ5dUX9nqm/bSboi+La+mzoHunuJrqCK+xe/4u9XnJdDFJzGpT/EkH+p1WmGTS/1cj7E7PlSKf2uInvialC342TI3N/fAYywhY8/1r60Rvf01Oge20UWneNBX29Qx1Lwe7Iu/1XfUI21GD5qqM4XYWcfQ2JM1S9/eyuhbsgf41lMPvOyl/6JBX227JT1ix6f0p619A8IL9NA7FbetICtEBlmOtZPYb4lXtUld/uCVT17arkJ95UAHAvFTf4onwKdejzoHpl+Zf+LHXKzZog4+MagQB9TDj7Pk1QcWLho2uG7evDnqOuKII/6+cSGbXMM4Ng5mBsknn3xiHNSuX78+DGzTA6q8iewLATsOqV+ADJYWF40a7tbf2xmfTs/u2uQKLU0aJgIwaPeDfI8sIJYmVfGlLxPXFNhkcuknq9i+B7Hj7tg03+XHr76utF949cjCZS02/FnyWVzmJlpgh7I5PXzJ4m3JFu2ZxcYUyCBrqU+ow2+LlDmwN/1gTo6YuL5yYza1yaVcs8+1PRlAx5xPbMU/tyBTps6WBRu75uKb/s+OKVviA13aei4ua3qy8FI+JeOi9MSfgNw+D+TT0VP6EJpqA/mBMpTrpJZVrNkcOWxcut6Usyn2pb3027l+vTQWuK7wTZXNXdu5phOns4K/dPCp3jg4d4PIZvHq9VckZukzjpH8lFeQH5ulytO2U770ebF568064BHn+MmnKV1TwKtvJd494p80lBjQkZiGYEk3Ppjrp1NIG+JZG4sC7cWvjINrr6ZW/yrRK+0x5a+6c30dlvRvRWzS3rlBhdiZuMb+2C4Vk60IXw/60r8q9Uj897QZH1z74Frb2kfooY/NYjIX58QjlP7BJ+c9ev9qrPGlrau+elyRNiNjqY/0YJf+3/PIN4aJ0dQYyj51+v4gH5IG+OXRoV7gXPstzRlngXjwK7rIR3NxUU/fYCOfQmugAw//1JdGb/pYH7s14EXp4/j5w3bylvwIKr9jMsQ5fJU/+vQf6O1WJjbJq7x05NpAgTqZY/AoY4u68WWp3SOv+h2wJddxEHl5jXDvRhf5vv3MnvxVfg8zFFdHxH90xBFH/H3j3JtcGcQ8NeVJrgyYn3xy7Y5BrUcbZE5P7iEyaO8d0LCFF3yzK+dSxM866fTIRCkOcxNBoF4m5yV5BuglWbGLrF6O89ieyS91at3wTrWffOWpY2E1BWUmXPGJrh7sVC+TzhT0LbrImcOaHpOpsrn+KB70wFKfFf82gU7rIYOs+DQFdfg9FzfYFpe2cMoml9cV6QY++JVKKiu+9dhir9irs7SQYa/yOVtB7NgzF1+2IHbM2QLacknXVj3Kp2Qkhms+pU8pxxO+HFcC9aqsHEdP9TtltQ45c9dA9GirNZv5PRffyBEfcqYQPdFRYzAXs6UycCM2d+M5d22zAfDM+bOG2JU+hSJLGbuc0x8fQ6nTU3yovuQ4sQoikw17N6yW4jkFPPzEx5+lfjCF9Pcg/kJsqKmy9JN6rSVdAhuBf1vBPvromrtOeqiPoq8+GVf9k7omguQH1bdQzmtKBl39E3gphxxS0evZgvDQ5dpJH5EfqvpSv0+3IrIrtEHmt6qrh1igPW0GxviMUVv7SGIvXbuep47Vz/UbgrlUv9Inc60lfwlsw0Pf0kZcD/XFZGqTK5seKZMXok9akTJ1e4LEEZKf+nztx7izIrGQkieGaG3MqjFUN3xzyLhRdUCVo49t0d0Db/pBYpQ+uzVGGaPYg2JL9Ynsam/aobc3cvDS7zjy8VUo12eiJ76EajzqcQ98sS8xBraiiqoz4bHRZY3bdOQaRK28Ar/4tDp39tsjjjji+4kH/vt//6d/Pj3eDeNiFioGssMrgO17DN/lQYZvfAA+9K8+Oq7nU6h1pAb6OSg3ecxNFpCJYimm0UNOpUxEeJU7T17yc0yGtE02h8kihD++mFTmoF9E9hQiY64cqj9zOK8eOkJLetI+a3JgqU4WCXNg71JMoNl6+M6C10yq7vzF0WpTj1o2p48t6szFRVnsXbKZz0t1Yod0SU7aeg5b9ETXUp20tePEQCq/pjlGtS4Kch2Rh+p1F3+SN2VTZCqfg/LYPAflS7GB2D4nRxl74k9Q83v5S2UgBnPXQ3yakolgSuYaYhPd+LM4rmWhnKedUcp6kEXOEqkTAvKWxoMe1fetCA9dEDsq4mfS+Fz5eh6oviQlH1/Kkr8F0UnGVuBJeyzFktz4lzR8kPPIC6kb8CXxk/ZUy0N5itxN29ycOVQ7TafH7eShahtbQ/U8dte6U+eVKqr9zYeDb3W8IqdC3tK6IKCPnUDWVuDBG1umoLz3N3zRm7yUpwyqbHnxSV78TlopiI7U2wI8sUV8q7wlhC/140t8c1zPpSh8FbF3iiAynPd9oMraanuP2GoDhC5y6ImuNaiP4ps0eRXyjf30VB2plzRyoJexBryJl2OUeG2VFd14Ie0WOFaHL9LaR6eQ+uQgfFUesC2bs6A89WNPNtJAnjprPoUXYkMFeV4lRH6kteGFbHLlmN45iu974nvEEUf8feMw6uyEcdEAmcHVgGhgMtj4FpdvY+WXhR5tEDo9+Q5gytZMJPwL9ciAq0yc6kSRiSF8qXdeRKYBPxM3ir2O6YptlXrM2ZO6a/ZehD9wUXouyp41nFeP+O6VMdV+Tc7pyQwuInZTuvfiImTsQfyRhvrr0nGu2Yx1dcxLubrAB9eVa69SXYTVaxFtAblr8bmf8Yu/PdiQ2O3Bku1zZfLF/6xI+6KMhTlHaVeU9p9qa+1Z29p5beva3kt+7gE5yB9E2Soy9kL8qv6imt+XB9Fd/e59RKkLZN1rRG986O1H2i+U69hxkHMUGWTyK76itO9UO8eOIOchm12Kp6jarW1726sPsb9Sno5wrA5EJqro7Wq2HfqoNH5V30PxHfWY0jeH6NtaHyoP6uNUqcYn9eXnmCw01ca1fdWda+MppJxNWxEeuuYQu1H1G6r/6QOpm/zkQXzp27j6nTpVdngqn2N16K027UG1lRyIHnZshbp42BlZ8Rkcx1aIjsQ/iF8Q36ucJcSP8CSOydsaHzzhrzLSvjkmTzmbpT3ICFX+HuTjj9+1Ph3KE6/YA8rmfIpMabWjh3KvG/ow/I0bja5du356X3lnfzziiCOO2ILdM5Gxqf2VwgfGV/jAo9UGVzAIZaHlI/Rto2ssuo3vwhjFxjU76wQ4N2iLRwhMBHUxmsmhDv499ZiqE9qCrfWWcBETzVYZF2HvGrbYclGT6xZ/1tqzmXKwx/nBPIv32Lsk48A/h9RZs/l+tBGcRU9iGQpy7SHXMHJdevXDsTTXqXP1xAO5no15+YXRK0g5lj+32OyxpQ22Yi02dPUxmMJa+RQSlzks6U7ZFOb4luStAY/21K7kaCfHafu0f6DcjV9ta3Ne2rou+vWRvVjyv4e6iD48zf5GkJhMUeA4fVpa+zekb8dnqTw6E68tUPcsiI9z6P1CgeNcz32b5npGytWtetLO2hb113TaudqXY5R2qKQaOth42EyNrSFPeeWTD+3zDw+ONnvlLBQ/0mZptxqDLejbOP3ZOV/4mXJp/MenfE0fm9ZADpDVy0teT1Vui9l8OydG+NJG8S0+h9LG8TO2JQVy9gDvXp5cW3xLu4aS1/ud/tz7rV7sr32br+nbiUco+oOqm2z10ydSN3kIaty3InriB5m1z+0FPvZIEys+VF8ci4E6iVOP9AnlW/1Sri5yzP4abzK2xiftlniH8PNBrPiTekBuT+qomzj0YFeNWY1V/FCHHn4EzhM/9Zag3lKso/OII4444qKwa0Vu/DEIGcyeeurJYeBuE2Y/aJlIlRm0bHQ9+ODdf0Xju4HpwbjC5JPJoEcmDnVMHmJVJyw8Jp4sXjPIzw30fZzVzwSeCU96XsxNQnuxJue7pifY2j5nxVY5d1Zz0jKYh+53fOfisgcXIaMHmblWcr3kuqs3j66dXMd8cu3mujWmeWw+N0X9onMKW+N/L3y+15jybc5f+UuxSNlUHJb4zor0A/qQttcntD19afMs5rM4R3NtDWe1lczYUkEe8gmAEBXIBkrlqazy+Jc5ISQvyLwUPzMvzfkYG/eA7XhyTe3Fkr7IzbUs5Z+8XM/JgxbHO69n5Dxxhvifc0h5Nq6m2qNUn0X8sYGlbdjph0Kvmj/++GPjN+DaeHTYrODP3rhvAZnpA/EZOV4DXnGt8a1QvsXmxHmuvry0MdKm4pNxGqWd1SUrPmlX7WtzIZvS8g9teWcbLyH1tvhUQcecb3OIrvgXv+N7KH6rA2m76rf5ynnKKwVbYhAb1E1/meJTljETD9oDfUnbAlmo2roXePnP3lxPUqRNUrYWg9gC4iDmS22qPGMRG7QFpG/Stzc+iX0ds2KDlK7aNxA/pclL3SmQOSUXX84Tzx54ztNOATnDv+3kiCOOOOICsOnD8xkX26+MbYFhsDUotYHpbhgYH3vs0XGgtRj0J1tTf4blWwd+84PNfMlg38NkpY6Bfi4eFVNyMsFnYq91cizuhxgeYl91qqve1GQULH3oGfCTM+cPW0P58PkUTK7smJsAo4eOpTriwt45rOlhJ8z5A+xQL4uZKay1c2IvnZOzxR91ED1zPtHhurKoZMulS0+P9svHQ76NZrFZWji063P+5j3+zLWRMqTe0oJxTU+Vs9QGc303/PSkLLZPofojdR4CcUtsg3o8F5eqTx19JtdiymqqHD+fxWcKadel+Cq3IO1trthyHbBZvbnxgx4xVt7LwIum7Ey8pnQnBvL7stgsv8YZ1vpURfxKLIPwT9mlnv6mbdCaHvX1m9zUbEV8/Oqr9RsuOhq54XrktL64pX/eOS/08viDXz9Zus56pP3I2xLvQNvCXl0ottMb/aGKWg/YF31TMQjki71+FF6vy8zVX0KzK2mztfmR89OKd6HxnRexOf6ixDHjSmyC1NEP+vbURyDXRGIDyYPISJ8K5Bkf1tocj9hrA3JRbKzyguhThqIn+VOo+fToj3i3XqPqpo/QtTQGV+DDQx9dfYzjA4q/9bzqqP5FTtqh1qMr9iWfrKUxLGNoLwvYkvaBrf6rH6IT3xJ6PXSkXS8C5Jsba99n19a2BDLYx06Yi0Wto5yeWiftuyc+PfCZZ8gNgbZNX4Jann7fQ1nWU7Et+fyQRy5fpH3/CfCpv7SuDVKXHxV0XLny/niveMQRRxxxEdj84fn262P7NWBqYTSFYZw8HfQtdNuNv7zvCswJmRj6D89XJN/EcFbgzaTnOJSyepzJJvmVMlEttU8WQ3MgY8kn8kPsnQN/YucU1vRA/Fmy9yL0xJ+luCmHORmgDl1zcpSxd8kfIIeeJZ8GS27X8et/dDsn33cM2oJr3l62wJKe0FSdtfKAHuVb9EzFTj7/9F0yyHMs5WOO1alxICukr0pjgxhVe6oNsbfKdIx6XbXMcWTkuOoA5yE8UO3qMSenQvnadU0OrMlRjz1TUM7mufK5ssid0q0MQV9e+fqy+NMjNooHyoIaRYY6jrMp2MsGeXj5s9Q+QfSuXdv1NbaI9Kpa4hafUfPhzj6nHJx/9ZXNhDs36ir1IAf/Fn96xK7YuQVsjL4KeZGH1ENps5yH1A3YTZ44VwKycj4Vj8abY3Y0HkRH5t8pTNnb1kWhNg71bdU2uuboVPgGHOxvbV19R2yP31JgQ18Wu1BQfU68Iyf6QrEDpPE1wCsfr2NlKDFLjFBsqTbhjR5pbK+2pG7OtyB6EFlbgY/dsWcLoit81fc6X9UYBI7xTPkdUo4qyEpZ4Fg+9GVAV/RVyLMxxEaILX29KdQ6+KfkB3zv9aAtevZADKqvieke4MPD1rRZ7ytfgPwtfsQuWKurHh36D9gco4NN8SV+SSF9MDqC1CHDcfxJPTocq8Ou+D4HdcmI3iWomxhW0HHz5q3dm35HHHHEEXOYvkvokEnIAJZBdQta/faLhw/R1wH9u4CVOedCkYmkJ7EOTZWje4W5tqo6L6I9vy194rvUN7dAOzWf5v1a83lr/7ooORY+WZgZL5AFV24M6JFmkZQFXKUpRP9WO4Kp62/uvFLyU6en1IM5mwP1v01YsnfNl7nyNb4pJC54a59JX0lfAnXNXZnD0g4pm4OyPbbtqW/zIzay3UZJ69vyDjdk7TW5O/tWI+dzZdM+pQ7Ze/yCs9aX8q+2T6Vcz6i2F0p71baTpgxV34G+GouK7vT2eWzNhmKzs9lq7WINlD+m06iVp25sR2RV2gq2sjt+xW8kv56j1AslDlO+5zzyU5Y26WOftMpEAb/Uxxu+CvIOsWptXPXgj00hdvU+Vj+rHervjW/FWfiWeGIL3/hY45njELCfH73PtW1S3vsdulfgR23XxH+PztiOJ23fx+8i9Kyh6kgMobbPVrALv3aC2s5SemDNj8hRR1rlzCF9K3FkQ/xBkSlFqY8cB1V39KeutB4rA2mO7yXYdsQRRxxxkVgc5S202ze12q/zmYS3wqDlaZIvvvhyGDQ9Nv3IOIB+93C2hdS9Qp20prBW/vc2mWz1Zy0ua4iei5Izhy3+tDqHRf4ci+Jzmjui+uw4FNS8LK5CdSEYslirlDz1+jIUPuB7Fl7Go9wgZHzK4g2pm3jGvrn4pm4o8kNzemqd5EU3fdWOUFCPl6AeWReBJTnn0bFk41rZHFJWeR2HpvqLfqIMr/ZIm9VfvmMPWsLWekGtH6rXQaWW54aibe4Ont3miazYbx7t+x2q9QHPElIeu7ZiLg7Ji7z4mXbo80LJj7z4Gn/jozZLu9V89Xtfq28OK4ktutuWO59ykGfzKhtad29wNZ74Vnm3IDbyofobP9PO1kw5lo+vj8FcHIIajxaTNqaRIU0ZPw7xOGxGpOzumN1JqV8hTxm+lMfm+Bxfql1T/vWQV33bip5vK2/40t6JSeISH1MeuVWX4953VPu3ssQjMi4CkTclMzYG6qStlcVOtu9B/MXrODJjh1il/8BZ9Syh9yWxp6PasweJSewkJ7KkytJ/l1DtgcgRlx41XtLqR0Aeis/ZWO79w1P7G5CJogephyIXzSE6lupURFePxr9NxhFHHHHEFtwxohp3DD7I4ttAaZPLn3C16FobuKdgIM33P7xHbpE4NcB9l7F1cF/Dmpz7pWcPltoyeubqrJUHW+09b7/awn9eHcGanG3l4tLq1RgpC39Nz0MwtRiqZFHVU7sxbK+L1fMpyiKvLvb4lUWdxVkWacaUUG4U6uKtz6ukPHIrZWFXF3dzWCrbg4uSA2uyLkpX+sMe0D3Ht6WsUvpa+pQ0fab2j9r+2jcgM7GY0xss1as21fKcsyeU66FRNuHMj+xtNyzsbDbrp4cb3jng6XUvVB8RmT3fElK3p/hW26G/ppWrq0xKNxvi69R1rGztGiR3Cuo3u+6Mf7OxPS2XTStrmzylHqRu+Ni8B7G5J/7Eb8fWU8h3E62vssZK+6uLEoezAC+kvQL5NcZpH22YeBxilqfZDh+zRmlv9aZAbtqztnHamf7qX2/jGhKTvTyJyZzdsaNSkD5RY9PHgY7avyHxTjx633vExqp7C+ZiQl7vS6CMLaCcH9oX4kfs2YvEgs9kJ15VT+okHheF6Ig+NsSf+FTt2QM2R1780AfSxnv8SHyADFTtqX5IU7/2G3VCuTbV7ZG2luIPD53y8DhXxpfwpO4UImOuvId69EzZB8WtI4444ohz446RxsDjaasnnnj85LHHHh9yfnBy7dqNcWA8DwyUPlAu9QF3g+p3CcZvC886sUxh60D/bUf8XPJnLRawpc4ayFiTs7X8vO2zxR861uK2Rc4a6PjhDw/XUZN7enIHDouQLC5QXVBJLY5CbmZsSIdyg+MDtqG+nEyLqyyyELnye7DVmIKy6LRwk8rz8VLjhQ/2Oq43Rll0nQdL7bMHiet5sVXOWp2L6Fd/C6zZze/00fQ5x/pW+pI+os9It/aTLXEnZ66O/FxLuW5yLFVe7dOX05+//vpwowteO9yLKZ41n1O+5ncPfuJBU+MDn/s20Q7x27Vcr+dc62e5nqdsr3mO2WWt4a8Wtr9ceOg37XXQ/RtYa+ALskGZDaxPP/1s/Jg9cmwzi98hvu/1fw/Sf3tf6e5vlnuIUcbxpVjNyaBj7VqsZXvbA99FtyF58VtfSf+uaG186NtL/dn5XlT+Pf7RNVU/Niibkyc//jqOT3PttgfiQh6Iq3gmpnSkj1wkMg7zRT/PtQZ0Ja+NB8v9ewpkhXLOj7OAHeyBrJ0CfZGN0tSLzgo+aLs5X/Aaf/s2pUuZlI4aG6l8MpegHG98WIK6c/Km/DriiCOOOA9+8MEHH/41i1aDVJvc7v4F2bi5dyIAcojC69fTp556clzoWfCddVK4n/CLcEtNmiaCu2NggOcfX88zWZvM+kmoInrAJDQFdcix+JrDmh46omuqjeSbqKJnzmcTZGIyp4ucOT2gjJwle9f0rPkDysnJYmwKkRNdUyBDvbkJf4s/6rgmtXGtIx/lGJQjMtl2VkRPn0J09fbUuuwVuyl+SPyX+sKWNth6jVyEnvg7J4cMOE+fokcd/WVODn/IgrnrXh2yyJmzVx3Xm/I5OVmEztlMRt/WFTZAjQlTZfj4OHXtpL8ri7+xJSBTeeo5FzvpXOwC8tSLXVviDuqoW3nBcWyoxHY8sXEK6rV0TEbQoX5kbkXilvbEaxNnCdpIPPiddnaeuCdNfg86qq09XQToRbVtYhdKv5CH7gfiX/xuMWhpyrdgT1tnvaGdc22HR+JYnbkY4Esc5/o5XvFMqv4Uqt+xI77rU9UGZfrWFh+3XosVGRvY6uZ9C9inPn3Att5medVmaeIillnvrPkE+PBIE4stYKP1uFgsjSM98NEVP4KMYRknMlYEiQkf8e5phz0gny3RQwddFw0xrzqWfMnGEDv2xBqPmCXeUsjch/aCzFDaiS8QP3q52k5M0RQSgz7O7A1P0jkdbBAX9tSy6FaGbw1pl8Sqh2vkww8/HD8+f5b4HXHEEUf0+MGNGzf/msfjM7BMDTDGpbnBaQ7kVFH4H3/88WFB9PDJp5+2X7Xp/TbjsMllITC9kSCPb/zdOkkmljWmJk2TUYvbVBscbj7m4paJJzcvU8iCZ04PZDKamrzkKydnaSGrDiibi8uSHoiufoKtuAg9W+IWW+hAzoMcKydLO8pLfk1zDHPHW8DfEJ3pG87Fi68WFjV2fVr9mQO56i0tSOkRu8jtQQb/lM/pUkefMi7MYa3vbtVzEddIXRxOYasedcR26RogC9g0BXXIIWPOXnW0o/I5OcrRnM1kLLW1m4alMn727cI3MgM6gAzknL19fJTxWVr9UZ9M5Dhyaj9P3Mlc6tdioS4+Oqb6FNkVc35WNJtOTwawZcgdeOb77RS8ctdiU/0/xLAi8RDrGpe+bvxJeW/PXN5FgC2IrWJf8yr68/OC/ZGZdp7awJryc6/vra3bJksfx4pq09J4pMpcPLb288ov9vjktb7Vrrsl37NxGsjHh6b4KtgX/5bGygq68OkjNrmig83xRZo+D6mDR97cZjzU/MjJ2JZ2WAM+ftGXzbEtwCeeif0WPvahXDOxT4rEilwy9YOU48l4AMq2+rcH5NNT24Oepbn+LKBDDMQssVvypdq1Nd7k4yEXD4oceWScJYZkoPTrIPJ6u9isf9WYVsS+2t6gPqIjOjNfTfmeuvEteeyMXUu+hl/9yJfX26wvfPTRR+MT2V7jP+KII444L37osfo6GUwNVhkIt4IMC8RelHwDmQV5+4BrW+x9mxEfpL0/PaZiZDA3EfVk0Ed1sF+aKCr2tMUUtuq5H9jat87rM0QXEvdQbQd9sqe+3eRZ0FRKuTKyal7yoye6QFuEXIMWDVkg5dz1iSxEKiXfU5H967R4vS4TeSH5laDacFaKP2tYq0fWEtbKgzU957VjK7b6w57z2gxLdS7KpyUs6UhZrjnXhRtH10r8Vyd9Pn1cP5XfU4Av1yWZjgFf+r36U9fdUrwg1wiEp6eLAD1rtsyBCXhRYlvjIb7inLGogv2JUz/GZHxJDBNHeqr/aA+qnWyMnekLjjNeorRbpbMi9sbn+Oo45S2/+Z56UhT+SntBzhYfap3wTPEtmRCb53iD6k/1Fep5T0F/vqavIrzaeQt62ek/qPYX0HaVajwgunuqqHlbbQzog97mJURfeEL1mom/uVaUhY/O3m99WVmuKcCDn2xluQ4cXyTIZ6OUbRlXqv6LAFlkxv+09RLit7p4E8spsFPs6MGXuOJF5EBivNcvMmMvXhQ95FdUW3s9kRP/IxPUxRP7UPVhCilTNzqlW2IcXamfWM+h2bTvGjviiCOOmMMPM/ktw0B5ergAddqgepoxAfq8rmgwa3+58du+0RVn5p1ai18GdYO9upkYpDkOfdegHZewVr4VbfK7c3MqE2if6lMhCxKU8pzXOiHl9RxPJeWVppB2TNvq7yGTfEiZtJZXSrlFQfLuru+8/frdZN7Zf+TVvlUpqMdLuKh2PGI/+ja719DWU/09lPIpUlavoUp9WerzTX+ufR21Pn33Qh3YEf5Q6qFcf1VG6lX053OY4r1INP/W5bOh+W6sOsTbmNb+EuCd45sYpc0gcWn62nmNeeIeSt1KW+IQO9NOsSfj79QYrF4I33nBdk8E8EnfyofdpSGbWfL4CuwWmur3RaPFkK7TjBnUGDaaZ1gyMz5saTc4i9/i1WOrPsCvfqX4XftP+kZkpy5702Y1RbUvh8K7FYlH9G0Bnsq3BnXib87jb/W59zFp/HLeX785d5xYugbJ78svEmxOu0VPxhi2xRb+nRXRgc7iCzvYJGXHlD1VB/Q6qt60G0qbbYG6aWfy0p617cF52q6Xv+Z/7Ip/6sX3JSiPb2LgHE3pgPgSfepu0dP7esQRRxxxHmyaWYxjBrNGp5kd2mA3X16RRaUBzUbXd2FQ2+LXFDI5ZNLJBI8yUaDEdwlr5cGWemsxVz5Xp9ra1wnfXL42r5R6Oc+kWCl8NS8LDhTemlcpPEvyY0cQ/6S1nUJpR2mltK0+PkW1zhRFPkgT61AFk2N3XzaUjP/enX83pvyvWCoLtui5KGyx57zgz5qetbiRsSbnvHHrbXCsnyc/10ZoKm/qeqjXTX8thafm5RhvzqW1rOpST//W510T9dpIv48/U4gfkDjji4zkVVRZa/KDyFmrV7FVdkV0VEr71LjZ2GpU430Y+1pMml4yE5OQOMur5X3Ml0BfMGVntbXZ2+xCdXMr5eGpcveAzSE+VPIDQBt327fHGt05Dje/D20G8etegS4+p52iDyUeNS4txTdWvwvV9h4pi/ytqHxboH5vR+yfQuzpy6vfKOeV5EdfSFuG0v69PUHyp/QvYU7eEnpdoTm/QjCVRx7f+Jk+HJ+X7FOWumTdjw0u9mcMoDN6qv2gPDHYC3LxkQFn9SV8kLEpMZeSn3ErtvOjoo+xumnDNVQ/pIlR5MQeFDum5OKrtoWfTJRjtqbullipE4p9c6BTndiJZypeU4iPRxxxxBEXgR9cuXJ1cYTz62H/hMjUGLRhnLwDJll//chri/nLQ99WHD7+2hYGPTKoSzNx91DO56VvEES2yWBu4lFnTY86S5NX9GTSmsKaHuX8yYQf1AkqMYHoyXmfBs7V7fO3oPpT/Yo81PsTHmVrcQOv02QhM4W1uClLXMiY05XYri0mhn+H6+fW+KpP/culbuSuXbs+/qXUJRmpv9bnLFiW+q640DknI/GFudik75Izh8igZ8qvrXr4s/T9lzU9oI1gzl620LPUjvSkTy31vXpdV7Q+0EAXkBE5Ka8pqnqqjHo8Z0tFX2ftPP1sqb9V8Cl1t9SH6kMgftpLm5MnlmTL9w2QJWgf9cR+rk9VkLvkI/va6/yHcU5qfvHkUfIRvarkvEK9Ri2u0ffNN+3maA6JRXxaut6CyMOTfhibkPyUL+k+C/hUkfPma3xu/sceNtrQ6nmnEB5/hRHydBd59wr+2qNNuMwjiZu1hmNmH/xzwztvi3qN/zSjw97+C7k+2GTcX4tj6ksr6veyKhJzYBvCm7EST/yHKRl4zHvquK7XbIQW48anjcVjK1/iKB5TfSP+9PB9LfX5Rlf1O4jPORZLtPX6DFzX0dUjvtd2ivwtMdiD6BIzoCP+V7Aj86jyre0B0YHfccb28/gSe8iNvBov50vrIGBLeNjCpyW7ej/EIW0iL7rlR3YPdemo1wG+EBuk+FM3du1BbI1MsqIPlKPEkHy+VD36RO8DGeJqLrae/TbfDx5xxBHfHZxpkysYxrJhcDo9OQMMdk888dg4GH744cd3DJbfJlzUJpeB3SQ0h8jOJDQFMuiZW/goUycT0BSqHoQHapoJMRNr8pOGzoLYFd2xI3k5rlBPTBKXWl8Ze2t5jy1xI2NqIVahz6qDppC4zfUDZUh/WNJlkaB8zh+ILH+NxhORjz322O22daN27dq18cZtyZ/Up2eunjri923Y5Mp1Rs9SW8O91qONYK1P4Z+TQY8bLqhtgDdp6Dyoch2HIGmQdqoL5lpnzaeLhH6lHffoEtNQ/HUtaa/cuPAhtLbJlRsNMpb6TKAu0Dtld23TRtXe00qniIyk2Rxrx+31GgQZk8ggdw7KxBUfnqU5KYgehD8+3ivwMci4Er+3gH8+i1DlrOHJJ58YU/3N+Jl43gsk/nBoT/PK/msKf2uX04wOta239F9QX7/X1ls2udKn+n4RfcpDfK1tGfvpU5+da/oAD53q1rFqDWwwV2rnrWMLHvMKomuqb8S/1hYHf8WEbXjiW2gOePiWNtvqG/vUTYwr2BUfgj0x2Ir4nPkxY+6cD6mLr1172/poxmV8ePCeF2mzXDPVZm2xZayEPgZzG6OQtoap9iZDm5E5BXXn4pY2V551hmM01x5bwGay2Vv9kscXttLRl4Py2geBLYmRTa6PP/7ktOSII4444uxY3ORqA74ByJlJecy+MBgQ/aLpaRO/+N269dniZPi3Qjb62jfEphf3mWwN7FPIZLM0SapDBv+nJkRlmVyqHvlJkfIaw5RD6uzBXHtEj4kscJ76UvbypfpT5WWym4sb0FN9rvyBhcDUhBpkkTC3gFI2ZWuPLDyrzxXpB8qn7Ezs1ZurA+xVxpa5Om6Oybt58+Zolw0tckGsPMnl+orOKTniqjy6pkAmWuq7iT85c/autTU71FE+JyN9Yamd1vTg58/SYnqLnixgz9On6LD4TBtUv/sYqFPlpDwpWTDVr3LOZsdLbYDISp1eVvoYW/qyiwQ7tCV/5uIHsRc5ZlNsq/a5RrSVMnXJ5svc0yaBeuImHkt9JiCb3OiPXbGzR32qq9nd+kvyhxYY0uYnSFp+m58feKD196+/nm7TKeRGQ2ynNq+rvXzp7Y4tZ0HiUintlXKI7owHyd8C11S7adrOYx3CLzHRzp60ulfIdVj9hj0+VmiOuTahSxzp2nOTjk8biIWY9Ig+qXr6U99PtN3cOBLIZ58+mfpb4kBXbFzaROjB3jxdlfFgDXjYSF8dj+hWlnN2VwJ+qYNvLRZB4pG+uFY/wAfsqTw1VsCO+BS7tsRhDWRmXIXEd8l+POzCE3vW+ilf6CGX7Xi2xmgL2KOPBHTsaQdIfNkJU7Ggx1gljw+ob4fISEwr4j+asq22h+PYcN62TptJ45Nz7bKmJ3NPhXraXHrc5DriiCMuCg/80z/9j382KE1Tq5T0omFgzMBsA6lNXG0gb2Xj4d8cYsEWthnIp1AH/CBxTJk0kwEy8SStJM8kEMqEjqZ4kp+yqjNUkZhLMxGhTLDxQXkWED3FD3VTJ7zKQqlT8ytim/IppDxyev6A71Pygy16QkvYqmetnJw5W4C/MCcH8mqLxYHUk4bhI9vrOs6TN4Xq85yuyNDGc0hcllBtm0Js2SJHnbl6bCFnSQ8ZS/GHLXpgzR+0BNcvHVms5hojNwTk1MVjqNoorXm1DOKTOlNQRg/f5tpbedqyyr5opE/N6YidsWUqJrG15oH8lPFzTgdUf2vc5CE2oIzDdZx2LCUDYodUW7tG6Xc8RPN22cFWfIc+dJqM5zk2Lzmvtq0h9tGRdo4/bEbmndRr+g60BfEhfTl+Smte9RdV0DWVvwb2792kShyBTWvxrDZtjUnQ4kjGxVxDZM3ZUNtPvLcCn/aPfY4rRS6oU/UEtX2XgEebwVYb8cRG/WprHMMnpavnUxa5ldSXpm/g64+lkZc08pzv8Y0uqDLXgC9U9buWpSBWiL3xM2Vb9UyBTm0Yu6Njj8z4Xe3vkXFJ+Vl0bIF4pD8C+XuunQr29TGOn9kAjR+oQp2QehXq4pvqw6B+/HB8URtcFVWHdoE5X4IaiyDxlbLTXwY/4ogjjjgvfmjcnKM7cVfGhcDj+Qa0vFpgsPQLisfJDZr9wP63BntCBupKBm8298QnlPJ6njQDf+RWPYH4VMpEYnIwsWTC6/N66utIe6qyc9xT0NtV6by4CBl/C9R2q7iX/twtutmwpS3m7IX73QZLtlwE4s959WyJ61ZMXV+VomuNLip2a/1hTU/GxDngN+bNyZGPP37NIfxTsQLltU7yq8xaZwqRxx7j9dS4nvG799n4Wcfd/txTW2jQctu+2NLskh7oohCf6GB7fKn+rMUlIIft1T83Kih+Jk09afwNTSE2brGjYk7eEvLUV9PX5nMbX74bKi7atpW1tmg/MjTaad5t+/byLWHO5RqLqTgmvvyrfSH+JiWntlnffs57RPYWkLG1LkQv7OFLXWnvc/o9xKekOQ6SV8sqBY732AeVfw/CRx/ij7GKn5BrNDa6LtmeuugswJ/4QdWzBeqxI/akPWrcogOpn3Fkq44tqDpiDz3Jr/ZsARkoMhJj7RF58RlVpG+iKb2J2ZT/6offcdqj13EeRG/0QHTM6Zny44gjjjjiXmH+LqSDselejE8GSoO87wp5beSrrzx98oPxyS6vX/mYdntC5W8/OLbFbJs8kON6jjJBZiILzQ3umRBC4pEJSVx6Sr2alxuK/saiysh5KBNkJXmV1rClzlYsTX70LJVD2uK8WJOxNTZL2OLPFh2qpNrd9fXLpqO17Xh4ZqzZs8Xe+9VGW7Em537oSdzUWdO3Jcawpm+rnDngX7M1498SlsbFPVjzac6O8GyNu3r8yhhf5brGMrYab53XsbmOwxlrgcwQkLkWtx5r/lcdZKdtcs6XbNqttVvVFV+naMrn6vdWqL83HoAvPm9FbGtxuXNe9xcsUdYA0zSyb8JZ7FvCUljjV/Wn+XRnPzj4cbArvJA+Xtu19udQBblbgbfq3oLo6/lyjuJrSF7l630H5VP+hi/pFszZuAQ8lW8KkYf40FO9piF+8CuIf3Th6ce1LaCfDrwQPXtiBOqzLby1vaoOZbXfXRSiA4lB/Ei7R796e1DtjY5sPCb+tU3iL11L+uST0Zc7j61Vx0XGCqIfAR8Sqzng6e094ogjjrhX2L96vEcwMHqa68aNWyf+2qJji8q20fXY+N56fZ3gfoPaLQO0QT43Nj2lzOtlviGBHIdSJ/UyyYZSlslEiqYmlSU790x2a/5uKb8oWy4C98uW88Ztmy2HhXBLDzzE09GeEpkHPvXW7IGlOpFzXqzJib/nxZqc+6VnK7bIuShdW7DW1mxZs0f5lj41V2etHJZ4Y98SP9S6YCzOmI4yjudc+dLYPAd11/xZQm54QrkBQbnpcXNVn+wAZUs643/mncxFdd7q56eLQHTujYf6h1ieZp7CeahHb7exM23NryZvny1zYN9gxSldDJpfh/avFGhrba8vOM45sImftR8njvKbzfNQvlZnDuGttm5B9PGh+ovS73tSFj5p2rj246lrN+eRvxX40Fn4wlOJXyH+ZDMk13bO08bk8Cl+9ZCftiYTHz1bEHvohegh6yyIrdqC7PhQ7VI258tZQW76B13igejIMbBBufpoKyInMcYbP2usIpceNAWykHqxObZIyU8e2fHjItHbyBd6qi17kHZv7Xq2vnPEEUcc0eNbs8lV4Tslnuz6+ONr45+StbnlLx89+eST45NdBtK/BbxamYG4UiaQTGRoqg4ymNdJrWIufy8uSs4avmv2ruHbYkfFWRYMAdb77dN57P2uYsnnLfFX59sWtzW7L6JfGQ/n/CZ/qfx+gz3IWN7fDE9BXbbfL/vpMS+66XDD6Uch5NV/qW+/yFcnN1lbEH9tZmUzTx5cRB/Ygj0xrHU9dcXEtF1vb3ta60BDzVYwgXvhK1N3uLaK3NymD2hzVG88+aHvTm1QZn1ScV6/97RddG3hUScEfI/P6efAp/TfUPyFKmML9tgY1Bju4Qv4guLf1HWtzcmuunLMfzQ3VkGuc3XIqn1mDspjl+PEttpwVrCHPHLjs2M2KrsIHRX84Ld+xAd6KtKP6GWPenvBfgSJ95QfuX6nkGvUWy9ksCN2A/l4ncfmpXY/K+hEkPEkttEdP/fg+vXrJ++/f3X8q+BHHHHEEReBH1y9+sHm2cIANjEm33MYML2+aGI3sLLD4O1Pv/u47NREcZFoA3ab3Gy49agTDbtMPj3IMJGaCJYmHRMU/rk6WXyYWKagDLFlaTHAF+VTtkImqkxcPZRncePm57x68M/5rJwcE+mSnsiZgrKUR1fqRq/Yoioj9RPvLD7kkQdJe/A5eqKffNBflKU8KRKTUGyG1AP5yiG2iUHy6HZ9SB980KL/ILOiyk4bRW9P0R+eanNi16PypJy95DmXVkS2NHp74ItcqDpQFl+uxSmQmThUf3qs9d34Mycj9qtXZVSfHFd753Sxl5w5n4K18SPj55LfsVmdJTmRMSUnsYmuHjU2Sz5t9Wctbvpcb6f8tDEbpvwI6Iku490acg0lRluR8aXGJLFC6beRn/OLAntRYj5lO53s3BKHi4Ab3Dr29/HIMaiD2K5sqe9MwVPjZOHTZ2q/WhsPmu7Tkw0QQzwZv9dgI+7gc9o/43Kuw4P/FXTpv3StjSEBPXhcJ2t/gRTYEz0V+slczIL4lbZO/eSDFLGjEp385dfetla/b+clZI7Fs7XdIJs0PZ+8+Fj9TH5F9Znd/THgrWNVjeUW0Fn7CpqKqXrRA3v1bIV4Zy5hx70Yc/hQr8XaPhVpj74tE/slZK6BOT52qBd/K9RFYiDWAbvVjz1pjz227UHanV7tPXXNxR75U2V409eDTz755OSjjz4ebT7iiCOOuCiMf13x9PhbDU9RffHF5+OgagD1MdhHH33k9oCaSeBeYBDv31FXPzgD/VmYGNSn7FCGYMlOOpZ8iZ658uhRr59gKtb0rNkbHchkNydnqx60VIecpUVU2qbKqzRXBknVIaeWy2OXWDqv5ZEphZqHKpKnPDRVD5TN+QPSKqfVw9PqB22h8/XpQuhuvVUe8LHKrHVBOsUPtf5cnRyLpzpbfezL5aVOpZqXNptCrVv7XHhR7AtiS/JDNa8uUlOWNHIrojvlazanzhLoU2euXmxYkhNdqTuFlG+Rs1RHzJaua+ViMidD7NYQP3oZ8sUL1m7Q1E07rdUF9UJL/geRzR6pc9dtKH1LfupKLwpunMytxozEe8luurfE4SLA71B8T1wRe9mCHMd+9df86CHOZENkB2eRt4S0X5UnD/kxrZEbSj+g6RfqN7/js/E9fi+9mh65fNvTbuGrcZgD2WmjirTHFPBEB6ptnDQxTxvH39iEJ37N6ZmC2MKSfT1io/pbYgJ40q8Qfuc2PaSo+h1/Uc5zfVb/az1QNxsI8vZu+gV4qj0QHRA96sBZ9ayhbnDRn+OL1CX2fCEzsV2DumJT22sOytWzMQbG16l+Wsf4HuoifP0mUMrowEtf2qPXcV7QkTaJLXM6Eps+PtXOCj/I2sC8F/3oiCOO+P7iO/EkV4XB0SBpAeiD9A880G6CMuh++eX2X+W2wnjc9FqQmPzvHKAN3CYoaRYiPfArh6UJyCSCf84HMpDyKRn0JEZLk5BJNxPuFOggB//UxKM8k/LS5GTypmOuPHpgzhbl7KVnzmdxI8tk+fHHH4+vuU4hsi5denp8MtB52gM/f65duz7KePSxR08uX7p0O5bqOlYPz2eDPTdv3jy59sm10XZlZHut9oknnhh8bzfwZCP88fe99947+eFQ/9lnnhnjqF7qkoNs7N64cX30ibynn356rIMfffrZZ+MvYGx5+aWXRjnyYbRv/Kuln58+AdnsvnXr1u1fzF5//UdjHtBLdmKgH/s2Hv23Bv1D8ZD/w5Onnnrq5KnBP37SRQ9yjA+u37hxcnMg5y+88MKYV+2uej65dm2oe3OQ9/DQJi3WAbkeXb8xlLP3Nk4vvwcGGY8Mvon34489NuYlzvHHcdAfIzpA/R5pF3Wq3CBtKW+KPzzkiGfyerhG1KPrDj8LlIuNOlMyAtcBGfGrR+Ibn6ZAV/SRNVVPmTrkTOlSlvgs+cTepV/nt/rDxjk7Yktvh7zEfm5sCdTVjtK5Mb6H+pB+GIL+OGmOg/58D+KPNFTP4xMYY1K+BjaJ+1zbXzS0UWyOjX06hbW5dArGNXEB/SXXLWQuq3ZUyFqyJyBfDKVN18G3O2VID+2fOkE9Bl1lrr9or/Rfbb0FaWd+p8/3Onuoiyrwpp+QWW3sfdJm6tIVnr5OBVn0sXNpHTKFzGHaeW6M6iGG6Qf8il1p0/iWtLXvoTy+VH8cV18r6MO3Nuaoo644kJExs5e3Fekv5JITeb0eNm3pF3uRNiU3foihvK19cQn8IIse8vf6UeMTXnIqlLGZDse5Dvp6iSfqwR4U+dKK6odjSHx6PecBP9gpZU/6/ly84ru0+hxblVV8+OGH47p763V4xBFHHLEFu57kyiD6t4YBs/2C2QZPm07tV0+/hmTheOcN6XnBd+4b6Nsvq3cuVHPOnim9jb/Rkl0mgbXJI1iqQ04mlinwY85W2GIvHcjEtFRH2Vw5RM+cvcrY20/wgXJ6pDZm3n7n3ZP3rlwZ6n918ulnnx5oWNzbsPHu/42bN0dei2qyY4N2NOG++dZbJ3/95q/jpo5Jmf3R8+Xgr82Xdwc9H3zwwcmNGzfGX1ptOtn0spHk3MYN3iA64Pd/+MP4CsjTly7dlp8YpT95cvHDDz86uXLl/bGOTa6AnOvDouAvb7452nDp6UuDL4fFA1muD9cJH+WLn7pv/OlPo/2vvfbqbZ8Dx24W3n333fH7CB9/8snJZ0PMvhjybBzy9bMhxSduKEhbv3/16slbb719cm2Is80nr4VAfFeHHqTue+9dcZs3blbxUz2kP7zDjsF/cf18iMftdhzaWR57xPvroe6TTzwxyoyevj8lvhXy5vLJIiNyar3+WB1pTyAuYp/zHum7ynubA+XsgTk5QFZsmUJiC0tyILLmwB4y5uQoTwynwI7EZg5rOiA+TdVJ2ZQd0a9sqX2C1CUnsqr8pKmXNOS8L6t1IqvSEmKvlD3SHPMnaY4rhTfX756bi632BerFv+jdA7y9j1sgttXXLUh7AL7aN+PzFnmtTfUvae0HiV2rl+P4RXSO8wpipXUcZFfQTZe0+rQGPGLS7Fkem1LXcY8p25NXfdMfHafPTvFVtPg1vXP2zaG1x53X8xyiR326kue4UsojW50K/mS9RGd/bcoPQWSkfo/YZN6kV72tsVtC1V9t0D5VDzqPnh700JE1Ua+j2gNn0Y2XDxn7zuqH+rEn50HahQ5pNgn7NmRH2m4KZMa+njd+IMfqJC5wlthMITbygw1TtswBD5tS33nsrWhrZpvUF2PzEUcccQTcvRr5DsHEYaPAzbeP1Xtc36TSPsppg6FNyP2AelaYNIjKwC1FFUu6tkw6F2HrFj1rdS5qgrwobLXnm28Of/XLpoeNIU8IhWxaPTj0iStXrpy888674yYJ2TXu+pWNFJsq35zqTXuDJ49sAl15/8r4ixa5zz///PhU1iMPP3xyc5iw333vvZOrVz8Y6+OtRJ9NGjq+GRYMc1Dvyy9tnrVvz1WwymabjZ6PP/5k3JhzDVQ0m6O3bV55issGlw25GtPYBlevXj158823xnoPD4uby4Nfzz3/3PhUm41D5TanlJOR6yD8X3z+xfiE1kcffTRuNlrgVPm1rvh99vlnJ1992Rb+qYdYpx0/H+jBwY472nI4fuzxxwaek5OPPvxosPfNMRZZTJGFsigLadukymtZJXyRMUUV8eU8uAgZsFXOWj0+LtVJDJbqbLFlix7la7LmyvGjfpwOlvRHbyhwnJuLSuaeSn2+43qtVJlLiA9Ivwylr+rLlVxTIee1T9d+HdlQr8ktwJeYxhcU/0J87ssc7wFdkbEH8W0PX+Xp+dZiJSvZyuMv6r+JSFZtS0+g3/nqYdM1heiJroqpPKjyzhIPdvc+VUoZ9LZHX3xNP639Ek9or33RF/1bET76eqq+5ToOQfLrtR1ecvnEt+prbE1+fI//PVIfyO0RfbEDqq7zgpzIqr7SWcsuCuSKa3ypOlD6TnxO++xBeNNeZ/VD/cpbZVY/pLFbGsSO1JlCfKaj8kLljx9pe/KqPedBZMWP+LwFiVGN7Zw9Vc8WkIPUD3nQwdOZc6TOeeNxxBFHfLewb4b4lsLgbtPg+vWb44aXQdVGl7/I+Nhjj4y/QmRQPC8sRN149zcSJoAt8i9qkF2Ts0VPnXzmsCQn/Fvq3A8cdLWP0f7oRz86+dUvf3mgX/3y5De//tXJf/kv/3By+fKlk2uffDxu+tgo7X0gq1qu3CSp7d99953xCasnnnjy5JeD3F8PMn/2s5+e/OIXPx91vPTiC+Pk/uc//3ncyILzTLDNrak4Wvy1hYdNtVuf3iqLoboA0Pfba4Q2n+baRL4Npf/84xsnPxj4Xn311dGfX/3yFyc//9nPRj9/8YtfjK9OfvDBhydX3n9/7P903LGgOk3cuL3z9jvjq5+5PkJzGOM+UF3UWbxcfuby7Xb89a9+NdryD7/5zXhsg9FG35///Je7Xn2b8lXemh3BFH+wVFaxpidyttTbYvNFYU3XWp/eEp+1cXMtNlvboAd5Pa88dLhuGunbuRlRbmzJwtlTkkieOlmoozXQv0Rik5sK19m44Tv0b2TMco5ycxPCuwXRA3PxhcQlFNS8xCmpeKAaC/7I24u1PjKHs/DhqTGpVPPW2re1Rdu8au2Wv+5nvdDK6ILIXkN0VzK2V5rDWlv3civh69tXX09/D/jD7/jVo9owhzneJVSZ7F1C9SvnfEpafdNXc23X/hxeel179dp0XUqdZ22Y6zK+kbEV8a3niQ+51mILHWsx3gMyEZliQmd8ukg9iT9fHItfryM+iqs66X+Ot0A99RFdkXUeP2p80j/SJo75wJeqo/qq7hTU15bs66+J8PMflLNBmrilfE98euDT/8kgM7QH/Oh5puyxprSeps96j872ds40JcbIPOxtAT9gv/DC85P07LPtsyBHHHHE9wvbZ9vvAAzyvkP0ySe+43NjHFxtdj399JMjGUDPgiwezzEXbsZ5Jtw9uF96wKS2NNFusWWtTl9OnwlQn8jknMWCSfH1118/efzxJ06u37g+vr64ZF+Fp5f0LU9svfbqqyfPPfvsqJt8qf720ksvnbz66ivjk0U2nyw87g3Etd1EWlj7pkF0cUe/zSuM8n2/69NPbw3+H64DZSE+eEpL3VdeefnkxZdeHGL0+FgvseOv2FkwjE+QffTRHf6jHw42tevu6fG7ZX98409jLJQF5NXzYCoPDFTaKO2I2PzUU0+O9vhOmKfZ8jTX/ehz30Xs8Sltfq/AFrTUVilfwlpbz0H/CZ+5AWXzqj0NfNjI0t/VvyjwS3z1ZzcorrlsYDmW51g5pG5idhGIDbDmmzipIw65uciNRm6kYqMbs/hSb/SVn8X2s/obvj19A0/li6/6gXRNlvLwb/FX/fZB+WVQGzorql/Vj5yjdnN55wZPkPZNf0XaV15t397nqmsNeGPLVtAL9XqeQuSqx08E0lzv8Vmeeuwhn5/8tYnFV/nS2r97v6ewx681pJ3oTTtssWEPErOLtHsK6Xf0rPki3uqoiwdtAR3ipV0j4yKQ/sHezCNsS//o/ah2zAGP8XMqBmT3OnINQOYP5enLexEdiVX6+L3EY489Om5GvfDCiycvvvjiycsvv7xALw11Xhg3sJ577tmTZ565PG6UzYE/4iA94ogjvj+4uFX7twx+Mb127cZIFia+i/HUU0+cXLr01LCgOXxcdh+WFxAmpHs9iGbSux+D9dQEW7FWDhch47ygA9VFuG9FWRzJ8z2nNYg38qSgzwZYELfX5Q6yQxYHLzz//Mkrr75y8tdT2WvtpVyfNBFLp+qnzkiOB+KDjZ7By5MPPrg6ftug1m1yfjA+TeWpMov5J59QvyE288EiBr/XOZ94/IkxVSYf3Y7d4LfNM68uWojR0dvLjycef3z8IL7Np3fffW+8Dvt6ezEVb68le53SU2g2uT0lcRGgZw0XUUf51ris1dtiz1bErjmdypf0pVw/nMOW8iUbppD65Lo+ckOh7/vFFznOIj48jvfqmkN8R/qoGxHXimsglE0CNxDqpK4UcgPr2uPHvVikRxffa7zExhgnThmTgC1sZjve2F/HhyUoP4sPaZs9iK49fL39te1y88hX+XvBDn6IpxiLr6cStpi3EtZNiG9sSBujXB9IHT6mjRFfawz7GPXoy/e0QeXd025pjxrj9OVxrj695utGlnrq05l+nWs0aa7RtLm6sXGvfWfhiz62BvjZz0dlsS/y9yKxklbQIx+Rnb6QvD1+LIEvkRdf1pD2ij1kLKHWSV/pIcbq6CM13mtIG7EpMXE81SaJ3Zx89V1/+l8PsrWR/gtL7U4GUpa+shVso0OqzemYi9lezPWZ6oMqM9U2wUMO3rTwuRDfs/XNV6nr+aL8OOKII74b2D6Sf8dg0GwTxpfDzX37K3hu8g2yfjFAWwb+uUG5R/TNIeVr8tbkbMUWPbDVvzWcV84We8+qAx8yaSPHNkO+Gibv8S9mDv1gLebR7RtZJsqHTm8QIPJzrF9ZVHuV0SuTFtfyozt1g5ThQ46nwEa6pSMNeXgtYjyqbWHkY+95RRKUW+zIt1jxa9cDw43VFMj22q9FmIUeW+RlIRUaywffyfb9LXk9eMiPV155ZZTl1UaLDjbiQ3NYKoPY8f9n7z/bLjnOPLHzwJsCCt4DhGHTe98kp92MplvXzuiNdmdX+0W0L0a6pqXvsrvXSprRGGl6pPHT076bngRIgCAAwruCqYKl2fxl1r+eu6LSnec5VQTJ8y/ciMyI20dkZGY8mXmSC5BvcQ4XZcNHtJf0LLUHu9LzXsIan8f6tSLtU7rST3O29OFc+5gN4yrHi7GY48Y4y40sys2sNvJklC1Bu78W/MsxkvFnjIdyI6ZNGUpuWorO6OOPGNUlZuUSEktkED3ygeqNfuWvsdSbKGXr+1gcSyCTftgGa/VX4E9cazFmJ3UtTSE5T549OeuPAvKffCfHXl0ccrJdPsYgztrftZ9jm9/KA/sHT2mkj9s41QX25xCZFmv6ocrycYq/xpkxbVtdYq7HPoghMRvXOU4Tr1KbMhR/KkHKpXimsI1ctSs+JDZxqU/fhecwSKz8Sr5sy232YycLXerllz9HQfqI/blFmxZ48CL+ZByM5TZt+NgQC3l1AR/EEj+yv6av8OBlhzyy38qzh0f9GBIT+7YrYiMx4hEPGkN0IciYWYoHT3yMjikbh8Gc/TbmwL3b8N3ZE/0PJ/XfhH1hmvyhNgvV6e/0+R577PHrhaOdoX4J4Nc6cuJ4663hSQ9znZOFi0+T+hwWzgm/1Fhzwlk6KcIaniXsQsdZ6Px3YgO6Q8aDV+icLH/SjYn8hTd8LdRU+TwldEl3U2JxDOQq5IJA6ULhqtM33JD6CvvGJcrFBLLN9/4EffoipaK3dXob+OVj7PD6a6/1FwUQn197/bV+4cvCnEWuqddjuGeByAXO8ITBQT6q79otDnbaO3+n/+rq2OKXR8/FdeKVE/2roVB1HxV0yTcb7/5kuPhL7EfFnI7kZBd22rExBjxHtbXGThB7UzbXxL/G57Y9NodxNtxsIHN2bhQqpb3yhqLrKBADyrFZj8/+GD19EZ02hDf8Sr4kX0uIraojeRRjiM66n3ykLfEH0Vv1xyd8ttu2tEPdBvvb5jY6Dit3IcDWYfzEi3xknhgd8jh8fyu5D9Wb9PV5jI3a97XPq57aj7U/8aSu8oRapC625zClYy1aW4lTjDn+2zlAO7nEFUp+0dwxWmXQEsK3Jh8V0T0nk5hD4VUmbvWQONb4PAfyyUPNtxKqHXzyWHnjz7Ygm75Lf9hei8jFt+irOcsY0Z7+DkHyGZnanvq0jUEbPnog4yz+qI8f1bcWbSwVsRH58CWGMeBDdPEHlnyIDSXdbCQH5xuuWV9//WR/fRjyaRB06tSwaDWQPx6d/YeklpIbsYf22GOPX0/8yi9yBeY5k59J0mTpQtNfV9c+0QV0HHXC3MUJY40PSzy7mPi38WMu7rQppwhyEm4pJ+KeryMm3+luPj099MIZevH0o8vPbZ5++un+W1IWt6677nj/3alqp0Wt706ZfRl+8aFcGOUEm+1Q6sKPnJD9yuPTzzzT/9LjWdT/euML/Xe28C7BLx+K4+TJU/3H9F3YxEe/cuhm3K9NXnPNNf1rjhXxp4+uKy+6eDwXiVe55jt1+Bxfd991V/99LhcxL7607mmuObT5oOeSbgyod8M451PFkv3WzmGxpCftczlZ68tavjW5p2uOr/o9hrl2dSHHb47tXIgrQ9qU9Qa3PfaPCr6Gxo7f3Lxke2qBKzFX0HVYP8nSH5/oT+w1D5WS16DGVWOJ3xXV/8hN+Z22beKa0zcF/OR21ddrsW1sEB/5O5brLHhpH6CUk4NLsdg1x9KXfo3ulJVqbuhu+3qwPYzP8K0B/vhabcyhygTxMbAfUo8SIyhz/LekLX4kzsRmP/Eqc4za14aqb9mOvjWo8tvIBWNxj8UZSk7CR7bGtAskd8rYAXZQjTm5rbzb5AFvtZE4qo21IBN/ohclr6jNF5nIhQe0JZ/aILrG4lOnLX0UP2Kr5ic8Y3ogsrEbJCbyyvDN5YqdEL74RD7U+oE3PsoBfiVedVN+b4spPT4DcrDQNZBr33xnNv6k7/bYY4891uDXZpGrIn8NgOFVguHVqwq7575CcP4nVxM4X6ZOBpngd3XSWcKYndTV8igUHTkxV8pJtq0L5eQfPWAB04nx6aef2Tz66I82P/zhox39cPPwww9vvv+DH2x+/OMn+0URH7m0OESHi4dcmFTYy8VP31aaw6tE9SSc/Urqgp//7Kf9id33Avwq4GOPP34WPf74E5tnn322/4tWvus1B4tX119//eZnXez9k1tvvdXXu8j3jQKmPbV2+WXnjvXzCbZ8M8wvTuqnfKx+DjVPczg7jrr93rsQ2kXOxXQh+86YnbOXHE/xpN4xaztUj2XHnjqLV3nNCNXFrOipGKur4NsSBTn2XUhn8SpkQdZcYjs3C2PzxBSqPfEuITlqibz+YFtJV81N2pXVz/CnrYW61MdWRWy19UBurH4OUzKxPUVB3V6DGt9aVJk1fdaCqMWsKbtnx6Vvz43f02DD+S3kWDhY8KC7HbPp86m+htQPttfhKDJBjU0MGb/iQlnARi2Pkr6M68TruMyxKe4Ar32yaxHf1oB+NCWT+paAXBt7jd+2tlDyUBH7aNegkw8gh2jMjnp9oS2+JsYpJA/iYUOZvjNmDws+ZFzU3CZ/GTetDXI5VpS1nZ/24298D9o4xMA+XfEH4dOveKaQXLb+xUbioHcuV/ExfYEXkeMbG9EXnsjxUR3d+CKLyKDwnw+Y4/bYY489do3tr+B+RWChyyKDb2IcO+aVtSuOPImTP58ngm3gxHZUjMWSutpWT5xO+qFctGW7fisnN7I5uSZ3rU0n3XrCdQLOxS1yE5oLpT7mjvy6H73XHT/eP0GELALR7X19v8TykY98pP9eFn/Y2EW+Ktp42rguuviSbtxd3f+C4V133TlKXvM7fu21He/yYXrFFVf2H7v3dJoYX3rxxT4nXsuUp+PXXtP/AmHvxtmunHfIrVj8Co6+eurJp/pfqDxsznfVV2v1tH1XMdcWbOPvrmwdVU+Ad4p/Lq7I5eLYHOCYzxwQcpzCLi6i+VPni8wV5ghP73plF9nPjYKyXciKfHiOCn7RJ9Y1McpF5s06V2aepCsx8Dm+qz8M5uKc6+PIHbXfgpxH6lhJ3IfFmuOhBZm5uHcBf0CzkJUFLE+Vi3f4dtfBkyX6VN/6FiTK+NR2GB+rzDY5mRsjY2h9Y0ucY9/MU6/vQWxk2RNrjtuc5zPO2/hto8RUt+eQuLYdH8GU3NxYJqNOWz2mxSu+zFfIsa0+4C9+csnZLhCdfITYrbG2iM98Ek9imYI2+uWC7+nLORvbIPmjO2MqdWPgL2Q8tRBT/KOr5tu2WJR42DhMHOzW81FF8sWGdnbic4vknc/Zbv3Rp3TQV4+59J229GegLjJTtncBT7LOjZ099thjj8Ngd2fJX0J4msv73u+++5PuxOvkMNQrt51wnVDQktxS+2FOlHNgDzlJhZysQk6iISe7XIC6GLXvZJgLUoSvXpwFTow5ETtRIifV3IApc+HmpI7STkbckcuJFdGZ3K5G55YPo99///2bj33so5uPf/xjm4985MObu++5u3+aySPQbiYgPtcT+2FRcyw3Nc+pD7TLp1f5Huj8vP+++84idffcfXf/dFbN8xSwXH31sc2NN9zY2blk89TTz/SvaD719NN97rLQV33YFkt+sNPzNGxyKwd++vm2227rnzL7wcOP9GNgq36dAB2eYGM7ptfk7L0C/q/Nw5o+uJDgj77NPOH48tpsvnVnjBtz5o0cB4ftm76fu7GUuSU3g26Cleozv2TeqXNIUH3YxXG/BuzzKXMnaudc29qB3+Kpc6V4Mj8mF5BYat1aVJmpvpnqL7Jr+xIf/eK2LfaxuPmSuPVljRvW2gv4CNvIRQbIbWszyHGRWL267Y9p9uUC9KXvIIr7nXcOPpRsnx/Vl12g9vU2INfmwT49iVE/ZhFL7BXJY/pXv+rfHL85htWnr2Ft/LWfE9uaGNu+Xgty+M/u34O5L+NaGz78Ys+xa3z7Y1SNu+376Ef2kzN8YqNb21FR47DNt/i5BHz8UibesbwbD3LCjvjqMX0+MRZD4lXyo/Ko4z9fk4f0iXpxILHi1dbqAHkIzxjw060/W1QfYiPHBRn1FXjiU3zJGGpRjy96jFWyqSfXQh27IK6jgK9tTvh5/Pi1vR977LHHHrvEdlc6v5LI4pRUHO5idhuMnXha5ETgRBfKydXJGalzwgk5weUiA2kPL7noywmGHygnsJzMnSSRk55Su1Jb2rOdE190RV+2K9oTW4uWv8VS+zno7PlLeXySA08y3XzzTf0rgH6hRQzJy1r4ZUKRJGdAR+Kr2++8I4/DXxHnbCRflYLTqlYB7/Hrjm+uv/66zu7bm+dfeL67UHun//i7i5nerxmFjgHjxdONclP9APt0iPvdrt3CkicSEu8c9IEP8XuK7lh3I6AP+m+FdfkZs7OE5Dm2jdf+mLh8/ZMfS3bW+AFL8e9Kzy6xjS28mXvqfOMiOXNNyqPGIFfIeMl8U+ecerGPJ/MNrD2O+Xihc803+cs+iKHGmDgT09K4mWpfm4dg2/xVVJnE2Y4VZD+84quxK9fEfZh+O0xsrQ9jsvGljVfpvHPZZeLlK13iPYg1i1rVTrV3vlDtHSaX+MUqzlxv5Joj/Uu/2FALdQc5OFiobWM/jI9kWj3miiVErrVlu+3bxG3eU1d5bIuljmuLJCjXUih5qbbGQC97yWlyBrEB/ECHBT/Ii4Gd6uM2iBw9ocC2WABPjWWXSD/FhjJ1FXKKWh/Sn2TEU8eTbfzpF7CPKh9oF/NcH/NtbHzGh9hIrtgIqdOeOJJrPqsf86kifgN7tvmDppB2euPbGtR4HDu2D4PoEav+ocsfDHxy5JZbbj6L9thjjz2Cw804v0IYzgUeRx5OSDkvDScUW8PFjwUA38TwKoGJNpNtKCe1OhmP8WizbdKvFB7tkVdGZ3yqJ6N6csqJq+7Xst1eQ9VeratU0e6Duvg/hTFdY5jTE/nKYzu6kSeZbr3llv4E6Xtdwy9tnnuBO4boIOv1QR+2d5ESWZS+kycf0Xz00Uf7D91bNFrCWI4PAzF6ast4tZD30+6C6NZbbznzcf058P3qq67ux4mnrZQ1rsTpYsrFu2Mjf1Vc8le7MX382uPdhcgtnZ5N3wdvvPlGb2ct4kMlpv1F3HHEH3bC+15AcjPlT83dks+7jil9W+cqeczNnLbUpT1Ehj+VliBWlLGu73Mhr3RM5abQfggvzB0j7f4U4uuYjl2CjeRVHsWIEkNL8WetX2TavJPLsboW9MCUTHyJrTpe7CuND3XaoMaF2tgTY7sfW7vCYfS1fuQYSJyJNeMfb41RXY0r27WutWGb3IXAmC374qx9m3kAJVb12QbxOD4drzlmU46hxo7GEP9CaxF9ZGzzbQ7VBmpjTl8nZrmpupWojT3b7ZiPDOQ4GQNb7OKJfvoiS4/95Jh/iG/bIDGzR3d8jp21wM8nfirpq1RjYaPmYReofUe3GGosbX7woFqn5Cs/o6OFtsikT/BW8CF6lhDbQXxgg3xiqDbie+LCbxuRScxoCuzgrXKhObS2W/9bJJ4cQ2P8dDnfKz3N5Y+gB3RDv4iFUucPuP5om8+Q1NefQ3vssccewa/dIpeJNpP8cEJxwTZcvFx9tcfNQ1ef2R4eQ1cevMLXUj1B1Mk8JxKU/ZRjVNtyQmm3EahzUhujKtfKhnaFsZPX+cKcram2xKq/jx+/bnPzTTdvXnnVB9Bf7i9WyK2N4epuLBgzb7/19vBR+E53xhKixyPoPijvlxOHXM9fbAdtXx0Gl3Vj8dprr93c2F0g/OynP+svCDzB5hXGKZ2xJy6LZLb9dLOFLPG0F0Difuftd/qLF8fJGtApNk84+DbXrbfcunn95Ov9r0G6mOs8OM05j/iTkl4LXK++8mp/geOi5+KuH9Svwdp+Pyzix/m0Q3el9FcoYzOU+lx8pmyp8oZiYw5iTn9nPrKtn1FuECrhV9Y5bJtjIXxLvi217wLylPyxx6/kQpm4joqxeNfkoAJ/fCEXSn+LAbKPop9c7aPsp26qL9FhcFjZxDSGGq9YM/btp9129X2MxDcWJxpD7KKgbp8PxB6faryO/zoXZDvHf2RAmT5tj+Ha1+iwqHnbJidjMrbFUOOtcSI84UvMQfq1xmz+Spwtj+3qf4u0jcWlLj4q8UVvqy9t/LGduMb0jgHfGjvboPojh/HJtrxkjCRvu0DNWY2j9knND1/Cl/r0O11pq1AfHhAH/TWO5DP6phC5+K2E7KeOD7HTgo8ptStR5NI+Bvr5GF5jOfX8jj9TiE18+MdiTRs7NZ4p3+K/eyv3WsP9Vu6/lAOlLa9946/2/WptflBsjz322AOmZ+P3EEySlXIyyEkFuXk+m3IRM2z7BlP2sz2UTkqDXhNnnUgzmSLf7EI5QaAgk3ROYKnLfiZ4ZN/Jq6XaPkaxgbZB9bOCnjaOFmtsbevPYXFUO5HX37fcclO//8qJVzZvvPlmv73mBA9XHzu2uerKq/pFGb9a6APq+s8JVv95OsxreC+++FI/Rn1TS8nGUgza09eHATkxXHnFFZubbr5pc/PNN/ffwLqs/0XF00wTIMtPf01zbFjIeq0jC3bi0u4VRfGeeOWVzU9/9tPNNdcc6/Ox1t/wOb58n8ux5LVK+WvXuNq++GmXlxwnOSb8BfCUj+y/9OLmjTdO9Qt6Yr94RT/Ckt/al44RWBN/1RGdlWp9Lh5bCl/mvyWq82NI32qjz7a68Ld2liDuSukXlPkspE7/tQtcaYM5u7ExB+1rfQ+25Z8CPSg5RJC4E2NFZMZk5wgvtPEmP7VuDLGHqj6oNrKd+srHVvoO1X7WFl/GoK3VtwZr4xsDmRpTKHVtO9QYEmMdtzXeijE7LVV7SrB9VERvdIdyjKO02868UNtATG3M6hJ3cjAWP4zVxe4SIruWf4wv8YRqnHU7+WdT2cac+SplYq5xr/ExIIPavqaj9hOe5Dp2WlQe8pFd8id25ADvkp1tUHXFn7Z+V2hjTv/ERs1PYlYi/Yc/+wi/uuojvdrkqsopg/A4n9qeQmQRVN+V6Y/wTeUq9mpOySunZIBMclB9qfmJP1Ognywig7fyx7ccY0D/XDzRE+DL8TZ88iM/MjV8h3OKXKt6g2KPPfbYI7jkv/1v/19/eHp7Egdz0/QECpnwpmhYTDqYGJfI0ycm3csuG0qTZl20ysKT7dCwP9Snbdj2HYWDCxzbJtdKmbxRTiAhE2/dzwkiJ4nw8HtqQtcmDm1j7ZDYYYonJwU2pxA9c3bogSVf5GMM2sQDeKb0VJ4xxM6UPMQWnpZPm1i0O9FZhHGS9FF39ZGJDossfnXQq3KezPJXImMifniK6cTLL/f1HpU23uL75bZ/7hdx3tm80tl5/eTJTmZ4tNyHZL0i+MKLL23e/cm7/ULOHXfc3uskH/18eeqpp3tf/CKi8Vrj4jOi8/XXT/YLOdddd7xfxAlPp2jzZuc/H+i8q4tVGzn++lVGrwVee+01Pfsgd9Hmrbff6mX8sui9977vTH6AP44TFwyvvfrq5o1Tb2ze7i4u+P6TdztfTr6+efzxJzavvf7a5tixY/0vJnpijHxsK1+z+NddbHiqyquS6jI++CrXFpDf6uy83OXZz+1bDETaIDnT/sYbb3b7cnJRf7Gjj+k/ceKV/uP6z7/wwubSLuYH7r+v7zOywdQxgif+oingCchMUWKbotjKdtsm97UtdfKhzLZ6ZaW0I+1zFJvbos2Rvgklh445lPmwtvNzbr7ie3jHEL+X2sU4xQN4kifAO+fXFGKvUvpDHIm/9SW86YtaVmr7kt7IInqV+GxXO/EBqkwlOlMieoLoQ+nLGk+o6gtqXaUWfIT4uQb8DNgPxuyFEl+tq7m1n3jSbwjSDubiNcBPDpRsharNqhvYV1fzoX0tVb2IPTlOmW1t0Z2Ya9xo7BhGziuQfM2BfvaUFbG5hMjGlu2WasyJLWQ/lLqAvsSWa7XodO5TH7tziN7wr0X8y5hiN77qJ7q08bH6VqkCDx/Sx6kbA1n2XXNA+nob/5dAF+IP1DzvCuJIzsQjjvYYrXnCk9ghPvJNLpLvivAb90rt7NQ44gcd1V4Ldly71FzTmf5qc6WcQtvH9KA2/gq+ubYLHz9iw3Z8UUKNcQzakx9l9ulIvhIL0q4NtXlKTpOb/o+X3fWda1TX1K7/lOqG/XHyRD9de+yxxx7BqkWuAcOk181B58CcZVKzKKUcFpOGE3Z9cmp4Ump4OipPSh07dvWZp6VCFqWUg1x7I2dSHeyaRDO5KjN5txSYAMmEyCCgW3tkajvKxGxb2xgy4U+1a8MTnVOotsYw5PrcD2dWaIc5O0s8/FiKp56cp/TILSzlZao9oIeN1k7ktVsAefXVVzueTb/ApD78lc8vajppekLI2PSaXngscr3akbGZhZea62uOHeu/XWW8nXrj1OaFF1/oF1teevnlXqfx63W8++67r+ev/tJv/9nnnu0vjG666aa+rHHxEfX6T5/svYJ47iLXm72vl15yaR8rkGMj2zkmOoF+v1/k6vLjdcv3ve+evq7ate1bCMq3u+Ph1Vde6RfuLCRZcPpZVy8n99x91+bGG2/s5dL3sespsLc6n6/sjm9Pk2mrNhAZMb3y6mt927XHr91c38Un19GFx9Nyb3Q5eKuL1eKcxckXO3rppZf72N/tLojI3nfv+3pbyW8wN+Za3jHwNXEps584kPGkTpm5SllprC4U+VDVXevRhYTcJH9K48h4Gpsn+VaPkQpt4pxqB7HSM9UfNfYxnrTTM9XnEF/wAV1zfk2BvH4LxW4u2KeQcRD7ARl1yWtL0Z/tzBm2lbEpPjbwakMZY7n5SK7IRKd29bbVoeicAn5EJ8zxx2bAXuxvg9istlJHZygx13gTa6XE2foeucRm3K8BPTWHrb3a1trmr3aIzy3aOJF+RWJO3AhvdFd/1Imr9an6MgY6IbxzSO6UNRZy5JcQ/4GMbXWJEbUx174mIy79VqnGmzjIRHZtP+ONT9G1BrFFjh+QuJT8iZ+2p0BPBV6UPEDrU/w1d4DFhORgl0if8INu5a7t0K//xWTOHeu35BqvxUsYyw/ZMd+SK3r0x9jcXv2YAhnXpVXWNmIDARtTvgTs8EnfZbvNc4vwsZOx1fKpwxd/6BvTVRE/2SWjZEc9O6jqCF/NFbsIXn75RH9N53q3+klfbO2xxx57bIOLXnnl1Z+bdM4mE2Mu8g7qAxOO/Uxgw/xz9gQOmXzDFx213aTn5HEYxI9MypksW2QCHrNDXpu/crR/aanAg7fG02LODpB3UszkPYY18azJGx40FQ/wZY2dqRMvX53UgC9TMbkIIE/PGBIz+SkdQM9U7nKx4WLGIgseC0h01xzgUxc+1Vcfu7pfuAqP70R5/e2yLjaLX5ec7tPkNP0jHk86vfzSS/3iz6Vd/RVXXtn/eqC8sJWY8CdOeOGFFzpdl/RPaCWu+ImHHdsWsk6demPj+wQWhRK7j9+/3V04edLLzz16IkwbWXYCcXpSyqKzNh/M98qhsX7brbf2POn/jAfydIkZryfJgE95JRAv4I9P8Tt/WcNjwSwXO0i7eG2z080/nS9v98efp8PiQ+LXR/6Sd+53zRxLw0WoJ/PI0Vf9oSNjLjmpZbZhrH0t8LLbYhsdvwjEZ/myPUbQHr+pD/R7P7a6MTUGedBP2lvZIP0eX1rQoT+Vc/MIX43bKTvAF/4Ce7kBakFftRuiO2WO2dhr7UYeZb+VCfikbiwHOWbI0gH45S386kNyFB3KVl+Q+uSELrKZEypiF7KtrH63qHazrazxrAE7yWO1TdcYVST36sd8HAMZcfETzMOt3l1CLLkGgcTZUov4VMvQGNTTk/zr6+SkysRe9SP9TGbqGAzwG5uZlyGy7XVL9FdiSzkGeuKrkv+pExef2ahjK/xjwM9PNs0Fa8cIfsfNWExTSGzkyLCNAj4vHRM19lrSnViU9GQu1JYYQX3ytkvIf/ouNsRqP+PmqDbFUecP1OpMLlBsquMbSv1Uv2l3PJKLjTouaj7xTiF90I6p+McGsLOUnxoT4Kt9mLxXHXjrMYG/9SWoMdnO/dAS8GfM0c0O+20c/MBHN2jHy1/wiY+pa4g99thjj8Pgou7irZ+JDiYkFxnDxJXJJ5NShckq7e1kBmRMetrqRFzBBjrqxMYX+qcmZH6wM3ZC4yfyalUm3DXxjGEpHjq0z51o4CjxBHgQHWPxgJOOtvRjiyV/tecCRsxTMR3VTpALyjEe8rEjZjrTXzUH+LSh5De5Co+SjfDZl+vstyfqjBl1va7Ohu9C1TbQHvtjPrJpG0/47Eceb+QQJBcWpS0E8Q1f4ObMrzuq91QkWJD7eSeXccZH+tikn3xs2Pe0W8fY1+MJ4m9yFb/VRQ9Kn6mPDvspUXgBX+zwvV3gSuzKVi5leFKX/Tms4XkvIDFBu133kx91+iAIj9IYSFuVrdsZJ/p0DOn3uXmPDvL6egzpb3bGeOhIPDWWCu1uGtyoVv9b5GIb8PE7+lEQP8Z01Tmt9Td+Zlxqj47ot9/KzeUgfdDqIqOs9ersR0fq50B/janmOD7Xsm6zF99aVNu2s5/cGBNtXfSH0q5MXfUv7UG7j7/aWwMy4nLOAU9ijMV3GCSGlvRBbNivqDHVfFS0+3PIeEr+Y09pPwQpyciJ3M9dewA9eI2pGkudA9SHsh9Un+Lj2HhufWSPXTJLPgbsiA3lGnANEh/b7UJ5jcnYU4ayH5+zLb6MT3VTwNtSBb/Ewg594lGHwH5yuksk9xAbIJYcR2LUlr7cFuJiJ7kai4M9fijZqu1powO0Vx7t8qbdtvHAVvVXvXZ8aAp8i3zFmA/2+YC39RnIxK62ylN9T9xsZx+1cU4hMvJsO9f1U3Lix0sG31i8gTEQ/wBfvW/YL3Ltscceu8bIDH1wIWliQyahSqmHut9SULdbzLVdCFT7iftCYBd21ui4EPHsysZR9OhHYxGceOkaG68p1deLFBcF4VeXk3GVhexX3bnwyoWlBaS0pWzl8OGvPEHl4wPexFP1gDZPhLmA8cRW1RMM/EWm05WLktQFqQvR7xcbxYdqTmIr/iFQJhegzIWTMvtKdS5+wh+KvuF15+E7e6H4Um1AZKp8q2+Ozjdq3kLJs+3w5OI9lAtUF5C5CavblaqMMnpTj9hLm22wXWkbrJFJ+1SejyofVL70fcZexo398ISAbCh9UvdD2a++xF4dx1D5sz2FtFW9AVmobVUvRH+1MWevYsq2/UqJrdaFL22Vp+Vt2+q8EB5IHImvxtnWhzc0BvXRfRhU39YAb+JLjHUMZv5KO97qe7ZrTO12i/i4hoL0RXS3Oc126qcQvTVm2y3a9tim25xU57HqQ5234gsKT5D9GuMSqo5t5II27rav08/JB7+BXOIXF6r1a2gM9MuhMv4oIXYS766Q2CG2k1fbzlWQPCUXayHW5LXmq40DX/yIDxXJWWTjd/LJLzZsJw4UqNeOby6G+FdlgTx7dEDGOqpttivSltiVocB2Yk4cyuivvFPAE36gI/lpUW2wm3xNgY7oYScUjNnYY4899jgKLjp16tQ5M59JDc39ZV57JtQ6UVWYALVlwmxhcqQnJ8DDwoUEOybZMcSO9jFfxeOVJ+1TE3VinotHO1tT8VQdyd0YlvJGD56peKD20dSJZylvSzFrpwPP3GP+a+KRN5jiAU9pyO1U/7CjrDrYDcUOmvIVkrfIQeXXTlfaxqAd1bGQOgS1D6uttPMz/LGfsupR+hC+0rfs6A382qPjmM9e76syrU08/Kk82Ya6HbmK8CPtlT8Yq/tlQBtv3U+8ta7lz5ib0pOxi6c9HqvuVn4ObNKLpl63ylh2zEzpxgNj/gP5OpbHsGRHGx5tU3OAdmQ84w+yLV7t5NVVnhxL9Nc2+/QpQ2vAjrmPrWovNthLW4X2qTjTBu0Y0JYYalvqIProUGd/bTz0mF/JmbOQ7RDUfWTO91qyV6B/2vlkkX1gHPRZHL+yO69ecXpxuiI6IXnP3Fa3W+Q4mTrHToE/ZLd5UkAe8zoRe/IZv6r/2a5lqO63SNzZ5mP28bPlCbKhP8bP0YeFHyTx9DpknLA3lXeQD/2IP2MNxmLNvpgqWjv2Q5D69JcyuV8DPpKD9umqOdTY6hhJHFBjBL6RU9bzZo15LM7Elno28dmmQ7vSq/rO637Exh+mjEXXqfm15OQxNirIJ6ZAHufm6MMg/ta+mvIJT+LWjneNL4kluc54aGXDB8lrBVkEyTV/bPNHGRtkW/8ib94nOwWy8tzar3HYDl98mWqLXfX8bPW2EFONI7QN2KKnnuNQ8qFdGxvqxuIN8IL5JtuJQ44D33w13mvO99hjjz2OgslFLpNXnYBa4IGcHMaQE8jU5McGPXN21sBkm4l2DCZWduokXaHdBKydDjGNYRfxrMnb2njomPIVcoKa4lljR0wwFrN2Ovhy1EWu2JryBeYWuYAdWIpHOWfHhaH2KTvpQzGN8SSepbGQeKbGAcTfqdyBdj+1jLdd5KJfmwUu7WzFP0gJ2oNa/8uMudy2qLzZlgfb6efUK5F2edOO0t5iaUzlONLPc2NmG/CNXuPB8Tk2hviOtE35rj3jYUyHNr6Tnxqna+y081FsBuTFIj9pU8a/UEVsKdM/ePhLzn77UeC1cM6oelHiH1sMCObmXW0wNgbEzvfallig5g0v21PjbQxuoMnSkxy3RJ92uv0AxDPPPNP/0IfFrne7eaZHx+cHYvzS6e233db/IIQfqchYlHd66EvOkj80B7GSi8xakEPbLnLpR/bEjNi0D8qxsZcyqLHVsRICMuzRF/jRkeeee67/wY2Tp4bvIu4K99937+buu+/ubSaX8W0M/ONbxmf6D9p4Ibr0d4V6Y4vNOdBJln9r+AP8GWNrj+s2tiyOqa8x1r4O6nbtS7BffY+OxKVdPuq4Qtqcsx955JHuGHuxHwfkbuqOoXvued/mpptu7HmS47HcxJZrjPiV45bcLlDjUYqV7in9iQ2/7eQm/o0hMig2xFGBB7Tj0976gIfd5Dzt+OtCIPCJnepX/Gh5W5Axx7R9Enk+gPb0e1B5bGccqmv9ngI5PspFbCzJzIEu9umgL3HxEanPuBoDfwBvji+Ib1XOh+fl7ij+7rHHHntUnNdFLpOaNpPZGNhAU+1rsWQnJw8T6piv2t2wiCUn6jGYqMlPTeg5yc7lDQ97R8lb4qFjylegh69TPGvs8BfGYtaek93YiT1Yyhs9sTU3Fpxwtc/1D8zFsws76UMxjfHEztJYYCf9gz+IfLYzdmtdtqHW/zpCP6BsQ3Iht7Udso8nuQ1fi6MeI8HSmGInvsyNmW2Q+NjO8TkVY3IwhsSoHMuD+vDMHVfbzkfVbraTa/sV5FDt77pdQUfyre2wi1x0sBE7FTm2UQttZMZyRSeMjQHzm7jbtjEZdXO5HoNzoNyQ45uYkv/k/cSJE/3N949//OTmR4891t+Az9ngsx/vsKByT0cf+tAH+x+vqP0XW6E56DOyfFzirSCH1i5yJWZ5VFbfkouKtKM6JkJrEB+DR3/02OY//sf/2C8k7mpOCN7//vdv/u7f/bub22695Sy/QeyJP7G2MdfYEi8k7sAiS41Ju1jGjosWck/W+Bg7VsbAT2OO3DaLXPhzfPExOUAVNeaxbYgPiN/i1RYbyUfi0lbtaX/uuec3//KP/mjz1JNPbn7S5coPQFk0/r3f+73NBz/4wf6HcmK3zWV0sMUX9u2rxxt/jopqI3EuofUtfxyd8idjgBz9Y+NAG6JzKrbMuaEKNsgmP+aIqiM+0xFoV1+hTjzK1ocqX/u9RWzxKXr4hMb4W+R4i4021sOA33Syn/yry1ias5F+EU8FuXa8nDjxypnxsMcee+yxC4wucjn5mNTaSagCD5qbfDNRZ2JssUZHkBNKPbHYzkmBjik74Rk7wYH2/MVrbtJeG89UO6yJeckOf+nAM3dCoIedw8aT/E7FpM0JDK1Z5OLHWMz0QE7OU3Bi1T4VDzswldu1dvKE1Zid5CO6Yif7ymynj6C2B3X7Vx1tf9ivddlOmWO68tVSX+ufqTEnt3PHPKzhydids6OfYYoHlsauYzG+rL0RXwO+sS2G9uI9WPIN+EbX2DlBDpLLuXPGmJ0cS0rytiFlBTn+o7odWgu65Tt9e9hFrozBMftzc6829WPjJXPY2PyUXLFV9dIHNfdzc9gUcoNUfWMz/f69731v853vfHfzw0cfnZ0/5+Cprk984hObT3/qk5vrr7++r0ue0FI/JAcwd7y1SBzVb3pQdLbbLZL3+Jn9JZ/Xgs0cq/CDhx/e/Nt/++82zz//fL+/S9x+++2b/+rv/71+8XEu3honyliTxzVjQDz1uKaL3Nw8ETgWkH5eww/6jwyb7Q0zH9K/ylCLxJrtmoO1YCNzTPJU7anLPI+3Et+ffvqZzf/2v//v/QIn2+H7g9///c1HP/qRM7+0rK0eB3iSN8h1Gbv8USaf0XsYxAZ7dK0ZC0HiNDb4Q55PbX6TP37SP2aDHjrkbOy8qZ2e6G9jJscPfKAdX56iSt7wBXjCH6gbW6CJf+ZWbWLgS+tHBRlEBpKfOZnqpzyw1fpyFEQ3OyCOpTEkhuS3gl+JqcITwW++ubsf+Nhjjz32OPcMfxpzk9euwIaJ0AQaMiGiWoec7DLJInLRscbXJZ74sgvM6Vnj61os+bvUvjZ3c6jyR8kf2TX+zmEsnujNmMn4MZZQLtbqWNOuzFh0seEpB2R7bHyGMk7rWEXVh9B7FcljKBdMyL6Lk1x05mInlDYXfGOEZ0wudaHYpa/arrQEPHN5XmrfBkt6ltrXxnQY0Juxd1iQnZKP72xUREZ9jgfHR44rx1OOJfV46dHXGQfGhot2Y0eZsZJxEdtjiO3Wr1ZmKq4l0HEY2dgek41vU23QtkWmot1vQUf6JfNf8qRNfez4rt93vvOdzde//o3N4088cc7NyTZwI0PXN7/5re4G/tm+D9kJLSGxruEFfIkTiTNzep3L5QAf3XX81VjrXFXH3y7Bh7Wx7RJiEVNizHxdjzk8CNb62OYn/bENtslHxgeM9bf9jHV86efECLXusP0c3eQz9mJTXWxNQciirrEv+YA31x94+Z/+Sv8qk5dt8lrBBoLkaBvwLf4pk5vqT45J/iaPLfCTQ2P5TD4Sd81fZNmB8IB6Y0ZJXhlUHQE5x0nbxkZyjSe5GtNRoR3V/KCan4rqZ2wkll2hzd9SDBC/WrS6Ar8QPhXjHnvsscdhMPkkF5qbkNsTyBhM7uSnTug5CQAdc5N4nRhbn/ixZIcO4G8L7Xzliwu7o8azlDc8bBzFTmgsnsCJmo4pO8nblI7Y4K+TZ4u08Td/PRqLGw9MtQNd9MSO/Qr7GW8VlU8f25+yAdorT5UPxurey0gsysQXqDMGMv5rbuo2kJvrI2jHd8t71GMxcENiLCyN3Sl/19ox5rQf1Y5yKmZYcyzGljmoRezMxTIGcvqM/cxtbRzJgfqxGIEO9tt5gH7QRo8Ya10Q/1v7sdnarvu1fgrRr4z9wL75qUKu+Qtzc9ccMq+Ra/uV/uhs9cbPMbm5NtDObu0H+2TSh5CxFGhHgba0p6SHHKhjn70HH3po8zd//TebJ37843PGpleojh+/dnPNNddurrpy+JC516t8NPvkyZObN9441fl69qs5vs/1xS9+YfOB3/iNzU033dS31fFXecdQc5CYEl9Laatl8ho7Y3azzZZjB4yTmuNdg3/mvfgy9SSXPrJA7Btq20D0F3XxiOn9D9y/+exnP9vnH8QlL21uWjhm5B5fe0yNIcdZcg9kPT25BDLk+ctWfFIfavdDZJLHyNX9ti4yc/PktqAz+bJNnzy354H4HMLvI9x/+qd/tnniiSc2r3XH0s9+9tPuOLtu86UvfrF/5bd9koucXJFN3dhY1Z6cjvmyBLIoNshuI98i+iA+803e6E1dGwee2setD7VdW5WXq9iwnRiQev6ojy+2ITqyD2TksPWRnFwjyLVM5VkCO9Fhe8xO+lM7/exsY2MNkhNlRcYOahG/En/ANz6SbTGcL94cbdtjjz32OAxGF7kyuU5NYIDHJGbSneJxEjGpTU1adGTipGcM2tGcL/xgZ0rHkh3tuRjZxSLXnK9reNbEk5jmTghrFwqm7AAb/KWnRWKRF360erSnRGxVpD1IXioqD1+WdLT773W08dgfi2mqDyEy8i+HGeugzZhWP6an2q/jKT60vtCDJ3q0V17tdKbddmwow6OciyljqvoH0Z2xa7vlAfrFo5w7RtYuBM/ZSUxjx0hw1EWuueNwDvHPTTFZY6T1YSlGYJsPkY3ebEP6viL7ylD2U9b6w4Jv4hBf/KHTNr/anCbf2pOXbX2gl7ycbJPTjEsYmzO1Q9sGibMuMKiLTGCf3RDEZvZrm1I8xmliYt+Y/ef/4n/bPHb6+1v4tKO77rprc9+9925uvuXmzbXXXLO5vDvfdAy97Kk33ti8/trrm5dPvLw58fKJzfMvvNA/xWVhxjeFPv+5z21uvfWWM+fU5L/NI8QeArHxlUzq2jKgEwXaYwva9hZsOY/C1DiZk98GfGMrORhb5JKvO+64Y3N3l/tburwP/V5jPvCldatPTfe/Sy6+pJe1wFWvaZZyAewZfzC1yFV11DEVaF9a5Ao/efbqHJ62tqxIXeKCxFf9q0hf72Ixk31+83/oo8G+vs15IPrxViLzdueDBa6XXnxpc9Jx1/FfdfXVm9tuu7Xve/M5HdETW7b5jqaQPlTiiz9ziF/pezLJkbY1SLwVrd6qLzZaaK85bXnow6Ot5hkim/jZUEcHXtva4k8QHdoDdWNzQnTwA9hAhwFd9CSmmvfkTT3ftS3147aouWIz+TJvVJs1/sjE5wq8yVkLx93rr58cvf7ZY4899jgMjrTIlRvRKR4TnclvbEIDOkyIMMez5MtaO0r+tlBPB8oFzhjqBeEY4uucL0CP9qPEE1tOGFNoF7nIVJAH7ey17RA7OblV2M8JrY1HW+Vfs/3LArmCKd9r+xRv8q2sebOdsQpKlLEQfS086q2P/Ipi+jWoi1ytvP34ArETH1IP+OhxjERP5av8aVcmPqV240UZnjFkTLU8dKhnN/tjeujHg+aOkaXFp/YYGQMb+I5iR7w57scu8uifiiV5n9KtzeKCvNX5IEiMbGvDD7VMLoO0ge3kJmXNV/Rm/3yAb+bVNnfq5VXc1b6Y1WvXL2hb/5ITsS3ltCL5VLLbInqn2tp4wo9asL00dwR8zoIEXvZfeOGFzf/7//P/7X89Mf6wf/zaazdf/vKX+wWra6+95qx4gQ6/EPfaa69unn/+hc3jjz+2efTRH21uueWWzcc+/rHN/ffd14/J8I8d60BPzRdku+W3n7qMt0pkkjuIvjngySKX+Mf8rPtt2xKqD+LKNQZ6+OFHNv/m3/7bsxa5jh071n/T7JOf+Hj/Xa2alzm/WpBDeOQqfTsnA8mhkkw7tqHqSEzKiixy1fgDdaHqZ4taZzsEGY9TC3FjYE9fi2sqtinUOOJ35heoumwbR61+vJH1xJ0cvTtyPeqHHMRHXrxk5BiM7fBXn1qQ5x+Mjeu63cbT8s/ZqQh/1Q3k6c64ghpHC77jiw+tr9rVtTFpq3HIn/Ehd2LCqx4ln1OI/nacxH5yiyfzzWERnYk7cz8b6sb82AXYkgc26E6/g/NEbKM6Ftu+rEg+pnz1S7Ke5tpjjz322AVmF7kykU9hzY3bnA52nFCU9Iwhk2Ym0jGstYPGTjiJ14Sekyt9LdbagSkeWJu3qXZIXuZOoLGTWMhUJCfaUdorX2Ka0vFeR/yuSAzyO5djEHv4k6fkquZFf+eYQfQaT+rPske23zs3t2A7eqpvlWcM0RV/w89+9aEFfqg+kq16UPRDbhxSh/CQjcwA7QcLMKkXn7qpYx7orPHHH2A/vsRuC7yIrbljpF0IbkEepuwAO/p67oYqY2FKh2MZwdhTDuKdikUb/XN/AfWXf8j8VkEeiTF9lDqUvAfhS07qPvpFgJ/yU+c74Lu8irnW4yWTNn235HubB/t0kBvLqXZtY33Orvax/oxvY201nqoXP8oxhY+eMd+mQN45Q0nOt7i+/vWvb/7oX/2r0xyD3htuuGHzyU98YvM7v/PbZ2JUQnzKfmBM//CHj/ZPoniCKDaCKqct8q2eiow9UNbtlHWbrjypA/bn9AeOLXzsteOo6h8rp/SnPj4gcSd2tn7wgx9s/vW/OXuRy2tqX/rSFzef/cxn+gWv5O0wqLaMG9tzSEzGH9l2DEJ4INsZUxV1nKas21VP9iPDZtqVVXf05BhKX7f6xqBebHjrOaHKtoiuWsZ2/KInx2Da7LdzFZDXHn1jiExK4xOqz9D61kK9eIE/dWxXv/jDb7StjYC+Md22yYqh5qzOx1V3cpMx0OoST/Jd28iQzbGsPfOruox/MSYnU6A3eWhzQZ4+PHRmzB4VVXcF/WKpfhwVbIE8JJ9tv4Pjmk/q+aGMj9FRkby1fVOxX+TaY489donJRa6cbExIU1i7WDOlI3aUcycDk+bcRB472scmT/qRCTgnthbaxDM3Ca+NB46aN0g88R/qNlt42vYgvvw6oO0v+6EgudTX8PrJk/2rNGOLAxddPLzidd3x4/13Z5LrkP3002uvvdZ/Q+N4x+uvrBmvyvC++eab/bc1nMRdwHU91uv3fZprrjnWjwn+hd+Jns6l1zqCyy6/bHPLzTef8ZV9T1/4KXI6x3DFlVf0N01eNWqPITqUr7z6aq/n6quu6n0FYzc8cimneF588aU+TscQf6695trNjTfduLmixAb48Tz11FNd3bnHWQv8cnXzzTf1eZI/tqHqrSCTvp465mEXi1x8kb/cUI1BO/kpHdozng6zyLUUp7FIP552riWrLTlDQXyufs/N1b8o8FkMGZuBevlJTHU7bWIzB1S5FnirLmX4HWvtfF/tjJ0Lku+xPtMf5Mfaqh+1H+y3YyDzz5j9MdDr+KJHbF5P/KN/9X9svvWtb53mGPy+7973bf7gD/6gfyqLfryJ1XbyEl/jb4u0tag66rgLIte2RabKQ93PIld0jNlvkb6iI/HCWFkJYiPjod1vUXV9//s/OOdJruuuu27zla98efO5z372TD9Ve9uAfHRkLI35VIGXDP9tT/UBLMXaIrLKEGTs1IUPZXTW3EJsono8VJmUFdrFpi22qr2K7PojDpBBxkqNV37aHMW3zBuxE5kqP4b4goe/wF921IWgLSvoiS9Avs6fyowRPNpQawOm7FRddTslkjNzVeqiI7mB2EP8TD1EDx38S3vlEYO5Deg1LrQnftv8SD5BXRsPyHX1LSBrfmGffjy7BF9qHOkP9nYJdtInczbw4UnOxEtuClN5q9gvcu2xxx67xJEWuZZuEE14JrScdFqwE1sm0imYSPkxZSeT7JIdfPWip4IP4uHHlK3EM5WT2FBWntgPoie+pq3lOyx2oeN8o/ZTzUPNe82RMvlJP6cNajua6yP9jN/Nw48ee7xfmDn7I77DmMVrXFx11dX9jV0+9pq2jLunn3lm88jDj2ze1/Hceuut/QeY8ehnpfYsWA0+65+u9F+3z7bv2pC9pLPHpu/XPPX005vXXnu9txG8+eYbnd1hQSTHKFzZxXRvZ99CmzavCp04cWLz7e98p1/44u/ZkL/hmLnxhhvOfKMFEp9j4cc/frL/ro62B+6/v29PbvF42uPFF1/cPPvccz1/zHS9wEJ/7Ppuz/XXX3/GX/rl4sEHH+qfbEs//qzT+053fOLLhRzYtxDoWyQWEV0ssY3I0jcGckMuphef2Jm6iAM61tgR59yTVBkL9CTeCmMJz5DTcxe51OOR+1ZeG1lxjOkG7XzkAx3Rp6xInKGqLzJTc+gvEvEt/sdv9fqn5g6FX07s6ztyLfCFpyVITuW+InZhbC5K7ls5IIfG2kBbO67pQ7XO2B7zbQr0klGK79VXX9v803/6Tzc/fPTR0xzD63If++hHNr//+7/f20uua7ztvu1aJncpoY7dll+Z7YqWP1BfbdR9/cUWGf6N6a0gl76COraCdj+8ib8ivCmjTwlsRe77P/jBOd/kahe5qj+tH0tgJ2O75mQOePEg29XmVC7H6iPXluGt+yFjO3mq7fEn+wjU5dgLP4SHrvAG9snlurb6l+38YQYf8aEc5pNsQ2SqHaU6fGC7ndOrDqjbQF94yOm71kalCvxtXeWLPiUbGfvqksv4XuVSToG+Sqmj31xmWwyJLXWh6l9F2hDZmsvI0pdrPu0IL2SOdBxAa6eNS/3BddwAPGzQpd44VVaeXYANfsoZ8Lsdp0dFcp+5JeeTKf3hT3+1+QL1xk/G1Rz2i1x77LHHLjG7yKU0MU3B0xX1wqNFPXmNTW70IxPq3I3T0o1onfSnJtFMxpm062SceJ1A6gkwCG9ykvZWRy2rH5UPWp62/b2IGk+7LS/KUOqDypPc1fZAP8+dVOmAqqdCHhG+qXGr3QUPWJjxCo1fLrr3fff2CygDfr55t5N/6803N6++9lq/0ORJpo9//GNnxhpk22LU97734OaBB+7f3HH77f2iEv+MNzb8VL5x5VfIbrj++s1lXZxdEP2N9YnupG7sW5zyjZVLO5185L+TfY3jzbfe7L9rw66nKG688YZ+MQkuueTi3q4xLH6LXBbW/uZrX+tie9/muuuv21x15cFCXtdTfXyevvLEhpvX++6/b3N9dxOV3PLrsccf37z00sv9IphfQ4O0W5B67tnnNk938V/a2b35pps2x645trnsUq/9vtN/MFe7eN93z939QlcuJvWhp8T6fu7+kx+/rvPkU0/18X/wA7/Rx5mflZbLq6++6nRswxjJeCA7Bu31mB/D0tyS8QRzdsQ1t8glFrGGWmjnK3tjTxXN+aGNvBhqHJFJe3wI8Faf8Cmjv/LCmjh/UeB74uV/9V2d3BrPtV4+Mhe4cZkaA2KeyktuksbmG/r5NNaWfqGrtau+7c8aHyJXz5nqyNQ6fpOfGrct6CAT/a+88urmH//jf9z/qmJgjvzEJz6++YPf//3en6BuBzVPtrOfbZSY4rftxBoCv9ZoMd2TqSdPnezj8jFuuOKK4ZcG+eZpz+PdHGa+7nmKLajHQOzSayHJr0JefdXVmxtuuP7MHwvYf+mll4ZfluzGyNvdvEr+iisu7+297557+tc35a0i/Zay9QPabbb4x679tYtc1cY2SH+zW8cIe242T53yB5WLu/hu7H8kgD1wTnyuO6+93OVlyMfPujn/0u4cc33/UXznuPq9tdqPfDV/PP30M/15w3Hn+KADxO48RpdzkXOGPJPPPE1v1S2O9KVznv50bsJz1513ba7tzrt9rroYnZOefeaZfmz3f0zo5H3H0lPHYnQO5rt8VFuhn/70YDEpY9XTXPy2r91YPXHi5S6PL2xOvXGqGzdv93xy7fyoD2+/7bY+NvXpQ/rtI9svvPDi6X442e97krr/I1rnX8YxOXkZ/DhYfNLmvPfyyyc2zz3/XP+ktfP9wNvNh5ddurmyO26u9weu7pjxBzzX8xlT8QVqLhJziD45fb47Ll96+aXOxtCfXWM3N17WH0euC26++eZ+ro1vYLvGgaJXvV9lfbnT+ULXn/0fCTvdfJHryzr//eGNXqQuPlaiK2Pc+Kh2yChrTEAOst9CfHRFPz3IvpzH9i4hH6E+v6fr2JETdFSb8iAOeuUo+ZoDGfklMwY+8Ret8W+/yLXHHnvsEhd1FxxnZp46CWXyr5NTO0ktLXJl4tM+NcFlYp27EXVyzEklqCegnKS0h6c9Qdnnj5NBUHnSHh1oTEdFu/9eRPKRMsh+YkjMFfaTl6mTlLrc6OViqCIy6aOcoFtoo2dpoQDonBpz7OAzXsbATl3keuSRR3r+D3/oQ/3FZ+9vx+OCmA4LMS90F6svdRdZH//YR/sbmvjBFljk+u53v7d5//sfOLPIRY/2737ve/0vxrj56heBjh07Iy9fFphckIv9mq4tOoEOlD5yUf6Nb3xzc0l3vNx99139hXIQHiUdwwXiy5u//pu/6WOzKGaRqEJ8J0680t/A6Zd77r67fxosudXeL3K9+FIv/4EPnL3I5YLk8U729e6m5/77H9jc2N0cikN8YvOE3HPdDdMz3U2Fi/O77rzzzA0LspDYBdjrotPNk1d0tH3h8587wwdKceFL3yZX9Ziu0O4CbG5M8VfsU+MpdmHODj39TdME5CT9iVpoz0U3f1ue+KFsj6HalvHSUvgAj3hR/LFNBxJnax+0Lc3VvygkTnls5yr1Y3ML3swF2qb61xjSNjZG6FU/Nq/JFYy1pb8gdrOfOCD9E2gj245ZdW3s7NueiqtF+pcecp4m/Z//5/9l8+MnnzzNsennto997GOb//IPfr/PS4A//tdxBWNlqPpNPvEp1fHBYsGzzz67efGll7r9V7rjzFN35If4+aEf3Pxff/11/TzuqVNzVvog9hJbbFlI+M53vtPNgU90efpZ/0SsefzWW2/r47BY8dTTz3R8z/fzzrs/6XLZybvJvvLKqza3dfPaPffcs7n99tvOWuwiW/MQmgN/+Jd+23aRay3iB3v8le/ocBz8yZ/8aW/T/M2X27pz2mc/8+lh8aab81/scmbh5OTJU2fmcIthzm0333Tz5tbbbu3/aOT7a8mzMeiPRc8+92x/PvHHjBPd+Ym8tvgkJsekc5VzhT70K57yrH9rTgP+I4uRzh+PPvrocBx0/z7wGx/Y3Hvfvf2cpf3ll17ePN/15Run3ujPu8Ame9dfd/3m9jtu37z/gff352t+xxYyPthPTIPdoc9i31j15LZtY1c+jRv8/oB1RXfNfOzY1Ztbbr5lc8/77unj80kEOmIHLznn7qeeerq/Ruiq+vH1hc9/vj+XGu+ZkyLDB+XwmQJ/fOrG7Ysv9Odpx0yu1XtfLjXOLutzfEN3zFgYtmhkfLmG4Q/gr/0TG3SJ75nuuDRWjInXT54cbHR58rc3Y0esbNzZnfvptVBnQS3+AhsI1NuWQwtn/WLqiRPdWHu9y+MwVvjWL0x2em668aZ+YVV/WaBs8zj00TBfJl+pT7/FD0iceAJ1ZCHHJn3RlTlGHdo1+MeGks3Y4H/6KfHF/21RbSS+xDyFyPCh5quCjjW6gv0i1x577LFLXPI//o//4x9msq+TfqieKFrKBBseZSa7bGcfsl95owuyjaovmUSn2tFce7sdSl0Iql/ZnqLzjfaEZb8SH3Jiq+REiKa2a12IntRnO6Vc5QKpJbIulG2Hv+oNkmPtYxALO3RMoea96q7QvmQnFyX+Amkh6NJLugv5227rF21jgy/icsHtgsoTT13L5vjx6/r62AEX/36FzJNVvm+VGx145IePdnwXnfnLLZn4btuFuxtH362is40rdlJaUOObmzl/JVU/8LmQG171Q+J3k+Ji0UWxC0J/WT3gH25wXNz7a7MLY98hczMRH+iwyPdmd9HhBuamm4ZvcoELF38NdzEvR57yuvzyKzrfDo5lF+KeqLBA+O477/YXu3KsDdhJXOgn3UWsv8Krs9imjL+AH6Vv077U17koHAO70TuG6sMcjz5ZsoNvSYdSPC1ffKBHu/3IqEsZyj7QRQaps+84Q7ZjKzagtQ+xOdb2XoH+zngQa81RO7ekTTmW84DOmqeK5HOqDeJPkDyi+Jiytrfbgf2xeTJ88aWVg+hD1XYdP2l3c+5JV8dvoN7xfustt/bzT2Kv8fMt+Ux9bW8Re9Ufx5KFLX88+Na3v715+OGH+5tp3z80r731FnqrJ3PX8PTMie7G+LlO7rnNGx2P+ceigrm12gmBm+ivff3rmyeeeKK/abeIYzHjzU6nJ40efOj7m8cee6xvs9jANrKtziL+K53dN9986/TizPBNxMSevp+LP0jsCMytP/rRj3pbgfnTotqd3Y19+KCNbYnI1jI6PE37x//5P/eLUBYXxKjO4sfDjzzcLyL9qMuH813Nhz7ozwfdWFHv/GTRgU7jyGLigw89uPnOd767eej73++/x0hv/4TR6X5EdOlLTyCRQRY2nT88deSJscRNdyXjhW6Lg85bfH+z09lF2S9i8t0fbZxjnPur73jFhN55++2uH491uXbuP3uRNLb44LyudOyw/e1vf2fzve99r//BAH/YyZhJXKc6O8avJ6ONGzH69cQru3OkTxzEFv38+8u//Mtu7P2o5/fqsPw+cP8D3XE3PJmWMRV/lK5nxPjNb36zy/dDmyeffLL/Q5Zc8yF5FrM6/P7Y57g58crwfdJbb7mlvy6BjF+6Y+ftt9/p/ZJr/WmOEI9+o9cT5328XQwWLeQbvfra8OS2Y8R1AV1tXsnL5V/+1V9vHnrwwc3j+qs7Dqr/0S1/0c2OBWq6c31W533zSeykz8IT1HwG6sjSgare6FLGxq5Bv3Gh1Bd1bg20Iaj1a8F/OaOjxjuHyCSPLeihQ7mNT/rXYuYee+yxxy5wsQkKZaI0aYXsm2BNZshFYyVyaa9lqNVZ20JpG9Mfav1o7URHpdhGifF8IRN5ndDbujFysgo5IYxR/9fjEXIiImfxCbk4CaUOTygyoeiv9rMd/4K6PYVd5HitnZ2jqKx5QMaamzk3F6+ffL3L3fgTYmPodXT6+nF4eky2/Y6Sb9vpl1BtH4P68P7kJ0M5xQutXceKmzPfArPIpH4NjKF33n2HA/3ilePQkxXxOfpddHqdYPgr/MGFD8Tv2BzrWm3hC83Fty12pWutnrnxGx3hyTFVZWwbR/qtnQPrfJe8ZW7IvKEuOlq09lsstb8XwMfkASUvU/2TsTeWj6NAjtZQfIyf6viqn9JnmbtzTE1BW9UNsZEy9jJm2nNqeFH/CnJ3wxtdYDy5IX6ou4F2s5n8VVRb0VW3K0H6DFK6afUHgq9/4xv9gogxHFuRbW3Q45VDN8Cezvqrv/6bzVNPPtX7HF5U46RTfgP7Fr5+8PDD3c37D/sb6BwzqIV+8YeH73z3u53MI73fY/2wDcijSZxuiv4a2xxlnKXvUfxT9vnrziHykVwrLV7ob/mwCORGNLYjH8T3iy8+0G2x54eP/nDznW9/p18wtGARREd8rPrknaynrf/iL/5i88QTwxPH9Ld2oT//edKuQF8+9H2+P7p56aUX+3EEsVshVvaMOYs3/rB1YOsg3mFxa/BZDi3MfOOb3+zlLDDZT/4gcoOeIUdyaAHnm9/6dh+fp5ghfeK64aenr9OADN8zD1REtzaLot/8xjc7nT/sF9Qs2IYnOU6eEbDRv8b57HP9k2MWviA8IXJ4n3tuWHyWI4t5ySlU/oC/jouHf/Dw5tvf/vbmxz/+cX9Miin5Reocb3/9N1/rFwstbuW106DqBbYtfuP/6+545zv+M3nsbMsLxE5ygCeIjapfnXhR2uv4I5+cxMYuwYZ5mZ3EwVagLv6FV1ljmEN4Mx+Iq7XRopUZs5W80YXkCP8Y7x577LHH+cSRr+xNXDlhIJNZe+GstFhV60JkgI5MoO/1ydAk7gRTTzKV1LtQdNIOORkjFzf5a1S2UdoR/pxscqLIfqX4gqawJpdLPHP6YcmHXSE25vzdxdjRfzUe49RTUPpGP6RtKeb48s7bXX+evnEwzkNppyfjCaV/Wz+mgAc/34bXeJb9im02+sWtTuaizqe1ML59a4TcsauH1zNB2W7ff999m4985MMb3zxx/KeN7TUIb3JyPrA0bpbaj4rkrEXm1jpfWnDNfKqdrL43b2QuGcbCMJ4qYmcsHm1oLlb6tJ/vfBwGfJeDxMjX5AW1SLzBVEwtX0Xqx2TV6R/9pq8sJitzzuNffEOOqYzxtt8g+sbagC/xA1/GTmyH6rkYD2T+qMeYp2buufuuXmeNzw3xX/31X2/+/C/+or+pxE9P+LId+7WtotbVNjfnFiW+8Y1v9AtWFfjocwx4uhTJbws+PfzwDzZ/87W/6Z9m5Ud8qeh69vTWAdj0VJjXr9p+b2MI+OxG++tf/8ZZi2aJcUpuDFNjrUffdq5PKPkOZc7IvJHY5ebgfHEwlqbsiufhRx7pYny9lwss9LRxseMpnePXHe/36bRA5iknTwxVe0CHMakf/UHE2Gx1WrzyhNh/+A//oV+04s/afLJHxkJdFnyWQP/Xv/H1zYMPPtiPA2AuNj01bRFPrK7j/uzP/nzz53/+F/0YaOODsTwFntazWORJwnbctKDbeK39VPksHlno8aRd1QXGgBx7Is9T3XJeQec777y9eeWVE/3TjLGRccOOvpfLP/7j/9w/LSenY8AbqrAAbcHar7Va7GzHmwWuv/yrv+oXwsbyCK1OoEfferLsL/7yL/s+U4eqHrI5Huo8EJ5z/O2OD0RPZOVjzLc2ll3AscDe2LEaqIuffMzx08YyBfqdB+gxZurxPQV5IDNlgy900Skv9oGttX7tsccee+wCl/zDf/gP/zATaE4M8Ks0GdWYTOKJU8z2U6rLCSVksk6pLZT6WofocALVHjuV1oCfyf+UjPacAKfAjyWbuYCRgzGsseOkBxlDY8gJbs7Okr/hgSm+tfEo87qifd/GcOEXOe0hdR6Nd5Hv1b+8khK42Mvrip5qcnPIP3p9c8RfdpGPwefCJRdasQEpK9ThQ3T6S6vt67qbCK9GqkvelV4XpN++C3A3eGJzgTvYPlhkw+Ovpb7dQfbOO27vv/uhHtS1ryumjW75cHN+y62DfvwV4Q3sx1f2HT/K5IAueex2+u+DRSbUInG0doPkbm7sxvaY/mBXdvC0scQ+0m8hfeVCMhfWCA8f2Knzk/3kNaj8FYlFG/kWaR+LlQwbieO9iuR4yUfxILkCeRyTSbxjbdGBh570WXKYvkmf1b5a8q9F+jTHDWILxW7dxo8H2GI34wYZO/U8Fp8SDzKfeeXJa1/4osu2G1WvgFmQ+vGTP+6ffPHEhteZElt8qHnKdgW+yFjA6l/97m7G6eM3Od9m+uxnP7P5W1/96ubLv/nlzZe++MV+/zd+4zc2N1zvRziGxaboAYu+5sl8n0ucbKcPzOuPNq8EAnvOB14z/8QnPrH5vd/7vc0nP/mJwdYN1/dzolciKywum++9+u7j60H1Zw5tfnw/qvVNni6/bJjHcx6y6ALMsPWzn/+s/+ODGM9Qt8+Li0/rDmILkfXapafSzO+t35d348r3tj784Q91+f/S5gtf+MLmQx/60Oaqq6/a+GaSD9T7dpd6fRX4ZtLxri89+Us/vXL0m1/6Ut+HX/7yb26+2Ml89jOf2Xz8Yx/b3NidZ4wh54OMOZCH49ce7xdqxA6JRem1Pk8WWThqYUx5ffJDH/xg5/tvbj73+c9tPv7xj/fjW37EqwwyTm66yYfNb+lqhlyoy7FlrHkK6z/+p//UH0cBHn/4YevzX/j85itf/nL/Yw333XtfX98fd11c8nDvvfduvvrVr/S8WXgiz5/vf//7/RNe+TVH+OhHP9qPLecHwIv4/p/++I/764P4ot4rl1/9Sne8dD58tTtuvuiY6fL8iYxlx03HJ+cf/vCHN5/p2j7ZjfeaC2MMPIH37//9f+jHZI1Xu6fd6dX3n//85/tj5n3vGz45kPHLZ+PlK1/5yub9DzxwZnzh8S0z3y/1mmW1Lc/Gz6c+9an+O536zvfefD9s+KOwHww5yI8x4NewfYbBGKlj2LxIH3sBW/ZrHZnMj+r1txjxaqMnPmrXRm/1+yigL9eJjoGcM+bALzx8I2+/xt6C33hRYp3jB3ojMwby9ORcUsG3NfkxX+9fV9xjjz12hUv+h//hf/jDTNLKTNpBJqt6EjjfqBNktk2QtlEmTJQTQOozyYZM4Jl0xaC9yofSHhsIUgbJQ1sfaJdLNg8LOkJ8G8MaO+lPmPIXD5qzM9cO/AA2pvjiy5wdNOVnQA8sxTOVFzb4q5xa5KI7/iJ1/sroYs0Hhl08qQ/OWeQ6fRGA5/JOpwsVN4kWul577dX+Gxn+2jh8THW4kCJTdQbq4gu/pha5XOgpxYLUu1D2Ko1XBX1nxEW573qE/FKZG1M+uHFzMelGhh72lFPf5HIx4oP6LjTFrZ1NFLTbtZ1+fVTzXBe57j59k9TKVUSWn2PQhmfpGIEx/UG1E1+jO2Vyrsx+pVwoh1Jf9WSfHj6zp0TmMaQOTeUkiM42N9XeWF6m5AJtYplq/2WCWBIPyMdYTsM3htSnP9I/VddcP02BXn2BMn6U9rMdqj5U+8ZL6rcdO/Rm++3uuDRfjS18sGNes1jkSR0/YvHY4491N8KP9aX5yqKDX7D1K6vmlzaX9tmjy3b2zbMWNG6/7db+VwwtgPzG+9/fzTd+wOPqbr4ePmdg4cBNr6eHzEvm10C85mQfprZoBtX+1CKXOdNCjUUBizo+mG3O9V3FG2+4ob+p950oi3AVPi5+3fHruhv8e87kai7XFfyS7+TAucmv6Vbf6DLnetrGgo4FRgstc+RVQa/GmVu9ls736ILYte9bZ54sGuvru+6++8zClgUjfYMsWNH5G7/x/s19993X5yjjB+jXlxZULKY4z1ic9OMA8qoti/ryfkNX55te7PtDSsYx+HaVJ4Lzy4SVpha59InvmH3m05/unyiOvxbenPfzi8JeVVRWGFd+WThzhNKTWeCa4Fvf+nZvM7my+HjXXXdvPvnJT24+97nP9rHy1dhzjmXPR9h9MN0vSFo4tdDVPlnVL3L94AenfTroh3aRC9j2x6qvfe1rZxZ5LWbK5ac/9eku15/tz90Wf3xf1I8mkOdT/4uSnY+etuaHb3KKse171wiOZU9aOcYCNu68847NV7/ylc63j/Txye21117T/8FM/PpYDn1n84Mf+MDm7m4cZbyl74xP3zIz5gN+fPQjH+n67VN9v9E95NEYur1f8KTHtYy5A+gUo5zrO7ph6Lfh2AoSo/pAXebOXJOlznau7TKfQvSidvxsC7r46vhhg934uRZkE+eYbGwg/rKzZKP6Fd0V5A/rb4UfSKBnjz322GMXuOQf/aN/9Id10jJBhcAkWOuQukzmaa98kLq63VKdELM4lYkyhA+qTC1DII5M2C2Bibptr2jz0EJ7eMbaQbuTwVEn6pw4E1sLbXjkYQrhGYs1yElryc6UPIgX8EzpoWPO39iBOVv8nYtnjR068Jw6/eFV+9suckUXjC1y0aE9F+5u7rzi4C+477z97uaNN33sffjIrg+1gr82s9vGlpjUzy1ydZnrYgnvcKHs9QAXtcNf0T198Ea/uOdGwIdw/aXXh2ZRft2RvsR9mEWumrcWiY0dfaQM/1mLXHcvL3JtM3ZjI3VTROcYVdm6HTuIH9Xf+KyMj6kf4616zB/KUOVbA3qAbIX6xDCmL+1TdrQb03Pzzi8bcjOTc0MLbQja9uwrKy0hOuUa1bGWG5BaF/sQG/pWP6A6Vup+5NSt9Sv+2CbjxtL+8OTE2b9CyYa89Qv55pduTjEvuNm2MGZ+tfjlV9gc27wxf4ovsdc8hLSbDy1A+KafhQlztLk0voXC6wPeXm2z6OB6AvhvbiLvphfIpOwXkppFLvXmHzftH/rQB0/P6cPCgI/Y81+dp0Uee+zxs/JBlo8f6G7mbSfnNffqE6dYaom0I3N0u8gl33LtvOEVPjldJh/nHj4U75xh4YE/8ana1X/tIpd6Mf3mb35p8/4H7u8X+bIo1eekO29mUYF+sUC1gcfih18Y9nScJ6Lp1HeJN3nQl3iNK4uQYg3w9YtEnR78gfqpRa47Ov5PfuqT/QKLRTl+s4v4cK3Fkk7+9e56wKJSoF8tTHmSS5/XPDkOfP9KruQssPj3qU9+sl8IdL4Ud+KSK2NRbPw3Jm9zPdH5ADXfzq9rFrnw8lPMXgnNApRvgFrEs0hrLCfPoDzLn46PT7bxGWPxBfB7iut7Dz7UL5qmTR4tHvqlT0+FmSccJ8mt2B0nFrn0t34Xt/r4Avr5oYe+v3n8iSfOyqXFsC9+4fOb++67v9edGOJ3b6+rs9Ccb5qBBfUbT48zcYaqTTGwS2egTi4R/uQB2cerL3Ovoh3oRbGR/GwL8nLKRubVbXWFP2MO4ieoF4c2vGKp7WOIX4mvBfnD+tvCcbV/kmuPPfbYFS42WZucQpnkM/Flf4xMaPjG2lAmvzGeao+e1n6lqidEptKFxNhEfz5woezsArv09ai6zsd42EYl+8YoiMXikRs0F7T+UnrzLTdvbuou/K49fm3P6yLthRdf7C8k8Ye2x7ky9Lgo5IMnHVzMuqh2XPmIvotFF+PqXQDtCjWOMVrCmAz/KqXOxVel2j5Grf7DIuNMWanOU3UOS9vcnAZjdYdFG1/0TcWuHR0lL7+smMrJEub6KDpRxmpuMlLWcVu3ydBdx4IyY2qMwhefsr1tXJEHC00WbTxNcf/9951ZKJgCWedyf5V3k26hxa+x+Ri8D3Q/+uij/c1MzQkkTyAO2xYh2LOIEps1H5AY/bqaJ0bctFf4eLWb/7U5MF+6KXcDb8El+mOPz27ePbXkaZX4D+K2WKJMfMq2X6d8SX1sjUE/W+iyILCGLG5ZKHKeqR99D6qtMbP8tlBxz9339HHzseYDnEfkqvrf8ug/5xm65FguWkSGLrm9ruOv8ES0Vxl/2vX/GvDHk0Z33H5H72P1Pb5dddWV/WuYFs/iP8jzG6eGHKpP34GcWlR7rSzAOZ7vuuvOzT3vu6ePEaotRN4ij9j6P5h147vajE/b4uenn+Q+C53ey684+EbTGIH+5Xv2Wx/o9Qcx3+OqbfIpXk9oOU4TYyW6LUZZ3JSTHE8QHxybFsXPXWi+u79uspjc6uUT+xYKLdrGd/DHQ/os1Kpvx1nmjypTdQfZr8du5tnw0eNYV0Kby7Wgmyw5uqqNbUAmPkLOMUC3/eSj+j0FvJEZi4m9o/h7Lg7G5R577LHHUXGxiyWr+S1lAlS2lEkUZYJDaa96wjMmZ1JcOzHuYuJbY+tC2dkF2NmFv0s6luysjXeOT9uaeLQf1Zc1PK2dn/384KmjNWAjY1zpAt8Fu7/03tddFL7//e/vv0vhQs4Fotcynnv+hV52GzsHkDuli/i+ogc9bhC9esOeV0Tuu+/e/i+d2uoFXPKylB9yAw374ktdYJvO6A/VC6YaZ5UN1FU9yqoz8tlPXUoUPYHY0id1LlK2c1edw8hkfotcKP0c/WOYqh/DWC62BXuo1ZV6mLMz15b+/lVB8pHxtA3whzLmUB2TxrzjP5R9ZY6HwHiqY8/5efjr9tnn5HbcTWFNX1fgpxcBOdtuUj/9qU/131Hy3aX7u3nEE1ZeK/OUixv3emy38GFoN7F+le0v/vKvzvwKXYWYcgzWYy3+8A0l31Btse2J2au7m9+KPo8dBdExBTfPnmz1h4g2HwFbFmzM5/o4+HnH55W/PI3ADl6U8WAb6G5jtp84u/92giHU4bzg498V7CyBv54G8sSucdsi+ZmixNOi9mFL5C67dHhSrEKe3n33nf6XB9fAq4Vefff6HPCj9Q38Ecg50uucgTb23n7n7b7f+JV6i7fPv/B83x4YN3fecWf/WiYeZNxXe5UAj20lsJHx0VUO5Qwid+llw2JGfKTT3GFhymJPxlXyy4ay9SftKDAuX3v1tf4puUC7p9zkzHGQOMZ0sV2PY2Q/PHJpAdY8F+gH/WZuobvKRx/I+e133N4/0RXoEzotdJ11bJ7WE13mqyBtyREdtnPMJo7UB7bpkiMlvsic6ccF4OMLmehKfIdBm6PMy45dNvgsjiUbkclYaUEPHUf1t4KZMVt77LHHHofB7Cy8q8lmSU89aYxhqX1XeK/4AbvIffzdhS46jqJnbe524esuUP3guxO5Cynf91jyMbkKAR258ED2XXzcdtut/c1Ux9H/lX3qYmHJJhzwnJ3riy9ykTIc6i5Y/DX1rjvv6L8p45tc/jpe+yd6Wpt1n55clPneF2jPxV22kb+65+Iwctpz8YUi34IMG/XCja5cpPX2u4v5UNr0Vy48q2z2Ed017qNgjZ6x+CqiY4lvDeZ0Je7kvcVcG0T3rwqMBZCrqXypl5PwZB8Zz8YyclPgxjyUxayMeboyHo3PLGKF6tjFk1zHB7QtIrsW+GM3PiM3nBa3fuu3fmvz9//e/2XzX/ydv91/ZPpjH/tYv3juOzleRxpe5Ru+syT2apse39/5xte/0X/QPsdkYs1xGUQ2bclbjnOLVxaUbJs/62tLgYUnBGvy0H+0urt5rgs61acKr42fq/KgIj73vp6en9K3baxrwH9jyaKiHK8jr6Rd0/+RxXeMpjCVG/YscmqPfVTnCLG0BFVnjVV7cpH+C8lTnkLTXkHOwtHavF122eVnnjwkUwlSGqtetbzs8nMX8bqoT28djEOLKKjCE9HXXX9dr2vgy5g9NzctBY4XiF9roB8cc9dcMzypBuQtKv/lX/7V5oc//GG/QGXRx1NOnpyy8IXkOz6QQZmrQvhfPvHyOU9aec3TmIocSlvmxjrWYwNSggWu9hrkqm7cWkCnI3JVPvCdP/1mnAd4Tp08ddZTi5HnC9Rju/qm5HNiyPyVY7i1D+pqO/7M+3TYn4I240XO2UV8OCoSB7/4kD9CqOdn8jCGxC6GjIUW4tylvwFbc/naY4899tgG03cyK5AJ/0JMSmMnl4olH8gv6ViLNbYuBHZlZ07Pmryl/ajj4ELEswaJQ0mX77wgH5F30l8DsiEXDAF9LjCQbe2X9hcTLkCGi8GjYa4vh5I/Xh3wysRbb77RX6y/1d1gx8/2BqaCv+AC6PLLh4/lepVhDOkHryd978EHN88//3x/AyPGerFlG2/4IfuhMR5o91ssta/FLuxkPMxhV/4CXUv2WpCZk9OmL9bE8suCjK2peNQ7HhwXw7gfvkNksVhpv97U0GVcuwHIIpYbRWQ7Nx/sZh44X4jubfqKTOtTcoDEau6wuPU7v/3bm//q7/+9zT/4B/+3zf/zv/lvNv+P//s/2Pxf/+v/evN3/s7f7j8u7nUj+WnhA/WPP/7Eme8tsUc3O5VAaa7wjS8yvt/zYDefeCrMK5Df/e53+20fAf/Wt761efbZZ3u5QCQ1HHmH6G+hH+s8n7gDctm/opsD8weEA3T586/J4S7AL69ofepTn9z8nb/9tze//3f/i80f/P7fnSU8f7vj/a3f+lv9K6e1f9sc5KPqFXg8bZyYyWbs1v0cR9EdtDbw6UsfzdeX3/ve9/r+q/Q3f/O1/pf26tNDh4F8ZRFhDHxLf/qe1BQfJE7XAhZl/FJkhdfyzAcH4fYj70xOQslVCAb7w8JL5oS1o4f/Xin22h77AT1eFf5n//xfbP7xP/lfN//r//pPN//sn/2zzb/8l3+0+Xf//t9v/uzP/7z/dVS/bGheCtiWh/Sb74ha4IqvoN0PPviYPSQ2MuIQj3nOcdvGGz6wb+ENb4UfGNBvGXMV6rL4xI8rOl5PdFX03yDt+iiQC4Q/eYb4k3b7QHfmLb4hfHMgb74PH1v8nEJsJFfV/i6QuOhky376Yw545Yj/U0hOdukvyEVnfo899thjJzj3DFKwNKmvgQlzDmygJT7tSzxrMKcj8e7Czi6wxo+leN4rsVxobBV31+0Z6k6yTu7DydbN1U/6C3J/FfTB11wgTY1be+qig5ynDdTZb8lFyPAExztnZILInEGx1R0NZ9pdSPmlMR+Rn7qgx4tIArm77r6rv5D2YWI/Vx+4cEE5HoLEjOSBTfCqpYsniJ3B1vCT/i90F9E/6fLITxQdFwJLdnbpR437sNiVP/RM+aNN/541thrMxRHdvypIzuXDsTOM7WERy8297RybSrGTyUW+si5k1Sd2chzFBqiDbXPY6lmDORn2UeaQxI1yc6bddsYK30PmrnoTle8o3XPP3ZuPf/zjm9/73d/d/P2///c2v/1bv9V/46rCUyQ+SG/hG6ov2ZZHr1v95z/5k80//af/bPO//ON/0t2w/7PNH/2rf7X5P/7Pf7351//m32z+9b/uSNnRn3R8PgRP91HQWe//9dudH/KXOJPPubyeT8jxBz7wG/1ro3LsQ+Qf+chHZgkPeuCBB/rFgNrfaOx80UKotc+NbSVkbCQftS/Tn9r8eMuf/8Vf9Isu/7//6X/a/PN/8S82//KP/mjzf/7r031Z6E//7M/6D6/74ZNdIP7k+M6YVg9cn+7Ooa+H/peHLgc/GfJQYa7IcQNV57B99thB7McX+uVV/RSMy5rTkDoff/ckZRZnAseRp6WefOqp/kcWHnzooc03vvHNzZ/92Z9v/qjL/z/+J/9k88+7PvnTP/3TzY9//OMzumPnZz/t/Dr9+m3A5yu66w3XAMlhcktWHImlEl56Ey/87OddXk9vB57QuvTSc5+qI8c2Xb18V3pF2XfVKjxFF51Dvw1PzpMPoiMLP/FPHMlhbVsDvFnoqrqSo4AfWeDCn/lll0iulHTzITankD6c4hFX7dtdg4/n/tFgjz322ONwONJskol8CUs8S5PlhbKzBmv8WOvvUbGLeNboWIpnbbxr9Rwld2vjqXAB4CPsLjS0ITetLrCffvrpzY+f/HF/seDVwlzEzdlJDP7S69Ucf7F++uln+l8dI+dCwkWEG+Knn3mm/wWpSy+5tH9tURtZ7ZVadB6c8YPfaHjibPyva4O/+A8WsIaPwd7UX2T5daZ8I2cu/9HNT68IeF3hre6m8rHHHusXtLLYpfSE2I+6m04yfjr+mtMfhI7fS/281D7EtAx6pnSt0bErnjWY83VXqL6Oja0lkL8Qfu4SOY4cx45h5ILfgo7txGNc5xgU53BcDU8kOE5C9lFuTlKSGaMWR8nfNnKxU2NP3CH76rUDfxMLJFaUXCT2UOYFtuTPjSe9vm31G7/x/s2HP/yh3lZA92vd/ODXDW3Hz/hqbvTLgv/u3/37zV/91V9vHvnhD/sFMXOoRawsKKK3T1N8ii9Bn63uf9Gf/u0xmcoh9uSi6jwje57RjZzTWwfw67lXXXlV/3ra5ZcffOet7VeLYaHsK3O8J67kK/Glz+eAp9JYPpJr9owZ54c/+ZM/3fzFX/zl5qGHHuqfHvIHoMm+PH3jvwax1bsx0zV8Tcw17sQ+jUH/UJ7WY2GmKyvOGlcjfYc9OQO8WYRQNzZ2xzHYIB996H3ve9/mC5//XP+LoL6TFWijtx67WZTPLy1b/Pra176++U9//MebHz766Jk4UrZ+8bmSOFDsIHYhZXhBrOp7/V3ZZgvfRRcn74Mf/bzSjXFy6cPTjf2vSZ4FOk/nm0/pm+hTn1xojy/4HEu2zfPa2tjnEN8yF1WdfUyn98VhX57wbWNjDejWH2zRLRa2IPUtIhM/W4gtY8j2+QC7Y7b32GOPPQ6DIy1ywa4muws1sZ1vO7uc/Od0pe2X5aSwq7zQs0bX2pz4q5GTtp9jtxA10NObpzqy/WJ3Aegi4c477uhfR3BxQHd7IWC/hRuSi7r6U93FvNcGnn3u2X5Ra9DdUbf90osv9Rc5199wff8UBOTCSpwpg9j1D5KPgc69aB/zKzwuvHxMmD4Xu6++OnzPpsbVW2pijT/+cn3zzTf1eXn5xIn+yYxnnuliPJ07+15H8tdlPzvvm2bxdQr1wnZX2LW+KRzVTnKzK3+n8qw+Y4StMXtzfuzSx10hcRjvjtHcdGUBINu5wEc5NurxIjbHY27UbLeU4wdv6ELkY8xWG3diT9w1ZiU+RCb6xFLjVdacQPhq3HP7kWHTvOYj0vnFueCNN9/s5wfzb4Wbb6+peY3tiSee6BfL3aTxTTwWeHxnybzi1xS9EomGD+Ff37e3qL0T/9ag8tbto/T3FuZHcNDX6cvap6GAzyj9WvtYGdomJxXkxnJR/fAE0UPf//7m0R892i9q+mMKm270z/RlNzacS27Wjx3d1G37xlX91lJAbfSP2Z4Df+uYPcBc/EPb8CrntL3Om3k1HWKS3zke+bFtH7Txk/WK37333rv5+Mc+vvnExz/eLy77BUc5dq6Wb98UZbNCPix6+e7WU0893b/y61rAGOkxFXbnblyOznYOAD5mfKpv25dALnMbuVZ2cG3CwQ5sxz6Qb8d9fGTDtrZt/awgX+fRzL+JA1ofdoXYEg/78SOl+vgSVJnkqWIsZ+cDOV/tsccee+wC594BFyxNZtrHJsRfFNZMvvyd8nltPLvimcPaE8mSHe1H9Td5WaNnCWvsVMRuqK1zUq7kZJ1625XCE1nfwvKxVt/aOnXqjX6hK/TKiVf6my0Xh76B4hUcJ19y/Kz9Y/HGh32doNPe13f7t916a3+xzr6Le3/BfvbZ5zbPPf98fyFJp/bbbh0uRsm6EEEuKJTRJ3o8x45d3f+aUkX1B1yQX3rpJf1fdIe/Gp6d1/C7uUC+R+JXwdgTAyi9AumXp/wUOUROKT43lnd3ubnm2DWbN994c/PiSy9unnvu+T6HbkwtovllrmOd33KfeFDsBP0NbKdHfG3bFMb0VMTfOay1tcS3Vs+FRutX8g/6pEXa5+K5kLGyVSnHcY5rx1BLaUt7+MWVYwu58EfJR9rUhacegy1Sv20+yE3pbJG4s51YEmeNOdshvJFlr8ZXyUITStw15uiIniAxtEQ2sG/+uaGbYyx0V5gfLHTVXz5kw5Mljzzyw/7prXyQWr3FkPvvu2/zqU9+cvPZz3528/nPfa7/8P3nP/+5zee67U99+lOb++6/r+erEEWn4iz/zsS3rgt69PxbYrB7YPtsOs3UIfmtOe72Tm816KrDO9a/KdOX6eN2u+3nbZE46vhoyZNa33/o+5uHH35k88orr/b2wGuTfmHYK5e+3fa5z6U/B/rMpz+z+cAHPnDOmAmqjbNwuFA6SOrpzQLqEmfsiXf4MZezBRw/XmUMNIclsgMdzF2wTT90nnR8Qw75ER3x0dh/4IH7+3x+9Stf2Xzxi1/cfOYzn+mOmU9sPvrRj2w+/JGP9K81Oo7uvPPOM6+vglf89JfvpD3+xOP98QlCCE+QsfTTn579GiMkjhpz5ONnhTY8FXT/rLMBkVeySz56batrF8oHmYNrwSD89McPPJk7bbfthwHZHIPK2HCNo1THTo6HXUGs9Cv5MPTRkMfWn3p+IINst4ieyJ5P8Mm16B577LHHLnDuHc5pmNjQ2KS3LeiZw5KdJXnYFc8u8Mtm56h6Iq8Pd0HRlRNwttv9nMyz3e7nRi9taScPXvuwSOM1RL+SdUDXdTdlN2zuuP32zX33vq//5TB/Uc7FT3vC1+ajr37lhz35wKuk32sEyNMGx49fu7n6qqs3x64+1i9uWQDylIN6oBON9Qnfb+n03XjDjf3iWwtxEUN48dx9152df1f1saeN7tjxGsutt97SL8bZzgURkPELSp6YOH7ttb1cYBvhIevCWnxy58LZa4y333bb5v0PPNDX+Qty4goN/h7odAGYpzLSR3OosnNY0qV9jif+zmGtL2v0rIl9DeK3sdAifoy1gb5aysmukPxX4lco+zmGhwvhgyeVUI51FBk+Gs9ZwBGT0s1b6hzHeLTFl22QPGwrF5CbopqDxK0ciz25IZe4xVZjHIu7xg6xDXWMVApPCF+lsbFzcbfPzxb5dk74yb/00sv9U6D121rmsnu7OdRi1le+8uXNV7/6lc2Xv/ybmy91N/Fu5L/4xS/0N/P333d/v6i2Glt0W+KDNr4xYI3MIEYm+T3IX5vf0KRvgws9aj+3favMtj5BB/4cxAJ1exuM9XWFX+/1XbWTJ4cfGBCXcXrPPfdsvviFL2y+qi+/8pXNb/5m15df+lLfn8hC1/sfeH//R50WXE08Z8d0mmFLDP0wjNExUNuP086APxblGGzH82uvD6/rD34MfZx+7mu6Uvz++ESWvvb4WwNykYlOSB7o9tSkxawvfP7zm9/9nd/e/O7v/m7/jbzf+93f6cnxI8d33Xnn6T+CHejwxz3f5lKCeH0fq/bzT7o433zrzTMLYfEHL11DTgfiT5WtbUguPfVe8eYbb2zefnvQHd/qmI4sf+X8jTfP/vGbSzqbl3R5rkjeQkDH0CeDj+rpT/tRwB6f+QfV58P0+xyiWxz6gI0c+xVsxra46/mDfIv4umt/x0D/QIc8kPfYY489Gpx9ZtkSJsCxifGwmNLFzoVCThZzWPLnQvp7IbBNPMld8uhEWi98hgumg5tUF1j5jki+GZK2nHxzAo7uICdslAt8lAshj+AjF2K5wcuJX0wWf1zk+avmGPlJ/Fxk1xM92Up4XLR7LYfPOVnHDv8tnlnM+uAHPrD56Ec/3H+j5n2djNdrIhMb0RvUbQtyXkHwy0bxpSKy8mix6b4uDhe8bAy8Z/uOLGJZhLNQJ++pl28/4y0PFqqqTPxNqe/uuuvOzQe6C2u/4OVVCU/A0Re+UHQE2eZjH18nN9Z+GBxFdtf4RfjCZnvcBHP+RG5KVj/CVPu2oMdxYrxkLsg3hfI9IXMFMk6Mb+CnYzrHvrHm5gy1x/wc6EnM0b0GyeG2eYi9IPGLrc1BYteGB8gmbnHmGzsoc17ykeNvrY8tX3KCbC/pSR5bdBGf3jrAwHXAy2eLIj5SXvHJT3xi85u/+aX+o+v+qEAisSWXV3Z58vqiPJ0P1P5aC2kY6OB8aJFDH/umVtvH+vdMnk/raCGP+jPxp3/buTXbY7QrRFft77r91FNPbk688krXrwffA/Kdtr/9e7/bnZvuHf4Acrq/6Eo88uO8enV3DtsFkv8xzLVVZM7jrw+d67OK1159rTv+/Eqh8T/UBfTn6WqxgeM3x+VaH4LkStnOC4OtYQ6j3zZf5dq53nneAthnP/OZzR/8wR9sPvyhD/VPa1c8+eRT/ScMfnZav0Xm6t9POtuefke13/AYx2K0TVaJB2xHT8qxX61+6+23+kW05Jxu+Qpii16L4adOnjrdMsA3Aa+84uBj9PgyH0L1Ib6yhSc2d4HkJvGD/mjj3QXkGiWOxNoiuVTyI/GPAV/G6fmGfrQo7tuue+yxxx67wOzVvIl5avJbizq5T2GNnaP6AbuIZy3Y2UXu5nQcNZ7IKp3sQjlZOvmhXHzbzkV5LswRXsjJG+VCHfjpJBlyAnYT1t6cobbdNsrJ1om56qIbtZjKS3xJSd8YRf+Y3djL9phc9tNe9WQ/26FWf2C/tTPGL2bb6lr81C8kdTbzF+nwtTqr3qk2mJKvuWrb1MXXiik9U/wt5vp6jfxaLNmZal+L6mury349Ph2TOf5yLI5hzi/5rcdpQCZtU4jeKd0t8GVO4aubJmTBQimGLOTEp/iRMZF5wdhwQZwFncwPeOZA1xTm2uawJg9pr32XeVXcNX71+CAxZ44Us231bdz858sUtM/5CPET1b63QOGj76e6m171awiiS595TdsvH1aI+drjx7v4r+z5QDxvdbGRqfAHhNxoizNjI/2Weh8sr0+AHQad9tNbAwZb5l/2po/RA3Rxd/88naK/jXd/UEFZHPFKjn6mW8w532V8933atW2L5CZ9sBaRm45pHDX/7RhAfnylHpfycfy66/pf28w4pwMP4kPgF4fffnt4mugoqDpb8IGfS3F7RZAefQM33Xxz/8efCt/vHJ5ae6PTJ/6DnLDj2BY/iDVtbFdaC3nLWKE/RGfak1Nkv5I630G7++67+z+2VZhb/IKkpywtNHriHG/FKydO9POCccrv2IPMc+rZUSbeSmQ8nZ7vnQYWC722zI/4WuXoV5oHXz7xypkfzQH1xpin8YEs1NzGH8eibXZQeHeFaiNxQOYF7UcFHcYWylzC1hz4MRertuRkSddRQPeJrv98wuOs78Dtsccee+wAR59hO9STxxh2deK4UHbmsMYGniVftwV9ISe1Si4OnDRDOeEh/OpyAxVSlwui6A347+TjggU58ahTOunlYjwnwZyY8EQG0RHShpZQ/TgsluykPbGNUeKf8j/7aEy28kRXy4diI7wtUo/mZEHubPsuSHwI8A78w0XowHeuX+pS37bZjy2IjlZPZEPa8bay8RdV+WorNAVtS2PmQoypNYiONf44Rusx61iNnHzKUT3+xvxLnWO8xRpf5trIt+32+RnfXcSjLMJl3qlzDj0o/V9jcgPTzjNiH4snSFxjiM+t3xC5qfYlkOEXyhwsBzUPbV8m9sQtVjEnbvWJObxHwVzeEncl9nwY/k//9E83/+E//sfN17/+jf5HJdIHc0Q+pb/M+3W9N06d/bSFJ01vuGF4kjXxVaoYcjBst+3Zliu/2MfnJbT65yCGAxzI9fUTQ0WT+KEer17BcgNv8cfCZcZ25sltkBzn/J/xlmPsfKHaRZDt5Cp91OZ5WCw8mNuBTOQqLFaefP3k6b2jo7UhT9V262sFnvisn3yawGv1Fl4D/eg125dffqlfKJWj5Mmipu3osAhmTIDt6lvr5xiq30An/a92x5rF6OF4OXeOVrcGfLZIR/6STq+n6u64487TrQPYeuqpp/qFLnyJj22UOgT2Q+oy3s0Dx49f158nKvx4TZ4Uq3LmUNvqxWphscZFz/XXXdf3kXrjDYaYBl+iB+ocu0uwkWMx83tsgRj4EJ8Og9gQW86hS3GwSwaNITnL+DwfcI7zjT6vpttOTvbYY489donZ2dVkl5PLFObaKub4YmcOF8rOewXxNScjJ7GQ+jYO/E4UyAkK5cRd99Oe7VCVH6PWRiX1KMh+S+8VjPnWUo0rNAb90PK1vLW+zRkK6naLMX9CFUPdmK4p3rMpdqbaUYu2nY6x+mBqf4qOil0d80t61thZ64sc5jhtyzGSp23jTG5dKG8jG36li/Qs5Cjtj81XwE8xuHhGtl341wWd1PNtLMbQFLRNxUKHtrH26Jxqh7TlxgLVeJMLpf3kiW62xZVFDSRW9dnWjhIvSrzxL9tTPo4hMvyZQ42PH25iv/a1r22+/o1vbB599Eebb33725s/+dM/23z961/v9h898/RE7esQeYtbjzzySKfj6/1H5L3iFMiT15l9zy85QnKZHFb4JdoTJ070ueJfJZArv9z3+BNP9De+R0bJhXj4g3zMOpjrA7GkL5WehkMZ43N9vITOs9527JOLndhcq6tiToap2Izd2CSnLn7UmCw4pI/A01n6KYulQLb2J/Laklfm/GrvLhHfjbPYgsHffnMSBzH+vF/c8gSS71kG4vEtq+985zv9oq6xmqf5YtcNvV9adlx8uzuePK1kPGhPHiD8cwh/cm3B6Wt/87XNX/3VX29++MNH++MgPCjbtfQEjb54rVkYzg/W4AGfR6g/vgMWIR97/PHN17vj20IT0BvIh3gff/yJzYMPPtT/+MDLL5/o5fkbyKXFbk9zVfywmzMefOjBfhENv+Mw9u2bE777vQf7nFd9nkrza9XOSRmPcgzRoeRr5t2MxV0hcwYb9OeYV2ZbHNpzvkhe1yKxxIbxthQH3sQ/Z4+emtNdwR8hPLH1+usn+7Gxxuc99thjj8Pi4m0n1m2xNFHuaiKNnl3FQ88YBU4WISeMUOoq72EhplbPWL7U5aSUbZSTd7ZDqQtFZ+SzX7E2nl3EvQZTdsZ8/2XAXN4S065yu6RnF3b4fL7t7Cov9MyNm13nfwrVD2WO23qcpr0idbvyj57oaue3XCBnrmvryMXP+F3nnkp46n5ihLlY8Ey1R34Mc21QbYfG4k+87c0CXjpq3GPxtzdWZEJLqD5uizUy4eGfbww9+qMf9YsSbmjdbD766A83X/v6Nzbf/OY3N9/57nc3P/rRY/1ixDPdDeczzzzbk5vmhx9+ePPd735v841vfHPz0Pe/3+uo8IuuftjD9wIr5NQTGF5jraD/R50vSk9qeRrK4qgbpVdffbW3aWGBL/K7C8gFGsbAQOekcLTLur7s/m8xJGMhtKaPtwWddGd8xc5cfye2lrZB7NbtNr5rj1/bfx8puvHoP2PHWNF3b7wxfMD87Y4szHgayiLqk08+uTnV3RS32NLNs8APx6w+RcDn1u9pMG7B2C8XX7e56667+jEbiM04/WY37i3sehrppZdf6hftjF1xif0b3/jG5lvf+s7m+9//QZ8DeUmOzpT9/89F5UN8f+WVVzY/+MEPTh933+0XpL/3vQf7V4QtpPHLMezpQTlW9+MfP9nzWiyqC8M+wH/H7bf1i0SBBa/bb7u9/6aX/AGf+f6Dzua3vz0s7A3f03up1//UU0/3v9T4zW99q4t1oMcef6z3JTGAfrj5ppt73ekTsEhucQz1urv5R5zGjXmJ79/v5haL3wF5T9jdcP0N/Xb6lq8oPMh+nYd3BbpzXoiNjK/4kjo8+I0hZc3LHGJDSc+aOOgmE1tTCN8czzbgV163d6wrHe983mOPPfY4n7jkv/vv/rs/zARckck2k+gUTIbap3joia45PSbeuUl6yk708zN2oK3PduJJXUvaITxVvt2Pvpa0wdJJZw7RwY+cwFByEJI3F/W2x8AfmGpPLGjOX3bqybqFdoiPY1hjRz+v0QFTPBA9U8h4O4od7cn/FHYRj3b9OBcP4NNH1PErfQ+eIqA/3woZsxVflmytPebRFA8s9dE2dub0+Evp3AXVhbJDHpbs8GfuWGsRuTGoH+vP8Oc4gPCm5AeyPbYfHeT5quR3KPX5a232UfSN5YveuTay0dOitreI3SqLP3HIRbaViTcUnyMTPSHxmQvqIlYbdwV9aCzOKcQ/cvSuBbk6VyUGFD9Q6vSZm8wfdTeX9UPA5N2kPvfc8/2TIz4Q/9TTT22e7m5o7Xuq4vHHH99878Hvbb7f3XQ/++yzZ30vh25PbnziE5/of5wi3wJKbuT35MlTvU0LY6mn4/WTJ/sPTL/Z3TBpd8PrhvqJJx7vb6Yf/dFjvT9tPr0OZTHCt4cgMSs9WWLhod7ku0H2QyJ+GTdI/wZkIfEmr/Rec+01m49//OP9fNBJjvb9AeT79FbxC17q4rdgUn3zZJQnanw8HF/GVgt6Ul/1huyDsra5Af32d77Tl5EXhw+V+yYT3jqmIcdE8hNdqGPqF3p8xDz9gq9/gqnbt0hiPClffMlYembz4IMPbh5+5JG+L90MV7A1/CjM8CMpAVtefbKQRHdgcUZfXHPNsTPnRLyJP3Hwzatx3/nudzqbw6/hgYWXO++8Y3NzV56N4ckiC0EvvPBi/4RKX9vpkjtj16KwGE50Y8wi7I8e+9HmwYce2vzgBw/3x4Xxa0zT4cmpfHMO6LBo5WnK+h24j370o/336epTVhYQhoWzb/b26JQDNvnw+muv9+PcDwC81LWz/aPHHu8Xjx7q/HEspW/o9MvIX/nKV878kE7yJd/mBbr0S/LG/rPPPtMfiy919EJnw3xgYcrCljnE98qM57fferuL98r+I/jpP/r7uanTTdbCdWBsqBMPYttTcOYWebTAlXEIfuDnM5/+dH+8y5G2UOJQ2s843iXoF4uxQbd5obURfyD+oLVIX8zZaJEcpz9bxJ+0KdlJ/WEwfAd2eE3ztW4MWuDi51F07rHHHntsg9lFrkx0cxOoiZb81MQVPUH2WzL5xs5YOzvAzlh7e7IYq7fNjhLRibIfmkKNka9O8CkrqcsJ6ChILFO5BSc7NqcwFw8kN2jOX3ljZ8wXstqBjjl/l/KS9ikd8RWmeMRMz1xedmFHOz25wRkDX8gf1c4SD1jASszGRe374UIoF3rzi0/kzncfQcbUFNaM3ZRz/i7ZEQ8/l+I5qp02nugMbOPJ2J3LXUV0pF+C1Mdu3Uf2yaREYsi2+sjwhW5+IeNJm9KNT+ozLlB0jOUsPpBpEbtz/UF2rL2VzX4o85T21MUXBO0+XpQYURtzYH8tYntbGSA3lteKxBeKTN1PWfschrbuJrO7ObH4MGZL31uccPPpZtpTHJ628DqWhSrtbT/48PrHPvbRfpHLq16xFz52bfng+LPPPHvWK45upp/vdLt59iqTJ0jQDx99tLdrMSj9Gn3gl+N8ODuLXIkb3Hifu8h1fb/I5SkzcYsDZbGBLB1gkeuJx5/YvNvdzIH6bRa5uBFforf6Nr7Idc/mzjvuGHLV6K26KuFF+jg2EFQdclwXufBYLBgWuW4+YzNtEJ1ylfEFSgs3w0LWyU7nG51c39Tn04KU10v1pSeQPNX08MMWRp/rY/7pT51XB10BWxa5br/99jMLPaH+NchmkcsC0sc//rH+m1KO/fACXx17YrFtkeu73/vuWQtrFvYsqFnkqnkC/WsB9corr+ifWqpyg75T/bFgjPz4ySf7uCza1OOdDN4bb7ixX1SKb/0iV5cTr3ZpB20f++hHzlrkcnxYcPa9PLbMS0CGbgtpnoiz0PSoPD/yw80jHT3R5d23w3KM0iW3nqA0dj/9mc/0+cpYAduewHyj883CGFvJiQUN/ewpPPaQ+aAulirfeeft3o54jx+/9oxu48TYpvOlbr75yU8OcqQuT3B5PTILhHwHOpC+/tznPtv/unP9NWjge537gR/bzL1LiA9s8Y3u9N0Y+EEmOQ7FvxbhzbUd/cO8NG0jOsVaF0Yr2Iu/EH+UMOXPFOghY6wPx/1bW+vYY4899tgFhllsAruamFo9mXhNoqFMxE5EJvGQiRmlLftpV4+iM2ATOQGYdFFuTJz8kb8Yoeyj8GbSr0TXmpzsKm9QYzoMduXvHE/a2j5ocdRYKnapaw5Ldtb29ZSemrujI76M3VRF/7y/a+JZG/NRsSs7S3p2FfM2dvR36Kigt7Ud3eZGyLzqItzNhNI8Cpl/6cjcZy7MKwZK++bPevG+FC9MxUd26uI88UzJkkt8LcbabIsxN205r+T8AeTiD9viFDfKOaLGXhF/D4NW1xKWclORuOs5Mv2efRCTvk2MfCLnZvqrX/3q5ktf+lJ/o5+bxMMgtun6nd/5nU7f7b0PbLGfuOzfesstmw9/6EP9UyttnHj4qE/SN8mhxXsLDp6KORcHevCjPo/dvg9rV1zSxenVRMBTMew3fd0paf280Mj4ztiW24x3qH3cHsuJsc9HF0cdG2C/WWvq2zO2sh8ZekLa9eOHPvjBzTXXnP3NJe3pS/OM0mJJ/LjyyuEXWMcQ+6Hsx4fg6k7+kkvOfXpF/7PNVoDnskvPfjqsBf6MHSTHFmx/57d/+6xX+dbCd70+/KEPbm677dbe//jDdij7lxbdafMqqCfNPvvZz/QLn5nTW9BrQSzH9xgs7n6yi+Vv/a2/1b+yGNuJFflu1le/8uV+IUy820CufLzesX377bediTX9Rt8XPv/5fo6or7iuAd2f+9znNl/8whf647/6DI4L+oz3zHMgX9vYmQIddIklx9VUnlvkGKSDvFjGfFKXcxYbc31ZgX9qXEB0VQr4ktythaft/JpuntzaY4899vhF4ZL//r//72ef5GovYkzCIW0o+yZE+ylrG4p8dCFgH29ODCjbSgRKE3DlCwV0tfsVfIu+MfBvDvFZOZa3QDzVj21RczSnZ208U76utZN4pvTwA/BM6WGDP3N2tLMxl9slf2NnKS9rbMBc7jJup7CUf8CzFE/1ZxoHOnIMBjlmBszrIXu++whcPB01d2zgm7NzlGM+cSD55EtsInXZZid8tkPizHbbhtJe9fJ3Lm5o/QjRF532teMFOuWKfqRNrsJbHQAA//RJREFUnQt/+9qQujX256AdjfVNfB+zETk0BfHFz+hKHmrcKHoSd3sOiQ/hReFdi9jeRgbIwVKuK/gnfrZssxtK7CigO5S4EneoRfJwxRWX96/+3Hffvf2H4r1eSDZ/MJqDxSM3xeQ+/OEPbT71qU/3rxJZuIjN1n7sWoi98cYbNldedWX/ipPvNY35CWL2HR430MjH7D3Nw0/wtM2dd97Zx0FHjd0TIZ4myiuZl19+Wa/r7nvu6W/6wzdAOYy1LIJ5SueFF1/ojx982jw1tMsnufI0jDZ5eV/nm1jSx/i1p29D2o31efsHxxoSh285eT2UPjH4KPi973tfn5dqE6KXb8lrEJ2eDrr22mv6J+ro15f1RroCv7x76k6MXj/zGptXVIH9vK6YG3c2yb3yyonNM08/07/eFuDzWiwf6jEB8ZUs3+XZU4Fi14bf02ueGsuTXDU+IAue+MIrTk/8iXMsRvxyindYlPn85t577+3HTIUFP69sepJr6MuLN8evu27zwAMPbG684YZ+wRj4I/d+TVCsnpA6ds2xzo7Fi2Gum4Mc3tDJfPCDH9h88Ytf7J+ylKuMQ/ozriD+O8YsSl3VjUdtFpzb3AB+Y9b88aXf/NLm05/61OZ93ViSW23sxIYSrziu6eYNMdPrib4x3XRY0OK7J7g+99nPnvmWH34Uf5XmrNhBts0dfDgKyGeBKzbQHPCyzY/0kTp+IrHF17SJQynfS/0K9LCR+FvQHV2xA7bxswXxBypfhfHudWFP8NI5xbfHHnvscSFxUTfBdfPRuSfv7NfJtvJk2yQ6N6mbIENzE7OTthN760dgojZ5ztnJSWLJjgl5yk5OPPUEUxEbwJ8pLNlZQnLG3lHiib+JaQx49LMT9BScxPkxpYMfyf2Uv+zIL3+nkH7m71hMyUlsjUE7PcbTFDJuj2pnKZ6l8QRyP2cnvsCcHnzpQ9+9cIMa+FCzNrKDvdMNI9DX4R3DmtzF56mYwAXt3DGf/M/FjKeOXfy1hDqmxtrpqPq11XbIfvjadvX08DWoOmMb2Q5Fj5J8tvkbn4PIV0p9ytovLQXZxi837OqH6vsakKODvjHZjOs2DlCvnVwrqy3txg/Z1AG7/I5sdCvDW+uCuj0G45pN+vk8d1y3IIe2keFn+py9MSTultjKmB+LFdp6tsixNdZfMGYnMhYBkG/+nHj55c0LL760OXXq7F/J8kFueTze3aQev+54/3qTG9Fj3U38Fd28YoErfRaK3YynlPregsOJE69snnvu2c0r3Q3/q6++0s9ldLBz7NjV/c22G2OLWT//2XDT6PtgvgNlxNx40439Io0n02Iz8XnF6smOFz/QYVHu9o4sPLATGnx1zAw3juAbSD7uPbyG9pOu3qLBDf2iHv314/OJtaJjOTMG0j/xzfeGfBz8FTG/+dbm0s6m7yV59dKCE54cW2P6l+bX2IlN9unxfadXupxbWBKrBQ2LhPUVsEpknf/5kuMV6Etf0qsvfZvH4t0Lzz/fx2fBS5sF0auuvrpf4LK4ZbGIrFedvFbnBnp4Uu/KzQc+8MF+UUl7bLFxqtP/4yee6PuTLxdfdHG/oPL+9z9wpr/wa6vn5dSz9aMfPdq/9igOfWlc3XFnN7Y63/CiavOALu5fWX2rOz4sTHnlzut6xqDx2lnYXN7pM74sFNN7UzcuxcMXOirY8Rqn13PlTaw+zn7//ff1C8dk4ktk+fxW199vd/3m1xKN7Reef6Ff9Kt+k72y6y8LSRbMbrjxhu54Pd6/PpjzQXJLp3xBYk2bY96ihu+RefXUYq8c+g6T9WC6ruti9bSaePWpeNXHZ35lDAPf6Peqp2PK8eWbZ35l0+uuP3n3J/2TlnTccsvN/XFqwdDiVp76oxPYyNjO/JQ2UM8eHvb5UX1ZA7KJR67q+J+C+KpNZepQ8stX+iB5wS+WNTYSW3JdQX7MX7zxBegIYrvmUD9lPta2xx577PFewkXdxPTzTFpjE6dJrk6ELY/JkHyd+CpMmpk4M2GPYemCjB8Xyo42dsZ4YkN5FDtLWBvPL9silwsCeZmC9vTzYfO/xk7GExtHsUPPhVrkUs5dhGlPH15+udfSDn4d6e23h9dUyPKpvwqdwNKYWnOMxOepmMAx0tohFyRm7eGp7WBf/uQl+xX26eFr0PJUsFPbq10UO0H1PX7UOmh1QNWT+sRLD5nqc0V0RG9K8vRGTn3LU0GP44Q9x8qUvSnEX2jzAtqT+1Z34oXIRlfa+DUmC9prbGPb24JO+YjPc/NHi/i7zYW+OFHGTa0LxmKJjGNrm7jJiY/cWE4htuNHcgLpC756wqL/Gfh33u6ftFHHfHwz97jpdPPp3KEumIoptoOw8ffkSR8ufqO/iX5HjrvGizudFvItHFj84Sf/8OM151EZPzJvodiybeHOB74hC3HmwIyxxD34PdwYe+IL2LJwM5zrfYtz+KSCBYPIWegaZAfUWGvI6thMm5zyjW4fQ/dkC7/4lz4Z8j4+V9T59WybB4vAqQ+xb9HCgpF+tS93qOZDGSLHlnr+KKOrlqBNH77++mtnnvr4WZc3r8fJm9gsAqWv5NdYkwc6Lr30sv7pLrzxA7TZ5rdfZPxp12bhzMIc37VX/4xHlBhCwxgbXrPiA1k+gbpqExKffs+3LvXVcHy81i865fqgPy6uuLLTedWZharoUiZH0WkBgT/GuwU749wH9LVB+h5yfGVfm0XKk76L1OXD4m+PzgRdFi/9IYxO38kjH71KelBiRvwKhRfY6n8soov33S5Wr5x2npzO37HehsXoKqsE/UvefnxIG/v6oh+PXS7k0SuXePBaSJdHYw/SNyg8dNFvXlbfInxIO140xtuCrBiVbItFOQe8CJLXIL7QyW8+pD37ydcc4lfib2E+GuI821+8ZGMLVT32yZHJL1rmj6d77LHHHu9FXNRdQP3cxDmFC3nDO1wo/mLtmNBhzk5OBEexswbs8Gdp8WnqBA7xFaZOjnjkNxdjY3BRnRPcGHa1yLXUz5CT7pydpXh2aWcu/xlPsTUGOtiZ6mdtiD19MGWr4zzt68+7cXH2IpdcuOkj6wJ3Wsf02OUDiElbKEg78DX+VlQecc+1285+7Niv26HqR7vND+UUD0RH20fh005PxkLqq56lY4SOjIexMaVdTnKz3vpov9qt20CW3in7LWIPGR9jNueQnCin4mnbbadMW/xlu22HxBrftvVzLdhLPuh3g7UW/E3+W98SE9hu942Jmp/anrgraWdrbqxNwTxtnlmSix+IDNS5p/oI7X6LVi77CotDKVPXYhA7OzcDhpzou4yXMcQeVF9CtR0O/BvmhDrmLGg4RrOoMdzUnw1uDh+qr+cYYzq22MU5juobgtivZXSnrvLzMeeU1EGrL1BvLMpjjTeIHaQ9IOc6BCKnLnZSBtrH+ip6lUErC5HFGz9aW8pqA1+OF6TNMaRkL1Tt1e3IofgXG3KGtGUsaFNHRZUJqs3sA7lKge0adz32yYoFT3RW+VqGJ7JQbcdGO48lhugIAZmax9SDbXWxZx9vrUfq5GsJ0UM2iK7MT/FHPX6xRG4MeOXvoA+XF7oio6wyc4hfMKU/elFF9Oc8MQUxO+6HsXfQD4E5iY4scIVHybYyuQR10ReQe/zxJ/pyLkd77LHHHr9oHHmRK5Pf3IRnosQ3dRMPu7KDzmc8TgI5IczZ+VVd5GJnzBY/6MEz5a92et4Li1xrxtOSHW3saJ/SkfwnpjHQgWcqb9pgyZbqn/1s6COvWvgLbUC3vLvI8RTClA6oYze2Ids1puixn/bK19pJG0THGoSvLaE9RloeeTMup/p6TR/hWRq7S8cIGxl3U2NKu2NJe3xOzsZ0BtGdGKbstyDDb/kjNxX/FMjTW+OpduJX2u1Xkleofle6kOCPsSIfbE99Z6ZFjQV/m8O0Vz5IjGzmnBRaQvKe8bYWjm221vYzG2RiK3L2K7KvbNsqEl90+W6QstWdY3LYjs4x3fQ5xoeFhr5mJB+pa9vYQW0+Kn8lPniiyhNF+S5XOycf+MjfQUf089HTD+HXHn5lqO4DueiIrLK1WwliG7X8QfiTC7Yi12LKHjmo7bEXSh04xshVZAyEB1oeyNjHW+eVlCg8gI9uBNHPZ8eeUl1rO2j14Kl2Mu9rH3QMMtqMEdvtGLEdahHddTvxnG3nQL7ytPVB+ldddCD7KG18jb9Vps01VFlEhs4gbamzDfbxyt0SEk9kKuy3NuQB7PM59XMgbyyQpbPOxy3Yq9e7a2yQoZ++jKEp0CsviQOqnSmfgA2U/Qpy5tuc6wEbe/jZU89WBV9anU8//exm+LXU6Tj22GOPPX7ReM8sci0t1qyxk4n6KPFkwteeE0GFNoTvKHbWYE3enID4sRQPtCevAI+TGH+noD25H7O1dpFryU76eSr/kBPunJ2lvO3CjjY8S/lHbBzFDizZUp2nB9z05TULIEc/HnrwRG9b8peNtn4bxEdl9bfW64Nc8NX6lOzG9tzYdQwsLZzOjV062NE21Ue7sAND7tctcs319RgSR3xokfaUIfuxNxX/FMRDRx27Vb9tMSW3yc1Snn5R0MeIX/p6TT4SpzKx2k98iJ7EXEGGvbk5cQz0oxw/a5GxtSauwLks8VS5xIxaJG403FgNP2xgew0GlRlDsaFUfwChsyGH5rzkpAWeMdCbeahFZBIHDP5Y2BgWRyD9Gsq+uThySnE4Xt599+C4Fk/Nn+3s13r9Fr2VR11rP7rXzEdQ9YlJLoFs6itPBb34QLvtzFuxWXUEfJP3WjeMj7PnvDGbmXPYyrwTPjpR7ZvhvDforH4BvviifuocnHY+0hm55DjXevwo6ns5YwXIZpy1fkQWaslO4sGTYzfyVQf+mhsUXUH8Vk8Xf+hHoK7NAV7tyjbftUTxk+0KY0qbejYQneaWOeBPzseQ+JV0xR8ytd/XILlJn5r/x+TZ4XvimPKtIsdvaA7VjwpyYsoYqhA3n9iZgniGXJ497oxPsnN5prf6g9f3AsW/xx577PFexeIi19ITSSZkE6zJcY7HJDp1AQEm0bmTUuxon5qI30t2drXI5cQydwPk4sEJh50xW2JJTFP9rJ0e/TwFfiQnY3bklR6+TOVlTd7ia2yNgS94jmoHsXFYO9rYmdOBh5018aR/bKNsB/iio9a3vLVtLfiXfiUfO7W+toN9fG07yAs66tilA+bGrrzM2UnepuzQkZj4MwY8a46ROTuAB6biEa9jKcfRlJ4xiCH6wf5YX1UCi6Ha+DQV/xTYSx+xRQ+CpVy8FyEe/QzGlHwkj8g4gJQ1l2hpzLegk0253zZPxgm55HsN5o65xFfjRenfisjHdvZrHdBnYctTcYcFH4K6HbCpXj58o2tu3scbJL70Jb9T11LGcmLLQpe6fHh5DLEXH5PLgf/sBSslX9IHAV5y6euqcw7RRWbKv9iMH4it2GcDxW67H+S44eNc/qMXP8o+LMkG5JJH/DlGUy8e4GM7X1efg8jyn4zjt+XDQ3fix5/ctvyJyauLg+6DxQcxIhjzJajx2I5cfAyNITmgf2w+1xbddCSO6ltFfElcY+eltNGFgC717JCPjeQPTQEPO2Tm8gSxnQWzjIkluTHEX/3FdvVBXPKvXZ+rR3NIrvmzJpZqg+34kxjJG9PVrjYyU/kkw1+L6xXk4p8fC5jzjQ+o2vAdNr9Oe5S5fY899tjjfOKibvL7ucl0CkuLNSZJk6X2qQk/Eyk9UzBJ5wQ4hrV2cnKYgpOX9iU7MHaBALuwswbsyMtRb6xzkhy7gAF2lvqHDpjKPz/p0TaVlzV5w7PUz3zFs2RnaTzF38PYUY/YSe6RuiA8qRtrB37AmK8tf+xUZH8oDvzgfyBGH8RV6iuvNQatPu015radbj6rp69tB3lBS8d8LkbHdLBDB5zPsZt4lOfTDogZ5sauuYMOtsbyModcnI/Zj65Wpz9kqNMXU/FPQcx8rnNl1b+t/79oiEc/K+UwcYkj1CJ1xo/+nZuvW2SM08HemP4pODcbR1NjbQx1TgD2K6UOEm+Ojfg4Nq/W/brNnhyeOvXGGb3nB/lw+XC9MgWxpEzM8av2dS0D+wMNceXXa994Y/hQeYuDcNkY8mpxzCts+GP7QO+03Xo90bZPge6MLZTYEy9EV9XLFsjH2uOaneG8cvaTU1PAz071heyaG2ZxkEegv7OvLbbVV//nENmck8ZyzdfMDaBt6fjDU/2lI/rnwE6OVccbmehKjOxW/wI2EHt42hyk3fwRf0KtvtgDumxHZixubeFB9OWcF/3RqX0MePRd9I/FGMSeXCmTqzHf1oIeuatjAdL3bIzNgS34RgbfWG5bJA42YpcO+0g7HSj5ia/kxvI58L57jr+D3kF2eLL03Kf+KuKHnISPjxa5/Arm2id05xC9S3naY4899liL/tcV5y4K1y5ygUlvDJm85+zkhMLOmK0LZYcNeuCodtacCOfADj2/LItceLRN6WFnOKlOX+DxM3rG7ABf8U3piY70c+rakj/JW+qDtCvpqe11OzrGgK/qDl/Ln/Yab+XJtriXxpS2/AXZrzgFYvCrVtod0/3PfE+g3lCNgW5xw9QxIv/8PerYxQNzY3dpTGkHNsbGlHjCcz6PEXCcwJS/7Mg/HWxN5WUKQ99u90QWe+ySm4p/CmKWv3qs/TJDPPpZKSb5SFxt2UIe5HKbRS6Qe7RtDqcWuegC/oRAfd0H9kLZT5lt/MatUj7mjoEW5NxE+ZW4anfX4Ksf27j66it7HxNntTkWG8iL/s4x2bZX5BVEY8Q3D21nXh1MDTbzimXsR19k2+NMfeVpIY8ZH217bMRetRtkjJCtbVVfyix+8LH1cwx45ZCPdIyNyRZk8q23gOzaH3sgJ4+InH1km+0cu2vBf7og/YNqHHgc3xAbaA34ZozV+XLqHFDjwsdW60fibduCtGceqzzq6U9/QfzJPrCDIHaiU9nqrcDDBvnIVn3k52COob/60yK+IHr115xP24Bu+aE7+tTZbvM0hhrrUhxQ42Cjjj11tZ0ubYhP1VaF68Cxfh3yZgylb86+vp3CoGfT/7pp+J3rXnnl1f77XJ3mvm7wZ/7psinkV8C3OXb32GOPPaZw7sx4nrBmEv1Vw4WK+b1gx0l06USe9rX+4hujICd3lIuAejGgzAVjtsd4xkhbbI211faUyUEoFyK2XWyE1LX7bV0oF26o1dPSYDN21y9yjKHm+VcBFyqeXdk5ih7j4DA4jE220K/KeEk8geMqx2fbNoXD5ILMWrnwosxF5qW5uQ7hCzLfJLbsI3NOnXcSO6z1MYjcirTtAEP/1Lm5Re2/Gnvdn+vjVi07w0fvcy46WOCagjZ2kt+a4ynb6smh2ufp17ShCnKJL/qX7Ga76oru2I79ajuo23OoNoMp2dhAsRn57IO6xLYW0RlZOUluq03HlG3taBsbdEcOqv7Adq2PL5EJ6n6NvSL2lHjCFxs1XmXqo0uJB6oPY3pbxA7gC6U+bS3ojT/xcYpXfeWJbPw8KvgQXxJnrZtD+CG5mgPetk9qHLZD2hN7KLYq8NLT+htZC1zq1y5wWXjyNK6ntuofcSyIX3PNsc3VV1/df/YA+ePqUB7UrSWyWUjeY4899jgqLuouZn8+95dnE87cXy5MsJkkTahjwGNV/yhPdbCRyfwodrRn4p+zo5z6a8Iu7KwBO/Iy95dzJyxgQ/7GMJzU5uPBo5+ngAflZFtBN3nEj1aP9pTR0eak5Wnz1rYrx/wI6vYY6A5PtdP6BdVO2lPyBTIm1bc6MhZaf4P0T8bLFJa+j0eHpsGXn2+uvfbaoaED2/5KbhFs6UmuNccIn2FqTGU8rBm7Y+MhMP5haexqn9KBB7Ez1Qdr7Rz2GAnkFqb0kMcjx3N9HWQMg21xiGHK/hjIpM/n5voxsMlnGMbdLzeSQ/mQh7VPlkBk5WGb/EP7VFbbr4Ht7POx8lc+4P8YGcd8XNtf9PJPP5NxTNOzBsOx6ZtczpXrx9W24I9fjTVHgrys7YMcc3Pn8xZkYiv9nfxC9scwNY+n/9p+BHlUP9bf1XZoW1SbxnDGcebDtKfMMV9tktFOZmoerciTXNFJx9jYqjzsZlsZP4LY3qbvEZvJo1wbD5C+xZM5kn7lYcDn6Ger6mJDDpXmAvVtLioyJqrvY6ixkEnMsaEuuuynLnrHchkdUHlSn7GQGLI/hsjjVbLNZ9vpyxpbckgnVL5dQhz8qHHWOXoMeJO7xD4HseRJ6sRBbgx4xZz+nAKbnp5tczLkTf/k6b71T3C9+upr/bEpNotRt9126xlZutjKD2qwcRR4Mva1117t9O62P/fYY49fPyzORkuTtHaT3dJkuaRnDdbYWcKaeHaB95KepbyxsSYvSzxsOFmHnBDHKCdqJ3fkBirbqG1H9pE2utmiK9uJL346uR+cfN89Q07UIe1KNxy+BYJsh3LBUeXVpT42qs2xHFX/zieq7daNwT7SMN+PSxiL8SiYy81S7tb4sgt/6VjSs+u8rEU93trjYQ124fc29n5ZcJiYksuj5CP9lz6t82GdK/Gkz9nNfJc5LWQ/cxeebUF3HSPbxpY4zje4GF/rzd35Qs4BbX5zTpjClG9TfW47OaeXfvbYRfV8NGd3CnRX20qwnXOu9thGsV3jju34uoQ2D+Ta2I33Oua14al+Vqgbq58CfVBzl/yCdnb5g0e99sOi9h8/6Y/P2W7zOQU8fEoupvKeWMQQ3vQbG7EXnpqTto+C2kZnQDcdfKk6p3yjA1+NOds1JxV0qVeGf8rPo4DfbCdWcaqbA7/4hH+p//hPJ8K/NLbavppC5oQ2J2Jhi/zaBS7IAheQPXnyZF8mvkHPOl1rIIdePd9jjz32OCoWv8llUs+ENjZpZ6IGE+sYcrKasxMdbLSTc0AHHMWO9pyAxuIBvojrfNtZQk5KuUgZAx7E1lzexBM9ObkpQzn5pb4tQ0HdXouahzYvdV88tpM/qO1L441vdEDV0cLFq5gTd4ulcZAcyC+eo9rRPqUDXOwbc3M8g57hwvH48WvP+EjGUymeqqDnpz8djwnWjF08MHeMrBm7/GNjauzmonJKD/mM3Slfw8PGUews9fMu7MgJO/RYoKCH3uSqbidvymxrg+y3iA4E+EP4+TUmN4XoIj81Fn6RSGzVt/irHPNZ/h2z4JiZ6u8xxN7SsRwfQMkm/uSzQn2o9je+Wr8WS/PRGMgYk2wZI2tlE4t5Z+58uQt4BeeKK4bFkanjawx8XDq2W0TG8eyPI2vyTwaRwZ99SB+mP0MV5OR9m76uYCvjM9vVVuxD5ik5WdvXZDL/6evEVyljvm63qD61RLe8Izog9thG6vX/0nyU46DGXRE7/MRjPh7jOywyfhIH3Wv8bkE+Y0o8Yz5qZw/oHzs+5A6feHPuWYo3/Zi5gQ0lWW3qW6Q9uvljv0V8xocHseX6BVIXPbsCvzPfZa5jI/7Yb6/D0gdz46lCHHShxDGWgwo28LMzBU9Bjdkf+tY9iye1h75Zg6effub01tnwoxt33HHHWf3je1q2j/okF8jviy++dHrvcBCjPCv5t8cee/z6YXGRyySWSXNq4sYDUxNJToJjJ9YgkxEbU5P9Gjt45uLJSXfODp65iXFXdpbAB3acOMegHfEH0j/qUoYOg7a/6VGX+rZdzOrkrfKBbfLxdexEHNSLhYrwp39y8dEiMbM1xQNLN3tr7IA+SsxjWLLDT7rIz42VdYtcQ8zo2muvOZNv8CtgjkF65r7ZlX4MjSEXWlPHNLv0LB3zSMxTcS/ZkTd25nTA1JgK1tqhYy7/S3bWzGF0sBUeumpfTNlXn5za5kcLejPWqh5jFNic8m0K7C319fnGlA/qUDtX6wd5GPMZv3xoX3uzF5CpY8A+35R1ewzpk1C1m7Ii+vChtRB7q38JYsrYlbM1YyQxg4X38/1T82xdeull/cfn587NLcjp823yGBnjJGMkSNxtX4en9tlU/sfqzdvyPnZcx061m239RV/sBnN9X+eDKXvVJpKP2GYn7RWxqYxc5WMr/o4hc2Nk2NHXsactfkyNU3z1GB2zRd54r7bomvNtW9Arz2zBUuxzoCvHNT1VR47dGqtY7FfQgbZdRKq5is7oQhXxT5wQv8b6gWz0Ap6ML/KR2yXoly9ltZE4+IPEkBzi5WNi2zZfmavm5KpMm9OAfBa5AryDrHOgX2s83bAAcVhkUo5Bju680yKXRdphrHglnQ+7WOQCtp977vnTe+dCbGzJyfCjIwc/tBS45vWjJ1Nx7LHHHr/auKibYH+eE84YTKwmTZPX1CSMB0x0Y8hJYM4OHsRWnaQrTKwwpWetHZOjWKbsiAfPtnbqyafGw1ba2rJCXa3P/ljex+QrX90Ob4231Rk7lVpkLERP5RFrxoG8jOlgAx8kL2Nw4eekNHViyole+5gObbE1xQNHtRPQk5jHsGSHn+yQr33UYskODDEP33bwQVAxBJ5KcaFDj7/mTSEyc/6sPRbnLpLFjKeOqRZLdtLPS7mjR/6PYmfJV1iys2auxIPy5EDN31QuK8jiGxtv4qiIPmNCG5kp36YgL/H3F4XkrV3c4Btq6/GSaesBv35Mu5xM5V3OMgaT2+Q/UJ99ZbuNyCuNm7RD3R4DW0tjsoX4oLU1B3aQWIyPHCf8huQhFL1K++Ykr7nYPp/go8X9bRbU4rNY5voawhv+HO9kKkGrJ/sZK9v2m2M0fVb9iN7oqnblQ3+Fd41NfBn/4Y88Ck+QbXbJKMkoq2/VLyAXOwG+zHst8GYMxoZxqAy05Zin1/FbbcemPkNjIIcHL1mkjk65JFdtHhZs0MkO8JH+beffgI/JZfxOzmzHb/bw1XEbpG24RhjOIXPx4hcDO9EN8aMFXbXPIh8/Wjv0aE+eUPp0yqfDInGwkX6ouQFtePhV/U2uWv4W5CJPth2/Y8CrD5ODOfB5eFpr8COLQMP3sg76Zw588ouJmePHcOONN/VvCtBPp9jzK7O7WuSCZ599ro/d9/t8c3EM8hNqYZHr1KmTffx77LHHrx9WzUZrJsY12JWeo6L6YbuSibJu5wQ7RiZfJ6xQ3c9JKXXKSq2uTNLVlwonD5STey4+ciKu+6juj8m02y1P9itV+9mvVNHuV7SxbYvoXtJzoezsCruws1bHhcrdhcL5jiegZ07XLvNmuz3O1iDzyBiqrjF9u8rTewWJcyyusfih5oZcKOeDzOGZ61Gdy2OLDv2XOVY5tp35NnYrLWGur6cQvWvkKk+2k4PEmnp667mhbq8wdWQI63RoW2PwcXAyMaW/a7w13zWPU7FXUp+2KcRuO9Zspx3G7LVlKP6hyCtjq8aY8Zw4Ux+fIldtZDxnHIOyjvXwtkRPRfRX2E8eYjt6W/m0IdvxnVxije0xxJYST3Qh+9rooOsoSM5BHAhSz/62qHHxL/NSzUl40JgdvNrW+KNOm5wE6qZyQy8fap/FXuTG/AH1ta3q2AUSJyRXYzbUZTzzJzL2l3xKrsjRHz1zkJOMuTY3ED1KwOe1RHLDAtTwR881C1z0eOrp5MlTkwtc9B87dqxfcDo73qF/lmwsgd91/PhD7bFjfqXRItfBN3oryU+VqRh8Otqxuscee/zyoj/65yamTGRzPEuT29LkD2t4gtgbo0ySyIQ8RmkzOY5R5MfaEFm2xtoiW32qECeqJzcnKPvKnLRCY3UhJyKUdtstT+Srftuh+LMm/2PxVETHGp6jYld6lrA2L3OgY05P2tboWeLRHp5zbU7Vn42l9rVY6+8c6Fjjz5IeWMMzh7V5mbMTHUf1ZddIXx3Gr7V9dD4RH1r/49dSfWLP/B3MnQdQ5c0cq2zn4czNdQ6OzzDl5/kAW4k1cdfY63kybUHlr/V0JrbEnDjRwNMX5xFDPhPfHNo4EmtbVkodsHEQ17mLCOrGEHm6kuea79Y+KFF0xvZYroNWV7bZMW5T1u1axiYkpsQYm6Fch9iOD/ER2R7Lx1h9bAbV57TFDzSlN76JO3HahjE5usPLnvZqQ0mfbe0o+rZBGw+dsWNbXXxNvNsg+Y6P1UZiTjxKdlpb6skgqP4GZFJvO7rCYx8F0Rn/KmpdfAalfXohPqurfEcF/YmDL+wop6AtPvNhjR+tjfTJHOglMxUreXo8uYV89zAyWajmo++vLvlIj6eeLHBN/aIwPzxRVX+1O6A+Ntr+3QZ8RsE111zT/5oj24eBXFgI22OPPX49sXiWzkR+WNSJz/a2lEkPjdWZ/ExkOYFoz18jM9lXCm/a6j6iL3qynf1ALCgnRCcIlIu9ekMznIQOftHPo/jIdviqXOoinxOq7bqPcjKpvh0Fu9CzpOOo46liSs82eQnvHHbl74XAQThjNxBDudQHa3KyFhfCzi76kI5d6FkzVpbspH2NrjGsjQXYQGtshneM0v6LhBjM1S3MlZnDx3zOHJ9zSZ3v1aU+5wN26Kxzd53Tp+bpOeCJzW1Abkl/4g3VOkj8yUEbb40ZbNdzVOKdAxdj73yCCb4kvjmq8VZSD+IUW+3n9ryc3NOXcomS0zH7UO3GtjI2gzmd+s/1je1c+9T6XPuoI0NH+rUdw4k9NJUDZbbXYkyGLyn5xk8lJC/KJeBD0UEfuSl74YtPKG1AVvzq5A3V9iXgrfHQlRyixFb93UY/VBll+quNGdTjSRyRA/z8SZ7rOEHVR75X+eSugp7EOYa00xF/qo3kJvmp/hwF5B0LdLFPf2KeAhmUePgSP1uENzbkhY2pPEBk6EwuWpAfcjLkzbbzj+1BdpBTPyZf8bOf/bx/guutt/ww0fhrfXz3rba6wDX08+mdDkt21oCOXegJPNV25ZX7X2rcY49fVywuch0FmbByMlIiE3dODPWCK/sm00r+eoDCU9us0kcHio3YDHLiNek7ESATei7c6iKUeuS7Hv6qgWzXBSp6IhcdZNSHYie20baIzNLEv9S+hMP4dhgc1c+1WBPPhYp5V3bWjoXwnWs3cr9ccb9XsMt45vrwqHYiv/ZYw1d55+S0mVszV2f+XWvrfGIqbvXqUM47KXN+ybkkbRXmcvN8zgdjC1oVsbcNyLTnrDWosc1Be/pNnDkH174TS85pYmzPackvbOPnIDe8Ona+wZb+SE5qzCH76iHXAWK2XWPOuXsOsVVR7eYYQbYztqrdUB1PY3bVRXfGL70Zw2PjOHGSi+22n5GxHR8Sf+wdBoeVA7KJs/YVn/goP2uRnAI90dUifQXyIXb5auNI7oAMWosajxyjGgub9KvHw58pf6eQcUEufTmHxDIWK3/ipzbjKjFk3sgYiax9BKkTIztL/aZd/GzwJzYin9yHhx8Z04eFmOhInEs+Ar/SV/EnOWnBf/VshH+NjZrjFmw7DujTHBZ66/FBh19BXMLrr7/eP8VlwWwKnqg6fvz46b0B6ec99thjj/cqLupO6D83KSITaibVWuZEa1Krk27lGatfi3aytB/KPsSPnLirnG128SSeKZj853i00+WENAZtTlpLdpyknIimeOigK/G00Baio8Zb4UTNDhpD7Ggf0xEbcjfFA3N2yIuXjlwwjCF8cjtlZylv8RXGfIFd2lFOxQNuLnJhPAbjSdtUH9IfW3N2Mm7pmLI1XLD9tI/bdwzc9ATDDc3w0+7+wjUVN6w5RmCun5f6CJbGbuxon8uduKeOV1hrZy4eYGfKF4gdeYsMxM8Q0FH3U4Lc6a/09zbImCUX2dShui3e8IhNmzp2bbe64k/1KzphKr/nG/FBDPE9MYYqpuKpMTmuYdt+SN7IoLVYGqNjiK3qd2KHxIRqjOY+mDtmWpBxnJAnt9bP5N+4Mv8cFuwOZV90vlioc6PrhncYu/ofEm8osnOQ/7nzxRjIxGbstOUYkscxnvRfypD9o4KtqdeRKtjT32xu09fikg923HAvAT+qsbGXeFPPvuPwMEgc0UV/5nl1rc/6BNTzw34bP/7I0bUUKx/w0lftT4FuMnzCu8QPh5EJ+CYXY7GmL5JHSI6yDxnL6shAzantJZBDuW7J2Gtl+SJeWJPPFolH3Pwbs9GCDJt4azz8Te618Ud7tREf19pIbC3orWP0AEO+fSvLq4uu7+jgG7tj41O91xM9xTWHG2644azryIB+9vg8+DXEqOvT/9tCvkC+dgWx+6XIPfbY49cPF3WT8uysOzZZ1YnadnhS307kLU8oyLYJzmTpRFGR9kz87Qkt7WyYcO2fexI4QE5GUzy5GGntBLu2gycxVGiLrSkecALia5u3gDw9/Jizwx96puzM3YSRFy9bdMzlDp+T2JSdpbzRkZjm7PDXCW7KjvGUnEzlZckOyP+cHXmFqfwDO8ndFNbq8aFR+fWYdm7UgY9+5rmLrPN5yPEUlvpg6lgM5Cz5W8qd9ilflmKOHXxzF0ZLCwiJJ3boDGID2Kk5SX18o0c81de6HV3q+BL5IO38Xbu4EplK8k4Oxd+qR7tY6sWvPlfHr7E+q/J1u9qc6+ujgo2UbMVu6tVVJH6Ib6mr/o9t0+lbICBHclL55kA246SOlSXMHXNTsabkW8Z26+dYfEvH7xjIiCu5XHsjEr/Z9sTAHOKfgkx+HYxN20O8dGVM4xvkkhuox2F0LiH531aGrRwzVW5KxxDXcO4PbIeyX9HuV8RO/A5lHKXfQL15JTxTYC/zgX5eO07ws0d+zS9chj/+Ab/J15jl9zCLXHSDWIcxNNjJvKe9HkPizHGkng9KdfW4VE8X0i5HGTst2EDa8EzxVdCfvERurg/w6i8+rrVRkTjHYgX1GQ9jiF3tdKH4LTdrfIkP6RMy6Y9WXntyTw7f2jEaG+Qjt+QfG7UPK3/ijU65QOygtTmoftFXQZbO6Gntx5aFpo6714HiM9l6rhfzqVOn+utB/k3BApd+p7sF/cMiv0WuYTEzfXDxxdPz1RzYAnHuCvzaL3LtscevJy75R//oH/1hJs2WMlmD0mRYy5BJVmmCq/UovEHqxuzVE0StDzLRVn0VOdm0J4gWmfir7gp2EtMYdm1nqj028E35AuwkZ2Oovk7xwJKdtM/FU/twDPzg79yJlZ45PxMPOqodWMrbnB04qh1gI/mdQnyZ0wMuOOi5+OLhkf+Aj/Fz8Glaz5qxC7vInfYlOzDGExvxN/vkQsZk9Ngeo7RX+exXu/b5m5i0Vart9lOGKtq2tNNR8xJ/Qq3fCA9ER6C/q/4QkKvjNrq0j8nNIT7y+SiIHmXiU8oHyrYST40bsc/3WiJ8uUGwH340BvzsKCv/WvAPtpFJ3Chxh1If8KmWMNfXLaJvqn0MfIqP5OrYWQIZ+XzzzbMXKgadQ596KsBNk9K8ZTs31kKPz2dj8L/Gi+hLPtai6l8rh59/+DNOUp98aVdm3KZMfaX40FL1x3bGtmsu29lPGcIbOxXalhCfEtsa8DVyfAkSR9riU0ptQXhjVxke22tBN5maC/vVLlKfvNkHddUWfqh14aFTn6at8qhPW/qpts8hfPEV2n6IbceJtm1tjKGNlQ117GQ/wIPYTD61q+PPmgUkqDboyLhO3C2qTjxj/TMGfHJFZq1/Vf9UbtXRlzjIpG7NAldiV9b8Atn0K30VeFHiwWtfGZt0xn91nqZ98803+kVjOsdAh9cT/aGn9ScYfI6/A0/0TcksIX62cR4FfFr648oee+zxq4mLMzFmEg21F0/2Q5Uv7XQoW8pE25ZjOOzE+MuK5OK9Evcu/Jjr322w5Muu7MyBjV3aWYppTf6P2kcH8keLa21eWn/tV2rrXKxNUS7WUOqqbKWqdw3EU3kTXy2znbmtnQczF1aKXKW1aGOEqXiq/vhhu/qwhPCt5a/AvybXiSVU+9VFfi702xLVXCS/Ne/ZRu35K/FsGxewty2mZOI/Sv+2sYVapF9QjTdI2xqEd8zOFKrMNnLhF6OFK9+JGRazhgWtyy/X7+n/ofS6zcFriIOttr/Tr2gX2DYflTfxZcyGMnaznXKuvxNTjbeNu60PpR1avWCf7TVIXlsdFbERvYkLko+xeEE51Xdt/ParniXgwRs9YNu8YD++QWtHW+xEvtYH6iIHbZyJ3Tae6FmL2CYbfdEP1QbEl21sVCQeZWJtbYzpTl31DRLzEtrYan/YVtfqBm3hBTpango6whO5pVyRQUBmjl8bHogfa20kx2P+t3EGeONfbFdxdRbY6lOLnVS/uGWha+obXPywuHX11VefrplGQmP3sE9vVfB5KV9jELu43nzz4DvKoaO8Ir/HHnv8cuOibhL4uUnSyX8KLkZzcTCGYfJcfnXJ5IlnahJb8+oSPVMnjtgRz9zJZc3rfXM6dmmHHvJTucUjv3N/DVrqn9iBKV+00+OEOGXHX8DIT9nJX93xTD1uzI685JWJMdAB7EzxiAnfL9oOyNtc/6zpZzZQfaS8BT1obsx1kXc23OT/tO+PY8cOLlT4KB8/+cnPutxc3ukY9wUydpfG1FQ7aBcTPS20gbE9lpe0sxMk5raMnfRRzU222Zkbu+QB/xQPO0c9RuhA4prKC/KaKR3p6xBM6a4QLz1zx4eY61iyz3/658bhGOgzZryiZDuo22B/iiriU409ccudbRS+OdAttuhYK6OvkyN5jP0lkM04GLNV4802vpRoSnYMbMFUX4+BrRzDY+NwDPgzRvjmBgLoqKj7iYmsMcmWbUisLQXVx23yAcbi3HE6BnbqPNHGUWEfJS6IrZZ3DHjxKSOX7SkC+Yc6FqfsxUcyySPQ5TywNJ7FhfBnPqi2oh+q/mzXcUVH7NVtfMZTchiQ1Q8ID52OR3KpT07GQEbc1Qd1qc8xoz06oy/jW70SkUsuan2gjVzVpY7fjsslf+cQ24h+PtNFd/r2qDZaJD9spz8TNz8C++ziQanjY/ycQ/qDTtt0pU8C7droig8VyQMdkcdT+fBoxzdmYwzRS8+a3OKXN2X6idwcqowYW8TXVg9eMrE1Zmfw25NkP9kcP35NL2P7lVde6c/TYzLiNXe2H5kfA15/pFACPzwxxe4QT1+9FTK2xFyRGKf6wEKWmPChpb7aY489fj1wcAe5gLEJuMUanjmsmZjwHNXOGrxXJsm1ObkQeK/kZC2W/P1Vi+cAw/ExzT9/cRc4zirlospFTchFScjFGnIzgtThrzxkhgugAx9zYZILGRc4LtpD9pEbLdTWI3rIoqpPfShxjEH7LrBkZxskF6jGtUu0fsb/o4KOjJWMDRfPyNiwn/EA6Tv9mn520epmPH0enm1zkP7fFrGzbX+Gt8ae40GddrprvBnT6g/r77bY1kblb/Nhv+1vZD8xkzeW07/irWN7zJ9t+zo4TP7I8LPGVuNKP9ZxLNaglR1D+l3c2R4b60t5ia2xnGecAR3osPlITlo7yYOyjm18keV7Hd/xpfZp9bWi8tFlnw76ycTOFMjIYYvIx7/Yr/3Gjv1ajz/1dFR+YAtpS35sJ27yh0ViQemDUGxoO4qNFm0OEkPbV+HhR4B3bczkE4f+EEcdH0CXutofFdqS5+Sn5dMn2vCM2RgDPWLAuxRL4oiN+DOH5G4prjFf5QuxMWXHHzqHp5h+vjl58o2OTnZ5uHRz7bXX9sfuGPxxbc0CF8jJii7eCfxB5ZVXXt2cOPHK5qWXXu6/sVXJL0Qm52vG3R577PHrgf5JLpOsCWIKTthzkyl5yAlhDDkJzJ2Mj2onJwp8c5OdCZ4fU3acPOias4PYOUo8sQNTPNqdoPXPlB3t5OdyH1v8HYM2/rognbKzdNLPSV771HhaYye+TtkBPGzN2VnK21I/AxuIv1NYyv+afmZD/tzoTIGO5BdFJ9jOvm9yicm+X1gM1MVPv0rm4qfq0J5cVTupq+2xZ39p7B4ld3TIH8zZcUy7UZzC0thd00fal8auvMGUHWALzR2LXhfQjqZyMwd+0DNnI3mNr/blSTmXS4i8MpTYbVfQjWIn26D/58b8GOjn59y4abGtTOLR3/w1j9RcJvZaAt3IvpI98mvBR5jqtzFEZltb4uPn1BxaIcbksNqD9Kcy2y0iK65tfAR9MDePj4Gt6tMYElOlHDfosIjdNietH3xUlzxWVJ9CGWsQuaUYgYzjLP0GeeoBohtio7UXxE4bY3TZznGjr+f6G0/y3UJ/J74K/GIB7WvGLrBBjjx/MofzQZy2YzOQL3J8qPXVfutf8kxO7HPnvsOg6mc7Od41Ykde0odyVftKHcrYgfRJm5cxkMtiC34Ue2NIH8Yf1CJ+JzfKjLOpMdUidsI7ZqdCHPjZ0N/k1sjwE42BXefFMT3soMQ3hvzSIV8sAAU33HB9v4il/uWXT5z1y4rq17yiGMiTNwISA19OnXqj8+1gPGyL6Ko5fO655/v9PfbYY49tsWo2qie2o2BJj0lt7uSwdOIANtbYeS9grR8XKp5d2FmT/7WY03Oh7KzBUl60x1/kAqeSCxalNid5F0zIxVnIxWAu4NJuO7Kogs3Wr1w4eaT8pz8dLsDth+y7EMxFqguLXCghddE7pn8MS7ldo2MNzxKWdKy1sRTPWqzJy1FskV/Sob0dN0HGo9IYy7gzDv21FxmXGYfRY4wYM8aQMeVmOk+pqMt4in+HwVJcY5iLtUWr274YcyyKObpyjOQYyo1UYtzWT/zbyuS4PCrYrf3dzjvaqh0xZr6wveTHYfIBa/utIrZCdGQMiytjWHztOF7yke52flRnO2PdXJq2ubyw1R5f/IkvEN10Vr2xW3XXeOlNvG0O6WfLYnqO5dglRwe98T3HMxJjzhU1vviRsrVZwVbsjGGqH9gSPyRnS6An+STP7/ibGICu6nNiU1fr2VfP/1pPXh3QbXsuxvcikiuUXCUH6VdQh2ps2uWm8o2BjLwYA8BG+iH2x5D+St7H8so+0pbjCa/xmv6cA97EjpZiwZ9xw27G0hxiI2OlIjE6zlrbyRt5PFO++cVEC1uvvfZa/wuKFa+++lpfDzfeeMOZRS2/ophfE16LMf/4dhTQORXXHnvssce2uOQf/sN/+IcmzrnJWfvc5GNyywlnjoeeuZPMkh2IrTkeE+1R7KyJB5biiR9LdtCUHm1OiHP9w86cn4llyY54luzAlC3t4ZnSw07yMgU88XnJ1vmyk7bY0V7r5CptldTnAib7tb3qznZgWzxsIb63FB7b4Ql/yHcYfG/Lt7lc5AXachF42WXD902mwNfonkJ8n+LRvmZMLdlA8WcMa+3AnK8IjhoPzMWEh66leGCpD+aQmObkjVXtfGITxb+M45RVH7+QXIQg2/F7zjZdbEV2G7ixIDenv4U44ldiqXFrt5/48amDGlcb25QP0Y9/LfgB28hA4pnyJYhPNe7sI0hsNdaUsYNqPy8BP7Cxhr+Cj3NjZCymShm/KHyoxhIK+Ji4Ufo/82dij1/04bdf44ve6ls7ziB5jL3sVwJlZLNNX6jGGzuxPwY6Yq/GmPiAbPbjxxhiJ2SfXIU6xy7fEvsY4teYvdTFnnLKr9iTDzxiq3qVCB+e6Ep7oC2obalP/rXFBl2pa/UdBnSJJf7TL/5d6U8OYkMcscM2W4H65D6wjeZ8qTZsW6xhC0HsJa4ptLZbxI4y43lOH9BJBt9a/sSBP/maQ2TiW0XsjulJPOTnfLPA5bXELIK1fPYzPi1u+2brlVde1ft0GLTjgu6joOqK7xbqpuLdY4899pjD+JXPlsgE1E7aLZbad4U1duYmzbXxvJcw5+uv6gmixmx7jJw0Qy4SKtU6J2tU2xAdrX6Q0ynKRVvdj0za2vZstzwttXqq3EAuFFxoTvX72XGcb6yxM8czHsP5w4XKyxrswhc6UDvWXdQi9XXsx6b6jKlceI+Rtlx0175q96eA5zBxrtENNXbbiV8dUkdXPZ7a4wpanrZ9DIeNa07nFMjEXo058aZ/EzO0MdfYsj9Wr4TDxHcYGTbTX21cGceJscbZEtshSDwZwxnPGdtuFNtxjpKT5KLmYy7fsdfKj7VVnVN6E7f91KUci7cFO4mvxhgfsg3REX2xhaZiDW9gOzHUeki8QStbgTe+Qvxo+WOPX2TEWHML1Y52vJFRjzf5qDZqfeK3Hb/W+LcW5JK32E1/QewfVj+QpSM2kqvUV93a7dc6vuCv46IF/rTbTo7IAb2JLzqqjUB7fEs/VdhH0ZftOdCDYn+Jn2+OP7rxi2ONDfkd85ls+rTVg5cMJPYWZHxU3uuCc095ATv5FUJP01noyrXAGNivhA+N9U+7vy2WcrjHHnvssQ36WW3NxLSLyWfJDht4lviO2r6riXTJzhrswpe1Oo7qb+xM6Vlqr8CzhuoJtZK62t7KKGNnjGcttRAjysVGJRcoLiBayoXcFEVn6Cjgcnyn+2yoP701EtthcFQ9a+NdsnPUvO0i9xVL/q6JZ5vc4kUZ6yHHSm6QQjl+Oqkz49NHanNTn1zUMdze8NdxC9nexufI8GUbOYjdxF1jr3NEdKNqKwRiqceu7RojVP41ILetDFR7c4juxFNjTtsUATviC43FPAZtaWdrLSIX+2OIf/SixKRO2Y7jdoEr8ScHQWzXONu+zn6tCyVHibtFjW2MwhP71UbkIDHXGCsl3sSpzHZrK/ZiU1mhPT4kNgTRVXUqY6faC6UOoittoBQDf1MXxMfYhyo7Brxk5BJfchGZ1LGJF1/irOA30pZ+ia7EFFvK8Fc7bECby/iHv/VvLRJHZOvYqfr5UP3aBvEvccQGXZUq6n5yp0TxNz6Dkv74Gd62PwCveuVUTJFteWyzYR9P8jOlB9IO4iY3hzEbSzJ4ydScVCTnqAJvfM+YaqH+7bff3Zw8eaor3xrNaQtP+Vvo8uRX4vFLicpLLz2Yg3yoPmXmn2F7oORtV4jvYzl6r4GPIXnYdS722GOPo2PVUblm0twF1tjZhS+7imdpImYnk+AY4scaPRcCc3biYy3HqMY8RkGtywkC5SKgrQvl5KseX20LfwsXILmAQC4oQqlzE19v5Gu7mMJHF1IXAr7sAkt6trHjA/QVg+g6+dqPY6ixz2ENz4XEUftpKZ5dxdvqSV+MUT1OcnygHBPD8XJwcW38Guu+U+L7bP766xWH4SJ5+BYIqmN+DfCNHX9zWCPTxps4sp34UXKQOSG8iSXHdHt8TyHHerV7vlHtTVGNeejfg/lQCXwXYzu3pU/Tz+HfFoeRi5+VaizpP+SGKt+JqtT2beIYozYHKN/MqnlJTlD8WovW3phebVBjrts13lrWmMMfVLuxzR6KD+JEfNEesAnR2VL6wzYk5wjYY6fmts0jRFdiiN0AH7nWv+rLFOID2/TGv9iUPzzRbbsCH/7KQ5d9/ib++IAnMtoQPiCX2AN6Uh/e6FyD2Iq9Nk/K9EH0V3/XAG+NI/pSrxzLW8AH/ORqHvHUeMWQ/fidtorwRg+eMT6go+XR57bVZ0zaVq99yh4khilEvtqI/iXgZ6e1D8lfqwdvYuMXnhbDGBu+BfjmmwcfkZ8DvZdearHq8v6c7w9cnv7nnw/Jm3uUV145/Ips6iyCIfGjjLeKsfjea+DjGCXX8rCW5CC5ILvHHnu8t3DRG2+88XMTmAu/KTiATcBTk3mdKMYmYtBmwhz7oGJg0gB2xnhiw2TixDAG7eJxYTdlRzzajmrnqPFAJlUn5DGwYxLNxdcYYicxjeGodpIPJYQn+2kPT8ZBy6/Ek5zU+pRkkO2p8SQWpJ/HQF57a6eFsQBT/byUN0jcfJ2yI7cwpSd2+DGlA4w5Oqb6ecjbcMEmNzfddOPpFuPw5/3FkDF7zTXHZmPiCyyNXbR0LM7NLbHDxlRMeNiZ8pcd/bgmnjk76YM5O0vHIh1DHxw9HqQP9aU6MhAbqVNWsO27bORa4nbDfhb019VXDx+gneu3KZCfy0+LxDo37ttYkRwmxxmjKadAHkVmDfimz+kVlxyuxdIxP4YaJx+zj4Iaayg829pKLtfKhV8/s2uMrMklOfAdmMwXiS1+HAY1D+22/OuvNf5V6HM6tulr+RCL2Op8mNhqnEeJOfGBuIZj+mAcTEGfIbEB3hxz1Sf7NY8Q2W36mj7nKvOXbfJtvHTxIXnGI4+BtrVzST1OEVtozme2Mj6qDf5qI6+dH1UHO3iSMzxLcyV94mNn7TwiJsRGcjEG7Xyiv83pEmreyCFIfJUguc129SvHm/r4DlVGe/pUnbzYn+ojMbEdW2PQzlb8TH6rTvOOuraeffvxew6xg8ZszIF98i3omBo7YkfinrLjVxT9keqtt95c9D/wsfnLLz/4Vqt+uO66452tYTwDVac3J1H7FeyvnSOmQF/yJDew619XZKNSxg1y7WNMzGOI2cJg4Lthr79+cnKM7rHHHr8Y9ItcLkbc/E7BpG4CM3mNTaR1spg6yLWbPOYWn0zoEFtjYANfTqwt2LlQi2nv5UWuxJDt2Ek8bTvgoaPayXZKvNVO5Sefiw3v+4+BPD+Sk8hW4BEznqn8L+UNkpe5/PMXjmIHD5q7UBIPzPUzO3M6wDHE1+S/RfrSIoex6Rd0Ukevx9NdEB07dmwyZliTu6XcpB+nFiKBDnxsTMXEBr45O/pRPHO+LtlZEw87+mgu/3SwM3VhNhYPuUp4osd+C/YtWvqVTNts+Yus7akcrIFXEPzKkjinjuE55MZ2Gx/IJBfygrKdeFDdDt+Qh/G+GENuxNbKsOGY0wd8nDtmWmRumTqma38nnvQ1/viZmOcQ+SlbUyDDz7ljtIVxqc/AHMMmxPc2nuwfBomdjuRjbU7EhSf8a2GM4F/b13wjk+OVvRr7tqCj+l1LiG5I7sfQ5j8UGM90Rv8YyIpNLl0jxocpVHuOG3rtt6An80R4kMWAQGz6YC7GCvb0AT10Tt1wa8eb+FuIFU90VV8hduznnCPeufMP0Bvd9M3Fha+OwzVjMf20RoYP8Ud8eKs/mZPDE9BNFshk3pYPiA754E/GGzm82muOtNOvfiofeGq+W8QWnsQ91q9iSqyJn0111acxVBvioGNJBhJfzSGQjY/02Y8+viXmtI2h/cj8GlxzzTWdL2d/ZJ69LHLFr0Edn4YS8oczrzPG34w5OuyP9fE2oCfxp6+zyJU20I7C66mzbX8d8ihw7SUPgWslffH22+vPo3vsscf5x6onuXICmzsZ1El5DCYjE+LchBw72nMCaLHGjpPZhVh8kre5G7o1dvDETibwIPtOIlP5wBM+NkIt8MTOlC856Y+1q6NDXmxXf8JPPx145ha5oiM0BmNFW050LZb6B/CwN5d/dmBKT+zMXdQkt+xM9dOSnTU6wJjjyxwPXVnkuuGG6/sYAhdG3THff2xUX0+BLyDmKVtLfcAPcc/dQKeP5uywgab0rMndWjv45uLJMTKlA/Cw0+aXPEre6EgdCur20NeDzyj+K2Eo1dX9w4NfbjRdNBon28LcOzUn1lgrsSnnZ8d0gLqf7cglL2thPOKfG/sV7Igp42JqbIyBf+T5jDIGK9S3/uOr47DGP4XD5oMdc8rcH7kCNhAZebSd+TlxtSXU7TEkP5VAHNlmT5+l31I/B/kAvNvkZOz4FTOIpVJbD2SzPQU8NQa2Ulfrx7ar7cRlu/Wh6lLKR85DkEWg8IyBPvkgh5+fsRNbsQ3VpnE1BXNEe26nw9wTXXzD0/KNgQx7tc8dP2M22rFUIRY6EmeuZ+zTZ187/XQn/7FrP3Ut6MNHB2SeTL6C5Jue+NnytOAjxN/4NxZj/IiNxBEbqUe24699sgjIJb/JWR0LQNY+3fLXxqKNTPW5RWwmxsqjjg321eNjo8YT4ImOxDZ3nxCQwaukWxxLMsAXviUHFfT8/9n70zY7jutM2C2RkjhgIEFSlKjBsuSe3uGvtfuT+3zw+eD3F77n6r7aQ9uWbE2kOIMEOGo4+87Ag70qEJk7d9UuoADmQy5kZsSKNcWYsTOz2EuO/NgM9ERX0npkHacNzfH0uHXr1k7u+Scqnd+6deNBnbcfzZreR/1rPrdxJP6nfZAjjU/x6yIgB/E/9Txa98WHHBOzxwX+iUOgHXmi7iJrpg0bNlwdrtUmFxn45M8N3JmolvTwZ+5GCy7jTx1c+ZMBPelQeXI+0iONHpQBvfJFLjtia/J7fUheH7fwk4Hm4lL1zMUeTGjKmwh78EM+OW6aRnpAPizFXx3Km6vn1M/ShJrYsnWORx3CZfQAv5did0iP+NNFx1L8yVla/ABZFinq4NVXX3kYb8hk7FevP/95XkbKLNmDh81LPonLUuzW+E0PGi12oLZdcka66MB3Kj0jGfLD44gnaSg8OUZOW1Ce79tto759T8eGpfye7ypAtw0urzSseXKjB7szlpEVf/t6qb5qI9pQ0tb6py+wbzQWzcG4gv+YMnxSp/yqdgbxs1LSAX/0JQ2kj3yma6lfjUCuMnCMb8qIY+b/2B/q03IdXbE7eXOovoJ6S1rS546g3sT/mPa4ps9D9QuN+m/yR8c50Bvqr5MW+XQlJkHVE8o18E9dR17SoeoA5/zSloM2toznxqpTOX0Ub7WxHqM751kHVMhD5ODJvIBAmraoLEhPn1tCykVf6lp8lI2PrtNue7/JQGQkD7kOpT1Ix1NlpCykLkcIH3uVZV9iWvOk9TpGUCbl8PLPuaNy4oeCXkf6VPQnXzoZ+GrM5AH+2Jd8iN/SQiknLzp7n3qbe8S26IpebUU6uWIZ+6Or14M/ehD+kT0BWbU90jHHWxE7oq8iMYif1fdGrW/WJ4WC5LVX4+Zf86xgS3sNb9/3d6mTfOPqSy+1V8gTL9TWHD2a3+QF2kfqAMhZG6M5iIWYkHOdwef4LXZ+2P/oo4+n6w0bNlwPnB99HwPqAHlRHCsjg1Glmm5QDRlcQ6PrKqNSlXdR1Ikh55l0kIE0lAVGqOZVquUj7xAu48OzhsTrUExOFbPrJucQrlNbeZw+9+OFhR6qY0UdMzQj/VFftRC0UPU9jUZfTRtabVNrv0D8+uv2cez8umpTck3/vSzyKy67LxLTOk6OwIeMT82vps/xGP8uYtuxOqCWobPWO4qvvT29LucZr1Ednyv662OwJibVXr4AP2r7rdSnpwxETgX7a/1q773fSa95KXPKmFT7co76Ouz7Lp5RevJQUO11HPldfe19VmZkV9JCFbmucYnMKjc0QpUd33rdkPK5hio7/iKIrB54e74qEyITqg1zqDZDb4v02BObEpsgeuTHn+Q7RxBZZPcyUg4iawR8sQ+P9uWoTO9Hr6NHb3d0xpbIjPyqI3ZUHZF1SG8F/qoXogvFV5S02FMRf+UlBhXxyVFZPGLnXDr54UFLevBFxxwfSI8OZaJjDZQNVUQOCiK32dA23awFen3ObWzZTLEuGD1t1YP+9uH4usGlLbcNTHk1fsAOpjxKrf4qlKk29vnfFKStbNiw4Xrh+b/927/9Ox20Dro96kBdB7QKPAY4A+YI8vD0g2JFBtEMlPU6REbkzOWbwDLR9XmjY82vVNPrsfImbvEL0Z045Bpf0isBOfn1oyegL+cjxB6Y44vtS/Uc35Z0LemJHahOmj3Ct6Qni5DEaITIuKi9cEhPjckhe5d4YschPWjJ50N6gAywWPLLfeSCX+ik+xUvaSPUMks+obk2pfyhOgoPLPGgpbgcshUO6Yk/9MSu6E4eUgehXId3Z8kknwzU4u01Nxtb+w0tR30+N7zhJ6t9JLf9Mrjkz1XBAli7iR/HgP0p14950kMV4tanrYGYR+5aKDNC6jl13V/v63ffTiofsKP3G+TP9ZERovPYmKQcvbEraf15bb/I+WhDJ/wIqk01Lf7yc47k4yUz52uhzCHEThT+ar/z+Bfic+93lRP0trpG8QuFX79uN6H7tl/R60B0J29kQ6/LtTJ13TBClYOUiUyoeb1uiGwxojfjVdKjN+UTz5QP+rKu3WSnfKBctTG8I8ReT6PgJzsUuZGFL7KqPHnJBzZWJD/141x5snrbc00WPuh5AjJiP5CfazagubIQu1Ief+JOthhA5JLlPDzRAZGTWCW9pgU5r7Y5py8+VTvIckTSYk/KjYBnLq/6Eb+iI5BGV6gicmOLsiN9ZOcpturHGiQGqIKOvn1CtbOtD77cydCexVMsp6xp/eCvIbe3JA7bEh88lV3BLvO7J7bpNYbEJmWkHeNrygRpexfFsTY8SfR+b68rbthwvdBmmwPoJ4CrAj0ZNBxRBlETEcp1JhGDOLLQQdKUkxaelIvs+ONoIDU4mcQM9u0Ji/a9COm5zsJVekh+yjuGjo3XZeN72fLHIPVyHfC4/L5OesKzXAf7OuplSpZ36FfAU/l8yN5T6zkFMt5kfDGuWBRmfKljEb3tT3j7RsbnD/7Kzv2zTz75dHqlwPXnn7e/aGmzy1gxZ2v0OhpznhS0jYvGM2PhMeXxah/LbfpRXKQc26Av43pU7857XmN/nRfqXND7fax9QEZ8Oxa1TPUHpR2jzI/y19jIHv7xMwTStG20Jh7x61jfIudQufiM+Jhj+m/1G+8av+Mvv/gXf91sVp/TtnrE31ofsSU2RA9ZVWaNZY85fT3Ij78VuSZnpDt62bZGV21PFTWGqUdHuhKTAE+PXh5IQ2II7IvNQD4/XNOBRn4kNo7K95AXHfLJmPMTyI+OPt4V8R8vWWTip4Pd8pcwspu8lHNMPOIDHfilVV+lJa+mLwEvHWxF/Khyoj+xqPbwM3wVePDjS8xHUD5llRmBnsS21xMdysoPX+orfiSv+rEGyqEec7LoRdYQxpVqb2sjYvfH6UevYz4hYIzpN7jIbnNA+14e+WJV0cdrCWI4VwfPOto66cHFhg0briWmb3IZ0DPoj5BJRX4/wEpHeAzs5NT0nEMmEXKSFp2OCE/VU/MhukysI8jnTya5EZb8CTJRmQRGWKMHDxn09BNJcEgPyAd6EocebFnSk/qZixskLkt6LD7kpZ4rEhNksj4UF/lzPCZoepbq+ZAMYO9SHbEVRv4APeICc7EF9o4WMMEaPdE1xwPk0CE2c3XU7P3WtMFy69bNKQZkg3b22Wdf7ORod62vjZD4yl9qu3QttanIWLKXT0t66CDnUNtFZCzpAfk13jlHFYlz/mrhn/7UbtScj79ZcTlYeFqAsuPu3U8epD5+iJM/TMAO7WUuniOkHlq81sWInjV9uYcyoMwhG1O/bFPOeco4RkalQBl9yFHfXGqHPehS7pgysROWxhw81a96vAhqDPrziuj0xKH8pbF+BGMlv5Z868GvxCQ4hc/xMX7mPD4eU2/aiL6jTD+Gx87oqZCurDiuBXl0RU9iED2O1R8EyqTfSBvZ2oMsdeZoPIj9riEy6e1BR8rEhgoylIfE2hhY+7b02lZSRsyA3Lk2GLsTe77GX+lkKDeKQeoTEidyIpNN0uf8wouUG/FAdOBnR43vHBJrfKM+lHx5ePRT12xwHfk1LpGVPEiM8QG+nOOrsSRHvUGV19unPLkIn02bEcjjR7VJWbFPuthLc82Oansgnw/iOoJvk6Z+8IbITLsbyZ1DH7OAnNFcSg/yA9lcO5GmfR8zztrcSn0EYmpeZx+Zfb8CtuCT1yOxCZynnhwhth4Tsx6JyVydXRfwlZ0Bv9977/0HVxs2bLgO+NZukpk2ufrBLoNZjgYxnRpBPYcMeHXCgMqfic0AWMtWhKe3B6RnUB0NwkBv/JkbaPGQMacH5NO1pAcPHUsD+pI/cMgfkA9LccvElUVHD3pSP3MID1svoiexRyaoOZ/XxM5ihp6l+LMV5vQAe+XP6WErzMWFnuhaip0FBVsP6ZmLbfScoi0kLj4wf/PmjYeLcvDIu18E8XznO/N/tROuW9udix0kdvQklklXtqYFZCFl0kZip02s6Op19tenANssuL/7XTe7X0119KQgjj5Uq16OXbDyI/VwTLlD/XSE1Kv6SJ2knpMXRC4+eY6jdj1Xt/qQ/qCMmKwFXYf6SI/4oFxsrG24961iLj3gX41F6kn82Tjyv0+LjvzJ9mOeLoCluo6PlarvI8ylB+yvFL2OvW+B2JN7TL1pH2kjo3Kxs9fJP+WWburw5JhYoOpT5M75BPSIP+Bj56G5DylDNz2JX/SQiadH5NcyI5Abv/BnI8M1GexLPKXRJz/2yOv7Mj48gMd5rVMy6VGOjt6+2CAdT/iUp5cNjqnrxKKit6HXUesiwENezxvEB/l0Vr2xS1rsxc8X5ynH95RXBjnv2wHbat1GBiTmkYFXXmx3nvj0vkhnlzJ0xp4K5RE+MiBtkA5HZaIL30gOyGfnCLE9clw7pl5hrmwPZbOxREagfD+PRhdiNx5rs/hakSdGR3kj+GHz+efP90nnt2/fehhPxJ7et/StpCuXc8fK71w+fhQcOx/0IEtcEv/rDP4nztsm14YN1w/TJpdBxaA0NzDpxAYdg1rlqQPeaGCq+ZEBo8E1MOHI6yfcgAy65gbADLqH/MFDz9zEMfKnouohZ86fuugY4ZA/gAeRMadnbdwyoY6wJnZLepTnLzo0KZOTiXaEQ/7QFVrSY4FHxpwetsJcbKND/OZsgUObXOIK8pfiz56ltrBOTutnvg/glzu2kQ1ke31ux7VLb4u7OTnXre1WO1InOc81OfEV+NceK2/H89etrppd0vZj1pytVwXt1Dcy4N69+w9texIQR/ZoOxdZsB7q2yNoo+p/rq1B6hnYmDoHutRZqEdNS7te6s89xEM59h2zycXGQ2NqfIhPIdex23VQz0dQJvGo1zmvR3DuaQ9+1fRDsMnFloz1a8tmzIX4CokDHOtvjj2lbG0fQT3vwUZll8a2HsqkbV1kI1QM6QxVVNtzxKNsbcdLPoU/N+LAP3oT+6q36pPPN7rSlpLW2wrKRPaSTQFZsU8snEdu+pxrYwseNKcDHxmQvJSJbD6gkX108Et+/O15yMFDJhns6HmALjxVJyhLT7WBTBS90nuQE9tQdMa3pIPr6CAvMYDIN645VllB4kBnD/WhTOKARwyiP36j+Fflx974krIVVQZe1+xGzkPkO5LlHB0D5cinB5Sfq8850C+W5FSQwV7yArzxS1708N+Pa3jxwPEbXLcmfyroyRNcic+cvMSi2lvRxyRxrzovu8mV+p6z4bpBDJAfJ99///2j2s2GDRuuFs/pkAYkx5DrnkZ5fZl6jSr668sik8AcMvBcFGvtvYyOx4lTx38O0fO44vK06Tkk5zR69v1vqdrxXHW74E9PWeBlMZM051kw9SQ/51l8S2sbem4g3PDkmzlf7RZaX06befnORY4WjAhfFsxt0Xd+THuc4D9/HNnCjicJ/seG1NkxuEiZQLnaNlLnzlt9N9nVxpyn7nJdqeZdBCl7Eb9SrvdJO05bzlF+qMYifkc/n7xGqx1rz9o3yg1RKG0cf9rWKeJREZsqqu3xufobqv6Gf+Rvtbf6ln7s+GifbhR/j/E7+SPf5hC5c2Wk9zFB8VcakFFtDo2uA+f1OiC311uR/JQPVX05QvIhdveQnzoI7yFER8r2oCexQoA/ZQJ8fHSseeFFozhAdCB8te30kM5Ox9Rl7KpQNhTbokOa8qHEjJxD8sgKkYk3ciB68MbO+FPLOI/MHvKWoDw5+MiOfCAv9oSnYmQPqoif1U5lIjs2K5c0vOE/BvhR7IrsNVCODfRWxF4U4A1f9QGkk5N6s17xF5bxHYKyfqhQtoI86cbd+HZIXmI5Ink9XRWOrcMngeo+c58Gmzds+CbhW/fv35+e5IIMYiNk4K0DdkUGaAvNOeBBS5OIwVjeaKEDa2Q8Ln/W6FnjDzny52RkEs1EM8IhPWtk4BGXpYnwUNzksyU3HHPwq5f8Q/7M1TNbkfgt6VnzhBU5S+1pTVs45A8Z9NCxFH9yLG7mwA44JIcrXnnztMVLL704pYGbYJs/rtXVTtKUDuEJ+rru8/mE+rYQPscQOYlvlZN8SD6kTNBO6+JKWut37cmsFo8c52JzHaGtqyPIRsWThtcdXn319mTLsfFceiqr1j2k/rW1qid8lT91D/icHxr3Rki7jow1oCfl9M++XLWz2o70kSBpUNNHaDamvbM1bb75H/tzRN/+to+st1/sXa/FoXGyBx+USf+PvvgWP+v1IX+h2hyfck6GY9qV80P2Vr2j9jgHZVDivAbG5pA2Et8hfkhLes3PuXaMN/xLUMZ8od7w93JHaXxq435D5qxDfiqnvlPPrjMXVcR2fPFlhNgDI558Rwrk81EfTLnYS48jHnnKOMaGiuTz3zHlw8efxKbGZQ6RF7vSf0Zl8IVSrueXjsiTnxj28vAk9vzEiwd/dFQ/UCBPWTqku84Y3yP9m76KxDb2KjuyM4gt8pVFAVsQPfEhfNIS25Tr9eBJWYQ/51XPHKoOUCZxXwPl0m7IqogcR8CLJzFDPejXLtoPdF88LLsEMo0DeX08YBPf8oR42ttcXMiJfXjXgg4UXPZJrsS0xig/3pwC5JsnfZf2shDLxMzrph9++OHqtrNhw4arx8k3uXTwQ4MoGXM8Bkt5cwPFaADssUbPWn+WBvtT+cMWMub8WePz2rgt+QzkLNlyKG6ZWNmxFLs1m1wwZwt/gL4lPYdu3sQE+DTHQxd7ljYf1m5ywVzs5C9tcskPsReN0PLbJpebhfObXF9PixDXvslVER5wntjEp+T3fNBMaTcaNb9ib+6jdsef+JTz/U1+qx+xy/nTiD6GYuw7XGlfFrf8uw54/fXXpja91K5H0IaX+m2NQaXUa+o7tIRD49EIa/p8D3oQ9ONJ7M95+nqlEZpr5/1LGvl5urDFUlqL6VJM+OY7fGw8FLuKuXF/ZHt8Uoav9ESX60PAq3y1LzIqxVcEdTxK2hooR592vBb8iG9pW6NYBPJSRjvpdcUf6O1XFrFzaS7roYz5jS7yIgeBtFCt13ozrCz/5vpPZEVX1dNDXmwRh5yjIOXSb/s6DvoNFvk5Z2viK2ZkoNiFt/dHetoB3tSTc7zKaM/ys+nT2zQHco15kHgqXxH9IXxz6wm2kadMfGVLtSfy8OJBScs4JW3UnpThK14yR/6SxQY8PfDKx++cfb2/PejDz6aqB2JPfIm/9Ff/gD3Hjm0jsB+qDj7EXzE5pIMMZcW7j1Ns5guE15GeUbzow+8PA335pQ/RH57TyOND/1cU6bL2y19RFLPEcARy+OEYO9bGWN2hwPp1SdchsEE8a5zu3r07rWeZdNm6J1u88sd10GUQGWL80Ucfz/brDRs2PH5Mm1x18J0bQDJJZdDuQQYyuM3JoKMfvHoc0rNGxhpb1vozlw+n0LPGH8iCbI5njR62wtIERI78OT3soGdOhnwy2LG0YDcx41nyB+SPdPEnsbuMHjEhh09zPPLZszR5HYrbmvjjYe/SJlfaHHtR0nMMyaLHX1AUo/CkXC1zLKI3G1C7lHIuPzcu+xu6XLc85Lxdw0XseNrARxuL6kM/QWkTXrXM9zeeNNQLvP76nakNLfWfEdJ31Xn8czzfFhpFrphAeNbi0Hg0gnqIXWvLpc4clWEnGWSFjgEXyWh/sTMbWW18d35MDCrY5MPDx94IzsWfvOpnri8CciOfrOrrGlsv00boW5onesRXx8ypzmt6COKDa3bSlXJroNyhOaaHMuYL8UhMQnNQxs1v7BZ/NGcrvhBdKdeDTjJQ4mCjij9sC6SLT2TWNlBBV/gq8IutMiA/42hkVX0BHqAnZcU7bQPkHVtvAVvZDDUOgfxqZ/yYA77Em714+xjJw0euNYMjn/DFhjkomxiTjzdxAfnZaOwRO+bsugjiByI3vqWuU6fsRewd1fNaVH2pc36QLYZkH+qLbEwbqkjd1niSS2f1pUf7o0A2uL5YrLuKub+iaCPbBhefeltG4AfUul1br8qmPGiLfLxou0jdK59Y+WvTNrnmYncRqBPxM19eBuxF6ix2btiw4Xrg4SZXBuC5gckgJm9u8NXJDRpLMsJjoJobrNbo6QfAHqfQsyYmp/LnkAwghy1zPCZaevCMkLjBHA9Y+LD1kB75o7jwhQw6lhYJJmaT75IeNstf8imLlDkc8kdMyIElPeK/5A876Oj1RHbak2t6ku6YcxC/xLXyHIOUb0f1vi9Ptw2VXe4uf8/Lbuehtmk15TzkyfFYe76pECdPaXn1T/vweLy0Ft/2C7i6SPtMfK8LXnnllZ29+6cTKviR9hxyzY/4qMxavyIrsVkL/QWOKRdbHfkWuK4UnhyPRWxCdSPrmLgcA/J8o+7OnVemG41D8uMniCM/IT5fBPHZsT9HwaF5cYRqV98el5C5ZGmeCBITekLQ+4GkVSgnjnyja61v0aecje61UI5vaU9roEw2N4Afyiee8Rlf7yf7pPfAk80s53jIdyQr4xuwF1IXaQf0OwbK442dQAY9+Cov4KMLT982Uv+jONVYyB/N8fEHejsr8CRG+PiIVzo9zsUCxd6RTYH8xKD6XkEXIj/yyHdcg/hPfl8ueeRXsIFveOdicRHQw18xBP6OdKyJ3RKUpYOcXkeNp/QlHWSkbQXkkKmMc3mJofjOxctnCmxw+QYXvjWwOeO1uwq+3bwpfVynI1iL48PPTjKcz/ndQxxSZzBXb2QnVqPzXEPOMx7u7lOnvxa+NjbH4oc/fOvB2cUQ+/n99tvvPEjdsGHDk8a0yaVzGqwPDegGrblBhoxMlkuDIzlLethBz9zATI9BGOZ44JCeU/izhmeNnlP4syZu0bU0UZjc5R/SI9+xh3hkgWCym8MaPeyVv+STuCzpORS3Ufyl9UdyLOySBvWc3zUeNQ/qNb4+v5Z13mi6One9Pz9PKYc/cOmR7MRSvlhZTAUpC+fPH5wUeRuWoQ00ajcn2lXqWWyz0fHHP2r3+7qba5tPGm0R3eaFtI3abmN3bTeQ/iR/rW/krhkHeyTGa+OIF6knZZVJGgrmznvUOnyU0jcd97wpd2qQyadXXmnfUnNd/XJMjJNe84J6PkL8iD5o7fr8jU3Oa1qQeeSYumZX6ntpDuuhrmuZUQxQtRdJUzYbMr0f/TXg7+c/cnKsVEGWsnNP8Y5AhjJpb3OILke+Z2wK2Co2I38SB2XQCOKT8uRGNrmxESI/7YQ8+Wyv7UCa+VY550FiOrITH4ruxCQylHFdy8qjJzrk8aO2rchEczEK8JKJ8LMX0aFcrp2HF2JrDzLwJO7KZuMsIEd+1jls7P1cAh2JgXKxEaSnjipix8jmyyC2JC5zetiD1zFxXYvocIz8Plbkph7x0N/bIC6InAryUiZyHJfaTv4oDlJ2Td35K4qRHTi/cePGbvzZ/0VNxzl5+PkQ//DVuErrEX1Vb2IRxIdeb67rMboqpPGNzHzfi8x79+5NG11XAWM2vdbLnnQ9BsxX1o/J7Nw2uTZsuD446SZXBnxy5kDOkh520DMnI3oc52yBQ3rW+GOgVX5OBpzKH5jjgctuPtETXUtxO/SElZjAnB75ie3Sgv2QP5nAD8WOnLrJJS1wnnZd0fOERv6APHFjay2LX5FWbl826dLaeb0Of8P+3LHacL7M/tjKhK/KGuHVV1952F/EwV8e3B6nvhq0haenTNVLGzdQ/cuNSXsa8PLLL00LvvRT9qf9L7XBtLf4uxaHxuQR0jcdU841SIu94QuqjeGZQ/Oj+Wgh67zdbKvLFodKjXcfn6tG842v7WbcQj1xr/6PjnPofYov/bn5giyxH90wzuHQPDIH4zl9dC0h9YtyXnX1R/l9mnLsrPPLIShjToI675BZ5dMXJJ0uccz1GtCHan1Hdo5VN0jX15LPztRdz4fYlbiPkPLAFpAWWcqS4Vp64hL5Va/r8EdWwMdDTygqn5jgcx1bajn5YgDJSzm+xEZ2REZifAiJl2PaXPyuNsRWR3xVfmwJyEJsSxsJDz+UlR59x4CMyFeWHLa6JrvaEV9ib7X5MqBDzBwjk/7EDfWQD6O8EfDTAfFzzn51grfWfeI6igvgSfuUp+yobgPijC3WY470RMccyDMvf/e7+1cUpbHJuOMj84nXUlzYF/ur3qQjNpNdUe2r8UhcIbpHvFDPob+mkzwxrnH59NNPd3TvAdfVQAzp9VmJ/jtnS2AzYuu2ybVhw/XBw1G6H8x6GGT6wegiOKTnVDiVnuti73XzZ60cfCOCOqGGTJjIOT5HE94c4anXKZ/zlM95jiE3hjsrd217Mmk6uknNwsQGhQ+AmmwtMB1tFCHfUBinN8qraO3YFqdtAbBfIPZ62jd6/CLbfpWNDNet7H7BtdQfxSW+Jt6Qb2BtOD3EudWd9lDbhD8F3upf3T0tyMYOpM0d0wavEmJdKX07fb2OBaNrZSIn4Evri3+c6gulT6tD9SpfH3Xdvp/S/hpm6lfZ9s2508aFmfGTLxbhFuQ2mUJucLLp1Pu8H+/24y+kDmv97sep89TGoX1eylwEKVdtOQbxA6Xuq6/Jg/hYr3Ns9dnqPOfhD9+xUC66oMrKeWLYx7GW6xGfUHyOr6O67RHd9PVIXhBZdGhHI7mRU+MOVVbKJS1yk9b7HlkjfbXsHKqeyElaII2tiP5aFxBfHEHZUczmUPWlXqqfQfj69NgH8tiVuYNN6iP2uw7PSMcaKBciDyVuPaThk1/tvAzIiE/xJf6wJb72iM1rEB3xK/LnED+h1x/feyiDkh9dIz3S1WnmDzzSlsAG4/uNG+0J69jgmPmAjCXf8Cam0Os9ZEPQ8/XX5KYeY08Ib6Ue0vBBfHxcUBeff/7Z9MSYzUdz/8jGDRs2PB2YnuRyYoDMRDqCQVVnN2CNYDAycDqSM4e1ejIY9oge5MZiDiYD+Zf1B+Z44BRxi66luB3yx8QFc3EDOvAtxS3+LMlgr/wRD/nxOXrwV7jGF19qfs6V78sF1NasZkazZW/SeduqveF3nRv55CV+jfbp0H8k3bGd7q9zdGoDrZ3n2rGltScvxLHpyI0x6p8O2de563psCF9Arjrwi1T+fDSoV49/m7g3nB7ivdR3njbwxyuLfFryS3sLcm6cqG3X+YgPIlebxW+sTH7lg5qesSiU9DlU+9vp/prekA1n/ZEd7bzx+ZBvNpG8OgGykl/lx6ZqTsk+l96wT6g+7OVkzGhzn/N2bDFYwnm/z9vKX+dI/NXz0nzXQzyM5cocU7baPVem+pVzupzT5VgJ4kulmn+Mb2ykb6nt91BGHJGbpLXlIL6lTiB2Q87rMcSv+Btagg9TRw595urEJjL1fzb1IBuvcvLDI05IOpAhDviThjflq41py3RWxMbA/KVcLVsR2yOv6kLJs86J3729KGnK8mktyOAjHTV2ie+c3aAspHyNJUhnN0gPf+J+WdAZ/8lja2wJ6LURQHf0S6t2HoPopIcMesUpedoDPdLQRfREjmPqc62c2CYWKSctdgXJR/gB70gPXj+CtR9PfIdr+alUYLunqn1vi25yEw/X1nl4ltoZe/Ek1iO+8DjyZQ36eJCdjbuLgg1p65H1OJ7kquAPv/y14sz7S5DPzu1Jrg0brg+eyk0uZKBemhyepk0u4M9S3NZuciV2I9DFnqW48aef/GKjY41LeJLenx8L8iKz+ZHrdnRa81u6SXV/nnK71Ok8BBexK5tR9eZyf33+PO3/qqBeUXzMuRvynO+83NXx8w9vPivUu5sEC6wNGw5B+7l9+/aubc3fGLT2f55AX8CfsQTJSx8JH7T23G6YHaMHr7Tw9+WOAR2xpW4iP8ht/z64pL9tcu37Fb02uYyPbMoHcSOP7PDK99pqPx5E/siFGpeMJzX9Imi2ZYw4f456mBvwoLVIPJTRRubmuR584huMyuxj0ajGB2q85/wJqoylObaHMn2bPARlxNHN0bGbXOxDKdP7HH+r33BoDTKCG2bygRzlsy6gj/3pez3EHm/05681upZOluuUT10BnWTjSxqepDvKE8OR7tzwzvkaWZHjSFZskB/fPEUjLX4EadPxZ9Q+56AcffQqh8iDxGYOsV15fvZ2Afnk4WU7+eSeCuRW/11X0Cc9foRvya8lqAv+xpdejnikXcgXl2OQ+qaDbDTXduaQ9qIc/bUOAjGQJw2xdU6Pp/PzkXltcA30MXMxvcrQ4TzrTjZpB45zbSdl2JZ67BH7yVxbp2KbNg+J07FxrmADmWKf73I97k2uijfeeH2K3RLYzM5tk2vDhuuDh5tcazeF5M8NjgY5x6XB8XFu1ixNaPHHYD/CWn/W6lmKG8okNYc5PcqC8s7piJ7Izjngi4yaD/V8DaInOnMtbpkkTejN9+b/H/8Y3nadMiMca89lwN7cxKbeH6f+q8aun+8WC+s/arxhg/bvm27679wYhyf9PWM3SMePsqAOX/pX+DIOOA9dBHUsyXls9/pBdBuT2dquz+tTTJk8yaWszS48xofcMGXeaBtc7eapxejPE4/XR6IjIJuqy/oZJG6VEvPY6HwtUn/N//lxuYIe/uJPDNZCWfFhp6N4OI78iT3hS95aKMe/pTm2R+yB1PchKEOPeWTpqaP4ER05h9Rbyo7KVxxag4yQdlx15obbGi029RC/2Cc/bSZ1yVZ5eOSza2Q/m/HII0N5cHNMTrWtQpm59aNysaevZ/7KB8f4MbItvEj+2nZNt7IQOyHtAcjpbQO+xn4xmEOtt9g2kncZsMOmygh0po7UAWIze46xA398WapToAtfeNduDClHB/vIV3ZOxxJSN/QDWfqI9CB1AUt6/MCITww/+2zdR9R9Gyofmqc7el566cWHG8xJZye+3gY89d5r1O6DyMC7BnjFxhHIP8UmF+JfZNnkunfv/uTbk4Lvob366qsPrvbYh/PP2ybXhg3XCCfd5EKHBsdDC7IMlNE1QiacQ4uBpckm/swNmPGHrkwqI6zdtEvcyAxynkmFnqT1fPL7uFeeNYj+2BI4z9MNsH/SofHt8xxx7HmDZosbWQu99tFGPG4u25NDVd/073R+HaAtWDBkgXpsXI9Fi20jukJXBW08f8Gnr7cNG5bQFnRtAT8aK41dIW343ffeO3vuW89Nm2MZg9PmjGH4pFms2nh9+cbLZ3d2OsIz6gdeDXRDgOeVV16ZxlwyYlMbe9tNk78s9fHHH599/sUX0wL55o0bUx5d9OPxpKOnpZS9/9n9s7sf3z37wx//cPadaRx4abqhoIPcpoP8tnllrJD+/vvvn317d/3K7duT/NjCfja0+enryW6vpPgV3l++gk8++XT67sfa14bNmd/73huT/XTH57m+LP3QvDRC6lGZteXYtHQDn7GNXEg7qfWtnOslf4IqSxzWgp3qZO0NMsR2ZZfWNBWxL/Fnu7TkQWJbfc5ROeuamncI6WfH1HXqLTYpLzbSxGkE/vR6Uh7YQa40fPFjBDz4a3tIe80Gi/ToSp3jI3eu7mNPr1f56FM2dVOhbOyhly/xB792OofEk8yMBZEfueLq2PcT+dGTvtAjPHxgG57I7eVdFJFHh/Ok9Ui9Jo+vbFuKT0VioYyy8Xnkd6AMfuVSprbDHvEj8YltSzqWwFf6ERl9H5F2SI81mHTzgSe5DtlCp9cTzUmJb9qVPy7CP+cIb9oAn1F4E7vkH9Lb8x9C4pKYqBdtZKl+1oBPxoLUtzm83U88uc9tJLZ+HHvjjTcepO4htu+88/uDMd6wYcPjwfN/+7d/+3dODJgZFEfIhLbUefEYAJYGN4NhJukRyDikSz457J2DfOXnZLBzCbEjfLlOWqWalgF/RJnYR9SXrzLBkS9i1zad2s2OG7BMAj5O/vXX7dwE5SkqN1rtvFKbjH1IeX/eJtAcUT6C3uqr1dlcTFv6/uhGkh+um82Xm/CuAmJqYep7BurGtbgfg8Qj9dLqYx9LlJg7mqDVSauX83mpi8S/vS61v6FNbHdaJ91rbKXP4orc61gHG6433HRrZmmDPbTBjFXyf/nLX5599eVXZy++9OLZy7vFuXSUMQ6vNvnhhx+evfvuu5P827dvPZSTdt70kX929t5775298/vfn93bLXLNUzbQ9Zd9H2vzgDGHjvc/+ODs9zt+m22+pyENj82nNiadnd29+/FO/3tnH3z4wdm9T+9NfcTrZZ9NH5xt30lxIxH+9lpIG5dtBvzbv//b1A1tiBlD8NncRxlLPMnzwc6Wjz++e3ZjZwe7lf/kk0/OPr57d6LP6HxAH3700XT8Yie/pv9pZwA/yBUXfo/qooI9c3W2BHbD2nL8YZdjrukOJR3O1227MXNc40+gTIictUjbo+tY8KMvR1ZkOsZf5yGo/i5RQMao3nJDOwJdc3lLqPXjiGpdVmReWoo5GyInMubsiq7YTjZyHbvoSiwST+mu5+SOUHWBvt2XxxM+vtZ86Sk70ste9QPxo+fLdWQ58s1RecAzim946JAfHclbsm0toiNxSn1D5AexM/rq+SGQRQddyiXWh8onP3Y6zpVLrKDqOAXorQRk02PeSFqPfMDc3OEc/xzIECfzhR9G+FPrw3rV5k/0RlZiGl/JQNKVXdJZQX/KrEH0oEDZU8ScHeTubRfDJ7fJtY95NrP3r2Yn3zqCnRs2bHjyeLjJZeJZGpjqADbHs2ZwlF8H4hHIQcfqSTkUe/u0nmo6maF63fPkPJT86AkF/OBKo/0gmU0MfrS/nmezw01b+9Uwmx7K0ds2QvabIcqcP1aaS2uTHZ1N/3lqtu7pImhl2xMI4hI5LS7iNF1NaU8KbMsGlwVRra99PFpdJVZi115N+uNUB+pCXNv5/rrGu+drMh4l6Xjaedso2/O280evwy+t1mOzWzuyIMDnesOGY+EVPX0j44HzOuahjJE2Y37xi19M7e/VV24/3NQJBfrDhx9+dPbBB+9PG1yeztKOsyHvnIxJ5q7d/ua3v93xfjhtnn1rp+/111+f8tvY2cYsduTm6YMPP5w2xvyZ9VdfeXWX1hbJ+jk+T3rZNLPJJI0NNpGmG4edXE933bt/b+L1BFb107hl8+pX//6rXdlvn92589oUo/Cg+GuxazPv7iefnL322msPn+TiH9DtCVLEh48++mgq59d7NiXPL/nSyG79+3Bfxps6Wwu6+diXkx6/4iO+pKX+lam2RUaVJz/XyiTtGMSOY8opExvXImW0K+Wqz5V64MXnWP3taQQ6UqZCW0m76RE75mTOIf6A8vGtB7n65aF4xy8yquzeLvnZTIHMY5B0PPTJA/KCi/iZOqRnFEc6E/v4GT2O8nt/4mdsjuwl+yIr/uRY9VZUHZC5nJxQlbekew50kFH96NcM0ivi5zH6qg7ljl2XRJ/ysYft1YbEKul01PyLIjEC8uiR1q5bvRjvpYVaHhtaPG1w+YFn1P4C5ci2NvUDCp3KKiNPujkBxK7Wg/zYCIlT+NYiNqwtE73R7fpQ3PGkXD0P0V/P+YAHPvvMJtKTBx+z9vYQALD3iy8+39l7+Ta3YcOGy+PhJlcGkrmBKQMRLPEcGhwNAnVQHhEeR6hpleiBPq1e99TnV13tV3rn+0F3p/2BrTS1Y32FL5OHQc6xXTfKALgfCNt5Njpa+n5zpFHOw9cmNzZ6CsEvRW4Eo5O+UGLKzor4UulxgE25qWwfYW6Lj+98px33ZCNx/4Rb6qYRe9tRXZzCdP5noSCm9ECr0/bXllCrs1YHlVJHFis1vdVJo75ejkVtXyjtC1WdrY3E1vNtbe/HulcINmwYIX04Y8f5fro/t/mkrf7617+e0l67c+fhK8t9X9AmPc1095NPz1698+q0yWUz1k2ANouPTHK87vf2g8f/jRdffvHF2Zvff/Ps+Z3uyAa2yVfGJtbdu3fPbrx84+zOzg7jz8PyOx2/e/vts3v3Pp02nX741ltnb37ve9Nm1a1pY+mlSaYP3H5y95PpNUExUDZjxSTjd7+beF9//bVpPAniI3vc9HzyqVcTv5hebaBP/rS5tYuNmxibaF55/NZujLPJReabb37v7K0f/GBnz+0p/9bNm5NfUH1eQmxdC/YCPTmf6nV3vkSVj23qttZ3aIRa7hgoh4xzx0CZ3p7qS+SGwFFMajtDFfG3+p04snHkX+SgXu+IX/uL7B6RA6P8HuGPjSmbY0AWkj7nRw887Ozlp2ziqQ+A9pJ6xCfdEaQnj/9B8qGej0BfZNb6qZDHJoi+AG/4409AdsacNveu21DBkzhA7OoRHjrorbGqIK/atsaGIL5HBzuqHzlW+Y7skLdWV+rBUZk5Xw4h+mK3Y+yIjurHKK4XAZnkO0KNh7UaXeaupg9vy7Meaz/etPltyR7y8keD/KihThInedLzg0p8q/F3zS7AA4n1MaCLnLn6kV+JrlBAb583KueYWI4o9RqZfLkum1wQm3K/oO7b2xf6R+PZsGHDk8NxK+EdRgNR6FB+Hegy8IUMdJUM8CETV71GZORcfs9TZUZHdCODk0nBQI4MVNm8cMPl9ZX2Cov35z+fBlbvg9+7h+5P34lxdDOUc/luypByfvE3sYXIrpsP9PYTVbUx5CYN8FXe6wx25q+iqAOTcx6zdiPnA45eB3Ij7DyUJxfwmtTdQKrbfOemftC5bYK1drcGypBBr2PKpi2od+/9p+7Uv7Q8YVLr7LpAc2BPm2j3bdhxbpGyYcNaZHzS5zLGZnPLuJQxqodRSlltUHvMWKiN9v3HTULGtshL/75795OJ36Lf+PDFl19MH6Btutu4fgh7ec+ffTqN1Z/uxpMXps0tG0rGpOnmYjfW+D7YD77//enoCSyvELJ5CRk/0gfnxojwOT63s+l549EujmJqrIvPU/ouTV7OIWXXoMYScj5HTfe+Pif9O8pYC2TyLeNMxkTpsSu8a5Byx5SB6FqD+APK5RrFX8fWnvckLXaJ+8hvaWhkjzKRP0cjvZByFWlPfTrEryDy56j6Ngf6+Bi9x4A9mX/oSVuKfuMIJIaJX/Wb3qobXxAeRzFzHMXMNb3yyCKj96fKqDoq2CePvWThr/0j7WLUDnpEFn6I3SPb5SVuyozsI49P5IU//hxCr4OcUZ1HR0XsXgN8dChDVur9okhdkJW6IFu7cpzz47KgLzFzHkirsYh/Nj6sH3clp3uCJXuU54t5yZrYute8mTi5zuv26VvVhoDuPtZziN09BaO8SnSgXFdIZ2vqJ+ch+RVsTb0hPoZgpOM6gc3uG/y41uy8vrZu2PBNwsORZjRg9shAgzLAZdAykCF5bVOivQ7Wfn3YEx5HNxY1PfzKZhDM4Og8epnpyZY2ALa/UpLNqGxE2XjKRODaN1E++ujj6RWZkOuPP/5k+ghwNqpscLQNqs8f3JR5cqptGBjE2u78/KbUVcHNXJsgD9fRdYIJXuxGbSuTmuM+u030NrK0BW2kbYbdmF4n8gqPJxt81PqVB69D2TxT5lD83eDaOMs3egL61bEbZ/U+MHXDhm8sjLXt+MdpjLWZ7yks46pF/By89qdMG6eNxW5alztXxtE2t7T+/NFHH05p+rsnvjz1+f577+PenTe+2b6/S542jXbjgzkG/xc7H9jig/TkjWCT/fvff3Mad7z2aHyANlad98FlFuf8dZ5xrUfKyw+vo7SRBzU/ctEaVP2Jj6NYmFfrHO08PNHJZ5uSmftib5UbJG22Hq4AIzvmkHWKI1+z3hCHzAV84yu/65wfv49FjQkddNFJNxukySObnuh1PvJtyQb8kRdUvfE5ug/VU2y6qO/AJu1HefrYkbi75mvadpC6AOWS54i3ImmI7NRl9S3+x5+RL/JhLu6BvLSJyHV0zZdjwe6UUyfaZ4Vr6RDbY2uPxIJ9iXUvbwS8aQ/kKz+KEfl9+jE60tdio+NlEXtT/9oWe8Rqzo/LQAzSPvp25jTzVZAfRt0v2Pg4BD6Yd8w54qXv8I1O62BE76H44VFGHJb42B9SBokfO1DqLWNW+m7aamKAILEJ6GarNt7/wI9iH0pd9TICPFXXdQYfrJNO3f42bNhwMTz///w//8/fGbRCBjgDWSgDm/TKE6plDXyQgRYcdXjkpiive2UARHlyxjFPTbUnoj6frhu1fANmBs06cBo0M3DSZTxkt42p3IxloNzTlHytIZY2Z8SRn4duFK8b1Enqav9ElDpqEzjK5MXXfvLskTKg/WmfWQSknSrbTzLyshAKyHGz3ja3nq64PktYqu8NTxb6o77T6kffO5uehDQm5UmuQJ/7zW9+M/XBO696XfGlKb3NGeYHm9FeM2t/DtyrfHe8rni7fZNLH6QvH5A3/v/q1785u3Xr5tkbr79+9uKu/+qrH3340dmPfvyjxruTzb66APf01fS64u6G4fXXXiv2n529/c7bkwyvMb722p1JBmRciQ1uOH70ox+efe9735tkh8f4ayx7++23p01239ryCzsoh+hyNE/x0dzmdcX+9U0IL5m/f/fdydb8JcbwQr0ZGCFyUObjUNLxRDd5laTRlzgdg+iu8o+BsseWqXbGv6xJQvEdql1i3fuN5kDXsXHBzwYgm65+jRLdFa7Z3dtEXnzpy0Dqms7KFz297sRn5Jd8fMqThU/aHGJbeKstyQ+RmfhX4K/9tK11ms6Ukx+4jn/xKXojw3wffY498IKyo/wRyK46ovsiiP3Vbmn8RPJSb9Lli/GcrbEj9QAj2+KD+DjP+nlOLp6UCWKL45z/8o2dyh3ScRFEFj2IHfScUkcFHWmj6j1xQeDH9kCadueH80MwF4mT+UGsav8w96Udp/+OQJ+y6SM5D6W/hxKz2E5+KPWZOgvRnfZeSZnoD5KODkFZtizxRnZ7sMHm+dXU8YYNG54t7MaWNthlQDI42YQwqBnkLNTrq3v7p6Xaq3rTzconjbxa4ld+1F7pa38mPhtWeWWlUdv0QHXgzEBn4BvRWriRIspNVR18n0a0+jERPUh4ilDblPZU21Q2M9NW2lN1n+7O61N1+9cGydm3g/ZUXyBNPbfFwkvT4iAfk86k3ref1t4utkDdcBqoF4uw9iqrV7ae7r76rCHzQurJ68TOg9a3d4vg3eLzYYecxqr9Exz7xbaFdptrRotU/PXJrI8+/mg63r51a7oB+O5use/pK/rMMX/e6da3s4ivdo2QsYiO53Z2QBsDzi/Gc01eZNb8iowf4a1l+Nj7KW9O1gixBVp8mvzENZt71X/8YsQ3c+tUPztyXuWNUHWtRZUZG9Zgra74ra7jd+o9YzukLWaeGfl9jH2BcsfEA+KbY9rYWtDV6ztkg3x+xvfqc6877WVOXmKdfMfE3Q13KD8uOU87jOy0R2WrHWKBKvCEILYHtXyAt9alPOXUN7AHj+taLlAWHVM3aXPRpWx8vSjIYKMj+WJJXk2H6ORTbfM9EoM52xI3fkB4l2Igb8QTWyKrgg66HelApwbZaafsqzpPDTpQi2+r+xoPefkgPHgLxP3OEpTxXUZQ76Dvkg1+TBJb17Ut9CCHz8gGWcaAnCuXc3JyRGnHfKn13Nf1VSK6+DFC7JGvvr/97Ufb24YNGzaM8Pzf/M3f/F2esMlTVm0AzHUbDBvZyd8Pjo3O7+pnYd9fZ6Dq6apAtl/YDYzsMMibdHwAsvl6WhIHOPUEy343eK0eru5XqseFWvfofFtxU5anDNp5bWvOcxOMV9xtmKV9NhmZDC3w8stVW/xkQRQ0GfOLhw2PD61dZ6OyLWJa2oYnhVYX7ebVuKbvhPRNY2nrd/tF6q9+9euzP+36qrrzxJQfPh6hT+5OZOPar9i+f4W/9dO2caG///rXv5le0P6Bj7Dfujk9tQX+0iJeTzzlZhYF9UkuT1qRlz7+7rvt9UObZcqDsnmSOD/AhMx39cZJk1Teh+fZxn8b9PQ9Sh+ffXrv053uPz58kgv4BrE7NycPn+Ta2cb25LMfTyjXQfgqiadjGxOPG9+qjDXAG7tATNYiPtFVfXPMebWnkjSxzDU/az6qwE9m4g+RHTvm9DuOZC4hN6ixq2KkNyR9VEY7nLOh2jfKB3LZRI7zOcS2yEkcegr6uIM2IM7xH5RxXuMP8Tsya51WVJ7YF9ngWnrkkRM/w+9IRvJHenpEpthBfAN54gmH5MyBD7Er/rVx9dE2AHgRjPKT1tvmmh8Zz2odHUJvXxBbyI/exAov2dZpIzsvA7LjB9kZc2rbPpXO+E3e559/OfnnPOkBdcZx815+lJ0DO/0YK042ikFdIDLbj34vPkxDI8QGPtOXNhMKj/jUtCWkruEYfnEJlIsta5CYjvilVT9dm6s3bNiw4RCey1MyBme037jpN7NMhvUXjHWD15MCG9lqUMzTA/yrNzCnpEyyp8bO/AntW2Dt/JuA1B/S9sRX/WmvibV4aKfSvvhCPdSnBL2i0CZPN8J18RMcMwlvuBqIv/pVj8YddQLZmOzrbMPVQ+wtvvOERv+9EVAt6iYff58WxRJ39fn1rn960uqDDz4Yku8heoozfY8cdd1uwNtNvn58/7PPpo/B57t76MbLL5+9/NJL0yYSnvThuX6cvOSPuOhzY8I23+BC77777tk777wznWubPcgxxny8s6P3L+TD9TbPetvSph2zcO9R05QP78NYzyB89YbjIhjZNIfq31w56aHYh5zXvPDOIfNBxgnHtIG1OFZ/4n8MYo9ydISW9F4GVd8I0qO750lMK2JveMnHE8rasKZLS30kLbRUR3TQFczxSkt6yvS+JD024JdW+R0jK/LmEH7jk2N8qT5CrdNj0ZdZklFjg2/EK7+3LRQbk0/eGizFisy0q3pe6+CUIDv1QXbaYnTFT3RZ0IW4YB5o60r+jH3K/dNSXNnX5tb9N/Jiv/PMvfRIm5MV25p95zd8K+RfBGvL0d1issdFdS6BDnUqPhs2bNiwBs+1QfLB1TOGTBqZ7PqB+FQg36SLTgm2eyIJ8jTcNx3Z6DKhe+LHYkCcbALmlcj2VIZf0/YfvkU9PI2yxfT6QF2oP7/SOW9P4l1+obrhMDJOtgV2+4MPXr/IplOQhTReG2B+cbYJha/iO7u++fKNl89u3LzxCCnj1cVdJU+85OepS3KN2/5YiJsXT1zRA22c/c6U1l6bv//whiI3CaP+vKaPG1eMF8YNRPbv3n57erpK+qNoC26/tg/93KUZmzJ+Az/Z4hhfndf4Bvj4JQZ8jG9Jn54U+8RTcXuyscj2yA1G8ucQ+9aWCZ9yAf094XPkd6XkodQjf0P1BjZtD2LnsVCu149gSf+crtiOIitEV72uelMGaj0j1zW/osa5Iul9Gdd0Z33ivCK6UY0vxFayxSB9BCU2iVnqB+Ef2Q5z9sWuKqMHHRXKVnmRBXgTU/Kk1/jLn4tlRWQq08cpcaEDj/jiqzYdQpXvnHxyl2TF9pQd8cQ28shJ/Ttnf/VjLUb80ugh29yBqg55pwRfo4OPVYdj6ls+Ep+LIvGFrDv94NO+Jzsln4Mnm/UNds2BvLzim5iRzXY/GElvn23Yf2R+JI9t/HNMHZwSaV+PC9HlWEkcUOyp6Y4bNmzYsITdWHHxSeC6wyYGtAFxOr0STN94uaI45imKU09iTzNM/tnociNuodBPePJ80wvv3KLDxlhetdpwvdC+1edm50HChiuF8ctm1X5za7xhPzvOPeh/vnXlW3g/+clPzv7Lf/7PZ//Hf/kv50jaz3/2s+kVxed2i/QRpifBPv1kEumvKuaGBhkP81cRP713f7pBuCzIff31189++tO/OPv5z382Hd98880HuWM8t7sheeX27ckXPvX0n3f0ox/9aPqLsG5egrpAp9e4bqw6h67R48OP8PqY/d//wz+e/c//+T/P0T/84z+evfP7309lIj/nV4nYFqgv7cfmZJ6ilQbsNyarN5QbucQhNq/BRfyig67Y4Jgb5SX9c+lsUJ8jn1PGsepE0Rm9Fbnu/ZPexzqgYy6PLebIvu8qEzuc9/6TNdvfT4T0BUic5tDHCaq/ZKFejnJpZ0HVuwR86pYM9VbjA67FEOEVa8e1YEPqhn3sRNJrv+mROpM/p09+/CYPHz/YOorlIcyVIR/FXucX1bEEPqSfkd3XKUQ33/Ghi4IuOq011f1+Lc6v8+2APX54ySdS5mCDK+ODI7nxIT8YKV/TR4ht9B6Kc99m1+BxlangD9JO+RdKu0o+0mc2bNiw4RCe862TDN7PGkwSBt41E8Fl4C9xmbBOjTagtwUM+y87iTxLsMDxgXqLATfV6sBE2MP3cjzdMFowtDaxxfS64tBC72mGvn2ZBfipoQ/5ZtSSTcYf/c4fHLGB3L5x6Gbm0T7k+1mjm6/4XfWQq56RG5Qvdv31k7uf7Przt6cNnffef//sXa8Q7uj9Dz44+/yLz6dF7kcffTT1bSD3MNoTY3/e2fvHBx8PBvqNHX5FF4ObN2+2zSklduPvkmw+jvKlfefB4jyIn5mPon8NyGt6djd6zz0//dVI3/mq5PtjfAgyX8zdBM9BuZQFenOzIe50IGMucuPW16e+q30g57kh7X3GK20Uw0OoNq5B/FqrKzFP/PgY35E5X1584GP1mb/RiY5Fb+eSjFGe8uysdROwt9oI+KX1smoMglpmDfCjnp/cKrva00M6u6vuWjY3wnhQj9QRH/Fls2HOh8h3NC4tgVyEVx9ZcxOeMSfyleeb89i4JEus8JLT10+Q+JIFjjk/BuxK/CvIGrWvi+hYQvSos8RqVMcgLvIdU+YYVJ/8ka3Ua9D0uj7voye86Jrz3Y8zGTfI99QXX9RP/mKxsrF9BPlpD8rOxeBJg091zkD8zthpzsj8kXVH0hMjpFzad+Lq+vXXX5vSNmzYsGEJzxkw8kHcZw0mCpNAG0BfnJ18LoM20J5eLrCX/CwwNlh03H/4+pCba5tYFoR+ATNBjhaEfonzna5HFwRXU28bNhyCcVd79aTSk1qs+XHD5tarr74y2TOCMdTro1noszWvCSObRnM/kmTcQhbkGY/7sSw88PkXX5x9fPeT6Xtc+vovfvHLs7//+384+1//6+8nci7t3qefnn22y89NSDA3xpMvi81OlGFT8kLs++OOvtrlf7kbV6ablp1/8X3kqzJkGYci99GxpqHZcfEbzdTZX/3Vz8/+03/8j+for37+87O3fvCDc/6sRfNt/8oVyk0Hyg2H/Ngevw/5fAjNr+P7wDH+BdEVH/b12nznY26yEgs8yvGPr+o5da1NJ6+3x7WyobUga1Qm8udkpQzij3obxZWc2F1tVo7u5FXUmFWM0pQdpYP05OU81709I9Q2plz8c0TKV54R8PBRHYJ6Rn2s4vMamUCmNgFpS3MgWxsjW9/pY04f+xyXZMlXPn02YLdrOoD86CCr8h4D+qqdqQPE3tiSvnMKkJ2xJzGuNowgH2/sUZ6cQ6htyo851pjSKsRAUpc84TvfGW9y2eCK3PjgiNePKuxLOvkj4OVLfFuLQ7EaIXFAdKZO0xa1q6wBsu6ufjsPb8qRJT18/Ez7deR7xlZr/PxggFzH55RfW6cbNmz45uI5rwVl0KqD1LOCvLLoVxKbeaf00cDtl4g1Ay21vi9kMya/YHgtqN1E5Nfh/a8XbXIwubRHzOtkc0p6murcZJeFAAITePvl/OspXmKoXirw4DeZVuDbvvm04XFDn9P39HHfkbvIIvSy0O6zOO3HgSyi9StPbLVfnNsC0ziU/oUn9GcL8+KHM3KMXY5ZyI58pTvkKS5PaD6/0/PDH7519pMf//jsL37yk+kYcv2Dt34w2f7Z55+dfbGzLwvoJdBtfLVRZDMNpZxjxtg/7MaKTz/5dLLZE11sUTY0QvLmfAzkHbJzhCobxd6eyFYf4XUdfeHhozoUv9ys5LyNiftfzskhTyxQxt6cJz06lVF2LdgIx5QJ6FtTLjaF+IfS9qX1vjrGp6QHqYNKI8ylrwF7UAV5o/Qg+uTzbcSHhy+OvX1Ji/99vlj1MvvrxAtVjPSlPgL5dKQNpm5SP9DLTn54RnpGCF/q2TkZdEdXZI78GSHyxA8/+/t6cC5dX4Po7+WTJS15kTVC+Gos8MeXyEi9QmJ8LFJ+BHnRET8voqMideIoJsYcR7QG8T/+kjOHxA7ad0GdPaqnr6tAWTpS347WpJ7SqnrZkzgae6eni3fKpJE951vsw7cUA3pDuU5diEMlbQppj5USL+fhCX8fx9hR7XGeNpc5o6fkpb+gxCbXKLJQ9cvmYLVjw4YNG3o852O1fq1ww+OjvhlAnhXkL0JmwD4FDKzilZuDuYE2kwu9+G1s5cYy5KkI+XkSyYZXjuRnQrEhdhVEDzuuc72b5NrE2H7ZNCnmUW/wytSXX7YNMPHikwm5Ql57tWq/QPHx622S3PC4oc1pe7pcnkp8nGjjUnuNo2//5gIbxu0XVN8i2b9mJk9fdK3voeTVBe6Eci0vNAc2kZMPyt+8devsL3/607Mf//hHZz/60Q/PkTTf/Hrp5ZcmXhtxZC+NYcm7ffv2NL5+9tn96S8ofvrpp5PeHcckg35/GdErkn4U8Qqg8XHvwyRmFks+XgaJsaOYz1Gti8wdjnyoNzW5iZGf2ER2rddcV6q6oq/6feyYquxS3S1BuZR1pDs+8xHFR1R1xfbqQ3zu/XOcQ2RHb3QnDsm/LNhR0et1ROrXdQ8+pP6WUP2uiG+HfEks55DyVVZi3JetPuY650Hsigy0FiO9ZKV/SDsUr4rwi7PztMHqR65TF3P2RhbqZfWI34kFoivyQ5EXO/CN5I3ABjJGiH944hcdseMiiI2OkTunvyK2IHakLmpcRoj9nvq33txdroay5MY+13R5g8RfUexBD35r/OgNjYAnOshNW0AZ0+dImcpfqcYkOirSblBiWY85T4wDcmpe5Q+RWX2OfhQ/q6+xURq4d4p/GzZs2DDCc24S/HJuELHRkgHkWUFuzAyOPjQ+N4mshfi4ObRh5UhuhW+4hKdtbLWNJNfSPVlms6ZRJoA68LOv2chUaXgy8J+S9r7s/9pL78/jhpv+vo5ct6e49pOiuNQNArF0Uy5W/BD76k8r0ybagP9u9sViw4bHAe3RBpe2l18x+/Z+1TBGpf9XWHR+9VVeE9i/HgDpc5AFa79IDVqf68fFflyxmN1zyfdk1f3P7u9Gvz+fvXbnztmtW7emfmxs6slH32/dvDnZ8vlnn0+xrCCvyg5uvPzy2ffeeGPy/f33Pzj7zW9/d/bue+/vzt+f/pLi797+3dnb7/z+7Kvd2GJDjQ6x6v2c5Ht1cS96iFF25PQxaddjgVV/bjp6e9iZY+o3aW4GjIegnPLqEIlhpfrr+lI9V9T83q81WFsGXwjiJ0p673t4Ib7E9/iX9CWQV6nqyLFSRX99CIlnldfrrmk5Tyx6pC7V61w9RR8kNjUm5GtD0Qc1fwn4qt7YGznsY9tcfYTPsU+Pz1XHsUh8ECS+FwEb4o9zssQtR37Tkz62BOXD61x5NLKNrFpHKVd5yZCGqj1rfVUejRC7EkvH2EvHMSCHfcpVmw9BOWVquVFdzNlj/W2Tayke1p386+NAplftPCmc9b/jCOyQ5ykumItpUOORmM5R+JByIaAHiUnqaUQ1bu0H5kefwgovvsitiF72hEb2IrYu5SM8kCO4d1Fuw4YNG0Z4/r/+1//6dwaq9vG/9ldkMmg9K8hGhl/8Dc510F8L/GSYuFBF5D33nEG6TV559dAALJb0mjx9KNl5yOZMJg5PTZgk2/U+7w9/OD/BnIrUM7tNIO2ppv1G4LHxORU8WSHOdSJjpxvvHmx0wxuk3SrbfuFpvybVtqyMvECWfHyXQe0zTyp2G6439n2t/frYbyQ9LhiT9He2BNqvsWfOJva2RWj761kBn1D66+9//+5u3PvO2Z07d6ZxMn3CMXx03b9/7+yz3Vj4yiuvlr+WeG/6mLxXH9966wdnN27cmHSlb4WALcZH46nz9mNCG5c/vnt3Gutv3ri5s+PVyc/YzAZjBjnGFD/yeJr5k12Zuzv6dGfXzqPpO2U//Yu/mMbw6FUWjJ2e9jJn+iuR5Ffb+IjEk3zjug/F4+cLhDcxIZPvYnfr9u1pM67qDR9y3upif3NQj+FvP/CYz3N89KZGWo1vEB2J2xrEBmXNbWuBX1l2xPYlio+OYlDzqh/xjQ81PboqqowRVd/Aea7lRT6qcQ2P9F5nEB2VyAyco6SHJ4je8PWQpz4SB2BXygXK9mm9LdFd5axpI5ETHZC6S6x6ObEFJXY5xo6cQ+RE/kWhPL9ynmP0HAPlaj8lg5/6+7F2VlnOa3lyq47E03FU187xkXcMUsaxB/2pw+irOqr+OeBHbM46LW33EGpZumoZcZDHRgS9PcrBXBuShjwUYL7JPJ48dtoAcx/QNrDmYyvfXzJmk7LRGR96IivywhtyjVLf/Tm4Zl9iGarlq0ygD38QW/hcj6G0vSA80kckLxQZ9ToyYo9jrmMXG/WlaueGDRs2BM//1//6139n0DBgo/yy8KwMGnwzaLp58DqmwdXNUBssDewPGA+ADE9v1U0VaL/atI/V5s/vu4H01FE2tdxM5bWftWB3yE3KVRB72KWu+cEHk2/b7MIzXpRfJcTKpOWpq/xlSRtfPdjpnfwebBZ7ZT1Bp57rE2DqnJ+ZRNWrMm6YL4PUMywtbjZ8c6HNZnzQ53z340nAGG+sNxaC9p9vb831ef3Fd7y07SyOk15Jv9UvPYVFx77fPbqANx57fdC4CV9+0Z7MvP3K7emvBaZvopSHLILFUT9nk9dCsqn29W5M++53vjt91N/GEtT5DD+9r7/++jRG+BGBnJd25d94/bWzv/iLn5z94Aftm1/RD3QaG3ej8/Ssrae88l2Q+Aiup7Td+TQO7cabW7dvnb2wq/8a3+pP8+9sZ++Ns5s3bjzcsFNH7EW5MXBEyivXng5uP6IYg4xF2pb6tGkp3Tifeodq7wjx4Zg5iz2x65j1Q4vrfuMpckLxPbJjO/7oQq6rX4lrrgNlIOm5ntNLDsRGMQm5rnp7XSkvHd8I9FbdVW8tW/VGd3SmP8eXCrHBX23Dm7IQG2paztlQ5bqOfUD2IUS+cvGFn9JyHb2HoExiU3GRjaMR2Mi22AW13xyD8KduyLuonVUWcs1GEAvzS3TIw+M8vL1OeamT1EPPU4GHDvwVysiDKgc5Z5t4QtLnoHz04BOr+HgIyqknfo3KJA1ffMYbpE1JH41feP0gAvkkRuSAMsZZ9wnkLPnJTj6CcuSQN0exiw95kiwkradRnKVXxG5HFP/ZgqKz2sHuegzVOASRC7EnxJbYn1jnPJtWofBBZKYMeBMmn6XZsGHDhopv/fM//8s0EvrlPTdhu+RpoeyX6GcBNqFMPAbidjO3/zPZBku/ti8NkC0u+w/MO0oz0LcbrTb5kGWSO2Zivk4QHzdXnkIDfphQ+XTVEC+/kGUyWwIb1ccc1Ie6SZ2Tm7Ysz42vRUqQJ0L4uwZkIfWddhS0J/naK1UbNrSxYv9Rb9Cn/FXAJwVtUx/KDxo2QrT/pTErfcpf9tP28Wr70vmI6kI3C9kcpTsPLwpf8lK2Qnpk5LzqrGXkQU1TDunbKVfLQ+WHqjN6gX8pHwqfscAR8FReiMxqR9Wf8x6xwUZWuwlwA3vcpkDQbGiveGSMH41hwH50zBoAvzbCF5tt8blH4lL9dgx/Yp5zbVWfGcnSlufmW7aIU59Hlzz6IzM6q+4e+q/8ka456Pf0KZO5zXX8huitumtsDs2JdIi9Mj2UHcVHmdpmq77YAdL5LV5zoCOyRnEL0j7wo8yR7FN+LdhETsZToFcb6f28CNglFtUuOsXMMfav1RV5yrKTTLIvisSx2sI2INc1JE7iIj+8PdJ+2FbLV7CfLHzGhOgH5er5qD6jQ8zkjXSQEd/IyTxzCNFNhzLKLoEv2g6KrfGB/vh4795nUxrxYujeIfAjzq1bN6exibzY6699S/NjT//Dab6D+cIL+x+Y6GaH8pUqEjcxo4ueoNnXKKhpSZ87HkK1px5repDYBXxDa+ow5fD2coPIR9YrPehyL/ck11YbNmy4Xnj+r//6r//OiQ0Bg4vBz6/VBhKD6tyA8zQhk1oGyEzWu+F6518bPOvEAeKgjFdm8Oe7Wo4msWxumczar+VtMygT5tMKde5XkcSFn26G+XSVfpGdJ6GWoE7YZMFQwda2gGj1k4Vl82U/KWdyz03eHhZnhxfabFTXc31DEr3azIZnD2l/rV+0TW6bWOobaYPZ1Gptcf+HHSyo82TNqO08LjQ79zcpc68o9tCu9Ru2Z+EaGTmmn4WyaNU/HXv+ehyVc8xCOXlBrnuKrFrGeQ/pFZW3lq18Oc+RrvCDdGnxC3KNxCFU05VrctoTtvXJLO0mN2N1PDsW9Oz+ncq2sa49AQS9vNgVv9YAvzbSxt32BAeqPle/9z7v49fmnxb7QJm59imv5w/qzWOP+BZ9VcaIH2L3HOT1PjtPmehA0YnYMNIdeXhGkK/++Dlnl/TorejjlvL09TYg/HOQH58jp9cHeFIngN95/BuVmUP0BcrWOF4U5IppXy/xMes7uqN/TqcyqR+yIi9xmqvXtSCj2lHHycB5Yo4f9fbmOjHt20XqTR4d/JAWeZFZz6HqcV7LJC2QJl+8nEfPIUSecqmbNYg+VO0NpU8lFmwxBgdt3m8/dOML2oai9tPkyMfnaWXrAeXoDPDkOnIcKyUNn6N6SLtKvfQU3yDl4luIb4hv9TyxV8Z9kfPKE6qyoic6ofIdQi03x58YIPb0kC8e7mXbpwFavW3YsOGbi4dPcvl11xMoBs/cmBns/DLxtCN/Lh+ZhAySBsT22l4b1N1MeLVklzzl7f6dJgsTVJNhYdIGYAN3G/j3CyFpzwraZGIi3T9CzT83Rib6+LwGNkxbXB+dZCvI9yvMkmz11jYY2yZlqE30TQfU+nGetpyNTHxeZVIW6Gtt/bMd//Kk6KkwrzfNmDhBm7E5uuHpRvrBt7/dFv/OtecsyPZtYN8Y9m23tUX82l17pH4/XjxJWGwb79P+vYLRnhCat0ueBbrX/PhgHAh/+l09VsJH18j3kc6alnJiV1F19dDfaxnyej19eUcU3vDXcn2Z3GDQE12REwqqPJQ85choT9LtdSN5jlcFY2a78frO8Eee3rcgtsfHnlLOmJqy0iH+9EcwbtYyQdLx9vFge2zs85TTDlCPlBvlzSE3WEBX/K2I7ckH8XDNB+jtnINy9NWb64DszM29DeTzSx5kg7Tq7WMdGcpUXunIvJtYsanXGShX6yMEypEvL3LpiqzexiWQow5TVjlru/hzEZAl5mKTm3tyYyv7k+a8xkF61R1ZaWeJtbRar5F3LBLL1DEZbKajyosd+EH+SGfk4a2yXEsnx3XGfX5VuWS6Bvn87dstXjzRgUe52IicS1vTFvAicvEqdwjhTxk6nbOVfyj2SBeHvO7dfshur9T7sce3JK3z8IKy5tL6lkHLo7O1k9hMN3IOuV5CytJTkXL9MUi5xKfm97y5xq+O+3lhDvj5qu8Eqd819ZI6SR2MQEfafPrnEsKjbv3V5Dm5GzZseHbx8Ekug1smM/D0jmtPKvUD4dOGNji2BYfNLDcT3EyawdnRgt8g3Y7tlbM88SAGBsm20dMoE/HTHp8R8qHiNjGYwNoCyESUNtL7LV2+uLaYmpDyrbfzvziFBynTzttEp0xti/Q4t9C2gMiNWSM62qIJtcVVqC1c5O+kPPCloX2frfkSOjQhmzSbzP1CgL19HBIjPm14upC2qP3p+47aWNopaEdtA3W/kdqotR/naY+uLY61y9r+niRq3wN9ZandQ9p6FrHxJW09R8gRxCB9gY70lcSoxqonILde96j8oeiK7CWkDBuR8/iWNMSO6mu9RlDTILLJq/5Gvmvtgr1upHJTEN6rRrOvtYce8TPnua4+h8IDZPLHdfW56drTCPrayHc658rERuh52DEXS7qk93nVr/hafc55kPPkRyaK7th4qI/1iC5yKqSzn3+RHdBHD8KTtFAwig1dSQ/iF1lpmxXyKlzH7pznOueQY+CaLeGJ3Bx74Ek7C9hX/TkWZPHTMWu7pNPlOv47r+lQbZce+zL24wtvtT1paxH50RdbqpzIrqhpvc56TTbgTzzYX+tfWvSD8jmPHvwVsRNfdIDrXk9vX49ef69rhJTp7Yuc6HREiXHqDvxVdCDDetRaNPICvqB9HZ3Pj/zYA/F5iQL2xKb+mPNKQE/adKU5sI39KX8I8aXWq7KH9ATKoyX+8MSunk9a1lp41EG792ivv7qGNfZs2LDh2cDz/+2//beHm1z5K4SwG0umAcJg0Ta6puSnFiYaN2huJmxU8KdNQPsFGWrXSc/A2V4bsclRFyzPOrjI1xavtohpE/h+cS2u+wklj3C3x7izSSC/lW2bW5l4UqbJ9PFoT5i0j/c7SlPOZhSZfjlrTxw22fLY1b6D1v4yHFv7RZJTdqpX/gS1vTf/2lM3c/AX4Wp5ZfnbL7DIQtpT2krKSdtwfaA+tE+kLSK/0mpfbfxr7SP9QPvwUW/nj9L+Y6mt3ttmmKekrhfaWMc/sGmbBfAS9J+2Odxu7DJeVgrS5tP+5eknuV4LY8CxZY7pY3hDbEzZ6hMbMoalrYQ3BPGXnyFxjd+hxA5ybuzhomvHB9lXDvrUv7G36W5xjl/xMz6HXFefqm/hqfLWQHsUq75M7ICRvDldys0hZeJnSHp/zHnKAV9rvVb9ritqmWMQ/dUv19qjWMWmAF9tb/jwVBuD1F9NA2WUryBDOl55Gd+gxqYitodqn8lxdI6vtrXk9RTeilHbWYvINZ9X/yC6pAfVDnNCeJKGxCz1Ue1yjlI/x9iMn55at+RHp7TIdIToqzzVvyB88skPr7Q+JiAvdYA3ZcF5344gPMrFnpyTP9JToWxIuTk9PfBHXy0TXTUPHOW1NOVb+5KWdN+n1F7IBsfaL8kI4Qcy+Jg0hF9afF+i8Oa66giNoD7XxCmgp/k+L7Mi/GkPkLLsXIM1+uhJvfdyXfsel2+n8dd1429/hMq9gxhIQ7Cka8OGDU8/nv/rv26bXGAzywCSQQT5tSIDytM8IBjoLOT5aDDNK5l88qqIx1ltZhn78OIxILb08Udvv0kQCzfy4mACaZtZ7YZXXLUTafJa+2kLFjf+7XFvm4ttIierTlBi3V4La4v3kEnJXy/zitSNGzenzYdMhOTZeLTh0GTOT6RsaXa1X7OADeSxFTLxkTtX1/yoWcp6XJ0dPfhHFmr2Nb3s2HA9oC1pZ9lczZigXrWPvKKw3+A+326X0Np0u0FYW+bxod1oaP+BV3DzhOIc+CQ2NgLFJ745D7mWXvtQ+lafvgb6S2SuRXQdAj5odbXfzOqPyQ8/e+K3dOf6OEreIV8jL3y5TvnoumrQzQ9jd4/Yz55ax7E3Y+kI8sUuiKwlJJY9r1jUWFW4pmeUV2PY59EVG0OuodZDfM51eKT1iL6RLlD+GFS/A+PTaA7BY35O/UB8avPPeXul4+ttJXvkG72JQcqkfPzO8VjETzbV80rxJXmunQfsqL4fC7LS37POSXqo1l/S8CUm9EsjgyxxJ2sEZaofyq+xXRl1EXsy5ihLVuTgY0OVW+MH1Z8Ar3Rlo4NfozZBHwqUVSbnI/mAJ3bkHP+cnorYnvZ4iD9IPEZlYieexDBpzv3glR9IjZPWAz48b32aOAXVh8hzVE+1rkC5xG+NHzVWxyB61sYKjtUVfvGo4G9iuQRlxYm+JZ2J6UiuPHXilVH3BdZs5Na5zVrP99ESj2NismHDhqcPD7/JFbQnbXxgvf0Jc5sMBnkDOzp0I3RdYfD111Agk44bWBsXwEc3ugY/eXxN3obzMHG0p7ZeeDDh5ImF+QXRWtgYUD+Z9BCYtNQh2cdO8qBsJja2gjZuY0M6kNv/9c2KTz/99Jx+NoJJdGlzbAQ69a34t+HqIdbtJrE9TVjrPa/suSnRPo6pyxHoaO2t3YhcN+gPfolODNpfIN3f3I0gfjbGfNTV2HlMP4+eushfA/VEz5qFcpBxI7r004wn/XkP/CmXY6UeFs3kqONj6rnq558xRHk6XRuDRvZdJfyYYCyP33Nge272RpAfUu9kZQNmDnyt43uvf6kdsEVeL5/M6O/zpMsnbyRzDuyAfvOCrNRp3w7S9tlxjK7IBPabr3JdQSZ7HGvcxCW6M64FYh3+WoaO+EZ/CH/4XF9HpH3EL8e1EKfUbW3Xacfk1TaU9iOtxg/IUWbNmkBc8Ud+364qyDTeQMabKp9N6lyaPPLIR1DrTWxGP97iYU+tb7xpXxX4EjPAHx10V//Zzj7kfATylXPEQ1aolpFPdm/PHKJXTJbK4OE3XXhrP5C3O5vmST6Jcza5KmoMnJMxaiOAT39zDN+SfbEDz1rfQTn2qu9jQBe7Q0ugI/4EytQ4HoK2dCgG6oYveMgd2fW737394KyBXdYtr7322oOUR/H22+8c9HHDhg1PHx7Z5MqA6EYGPGFz+/bNaQB4Wjd+DIztaY02ABvs3dC5AW1PeHk9qQ2cfGwLhOWF/jcd2kmONU6niFkTvV+QAbnReREdymZzw9N5YBJ3o5+FCrleefRk30iHBc5oEu5jsAbKxKb8wYcNp4V+nzpXx+ItTV1lwZvNLU/7pQov0r560NeeHLyevxayrW3ytjFRn3DjcMhWP4CYD8K7Nlbijo4pA+KonpQZlVOnOYaiK3k9IiuU/py2MYqB9BHMG/Fr7WIeqq3aIj+dtzbptdhHbyqvGvqJTX96l3SzE+/cTRO/+CMm8Usav8iN346B9Pg/0i/O5I3qhi3S+zIQHX39Vf0jmXPgD6izHuYTMvu8+Fvb2hqknGPi2IPM/oY/folLblTZVGMgvUKZUB8r1739zislDcggX1xjf2jkwykRG3pUG/ngmPPYK8biVPuxdDb38cOrXOXFJ+b45tpqj6rbea8fEjeyo5Pdtc4hfGkr7JCGRpBfx3x8yiYO5McuvNEbxG7HHvjwsyM0QrWtxjeo+uTHpjWbXGRHN39gpCMIP39QjbM8afKNzcZJslKmInaJa99ueijvx3W8fXx7VF1r2lagnPufuR8l5pB6ZdOSD0AHuswm19IYH/A//WC0SQu///27j9ic2Gk7PntiXVgRnX7I9oP6IX83bNjwdODhh+cr0sENCO28DfBujPJB8qcBBjYDogkpHx/Md5t2WdPmFsqE1ja4rudN6XXF0zQZmOTUdb6RxHaTnY1cbQXa5DneyM3C71Q+k+PJyCYTPXrzcQpYDGjfiB7fInuWYdyyqLPg8oSmmIq1jWsxsEht8Wj12eL/oPCJoK0hY8l17SNewbCwBCaKw9LYFzf8WMCn+MVP/SZ9aA6pB8Bby9Xy/Xn4HMkIqWdU01D4IXbGt9R3q/PzN+kpA8776wrX1S6InIrICS8KRmVdZzyS1q7Pl8158vY8j95Ihq/yp3wPMWnxnPcHUn4uH8hJnCG6+7j3FLmoYpRWsZQ3h/gRG9dgyffqY0XKjPIOQRlrGMcR2CGv7wPiL73qrnzSIEcgq9aP8/SZ8Lmu/ajy5jw6w5d8SJ40Y3CVl/KoIrrXIPLnqMahxiPp4Ul68mrZXCO25jy8fOHTWsTfyIakRW7qM5smiWeAT35sjk0oqDJzjL6UTb9ta4V9fUZm0lIm5aueIDJTJhtN0iNDnJKfNlDj5zzXOSfTMTJGiG8oOo6B8mKRcjnGJ5CGr/e92ramHVR5KTdC9LCBjrVQjo41tkB8QnRBYklOPQ/VvIrU2RoovyYG0T9Xr9b0ow2wyNa2fZ4B1DFEJnJPWD/JsGHDhqcX3/rFL375sBdnEEA6uxsgvzI4z/dq3Ch60mXtgPmkYMDMx6MNjOzNokqedEfITe82qD3b0I4zqfklELTxtG1Q/x9/fHc4MWsjS22f/PSfY6GNsk2b1OeOBduyuOr1Z3OO7DaBP/r9nWcF+rw65as48Ft9Gbech64a9McGdXMdwb5XXrk9tT0x8Qvm0q+9mpXXiV977c6DmLZ+oHyQmPftEI8+ljzXtdwcer5RueiqctMXqy3sTX4vA5KGN0jZUEB+JXnk09f7KL/qiyxpuamE8IO0+g24lMlmOLa6Od/QNnJbuXwfqN182AALb+Q03v1TR9LVUTaG+SOtR5O7/NqMTeaMSfzPfLv0BOAauadCdEGNwSGkLtnf20ie/FF/lw7H+EWPuGXO6hEb8OW6HquPaZsVPT/0aY7kGFP54ObxkA/42ZwNmaC2AzLqjagyoVwn1r0+aWSE96pQbYela+eJNXtHMVoqH3/JkJ76iq/ypGUuT5mUCyWtgrxqU/QE0vEo50gHXQH+rE2kJy9y5nSG4kt0KAfRh6CeA50pW1HHlhESh6D6shb80ubZk5iTqf32kN7rU06ZNWNL+haflmyNHrxr5ELKsJv8aif01zX+0ZW661HLynfNl0Aaf7LWPgRl8R+KQcZEa5W5NuBpriU5/CLD2t886jtdFWJ19+7d6d5ww4YNTy++9etf/+bh6JVBCWVQ84FFA74b45deat8v8qSLm/3rivaKUnsF0TjsiQ1/fc+iPjfBFv0mCoOZQXg0iG949mBys4l0//796dpEpz3kVVawyTU3QXqcebTAMPmS5TiaeLWvRtPVYnvzrS5y2Ioqat+sMtoNQ7txHcmO33UR8iwh8W9PbbYbLOOUD/6LyeNGFlGOo18VrwPY5juFuVGxaLTRNbdwBHx37rw6+VP5nKfNOg/Fb+kWp7nGC+pJiitpbMHbI/yQ/hc+fSK6pEVG0mOX65z39o9ADoS310FW7w+e9FFp4UPRH15HsiA+9fKUgZTz5GezYe9HLZONK4SHfnGv/jc57VXd/gaELGOEeRJGMVKevKZvvGFVb0TxsYNcdkkflQG2JoZXDbqAPXNge+A8xP7exvT3tTd1S6CDPHFLGwnoFqNaN9IS0xyVi49pE8k7Bmwhhy1rN7nw9jZGDr/EbmndFRmOeKsc6YlNUP3vQUY9PilU++bsZaN6k8dv57lO/aVceEMVvWxtPO0Vbx8/iM70zxovZdSdo/zoxNPzQmSpN3aPEBn4ensh40Xf3ubSITFxlD/iWQMy4m+VI63amvS+LUrn15xvFekTfEodj8AnRFdi2sd9hJTpYxF5FXRX/cqlHpO+ZJ+n56tMdp56k0usxGxpk+vdd99bFXv1y8f82Odcmrnxo48+ehjnDRs2PJ341vvvf3BuFDBwGJQyqOn0/oKcjt9e72sfP/UXLA4NII8TBigbVza4cqNrkPN6ooEq9mcg5aOb4LlBcsOzCe3Erza+QZT264bMt7mCe/fuzy7A5za59JMXX3xpancjKIPaBG7R9Khs+qKTne11u/ObUj6MT8Yx7Vbb9409C4NnDbsw+XfyTb2KW+vb+v3V3ygvQdxtFqjSufb0JNHaWPvLks7dvNjkWrrp51M2xvijLeav09oo9vFyaai2Z+XUET3aLh3qyHfuvt7xPrdL19Zv7Nqpdk8+3irDNbkf7hafz+/k+bYGuekP+JRDX+/62ue7vvKHXR65t27enPjIQGy+d//+2Z/1o911hXwyXtrZYWyovjom37kNcdD2xBEPAnzsc+Tvxx9/PPFkPo0s9N577+/KPRhXdtcVO46zF3b19MLOj/ThyOVH+8GpjWvy6TLWyK83sx988MGUr47kaZPmxxHETNsgh509lI+uUX7/tAV72YKsMZQZlcv8nBheBdgObHHOzjnIR4l3yo5sjDxxvQzIEFs6UYV4Zh4Zxa+CnNx08nHJzyUon7rLJpe0imqLvNhdYySdX+TwYa7tQNos9HGWR0bliV29vNQb3tjsmHNwvhTLynvdwQ8kFuLGdjGXlv7oPOniWCG/1gu+kFjWmEePYy9HWsYOxxHITFuIvgpjgTw6KtgtLbqD2AjS+3JrQAawS/nY6Ji8yBZfJCZsrUhe7FxCyuOfi0WQOsALsSn2VRsr1bScHwJZYj2qgxHw95tc7NQ312CuvivITryMs+SPfPnwww93+fNP+41AprnZfaI+8MEHHz7I2bBhw9OKRza5oC1+v3g4kFqwGgB8INsAYCDzJMxlF3OnhImIjRbmwDYDnEdRvbKRSdhNnJuCNYP8hmcT2gJKG7ER4eYzbUS6m/a0/4q5Ta5bt24/XGBdBL4R8OWX7Ztwp0Y2A55FeFrF+GQTT33p3+rvuvRvizILJ+PpqN08aWjzt2/fmuwUP5sebJ1D/MmTPjapfv2b35y9887vz958882z/+v//D8eLizVAX5Ubz4+2C1Af/e73z38yCu9eCyobSzZhPnBD75/dufOnUkWkg+f7fj/x//4H2e3b906+/nPfzbVexbGZFsAo7uffHL229/+dvLlRz/60dkPvv/9h3pA3q9+9etpLnhux18x2bsj7eqtt96abHEeW4AOi/d/+qd/mvrsD3/41o5++NCO+EsW+2ww/cM//OPZT/7iJ2c/2vGZqyrf//v//v/OPr7bXpOOjYGrb+9i4wnP7+9iLM70Y7PJ9otf/nKy5cc7P3/84x9NC3Q2keNHnz/uZNpg+x//439OPD/96U8nf/STuRuQdiPRXvcnb4TI4EcPebmphimmO1+Tri6SV0HfXN6pwJYWmzbex/6kB9IRW9iO5I/8heStvambg7bR6vd8O2CHtiQ+czb0qBvYc/V4CMr3c2bSg1pf0tOupcdW6eqXHH6wZ84PfMrytUdsiQ4Q8xHvIdAj1nQlPqnnUK13R8jxOiGxzjHEP/FyLu4I+KWt1TguIfLwp24cxYKciujKcQTl2DXX38lUts+LL/EzUJeuj+kfPfgmXtVu+qQlXVurNiW+joH8+HWoXYqDcREqr/TazujuqaZfBebqYIT4UdsTf9aux9aM/XSQn7kH/5xsc17+yNQxUJd0kL9hw4anG8//zd/897+rAylkQM8A4tgG8TZ4WfzKvw5/adFgxDZPEWSDiz/SDJpugg2abDXgXXYBuuHph/bgqYc2eVsgtM0S7QW0Hwve0WRbF/kVJt2+Hx0Dm7E2kW0gQ/v2zuUXLjYKRnZJEwOLGNSecmyb2W0j24Z2syfkY5xMuqoF1bFQX3xgp8fL5zYgnzS0mRs3Xt61Gwu46xG7QFtW58ZR5HrpZlg/8Uc8bJ5oQx9++NHZ2797e/rRQ+xtCLVxd78pANqM89+9/fbZb37zmx3/Z2evvvrqtFH185/95bSZdPPGjWl8tkFF1quvvLorQ8YkYsLXf/j67Le/+e2kw58EZzub0yajd5IzfVPjq2nTzJNcsQHu3v1k0vPyTudf/fznk93f//6O3vze2euvvzY9reZJr3feeWeKh8239E0y6DAvvv/++1Od2uSmhw7pKHYhm2nvvvfezqdXpk3FekNEnk03Zb6/s8NGlXh8//tvTvT6669PG133du3bKxRfffXl2RtvvD6VZRNf24bh52ev7Wz/zm7uAzaqp09tRP7619P893//3//X1F/YFhtHaPl/msaCOZhjyRiBf7VewLl0dvV5gVikjoKkKZdjKPIcUVuntGPWAEkLRQ798d+1ek7dhWKnMs61S9Tzodjp/KJQN2wkp4LuzD2juM2B/2QphwJpiWHil2NiV+MXvvhYz+VXm6QBnj49esRwyQ988kc81ZbgkLw5sJ0csUm9kZN4SXPEo5+l/rWVnKdc5KDe9mrrVYEOcRG7Wo/O5SVfmnpN25gDP/hZib+JffxMnfaQX48jsCVyeszlVZvlueaLc3UxkrUGiRudtQ9XG+Q773W4Zu8IS/6DOSx140h32lVPZMWekR2nxlL99GB73xaUW1t+1IbmoL4Tizn4gcu68FiQKdYbNmx4+vGcsWc0/his/EqegdcEb3FtAPAYqMHPptcu67GBHfSaFCzuvWLmZoSdbrwyOLHVgv/TT+9N5IZK2jZwbQi04XyM2QRc20abbNc37GMm5zXQvrXpGzdu7tq5X+KPl6//+p5eD+n6jn7jhqotdrMYtkBuNxDN//2NIMJjs0a/axtkbTPjSYDdNuL44+bPa5xrFlJPCjbZxc+mw3WDtp/Y5TtOc0h/AXH/4ssvpm9qvXL79rQwt3FEnvaSG6PId+41AgvP11977ewvfvLjqZz26DXFN773vbOf/ewvz/7Tf/yP09NXLVZXt5Dny3d37cim1p1XX502oF69c2faVLLh9Z/+03+c+ogNvM93C2Z2iI1yc8ATWgN8kacv2eizMW3DLGQz8Kc//YvpSbHvvvDdaYPOE3RRoZ+z3ZOgnhgjB+nLYv7prk5sgn3vjTemJ3tA/SzZGJtsjJE18rkvjwdlTMi5mIWUkaYvtLFnT8a91kfO56Vsb0dkOWpjKBsPte3lOnko/BnbRv5VxNdDfLCGp4cyfO19BLrZv1RnyoTIQIk3OK8xFeOqK7JrvJA+jqTJxxeeGsMRej8g9uQYe1PH7Iofo/LQ50XWRVDtOBbKVgKx6ONn7emGu62hWzzl4UsclUsdRNZVILGrOtjCNseaXutFmVwDW6WlvkaIrotiLg41PTZIE8e5MocQP1IPPSJffeEVB/FIXiggK/kjyCdDX4xcR0i8rwMua8dV+SHW4rss/3Ltb8OGDU8/plF4NA4YHAzmgQE4H7U2IEP7BeJqbnLpzyTgJshNf26uPbXl5sMgxyaT8xdf+C7MZxNZUHjtJgsJtmcBsWEDWGhq31kg5YPOF4H2ecrJtC0m9zd72nrti4BnbhGFVx9JmfRlN7j6UXvi0ca1PyDRPjZuUzhHN7aVWl47zy9j7Gry2reIXD+OBQWf6eMffa3vX/8N7HYDwf5203Cd4NW2tP3W9pYW5/Iar40W4+2Lu/ZpY8Z3smyykBV59dyNFH4babdu35pee0ws1KUnkGzY+OuNnryCWv4Q1ra/ic//uyNf9V9zmTbMhsw5Nr686msO+ar8SDJn0zG2zoFuG29iyRskXja7X331lbOXX3p5aks2rYC+aZNrl/fcrm7e/f27Ux/N+OAHno/vfrI7f/7srR++tfO5bQq1pwqXnzBovrR5OHNxJfIzRjmGT7rYxoYKscwNMmRuRs7lZ84OJb+nxLr5M8/T5yctBIfaDr41PHCIrwd+8UN9WTLFIzx9HYRq7BP/lK/UxzVHeTVGPckfyUPy6et1jpD02BubA7LqsW8/1bdgTtcapGwv8xiQUX1PzHoS67Rtx6xPHUPZBEPKRF7tE5F3Ub/Z2sc19vdyU0e1bUZ/vZ5DeOawlH/IPz6wDZ+4XDQefFMWzcU1OtQDnvS5xDFle/Cvxto1fcqCMojcyJZH/nXAKBZLGPEfagPBXFnxS10j8VsDP5Ilzhs2bPhm4vxMN0AdoA3AFtD7gX79+/xrYAHuqRI3HMjNPWrfBtl/g6FNChYE+0WBG1037c2+/cJtw4YRtA83j0HfVtz8rp2c9YO1vMdCm2834Ov+KiL+djPU+J23vtRu4vlsY7j9uqzPtF+Z9+ftDzLsF9vpZ20zCTlvY0B7RF//zCuOdORVtlPD+JDxYHc19XO2suW6Q/tiZ56Uuqr2clGk+bNrzrbkJd8mlzajfXnayAaqb0RpN+lPVZY+90ffitr99+1dDPq5Qxn8Wcy6ViZ5c6h2hSpczeW13DHYZwPP0Xet2FDt6G0ay1/GHL++NcXrwQ9LO21T3xJr11/tbohBlv728ss3zm7eujltItoAw6O93bt/7+yLzz+fnsBUR9LbjfL8RkTFd7/bXlcZQfmR/ZHr2BNZ/XVu3nuS11Mti64jjmkDeNPe52K51s/w9Udwfop4zvk2Sl+KQ/J6/SG2gb6HEqOMC6iivz41lnw5FrEfpR5qe6/54an9Qr/uz2vZYyGmYszHUfnUQXiCauMIa2J20bgqF3sv6jdUnw7Jib5Q4oZA+R41v54H6i46ax2mrV80Pk8S8SdIXY0oMakU351X3siK/KTNwVy5dkNsw4YNzyaeOzRQ1HwT6ldftdc23FzaeLrsQKwsGWS9+GJ7DdFTGqh9+8u3MDyu/4fpSROLeK+P+IXazbkbKnb1A+uGDUvQ7vomUxcpnqTSLpdAxmXa/lrQYcKuyIKowqKgbXDtfwVsT0G2J608vaHPTK9f7fqSftNudi1MGh2CX5uV/fRTfTBy/IUh/Ve/fWk62vRiyyniQwZZNtHI3qU82JC7nh9zn0O7GbEx0DYfrwtsvGXD1zg6agetre8XonzxV0jF3xNZnnh64403po0vpJ20Mvs+MpXdjed/+GP7s+I9D6I/C/0c58f2vVx9VUydR1+Pc3kPRTb5vS58fPOaoiekvvPt/au5c/JhKW+EOX7JNd5gw0vsuP3tXX+DfLvvxd18Kf7i8PY770z9Y3pd/5NPJ2Fvfu9704bd/oZ4Ka7Q+pxxJ0+Z9NTGj/1TCCE6cvPWdO2pxvgUOBTv6DrEt1bOEg75RkdPYpx22yPyEk+xHdUDqnEPJd6XBTsr+us5HSO+8LKtt7Xam2vQpkOn8KdHZPb2XgQXsY/e9HPET8cqS4xqH1Pn+x+izr/+iGr9H7Kp6mRLrZNAnjUEvtgLeKTN4TIxnauXpI/sXIv4wPYaqzngTxl8YuxY5xxpFbEbDz2JHV2powrypEWOeEfv04I+hrEfiVMl8cgxsal8yQ/IFrsQ3iWYu9xXbtiw4ZsLf0RqESbPDFxtkGmTpokV5hZoa2CQUt4Nsb8c5UmAdjPe/oKJjaxPdov0vBZDZ3tKa34y2rBhDUyg/mS/ybKhTaBBvfGvyEQcHJpoHyfYW3+90i/1LYsmrxralPj8cx/PPc2rfeS0Da/27TubTsLBhvZNMd/Ku/zj4s0Pf0HxpV0d/fHhWFDr62kBu42fNvCvS9tJe4G+fVdI1sbke31VfSurnm1A3rnz6tkfdvOFp7nMG72cF6ZN0Jenp7l8V8omKZ4sZiutQbOn8bMji+Upb/q3wWwh5qObGafSqm42Sfvkk0+mj9dL0/7IrmVPhb4dJyYW6Psfkp6bYm5OZI/5Mr44ejLOX5y0Cfzee+9OdvsovjJe/fQ6qU0yMVDG5tgc5LfXONsfcpnDUiyS17eBYC79WcDIt5qWc20Wqc8ltPq6XLuj8yIx78uMZFzWtjlo1+auuqHjutd3Gf2ntP2istR/2oL48hdlXDhUb/Rmc6TGCrkejXs96Ige/Nbf1YYguqRnLJnDIbsvCjovK1t59xprYhMoYywWF7FWFshRh2T0cpTBZ02UmPUxrVAej7ojMxtdTwpr4nIIYtbmsL0f5CYe4jlqtzXOiVvq6hR2bdiw4dnH8//9v/9//u7B+UMYXNxIoh4GXgt+g4wFuJvYDEJrYKAz4O+/5+Ovtn1nN7B5QsQivv0FRIPb0mSwYcNl4GZQO9+3W4u8tqgI5PUbQsrUdqkftKeLrh4+LL0ET9TEfjepeUXR5pb+dZULAzHxtGV7nXG/Aa6f76L0cHFyLPiQb37xwatYT/u44PtIyBh3HSC+udFmk43LHvVGzJj/9tvvnH308UfTh9G//+abU/2YF957//3p9bibN31z6+WprHqfbhAeLNq/2I3v77zz++mJow/e/2D6IeP+bq75ctokbTcSWRTnerJvd67/vf3229O5eeKjjz+ePmb/QSHXZNqkUt5TZv1fV5TnT4yTd/+z+5Pdobd3tv36N785+9W//2p6+ukv//Kn0wZeygbGB98g86OL72L5q4lJh9gP5rb33nv/kb+umHw+ib0nxpTXj5RBXjn01xHFC48P4/sIvU16vOlXZH57Nyd/9NHHZ5997ltcd8+e39XXm29+b/pLlMYy5WuZHpLNzza4ctO91E7Tbnp5ysmT3udJT95l+7L2tORPrYMlHvak3uYgviN/AjKmOnjQT5xXkh978mNEbKvIWIkf5uIfOUsxJANVu2NnjrEXiWdNS3mQTsZoLE9e0tmmfB/T6IyciyJ2kUPHRWWxkz0wV/94oivnylTiK4xiMwdyjJmgjlH1I7rgIv4lxvxKv0+s4gsKoo8viUn0xo4c8cZPab2sAM9cXIGeKieUuOY87RGljSI4NjaR18d7DokLMl8ENY7kOUrDl1g40ldjEH+XgAeRS17SHjfoji2HwNf4G/+B71k3R9ZamSOQnfqIzDlk02zDhg3fTAw3uQweJhI37yGDSQbwTMy74Wbi2w2/i4ONQQmfDS1PeHz3u75z0n7h8DSAp0wMRGRs2PA4oA1b5NQ2q227aQi0TzwVJut+gn5cm1xff+0poAcXA9gQsnkCFhrs8sSGTYulhcCpQVVuqPVzsWYPG9b2cWOGzZcXXnhxkmGDzw3/0448mSM+S4v/xwVtvv0Fz7YotVE5WhTis+DOAtamiyeDPCFkAwWkG88//Oijaay/cfPm9IRRxUu78d+Gkw2wb+3q1YaXv8j44YcfTJtTyJO79JgryEzbdfQtqt/85rfTU2DmDU8Qtg2t82QzVHvRn32Lqt/k+vjux2cffvDh9DqiPp0fdRq1p9Q05Duv3Tl7ZVdeX4otacvq77KbXMFvf/vbs0/v7ezekfh5CgvZdPv9O+9Mdnol8Uc/+uHZD996a1e+bcrkm13UkGmezRNorr/3xutnb7755u68bTi0p1fnxwJlXnih3US2/ru8+YOPftRD2VGedOWyprgMImekP0g9zPHIO+QnaP8jf4KqRx8iLz6G5KUfjWDjFtgTWXN2yY//cyAnsnrEl9YuxtTbXctV9LGJbWRUJB36vGNQ/aJzKQaAD6VMztlSZblO/YTC3yN6UWTk+hDIa2vnFodRmciEy8SqR+yOX85rveVY9cvPecpJS3rSgpzn2Me1nkPKVxmxiX3GIjEI4cv5WigTvcpF/hKUwR99I0RO+kDi0SNpa/RC+KIf1pY9Feheq5ONfK/2gvobte+LInrQoXrcNrk2bPhm47nRgrcOIiGLfJOywSq/ZjhaNLuxNsBXkCFNOTcr++8C/Wk36PiV2seu3WDsf1kObdhwldAutdva1py7YQy0+TpRB6M0fwThcbRbN6oD9RMsLHbWTefpv564ueonuEagr40TXpP03byvJ/s8HWLDKxtxc8Brg8srfTbp8urE4/bj1GhjqZtS3/Q43U3LRaCN2ABqG0ktTZ2NYpz21I7fmjaYbNoY01/e1VPtE/7Kn8vPbRTteOSFwL902nj5y5/+9Ow//NVfnf3VX/18Opf23K6N2+T5zW9/O+lgT5Xv3BNhniD7yU9+fPZXP//ZVL7Sz3/2s+npMk82sncEcowDNqd++tO/3MlhR+jnZ//hP/zV2fd/8P3JBptNXhNMuTHa3DWffx7hy+Lf9Xe/Y0Puztlbb7119uOdbz/68Y/OXrtz5+zr3Q3eFLM33pg2FP1RCTd9SHnzZza79J3XX3t9amfqtz0F+d0HPHu+Edo8/91JRtrCHG8w5++hcofy12KtnLX1ciokdpVAm2tj9aMwxqU9VCzZTu6h/AptgI5K1cZDNIeRDXP8S3JGIDvUxtDzc7NrcUXWmJX0AUcxRymb8tV/5+LTb6jUtBq3XKf8GkQ3m5RfKlvTq7+XQdVHP7jOeBKbgM7EGwVJT8wT0xHISqwqjeIZvpynrGNPkZ3zQ2Cf+neMjkNl+aUMvjn+5EXmXN9OjByX4lVBduKEf2nsuCqwYY2twShGV4Gq5xj7NmzY8M3CNHOtGZiygDBAZ5Mrg7sbCTfUmRTcyFpct4/HWzTbcd//Rbe80pQNrg1PDzyJon7PU/vrfZXU+2GyCD1PWZwepva9mlAWXIcWASZE/KPNn/47NXj7CXQ0oWrXj2Ny5/fchK4e9D9wFAu8/kDEk4KYGCtsaIu310FtetvsUgc9uCY9f3TC+CK2xoonvSl0Cqg/MTHmLX0T6aqhbagDcdZX06ZsvvnmWQ/Zxvj2R0D+dPbRRx9N9eKJXLKywHfUr218eSLKxhB/a5vNtXbgNcLvfe+N6cmkH//4x2c/2dFbP/jB2Y0bN88+/NDTTJ6SGt/00+Fj6l7bU76Sp528ojc9LVZ0V+x69vQq380bN6YyP/jB989+8P1Gk4yd3J/85CfT64O+Mfbpp59MNxy9vFGvH+mcGx+SroxYvvH665PuvS8/mr6/9eddHJ4zt+7iq4y4qK/EPqTv2wA0Hqjj7z4YF5I/Zweou9zUnWJenov9kg2nxjG65uw9FiM50vT/jMtB6tI4qX25RqeyJSAvskOPG2yIX47aJdLmQuLTU/LwzsUlPqWNh8KfvJpfz8Oj3ffUl6tlLgI+RRe5S4ieOb8D+ZUS2z6+KDGVV8tC9bnqTn5F5MMoHtIixzGyKyUv5LrSKcB2PjtWvUvAy7fYwbY5JD8yR7GCWheJ2yGQaVwgn9xjyj5uxP8ec/E4BZZkZ4Nww4YN31xMo6WxaW6AqjBR9Dfaufk0+LoxbZscbeNDmps5N7ie2mo3u+0x/jX6Nlw/tKf2GmXCvlqyMNhTWyjsFwuPUnuCaQn4Rm2wv25/3ey8LG2/n1fXLpwuC31vDnWTi41iYGGUG6cnif1GV3sluY0TNkj2j7U3m9sGqptt8bRBZ+yoT9g9rdDmbBTxn29PAtqHTUTxbfE/v9Fog2u8mejmst1gst83nzxd5CPzvvdmQ8rGF/L64Ld2emyC2ehS963PtHrWFkNkOTa7vjM9efXG996YvjnFFt+UwpOyPerNWnS08WE3Pu3kOR4C0WLS6yD7ldu3H3yw/Y9n971Sv/MF2Bx9SsWXIHk5hz/teEZQ9iF2vOomT007t2H1yiu3z77c9Z170x93+BLbIyAnovgjDv4Co78Muct9kD8/Dnz7223uxtO3z/hwLGocRjiUvwZLPq1FYnNZW2BkT9q3NtXryHign9Sy9XzJrth9iAdO4R9EX4h/SXceqvn1uuetfPps+nSlvi/3cRbDkDkvlPg69kRGL+eiWCOHj/xwZNta4Ic+JpUSQ1Sv+/OeAvmJR2LoeMgv5WDEl7wcR0i5OZ41ZeegLIqvqfcl1DKOdKwtA2lrc4js0BqQl7pI/4i+q8ah+ulxqE5OATrW6MkPBxs2bPjm4uEoa8w4NHAYXPP6YQbrwCJOunywqeUGKH91bRtsng24efWEBqrfsOnJaz6HqW18VtJWztP+6T9Ef6OvzlF7MrDdUGuDdQMlcCltqZ3XBUp7euW8jLb4Ob84Ie+zz+5P+pVfMwGfEtVP53xnpzhdF1ikaRfajSc43cAbL9z4sdX44ftb0sXRd5nU6eOO5VWgtckXJr8f9zhINxJj/cJTUp7g6m8atVu29fa19tQ2ltWFPumD7f4sr4+++0D7v/zrv5798780cv3Vrj9OdXj/3tmnu3qMDSgygTxEd/rNd3bt4aVdrNhL15r6V1b7WrrBiM4lxJ7YBGKm7Nd+nHmwARib2LjLPPvDH1vcajqKTnZpy5C4Nz3OOrseXCYm4u7VS33ad8bax/TbTX/V0XB8X1GenJs3X558YGsFO5diF5+PxUXLjcC+JRsP5cNae5b4Rnlimw2uCrxiLeb6SkUvZ852fEv2QPL7GOT6GCIrbRtpg2mH4MjPEH7Hng/IS7/NuIOk6yshsZEe3tAhv4M1fDVGF0WVMUdi4Minalfye1SZNa7aU9pUjS2KHGVRjTG9qMY3vDW24ZfvmLRqc0Bf1dtjVKZiKT95S7E5BLaJD1/4sIToSSzFSvyWEP/VBfmJ2VK5yE97WIPUCbl0Kb+27GWwNs5zYOPjsHOE9t3T5frbsGHDs43zd+s7HBrUDFiexPAqyPRXq27dnAZdMBBnIW7DwqC8YcOpoYlqpz1ZANjw0vY8qdI/oWFhIM3TQXOo36xpT6+c7yI2YcgZ4fPPPzu7d+/TnQ3LfwXxlOCfxVKgLyIuiMV1gzEhG6QW6jdv3piofbPv29PGho3xB1Xw1EP92ODKzcLjhKavreoLxml22DTpod/YVNRveqQPoD/u+Gxs3bt/f3rCyauFQ3rrrelbVzZZPY3V5LSbAU80oVynfzoife8Puzjphz5an/xDSP/PWFCxdokdG2r/1h7JfW4Xt3zfKzr0M3998c9/ssntrwK3/qZ8JfXulUex9+qhcnnVcA5cEAM8vsNlrv3yqy+nD/QbXyKbzJUhegTqVNvwIXx6+rhB0ubq4VD+CLXMMeVGGNl8EayRs5an8hnj6vgcaFNuokdtoJY/FJ81Ns0h8W/tqG2WIO2T3eY67QM5723hA/uRvp5zY53rbKRkcyVjoHLQx+pJIPpP1Q4TzxpbJKauM0YFa/zHI26JZ/uRL5/82Mc28U2MQ3M6qs1oDmREN9kj8LEH+Wv8m9Ot7KG8JbvTrtm9xg5IfYnpGoQ/cYdaF3NIObQW6iF2ZR265P+pcIyOtXG+LKJnqQ14GlzMNmzY8M3FuRHWuNHo/EBlweOpC69NvPbanWmhLs3k4WktHyJ2Ds/Ct3M2PN2wuHDT6UPtbuyzkGivWn5ndgGj3deFiRvI0abAEsiwAPUNn1Pj7t2PH5m0TfA2FAKLaQs7iyxPDl1H8MEH6d34izebxc2Ggnp7VqBustE6+gbcVaGN1y9Nr7r5ELwfJHKTFaiDtqH46VQPc23Fxk4W415P9BF2N71/8dOfnv3s5z87+/mOfvazvzz7y7/86UOS5ptY2uBHH3449Qe6vc7493//92f/9E//NH1vy6ZZbqod2eSvFb7z9juTvrd++NZ0XIpb9ekiINqmmlcs2YCazrPptcx//9WvpjYqli++9NJkC6IXebXS3OivQv7rv/7rFFPlI8fm4a9/89vJ9/qjEF+X50qbdu3GiRzfH7t96/bZp7v59ne/e7vYagPluDGK3cZF7aJt+n81jGP1dQ5L+Sl/lYj8JRvXgow1vq7Rhcd3SdVRD/1CzPuxvOJQ3GJH2hrSrrI5FXKNBxyTjtc1Ioc+9mhvbe74euq32jNyLh3w4sPvPLbmeCg+4Ruhz1sjM7EYQfml/FOh2pm4ogo8fZ0v+Scv9l8Vov8Q8KnztImlthsk7qERlvxfwhq78az1T13pQ+xYu8GVPiQuqEJfQXNxooe+9M81/vOFvMyn+nHfxk6NtfELRvzH1u0aRM+SbDzH2r9hw4ZnC8MRsv3C63WidqNkMezpLQOGAdZTGHkN0WLtD3/wi1GbjI/dFNiw4Rhoc2sXIdqqpyGy2IdDk179ILj2rC9cBPTcv6+PfL5qQTgHiyf9jaxDaAs19lqoXf+nKN3k37v32a6e2k12FpnPCtSHtqcdXuViS8jUu1fr8lScjSjxrBBvtvhRIuO3drJkGx+Qv0Z6f9cOP/nk02nj7OWXXnz4PSrQxkNg4wd5xe/u3bbh66YAuw2u//3P/3z2v/7X/zr7t3/797N///d/P/vFL3959r//9z/vzn816fFB+juvvjrppuOcjRSXZnLRNvOnB33r3/7t385+8YtfnP0r+tdfnP3zP//LtBH3D//4j9ONyqs7O2wk+6uO1Q7n7eP535s2NGx0/f3f/8PZL3/5b5NP//wv/zK9ymlj0Bw6fch+Nw41f8Sp86kDvvbHAP40zcM2yGx8fbDT43Xv1M0x7tOfjX9yjS/0zMWw+ruEUfm5sjX9sv19jX14DvHJP2TLGl1Ajn4/kifm2SySnzpE2ahydB0eaZnDQnjSv8l0jjfyQ+ZKaUHNy805wpM4hXokjZ6Rb6MyI1S+kZw1qDYuyTjGpovaUkGOWNa4oshea0/FqWy7COjubXbNtzW+HLJ9jYzL+n6ofPpf/FoDfRJSvyNI18/m8oFe/fkYH9mpXzuyI7ZcBebqh72JG8p4NGfLZetww4YNGy6C5//mb/773xmADLQ2tl56qf1VJk+8GLQMcgZqTyL84Q8ejW5PiFhsZwB0xOtX4bxicWpY1H/99f7x7EPkhi4Lvw1PJ7Szr776cnes9f6HaVJdM7Frl24Sd+wTv42A1nbHi45M3DZ0027aQuX8go4d2jgem2A3brx0rgw03W0B1PqEG4vWh/bkRkP6+QWxdgs2kPmPR3oP+nyrx1+5A/3PzRCfvdLkeN3BL2FTN+pI3K5i/HjcyI0oX9TzqaHuPan4wgvtI/6IztbO9+Oe+NJvc8tmYsZw6bVNz4E8pC36vtZn9z87+/7335w2d3ZWNKYd0n6Bbv3Ih9q/2vVd84qNImkv7OYW1/i/3s0pZHraySus+G0W3XntzvQXBp33UM4rkDbQbILxOX0N6ED6qNcvv3X252mDyNPHra01m71aLF/fml5x9h1BtJtn8uQKv30Pi7/KK5m4iXGO/NH/PfX22a48f3wk3rnx4c6rr0z+vLqLGf3KqZOURz7e7689eg3UX45sY0bTpQw/veapHvjmqTIbb/KrTfTZQBOjl2x6Tq+p+k6m/Na/2Bk7AmUTw4rUZeWtqPk9z1I5+pI/0rsW9COY00VP729Fyh+KQSg644NjKNeOPaqvlSfyIDZGp2uk3ec89V3PycNT+ULR5Vz+ReMd38iZi1PvR4/w6FuxNYjPvWzp8S/Ah6Iv/alHZMqbsymyoOo4FnyiI3USxM6RDdLjw8i+U9k2B3GF2N0juufqO/kjRCaeUXk45H+NacWhcgGepfzENzqWeAM2Ad5DdRJ5dMTeHokh3jX6AV9ikD65tuyx4G/ilLGk+lP9YgOePu0q2m6d+0e+50e8DRs2fHPx/N/+7f/379wouTl2w2xAM0BZKLv5tniwqHY0ULXJ5tEBJWXlG1zCn2OlfhBcgzzB08uaI4NeBucNTw9ae2ubP+q7tr3Uq/azvg2ZBP+8mxDz2tj8kyvytZf6K7yy9NZFFptcs4HcF1/0Wsr+Y6CONm2oySQc+yslvfHkuumRbnOP73PQ577znfbqCeTpHWWu4/e45mCsETN+iFu/qfi0Ib609nbaeohsCzxtT/07ZqyjM+0oG1qIHa3NHRdXerSp3RJ6uraZ4xU9fUS92VShM+3YOUr/VL49YXZzsu+FXTmbOG1Trs05L3z3hbOXpqeGb02bPAh/ELmQ461dvo0ufvM37YWOxAHZDLp548akD1/SQVl/7MBmWiVPwt24eePs9ddeO3vjjTfO/NXHPMUV4h95ezk7H3Zl81cdX9zJVc5mYPum1u0Wx13ZtskoXu0mU5sXP/7kUwAZD/DHH5tgdIm9DSz86sBYSZZXF1vcd7buyvMBj7GJy2QlBj3IZUMPvPTH7x6J5yhfORiVYyfISxwvgkP2QeIXxOak5zz2OrIvaTlvsd2XS36o5vXgYwjI6m3ONYrMpJtzan4oGMkLYr+89NOLgIzoGdUZv0NzdZr8vt+CdPL7suGvc2HiIw/kjfyKPnlzfkeW/FEfWIPYSEbvV2SHKmIf9HlwCtuWwGb62TyqM7phLk99zYHNykX+CPJqfHrMtbfEDY3KQWRDz5Oy8hH5c3KCyj+yqUd0oHo9gvToP2RHBVuUjU3HlF2LuTquuqrtaVOBtDXxPRb0wEi28aDdh56+z2zYsOHpwbd2i6c/t0HeQFQ3pdoN+FpMC+/dIt+A884770xlR4OPwc9CPgPUWvh2TF3kHIKbp5df3t2cLEzCG64fvEqlnucWENqPtuPG+Zg21J60aE9yLbVrMj0hkY9Ms8UGQf0ot8mTDLxubkfQ7rPZm2s059dFoM+5kQbt3CtR8Pnn7cO0TxOmzY5dLD1Fyvan9dtc2qdNCkdt5JgxawRyQnnazVO2NrYqWtvKGN702uQ6dlOrhzqhU/tiw07TdGzy/zD5Kt9NOH/1MbxZfAfO0/6dh5TZJe/O9zdU6SsIT/qM/PAEkdnk7J9aqXzRpR87ynM8BHxko+iJXfymM3xVbuwNpKWc8/v3P5/K+sut2aSsaHNvNvv/OOXTt6+DBvLUNb/oxBO+1FPTO3FPrwb7S5kj/42n+h3+CnxkquveL5BPn3KJR9Ds2NdRRX5IUGZNH+ntDaI/dRNUfud87vN7HhSemldRZUC9HsUV2Jb+EuhXrvuYBeJT42cuWQL+uTpSf/ooOemnFwF76EmdjXThEYPqa0XirL3FlsiRPmpr4kpvjQE9eOWBtjvyi0y+Vz092pja4nOZeTPr375e2Tmnn318oXtk/2VtIx+UH0FcxZDNozpLfbKtl8EuvkVHD/6qYzIcRzbEf7yj+KS99bGpfa3mVVvwIHJ7nlB8n4tPEH62kjWytaLKd+S/Pl/t7hE/0SF7AvaE2GQuWFt2LebqYA78ZE/ArsuMO3MwhvCV7L4+3C9as4/a9IYNG745eM4g8cUXX7ZXLO7dnwYGryYeOyCRY6DJr9LOTz3YHofxRLLheiM3bHOwQMjC7xiY7Mi12bWEpnvfbk3WFnIVJlebSybzObDToteGGcpi8hiQMbcg6uGVKba66T31YuJxgM1ZrNQF0tMGdYz4cYoFlnau7Xi6yI8D2tRog0vsvGrnW1u+M9X60eXHX/WC+NJIPbmJ458bk7aZknbKlswFlSIn546ZH7KhPOKHyOzlyo8M+vt8lLRgxAN9GoqdPYWfrCovNmu/9WYmvNDGgJRpN7bi2TYmG0VOyolzyzvP57ryOd+/Cp16Iqs9FSvObFs7pkDsnoP8OXmHyh5jB+BP/0J8Saxzw62vhIzPyHnyQ65r+YDN+1junybWn2wy5IhsuuRcHYxAVurpKnEo1qdAYnOo3g7lL9l6jB8970jvMfIui4voukr7xCP9fa5Oon+pzvAs5V8l5uITm0Z2SdOnk1f7dyBPbPTtNXUQ/oy3a6AMogOMHcrP6RuNR4eQcYpNKR+/v8kw962tpw0bNjy7+Nb7739wklnW4PrSSy9Oi0rfF7l79+7DxXcFvun1j93xGBz7JJeFrc2IY/VseDLQTtw0jH6xNmm7KfHqzTELgB7agk2udlM535Z8vFv7yWLBzWj9C6KngPbMl2PaqDJZJCnLRjGxAUKOmy2b1Px7GmHzhi98y8fKnya4edZ2DHltgeWmUM7+OP3bpTnWxXO7WX/0yZ0KvO3mu73O+yQWdNph2h77s5hfA76hQ31KG1/yT3wyJrChR/LNS9mMqHOSfDrY0c9VysmvZVyjWjdJC4EyKYdyTqb+2RbhV78ZzW86vb7sswRzwDeKAchTt3wYQfzk9WNq4gcpmxgZz+VLR+FLfq6hns8hca7n1Zea1qcHSzFYAv9HfZUcccuYXaGM9FGbhWzEgbKHnuTCT9aojqqs2AM11tX2UVrqKHWmrke2i0Nr48tjgXkrtsRm8pV3zefEjDw+6L8BPhS/Rn07WIoN9HIuCuMg1BgD2XTP6Wcfu0drktgmNofawAjKKT/nv7zkj+osfZh9ffkaN+c9lCFT3lK/qvVDF+QY+Slb83MuL/n1PKCf/NQJn9a00YB9dK2dZ8mmkx19nZKTmOe6BzuPHYfojFxl2bnG1jU4NFb16MdDdvR94hQwXsNoLHrvvfen9GNiuGHDhmcPJ9vkMsgadNz02OBy8+WJgn4imf5KVRkA1+LYTa6L6tnwZGAi/OSTT85NSurPhIlAG7sMtAVPM1hge+JlDhY1Xv2jP9CO/WW5UyELEDatbaP9ooWdXu/T7yzOPZHpCY6ndWL3yqK4W6h99NHHD1KvP7ST9jF1T/NYCIt/q4NDVaHujZl8Tjvoj4H6NwaONraeRJ1T6YcNRP8xN4hihizIl1BvgEYQI+OC49z8IN8NaBbaVZZyxpd6U5G4K5cxQFrScwyUS1mylYueWi/OW9n2634/N54aiXEbN5efxlja4JHH1rk6yPicsolVaA7yUqbXO0p3Hso16DtsW3sTVWVWLMVgDv0NXYX+QNYobofatfwq11OaSxCD6Ortl4fSLhMn8vHHBuVq2dSfculbYgSuR/0t49ihtm0OjozoVy42VVvoJ7eOFfiQdJDHr953UEfV7x6RQ/9FNpICsSGjjw3ZvU8V6lr6KJ6xTQwOtYE5LPVfsumne1Rn9PKJfX15tiU/9VChjJjX9hMoU6nKT4wclYVR/KJzFLcgtkV2dM21lR6pm5H+EdhLH/kp0wMPIhvY1EPZY9siOX0bXOPjIRzqPz34JQbxiw3a1lI9XQTsiq+9be+++97J9W3YsOHpw+V2DQoMZJlIfOjWBOjGIgN5YOC+yMDrNR03wGuJ/tHkseH6wQRlEtQu1Fnqur2a1b67kcXOZdDaqMWk79zMf0siC4S0ZzBp14n7sohPx8hLGWSCb/3ru1PsfIfrad7gAqaL+bFxeVJIPXgCLW3GRhcftDOkPpYor5DVuuV7/MdDrif0fKfM+JnXyaucJwEmNl/3v8CvxVq78dR49DiUD9EltkHKJN76tjFBfYZcq5vMJZGTBT+/9b0s4HNE+CBl6nXq+aph0xgJzVJ8IPbNQQzEo1JiRnbihOIbmWkfKHETH9fJTwwr9fEMJe6VomstzeFQjCrSZtI2etBT7euxZEcF2WvsWiMvPLGr2ljTQrmGpK3BWnvn4nYRf5fKrJEHa/nmsBSfy8q+DGLXoRjV/Fwj/Tl9O+ugtP3a33v0Mms7q2MB+2pazh2TV4+hoKaNCMjLOZtyvgRjG52hQ2XIFZdq+wiRh28OYpqxdS3oM2Y6pq6OKT8H8g75fgiXsUNZ1LfDpPfwcIX4btiwYcPJVtoGwQzsBiEwEBmo6yRoEPaL1NIAPwJZ3/2u72uso8sMqhsexVXGU/tANm1Qu8n019fyEeXTQfv0q2/fLivweJ3IhkXA//bx+ifXrsRCbDy9JU5uYD05lA9sXnYh8qSRMQSuc/9lm/bTFlpt0dray/pNRjKUV4/qtfeXLO3Uppb69VQIosdf1LsuSJ2x/5g6S5wOlblMm45N6efOxTp1t6/D/SZNtYdu1/xTH3WzZe7mTNohm6koaq4Mo3Y1hzV88a0SiK/zxEFs+nj1G1Y1Vq5TthKeSuEPPSmkvaTt9DiFjX1ZukbU41A9XiSeVeYS32VxSPaaNnoVoBdlnRLKmLHUFuAyMat1c1H/1fWc3a6B7PiRdBSdOcYeVNsS6hG7QX5fJv18JCs6IiPHi4DtVYfzpfqSnr5VbViCMuJWdSxBfsa9ObCh1sEa0E0upK6PKT/CGv/XgB2htC/2hfgbMjf3VPPRXGx8W/pUNm/YsOHpxsk2ucDAYmPAgFWRjYEMTG7e8nj5husP9ZknG9Sh68tOnBVkke3JLTf92shVIu1ubpKEtgA5v3EkBv5M/+NCFgOeFKLbK3EeR8/GCBu9oujJnmcFCfdS3TxJsEvsM8Z5ek78j1lU8Us/Sn3GzzZ+/nHayDI+enKr/SGQ6ztW2nCL78fWl3KH+voh2Ul3JCuUOgol33kWyUmPjtyg6FehpIt/KHxzNpE3lxfEnqsA/fw7ZAPgWcPH7xoXlFhA4lY3s0YxQ+xLzE+FU8hbI0Os0ob6+lM+/q3BodhXOWnXlWrZ8I7kyZvLjw0j+WgkbwlV1xLwRHdF0ivmZNa0kawgfOEJVR8RVN9rfo6hml75ljCXP/IvemqZQ/LnoE0qW+3MdWTWvJoOsQ+RVft17dsj1LLooqj2HIuUpZ+9jiM/IekovIfsxmtMcDTurfETj5jhdxyVYUvk9nbOIXLZnvJryy6BjBElVpWk95DOloydOdbzmlYp5VD0VuSa75l71tTBhg0bnn2c7JtcYBDyfRYbFj4cbbBtr9e0byncvn17+iuOmTwMYD5CPxoUNzxZtMnExORba+31HfXZJlBkMmkLnEwol51Y0g7m2sNI/kV12ni1wcAHN2Yj8Fl71k4DTyF6oqY+5XUqVP/rxO6JLUdor1v+YbIh/eqSYb824LeY3759c/pmWh69vyrUeOf8EGw42uhsbeD4jSd6tKeMk8BHxF8bZqnXpwH8aZvT7bsv2uYaJOYWv0tl8Gj74mOsCaTnKJ8c+Y5J7yGtjV/7mxcEyiW9wreDpPOt6gf1J69Ph1FebFL/xg/1PDf2XBTsN27funVzd958XQKbEjO29v6DPqmORn7yha/yj/GljWttXBWHkd61WKqHEUZtA/i5ZItybE57q1AmMZKP1xgxBzwwF3P5NUbWUUv+sSd+9XUeOY7yYldkB8qPYsO+1K0Ypa+M6psO+YfaQjb38VV7lY38xAUfuTVWScsYGntGsWRzlQfVT/rIklb56rGWzXVNA7YkxmyJDkeEf1SHqQflgpSNbY7aZuU5BspD74d08XHO5pF9eNBonJbOPkhdBPE3sqvuitTPyDfy52KXuB2aP7Q1/acidkcuwpv0ufGuhzKpnyUfl6A8X+JrD7aITWK5BuSQiZQbjWsjXSMkThXKVgpGacGc7Umvx0pBn6+98U/cxQj5drMfBjds2LABTrzJtf+Lbx9/fHcamE0uFlUGJOnQNr78NZy20eVP42+4XlBfblzVJ5g4bGy5lpdJLJOLp08c1ywMemRSbJOyBUPb2IkOExq5579x1K7pvOjCz+bdTvtOhgXWaAFn07Y9ORXQ5wkbE+spYYFjA0UMxDcLHr7uY+x7Netv5p5GiMGrr74yPXLO36v0tcXazZ+PNs//Gl2hrbVXBo8fNtWnzS19yMIx8DSeMVIdP20QBuOEb+hlsbkG6fPisNSX8IhX+n3Kzd0QtHGi3QxUwk9ObhSlBbEjZSts4EkbtUXtp+qqoIueOjbRo2+3Mm0s6W++LoP4efv2rUlH7+cI+PkhLnNgc2T18tqYPf/X2eaQGztY2lhag9RDXz9zSLtxDAGblmwRB7rCH+DPGA14xHXNJpeyI7vl1xgd2uRiE51Q2xxEjqO82BX++LumDrRr5ebqmw75h9pC5OCr9vKDjFqfSWMfch1/Ex+8yYPqE74qL3JCkUOH2ITvWJChjdS2AOSzq9pQEd14etviJ8rYdUqQbxOIrtEYB3Szb1SniR27yOkhnUzxoGOE0VgZJHbQ56fua6x7KEv+XF9UX0B2dC3Z2oMNyonN2jIjkMEWcR6BfXP1Mwcyycv4XWPAz8Q155WSDuQcAt+r/32Zvg3kiG+p/paQ/iYuZOgfu/vZB7kbNmzYsBvHTrnJZVA08Fhke2LLUwk+AmgA8tcOwU67ATeDnDIGOk95bXjysFBx02pyVEcmxg8//Gh6gglsVLpRz+SpvpF6xG8yy4bXaFJW1/iV39P5G1btw5MOykqWl3aS88pvcqNLeztmEQD+sp2mOPeXi3yHy40um4P2NNflFpz8JjMxFAMQwzZpt0VNYvFNgTi89tqdaSPxMjccI2gzNd7iq61eph7Xwqatp1ZrO9LujJPsyHj4tIHdbZPrxhRHfXEtUh/8r317rp8DfRlnRudzINNmdfpU367cCBmz+vS5J05AH4bYUFFv3JTPWEcOXu1AH79//7Odbed9vAi4TubNm+3Js8TkEDIesyuxrnF3xBP0eUCP8sfcrGT8g6WNpSVEf+SQ0dvmWO2sFOS61Um7Eav5oD7ZHFmBOMd+JB+fmC31hbRxZfq2A2kv8S1jYW9XEL3Q1wNd+pl8Mi6zsSoO5Glj6rwHHWyR39sqHUHsSbyT7kh+0hIfxyrPefyC2DOKpRhKH+UBOXjYc5k5R3n2xGaIL0ljZw+6k+9YIQbykfY0Kn8ZkJ9NLnUxks8vfszVN5JnndSDvPg9F1cxm8tPe3Ds27WYQJ9eoRz5S30x9caGtMc1SF0rt7bMEtgaW5z3EB/2yUt+5Uv8al7O0w6hlhkBX6Xwk9/nQY4BH4wTVY+y/bjDprSdi6DOzWT7YXRuHb9hw4ZvJk66yQUGrjt3Xp0W7wYfZBA0mEG/yQUGqldfffXB1YbHDfHPd5+y4LLYs0GZj5pnArXJZXJpN2YWIG0R4qknddwmrv2GjQ2a9qHs8LWJF8nPxOmI16aSJ1u0kYodu3+nc4gM/J7Eka8Mstm1tPCpUJ5c+kdlyMZjMyywYLLJtbRw6sF3sRUbcUJeK+J787/Z3p4SsiCXpo/IbzK+CRAf44f4Wrj07eBYaG8Wje1pLe1RW25xbTEeL7xPCe3HBov6T7u3weFpVn66vu6IjTE1/R88EZn+MXcDnf6qHzhCGw8eXXy73uvb3+xqC0mHufMRyHATpo/X8Sww9s2lZyHejw+xX5m+XG6a2NX6ervxD1/i4PrevctvdNGRcZnMQ/Ggfz8OtfhWSOsRntGRzmP6Kv25mRNb5aPTsZ4HOa96EVmQ2CZ/DnP5+mfqrPKwM323Ak+/8YBHTNmUtc8I+PDIj90V8uhEcGiTC8Lbt1O64oPyl7kRbGNp+wGMf0B+T7Gz2lvP+UdO+lzNC+RD6qSHfP0TyFAXo1jyOzpGctibWPf1eQzYIz508ItcIC8xG8mOn6M4VNtGY9ApkCfVyR7JZx8arXeks037zJsaFXxKHY/qBpSfy+e/tuLY26YczLUPUE6dLK3V0hbpX1v3qeclv+aQdpEjOEdsib81H+Z8HKHnJRPiX/IdR+cVsUVe9XXEC3Tpl9EJyo02udThUt3MQVnzHX+0C/ebd+/ePbouNmzY8Gzj5Jtc4CbVzbqJLwuhIAs/eXXSunPnzoOzDY8LmWSQTS6wwXT/fntVDPWTvoklm2EVmaBtUjjPwqhOkG2SzLEtDnIOjjdv3pie4lmz2NjrtLhs30qinxwbZn/4Q3tSJ/JHIIMvZGiT7KmIL+xyBPLylGLPD8pA5GZjK+nxmY38dO34uDZdrjPU56uv3p5iI75r2kFF6ivxTqydO4YeB/iir9gEqvVPv4Wddj5qP9cRbOcPatfTv9O59p3NIH0Ib09Brvkd35fOgU7n4pa0i2Dp1UM3La0Pnk9vY+P+FaSqnx98lta3U+Wqn6iXzS88yt6///nueh+nY8A+41/bND8co/SPxBVqvdQ448l1lVvPoV6Tk2POg5oX/8WVDudzOno5yXOMHOfV9mMhJhA5ZKrH1GUgH6VNVOBjD1nxaw7RNxrjolvdgvEC35Jv4e3XXGTJI095N5vVn5yP0oLojW+us5bDW/NznTTozxPXxLDmB/SQ1cc4kG89AuIsRqN4x++5tkFH7EmcLwL2iDM9ZIhFfKvpPfr224NdypPV1+0pIIaJ8yjW/EJi04PtiZvxlZwK/sTmufgrn7xR/lw7SPpSv5BPfuphhEPx75G6rPbGb8ecw+i8pkGfHpnsGkF+9TnHoL8ml82O6iJtsPL1ZSqUiy2j9tsDb7/JRX6/uS6fXdYMx4A96Wvxxz2LT+Rs2LBhQ8V4FL0k3KxnwO5hYGo3fi9MN38moFMjg2fTdf7Pz7ohkz9j3jcCfM+TW60OLMj/OD3u+8knn0ybC3NP0VgsjBYCJjH8Nn88nWLiQq5DLb3lkW9hlEkKkTHXbkbY6/TUD11tU5UM/rU2ZlOu/fo8kk1G/Bm1xeioCyzth7zK3z7S3xaj4uoVLrGlO3z0kMPeGgMk/msWWN8EpB2I8Zq+Kh9vYq1MqLaRubZ7EbAvVNtD61etDez71/4meWfOZANK2ZSPDOQ8Za4D2MKm+JexNed8wFPtR/FPHkp9JAbOQ+oH5To8ypwSS3FdyuuRdjpCzXPOjx7xS/y0EzjGVeWVVSdivEt5KHMOaWuOePv4J94o55UnlLoJAX8rHYvYXnVH/px+PD2dAuxPW+59oSN2zGFNHJbyelTeKrtS8lLHtQ9WuB6Vy/kh9HHOdV8no/qq+Y8La3SFZ20M5kBOYolOqfuytl0GS37E58vgIuXpXat7iaf2D3yV5IX0pcxto7Q671Xq05WrOuKHvpG+cmhsCU/mzErpc5XIh6or58m7SrD5lBBDYHu71zj+abANGzY8+7iSJ7l8f8tmkicV3FwuwQBsUyXf7LoMDKT7ycQgmIE1AztX+/P9AJzB3rGdPp4J4HFCbNqNqldb/NJo88nTW59Nv4YsocXpW9Pj7TZxrgK+zfbZZ/d3dh3+xWiEtAEbDLn5yxNTWQCY4FGFMjbE/NrU1zmZFiq+NRcob2K1sWaDq/0FRPrawkgZbSyLjHz7yWuJz1iTOinE7tYt367y2mr7YwdtQdbqofVNAbS4bQsdZZA6wKvt4JX26FML07/n0iDpwaPXyjy4mMrvjy1vX+85Rz1aW+y/fdIEVx18rE/69XRVYAPEF4g/GTtqen8c2TqiY1BtOR+347D0xALfgG11bKDbWNLa1aObpDWvotosf8nnxNZGvU36Jd6W1W7slDEOOz+kA+jJhmRs7uMpr9qeeAH5czpqmSD8ozJ4Y0t9uuAiqLovKweJTW5Me59q3JZiwTc8I77IpENebK66nEcO0Nm3sfDniB/IrLIgvoF48yOIffxlS83rgYfdYG038i164tcI5Og78auXA4l/73cQGXiUt44Z2Y4P5I30AJ/Emi7xuQhSX+xJvcf2uXECDsUsfso7tJ6+CMimn/yR7/LYMMpju9gpGzkVqZfIn6tnmKsf8unp9ZMpHebarHzyyQ0lPSC/6paX/MpX00eottfz6nuoYi49r5FKp7fGljxtaalNB8qqm9ShsnPxGkF5ZZVZUw6/ubZvC+7zKuSL/TFtmmwkNvzgz4cffjjda27YsGFDjyvZ5PLX0WDNJtcpYSC26Df42YDoB/8M1gbXbEYgN8u7rAeDeLvJQcq3byWtnxCuK/jO12xQ8dME8dFHH00fv16DyMgTUleBtsnV/ljBZdFsbU8NOgebTdqkhVeFfE+lJC6jhcPrr7/24KxBG2FnFragrUgjw3G/uJmyNxyAerDJ5WiDKmltA9FicR9TfRnZ1Eq8A3WC1LO6Cen3ra72aY/mtbYeOhXSpg7JxBce562dZZNW27p83+gRX1us2xhpAbp/8vW8za1N70m+cvpW6udUiF2OtY6PhfbAp76tAPkoY3+FMZM/6c8VSzevuTlTppfZg27x8w1EMezjHbR4k/38tOlO9pp4k5cbHfxisGQTfpS2gHeNH2tBtvogW+wuU69kJF5svCjIST1UmYEYi9uheMe3xKznlY+0D0hMoy/5iB1ABj7HUNLrNdTzIOOhvNFmEF38lt7nVeCJ3dpprys2Oy7VKR7zcup+ZDNd5MzFW742jWfOL8AHeOZ845P4sEUdXwTsyEYPm8mJ3UvjRGIGo/YbP+VdxXq6t7mHPDaM8tguj29i6FxakHqJ/Ll6BDJG+RlHe/2JW2QnLfpzlO+c7JoP9XwJylbqwfbYX/PpZv9F6k3/YJ8245g4BKkvepeQstr32jKXhTmT7xWjTa65djUHviijzWat4R5m2+TasGHDCCfd5DL4ZBMlf11xNCGcGgZLEwL9nsTJhHcRGETbQGrybBN2vdHjDp+y+UUXehx+XgRs9vSF+JgYQIx+//t3Z+3mK8Kv3OMAO9srO9+aJq9TT8Imef7YyNJOyG+vUO6/DcfnV17xPaj9U195jVAcbtx49MOq4tc2ztqrma4T02vaJK4t0tf8pT7HdtNyfmHaePYL6QeHhzzq8Dqi72dpJyG2O2ZM0ebSD8WCzyhI22zt1I3i4TGIrMSvlzuKGxvSDx1ja9KCxN7Yn4XnIVuOBRvpGN0krkUW+mSgamPiIo39FbnZsBjv88hMTEY+J77KHopJq5PGa9FOZ6Af2IQ1lvMhi/xDMuMXO8nv64fcjFsvvnj+L2IFn3/+5Zm/qGvsBLxk9O3gWPCDXfy9TL3GR7isHHU91xfYGZ9rnJyHcs2eWjfOc51zvpOX+qg8IF89S8O3pr7nINZI+cyvVRab43efV4GHHKjxCBIHfEt1IV+s+Y6vlwNiSFZtrxVkiI+j/LlNLvnk4BnlA11ksYVfFwUZZLFZnAPpdI9ikng5jvLJS93x8dRIDNk88l1e8vt6iO3gqM1KC/D7sYoP/O/jn/Koyo6MKl++65q3BpFbj/U89RXb+vza3nuwjR34Rm1LvvIXqbe0JXrZJ7axJdBe5KE5sI+ctMHIu0qMNrn6tyTkx7+1SDwdxfS9996/1Li4YcOGZxsn2+SyALdo8fFJg0/bWTdZtPyrQluUWgi1BYTB7rIDXps75yfQTK4GWhNPmyTb4ug6PfVlUrPhyD4hUS8e7fWKIjvFrfnQbpp68HPtQuIyaBOXxVGbuODUk1ZfZ/lWEmg3bvQc3fgnXRnniUMfC5tbNnPZ6mYRvkmTbQvHPjZ5EipxEuuWbrEjvY0TOc8TlOEP+uu1uGi5q0RrG/u/HBfkWv5F7O7LRY92aCxKe9T3xV+7Dr9j2mk9hkC7n1uYh6eCTAtbi2fj4IjnMkg/XLMgxjdHYsFGfb2/KclNgLwK6cpJ7/PEF5Sbi0uL//jDzT3wKkOem4K2udWeMpVOjliM7O+BHy+CenPTfGGzG9cpaYJzfbR9X7D5lo/is4OsvAaOyJvz/RDcrPAnbeYyiI99/YwgLkE9r7HqwUY+4nesVJHr2pZ6noD/eFInPZ/YZF7Gd5mbuVZv7QZ5bpMrtFSfaQOOkVMRGfKX6gJPxou5tkzGkj3y04bAZspIDhl4yEiseyTW8tf00zmQQRafapvu67qHMvwZ9QN5Ys6PPN18SiSG7Bv5nvixva8HeexG8siSVsEn5Xv0fIdAfvRXO8ipca18EBtH9gOb+35az+XDqG7IJR//XBvWJi5Sb/Sqd7YhelyjIHrZNtIPyok/O/DjJe8q4b6sr/O+f8afPvZzSD2mn/Lj/fff361TLt5fN2zY8GzjJJtcBh8Dsg0Vg9Cnn96bBrM1A9dFYdHdfglsetYOlKdEBt020bUJjQkG4KueROaQicONiM2r3TT4YBJsE6WJxl/g2nFONreNhjYJPgnQi8TOpFUXK1cFPrdvaLXFow0A8WhxafUYaFNuND25p423um6LM/H85JNPpzb4tCC2t7abReb+BmdPjcdRfuNx3tKD5I+P4X00HaqcJ4nRuNGnua5pOW8xOr/IrgiftjY3Jiovv+qosenPsSTJdc2PjEbn+c7nNQrqtTaurR+zMCffeEzGZW7G5yA+dGRcjd+hpEH1JcfkWSCrB3L6Oqt5FWJBfxbWFRkP6FG2hzxlU/9kL8Um/OTmhjNPFKe/knNonFQ+egF/dH/9tY2p5Sex9vrEvOnaJZ3zxxwDdJEbWpJbkRu2UVyXwIZ6BHKg6q75QWKfY3gSr74MPrZVfuS6r4PKkxtKMZ+Lh3YVnhHYQw7gs+kcHceirQn2N+tsr7Lilzj0eRV4Mg/OzdeJ5aE6zV875f+cHPrwjOyRn74J4jPiJQOP9JEekJ/6mNvcXwP1lRhW/8lm25L+xLSH9LZOaW8qnBqJId+jP+0h52yQj5IOOU9+LRfwW/6obnp5PY9ztkFiV/PJRTVuvQ7yM86Q30Oe9FEeiA/M1U3sH9WtfOUv0qb4rT3pHxkj6EobC/hL99xYowx+8zPwA28fp1OiPXywjw2MNrn4uBT7CvLwqy9z48cffzz1h8xPGzZs2NDjJJtcBvE8GWMw912Rq0IGxkx87XWy+UXZ40IGYDcGTGEnu9a8RnQK0Cf+IXaYOLK5ZRJ80jHqkXpkeybpx4l9W1J3LWat3iy0LB7a5Ns2uf509vLLL01tHQ+w14buVU+y0efg3CYd5Ca0ZffHxluxl7M/Vt6W3o41vaXV6ycL7ZgdjnNtuvmwv0Ea8cUXPDDi0a+l9wvY8MpHowVwQI921trSeDGnz0L0xLYg/uAjI/mOvd25dqx2gms65uwAvMcuzNlh8e2oXG/TRUBW/Mw4we6R7PBB/A5f5c9CP2NiBZ/J79Mzpkrv65nexLYvl7YRxP4lH/DHl/D0vs2VD8hoc8C+7e6p+bdUPsBDN9aYkGLGnozf2ezC2/hb7NkJva74w8b0C/VR/YT+eslmsqDOIX15iIwc8cSPnj921XjhSZ1KHwFPNqe0l8ShB5vJnZPTYts2lPDpV3OyDoEuxDY+ofgE0hGdfV4FntjEt5HtaX+HnojyJBc9iXEPcujDM/JbPlvYDIlPb3v8kn4o1niOGfd6xB566lixpq4T0x6JJ565TS4+VuR6TTr5CNhXedjsmLQ+trlWXlk2VtmQdPXc108vP/GpPJGpfA965Y/iFigrfmSP2pE86aM8UKcw0kE2G5bsU/4ibYpfdZMrsUp6hTz+sbHGLlDmcW5ysS/1FvT9M74sxb4Cr7pSjiyfXBnFfMOGDRuCS29yWey++GK7+feajI8L5lWZU8Pglsne+VX8qnVZxEavl5h02sRqkWbhf7EFag86oE2uU8pOZ5sAkEnE4O8xXvqvcjK7KPiQiZqt7HySYI92pT23hcKDjALfilKv4g42t+7f9+258UTb6skCbrqaju0ckg4PTx5inwdtEUhtnrxr1+2Y/Ebhx5v864E17bAugKCWqefqoF8c9fnqM30weT0PPUt9JP1prn1Gz9IiG9r4OL+5JJ+epUUbXVn01rolM/bjcR4K2Bjgn/MHyOD33IJ5BLbwQbn+F9slxAeo50HS2IQg/obW6gLxI0cM+1inrms8Qez4Jn0UE/nsTDtyjqS7RvJc0x2+Kgd/fKRnqX7mEL38oIucjK3Z3ErbOQXMaW3eaX7RmzglhtXHHviVg1oXsa+3s5dXzxNrcpZ0VpCvXLUjSB30/VoZvI59+wnkaWeONnrIGiHtba6u2Saese2YftUjstgUv/o4ycOz1O/xpH3xfxSDtIXHvclFHzkj29fGGo55grVH7GFv9T/6pc/Zx5+59kYmqrbJC+o5uA7Rl/z+GIQPqn05D3+13xHJS31nfA3kq1/5fBvVj/Kpw1F7kodnVDZxWWpryqoXskftaE3dwMg2stNOR/lpoxfZ5FLWxhS/q+106TuOPfqNpIAsZYCsuVicCtpB6i3o+2diB3OxD/CqBzLJ8NfgfXrlKn3YsGHD049LbXIZeDzBZfA02HiCq5+kTwF63Ny375K0zYUlPXVgvSosDciBxb8Jjj1uMrJ4XFO29yHXJgXk6aN2bBOJozoQGxPdVdTDqcBekyCYbE1aV4E+hofQ2FuZUR15vUJ7z8SsTm3q+p4X1PKtnkzibeOMLY7QzvebVQ3OW951wJo2uoSUH7V3Po4WrPXaggbPXNvQr/CPFpagPB7l5xbArY6WX885pEd5fU/+nAyILXOLskN6gC79hj8jOeLK79qGyAyv45KNgfIZT+bs7ZEy7BsttKtNFdJHFLsdI0c6zLWJNWAfOWT0sWY/RHeAf2m8SjtKOfxkue7blnS8+OJf+GNX1b0WyqLcCJCRm8rMPVcJc50YRTe/0jeCGofkI9Cmk1/51kL/gbV+1ljFhqDGboTYPddXyWYPnrm+CvTzdUmPmMa+y25yxV/6arwr3FTP5QV8I0uMRjFgL55DN/ZLT1UCOWIJo/zEmS3Abnwj2/FJn6uz2EzmRTe5aptKGwriCxtSh/EN0g5jn7wQyHde67+WX0LiUY85D8iXRn/yw0NP7B/FT3rGffcCeIPITHuZq5/U4Ug+eYjvfftnN1L3S2Af2X15UB7kHWsbsI2M0dgjL76PZC9BXMVTzHrb6eNT3wboUA+OVR876iYXmaM+dSpkLqj29f1THrsc59oFhC992Jp7d986W18bNmzYEFxqk8vg7ekWA42B9dCi5qLwOoQFkYkifwlqCZmUrhJsiB39sYdBmk3561SHnrDCb4JoG1ltEs+1vEB5cgz2jvl4+nUG+7O4NemNFh2XAfntaaecn6c9z/nzB5cPrxNXUE3S1KGbOedBeFLuacKo/e193rfpymexUdtun7/mZqKX0SOxrnXQ45CeLAJbvxgvgOnBt2TLKfwBci7jD9DDp8s8abAG4kIXsHfJrwqx1LfNA325xAnVvhKfHUMjxCbHpRgdQuvD41cPIx/kV4i7fLpH+vlOrrwc52Innx75SFnXS+3jENgW3+jmWzs2O+LXVYGfdNDvte7RDV+PxEy5y7Zp/QfW6AV6lUR+fjkAAP/0SURBVBnFJbGba4tinbYwQuLAv6U5Dg8d8ke66GAjOXDZTa7EWztj10jn2k0uskZ9CGL3ofUgXWIljqNYkpP66fsjyKOHT8CWuT6Ej09zdUYXOY6n2OQC9khD5FYkPedrUdtKPVYK+us5pL6AzX38qg+j+MlTXrtRp/Ef6FdGXByX6gfm2hMdZPVl6ZI/Kldh/KZ/pDv2juRD2tdS2yFjZAO74/uauuix9N260UYS4GdL5cdDFhtSJ3P+nALpl9U27YNNiYM8JH41vQce8sKnf3pVccOGDRsO4VKbXK+8cns6fvHFlwcXRheBwc2vD+RG/kgHPoM9ar8ot02Uq8Wyr7Fzf5wOO7RfsONLfY2xbWjtF3Y5ZgLwi7wJbH/dJrHogHp+3cBvkxW/1KdYMLf6i/Lk0z69xeR82vTvdL1/ba+H9AenJ8NVyDyMvl7rtbhmwZL0LNZybcHhPG0GehlZRNT0CjHWx8Iz4lO/0ucWUJHBvtg4wtKiFEb+VNBBhvzW1h7FGlvW+rMUNzjkzyE9kP5zVT8mBHyKX+xZ8qsCv5ucPhbxWVqIfFCPuTk4pIf/dBy6oVmC8mLIJnJ6nfLZ1teDMvSnXA/l0iYP+UN++hvgSzs+FIMRops8dqMvvjBfrt+gPBXY4Icvf8H3EGK3eFx2k4scWOo/AV71CWmHIFZI/c2NK8BHts+1QzLlh2euz8sH+aN6ooet8W20ebwWsYesjIkjOdZb9CzpiE3kjGIQu+fG3cCYWNtsj/QTGNWHfHpSl6m3Ubzx8GmufcRmMdIW0y5q+3BeKRhdwyiGSevzlJFW/XSN5LGPD6mbvnyPQ/kV8d1x1Pbjn/y5elJeXjZeAnaQyXZy8czVD8y1Jzqgt00efaNyFeYlPCPdZCB5o3y+Ad2juC7ZwG55c7IPIU9fkT3yXdxqvIGNdPX+vvzyy1MeIutQzC4Ddolb6g3oU/+JobzEp6b3SJvii6e4Pvro44Njy4YNGzbAhTe5DGK3bt2cJl2LAhswp4KBzwBpcOsHRoNdJqUMfO0D4fJtID2/W2S/PPFmYrjI5LIOWfA8uOw2QOoAD7nu04NMQO0bXs3uxDX+hyfnjxPV/v7cZU3b/VvSshGlzvKEiMXbdFrQylREZsOj+eO0x4taD/VcG+3ryjHnfEvbrOkVZEC/wKnQT+Y2PiJTf3WuL43AFv1pbiEHePTLpT61Rk/istQv+UTGHA87yJiLC19iy1xsAM9l/ck4tMYfspSpiAwgY5Rfj0v+9FCmJzqW2lOQ8ZfNoGyO6jDXAT7xivzEI+WhniuPf+2CVYzQZRa47KYT+NbXWRbm8iqUST3TH/8r8U36mvohK7rIRMqHIHbWmIFr5cAxbUfMPc1rPu7LPC6wxw2lH5vi0xwSAzG77Pc1yYG5fhrgS1wTQ2Bn6nVpPAB24+vbSECufLpGbSxIvdE94iGHrfFNuzoU0znEHkQGWSM56k4clnSQwXZyRjGgS/5cfIL0KfEe8SaOMBqv5CtvnAIy8MX2Wr+JIZtruvOeal247hH5NUZVZ2xmT01Hrqt8kMYP+bX99jLVzWXawBzIVxd00D/qQ0t1qrw8dkWONGAneeKvbkI90iePbQdLdlUsbXJF/qhugHyYi7t8NJqXamxGsg+B3WSIYfU98Y3/sbGCv8rFZptcbFCWrMvMo4egvtVp7AS2sKnGUD6+Pj3gl3x5ypsnPvjgwyHvhg0bNvS40CaXgcnC4ubNG2f379/fTbyne4qrDWoW/22ibE85PboZgAzwmXii3+Bq8w08YWZRcMoNuKCM3ZOdPVpSS6/nsGffp0H1rdJFwS66mn1tkZX08XH691z6Pq0eYXyesvCo/H3ek0bi2h+BnWlXPbSv+CEfn8m3Bx6Tc7+QqPrIUn5OFxnauONIB8zp6VEXCiOQs2YxdtnNp/gEczywtCiFQ3rq4mhp0wEPGfSwLch59FQ7er4skFGPpJEjbj2PazLY67z6U/VAdPV1LT28Oc919JEvniCttyOoctR1taeWcwwvJE+9OfJ1qX5Befxrn+LhA7rM4jx+wchG9YQnsQqkI0gfis/4HaG27aT14IMyocpb07VNGMmpaTn3PUa/dJvvdsWfGPzQdOuWp7nmxwkQKzEVj8tuzKVu5uIunvSIqfMKNrIVkeOajDl71rRDvtGVm7eRLDxskTeKU9pAfKMP31JM55BYI/qyWdJD35i74QwiR/lRDOgSn74P9Ygcddbz8h0lRniSlnyILhjFseeH+FZ9rPLSvwFP5avn0F/HHvLqRqLr+FLlBykzar8pa6y8ik0u0M7YkH7QI37N1WnqQH3Gz4A8+ex2zsceGetG8pdiF7ukL8XEE1HpPz3IJUP5kW3RLX9UXll+j9YZsR1SVlrgvF5DvSbbNbtSnh3SHMkO9XKUEc+Uy+uK+KSJh+urALvVaXwH9vQ62VLHySC+aPOQdiPGvse1YcOGDWuwH4EuiDYwXX6gNCj6ZpVFVhvY26DYntAy6NFlcm9PNxn0DJgZ/AzaowFbWsqdkugL0d+TGw62Id9FMYiH/Nre6KtzJA//3pc2QYpHo7YoRCYGlJghH0Vv9MJuUn9hOo6p8Zw/5vzR/L2spqdR099ob9fe1v0TdyasfgK+SrQ6bwuSUR1Bve5prk5R38Zcj/jQKC/2xMZDWMPzNOJxtQd60g5r2+zbaG2nlSpGacFc+hqkLYRGbTZtB0a6YhuKL0FtQ9HR8yceNR3NgYzetuhZKncZHCO/+oDio2MwkpP49Eh65OUaxf9QH/9AWmIMylU5KIidNc151VPjj4htuh8UeELwFDIkVmuwxBc5c5R4oxGki7v5qeepcQzm5FwES7JSt6fUN4favi6rr7bJEaqeEamvUNJSP/06InyjtYWjskFkRyaK36Had3KOrLtid/KzfuvPK1UZoYsguqs/IxzKv0os6Wb/XP4am1M/xyLlHkdc6FiitMm+ndb8yj+iOfR5iZV059riCHSOcEjf48ScHWxH6VcXaR8bNmz4ZuPST3Ldu3dv2qC5yPhDTgbhtrjZPxZsk8hxbvCew7e//Z2zV165NZ17wswvxBYnV4k6SLfTXJtIHpzuUPPO87kObz2eP5/OHqS14/n0HHN+3dFPWuzu0+p1/JJW03Ne8+ukGH6ER9sd/eoWaIspHxmgrM2+tFl5+OZ+wcO79JSKRRBUW3tkop9rw/SMfgnrwSf5c/2JnPi11Of4RBebR1irx3GpXy798gqHYkeHeq56nPfAF1sjp8qjh47Y0fOs9eeycQM68NFTbYwNQD6b5VddkV/TlKsE1U9llmweQczpz4b9EujE3+aPvT9zwM8mMWJTbIZ6Drmux5wnVuSws0Je2kS1iU90k6HMUj2pa76zsZeBlEWxKfEC1/RIA3Jq3c7FVDl8jv7KMfl9jB4X+OxparprDHpbXPOV3Yfa2ZwfSSeDnvgdyE/dJY4B3r6eEvea1oOcWmcj0Kttp65HsvDEJjw95LPb+A5pd0txmkPiwCYwL43kyE9MAmUrEk/Qdyvwxq9efvIir9aH+EjPsUeNX87DW+sM1VjiQXgcR3EGchLrudisAZ/IIK+fv9ggfdSHlUNzNsozJ16mDSyBzfxn26hdx6+5dVPil/pwDNjq2pH8kX9pT6PYAP3k9rZF31LdQp1/q20B35ZiH/TlnaPEbiQbpJNNR4Vr9pOL+nx2yVd2VC+Jm3L6btUvrdan9iMt/iQex0D53sYR2Mz2PnbaTy3PXnVT06WlvTlPP5LvfHuSa8OGDWvxxDa5fJvJhlQG6a+++nI3II8Xg8eAPB/EbwNi+z7J3MR5GYhBqH4oHT3geCR/Sn2YZvAPz5T1TKKvT9dJq3nOTYzqqk/PsS4GRtjHdX6jBo+2u7TJRQ99oQoLhTpx0zO3ybVGD2QCH4EufKMFDtCTBdacDMAjfykuh2IHazdr5nyKHselfnmKTa4skpY2Gh+XP5fVA3TwW/3M8UDsweNYbQTpVdecTeIXXWgN+KGcWBxqk+zBf4gviB+xOb4lPedQ5ZFffWSfOErTxipq7GoZacrJV4+H+oj8Wk/KGw/aXLm3LXJjR2yD6PGaCR+cz9UVkMU+9Nln5r228S39ccLT1zduvDT5264fvTHMMfHGU+OS8/4Io7xab7VutC8kv4K+UT0eGleALHzKL2HUDiriP/R2gHx6EsfYu9QG5tDLmtvI0f5iL1IOHENsTrzx1rzwHkLigdd54p30HIGuxLqmR6e5AtiSftLj0PhKTuJzmU0uMugir5+/5ElnY4/EE0b2yzMOXKYNLCHjDtmjds0+PEvrmbSt+BnEVnFPHfUQMxjlAf3k9rbRIw9GcQsy/7JBmWqf8+jv21ffVtJ+kh55tY1WRA/5fOvlAb9AXl+vyom7siP5sVs557kOxCR1lk0uNsW3xCx25gg5TxlHdizFORAP7SF1A2xkCzkBueqmpkvjM1/0IfqS53rb5NqwYcNaXHqTy6/GBr58KN1YVAexigx8Xm8zcOU1vlOCjjt3Xp1sYJcFCz3G6/Ff6XOeY6U9b79J9awi9dYfxbRONFB5TNLqvtX/+bKgfOI2N0HK1zaWFlEmveio8gMyEH3qfgT5JtWljY8sOqo/gbLJB/6MbKbHRJ2b1xGWFjcBX/DN9RN65Pf100Ps5C/FP/U0FzvIYnHO3qXYAfmxeanvr9UzFzu+iL/j0ketT+XPUpsDbbuNkxfTA4kbnsiJ7hzlJyaOOQ//MTgU4xGUia9ozhcY+dMDT4h/8bX6Vs8rtHm8fTuTjqAfB6LHsa/PLLzJG9W1MnyXH5uSHrl9P5We8Sjy5ZORvkpmIG8pruSRkZj6oYcs6Y8L2eTibxB7e99TF7mZuSgSX4gccsW0912+mIza3Jo2Tw8atYEKN5V0oZGs2Ow4157SnwAPmrNrDuRElnhA2pB0yDExzPUhkBGq1/WcXkdxqPmxhz9zfrEHn/rqEb+yyRU5qAcZgCf6K8ihS180n8/xHULaM9Q+DNLpmfMlsa9lgvgp7yJtAFL3I/2xm9zRmoVt8pfWM2InZmLN3kAaudLm6icxSxvpUdsBOZHvKM9RueQlH6TjqbIdQ7mux4rII2Nke7VtDmKv7Eh+tb+vV3LTR8jvy6dsoA4qUp+O8uJLdMXmkV0VabtzPvRgF7vT70C59K2ATOMbG+W7rj73a2t82ybXhg0b1uLSm1yfffb5w0k5m0EGOAQGroyJNsLat6rwt8QMmMrlGGrXyatp4XHeBvl23vIzmUd2jg2N9xhE7nVC9Wl07qgOTBTOa3qQOPY8FfLFc2lxYwLUBurkVUFG2kPaSg88udmbQybM2Nsj/tA1WoyAfG13aTMteujofWJjnbjlj2ym51Dc2IlvpCegC9/cAkp5PMrPyQB1FD1zsYs9c7EDC+0smkY4VEdAB3uWFoXiLH9Oz6HYyacD+Rj3HLQF/l7UHzYgfEv+XFYP0BO/wlP5HeWNFqJzMpdAF6Jjzu4e+NWdfr7kb8Dv1CMkngikR0Z45vpV76NYkNPXCxvJkDdqy/JH9Umecnzr9eOXLw9VW+iRL60f/+SRKa+WZ1NkpO0A/tRJLysID52+X8nWUbwugri1UzEE3T47wJdc9/USyGMj/8U6Pl4E8RnEJXUF8gJxy9g/souM2Ny3iwAPomfONzi0yQX8p2/ke+Kj/oGMvm/jCQWjtCBpVUbvg2t8jrE7PMmL3dpVX76HeojtFWKYOpob6+nBNze2ssETThAdo1iSA3hG9pKD1Bld4ZHmfCRzBP6k7fdtWjp5I1+kp+2NdEk3rsbHUawOoca6B9sQX0drI7aJ4Vw9APuUT9sIpLFXmr4QGZUnMYtf8iolbdTnki8P+nzQh+gd5cFcesB/NKqbxEbenJwl/al3eX29kpv+MyqvnPKAJ30hwK8c29hQdUkb+TPCUtsZgR5l0u+AztEmF77I1Q5SZjQ3S9s2uTZs2LAWbXRcCQOSTSUDWAbWXdKU3q7bZGMc9mtuG5DltXyvJxpoX375xenP2SIbZejGjRxb+ssvvzSRQbvRi7sFiI+gt+P+I+j7D6Bnog6avU33ns5PnmvoouB/TwbtHLMARplwQkkz+OcmpZJ0MnLek7LREXlIWtJzDo69rSEYpVeCy8QKIueiOJUdh7DWzsv6sxb0HGqra2yJnCUckrNGzyFbYY0cOCTnENb6M6dnrZ2X1RNkMd3351DkOFa6CJQ7Nr7VhlrWufGX/RmnswhG4VU+vo18jOz4VanHmvSRf9JG6aDcKC8y5fEnc1Lmpfg4KisNz8hPyHnyxATIFtNeJn582snuapojzaF4q9xjoJyibQPLpvq8HPMyG/Ev6buoLUvgY9pWjXdiYm5svlxcd8qO6rICX3gc2/qjUfpB2n9sDrW1Tfu+XUBGz4fwRG7vb20zjkFiMVo/1PEF9dfK1vg5X6I51LylWC7lQeTgm+OtPCNUW8PjOv6ugXJVzrFYU27O/sviInazBdW2N7Iv6Uhb1WZr2+/bOKTNIu0vdZD6SH7OIefxpVJ4YJS/BiPfIDLm8mEpb6lslX1IfngrpKubivDWmCzhWH7o7YAl+6G2haV+1/uzYcOGDXN4zkKq/hW9bCTZVLIwzmZTNpxsUMmzcAYTVjaacjSBWQjXSQxJa/raJtX+r/Yt/eW+/ebVSG6bYPeT6KGB9BAyUWRQH1EmX2QCrpTBOYtF1C8gIyP5PfXy63nlYWPyQtXO6ktP8fVx4rJ18zgxZ2sfs0M+XTb/EB53Ha7FVdf1Ib9r/ilsuep6PATys7jr+ztf4++SHRkv14LMJXnyYhdqY3x7WqFeR29kxVZH9tfzHOf8OwYp0/sQebF/LXr7K6T19vaUvB7SyI7fPU+u8VQ5KLFHFeFDYN7MXLuTtMufkhdR9apHnxlodXqoHUX+CiUPcEw9jBBb2ZU2GCQWmTePBVmoxtq1WKSNV8q6Jbx1HVPPa7/IdU0L9Ug7QfGprgtyHqobV0GVMSL54tYT1PORfdcRx9rL/0proN5qbI7BWvtOEW8y0jZHba7Pqzx9O63l4JDv8vu2lRinbM4d+/YY3nrtGP1LWMNzVTiF7pEMvlf/nfdQR0GVMeIdQZnoOQbH8KdNgfo2Xo3AllEcNmzYsGGE5+qmVntK6qWHx/NPUuVpqhenhbLJDhwf3Ziqi75Mkm1CrBtS/3/2/rPbkiNJz0Q3NJAKKaBlqS7BlsMWXGvm/rNmc/GvzZBzv/GSzW62qiqggIIGMoHUkFU3Hvfz5Lbj6WqLczJR3C9gGRFu5qZcRISfiNj7QpxMy4nVyRmKJ8iSmFiV8cQaiUk3ynoBKcWFLGTicSmLnVK/uiH9Lf0vcVqT/YydnkzN912wa9wjfzbxd+TLTF520SH2lZNd9czitOycFnrxwJPvfqR4o+BxjeAxV/SATAvo2BQtn7zJ8eLU+Z79so7HgH7GHBfnQ1DOe/sC+vChhHZ6PH0GxgDVfKQszufGVs7tNaivx4++AGTNnXk21xH6hTzn5fzHJJ7+qcmufYHneZt2pW5e5Mr12Fe2BOc86i5acsEESl82BfUh8xBhrsiDcpHK/Llv366R/PV1Tu778bimK9qFyKGEn5HwmW2UocxritY1hn1QijrRsU8Qwy7Qn5Ye4+5hpGMbzNgtof2WP9vojKAuOltkX4tkv4t9z+PYV5EtdbmNvPI4wvhqMdL33Lb6p/VqOlp6RelLiV7dGdTijUD/yIcWenVHcYPoW22My4/lM3pLzMhHX9xGUGYfin3JPkh/YA7r2ULugAMOOGAGj8a/KmbixMjks92EPQMnWKlWFkm+J0MoniS9sOMVCi742LfuV1/lx/Hd5/F83guH+JaSxDH1kI2vBErx4jHa1x/tzWAkN6tnBPXUTjb7xL797WEUy0ys2DnpnICHKf+n2Ub7wD5z19NR2mEbqVZW0qxMvLCDnHNrZczJ6z8a5FeS0MOcsy2INfoTYbmkP0B/IJ+25Q8dbOP5g3rYYD4E+Mo8Gm++nSt3ATqwNUKvD8GDiLHky7OcLTEiS/kmbUBd69VAuflCtvRFtHjk1fNbbIdSFhvK8ccq2k9ZkfdzXXT5dDV/qFLOMLhGqIWEftrcfI1gXkp/I+CNiFjKeABx017YwR8JWXyUyrHG1r5uubLw0aFt48QG9uzv7HvsdYfXFl5/eC0SefGaA4o5Yl/aBlHXDFpy6JnV0cKmvrSwbS5q2DYu6tAPqE+bW1aD5Wwj1coiyY99uNWP7bv2X7bK25djP3YLjIFxY1+0P1pm3+RY6iG2tXYi4CvTQo9f0xkR7Z8UerpHsbUQ/Z7xvdUOtLW62I780V60W5ZFsk9GoryE/dM+yRbfkLUf9XzT3gEHHHDADE5sSdyJFPJiz0lMiidJTpxe5HkR6IUgcu7HRSmJX09kgYsP2/shfC80vvuOm4D8F2990a9NYZ0/tEl2FM9MrmZkds3bNm22DXrtvE8f0DWTk5HNTXw66b7by91JoGdnJi9RJupiPxIXbd4k1G4mkHHhR1LGi7jywi/Oi8xxzoFu4xxn+UkC3/AV34mFp3aNVwLkDL/xWT+dlzmmfBNs0n8B8vgac9lCTzcxtHTAE8jQdiCeW2ZBfeq1oD5tlJDfi9dzKKD9WjcZyNFGLFLlzw+cSW28aF/aO38vk6e7WdiqAV++/PLr5Tz75WKj7Y957/ksZtvfdsBfiT7pWMtxrGE/ge8T6FIcn+iI+WJL3XJcum9/51db2UYZiH2I+pHInTQbM4iyM/nsYVaXcrvam8WMLzNAT0/XKJ5NbJVwnIJZPfhD34tEf6RfOg/bX+3f8Cyr9WMI4IN9jz7qPn207MMcO29Tr9ZHPR7lsMSm/f0ksA/7PR276h/12xG0T/uWvtjHBPyev/phPci51r4W+2Z+82f9lo8UbYqoU9A/nDfjGKpB2QMOOOCAGaSZxkmvRp4YIS/mvKCD7wkz3uhITlwQfI5jGfog7TCBSdGHEZgwmTyRtW7E73+fy2qTbsSMrRl4kmhh1s5Iz4ydnsy+4gXYGfkzwsOS/039qNlDB7RrTmYxyv9sTLO52zWuGTsz8SADeeEEeQNsffa9MJO4CGMbL9zYt65zijqwBzG/xLnQ+QxenOPKeS7ObZI6I+2Kno7IM2fETB68QCUP8JDFb2IlBud3Y6zN14J9KOavh01llY+wvu0f25SyEuoBNbvwrBd1IBv7xz7Qikm0eGVsyNEutA/yrdgBbcYfgJZa6bME58+fS3HVwK8h8xT03bv5nE6dmj/Y549N8Nj31UbAFsIfKeaRbRybjk/aEDlIHejOttaLg5RHRBly4pgtx2a8bmEfUt6xy37s55Ioj78PKPNVohdP5I30gF5+ZvPWs9PTL+TvEncP9MHoB3bos/Rf+zXjEaJvs8DsnCsfWfQgY38H6rW/x3NP7L+RnKftw1DU434NM21ag/rK+tqC4PX0j2y3+K1YSkRfpH2h5/sudqw7ir1nn34FAeRi36QP0hf9LE1csLLfOgdDzrfmD6JP2S/tm/bXCGTss3G+NYYebt++vfrii+tHRwcccMABYzzqRBMpnhzjpGUZ5MTkBBcvBCEnLWVaJGo8SF4PPMGVT/h5hR95JuE86eeJnzIuunfByI9N0TspzWBf/oz8GNmZ8WM21p6cdnbNG9hWx777AJiJuQdk9pHffaK0w3EkwMWSF07eAEDxYj/eJLAveeHlxZsXXuqOeWOf+cm5y3nNeUye+5Lzmrri/OYcN0voESVvn2jpIy/m25xyEcs+5cbsXB/ne2ONMbOv3hLKxPboAV0zsspA9gH7hv1BHcSi7zXoI7DviFguUYY+SJ72y/4o0GndEUY5qPHQi11Iu5RBxI9OyvEP3yKUQybLfpdk1MViFX3gyy/zEx5lHqMr6FlKkh2eAiMn/GEJf9FX5sdY9EEyv/S7cnwaj1tjQ28JdMU+rC7Koy6IMrcjinUi0FeWAcrKNtsG6t6HLhF12R7kM9KMvRmZWm5KtPTMxD6jfxPMxFTC8eUYQgdU9nlhP4x9ni39i37rdXjsw8gDZKxvn5TIRYtEeTwL6rRyQ3mLP2uvpRuooycj8lsdx+m77/L8hRvHaewX6MnpWw/6PuN/RJSnH9m/nFclyj2nI1fCuvoA2TcBx/hov4Jiv5Tsk7FfUq68ZN8s8+Ix27g/AuOBP7Kg+4ADDjhgFo86GdUIuO+k1KIaWuX7Rj4R5ItQgN1cBi8fc6J79NH6X6rFvvzVdg89Gf2Y0TODfenZFSM/YrvVMNs+Iznt9Gy1eNQt9fdkezbAiH/awJ9IXARFooyLo3ixFS+4PIZfHkvo0JYgV8415ZzEcWuesl6NH9sp6i9llIvHJQG33wfYTrYNF8Ax/8RCzuINlBesMTds1RcBrywT8OR7Ed1D1IW8fuq7RBl85AHbXt+QlI+gzPKaj/DwCR9AacfjWAbQFf1Wd81GBPXNVy+vEfoBqEd+BLKlb9GfCGTVxZY+8M03PK1H3XWeWsh5or0y+SM06o26o0/wlUGH5SUpJwFixQb1Yr7gcwNW2pEXCbRyXUOsFxFt7Av4ZV+IfYLtJj6XiHE7xtg6tqIt0LJlLjbxpSarnh5GdmJ95FqyM75qa0ZWIEve6I/kk2PjigsB3vy7H8vlSfbd2IfZCvVD+0DU1Yu9xTPmGr/0cRv9oKUflDZKrGNLm3sYVLsPm/pOmeXuO97oK5Ll9CHO1S5Yed52bMK3n6nHMcsW0H9q+bAv2fdi37Q88mKftG6tb0LaYxuphLmIQK5WHsEi17ffnuznGg444IA/PPSvvPeE0QQ24s9CNeXcmo/rHxneBrvqqE3+DztOqw3BLrpGuT2J3OPvPuPfFNpvkf3efS+OSopyLYr2tkGZf44hL5TiRZP7XmhFUqZF6p7BtrE8TLBNINoyXgTbtixarP8Su17ckmr5oqyXnxov5r/k6yOETyUpX9aroewbsU+UqOlTrmVLH4G6gTaifcuUAdRXt7pie0R+rFcDtkpQx7iB+tUJ4MW6+hFlBHJ8v5LXE1ncAhWxCnLbxbiA/ukjZI4ibQJ0Y8cbwxLai9jGzr4wY5c4IHNY6x/7wMiXB5mnETbJQ092Ro8ybCPRJrGN7If2RYj82c+B/VFyLJZjIQI9JaJMjb9PjOzX0PJpVG+fGOWlxp+pE2U8huwP9gnKYp+APFbGspLUx37cQsA8snUuleJ8Zx+r5Z0yKPZHKepVTpoFMUTU6tdkRuDVRq5XPCcdcMABB8yiusjlxFNOSA8K8/5kfpw4rcPkze5IB/yWzMyEDGbldsXIzowfvXjFPuzMYqZ99oEZO7vaIi+lHo9b5IVNJFArl6xX1vcCyn1lLI9knWgL2Qjigbyw8i9/8a9/8S+A7kei3IupuK9uEfdbwL/SRxH1tWTArJ0RZvTsE8ZuW9GG/IWX/XiBjQy+0Ra3bt1OxI9zcOHIgsZMjrQVQZv16qDXevoIeWyfi32Pfeuin/5S61fQLNAFob8G7MBrxQIPe+apBX1GttbX0U98Md5Iwvy0UPNTu8YiKYtv8Mmh+uM2ggUuZDcBT28ZG/q0xXaUN1H6UQMy2PCmMYLYyTn2WrpiuXI1WXizfvdQxq89yDaKbRFvgPWL+pu2Rw/RH/TaV+2vkWZyoJ89jPSYk5OAuqMNtjH/kQT7tgXt4hM0PkVjmVtijLmkPwJtzmCUp8jfRO8M0K3+lm74LR7l8kuZUndLR5SrQf0lrFfjaa+k2Oblse0OxWPkyr4gUY6M+5LHUY929EUQg2OPPsQc6muB9iuO46usEOXmTTn7XwQ2W7B+DeY2+hoBv1W/p1eovwZi5ztcxHnAAQccsCnas94ERhPYzAS3L+RJOO/fbzffgIxwmv6C1sQOerxNsC89MxjZ6uUX3mnlfxc7u9SN+WHfY7ZeAEleJHnsI+y1CysIeOEk6PPxooktZfECSfJCCr4XStaV4EG7ttNsW8dYvu/YNWcl7DP0g/iBWGAbcjEM0XZ8z4LvJPWwab6RH9XRx9hfqYOP+OWFPPmJfRTqYcSPaOXeftiLQz83sQfQh25jIbZ404JO5cyLxzVftN/yE1voxI43VDVZ+OjCJnT/jc/m4zt/YL5/g7UPEFPNZ/zV9qzvm8a4L9g2xFGOCXjOx8Riv3tQvoJWf9sEM/5vawfdUT96Sl3mVh75tg1sB8+tlAPPt5bbTuoBtI1tFMd1L95RLmbqlvE9aOhPy3fLR7Hvgppu/WLLL8HSdnyyJLc7W85N7OfzE23tudR9j+0DkexH6BX4QX+wbzCOvbZyn77CeTn+SIB8ZayDjjgPtHIYy1syse+WaNUBPV7ESfTLzz//Ytr+AQcccECJnRa59oXR5Mgk15NxElQm3sxZ5ocnexP9LGb8PQ3M5GUfvminZWvkxz7R80PsI2agLShfIK3/AhfBBQ8XQV4U+es0XBzJKy+Uoh789cLICx1vdrzh8aLIhQvIC2so1q1dGM3mZCQ3o8ecjdCT2cTnXTBrY8bXmZi3BbrpN/QjfwGJffoR7UxfiD8Hb5+gHjI8oRNj5eL8mWfW/RSirBaD8W0C5dmW/ZU+at8Um+qnPpjJObrJQQ1Rj7rYOkbxt+Vbz7bjW/0l0OlNEHlh3/JWHdCzCaiPz+hjvoHKOui3LfCTOYstH5nnlZCRjRL84Et8KnATUMd6PbvOo2U7Egt9izz2gO5N49pUvgRxMaYcX8SATvMfxwTt1cpfLN8mjoiY65GeHh890Ca+1GTVA0o+x5bR7uTSfgCZ19jHkaPszJkzieKvGFLX9qAO+8hbN/riuKSNmFOZW+/cuXNsjoVvv+uN2U3Qy2krT7OI8dUwo7/F69XR7oz+6B9yEG0kxT5g+0OUsaW9z549szp37mzaQvx6LOW57blOO17PH6TCtnMy8xnzGnMixD7tDd2+fece8WQ0W/oDde0XEOMaQp/jm34CxThBeVzCXLRA/cjnuKazp2NkYx+o6dfPGu+FF55P7X7AAQccsA26s8dowutNThGzenqYkQHIRVltc5LhZNW7mBQ9f0exzAD7M3r2YQsdIz29fJT53BYzOmbzUoNxSuWFkRdHXujmC571xY5/sZOohx5lPQZlLBx7UQxxoePFDhc0Xux4weNFT7zgKamEtneBuWmhZfskMGNnJuaRHvijmGcwY2ffwG/6Hhf09E+29EP7FDdbEP2sN6+hhzoRyPN0F/0UXb36lpd5pLxXp1Wvhk1kAfLIjuT1oyVXs+ucEcdnBLK2C9uabnRouwbqIOMNG1vtlW0FLGvFUQK7zj/OXzU4byHDzaAL9PS33OdYEFjPixI3ipF4IgId25C+tWIzRyWIkf5rjt3O5gi5mmyrzbYBusixc//M9UeJffuzL6BrlGtz7JiSbFP25dOv7H9xcYpy5Ng6ViDKav2aPu951vMufdwy500Xq+L5Gr46JOLs5a3Gsyzmp1ZWgzmrYeTLDEb2e2jV1ecav/QXmdgHnFNs29j+sQ/Ap72Vs/2jTdqLMWbb8y0nF6v4Qw9tzHmPV/Yh9nNfiItZxxenMq3/MBNpFiNZ+bX8jVDTra+zGMm22lbU6lNWltf0INPT/dxzV5Z+8NTR0QEHHHDAPE50iXw0cW6C0SS7SNzjH/9AIWWWbzbxb4vRpA1/H37M2NkX+rnPmJEByElcpJTkBVAkLmwg6sD3WD5lkHrdB+ab9vciiOP1BUy+KIrHtTruUx6hbI1EjQeVvG2xS90S5q2G76Od08I+4rHv0re9sOeY+vRBb9rsj5RLPZSuxXqxbk2PZWV8rXIQ9TKmRyCWTYDuVr7LeYQtVAId5hB59FmPfeYEYxCUo5MtbaCtCHjUK+sCdJc3dfpmHepLEbWyFtQV44swXgCfWABPNZgD6IknMvl6T/7+Fgt4+TybiXnx/lhngX1Qxsc++SFPkae/3LCyb33AftQR0So/aehjpBpmymMetkFpY6QLvn3cfkGbxP5D+0j2bRdJYz+3LSV0qRegz/zkPrU+7wIXLkqK49S6lEVCDxR1ayuStoTlNeAvVKsjlBHlcQnq9vhgxG+hFUfEyH4tNvtCrR7yEG2vTJ5X7u8Dsb5tZLvF9rPdGf+2v23sfpY53v7U5Y0O9tWf6XgfqBOx4Nlcbkr0ePuEOcQesZWwDVro8Vowtm3qzoA+cu7cubTgecABBxywCbp3HzOT1r5kdkU2ke0w53pOoTzbn5uId41n9mQ2Y2cfJ8aRnZEN67OVvCiR4oUK+17QRoJH3ShrmRSBXzXq8aARH/Lkz9aLp5LWF0CZYv0Spe+boKavBDK72Ng3TsuXkZ1R7uSP9OxqZ1fEccOFP1uO8cs+Gi/W7ZMzwPVdFiBAK4/6UMtfrDPKb8SsLPqRjbmLeVOPfvTaMPKcl8x7BDqdv4Ty0W9kavaQ00d1IGd7mk91QshC1LOsjHUbUA9dAtv4kv2OdD+om+vHuft4HJtSCXQad9afgX+Oh7J99gXbLto9LezTJrpKim1u3zLPkIsPLkCUPLaWqYtj+6aELWGbxbnL9rMMGculuIABny3ylnkMRahLvZK86Ns+oO4Iy7axtW//hHmI+tmPZJltL9kH4NkHbGtArq0vtIcsW2Rsb6hsT9vSstj+7qNHfpRHHyhtQPqhzC4oYyzR44/qgpaMMYxg/RnZk8YmPoxyw2L52bNn0xN+gjo8fXz+/LljdMABBxwg1lc8W2BfE+lIz6wd58n8TS7rOOmnf9N+C/uMZ5cTGpjJiXbU436kWB4vQiONeJFiWU3GspIi3/0SxuzFSbyI8WIHGXgeRxnJ3MQLnEi7YhMdtThrmJU7aRDbafiinZO2NdNW+/BjJh55yjEWypsI9uHFPm4/p2wTZHv5pkDbLUSfSpjDlo5aOXVmci9qNqJPJUVeKSfQ6ZxA7pCpATnrqs+5I0Ke4Lj0Wx2URx5k+wJ8Kts32rOO+iDhsX2lB/2oyZXlys6QH3Lmqa784fn1UzjbENAXto6LGDdy5o1tC61YtSNqZRE1PScJfKnZLMs4tg/UyNzVCL5Q1rmnJGVjXWyX/phHqOzXNcpP2ayfwnKsUTcS5fIilaiV1aBcLcdiRiaCnMzaFy3ds/7BjzIel4RvJZW8eNzaL2WjjKCdKCuBv5TDp61t27IPSLEv2P6WGTvbiMibwaxcxNrGUUEFpV8ltrE7C21jwxy1/FFm35jRqe0ajcBr8XxrjQUvwKI7C1/nz58/RgcccMAB4v6zUsBo0p7BzOQFRnIzfGX0my1FsbynZx/xbgr9rtGIHylehLBfkhep7ntxa5l/pZVqF7YQIE8QFx9etHDsxQuPkZcUL3C8oPE4kui1xaidRnxgLJuipntbXZtgZEO/9uFLTwd2ZnzZRxvAn7E1o2dX7GpHHlvHIGOOCzbHIeMpjp940b898mt1M9Avx3wEx2WZfpXlAj6EvhbUq5zHEmX6RZ58wkQe+SFP5o2tcwk8gX7q1KBcbAd0ltCm+UQOe5D68U3b0abzKmXWiX66LzlHKmuf8NtB0C7AD9DKyWkBP6Iv5lASyJgP26uFVkzaGWFWbhMYW4sE+/Z5KfI5Ji/2J+eQGsGLhHzMabRNzPZ79umDsd/Z9yC/ZeUYYasMdTiGYn9GtxTzyz4UfdkGUecIM3ZmZaCyPxoTmI1JXXG/RqIst6/EsRPLbHv34zEyJZyD4vzDNpbHNiYH0T9BHpAr26fXXjU9I6BvVC/LHB1siZ6NkQ/wWnzr9uqDXn1Au6qnJVvjWb8F+KVMaScex/KIyIv9cxbMY5cuXUx12HJcotevDzjggP+9sNMs4KRXm8xmUZs8S4z4a6z9iHV0b1bNKJ59+BsneyhO+E7QbL1A9cI1fuvCC5XyokWdAn+4CPGCJF64cAECeZEqKSM/6mArUS6dBk7bTszjSWBf8exbz/cl7hEeFjvkk7HpGGbLGHc8xg8fM672CWzMwDHNfIOvJco+MZPbGRny4PyFbfLDlnKAT85R5Il8OZfN5AoflKvFIE976C39ph5l8JwToxx8YlAm1jcuoO+l/m0QbW+KfdjfF6Iv5LDsf/AdGyO/t4lrm/zNAn/Q7/lcMk7Icztlzg/xo9uQQJf1IfssdiT7qOdwyLHD1hzFMSUPWcaDOthKlFsXxP2TzOEM9AU/er5En2sY8SO0tUkdUMqrJ1Js49hP4NHmHrNFlnLgfmxD2x/i2Ha3b9jOsX1bMfVixS/9QE59I50RI5kZHS1Y98jFvQF90S9zsAl2iSuCNrDPODeUsA9FYJ/yTX1XF/1O29pnS3kJ62irnFdGQOeLL75Q1Q3gQYeP1R9wwAH1WfAIo4lndmIaTZz7muAXTUfbrBPKtvuP74oWHx0lObFD8ULEyZ2tF6hexEY+9Z3oIaCPTPpepHgh4kVK7YLUCxkvYMqLUnW6H1EenyRO05Y53Rb78nWk57Tzvw97sc8+SJxW7rSzSczIMjcw3r1ZpQxdjFHGME9EMG4dq/uG/vKrUiMoix/4BPDdOarVd+BZt4TyznXOi3E+pByYA3MT89KyTVnPfgSy2ioRdWMPuyWsW2sn40NPrItfxgyP2IxnW6DTfiVG+mZz9CBBDJ5Po6+U0x9m8ia/F2upu6dzpEey/fUfst0pt8+zleAjB189+GL/81zOOOBcr68QZf46oE9VeX3gdQF10SOZP8kYHhboUwsjfsSucWFrX7mhfeO8Z7s7B1pmH9IuPth2tKf9wLakfcu2ptx2dltiFFutTkSNjz5iitAGfkVQ3rKP7m3sl+jrZ68dfw+obekG6B/xt0X2fdwvaXdy7vxR5h+UOjiOVM5h9lGI/dr8hW/Rtn2W/RLIIgfZT6EDDjjggH2ju8h1mmCibGFmAowTZdZ1fNJ+8kkuLtdPC0QqLzic3CUn/XgR4habTu5O8E7eTvZsLVfGepFiWYzH/ZKQ6/GhWRhPDejp8cGsvZGeGTtgJDfCLvXLWHu6ZnICdtWBDDp2zYt69oFRTKdpZ1dbozaAz/yQ55rj8wlwLvDGJI7xke5tQLx5vuLCd7zIJfAF35yrnPvQB6/MY89/eeZfvc6HEGUlxbpSDZaXPtWAbJy/I7AJX/s1e8ZQ8tAJAWKLPnkuAei13bcB+mgH9LEfzyP6Fn0pAb+EdR8ksG9MsX3wjRhnF7i2gTrNG+R53v14HeCYZh+fHRvKC/TiM/5LcfxL5eIUhEwk6lE/xq9+87IpjTArJ/bRh9DR04M/I370uSYrf+TvjBy80mZE5MU+EPcjWW6b2r61No62W1SD5a24Yr1Rjko4zwn8Jp6WLy1gd1PbYqYeItvqH4FYd9E9E3vJrx07b9EmcV4SUQZyDpMHiMU2bPXVSPbTWn9tYVbugAMOOGBb1K+IA8pJ9KSAHcmLRslJmC3E5F1SllkvZgl1Moeuf+78+AVEeVwrK7e1/ZpsjeAJ60eyHOD7SQNbJ23ntOM5TdjHThKnkbfTwj7bZx+60DGjp9YGlDE3MQfFLWCscwHohSFbx/8+c2D/c250vjziHm03gz7ir+C41Q9b5RHqk7QByd8ELXnbBPKcAfV8jHG2EH0F2gHGAyj3vAQop+17/kbS9+h/bFe3JVl/BtHX04YxEpM3WRH4Rj4dLyMYdyT0m7uYL9vFsrJeidhP2Y80U+423gx67H5J1o8UUYvPuCKNUIsXYK+VDxH9KuWsC5n3nr/WL/WIlp0eRrr2AWzM6EOm1r6t9rbOgwSxtXIYeWxtX4HvxEUf3wYtu2LEb2O3nLaahPLZ9qrJtfIZx0s8dtxYDpX1PW75ZRvZ/9hSx322pUwsi8eQOiPK4wMOOOCA00ZzkStOXoJJMFKtzEkXYhK23AlainJl3dZxzZ60cI74TvBr3/m1RS8yS+JCOhIxM4mXcrXJPtKDQo61jX35N2NnHxjZ2RdG/spv+bOveMWudjbxZ5TjXdtglDuAzMgOMjNx7RrPyEbkowtiXooXm85pyDpnMJ/4NAZzx0lAX+I86X5GO8+j1BqL8x5AdwTlUM2GvFko2/I3Qhljh2wDeFDcV74FY6jJtcqwB6hr+1JunwCRZz+R9Js67pfH7ENAXZDlkd8C9aDTRvSPWIjZ3Dh2IHgCPx07xGkerB/J8mijti/FNoJfgzl2qy+RHN8SctaJJNyv8WZhHWOpxUdZJMtLlPajDqi0VVIJyrBXtktJykVdknpqBGo5izK9nEY9sU4sL2F5KRvLQS9XlkdE+W1Q2mthV/20Uwl4UKm7lEXG8bANer7X7Is5e/28jVAzkfVlnezHPs4+xLjg2DESx0mUremQ5EnKgBi785JzVQnbRzkothdbSbivvRIj/gyM64ADDjhgX1jmyeMXIpGYcMrjskyKE3c5kVOnLIu8I0fSFjjBxonYYybu8pH+fCPJN1zy91y++urr+yZtjiHtbQt19oDMrnZET8+MLyPsQ0fEvuJuYeSv/JPMf+nDabTRTDwjmVFu4O/DX7AvPT2MbMzEE3PB/oiYt3zMH/Im3fllPR/lC8yTzgO2nTuxp/3sD08QbffX9Ah0GQs5iDC+shzAoy6I83sL6lLWnBtjJHnyy/MLwLYLE+SkB/1UZwT68E3/gH6YG6Av9Av2jZ9t9E8f3UaK9dALtc959YWXGqLvu8D8RCpjiHHGxSzyEl/jRbZEjAeU+qRYzj5+RJg/9c3mz/baF9RV+rcpSp/0N/qu/5J5KW2jC4ptV+ZSijz5yqiL8tjOtnVs4+h/zDtkztFZs6W9SJZH2YiavHIclzaibC037vdk1QlRFv2IsE4LPT68HuS36tf8EdSN9Wty0T58446wL9YQbWyD6F8JeLG8tMP5sATixhrp0UfX7b+mrPuxx8ryTLne/f0r9gmPrSPBE/jNmCCH5VihrJzDynFPmTyO94noZw0lf7atZ+VOG6N4he3Kt1dta8B2VscBBxywfzwaL0riRSj7DFz5UJysAROT5KQcJ2G+MeEkXPvuhLw4Scd9SP0zQCz6FrGJnocFp+nvaUzEM/GcVsy72tm0fiu/6unlf6ZtZv0Zye2alweBXfsu9WsXns538pgD4w068xPzmN/Wcb46TTjfso22iQl/8O00sGsbtGA7kHPPT56LtGk7eG6JF/4R5XEEuYPQWcbisfnlGB/iTYT18E/Axx99i2Q5MhBAP/okfToplHGOYIxSHCOxfSB/cMXrCsdMC8Ya243jmEP24ceyWG5d6rn9Q0EtFsvKtohEOYSMiPWQcTy539MH1fRFnfLcr/kAOI76IOxL9htk1KMcZfJKn+JWvmSdWBeK9Y2llIeQi34gy3HUpXwL6m+hx4cHab/ESPcIm/pmPoT+7eJHq+5Ib41nnVi3ljfKynZ8/HH+oMU5P89rTzzx5FL+6NEcR1n+NEpe9DreHsw/zknMUfHcFOctKc5fUi2efaDVd3qY8WXW3579Tf06acz6Qx84e/bM6sqVy6tnnnnmXr1erAcccMDJ45Hbt29XZyYGJpM+ExcTbgtciDg518DJAl3I1CZBJwFstWQAJxZPBDWgAx++/jo/xcCEQx3KudG7fftOssHPyvYmY+pQnxNPDeiAkGnFDNDDiaxli7xRvxUPNvAdtGQANxOcQFt2uNiCh62ajLln24oZ8Atx2GnFTDuDnh1t9ewQD3lr2dFXY6oBGfxBTwujftvLvxe+xgzoY7V22jb/2gbso4f8t6AMdoyptDeTO0DfxZeyvse75C5ipu/W8qZuttrCTix3C9FO+mrZNsAP8oKuml+jMb9PtGLANu3zzTf5qdZWG/Fatxfx6DLX5LHlP7lGd1w4ox7l5qUEPPKCzpgbt/BtQ8h9/Yh5dgvcxx/2e3OKwNdSp8Am/RGgK+rDf/yB8A89Zbz6zzyJbucw7ZT2BHViv2nJ7QJ8ZgwYk77GcssiX5THLRivMcR2bQFZ/bJvkeca0INO0JKxfXpz5QzQgb3eOWQG6PA8EfvUpsAf8oM+9MSxhH7i5puk8PjFRXDhwvl7MmxjOyAvD1137+Y6586dvScLsY9O+NzIewNHW7PFL4AcOb9z5+7qm29zzh5/7PHFhwuLf+unuSDbzv6B/5R/ma7Tbt/T/cwylrAnP9Y1p/j+5ZdfJd/Onj17Txaf2XKMLkBe7i4ED9vnzp1bPbWMPWDfZUsd66Vfr1ziemyRRz985wGAfWTTnLCUf/1VPp+5MKIO6gGOpVofphx9+gNFwGeegk8c6hXmFNT0oxuZWr+mHjz0o7umP/rHPnFzLFr1BLLUw7cyNoB9dLbGr7bQT310QQBe1Gl5lHFrbvPTXes8s5EnCfoYvnFujeWAY/p57/q19L2EY4n81UBu0FFrO3jOD8yh6kfe85qAh41ST+9cag6hVr/FBxDjw77jQNT6CHWRoV4td9vgiy++SPPRtsD3F1984egog5xxL8mbQ/aDS5cuprmhBuammzdvHrtmOuCAA04Pw0Uu0JqUQbwBqIGJwomxpsPJL10kLBPftnYWTakukxAyZ848kyZ3buaYYLh4whYXTXyjqwXsEG9togdOxqDty/iGlxMKdlo6zD/bli+AGEcLBfBabYh+bY3sEE/rBEQ7g15fwQZy5ck1gryVJ8AIc2JMNSDTu1AC5J/co6eVl1b+0U0cxgxaN2ej/APHiHaibY+RIZ5azMpiC762ytiizl7fpa3NTYR67buQ+kD0F1sA+Vhe2540sIOvIPoDPGZrTBGUA2SIyTayPEI9J42yb4Bo97vv1q8sRCib//K8/mt1Lss3LvYL9JWxYDeOK/oBaI0j7GUbecEA/cjUfLY+Ntjiv31IeWAddTm+ev1ZOM5q7QyYe7CJLnOHvHECbFlfXwD1kMMGvisH2JdKoB+7vTlcxDy4X9u29mugPNot920D45WAW2Jmn7whz3Gt7SKUh9BNHfLAPFrmVqALvWwdhyXgxz66LYyhd66aAb6iC7R8ngEx0b/QZ86AORGfXb26+s1v3ln9bpH58z//s5RTcom8ebWfmsePPv549fZbb6fjv/mbv076os9Xr15b/fJXv1q9+sorq1deeTnVR5dyN27cWH340UerG9evHy0i5bEI7/y586tLly8uN4KXVhfO50U3fac+x9euXVt9+tlny83grdXdu3dTGb489dST6ebx8qXLq+eeey79gZLY4VMX3z777Orq17/+9eqNN15ffHvlWLxs8eHa558vMVxdfbFs79z98qif5mtB/Lq80MWLF5POGNdSffXREtf7H3yQ8vmjH/0wyQH8A1lXlscGsk88/sTqpZdeXF2+fDnJ1Ba59L8GdAFjiMh5aS9yqRvgWwl9rfVrfWOhnrrIlPpBbH/2Ixx3+N2yjw3bCHDsVv+ITX9EPKa+uXFLXfVaBuJ+DWs9aXMPZT1sc77k/FrmBdnZRS5ka3zGOCBvNZ+pD9XmNmKnPnznUMAxYyLmEd3kt+wDvXOpucdOrd/Kh2L+sU8foZ6gftl34VO3lZttgC7u+1joqvlMP3/22QtHR3Xgf4Rxsc2+5msQ2p58MofF2MyF9Q444IDTxWN/+7d/+5+P9o+BCcdtb4AyCfQGsRMfGOnpTW4jO8JJhYkH4mKGSZsnvEC+CEq7VXiibNmZjQfbtZOFcNIf2YF6eeEE0rMz8nXWDvGY2xrUAXoyxD1q5xk70MjOKP+t+iDaKf213DYE2KrpQ0607KEn2iEHlHFxzEka3V68R+gH8vwVmRPsN998nep68akMRLm23I+EHglw0uaCCh72Kc9j6rg8Ze5LypR2Z0i4T9z2iRoBLyxKgo8/8q3D/q1b5Oub5D+I+iIsI4ZenzppkA9ziU/cUN5eYuBJg6UgtdEildqsvKijLnnIbZXnpjt37qyu37i+unHz5r2bS9sytoOgDFKOrXmuwTYH/FUVv+yXtgW4tfTxbxZ/kdc2POO8ucSIr18vbcWxYwGq+dmDOqESMe7YzspL0XeATvNmPsgn/qLPmKnDMWRujBmwL1EmqdttWQ5ZR/0RHuu7+8bg2CBm/Yf0F8CTb10JP6LfbGt+CHWpT1n0qL8FdSNXg7p6OmagnbjdhqwLWj7PAD22L7Ghq8wV+5wDWHDivHH+3Ln0tJJ1IPb1iS1PGXz66adpken3i7433njjHk+dt+/cXr333nuri5cupoUq/eAGj/nznXffTXoeX8ovPPvs6tLFS6tnL1xI45S5ibGAOm4qGQv6AJgX8PfO7TtpgYAFp0sXn12dPXN29djSH7788u7qzt076UmqZxfdxpvtM4ffXr3//vurK1eurM4vvtGHBHGg/7fvvZ/84xj/Wdg6c+ZMeuIsPZXxzbeLX4/fe2pM/3Dxi+tfrK5eZQHuJkZXFxcfsKH/MafMY9iDgy8+9cb4in5D+LJtHzZG+DUZ26+mv2dbu+pnfNb0Gz96IOGYtjzKkNdIJd9jwFa79vFI8J07LGPf+h7Lm0GWPTpoAP380byENrjX8Hq8ZjfXX/tYQn7LZ/OI/hLWRSbat452BfmBIpAFLfvqL+uBaD/Wr9mHL0VYtyzfFtjENm3Ck5VcG6saHovojFHstiiCccwCosRTWlzTcJ2envhcyji2b9oHDzjggAeH7iJXbdIqwSTSm5jU05MBnDhrk6fAj/GkkW0ghz6oXOTiQgq5FkbxAGPq+Yvt2slIOIG27KDf7UnaAdgwvy3YPj1/9bknQ357/sLv2QH7sDPq18YDlXmhriRatqJMzR76kWELn31z8OGHH64++ujjdHLmIl5/tI2cW/5a/e4776YTLTcX/AU8yik7S+j54IMPVp988kmyyWsn8qIPHo8owjxQTpy2N1vy6NZ6HHsjHgkZ6iHnvnog7dB3vdGQuCHhCYAby03huSVXeYHoeLtrH3n2iRW924K/ABufT5NqYwb6wIUU/eLDjz9KN6jc6BEjN5bEyY2nsQPq0f78FZpXgrgRu3b12urjTz5O7cuTGteXMvRQnznT1+5KqIttzHEET3IQK3qQY4HqX//t39KFIDfd+Go9/PnlL3+Zbs6fforXk55OdeDfi3MZBzyh4itT3ECW8VmnB2TwHbmarHqg2M7Kx3rK5bzmRR6O4RPnb997Lz3ZsUimvxbDQwZ5iH2P3Y8yllkOlYg+4a/t4bbch6zneAGOrSgn6UMca/pnLGUMPV/RI3EsqOs5BmpBGyMZ7c1Cv9XvdleoC/R8HgEd5Bl9xGWe2KdMYhwxppm/WSS6fPnSPfuCY4i6Hy+yyDNGyf+bb+ZFLoA+bMBjIQpdzDH4ARjnPIX13vvvL+XPrp5//rmFnk9POzFGz507n24kmXfOPHMmLSwZA8T45smnmzdupvPVq6++kr5pw2IW9fnkBDeo+MO8EV8J0jfmLJ5E40kvzlHEAA98t/B/85vfLHPb9VT/xRdfTD7yhBWvcnKDy0IX8X373bfp2pBXJAE66D48pfb5cm69vch8t8T71NNPLbEcf4US4CN6kGdBDl9c5Cr7OmXUp7wG+LZPDebf9i9BXXTAL0E5VKsnjxwCZDhGHzbVCyzzGDiPwINq9iMiH1sSOtkaX0nqjnxAPWhkt4YYRwvIrHOgzfRvKoPIXdneQhnQ4osa37y2+g082sRrHaBPUTeAX+qhPqjZBuhAppZfeDW+ZeoG6LfthHKUtexvA3QSv4vrXOcxJz35ZP5mpH29BLlhAfzrr/PCFcSi1ldffbns88ff499Vc3+fvh9wwAG741EGfg8j/iz2pacF9Gcb2U45gWr/pP0Qs3ZacrOT5azcrnGftp3TaKeejdl4BboieWJ3P5ZxISJZFsvZ5yR77drn6QKehRjqw+Ok7EnbfcpvXL+Rbhg+/+LzdHGvPvlStNciwI361eUGhtdBONkDcjJD8eKT/RbBJ04vFLxY8IIBGe2WdSHKAbnRnmUtIPu7RYYbEhaIPl9ixNY93qIXHk9JoYsyEfc3Bbr4hsM6xvWiQaQW5NM+3Fi+9dZbqw+X9uZptK+XG9rffZfzge6YA+two4ltbth4KuP9D95fXb9+fSn7Lr2KQ7w8zfHub3+b+hwXddSr+UU57YadaIsnO8gfF4BJ73KMHE9BvPfe+0vf/OJYrqlLP7Mdvv5m/RoGfOPkJjw9dbf4hP4I7Zc+1oBsjMf9WCY4Js6S4liCHF/Iox8ZFhjwnYVEnmKxXjkWY70Iju3jUDlGIjleIkW+OqKNqLu0LcyJpP8S849zEPwS6DUO/IfYxz/7TkQ8runbBOhCR2y3ESnPNto3jm2JmEud2wBdM8DMclGXYrl588Yyl91N+daH6Avj9NZybkGG9i3RsqkOfs2aJ53YXr5yOf0hhoWofCP5VFpIeuXll9NrjixelX9I4GmzGzdurh5b5qYrz11JC1UshFGXz03wxBX1X3v11aQ71pV64PtYjMMnnnxi0X1l9cILz99bfMLPtOj13PML/8m0OMjrjLbbPZDPJZfkh/Mq50NzmtiLD7U8xbLS11ZehfxefCVPGzWyj0u1Mssh0ZKjT7ONsoBywb5EruKcxHFJyhJ7Lz/wSrtiJm89UG9clzm+zG+mxJ3wfWyjjZ7+Fso6Lfuj/PX8HtWNiDLsezxTd1ugm4VuFs8znUt/yGuBaxeugbj2ZSGd+YFzOddw9Ndt2uGAAw44fRz/E1+BfQxkdMzo2ccElyfMvJ9tru2uJ9K0aeK0Jq8ZO8jsmpfZePaR/xnM2NmHTC1u6kgilvUoXuRZL8Kb1vJGkC3lXvhDcR+KMtRh/6vlAj2/5vHI6uxy4e9FpVSCmw1uIHkaBiL+bQnwStuVy1dWry43GBcv5tdEuAiNF6ns+1cuyUe2IfxhEQOKMt6Ml/o4FmWMvdhFTcZ4LOOYvSeXPPMNF54eIO/wsc9f4v/pn/959fbbbyefgHVL3SVafGzevbv+TgYyXBTTzsvRvX5l/RpZD12/eeedtGB08dmLq5/97Gern//8Z+kmjptWbMSYIeywfffdd1dvvfX26vPPv0gfhf7Rj360+qu//Perv/7rv1n9yR//8eqF559PN57IffDhh/fqC/SSE9pOG4B97NL2X3759VIH25mQ50IR3oXz66dArM9TD7YD/Vxd9BPj5OmQn/30p6s/+qOfpBthZKJ9fdTfFsUcm3PJHMlzLLKtkYs8xgOoi1+MnRdfeGH12muv3fuGj3mDHAeOlZy39esOkLKQY4S8SB6XuQDGEckYy3qxbikvgTifUYZMCfWhH5/x3Zii3Rosr+mN0L8e0BX9J24I343DWChXThiHPuH3LqSeXTCtY8kNT3CxkMN88Nlnn6bzSGat2xdwzuAJJfLA4lLEjD2e1uQGcNGYXo1ED/WMW1v4wpgRlrNYxFPKTz7xZKovYnvQTj6VLPR/2Tva3g/sM5dzU8oYPLfc2KLDfkj/ZMvTadz80k9ZcMP/GDux0UdYdOPm+PqSs0+Pcmoca3+Oo5fDsk7UJfXKAfHU+OYPsn87Bix3LEi1cUB+nIPivKSdiNr4LnMZUdaPoE6P3+KN6s2A6i5a1SjLtG204gU9XkQvvh7kU3+XPMzW1U60V5ZBpd8lP/a7kgc9CPD6MvMG88+D8uGAAw7YHesz2kMOJspNJr37J9ajnUn07IxONmBGZoSZWPdhZwbaafm0Lz9Gera1Y9+JxImVi7t4secNEBfllsUFKf76w5Z6ERxbF6JevHDE3ia4e5enifLNCa9t9MDFJd80wc4zy80Kvnsh70Wq5A0zF6zeXJdEXS7qeXXlJz/5cXq9I+pSh1vJi1xphNm23DR3oFeHdiGmP/53/271wx/+MN2EAWLgxuj99z9Y3V5u3qJ/m/gQZdHBgiVFUQXl5vDrr3nM3XqZ7Jds+Q4IPORZhOL1Qp5s4EPIPCXBTSAytA1tEEE5/YInEN7+zTupzflI81/8xZ+vXn/ttVT37NlnVi+//FJqaz4sTR/g1VdhPG5jXvJfPPMvnAFjzCJ54ZCnsPC9fFURfTxZYTvgC6DOsTh/+KO0EAbfvi3QQXyOVfMWxzHk+IXPseNYogx5xypbCOCvZJuRa8aQ+44d9vmFOuKhfXiChTpx3OA/pM4IbOvjtvMIcsZOfYBtSLs1UA/5mJMZe+alzAP2WrZOA8Ratpfznotv+gkhW7bPwwjapNUuCyd9Gys9EbW0H0/jusgV+w+xMb6Il/mPV3hquM/Oke1MuYgnY5d0Lcf5fOrYA2vZ42Mqg/5P/ZxvYbu5hexLthtlvR8QQpZzKDbIBf2aMsn2pZzv9eAXT5Kit4bHH38iverIR+V58pQnxJAlrl0RcyThTzmXOabNY8x1bY4wTvykn0v2d8dDOQ4E9WvAVgRyrbzV0NIrRvwWtq23CWZ9tw02wYz/PZkWr1Ze82/G95LHsX0R4jj2WfbL/oIMZfLUiZ48HvP5mv3Yn08bfEye8zc+HHDAAd9PNF9XZMKDRhOMciOM9MzYGSNfIIAoT9n6g5G72ZmNdwR1jOLeFx4WO7O5y222vuCTOCm69aLPk2K8OYPPxbtU3tRyAq0R9bQBaV9fNoF9BfKi2n0uCr2o5BjyIpR9/kLO4gg+4T9lXIzGhSkvUNm/s9zIEDffFOHkjHy0H8lYIpVQVigXcxHJfMWcxf1SBop6437kg7Ku7aN8yZfklYi5iMTHz2/fuZtyzF/t1aE+YJnQhjLyoxy6I+Qve0u/fGrpx/kGLH/LKt983L59Ny0OcYPKMU9N4B+v/tHeaWHrUX5piT7TXsDIv6T46Orjjz9e3blze/XiC88v9GIaO7HvQYwRXhF66qmn0zfLsKO+WpyacswYL2CXY17xYbGWfsxibY4747j8Wj9jg9ixzxMe3ISi3zHK+MXXuOBMPXjxwpoy9RIHFON1DMaxyL58b/wos1w9kL5SHiHfffnIt8i48Js6tDn20a8u84NMnPsgj9EB8DvOJ4D6EeqjLnMM9fGDshaMB/3ORTFH+lqC8tJ+RIxxV6CrpG2xD3/2gTKGrl8LCz6vEPIdu8+/uJ7aiTL7Gz82wROWPD3JN7CWUZKrLjL0L8dPCaSQgR5f+g0/n49vfN+PMRvHCGBLmX3G/kj5+fMX0gIUr4f7HTGhDUiocwbIph9+WP5jsY8nRkXUg/4n0rzR/+YoueCD+vwRgPPyxx/nbxmazx4YU3GsQtRh3DlfqSfqwh/GVBzL+VywXgC0PI5BeMYilYh5LYF8i49/9I2Sjz3Rsgks39Y+6PFOEr24ZoHvu8QOTip+bdvG9Mt4nrGfsh/7LXWoa58r+yzHEcoiY7+Ndenj9nN0O36izdMEC13YPeCAA75/OJXZgsnrdJDfl097i821WcrW5buCiXd0otlXzDN2ev7M+jFrpwf94CQUyZsyT1DxxMlNGeQ+PPmRF0k9bOMFedzXl5JqIDaJk21Jnow9cXtijvDkzIV6Sdb15O3JP14EYMctxKIV/nAj7yJX9BO4ZSGEGwX+Gs+HcYkfEC/2sWE9jvkWE79Yx3HMFbAucviKXZB8X/SQ3zKP5t74gHLysIWP2I3fu6rZR97cGTf7LPDwhI9+I2d9wMIgr5y4QKJ+wFYC8MmLttm/tei/cYPvVOVf+uNmhl+tzL8ilm/qKTc2iWN9VidybAH1QS7noo3xwIJN/hD8rdu3UlwscKGH/o9cXpg3hpw/fmAAG3x3h29pffstP6iRf74c2QjskStk+Ag6fYlH8HlKj/LvvltfmAJsc9PJU10vvvgCGu7FAo8t8nyfgj5069bN7MtS7vhGPhOLYMvYWfj0Txbl0M34dYwjz6+vmW9ssM8rVHyPTt1sY1/EX/2GR3vzrTGewkOOceSYs65ji3bHH8opY59XIvOrTevXMImB9qSu9vDr+iLHAiBl+Iac8hxD2LAex0AewCY5hGhTQOxx/FNXuxJ8ZdgaIxTrRlIPpK/2MdqCfSi3WaYI62KDmMwJuSrt7IoZHfrTA/wyjm2wj5h2QWwT+o7+eMz4cRyt2zCJpC0L1ryWzbzJopb12H7Gryn+/rvVsxefXV04v35VEPTihkd7099YOOIVZ87RfB/wX//tX9MPTLzzzrurjz76KI0rFtmiPmwDdPDEI68LLl6nj9f/wz/+4+qXv/pV+mYgT54yl3POiWNH/9XTAzaYEh9dciP0P+KRpDvrO+4r/7j/SJo3+Y4XTwEzb/PRfubBkS/ojGPVecbx7PiV9E9fIfYjibIcKuVL1MpqKOPimH4WoT19ngF6WjnT515Oe/736u0LI9+29aEXFyhzwxYqxwRt5NxQttcmoE3tn7GPuh/L7HP4YH/QXyhCPyNfGffVUdqER7zxGsL4TwrkkMV8xv8BBxzw/cJjf/d3f/efnWBqYBJhcmmBCcaJqQYnXye/FmbsiJ4twISIvI+hp5utpQz7XJD1HnOftYNcLx4mxh4/5qVnBz29vMBv1QfaADU5eMSS85RPUh5L2IBKecslymp8j2uEfKSI6C/7kohl5DoSIG9QyZMA25aM/kS+tuARm6BMuegXRJyxviTgA+qzD+/9995PN8AXn72QXtXCVqwX88WF9ltvv53+4sS3gFgUQw57v/r1r9PiTV4kupV+pe7qcgPBL+yhH3vlhQL1+B4SNxnw0PXJJ5+m1zRYJNFfwTE37u+++9vV7du3Uh18QB9PH3221GORhVdnsHvzBh9EvrPwH00Lc8jFuPSbBbHs9830UXRufKifF4PyaybIJt0Lfbz4yK8EfnH9Rlo0yotO36YFFnOHPLb5wDo++4uExAfxvSrq8hqdr6+waEE5r6jwyl2MX9+x9eu33krbtBi7XIAB7OEDctSjHdlnAQ193Gyy5VsveXHuqyTDghBygrb78KMPc3xHvxaGb+jG/tNPrxdCgfYA8ZBPfp7/haV/oJuFt0V8aav1mAVsmSN5ko2bUPs4OSMH/Jz+p59+lp4O4VfR0J2emFhc5SlCzEN50S3Xe/+DD5f+8PTqBz/4QbowBfhJXvlGmO1gW374ITfIedHq3HIDzq+acVOJn/gGWGghb/hCDu1bLEThAHaQRydwnw/gp1e4Ftv4hj10UDfHkX8GHv34RpvQpowFxs61a1fTeMMObUxfpw4EaBP6AbpZVKQv2O9YiEs/5rDYY7GStkRvfq0qnwPRYxu2AL8kYZwlKFc/bQrR1hxDJdABOSd5/iztAftOWR6hXfS1QN7RoZ0a9LkWo4CPXE9mBvvQY9yAmDhWbyTbw32P4z5k/VIHx4DxSD+jDh9sZz7hDya0PfMgW/r2e799b6n3WDpnsFjF97ko/8GbbyZ9+CrRl/kxChZ3/HVFY0njbPmPeZ7va31598u0CMy4uXHr5nJ8d+k7eaEqjhXqo8cycsyH4pkLbt3mjyE3j54mzR95949b2rUO8bLY9Hz4dUUAjzGGHyxM8TSXcQF1QNjhHANeWmTNKWBxkHloqZHymfroMnd++VWeP8gdT8Ihz5yALGXMn54DsUkM+KR9YmdMeVyCOKJ8hP7BQ6YEPOzWeMbc49sm+Bzto5f42UY4N4iefqD/vbmA/LTq93LT4+0L2Gj5bm5a9okLGJu5kqivjHmyDGK/rBMJGWxD2lBHBPwyBuqrX566IAC/7BcRZW7UaUwC3/RPIFdru2gfsI/euK+dkwL+5z/c5QXrAw444PuBtMhVTjYRvQkdMLGUk1AJJ6CeHSaRnh0nMtCylfmPpEmIfW6gs908MaHfm44WZu2M/I0nmxq2sWOdSNqp8Ym93JZEfbfKWBZlYhlyZZnlkWJZhCcyiWPJWIg5lksx5zUZyqKOlp6WjD5B+u3FaCRiI35BWdQbgZz1ajBH6uWm+rfv/Tbpu3zlufTXchB1II8sMtyk//a999JFOB8gp49TzkX4f////fflJme58Vgu9rnZYWGBBRaOP/zww9W333y7XJDnX5rRD+r94z/+r3SDwSsllP12uSn6zW/eWb322qtpTrBtAfvvLnz+Cs+FwMXlop+FFG6aWLDgZ9x5NYa/YH/z9TdpwYabfZ7iwbb9SNzze9mmX7ZJCw1fpl8RvHHzRlrwOHsmf4yYhZf0gfLlhua73+W2xC4fNeapm7uLDj5Wrn58YLHi3/7tlyse+uQGiPaljIUVvm1Gjq9cvpRyyDdYvvr6q/R6ygcffJB+ocuFFvNFe/E64D//8z+nuM+fO5/yaXs5HxknbcBNIznlxog2IBf8QmaKY4mBvxwiz2IRi/LchH3y6afJP24oL128mPO//E97nFnywSuNsX9QH9ss5LCo9/obr68uLTeqxIQs4Gky47AOMXBDzD5ltAPt+MGHHyQfebrtu0VvXvy5kRZ9yDntzo0zwG9sf7HweKrjuStXVi+//HKKHx9pBxbr/uc//MNyU/hIWnwj3zzBxaJVystSP324fYmROuQUopwP4/PEx7XPr6V8stjHYhFjgWNew2Ic2O5suSHmSRPyQX8kl7xKSb/ippo+Q9tig3z//d//z6MYb6ZFMfogujkmpqV1081sutFf8oSPqe/+j79PseSn5s4k31hEe+vtt1L74j/5y/2UV7Xyh6x5nRP7+rwp8MH82p6W0Zb0k9yncrvWgN8S/RBfvQawb5WI/rZk9AM9LWAHoKNnC10tvkAXMewC7JAr9LBfkr64L1GnPC7lShnLlKPT5+06p2teRpkn9uMi1xtvvJHk6dv0tSee4OnoJ9PiD2OMp6gYs7xSzDyKzJtLHXwRxE4fjYtc8LGFbuwwBniCmEUd8g4fnYzxtIC02Af0bcYk9cwpx2eWfs98g2/88WKJJM1PjEvq56fQHk22tauObRe5gHqSjWVMg7jIhWx6Cu5okYvvH1LOK+b0Y57A5fzk+ZM8lYtcAD34o21sphx1xgJ5jXUion/IlICHjVpdoP1aXXj2w5rPzHURyJR+ItcDfGyM5oIW37Fdi6/H2xfIQekb+TFH7gOP2UpAmUhRBv9jeZQTcV8YP/6xBeRauwL98iPU2eJBrdzCK9uVMmxTHoH+0oZx99pOfqyvz8bYq78LuFYCzJMnZeOAAw7YL/pnowVOID0gMyPXw+ykMbIjv6WP8hlTs3Z6QKZFkc/k3CL4nCAgTmCQxxB8yyFOwG4lj7mgLEl+tFP6AMxnzl/+KxA3QBAXs0z8lEFpMWOhyPNYPmUQN5El3xOY+mJZ9KPFV6aHGZkHBS7MuZnmY7dnlgtl2gB/aaMIjiln4Qc8c+aZpT3zB4TJCXq4eWb/2+++Tbpee/W11Y+PPlhOzvnIOgtO7KMPYlHpzt076Rf48kJx/hD27Tvoyx+m1xfs04bvv/9+2udpofPLzQb6WEz413/91yWWr1YXlpspbqD4IDe/2Ei/e+fdd9PTONTXNtDv1H++/SbdQLzy8iupLj8pz1NMvO7HzRwLXNjhBgf+T37847TllTueROJmCz0A/fQ1bka4gbpwIf8Fnv7PggTH/Jw9+6+//noiXttL9pbyO8vNEO1i39FfFkd4QogbtJdfwr+z9/qjrypih7GF/Y8++ji90oMuFn/efPPNlJtLy00nC3XkhafSuNEj9/QDdPLUxSOPPpKeHODpPn6976UXX0p+Y2tpjWQLmE8WyK5fv5H4yPFLZpTlp1nXcRBTHE+pzyx5w38WhNKC4dL2F569kNtx6UP4Ta6IgwU7b65Z4Mq5/iZ9wB89tA85MC/0D24SaWfbATp/4Xz6lhD7xEmMb7z+Rmp/bhwBi2r/+i//muzRN5D58Y9+lD6kT7/64IMPj75BxtOCOQ9QGleLPWz/bskzuXz5pZfu9atnl9ieeDJ/q4yb2zR2Fl/JDd8Gw84Pf/CDdCOMDtqQRTxyhX7ATTf1vKGnLrnOi4E30o3vq6+8mvKHXRaN+TU8+jELqYwV/TUnJTlPlwSPemV5nOP1swRtQtyQ8zFxAft7C+V4aGHER8+MDNjUFscllXmN1MonefR8al7jtkbRpsj9It+s5bHm6+58YzF/64x+xNziFjnkqce+507ajOOs88jAAvxlsZxxgxwLWywYsVhObP4xglefN4XjGCJ25jHG3x/95CerX/z85wv9LO2z+MQi76fLfMaiU4SxsAB15fLl1Q+W8fCzn/109Ytf/GL182X7gx/+IM0bLF6/s4wP4gUxjxHoilCuLAfHdCxsZXp1AOW06ZUlLr7R9c2SV+Z+2st4ZtGKA/T0RF9rOiK/hRnbpQz9KQI5YnaeKNGzMcKMfzX0eD1gr0ZxTpBq5ZZFHvlyK8mLpC2A/1CeE9bX1xLH5FwecpFKqG8fUI++1lCztS/7NaCbuMkJ1PNtH2CuY5H7pO0ccMAB+8FwkWuEk5zA9gXmo3gSWf5N+6cB7EKe0OIJT2Li9CLZxSdvkqjDPuRFszJQqcNj6tVA/JAnBYmy8qTKhbEUT7TlsSdb9XjCjTxJ+1KJVvmmmNGxy4lqEx/tA7Pghuar5UYn9wNvlI/bUx/l3AQhm/+Sni9EyXV6emrJP+3CX/W5gXj11VdWLy039vzyGzf2LH7x2hk3V4IbdZ404a/z6EUn/Q/wNAv6AD5gh6dvWKziiTP+2v/0IstfuFlA4+b+j/7oJ8sNz4+TXZ6E4saeYxaa+HivttFHPPjNq2M8McQCBzdMr7/+2lL/xSWGny03QD9LC0/csLHgwY0c5djnOzS8sslixJ/88R+v/vRP/iTdyJkv+uTdJb9LRpMO7DGmuBH09ccLF86vnl90sYDDIgo3YeSBb7fgK3XQB3HMYgtPFLFgcvHis0kfQI78KMuY5IkebjYp/+GPfrT66U//KP1q1wsvvLjE+np62indkC43osjgLwsytO25s2fTzRQLLvzqILb4TgT2sk/J7D1wzEIZC5apfyyxMDcsovfB/KCHHEDEhi88qfDKy0ufWW5CyT1PC1589mJ6QoKFQNocOb7BI9DH6548KYVOcr2Upn3AjS+LULx6ajuQH2KEePWJOLlJzjfqfID+yZSP9z/4INl64fkXVj/76U/Tr4CyGPnGG2+mG+sl2+nJFPRH0K94CpAFheefez79qiP+069+uujh5pwFLH4tjifJHDs/+vGP8i9PLm1DH/7hcvPNPuPk1s1bKXZADNggJhaUyTVgXsYGfv7Zn/5p6v/Ehc9pgW7RT1szVni1i3rO9RBxS54X4rHEMbYiHxqdD3JbrxdMbKOHFZv65/hzDELkBPK8CZnrmGNk3IdsE+TVoU6Ab7Ql5LmULQu+LBLzFOv163ne4klG9iljAZa+w1zOGLc9qM9YyedRzq/JzL3xOgI+s5j12KOPpbmHPwgw3z/11DPpl3iJY1vYd9yH8IucMF/xpBhjhz98kA/+SMA2yqsj6Vn2eQqK14CZE5jH31jmfeZ08sNCO7AtR2DxblGZdMceg82I9aL/WKc+86QoTwjjJ/M5vhFbqbuFkVyPP2Nj1o8aYl3zzLacQ5Cr2bGs10b78K+mfxe9xig5vuP8ACFXmwco1z59znmAMcxYdn6N80Ie18evj0ErjlF8m8Tfap9W+T6BjZqdVvkMiP2kfafNeWq+HAsHHHDAw4nhSN1k0uxhNPk4Qe06SVk/+s1uLK/ZsQzyJMcJjItEbyK44eXija0XctxA14i61kk3ykc64sWyJ0cIe9jGP8iTZDyWODFyEczFsCdPjvNffPOFshfLUabGk+/JuHby1e5poWybbUDOdoW5byHydvUZXfaB9PrX0g4sStDHWn7QJtw8cZPExfaZZ86kvgRoN26a0cdCCjcM9EnqUIYc/ZT99UV+Bq+kYe6Zp/MvriHLq1Q8JcbNP7oFfertt99O/v3gB2+mp2HoX/za1kcff5QWbnzCxjjwg4URfGahigUN/IDw7/qN60n3D958I/2aFTmwLwLqY+P6cpNIf7186fIytvIrmuh3iz6e+IpgnOAzT12xcOLFCk/48NQRddGnHihf2CxjesmDCyfoBjdv3li9/8H76btRLOaZY2NlH1lyiG2+LcZroyx6/HDJFzew3sQyT3BDyPeruGlicWvpGcs2f78qPV105276WDTx4hdtkrf5O2i0V56/8lzC2Obm+UJ6febpxEMfvBbwmV93NOc8Tfb88y+kJ/AAN9vmhriwT4zmMu8/kj46z1Mp+MTCoT8KAmhzFojQHduBHN1c2oF+ffFSfiXTXNLW9GmenKA/8yTZ2bP522TZz0fSAty583kxkEU66kOAfkWeX136FIu9cWxhnzhoPxZ4uammHgulPKVCnNhAFhn6A/hdGjs5l+QD/4iJBQTiBujhiRQW5GhjgCz14DHO2T76WP2PILk9MyEXaRtg13MIpC8t9HhgxJ+Fesq4jDXmgbzQDrQZeY7naAi+52e2lsfzsO1tjrGBD+SDtiZH7Ht+lehbzD/xfArlPpcXpyDPpehiLOct8yxx2oYpxCm08tMDdZhrWSjijwY85ci4fPmlF9IfI0Cpb9SetoX9U1CPGCViZdGKef7JxRbzHOMamHNJH2L+2aa54/yFNPcyX4x8E+h7eml3wCvrjGnKIgHbl9fosRHjaSG34Sqd65iDqPPrX7+1+uLzL1KbR+CvtiIsr/EiduGP6s4CPbZXhO1UYtRG8GdkWpjh4Stj2zkizhPMA8wJzgNQnAck4mP80qZxDiBm9x3nx8f6+vzf8rXXNr34wKZ9YqQvYqR7pAv+SEcLm/hZwrrb2t4E/DE0/zDPAQcc8LBjuMg1wmlNLk6ekTwZcXKC8gkt/1Q9r/fAA7w+ww0eFyU8auoFLyc6yTJPeJ4c44lPuxH4FckTIye72gmSC2HJE6QXx540JXjoiXyI8vJEKtVQ87tEq67o6d8E6Oj5MmNj1pdR3DN5eRDgCRH6HU/p0CeNVV/1m77BqxzcYLFQQJ9Vhr7HghQ3eSyc0K/pMxE8qUK/fvLJfLEHsMU3Slxgs/97QcgiC0+6YId+ycfoeTqADxbzehny+M/TTSwyUIYvkejb3CBiK70qc+Qzx+nJo8UGN0aXr1xZPbX4IeBL2GF88guDfAydVwDxJ7/id/ymCRLcZDF++Es8uRXYZPGJujzVVdpCFns8FUUZ+m/cuJX+ik9Mb7z5RlrIoNx6QFkWYFi4YgGT/SuXryQebUI7ZtnlxmEhtvixJCaVU58b1PSdqmXLghU2aXcWsPIrcl+mfeY6v22Tn+LKN+B+Y2vRfkTHgS/If/UV8xUfiqaPOe8liUUmz20uin79bX7lkAUh6ps3ZIkr/3Likuujb02ZC4Ae2qtsh9Q3lniQ5Rs85hMw9/HkH4t9LLgRJ+rk4yv72iEGyuzD5AFbl5bc07/0BXnbAb+ww+IcY4dFM+rHsYM8Yyf1iyUuxh2gPmOHmHxqDhvRDnrJL0+TOffzJCR1sffE0Tg8CWCjPIcA/WsBv8FIrsU3BxDtYJtA8VxLOTIcx5tRthBlyMU6bGt5hmhLiXjpW8af2zgvVrG1DBkIeerZL9hGMiczmM3fCPkPEfN2AbaZt1lkpn+luW+5NnKu3ga2Y8y3+S8J8Mp5WrBfDi1jiw7zGcslAC89UbnYYBF4FujmaUq0MCbRoc1InKOghZn6F2UzwC/yxzXly6+8vOj4Mr26TN+JMDcRlNknWqjVi+jxR7pHsH7MRWnLdmvZGvkPSj7HErCNynmC45l2wgfIed05wLHtvscS8taVIsrjCHi9uHt1R9CXGf09GdDj71K3jE+fZzDrew+z43cfYKFr2zn0gAMOOB0s95j9CWV2ghoBO+UJqzxpyaOsRtbhog2izC1EfcgyY4u2a/FysubEJnkC98QYiRMj5fDZL8kTpnpKnZE8AbQI1MpLGrXhvrAPO/h7GtinnVbc+7KhHuzQV7jpop9zY0efBbV2pp+xWES/46ad70kB+hY30tzA8eoX46E8+aMPvnbYUoZOyrm55HXF9ZjKi1z4xsISNlh0Sa+oLX7xZIzji8UNbhjRxyIIv/wYie8P8SojsmncBt9YFNHvpxab/HUdPZLjBp+fe/659LQPHw3mabJf/urXq3/75S9Xv/xl/hl6Fn+IGzvmFr/S98lYUFhsC54sInZi5Ntm2ABsiYsnph5f5HmNVB9u3ryefsmR3LHogg3KrQvYzT48mp4oYH7ABjeayKFLcCP4bfBDLGrTk2L8+hi6nnnmTKqbn6g6fkFOu7PNr63yvbQv03dj+LjzommRP+4f4Dj7QT3+Ak57M6fmRVMWlfjQO+1G+7399m8SvfObd9LiIn0w+8WTE+gm179LuSLn5JocAfRhiz5LP2HxLbYD/vOhfxbr4KFXIne3bt1M/vIKozeltA9byrmZ5YkR7FFOGYQ9FjLJKwtT+lHOzeQeWfo5fyjBBrIRyNFH0eXCi3Upx294+ATQRX8nZ7/+9a9Xb7311hEtY2HJIa/6YoOFsSeO8gTQiX8twl4kyojVY+sTD8SxZF5mgBz+SbYH+TXPErmQyIGEHHUsV4ZyttSNNrTbygHl8ZzsPkTs1EXOXEDWU2fMQ430oVa+DY7C2hrRfszTCNThiUdexeUHHnjNmLyP6o/49OsPP/po9d7776d+jx37AW1NfV/DJNfM2T5ZC49zB+OCH4vwfEE5RH3q8Nr77UUH5wie6II3A+SImfHJ05U89YsNdUPMFZ9++kn6BiV//OQJWXMMtRD5xEo++XVb5kEWsflDxAxmYqnJRN96Omb019CLPaKUw14kcmx/oL9J9g/nAElZeIAtesx3HLcAXg3WQU5SByRiWclTRw2Uw2/ZBz1eDy2bs9C3GWzrY69eKzdlXDWZfWDX/G0C+iqL3Pyx7YADDng4cd+yt5NPJE42kTwZxZMS23giiycvjpFxP5L1anojwdc/9iH2hZMbJ0EvfD25cWPHjQ9PO3ATFS9+vSiO5InU/ZIPwYdXo3hSBe57PAvlY5wniV3tzMaInZ6tfcV7WnkD+7JFf+SX3BgrLCzR91t5RZYLdPoc313xBpljf+Kcp4sYX/qnLmR4YoYbTi7wkaHfUictcp05k76NAqiLP8jhG2MJOZ7W4iaG7wvxSgxjEh18awsZ5ImBskjY5/tWvLIXf60QHrb1m4WWEvpPXrD74x//ePXSyy8l/6n7xeITN10uprFAI5gTkME3FjBiTrhhY1yzUJMXa46Pv9QeC+X4v0kLaDzFxSISrwLxSluML0I7tAlPYzz11NPpVVAXnGAjg33mKNqGp6Kc85Bh8Y+bNG4Us3/1i3DqQvDwhbZALwsvR27cQ9abZbHP0xIsTrEgR7zkmBj5ED4/LMA3fdCV6i7/sf/11yz6fZfamtdlAbpSrr/MPx5wbrnZpEx/U9+7k3/VkDjND3z05TifOfJ57TS6XKhiUZf8GKdb2gXbLND6VFS2dycRC1zUB9aTADeoPP2GDvpgeZ4ByY/FDu1AeyCjDfoXMZE/gD/cyLOoRS75Jph2qYMdyhgDjDnHOza2IXSyVQd9lTJsAmKR8Nv4sAsxjiLZD+RxHLdSqQdSv3bNMb5I+ssWMi+W16hVNxJ6oh2OI20CfN8F2SZ7u+uJ2MQvnmR/fplr33jj9TRv0j67gjzzZCo/wMAfGZgjfLIX4tt577z723SOeHqZ8zwXCeZcftX23d++m+ZrF7xY9P3kk0/SMYvrjCHOL3muGP8CGyA3jKkXX3ppaf/fpx+i4Mcx+FVUfEP/u4tvLNLTh5jDeeJ5RjdAhn4F+HYg3+rDpn0votVOo/br8bUx0nFSiPbL8U5Z6RfyPXKM1sZqLGdr3mtARli3hlbelN8lr726s/p7/F18m0ErZwBey36vXg0tPfuMD12R7KOR7L/24U3A+Z96BxxwwMOJ9CRXHOQlOTHEC9pI5SQRebE82nHCiQTcMll6MpO8ePAiNlJ5AeyNMjdwXOAsGhOPcm4qXNhyi45oS2Bv04lbUM94Woixb4tt/YuY0TETz74wm5eT9se81OxsmveRvDbon5DfB4m22ZcAC7b5G0D5FTvkAb8IZ1+PiwHRBxYS7iw3GfwViu+loJNxwLih3vEPmuexy5NV1IPPqxk+gcKHtBnvAHn+Qs4W23wMnqcHJL6lBL3Eh8Jffz2VcaEAkv3CbxBjZmssPCHEx95/8pOfpA/r86QCH2Tn5obFoo8+zDc01kMvN1a5bn6SCjAH8MoKT6hxMxifpkGGujxZRD6InyeQ+LA5rx+SF2J04ST6Cta7+WkiYkKWfGmfMl6t4ztsxP/7pf0upO9U5crI0dY8gZa/jZYXUKxfgoWqPDfytEtui1wHfes6lBM7QJZv3tCm9AHigseCITeei3B6koKPvfNRftqNX3tkMQpZFnxif2FuJVe/X+ZfFqv0VV5abFz0087ymHvzK47f3YsTefjwkCdHLKhpizjZKsMNNfpZcOMHA9SdFtUW3fQNniaxPAJbfK+IvkPsjCmhfPLxaOzw5BVtSfshH/uu+eNpFZ4qJKe8UvziC8+nxV0WZskhN+/opi8zvqiHDepCuR3XBE+iXhkHx8SBHrZQ7l/HL+g9P8dyy9hGivUkdQv3o3/4axwQZe7TRiUhD4ihFbOkXAvmYReof1c9ABX78mcE20hQjzakv166mJ+ALMFr47FdS18ZM+iI5fwqKP12sbD67LOr6akuFqZY3Hr/gw/Tt/OYT/jjQPr12mU8xRgYnyw6M0cxx7BIBvHdMPR8+NGH6fz29DIn82u5+cnSo8pH4Ji5AN9A1A+Pcw2vZvKrtfyqJD6hP28/yK9/X7iQ/kjBHEZ9CaS8pF+4beeGY8Y1i13k1jxF2bIO+iO/RIyjhLyybqnPYwifJGViWeTJj/slokysWwJfHbO1Me18UBvr1C1JnT30/J4B+nv1R/Zn0NJvnD37I99Kfsvfmp5ebPL2ZR8gK5XHUOybI0IeW2WZesr5Lcq4f8ABB/xh4VEuYjkxS1wwRGICQMYLJyhODpBgguHkxMnKE5dbeJ7ILOfClpsCb5yl8hjyIhj9sQyKJ8l8g8cJ0gk3+xZvGGuv7GyKXevPIsdw/KRRYsSfxb709DATzwgzud+HHdCzFXk9WzP+RiCfPmgdFiTQH4l+z1/RIf4KzYU6YxPwehofUWc8UF76yRhiMeCrdKP+zOrxx9ZPgPHRb7bpRn0Z99SFGD/cBPDkEgsUny03Jdy4o59fBEQnSL4v+9wcoJsntfgLuZT+Yr7c2EssJDC/UI9xzEf09ZvyiBg/oA77fAOJ7yPw4fuf/5xfX/xpWngiRyxGAeRY4ILY90kuy4nlkSXG+PSQfIj5jvkxxb/I8mQAN2fcvD232FLeeXFxLdFSmnjMOSzeLNpSXFlv5rMPvkzf1bqdFh2JP9flCa/8CiuvLObFv/VTMS3Aph2yC0ubLznFTLa7Jm7e0MXN6Fu/4ZXPX62uLvuA7ceffJJujvnAMr/IySIij+jz64osenEDiBGe1sp+paopT7y6wxN7LnLpM3M3T8QhzMIPwBfai76VfnEx6VvfuBILH48mDvqrPEBdQH0WNRkH5xa9Lp5Slx84oF9xU873ykDMoTo49/AjBPCIT7/NF7ocOy5mUU7fdcwRE+XcoPPECG362uuvLX3z52ms8KtsPE2TPpK/6IDPOPDXPdGhTeJsETboSyW54AqffciFAPjsK4sMtuCZA471g7g8v7Kl7Tw/p1wteYDIPTKemyHKrAuhUzKvJwV1G9O2QE9LB+WbEDneBeV1CzojOGYBmLHJwo6gju3n1jYA9AfmQ36tVZ0xf/Qfxr0fqocHcfzmG2+s/viP/zj1b+ZHnlbl6dk7d24v/euxtDjFr4fyAyLoiW2PTn6sg/n6tVdfTecbnkxm3KQfXlnON/yq7o9/lH+Zl7rRPvnkSWEWqFpP/fLHmp8uNvhlWOLjvHrz1s00z3A++tEPf5B+LZX5NuaEuCFiIpfM8+ZGngQYx/yhhUW1NEcv4yoiygLtlCjlPK7RiE9+IMa4W+cMjr3Gdx5QXqCjB/jkjHFejnXbKLZ3BMc9/aX8LGbq1fzZFKPctLCr3VnMtF0PNb5lbHtUkykRefY7KJbFPumxfdXzV9mHyS/bWFedlLG1/e2r9tc4/g844IA/DKQzGoPbwR73uVBlywksXtBygQCxTzknNyhe3MYTn4SsF8jxpOikM4KTVR9rPcd15nqztnbFadgA+7Izo2cu/6eDkb+n4WfpQ8vmTG6V8aaUp0m42WaMeKIG7vOxav4SzVjiV/o4yQvqMD6R84YbqIMxx2IScunJpaPvpPAEGDfw2GDhyNcV9Y1XwHiiiO9sfXH9i9Wjjzyab06OLi4gbFCfGugHlJcXEByXoIybI/1Oeo7q6Lv6IaGMNnIOs+8sXIkvv1rmncUncsXCC0APT3HxytgineKmjAsn24L4Hn+c1zWfXuatb9OHjImfxR5uvngiAdtSjjfPm0du3wOvBLJQk33OT4jxa3zMpdeuXU355wkfvidjXfTwAwM8yZVvxvpzGDyIDzVzI4r/9BfqYSvH4yLH40k/T018fu1auklmYZL6n39+LS3mkKu8UJX7jnM2vt64eT3FxCIN+gX5pP3JI984A7QdlL67tfC5qeWGUFDGDxuwmIc9cxnBEU9f4AOwXyDLU1MsKl2+fCk9sULbyeNbXshy01u7IQbwyQW+k6O80Jj7CMcQ/vCNIWJjIY3vtFGPP6ywUIosMZFbvlnHOFsE0sIWcuphn3hpc+pxA245W//oJNH3oFhGfF7gQ44JfISI2/bCX2LzHA15Pobvud0yz9EQ/KiLfahsm12h3+QA2gX78q2lR//01T5iW3jzRRvRVuyfRkwsxvzsZz9d/fhHP7qXT8g2i20oGLs/+9nPVn/+Z3+WfI8gJhaj4L3yyispjlIvr8pjD5m//qu/Wv2Hv/mbtP0//uIvVj/58Y/TIhF6og9usYd+FtD/8t//H6v/8B/+JtFf/dVfrv70T/80/aAJH83Xb2wKdDJX/cVf/Hmahx3vQv+wwdOn/+4Xv1j91V/+5epv/vqvV3/zN3+9+uM//ndp0ZlFfED7oBNyLPGHGBbiiK9sP33RNxb00IksP5phjNFnUSsr9cd5B7JfESc8iDLngSirLnOAH3EOYN85wLFOGYTsCDN9uSdTiz+ixx/xRrp3hfpnctDCaeZm03zU5PFXKo/tiyXZZ6ES1KPcvgphN+7bbyWOIfuu/dc+bD+WYn+O9SVsRNKvAw444A8HjzLY4yQRJwongnJCiCiPd8E+JpjoTvbXCXldlu1sb8uYT2NC1N9dbOU87K+dRuj5uk8/WnaMd5Sz2bxskvuWLOUz/nIjyyIHJ2Ve++AVEPa9GOAGnA9Wv/X2W8tN9O3l5pnvrLxxTwfEQg6/aMWvS+XXSY7nnX3+2o4++N4c8KQMi0wsfPFXdC5U1IksC0D48uGHH6U54eLRk1nKQNThCS508vQMTzx5wYMOFpT4Nsr/+Pu/TzfVEeiGr9/xAggdXjDx1BEfmCc/1PFiiQt95i1y9vEnn6ZFlOeX/AB84xtQbNFPnvWZj87z9BAx5adAczm6vVBaXEg3q5TzHZelRVM78TQAcuUcqc8epw+pLzEhR154WoEnHfAZ/R8sOf3k089SLK8sN17UQRbg3527PIHGx5fXv/zYA3y+g8PNHTdqPJHla3PZLjl7dHX79q3Vv/zLv6SYePXwtVdfS6/6JZ8fzfnnqQqeJkNen/ne1ocffpielOMJLtor+sRClTmhTciF+fj6KN9nln4W67nQQrJZKKIc+4C6+VtmT6cYePUIPuXYYRHvrV+/lfrPKy8vN+NL/4MPsXhLHdqdfk1fkSe0wyIm44C2YkFMKA/fhVh/vQ37fEuMscnYISb84mPZEHye0qNtKQfESQy8lkX7c1NMXtGrL9ijbuyH5JJzNOdseGzR5R+dIM/nnsch6tpPI80g5mkXoMfYaoh2enIxR7tAPbSJRN9wnnFeYeuiogsK8qijL7G9zLttRf53dZn0mKKYA+xK2GcLL7Zz5EkllIHKY/bRaRkxxnlPIGMuLVeHRLl6ynJeFSevRMZr26UddboPxVxE6EfkcYx+CKjfsUVb2XalLf3UH0ke5e5bBwL2I4j+Qz+ijK19K/YpCKhP/fYpfcBvxzr7UumDFFHLGYhyLRnQ44HSXolR/Z5/I79Gukfo1R/Zh9+KfZQTMdLfgryZHES+8hB9j/4Y/6gS5z347EuOJ8rVAfDFsVX6zLF9FRn7M+WtvgsB9W8K69fQ442xe3874IADTgaP/d3f/d1/ZoJpgYlrNAF4QmZyqsGJc0YPMi05JlLQs0NV48kXFflGDZ3cALFvWQvyRvG0+AJ/e/HM2FGmpQMQZ88OvqJnZEdbLczG0+NDo9zN2JF6MujZxQ5AD6jJUJ9YBP2uJtfTAeSriwsKbpp5YuTmjRtpQYSPfn/yyafpG0k8rcKNOAs4f/STHx89ZeONDU/gLLIff5Ju6Pkwe7SLDH7+5je/SYthvOKXng5aZFj4YgGKerzeYb8SyL/zzjvpoppXRF5//fX0V3Zt289Y9OBmAb/5FhILDDz5xIe3WRj56OOPE++5K8+t+DYW8vjNqyosxGCf72wBcxL94IPBaYHl2udJD37zEXwXDfi4ME9S8YoM3/0iDm4C8keM76QnsF595ZWkEyIedPlR+Tt383fJuMiL9omJb7mw5ckBflGSRRf62P39LLcp5TE3fLCcJ3x4Cgp7X3zxeVqUo01ZeOJpAHzLT2vlPsavR3668BcFqx+8+YMk52JcC/kbYvmmiie6rl69lr4ZRa74lhj9iVdOeRrw06VdLl26vHr9tVfTwh1+4j/6ry15JSfETFvyZBILSh9/8nHSw2uJvFr42muv3esvxJqe9ltsUIcFMrY8+Yfuq59dXX2+xM1CFq9BAurwEepPP/t02X8s9T+euKJ8HSeLhY+nfkQ78moUPzTAAh6LqdjDjx/84Afp6bpUY6nL4hO/bEi/gs82thc+QZSRC/oSvv1w8QFQrg9ffnk3jRHGEE940EdYRKMOC4X2XfymHvn54ovrR4tPSz8j74uNjxdZ+it9gfz+4ue/SOMeO+iGqA/FfQgZiL4hb1sYu/G1YDu05NABWr5oR7kW4rmsZQtfjL0F7KS+fyTLvvM1W/dbfpX2XTiI+Y/7JZVQP229C/KN5vo6qPSBY0BszGH6UvqEP+SALTz8Uh9Efcpj36PM46gXHfKifKwDWQd57YJYjrxQLgKfkZewEW0CdcAnB9qXkEMPMXscdUIAPezHelE2Aj5lykCUAfpeWTfy5ZUyxqpuSOCbcaonQn6NZ17L3EbQz+Br2/ESob81UBf5Fh+gs+af0F6MW8R+UKJXDxh7jz/jW89+iwfgY6OWG33r8alf8qwDz9wAji2rQR5bdUDUx0Yk84FsOV9A1qG+x5A6qSfklTnGF2RruafcLXU3gT60AA//9GsTMMfUFvIOOOCAB4/jZ60GepPDDB7k4F+bzjFkX3aLR+yal1nsy86D9td+MPIDuX30mRk7M5jN2z7yy8UBT3WwgMRTQuhkoSE/nfRxusnm+ym8ZsENu69UAeLh4oAt33XiJ9GjT+7nC5FV0s9NeSon50s5T57wTRcuNo7RcqHOkyvYg1gMYbGIuuq13bjx55e8+MA2r+ax6MSiFL+8xWIHi3KvL77nRaRcn0Wp9L2lxQ5+R33ue+HE6y980+jJp55Miynofu9ocYunbFigePXVV9PrNXHhYMlAihc+NtWNPy8uvvLKGE9NXbt6LV20COSQJwfkgsUjFvl4UgqeerxQBGzyN6rg54tA7JKTi0veWDRiYYbFLb7xRZvyBBLfdOGJLeTXyB+O5xVOXifEnDZbQEfyefGX75PxbRt+ZID80A4ff/zJ0q+uJTv8BD4/HsBCFzGQK4jXmFhwYyGP79iQX4j+CHhqCRle22NBylxA9hH4PC3G03cg9c/lP54ag2e+EpZ6PK3FwmmOc932EP3l8pXL6clF+guLviwsXf/ii8RnTLz55huprnopxyZx0a/IYw3Ip5wvJp+mnx/1baB9iMVHFhkYO/StVI+YUvnjaex4sUxf40k6vhfHAvEHH36w+mDpp+SfRS/+Qk6f4BUzYsMcPuAvWynaj3Qsd1sCPWAfumZwWnaAearlMpZFXu0YxHJJXSXV0OPNItdf64i5hNfzrUQsU6ZWt6VT29EH9iXGgPOh+7FMinbYArbOQVK0rz+R57E6hLxIUY/7Ug3KRvkI41AmykbUZJSL+1IPI/4M8HtbzNY9DRslRvXM98MIfWcbx0y8FuOYc41kGRRjZ3+mH9n3IlFeji33gfs10od99NEI9cUYZ7FL3RG81jrggAMePjz2n/7Tf+o+yRUHb2vSYpJFjgmuBnjqaemAjx74LRkmcdCzA3zKYX0S4KYjv9oB8l+p0m4VnixG8fR8BdhGRy+ekR23u9iJ/tagHfzp2Rm1j3Z6tgB6WjGDkR2gnV7u0NPr2/anFrRRs0MZ9bEhkKn5o51RPMhRn/Zk4eXM2TPpl6XorxBlfL8k/ULhiy+mxYBon/ro4YabRQdusM8tdSgDbN3nZh1dLBhxs67fnLD5zkn8cLH1kq2l+vPPP5d88Aky43KLH08tN+0sdPCRcEyyeMFrXHwvCd95YskFtpg36rJApm5ts48M+/zyHgsk1OeJHfzi+2Ecs/iA/hdeyPkB9+ovcwD5YDELWf0ltxxDLFyxZcGHRQhAfRYpeNqLp4b4RUcWjaIOZGi3CHjffLPufyyOUYen155c9vGbBaRLS05oK9rjmWfO3HuEH53kAz1PLO3Jq4q0S8xXDcST+xIXqr9LuU+//LXYYjEFPr/kxwILi4XE8+yzF5P/PHWlbvpFenV1aTfaET6Lp7QNi3y0AT6xSHPuHN/kWvuV8ngmv3aKHvLOd6lSH1pSxoIpfQG+oC45J0Z0AuIA5IC68LGLLyzIcnzhwrNp8Ys+xauZyEK2e+7xq7To5jfXKBex7egjtBH9iPwg5xyC3PJ/2mKHV3W1wfmFONOYO5e/90aeyTe5f5z2Xuw+ueQFPt8Mg2xT8qmuWeAzvm1Sp0SOyRjaesh9T4ac9vyHB3K/bPdd2wE9LTl0oWd03QLZJ0sylpJKoIPYe7ZmgB7Ux8XzbfDEE/m1NmAsJcxPjSeQQQ9bYOy2YxqnC9QlCcsjP4Jyeehm33JAedkO8Mw1ZHxRRn4rNn3RTi3f+tXLD1APdmuyMRag3kiUOXaMJQK+ekperFdC/aDWN/WlxQPwWzlg7gLWj/YEdVv1QSsuAM/5qwX4tZwBeJS3eKDnW62e6OUOwLdtoh7KrctWxDKIuuYylkdSf8mPdUAsdx8+dWPuzEkE8fkEkgTUV8uf+jdtN+oQUwQypQ1lWralGn8E8xb9iqi16Qy+/ZbXm/OTvgcccMDDhUe+/vrr3/ceoWdigGoTkvCE2NLDxOIE0psc0QO/ZceJunWhiB2Qfm5/keEGiL/qU49jXvvBB2+suDGpwZjxpTbhYQc+6MXDTQ/8lgw5QVfPDtD/1uRLnPBbdvAVXdSv5RYehD89O8QDv9U+2gEtX+CjJ75KUWLUD9ChLfypAR55YWGzZYe8mpOaDDq0VdqhnPr2feDrD6WuUf4BMuQfHfaLCOoi04N2QLRDXX2Cr4xlbiP0hXisQ5ngmHq1/gLPeNiPueNY4CP5M/+RxzHl5Bhd+IE/6gbsQ8hRxlYd+sQWHfgCH7LcPkqdmHN9QVY9vF74L//yr+n1vr/8y3+fFtKi7+YGPxwj0FdfMSdmHbxq56vS+RVNfMn72Z9cxz6EThbG1n8pzDn5+mv0t8cX/R4552Ne/3v88fVNCroJC7seZ7vZPseAvOEv9XIdytf9x232K7/yhO/I4zt/XMD3fLzum2zVJ+lbhLqiPPvqwVdgmTKx3PpCvjIAGeYk5OSxTwz4YP+t6QLaAfrAcSlvfwPKAevabywfgXYm5zGWTRF9j/6VGJ3LjNf81YAt+lRtzhDEhBwy5r0Edmgb+3cN6ECm588M0EPs/oFsW6CHkPl22i5ggZ8cAdqilQPmJvNXyzX+IEOO4Mc2MXccQ9n3zLPMfaAu/EFPzLflZRuQU3xXB6BdWRRGR8kTLX3CczI+AV6VLwEPuZ4e4JxgXDXgsz4hKwFzhS3soAO5COojj1wtR8iXdUCem/P1ME+FlnCMxHaNGPFZ6Mcv2gH70Z7otRN1e+MPPv245rvozW+93MAz35sCvyBixXYLtX5IPRDbNKLGl4T7sW2iDPUcm9i2XKCbvOEb9ZGhDu0ZQT3bLwJZdIBabuERe28+LNtNn2kX0bJvH2u1HfahFr8H6xJXzBv+AWyXbToD+jC/kMznCA444ICHC/ffWZwQnFScUE4K6mdbngAib+RGWbeF04qnh1lfd8XBznGU9TmBcjKP5MWh+5zoJS4G3OfCgfrI1NqcMk6+Xrx4gcBiocSFhwRPgsfWep7I43FJZWwc9/gR8PS1vGAoeR5bJskr7UR5idyQX1DyIHVYt9Rvufv6wD66yd316zdWV69dS0/qpF9UXNoOPsC2F17WyW2YF7BE/sVFvt+Q//LHohJ2WJSHbCP14hNytqGL963FeZBfG8x60QNlu1lPbu+cF57ayrr153i7ckx5tktOst7s/7rf6Ts6QdZNvfUveFFP0gb7yEKRLyGHHgiQZ/IqXyBnGbo4lkrd8iPW7ZV9VzaipQtQFz45oNzxrk4R/c/tkPVQbxuUceyK0t9NMfJnxl9lRr7sO/bTQZ4bdgFhx9jRB3nuoe+5yMMWYq7yXGNZrX/av50n8hjO49exHnn2X8fBrijjquFha3f9MW/my5xRtq3PJxnrJrpbbTHCw9ZWIxCnBBgjjinHFcQ4otx9x5XyjEV1MDbiuIIcN7GPSIwr5MmdYyvmkf1eXjfJea9de7yRjRq/Vtaz0cIm8ZWwbrTr/ja+CBbm6QMHHHDAw4dHt5mwTgpMNDOTzUhmzY++r3XP2AA9uZm8jOygA2rJyd8XZuPeFvq6Dzvo6OmZyUtPRt1svTiB4gWN+xAnMW8WOKmxRaYENuOFDRctXrxAXgBD+WPU60Up6sQLnpK8sVB/GV+0HUnAVwaUcpGi7livpFEbQV7USdSL+kGptyYj1IuMOoG6rWt9joF1JKGcfEBcXKyCq1evrt59992Uf35qn3Lk6C/0AWS5WAXIWJcFLr9VBbJ+Fm7WF7yxXZUTHFMOf033ywn7cF6QOr4IhL/Zbu6Pa9v19gDRfqyDDupFv0r/s821DDaQgbTHttyPpD626MA25YxH4mS/1GkdMNILaCv0UaYeKaKmy5sZ6tH+yMQbnAh4+M9YNx8lRb9mMJLHj3VfXC/AE2+8QeO45vM2GOmZsTOTB2NrAR2nFdMsct/Y7e+K5gafbFf9g0dftJ9JnGc819BPvbG2z0Hb9kHQqyOvzGErpzP2qduqD6KOkZ2eHjBji7zO+F0D9Vo2ej7Cm+H3fO/xIugX9CvtCeqPdPT4pb4SPb7xRUR/2LbmO6/hvI6zHBnko8/YIHbPP4wd2rscZ44pCFn4jqltxtUobz3+ruj5Cm9kfyZW6m8Twzb1mCO9drcf2O70DaicSw844IA/DDy67WSzKU56YhbMr9qJky1Flu/LjVE8M5P9DGbs7GLL+g9TPAA5yZOQJyK25UWM5EULMvFYPvLUi/oEtr2okzj2AseLHC9qIsxjSQ8TZn2KOdkFIz378meXPNufAG3NMfre/e1vV//0T/+8euutt1Ob82MAV66sP87uhS9boR/oGPm8T+DTmTPPLH5+nWJ4mDHb5iWo41hk69iOF6m1mxr2a7DdoVmfrINe4PwgsF8CvfQRqGUDPdS1z9h/oo8QMsbIMVvjjDdsUDnPAXMI4Y/zmHa3hXGN9MzYGclgC5qxNWNvhFqbqdvcQraN7eP5xvbIbbGrPzl2yf4XqeZvD708zeRPezU98Go6enp7vFFs8PchA2ZkZqCeWlw9G7O8Vr5G/s/kGRmIfkVf2xQzNoS2HE/sO5YkxxPlbJ3zKHfsRWADiudr5zxicl9CxjFFvTimor+9uERLptRVQ09/r6486kcdZZ2SL2L9Fka+17BpnZ79Hq8F2pBruLjYb3vb5gcccMAfHqae5BpNKshsM/GVmLEzAirUU/q16eQ4kt9UXwsnbWcfbRNR84eySOWFvxcp7MP3gqVG1onkRY8kiI0TGCepknrlkdRRI2FfkuCxrUEZ4X70u4YRf98gry2brdjEDH8k8zCA+MkDvtKmHENcCPHrh/wSHn2GD6Hzi43s54uk9lNQ1Lf/g5NOA3YYT164P+x51z/HtLmCHO/OF+U8wbH9Fj3q4hhwTA7K8d4CugByUV8N2ICoo17zbTkxRMDTj55u9KDDeNEVSdvqQN6Lc6k8hvTRferrE8eg55ew3q4ghh60MSM3kmnxKZfKvhf7nQSv1gcheOoS+GbOI1EW5bZBboccgz5HKn2X9BWqoawLYn7kxzyYC+WBdSxv+YRcrbymI1JLn/FRNwJe9FM5wBaiTL0xNvUpYz1lZynq4JjtDHrjLfeD8VjZllfTTx+OMK4ekGnli7rmmmPkIMqjXvxg7MQx1RpfkL67b3nkQepuUQ89vrxefsEo/z1Qt1V/VHcfmPE9ysz6NCPXs90CddA9om3B91ZZcOWHei5duphodpwfcMABJ4d0Jtlm0tgG+7DDRDTSI7+cs1rlJXaZ7ErsU9euIP4aeVHhvhcbUrwoiRcjkayvDvdFPIm4vwnVLl4ixQsZL3osLy+CpFKHtC1ivCV6vNMGMRI/7WRbbQrzNKq7a9y7tMcMiB/YHwTlVy5fSb/Y9/obr69ee/319Et4+XW/9atzNVjOuAAn3fb6bSwPE4yd73mRD+cRytm6LwliGhF5jlTyHPdQCe3jE7IzsE60LeDZ3gI5bLP41LOBTvKCDnUbB2ReLHcb46sRclLUBwn3tdFCrNPCjMwII38oj2QfkmgD+xl89y2HonzUBbBfEu3nfpnLeFzm2mPbgzLtbAted168TPvoirHUyNg9jrFGqEtZZdiaN3MaYR3r9/RwLJmLWMaxpM3IVybqU660JyhXVvlSR9QT67svX9nacY+A8VpvE0SfSsAb8bcB/kZwDNGfBXG04lFWPdavUW3MlBT5cW7rzXXRbg2j3Iz4Lb2gV7dXbxa7+j7CjP6eTOT18l/qsL16uh9G8FkKfnUa4iP/EPPlAQcc8GDxyFdffbXMKfmCuQUeB+5dqDuYkanByYwToheMNWDHk1YN1AfUb/mCHdTzWCqvBvgT9ui8ezc/qpp/Gj6fEGtAhyfuli/wiZub3VY8/IWK+tvaMW/4z+O1pR14AD+o3/JDPUBfPBYcl3qUcYuv8CThPltkbWfL4hY+eanFI7CDHPxW7sw/emrQTq99tANa7Uws2KHflIDHX28EOoi71GVOQGuMwIda8Qj7CyhzuymIC99s86hnNOappy+t3NkGvZjwAbvYqcUB39zV2gCM7OAn7WT7GJN9iHJjoAzClxgXrlHP+txsPvUUr4QdX9gQ+INf9L87d/gFqe3aaBb4zFzHvIfftVw+SPALj+fOnUk50bfWFrAfj/cF7Eu2P20EsGc/hM+FKjzySTn9kDr0gdI3eLGvAvsK2xqiHxD7yMZ+Rxk6c5+rj8V9gPHRm5NH4xQQA76azxLEwrxSm5PhAfOInZ4e82WurA/YVwY7kqgdi5K3L+gfcX355fa/1MjNFN8SYn4B+Ve9vlr03u8zNpHjF1qdj+xHEGXkm3jv3L2b5o5nL1y456uwHov7/Dpk6v/Lf0n/0lZ+eDnmG73og6hbphQTsYxj6jz77LPpGB20LX2S6zaha6nusv/4UueJxTZ+GAt+QABfb926nXzlKQtk7DPsA+rgI7LGB8gP44KtfRLSDr7duTP+tUx8xr7fgLKuQD9l2hX2cRDnBJByf9R+jJOyLnwIfskD8LyurAHd2CdebKODOuQBYh/oN8R+hD4AeJGvLnRjowb41IFf6rbtejzr1kBsxE//rAE+elr+kZ+R76CWe9u15R989LeudwD9iHav1YcHYrtRht4I6tbi79lHl/6jv8w9aLWNv2ov4GMjyqgboL8EfPS3zg01UIf2aPV1Mbrm3RTXrl1b4mufUw844ICTxyPLJJdGYG1CEQx++C0ZJ/TWpAecaGoXuGI0yYwmQMHHXblYQZSV9ex/ntAhyvCh9StlTuSgZQcZTgS1k7sYnQh7doyzZkeeYNIvfVAmlmMLPUIeW+1wIuC41AdaJ68IbPROQtrp9QPbGX4rd9iAWicu6tPfRvk3ppiXCPjoqZ3w8ZOLB/QA7BBXrc84Rlp20IVMLR71A2TK3JTxtfJag36Vubbv1mIB+IDPoCfD2OtdrGFf2zW/4dtGLT3Y6fUp+Nxg4Cf5x5Z1KIu2KZcA84Z1otxokctxgPjt23cX+Xq77xPY5EaOVym/+4754ohxhFpuTgvkk3yZ19NCtGe70i7kSh7nhNxW634ILy5yUUYdqJzb1APPGwx1lf1L3RJ1lKudZ5HBN2SgkwJ+O/eX0E+2MZYSyOBrmR9BfcecOigT2oFAaYv9eIycuko5MLqemIU+RhvbAD2o4NpkW5C/vKiUrwneeeed1Xvvf9D07fy5c+lV6+eeu5L+uAfsS7QVdPvOndV77723+uCDD1Z/8ed/sbpw4fyxmKHr16+vPv7k09X1L75YfbX0E+ojgx+XL19ePf/cc4v+8+mYcvifLPJv/+Y3x/oDupJt2vjIBsAPFrh+8fOf3Tsn3Lp1a/X+++8nuzVgh36Lvy+/9NLq/PnsN2QfunHj5upf/uVf0jXfyy+/vNi4kOwDbGKHG9Hr179YffrpZ6vPl/g8R2fdF1ZXLl9a8vdcyr1xcy766OOPV++++9skK9C3/MvPHB2Lj77IU8H4SXzxPI9e6mlXEAO2gD4Lyj03OkeVQAbdpV7KIeqqVzv4AcHDPnzqq4OyeM0Dcg5ZaJ0fZ9qnLvXYloAPanxz0+OpuwZkaJPaIg+gPvklrzUdzmMt/dQFZe6B/oFau8GnPu1aywtgDqAP1ewTF/rRjX32aTP0RlCXdqvlj/hq11vogpBBf82/VrtxPjVuAL+MQd2glpttYD5r19YRozbdFNeufd5sowMOOOB08Nh//I//8T+z05pMgSejloyTUk8HQE9vwKOnZwc4SY5kPLk88YQ3ouu/OPGXzR60gT8tf5GJ8XAMUSful0QdL07cQvLcRl1sox/miDLzwD4TdI2Ug4if41imDvyB73EJ4wI9mdLfCPjE1+KDGTvYgIivBv2I8ZVQBrT8gY9czQ7lthXQVk3XyA46oBqfcup7wWobWYdy/dwU2KMucUSiDF4vd257MuhqtRFQT0sHfhgbcdcAT39rgE/ftm3Mnb6VtjmWWDCqXWxyyLyC3RrQm7/blX1uLajvE/hIfCwmeSP8+OO5b/BUKzEXYZwiaIPjrwOdBuwbtD/jhK19xb5AW+XcrJPDMfLK2M4eRyCLXm4uImh75OHR16gHeUw9ZUCUEfpflu8b+NQap/hQI/zCZ7cSx8YY+daLcbAf2wEYLzcIlEnIxfyjy7mwBvW0+LPQ912R418t80l9HpvBY4+tc0tOeFqAxRkWsngK6+yZM4lY7GbMf3H9+uqTTz5Z3blzJ9VjIUiQH3z6Zsnz1avX0qLUG2+8fm8RAyLf2Phf//RPqzu376SFsivPXUmLZmfPnln4v1998MGHSQZ73Mgybsg5T5k9+sijqzNLmX7x7ZrrN66vrly5knxJr/gs5TzlwZzFIpT55ib7s6tXVzdv3lq99OKL93Rkeew8nhYpWJy7vfh29uy5NPfF9rq78PkBkceWuYf8YMf+QPw8VUf9t95+Oy2IsSj40ksvJt/oW59//vnq2kK/W+ZvFvMAuuExv2Mr+vX10bkCO7TJPX+XHJxZ8kV+WOCzrwN0AOeBCHy0H2PXY4h6bClnvxxzUtn/OVafC2SR8ENbwHEHqKdNCLiNMc3AeqV/QvuglIn2N+EJ+Ojv+UweqV/TEX2rgbrYqLXpjH/or9UVzte1+ra/7YYtyyKoW4u/lxv9ht/zXUQZ5gXrA+1HGfjKtPRvil48EWV+dgVzS6uNDjjggNPBI3fv3v09k0BvAuCih5N6S4YJFDChtgY0Npjken+dgI+N1uTuZAV6/vJqDBd12Dl37mzyH51cNPHoOxdIwgkVuM9W0ld50XcnzjIej8mLOZEitIEe8lsD/Fbeoh3Qyz82kENPDdjhJo0bi54O5OC32ggbUOuvJtT3BD1q55Ed9NT+2gTQgQz1WzoAOkAr/7148JGcsQXYQU9NF20IWvnvtY+xkI/Y7ymPQAfxUK4sPrEPtVDqATNtBGGz13fJT6uNAHEB/Sxh/rHT+6srMrWxKLi5gI+v2KIO8wK+9XLjQhXy83AeSZsE2wA96tKPfaLUpz3yl/vY+gYFf7hJzb/I2L8A3Aeefvr4EwD7hHqNDTJmeeQbsp9QTj9nbLO1D8qLT3LF8ce2BHz/gi6o69jQH+T0Q3uC+uiHBPVinU2hP9Ev9stjx7vl5sF967Cv3x4rR3zmswXtWMetQAd5oLx3LsI2c+rIFvXLPG8K+1Gr7WeRc/hoWvzZFiwSsYDFYg796+233169/Zt3Vj/9o5+sXnjhhXvnGYCvvIb4/nvvra5e+zwtvPzsZz9NCzn2JeLCn7ff/k166ur/83/9n+npJcoBT3lh44svrq9+8OYbaXEq2vjdYoMFLvr5JRZ1zp494qzHmyB//JDHP/3zv6SFpD/6yU+O6VoytLRZnuvx/caNG8mnLz7/YvXTxe/nFtslOCe8/8EHq/ff/yA9JfXKKy+vLl26dMRdpUW+//7f/0d62uvNN95IC1X6xLj69VtvrT779LPVI48+snrl5ZfTE1uU01bkF38/+ujj1beL7z/+8Y9WV5b68EHZH8gBv8T7xRdfpF/h/dGPfpT0ANuehUDqxHOK+iinTJ0eQ7W+Rz0IXuu6oTdGHIuxjQQ82wZfo35slnMdvnEurelqYTSu5Jf9CFCufepH9HgCmdFcRYzEXovJNoNX893ctdpFH9FfgnL01+IWXLugu8bHduwX6CMWfRbUrV3/9HJjXuHj+ybtxiI25QIe/sU2Qj+EXC032wBdxF5ri4hRm24Knn51oeuAAw54MEgzjhNXC7MDfqRn1k4px3EkJ1EmJYgJV2KC5y98XNDxl0ZPNtTjqQZPzuqIcFJmUnKfiRZigoQ8dgJGtiTrQsQU9yPVyjahEsT1h4RRPLUc1LBLXlq5FrM+zKLlq3YiX98gyunP9Cn7KvuUMwbo94yPss+DqCcSGPkzQqt+iRm5kcwMP8qMYvj66/WC2GZA7/25BLQBF3vQ4lEu3COiTQj/mZOcw7joysSr21+lMp74qvWLfaL2zaBNQTs4bzvX06+54I9byAt96hA/F+zkAjI36oxbywH72PHiN9aroeShE4r1sA+IQf9qsK7xsu/5Dlqf6zLFuCV9h9ShPfwxH+SHY7bOHfQXjiVlpVg/xgc8bpGI+xGUR19bGPFb+jfFrD8zoB12AzHdHxeLX7HNscP+ubNnVy+99FJ6iokxf+3q1SRPTKP80LZfLzfB3KwxX7HAxRhTP8S3sFh8evGFF9JTXui0vwD9sL/SR83l44W/LAC1gIyy6qMOC9H86i3bm7dupW9kzbQ79pn/bt28lY6J7cUXX0z+oRc+sT7//POrV155Jcl88vEn9677QPSF2MxN7ie5vjyIPzDEvJMjc8XWOZqt4w/ZKCd5rC71ltTiWd5Cj6cPUSa151GbzKJnA8BvyViec30cPV7EyP6o/i4Y2d4FNd0te60YW/KUQ73c9OqOoMxJ5P4k27MG55EDDjjgwSGdkXYdiHHyQlekfPFSv1CPFwmQx6VMrB9JYD8S4CJAWvvHBcP9F+yS9T0GkR9JndZp0QxiLCeJ75Odffl6WjGDk7bV0u/4oL/Z5+2jZR9EB7IzmInnpGOO/o9swd/EH3LUk58dv5uA1xbR63x2WsCmcxf949tv1/MjaN2g4CPlzsUn7bP2tOm5wRtF9z1PxDwSI1T2f+OGwGwM3HBSXzs9aKsEtiJFX5BHrzHCN262xiZFlHFFneot5eTF49p+SfLYqlPaBmUsEVFnT+60UfPFdrGtJNov9l37KrRrTDnvRwcFbJPYdvjD4hOvymH79tGH0mf8iLp4wso+yrG2IOJicUjAdwwqK0q70UZNPiFU0aZEfCxwMSe4ONTEkW18gL788m5a/OZVRl4pRIc8iYUqXqHk6TD+eIo9gO3oL1SDcso458YySX2RKFdPpAj8bKHHA8bZQ8nHfvRN2L9H+iJG8tvyRtD3k9Rf5ke0yktgfxcfdsVJ5UacVnwzbX0SOK34DjjggDYedSCW5AUb5LEXaiVFmVrdyOuRYL+UF/EE4YkkXhTkC4j86DR/qeNmTjmI72G0LjKk00aMr4UZmR5m6p9W7Npp+TTjx0gG/owefNgl/zM2ZqCenp2Sx7HjDDgGBHUcE5A6Yp0W9h3XSQIbIzsl3zrko5Xz/C0/ZNNmY0S/sMFcuewtZXnuUf+DBH7RR7iBzU8D8bTFekHJcm/UKd83zI324n4kzzWA/MW+DXmT69NI5ViAyra2fdiiWz7H6pOHfX2o6Yn2gHIQ+8qU41HiGMQyyyXqS7XYJfilvBT1ibjfgv60UOqsAf5Izyz2oUPoU4/sA2xt27KN43EkyrOdtNkaOb/tHNsGsa0Zs089mT887Ufvs54B8J2YHnl09d1yHcWYysX39331uR/72wixjnpmgB9IayflvvM0GIhtwmva3y31nng8P4Ul9AdCJ69gxlcZ5WGTsaffUIRlyHisr1HebZnXEaKOTTFb11yVIKayPnL0NcfADGbkajI93zfJyayfLexSv1eXGEb8FnaNf5P6NbTqU76r7m2BXWKdaa8ZmRnwPWjmiwMOOODB4d4iFycmKF7Ie1zyvOGQ5EsRTmye2MsLcm9III7leyxRDkU95QUDdD/WZU5eiI0mspmJrm7vfvR07cPOPvwQPRnswB/pmfFnxpcRTsvOLGZy00MrHsrNfQnGG+WMEcZCDZRbl3EDGLe7+rsPzLShMj1fW/mJMF7JOiUJXi8p57MejseiPtqHp3V42iEvIJH7RTqVPSjgW/6I9bofMK9zs5dp/epblsnxrf2fR61ttEl+XcTKto4vaFEX8pwg8UcMnsLwOJ4jrKNdbcdxUIJ62HNcCPWiC15c8HPsRf0RxoYs5NgTyMe4jIcyiTrISTG2HqiHX/o4grlqYWRPjORm9MzamkWMi/0WkatItps5LMsggc/kHLLtbFcJ3q6xUX+bHOIzWfjmm/wxf+Lp6YG3XByunmSB7Omn0wfc+TA7fRSeOQNuQdy3v84C2Za8PO1Kv19s8CuM+JUX6Y9/K6qHb7/NC+F5zln/wmFsL/jkjqe5eKWRNkeOcvlg1iZoxbiJjohevZYtYD5rgNera/yljGOE7Sienn0w4vdAvX3Yb6HHm8UuscvvyYz4PYzsj/RuaxfsUreFUTxgH20aka+h+j9ydsABB5wsjt3BMcg5eXkC84TvlgsJyBsMyQsC67gPqQ9C/74nkhpKG7Xj774bX4DtOtnuK9aRnu+THXTsy98RTtrOwxAL42oE6tKXIfYdo9wQjC5Gt+WJUX525W8KfCZmCHBBzuIKufCv0BF8J6b3rZgasPHkk/kD0c8889Tq6afzwoj5yvMr7baZ3n2CBS5e8yG99Ad+qIObRX7JDLp163Z66gOf+fi+3+/ihzt4soEf95iBfe/Mmafvxc8WIt8sqLHlmD7peYbvB2Gfcw3kechzygj2m7L/aFtEOXSDyAfYxQe2gD5Df+E7RfpvvyntUW581EmLDYX+k4A5KuM9aZTxl5jlz/i9qS300Qa0GVvHPGS7RLt5nObrGED7e73Dvv3RPom9kU/7+DbdLPTnXkwL/e7IV2CcPZCjF55/fon1m9Uvf/nLhX61ev/999PP4zM+iZ0+HvNWzqE9UAd5yAVhdamPGPDZvLOFmCM+++yz1S//7ZfL8dery5cvpW+QNdvgKB8SbcGWp7+gWC/z1/NM7AvsR16sN4IxRVi/xtsVm/gWMVOvzJGgHeOcuAtiPyjR481gl7xTd8Z+iz+qN8r/TPsA7czK7wu13Gziwyg/m2LG9mnn6IADDjh5PMpJm8EdT95QHPDs1yatiH1OIj07c5Nf9P1+//Nx2t0Js/GMMBfTOC8jPfvytwdsjOzM+DETD+jJ7CNe45nxpQf19DCyU140qnPmYlJZ9TPGuWHjpmKXG+9d8wLQUdMTy9kSJ756EQ2VN6vcwLr4EG9m1RV1kg/ADZOLGOZDeOOlbETOKb7lGzR+tZWFLX5F0Jx685Z9XC9yUBe7DwL4R45YsMIHzwEl+EskN7fffbf+zg2yLIadPfvMEld/oQudxEtOALmIbURe6IcuZNEfXTio+bMp1NEaH/CjHeyC2P4COXzFP27uucEmd5Qjb39rAR+0te4Pmz8VtwnwFczaiGOjhhEfjGTIwUgHmJEzny2oQz0c089ou9jnyoUr+6DXQdJ+sC89Jwtjpp++9tqrq5//7GfpFwo//+Lz1S9/9avVf/tv/231//6//9/Vf/mv/zX9euGnn3625PPrY/OdRFlsB8FRbBvyTltoG1r+SQvu//gP/7j6f/7Lf1393//Pf7lH/3Wx//f/8x9WXy113njjjdXLL7+cfnCovH7dFtEPdNIn7BuRB/WgTC0HoFd/pF+9LfT46u3VFzUZ8uC4KUGb0/b0hR5mbLdA3dbcPoOZ3LXQ4wH4I/27xK7+GqLtkf0Wf+R7y3YPtTo9+/vErL5eTg444IDvH3b/U0vArpPDPiY2dBzXs97Xv1k7u/qzDzvwRnp29VPsS88M9tFXZv09yX5Z8rC1q70Wan5QxkUmN7I9u1ykw48XhdR1oYX68Wa4F3MNxq0NiWMudCO5IOVNkOUew+MYf9ShDfyC4k0HMUAcc5NU3rxC3vhYz+MYJ9/ru3Pny3u+C+OqgSeinnoqv9IHYlz84hl2uKnmVZ9bt26ubt++sxznJ5PgnSaIgae3lr20wNWzjyyxkN/y6RNjevLJvIhYA3mlDVkoy9u8CMQ+POJHB21kW+wbtm9sS2O2Pcu21ZfawlDUx5bcxP5GTMrUgE5yCuiDELbJof09+rIPEA+EfoEPtEUca2UetoGx70PPDPZhaxazPo2Amt3zc7SzDSbaGb4E6Jf88uAvfvGL1Z/96Z+t/uSP/2TZ//nqjTffXF2+fGV19dq11b/+27+tPvzwgzQWAH3OuZl+bt+I4Mj+CVVzvPhwZpmzWMR64/XXE7326qvpaVL84imzP/mTP1m9ufD5pcemnh1AHjwnSDE/s9jFr5qtqK/lS88mvG3qRSBHG9PWJdDN/NKb12bttIBe569N0Ysf6Nu2ukcoZbAj2cd6UHYGLX9a9Uf+z8RXohVviW1096C+Ua72bfeAAw548EhX/7MTZQunPYmM7SDj/vriKtbLRbvHPZO7XfMLdtUR89BCLU8l4O0a88iPTbCrnZm8gJadTWMZ+btNPFzYj26QvfgvZSjzJoQLKy4YveGG2OdCtUbaVL52E4BeyZsZb/ChvIhyf7llEHX1VT1RxjKhXEkillFPXyGOeSKBmIwjf7sqL87UYF1ygAwxsYjEEz+86uePX/h6TKTTBG1GfPhH/lr2iZtFEHzX5xLewCKL3gjkyZcLKeybW2+IbL+TzEPUjZ/AY/wB+KB/HiNj20fIs50lyu23xOeCl/ICfRD1HTvWZcsxvsSxBaKOTaEP6DIH2LMNtF36ui201QP8kcw+sI94hLp29ZtXn3nycxvgAn5kOiosYDvTjyD7UfJ/ocV6OpZq0Ib9AwL0y3Pnzq4uXbq4euGFF1avvfrK6s03WXx6LfX3L65fT689q1c97peoWa/JPbrEgN1XXnlloZdXry52X1zs8zTolyyqLXXieIp2a5CXcpCO+ed42ybeEQFy6ritzQ1RtoVt+NHXHnr8bXnH8tSQM9etcwr1yvksopQvof4aKKe9gf1dG716YMQHI34vLzMwN1LsX/JbwLcWf+T3LEb2e4BfyuzLr21Ri4cyiJzHvNufoNhGttMBBxzw/UAa1b3JDOxzchrZ2he8kIy+a3smnn3FvK/cnnTe9OO02gechq3TjGcfwF9PuJE8sdbioe0gZTcFdb3R9XhE8aa4xXPrfkneQLWOJeoL9e0LURep5SaURS7semEOsdB1P2iL3B7KUZcntfJCR38x6bTBBRtxcUPSQo6VC+1H0o1ry3eKvbEhN1z8Afpf/hYZP+ufbzrQgSz6YhuPYE4l+zdELPgpxYtS2w27+s8xKOPxGJ3K2OfQU6LUJyinnvEZrzmKwJY+s6Wu9bUd5aJv20Dd5iX6GW3uYmMTzNqZkTstn8H+bKFHXfZt+vHxmyoWiFko9vXi/Cr000fj6qh6gP7Zn4TtD9CPXClTwj4h2U+oiw5842mqSxcvrl577bXkG4v6UKm3Z2cGREU+zp8/l2yeP39+9dxzV1ZXLl9K9q5eu5rGmXZm7aXxsMxzfKfs26NXsolPctwRt6+3Rj40i55P8lr6WnUpj3Vb9Tf1tYZRfXLkXFf6Sx7jvLwJWrED47dvgjhngpG9XfPSQmyXGuTHGGIs7O/im/p3iX+XurNo6dglfto+Ev3Bvkc/tC/aTyB4EHZ7ZD874IADvh/Y/I74BMEk4mTTA3I9ZP5xHVHvqP6+MGtnLp79YJTbXaGvJ20HYOtB2fG4Vh5PsFKPB8GTPAGX1OsH8KKeGuQhV4L68cbXi1X2uXgtqZR1PxL1ez6Lns+bYBsd+Kd9iMUdYyrzWcvbEeseeGqL+qDkPUjkOI4OOiBGFq18+qwH+PQFnvaif3rzy3dx+BVGyvOTbLnPmGtszFApG4+xF3kl5XiPnmBZQBmI7Q3sq2WdWBahvqijBuToQ3GsRFDXnEHAfgdRP8YyA30q68R4IpUyoGcLGeVagN/TMYORDaGtnr0RfxY1n9RdozLXErwnnqDdmdNp+9wHWLjKxAJXXOhav/7Mq78Q/aYGXcRXiDZnm/sU4+93adEMP6JcDWUMHIOoV2JB+8knnkz73x713b0C04t97QFsXrx4MeXi008+TQtQIPo6Arl/9JFHV998m5++BNSNBFis/vzzz1fXPv8i5TLyNsWm9Yy3Va+Xa/PVsznyp6e/hHOX/SOCdqGtnLfFtnkU2InzJvrsA5Fa6PHAiD9Cr75+l9dTUg+9dpGnbY578iXK+j3sKz9sa7QNqEcfkNRFXJFnOSSQMf+2idcvrXN5C1n+sCh2wAEPEvfftXUQJ4MSPZ4YTZ4zE/GMzCK1TGLria2ss/YjbZpArhfXWs849pMGPuzqxyjeWZT5LjFjB5mRHjDSI59tjUSN1yJPkG4jLIe8qPMvR5R5UytZXiPtaYMTbzyOQB60+JYhh82aDJjN+yZo2ZqFPo309PjGVMq0YiXX3Pis2yLnrZTXNyn/kuLD9zg7N8suOLVAbozVm74RiDlf9P3+6EmLM6mcG8P8ZMeX9y4KzSV5lBgD3tDXxkRsL2x58e9FKHYg/JXgoYf6wn3bCb3YYYseyjyGtFX6AJBH/wzQQ87xEX0cR6DbmLWjbepQt6zTg/pKn9GBPuIxN8hIoKyzLUZ68GUUE/yeHnXs6jP1exRR40PkUqId7b9syXUkynnqiR+p4BdH2fen5llc5roFsCD1u9+tnwjk1wPp2+zbXyPyYS7TNlvAAtDdL79MXMdnRK0tYv04fo1ZsP/d0ld/l3QsuQg8UdPfw0iescF88eyzz6ZfVLx+40b6lUVyVfrXAjZYjH9imRd54varJT/opW7MHzpv3ry5eufdd1cff/zxvdxvE9OmdTZBK2ZszuSjhm38JT/kzD4T4XiwHwG2Ug81vv7J49jxgn3KsYddbZR6yuMIc9eTaYG6vfyVvtdgf6zJ6NsII5kWv+c7GNmXH6mGUqbsG9uC3NEHJPpEvEbgmL4iKUc9fB/FPwN+pZrvjh5wwAEPDukqZmZC+74C16P7xyfO7SfR2YnQybuH2fzvMumfJk6rv8zasQ0kTqTxQpatN9rQ+i/n628KKeO+dUvgkyfYfHOST66eTGdOtr4aEeWgXrzERX22+MY2gjKAPfwjjh5mc9uTgzerZ4Qynn0B/+KFFeA4f48qtyPIT1ywyJUOE6iS2yt/vJ996tpHHibwy470j1575Bvtx+49FTEDXrPiJp0nK4gd/bdv306/iEZfi81mPvEDnmOh7O+1MQHpOz7aj2tAFj6gLagX21ddlDmGsQM8hk8Z9WNdyiHlZoGvXPCik/olmFvQWevn1K3VKaFvAD2lLvSYc/axx/yG7U1Q83ETzMQCRnZm9bRgjiTyQd+CyjEMjzLPDeQMvm0GAfJqfzXXkSiDZ9+GlKfubFuXYFEMGIexoI8FIJ5EgsfTT7GfjMBC9W/fey/Vp07MEYTOa9euJTkW0p96+ukkswt6vkXfaYeXXnwx+fDhRx8lH8CsfeYsPmpP7vmeGItZxscWvSygffDhh6ntWFCDJ2ZzCEay2OphxG9Bu636MzFQdxP79n36dgny6nUUwH5P/8i/Fp9yxxngWq6cy0eYyc0IPXsj/fjuGDsJ7KJX33s64EG0uVQCfjmX7grnUnyUHgT044ADDnhw2O1qpEBvgnKy2cckNsL9k+l6ktM+254rsxPjPuLJvpxsXmbyb8z7imlbmA8oniA5EXKhEokybzy4kHFhKt6IeAKVALF6UwF5YRZvTLzxpgwZL9wiUa+Gsv+Uxy308mb7RRn2iQ9f4HtiJTcCPqDcuNlS3rM3i33oGGE2fy2YuzFyfn3MnFxxbL8pv80FDxm+wwXYR9a++TAAH0f549UpY5nNNWONJ0P4ThAx0/euX7+xjBkWmHK+0cWrj4B9aRuYV8bkCNhwTAPq2oaAOOFbjq+MIRDHRZSJoBwZec5HzDnkw5uqsh428J/6EeiirnY3gbYBcRPzaGwbP77gE36ObI/aTv6MHmS2iTVCPbYBRNyQOYlxsaWMPEPyJWAM5AcSlnl+8FxADiX41odqoHzXuEug88aNG6tPPvl0oU/SE0cfLfTWW2+v/uf//IfVu7/9bXotj4+1u8gVY2uBmFg4+uyzq6t/+ud/Xv3jP/6v1fsffLD67OrV9IuKLP788le/Wv3612+l/F25fGV1/ty5bvyboJUn/aedL1y4sHrppRfTr9aymMeH70fQP/Tzq5EXLz6bfv32X//tl6tfv/XW6uoSHzG+9fbbKYfk9tKlS2lBDZvbxoe9Xtv34q0h+rFpXRH5+gfFcQNa+ntwjJRAl+OQseTYq2EUXwuxHv2Yazn6DHa5NqQdQS8/8Hbh7wp043PZFoKyVl5Kv7bxU/0QPpTzqsdeb0fS5+h7LV8ct+bS7zP4Ix9xHHDAAQ8W6ewymgDlO1mdJJxUe8CfkUycWCOO1xvH07MzytsM0DGKZybeGezT3wh8kzipSfGk6I2FBI8tJ8RYjqwXIOqLsXPygzwZ4gsnSIiTpSdMT5pRVqLMOKDyOJI8UPIg+DNAFsRYNgU6avXJmX6ylcinbSGPLUQe5LV8orznL3pGQGaXmCNGemb8qcGcoJ/XhXgiIepyn9f46K/LXjoWuIWMT39BPPXFQse+Yt8W2KcfMC5aYLzxNBZxIRdjr4H+xuIWr1rx9BfyLPJ5YcexKtjn21y7Ah/pq4zrkX8i284LE+w7x6AHwMNfdSvPlhgB/LIN4eNHHD/WRR7opzKCMmScqzgWyMX5bxbYjz7qS2m7BHLK6ncP+lrmY1NEPZB+QsRuOWSbefPkMWSe1MFW3cZke8KnDqAc8hwhISt5LNQL2O9RC/Lxc1dEO/SZL65/sXrv/fdWv3nnnfRq3bvvvJuebvp66WPPXnh29cYbb6xeeunlezmSBPnJc9sa5JePvL/+2mtpceyrr79e/fa3v139+te/Xv3qV79avbvYuXr1WlrUfXPRzy8uMueBqD/uYx8Z26sFeY89ynXCcb/UB+Ejv7rInH3t889XN27eTO0WdcN7PC3i5zEOIcOW+F55+eXViy++sNh5fPXJx5+sfvkr4vv16uNlH/3PP//86gdvvpnyY13rl0A+9k2hbC/mGmbrRT77EDmORD+ByjFkmXMPhHwtvllQF2KM1eZs/NMfcom9MmcRtfhncgNPX+KYNz+lXyV6ukVLZlQX2z0Z+PYzfJ3xpQR1enXh0fbl/Eq7wIsEok+QOS2plOE4lpWwPPK2ifdhAU9tE+8BBxzwYPHY3/7t3/5nTi5MRC04UYLaBAXgI9cb2Mq0dABPdCM9PR3wubEiJvb91SLAr59Rl4m85ws8qScz8mUUT9Qx0tOTmbEjlcfYd6sejy1zXwLuR10SiL7qu2XUYz/6G+WF/Fg3Alu0s/ySaHf5NbT8jYBPDlpjhL4k0IHPpa5ZO/rbgheF6FAnuYx1tGP7IB/zLKyvfHk806fQD3oxQS0+sC+0ZODjC3q4gGoh5qaEuYBXxlP6yD7faWHrt/2kJdJm+1CfG6lcL29Brz1PGuSNBSz+Ym585pN8sTUv+Nlqa0A86OIm1VcbkWdxzyeCaiANu3ynzLYDNf9sG/NdgnJj9hgYt/sA/cpD6oWUFbEs8qiHHsrUBaKM+9oRyAv8hZCNdUsYV5mbmt0eeuMHmAeAjMeSsaAHvsf4577HZV1JeKw/Eqjtl2VusacujtHXi7EF9VBv07oliL9sq02AH/rDmH3q6adW586eS9/54hU8iV8ivHzpUnrN7sKFZ1f8SqM5YKse43n6madXVy5fvndtBNGWTyw3v08vY/6pJxn3yw3xQswBfNOKBbTLVy4nOy5eoQ+/tKEdeY8t2/PnzqcFpoWVyiSATepYn1h4Yuupo0UmyyEUuDh3dvHn3LlzSV6+spSfO3c2+U8ZOaCctniceBYd+P/44/kmn3ixSe4uXbyUvjcIrBtBXHEMPrnkCVvk/z5/j2RKyJfnMRRz534kbYNYT4KvH8CtkBfL2Ve/x9uex9ShP8LjGHP0QVinxavVsxyK+VaOcvoZqLUHQAbfqbOpX8D81fKmb1DLvtCPWIdj251j9rXnsbLot6wGx6pxuI2+y5cH4KMbivwoA2J8jm1IaF/IU//3EXyP6/vq+wEH/CHhkTt37vyek3rvL/hOkPBbJzomJGTQ0wIyTpwtW16EtG+Ysi9OrjVogwUt9v0JbsBj6ejmmFePWvFgh7qgFzPU82UmnpEdZNADv2bHnABkOK7BcnTUZCjDF/yN7RNl9RUdUaaUh/DF8sgHXFDSV1p5M57STgS+cNLkBrsFLoDJfcsOOoyvl3/0tL5VxMW+wA72yvZGx0w7k5fexypj3pBvjUvtmZ9WDqmPbK2d1N3ru8jgSy+/yOBfSwYfazEI6tP/QS83vbZWB7zaEzTEAvTh9u27S3l+qssLM3RQlwUw5KIOwSKX3+/K7f1I6jct+ZMGMTP/3blzd/E/j218sn8AfINa7QOQRxdPb9le5Jpc0L/MWwnMUfeZZ/ITHi2Y/xLmHdT8izlFtuUHOugfyKPHeu7DZ18b2lWOY/atD+RFkFPI9lYPW/IV61CGLH6xL5CxPnA/1o1wbJTnXu3GuHpgbsFWlI1+se+xeY58QDz0D30p+cAy4in9ogw+vqMLPdraBviCHvSW+d8E6MEndOziDyDPvTl5BPwwLvLTalvyiFzMN6T/1IcAZfDMe/SN+hAyPBn2u1Af/fQ/5ZHDH+PjGLmo177heEQvdYyDcuQ5Jt8APZTpp8fss/XcrE/w9UV78CB0QNEvwTUjv0S5WFziWr+aBayHTX0F6CAH2LM98lO/+ZoN0l8Q+yHlQN/0VcCXh54IeBA+oi/qdQvwTb9iOTCHUoRtC7Ddu85qAb/RQ31sQcYszJGwzYHx41vMOZAHytwAeNgrcwrg2W+xV+oWyKC7xrc9a3kFxlvLm23X8q+EfRpbbIFbbLsv1I088XHMuCpBXb9lF6F865oXvu1ayw351afYNsx9kYd98lPmEBn0b9PnHiR4uOKrr75Mn22o5eWAAw44XaQzRG2CjhjxZ7EvPSNkO/kkwn406+S6SE35s5a/H6361JFELNuGPDGwlTyJegzfMoiTBBTl3CIrco7WFxGeGCVOwlIsj8SJzBNe1KPubRH9LLGL3n1i1o99+kte7A/xIiICPjxloRK2mVCnNAIx1fSKfcSsjp6dXWAMpX4uWDAd7UPc/LR84QPQeSzkvo9Yvrg8Gd8j9M/x7VjHH+YB/ODVH8pocxYMIcZ17AM1oIsLfvSAXP+r5QJ5/euJdazHv/71yH4HYQubkYcfcU4zRvg94CPzlHL4TxnH6OBYGwCfyQsy9o9oU1m2kfDNOurxGB4ygjLsYidCGfy1bdRXA7wa33oz+QHIIoc8FOM15/KkWjxsPS/gf0nko0XUH8W7CdTDdl86twF52gfFnLNlTHPjyLYkx04J206wjzx6AO1g29mOEOApLp8Uow514dl2Md9uLZfoS1DJF+7ju/0PO9hQB7Au9tWJHGUQMDZ46JNnXcDWGJjbc3z8EXS9AKSc++iSBDzq5HkyzymlPP4Yj7HhG1v4lkHIgGjftoFsH+1YDiEnAfjqKRFjKEEdfd8G1o85Lv2IcbIfbVFGHerXUOoq0fKbevhT2isBT37cnwE2Wv7Jm9VpW1LHfuB8ShzuS/aJWLeGTeKJaMUlWrGN6n3fwfXfYYHrgAMeHozvYk8A206sYmai1ASyUX5H00MYmxO85IWLF2NcCEmWlRer8qgH4gmZmDzZQfHEx18/IP4KA7FPuRcZbN23rqTuk8bIxr58OA07m+iw/baFbQTQFY8j7HP0GfoVfallGx32hdg/WrofBGZyrMwoxyWfepTF8trFNvlYl7VtOKaswxNU/FW/tLtPoJu5gqe2eE2G12V4fYljQHvyzSw+zMycwPEmcO4iJognYvNfWef7PvXph8xt9EnnO8qcH4mjzDu+Ooc5r7Et5zWoB2SRcVzQNtSFsEk5vsSxgn3qYEv9uU3XssSl3xB1ItQBjFEYH/xYDzloF6BPncQ7AjHGXJbnEvMNz7xFefJiv+9hxN839mVvWz2xb0i0B+1L35HoS5774/hwjCBj/4m+2I9je8V2i2QbRqLthG1qW5ZtDVmvLEce4F8EvkpR3j4jT6iHbSlvHVHzTxLojnLW1y7HkR/jgxftxXYrxz+IsZdxgegLNmyjmM9oH1l14EepD9TKIkZ8ULYZmKm3CfDfmCKwbb+GRz43Qc130CoHxBb96MmCGt/8tOoSL+3YAvXJB/GO5mdk7YutflCDvs3KR4zqEBu+1NCqu40f3zfQlqP+dMABB5wO0je5ZgakF9ytSQ0d0GgSQw8yLTkmiB5fO2Nb61dX+KsaFyOAiZlyfvo+fz8n63RiYivhq/teYLKNRFkk5aOfwJg8SeED5DE8LngsL/nojhc9ksBmD/qCHPpawI7+1BDttGQAevC1hZGdmL+eDG3Qs4O/1B/ZASM75L8GeOoA6KnlWFut/MMb5c14kEO+5hPlyNnWyLBvfwWtWCOU7fkrtWQAduG3bOJbD+jvxSvMTQ3w0GHblHJlrPlj6Vk2288+Gouv/iG3sI8B+Tx216/BUQ+of98wR8xv3syub6C2f00L8Nomi2Uu1BGD3zacAXV4QoJ65AWiHSGP4UnopQ5tRjy7+F4CXeiFjAXom3zai220HWXchwCy5F+9UAnqUI4c21I3dSEAv7Rfg3IAHSWoj4zxsA9tC+vXbAF42DEvLehzLT5tOHZatmaAHoCdUS57MHdu8Y2cunXBIy58xH3zry77EUR89iWpHB+QuaCOPoDIV6c0g6irN95K3ZKI+SnnaWPHT+shJ6IeZPGHsigfEfUBZaIsuQcc24f0Ef1SPLadpFhH3eYaYl8fPS7nNf1BDxTLhDxQ8rAND30lKNdX/ShBXDWbwPrwanapq19lm86AuuRU37WjXeE+fmqv5m8J9VCvBOVQzJvyEnAfP2M/oP9EWcj6+sYxNONrDdTD1rb1W9BPtsbveCjBmC9RxrkNqA9i21AW+xRojQfkan3+YQZhHD46f8ABDw/WZ5nvAZj4JCZLKZ6YJCZ0nmTgV8D4S6jgr6N8Q4kti1/WVZdg0nXyZaLlBM/JwJtHbyDheQwfudpFTkkR5XENI5kZHTOIJ58a9mXntOIRvbiwtUvcm/g6sjPCjK+AvoycfZC+CbHP+GBMxP7+IDGTv9m4W6B+T0fJf/LJ9es0ke7H8TJE1BPzS975aDu5Pwlg0/bdN/gYs7Fghw/N279GUObbb+s3YCXMG0Q8M3U2AflhTADagrk/wrHC3M48jh/KteJVp/XYp57nlghkIXRFHnFiL8aLDOexlt1ZYI/zk3Ebk08MYQNfKJ/Brv6M2rTMwS5QV0sP5RLx227kh7z4FBVlyrmPbii2v9cFkK8DS7aB9azLdhNYV+jXNihtb6unxIyeVtzGZ1yS7QN5bDvZVvEJOKEsW6B+24Kt13C0G1vaEoJHG1nP9pJE3K8h8vWjREtHaSvC8pZO0KoLevXLej0bPZR6OGauK2HbwqM92S+BD5LyUByz9gW2lLsPIYO8sWiDdsWu7W5foP0tZ8ux/WZfQG/0aR+I/ql3U593jdF2GqEls898nBZw+fvo9wEH/KEizfBMZrsOTCdE9bCFPAmVxMmmJE9K7keiDB511S0JfOBklS9EuFn5djlRHf/VLy9oOGkpC3nyimXQcZ3rixtJ1HhQyauhjKOGVt1ZaP+k7YiHxc5pYDaWGV9ndDEOAH2yBsdIvBhji7x9HD5jStkaqDPyB/4orpm49wF92cYf45QXZRz/7kcZ8ic45mknLqohn/4Ca/1pcyIYtdWmMJ/5Q/r5r81+aJ7jmKMS5IV5myfAuOnkG2UjoM85njzvOx7hXA8cAwKbku2OrL459kqU9Rx71hPy5cUcUodzFXyBbzHXbM2t0G4L8mM82vLGDZj76FOJHk8YWw/wZ3TNykj4D9lWxhTBMTklh1FGHcB8AcpivsxZrcwcm/MaRf4usL4+P2jEeGo+UWb7RCL/tIdtYn+H2G+1EYj9ObYH+9Ef5cw929gOPZpF9KuEunoyoMdv8WZ9HNmuYZP4S2BPm7GtbUfaI4Iy5WhDtvQHKfaFqEeUfQHC/7Is9gVg27T6Q608IvqwDfQDPbvq2gY9myfhT8xfL+Yyz98XPIg2POCAA+pIV39ONJInGskTivtekJQkP8qXukU8YYyodZJxH74UZThR5r/ArE+mlvMLOtx41epJIPq8DdTTwr7t7KpnhNOyI75v+QenlRv6bQlsa58LuQh8hLwJQI6xelr+tjBqg9PIbZwHSlDmh+SRcX7Lv6DIazXKsVCQy9kiE0H9/Ir08fKHAdm33B+Yy3nqjI8vs0jFDQa8/MtBPuF0fD4H5IJFPp9Yy/z8NBJ/dBjBfOV8H++7+4T6IWz2xoB9otU3ShhD7E/oXucj25fKPuLYjLbwzz4nyUdnST1oV/+wVfo6wr5ketBP9Bg/5LWGVOYF+WhbPRHKyDP2eCyZHyDPvsN+rCfNIPr4oBF9LvNXQj4U8247yCvbiDLsWI8yQFktjyKWlXIes4VsF0lgE8S60AyirHpOAj0bs772/NuH72V7RyrbG7I/4D/b6ANltFkJ6qDDthXsR7LN43Estw+4b7kU6/Vyg0wLPd42MGf7gPGBXdq+bLddUcvZPvU/DPgDC+eAA77XeNRJTPLE5H48jmUlRRmpBSY6Ti6eiCQv8ONxWRZPUnG/pOP27y9fdhN6fs5gtv4oH6eFXeOdxT7yMoOZ3O0jZvtOSSVqZREjfuyj20C/0MPYKEE5xLiKtraxSX0wqjurexsfSrR06GsL8O+fY+AczyVbbbBlsUfdMzaoE5/w2gXZvvMvOjfPX/aHbxbe//Ssr/7AB7/7XZ6T8z7fG1vf7OQbnPVNDykil1G+B+MA1MOvSPJHNAva0bbGd+3UYPtDvTaOfrJvPds9+kiZ5RGU6ZdAxhzn3Obv+mhHHR5rx+MZ6A+YrdOCce2qB6iHWIg9xibVbOFDbLPIj7w43iX4Enz7o7nfF3bRhW9xOwts1kiYzzLHkvLux3K2otSBn+RWwI/5lbzmg2cdebGNIPjoaQH+DGblRrZ6/IhZuYhN9JfoxTerF5nYzmzdb5EytB12JNtOikDecRbbHTmPLbMc1HQBytDVwoh/WsAHyLydJmr2Wvk8TTxo+9vCtjzggAMePJY5NV+YxIHpBMdJJJ5YuPjwffWS4jvrXqjEulLU30NrkrDeaBI5Hs/99fLx+AQ34o8wilOM7OxLzwizdnbFyM6+/dg1L8CLN0mdp5UzEcdSBP5wIwwYfzPAd+r18rOP3O0Kcxx90W9phFE78bTW3btfJfryy68WndjIPOpan3lxbfe4jKj5BN++sw/Ehai8MJX/ks4TVbl/ZtJmpvWNCTcTvFbpLzLyDUOewkKG/sWcLpz7iR0w5/OtLurmVxL5Bs7vl9x9ubpz5256TRwdxJxfVVy3X43w2xxbpo/l4gbHyLsY5+IPvE3g+Q2gR7st4Jvxt4CMvqArx5/PiTEGUfMZG8hHW8Zsffyl7SjTjnLmBLlRTBHq6AGZntyIvw3si+U1B+R1B4ScRO56vszmBKAD/fuKCz2b2C9hm+qPuiwfkX1Iokxd9jOoHF+xXwPqOIZsI/NOvso2iu1jXe1GWKa/PfT4Nd0lTlsGqvksr4dWrNZr5Uubrfq9ejWfbHPalLYtx6Zl8GO7U882V0dNP2j5WqLlI2iVb4pe7vYJY2GM7Qp1Rd9b+YhjOsL620IfSpRlLdu72n9Q+D76fMABf6h41JOQJ514MvKEJO0D+9IzQrZz8rZm49nXxNfSc1p5FaN4ZvyZyck+7Iww4wd2kJO4MOCiX17EjL4WRvGguyWjb2A2L4xx4zkpjHyZ9TXCOI3ZCzXLS2ijJ5P1ZCplqO9rz+asr2fdPwQ65O0D6MnEK4GPpYUmXjE8d+7MQmdXFy6cS8T++fN5e/YsW8rPpx/lYGEMv7g58aaD+IC+sqWMc4XgGOIbXbdv30nEB+lLZH3fVW+eIRZqWKQzX5LHyLCPHvzzxgp//cC3N1bRvxmoE9Jeq01nEPUZg/rg4SNbchB5NZT5FvpZ6meLXWyYE3QoO4td4hfEuE/sqo+YYlzb6KPOPnIDtL+NPmOJddmP48pvAjKu4hYefaG0iz/6ZB+qjS/HmH3cOSDWB6V/JaJsC/uQmfFpxg6YldsFPRvb8sC2vsd67NPWtvu2OiPQob4aaC/t9PpTDyM/d+W3+tU2IBfY22S+3gf25X8J5oryHDbK5x8CHsbPURxwwP+uSKORiWdfk/WuOvY1CaImqvJ1megfZaPXaHbF/uLZz0X2SIf+7sPWDE7azr7yBrzI612YiZbNmf7Q89cLoJoebmL0cROgq6Zvxlcwk19kJG7OJW/C3fdmrbxRM274HLOlTH1g1t8WCKMXi22OHWz2ZEHNHxfQdvV1jXzzgT7b3ovLeGO6vkGFl29iObauOTRGsC7LC3zx24a0AU9ojX41MeeUveP+6VvtZjr7mW+2+VU69vHFxaERrl+/sfrkk09XH3/8SaLPPrt6xLkf+I4dfLMf5vbhIh0f8DXT119DLCJBXy++4S85ZI5Zf8wcHcRQ8xk7kRdzH2F7xvaogbr4LUXE+tgawXYc9esZzIwN7dUgfx++lNhWL3V28SfWdz+2n/3HuQ+KC1QQctShbowjjivGkePKMQVfGbb2DanXFrOwzWag3y2opyW3D38jRv6AkQz8XfT06hNvjwd6/F3z1fNtF9AXa/5pa1e/Qc9v9I/44CRijzAHjsdyLt8HtFGiFRuy8PYZe8t+zYb2v2/4Pvp8wAF/qBjfMRToDeDaBFZiRgaMJorxRFLaycfUo2r2Q2pjZGc2nhHG8cxhV39n+aeRl5mcYGcfuZuNh20Z22ysM3LI4EvLn5EO+FwkzUI7pV7L2XJTJcUbMsibLm/CvDnzGFKHshBl0baE796MedPG1pjYyvNmLd60lXHUoN0SlLvwUELf3K+hofYYctxHB3sEPm1LgDZh3xgBucDfvDC2fl2LLR+Y5xtcPAnGfi+ntDsLQSwI2VbcfF+/fn316aef3aOrV6+t7t69e88vCXnqQfa10h66qc+CFjqUh/Cd8lu3bqXjEtiwPPbr8gmYxx4jlkdTvH6UP8eW48EuT7ShD+g/Pgvjsf/CQ0cJ4oOHrIsU7NegbLQjqKMPcUzWyPYeAX09OfkzukZ6ThIz/pUwLvMN0X72G8h8lvOg/SrWRZdx0lb2V8og5z/L2db6ArK29aYUsU1OahjpOQ07MTbkarJl/C0gdxox9XS0/DcG+K36+/DtJFD2WcHYmAX1WvH1eCDafFDAP/1gS06YJ/bVZiM9rVyPcrcN0FnmvGVD+/v24SSBrzwh/33y+YAD/pBxb3YbDcpyYmph18F9EnbyxJr31/Xm7OwLh0nvfnwfc6LPo366TWylTnRIXIhw4TMzPja1HfUDb8SifUnkMbW+YHGfC7R44VrbL8tqxzUSytYo+jgCOvPNo4tq3EDiy5HACSD7yd7m/aPEBqEOYd7MIe3vxa+LU0JefLWTem1k3eog1ywI8ZQWi0MST57AK4Fu2irnLpP9E1D39u3b9/QoKzimPNv86lhfEvBZUIBn3Dzx5sICvw6pyvwB/vUiGmT/Yetrm7m8vjiFf9bVniAux+Jx/ccXfWOMsc0g6ruoAs+42LZIPT1ocyQ34oN9yWwC9EWK+YoUF61iHq0TdQDyIpHLuHU/loOyrJSLx7FMEvqwD+yqq/TtJHFadkRs722gvz0dNd5MvV3Qa7PIOyn7oPRh1taMb/vwu6Wj9HsblLrRx3h3ztkW+raP+GtAb6RyLmX/fzeQB2I/4IADHg6kWWjXSRqog0H+MOD+kKJ/+aYsy/T93UduZjBrp5XffeZ/X23Y07NrvBEzdkZ6ev7Ag2o6KKvVpbxF5cVAJPneWEmW6UsNXBipexPol/C4LAfY9qaLm29vvrwJLwmZWKekGE9pa9/QVnz9jgUc/GTr/vZgMWHdT4wrYh1r2jwUqOXdPuQiS26rVJSecDKXlBFzLVZAsTzkWMi6c+fOig/Uk/8IdbYAT1/wT79ZoEJvry6gfe1zJViYwicWkeCjn77gwpl1WQRFxlfBkKFc4BPl2c91v6/BeAR14zwQ42WLrUiUxVjw2bqRkEGH+lqkn9TZBdGnHvSvhqgjylinJGKXzGHMJYCnLIh13a8dS624zG/MZa2tJNuiRiWwW0Mp35IDys3o6unZBCM9I/6Mz6CnR5keZuOe1TWSgz+yVcMuekc2W7q38XMbYB9y/gHRNvvb+jITeyv+BwX8YZ6I89AusP42cVIXP8o5NfrGvse18hkgX2LUdg8zvq9+H3DAHxruzUCzg3LXwetEe/KTABNktoNNzLKv3S3m+ypG8WxzYqnhYdIz03b78neEUf5nEHVsQtYpId+TfCRQXjDEpwWQibyyLr62cstFInapNwvkqeeNGChvzOINXLxBEy1/xIg/QrRXy3eEue+Bp3JciDiumxth2q1fX5RxUT/nqB2vdTZpo21gHmbyQd+yXQHy9EfAgg4xAdTA4wP3ytovaja0bX1s8DQVi0mWlUBvmdcS8KO9PH7m8onv5l5bEj7ZL9DHYp525EPL7j3U4gYs4FGH3LZkBHLKKK+tEsg6HhmjHAvq2W7waTvbL9poYUYGzMi1+JRHnsclOd8Bj82N+1A5T3oMOa9GeQiQE/t8zCdk3iKZa+RKimNnBjP5m9EXZczbrpjVob0ayX+QIDebtEkP6hnFNLIXfWrp6unYJqfUGZFyjI2SB4m4v2+UcW9ii7o1+VGuZ6DukY5dbFAXOzEH7DOv2CYnjZYN58w4p8Y51vlU/+Ncik5kSpSx9nAasZ8EeD39++r7AQf8IWF9JTnA7KQ0wr4mt5GezM468v5xeevvamcW+7BzmpPmSds6rfxTf9NYkIc8wUfipO33VTgGpY/WLe16M8RFADdO3FBDPBUSnwyB5MUbLer14pEPWjKbYJ+6wL707AJ84CPh+/CFxSye7Im6iq5wH3L77WuRC7v1OGr9tAX4+EX/JBaOrcMTTpSLxx7L+uzL1qtBPeQIP7/++suln+dFpBawd+fO3aOjOnIO13E//fTTq/Pnzx8dzQGf+JA8H49n0U2wOMUrjTy5hV6+v9Va9MQHvtFlriJcFPF1zh7MO3Cst3IqsMk3n2yDfUA9I393hfpz/tY3T/TX+E0/yoD7ELLRP/JEf5LIXTmv0hbwnFujPPWhmRwig+195WekR3stbNrus7pGfsGHHN+xDTke1Qcj3+XP6JqBPrewLzu7YtM2Fb16xBbbyrHEuIpjK449KI61B5GffdiczSe2ava2bY9NUbPDXFXOd7tgdE5pxY8fcU6N16XOp86js3NpDaX908r9SeDSpYtpDB1wwAEPFtOLXGI04c5MyD0ZJ7YZPT2gZ62DG4G8d1xvvuHcBcftnBxm8jLjx8jf2XhGMuppyRnPtoh6axdwXsRx0UY5+zyZAXHz6j7kBZ311KcNfPUEzgndGyn2a3FQBq92QzWKG360Gwkd0a8asAGIYwboUv+2GNWd0d2Lad9gYYKPhu8e8/H6lD35JDfi9cVPYBn97SRB36Of0mcAfdx+b3835zH37NPHAAtO6MFniPKnnnoilQEWgtDfajvHEd+2unv3dvN7WBH4/NVX60WnFrBZy28L+HHp0uVFP09rsYjEeCQ39893xMcrlcidO3duadOcM3J35syZ1fnz51YXLz67unz50urZZ59dPfPMM/dyFpFvBvKNSgvEQA5je7QAHznmNOzxTTPyFfOAzOzYL7FJPvWVLb7gl/MnuaIMP51jvXlGDh71jB0i595ESRwD59ucz/WNFeScKvWgz9tik/zsCm3N+ozcLvFFe7STbcec4bxhG9LGsb96XrRdON7Fl03QsxPbqyU3m+cZOWTgj3TNQl2MFymOMduILXLODWVbUQ/foNhWjinHVRx3ltme+nMS0LeIaKvGL7GLb9Tdtr6+nZR92oM22Aalb+hp5bFlvyW/b5T2S9+/j8D377P/Bxzwh4B7V+ajwbjPyW4fujbVEeXz5JP20nEPMxPtyJeZiW7GzvcVOd/HL9Ygy7xw8+JN4qINimUlTx3mzpueeDHnPhdt3jC574WcFG+goKgPsF+2FcclIn8T1HQJeMTaA35C2Cc/+8C2sewbZd53xaa6yqbhOLbXjD77++wrkSP0TOKb/cGbGvp77B/4g5xxWA6QF8g55qiPPE9D9V7NtK/mD8wfX4xpgV8tvHDhwtFRHejFz5hvcnrlyuXlBi8vAAnKWag6e/bscvT7xMfGmTNnUxm/DlkDvvJqJbGyIMriFvXyk1356TTygxyLmq2xZu6jTyXQ0eMD9Od+k78VBrXQyvNM/5wF/jAP6xO6sQsxb7KNc6w+x3lVsl4LZVtvCvXvGr8+7iOP+9DRy1nEpn7bVrQbfdx5w3Ipnh9LGmEkE/X0/O7xZvyYxbYx4R/jwzGiv4wbyOsZF6WQsww+40wd5oSck3vbCLIdLCvbybqRSvRyCUb8bdHzKaJln3o930Z+a7clRzn5L9tMas39s0D/TPzbIOamZ8P+WWIXn3r2SrRy/30G1zFcMxxwwAEPDv0r6y0wM1kh05Ob0TGaPNeviUDHJ9t8g6mNtq3ZSXoUzz6wr5MFekYy8DnpReJEHm+0kKmd8CFl2FoPUhd1JfzxZseLt3hcEvxSxnZyP/IgUCuXWheBJelzDfBFSwaop4ceH397fsAHthltMLJnO9pum2IU0yh3YsSfAbZiW0RYri/cWDREt4K5M47SD8cAQKbl5wgsqrDYwnYmZ+Yk9nfHED7ZZ9Clf5S5MAVRzoIQMuqgvGde37Q1wpkzz6SFJ/phDfqHz+i0jP38DazVkpen0pNV6OGnvNm3b+cnU55K9XGNeOBTZtyC2LhBzB/IzzeOvGrJgh1l/jIk5fjQ+iaYvpX6S2CvBscwMO9slUeveQaUm5uTAPol7OiPW0mZWpkEou8tzMjM4GHSY/wtjPhgRkZs4rPtE9uu1YZSiZG9Wp2IEV/05EpezaeRHepIwPmHMRnJOaYkZB2jULRHPuP4geBDkee+5SVZrs5Y3qIajDGiJ79PxBxvghnfRnrR0ZPRN+TIq23l/qj+CDN1kaEfjc4jETE32qAslotd/B+h1F3zAZmaDyfp10mD6wvG/wEHHPDgMD9jHmEfk86uOpwge3rgyc/i90/4bGZ8mZEZYR92Sj7HNfJkyARbkuXxIqzk13QKT1CbUu3iS5Qy8SLC8lgWKdZ1H9oGMc4aSv5I/iRAbGWblDA3ILZrCXQopz629IuafA3b5npTaKcX96bIT+BsPAXeAy4ZPv6Rt5Z/tAE85HJfPWJMwnZhYc6xq75tQD2Ido77HrN4wwf6Ad8w03/7S/5lxLZt5AHp4HWnEfKiFE9W1b9jgW39i/0bLO7eK8MuOcr0VMoToNzFLBbvWKRi0Qr4Sha2yyfseF2ERa38Kg/fzMsLSCxqIY9fgBw9+uj9F7TkEr+UawE5ZCT8jP1JPTFueOZZKIO8UC6W7QPa0p60D0Rd5mBb7FuPQF8k+ye5lhyrUCw/CV+2Rcw12FWXGOkZ8dW1a64AOiDbKLaT+7W2UlYf1GPOZsjxEcdl5HltE69v4r6y0jbo1ZvlmYOTQM0H7cnr2T9p3yDbIraR7bSLferGPlYDPGkXtPK8q94aarY2xa5+GRvkWGZcn0S8NWjvgAMOeDC4d4c3mpBmJ6x96dl1EsIOKrKa8uJA3Ux+R7tbYjYeECfcSIJ9J+IalfzaMYjHUixjGy/gLIdaIE5P7hDHnODjY/GR4FknXrBFEsi18tgqF/BHvu8Dm/rX82fka49P3kbx4hM5F7GtS5TtgYzy2hnZA7vywUxb7xu7XfAc96e1YIZ+8on/61zn19xmgZ/cfOUnuPI+sN02BT4ZN37pI4ROX1WEF/sExxCv6y2bKljswT/TOnpknwWpCxfONxe49Asfs+08t1jGwpT7xhRhbPhEXZ/KcuGKOMgrrzLmha7j7YItdDzxRF5AY7GMp8JsA+e72iuo2q75FUHOkYnyELbRD5/9iDhOAfyanDo36Svq1A/qS5b1UPrwsMJYIsVYa6RMKdsqr9EMyCG6Wog57smJGZl9Yh8+we8RqOVXioj14LlVzv1I2oi5ZhxBjHnJOQAqecqjI+qJ+4IyfSwhr4cev6VXtHjRz5H9bVDLA4j+jmLv8Vr6hbpHOqR9Q9s9H+Rta1+9vRhqtpVt+TUC9cu6NR96+uGVVBurNYrycQudBh5/PL/dcsABBzwYzN9lPWSoTZ4l8mSG7FHBEY5Pcsd1yFvz65PspqSeOAFD3Kh4s+I+N08SE6QU67gf4YkjXmS56MSNHTeuHsdvbUCWQ+ipXaiVJyfjOilo66TtAGyN7PT4MS/gpHzWT9q+ZQMZ5Whj9u1PtXq0Oe1rf6K9gf0x2pMiythLjPhgVqa0XUKZnlzk8UTO7Gt/ddzfR7UvkXfy6xgSLJj02hFYP4/5/GoeoB66yrxFu1IL6KDtQZRFZ35VMXGO5Qh5eIjWVPNEEx/fLxd8an5QRlzPPXelyVeGrXMSsJ0BfHzEdpkPQFl+Ms2+kcvRx0LXzZs3E585Nj/VxQJWnmMtO3fubPouFwth6ECej9PfvHlrdfv2naTHXAp9b333K8I51nFKXfQZbwn4yEVQv+YDRCz43IJy5sh+yVbKeV77twtq7VSD/rQAb5ZK+VaM5THx0g/YWqZcBL7aR8k15Hk2nmshZHo5mM3PPqFNc7UN0FHqMd+RWuWS8Di2iW0Q9+2XXiuxT3npi/7FdnLs1dqK8VSOwxhjRK0sIvJjjCVaPOr3eAB+Tabn2ya8nt/7hrZ6/omeX6P6M/yWTI+3CfDf/tyLhX46i+ibOmvzzi656yHWxYbkcYkoIwHzIvXGvvuOf2TUAxz3m+RxF3C9wPVD9OGAAw44Pdy7SpudzEaDdaRn1s4ukytY18/+Rn0xhJYd4nSCdDKNEyoUJ1X2+et+/GUbKeop88dk68QLcUEVL7by0waZlCsvviR1QcS1aw57GOk+SdsRp2XnYYP9qQXyQj8AXrRTh/5Y9kGArHLUjfo5Zt+nV+BFHd/3NnCM7hIHc0MNljsmAVuIXLJ40moTgF/OMdanjPFe8xee8471arAN1UM9CD/pA+KZZ/iG1fF+5it79+OR5YIuLwKNgAy5efHFF45K7gcyxIFPzm+CfQgd+s4vP1ZScg/EhRyLYRHoYaGKRStywUXp+fPn09Nl/JIii158YJ9fh7x16/bq+vUbSX70MX1yz7mg1QYl8MM5HT97IDc5lpxr/KB+6Q8y5AidPSCHn+pl336JTup7bor9owX90L8WRvwZoEO/iRXCf2NwLLCN52bKkI0+2K+Ml1jjeZhyiPLW+bfXJyL0u4cRH1uz9mblwMhuD9GOeoyVNoLYt51sFyheP8EHtpG6gG0E2S9jO9lPoy/s20abtBOoxVRiE30tzOgo7VNnVG8X3/YR1z7QyvsIs7nZVv+uwD59GOAD46ME5dv4V8bOcS0fPd275MV49N/xX4Iyxnx5/wSsKxz7cX527Lvv+K/N0bX4TxK4Hv0/4IADTg/9K+mHGExUTpglcVHkBRQ3LH58WDz11NPp+y/+xT5OqtZ1YsWOW6icYJ1IofICS3JyjROtpF7oNICd0YRr7LtiH3pm8jKycRL5LW3O2kBm5O+Ib79Bjr7aAnL2Zfbpi2zp74yNFpChP9uP6bPGx/hinDhm9JVty++ZvMxgRk9Pxhhq6Plfg7qgnJPj+UQX5YBclnY5Ns/MQbzSF+cowGIM8xeLTMgK2pTjUieAh07brGwv+wOI8VpOPb9VJV8eelngivVE9vXJo6PjQF7b/GXz4sVnVy+88Hz6NcQakHcBAputWCmHlGd75kz71Uh0kQ+oFgOLVnmxK/+qIsTC140bN1a3bt1K3/FCxwxyu+V2ok7N/xqQ9zxBzuxDEcYbYb0SyBqzhF/2CW4q2AfUz22cqRz7MYZRPLPx9qBNfMZHfPUmKPZn4yJW6xgLMcR5rDw3I0O57U1dtzVgo9Z3NkVL/6aIenp+jezBV6amhzLzDJF3+iBEO9ifIMei/Yxj20doL7YRFG9UaRfAVrKdbCNol7g3wYwufJnxpydT441ijXo31Q1G9U4SMS7jKNEqFyP+KLaZ2Hsyu+RO3+3f6GK8nDawW8ahb/JG4z/Oz457Sd3oLNuL4zj+nZ/JRzn2a/UfZnAtcPnypaOjAw444DRxbyZ10ignuYgeT6CnlOO4RkyUUpwwLXOyhJxIIeTgxwnUSRQCToRcROVJc31zQllekMofEvZC160TKlv1OMHKi+XA4xbNyOj7Lhjpgb8r1HHSdsQoL/vIGxjpoY95Mqf/RZTx1nTN5mQkB1+y75eAR990nAD7L+MhlpeI+u3rbL3wcAwQo2MTXRzv0hbYGdUf2UDHDEodLCQxr8zUr9kvy8yHc0gNlEceC2VcENm/+LXBRepIJucGvdaLdQHtUNqzvZzbALq9AHU+RTf1+NYWbQuMyW3uA98ux+nwHtDHU1TKlaD82WefXV26dCltXQCCSuCT5fazMk6R/c0ygFiwVfsAPGARC1naGjsl1Mf4uH379r3XEM0J/JYvEfyqo/IxJa38lKAe9WmzMk85vnWOgPJQhG0sj/yYI/tEHM9QjNF9jx8EtI2Pzj/4Hc/VkYwjxhL9j2UtOk30+sRMf9HfkR759Af7D0QfkZSx3P7CPmXUU5e5Is/kHbAf5xn4sa1i20D6rq4WRXuSkK/vPbTkSp099OzM6tDnEiM/WvXArO2e/zWUeqm/qY4Roo24vy9bvbwBbbZk4Ee/SuziJ/XUHe1Efcr0fBjBce8YLkEZY5zxHu+5nCekWN8xDLHPOC/nZ2Vqc3MN6oskamUPC7hm4A9hPOX9+edfrK5d+3x19erV1WefXV2211L5AQcccPqo3uUyiUnl5Mi2nPigeCEUjy2LOtQT4eQVJ8FyUrTM/VhWyuTj9YXX7363/is3Mky6tYk3krIi7kcQzwxGcrN6dsXDYifmuYYebxPM6JmVsa/Yd7bBPvKPL/rjGCsBH1tx7NnP8Z/tDLQjxbHjPojj/rT6WAs1+714Y45mgTrk4+tv+ThflJpr0dKNjHJ+RJ2/iLIfeYDclm2HXuqAUj62G+VshW1o3Czm2JbAWIB6o+411nI1wGMBj4+70z/0NQIZyiH9jL72oDxb9GOrfCURqBMb5BG/Mx2PDxn++JHz04q5DXTHem57OSqhLzWU48t2LGG7ogc+ch5bJmmrZXMbbBLvCNHXSMZS0knhpPWXMIdsIzlWyjL6fyT6SpRzXxiPuRSWxRy7X9sCtvZFygHbFo0wIwNiPH8I+P+z96ddklxXeiYaADEDiYEAyapSlaRb3UulHtZq9bot6cfVl/6hVyqpikWCA2YkJhLkjcctn4w3dp7J3S0iB/q7cqeZnbPPHs9kFubuI3/M47FYjeUMdx3rtFNdlp2jeyVu58ToVNta7Xp2HGsf/JC+S9ZVWMf4rWPb8yznmGS9lOtS5a1Q97MA1n7e2v72228Pf+zi4RXf2zki/iAG//ff+0vM20sUPPzaXrKYf8T/ggsu2B8vswly01w3Tnk+osrndS1P1EnPSdGJ0Wv/KpB/HZBsV0mZibys9lTbElXOqZjJWdHT8ith3cifPTHTs5cde+k51x7ia5+0D4qal718byF1OQ4Ya463FqyH4MeHavMqaMc4Q4Z/ueMaoL/aAv8sHtrS46N+RY6Y8bXqeajEjeE6sJm/gG4PVJDJXAqciwR1xqWH9JGPMJpbQJkyUq6wHIKvBeVL5A5+c4U+3nbaeHmYspXLz4ObtuzT+pHQL2Oz6XrSxx7kx35k8ZBre9CF7Y+YrgEfD/LUhSvbw7ebj1dAxgP+U9BqRxkyoWOhPNr60EJQp++JGkuOjnnpHNB+5IvyezyzeqGeGd8K9pBxDvRDOzy3P0Lux8yzVPlSjrAsSd4K4kq/sO94bh1lleShPukUrLab8a3UJ08rFmJUB5Az46F+xgNOsWPmK5jJHcnuyc+6kfy9UXWNdGNfq17bZ21HuAvfkeVY1sZEXqt3ZucIaXuOdaFsylknpBz3SS2bz0EvtujYM+4V+MfDqaTtwdb2cOvm/OEVPzLTI9rxljsPyIzPBRdc8PTRfMjV2hg5qTGAmRhyIuRmSaplyedmSXl10hTqGoH62eSX1crMdl73YN1cz3hjc4ycu0b6fypmcXvesJqfVSBnJGum59jYMraQ6bhN+chy7MlTYZukY4AO5DPe+asV47k3j9wVTrG7gvb5YGeGjf+mjT4L7eG48a6+4Xbza4Ag5Th/CmVnnTaQhwp5hdfmcJuLqeGtqBt7qeMBUTR9DNq24mV5UgXyXYOop6+27F4B7Ykbsnh45QPL1Pvjj9vH1s0Vb5fxfWgS39NIGTJOxR//6Ecib4LlmDgW5sZzKOUgtxUvfDee5hVkLEYw7y0gYyZnVc8KRrbcJ9IOc3Es2e88p59Z5jjIh61AHtoIc0BeOVLHufuupOwD0M04n+dxBWlXolcOtHmGGc9MTvoHX4t3NQZ7xAoZM5t7daN22nauj08L2px2ph89vwBtRv7t5bs2VAIrOlptGde1LeUJr0/xgza229bw9kOYtCkBXy1rYYVHpE2Jlgz5jpF/DIgHHy9M4sHW9vYV963teF1wwQXPB172dUo2QklOiHVi7E1Q4tmaDJ6csMXqpHlf/jxbcbsf6PMoF3vEZa/YjuQ87fxxM+PNUkK7GL+gFWtvrLyZOhfOGchTH8fZmJvF0PoVWS1km54u/OdBxwq2N4ZuvouKGHpTSRnXAj7n0VNgbpGRoIw4o1MY95YubaWOc3i9vonJTWzkB3F6C7T1y+oFD8R++OGPV99998OBvvmG1/h/uBV39XMkbtW3c8FDOr4rLEGcsIGHUOaHa3QTS8q27yHCrtPGwtb3nxyL54I4VZnoavVl+0rtAy3exKxerPBl3zkF6Fi1ZwV7yMIn+61jD7Lf+FZgfgEz5PfbGBN9Iz/kiX7JGGAv5sdd3Ic5p3htXm+P2TlGvNoD9PEYHGPHsRjZMrNz1a4Vvr18vKtYzeSekldxVzbfB2a2Uw/14mP7U2MnaM8c4HzAtete1ZE2t8qOQW3HdS1Dh3oqRnUzm3rteqj8p/p8wQUXXABu7ZhHkxlYnXBmclbRk9GapFvgL+kpwjYpl7I9bJ1hNXYjtOyv2MMfZKzYO9Mzq98jJmAmZy899wXtPTa+3CBRxg0XR2jVd2/wIW/SpO2mv/1dSj1wA8YGrrbDJq4lbxIl+NFXbxgh6oB1lMlDHYQM5NbYgIzJLC5pM9jaXh0e1OCbOiDOsYUbU+R648q5dtbNbA/Iwwd81D/99gGN0Ia82a3XFbShDlsAsmnz3XffX9v45JfKUwdox4OfllzK0Pntt99fPXz47eHXCYnF9j2I8PNx2u07v/jIYwWx6dkr0G+/mAHfsNv4EE+BDfx1lgdYlPuDJOjHDm0h9u+++87UrjZu3zAhA/L6GNgGX7A3faE/1FzDj+3mt4eRLdSt2DriOS1uT0I5qzb1kDmAjCf9334FOV75cQSI8zoOgbY41skFfYd+zzyMLh9WWUZ9PqjSJqiFXnkieVZiNKpf0bcCfVqxZWbPSM6KHupXMbMXrPCci5HNK76eY+OoLXV36f9M9igus36QtnsOOQ947nzAeGf8Uyacf+FJggf9tEly7pBoC58Psut6DphParm27gVkSwmu0YOdx2Jk36rtPb49fb/gggv+srB+17qIOnGeihU5s8lvm8gfXVxDmbbbrs/Xs4qZnBV/RliJGdjDn1Vd56Dmq4e9/N5Lj+jJOzf+Izu4eWKjlJsvwXmrLfzcgOWNWN48Y6+bwbwhnG2GaI8s+GivDOVlHNCnTm8aJWzSLlDLKrV8BOrr1Sf4yNp1iyd4sRFgI/KMA7Yk0h+pBWSQKzbFyOIcID/9U5YwhkCbALbAl2UJ2knmAP5Nx82DEVVZ37MfKO+61ePz7fo2ahky8XMEbCQuHPEJO1dQ+1cCOVTx0G47v+EzdvYjbnR6clqgjR9frTBfp4C2tT2xa+UFvl4dZcf404Ny9pA1QvVBnZAxoc9D3nQ6P3mz6bW8HJWBfPJNvCDyzrhjLnQ+rOMwifZJIs/PAXKws4dVPfKtyDI252BmNzhXh1iVM/NrJmcl1vCs8J3q+6jdit4etNsYSY4Vked7o8YudVnumJcc+5471uv4d37gnKNtoIRzAWOd8a9ejllXqVXu3CHpT/p4H0BfzRtlLTvgqzEZQRnH9oue/ooVnnORXytwwQUXvFh4PJsxmRw7UfVwX3Jm9XWC9Np2XPJmQevtgj1xHxN1Yq+4zfhmmPl933HZC624HOPLSlx6sac8qcKbL8BmLnVlHbC95Um5WfMGUFluDr2pHG2KkGVbSPmUeS4lT/JmPUi+rJN6wN8Zj9DHlm98OTtxSTn4U4Fdxo44Zb7MnzkyHqO4JNikA+uF9lZ+QB3ltAHKQGfq0LZ6voIRK3Xbrxbe9MGWncK+VWPRgnYa5+TnmCB3lPE2V88348gRnpGdCeW15K7KALRXLzZ4UybsJykTfnhqPhOWtew7Bi3ZiVG9dhpbz70RrQSs42gsbA/QZ85zLOV58iTfKtlecN3zs1eewPZRHpTR41nRkTiWv0J7M1/mpWJF16o9oxiBlRiKFq88Mz3JN+PtARkzv0f1s7baBpknc+W54yofCFkGJS8EZnpX0bIPfVme0E55bCOv8XRc5nh1/EPWeZ08HIE+WgcpX3hdKdv0CF36cJ/Avowr1z0kn9DHU3BMW3OaoG3Lpr1A33rvvfeuPvjg/Vv04ME7h75337m64IIL9sWtEbwyGa1MOrP62cS3YsfxuJGJeZuJN4vUCOf6I86Nmxjx3U3sbkMdq/bOsFdcZthDz4inxr7yci25WZPYxEle58ZTkmdmBxuqag/XbLZmgE/euimsZdiKXSPAlzI9TwIeZxj53kO2WdXz6qu3HywIfPdLSX3YRU5aMGbwmGtBG8qpz5jO7EMG/ihbUE7bUXvl016b9SFj5OkpsR5BH3vQLvsUdulnzy/a4Lv+VP7aThtwLftuS44PxFbBpnmvmGEHtmqXwB/Kq1/Grj6ArdjLPuRoWxI2QD091gvlAOxOMvbUZ1nr6DlEfCpRD+RNOhY93xIrPDMca9seOpFBHl1zIPJlfqlf9X/GN/Ivc7Oi776wly0jOcYOMu7G3vEDZY5qm7wGxrNFjpvKl2MLpEwobUu7qm0S5fIrQ6ijQv2SNqVtWdca+4C6pNr2roFOUP1+1mBexV3F5j5iPgO+vvnmm0/Q22+/fXjQ9c4728OuZzlfF1xwQR+PZzImnNlAdlIa8d3nxLVqL+D0tv03bZ+XCey+YruXnmfdXvKeVMvcjEnWZ5kbOs6VIZKv1qtDeR7reW4KJduPQEzcVO0B5bFh5CZaoky7Vmw6B9l+pIu6Wp9lq3bgU+sLxJHj5hn/jUHVKSoPR2n0QEKbJdvQJ5BXQR3lPXnaAeBFJuCBXW1jXQvwrsYwsTW5uTmp0Ef9hY8Y93TJn76Yk81GfN6OCeqMA7FUn/Kot3/zMZNNfz8eQH35i5SnQlsAdmJTIu0XaX+tE9Rvvmywje0krkGWVco2VYbnyqmwrvrhtWNLApRb57m0xX7eJ6nv2bSKFT3iXF1iJCdtga/HK9+qLHM5yqexIActjHSB1DfDqt0Vx+gYQV9nkAd7W5RxzBhLrbpsK7JeAvJWaD+5clw5x0E5rlpjTKAn7clz51LtqeRepiJtS12Acu2tfF5L6D4VyuvhHNki7WzF4S6gTyv2y8Ox8rfKxKgOtHLTivVIfkJ9Pco+t0ItUM7DrnfeeXuXNf2CCy54Oth1pl2dUFsTXAt7TyxpH6Jvrg+HLlbtHWFFxrl60r8R9vAH3NfEv+VrTixMrfKUkYtbXlvPRqz+9RHKV/o59/se8nsfaC+UlaQe488RcsPpdzfk5rNeQ25CZ4Anbdob2o6NxABdPX2zPjerB/Kc4pO2IWNFl7A/vPTSk29qbXm7uSGAtxcD6uGnD9BXOBI3+UcEr/1HHeoU1lE28w9eCOhDbeMvC9aYb+02uziKXlyz3DY8eKIfJ6gjzsiHn9ikfwl4IXi33GzxQKb6oB9/3MbKQW0BH5mE+IVMZRk/vovl22+/O3wZP9j0HU67UAbAJm0AW/uJgICysEW7bL/51R7/8FCvvhEhV7Jv5TlH5zqOkrbAw1Fol0T+QPIIv+/KuUzCJ2MGOPe6JedYpOy7BrqweQ+7RzKO9aknK2MNzGH9XrKaL/thtj3Wph7SplPjmLbMfM96zls0qoOsz3FSx5Z8ji/J8QWST/uMt7kxPxLl8mWeoMyVco8BcgXtW7Z5TT+ptkEtu6ptLaSuFrRh5FevrdCOU2JzDNCDLZnf+0JLX427PPZDMIvdCLZFbqUqt8UjGa9aBmFrUpbl2pXjzLEG7wyn/sryBRdc8PSx++hdnRCdqHpYkXPs5Hubf9N9rIwWlDHyZ0/ctZ49YgJW5az6Y59xcXMxo8xFjUUsHz75y1gucFz7y1n117OQl7yjxRDfIDdq3mALzt3sSVyzqbCdm7tsB7iW5KkE7rofrEBfOBKrc2xCxl3BvgOO1cPbXK+9xqbvtm/m3hgA+2ML8NU6rmlD7Oy79EfOs9+Rc3R485A+KNN+MYM6tZsvnM+QUO+XsabN2PLGG69fvfXWG1dvvvnGta08lNo2w9le0JZyiI3iG2+89qjt5l9Ce7yRHgF7HK/wO67EDz/88fBLj3x3Wtqf+POfGXc3b0lx/Oab764ePvzmil/QBK12LaBji81rh2vabb7fDspKfmgrwU9cEvaDCvQTU9rZhzhK2Z9adiHT/mVM6Wf+MqBkPUfk2A4Z+lzln4NnVRZx7mHvGIzwrMd6Fif7+jk4xu5jdGkbYwayLePIubqOtdwvZBtszHEGnMvrL3BSzxjLsSWN4pp1rXowitVqHNOPattIxsgu0Go74k/MbD+3HqzaMoPxoq/cB3q+UU4OE/hY1wjPj81dgraS46LKo9xxVffl7o9yHUuZEDG1XzKOHF9SjjPHGuNshu2HZB5dXHDBBc8VHt+5M0nVSaeFVb4RZhPiXlCN9mr7RmnH2J9z7bX9LG73F5c1Pafk2fi6CHGEWJgkFiw3g17nwlYfQsFTH0hJLHrKR05d/PA1iYXQm7RcCDmyOLoQfvcdb3J8d32z/O3jcxdFF0nbWV7jiv4K7WjV7Y370gNa/idGdcKctWDcTgVylXGKHPrV66/ffjCjTB6mADeM9sEE1/RVN2C0o8/Cy7n9kj5F/7NPwe+muGU3cpFB34d35pv82qfNmrvZshGw3jGKzYIHXDzoygdf1G9f6L49MKYcInbq5AhfbliNw8h+2jlvbHbexIRz3rziDSwe2qFKfRVsWtFtzL766uHVF198dX2+bXh77XrQfs9rrvR3JT/Kgtd22lN9FvLQZ2hX5yjnKcrtUxCylCcljo3D84A9fFqRQSxnfK2YV6zIEfCd69/Mnh6qLytyTtVVgZyW35QxltTjNeOe8Q8xR7GncC6yHB54U65yGDM5xuqNs+Mrxxltc6yBUa56dbQdtRtBvS3MbMq2d2FboupS5l7yT0XaldBG+s8KkKOslTbJfwpsm7FTZpXLtf202taLPeWMl9beHHJN640ngV7Gj2PKceV4o851LMcX0BdpT2w2P71+d8EFF5yO26+n7ITeZLgKJ6mZnJXJDBmbnDr5bbIp28veu8ZqXFbiZlygXISSWLgkFyzIBQweHzxB9UEUiyRtc+GzLUQ9pD6BfZILLouZN2m54LEIWuZGM6kujHktuViqj3OO6k5bRJYn7QHkzHJ41zD/5mmGjM0IM79W/J7xtHJhm3NytPV33ta50Y88fPd7rexH8KqTI7HMfmWfs8wjbVvUAnIdQ/Rj2s+QY0252/WmR5uRxUOj775jHN08PAGOX76rQj8lPv732mu8MUm/uamDDztzHsi5gTquW32Nsk3f7V+iBMjmvPWRyxaQ8cYbbx500u6bb745+EXblfZPYsuB39vBuXGqmOXHWMKHLdjKtaAc39NO6uXJuOjPKiUsS90tzOr3wootq1AOR4iYS/ZB+zdk//TaPgr/Xuj5Zl5mvtf8jTCTJYzPClb5TgXyzU8rR9RRtponx5FzGvsBx1WWc4RX4lrAO6IWj/C8FzfqR3XgnJj32lJ+jtxzbGvFp6JXLkZ6V2yjzj5Gv4Eoa7WxP2Zfs/1Ih8Ae+tMqP1jlq0jfUwblrhfCeuqwzXPQ048MxxFHKceR/uZ4Uq5I3UnJ3yJAW8/3xltvvXUdi/3m+wsuuOD+cNTIzQllD+wlp4+cALH/cPkY6l+xYw9bT9VDWSUX4SQWJc9ZeCu5AYQvr2s958ryPIlybeCojbnwVHLBq4ugC19et3h65y6ALoJ5naQdeZ4E8ryHWX3C2LQwqtsD2nmqHtshh3P6AfnuAT5iC0/2i8Rd+zxCxgM7v/764dVXX319VD4BvvEgB9gUGVufvOlbgLHi2KLMvgfkk44FfhjnlDtD5oYj4317OP3G4ZyyrXqzlzHG5pWP8Pkgj3II3pwXtrbYdXuOwn/nFa5BjuOWPMA1bTiKqh9sb57NH/Ahi4eUPJBCrz7ha6hYBraw+c2HeRDl5iPLZjA2+GLshH5XOcZqxf9jgd0jzOozDncBY2usJPuQRN45Zr3nytAX42ys63keZ0i552BVxh669gY2ZZxbOTBHEtfW61P6lnkxF6Myz0XllQfkdYtWkfYmUoYxORYrbVo86j5W5zG+n+IP6Mmv8kbyZ7qPsQ1eyD7qtX1VWdhtf+GYvCMYU9ogc8Tfi8256MnVlvTjGH+SUoc80vMC8nMdge3iggsueK5w6641J7VzsDIhrmDFlmPsTb3ZbCbCdj1dWb9CLpySmzrAdW74kuCxTa3zJhJakaFO5UEi48Q55KLFzWHemHqjyrFS8vhXHo5Jyst2lkG0T/1eJwHiOoKx72FFDjwzPStQ113jHD34SXvjzbX9phcD+exXiVVbZvFVx7HAD8GDjYcPH159/fXXhzd5Vm0TPCTZHghhz1aGjK3/8lDo5q0q46bd0gjJl+Q4zXGLXMbJig8pC35sRBYPfviooW9iOpdsX7i68eXY9Q1J9AJtQS7ypDrvUO+4TnmOe/QgJ+cp2gDtzWvPt2M/ptQjk49VckQ/b6nxcYiVuLVAO32sdiYop97+0IMybM81JLAZGSk/26R8bXkegK2V9D1jQLn9ynJ5a9vVa0H8JOKYfTTJ8pqHFqhPHS3MZIgVOco6V2ev3phVMp7mpY5bzpOyDchrKevTHs6Jfc2RObEsaSVXxwBZ2tmCunr1YMYzqh/5Qh00sg+M6lbQkz+yDWjfDJUndZ1q+4peoI0tG6DaN1vzAmNgxU54aYfMlFtRbTkVVT7XyK7yKYfwp2dTwvYj3lrX09tC5bvgggsuWMXtO9EFPEsTzmxypXx7q6A1qW4TuW09b9GoPjdoLlZJuTGHh5siiBvJSvBZn3x5rSzlSsoX+guxWEG5WefoTWaP4Mnvm6gf/0uZkIt9kgu/dBfYU27G8BSkLT1Z8Iz0zOoBPCt+n+oP/Qn55I88kl+uW31NmGvqejz3idSPbZsv2/c+4BO2fvHFl4fvXVuJZYIHXT/5yc0bXehCPm8HbWPl9jjKMWtsRgRPku2UwVyAPvOyAtvCT1vt4xrZfMzwrbfePJAPu3hLiTpsgo+PL+IjD/OIof4hD5taHxkCGQv5gbY4X2gL7dEpP3WAMgCfsYKwk7IK6pDnR6jRxQMubDkXxMsv6N9s2N4QE2mf/rZAvfmEbJOwTtQ2wricg1YcW1jh05cW2a84tsj+CvJaokxgC0QsyIH9xn5n36M++xRkDKFV3wG297CXnBWoa0UOvPD1SLTqMjfmox7pkxDXgCNtReZIqnkyV+ZG/zz3OpE6ZujxtuTeFUa6qDvFxpn91M94elhpe6rsBH6nHOOwInvEY92on8DjPNDqo57TPznCUwEfQM9Il0AnsuQftVmRV4H8lu+eq18eQT3ljGmvZ/pb9erv1SVGOkZ1F1xwwQU9HP2QawV18urhfiYtdGx60i5Uo5+bFDdiHN2s1Q0bR268uFHye6eSKG/VWU5b5Hjzpy5IuCBALrK5AeTm2cXWL2b0y9H9gnR5rM+HVLl5bJGL+2r+VvlGmC1exuM+MNNzTP1K315cuD66AAD/9ElEQVThuUuM/Kl1XNNH6EOjnMHTkmvZuT4jpyV/BtvxYOLtt996VLrh88+/OIyfY8GXriMv7fGhB3HiS9B5KGTcGHvwMuaZG+p84jzB3FPj5HzgPMC45voYONdgA22R6VyRcwd8vPX07rvvXNO71/F6+2BfPtSDj18w5IEXDw6dy7BbPfAgE9mc9/qGoF4eiDbye1R2gpj3vjODWG5vqb1+8PObb749yD0Xbv6FfhNTQRm0mif9Bpn/1rysrlq+J9KGU4BdxKnVx10Hs6/rPz4RM/o6pJ/2fcvtU5A80F3FI7GHDmXM4rynP+iC6D/EHnJvA2kL9VmeeQKZp8xV7jlA8mSeaA9pzzmYxWfP+Cnrrm0+BWnbyL5TbT/X5lnsqG/VWTbTP6o/1/ZjwLzk+FkB4wLQpoVZ3GawPfJTRi+ulMPLOK1terjL+N5n7i644IIXC+1ZtYNzJ9tj0dNDuXVMwrlZk9xE81Ec3kx48OCdWze3b7755tX77793Xf7gwNf69b7c4KEnJ3xiAbFAudnmyOYOcrMHcZPHkXo+HgX5YMqHU5AbRWV4TTt1qDc3i8eCNhnDilNktqCeczGyFexl7wr28GfF3pnPdwn6ec9GykcbH+oh6hk3x2KP2KQNCWU7nhM86Pr8888fXa2DN7refPP1J+zWxj//mS83Z5x/dxi/EGPah0rOD84RjnvHu1THOm9S8bbY9ouCvJk0fnCDv/iNTc4dCWRrG3YwL2EL5XwHGXPn+++/e/XRRz+9+uCD967efffB4fjBB+9fvfPO24d5EuhT2n8s0FnjCWq5PpjnRpODfn/9EpvIx7ngY5ysK+r1WH013qMYUM9aQ9zTn+yfmSvrWLM2f26cNj7a04MysM/1EiKHrn0rYzd1t0D9Fv/tQWf2cSn7uv0Sqn5h88yvFewhYxUzXbP4ieQzDuQvx7REHt3H1D0NdbYBxpr4kwfyQR7QB1HeylPmSttscwyO4ce3HpTT41nRs2r/Cs/I1sSIb+TLSixOwWoM7tK2akOVN5I/w2rbU/0T8DmOGHMrYGwhe5W/gnHNGO+hZXvGuUJexjgY+T2SI1biNkNPBvpXbLjgggv+8nDUQ65VOOEwKUluyiCvc5PtAyWJMviYuN2o1Y2b7Xrtka8eZOVEyOS93WDyRsTNR3fc1FEnucGzzk2f5W7+kFk3gdAxE7DxOgcv2oSPP+fGZAXq2UvXSM596ACj+l4/YcyM+i11yPVmqcJ+j5yKmb2zvrvSF3oyKIeYH376058+Kr0BbyV9+eWXj67WwUMP3hTq6dXeH3744/V8w9zCxx3GD1u2+QbavvR9+6XDnJO2j15tOnnovT3M6dlgLoxBjw9YzzzGHIc+5jxsMq/Or1zn3OjcB2Z5Ai0eylrl2qwvK3r0A17yvn3P2GlAFrr45cgE9kDaA+Azjj3oJ+0qX/qUcign9sRcvZBrqWuea6IPrVrrYtqIDcQJueSc8xlol3beFfR9D+whSxkz363nCNV8JZmfJPMGv2XmT3kAe7SJPLo3Ge1T7HMebe/xGPTigKxe3bEYyZnZnP6Bc21aaT/jmcVm1r5XX32t2MN26kc8I9t6yLrKl/ryCOWY4pqx4dxXyfFS0RpH58Ixpo0rsA0+tKDvpwLfiI33TqLls7qwx9jOcIx9vVgjo8pZzckx+o8FOVnN4wUXXPDs4PGodYLgyGCWGNwuHJDldSFxMw3Bn9dQ8nGkPXyWq0dCR2/CczFIyg16EmXcJG4fHfr+kRRvIjce27oJ9JjkpNzSbR3wvEcjUH+XE7VY0dOKfUJfVnjuGit64NnLnp7PVceI774w0kXfdTwnKGcM9uxnfFBX2wnHxIjnaYBxrM98hK36Rz1vXX322XFvdCEGmX6crwfeIoJ4IMW8w7zEgyyOkg+Ltu+8yptS5p4bupZ2K7eUwcvDr1bOmW/xlzrzM4O8EDl3PnXO9Nr5UrkS+uhHFfYL14BjgA77FOfAPNZ8CmKOra+++tqhbY9vBPwhv8axwlgJ9NSyCuTgP/ETlFX5ykCm9kN5bswl2kDkxdx4zLq8TkJGtaMCnhGsn8mZIeXsJetYqDtjTu7oD5J7GUkeybYCW6TMk9Qrq+fVJ67lSbJcnbUdsEwfz0FLfsVMj3bObFm1daZvJifjcw5mPo1iN9NN/YinVzeL9YrvozohD0fJuQ0a+U696waUMmzHsY4d5tieXGQqC3hsYVRXgT50p+wRsJc28GKT6NldMdKhXIhz42NdC9iA/bYbYWZjr/2qbyPsIWMG3mR/7713H7+5nvm54IILnl28nJs0JiIXD8u8npELBYQcriEnSCc5JqQkF6EkFyfqnYwlb6ig5E/KGy/Jm0dxLfpx22rTBeswr3eN7EMt7GXHTM6o/pi+c6696jpHDjJa7ZXt+B1hFg/mg70xs2kUG+og5rbWZoU5wY8RK2cVr7wyj5fgoZQPsjhu59sRqroRuyKatvmgC3sg/XRePQW0yzlVasm0LPuQdkgtpN0tUJ91N/L78wMiicn23V2n9Udk/+QnvEV1u31Pp+tgD9QZg4xdlouMCURsgeV5hORp5SlJfttXIOdFgv4YR8n+CLmHkSyv/MpZRY2z1+bBnNScQfJy3sod18dAP/bCnrJOxbk2EEewImfGY15meBbidi7woUWt8WSZ1GrXQ6uuxtixkJTjaKTDuhEPGNVVaA9H/F9pCy9kfI5Bi5+yJGA8sG0E+LFlBnmUfy5OkbNi5zng5Qy+4gZ6++13Hp/zxwxydcEFFzybeNm/OnLT5+KT55ITj0cmlbqY5MMl/nLeIx42ye/Hb3wIBcGjHGVKlCVhR9qSk12d+PI659HKdyyOaX/uQoCukT7r91pwRpj5PasH2jvCipxVjOKypx7Q0qWOPfJzrr2MH4AtaQ9yrcuxn3C8Ud+Cc4KbO2RWPRXwyNeDPo94RsAm5hHa/+xnPztsXlo+8DYX85JxWAG+bnPn3DbMl48jZHyO9Y2QGDfk1Add2CVyniQOOedSvgpl9JB1m13bOuLNDu2d0yt6cimHWvkiZDyAarWlDP84+oebY6H9Ffbv7CfmD359twxYBmr/oi55hTKIW66PEGVSy/9T0LOjYoVvRc4I1Sd1SsRmhWybZfZHz5OyjHPaAuyRiL/9mLwkmZ/MFZT5WgF69HUPjOTUWJ+LPWzW/xFm9St+7cWzAuWcGp+ZHT25tEvdlSx3TCQJeSlLXsYJyOtK1knKAtpVfas8jrccU44r+VpIOQlkgV49MG4j+S1oL76P5Av1ZHzAStseMs7Kh2bAZiD/qfpBS1+rrOWnunsEOBqzFu0JfuTm5q2udx5/hQ730eb5ggsueDbwMpsxb3RYKJiQ86GTD6HyS2Phs16qmzsWHBcfyY2dk9toMoDHye089No7QaJnvDi2JuNjsSJjDz0AX+7aHzHLz6x+FSt6ztW1R3/bM88rfDN7ZzKsr3LqOM16zqkHvUWdtsqo9cqr1KvLzQrXPb6knt+UMxcxz8H3/vvvHzYnnFd8+ulnh48592S1wIMWPta298aqBc3CdvThBx/D5DujsNkvXNc3519ADL744our3//+k6tPPvn08KX7vL1W5+tzoBweLEHYQdxZI2ayW/loAT8h/K9vWSXQh154jsmNsvny/drOuGuDYEzgtzdP/tEI/iTa1DjIJ6z3hgO5M6Qtd4lT9NQYrJJtiU8ScanXxDv/eEeZpByA/fZR+2VvT0O9vOTEvOwRa+3pAR0znsSId1UWPMnndY9aWIkNPCO+rOvpmaHKH9k70zGyteJUe8FKTJBfKdu16qU6ZpJy/OTXjeT4kZf2gjGBfsZKazxBlMMnj2MK6vmszWAUFyDfsdAucKqMEYgF8UpfesCOY/jFLDagJavVDj5zm7kZ2TKqoz31lapuy7N/Jn+rXh77JP03+zBldwX2W/yA2Ycf/vTqpz/94PDdrNrRos3eJ/254IIL7gYv50LD5OpCled1IqrXd4XZ4F+xo04i+kORxXv48yxNVveVH/Xctd/35c+5fuxp5335zLjHbxbfCuoAi3PGhnM2D2wkvG4BH5hf4HUj0uMF8KALfjbW+UMTHCFtQTflkBtxN+NuckZ24Ru2bd+18N6hXQt8Ef3XX3/96GoN24Ouu9tY3YA+suUCP9hwubljs8WDGXw0DszngnO+AwwQD978+uKLL69+85vfXv32t787ENfZ5hQg234AcT7DCo+Qd9SvBDcOoPbnGeh39vUEMlrxQT52UUc/Qy+89E/6uLIcXxVpGzKQB2+Pv+KY+I0wk7NSjy811pY53iHHbI59xzbl8Mub8owxRP/yxto/znFOGUQ9fLSRsHGveFUot/qfGNWJlTinrhWZPYx0IdecmavevAlmdu+Jka67sGMW55nOrG/Jsb6nw3LtMC9ec+5Ycjy5lpI7zx1jEPyOMeSpA1scZ1471hxTjquR36M6Ac+pMlbkj5A+7g3nG2M6A75gS+bhVMzi0qvP/ANsgY4F7VMHcqUK+637PfsofbbXN+1/zvM+UHUNoOw+gG3sJX/+859d/eIXP2/SW2+9de3XmwefHG+nxPSCCy5Yw63R1ZvsjsWecloT4THYnpo/urjGbdv4S8Lc3j3sADM5x+g5x569/FkBelZ0jXhm+VkBMkZ+W78nRj6txGSEVVv1eeT3qN6Nn4sxm2HO2dyykbCuh9zcuUkakXwcsc326HNj7YYmb2QlNzrwjIBsN+h8N9e77z44bKpaePjwm8NDHz7CyAOvldjzSjuxus70VjAA38+FzBW5AP6XX/7J9YbpzYPdb7/95iFe+EOsyAfExvCVV47/zght4e3d3/3u948ffPHG19dfP3zEtQbkEGMfVPSAjWz63PjN8ieUaexGIfTXJ1cfQsL74MGDQy5bwGb7p6BMW4QxoH9i7ygOrXrao6PKrbAthB1SS2aLb8bb4r/pZzdEDr1xtsybac7tn6lLH4mT4zzHtfUS16N4tGxVl0egDS3e5AOWSZW/Avssb7WxHccZWm0lZcvX400+Ufmznmtyac64BubCPI1Q9Z0C8zySNeoLCf1tIfN1Dmb2Ui+PMefouJDqWGIMsUZRznV9UOXcqV5lQ+hzfOUYc5y5lvpQwE9uuL5SRnvQ8wsYwx7PqA5kbMSsjbDdCm8LK+1PlX0KiDf6zOMMNW4iy5Gz6kPlsy2ETVL2Wfqgfda+yTV8HOm7tmvZQd+kr/FWOX1Qotw5xz7MNb5Bnj/rePDgncOejbe/ePOL80YYLrjggp3wk3/8x3/8fx+dHyYeMJosnORc8FrICawniwkR9OQ4kTqJ9YCcEQ8yti953j46whsOyIafL31GPzLU1cOKnlFcqJvFBKzq6dWrR109zPTYfuQP2CtuIzsg+EZ9bsUfbR7xIGekRztaMmwPj2DBboHFnoW6h1lc9QdaicsIyIDHYwW2IAe4uQC2mcUMvpSPDMuSgLFjY41MSb2QPtumBXjM1QjIgNcbBDb1tQ086uaNJ36llV9hhPg4IzlmfmFjJzb9xObla9vHNvDASv20A8xZwGvtfO21Vw8Pt7aN45b/tA9YBhEDeIE8bCB5WDXqf0I5tOOIn/iM78TB/k1/HsF+CFV4M2cf006oAt/wSduzDeD7yB6F7Amgm7fbNlvYMPf9R48fPUBfz3b7q3W0y/hXWNaqo503AQnXrhGMC4QMrrW9ytNG+OBJgjfPlWdZnlOnLEif7CtAHsBRmZ5nWdZByFAOegU82iCv8Bqe6p+yAXLlS54Wn0hez5UBbCO4nulRRm8sUlf5K1EOHwQqX15b73hpyecIsN15l/OkzDFtqv3IRQ5EnbwV6upBv9DBOOjJoV7bWmj5lVAPZGxa0BYgH3Jtq8+WwQu1xpBtWjzKkqcCH8wBx8yT/MzNlFtnfasNR4HeGh+Bjcjv5ULdrTqgT6lPUE49da5ZgjKI+p5sYH2Lh7giY9Yeqv5rGzJW5uMWaC9GNlSomzatuAF4enEFxtPYQMhMvzivqPXy5BFZ1tkvzFfGm3Piqn6AbEhYl+0APJY/zzBOEj6xj3re/brggmcV4x3GMwAng7vCNqk+uhhgLxtm/sz0OPGfa89e/pyLmT/W74Vz/T7Wnp4+yzlWYkGvRzYZPWLjmZR1yhzBBTY3Gy3A5+bDOHCkTFtbSH7gdYuEuqpOaObPMUA2Gy9ixV/G+UtbLw7y+naJxF8aeXD01VdfBX19eJDERwJ5sDIDPvFAzHzyMGt7kLXFlXL/Wr/5v8XC2Igan1as2Ij2Hr6OgC7a6jcPBPH9m2++uXr4sP+GV8sGyiD7LOfEFvkcW21Ar3wVPKQEPFjs5TntyvhW3cY6y2v8K6hHJqj6qyygfm1IyJ9EP4HXHHGOHv2B4IHsW/QF8igv0Eblykt+eLORNxrJO9fJ1wL55MEoY0TyL/SV7JcteZZhm2+caFfyck45hO7vr+MAr3wtIrrcbFR/IMG58YEPP5APLK9IObb37RjiTZl8PdgOHxxzlbCFfBhb+LSJPo8+bM68J4FDrB7ZZv4BdlY6Bspv4RhZaes5SBnKlIgN5BiRcvzIyznzseV5XmUoF6JtghgQb+Iv5TV5q+fWZ53lmSeuKxnz5PMaVPtaWOE5FS3Zq/r2sl0ejpm7+0bmS2BTkn0Kyj5nX4REq80M6NcO+PPao8R1i6gTyV+xYs+Lhr9Eny+44L5w602unPRaExCgngmyVw+Sp8fngsEE2MKKLYAJvE6iCWRQz2YA8PrsSy+5Ud02BtjCDeZID4vGzB91tbDqz0yPMkCLRz3QOXr0Z2QHBF/PZ3CuPwI5Iz3aMZKhrpEt9Cf6RAv6K7hOok4S2JTlkv0WZPs8z7oRtfgsQ84sLtoEf4tPOa24qCv96YEcgh6fejg6XltY6VP61MtlC/jA/IB93OytAjto44MFiBtSCD/4eBxvc22xIj9buwQ+bTZvtm8PvLZr5ivqkWP/NIbIlCyDB1CmXEA95E3wHuCNM+whBnzfREXLPs6xCTshrpHhDRvX2C2/UA5kHXK2+G85sH0PyOWhIyy0g79iiz0Pg27mNmNY+xzyKMtyeLGh8iaqHwBZkPbTPvVLtpWyDsKnjz/++PCglb7DG2m2A7bhSB/99NNPr37/ySdXb1/nj3ygE93wcISPByh8P92nn3129Sk/VPDFF1dfff3VoT388Gq7bSgDPHj5zW9/e/ihA2y6/TD4NhExHuYaV/23n1CGLdj7/XU/fvfddw/1ibTlk2vfPv/s80M73oAU2ggfOpD561//+lDuwwrO5QXwIpt++tnnn1/97re/e/yRMWQBjhB8UF57/stf/uthDL7++vYxNOSTM/UkbItuYv/Jtd+tOH755Q3xwJk3LflRDXzjRyVogw5+9h6ZxlU7mbOIFXzYlPGWtwd46zjSbqjnG4APAjP/saPy2F4ZeaSdR3OX4DrrJNrUsrymvkfCc232mOfIJDYQZZDn+pllWQ5SlkCvNlKedUA7Idq2oF0VtCHXgPoqGygbtOq1raWbcuqBeoD80Eg2oF2NiRjFRVCvDvilLBvtTUZI2cBrST15nbrzWHmtA7UekFNR48O59SkH2PeAdcz5NYbqkjdhHaj1+phAbouv6nwRwL6FvVhrvF1wwQXn4/bssoD7nmScHEcY8VRzt48BbRtcm7Um1YqZHSsTMPUzOSv+grHP8xyt+DPCio5jsFdcBPyVRKvuGHJhltggQJxTn6CcjZckr3W2gxLGlyN9k0UQYoMF+QCFOs4rybeyeGo3uqr9gPJRnWOH+hbPsZjJWNGhLSu8+GB8ycdHH310a5N9CowLueC7vLiJBJhzXbUMcrN9h9TWPzIP9pvsO1ln37proIcHAz1Qbz/EPq4dC/hjP+UcmA94av64li/rKOONlcqfoM6PeHregg/u/Jip/ZtYVvktW/BHHZUf2KaiJdtYSVxLNfdgi8Mfrv71X3919T//+Z+vfvu7311vom++02rz6+bGGlv5hc1/+qf/ceij8KXtyIeHB2H/8i//cpD729/99vCw5be/+e3V//yf/3xd/svrPv7ZQR782KYvyOOhCw+Q/vm6/ce/+c2QeJCGvhG++fbbq9/+9rdX//qrXx10aivwHDo8uLn2jQd+Dx/ywO9JHkC88Oef/umfDt899+133x3KzXfyAuz7/PMvrv7bf//vjx8WU28+Mj95Dg9x/9V1LH73+98f9BAf28/AwyzazuN4nZ9PP3mcy2++eXiI18cf/+bQF7SVI/Sna75vv/v+kEe+f8/6c6FvAJkVWaYtlRKWYVuLjHWOF+YliHqBDMuhHFvK4ag+CF8cP3nuegvR3ySu6Sd5LVGefVx5EOfSOcDmU9FrmzYZl2Mx8s3yzFULI90rNlUe5UHYQF7tRxwBZRA5OgepCz9bhE4p+6V1HBPYjF32K6j2N+1OH9OnXk7gXwHtoRa/+lqx6+n9SwHhWo3xBRdccDzO38k0sNfEdRcT4G2Zl8llhFn8n9UFKhcNznubB8iNrh8Fg49zKTfCtFN26mDxzg1Dgg0Gm1xuhiA3vfDVTa8yUpZErE+Jt21GCyl1ELz42MJMN/YSu5GeFZziYwUyIOwhdyuA3zzgw9/+7b855Hwv8ObGzRee7zNu6Bf2L46CcnzYIx8r4KOVrTdqAPohbXI8YRs2Mybs34Jzylp9UVmem2tiOvvuM95igeDno2lQC9TTn32wCDYdT96AaUuWa1PlTRiXRL3Wjjp/9OaNjOP3P3x/9fVXX1395jcfX/3+k98fylo6W0g+jv/jf/zPq//5z/9yxUcO37vO8z/8h3+4+k//6f+6+o//2388fHEub//4gAT9VccWj+1XKv/X//V/ufqP//APV//bf/yPTfrrv/rrq9dff/IHIPSLmL7+2utXb77x5uENMR6g4XvaLA4fqfz2m6ufXI/jN99861CvHM6RBf3xuv3vfve7gxze0GKsAvoffdV1wPl/k3Pzdvjm35YrysiN87w5girfnw9/cDsOf7ru4w/eeXD17//dv2vGD/qH//Afrv7+7//+sa3vvff+4W2zr69j9fvf3+4L0B+u7fz8888O8fzwow8PY8S+a7xGaPHo6wq0A53EGMq12XmAMvyA6Ev5xevUZRuIa/1IYJc5cSyZL3JD/v3Yp5Rrt34x3uCXcvzNfLcev1ugvidjJDvrRrLvGj3dK2i1pWwUkxXYtspv9RsAf+b2XCAP3fZx7dAv+1P2Sed9iXL6rXZpW/a9FkZ1IxzTrpW3BPPojOcvEb0/tl1wwQXno7kLn01ETHx7TVYjOSsT7IqtKcdz2tH0pn4uZw+s2DvCqh3n6hEzOcfGv8I65HjT0droUu6DJze2bnY5wg8f9bSDKHOTix43Ahzd4LpxdRNLXW4qrHfj4aaibjJmflas8s7iuwcyNsSsBepbNwyCOBDzEc99A5vI8+rmCv/hJ9/4woOut99++1HtPuCBEB9Tyvwb+xWYI/zhvLYj/pTZXzknDmL7ONM3j67uFtgCEVPA+MR2bHL8cd7LDXFJwKffLfRSTBt+QfPNN9+41rl9pxQ5HgFZaZcxrP0bG+Gr5fhHOf2oBXyoviPDa+qUfQqQ9ep1X+PB1K9+9etbb+iknh6oxwbeHvrXX/3r1evXY4gHVP/wD//h8BPp71yPi5999NHV//G//+9Xf/dv/+7q2pvDRxL5yBttq3yuyf9f/eIXVx999OHVhx/+tEl8pJBNf2tMGDM+fvnTa17euOMtNHKDT8QaHc5Dn3z62SHfPIiDgLYZA/ogDwO/u47T3/zN3xz6xReff3F4yIEuZLsGcK4NFatlPdR4dXHN9+Zbbx38z7gR05/97KMDcc3DSGOI7++9/96hOTliXaOcGAC+O5A33sjx3/3t3z4un8FYGk/GtjlwrAPXbNZqHzTz0WaOlOW67rl5REbag0/kwfmDvOQ6zTm54+On+R1l8Gc+bM8RQiaywSxvK/UzHjDjMbYt9Opmulds6+kEs7bUj+wWvXraj/qf8nsY2deqQ5b9yT4gaQt90b7p2nsKkAehx77X0nnXwP7qQ09v2jSzjfpRbFp1VWbLtsSo7vkE/q7Nt6eAeN3MzXyv66uH9ZP598MPPzysG/TvCy54UXFrdM0mMXHuZLeK2YQH5jbfrte2Te4me9XvFezh9wp6evBlT38qjB0TZxKT6DaRPvkxAa5z85pEHTzKTL9c+NkI4JMbUjYIEhvb3DDI43XdRIBRjGaxOza2vTztAXMxAvaOeKjLeHAkDy2s6urxpZ4RVvSsQn/sZzPAbz+iP7/33rvTB13I5WaNDUMlbjjZILPB4KNY3HDBz2bDttuXzG83dFDPTmyzD8/4jJH5FbTP63Ox5aqdL/tC2uI4XLFhk/0kbKv/5Kr3UUXyzoaOucYH1+R3BlRsv9R4I9PY17infwn9bOWJ8qzr8ZwK5PHGz9tvv3WYI/loHx9Vo7wX1wr081CUIw9KiCPtzSGErPffe+/wZtV3320/vqB8jlUX18hLGVxLAj30cfLGuqHd0CuvvHrt1/YDEfnxRuVypIw3ubh+49ENKufmXl2sHXy/Fbo++OCDw4MePg7JwxFRfTgW57YHGRvEIVF/XeO4liizHNAXyBN+8TYX5djFfPT1119d/finH6/ef/+DQ5y0l/jmWk4dc1kl+OSBaJPrutBeiPxU8iGV5BtU5Mi2rvWSPkLqgCpqeS8nK7nq6UggZyZLGS2+kfyZbjDSPbNtRXdPxsw26qGefsrpN6vQDtrY3zjaB2u/dI21zHXUttpHf6Jv0cfocxLX8D1vmOVF/yuy3cxv83pMfFp2zex4kbASKuJhH2UfyV6RuZg9J2tWa98psf/86U8/uOZ7/8D73vUawFv3/NEv96AXXPCiotm7VyapYyayFmaTFvV7TWyYqr0pUxcom/lzrj22v2s9Aj1JTpIQC7tlbgbqpqCWS24SaIsMNgJAu91wusl2IypZnzy9+pQHsq6S+kcE8vwc4HvFMbJX+Vp6jsFMD3kE8NknahuuIXlboI48IIN+Yv84BurZA8qhr9KvtH/kg4CXfos/bCR40PXOO+88qt2Ab9z0s3lg40A9Gw+Jmz/a2v6nP/3p4SaSB2bU0ZaNBg8hOKeNYw/yOscawDb8AS1/8po2EqAtbzO9//57B7s5Ygs6TgX6Wu21GZ3G3mviegrSF+A5H1M0JoI6Yoi/xJEbFN5qIq/YsIKtD9zwanv1N31MOC/VcqAN+mB8hDLlOx7X/r/+2qFvspn96ssvr3798a+3mms9UgvW4TsfB+Sct4eII8AvCfvov29cx5mP0vH2DNCfqsOyJJD+IjfXA4/WE38eXPGgC/t4GJL5RyYPc3hAwkMr3hiiTBnq5Ry+h988PMSKMcoNAO34aB8y8aPm5histjtVPtCfETHXcLODL7/57e8OfRvwUdMvrvvGq6++dvVXf/XzQ2zhBxzhpyzLgbkwpuYLuflAQB7OJes8rzIkyiXq1ZtlSSBtPAXKmQE9M13n2jLSca7+WdseVuOzAmxwfEkzm92D9vaj8mEnfST7Ev3NflP7WL2WhPLO9R/bRj7eFdLuasPIHtoljey3vgfqK1ploMqRbyT/eQT9lj3g9hCqTezT2ENCrE8PHjw4EHtO3spyzzkj95aOnetoHmxg/FxwwYuKJ3bfq5PIjG9FzmxSBKtyZhh97vnGjrmuHlZsGAH9+up5Um4CvHaBr5R8PVpBzyfKpVz4aznk5qFF8kjZPmlPrPo+w6qcEd8etpwrw/YZ51NijhzamUeuIfqj58dgxr9iozz2NeA4mgF+2gEeBLHR2D5Ktb215UduIDYpbDbw1Q2EG3A2FRvP24cbTTYb1iOXt1Lk1TbOvfY8y/BL34xx1gtjyBF+fEK/HxlKwkaO+MZfC1fzxV8V+fhlhXYYd+V5nejpmtmgXxs9KnwE9PsdaD/+yHd/3XzcbAXG61rLVnANdaE3bbM8Yw8oA7W8heqrOpRxCmjPRpi/4L50vf79+tcfHx7qtHyo2Or+fPhuLz5OQb/RD9spg/5LP+f8j3/YHp5Y17Pf+kqANo4/6Xa/+fMht4xJHpLw8VNuYFPO418TvB6zr1/3aWULrmnDAzJkMD7fuu7/773//kE/D8942JUyT8GsnfFJPRCxhui/lj3Go5Amf9ZzbnvryA99ASI2X3399fYW18HPHw6/rMmNE/ZkzjjPHJiXzA88XhPTPIJsB3kNpb7U20L6eCxSDzAuTxsjG061T1/vQrao7bmuZB+0H7s+Sa020AwtHnPLMfuXZN8zNpUqqo2JVTufJbR8ECN/WrF5GtCO5y3uM+APc3Pdj/XIP5xuv8y7rbmngqYvv7ztWS+44EXFrd336oS2yrfHhDSTsWLLJmOTc5v/ZnLnuGLuxtcm4MLoIllJ3l55q75uDrK8knVVXoJFnzi4+LMhldjwS25Isx5ywyC5kUCmdAzg5+NGP/xw8x1ZEDLFTKb11deKWf2xtt8VsKOVu72B/D18ps/ZnyBk1n65F1bthS/7J+dg1R77Orw8kOI7DHgzyL+wce4NPuRfzCDLfvKT7QGWcUYeY4u+zs3l9nGc7QuqtRMCxk5ZNzJv/vKGbfJBxib7DjzKz9hRz4M7Porm211+LI2NVPqDn62YYQ/1idSNTs5ti/604Ri02vG2ETrqHzH40nhiTx1vcBHzY0Gu6gM/bKCcWFuuT8kH6nWCuqzPc+WZN85nUF7KAW9e55FfC/3Zz35++GgfD7p4uAEqL6gyeGhFLH0QSx12ZT45f+W67uVrIt5JCa55eMSDtkrYJL82pB3GgKN89Fe+NP7Lr748jKPrlo/b8AXyf77me/uttw99mTa0leDzIQ8bfd7iwr8PDm83vnZ4I+2LL748yKq2jCAvRFxsZ7xuybk+zXpinPOJYx1K/PHw0Hb74YRtDvnhOobfXdu8xZK1M3XrM3PYL37x88NY+N3vfn/45U36BLnjLS/00bch+ImZ81USfVJK3oxx4pbPJwKZyOnJsn4VIzmrmOmb1R+j6xQcE4/EyC7qjDV9TKrXSfZhCV6O1AlkOq4rrONI/7Nf1n4IyTcC+qWerVkGlMmRds8b9AOkb8aghV4+ev7PYlPzMsvTBXcP9jc8PLvgghcV7dltAbOJflbvBDfjm2E2USL/hh4VPgI3RvyVejuOCdSyulhY5iLpgunmFaKczaTXdVFVDsA3yEU9F3bO84GQ5CYU2KYS8noL2F1BP9IXiZsNNtv8DD1fJAx99tnnhxuNWX6PgXEdAX0rfD2YM9GTJc85usAsPiN/KLeOI/2PfPQwkwXggcgzfZE+ybnyPfagPz09q2jJoQz/sIcxR12lCscbdTzM4WbYseo49hpsvm/+851OxICbUG5AeeOE7ziC+O6iw6+/XfdxvhOIL3+Gx3gpC3DtOXaj1wdP2KVf2Ik+rrVps2d7UK2MEZC5vf3z/q3vdnjw4J2DXucr43cd4a1hIPWKjM85sL1+E+P8SKHgARc8xuVU4OLm5wb9wn9hffXN8oyDsM7xZnyEeuCbUW2boI4vIf83f/PXh487/PKXv7z6/IsvDg+HAO0r9OPGnxv/7EuQY4nyJzNwG/D+cD0O+KXGFv3zP//z4YETskY2Ac71i/7KgzMeGluHbZ9//sV1HX8hf+Pq1Wueg42PZEOcf3kYgw+vXrvu1z/94INDGX2f76+iXxGnP0Wbll2COscFNkmUc7wZLzfgijJ8gWwDL9fUQdglOGce4WHlP/3TPz1B//zP/3JYP+HLOYFzZPK9XLzZx69Jfvzxb66+/+77w0Pt999//5DLx/l85PcKenzarR89rOhR1l44xx7jcy6M8Yr/x2DFvln9zCb6kn3d/iqQTT/K/uf+FKLcOs/h7+lMf2Z2g5nt1Du+EtpdbedcwDOT/ywi45a54zxzlyAOgvaj2BuXUWySZ8Y7qrtgb8zH1AUXPK/o747vGKMJ81iMJsytjkl9m9iTjes33ti+P8e/VnsDSZnEtYuCi/om60m9+OXCzQJZF3gWjryWhwVVcqFNQu6eMVvBnvq40ecv42zAf/vb3x1+7UvigRZ/mc7NBOfc/PPgC6za0usHewE7Wnkf4RSb7iPX9HX16FPmoIJ+2ANtezbTzr4ND2NnBafEbQb0O6byoY3jugJ+YoLt2MN8AC9zgptDZPkgiwdXX3315eEm+/CxoOsbaT/6xDjvxQgd8GwPwr48tOPtDGSj180ofJKxxI+cqzhSBj88I72r4K99fIkpb4JIvAXGvFmBTejDdoEPeb2CtNm+YBnXnP/5z8h80jdzw/d1nQPeMEWP+nvQngQ2UE6uerCNvICj8uybrkuSuabcdUmfK5DBx/H+7d/93dUfrvsxD0j4RUFQbfa6lp8DHkLSB3mo9Otf//rq1x9/fIs+/s1vDuvCj4/mhxXAh888dOaB1LfffnOt44dDOWOQmL//wXuHt7jkB8aY+m+vxys6Dx9pvI4nPMSKB7ovX/MxDvkDDHE1xtS/VOKMzMyTZE7UWYFJjAlpezvru1vkuqj99PfDG3klhhJfKk8bQbskbOJXY8kH89Nbb2+/1EhfkqeO23OAvBWcqwcgox/r9X41w16yVuXcBUa6V+roI6yJ7mE5p5/e7qttOSP5rTkM/uyTI4xkA+qxMe2VHIfQKbY/y2jZTRnzVGvcUJcxX/H7mNigj1xDtd1oHPfKL7jgggtaeGJFGU0wx+CYCU+oG3IClNxESm4kLc+Nv0T91nbbpPKxhGstm7JrsPlmg8xfgbGXhY8Fm4WbjaLEtYsiR6m3OEot7BFbY3QOZvmZ1fdArHhoxcch8kHW55/fPMhalZ1xPNWeilnc9tIjevrQs0cOV+zN/sKRMcP4sP8qg7rc2CTUxXg61W5kq4+xiqyKtKUHeKif2aGsCsqV4bW2tUC9Yx4wlwDLuRnljRD6Nw9FeLBC3amgKfMScnkwDPHwa3tb5eaNEezHbuciYH70jSO8zpfOn5TBK2WbVfAlqPVVd2Q5DwLlUi5auuAfxcw2KZcYcV1lcc1r+KDXn1fBQwV1J/La82q/7Wo5sQfalrEB8BtDiNySY+ZWyXWJ9SpvMqsuQBk6fvGLXxweVPLQ9Xe//+QwJ5/zEFD/RkA3PDxs4uO+//f//Z+u/vN//n+u/kvQf/5//r9X/+k//V+Ht4lqLHowNh9dy7y+OjxAe/jNNkY++eTTQ/zef+/9wzyDfmJu3+eaL1vnLUquebuJMnRz5LupeCjIA7DPPv3sUAap9/q/w3kCfeYoH1JlfrS5wvJKLbCH+fnPf3b1f/6f/8etGP7X//Jfrv7rf/0vhzj+9V//1YE3ZWAfhI/EjLf6OH/3wbsHyv4m0u8RRjzKm8np+Qu0a8WWHpQxwwoPWInNTJb1PVkjm0d14tR4jeRaN/J/ZFu2TyivlsNv3xQ9vYkZz4qMipFfq9hDximoOp2voN6c27KTuMGfxNwqcc0+I+/DvC+jzjmY82NyoC2n5O2CCy74y8XajjLgJM1kIznZSUx2lntzleTkx2QHr+Ve256HUHzvBEf1ulljQw+5iczNZJI3CNwQWSY2ebdvKM6hFazy4f85WNUzw8gO4ubHCyXeYGFzb+wl83asXck+skW558ZthhX794z9nv7k2CQ/rZyMbIfXMV7tWvUZPscttrjhuSu04mdZ9k2OPR8oh8c+DZBhe9txlLxmfjkFKQsd3DxzU85bKl9//c0Vb45hE3YQR2OoL8TXhyHabc61j7aQ/YJc1Hk6r6GcoyXlAK5TB0jbslzYtqLFSxnysAOfkFmBDYAHVK36VaBL/yrSNv1PXVzD09KP/fJzJK4J23mUuB7RCNTjC29z8ZE8fm3xk08+OfSRUVu+sP6g+9Ea3MJB/6N1FH+ewKMi/th0+CVSvuT9re1HGyQelto2/a2Axz5IHA+/EPra69tblF99dd3HtzeUqH/nwfaLp/BJ6vjqy+2h2HXB4c0s9hmOFx78vfraq1cvX9v7yaefHPoZtmQOEtbZH5NaPrSAXau8+EQMD1+W/zh+bxy+PJ5z30rTLs8l4ncY24/H+/ZxzrQZWsWIl7pmnwis6EqembwZaD+SsWKv9sx4z7F1Rcc5fmQ950mMH/qJlHN/tjsF6khwzfiskG+ljwD4RvaZuxGPgEe78FtaafusIeNnDETPH+aC3AM4fzqXSkKZ7jUk78sor3TMHHnBBRdccCyu56htosoJ3Otc5FzgKh/EeVLCjVNunjivEx03bf51mnOO3qh5c6YMz2ekvtS7fbxlA6YWc58b1Dg/DRBT8pNEroz3fWPPmOwlayTnPnQA6h2rt8fCliPqoVnObNca97O2CeVAQHkJZO6BnhzmMGOwajv89m+A7M1uYnAougXrj4lND+hmrtw2jdscycPkfKOHOinnVinj7rVlrTpjl3WcC+r1ESKmHqFcM0BtfyxSl/615FEPr3/AOB3bzR5YsTt5sIHr2i5jqj+WCeqMVW1/KpTF23cfvL99YfvnX3x5+NL2Hzsxwi5ucvgC9z/8cfvCZ23l6Dnl27jgu8qe9CdhPG2fZDkxsd9IlFnvEX94oMNH7ni4xduOfMSXL1/nQR7ftQVyLNCG8fLw4deHcQQvbx3/y7/8y9U//8svD8TH/vioPG9lfnMtk3EmZvmgXn+0FeR5D9muUmJWDvS1h5/wVntDxrOOkb34O8uPGMnJOM7Q41u141S05LfsruPIsQTl/GyZ7T0aU/qTxHVLl5DvGPRktXAMb4V2KQPfe/c4NSbiVP20k+4T5jChDT1bMu8cXWuVY46TRnWQ9cpJqrjvGF1wwQUvJq7n8JuJXAJ5LeWEb1kLTlxMbG4wobwJk6xjc8pfU7dfDNp+NShv3EYT4ggb/42dOdmCzYV1uT2fATJG9c8iZvY+K/4cm/cWkDGSY/05Plf5PVkjO+4Cjl3HZMK6FZtoiwz4aQc4nuKPsgAylDfDnrEb5bpV53yF3di7bYiJ323bMZH2bJz3Bv5zU88cyRss33zDjf1GzJnYBvXiRDkkH6RfEnNuq45r26d8fCUWlnGdBJL/WCCDeCuLBxXY0oIxP/dNLt5wsW9XX+u1dgnbVf2UG0N9SlmiVXYukElsfvaznx3eBPrhh+8Pb3OR60TqfuvNNw/X33377SH/2qzPnJOL769l8dVor7/+xuO6x/RIFrBsBGRC9Cf5scF2nGMLR3h4cMc532MHfX9tz4ePfi2RWNtvzcXhO+++/vqxDh508fFF3gCD+DgnvD/Bt+vxxMfvtUMbKqzTdmnWTrTaSrO2+A5VrOhtIeWtyGjpFtStyhjxjHSImR1Z39JVeXpY5QPH+mSssh3n2R/os63zVtta7rV1WS+0yzHj3C+BlFeRY62H1AeqDWI1zsdCXcyH6oZqvIQ5H/mVMiTyY45SXp7fBzKO2im1IL/3X86hwDhIxiZ19DDSKXo8K20vuOCCCxIvO1ExieWNDefcMFVywmNC87ySMlYmvYSTWJ3MjhTThPLy40OWIX9m67n14lmRs6Inc1BBe3J9n6j9IrFX3MDIbzCyA6zoWLV3BGXM7AXwkq+WXjZgYNUm8+7GjeMp4x3QTnlsBvXFGJ9KIs8T6HWD20JLlmAepD3A5vzIj7DtK6+w2b15+HMX+NOftrl7ewOWX4O6vfGstAryUjfntMd3CR7IeLTWC+t6aMUYpK3yoAuZfo9iBXw8dNxsG+ud4bXXti/lTXitbq45hzhPqqCMeLb4RdbtDWKC7Hfeefvw/VevvvLq4eOvPOxKoBs+bH3zrbcOvzDId87xByjK6fOMHY5c+8MKjAN+jEAZLR/0rVcPsBMiz1L2syw7+PP2O1ev/OSVw8d5echFOR+LrPK95iP1jBU+7scPKPzVX/2iSXwhO7+8/Olnnx70tGA5so1LEjGsY+gGt/t3bQvlnPgYj5pRDqlDZFlfdx/V11l7c9pCL26JjGEPKzx7YORLCy3eLOO8R0B95slzrznSBzxK8mSZ5coF2zx48wdm5+QWOcYggAzltKC9e6AlS90jGyrk7dnV8gl/65pVY1LbaW+SOWnlpZWbu4L2JHo6tSlRfa2oshOjdr26mb4LLrjgglPx+CHXXUwyrcn2VJxjHib07LDc7/06F3v5+6yDzcCnn26/fHjXuM9F8L4X23P7y172Yoeb2xXAy7zBjS04xw7auplkMwjcKPZu/CC/KwLiY1V+f4Qx7dlEufMevK0cUIYu7GjVswGmPcAWvhNHoJYvPn/99dcObfkF15aMay2PjvuAG3J844EDb3dJ333nR8DZxM8fOolRfBJZf04/ED2d5g1sD/IOp49BE+JO3uDNj6YfC23wBqei5yd94fARv069sF8hv+Vrq+xcGD+OP/vZR4cvMGfd47sUBXodey9fE79eSD/+7PPPr373+98fHnbJw5GHSnzE78svv7p658GDq59++OFBvuOZ84wE44Yy2iqnR9QL2gDbHeQ+Ih7avX1NvHX129/97vAl93wfl3y2A1zzC4Rc/9Uv/urwHWV/89d//QT93d/+7eH4yiuvXn1yHR/WO9qqX+gbZS0fINtkO8DDQ0CsQast1Grn2KSe9lDyWQfdF6qdIOPfqj8FMzl76ZmhpUc/jbv5YU6q6xXHWl/zCMg1Y8mHMLw5CfkgxnLIBzPGHeS5aJWJVj8XthvxrKDqR07tq/A43ydq24R2zSAPsQKjNtRpH/nBJvJFDvm4NHnjWhnUmxdzZW5a/uyNtEWMYtbCsXEXs9y0cIxtx/pxwQUX/GXjJ//4j//4/z46P8CFZjQZM4EykTJp9+AkuzopcfNVJ2ZBcWvxX8XWbvuybfDGG9svu2Gbm3HexJjB2PR8Qg88vdhZT/tRXFb0QHeth3ri7kYgQRnfgXLXQD9fpjuzFdhHRnEZ1QN5ZnpASw52SoJYteTBQ3lP10gP0FYws1c9LT43RaPxPAKbPDZxADn4hU6P1Pd0J6jH19z8V6Jcv9WV1/IAZHHeix/l+t6SQT3XoNrOtbo5QrzpAmiSdgBkKWNry4Ox16/L53E5FumL9gP0QNsGfKMfftiO2w9z+EbW5pttlNOzE178bfVz2hkL9FLPOeXmhRzkHKPNqdMy2yDLMsADvsPDjXfeObTZPrp5Wn9GLjZxE1N9oi5j4w1O+sSRdtoKlElZjQEyBHXypN4K7fAIZZw//vg3B7nvvvfu1YPrmMgrYQv1f/rxT4cHWLT923/zbw4+o998wEdM+Q6r3/52+6XcTz799Oqzzz67+tdf/uvVf//v/3R4qPrRRx9d/du/+9vDLxNqP3oAX/DOLx5ys8d3gP3mN7+5+rhD8HDjiF5jIbARmZRZrt/fX489PnbId43x64I//xkP8G7iqN/8CuP/77/9t6uffvDB1c9//vPDF94rT175wR9//OPhQd7b1zHALnQx1/GxRv7Ig37i0vIF4qEbvtA3kYnsX/7ylwcZvAHHA7ePP/54o9IWW8mRbYn5l198efXd998dYvq4je0fEfaQUz6yCYwVMrBXm7/97rtDHMivtkHAvsR1a1wn5GuBOmRRrx0VxlobKqw/9NfIU4V8I1sg+Xp+YS+AT/s9kkvlWFaJduoA6HA+4JgEP+WMWYhzfUxQlkgdlVe7IXS06uVp+Q/ws2UHcL5SPzqOgfr1yThyTKAbqnaMbAPIsm0L6FE/PMgzHrTlWuIaEvDTzvyRM46UKa+nF+g7GPGdg57/5g1Yr+8Jylv9xvhYX2EMlV3RqjceyE07WjrkJc4X7AdizVvQF1zwIuL2qnIEWpPYXWEPVTF/Hmyv9nOdk+wpWGk/i9tecX3W5JyLPfIDXCh70N89dM0w04EtK/GfyaG+J8s6wCZo1W/4JEBbKTcybt7dLK7Ipx0bHG54t+/nu03+VZQj1/61FKKM9mzeVvzJzVz64w0HwJ+WHDe2gptg+DZfb0+tPESnDl3U81E4y3vy7wroepKo2Tbw+ZFu7JWnB+uN4x5IfVU3D+ayjHjyXVA8DCBvfE8Z31l2ij1bGx4C3dzkt0A5/Yv+Q5+j76Gbctq1oDzsBcS68lImj+PJtz4q0RYyFrRT/+HtprffOvyCHjKxE/sgzilDLg96/uoXvzj8Mh9jRigLevfBg6u///u/v/r3/+7fH760njHHQx4etnzwwQdX/8vf/38Obz7x8T/thza8dPhYJPL5IvgfeKNwQLZv4bbc29f4yltkvHn2wfsfPK6z3hjxYOnBg3cOdvPHLurRaYzSfuKBLP7IwkO0lPXG9VjnI58tH27RD384vHlFG4kHga9fx54v9G+2eUQ//nGbm9IeYsyxxf+YHvVFfW6B/sP3sr326G3TCnWCkRwAn75VKKdXD9TTgzLAyJbkgRwfEOOJo6B+m4dv3gCGiK1t1KX+HEP2E8e/5Z5nX8o+lfBaeysqfwutdolR/al1+APggTKux0AdymlhFLcRlAmZT3Jrjp1fORfINcfk0VxyrHPDXQF7XR9OhX5XVLuTr9b1fKS8JVuMYjNru4KR/AtOx6lj+IILnnW8dL3puzVrOOkzuffARMXGgM1uD07ULgwz8LGa/vz30vVNDD8FftoEyQDGBJ9Wv/feu4cybGNDyBsY+IPNo4+4EBt8YcFrgfbIZVFsgbjBg143Ci3M9KADOeSoFdu99CADIkYJ4kUs81en7grk5aOPPjz4DGFrrz+xaQGz+I9krMRupAcbiavjCBCnlizkYEtPDzKwhzxzTHiNPs6VUfkAPMho5dn2SfiV8an1EIAH4lp+5HGuriy37Si21POwiHpsbvEpC9m1nnLiBg9E/WieErRLpN0QaM2J6LI/8BE63vqgrD7kAoyjH3/0IddN/+Ch0pYffGn3y/sCfmMf863gGrTiDaiH6jwBiKs3E44D+7Xjh3zT1phTJ6kvc/Dtt99f1x0ur/XylsxrB5m0RwdvcCnrWKBT/5FZfbKeo/GoMWHOwk7q0yfiQDm+WIcOSBAT5KEDXtq1QH3OP2kXRD/kyIM/5xltQj+8xpQHVsTsgw/eP5ShH/7ko2/y3V3E45DHazl8Mfv2cHH7yA76jAd6bIvsb755eDjOwMd+ebtq07nZLNCBTMrxXZ/hhY+PK1LOwxtiCh+2yAewnTe+eHBFbAC2ygeQ5zkPqXiLjZzCr1zkPPzm20cfOCaXh5MnwJ7l8FDruo+jB3z++eePcnG4vNZ1+P9xvcBffjmSh4PY45rLG5ctKIfjT67tfP+99w5+tfLOr0fylhoPH9EDn/EClNkviWnmocJ4GccEdcSOOvt2BW2VoR7j7xEQf+00VlnvOXXWewTowCf5cs4BnuM7tmYdyGv7Iva2YoMOSJ4qS9AvADz4laB9jUvCXGJrBX5iI+1a9cjs+Qmwq5cvZSODenS07OvBuNAWSnkJZWe+Qc6vgHYSQDagvTyci9RjfT3eFdBNzkDNN6AO+1s5WwXxQXaVz/hRN35S7xjn2rhQ3tozYZf8rXraZ15bIM/It954YHPmpWUDsuGh7q7z9JcE4smb1seM4QsueF7wzDzk4uMlI7DonvOQ69rqw19xwbvvPng8GbOJZeOIP5vNNxukCmLj4tAC7aHWzR7IRQA5p+pBDjy50Cf20kPc4Kn+sEEmli5Udwnykg+50NnTywIKehuEjEtPhrElJj0e6oFjhDYCG9EhDyB+VZZ6qi2ZK+QAbEkdgjL0cTSHLT54sLWVZ3Wo1/gkqEOusjlSVgngE+c9XcrozS/Ue0PY22TrMzy9enTpm3K08VggxxhWGdTR76gH20d423+x5EEBdmz2bfyCOuS3/Gkh7WjpOhWIxbZ8yDWLt7FuzXu0Iz70i8PDkev2nFPuOGXzzVqiT9QZT/i5hgAx4g8irAXI4Y045NOW7x0brUkzIAM/kKlPdS7Zcnez2ca+zAXAHsqzDn7LAeUQZcgTzhUt3QJZ+J79kTLaaB/llHHUFuzl2nzCp2754dEvgB5zkZBfHUm21Z7kW4U2cBTGijJ8RybyJa4Fbast2gE4Jo+2yZPUQvLP/NqDRztW5Mhr/CDaGSdjASiH5DVexJrcA/oh8e5BubS1PUAH5azhlDu/qRtor1T1JC/rAu31B2Q94Fqf5AGcY0v2Z+YKZFWgh3GY7SuyL/bGqfqo78lCFzbDU22hHBkcW/F3fLX0oxcbkdmbl8lLz0/qzFcFOqnnSFv4ejFoAd3Yjmxo29vfHr8A2dU+ePANv7SNsmyLLEC7Fj1NYKf2tfreKKerIDfIrvLrQy7Ia0FZr89gG7HHB9byCsrhQQa5acW61a9oQ3nmEBvqWo6tkP1mD6TOiqzjvOfT8w784iHXOX3uggueVdye4a7hIB4NfrA62GdybtDn23SdPrn0TMU2zdt4TtexAvyA1mPSx0jO3nqexM3Nw32hbcdxMB5b3ufkolqp1mcbKZFtWdAl+LKsnkPyJMwvOWAzwJGNg5vNSm52ql1A2ciA4Ne2tEUedXBU92pu5Ed2y5ZVzPRpJ4QeNvvG8xQY75bN6IIEb7UQsxZ4eMTHE1tveVGWN2AV6KaON5fg5Tu9IHOV0N5ZnFpAFM2y7Tm52gPqN9Zc8pCLjTFEGRvicx5wbbg9Hh03FdhDfNDbijHtkNOKG3JpAw/1yUN5S14PVb7xybEJcZ5y1VP5OXKddsgnj3IttyypVT/ibZEgjpL+5rVltEmZwHqoZQ9l6TvE3MYNnnNcj5QDPO8RetSVbSVsSdta1GubhA6hPv2E1GN5tpVP2AZkHKHMSVKtk18ZlNH/PUry1zLbCm3CXuNBniTjo48t//RJVB2gVVaRsemh6mpBm1pyZu1XdK/40oI2tdoTSwm0cjVDym/pIWdAvuwblqmXa2yhDXln/OYYzvw/K6j+JkZ1e8H4gYwL5704UU67nn22nflWqYWVuh7h1yr12jgHee71iwr8u+CCFxHNUdub5I7BHjIEos4Vl/bkORPcBhbt/gQPnBBH2MPvFT174L78eRaQfup3XcRyMfMvoZI31JzLB0+2gVrxdEPIZssNuX+h9NxNmZSbM45JyqP9Sn5GPC17sQU92pa27IGZzSs+mcMekIHN2E9efNA1anMqjAs67QenwIdg195tBQFk8nYVH3OkH/IRPYgyiD740kvoZdOPLdI8lk+CG+T2A577BLan/Vs+bx5c8sYVb8Dx8Wne4joXPDizXxHvVn/HHsbDCLRTjqAd9nsuKg/Ish4qL9foxTbnEK7RKdlGXo/yQ7SnrMVHXcrPNsiX17aU2UYb8hx+CX7b4hP92bmXedY3CGpskKMdzqM+8IRqnaQ/2lFhve17pE+tOkkd8PV44UlfTqH0hVjqXysnHqXkqzDujAnXO3OSa2DNF2UV2IcubTYfnGOH5dqUtIraRxI9H59VtPr8Ks7xddbWfma/2BvI1wb9b/UX+gW8yf+84678QG5LtrkUI/0z21Zst0/Tb6Bj+neVn3KchyTmIOckyP27lHNXtYGYOO/Y746Zg543tP7wesEFLwK6PXs28TDZHDM5zbCnrCfBxHgzOTpRonPT6+R/ewK9C6wsAiuYxX+v/NzEaAPf38LPyN8HUjf+uCDlQuXDJ155d2HjtWyuIetd1FoLq5skFjE2TpyzsOXNEq9nQ5zDkxtyN1xuumqOuZaOgW3S1ruAMUmcYi+wTc/mWb0Y1RsTcmqeIfIumXtyTj7xz35C2QpoQ58yNq14UIZ8cg+wqxXPVdCOh1fXkq7l8tBs+34ov6i+BXRSTzt+sfHtt998TLxZNov1DLZv+X8KkDOTlTZn/P3ORHLJtQ8yeuDBH/1kZROHvG0cb5vZVg61HaK+F1t5Es4NtEkS2aYnd09U+1pIe4HnEP475zofQ46zHIvy1DkY+Y4f8sjNRJ1vvbElfvDShvO8XvHlLlDjcyqUsxeUxdF4u36SA469XFFGvX5JgHgTd3Nlvsif55a7LpobjubrLnCsXH2qOEZOT4aY1YMVnh7OaTsCeUJ2T75jT9C/jgExRjZ9saUjc8D5sbl9VjHzYw9feznLfCVyTM701zp0Ob84x5DTnFf4jkWI70GknjrnGuebajOyqKOdMuRFvgRftqVsW8O39YT5SHI9kZyjnKdcU56FdeU+QQzfe++9R1cXXPBi4YmVaXVQz/ioZ/LpTbgVi2wnI82tkxen2/V5RsxiIlZj8rRR4/S0gS0sPi5ELmQQC5ZlLmC5iEnwKEfST+kctGT08r2XrnP6E/EALHR7gHiCc+StxAUecm2eobqBqeXYRqy8GcdGiI2RZWyiIOtXYostxBFezpV7KpDDA6u33nrj2hZuAk6XhR3b92ut9xF8aOWgVbYHZnKNK29tcQ6RH8dyD8aRX9N79913D1+szmaOa36Nb4vLbSCPN8O+/PLrw4bcm/3EZsv28/+9PmJfq/2APuuNQK1z7ICRX9RBLb0J6mc8MznUY69jA7v1W/vhwXZi4pyc445z517qOUq0058VrPi0gmN0jrCHDICcll/6a7wh+0+dt7JP0YZyy1I2uox/L1fkSd84kidz5XEVq7wt/xPKGfFR16uvdsz0jYCsFb/28GmEkQ3U3YVcQL19Ah30yWNBO/trC+fY/7zCuI/icipaOaUs5wdz6ZzigygfMFEHjw+u8mEV5HwjwSsdA+yCmIugnJ+Yt5ifci3J+Snpggsu+MtGdyZdmZSOnbhG2FNWGzcLppMf17XsrpG6zwFyRjJGeijLBcgFiQWsbqDlE/yEOb+AtRe0QTvUj25+Bp+b0wR+9RY0Sb7Vckmkvy1U/rvC3jpafqlj5vMqVuTBM9O3Yg9yVon+wmaJI7LtZ5xT5mapbp4g2quvBeVDwPEEnQrsuqFHhScCGa+/zptg28OiFijv1c1wTtsesDlhjgBzA/W8cUWuenCjjm1skLf8bw8jqWOTznymvBts+eRHBCinr9RcIhN7ennOvpCwn1CO3IRxXInlCs9eQFfrpsJjnqcPSaJVB60geWv/eFpYsV0e+4q5d51zvaWM/kqZZDlt8Fm/kWncIfNDmbA885QkjGuLADprWUXaVjFql+i13xNpR8/mFVvFzOaZrGN0VYzaUgeN7Ju1nyH7EX10NX9pm/06QR3laUP21+cd+DvLy2oslQU5twCOziE+rGIuqbCd4Ny5iWMSddqVeivV+lPh3Ob8lf2B80qWX3DBBReIJ3bnx0wS505i94l0K33UfsqeFV+0z/hKLDKV6kLkhrm1SEm0q7IhgX6otbFA7ptvvnV49Vj9r7zCX362DTt/2eFNiVV6552ktx8Tb1pwE7p9R9G+SF/Pwaqcc/XN2p8j335/ro3H4i59asH+7KYpx07WJzkOwMwe2wv40fGsAFsYS9Wmzb/7zf0KiKVzVc0Dfmw56n9HxjYvbd9vxl9/eSCGjO3XdPmr8FYGDx/p5CaANjd53h7swEd/aeXTPtLLdasMZLuEPq6itj8WGdMZ4N1i3n6QNQM8e9kL9pS1AvQlkVvJecQ+J1kmsj3ABuPJEeS1lHxZV/ksE/K3yPoVaK9IP4xB5bkrnKNn1d9jcNd+Z756GNkws++ctthln4P32H7Q4lUmdTO/XyTgb9JsbsmH4PU821HmeS8/tSztuCuQW3MN9VD7wEqfuEu7L7jggucLJ92FOUGNsDIZJUaTKsV7zFt+7AfTsG/Ttwm+sbevqOW3dqftWQa5YFVy8amkrNre6x4lj+1Bqy2o/njtwgN5g5fgYz7vvvvg8KCLh1HbcXswtT28enAE3X7ghRzkQSzQiWpHRc1NxaxenCOHulZ9y/Zz9ByDmb3PGrRplG/qZv2hArn0Zz+OQ3vGG/3sFHkVyAbocXyfK3NP8DC6fjfV9muN3IjftjO7xR6xOQbEz40vceQ6+wQb+e2tlfZYA/z1mrz++CMfab35xVDkkv/tO5++vT7ffpgAfh7Q891mXAP4t49J+KDrdk6rnRkj61r2wZe8AD7J68pT0ZKTSHnnYGbHDHvYANKfU2wyXrYlZ5XIb5LltsvrLG9dS8B+IvCDMvqVb2BRxjlEeRL1knEwFqKWqbsF+Gb1Vb6gXSsOI1A/4+npEzObV5A6erJW9MCjrBFv6mshZRzrW9pQkeUjP0eY2aR++iQ41v6efORZTt8CM1ufBehPJccK5PrBOeuTRLlHKevrA62k5Ev5kDYcA/OalPMPyOsZ1XnMc+c6579zoa3H+nvBBRe8uDjpIZfYczJBFhPUXUCx/HoW2PRs57iw+cFisPFwfQq5qLDQuKB5nmR5XZxa/MhL1AUnFwtu3pJcTDjPBQWiPGXktYuF+ag2AGzjQZdvYflgikX3aQKbW/aKWf0x2EvOuTjHjmy7tz8jeefqMo+tMTIC7ejjjAGOtM3N4TlwDGmb9j1L4EGNtuEzH2Pke7+cG+8a6k4QrwrKmLeI35azLabOkdQR6xbIJ/MQanhbize+tl9i5M0t5t3t7Zo//OHHq2+/3b7gHPDwPh90aSvtePuLPuP8rA/YoB01186rFcpNJJ/xqDyJVsxOAXJGevbCnnqUw/FYIkeZW/Npv4JGa7LY+uS2dnLO0XVXquttkvOEuIs87CWvyqnX1Ze7gjpGfsGzly13Fb9TMJLRq5vFgXra9mgFdQysxF75LV7KnE89ghW5eyD9XyHnhaScN5xL6gMp6vjDSpI8zjc5BylbvSsgZkkVtZxzcsh8VecyybmsVdciv+PPc+dDy7xu2Vf9bPFUrPBccMEFfzlo3oExUcwm0pXJ5JgJ2RuPu5qkMIMbORcMzeI8vzSRehebXICsh1oLUl2A8INF2k1ALh4e/TJFv1BRSn7PJWW6AbjrSf2u5R+D+7JlpudYO3pjQDmrY+RUoCf7ZoI+TN8Fe9mBPnW2MItf1vdkMBYA4/EUMH4Yd8rpxQccExfGtfbTztg+K2Ce5eN5UP5i45MuHtfHV8F8CZy/ZnATDD/xtL0fP2yBh1X4adtXX33tcZ6B8zztId7U+uqrr66+/fbbQz0P63nLNOMDHw/D+J4ucooM+wW2Ua9tM7hmJHq+9HAs/znYQ9cxY2gGxxVELMlFXbNZrz3PtTrtwC/XVW+6WH9zTbbcviQ/OZfuMxczVFt6cYfv1JwYgxqLXhwsn+mbxXFWfyxGsdkLx/h0aj7OBXodSzmeKFvJGX2AsQHvqg/woasF5IG98z2D9kN1fqlzDPOLX7rO0fOcd5x7aGtsodUY9UBcGG+C6yTHI2RuvK+g3jbyCOrrfCdRJ6XsGckLaV8Lo7rEjGdFxgUXXPCXg5cePnx4a1bISZ7JrQcXASay3sTCBI8M/loONraNd5vUDqcHMO/3Jn94uSlD3ynQH/Tx8RUWGmzjiP3ffPPt4ch3QG2TcfsGjMUKW5ywK9CDTCf1Hlj8iEuPZ6YHoAsfWLx6OFcPOozdqC/cF2b+YCf2AvLZwkrcqHeBbsGYgJYe+gC2ags2t+yGj7hLFbRXVy/+1KOLm7IRzHXaa5l6ON8jz9rMsSWPcnSzmaqgzvjhU69vAvWYrxGoR06VhR20B9jasgkedLXqWsB+2phf/XiWgY3+eiEgrv76IPEZ9Q148bWXT9oTD8Yc18Qi80WuadvKM3J5oEU9bdDFrySypmw238jZdL1yeLMUXdTz5ho/lFHH+x/+sH2Msb7BhnwebnGzos3IgV/70MNHs7EN/eaWctv0QJucG4R9BB3UYQdI/yqQQ056fQtbkKfcCvVwHI17YkH8e3pWgB76gX0AcJydY3farr3EBcr6lo89KIc25/gFiDMyzpGDLSvz+AjIsH8BYm2MWoDPOLZAvhz7POAdxXcUA+rsiz3/sB0e+mFPD/XYA0+PD//tH716+jPAVmJUbYaHtlIL9B/sgdexW2E+qOvJclwAfKq5GPVT6iBAHXyAI0Rd6rdeW1Iux6yD1A16fUTARzzgq3YK5MEDAXQoX1BGe3NAPdfmU1uhCniVl+fA66z36Pl9Qvv1Jf3Jslb5qeD+Rl+JJ+RcQVxdY0egvX0KOha0BeZRYAd12kcdttS11D7d22vkeDgnVn+J+NWvfv3o7IILXhw88dTIiWE28cMHj3yeQ0w0LpB8zOTmu1NuJp3kl+4S6GcTwY1N3SDxUMsJ+1wzjMs5SNtGuOuYifvSM8MsLnvFTTkjvlVd5+AudeAbYxQdbgj2yrPjv7cJQs9KbGf2aDsbHvW5eUvSt5a89H2kb2ZLQjs40o6bGOx7nvAoBbuCGBiXVRA/P0Juv2D+5mFWKyf8RR35zPPXra9vqLYHUYINMhtqHuB5c5mw7TfffHO4sec7y7aPYr/5+OYM8IcRHnzhkxt37Ruh1w9abWd9bla/Ys+xPOiE8EPCf29eialEnCHOqZOXo7YjGyJH5BViPHNzA3FuOWTfoQ3ntodOwSyGK9hDBjhFTubCc7GXXcdgpnNUf2oOEyt9YUUPds5sVc45PtV6cwkxVqQ6tnJMSQB5jAvHBuCcsdMaU/Jmm2w3i4OgjXZU27h2LkCWa3IL1OuLerlGHrTN3TdvUUle55yTRFvnHkg9K76NgB8Zv+obZTmf8UCUdYUj1JrjINdJZKmjF7MV4Lu+Ksc4g2Pkn2OHqHHfQyZAzrk5veCCC14cXM9zN4sklAuBCwtUFw1IfheQuojUSbWCamkG//LeJhaFlRunbbH44x9vT+icb5Pjo4IOen4ci/uahGd6Zv4YlxcNe8V/Vc65+s7NYwXyGLNuyBgTlu8B5Si3hZ6uY/uc9uML8w/gutJIn4BnjxggE3uMr3PkHrLvApudNSc3ccGHjNOpIA8tWSPZ5mSj7aEsc/623tzcpLDmbB9T3N6k4nu4qKccvcJ1ihshHlzxhvBtv70x+ePhe7j4CCPxQS5/CedmCpmsN+jhhgSbkOm61wN18FUe2hsbMYrJKnoy0J+E3diFj0l1neecY/oKAX2w39dz6uU5h9InZZ4C22n/Ocg4HAvbEk8wywXkjbw39VmunL2x4l+P55g8jfQck+sVW0Y8K/4KeTlKjg+O5C9zmrnk2jY5roC2SnUsOLZAHWfyi1b7Wi8luNaPGbABKIc2kHMGsEyfW2iVa0OSco1bJXX0SDsh4+GcBdUHT/mwCsqHVEnIQaZQLjI4qqtHaZd0DvDV+AN1WMY5dh2jxxgei56OWj6SP9KLnFPsumAc1wsueF7xspOJBFY6+2gyccLiWCevU8HE7OLzJPVfcRe37cWuR6fXWPEXqGPGvyqvh/vSI+5Lz/OEkc+r+VnBfccWfZKbHbGXP8hMuadi1R50MQ+wsW2B+p6svWytQKabWuBmfI8Y740ffzzf/5UY1v4GZvGwniNvdBnX7frmhoabRW7y0cGNhjc5QJ224RriIZhvAnizmSB3/uUdnejnQRofZ4R1W3tufEqdLVDXqsfmhPJGUFYl45Fk3/O6tlHeCLU+beQcH5K22NwmYD1tko7Bsfw9zHxeQY1hUuYAMg8+7IC85kgbz6VsV8s4pr6KVlnimNj3dIg9czKzewUrMkY82pGUeayxr9eVRsj6GsccL60x1RpLSWCkf2YbMtCBfzPAqzyOxopzybq7Qvpu7KBW7I4h1/LetaQuod/Y87SA/syftpgHY3WMjXeZQ9HT0Suvfl1wHC5xu+BFxBMrV054TNZM5lD9awXkhC5Pnfip3wOzwYetaxP0JmfjveHnDQGxJOZMrNl6/qSzqud5gf6M4gLPsxC3lDGyh7pz7QUzGamHjSfj8y76hzqQP0LP3lre46sY+WKf6MlyvqO+t5k/JVa0YU50Hsybo2cJfFy7+uflzNa79kX5PJDio4fYydrD8ZVXtrdXeBuLB1XEl4dSfIcXdS+/fPujijxAQB5lflwE8J1dvgXWyj9vdW3fAfbDQS9vYKTfroPUZTnnSepP0IY+AqhDv30krytRpz7L7F8cPe+V0w4gA9tba7nrPOW1zjLI8TPDCs8MytD+U1Dbci0ZsxEZx4yn5+QYyrd1WpQ8nNMWqEMbPRJjcwSZm6R8sxDY9lQg51hZLb5VOfL0kDJ6clKGfJJxhYT5S0p+yNzmudfK8LrKz5w5dmreqKu85nsWkx5oR3uQ9iRWZGtD9QtYBhkLjjVOtpO3B/Rok3FIMiZJlBvXjG/rDSvLnfs5l6xPOS3daWMP8gL8bc379wVjbn6wi2vyIvB75lMC3lP9se2p7UdQpvIh+6N0F3pfFPi1EBdc8CLh5ZzInczBymS+AsZM/XLfZws3tvHdYdeebxcDPCsTwbn5sf3zMrHt0R/BXnJGqDpaMV6xYyU3x/jjYs9YTyBjj7gwfyD7FFlPqx9iM/ain9jsCWSziQRu+vfW8SLjdj+6yQ83ITz04iOHfIyQ7+jyI4bwkMvanYg98sgJD8K+/fb7q4cPHx5k8ZCM797qfeRra8PNz/ax2O0m4UYBclv9HlnK29rchu0AfPD4oMQHIfmRNMvhq/oce60bNssshy/JMdBCr/x5hmM9ybz2cgD5EUHfAOQcWfDVPCFH2c5t5hvK3HCjTVnehCf1bsaVBWUOV3K2Fw9Y4dvGZH+On8lYtQUY81ZuE5m3zFna6biCzBVE/LHJ8poPaRW92Bzj912iZZ+xdYxwbhxHuW6BWBFXjq0xwBu1kmOBmJuPLMv4Q+RwNMftiaqLGD1NZJ/Hpuzf9t9jcBcxPEYmsa3AHwnUMQ/RLy/og5c9jh2zF1zwrOOJX1cETgosGiOwyWNRaU06gEmFem487hJMkNvmcjSJbYOX71hhIL/99tvX9m8fb+FLhFlEucm5ltadcGnngtVaGJxkiR1+94CtLrwtzPQAeNhUYHcPMz252J2j575AXAH+9HKETxAbnRZW/FEPOnqxgwc9rTxT50YPIAO+GmNtpX6kB+qNRfyhHtmjjQJ9AV3ytWzBZuzoxW4E+xFHz0Feey5hh+ctGH9sXbGJ70siTq1Y4pvyapzQT58wPjXW5qAlN23XJ2RUXtqjAx7qWv3haeG773hDqfr20tWbb26/aEvs9E3KOFIHXytH1NH3kMHNSY0L9dTRVnkJ+6Tt4OGtKh5soZNy2qbuBw8eXJffzgHxZ72Sd5O5vRVGHqhDJg/OeJCFra05AnsePHjn0O7hw++uc8rbXzf9O+cWeAHyzX8CX5Cj7fgDKDcuszV4BGSAVlyPAbYD5GRMj4H96BR/9IMjtiAHW4wb5ckjeuWrQIexyxjWcmza+tPNmEieFWAffuHTMe0qsCXneuLdk2cc0+4E9RC2OU56stAHn/ISlGtTb96DB9LuLBPKAamDcvRqm220t9qMDPs0Y7XlPzy0r74kkMGYhq/Xr7El+0cLufYQnwrqkNGrI0ct/ehmTUSuc14Funt1AjnqQRa2cG2cV5G54GgOANfYgHxkz+YJ4wqcB54lECvs00bn+drP7hroJ8fEix9ToV87prEFm1r9agZk0u4Uf9BPO3It0k4BDzooqwToL+rPo+fA6yy7oI1PP/30etyd9yvKF1zwrOGsPzE42YwAz7PwJhemasc24d1MevqxTYaH05Nw35PpubpW26/k+b6wYvPM3pmM+4qrfHvE9xgZo0WMDSbkBo0NCcTmCGIj4lsMEJtov5AbogweyU0VhLzbY+1mY8tmyw0XG1zKOYfcWKuPI3IpW91sj2KtLdSNZBkbdaofUgbn2pbAHze5tCUeI133i35/xV5zYi70AR/N6zlAXgvEEtR69BFLbLrZlJG7LfbwZxttpUz7AesB36/FxxWR8/XXXx/+4EE9f/DgYZb5Re7Wx18/tKVvt9a1zCnnUo2RtkACPyDtS1mnADnKOgfHyki/jR9kHJwPiCnkXJFzCsS8UucWx405geyD6oAAdhtT4pxzDGQ5DzryLRGIP4b5oBPa+trtt0Ug+1PmTjoWtNH2U5G6Z7JmNh4ry9gnZU4g85+5J68czaM5ta3yk4i7+TA/5pW8mNvMSZ4L5Vdo7wzIavFle/yQ8E/CR2imJ2W1MKrr2Sd6ddrq2CQnlHGkfCQTGG9yQW48khOArApzA82wwvM0gZ/6ClZitjfMoXodV16bn1Ow6gt8EvZIK+3hcRzbf+xDkOO9zse0SXrW+8qzgvzangsueFFw1ptcbDzhYSJpARn8VXy7EbmZ8PcGcxhvcY3e5Nom2Z8cbmTA9ibX6wfb2SSxqcWf2w/CbsOJGuQClqCehWQUO+qdfEd6OPYWIepYtPbQA3r+wEOc2PA/bdCfAL6M+hw+sfC1sBI3Yz/T0xsjtHczCJDjQpxABzzU9+Jf9dBGeK6MiuTFJnzBhhYv9fQXZWVbYBvKa0xa8oB9T/T4WuXED1vVhX1strUfwhbt5Egb+mkrZ+YUtGJNW/xHLvNB2kRbCCibesuJGTKxDR2Ww0M5beSD0o5RP7wv8LG9a4+2iwAPf1rQfuA5vmbMBPXGtpUb4kFsLFceR8+NofJvjofDI2z94bXXXr/mv91HkE/fMUepizrK+QJ51irk8DYX9tJGXdoC5Oc7ul599SafHJ0rkQtpAzGoMpgTajwEbbHhvvoHtqV9gjJs4WgshPzZriUDtMqrvNF1niMLIpeitm2h8hBf4JxyKpBj/zxVDv4QZ5B9/Vggg77mPM5cNupj6IWv8lDufAVtff7mAbc8gnNlSYJzYoQ+Yo2cHrCdcZHtE4wvAE9PDnqwubUHwEbnI6Cc6r/zxchWdDiu4as2e42uVh/LemzGhtZ4Nwe9vQbtW3XYxZ4WPdS3+oF+woMsyFxCwOMItEe+R6BPyFeueohbgvhA6hrFXZhD2j2LsH/gL3AsEoP7APGxbwHihE3mgevWGFkB/SrzBTyv/uW15zUO2Ehf1FbB22cJdOADfKN54oLjQT4/++zzk/vEBRc8i7g9owT2mjyY93IifJq4bQf+bT4ea99d+3NM7Pew5VnJz33iafjMwtwjN7JuTHKDgq3WZxvK9cMjfUdiI+FmIqkFy5HjxhRi4YO8hs/6rMvzbF/PW5S2ST3Ajyx4sj1HYBwq4OnVgZRBbBPUQSB1pl+0UYZl6Ms8Um+MgDkd2XUf4I8D2vDIzSGMh/4ajxmyf/d8r3KNo/zZjj9ISJQhF3HKEI4V+43YZGxjb3uwtcn1DzM8xOKaNlvZD1d89J7y3k2jMN+eI0dQblt0nwpkSuhIMk6ScYe48WpRi4fzlJPyPU/fAP5JmUevW/NG79oyzyVl1usRpV2QyPNTUWNwLPawQSgr+weUuau5zNxblz7lufHLmHKeuWjxCMsryTeiEdLHGe8M6e8KtH/mT69+hmPtSdS2xsk8O95zrJv/ll7sNdc5XvVLwGd7ynvygO2oX4nH84AaD+La839vGGvyCIip54DrtO1U6GMSspVfr/O4gl687iuOLzIYvzx45Y9y21f29D/afsEFzyuaD7lWO/qMb6tnor3bCWmb72abhdsLLKzwU2T5mj/zCXZlAt6DZ2YvGMlYaQ9W+e4aq3YcGzf4k1plbBAkN4GeJ1me6MnivFVfqfL04KZCyo3oMRsL+PlrTouUC4/yodSrHo6rOitsl/5yXmVrD8cR4B3FT7upJ48JdbXaUo5+6sypZZZz88ARHcZNedRlX3ga4OEONzn24bt6bR0fpfTZ3BETziFiZKysd9xAOd5SprEV8ivbOnUDeXwbWH4faG3EZnD76BrjAD3XFm8CGkA+MqDUBapPPWhrQl/xnb5zDNmmtjWOSQn9kMxPi8hZi4xZXkPJA1V5EPqS0pZzsIcMsIcMkX3FXFequSJ/EtfwiOT3XDkJy5KnAj/NgbmZ5a/mTDk9tPSuQLshgM4eUv+p+kD61PMfAvBlHCqdA9rjx4jsHznuIeLV6zsJdJh3/dRnr/UPKEf5XJsTcyQyBvB5PgO8PXufFWQ/NA73YTMxzjgT08wvdqVtp4D29vHaH+wTSeps5Xc15+B5yPt9gTXUP77xsIrvK+VTSSvEj+58/TX09YEePvz6kKcLLniR0Py4ogsTA2gEXi9lMutNlshh8uJXr2ayzoU2c8PWAvUs6l988eXhml/l8tV3/mrPgMcf2/cmXTcDPX+oQw4TTg/IAL0JH8z0MMnjj4tHC6t6kEUeW6AOf7i5e9ogHhC+jPocPo36m3GryIUTGeipcYMnKeuTXzsE9tQ8cI4tlPcWlxV/jAsyUn4CPdT19OCLf81tfaxMwENd9UUgB1tAT9cK0JP+IJN+yOJcgU7s5tibj+QByq32U49eyuv4RT/15KG2sw4dbDisNxYQOrVLW2xDnXZX2U8D2PHDD3+8euON21+Ufgr0lbgyh5zTJ4AxdWwZM6iOE3gpo99QXuuQwxEZ9jfl8aX0K7b+5Cc3Dw0g50p8pj1lrjOCPmJdb2xbB1/2Jwi7sXcG29UjyLIsB5UPyvicAu0GxvhUmP9W3I4BOQK9tW8V2AKqX/h8DPALqv2uyvE6j56jXzmAGJkzbeO4En9kOE8hg3690q4F+o/9uZc3fGCs9PRQ78fvkGGcKMdW5df4JeCFj3EKyH1rzaAeObU8YXw4jvZ7yOqtSwAZ2IRfzA0V6unNE9S3ZFOnn9bDu4rMAefGagXGGX2cmxfK6AuUCcrxTV96/aPCOXCV/2kAf+z7oNffMh6nwnwhy3GrXGMP0M89Dz82c6pexmnudc4FdiCz9s+6F9U3fDlnPnoWgO3V/mP94eEUb5kTI+VBrfngggv+EnHnD7kAPPw1/C6xTX7bX6pa4O0E6r78sv+Qa/tL/rZw9iYb4jJaiKkjLrOHXDkhteAC1dNDHXKIfS/+1AMnwBZm/qCHmLQ2X/cN+yW+6DP25VEeFnVQ62nLeca+dUQOx4ydR6CeVtyQT/7sS4D4MQ4q6CvoaNUB9EC9eiAPPqeNCeyp/iTS5tFDrhU52MJxZPMM6FGHtiG3Na6oZyzPxpy2AfJW7YcH/ylnA5WgLfXY1IsNX5JNu6y3Hcj86JN9hFhBPdnPK/Sffu7DnVa/OQXm09yS04wf5fabmhf7KHCugJcy7Du276KLXNKetsiAtEFgA3HgqO2jOURZQFkcKcs5WR717g18I06n9k/8kZBxjo2juB0D83Jun8QWgIyMj/7Wc+B1LQPmUJvqNajXAhn45bxiv2/xzmCckYWMc24qkYEsYt3LG7aPHnIhwzHhuKANcjmu9E/48Mu9H22QxTGhzzWfgnN1I6/6lLzwYKv2VlCGDFDtUI9otb8rYAuE3diXc9ExsA8xXyGHHOovMJ/4Bm/OayMgE5w7D9wl9CkfNmLvKM95bJ0Dzs0FR+QSQ0Ad+tALzKHz3e9//8nVV199daj/6KMPD2XHAvn4cUp/6GH7TuT5Qy7stp/sqf++4dtX2zyTD6r68/sFF1xwHLoPuSAnxx5YZODJSSjBhIQc6h8+/ObWJL03kD1+yMXk+MphcgfckL7+Oj9Zu21QeCJOWybP0ccr4UFWb2HFXxaA2Q03ILa92M30AOSMZOyhZ4tr+6+II9CuHj0HtR7UMvte9kHq9KdV3yqrMG5SC25y62ZEkGfktOKCjcTMTRhgQXYTkqCvoKdVB1bGovpGY5F62mfcEmlz3VgkZrFDDvZybPlkPcjYIpdy46m9kLYBboASytPuHoiz8YEfeXWThA3wIbP1hacQPPjV8t35ULsT2o/+jC36kIls5EK92D+PMG5sYMltL3bngNiio45F8kFsiWe9caIPQHVcWQ4hzzr9gOq1JK99FN2QuQfYoU50UN+bQ7QdPmRwpB0xbLW5Szh+oFNgjPChxvxYjOJ2DJABiHHLHuz12DoHnGMPR2Qox/OU2ytLOIecOgdgB36RL3DOQ66URXtlnQL6L4Rv5s045hH/nSMsF9qBDRD1jgmvE3nteT1ecBvE0nWIc0Cs7OOUnwJyR1v6EzlO2K+Qf8y4dl491ab7BPcb9jnimmSZx9Y5yPMRiAsxRh9x5WEKf9QH3Id9+umnT+yjfvGLnz+eD1fgPFVtPAc8eK421PnLPkJ/JO/UtfDVV19f7zm2X+G+K/DCxDZXu69mXrqd1wsuuODpYpeHXL1BzYSEHCaA+3jItS2g/Ydc+euK3HRtk+o2WX755faXje1mom8n9cjqLcT4S1zqIpKABxnErDdJb3a8/MTNWcIFIReBxEyPMYOvbhSoE9hS22c98tXjdR6BttBfQNYJbFFPqx7AQ51yEr02FbO4AXJIXW8DhT+tuAHj6o0GoL/AW/XBgx09PcoajUV4yBE8rTyDmc9pc91YJJRD3UgX8nqxIW4gc2g8kQnhDzrghyhDbh0P1Jmr3phUljZrA/KwkTKvPfLAzDbANlArj4D5pD44E7bVP0EZMUc+7YjJ6ib/eQG+Md/iN75V/6lPtOIHKK915oVj9jfKnEMpr31x1EeVB0/q89wjflTbc+6nPYQdIh8go4f6Vr7VD8GHTto5xmsc7hr0UXTnmD0GxolY9MbPKozLaG0U6s08cZ4EsIfzapfXrXLbQJkjUduIXjkgzsQn5RwDbCE2yAHECFmnyGvJ0meR56KWcU18RM9/+CBtbckB2Z6yUTwTVd4FG4iffYTxzXWNKflj7K6OOcn5wn6NjJwP0WMfhR89rTnZ3HkE9E1w7nxyH2BvgG/Yj691jPfsP8WvqoscsC4B3+Kq8zj5gZ+HcT4QG4EcIhv79oo9NpDTzPExD7m43nzbfDYGEPd0yH/rrbcO13yFDrJ5MIVs2lxH+/p8i/mKT44VkPwrbS+44IL7QfMhlxMJE0hOIhVMdAzonIQS2+Ty7Dzk4q0tPpYIWAh40k8bJiu+q4tzfMJmJrwWrO8t9tTdxUOujJ3n2AuQkfUi9WR+8lweF73KR50xGgE58Kc/KQsZ8HhDl3UAPdSDXn8CxJb6mT0joAfKRaqCBRE9rQ0XGMkwZsgQ+N3ajM30KAseqAfk1EU/ga3Ior7lc9o8esil3yN7kIO8lk+U0x5ke+1TJzI4pwwizhzrAwH4HG/VXtvCQ/vUZ7m+CMqRl/miTL/Nd+qiHtiu2gHSvxo3xrrjnTr09vrD8whjSryJj/7jL2jFqwIZtKux68XVmFLWygl1tKv9SVCnfcD2KafK1E/nbPyF0CV6D7loCziq2/5Jn7P/Vv/vC8wL2nEOkNMbIxXGBNT4EBttST7Rkk8ZBD/HVn5FXo/qBDmm/Nz4sC/JMXIsjA1xBj5AOEWefZA+DfAPasW7YoXnLxm1DxmvLPecOsj4g9qeXJFjyqsscmj+s05e+4ftW7AvOA+1AI8k4GUtoz9yjgwoIQ+6tVU7RdqVtoNzx9x9AL+IATZjO/721p5zkHqII7rIB9esPZ988unjP+C1wFjf1uqXrx48ePCo9Em4tpqLPYDd2J+5Z/4iv+qgTh7089ICXzejLa19ILBfuu7DfyOXvYNt8OfR6QUXXPDc42Y1ugPkxPSsISdC7aNsL1uRMyInXYmJO6nyZVtJ5HkLo3rr8D1j4nUuZCwKLUoeziXLWlTRKnuWob2z2O+FvfSsyLlrn5DfIsG58eVIXwIeRW3XAmMHGbV/cU3fBfAA5NcydUDZryuopzzHa8LrVtuUSVvG/4sEY82RTSb+GSPKKrXQKzdPWY9cdMxkagfHtMlcOb9BmfuUKT9ttWUEZQPboVs5kvLQzQ2RNjwtjOI4Q/Ut/ZPMQVKrnfKOQbXd68xn5tpYt3IO3SWO9a2i2jiSZ0wrEfscp4I6rit/i54HZE5HlH1Bso9QD7L8FLI9Y13KOpFtkrDD89oepB+W13p9acH25l9wThn9JeuUVftPC7ZXRrapSBu16XkAtmo7cZD2Ro0dOtXDH/hnf2Cgfvv1ve1X+kYPxPa2v6Wn6iDfPMjCLo/+WuDIVtoxJuSn7c0YyTn+UYMLLrjghcDwTS4GvYtgCyxK8DCB9CYX5Xz11cPrCXj/ST2Brtdea38GG5+gb7759mAPfzV48803Dj5g/+eff3FYIGjPUX/qJIsOypggW6AOmSwWta3XHD3v6fHaRRw+eYVyyFHWpcxZHt1Y9N5MSxmjPPPXH+p7epCBntFfr4xt9SfhXwR78V8BdqALPca3YqbHuMBTZVCHDv4qL/C7pQ89lPfipizQ4wGzNwCQgSzz2AL+IKf+9Swx8lvQp+Br5drYU0/71FHPW/oTyJIyT7ajHFvY0LSgL+rCHtrQlznajnPQ6wvUy8NRWcqFnGe8rtj+errFBYw2bM8r8JE4APoX/eMcHzN/OTYoc/z2xgR2QLRDjnmRWrDcHAmuk5xLkY8tkMixRTk8nNs3AH3INvCn/er2mEi783wPOL+3bFmBvMipcwt1VRb18lS/jA+xybpjgU7HbfafU2Aez5XDx3przo8FsXHtYc4yb618ZZnn+NLi3RPH5E1bVmPSkj0rq/XO41Iir4kVZM4qL2iVVSADncipIJ/uE1r1xAce9UPGjCNjjjLat2zM+lqXUFaug9gMUacMiDJsogx+7IdH3h6wz73SiwZiQEzwf28/jSnzh+fEHiLmPMj55S9/edCH7lVg7zvvvH2w3ZxaDlr96VhgEzLQoR5BjOg//ILgjz9uD6V4AAf4DmbOX8S+csEFF+yD7kMuJ5rRBOJExwTVmzjhYQ7kiwCf9kOu6/8PN4/YymSaD7m0j3I+1njt1ePFAnCe5MTOsU7yxC43Askr4OG6F198gYdJvgfswH50VRsA9Vv8+3poD99Ij3keLWjeBJ3jD/UQMnp6yA96Mr7HwrihB1ktzPQYW3iqDOrwIx9ybQv1kx8nnMVNWaDHA2YPuZRDXHs8+DN7yAUcMz05oz61kuNV2KeQlefYhWzKOLbiZv5A2mI5+dd+5LVkAOOKz/lQzBjQjryTZ21rgXr00ga8iA+5AHHFT2JBfM/xkTgTL2RkXI2lOlpo9VHlSVwD5EvAOsvQrX50eyOKDuyAxMrYsh9gG7wJyqmHD53awXna05N/KvALIBsbAMfWuXYIryHkmHfpWOh/7+H1KrQZqnE+FviFL+esS2A2j8+AL/SJbR9zs09JUH4fULfHjHXa1TsH8JNrUPM9ancuHLOjsYRtxJqcYds54w4fkdear7CF/oX81kMuQFv44IG0DbnEezTn0A5+6kfjAB7sgAfZxojranfVTX+kDBlQD9jemvdeBJhH4kCsmSta+T4F5jv3nAJdfF3Mxx9//KjkePA1MHxf1zvvvPOoZB+Q76+/fnid7z9dvfXWGwf5xEgQH+LESwi8gWXfpm9x/8ZLC+fOuRdccMGLizt/yMVkRP2XXz75kIvyFlrF2+J4OHt0vZ175Kk+nyPvY2sHH7a6CLvg8GtqlLMYw+sXEoK0E59p01ucnICZeHv+ATctvfjO9IAVXXvoMc/I6ekhbtT3FhxkYO9oQcIOCFtP1bMC44YeZLUw04MMbAU1ttRB/FVNIAeq+mb5UQ/Hkc+rD7nAqC8oB12jPjWKHbFF36hPnQvk26dSDz46rrFv9JdvjtVPyoB/ER3FQjnogq/yWG88vBFqgZgqCznYDW8vB88rzA++0od6N20rcOxknIizX3JP3kZ93bzNgEwJ9PJCPTbpk35CgjpsarWHn/bUYVe1XVn6lkgb8QsCyKi8p8A+nL5zbPkxAvMLMTi2XcI4nNN3hLE6N0bm7Vw5xAcZxoeYe5S89tjKA/HJuuRZPRIX5JB7QX+yD1R+kOUJZCGHI3lDxgzYTxvIefi+gN8AX3q2Yh/k23e9cb0C9BGb1nxEnf1r9GCXPQs2YBOyWvNED47v3nxInX2Bc+eVXmzghZCH3djGNW0F5XkNkNea+14UEAdiCPB/rz9mkW/6CDGuIJY84PINqHOAHuaoDz54/1HJ9vDZvQ0Pq/70J+aIJ+edGXhj7IMPPjjIF/QxbPd7twR2vPfeu4eXE+5zXrjgggueL4yeCj2xAFUwebV4KEvaJsbXDsSGYPsFj7cOT+3ffffBgZiwoPfff+96onvv+sg5ZdTB887hVz/eeAMZm6zXX3/1etGA2DyNbRX8nC6T/fffsynZJk384Nc2ICbS7adgb2/kjsEpbVroxVfM6vfCnnpW/Llrn+4rbhUtndgCzrVntf2MT3tGQMa59p4D5hM327nxAVwntaD9bI56/lIOsWlEX0Xa4Ea+gjI2mNixshFDFm20vSXzeQd+EROI2LrhPwXECxgnrt3kG/cWarsZMiezvMxkqrvCWNC+2k5f4+aItvQj6ivSRni46fbGew8on2PSi4BeTs4BMsmbZH4lbkjJKTd0EOeU0c45J+0i1uSS3DLfmF9uLjlSJsFnbsiZ/NYjw34E2W8yr1JC2b12nreQ8lbjbeyQi777RM+PuwQ6z+mLtHf+680TPZjLOh8Tf/srsukD9DmOsxjhyyjnvfbY8aLCOAvzdQ6ILUSuQMYVXdv3VZ331qtAHg/mfvOb3z6mzz77/PBGFeXMM3y0UD9nfSTR4ufhFvJqOdf8Wv454+WCCy548fFyTpAtyk1Zi9y81TJJ2TyM2srYvKGaSetm48ORRbm3AdPOEY1ANXYAdG0T6u3FtE6kPcA31zeffFd49sBMz6rf50AdI1vuw45VYMuKPS1/VtuuAln3mcP76pczYIdzEPOKN4WcA+eGCu0f1YFezJC/bda2B1NcY4PgHLuQD09PDrqY82Z8yHOuBCs3EM8zzBtEbIll5iVBHbFx7hbGv8aJWFLWqqs4Nsbwr7Tp+QKoq/X4Qt8GroGpB/5cC0c2aGPSHlDOuXL3smcv9HJlniDyYz+E6GMQfRcid9ZZZp+VAL6TP/c25JmxDnFujjPXLcocjAjoX6u+Rz3g00jeCozpDBl3fT4X6jYfI6hvZGv6veLTCDM5Pf/ht98lz7Exkx95yswHr/RP1sTaB1eh3L90GD9gnPdAjs0EcwkfBzwmVzMgyzns9lx1/HyQ2N4Cq/dk7b7GNS86rIzlCy644C8X13PEtpFwEZKEE8zNRHYz6dTzXn0iryu/bVq0B3ArXLvW9+jkGjd+P7lQ3AUyxi0YpxnfufViRc6qrHMw02E/ORcrep4F7GXHipwVnpV+gJxj7Uamc5E3kWzcIMoAMpkLcmM10nNsXfqmHgikPUBbejr0h6N8LV5lwkc9+noyXxToZ8bW3BOLzL/5qKAuY2q8IeL9rKDan9fajK/AmLTyn74+TfTycQzOlbEaB/RI9o0WzEH2O/khZQhz4bjmODpPyrYtsr5FTxvG4lQc44Oxpw1xOQeZf32o80zW6eMxvh7D2wO+juRom7ZqO2XGieMxcU7YVplAndalbMrhlVoxHGGF50VDzZExOwdVRsaV9YQ3rJ4HZN8So9hQ9xfYhS644IIjcHiTq4LJxo0FR8gNOMRfdaRal5QTep5LidmCR/25iyI6lbG9xXV7wd6OY1u0e8ZD/YjnWUHNQwsrPKt4HmJyDFb6Cuj1h9XY3lfc7LsznGOPsWCT4ga5VbZtYm422Mwp+dZDL3a0AbP6FqhjrgLObRwp96YCuc5nLcCr7fApL0FdyuTcebMn90UCPupv3mgSB2B8ALw1JtRlOdfIALMYplxh+2NJWQnK8CX9ET2dxqLVV1Yw0rknzpWd+RqB+uTxOglfMxdSxkE+z3uwfsSP7Y5niHyN9kHJS1tphFn9KpRTfTgGLXtPlXeMX+hgTuBo/E4B7TOXknVJ9hn5s12VUYFvrfIeUlYldNX+XOvl0S702weNFXWnAFnIBsiiH1OmLpG2pG15nGGF50VE5sl4QRXUtUj+7COt9uTt+t9hLN31j37tAftaAt/wuYXtzbFHFxdccMEFDbzsDWMlJ5ttomzPJL3yxKi9WJGzF5wwq103EymbhkenZ6A3MR+LmZz70EOcVvSM8ljj3cNe/sywqqfHt+rPfWFPW2Z9YRXI6ZGbtHzAAYyr81B+nMeN4QjIHsH6lh/ahl6BTudIbHSD2osD7d2Y6UcP8EEAmfr8lwLiQ2w5GjPjXT/ClfGGL8G1cW/xV9i+yqQ9/fEYqrYAZemTQJ+2UU5/QgbX+EvdMUCG1BtPTwNpVyWAbZxzlJInr4V8+kadMdZvfZdHAsQ4850w/kn0PfufZO5asrxOm0/FuTKqfcfKg1+qfoKsl8zJCmZ8ygSzsVxhWwib7A8gc8oxc21+ge2qDH30KIG8XiFkSKnL69qfqQfJrw/YLtKHFWhPkv0HucpPvdkOvowf11mXvCuAD79fFOh7kvEV+Es5Ma68lCWRA4+QH41ugZxcizh817F8tkf2swb6j9+TLEZ9Af8yjhdccMEFFWfvhJ/FybKHnBBvz403PqxMmjOevSbe52kCvy9b1XPX/W7FnxlP1vfsvS9/ADpmelb8PgboY6PC93v4HR9uythA+8XJbpShvD7VnlE7bGrVG59ax7U3DzN78A0Z24at/cCKejaaxELAq46/JOAz/QCsbr7hy75hPEEv5gl1ZC4po619cpVqzrAjv8tGoMsbRs7pJ27g6e+zftWCfYgfc/G76hxrnBuTPYB9+JM+zQAvNnhzBXmNjX7pehLl+ABPS5fjyht8YgeZD84pp16Cn3a98XVK7Hs4Jj4taMu5cvZCtYP82ccyZxzJ2R5AB3rN9bGgvf3ffjKTQ9yzb9mvIK7tO/iI7OyrgjquqafOuHCkTMq+nXqde2p/Tv3Afp9l4pRxqk/YTntkY499ET3YAOBDtrk2rvqRNtm+ZYt1FfCi40WAeZCc+4ydMaA8x1LtJxCAn3jbV8xTD+YEOR9++OHVL37x8wPxA17P4ptd2pt9yLnAGCQoahRfcMEFFzzGSw8fPmyuNkwuLHpMpCMwKTvxtsAEiywm5RacvNDFQtpb/GZ6ZrhZKPiFxe1ne/mFxzfffONw/vDhNwdfuWFgAciJNuGkC1q2OCHDR/3IH3S4eaiY6REsjNh913qQUzdbCRZl6noyjAnHni3An+Pu6XEjRn3P5xUQN/pkT48bkZEe/OmNEfxEBzwAOfhdfTcm+tQCPMSXTW8P1NvfevZiK7rqWKQM6A/H5EFe5tU+pb4KN2jwjPjuAs436Gv1M+rxt2VTb66Cnzr8om7kN+X63ULKEpTRDtmjsfEig3jQ94gbMcj+liBW9L8cC7YlhivfP2KeMtbqphxaAX0Fst9gWwvqsl+hnzaA8lnO4dUm+w+U+qi3zynbMmI50zEDurCbY9qS14BzSWQZcbIM29IHz+XtwZjj04hvBcqqY/5YZP57fXcFyIGIjfk8FtiBT4wTQJxasZaAcczYc6SevAvkOAcm4KFsZDM2yTeKN3sAsDI2hHnEXmxAx7l9YwXoI84c3YftrRffmJ/wj1/Km2HWF6kzXsC8rdhNO3IIL+1a8rHVPEDmXZsA7fMaKBMdgDl+71geC2xMEr0y7E2bva5l8JrTBHWr+wDiRN8zXsr1fFUOv5C4mv+7xocf/vTqwYMHh9iIX/7yX5v3BB999NHVl19+2dx/3yWMMcftYeHNvQ1Hyt59993HfMfg97//ZBd/tI3jSy9tNvFrlPzwG/H9/PMvDuOrxvSCC140DB9ysTCNbqwBk2xvsQNuPKhvTaJOBExqTMi9iXamZxUMeDYK6OEvGm+++ebhnJ/AxVcfTNRfXhTb5LEtKi1bVv0htkwwPX/Uw3G0UM0ecs30qAOMYjt7KIS/2EB9yxZ06NPIn9lDLjcFPT2rmPljXEZ64MHv1qJEW/ps2kt86+Z+Jf7wOBblBXluntPWyoscAB/XLd/whzrstK7yIYfr2lbQHrK+x7cH0OMR0kdiid0Vzke1D9qe+pojy4kxdchOn6wH5rDls3zEGGADZcYceykbjY8XFeSNOBAfY2cOc1wQJ/LgmDMvlMM32yCqx1gLxirXrT4DzB1HyH7GeR4r8AW7HE/ozvxT1+orQnvVm/qMDe3Tbupoo436mnE8Bdoxk9Pzh3JsgrCpxlrfRvEA8JGLWexWoD3nysIm431OnJWDLZAxAZxLCa6r7ZTVfgZacitSFrYwNuQnZ86Bwhi2cpogZ+7jeuNUHm0eycMmiDag+ngfQD/zDzacc9NofD0C/ZPQsfKQC8BLTnItUwZH4qOtrXiZzwra5nwLT+Wznhwil2v7YgX18ALk0AbQB9wHtuy4a+C//crY1OMKerzIJybE0HgB+CFjMfLduNpWZHvHxAg//EAf2ezkPsj7o7sGdkvG+4MP3j+8fJA+/epXv74eW99d+3I7Fj/96U+vvvrqq8f9rEIZHn0gpT6O6ORFh1ORduZ5r7/P8Omnn177+kPYvNm5PbDa5uLXXjvmTUfa3djGEZ+zbxG7r7/++tAP7iPvF1xwn3jqD7kEcrwRaAFbkHHugsfT7G+++eaghwdcPOji/Ntvvzu8BeDP0vbs2CacbeJxQU44mTDJ9SZfgD/40osbctTV0iNmccMO6kZ6Rv6Ic9+wWvVnj4dPKyBu2DHTo08twNMbI7RFR26UyEHmwZhAAD2eVxBfN6wtv9FjTLLe/pFAB/LqjYbl+JW5bum7bxgnbPNacK7v1nPd6vPECZ4aE8qU2Wtnn4GMCW3MMe16sZKP+AJkqIc+RJ1+KEcCef6ighxIxIIjPhMT82uOiB8xI3aUUTean4w/4Khc26KLuFsGtAVQluczIBNSJkdyD6nbugSy1QV5rs6UqY4qA9DGsUxb9RG3U0GsQR07xwBbiD/2tOzO3PQwk3EMlEVs0HsqkEOsAbIAZaMjyHNBmbkF1a68ru2powxivgLkS/+qrBnwCTn6RnvkZT+in5GHmXzijCxsqWsP0GZ0UW8cK+BDFkd1Jt0nsMFx7UMuyqwTnNfrCm1PP4gFpL/sXVdgG+dJ9SPXXNWxo03wA67hkR8o17bKzFzZ78gh9ewdlT0CMuhbyGMfCJDBtfrvEsZan1Jv6j/XFvUghzgaU/MkiAdkDhK0cd9QkW0yLyugv5gD7omM/10A+9955+2DzxA+0VfoPxkH3jTjwVtdu/iuMR4IEYP5gx90PDp7pI8yHh4xdp8V3J73NpvTVnwlTnuC/LpGCO6FiW3tdxdc8LxhOFpyojkVTpB7yNoDt+24WcT2sm9V3l0tHM8q9vZ37/6EvBGxsLSIOjcoUtYlvFbmKlZ5ibGbGwlwZAFLsjyJ9hD6PIeeNowXMfW6xti6tNlcyFORcqVj/LUtGMVKPjdTNd7kw7byYbs3T/Yrz7VV+6EXAcSEWLCZ5cg10H8JGCd8J3a0kT9h7I0XqHmyDtkZe4+ew6OMCmSaV1D5vCFRF/zaoVzqk9QLamykls+AcnjRkbKfBdTYJIjP00DPJnNTyT5lXCHLpNpGeSNk38w+Aji3j0nZF+wPUqLK2hP4Clblt2JgjJCFHI4ZV+skAa9+7+1f1QllvqW0Pa8r9aBsUH041SfbYY+yAeVQ9o+RrdpmOfLsX+pI+0XKgo6B9qnvLoGO9FFgQ44n46bPpyLjodw6fgW+uwZU+7S7BWWcYiv6+OO/LwB45MFT5gJT9CVp+1jc7XHiGvrqq68cHmIpnweZHCnjPP9glaAt5UJd8L3xxuuHN7+U2ac3DnrUhT88GEP2swTsqjZjLy9fEJ9ezs8Bsbytl5xvMUX/BRc8zxi+yUXHn33HCTxO0C0gB3Kx6IGBPPqrAQO8LgKn4JVXXj28mrlNkEy42yDmVU3+SsbEh72tyRY4wcJT/7KQIC7+RaQFJlfq8KfHgw4WCeT0MIvLTI++cBz5Q6zIT0+PC+DIH3Rgz8gf4ta7YQWZmx7PCuy31VZke/Q8eSwD2AJl309eYkK9gC99l3cWf+rJ8+ityl7cyBvtqg/wV3mUkx90Me7Pie8ewB7I+ABssgyfIMqIteegttF/+CgnVhyTHEcZK0E7+ww5hB8dAP7sAxW0Jaa0QS9UdVBP7OEB1nO0DHBtXdqa5aB3/rzBMSQBffWafNSxQ8yS4JUHmYD4WQfJO4KxzCOUuSCPaStQLkf56TOcpw3ZToJX4voYYIv20H7lO8t6oI+C0fy9AuQ41ipGdYJ4kUNiMRp3NZdcV7nERVk9nSmnnrfq0ibzlXnjPK8rVmIwgnZ5g+L4GOnsgfgw79kvAfsAxxJ62LvVNaYF50FQ+yFyXHtyLGessAE+4nJKfGibx4q0n3PshXfWDrsgY6ycPCJLuyvwGZ70W6AT2bQnPqtvctHONujVNuVpB9eSoE7baQ/yOvfpykuZ8FAOHzbQf3rANtoC2iubMvoV59jeis2pSH+1H2ALpG97o+qqeqgnXhB82giIjTmkLbGpPIA6+eQ9F+jwzR7mEuRuaoljHjfezabtuNGh5trelw4PTrb6Nug7xkBc36NeffUVH6fb3v5UJg9imOO4rrG8YB/Q7z777PNDn9qjL11wwX3juXnIxeTnpH3OhNZ7yMXkzZfPs+Hgy/l6E+c2wW6L1WjhJS4uCC04iY/8QQd8o5sKN8TIaMmZ6Vn1h/xgRy+He/lD3EYTKjLMTY9nBcQNWcDYaTdH46KerBO0740R2qLDTSLALxfqBDGBvxd/9CDrlIdcrXGlbdUWyrGXOnw6J757gLiYI2zhHKK/c13tc3NtPef6xFFwbnuI2GR8WsAW5zr6rzmjfW/uA/C4IaWdtlUQc2VC6gFc0946zyvSl3r+vEO/ySVxEsSIfl/zB2/mCB7KLO/FcATjSW56eRTkHD2ZA47qHiF1QOcAXcQMQu7qd/q0QB8Fo/l7Bcjpxc8xNvLbvgBmfBL8+F/nWPKhXwAej/Xca1Cvgbk9Nz4rMRjBfs0NJcDn1tqwAvxxbhKsG8hTD32L6xqPCmVxrP3QOmS2/igDZVxO8QUZ6MEXbVeP+XScpn5BO+usRw7l2Ibdtq/AN+paOaWONrVvCnQQY/hWH3Jhk2M+13n9Vxc8yNe2lu3qp639qPLBw5xHvXFiHGAzbXtAFnIBbdNWfcYuZLVsOwXmDNJvjncNY6/OHjLfCWNKnHoPi6jXF/j38Aub0YWsu44Tfpsbgb/2u4Q8e/l5QR98ZHTUZy+44FnFS9eL5vUc8eTiwYTMJDu6sQYuQr1JBjlOxqNB0roZTzD5OZn1eFbAZoQvK/zTn7ZXXf1LAJPo118/vPZnm2Qp6+lxsRptZmf+OEGP/FnRQ1yU0ZIz04OfELqIQQ/ErbXQCPOMjhaPOrAHOVxb7jmgXjuzXP8o40hfOmfStd8qtwI9+tSLC/W9MUK7ulFBTm7iBD7P9CCr1VbQ33KDI1r9EF3YVeVRji2zDfuewA7jDNCHXsvMDzSaZ4Sxgt9xgz+0k06Bcck+M5Nn/6AtsbZtBTyUG3/agVkOaEcbeDgaM9tXoL/VR5514A9xydjgi9SKD7kSGZtjQJyUz/lecdMf+qk2qQsa6ZFfGVxrX2/+QI/xWL1JboH+Bkbr0QocR1CFdRkDfJS8xn/7grCeeEBce96LkbI49uK3CvvnXcbnGPCmA8AvaNSvesAf5zCBf8gjZpRnvCVQj8D67IdcIwc9yMZv5FUQF3jRfUxs8IExAHp9AAL2BfigtMMYtMpZZ0fzNba3dAPXq55P2AMP8Vn9UnBsglprPEQdx1m/IB7Gz7iM1hBshJ96/MFvrlug3pjiE7bk2EEfcQXUtWK3CmRhh/rQfUwf2gPHjmvjbq4EsW3FlBjSP/TRHHF9auyMGTb3cn4qMif2Q/3VB4DuVp+TB7/3tu2CJ7HXLz9ecMF94uWcPO8CKwsymNmxKmcG5CiKI9foVj8Pv3ZSNcRecZlBPT05rXrjAbEIQSwyXLsAsRi58ZK8ZmPCgi5RRhtlQQDdLE6Qiz/nbnbYNEpMrpS1FrtTYN7vEz19xvoc9NrXfqauWi565XuC/Ns3si+o2zI3NxB9YsU2+w+89EPIvnWOb9qnbegZyaO/0++J9ewBF7K0234OGE+9vCIfefpmW8YKG11jRhlHgO3Egwf7GftnEfiNj+aQWAD84i1DYwrww3jDy1+5uZao78VRGEtjtn084/vDNeV7zDmi5hpSV6uPYD/+51wKaIcM2uBfz0fqW3KPxbFytAn7JfPBEV8g/CJvHAF1+CsvBKp+YkaeJPq959ZxNM72l7vCrI/dN4zVqG/0cuRa3pqDzJ35UQ9H+7Z907nNOnOQMtUJD/XKq7Bee2eAhz6FbG1q9QFtS/0tGyirsQAt3mNg+5bsU4AcqNplXjlST0zwu4WMHXKIHbwckdHqF8A4Aup7eYIndXNd7eXafK3kuwL92G8/BvaDnt93BfRnbFYAL7ZWe1uxyFjhd80NuWzlawZi55jYE/YNiJxwRFfLxpY/F1xwwQUrGK4cKxObPLNJaFa/9yTaw209N+dpHzwze871V6zyjYAMyEVDYoGX3JhALCZJ1MNvfbajHNmcC2LDoguxAEqWsWhluXXGtXctqWNE58ZNOT2M6hJ7yFgBskY+93QdW34fQLf9gr7SI+rhTVpBj2+1fQuOMSj7bguMFcaRvPqRoA4e5ShTfvx3DHNMcA3B34oRsjmmLG445VUuY98bGdo8bWADtuUcZQzxgc0+PlBmjOWDnLuor1RhfJRLfDiH0GE+5D0WPb1C/RLXUkXmWtuyTeZ1BmM1y7n2I1PymjhLGX/JOnRAthXYiv36Axn3JP3Mc+ToM9fGQGqVJbVAedp3DvaScyzQC2W+BOXkoZWrUY4yxgmus5xzqeaFvGa5UJc2c4Sn6kooE960NUG5viIXmcqVekielg7bjnT36kaYyQXyOOYcYz0yplnGtbmAiFPq5Jx2NXbmkyNEToH9JoEMeKFapw8i+0OtE+rMnM4AT8tnZWnffcCYage0Cu3EdufHnt2Umxf02RbSf+JRcz4C/LQ/ps0KMibmhSNk/SpW+sMFF1zwl4td3uSayWCi3At72CswS9uQi+jtcj97E5uO28QkLbGYJFnugi0lT8qosoEL3YhELXdR5hz5Ix4XK8+TLIdaMipaZXcBY/Ss49R4PKv+4U/tIy2ivxzru2MBsOmD6pg4FikTYFPPLsYkYxRd2I/+ykudYzfHhbAdUF7qp6wXG2TCSx0x5Kg8yAdFAD5k501T6rlvaI92aLvxyfok4kHdKL/KwnfjABkX+xtAVsbdc3WlvqpTG+VrtakY2Q1oZz61k2uRMZqBdrZNvS3/0sfkVcYKaZs251HSryTrUlbaAM8eQC5I2U8TaQfn5sG8QOYqczbKF+cZR8n41lh7DZmLROWxHVRhmW281sa0u9U+kbJsKzg3PspCn/bPZK8C2T2M6tDfs8HyUftEjfkq0U7iGhh78yBlDIVtlAHgrZBv5k/W08Z2CW2FyC1rlTlOcE054yFt9+j50wB2naOfds6LMxnkA57kS/+JjTnuQR6O6uS6FfdToGzkYheoNidGOqnbw6anDf2QzJFxT8q531hecMEFbUzvaJ6VAdSbAI/FbTk355uf0FbmZNMiJ5bRRAQsl6e2z+taJoFalrzWV7houMBBLpTe2OUNHrzWS9lWeZX2BjJb/oi9dY50reIYGafqG8WF8hqXkZ5RnXJOtfOugV1SheOCI37Yj62z/hjQxjEMkFtjLeBxk+1445igDnny1Hphnf64oZF6bZ17QLXTNtrl2EeHD7poL9039BXKOHONPWkjZfCPQHv9zfnOh1uUw6N8dSu7RdYlr/GCKj9Uy+WlLaBshFk90M8Z4NHvhLbpn5QwnhyVk3GVrIPgt03SsTDWALmnyLhrpG8ZwyT9sA8kGXvbe+2xnteyCm3hSA56eTJHNU8iz4W6W3WJtCvlWq7tlHM0Di3Ak77K69F2+sqxB2S0KOVX9HytPp2Klfbmy9y1yFxWPq611XN9Tr/htc4yjul/ykrIB5mPhG3gy3rbtJC+0KauARwl7ZVfX54GtI3jHnaM2qODmECt3HDNmOAIr/wcW8BueI2hZdKpMB4AOxPoM9cJ7a22wg8hc+TLXSBtalHGSvtaZH1tk3I8r9ecI4PzCy64oI3ubOUEMsOMx/rZQFzR1YIDfpWuWzyeXF56aZvIraNsk3l7IklyUsnrSt7o1ptG+CmvcGJ3QclNKOW+dZBUebJ9lq3GtWVXxR48e9pzDlbswIaRHcjoyRnV7Q1sbOk6tjwx8/1pwXGnfUmMMY6OAeHmzvFa20kVlDmWHU8tXsv8OAV8js0EPOgH1cYKeJWD7bTzIQ9lLdBG/T3Z8CAPGcwjfGcRvJTpA9+PpC+USXcBZaMrgb/46hxa61vABwmf9DHnTH1NIF8d6oEv59mUQx0xBvBrK0dQebUHyF91ZpwrqWsPIA97kJly02Z9Nl6SsT0XyNC3FcBnbLVjb/Rs0c5VyjbmVjLfmf9K1Kcsc4XftR8m1VxlnFLeKWjFW5/QMwI+2deQk7KMEdDeHO8tu62TjBt86bdtR5RylOU59S20ylvxOQbHtO/ZlZjJ03/HP/7SJsc918bCeKTcnh1Z3uMRyE207FYGedU22rE+mXvzBg9jwT7wNIHd2IRt2HMulFdjJqh3fzDyHVsg+OFFnjEGnEvEGiDP2FOOT/IcA9uCXo4oa5Wb59QrL9fGJut7kGcPUq+knXmeRMyd4yTbIk/oW879UJ33L7jggjFeur7J+bOTWYIBx2CkrjXpCAenm5gWHPCjQcl3w1A/kuEkkIsGZZZ7BLUsj9vizgS1TVLWff/99iW+lFOmLWnTVr/5ww1iDzN/kK/uVvwB9eSA74vpgfbYgk9uWhKrelggR/5gB76M8owdMz2zfqCt6moBW+A5Z5JHD9SLG5jpoQ5/egs2dTwwEPAhq+pb0YOtvZjoS9pBG9vV8l5/oQ7wxd3YQrtebJ4W6Kf4om9A37TX6wraEGv9p71xkBLmjv5MHW3RT2xyXkQOddAobtSDlq4KZJo75Ws3X6hdYV6xCZ5eDJBDHXIr9AF9Aln6T7ue3FORvtn/ToE+zfrADMYd9OaxBLzYjT70VuAXPK2xbR82J5wrJ+VRjl+n+oQNfvEwfQc5p8jSV9DqP6vAHrCaJ8ZcjcmewK/W+qevHOt5qw5wbq4yznn0vAf7w2p8evD79oBz1rHAH+JT1zHtGu1NADY4fwDsQRbtkI2vyKs8xiDLsx9gU/oGzAWU1xW0TxJe0wb56FK3qP4IfsmS8lYdmOUUX9A5mieIG320J2MVyMMejsS+J496Ys4RHnyTT5s4Ui7MEeXEKpFtAXzIAH4nYoU5ThuxPe1yzX2WYD4h/DrXPseE8RgBXcSE2IyAbciEjzbEV7sz1wnzTjt0wNPia4E2AH0925BvfhPooA1H9YKcE5Sf9S2gI8my0VF5xxw9v0v05qO7wOXXFS94HjF8yMWEN5qQABMevAzoHh88yEJPbxJRF6DMcpDnOXnkJMI5fMhpTb6e85aWG4VXXrn59S7w2WefH/iYOKnL9gkn+dGAZ/IZTbbYauxa8QfGDTk96PMoT9TP9Mz8QQa+SC2s6Jn5Aw808gdb0TOSMwPt0YMvp+qhbhR75PNLdgIeZNUNzyxu2gqQUeNPe5B1tJGyHDnwo6vKgRfc1UMu7Txnw+cNUrXdPjOC+YRPG7imrcQ1dZzrv3KpY1zjBzZQTxnzRZZV2wC6QcprAXnKTD+xBxkQuSM/1tmGuiyvgAc7qdf/hPFBPnzYwHWCthA+eJ5lKzDW6IBOgXGEejE/FcaaOMx8gtcYtWKqj725lbbmWlCmXI7IxY5TfTSXyDrnJll7QMvXVZjzmR3ok/eUHNNeom0vl/jEuPbhsbGiTSVRrwG2ouvc/rganxnwg34MmBd668sIxq+uY1JPJm3wQx+qH8zjxhgZLTnUZ0w5b817yEqb1Fd1rgK9kPIS6MKGWs6aSVmrDsxy6txL+wrKsQfd54xfbEAO8lbmNkE77EO3UA52KMe4eW7fA9psO8C1Mlw7K5ChDo6CdtRl/+jNsfcNbcNe+y1+Z989BsjLsZywvxkLgR5yjP5ZnmlnW2PdykVCH8FMB7z2DWwaxUC5+JtwXGCnvuk3R8poa3vtsQzAI9Vry0CeP+u4POS64IIxthUp4KTgxMDE5CTtZAg5EXGUGHAQ5UnZ3smuNfEwUJkwGbRMahIDiyN11ldyolVOyoVusE2Gh7Pr4qyj/OZ64+nhtswnQX3GsWLWfhXquQ+M/AGz+hXsFZcV7BG3+7K3p8eYt+qP9Q8ZytkjNi0gl3lgBHicJ5xrnG96mOWB9oC5ITcEtHPeYY5hLkE/ZRzVy5Fr6qnDNus4dw5q2ZG6R3YiH0ImfM6TENfOfcaEekEZdSP58FCf/gtlaSO6uKmBmH/12/r0H2Le50bY+T/XAfi0OdeItH8GbSJH2uSaMPL5FCAPf83bCOomR3sBmcTZfBvzFw2jmFFH/4Dw3es6H0jZryD7HG1WcpPxtZ8Re4hrc2BuWvmw7Ny+0JJ9DrDnVJv0OaEs4jCC4zvb05bcmBdk9OTQjthD5JJjtQU55srr1Zz3UHUkenWW9/SOZIpzbB6B2DEmjDfxWrEnUfm1NcuJO9fUcV5BXfK3ZFTAA1UerukPzo/4yPjn+LRB/9Y+jxA5wD79XoUxqHDsoIMjsTBO8DtHzmJCW+wDq7bpF23J9UgHMrEj7TsWtKO9MtDnPCKhJ/kg+jp7BfcLWaf9tEl6nqC9q3k7B++99+7VW2+9+ejqggueD7zMZOGmEOIayskD5CBiYDkxOlG0ri1zII74IKDsSi05XI+oBSdDUPnSx/uYNFZxri20n8noxUvM6legjGchtnv4I3rx3VMH6MWNcnRVfZa3sLdtK3DcMgadczgmOQc5TrHTds4BOYbFyB9kAmVVXssFetwEOU/Bg071usniWv4qlzp1K6PyCHide5UH1KMuZVgGEQ/K0ocKeCDQssE6ZSgvYwC5UeQo1Rjph/Zlfik3f1APyDIOdZOa+lq+HIs//hE9N+uLctGB/dqpzdivbxA+9bBiYysOacOs/TEYxXwVqzKMF2T/M/cc7SPZPyTjiu8pJ+NCP0AO15zbLzxKXM9imPXZVn1JI1CPnXvgXDkzW4WxzRzl+IVExqEnX1nGL8E15fB43pNT6zlPqMfcJyjHbo4z6L/yRhjZSvsZejy078kG1tW8QK3xkw99AbGTqi5jBbX8b9kGX+X12lhWtOSAXjkYxRRfyLtrArHB354f9wF044txBl7bR7HzGPt6/OowRq7LWW5MoF4s4UU+7SDOaTeD/LZpxV1Z+G48ZujxUZ7rP3L1iTrLPfYI3krPK7B9NEb2BH3oJz+52Q9dcMHzgJeP6bB1YnDC8MjkUsmJBXieMiTg8a6RPt9WeVO+Epa7Huyr8XjeJp1nxd6ZHdk37wMze06NW/VhRc5d5Mh4Mi/MkDY7b0jYtuoDmywIec49LchHG+2EP+cxQV3aoF0J6+VRZg/qBuiTv7bjXF1ufmmXPAltMAYtPnlAq562wDgYEzecSVmvLPWnnhbgz/aVqGvZtweQn0APhN3E2Q31zIdTsLe8EY61X/5s4zWxyfgkZb4rpYwRzIE592g/4Oh17SdJKeMusbeOWXwSxrOS4LyVq16eEnmd9T1/qUeusU9QZxlH5WlHhWXwpqxantfoFZRXn5Na/t8lzpV/THt8EzkWBLJa/hMXjvKAbJe5qvJEnoPkq8h8JZBBu1Fb6mjv2Ac8bMnc3hfQ1bOZa+yzHL6Mcw/KbPGlPJBxyJgSh9rfE5QB2kDItM3MPnj1TTvVkedpzwjpTw/6ra3IF9rzlwJ9zRjcJV59lbfx+5+ouOCCZw0vM1H4F/KknCyhPM+JhKMT2jlQzrnQrhG0d+O94Weuv/Glb8uKjmPsmGEvnhlmMvbQMYsL9TM98KzE9z6wYm+ixbviy4gHma36lq4VW+8ytsjOOYdjUmv+SVCXm6geqHOjpqyeX/KBlk5AW+s4l7xGBtAuriFlWWZ9Ql7k4F/KRqdxyrhA6kUe1xXqUj7tW77hO+WtOtuClo6enR5bMitqe4g3t7jWz7sE37/444983ANdjwqvoW7i41+pMxbay/k5yDzeNdRR+0aP5JPXc2LCNccepQxhf2nlvEX2Ach2yLiLPpF2Pg0Y2zyXjGWPWnxcC657+ZGE8TXu0CpSJ7lqwbeLyC3QNu1PGZxTV22wjeVcZ99CNkS5b/d4TP89oqfqbWHU73ptVmDMZzLwV9+k1riBjzh4rt36qd/Eg2t4oIxNku2zTeZXuznCU6E9rfjpewWyenUJ6pHPmsER4INztrbdNdCJLT0/AXXYaJxm9pmLCvKODtpC+k0ZObdvaAcyeLPPmKgXQgfttZ1zjtkPRjbaDn3K46guZe4J5NV8a+/I1hcN2QfuA3wlBT+yQZyPgf2CPnjBBfeJYU91gtwDq7JGg3U2mNEx01Prb1/eyL6nOWOKPXPQw4qO+7DjvjHrT+eixmzWd+8CL2Le2MSxyLJo9mA9m6DZBovNGHGCjw1ZD+TPzZSbOtrRPm1xc6dMeSqfoNyN4CxfyvQhEGjJFMYB/p5s6qlr+W7dLIYVI38T6PS7v/Lm7L7B0OQhV/UTm/Dfmwao5qk3j1jWizugDh2jj5Ocg2ob5+QEMkcQ+qH8mJP5g+hHKYcYQNhO36pEecZLIrd75ncU21UgYw854tw8mrPMlfmqOap5St0ZZ86Jfy9HmSdzZEyqP6N4wUtfQU4LdV7GBnXiC3UtpC9AmyxHrnZXpA7sxlf9NwbaA630hVZMQC0Xs3pR62f8p4BY0Wc46n/GjWv0wiMf9lNGjqj3OoEMylo2G/sKynp1yGmVj2BOaed4wf67Braiz9iMQL19rTVuE7069ADHS+YPIBseYpF1mVPgEZu0W/sYIzP7ErRDJ/rQoW3augrtSKC/FwfHLPrQ+5cEYr2Smz3Bj7cdG2dy8/bbb1199NGHj0ouuOB+cPZDrhWeFewlpzcZJuRBZ+o9ZrKg3Yjf+mNktrASl3N13CdW4rJH3PbEyJaVfrCKnhxkjPQcG6sZvzYfK/e+gH1sbEBrE+vNkhuuEbhZRJYbpR6IBXIheN1M2w7i16+Q502BuuHxpopyNgjwcuRXuaiHd6S/BdthW910YIObU3T3AI8+VFCnH6u20QbfejcXyEEfBOCBnnZfw70//7ntJ/0I+/DtGChr5hvxpW+Qw54OZJhTCX7iTJ8j5hJ/beXog5DMA+24xjb8Qi/9wweN/MIglF/uD8EL0S7paWMvG5CzRx9UTuYq85S5Ik+ZK/gg2kv0DcYKsTdPmaNWnhxftN0D2X9Ajt8KeLW7gnLiwRE7hX0JQq6xsu+2dNEef0G1T2QMjR9H5BJzbTkGvX5C+Qi9em0x//YPjsbAfgH06VjQBlkQ5/Qb4pd2KTfjZf8CtOW8lVtyQHnLNvLX87/XjwCyaDeLbQUysROirfHs9ZNzgVxiQzwZz47hEbCLeGVsq33anLJoZ79Hj7lqwTpymDz0e/QRF+3uxdh8O4+tgPinzbS9S6AP/zgSL/zC1rvK97MGYj3rb3vijTdev/rgg/cfXY1BHt5//72rn//8Z1fvvPPOoexv/uavD337ggvuA9Pv5Npr8KwsVHvomump9Xn98svqP38Df277xGwS20MXMmY6ZvmBZ0+/X0Ts0ccr7B8Si3uSGxSIc8rY3LiRZlOQG+u7sHFv2B/1Dfu9aaSOTU+vLxoj2rAxYhM36rfGC11uqORXFzzKccNVZXLtxhNy88cROjbuyuOIfsG51+jpAX3EDhkJyo3tLDZCfvpP2pJAFptmNtXGABDbY33fG9iMDeTtD3+4HbOMz6l29mIiiDGyyYdjkiOxgSjXRvnNC0di6Y1dffAh2QY5ylPGMdgjV8jYQw5+n+JDBTK0SSI+En2bmEnOnzlvWmcb5dJ/IGwlD5mnzJVjwrnDsScdi2xzaqyNRaJnDzGiPMdLwrgYD2WowzJiQQxES5egHTGv8y3l2JPl+oEeYg5qDiXamuMkc1zL8Uv5xyDHrX3Ac8l+cQzwkbbGBxsB8cjYCm1v1eEb8cAGY8kx42peaxzgoRxQnnUg5VTI26sfgTb4QiyxG/uJAbGoNpwDZGWfZjxThj5oBdipjfQ520LVVnTAjx+0MbYjEAv7krHUbnM7iok6aYt9tBkBHnViI/yUHQPtXAX82Ej8Odevma0vAvD32HidC2L7i1/8/NHVkyDuvLX14YcfHv6QW/Hhhz89PCy74IK7xsu9wXHMwGGCHE2SK9hzkI5sQY/2tnTSdMWUlNPDqG4Ve8QFGTM5e+hZgXHbA3vJ6cGY9PQY15EdrbjCD7EQQHnt5sbNtOTmgmMSdbS1HaQ8oH6ObsTctEhsRCCvZz7dNYxLjUP6TR1IX9hUcY39UoWxQR5t5O8BO+DlCK8bxdrGeLnx7Mm0HH5j7RGfzCn6VoAuiLbGjCPyRnagH155Kp/xadVVKAvbjUMFMoyNxDXxTLufFrT7T39q+4u98LRsHMWIctri3wjG23GY41FCjkf1Kd+yHtlWP/EDnTO7nnXoXwv4as7wU8JvyLnEa0k+2kE3feOm75qTmifqgOfaV69nBNDr+SmobfXjGBg/kfZVwAsZg4Q5oJ6YpQzjTIxSvufJm1Bf5bMcmWlLlsnLOXPQ99/zoGl7uKYd1Hmd1CpXprpbaNVpt9QqSxLKMnaS/ds+zDm2EXOOtKHcNVR7aMs5PAl4qKM86/RZpKwKeAH1lce6FtB7DoyZYxQQD30/F/iijchXn+fUo68XFwEvsbSd+antlI3M1LcC+IiDe6SEc2Av3rQ1/xD29fxCRvYXbeYcPdTN4nEqjEf6iJ0j314E4DMxvau49uDckCDHvOX13nvvPhpn7XxT9qLn5YJnA9MetufAue9B2MNtO25vHK7/vyYm9bXF4xw4Kc+wErcVOTOg51nJ0Qh7+LqKXEAgJuVKlDPhSy6sUI1nbVdJ2DeSarmbiCy3LMspq+Vcs/lokTwj6MMpwE/a1lgZP2NhjNIXSF+w1c27tnMNerap1zYjX+HFLo7wqau2UZd1M5noB+qnnW094ncvPsgwRrYBaasyW8jY1hhYB7SlB3m1z3YJ2qNDe5SnjcY0/XoaePXVm5s0v4Q+od0tH0XLdtplW31Msj8QB2KVZNykKo9zy0egnljLxxHd5u4YzHTtiRorY+hYgPQByvKMdwL7oYxnnnstZX2W93KVcqSnhT10Z/x68mZ90VwYN2Fege0sU17CvAqukVd1qivLlZsyGRO87eNbdd99t5G6M78QZVKWV/3HwvbGogfjKOmTBJAlYSfHtN06gAzGDUdgOUiZtE8oR3BOLuRPyFfrKZda6JUfC2wlzxDADueLlr2rMP7Vh4wzqH22B9vAW/mpIwfqS/mrgD/7AQTQZUx6OQTqtV31i3bIkAd+yWt9m8V9Vj+C+iGAnas5eB6Rft43+AjigwcPDp+g4I2tt99++3CEZjmkzeWXGi+4a9zLqGdyW8FsUDhhjkA9ckaysi7FWb6VrenpYdXnFYz0gFVdMzkz0H5FxoznXDtAL/7a2CMXWRdaji6CSdbXditled1CrcMXc8jRBZoNieQGzc0aZB1tPLdtyktaAXw924W+96CPPTk1TpBlgnPj0PI7fdU3rlOm4Jy8coSX9qN4wOfmHz71JuDRZu0cyYQXAtVujukXQK7HJOV4LfAPKLsF23OET11AedRbznmOC/XJ580C5xXIwB9jB0/lw07qkZfy7xvYtanecsJbHfmHDsqMabXRup7t1BEL6iHj4Dl+z/pOgna0Ue9qO2wg1vJzRNbs5iaxqiuB3ErCWKA/qcaoXitHu6Wsg4RxIgb2y+ybxt9z+STbryD1PktYsStjZ8wTvTjI16tTpnEW5A9QLuATyZv2KA8iPwnLU6btzCX1lPHR5O1XVbe+wVsgjP2GGwfYtiLtPAct2Qnrezboh5Txto6ynAfMD3UJYwbkqaAMQlbyC8qtqzKsa0GZeyHjwRH5znstu2fQb5D9TGB76kKHc1UP8lUeZGk/yNwdC+QjBxmQMil3LR/FRL84aq82S/ot4IW0u7ZLWHcu0I8d2oJM/Jrl4HkE/hFXsEfsjsE777x99eDBO4cj9NZbT340sQc+PswvNfpR6gsuuAt0P64o9pwQRrJmdhyDFZvlQa+6KduKKTsUnYXV2K3ynYqV2MJzrh0ZxxbSji3WbRKtOskFslXGsZILXF7Ly7mLeyX5E/gBuZBy7qaBTXJSLkCAa3lzEU6Znq/iGN5jQHzOAe2JYQvGocYr43JsHIRttJ+juaYOHT258tof5MeehHwQgGcE+OxH+A4B5CtDUIY+ZEI1Nra17+oXcnp+Ae1VX88nZECOAcgNMLrg4WiZ8gRtza82c0SOOhLUwU+5PE8Dhg71EDFPGBfzKCgDxqaC+hprYCzMqXJGgB89kHE7BrRRD0fjfuxHSbR9Rsr0HCLHnnudfcxr+RLG0j6F/Z7nOJHkhc8Y1zhbho3PO4y1JDyv9S3KvHCdqLEDtmnF1jpkmYMK2lgOP7xZJugb5lC55DahvWmLvCD1UK08QTlUyyvUI1JXrRNpUw8r9diWfbvXx2ey4LWdxwR+EDfzx1H/0k+OtLVeoB+5lNG+oupLIGvFh1VoA/KMHWXbR6pufFtBykLOCPjInAQvOjKGCWW27DBO1KHv1JggFxnIMwbYlnnABmPSslPYFsDrvI3ckX20Qx9y3TukjpZO+LG7F58R0IdNqVMZx8h51mFczdt9gwdV9JtjwdtcfLQRuy+44C5wewd5hzh1Yj4WK3rqHECbm3bb5udwNpgsZnruy1+ArtmkfV/2HBsXbGbRkZykWYwgJk6ISRTiS2JdhK2DXGRtn7FAJwsAC4GLHgs05xz9uAJHiXJ5KiFLOjauvRytyDlWVw8zOcfo6fkzAvKJ3Qzw1VyuwLy4cNKe/kE5+ZvBvgW/faACmcqHZxYzeZHZ8n3VR2OHTfZjiD4L7P8taDMyaFvhGER28uX4QIbjUJ8qsA9eN5cCO2mPjgrtQWZP7n2jfmTR3FX7iRM0yyFxrYTfHFfhHEksT0Hm3jiTK+TS5znO/ADa4Rzt/Gzf4Jjzcso1jvpv//UjY5zbr42PRDvjLVbsnSHlnYs9ZR0D48ARIuaC65or8tTKle1BygDGP0Eb8tTz235m/hK9/o+sljz1YxdU21KGvizXF0BbruHhY4nVHgD7N99883icJGx/F8CW0bhuxWMPELOWT8YXmzjCQ1+hn1AnKMf2KgN7jaH9SlDXyrtQ5l7AXnQiE73YxVxDGX0fSp9GwDaIttAK0AkRB+JXgTzHX8IYcMTmc2KC/LSXc2wiDsi2DlucJ2bQJtrYX2YxyRzknAOQ4bmQF7RiNAP22IeBc92LBvwktsfG52mDfPAl9RdccBc4zOp1UrkLzCY+gB33YUvVkZO7oGxky33Yig0zO8BKbMFMTq9eXyEWIRdqyU1CEptnf+0Oys207TnWRY1JGmJRg7jhyRsgfjo9b4Ks9xqyLYsapEzjKe46biB1GMO90fOjpavG4FTsJWeEU+WnbfQx+hz9wk1OD8QLXvopvPQr+k0FMlt9twVlAvtiYo8Y6i99HptawA7GHPpbcdBGZCDLeFX7HP89OB5bcbMMW6qd6EI3wM6eH3eJl166nU9+bZcvpG7lqOYdHnxYuTE4FfY5c3QqsNP8On+TM+AcXf0T5FD9ntPW+dk5mqN9oc7JtNP+np5VIOecWNwFzrHHscERIj/mCCI/uba2HlTR3vGT8SH2mSvylLkiT5mr6gfXmTtBv0w9Cfss7dA/gv7aRwTl+KZNyONY5Rm3aov2pUx4//jH/h8nWn4Kc5Po8SawFx/uG8bPfmIfAcQGXzM2wJzhl7HDdvqKPigz5QnamB/qWxj1h1YeTwWysCH91Cf3k9hPbKDqSwU8xEBZq4AfXRyxx7iYn1YMtVM6FcpuyUGH4z/r6BvMMS3bEo4FYmJ/sKwH/UInUAeE3oQ2I19+9IxsaoH+Zvxpi85e33weYUyN4/ME+gvjatZvLrjgWExHwkqnczKeAVl7dOKZjLmOdr3tNl/6/ujvih0jnlU5q1Af5ESXxOLh4soEX8n6LOOactpvcdmg7ZCbN4lrFiMWFKlunuWTXMiUOYL1e8ath5ktYIVnhFV/enoo3ysWIO05V+457Wdx0b7av+23lHFO3+vFTiDHvk4/7LVRl312FHttgwf+FuTpyTgG6nC8JoiDNlfAj41SC8hDBrwt0I6YoaMnA1CHLORUn50DKO/puUts5jxpU/rDOWU1Z5RD+N/y7RxkvKo9pwI52Mo8jFxyqw/mmmML8kmn4NR2LWD/HvE+V0a2J3YSuWNucW6SvKnOMngz7sbYXEG5tnIOWZ7r6rl9pca1yqIOe9HVAvX4jB0zW9QFtfRkOfHhGpkJyuFJe4wl5ZCyvv32+0N5Dxv/o4sFaJvy7xvqhexzEv0K++wfnMNjn9t8ve0s9b2cUUad/VF5CerNAzZkTGw/QpV3KtBLH9TOFrCT2GATtjImOVa0ZFnWa9NCxsYctPxFB3zwz+I1AjaiYxQDYByqf/iFjy3/tFsbaQ/gXcmhPkLoqG2oR672yI8eeFttRqA9/ukjbYkNfr4I0L/nzSds5WOLx+TyggtWcPhOrtFgoH4PrMiZDcq9bLmW9Oi4Qbnq3y7vdoJAl8TAllgcXFRcWCjn3AWxkm0kZSk/4WLkwpLnxMF6y/O61idRl9TigagDlb/SfQA9NT574z586flxH7rvIn7ItA9D9GnHQ6vf29cBfYx+y0Jv/53FgfaONfjd8Ca0SR5kOmZaMdB26uRLO9JHffOGl3PbrgLZ2AUZE4AMZFqXNgBtsH0LyDPe1abUm5vjFvALaAfyEpSbM+pq/V2DN7l4e6uCL6f2S+ixG9KXBOXYb5yOyZ+gDe3t4/YFZBtnzs+FtpIz+jvX6FE+5+a8BXjOscO2p8QogZxzZQhzBjkuIGJAHpLMTxJ82U67jJX92z7eO0+yXT1vkXoqiWPilLEQKQtQh8/YXesAdfBQh30zKCuhDeogrkB/heUgy8lVtY9xzgPCLHsSx/epsbwx9DP7T/Y7Y0l57X/WZ1uBTbTLfpJEvZRAnqB9RW2X/Cm72iOov2sYL9Dro4By5kH3DMDY0h45yuIoT5XPNbngOAL6jFGvDTzIhEd9pwC55AYZyOzFAKiT9QBSLz7a5zjqM0fIdhy1l3Pq7Lcj2I5j5aW8Qn7baN9Mj7CtdmIj7Tnq2/MMfctcPesgd/Svy/dzXbA37nUErE5CI7QmQkEdmOl5xPYITPzbGe1sqiywlfeJiaSSk7vnkvXUjWQn6vUK0n7OK+VEL1nutTxQbZ8kPJ/Ze4o/Fan3rrDqzzEYyVrR0+Oh/Bg7j+FtYRb/Gjvtk3Kc1PEhzyrUxRGyz9qHc7xVUK5eYN9PaA88ylcXRPuE/JA8iZQHkCcsh5Dr5itj00PqSh0c8allhza07ATa0dINv3HmvNYDyiBkWE8byLoEcpCXeu8LP/kJtjzpw48/bvYK41RtB9RB2P3/Z+9fuCRJjjNNswg0AVQBYLO7uTv7W4e953D/7O72zGwTtyqA4KW3nvR6kVIKNXPzCM+sTCC+cyTNTFUun4hezNzSIyLZ5Qm1l2s1qi0UD4fOn4XGrzEsLg5xKodn4tl5TFTDVeSRlNua45E8ArmtNo2d46x5UntCd8rHxi7vyWX27fhVY2hunSF/5R6081Vb56u/XXs51P79GPdfstBrbK6imFNwqx470bezeynKd8qE6znHVsz4nU+eE5N7qG6gf8VR3LDGeCn4Ef/q+OE8X3TJuRcF5Ti5z7bmuOujWk3Ut9PhB+fkpeA7ecSP+NWBXfnKab4MIqA/HZjXYt+rBUz7iaN2mNxgcrqHOMqRZHuF6+eAxvtzy8ePx/785z9/98LrDW94Bn783//7f/8ni+BoM7Gptekfgf2Zj/rPdMDm2eazw9zAzmLx0yKfsZPZz+ff/u1t4wa53nTe39imtGk4ZrP2T5nts7/2pHzKf27g4vQ/K9pXgWzo5COB4qS/Qt+9scb7DMV4Vpy473AvzhXMfI5iiUHvLM6cTyv0Nd4gzi53OuReXeaYhmoRuhb7KNZZPtnSOdIrBjkbJ2OtP91qUb5T0iHBOXsPXfFZpZrseGiLQ5hx9NU/H3BDevGjM1EfHvPakc8zf2rMX3EJP/VPmW0w28mEfKB2ftfaZBeHtR/497BBZ41RbgnQm35mDBKPdPSJUe1g2ssj3x8D+JTX9/PtpdUtn/S+r/Me+nbj03lSv2M1JqFvFPI36/IhMOdvHMSM17PjF2f1XVu12bVN2enN9vXacZXZPudiwK9xcDwTOvw5rvP9EeASXmIfyovE6QroN/Zh7hP1l2OYtbR36K8uR8jGcfJzLQZod21PWP3NdhLa19OlB/6gxL06UGXnBbejtf/e1+25Y/Xbvhuqg/55nKJtygT/5XTjcJsTR8+C8ZsC7DoPYvVBMttQzbWfcZUv3XgBP3ErhuOEPjorJ5j+6b0U7Ju/6z37DDglM7fyz5fzxru5VD6zVkegw/86Z/iQd88Er4EYJJ+Pgk05lQ+pro6N9YoZMx5nyB8956F74BGO4kwfZ8i+uOQe188B8iof0jh+DvATDf4TwjfoPyfeb/g0cXc1X51k9/SeMVnzYdHuMNtb3G18NtDE9U9+8rdffPmlX976/q+E0fcmWbuF9p/+0/uvgidrbBukjT6xKZO+Du9mtf7+DNJNbLV3Tdgm93BF53NC+ay1fjY+Rt0+RgzzpnnevDdXte9wj9MzOeM01xDwj1vrZK4P66K1QV7LJft17bqOG5w9VGaL3z00BuW4Ax0+dzHZaVePfkG0c232Bb7tTX7xar9IuBdRE3Hmn90OcTiqsf7yWcFOPRqj9qzigmPXckgnON/F1sY/GJ9d/I8J8fFprPBzflSb+JPGTB2Mk3was2z5av43Xru6fGjEWexywwf3jzkOrQ8xO0+0JdVzPae3clVTuagxUe+kNv07aTyujskzxi4fr6355PKIr53urEH9ahO0JcYAqt8ZjDEx9ya0QfZ8Nj8n6DVGIQ6rvnNj/Qjk4C8x+j1e/hDF119/8+35H771Y094n9uap+vm0G7eNfdadyR9sua05n0VR3ZHddMuPjjiFU+wxuxhjfEEf9WBn8ZwQrx0dsDhrP8K2gPi/Ajwk7fxwYMvOfMX5LXLw3Xz6yj/asznDnxU/5eiGI6v8cW2sZ+5Nvb8z7qsmLkc5RviO7HW9wjFcTQ3zzjtIMd4ym3enz9XlM+9MfoUcbR23vCGR/E3v//97/+XBdCCWGHDsAEc3SihDe/o5tUio2ezpNeim4vPJqhvxsp2PYep17mjOG14Yfb/6Ec//tNDBt3bXyr66Tv93/3ud99yvP08821T3ueNhw+ZPoROHhNqh8dRbfloIZ/p8IPrUZxuDvrP6k/v6KZ/JU7jLMZO51lx7uUDdPDpgeIluBJHDILvEdwQ1/kWzKF5w6SzmzNi0NV3BP3Vflc7/Y2R+u/mFB50+DnKWV3Mbfbrw03ghx7cm7tnOd2D2sFrxhmPOQaTu9z4rq4T9NRU+9l8rp6dH9VMTP7oHY3Po+BzSjzx6HqtXbqwy6v6mAMrcK5eO7Tn8UHo7fLkv1rt5jJbtSLV6ijmM+GDq/zEX3HjdFunYE7hRHY5vARqAvyt+bovaffN4w8JeeIhT+Ok9o6tg92c2aEaHo0vn47Tn/mjjU01mPa1h7g2Dq+B2MZ++n8U+CS7eX8V7NUHXuNHbcxTvtTn7HkF4m7s2ToPjVM6pJrn0zF7+vfqSbc4c5+qHYprP1qfG+itzxPa1rnld+q5Jt8+875rexaKK+ef//yrb6+/eFfn9hFc7BvOXwq2xlFN+H5kruOFIxvHOPHVvjprp87+6uAZ1HydH3zEjf/4TugzJo3LCv6aO3F6FPESi7wGfLV+Qtzu3ZNwYM92rgP5kekT9PM918FLgXMcX1rHFfLhF/cJMfC+t081J+itvNSpvT+o7b15eAQcmwP3eE2wYYtP82fl+rmhWjxjXn1MfPPNN1/86le//u7qDW94Gd7tsnNjWdHipkNsVFPaxDu3oGxkNizihumoTb9jG+W0JfyLZ2PpaINp409cu5l6sEnqa0NybJPK33t5f7MH53C7fv+A/V33IbI7Qn7OcItzJ9Ad5OPIzz0O4bU8ruIqn4+FD5n3LtfXjtMRmvvN+SPQOcv5Uxufl0KOZN1ryl2e9oz2hwk69il96noEenza5+g7d3S9inZx7F+78YnvI4ifPOyJzhN9ciehGOQoLznYs1fwh/vZ/NAvHh/0d3lCHI58zTo1dh8Px+tzfnND/crjGZBjMusijm+S/PGP5z+68Szc8vz+n1vXJk9jax4Hfbv7vnNtR7WZ+U2Yx93PG3+6pPOJeD0D+XqGv2dxegRxn/OIxMV5Y2Q/aqzmeO32SVB749H42Gt8AF2fv6qh4729AsSBdS/CA8TlD7fVn3ZCZ0Ibv9Nnejg+G5OHmH600Ytov+C+tts3wf7wTr755iZ/+IM6qp+5fvyfoa9FNcOxY3XXN/vL4wzmSr4mjE/7gGMxJsQ688+GLdnFuAf27O7FuQJ++DNnurdC+91RjgEHNuqiJtm1xiboikP3teC//B2fiWox/cqlPeQMbOwVgCMJu3q8ZvzUnRhD3M7GaUJcY9A+Ybwau5fMx08B6kjk8jnhyy+//OIf/uG/fXf1hje8DD9qs7GQV2kTb2MmrokF36Jvw2tjaoNpgyfO9c++Ft+8ppOfKbUX50zw2rWT7Nuvbm239j/fxD6NTS3er8W9TfpenPqP/Nzrv4or+YrxMeLAa+v2LIhzxkV/XD4Wp9eOwWvQHLAf2ZvsUz2UJB5wtKULatMHs/aWkB7buSft0F4IdNZ9bUqxu975pNNe3N57BXytEhfn/PEL7d1HHNrn4wv0yuGMl3a2xYVdjHzv+ib081Vdrtbjpbh90JTndw0bxKlz3Krpa1Bd1XnWzzfL+gaXEI50PjTEIa0R+ZWrsWiOlne8VymPHfI5UdydfGg8M8aa11VUk6T1qNaJ2q+iPd3mI5m1c2yceiaboo/s6qA/X0cCxc3fGSbHqVt7c62cVn905C2XNT7U1rczy/lDQby4uO/8/Odfvvslyn5KoPtQ+XgJ1rdCXdt38OylYfn7qYPy99Lsffv1vbA6TFSntU/bWY1uPP58zyv38s//hPFrHu0wbeiqzRrnHtjwf2/uXQFf/BA+k/jcxvG2/pzvEBd5y6WxnKBjfp7V5ir4JsV9JvjMrzm6jrXczl4oZV+ebNTYcWdzNg/vIZ7JEacdso1vuRHnnxvK5ajOnyqaH//lv/z9dy1veMPj+JHJDy3oZC7y2Zasbeu1DWoVqH9KtiTM8xXP2mjyM0NN108Kc4hy/Fgb58eK87HwqeVzlc9O72y+fwg8o3ZXOL8kDhvihty5Bww3PDI/2HWc0gMJ+x5M2mvugS4fcmtv2oHvBPoAtUr2zumc+dQ+JS4zH21XwD4OUG3Y17eietEL+PbhhdCZvsCxWvBdrbVX//qTeNxDOdAXk+2HQr9k+gz6fRjtPH28HuUnp/ICvqpdcZozE//2b8/98HIEHNQeB8d4xbk5ULtj4+W89r9GqEtzPWkdt8aS2Z5uc4OAOibVdXc96z77po/GaEp2pJghP/cQd+DzHujGaaL2YuLjfOpVm9W+2s34M8c11rPhZYVvZzmCF1k++N9+1+uX7+Srrxxvv/tVu2/V/exnt2/CoOel9u3FXN+cu31Lrm8TzbnyKGbdVmjn82is9RfX+US1dczPintjkF1+HF3v4u2AG5vkNeAL8lP85lLAjW5reZc3yOcol/b413IGXJ7l6wh8V4d5f5KbGvRMdjRm7NlkV92m/ux/DfjA89F64EK69wGOzf/PDdX8c+OPqz3ztT/u/Ya/XvzIxLcALOYpbWJtNkfCNvkYuBLnnk4b2Hu81/9+3/miuhfnmTU5W+BX4pzZPxv3YuF7T0f/x+D8rDhHPuR6dR7c07tStyu4EgfOanM1J8jPFDevVdyAp/SgpM/5TtJND3Brf2ofI3TqT389JvbAoxzTmf7or/viRHtq7WyToI9OviBe67Hzab9Duc865XuCv3Qm4t2RpBuPJP1qAPXFlXR9VN8JOtVzxvlQuM7Jur7VN27lNkXbDtWiOlYzvogXbj7crrj13X+B8Ew0/vGDcu38h0S1fAbytZM5rkcydVfbjmdCZ4Waq33rr/FIZnvzKGm8HsGOxz1fM8f4niF9mLq1aysnWP3RSS+wJVC740tq8FLYF/74Rz+a+Pt3L6X6xsu3o/gtX+vdvez9iyJ0nXsx8NOf+jHS28suL7r6Vhfx4qwfD5WPfaP7XzmfIZ3qxsesS7Uju3rVF+8J+rccv+9ngk5jsfPhOl4wfcaZ7FA8/eZLPl6C6WvyVWfn/OPlvDjpz+cR19qD67UN+OBvzuOXIA6Er9f6u4LWJ6lWUA12dQh046luU6fa5u+14AfHq8CFZFd+UI2P8vpUIRc5lNvnxB1++tOfvav5G97wKP70Ta6PgXsL6x6XZ3G98bhx4XO6vW0A74+vxc3P6xw9N+9jPCPOa3OFZ+V7D1fi3ObHud6jfM9q9Iz6XcFRHO1rX21XZX0I6Jp48OkFlYd5/8u9inYyH5Ic1dmN2kOHB8Pb/3K//yCg/faB4P3v63NO4sKebQ+W4kx+hN3RmPIzefHR/9qDtnQIP/od60vy0XGCvnzYEufa6PYwnd2RgGO2bGqrH5w3JrNdjdjKEcpVu9iNk3PQHuKfLWirvVxmvCPEA1aOz4Tf1fjtv7eLOzCn5CA/3BonbY29/I7GaPaZb/zky8stbT4U7/G8DwBXMcd+xrZejcnVsfxYmLW+KqtdY0Qaz8aWyLs14Lx2ehPqZVznPGl/IrVV33RbO46vGe9sZ55HKO/02F6JX23K9Z4+/3RWvZVf19UCJsfZXt3z6egvIn5sCN9Lar+Dy19j/M1vfvvFr3/9m3fH3/72d3+6Jl9//fW3Y/9v7+r3s5/1I47W1e0FViWRzzff/P6dqLF8zT12N733teu6Nsc5N80zc4/PqbeOB9Rnjq+g33wF/osx0b6xWx9xgzme0HpIZ3Kd0Md/8hrgV15iTb7lqnaOxYp3e0J5xlfbyput/J4F8ewhr83/Eci7/WzWQ/49y1WHFbu28DFzmMAJX9LYNE5zDsuNbvI5AHdjdbaOPlX85//8d+++8Wpc3vCGR3B3xlzdbOh9rEVzL84VzjcXNz/H+q+Lc43H/Zpd9fOh64/HM+KUz7P8fGi8Js5q+5qcP3S+cXMUy9FNxU0x8RDXg1znbvj9cvX3P35x+1EM9vWRHnzYrTcsD0weJNyIvUTwP9f977UHqPnyaveB8Ep96CTs+YR4nflRD3r1i8vHhJz4gfhN6Jd7tXDeQ8cZxCye/Itb/aup88R1fstL22wH13jNNrrirLVwXe3pZ7fmCXFOcEhc65f7FWQnFr4fAiP9S/AB1gdZH2iDvNSHyE991rEwVtrlQy/4oMtfeZ6B7sdG44kzjrU1p+T0KaH5Seb+pf7EuMx9ae5vc03KUb5yN+8bX+vD/tG+VDudakXYuiYfG4/GlPM69+RwD61jubY3nUGNq0sQV3s1a+xWf9ri6TzEgT2/1sjxi+IfBnjFL8jPXxLz4qu//Pjll1998Ytf/OLdjzaqyYQ55kWZ/UedzF3zeR236qlfnRob9hP6mu9rH2jP/1wXIA9+w9oP5Twx81/9zT7gnz2RC/1p41zc1t1roBbNQXDON7+zNtWymOzYpNP+4sjHnKfAhr4jnbX/UfCDyxyLjwlx5U5wCWrX3rrCuKnN1AfXP1QeQfyVV2Pe3CivORc/dcgJf7xfO+c+Nv7+7//zt58p/vwvfr/hDWf4m29vrv/LYu3D3oo2p7ONp5uORWMT2EG/OLsPTuFKLDHo7W7GII6bxrrZTvBx+0WfHtb//Z3+L3/5y3d9HjZ8Ndzm6+H33/7tOE43wyOu5bPbMEObzVk+dPJx5EcO+o7qzwdR/x2u5BMXcdroV+jn52g+fax8rgJXOIpzb74Bnduc+v7Da+hlD5TT6q84+o5qstbOdei8fOYY6qt/PcI8v4L4ZRef0Llj53g3t2Y7nI21GER9jsYI6BRj+g7qIs6u9pB99eNj8hVfH3vH297x/XVif5t2gV8C0196+QZtZKI67/IC/ezXuJCt3PVPLnLRT3BIlw/5rTxCPsqDZLPGP4N4eLE7ym1CHPpie/nJ5ordFfhALN+X+LvZyMUc+/4HUqjGeMtB3dVpxvr6699/p/ddwwX4nT4fG/jLo3XQvMVdPsZS3xXww26nX80677hrxwmqaXWdx935Cv5w4ueRebyCH88O5uhrUH1f68e+xI+8742P9UW32qqDe+xZPdRfvnT4Pto3gN/qTLexqF1sHJ03ritfHNm1n7FpzBL9/oLhp/aS6yp+8pPbX+htLPz4Yi9UJ/z4Iz2/t0bOq8war6je+qvbhL7GQK1dq3fIv/ECuuZaNkBHP3vjJsY6nmz0E7binD3XNf7xxYntyv9R8CM+P50X58w/ve5LciPaXJMVu7qxrwb6P2fIp7lijgW5yVl+rW9HuU+k99rxfAkarzm/jmDe4k+3sftcYHxAjj9EnV8Dn9F/9atff3f1hjec48f/+I//+E8W9tECtYjbqM423zatowWj/ywOXInVxngWhw77Ix+3GDax20bmL9h4UAAfdm5tNurbA+8OcT2Lw0c40yFX6n+GNucjvlfi6D/LB+jAWT583cuHnMW5l08+jvqvQpwzP/rkdC9OtdvBDYUf6EiXDcGh89nWg8I8X4+rsI1z51OK7VxOzonzxNil67wHN+ddO2bfA8lOijXjTMSr/hXlcNQf5A5HOvr5idcOMwbdjmqNBzvn5R7o9ACvD8RrjPicfXzB9FFsvkg8gI/4z/bAn/78T7Cprxghn9UY9E+uE3Tk5KifXv744mfH7wz0q90V0H9prDPY91/qTz2Uj/3tLyEak/frDfSRapb0ny3fnr7zcRVs1w8HHxrymXMXB7jlfyM/++/BOE5h2zFxPesFfE8ptjnZvCSrHczzFeW32jwKfvDeraFHgAtfr/VTTUFeahP4L29HcypdoHsvfjbV/wxitIfOGq/tOMPqjw40vkCHfuN++71YtxcI37r9LCE3e8mtHsbw9iJE/mp9+52A8jeet31EnzY2jXH6UL3U2gf0WbP6QvXXrp8PvtgG7Z4Fsm0eTB199rc4rLFmHMKW0DtCemxxonumfwX4Eb5XjrWdoX6ccMu+/CaMz21c38dgX07T/nNF/OVCOm9+JPTWGqmF+vwQiMuV+s8cy+tzGTc843xvbn9qMDdunzk+7zXyho+Ddy+53CjcrHZoAVsUZws4vaMFc68f6BA4inVvYebjCl8+iHPftgEPFvn+8Y89NJzncxZDfzjLh5xt6uV8FqvN+V5dXlu3cnptPvDafPg56r+KHir4yeeU2sCR/uzveh4T66qHTH6C86lH0lmP6QfnjdEU/B3BufrP4xR6/Kwvp6YuTqCtB9lV4nnUH9TANb8rirPrg2pz1A/xmDFXeACnV35HmPzpk7g7tlc6D2KXR3ynTcLXrOv0UT/EcwW/a55xhCMbMdvf4wLxyR700Z2+0uMLJvfpr1ih9on40u18+q4tnXy6hjXW2v4S+ED8GvsJbvhq7NGLIxTHh9L3H2Jveo8gn+vLtA+J6l1uMI+NF6ntDHPs8jlFP1/NXdjp0cmXer4GcszvSxHv13Lhh9zzk15xk9ZVoh/qazzrI/a3UK2P4mdrb61mZ3UrBpvpc22PD184TOCnrXY69CG+jtbWty4+WyhjuZDqJX9y+9aoH7v1I3Hv/8Mr3cah+lQbcE2X3myfaEwbDzGrM9THHoxX32wJU0c81+kD3Tmerknzcscr6CsWXq7P9M9QTMAjX4n+cj+KMXXjzyaOgY6akInplx2ZtfrcUD2qSVJu1aW20FxY6/OxMOfBPZQfyKFxh9o/dTQunwtfUGt0fX55wxvu4f3u8hmhjeQ1mGt6LvDp+srCfw6X18fh41kb1WtyusrhGXUDfpJuoImbzpQeEKfQYzvbVpudr7WtmLPdedwmXDdepBt75z0Ekfrm9ezfSTo+HK59CeQ7mZyeCXU48rvWZocrnO75uRIniKVGsyZBG19n/rKZdQV1gOlz56e+MH3Rb57Fo/quyPeRvx2KE/JfLLarP/rNKbpH66G1tR75Tac4U6Bz/sSLQ3bZXgX724uml/+Y4g43Crf5w3cvsmZNxa1mr4nL95No38Uci5nLrY7v9xXX9IyH8T0bE7p8VYukNsKeXrLDUftLcMb3UTzii+5OdutoivbVJn8T1Whth2q76zMGZyh+epPvzp+23XjNdrZxmti1s9Mufn3W118K5GMf8eN7fo1GP8bnP2CtLz9tcJsLXk7++XOF9bTDrU77/UdNG4/qK8bErHc6jiv06+s8ZJOPFfqOfIb2i2Lc0z8CO1i5dE34jfMRqrdjfHbIz8qVXaJvru/PEeoml9t98P1/DM781xpV7x8C+Dwan+4ct8bM8VMftzh/bnMMX7+rsJ++esMbzvBuhzlb1FcXvEVyZaGc6TyyuVzBUSxxbl33uJzX5R7fK/k8S+cq7o3Rlf57Oju+2WU7r4mNa8rafnuQ+77o7/z2v5rH4n8Zd5L97YHx+y+4SFzmefyhG4WcHT3kuKH7X4ak/kBHuwfW28Pr+19cvNom80GhOFMmj2eAn2f4qk5HUNOjWPdsJ+he9TPH8QzVFtgQ1+YC+3yIWf3neExkn05oXhH+0lkhBjtzYM7FjtNn0E537ctO30T+Zw3pEW36juIQvOnke7cOSWst32HGWmvqGG8yueSv9ZsOiVvIrx9PvK2/D/O/gcXE0YfTfgz+Fvv67606A19zrD4k1PIIODR3iGvjMMd5h7jP8XkpqsVrfa3z5RGsts7nXDyTbNc2UMud0OmYPaiDehiT1o626r3eV9JZMW1WxNX40smXc33xmtyyEW8iPe3p8DM5aRerXGpLtBPr7HP/FtcR1PcPf/CsMP86p/P2kz8fL7XZYdWbYNMYNddW6G+8iLHZgW3j1nhmow/v2kG7a77n3DkC3Vvut1j39FfQZace5TxRuxjpNl93cfA5qi0/+qrJzof+8p/57GJ9Dqh+c38A+VTLifL/IVCN43gV9OUmR7nKqdw+9XGr3ubj5zTH1NdfXPQZbp1Db3jDxEedHVc2Dwvt3mI786PvShyYYbIpvsuLbv4i8EjdHkU1TWqzUREb7Dz3QdjG5Xx9KeXtPenDcu3TR8JHUtwg1x5IHHuwIN2wepB07ehllF8C3C+A7eUUmXbd0In23U272LPmz6r/M/xc9XFPT93V4EjvzL4xewaXfDXH1vlwBD4bW2Cvbc4p1/pd69/5pn/Ez1xuvsJZHvrMNyjWkX481vlXDSb42M1VutqarzvgTU8NWi+1zZzmGmndtKb0pVe8GdcxWwLlTsRSR3uD/WDWdI6HD4Q+KPIFu7F6NsTA//e/l+u/vOP7DPD7Eei/g1qSs3rNMQK65tkj620Fn4+g+faxUX6OcWgNEDUwJ0nzM9G3m6vNe2tjrpmktaDmdBI2pLVxBZN3KP4R6JO5dieHdc44rpzqq9113EM6sPbxL39t//qvYnsZ/l3nXyDMF7nK2R9N+rZyQ/bY1XK2TehX08a0eTlhDOY4ZDOhn4/s6cxxBPY7HtrmHFrjr6B/q8ftw3rxrqBc2Z4hTsT6PfKvfReffevVubhH+6J+fKxx/Vdq8Dmg+snvCPrO+j8k1Po1sdkaXzny1b6+G+NPBTibazgmnwvU9h/+4b99Vpzf8PHx7q8runHaUI9gsVoIZzcCE44c+TER+bEBnPmhY+HR26EN32ZyBDogztGmdfNx+1Dm3FthR//r7oMX25/+9CfvdM98kKONW864nOXDns5ZPvk5G4N7dcvHEVcoH/1kbh6dFycfta9HmOdXkM9izzjrEdJpnF1PO3KvbuY+HNWfPzWBo9oCP/p3cTwU4cEX0DPHJuIulge2I/gQj+tRPuJAddlBHH7O/mqXfJovR7XRj+9Z7cyXPoSsuMe1uaZvZx/EUeO1pgFH+colLnyz6+H4KsoJd7Z8Tm76YLbTJeWyy4dda+9sL5jAhcCaA1/5wyXgEf8JMelNP3T4j/MOdMRZbR8FP+YcX/zE5wrKNb4waxP4rb63b3w8NvafJsx9a/X6h6Dm/iNQN8JOrdXQ9RHoWJOOYCzZzHrny9FYrNCOa2v2CHMux+0lEA9nXMs1OE9WxM2xczzk2pyDjlfBh/z52NXnKvgg/OHw+9///rueG+SkhnIP9NTxKG7rla1nqHiu+4CYdKvHOjbsoLWOA3+zVmLQm74bC77zaf+/veR6bG5/LlDDr7766tv6/Ou3edvzbntzdTAeaqet+q21c82P49Ga617qyK+2CTFaI/r5dwz81t+cElNbMenzMxE3do2zawJX1gAf6sDHnC8r6BHczZ/qdRXs2PMvTph/SXvF5FRsWMdsBX/V96V726cAtekZTe7VcMIYk6Nx+5Awb87mzCOQV88zxrU18SnD+DQXPyf86le/evefh58b7zd8HFx6yXVl8duELeijTdiip8PHmR8bXzeDHdrwzzZ7OoSPoxtHPrzUovt3f/fL7/j/23cPS/2PzfHDaTmdxbmSzz2uR7XTTkA/++mjvvS6DvN67buHlWvX+Zlcdsdd3eb5vbqJo250juaTvntzVxw4eoAqDhxxAXPl6Oa8PizSWV8w6SP0zub2WRzAlZ+zuujn5+ilEKiL2ol1xEesM7734twbG7b6z+oO4py9tJu5ELVhQ+Y8O+Kxgp3c2bKZ+edTe7y1dWx8HItJ2GjHBceryDe7ifyVL7hWhzkXAQ85rPk319iv/kEMYHekcxWTG1Q/csXvzKd56Th50Ung1vc+llydJ6/J52MBR+Pkd/NcgZqQ1+RXfavXDtXZmNJ3Ttdzxq3u71+YmUeN8+SlX5y1fUVzJn/msvPa1uPaxm/S2p3xZtx5foYrvO+hOsPRHnsFciL84WKfnJzUQb+xCq0HxxXxYkOH1E74a25Ub/rVW7v+2qtT1/ril71YalB7HPBj+y//ou/ltf7U4YWWF1zffPOHd+debKtLdWuMra85Zo1J64uua1jHtlpXV/dU1xPi9UF4xk1Pu/FjXxxt7e2NdXoTfLBJJ7DL/2qzQ37ObPTj1H70KGYMgm8+J8pTDHUqvyQf1WzmPVGNz3Q+VcjRGOLdnJOPWslpQk3SuzLW0BiIU3078lWtkyOY743DMzA5kUdy+iFgjOL5Oc0xXP/n//zn790f3vCG8O6vK7YhHKGb05kOHxb10eJoI7oHseDMj1hni7BY93Li4/b7G24fxvNrkbN1fVabuMCRjv64dJ7kv/bOcdsJHcceLGZfdqt9Pgn7I+CXqME8ryaOfDjarOubkl36uz6Cz9o+oX/q71A+fBxBnYqxgzhw5KMY8T2CWh/FaRxm/debnT7ymjiQHzjT4ccYHQGPYh3xOeMbD3Jk7yHniMP0fZQHFIPuka/q35wM/OY7HTiLN1FcmDZxIrO9eFPYi00AR+2vAZ9iw8xXvXtYDmK1loN+evqO6o9v+SWvBX/Vs/VRnEcR9/LiI77fby/f2xj8p//kR8g8gN9eTPvWxEvifyyUV3IP5kBjejRmzUn+qtMOdODIj/Z4Na6Oc526rs1xzSGexaAjbnadh+JNP9PHlOZB547snLcOV3kEeD1qs4IPnGbNHkW1qibrvUffWkfxjmKmL7f5wWIexWoPoe9YjUFf8bSDNtzSAX7EopNebdXFM5wf3Zt2z0S5iPnt1bvrj4VytT9JT727njy0qeeufqS2rqvlROPKh+fhdAMf+rKlW9zQvGGnzzk7kj/6+Z1ctZMdt2m7698hGzxmnPxou+prh3wWwxxxHvLfmBQrXjh03TlMrjD7X8P3h0DcHdtPnDd3VuibNrDWI9DJD121qc6OyfSZPinGlGyfiTis8+NTRHWAZ9fhQ6HaGjtr7Q1vmPjTS66zzbMJdDbpTbR7ftpUzvzYfODIT3HucSFwpMeHr7Z3Q/ajifnV9h//4X9e3m+g+uLftePaT9pEk9k3+ztf/U3d2qccAfdE/RqzrtfzdKbwf8v//Ystki3UV9sqfDhmt8O9OVWeZ/0JP0dQz7M46gtHPq7GOctnjmPYbcb68VXbI9zLB+J7Vrt7ceLMx1lt6Oz6i8F+5ZHdkS2whZ39xIxz5MvYFGvVmb75Sq4i/dXv9LPyX3OiF/9V9yWodnN8tVWHCTFby4EO/R7OV9T/TM6gDnw7xqk6Jldj0Zu6XSd4xz25xXg/973sco/Q9+nDOng/tsaHlAsBxytjdq/m1Ys/xyNkmx6Z87I2nKB5dcTvXqzs1mNI50iu1uceyus1fvKB09lefQ/5ILBb7/YGeqH1EYckXUf9K6/pd9ppb4ydzz7Cn+Nubuib7eaI9nwe7VOvgRjWv5fe8nXt21O4JNrp/OhH1tn7XO6hnEhr1JE/z5x8uraeb3LLtz9e4UV1bUTu+dmNbTpQ7J2OI4Hdt2xmrfXdON54gPb8FmMdcyjW6r/2bHaI3yPI7zx3XOfuS8Hfun7Kfc5NxyTseEE6rtUY+Ju2nwPkhP+cl+VU7qHxqA6zHjtUl2pKqlFS/w61F2udy89E/u7l9CngU+e3w20+3Z4ddp+t3vDXiz/tMvcm9qc08Y82IBzj2dGmklgIiX4PED2oZOthRf/tAef2sHF7+Pj+edfJbJ+yi+26eNAR5EZs1qu4CVjAO9GX+N++VdLhZ2dTHyl+XKZcAb2Z04fCFT73eOTjnt4z8znydSWfq2NwD/f8zLqc5U5v15+debSDNXDUB/r5PuNZDGL+HkE/HPnS3hqA1mzr9Aj4T5sweZ/Z0+Fjrscjjlch3qyda9JeNKFf3DkO6Wc/UZ89DNitOleRr2Tlpi1+XafneBV8NE75grV93S+1i/Pllz99V7tHYn5syGUdh+4zSbW7MseqjeO0X8EX5JusyBeBdKc/5+l1PfsnGrNkXTe1F1P7lHugcxb/Kp7l5yqKtUpj4jw0VquE6jR9JM0raLxWsNdnbNi7zmfnc9zy7XzyLHY2teWz+LW9BsWy1j37ecnj25xebN2eBd+/hLrpzD8ccPuA1fNdL6Zu+jep72Y/9cTsOp33+rPWt3rh+q7pezjLv9pBemtbcbSLv6J6Zxe3GXeOJ3ROJ2le0NVXrtNXMSa0EfbT5xnSbx6yS/L3WuR35cJ3+9BE7dVg9vOxjnu+y+VzQvlUm46NwQr1qCbypb+bH5APutNmhbZqV92TaTP5iJP/GfOlKL7nCsd8J58S8INq8DnBF1W+/PL4d+K94a8T734nl02kBd+in7jys8otWDo7H7DTWTcRDw36xNth+liRrxYoP+nXfhVHOUzkf26WjtM2HpPv1MUpXmf17ffjtAmtEOfMT3HoHdUW1J/9URw3HbxnzhPFgLN8zKk2/R3MSSjWivKhx88RrsY5y+dKnLPxuT0If/+D8rfr7ruz99DPz9nvyro3Pnzcqz8dfuSzyxnkS0ecI73qIs7sj4Ocd7no4/vs92HcGzfgh/BxlqtfqAn8pXcUF9jgDjO3I5tyPavnhwS+wXjgQNSuMTKvJvSbrzgHuunrW3Opj/C9jvtVxHd3bEz5n/Njxhb3pbHv7V+heK3H+RcZP0WoGa7flfLPIB/9j/4Omua2elWz1V6d+CdH84YPax6MHT1HtvraJxp/PvRfAX0x4KrNEfCBe/PjHvCRrzz5uof4r8iPcVuhL47ZTz+dV1MCa26zftBYx3vqGiu6+to7jupErxqks+rSUXOir7jOG4u51rUVP35AxzedVv9nKEYc5OaFE8ShGHTck8zTYmhzfvt9YHzd/OTvb/5GXd9p/slfvzfMTwrMGI7siFwcQ+ffqrw7/+lPb88T2d7afvpOxzyJM9B7H/v9N77Wfb+jvvVeAXzkmx4dvgLf83e98VMtZj7s86F/7gnZTm475HfmdQXsqtu9uXsFONzmzP5bXHIitR1h+sgPe/XGOV+fE6oNyF0e7QONw6xZ+TqaO+aFI9DT3j0D2GsjrxnDYD6bE/FrLPJfjGfE4p8A/1fmyMeG+rZPfEq87gHf3/3u6z/7vZNv+OvFpd/J1YZyptOm8IiO81BfGwx0o0zwcKzdNbEhdr7qOOZ7B1xWPnNjaxMiNtnEYnJk03l6bJJqqz2fSSjubFshl3gd4cyPvoSfI4iz8puQDxz1x8HxjKtxOstn8t3p1IfPWT734pQPvCbO2fiw1c9PMGdW6KdnrhyBLzGO8inGGd8r+cRZnHt+Vi7ayZGtPr6tmSOc1RPy4XjkRx/YH/hxjS8c+Q3xbj+Beza7WnwMlFcfGHCPP+63lx/v5x7gqW6TLx/lsBs3ffx5GOWv/Tbf8aBD6q+G+U9C8Uh86K/jmk6+YPK/gkfsxKKPv/OzdfmpwDdDdmiM5CL3q3WjJ/fm1s6utubEUZ2aHyQOtWWjzfhq38U6Qvk9YrPDI/PjHuShdvd8xd2xehD2ifbWkWPPPOlmNyFu8dNzrtbz+WW11UeHZJ8PMemDY307FJOku6LcxIlPeQZ9Qd6uZxv4j4xeHF0FOn6Z++1XVajD+5ekOM/c8MKpfnhfD+vKvujZ8FY3NbRPJq6reTrlUQz+v/zyyy/8MaTbC7JbTN8k+8lPfKPU2L/fR4FtNXM+/Wkvj5DtzCNob05NsKefDU5zHsDsh7ho48+4yX2OT/nr55PA9LND+cR15neGatT5rNVLwEccJsqz+s+cd9A/c2ZzNKafCxrLciPVSt9aM/3lOXOmqxbVsutsnlUX87MxiEPx8Q7PiMeH/OTDtxjF/lRQnjji+rlALX379uuv//xLBG/468TffP311+++yQVtLCt8SLIISRsMtPl0bkFkP9vDqn8Vk1Pnjmv77JOTfGZOU78bSDnZ5KrD7UHk397lo8/5EdRmvXlP8CvOkQ/+r8S5982W/MBuw9RP5MjPEe7lU43ktNMpDi6vyaeawIfM514c0G8cPaweoZvkLo65pr844M+4z/kI+vE9+yYXX2KwXe2BD3JWf/3qhu/OB7Bv7qrvUSx+8Jl5a9O38x83xyN+zbHy3KEHj3s50CNqyl/xxWheHNmH9OM8c51on7zi81mIGxinyUGfa7xX6KdPN6gT3d16Ko685rjRT8p5PV7Bb3/723cfVPEVx9yL387PzE3/KmFtP1unO/BfTc0hv4j+U4Tc/MjUz37259/CmJBP6/qROkDzg82cN0GfceF/fuMF9JG+Vcm+eUR//mXU/Dge7RET9FoDV/TP0DqX48r/CLs+bepVnVyn5zh9O09COuxne5h1vge+6OKTz/b02uMGxmI3L9yz6akxcZ6ta/7iqs266Z7Z/gF08y8+m3Xc2LKhl/4cm+xda+fjpnubV/VPvOfmvnB7YcR+hbjFnnHKJz/iknL8/e+b898fL/HY3vip282fGJPD7fr2FxKDtvrnXCpnba6NTf4nZ/60Tc58rnt8sckKMWbe1jD9oP3smxPxnfVcIW71XOOdId7lfoTyisO0E+9KrAk8zd1ZB+iexa+8i9O43ItTrcyXwHaO66cOOTeOK+ejuvV8ttZHPeizcw50zp4NXgL1bk/cQfw4GAuxn4GZ37Nzei1wa41cmbufGv7f/+//z3dnb/hrxt98e3P6X+uGA20oYAGa4GS2T+za56LonF7nu35cnM9NZOqxL1Yb6OwPNg4+jjYji7c4/Lkm0E0FF33Oj3DvZQ0e4hz54P9KHJuw/qM4+YGjnMsT3yPcixNXOe109JE27SM8Kx/1nQ+FK5oH9/KBDxVHLfSXDxy95DKf5ge+FXyBOLt5D+Kc1V8c/Xyc1QVnOJrf/NBb54I5pm8X/15s/ezVkt9djmKSIx8QN/OML1zypb0jvfwc1ZMOgcl91ecP97N5/SyIVR54xAe/mZ/rCTrqQarR5FpuoTj8sJ11DNUGfvWrX31r//5D+6p7BHzM/a+++vLdtxl24zbRmODlSIf+RDrBebWZ3LLdxQHrgK0fWbzyUuGHAO5XXnKBGlSbcr+CaXd0r6q/Ndy8rM8Y86OND0djuH6obc7l4wz06OcXpq8rSJ8PcD194b7iLAZO61oKRzGCWOkc1Vm/Gp/dkwJ/5jB9cXDKzjrDNehbX1CCeMbOeCTAd3wdy9m5eK3f9CDdsI6xfpzyp5+PnrWcx4+O3NpztTve/uLi7bofG+Tz9k1HXG62O1SPfEFx5n508/f+JZdvYIE23wwLbLXdvml223eJPPnKn+t1TKvV5ALaQD/BTZ3wm5z5a50BXVzoTdBrn5tgxz79VU+/uGfzkE1jEY8V5RG/4jb2R8CDsHOcuQbtzZHJoXj61zl4BvrWTbaBffeHYugnj8RJV92c88WGLfnU0b27MZ8wtsZCXoFOL7l2oMuOZMdmzo81zlXM8cnXDul1/sxxKD/HxvneHPlYwKk95FPhdBX2pF/96tfvuL/hrxc//n/9v/5f/9QCa7F3DnNxhzYV0kbWkVikLdRV+J79qx7Unr8pEB96ta2Q01k/HhMz78lFW+c73IujH458lMtr4zRO8d9BHz9qe4T5QLJDMWCnU/+9fPSzf2kc0H8vH/1nceBKHHU5i1M+O+jDozjQ/J64kg9fcC+fs/rrn1yOgAsczYf8kPqn7118PnE7ypFtN9Ud6od784ue4/pAj+sUOuv4rEgX+J3XwfXMf+1/FsorDgk4yqU6rzmp2XxgyY5Puq4dq9+Ko3Fj53chfPPN1396+Ox4Rdj7EPvTn96+JRD/o7kH2pPqnq9s1vPqlt8z/4HNjcv7bx99arjlL4/b2J1h5ttcgXt10P++FsdrLz/0nK9+tTdekM6qB+agMd2Bn7kWG8udBPrGcKdDymvXR8KuLwHczuJUm938qx+O6qx2dI5qs4Kucc43brU1DpC//KfT/qB/5cRnkj5Z18rUA7p8rf7Eqi5iOvIHtUMcIR/aiq/Nj668/+Xu75/xyBHoTJ5QrMnVtTjVzHW/tF4O8XB+073p3/RuL4pW0beOqfb3Pm4+5znBtfkW2OmbY1qMmQed/K/gc+bnBQYfgZ817gRdufJxpAP6Zn/5hau2bCY/53Ir/vSz2ok5+48gnzUOu/mCceIlcfTTa50mxbxn/0NBrct3x1H/Wjs1W+f8BD/0yTyvJum8BPzghMM9H/pfGucM+SXyqT4fItZLgE/8Pifg7fc03tt73vCXjR8Z/Ba4Y2JirNf3JL1ujDuZPkmLJ7kKm8AZ7vU/Eus1eDSvl6IYr63LPdyLc5XHVXzofP4a8egYvaTGL5nz4tyL1UNNe8cOfPQARCdZoW3uQdmdcaAPR1zrv+fnUcRtPiBO/mHGXePTtQen3zW9ahBW22IdQZ9vJ85vcT2K+SNE/DnKd+a8olj05T7zr69+Uv6dO6ZzBH18HnH4VCAF994rKGc1gHVuvRbNq9Vf9Yb6q+9E/KaPxjeujqHx3Em+6OSr61XSnf2zjYS1fUp5fYqopslEnGt3rN7ldWRXrWDq7XSnTKSvfdrjMP1D7asf7be/jPiTdy8keuk0P2DfkxW7thW+vSXGnJcTceRr1cm/HCfKTT/uycyleb7WZwf6qw4uxZ8odpzoTL36Vs5h1b+H4kEvzmbOZ76mrXymsDuqTXaE3lEtoP6VC9vqf4RdHHIEfXT5VAtHdnPcPyWsOeG+w5pzNTkD30QN1Lm5Uczmx+r7CvJ9j8PEI7pXwWfruNx+6HGetYnT5wY/Wq2Ob/jrxY98pY+0eXTtfyWSubmQFiPRR64uhE91oeAeJscPzbe49+JMfp86nsH1Wfle9fOMeXuks+NA94rPI5zZvsbvxCO1SzxoONoTVsTrzO+ZLXHDat85Ar3JI9sjtJfhVQz2+VhhDzzqay+EZz2k8EHE5FOM+b/G9evrf5npBnza28szZNvero/tjKFfe/GOwPdrITbhCx+5lA8eO+BG2PgQUE47lMNanzPknw0unyqk0UvGK6DXOEO1v1drOOqfqG4T4s21Fnb+6JgDjenkR/Tjvs7pFWyzvzJHzvrCa/rX3F+KR/zQXfXVY8Wso/O55tWOfeuRrPGLw04/XTrpB2NAZ8YD7XM88++oPcy4a/strh+vvP0oZnwd+V/b4kbY56Nj50eYdtAcJ86JeVxb9am/mhF6MGOTWQ+ST/M/SWciThNTb8ZZET+gp3YT5XAGfvHccVsxuconu8aN7HgGfKoDvcb6Hsdq6YhDc2KiOrm/rn3V4V6OxaE76z7zdh6H8qfvvOte3NKZtj8kymee73Jb2+Be7bKhUx2qBahDL7J3/o9AL79n8T8mGmuQy6M5PQNiFbP1Y+5+KjV6BD/72U+/+PLLn72bH2/468S7b3Ldww8xuc8W9TM5v3aT+yFq8yHxsfL52HV77Xy6h2fl86nUv351O6vdBL2zBy83TnDDPAJbN9Ud2F+52eJQLHB9D3yK2wPX+mMZEzjoO+rPx5nOI5BLOfSiaoV+nNf64+Ghid2udnxrS+jQb4xWX2fI5hmQY7nK6d4HHNzopn9U93s57JANn2ccfmhImfh9RJPzUS0mjHm1O6sfXK0hvV18cZorc26vYB8nwDHxYVbfFdDji5/iHuV4NbcPjV3dJl7Lk2+1nzFa++q1jlF9rUltfdCeyGcvXuhau+v6pcPnzENbYzTb2Yk9Ef84huKL2zyJR34ds6PfXCg+0Y5zLxSc72q+2iTxY5f/aR+fVQJbdvZ0wg80BqS8drx2wGGHo/Z8lws+QXs5HIEdoXcFdMVorBs/MWYt74FdvNidcZzAM67Ve2KtAfA97a4gGzC3qhNUA/1zXLNZ11R2PyTirz7tD7i5njjiWi2OoB7ybxzVRR3EqkZ8i/nIy4zGs/n2qUCeOM1x/pioLs3D6v654he/+MUXP//5V99dveGvDe92oW5kZ2gjO8PclF+KuWmd4V7/PTyD6yN4Ft8zP1di3NO5Wpd7fq7m+1o/V/I507ma72vny2vtw718whUdN7PEDa0bag8L2vhxfft9ST999/Xfzlcdfpw76vNwPm20keKlH9ds15tq7WK4+Z/VMt/QhwH+cCn2Gfh2Y/fL/+O4Ax544bQDH0TMl0JsdXMUb30YK34fhKpjEL8PQzvQx4/eUU3VQN/HeND58Y/f/96f0EOzGuB6VO9AF1f6R2NH52zsVsif+AXWza1PGY2lHPFVtyu81a31Qn9Xn2pxVNuJ5sw6L7XH0dF4rHN7wvzF50rMI4ghN35aD/yt3EDbrj3gfNYP5XeEezGu4F6MFZO3Osz4jcOE+qQ39xDjNz9k2t/NFbquG3dwPveg7h2uJ38xxGseuK7f+fQJjd3KWVu20z/ELWGrrflH8OrauV+IPflPTFv+iif+nFva1afcuxd1Pdsc/eENba0//nHAJX7FegSTTzhaA40P0W9sJ8r5CDufZ5A7genXebk7r27r/F2hD3d2bNTyCic2jX1j0DqIX0iXPIps8RMjEUufMV6hXQ2aB3SbP+v4fEzgQVojcYTygh3HXZ4Tat58JxPaq0VzRoz2I5yOoM98eOla+tBoDvgVENBcfHRdPYrWCohfXT93fPXVV1/8wz/8t++u3vDXhEtPjY9sAvcW4WsXaVzu+Xl04zrSf22cqzyenc8RnuXntcDjGXPlWflciXUFV/0c6e3yobuKm7QbetLDRDcp/R6YewgiPUiTHjjyB2In3eA696DZw2bnHi5ID3rpOq8vm6nXjbMc8I2bNjJRvnzcQzdoMYrjiIejeMW5B/qzPhP5PuoH9ZCveEc6O9BtDKsbXxPymDWbKN9y3kEMdnwfIb/Fdk3KeQq+/4//x//2xf/2v5H/+/fk//Z/+4d3H9x8dRxnuvjn6+Ybn/2H02oAc+4eoXGb/ieKses7Qvq3v872aUP+rbPWo1q0Nu4heznvaq2dv3uY43AG/s7ADx9H43kV4lgT5lA+r9YkxPU1POC19uGqH7wTWMdk9oXGTrt6rf2129+dmytstK3Q31x0vvpix55OfeW2+mtOru2NJR9X60Jv1XW9cqwtZJPeFLxwIPaurp2rlf9AUYfazMmugW/XtZWn/LqPT9nd3+mS1s0UHIPrFfobJ1zUe+rhNHkdge09nVDtirdCnzqpFy7lutPVDjiyYwPV4wqKB9V0Qr8aXc3vDM0R3OTfPDiD2N3f2TTmHxvq3ziryUTzBIxX+QX6R/WjR5+c6TUOalis6kF2451vOPL7KUFuRK3ltJvzr4WaGCPHxm0dz88dxtw++Ya/LvxpBzC5X4OrC+Ke3sdaWMXZ5a3t0Xq8tn7Pwocex7O6TXwq9Qgfqy4gVjdo4nqNr70H0W7IzruRrW1k+lr9uVmTeYNy9ACQ1Ee6udPLdpVycrwi+DkWfwq+nec/HumDmzk/cncs5+zOUI3oTp+O2ReTrtqudZygC3zuwA+/R/3FhfI4g/54xXf60M9PcyOf+aU3H/im7UQ27GedVuCijx5OjqvQifPtw9b3X6wS/7P6n//z330rf//Ff/kvf//Ff/2v//WL//bfyH/74h/+4R/evQRz7iFrx9l189e53MUs7xX5iN9Orxj5OkP2XsLRl6N8P1XI7d//3Yuq7+8FjnPeHKHa7FDfmf0EvVV3tvF3Fg/0G39HdT8b+3vgQy3UINwb/xVXYl/J6Qz6r+jMWl4BXXbrHNCmLkFfdW7u7KB9J3DEa/WHS+ORjSMdeyCZSGe21zbjzxiP4Ij3GWZc6Lq2eb2TmYtrNZr37epAXK+y9nfOvnEsjmOY6yCwj1djM2tS/xmyE+8e5tjx7do6nzHjIx/3N375bz8I2tItdn5JNo73wA7wmFwgf1fyuwdx+OeLFPcM5dT8AHs72fH9EFBDcXDZ1aH2ZN1n9Z/lapyyOxuv4jQ3XOPFRj3W8Y4Hm7P4nwrKzzg7lw95BqpT/or1udTmERh3P7Z4Npfe8JeHp4/2szbXe36eFecersQ502mjeEY+HyvnTwkfMme+p9j8VrExEv2O3WBW0TftVt87mBvdVDqfsmufbd2MapvXpAexKbMfr3ytEr9HkL8dqoG4UJx5Hcf6qr+j63swDlCeK4qXQP53Y1RMfbv+/BzZaysXceYcyWeiTX82+Z4c6DTf1ph0e+Cthjvkh8RtBZ30ihGfOCWuJ2ZfAh42/Tl/L7J6EdYvBfUtr5///Od/Gr8d+Ck/nFpz8Qv1QdzoreCvOmVTvgm72mcuXtoRX4GXDx36nxLKz8suMseu8b/H+az/ar6zbuEltYo/YW9sduN/BY17vPhQj0dwJe49nbUuHxK7cQj1zX61rSbqdQ90Gx9YxyhJb6I+7frX2JNX7Svf2X6Ge/1HwG/Frm2HVa98z1B+STXr/La238vUI+v5vJ5YudCzz4L2ORYwfR5h9XcPYoA8Jsdir/7o4UhPn/23fZpNuU5om+3pnoHOGh/i4PgMiAE73vdQLaqHOrjXym3l/WxM3me1OOo/yhfvxrE6N15HOeVLHfpPPmAzX3Q15kexP1XgKzd54V1ejcFrwQ+/z5zXnxrMHc+dv/jFz59Wtzd8+vjTSF/ZEJ+l8zHQQr3Hp/51YV/N42NvCPd43eNzha8YV/M/wtW6XI0Tp1Xqs2mdyU5n+plypDPbV5l6K9RiVw83lKQbGOlmPftrJ/lb5RE8or/LacU9HTXa8dTeg4ccO8ofpt/qvEN++K9GR9BXPdmdvaTIT7GnaCP1r5IOH87xI9M2qQZ05V7cdPX3MK9tovnSnNlhxsx+p6svXcCD/+q1E3Ed6dJ7RCbv6lTsFdWGbrmUT3ZJXI58ao+7c/1qPH1Mn8Vmo90LOy/r+hHMXnY1jp8CqsF//MetDuUAcrrHVZ5sdtB3D3SSMxzFWPE+n/cfVJMrfCb4gfhNH9XqNbhnf7X/LC86j+Z9hMlnrQecxUmfj9VPfcmRDsxxbS3OftAG6UIxpu9pA+v1GY50V+6PYrXd+Trjqe8o/trnvOvO1WzqsJnx0lnXVzr621PPkP4coyMUY/KLw4y/8sSjvUBfL3byteOY79Z+/skKPvkjMzbE8xkoTpxf4peNnOa9jFSPD4G1bvfirP1HeaoHXcfGtzEu5lGs6td9unGqxt2ften7HIF3dWluVq/XYNaL/KVCnfwi+me+IHzDp42PPsr3FtDVBXZlUb924T8T97hcyfsZPuDMzzN41O94JPf6E3zWtvVm1808cd1NreteEHSjm/p8TrTh9+BAOvd7EHbSV+jp7eTq2EB5HuGs7xE8yw+oo/x3EGeXv3ZjoW9Xo+qtj143pnXMnBvXIz9HoGfcgI+dyMlRfMfirxI/MudY6Gv0R9yac8WbvvPL5wRfasS34853efCDl3M1WvXTS5eoPT2c4r7K/JE4ti8FH2utd/7EiRc9OeEK2fU/uXSrabnvQLd5Rid/teePOO/30rkW04suX4P3bTTf8LqN1esfPJ+Bxuhf//X9eDemcMSx9vRWNFZnuJp/vK5CbDmov7Ga8+WRmI0rH2fzYwXbe5z1n/mr/4rOGZ7BWfscZ/VsDfBvPrsmO8701XGCz1nfxmjVK472Oa6Q3YzrnN7MJT7luPKbmHZh17bDFVvXa9sZnxV0z3ys7St2dkc2ajtBT/2BXWM2YWzucWi85pw6grkVZiy29liY4z+BizmGM07WcFh1J+iyJd0/ihGc4zbbqg+7anMW5wqy5/tKvY5QTmrGD35yexbPkC9+xYNZv10cbfp3mHXPnsiheji2l+QrvSM0L9iwp1s9wpn9p4zqYazN0ebwo/nQZ9dY8mse/TXAr8tY1/cb/jLxp53nbHJ/jhP/Uc5H+lf9HC2WZ9XuU/NzlO9sd07aSJNuNo6kb0IQXyftfNXnZ27mciE2Z5s0cWNzA+gm0M2u69mWtLnnw/W64V+t21FdrqB8noFn+bkK43J0k6xvhTGlf2QXmkPgOG/qibaX3KjZssHFTS9pLpJizZtivM0fcc0pLz96AdIcm3PKdXxrn/3aWw/FJrgVN9BnV4wzVK847erDf7nrp5ueH3fzkuRf/uWPX/zhD3/84ptv/vAn0fYv/yL32weS16CcxFWDNeeJcpGXGtGvHjM/5/ySXR0n6LDnOx5H0E/PL5E25s659sLr7/7ul1/88pe//JaT+fKdwQ8Iedz43j7ABu1n9ThCNb0H866aTohZ3LMa3wPfjZVY5q758Agmv7m+n4Ujf/fyrv+ZfI5iruNpnUDraa6x+ia0sZ8+At/86HO+cmi8pq2ci+3Iv7Fpj5+gq78YR3hkHHZtq/0zxmVXD9i1hSMbWNvPOOpb+9Wv+hoXdZ06/J/VeMVZHoF/esVbYQ6IqW/Xz5aOfRh3fpqnZ/mXi3s1vanvaL6toN99x7n5eC/OGYqTv2egnPAE/u/dSx/FXLOT+65mIHY2gU1re9aw83WdQzZwJSe66tA9AtiwNXafO9TDvIf2x0dgTIjaNIZ/Tbj9btU/31Pe8JeFx54IL+DextON757evf7XYsdjtn3o+CuK/TFRnm12iRtNHxoSNwbiYbcN1bcW+iBevz72wFd17KGCuDEmbkC9HCB9aOyD47xRTbs2Zn6nrKjt3njubFdUrx3Y34sx8YjuijMeE6+JAUc13cGYH+nX140Ur/kwc3aDNc8IneYEYTvnJ5gXsM7f5m2/S6n5SsccxY0/woeHxObinI9kzr0z3jtUG/xaN34fld/t1J+Nx7fakB3ix99cYxPaq0FrqPi+2fOHP6jl7aVbMeXGL3344x//9Yvf/14Nbrr9bqcd/uM/9vO/PBK8jjgDjo0BXnI40gV8qgPZIZ/8yPNI76XAodr5k9+4i2Fczbfq/kPDuP7+9/4U//t1elRb7Wd1r+ZHOuZya+Qof+3PqI0YfbDDR81bQ/cgPntjR9+cy+7MXp+5uUN5XYl/hHt1eU2MacPHHKP2RG3mtJraAx1hPgOoMWm/OAIdWPXEEnfXLr52R7Ed8Wr9ymFK/MPM8bXI1xoDdm1XsON3lEs4y+msj7+dz7l+V52dP2NwD431PV3+jbOxNc8ImFcr+Krf3DvK1R5A9Pc8Gp8zNL/osmluT8ShGpmbrYmd/j2ovfynz2eC3/ZEseyJeDp/Dea4xVtt1ENMMfQ3Ro7JRPWcNVT7OdY7iFlu4pCznOgnccZFPHPp0XH7FCEvNZGXnK6Msfzps1Pzv0b4sUXP3evcfMNfFv60Giz+I9R3ZTKc+YHX9oereq+dwFf4XonxrIXEj00ssUkTm72jNhvYlG74zmd/Nvl0lE/SzasbGGlDJd1EZxuhn/2U6ZuUz2vAz5mP4rwWr/Uzcz7DvXyu4CrXK3HonOnVb3yvgG5z11w549rcpGNOha6z56vjnMc4pWeO9hA856t+NtC8fS3K0fpq/Xn4ID2UTa5XUM74x7Oaq1Pgrxh05FpOt29i3V4UtiZ9C8tLrzkWN7vbw893TaeIi9jtLQluU+g4xvEMeAL9qeucb3EbR/H5JEc1pQeTy7OBk/Gp7sbeg5QXS58G8Li2F52ND/ujfmPT2roS51kQyzywRloHV8aZHTFmdOV1ZKOPlJdcd/r678WFM51ifGjgr1ZycYTb2r/FdzSe6toaSp9M3RXVKpmQ+9pOf5039Iyj8RFfn/hJbVew+t3ZXfV1FVfmwcRR/CO+sItB92wNqnUwhiSs/vg48jPReE9fR6Db3CFxtWdObpBPY23OHa1rOs1T/c3Re2AXZ74nilt/iDPBt7VzD3iV3+rzmeAbt/7jqvUi9q5298BGbdRiRWPYWiwO7MaSdI5bdRDjCrdiAf/rmIVyTb9xdK396vz4lFENy6+cjuqoJmw84/lmvue/v1Z4NvOL6N/wl4vv7z4nuLLxPBP34lmkZ7jXD2uMKzYr2Ew7PpM22M7bjLvZJNr0tTlNSSd7MmMEHNq8u7k5dp7UttNxLJ+1f5V0dpKPI4nvVcw8V+TnTOce7nF5JMZVHq/hexX3Ylwdg3t+zElzZQd95gTwk9A/iz/nevNqYrWdL27O5u0UPqwtmPP/KnDD0fq1VnuZ5Uhau6Q1PmtAdsAhHjh5cOnBfdYtzvzwn+i/2Xkp5psYvoXm5ZjayJ3/2ze6/v3fbz+GWO76vv/S63o94jeFX2J85OC8dlyr/4pyoAtqVy2d51f/rItx4HdXW/30iP7G5dkoDn649lckv50xN4UfEOvLtqM5CPLAf0Vjs9pW0/odd6BH9B/pvBRzXhCQwy6PFdngFMcJ1/lpzonVupsx7uV1Ne+Vw4p7/eGo1vi/X+vv93J+W5/O9dO1jnvZlH7PKs5XPnxkO8GvtsmJLT+zXRvRtgqIKQY7Pkk8GpOup5xhcgqrTX5W/o/gyHYXH878H/Ud5bIbq4m1j59qfoRsjvgHesaGv6nrvDXY2E3Qrz8fq04+5j3BnDianxP6Vh32fK1cg7Z4Ob8SJ87ZfEjgRqxZ8eZa5OooygAAgjpJREFUWWt3BroEX352qBYJ/eoxQW/mXa3mnoLnPYiBiyMfa07akvY4x3X/YteL1bh8bpi1l5tcdrUHtX3/PHZbK8/4dROfI9TCN+7/83/+u+9a3vCXhuu73BPxKW0kcyMMs43YKBKLYsrsI6ttMv0+E90wbG7r0Q1gldmf5CN5Fp6R6xmf+u7FeXbNj/CsOPw8w9fHyFsM8343d9a+rsG8O0Nrac7RHcoxvXSTI7Br/dLLdgW9eLfmPRQl+ag9HW3lcITirjxnTuv6XXVdEzHj6iWV/6Xz8MLm9tJq/0CtzYuu248j3mLQDRuTLfjxoOSlWh+Ek1vbLYZrMcq72h7Vic7UIzfONx/pdE2vcdj5pFtswl/j9UxMTnzffv/D+xcGPyRm+KO6QzU/wrRNt/zOcjyL+SyIf3WOTZzZmCdQfmuM1aa2l4BPuGf/Uv8B/3IItQH/cppja16T9pf6ze+pm7CZ/vMJM08CO934QP6I9nytyOdOVp7GNpn9q16yg/Z4Tez0r7ZN3Ot/BKuvahl2sda8VrCZPo5A70hXDHPKcdZ+on7QR2cF381Puubm2Quo/Ky+2CZH0CdeOsXYxZnxr9TqWRBLLYj4zfU13x3W2uzymljrseqvffnVXk20tRbPwE9CN4F5XjxHNage2ZkfZ88NnwtmftAYl1O19oyXDhvXzY9q9dcCNfrZz758N/5v+MvDn3a4JvZugT8y6T/UAsErCbPN4t3Jvb5pPzF1LIJE27xe26fdCrVpcyVuwlO0rR8QZ/9qT1wTfVdrv+MW8nGmE17r516MR7g8A/fyeS2POT587fxNndfgGX74yM9Z7uZ7N8wV1oR5yt45uD4Df244Yje/d5jr7EhnBzZsPfQWw1Fb0romPSCTvqVFXOvn76w+1VGc1u26rsnUpTO/vbVDeQR6XjTZN3rh5JtbZxBWPC+gbj+66H84r88daePBh5g7ufG47VW9TKMvlrZqKJdZxzW/WZsVtfPHrrGb9hN0008vmRxeA77L0Rz68svbj6uKB99S/sEwa7vm27X6nNWktnw5ynU3PiFdMGb0PyT4Fwd2OayIv2Ncp6zzz3VjTL+55PwsHrt7Os/ELtasvz5zs/2GdK5vrhHX7PTPHw2jY09sjjuyr/5AjxR79rHhq7Z0yaz5bI+jY+Ka7+mfbiiPmZPzONOtnRRr6s/22baTnb8dap81uYpHbfCYYD99TI7aq+cZ1C7dI/Cb7zM94wizbhONMTQua11x4cf9kC6d5ubUd6x9opro3/lfIYZYMOdKYF+MOZ8/FsTEr9hytl7jeZSf9tl3VO+J5kH1m1jryh9O2XQ+a3gvFhuSv45QvhPa1KK5Ac2B7M9ifuponOUw8yLtkRM/+tHf/OlZrRdg6vrXAkP91Vdvv5/rLxHfv3N8RJxNpnt99bcBzgVM5qKeH0yd9xCWDl+7DW1uuHNDJB7sprRp6HPeddKG4dj5h9pA7vl9bX94Bv85li/FFR5X4jwjn2fgY/J4Vqwrfqw1etbDmb5xsjahtXMG+vQeARv7AFiz+LSPzP2iHz3Upu/RB5/yFcPvxZhi39DOXxLsH/rbK46AU3sYn35JPPEi6cxuBdVb+Os2E2w9JCUzp5t8p7iB+hA1Vt8V1T29M8hZzeixMY92PkPjo9bO5z3hWeDXeAL/f/u3/+lP3+p6ab1fA6mR5o76OO4Q96OatDb50F897yF99vfW9zPQOjrKcwX97uPVx3jJ7YivvqS6ngGfe7gyD6/4Ab5Wf9UFGuN1/KqF9p6dZm7s29/mPLdvOupfOYpFd7aLze+MH+eVE8xcVv+gDXfCPh7OG9t53rMcWXWqkyPEq7nR/CCdz+dNurU77ubGzOcIuzzDWd+K+J9h1XnE/xnyqa73oP7iqteuZo0vqc47iNW48tM8Do3jat98gCMOO+CNU36D6+bRs+r5KMS1XqsHfubqUe1ArXBm17jN+h2Bz9Wv+Ik+8fmd9XAujvbWyxm/EEcwxnBW6+LYu8pLvHV+fK6Qk3GW58zpm29+/21d/rwm1VgN/a4uz5F/LTDH/CL63Zx9w+eNH//jP/7jPzlpAz/aENqsbRpnyA+0OTlOaeNyTCxAYjHWNnWmfT5xnYIbsbjj6YZj0fbAMgXYdVMSpwmeH9f5PwK7M538xmmFvuKexWmTuueHHPm51w/38mkMznw8Eucsn3Dkh05z4QhX4tzjCq+JM+dtML92/owzH0ex4nHUXz7kKGfA916c+LZeJspnx6X4MOtyFAvoy53P9cFnxdTF7SzPQNf+Mh/qXPcAgCedyf0e4thY4mE/8XAhh7jp41sMsXAgrsXKln4Pakdgw5aNv3z29dffvHsgictrwMWUe1Cmq7UCD1f4//jH79cB3vKuPo6NVft29SOud8BDbatf/uDe/IgDsOFH2zNqCuI3z255qNntR0sfqd8z0FxvvjmfNcUvTnSq4Qo6+hxn/c7gr3zxD9njs4r2nTSmnfOR3EN6j4yp/NmI5/yerX56uMnD+RH4hCMdPsjZfOfjSt2rm2Ngh682cxOPo72n+s7cYNZDH5+O9Hcxd5z1E3bTHz369oCJYheHzbTTRvQHvmC2TV7Za8tncK0dD+3FBfVyXS07b+8n2aYDaw2KMeNM1D9tQn0ztzPQVcNyEIvfae/+EupfOa1ovp/piS3uPa7qY07SL/4R6qfP91H8mQOu1SC7QMcYNO/KCZfWyT3QJ/x2r27Mr9h/aOCDB5m1iHeQb221V4/GB6ZNkK/+dCbEKt7Z2Oqjx1f6V1DcGecMzY1sHMW8Gu9TRuMlp1//+jfv2r5N8RC3mt3sPFfentludflLhxdd86XnGz5//KhNIGlzsMATG2BtNrY+oM1fskza9LLLZ7DQiMVjErmJeBgg/a9J/yNI+qBIakv4aPHms/NiPYqX2MCa50vxWj/xP/NB516MezyuxnkWPnScK/nAvbo8gtf4eVZt7+U94+x0tFnv9HpQsgdMae+4l69+ewbdHjjO8qRPdnrxEt8e5S+oEOdihHucAv/tWfYiL5ZIN8M4tE/VVk5xcMRJG3/ptu85atth5sT3b37zuy9++9uvv7XzMvA7pc8AvhL+k5/s/9ddLdRFH1EP16E672xD/fM+0VxUv3tgny395kxz8yXgEw9j7MiX+6VfSP/VVz87zefZEKs/PgBxk9vKQx+oBc5rv2t2jdsR6JVzNeTT+B5J933CN2EjVusL+CPtPbe67mta7R8FOzzYknI4Am44Gm+62b0E5XmEe/2hsZpg29jEeYd05jgQ7eqtr3rzQ8cYrvPdWjJObCfYErqheq2cykGc+DuGeDyC1X5evwSrfdeOcjzyH/ej/l07m0dyTn/arJwe8TfxiN2aC1tj3hoG88S6m+t9B7bNi3wcrVG55pdP83Hy1pbOhHY82PE/5/wRsmkf4PMsj4+NcsUPz9ap/GZN6ZAJttWQnjqumD5CY6mduL4HsenRx2/1uQJ/tbYHsaW/47dCDDaTo3hs78X8lIH7t+m8+wbXIzB+RA1//3vPp+9/tPMvFf/jf/wff7b23/B540c2tjbsKRY5OJrYHW0AickwrwmdI5m+1vNVir2T+jp2/ihWu66rAWib1y/FPfuX5vBD4Qrf19bsak2eMT73YjUPzkDnKuczXM3lTO8K39eA7x4ePFQkrttT9NMj6e0eGvJ1uxnfHgzv1TG/YfrvQS0u6a42K8S0J4nfh20PgI4e6Ig9j06+nLcPOm9Pm8Ahvz18OSaB3b28wQNH8a7of0qQL8pz/EP1J11P1L+zDXSMi6MaVafmB2lO7MAu6br5TM5in4EfPOSPk2tcfPCf324q7oeGOAk+cgvN7bg4VvdqQOjcxvN43tJJP/A15+89oRemDS5TxzEd4z3HeOqtffeQXblWhzNk01izeUnce6Bzz2djsOrFyZEfXFewya4ak3LLhh81oTt12jPp6aOTLsQrm6AdZhvUzndYda6iuCuutr0UO1/VGJyfXe/wCL97vu71H+EKh5lL8y+B5pUj4XPnd9o278yz5lrzbJdLHJp7E2K1zldoix87MZqPR4g/m84/JZSTdRpHdev5qbYV5aKfPdCvHtV4rW+64WoNq7sjG7JCrMl52oGcVj4T5bM+5/GZnNl/isC3eY767scUr0Jt/vhHa+z+i8nPCcb7t7/97Rf//M+/+tMce8NfDn40N4P1fLbNPhNhJzsfO7mCK3q3hXu86bxmQ3qN7UvxjJhX6/YMfKwa3YvzueXzKeEs57le03PD7AGyBw191v98yCRsZxuwZztfOMyHluzOEAdxyXwIiVf9K8qpfayHOxyd94BTm2PCpniO+aHneIb0pk9t5N5D3kQ1vVejTxU37u9fEq5ofHZ9oO+oXvoah8ZHnau5NvNizpOjOKBvjpXr7F6ClQ+Ri290ffnlz9698HL9rdpHxVlNA670QB2qjbrUvoJPUo2LMX1dwarrmvDbGooLdJyxgQ29+M++KyhWsdsHzpBNnMyd6lAe9zD5kupafo7N6SMp5sTkcjYm9OI/UT3LAxe6xdPGznxPXMe3/R/4CXHKbyh/PopHVuzarmD6m3E/BCZH53ImzqtN4rqxct51bdlNOcKuf1fnibX/tSgPx/waU2Ie7OZivNf5NSX7fMGs26yp9h3WuDsUgy7ffK01W5H+pwr8ehZyLqcrec3ag3qQxmui/B3FsR/AIzWMH93mARSP0Jmx4ucoTvyOQLf9ii+67MSbMT91xBtuz1y+mXb+I71HqFxq40cYSeP3KcDc9R/SfsLC76X1rbVvvvnmi6+//vqd/O53xE8/JL/9k+ij//vfP/ZNtzd8HviRRdzG0Yawk0dgEZ1tIvdwJd4VnSs8+Lmn85pcwlW+r8HVun3MOPdiXfF1hqv2r40Dr6mb+CuHI3+vrVn9z6p9fnoYmTd7+4b9oxdE80GpdjfD2Z6v/OQLHzo74ECy66GI3Htw4Tc+jj3AxGu20SFrbYqd5LN87oF+MuG6PP4acKvbrQ5nOe9qUv3U/whrPV0bz+YhsDdnksY0ZE+aD8Y53zubR7DON7h9o8uPs/qm48teol3FrM1E7TvQrQZht06An+rjPLvqVT2vYtqG4jquwjcp/swrnfoeRf7zkZz5olvO9KbNvN4JrHqd1z77dmK+0lmRbTmtqJ8cjTWwNZf1T5vi57/57jxe7f3ZgGs6Kyf6K4ds7oHdke1sv+pvh53tmT99cp33M1ycV5sps2ZTtNV3JPrTcZwof/GTD41izHmxG594rwL02TWnJrqW765Wa458kRnzrA5zfl7R/xww69lYqNm9/OiqBbvqp86rfvVNPxvI/706xtFxtXHUTiaKN/klRyiOuTnHec6hHwJXahTSK38m/vCNdtczt6u4hb39qOrt93UZxz+vebjFudWR3Ozeix+B7KcmXiO91Pr+i63ffe8F1/vjfNn1u3cvt5qHb/jLw998OwnezU4Tv8m/m/j+98NENlGP0AIEPo4mPl8m1S4OtIlYBDvMhd6Gt4MfW9J/NIHLOR/issmvxVOse3Fui3lfmyv5gA2Uj5fmA3zxcxQLfKCS20vjVBPHo5zjwcfROJsH+s7iFOts3slHvq+JIwYc6cC9OPJVU/1rbc0BQif0O0tWXT++ZHyO4vADO1uobvLm5whnfCEfakMnv9kQ9Zq2+vFzvLd+8w18GOPGefWZTJsdsptHPu/lmM4OxZZXee98rWCDa+ttrVW4Nw4QB/5+/evfftf6w+NbSu94XYX81NtfGFRPdV9z5u9o79Bnf7q3fx2Np76glvzxM+eINtx28dng5rjOqyM+98BX85oP6+YPf3j/+96eDTXoRVr+xS9f+VebRzjQh2rElmh3TdRMfo/mtd6T8um6MTJmJP/6Qf86jvmb4/cSiDHrdMVXPNnRr+YEOuZv9TvPjdvZWtAvljGZwLf55ny3VzcHgM5VsClmtY9fR/1qFy86rSdjg49ziIP2mStbPuY9jm4+J2d65RrmnAe29PAohrZ8ag+N32zjj68Zgw5d7SR/7gls8yOe/o6hOvJJD8oPajtCvssHpj1Ug/Qam6B/jscRjE9juAMuYjvOuoU1l6kP/MZzRTodq5sjsNGXbXpBjumwE2fuU7uYgU1xGvsz/U8Z1TtpHjSuR/WfUAtrga+J5lnHCTZkxrgXZ/Kj63q3j60Qp/yah2exmkeknOQw9517XJ+FeFTDo7jVpnpP+J2c//zP//xt7v/+bs16Fqsej6K6i3X7Yzrfh5dPauybZKjSb+ydx3+ev+ENz8SfdqFnTbJnTdR7fj7GgnjJov+QuJLzMzh/SvPgGbjK5VMZ73t8z/rLYR7dmOeNmtxuSrc2DyRudokH8EQ/H47gIaLfU3W7eX2fC7/0dw+xE+x6YAA2eJAV9eEzbVbw2cMHjr1EvPcw0E33CNVLTvyf1f8lyB8ub7hBnY31rib6tL+kXmptHM1j8yRfzfvmL73dvNDGll1rJ5uXgs/WFODxy1/+4t3L7g+FdQrPesudvCQnNSHyaX/gR41gfnB8DRqfOUdqC+Lr282j+trXXgp+xJQfX2ucHdR6lebj3Lucaxdj6opHrtZxxyk/Z1A3QvcR4IUz/s7VpvEPfM45Ik73nF1ecrjHF67U/x6u1nWHK7bNk+51xrg9RY6OSddzfqSvfv0RFNdqWd86Z+K1qw8+uMw9cMWVvO7pFPtMzzwQHxe85F9eM4+J/GZn35RPa3vWdGevn//qKx7beT84A5/NY/F3+83nAJxb89W8NayeRN89HNWZrT71XqFdLFD7K3HEwBHyfQX04mi87o1V86M5CM2PKzyfCfHxEPdsbuInv904eMHFx3/8hz3YX+f++ruex1F8P/b3f/6f/9e7X9w+RbtvSvlPu+5p5haRi9qSHc83vOEZ+N4KPVvsRwtmh3ubhv57OnBF5xk4ilPO93g8UpsdHolzBff8XI1zpneFy2vjXOHxCD5WPjvs+vLn6KaVuHaTchNLeshwU+68DwUe6voLgs5JD1v6nU87wueMNwVXMm9AbkhuUt3kd+Azu12+UG74AF03Pr7deOfDA10+y+UIOPHRw37x2bM74gL6z/jiA2Kc+XkNxK/2f+mQo3z7qnv1najOuzHXR87mw9E4iV2f443H7a9leuiCOd+OYrDtQwAf9NjMdfeSseTLPCZi+D1dv/zlL09zfQniNuvkfPJ2bc6rR2KsjnLTTgfUJbAh/MlvxgS+2M69aSew2lb7yVnbnFPtV/Qm6AHbXT6PgK85f3ZzegWbYq95XcEV2yMe1Sn7nY/q9RJuE+K0TtTGWIoLxVe79n/Amx79xtc5vZXPEb/ZXrwVu/Yj3Zcif45ycm+TC36t9XlvOcpnYnKc+mrMF1GrztVVnD5kagvspw7h51E8UrfJ2fiqh7q0zvHBo/E+qknzpGeg5gt9OfBhb29uacNzrZ++GaP5qI1PMa6uab7YxOVzQjnO+VEd1QTc39TjbLzXGocrc0tsonbNhzM03mzmGN5DNvKSNznLCRrf5ovY1eNjjrXYeOMj/sodF6J/V5PZXh1+85vffNt+vX4rxLtXvze84YfAn1bmbjG8BPy8drJf4fKMOHDm55mL9ll84WPU9wxX7Z9ZvzPci/PafEGMxrCbSNJNsusejBI3om5GE/Q8oJF0yM7HjFG+5eXYw0HSw4SbIenm7EEjcV3f2p50My3/ZEW5xWWHatcDIF0xJm/xoVrIfeYM7HBiOx/cJ7cZ5wz1ZzchZnlXzw8B/ot1BjXe8fzcIIfkaHyqyZz3SXbVbNbNuf4dsp1wTZpP5ru5JGbzz/mMAdnNtUW0sWHbB7ed/Q7xEL9158cKtT8Ta82gfELXuOBRnxrKp/1prlG6rcOQPqjPDo1Z9key8mazXkPxAHdCb7ZDfWv7oxCXn8lTTc7AJpk5PAJ24pX3CmO08z3147DCuAH/r0H+Z33UW33wA231t5dXw+S12OW5q81R27Td6YD2ta/5f5Sv48prYscb1vY4ru35X2WCziqPYsY/QvUhamHvUB/x7HfteeSIK3217JmJnzlXe4ZpHuWrcRB7opjFKaa2ORfFmbF2mD6gmJ8DmpvVP1SLxkc9GrtdPUHeazs/u/YV9Ig4xFgfxdFWfecYXsWMA43vEUf64tD33JkdDnN9fwzExT21OlQnXNZ5Dc59iyveIV9ff/27b/tuYz/truBj5/+GN1zFj//xH//xn747f7dITO7dBD/b3EObA12L5ghncYCffO10rsap/2oc5xaqo+tstd2LA0dx9OfzDOKsG9DE5HoEOup75udZce7Vv7od+XlWPvpnHDYJjslsYzP7Zpsj7o7zfNWdOkn9M/bKaQLnpBzoyJdoI/N86s/2pFqJ7SaobfqfItZRH8kPSWeCvT657/oDPTpuhtXAQ+S0mUe15Tfd0MMWu3KfiMu0qx4r4i7ejjcOcDUv+lPmfJjY+VrznJg+cPHLOj8VoH3GfYfqnhzVQ/0aG9dJtXBcfal7Nqvf6W8Fu+bT1DnzF2Z/kp/ymBxrP8PMy7cRngk57cKLtWLmNK/nOdmtEf5usfr23p/PWzrqo/bT3yqTm+uw4xzSc6yeXc+j+Pobk44vweQm93so1rS7AnbVbYU+uRLnSbB/wlwPM352uzF9DXZxxCBQf3EJncbHuZq6nmM2ZXIPtcGMz8fMkY62WdOdresjf13HG1/nwG/zvOuw4w27dn7hjLc2tnQmx9rj5Do753T1FWNC/5S1DWasFXxOvSlzHCbioo7J6ifbngtWX3x4KTN5QnqOO+jLD7s5ltP/hOcA9cw3rtXyyOaHRjWudjvMWjhmM8chVKfZV02mzRmKR3f1FdS6Os/2R5Gto1ik6x2KR+IXxx3PD4kZJx5qMveCoP3Xv/7NIbebnXq+/8Zj+dwDPTF3cd/whh8St9X8JLR4ri6Ml+JZcXZ+jjaA1+Bj1eXZeC3fq/b0jqSbRxs46cEh0e84H4LmOdnZrTJ1ZjwSn8nXuE7phuvYjaabe30TU8cDWuf5qH32kemv8ym1g/PktSj/UB3U514cNTUe+SiXI/01Fj05zTqstnOc9J35hzXGRH6q5w76xTyaM0n2+Ux3YupMZEPonOXzuWDmuOa7onxn3s6PxiV/j/aFfLfm2KxjdQb2c47yRSBfxt95fD42PMTCGh/PM15yS8qrPLWtkGu+6OxQvJ39xFG/9pWzthkbtNW+Qh7pO5J1TRdj+jwCf/FtrPlYEXc6jyIuxVlRX3pBWzbprD52XJ+J6rOLDdrW9UPwbWw6JvN+r2+9JtUi2eGofeLMlhS/2PJpP5lz4x5ewxGu6l1BuZHqWU07v4eZd2O81qMYjanjFHGync9FzQ8yMfnNPvrsYNcf6M2xm1xWfT4Av/IqRjx2MX5oxCs5QnlVc5jjku3qY9YDilO9zlDdIZvsId+vBT/JVX7imhuEHf3+s3M3Pz4Uqm0cdvXQ1o/gnuHf/u32Ux3+Q0pej+BKzd7who+N783IFvcO9xZHuKp3D/ycbRLPijMxfc5anPGYuKp3hI8V517t6l/juE7Wa2KDm7JrI/PGuLaRHlBJ/W4eifZ5rX/apJPkYwpuE+XsZtBNvBuYDb9vRHXdjaDzeU1nXic9GAQxi+c45WyMjsZnxZmPq4gPqNtE4+so56N4dBoHkK96rMif/3WdqE67GkJ25o7z6gkdd2Cjf8ebr7P6lVPzr5yORH3EorsTKN5slw/o2+X+Q+I7ag/hluJtvN6dfetkrbO22tUskf8UNV1F+9G4FfMq+BIXlzkmV9GYGX/7AX7QPnfV10E6L4a/qgRrfHzXXEnjQa4iP9DYHGH1u4sVt7VdfWdbNW8vqK/5U91rp08gG/1zjKbUv2vPJ4hn3Pmu33GiuKvtPUzdbMnkg3tzd4U6TMQD6LPVxv5DIX4z9g7VcYq5lC1Z8+e7vTmpLXE965XkaxXYta+2/BYPcMVZze/Vk/0O92oEq23XV2zTObJxjTuhM+tU7uV7hnx0Hna+1NBzgKM2UMPquc4Hwm7Hj48J+fCVLbtps4J+MdKfcyg71/xWv+omTv1HMX4I4IE/XvKKYzntMHMqVzazHuU50dizY0MvuVeP1k78iqetWj8DfIlFxLrCDwe1m/Voj8n+Q2Pyq1YrcPzd73733dU5+PBCjDwCOa9r7Q1v+KHx8Aq8tyF9SriyAT5jk3zmRnuGq3E+NJ9uAB278Uyx4UEbnweWKf2+ml1f7YS9OHx205g3DrkSGzuxQXfTIX24JM7bvPuFpEk3qfVlVdLNoxidkzjcw4cel0eBz5X1HO9Z98aeqNUZjGm2akd/Vws+G+8JNW58VtAl5or+xqa+o5rrw6nxW2G+TV8r8IwrvTnPdhK35hUczfektQRs/1LgT03v/tz0iqPaH8FYwNGYn+EoVu2NyVwDj4Iv8wQ/fuK7w5rDC1I6hLnE3xpfzLjN+djeS/+M8wS91tdRbemId2Vu09vFP2oXc6dr/clp9mlvTbZGjVNrOn5s1GJdr/LUvsYD9nFpLU+IXQ6PgH51zTdpnu5iARvxjsAO5zOdZ0Cce1yac+pP1xG39lBijLqXN2b1089/Y9S4dU9yPn+/E9DTV/zGJh9T8pU/bRC35s6Ko7yfXfer/maeO/CTL2NR/ZNZ6yPo38VxrW7q31ioJbDhu+e0arrGcq0vX42d8zVe/GFndwRx6bKlN9d/MY7qwEbc1ubK6YcADvhYL3hXk3K6B3akvNRDbivUg04Qq2t2V9CYsRWDaNvV+rXgVxyQ072xwgG3ud7xM48/1lg3BxvDHfrPrQ8FuarXG97wKeFvvv766z/tEhalRdpCnTCBYd2wdnCjsuCPNiALQYwjPxbrlUV7L44NNL47Hf6LVRx/pcU1mzb/e3GqzVGccoFdbcO9OPkppx3o4FM+5Ric689+7eu4a38EOCbrtb/i4Xj7sPv+YYZ0HsTGV12OYN7K96wm5XBUfzrmy1mcq/MW1jjlgWvAecf73rwFvvhsnFdcyQfO1nzIl5j+HDB0MxP/iCN+5jR7Oq2nnT7/pPoBPT7UIdsJujiB/onqzXY3XvrlfrTe7AMeqtc+MeXOt9zv1e4I+RHjCvD44x9v8+VTwbcl/O54fX+Qh7z/9m9vLxrMj/V3Tmk3F87m1g7ZGY/dmIvVQ/mEsSC7uckfvo21GMae3lGcK+CTL3x2OeqjI/7//J///G0ca+G7zifgq6+++m4O3//9btUHpwRaW/gnwdpio25Hczaf0BqSb238TVv1WNtA+zoWfBytfzHiO/uO2u9h1gZ2+VbDdY5lV60map/n6UM8yeoT5E+mvvkmjvHR13U42veehZnHWosJOkR/c2Oi/jMfQZ4w9cSv3Xk14vMq+JvCn1oS18VofGpLZl7N+3kfw0UbTF37WO3A71qL4q21Y9e+Eox39cQV51kHbc0R9uUXtLG5OhZxdT7Xe+CjfVpfXNa4R6DPL/+rbz7EXusC7NjAHIcd1hi4Xv3didVALtX1CHTp8f9MNGawctDX/LhXB2iMqsdEOe78sCPt31fmjzjpO3dUmyvz4qUQD4p1D2rABj9g17z7EBBL/vzv6vDNN9988bvffX13rk24D/hr7Y9CjK+//vrp8/UNb3gpLv/i+TYkuLeh2OzOFnQb/JGfYpGzxXIvzlW++BSHz+y0kTbVI8QVznKCtT9bHMTW33ViXDpOoU/w65zkK1ntVv9xIAGPpDoQdegcfvvb3337kPSHb2/w//LF73//h3cvQRxv/7vqm1M3+eMf+5/W99+S4qOYzosXnMereDvIYdqtmLkd6elXm7Nx1n8lDtnxxZOPwFd5T7A/iwON21Fd9NE5ywfK6V48etXHnDriHsTugxSdHlp3+s3Tagd0zZfyKF6IT3BOD+g6J7v6FGfXX1+57tB+YA7PfPjL/gxTZ8dvwv++/eu/eki8/oDyQ+BezhO3sbvValdndTyr/xGO/IG+xnuOWTbaZnvIDrJtzG55vJ+DdK+C3Y5PiBcd+ymVB9yfwn8u/PjH3ef+PPYO5U3Ul8S7GuE77zn6p94KNmz1O/awXk3089V4uta++mObzD62O33Xc9yCdjZHY3IG+uLj2PWK+vmfnKubczVo3OsH/qq9NtfrnhoH9vT4ig/obzyK53zadf2hgI/Y6965Ys6FHarPUf9EYz1zc2ws1AQfRwJdZ+O6tmzIbItPnFyLUUyoDWb7Lh/XJA6B7hpbjuZDeuyaBxO1xwFmzM6rWcgvf5ML5HP6WUHHuNMjzsu5/PiWQ3kUpyOb2X4Gvtcc8FOzM576cDL/zvSgfrHK5Z5NkMO9upXD1ZyvQtw4r/MjFM8z3BXEEV/+g7bdnAnaqzk+te0QZ/qEXvsYHNm9FvkVW6wrcRpT+qS6HI31SzHnxxEvL7F9PrsKL7e85Kquj0CNjMm9/1x/wxs+Ft7f6S7iysS/ujjO9K5sJC9ZhCv4mH6O4qZH2mxXseFY4IkbZVKfm0bif+Q6p8OHY9dT2BYnDmFucm3+bixTekjrAaKHiVXSS3dtS7rR3K5vMYo9ubwX1+/7iL/kMf9k7SrPQr7mOO9wL6b+Mx/P5NxcO8K9frjH9xEYXzAP+SXGdQdzs/kK5siRPj1ro3kN9My7bBwn6KavrznunK/8wWob9JdTqKbW25Hd2u6aTXGd8y2vde2G9Nf4E9aUl8OO1e0W693pJwUlOarXPVyt81Wo7Q7az+areLuY2bAn6TUv2Tb2xFjPsde2Q37IfYj93ekT8Ld/2/3l/f2oeYqvnGYdJ9cp1cCRmM+zXvUfgU6xxM0+O5IO5Gtyg9ZReoGfaR/4YbP21a5ttTlDXOO+G/O47+o8be2VOFSLjkmxoPNkrcsubz6Ca4iPo3i1PxuT31kMvPUnR1jzvYrp13HWtWtS7bXN8Tizc7yHxnzF1XxmzKTYcXS+wy6GtuzOcjjrW3NybRzNK3PeHrPbX3rG7DmzGPly1Ba/5ukuj0CHTPAz/e9QXHHoxncXKx/5JXTLc117E8UpL/WZNQn8nPF9KYp1rxb65dU4nuUEbNYcXO/qNzFrIcZufF0XP97xcx7HD4Edv7NaTG4E8Gd3NNYvAT/xEG8HL7h238xVq93c9oLLHH4Nv7PavOENHxvfm40WwroYwlH7S/GMRX4EvvPv2GaQtMBJbTagdXPVb1PS5pikO6/zV99sm7FJnFZU/zZUN9tuuJ3Pl06zf7bNDZZMm+m7tvysku6UODYfOr4Ej9jOcdnhXv+niA/J+TXjsmKOd/PWXNhBTs1753OOrZjrI/CbfnEJvdYVfW3NUefNTyJutT2qsfZsJ8Sp7chW//RPcFq5OE/olEM5E+fz+m/+Zn7AexftT7E+ZeCK8z1MlV1etV3xtcNRrbRX1xX17aB9zinSeOmb+2T+pzwD34Z8GtyvPMT6Nlf8moetr+5r8972fn5+n8yaazWaNTnD1K+Wga3rWe8jrLwgX0e8Qbv+cGST3qyT84n4gj6y46WNbvpE7todd3MqZLuDPsJu5gT5yXblEHa1eib4lt8ZZl3jk7wE7GbuYeevtvRXOcIRt+nvUZzxm7gX+x7Sm/Ngh3v9/KxrZK4V/erg/u6Z1DxwPef8UZ3SiwN/6xwH7cWaYKdtbd9hxiqnNZZ2cYBuzznlf8QviMF/OReD5Dsdx2chfmfcQnUgcWS7q2F12oGNObCzC/wnsHJ0DWs9Zg35vxfnpYibWgBu92pIH7dqGD/31aM6XgVbPsr/CF5wrT8FwM4XLIhvbCVxu5fXPeDG32v9vOENz8AHmYVzE9ph9lsQq8z2NpOdpOfcwr0iFvIqs33Gz+9RDO2rQBtim1ziug2vm+IUOp33YspxSv1T8kn4wGONm9T3DNx8fnfxArCH6rZDOme4ovMp4Favj5vPWW3DvXhzXrfudtDXegLzzPxc/fM3dfNPv7UR2Ba3NQrpNr/BUVs2wG6twa4m2uIyOe909Wlf+3BJyoPEEZf4dJ2f7/fdHkR806YXDVNu7bfzm813BH5gfFeyS6h21TlUj2ei+q6xrmByidv0Z5ybh53PsXd+hPwcIb6Tw2vAz89+9tNv583t4Th+xHU6OJl/67zTNoXelHT44POo3jPv9I7qFC/61SHbFfrTgZlTfIOY+h3zPW2da5+ya9uB3+JNn2IldIrfkc095I/NisnJWEwUByYnbY2/Yz5W7s9A9dtxD3Sqg/Ns4tP50TV5BNN+9TPPp7wWRz6M0Q6zfbXt+sj2CmZe/Ky+XB+NWbbEuM39ov0A+DC/7Dk9x7rWT6r1PbDhq5jTLg6rL/riwWpzBrGA7mrXebUh5aT9al4rN8KGlOuzkG+ohvf4gdziEbedjXwn2BTHXDizBbpybq6lP21285BdHHc2r0V+itO8uBenPvrNDWhuND8eBZ/FnmOzQjwvuGbN2K7/geX4jBdvgQ/fCHtpfm94wzPxvV88b6LPTWbCxDVpocV6BG+Ij36hcwsUjvo7iheX2mHqrD6m3j1ki085sc+HfpuTTcBxjeWaTJuj2rQpdUPbofrn9yUQgx9v8Ffg6H/xj8bmEZTPr3/922+P12s+gYMPXTgd1QVn9T+al6Cfr7MNvw38KI5c6HgAO0Lzv1g74CLOzg/7+VVgPozF6qvaan9JHNDX+jnyAWdrPuSL4CV/cdlUbzq3b4jc1rY+tV7XAz3STTXEc/ez/HLlG/gTu7hH4w1xzjddUj7O+XMtBrTO4+ac7UR54pH99Pco2O+O4ajfj//6xeH/8i+3sVh5fmxc2QfUyNj/5Ce3b8iq41yT6qhdHek+AnbGZt3ftIs5500Q39jv+kB/axYnNX4Jtwm+5Mk3f7s9iQ5eeP/617/Z6jwC/n7605988fOf//wd/9bvCnoJfvO4Qg2qQzauWxcT056/cl/1QnH5o2cM4qtttWvepB8vKB7seKkzG+cdE5g+kyNkwyc98dLHQTud3Rz13HT2y6vp8OHItnqEfOszbybMH8KGD7Fwqy2wz4/28obJ91HEnZgftUF+i11Moi29zqfM+s5j56AW9NaxV4Op5xy/7LsWZ66/dGZt6GifbVDs/NEzVydvaP6KU7s2mD7T00acF3v6pEfW+yk9NSaBn7lm2alNWPvFC/yRdb7Fw5GtIz8risO3fnrZngEHPMubrWs8Jr+V+9HcPkM5ksbnaE5B9S1Oa+xerGLIg985556BWS9cXJP4wT2O2az147f7ZKg+2ppv5cXuLBabauGcXTHvwdjwHb+zOFeARz6mr2pRPWcsnPHAYY6jtrn2rtYjVF8+qskR/vmff/Xuc2A61fRnP/MC6kfv+vqcqE8uvoHlWFvxXgq/hL71/4Y3/BD43ksuC8dkbHOYaBE4Wly17Y70+Fjbwfm8vorJp3N+Jtf1WCzXcXZeP1j0Np4Wex9ggY0Fqu1soYrBxvHoxqRPXY76Qf3L5yjWPeDBz+5lAQ5y2b0AexTl/Nvffv3t+XeND0KONlUfeO/VTV3IDm3K/J3pnI2PXOgY5yNciaP24uz8sJ8PAnwYp9VXtX1pHLjiA3pYO9LJD+64dpPmVy2rp4fV6tO62fnkiz0JfNE/GpvqBvgU+4z3hFh8sEkfD3Ddwwh/fIN+on2NQT9/k7MarB9ePyTmGFvT/tfuI4X+Hr6l8Y7LVfQNNTZE3cO9eX0GdvyynWOgfbfvFb+x3I0bPnw21s8Y22I2drtc08HbfyTc5tnLYufrl7/8xbvr3Z5zD9WK4N2RAH/VaAd6cpFv6/aMQ5zTc20s+GG/i6OPzW5fiK9+9XY+c3DOJls8XzLWM07++NFOtDvu5qj94+wlF7/VgC3/STkUw/WEeM0zfWKp4a5WYM4Xh9CdfB8FX/kTE/AsD6gG1um9WOUop/I+E3rrnBFL+4w/OXUtTra1weRIZ6I++nzNa9K8qJ299llnY+182s/YcUxWPbI+B4rDLwnsxC1HdmoT9KvTHLdE3Il4pQtr3Scag/Jfbe+BHR4gp8kHF7H5n6CT7lqfI9CtduWY7BCv4jT/Gp8jsGG7cn4GPGvv9n778r18VpSXsZr1xD2UcxBHfmLouzLO/BI2fF3lVx3VW5x7dT+DvRD4WeOXO+grJzauyRobt/ZXoHP1nswmu7N1Bf/jf/wfl2q8Qxxf8hcWV/hjZFf/8ugb3vBs/PifvoUJbaE6Jq5N8nnUboE5X/XrSyx+6NhCd2zxkzYOx2RuZha/6ynpidNmOX2KkcB6PoEf7nxAeWjPnzbHM0ybHarLmR/9K7+XYBcHt+ReLlfAz7f/flv/8432HLcPpf34zA7iVJej2ugPRzrG8F7uV/qvcDnyo6/+YN6tvl4bB/QlZ+DnDK2HeCa1p1N96c31O0GnfSNefN174CkPdvaDzu/VIIhBp7ikHIg+om2Cf2279mkX8p3/j4kf/ehWj1se3zV+JHyb7rucr+E2dv4nsflTrfi4OqYrqvvOVpt5Z15OaF85rGCXz0c5rYhfawBWTiFu9KyP18QWzwccLxetn5fOzeyqhTU79wVtO98z5x7m73G4zZH39+XQ/DjbL8Q6q1djDvTmc0W87vHbofHCjz88JuJOJr/ayFFebPnTP7my0ec+Cl07Bnr0ixnP2baCDjuxHBu/l6K6iBlf19rjS8Qi98AGJv9stRGxiud69Sv2bBe/vJPi8DPbHNWmWOCorfFxTbcaEhAnm/KmN89xU3PnpPpXrySb6R9qL07IPwns6KWrb527IHYvKooNxe2lRrWCHYcJcYrNpthnNjvEKfCFBz4rJif5QHzvgV61ifMO2gkd8fCrXkcoh1m/Z0BcnI/8PsIxlB+/1Z190NcaCJ2XJ8nPCjzibV7RzW76PAO/+TiKcwXZxWH1M/tJ3PE8iqk2QC+/zuHIJl2S/RF+85vfvKtbvszz//Jf/v6Lb775/bvrKxCDj/nC+yVQf/Ie8tzn+IY3PBvvXnLNhUnmInOehDaveZySzhR6yXpNZhzXgFcPCDvor+9Ip5zyuULf3DRmLfjUPuMcIbt7cY76gc5rEO8dD7FtpPK5l8sV3PLpJdfL/EkXJx94z+qWHOHG5fiGCVfGZ3cDm4jHS+M0BvrD0XjcyycfZ/l0PPIB6R1xIGLMOOmy7SHHeQ+4raUJedOd+fPTB/gzjlDt+E4/fsT1mY/ZJz5f+TsaA/07v9mvfc5r//i4rUfx/+M/5PNd80eA4WxM7wNHH2S+/xLDeeO4mz9HEHcKH9C8yG/tE/Rv9drPP/0eDuN0NK70mttHEofWi5j3fNJje/V/eY9QXHWfD77PAF8kvpNn9SVh96FzoloSmP4mb3pHeWj3EuWoZnFOngG5E/7Ezbfci5GOcV/rpB1WzrOGzZf8dYR8EOcTfGab3vS3Ip3yAEfCbhfjDOnn17Ea5F87OeI0kS+y1msHc2nGCuKVF/Anv+lz8g102Ew9OmHGmTkRemsbZL/qiqHNkcy29JIVk18oPpmgy4f29qjAJrvO6eIQj3kestnxCNbpzAUcW//3IIbxWPXFPPvsEOjhWL5n+mLh2x56xUYfqRa4Oq8v1K7trF6Pgs9ir+OzA11c4J4uVDtSXiCHXTzXpDhHsfS3bkn94mjPzxmmjjhs79kcIV8kX+s46cO7e8/avyJ/kE8CtU/Q4X/W4wi/+tWv/hT/q6++/OKXv/zlu7r5zy5/tfuefaBnvpM4Pgqc2bH3POUnd7w428lN/92/786B/RS+5vmsnXMi16+++mobYxX6V2r6hs8TP/7f//f//Z9akAa5cxtU50lw83CdvuMUk2/XnlwBHyYfHkfQf88fHZj8J1ooxaHfguFb+5U49Mt7hyv55CN0HSfHpL7Ja9qvfLO/9yHjKooj36Ocr8C3C/A6q1vHozHQV/+RTrU5i0PgyAfw89I42vWTro8exNTkpXFAX/GOfEBcVp3mGP9HMfTTi0f7wgo6Cd3gxmk9nPEL7NgDmxknHnDmS19Sbc4ehI8eptjOvrX/qKYfA+rgBdK3LA/H7UNAqnNsV/j9Yepy+4X57/cvY6mWrtUL53t1S1+u+UmObLWT1c7xaE8Uh6zzbeJW7/cfCieXneDA3715Tzeu/iOB/mvAnwfMDzknqumsc9flehZ/zoP017y1V5uuV6QjftcfEniX55y/8Zi1cFznW+1rrrU75neXC/8J3RX8Vnf91Xm2T+gLM5cZO250d5yCfnqEXnkUN1tHkr7zXS6gvb7sz5C/VXdtL6c5DsWadZq5hF0Mdu0fQX5kN9Yw60IP6OZbnGo45SrKMd+hujc34hO6xsX8dYwr/d19tFhrrhMzH5j5TB67HPXh2/oLdGeNzlA/+3uxqtnMR1vtR7G0V6v8zFi1Tb1ngF/SHDziF/SnU15nfLzMyaYcArvGYMVsj99EvhzbK4sTGvOd/xVTx3x7BOIcxZi86ZQLzvGv7wj6iJq0LrOd+dVeXY9A348G9o0t/7H15ZdfvXu5xd9tjd9+99aXX97E70Vm5z9Jb7Hfmf4JjddtzcvzxucRiF0O90QNifnlhdjf/u1P3p2v4nnGceqv56tvPHzuuO1ht33s3/7t+PnuDZ8/fmSQkxbQkZjoq/yl4UPmZIHdQ5uBzehv/ua2MI/QptXi/SEg7mti//u/ezly/BAUijPlLwGvzeNZdZh+nJtTR2u8/iux6Zijt/n8Xj+/2q74Sb/14HruXTPOPW7Zdn6Eez5g1Zk8y3knHxLizt979UOh0uLQw0c/pqhNreZ5cgR6cx51nLbZd969y3jPfrbJbs441wbd+yamHcxYZ4KH4+rvDDdeLx9HsW753+blzPO14G/WoOvilPdZvtUyXtXyCPkrxg6t7zOde2DHvnHO15R4x3nNszzogP5VJ1+zvXhw5DvEa4fiTdvJZYezfjwS/XRnbVbUTjcbx4na5p48a+58HYOwi7kDnxNHdlf9XcXO31GMKxxrW3VfAz6r81rfYHx6uZXgEI8jPke53gP/zZP4TWjb8cVjvnCjc4+DOMWqDtOm+I7p8e/cUXtyBHpyiht/t/vh+xfAyTMR73v8gvgzr12NQRtUj7X/Xh7smk90xZkvJfjLd4hbNvTWsTpCOcFVGzpr7nwkEF8C2uPHLjlDOamHc/o4Jq75n3HPQKWYP/nJT989B07cXnB9+Wfim0++9eWlmJdL5QTi4vev//rHd98sJx8C5gC+t298kdsfJtsJvSk9Y7auAt74+l2PjuXgG22kNfmGv0x8785xb6DvLdZn4x6fZ03MZ8RRm5fWJ9vpo5DenItv87ttMrevjrYw2wSn0P1YmBvhSyCXKxtmuXVDcR6eNQ+gODtciUPnGXzOeFwFHvd8TK7FdJPooWDNRb85141Evxt0do1N0s3HOaRv3OdY7sZ1Bbupk6/Whb7i5e8MPVA8ilmT1V4f0V6N4pJoO5JVl/CV3IOcCF/+mp6XXXx8DIyyvMPtfwZvPH72Mw8mt1/YX07gGl9j6LgDXTbZpq/Ozs2BVbSTxmPqtn+mc1R37fTZhrgQcw3o2MP4vCdxuoL0lOrC0B+CHxzFP8r1iuzmX/7qc9QmZvnW3nmYtWSjv7HbxQrlUyz2K67o7EB/5ZV0PdutcXxJ4zWhrT52anKGYvPtvJocgW77DP0VcwwCvR3XwCcc6ZQTXmTydZ597XStOborlxX40qu2jlPyT8SbMXd9ZJfHUftVrLb8vRSvsX0E1ePReHI1Jo3hzJ2ve2P6UohFYOVsjJsfAa/2dsJmzoczyIENH/Sba+yS6jARR/3TZodZR/Ho9WG9/mchPo5izrVzxC/Ec9qxmfXQLge6te3A5gizHkB3jqm+FWzEdb91TndyPAM7sdjRP+M2we/0H4fVF9EO7bts8LvHjZ/mrrzpq4W5kT0dcgZ6XlR55jK3vLjy3HWGm81X7/7y8i9+8Ysv/u7vfvnuyIf/lJzAzcsiv0w+vvc4fUzggiNe+JHbN9u++ZP4UsWnxPkNHxbXVvmD+JwmEK5HfO9tTM+EDdJmZmP8wx/+5Yvf/e537/78qsU6H2InJ4vZZq9N/9wM/1LQ+JDyT8Kz8r3iZ8Z9CXYxXuvzmehmbh52w15hPtKTSzc9R231gfnoeoLPbo7mruv0mr87iHU0PtpXf27w8ThC+Z3F3CEuR/7VAqpjflyXa/8btYrfEeDYw40YHY94rhDP7+X69uxbX7evfH9s4CuPL7+8/U+iHHaiVtXrCNXN0TjP+r4Utxrd5mLzhj9jM+eiWI0fpCO35vE9/q+Fl4WvhRzkaVzwNyaPSPXYge9ELarJWrd5Ddr4xUktV5sz0GMTrx03Y9rYiHEVfDYH2Ktb/Noz+FMXmGt8h/p2HGvLr2t+2cx4O9DF8QjsjcXOxxnfHc8d+OC72lQ3tYlba+Qs3gq65c9e/ecY8J0Usz2zuUricYYrdVh1Hs1lxSP2z0T1OloLeKnvI7iXyzP6cVp5Nc8mmh9spt2ck/dA33ytVvO4cgjWQH1i3Ysz1wzdGeNZqDZiycf6EeOROGzZAbt8Tt9QDqH2aXOExkkcdo0TzvfQ3tL6vxcrNFb4nQE3Mfg9qhtfcaXHJhTnar2BLzEJX3za0/iavu/hv/7X//rFP/zDf3v3ouol8Bzq93ip6w7Gqs+o5fkpQP28yMItqZZv+OvE33w7Sf80+m0wsJu43Sza+I7Q5mFiteE9ijYWE/QIV+L0IHrkR77ysjj44dO1I5/eAl+J083tKI586Mza0eebtFl+840/tfr9b+D4NtcvfvHVO3ugu/Kg3wPeEUf8743dI+DvkV9iuEM1f+lmHLoRHOUuhhp1Q1qhL+HjKKfXxGkONI7gBdEunpuLOGSH1iq7yWXmAWKt/bsjP8nZWvG15iDHOZ/URrz8qMUEv62zFXwTNnKjN+uiTU1ci7nzEXDgh/BBf9Yg8EnUeOevXCaP0EMV21294qD/aM7t0HjEDbQ5L5fHcPMHfk/DWd1eC9S5/+qrn/2p/riXv9ja4KjmK9QR5L6O4b21+BJM3o5zfHE5G/NnojH3sGnMv/76m3dxmx8vAX/+wlL8H6lbD7tsCVSj3dhMiFvdGnO1ZM8ufxP8tgcCO+drHD6aBzs/UHzYrUU+yJxrfO3mZ77oX5kDdOXCF79isMt3/vTF4crYsKmG/K9gv/uz7fT9uIr+ozj37j1n4L+cYeb6CHDAbTde8m4+7IADVFtc8Jj69c1xZme9VbdycZw8zDfcpj9811zZ0Z3tuJC5j1crOnM8dnHwOxq3EGeYtvw1Z1aIHUf2E9rlL+4EP4T+bpy0V/sjqBvbs3xWmL+TI35i7DgEuYN6XI2FOzs2V+3wmjbVdEW+1Y/f8pEDObK7gurOLw4T2vU3plfBJr/guRVcm1O1w8xBO7k3Z4EfoHel1hNiqKeYcTtD+cCsw1wbcwzKXT/9lV9965i3PsjZOtiBrfXOtvG6Og+fBbF+97uv3704Ootr7HC1nj82fvvb356utTf8deN7d7NnTRJ+5mbxofBMvkf4UHnMG4Nvbv3+9394J7DGdP3117//04d1dm3QQQ42UQ9o9FaZG/lz8fr6XPndYzbPs7HQd9Z/Ffd8XI2TTvpHdru2oCbG2lxJ3MjVwrG2rklzI7/dFIlzc4Ssc6O+o3nC37yB0Vt180O3uR3EObsRaceRD7pQTnIsr7MbbZh54uLmy89uzeivVivO9oV7YEvEXOOeIbtqQeThwc3xccjhxuMXv/j5t2PowfrW82zcxt2H71ut5YBzOVUPcH6E5o9xg6N5o+1s/F6C6u4Y39YZyEf/x0A5Pys/Of3xj7c18VKf7BrDK2MZ2FVP+4hz44rTEZr75GwO0ON33XMCneLYB9ov6Te27PkhR7Hag+DKHEifv3KVi/jVv7GgR+x9u9iBbrwhPhPlqy//q9DZxTnru4JiOx7V8UMj/nhU+5VHea6413ZkdxVsV3s+YW3fxVnnhzE2l3eYes3Fo1jak6vIx5HNvX64ogP68T96wWWMz2C9mg+tnSt50uHXca79M+DT80v7ygptccCdviNb7faHK7GOwIdcyYrWhFi7Z6IjsGusQD3wTybSJWKpPf1sdojHEe97YFMN1zmyQ3Ho9XxI1C6uxqEx5Lf7g2u6vdRxTj+9CdflQ+dRsO8/wnGJ48eCnH75y18cjlswzn6E0Te7PiT++Md/eRfjN7/5zRe//vWv30nz+Q1v2GG7E9yb0B8T97g8i2t+dotF27Pi2DRsUm1+Nk2bc798fRemNt+a8pe22LWpTvB5JB8Kry/L+4fquYnL70PMwyvzKVHfVWrHMcE5aVzqc53kd2LXBuZFmzcx5kRbDw7pTJl6u2P+pt9Q24rykQMUe9pCeaz50F1jHWHyKsas0Y7fiuzl7AHSeeNBpq+V6w47nXic2dPBYca8CrY7eSn+1/9S+9uDrV/meZvLt75n4Obr9vsgAFd1n9zF1EaOQCdp/LNfsWubUHN+zFtj4PweimXcemhu3s819DEQX3Hh0Tm0wy2nm+9H/ZW7erAnZ2MZxCHGgG11PKtl7Y7kTDdfjfeKfIg7Zbbn4yhOa7i67XQm0i9G+o7iNR8n58lpB3rql19HMqG9/Zl+Nom4oN159y3nSX6zJ7tYR0hXLT8ErnKpjms9s9/Vede2gs7O58RZjCtY/YWXxm4cw87Pri0c8SnWEfg7678CvJuraw7zHnEG/a1z4G/6WoGzfvrFmOvnCOIQ+jubcuEfn9a8oziOdHrB8mjt2IgbjxWT2+R3L061iid9duynbXGL7ViewIavNZ72afcoilMNr/ihowZQPdjOczqNmVxB+4xF9168K3wm1IfEsVjaro7Zs3AlTjw9X3zzzdfvXng9mvMOfPDFJ+kXxVf3K7V/w183fvyP//iP//Td+bvJ3GZm8qw465vgh5h8r5mA4p3FuhKnjenIz8wZuiZ8Zncvjn7YxdGHR3Fc07NYr/55eO7j45yvcjviNFFeV2I9gn//99eN8S2vWw7l51iOJO43/duYr6IWN7v340eq+06mbueOM06II3+NnSPxFyL9SKna3vKw2fug8f4DFaHr9+s0blC+ZGJed57eFXkE8gZcVujDt5tquawx9NFZb77V6CWYMfiFWw3//CFph7UW2SX6Gs81H6gusPbrq189VtTH9xzvHxr9meg43V5+vQ5q6dtbviVmnPhcaw+3vuP5WU0bm908C+mmT47Ow6p/5BsmTzbOj+bJsxH/5rxv+L50Da3A34fF6nI1n9YJid+syxHSneus4xmyo3d1/WQDR/61J7vrHcTne+qs10H73Kt2vl3HNb7dH44wdbOPV9DuvkRmzM7pFles4k1dWPWnxIOIP69nPx9n+dwD30c+mg9X/MfJsevaYOaune/283Qhvelr2hrzeR/Ilv7kWftsi8vaRk+M4uRvQtvkDNMW9OM349CnQ1bs2viaMQKfZNfHj76Zw4rGctfPPu6TP5QDmXW7h+KU+y7X4tLle3LTV05n2NkAv/leuWvLjg6bI44risEOpq97mPx2Nvr5dZyc2SSBvf1nhXb2U0K+11q/BOyTK0hvxl99xNV13NPPphpUm4lqtFsjR+BfXWaM+PDVONOr/UPCt6euxmld0scdRzAvtHePSm5f8vh+W6Kv/ubex8j3DX85eL87fYt7k+fq5HrmJGyB7PCsOGd+zuLvQJ+0sdmMHGsHC9WC7UXIVbD3MuVmd7uRFCffZ3jmuAQfmq/EPsftxuhHLcntbX0fcG++nVfDZOaupjtwkfSXKt/L7L9tyG2kt/ObtOEmvh1E/JhpnP1vw427ttuPn976b6KdzSPj/X2u35L8yFBX89cDpnMc5K828Wkspl5IP53G6tE5m55zkv1VP91Y8aaLZ+vyDOW4w+xb46/X4sfznnxI4KwG1qy/uthX7b2ccl1dbrV5v2+dQT/bm7z/HVlr7cpP+65PLHFBPz9HoDvHruti5Cud/DnWP49HyO5Ws+/7/FAoh2Ld9ozX/Y6WierA95nEY4IdUY+JI9spwK7495Dd6vMIk1f691A+R+Cjccj/rN+M4XxypUuO/Od76u6w81ubYxAHt1nf/JK1r2tzq/OEPr2V++RyJHIiq+1LMX2LP3Puem2fWHV2ssZYr3d+VuzaYNbhyHaHoxg4XYXYbOZ9uXFNnoGznOJwpHPEgb5cuydN+zmfnT+K7KExzn/n2unEz7F1oS+ZvFZMm9aFfCD+E+mXF9/zWeUsFtDhA8rhHr9yTHdnUxu9/ONHVuzaQrkBn6S66Mv3EeJHznDPzwRdnHDgf829/vn8WD2u8kn3EV7ZzHpWv54HzI3i0/2UgF+feXpRdft8dPuMdPuc9P5z05HQmzV4wxsexfd+8Ty0CVtIK9psTdgzWHD8WJAvnaB8tPkd+bgS5ywf4KNNgp98Ej7l6njGJa6O4rTxkDZJcK2fb78Euhcet83v/Yf5q/jZz24/E84er5uf76M2sXG8N3ZXEE++5dCm+6GAu1xnfWY8L/1c13arhbM9Jy+7dvjz8rvRfHf6BOAvD3+uN6gd2c2rjwUvJ2DODVxbB87V1g2ruQyNh/Hp9ycF+nJykwK69Drqz1fj1nGCvnmLozrFMT/T185+BV9yyo5U/9W+2PmfYN83YtRljl/cIDv1KcaMs8aEXds9PGpTbng6Z49rL4JvXOXk94bsv216q8HtIZxuOe+g5u/9vudarfSLQY5yoRtvfo58wdq3otzpnMWEW563sTZX7ulDvu/pTcz8iLnul74+G/5UeH/oY1cnbaFxb3xmnxyredzzR2ojru/de+h15FNM9WbrurqTI9A7mh9XMXnjgPfMW7sYjvjVJjahv4tLp6P5RCeOO67p41A+2Yo/gUf72BFwY+uY/kvqcwZc+bcnvgatt/hNnvxXM5h9az7qpG21b45or87ana81zJ7QgWwJ+D1A7nVdA10y50gy9xA1c95ag8a3ONCcm7b8s5/1Tk9c5/PezI7oyzZoL/fiB/q7MaXHR/f5iXIVZ3KeKPd1LLSTrgM9POju/D0K/Mnk51qcOR4rzE+gF/cVcXeUC7/O+VXPnZ1+9YrTXAdsdnXUXwy1cV6sM34TRzaucRB3rYd48YM4knvxyrG5sctrxZyvj+4vk+MO/Oojcr+H6oXT1Jf7BD065N79L7DJ/84mnzgXf47PvTq+BP/jf/wffzb+b3jD54A/e8nV5r1bXC3qK4u1jfHKhrFDi5z9mY97cdoU180ntKHIq0XMJzs+5ep4xoWtfgL8rJzE4BOPfNmMvCTqLxQ++qfi2fgdOI2Z6za4zruO49WN9gzViz95esB5/82rDwMfvr8Nu4Hx++70E4e6eeD8+c8//ZdcrQGcjau+3Q3cHKDrPMy5v5tvzR92zdGjGvBP6HuwWXXiUP8VrLzxbZ2vUAP86Eyw84LZke3sx0U71F4e5TuRLsxzOOrLD87JM9A3Rfn78Y9v89Xa9gvLZww5/vznX36nfxtjL7x2wFut+nAStKuJo/Ff6zJBR0z6z1ovfBrfOV+P0HrAcTcPV6gbv+uaOYP8mpPG4N5fNHop3DOMB9/r+mxN6qs+8m3uaj8bJ5AHoZeu63u1EE8cusD2/dy67VFXxgrUn+3kcBXlfRuH4xdWdKoTcT73gRV05FZN+S3fXV7p6iN01aH6BHZX5iR7484XH1dsHsWs22sgz+rJX6jWnYfZNttnno2jfv7n2GZHv3mqXtropKdtBR3t6XQE58UuBsz9rjU310dxJu9dW3NEjqEx4I9v16CW7NgUr3sYaEvWPMX0zYoV9MiMH/Krv9grilPc8lnjAw7ri8RnAE91gnxfmb84zlqu4FcujQf+jp2zWe3441c7v9MHaF+5rTbhHr8d8gXitF/MORf00cUx0BVrpz/Bpli7ubND+myv2kD82B7Nw3yX6yNgWwz2E/qImGvfEaqN471xm+ub7joHnoW3l1xv+Fzxvd/JBRY67Ba6hQdXFhE/9F664Czw5Az34sT5aOOacfLB57QjMw5d/dq6gaXbBr+iGMBH/r+9+najuv24j99v5foq+BNvjksxtCV4llNHMjldARv5OtrwfNX09uH35eN8Fdz3o5Hfl+8UPgPgq/4eDkJz6kPX7ww4QRyMsZsnvtrMsfUGVy7Nh0CvNaD9LC/2HqTSdb1yqY3O0U023VnXe2DDnzyKXb4T8dmtaX1s9c1+fghMf7Wlr490vRMcjyTf8W8sivNS3P5CYh9e/vW78/djrM4/+9lP3r2c72HT/nUWd/Y5j285rnWfSF9u93RfAnMdjyNUU9I5HmeQW2N7Bfz2Qcv6eebv4VrRh5Mdv7XdMV5wtfb00pUb7GyrqbgzNtEH+crPFaQ/fRsTMmORCfpX56W+9slH5vB8uRKKCXT5pc+vdufGTV91AX6swbPYwKZa7Or7LMSvXF4K9YCdH3xXKSeiZgmsPvCrDiHewB/QmTHCGo/QNQ7dK7XxN+1dG4NizbmZz6BtztUE2OWnI/tQPzQ/Jw/oPHtwnOcTdKvnRDaT+4Q+vI/640lPvvElodi7dfMsNF5EjCO+K+iywds5ka/r1nCczQ95uJa3vuKB6+ox4+vvWo3mXnFkE7Tpn/zugQ1e9hvnZGfXfhToybG84Che+VePK2BTrru5uAIHMeLT9RH0Xa3RRPo7O3zFVZuriOsVu/iW20tzOIL4v/vd774d1w+39t7whg+Jh19yWUxXJruN+DWLTZyOZz7uxWlTPOrnn9CTMz3nsw5EHHra58aVhCMuxdBHf/LacXB9FcX3Eqj4q8Qz/+Rm8/5BS46uSZzi1cOHbxj4M6592+NjAd1HavIpAn8vCzwchMam8fghYQ7g2MMLTh7ayeR3y+PPv1XgwYM0Lxqvo9z46CFnSnMyHdd83nuwoUOXxP8MM96U+iAeu7murzhr/y73Yunb+XsU+XaMQzEIfnG8Ug9Id0q++tFEbT5w+H11rv1OL21nENt8gfjNsT9COdBJ/0NADFj9x1V7Y1YNjrjQ74PIlXHmqzVnX/Vthd1cn/Hu1fsMfmQaxx2/al2szqsPTB5XUA3XWNXJkU/9xQur3ZGvFfmZwmZKvvSBHEn9te+g/o1xPpzvoL+6ns1h/vR1bN9l2/yY467Ph8qjuBNxcOw/FuJEngX+4TU+q+szuJXjRGM315i2lfu8nm1d1wba17HlszwmtM386DlqC/y55jP9aQMdIf7JvIZy1Z7PapP+xHodvxkTiqNvB/3iHPWz1W884jFjs8N3fQb5EOCfxPlKvGzwlEPCh/bq7kjSD7u8s1mRbTW7YgNs8GPDtrYj5DPdMG30lSfoK8dAh6yxaocz3iviL+aZHZ3qGtiqQfYdJ7fGfOX7Gogx4zlekbhd4TL12Mn9aL09Cn79h9u//7v1913jG97wGeH7u9gdzIX0sfDaWPc2ibV/jWfDWTdzGwjp3DE/9/jqJzv9flzxno8VNnwPAd62e4D1QYn4MaO4rhLnoz6IK9HOv4fqj/2C6y8J35X2k0LjDs11c8CcMreaD6DPw8BcE8Ce7k7/CLNvnYuue6hxPn3uMO2dx/MsPqTviDt9uWV7Fvusjy3uE+nu+l6KOMzc55FAeZVbD1L3kJ4j2/5HWJvf69TL73tgA2IXv/N47YRe+eQjiHsl9hn4bM7u/OEHa/yVy8QjnOiW520P//7vvXsf5/2LZfon4e/i0Zo1j9g1Hx5BOWTX2DuGYqTbcacDanAPfJDsptQHzUH8Zv8O1YDN9F37Cm2keDu/s/02tje/MLlN0DFf6KVDnCfispsC8Xc8sktW23soj6v6K8RnO2vyDKy+dvyOOE/bR/JKd+bSeXI016pB82vKtFvbwZG98etaf+i8GFdxlvtRH/9zP5to/s25NpFt+/OHhhikWrYW7uVNZ64d4CPeZN3Ty4tM+/pXTD/WPUx+O5ugD5/GnU08j6C/57+up01cJ+JQ/bqedaleEJ9HUK58rvtWe9nk2djJY47JHLcQ32yegXxOThOzHi+FGHJrvPiceb0Wt/H87uINb/jM8LrVdYJnbRRnfvTV3/kUm8c8b1NbZacfaoO5kdwW/mMrf+qzB/EnfvzjP3+gDT4AkW5ygX7cbi+4bi+6XHvRhW/i+vty07/p/nluDvR8u8CPJ+l/w8twq+ljc+ZjAr/mY/OleQrmmf71QYJdc2fOcedHc/kMYhK22U+/Z8iWfmv+CofmP1s2a447xGn1P7mufdX0Kq9HITb/c/wmz6TatAce8Um3vn5s0be6fIPLjzJeBT75wQtcn0n5pB/0Xanh9FXOq00xVp2OxXdO0q+uK9KZ/drWWjv2YG6/vv1uw+9/Y8FpPz5Krx9tj+dLsON3D+VbHuWQnIEd+5l/3PN7xGX1nf5r8gc+Wh/xgvzvgIuY6WbvCJMT3XLljx7ZoRrSm/k2N3Z5zrWdPaE7z7vuGIfOHePpPN1pt55Xr1XSA+ePYPovr6NxeAT8XvVzRbf8pl5tEzs92OnSuaIX0k/UizQP2SYw5wpod+6Y7UR2E9PfxPR5BPHTA7rN7ebNCvrzefRjQVzxxMYzfitHfdrm/GeL76w3vc4n0u25g9706XwFG0K/mmSjljubiVnLozj5c5y5wLRJJ8QtsMk2/QTo5vcK1ljVfJXqEJ+kmlXvySvQq231q03f5HEFxZ/nU8JZ3xXQLz9HnF/CdwW/xvENb/hc8Wc/rtii321ALRjHe4vQZsPH1GvRHcncSGYbH2t7Ik6ojU2+dscp2dgUilM7yMFLoF0+E/khO521nxRn6vtA49rvuZqwed1+B9bt929kx8cR9PuRopu8f8nVzef9sRvm+81We31iq8EPiW8pvcv5c8ePfvT9v3YEZ/PqY0Ftu6HjYsxXTvpwn+NAp5ekE+mYn/LbwbdSjm6g/LIlzuOycjoCvXK6N2/iOMchu2x3ceNHZ5dH9qutNnZwNZ/XQAyy5ojDzHMn+quPHLVN+x2O2tnp46eHsSuyIt6O5bYDrnTKxTnZIW70wNGe3zpwLSbB/2jeQjXFPVu+a09cd1/xS+btzWsu9Hxjju78pm9cj3I/wm3/uf24NNvVXpxdO4gXin8ksLbJ1VG+6udYXXb1pKt/NweAv0fzD/kuD8jXUe7pxz+kTydf9ORFlxzxzO/UdZ7oW2FOzjmY3ZTJKf+ObOfa00/XOX/Ok+yBbb46TtE2RVs+7iEbHNfYU14Cc2SdW8Wa7eWhDsE1zDxWjsDfalvbGkP71INdnPaF2XYPfLPD0Tmwd392XVvHahCv2o/A18p92pxxpScOiSNZkQ+cm48/FORabaCjtvgT7biS1tbM72wcZ01njc6QXnbx0X6vXsXLh2OYbfTytbMxhtNW/+4zQn7i2LyO+1WwJ/Egc21BfGb/UazaZ57QuLF3LN/i57vrK0i/Z4kZUx8010kxIL2rYMemb9wnLwE7//Hm2eQNb/hccW2VvgBnC6tFbOG3qUyxEfZjGa79Poqk9vqmv9AG1k2no024b0MlfUBf9T8E1pp0vW6Waz7w9ddf/2kjxNsvAyT3wM1NqvlNAn9E3n/4w7+8k9///iZ/+IMa3R42Vj5veBmq98SnUNvWIlgT1teclzhaeyusG3PnQ0B8tRJDfJwegXlrrcR9XWch/8R5D9jVpL4j7PrivYupj//q/bERN+PWHjhr3B7b7wHCdbcHrPM4VLMPAX6rW/v2EehNLuVhTHbj0t4vLzZ8E9fZNHaPIM7qXK350sbf7QXXn79UPoPx4esRG7jt/bd67GxxrV4T6TriWh4gl+YLcS63ciTamm/VOOziAR0x1v7aCd9H9veAE45ywYsv2Pkrn+bQClzwYlu+u1xX0CX5LV+xdjzSI2eoRvmcbRP6tYsHzpPsibFr3KvXFG3FSnb3ix3KV0xwnuxq8LEg9tX4cf+hsfJtTLQ3ns7NuThrv8f/qBbsinEGtu0Rrbsd+DOfHt0PPxTwqGZ4O5rX5YFja4IeaEtAre+htcUHff6P7KqdmhdbLHzIFYgjpnyK45xAuUxoI+u6FPts/PWLBTPGI8CxuDiYI+VAxCiP8jqaY2Hl7bo2Ur7a8qe+3efW//A9Ax8fA+LEeR2nR2Fe/fM//+q7qze84fPE33z99dffW31tkhZKaKG00B1tArO9c+jaQktgHtN33kaz6tFxQ2kT38Fm02a0w1zoRzr6+bFxiqMG4mpn4222Dc3meeajTXWnoz8d/eXT5i3HCT++4gXTt9X44te//vWt8QR+hOWnP/3Z5QfLzw2+2TZfzn2uMLd++ctf/GmumPvdqH8omJfNefPSNwbx04afNn1xBm3msf5kBb/srKsdrKnW3AqxrMnqQ4c/bdZKvK5AnPR3XMXiu/5QTUCuax7WbutX384vH7v8xWNbzKu5fGjgFW91n9zWfHqoXPk3b9Z6wFGt7yFeYsbrDDjA3GsDH3HY7dU7mHfi01/36hV803esNo7F0nfL4/YXas/82fe++upn73xNsP/d777+7uo6/IjpV1999Y5P62pirrkVrYV7+UPjDGdj3ZjufLIn1X3lCu1Z/B/FWMGf+cHnHH+x+JvttfF9xCGUi2N71BHiwF/joO3sgxN//E7OVyBOsTzLrIj3lXF9BPnF96gWdAioQ+eNfefrsXOQ1xyXeS1vOc9+tsZUvrXvatDcmmvB+nA98ymHOT9ciz33fv7Fnv5ca2c3x3UX5x7wFbPa8PmHP/zh3ZE//kkxiRjzeoKuPKa/7MH5zOUI/OLG1xHyPccE5tr7oVB9cHEe16PxoZue/uZCuc38VrAj9Al7do7s9BnLdR1nM+csjjt+Kxp7Pu6NKR26OIRsjsaITXa4daR/ZDNBf9YiaA/8twbp4lPc6nEFs37PQrnjP8cjzo4z3lxzV+qzQ3OBPd9X5sHEb3/722/l/pco3vCGTx0/sll5sHIkFmObSuctuhaeTaBNygKy8biZJzZgfbU7ErpEn0XHR8cpj+CezaP+wmr3Uj8rqmEofzWeoNfvu1ltdvCByTcCfvOb3/xFfr30Sg0+FzxrLj0LrXO8uhk6t1bV3c1yzk86rWnnbI/w0nFrz+G/NULsLfpwOosL7OPdeTLB79QN9in7l36x7I8zn3jBbA/66PC79uvjX5+9dqfzsYGDPPGQ98xvh7M+Pnb58Alrre+BLzbm5FlcKDa9nW558XeFRzVhE/8z0LM2ijHtusf2gks+j+CWm5eqL3sIf7TuL0U5J0dorHa8+KiG6a1ojzrqn9Cv9rf6//mDv1jaxUuvDwrkDHTZ8WnsrekjPvnns/F3ffaCC7fW5KPI55FtY4XzMzH99ny5ij561dd5dtVdjUj3nJ4xk/UZk01+5D5r2rW+iVXvCEc6qz+44g/iOrHzdw/mUGCvFo7Ny3w6dn22tmC1q/6kMTsCn9aPcRZnh7g0dsUKZ9w+NOJvXTq6xs+LQ3xXriDP6l3tys9cN0Zn+Ux9Qlf9xGdPtK9gp37WA3t62dxDPEG8OY9W6D8ayyOwwaW16Qi4ye2sHlAOeJ6h2pmbfJLyOpuDHwN4qMEqak1mm3xxjftL0B7Iz736rvCfZ/6i4hve8JeAH7XpOBKbxD1pM+l8J2d9U2Cer3h0gb4Uuzg4PRr/SP8sR+3rjcXv5rptdF+8+5/3exs0H2puDN0Ev/nm63cvu7R9zpA/+UjT4KNgzgPz5WPN8R3MK3Ov+dUDCI5rH2hvv1jz2OEst2m/Qtz2kOCciA101nUzkX58+SunCTq7cdDOhn22HkJmPWBnC9kfPWjqx4uwp9cDziMo/j3h90jmg1V1Jyv4mTjSezbEndzO0NwhO0w/Z/MnqIv4Zz5X0GvOQZz50v6v/3r/R9l2wMO9YfdB5wrKRdxHYz+C/J/FUHt8GouJW577/2ybYNf6obP2h/qr/xG32qdu/Hb6gCP/+tNlV3twXj70SLzsK1N3Ir9sSR+EkrhO4Yt0fca/vuyehXivz5fQdW1xi8tLha8p2qrFM3ObOPIr9sSOw1XbezAHpn+5qy3oqz7BufHWZw7teEx/0Hm+pr8Jevnd+c628Znj9UOjnPH2YkQeoJb2XHP5bD2xK6/6y5Gtcz75OAM9+vPZg2/HozrNOPjOcTiLVz4zVnmvyOeKI5vqiY8YxPmMtXumCnGju+ZdG6EDM0Y1IHTwI66PkP2ZzqPgT/zqMCX+axub16AaOMr5qL47/Pu/3+bPG97wl4B3L7mmtMBafIm2BDq+Fs/cTM7wSJyj3M5ynrU5w8ojO+2zz7nNybe53Gx/9rOfXd6ojJe/hOh/NJx/7rhS188Vxtm4ehBZ5ZEb00shRnFa69ADweRgHDzo2ScaE0c29x4eHsWZr3i2btTqtlbef+DLnk77Wntc3AN9bWs7ZO+hzHlxqks2R3zv9ZcHcQ58i3NV6F8RHI4E4hCPe4j3il1bmDFxejZmPlCc2QY4NhfUcO0PbPXTa6yuIt2d77M6s0tCedzEuL/shcRLbMLK6TVoTPjbrcny1V6daltzmLU0VivY1J7uUR7Td/zOdO0FEM/04xNfsnIAbWd7Pb32n/x3TKAYCX/lPTmI1T6Z1M/Xqv9axFcOjnF3nZTDM8FnIo/qMaVaVH96a01WWXHU/ho86o++HLKb9Qa5VGO50e2l6sxzh2oYjvTCWtdVn6/4QXPiUwCu1SfuuFl7Cf67vIBt9Zo1C+Wqrzqd1ZOemJ65qhH9Mzs2asuuGpdPYx2ck+ZH/MguTvqzbdplwx+4LmZcAv1qqn+uuwlt+umLNeF6CtCF2sSdfcVaaxFWP89EnKpXOa1ttb8W1Vwua12P4IsRPjs+I/4b3vApYDvzTfCzDeAq+HjtZnHP/gqnl+hUg+I/mvsj4NvGttbLeT+y2FeWr25WbI828s8LH67uPwze35BDY7XKh0ZxAadE23xYCT08Tf7OzV0PDjtM3RX6XjM/2edjPiS5njV1nm45QDpxl8cO7PT1wER/fQAszg5xPOvPfw8mcT+TfF6Re5j5nWHWiO49/YnJG67wgqlXPmTWgjQH0k9nHieq+7RZUR+9mftViME+/3zEdwd65fHjH/sw+v4FbuJ3E95+xcD7H3k44r/CjzqGXU2uoHxIuTwqOMNuzuUX+rBW7fXt8tXPzxonAf2trx3S5bvxdr7Gcj19pzvzcK4tnTjHwbmx1K5/B/Z0q4Fj50lxk4l4gr6VN6ktbvGZfY8Im1UmXK88PwbiEk+YvKekF/fZDtPP7JvtXa+yorZZk53eEfLbeoLmI8TFce4h5F6cfE/s2kCbGHg0r1c9OTZvnZN43kN5fAis3Ang2XrDlQ7QT+Y1+9bjEcrZkc29vNKPB1TfM9tpw0d5rTb8QJwmP7pJNmu89KcNnWmX3xXa8GNLrzmTXedH9hP1Z0OA7+pGp/7qtwoU+0xegvJ8qf2jaFzEk9u9uL4U4UcVzZs3vOEvBX/2i+dbDDYEC2SFPpvlvR+XWDfPFS08aBNaQcfDvJ8zP9rkcInrkU4b2NHiFcdLJIucD9y7kbj2u1N8mGhDPoIYbI5qs8aZ0CcGjvrqd/zXfxX3drNSC3xW+1BdyZUfc/wUccvNzeB27vIv4ZfOg/nx5Zdffjuv3//iTvPl3nr6EDDH+x9d87qHImtuzhtjoH83bwObtb85LbedXWvqNsbf7+ePPdvd/tC610ev6/y0DtoXZl/Qz46PeNwDG2uYfzb8G1Nibe64stGf/qcOucGVeuwgV6j2wOdsB9dn8z4ejaXjyknbqtdYJqDd+ZwPAY/VDvjzDVo2rY1HkF/gg7222z3gX9/93oti2d/E8w2t7G7X7z8sxs31bLv9kZLbN3fv4e/+7u/exWJXLRoP57iVLxQHcIH041GOoG/azHPoWqy5HlyD/uI0HvyTdItXf4gL+6nrfNWdiFN7CH3CVpta5C/d4pzVvFwIv/nRbu/Tnr+JOODcOLwEfLdX8XPkKw6O6z4Ks7/z+lfdeQ5Tj+0cu6tYfT4C+c/7z+SgxrU31sazPI0PNPaw1ocd3a5nH3s1n9fO5543Y0w9Ps/mbKBnLuEF/IjJVp/2/J2hHKtNEJ9oj/vklV/9PUussejyz84xXtWarfY4TPAJ8Vh14nGG+Ezd2hzVpxrRwXPNMb3aJ+fpQ05XOAG75hM/jme2M07xjXW2R6DbPKCXDaiv55YjsBNX3vHlJ5gPc45D8wC0n93jQ3FwZVO88pzjsYIeiZdz+mtdtIsT+A6rHvABu7jV74jTDuLhWL3E0eaoLdRGpzgvhXjVtrW7gzj/3//v//ju6g1v+MvBj//xH//xn747fweLIdktYAuQ3Ft8dOBoE+C/45mORXq0MCE/Rz6Azhnntb8cy8EG1PkZrsQ5y6dNGsrnZnO7Sd3+wiBetw1rBV16v/zlL//0cPs5QuqoT/6fay4rjJ8xmjdb8+XeevoQaI4Q8c1LDyjrPKzvbI3JZ53X/J6tB31HPvmL106HLdRHr1y04ZJtNXdMx7k8raMjfjvkO3tH9vne+WIjfnw+ZVQf8lKuagHZ82WuVbvp/yhGNtW1I311nMJn402nhznXxXAeL5hxna+cwfg2bvl6BHyyIXjxAfzeXmaZl7dz38rqm1lEXHps2bkHTZFffHzbyze0ZtsRfvaz28vjdMUh2c2YUO2b653PseArcT1l9k2ZsYEu8D99Q7q1OcYjnYl00svuCHTMNbyyDc6Nhz4Qs/zvfXiLIxSfPy/w5cPHCv1zjF8D/nEv/5nXDunh7Vg9Eter1JfvmZNzvqpDsrtO2ORjnr8UfOIX8onvrEft6epj6yjP9LWtubMzF+a6JNpdOwJbmHxqox92bUdQP2NcjPi0j/BV3w6TZ1yn/npNP/7a+S/Wqgv0qw078x7nrvXz4UhWzL5iFWOnv4Jua23qu8bDunfUJ//uHa6z1Q/6tJP2I6K/nLrPkStQA3nF4Z4dffyyiduZnT42QB939vLD+cy2sWYz7YL+dIJrcar5vZyATX4dxanG9zjSqxb0Gqcd4sr/mks2tblOtCXszMOjGEegz66xmD5nDWuDR2OsYI9v86TYE//+7//xxf/8n//zz8bxDW/4S8CffZPL4rIoYLcgWjA2kjO0qCyy3eJpIfNnE9tBv5vG2f+OFEeMI517nMWx+bQ50m9TBz+n3IZ7FkcMtmdxzvLRL46jOOo/9TpXrz/84Y/fxvqbd9/qoufBWQ6Aw+cMH9jU4NuM39XByz2Xt7bPG+aIsfryy59913Ibz7Mb8yNoPezWblBHcwQPMRPQPuuMG9FGZ7eWwTde1m9cssHnNoZ/bmeua5/xwyPf5Aq4k3wWv/2l9VysdX1dBb/W2lxn/LjGd5fvlf3jEeAQXuuvupVP/qrPmX88JpdqDuzqMwb50q/9qP75pJcObtqcH9VQ/9zHV5TjbnzY1u98ttmvXzJu1QGc8wN9sNpBDCLvNeYaH79yBr9Lw/3gDP/lv/z9O7+NR5AnTtry6zwO6U4bWK8fQXGKjZNcxJQ/CY3NrAkb9tVqh90+Edjywe+u3iEd0E+OdKGc8kvPefuPczor+GyOHOXzCPA219R1He8zNAZnOR5hl1eoLqvfabPau177u+Zj+ul6tjWvamOrrfxC40UX0mPX3NnZajOu85lPG+Fvzju2UAxY7wszhut4r+CbHnEe0udnohiTu7mRXu34uvceoXUiZnnCLh7dak/MK3rFiav2/K6Y9Ql8iE/qY38E+urkWEx+u2YbHzL98107CfXTBXqT49S9h3zAVTs2cioPsXv2OAI9MsedzZyPR5CreN1rAFf71Vr7tdauxTjjBvErVm3df4+QXbZzLR6B7orpg8yYq75r+RXvbP5NqD19tsVynGNQm/hX58MZ1JLwq5Z8Tr+4/5//5/91d3ze8IbPET/+f/4//5//ZEERaOHBboHpt2DuLep8wNFCLe7R4orL2eK7EofOlTgt/q7zbVPSBkcx4EocN6VZO21tQgSyn23xIuJ08/dLiN14XH/r7Tu5+f0cISf5/O3fvq+J3HxbQd/72qrFd6efEYydnObDgpyO5swjaG44nvnTL77jnCfZglqbpz2kgr7OV8hp3RPyP2NMzL7VL3/65LGLiSvMPufaHdnGKR3Xzmur/RHwr3Z8xE2s+DjuOLvWh4NjuV/lUD7EeuAjqX32zbbipd853fpxTnAi+o6QvSOUD7DNj+McA+CX7jpfgj468akt1LZi2u0wc5p8JuJM6MpvroFHwBanyR2K4ZhftSB9GKj/HugUw3gwOaor/PznX30v7owx2/PpGheYus9CPsXAv7kitvrNmNVTW5IeTN3QeJdDYKOPfeO7sw/t1/fGhr/8Tj3xWi/6JujI23PGme9HUTy+1/zv4aymL4W817qA82S9XoXtlNkXimMcdn3a2Yb0Se0z/+z1a19t+ZtrbucPdm387WJMzhP6jKuYJJ6hGMHcJvi1t/BNZxezttVvSHceSWAvRnHzB9aQ69Z4kAfMtpBvffWv53RmTXegU82Kx2auOTpqS1zXXqwV/BQ73Y+JyW3mdY/HrGl7xD1Uv6kr53Us01trl+09btMm/Sv86BV7+oDZfoZp5yhuc7gx3sm0u4dqH1wTfoK42q76vIJqsMYCcX73u999d/WGN/xl4UduPG3snVsMXSfptFCehWf6+lB4hOMVXTo2MrUk0EbZA+ncQNNt8yN+xMWLHz9+4ltB/bhLP/KSbrBfFoP8UMDJ/xQ2n3D1vxvayG2uvc/1lvvtw/mck/1C/ls+704/C3zo2t8b32pKpq72OV/MvR6Kw+y/gun7Y2HNb/Iv3+QRTL+tS2s1cT111pzr7xxct9e2t2Y7+2oHtuKvor2+Vad4If/ZxH/aJPQmJ4KTtmzyc+RDe5hxj1DMM52Xgu8jTP6dQ3nv0Pjs+vOTPb3a1bwPgqTrGf8q2LIRw+/6K86KOK6c5OBce3nzSaD51zx4Nsq5MRe3/IsdL3ANtWV7lPcKuvkoVvFWVKNqcYbJIV5wb45Ua+d0EzZJnB+pf1zgEbtq8SHG+h4aiynV8kym3rS9iiu5Huns2te2R2x3oNc8cH5vLqhD3zBJqkf22tpz9GkT46xubJMV/ORzxoP8JhNneYRVh49inNnraz2lx45AXModqkfHM9A50xOT7w+BOHYPgbl37OqCC7vGiD3dMxtgt/a5TrpexzmOBPTfqwebOUbA5qpdMfBxPMtrh8Zz5X8mV0H3UT6vxczhY8d+wxt+aPzIpG9jnBskub1M+PO+No+PhWcsyns+bARHeG189knXbdq12YDmAwexYXfzmjbZ3cbuJl54Tbm1N243HX+ti2jjY0Vxz2rxCPzYoTji9XKK+NG2W9utvRdzjvrkxa5jNerF3szvls9tTqL9JOofFM+q74rqdOa/eZMuOJ/Xzbv8NCemzlVkt7O94vPRmMXi21qa6Ho398+Qz+zUJ1/irPVq3q5gM9c35HvGmMfOoZx6QJ2ibcrsmzGL65hd/Sv0a9/xyj7/ifadr1Au7M5QjNC59quYfMM9foGOfGD1sUL/uqYgH9UlvfzVXw3vgQ37NdaMY0/sPxFufe8O79BfVqRPgB+C0+SFk7nhvP5ir/GfgeImsybFhvgUv7whnmcoT5i2K/JFnONDdjG04Zcujvw6Nw63+9T3X8DRmeuV/vRRnPXcMaE/Ze1zjMds63xK7XTj51xfbc8AX3w/G3wmjesuzszvDK/J+SzGvbgr+JpjNsdpx7H8zalecs2Y+atGpLWm7yXjnf/m8i4mv3FboX3qT9T+KKfybP25FjuOhO9ZU0hnx3OCfryPuEO5v6SuVyD2zAvKGccZs2v67WdsHPW1T6124Fr7BD/pzqP2WRPnzYl00j8C3cZh2p3VsThTtzj6HkH6ZxzhpX6rQdIcie+9uI9CXPKo32fzeMMbPjZ+/N//+3//pzaSFmDHMNtbgBYjHC0CCxZWXxP5EX+H+vk48hMfONLhg9gAd5hxgutysNkWA87i0JNPPuexjYw9HdLmf4bGJz/B+Sq13/h/fwN9/7LrdqNI6Nz+eiH/yc3PxI7n933MmO9fqInZyymx9d/GnP8eFG716K8O0sn3KuAoVvncfGm/9QG/nX8qwEduvr0WGt9dfSGbo/5AB878qJUXiuZd8yDEoa/wT2R7tIb0rTahvpUXn6S4E3Fjt/N7lGuxjtYVn2yPuE7Ej371P8o/f+nCLi99fMav/Ijr4oE2evWtvh5B9lOugN6sA9gPd/bppJ/UR4zPGaaNvEPtZLZP6JvzEBcyuZbDVVgrcBSz+pR3bROu02teg+Oqewa22U8fkB/X7zl/f5ztxV6AyaV5lQDbyS/e+rWtYwvr8aUQt1hhxq4fit81OE9vomv9zmecaT+RfyJn+yFdso5zOgT4Ja6Ng5qnH9j14bL9hA7dXkzkZ/LMj6M8iku0JfqKm//0tU271bZrqL887wns2oJr/uT0MSAWVD/AQS2qC0yu6WYLa9vqT62NZ8gfvXR3MYDtqjdjO2/s6NB3nq+J5orcJp/ALls6XfM/43a8B7HE5It9v+9nRZzp7frF177r47dcd/386p9zqlysv3Kb6yo/jnSyP+IX6E3f2Rwh3TjU9qFQbsWtNmGda+CcHb3sVo6uG8PArt8fWCzCF9mh2OkWZ/LZIb343dOHOa5HzytnYMummj0T5d5xSrWBozq+BHy3j6z1cP71119/d/V+vJOzOf6GN3zq+NFvf/u7L8jvfvfNF9988/t3vzzaDaGbQgsPXHfztGB8ULcI6KzI5myD2Nl9KJzx0HfW/xLIX23mjbYbgBo6PhKTLrtuxNWf/zYjbW1k92rbt6Le/5jjT7742c/eiza/74vkC92Vsng4sPdjk1999dW3xy/fHX/yE5y+P3f+4z9smG7EWv88f7nRdQOtTuIXo3m1wssuL8gIzt/OrlvHJwb5reN+Nlb6iDrfw5kfULszP3jd+yWfj2LNdeKs70OgePfqNGFdqZuamJdnMF/7QNxanNDeeO6gv3XSOv8UgEu8yBHa88p9J+l1vkJtqvczsNYwv1fmAFv6Z3wbM3rlvgM9c8P64q/7wqMQpznGB19BHy5yw8U+7ncbwpx3a00g2+xXbtqKbQ7wIUbr4zXgmw+xd9y0i1scOis/bfgR94kVbNmU4y5OSNdR3IlyL3664upzrH5qU80nqiHdELcdr3KLO+HDXEpca88nXq4BB8IPvSPb7CeHmUv3YOKcaNc/a7bL+YeCXHY1nfgQfFefj8ZQx9Z3Y+J650d/Oo3jDo2Pfuf89a1P149ALHPY/HE8Ar75PhoLbfQerdER5FhOfDe/19j1Oa59R6huVyEn9RGHLW4fEvJsTMRWB1LcXa6u2wec02/uwW5s2mfE61x+nR+Bf9zY8dncOAIuxWBbTiufCT7FuMflDGKRe/xeguZD+6/P3NWfNFfJs1C9rvhU31/+8hdf/MM//Lcv/v7v//N3rW94w+eJv/m//q//3/dm/W1x3c5vL0L8CNn7P3mt3yIk2toIbSjr5qXtbKOhw97C3mH6OVr06cRrh3txgA7EV27dzPqrceW/5sR3PEj1iXegwyceu1xeA3H5h7hOmdBf/M6nrGAvx/LMH105ruOjX/3Mh9VffdVnhQfooxuUPv7i4LxaH+Ff//U2J32r4VvGf+L+Q6H8/+7vfvldy/sPcbucQd3ZuBGewdw6qit7wlc1nGDTDXYH+upvLexQbL7XMfcgvcuPT/NW+9rHnz5zgUxUDygWX6T8dnbAJx3xjnKFYlTPNaeJajnr66hd3pNHvHc5PwtyJFCeZ/xfg8aQiFOu1aRjcI1LdvRnHdRHn7pNaCPquhtX0D/318bAeTFqA2336kLfvGdTfrtxi5ucnO/m+0Q1Y0O3uRi3Ha98r/NJG33tzls7gAP/f/zj7UOWXzxvDZ/lzsfkRk8NcIxnoDvznnPgKtid7S1BrrjgLp7zHR+w59gvW5PxOso5VE/6R+OnX3y6q1+xZv1DvNd5QZ/Ao3VbwQ9O8aqejSXeYr8mjnFaffA7Jazt9TVm1Wwed20vgVjyxnWtt/rMe2m1ESvdxs+19unPdby0r3OXnnZ5preLAXNd6SfmDz01do1vfCYmN/aua5sQm8/8kyPk7wizXywcxd6t32JVD7Zs6E+stZ5gV+1281Yfe+sK5Kle/MRNW/VZ/UP8/v/t3U1vZdURhWGkTBiFYfJLyTR/FyIiEYnAoAfh6duvXKre517bbQhIXlJx9tlVtepjf1xjG0NPNqqB4GRjfGUf2Miv3EBu+Mrnt4TY4hF4dO9DtfKZuZd3cH7UEBcdqddTdwX2YvDpXpx8dJ5xNVc9rcVVHHXwoccxEVcx2OCbXObFEuNR394S5X3a769FffO0D2YteuP/rvj3v//t08wT1O2P0vsFGON3vOPPhs++yRWcgV/P2cfDBv4TNpeR35TxWzPQ5dNFQZp7dDF0wcDVYcbXhwmeKy6Hl25fZEEcPPPDZqMaOsjsfXBDHw5syqP8+czcvFdPc4GuC33rvhRd/Fc92JBLuZ/G1QZd/uWcHZvT2tC1bvUz3NOBnot30vUBOmO1DmB+805b8x8+PH2xU32/J6r/m2/++mnmtmZqvrd/1b6/ybXzZ6O2ySMWyfZUc/Hrywn8Tl/Ihrk2k0PufaEwUR5y2zHp0sfXezzzfcfzLpcdE+IW92RD15461TMxbaFcyOy7dWt++ty7j16C6tl5eBaLjfeZY6DrmdCr/wpsunOm7eQN8W+Yl3d5QT3bvTFH1NL9CnLgE8Tvfq1u4/hh9sSzdT7VW9w+C+KffIFdPenOvALbns5OOXo3njWGejN13pN6OecSnES9/QvKPfBhi1M8Tz5XdffMD9hmf9WLfPDfOw84CT5c1XrKB3DqK9TPqxzCXAfPK3vc1lk+etL+kROOappgI4e4obo9n5PfPZRTfekMpDNPzE3dSxAP371/6F6K+GCuY1yeRLw5B+aq4fRkh7ueB2tmjebnGDv2rWNz0HrF533nuj8X4xM7iGsO1/TnK645fuz4ecaThMlhnJQ/27iKC5Mj5As7zgnxN5aHfO29/bUBu3Jg6ynHvXfKMb6NUz8DX3qc1tU7juKUr/zME3MT9DiKnz4/MFfe5RvfCeU8/cAc//I85fNWKFafXSCXfSY2+JH6GcyFX3755cgx6xPrXhyIU59n//nr4b6r4m9dxCCnHs5cegfv4uRH1KovvQN7ceSx66CbMfM77dGXor3zFlxBzX02Oaczd9ALcYMxn/r//ff/+mjzjnf82XD5Ta4TbHqbn9z++PfTT5E7NF0oDqhDcXXJzUtqH7iAO74uvxO6IK8OYXnPL6JxB+OkfHD24eBfCsTHwaZciPc5ZtNluUHvonntF5lXqD55vfQiktNE73HCzLdntYpJJuiu1u2eH+hPa7B7ZE3im3mU8x4XI9ubn+ct7ocPdE955HsPT/wf//nxeZu7jZ+en89//OevL3rjtyND9dzLg0/6K7Cp1oDrxBfY269xT//pZ6z/ffBuTmtaHZDec9vCtpu+YF49MzfIpni7J3Nvbd0EO3L6Isq859U+lBdhU4zssqXTL1wgTmfTHP95H70W5TJzNC4veSRQ3jDznc9pGxdpvpqm/71e34MY+OIJ7bOJbGff9Fhe5cemNa3Wapgwn2TbvPd8PKG1ZGcd974M/Nnmf7KZYF9dM+bJjw37q95UL1/P5o2LA+U1c6zOiXzEzY7cQ7GmAP7GMOOJcdXPMHuKR058TnkHvPldnbVyrMZinMCufrIj+dUnzxBXvPl1D8SVzZdAnQT0Ze+RaizfR707gS9Uz1tgruvE7PXUeQc+Mwc85ZWNfPXa+2k+ND/rEtt4zonBb+fja5b5Ayj8/Oeeq3dxBr7xz6f56p/gO/3ZspEXe8gvmWBP4pgxTraw5/kWi009Pn2TS8887Tc9YL/35sxhrkuI43SG+eoVtK745Vj+wC69+akD/K1RvSSTp57NvbZ5YHOdYuFuTEKcU14LMYolX3kby4nsHm2w5aOWnePPP//86e1zFJOwPfVgg+2pF3w34pcbnNY7sJM/6c4rr7mG1WiOhOI86lW66ftalMs+J18Cdfj3WXn2Q9cr1DPozH333ffHtXjHO/7oeNE3uYID6ODf/pD47eK8/eHyG+gdIge+C24e/vzNPzrIHbbTJYMH4toxwi2/2+UOmweycajx4Jzf5OJTnFNNMOOcYsipb+JcYeZ9hc0tZvnsnF4LfSd4T19cyJP+KubVuuVXvrsW/Ylz6/S/+a0D3FMmijfnb3+YGZ8344/Tn/xv41/fPo2fnh//+Ukf3+Tdc5/rfEg/zf0/US/rp+fMN5gj0zZMHWz93Cf3dIENvs4KmXqYZxHYQ3vr6gwG9vs8N9853jlBOijvnVsohjrcc30xNvmvfJ8D/POcPeISs/rAOOS/+wCzj/mYm/ZfAjXgJfiu1k4+bOd9NNeQv17Tm6teaJ+cUOxsJ8zh8pz9w9d6blQPv+f2SB188J44Id7TZ2Z51R/vwTiJA+SVlOeU4D/9kxeZ8/dQPHUB3xk3lBM9zPjTrrtAnuzJ/MbCFfjhib8cTk99nTEnyhPY1C/8c18EuvZH65kd9KymE9gk5X+CvOb+uaqDnp082Nzj3Ghv8cF94n8N5vndEE/Oc7+3BvUf2Mz94b1apy9UR/M4WpeZAxu61oa++jfEmXdSfDPG5Nt5z/niEOMJNsVPx0c8MJdMsCkmzHG5QvP1EMwZFwPSk3w8/XbPBB/1gbNqzHevyeS/6i+b/XWoOX1Kny9+cTbqqVxPceTAJuAg1Rjaa+a3Dh7FAfopcOKCqc9mjk/g09pWh7xIva5P5Ap6q95yAPZ7rTdmfHgUB9iWI1jvez7TVp8frWk5iFNe+XhXq/cdM3/9flTDW0A8+exz8iXQh/6nM1ff5BKzNWt/ycEfpf/pp//+LrW/4x1vjb98++0//vlp/CLY8P7ekYPQhdHlCR2WZGJeOvuwTR8cydZNiQ9m3HynbTLhHQdbl5ycjGeebMwZO/g778AGTvo4iu855/b4uVJe5K0QN9yr5QrVceUL6YoV5/RpztN6nHymDUlvrnUlMOd8qN0+xD2f/oC/P7p/m/fHdW9Pc0/vN7spOLcUd8rM8Y+CcqpnM8c9rv9zjeZc+3CKXjgzpC8iEvHMzXk8pFzinaCb89Nnju+BjbXzDNWab8/60LrykXO6ybHBPp/s+JjbdT0X5QLxmruH7OoxTJ84CJtyk2fzMHVvgXJpLa64xVfz7LvcoNzp8585F+MK9Elo3YpDh7v5K07z+RX/OYjzijfO5/QnnoTP9Cu3apn5kmwC36u87gEHv9P5LpbYMHOAxkRd+bHb+2DK5Ikbmp/P9Pc+07Ntb5H4u/uNAx65zXVonrCPK90JO0fv237mgK+YJ5RjfM9BOeCHangrlMuJk058dYWZxwTb+pnOXOs658F89mKQ9hPsvLwT7575JME4/eQ+yeTMVn3W03iCvnx3/Hh6n5h+BLLPB9KT+kA/Y07ENWPO/gGf1ovOmB/OCf7lsnVw0pnTJwJ01tT8iSOUD1RDqE4CeKptQsyrc8a+Onc/NtgQccjkw0PKpzzms/EJs47yiD/f9PeglhkfyvcRdrxHKCdPvo982GSfz8bsgVrKO79Zx9wbG3Tl8yivL8Upty8Fzuo/8YrHpn5l57czf/zxP8fevuMdfwa86je5TnCAfCPAd4sdlH3BOTB9YcHWpXM6bB3wLRO4E+jw7su85yPg7wPToS5HtUB503v2mwIbeB5dJHGQ5+Z3D3Fe9fO16FIE9Z+Qvr5PdGHSzTrlm5SvcYhz+/SctjDft+4dN+jlqTdzH9ZvT+uWrjn+9pm9kO3EXLf8wtdff/3xp0d7HpwxnKc95Dcp20P7p7hyEWv7lQfs/XeVd3YzP7E752pP2PCZ8zOPqxj9qng/neTnm6ZXP1UL7E7AWez4yKz3JdADUrzTOhfvEeI44cqfT3fjXtOgZtJv8PDxzmf2tHWb9VxxPgc4ytsYrzjG7d1TXeqB8nsEnLiubNUKV/Hkw4buUb2tN3tPqFcgBzzlbjxjnuJvFOMqH7pipvdO8jUW37O6jeXdnZBP4571Iqmvxj0bnxAXHuMZX27tgRCfPSEWv6v7kj890Ff/tsVPxIpr2thjnZvulnvAxb7c2Md3ig3s6ar/LaEunHLZqO9TVy4zbzZszVW/OXfu6T+hq/aA03z7Cfiqt3WJb97X5uKbvvXXHH1oPOfqKfskFKe6pg6KH7KH6WvMrjMVNn92xFgd5qGzGOrLzGn+naZ44mDf/ZbvBDs47YO5PuVgjsgTX/2Xj1xnTRvZiHXSi0HPbvJk6+uZ0981Aj7883trPMoN2NSbUz+BP5t6pX9xTC614iNAp99XsU+YOfPNZ/tlY55dvZw+G/YUpGd7Ap55fnGLN88tG/PVNsGXvvlinXL6UlT31dq9BjjVgHPue3GgfqipHurVDz/8+zep8R3v+H3w1Vf/A0wH+YlSGG09AAAAAElFTkSuQmCC";
const OutdoorsMapbox = "data:image/png;base64,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";
const SatelliteMapbox = "data:image/png;base64,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";
const StreetsMapbox = "data:image/png;base64,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";
const StandardMapbox = "data:image/png;base64,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";
const Images$1 = {
  MapPin,
  DarkMapbox,
  LightMapbox,
  OutdoorsMapbox,
  SatelliteMapbox,
  StreetsMapbox,
  StandardMapbox
};
const helvetiker = "data:application/json;base64,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";
const Fonts = {
  helvetiker
};
class DxfUtil {
  static async convertToGeoJson(dataUrl, center2) {
    const enableLayers = true;
    const dxf = await DxfUtil.loadDxfUrl(dataUrl, {
      enableLayers
    });
    if (!dxf)
      return null;
    dxf.traverse((child) => {
      if (child instanceof Mesh) {
        child.geometry.computeBoundingBox();
        child.geometry.computeBoundingSphere();
        child.material.depthWrite = true;
      }
    });
    let toGeoPoint;
    let world;
    if (center2) {
      const scale5 = [1, 1, 1];
      const orientation2 = {
        dip: 0,
        head: 0,
        azimuth: 0
      };
      const flipY2Z = false;
      const recenterOnMass = true;
      const debugBoxHelper = false;
      const parent = {};
      const result = GeoreferenceUtil.doGeoreferencing(dxf, center2, scale5, orientation2, flipY2Z, recenterOnMass, debugBoxHelper, parent);
      world = result == null ? void 0 : result.world;
      if (!world)
        return null;
      toGeoPoint = (...args) => GeoreferenceUtil.toGeoPoint(...args);
    } else {
      world = dxf;
      toGeoPoint = (coords) => coords;
    }
    const geojson = DxfUtil.createGeoJson(world, toGeoPoint, enableLayers, true);
    if (!geojson)
      return null;
    DxfUtil.destroy3(world);
    world = null;
    const features = geojson.type === "Feature" ? [geojson] : geojson.features || [];
    const uniqueLayerNames = uniqueArray(features.map((f2) => f2.properties.layer));
    const layers = uniqueLayerNames.map((layerName) => {
      let fill;
      let stroke;
      features.some((f2) => {
        if (f2.properties.layer === layerName) {
          stroke = f2.properties.stroke;
          fill = f2.properties.fill;
          return true;
        }
        return false;
      });
      return {
        name: layerName,
        fill,
        stroke
      };
    });
    return {
      geojson,
      layers
    };
  }
  static async loadFont(fontUrl) {
    return new Promise((resolve2, reject) => {
      const loader2 = new FontLoader();
      loader2.load(fontUrl, (font) => {
        if (font)
          font.url = fontUrl;
        resolve2(font);
      }, null, (error2) => {
        reject(error2);
      });
    });
  }
  static async loadDxfUrl(url2, options2) {
    const {
      enableLayers,
      headers,
      font: fontPath
    } = options2 || {};
    const fontUrl = fontPath || Fonts.helvetiker;
    const font = await DxfUtil.loadFont(fontUrl);
    const loader2 = new o$1();
    loader2.setEnableLayer(enableLayers);
    loader2.setDefaultColor(16777215);
    loader2.setConsumeUnits(true);
    if (font)
      loader2.setFont(font);
    if (headers) {
      loader2.setCrossOrigin("*");
      loader2.setRequestHeader(headers);
    }
    try {
      const result = await new Promise((resolve2, reject) => {
        loader2.load(url2, (result2) => {
          const scene = result2 == null ? void 0 : result2.entity;
          if (scene)
            scene.name = "dxf";
          resolve2(scene);
        }, null, (error2) => {
          reject(new Error(`DXF loading failed: ${error2}`));
        });
      });
      return result;
    } catch (error2) {
      console.error(error2);
    }
    return null;
  }
  static createGeoJson(world, toGeoPoint, enableLayers) {
    if (!world)
      return null;
    world.updateMatrix();
    world.updateWorldMatrix(true, true);
    if (!enableLayers) {
      return Object3dToGeoJson.convert(world, toGeoPoint);
    }
    const geojson = {
      type: "FeatureCollection",
      features: []
    };
    const dxf = (world == null ? void 0 : world.name) === "dxf" ? world : world == null ? void 0 : world.getObjectByName("dxf");
    const layers = (dxf == null ? void 0 : dxf.children) || [];
    layers.forEach((layer, index2) => {
      var _a3;
      const featureCollection2 = Object3dToGeoJson.convert(layer, toGeoPoint);
      if ((_a3 = featureCollection2 == null ? void 0 : featureCollection2.features) == null ? void 0 : _a3.length) {
        const features = featureCollection2.features.map((feature2) => ({
          ...feature2,
          properties: {
            ...feature2.properties,
            layer: layer.name || `layer-${index2}`
          }
        }));
        pushArray(geojson.features, features);
        if (!geojson.crs)
          geojson.crs = featureCollection2.crs;
      }
    });
    return geojson;
  }
  static destroy3(object2) {
    var _a3;
    if (!object2)
      return;
    try {
      if (Array.isArray(object2)) {
        object2.forEach((child) => DxfUtil.destroy3(child));
      } else if (object2.isBufferGeometry || object2.isMaterial) {
        object2.dispose();
      } else if (object2.isObject3D) {
        DxfUtil.destroy3(object2.children);
        DxfUtil.destroy3(object2.geometry);
        DxfUtil.destroy3(object2.material);
      } else {
        (_a3 = object2.dispose) == null ? void 0 : _a3.call(object2);
      }
    } catch (err) {
      console.error(err);
    }
  }
}
function array_cancel() {
  this._array = null;
  return Promise.resolve();
}
function array_read() {
  var array2 = this._array;
  this._array = null;
  return Promise.resolve(array2 ? { done: false, value: array2 } : { done: true, value: void 0 });
}
function array(array2) {
  return new ArraySource(array2 instanceof Uint8Array ? array2 : new Uint8Array(array2));
}
function ArraySource(array2) {
  this._array = array2;
}
ArraySource.prototype.read = array_read;
ArraySource.prototype.cancel = array_cancel;
function fetchPath(url2) {
  return fetch(url2).then(function(response) {
    return response.body && response.body.getReader ? response.body.getReader() : response.arrayBuffer().then(array);
  });
}
function requestPath(url2) {
  return new Promise(function(resolve2, reject) {
    var request = new XMLHttpRequest();
    request.responseType = "arraybuffer";
    request.onload = function() {
      resolve2(array(request.response));
    };
    request.onerror = reject;
    request.ontimeout = reject;
    request.open("GET", url2, true);
    request.send();
  });
}
function path(path2) {
  return (typeof fetch === "function" ? fetchPath : requestPath)(path2);
}
function stream(source) {
  return typeof source.read === "function" ? source : source.getReader();
}
const empty = new Uint8Array(0);
function slice_cancel() {
  return this._source.cancel();
}
function concat$1(a2, b2) {
  if (!a2.length)
    return b2;
  if (!b2.length)
    return a2;
  var c2 = new Uint8Array(a2.length + b2.length);
  c2.set(a2);
  c2.set(b2, a2.length);
  return c2;
}
function slice_read() {
  var that = this, array2 = that._array.subarray(that._index);
  return that._source.read().then(function(result) {
    that._array = empty;
    that._index = 0;
    return result.done ? array2.length > 0 ? { done: false, value: array2 } : { done: true, value: void 0 } : { done: false, value: concat$1(array2, result.value) };
  });
}
function slice_slice(length2) {
  if ((length2 |= 0) < 0)
    throw new Error("invalid length");
  var that = this, index2 = this._array.length - this._index;
  if (this._index + length2 <= this._array.length) {
    return Promise.resolve(this._array.subarray(this._index, this._index += length2));
  }
  var array2 = new Uint8Array(length2);
  array2.set(this._array.subarray(this._index));
  return function read4() {
    return that._source.read().then(function(result) {
      if (result.done) {
        that._array = empty;
        that._index = 0;
        return index2 > 0 ? array2.subarray(0, index2) : null;
      }
      if (index2 + result.value.length >= length2) {
        that._array = result.value;
        that._index = length2 - index2;
        array2.set(result.value.subarray(0, length2 - index2), index2);
        return array2;
      }
      array2.set(result.value, index2);
      index2 += result.value.length;
      return read4();
    });
  }();
}
function slice$1(source) {
  return typeof source.slice === "function" ? source : new SliceSource(typeof source.read === "function" ? source : source.getReader());
}
function SliceSource(source) {
  this._source = source;
  this._array = empty;
  this._index = 0;
}
SliceSource.prototype.read = slice_read;
SliceSource.prototype.slice = slice_slice;
SliceSource.prototype.cancel = slice_cancel;
function dbf_cancel() {
  return this._source.cancel();
}
function readBoolean(value) {
  return /^[nf]$/i.test(value) ? false : /^[yt]$/i.test(value) ? true : null;
}
function readDate(value) {
  return new Date(+value.substring(0, 4), value.substring(4, 6) - 1, +value.substring(6, 8));
}
function readNumber(value) {
  return !(value = value.trim()) || isNaN(value = +value) ? null : value;
}
function readString(value) {
  return value.trim() || null;
}
var types$2 = {
  B: readNumber,
  C: readString,
  D: readDate,
  F: readNumber,
  L: readBoolean,
  M: readNumber,
  N: readNumber
};
function dbf_read() {
  var that = this, i2 = 1;
  return that._source.slice(that._recordLength).then(function(value) {
    return value && value[0] !== 26 ? { done: false, value: that._fields.reduce(function(p2, f2) {
      p2[f2.name] = types$2[f2.type](that._decode(value.subarray(i2, i2 += f2.length)));
      return p2;
    }, {}) } : { done: true, value: void 0 };
  });
}
function view(array2) {
  return new DataView(array2.buffer, array2.byteOffset, array2.byteLength);
}
function dbf(source, decoder) {
  source = slice$1(source);
  return source.slice(32).then(function(array2) {
    var head = view(array2);
    return source.slice(head.getUint16(8, true) - 32).then(function(array3) {
      return new Dbf(source, decoder, head, view(array3));
    });
  });
}
function Dbf(source, decoder, head, body) {
  this._source = source;
  this._decode = decoder.decode.bind(decoder);
  this._recordLength = head.getUint16(10, true);
  this._fields = [];
  for (var n2 = 0; body.getUint8(n2) !== 13; n2 += 32) {
    for (var j2 = 0; j2 < 11; ++j2)
      if (body.getUint8(n2 + j2) === 0)
        break;
    this._fields.push({
      name: this._decode(new Uint8Array(body.buffer, body.byteOffset + n2, j2)),
      type: String.fromCharCode(body.getUint8(n2 + 11)),
      length: body.getUint8(n2 + 16)
    });
  }
}
var prototype$2 = Dbf.prototype;
prototype$2.read = dbf_read;
prototype$2.cancel = dbf_cancel;
function cancel() {
  return this._source.cancel();
}
function parseMultiPoint(record) {
  var i2 = 40, j2, n2 = record.getInt32(36, true), coordinates2 = new Array(n2);
  for (j2 = 0; j2 < n2; ++j2, i2 += 16)
    coordinates2[j2] = [record.getFloat64(i2, true), record.getFloat64(i2 + 8, true)];
  return { type: "MultiPoint", coordinates: coordinates2 };
}
function parseNull() {
  return null;
}
function parsePoint(record) {
  return { type: "Point", coordinates: [record.getFloat64(4, true), record.getFloat64(12, true)] };
}
function parsePolygon(record) {
  var i2 = 44, j2, n2 = record.getInt32(36, true), m2 = record.getInt32(40, true), parts = new Array(n2), points2 = new Array(m2), polygons2 = [], holes = [];
  for (j2 = 0; j2 < n2; ++j2, i2 += 4)
    parts[j2] = record.getInt32(i2, true);
  for (j2 = 0; j2 < m2; ++j2, i2 += 16)
    points2[j2] = [record.getFloat64(i2, true), record.getFloat64(i2 + 8, true)];
  parts.forEach(function(i3, j3) {
    var ring = points2.slice(i3, parts[j3 + 1]);
    if (ringClockwise(ring))
      polygons2.push([ring]);
    else
      holes.push(ring);
  });
  holes.forEach(function(hole) {
    polygons2.some(function(polygon4) {
      if (ringContainsSome(polygon4[0], hole)) {
        polygon4.push(hole);
        return true;
      }
    }) || polygons2.push([hole]);
  });
  return polygons2.length === 1 ? { type: "Polygon", coordinates: polygons2[0] } : { type: "MultiPolygon", coordinates: polygons2 };
}
function ringClockwise(ring) {
  if ((n2 = ring.length) < 4)
    return false;
  var i2 = 0, n2, area5 = ring[n2 - 1][1] * ring[0][0] - ring[n2 - 1][0] * ring[0][1];
  while (++i2 < n2)
    area5 += ring[i2 - 1][1] * ring[i2][0] - ring[i2 - 1][0] * ring[i2][1];
  return area5 >= 0;
}
function ringContainsSome(ring, hole) {
  var i2 = -1, n2 = hole.length, c2;
  while (++i2 < n2) {
    if (c2 = ringContains(ring, hole[i2])) {
      return c2 > 0;
    }
  }
  return false;
}
function ringContains(ring, point4) {
  var x2 = point4[0], y2 = point4[1], contains3 = -1;
  for (var i2 = 0, n2 = ring.length, j2 = n2 - 1; i2 < n2; j2 = i2++) {
    var pi2 = ring[i2], xi = pi2[0], yi = pi2[1], pj = ring[j2], xj = pj[0], yj = pj[1];
    if (segmentContains(pi2, pj, point4)) {
      return 0;
    }
    if (yi > y2 !== yj > y2 && x2 < (xj - xi) * (y2 - yi) / (yj - yi) + xi) {
      contains3 = -contains3;
    }
  }
  return contains3;
}
function segmentContains(p0, p1, p2) {
  var x20 = p2[0] - p0[0], y20 = p2[1] - p0[1];
  if (x20 === 0 && y20 === 0)
    return true;
  var x10 = p1[0] - p0[0], y10 = p1[1] - p0[1];
  if (x10 === 0 && y10 === 0)
    return false;
  var t2 = (x20 * x10 + y20 * y10) / (x10 * x10 + y10 * y10);
  return t2 < 0 || t2 > 1 ? false : t2 === 0 || t2 === 1 ? true : t2 * x10 === x20 && t2 * y10 === y20;
}
function parsePolyLine(record) {
  var i2 = 44, j2, n2 = record.getInt32(36, true), m2 = record.getInt32(40, true), parts = new Array(n2), points2 = new Array(m2);
  for (j2 = 0; j2 < n2; ++j2, i2 += 4)
    parts[j2] = record.getInt32(i2, true);
  for (j2 = 0; j2 < m2; ++j2, i2 += 16)
    points2[j2] = [record.getFloat64(i2, true), record.getFloat64(i2 + 8, true)];
  return n2 === 1 ? { type: "LineString", coordinates: points2 } : { type: "MultiLineString", coordinates: parts.map(function(i3, j3) {
    return points2.slice(i3, parts[j3 + 1]);
  }) };
}
function concat(a2, b2) {
  var ab2 = new Uint8Array(a2.length + b2.length);
  ab2.set(a2, 0);
  ab2.set(b2, a2.length);
  return ab2;
}
function shp_read() {
  var that = this;
  ++that._index;
  return that._source.slice(12).then(function(array2) {
    if (array2 == null)
      return { done: true, value: void 0 };
    var header = view(array2);
    function skip() {
      return that._source.slice(4).then(function(chunk) {
        if (chunk == null)
          return { done: true, value: void 0 };
        header = view(array2 = concat(array2.slice(4), chunk));
        return header.getInt32(0, false) !== that._index ? skip() : read4();
      });
    }
    function read4() {
      var length2 = header.getInt32(4, false) * 2 - 4, type = header.getInt32(8, true);
      return length2 < 0 || type && type !== that._type ? skip() : that._source.slice(length2).then(function(chunk) {
        return { done: false, value: type ? that._parse(view(concat(array2.slice(8), chunk))) : null };
      });
    }
    return read4();
  });
}
var parsers = {
  0: parseNull,
  1: parsePoint,
  3: parsePolyLine,
  5: parsePolygon,
  8: parseMultiPoint,
  11: parsePoint,
  // PointZ
  13: parsePolyLine,
  // PolyLineZ
  15: parsePolygon,
  // PolygonZ
  18: parseMultiPoint,
  // MultiPointZ
  21: parsePoint,
  // PointM
  23: parsePolyLine,
  // PolyLineM
  25: parsePolygon,
  // PolygonM
  28: parseMultiPoint
  // MultiPointM
};
function shp(source) {
  source = slice$1(source);
  return source.slice(100).then(function(array2) {
    return new Shp(source, view(array2));
  });
}
function Shp(source, header) {
  var type = header.getInt32(32, true);
  if (!(type in parsers))
    throw new Error("unsupported shape type: " + type);
  this._source = source;
  this._type = type;
  this._index = 0;
  this._parse = parsers[type];
  this.bbox = [header.getFloat64(36, true), header.getFloat64(44, true), header.getFloat64(52, true), header.getFloat64(60, true)];
}
var prototype$1 = Shp.prototype;
prototype$1.read = shp_read;
prototype$1.cancel = cancel;
function noop$6() {
}
function shapefile_cancel() {
  return Promise.all([
    this._dbf && this._dbf.cancel(),
    this._shp.cancel()
  ]).then(noop$6);
}
function shapefile_read() {
  var that = this;
  return Promise.all([
    that._dbf ? that._dbf.read() : { value: {} },
    that._shp.read()
  ]).then(function(results) {
    var dbf2 = results[0], shp2 = results[1];
    return shp2.done ? shp2 : {
      done: false,
      value: {
        type: "Feature",
        properties: dbf2.value,
        geometry: shp2.value
      }
    };
  });
}
function shapefile(shpSource, dbfSource, decoder) {
  return Promise.all([
    shp(shpSource),
    dbfSource && dbf(dbfSource, decoder)
  ]).then(function(sources2) {
    return new Shapefile(sources2[0], sources2[1]);
  });
}
function Shapefile(shp2, dbf2) {
  this._shp = shp2;
  this._dbf = dbf2;
  this.bbox = shp2.bbox;
}
var prototype = Shapefile.prototype;
prototype.read = shapefile_read;
prototype.cancel = shapefile_cancel;
function open(shp2, dbf2, options2) {
  if (typeof dbf2 === "string") {
    if (!/\.dbf$/.test(dbf2))
      dbf2 += ".dbf";
    dbf2 = path(dbf2);
  } else if (dbf2 instanceof ArrayBuffer || dbf2 instanceof Uint8Array) {
    dbf2 = array(dbf2);
  } else if (dbf2 != null) {
    dbf2 = stream(dbf2);
  }
  if (typeof shp2 === "string") {
    if (!/\.shp$/.test(shp2))
      shp2 += ".shp";
    if (dbf2 === void 0)
      dbf2 = path(shp2.substring(0, shp2.length - 4) + ".dbf").catch(function() {
      });
    shp2 = path(shp2);
  } else if (shp2 instanceof ArrayBuffer || shp2 instanceof Uint8Array) {
    shp2 = array(shp2);
  } else {
    shp2 = stream(shp2);
  }
  return Promise.all([shp2, dbf2]).then(function(sources2) {
    var shp3 = sources2[0], dbf3 = sources2[1], encoding = "windows-1252";
    if (options2 && options2.encoding != null)
      encoding = options2.encoding;
    return shapefile(shp3, dbf3, dbf3 && new TextDecoder(encoding));
  });
}
function globals(defs2) {
  defs2("EPSG:4326", "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
  defs2("EPSG:4269", "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
  defs2("EPSG:3857", "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");
  defs2.WGS84 = defs2["EPSG:4326"];
  defs2["EPSG:3785"] = defs2["EPSG:3857"];
  defs2.GOOGLE = defs2["EPSG:3857"];
  defs2["EPSG:900913"] = defs2["EPSG:3857"];
  defs2["EPSG:102113"] = defs2["EPSG:3857"];
}
var PJD_3PARAM = 1;
var PJD_7PARAM = 2;
var PJD_GRIDSHIFT = 3;
var PJD_WGS84 = 4;
var PJD_NODATUM = 5;
var SRS_WGS84_SEMIMAJOR = 6378137;
var SRS_WGS84_SEMIMINOR = 6356752314e-3;
var SRS_WGS84_ESQUARED = 0.0066943799901413165;
var SEC_TO_RAD = 484813681109536e-20;
var HALF_PI = Math.PI / 2;
var SIXTH = 0.16666666666666666;
var RA4 = 0.04722222222222222;
var RA6 = 0.022156084656084655;
var EPSLN = 1e-10;
var D2R$1 = 0.017453292519943295;
var R2D = 57.29577951308232;
var FORTPI = Math.PI / 4;
var TWO_PI = Math.PI * 2;
var SPI = 3.14159265359;
var exports$3 = {};
exports$3.greenwich = 0;
exports$3.lisbon = -9.131906111111;
exports$3.paris = 2.337229166667;
exports$3.bogota = -74.080916666667;
exports$3.madrid = -3.687938888889;
exports$3.rome = 12.452333333333;
exports$3.bern = 7.439583333333;
exports$3.jakarta = 106.807719444444;
exports$3.ferro = -17.666666666667;
exports$3.brussels = 4.367975;
exports$3.stockholm = 18.058277777778;
exports$3.athens = 23.7163375;
exports$3.oslo = 10.722916666667;
const units = {
  ft: { to_meter: 0.3048 },
  "us-ft": { to_meter: 1200 / 3937 }
};
var ignoredChar = /[\s_\-\/\(\)]/g;
function match(obj, key) {
  if (obj[key]) {
    return obj[key];
  }
  var keys4 = Object.keys(obj);
  var lkey = key.toLowerCase().replace(ignoredChar, "");
  var i2 = -1;
  var testkey, processedKey;
  while (++i2 < keys4.length) {
    testkey = keys4[i2];
    processedKey = testkey.toLowerCase().replace(ignoredChar, "");
    if (processedKey === lkey) {
      return obj[testkey];
    }
  }
}
function projStr(defData) {
  var self2 = {};
  var paramObj = defData.split("+").map(function(v5) {
    return v5.trim();
  }).filter(function(a2) {
    return a2;
  }).reduce(function(p2, a2) {
    var split2 = a2.split("=");
    split2.push(true);
    p2[split2[0].toLowerCase()] = split2[1];
    return p2;
  }, {});
  var paramName, paramVal, paramOutname;
  var params2 = {
    proj: "projName",
    datum: "datumCode",
    rf: function(v5) {
      self2.rf = parseFloat(v5);
    },
    lat_0: function(v5) {
      self2.lat0 = v5 * D2R$1;
    },
    lat_1: function(v5) {
      self2.lat1 = v5 * D2R$1;
    },
    lat_2: function(v5) {
      self2.lat2 = v5 * D2R$1;
    },
    lat_ts: function(v5) {
      self2.lat_ts = v5 * D2R$1;
    },
    lon_0: function(v5) {
      self2.long0 = v5 * D2R$1;
    },
    lon_1: function(v5) {
      self2.long1 = v5 * D2R$1;
    },
    lon_2: function(v5) {
      self2.long2 = v5 * D2R$1;
    },
    alpha: function(v5) {
      self2.alpha = parseFloat(v5) * D2R$1;
    },
    gamma: function(v5) {
      self2.rectified_grid_angle = parseFloat(v5);
    },
    lonc: function(v5) {
      self2.longc = v5 * D2R$1;
    },
    x_0: function(v5) {
      self2.x0 = parseFloat(v5);
    },
    y_0: function(v5) {
      self2.y0 = parseFloat(v5);
    },
    k_0: function(v5) {
      self2.k0 = parseFloat(v5);
    },
    k: function(v5) {
      self2.k0 = parseFloat(v5);
    },
    a: function(v5) {
      self2.a = parseFloat(v5);
    },
    b: function(v5) {
      self2.b = parseFloat(v5);
    },
    r_a: function() {
      self2.R_A = true;
    },
    zone: function(v5) {
      self2.zone = parseInt(v5, 10);
    },
    south: function() {
      self2.utmSouth = true;
    },
    towgs84: function(v5) {
      self2.datum_params = v5.split(",").map(function(a2) {
        return parseFloat(a2);
      });
    },
    to_meter: function(v5) {
      self2.to_meter = parseFloat(v5);
    },
    units: function(v5) {
      self2.units = v5;
      var unit = match(units, v5);
      if (unit) {
        self2.to_meter = unit.to_meter;
      }
    },
    from_greenwich: function(v5) {
      self2.from_greenwich = v5 * D2R$1;
    },
    pm: function(v5) {
      var pm = match(exports$3, v5);
      self2.from_greenwich = (pm ? pm : parseFloat(v5)) * D2R$1;
    },
    nadgrids: function(v5) {
      if (v5 === "@null") {
        self2.datumCode = "none";
      } else {
        self2.nadgrids = v5;
      }
    },
    axis: function(v5) {
      var legalAxis = "ewnsud";
      if (v5.length === 3 && legalAxis.indexOf(v5.substr(0, 1)) !== -1 && legalAxis.indexOf(v5.substr(1, 1)) !== -1 && legalAxis.indexOf(v5.substr(2, 1)) !== -1) {
        self2.axis = v5;
      }
    },
    approx: function() {
      self2.approx = true;
    }
  };
  for (paramName in paramObj) {
    paramVal = paramObj[paramName];
    if (paramName in params2) {
      paramOutname = params2[paramName];
      if (typeof paramOutname === "function") {
        paramOutname(paramVal);
      } else {
        self2[paramOutname] = paramVal;
      }
    } else {
      self2[paramName] = paramVal;
    }
  }
  if (typeof self2.datumCode === "string" && self2.datumCode !== "WGS84") {
    self2.datumCode = self2.datumCode.toLowerCase();
  }
  return self2;
}
var NEUTRAL = 1;
var KEYWORD = 2;
var NUMBER$1 = 3;
var QUOTED = 4;
var AFTERQUOTE = 5;
var ENDED = -1;
var whitespace = /\s/;
var latin = /[A-Za-z]/;
var keyword = /[A-Za-z84_]/;
var endThings = /[,\]]/;
var digets = /[\d\.E\-\+]/;
function Parser(text) {
  if (typeof text !== "string") {
    throw new Error("not a string");
  }
  this.text = text.trim();
  this.level = 0;
  this.place = 0;
  this.root = null;
  this.stack = [];
  this.currentObject = null;
  this.state = NEUTRAL;
}
Parser.prototype.readCharicter = function() {
  var char = this.text[this.place++];
  if (this.state !== QUOTED) {
    while (whitespace.test(char)) {
      if (this.place >= this.text.length) {
        return;
      }
      char = this.text[this.place++];
    }
  }
  switch (this.state) {
    case NEUTRAL:
      return this.neutral(char);
    case KEYWORD:
      return this.keyword(char);
    case QUOTED:
      return this.quoted(char);
    case AFTERQUOTE:
      return this.afterquote(char);
    case NUMBER$1:
      return this.number(char);
    case ENDED:
      return;
  }
};
Parser.prototype.afterquote = function(char) {
  if (char === '"') {
    this.word += '"';
    this.state = QUOTED;
    return;
  }
  if (endThings.test(char)) {
    this.word = this.word.trim();
    this.afterItem(char);
    return;
  }
  throw new Error(`havn't handled "` + char + '" in afterquote yet, index ' + this.place);
};
Parser.prototype.afterItem = function(char) {
  if (char === ",") {
    if (this.word !== null) {
      this.currentObject.push(this.word);
    }
    this.word = null;
    this.state = NEUTRAL;
    return;
  }
  if (char === "]") {
    this.level--;
    if (this.word !== null) {
      this.currentObject.push(this.word);
      this.word = null;
    }
    this.state = NEUTRAL;
    this.currentObject = this.stack.pop();
    if (!this.currentObject) {
      this.state = ENDED;
    }
    return;
  }
};
Parser.prototype.number = function(char) {
  if (digets.test(char)) {
    this.word += char;
    return;
  }
  if (endThings.test(char)) {
    this.word = parseFloat(this.word);
    this.afterItem(char);
    return;
  }
  throw new Error(`havn't handled "` + char + '" in number yet, index ' + this.place);
};
Parser.prototype.quoted = function(char) {
  if (char === '"') {
    this.state = AFTERQUOTE;
    return;
  }
  this.word += char;
  return;
};
Parser.prototype.keyword = function(char) {
  if (keyword.test(char)) {
    this.word += char;
    return;
  }
  if (char === "[") {
    var newObjects = [];
    newObjects.push(this.word);
    this.level++;
    if (this.root === null) {
      this.root = newObjects;
    } else {
      this.currentObject.push(newObjects);
    }
    this.stack.push(this.currentObject);
    this.currentObject = newObjects;
    this.state = NEUTRAL;
    return;
  }
  if (endThings.test(char)) {
    this.afterItem(char);
    return;
  }
  throw new Error(`havn't handled "` + char + '" in keyword yet, index ' + this.place);
};
Parser.prototype.neutral = function(char) {
  if (latin.test(char)) {
    this.word = char;
    this.state = KEYWORD;
    return;
  }
  if (char === '"') {
    this.word = "";
    this.state = QUOTED;
    return;
  }
  if (digets.test(char)) {
    this.word = char;
    this.state = NUMBER$1;
    return;
  }
  if (endThings.test(char)) {
    this.afterItem(char);
    return;
  }
  throw new Error(`havn't handled "` + char + '" in neutral yet, index ' + this.place);
};
Parser.prototype.output = function() {
  while (this.place < this.text.length) {
    this.readCharicter();
  }
  if (this.state === ENDED) {
    return this.root;
  }
  throw new Error('unable to parse string "' + this.text + '". State is ' + this.state);
};
function parseString(txt) {
  var parser = new Parser(txt);
  return parser.output();
}
function mapit(obj, key, value) {
  if (Array.isArray(key)) {
    value.unshift(key);
    key = null;
  }
  var thing = key ? {} : obj;
  var out = value.reduce(function(newObj, item) {
    sExpr(item, newObj);
    return newObj;
  }, thing);
  if (key) {
    obj[key] = out;
  }
}
function sExpr(v5, obj) {
  if (!Array.isArray(v5)) {
    obj[v5] = true;
    return;
  }
  var key = v5.shift();
  if (key === "PARAMETER") {
    key = v5.shift();
  }
  if (v5.length === 1) {
    if (Array.isArray(v5[0])) {
      obj[key] = {};
      sExpr(v5[0], obj[key]);
      return;
    }
    obj[key] = v5[0];
    return;
  }
  if (!v5.length) {
    obj[key] = true;
    return;
  }
  if (key === "TOWGS84") {
    obj[key] = v5;
    return;
  }
  if (key === "AXIS") {
    if (!(key in obj)) {
      obj[key] = [];
    }
    obj[key].push(v5);
    return;
  }
  if (!Array.isArray(key)) {
    obj[key] = {};
  }
  var i2;
  switch (key) {
    case "UNIT":
    case "PRIMEM":
    case "VERT_DATUM":
      obj[key] = {
        name: v5[0].toLowerCase(),
        convert: v5[1]
      };
      if (v5.length === 3) {
        sExpr(v5[2], obj[key]);
      }
      return;
    case "SPHEROID":
    case "ELLIPSOID":
      obj[key] = {
        name: v5[0],
        a: v5[1],
        rf: v5[2]
      };
      if (v5.length === 4) {
        sExpr(v5[3], obj[key]);
      }
      return;
    case "PROJECTEDCRS":
    case "PROJCRS":
    case "GEOGCS":
    case "GEOCCS":
    case "PROJCS":
    case "LOCAL_CS":
    case "GEODCRS":
    case "GEODETICCRS":
    case "GEODETICDATUM":
    case "EDATUM":
    case "ENGINEERINGDATUM":
    case "VERT_CS":
    case "VERTCRS":
    case "VERTICALCRS":
    case "COMPD_CS":
    case "COMPOUNDCRS":
    case "ENGINEERINGCRS":
    case "ENGCRS":
    case "FITTED_CS":
    case "LOCAL_DATUM":
    case "DATUM":
      v5[0] = ["name", v5[0]];
      mapit(obj, key, v5);
      return;
    default:
      i2 = -1;
      while (++i2 < v5.length) {
        if (!Array.isArray(v5[i2])) {
          return sExpr(v5, obj[key]);
        }
      }
      return mapit(obj, key, v5);
  }
}
var D2R = 0.017453292519943295;
function rename(obj, params2) {
  var outName = params2[0];
  var inName = params2[1];
  if (!(outName in obj) && inName in obj) {
    obj[outName] = obj[inName];
    if (params2.length === 3) {
      obj[outName] = params2[2](obj[outName]);
    }
  }
}
function d2r(input) {
  return input * D2R;
}
function cleanWKT(wkt2) {
  if (wkt2.type === "GEOGCS") {
    wkt2.projName = "longlat";
  } else if (wkt2.type === "LOCAL_CS") {
    wkt2.projName = "identity";
    wkt2.local = true;
  } else {
    if (typeof wkt2.PROJECTION === "object") {
      wkt2.projName = Object.keys(wkt2.PROJECTION)[0];
    } else {
      wkt2.projName = wkt2.PROJECTION;
    }
  }
  if (wkt2.AXIS) {
    var axisOrder = "";
    for (var i2 = 0, ii2 = wkt2.AXIS.length; i2 < ii2; ++i2) {
      var axis = [wkt2.AXIS[i2][0].toLowerCase(), wkt2.AXIS[i2][1].toLowerCase()];
      if (axis[0].indexOf("north") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "north") {
        axisOrder += "n";
      } else if (axis[0].indexOf("south") !== -1 || (axis[0] === "y" || axis[0] === "lat") && axis[1] === "south") {
        axisOrder += "s";
      } else if (axis[0].indexOf("east") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "east") {
        axisOrder += "e";
      } else if (axis[0].indexOf("west") !== -1 || (axis[0] === "x" || axis[0] === "lon") && axis[1] === "west") {
        axisOrder += "w";
      }
    }
    if (axisOrder.length === 2) {
      axisOrder += "u";
    }
    if (axisOrder.length === 3) {
      wkt2.axis = axisOrder;
    }
  }
  if (wkt2.UNIT) {
    wkt2.units = wkt2.UNIT.name.toLowerCase();
    if (wkt2.units === "metre") {
      wkt2.units = "meter";
    }
    if (wkt2.UNIT.convert) {
      if (wkt2.type === "GEOGCS") {
        if (wkt2.DATUM && wkt2.DATUM.SPHEROID) {
          wkt2.to_meter = wkt2.UNIT.convert * wkt2.DATUM.SPHEROID.a;
        }
      } else {
        wkt2.to_meter = wkt2.UNIT.convert;
      }
    }
  }
  var geogcs = wkt2.GEOGCS;
  if (wkt2.type === "GEOGCS") {
    geogcs = wkt2;
  }
  if (geogcs) {
    if (geogcs.DATUM) {
      wkt2.datumCode = geogcs.DATUM.name.toLowerCase();
    } else {
      wkt2.datumCode = geogcs.name.toLowerCase();
    }
    if (wkt2.datumCode.slice(0, 2) === "d_") {
      wkt2.datumCode = wkt2.datumCode.slice(2);
    }
    if (wkt2.datumCode === "new_zealand_geodetic_datum_1949" || wkt2.datumCode === "new_zealand_1949") {
      wkt2.datumCode = "nzgd49";
    }
    if (wkt2.datumCode === "wgs_1984" || wkt2.datumCode === "world_geodetic_system_1984") {
      if (wkt2.PROJECTION === "Mercator_Auxiliary_Sphere") {
        wkt2.sphere = true;
      }
      wkt2.datumCode = "wgs84";
    }
    if (wkt2.datumCode.slice(-6) === "_ferro") {
      wkt2.datumCode = wkt2.datumCode.slice(0, -6);
    }
    if (wkt2.datumCode.slice(-8) === "_jakarta") {
      wkt2.datumCode = wkt2.datumCode.slice(0, -8);
    }
    if (~wkt2.datumCode.indexOf("belge")) {
      wkt2.datumCode = "rnb72";
    }
    if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
      wkt2.ellps = geogcs.DATUM.SPHEROID.name.replace("_19", "").replace(/[Cc]larke\_18/, "clrk");
      if (wkt2.ellps.toLowerCase().slice(0, 13) === "international") {
        wkt2.ellps = "intl";
      }
      wkt2.a = geogcs.DATUM.SPHEROID.a;
      wkt2.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
    }
    if (geogcs.DATUM && geogcs.DATUM.TOWGS84) {
      wkt2.datum_params = geogcs.DATUM.TOWGS84;
    }
    if (~wkt2.datumCode.indexOf("osgb_1936")) {
      wkt2.datumCode = "osgb36";
    }
    if (~wkt2.datumCode.indexOf("osni_1952")) {
      wkt2.datumCode = "osni52";
    }
    if (~wkt2.datumCode.indexOf("tm65") || ~wkt2.datumCode.indexOf("geodetic_datum_of_1965")) {
      wkt2.datumCode = "ire65";
    }
    if (wkt2.datumCode === "ch1903+") {
      wkt2.datumCode = "ch1903";
    }
    if (~wkt2.datumCode.indexOf("israel")) {
      wkt2.datumCode = "isr93";
    }
  }
  if (wkt2.b && !isFinite(wkt2.b)) {
    wkt2.b = wkt2.a;
  }
  function toMeter(input) {
    var ratio = wkt2.to_meter || 1;
    return input * ratio;
  }
  var renamer = function(a2) {
    return rename(wkt2, a2);
  };
  var list2 = [
    ["standard_parallel_1", "Standard_Parallel_1"],
    ["standard_parallel_1", "Latitude of 1st standard parallel"],
    ["standard_parallel_2", "Standard_Parallel_2"],
    ["standard_parallel_2", "Latitude of 2nd standard parallel"],
    ["false_easting", "False_Easting"],
    ["false_easting", "False easting"],
    ["false-easting", "Easting at false origin"],
    ["false_northing", "False_Northing"],
    ["false_northing", "False northing"],
    ["false_northing", "Northing at false origin"],
    ["central_meridian", "Central_Meridian"],
    ["central_meridian", "Longitude of natural origin"],
    ["central_meridian", "Longitude of false origin"],
    ["latitude_of_origin", "Latitude_Of_Origin"],
    ["latitude_of_origin", "Central_Parallel"],
    ["latitude_of_origin", "Latitude of natural origin"],
    ["latitude_of_origin", "Latitude of false origin"],
    ["scale_factor", "Scale_Factor"],
    ["k0", "scale_factor"],
    ["latitude_of_center", "Latitude_Of_Center"],
    ["latitude_of_center", "Latitude_of_center"],
    ["lat0", "latitude_of_center", d2r],
    ["longitude_of_center", "Longitude_Of_Center"],
    ["longitude_of_center", "Longitude_of_center"],
    ["longc", "longitude_of_center", d2r],
    ["x0", "false_easting", toMeter],
    ["y0", "false_northing", toMeter],
    ["long0", "central_meridian", d2r],
    ["lat0", "latitude_of_origin", d2r],
    ["lat0", "standard_parallel_1", d2r],
    ["lat1", "standard_parallel_1", d2r],
    ["lat2", "standard_parallel_2", d2r],
    ["azimuth", "Azimuth"],
    ["alpha", "azimuth", d2r],
    ["srsCode", "name"]
  ];
  list2.forEach(renamer);
  if (!wkt2.long0 && wkt2.longc && (wkt2.projName === "Albers_Conic_Equal_Area" || wkt2.projName === "Lambert_Azimuthal_Equal_Area")) {
    wkt2.long0 = wkt2.longc;
  }
  if (!wkt2.lat_ts && wkt2.lat1 && (wkt2.projName === "Stereographic_South_Pole" || wkt2.projName === "Polar Stereographic (variant B)")) {
    wkt2.lat0 = d2r(wkt2.lat1 > 0 ? 90 : -90);
    wkt2.lat_ts = wkt2.lat1;
  } else if (!wkt2.lat_ts && wkt2.lat0 && wkt2.projName === "Polar_Stereographic") {
    wkt2.lat_ts = wkt2.lat0;
    wkt2.lat0 = d2r(wkt2.lat0 > 0 ? 90 : -90);
  }
}
function wkt(wkt2) {
  var lisp = parseString(wkt2);
  var type = lisp.shift();
  var name2 = lisp.shift();
  lisp.unshift(["name", name2]);
  lisp.unshift(["type", type]);
  var obj = {};
  sExpr(lisp, obj);
  cleanWKT(obj);
  return obj;
}
function defs(name2) {
  var that = this;
  if (arguments.length === 2) {
    var def = arguments[1];
    if (typeof def === "string") {
      if (def.charAt(0) === "+") {
        defs[name2] = projStr(arguments[1]);
      } else {
        defs[name2] = wkt(arguments[1]);
      }
    } else {
      defs[name2] = def;
    }
  } else if (arguments.length === 1) {
    if (Array.isArray(name2)) {
      return name2.map(function(v5) {
        if (Array.isArray(v5)) {
          defs.apply(that, v5);
        } else {
          defs(v5);
        }
      });
    } else if (typeof name2 === "string") {
      if (name2 in defs) {
        return defs[name2];
      }
    } else if ("EPSG" in name2) {
      defs["EPSG:" + name2.EPSG] = name2;
    } else if ("ESRI" in name2) {
      defs["ESRI:" + name2.ESRI] = name2;
    } else if ("IAU2000" in name2) {
      defs["IAU2000:" + name2.IAU2000] = name2;
    } else {
      console.log(name2);
    }
    return;
  }
}
globals(defs);
function testObj(code) {
  return typeof code === "string";
}
function testDef(code) {
  return code in defs;
}
var codeWords = ["PROJECTEDCRS", "PROJCRS", "GEOGCS", "GEOCCS", "PROJCS", "LOCAL_CS", "GEODCRS", "GEODETICCRS", "GEODETICDATUM", "ENGCRS", "ENGINEERINGCRS"];
function testWKT(code) {
  return codeWords.some(function(word) {
    return code.indexOf(word) > -1;
  });
}
var codes = ["3857", "900913", "3785", "102113"];
function checkMercator(item) {
  var auth = match(item, "authority");
  if (!auth) {
    return;
  }
  var code = match(auth, "epsg");
  return code && codes.indexOf(code) > -1;
}
function checkProjStr(item) {
  var ext = match(item, "extension");
  if (!ext) {
    return;
  }
  return match(ext, "proj4");
}
function testProj(code) {
  return code[0] === "+";
}
function parse$8(code) {
  if (testObj(code)) {
    if (testDef(code)) {
      return defs[code];
    }
    if (testWKT(code)) {
      var out = wkt(code);
      if (checkMercator(out)) {
        return defs["EPSG:3857"];
      }
      var maybeProjStr = checkProjStr(out);
      if (maybeProjStr) {
        return projStr(maybeProjStr);
      }
      return out;
    }
    if (testProj(code)) {
      return projStr(code);
    }
  } else {
    return code;
  }
}
function extend$5(destination2, source) {
  destination2 = destination2 || {};
  var value, property2;
  if (!source) {
    return destination2;
  }
  for (property2 in source) {
    value = source[property2];
    if (value !== void 0) {
      destination2[property2] = value;
    }
  }
  return destination2;
}
function msfnz(eccent, sinphi, cosphi) {
  var con = eccent * sinphi;
  return cosphi / Math.sqrt(1 - con * con);
}
function sign$1(x2) {
  return x2 < 0 ? -1 : 1;
}
function adjust_lon(x2) {
  return Math.abs(x2) <= SPI ? x2 : x2 - sign$1(x2) * TWO_PI;
}
function tsfnz(eccent, phi, sinphi) {
  var con = eccent * sinphi;
  var com = 0.5 * eccent;
  con = Math.pow((1 - con) / (1 + con), com);
  return Math.tan(0.5 * (HALF_PI - phi)) / con;
}
function phi2z(eccent, ts) {
  var eccnth = 0.5 * eccent;
  var con, dphi;
  var phi = HALF_PI - 2 * Math.atan(ts);
  for (var i2 = 0; i2 <= 15; i2++) {
    con = eccent * Math.sin(phi);
    dphi = HALF_PI - 2 * Math.atan(ts * Math.pow((1 - con) / (1 + con), eccnth)) - phi;
    phi += dphi;
    if (Math.abs(dphi) <= 1e-10) {
      return phi;
    }
  }
  return -9999;
}
function init$v() {
  var con = this.b / this.a;
  this.es = 1 - con * con;
  if (!("x0" in this)) {
    this.x0 = 0;
  }
  if (!("y0" in this)) {
    this.y0 = 0;
  }
  this.e = Math.sqrt(this.es);
  if (this.lat_ts) {
    if (this.sphere) {
      this.k0 = Math.cos(this.lat_ts);
    } else {
      this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    }
  } else {
    if (!this.k0) {
      if (this.k) {
        this.k0 = this.k;
      } else {
        this.k0 = 1;
      }
    }
  }
}
function forward$u(p2) {
  var lon = p2.x;
  var lat = p2.y;
  if (lat * R2D > 90 && lat * R2D < -90 && lon * R2D > 180 && lon * R2D < -180) {
    return null;
  }
  var x2, y2;
  if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
    return null;
  } else {
    if (this.sphere) {
      x2 = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
      y2 = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * lat));
    } else {
      var sinphi = Math.sin(lat);
      var ts = tsfnz(this.e, lat, sinphi);
      x2 = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
      y2 = this.y0 - this.a * this.k0 * Math.log(ts);
    }
    p2.x = x2;
    p2.y = y2;
    return p2;
  }
}
function inverse$u(p2) {
  var x2 = p2.x - this.x0;
  var y2 = p2.y - this.y0;
  var lon, lat;
  if (this.sphere) {
    lat = HALF_PI - 2 * Math.atan(Math.exp(-y2 / (this.a * this.k0)));
  } else {
    var ts = Math.exp(-y2 / (this.a * this.k0));
    lat = phi2z(this.e, ts);
    if (lat === -9999) {
      return null;
    }
  }
  lon = adjust_lon(this.long0 + x2 / (this.a * this.k0));
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$x = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
const merc = {
  init: init$v,
  forward: forward$u,
  inverse: inverse$u,
  names: names$x
};
function init$u() {
}
function identity$8(pt) {
  return pt;
}
var names$w = ["longlat", "identity"];
const longlat = {
  init: init$u,
  forward: identity$8,
  inverse: identity$8,
  names: names$w
};
var projs = [merc, longlat];
var names$v = {};
var projStore = [];
function add$4(proj, i2) {
  var len2 = projStore.length;
  if (!proj.names) {
    console.log(i2);
    return true;
  }
  projStore[len2] = proj;
  proj.names.forEach(function(n2) {
    names$v[n2.toLowerCase()] = len2;
  });
  return this;
}
function get$4(name2) {
  if (!name2) {
    return false;
  }
  var n2 = name2.toLowerCase();
  if (typeof names$v[n2] !== "undefined" && projStore[names$v[n2]]) {
    return projStore[names$v[n2]];
  }
}
function start() {
  projs.forEach(add$4);
}
const projections = {
  start,
  add: add$4,
  get: get$4
};
var exports$2 = {};
exports$2.MERIT = {
  a: 6378137,
  rf: 298.257,
  ellipseName: "MERIT 1983"
};
exports$2.SGS85 = {
  a: 6378136,
  rf: 298.257,
  ellipseName: "Soviet Geodetic System 85"
};
exports$2.GRS80 = {
  a: 6378137,
  rf: 298.257222101,
  ellipseName: "GRS 1980(IUGG, 1980)"
};
exports$2.IAU76 = {
  a: 6378140,
  rf: 298.257,
  ellipseName: "IAU 1976"
};
exports$2.airy = {
  a: 6377563396e-3,
  b: 635625691e-2,
  ellipseName: "Airy 1830"
};
exports$2.APL4 = {
  a: 6378137,
  rf: 298.25,
  ellipseName: "Appl. Physics. 1965"
};
exports$2.NWL9D = {
  a: 6378145,
  rf: 298.25,
  ellipseName: "Naval Weapons Lab., 1965"
};
exports$2.mod_airy = {
  a: 6377340189e-3,
  b: 6356034446e-3,
  ellipseName: "Modified Airy"
};
exports$2.andrae = {
  a: 637710443e-2,
  rf: 300,
  ellipseName: "Andrae 1876 (Den., Iclnd.)"
};
exports$2.aust_SA = {
  a: 6378160,
  rf: 298.25,
  ellipseName: "Australian Natl & S. Amer. 1969"
};
exports$2.GRS67 = {
  a: 6378160,
  rf: 298.247167427,
  ellipseName: "GRS 67(IUGG 1967)"
};
exports$2.bessel = {
  a: 6377397155e-3,
  rf: 299.1528128,
  ellipseName: "Bessel 1841"
};
exports$2.bess_nam = {
  a: 6377483865e-3,
  rf: 299.1528128,
  ellipseName: "Bessel 1841 (Namibia)"
};
exports$2.clrk66 = {
  a: 63782064e-1,
  b: 63565838e-1,
  ellipseName: "Clarke 1866"
};
exports$2.clrk80 = {
  a: 6378249145e-3,
  rf: 293.4663,
  ellipseName: "Clarke 1880 mod."
};
exports$2.clrk80ign = {
  a: 63782492e-1,
  b: 6356515,
  rf: 293.4660213,
  ellipseName: "Clarke 1880 (IGN)"
};
exports$2.clrk58 = {
  a: 6378293645208759e-9,
  rf: 294.2606763692654,
  ellipseName: "Clarke 1858"
};
exports$2.CPM = {
  a: 63757387e-1,
  rf: 334.29,
  ellipseName: "Comm. des Poids et Mesures 1799"
};
exports$2.delmbr = {
  a: 6376428,
  rf: 311.5,
  ellipseName: "Delambre 1810 (Belgium)"
};
exports$2.engelis = {
  a: 637813605e-2,
  rf: 298.2566,
  ellipseName: "Engelis 1985"
};
exports$2.evrst30 = {
  a: 6377276345e-3,
  rf: 300.8017,
  ellipseName: "Everest 1830"
};
exports$2.evrst48 = {
  a: 6377304063e-3,
  rf: 300.8017,
  ellipseName: "Everest 1948"
};
exports$2.evrst56 = {
  a: 6377301243e-3,
  rf: 300.8017,
  ellipseName: "Everest 1956"
};
exports$2.evrst69 = {
  a: 6377295664e-3,
  rf: 300.8017,
  ellipseName: "Everest 1969"
};
exports$2.evrstSS = {
  a: 6377298556e-3,
  rf: 300.8017,
  ellipseName: "Everest (Sabah & Sarawak)"
};
exports$2.fschr60 = {
  a: 6378166,
  rf: 298.3,
  ellipseName: "Fischer (Mercury Datum) 1960"
};
exports$2.fschr60m = {
  a: 6378155,
  rf: 298.3,
  ellipseName: "Fischer 1960"
};
exports$2.fschr68 = {
  a: 6378150,
  rf: 298.3,
  ellipseName: "Fischer 1968"
};
exports$2.helmert = {
  a: 6378200,
  rf: 298.3,
  ellipseName: "Helmert 1906"
};
exports$2.hough = {
  a: 6378270,
  rf: 297,
  ellipseName: "Hough"
};
exports$2.intl = {
  a: 6378388,
  rf: 297,
  ellipseName: "International 1909 (Hayford)"
};
exports$2.kaula = {
  a: 6378163,
  rf: 298.24,
  ellipseName: "Kaula 1961"
};
exports$2.lerch = {
  a: 6378139,
  rf: 298.257,
  ellipseName: "Lerch 1979"
};
exports$2.mprts = {
  a: 6397300,
  rf: 191,
  ellipseName: "Maupertius 1738"
};
exports$2.new_intl = {
  a: 63781575e-1,
  b: 63567722e-1,
  ellipseName: "New International 1967"
};
exports$2.plessis = {
  a: 6376523,
  rf: 6355863,
  ellipseName: "Plessis 1817 (France)"
};
exports$2.krass = {
  a: 6378245,
  rf: 298.3,
  ellipseName: "Krassovsky, 1942"
};
exports$2.SEasia = {
  a: 6378155,
  b: 63567733205e-4,
  ellipseName: "Southeast Asia"
};
exports$2.walbeck = {
  a: 6376896,
  b: 63558348467e-4,
  ellipseName: "Walbeck"
};
exports$2.WGS60 = {
  a: 6378165,
  rf: 298.3,
  ellipseName: "WGS 60"
};
exports$2.WGS66 = {
  a: 6378145,
  rf: 298.25,
  ellipseName: "WGS 66"
};
exports$2.WGS7 = {
  a: 6378135,
  rf: 298.26,
  ellipseName: "WGS 72"
};
var WGS84 = exports$2.WGS84 = {
  a: 6378137,
  rf: 298.257223563,
  ellipseName: "WGS 84"
};
exports$2.sphere = {
  a: 6370997,
  b: 6370997,
  ellipseName: "Normal Sphere (r=6370997)"
};
function eccentricity(a2, b2, rf, R_A) {
  var a22 = a2 * a2;
  var b22 = b2 * b2;
  var es2 = (a22 - b22) / a22;
  var e3 = 0;
  if (R_A) {
    a2 *= 1 - es2 * (SIXTH + es2 * (RA4 + es2 * RA6));
    a22 = a2 * a2;
    es2 = 0;
  } else {
    e3 = Math.sqrt(es2);
  }
  var ep2 = (a22 - b22) / b22;
  return {
    es: es2,
    e: e3,
    ep2
  };
}
function sphere(a2, b2, rf, ellps, sphere2) {
  if (!a2) {
    var ellipse = match(exports$2, ellps);
    if (!ellipse) {
      ellipse = WGS84;
    }
    a2 = ellipse.a;
    b2 = ellipse.b;
    rf = ellipse.rf;
  }
  if (rf && !b2) {
    b2 = (1 - 1 / rf) * a2;
  }
  if (rf === 0 || Math.abs(a2 - b2) < EPSLN) {
    sphere2 = true;
    b2 = a2;
  }
  return {
    a: a2,
    b: b2,
    rf,
    sphere: sphere2
  };
}
var exports$1 = {};
exports$1.wgs84 = {
  towgs84: "0,0,0",
  ellipse: "WGS84",
  datumName: "WGS84"
};
exports$1.ch1903 = {
  towgs84: "674.374,15.056,405.346",
  ellipse: "bessel",
  datumName: "swiss"
};
exports$1.ggrs87 = {
  towgs84: "-199.87,74.79,246.62",
  ellipse: "GRS80",
  datumName: "Greek_Geodetic_Reference_System_1987"
};
exports$1.nad83 = {
  towgs84: "0,0,0",
  ellipse: "GRS80",
  datumName: "North_American_Datum_1983"
};
exports$1.nad27 = {
  nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
  ellipse: "clrk66",
  datumName: "North_American_Datum_1927"
};
exports$1.potsdam = {
  towgs84: "598.1,73.7,418.2,0.202,0.045,-2.455,6.7",
  ellipse: "bessel",
  datumName: "Potsdam Rauenberg 1950 DHDN"
};
exports$1.carthage = {
  towgs84: "-263.0,6.0,431.0",
  ellipse: "clark80",
  datumName: "Carthage 1934 Tunisia"
};
exports$1.hermannskogel = {
  towgs84: "577.326,90.129,463.919,5.137,1.474,5.297,2.4232",
  ellipse: "bessel",
  datumName: "Hermannskogel"
};
exports$1.osni52 = {
  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
  ellipse: "airy",
  datumName: "Irish National"
};
exports$1.ire65 = {
  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
  ellipse: "mod_airy",
  datumName: "Ireland 1965"
};
exports$1.rassadiran = {
  towgs84: "-133.63,-157.5,-158.62",
  ellipse: "intl",
  datumName: "Rassadiran"
};
exports$1.nzgd49 = {
  towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
  ellipse: "intl",
  datumName: "New Zealand Geodetic Datum 1949"
};
exports$1.osgb36 = {
  towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
  ellipse: "airy",
  datumName: "Airy 1830"
};
exports$1.s_jtsk = {
  towgs84: "589,76,480",
  ellipse: "bessel",
  datumName: "S-JTSK (Ferro)"
};
exports$1.beduaram = {
  towgs84: "-106,-87,188",
  ellipse: "clrk80",
  datumName: "Beduaram"
};
exports$1.gunung_segara = {
  towgs84: "-403,684,41",
  ellipse: "bessel",
  datumName: "Gunung Segara Jakarta"
};
exports$1.rnb72 = {
  towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
  ellipse: "intl",
  datumName: "Reseau National Belge 1972"
};
function datum(datumCode, datum_params, a2, b2, es2, ep2, nadgrids) {
  var out = {};
  if (datumCode === void 0 || datumCode === "none") {
    out.datum_type = PJD_NODATUM;
  } else {
    out.datum_type = PJD_WGS84;
  }
  if (datum_params) {
    out.datum_params = datum_params.map(parseFloat);
    if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) {
      out.datum_type = PJD_3PARAM;
    }
    if (out.datum_params.length > 3) {
      if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
        out.datum_type = PJD_7PARAM;
        out.datum_params[3] *= SEC_TO_RAD;
        out.datum_params[4] *= SEC_TO_RAD;
        out.datum_params[5] *= SEC_TO_RAD;
        out.datum_params[6] = out.datum_params[6] / 1e6 + 1;
      }
    }
  }
  if (nadgrids) {
    out.datum_type = PJD_GRIDSHIFT;
    out.grids = nadgrids;
  }
  out.a = a2;
  out.b = b2;
  out.es = es2;
  out.ep2 = ep2;
  return out;
}
var loadedNadgrids = {};
function nadgrid(key, data2) {
  var view2 = new DataView(data2);
  var isLittleEndian = detectLittleEndian(view2);
  var header = readHeader(view2, isLittleEndian);
  if (header.nSubgrids > 1) {
    console.log("Only single NTv2 subgrids are currently supported, subsequent sub grids are ignored");
  }
  var subgrids = readSubgrids(view2, header, isLittleEndian);
  var nadgrid2 = { header, subgrids };
  loadedNadgrids[key] = nadgrid2;
  return nadgrid2;
}
function getNadgrids(nadgrids) {
  if (nadgrids === void 0) {
    return null;
  }
  var grids = nadgrids.split(",");
  return grids.map(parseNadgridString);
}
function parseNadgridString(value) {
  if (value.length === 0) {
    return null;
  }
  var optional = value[0] === "@";
  if (optional) {
    value = value.slice(1);
  }
  if (value === "null") {
    return { name: "null", mandatory: !optional, grid: null, isNull: true };
  }
  return {
    name: value,
    mandatory: !optional,
    grid: loadedNadgrids[value] || null,
    isNull: false
  };
}
function secondsToRadians(seconds) {
  return seconds / 3600 * Math.PI / 180;
}
function detectLittleEndian(view2) {
  var nFields = view2.getInt32(8, false);
  if (nFields === 11) {
    return false;
  }
  nFields = view2.getInt32(8, true);
  if (nFields !== 11) {
    console.warn("Failed to detect nadgrid endian-ness, defaulting to little-endian");
  }
  return true;
}
function readHeader(view2, isLittleEndian) {
  return {
    nFields: view2.getInt32(8, isLittleEndian),
    nSubgridFields: view2.getInt32(24, isLittleEndian),
    nSubgrids: view2.getInt32(40, isLittleEndian),
    shiftType: decodeString(view2, 56, 56 + 8).trim(),
    fromSemiMajorAxis: view2.getFloat64(120, isLittleEndian),
    fromSemiMinorAxis: view2.getFloat64(136, isLittleEndian),
    toSemiMajorAxis: view2.getFloat64(152, isLittleEndian),
    toSemiMinorAxis: view2.getFloat64(168, isLittleEndian)
  };
}
function decodeString(view2, start2, end) {
  return String.fromCharCode.apply(null, new Uint8Array(view2.buffer.slice(start2, end)));
}
function readSubgrids(view2, header, isLittleEndian) {
  var gridOffset = 176;
  var grids = [];
  for (var i2 = 0; i2 < header.nSubgrids; i2++) {
    var subHeader = readGridHeader(view2, gridOffset, isLittleEndian);
    var nodes = readGridNodes(view2, gridOffset, subHeader, isLittleEndian);
    var lngColumnCount = Math.round(
      1 + (subHeader.upperLongitude - subHeader.lowerLongitude) / subHeader.longitudeInterval
    );
    var latColumnCount = Math.round(
      1 + (subHeader.upperLatitude - subHeader.lowerLatitude) / subHeader.latitudeInterval
    );
    grids.push({
      ll: [secondsToRadians(subHeader.lowerLongitude), secondsToRadians(subHeader.lowerLatitude)],
      del: [secondsToRadians(subHeader.longitudeInterval), secondsToRadians(subHeader.latitudeInterval)],
      lim: [lngColumnCount, latColumnCount],
      count: subHeader.gridNodeCount,
      cvs: mapNodes(nodes)
    });
  }
  return grids;
}
function mapNodes(nodes) {
  return nodes.map(function(r2) {
    return [secondsToRadians(r2.longitudeShift), secondsToRadians(r2.latitudeShift)];
  });
}
function readGridHeader(view2, offset, isLittleEndian) {
  return {
    name: decodeString(view2, offset + 8, offset + 16).trim(),
    parent: decodeString(view2, offset + 24, offset + 24 + 8).trim(),
    lowerLatitude: view2.getFloat64(offset + 72, isLittleEndian),
    upperLatitude: view2.getFloat64(offset + 88, isLittleEndian),
    lowerLongitude: view2.getFloat64(offset + 104, isLittleEndian),
    upperLongitude: view2.getFloat64(offset + 120, isLittleEndian),
    latitudeInterval: view2.getFloat64(offset + 136, isLittleEndian),
    longitudeInterval: view2.getFloat64(offset + 152, isLittleEndian),
    gridNodeCount: view2.getInt32(offset + 168, isLittleEndian)
  };
}
function readGridNodes(view2, offset, gridHeader, isLittleEndian) {
  var nodesOffset = offset + 176;
  var gridRecordLength = 16;
  var gridShiftRecords = [];
  for (var i2 = 0; i2 < gridHeader.gridNodeCount; i2++) {
    var record = {
      latitudeShift: view2.getFloat32(nodesOffset + i2 * gridRecordLength, isLittleEndian),
      longitudeShift: view2.getFloat32(nodesOffset + i2 * gridRecordLength + 4, isLittleEndian),
      latitudeAccuracy: view2.getFloat32(nodesOffset + i2 * gridRecordLength + 8, isLittleEndian),
      longitudeAccuracy: view2.getFloat32(nodesOffset + i2 * gridRecordLength + 12, isLittleEndian)
    };
    gridShiftRecords.push(record);
  }
  return gridShiftRecords;
}
function Projection(srsCode, callback) {
  if (!(this instanceof Projection)) {
    return new Projection(srsCode);
  }
  callback = callback || function(error2) {
    if (error2) {
      throw error2;
    }
  };
  var json = parse$8(srsCode);
  if (typeof json !== "object") {
    callback(srsCode);
    return;
  }
  var ourProj = Projection.projections.get(json.projName);
  if (!ourProj) {
    callback(srsCode);
    return;
  }
  if (json.datumCode && json.datumCode !== "none") {
    var datumDef = match(exports$1, json.datumCode);
    if (datumDef) {
      json.datum_params = json.datum_params || (datumDef.towgs84 ? datumDef.towgs84.split(",") : null);
      json.ellps = datumDef.ellipse;
      json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
    }
  }
  json.k0 = json.k0 || 1;
  json.axis = json.axis || "enu";
  json.ellps = json.ellps || "wgs84";
  json.lat1 = json.lat1 || json.lat0;
  var sphere_ = sphere(json.a, json.b, json.rf, json.ellps, json.sphere);
  var ecc = eccentricity(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
  var nadgrids = getNadgrids(json.nadgrids);
  var datumObj = json.datum || datum(
    json.datumCode,
    json.datum_params,
    sphere_.a,
    sphere_.b,
    ecc.es,
    ecc.ep2,
    nadgrids
  );
  extend$5(this, json);
  extend$5(this, ourProj);
  this.a = sphere_.a;
  this.b = sphere_.b;
  this.rf = sphere_.rf;
  this.sphere = sphere_.sphere;
  this.es = ecc.es;
  this.e = ecc.e;
  this.ep2 = ecc.ep2;
  this.datum = datumObj;
  this.init();
  callback(null, this);
}
Projection.projections = projections;
Projection.projections.start();
function compareDatums(source, dest) {
  if (source.datum_type !== dest.datum_type) {
    return false;
  } else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 5e-11) {
    return false;
  } else if (source.datum_type === PJD_3PARAM) {
    return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2];
  } else if (source.datum_type === PJD_7PARAM) {
    return source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6];
  } else {
    return true;
  }
}
function geodeticToGeocentric(p2, es2, a2) {
  var Longitude = p2.x;
  var Latitude = p2.y;
  var Height = p2.z ? p2.z : 0;
  var Rn;
  var Sin_Lat;
  var Sin2_Lat;
  var Cos_Lat;
  if (Latitude < -HALF_PI && Latitude > -1.001 * HALF_PI) {
    Latitude = -HALF_PI;
  } else if (Latitude > HALF_PI && Latitude < 1.001 * HALF_PI) {
    Latitude = HALF_PI;
  } else if (Latitude < -HALF_PI) {
    return { x: -Infinity, y: -Infinity, z: p2.z };
  } else if (Latitude > HALF_PI) {
    return { x: Infinity, y: Infinity, z: p2.z };
  }
  if (Longitude > Math.PI) {
    Longitude -= 2 * Math.PI;
  }
  Sin_Lat = Math.sin(Latitude);
  Cos_Lat = Math.cos(Latitude);
  Sin2_Lat = Sin_Lat * Sin_Lat;
  Rn = a2 / Math.sqrt(1 - es2 * Sin2_Lat);
  return {
    x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
    y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
    z: (Rn * (1 - es2) + Height) * Sin_Lat
  };
}
function geocentricToGeodetic(p2, es2, a2, b2) {
  var genau = 1e-12;
  var genau2 = genau * genau;
  var maxiter = 30;
  var P2;
  var RR;
  var CT;
  var ST;
  var RX;
  var RK;
  var RN;
  var CPHI0;
  var SPHI0;
  var CPHI;
  var SPHI;
  var SDPHI;
  var iter;
  var X2 = p2.x;
  var Y2 = p2.y;
  var Z2 = p2.z ? p2.z : 0;
  var Longitude;
  var Latitude;
  var Height;
  P2 = Math.sqrt(X2 * X2 + Y2 * Y2);
  RR = Math.sqrt(X2 * X2 + Y2 * Y2 + Z2 * Z2);
  if (P2 / a2 < genau) {
    Longitude = 0;
    if (RR / a2 < genau) {
      Latitude = HALF_PI;
      Height = -b2;
      return {
        x: p2.x,
        y: p2.y,
        z: p2.z
      };
    }
  } else {
    Longitude = Math.atan2(Y2, X2);
  }
  CT = Z2 / RR;
  ST = P2 / RR;
  RX = 1 / Math.sqrt(1 - es2 * (2 - es2) * ST * ST);
  CPHI0 = ST * (1 - es2) * RX;
  SPHI0 = CT * RX;
  iter = 0;
  do {
    iter++;
    RN = a2 / Math.sqrt(1 - es2 * SPHI0 * SPHI0);
    Height = P2 * CPHI0 + Z2 * SPHI0 - RN * (1 - es2 * SPHI0 * SPHI0);
    RK = es2 * RN / (RN + Height);
    RX = 1 / Math.sqrt(1 - RK * (2 - RK) * ST * ST);
    CPHI = ST * (1 - RK) * RX;
    SPHI = CT * RX;
    SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
    CPHI0 = CPHI;
    SPHI0 = SPHI;
  } while (SDPHI * SDPHI > genau2 && iter < maxiter);
  Latitude = Math.atan(SPHI / Math.abs(CPHI));
  return {
    x: Longitude,
    y: Latitude,
    z: Height
  };
}
function geocentricToWgs84(p2, datum_type, datum_params) {
  if (datum_type === PJD_3PARAM) {
    return {
      x: p2.x + datum_params[0],
      y: p2.y + datum_params[1],
      z: p2.z + datum_params[2]
    };
  } else if (datum_type === PJD_7PARAM) {
    var Dx_BF = datum_params[0];
    var Dy_BF = datum_params[1];
    var Dz_BF = datum_params[2];
    var Rx_BF = datum_params[3];
    var Ry_BF = datum_params[4];
    var Rz_BF = datum_params[5];
    var M_BF = datum_params[6];
    return {
      x: M_BF * (p2.x - Rz_BF * p2.y + Ry_BF * p2.z) + Dx_BF,
      y: M_BF * (Rz_BF * p2.x + p2.y - Rx_BF * p2.z) + Dy_BF,
      z: M_BF * (-Ry_BF * p2.x + Rx_BF * p2.y + p2.z) + Dz_BF
    };
  }
}
function geocentricFromWgs84(p2, datum_type, datum_params) {
  if (datum_type === PJD_3PARAM) {
    return {
      x: p2.x - datum_params[0],
      y: p2.y - datum_params[1],
      z: p2.z - datum_params[2]
    };
  } else if (datum_type === PJD_7PARAM) {
    var Dx_BF = datum_params[0];
    var Dy_BF = datum_params[1];
    var Dz_BF = datum_params[2];
    var Rx_BF = datum_params[3];
    var Ry_BF = datum_params[4];
    var Rz_BF = datum_params[5];
    var M_BF = datum_params[6];
    var x_tmp = (p2.x - Dx_BF) / M_BF;
    var y_tmp = (p2.y - Dy_BF) / M_BF;
    var z_tmp = (p2.z - Dz_BF) / M_BF;
    return {
      x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
      y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
      z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
    };
  }
}
function checkParams(type) {
  return type === PJD_3PARAM || type === PJD_7PARAM;
}
function datum_transform(source, dest, point4) {
  if (compareDatums(source, dest)) {
    return point4;
  }
  if (source.datum_type === PJD_NODATUM || dest.datum_type === PJD_NODATUM) {
    return point4;
  }
  var source_a = source.a;
  var source_es = source.es;
  if (source.datum_type === PJD_GRIDSHIFT) {
    var gridShiftCode = applyGridShift(source, false, point4);
    if (gridShiftCode !== 0) {
      return void 0;
    }
    source_a = SRS_WGS84_SEMIMAJOR;
    source_es = SRS_WGS84_ESQUARED;
  }
  var dest_a = dest.a;
  var dest_b = dest.b;
  var dest_es = dest.es;
  if (dest.datum_type === PJD_GRIDSHIFT) {
    dest_a = SRS_WGS84_SEMIMAJOR;
    dest_b = SRS_WGS84_SEMIMINOR;
    dest_es = SRS_WGS84_ESQUARED;
  }
  if (source_es === dest_es && source_a === dest_a && !checkParams(source.datum_type) && !checkParams(dest.datum_type)) {
    return point4;
  }
  point4 = geodeticToGeocentric(point4, source_es, source_a);
  if (checkParams(source.datum_type)) {
    point4 = geocentricToWgs84(point4, source.datum_type, source.datum_params);
  }
  if (checkParams(dest.datum_type)) {
    point4 = geocentricFromWgs84(point4, dest.datum_type, dest.datum_params);
  }
  point4 = geocentricToGeodetic(point4, dest_es, dest_a, dest_b);
  if (dest.datum_type === PJD_GRIDSHIFT) {
    var destGridShiftResult = applyGridShift(dest, true, point4);
    if (destGridShiftResult !== 0) {
      return void 0;
    }
  }
  return point4;
}
function applyGridShift(source, inverse2, point4) {
  if (source.grids === null || source.grids.length === 0) {
    console.log("Grid shift grids not found");
    return -1;
  }
  var input = { x: -point4.x, y: point4.y };
  var output2 = { x: Number.NaN, y: Number.NaN };
  var attemptedGrids = [];
  for (var i2 = 0; i2 < source.grids.length; i2++) {
    var grid = source.grids[i2];
    attemptedGrids.push(grid.name);
    if (grid.isNull) {
      output2 = input;
      break;
    }
    grid.mandatory;
    if (grid.grid === null) {
      if (grid.mandatory) {
        console.log("Unable to find mandatory grid '" + grid.name + "'");
        return -1;
      }
      continue;
    }
    var subgrid = grid.grid.subgrids[0];
    var epsilon2 = (Math.abs(subgrid.del[1]) + Math.abs(subgrid.del[0])) / 1e4;
    var minX2 = subgrid.ll[0] - epsilon2;
    var minY2 = subgrid.ll[1] - epsilon2;
    var maxX2 = subgrid.ll[0] + (subgrid.lim[0] - 1) * subgrid.del[0] + epsilon2;
    var maxY2 = subgrid.ll[1] + (subgrid.lim[1] - 1) * subgrid.del[1] + epsilon2;
    if (minY2 > input.y || minX2 > input.x || maxY2 < input.y || maxX2 < input.x) {
      continue;
    }
    output2 = applySubgridShift(input, inverse2, subgrid);
    if (!isNaN(output2.x)) {
      break;
    }
  }
  if (isNaN(output2.x)) {
    console.log("Failed to find a grid shift table for location '" + -input.x * R2D + " " + input.y * R2D + " tried: '" + attemptedGrids + "'");
    return -1;
  }
  point4.x = -output2.x;
  point4.y = output2.y;
  return 0;
}
function applySubgridShift(pin, inverse2, ct) {
  var val = { x: Number.NaN, y: Number.NaN };
  if (isNaN(pin.x)) {
    return val;
  }
  var tb = { x: pin.x, y: pin.y };
  tb.x -= ct.ll[0];
  tb.y -= ct.ll[1];
  tb.x = adjust_lon(tb.x - Math.PI) + Math.PI;
  var t2 = nadInterpolate(tb, ct);
  if (inverse2) {
    if (isNaN(t2.x)) {
      return val;
    }
    t2.x = tb.x - t2.x;
    t2.y = tb.y - t2.y;
    var i2 = 9, tol = 1e-12;
    var dif, del;
    do {
      del = nadInterpolate(t2, ct);
      if (isNaN(del.x)) {
        console.log("Inverse grid shift iteration failed, presumably at grid edge.  Using first approximation.");
        break;
      }
      dif = { x: tb.x - (del.x + t2.x), y: tb.y - (del.y + t2.y) };
      t2.x += dif.x;
      t2.y += dif.y;
    } while (i2-- && Math.abs(dif.x) > tol && Math.abs(dif.y) > tol);
    if (i2 < 0) {
      console.log("Inverse grid shift iterator failed to converge.");
      return val;
    }
    val.x = adjust_lon(t2.x + ct.ll[0]);
    val.y = t2.y + ct.ll[1];
  } else {
    if (!isNaN(t2.x)) {
      val.x = pin.x + t2.x;
      val.y = pin.y + t2.y;
    }
  }
  return val;
}
function nadInterpolate(pin, ct) {
  var t2 = { x: pin.x / ct.del[0], y: pin.y / ct.del[1] };
  var indx = { x: Math.floor(t2.x), y: Math.floor(t2.y) };
  var frct = { x: t2.x - 1 * indx.x, y: t2.y - 1 * indx.y };
  var val = { x: Number.NaN, y: Number.NaN };
  var inx;
  if (indx.x < 0 || indx.x >= ct.lim[0]) {
    return val;
  }
  if (indx.y < 0 || indx.y >= ct.lim[1]) {
    return val;
  }
  inx = indx.y * ct.lim[0] + indx.x;
  var f00 = { x: ct.cvs[inx][0], y: ct.cvs[inx][1] };
  inx++;
  var f10 = { x: ct.cvs[inx][0], y: ct.cvs[inx][1] };
  inx += ct.lim[0];
  var f11 = { x: ct.cvs[inx][0], y: ct.cvs[inx][1] };
  inx--;
  var f01 = { x: ct.cvs[inx][0], y: ct.cvs[inx][1] };
  var m11 = frct.x * frct.y, m10 = frct.x * (1 - frct.y), m00 = (1 - frct.x) * (1 - frct.y), m01 = (1 - frct.x) * frct.y;
  val.x = m00 * f00.x + m10 * f10.x + m01 * f01.x + m11 * f11.x;
  val.y = m00 * f00.y + m10 * f10.y + m01 * f01.y + m11 * f11.y;
  return val;
}
function adjust_axis(crs, denorm, point4) {
  var xin = point4.x, yin = point4.y, zin = point4.z || 0;
  var v5, t2, i2;
  var out = {};
  for (i2 = 0; i2 < 3; i2++) {
    if (denorm && i2 === 2 && point4.z === void 0) {
      continue;
    }
    if (i2 === 0) {
      v5 = xin;
      if ("ew".indexOf(crs.axis[i2]) !== -1) {
        t2 = "x";
      } else {
        t2 = "y";
      }
    } else if (i2 === 1) {
      v5 = yin;
      if ("ns".indexOf(crs.axis[i2]) !== -1) {
        t2 = "y";
      } else {
        t2 = "x";
      }
    } else {
      v5 = zin;
      t2 = "z";
    }
    switch (crs.axis[i2]) {
      case "e":
        out[t2] = v5;
        break;
      case "w":
        out[t2] = -v5;
        break;
      case "n":
        out[t2] = v5;
        break;
      case "s":
        out[t2] = -v5;
        break;
      case "u":
        if (point4[t2] !== void 0) {
          out.z = v5;
        }
        break;
      case "d":
        if (point4[t2] !== void 0) {
          out.z = -v5;
        }
        break;
      default:
        return null;
    }
  }
  return out;
}
function common(array2) {
  var out = {
    x: array2[0],
    y: array2[1]
  };
  if (array2.length > 2) {
    out.z = array2[2];
  }
  if (array2.length > 3) {
    out.m = array2[3];
  }
  return out;
}
function checkSanity(point4) {
  checkCoord(point4.x);
  checkCoord(point4.y);
}
function checkCoord(num) {
  if (typeof Number.isFinite === "function") {
    if (Number.isFinite(num)) {
      return;
    }
    throw new TypeError("coordinates must be finite numbers");
  }
  if (typeof num !== "number" || num !== num || !isFinite(num)) {
    throw new TypeError("coordinates must be finite numbers");
  }
}
function checkNotWGS(source, dest) {
  return (source.datum.datum_type === PJD_3PARAM || source.datum.datum_type === PJD_7PARAM || source.datum.datum_type === PJD_GRIDSHIFT) && dest.datumCode !== "WGS84" || (dest.datum.datum_type === PJD_3PARAM || dest.datum.datum_type === PJD_7PARAM || dest.datum.datum_type === PJD_GRIDSHIFT) && source.datumCode !== "WGS84";
}
function transform$1(source, dest, point4, enforceAxis) {
  var wgs842;
  if (Array.isArray(point4)) {
    point4 = common(point4);
  } else {
    point4 = {
      x: point4.x,
      y: point4.y,
      z: point4.z,
      m: point4.m
    };
  }
  var hasZ = point4.z !== void 0;
  checkSanity(point4);
  if (source.datum && dest.datum && checkNotWGS(source, dest)) {
    wgs842 = new Projection("WGS84");
    point4 = transform$1(source, wgs842, point4, enforceAxis);
    source = wgs842;
  }
  if (enforceAxis && source.axis !== "enu") {
    point4 = adjust_axis(source, false, point4);
  }
  if (source.projName === "longlat") {
    point4 = {
      x: point4.x * D2R$1,
      y: point4.y * D2R$1,
      z: point4.z || 0
    };
  } else {
    if (source.to_meter) {
      point4 = {
        x: point4.x * source.to_meter,
        y: point4.y * source.to_meter,
        z: point4.z || 0
      };
    }
    point4 = source.inverse(point4);
    if (!point4) {
      return;
    }
  }
  if (source.from_greenwich) {
    point4.x += source.from_greenwich;
  }
  point4 = datum_transform(source.datum, dest.datum, point4);
  if (!point4) {
    return;
  }
  if (dest.from_greenwich) {
    point4 = {
      x: point4.x - dest.from_greenwich,
      y: point4.y,
      z: point4.z || 0
    };
  }
  if (dest.projName === "longlat") {
    point4 = {
      x: point4.x * R2D,
      y: point4.y * R2D,
      z: point4.z || 0
    };
  } else {
    point4 = dest.forward(point4);
    if (dest.to_meter) {
      point4 = {
        x: point4.x / dest.to_meter,
        y: point4.y / dest.to_meter,
        z: point4.z || 0
      };
    }
  }
  if (enforceAxis && dest.axis !== "enu") {
    return adjust_axis(dest, true, point4);
  }
  if (point4 && !hasZ) {
    delete point4.z;
  }
  return point4;
}
var wgs84$2 = Projection("WGS84");
function transformer(from, to, coords, enforceAxis) {
  var transformedArray, out, keys4;
  if (Array.isArray(coords)) {
    transformedArray = transform$1(from, to, coords, enforceAxis) || { x: NaN, y: NaN };
    if (coords.length > 2) {
      if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
        if (typeof transformedArray.z === "number") {
          return [transformedArray.x, transformedArray.y, transformedArray.z].concat(coords.splice(3));
        } else {
          return [transformedArray.x, transformedArray.y, coords[2]].concat(coords.splice(3));
        }
      } else {
        return [transformedArray.x, transformedArray.y].concat(coords.splice(2));
      }
    } else {
      return [transformedArray.x, transformedArray.y];
    }
  } else {
    out = transform$1(from, to, coords, enforceAxis);
    keys4 = Object.keys(coords);
    if (keys4.length === 2) {
      return out;
    }
    keys4.forEach(function(key) {
      if (typeof from.name !== "undefined" && from.name === "geocent" || typeof to.name !== "undefined" && to.name === "geocent") {
        if (key === "x" || key === "y" || key === "z") {
          return;
        }
      } else {
        if (key === "x" || key === "y") {
          return;
        }
      }
      out[key] = coords[key];
    });
    return out;
  }
}
function checkProj(item) {
  if (item instanceof Projection) {
    return item;
  }
  if (item.oProj) {
    return item.oProj;
  }
  return Projection(item);
}
function proj4(fromProj, toProj, coord) {
  fromProj = checkProj(fromProj);
  var single = false;
  var obj;
  if (typeof toProj === "undefined") {
    toProj = fromProj;
    fromProj = wgs84$2;
    single = true;
  } else if (typeof toProj.x !== "undefined" || Array.isArray(toProj)) {
    coord = toProj;
    toProj = fromProj;
    fromProj = wgs84$2;
    single = true;
  }
  toProj = checkProj(toProj);
  if (coord) {
    return transformer(fromProj, toProj, coord);
  } else {
    obj = {
      forward: function(coords, enforceAxis) {
        return transformer(fromProj, toProj, coords, enforceAxis);
      },
      inverse: function(coords, enforceAxis) {
        return transformer(toProj, fromProj, coords, enforceAxis);
      }
    };
    if (single) {
      obj.oProj = toProj;
    }
    return obj;
  }
}
var NUM_100K_SETS = 6;
var SET_ORIGIN_COLUMN_LETTERS = "AJSAJS";
var SET_ORIGIN_ROW_LETTERS = "AFAFAF";
var A = 65;
var I$1 = 73;
var O = 79;
var V$2 = 86;
var Z = 90;
const mgrs = {
  forward: forward$t,
  inverse: inverse$t,
  toPoint
};
function forward$t(ll, accuracy) {
  accuracy = accuracy || 5;
  return encode$8(LLtoUTM({
    lat: ll[1],
    lon: ll[0]
  }), accuracy);
}
function inverse$t(mgrs2) {
  var bbox2 = UTMtoLL(decode$k(mgrs2.toUpperCase()));
  if (bbox2.lat && bbox2.lon) {
    return [bbox2.lon, bbox2.lat, bbox2.lon, bbox2.lat];
  }
  return [bbox2.left, bbox2.bottom, bbox2.right, bbox2.top];
}
function toPoint(mgrs2) {
  var bbox2 = UTMtoLL(decode$k(mgrs2.toUpperCase()));
  if (bbox2.lat && bbox2.lon) {
    return [bbox2.lon, bbox2.lat];
  }
  return [(bbox2.left + bbox2.right) / 2, (bbox2.top + bbox2.bottom) / 2];
}
function degToRad(deg) {
  return deg * (Math.PI / 180);
}
function radToDeg(rad2) {
  return 180 * (rad2 / Math.PI);
}
function LLtoUTM(ll) {
  var Lat = ll.lat;
  var Long2 = ll.lon;
  var a2 = 6378137;
  var eccSquared = 669438e-8;
  var k0 = 0.9996;
  var LongOrigin;
  var eccPrimeSquared;
  var N2, T2, C2, A2, M2;
  var LatRad = degToRad(Lat);
  var LongRad = degToRad(Long2);
  var LongOriginRad;
  var ZoneNumber;
  ZoneNumber = Math.floor((Long2 + 180) / 6) + 1;
  if (Long2 === 180) {
    ZoneNumber = 60;
  }
  if (Lat >= 56 && Lat < 64 && Long2 >= 3 && Long2 < 12) {
    ZoneNumber = 32;
  }
  if (Lat >= 72 && Lat < 84) {
    if (Long2 >= 0 && Long2 < 9) {
      ZoneNumber = 31;
    } else if (Long2 >= 9 && Long2 < 21) {
      ZoneNumber = 33;
    } else if (Long2 >= 21 && Long2 < 33) {
      ZoneNumber = 35;
    } else if (Long2 >= 33 && Long2 < 42) {
      ZoneNumber = 37;
    }
  }
  LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3;
  LongOriginRad = degToRad(LongOrigin);
  eccPrimeSquared = eccSquared / (1 - eccSquared);
  N2 = a2 / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
  T2 = Math.tan(LatRad) * Math.tan(LatRad);
  C2 = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
  A2 = Math.cos(LatRad) * (LongRad - LongOriginRad);
  M2 = a2 * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - 35 * eccSquared * eccSquared * eccSquared / 3072 * Math.sin(6 * LatRad));
  var UTMEasting = k0 * N2 * (A2 + (1 - T2 + C2) * A2 * A2 * A2 / 6 + (5 - 18 * T2 + T2 * T2 + 72 * C2 - 58 * eccPrimeSquared) * A2 * A2 * A2 * A2 * A2 / 120) + 5e5;
  var UTMNorthing = k0 * (M2 + N2 * Math.tan(LatRad) * (A2 * A2 / 2 + (5 - T2 + 9 * C2 + 4 * C2 * C2) * A2 * A2 * A2 * A2 / 24 + (61 - 58 * T2 + T2 * T2 + 600 * C2 - 330 * eccPrimeSquared) * A2 * A2 * A2 * A2 * A2 * A2 / 720));
  if (Lat < 0) {
    UTMNorthing += 1e7;
  }
  return {
    northing: Math.round(UTMNorthing),
    easting: Math.round(UTMEasting),
    zoneNumber: ZoneNumber,
    zoneLetter: getLetterDesignator(Lat)
  };
}
function UTMtoLL(utm2) {
  var UTMNorthing = utm2.northing;
  var UTMEasting = utm2.easting;
  var zoneLetter = utm2.zoneLetter;
  var zoneNumber = utm2.zoneNumber;
  if (zoneNumber < 0 || zoneNumber > 60) {
    return null;
  }
  var k0 = 0.9996;
  var a2 = 6378137;
  var eccSquared = 669438e-8;
  var eccPrimeSquared;
  var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
  var N1, T1, C12, R1, D2, M2;
  var LongOrigin;
  var mu, phi1Rad;
  var x2 = UTMEasting - 5e5;
  var y2 = UTMNorthing;
  if (zoneLetter < "N") {
    y2 -= 1e7;
  }
  LongOrigin = (zoneNumber - 1) * 6 - 180 + 3;
  eccPrimeSquared = eccSquared / (1 - eccSquared);
  M2 = y2 / k0;
  mu = M2 / (a2 * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));
  phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + 151 * e1 * e1 * e1 / 96 * Math.sin(6 * mu);
  N1 = a2 / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
  T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
  C12 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
  R1 = a2 * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
  D2 = x2 / (N1 * k0);
  var lat = phi1Rad - N1 * Math.tan(phi1Rad) / R1 * (D2 * D2 / 2 - (5 + 3 * T1 + 10 * C12 - 4 * C12 * C12 - 9 * eccPrimeSquared) * D2 * D2 * D2 * D2 / 24 + (61 + 90 * T1 + 298 * C12 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C12 * C12) * D2 * D2 * D2 * D2 * D2 * D2 / 720);
  lat = radToDeg(lat);
  var lon = (D2 - (1 + 2 * T1 + C12) * D2 * D2 * D2 / 6 + (5 - 2 * C12 + 28 * T1 - 3 * C12 * C12 + 8 * eccPrimeSquared + 24 * T1 * T1) * D2 * D2 * D2 * D2 * D2 / 120) / Math.cos(phi1Rad);
  lon = LongOrigin + radToDeg(lon);
  var result;
  if (utm2.accuracy) {
    var topRight = UTMtoLL({
      northing: utm2.northing + utm2.accuracy,
      easting: utm2.easting + utm2.accuracy,
      zoneLetter: utm2.zoneLetter,
      zoneNumber: utm2.zoneNumber
    });
    result = {
      top: topRight.lat,
      right: topRight.lon,
      bottom: lat,
      left: lon
    };
  } else {
    result = {
      lat,
      lon
    };
  }
  return result;
}
function getLetterDesignator(lat) {
  var LetterDesignator = "Z";
  if (84 >= lat && lat >= 72) {
    LetterDesignator = "X";
  } else if (72 > lat && lat >= 64) {
    LetterDesignator = "W";
  } else if (64 > lat && lat >= 56) {
    LetterDesignator = "V";
  } else if (56 > lat && lat >= 48) {
    LetterDesignator = "U";
  } else if (48 > lat && lat >= 40) {
    LetterDesignator = "T";
  } else if (40 > lat && lat >= 32) {
    LetterDesignator = "S";
  } else if (32 > lat && lat >= 24) {
    LetterDesignator = "R";
  } else if (24 > lat && lat >= 16) {
    LetterDesignator = "Q";
  } else if (16 > lat && lat >= 8) {
    LetterDesignator = "P";
  } else if (8 > lat && lat >= 0) {
    LetterDesignator = "N";
  } else if (0 > lat && lat >= -8) {
    LetterDesignator = "M";
  } else if (-8 > lat && lat >= -16) {
    LetterDesignator = "L";
  } else if (-16 > lat && lat >= -24) {
    LetterDesignator = "K";
  } else if (-24 > lat && lat >= -32) {
    LetterDesignator = "J";
  } else if (-32 > lat && lat >= -40) {
    LetterDesignator = "H";
  } else if (-40 > lat && lat >= -48) {
    LetterDesignator = "G";
  } else if (-48 > lat && lat >= -56) {
    LetterDesignator = "F";
  } else if (-56 > lat && lat >= -64) {
    LetterDesignator = "E";
  } else if (-64 > lat && lat >= -72) {
    LetterDesignator = "D";
  } else if (-72 > lat && lat >= -80) {
    LetterDesignator = "C";
  }
  return LetterDesignator;
}
function encode$8(utm2, accuracy) {
  var seasting = "00000" + utm2.easting, snorthing = "00000" + utm2.northing;
  return utm2.zoneNumber + utm2.zoneLetter + get100kID(utm2.easting, utm2.northing, utm2.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}
function get100kID(easting, northing, zoneNumber) {
  var setParm = get100kSetForZone(zoneNumber);
  var setColumn = Math.floor(easting / 1e5);
  var setRow = Math.floor(northing / 1e5) % 20;
  return getLetter100kID(setColumn, setRow, setParm);
}
function get100kSetForZone(i2) {
  var setParm = i2 % NUM_100K_SETS;
  if (setParm === 0) {
    setParm = NUM_100K_SETS;
  }
  return setParm;
}
function getLetter100kID(column, row, parm) {
  var index2 = parm - 1;
  var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index2);
  var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index2);
  var colInt = colOrigin + column - 1;
  var rowInt = rowOrigin + row;
  var rollover = false;
  if (colInt > Z) {
    colInt = colInt - Z + A - 1;
    rollover = true;
  }
  if (colInt === I$1 || colOrigin < I$1 && colInt > I$1 || (colInt > I$1 || colOrigin < I$1) && rollover) {
    colInt++;
  }
  if (colInt === O || colOrigin < O && colInt > O || (colInt > O || colOrigin < O) && rollover) {
    colInt++;
    if (colInt === I$1) {
      colInt++;
    }
  }
  if (colInt > Z) {
    colInt = colInt - Z + A - 1;
  }
  if (rowInt > V$2) {
    rowInt = rowInt - V$2 + A - 1;
    rollover = true;
  } else {
    rollover = false;
  }
  if (rowInt === I$1 || rowOrigin < I$1 && rowInt > I$1 || (rowInt > I$1 || rowOrigin < I$1) && rollover) {
    rowInt++;
  }
  if (rowInt === O || rowOrigin < O && rowInt > O || (rowInt > O || rowOrigin < O) && rollover) {
    rowInt++;
    if (rowInt === I$1) {
      rowInt++;
    }
  }
  if (rowInt > V$2) {
    rowInt = rowInt - V$2 + A - 1;
  }
  var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
  return twoLetter;
}
function decode$k(mgrsString) {
  if (mgrsString && mgrsString.length === 0) {
    throw "MGRSPoint coverting from nothing";
  }
  var length2 = mgrsString.length;
  var hunK = null;
  var sb = "";
  var testChar;
  var i2 = 0;
  while (!/[A-Z]/.test(testChar = mgrsString.charAt(i2))) {
    if (i2 >= 2) {
      throw "MGRSPoint bad conversion from: " + mgrsString;
    }
    sb += testChar;
    i2++;
  }
  var zoneNumber = parseInt(sb, 10);
  if (i2 === 0 || i2 + 3 > length2) {
    throw "MGRSPoint bad conversion from: " + mgrsString;
  }
  var zoneLetter = mgrsString.charAt(i2++);
  if (zoneLetter <= "A" || zoneLetter === "B" || zoneLetter === "Y" || zoneLetter >= "Z" || zoneLetter === "I" || zoneLetter === "O") {
    throw "MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString;
  }
  hunK = mgrsString.substring(i2, i2 += 2);
  var set = get100kSetForZone(zoneNumber);
  var east100k = getEastingFromChar(hunK.charAt(0), set);
  var north100k = getNorthingFromChar(hunK.charAt(1), set);
  while (north100k < getMinNorthing(zoneLetter)) {
    north100k += 2e6;
  }
  var remainder = length2 - i2;
  if (remainder % 2 !== 0) {
    throw "MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString;
  }
  var sep = remainder / 2;
  var sepEasting = 0;
  var sepNorthing = 0;
  var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
  if (sep > 0) {
    accuracyBonus = 1e5 / Math.pow(10, sep);
    sepEastingString = mgrsString.substring(i2, i2 + sep);
    sepEasting = parseFloat(sepEastingString) * accuracyBonus;
    sepNorthingString = mgrsString.substring(i2 + sep);
    sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
  }
  easting = sepEasting + east100k;
  northing = sepNorthing + north100k;
  return {
    easting,
    northing,
    zoneLetter,
    zoneNumber,
    accuracy: accuracyBonus
  };
}
function getEastingFromChar(e3, set) {
  var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
  var eastingValue = 1e5;
  var rewindMarker = false;
  while (curCol !== e3.charCodeAt(0)) {
    curCol++;
    if (curCol === I$1) {
      curCol++;
    }
    if (curCol === O) {
      curCol++;
    }
    if (curCol > Z) {
      if (rewindMarker) {
        throw "Bad character: " + e3;
      }
      curCol = A;
      rewindMarker = true;
    }
    eastingValue += 1e5;
  }
  return eastingValue;
}
function getNorthingFromChar(n2, set) {
  if (n2 > "V") {
    throw "MGRSPoint given invalid Northing " + n2;
  }
  var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
  var northingValue = 0;
  var rewindMarker = false;
  while (curRow !== n2.charCodeAt(0)) {
    curRow++;
    if (curRow === I$1) {
      curRow++;
    }
    if (curRow === O) {
      curRow++;
    }
    if (curRow > V$2) {
      if (rewindMarker) {
        throw "Bad character: " + n2;
      }
      curRow = A;
      rewindMarker = true;
    }
    northingValue += 1e5;
  }
  return northingValue;
}
function getMinNorthing(zoneLetter) {
  var northing;
  switch (zoneLetter) {
    case "C":
      northing = 11e5;
      break;
    case "D":
      northing = 2e6;
      break;
    case "E":
      northing = 28e5;
      break;
    case "F":
      northing = 37e5;
      break;
    case "G":
      northing = 46e5;
      break;
    case "H":
      northing = 55e5;
      break;
    case "J":
      northing = 64e5;
      break;
    case "K":
      northing = 73e5;
      break;
    case "L":
      northing = 82e5;
      break;
    case "M":
      northing = 91e5;
      break;
    case "N":
      northing = 0;
      break;
    case "P":
      northing = 8e5;
      break;
    case "Q":
      northing = 17e5;
      break;
    case "R":
      northing = 26e5;
      break;
    case "S":
      northing = 35e5;
      break;
    case "T":
      northing = 44e5;
      break;
    case "U":
      northing = 53e5;
      break;
    case "V":
      northing = 62e5;
      break;
    case "W":
      northing = 7e6;
      break;
    case "X":
      northing = 79e5;
      break;
    default:
      northing = -1;
  }
  if (northing >= 0) {
    return northing;
  } else {
    throw "Invalid zone letter: " + zoneLetter;
  }
}
function Point$6(x2, y2, z2) {
  if (!(this instanceof Point$6)) {
    return new Point$6(x2, y2, z2);
  }
  if (Array.isArray(x2)) {
    this.x = x2[0];
    this.y = x2[1];
    this.z = x2[2] || 0;
  } else if (typeof x2 === "object") {
    this.x = x2.x;
    this.y = x2.y;
    this.z = x2.z || 0;
  } else if (typeof x2 === "string" && typeof y2 === "undefined") {
    var coords = x2.split(",");
    this.x = parseFloat(coords[0], 10);
    this.y = parseFloat(coords[1], 10);
    this.z = parseFloat(coords[2], 10) || 0;
  } else {
    this.x = x2;
    this.y = y2;
    this.z = z2 || 0;
  }
  console.warn("proj4.Point will be removed in version 3, use proj4.toPoint");
}
Point$6.fromMGRS = function(mgrsStr) {
  return new Point$6(toPoint(mgrsStr));
};
Point$6.prototype.toMGRS = function(accuracy) {
  return forward$t([this.x, this.y], accuracy);
};
var C00 = 1;
var C02 = 0.25;
var C04 = 0.046875;
var C06 = 0.01953125;
var C08 = 0.01068115234375;
var C22 = 0.75;
var C44 = 0.46875;
var C46 = 0.013020833333333334;
var C48 = 0.007120768229166667;
var C66 = 0.3645833333333333;
var C68 = 0.005696614583333333;
var C88 = 0.3076171875;
function pj_enfn(es2) {
  var en2 = [];
  en2[0] = C00 - es2 * (C02 + es2 * (C04 + es2 * (C06 + es2 * C08)));
  en2[1] = es2 * (C22 - es2 * (C04 + es2 * (C06 + es2 * C08)));
  var t2 = es2 * es2;
  en2[2] = t2 * (C44 - es2 * (C46 + es2 * C48));
  t2 *= es2;
  en2[3] = t2 * (C66 - es2 * C68);
  en2[4] = t2 * es2 * C88;
  return en2;
}
function pj_mlfn(phi, sphi, cphi, en2) {
  cphi *= sphi;
  sphi *= sphi;
  return en2[0] * phi - cphi * (en2[1] + sphi * (en2[2] + sphi * (en2[3] + sphi * en2[4])));
}
var MAX_ITER$3 = 20;
function pj_inv_mlfn(arg, es2, en2) {
  var k2 = 1 / (1 - es2);
  var phi = arg;
  for (var i2 = MAX_ITER$3; i2; --i2) {
    var s2 = Math.sin(phi);
    var t2 = 1 - es2 * s2 * s2;
    t2 = (pj_mlfn(phi, s2, Math.cos(phi), en2) - arg) * (t2 * Math.sqrt(t2)) * k2;
    phi -= t2;
    if (Math.abs(t2) < EPSLN) {
      return phi;
    }
  }
  return phi;
}
function init$t() {
  this.x0 = this.x0 !== void 0 ? this.x0 : 0;
  this.y0 = this.y0 !== void 0 ? this.y0 : 0;
  this.long0 = this.long0 !== void 0 ? this.long0 : 0;
  this.lat0 = this.lat0 !== void 0 ? this.lat0 : 0;
  if (this.es) {
    this.en = pj_enfn(this.es);
    this.ml0 = pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
  }
}
function forward$s(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var delta_lon = adjust_lon(lon - this.long0);
  var con;
  var x2, y2;
  var sin_phi = Math.sin(lat);
  var cos_phi = Math.cos(lat);
  if (!this.es) {
    var b2 = cos_phi * Math.sin(delta_lon);
    if (Math.abs(Math.abs(b2) - 1) < EPSLN) {
      return 93;
    } else {
      x2 = 0.5 * this.a * this.k0 * Math.log((1 + b2) / (1 - b2)) + this.x0;
      y2 = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b2, 2));
      b2 = Math.abs(y2);
      if (b2 >= 1) {
        if (b2 - 1 > EPSLN) {
          return 93;
        } else {
          y2 = 0;
        }
      } else {
        y2 = Math.acos(y2);
      }
      if (lat < 0) {
        y2 = -y2;
      }
      y2 = this.a * this.k0 * (y2 - this.lat0) + this.y0;
    }
  } else {
    var al2 = cos_phi * delta_lon;
    var als = Math.pow(al2, 2);
    var c2 = this.ep2 * Math.pow(cos_phi, 2);
    var cs = Math.pow(c2, 2);
    var tq = Math.abs(cos_phi) > EPSLN ? Math.tan(lat) : 0;
    var t2 = Math.pow(tq, 2);
    var ts = Math.pow(t2, 2);
    con = 1 - this.es * Math.pow(sin_phi, 2);
    al2 = al2 / Math.sqrt(con);
    var ml = pj_mlfn(lat, sin_phi, cos_phi, this.en);
    x2 = this.a * (this.k0 * al2 * (1 + als / 6 * (1 - t2 + c2 + als / 20 * (5 - 18 * t2 + ts + 14 * c2 - 58 * t2 * c2 + als / 42 * (61 + 179 * ts - ts * t2 - 479 * t2))))) + this.x0;
    y2 = this.a * (this.k0 * (ml - this.ml0 + sin_phi * delta_lon * al2 / 2 * (1 + als / 12 * (5 - t2 + 9 * c2 + 4 * cs + als / 30 * (61 + ts - 58 * t2 + 270 * c2 - 330 * t2 * c2 + als / 56 * (1385 + 543 * ts - ts * t2 - 3111 * t2)))))) + this.y0;
  }
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$s(p2) {
  var con, phi;
  var lat, lon;
  var x2 = (p2.x - this.x0) * (1 / this.a);
  var y2 = (p2.y - this.y0) * (1 / this.a);
  if (!this.es) {
    var f2 = Math.exp(x2 / this.k0);
    var g2 = 0.5 * (f2 - 1 / f2);
    var temp2 = this.lat0 + y2 / this.k0;
    var h2 = Math.cos(temp2);
    con = Math.sqrt((1 - Math.pow(h2, 2)) / (1 + Math.pow(g2, 2)));
    lat = Math.asin(con);
    if (y2 < 0) {
      lat = -lat;
    }
    if (g2 === 0 && h2 === 0) {
      lon = 0;
    } else {
      lon = adjust_lon(Math.atan2(g2, h2) + this.long0);
    }
  } else {
    con = this.ml0 + y2 / this.k0;
    phi = pj_inv_mlfn(con, this.es, this.en);
    if (Math.abs(phi) < HALF_PI) {
      var sin_phi = Math.sin(phi);
      var cos_phi = Math.cos(phi);
      var tan_phi = Math.abs(cos_phi) > EPSLN ? Math.tan(phi) : 0;
      var c2 = this.ep2 * Math.pow(cos_phi, 2);
      var cs = Math.pow(c2, 2);
      var t2 = Math.pow(tan_phi, 2);
      var ts = Math.pow(t2, 2);
      con = 1 - this.es * Math.pow(sin_phi, 2);
      var d2 = x2 * Math.sqrt(con) / this.k0;
      var ds = Math.pow(d2, 2);
      con = con * tan_phi;
      lat = phi - con * ds / (1 - this.es) * 0.5 * (1 - ds / 12 * (5 + 3 * t2 - 9 * c2 * t2 + c2 - 4 * cs - ds / 30 * (61 + 90 * t2 - 252 * c2 * t2 + 45 * ts + 46 * c2 - ds / 56 * (1385 + 3633 * t2 + 4095 * ts + 1574 * ts * t2))));
      lon = adjust_lon(this.long0 + d2 * (1 - ds / 6 * (1 + 2 * t2 + c2 - ds / 20 * (5 + 28 * t2 + 24 * ts + 8 * c2 * t2 + 6 * c2 - ds / 42 * (61 + 662 * t2 + 1320 * ts + 720 * ts * t2)))) / cos_phi);
    } else {
      lat = HALF_PI * sign$1(y2);
      lon = 0;
    }
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$u = ["Fast_Transverse_Mercator", "Fast Transverse Mercator"];
const tmerc = {
  init: init$t,
  forward: forward$s,
  inverse: inverse$s,
  names: names$u
};
function sinh(x2) {
  var r2 = Math.exp(x2);
  r2 = (r2 - 1 / r2) / 2;
  return r2;
}
function hypot(x2, y2) {
  x2 = Math.abs(x2);
  y2 = Math.abs(y2);
  var a2 = Math.max(x2, y2);
  var b2 = Math.min(x2, y2) / (a2 ? a2 : 1);
  return a2 * Math.sqrt(1 + Math.pow(b2, 2));
}
function log1py(x2) {
  var y2 = 1 + x2;
  var z2 = y2 - 1;
  return z2 === 0 ? x2 : x2 * Math.log(y2) / z2;
}
function asinhy(x2) {
  var y2 = Math.abs(x2);
  y2 = log1py(y2 * (1 + y2 / (hypot(1, y2) + 1)));
  return x2 < 0 ? -y2 : y2;
}
function gatg(pp, B2) {
  var cos_2B = 2 * Math.cos(2 * B2);
  var i2 = pp.length - 1;
  var h1 = pp[i2];
  var h2 = 0;
  var h3;
  while (--i2 >= 0) {
    h3 = -h2 + cos_2B * h1 + pp[i2];
    h2 = h1;
    h1 = h3;
  }
  return B2 + h3 * Math.sin(2 * B2);
}
function clens(pp, arg_r) {
  var r2 = 2 * Math.cos(arg_r);
  var i2 = pp.length - 1;
  var hr1 = pp[i2];
  var hr2 = 0;
  var hr;
  while (--i2 >= 0) {
    hr = -hr2 + r2 * hr1 + pp[i2];
    hr2 = hr1;
    hr1 = hr;
  }
  return Math.sin(arg_r) * hr;
}
function cosh(x2) {
  var r2 = Math.exp(x2);
  r2 = (r2 + 1 / r2) / 2;
  return r2;
}
function clens_cmplx(pp, arg_r, arg_i) {
  var sin_arg_r = Math.sin(arg_r);
  var cos_arg_r = Math.cos(arg_r);
  var sinh_arg_i = sinh(arg_i);
  var cosh_arg_i = cosh(arg_i);
  var r2 = 2 * cos_arg_r * cosh_arg_i;
  var i2 = -2 * sin_arg_r * sinh_arg_i;
  var j2 = pp.length - 1;
  var hr = pp[j2];
  var hi1 = 0;
  var hr1 = 0;
  var hi = 0;
  var hr2;
  var hi2;
  while (--j2 >= 0) {
    hr2 = hr1;
    hi2 = hi1;
    hr1 = hr;
    hi1 = hi;
    hr = -hr2 + r2 * hr1 - i2 * hi1 + pp[j2];
    hi = -hi2 + i2 * hr1 + r2 * hi1;
  }
  r2 = sin_arg_r * cosh_arg_i;
  i2 = cos_arg_r * sinh_arg_i;
  return [r2 * hr - i2 * hi, r2 * hi + i2 * hr];
}
function init$s() {
  if (!this.approx && (isNaN(this.es) || this.es <= 0)) {
    throw new Error('Incorrect elliptical usage. Try using the +approx option in the proj string, or PROJECTION["Fast_Transverse_Mercator"] in the WKT.');
  }
  if (this.approx) {
    tmerc.init.apply(this);
    this.forward = tmerc.forward;
    this.inverse = tmerc.inverse;
  }
  this.x0 = this.x0 !== void 0 ? this.x0 : 0;
  this.y0 = this.y0 !== void 0 ? this.y0 : 0;
  this.long0 = this.long0 !== void 0 ? this.long0 : 0;
  this.lat0 = this.lat0 !== void 0 ? this.lat0 : 0;
  this.cgb = [];
  this.cbg = [];
  this.utg = [];
  this.gtu = [];
  var f2 = this.es / (1 + Math.sqrt(1 - this.es));
  var n2 = f2 / (2 - f2);
  var np = n2;
  this.cgb[0] = n2 * (2 + n2 * (-2 / 3 + n2 * (-2 + n2 * (116 / 45 + n2 * (26 / 45 + n2 * (-2854 / 675))))));
  this.cbg[0] = n2 * (-2 + n2 * (2 / 3 + n2 * (4 / 3 + n2 * (-82 / 45 + n2 * (32 / 45 + n2 * (4642 / 4725))))));
  np = np * n2;
  this.cgb[1] = np * (7 / 3 + n2 * (-8 / 5 + n2 * (-227 / 45 + n2 * (2704 / 315 + n2 * (2323 / 945)))));
  this.cbg[1] = np * (5 / 3 + n2 * (-16 / 15 + n2 * (-13 / 9 + n2 * (904 / 315 + n2 * (-1522 / 945)))));
  np = np * n2;
  this.cgb[2] = np * (56 / 15 + n2 * (-136 / 35 + n2 * (-1262 / 105 + n2 * (73814 / 2835))));
  this.cbg[2] = np * (-26 / 15 + n2 * (34 / 21 + n2 * (8 / 5 + n2 * (-12686 / 2835))));
  np = np * n2;
  this.cgb[3] = np * (4279 / 630 + n2 * (-332 / 35 + n2 * (-399572 / 14175)));
  this.cbg[3] = np * (1237 / 630 + n2 * (-12 / 5 + n2 * (-24832 / 14175)));
  np = np * n2;
  this.cgb[4] = np * (4174 / 315 + n2 * (-144838 / 6237));
  this.cbg[4] = np * (-734 / 315 + n2 * (109598 / 31185));
  np = np * n2;
  this.cgb[5] = np * (601676 / 22275);
  this.cbg[5] = np * (444337 / 155925);
  np = Math.pow(n2, 2);
  this.Qn = this.k0 / (1 + n2) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));
  this.utg[0] = n2 * (-0.5 + n2 * (2 / 3 + n2 * (-37 / 96 + n2 * (1 / 360 + n2 * (81 / 512 + n2 * (-96199 / 604800))))));
  this.gtu[0] = n2 * (0.5 + n2 * (-2 / 3 + n2 * (5 / 16 + n2 * (41 / 180 + n2 * (-127 / 288 + n2 * (7891 / 37800))))));
  this.utg[1] = np * (-1 / 48 + n2 * (-1 / 15 + n2 * (437 / 1440 + n2 * (-46 / 105 + n2 * (1118711 / 3870720)))));
  this.gtu[1] = np * (13 / 48 + n2 * (-3 / 5 + n2 * (557 / 1440 + n2 * (281 / 630 + n2 * (-1983433 / 1935360)))));
  np = np * n2;
  this.utg[2] = np * (-17 / 480 + n2 * (37 / 840 + n2 * (209 / 4480 + n2 * (-5569 / 90720))));
  this.gtu[2] = np * (61 / 240 + n2 * (-103 / 140 + n2 * (15061 / 26880 + n2 * (167603 / 181440))));
  np = np * n2;
  this.utg[3] = np * (-4397 / 161280 + n2 * (11 / 504 + n2 * (830251 / 7257600)));
  this.gtu[3] = np * (49561 / 161280 + n2 * (-179 / 168 + n2 * (6601661 / 7257600)));
  np = np * n2;
  this.utg[4] = np * (-4583 / 161280 + n2 * (108847 / 3991680));
  this.gtu[4] = np * (34729 / 80640 + n2 * (-3418889 / 1995840));
  np = np * n2;
  this.utg[5] = np * (-20648693 / 638668800);
  this.gtu[5] = np * (212378941 / 319334400);
  var Z2 = gatg(this.cbg, this.lat0);
  this.Zb = -this.Qn * (Z2 + clens(this.gtu, 2 * Z2));
}
function forward$r(p2) {
  var Ce = adjust_lon(p2.x - this.long0);
  var Cn = p2.y;
  Cn = gatg(this.cbg, Cn);
  var sin_Cn = Math.sin(Cn);
  var cos_Cn = Math.cos(Cn);
  var sin_Ce = Math.sin(Ce);
  var cos_Ce = Math.cos(Ce);
  Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
  Ce = Math.atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
  Ce = asinhy(Math.tan(Ce));
  var tmp2 = clens_cmplx(this.gtu, 2 * Cn, 2 * Ce);
  Cn = Cn + tmp2[0];
  Ce = Ce + tmp2[1];
  var x2;
  var y2;
  if (Math.abs(Ce) <= 2.623395162778) {
    x2 = this.a * (this.Qn * Ce) + this.x0;
    y2 = this.a * (this.Qn * Cn + this.Zb) + this.y0;
  } else {
    x2 = Infinity;
    y2 = Infinity;
  }
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$r(p2) {
  var Ce = (p2.x - this.x0) * (1 / this.a);
  var Cn = (p2.y - this.y0) * (1 / this.a);
  Cn = (Cn - this.Zb) / this.Qn;
  Ce = Ce / this.Qn;
  var lon;
  var lat;
  if (Math.abs(Ce) <= 2.623395162778) {
    var tmp2 = clens_cmplx(this.utg, 2 * Cn, 2 * Ce);
    Cn = Cn + tmp2[0];
    Ce = Ce + tmp2[1];
    Ce = Math.atan(sinh(Ce));
    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);
    Cn = Math.atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
    Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);
    lon = adjust_lon(Ce + this.long0);
    lat = gatg(this.cgb, Cn);
  } else {
    lon = Infinity;
    lat = Infinity;
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$t = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc", "Transverse_Mercator", "Transverse Mercator", "tmerc"];
const etmerc = {
  init: init$s,
  forward: forward$r,
  inverse: inverse$r,
  names: names$t
};
function adjust_zone(zone, lon) {
  if (zone === void 0) {
    zone = Math.floor((adjust_lon(lon) + Math.PI) * 30 / Math.PI) + 1;
    if (zone < 0) {
      return 0;
    } else if (zone > 60) {
      return 60;
    }
  }
  return zone;
}
var dependsOn = "etmerc";
function init$r() {
  var zone = adjust_zone(this.zone, this.long0);
  if (zone === void 0) {
    throw new Error("unknown utm zone");
  }
  this.lat0 = 0;
  this.long0 = (6 * Math.abs(zone) - 183) * D2R$1;
  this.x0 = 5e5;
  this.y0 = this.utmSouth ? 1e7 : 0;
  this.k0 = 0.9996;
  etmerc.init.apply(this);
  this.forward = etmerc.forward;
  this.inverse = etmerc.inverse;
}
var names$s = ["Universal Transverse Mercator System", "utm"];
const utm = {
  init: init$r,
  names: names$s,
  dependsOn
};
function srat(esinp, exp) {
  return Math.pow((1 - esinp) / (1 + esinp), exp);
}
var MAX_ITER$2 = 20;
function init$q() {
  var sphi = Math.sin(this.lat0);
  var cphi = Math.cos(this.lat0);
  cphi *= cphi;
  this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
  this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
  this.phic0 = Math.asin(sphi / this.C);
  this.ratexp = 0.5 * this.C * this.e;
  this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * sphi, this.ratexp));
}
function forward$q(p2) {
  var lon = p2.x;
  var lat = p2.y;
  p2.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + FORTPI), this.C) * srat(this.e * Math.sin(lat), this.ratexp)) - HALF_PI;
  p2.x = this.C * lon;
  return p2;
}
function inverse$q(p2) {
  var DEL_TOL = 1e-14;
  var lon = p2.x / this.C;
  var lat = p2.y;
  var num = Math.pow(Math.tan(0.5 * lat + FORTPI) / this.K, 1 / this.C);
  for (var i2 = MAX_ITER$2; i2 > 0; --i2) {
    lat = 2 * Math.atan(num * srat(this.e * Math.sin(p2.y), -0.5 * this.e)) - HALF_PI;
    if (Math.abs(lat - p2.y) < DEL_TOL) {
      break;
    }
    p2.y = lat;
  }
  if (!i2) {
    return null;
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$r = ["gauss"];
const gauss = {
  init: init$q,
  forward: forward$q,
  inverse: inverse$q,
  names: names$r
};
function init$p() {
  gauss.init.apply(this);
  if (!this.rc) {
    return;
  }
  this.sinc0 = Math.sin(this.phic0);
  this.cosc0 = Math.cos(this.phic0);
  this.R2 = 2 * this.rc;
  if (!this.title) {
    this.title = "Oblique Stereographic Alternative";
  }
}
function forward$p(p2) {
  var sinc, cosc, cosl, k2;
  p2.x = adjust_lon(p2.x - this.long0);
  gauss.forward.apply(this, [p2]);
  sinc = Math.sin(p2.y);
  cosc = Math.cos(p2.y);
  cosl = Math.cos(p2.x);
  k2 = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
  p2.x = k2 * cosc * Math.sin(p2.x);
  p2.y = k2 * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
  p2.x = this.a * p2.x + this.x0;
  p2.y = this.a * p2.y + this.y0;
  return p2;
}
function inverse$p(p2) {
  var sinc, cosc, lon, lat, rho;
  p2.x = (p2.x - this.x0) / this.a;
  p2.y = (p2.y - this.y0) / this.a;
  p2.x /= this.k0;
  p2.y /= this.k0;
  if (rho = Math.sqrt(p2.x * p2.x + p2.y * p2.y)) {
    var c2 = 2 * Math.atan2(rho, this.R2);
    sinc = Math.sin(c2);
    cosc = Math.cos(c2);
    lat = Math.asin(cosc * this.sinc0 + p2.y * sinc * this.cosc0 / rho);
    lon = Math.atan2(p2.x * sinc, rho * this.cosc0 * cosc - p2.y * this.sinc0 * sinc);
  } else {
    lat = this.phic0;
    lon = 0;
  }
  p2.x = lon;
  p2.y = lat;
  gauss.inverse.apply(this, [p2]);
  p2.x = adjust_lon(p2.x + this.long0);
  return p2;
}
var names$q = ["Stereographic_North_Pole", "Oblique_Stereographic", "sterea", "Oblique Stereographic Alternative", "Double_Stereographic"];
const sterea = {
  init: init$p,
  forward: forward$p,
  inverse: inverse$p,
  names: names$q
};
function ssfn_(phit, sinphi, eccen) {
  sinphi *= eccen;
  return Math.tan(0.5 * (HALF_PI + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen);
}
function init$o() {
  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  this.lat0 = this.lat0 || 0;
  this.long0 = this.long0 || 0;
  this.coslat0 = Math.cos(this.lat0);
  this.sinlat0 = Math.sin(this.lat0);
  if (this.sphere) {
    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
      this.k0 = 0.5 * (1 + sign$1(this.lat0) * Math.sin(this.lat_ts));
    }
  } else {
    if (Math.abs(this.coslat0) <= EPSLN) {
      if (this.lat0 > 0) {
        this.con = 1;
      } else {
        this.con = -1;
      }
    }
    this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN && Math.abs(Math.cos(this.lat_ts)) > EPSLN) {
      this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
    }
    this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0);
    this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI;
    this.cosX0 = Math.cos(this.X0);
    this.sinX0 = Math.sin(this.X0);
  }
}
function forward$o(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var sinlat = Math.sin(lat);
  var coslat = Math.cos(lat);
  var A2, X2, sinX, cosX, ts, rh;
  var dlon = adjust_lon(lon - this.long0);
  if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= EPSLN && Math.abs(lat + this.lat0) <= EPSLN) {
    p2.x = NaN;
    p2.y = NaN;
    return p2;
  }
  if (this.sphere) {
    A2 = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
    p2.x = this.a * A2 * coslat * Math.sin(dlon) + this.x0;
    p2.y = this.a * A2 * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
    return p2;
  } else {
    X2 = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - HALF_PI;
    cosX = Math.cos(X2);
    sinX = Math.sin(X2);
    if (Math.abs(this.coslat0) <= EPSLN) {
      ts = tsfnz(this.e, lat * this.con, this.con * sinlat);
      rh = 2 * this.a * this.k0 * ts / this.cons;
      p2.x = this.x0 + rh * Math.sin(lon - this.long0);
      p2.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
      return p2;
    } else if (Math.abs(this.sinlat0) < EPSLN) {
      A2 = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
      p2.y = A2 * sinX;
    } else {
      A2 = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
      p2.y = A2 * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
    }
    p2.x = A2 * cosX * Math.sin(dlon) + this.x0;
  }
  return p2;
}
function inverse$o(p2) {
  p2.x -= this.x0;
  p2.y -= this.y0;
  var lon, lat, ts, ce2, Chi;
  var rh = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
  if (this.sphere) {
    var c2 = 2 * Math.atan(rh / (2 * this.a * this.k0));
    lon = this.long0;
    lat = this.lat0;
    if (rh <= EPSLN) {
      p2.x = lon;
      p2.y = lat;
      return p2;
    }
    lat = Math.asin(Math.cos(c2) * this.sinlat0 + p2.y * Math.sin(c2) * this.coslat0 / rh);
    if (Math.abs(this.coslat0) < EPSLN) {
      if (this.lat0 > 0) {
        lon = adjust_lon(this.long0 + Math.atan2(p2.x, -1 * p2.y));
      } else {
        lon = adjust_lon(this.long0 + Math.atan2(p2.x, p2.y));
      }
    } else {
      lon = adjust_lon(this.long0 + Math.atan2(p2.x * Math.sin(c2), rh * this.coslat0 * Math.cos(c2) - p2.y * this.sinlat0 * Math.sin(c2)));
    }
    p2.x = lon;
    p2.y = lat;
    return p2;
  } else {
    if (Math.abs(this.coslat0) <= EPSLN) {
      if (rh <= EPSLN) {
        lat = this.lat0;
        lon = this.long0;
        p2.x = lon;
        p2.y = lat;
        return p2;
      }
      p2.x *= this.con;
      p2.y *= this.con;
      ts = rh * this.cons / (2 * this.a * this.k0);
      lat = this.con * phi2z(this.e, ts);
      lon = this.con * adjust_lon(this.con * this.long0 + Math.atan2(p2.x, -1 * p2.y));
    } else {
      ce2 = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
      lon = this.long0;
      if (rh <= EPSLN) {
        Chi = this.X0;
      } else {
        Chi = Math.asin(Math.cos(ce2) * this.sinX0 + p2.y * Math.sin(ce2) * this.cosX0 / rh);
        lon = adjust_lon(this.long0 + Math.atan2(p2.x * Math.sin(ce2), rh * this.cosX0 * Math.cos(ce2) - p2.y * this.sinX0 * Math.sin(ce2)));
      }
      lat = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + Chi)));
    }
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$p = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)", "Polar_Stereographic"];
const stere = {
  init: init$o,
  forward: forward$o,
  inverse: inverse$o,
  names: names$p,
  ssfn_
};
function init$n() {
  var phy0 = this.lat0;
  this.lambda0 = this.long0;
  var sinPhy0 = Math.sin(phy0);
  var semiMajorAxis = this.a;
  var invF = this.rf;
  var flattening = 1 / invF;
  var e22 = 2 * flattening - Math.pow(flattening, 2);
  var e3 = this.e = Math.sqrt(e22);
  this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e22) / (1 - e22 * Math.pow(sinPhy0, 2));
  this.alpha = Math.sqrt(1 + e22 / (1 - e22) * Math.pow(Math.cos(phy0), 4));
  this.b0 = Math.asin(sinPhy0 / this.alpha);
  var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
  var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
  var k3 = Math.log((1 + e3 * sinPhy0) / (1 - e3 * sinPhy0));
  this.K = k1 - this.alpha * k2 + this.alpha * e3 / 2 * k3;
}
function forward$n(p2) {
  var Sa1 = Math.log(Math.tan(Math.PI / 4 - p2.y / 2));
  var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p2.y)) / (1 - this.e * Math.sin(p2.y)));
  var S2 = -this.alpha * (Sa1 + Sa2) + this.K;
  var b2 = 2 * (Math.atan(Math.exp(S2)) - Math.PI / 4);
  var I2 = this.alpha * (p2.x - this.lambda0);
  var rotI = Math.atan(Math.sin(I2) / (Math.sin(this.b0) * Math.tan(b2) + Math.cos(this.b0) * Math.cos(I2)));
  var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b2) - Math.sin(this.b0) * Math.cos(b2) * Math.cos(I2));
  p2.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
  p2.x = this.R * rotI + this.x0;
  return p2;
}
function inverse$n(p2) {
  var Y2 = p2.x - this.x0;
  var X2 = p2.y - this.y0;
  var rotI = Y2 / this.R;
  var rotB = 2 * (Math.atan(Math.exp(X2 / this.R)) - Math.PI / 4);
  var b2 = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
  var I2 = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));
  var lambda = this.lambda0 + I2 / this.alpha;
  var S2 = 0;
  var phy = b2;
  var prevPhy = -1e3;
  var iteration = 0;
  while (Math.abs(phy - prevPhy) > 1e-7) {
    if (++iteration > 20) {
      return;
    }
    S2 = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b2 / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
    prevPhy = phy;
    phy = 2 * Math.atan(Math.exp(S2)) - Math.PI / 2;
  }
  p2.x = lambda;
  p2.y = phy;
  return p2;
}
var names$o = ["somerc"];
const somerc = {
  init: init$n,
  forward: forward$n,
  inverse: inverse$n,
  names: names$o
};
var TOL = 1e-7;
function isTypeA(P2) {
  var typeAProjections = ["Hotine_Oblique_Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin"];
  var projectionName = typeof P2.PROJECTION === "object" ? Object.keys(P2.PROJECTION)[0] : P2.PROJECTION;
  return "no_uoff" in P2 || "no_off" in P2 || typeAProjections.indexOf(projectionName) !== -1;
}
function init$m() {
  var con, com, cosph0, D2, F2, H2, L2, sinph0, p2, J2, gamma = 0, gamma0, lamc = 0, lam1 = 0, lam2 = 0, phi1 = 0, phi2 = 0, alpha_c = 0;
  this.no_off = isTypeA(this);
  this.no_rot = "no_rot" in this;
  var alp = false;
  if ("alpha" in this) {
    alp = true;
  }
  var gam = false;
  if ("rectified_grid_angle" in this) {
    gam = true;
  }
  if (alp) {
    alpha_c = this.alpha;
  }
  if (gam) {
    gamma = this.rectified_grid_angle * D2R$1;
  }
  if (alp || gam) {
    lamc = this.longc;
  } else {
    lam1 = this.long1;
    phi1 = this.lat1;
    lam2 = this.long2;
    phi2 = this.lat2;
    if (Math.abs(phi1 - phi2) <= TOL || (con = Math.abs(phi1)) <= TOL || Math.abs(con - HALF_PI) <= TOL || Math.abs(Math.abs(this.lat0) - HALF_PI) <= TOL || Math.abs(Math.abs(phi2) - HALF_PI) <= TOL) {
      throw new Error();
    }
  }
  var one_es = 1 - this.es;
  com = Math.sqrt(one_es);
  if (Math.abs(this.lat0) > EPSLN) {
    sinph0 = Math.sin(this.lat0);
    cosph0 = Math.cos(this.lat0);
    con = 1 - this.es * sinph0 * sinph0;
    this.B = cosph0 * cosph0;
    this.B = Math.sqrt(1 + this.es * this.B * this.B / one_es);
    this.A = this.B * this.k0 * com / con;
    D2 = this.B * com / (cosph0 * Math.sqrt(con));
    F2 = D2 * D2 - 1;
    if (F2 <= 0) {
      F2 = 0;
    } else {
      F2 = Math.sqrt(F2);
      if (this.lat0 < 0) {
        F2 = -F2;
      }
    }
    this.E = F2 += D2;
    this.E *= Math.pow(tsfnz(this.e, this.lat0, sinph0), this.B);
  } else {
    this.B = 1 / com;
    this.A = this.k0;
    this.E = D2 = F2 = 1;
  }
  if (alp || gam) {
    if (alp) {
      gamma0 = Math.asin(Math.sin(alpha_c) / D2);
      if (!gam) {
        gamma = alpha_c;
      }
    } else {
      gamma0 = gamma;
      alpha_c = Math.asin(D2 * Math.sin(gamma0));
    }
    this.lam0 = lamc - Math.asin(0.5 * (F2 - 1 / F2) * Math.tan(gamma0)) / this.B;
  } else {
    H2 = Math.pow(tsfnz(this.e, phi1, Math.sin(phi1)), this.B);
    L2 = Math.pow(tsfnz(this.e, phi2, Math.sin(phi2)), this.B);
    F2 = this.E / H2;
    p2 = (L2 - H2) / (L2 + H2);
    J2 = this.E * this.E;
    J2 = (J2 - L2 * H2) / (J2 + L2 * H2);
    con = lam1 - lam2;
    if (con < -Math.pi) {
      lam2 -= TWO_PI;
    } else if (con > Math.pi) {
      lam2 += TWO_PI;
    }
    this.lam0 = adjust_lon(0.5 * (lam1 + lam2) - Math.atan(J2 * Math.tan(0.5 * this.B * (lam1 - lam2)) / p2) / this.B);
    gamma0 = Math.atan(2 * Math.sin(this.B * adjust_lon(lam1 - this.lam0)) / (F2 - 1 / F2));
    gamma = alpha_c = Math.asin(D2 * Math.sin(gamma0));
  }
  this.singam = Math.sin(gamma0);
  this.cosgam = Math.cos(gamma0);
  this.sinrot = Math.sin(gamma);
  this.cosrot = Math.cos(gamma);
  this.rB = 1 / this.B;
  this.ArB = this.A * this.rB;
  this.BrA = 1 / this.ArB;
  this.A * this.B;
  if (this.no_off) {
    this.u_0 = 0;
  } else {
    this.u_0 = Math.abs(this.ArB * Math.atan(Math.sqrt(D2 * D2 - 1) / Math.cos(alpha_c)));
    if (this.lat0 < 0) {
      this.u_0 = -this.u_0;
    }
  }
  F2 = 0.5 * gamma0;
  this.v_pole_n = this.ArB * Math.log(Math.tan(FORTPI - F2));
  this.v_pole_s = this.ArB * Math.log(Math.tan(FORTPI + F2));
}
function forward$m(p2) {
  var coords = {};
  var S2, T2, U2, V2, W2, temp2, u2, v5;
  p2.x = p2.x - this.lam0;
  if (Math.abs(Math.abs(p2.y) - HALF_PI) > EPSLN) {
    W2 = this.E / Math.pow(tsfnz(this.e, p2.y, Math.sin(p2.y)), this.B);
    temp2 = 1 / W2;
    S2 = 0.5 * (W2 - temp2);
    T2 = 0.5 * (W2 + temp2);
    V2 = Math.sin(this.B * p2.x);
    U2 = (S2 * this.singam - V2 * this.cosgam) / T2;
    if (Math.abs(Math.abs(U2) - 1) < EPSLN) {
      throw new Error();
    }
    v5 = 0.5 * this.ArB * Math.log((1 - U2) / (1 + U2));
    temp2 = Math.cos(this.B * p2.x);
    if (Math.abs(temp2) < TOL) {
      u2 = this.A * p2.x;
    } else {
      u2 = this.ArB * Math.atan2(S2 * this.cosgam + V2 * this.singam, temp2);
    }
  } else {
    v5 = p2.y > 0 ? this.v_pole_n : this.v_pole_s;
    u2 = this.ArB * p2.y;
  }
  if (this.no_rot) {
    coords.x = u2;
    coords.y = v5;
  } else {
    u2 -= this.u_0;
    coords.x = v5 * this.cosrot + u2 * this.sinrot;
    coords.y = u2 * this.cosrot - v5 * this.sinrot;
  }
  coords.x = this.a * coords.x + this.x0;
  coords.y = this.a * coords.y + this.y0;
  return coords;
}
function inverse$m(p2) {
  var u2, v5, Qp, Sp, Tp, Vp, Up;
  var coords = {};
  p2.x = (p2.x - this.x0) * (1 / this.a);
  p2.y = (p2.y - this.y0) * (1 / this.a);
  if (this.no_rot) {
    v5 = p2.y;
    u2 = p2.x;
  } else {
    v5 = p2.x * this.cosrot - p2.y * this.sinrot;
    u2 = p2.y * this.cosrot + p2.x * this.sinrot + this.u_0;
  }
  Qp = Math.exp(-this.BrA * v5);
  Sp = 0.5 * (Qp - 1 / Qp);
  Tp = 0.5 * (Qp + 1 / Qp);
  Vp = Math.sin(this.BrA * u2);
  Up = (Vp * this.cosgam + Sp * this.singam) / Tp;
  if (Math.abs(Math.abs(Up) - 1) < EPSLN) {
    coords.x = 0;
    coords.y = Up < 0 ? -HALF_PI : HALF_PI;
  } else {
    coords.y = this.E / Math.sqrt((1 + Up) / (1 - Up));
    coords.y = phi2z(this.e, Math.pow(coords.y, 1 / this.B));
    if (coords.y === Infinity) {
      throw new Error();
    }
    coords.x = -this.rB * Math.atan2(Sp * this.cosgam - Vp * this.singam, Math.cos(this.BrA * u2));
  }
  coords.x += this.lam0;
  return coords;
}
var names$n = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Two_Point_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "Oblique_Mercator", "omerc"];
const omerc = {
  init: init$m,
  forward: forward$m,
  inverse: inverse$m,
  names: names$n
};
function init$l() {
  if (!this.lat2) {
    this.lat2 = this.lat1;
  }
  if (!this.k0) {
    this.k0 = 1;
  }
  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
    return;
  }
  var temp2 = this.b / this.a;
  this.e = Math.sqrt(1 - temp2 * temp2);
  var sin1 = Math.sin(this.lat1);
  var cos1 = Math.cos(this.lat1);
  var ms1 = msfnz(this.e, sin1, cos1);
  var ts1 = tsfnz(this.e, this.lat1, sin1);
  var sin2 = Math.sin(this.lat2);
  var cos2 = Math.cos(this.lat2);
  var ms2 = msfnz(this.e, sin2, cos2);
  var ts2 = tsfnz(this.e, this.lat2, sin2);
  var ts0 = tsfnz(this.e, this.lat0, Math.sin(this.lat0));
  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
    this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
  } else {
    this.ns = sin1;
  }
  if (isNaN(this.ns)) {
    this.ns = sin1;
  }
  this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
  this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
  if (!this.title) {
    this.title = "Lambert Conformal Conic";
  }
}
function forward$l(p2) {
  var lon = p2.x;
  var lat = p2.y;
  if (Math.abs(2 * Math.abs(lat) - Math.PI) <= EPSLN) {
    lat = sign$1(lat) * (HALF_PI - 2 * EPSLN);
  }
  var con = Math.abs(Math.abs(lat) - HALF_PI);
  var ts, rh1;
  if (con > EPSLN) {
    ts = tsfnz(this.e, lat, Math.sin(lat));
    rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
  } else {
    con = lat * this.ns;
    if (con <= 0) {
      return null;
    }
    rh1 = 0;
  }
  var theta = this.ns * adjust_lon(lon - this.long0);
  p2.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
  p2.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;
  return p2;
}
function inverse$l(p2) {
  var rh1, con, ts;
  var lat, lon;
  var x2 = (p2.x - this.x0) / this.k0;
  var y2 = this.rh - (p2.y - this.y0) / this.k0;
  if (this.ns > 0) {
    rh1 = Math.sqrt(x2 * x2 + y2 * y2);
    con = 1;
  } else {
    rh1 = -Math.sqrt(x2 * x2 + y2 * y2);
    con = -1;
  }
  var theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2(con * x2, con * y2);
  }
  if (rh1 !== 0 || this.ns > 0) {
    con = 1 / this.ns;
    ts = Math.pow(rh1 / (this.a * this.f0), con);
    lat = phi2z(this.e, ts);
    if (lat === -9999) {
      return null;
    }
  } else {
    lat = -HALF_PI;
  }
  lon = adjust_lon(theta / this.ns + this.long0);
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$m = [
  "Lambert Tangential Conformal Conic Projection",
  "Lambert_Conformal_Conic",
  "Lambert_Conformal_Conic_1SP",
  "Lambert_Conformal_Conic_2SP",
  "lcc",
  "Lambert Conic Conformal (1SP)",
  "Lambert Conic Conformal (2SP)"
];
const lcc = {
  init: init$l,
  forward: forward$l,
  inverse: inverse$l,
  names: names$m
};
function init$k() {
  this.a = 6377397155e-3;
  this.es = 0.006674372230614;
  this.e = Math.sqrt(this.es);
  if (!this.lat0) {
    this.lat0 = 0.863937979737193;
  }
  if (!this.long0) {
    this.long0 = 0.7417649320975901 - 0.308341501185665;
  }
  if (!this.k0) {
    this.k0 = 0.9999;
  }
  this.s45 = 0.785398163397448;
  this.s90 = 2 * this.s45;
  this.fi0 = this.lat0;
  this.e2 = this.es;
  this.e = Math.sqrt(this.e2);
  this.alfa = Math.sqrt(1 + this.e2 * Math.pow(Math.cos(this.fi0), 4) / (1 - this.e2));
  this.uq = 1.04216856380474;
  this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
  this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
  this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
  this.k1 = this.k0;
  this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
  this.s0 = 1.37008346281555;
  this.n = Math.sin(this.s0);
  this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
  this.ad = this.s90 - this.uq;
}
function forward$k(p2) {
  var gfi, u2, deltav, s2, d2, eps, ro;
  var lon = p2.x;
  var lat = p2.y;
  var delta_lon = adjust_lon(lon - this.long0);
  gfi = Math.pow((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat)), this.alfa * this.e / 2);
  u2 = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
  deltav = -delta_lon * this.alfa;
  s2 = Math.asin(Math.cos(this.ad) * Math.sin(u2) + Math.sin(this.ad) * Math.cos(u2) * Math.cos(deltav));
  d2 = Math.asin(Math.cos(u2) * Math.sin(deltav) / Math.cos(s2));
  eps = this.n * d2;
  ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s2 / 2 + this.s45), this.n);
  p2.y = ro * Math.cos(eps) / 1;
  p2.x = ro * Math.sin(eps) / 1;
  if (!this.czech) {
    p2.y *= -1;
    p2.x *= -1;
  }
  return p2;
}
function inverse$k(p2) {
  var u2, deltav, s2, d2, eps, ro, fi1;
  var ok;
  var tmp2 = p2.x;
  p2.x = p2.y;
  p2.y = tmp2;
  if (!this.czech) {
    p2.y *= -1;
    p2.x *= -1;
  }
  ro = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
  eps = Math.atan2(p2.y, p2.x);
  d2 = eps / Math.sin(this.s0);
  s2 = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
  u2 = Math.asin(Math.cos(this.ad) * Math.sin(s2) - Math.sin(this.ad) * Math.cos(s2) * Math.cos(d2));
  deltav = Math.asin(Math.cos(s2) * Math.sin(d2) / Math.cos(u2));
  p2.x = this.long0 - deltav / this.alfa;
  fi1 = u2;
  ok = 0;
  var iter = 0;
  do {
    p2.y = 2 * (Math.atan(Math.pow(this.k, -1 / this.alfa) * Math.pow(Math.tan(u2 / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
    if (Math.abs(fi1 - p2.y) < 1e-10) {
      ok = 1;
    }
    fi1 = p2.y;
    iter += 1;
  } while (ok === 0 && iter < 15);
  if (iter >= 15) {
    return null;
  }
  return p2;
}
var names$l = ["Krovak", "krovak"];
const krovak = {
  init: init$k,
  forward: forward$k,
  inverse: inverse$k,
  names: names$l
};
function mlfn(e0, e1, e22, e3, phi) {
  return e0 * phi - e1 * Math.sin(2 * phi) + e22 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi);
}
function e0fn(x2) {
  return 1 - 0.25 * x2 * (1 + x2 / 16 * (3 + 1.25 * x2));
}
function e1fn(x2) {
  return 0.375 * x2 * (1 + 0.25 * x2 * (1 + 0.46875 * x2));
}
function e2fn(x2) {
  return 0.05859375 * x2 * x2 * (1 + 0.75 * x2);
}
function e3fn(x2) {
  return x2 * x2 * x2 * (35 / 3072);
}
function gN(a2, e3, sinphi) {
  var temp2 = e3 * sinphi;
  return a2 / Math.sqrt(1 - temp2 * temp2);
}
function adjust_lat(x2) {
  return Math.abs(x2) < HALF_PI ? x2 : x2 - sign$1(x2) * Math.PI;
}
function imlfn(ml, e0, e1, e22, e3) {
  var phi;
  var dphi;
  phi = ml / e0;
  for (var i2 = 0; i2 < 15; i2++) {
    dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e22 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e22 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
    phi += dphi;
    if (Math.abs(dphi) <= 1e-10) {
      return phi;
    }
  }
  return NaN;
}
function init$j() {
  if (!this.sphere) {
    this.e0 = e0fn(this.es);
    this.e1 = e1fn(this.es);
    this.e2 = e2fn(this.es);
    this.e3 = e3fn(this.es);
    this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
  }
}
function forward$j(p2) {
  var x2, y2;
  var lam = p2.x;
  var phi = p2.y;
  lam = adjust_lon(lam - this.long0);
  if (this.sphere) {
    x2 = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
    y2 = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
  } else {
    var sinphi = Math.sin(phi);
    var cosphi = Math.cos(phi);
    var nl = gN(this.a, this.e, sinphi);
    var tl = Math.tan(phi) * Math.tan(phi);
    var al2 = lam * Math.cos(phi);
    var asq = al2 * al2;
    var cl = this.es * cosphi * cosphi / (1 - this.es);
    var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
    x2 = nl * al2 * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
    y2 = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);
  }
  p2.x = x2 + this.x0;
  p2.y = y2 + this.y0;
  return p2;
}
function inverse$j(p2) {
  p2.x -= this.x0;
  p2.y -= this.y0;
  var x2 = p2.x / this.a;
  var y2 = p2.y / this.a;
  var phi, lam;
  if (this.sphere) {
    var dd = y2 + this.lat0;
    phi = Math.asin(Math.sin(dd) * Math.cos(x2));
    lam = Math.atan2(Math.tan(x2), Math.cos(dd));
  } else {
    var ml1 = this.ml0 / this.a + y2;
    var phi1 = imlfn(ml1, this.e0, this.e1, this.e2, this.e3);
    if (Math.abs(Math.abs(phi1) - HALF_PI) <= EPSLN) {
      p2.x = this.long0;
      p2.y = HALF_PI;
      if (y2 < 0) {
        p2.y *= -1;
      }
      return p2;
    }
    var nl1 = gN(this.a, this.e, Math.sin(phi1));
    var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
    var tl1 = Math.pow(Math.tan(phi1), 2);
    var dl = x2 * this.a / nl1;
    var dsq = dl * dl;
    phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
    lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);
  }
  p2.x = adjust_lon(lam + this.long0);
  p2.y = adjust_lat(phi);
  return p2;
}
var names$k = ["Cassini", "Cassini_Soldner", "cass"];
const cass = {
  init: init$j,
  forward: forward$j,
  inverse: inverse$j,
  names: names$k
};
function qsfnz(eccent, sinphi) {
  var con;
  if (eccent > 1e-7) {
    con = eccent * sinphi;
    return (1 - eccent * eccent) * (sinphi / (1 - con * con) - 0.5 / eccent * Math.log((1 - con) / (1 + con)));
  } else {
    return 2 * sinphi;
  }
}
var S_POLE = 1;
var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;
function init$i() {
  var t2 = Math.abs(this.lat0);
  if (Math.abs(t2 - HALF_PI) < EPSLN) {
    this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
  } else if (Math.abs(t2) < EPSLN) {
    this.mode = this.EQUIT;
  } else {
    this.mode = this.OBLIQ;
  }
  if (this.es > 0) {
    var sinphi;
    this.qp = qsfnz(this.e, 1);
    this.mmf = 0.5 / (1 - this.es);
    this.apa = authset(this.es);
    switch (this.mode) {
      case this.N_POLE:
        this.dd = 1;
        break;
      case this.S_POLE:
        this.dd = 1;
        break;
      case this.EQUIT:
        this.rq = Math.sqrt(0.5 * this.qp);
        this.dd = 1 / this.rq;
        this.xmf = 1;
        this.ymf = 0.5 * this.qp;
        break;
      case this.OBLIQ:
        this.rq = Math.sqrt(0.5 * this.qp);
        sinphi = Math.sin(this.lat0);
        this.sinb1 = qsfnz(this.e, sinphi) / this.qp;
        this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
        this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
        this.ymf = (this.xmf = this.rq) / this.dd;
        this.xmf *= this.dd;
        break;
    }
  } else {
    if (this.mode === this.OBLIQ) {
      this.sinph0 = Math.sin(this.lat0);
      this.cosph0 = Math.cos(this.lat0);
    }
  }
}
function forward$i(p2) {
  var x2, y2, coslam, sinlam, sinphi, q2, sinb, cosb, b2, cosphi;
  var lam = p2.x;
  var phi = p2.y;
  lam = adjust_lon(lam - this.long0);
  if (this.sphere) {
    sinphi = Math.sin(phi);
    cosphi = Math.cos(phi);
    coslam = Math.cos(lam);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      y2 = this.mode === this.EQUIT ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
      if (y2 <= EPSLN) {
        return null;
      }
      y2 = Math.sqrt(2 / y2);
      x2 = y2 * cosphi * Math.sin(lam);
      y2 *= this.mode === this.EQUIT ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
    } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE) {
        coslam = -coslam;
      }
      if (Math.abs(phi + this.lat0) < EPSLN) {
        return null;
      }
      y2 = FORTPI - phi * 0.5;
      y2 = 2 * (this.mode === this.S_POLE ? Math.cos(y2) : Math.sin(y2));
      x2 = y2 * Math.sin(lam);
      y2 *= coslam;
    }
  } else {
    sinb = 0;
    cosb = 0;
    b2 = 0;
    coslam = Math.cos(lam);
    sinlam = Math.sin(lam);
    sinphi = Math.sin(phi);
    q2 = qsfnz(this.e, sinphi);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      sinb = q2 / this.qp;
      cosb = Math.sqrt(1 - sinb * sinb);
    }
    switch (this.mode) {
      case this.OBLIQ:
        b2 = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
        break;
      case this.EQUIT:
        b2 = 1 + cosb * coslam;
        break;
      case this.N_POLE:
        b2 = HALF_PI + phi;
        q2 = this.qp - q2;
        break;
      case this.S_POLE:
        b2 = phi - HALF_PI;
        q2 = this.qp + q2;
        break;
    }
    if (Math.abs(b2) < EPSLN) {
      return null;
    }
    switch (this.mode) {
      case this.OBLIQ:
      case this.EQUIT:
        b2 = Math.sqrt(2 / b2);
        if (this.mode === this.OBLIQ) {
          y2 = this.ymf * b2 * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
        } else {
          y2 = (b2 = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
        }
        x2 = this.xmf * b2 * cosb * sinlam;
        break;
      case this.N_POLE:
      case this.S_POLE:
        if (q2 >= 0) {
          x2 = (b2 = Math.sqrt(q2)) * sinlam;
          y2 = coslam * (this.mode === this.S_POLE ? b2 : -b2);
        } else {
          x2 = y2 = 0;
        }
        break;
    }
  }
  p2.x = this.a * x2 + this.x0;
  p2.y = this.a * y2 + this.y0;
  return p2;
}
function inverse$i(p2) {
  p2.x -= this.x0;
  p2.y -= this.y0;
  var x2 = p2.x / this.a;
  var y2 = p2.y / this.a;
  var lam, phi, cCe, sCe, q2, rho, ab2;
  if (this.sphere) {
    var cosz = 0, rh, sinz = 0;
    rh = Math.sqrt(x2 * x2 + y2 * y2);
    phi = rh * 0.5;
    if (phi > 1) {
      return null;
    }
    phi = 2 * Math.asin(phi);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      sinz = Math.sin(phi);
      cosz = Math.cos(phi);
    }
    switch (this.mode) {
      case this.EQUIT:
        phi = Math.abs(rh) <= EPSLN ? 0 : Math.asin(y2 * sinz / rh);
        x2 *= sinz;
        y2 = cosz * rh;
        break;
      case this.OBLIQ:
        phi = Math.abs(rh) <= EPSLN ? this.lat0 : Math.asin(cosz * this.sinph0 + y2 * sinz * this.cosph0 / rh);
        x2 *= sinz * this.cosph0;
        y2 = (cosz - Math.sin(phi) * this.sinph0) * rh;
        break;
      case this.N_POLE:
        y2 = -y2;
        phi = HALF_PI - phi;
        break;
      case this.S_POLE:
        phi -= HALF_PI;
        break;
    }
    lam = y2 === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ) ? 0 : Math.atan2(x2, y2);
  } else {
    ab2 = 0;
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      x2 /= this.dd;
      y2 *= this.dd;
      rho = Math.sqrt(x2 * x2 + y2 * y2);
      if (rho < EPSLN) {
        p2.x = this.long0;
        p2.y = this.lat0;
        return p2;
      }
      sCe = 2 * Math.asin(0.5 * rho / this.rq);
      cCe = Math.cos(sCe);
      x2 *= sCe = Math.sin(sCe);
      if (this.mode === this.OBLIQ) {
        ab2 = cCe * this.sinb1 + y2 * sCe * this.cosb1 / rho;
        q2 = this.qp * ab2;
        y2 = rho * this.cosb1 * cCe - y2 * this.sinb1 * sCe;
      } else {
        ab2 = y2 * sCe / rho;
        q2 = this.qp * ab2;
        y2 = rho * cCe;
      }
    } else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE) {
        y2 = -y2;
      }
      q2 = x2 * x2 + y2 * y2;
      if (!q2) {
        p2.x = this.long0;
        p2.y = this.lat0;
        return p2;
      }
      ab2 = 1 - q2 / this.qp;
      if (this.mode === this.S_POLE) {
        ab2 = -ab2;
      }
    }
    lam = Math.atan2(x2, y2);
    phi = authlat(Math.asin(ab2), this.apa);
  }
  p2.x = adjust_lon(this.long0 + lam);
  p2.y = phi;
  return p2;
}
var P00 = 0.3333333333333333;
var P01 = 0.17222222222222222;
var P02 = 0.10257936507936508;
var P10 = 0.06388888888888888;
var P11 = 0.0664021164021164;
var P20 = 0.016415012942191543;
function authset(es2) {
  var t2;
  var APA = [];
  APA[0] = es2 * P00;
  t2 = es2 * es2;
  APA[0] += t2 * P01;
  APA[1] = t2 * P10;
  t2 *= es2;
  APA[0] += t2 * P02;
  APA[1] += t2 * P11;
  APA[2] = t2 * P20;
  return APA;
}
function authlat(beta, APA) {
  var t2 = beta + beta;
  return beta + APA[0] * Math.sin(t2) + APA[1] * Math.sin(t2 + t2) + APA[2] * Math.sin(t2 + t2 + t2);
}
var names$j = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
const laea = {
  init: init$i,
  forward: forward$i,
  inverse: inverse$i,
  names: names$j,
  S_POLE,
  N_POLE,
  EQUIT,
  OBLIQ
};
function asinz(x2) {
  if (Math.abs(x2) > 1) {
    x2 = x2 > 1 ? 1 : -1;
  }
  return Math.asin(x2);
}
function init$h() {
  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
    return;
  }
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2);
  this.e3 = Math.sqrt(this.es);
  this.sin_po = Math.sin(this.lat1);
  this.cos_po = Math.cos(this.lat1);
  this.t1 = this.sin_po;
  this.con = this.sin_po;
  this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po);
  this.qs1 = qsfnz(this.e3, this.sin_po);
  this.sin_po = Math.sin(this.lat2);
  this.cos_po = Math.cos(this.lat2);
  this.t2 = this.sin_po;
  this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po);
  this.qs2 = qsfnz(this.e3, this.sin_po);
  this.sin_po = Math.sin(this.lat0);
  this.cos_po = Math.cos(this.lat0);
  this.t3 = this.sin_po;
  this.qs0 = qsfnz(this.e3, this.sin_po);
  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
    this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
  } else {
    this.ns0 = this.con;
  }
  this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
  this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}
function forward$h(p2) {
  var lon = p2.x;
  var lat = p2.y;
  this.sin_phi = Math.sin(lat);
  this.cos_phi = Math.cos(lat);
  var qs = qsfnz(this.e3, this.sin_phi);
  var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
  var theta = this.ns0 * adjust_lon(lon - this.long0);
  var x2 = rh1 * Math.sin(theta) + this.x0;
  var y2 = this.rh - rh1 * Math.cos(theta) + this.y0;
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$h(p2) {
  var rh1, qs, con, theta, lon, lat;
  p2.x -= this.x0;
  p2.y = this.rh - p2.y + this.y0;
  if (this.ns0 >= 0) {
    rh1 = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
    con = 1;
  } else {
    rh1 = -Math.sqrt(p2.x * p2.x + p2.y * p2.y);
    con = -1;
  }
  theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2(con * p2.x, con * p2.y);
  }
  con = rh1 * this.ns0 / this.a;
  if (this.sphere) {
    lat = Math.asin((this.c - con * con) / (2 * this.ns0));
  } else {
    qs = (this.c - con * con) / this.ns0;
    lat = this.phi1z(this.e3, qs);
  }
  lon = adjust_lon(theta / this.ns0 + this.long0);
  p2.x = lon;
  p2.y = lat;
  return p2;
}
function phi1z(eccent, qs) {
  var sinphi, cosphi, con, com, dphi;
  var phi = asinz(0.5 * qs);
  if (eccent < EPSLN) {
    return phi;
  }
  var eccnts = eccent * eccent;
  for (var i2 = 1; i2 <= 25; i2++) {
    sinphi = Math.sin(phi);
    cosphi = Math.cos(phi);
    con = eccent * sinphi;
    com = 1 - con * con;
    dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    phi = phi + dphi;
    if (Math.abs(dphi) <= 1e-7) {
      return phi;
    }
  }
  return null;
}
var names$i = ["Albers_Conic_Equal_Area", "Albers", "aea"];
const aea = {
  init: init$h,
  forward: forward$h,
  inverse: inverse$h,
  names: names$i,
  phi1z
};
function init$g() {
  this.sin_p14 = Math.sin(this.lat0);
  this.cos_p14 = Math.cos(this.lat0);
  this.infinity_dist = 1e3 * this.a;
  this.rc = 1;
}
function forward$g(p2) {
  var sinphi, cosphi;
  var dlon;
  var coslon;
  var ksp;
  var g2;
  var x2, y2;
  var lon = p2.x;
  var lat = p2.y;
  dlon = adjust_lon(lon - this.long0);
  sinphi = Math.sin(lat);
  cosphi = Math.cos(lat);
  coslon = Math.cos(dlon);
  g2 = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
  ksp = 1;
  if (g2 > 0 || Math.abs(g2) <= EPSLN) {
    x2 = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g2;
    y2 = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g2;
  } else {
    x2 = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
    y2 = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
  }
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$g(p2) {
  var rh;
  var sinc, cosc;
  var c2;
  var lon, lat;
  p2.x = (p2.x - this.x0) / this.a;
  p2.y = (p2.y - this.y0) / this.a;
  p2.x /= this.k0;
  p2.y /= this.k0;
  if (rh = Math.sqrt(p2.x * p2.x + p2.y * p2.y)) {
    c2 = Math.atan2(rh, this.rc);
    sinc = Math.sin(c2);
    cosc = Math.cos(c2);
    lat = asinz(cosc * this.sin_p14 + p2.y * sinc * this.cos_p14 / rh);
    lon = Math.atan2(p2.x * sinc, rh * this.cos_p14 * cosc - p2.y * this.sin_p14 * sinc);
    lon = adjust_lon(this.long0 + lon);
  } else {
    lat = this.phic0;
    lon = 0;
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$h = ["gnom"];
const gnom = {
  init: init$g,
  forward: forward$g,
  inverse: inverse$g,
  names: names$h
};
function iqsfnz(eccent, q2) {
  var temp2 = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
  if (Math.abs(Math.abs(q2) - temp2) < 1e-6) {
    if (q2 < 0) {
      return -1 * HALF_PI;
    } else {
      return HALF_PI;
    }
  }
  var phi = Math.asin(0.5 * q2);
  var dphi;
  var sin_phi;
  var cos_phi;
  var con;
  for (var i2 = 0; i2 < 30; i2++) {
    sin_phi = Math.sin(phi);
    cos_phi = Math.cos(phi);
    con = eccent * sin_phi;
    dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q2 / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    phi += dphi;
    if (Math.abs(dphi) <= 1e-10) {
      return phi;
    }
  }
  return NaN;
}
function init$f() {
  if (!this.sphere) {
    this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
  }
}
function forward$f(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var x2, y2;
  var dlon = adjust_lon(lon - this.long0);
  if (this.sphere) {
    x2 = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
    y2 = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
  } else {
    var qs = qsfnz(this.e, Math.sin(lat));
    x2 = this.x0 + this.a * this.k0 * dlon;
    y2 = this.y0 + this.a * qs * 0.5 / this.k0;
  }
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$f(p2) {
  p2.x -= this.x0;
  p2.y -= this.y0;
  var lon, lat;
  if (this.sphere) {
    lon = adjust_lon(this.long0 + p2.x / this.a / Math.cos(this.lat_ts));
    lat = Math.asin(p2.y / this.a * Math.cos(this.lat_ts));
  } else {
    lat = iqsfnz(this.e, 2 * p2.y * this.k0 / this.a);
    lon = adjust_lon(this.long0 + p2.x / (this.a * this.k0));
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$g = ["cea"];
const cea = {
  init: init$f,
  forward: forward$f,
  inverse: inverse$f,
  names: names$g
};
function init$e() {
  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  this.lat0 = this.lat0 || 0;
  this.long0 = this.long0 || 0;
  this.lat_ts = this.lat_ts || 0;
  this.title = this.title || "Equidistant Cylindrical (Plate Carre)";
  this.rc = Math.cos(this.lat_ts);
}
function forward$e(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var dlon = adjust_lon(lon - this.long0);
  var dlat = adjust_lat(lat - this.lat0);
  p2.x = this.x0 + this.a * dlon * this.rc;
  p2.y = this.y0 + this.a * dlat;
  return p2;
}
function inverse$e(p2) {
  var x2 = p2.x;
  var y2 = p2.y;
  p2.x = adjust_lon(this.long0 + (x2 - this.x0) / (this.a * this.rc));
  p2.y = adjust_lat(this.lat0 + (y2 - this.y0) / this.a);
  return p2;
}
var names$f = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
const eqc = {
  init: init$e,
  forward: forward$e,
  inverse: inverse$e,
  names: names$f
};
var MAX_ITER$1 = 20;
function init$d() {
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2);
  this.e = Math.sqrt(this.es);
  this.e0 = e0fn(this.es);
  this.e1 = e1fn(this.es);
  this.e2 = e2fn(this.es);
  this.e3 = e3fn(this.es);
  this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
}
function forward$d(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var x2, y2, el;
  var dlon = adjust_lon(lon - this.long0);
  el = dlon * Math.sin(lat);
  if (this.sphere) {
    if (Math.abs(lat) <= EPSLN) {
      x2 = this.a * dlon;
      y2 = -1 * this.a * this.lat0;
    } else {
      x2 = this.a * Math.sin(el) / Math.tan(lat);
      y2 = this.a * (adjust_lat(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
    }
  } else {
    if (Math.abs(lat) <= EPSLN) {
      x2 = this.a * dlon;
      y2 = -1 * this.ml0;
    } else {
      var nl = gN(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
      x2 = nl * Math.sin(el);
      y2 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }
  }
  p2.x = x2 + this.x0;
  p2.y = y2 + this.y0;
  return p2;
}
function inverse$d(p2) {
  var lon, lat, x2, y2, i2;
  var al2, bl2;
  var phi, dphi;
  x2 = p2.x - this.x0;
  y2 = p2.y - this.y0;
  if (this.sphere) {
    if (Math.abs(y2 + this.a * this.lat0) <= EPSLN) {
      lon = adjust_lon(x2 / this.a + this.long0);
      lat = 0;
    } else {
      al2 = this.lat0 + y2 / this.a;
      bl2 = x2 * x2 / this.a / this.a + al2 * al2;
      phi = al2;
      var tanphi;
      for (i2 = MAX_ITER$1; i2; --i2) {
        tanphi = Math.tan(phi);
        dphi = -1 * (al2 * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl2) * tanphi) / ((phi - al2) / tanphi - 1);
        phi += dphi;
        if (Math.abs(dphi) <= EPSLN) {
          lat = phi;
          break;
        }
      }
      lon = adjust_lon(this.long0 + Math.asin(x2 * Math.tan(phi) / this.a) / Math.sin(lat));
    }
  } else {
    if (Math.abs(y2 + this.ml0) <= EPSLN) {
      lat = 0;
      lon = adjust_lon(this.long0 + x2 / this.a);
    } else {
      al2 = (this.ml0 + y2) / this.a;
      bl2 = x2 * x2 / this.a / this.a + al2 * al2;
      phi = al2;
      var cl, mln, mlnp, ma;
      var con;
      for (i2 = MAX_ITER$1; i2; --i2) {
        con = this.e * Math.sin(phi);
        cl = Math.sqrt(1 - con * con) * Math.tan(phi);
        mln = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
        mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
        ma = mln / this.a;
        dphi = (al2 * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl2)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl2 - 2 * al2 * ma) / (4 * cl) + (al2 - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
        phi -= dphi;
        if (Math.abs(dphi) <= EPSLN) {
          lat = phi;
          break;
        }
      }
      cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
      lon = adjust_lon(this.long0 + Math.asin(x2 * cl / this.a) / Math.sin(lat));
    }
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$e = ["Polyconic", "poly"];
const poly = {
  init: init$d,
  forward: forward$d,
  inverse: inverse$d,
  names: names$e
};
function init$c() {
  this.A = [];
  this.A[1] = 0.6399175073;
  this.A[2] = -0.1358797613;
  this.A[3] = 0.063294409;
  this.A[4] = -0.02526853;
  this.A[5] = 0.0117879;
  this.A[6] = -55161e-7;
  this.A[7] = 26906e-7;
  this.A[8] = -1333e-6;
  this.A[9] = 67e-5;
  this.A[10] = -34e-5;
  this.B_re = [];
  this.B_im = [];
  this.B_re[1] = 0.7557853228;
  this.B_im[1] = 0;
  this.B_re[2] = 0.249204646;
  this.B_im[2] = 3371507e-9;
  this.B_re[3] = -1541739e-9;
  this.B_im[3] = 0.04105856;
  this.B_re[4] = -0.10162907;
  this.B_im[4] = 0.01727609;
  this.B_re[5] = -0.26623489;
  this.B_im[5] = -0.36249218;
  this.B_re[6] = -0.6870983;
  this.B_im[6] = -1.1651967;
  this.C_re = [];
  this.C_im = [];
  this.C_re[1] = 1.3231270439;
  this.C_im[1] = 0;
  this.C_re[2] = -0.577245789;
  this.C_im[2] = -7809598e-9;
  this.C_re[3] = 0.508307513;
  this.C_im[3] = -0.112208952;
  this.C_re[4] = -0.15094762;
  this.C_im[4] = 0.18200602;
  this.C_re[5] = 1.01418179;
  this.C_im[5] = 1.64497696;
  this.C_re[6] = 1.9660549;
  this.C_im[6] = 2.5127645;
  this.D = [];
  this.D[1] = 1.5627014243;
  this.D[2] = 0.5185406398;
  this.D[3] = -0.03333098;
  this.D[4] = -0.1052906;
  this.D[5] = -0.0368594;
  this.D[6] = 7317e-6;
  this.D[7] = 0.0122;
  this.D[8] = 394e-5;
  this.D[9] = -13e-4;
}
function forward$c(p2) {
  var n2;
  var lon = p2.x;
  var lat = p2.y;
  var delta_lat = lat - this.lat0;
  var delta_lon = lon - this.long0;
  var d_phi = delta_lat / SEC_TO_RAD * 1e-5;
  var d_lambda = delta_lon;
  var d_phi_n = 1;
  var d_psi = 0;
  for (n2 = 1; n2 <= 10; n2++) {
    d_phi_n = d_phi_n * d_phi;
    d_psi = d_psi + this.A[n2] * d_phi_n;
  }
  var th_re = d_psi;
  var th_im = d_lambda;
  var th_n_re = 1;
  var th_n_im = 0;
  var th_n_re1;
  var th_n_im1;
  var z_re = 0;
  var z_im = 0;
  for (n2 = 1; n2 <= 6; n2++) {
    th_n_re1 = th_n_re * th_re - th_n_im * th_im;
    th_n_im1 = th_n_im * th_re + th_n_re * th_im;
    th_n_re = th_n_re1;
    th_n_im = th_n_im1;
    z_re = z_re + this.B_re[n2] * th_n_re - this.B_im[n2] * th_n_im;
    z_im = z_im + this.B_im[n2] * th_n_re + this.B_re[n2] * th_n_im;
  }
  p2.x = z_im * this.a + this.x0;
  p2.y = z_re * this.a + this.y0;
  return p2;
}
function inverse$c(p2) {
  var n2;
  var x2 = p2.x;
  var y2 = p2.y;
  var delta_x = x2 - this.x0;
  var delta_y = y2 - this.y0;
  var z_re = delta_y / this.a;
  var z_im = delta_x / this.a;
  var z_n_re = 1;
  var z_n_im = 0;
  var z_n_re1;
  var z_n_im1;
  var th_re = 0;
  var th_im = 0;
  for (n2 = 1; n2 <= 6; n2++) {
    z_n_re1 = z_n_re * z_re - z_n_im * z_im;
    z_n_im1 = z_n_im * z_re + z_n_re * z_im;
    z_n_re = z_n_re1;
    z_n_im = z_n_im1;
    th_re = th_re + this.C_re[n2] * z_n_re - this.C_im[n2] * z_n_im;
    th_im = th_im + this.C_im[n2] * z_n_re + this.C_re[n2] * z_n_im;
  }
  for (var i2 = 0; i2 < this.iterations; i2++) {
    var th_n_re = th_re;
    var th_n_im = th_im;
    var th_n_re1;
    var th_n_im1;
    var num_re = z_re;
    var num_im = z_im;
    for (n2 = 2; n2 <= 6; n2++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;
      th_n_im = th_n_im1;
      num_re = num_re + (n2 - 1) * (this.B_re[n2] * th_n_re - this.B_im[n2] * th_n_im);
      num_im = num_im + (n2 - 1) * (this.B_im[n2] * th_n_re + this.B_re[n2] * th_n_im);
    }
    th_n_re = 1;
    th_n_im = 0;
    var den_re = this.B_re[1];
    var den_im = this.B_im[1];
    for (n2 = 2; n2 <= 6; n2++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;
      th_n_im = th_n_im1;
      den_re = den_re + n2 * (this.B_re[n2] * th_n_re - this.B_im[n2] * th_n_im);
      den_im = den_im + n2 * (this.B_im[n2] * th_n_re + this.B_re[n2] * th_n_im);
    }
    var den2 = den_re * den_re + den_im * den_im;
    th_re = (num_re * den_re + num_im * den_im) / den2;
    th_im = (num_im * den_re - num_re * den_im) / den2;
  }
  var d_psi = th_re;
  var d_lambda = th_im;
  var d_psi_n = 1;
  var d_phi = 0;
  for (n2 = 1; n2 <= 9; n2++) {
    d_psi_n = d_psi_n * d_psi;
    d_phi = d_phi + this.D[n2] * d_psi_n;
  }
  var lat = this.lat0 + d_phi * SEC_TO_RAD * 1e5;
  var lon = this.long0 + d_lambda;
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$d = ["New_Zealand_Map_Grid", "nzmg"];
const nzmg = {
  init: init$c,
  forward: forward$c,
  inverse: inverse$c,
  names: names$d
};
function init$b() {
}
function forward$b(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var dlon = adjust_lon(lon - this.long0);
  var x2 = this.x0 + this.a * dlon;
  var y2 = this.y0 + this.a * Math.log(Math.tan(Math.PI / 4 + lat / 2.5)) * 1.25;
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$b(p2) {
  p2.x -= this.x0;
  p2.y -= this.y0;
  var lon = adjust_lon(this.long0 + p2.x / this.a);
  var lat = 2.5 * (Math.atan(Math.exp(0.8 * p2.y / this.a)) - Math.PI / 4);
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$c = ["Miller_Cylindrical", "mill"];
const mill = {
  init: init$b,
  forward: forward$b,
  inverse: inverse$b,
  names: names$c
};
var MAX_ITER = 20;
function init$a() {
  if (!this.sphere) {
    this.en = pj_enfn(this.es);
  } else {
    this.n = 1;
    this.m = 0;
    this.es = 0;
    this.C_y = Math.sqrt((this.m + 1) / this.n);
    this.C_x = this.C_y / (this.m + 1);
  }
}
function forward$a(p2) {
  var x2, y2;
  var lon = p2.x;
  var lat = p2.y;
  lon = adjust_lon(lon - this.long0);
  if (this.sphere) {
    if (!this.m) {
      lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
    } else {
      var k2 = this.n * Math.sin(lat);
      for (var i2 = MAX_ITER; i2; --i2) {
        var V2 = (this.m * lat + Math.sin(lat) - k2) / (this.m + Math.cos(lat));
        lat -= V2;
        if (Math.abs(V2) < EPSLN) {
          break;
        }
      }
    }
    x2 = this.a * this.C_x * lon * (this.m + Math.cos(lat));
    y2 = this.a * this.C_y * lat;
  } else {
    var s2 = Math.sin(lat);
    var c2 = Math.cos(lat);
    y2 = this.a * pj_mlfn(lat, s2, c2, this.en);
    x2 = this.a * lon * c2 / Math.sqrt(1 - this.es * s2 * s2);
  }
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$a(p2) {
  var lat, temp2, lon, s2;
  p2.x -= this.x0;
  lon = p2.x / this.a;
  p2.y -= this.y0;
  lat = p2.y / this.a;
  if (this.sphere) {
    lat /= this.C_y;
    lon = lon / (this.C_x * (this.m + Math.cos(lat)));
    if (this.m) {
      lat = asinz((this.m * lat + Math.sin(lat)) / this.n);
    } else if (this.n !== 1) {
      lat = asinz(Math.sin(lat) / this.n);
    }
    lon = adjust_lon(lon + this.long0);
    lat = adjust_lat(lat);
  } else {
    lat = pj_inv_mlfn(p2.y / this.a, this.es, this.en);
    s2 = Math.abs(lat);
    if (s2 < HALF_PI) {
      s2 = Math.sin(lat);
      temp2 = this.long0 + p2.x * Math.sqrt(1 - this.es * s2 * s2) / (this.a * Math.cos(lat));
      lon = adjust_lon(temp2);
    } else if (s2 - EPSLN < HALF_PI) {
      lon = this.long0;
    }
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$b = ["Sinusoidal", "sinu"];
const sinu = {
  init: init$a,
  forward: forward$a,
  inverse: inverse$a,
  names: names$b
};
function init$9() {
}
function forward$9(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var delta_lon = adjust_lon(lon - this.long0);
  var theta = lat;
  var con = Math.PI * Math.sin(lat);
  while (true) {
    var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
    theta += delta_theta;
    if (Math.abs(delta_theta) < EPSLN) {
      break;
    }
  }
  theta /= 2;
  if (Math.PI / 2 - Math.abs(lat) < EPSLN) {
    delta_lon = 0;
  }
  var x2 = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
  var y2 = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$9(p2) {
  var theta;
  var arg;
  p2.x -= this.x0;
  p2.y -= this.y0;
  arg = p2.y / (1.4142135623731 * this.a);
  if (Math.abs(arg) > 0.999999999999) {
    arg = 0.999999999999;
  }
  theta = Math.asin(arg);
  var lon = adjust_lon(this.long0 + p2.x / (0.900316316158 * this.a * Math.cos(theta)));
  if (lon < -Math.PI) {
    lon = -Math.PI;
  }
  if (lon > Math.PI) {
    lon = Math.PI;
  }
  arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
  if (Math.abs(arg) > 1) {
    arg = 1;
  }
  var lat = Math.asin(arg);
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$a = ["Mollweide", "moll"];
const moll = {
  init: init$9,
  forward: forward$9,
  inverse: inverse$9,
  names: names$a
};
function init$8() {
  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
    return;
  }
  this.lat2 = this.lat2 || this.lat1;
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2);
  this.e = Math.sqrt(this.es);
  this.e0 = e0fn(this.es);
  this.e1 = e1fn(this.es);
  this.e2 = e2fn(this.es);
  this.e3 = e3fn(this.es);
  this.sinphi = Math.sin(this.lat1);
  this.cosphi = Math.cos(this.lat1);
  this.ms1 = msfnz(this.e, this.sinphi, this.cosphi);
  this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);
  if (Math.abs(this.lat1 - this.lat2) < EPSLN) {
    this.ns = this.sinphi;
  } else {
    this.sinphi = Math.sin(this.lat2);
    this.cosphi = Math.cos(this.lat2);
    this.ms2 = msfnz(this.e, this.sinphi, this.cosphi);
    this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
    this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
  }
  this.g = this.ml1 + this.ms1 / this.ns;
  this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
  this.rh = this.a * (this.g - this.ml0);
}
function forward$8(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var rh1;
  if (this.sphere) {
    rh1 = this.a * (this.g - lat);
  } else {
    var ml = mlfn(this.e0, this.e1, this.e2, this.e3, lat);
    rh1 = this.a * (this.g - ml);
  }
  var theta = this.ns * adjust_lon(lon - this.long0);
  var x2 = this.x0 + rh1 * Math.sin(theta);
  var y2 = this.y0 + this.rh - rh1 * Math.cos(theta);
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$8(p2) {
  p2.x -= this.x0;
  p2.y = this.rh - p2.y + this.y0;
  var con, rh1, lat, lon;
  if (this.ns >= 0) {
    rh1 = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
    con = 1;
  } else {
    rh1 = -Math.sqrt(p2.x * p2.x + p2.y * p2.y);
    con = -1;
  }
  var theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2(con * p2.x, con * p2.y);
  }
  if (this.sphere) {
    lon = adjust_lon(this.long0 + theta / this.ns);
    lat = adjust_lat(this.g - rh1 / this.a);
    p2.x = lon;
    p2.y = lat;
    return p2;
  } else {
    var ml = this.g - rh1 / this.a;
    lat = imlfn(ml, this.e0, this.e1, this.e2, this.e3);
    lon = adjust_lon(this.long0 + theta / this.ns);
    p2.x = lon;
    p2.y = lat;
    return p2;
  }
}
var names$9 = ["Equidistant_Conic", "eqdc"];
const eqdc = {
  init: init$8,
  forward: forward$8,
  inverse: inverse$8,
  names: names$9
};
function init$7() {
  this.R = this.a;
}
function forward$7(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var dlon = adjust_lon(lon - this.long0);
  var x2, y2;
  if (Math.abs(lat) <= EPSLN) {
    x2 = this.x0 + this.R * dlon;
    y2 = this.y0;
  }
  var theta = asinz(2 * Math.abs(lat / Math.PI));
  if (Math.abs(dlon) <= EPSLN || Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
    x2 = this.x0;
    if (lat >= 0) {
      y2 = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
    } else {
      y2 = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    }
  }
  var al2 = 0.5 * Math.abs(Math.PI / dlon - dlon / Math.PI);
  var asq = al2 * al2;
  var sinth = Math.sin(theta);
  var costh = Math.cos(theta);
  var g2 = costh / (sinth + costh - 1);
  var gsq = g2 * g2;
  var m2 = g2 * (2 / sinth - 1);
  var msq = m2 * m2;
  var con = Math.PI * this.R * (al2 * (g2 - msq) + Math.sqrt(asq * (g2 - msq) * (g2 - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
  if (dlon < 0) {
    con = -con;
  }
  x2 = this.x0 + con;
  var q2 = asq + g2;
  con = Math.PI * this.R * (m2 * q2 - al2 * Math.sqrt((msq + asq) * (asq + 1) - q2 * q2)) / (msq + asq);
  if (lat >= 0) {
    y2 = this.y0 + con;
  } else {
    y2 = this.y0 - con;
  }
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$7(p2) {
  var lon, lat;
  var xx, yy, xys, c1, c2, c3;
  var a1;
  var m1;
  var con;
  var th1;
  var d2;
  p2.x -= this.x0;
  p2.y -= this.y0;
  con = Math.PI * this.R;
  xx = p2.x / con;
  yy = p2.y / con;
  xys = xx * xx + yy * yy;
  c1 = -Math.abs(yy) * (1 + xys);
  c2 = c1 - 2 * yy * yy + xx * xx;
  c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
  d2 = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
  a1 = (c1 - c2 * c2 / 3 / c3) / c3;
  m1 = 2 * Math.sqrt(-a1 / 3);
  con = 3 * d2 / a1 / m1;
  if (Math.abs(con) > 1) {
    if (con >= 0) {
      con = 1;
    } else {
      con = -1;
    }
  }
  th1 = Math.acos(con) / 3;
  if (p2.y >= 0) {
    lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
  } else {
    lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
  }
  if (Math.abs(xx) < EPSLN) {
    lon = this.long0;
  } else {
    lon = adjust_lon(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
  }
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$8 = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
const vandg = {
  init: init$7,
  forward: forward$7,
  inverse: inverse$7,
  names: names$8
};
function init$6() {
  this.sin_p12 = Math.sin(this.lat0);
  this.cos_p12 = Math.cos(this.lat0);
}
function forward$6(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var sinphi = Math.sin(p2.y);
  var cosphi = Math.cos(p2.y);
  var dlon = adjust_lon(lon - this.long0);
  var e0, e1, e22, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G2, H2, GH, Hs, c2, kp, cos_c, s2, s22, s3, s4, s5;
  if (this.sphere) {
    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
      p2.x = this.x0 + this.a * (HALF_PI - lat) * Math.sin(dlon);
      p2.y = this.y0 - this.a * (HALF_PI - lat) * Math.cos(dlon);
      return p2;
    } else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
      p2.x = this.x0 + this.a * (HALF_PI + lat) * Math.sin(dlon);
      p2.y = this.y0 + this.a * (HALF_PI + lat) * Math.cos(dlon);
      return p2;
    } else {
      cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
      c2 = Math.acos(cos_c);
      kp = c2 ? c2 / Math.sin(c2) : 1;
      p2.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
      p2.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
      return p2;
    }
  } else {
    e0 = e0fn(this.es);
    e1 = e1fn(this.es);
    e22 = e2fn(this.es);
    e3 = e3fn(this.es);
    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
      Mlp = this.a * mlfn(e0, e1, e22, e3, HALF_PI);
      Ml = this.a * mlfn(e0, e1, e22, e3, lat);
      p2.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
      p2.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
      return p2;
    } else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
      Mlp = this.a * mlfn(e0, e1, e22, e3, HALF_PI);
      Ml = this.a * mlfn(e0, e1, e22, e3, lat);
      p2.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
      p2.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
      return p2;
    } else {
      tanphi = sinphi / cosphi;
      Nl1 = gN(this.a, this.e, this.sin_p12);
      Nl = gN(this.a, this.e, sinphi);
      psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
      Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
      if (Az === 0) {
        s2 = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
      } else if (Math.abs(Math.abs(Az) - Math.PI) <= EPSLN) {
        s2 = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
      } else {
        s2 = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
      }
      G2 = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
      H2 = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
      GH = G2 * H2;
      Hs = H2 * H2;
      s22 = s2 * s2;
      s3 = s22 * s2;
      s4 = s3 * s2;
      s5 = s4 * s2;
      c2 = Nl1 * s2 * (1 - s22 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G2 * G2 * (1 - 7 * Hs)) - s5 / 48 * GH);
      p2.x = this.x0 + c2 * Math.sin(Az);
      p2.y = this.y0 + c2 * Math.cos(Az);
      return p2;
    }
  }
}
function inverse$6(p2) {
  p2.x -= this.x0;
  p2.y -= this.y0;
  var rh, z2, sinz, cosz, lon, lat, con, e0, e1, e22, e3, Mlp, M2, N1, psi, Az, cosAz, tmp2, A2, B2, D2, Ee, F2, sinpsi;
  if (this.sphere) {
    rh = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
    if (rh > 2 * HALF_PI * this.a) {
      return;
    }
    z2 = rh / this.a;
    sinz = Math.sin(z2);
    cosz = Math.cos(z2);
    lon = this.long0;
    if (Math.abs(rh) <= EPSLN) {
      lat = this.lat0;
    } else {
      lat = asinz(cosz * this.sin_p12 + p2.y * sinz * this.cos_p12 / rh);
      con = Math.abs(this.lat0) - HALF_PI;
      if (Math.abs(con) <= EPSLN) {
        if (this.lat0 >= 0) {
          lon = adjust_lon(this.long0 + Math.atan2(p2.x, -p2.y));
        } else {
          lon = adjust_lon(this.long0 - Math.atan2(-p2.x, p2.y));
        }
      } else {
        lon = adjust_lon(this.long0 + Math.atan2(p2.x * sinz, rh * this.cos_p12 * cosz - p2.y * this.sin_p12 * sinz));
      }
    }
    p2.x = lon;
    p2.y = lat;
    return p2;
  } else {
    e0 = e0fn(this.es);
    e1 = e1fn(this.es);
    e22 = e2fn(this.es);
    e3 = e3fn(this.es);
    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
      Mlp = this.a * mlfn(e0, e1, e22, e3, HALF_PI);
      rh = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
      M2 = Mlp - rh;
      lat = imlfn(M2 / this.a, e0, e1, e22, e3);
      lon = adjust_lon(this.long0 + Math.atan2(p2.x, -1 * p2.y));
      p2.x = lon;
      p2.y = lat;
      return p2;
    } else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
      Mlp = this.a * mlfn(e0, e1, e22, e3, HALF_PI);
      rh = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
      M2 = rh - Mlp;
      lat = imlfn(M2 / this.a, e0, e1, e22, e3);
      lon = adjust_lon(this.long0 + Math.atan2(p2.x, p2.y));
      p2.x = lon;
      p2.y = lat;
      return p2;
    } else {
      rh = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
      Az = Math.atan2(p2.x, p2.y);
      N1 = gN(this.a, this.e, this.sin_p12);
      cosAz = Math.cos(Az);
      tmp2 = this.e * this.cos_p12 * cosAz;
      A2 = -tmp2 * tmp2 / (1 - this.es);
      B2 = 3 * this.es * (1 - A2) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
      D2 = rh / N1;
      Ee = D2 - A2 * (1 + A2) * Math.pow(D2, 3) / 6 - B2 * (1 + 3 * A2) * Math.pow(D2, 4) / 24;
      F2 = 1 - A2 * Ee * Ee / 2 - D2 * Ee * Ee * Ee / 6;
      psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
      lon = adjust_lon(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
      sinpsi = Math.sin(psi);
      lat = Math.atan2((sinpsi - this.es * F2 * this.sin_p12) * Math.tan(psi), sinpsi * (1 - this.es));
      p2.x = lon;
      p2.y = lat;
      return p2;
    }
  }
}
var names$7 = ["Azimuthal_Equidistant", "aeqd"];
const aeqd = {
  init: init$6,
  forward: forward$6,
  inverse: inverse$6,
  names: names$7
};
function init$5() {
  this.sin_p14 = Math.sin(this.lat0);
  this.cos_p14 = Math.cos(this.lat0);
}
function forward$5(p2) {
  var sinphi, cosphi;
  var dlon;
  var coslon;
  var ksp;
  var g2, x2, y2;
  var lon = p2.x;
  var lat = p2.y;
  dlon = adjust_lon(lon - this.long0);
  sinphi = Math.sin(lat);
  cosphi = Math.cos(lat);
  coslon = Math.cos(dlon);
  g2 = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
  ksp = 1;
  if (g2 > 0 || Math.abs(g2) <= EPSLN) {
    x2 = this.a * ksp * cosphi * Math.sin(dlon);
    y2 = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
  }
  p2.x = x2;
  p2.y = y2;
  return p2;
}
function inverse$5(p2) {
  var rh;
  var z2;
  var sinz, cosz;
  var con;
  var lon, lat;
  p2.x -= this.x0;
  p2.y -= this.y0;
  rh = Math.sqrt(p2.x * p2.x + p2.y * p2.y);
  z2 = asinz(rh / this.a);
  sinz = Math.sin(z2);
  cosz = Math.cos(z2);
  lon = this.long0;
  if (Math.abs(rh) <= EPSLN) {
    lat = this.lat0;
    p2.x = lon;
    p2.y = lat;
    return p2;
  }
  lat = asinz(cosz * this.sin_p14 + p2.y * sinz * this.cos_p14 / rh);
  con = Math.abs(this.lat0) - HALF_PI;
  if (Math.abs(con) <= EPSLN) {
    if (this.lat0 >= 0) {
      lon = adjust_lon(this.long0 + Math.atan2(p2.x, -p2.y));
    } else {
      lon = adjust_lon(this.long0 - Math.atan2(-p2.x, p2.y));
    }
    p2.x = lon;
    p2.y = lat;
    return p2;
  }
  lon = adjust_lon(this.long0 + Math.atan2(p2.x * sinz, rh * this.cos_p14 * cosz - p2.y * this.sin_p14 * sinz));
  p2.x = lon;
  p2.y = lat;
  return p2;
}
var names$6 = ["ortho"];
const ortho$1 = {
  init: init$5,
  forward: forward$5,
  inverse: inverse$5,
  names: names$6
};
var FACE_ENUM = {
  FRONT: 1,
  RIGHT: 2,
  BACK: 3,
  LEFT: 4,
  TOP: 5,
  BOTTOM: 6
};
var AREA_ENUM = {
  AREA_0: 1,
  AREA_1: 2,
  AREA_2: 3,
  AREA_3: 4
};
function init$4() {
  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  this.lat0 = this.lat0 || 0;
  this.long0 = this.long0 || 0;
  this.lat_ts = this.lat_ts || 0;
  this.title = this.title || "Quadrilateralized Spherical Cube";
  if (this.lat0 >= HALF_PI - FORTPI / 2) {
    this.face = FACE_ENUM.TOP;
  } else if (this.lat0 <= -(HALF_PI - FORTPI / 2)) {
    this.face = FACE_ENUM.BOTTOM;
  } else if (Math.abs(this.long0) <= FORTPI) {
    this.face = FACE_ENUM.FRONT;
  } else if (Math.abs(this.long0) <= HALF_PI + FORTPI) {
    this.face = this.long0 > 0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
  } else {
    this.face = FACE_ENUM.BACK;
  }
  if (this.es !== 0) {
    this.one_minus_f = 1 - (this.a - this.b) / this.a;
    this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
  }
}
function forward$4(p2) {
  var xy = { x: 0, y: 0 };
  var lat, lon;
  var theta, phi;
  var t2, mu;
  var area5 = { value: 0 };
  p2.x -= this.long0;
  if (this.es !== 0) {
    lat = Math.atan(this.one_minus_f_squared * Math.tan(p2.y));
  } else {
    lat = p2.y;
  }
  lon = p2.x;
  if (this.face === FACE_ENUM.TOP) {
    phi = HALF_PI - lat;
    if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
      area5.value = AREA_ENUM.AREA_0;
      theta = lon - HALF_PI;
    } else if (lon > HALF_PI + FORTPI || lon <= -(HALF_PI + FORTPI)) {
      area5.value = AREA_ENUM.AREA_1;
      theta = lon > 0 ? lon - SPI : lon + SPI;
    } else if (lon > -(HALF_PI + FORTPI) && lon <= -FORTPI) {
      area5.value = AREA_ENUM.AREA_2;
      theta = lon + HALF_PI;
    } else {
      area5.value = AREA_ENUM.AREA_3;
      theta = lon;
    }
  } else if (this.face === FACE_ENUM.BOTTOM) {
    phi = HALF_PI + lat;
    if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
      area5.value = AREA_ENUM.AREA_0;
      theta = -lon + HALF_PI;
    } else if (lon < FORTPI && lon >= -FORTPI) {
      area5.value = AREA_ENUM.AREA_1;
      theta = -lon;
    } else if (lon < -FORTPI && lon >= -(HALF_PI + FORTPI)) {
      area5.value = AREA_ENUM.AREA_2;
      theta = -lon - HALF_PI;
    } else {
      area5.value = AREA_ENUM.AREA_3;
      theta = lon > 0 ? -lon + SPI : -lon - SPI;
    }
  } else {
    var q2, r2, s2;
    var sinlat, coslat;
    var sinlon, coslon;
    if (this.face === FACE_ENUM.RIGHT) {
      lon = qsc_shift_lon_origin(lon, +HALF_PI);
    } else if (this.face === FACE_ENUM.BACK) {
      lon = qsc_shift_lon_origin(lon, +SPI);
    } else if (this.face === FACE_ENUM.LEFT) {
      lon = qsc_shift_lon_origin(lon, -HALF_PI);
    }
    sinlat = Math.sin(lat);
    coslat = Math.cos(lat);
    sinlon = Math.sin(lon);
    coslon = Math.cos(lon);
    q2 = coslat * coslon;
    r2 = coslat * sinlon;
    s2 = sinlat;
    if (this.face === FACE_ENUM.FRONT) {
      phi = Math.acos(q2);
      theta = qsc_fwd_equat_face_theta(phi, s2, r2, area5);
    } else if (this.face === FACE_ENUM.RIGHT) {
      phi = Math.acos(r2);
      theta = qsc_fwd_equat_face_theta(phi, s2, -q2, area5);
    } else if (this.face === FACE_ENUM.BACK) {
      phi = Math.acos(-q2);
      theta = qsc_fwd_equat_face_theta(phi, s2, -r2, area5);
    } else if (this.face === FACE_ENUM.LEFT) {
      phi = Math.acos(-r2);
      theta = qsc_fwd_equat_face_theta(phi, s2, q2, area5);
    } else {
      phi = theta = 0;
      area5.value = AREA_ENUM.AREA_0;
    }
  }
  mu = Math.atan(12 / SPI * (theta + Math.acos(Math.sin(theta) * Math.cos(FORTPI)) - HALF_PI));
  t2 = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));
  if (area5.value === AREA_ENUM.AREA_1) {
    mu += HALF_PI;
  } else if (area5.value === AREA_ENUM.AREA_2) {
    mu += SPI;
  } else if (area5.value === AREA_ENUM.AREA_3) {
    mu += 1.5 * SPI;
  }
  xy.x = t2 * Math.cos(mu);
  xy.y = t2 * Math.sin(mu);
  xy.x = xy.x * this.a + this.x0;
  xy.y = xy.y * this.a + this.y0;
  p2.x = xy.x;
  p2.y = xy.y;
  return p2;
}
function inverse$4(p2) {
  var lp = { lam: 0, phi: 0 };
  var mu, nu, cosmu, tannu;
  var tantheta, theta, cosphi, phi;
  var t2;
  var area5 = { value: 0 };
  p2.x = (p2.x - this.x0) / this.a;
  p2.y = (p2.y - this.y0) / this.a;
  nu = Math.atan(Math.sqrt(p2.x * p2.x + p2.y * p2.y));
  mu = Math.atan2(p2.y, p2.x);
  if (p2.x >= 0 && p2.x >= Math.abs(p2.y)) {
    area5.value = AREA_ENUM.AREA_0;
  } else if (p2.y >= 0 && p2.y >= Math.abs(p2.x)) {
    area5.value = AREA_ENUM.AREA_1;
    mu -= HALF_PI;
  } else if (p2.x < 0 && -p2.x >= Math.abs(p2.y)) {
    area5.value = AREA_ENUM.AREA_2;
    mu = mu < 0 ? mu + SPI : mu - SPI;
  } else {
    area5.value = AREA_ENUM.AREA_3;
    mu += HALF_PI;
  }
  t2 = SPI / 12 * Math.tan(mu);
  tantheta = Math.sin(t2) / (Math.cos(t2) - 1 / Math.sqrt(2));
  theta = Math.atan(tantheta);
  cosmu = Math.cos(mu);
  tannu = Math.tan(nu);
  cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
  if (cosphi < -1) {
    cosphi = -1;
  } else if (cosphi > 1) {
    cosphi = 1;
  }
  if (this.face === FACE_ENUM.TOP) {
    phi = Math.acos(cosphi);
    lp.phi = HALF_PI - phi;
    if (area5.value === AREA_ENUM.AREA_0) {
      lp.lam = theta + HALF_PI;
    } else if (area5.value === AREA_ENUM.AREA_1) {
      lp.lam = theta < 0 ? theta + SPI : theta - SPI;
    } else if (area5.value === AREA_ENUM.AREA_2) {
      lp.lam = theta - HALF_PI;
    } else {
      lp.lam = theta;
    }
  } else if (this.face === FACE_ENUM.BOTTOM) {
    phi = Math.acos(cosphi);
    lp.phi = phi - HALF_PI;
    if (area5.value === AREA_ENUM.AREA_0) {
      lp.lam = -theta + HALF_PI;
    } else if (area5.value === AREA_ENUM.AREA_1) {
      lp.lam = -theta;
    } else if (area5.value === AREA_ENUM.AREA_2) {
      lp.lam = -theta - HALF_PI;
    } else {
      lp.lam = theta < 0 ? -theta - SPI : -theta + SPI;
    }
  } else {
    var q2, r2, s2;
    q2 = cosphi;
    t2 = q2 * q2;
    if (t2 >= 1) {
      s2 = 0;
    } else {
      s2 = Math.sqrt(1 - t2) * Math.sin(theta);
    }
    t2 += s2 * s2;
    if (t2 >= 1) {
      r2 = 0;
    } else {
      r2 = Math.sqrt(1 - t2);
    }
    if (area5.value === AREA_ENUM.AREA_1) {
      t2 = r2;
      r2 = -s2;
      s2 = t2;
    } else if (area5.value === AREA_ENUM.AREA_2) {
      r2 = -r2;
      s2 = -s2;
    } else if (area5.value === AREA_ENUM.AREA_3) {
      t2 = r2;
      r2 = s2;
      s2 = -t2;
    }
    if (this.face === FACE_ENUM.RIGHT) {
      t2 = q2;
      q2 = -r2;
      r2 = t2;
    } else if (this.face === FACE_ENUM.BACK) {
      q2 = -q2;
      r2 = -r2;
    } else if (this.face === FACE_ENUM.LEFT) {
      t2 = q2;
      q2 = r2;
      r2 = -t2;
    }
    lp.phi = Math.acos(-s2) - HALF_PI;
    lp.lam = Math.atan2(r2, q2);
    if (this.face === FACE_ENUM.RIGHT) {
      lp.lam = qsc_shift_lon_origin(lp.lam, -HALF_PI);
    } else if (this.face === FACE_ENUM.BACK) {
      lp.lam = qsc_shift_lon_origin(lp.lam, -SPI);
    } else if (this.face === FACE_ENUM.LEFT) {
      lp.lam = qsc_shift_lon_origin(lp.lam, +HALF_PI);
    }
  }
  if (this.es !== 0) {
    var invert_sign;
    var tanphi, xa;
    invert_sign = lp.phi < 0 ? 1 : 0;
    tanphi = Math.tan(lp.phi);
    xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
    lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
    if (invert_sign) {
      lp.phi = -lp.phi;
    }
  }
  lp.lam += this.long0;
  p2.x = lp.lam;
  p2.y = lp.phi;
  return p2;
}
function qsc_fwd_equat_face_theta(phi, y2, x2, area5) {
  var theta;
  if (phi < EPSLN) {
    area5.value = AREA_ENUM.AREA_0;
    theta = 0;
  } else {
    theta = Math.atan2(y2, x2);
    if (Math.abs(theta) <= FORTPI) {
      area5.value = AREA_ENUM.AREA_0;
    } else if (theta > FORTPI && theta <= HALF_PI + FORTPI) {
      area5.value = AREA_ENUM.AREA_1;
      theta -= HALF_PI;
    } else if (theta > HALF_PI + FORTPI || theta <= -(HALF_PI + FORTPI)) {
      area5.value = AREA_ENUM.AREA_2;
      theta = theta >= 0 ? theta - SPI : theta + SPI;
    } else {
      area5.value = AREA_ENUM.AREA_3;
      theta += HALF_PI;
    }
  }
  return theta;
}
function qsc_shift_lon_origin(lon, offset) {
  var slon = lon + offset;
  if (slon < -SPI) {
    slon += TWO_PI;
  } else if (slon > +SPI) {
    slon -= TWO_PI;
  }
  return slon;
}
var names$5 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
const qsc = {
  init: init$4,
  forward: forward$4,
  inverse: inverse$4,
  names: names$5
};
var COEFS_X = [
  [1, 22199e-21, -715515e-10, 31103e-10],
  [0.9986, -482243e-9, -24897e-9, -13309e-10],
  [0.9954, -83103e-8, -448605e-10, -986701e-12],
  [0.99, -135364e-8, -59661e-9, 36777e-10],
  [0.9822, -167442e-8, -449547e-11, -572411e-11],
  [0.973, -214868e-8, -903571e-10, 18736e-12],
  [0.96, -305085e-8, -900761e-10, 164917e-11],
  [0.9427, -382792e-8, -653386e-10, -26154e-10],
  [0.9216, -467746e-8, -10457e-8, 481243e-11],
  [0.8962, -536223e-8, -323831e-10, -543432e-11],
  [0.8679, -609363e-8, -113898e-9, 332484e-11],
  [0.835, -698325e-8, -640253e-10, 934959e-12],
  [0.7986, -755338e-8, -500009e-10, 935324e-12],
  [0.7597, -798324e-8, -35971e-9, -227626e-11],
  [0.7186, -851367e-8, -701149e-10, -86303e-10],
  [0.6732, -986209e-8, -199569e-9, 191974e-10],
  [0.6213, -0.010418, 883923e-10, 624051e-11],
  [0.5722, -906601e-8, 182e-6, 624051e-11],
  [0.5322, -677797e-8, 275608e-9, 624051e-11]
];
var COEFS_Y = [
  [-520417e-23, 0.0124, 121431e-23, -845284e-16],
  [0.062, 0.0124, -126793e-14, 422642e-15],
  [0.124, 0.0124, 507171e-14, -160604e-14],
  [0.186, 0.0123999, -190189e-13, 600152e-14],
  [0.248, 0.0124002, 710039e-13, -224e-10],
  [0.31, 0.0123992, -264997e-12, 835986e-13],
  [0.372, 0.0124029, 988983e-12, -311994e-12],
  [0.434, 0.0123893, -369093e-11, -435621e-12],
  [0.4958, 0.0123198, -102252e-10, -345523e-12],
  [0.5571, 0.0121916, -154081e-10, -582288e-12],
  [0.6176, 0.0119938, -241424e-10, -525327e-12],
  [0.6769, 0.011713, -320223e-10, -516405e-12],
  [0.7346, 0.0113541, -397684e-10, -609052e-12],
  [0.7903, 0.0109107, -489042e-10, -104739e-11],
  [0.8435, 0.0103431, -64615e-9, -140374e-14],
  [0.8936, 969686e-8, -64636e-9, -8547e-9],
  [0.9394, 840947e-8, -192841e-9, -42106e-10],
  [0.9761, 616527e-8, -256e-6, -42106e-10],
  [1, 328947e-8, -319159e-9, -42106e-10]
];
var FXC = 0.8487;
var FYC = 1.3523;
var C1 = R2D / 5;
var RC1 = 1 / C1;
var NODES = 18;
var poly3_val = function(coefs, x2) {
  return coefs[0] + x2 * (coefs[1] + x2 * (coefs[2] + x2 * coefs[3]));
};
var poly3_der = function(coefs, x2) {
  return coefs[1] + x2 * (2 * coefs[2] + x2 * 3 * coefs[3]);
};
function newton_rapshon(f_df, start2, max_err, iters) {
  var x2 = start2;
  for (; iters; --iters) {
    var upd = f_df(x2);
    x2 -= upd;
    if (Math.abs(upd) < max_err) {
      break;
    }
  }
  return x2;
}
function init$3() {
  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  this.long0 = this.long0 || 0;
  this.es = 0;
  this.title = this.title || "Robinson";
}
function forward$3(ll) {
  var lon = adjust_lon(ll.x - this.long0);
  var dphi = Math.abs(ll.y);
  var i2 = Math.floor(dphi * C1);
  if (i2 < 0) {
    i2 = 0;
  } else if (i2 >= NODES) {
    i2 = NODES - 1;
  }
  dphi = R2D * (dphi - RC1 * i2);
  var xy = {
    x: poly3_val(COEFS_X[i2], dphi) * lon,
    y: poly3_val(COEFS_Y[i2], dphi)
  };
  if (ll.y < 0) {
    xy.y = -xy.y;
  }
  xy.x = xy.x * this.a * FXC + this.x0;
  xy.y = xy.y * this.a * FYC + this.y0;
  return xy;
}
function inverse$3(xy) {
  var ll = {
    x: (xy.x - this.x0) / (this.a * FXC),
    y: Math.abs(xy.y - this.y0) / (this.a * FYC)
  };
  if (ll.y >= 1) {
    ll.x /= COEFS_X[NODES][0];
    ll.y = xy.y < 0 ? -HALF_PI : HALF_PI;
  } else {
    var i2 = Math.floor(ll.y * NODES);
    if (i2 < 0) {
      i2 = 0;
    } else if (i2 >= NODES) {
      i2 = NODES - 1;
    }
    for (; ; ) {
      if (COEFS_Y[i2][0] > ll.y) {
        --i2;
      } else if (COEFS_Y[i2 + 1][0] <= ll.y) {
        ++i2;
      } else {
        break;
      }
    }
    var coefs = COEFS_Y[i2];
    var t2 = 5 * (ll.y - coefs[0]) / (COEFS_Y[i2 + 1][0] - coefs[0]);
    t2 = newton_rapshon(function(x2) {
      return (poly3_val(coefs, x2) - ll.y) / poly3_der(coefs, x2);
    }, t2, EPSLN, 100);
    ll.x /= poly3_val(COEFS_X[i2], t2);
    ll.y = (5 * i2 + t2) * D2R$1;
    if (xy.y < 0) {
      ll.y = -ll.y;
    }
  }
  ll.x = adjust_lon(ll.x + this.long0);
  return ll;
}
var names$4 = ["Robinson", "robin"];
const robin = {
  init: init$3,
  forward: forward$3,
  inverse: inverse$3,
  names: names$4
};
function init$2() {
  this.name = "geocent";
}
function forward$2(p2) {
  var point4 = geodeticToGeocentric(p2, this.es, this.a);
  return point4;
}
function inverse$2(p2) {
  var point4 = geocentricToGeodetic(p2, this.es, this.a, this.b);
  return point4;
}
var names$3 = ["Geocentric", "geocentric", "geocent", "Geocent"];
const geocent = {
  init: init$2,
  forward: forward$2,
  inverse: inverse$2,
  names: names$3
};
var mode = {
  N_POLE: 0,
  S_POLE: 1,
  EQUIT: 2,
  OBLIQ: 3
};
var params = {
  h: { def: 1e5, num: true },
  // default is Karman line, no default in PROJ.7
  azi: { def: 0, num: true, degrees: true },
  // default is North
  tilt: { def: 0, num: true, degrees: true },
  // default is Nadir
  long0: { def: 0, num: true },
  // default is Greenwich, conversion to rad is automatic
  lat0: { def: 0, num: true }
  // default is Equator, conversion to rad is automatic
};
function init$1() {
  Object.keys(params).forEach(function(p2) {
    if (typeof this[p2] === "undefined") {
      this[p2] = params[p2].def;
    } else if (params[p2].num && isNaN(this[p2])) {
      throw new Error("Invalid parameter value, must be numeric " + p2 + " = " + this[p2]);
    } else if (params[p2].num) {
      this[p2] = parseFloat(this[p2]);
    }
    if (params[p2].degrees) {
      this[p2] = this[p2] * D2R$1;
    }
  }.bind(this));
  if (Math.abs(Math.abs(this.lat0) - HALF_PI) < EPSLN) {
    this.mode = this.lat0 < 0 ? mode.S_POLE : mode.N_POLE;
  } else if (Math.abs(this.lat0) < EPSLN) {
    this.mode = mode.EQUIT;
  } else {
    this.mode = mode.OBLIQ;
    this.sinph0 = Math.sin(this.lat0);
    this.cosph0 = Math.cos(this.lat0);
  }
  this.pn1 = this.h / this.a;
  if (this.pn1 <= 0 || this.pn1 > 1e10) {
    throw new Error("Invalid height");
  }
  this.p = 1 + this.pn1;
  this.rp = 1 / this.p;
  this.h1 = 1 / this.pn1;
  this.pfact = (this.p + 1) * this.h1;
  this.es = 0;
  var omega = this.tilt;
  var gamma = this.azi;
  this.cg = Math.cos(gamma);
  this.sg = Math.sin(gamma);
  this.cw = Math.cos(omega);
  this.sw = Math.sin(omega);
}
function forward$1(p2) {
  p2.x -= this.long0;
  var sinphi = Math.sin(p2.y);
  var cosphi = Math.cos(p2.y);
  var coslam = Math.cos(p2.x);
  var x2, y2;
  switch (this.mode) {
    case mode.OBLIQ:
      y2 = this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
      break;
    case mode.EQUIT:
      y2 = cosphi * coslam;
      break;
    case mode.S_POLE:
      y2 = -sinphi;
      break;
    case mode.N_POLE:
      y2 = sinphi;
      break;
  }
  y2 = this.pn1 / (this.p - y2);
  x2 = y2 * cosphi * Math.sin(p2.x);
  switch (this.mode) {
    case mode.OBLIQ:
      y2 *= this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
      break;
    case mode.EQUIT:
      y2 *= sinphi;
      break;
    case mode.N_POLE:
      y2 *= -(cosphi * coslam);
      break;
    case mode.S_POLE:
      y2 *= cosphi * coslam;
      break;
  }
  var yt, ba2;
  yt = y2 * this.cg + x2 * this.sg;
  ba2 = 1 / (yt * this.sw * this.h1 + this.cw);
  x2 = (x2 * this.cg - y2 * this.sg) * this.cw * ba2;
  y2 = yt * ba2;
  p2.x = x2 * this.a;
  p2.y = y2 * this.a;
  return p2;
}
function inverse$1(p2) {
  p2.x /= this.a;
  p2.y /= this.a;
  var r2 = { x: p2.x, y: p2.y };
  var bm2, bq2, yt;
  yt = 1 / (this.pn1 - p2.y * this.sw);
  bm2 = this.pn1 * p2.x * yt;
  bq2 = this.pn1 * p2.y * this.cw * yt;
  p2.x = bm2 * this.cg + bq2 * this.sg;
  p2.y = bq2 * this.cg - bm2 * this.sg;
  var rh = hypot(p2.x, p2.y);
  if (Math.abs(rh) < EPSLN) {
    r2.x = 0;
    r2.y = p2.y;
  } else {
    var cosz, sinz;
    sinz = 1 - rh * rh * this.pfact;
    sinz = (this.p - Math.sqrt(sinz)) / (this.pn1 / rh + rh / this.pn1);
    cosz = Math.sqrt(1 - sinz * sinz);
    switch (this.mode) {
      case mode.OBLIQ:
        r2.y = Math.asin(cosz * this.sinph0 + p2.y * sinz * this.cosph0 / rh);
        p2.y = (cosz - this.sinph0 * Math.sin(r2.y)) * rh;
        p2.x *= sinz * this.cosph0;
        break;
      case mode.EQUIT:
        r2.y = Math.asin(p2.y * sinz / rh);
        p2.y = cosz * rh;
        p2.x *= sinz;
        break;
      case mode.N_POLE:
        r2.y = Math.asin(cosz);
        p2.y = -p2.y;
        break;
      case mode.S_POLE:
        r2.y = -Math.asin(cosz);
        break;
    }
    r2.x = Math.atan2(p2.x, p2.y);
  }
  p2.x = r2.x + this.long0;
  p2.y = r2.y;
  return p2;
}
var names$2 = ["Tilted_Perspective", "tpers"];
const tpers = {
  init: init$1,
  forward: forward$1,
  inverse: inverse$1,
  names: names$2
};
function init() {
  this.flip_axis = this.sweep === "x" ? 1 : 0;
  this.h = Number(this.h);
  this.radius_g_1 = this.h / this.a;
  if (this.radius_g_1 <= 0 || this.radius_g_1 > 1e10) {
    throw new Error();
  }
  this.radius_g = 1 + this.radius_g_1;
  this.C = this.radius_g * this.radius_g - 1;
  if (this.es !== 0) {
    var one_es = 1 - this.es;
    var rone_es = 1 / one_es;
    this.radius_p = Math.sqrt(one_es);
    this.radius_p2 = one_es;
    this.radius_p_inv2 = rone_es;
    this.shape = "ellipse";
  } else {
    this.radius_p = 1;
    this.radius_p2 = 1;
    this.radius_p_inv2 = 1;
    this.shape = "sphere";
  }
  if (!this.title) {
    this.title = "Geostationary Satellite View";
  }
}
function forward(p2) {
  var lon = p2.x;
  var lat = p2.y;
  var tmp2, v_x, v_y, v_z;
  lon = lon - this.long0;
  if (this.shape === "ellipse") {
    lat = Math.atan(this.radius_p2 * Math.tan(lat));
    var r2 = this.radius_p / hypot(this.radius_p * Math.cos(lat), Math.sin(lat));
    v_x = r2 * Math.cos(lon) * Math.cos(lat);
    v_y = r2 * Math.sin(lon) * Math.cos(lat);
    v_z = r2 * Math.sin(lat);
    if ((this.radius_g - v_x) * v_x - v_y * v_y - v_z * v_z * this.radius_p_inv2 < 0) {
      p2.x = Number.NaN;
      p2.y = Number.NaN;
      return p2;
    }
    tmp2 = this.radius_g - v_x;
    if (this.flip_axis) {
      p2.x = this.radius_g_1 * Math.atan(v_y / hypot(v_z, tmp2));
      p2.y = this.radius_g_1 * Math.atan(v_z / tmp2);
    } else {
      p2.x = this.radius_g_1 * Math.atan(v_y / tmp2);
      p2.y = this.radius_g_1 * Math.atan(v_z / hypot(v_y, tmp2));
    }
  } else if (this.shape === "sphere") {
    tmp2 = Math.cos(lat);
    v_x = Math.cos(lon) * tmp2;
    v_y = Math.sin(lon) * tmp2;
    v_z = Math.sin(lat);
    tmp2 = this.radius_g - v_x;
    if (this.flip_axis) {
      p2.x = this.radius_g_1 * Math.atan(v_y / hypot(v_z, tmp2));
      p2.y = this.radius_g_1 * Math.atan(v_z / tmp2);
    } else {
      p2.x = this.radius_g_1 * Math.atan(v_y / tmp2);
      p2.y = this.radius_g_1 * Math.atan(v_z / hypot(v_y, tmp2));
    }
  }
  p2.x = p2.x * this.a;
  p2.y = p2.y * this.a;
  return p2;
}
function inverse(p2) {
  var v_x = -1;
  var v_y = 0;
  var v_z = 0;
  var a2, b2, det2, k2;
  p2.x = p2.x / this.a;
  p2.y = p2.y / this.a;
  if (this.shape === "ellipse") {
    if (this.flip_axis) {
      v_z = Math.tan(p2.y / this.radius_g_1);
      v_y = Math.tan(p2.x / this.radius_g_1) * hypot(1, v_z);
    } else {
      v_y = Math.tan(p2.x / this.radius_g_1);
      v_z = Math.tan(p2.y / this.radius_g_1) * hypot(1, v_y);
    }
    var v_zp = v_z / this.radius_p;
    a2 = v_y * v_y + v_zp * v_zp + v_x * v_x;
    b2 = 2 * this.radius_g * v_x;
    det2 = b2 * b2 - 4 * a2 * this.C;
    if (det2 < 0) {
      p2.x = Number.NaN;
      p2.y = Number.NaN;
      return p2;
    }
    k2 = (-b2 - Math.sqrt(det2)) / (2 * a2);
    v_x = this.radius_g + k2 * v_x;
    v_y *= k2;
    v_z *= k2;
    p2.x = Math.atan2(v_y, v_x);
    p2.y = Math.atan(v_z * Math.cos(p2.x) / v_x);
    p2.y = Math.atan(this.radius_p_inv2 * Math.tan(p2.y));
  } else if (this.shape === "sphere") {
    if (this.flip_axis) {
      v_z = Math.tan(p2.y / this.radius_g_1);
      v_y = Math.tan(p2.x / this.radius_g_1) * Math.sqrt(1 + v_z * v_z);
    } else {
      v_y = Math.tan(p2.x / this.radius_g_1);
      v_z = Math.tan(p2.y / this.radius_g_1) * Math.sqrt(1 + v_y * v_y);
    }
    a2 = v_y * v_y + v_z * v_z + v_x * v_x;
    b2 = 2 * this.radius_g * v_x;
    det2 = b2 * b2 - 4 * a2 * this.C;
    if (det2 < 0) {
      p2.x = Number.NaN;
      p2.y = Number.NaN;
      return p2;
    }
    k2 = (-b2 - Math.sqrt(det2)) / (2 * a2);
    v_x = this.radius_g + k2 * v_x;
    v_y *= k2;
    v_z *= k2;
    p2.x = Math.atan2(v_y, v_x);
    p2.y = Math.atan(v_z * Math.cos(p2.x) / v_x);
  }
  p2.x = p2.x + this.long0;
  return p2;
}
var names$1 = ["Geostationary Satellite View", "Geostationary_Satellite", "geos"];
const geos = {
  init,
  forward,
  inverse,
  names: names$1
};
function includedProjections(proj42) {
  proj42.Proj.projections.add(tmerc);
  proj42.Proj.projections.add(etmerc);
  proj42.Proj.projections.add(utm);
  proj42.Proj.projections.add(sterea);
  proj42.Proj.projections.add(stere);
  proj42.Proj.projections.add(somerc);
  proj42.Proj.projections.add(omerc);
  proj42.Proj.projections.add(lcc);
  proj42.Proj.projections.add(krovak);
  proj42.Proj.projections.add(cass);
  proj42.Proj.projections.add(laea);
  proj42.Proj.projections.add(aea);
  proj42.Proj.projections.add(gnom);
  proj42.Proj.projections.add(cea);
  proj42.Proj.projections.add(eqc);
  proj42.Proj.projections.add(poly);
  proj42.Proj.projections.add(nzmg);
  proj42.Proj.projections.add(mill);
  proj42.Proj.projections.add(sinu);
  proj42.Proj.projections.add(moll);
  proj42.Proj.projections.add(eqdc);
  proj42.Proj.projections.add(vandg);
  proj42.Proj.projections.add(aeqd);
  proj42.Proj.projections.add(ortho$1);
  proj42.Proj.projections.add(qsc);
  proj42.Proj.projections.add(robin);
  proj42.Proj.projections.add(geocent);
  proj42.Proj.projections.add(tpers);
  proj42.Proj.projections.add(geos);
}
proj4.defaultDatum = "WGS84";
proj4.Proj = Projection;
proj4.WGS84 = new proj4.Proj("WGS84");
proj4.Point = Point$6;
proj4.toPoint = common;
proj4.defs = defs;
proj4.nadgrid = nadgrid;
proj4.transform = transform$1;
proj4.mgrs = mgrs;
proj4.version = "__VERSION__";
includedProjections(proj4);
class ShpUtil {
  static async convertToGeoJson(buffer3, extension) {
    if (extension === "shp") {
      return ShpUtil.getGeoJsonFromShp(buffer3);
    }
    if (extension === "zip") {
      const files2 = await FileUtil.getFilesFromZip(buffer3);
      if (!files2.length)
        return null;
      const shpFile = files2.find((file2) => file2.extension === "shp");
      if (!shpFile) {
        console.error("No shp found in zip");
        return null;
      }
      if (shpFile.type === "dataUrl") {
        const file2 = await FileUtil.importFromUrl(shpFile.content, "buffer");
        shpFile.content = file2.data;
        shpFile.type = file2.dataType;
      }
      const projectionFile = files2.find((file2) => file2.extension === "prj");
      const projectPoint = (projectionFile == null ? void 0 : projectionFile.content) ? (coord) => proj4(projectionFile.content, "WGS84", coord) : null;
      const geojson = await ShpUtil.getGeoJsonFromShp(shpFile.content, projectPoint);
      return geojson;
    }
    return null;
  }
  static async getGeoJsonFromShp(buffer3, transformPoint2) {
    try {
      if (!buffer3)
        return null;
      const source = await open(buffer3);
      if (!source)
        return null;
      const result = await source.read();
      const features = [];
      const recursiveRead = async (result2) => {
        if (result2.done)
          return;
        features.push(result2.value);
        const data2 = await source.read();
        await recursiveRead(data2);
      };
      await recursiveRead(result);
      const geojsonData = GeoUtil.getProjectedGeoJson(GeoUtil.getCuratedGeojson({
        type: "FeatureCollection",
        features
      }), transformPoint2);
      if (!geojsonData)
        return null;
      const center2 = GeoUtil.centroid(geojsonData);
      if (center2) {
        center2.properties.category = "default-center";
        geojsonData.features.push(center2);
        const longitude = center2.geometry.coordinates[0];
        const latitude = center2.geometry.coordinates[1];
        if (longitude < -180 || longitude > 180 || latitude < -90 || latitude > 90) {
          message$1.error("Unsupported projection");
          throw new Error("Unsupported projection");
        }
      }
      geojsonData.features.forEach((feature2) => {
        if (feature2.properties) {
          feature2.properties = GeoUtil.unFlattenedProperties(feature2.properties);
          if (Array.isArray(feature2.properties.center)) {
            feature2.properties.center[0] = Number(feature2.properties.center[0]);
            feature2.properties.center[1] = Number(feature2.properties.center[1]);
          }
        } else {
          feature2.properties = {};
        }
        if (!feature2.id)
          feature2.id = generateUid();
        if (!feature2.properties.category)
          feature2.properties.category = "custom";
        if (!feature2.properties.parentType)
          feature2.properties.parentType = "orphan";
      });
      return geojsonData;
    } catch (error2) {
      console.error("Error converting SHP to GeoJSON:", error2);
    }
    return null;
  }
}
function uncurryThis(target) {
  return (thisArg, ...args) => {
    return ReflectApply$1(target, thisArg, args);
  };
}
function uncurryThisGetter(target, key) {
  return uncurryThis(
    ReflectGetOwnPropertyDescriptor(
      target,
      key
    ).get
  );
}
const {
  apply: ReflectApply$1,
  construct: ReflectConstruct,
  defineProperty: ReflectDefineProperty,
  get: ReflectGet,
  getOwnPropertyDescriptor: ReflectGetOwnPropertyDescriptor,
  getPrototypeOf: ReflectGetPrototypeOf,
  has: ReflectHas,
  ownKeys: ReflectOwnKeys$1,
  set: ReflectSet,
  setPrototypeOf: ReflectSetPrototypeOf
} = Reflect;
const {
  iterator: SymbolIterator,
  species: SymbolSpecies,
  toStringTag: SymbolToStringTag,
  for: SymbolFor
} = Symbol;
const NativeObject = Object;
const {
  create: ObjectCreate,
  defineProperty: ObjectDefineProperty,
  freeze: ObjectFreeze,
  is: ObjectIs
} = NativeObject;
const NativeArray = Array;
const ArrayPrototype = NativeArray.prototype;
const NativeArrayPrototypeSymbolIterator = ArrayPrototype[SymbolIterator];
const ArrayPrototypeSymbolIterator = uncurryThis(NativeArrayPrototypeSymbolIterator);
const NativeArrayBuffer = ArrayBuffer;
const ArrayBufferPrototype = NativeArrayBuffer.prototype;
uncurryThisGetter(ArrayBufferPrototype, "byteLength");
const NativeSharedArrayBuffer = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : null;
NativeSharedArrayBuffer && uncurryThisGetter(NativeSharedArrayBuffer.prototype, "byteLength");
const TypedArray = ReflectGetPrototypeOf(Uint8Array);
TypedArray.from;
const TypedArrayPrototype = TypedArray.prototype;
TypedArrayPrototype[SymbolIterator];
uncurryThis(TypedArrayPrototype.keys);
uncurryThis(
  TypedArrayPrototype.values
);
uncurryThis(
  TypedArrayPrototype.entries
);
uncurryThis(TypedArrayPrototype.set);
uncurryThis(
  TypedArrayPrototype.reverse
);
uncurryThis(TypedArrayPrototype.fill);
uncurryThis(
  TypedArrayPrototype.copyWithin
);
uncurryThis(TypedArrayPrototype.sort);
uncurryThis(TypedArrayPrototype.slice);
uncurryThis(
  TypedArrayPrototype.subarray
);
uncurryThisGetter(
  TypedArrayPrototype,
  "buffer"
);
uncurryThisGetter(
  TypedArrayPrototype,
  "byteOffset"
);
uncurryThisGetter(
  TypedArrayPrototype,
  "length"
);
uncurryThisGetter(
  TypedArrayPrototype,
  SymbolToStringTag
);
const NativeUint8Array = Uint8Array;
const NativeUint16Array = Uint16Array;
const NativeUint32Array = Uint32Array;
const NativeFloat32Array = Float32Array;
const ArrayIteratorPrototype = ReflectGetPrototypeOf([][SymbolIterator]());
const ArrayIteratorPrototypeNext = uncurryThis(ArrayIteratorPrototype.next);
const GeneratorPrototypeNext = uncurryThis(function* () {
}().next);
const IteratorPrototype = ReflectGetPrototypeOf(ArrayIteratorPrototype);
const DataViewPrototype = DataView.prototype;
const DataViewPrototypeGetUint16 = uncurryThis(
  DataViewPrototype.getUint16
);
const NativeWeakMap = WeakMap;
const WeakMapPrototype = NativeWeakMap.prototype;
const WeakMapPrototypeGet = uncurryThis(WeakMapPrototype.get);
const WeakMapPrototypeSet = uncurryThis(WeakMapPrototype.set);
const arrayIterators = new NativeWeakMap();
const SafeIteratorPrototype = ObjectCreate(null, {
  next: {
    value: function next3() {
      const arrayIterator = WeakMapPrototypeGet(arrayIterators, this);
      return ArrayIteratorPrototypeNext(arrayIterator);
    }
  },
  [SymbolIterator]: {
    value: function values3() {
      return this;
    }
  }
});
function safeIfNeeded(array2) {
  if (array2[SymbolIterator] === NativeArrayPrototypeSymbolIterator && ArrayIteratorPrototype.next === ArrayIteratorPrototypeNext) {
    return array2;
  }
  const safe = ObjectCreate(SafeIteratorPrototype);
  WeakMapPrototypeSet(arrayIterators, safe, ArrayPrototypeSymbolIterator(array2));
  return safe;
}
const generators = new NativeWeakMap();
const DummyArrayIteratorPrototype = ObjectCreate(IteratorPrototype, {
  next: {
    value: function next4() {
      const generator = WeakMapPrototypeGet(generators, this);
      return GeneratorPrototypeNext(generator);
    },
    writable: true,
    configurable: true
  }
});
for (const key of ReflectOwnKeys$1(ArrayIteratorPrototype)) {
  if (key === "next") {
    continue;
  }
  ObjectDefineProperty(DummyArrayIteratorPrototype, key, ReflectGetOwnPropertyDescriptor(ArrayIteratorPrototype, key));
}
const buffer = new NativeArrayBuffer(4);
const floatView = new NativeFloat32Array(buffer);
const uint32View = new NativeUint32Array(buffer);
const baseTable = new NativeUint16Array(512);
const shiftTable = new NativeUint8Array(512);
for (let i2 = 0; i2 < 256; ++i2) {
  const e3 = i2 - 127;
  if (e3 < -27) {
    baseTable[i2] = 0;
    baseTable[i2 | 256] = 32768;
    shiftTable[i2] = 24;
    shiftTable[i2 | 256] = 24;
  } else if (e3 < -14) {
    baseTable[i2] = 1024 >> -e3 - 14;
    baseTable[i2 | 256] = 1024 >> -e3 - 14 | 32768;
    shiftTable[i2] = -e3 - 1;
    shiftTable[i2 | 256] = -e3 - 1;
  } else if (e3 <= 15) {
    baseTable[i2] = e3 + 15 << 10;
    baseTable[i2 | 256] = e3 + 15 << 10 | 32768;
    shiftTable[i2] = 13;
    shiftTable[i2 | 256] = 13;
  } else if (e3 < 128) {
    baseTable[i2] = 31744;
    baseTable[i2 | 256] = 64512;
    shiftTable[i2] = 24;
    shiftTable[i2 | 256] = 24;
  } else {
    baseTable[i2] = 31744;
    baseTable[i2 | 256] = 64512;
    shiftTable[i2] = 13;
    shiftTable[i2 | 256] = 13;
  }
}
const mantissaTable = new NativeUint32Array(2048);
for (let i2 = 1; i2 < 1024; ++i2) {
  let m2 = i2 << 13;
  let e3 = 0;
  while ((m2 & 8388608) === 0) {
    m2 <<= 1;
    e3 -= 8388608;
  }
  m2 &= ~8388608;
  e3 += 947912704;
  mantissaTable[i2] = m2 | e3;
}
for (let i2 = 1024; i2 < 2048; ++i2) {
  mantissaTable[i2] = 939524096 + (i2 - 1024 << 13);
}
const exponentTable = new NativeUint32Array(64);
for (let i2 = 1; i2 < 31; ++i2) {
  exponentTable[i2] = i2 << 23;
}
exponentTable[31] = 1199570944;
exponentTable[32] = 2147483648;
for (let i2 = 33; i2 < 63; ++i2) {
  exponentTable[i2] = 2147483648 + (i2 - 32 << 23);
}
exponentTable[63] = 3347054592;
const offsetTable = new NativeUint16Array(64);
for (let i2 = 1; i2 < 64; ++i2) {
  if (i2 !== 32) {
    offsetTable[i2] = 1024;
  }
}
function convertToNumber(float16bits) {
  const i2 = float16bits >> 10;
  uint32View[0] = mantissaTable[offsetTable[i2] + (float16bits & 1023)] + exponentTable[i2];
  return floatView[0];
}
function getFloat16(dataView, byteOffset, ...opts) {
  return convertToNumber(
    DataViewPrototypeGetUint16(dataView, byteOffset, ...safeIfNeeded(opts))
  );
}
var getAttributeExports = {};
var getAttribute$1 = {
  get exports() {
    return getAttributeExports;
  },
  set exports(v5) {
    getAttributeExports = v5;
  }
};
function getAttribute(tag2, attributeName, options2) {
  const debug2 = options2 && options2.debug || false;
  if (debug2)
    console.log("[xml-utils] getting " + attributeName + " in " + tag2);
  const xml = typeof tag2 === "object" ? tag2.outer : tag2;
  const opening = xml.slice(0, xml.indexOf(">") + 1);
  const quotechars = ['"', "'"];
  for (let i2 = 0; i2 < quotechars.length; i2++) {
    const char = quotechars[i2];
    const pattern = attributeName + "\\=" + char + "([^" + char + "]*)" + char;
    if (debug2)
      console.log("[xml-utils] pattern:", pattern);
    const re = new RegExp(pattern);
    const match2 = re.exec(opening);
    if (debug2)
      console.log("[xml-utils] match:", match2);
    if (match2)
      return match2[1];
  }
}
getAttribute$1.exports = getAttribute;
getAttributeExports.default = getAttribute;
var findTagsByNameExports = {};
var findTagsByName$1 = {
  get exports() {
    return findTagsByNameExports;
  },
  set exports(v5) {
    findTagsByNameExports = v5;
  }
};
var findTagByNameExports = {};
var findTagByName$2 = {
  get exports() {
    return findTagByNameExports;
  },
  set exports(v5) {
    findTagByNameExports = v5;
  }
};
var indexOfMatchExports = {};
var indexOfMatch$2 = {
  get exports() {
    return indexOfMatchExports;
  },
  set exports(v5) {
    indexOfMatchExports = v5;
  }
};
function indexOfMatch$1(xml, pattern, startIndex) {
  const re = new RegExp(pattern);
  const match2 = re.exec(xml.slice(startIndex));
  if (match2)
    return startIndex + match2.index;
  else
    return -1;
}
indexOfMatch$2.exports = indexOfMatch$1;
indexOfMatchExports.default = indexOfMatch$1;
var indexOfMatchEndExports = {};
var indexOfMatchEnd$2 = {
  get exports() {
    return indexOfMatchEndExports;
  },
  set exports(v5) {
    indexOfMatchEndExports = v5;
  }
};
function indexOfMatchEnd$1(xml, pattern, startIndex) {
  const re = new RegExp(pattern);
  const match2 = re.exec(xml.slice(startIndex));
  if (match2)
    return startIndex + match2.index + match2[0].length - 1;
  else
    return -1;
}
indexOfMatchEnd$2.exports = indexOfMatchEnd$1;
indexOfMatchEndExports.default = indexOfMatchEnd$1;
var countSubstringExports = {};
var countSubstring$2 = {
  get exports() {
    return countSubstringExports;
  },
  set exports(v5) {
    countSubstringExports = v5;
  }
};
function countSubstring$1(string3, substring2) {
  const pattern = new RegExp(substring2, "g");
  const match2 = string3.match(pattern);
  return match2 ? match2.length : 0;
}
countSubstring$2.exports = countSubstring$1;
countSubstringExports.default = countSubstring$1;
const indexOfMatch = indexOfMatchExports;
const indexOfMatchEnd = indexOfMatchEndExports;
const countSubstring = countSubstringExports;
function findTagByName$1(xml, tagName, options2) {
  const debug2 = options2 && options2.debug || false;
  const nested = !(options2 && typeof options2.nested === false);
  const startIndex = options2 && options2.startIndex || 0;
  if (debug2)
    console.log("[xml-utils] starting findTagByName with", tagName, " and ", options2);
  const start2 = indexOfMatch(xml, `<${tagName}[ 
>/]`, startIndex);
  if (debug2)
    console.log("[xml-utils] start:", start2);
  if (start2 === -1)
    return void 0;
  const afterStart = xml.slice(start2 + tagName.length);
  let relativeEnd = indexOfMatchEnd(afterStart, "^[^<]*[ /]>", 0);
  const selfClosing = relativeEnd !== -1 && afterStart[relativeEnd - 1] === "/";
  if (debug2)
    console.log("[xml-utils] selfClosing:", selfClosing);
  if (selfClosing === false) {
    if (nested) {
      let startIndex2 = 0;
      let openings = 1;
      let closings = 0;
      while ((relativeEnd = indexOfMatchEnd(afterStart, "[ /]" + tagName + ">", startIndex2)) !== -1) {
        const clip2 = afterStart.substring(startIndex2, relativeEnd + 1);
        openings += countSubstring(clip2, "<" + tagName + "[ \n	>]");
        closings += countSubstring(clip2, "</" + tagName + ">");
        if (closings >= openings)
          break;
        startIndex2 = relativeEnd;
      }
    } else {
      relativeEnd = indexOfMatchEnd(afterStart, "[ /]" + tagName + ">", 0);
    }
  }
  const end = start2 + tagName.length + relativeEnd + 1;
  if (debug2)
    console.log("[xml-utils] end:", end);
  if (end === -1)
    return void 0;
  const outer = xml.slice(start2, end);
  let inner;
  if (selfClosing) {
    inner = null;
  } else {
    inner = outer.slice(outer.indexOf(">") + 1, outer.lastIndexOf("<"));
  }
  return { inner, outer, start: start2, end };
}
findTagByName$2.exports = findTagByName$1;
findTagByNameExports.default = findTagByName$1;
const findTagByName = findTagByNameExports;
function findTagsByName(xml, tagName, options2) {
  const tags = [];
  const debug2 = options2 && options2.debug || false;
  const nested = options2 && typeof options2.nested === "boolean" ? options2.nested : true;
  let startIndex = options2 && options2.startIndex || 0;
  let tag2;
  while (tag2 = findTagByName(xml, tagName, { debug: debug2, startIndex })) {
    if (nested) {
      startIndex = tag2.start + 1 + tagName.length;
    } else {
      startIndex = tag2.end;
    }
    tags.push(tag2);
  }
  if (debug2)
    console.log("findTagsByName found", tags.length, "tags");
  return tags;
}
findTagsByName$1.exports = findTagsByName;
findTagsByNameExports.default = findTagsByName;
const fieldTagNames = {
  // TIFF Baseline
  315: "Artist",
  258: "BitsPerSample",
  265: "CellLength",
  264: "CellWidth",
  320: "ColorMap",
  259: "Compression",
  33432: "Copyright",
  306: "DateTime",
  338: "ExtraSamples",
  266: "FillOrder",
  289: "FreeByteCounts",
  288: "FreeOffsets",
  291: "GrayResponseCurve",
  290: "GrayResponseUnit",
  316: "HostComputer",
  270: "ImageDescription",
  257: "ImageLength",
  256: "ImageWidth",
  271: "Make",
  281: "MaxSampleValue",
  280: "MinSampleValue",
  272: "Model",
  254: "NewSubfileType",
  274: "Orientation",
  262: "PhotometricInterpretation",
  284: "PlanarConfiguration",
  296: "ResolutionUnit",
  278: "RowsPerStrip",
  277: "SamplesPerPixel",
  305: "Software",
  279: "StripByteCounts",
  273: "StripOffsets",
  255: "SubfileType",
  263: "Threshholding",
  282: "XResolution",
  283: "YResolution",
  // TIFF Extended
  326: "BadFaxLines",
  327: "CleanFaxData",
  343: "ClipPath",
  328: "ConsecutiveBadFaxLines",
  433: "Decode",
  434: "DefaultImageColor",
  269: "DocumentName",
  336: "DotRange",
  321: "HalftoneHints",
  346: "Indexed",
  347: "JPEGTables",
  285: "PageName",
  297: "PageNumber",
  317: "Predictor",
  319: "PrimaryChromaticities",
  532: "ReferenceBlackWhite",
  339: "SampleFormat",
  340: "SMinSampleValue",
  341: "SMaxSampleValue",
  559: "StripRowCounts",
  330: "SubIFDs",
  292: "T4Options",
  293: "T6Options",
  325: "TileByteCounts",
  323: "TileLength",
  324: "TileOffsets",
  322: "TileWidth",
  301: "TransferFunction",
  318: "WhitePoint",
  344: "XClipPathUnits",
  286: "XPosition",
  529: "YCbCrCoefficients",
  531: "YCbCrPositioning",
  530: "YCbCrSubSampling",
  345: "YClipPathUnits",
  287: "YPosition",
  // EXIF
  37378: "ApertureValue",
  40961: "ColorSpace",
  36868: "DateTimeDigitized",
  36867: "DateTimeOriginal",
  34665: "Exif IFD",
  36864: "ExifVersion",
  33434: "ExposureTime",
  41728: "FileSource",
  37385: "Flash",
  40960: "FlashpixVersion",
  33437: "FNumber",
  42016: "ImageUniqueID",
  37384: "LightSource",
  37500: "MakerNote",
  37377: "ShutterSpeedValue",
  37510: "UserComment",
  // IPTC
  33723: "IPTC",
  // ICC
  34675: "ICC Profile",
  // XMP
  700: "XMP",
  // GDAL
  42112: "GDAL_METADATA",
  42113: "GDAL_NODATA",
  // Photoshop
  34377: "Photoshop",
  // GeoTiff
  33550: "ModelPixelScale",
  33922: "ModelTiepoint",
  34264: "ModelTransformation",
  34735: "GeoKeyDirectory",
  34736: "GeoDoubleParams",
  34737: "GeoAsciiParams",
  // LERC
  50674: "LercParameters"
};
const fieldTags = {};
for (const key in fieldTagNames) {
  if (fieldTagNames.hasOwnProperty(key)) {
    fieldTags[fieldTagNames[key]] = parseInt(key, 10);
  }
}
const arrayFields = [
  fieldTags.BitsPerSample,
  fieldTags.ExtraSamples,
  fieldTags.SampleFormat,
  fieldTags.StripByteCounts,
  fieldTags.StripOffsets,
  fieldTags.StripRowCounts,
  fieldTags.TileByteCounts,
  fieldTags.TileOffsets,
  fieldTags.SubIFDs
];
const fieldTypeNames = {
  1: "BYTE",
  2: "ASCII",
  3: "SHORT",
  4: "LONG",
  5: "RATIONAL",
  6: "SBYTE",
  7: "UNDEFINED",
  8: "SSHORT",
  9: "SLONG",
  10: "SRATIONAL",
  11: "FLOAT",
  12: "DOUBLE",
  // IFD offset, suggested by https://owl.phy.queensu.ca/~phil/exiftool/standards.html
  13: "IFD",
  // introduced by BigTIFF
  16: "LONG8",
  17: "SLONG8",
  18: "IFD8"
};
const fieldTypes = {};
for (const key in fieldTypeNames) {
  if (fieldTypeNames.hasOwnProperty(key)) {
    fieldTypes[fieldTypeNames[key]] = parseInt(key, 10);
  }
}
const photometricInterpretations = {
  WhiteIsZero: 0,
  BlackIsZero: 1,
  RGB: 2,
  Palette: 3,
  TransparencyMask: 4,
  CMYK: 5,
  YCbCr: 6,
  CIELab: 8,
  ICCLab: 9
};
const ExtraSamplesValues = {
  Unspecified: 0,
  Assocalpha: 1,
  Unassalpha: 2
};
const LercParameters = {
  Version: 0,
  AddCompression: 1
};
const LercAddCompression = {
  None: 0,
  Deflate: 1,
  Zstandard: 2
};
const geoKeyNames = {
  1024: "GTModelTypeGeoKey",
  1025: "GTRasterTypeGeoKey",
  1026: "GTCitationGeoKey",
  2048: "GeographicTypeGeoKey",
  2049: "GeogCitationGeoKey",
  2050: "GeogGeodeticDatumGeoKey",
  2051: "GeogPrimeMeridianGeoKey",
  2052: "GeogLinearUnitsGeoKey",
  2053: "GeogLinearUnitSizeGeoKey",
  2054: "GeogAngularUnitsGeoKey",
  2055: "GeogAngularUnitSizeGeoKey",
  2056: "GeogEllipsoidGeoKey",
  2057: "GeogSemiMajorAxisGeoKey",
  2058: "GeogSemiMinorAxisGeoKey",
  2059: "GeogInvFlatteningGeoKey",
  2060: "GeogAzimuthUnitsGeoKey",
  2061: "GeogPrimeMeridianLongGeoKey",
  2062: "GeogTOWGS84GeoKey",
  3072: "ProjectedCSTypeGeoKey",
  3073: "PCSCitationGeoKey",
  3074: "ProjectionGeoKey",
  3075: "ProjCoordTransGeoKey",
  3076: "ProjLinearUnitsGeoKey",
  3077: "ProjLinearUnitSizeGeoKey",
  3078: "ProjStdParallel1GeoKey",
  3079: "ProjStdParallel2GeoKey",
  3080: "ProjNatOriginLongGeoKey",
  3081: "ProjNatOriginLatGeoKey",
  3082: "ProjFalseEastingGeoKey",
  3083: "ProjFalseNorthingGeoKey",
  3084: "ProjFalseOriginLongGeoKey",
  3085: "ProjFalseOriginLatGeoKey",
  3086: "ProjFalseOriginEastingGeoKey",
  3087: "ProjFalseOriginNorthingGeoKey",
  3088: "ProjCenterLongGeoKey",
  3089: "ProjCenterLatGeoKey",
  3090: "ProjCenterEastingGeoKey",
  3091: "ProjCenterNorthingGeoKey",
  3092: "ProjScaleAtNatOriginGeoKey",
  3093: "ProjScaleAtCenterGeoKey",
  3094: "ProjAzimuthAngleGeoKey",
  3095: "ProjStraightVertPoleLongGeoKey",
  3096: "ProjRectifiedGridAngleGeoKey",
  4096: "VerticalCSTypeGeoKey",
  4097: "VerticalCitationGeoKey",
  4098: "VerticalDatumGeoKey",
  4099: "VerticalUnitsGeoKey"
};
function fromWhiteIsZero(raster, max3) {
  const { width, height } = raster;
  const rgbRaster = new Uint8Array(width * height * 3);
  let value;
  for (let i2 = 0, j2 = 0; i2 < raster.length; ++i2, j2 += 3) {
    value = 256 - raster[i2] / max3 * 256;
    rgbRaster[j2] = value;
    rgbRaster[j2 + 1] = value;
    rgbRaster[j2 + 2] = value;
  }
  return rgbRaster;
}
function fromBlackIsZero(raster, max3) {
  const { width, height } = raster;
  const rgbRaster = new Uint8Array(width * height * 3);
  let value;
  for (let i2 = 0, j2 = 0; i2 < raster.length; ++i2, j2 += 3) {
    value = raster[i2] / max3 * 256;
    rgbRaster[j2] = value;
    rgbRaster[j2 + 1] = value;
    rgbRaster[j2 + 2] = value;
  }
  return rgbRaster;
}
function fromPalette(raster, colorMap) {
  const { width, height } = raster;
  const rgbRaster = new Uint8Array(width * height * 3);
  const greenOffset = colorMap.length / 3;
  const blueOffset = colorMap.length / 3 * 2;
  for (let i2 = 0, j2 = 0; i2 < raster.length; ++i2, j2 += 3) {
    const mapIndex = raster[i2];
    rgbRaster[j2] = colorMap[mapIndex] / 65536 * 256;
    rgbRaster[j2 + 1] = colorMap[mapIndex + greenOffset] / 65536 * 256;
    rgbRaster[j2 + 2] = colorMap[mapIndex + blueOffset] / 65536 * 256;
  }
  return rgbRaster;
}
function fromCMYK(cmykRaster) {
  const { width, height } = cmykRaster;
  const rgbRaster = new Uint8Array(width * height * 3);
  for (let i2 = 0, j2 = 0; i2 < cmykRaster.length; i2 += 4, j2 += 3) {
    const c2 = cmykRaster[i2];
    const m2 = cmykRaster[i2 + 1];
    const y2 = cmykRaster[i2 + 2];
    const k2 = cmykRaster[i2 + 3];
    rgbRaster[j2] = 255 * ((255 - c2) / 256) * ((255 - k2) / 256);
    rgbRaster[j2 + 1] = 255 * ((255 - m2) / 256) * ((255 - k2) / 256);
    rgbRaster[j2 + 2] = 255 * ((255 - y2) / 256) * ((255 - k2) / 256);
  }
  return rgbRaster;
}
function fromYCbCr(yCbCrRaster) {
  const { width, height } = yCbCrRaster;
  const rgbRaster = new Uint8ClampedArray(width * height * 3);
  for (let i2 = 0, j2 = 0; i2 < yCbCrRaster.length; i2 += 3, j2 += 3) {
    const y2 = yCbCrRaster[i2];
    const cb2 = yCbCrRaster[i2 + 1];
    const cr = yCbCrRaster[i2 + 2];
    rgbRaster[j2] = y2 + 1.402 * (cr - 128);
    rgbRaster[j2 + 1] = y2 - 0.34414 * (cb2 - 128) - 0.71414 * (cr - 128);
    rgbRaster[j2 + 2] = y2 + 1.772 * (cb2 - 128);
  }
  return rgbRaster;
}
const Xn = 0.95047;
const Yn = 1;
const Zn = 1.08883;
function fromCIELab(cieLabRaster) {
  const { width, height } = cieLabRaster;
  const rgbRaster = new Uint8Array(width * height * 3);
  for (let i2 = 0, j2 = 0; i2 < cieLabRaster.length; i2 += 3, j2 += 3) {
    const L2 = cieLabRaster[i2 + 0];
    const a_ = cieLabRaster[i2 + 1] << 24 >> 24;
    const b_ = cieLabRaster[i2 + 2] << 24 >> 24;
    let y2 = (L2 + 16) / 116;
    let x2 = a_ / 500 + y2;
    let z2 = y2 - b_ / 200;
    let r2;
    let g2;
    let b2;
    x2 = Xn * (x2 * x2 * x2 > 8856e-6 ? x2 * x2 * x2 : (x2 - 16 / 116) / 7.787);
    y2 = Yn * (y2 * y2 * y2 > 8856e-6 ? y2 * y2 * y2 : (y2 - 16 / 116) / 7.787);
    z2 = Zn * (z2 * z2 * z2 > 8856e-6 ? z2 * z2 * z2 : (z2 - 16 / 116) / 7.787);
    r2 = x2 * 3.2406 + y2 * -1.5372 + z2 * -0.4986;
    g2 = x2 * -0.9689 + y2 * 1.8758 + z2 * 0.0415;
    b2 = x2 * 0.0557 + y2 * -0.204 + z2 * 1.057;
    r2 = r2 > 31308e-7 ? 1.055 * r2 ** (1 / 2.4) - 0.055 : 12.92 * r2;
    g2 = g2 > 31308e-7 ? 1.055 * g2 ** (1 / 2.4) - 0.055 : 12.92 * g2;
    b2 = b2 > 31308e-7 ? 1.055 * b2 ** (1 / 2.4) - 0.055 : 12.92 * b2;
    rgbRaster[j2] = Math.max(0, Math.min(1, r2)) * 255;
    rgbRaster[j2 + 1] = Math.max(0, Math.min(1, g2)) * 255;
    rgbRaster[j2 + 2] = Math.max(0, Math.min(1, b2)) * 255;
  }
  return rgbRaster;
}
const registry = /* @__PURE__ */ new Map();
function addDecoder(cases, importFn) {
  if (!Array.isArray(cases)) {
    cases = [cases];
  }
  cases.forEach((c2) => registry.set(c2, importFn));
}
async function getDecoder(fileDirectory) {
  const importFn = registry.get(fileDirectory.Compression);
  if (!importFn) {
    throw new Error(`Unknown compression method identifier: ${fileDirectory.Compression}`);
  }
  const Decoder = await importFn();
  return new Decoder(fileDirectory);
}
addDecoder([void 0, 1], () => import("./raw-251b2af2.mjs").then((m2) => m2.default));
addDecoder(5, () => import("./lzw-2396b20d.mjs").then((m2) => m2.default));
addDecoder(6, () => {
  throw new Error("old style JPEG compression is not supported.");
});
addDecoder(7, () => import("./jpeg-bc34f1df.mjs").then((m2) => m2.default));
addDecoder([8, 32946], () => import("./deflate-7201454f.mjs").then((m2) => m2.default));
addDecoder(32773, () => import("./packbits-b3165bea.mjs").then((m2) => m2.default));
addDecoder(
  34887,
  () => import("./lerc-e0297f7a.mjs").then(async (m2) => {
    await m2.zstd.init();
    return m2;
  }).then((m2) => m2.default)
);
addDecoder(50001, () => import("./webimage-ac67f128.mjs").then((m2) => m2.default));
function copyNewSize(array2, width, height, samplesPerPixel = 1) {
  return new (Object.getPrototypeOf(array2)).constructor(width * height * samplesPerPixel);
}
function resampleNearest(valueArrays, inWidth, inHeight, outWidth, outHeight) {
  const relX = inWidth / outWidth;
  const relY = inHeight / outHeight;
  return valueArrays.map((array2) => {
    const newArray = copyNewSize(array2, outWidth, outHeight);
    for (let y2 = 0; y2 < outHeight; ++y2) {
      const cy = Math.min(Math.round(relY * y2), inHeight - 1);
      for (let x2 = 0; x2 < outWidth; ++x2) {
        const cx = Math.min(Math.round(relX * x2), inWidth - 1);
        const value = array2[cy * inWidth + cx];
        newArray[y2 * outWidth + x2] = value;
      }
    }
    return newArray;
  });
}
function lerp$5(v0, v12, t2) {
  return (1 - t2) * v0 + t2 * v12;
}
function resampleBilinear(valueArrays, inWidth, inHeight, outWidth, outHeight) {
  const relX = inWidth / outWidth;
  const relY = inHeight / outHeight;
  return valueArrays.map((array2) => {
    const newArray = copyNewSize(array2, outWidth, outHeight);
    for (let y2 = 0; y2 < outHeight; ++y2) {
      const rawY = relY * y2;
      const yl = Math.floor(rawY);
      const yh = Math.min(Math.ceil(rawY), inHeight - 1);
      for (let x2 = 0; x2 < outWidth; ++x2) {
        const rawX = relX * x2;
        const tx = rawX % 1;
        const xl = Math.floor(rawX);
        const xh = Math.min(Math.ceil(rawX), inWidth - 1);
        const ll = array2[yl * inWidth + xl];
        const hl = array2[yl * inWidth + xh];
        const lh = array2[yh * inWidth + xl];
        const hh2 = array2[yh * inWidth + xh];
        const value = lerp$5(
          lerp$5(ll, hl, tx),
          lerp$5(lh, hh2, tx),
          rawY % 1
        );
        newArray[y2 * outWidth + x2] = value;
      }
    }
    return newArray;
  });
}
function resample(valueArrays, inWidth, inHeight, outWidth, outHeight, method = "nearest") {
  switch (method.toLowerCase()) {
    case "nearest":
      return resampleNearest(valueArrays, inWidth, inHeight, outWidth, outHeight);
    case "bilinear":
    case "linear":
      return resampleBilinear(valueArrays, inWidth, inHeight, outWidth, outHeight);
    default:
      throw new Error(`Unsupported resampling method: '${method}'`);
  }
}
function resampleNearestInterleaved(valueArray2, inWidth, inHeight, outWidth, outHeight, samples) {
  const relX = inWidth / outWidth;
  const relY = inHeight / outHeight;
  const newArray = copyNewSize(valueArray2, outWidth, outHeight, samples);
  for (let y2 = 0; y2 < outHeight; ++y2) {
    const cy = Math.min(Math.round(relY * y2), inHeight - 1);
    for (let x2 = 0; x2 < outWidth; ++x2) {
      const cx = Math.min(Math.round(relX * x2), inWidth - 1);
      for (let i2 = 0; i2 < samples; ++i2) {
        const value = valueArray2[cy * inWidth * samples + cx * samples + i2];
        newArray[y2 * outWidth * samples + x2 * samples + i2] = value;
      }
    }
  }
  return newArray;
}
function resampleBilinearInterleaved(valueArray2, inWidth, inHeight, outWidth, outHeight, samples) {
  const relX = inWidth / outWidth;
  const relY = inHeight / outHeight;
  const newArray = copyNewSize(valueArray2, outWidth, outHeight, samples);
  for (let y2 = 0; y2 < outHeight; ++y2) {
    const rawY = relY * y2;
    const yl = Math.floor(rawY);
    const yh = Math.min(Math.ceil(rawY), inHeight - 1);
    for (let x2 = 0; x2 < outWidth; ++x2) {
      const rawX = relX * x2;
      const tx = rawX % 1;
      const xl = Math.floor(rawX);
      const xh = Math.min(Math.ceil(rawX), inWidth - 1);
      for (let i2 = 0; i2 < samples; ++i2) {
        const ll = valueArray2[yl * inWidth * samples + xl * samples + i2];
        const hl = valueArray2[yl * inWidth * samples + xh * samples + i2];
        const lh = valueArray2[yh * inWidth * samples + xl * samples + i2];
        const hh2 = valueArray2[yh * inWidth * samples + xh * samples + i2];
        const value = lerp$5(
          lerp$5(ll, hl, tx),
          lerp$5(lh, hh2, tx),
          rawY % 1
        );
        newArray[y2 * outWidth * samples + x2 * samples + i2] = value;
      }
    }
  }
  return newArray;
}
function resampleInterleaved(valueArray2, inWidth, inHeight, outWidth, outHeight, samples, method = "nearest") {
  switch (method.toLowerCase()) {
    case "nearest":
      return resampleNearestInterleaved(
        valueArray2,
        inWidth,
        inHeight,
        outWidth,
        outHeight,
        samples
      );
    case "bilinear":
    case "linear":
      return resampleBilinearInterleaved(
        valueArray2,
        inWidth,
        inHeight,
        outWidth,
        outHeight,
        samples
      );
    default:
      throw new Error(`Unsupported resampling method: '${method}'`);
  }
}
function sum(array2, start2, end) {
  let s2 = 0;
  for (let i2 = start2; i2 < end; ++i2) {
    s2 += array2[i2];
  }
  return s2;
}
function arrayForType(format, bitsPerSample, size12) {
  switch (format) {
    case 1:
      if (bitsPerSample <= 8) {
        return new Uint8Array(size12);
      } else if (bitsPerSample <= 16) {
        return new Uint16Array(size12);
      } else if (bitsPerSample <= 32) {
        return new Uint32Array(size12);
      }
      break;
    case 2:
      if (bitsPerSample === 8) {
        return new Int8Array(size12);
      } else if (bitsPerSample === 16) {
        return new Int16Array(size12);
      } else if (bitsPerSample === 32) {
        return new Int32Array(size12);
      }
      break;
    case 3:
      switch (bitsPerSample) {
        case 16:
        case 32:
          return new Float32Array(size12);
        case 64:
          return new Float64Array(size12);
      }
      break;
  }
  throw Error("Unsupported data format/bitsPerSample");
}
function needsNormalization(format, bitsPerSample) {
  if ((format === 1 || format === 2) && bitsPerSample <= 32 && bitsPerSample % 8 === 0) {
    return false;
  } else if (format === 3 && (bitsPerSample === 16 || bitsPerSample === 32 || bitsPerSample === 64)) {
    return false;
  }
  return true;
}
function normalizeArray(inBuffer, format, planarConfiguration, samplesPerPixel, bitsPerSample, tileWidth, tileHeight) {
  const view2 = new DataView(inBuffer);
  const outSize = planarConfiguration === 2 ? tileHeight * tileWidth : tileHeight * tileWidth * samplesPerPixel;
  const samplesToTransfer = planarConfiguration === 2 ? 1 : samplesPerPixel;
  const outArray = arrayForType(format, bitsPerSample, outSize);
  const bitMask = parseInt("1".repeat(bitsPerSample), 2);
  if (format === 1) {
    let pixelBitSkip;
    if (planarConfiguration === 1) {
      pixelBitSkip = samplesPerPixel * bitsPerSample;
    } else {
      pixelBitSkip = bitsPerSample;
    }
    let bitsPerLine = tileWidth * pixelBitSkip;
    if ((bitsPerLine & 7) !== 0) {
      bitsPerLine = bitsPerLine + 7 & ~7;
    }
    for (let y2 = 0; y2 < tileHeight; ++y2) {
      const lineBitOffset = y2 * bitsPerLine;
      for (let x2 = 0; x2 < tileWidth; ++x2) {
        const pixelBitOffset = lineBitOffset + x2 * samplesToTransfer * bitsPerSample;
        for (let i2 = 0; i2 < samplesToTransfer; ++i2) {
          const bitOffset = pixelBitOffset + i2 * bitsPerSample;
          const outIndex = (y2 * tileWidth + x2) * samplesToTransfer + i2;
          const byteOffset = Math.floor(bitOffset / 8);
          const innerBitOffset = bitOffset % 8;
          if (innerBitOffset + bitsPerSample <= 8) {
            outArray[outIndex] = view2.getUint8(byteOffset) >> 8 - bitsPerSample - innerBitOffset & bitMask;
          } else if (innerBitOffset + bitsPerSample <= 16) {
            outArray[outIndex] = view2.getUint16(byteOffset) >> 16 - bitsPerSample - innerBitOffset & bitMask;
          } else if (innerBitOffset + bitsPerSample <= 24) {
            const raw = view2.getUint16(byteOffset) << 8 | view2.getUint8(byteOffset + 2);
            outArray[outIndex] = raw >> 24 - bitsPerSample - innerBitOffset & bitMask;
          } else {
            outArray[outIndex] = view2.getUint32(byteOffset) >> 32 - bitsPerSample - innerBitOffset & bitMask;
          }
        }
      }
    }
  }
  return outArray.buffer;
}
class GeoTIFFImage {
  /**
   * @constructor
   * @param {Object} fileDirectory The parsed file directory
   * @param {Object} geoKeys The parsed geo-keys
   * @param {DataView} dataView The DataView for the underlying file.
   * @param {Boolean} littleEndian Whether the file is encoded in little or big endian
   * @param {Boolean} cache Whether or not decoded tiles shall be cached
   * @param {import('./source/basesource').BaseSource} source The datasource to read from
   */
  constructor(fileDirectory, geoKeys, dataView, littleEndian, cache2, source) {
    this.fileDirectory = fileDirectory;
    this.geoKeys = geoKeys;
    this.dataView = dataView;
    this.littleEndian = littleEndian;
    this.tiles = cache2 ? {} : null;
    this.isTiled = !fileDirectory.StripOffsets;
    const planarConfiguration = fileDirectory.PlanarConfiguration;
    this.planarConfiguration = typeof planarConfiguration === "undefined" ? 1 : planarConfiguration;
    if (this.planarConfiguration !== 1 && this.planarConfiguration !== 2) {
      throw new Error("Invalid planar configuration.");
    }
    this.source = source;
  }
  /**
   * Returns the associated parsed file directory.
   * @returns {Object} the parsed file directory
   */
  getFileDirectory() {
    return this.fileDirectory;
  }
  /**
   * Returns the associated parsed geo keys.
   * @returns {Object} the parsed geo keys
   */
  getGeoKeys() {
    return this.geoKeys;
  }
  /**
   * Returns the width of the image.
   * @returns {Number} the width of the image
   */
  getWidth() {
    return this.fileDirectory.ImageWidth;
  }
  /**
   * Returns the height of the image.
   * @returns {Number} the height of the image
   */
  getHeight() {
    return this.fileDirectory.ImageLength;
  }
  /**
   * Returns the number of samples per pixel.
   * @returns {Number} the number of samples per pixel
   */
  getSamplesPerPixel() {
    return typeof this.fileDirectory.SamplesPerPixel !== "undefined" ? this.fileDirectory.SamplesPerPixel : 1;
  }
  /**
   * Returns the width of each tile.
   * @returns {Number} the width of each tile
   */
  getTileWidth() {
    return this.isTiled ? this.fileDirectory.TileWidth : this.getWidth();
  }
  /**
   * Returns the height of each tile.
   * @returns {Number} the height of each tile
   */
  getTileHeight() {
    if (this.isTiled) {
      return this.fileDirectory.TileLength;
    }
    if (typeof this.fileDirectory.RowsPerStrip !== "undefined") {
      return Math.min(this.fileDirectory.RowsPerStrip, this.getHeight());
    }
    return this.getHeight();
  }
  getBlockWidth() {
    return this.getTileWidth();
  }
  getBlockHeight(y2) {
    if (this.isTiled || (y2 + 1) * this.getTileHeight() <= this.getHeight()) {
      return this.getTileHeight();
    } else {
      return this.getHeight() - y2 * this.getTileHeight();
    }
  }
  /**
   * Calculates the number of bytes for each pixel across all samples. Only full
   * bytes are supported, an exception is thrown when this is not the case.
   * @returns {Number} the bytes per pixel
   */
  getBytesPerPixel() {
    let bytes = 0;
    for (let i2 = 0; i2 < this.fileDirectory.BitsPerSample.length; ++i2) {
      bytes += this.getSampleByteSize(i2);
    }
    return bytes;
  }
  getSampleByteSize(i2) {
    if (i2 >= this.fileDirectory.BitsPerSample.length) {
      throw new RangeError(`Sample index ${i2} is out of range.`);
    }
    return Math.ceil(this.fileDirectory.BitsPerSample[i2] / 8);
  }
  getReaderForSample(sampleIndex) {
    const format = this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[sampleIndex] : 1;
    const bitsPerSample = this.fileDirectory.BitsPerSample[sampleIndex];
    switch (format) {
      case 1:
        if (bitsPerSample <= 8) {
          return DataView.prototype.getUint8;
        } else if (bitsPerSample <= 16) {
          return DataView.prototype.getUint16;
        } else if (bitsPerSample <= 32) {
          return DataView.prototype.getUint32;
        }
        break;
      case 2:
        if (bitsPerSample <= 8) {
          return DataView.prototype.getInt8;
        } else if (bitsPerSample <= 16) {
          return DataView.prototype.getInt16;
        } else if (bitsPerSample <= 32) {
          return DataView.prototype.getInt32;
        }
        break;
      case 3:
        switch (bitsPerSample) {
          case 16:
            return function(offset, littleEndian) {
              return getFloat16(this, offset, littleEndian);
            };
          case 32:
            return DataView.prototype.getFloat32;
          case 64:
            return DataView.prototype.getFloat64;
        }
        break;
    }
    throw Error("Unsupported data format/bitsPerSample");
  }
  getSampleFormat(sampleIndex = 0) {
    return this.fileDirectory.SampleFormat ? this.fileDirectory.SampleFormat[sampleIndex] : 1;
  }
  getBitsPerSample(sampleIndex = 0) {
    return this.fileDirectory.BitsPerSample[sampleIndex];
  }
  getArrayForSample(sampleIndex, size12) {
    const format = this.getSampleFormat(sampleIndex);
    const bitsPerSample = this.getBitsPerSample(sampleIndex);
    return arrayForType(format, bitsPerSample, size12);
  }
  /**
   * Returns the decoded strip or tile.
   * @param {Number} x the strip or tile x-offset
   * @param {Number} y the tile y-offset (0 for stripped images)
   * @param {Number} sample the sample to get for separated samples
   * @param {import("./geotiff").Pool|import("./geotiff").BaseDecoder} poolOrDecoder the decoder or decoder pool
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   * @returns {Promise.<ArrayBuffer>}
   */
  async getTileOrStrip(x2, y2, sample, poolOrDecoder, signal) {
    const numTilesPerRow = Math.ceil(this.getWidth() / this.getTileWidth());
    const numTilesPerCol = Math.ceil(this.getHeight() / this.getTileHeight());
    let index2;
    const { tiles } = this;
    if (this.planarConfiguration === 1) {
      index2 = y2 * numTilesPerRow + x2;
    } else if (this.planarConfiguration === 2) {
      index2 = sample * numTilesPerRow * numTilesPerCol + y2 * numTilesPerRow + x2;
    }
    let offset;
    let byteCount;
    if (this.isTiled) {
      offset = this.fileDirectory.TileOffsets[index2];
      byteCount = this.fileDirectory.TileByteCounts[index2];
    } else {
      offset = this.fileDirectory.StripOffsets[index2];
      byteCount = this.fileDirectory.StripByteCounts[index2];
    }
    const slice2 = (await this.source.fetch([{ offset, length: byteCount }], signal))[0];
    let request;
    if (tiles === null || !tiles[index2]) {
      request = (async () => {
        let data2 = await poolOrDecoder.decode(this.fileDirectory, slice2);
        const sampleFormat = this.getSampleFormat();
        const bitsPerSample = this.getBitsPerSample();
        if (needsNormalization(sampleFormat, bitsPerSample)) {
          data2 = normalizeArray(
            data2,
            sampleFormat,
            this.planarConfiguration,
            this.getSamplesPerPixel(),
            bitsPerSample,
            this.getTileWidth(),
            this.getBlockHeight(y2)
          );
        }
        return data2;
      })();
      if (tiles !== null) {
        tiles[index2] = request;
      }
    } else {
      request = tiles[index2];
    }
    return { x: x2, y: y2, sample, data: await request };
  }
  /**
   * Internal read function.
   * @private
   * @param {Array} imageWindow The image window in pixel coordinates
   * @param {Array} samples The selected samples (0-based indices)
   * @param {TypedArray|TypedArray[]} valueArrays The array(s) to write into
   * @param {Boolean} interleave Whether or not to write in an interleaved manner
   * @param {import("./geotiff").Pool|AbstractDecoder} poolOrDecoder the decoder or decoder pool
   * @param {number} width the width of window to be read into
   * @param {number} height the height of window to be read into
   * @param {number} resampleMethod the resampling method to be used when interpolating
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   * @returns {Promise<ReadRasterResult>}
   */
  async _readRaster(imageWindow, samples, valueArrays, interleave, poolOrDecoder, width, height, resampleMethod, signal) {
    const tileWidth = this.getTileWidth();
    const tileHeight = this.getTileHeight();
    const imageWidth = this.getWidth();
    const imageHeight = this.getHeight();
    const minXTile = Math.max(Math.floor(imageWindow[0] / tileWidth), 0);
    const maxXTile = Math.min(
      Math.ceil(imageWindow[2] / tileWidth),
      Math.ceil(imageWidth / tileWidth)
    );
    const minYTile = Math.max(Math.floor(imageWindow[1] / tileHeight), 0);
    const maxYTile = Math.min(
      Math.ceil(imageWindow[3] / tileHeight),
      Math.ceil(imageHeight / tileHeight)
    );
    const windowWidth = imageWindow[2] - imageWindow[0];
    let bytesPerPixel = this.getBytesPerPixel();
    const srcSampleOffsets = [];
    const sampleReaders = [];
    for (let i2 = 0; i2 < samples.length; ++i2) {
      if (this.planarConfiguration === 1) {
        srcSampleOffsets.push(sum(this.fileDirectory.BitsPerSample, 0, samples[i2]) / 8);
      } else {
        srcSampleOffsets.push(0);
      }
      sampleReaders.push(this.getReaderForSample(samples[i2]));
    }
    const promises = [];
    const { littleEndian } = this;
    for (let yTile = minYTile; yTile < maxYTile; ++yTile) {
      for (let xTile = minXTile; xTile < maxXTile; ++xTile) {
        let getPromise;
        if (this.planarConfiguration === 1) {
          getPromise = this.getTileOrStrip(xTile, yTile, 0, poolOrDecoder, signal);
        }
        for (let sampleIndex = 0; sampleIndex < samples.length; ++sampleIndex) {
          const si = sampleIndex;
          const sample = samples[sampleIndex];
          if (this.planarConfiguration === 2) {
            bytesPerPixel = this.getSampleByteSize(sample);
            getPromise = this.getTileOrStrip(xTile, yTile, sample, poolOrDecoder, signal);
          }
          const promise = getPromise.then((tile) => {
            const buffer3 = tile.data;
            const dataView = new DataView(buffer3);
            const blockHeight = this.getBlockHeight(tile.y);
            const firstLine = tile.y * tileHeight;
            const firstCol = tile.x * tileWidth;
            const lastLine = firstLine + blockHeight;
            const lastCol = (tile.x + 1) * tileWidth;
            const reader = sampleReaders[si];
            const ymax = Math.min(blockHeight, blockHeight - (lastLine - imageWindow[3]), imageHeight - firstLine);
            const xmax = Math.min(tileWidth, tileWidth - (lastCol - imageWindow[2]), imageWidth - firstCol);
            for (let y2 = Math.max(0, imageWindow[1] - firstLine); y2 < ymax; ++y2) {
              for (let x2 = Math.max(0, imageWindow[0] - firstCol); x2 < xmax; ++x2) {
                const pixelOffset = (y2 * tileWidth + x2) * bytesPerPixel;
                const value = reader.call(
                  dataView,
                  pixelOffset + srcSampleOffsets[si],
                  littleEndian
                );
                let windowCoordinate;
                if (interleave) {
                  windowCoordinate = (y2 + firstLine - imageWindow[1]) * windowWidth * samples.length + (x2 + firstCol - imageWindow[0]) * samples.length + si;
                  valueArrays[windowCoordinate] = value;
                } else {
                  windowCoordinate = (y2 + firstLine - imageWindow[1]) * windowWidth + x2 + firstCol - imageWindow[0];
                  valueArrays[si][windowCoordinate] = value;
                }
              }
            }
          });
          promises.push(promise);
        }
      }
    }
    await Promise.all(promises);
    if (width && imageWindow[2] - imageWindow[0] !== width || height && imageWindow[3] - imageWindow[1] !== height) {
      let resampled;
      if (interleave) {
        resampled = resampleInterleaved(
          valueArrays,
          imageWindow[2] - imageWindow[0],
          imageWindow[3] - imageWindow[1],
          width,
          height,
          samples.length,
          resampleMethod
        );
      } else {
        resampled = resample(
          valueArrays,
          imageWindow[2] - imageWindow[0],
          imageWindow[3] - imageWindow[1],
          width,
          height,
          resampleMethod
        );
      }
      resampled.width = width;
      resampled.height = height;
      return resampled;
    }
    valueArrays.width = width || imageWindow[2] - imageWindow[0];
    valueArrays.height = height || imageWindow[3] - imageWindow[1];
    return valueArrays;
  }
  /**
   * Reads raster data from the image. This function reads all selected samples
   * into separate arrays of the correct type for that sample or into a single
   * combined array when `interleave` is set. When provided, only a subset
   * of the raster is read for each sample.
   *
   * @param {ReadRasterOptions} [options={}] optional parameters
   * @returns {Promise<ReadRasterResult>} the decoded arrays as a promise
   */
  async readRasters({
    window: wnd,
    samples = [],
    interleave,
    pool = null,
    width,
    height,
    resampleMethod,
    fillValue,
    signal
  } = {}) {
    const imageWindow = wnd || [0, 0, this.getWidth(), this.getHeight()];
    if (imageWindow[0] > imageWindow[2] || imageWindow[1] > imageWindow[3]) {
      throw new Error("Invalid subsets");
    }
    const imageWindowWidth = imageWindow[2] - imageWindow[0];
    const imageWindowHeight = imageWindow[3] - imageWindow[1];
    const numPixels = imageWindowWidth * imageWindowHeight;
    const samplesPerPixel = this.getSamplesPerPixel();
    if (!samples || !samples.length) {
      for (let i2 = 0; i2 < samplesPerPixel; ++i2) {
        samples.push(i2);
      }
    } else {
      for (let i2 = 0; i2 < samples.length; ++i2) {
        if (samples[i2] >= samplesPerPixel) {
          return Promise.reject(new RangeError(`Invalid sample index '${samples[i2]}'.`));
        }
      }
    }
    let valueArrays;
    if (interleave) {
      const format = this.fileDirectory.SampleFormat ? Math.max.apply(null, this.fileDirectory.SampleFormat) : 1;
      const bitsPerSample = Math.max.apply(null, this.fileDirectory.BitsPerSample);
      valueArrays = arrayForType(format, bitsPerSample, numPixels * samples.length);
      if (fillValue) {
        valueArrays.fill(fillValue);
      }
    } else {
      valueArrays = [];
      for (let i2 = 0; i2 < samples.length; ++i2) {
        const valueArray2 = this.getArrayForSample(samples[i2], numPixels);
        if (Array.isArray(fillValue) && i2 < fillValue.length) {
          valueArray2.fill(fillValue[i2]);
        } else if (fillValue && !Array.isArray(fillValue)) {
          valueArray2.fill(fillValue);
        }
        valueArrays.push(valueArray2);
      }
    }
    const poolOrDecoder = pool || await getDecoder(this.fileDirectory);
    const result = await this._readRaster(
      imageWindow,
      samples,
      valueArrays,
      interleave,
      poolOrDecoder,
      width,
      height,
      resampleMethod,
      signal
    );
    return result;
  }
  /**
   * Reads raster data from the image as RGB. The result is always an
   * interleaved typed array.
   * Colorspaces other than RGB will be transformed to RGB, color maps expanded.
   * When no other method is applicable, the first sample is used to produce a
   * grayscale image.
   * When provided, only a subset of the raster is read for each sample.
   *
   * @param {Object} [options] optional parameters
   * @param {Array<number>} [options.window] the subset to read data from in pixels.
   * @param {boolean} [options.interleave=true] whether the data shall be read
   *                                             in one single array or separate
   *                                             arrays.
   * @param {import("./geotiff").Pool} [options.pool=null] The optional decoder pool to use.
   * @param {number} [options.width] The desired width of the output. When the width is no the
   *                                 same as the images, resampling will be performed.
   * @param {number} [options.height] The desired height of the output. When the width is no the
   *                                  same as the images, resampling will be performed.
   * @param {string} [options.resampleMethod='nearest'] The desired resampling method.
   * @param {boolean} [options.enableAlpha=false] Enable reading alpha channel if present.
   * @param {AbortSignal} [options.signal] An AbortSignal that may be signalled if the request is
   *                                       to be aborted
   * @returns {Promise<ReadRasterResult>} the RGB array as a Promise
   */
  async readRGB({
    window: window2,
    interleave = true,
    pool = null,
    width,
    height,
    resampleMethod,
    enableAlpha = false,
    signal
  } = {}) {
    const imageWindow = window2 || [0, 0, this.getWidth(), this.getHeight()];
    if (imageWindow[0] > imageWindow[2] || imageWindow[1] > imageWindow[3]) {
      throw new Error("Invalid subsets");
    }
    const pi2 = this.fileDirectory.PhotometricInterpretation;
    if (pi2 === photometricInterpretations.RGB) {
      let s2 = [0, 1, 2];
      if (!(this.fileDirectory.ExtraSamples === ExtraSamplesValues.Unspecified) && enableAlpha) {
        s2 = [];
        for (let i2 = 0; i2 < this.fileDirectory.BitsPerSample.length; i2 += 1) {
          s2.push(i2);
        }
      }
      return this.readRasters({
        window: window2,
        interleave,
        samples: s2,
        pool,
        width,
        height,
        resampleMethod,
        signal
      });
    }
    let samples;
    switch (pi2) {
      case photometricInterpretations.WhiteIsZero:
      case photometricInterpretations.BlackIsZero:
      case photometricInterpretations.Palette:
        samples = [0];
        break;
      case photometricInterpretations.CMYK:
        samples = [0, 1, 2, 3];
        break;
      case photometricInterpretations.YCbCr:
      case photometricInterpretations.CIELab:
        samples = [0, 1, 2];
        break;
      default:
        throw new Error("Invalid or unsupported photometric interpretation.");
    }
    const subOptions = {
      window: imageWindow,
      interleave: true,
      samples,
      pool,
      width,
      height,
      resampleMethod,
      signal
    };
    const { fileDirectory } = this;
    const raster = await this.readRasters(subOptions);
    const max3 = 2 ** this.fileDirectory.BitsPerSample[0];
    let data2;
    switch (pi2) {
      case photometricInterpretations.WhiteIsZero:
        data2 = fromWhiteIsZero(raster, max3);
        break;
      case photometricInterpretations.BlackIsZero:
        data2 = fromBlackIsZero(raster, max3);
        break;
      case photometricInterpretations.Palette:
        data2 = fromPalette(raster, fileDirectory.ColorMap);
        break;
      case photometricInterpretations.CMYK:
        data2 = fromCMYK(raster);
        break;
      case photometricInterpretations.YCbCr:
        data2 = fromYCbCr(raster);
        break;
      case photometricInterpretations.CIELab:
        data2 = fromCIELab(raster);
        break;
      default:
        throw new Error("Unsupported photometric interpretation.");
    }
    if (!interleave) {
      const red2 = new Uint8Array(data2.length / 3);
      const green2 = new Uint8Array(data2.length / 3);
      const blue2 = new Uint8Array(data2.length / 3);
      for (let i2 = 0, j2 = 0; i2 < data2.length; i2 += 3, ++j2) {
        red2[j2] = data2[i2];
        green2[j2] = data2[i2 + 1];
        blue2[j2] = data2[i2 + 2];
      }
      data2 = [red2, green2, blue2];
    }
    data2.width = raster.width;
    data2.height = raster.height;
    return data2;
  }
  /**
   * Returns an array of tiepoints.
   * @returns {Object[]}
   */
  getTiePoints() {
    if (!this.fileDirectory.ModelTiepoint) {
      return [];
    }
    const tiePoints = [];
    for (let i2 = 0; i2 < this.fileDirectory.ModelTiepoint.length; i2 += 6) {
      tiePoints.push({
        i: this.fileDirectory.ModelTiepoint[i2],
        j: this.fileDirectory.ModelTiepoint[i2 + 1],
        k: this.fileDirectory.ModelTiepoint[i2 + 2],
        x: this.fileDirectory.ModelTiepoint[i2 + 3],
        y: this.fileDirectory.ModelTiepoint[i2 + 4],
        z: this.fileDirectory.ModelTiepoint[i2 + 5]
      });
    }
    return tiePoints;
  }
  /**
   * Returns the parsed GDAL metadata items.
   *
   * If sample is passed to null, dataset-level metadata will be returned.
   * Otherwise only metadata specific to the provided sample will be returned.
   *
   * @param {number} [sample=null] The sample index.
   * @returns {Object}
   */
  getGDALMetadata(sample = null) {
    const metadata = {};
    if (!this.fileDirectory.GDAL_METADATA) {
      return null;
    }
    const string3 = this.fileDirectory.GDAL_METADATA;
    let items = findTagsByNameExports(string3, "Item");
    if (sample === null) {
      items = items.filter((item) => getAttributeExports(item, "sample") === void 0);
    } else {
      items = items.filter((item) => Number(getAttributeExports(item, "sample")) === sample);
    }
    for (let i2 = 0; i2 < items.length; ++i2) {
      const item = items[i2];
      metadata[getAttributeExports(item, "name")] = item.inner;
    }
    return metadata;
  }
  /**
   * Returns the GDAL nodata value
   * @returns {number|null}
   */
  getGDALNoData() {
    if (!this.fileDirectory.GDAL_NODATA) {
      return null;
    }
    const string3 = this.fileDirectory.GDAL_NODATA;
    return Number(string3.substring(0, string3.length - 1));
  }
  /**
   * Returns the image origin as a XYZ-vector. When the image has no affine
   * transformation, then an exception is thrown.
   * @returns {Array<number>} The origin as a vector
   */
  getOrigin() {
    const tiePoints = this.fileDirectory.ModelTiepoint;
    const modelTransformation = this.fileDirectory.ModelTransformation;
    if (tiePoints && tiePoints.length === 6) {
      return [
        tiePoints[3],
        tiePoints[4],
        tiePoints[5]
      ];
    }
    if (modelTransformation) {
      return [
        modelTransformation[3],
        modelTransformation[7],
        modelTransformation[11]
      ];
    }
    throw new Error("The image does not have an affine transformation.");
  }
  /**
   * Returns the image resolution as a XYZ-vector. When the image has no affine
   * transformation, then an exception is thrown.
   * @param {GeoTIFFImage} [referenceImage=null] A reference image to calculate the resolution from
   *                                             in cases when the current image does not have the
   *                                             required tags on its own.
   * @returns {Array<number>} The resolution as a vector
   */
  getResolution(referenceImage = null) {
    const modelPixelScale = this.fileDirectory.ModelPixelScale;
    const modelTransformation = this.fileDirectory.ModelTransformation;
    if (modelPixelScale) {
      return [
        modelPixelScale[0],
        -modelPixelScale[1],
        modelPixelScale[2]
      ];
    }
    if (modelTransformation) {
      if (modelTransformation[1] === 0 && modelTransformation[4] === 0) {
        return [
          modelTransformation[0],
          -modelTransformation[5],
          modelTransformation[10]
        ];
      }
      return [
        Math.sqrt(modelTransformation[0] * modelTransformation[0] + modelTransformation[4] * modelTransformation[4]),
        -Math.sqrt(modelTransformation[1] * modelTransformation[1] + modelTransformation[5] * modelTransformation[5]),
        modelTransformation[10]
      ];
    }
    if (referenceImage) {
      const [refResX, refResY, refResZ] = referenceImage.getResolution();
      return [
        refResX * referenceImage.getWidth() / this.getWidth(),
        refResY * referenceImage.getHeight() / this.getHeight(),
        refResZ * referenceImage.getWidth() / this.getWidth()
      ];
    }
    throw new Error("The image does not have an affine transformation.");
  }
  /**
   * Returns whether or not the pixels of the image depict an area (or point).
   * @returns {Boolean} Whether the pixels are a point
   */
  pixelIsArea() {
    return this.geoKeys.GTRasterTypeGeoKey === 1;
  }
  /**
   * Returns the image bounding box as an array of 4 values: min-x, min-y,
   * max-x and max-y. When the image has no affine transformation, then an
   * exception is thrown.
   * @param {boolean} [tilegrid=false] If true return extent for a tilegrid
   *                                   without adjustment for ModelTransformation.
   * @returns {Array<number>} The bounding box
   */
  getBoundingBox(tilegrid = false) {
    const height = this.getHeight();
    const width = this.getWidth();
    if (this.fileDirectory.ModelTransformation && !tilegrid) {
      const [a2, b2, c2, d2, e3, f2, g2, h2] = this.fileDirectory.ModelTransformation;
      const corners = [
        [0, 0],
        [0, height],
        [width, 0],
        [width, height]
      ];
      const projected = corners.map(([I2, J2]) => [
        d2 + a2 * I2 + b2 * J2,
        h2 + e3 * I2 + f2 * J2
      ]);
      const xs = projected.map((pt) => pt[0]);
      const ys = projected.map((pt) => pt[1]);
      return [
        Math.min(...xs),
        Math.min(...ys),
        Math.max(...xs),
        Math.max(...ys)
      ];
    } else {
      const origin = this.getOrigin();
      const resolution = this.getResolution();
      const x12 = origin[0];
      const y12 = origin[1];
      const x2 = x12 + resolution[0] * width;
      const y2 = y12 + resolution[1] * height;
      return [
        Math.min(x12, x2),
        Math.min(y12, y2),
        Math.max(x12, x2),
        Math.max(y12, y2)
      ];
    }
  }
}
const GeoTIFFImage$1 = GeoTIFFImage;
class DataView64 {
  constructor(arrayBuffer2) {
    this._dataView = new DataView(arrayBuffer2);
  }
  get buffer() {
    return this._dataView.buffer;
  }
  getUint64(offset, littleEndian) {
    const left = this.getUint32(offset, littleEndian);
    const right = this.getUint32(offset + 4, littleEndian);
    let combined;
    if (littleEndian) {
      combined = left + 2 ** 32 * right;
      if (!Number.isSafeInteger(combined)) {
        throw new Error(
          `${combined} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
        );
      }
      return combined;
    }
    combined = 2 ** 32 * left + right;
    if (!Number.isSafeInteger(combined)) {
      throw new Error(
        `${combined} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
      );
    }
    return combined;
  }
  // adapted from https://stackoverflow.com/a/55338384/8060591
  getInt64(offset, littleEndian) {
    let value = 0;
    const isNegative4 = (this._dataView.getUint8(offset + (littleEndian ? 7 : 0)) & 128) > 0;
    let carrying = true;
    for (let i2 = 0; i2 < 8; i2++) {
      let byte = this._dataView.getUint8(offset + (littleEndian ? i2 : 7 - i2));
      if (isNegative4) {
        if (carrying) {
          if (byte !== 0) {
            byte = ~(byte - 1) & 255;
            carrying = false;
          }
        } else {
          byte = ~byte & 255;
        }
      }
      value += byte * 256 ** i2;
    }
    if (isNegative4) {
      value = -value;
    }
    return value;
  }
  getUint8(offset, littleEndian) {
    return this._dataView.getUint8(offset, littleEndian);
  }
  getInt8(offset, littleEndian) {
    return this._dataView.getInt8(offset, littleEndian);
  }
  getUint16(offset, littleEndian) {
    return this._dataView.getUint16(offset, littleEndian);
  }
  getInt16(offset, littleEndian) {
    return this._dataView.getInt16(offset, littleEndian);
  }
  getUint32(offset, littleEndian) {
    return this._dataView.getUint32(offset, littleEndian);
  }
  getInt32(offset, littleEndian) {
    return this._dataView.getInt32(offset, littleEndian);
  }
  getFloat16(offset, littleEndian) {
    return getFloat16(this._dataView, offset, littleEndian);
  }
  getFloat32(offset, littleEndian) {
    return this._dataView.getFloat32(offset, littleEndian);
  }
  getFloat64(offset, littleEndian) {
    return this._dataView.getFloat64(offset, littleEndian);
  }
}
class DataSlice {
  constructor(arrayBuffer2, sliceOffset, littleEndian, bigTiff) {
    this._dataView = new DataView(arrayBuffer2);
    this._sliceOffset = sliceOffset;
    this._littleEndian = littleEndian;
    this._bigTiff = bigTiff;
  }
  get sliceOffset() {
    return this._sliceOffset;
  }
  get sliceTop() {
    return this._sliceOffset + this.buffer.byteLength;
  }
  get littleEndian() {
    return this._littleEndian;
  }
  get bigTiff() {
    return this._bigTiff;
  }
  get buffer() {
    return this._dataView.buffer;
  }
  covers(offset, length2) {
    return this.sliceOffset <= offset && this.sliceTop >= offset + length2;
  }
  readUint8(offset) {
    return this._dataView.getUint8(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt8(offset) {
    return this._dataView.getInt8(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint16(offset) {
    return this._dataView.getUint16(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt16(offset) {
    return this._dataView.getInt16(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint32(offset) {
    return this._dataView.getUint32(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readInt32(offset) {
    return this._dataView.getInt32(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readFloat32(offset) {
    return this._dataView.getFloat32(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readFloat64(offset) {
    return this._dataView.getFloat64(
      offset - this._sliceOffset,
      this._littleEndian
    );
  }
  readUint64(offset) {
    const left = this.readUint32(offset);
    const right = this.readUint32(offset + 4);
    let combined;
    if (this._littleEndian) {
      combined = left + 2 ** 32 * right;
      if (!Number.isSafeInteger(combined)) {
        throw new Error(
          `${combined} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
        );
      }
      return combined;
    }
    combined = 2 ** 32 * left + right;
    if (!Number.isSafeInteger(combined)) {
      throw new Error(
        `${combined} exceeds MAX_SAFE_INTEGER. Precision may be lost. Please report if you get this message to https://github.com/geotiffjs/geotiff.js/issues`
      );
    }
    return combined;
  }
  // adapted from https://stackoverflow.com/a/55338384/8060591
  readInt64(offset) {
    let value = 0;
    const isNegative4 = (this._dataView.getUint8(offset + (this._littleEndian ? 7 : 0)) & 128) > 0;
    let carrying = true;
    for (let i2 = 0; i2 < 8; i2++) {
      let byte = this._dataView.getUint8(
        offset + (this._littleEndian ? i2 : 7 - i2)
      );
      if (isNegative4) {
        if (carrying) {
          if (byte !== 0) {
            byte = ~(byte - 1) & 255;
            carrying = false;
          }
        } else {
          byte = ~byte & 255;
        }
      }
      value += byte * 256 ** i2;
    }
    if (isNegative4) {
      value = -value;
    }
    return value;
  }
  readOffset(offset) {
    if (this._bigTiff) {
      return this.readUint64(offset);
    }
    return this.readUint32(offset);
  }
}
class BaseSource {
  /**
   *
   * @param {Slice[]} slices
   * @returns {ArrayBuffer[]}
   */
  async fetch(slices, signal = void 0) {
    return Promise.all(
      slices.map((slice2) => this.fetchSlice(slice2, signal))
    );
  }
  /**
   *
   * @param {Slice} slice
   * @returns {ArrayBuffer}
   */
  async fetchSlice(slice2) {
    throw new Error(`fetching of slice ${slice2} not possible, not implemented`);
  }
  /**
   * Returns the filesize if already determined and null otherwise
   */
  get fileSize() {
    return null;
  }
  async close() {
  }
}
class AbortError extends Error {
  constructor(params2) {
    super(params2);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AbortError);
    }
    this.name = "AbortError";
  }
}
class ArrayBufferSource extends BaseSource {
  constructor(arrayBuffer2) {
    super();
    this.arrayBuffer = arrayBuffer2;
  }
  fetchSlice(slice2, signal) {
    if (signal && signal.aborted) {
      throw new AbortError("Request aborted");
    }
    return this.arrayBuffer.slice(slice2.offset, slice2.offset + slice2.length);
  }
}
function makeBufferSource(arrayBuffer2) {
  return new ArrayBufferSource(arrayBuffer2);
}
function getFieldTypeLength(fieldType) {
  switch (fieldType) {
    case fieldTypes.BYTE:
    case fieldTypes.ASCII:
    case fieldTypes.SBYTE:
    case fieldTypes.UNDEFINED:
      return 1;
    case fieldTypes.SHORT:
    case fieldTypes.SSHORT:
      return 2;
    case fieldTypes.LONG:
    case fieldTypes.SLONG:
    case fieldTypes.FLOAT:
    case fieldTypes.IFD:
      return 4;
    case fieldTypes.RATIONAL:
    case fieldTypes.SRATIONAL:
    case fieldTypes.DOUBLE:
    case fieldTypes.LONG8:
    case fieldTypes.SLONG8:
    case fieldTypes.IFD8:
      return 8;
    default:
      throw new RangeError(`Invalid field type: ${fieldType}`);
  }
}
function parseGeoKeyDirectory(fileDirectory) {
  const rawGeoKeyDirectory = fileDirectory.GeoKeyDirectory;
  if (!rawGeoKeyDirectory) {
    return null;
  }
  const geoKeyDirectory = {};
  for (let i2 = 4; i2 <= rawGeoKeyDirectory[3] * 4; i2 += 4) {
    const key = geoKeyNames[rawGeoKeyDirectory[i2]];
    const location2 = rawGeoKeyDirectory[i2 + 1] ? fieldTagNames[rawGeoKeyDirectory[i2 + 1]] : null;
    const count3 = rawGeoKeyDirectory[i2 + 2];
    const offset = rawGeoKeyDirectory[i2 + 3];
    let value = null;
    if (!location2) {
      value = offset;
    } else {
      value = fileDirectory[location2];
      if (typeof value === "undefined" || value === null) {
        throw new Error(`Could not get value of geoKey '${key}'.`);
      } else if (typeof value === "string") {
        value = value.substring(offset, offset + count3 - 1);
      } else if (value.subarray) {
        value = value.subarray(offset, offset + count3);
        if (count3 === 1) {
          value = value[0];
        }
      }
    }
    geoKeyDirectory[key] = value;
  }
  return geoKeyDirectory;
}
function getValues(dataSlice, fieldType, count3, offset) {
  let values4 = null;
  let readMethod = null;
  const fieldTypeLength = getFieldTypeLength(fieldType);
  switch (fieldType) {
    case fieldTypes.BYTE:
    case fieldTypes.ASCII:
    case fieldTypes.UNDEFINED:
      values4 = new Uint8Array(count3);
      readMethod = dataSlice.readUint8;
      break;
    case fieldTypes.SBYTE:
      values4 = new Int8Array(count3);
      readMethod = dataSlice.readInt8;
      break;
    case fieldTypes.SHORT:
      values4 = new Uint16Array(count3);
      readMethod = dataSlice.readUint16;
      break;
    case fieldTypes.SSHORT:
      values4 = new Int16Array(count3);
      readMethod = dataSlice.readInt16;
      break;
    case fieldTypes.LONG:
    case fieldTypes.IFD:
      values4 = new Uint32Array(count3);
      readMethod = dataSlice.readUint32;
      break;
    case fieldTypes.SLONG:
      values4 = new Int32Array(count3);
      readMethod = dataSlice.readInt32;
      break;
    case fieldTypes.LONG8:
    case fieldTypes.IFD8:
      values4 = new Array(count3);
      readMethod = dataSlice.readUint64;
      break;
    case fieldTypes.SLONG8:
      values4 = new Array(count3);
      readMethod = dataSlice.readInt64;
      break;
    case fieldTypes.RATIONAL:
      values4 = new Uint32Array(count3 * 2);
      readMethod = dataSlice.readUint32;
      break;
    case fieldTypes.SRATIONAL:
      values4 = new Int32Array(count3 * 2);
      readMethod = dataSlice.readInt32;
      break;
    case fieldTypes.FLOAT:
      values4 = new Float32Array(count3);
      readMethod = dataSlice.readFloat32;
      break;
    case fieldTypes.DOUBLE:
      values4 = new Float64Array(count3);
      readMethod = dataSlice.readFloat64;
      break;
    default:
      throw new RangeError(`Invalid field type: ${fieldType}`);
  }
  if (!(fieldType === fieldTypes.RATIONAL || fieldType === fieldTypes.SRATIONAL)) {
    for (let i2 = 0; i2 < count3; ++i2) {
      values4[i2] = readMethod.call(
        dataSlice,
        offset + i2 * fieldTypeLength
      );
    }
  } else {
    for (let i2 = 0; i2 < count3; i2 += 2) {
      values4[i2] = readMethod.call(
        dataSlice,
        offset + i2 * fieldTypeLength
      );
      values4[i2 + 1] = readMethod.call(
        dataSlice,
        offset + (i2 * fieldTypeLength + 4)
      );
    }
  }
  if (fieldType === fieldTypes.ASCII) {
    return new TextDecoder("utf-8").decode(values4);
  }
  return values4;
}
class ImageFileDirectory {
  constructor(fileDirectory, geoKeyDirectory, nextIFDByteOffset) {
    this.fileDirectory = fileDirectory;
    this.geoKeyDirectory = geoKeyDirectory;
    this.nextIFDByteOffset = nextIFDByteOffset;
  }
}
class GeoTIFFImageIndexError extends Error {
  constructor(index2) {
    super(`No image at index ${index2}`);
    this.index = index2;
  }
}
class GeoTIFFBase {
  /**
   * (experimental) Reads raster data from the best fitting image. This function uses
   * the image with the lowest resolution that is still a higher resolution than the
   * requested resolution.
   * When specified, the `bbox` option is translated to the `window` option and the
   * `resX` and `resY` to `width` and `height` respectively.
   * Then, the [readRasters]{@link GeoTIFFImage#readRasters} method of the selected
   * image is called and the result returned.
   * @see GeoTIFFImage.readRasters
   * @param {import('./geotiffimage').ReadRasterOptions} [options={}] optional parameters
   * @returns {Promise<ReadRasterResult>} the decoded array(s), with `height` and `width`, as a promise
   */
  async readRasters(options2 = {}) {
    const { window: imageWindow, width, height } = options2;
    let { resX, resY, bbox: bbox2 } = options2;
    const firstImage = await this.getImage();
    let usedImage = firstImage;
    const imageCount = await this.getImageCount();
    const imgBBox = firstImage.getBoundingBox();
    if (imageWindow && bbox2) {
      throw new Error('Both "bbox" and "window" passed.');
    }
    if (width || height) {
      if (imageWindow) {
        const [oX, oY] = firstImage.getOrigin();
        const [rX, rY] = firstImage.getResolution();
        bbox2 = [
          oX + imageWindow[0] * rX,
          oY + imageWindow[1] * rY,
          oX + imageWindow[2] * rX,
          oY + imageWindow[3] * rY
        ];
      }
      const usedBBox = bbox2 || imgBBox;
      if (width) {
        if (resX) {
          throw new Error("Both width and resX passed");
        }
        resX = (usedBBox[2] - usedBBox[0]) / width;
      }
      if (height) {
        if (resY) {
          throw new Error("Both width and resY passed");
        }
        resY = (usedBBox[3] - usedBBox[1]) / height;
      }
    }
    if (resX || resY) {
      const allImages = [];
      for (let i2 = 0; i2 < imageCount; ++i2) {
        const image = await this.getImage(i2);
        const { SubfileType: subfileType, NewSubfileType: newSubfileType } = image.fileDirectory;
        if (i2 === 0 || subfileType === 2 || newSubfileType & 1) {
          allImages.push(image);
        }
      }
      allImages.sort((a2, b2) => a2.getWidth() - b2.getWidth());
      for (let i2 = 0; i2 < allImages.length; ++i2) {
        const image = allImages[i2];
        const imgResX = (imgBBox[2] - imgBBox[0]) / image.getWidth();
        const imgResY = (imgBBox[3] - imgBBox[1]) / image.getHeight();
        usedImage = image;
        if (resX && resX > imgResX || resY && resY > imgResY) {
          break;
        }
      }
    }
    let wnd = imageWindow;
    if (bbox2) {
      const [oX, oY] = firstImage.getOrigin();
      const [imageResX, imageResY] = usedImage.getResolution(firstImage);
      wnd = [
        Math.round((bbox2[0] - oX) / imageResX),
        Math.round((bbox2[1] - oY) / imageResY),
        Math.round((bbox2[2] - oX) / imageResX),
        Math.round((bbox2[3] - oY) / imageResY)
      ];
      wnd = [
        Math.min(wnd[0], wnd[2]),
        Math.min(wnd[1], wnd[3]),
        Math.max(wnd[0], wnd[2]),
        Math.max(wnd[1], wnd[3])
      ];
    }
    return usedImage.readRasters({ ...options2, window: wnd });
  }
}
class GeoTIFF extends GeoTIFFBase {
  /**
   * @constructor
   * @param {*} source The datasource to read from.
   * @param {boolean} littleEndian Whether the image uses little endian.
   * @param {boolean} bigTiff Whether the image uses bigTIFF conventions.
   * @param {number} firstIFDOffset The numeric byte-offset from the start of the image
   *                                to the first IFD.
   * @param {GeoTIFFOptions} [options] further options.
   */
  constructor(source, littleEndian, bigTiff, firstIFDOffset, options2 = {}) {
    super();
    this.source = source;
    this.littleEndian = littleEndian;
    this.bigTiff = bigTiff;
    this.firstIFDOffset = firstIFDOffset;
    this.cache = options2.cache || false;
    this.ifdRequests = [];
    this.ghostValues = null;
  }
  async getSlice(offset, size12) {
    const fallbackSize = this.bigTiff ? 4048 : 1024;
    return new DataSlice(
      (await this.source.fetch([{
        offset,
        length: typeof size12 !== "undefined" ? size12 : fallbackSize
      }]))[0],
      offset,
      this.littleEndian,
      this.bigTiff
    );
  }
  /**
   * Instructs to parse an image file directory at the given file offset.
   * As there is no way to ensure that a location is indeed the start of an IFD,
   * this function must be called with caution (e.g only using the IFD offsets from
   * the headers or other IFDs).
   * @param {number} offset the offset to parse the IFD at
   * @returns {Promise<ImageFileDirectory>} the parsed IFD
   */
  async parseFileDirectoryAt(offset) {
    const entrySize = this.bigTiff ? 20 : 12;
    const offsetSize = this.bigTiff ? 8 : 2;
    let dataSlice = await this.getSlice(offset);
    const numDirEntries = this.bigTiff ? dataSlice.readUint64(offset) : dataSlice.readUint16(offset);
    const byteSize = numDirEntries * entrySize + (this.bigTiff ? 16 : 6);
    if (!dataSlice.covers(offset, byteSize)) {
      dataSlice = await this.getSlice(offset, byteSize);
    }
    const fileDirectory = {};
    let i2 = offset + (this.bigTiff ? 8 : 2);
    for (let entryCount = 0; entryCount < numDirEntries; i2 += entrySize, ++entryCount) {
      const fieldTag = dataSlice.readUint16(i2);
      const fieldType = dataSlice.readUint16(i2 + 2);
      const typeCount = this.bigTiff ? dataSlice.readUint64(i2 + 4) : dataSlice.readUint32(i2 + 4);
      let fieldValues;
      let value;
      const fieldTypeLength = getFieldTypeLength(fieldType);
      const valueOffset = i2 + (this.bigTiff ? 12 : 8);
      if (fieldTypeLength * typeCount <= (this.bigTiff ? 8 : 4)) {
        fieldValues = getValues(dataSlice, fieldType, typeCount, valueOffset);
      } else {
        const actualOffset = dataSlice.readOffset(valueOffset);
        const length2 = getFieldTypeLength(fieldType) * typeCount;
        if (dataSlice.covers(actualOffset, length2)) {
          fieldValues = getValues(dataSlice, fieldType, typeCount, actualOffset);
        } else {
          const fieldDataSlice = await this.getSlice(actualOffset, length2);
          fieldValues = getValues(fieldDataSlice, fieldType, typeCount, actualOffset);
        }
      }
      if (typeCount === 1 && arrayFields.indexOf(fieldTag) === -1 && !(fieldType === fieldTypes.RATIONAL || fieldType === fieldTypes.SRATIONAL)) {
        value = fieldValues[0];
      } else {
        value = fieldValues;
      }
      fileDirectory[fieldTagNames[fieldTag]] = value;
    }
    const geoKeyDirectory = parseGeoKeyDirectory(fileDirectory);
    const nextIFDByteOffset = dataSlice.readOffset(
      offset + offsetSize + entrySize * numDirEntries
    );
    return new ImageFileDirectory(
      fileDirectory,
      geoKeyDirectory,
      nextIFDByteOffset
    );
  }
  async requestIFD(index2) {
    if (this.ifdRequests[index2]) {
      return this.ifdRequests[index2];
    } else if (index2 === 0) {
      this.ifdRequests[index2] = this.parseFileDirectoryAt(this.firstIFDOffset);
      return this.ifdRequests[index2];
    } else if (!this.ifdRequests[index2 - 1]) {
      try {
        this.ifdRequests[index2 - 1] = this.requestIFD(index2 - 1);
      } catch (e3) {
        if (e3 instanceof GeoTIFFImageIndexError) {
          throw new GeoTIFFImageIndexError(index2);
        }
        throw e3;
      }
    }
    this.ifdRequests[index2] = (async () => {
      const previousIfd = await this.ifdRequests[index2 - 1];
      if (previousIfd.nextIFDByteOffset === 0) {
        throw new GeoTIFFImageIndexError(index2);
      }
      return this.parseFileDirectoryAt(previousIfd.nextIFDByteOffset);
    })();
    return this.ifdRequests[index2];
  }
  /**
   * Get the n-th internal subfile of an image. By default, the first is returned.
   *
   * @param {number} [index=0] the index of the image to return.
   * @returns {Promise<GeoTIFFImage>} the image at the given index
   */
  async getImage(index2 = 0) {
    const ifd = await this.requestIFD(index2);
    return new GeoTIFFImage$1(
      ifd.fileDirectory,
      ifd.geoKeyDirectory,
      this.dataView,
      this.littleEndian,
      this.cache,
      this.source
    );
  }
  /**
   * Returns the count of the internal subfiles.
   *
   * @returns {Promise<number>} the number of internal subfile images
   */
  async getImageCount() {
    let index2 = 0;
    let hasNext3 = true;
    while (hasNext3) {
      try {
        await this.requestIFD(index2);
        ++index2;
      } catch (e3) {
        if (e3 instanceof GeoTIFFImageIndexError) {
          hasNext3 = false;
        } else {
          throw e3;
        }
      }
    }
    return index2;
  }
  /**
   * Get the values of the COG ghost area as a parsed map.
   * See https://gdal.org/drivers/raster/cog.html#header-ghost-area for reference
   * @returns {Promise<Object>} the parsed ghost area or null, if no such area was found
   */
  async getGhostValues() {
    const offset = this.bigTiff ? 16 : 8;
    if (this.ghostValues) {
      return this.ghostValues;
    }
    const detectionString = "GDAL_STRUCTURAL_METADATA_SIZE=";
    const heuristicAreaSize = detectionString.length + 100;
    let slice2 = await this.getSlice(offset, heuristicAreaSize);
    if (detectionString === getValues(slice2, fieldTypes.ASCII, detectionString.length, offset)) {
      const valuesString = getValues(slice2, fieldTypes.ASCII, heuristicAreaSize, offset);
      const firstLine = valuesString.split("\n")[0];
      const metadataSize = Number(firstLine.split("=")[1].split(" ")[0]) + firstLine.length;
      if (metadataSize > heuristicAreaSize) {
        slice2 = await this.getSlice(offset, metadataSize);
      }
      const fullString = getValues(slice2, fieldTypes.ASCII, metadataSize, offset);
      this.ghostValues = {};
      fullString.split("\n").filter((line) => line.length > 0).map((line) => line.split("=")).forEach(([key, value]) => {
        this.ghostValues[key] = value;
      });
    }
    return this.ghostValues;
  }
  /**
   * Parse a (Geo)TIFF file from the given source.
   *
   * @param {*} source The source of data to parse from.
   * @param {GeoTIFFOptions} [options] Additional options.
   * @param {AbortSignal} [signal] An AbortSignal that may be signalled if the request is
   *                               to be aborted
   */
  static async fromSource(source, options2, signal) {
    const headerData = (await source.fetch([{ offset: 0, length: 1024 }], signal))[0];
    const dataView = new DataView64(headerData);
    const BOM = dataView.getUint16(0, 0);
    let littleEndian;
    if (BOM === 18761) {
      littleEndian = true;
    } else if (BOM === 19789) {
      littleEndian = false;
    } else {
      throw new TypeError("Invalid byte order value.");
    }
    const magicNumber = dataView.getUint16(2, littleEndian);
    let bigTiff;
    if (magicNumber === 42) {
      bigTiff = false;
    } else if (magicNumber === 43) {
      bigTiff = true;
      const offsetByteSize = dataView.getUint16(4, littleEndian);
      if (offsetByteSize !== 8) {
        throw new Error("Unsupported offset byte-size.");
      }
    } else {
      throw new TypeError("Invalid magic number.");
    }
    const firstIFDOffset = bigTiff ? dataView.getUint64(8, littleEndian) : dataView.getUint32(4, littleEndian);
    return new GeoTIFF(source, littleEndian, bigTiff, firstIFDOffset, options2);
  }
  /**
   * Closes the underlying file buffer
   * N.B. After the GeoTIFF has been completely processed it needs
   * to be closed but only if it has been constructed from a file.
   */
  close() {
    if (typeof this.source.close === "function") {
      return this.source.close();
    }
    return false;
  }
}
async function fromArrayBuffer(arrayBuffer2, signal) {
  return GeoTIFF.fromSource(makeBufferSource(arrayBuffer2), signal);
}
var mainDistExports = {};
var mainDist = {
  get exports() {
    return mainDistExports;
  },
  set exports(v5) {
    mainDistExports = v5;
  }
};
(function(module2, exports2) {
  var $jscomp = $jscomp || {};
  $jscomp.scope = {};
  $jscomp.createTemplateTagFirstArg = function(a2) {
    return a2.raw = a2;
  };
  $jscomp.createTemplateTagFirstArgWithRaw = function(a2, b2) {
    a2.raw = b2;
    return a2;
  };
  $jscomp.arrayIteratorImpl = function(a2) {
    var b2 = 0;
    return function() {
      return b2 < a2.length ? { done: false, value: a2[b2++] } : { done: true };
    };
  };
  $jscomp.arrayIterator = function(a2) {
    return { next: $jscomp.arrayIteratorImpl(a2) };
  };
  $jscomp.makeIterator = function(a2) {
    var b2 = "undefined" != typeof Symbol && Symbol.iterator && a2[Symbol.iterator];
    return b2 ? b2.call(a2) : $jscomp.arrayIterator(a2);
  };
  $jscomp.ASSUME_ES5 = false;
  $jscomp.ASSUME_NO_NATIVE_MAP = false;
  $jscomp.ASSUME_NO_NATIVE_SET = false;
  $jscomp.SIMPLE_FROUND_POLYFILL = false;
  $jscomp.ISOLATE_POLYFILLS = false;
  $jscomp.FORCE_POLYFILL_PROMISE = false;
  $jscomp.FORCE_POLYFILL_PROMISE_WHEN_NO_UNHANDLED_REJECTION = false;
  $jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a2, b2, e3) {
    if (a2 == Array.prototype || a2 == Object.prototype)
      return a2;
    a2[b2] = e3.value;
    return a2;
  };
  $jscomp.getGlobal = function(a2) {
    a2 = ["object" == typeof globalThis && globalThis, a2, "object" == typeof window && window, "object" == typeof self && self, "object" == typeof commonjsGlobal$1 && commonjsGlobal$1];
    for (var b2 = 0; b2 < a2.length; ++b2) {
      var e3 = a2[b2];
      if (e3 && e3.Math == Math)
        return e3;
    }
    throw Error("Cannot find global object");
  };
  $jscomp.global = $jscomp.getGlobal(commonjsGlobal$1);
  $jscomp.IS_SYMBOL_NATIVE = "function" === typeof Symbol && "symbol" === typeof Symbol("x");
  $jscomp.TRUST_ES6_POLYFILLS = !$jscomp.ISOLATE_POLYFILLS || $jscomp.IS_SYMBOL_NATIVE;
  $jscomp.polyfills = {};
  $jscomp.propertyToPolyfillSymbol = {};
  $jscomp.POLYFILL_PREFIX = "$jscp$";
  $jscomp.polyfill = function(a2, b2, e3, c2) {
    b2 && ($jscomp.ISOLATE_POLYFILLS ? $jscomp.polyfillIsolated(a2, b2, e3, c2) : $jscomp.polyfillUnisolated(a2, b2, e3, c2));
  };
  $jscomp.polyfillUnisolated = function(a2, b2, e3, c2) {
    e3 = $jscomp.global;
    a2 = a2.split(".");
    for (c2 = 0; c2 < a2.length - 1; c2++) {
      var d2 = a2[c2];
      if (!(d2 in e3))
        return;
      e3 = e3[d2];
    }
    a2 = a2[a2.length - 1];
    c2 = e3[a2];
    b2 = b2(c2);
    b2 != c2 && null != b2 && $jscomp.defineProperty(e3, a2, { configurable: true, writable: true, value: b2 });
  };
  $jscomp.polyfillIsolated = function(a2, b2, e3, c2) {
    var d2 = a2.split(".");
    a2 = 1 === d2.length;
    c2 = d2[0];
    c2 = !a2 && c2 in $jscomp.polyfills ? $jscomp.polyfills : $jscomp.global;
    for (var f2 = 0; f2 < d2.length - 1; f2++) {
      var h2 = d2[f2];
      if (!(h2 in c2))
        return;
      c2 = c2[h2];
    }
    d2 = d2[d2.length - 1];
    e3 = $jscomp.IS_SYMBOL_NATIVE && "es6" === e3 ? c2[d2] : null;
    b2 = b2(e3);
    null != b2 && (a2 ? $jscomp.defineProperty($jscomp.polyfills, d2, { configurable: true, writable: true, value: b2 }) : b2 !== e3 && (void 0 === $jscomp.propertyToPolyfillSymbol[d2] && (e3 = 1e9 * Math.random() >>> 0, $jscomp.propertyToPolyfillSymbol[d2] = $jscomp.IS_SYMBOL_NATIVE ? $jscomp.global.Symbol(d2) : $jscomp.POLYFILL_PREFIX + e3 + "$" + d2), $jscomp.defineProperty(c2, $jscomp.propertyToPolyfillSymbol[d2], { configurable: true, writable: true, value: b2 })));
  };
  $jscomp.initSymbol = function() {
  };
  $jscomp.polyfill("Symbol", function(a2) {
    if (a2)
      return a2;
    var b2 = function(f2, h2) {
      this.$jscomp$symbol$id_ = f2;
      $jscomp.defineProperty(this, "description", { configurable: true, writable: true, value: h2 });
    };
    b2.prototype.toString = function() {
      return this.$jscomp$symbol$id_;
    };
    var e3 = "jscomp_symbol_" + (1e9 * Math.random() >>> 0) + "_", c2 = 0, d2 = function(f2) {
      if (this instanceof d2)
        throw new TypeError("Symbol is not a constructor");
      return new b2(e3 + (f2 || "") + "_" + c2++, f2);
    };
    return d2;
  }, "es6", "es3");
  $jscomp.polyfill(
    "Symbol.iterator",
    function(a2) {
      if (a2)
        return a2;
      a2 = Symbol("Symbol.iterator");
      for (var b2 = "Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "), e3 = 0; e3 < b2.length; e3++) {
        var c2 = $jscomp.global[b2[e3]];
        "function" === typeof c2 && "function" != typeof c2.prototype[a2] && $jscomp.defineProperty(c2.prototype, a2, { configurable: true, writable: true, value: function() {
          return $jscomp.iteratorPrototype($jscomp.arrayIteratorImpl(this));
        } });
      }
      return a2;
    },
    "es6",
    "es3"
  );
  $jscomp.iteratorPrototype = function(a2) {
    a2 = { next: a2 };
    a2[Symbol.iterator] = function() {
      return this;
    };
    return a2;
  };
  $jscomp.iteratorFromArray = function(a2, b2) {
    a2 instanceof String && (a2 += "");
    var e3 = 0, c2 = false, d2 = { next: function() {
      if (!c2 && e3 < a2.length) {
        var f2 = e3++;
        return { value: b2(f2, a2[f2]), done: false };
      }
      c2 = true;
      return { done: true, value: void 0 };
    } };
    d2[Symbol.iterator] = function() {
      return d2;
    };
    return d2;
  };
  $jscomp.polyfill("Array.prototype.keys", function(a2) {
    return a2 ? a2 : function() {
      return $jscomp.iteratorFromArray(this, function(b2) {
        return b2;
      });
    };
  }, "es6", "es3");
  $jscomp.polyfill("Object.getOwnPropertySymbols", function(a2) {
    return a2 ? a2 : function() {
      return [];
    };
  }, "es6", "es5");
  (function(a2) {
    module2.exports = a2();
  })(function() {
    return function() {
      function a2(b2, e3, c2) {
        function d2(k2, p2) {
          if (!e3[k2]) {
            if (!b2[k2]) {
              var l2 = "function" == typeof commonjsRequire && commonjsRequire;
              if (!p2 && l2)
                return l2(k2, true);
              if (f2)
                return f2(k2, true);
              l2 = Error("Cannot find module '" + k2 + "'");
              throw l2.code = "MODULE_NOT_FOUND", l2;
            }
            l2 = e3[k2] = { exports: {} };
            b2[k2][0].call(l2.exports, function(r2) {
              return d2(b2[k2][1][r2] || r2);
            }, l2, l2.exports, a2, b2, e3, c2);
          }
          return e3[k2].exports;
        }
        for (var f2 = "function" == typeof commonjsRequire && commonjsRequire, h2 = 0; h2 < c2.length; h2++)
          d2(c2[h2]);
        return d2;
      }
      return a2;
    }()({
      1: [
        function(a2, b2, e3) {
          b2.exports = {
            2e3: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2001: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-270,13,62 +axis=en",
            2002: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2003: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2004: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=174,359,365 +axis=en",
            2005: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2006: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2007: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2008: "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2009: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2010: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2011: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2012: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2013: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2014: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2015: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2016: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2017: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2018: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2019: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2020: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2021: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2022: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2023: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2024: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2025: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2026: "+proj=tmerc +lat_0=0 +lon_0=-95.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2027: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2028: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2029: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2030: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2031: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2032: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2033: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2034: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2035: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2036: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne",
            2037: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2038: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2039: "+proj=tmerc +lat_0=31.734393611111113 +lon_0=35.20451694444445 +k_0=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2040: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2041: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2042: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2043: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2044: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2045: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2046: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=14.999999999999986 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2047: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=16.999999999999982 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2048: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=18.999999999999982 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2049: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=20.99999999999998 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2050: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=22.99999999999998 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2051: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=24.999999999999975 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2052: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=26.99999999999997 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2053: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=28.99999999999997 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2054: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=30.999999999999968 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2055: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=32.999999999999964 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ws",
            2056: "+proj=omerc +lat_0=46.95240555555556 +lonc=7.439583333333333 +alpha=90 +gamma=90 +k_0=1 +x_0=2600000 +y_0=1200000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            2057: "+proj=omerc +lat_0=27.518828805555554 +lonc=52.60353916666667 +alpha=0.5716611944444444 +gamma=0.5716611944444444 +k_0=0.999895934 +x_0=658377.437 +y_0=3044969.194 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2058: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2059: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2060: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2061: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2062: "+proj=lcc +lat_0=39.99999999999996 +lon_0=0 +k_0=0.9988085293 +x_0=600000 +y_0=600000 +a=6378298.3 +b=6356657.142669562 +pm=-3.6873750000000003 +axis=en",
            2063: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            2064: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            2065: "+proj=krovak +alpha=30.28813975277778 +x_0=0 +y_0=0 +lat_0=49.5 +k_0=0.9999 +lon_0=42.5 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=sw",
            2066: "+proj=cass +lat_0=11.25217861111111 +lon_0=-60.686008888888885 +x_0=37718.66159325 +y_0=36209.91512952 +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=en +to_meter=0.201166195164",
            2067: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-2,374,172 +axis=en",
            2068: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2069: "+proj=tmerc +lat_0=0 +lon_0=10.99999999999999 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2070: "+proj=tmerc +lat_0=0 +lon_0=12.999999999999988 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2071: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2072: "+proj=tmerc +lat_0=0 +lon_0=16.999999999999982 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2073: "+proj=tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2074: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2075: "+proj=tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2076: "+proj=tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2077: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2078: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2079: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2080: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2081: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2082: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2083: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=16,196,93 +axis=ne",
            2084: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=16,196,93 +axis=en",
            2085: "+proj=lcc +lat_0=22.35 +lon_0=-81 +k_0=0.99993602 +x_0=500000 +y_0=280296.016 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne",
            2086: "+proj=lcc +lat_0=20.716666666666665 +lon_0=-76.83333333333333 +k_0=0.99994848 +x_0=500000 +y_0=229126.939 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne",
            2087: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2088: "+proj=tmerc +lat_0=0 +lon_0=10.99999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-263,6,431 +axis=en",
            2089: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            2090: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            2091: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2092: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2093: "+proj=tmerc +lat_0=0 +lon_0=105.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2094: "+proj=tmerc +lat_0=0 +lon_0=105.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            2095: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2096: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=128.99999999999986 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            2097: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            2098: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=124.99999999999987 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            2099: "+proj=cass +lat_0=25.382361111111113 +lon_0=50.76138888888889 +x_0=100000 +y_0=100000 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            2100: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2101: "+proj=lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=0 +y_0=-52684.972 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2102: "+proj=lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=200000 +y_0=147315.028 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2103: "+proj=lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=500000 +y_0=447315.028 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2104: "+proj=lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=-17044 +y_0=-23139.97 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2105: "+proj=tmerc +lat_0=-36.87972222222222 +lon_0=174.76416666666665 +k_0=0.9999 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2106: "+proj=tmerc +lat_0=-37.76111111111111 +lon_0=176.4661111111111 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2107: "+proj=tmerc +lat_0=-38.62444444444444 +lon_0=177.88555555555556 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2108: "+proj=tmerc +lat_0=-39.65083333333333 +lon_0=176.67361111111111 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2109: "+proj=tmerc +lat_0=-39.135555555555555 +lon_0=174.2277777777778 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2110: "+proj=tmerc +lat_0=-39.51222222222222 +lon_0=175.64 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2111: "+proj=tmerc +lat_0=-40.24194444444444 +lon_0=175.48805555555555 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2112: "+proj=tmerc +lat_0=-40.92527777777777 +lon_0=175.6472222222222 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2113: "+proj=tmerc +lat_0=-41.301111111111105 +lon_0=174.7763888888889 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2114: "+proj=tmerc +lat_0=-40.71472222222223 +lon_0=172.67194444444445 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2115: "+proj=tmerc +lat_0=-41.27444444444444 +lon_0=173.29916666666668 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2116: "+proj=tmerc +lat_0=-41.28972222222222 +lon_0=172.10888888888888 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2117: "+proj=tmerc +lat_0=-41.81055555555555 +lon_0=171.5811111111111 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2118: "+proj=tmerc +lat_0=-42.33361111111111 +lon_0=171.54972222222221 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2119: "+proj=tmerc +lat_0=-42.68888888888888 +lon_0=173.01 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2120: "+proj=tmerc +lat_0=-41.544444444444444 +lon_0=173.80194444444444 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2121: "+proj=tmerc +lat_0=-42.88611111111111 +lon_0=170.97972222222222 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2122: "+proj=tmerc +lat_0=-43.11 +lon_0=170.26083333333332 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2123: "+proj=tmerc +lat_0=-43.97777777777778 +lon_0=168.60611111111112 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2124: "+proj=tmerc +lat_0=-43.59055555555556 +lon_0=172.72694444444446 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2125: "+proj=tmerc +lat_0=-43.74861111111111 +lon_0=171.36055555555555 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2126: "+proj=tmerc +lat_0=-44.401944444444446 +lon_0=171.05722222222224 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2127: "+proj=tmerc +lat_0=-44.735 +lon_0=169.4675 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2128: "+proj=tmerc +lat_0=-45.132777777777775 +lon_0=168.3986111111111 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2129: "+proj=tmerc +lat_0=-45.56361111111111 +lon_0=167.7386111111111 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2130: "+proj=tmerc +lat_0=-45.816111111111105 +lon_0=170.62833333333333 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2131: "+proj=tmerc +lat_0=-45.86138888888889 +lon_0=170.28250000000003 +k_0=0.99996 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2132: "+proj=tmerc +lat_0=-46.6 +lon_0=168.3427777777778 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2133: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2134: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2135: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2136: "+proj=tmerc +lat_0=4.666666666666667 +lon_0=-1 +k_0=0.99975 +x_0=274319.73916335794 +y_0=0 +a=6378300 +b=6356751.689189189 +pm=0 +axis=en +to_meter=0.304799710181509",
            2137: "+proj=tmerc +lat_0=0 +lon_0=-0.999999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378300 +b=6356751.689189189 +pm=0 +axis=en",
            2138: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2139: "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2140: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2141: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2142: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2143: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2144: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2145: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2146: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2147: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2148: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2149: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2150: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2151: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2152: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2153: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2154: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2155: "+proj=lcc +lat_0=-14.266666666666667 +lon_0=170 +k_0=1 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-115,118,426 +axis=en +to_meter=0.3048006096",
            2156: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2157: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k_0=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2158: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2159: "+proj=tmerc +lat_0=6.666666666666667 +lon_0=-12 +k_0=1 +x_0=152399.8550907544 +y_0=0 +a=6378300 +b=6356751.689189189 +pm=0 +axis=en +to_meter=0.304799710181509",
            2160: "+proj=tmerc +lat_0=6.666666666666667 +lon_0=-12 +k_0=1 +x_0=243839.76814520705 +y_0=182879.82610890528 +a=6378300 +b=6356751.689189189 +pm=0 +axis=en +to_meter=0.304799710181509",
            2161: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-88,4,101 +axis=en",
            2162: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-88,4,101 +axis=en",
            2163: "+proj=laea +ellps=clrk66 +lat_0=44.99999999999996 +lon_0=-99.9999999999999 +x_0=0 +y_0=0 +a=6370997 +b=6370997 +pm=0 +axis=en",
            2164: "+proj=tmerc +lat_0=0 +lon_0=-4.999999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2165: "+proj=tmerc +lat_0=0 +lon_0=-4.999999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2166: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2167: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2168: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2169: "+proj=tmerc +lat_0=49.833333333333336 +lon_0=6.166666666666667 +k_0=1 +x_0=80000 +y_0=100000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2170: "+proj=tmerc +lat_0=0 +lon_0=15 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            2171: "+proj=sterea +lat_0=50.625 +lon_0=21.083333333333332 +k_0=0.9998 +x_0=4637000 +y_0=5647000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2172: "+proj=sterea +lat_0=53.00194444444445 +lon_0=21.502777777777776 +k_0=0.9998 +x_0=4603000 +y_0=5806000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2173: "+proj=sterea +lat_0=53.583333333333336 +lon_0=17.008333333333333 +k_0=0.9998 +x_0=3501000 +y_0=5999000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2174: "+proj=sterea +lat_0=51.670833333333334 +lon_0=16.672222222222224 +k_0=0.9998 +x_0=3703000 +y_0=5627000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2175: "+proj=tmerc +lat_0=0 +lon_0=18.958333333333332 +k_0=0.999983 +x_0=237000 +y_0=-4700000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2176: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.999923 +x_0=5500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2177: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.999923 +x_0=6500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2178: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.999923 +x_0=7500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2179: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.999923 +x_0=8500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2180: "+proj=tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2188: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2189: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-104,167,-38 +axis=en",
            2190: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2191: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314 +axis=en",
            2192: "+proj=lcc +lat_0=46.8 +lon_0=2.337229166666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            2193: "+proj=tmerc +lat_0=0 +lon_0=172.99999999999983 +k_0=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2194: "+proj=lcc +lat_0=-14.266666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-115,118,426 +axis=en +to_meter=0.3048006096",
            2195: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2196: "+proj=tmerc +lat_0=0 +lon_0=9.5 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2197: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2198: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=900000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2199: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2200: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=300000 +y_0=800000 +a=6378135 +b=6356750.304921594 +pm=0 +axis=ne",
            2201: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2202: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2203: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2204: "+proj=lcc +lat_0=34.666666666666664 +lon_0=-86 +lat_1=35.25 +lat_2=36.416666666666664 +x_0=609601.2192024385 +y_0=30480.060960121926 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            2205: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2206: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2207: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2208: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2209: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2210: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2211: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=14500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2212: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=15500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2213: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2214: "+proj=tmerc +lat_0=0 +lon_0=10.5 +k_0=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2215: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            2216: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=164,138,-189 +axis=en",
            2217: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=164,138,-189 +axis=en",
            2219: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378135 +b=6356750.304921594 +pm=0 +axis=en",
            2220: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378135 +b=6356750.304921594 +pm=0 +axis=en",
            2222: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2223: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2224: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2225: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2226: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2227: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2228: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2229: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2230: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2231: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2232: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2233: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2234: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.60960121924 +y_0=152400.30480060962 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2235: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2236: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2237: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2238: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2239: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2240: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2241: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2242: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2243: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2244: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249364.9987299975 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2245: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249364.9987299975 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2246: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2247: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000.00010160025 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2248: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.99989839987 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2249: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000.00010160022 +y_0=750000.0000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2250: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2251: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2252: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2253: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=3999999.9999840003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2254: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2255: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2256: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2257: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2258: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2259: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2260: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2261: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=249999.99989839984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2262: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000.0001016002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2263: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2264: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2265: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2266: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2267: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2268: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2269: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2270: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000.0001464002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2271: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2272: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2273: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2274: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2275: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000.00010160022 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2276: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000.0000000001 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2277: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=699999.9998983999 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2278: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000.0000000001 +y_0=3999999.9998984006 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2279: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000.00000000006 +y_0=5000000.000101601 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2280: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.00015040004 +y_0=999999.9999960001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2281: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.00015040004 +y_0=1999999.9999920002 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2282: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.00015040004 +y_0=2999999.9999880004 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2283: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000.0001016003 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2284: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000.0001016003 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2285: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2286: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2287: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2288: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2289: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2290: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=700000 +y_0=400000 +a=6378135 +b=6356750.304921594 +pm=0 +axis=en",
            2291: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=400000 +y_0=800000 +a=6378135 +b=6356750.304921594 +pm=0 +axis=en",
            2292: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2294: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=4500000 +y_0=0 +a=6378135 +b=6356750.304921594 +pm=0 +axis=en",
            2295: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=5500000 +y_0=0 +a=6378135 +b=6356750.304921594 +pm=0 +axis=en",
            2308: "+proj=tmerc +lat_0=0 +lon_0=108.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            2309: "+proj=tmerc +lat_0=0 +lon_0=115.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            2310: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            2311: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            2312: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2313: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            2314: "+proj=cass +lat_0=10.441666666666666 +lon_0=-61.333333333333336 +x_0=86501.46392052001 +y_0=65379.0134283 +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=en +to_meter=0.3047972654",
            2315: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=en",
            2316: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=en",
            2317: "+proj=lcc +lat_0=5.999999999999994 +lon_0=-65.99999999999993 +lat_1=8.999999999999991 +lat_2=2.999999999999997 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2318: "+proj=lcc +lat_0=25.089509999999997 +lon_0=47.99999999999995 +lat_1=16.999999999999982 +lat_2=32.999999999999964 +x_0=0 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2319: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2320: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2321: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2322: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2323: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2324: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2325: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne",
            2326: "+proj=tmerc +lat_0=22.312133333333335 +lon_0=114.17855555555556 +k_0=1 +x_0=836694.05 +y_0=819069.8 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2327: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2328: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2329: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2330: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2331: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2332: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2333: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2334: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2335: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2336: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2337: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2338: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2339: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2340: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2341: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2342: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2343: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2344: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2345: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2346: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2347: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2348: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2349: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2350: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2351: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2352: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2353: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2354: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2355: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2356: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2357: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2358: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2359: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2360: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2361: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2362: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2363: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2364: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2365: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2366: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2367: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2368: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2369: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2370: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2371: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2372: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2373: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2374: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2375: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2376: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2377: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2378: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2379: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2380: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2381: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2382: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2383: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2384: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2385: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2386: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2387: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2388: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2389: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2390: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne",
            2391: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=1500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2392: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2393: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=3500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2394: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=4500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            2395: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2396: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2397: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2398: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2399: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2400: "+proj=tmerc +lat_0=0 +lon_0=15.808277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
            2401: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2402: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2403: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2404: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2405: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2406: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2407: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2408: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2409: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2410: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2411: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2412: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2413: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2414: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2415: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2416: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2417: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2418: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2419: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2420: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2421: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2422: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2423: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2424: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2425: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2426: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2427: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2428: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2429: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2430: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2431: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2432: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2433: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2434: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2435: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2436: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2437: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2438: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2439: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2440: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2441: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2442: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            2443: "+proj=tmerc +lat_0=33 +lon_0=129.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2444: "+proj=tmerc +lat_0=33 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2445: "+proj=tmerc +lat_0=36 +lon_0=132.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2446: "+proj=tmerc +lat_0=33 +lon_0=133.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2447: "+proj=tmerc +lat_0=36 +lon_0=134.33333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2448: "+proj=tmerc +lat_0=36 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2449: "+proj=tmerc +lat_0=36 +lon_0=137.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2450: "+proj=tmerc +lat_0=36 +lon_0=138.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2451: "+proj=tmerc +lat_0=36 +lon_0=139.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2452: "+proj=tmerc +lat_0=40 +lon_0=140.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2453: "+proj=tmerc +lat_0=44 +lon_0=140.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2454: "+proj=tmerc +lat_0=44 +lon_0=142.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2455: "+proj=tmerc +lat_0=44 +lon_0=144.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2456: "+proj=tmerc +lat_0=26 +lon_0=142 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2457: "+proj=tmerc +lat_0=26 +lon_0=127.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2458: "+proj=tmerc +lat_0=26 +lon_0=124 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2459: "+proj=tmerc +lat_0=26 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2460: "+proj=tmerc +lat_0=20 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2461: "+proj=tmerc +lat_0=26 +lon_0=154 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2462: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2463: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2464: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2465: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2466: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2467: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2468: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2469: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2470: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2471: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2472: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2473: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2474: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2475: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2476: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2477: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2478: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2479: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2480: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2481: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2482: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2483: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2484: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2485: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2486: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2487: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2488: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2489: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2490: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2491: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2492: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2493: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2494: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2495: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2496: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2497: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2498: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2499: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2500: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2501: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2502: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2503: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2504: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2505: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2506: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2507: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2508: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2509: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2510: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2511: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2512: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2513: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2514: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2515: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2516: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2517: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2518: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2519: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2520: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2521: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2522: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2523: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2524: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2525: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2526: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2527: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2528: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2529: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2530: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=14500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2531: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=15500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2532: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=16500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2533: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=17500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2534: "+proj=tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=18500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2535: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=19500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2536: "+proj=tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=20500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2537: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=21500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2538: "+proj=tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=22500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2539: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=23500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2540: "+proj=tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=24500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2541: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2542: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2543: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2544: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2545: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2546: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2547: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2548: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2549: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2550: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            2551: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2552: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2553: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2554: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2555: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2556: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2557: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2558: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2559: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2560: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2561: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2562: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2563: "+proj=tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=46500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2564: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=47500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2565: "+proj=tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=48500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2566: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=49500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2567: "+proj=tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=50500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2568: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=51500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2569: "+proj=tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=52500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2570: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=53500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2571: "+proj=tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=54500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2572: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=55500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2573: "+proj=tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=56500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2574: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=57500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2575: "+proj=tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=58500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2576: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=59500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2577: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60000000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2578: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=61500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2579: "+proj=tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=62500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2580: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=63500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2581: "+proj=tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=64500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2582: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2583: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2584: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2585: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2586: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2587: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2588: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2589: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2590: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2591: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2592: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2593: "+proj=tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2594: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2595: "+proj=tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2596: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2597: "+proj=tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2598: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2599: "+proj=tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2600: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2601: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2602: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2603: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2604: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2605: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2606: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2607: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2608: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2609: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2610: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2611: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2612: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2613: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2614: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2615: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2616: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2617: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2618: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2619: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2620: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2621: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2622: "+proj=tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2623: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2624: "+proj=tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2625: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2626: "+proj=tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2627: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2628: "+proj=tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2629: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2630: "+proj=tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2631: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2632: "+proj=tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2633: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2634: "+proj=tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2635: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2636: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2637: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2638: "+proj=tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2639: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2640: "+proj=tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2641: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2642: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2643: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2644: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2645: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2646: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2647: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2648: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=14500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2649: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=15500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2650: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=16500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2651: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=17500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2652: "+proj=tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=18500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2653: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=19500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2654: "+proj=tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=20500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2655: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=21500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2656: "+proj=tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=22500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2657: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=23500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2658: "+proj=tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=24500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2659: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2660: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2661: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2662: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2663: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2664: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2665: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2666: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2667: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2668: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2669: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2670: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2671: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2672: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2673: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2674: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2675: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2676: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2677: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2678: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2679: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2680: "+proj=tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=46500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2681: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=47500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2682: "+proj=tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=48500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2683: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=49500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2684: "+proj=tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=50500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2685: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=51500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2686: "+proj=tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=52500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2687: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=53500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2688: "+proj=tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=54500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2689: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=55500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2690: "+proj=tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=56500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2691: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=57500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2692: "+proj=tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=58500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2693: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=59500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2694: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60000000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2695: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=61500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2696: "+proj=tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=62500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2697: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=63500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2698: "+proj=tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=64500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2699: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2700: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2701: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2702: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2703: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2704: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2705: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2706: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2707: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2708: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2709: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2710: "+proj=tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2711: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2712: "+proj=tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2713: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2714: "+proj=tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2715: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2716: "+proj=tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2717: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2718: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2719: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2720: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2721: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2722: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2723: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2724: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2725: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2726: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2727: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2728: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2729: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2730: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2731: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2732: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2733: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2734: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2735: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2736: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2737: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2738: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2739: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2740: "+proj=tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2741: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2742: "+proj=tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2743: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2744: "+proj=tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2745: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2746: "+proj=tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2747: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2748: "+proj=tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2749: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2750: "+proj=tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2751: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2752: "+proj=tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2753: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2754: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2755: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2756: "+proj=tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2757: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2758: "+proj=tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            2759: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2760: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2761: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2762: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2763: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2764: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2765: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2766: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2767: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2768: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2769: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2770: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2771: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2772: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2773: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2774: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2775: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2776: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2777: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2778: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2779: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2780: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2781: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2782: "+proj=tmerc +lat_0=18.833333333333332 +lon_0=-155.5 +k_0=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2783: "+proj=tmerc +lat_0=20.333333333333332 +lon_0=-156.66666666666666 +k_0=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2784: "+proj=tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2785: "+proj=tmerc +lat_0=21.833333333333332 +lon_0=-159.5 +k_0=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2786: "+proj=tmerc +lat_0=21.666666666666668 +lon_0=-160.16666666666666 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2787: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2788: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2789: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2790: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2791: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2792: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2793: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2794: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2795: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2796: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2797: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2798: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2799: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2800: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2801: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2802: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2803: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2804: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2805: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2806: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2807: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=8000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2808: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2809: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2810: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2811: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2812: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2813: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2814: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2815: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2816: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2817: "+proj=tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2818: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2819: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2820: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2821: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2822: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2823: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2824: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2825: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2826: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2827: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2828: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2829: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2830: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2831: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2832: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2833: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2834: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2835: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2836: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2837: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2838: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2839: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2840: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2841: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2842: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2843: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2844: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2845: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2846: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2847: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2848: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2849: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2850: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2851: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2852: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2853: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2854: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2855: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2856: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2857: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2858: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2859: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2860: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2861: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2862: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2863: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2864: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2865: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2866: "+proj=lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=200000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2867: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2868: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2869: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2870: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2871: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2872: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2873: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2874: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2875: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2876: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2877: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2878: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2879: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.60960121924 +y_0=152400.30480060962 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2880: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2881: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2882: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2883: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2884: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2885: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2886: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2887: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2888: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2889: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249364.9987299975 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2890: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249364.9987299975 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2891: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2892: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000.00010160025 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2893: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.99989839987 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2894: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000.00010160022 +y_0=750000.0000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2895: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2896: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2897: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2898: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=3999999.9999840003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2899: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2900: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2901: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2902: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2903: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2904: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2905: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2906: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=249999.99989839984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2907: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000.0001016002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2908: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2909: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2910: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2911: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2912: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2913: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2914: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000.0001464002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2915: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2916: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000.00010160022 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2917: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000.0000000001 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2918: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=699999.9998983999 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2919: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000.0000000001 +y_0=3999999.9998984006 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2920: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000.00000000006 +y_0=5000000.000101601 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2921: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.00015040004 +y_0=999999.9999960001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2922: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.00015040004 +y_0=1999999.9999920002 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2923: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.00015040004 +y_0=2999999.9999880004 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2924: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000.0001016003 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2925: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000.0001016003 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2926: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2927: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2928: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2929: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2930: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2931: "+proj=tmerc +lat_0=0 +lon_0=12.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            2932: "+proj=tmerc +lat_0=24.45 +lon_0=51.21666666666667 +k_0=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-128,-283,22 +axis=en",
            2933: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            2934: "+proj=merc +lat_0=0 +lon_0=109.99999999999989 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +axis=en",
            2935: "+proj=tmerc +lat_0=0.11666666666666667 +lon_0=41.53333333333333 +k_0=1 +x_0=1300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2936: "+proj=tmerc +lat_0=0.11666666666666667 +lon_0=44.53333333333333 +k_0=1 +x_0=2300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2937: "+proj=tmerc +lat_0=0.11666666666666667 +lon_0=47.53333333333333 +k_0=1 +x_0=3300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2938: "+proj=tmerc +lat_0=0.11666666666666667 +lon_0=50.53333333333333 +k_0=1 +x_0=4300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2939: "+proj=tmerc +lat_0=0.13333333333333333 +lon_0=50.766666666666666 +k_0=1 +x_0=2300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2940: "+proj=tmerc +lat_0=0.13333333333333333 +lon_0=53.766666666666666 +k_0=1 +x_0=3300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2941: "+proj=tmerc +lat_0=0.13333333333333333 +lon_0=56.766666666666666 +k_0=1 +x_0=4300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            2942: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314 +axis=en",
            2943: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-289,-124,60 +axis=en",
            2944: "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2945: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2946: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2947: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2948: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2949: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2950: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2951: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2952: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2953: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne",
            2954: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2955: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2956: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2957: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2958: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2959: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2960: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2961: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2962: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2964: "+proj=aea +lat_0=49.99999999999995 +lon_0=-153.99999999999986 +lat_1=54.99999999999994 +lat_2=64.99999999999993 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            2965: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2966: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            2967: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2968: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            2969: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2970: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2971: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2972: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2973: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2975: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2976: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2977: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2978: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2979: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2980: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2981: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2982: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2983: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2984: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.666666666666668 +lat_2=-22.333333333333332 +x_0=400000 +y_0=300000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2987: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            2988: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2989: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            2990: "+proj=tmerc +lat_0=-21.116666666666667 +lon_0=55.53333333333333 +k_0=1 +x_0=50000 +y_0=160000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=94,-948,-1262 +axis=en",
            2991: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            2992: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.99999840005 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            2993: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            2994: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.99999840005 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            2995: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2996: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2997: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2998: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            2999: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3e3: "+proj=merc +lat_0=0 +lon_0=109.99999999999989 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            3001: "+proj=merc +lat_0=0 +lon_0=109.99999999999989 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            3002: "+proj=merc +lat_0=0 +lon_0=109.99999999999989 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            3003: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3004: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3005: "+proj=aea +lat_0=44.99999999999996 +lon_0=-125.99999999999987 +lat_1=50 +lat_2=58.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3006: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3007: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3008: "+proj=tmerc +lat_0=0 +lon_0=13.5 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3009: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3010: "+proj=tmerc +lat_0=0 +lon_0=16.5 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3011: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3012: "+proj=tmerc +lat_0=0 +lon_0=14.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3013: "+proj=tmerc +lat_0=0 +lon_0=15.75 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3014: "+proj=tmerc +lat_0=0 +lon_0=17.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3015: "+proj=tmerc +lat_0=0 +lon_0=18.75 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3016: "+proj=tmerc +lat_0=0 +lon_0=20.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3017: "+proj=tmerc +lat_0=0 +lon_0=21.75 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3018: "+proj=tmerc +lat_0=0 +lon_0=23.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3019: "+proj=tmerc +lat_0=0 +lon_0=11.308277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
            3020: "+proj=tmerc +lat_0=0 +lon_0=13.558277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
            3021: "+proj=tmerc +lat_0=0 +lon_0=15.808277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
            3022: "+proj=tmerc +lat_0=0 +lon_0=18.05827777777778 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
            3023: "+proj=tmerc +lat_0=0 +lon_0=20.30827777777778 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
            3024: "+proj=tmerc +lat_0=0 +lon_0=22.55827777777778 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
            3025: "+proj=tmerc +lat_0=0 +lon_0=11.308277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3026: "+proj=tmerc +lat_0=0 +lon_0=13.558277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3027: "+proj=tmerc +lat_0=0 +lon_0=15.808277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3028: "+proj=tmerc +lat_0=0 +lon_0=18.05827777777778 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3029: "+proj=tmerc +lat_0=0 +lon_0=20.30827777777778 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3030: "+proj=tmerc +lat_0=0 +lon_0=22.55827777777778 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3031: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-70.99999999999993 +lon_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3032: "+proj=stere +x_0=6000000 +y_0=6000000 +lat_ts=-70.99999999999993 +lon_0=69.99999999999993 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3033: "+proj=lcc +lat_0=-50 +lon_0=70 +lat_1=-68.5 +lat_2=-74.5 +x_0=6000000 +y_0=6000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3034: "+proj=lcc +lat_0=51.99999999999995 +lon_0=9.99999999999999 +lat_1=34.999999999999964 +lat_2=64.99999999999993 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3035: "+proj=laea +lat_0=51.99999999999995 +lon_0=9.99999999999999 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3036: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3037: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3038: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3039: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3040: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3041: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3042: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3043: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3044: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3045: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3046: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3047: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3048: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3049: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3050: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3051: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3054: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-73,46,-86 +axis=en",
            3055: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-73,46,-86 +axis=en",
            3056: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-73,46,-86 +axis=en",
            3057: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3058: "+proj=tmerc +lat_0=0 +lon_0=-8.5 +k_0=1 +x_0=50000 +y_0=-7800000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            3059: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3060: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3061: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314 +axis=en",
            3062: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3063: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-104,167,-38 +axis=en",
            3064: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3065: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3066: "+proj=tmerc +lat_0=0 +lon_0=36.999999999999964 +k_0=0.9998 +x_0=500000 +y_0=-3000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            3067: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3068: "+proj=cass +lat_0=52.41864827777778 +lon_0=13.627203666666666 +x_0=40000 +y_0=10000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3069: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=-4500000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3070: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3071: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3072: "+proj=tmerc +lat_0=43.833333333333336 +lon_0=-67.875 +k_0=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3073: "+proj=tmerc +lat_0=43 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3074: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.375 +k_0=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3075: "+proj=tmerc +lat_0=43.833333333333336 +lon_0=-67.875 +k_0=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3076: "+proj=tmerc +lat_0=43 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3077: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.375 +k_0=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3078: "+proj=omerc +x_0=2546731.496 +y_0=-4354009.816 +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25555999999966 +gamma=337.25555999999966 +k_0=0.9996 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3079: "+proj=omerc +x_0=2546731.496 +y_0=-4354009.816 +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25555999999966 +gamma=337.25555999999966 +k_0=0.9996 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3080: "+proj=lcc +lat_0=31.166666666666668 +lon_0=-100 +lat_1=27.416666666666668 +lat_2=34.916666666666664 +x_0=914400 +y_0=914400 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048",
            3081: "+proj=lcc +lat_0=31.166666666666668 +lon_0=-100 +lat_1=27.416666666666668 +lat_2=34.916666666666664 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3082: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3083: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3084: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3085: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3086: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3087: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3088: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3089: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000.0000000002 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3090: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3091: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000.0000000002 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3092: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=en",
            3093: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=en",
            3094: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=en",
            3095: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=en",
            3096: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=en",
            3097: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3098: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3099: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3100: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3101: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3102: "+proj=lcc +lat_0=-14.266666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480060962 +y_0=95169.31165862334 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-115,118,426 +axis=en +to_meter=0.3048006096",
            3103: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3104: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3105: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3106: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=en",
            3107: "+proj=lcc +lat_0=-31.999999999999968 +lon_0=134.99999999999986 +lat_1=-27.99999999999997 +lat_2=-35.999999999999964 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3108: "+proj=tmerc +lat_0=49.5 +lon_0=-2.4166666666666665 +k_0=0.999997 +x_0=47000 +y_0=50000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3109: "+proj=tmerc +lat_0=49.22499999999995 +lon_0=-2.1349999999999976 +k_0=0.9999999 +x_0=40000 +y_0=70000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3110: "+proj=lcc +lat_0=-36.999999999999964 +lon_0=144.99999999999986 +lat_1=-35.999999999999964 +lat_2=-37.999999999999964 +x_0=2500000 +y_0=4500000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            3111: "+proj=lcc +lat_0=-36.999999999999964 +lon_0=144.99999999999986 +lat_1=-35.999999999999964 +lat_2=-37.999999999999964 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3112: "+proj=lcc +lat_0=0 +lon_0=133.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3113: "+proj=tmerc +lat_0=-27.99999999999997 +lon_0=152.99999999999986 +k_0=0.99999 +x_0=50000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3114: "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-80.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3115: "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-77.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3116: "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-74.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3117: "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-71.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3118: "+proj=tmerc +lat_0=4.596200416666666 +lon_0=-68.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3119: "+proj=tmerc +lat_0=0 +lon_0=10.5 +k_0=0.999 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3120: "+proj=sterea +lat_0=50.625 +lon_0=21.083333333333332 +k_0=0.9998 +x_0=4637000 +y_0=5467000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3121: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3122: "+proj=tmerc +lat_0=0 +lon_0=118.99999999999989 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3123: "+proj=tmerc +lat_0=0 +lon_0=120.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3124: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3125: "+proj=tmerc +lat_0=0 +lon_0=124.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3126: "+proj=tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3127: "+proj=tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3128: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3129: "+proj=tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3130: "+proj=tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3131: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3132: "+proj=tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3133: "+proj=tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3134: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3135: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3136: "+proj=tmerc +lat_0=0 +lon_0=28.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3137: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3138: "+proj=tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3139: "+proj=cass +hyperbolic +lat_0=-16.25 +lon_0=179.33333333333334 +x_0=251727.91554240003 +y_0=334519.953768 +ellps=clrk80 +a=6378306.3696 +b=6356571.996 +pm=0 +axis=ne +to_meter=0.201168",
            3140: "+proj=cass +lat_0=-17.999999999999982 +lon_0=177.99999999999983 +x_0=109435.392 +y_0=141622.272 +ellps=clrk80 +a=6378306.3696 +b=6356571.996 +pm=0 +axis=ne +to_meter=0.201168",
            3141: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3142: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3143: "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k_0=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            3146: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            3147: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            3148: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=198,881,317 +axis=en",
            3149: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=198,881,317 +axis=en",
            3150: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3151: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3152: "+proj=tmerc +lat_0=0 +lon_0=18.05779 +k_0=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3153: "+proj=aea +lat_0=44.99999999999996 +lon_0=-125.99999999999987 +lat_1=50 +lat_2=58.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3154: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3155: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3156: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3157: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3158: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3159: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3160: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3161: "+proj=lcc +lat_0=0 +lon_0=-84.99999999999991 +lat_1=44.49999999999996 +lat_2=53.49999999999994 +x_0=930000 +y_0=6430000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3162: "+proj=lcc +lat_0=0 +lon_0=-84.99999999999991 +lat_1=44.49999999999996 +lat_2=53.49999999999994 +x_0=930000 +y_0=6430000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3163: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.666666666666668 +lat_2=-22.333333333333332 +x_0=400000 +y_0=300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3164: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3165: "+proj=lcc +lat_0=-22.26969175 +lon_0=166.44242575 +lat_1=-22.24469175 +lat_2=-22.294691750000002 +x_0=0.66 +y_0=1.02 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3166: "+proj=lcc +lat_0=-22.26972222222222 +lon_0=166.4425 +lat_1=-22.244722222222222 +lat_2=-22.294722222222223 +x_0=8.313 +y_0=-2.354 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3167: "+proj=omerc +x_0=804670.24 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579049999997 +gamma=323.13010236111114 +k_0=0.99984 +ellps=evrst69 +a=6377295.664 +b=6356094.667915204 +pm=0 +axis=en +to_meter=20.116756",
            3168: "+proj=omerc +x_0=804670.24 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579049999997 +gamma=323.13010236111114 +k_0=0.99984 +ellps=evrst69 +a=6377295.664 +b=6356094.667915204 +pm=0 +axis=en",
            3169: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3170: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3171: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3172: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3174: "+proj=aea +lat_0=45.568976999999954 +lon_0=-84.45595499999992 +lat_1=42.12277399999996 +lat_2=49.01517999999995 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3175: "+proj=aea +lat_0=45.568976999999954 +lon_0=-83.24862699999991 +lat_1=42.12277399999996 +lat_2=49.01517999999995 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3176: "+proj=tmerc +lat_0=0 +lon_0=105.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=198,881,317 +axis=en",
            3177: "+proj=tmerc +lat_0=0 +lon_0=16.999999999999982 +k_0=0.9965 +x_0=1000000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3178: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3179: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3180: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3181: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3182: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3183: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3184: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3185: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3186: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3187: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3188: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3189: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3190: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3191: "+proj=tmerc +lat_0=0 +lon_0=10.99999999999999 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3192: "+proj=tmerc +lat_0=0 +lon_0=12.999999999999988 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3193: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3194: "+proj=tmerc +lat_0=0 +lon_0=16.999999999999982 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3195: "+proj=tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3196: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3197: "+proj=tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3198: "+proj=tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3199: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3200: "+proj=lcc +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3201: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3202: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3203: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3204: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +lat_1=-60.666666666666664 +lat_2=-63.333333333333336 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3205: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +lat_1=-60.666666666666664 +lat_2=-63.333333333333336 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3206: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-41.99999999999996 +lat_1=-60.666666666666664 +lat_2=-63.333333333333336 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3207: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-173.99999999999983 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3208: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3209: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3210: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=41.99999999999996 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3211: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=53.99999999999994 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3212: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=65.99999999999993 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3213: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=77.99999999999993 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3214: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=89.99999999999991 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3215: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=101.9999999999999 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3216: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=113.99999999999989 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3217: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=125.99999999999987 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3218: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=137.99999999999986 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3219: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=149.99999999999986 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3220: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=161.99999999999983 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3221: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-101.9999999999999 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3222: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-89.99999999999991 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3223: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-77.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3224: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3225: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-17.999999999999982 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3226: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-5.999999999999994 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3227: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=5.999999999999994 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3228: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=17.999999999999982 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3229: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=29.99999999999997 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3230: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=41.99999999999996 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3231: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=53.99999999999994 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3232: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=65.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3233: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=77.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3234: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=89.99999999999991 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3235: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=101.9999999999999 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3236: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=113.99999999999989 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3237: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=125.99999999999987 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3238: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=137.99999999999986 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3239: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=149.99999999999986 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3240: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=161.99999999999983 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3241: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=173.99999999999983 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3242: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-152.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3243: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-134.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3244: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-116.99999999999989 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3245: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-98.9999999999999 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3246: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-80.99999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3247: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-62.999999999999936 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3248: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-26.99999999999997 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3249: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-8.999999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3250: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=8.999999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3251: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=26.99999999999997 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3252: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=44.99999999999996 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3253: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=62.999999999999936 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3254: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=80.99999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3255: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=98.9999999999999 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3256: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=116.99999999999989 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3257: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=134.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3258: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=152.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3259: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=170.99999999999983 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3260: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-167.99999999999983 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3261: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-143.99999999999986 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3262: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-119.99999999999989 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3263: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-95.9999999999999 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3264: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3265: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-47.99999999999995 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3266: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=-23.999999999999975 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3267: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=0 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3268: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=23.999999999999975 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3269: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=47.99999999999995 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3270: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=71.99999999999993 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3271: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=95.9999999999999 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3272: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=119.99999999999989 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3273: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=143.99999999999986 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3274: "+proj=lcc +lat_0=-89.99999999999991 +lon_0=167.99999999999983 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3275: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-164.99999999999983 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3276: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-134.99999999999986 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3277: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-104.9999999999999 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3278: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-74.99999999999993 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3279: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-44.99999999999996 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3280: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-14.999999999999986 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3281: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=14.999999999999986 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3282: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=44.99999999999996 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3283: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=74.99999999999993 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3284: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=104.9999999999999 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3285: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=134.99999999999986 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3286: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=164.99999999999983 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3287: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-149.99999999999986 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3288: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-89.99999999999991 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3289: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-29.99999999999997 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3290: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=29.99999999999997 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3291: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=89.99999999999991 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3292: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=149.99999999999986 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3293: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3294: "+proj=lcc +lat_0=-77.99999999999993 +lon_0=161.99999999999983 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3295: "+proj=aeqd +lat_0=9.546708333333333 +lon_0=138.16874444444443 +x_0=40000 +y_0=60000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-100,-248,259 +axis=en",
            3296: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3297: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3298: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3299: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3300: "+proj=lcc +lat_0=57.51755393055556 +lon_0=24 +lat_1=59.333333333333336 +lat_2=58 +x_0=500000 +y_0=6375000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3301: "+proj=lcc +lat_0=57.51755393055556 +lon_0=24 +lat_1=59.333333333333336 +lat_2=58 +x_0=500000 +y_0=6375000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3302: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3303: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3304: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3305: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3306: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3307: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3308: "+proj=lcc +lat_0=-33.249999999999964 +lon_0=146.99999999999986 +lat_1=-30.749999999999968 +lat_2=-35.749999999999964 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3309: "+proj=aea +lat_0=0 +lon_0=-119.99999999999989 +lat_1=33.999999999999964 +lat_2=40.49999999999996 +x_0=0 +y_0=-4000000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3310: "+proj=aea +lat_0=0 +lon_0=-119.99999999999989 +lat_1=33.999999999999964 +lat_2=40.49999999999996 +x_0=0 +y_0=-4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3311: "+proj=aea +lat_0=0 +lon_0=-119.99999999999989 +lat_1=33.999999999999964 +lat_2=40.49999999999996 +x_0=0 +y_0=-4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3312: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3313: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3314: "+proj=lcc +lat_0=0 +lon_0=25.999999999999975 +lat_1=-6.499999999999994 +lat_2=-11.49999999999999 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3315: "+proj=tmerc +lat_0=-8.999999999999991 +lon_0=25.999999999999975 +k_0=0.9998 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3316: "+proj=tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3317: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3318: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3319: "+proj=tmerc +lat_0=0 +lon_0=13.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3320: "+proj=tmerc +lat_0=0 +lon_0=15.999999999999984 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3321: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3322: "+proj=tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3323: "+proj=tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3324: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3325: "+proj=tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3326: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3327: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3328: "+proj=sterea +lat_0=52.166666666666664 +lon_0=19.166666666666668 +k_0=0.999714 +x_0=500000 +y_0=500000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3329: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3330: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3331: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3332: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3333: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3334: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3335: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3336: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3337: "+proj=lcc +lat_0=-20.195069444444446 +lon_0=57.52182777777778 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3338: "+proj=aea +lat_0=49.99999999999995 +lon_0=-153.99999999999986 +lat_1=54.99999999999994 +lat_2=64.99999999999993 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3339: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3340: "+proj=tmerc +lat_0=0 +lon_0=13.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3341: "+proj=tmerc +lat_0=0 +lon_0=15.999999999999984 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3342: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3343: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3344: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3345: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3346: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3347: "+proj=lcc +lat_0=63.39067499999994 +lon_0=-91.86666666666666 +lat_1=48.99999999999995 +lat_2=76.99999999999993 +x_0=6200000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3348: "+proj=lcc +lat_0=63.39067499999994 +lon_0=-91.86666666666666 +lat_1=48.99999999999995 +lat_2=76.99999999999993 +x_0=6200000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3349: "+proj=merc +lat_0=0 +lon_0=-149.99999999999986 +k_0=1 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3350: "+proj=tmerc +lat_0=0.1 +lon_0=21.95 +k_0=1 +x_0=250000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            3351: "+proj=tmerc +lat_0=0.1 +lon_0=24.95 +k_0=1 +x_0=1250000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            3352: "+proj=tmerc +lat_0=0.1 +lon_0=27.95 +k_0=1 +x_0=2250000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            3353: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3354: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3355: "+proj=tmerc +lat_0=29.99999999999997 +lon_0=30.999999999999968 +k_0=1 +x_0=615000 +y_0=810000 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            3356: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3357: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3358: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.22 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3359: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3360: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3361: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3362: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3363: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3364: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3365: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3366: "+proj=cass +lat_0=22.312133333333335 +lon_0=114.17855555555556 +x_0=40243.577756042374 +y_0=19069.933515125784 +a=6378293.645208759 +b=6356617.987679838 +pm=0 +towgs84=-156,-271,-189 +axis=ne",
            3367: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3368: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3369: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3370: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3371: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3372: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3373: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3374: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            3375: "+proj=omerc +x_0=804671 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579646666663 +gamma=323.13010236111114 +k_0=0.99984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3376: "+proj=omerc +x_0=0 +y_0=0 +lat_0=4 +lonc=115 +alpha=53.315809949999995 +gamma=53.13010236111111 +k_0=0.99984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3377: "+proj=cass +lat_0=2.1216797444444446 +lon_0=103.42793623611112 +x_0=-14810.562 +y_0=8758.32 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3378: "+proj=cass +lat_0=2.682347636111111 +lon_0=101.97490504166667 +x_0=3673.785 +y_0=-4240.573 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3379: "+proj=cass +lat_0=3.769388088888889 +lon_0=102.36829898333333 +x_0=-7368.228 +y_0=6485.858 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3380: "+proj=cass +lat_0=3.6846490500000004 +lon_0=101.38910791388889 +x_0=-34836.161 +y_0=56464.049 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3381: "+proj=cass +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3382: "+proj=cass +lat_0=5.421517541666667 +lon_0=100.34437696388889 +x_0=-23.414 +y_0=62.283 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3383: "+proj=cass +lat_0=5.964672713888889 +lon_0=100.63637111111112 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3384: "+proj=cass +lat_0=4.859063022222222 +lon_0=100.81541058611111 +x_0=-1.769 +y_0=133454.779 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3385: "+proj=cass +lat_0=5.972543658333334 +lon_0=102.29524166944444 +x_0=13227.851 +y_0=8739.894 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3386: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            3387: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=5500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            3388: "+proj=merc +lon_0=50.99999999999995 +x_0=0 +y_0=0 +lat_1=41.99999999999996 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            3389: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            3390: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3391: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3392: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3393: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3394: "+proj=lcc +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3395: "+proj=merc +lat_0=0 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3396: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3397: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3398: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3399: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3400: "+proj=tmerc +lat_0=0 +lon_0=-114.99999999999989 +k_0=0.9992 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3401: "+proj=tmerc +lat_0=0 +lon_0=-114.99999999999989 +k_0=0.9992 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3402: "+proj=tmerc +lat_0=0 +lon_0=-114.99999999999989 +k_0=0.9992 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3403: "+proj=tmerc +lat_0=0 +lon_0=-114.99999999999989 +k_0=0.9992 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3404: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3405: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3406: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3407: "+proj=cass +lat_0=22.312133333333335 +lon_0=114.17855555555556 +x_0=40243.577756042374 +y_0=19069.933515125784 +a=6378293.645208759 +b=6356617.987679838 +pm=0 +towgs84=-156,-271,-189 +axis=ne +to_meter=0.3047972654",
            3408: "+proj=laea +ellps=sphere +lat_0=89.99999999999991 +lon_0=0 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +pm=0",
            3409: "+proj=laea +ellps=sphere +lat_0=-89.99999999999991 +lon_0=0 +x_0=0 +y_0=0 +a=6371228 +b=6371228 +pm=0",
            3410: "+proj=cea +ellps=sphere +lon_0=0 +x_0=0 +y_0=0 +lat_1=29.99999999999997 +a=6371228 +b=6371228 +pm=0 +axis=en",
            3411: "+proj=stere +x_0=0 +y_0=0 +lat_ts=69.99999999999993 +lon_0=-44.99999999999996 +a=6378273 +b=6356889.449 +pm=0 +lat_0=90",
            3412: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-69.99999999999993 +lon_0=0 +a=6378273 +b=6356889.449 +pm=0",
            3413: "+proj=stere +x_0=0 +y_0=0 +lat_ts=69.99999999999993 +lon_0=-44.99999999999996 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +lat_0=90",
            3414: "+proj=tmerc +lat_0=1.3666666666666667 +lon_0=103.83333333333333 +k_0=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            3415: "+proj=lcc +lat_0=20.99999999999998 +lon_0=113.99999999999989 +lat_1=17.999999999999982 +lat_2=23.999999999999975 +x_0=500000 +y_0=500000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            3416: "+proj=lcc +lat_0=47.5 +lon_0=13.333333333333334 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3417: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000.0000000002 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3418: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3419: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3420: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3421: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000.00001016003 +y_0=8000000.000010162 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3422: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000.0000101601 +y_0=6000000.000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3423: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000.0000101601 +y_0=3999999.9999898407 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3424: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3425: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000.0000000002 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3426: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3427: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3428: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3429: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000.00001016003 +y_0=8000000.000010162 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3430: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000.0000101601 +y_0=6000000.000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3431: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000.0000101601 +y_0=3999999.9999898407 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3432: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3433: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3434: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3435: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3436: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=699999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3437: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3438: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3439: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3440: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            3441: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3442: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3443: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3444: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=699999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3445: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3446: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3447: "+proj=lcc +lat_0=50.797815 +lon_0=4.359215833333333 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=150328 +y_0=166262 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3448: "+proj=lcc +lat_0=17.999999999999982 +lon_0=-76.99999999999993 +k_0=1 +x_0=750000 +y_0=650000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3449: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3450: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3451: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3452: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3453: "+proj=lcc +lat_0=25.5 +lon_0=-91.33333333333333 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3454: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3455: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3456: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3457: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3458: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3459: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3460: "+proj=tmerc +lat_0=-17 +lon_0=178.75 +k_0=0.99985 +x_0=2000000 +y_0=4000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            3461: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-83,37,124 +axis=en",
            3462: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-83,37,124 +axis=en",
            3463: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3464: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3465: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3466: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3467: "+proj=aea +lat_0=49.99999999999995 +lon_0=-153.99999999999986 +lat_1=54.99999999999994 +lat_2=64.99999999999993 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3468: "+proj=omerc +x_0=5000000 +y_0=-5000000 +lat_0=57 +lonc=-133.66666666666666 +alpha=323.13010236111114 +gamma=323.13010236111114 +k_0=0.9999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3469: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-141.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3470: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-145.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3471: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-149.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3472: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-153.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3473: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-157.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3474: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-161.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3475: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-165.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3476: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-169.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3477: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.833333333333336 +lat_2=51.833333333333336 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3478: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3479: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3480: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3481: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3482: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3483: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3484: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3485: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3486: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3487: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3488: "+proj=aea +lat_0=0 +lon_0=-119.99999999999989 +lat_1=33.999999999999964 +lat_2=40.49999999999996 +x_0=0 +y_0=-4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3489: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3490: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3491: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3492: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3493: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3494: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3495: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3496: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3497: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3498: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3499: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3500: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3501: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3502: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3503: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3504: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3505: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3506: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3507: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3508: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.60960121924 +y_0=152400.30480060962 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3509: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3510: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3511: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3512: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3513: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3514: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3515: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3516: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3517: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3518: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3519: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3520: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3521: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3522: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3523: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3524: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3525: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3526: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3527: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3528: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3529: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3530: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3531: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=699999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3532: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3533: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3534: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3535: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3536: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3537: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000.0000000002 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3538: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3539: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3540: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3541: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3542: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3543: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3544: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3545: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3546: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3547: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000.0000000002 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3548: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3549: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000.00010160025 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3550: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3551: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3552: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3553: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3554: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3555: "+proj=tmerc +lat_0=43.833333333333336 +lon_0=-67.875 +k_0=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3556: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.375 +k_0=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3557: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3558: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3559: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3560: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.0000101601 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3561: "+proj=tmerc +lat_0=18.833333333333332 +lon_0=-155.5 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=61,-285,-181 +axis=en +to_meter=0.3048006096",
            3562: "+proj=tmerc +lat_0=20.333333333333332 +lon_0=-156.66666666666666 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=61,-285,-181 +axis=en +to_meter=0.3048006096",
            3563: "+proj=tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=61,-285,-181 +axis=en +to_meter=0.3048006096",
            3564: "+proj=tmerc +lat_0=21.833333333333332 +lon_0=-159.5 +k_0=0.99999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=61,-285,-181 +axis=en +to_meter=0.3048006096",
            3565: "+proj=tmerc +lat_0=21.666666666666668 +lon_0=-160.16666666666666 +k_0=1 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=61,-285,-181 +axis=en +to_meter=0.3048006096",
            3566: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.0000101601 +y_0=2000000.0000101603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3567: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.0000101601 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3568: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.0000101601 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3569: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.0000101601 +y_0=2000000.0000101603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3570: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.0000101601 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3571: "+proj=laea +lat_0=89.99999999999991 +lon_0=179.99999999999983 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3572: "+proj=laea +lat_0=89.99999999999991 +lon_0=-149.99999999999986 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3573: "+proj=laea +lat_0=89.99999999999991 +lon_0=-99.9999999999999 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3574: "+proj=laea +lat_0=89.99999999999991 +lon_0=-39.99999999999996 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3575: "+proj=laea +lat_0=89.99999999999991 +lon_0=9.99999999999999 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3576: "+proj=laea +lat_0=89.99999999999991 +lon_0=89.99999999999991 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3577: "+proj=aea +lat_0=0 +lon_0=131.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3578: "+proj=aea +lat_0=59 +lon_0=-132.5 +lat_1=61.666666666666664 +lat_2=68 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3579: "+proj=aea +lat_0=59 +lon_0=-132.5 +lat_1=61.666666666666664 +lat_2=68 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3580: "+proj=lcc +lat_0=0 +lon_0=-111.99999999999989 +lat_1=61.999999999999936 +lat_2=69.99999999999993 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3581: "+proj=lcc +lat_0=0 +lon_0=-111.99999999999989 +lat_1=61.999999999999936 +lat_2=69.99999999999993 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3582: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.99989839987 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3583: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3584: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3585: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3586: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000.00010160022 +y_0=750000.0000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3587: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3588: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3589: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=8000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3590: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3591: "+proj=omerc +x_0=2546731.496 +y_0=-4354009.816 +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25555999999966 +gamma=337.25555999999966 +k_0=0.9996 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3592: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3593: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=3999999.9999840003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3594: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3595: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3596: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3597: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3598: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3599: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3600: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3601: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3602: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3603: "+proj=tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3604: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3605: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3606: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3607: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3608: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000.0000101601 +y_0=6000000.000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3609: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3610: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000.00001016003 +y_0=8000000.000010162 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3611: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3612: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000.0000101601 +y_0=3999999.9999898407 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3613: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3614: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3615: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3616: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3617: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3618: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3619: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3620: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3621: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3622: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3623: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3624: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=249999.99989839984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3625: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3626: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3627: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3628: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3629: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3630: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000.0001016002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3631: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.22 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3632: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3633: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3634: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3635: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3636: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3637: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3638: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3639: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3640: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3641: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3642: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3643: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3644: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.99999840005 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3645: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3646: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3647: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3648: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000.0001464002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3649: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3650: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3651: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3652: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3653: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3654: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3655: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3656: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3657: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3658: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3659: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3660: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3661: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3662: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3663: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3664: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=699999.9998983999 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3665: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3666: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3667: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3668: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000.00010160022 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3669: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3670: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000.0000000001 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3671: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3672: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000.00000000006 +y_0=5000000.000101601 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3673: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3674: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000.0000000001 +y_0=3999999.9998984006 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3675: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3676: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.00015040004 +y_0=1999999.9999920002 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3677: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.0000101601 +y_0=2000000.0000101603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3678: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3679: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.00015040004 +y_0=999999.9999960001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3680: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.0000101601 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3681: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3682: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.00015040004 +y_0=2999999.9999880004 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            3683: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.0000101601 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3684: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3685: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3686: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000.0001016003 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3687: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3688: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000.0001016003 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3689: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3690: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3691: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3692: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3693: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3694: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3695: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3696: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3697: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3698: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3699: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3700: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3701: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3702: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3703: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3704: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3705: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3706: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3707: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3708: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3709: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3710: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3711: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3712: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3713: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3714: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3715: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3716: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3717: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3718: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3719: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3720: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3721: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3722: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3723: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3724: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3725: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3726: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3727: "+proj=tmerc +lat_0=-21.116666666666667 +lon_0=55.53333333333333 +k_0=1 +x_0=160000 +y_0=50000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=94,-948,-1262 +axis=en",
            3728: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3729: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3730: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000.00001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3731: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3732: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3733: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3734: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3735: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3736: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000.00001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3737: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3738: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3739: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3740: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3741: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3742: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3743: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3744: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3745: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3746: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3747: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3748: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3749: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3750: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3751: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3752: "+proj=merc +lat_0=-40.99999999999996 +lon_0=99.9999999999999 +k_0=1 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3753: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3754: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3755: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000.00001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3756: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3757: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3758: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3759: "+proj=tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            3760: "+proj=tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            3761: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3762: "+proj=lcc +lat_0=-54.99999999999994 +lon_0=-36.999999999999964 +lat_1=-54 +lat_2=-54.75 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3763: "+proj=tmerc +lat_0=39.668258333333334 +lon_0=-8.133108333333334 +k_0=1 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3764: "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k_0=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3765: "+proj=tmerc +lat_0=0 +lon_0=16.499999999999982 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3766: "+proj=lcc +lat_0=0 +lon_0=16.5 +lat_1=45.916666666666664 +lat_2=43.083333333333336 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3767: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3768: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3769: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-73,213,296 +axis=en",
            3770: "+proj=tmerc +lat_0=32 +lon_0=-64.75 +k_0=1 +x_0=550000 +y_0=100000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3771: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3772: "+proj=tmerc +lat_0=0 +lon_0=-113.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3773: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3774: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3775: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3776: "+proj=tmerc +lat_0=0 +lon_0=-113.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3777: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3778: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3779: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3780: "+proj=tmerc +lat_0=0 +lon_0=-113.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3781: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3782: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3783: "+proj=tmerc +lat_0=-25.068552611111112 +lon_0=-130.11296711111112 +k_0=1 +x_0=14200 +y_0=15500 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3784: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=185,165,42 +axis=en",
            3785: "+proj=merc +ellps=sphere +lat_0=0 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +a=6378137 +b=6378137 +pm=0 +axis=en",
            3786: "+proj=eqc +ellps=GRS80 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371007 +b=6371007 +pm=0 +axis=en",
            3787: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            3788: "+proj=tmerc +lat_0=0 +lon_0=165.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3789: "+proj=tmerc +lat_0=0 +lon_0=168.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3790: "+proj=tmerc +lat_0=0 +lon_0=178.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3791: "+proj=tmerc +lat_0=0 +lon_0=-177.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3793: "+proj=tmerc +lat_0=0 +lon_0=-176.5 +k_0=1 +x_0=3500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3794: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3795: "+proj=lcc +lat_0=22.35 +lon_0=-81 +lat_1=23 +lat_2=21.7 +x_0=500000 +y_0=280296.016 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne",
            3796: "+proj=lcc +lat_0=20.716666666666665 +lon_0=-76.83333333333333 +lat_1=21.3 +lat_2=20.133333333333333 +x_0=500000 +y_0=229126.939 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne",
            3797: "+proj=lcc +lat_0=43.99999999999996 +lon_0=-69.99999999999993 +lat_1=49.99999999999995 +lat_2=45.99999999999996 +x_0=800000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3798: "+proj=lcc +lat_0=43.99999999999996 +lon_0=-69.99999999999993 +lat_1=49.99999999999995 +lat_2=45.99999999999996 +x_0=800000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3799: "+proj=lcc +lat_0=43.99999999999996 +lon_0=-69.99999999999993 +lat_1=49.99999999999995 +lat_2=45.99999999999996 +x_0=800000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3800: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3801: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3802: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3812: "+proj=lcc +lat_0=50.797815 +lon_0=4.359215833333333 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=649328 +y_0=665262 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3814: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k_0=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3815: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k_0=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3816: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k_0=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3819: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            3821: {
              p: "+proj=longlat +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            3822: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            3823: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            3824: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            3825: "+proj=tmerc +lat_0=0 +lon_0=118.99999999999989 +k_0=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3826: "+proj=tmerc +lat_0=0 +lon_0=120.99999999999987 +k_0=0.9999 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3827: "+proj=tmerc +lat_0=0 +lon_0=118.99999999999989 +k_0=0.9999 +x_0=250000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            3828: "+proj=tmerc +lat_0=0 +lon_0=120.99999999999987 +k_0=0.9999 +x_0=250000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            3829: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-634,-549,-201 +axis=en",
            3832: "+proj=merc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3833: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=2500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3834: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=2500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3835: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3836: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3837: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3838: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3839: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3840: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3841: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3842: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3843: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3844: "+proj=sterea +lat_0=45.99999999999996 +lon_0=24.999999999999975 +k_0=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            3845: "+proj=tmerc +lat_0=0 +lon_0=11.30625 +k_0=1.000006 +x_0=1500025.141 +y_0=-667.282 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3846: "+proj=tmerc +lat_0=0 +lon_0=13.556266666666668 +k_0=1.0000058 +x_0=1500044.695 +y_0=-667.13 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3847: "+proj=tmerc +lat_0=0 +lon_0=15.806284529444445 +k_0=1.00000561024 +x_0=1500064.274 +y_0=-667.711 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3848: "+proj=tmerc +lat_0=0 +lon_0=18.0563 +k_0=1.0000054 +x_0=1500083.521 +y_0=-668.844 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3849: "+proj=tmerc +lat_0=0 +lon_0=20.306316666666667 +k_0=1.0000052 +x_0=1500102.765 +y_0=-670.706 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3850: "+proj=tmerc +lat_0=0 +lon_0=22.556333333333335 +k_0=1.0000049 +x_0=1500121.846 +y_0=-672.557 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3851: "+proj=lcc +lat_0=-41 +lon_0=173 +lat_1=-37.5 +lat_2=-44.5 +x_0=3000000 +y_0=7000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3852: "+proj=lcc +lat_0=-90 +lon_0=157 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3854: "+proj=tmerc +lat_0=0 +lon_0=18.05787 +k_0=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3855: 1,
            3857: "+proj=merc +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3873: "+proj=tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=1 +x_0=19500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3874: "+proj=tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=1 +x_0=20500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3875: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=21500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3876: "+proj=tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=1 +x_0=22500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3877: "+proj=tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=1 +x_0=23500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3878: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=24500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3879: "+proj=tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=1 +x_0=25500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3880: "+proj=tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=1 +x_0=26500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3881: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=27500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3882: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=28500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3883: "+proj=tmerc +lat_0=0 +lon_0=28.99999999999997 +k_0=1 +x_0=29500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3884: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=30500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3885: "+proj=tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=31500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            3886: 1,
            3887: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            3888: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            3889: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            3890: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3891: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3892: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3893: "+proj=tmerc +lat_0=29.02626833333333 +lon_0=46.5 +k_0=0.9994 +x_0=800000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            3900: 1,
            3901: { p: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=3500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            3902: { p: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            3903: {
              p: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            3906: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            3907: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3908: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3909: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3910: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=8500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3911: "+proj=tmerc +lat_0=0 +lon_0=15 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            3912: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            3920: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=11,72,-101 +axis=en",
            3942: "+proj=lcc +lat_0=41.99999999999996 +lon_0=2.999999999999997 +lat_1=41.24999999999996 +lat_2=42.74999999999996 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3943: "+proj=lcc +lat_0=42.99999999999996 +lon_0=2.999999999999997 +lat_1=42.24999999999996 +lat_2=43.74999999999996 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3944: "+proj=lcc +lat_0=43.99999999999996 +lon_0=2.999999999999997 +lat_1=43.24999999999996 +lat_2=44.74999999999996 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3945: "+proj=lcc +lat_0=44.99999999999996 +lon_0=2.999999999999997 +lat_1=44.24999999999996 +lat_2=45.74999999999996 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3946: "+proj=lcc +lat_0=45.99999999999996 +lon_0=2.999999999999997 +lat_1=45.24999999999996 +lat_2=46.74999999999995 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3947: "+proj=lcc +lat_0=46.99999999999995 +lon_0=2.999999999999997 +lat_1=46.24999999999995 +lat_2=47.74999999999995 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3948: "+proj=lcc +lat_0=47.99999999999995 +lon_0=2.999999999999997 +lat_1=47.24999999999995 +lat_2=48.74999999999995 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3949: "+proj=lcc +lat_0=48.99999999999995 +lon_0=2.999999999999997 +lat_1=48.24999999999995 +lat_2=49.74999999999995 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3950: "+proj=lcc +lat_0=49.99999999999995 +lon_0=2.999999999999997 +lat_1=49.24999999999995 +lat_2=50.74999999999995 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3968: "+proj=lcc +lat_0=35.999999999999964 +lon_0=-79.49999999999991 +lat_1=36.999999999999964 +lat_2=39.49999999999996 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3969: "+proj=lcc +lat_0=35.999999999999964 +lon_0=-79.49999999999991 +lat_1=36.999999999999964 +lat_2=39.49999999999996 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3970: "+proj=lcc +lat_0=35.999999999999964 +lon_0=-79.49999999999991 +lat_1=36.999999999999964 +lat_2=39.49999999999996 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3973: "+proj=laea +ellps=WGS84 +lat_0=89.99999999999991 +lon_0=0 +x_0=0 +y_0=0 +a=6378137 +b=6356752.314245179 +pm=0",
            3974: "+proj=laea +ellps=WGS84 +lat_0=-89.99999999999991 +lon_0=0 +x_0=0 +y_0=0 +a=6378137 +b=6356752.314245179 +pm=0",
            3975: "+proj=cea +ellps=WGS84 +lon_0=0 +x_0=0 +y_0=0 +lat_1=29.99999999999997 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3976: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-69.99999999999993 +lon_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3978: "+proj=lcc +lat_0=48.99999999999995 +lon_0=-94.9999999999999 +lat_1=48.99999999999995 +lat_2=76.99999999999993 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            3979: "+proj=lcc +lat_0=48.99999999999995 +lon_0=-94.9999999999999 +lat_1=48.99999999999995 +lat_2=76.99999999999993 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            3985: "+proj=lcc +lat_0=8.999999999999991 +lon_0=25.999999999999975 +lat_1=-6.499999999999994 +lat_2=-11.49999999999999 +x_0=500000 +y_0=500000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3986: "+proj=tmerc +lat_0=-8.999999999999991 +lon_0=29.99999999999997 +k_0=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3987: "+proj=tmerc +lat_0=-8.999999999999991 +lon_0=27.99999999999997 +k_0=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3988: "+proj=tmerc +lat_0=-8.999999999999991 +lon_0=25.999999999999975 +k_0=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3989: "+proj=tmerc +lat_0=-8.999999999999991 +lon_0=23.999999999999975 +k_0=1 +x_0=200000 +y_0=500000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            3991: "+proj=lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=11,72,-101 +axis=en +to_meter=0.3048006096",
            3992: "+proj=lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=152400.30480060962 +y_0=30480.060960121926 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=11,72,-101 +axis=en +to_meter=0.3048006096",
            3993: "+proj=aeqd +guam +lat_0=13.472466352777777 +lon_0=144.74875070555555 +x_0=50000 +y_0=50000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-100,-248,259 +axis=en",
            3994: "+proj=merc +lon_0=99.9999999999999 +x_0=0 +y_0=0 +lat_1=-40.99999999999996 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            3995: "+proj=stere +x_0=0 +y_0=0 +lat_ts=70.99999999999993 +lon_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3996: "+proj=stere +x_0=0 +y_0=0 +lat_ts=74.99999999999993 +lon_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            3997: "+proj=tmerc +lat_0=0 +lon_0=55.333333333333336 +k_0=1 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            4e3: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4001: {
              p: "+proj=longlat +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4002: { p: "+proj=longlat +ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0 +axis=ne", x: 1, y: 1 },
            4003: { p: "+proj=longlat +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +axis=ne", x: 1, y: 1 },
            4004: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4005: { p: "+proj=longlat +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=0 +axis=ne", x: 1, y: 1 },
            4006: {
              p: "+proj=longlat +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4007: { p: "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=ne", x: 1, y: 1 },
            4008: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4009: { p: "+proj=longlat +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +axis=ne", x: 1, y: 1 },
            4010: { p: "+proj=longlat +ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0 +axis=ne", x: 1, y: 1 },
            4011: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4012: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4013: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +axis=ne", x: 1, y: 1 },
            4014: { p: "+proj=longlat +ellps=clrk80 +a=6378249.2 +b=6356514.996941779 +pm=0 +axis=ne", x: 1, y: 1 },
            4015: { p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=ne", x: 1, y: 1 },
            4016: { p: "+proj=longlat +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +axis=ne", x: 1, y: 1 },
            4017: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4018: {
              p: "+proj=longlat +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4019: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            4020: { p: "+proj=longlat +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=ne", x: 1, y: 1 },
            4021: { p: "+proj=longlat +a=6378160 +b=6356774.50408554 +pm=0 +axis=ne", x: 1, y: 1 },
            4022: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4023: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4024: {
              p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4025: { p: "+proj=longlat +ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0 +axis=ne", x: 1, y: 1 },
            4026: "+proj=tmerc +lat_0=0 +lon_0=28.4 +k_0=0.99994 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4027: { p: "+proj=longlat +ellps=plessis +a=6376523 +b=6355862.933255573 +pm=0 +axis=ne", x: 1, y: 1 },
            4028: { p: "+proj=longlat +a=6378298.3 +b=6356657.142669562 +pm=0 +axis=ne", x: 1, y: 1 },
            4029: { p: "+proj=longlat +a=6378300 +b=6356751.689189189 +pm=0 +axis=ne", x: 1, y: 1 },
            4030: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +towgs84=0,0,0 +axis=ne",
              x: 1,
              y: 1
            },
            4031: { p: "+proj=longlat +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4032: { p: "+proj=longlat +a=6378136.2 +b=6356751.516927429 +pm=0 +axis=ne", x: 1, y: 1 },
            4033: { p: "+proj=longlat +a=6378136.3 +b=6356751.616592146 +pm=0 +axis=ne", x: 1, y: 1 },
            4034: { p: "+proj=longlat +ellps=clrk80 +a=6378249.144808011 +b=6356514.966204134 +pm=0 +axis=ne", x: 1, y: 1 },
            4036: { p: "+proj=longlat +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            4037: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            4038: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            4039: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4040: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4041: { p: "+proj=longlat +a=6378135 +b=6356750.304921594 +pm=0 +axis=ne", x: 1, y: 1 },
            4042: { p: "+proj=longlat +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=ne", x: 1, y: 1 },
            4043: {
              p: "+proj=longlat +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +towgs84=0,8,10 +axis=ne",
              x: 1,
              y: 1
            },
            4044: { p: "+proj=longlat +ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0 +axis=ne", x: 1, y: 1 },
            4045: { p: "+proj=longlat +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=ne", x: 1, y: 1 },
            4046: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4047: { p: "+proj=longlat +ellps=GRS80 +a=6371007 +b=6371007 +pm=0 +axis=ne", x: 1, y: 1 },
            4048: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4049: "+proj=tmerc +lat_0=0 +lon_0=13.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4050: "+proj=tmerc +lat_0=0 +lon_0=15.999999999999984 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4051: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4052: {
              p: "+proj=longlat +ellps=clrk66 +a=6370997 +b=6370997 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4053: { p: "+proj=longlat +a=6371228 +b=6371228 +pm=0 +axis=ne", x: 1, y: 1 },
            4054: { p: "+proj=longlat +a=6378273 +b=6356889.449 +pm=0 +axis=ne", x: 1, y: 1 },
            4055: { p: "+proj=longlat +a=6378137 +b=6378137 +pm=0 +axis=ne", x: 1, y: 1 },
            4056: "+proj=tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4057: "+proj=tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4058: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4059: "+proj=tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4060: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4061: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4062: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4063: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4071: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-134,229,-29 +axis=en",
            4073: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4074: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4075: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4079: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4080: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4081: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4082: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4083: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4087: "+proj=eqc +lon_0=0 +x_0=0 +y_0=0 +lat_1=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            4088: "+proj=eqc +ellps=GRS80 +lon_0=0 +x_0=0 +y_0=0 +lat_1=0 +a=6371007 +b=6371007 +pm=0 +axis=en",
            4093: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4094: "+proj=tmerc +lat_0=0 +lon_0=9.99999999999999 +k_0=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4095: "+proj=tmerc +lat_0=0 +lon_0=11.749999999999988 +k_0=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4096: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4097: {
              p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.99998 +x_0=200000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            4098: { p: "+proj=tmerc +lat_0=0 +lon_0=9.99999999999999 +k_0=0.99998 +x_0=400000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            4099: { p: "+proj=tmerc +lat_0=0 +lon_0=11.749999999999988 +k_0=0.99998 +x_0=600000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            4100: {
              p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=800000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            4120: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4121: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4122: { p: "+proj=longlat +a=6378135 +b=6356750.304921594 +pm=0 +axis=ne", x: 1, y: 1 },
            4123: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4124: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne",
              x: 1,
              y: 1
            },
            4127: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4128: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4129: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4130: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4131: { p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=198,881,317 +axis=ne", x: 1, y: 1 },
            4132: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4133: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4134: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4135: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=61,-285,-181 +axis=ne", x: 1, y: 1 },
            4136: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4137: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4138: {
              p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4139: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=11,72,-101 +axis=ne", x: 1, y: 1 },
            4141: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4142: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4143: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4144: {
              p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4145: { p: "+proj=longlat +ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0 +axis=ne", x: 1, y: 1 },
            4146: { p: "+proj=longlat +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=ne", x: 1, y: 1 },
            4147: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4148: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4149: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4150: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4151: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4152: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            4153: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4154: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4155: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-83,37,124 +axis=ne", x: 1, y: 1 },
            4156: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4157: { p: "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=ne", x: 1, y: 1 },
            4158: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-2,374,172 +axis=ne", x: 1, y: 1 },
            4159: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4160: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4161: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4162: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4163: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4164: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4165: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4166: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4167: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4168: { p: "+proj=longlat +a=6378300 +b=6356751.689189189 +pm=0 +axis=ne", x: 1, y: 1 },
            4169: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-115,118,426 +axis=ne", x: 1, y: 1 },
            4170: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4171: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4173: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4174: {
              p: "+proj=longlat +a=6378300 +b=6356751.689189189 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4175: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-88,4,101 +axis=ne", x: 1, y: 1 },
            4176: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4178: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4179: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4180: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4181: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4182: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4183: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-104,167,-38 +axis=ne", x: 1, y: 1 },
            4184: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4188: { p: "+proj=longlat +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=ne", x: 1, y: 1 },
            4189: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4190: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4191: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4192: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4193: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4194: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=164,138,-189 +axis=ne", x: 1, y: 1 },
            4195: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4196: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4197: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4198: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4199: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4200: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4201: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-162,-12,206 +axis=ne",
              x: 1,
              y: 1
            },
            4202: { p: "+proj=longlat +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=ne", x: 1, y: 1 },
            4203: { p: "+proj=longlat +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=ne", x: 1, y: 1 },
            4204: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4205: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-43,-163,45 +axis=ne", x: 1, y: 1 },
            4206: {
              p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4207: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4208: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4209: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-143,-90,-294 +axis=ne", x: 1, y: 1 },
            4210: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300 +axis=ne", x: 1, y: 1 },
            4211: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4212: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4213: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4214: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne", x: 1, y: 1 },
            4215: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4216: {
              p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-73,213,296 +axis=ne",
              x: 1,
              y: 1
            },
            4217: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4218: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=ne", x: 1, y: 1 },
            4219: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-384,664,-48 +axis=ne", x: 1, y: 1 },
            4220: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4221: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne", x: 1, y: 1 },
            4222: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ne", x: 1, y: 1 },
            4223: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-263,6,431 +axis=ne", x: 1, y: 1 },
            4224: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-134,229,-29 +axis=ne", x: 1, y: 1 },
            4225: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=ne",
              x: 1,
              y: 1
            },
            4227: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4229: { p: "+proj=longlat +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=ne", x: 1, y: 1 },
            4230: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=ne", x: 1, y: 1 },
            4231: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-83,-96,-113 +axis=ne", x: 1, y: 1 },
            4232: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4233: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4236: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-634,-549,-201 +axis=ne", x: 1, y: 1 },
            4237: { p: "+proj=longlat +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=ne", x: 1, y: 1 },
            4238: { p: "+proj=longlat +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=ne", x: 1, y: 1 },
            4239: {
              p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=217,823,299 +axis=ne",
              x: 1,
              y: 1
            },
            4240: { p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=210,814,289 +axis=ne", x: 1, y: 1 },
            4241: { p: "+proj=longlat +ellps=clrk80 +a=6378249.144808011 +b=6356514.966204134 +pm=0 +axis=ne", x: 1, y: 1 },
            4242: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4243: { p: "+proj=longlat +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=ne", x: 1, y: 1 },
            4244: {
              p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=-97,787,86 +axis=ne",
              x: 1,
              y: 1
            },
            4245: { p: "+proj=longlat +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=ne", x: 1, y: 1 },
            4246: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4247: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4248: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4249: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4250: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-130,29,364 +axis=ne",
              x: 1,
              y: 1
            },
            4251: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-90,40,88 +axis=ne", x: 1, y: 1 },
            4252: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4253: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-133,-77,-51 +axis=ne", x: 1, y: 1 },
            4254: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=16,196,93 +axis=ne", x: 1, y: 1 },
            4255: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-333,-222,114 +axis=ne",
              x: 1,
              y: 1
            },
            4256: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=41,-220,-134 +axis=ne", x: 1, y: 1 },
            4257: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4258: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4259: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4261: {
              p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=31,146,47 +axis=ne",
              x: 1,
              y: 1
            },
            4262: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=639,405,60 +axis=ne", x: 1, y: 1 },
            4263: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-92,-93,122 +axis=ne", x: 1, y: 1 },
            4264: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4265: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4266: {
              p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-74,-130,42 +axis=ne",
              x: 1,
              y: 1
            },
            4267: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4268: { p: "+proj=longlat +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176 +axis=ne", x: 1, y: 1 },
            4269: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4270: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4271: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-2,374,172 +axis=ne",
              x: 1,
              y: 1
            },
            4272: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne", x: 1, y: 1 },
            4273: { p: "+proj=longlat +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=0 +axis=ne", x: 1, y: 1 },
            4274: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4275: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4276: {
              p: "+proj=longlat +ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4277: { p: "+proj=longlat +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=ne", x: 1, y: 1 },
            4278: { p: "+proj=longlat +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=ne", x: 1, y: 1 },
            4279: { p: "+proj=longlat +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=ne", x: 1, y: 1 },
            4280: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4281: { p: "+proj=longlat +ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0 +axis=ne", x: 1, y: 1 },
            4282: {
              p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4283: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4284: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne", x: 1, y: 1 },
            4285: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4286: { p: "+proj=longlat +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=ne", x: 1, y: 1 },
            4288: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4289: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4292: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-355,16,74 +axis=ne", x: 1, y: 1 },
            4293: { p: "+proj=longlat +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ne", x: 1, y: 1 },
            4295: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4297: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-189,-242,-91 +axis=ne",
              x: 1,
              y: 1
            },
            4298: { p: "+proj=longlat +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46 +axis=ne", x: 1, y: 1 },
            4299: { p: "+proj=longlat +ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0 +axis=ne", x: 1, y: 1 },
            4300: { p: "+proj=longlat +ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0 +towgs84=506,-122,611 +axis=ne", x: 1, y: 1 },
            4301: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne", x: 1, y: 1 },
            4302: {
              p: "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4303: { p: "+proj=longlat +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=ne", x: 1, y: 1 },
            4304: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-73,-247,227 +axis=ne", x: 1, y: 1 },
            4305: "+proj=longlat +ellps=clrk80 +no_defs",
            4306: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4307: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310 +axis=ne", x: 1, y: 1 },
            4308: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4309: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-155,171,37 +axis=ne", x: 1, y: 1 },
            4310: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4311: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-265,120,-358 +axis=ne", x: 1, y: 1 },
            4312: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4313: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4314: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4315: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4316: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4317: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4318: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4319: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4322: { p: "+proj=longlat +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=ne", x: 1, y: 1 },
            4324: { p: "+proj=longlat +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=ne", x: 1, y: 1 },
            4326: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4328: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4330: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4331: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4332: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4333: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4334: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4335: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4336: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4337: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4338: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4340: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4342: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4344: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4346: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4347: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4348: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4350: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4352: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4354: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4356: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4358: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4360: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            4362: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            4364: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4366: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4368: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4370: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4372: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4374: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4376: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4378: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4380: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4382: "+proj=geocent +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            4384: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4385: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4387: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4389: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4390: "+proj=cass +lat_0=2.0425833333333334 +lon_0=103.56275833333333 +x_0=0 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4391: "+proj=cass +lat_0=2.7122833333333336 +lon_0=101.94116666666667 +x_0=-242.005 +y_0=-948.547 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4392: "+proj=cass +lat_0=3.7109722222222223 +lon_0=102.43617777777779 +x_0=0 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4393: "+proj=cass +lat_0=3.680344444444444 +lon_0=101.50824444444444 +x_0=-21759.438 +y_0=55960.906 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4394: "+proj=cass +lat_0=4.946141666666667 +lon_0=102.89520833333334 +x_0=0 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4395: "+proj=cass +lat_0=5.421325 +lon_0=100.34586944444445 +x_0=0 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4396: "+proj=cass +lat_0=5.965147222222223 +lon_0=100.63759444444445 +x_0=0 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4397: "+proj=cass +lat_0=4.859380555555555 +lon_0=100.81676666666667 +x_0=0 +y_0=133453.669 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4398: "+proj=cass +lat_0=5.893922222222222 +lon_0=102.17729166666668 +x_0=0 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            4399: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4400: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4401: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4402: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4403: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4404: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4405: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4406: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4407: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4408: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4409: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4410: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4411: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4412: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4413: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4414: "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k_0=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            4415: "+proj=lcc +lat_0=-8.999999999999991 +lon_0=25.999999999999975 +lat_1=-6.499999999999994 +lat_2=-11.49999999999999 +x_0=500000 +y_0=500000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            4417: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4418: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4419: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4420: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4421: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4422: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4423: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4424: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4425: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4426: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4427: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4428: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4429: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4430: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4431: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4432: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4433: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4434: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4437: "+proj=lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=200000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            4438: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4439: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4440: 1,
            4455: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4456: "+proj=lcc +lat_0=40.5 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=609601.2192024385 +y_0=30480.060960121926 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            4457: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            4458: 1,
            4462: "+proj=lcc +lat_0=-26.99999999999997 +lon_0=131.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            4463: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4465: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4466: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4467: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4468: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4469: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4470: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4471: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4472: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4473: "+proj=geocent +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            4474: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            4475: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4479: "+proj=geocent +a=6378137 +b=6356752.314140356 +pm=0",
            4480: { p: "+proj=longlat +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4481: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4482: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4483: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4484: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4485: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4486: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4487: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4488: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4489: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4490: { p: "+proj=longlat +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4491: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4492: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4493: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4494: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4495: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4496: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4497: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4498: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4499: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4500: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4501: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4502: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4503: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4504: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4505: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4506: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4507: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4508: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4509: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4510: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4511: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4512: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4513: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4514: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4515: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4516: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4517: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4518: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4519: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4520: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4521: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4522: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4523: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4524: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4525: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4526: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4527: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4528: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4529: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4530: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4531: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4532: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4533: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4534: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4535: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4536: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4537: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4538: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4539: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4540: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4541: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4542: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4543: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4544: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4545: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4546: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4547: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4548: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4549: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4550: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4551: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4552: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4553: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4554: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4555: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4556: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4557: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4558: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4559: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4568: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4569: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4570: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4571: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4572: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4573: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4574: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4575: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4576: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4577: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4578: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4579: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4580: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4581: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4582: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4583: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4584: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4585: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4586: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4587: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4588: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4589: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4600: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4601: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-270,13,62 +axis=ne", x: 1, y: 1 },
            4602: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4603: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4604: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=174,359,365 +axis=ne", x: 1, y: 1 },
            4605: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4606: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4607: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4608: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4609: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4610: { p: "+proj=longlat +a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1 +axis=ne", x: 1, y: 1 },
            4611: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4612: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4613: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4614: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-128,-283,22 +axis=ne", x: 1, y: 1 },
            4615: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314 +axis=ne", x: 1, y: 1 },
            4616: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-289,-124,60 +axis=ne", x: 1, y: 1 },
            4617: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            4618: {
              p: "+proj=longlat +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=ne",
              x: 1,
              y: 1
            },
            4619: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4620: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-106,-129,165 +axis=ne", x: 1, y: 1 },
            4621: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4622: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4623: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4624: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4625: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4626: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=94,-948,-1262 +axis=ne", x: 1, y: 1 },
            4627: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4628: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4629: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4630: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4631: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4632: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4633: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4635: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4636: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4637: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4638: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4639: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4640: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4641: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4642: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4643: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4644: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4645: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4646: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4647: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            4652: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4653: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4654: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4655: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4656: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4657: { p: "+proj=longlat +a=6377019.27 +b=6355762.5391 +pm=0 +axis=ne", x: 1, y: 1 },
            4658: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-73,46,-86 +axis=ne", x: 1, y: 1 },
            4659: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4660: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4661: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4662: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4663: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314 +axis=ne", x: 1, y: 1 },
            4664: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4665: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-104,167,-38 +axis=ne",
              x: 1,
              y: 1
            },
            4666: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4667: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4668: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-86,-98,-119 +axis=ne", x: 1, y: 1 },
            4669: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4670: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4671: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=ne", x: 1, y: 1 },
            4672: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=175,-38,113 +axis=ne", x: 1, y: 1 },
            4673: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4674: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4675: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-100,-248,259 +axis=ne", x: 1, y: 1 },
            4676: {
              p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4677: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4678: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            4679: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4680: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4681: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4682: {
              p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4683: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4684: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4685: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-133,-321,50 +axis=ne", x: 1, y: 1 },
            4686: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4687: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4688: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4689: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4690: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4691: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4692: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4693: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4694: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4695: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4696: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4697: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4698: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4699: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4700: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4701: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4702: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4703: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4704: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4705: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4706: {
              p: "+proj=longlat +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4707: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4708: { p: "+proj=longlat +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +axis=ne", x: 1, y: 1 },
            4709: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4710: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-320,550,-494 +axis=ne", x: 1, y: 1 },
            4711: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4712: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-207,107,52 +axis=ne",
              x: 1,
              y: 1
            },
            4713: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-79,-129,145 +axis=ne", x: 1, y: 1 },
            4714: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-127,-769,472 +axis=ne", x: 1, y: 1 },
            4715: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4716: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4717: {
              p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-2,150,181 +axis=ne",
              x: 1,
              y: 1
            },
            4718: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4719: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=211,147,111 +axis=ne", x: 1, y: 1 },
            4720: { p: "+proj=longlat +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=ne", x: 1, y: 1 },
            4721: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4722: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4723: {
              p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4724: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4725: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=191,-77,-204 +axis=ne", x: 1, y: 1 },
            4726: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            4727: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=912,-58,1227 +axis=ne", x: 1, y: 1 },
            4728: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-307,-92,127 +axis=ne",
              x: 1,
              y: 1
            },
            4729: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=185,165,42 +axis=ne", x: 1, y: 1 },
            4730: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=170,42,84 +axis=ne", x: 1, y: 1 },
            4731: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=51,391,-36 +axis=ne", x: 1, y: 1 },
            4732: { p: "+proj=longlat +ellps=hough +a=6378270 +b=6356794.343434343 +pm=0 +towgs84=101,52,-39 +axis=ne", x: 1, y: 1 },
            4733: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4734: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-632,438,-609 +axis=ne", x: 1, y: 1 },
            4735: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=647,1777,-1124 +axis=ne", x: 1, y: 1 },
            4736: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=260,12,-147 +axis=ne", x: 1, y: 1 },
            4737: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4738: {
              p: "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +pm=0 +towgs84=-156,-271,-189 +axis=ne",
              x: 1,
              y: 1
            },
            4739: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4740: { p: "+proj=longlat +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0 +axis=ne", x: 1, y: 1 },
            4741: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4742: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4743: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            4744: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4745: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4746: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            4747: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4748: { p: "+proj=longlat +ellps=clrk80 +a=6378306.3696 +b=6356571.996 +pm=0 +axis=ne", x: 1, y: 1 },
            4749: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4750: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4751: { p: "+proj=longlat +ellps=evrst69 +a=6377295.664 +b=6356094.667915204 +pm=0 +axis=ne", x: 1, y: 1 },
            4752: { p: "+proj=longlat +ellps=clrk80 +a=6378306.3696 +b=6356571.996 +pm=0 +axis=ne", x: 1, y: 1 },
            4753: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4754: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4755: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4756: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4757: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4758: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4759: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            4760: { p: "+proj=longlat +ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0 +axis=ne", x: 1, y: 1 },
            4761: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4762: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            4763: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            4764: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4765: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            4766: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4767: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4768: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4769: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4770: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4771: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4772: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4773: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4774: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4775: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4776: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4777: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4778: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4779: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4780: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4781: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4782: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4783: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4784: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4785: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4786: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4787: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4788: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4789: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4790: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4791: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4792: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4793: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4794: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4795: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4796: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4797: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4798: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4799: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4800: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4801: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=7.439583333333333 +axis=ne", x: 1, y: 1 },
            4802: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=-74.08091666666667 +towgs84=307,304,-318 +axis=ne", x: 1, y: 1 },
            4803: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=-9.131906111111112 +axis=ne", x: 1, y: 1 },
            4804: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +axis=ne",
              x: 1,
              y: 1
            },
            4805: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne", x: 1, y: 1 },
            4806: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=12.452333333333332 +towgs84=-225,-65,9 +axis=ne", x: 1, y: 1 },
            4807: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=ne", x: 0.8999999999999991, y: 0.8999999999999991 },
            4808: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +axis=ne",
              x: 1,
              y: 1
            },
            4809: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=4.3679749999999995 +axis=ne", x: 1, y: 1 },
            4810: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=2.337229169999998 +towgs84=-189,-242,-91 +axis=ne", x: 0.8999999999999991, y: 0.8999999999999991 },
            4811: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +towgs84=-73,-247,227 +axis=ne", x: 0.8999999999999991, y: 0.8999999999999991 },
            4812: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4813: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +towgs84=-377,681,-50 +axis=ne", x: 1, y: 1 },
            4814: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=18.05827777777778 +axis=ne", x: 1, y: 1 },
            4815: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=23.716337499999998 +axis=ne", x: 1, y: 1 },
            4816: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=ne", x: 0.8999999999999991, y: 0.8999999999999991 },
            4817: { p: "+proj=longlat +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne", x: 1, y: 1 },
            4818: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne", x: 1, y: 1 },
            4819: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=2.337229169999998 +axis=ne", x: 0.8999999999999991, y: 0.8999999999999991 },
            4820: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +axis=ne", x: 1, y: 1 },
            4821: {
              p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=ne",
              x: 0.8999999999999991,
              y: 0.8999999999999991
            },
            4822: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            4823: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4824: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            4826: "+proj=lcc +lat_0=15.833333333333334 +lon_0=-24 +lat_1=15 +lat_2=16.666666666666668 +x_0=161587.83 +y_0=128511.202 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4839: "+proj=lcc +lat_0=50.99999999999995 +lon_0=10.5 +lat_1=48.666666666666664 +lat_2=53.666666666666664 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4855: "+proj=tmerc +lat_0=0 +lon_0=5.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4856: "+proj=tmerc +lat_0=0 +lon_0=6.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4857: "+proj=tmerc +lat_0=0 +lon_0=7.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4858: "+proj=tmerc +lat_0=0 +lon_0=8.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4859: "+proj=tmerc +lat_0=0 +lon_0=9.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4860: "+proj=tmerc +lat_0=0 +lon_0=10.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4861: "+proj=tmerc +lat_0=0 +lon_0=11.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4862: "+proj=tmerc +lat_0=0 +lon_0=12.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4863: "+proj=tmerc +lat_0=0 +lon_0=13.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4864: "+proj=tmerc +lat_0=0 +lon_0=14.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4865: "+proj=tmerc +lat_0=0 +lon_0=15.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4866: "+proj=tmerc +lat_0=0 +lon_0=16.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4867: "+proj=tmerc +lat_0=0 +lon_0=17.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4868: "+proj=tmerc +lat_0=0 +lon_0=18.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4869: "+proj=tmerc +lat_0=0 +lon_0=19.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4870: "+proj=tmerc +lat_0=0 +lon_0=20.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4871: "+proj=tmerc +lat_0=0 +lon_0=21.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4872: "+proj=tmerc +lat_0=0 +lon_0=22.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4873: "+proj=tmerc +lat_0=0 +lon_0=23.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4874: "+proj=tmerc +lat_0=0 +lon_0=24.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4875: "+proj=tmerc +lat_0=0 +lon_0=25.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4876: "+proj=tmerc +lat_0=0 +lon_0=26.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4877: "+proj=tmerc +lat_0=0 +lon_0=27.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4878: "+proj=tmerc +lat_0=0 +lon_0=28.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4879: "+proj=tmerc +lat_0=0 +lon_0=29.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4880: "+proj=tmerc +lat_0=0 +lon_0=30.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            4882: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4883: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4884: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4885: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4886: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4887: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4888: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4889: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4890: "+proj=geocent +ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0",
            4891: { p: "+proj=longlat +ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4892: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            4893: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu", x: 1, y: 1, z: 1 },
            4894: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4895: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4896: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4897: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4898: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4899: "+proj=geocent +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            4900: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4901: {
              p: "+proj=longlat +ellps=plessis +a=6376523 +b=6355862.933255573 +pm=2.3372083333333333 +axis=ne",
              x: 0.8999999999999991,
              y: 0.8999999999999991
            },
            4902: { p: "+proj=longlat +ellps=plessis +a=6376523 +b=6355862.933255573 +pm=2.337229169999998 +axis=ne", x: 0.8999999999999991, y: 0.8999999999999991 },
            4903: { p: "+proj=longlat +a=6378298.3 +b=6356657.142669562 +pm=-3.6873750000000003 +axis=ne", x: 1, y: 1 },
            4904: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-9.131906111111112 +axis=ne", x: 1, y: 1 },
            4906: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4907: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4908: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4909: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4910: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4911: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4912: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4913: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4914: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4915: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4916: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4917: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4918: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4919: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4920: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4921: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4922: "+proj=geocent +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0",
            4923: { p: "+proj=longlat +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4924: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4925: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4926: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4927: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4928: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4929: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4930: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4931: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4932: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4933: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4934: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4935: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4936: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4937: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4938: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4939: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4940: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4941: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4942: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4943: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4944: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4945: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4946: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4947: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4948: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4949: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4950: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4951: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4952: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4953: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4954: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            4955: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu", x: 1, y: 1, z: 1 },
            4956: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            4957: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4958: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4959: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4960: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4961: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4962: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4963: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4964: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4965: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4966: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4967: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4968: "+proj=geocent +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            4969: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4970: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4971: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4972: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4973: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4974: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4975: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4976: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4977: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4978: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4979: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4980: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            4981: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4982: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4983: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4984: "+proj=geocent +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0",
            4985: { p: "+proj=longlat +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4986: "+proj=geocent +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0",
            4987: {
              p: "+proj=longlat +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4988: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4989: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4990: "+proj=geocent +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            4991: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4992: "+proj=geocent +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            4993: {
              p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            4994: "+proj=geocent +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            4995: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4996: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4997: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            4998: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            4999: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            5011: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5012: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5013: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5014: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5015: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5016: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5018: "+proj=tmerc +lat_0=39.666666666666664 +lon_0=-8.131906111111112 +k_0=1 +x_0=0 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            5041: "+proj=stere +lat_0=89.99999999999991 +lon_0=0 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5042: "+proj=stere +lat_0=-89.99999999999991 +lon_0=0 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5048: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5069: "+proj=aea +lat_0=22.99999999999998 +lon_0=-95.9999999999999 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5070: "+proj=aea +lat_0=22.99999999999998 +lon_0=-95.9999999999999 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5071: "+proj=aea +lat_0=22.99999999999998 +lon_0=-95.9999999999999 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            5072: "+proj=aea +lat_0=22.99999999999998 +lon_0=-95.9999999999999 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            5105: "+proj=tmerc +lat_0=58 +lon_0=5.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5106: "+proj=tmerc +lat_0=58 +lon_0=6.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5107: "+proj=tmerc +lat_0=58 +lon_0=7.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5108: "+proj=tmerc +lat_0=58 +lon_0=8.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5109: "+proj=tmerc +lat_0=58 +lon_0=9.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5110: "+proj=tmerc +lat_0=58 +lon_0=10.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5111: "+proj=tmerc +lat_0=58 +lon_0=11.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5112: "+proj=tmerc +lat_0=58 +lon_0=12.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5113: "+proj=tmerc +lat_0=58 +lon_0=13.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5114: "+proj=tmerc +lat_0=58 +lon_0=14.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5115: "+proj=tmerc +lat_0=58 +lon_0=15.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5116: "+proj=tmerc +lat_0=58 +lon_0=16.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5117: "+proj=tmerc +lat_0=58 +lon_0=17.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5118: "+proj=tmerc +lat_0=58 +lon_0=18.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5119: "+proj=tmerc +lat_0=58 +lon_0=19.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5120: "+proj=tmerc +lat_0=58 +lon_0=20.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5121: "+proj=tmerc +lat_0=58 +lon_0=21.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5122: "+proj=tmerc +lat_0=58 +lon_0=22.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5123: "+proj=tmerc +lat_0=58 +lon_0=23.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5124: "+proj=tmerc +lat_0=58 +lon_0=24.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5125: "+proj=tmerc +lat_0=58 +lon_0=25.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5126: "+proj=tmerc +lat_0=58 +lon_0=26.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5127: "+proj=tmerc +lat_0=58 +lon_0=27.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5128: "+proj=tmerc +lat_0=58 +lon_0=28.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5129: "+proj=tmerc +lat_0=58 +lon_0=29.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5130: "+proj=tmerc +lat_0=58 +lon_0=30.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5132: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            5167: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=130.99999999999986 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5168: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=550000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5169: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=124.99999999999987 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5170: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5171: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=128.99999999999986 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5172: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=130.99999999999986 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5173: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=125.00289027777778 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5174: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=127.00289027777778 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5175: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=127.00289027777778 +k_0=1 +x_0=200000 +y_0=550000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5176: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=129.00289027777777 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5177: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=131.00289027777777 +k_0=1 +x_0=200000 +y_0=500000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5178: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=127.5 +k_0=0.9996 +x_0=1000000 +y_0=2000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5179: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=127.5 +k_0=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5180: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=124.99999999999987 +k_0=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5181: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5182: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=550000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5183: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=128.99999999999986 +k_0=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5184: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=130.99999999999986 +k_0=1 +x_0=200000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5185: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=124.99999999999987 +k_0=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5186: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5187: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=128.99999999999986 +k_0=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5188: "+proj=tmerc +lat_0=37.999999999999964 +lon_0=130.99999999999986 +k_0=1 +x_0=200000 +y_0=600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5193: 1,
            5195: 1,
            5214: 1,
            5221: "+proj=krovak +lat_0=49.5 +alpha=30.28813975277778 +k=0.9999 +x_0=0 +y_0=0 +k_0=0.9999 +lon_0=42.5 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=en",
            5223: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5228: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            5229: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
              x: 1,
              y: 1
            },
            5233: { p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=ne", x: 1, y: 1 },
            5234: "+proj=tmerc +lat_0=7.000480277777778 +lon_0=80.77171111111112 +k_0=0.9999238418 +x_0=200000 +y_0=200000 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=-97,787,86 +axis=en",
            5235: "+proj=tmerc +lat_0=7.000471527777778 +lon_0=80.77171308333334 +k_0=0.9999238418 +x_0=500000 +y_0=500000 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=en",
            5237: 1,
            5243: "+proj=lcc +lat_0=50.99999999999995 +lon_0=10.5 +lat_1=48.666666666666664 +lat_2=53.666666666666664 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5244: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5245: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5246: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5247: "+proj=omerc +x_0=0 +y_0=0 +lat_0=4 +lonc=115 +alpha=53.315809949999995 +gamma=53.13010236111111 +k_0=0.99984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5250: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5251: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5252: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5253: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5254: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5255: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5256: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5257: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5258: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5259: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5262: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5263: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5264: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5266: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5269: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5270: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5271: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5272: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5273: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5274: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=14500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5275: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=15500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5292: "+proj=tmerc +lat_0=0 +lon_0=90.73333333333333 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5293: "+proj=tmerc +lat_0=0 +lon_0=89.55 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5294: "+proj=tmerc +lat_0=0 +lon_0=89.85 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5295: "+proj=tmerc +lat_0=0 +lon_0=90.03333333333333 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5296: "+proj=tmerc +lat_0=0 +lon_0=90.15 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5297: "+proj=tmerc +lat_0=0 +lon_0=91.13333333333334 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5298: "+proj=tmerc +lat_0=0 +lon_0=91.23333333333333 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5299: "+proj=tmerc +lat_0=0 +lon_0=89.35 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5300: "+proj=tmerc +lat_0=0 +lon_0=91.35 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5301: "+proj=tmerc +lat_0=0 +lon_0=89.85 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5302: "+proj=tmerc +lat_0=0 +lon_0=91.56666666666666 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5303: "+proj=tmerc +lat_0=0 +lon_0=89.06666666666666 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5304: "+proj=tmerc +lat_0=0 +lon_0=90.26666666666667 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5305: "+proj=tmerc +lat_0=0 +lon_0=89.55 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5306: "+proj=tmerc +lat_0=0 +lon_0=91.75 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5307: "+proj=tmerc +lat_0=0 +lon_0=90.5 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5308: "+proj=tmerc +lat_0=0 +lon_0=90.16666666666667 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5309: "+proj=tmerc +lat_0=0 +lon_0=90.11666666666666 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5310: "+proj=tmerc +lat_0=0 +lon_0=91.56666666666666 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5311: "+proj=tmerc +lat_0=0 +lon_0=90.86666666666666 +k_0=1 +x_0=250000 +y_0=-2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5316: "+proj=tmerc +lat_0=0 +lon_0=-6.999999999999993 +k_0=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5317: 1,
            5318: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-6.999999999999993 +k_0=0.999997 +x_0=200000 +y_0=-6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            5320: "+proj=lcc +lat_0=0 +lon_0=-83.99999999999991 +lat_1=44.5 +lat_2=54.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5321: "+proj=lcc +lat_0=0 +lon_0=-83.99999999999991 +lat_1=44.5 +lat_2=54.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            5322: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5323: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            5324: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5325: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=1700000 +y_0=300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5329: "+proj=merc +lat_0=0 +lon_0=3.1922805555555556 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +axis=en",
            5330: "+proj=merc +lat_0=0 +lon_0=3.1922805555555556 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +towgs84=-377,681,-50 +axis=en",
            5331: "+proj=merc +lat_0=0 +lon_0=3.1922805555555556 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +axis=en",
            5332: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5336: -1,
            5337: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            5340: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            5341: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5342: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5343: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +k_0=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5344: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5345: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +k_0=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5346: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-62.999999999999936 +k_0=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5347: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-59.99999999999994 +k_0=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5348: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-56.99999999999994 +k_0=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5349: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +k_0=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5352: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5353: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5354: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5355: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5356: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5357: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5358: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5359: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5360: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5361: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5362: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5363: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5364: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5365: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            5367: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            5368: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5369: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5370: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5371: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5372: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5373: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            5379: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5380: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5381: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            5382: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5383: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5387: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5388: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5389: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5391: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5392: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5393: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5396: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5451: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            5456: "+proj=lcc +lat_0=10.466666666666667 +lon_0=-84.33333333333333 +k_0=0.99995696 +x_0=500000 +y_0=271820.522 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5457: "+proj=lcc +lat_0=9 +lon_0=-83.66666666666667 +k_0=0.99995696 +x_0=500000 +y_0=327987.436 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5458: "+proj=lcc +lat_0=16.816666666666666 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5459: "+proj=lcc +lat_0=14.9 +lon_0=-90.33333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5460: "+proj=lcc +lat_0=13.783333333333333 +lon_0=-89 +k_0=0.99996704 +x_0=500000 +y_0=295809.184 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5461: "+proj=lcc +lat_0=13.866666666666667 +lon_0=-85.5 +k_0=0.99990314 +x_0=500000 +y_0=359891.816 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5462: "+proj=lcc +lat_0=11.733333333333333 +lon_0=-85.5 +k_0=0.99992228 +x_0=500000 +y_0=288876.327 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5463: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            5464: {
              p: "+proj=longlat +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            5466: "+proj=tmerc +lat_0=17.061241944444443 +lon_0=-88.6318575 +k_0=1 +x_0=66220.02833082761 +y_0=135779.5099885299 +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=en",
            5467: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1 },
            5469: "+proj=lcc +lat_0=8.416666666666666 +lon_0=-80 +k_0=0.99989909 +x_0=500000 +y_0=294865.303 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5472: "+proj=poly +lat_0=8.25 +lon_0=-81 +x_0=914391.7962 +y_0=999404.7217154861 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=3.3047972654",
            5479: "+proj=lcc +lat_0=-78 +lon_0=163 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=7000000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5480: "+proj=lcc +lat_0=-74.5 +lon_0=165 +lat_1=-73.66666666666667 +lat_2=-75.33333333333333 +x_0=5000000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5481: "+proj=lcc +lat_0=-71.5 +lon_0=166 +lat_1=-70.66666666666667 +lat_2=-72.33333333333333 +x_0=3000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5482: "+proj=stere +lat_0=-89.99999999999991 +lon_0=179.99999999999983 +k_0=0.994 +x_0=5000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5487: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5488: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5489: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5490: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5498: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5499: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            5500: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            5513: "+proj=krovak +alpha=30.28813975277778 +x_0=0 +y_0=0 +lat_0=49.5 +k_0=0.9999 +lon_0=24.833333333333332 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=sw",
            5514: "+proj=krovak +lat_0=49.5 +alpha=30.28813975277778 +k=0.9999 +x_0=0 +y_0=0 +k_0=0.9999 +lon_0=24.833333333333332 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5518: "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k_0=1 +x_0=350000 +y_0=650000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=175,-38,113 +axis=ne",
            5519: "+proj=tmerc +lat_0=-44 +lon_0=-176.5 +k_0=1 +x_0=350000 +y_0=650000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            5520: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            5523: "+proj=tmerc +lat_0=0 +lon_0=11.5 +k_0=0.9996 +x_0=1500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5524: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=ne", x: 1, y: 1 },
            5527: { p: "+proj=longlat +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=ne", x: 1, y: 1 },
            5530: "+proj=poly +lat_0=0 +lon_0=-53.99999999999994 +x_0=5000000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5531: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5532: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            5533: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5534: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5535: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5536: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            5537: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            5538: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            5539: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            5544: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5545: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5546: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5550: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5551: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5552: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5554: { p: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5555: { p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5556: {
              p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            5558: "+proj=geocent +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            5559: "+proj=lcc +lat_0=16.816666666666666 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            5560: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5561: { p: "+proj=longlat +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne", x: 1, y: 1 },
            5562: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5563: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5564: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5565: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5566: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5567: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5568: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5569: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5570: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5571: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5572: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5573: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5574: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5575: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5576: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5577: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5578: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5579: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5580: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5581: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5582: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5583: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            5588: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=304800 +y_0=304800 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne +to_meter=0.3048",
            5589: "+proj=tmerc +lat_0=17.061241944444443 +lon_0=-88.6318575 +k_0=1 +x_0=66220.02833082761 +y_0=135779.5099885299 +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=en +to_meter=0.3047972654",
            5591: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5592: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5593: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5596: "+proj=tmerc +lat_0=0 +lon_0=11.333333333333334 +k_0=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5597: 1,
            5598: { p: "+proj=tmerc +lat_0=0 +lon_0=11.333333333333334 +k_0=1 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5600: 1,
            5601: 1,
            5602: 1,
            5603: 1,
            5604: 1,
            5605: 1,
            5606: 1,
            5607: 1,
            5608: 1,
            5609: 1,
            5610: 1,
            5611: 1,
            5612: -1,
            5613: 1,
            5614: -0.3048,
            5615: 1,
            5616: 1,
            5617: 1,
            5618: 1,
            5619: 1,
            5620: 1,
            5621: 1,
            5623: "+proj=tmerc +lat_0=41.5 +lon_0=-83.66666666666667 +k_0=0.999942857 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            5624: "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            5625: "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            5627: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            5628: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5629: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5631: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=2500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5632: "+proj=lcc +lat_0=51.99999999999995 +lon_0=9.99999999999999 +lat_1=34.999999999999964 +lat_2=64.99999999999993 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5633: "+proj=laea +lat_0=51.99999999999995 +lon_0=9.99999999999999 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5634: "+proj=lcc +lat_0=51.99999999999995 +lon_0=9.99999999999999 +lat_1=34.999999999999964 +lat_2=64.99999999999993 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5635: "+proj=laea +lat_0=51.99999999999995 +lon_0=9.99999999999999 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5636: "+proj=laea +lat_0=51.99999999999995 +lon_0=9.99999999999999 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5637: "+proj=lcc +lat_0=51.99999999999995 +lon_0=9.99999999999999 +lat_1=34.999999999999964 +lat_2=64.99999999999993 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5638: "+proj=laea +lat_0=51.99999999999995 +lon_0=9.99999999999999 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5639: "+proj=lcc +lat_0=51.99999999999995 +lon_0=9.99999999999999 +lat_1=34.999999999999964 +lat_2=64.99999999999993 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5641: "+proj=merc +lon_0=-42.99999999999996 +x_0=5000000 +y_0=10000000 +lat_1=-1.999999999999998 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5643: "+proj=lcc +lat_0=47.99999999999995 +lon_0=9.99999999999999 +lat_1=52.666666666666664 +lat_2=54.333333333333336 +x_0=815000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            5644: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5646: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            5649: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5650: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5651: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5652: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5653: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            5654: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            5655: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            5659: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500053 +y_0=-3999820 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            5663: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5664: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=2500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5665: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5666: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5667: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5668: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5669: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5670: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5671: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5672: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5673: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5674: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5675: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=en",
            5676: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5677: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5678: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5679: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5680: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5681: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            5682: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5683: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5684: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5685: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            5698: { p: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5699: { p: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5700: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5701: 1,
            5702: 0.3048006096,
            5703: 1,
            5704: 1,
            5705: 1,
            5706: -1,
            5707: { p: "+proj=lcc +lat_0=49.49999999999995 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            5708: { p: "+proj=lcc +lat_0=42.164999999999964 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            5709: 1,
            5710: 1,
            5711: 1,
            5712: 1,
            5713: 1,
            5714: 1,
            5715: -1,
            5716: 1,
            5717: 1,
            5718: 1,
            5719: 1,
            5720: 1,
            5721: 1,
            5722: 1,
            5723: 1,
            5724: 1,
            5725: 1,
            5726: 1,
            5727: 1,
            5728: 1,
            5729: 1,
            5730: 1,
            5731: 1,
            5732: 1,
            5733: 1,
            5734: -1,
            5735: 1,
            5736: 1,
            5737: 1,
            5738: 1,
            5739: -1,
            5740: 1,
            5741: 1,
            5742: 1,
            5743: 1,
            5744: 1,
            5745: 1,
            5746: 1,
            5747: 1,
            5748: 1,
            5749: 1,
            5750: 1,
            5751: 1,
            5752: 1,
            5753: 1,
            5754: 0.3048007491,
            5755: 1,
            5756: 1,
            5757: 1,
            5758: 1,
            5759: 1,
            5760: 1,
            5761: 1,
            5762: 1,
            5763: 1,
            5764: 1,
            5765: 1,
            5766: 1,
            5767: 1,
            5768: 1,
            5769: 1,
            5770: 1,
            5771: 1,
            5772: 1,
            5773: 1,
            5774: 1,
            5775: 1,
            5776: 1,
            5777: 1,
            5778: 1,
            5779: 1,
            5780: 1,
            5781: 1,
            5782: 1,
            5783: 1,
            5784: 1,
            5785: 1,
            5786: 1,
            5787: 1,
            5788: 1,
            5789: -1,
            5790: 1,
            5791: 1,
            5792: 1,
            5793: 1,
            5794: 1,
            5795: 1,
            5796: 1,
            5797: 1,
            5798: 1,
            5799: 1,
            5825: "+proj=tmerc +lat_0=-35.31773627777778 +lon_0=149.00929483055555 +k_0=1.000086 +x_0=200000 +y_0=600000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            5828: "+proj=geocent +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            5829: 1,
            5830: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5831: -1,
            5832: {
              p: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            5833: { p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5834: { p: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5835: { p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5836: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5837: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5839: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5842: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5843: 1,
            5844: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=0.9999 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5845: { p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5846: { p: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5847: { p: "+proj=tmerc +lat_0=0 +lon_0=13.5 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5848: {
              p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5849: { p: "+proj=tmerc +lat_0=0 +lon_0=16.5 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5850: { p: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5851: { p: "+proj=tmerc +lat_0=0 +lon_0=14.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5852: {
              p: "+proj=tmerc +lat_0=0 +lon_0=15.75 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5853: { p: "+proj=tmerc +lat_0=0 +lon_0=17.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5854: { p: "+proj=tmerc +lat_0=0 +lon_0=18.75 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5855: { p: "+proj=tmerc +lat_0=0 +lon_0=20.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5856: {
              p: "+proj=tmerc +lat_0=0 +lon_0=21.75 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5857: { p: "+proj=tmerc +lat_0=0 +lon_0=23.25 +k_0=1 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5858: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5861: -1,
            5862: -1,
            5863: -1,
            5864: -1,
            5865: -1,
            5866: -1,
            5867: -1,
            5868: 1,
            5869: 1,
            5870: 1,
            5871: 1,
            5872: 1,
            5873: -1,
            5874: 1,
            5875: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5876: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5877: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +axis=en",
            5879: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            5880: "+proj=poly +lat_0=0 +lon_0=-53.99999999999994 +x_0=5000000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5884: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            5885: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            5886: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            5887: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            5890: "+proj=stere +x_0=0 +y_0=0 +lat_ts=69.99999999999993 +lon_0=89.99999999999991 +a=6378273 +b=6356889.449 +pm=0",
            5896: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5897: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5898: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5899: "+proj=tmerc +lat_0=0 +lon_0=107.75 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5921: "+proj=lcc +lat_0=81.31722599999999 +lon_0=-110.99999999999989 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5922: "+proj=lcc +lat_0=81.31722599999999 +lon_0=-38.999999999999964 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5923: "+proj=lcc +lat_0=81.31722599999999 +lon_0=32.999999999999964 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5924: "+proj=lcc +lat_0=81.31722599999999 +lon_0=104.9999999999999 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5925: "+proj=lcc +lat_0=81.31722599999999 +lon_0=176.99999999999983 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5926: "+proj=lcc +lat_0=73.15574086111111 +lon_0=-110.99999999999989 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5927: "+proj=lcc +lat_0=73.15574086111111 +lon_0=-38.999999999999964 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5928: "+proj=lcc +lat_0=73.15574086111111 +lon_0=32.999999999999964 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5929: "+proj=lcc +lat_0=73.15574086111111 +lon_0=104.9999999999999 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5930: "+proj=lcc +lat_0=73.15574086111111 +lon_0=176.99999999999983 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5931: "+proj=lcc +lat_0=65.10127088888888 +lon_0=-110.99999999999989 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5932: "+proj=lcc +lat_0=65.10127088888888 +lon_0=-38.999999999999964 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5933: "+proj=lcc +lat_0=65.10127088888888 +lon_0=32.999999999999964 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5934: "+proj=lcc +lat_0=65.10127088888888 +lon_0=104.9999999999999 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5935: "+proj=lcc +lat_0=65.10127088888888 +lon_0=176.99999999999983 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            5936: "+proj=stere +lat_0=89.99999999999991 +lon_0=-149.99999999999986 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5937: "+proj=stere +lat_0=89.99999999999991 +lon_0=-99.9999999999999 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5938: "+proj=stere +lat_0=89.99999999999991 +lon_0=-32.999999999999964 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5939: "+proj=stere +lat_0=89.99999999999991 +lon_0=17.999999999999982 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5940: "+proj=stere +lat_0=89.99999999999991 +lon_0=104.9999999999999 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            5941: 1,
            5942: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5945: { p: "+proj=tmerc +lat_0=58 +lon_0=5.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5946: {
              p: "+proj=tmerc +lat_0=58 +lon_0=6.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5947: { p: "+proj=tmerc +lat_0=58 +lon_0=7.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5948: { p: "+proj=tmerc +lat_0=58 +lon_0=8.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5949: { p: "+proj=tmerc +lat_0=58 +lon_0=9.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5950: {
              p: "+proj=tmerc +lat_0=58 +lon_0=10.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5951: { p: "+proj=tmerc +lat_0=58 +lon_0=11.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5952: { p: "+proj=tmerc +lat_0=58 +lon_0=12.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5953: { p: "+proj=tmerc +lat_0=58 +lon_0=13.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5954: {
              p: "+proj=tmerc +lat_0=58 +lon_0=14.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5955: { p: "+proj=tmerc +lat_0=58 +lon_0=15.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5956: { p: "+proj=tmerc +lat_0=58 +lon_0=16.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5957: { p: "+proj=tmerc +lat_0=58 +lon_0=17.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5958: {
              p: "+proj=tmerc +lat_0=58 +lon_0=18.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5959: { p: "+proj=tmerc +lat_0=58 +lon_0=19.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5960: { p: "+proj=tmerc +lat_0=58 +lon_0=20.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5961: { p: "+proj=tmerc +lat_0=58 +lon_0=21.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5962: {
              p: "+proj=tmerc +lat_0=58 +lon_0=22.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5963: { p: "+proj=tmerc +lat_0=58 +lon_0=23.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5964: { p: "+proj=tmerc +lat_0=58 +lon_0=24.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5965: { p: "+proj=tmerc +lat_0=58 +lon_0=25.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5966: {
              p: "+proj=tmerc +lat_0=58 +lon_0=26.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5967: { p: "+proj=tmerc +lat_0=58 +lon_0=27.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5968: { p: "+proj=tmerc +lat_0=58 +lon_0=28.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5969: { p: "+proj=tmerc +lat_0=58 +lon_0=29.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            5970: {
              p: "+proj=tmerc +lat_0=58 +lon_0=30.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            5971: { p: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5972: { p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5973: { p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5974: {
              p: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            5975: { p: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            5976: { p: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6050: "+proj=lcc +lat_0=85.43711833333333 +lon_0=-30 +lat_1=87 +lat_2=83.66666666666667 +x_0=25500000 +y_0=1500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6051: "+proj=lcc +lat_0=82.05842488888888 +lon_0=-52 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=18500000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6052: "+proj=lcc +lat_0=82.05842488888888 +lon_0=-12 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=20500000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6053: "+proj=lcc +lat_0=78.70733752777778 +lon_0=-69 +lat_1=80.33333333333333 +lat_2=77 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6054: "+proj=lcc +lat_0=78.70733752777778 +lon_0=-39 +lat_1=80.33333333333333 +lat_2=77 +x_0=31500000 +y_0=3500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6055: "+proj=lcc +lat_0=78.70733752777778 +lon_0=-10 +lat_1=80.33333333333333 +lat_2=77 +x_0=33500000 +y_0=3500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6056: "+proj=lcc +lat_0=75.36440330555556 +lon_0=-64 +lat_1=77 +lat_2=73.66666666666667 +x_0=20500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6057: "+proj=lcc +lat_0=75.36440330555556 +lon_0=-39 +lat_1=77 +lat_2=73.66666666666667 +x_0=22500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6058: "+proj=lcc +lat_0=75.36440330555556 +lon_0=-14 +lat_1=77 +lat_2=73.66666666666667 +x_0=24500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6059: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-62 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=41500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6060: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-42 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=43500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6061: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-22 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=45500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6062: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-56 +lat_1=70.33333333333333 +lat_2=67 +x_0=26500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6063: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-38 +lat_1=70.33333333333333 +lat_2=67 +x_0=28500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6064: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-20 +lat_1=70.33333333333333 +lat_2=67 +x_0=30500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6065: "+proj=lcc +lat_0=65.35103930555555 +lon_0=-51 +lat_1=67 +lat_2=63.666666666666664 +x_0=11500000 +y_0=7500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6066: "+proj=lcc +lat_0=65.35103930555555 +lon_0=-34 +lat_1=67 +lat_2=63.666666666666664 +x_0=13500000 +y_0=7500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6067: "+proj=lcc +lat_0=62.01530688888889 +lon_0=-52 +lat_1=63.666666666666664 +lat_2=60.333333333333336 +x_0=20500000 +y_0=8500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6068: "+proj=lcc +lat_0=62.01530688888889 +lon_0=-37 +lat_1=63.666666666666664 +lat_2=60.333333333333336 +x_0=22500000 +y_0=8500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6069: "+proj=lcc +lat_0=82.05842488888888 +lon_0=16 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=22500000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6070: "+proj=lcc +lat_0=78.70733752777778 +lon_0=21 +lat_1=80.33333333333333 +lat_2=77 +x_0=11500000 +y_0=3500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6071: "+proj=lcc +lat_0=75.36440330555556 +lon_0=10 +lat_1=77 +lat_2=73.66666666666667 +x_0=26500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6072: "+proj=lcc +lat_0=75.36440330555556 +lon_0=34 +lat_1=77 +lat_2=73.66666666666667 +x_0=28500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6073: "+proj=lcc +lat_0=72.02500919444445 +lon_0=14 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=11500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6074: "+proj=lcc +lat_0=72.02500919444445 +lon_0=34 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=13500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6075: "+proj=lcc +lat_0=82.05842488888888 +lon_0=53 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=24500000 +y_0=2500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6076: "+proj=lcc +lat_0=82.05842488888888 +lon_0=93 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=26500000 +y_0=2500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6077: "+proj=lcc +lat_0=78.70733752777778 +lon_0=52 +lat_1=80.33333333333333 +lat_2=77 +x_0=13500000 +y_0=3500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6078: "+proj=lcc +lat_0=78.70733752777778 +lon_0=83 +lat_1=80.33333333333333 +lat_2=77 +x_0=15500000 +y_0=3500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6079: "+proj=lcc +lat_0=78.70733752777778 +lon_0=114 +lat_1=80.33333333333333 +lat_2=77 +x_0=17500000 +y_0=3500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6080: "+proj=lcc +lat_0=78.70733752777778 +lon_0=145 +lat_1=80.33333333333333 +lat_2=77 +x_0=19500000 +y_0=3500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6081: "+proj=lcc +lat_0=75.36440330555556 +lon_0=58 +lat_1=77 +lat_2=73.66666666666667 +x_0=30500000 +y_0=4500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6082: "+proj=lcc +lat_0=75.36440330555556 +lon_0=82 +lat_1=77 +lat_2=73.66666666666667 +x_0=32500000 +y_0=4500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6083: "+proj=lcc +lat_0=75.36440330555556 +lon_0=106 +lat_1=77 +lat_2=73.66666666666667 +x_0=34500000 +y_0=4500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6084: "+proj=lcc +lat_0=75.36440330555556 +lon_0=130 +lat_1=77 +lat_2=73.66666666666667 +x_0=36500000 +y_0=4500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6085: "+proj=lcc +lat_0=75.36440330555556 +lon_0=154 +lat_1=77 +lat_2=73.66666666666667 +x_0=38500000 +y_0=4500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6086: "+proj=lcc +lat_0=75.36440330555556 +lon_0=179 +lat_1=77 +lat_2=73.66666666666667 +x_0=40500000 +y_0=4500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6087: "+proj=lcc +lat_0=72.02500919444445 +lon_0=54 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=15500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6088: "+proj=lcc +lat_0=72.02500919444445 +lon_0=74 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=17500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6089: "+proj=lcc +lat_0=72.02500919444445 +lon_0=95 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=19500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6090: "+proj=lcc +lat_0=72.02500919444445 +lon_0=116 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=21500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6091: "+proj=lcc +lat_0=72.02500919444445 +lon_0=137 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=23500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6092: "+proj=lcc +lat_0=72.02500919444445 +lon_0=158 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=25500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6093: "+proj=lcc +lat_0=72.02500919444445 +lon_0=179 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=27500000 +y_0=5500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6094: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-163 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6095: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-147 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6096: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-165 +lat_1=70.33333333333333 +lat_2=67 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6097: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-147 +lat_1=70.33333333333333 +lat_2=67 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6098: "+proj=lcc +lat_0=85.43711833333333 +lon_0=-90 +lat_1=87 +lat_2=83.66666666666667 +x_0=23500000 +y_0=1500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6099: "+proj=lcc +lat_0=82.05842488888888 +lon_0=-115 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=14500000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6100: "+proj=lcc +lat_0=82.05842488888888 +lon_0=-75 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=16500000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6101: "+proj=lcc +lat_0=78.70733752777778 +lon_0=-129 +lat_1=80.33333333333333 +lat_2=77 +x_0=25500000 +y_0=3500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6102: "+proj=lcc +lat_0=78.70733752777778 +lon_0=-99 +lat_1=80.33333333333333 +lat_2=77 +x_0=27500000 +y_0=3500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6103: "+proj=lcc +lat_0=78.70733752777778 +lon_0=-69 +lat_1=80.33333333333333 +lat_2=77 +x_0=29500000 +y_0=3500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6104: "+proj=lcc +lat_0=75.36440330555556 +lon_0=-129 +lat_1=77 +lat_2=73.66666666666667 +x_0=14500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6105: "+proj=lcc +lat_0=75.36440330555556 +lon_0=-104 +lat_1=77 +lat_2=73.66666666666667 +x_0=16500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6106: "+proj=lcc +lat_0=75.36440330555556 +lon_0=-79 +lat_1=77 +lat_2=73.66666666666667 +x_0=18500000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6107: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-131 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=33500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6108: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-111 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=35500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6109: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-91 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=37500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6110: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-71 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=39500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6111: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-132 +lat_1=70.33333333333333 +lat_2=67 +x_0=18500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6112: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-113 +lat_1=70.33333333333333 +lat_2=67 +x_0=20500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6113: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-94 +lat_1=70.33333333333333 +lat_2=67 +x_0=22500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6114: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-75 +lat_1=70.33333333333333 +lat_2=67 +x_0=24500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6115: "+proj=lcc +lat_0=85.43711833333333 +lon_0=30 +lat_1=87 +lat_2=83.66666666666667 +x_0=27500000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6116: "+proj=lcc +lat_0=85.43711833333333 +lon_0=90 +lat_1=87 +lat_2=83.66666666666667 +x_0=29500000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6117: "+proj=lcc +lat_0=85.43711833333333 +lon_0=150 +lat_1=87 +lat_2=83.66666666666667 +x_0=31500000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6118: "+proj=lcc +lat_0=85.43711833333333 +lon_0=-150 +lat_1=87 +lat_2=83.66666666666667 +x_0=21500000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6119: "+proj=lcc +lat_0=82.05842488888888 +lon_0=133 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=28500000 +y_0=2500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6120: "+proj=lcc +lat_0=82.05842488888888 +lon_0=166 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=10500000 +y_0=2500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6121: "+proj=lcc +lat_0=82.05842488888888 +lon_0=-154 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=12500000 +y_0=2500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6122: "+proj=lcc +lat_0=78.70733752777778 +lon_0=176 +lat_1=80.33333333333333 +lat_2=77 +x_0=21500000 +y_0=3500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6123: "+proj=lcc +lat_0=78.70733752777778 +lon_0=-153 +lat_1=80.33333333333333 +lat_2=77 +x_0=23500000 +y_0=3500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6124: "+proj=lcc +lat_0=75.36440330555556 +lon_0=-155 +lat_1=77 +lat_2=73.66666666666667 +x_0=12500000 +y_0=4500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6125: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-5 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=47500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6128: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=499999.99999800004 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048",
            6129: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=499999.99999800004 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048",
            6130: 0.3048,
            6131: 0.3048,
            6132: 0.3048,
            6133: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6134: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            6135: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            6141: "+proj=lcc +lat_0=19.333333333333332 +lon_0=80.56666666666666 +lat_1=19.333333333333332 +lat_2=19.7 +x_0=899160 +y_0=579120 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            6144: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6145: {
              p: "+proj=tmerc +lat_0=58 +lon_0=5.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            6146: { p: "+proj=tmerc +lat_0=58 +lon_0=6.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6147: { p: "+proj=tmerc +lat_0=58 +lon_0=7.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6148: { p: "+proj=tmerc +lat_0=58 +lon_0=8.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6149: {
              p: "+proj=tmerc +lat_0=58 +lon_0=9.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            6150: { p: "+proj=tmerc +lat_0=58 +lon_0=10.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6151: { p: "+proj=tmerc +lat_0=58 +lon_0=11.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6152: { p: "+proj=tmerc +lat_0=58 +lon_0=12.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6153: {
              p: "+proj=tmerc +lat_0=58 +lon_0=13.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            6154: { p: "+proj=tmerc +lat_0=58 +lon_0=14.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6155: { p: "+proj=tmerc +lat_0=58 +lon_0=15.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6156: { p: "+proj=tmerc +lat_0=58 +lon_0=16.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6157: {
              p: "+proj=tmerc +lat_0=58 +lon_0=17.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            6158: { p: "+proj=tmerc +lat_0=58 +lon_0=18.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6159: { p: "+proj=tmerc +lat_0=58 +lon_0=19.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6160: { p: "+proj=tmerc +lat_0=58 +lon_0=20.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6161: {
              p: "+proj=tmerc +lat_0=58 +lon_0=21.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            6162: { p: "+proj=tmerc +lat_0=58 +lon_0=22.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6163: { p: "+proj=tmerc +lat_0=58 +lon_0=23.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6164: { p: "+proj=tmerc +lat_0=58 +lon_0=24.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6165: {
              p: "+proj=tmerc +lat_0=58 +lon_0=25.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            6166: { p: "+proj=tmerc +lat_0=58 +lon_0=26.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6167: { p: "+proj=tmerc +lat_0=58 +lon_0=27.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6168: { p: "+proj=tmerc +lat_0=58 +lon_0=28.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6169: {
              p: "+proj=tmerc +lat_0=58 +lon_0=29.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            6170: { p: "+proj=tmerc +lat_0=58 +lon_0=30.5 +k_0=1 +x_0=100000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6171: { p: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6172: { p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6173: {
              p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            6174: { p: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6175: { p: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6176: { p: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6178: 1,
            6179: 1,
            6180: 1,
            6181: 1,
            6182: 1,
            6183: 1,
            6184: 1,
            6185: 1,
            6186: 1,
            6187: 1,
            6190: { p: "+proj=lcc +lat_0=90 +lon_0=4.367486666666666 +lat_1=51.16666723333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6200: "+proj=lcc +k_0=1.0000382 +lat_0=45.45 +lon_0=-87 +lat_1=45.483333333333334 +lat_2=47.083333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            6201: "+proj=lcc +k_0=1.0000382 +lat_0=43.31666666666667 +lon_0=-84.33333333333333 +lat_1=44.18333333333333 +lat_2=45.7 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            6202: "+proj=lcc +k_0=1.0000382 +lat_0=41.5 +lon_0=-84.33333333333333 +lat_1=42.1 +lat_2=43.666666666666664 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            6204: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            6207: { p: "+proj=longlat +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=ne", x: 1, y: 1 },
            6210: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6211: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6244: "+proj=col_urban +h_0=100 +lat_0=7.087606391666666 +lon_0=-70.75830965555555 +x_0=1035263.443 +y_0=1275526.621 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6245: "+proj=col_urban +h_0=1470 +lat_0=4.532325 +lon_0=-75.67348916666667 +x_0=1155824.666 +y_0=993087.465 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6246: "+proj=col_urban +h_0=100 +lat_0=10.923183083333333 +lon_0=-74.83433133333332 +x_0=917264.406 +y_0=1699839.935 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6247: "+proj=col_urban +h_0=2550 +lat_0=4.680486111111112 +lon_0=-74.14659166666668 +x_0=92334.879 +y_0=109320.965 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6248: "+proj=col_urban +h_0=931 +lat_0=7.078887141666667 +lon_0=-73.19734322222223 +x_0=1097241.305 +y_0=1274642.278 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6249: "+proj=col_urban +h_0=1000 +lat_0=3.4418833333333336 +lon_0=-76.5205625 +x_0=1061900.18 +y_0=872364.63 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6250: "+proj=col_urban +h_0=0 +lat_0=10.3970475 +lon_0=-75.51120694444444 +x_0=842981.41 +y_0=1641887.09 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6251: "+proj=col_urban +h_0=308 +lat_0=7.888936736111111 +lon_0=-72.50287095 +x_0=842805.406 +y_0=1364404.57 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6252: "+proj=col_urban +h_0=300 +lat_0=1.6210122944444445 +lon_0=-75.61911760277778 +x_0=1162300.348 +y_0=671068.716 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6253: "+proj=col_urban +h_0=1100 +lat_0=4.419412827777778 +lon_0=-75.17992593333334 +x_0=877634.33 +y_0=980541.348 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6254: "+proj=col_urban +h_0=96 +lat_0=3.8454381833333335 +lon_0=-67.9052320888889 +x_0=1019177.687 +y_0=491791.326 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6255: "+proj=col_urban +h_0=89.7 +lat_0=-4.197684047222222 +lon_0=-69.94281105833333 +x_0=25978.217 +y_0=27501.365 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6256: "+proj=col_urban +h_0=2100 +lat_0=5.068153888888888 +lon_0=-75.51109472222223 +x_0=1173727.04 +y_0=1052391.13 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6257: "+proj=col_urban +h_0=1510 +lat_0=6.229208888888889 +lon_0=-75.56488694444444 +x_0=835378.647 +y_0=1180816.875 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6258: "+proj=col_urban +h_0=170 +lat_0=1.2499693666666667 +lon_0=-70.23546165555555 +x_0=1093717.398 +y_0=629997.236 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6259: "+proj=col_urban +h_0=655.2 +lat_0=1.1400233583333332 +lon_0=-76.65102121944444 +x_0=1047467.388 +y_0=617828.474 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6260: "+proj=col_urban +h_0=15 +lat_0=8.773085755555556 +lon_0=-75.87955333055555 +x_0=1131814.934 +y_0=1462131.119 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6261: "+proj=col_urban +h_0=430 +lat_0=2.9424150555555557 +lon_0=-75.29643672222223 +x_0=864476.923 +y_0=817199.827 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6262: "+proj=col_urban +h_0=2530 +lat_0=1.2009895138888889 +lon_0=-77.25312563333334 +x_0=980469.695 +y_0=624555.332 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6263: "+proj=col_urban +h_0=1500 +lat_0=4.813593611111111 +lon_0=-75.69395138888889 +x_0=1153492.012 +y_0=1024195.255 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6264: "+proj=col_urban +h_0=1740 +lat_0=2.4561598833333336 +lon_0=-76.6060916361111 +x_0=1052430.525 +y_0=763366.548 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6265: "+proj=col_urban +h_0=51.58 +lat_0=6.1807214138888895 +lon_0=-67.50075024722223 +x_0=1063834.703 +y_0=1175257.481 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6266: "+proj=col_urban +h_0=44 +lat_0=5.6942476611111115 +lon_0=-76.65075385833335 +x_0=1047273.617 +y_0=1121443.09 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6267: "+proj=col_urban +h_0=6 +lat_0=11.536913327777778 +lon_0=-72.90276886944444 +x_0=1128154.73 +y_0=1767887.914 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6268: "+proj=col_urban +h_0=6 +lat_0=12.523794325 +lon_0=-81.72937595 +x_0=820439.298 +y_0=1877357.828 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6269: "+proj=col_urban +h_0=185 +lat_0=2.5640789416666663 +lon_0=-72.640033325 +x_0=1159876.62 +y_0=775380.342 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6270: "+proj=col_urban +h_0=29 +lat_0=11.219643055555556 +lon_0=-74.22500527777778 +x_0=983892.409 +y_0=1732533.518 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6271: "+proj=col_urban +h_0=20 +lat_0=8.810550366666668 +lon_0=-74.722466825 +x_0=929043.607 +y_0=1466125.658 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6272: "+proj=col_urban +h_0=2800 +lat_0=5.534194738888889 +lon_0=-73.3519389 +x_0=1080514.91 +y_0=1103772.028 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6273: "+proj=col_urban +h_0=200 +lat_0=10.44726111111111 +lon_0=-73.2465713888889 +x_0=1090979.66 +y_0=1647208.93 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6274: "+proj=col_urban +h_0=427.19 +lat_0=4.1553751000000005 +lon_0=-73.62448598611111 +x_0=1050678.757 +y_0=950952.124 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6275: "+proj=col_urban +h_0=300 +lat_0=5.353927222222222 +lon_0=-72.42004027777779 +x_0=851184.177 +y_0=1083954.137 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6307: "+proj=lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=200000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6309: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6310: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            6311: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            6312: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.99995 +x_0=200000 +y_0=-3500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6316: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            6317: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6318: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            6319: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu", x: 1, y: 1, z: 1 },
            6320: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6321: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            6322: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            6323: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6324: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu", x: 1, y: 1, z: 1 },
            6325: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            6328: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6329: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6330: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6331: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6332: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6333: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6334: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6335: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6336: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6337: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6338: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6339: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6340: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6341: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6342: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6343: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6344: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6345: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6346: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6347: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6348: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6349: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            6350: "+proj=aea +lat_0=22.99999999999998 +lon_0=-95.9999999999999 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6351: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-163 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=29500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6352: "+proj=lcc +lat_0=72.02500919444445 +lon_0=-147 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=31500000 +y_0=5500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6353: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-165 +lat_1=70.33333333333333 +lat_2=67 +x_0=14500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6354: "+proj=lcc +lat_0=68.68747555555557 +lon_0=-147 +lat_1=70.33333333333333 +lat_2=67 +x_0=16500000 +y_0=6500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6355: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6356: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6357: -1,
            6358: -0.3048006096,
            6359: -0.3048006096,
            6360: 0.3048006096,
            6362: "+proj=lcc +lat_0=11.999999999999988 +lon_0=-101.9999999999999 +lat_1=17.499999999999982 +lat_2=29.49999999999997 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6363: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6364: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            6365: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            6366: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6367: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6368: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6369: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6370: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6371: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6372: "+proj=lcc +lat_0=11.999999999999988 +lon_0=-101.9999999999999 +lat_1=17.499999999999982 +lat_2=29.49999999999997 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6381: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            6382: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            6383: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            6384: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            6385: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            6386: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            6387: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            6391: "+proj=lcc +lat_0=19.333333333333332 +lon_0=-80.56666666666666 +lat_1=19.333333333333332 +lat_2=19.7 +x_0=899160 +y_0=579120 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
            6393: "+proj=aea +lat_0=49.99999999999995 +lon_0=-153.99999999999986 +lat_1=54.99999999999994 +lat_2=64.99999999999993 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6394: "+proj=omerc +x_0=5000000 +y_0=-5000000 +lat_0=57 +lonc=-133.66666666666666 +alpha=323.13010236111114 +gamma=323.13010236111114 +k_0=0.9999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6395: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-141.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6396: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-145.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6397: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-149.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6398: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-153.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6399: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-157.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6400: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-161.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6401: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-165.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6402: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-169.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6403: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.833333333333336 +lat_2=51.833333333333336 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6404: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6405: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6406: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6407: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6408: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6409: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6410: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6411: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6412: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6413: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6414: "+proj=aea +lat_0=0 +lon_0=-119.99999999999989 +lat_1=33.999999999999964 +lat_2=40.49999999999996 +x_0=0 +y_0=-4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6415: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6416: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6417: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6418: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6419: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6420: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6421: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6422: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6423: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6424: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6425: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6426: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6427: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6428: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6429: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6430: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6431: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6432: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6433: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6434: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.60960121924 +y_0=152400.30480060962 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6435: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6436: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6437: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6438: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6439: "+proj=aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6440: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6441: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6442: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6443: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6444: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6445: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6446: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6447: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6448: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6449: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6450: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6451: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6452: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6453: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6454: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6455: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6456: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6457: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=699999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6458: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6459: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6460: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6461: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6462: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6463: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000.0000000002 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6464: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6465: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6466: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6467: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6468: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6469: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6470: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6471: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6472: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6473: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000.0000000002 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6474: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6475: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000.00010160025 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6476: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6477: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6478: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6479: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6480: "+proj=tmerc +lat_0=43.5 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6481: "+proj=tmerc +lat_0=43.833333333333336 +lon_0=-67.875 +k_0=0.99998 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6482: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.375 +k_0=0.99998 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6483: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6484: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6485: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6486: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6487: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6488: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.99989839987 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6489: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6490: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6491: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6492: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000.00010160022 +y_0=750000.0000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6493: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6494: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6495: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=8000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6496: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6497: "+proj=omerc +x_0=2546731.496 +y_0=-4354009.816 +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25555999999966 +gamma=337.25555999999966 +k_0=0.9996 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6498: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6499: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=3999999.9999840003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6500: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6501: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6502: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6503: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6504: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6505: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6506: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6507: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6508: "+proj=tmerc +lat_0=32.5 +lon_0=-89.75 +k_0=0.9998335 +x_0=500000 +y_0=1300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6509: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6510: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6511: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6512: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6513: "+proj=tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6514: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6515: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6516: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6517: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6518: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6519: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000.0000101601 +y_0=6000000.000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6520: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6521: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000.00001016003 +y_0=8000000.000010162 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6522: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6523: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000.0000101601 +y_0=3999999.9999898407 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6524: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6525: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6526: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6527: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6528: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6529: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6530: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6531: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6532: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6533: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6534: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6535: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=249999.99989839984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6536: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6537: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6538: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6539: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6540: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6541: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000.0001016002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6542: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.22 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6543: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6544: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6545: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6546: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6547: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6548: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6549: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6550: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6551: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6552: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6553: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6554: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6555: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6556: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6557: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.99999840005 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6558: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6559: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6560: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6561: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000.0001464002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6562: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6563: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6564: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6565: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6566: "+proj=lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=200000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6567: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6568: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6569: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6570: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6571: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6572: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6573: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6574: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6575: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6576: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6577: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6578: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=699999.9998983999 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6579: "+proj=aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6580: "+proj=lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6581: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6582: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000.00010160022 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6583: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6584: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000.0000000001 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6585: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6586: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000.00000000006 +y_0=5000000.000101601 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6587: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6588: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000.0000000001 +y_0=3999999.9998984006 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6589: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6590: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6591: "+proj=lcc +lat_0=35.999999999999964 +lon_0=-79.49999999999991 +lat_1=36.999999999999964 +lat_2=39.49999999999996 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6592: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6593: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000.0001016003 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6594: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6595: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000.0001016003 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6596: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6597: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6598: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6599: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6600: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6601: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6602: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6603: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6604: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6605: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6606: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6607: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6608: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6609: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6610: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9996 +x_0=520000 +y_0=-4480000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6611: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6612: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000.00001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6613: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6614: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6615: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6616: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6617: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6618: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6619: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6620: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6621: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6622: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6623: "+proj=aea +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6624: "+proj=aea +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6625: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.0000101601 +y_0=2000000.0000101603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6626: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.0000101601 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6627: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.0000101601 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6628: "+proj=tmerc +lat_0=18.833333333333332 +lon_0=-155.5 +k_0=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6629: "+proj=tmerc +lat_0=20.333333333333332 +lon_0=-156.66666666666666 +k_0=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6630: "+proj=tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6631: "+proj=tmerc +lat_0=21.833333333333332 +lon_0=-159.5 +k_0=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6632: "+proj=tmerc +lat_0=21.666666666666668 +lon_0=-160.16666666666666 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6633: "+proj=tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6634: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6635: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6636: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6637: "+proj=tmerc +lat_0=13.5 +lon_0=144.75 +k_0=1 +x_0=100000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6638: 1,
            6639: 1,
            6640: 1,
            6641: 1,
            6642: 1,
            6643: 1,
            6644: 1,
            6646: "+proj=tmerc +lat_0=29.02626833333333 +lon_0=46.5 +k_0=0.9994 +x_0=800000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            6647: 1,
            6649: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            6650: { p: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6651: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            6652: { p: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6653: { p: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6654: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            6655: { p: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6656: { p: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6657: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            6658: { p: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6659: { p: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6660: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            6661: { p: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6662: { p: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6663: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            6664: { p: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6665: { p: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            6666: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6667: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            6668: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            6669: "+proj=tmerc +lat_0=33 +lon_0=129.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6670: "+proj=tmerc +lat_0=33 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6671: "+proj=tmerc +lat_0=36 +lon_0=132.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6672: "+proj=tmerc +lat_0=33 +lon_0=133.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6673: "+proj=tmerc +lat_0=36 +lon_0=134.33333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6674: "+proj=tmerc +lat_0=36 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6675: "+proj=tmerc +lat_0=36 +lon_0=137.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6676: "+proj=tmerc +lat_0=36 +lon_0=138.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6677: "+proj=tmerc +lat_0=36 +lon_0=139.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6678: "+proj=tmerc +lat_0=40 +lon_0=140.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6679: "+proj=tmerc +lat_0=44 +lon_0=140.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6680: "+proj=tmerc +lat_0=44 +lon_0=142.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6681: "+proj=tmerc +lat_0=44 +lon_0=144.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6682: "+proj=tmerc +lat_0=26 +lon_0=142 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6683: "+proj=tmerc +lat_0=26 +lon_0=127.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6684: "+proj=tmerc +lat_0=26 +lon_0=124 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6685: "+proj=tmerc +lat_0=26 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6686: "+proj=tmerc +lat_0=20 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6687: "+proj=tmerc +lat_0=26 +lon_0=154 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6688: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6689: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6690: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6691: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6692: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6693: 1,
            6694: 1,
            6695: 1,
            6696: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6697: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6700: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne", x: 1, y: 1, z: 1 },
            6703: "+proj=tmerc +lat_0=0 +lon_0=-59.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6704: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6705: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            6706: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            6707: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6708: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6709: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6720: "+proj=tmerc +lat_0=0 +lon_0=105.625 +k_0=1.000024 +x_0=50000 +y_0=1300000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6721: "+proj=tmerc +lat_0=0 +lon_0=105.625 +k_0=1.00002514 +x_0=50000 +y_0=1300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6722: "+proj=tmerc +lat_0=0 +lon_0=96.875 +k_0=1 +x_0=50000 +y_0=1400000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6723: "+proj=tmerc +lat_0=0 +lon_0=96.875 +k_0=0.99999387 +x_0=50000 +y_0=1500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6732: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6733: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6734: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6735: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6736: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6737: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6738: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6781: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6782: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu", x: 1, y: 1, z: 1 },
            6783: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            6784: "+proj=tmerc +lat_0=44.5 +lon_0=-117.83333333333333 +k_0=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6785: "+proj=tmerc +lat_0=44.5 +lon_0=-117.83333333333333 +k_0=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6786: "+proj=tmerc +lat_0=44.5 +lon_0=-117.83333333333333 +k_0=1.00016 +x_0=40000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6787: "+proj=tmerc +lat_0=44.5 +lon_0=-117.83333333333333 +k_0=1.00016 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6788: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k_0=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6789: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k_0=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6790: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k_0=1.0002 +x_0=80000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6791: "+proj=tmerc +lat_0=41.75 +lon_0=-121.75 +k_0=1.0002 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6792: "+proj=lcc +lat_0=44.666666666666664 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6793: "+proj=lcc +lat_0=44.666666666666664 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6794: "+proj=lcc +lat_0=44.666666666666664 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6795: "+proj=lcc +lat_0=44.666666666666664 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6796: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6797: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999951999 +y_0=59999.999999759995 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6798: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6799: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999951999 +y_0=59999.999999759995 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6800: "+proj=tmerc +lat_0=42.5 +lon_0=-123.33333333333333 +k_0=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6801: "+proj=tmerc +lat_0=42.5 +lon_0=-123.33333333333333 +k_0=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6802: "+proj=tmerc +lat_0=42.5 +lon_0=-123.33333333333333 +k_0=1.00007 +x_0=40000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6803: "+proj=tmerc +lat_0=42.5 +lon_0=-123.33333333333333 +k_0=1.00007 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6804: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6805: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6806: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6807: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6808: "+proj=omerc +x_0=7000000 +y_0=-3000000 +lat_0=45.916666666666664 +lonc=-123 +alpha=294.9999999999997 +gamma=294.9999999999997 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6809: "+proj=omerc +x_0=7000000.00000248 +y_0=-2999999.9999880004 +lat_0=45.916666666666664 +lonc=-123 +alpha=294.9999999999997 +gamma=294.9999999999997 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6810: "+proj=omerc +x_0=7000000 +y_0=-3000000 +lat_0=45.916666666666664 +lonc=-123 +alpha=294.9999999999997 +gamma=294.9999999999997 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6811: "+proj=omerc +x_0=7000000.00000248 +y_0=-2999999.9999880004 +lat_0=45.916666666666664 +lonc=-123 +alpha=294.9999999999997 +gamma=294.9999999999997 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6812: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-123.33333333333333 +k_0=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6813: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-123.33333333333333 +k_0=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6814: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-123.33333333333333 +k_0=1.000023 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6815: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-123.33333333333333 +k_0=1.000023 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6816: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k_0=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6817: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k_0=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6818: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k_0=1.00011 +x_0=80000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6819: "+proj=tmerc +lat_0=44.5 +lon_0=-121 +k_0=1.00011 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6820: "+proj=tmerc +lat_0=43.75 +lon_0=-123.16666666666667 +k_0=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6821: "+proj=tmerc +lat_0=43.75 +lon_0=-123.16666666666667 +k_0=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6822: "+proj=tmerc +lat_0=43.75 +lon_0=-123.16666666666667 +k_0=1.000015 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6823: "+proj=tmerc +lat_0=43.75 +lon_0=-123.16666666666667 +k_0=1.000015 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6824: "+proj=tmerc +lat_0=41.75 +lon_0=-123.33333333333333 +k_0=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6825: "+proj=tmerc +lat_0=41.75 +lon_0=-123.33333333333333 +k_0=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6826: "+proj=tmerc +lat_0=41.75 +lon_0=-123.33333333333333 +k_0=1.000043 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6827: "+proj=tmerc +lat_0=41.75 +lon_0=-123.33333333333333 +k_0=1.000043 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6828: "+proj=tmerc +lat_0=45 +lon_0=-122.33333333333333 +k_0=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6829: "+proj=tmerc +lat_0=45 +lon_0=-122.33333333333333 +k_0=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6830: "+proj=tmerc +lat_0=45 +lon_0=-122.33333333333333 +k_0=1.00005 +x_0=10000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6831: "+proj=tmerc +lat_0=45 +lon_0=-122.33333333333333 +k_0=1.00005 +x_0=10000.0000152 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6832: "+proj=tmerc +lat_0=44.99999999999996 +lon_0=-117.99999999999989 +k_0=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6833: "+proj=tmerc +lat_0=44.99999999999996 +lon_0=-117.99999999999989 +k_0=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6834: "+proj=tmerc +lat_0=44.99999999999996 +lon_0=-117.99999999999989 +k_0=1.00013 +x_0=40000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6835: "+proj=tmerc +lat_0=44.99999999999996 +lon_0=-117.99999999999989 +k_0=1.00013 +x_0=39999.99999984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6836: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k_0=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6837: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k_0=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6838: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k_0=1.0001 +x_0=80000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6839: "+proj=tmerc +lat_0=43.25 +lon_0=-117 +k_0=1.0001 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6840: "+proj=omerc +x_0=-300000 +y_0=-4600000 +lat_0=44.75 +lonc=-124.05 +alpha=4.999999999999995 +gamma=4.999999999999995 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6841: "+proj=omerc +x_0=-299999.9999988 +y_0=-4600000.00001208 +lat_0=44.75 +lonc=-124.05 +alpha=4.999999999999995 +gamma=4.999999999999995 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6842: "+proj=omerc +x_0=-300000 +y_0=-4600000 +lat_0=44.75 +lonc=-124.05 +alpha=4.999999999999995 +gamma=4.999999999999995 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6843: "+proj=omerc +x_0=-299999.9999988 +y_0=-4600000.00001208 +lat_0=44.75 +lonc=-124.05 +alpha=4.999999999999995 +gamma=4.999999999999995 +k_0=1 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6844: "+proj=tmerc +lat_0=45.25 +lon_0=-119.16666666666667 +k_0=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6845: "+proj=tmerc +lat_0=45.25 +lon_0=-119.16666666666667 +k_0=1.000045 +x_0=59999.999999759995 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6846: "+proj=tmerc +lat_0=45.25 +lon_0=-119.16666666666667 +k_0=1.000045 +x_0=60000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6847: "+proj=tmerc +lat_0=45.25 +lon_0=-119.16666666666667 +k_0=1.000045 +x_0=59999.999999759995 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6848: "+proj=tmerc +lat_0=45.083333333333336 +lon_0=-118.33333333333333 +k_0=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6849: "+proj=tmerc +lat_0=45.083333333333336 +lon_0=-118.33333333333333 +k_0=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6850: "+proj=tmerc +lat_0=45.083333333333336 +lon_0=-118.33333333333333 +k_0=1.000175 +x_0=30000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6851: "+proj=tmerc +lat_0=45.083333333333336 +lon_0=-118.33333333333333 +k_0=1.000175 +x_0=30000.00001512 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6852: "+proj=lcc +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6853: "+proj=lcc +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.99999960001 +y_0=50000.00001504 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6854: "+proj=lcc +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6855: "+proj=lcc +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.99999960001 +y_0=50000.00001504 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6856: "+proj=tmerc +lat_0=44.333333333333336 +lon_0=-123.08333333333333 +k_0=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6857: "+proj=tmerc +lat_0=44.333333333333336 +lon_0=-123.08333333333333 +k_0=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6858: "+proj=tmerc +lat_0=44.333333333333336 +lon_0=-123.08333333333333 +k_0=1.00001 +x_0=50000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6859: "+proj=tmerc +lat_0=44.333333333333336 +lon_0=-123.08333333333333 +k_0=1.00001 +x_0=50000.00001504 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6860: "+proj=tmerc +lat_0=44.083333333333336 +lon_0=-122.5 +k_0=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6861: "+proj=tmerc +lat_0=44.083333333333336 +lon_0=-122.5 +k_0=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6862: "+proj=tmerc +lat_0=44.083333333333336 +lon_0=-122.5 +k_0=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6863: "+proj=tmerc +lat_0=44.083333333333336 +lon_0=-122.5 +k_0=1.000155 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6867: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6868: "+proj=lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.99999840005 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6870: "+proj=tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6871: { p: "+proj=merc +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6875: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9985 +x_0=7000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6876: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6879: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6880: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6881: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            6882: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            6883: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            6884: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6885: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6886: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6887: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000.0001464002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            6892: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            6893: { p: "+proj=merc +lat_0=0 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            6894: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1 },
            6915: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            6916: 1,
            6917: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6922: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6923: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            6924: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6925: "+proj=lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            6927: { p: "+proj=tmerc +lat_0=1.3666666666666667 +lon_0=103.83333333333333 +k_0=1 +x_0=28001.642 +y_0=38744.572 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            6931: "+proj=laea +lat_0=89.99999999999991 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6932: "+proj=laea +lat_0=-89.99999999999991 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6933: "+proj=cea +lon_0=0 +x_0=0 +y_0=0 +lat_1=29.99999999999997 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6934: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6956: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6957: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6958: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6959: "+proj=tmerc +lat_0=0 +lon_0=107.75 +k_0=0.9999 +x_0=0 +y_0=500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            6962: "+proj=lcc +lat_0=40.99999999999996 +lon_0=19.99999999999998 +lat_1=38.999999999999964 +lat_2=42.99999999999996 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            6966: "+proj=lcc +k_0=1.0000382 +lat_0=44.78333333333333 +lon_0=-87 +lat_1=45.483333333333334 +lat_2=47.083333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            6978: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6979: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            6980: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            6981: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6982: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            6983: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            6984: "+proj=tmerc +lat_0=31.734393611111113 +lon_0=35.20451694444445 +k_0=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6985: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6986: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            6987: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            6988: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6989: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            6990: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            6991: "+proj=tmerc +lat_0=31.734393611111113 +lon_0=35.20451694444445 +k_0=1.0000067 +x_0=219529.584 +y_0=626907.39 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            6996: "+proj=tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=0.0000010000070000000001 +x_0=48000 +y_0=24000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            6997: "+proj=tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=0.0000010000070000000001 +x_0=48000.00000000001 +y_0=24000.000000000004 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7005: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            7006: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            7007: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            7034: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            7035: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            7036: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            7037: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1
            },
            7038: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            7039: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            7040: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            7041: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            7042: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            7057: "+proj=lcc +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.010414021 +y_0=2926085.8521717046 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7058: "+proj=lcc +lat_0=43.166666666666664 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.6200152407 +y_0=2987045.9740919485 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7059: "+proj=tmerc +lat_0=40.25 +lon_0=-91.2 +k_0=1.000035 +x_0=4114808.22961646 +y_0=2529845.0596901197 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7060: "+proj=lcc +lat_0=42.53333333333333 +lon_0=-94.83333333333333 +k_0=1.000045 +x_0=4419608.839217679 +y_0=2621285.2425704855 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7061: "+proj=lcc +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.448818898 +y_0=2712725.425450851 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7062: "+proj=tmerc +lat_0=40.25 +lon_0=-95.73333333333333 +k_0=1.000039 +x_0=5029210.058420118 +y_0=2011684.023368047 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7063: "+proj=tmerc +lat_0=40.25 +lon_0=-94.63333333333334 +k_0=1.000045 +x_0=5334010.668021337 +y_0=2072644.145288291 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7064: "+proj=tmerc +lat_0=40.25 +lon_0=-93.71666666666667 +k_0=1.000033 +x_0=5638811.277622556 +y_0=2133604.2672085348 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7065: "+proj=tmerc +lat_0=40.25 +lon_0=-92.81666666666666 +k_0=1.000027 +x_0=5943611.8872237755 +y_0=2194564.3891287786 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7066: "+proj=lcc +lat_0=41.833333333333336 +lon_0=-91.66666666666667 +k_0=1.00002 +x_0=6248412.496824995 +y_0=2438404.876809754 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7067: "+proj=tmerc +lat_0=40.25 +lon_0=-90.53333333333333 +k_0=1.000027 +x_0=6553213.106426214 +y_0=2316484.6329692663 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7068: "+proj=lcc +lat_0=40.916666666666664 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.716027433 +y_0=1889763.7795275594 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7069: "+proj=tmerc +lat_0=40.25 +lon_0=-91.91666666666667 +k_0=1.00002 +x_0=7162814.325628652 +y_0=1950723.9014478032 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7070: "+proj=tmerc +lat_0=40.25 +lon_0=-91.25 +k_0=1.000018 +x_0=7467614.935229871 +y_0=1889763.7795275594 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7071: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7072: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7073: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            7074: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7075: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7076: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7077: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7078: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7079: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7080: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7081: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7084: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1
            },
            7085: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            7086: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            7087: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            7088: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            7109: "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k_0=1.00016 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7110: "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k_0=1.00019 +x_0=100000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7111: "+proj=lcc +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7112: "+proj=lcc +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=200000 +y_0=150000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7113: "+proj=lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00012 +x_0=200000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7114: "+proj=lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00009 +x_0=100000 +y_0=50000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7115: "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k_0=1.000148 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7116: "+proj=lcc +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=100000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7117: "+proj=lcc +lat_0=45.78333333333333 +lon_0=-108.41666666666667 +k_0=1.0001515 +x_0=200000 +y_0=50000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7118: "+proj=tmerc +lat_0=42.666666666666664 +lon_0=-108.33333333333333 +k_0=1.00024 +x_0=100000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7119: "+proj=tmerc +lat_0=48.5 +lon_0=-112.5 +k_0=1.00016 +x_0=150000.00001464 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7120: "+proj=tmerc +lat_0=48 +lon_0=-112.5 +k_0=1.00019 +x_0=99999.99999960001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7121: "+proj=lcc +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000.00001464 +y_0=199999.99999920002 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7122: "+proj=lcc +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=199999.99999920002 +y_0=150000.00001464 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7123: "+proj=lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00012 +x_0=199999.99999920002 +y_0=99999.99999960001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7124: "+proj=lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00009 +x_0=99999.99999960001 +y_0=49999.99971024 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7125: "+proj=tmerc +lat_0=44.75 +lon_0=-107.75 +k_0=1.000148 +x_0=199999.99999920002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7126: "+proj=lcc +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=99999.99999960001 +y_0=99999.99999960001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7127: "+proj=lcc +lat_0=45.78333333333333 +lon_0=-108.41666666666667 +k_0=1.0001515 +x_0=199999.99999920002 +y_0=50000.00001504 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            7128: "+proj=tmerc +lat_0=42.666666666666664 +lon_0=-108.33333333333333 +k_0=1.00024 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7131: "+proj=tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=1.000007 +x_0=48000 +y_0=24000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7132: "+proj=tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=1.000007 +x_0=48000.00000000001 +y_0=24000.000000000004 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7133: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            7134: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7135: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7136: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            7137: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7138: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7139: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            7142: "+proj=tmerc +lat_0=31.734096944444445 +lon_0=35.21208055555556 +k_0=1 +x_0=170251.555 +y_0=126867.909 +ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0 +axis=en",
            7257: "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k_0=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7258: "+proj=tmerc +lat_0=40.55 +lon_0=-84.95 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7259: "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k_0=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7260: "+proj=tmerc +lat_0=40.9 +lon_0=-85.05 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7261: "+proj=tmerc +lat_0=39 +lon_0=-85.85 +k_0=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7262: "+proj=tmerc +lat_0=39 +lon_0=-85.85 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7263: "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k_0=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7264: "+proj=tmerc +lat_0=40.45 +lon_0=-87.3 +k_0=1.000029 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7265: "+proj=tmerc +lat_0=40.05 +lon_0=-85.4 +k_0=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7266: "+proj=tmerc +lat_0=40.05 +lon_0=-85.4 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7267: "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k_0=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7268: "+proj=tmerc +lat_0=39.6 +lon_0=-86.5 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7269: "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k_0=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7270: "+proj=tmerc +lat_0=39 +lon_0=-86.3 +k_0=1.00003 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7271: "+proj=tmerc +lat_0=40.4 +lon_0=-86.65 +k_0=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7272: "+proj=tmerc +lat_0=40.4 +lon_0=-86.65 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7273: "+proj=tmerc +lat_0=40.55 +lon_0=-86.4 +k_0=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7274: "+proj=tmerc +lat_0=40.55 +lon_0=-86.4 +k_0=1.000028 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7275: "+proj=tmerc +lat_0=38.15 +lon_0=-85.6 +k_0=1.000021 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7276: "+proj=tmerc +lat_0=38.15 +lon_0=-85.6 +k_0=1.000021 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7277: "+proj=tmerc +lat_0=39.15 +lon_0=-87.15 +k_0=1.000024 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7278: "+proj=tmerc +lat_0=39.15 +lon_0=-87.15 +k_0=1.000024 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7279: "+proj=tmerc +lat_0=40.15 +lon_0=-86.6 +k_0=1.000032 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7280: "+proj=tmerc +lat_0=40.15 +lon_0=-86.6 +k_0=1.000032 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7281: "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k_0=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7282: "+proj=tmerc +lat_0=38.1 +lon_0=-86.5 +k_0=1.000025 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7283: "+proj=tmerc +lat_0=38.45 +lon_0=-87.1 +k_0=1.000018 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7284: "+proj=tmerc +lat_0=38.45 +lon_0=-87.1 +k_0=1.000018 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7285: "+proj=tmerc +lat_0=38.65 +lon_0=-84.9 +k_0=1.000029 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7286: "+proj=tmerc +lat_0=38.65 +lon_0=-84.9 +k_0=1.000029 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7287: "+proj=tmerc +lat_0=39.1 +lon_0=-85.65 +k_0=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7288: "+proj=tmerc +lat_0=39.1 +lon_0=-85.65 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7289: "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k_0=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7290: "+proj=tmerc +lat_0=41.25 +lon_0=-84.95 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7291: "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k_0=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7292: "+proj=tmerc +lat_0=38.2 +lon_0=-86.95 +k_0=1.00002 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7293: "+proj=tmerc +lat_0=40.65 +lon_0=-85.85 +k_0=1.000033 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7294: "+proj=tmerc +lat_0=40.65 +lon_0=-85.85 +k_0=1.000033 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7295: "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k_0=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7296: "+proj=tmerc +lat_0=39.25 +lon_0=-85.05 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7297: "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k_0=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7298: "+proj=tmerc +lat_0=39.95 +lon_0=-87.3 +k_0=1.000025 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7299: "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k_0=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7300: "+proj=tmerc +lat_0=40.9 +lon_0=-86.3 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7301: "+proj=tmerc +lat_0=38.15 +lon_0=-87.65 +k_0=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7302: "+proj=tmerc +lat_0=38.15 +lon_0=-87.65 +k_0=1.000013 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7303: "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k_0=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7304: "+proj=tmerc +lat_0=40.35 +lon_0=-85.7 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7305: "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k_0=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7306: "+proj=tmerc +lat_0=39.9 +lon_0=-86 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7307: "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k_0=1.000036 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7308: "+proj=tmerc +lat_0=39.65 +lon_0=-85.8 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7309: "+proj=tmerc +lat_0=37.95 +lon_0=-86.15 +k_0=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7310: "+proj=tmerc +lat_0=37.95 +lon_0=-86.15 +k_0=1.000027 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7311: "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k_0=1.000043 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7312: "+proj=tmerc +lat_0=39.75 +lon_0=-85.45 +k_0=1.000043 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7313: "+proj=tmerc +lat_0=40.35 +lon_0=-86.15 +k_0=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7314: "+proj=tmerc +lat_0=40.35 +lon_0=-86.15 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7315: "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k_0=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7316: "+proj=tmerc +lat_0=40.65 +lon_0=-85.5 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7317: "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k_0=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7318: "+proj=tmerc +lat_0=38.7 +lon_0=-85.95 +k_0=1.000022 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7319: "+proj=tmerc +lat_0=40.7 +lon_0=-87.1 +k_0=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7320: "+proj=tmerc +lat_0=40.7 +lon_0=-87.1 +k_0=1.000027 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7321: "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k_0=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7322: "+proj=tmerc +lat_0=40.3 +lon_0=-85 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7323: "+proj=tmerc +lat_0=38.55 +lon_0=-85.35 +k_0=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7324: "+proj=tmerc +lat_0=38.55 +lon_0=-85.35 +k_0=1.000028 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7325: "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k_0=1.000025 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7326: "+proj=tmerc +lat_0=38.8 +lon_0=-85.8 +k_0=1.000025 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7327: "+proj=tmerc +lat_0=39.3 +lon_0=-86.15 +k_0=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7328: "+proj=tmerc +lat_0=39.3 +lon_0=-86.15 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7329: "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k_0=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7330: "+proj=tmerc +lat_0=38.4 +lon_0=-87.45 +k_0=1.000015 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7331: "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k_0=1.000037 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7332: "+proj=tmerc +lat_0=41.25 +lon_0=-85.45 +k_0=1.000037 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7333: "+proj=tmerc +lat_0=40.7 +lon_0=-87.4 +k_0=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7334: "+proj=tmerc +lat_0=40.7 +lon_0=-87.4 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7335: "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k_0=1.000027 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7336: "+proj=tmerc +lat_0=40.9 +lon_0=-86.75 +k_0=1.000027 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7337: "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k_0=1.000028 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7338: "+proj=tmerc +lat_0=38.95 +lon_0=-86.5 +k_0=1.000028 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7339: "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k_0=1.000031 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7340: "+proj=tmerc +lat_0=39.45 +lon_0=-86.95 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7341: "+proj=tmerc +lat_0=39.15 +lon_0=-86.9 +k_0=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7342: "+proj=tmerc +lat_0=39.15 +lon_0=-86.9 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7343: "+proj=tmerc +lat_0=39.6 +lon_0=-87.35 +k_0=1.000022 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7344: "+proj=tmerc +lat_0=39.6 +lon_0=-87.35 +k_0=1.000022 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7345: "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k_0=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7346: "+proj=tmerc +lat_0=37.8 +lon_0=-86.7 +k_0=1.00002 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7347: "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k_0=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7348: "+proj=tmerc +lat_0=37.85 +lon_0=-87.3 +k_0=1.000015 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7349: "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k_0=1.000013 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7350: "+proj=tmerc +lat_0=37.75 +lon_0=-87.95 +k_0=1.000013 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7351: "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k_0=1.000044 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7352: "+proj=tmerc +lat_0=39.7 +lon_0=-85.05 +k_0=1.000044 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7353: "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k_0=1.000038 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7354: "+proj=tmerc +lat_0=38.9 +lon_0=-85.3 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7355: "+proj=tmerc +lat_0=39.3 +lon_0=-85.9 +k_0=1.00003 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7356: "+proj=tmerc +lat_0=39.3 +lon_0=-85.9 +k_0=1.00003 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7357: "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k_0=1.000014 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7358: "+proj=tmerc +lat_0=37.75 +lon_0=-87.05 +k_0=1.000014 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7359: "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k_0=1.000041 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7360: "+proj=tmerc +lat_0=41.5 +lon_0=-85 +k_0=1.000041 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7361: "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k_0=1.000017 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7362: "+proj=tmerc +lat_0=38.9 +lon_0=-87.5 +k_0=1.000017 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7363: "+proj=tmerc +lat_0=40.2 +lon_0=-86.9 +k_0=1.000026 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7364: "+proj=tmerc +lat_0=40.2 +lon_0=-86.9 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7365: "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k_0=1.000015 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7366: "+proj=tmerc +lat_0=37.8 +lon_0=-87.55 +k_0=1.000015 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7367: "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k_0=1.00002 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7368: "+proj=tmerc +lat_0=39.25 +lon_0=-87.45 +k_0=1.00002 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7369: "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k_0=1.000034 +x_0=240000 +y_0=36000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7370: "+proj=tmerc +lat_0=40.55 +lon_0=-85.25 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7371: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-346,-1,224",
            7372: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-346,-1,224 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7373: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-346,-1,224 +axis=ne", x: 1, y: 1 },
            7374: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-346,-1,224 +axis=en",
            7375: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-346,-1,224 +axis=en",
            7376: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-346,-1,224 +axis=en",
            7400: { p: "+proj=longlat +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=ne", x: 0.8999999999999991, y: 0.8999999999999991, z: 1 },
            7401: { p: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            7402: { p: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            7403: { p: "+proj=lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            7404: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496 +axis=ne", x: 1, y: 1, z: 1 },
            7405: {
              p: "+proj=tmerc +lat_0=48.99999999999995 +lon_0=-1.999999999999998 +k_0=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            7406: { p: "+proj=longlat +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=ne", x: 1, y: 1, z: 0.3048006096 },
            7407: { p: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.18333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            7408: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            7409: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            7410: { p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            7411: { p: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            7412: { p: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            7413: {
              p: "+proj=lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            7414: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne", x: 1, y: 1, z: 1 },
            7415: { p: "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.3876388888888895 +k_0=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            7416: { p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            7417: {
              p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            7418: { p: "+proj=tmerc +lat_0=0 +lon_0=9.5 +k_0=0.99995 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            7419: { p: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            7420: { p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=900000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            7421: {
              p: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            7422: { p: "+proj=lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en", x: 1, y: 1, z: 1 },
            7423: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            7446: 1,
            7447: 1,
            7528: "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k_0=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7529: "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k_0=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7530: "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.85 +k_0=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7531: "+proj=lcc +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7532: "+proj=tmerc +lat_0=42.99999999999996 +lon_0=-87.99999999999991 +k_0=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7533: "+proj=tmerc +lat_0=43.481388888888894 +lon_0=-91.79722222222222 +k_0=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7534: "+proj=lcc +lat_0=45.898714865833334 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7535: "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k_0=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7536: "+proj=lcc +lat_0=44.977856898611115 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7537: "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k_0=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7538: "+proj=lcc +lat_0=43.462546645833335 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7539: "+proj=lcc +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7540: "+proj=lcc +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7541: "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.775 +k_0=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7542: "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k_0=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7543: "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k_0=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7544: "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k_0=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7545: "+proj=lcc +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.9239 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7546: "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k_0=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7547: "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k_0=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7548: "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k_0=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7549: "+proj=lcc +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7550: "+proj=lcc +lat_0=43.807000117777775 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7551: "+proj=tmerc +lat_0=42.538888888888884 +lon_0=-90.16111111111111 +k_0=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7552: "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k_0=1.0000677153 +x_0=220980.4419 +y_0=0.0085 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7553: "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k_0=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7554: "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k_0=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7555: "+proj=tmerc +lat_0=43.266666666666666 +lon_0=-87.55 +k_0=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7556: "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k_0=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7557: "+proj=lcc +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7558: "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k_0=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7559: "+proj=lcc +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7560: "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k_0=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7561: "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k_0=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7562: "+proj=lcc +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7563: "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k_0=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7564: "+proj=lcc +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7565: "+proj=lcc +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7566: "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k_0=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7567: "+proj=lcc +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7568: "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.4888888888889 +k_0=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7569: "+proj=lcc +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7570: "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k_0=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7571: "+proj=tmerc +lat_0=43.919444444444444 +lon_0=-91.06666666666666 +k_0=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7572: "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.9 +k_0=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7573: "+proj=lcc +lat_0=45.900099131388885 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7574: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k_0=1.000032144 +x_0=262433.3253 +y_0=0.0096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7575: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k_0=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7576: "+proj=lcc +lat_0=45.177822085833334 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7577: "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k_0=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7578: "+proj=lcc +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7579: "+proj=lcc +lat_0=46.07784409055556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7580: "+proj=lcc +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7581: "+proj=lcc +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7582: "+proj=tmerc +lat_0=42.918055555555554 +lon_0=-88.06388888888888 +k_0=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7583: "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22500000000001 +k_0=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7584: "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k_0=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7585: "+proj=lcc +lat_0=44.113944045833335 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7586: "+proj=lcc +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            7587: "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k_0=1.0000365285 +x_0=147218.69413258828 +y_0=0.003657607315214631 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7588: "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k_0=1.0000495683 +x_0=172821.94594869192 +y_0=0.0018288036576073155 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7589: "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.85 +k_0=1.0000486665 +x_0=93150.00000000001 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7590: "+proj=lcc +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.45750571505 +y_0=148551.48356616715 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7591: "+proj=tmerc +lat_0=43 +lon_0=-88 +k_0=1.00002 +x_0=31599.9998983998 +y_0=4599.9998983997975 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7592: "+proj=tmerc +lat_0=43.481388888888894 +lon_0=-91.79722222222222 +k_0=1.0000382778 +x_0=175260.35021590043 +y_0=0.004876809753619508 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7593: "+proj=lcc +lat_0=45.898714865833334 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100839 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7594: "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k_0=1.0000286569 +x_0=244754.88920497842 +y_0=0.004876809753619508 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7595: "+proj=lcc +lat_0=44.977856898611115 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72009144019 +y_0=44091.434493268986 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7596: "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k_0=1.0000463003 +x_0=199949.19898399798 +y_0=0.008534417068834139 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7597: "+proj=lcc +lat_0=43.462546645833335 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.33802387604 +y_0=111569.61351282703 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7598: "+proj=lcc +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.62738125477 +y_0=53703.120243840494 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7599: "+proj=lcc +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7600: "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.775 +k_0=1.0000346418 +x_0=263347.7263906528 +y_0=0.0076200152400304816 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7601: "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k_0=1.0000187521 +x_0=158801.11760223523 +y_0=0.002438404876809754 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7602: "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k_0=1.0000385418 +x_0=59131.31826263653 +y_0=0.00396240792481585 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7603: "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k_0=1.0000410324 +x_0=51816.10393700788 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7604: "+proj=lcc +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.44018288038 +y_0=91687.92390144782 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7605: "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k_0=1.0000552095 +x_0=133502.66822453646 +y_0=0.006400812801625604 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7606: "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k_0=1.0000673004 +x_0=275844.55321310647 +y_0=0.0158496316992634 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7607: "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k_0=1.0000349452 +x_0=242316.48402336807 +y_0=0.010058420116840236 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7608: "+proj=lcc +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.74015748032 +y_0=45830.2948437897 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7609: "+proj=lcc +lat_0=43.807000117777775 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.30175260353 +y_0=79170.77937515876 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7610: "+proj=tmerc +lat_0=42.538888888888884 +lon_0=-90.16111111111111 +k_0=1.0000394961 +x_0=113081.02616205234 +y_0=0.004572009144018289 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7611: "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k_0=1.0000677153 +x_0=220980.44196088394 +y_0=0.008534417068834139 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7612: "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k_0=1.0000353 +x_0=27000.000000000004 +y_0=24999.9998983998 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7613: "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k_0=1.0000260649 +x_0=185928.37277114557 +y_0=0.0009144018288036578 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7614: "+proj=tmerc +lat_0=43.266666666666666 +lon_0=-87.55 +k_0=1.0000233704 +x_0=79857.76154432309 +y_0=0.001219202438404877 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7615: "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k_0=1.0000319985 +x_0=130454.6596901194 +y_0=0.0033528067056134113 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7616: "+proj=lcc +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.19685039372 +y_0=105279.78288036576 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7617: "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k_0=1.0000599003 +x_0=116129.03225806453 +y_0=0.005791211582423165 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7618: "+proj=lcc +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.14935229871 +y_0=55049.266954533916 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7619: "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k_0=1.0000234982 +x_0=238658.87945135892 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7620: "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k_0=1.0000362499 +x_0=105461.0121412243 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7621: "+proj=lcc +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.98618237238 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7622: "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k_0=1.0000236869 +x_0=182880.36758953522 +y_0=0.0033528067056134113 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7623: "+proj=lcc +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.14020828043 +y_0=57588.03474726951 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7624: "+proj=lcc +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.33528067058 +y_0=86033.08773177548 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7625: "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k_0=1.0000433849 +x_0=141732.2822453645 +y_0=0.005791211582423165 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7626: "+proj=lcc +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622556 +y_0=50022.18745237491 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7627: "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.4888888888889 +k_0=1.0000649554 +x_0=227990.85445770895 +y_0=0.010972821945643892 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7628: "+proj=lcc +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.60477520956 +y_0=134255.42545085092 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7629: "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k_0=1.0000337311 +x_0=146304.29260858524 +y_0=0.006705613411226823 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7630: "+proj=tmerc +lat_0=43.919444444444444 +lon_0=-91.06666666666666 +k_0=1.0000495976 +x_0=250546.10139700284 +y_0=0.023469646939293883 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7631: "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.9 +k_0=1.0000373868 +x_0=185623.57155194314 +y_0=0.0051816103632207275 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7632: "+proj=lcc +lat_0=45.900099131388885 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.16316992637 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7633: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k_0=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637797 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7634: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k_0=1.0000381803 +x_0=165506.73009906022 +y_0=0.010363220726441455 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7635: "+proj=lcc +lat_0=45.177822085833334 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.75214630431 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7636: "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k_0=1.0000361538 +x_0=256946.91389382782 +y_0=0.00396240792481585 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7637: "+proj=lcc +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.44500889003 +y_0=47532.06035052071 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7638: "+proj=lcc +lat_0=46.07784409055556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101855 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7639: "+proj=lcc +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.86512573028 +y_0=111088.22240284483 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7640: "+proj=lcc +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.86817373638 +y_0=188358.6059436119 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7641: "+proj=tmerc +lat_0=42.918055555555554 +lon_0=-88.06388888888888 +k_0=1.00003738 +x_0=120091.44140208283 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7642: "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22500000000001 +k_0=1.0000346179 +x_0=208788.4178816358 +y_0=0.0033528067056134113 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7643: "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k_0=1.0000333645 +x_0=185013.97094234193 +y_0=0.007010414020828043 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7644: "+proj=lcc +lat_0=44.113944045833335 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.44018288038 +y_0=45069.758801117605 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7645: "+proj=lcc +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.61727203458 +y_0=134589.75392430785 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            7651: 1,
            7652: 1,
            7656: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7657: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7658: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7659: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7660: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7661: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7662: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7663: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7664: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7665: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7677: "+proj=geocent +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0",
            7678: { p: "+proj=longlat +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7679: "+proj=geocent +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0",
            7680: { p: "+proj=longlat +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7681: "+proj=geocent +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0",
            7682: { p: "+proj=longlat +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7683: { p: "+proj=longlat +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne", x: 1, y: 1 },
            7684: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7685: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7686: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            7692: "+proj=tmerc +lat_0=0 +lon_0=68.51666666666667 +k_0=1 +x_0=1300000 +y_0=14743.5 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7693: "+proj=tmerc +lat_0=0 +lon_0=71.51666666666667 +k_0=1 +x_0=2300000 +y_0=14743.5 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7694: "+proj=tmerc +lat_0=0 +lon_0=74.51666666666667 +k_0=1 +x_0=3300000 +y_0=14743.5 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7695: "+proj=tmerc +lat_0=0 +lon_0=77.51666666666667 +k_0=1 +x_0=4300000 +y_0=14743.5 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7696: "+proj=tmerc +lat_0=0 +lon_0=80.51666666666667 +k_0=1 +x_0=5300000 +y_0=14743.5 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7699: 1,
            7700: 1,
            7707: 1,
            7755: "+proj=lcc +lat_0=23.999999999999975 +lon_0=79.99999999999991 +lat_1=12.472955 +lat_2=35.172804444444445 +x_0=4000000 +y_0=4000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7756: "+proj=lcc +lat_0=16.25543297999998 +lon_0=80.87499999999991 +lat_1=13.749999999999986 +lat_2=18.749999999999982 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7757: "+proj=lcc +lat_0=28.001578969999972 +lon_0=94.4999999999999 +lat_1=26.99999999999997 +lat_2=28.99999999999997 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7758: "+proj=lcc +lat_0=26.002577029999976 +lon_0=92.7499999999999 +lat_1=24.666666666666668 +lat_2=27.333333333333332 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7759: "+proj=lcc +lat_0=25.877252469999974 +lon_0=85.87499999999991 +lat_1=24.624999999999975 +lat_2=27.12499999999997 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7760: "+proj=lcc +lat_0=28.625101259999973 +lon_0=76.99999999999993 +lat_1=28.375 +lat_2=28.875 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7761: "+proj=lcc +lat_0=22.37807120999998 +lon_0=71.37499999999993 +lat_1=20.791666666666668 +lat_2=23.958333333333332 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7762: "+proj=lcc +lat_0=29.25226265999997 +lon_0=75.99999999999993 +lat_1=28.083333333333332 +lat_2=30.416666666666668 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7763: "+proj=lcc +lat_0=31.75183496999997 +lon_0=77.37499999999993 +lat_1=30.749999999999968 +lat_2=32.749999999999964 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7764: "+proj=lcc +lat_0=34.75570873999997 +lon_0=76.49999999999993 +lat_1=33.083333333333336 +lat_2=36.416666666666664 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7765: "+proj=lcc +lat_0=23.626526819999974 +lon_0=85.62499999999991 +lat_1=22.541666666666668 +lat_2=24.708333333333332 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7766: "+proj=lcc +lat_0=24.005298209999975 +lon_0=78.37499999999991 +lat_1=21.99999999999998 +lat_2=25.999999999999975 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7767: "+proj=lcc +lat_0=18.880157739999984 +lon_0=76.74999999999993 +lat_1=16.625 +lat_2=21.125 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7768: "+proj=lcc +lat_0=24.750609109999974 +lon_0=93.9999999999999 +lat_1=24.083333333333332 +lat_2=25.416666666666668 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7769: "+proj=lcc +lat_0=25.625247469999977 +lon_0=91.37499999999991 +lat_1=25.208333333333332 +lat_2=26.041666666666668 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7770: "+proj=lcc +lat_0=26.125819739999976 +lon_0=94.3749999999999 +lat_1=25.375 +lat_2=26.875 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7771: "+proj=lcc +lat_0=25.634521349999975 +lon_0=93.4999999999999 +lat_1=23.041666666666668 +lat_2=28.208333333333332 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7772: "+proj=lcc +lat_0=20.25305173999998 +lon_0=84.37499999999991 +lat_1=18.583333333333332 +lat_2=21.916666666666668 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7773: "+proj=lcc +lat_0=31.001782259999967 +lon_0=75.37499999999993 +lat_1=29.99999999999997 +lat_2=31.999999999999968 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7774: "+proj=lcc +lat_0=26.885055459999972 +lon_0=73.87499999999993 +lat_1=24.291666666666668 +lat_2=29.458333333333332 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7775: "+proj=lcc +lat_0=27.13270822999997 +lon_0=80.87499999999991 +lat_1=24.875 +lat_2=29.375 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7776: "+proj=lcc +lat_0=30.001713199999973 +lon_0=79.37499999999991 +lat_1=28.99999999999997 +lat_2=30.999999999999968 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7777: "+proj=tmerc +lat_0=10.24999999999999 +lon_0=93.2499999999999 +k_0=0.9999428 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7778: "+proj=tmerc +lat_0=20.99999999999998 +lon_0=82.24999999999991 +k_0=0.9998332 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7779: "+proj=tmerc +lat_0=15.374999999999984 +lon_0=73.99999999999993 +k_0=0.9999913 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7780: "+proj=tmerc +lat_0=15.124999999999984 +lon_0=76.37499999999993 +k_0=0.9998012 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7781: "+proj=tmerc +lat_0=10.49999999999999 +lon_0=75.99999999999993 +k_0=0.9999177 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7782: "+proj=tmerc +lat_0=9.99999999999999 +lon_0=73.12499999999993 +k_0=0.9999536 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7783: "+proj=tmerc +lat_0=23.124999999999975 +lon_0=92.7499999999999 +k_0=0.9999821 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7784: "+proj=tmerc +lat_0=27.62499999999997 +lon_0=88.49999999999991 +k_0=0.9999926 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7785: "+proj=tmerc +lat_0=10.87499999999999 +lon_0=78.37499999999991 +k_0=0.9997942 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7786: "+proj=tmerc +lat_0=23.749999999999975 +lon_0=91.74999999999991 +k_0=0.9999822 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7787: "+proj=tmerc +lat_0=24.374999999999975 +lon_0=87.87499999999991 +k_0=0.9998584 +x_0=1000000 +y_0=1000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7789: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7791: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7792: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7793: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7794: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9985 +x_0=7000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7795: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=3000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7796: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7797: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7798: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            7799: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            7800: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            7801: "+proj=lcc +lat_0=42.66787568333333 +lon_0=25.5 +lat_1=42 +lat_2=43.333333333333336 +x_0=500000 +y_0=4725824.3591 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            7803: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7804: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7805: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7815: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7816: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7825: "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=23.5 +k_0=1 +x_0=1300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            7826: "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=26.5 +k_0=1 +x_0=2300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            7827: "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=29.5 +k_0=1 +x_0=3300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            7828: "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=32.5 +k_0=1 +x_0=4300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            7829: "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=35.5 +k_0=1 +x_0=5300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            7830: "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=38.5 +k_0=1 +x_0=6300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            7831: "+proj=tmerc +lat_0=0.08333333333333333 +lon_0=41.5 +k_0=1 +x_0=7300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            7832: 1,
            7837: 1,
            7839: 1,
            7841: 1,
            7842: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7843: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7844: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            7845: "+proj=lcc +lat_0=0 +lon_0=133.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7846: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7847: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7848: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7849: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7850: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7851: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7852: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7853: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7854: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7855: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7856: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7857: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7858: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7859: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7877: "+proj=tmerc +lat_0=-15.966666666666667 +lon_0=-5.716666666666667 +k_0=1 +x_0=300000 +y_0=2000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-320,550,-494 +axis=en",
            7878: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-320,550,-494 +axis=en",
            7879: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            7880: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7881: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            7882: "+proj=tmerc +lat_0=-15.966666666666667 +lon_0=-5.716666666666667 +k_0=1 +x_0=299483.737 +y_0=2000527.879 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7883: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            7884: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7885: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7886: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            7887: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7888: 1,
            7889: 1,
            7890: 1,
            7899: "+proj=lcc +lat_0=-36.999999999999964 +lon_0=144.99999999999986 +lat_1=-35.999999999999964 +lat_2=-37.999999999999964 +x_0=2500000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            7900: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7901: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7902: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7903: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7904: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7905: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7906: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7907: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7908: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7909: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7910: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7911: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7912: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7914: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7915: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7916: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7917: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7918: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7919: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7920: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7921: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7922: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7923: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7924: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7925: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7926: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7927: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7928: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7929: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            7930: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            7931: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            7954: { p: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-320,550,-494 +axis=en", x: 1, y: 1, z: 1 },
            7955: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            7956: { p: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            7962: 1,
            7968: 1,
            7976: -1,
            7979: 1,
            7991: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            7992: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            8013: "+proj=tmerc +lat_0=0 +lon_0=117.88333333333334 +k_0=1.0000044 +x_0=50000 +y_0=4100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8014: "+proj=tmerc +lat_0=0 +lon_0=115.25 +k_0=1.0000022 +x_0=60000 +y_0=2700000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8015: "+proj=tmerc +lat_0=0 +lon_0=122.33333333333333 +k_0=1.00000298 +x_0=50000 +y_0=2300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8016: "+proj=tmerc +lat_0=0 +lon_0=115.43333333333334 +k_0=0.99999592 +x_0=50000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8017: "+proj=tmerc +lat_0=0 +lon_0=113.66666666666667 +k_0=0.99999796 +x_0=50000 +y_0=3050000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8018: "+proj=tmerc +lat_0=0 +lon_0=105.625 +k_0=1.00002514 +x_0=50000 +y_0=1400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8019: "+proj=tmerc +lat_0=0 +lon_0=96.875 +k_0=0.99999387 +x_0=50000 +y_0=1600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8020: "+proj=tmerc +lat_0=0 +lon_0=115.93333333333334 +k_0=1.000019 +x_0=40000 +y_0=4100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8021: "+proj=tmerc +lat_0=0 +lon_0=121.88333333333334 +k_0=1.0000055 +x_0=50000 +y_0=4050000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8022: "+proj=tmerc +lat_0=0 +lon_0=114.06666666666666 +k_0=1.00000236 +x_0=50000 +y_0=2750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8023: "+proj=tmerc +lat_0=0 +lon_0=114.58333333333333 +k_0=1.00000628 +x_0=50000 +y_0=3450000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8024: "+proj=tmerc +lat_0=0 +lon_0=121.5 +k_0=1.00004949 +x_0=60000 +y_0=3800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8025: "+proj=tmerc +lat_0=0 +lon_0=114.98333333333333 +k_0=1.00000314 +x_0=50000 +y_0=3650000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8026: "+proj=tmerc +lat_0=0 +lon_0=114.31527777777778 +k_0=1.000014 +x_0=55000 +y_0=3700000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8027: "+proj=tmerc +lat_0=0 +lon_0=116.93333333333334 +k_0=0.9999989 +x_0=50000 +y_0=2550000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8028: "+proj=tmerc +lat_0=0 +lon_0=128.75 +k_0=1.0000165 +x_0=50000 +y_0=2100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8029: "+proj=tmerc +lat_0=0 +lon_0=115.36666666666666 +k_0=1.00000157 +x_0=50000 +y_0=3750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8030: "+proj=tmerc +lat_0=0 +lon_0=115.16666666666667 +k_0=1.0000055 +x_0=50000 +y_0=4050000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8031: "+proj=tmerc +lat_0=0 +lon_0=115.81666666666666 +k_0=0.99999906 +x_0=50000 +y_0=3900000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8032: "+proj=tmerc +lat_0=0 +lon_0=118.6 +k_0=1.00000135 +x_0=50000 +y_0=2500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8035: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000.00010160025 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en +to_meter=0.3048006096",
            8036: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000.00010160025 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en +to_meter=0.3048006096",
            8042: { p: "+proj=longlat +a=6376045 +b=6355477.112903226 +pm=-17.666666666666668 +axis=ne", x: 1, y: 1 },
            8043: { p: "+proj=longlat +a=6376045 +b=6355477.112903226 +pm=-17.666666666666668 +axis=ne", x: 1, y: 1 },
            8044: "+proj=cass +lat_0=48.038463888888884 +lon_0=31.804180555555558 +x_0=0 +y_0=0 +a=6376045 +b=6355477.112903226 +pm=-17.666666666666668 +axis=sw",
            8045: "+proj=cass +lat_0=48.208761111111116 +lon_0=34.04092222222222 +x_0=0 +y_0=0 +a=6376045 +b=6355477.112903226 +pm=-17.666666666666668 +axis=sw",
            8050: 0.3048,
            8051: -0.3048,
            8052: 0.3048006096,
            8053: -0.3048006096,
            8058: "+proj=lcc +lat_0=-33.249999999999964 +lon_0=146.99999999999986 +lat_1=-30.749999999999968 +lat_2=-35.749999999999964 +x_0=9300000 +y_0=4500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8059: "+proj=lcc +lat_0=-31.999999999999968 +lon_0=134.99999999999986 +lat_1=-27.99999999999997 +lat_2=-35.999999999999964 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8065: "+proj=omerc +lat_0=32.25 +lonc=-111.4 +alpha=44.99999999999996 +gamma=44.99999999999996 +k_0=1.00011 +x_0=48768 +y_0=243840 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8066: "+proj=tmerc +lat_0=31.25 +lon_0=-112.16666666666667 +k_0=1.00009 +x_0=548640 +y_0=304800 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8067: "+proj=tmerc +lat_0=31.5 +lon_0=-113.16666666666667 +k_0=1.000055 +x_0=182880 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8068: "+proj=lcc +lat_0=30.5 +lon_0=-110.75 +k_0=0.9998 +x_0=9144 +y_0=-188976 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8082: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=24500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8083: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=25500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8084: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8085: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8086: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8088: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=2700000 +y_0=300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8089: 1,
            8090: "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k_0=1.0000552095 +x_0=133502.6683 +y_0=0.0063 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8091: "+proj=tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k_0=1.0000552095 +x_0=133502.66822453646 +y_0=0.006400812801625604 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8092: "+proj=lcc +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.9239 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8093: "+proj=lcc +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.44018288038 +y_0=91687.92390144782 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8095: "+proj=lcc +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8096: "+proj=lcc +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.61727203458 +y_0=134589.75392430785 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8097: "+proj=lcc +lat_0=44.113944045833335 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8098: "+proj=lcc +lat_0=44.113944045833335 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.44018288038 +y_0=45069.758801117605 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8099: "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k_0=1.0000333645 +x_0=185013.9709 +y_0=0.007 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8100: "+proj=tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k_0=1.0000333645 +x_0=185013.97094234193 +y_0=0.007010414020828043 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8101: "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22500000000001 +k_0=1.0000346179 +x_0=208788.418 +y_0=0.0034 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8102: "+proj=tmerc +lat_0=42.56944444444445 +lon_0=-88.22500000000001 +k_0=1.0000346179 +x_0=208788.4178816358 +y_0=0.0033528067056134113 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8103: "+proj=tmerc +lat_0=42.918055555555554 +lon_0=-88.06388888888888 +k_0=1.00003738 +x_0=120091.4415 +y_0=0.003 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8104: "+proj=tmerc +lat_0=42.918055555555554 +lon_0=-88.06388888888888 +k_0=1.00003738 +x_0=120091.44140208283 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8105: "+proj=lcc +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8106: "+proj=lcc +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.86817373638 +y_0=188358.6059436119 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8107: "+proj=lcc +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8108: "+proj=lcc +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.86512573028 +y_0=111088.22240284483 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8109: "+proj=lcc +lat_0=46.07784409055556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8110: "+proj=lcc +lat_0=46.07784409055556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101855 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8111: "+proj=lcc +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8112: "+proj=lcc +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.44500889003 +y_0=47532.06035052071 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8113: "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k_0=1.0000361538 +x_0=256946.9138 +y_0=0.0041 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8114: "+proj=tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k_0=1.0000361538 +x_0=256946.91389382782 +y_0=0.00396240792481585 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8115: "+proj=lcc +lat_0=45.177822085833334 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8116: "+proj=lcc +lat_0=45.177822085833334 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.75214630431 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8117: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k_0=1.0000381803 +x_0=165506.7302 +y_0=0.0103 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8118: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k_0=1.0000381803 +x_0=165506.73009906022 +y_0=0.010363220726441455 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8119: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k_0=1.000032144 +x_0=262433.3253 +y_0=0.0096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8120: "+proj=tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k_0=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637797 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8121: "+proj=lcc +lat_0=45.900099131388885 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8122: "+proj=lcc +lat_0=45.900099131388885 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.16316992637 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8123: "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.9 +k_0=1.0000373868 +x_0=185623.5716 +y_0=0.0051 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8124: "+proj=tmerc +lat_0=42.81944444444445 +lon_0=-89.9 +k_0=1.0000373868 +x_0=185623.57155194314 +y_0=0.0051816103632207275 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8125: "+proj=tmerc +lat_0=43.919444444444444 +lon_0=-91.06666666666666 +k_0=1.0000495976 +x_0=250546.1013 +y_0=0.0234 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8126: "+proj=tmerc +lat_0=43.919444444444444 +lon_0=-91.06666666666666 +k_0=1.0000495976 +x_0=250546.10139700284 +y_0=0.023469646939293883 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8127: "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k_0=1.0000337311 +x_0=146304.2926 +y_0=0.0068 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8128: "+proj=tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k_0=1.0000337311 +x_0=146304.29260858524 +y_0=0.006705613411226823 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8129: "+proj=lcc +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8130: "+proj=lcc +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.60477520956 +y_0=134255.42545085092 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8131: "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.4888888888889 +k_0=1.0000649554 +x_0=227990.8546 +y_0=0.0109 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8132: "+proj=tmerc +lat_0=44.55555555555555 +lon_0=-90.4888888888889 +k_0=1.0000649554 +x_0=227990.85445770895 +y_0=0.010972821945643892 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8133: "+proj=lcc +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8134: "+proj=lcc +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622556 +y_0=50022.18745237491 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8135: "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k_0=1.0000433849 +x_0=141732.2823 +y_0=0.0059 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8136: "+proj=tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k_0=1.0000433849 +x_0=141732.2822453645 +y_0=0.005791211582423165 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8137: "+proj=lcc +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8138: "+proj=lcc +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.33528067058 +y_0=86033.08773177548 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8139: "+proj=lcc +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8140: "+proj=lcc +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.14020828043 +y_0=57588.03474726951 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8141: "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k_0=1.0000236869 +x_0=182880.3676 +y_0=0.0033 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8142: "+proj=tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k_0=1.0000236869 +x_0=182880.36758953522 +y_0=0.0033528067056134113 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8143: "+proj=lcc +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8144: "+proj=lcc +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.98618237238 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8145: "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k_0=1.0000362499 +x_0=105461.0121 +y_0=0.0029 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8146: "+proj=tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k_0=1.0000362499 +x_0=105461.0121412243 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8147: "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k_0=1.0000234982 +x_0=238658.8794 +y_0=0.0032 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8148: "+proj=tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k_0=1.0000234982 +x_0=238658.87945135892 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8149: "+proj=lcc +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8150: "+proj=lcc +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.14935229871 +y_0=55049.266954533916 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8151: "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k_0=1.0000599003 +x_0=116129.0323 +y_0=0.0058 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8152: "+proj=tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k_0=1.0000599003 +x_0=116129.03225806453 +y_0=0.005791211582423165 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8153: "+proj=lcc +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8154: "+proj=lcc +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.19685039372 +y_0=105279.78288036576 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8155: "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k_0=1.0000319985 +x_0=130454.6598 +y_0=0.0033 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8156: "+proj=tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k_0=1.0000319985 +x_0=130454.6596901194 +y_0=0.0033528067056134113 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8157: "+proj=tmerc +lat_0=43.266666666666666 +lon_0=-87.55 +k_0=1.0000233704 +x_0=79857.7614 +y_0=0.0012 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8158: "+proj=tmerc +lat_0=43.266666666666666 +lon_0=-87.55 +k_0=1.0000233704 +x_0=79857.76154432309 +y_0=0.001219202438404877 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8159: "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k_0=1.0000260649 +x_0=185928.3728 +y_0=0.0009 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8160: "+proj=tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k_0=1.0000260649 +x_0=185928.37277114557 +y_0=0.0009144018288036578 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8161: "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k_0=1.0000353 +x_0=27000 +y_0=25000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8162: "+proj=tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k_0=1.0000353 +x_0=27000.000000000004 +y_0=24999.9998983998 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8163: "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k_0=1.0000677153 +x_0=220980.4419 +y_0=0.0085 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8164: "+proj=tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k_0=1.0000677153 +x_0=220980.44196088394 +y_0=0.008534417068834139 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8165: "+proj=tmerc +lat_0=42.538888888888884 +lon_0=-90.16111111111111 +k_0=1.0000394961 +x_0=113081.0261 +y_0=0.0045 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8166: "+proj=tmerc +lat_0=42.538888888888884 +lon_0=-90.16111111111111 +k_0=1.0000394961 +x_0=113081.02616205234 +y_0=0.004572009144018289 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8167: "+proj=lcc +lat_0=43.807000117777775 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8168: "+proj=lcc +lat_0=43.807000117777775 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.30175260353 +y_0=79170.77937515876 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8169: "+proj=lcc +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8170: "+proj=lcc +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.74015748032 +y_0=45830.2948437897 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8171: "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k_0=1.0000349452 +x_0=242316.4841 +y_0=0.01 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8172: "+proj=tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k_0=1.0000349452 +x_0=242316.48402336807 +y_0=0.010058420116840236 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8173: "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k_0=1.0000673004 +x_0=275844.5533 +y_0=0.0157 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8177: "+proj=tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k_0=1.0000673004 +x_0=275844.55321310647 +y_0=0.0158496316992634 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8179: "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k_0=1.0000410324 +x_0=51816.104 +y_0=0.003 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8180: "+proj=tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k_0=1.0000410324 +x_0=51816.10393700788 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8181: "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k_0=1.0000385418 +x_0=59131.3183 +y_0=0.0041 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8182: "+proj=tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k_0=1.0000385418 +x_0=59131.31826263653 +y_0=0.00396240792481585 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8184: "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k_0=1.0000187521 +x_0=158801.1176 +y_0=0.0023 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8185: "+proj=tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k_0=1.0000187521 +x_0=158801.11760223523 +y_0=0.002438404876809754 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8187: "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.775 +k_0=1.0000346418 +x_0=263347.7263 +y_0=0.0076 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8189: "+proj=tmerc +lat_0=41.47222222222222 +lon_0=-88.775 +k_0=1.0000346418 +x_0=263347.7263906528 +y_0=0.0076200152400304816 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8191: "+proj=lcc +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8193: "+proj=lcc +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8196: "+proj=lcc +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8197: "+proj=lcc +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.62738125477 +y_0=53703.120243840494 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8198: "+proj=lcc +lat_0=43.462546645833335 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8200: "+proj=lcc +lat_0=43.462546645833335 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.33802387604 +y_0=111569.61351282703 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8201: "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k_0=1.0000463003 +x_0=199949.1989 +y_0=0.0086 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8202: "+proj=tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k_0=1.0000463003 +x_0=199949.19898399798 +y_0=0.008534417068834139 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8203: "+proj=lcc +lat_0=44.977856898611115 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8204: "+proj=lcc +lat_0=44.977856898611115 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72009144019 +y_0=44091.434493268986 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8205: "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k_0=1.0000286569 +x_0=244754.8893 +y_0=0.0049 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8206: "+proj=tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k_0=1.0000286569 +x_0=244754.88920497842 +y_0=0.004876809753619508 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8207: "+proj=lcc +lat_0=45.898714865833334 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8208: "+proj=lcc +lat_0=45.898714865833334 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100839 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8209: "+proj=tmerc +lat_0=43.481388888888894 +lon_0=-91.79722222222222 +k_0=1.0000382778 +x_0=175260.3502 +y_0=0.0048 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8210: "+proj=tmerc +lat_0=43.481388888888894 +lon_0=-91.79722222222222 +k_0=1.0000382778 +x_0=175260.35021590043 +y_0=0.004876809753619508 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8212: "+proj=tmerc +lat_0=42.99999999999996 +lon_0=-87.99999999999991 +k_0=1.00002 +x_0=31600 +y_0=4600 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8213: "+proj=tmerc +lat_0=43 +lon_0=-88 +k_0=1.00002 +x_0=31599.9998983998 +y_0=4599.9998983997975 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8214: "+proj=lcc +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8216: "+proj=lcc +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.45750571505 +y_0=148551.48356616715 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8218: "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.85 +k_0=1.0000486665 +x_0=93150 +y_0=0.0029 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8220: "+proj=tmerc +lat_0=45.13333333333333 +lon_0=-91.85 +k_0=1.0000486665 +x_0=93150.00000000001 +y_0=0.0030480060960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8222: "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k_0=1.0000495683 +x_0=172821.9461 +y_0=0.0017 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8224: "+proj=tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k_0=1.0000495683 +x_0=172821.94594869192 +y_0=0.0018288036576073155 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8225: "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k_0=1.0000365285 +x_0=147218.6942 +y_0=0.0037 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8226: "+proj=tmerc +lat_0=43.36666666666667 +lon_0=-90 +k_0=1.0000365285 +x_0=147218.69413258828 +y_0=0.003657607315214631 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8227: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8228: 0.3048,
            8230: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8231: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8232: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8233: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8235: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            8237: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8238: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8239: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8240: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8242: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8244: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            8246: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8247: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8248: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8249: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8250: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8251: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            8252: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8253: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8254: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8255: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8266: 1,
            8267: 1,
            8311: "+proj=tmerc +lat_0=43.5 +lon_0=-117.66666666666667 +k_0=1.00014 +x_0=90000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8312: "+proj=tmerc +lat_0=43.5 +lon_0=-117.66666666666667 +k_0=1.00014 +x_0=90000.00001488 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8313: "+proj=tmerc +lat_0=43.5 +lon_0=-119 +k_0=1.00022 +x_0=20000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8314: "+proj=tmerc +lat_0=43.5 +lon_0=-119 +k_0=1.00022 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8315: "+proj=lcc +lat_0=45.583333333333336 +lon_0=-123.41666666666667 +k_0=1.000045 +x_0=30000 +y_0=20000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8316: "+proj=lcc +lat_0=45.583333333333336 +lon_0=-123.41666666666667 +k_0=1.000045 +x_0=30000.00001512 +y_0=19999.99999992 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8317: "+proj=tmerc +lat_0=44.25 +lon_0=-119.63333333333334 +k_0=1.00012 +x_0=20000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8318: "+proj=tmerc +lat_0=44.25 +lon_0=-119.63333333333334 +k_0=1.00012 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8319: "+proj=tmerc +lat_0=41.75 +lon_0=-118.41666666666667 +k_0=1.00019 +x_0=80000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8320: "+proj=tmerc +lat_0=41.75 +lon_0=-118.41666666666667 +k_0=1.00019 +x_0=79999.99999968 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8321: "+proj=lcc +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=40000 +y_0=70000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8322: "+proj=lcc +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=39999.99999984 +y_0=70000.00001496 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8323: "+proj=lcc +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=60000 +y_0=-60000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8324: "+proj=lcc +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=59999.999999759995 +y_0=-59999.999999759995 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8325: "+proj=lcc +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000 +y_0=290000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8326: "+proj=lcc +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000.00001512 +y_0=290000.00001408 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8327: "+proj=lcc +lat_0=46.166666666666664 +lon_0=-120.5 +k_0=1 +x_0=100000 +y_0=140000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8328: "+proj=lcc +lat_0=46.166666666666664 +lon_0=-120.5 +k_0=1 +x_0=99999.99999960001 +y_0=139999.99999944 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8329: "+proj=lcc +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=40000 +y_0=-80000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8330: "+proj=lcc +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=39999.99999984 +y_0=-79999.99999968 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8331: "+proj=tmerc +lat_0=41.75 +lon_0=-117.58333333333333 +k_0=1.00018 +x_0=70000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8332: "+proj=tmerc +lat_0=41.75 +lon_0=-117.58333333333333 +k_0=1.00018 +x_0=70000.00001496 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8333: "+proj=lcc +lat_0=46.166666666666664 +lon_0=-119 +k_0=1.000025 +x_0=50000 +y_0=130000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8334: "+proj=lcc +lat_0=46.166666666666664 +lon_0=-119 +k_0=1.000025 +x_0=50000.00001504 +y_0=130000.00001472 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8335: "+proj=lcc +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=60000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8336: "+proj=lcc +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=59999.999999759995 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8337: "+proj=tmerc +lat_0=41.75 +lon_0=-120.33333333333333 +k_0=1.000215 +x_0=70000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8338: "+proj=tmerc +lat_0=41.75 +lon_0=-120.33333333333333 +k_0=1.000215 +x_0=70000.00001496 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8339: "+proj=lcc +lat_0=42.5 +lon_0=-122.58333333333333 +k_0=1.00015 +x_0=10000 +y_0=60000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8340: "+proj=lcc +lat_0=42.5 +lon_0=-122.58333333333333 +k_0=1.00015 +x_0=10000.0000152 +y_0=59999.999999759995 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8341: "+proj=lcc +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000 +y_0=90000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8342: "+proj=lcc +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000.00001512 +y_0=90000.00001488 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8343: "+proj=tmerc +lat_0=45.25 +lon_0=-117.5 +k_0=1.000195 +x_0=60000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8344: "+proj=tmerc +lat_0=45.25 +lon_0=-117.5 +k_0=1.000195 +x_0=59999.999999759995 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8345: "+proj=lcc +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=40000 +y_0=60000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8346: "+proj=lcc +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=39999.99999984 +y_0=59999.999999759995 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8347: "+proj=tmerc +lat_0=43 +lon_0=-122 +k_0=1.000223 +x_0=20000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8348: "+proj=tmerc +lat_0=43 +lon_0=-122 +k_0=1.000223 +x_0=19999.99999992 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            8349: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            8350: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            8351: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1 },
            8352: "+proj=krovak +alpha=30.28813975277778 +x_0=0 +y_0=0 +lat_0=49.5 +k_0=0.9999 +lon_0=24.833333333333332 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=sw",
            8353: "+proj=krovak +lat_0=49.5 +alpha=30.28813975277778 +k=0.9999 +x_0=0 +y_0=0 +k_0=0.9999 +lon_0=24.833333333333332 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            8357: 1,
            8358: -1,
            8360: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            8370: { p: "+proj=lcc +lat_0=50.797815 +lon_0=4.359215833333333 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=649328 +y_0=665262 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8379: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.0001 +x_0=100000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8380: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.0001 +x_0=99999.99998984 +y_0=200000.00001016003 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            8381: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.000135 +x_0=300000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8382: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.000135 +x_0=300000.00000000006 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            8383: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.0001 +x_0=100000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8384: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.0001 +x_0=99999.99998984 +y_0=200000.00001016003 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8385: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.000135 +x_0=300000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8387: "+proj=tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.000135 +x_0=300000.00000000006 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8391: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.999929 +x_0=300000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8395: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8397: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8399: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8401: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8403: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8425: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8426: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8427: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8428: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            8429: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8430: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8431: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8433: "+proj=tmerc +lat_0=22.212397222222222 +lon_0=113.53646944444445 +k_0=1 +x_0=20000 +y_0=20000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            8434: 1,
            8441: "+proj=labrd +x_0=400000 +y_0=800000 +lat_0=-18.9 +lonc=46.43722916666666 +alpha=18.9 +k_0=0.9995 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-189,-242,-91 +axis=ne",
            8449: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu", x: 1, y: 1 },
            8455: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8456: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8518: "+proj=tmerc +lat_0=37.5 +lon_0=-101.6 +k_0=1.000156 +x_0=457200.91440182884 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8519: "+proj=tmerc +lat_0=37.5 +lon_0=-100.95 +k_0=1.000134 +x_0=762001.5240030481 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8520: "+proj=tmerc +lat_0=37.5 +lon_0=-100.35 +k_0=1.000116 +x_0=1066802.1336042674 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8521: "+proj=tmerc +lat_0=37.5 +lon_0=-99.45 +k_0=1.000082 +x_0=1371602.7432054866 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8522: "+proj=tmerc +lat_0=37.5 +lon_0=-98.66666666666667 +k_0=1.000078 +x_0=1676403.3528067057 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8523: "+proj=tmerc +lat_0=37.5 +lon_0=-98.15 +k_0=1.000068 +x_0=1981203.9624079252 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8524: "+proj=tmerc +lat_0=37.5 +lon_0=-97.33333333333333 +k_0=1.000049 +x_0=2286004.5720091444 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8525: "+proj=lcc +lat_0=39.166666666666664 +lon_0=-96.5 +k_0=1.000044 +x_0=2590805.1816103635 +y_0=182880.36576073154 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8526: "+proj=lcc +lat_0=38.5 +lon_0=-96.5 +k_0=1.00005 +x_0=2895605.7912115827 +y_0=91440.18288036577 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8527: "+proj=lcc +lat_0=39.63333333333333 +lon_0=-95.75 +k_0=1.00004 +x_0=3200406.400812802 +y_0=213360.42672085346 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8528: "+proj=lcc +lat_0=39.1 +lon_0=-95.25 +k_0=1.000033 +x_0=3505207.010414021 +y_0=182880.36576073154 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8529: "+proj=tmerc +lat_0=36.75 +lon_0=-101.41666666666667 +k_0=1.00014 +x_0=3810007.6200152407 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8531: "+proj=tmerc +lat_0=36.75 +lon_0=-100.4 +k_0=1.000109 +x_0=4114808.22961646 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8533: "+proj=tmerc +lat_0=36.75 +lon_0=-99.66666666666667 +k_0=1.000097 +x_0=4419608.839217679 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8534: "+proj=tmerc +lat_0=36.75 +lon_0=-99.2 +k_0=1.000087 +x_0=4724409.448818898 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8535: "+proj=tmerc +lat_0=36.75 +lon_0=-98.55 +k_0=1.000069 +x_0=5029210.058420118 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8536: "+proj=lcc +lat_0=37.766666666666666 +lon_0=-97.5 +k_0=1.000059 +x_0=5334010.668021337 +y_0=121920.2438404877 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8538: "+proj=lcc +lat_0=37.18333333333333 +lon_0=-97.5 +k_0=1.000055 +x_0=5638811.277622556 +y_0=60960.12192024385 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8539: "+proj=tmerc +lat_0=36.75 +lon_0=-95.96666666666667 +k_0=1.000034 +x_0=5943611.8872237755 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8540: "+proj=tmerc +lat_0=36.75 +lon_0=-95.08333333333333 +k_0=1.000031 +x_0=6248412.496824995 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            8541: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            8542: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu", x: 1, y: 1, z: 1 },
            8543: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            8544: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            8545: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            8675: 1,
            8677: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            8678: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            8679: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=8500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            8682: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8683: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8684: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8685: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8686: "+proj=tmerc +lat_0=0 +lon_0=15 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            8687: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8690: 1,
            8691: 1,
            8692: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8693: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            8694: {
              p: "+proj=longlat +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            8697: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8698: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8699: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8700: { p: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8701: {
              p: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
              x: 1,
              y: 1,
              z: 0.3048
            },
            8702: { p: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8703: { p: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=7999999.999968001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8704: {
              p: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=5999999.999976001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
              x: 1,
              y: 1,
              z: 0.3048
            },
            8705: { p: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=3999999.9999840003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8706: { p: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8707: {
              p: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
              x: 1,
              y: 1,
              z: 0.3048
            },
            8708: { p: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=599999.9999976 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8709: { p: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000.0001424 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8710: {
              p: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000.0001464002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048",
              x: 1,
              y: 1,
              z: 0.3048
            },
            8711: { p: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048", x: 1, y: 1, z: 0.3048 },
            8712: { p: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8713: {
              p: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8714: { p: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8715: {
              p: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8716: { p: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8717: { p: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8718: { p: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8719: { p: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8720: { p: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8721: { p: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8722: { p: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8288036577 +y_0=304800.60960121924 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8723: { p: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.60960121924 +y_0=152400.30480060962 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8724: { p: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8725: { p: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8726: {
              p: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8727: { p: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8728: { p: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8729: {
              p: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8730: { p: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8731: { p: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8732: {
              p: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8733: { p: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8734: { p: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=699999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8735: {
              p: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8736: { p: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249999.99989839984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8737: { p: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000.0000000002 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8738: { p: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8739: { p: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=399999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8740: {
              p: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=399999.99998984 +y_0=399999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8741: { p: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8742: {
              p: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000.00010160025 +y_0=500000.00010160025 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8743: { p: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8744: { p: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.9999898401 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8745: {
              p: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8746: { p: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8747: { p: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.99989839987 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8748: {
              p: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000.00010160022 +y_0=750000.0000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8749: { p: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8750: { p: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8751: {
              p: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8752: { p: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8753: { p: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8754: {
              p: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=699999.9998983999 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8755: { p: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8756: { p: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000.00001016003 +y_0=8000000.000010162 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8757: {
              p: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000.0000101601 +y_0=6000000.000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8758: { p: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000.0000101601 +y_0=3999999.9999898407 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8759: { p: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8760: {
              p: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8761: { p: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8762: { p: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8763: {
              p: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000.0001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8764: { p: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8765: { p: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=249999.99989839984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8766: {
              p: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000.0001016002 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8767: { p: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8768: { p: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8769: {
              p: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8770: { p: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8771: { p: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8772: {
              p: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8773: { p: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8774: { p: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8775: { p: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=99999.99998984 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8776: { p: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8777: {
              p: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8778: { p: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8779: { p: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000.00010160022 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8780: {
              p: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000.0000000001 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8781: { p: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=699999.9998983999 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8782: {
              p: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000.0000000001 +y_0=3999999.9998984006 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8783: { p: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000.00000000006 +y_0=5000000.000101601 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8784: {
              p: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.0000101601 +y_0=999999.9999898401 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8785: { p: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.0000101601 +y_0=2000000.0000101603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8786: {
              p: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.0000101601 +y_0=3000000.0000000005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8787: { p: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8788: { p: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000.0001016003 +y_0=2000000.0001016005 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8789: {
              p: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000.0001016003 +y_0=999999.9998983999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8790: { p: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8791: { p: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000.00010160025 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8792: { p: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8793: { p: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8794: {
              p: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8795: { p: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8796: { p: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8797: {
              p: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000.00001016003 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8798: { p: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8799: { p: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096", x: 1, y: 1, z: 0.3048006096 },
            8800: {
              p: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
              x: 1,
              y: 1,
              z: 0.3048006096
            },
            8801: { p: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8802: { p: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8803: {
              p: "+proj=omerc +x_0=5000000 +y_0=-5000000 +lat_0=57 +lonc=-133.66666666666666 +alpha=323.13010236111114 +gamma=323.13010236111114 +k_0=0.9999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            8804: { p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-141.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8805: { p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-145.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8806: {
              p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-149.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            8807: { p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-153.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8808: { p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-157.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8809: {
              p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-161.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            8810: { p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-165.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8811: { p: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-169.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8812: {
              p: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.833333333333336 +lat_2=51.833333333333336 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            8813: { p: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8814: { p: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8815: {
              p: "+proj=tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            8816: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8817: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8818: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8826: "+proj=tmerc +lat_0=42 +lon_0=-114 +k_0=0.9996 +x_0=2500000 +y_0=1200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8836: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8837: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8838: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8839: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8840: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8841: 1,
            8857: "+proj=eqearth +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            8858: "+proj=eqearth +lon_0=-89.99999999999991 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            8859: "+proj=eqearth +lon_0=149.99999999999986 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            8860: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1 },
            8881: 1,
            8888: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            8898: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8899: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8900: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8901: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            8902: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            8903: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8904: 1,
            8905: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8906: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8907: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8908: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8909: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8910: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8911: 1,
            8912: { p: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            8915: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8916: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8917: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8918: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8919: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8920: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8921: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8922: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8923: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8924: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8925: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8926: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8927: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8928: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8929: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8930: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8931: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8932: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8933: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8934: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8935: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8936: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8937: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8938: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8939: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8940: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8941: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8942: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8943: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8944: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8945: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8946: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8947: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            8948: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            8949: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8950: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8951: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            8972: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            8973: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8974: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8975: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8976: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8977: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8978: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            8979: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8980: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8981: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8982: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8983: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8984: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            8985: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8986: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8987: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8988: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8989: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8990: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            8991: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8992: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8993: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8994: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8995: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8996: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            8997: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8998: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            8999: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9e3: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9001: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9002: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            9003: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9004: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9005: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9006: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9007: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9008: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            9009: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9010: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9011: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9012: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9013: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9014: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9015: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9016: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9017: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9018: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9019: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9039: "+proj=laea +lat_0=51.99999999999995 +lon_0=9.99999999999999 +x_0=4321000 +y_0=3210000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            9040: "+proj=lcc +lat_0=51.99999999999995 +lon_0=9.99999999999999 +lat_1=34.999999999999964 +lat_2=64.99999999999993 +x_0=4000000 +y_0=2800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            9053: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            9054: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            9055: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            9056: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9057: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            9059: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9060: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9061: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9062: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9063: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9064: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9065: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9066: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9067: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9068: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9069: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9070: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9071: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9072: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9073: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9074: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9075: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9130: 1,
            9138: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9139: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9140: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9141: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=7500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9146: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9147: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            9148: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9149: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9150: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9151: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9152: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            9153: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9154: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9155: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9156: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9157: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9158: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9159: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9182: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9183: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9184: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9191: "+proj=aea +lat_0=-39.99999999999996 +lon_0=174.99999999999983 +lat_1=-29.99999999999997 +lat_2=-49.99999999999995 +x_0=0 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9205: "+proj=tmerc +lat_0=0 +lon_0=103 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9206: "+proj=tmerc +lat_0=0 +lon_0=104 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9207: "+proj=tmerc +lat_0=0 +lon_0=104.5 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9208: "+proj=tmerc +lat_0=0 +lon_0=104.75 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9209: "+proj=tmerc +lat_0=0 +lon_0=105.5 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9210: "+proj=tmerc +lat_0=0 +lon_0=105.75 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9211: "+proj=tmerc +lat_0=0 +lon_0=106 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9212: "+proj=tmerc +lat_0=0 +lon_0=106.25 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9213: "+proj=tmerc +lat_0=0 +lon_0=106.5 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9214: "+proj=tmerc +lat_0=0 +lon_0=107 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9215: "+proj=tmerc +lat_0=0 +lon_0=107.25 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9216: "+proj=tmerc +lat_0=0 +lon_0=107.5 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9217: "+proj=tmerc +lat_0=0 +lon_0=108.25 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9218: "+proj=tmerc +lat_0=0 +lon_0=108.5 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9221: "+proj=aea +lat_0=-29.99999999999997 +lon_0=24.999999999999975 +lat_1=-21.99999999999998 +lat_2=-37.999999999999964 +x_0=1400000 +y_0=1300000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            9222: "+proj=aea +lat_0=-41.99999999999996 +lon_0=43.99999999999996 +lat_1=-33.999999999999964 +lat_2=-49.99999999999995 +x_0=1200000 +y_0=1300000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            9245: 1,
            9248: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            9249: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +k_0=1 +x_0=1500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            9250: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            9251: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9252: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            9253: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            9254: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            9255: 1,
            9265: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9266: "+proj=geocent +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            9267: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9271: "+proj=tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            9272: "+proj=tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            9273: "+proj=tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            9274: 1,
            9279: 1,
            9284: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +k_0=1 +x_0=1500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            9285: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +k_0=1 +x_0=3500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            9286: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9287: -1,
            9288: -1,
            9289: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: -1
            },
            9290: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: -1 },
            9292: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9293: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9294: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9295: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9296: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9297: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9299: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9300: "+proj=tmerc +lat_0=52.29999999999995 +lon_0=-1.4999999999999984 +k_0=1 +x_0=198873.0046 +y_0=375064.3871 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9303: 1,
            9306: { p: "+proj=tmerc +lat_0=52.29999999999995 +lon_0=-1.4999999999999984 +k_0=1 +x_0=198873.0046 +y_0=375064.3871 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9307: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9308: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9309: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9311: "+proj=laea +ellps=clrk66 +lat_0=44.99999999999996 +lon_0=-99.9999999999999 +x_0=0 +y_0=0 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            9331: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9332: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9333: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9335: 1,
            9351: 1,
            9354: "+proj=stere +x_0=0 +y_0=0 +lat_ts=-64.99999999999993 +lon_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            9356: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9357: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9358: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9359: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9360: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9364: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9367: "+proj=tmerc +lat_0=53.5 +lon_0=-2.25 +k_0=1 +x_0=203252.175 +y_0=407512.765 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9368: { p: "+proj=tmerc +lat_0=53.5 +lon_0=-2.25 +k_0=1 +x_0=203252.175 +y_0=407512.765 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9372: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9373: "+proj=tmerc +lat_0=52.45 +lon_0=-0.85 +k_0=1 +x_0=49350.157 +y_0=108398.212 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9374: { p: "+proj=tmerc +lat_0=52.45 +lon_0=-0.85 +k_0=1 +x_0=49350.157 +y_0=108398.212 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9377: "+proj=tmerc +lat_0=3.999999999999996 +lon_0=-72.99999999999993 +k_0=0.9992 +x_0=5000000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            9378: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9379: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9380: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9384: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9387: "+proj=tmerc +lat_0=57.4 +lon_0=-3.2 +k_0=1 +x_0=155828.702 +y_0=115225.707 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9388: { p: "+proj=tmerc +lat_0=57.4 +lon_0=-3.2 +k_0=1 +x_0=155828.702 +y_0=115225.707 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9389: 1,
            9390: 1,
            9391: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9392: 1,
            9393: 1,
            9394: 1,
            9395: 1,
            9396: 1,
            9397: 1,
            9398: 1,
            9399: 1,
            9400: 1,
            9401: 1,
            9402: 1,
            9403: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            9404: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            9405: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            9406: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-307,-92,127 +axis=en",
            9407: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-307,-92,127 +axis=en",
            9422: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9423: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9424: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9425: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9426: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9427: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9428: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9429: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9430: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9449: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9450: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9451: 1,
            9452: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9453: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9456: "+proj=tmerc +lat_0=55.75 +lon_0=-4.35 +k_0=1 +x_0=93720.394 +y_0=113870.493 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9457: {
              p: "+proj=tmerc +lat_0=55.75 +lon_0=-4.35 +k_0=1 +x_0=93720.394 +y_0=113870.493 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9458: 1,
            9462: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9463: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9464: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9468: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            9469: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9470: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9471: 1,
            9473: "+proj=aea +lat_0=0 +lon_0=131.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9474: { p: "+proj=longlat +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0 +axis=ne", x: 1, y: 1 },
            9475: { p: "+proj=longlat +ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0 +axis=ne", x: 1, y: 1 },
            9476: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9477: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9478: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9479: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9480: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9481: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9482: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9487: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9488: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9489: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9490: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9491: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9492: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9493: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9494: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9498: "+proj=tmerc +lat_0=-34.629266666666666 +lon_0=-58.46330833333334 +k_0=1 +x_0=20000 +y_0=70000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            9500: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9501: { p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9502: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 0.3048 },
            9503: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 0.3048 },
            9504: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 0.3048 },
            9505: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9506: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9507: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9508: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9509: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9510: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9511: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9512: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9513: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9514: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9515: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9516: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9517: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9518: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9519: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9520: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9521: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9522: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9523: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            9524: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            9525: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            9526: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne", x: 1, y: 1, z: 1 },
            9527: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9528: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9529: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9530: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9531: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9532: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9533: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9534: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9535: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9536: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9537: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9538: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9539: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9540: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9541: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9542: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9543: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9544: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9545: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9546: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9547: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9650: 1,
            9651: 1,
            9656: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9657: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9663: 1,
            9666: 1,
            9669: 1,
            9672: -1,
            9674: "+proj=aea +lat_0=33.999999999999964 +lon_0=-119.99999999999989 +lat_1=42.99999999999996 +lat_2=47.99999999999995 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9675: 1,
            9678: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=-2000000 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=en",
            9680: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            9681: 1,
            9694: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9695: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9696: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9697: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9698: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9699: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9700: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9701: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9702: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9705: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9707: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9709: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            9711: { p: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            9712: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9713: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            9714: {
              p: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9715: { p: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en", x: 1, y: 1, z: 1 },
            9716: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9721: 1,
            9722: 1,
            9723: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9724: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9725: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9739: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9741: "+proj=tmerc +lat_0=56.35 +lon_0=-2.75 +k_0=1 +x_0=74996.927 +y_0=133508.35 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9742: { p: "+proj=tmerc +lat_0=56.35 +lon_0=-2.75 +k_0=1 +x_0=74996.927 +y_0=133508.35 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9748: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000.00010160022 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            9749: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            9753: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            9754: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            9755: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            9758: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9761: "+proj=tmerc +lat_0=55.05 +lon_0=-1.55 +k_0=1 +x_0=112242.8512 +y_0=402313.7432 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9762: {
              p: "+proj=tmerc +lat_0=55.05 +lon_0=-1.55 +k_0=1 +x_0=112242.8512 +y_0=402313.7432 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9763: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=89.5,93.8,123.1,-1.2,0.0,0.0,0.156 +axis=ne", x: 1, y: 1 },
            9766: "+proj=tmerc +lat_0=51.95 +lon_0=-0.9 +k_0=1 +x_0=192519.9715 +y_0=146942.6806 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=89.5,93.8,123.1,-1.2,0.0,0.0,0.156 +axis=en",
            9767: {
              p: "+proj=tmerc +lat_0=51.95 +lon_0=-0.9 +k_0=1 +x_0=192519.9715 +y_0=146942.6806 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=89.5,93.8,123.1,-1.2,0.0,0.0,0.156 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9775: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9776: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9777: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9778: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            9779: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            9780: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9781: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9782: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9783: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            9784: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            9785: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9793: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9794: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9821: "+proj=tmerc +lat_0=0 +lon_0=30.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9822: "+proj=lcc +lat_0=41.99999999999996 +lon_0=2.999999999999997 +lat_1=41.24999999999996 +lat_2=42.74999999999996 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9823: "+proj=lcc +lat_0=42.99999999999996 +lon_0=2.999999999999997 +lat_1=42.24999999999996 +lat_2=43.74999999999996 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9824: "+proj=lcc +lat_0=43.99999999999996 +lon_0=2.999999999999997 +lat_1=43.24999999999996 +lat_2=44.74999999999996 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9825: "+proj=lcc +lat_0=44.99999999999996 +lon_0=2.999999999999997 +lat_1=44.24999999999996 +lat_2=45.74999999999996 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9826: "+proj=lcc +lat_0=45.99999999999996 +lon_0=2.999999999999997 +lat_1=45.24999999999996 +lat_2=46.74999999999995 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9827: "+proj=lcc +lat_0=46.99999999999995 +lon_0=2.999999999999997 +lat_1=46.24999999999995 +lat_2=47.74999999999995 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9828: "+proj=lcc +lat_0=47.99999999999995 +lon_0=2.999999999999997 +lat_1=47.24999999999995 +lat_2=48.74999999999995 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9829: "+proj=lcc +lat_0=48.99999999999995 +lon_0=2.999999999999997 +lat_1=48.24999999999995 +lat_2=49.74999999999995 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9830: "+proj=lcc +lat_0=49.99999999999995 +lon_0=2.999999999999997 +lat_1=49.24999999999995 +lat_2=50.74999999999995 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9831: "+proj=tmerc +lat_0=0 +lon_0=34.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9832: "+proj=tmerc +lat_0=0 +lon_0=28.666666666666668 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9833: "+proj=tmerc +lat_0=0 +lon_0=24.833333333333332 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9834: "+proj=tmerc +lat_0=0 +lon_0=34.999999999999964 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9835: "+proj=tmerc +lat_0=0 +lon_0=37.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9836: "+proj=tmerc +lat_0=0 +lon_0=28.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9837: "+proj=tmerc +lat_0=0 +lon_0=23.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9838: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9839: "+proj=tmerc +lat_0=0 +lon_0=24.75 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9840: "+proj=tmerc +lat_0=0 +lon_0=31.999999999999968 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9841: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9842: "+proj=lcc +lat_0=41.99999999999996 +lon_0=2.999999999999997 +lat_1=41.24999999999996 +lat_2=42.74999999999996 +x_0=1700000 +y_0=1200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9843: "+proj=lcc +lat_0=42.99999999999996 +lon_0=2.999999999999997 +lat_1=42.24999999999996 +lat_2=43.74999999999996 +x_0=1700000 +y_0=2200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9844: "+proj=lcc +lat_0=43.99999999999996 +lon_0=2.999999999999997 +lat_1=43.24999999999996 +lat_2=44.74999999999996 +x_0=1700000 +y_0=3200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9845: "+proj=lcc +lat_0=44.99999999999996 +lon_0=2.999999999999997 +lat_1=44.24999999999996 +lat_2=45.74999999999996 +x_0=1700000 +y_0=4200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9846: "+proj=lcc +lat_0=45.99999999999996 +lon_0=2.999999999999997 +lat_1=45.24999999999996 +lat_2=46.74999999999995 +x_0=1700000 +y_0=5200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9847: "+proj=lcc +lat_0=46.99999999999995 +lon_0=2.999999999999997 +lat_1=46.24999999999995 +lat_2=47.74999999999995 +x_0=1700000 +y_0=6200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9848: "+proj=lcc +lat_0=47.99999999999995 +lon_0=2.999999999999997 +lat_1=47.24999999999995 +lat_2=48.74999999999995 +x_0=1700000 +y_0=7200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9849: "+proj=lcc +lat_0=48.99999999999995 +lon_0=2.999999999999997 +lat_1=48.24999999999995 +lat_2=49.74999999999995 +x_0=1700000 +y_0=8200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9850: "+proj=lcc +lat_0=49.99999999999995 +lon_0=2.999999999999997 +lat_1=49.24999999999995 +lat_2=50.74999999999995 +x_0=1700000 +y_0=9200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9851: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9852: "+proj=tmerc +lat_0=0 +lon_0=31.833333333333332 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9853: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9854: "+proj=tmerc +lat_0=0 +lon_0=33.833333333333336 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9855: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9856: "+proj=tmerc +lat_0=0 +lon_0=34.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9857: "+proj=tmerc +lat_0=0 +lon_0=25.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9858: "+proj=tmerc +lat_0=0 +lon_0=36.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9859: "+proj=tmerc +lat_0=0 +lon_0=33.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9860: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9861: "+proj=tmerc +lat_0=0 +lon_0=31.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9862: "+proj=tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9863: "+proj=tmerc +lat_0=0 +lon_0=31.999999999999968 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9864: "+proj=tmerc +lat_0=0 +lon_0=30.5 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9865: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=300000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            9866: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-446.448,125.157,-542.060, 20.4894,-0.1502, -0.2470,-0.8421 +axis=ne",
              x: 1,
              y: 1
            },
            9869: "+proj=tmerc +lat_0=52.3 +lon_0=-1.8 +k_0=1 +x_0=227286.9881 +y_0=265751.2874 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-446.448,125.157,-542.060, 20.4894,-0.1502, -0.2470,-0.8421 +axis=en",
            9870: { p: "+proj=tmerc +lat_0=52.3 +lon_0=-1.8 +k_0=1 +x_0=227286.9881 +y_0=265751.2874 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-446.448,125.157,-542.060, 20.4894,-0.1502, -0.2470,-0.8421 +axis=en", x: 1, y: 1, z: 1 },
            9871: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9874: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9875: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9880: "+proj=tmerc +lat_0=53.35 +lon_0=-1.9 +k_0=1 +x_0=226574.2032 +y_0=390894.838 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9881: {
              p: "+proj=tmerc +lat_0=53.35 +lon_0=-1.9 +k_0=1 +x_0=226574.2032 +y_0=390894.838 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9883: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: -1 },
            9892: "+proj=geocent +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            9893: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9895: "+proj=tmerc +k_0=1 +lat_0=49.833333333333336 +lon_0=6.166666666666667 +x_0=80000 +y_0=100000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=neu",
            9897: {
              p: "+proj=tmerc +lat_0=49.833333333333336 +lon_0=6.166666666666667 +k_0=1 +x_0=80000 +y_0=100000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9907: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9920: { p: "+proj=tmerc +lat_0=48.99999999999995 +lon_0=-1.999999999999998 +k_0=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9922: { p: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k_0=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9923: 1,
            9924: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9927: 1,
            9928: { p: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9929: { p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9930: { p: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9931: { p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9932: { p: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9933: { p: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9934: {
              p: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9935: { p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9939: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9943: "+proj=tmerc +lat_0=51.75 +lon_0=-3.1 +k_0=1 +x_0=106702.326 +y_0=119968.1395 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9944: {
              p: "+proj=tmerc +lat_0=51.75 +lon_0=-3.1 +k_0=1 +x_0=106702.326 +y_0=119968.1395 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9945: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=-4000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            9947: "+proj=laea +lat_0=64.99999999999993 +lon_0=-18.999999999999982 +x_0=1700000 +y_0=1300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9948: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9949: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            9950: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            9951: { p: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9952: { p: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=1700000 +y_0=300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9953: {
              p: "+proj=lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=2700000 +y_0=300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            9964: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9967: "+proj=tmerc +lat_0=53.75 +lon_0=-0.95 +k_0=1 +x_0=140859.7394 +y_0=247512.2812 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9968: { p: "+proj=tmerc +lat_0=53.75 +lon_0=-0.95 +k_0=1 +x_0=140859.7394 +y_0=247512.2812 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9969: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            9972: "+proj=tmerc +lat_0=56.6 +lon_0=-3.85 +k_0=1 +x_0=108600.972 +y_0=239087.349 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9973: { p: "+proj=tmerc +lat_0=56.6 +lon_0=-3.85 +k_0=1 +x_0=108600.972 +y_0=239087.349 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9974: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            9977: "+proj=tmerc +lat_0=58 +lon_0=-3.8 +k_0=1 +x_0=139618.9493 +y_0=183110.794 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            9978: { p: "+proj=tmerc +lat_0=58 +lon_0=-3.8 +k_0=1 +x_0=139618.9493 +y_0=183110.794 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            9988: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            9989: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            9990: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10150: -1,
            10151: -1,
            10156: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: -1
            },
            10157: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: -1 },
            10158: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            10160: "+proj=tmerc +lat_0=0 +lon_0=10.369999999999989 +k_0=1 +x_0=-210327 +y_0=-6034310 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            10162: { p: "+proj=tmerc +lat_0=33 +lon_0=129.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10163: { p: "+proj=tmerc +lat_0=33 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10164: { p: "+proj=tmerc +lat_0=36 +lon_0=132.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10165: { p: "+proj=tmerc +lat_0=33 +lon_0=133.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10166: {
              p: "+proj=tmerc +lat_0=36 +lon_0=134.33333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            10167: { p: "+proj=tmerc +lat_0=36 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10168: { p: "+proj=tmerc +lat_0=36 +lon_0=137.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10169: { p: "+proj=tmerc +lat_0=36 +lon_0=138.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10170: {
              p: "+proj=tmerc +lat_0=36 +lon_0=139.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            10171: { p: "+proj=tmerc +lat_0=40 +lon_0=140.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10172: { p: "+proj=tmerc +lat_0=44 +lon_0=140.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10173: { p: "+proj=tmerc +lat_0=44 +lon_0=142.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10174: {
              p: "+proj=tmerc +lat_0=44 +lon_0=144.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            10175: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10176: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            10177: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            10178: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10183: "+proj=tmerc +lat_0=52.7 +lon_0=-4.15 +k_0=1 +x_0=64859.6557 +y_0=122266.5277 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10184: { p: "+proj=tmerc +lat_0=52.7 +lon_0=-4.15 +k_0=1 +x_0=64859.6557 +y_0=122266.5277 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10185: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10188: "+proj=tmerc +lat_0=52.6 +lon_0=-3.35 +k_0=1 +x_0=56023.5377 +y_0=24567.6764 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10189: {
              p: "+proj=tmerc +lat_0=52.6 +lon_0=-3.35 +k_0=1 +x_0=56023.5377 +y_0=24567.6764 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            10190: 1,
            10191: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10194: "+proj=lcc +lat_0=53.25 +lon_0=-3.5 +lat_1=53.1 +lat_2=53.4 +x_0=212548.8756 +y_0=495230.9254 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10195: { p: "+proj=lcc +lat_0=53.25 +lon_0=-3.5 +lat_1=53.1 +lat_2=53.4 +x_0=212548.8756 +y_0=495230.9254 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10196: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            10199: "+proj=tmerc +lat_0=52.4 +lon_0=-2.9 +k_0=1 +x_0=199668.0926 +y_0=89354.3229 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10200: { p: "+proj=tmerc +lat_0=52.4 +lon_0=-2.9 +k_0=1 +x_0=199668.0926 +y_0=89354.3229 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10204: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10207: "+proj=tmerc +lat_0=51.85 +lon_0=-1.3 +k_0=1 +x_0=511622.854 +y_0=324737.4633 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10208: { p: "+proj=tmerc +lat_0=51.85 +lon_0=-1.3 +k_0=1 +x_0=511622.854 +y_0=324737.4633 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10209: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10212: "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10213: {
              p: "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            10214: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10217: "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10218: { p: "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10219: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            10222: "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10223: { p: "+proj=lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10224: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10227: "+proj=tmerc +lat_0=52.2 +lon_0=-1.15 +k_0=1 +x_0=175262.1809 +y_0=174688.2508 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10228: { p: "+proj=tmerc +lat_0=52.2 +lon_0=-1.15 +k_0=1 +x_0=175262.1809 +y_0=174688.2508 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10229: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10235: "+proj=tmerc +lat_0=51.95 +lon_0=-1.7 +k_0=1 +x_0=134791.6965 +y_0=121872.5056 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10236: {
              p: "+proj=tmerc +lat_0=51.95 +lon_0=-1.7 +k_0=1 +x_0=134791.6965 +y_0=121872.5056 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            10237: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10240: "+proj=tmerc +lat_0=52.9 +lon_0=-2.6 +k_0=1 +x_0=110094.4312 +y_0=120623.8396 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10241: { p: "+proj=tmerc +lat_0=52.9 +lon_0=-2.6 +k_0=1 +x_0=110094.4312 +y_0=120623.8396 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10245: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1,
              z: 1
            },
            10246: { p: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10249: { p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne", x: 1, y: 1 },
            10250: "+proj=tmerc +lat_0=0 +lon_0=10.369999999999989 +k_0=1 +x_0=-210327 +y_0=-6034310 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            10252: {
              p: "+proj=longlat +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            10254: "+proj=tmerc +lat_0=55.111709999999945 +lon_0=14.889269999999986 +k_0=1 +x_0=-50000 +y_0=50000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            10256: { p: "+proj=longlat +a=6377019.27 +b=6355762.5391 +pm=0 +axis=ne", x: 1, y: 1 },
            10260: { p: "+proj=longlat +a=6377019.27 +b=6355762.5391 +pm=0 +axis=ne", x: 1, y: 1 },
            10265: { p: "+proj=longlat +a=6377019.27 +b=6355762.5391 +pm=0 +axis=ne", x: 1, y: 1 },
            10268: {
              p: "+proj=longlat +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            10270: "+proj=tmerc +lat_0=54.46849999999994 +lon_0=9.232999999999992 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            10272: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10275: "+proj=tmerc +lat_0=50.75 +lon_0=-3.85 +k_0=1 +x_0=110693.666 +y_0=102089.2943 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10276: {
              p: "+proj=tmerc +lat_0=50.75 +lon_0=-3.85 +k_0=1 +x_0=110693.666 +y_0=102089.2943 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            10277: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10280: "+proj=lcc +lat_0=50.85 +lon_0=-3.25 +lat_1=50.3 +lat_2=51.45 +x_0=372382.8292 +y_0=217764.7796 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10281: { p: "+proj=lcc +lat_0=50.85 +lon_0=-3.25 +lat_1=50.3 +lat_2=51.45 +x_0=372382.8292 +y_0=217764.7796 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10282: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            10283: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            10284: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10285: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10286: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            10287: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=31500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10288: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            10289: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=32500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10290: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            10291: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=33500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10293: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10297: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            10298: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            10299: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10300: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            10303: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            10304: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            10305: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10306: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9996 +x_0=500000 +y_0=-6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            10307: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            10308: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            10309: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            10310: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10311: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=enu", x: 1, y: 1, z: 1 },
            10312: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1 },
            10314: "+proj=lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.666666666666668 +lat_2=-22.333333333333332 +x_0=2400000 +y_0=2300000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10315: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10316: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10317: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10318: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            10326: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            10327: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            10328: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10329: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            10345: { p: "+proj=longlat +a=6378273 +b=6356889.449 +pm=0 +axis=ne", x: 1, y: 1 },
            10346: {
              p: "+proj=longlat +a=6371228 +b=6371228 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            10349: -1,
            10352: 1,
            10353: 1,
            10354: 1,
            10355: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10356: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10357: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10364: -1,
            10365: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10370: -1,
            10371: -1,
            10372: -1,
            10373: -1,
            10374: -1,
            10375: -1,
            10376: -1,
            10377: -1,
            10378: -1,
            10379: -1,
            10412: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            10413: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            10414: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10448: "+proj=tmerc +lat_0=0 +lon_0=117.88333333333334 +k_0=1.0000044 +x_0=50000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10449: "+proj=tmerc +lat_0=0 +lon_0=115.25 +k_0=1.0000022 +x_0=60000 +y_0=2600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10450: "+proj=tmerc +lat_0=0 +lon_0=122.33333333333333 +k_0=1.00000298 +x_0=50000 +y_0=2200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10451: "+proj=tmerc +lat_0=0 +lon_0=115.43333333333334 +k_0=0.99999592 +x_0=50000 +y_0=3900000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10452: "+proj=tmerc +lat_0=0 +lon_0=113.66666666666667 +k_0=0.99999796 +x_0=50000 +y_0=2950000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10453: "+proj=tmerc +lat_0=0 +lon_0=115.93333333333334 +k_0=1.000019 +x_0=40000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10454: "+proj=tmerc +lat_0=0 +lon_0=121.88333333333334 +k_0=1.0000055 +x_0=50000 +y_0=3950000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10455: "+proj=tmerc +lat_0=0 +lon_0=114.06666666666666 +k_0=1.00000236 +x_0=50000 +y_0=2650000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10456: "+proj=tmerc +lat_0=0 +lon_0=114.58333333333333 +k_0=1.00000628 +x_0=50000 +y_0=3350000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10457: "+proj=tmerc +lat_0=0 +lon_0=121.5 +k_0=1.00004949 +x_0=60000 +y_0=3700000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10458: "+proj=tmerc +lat_0=0 +lon_0=114.98333333333333 +k_0=1.00000314 +x_0=50000 +y_0=3550000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10459: "+proj=tmerc +lat_0=0 +lon_0=114.31527777777778 +k_0=1.000014 +x_0=55000 +y_0=3600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10460: "+proj=tmerc +lat_0=0 +lon_0=116.93333333333334 +k_0=0.9999989 +x_0=50000 +y_0=2450000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10461: "+proj=tmerc +lat_0=0 +lon_0=128.75 +k_0=1.0000165 +x_0=50000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10462: "+proj=tmerc +lat_0=0 +lon_0=115.36666666666666 +k_0=1.00000157 +x_0=50000 +y_0=3650000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10463: "+proj=tmerc +lat_0=0 +lon_0=115.16666666666667 +k_0=1.0000055 +x_0=50000 +y_0=3950000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10464: "+proj=tmerc +lat_0=0 +lon_0=115.81666666666666 +k_0=0.99999906 +x_0=50000 +y_0=3800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10465: "+proj=tmerc +lat_0=0 +lon_0=118.6 +k_0=1.00000135 +x_0=50000 +y_0=2400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10468: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            10471: "+proj=tmerc +lat_0=52.4 +lon_0=-1.55 +k_0=1 +x_0=116887.9989 +y_0=102194.9369 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10472: { p: "+proj=tmerc +lat_0=52.4 +lon_0=-1.55 +k_0=1 +x_0=116887.9989 +y_0=102194.9369 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10473: "+proj=geocent +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            10474: {
              p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=neu",
              x: 1,
              y: 1,
              z: 1
            },
            10475: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1 },
            10477: "+proj=tmerc +lat_0=46.98077630555556 +lon_0=11.52849375 +k_0=1.000121 +x_0=20000 +y_0=100000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            10480: "+proj=aea +lat_0=31.249999999999968 +lon_0=-99.9999999999999 +lat_1=27.49999999999997 +lat_2=34.999999999999964 +x_0=1500000.0000000002 +y_0=6000000.000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10481: "+proj=aea +lat_0=31.249999999999968 +lon_0=-99.9999999999999 +lat_1=27.49999999999997 +lat_2=34.999999999999964 +x_0=1500000.0000000002 +y_0=6000000.000000001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            10482: 1,
            10483: 1,
            10484: 1,
            10485: 1,
            10486: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10487: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10488: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10497: { p: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10498: {
              p: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
              x: 1,
              y: 1,
              z: 1
            },
            10499: { p: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10500: { p: "+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            10507: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            10516: "+proj=tmerc +lat_0=44.25333532222222 +lon_0=-90.84429651388888 +k_0=1.0000353 +x_0=27000.000000000004 +y_0=24999.9998983998 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            10731: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10732: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            10733: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            11114: "+proj=tmerc +lat_0=4.596203222222222 +lon_0=-80.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            11115: "+proj=tmerc +lat_0=4.596203222222222 +lon_0=-77.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            11116: "+proj=tmerc +lat_0=4.596203222222222 +lon_0=-74.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            11117: "+proj=tmerc +lat_0=4.596203222222222 +lon_0=-71.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            11118: "+proj=tmerc +lat_0=4.596203222222222 +lon_0=-68.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            2e4: 1,
            20001: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            20002: "+proj=tmerc +lat_0=53.35 +lon_0=-2.55 +k_0=1 +x_0=171975.9382 +y_0=116744.6938 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            20003: { p: "+proj=tmerc +lat_0=53.35 +lon_0=-2.55 +k_0=1 +x_0=171975.9382 +y_0=116744.6938 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en", x: 1, y: 1, z: 1 },
            20004: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20005: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20006: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20007: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20008: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20009: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20010: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=10500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20011: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=11500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20012: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=12500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20013: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20014: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20015: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20016: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20017: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20018: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20019: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20020: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20021: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20022: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20023: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20024: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=24500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20025: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=25500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20026: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=26500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20027: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=27500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20028: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=28500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20029: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=29500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20030: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=30500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20031: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=31500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20032: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=32500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20033: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1 },
            20034: 1,
            20035: 1,
            20036: 1,
            20037: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            20038: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            20039: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            20040: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            20041: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            20042: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            20043: { p: "+proj=longlat +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne", x: 1, y: 1, z: 1 },
            20044: "+proj=geocent +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            20045: { p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=neu", x: 1, y: 1, z: 1 },
            20046: {
              p: "+proj=longlat +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
              x: 1,
              y: 1
            },
            20047: "+proj=tmerc +lat_0=-27.99999999999997 +lon_0=152.99999999999986 +k_0=0.99999 +x_0=150000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            20048: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            20049: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            20050: "+proj=omerc +lat_0=40.833333333333336 +lonc=-74 +alpha=58 +gamma=58 +k_0=0.99999 +x_0=457200 +y_0=457200 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048",
            20062: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1.000000 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
            20063: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1.000000 +x_0=500000 +y_0=0 +ellps=krass +units=m +no_defs",
            20064: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20065: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20066: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20067: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20068: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20069: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20070: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20071: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20072: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20073: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20074: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20075: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20076: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20077: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20078: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20079: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20080: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20081: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20082: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20083: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20084: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20085: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20086: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20087: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20088: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20089: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20090: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20091: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20092: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            20135: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-162,-12,206 +axis=en",
            20136: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-162,-12,206 +axis=en",
            20137: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-162,-12,206 +axis=en",
            20138: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-162,-12,206 +axis=en",
            20248: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20249: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20250: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20251: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20252: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20253: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20254: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20255: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20256: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20257: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20258: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148 +axis=en",
            20348: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20349: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20350: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20351: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20352: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20353: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20354: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20355: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20356: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20357: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20358: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149 +axis=en",
            20436: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20437: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20438: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20439: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20440: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20499: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20538: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-43,-163,45 +axis=en",
            20539: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-43,-163,45 +axis=en",
            20790: "+proj=tmerc +lat_0=39.666666666666664 +lon_0=1 +k_0=1 +x_0=200000 +y_0=300000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=-9.131906111111112 +axis=en",
            20791: "+proj=tmerc +lat_0=39.666666666666664 +lon_0=1 +k_0=1 +x_0=0 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=-9.131906111111112 +axis=en",
            20822: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20823: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20824: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            20904: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20905: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=5500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20906: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=6500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20907: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=7500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20908: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=8500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20909: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=9500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20910: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=10500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20911: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=11500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20912: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=12500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20913: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20914: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20915: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20916: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20917: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20918: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20919: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20920: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20921: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20922: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20923: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20924: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=24500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20925: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=25500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20926: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=26500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20927: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=27500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20928: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=28500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20929: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=29500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20930: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=30500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20931: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=31500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20932: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=32500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            20934: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-143,-90,-294 +axis=en",
            20935: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-143,-90,-294 +axis=en",
            20936: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-143,-90,-294 +axis=en",
            21004: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21005: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21006: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21007: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21008: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21009: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21010: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21011: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21012: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21013: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21014: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21015: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21016: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21017: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21018: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21019: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21020: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21021: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21022: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21023: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21024: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21025: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21026: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21027: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21028: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21029: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21030: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21031: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21032: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21035: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300 +axis=en",
            21036: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300 +axis=en",
            21037: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300 +axis=en",
            21095: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300 +axis=en",
            21096: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300 +axis=en",
            21097: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300 +axis=en",
            21100: "+proj=merc +lat_0=0 +lon_0=109.99999999999989 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +towgs84=-377,681,-50 +axis=en",
            21148: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            21149: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            21150: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            21207: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21208: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21209: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21210: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21211: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21212: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21213: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21214: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=14250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21215: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=15250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21216: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=16250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21217: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=17250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21218: "+proj=tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=18250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21219: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=19250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21220: "+proj=tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=20250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21221: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=21250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21222: "+proj=tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=22250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21223: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=23250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21224: "+proj=tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=24250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21225: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21226: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21227: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21228: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21229: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21230: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21231: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21232: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21233: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21234: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21235: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21236: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21237: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21238: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21239: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21240: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21241: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21242: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21243: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21244: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21245: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21246: "+proj=tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=46250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21247: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=47250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21248: "+proj=tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=48250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21249: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=49250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21250: "+proj=tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=50250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21251: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=51250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21252: "+proj=tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=52250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21253: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=53250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21254: "+proj=tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=54250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21255: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=55250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21256: "+proj=tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=56250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21257: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=57250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21258: "+proj=tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=58250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21259: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=59250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21260: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21261: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=61250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21262: "+proj=tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=62250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21263: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=63250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21264: "+proj=tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=64250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21291: "+proj=tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            21292: "+proj=tmerc +lat_0=13.176388888888889 +lon_0=-59.55972222222222 +k_0=0.9999986 +x_0=30000 +y_0=75000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            21307: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21308: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21309: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21310: "+proj=tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21311: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21312: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21313: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21314: "+proj=tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21315: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21316: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21317: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21318: "+proj=tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21319: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21320: "+proj=tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21321: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21322: "+proj=tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21323: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21324: "+proj=tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21325: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21326: "+proj=tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21327: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21328: "+proj=tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21329: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21330: "+proj=tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21331: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21332: "+proj=tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21333: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21334: "+proj=tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21335: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21336: "+proj=tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21337: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21338: "+proj=tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21339: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21340: "+proj=tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21341: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21342: "+proj=tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21343: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21344: "+proj=tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21345: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21346: "+proj=tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21347: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21348: "+proj=tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21349: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21350: "+proj=tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21351: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21352: "+proj=tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21353: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21354: "+proj=tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21355: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21356: "+proj=tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21357: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21358: "+proj=tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21359: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21360: "+proj=tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21361: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21362: "+proj=tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21363: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21364: "+proj=tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=250000 +y_0=0 +ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0 +axis=ne",
            21413: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21414: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21415: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21416: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21417: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21418: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21419: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21420: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21421: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21422: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21423: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21453: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21454: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21455: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21456: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21457: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21458: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21459: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21460: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21461: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21462: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21463: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21473: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21474: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21475: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21476: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21477: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21478: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21479: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21480: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21481: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21482: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21483: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2 +axis=ne",
            21500: "+proj=lcc +lat_0=90 +lon_0=0 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=150000 +y_0=5400000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=4.3679749999999995 +axis=en",
            21780: "+proj=omerc +lat_0=46.95240555555556 +lonc=0 +alpha=90 +gamma=90 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=7.439583333333333 +axis=en",
            21781: "+proj=omerc +lat_0=46.95240555555556 +lonc=7.439583333333333 +alpha=90 +gamma=90 +k_0=1 +x_0=600000 +y_0=200000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            21782: "+proj=omerc +lat_0=46.95240555555556 +lonc=7.439583333333333 +alpha=90 +gamma=90 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            21817: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=en",
            21818: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=en",
            21891: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-77.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=en",
            21892: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-74.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=en",
            21893: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-71.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=en",
            21894: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-68.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=en",
            21896: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-77.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=ne",
            21897: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-74.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=ne",
            21898: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-71.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=ne",
            21899: "+proj=tmerc +lat_0=4.599047222222222 +lon_0=-68.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318 +axis=ne",
            22032: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            22033: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            22091: "+proj=tmerc +lat_0=0 +lon_0=11.5 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            22092: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            22171: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +k_0=1 +x_0=1500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22172: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22173: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +k_0=1 +x_0=3500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22174: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-62.999999999999936 +k_0=1 +x_0=4500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22175: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-59.99999999999994 +k_0=1 +x_0=5500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22176: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-56.99999999999994 +k_0=1 +x_0=6500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22177: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +k_0=1 +x_0=7500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22181: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +k_0=1 +x_0=1500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            22182: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            22183: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +k_0=1 +x_0=3500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            22184: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-62.999999999999936 +k_0=1 +x_0=4500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            22185: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-59.99999999999994 +k_0=1 +x_0=5500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            22186: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-56.99999999999994 +k_0=1 +x_0=6500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            22187: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +k_0=1 +x_0=7500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            22191: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +k_0=1 +x_0=1500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne",
            22192: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne",
            22193: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +k_0=1 +x_0=3500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne",
            22194: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-62.999999999999936 +k_0=1 +x_0=4500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne",
            22195: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-59.99999999999994 +k_0=1 +x_0=5500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne",
            22196: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-56.99999999999994 +k_0=1 +x_0=6500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne",
            22197: "+proj=tmerc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +k_0=1 +x_0=7500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90 +axis=ne",
            22207: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22208: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22209: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22210: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22211: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22212: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22213: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22214: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22215: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22216: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22217: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22218: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22219: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22220: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22221: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22222: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22229: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22230: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22231: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22232: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22234: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=en",
            22235: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=en",
            22236: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=en",
            22239: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22240: "+proj=sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=2500000 +y_0=7500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            22243: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22244: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22245: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22246: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22247: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22248: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22249: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22250: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22262: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22263: "+proj=tmerc +lat_0=0 +lon_0=-113.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22264: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22265: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22275: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=14.999999999999986 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22277: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=16.999999999999982 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22279: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=18.999999999999982 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22281: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=20.99999999999998 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22283: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=22.99999999999998 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22285: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=24.999999999999975 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22287: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=26.99999999999997 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22289: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=28.99999999999997 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22291: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=30.999999999999968 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22293: "+proj=tmerc +k_0=1 +lat_0=0 +lon_0=32.999999999999964 +x_0=0 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292 +axis=ws",
            22307: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22308: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22309: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22310: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22311: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22312: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22313: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22314: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22315: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22316: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22317: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22318: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22319: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22320: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22321: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22322: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22332: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-263,6,431 +axis=en",
            22337: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=15500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22338: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=14500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22348: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22349: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22350: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22351: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22352: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22353: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22354: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22355: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22356: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22357: "+proj=tmerc +lat_0=0 +lon_0=-95.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22391: "+proj=lcc +lat_0=35.999999999999964 +lon_0=9.89999999999999 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-263,6,431 +axis=en",
            22392: "+proj=lcc +lat_0=33.29999999999997 +lon_0=9.89999999999999 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-263,6,431 +axis=en",
            22407: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22408: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22409: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22410: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22411: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22412: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22413: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22414: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22415: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22416: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22417: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22418: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22419: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22420: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22421: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22422: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22462: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22463: "+proj=tmerc +lat_0=0 +lon_0=-113.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22464: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22465: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22521: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            22522: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            22523: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            22524: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            22525: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6 +axis=en",
            22607: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22608: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22609: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22610: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22611: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22612: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22613: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22614: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22615: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22616: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22617: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22618: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22619: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22620: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22621: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22622: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22639: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22641: "+proj=tmerc +lat_0=0 +lon_0=-52.99999999999995 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22642: "+proj=tmerc +lat_0=0 +lon_0=-55.99999999999994 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22643: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22644: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22645: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22646: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22648: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22649: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22650: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22651: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22652: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22653: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22654: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22655: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22656: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22657: "+proj=tmerc +lat_0=0 +lon_0=-95.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22700: "+proj=lcc +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            22707: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22708: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22709: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22710: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22711: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22712: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22713: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22714: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22715: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22716: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22717: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22718: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22719: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22720: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22721: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22722: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22739: "+proj=sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=400000 +y_0=800000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22762: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22763: "+proj=tmerc +lat_0=0 +lon_0=-113.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22764: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22765: "+proj=tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22770: "+proj=lcc +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            22780: "+proj=sterea +lat_0=34.19999999999997 +lon_0=39.14999999999996 +k_0=0.9995341 +x_0=0 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            22807: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22808: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22809: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22810: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22811: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22812: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22813: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22814: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22815: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22816: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22817: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22818: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22819: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22820: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22821: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22822: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            22832: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            22991: "+proj=tmerc +lat_0=29.99999999999997 +lon_0=34.999999999999964 +k_0=1 +x_0=300000 +y_0=1100000 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            22992: "+proj=tmerc +lat_0=29.99999999999997 +lon_0=30.999999999999968 +k_0=1 +x_0=615000 +y_0=810000 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            22993: "+proj=tmerc +lat_0=29.99999999999997 +lon_0=26.99999999999997 +k_0=1 +x_0=700000 +y_0=200000 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            22994: "+proj=tmerc +lat_0=29.99999999999997 +lon_0=26.99999999999997 +k_0=1 +x_0=700000 +y_0=1200000 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            23028: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23029: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23030: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23031: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23032: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23033: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23034: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23035: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23036: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23037: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23038: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23090: "+proj=tmerc +lat_0=0 +lon_0=0 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23095: "+proj=tmerc +lat_0=0 +lon_0=4.999999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121 +axis=en",
            23239: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            23240: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            23301: "+proj=lcc +lat_0=42.2 +lon_0=-89.95 +k_0=1.000029 +x_0=549860.2997205995 +y_0=230124.4602489205 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23302: "+proj=tmerc +lat_0=41.25 +lon_0=-89.25 +k_0=1.000029 +x_0=860147.3202946407 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23303: "+proj=tmerc +lat_0=41.25 +lon_0=-88.5 +k_0=1.00003 +x_0=1150012.7000254001 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23304: "+proj=tmerc +lat_0=41.25 +lon_0=-87.8 +k_0=1.000023 +x_0=1449936.499873 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23305: "+proj=lcc +lat_0=41.55 +lon_0=-90.6 +k_0=1.000024 +x_0=1749860.2997205995 +y_0=230124.4602489205 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23306: "+proj=lcc +lat_0=41.55 +lon_0=-90.05 +k_0=1.00002 +x_0=2050088.9001778006 +y_0=230124.4602489205 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23307: "+proj=lcc +lat_0=41.3 +lon_0=-89.05 +k_0=1.000023 +x_0=2360071.1201422405 +y_0=230124.4602489205 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23308: "+proj=tmerc +lat_0=40.55 +lon_0=-88 +k_0=1.000022 +x_0=2649936.499873 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23309: "+proj=tmerc +lat_0=40.2 +lon_0=-90.85 +k_0=1.000024 +x_0=2949860.2997206 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23310: "+proj=tmerc +lat_0=37.25 +lon_0=-90.1 +k_0=1.000023 +x_0=70104.14020828043 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23311: "+proj=tmerc +lat_0=37.4 +lon_0=-89.65 +k_0=1.000023 +x_0=420015.24003048014 +y_0=189585.97917195837 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23312: "+proj=tmerc +lat_0=37.45 +lon_0=-89.3 +k_0=1.000025 +x_0=840030.4800609603 +y_0=130149.86029972062 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23313: "+proj=lcc +lat_0=40.5 +lon_0=-88.85 +k_0=1.000031 +x_0=1150012.7000254001 +y_0=530048.2600965203 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23314: "+proj=lcc +lat_0=40.9 +lon_0=-88.55 +k_0=1.000025 +x_0=1449936.499873 +y_0=530048.2600965203 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23315: "+proj=lcc +lat_0=40.75 +lon_0=-87.95 +k_0=1.000024 +x_0=1749860.2997205995 +y_0=530048.2600965203 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23316: "+proj=tmerc +lat_0=36.75 +lon_0=-91.25 +k_0=1.000023 +x_0=2050088.9001778006 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23317: "+proj=tmerc +lat_0=36.8 +lon_0=-90.6 +k_0=1.000024 +x_0=2350012.7000254 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23318: "+proj=lcc +lat_0=40.15 +lon_0=-89.8 +k_0=1.000018 +x_0=2670053.3401066805 +y_0=530048.2600965203 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23319: "+proj=tmerc +lat_0=36.3 +lon_0=-88.8 +k_0=1.000024 +x_0=2949860.2997206 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23320: "+proj=lcc +lat_0=40.15 +lon_0=-88 +k_0=1.000026 +x_0=99974.59994919991 +y_0=860147.3202946407 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23321: "+proj=lcc +lat_0=39.65 +lon_0=-90.6 +k_0=1.000023 +x_0=380086.3601727204 +y_0=860147.3202946407 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23322: "+proj=lcc +lat_0=39.75 +lon_0=-89.65 +k_0=1.000022 +x_0=709880.6197612396 +y_0=879959.35991872 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23323: "+proj=lcc +lat_0=39.65 +lon_0=-88 +k_0=1.000024 +x_0=1150012.7000254001 +y_0=840030.4800609603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23324: "+proj=tmerc +lat_0=32.85 +lon_0=-90.5 +k_0=1.000019 +x_0=1449936.499873 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23325: "+proj=lcc +lat_0=39.3 +lon_0=-90.15 +k_0=1.00002 +x_0=1749860.2997205995 +y_0=840030.4800609603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23326: "+proj=tmerc +lat_0=33.15 +lon_0=-89.4 +k_0=1.000023 +x_0=2050088.9001778006 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23327: "+proj=lcc +lat_0=38.95 +lon_0=-89 +k_0=1.000019 +x_0=2350012.7000254 +y_0=840030.4800609603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23328: "+proj=lcc +lat_0=39.1 +lon_0=-88 +k_0=1.000017 +x_0=2649936.499873 +y_0=840030.4800609603 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23329: "+proj=tmerc +lat_0=32.35 +lon_0=-90 +k_0=1.000016 +x_0=2949860.2997206 +y_0=149961.89992379988 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23330: "+proj=lcc +lat_0=38.45 +lon_0=-89.15 +k_0=1.000015 +x_0=99974.59994919991 +y_0=1150012.7000254001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23331: "+proj=lcc +lat_0=38.55 +lon_0=-88.15 +k_0=1.000013 +x_0=380086.3601727204 +y_0=1150012.7000254001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23332: "+proj=lcc +lat_0=37.9 +lon_0=-88.95 +k_0=1.000012 +x_0=729997.4599949201 +y_0=1150012.7000254001 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23333: "+proj=lcc +lat_0=37.2 +lon_0=-88.9 +k_0=1.00001 +x_0=1110083.8201676405 +y_0=1170129.5402590807 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=ne +to_meter=0.3048006096",
            23433: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            23700: "+proj=omerc +lat_0=47.14439372222222 +lonc=19.04857177777778 +alpha=90 +gamma=90 +k_0=0.99993 +x_0=650000 +y_0=200000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            23830: "+proj=tmerc +lat_0=0 +lon_0=94.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23831: "+proj=tmerc +lat_0=0 +lon_0=97.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23832: "+proj=tmerc +lat_0=0 +lon_0=100.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23833: "+proj=tmerc +lat_0=0 +lon_0=103.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23834: "+proj=tmerc +lat_0=0 +lon_0=106.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23835: "+proj=tmerc +lat_0=0 +lon_0=109.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23836: "+proj=tmerc +lat_0=0 +lon_0=112.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23837: "+proj=tmerc +lat_0=0 +lon_0=115.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23838: "+proj=tmerc +lat_0=0 +lon_0=118.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23839: "+proj=tmerc +lat_0=0 +lon_0=121.49999999999987 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23840: "+proj=tmerc +lat_0=0 +lon_0=124.49999999999987 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23841: "+proj=tmerc +lat_0=0 +lon_0=127.49999999999987 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23842: "+proj=tmerc +lat_0=0 +lon_0=130.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23843: "+proj=tmerc +lat_0=0 +lon_0=133.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23844: "+proj=tmerc +lat_0=0 +lon_0=136.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23845: "+proj=tmerc +lat_0=0 +lon_0=139.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23846: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23847: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23848: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23849: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23850: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23851: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23852: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23853: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23866: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23867: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23868: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23869: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23870: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23871: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23872: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23877: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23878: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23879: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23880: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23881: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23882: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23883: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23884: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            23886: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23887: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23888: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23889: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23890: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23891: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23892: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23893: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23894: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5 +axis=en",
            23946: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=217,823,299 +axis=en",
            23947: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=217,823,299 +axis=en",
            23948: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=217,823,299 +axis=en",
            24047: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=210,814,289 +axis=en",
            24048: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=210,814,289 +axis=en",
            24100: "+proj=lcc +lat_0=17.999999999999982 +lon_0=-76.99999999999993 +k_0=1 +x_0=167638.49597000002 +y_0=121918.90616000001 +ellps=clrk80 +a=6378249.144808011 +b=6356514.966204134 +pm=0 +axis=en +to_meter=0.3047972654",
            24200: "+proj=lcc +lat_0=17.999999999999982 +lon_0=-76.99999999999993 +k_0=1 +x_0=250000 +y_0=150000 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            24305: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=en",
            24306: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=en",
            24311: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0 +axis=en",
            24312: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0 +axis=en",
            24313: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0 +axis=en",
            24342: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24343: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24344: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24345: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24346: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24347: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24370: "+proj=lcc +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.7391685303 +y_0=2368292.194628102 +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=en +to_meter=0.3047995",
            24371: "+proj=lcc +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=en +to_meter=0.3047995",
            24372: "+proj=lcc +lat_0=25.999999999999975 +lon_0=73.99999999999993 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=en +to_meter=0.3047995",
            24373: "+proj=lcc +lat_0=18.999999999999982 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=en +to_meter=0.3047995",
            24374: "+proj=lcc +lat_0=11.999999999999988 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=en +to_meter=0.3047995",
            24375: "+proj=lcc +lat_0=25.999999999999975 +lon_0=89.99999999999991 +k_0=0.99878641 +x_0=2743185.69 +y_0=914395.23 +ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +axis=en",
            24376: "+proj=lcc +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0 +axis=en",
            24377: "+proj=lcc +lat_0=25.999999999999975 +lon_0=73.99999999999993 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8 +ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0 +axis=en",
            24378: "+proj=lcc +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24379: "+proj=lcc +lat_0=25.999999999999975 +lon_0=73.99999999999993 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24380: "+proj=lcc +lat_0=25.999999999999975 +lon_0=89.99999999999991 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24381: "+proj=lcc +lat_0=18.999999999999982 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24382: "+proj=lcc +lat_0=25.999999999999975 +lon_0=89.99999999999991 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407 +a=6377299.36559538 +b=6356098.359005156 +pm=0 +axis=en +to_meter=0.3047995",
            24383: "+proj=lcc +lat_0=11.999999999999988 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5 +ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0 +axis=en",
            24500: "+proj=cass +lat_0=1.2876466666666666 +lon_0=103.85300222222222 +x_0=30000 +y_0=30000 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            24547: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            24548: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en",
            24571: "+proj=omerc +x_0=804671.2997750349 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579049999997 +gamma=323.13010236111114 +k_0=0.99984 +ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0 +axis=en +to_meter=20.116765121552632",
            24600: "+proj=lcc +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            24718: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24719: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24720: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24721: "+proj=utm +zone=21 +ellps=intl +units=m +no_defs",
            24817: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24818: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24819: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24820: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24821: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24877: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24878: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24879: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24880: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24881: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24882: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24891: "+proj=tmerc +lat_0=-6 +lon_0=-80.5 +k_0=0.99983008 +x_0=222000 +y_0=1426834.743 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24892: "+proj=tmerc +lat_0=-9.5 +lon_0=-76 +k_0=0.99932994 +x_0=720000 +y_0=1039979.159 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            24893: "+proj=tmerc +lat_0=-9.5 +lon_0=-70.5 +k_0=0.99952992 +x_0=1324000 +y_0=1040084.558 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            25e3: "+proj=tmerc +lat_0=4.666666666666667 +lon_0=-1 +k_0=0.99975 +x_0=274319.51 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-130,29,364 +axis=en",
            25231: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            25391: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-133,-77,-51 +axis=en",
            25392: "+proj=tmerc +lat_0=0 +lon_0=118.99999999999989 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-133,-77,-51 +axis=en",
            25393: "+proj=tmerc +lat_0=0 +lon_0=120.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-133,-77,-51 +axis=en",
            25394: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-133,-77,-51 +axis=en",
            25395: "+proj=tmerc +lat_0=0 +lon_0=124.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-133,-77,-51 +axis=en",
            25700: "+proj=merc +lat_0=0 +lon_0=109.99999999999989 +k_0=0.997 +x_0=3900000 +y_0=900000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +axis=en",
            25828: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25829: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25830: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25831: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25832: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25833: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25834: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25835: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25836: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25837: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25838: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            25884: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=ne",
            25932: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            26191: "+proj=lcc +lat_0=33.29999999999997 +lon_0=-5.399999999999995 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=31,146,47 +axis=en",
            26192: "+proj=lcc +lat_0=29.69999999999997 +lon_0=-5.399999999999995 +k_0=0.999615596 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=31,146,47 +axis=en",
            26193: "+proj=lcc +lat_0=26.099999999999977 +lon_0=-5.399999999999995 +k_0=0.9996 +x_0=1200000 +y_0=400000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=31,146,47 +axis=en",
            26194: "+proj=lcc +lat_0=26.099999999999977 +lon_0=-5.399999999999995 +k_0=0.999616304 +x_0=1200000 +y_0=400000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=31,146,47 +axis=en",
            26195: "+proj=lcc +lat_0=22.49999999999998 +lon_0=-5.399999999999995 +k_0=0.999616437 +x_0=1500000 +y_0=400000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=31,146,47 +axis=en",
            26237: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=639,405,60 +axis=en",
            26331: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-92,-93,122 +axis=en",
            26332: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-92,-93,122 +axis=en",
            26391: "+proj=tmerc +lat_0=4 +lon_0=4.5 +k_0=0.99975 +x_0=230738.26 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-92,-93,122 +axis=en",
            26392: "+proj=tmerc +lat_0=4 +lon_0=8.5 +k_0=0.99975 +x_0=670553.98 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-92,-93,122 +axis=en",
            26393: "+proj=tmerc +lat_0=4 +lon_0=12.5 +k_0=0.99975 +x_0=1110369.7 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-92,-93,122 +axis=en",
            26432: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            26591: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=1500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=12.452333333333332 +towgs84=-225,-65,9 +axis=en",
            26592: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=2520000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=12.452333333333332 +towgs84=-225,-65,9 +axis=en",
            26632: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-74,-130,42 +axis=en",
            26692: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-74,-130,42 +axis=en",
            26701: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26702: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26703: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26704: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26705: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26706: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26707: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26708: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26709: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26710: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26711: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26712: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26713: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26714: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26715: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26716: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26717: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26718: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26719: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26720: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26721: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26722: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            26729: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26730: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26731: "+proj=omerc +x_0=5000000.001016003 +y_0=-5000000.001016003 +lat_0=57 +lonc=-133.66666666666666 +alpha=323.13010236111114 +gamma=323.13010236111114 +k_0=0.9999 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26732: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-141.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26733: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-145.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26734: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-149.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26735: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-153.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26736: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-157.99999999999983 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26737: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-161.99999999999983 +k_0=0.9999 +x_0=213360.42672085346 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26738: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-165.99999999999983 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26739: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-169.99999999999983 +k_0=0.9999 +x_0=182880.36576073154 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26740: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.833333333333336 +lat_2=51.833333333333336 +x_0=914401.8288036577 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26741: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26742: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26743: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26744: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26745: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26746: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26747: "+proj=lcc +lat_0=34.13333333333333 +lon_0=-118.33333333333333 +lat_1=34.416666666666664 +lat_2=33.86666666666667 +x_0=1276106.4505969014 +y_0=127079.52451104904 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26748: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26749: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26750: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26751: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26752: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26753: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=39.71666666666667 +lat_2=40.78333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26754: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26755: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26756: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=182880.36576073154 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26757: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26758: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26759: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26760: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26761: "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999967 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26762: "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999967 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26763: "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.999990 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26764: "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.999990 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26765: "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1.000000 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26766: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26767: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26768: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26769: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26770: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26771: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26772: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26773: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26774: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26775: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26776: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26777: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26778: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26779: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26780: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=36.733333333333334 +lat_2=37.93333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26781: "+proj=lcc +lat_0=30.666666666666668 +lon_0=-92.5 +lat_1=31.166666666666668 +lat_2=32.666666666666664 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26782: "+proj=lcc +lat_0=28.666666666666668 +lon_0=-91.33333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26783: "+proj=tmerc +lat_0=43.833333333333336 +lon_0=-68.5 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26784: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26785: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=243840.4876809754 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26786: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.71666666666667 +lat_2=42.68333333333333 +x_0=182880.36576073154 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26787: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.28333333333333 +lat_2=41.483333333333334 +x_0=60960.12192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26788: "+proj=lcc +lat_1=45.48333333333333 +lat_2=47.08333333333334 +lat_0=44.78333333333333 +lon_0=-87 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26789: "+proj=lcc +lat_1=44.18333333333333 +lat_2=45.7 +lat_0=43.31666666666667 +lon_0=-84.33333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26790: "+proj=lcc +lat_1=42.1 +lat_2=43.66666666666666 +lat_0=41.5 +lon_0=-84.33333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            26791: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.03333333333333 +lat_2=48.63333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26792: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.61666666666667 +lat_2=47.05 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26793: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=43.78333333333333 +lat_2=45.21666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26794: "+proj=tmerc +lat_0=29.666666666666668 +lon_0=-88.83333333333333 +k_0=0.99996 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26795: "+proj=tmerc +lat_0=30.5 +lon_0=-90.33333333333333 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26796: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26797: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26798: "+proj=tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26799: "+proj=lcc +lat_0=34.13333333333333 +lon_0=-118.33333333333333 +lat_1=34.416666666666664 +lat_2=33.86666666666667 +x_0=1276106.4505969014 +y_0=1268253.006858014 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            26801: "+proj=tmerc +lat_0=41.5 +lon_0=-83.66666666666667 +k_0=0.999942857 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176 +axis=en +to_meter=0.3048006096",
            26802: "+proj=tmerc +lat_0=41.5 +lon_0=-85.75 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176 +axis=en +to_meter=0.3048006096",
            26803: "+proj=tmerc +lat_0=41.5 +lon_0=-88.75 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176 +axis=en +to_meter=0.3048006096",
            26811: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=45.483333333333334 +lat_2=47.083333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176 +axis=en +to_meter=0.3048006096",
            26812: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.33333333333333 +lat_1=44.18333333333333 +lat_2=45.7 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176 +axis=en +to_meter=0.3048006096",
            26813: "+proj=lcc +lat_0=41.5 +lon_0=-84.33333333333333 +lat_1=42.1 +lat_2=43.666666666666664 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176 +axis=en +to_meter=0.3048006096",
            26814: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26815: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26819: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26820: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26821: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26822: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26823: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=1968500 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26824: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=1968500 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26825: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26826: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26830: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26831: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26832: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26833: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26834: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=1968500 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26835: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=1968500 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26836: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26837: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26841: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26842: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26843: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26844: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26845: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=1968500 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26846: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=1968500 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26847: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26848: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26849: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26850: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26851: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26852: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26853: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26854: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            26855: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26856: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26857: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26858: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26859: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26860: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26861: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26862: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26863: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26864: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26865: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26866: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26867: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26868: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26869: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26870: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en +to_meter=0.3048006096",
            26891: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26892: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26893: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26894: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26895: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26896: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26897: "+proj=tmerc +lat_0=0 +lon_0=-95.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26898: "+proj=tmerc +lat_0=0 +lon_0=-52.99999999999995 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26899: "+proj=tmerc +lat_0=0 +lon_0=-55.99999999999994 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0 +axis=en",
            26901: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26902: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26903: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26904: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26905: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26906: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26907: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26908: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26909: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26910: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26911: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26912: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26913: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26914: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26915: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26916: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26917: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26918: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26919: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26920: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26921: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26922: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26923: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26929: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26930: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26931: "+proj=omerc +x_0=5000000 +y_0=-5000000 +lat_0=57 +lonc=-133.66666666666666 +alpha=323.13010236111114 +gamma=323.13010236111114 +k_0=0.9999 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26932: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-141.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26933: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-145.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26934: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-149.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26935: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-153.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26936: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-157.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26937: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-161.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26938: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-165.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26939: "+proj=tmerc +lat_0=53.99999999999994 +lon_0=-169.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26940: "+proj=lcc +lat_0=51 +lon_0=-176 +lat_1=53.833333333333336 +lat_2=51.833333333333336 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26941: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26942: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26943: "+proj=lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26944: "+proj=lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26945: "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26946: "+proj=lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26948: "+proj=tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26949: "+proj=tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26950: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26951: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26952: "+proj=lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26953: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26954: "+proj=lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26955: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26956: "+proj=lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26957: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26958: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26959: "+proj=tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26960: "+proj=lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26961: "+proj=tmerc +lat_0=18.833333333333332 +lon_0=-155.5 +k_0=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26962: "+proj=tmerc +lat_0=20.333333333333332 +lon_0=-156.66666666666666 +k_0=0.999966667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26963: "+proj=tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26964: "+proj=tmerc +lat_0=21.833333333333332 +lon_0=-159.5 +k_0=0.99999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26965: "+proj=tmerc +lat_0=21.666666666666668 +lon_0=-160.16666666666666 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26966: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26967: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26968: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26969: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26970: "+proj=tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26971: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26972: "+proj=tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26973: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=100000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26974: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000 +y_0=250000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26975: "+proj=lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26976: "+proj=lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26977: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26978: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=400000 +y_0=400000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26979: "+proj=lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=37.96666666666667 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26980: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000 +y_0=500000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26981: "+proj=lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26982: "+proj=lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26983: "+proj=tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26984: "+proj=tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26985: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26986: "+proj=lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000 +y_0=750000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26987: "+proj=lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26988: "+proj=lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=8000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26989: "+proj=lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=6000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26990: "+proj=lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=4000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26991: "+proj=lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26992: "+proj=lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26993: "+proj=lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26994: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26995: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=700000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26996: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26997: "+proj=tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            26998: "+proj=tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=850000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            27037: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            27038: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            27039: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            27040: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +axis=en",
            27120: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-2,374,172 +axis=en",
            27200: "+proj=nzmg +lat_0=-40.99999999999996 +lon_0=172.99999999999983 +x_0=2510000 +y_0=6023150 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=en",
            27205: "+proj=tmerc +lat_0=-36.87986527777778 +lon_0=174.7643393611111 +k_0=0.9999 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27206: "+proj=tmerc +lat_0=-37.76124980555556 +lon_0=176.46619725 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27207: "+proj=tmerc +lat_0=-38.62470277777778 +lon_0=177.88563627777776 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27208: "+proj=tmerc +lat_0=-39.65092930555556 +lon_0=176.67368052777778 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27209: "+proj=tmerc +lat_0=-39.135758305555555 +lon_0=174.22801175 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27210: "+proj=tmerc +lat_0=-39.512470388888886 +lon_0=175.64003680555555 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27211: "+proj=tmerc +lat_0=-40.24194713888889 +lon_0=175.4880996111111 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27212: "+proj=tmerc +lat_0=-40.92553263888889 +lon_0=175.64734966666666 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27213: "+proj=tmerc +lat_0=-41.301319638888884 +lon_0=174.77662311111112 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27214: "+proj=tmerc +lat_0=-40.71475905555556 +lon_0=172.6720465 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27215: "+proj=tmerc +lat_0=-41.274544722222224 +lon_0=173.29931680555555 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27216: "+proj=tmerc +lat_0=-41.289911527777775 +lon_0=172.10902819444445 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27217: "+proj=tmerc +lat_0=-41.81080286111111 +lon_0=171.58126005555556 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27218: "+proj=tmerc +lat_0=-42.33369427777778 +lon_0=171.54977130555557 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27219: "+proj=tmerc +lat_0=-42.68911658333333 +lon_0=173.0101333888889 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27220: "+proj=tmerc +lat_0=-41.544486666666664 +lon_0=173.80207411111112 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27221: "+proj=tmerc +lat_0=-42.88632236111111 +lon_0=170.9799935 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27222: "+proj=tmerc +lat_0=-43.11012813888889 +lon_0=170.26092583333335 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27223: "+proj=tmerc +lat_0=-43.97780288888889 +lon_0=168.606267 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27224: "+proj=tmerc +lat_0=-43.59063758333333 +lon_0=172.72719358333333 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27225: "+proj=tmerc +lat_0=-43.74871155555556 +lon_0=171.3607484722222 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27226: "+proj=tmerc +lat_0=-44.40222036111111 +lon_0=171.05725083333334 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27227: "+proj=tmerc +lat_0=-44.735267972222225 +lon_0=169.46775508333334 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27228: "+proj=tmerc +lat_0=-45.13290258333333 +lon_0=168.39864119444442 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27229: "+proj=tmerc +lat_0=-45.56372616666666 +lon_0=167.73886177777777 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27230: "+proj=tmerc +lat_0=-45.81619661111111 +lon_0=170.62859516666668 +k_0=1 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27231: "+proj=tmerc +lat_0=-45.861513361111115 +lon_0=170.28258911111112 +k_0=0.99996 +x_0=300000 +y_0=700000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27232: "+proj=tmerc +lat_0=-46.60000961111111 +lon_0=168.342872 +k_0=1 +x_0=300002.66 +y_0=699999.58 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=ne",
            27258: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=en",
            27259: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=en",
            27260: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=en",
            27291: "+proj=tmerc +lat_0=-39 +lon_0=175.5 +k_0=1 +x_0=274319.5243848086 +y_0=365759.36584641144 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=en +to_meter=0.914398414616029",
            27292: "+proj=tmerc +lat_0=-44 +lon_0=171.5 +k_0=1 +x_0=457199.20730801433 +y_0=457199.20730801433 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0 +axis=en +to_meter=0.914398414616029",
            27391: "+proj=tmerc +lat_0=58 +lon_0=-4.666666666666667 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27392: "+proj=tmerc +lat_0=58 +lon_0=-2.3333333333333335 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27393: "+proj=tmerc +lat_0=58 +lon_0=0 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27394: "+proj=tmerc +lat_0=58 +lon_0=2.5 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27395: "+proj=tmerc +lat_0=58 +lon_0=6.166666666666667 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27396: "+proj=tmerc +lat_0=58 +lon_0=10.166666666666666 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27397: "+proj=tmerc +lat_0=58 +lon_0=14.166666666666666 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27398: "+proj=tmerc +lat_0=58 +lon_0=18.333333333333332 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666 +axis=ne",
            27429: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            27492: "+proj=tmerc +lat_0=39.666666666666664 +lon_0=-8.131906111111112 +k_0=1 +x_0=180.598 +y_0=-86.99 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=ne",
            27493: "+proj=tmerc +lat_0=39.666666666666664 +lon_0=-8.131906111111112 +k_0=1 +x_0=180.598 +y_0=-86.99 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            27500: "+proj=lcc +lat_0=49.49999999999995 +lon_0=5.399999999999995 +k_0=0.99950908 +x_0=500000 +y_0=300000 +ellps=plessis +a=6376523 +b=6355862.933255573 +pm=2.3372083333333333 +axis=en",
            27561: "+proj=lcc +lat_0=49.49999999999995 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27562: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27563: "+proj=lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27564: "+proj=lcc +lat_0=42.164999999999964 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27571: "+proj=lcc +lat_0=49.49999999999995 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27572: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27573: "+proj=lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27574: "+proj=lcc +lat_0=42.164999999999964 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27581: "+proj=lcc +lat_0=49.49999999999995 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27582: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27583: "+proj=lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27584: "+proj=lcc +lat_0=42.164999999999964 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27591: "+proj=lcc +lat_0=49.49999999999995 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27592: "+proj=lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27593: "+proj=lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27594: "+proj=lcc +lat_0=42.164999999999964 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +axis=en",
            27700: "+proj=tmerc +lat_0=48.99999999999995 +lon_0=-1.999999999999998 +k_0=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=en",
            28191: "+proj=cass +lat_0=31.734096944444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=126867.909 +ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0 +axis=en",
            28192: "+proj=tmerc +lat_0=31.734096944444445 +lon_0=35.21208055555556 +k_0=1 +x_0=170251.555 +y_0=1126867.909 +ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0 +axis=en",
            28193: "+proj=cass +lat_0=31.734096944444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=1126867.909 +ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0 +axis=en",
            28232: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            28348: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28349: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28350: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28351: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28352: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28353: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28354: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28355: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28356: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28357: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28358: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            28402: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=2500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28403: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=3500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28404: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28405: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=5500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28406: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=6500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28407: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=7500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28408: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=8500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28409: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=9500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28410: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=10500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28411: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=11500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28412: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=12500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28413: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28414: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28415: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28416: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28417: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28418: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28419: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28420: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28421: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28422: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28423: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28424: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=24500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28425: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=25500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28426: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=26500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28427: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=27500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28428: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=28500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28429: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=29500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28430: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=30500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28431: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=31500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28432: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=32500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28462: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28463: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28464: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28465: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28466: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28467: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28468: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28469: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28470: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28471: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28472: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28473: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28474: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28475: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28476: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28477: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28478: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28479: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28480: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28481: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28482: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28483: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28484: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28485: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28486: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28487: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28488: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28489: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28490: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28491: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28492: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1 +axis=ne",
            28600: "+proj=tmerc +lat_0=24.45 +lon_0=51.21666666666667 +k_0=0.99999 +x_0=200000 +y_0=300000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            28991: "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.3876388888888895 +k_0=0.9999079 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            28992: "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.3876388888888895 +k_0=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            29100: "+proj=poly +lat_0=0 +lon_0=-53.99999999999994 +x_0=5000000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29101: "+proj=poly +lat_0=0 +lon_0=-53.99999999999994 +x_0=5000000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29118: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29119: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29120: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29121: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29122: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29168: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29169: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29170: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29171: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29172: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29177: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29178: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29179: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29180: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29181: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29182: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29183: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29184: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29185: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +axis=en",
            29187: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29188: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29189: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29190: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29191: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29192: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29193: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29194: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29195: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41 +axis=en",
            29220: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-355,16,74 +axis=en",
            29221: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-355,16,74 +axis=en",
            29333: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=en",
            29371: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=10.99999999999999 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29373: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=12.999999999999988 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29375: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=14.999999999999986 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29377: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=16.999999999999982 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29379: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=18.999999999999982 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29381: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=20.99999999999998 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29383: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=22.99999999999998 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29385: "+proj=tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=24.999999999999975 +x_0=0 +y_0=0 +ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251 +axis=ws +to_meter=1.0000135965",
            29635: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            29636: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            29700: "+proj=omerc +lat_0=-18.89999999999998 +lonc=44.09999999999996 +alpha=18.89999999999998 +gamma=18.89999999999998 +k_0=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=2.337229169999998 +towgs84=-189,-242,-91 +axis=en",
            29701: "+proj=labrd +x_0=400000 +y_0=800000 +lat_0=-18.89999999999998 +lonc=44.09999999999996 +alpha=18.89999999999998 +k_0=0.9995 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=2.337229169999998 +towgs84=-189,-242,-91 +axis=ne",
            29702: "+proj=omerc +lat_0=-18.89999999999998 +lonc=44.09999999999996 +alpha=18.89999999999998 +gamma=18.89999999999998 +k_0=0.9995 +x_0=400000 +y_0=800000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=2.337229169999998 +towgs84=-189,-242,-91 +axis=ne",
            29738: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-189,-242,-91 +axis=en",
            29739: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-189,-242,-91 +axis=en",
            29849: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46 +axis=en",
            29850: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46 +axis=en",
            29871: "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984 +x_0=590476.8714630402 +y_0=442857.653094361 +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46 +axis=en +to_meter=20.1167651215526",
            29872: "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984 +x_0=590476.872743198 +y_0=442857.65455739846 +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46 +axis=en +to_meter=0.304799471538676",
            29873: "+proj=omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984 +x_0=590476.87 +y_0=442857.65 +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46 +axis=en",
            29874: "+proj=omerc +x_0=2000000 +y_0=5000000 +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984 +ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46 +axis=en",
            29900: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k_0=1.000035 +x_0=200000 +y_0=250000 +ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0 +axis=en",
            29901: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k_0=1 +x_0=200000 +y_0=250000 +ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0 +axis=en",
            29902: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k_0=1.000035 +x_0=200000 +y_0=250000 +ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0 +axis=en",
            29903: "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k_0=1.000035 +x_0=200000 +y_0=250000 +ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0 +towgs84=506,-122,611 +axis=en",
            30161: "+proj=tmerc +lat_0=33 +lon_0=129.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30162: "+proj=tmerc +lat_0=33 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30163: "+proj=tmerc +lat_0=36 +lon_0=132.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30164: "+proj=tmerc +lat_0=33 +lon_0=133.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30165: "+proj=tmerc +lat_0=36 +lon_0=134.33333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30166: "+proj=tmerc +lat_0=36 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30167: "+proj=tmerc +lat_0=36 +lon_0=137.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30168: "+proj=tmerc +lat_0=36 +lon_0=138.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30169: "+proj=tmerc +lat_0=36 +lon_0=139.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30170: "+proj=tmerc +lat_0=40 +lon_0=140.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30171: "+proj=tmerc +lat_0=44 +lon_0=140.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30172: "+proj=tmerc +lat_0=44 +lon_0=142.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30173: "+proj=tmerc +lat_0=44 +lon_0=144.25 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30174: "+proj=tmerc +lat_0=26 +lon_0=142 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30175: "+proj=tmerc +lat_0=26 +lon_0=127.5 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30176: "+proj=tmerc +lat_0=26 +lon_0=124 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30177: "+proj=tmerc +lat_0=26 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30178: "+proj=tmerc +lat_0=20 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30179: "+proj=tmerc +lat_0=26 +lon_0=154 +k_0=0.9999 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664 +axis=ne",
            30200: "+proj=cass +lat_0=10.441666666666666 +lon_0=-61.333333333333336 +x_0=86501.46392052 +y_0=65379.0134283 +a=6378293.645208759 +b=6356617.987679838 +pm=0 +axis=en +to_meter=0.201166195164",
            30339: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            30340: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0 +axis=en",
            30491: "+proj=lcc +lat_0=35.999999999999964 +lon_0=2.6999999999999975 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-73,-247,227 +axis=en",
            30492: "+proj=lcc +lat_0=33.29999999999997 +lon_0=2.6999999999999975 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-73,-247,227 +axis=en",
            30493: "+proj=lcc +lat_0=35.999999999999964 +lon_0=2.6999999999999975 +k_0=0.999625544 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            30494: "+proj=lcc +lat_0=33.29999999999997 +lon_0=2.6999999999999975 +k_0=0.999625769 +x_0=500000 +y_0=300000 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            30591: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500135 +y_0=300090 +ellps=clrk80 +units=m +no_defs",
            30592: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500135 +y_0=300090 +ellps=clrk80 +units=m +no_defs",
            30729: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310 +axis=en",
            30730: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310 +axis=en",
            30731: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310 +axis=en",
            30732: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310 +axis=en",
            30791: "+proj=lcc +lat_0=35.999999999999964 +lon_0=2.6999999999999975 +k_0=0.999625544 +x_0=500135 +y_0=300090 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310 +axis=en",
            30792: "+proj=lcc +lat_0=33.29999999999997 +lon_0=2.6999999999999975 +k_0=0.999625769 +x_0=500135 +y_0=300090 +ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310 +axis=en",
            30800: "+proj=tmerc +lat_0=0 +lon_0=15.808277777777779 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31028: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            31121: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-265,120,-358 +axis=en",
            31154: "+proj=tmerc +lat_0=0 +lon_0=-53.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-265,120,-358 +axis=en",
            31170: "+proj=tmerc +lat_0=0 +lon_0=-55.68333333333333 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-265,120,-358 +axis=en",
            31171: "+proj=tmerc +lat_0=0 +lon_0=-55.68333333333333 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-265,120,-358 +axis=en",
            31251: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=0 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31252: "+proj=tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=0 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31253: "+proj=tmerc +lat_0=0 +lon_0=33.999999999999964 +k_0=1 +x_0=0 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31254: "+proj=tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=0 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31255: "+proj=tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=0 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31256: "+proj=tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=0 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31257: "+proj=tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=150000 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31258: "+proj=tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=450000 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31259: "+proj=tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=750000 +y_0=-5000000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31265: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31266: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31267: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31268: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31275: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31276: "+proj=tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=6500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31277: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31278: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=7500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31279: "+proj=tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=8500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31281: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31282: "+proj=tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31283: "+proj=tmerc +lat_0=0 +lon_0=33.999999999999964 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31284: "+proj=tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=150000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31285: "+proj=tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=450000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31286: "+proj=tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=750000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31287: "+proj=lcc +lat_0=47.5 +lon_0=13.333333333333334 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31288: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=150000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31289: "+proj=tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=450000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31290: "+proj=tmerc +lat_0=0 +lon_0=33.999999999999964 +k_0=1 +x_0=750000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=ne",
            31291: "+proj=tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=en",
            31292: "+proj=tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=en",
            31293: "+proj=tmerc +lat_0=0 +lon_0=33.999999999999964 +k_0=1 +x_0=0 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668 +axis=en",
            31294: "+proj=tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=150000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31295: "+proj=tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=450000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31296: "+proj=tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=750000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31297: "+proj=lcc +lat_0=47.5 +lon_0=13.333333333333334 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31300: "+proj=lcc +lat_0=90 +lon_0=4.356939722222222 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            31370: "+proj=lcc +lat_0=90 +lon_0=4.367486666666666 +lat_1=51.16666723333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            31461: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=1 +x_0=1500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31462: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31463: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31464: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31465: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=en",
            31466: "+proj=tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31467: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31468: "+proj=tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31469: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0 +ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +axis=ne",
            31491: "+proj=tmerc +lat_0=0 +lon_0=3 +k=1.000000 +x_0=1500000 +y_0=0 +ellps=bessel +units=m +no_defs",
            31492: "+proj=tmerc +lat_0=0 +lon_0=6 +k=1.000000 +x_0=2500000 +y_0=0 +ellps=bessel +units=m +no_defs",
            31493: "+proj=tmerc +lat_0=0 +lon_0=9 +k=1.000000 +x_0=3500000 +y_0=0 +ellps=bessel +units=m +no_defs",
            31494: "+proj=tmerc +lat_0=0 +lon_0=12 +k=1.000000 +x_0=4500000 +y_0=0 +ellps=bessel +units=m +no_defs",
            31495: "+proj=tmerc +lat_0=0 +lon_0=15 +k=1.000000 +x_0=5500000 +y_0=0 +ellps=bessel +units=m +no_defs",
            31528: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            31529: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +axis=en",
            31600: "+proj=sterea +lat_0=45.9 +lon_0=25.39246588888889 +k_0=0.9996667 +x_0=500000 +y_0=500000 +ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +axis=en",
            31700: "+proj=sterea +lat_0=45.99999999999996 +lon_0=24.999999999999975 +k_0=0.99975 +x_0=500000 +y_0=500000 +ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +axis=ne",
            31838: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            31839: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            31900: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31901: "+proj=tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31965: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31966: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31967: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31968: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31969: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31970: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31971: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31972: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31973: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31974: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31975: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31976: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31977: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31978: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31979: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31980: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31981: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31982: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31983: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31984: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31985: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31986: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31987: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31988: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31989: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31990: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31991: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31992: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31993: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31994: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31995: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31996: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31997: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31998: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            31999: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32e3: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32001: "+proj=lcc +lat_0=47 +lon_0=-109.5 +lat_1=48.71666666666667 +lat_2=47.85 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32002: "+proj=lcc +lat_0=45.833333333333336 +lon_0=-109.5 +lat_1=47.88333333333333 +lat_2=46.45 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32003: "+proj=lcc +lat_0=44 +lon_0=-109.5 +lat_1=46.4 +lat_2=44.86666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32005: "+proj=lcc +lat_0=41.333333333333336 +lon_0=-100 +lat_1=41.85 +lat_2=42.81666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32006: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-99.5 +lat_1=40.28333333333333 +lat_2=41.71666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32007: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32008: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32009: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32010: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32011: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.66666666666667 +k_0=0.999975 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32012: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32013: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32014: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32015: "+proj=tmerc +lat_0=40 +lon_0=-74.33333333333333 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32016: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32017: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32018: "+proj=lcc +lat_0=40.5 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=304800.60960121924 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32019: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.333333333333336 +lat_2=36.166666666666664 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32020: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.43333333333333 +lat_2=48.733333333333334 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32021: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=46.18333333333333 +lat_2=47.483333333333334 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32022: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=40.43333333333333 +lat_2=41.7 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32023: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.733333333333334 +lat_2=40.03333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32024: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=35.56666666666667 +lat_2=36.766666666666666 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32025: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=33.93333333333333 +lat_2=35.233333333333334 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32026: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=44.333333333333336 +lat_2=46 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32027: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=42.333333333333336 +lat_2=44 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32028: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=40.88333333333333 +lat_2=41.95 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32029: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=39.93333333333333 +lat_2=40.8 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32030: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.9999938 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32031: "+proj=lcc +lat_0=33 +lon_0=-81 +lat_1=33.766666666666666 +lat_2=34.96666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32033: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=32.333333333333336 +lat_2=33.666666666666664 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32034: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=44.416666666666664 +lat_2=45.68333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32035: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=42.833333333333336 +lat_2=44.4 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32036: "+proj=lcc +lat_0=34.666666666666664 +lon_0=-86 +lat_1=35.25 +lat_2=36.416666666666664 +x_0=30480.060960121926 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32037: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.18333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32038: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-97.5 +lat_1=32.13333333333333 +lat_2=33.96666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32039: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=30.116666666666667 +lat_2=31.883333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32040: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=28.383333333333333 +lat_2=30.283333333333335 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32041: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=26.166666666666668 +lat_2=27.833333333333332 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32042: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=40.71666666666667 +lat_2=41.78333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32043: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=39.016666666666666 +lat_2=40.65 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32044: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=37.21666666666667 +lat_2=38.35 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32045: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32046: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=38.03333333333333 +lat_2=39.2 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32047: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=36.766666666666666 +lat_2=37.96666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32048: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=47.5 +lat_2=48.733333333333334 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32049: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=45.833333333333336 +lat_2=47.333333333333336 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32050: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32051: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=37.483333333333334 +lat_2=38.88333333333333 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32052: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=45.56666666666667 +lat_2=46.766666666666666 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32053: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32054: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=42.733333333333334 +lat_2=44.06666666666667 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32055: "+proj=tmerc +lat_0=40.666666666666664 +lon_0=-105.16666666666667 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32056: "+proj=tmerc +lat_0=40.666666666666664 +lon_0=-107.33333333333333 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32057: "+proj=tmerc +lat_0=40.666666666666664 +lon_0=-108.75 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32058: "+proj=tmerc +lat_0=40.666666666666664 +lon_0=-110.08333333333333 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32059: "+proj=lcc +lat_1=18.03333333333334 +lat_2=18.43333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=152400.3048006096 +y_0=0 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            32060: "+proj=lcc +lat_1=18.03333333333334 +lat_2=18.43333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=152400.3048006096 +y_0=30480.06096012193 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            32061: "+proj=lcc +lat_0=16.816666666666666 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32062: "+proj=lcc +lat_0=14.9 +lon_0=-90.33333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32064: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32065: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32066: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32067: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32074: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32075: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32076: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32077: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32081: "+proj=tmerc +lat_0=0 +lon_0=-52.99999999999995 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32082: "+proj=tmerc +lat_0=0 +lon_0=-55.99999999999994 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32083: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32084: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32085: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32086: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32098: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en",
            32099: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-91.33333333333333 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=609601.2192024385 +y_0=0 +ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +axis=en +to_meter=0.3048006096",
            32100: "+proj=lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32104: "+proj=lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32107: "+proj=tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000 +y_0=8000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32108: "+proj=tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000 +y_0=6000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32109: "+proj=tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32110: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32111: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32112: "+proj=tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32113: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32114: "+proj=tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32115: "+proj=tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32116: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=250000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32117: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32118: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32119: "+proj=lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.22 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32120: "+proj=lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32121: "+proj=lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32122: "+proj=lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32123: "+proj=lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32124: "+proj=lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32125: "+proj=lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32126: "+proj=lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32127: "+proj=lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32128: "+proj=lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32129: "+proj=lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32130: "+proj=tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=100000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32133: "+proj=lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32134: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32135: "+proj=lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32136: "+proj=lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32137: "+proj=lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32138: "+proj=lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32139: "+proj=lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=700000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32140: "+proj=lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000 +y_0=4000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32141: "+proj=lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000 +y_0=5000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32142: "+proj=lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32143: "+proj=lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32144: "+proj=lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000 +y_0=3000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32145: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32146: "+proj=lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32147: "+proj=lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32148: "+proj=lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32149: "+proj=lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32150: "+proj=lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32151: "+proj=lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32152: "+proj=lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32153: "+proj=lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32154: "+proj=lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32155: "+proj=tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32156: "+proj=tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=400000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32157: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32158: "+proj=tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000 +y_0=100000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32159: "+proj=lcc +lat_0=41 +lon_0=-107.5 +lat_1=41 +lat_2=45 +x_0=500000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32161: "+proj=lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=200000 +y_0=200000 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32164: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            32165: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            32166: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            32167: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en +to_meter=0.3048006096",
            32180: "+proj=tmerc +lat_0=0 +lon_0=-55.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32181: "+proj=tmerc +lat_0=0 +lon_0=-52.99999999999995 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32182: "+proj=tmerc +lat_0=0 +lon_0=-55.99999999999994 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32183: "+proj=tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32184: "+proj=tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32185: "+proj=tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32186: "+proj=tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32187: "+proj=tmerc +lat_0=0 +lon_0=-70.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32188: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32189: "+proj=tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32190: "+proj=tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32191: "+proj=tmerc +lat_0=0 +lon_0=-82.5 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32192: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32193: "+proj=tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32194: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32195: "+proj=tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32196: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32197: "+proj=tmerc +lat_0=0 +lon_0=-95.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32198: "+proj=lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32199: "+proj=lcc +lat_0=25.5 +lon_0=-91.33333333333333 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=1000000 +y_0=0 +ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +axis=en",
            32201: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32202: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32203: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32204: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32205: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32206: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32207: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32208: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32209: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32210: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32211: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32212: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32213: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32214: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32215: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32216: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32217: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32218: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32219: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32220: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32221: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32222: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32223: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32224: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32225: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32226: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32227: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32228: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32229: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32230: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32231: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32232: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32233: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32234: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32235: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32236: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32237: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32238: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32239: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32240: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32241: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32242: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32243: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32244: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32245: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32246: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32247: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32248: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32249: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32250: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32251: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32252: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32253: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32254: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32255: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32256: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32257: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32258: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32259: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32260: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32301: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32302: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32303: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32304: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32305: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32306: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32307: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32308: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32309: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32310: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32311: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32312: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32313: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32314: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32315: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32316: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32317: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32318: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32319: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32320: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32321: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32322: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32323: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32324: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32325: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32326: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32327: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32328: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32329: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32330: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32331: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32332: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32333: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32334: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32335: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32336: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32337: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32338: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32339: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32340: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32341: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32342: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32343: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32344: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32345: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32346: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32347: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32348: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32349: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32350: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32351: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32352: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32353: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32354: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32355: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32356: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32357: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32358: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32359: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32360: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32401: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32402: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32403: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32404: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32405: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32406: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32407: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32408: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32409: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32410: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32411: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32412: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32413: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32414: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32415: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32416: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32417: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32418: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32419: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32420: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32421: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32422: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32423: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32424: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32425: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32426: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32427: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32428: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32429: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32430: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32431: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32432: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32433: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32434: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32435: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32436: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32437: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32438: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32439: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32440: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32441: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32442: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32443: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32444: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32445: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32446: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32447: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32448: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32449: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32450: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32451: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32452: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32453: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32454: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32455: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32456: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32457: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32458: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32459: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32460: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32501: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32502: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32503: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32504: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32505: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32506: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32507: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32508: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32509: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32510: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32511: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32512: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32513: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32514: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32515: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32516: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32517: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32518: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32519: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32520: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32521: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32522: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32523: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32524: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32525: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32526: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32527: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32528: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32529: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32530: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32531: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32532: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32533: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32534: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32535: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32536: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32537: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32538: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32539: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32540: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32541: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32542: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32543: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32544: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32545: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32546: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32547: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32548: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32549: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32550: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32551: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32552: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32553: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32554: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32555: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32556: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32557: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32558: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32559: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32560: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +axis=en",
            32601: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32602: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32603: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32604: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32605: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32606: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32607: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32608: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32609: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32610: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32611: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32612: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32613: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32614: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32615: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32616: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32617: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32618: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32619: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32620: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32621: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32622: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32623: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32624: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32625: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32626: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32627: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32628: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32629: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32630: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32631: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32632: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32633: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32634: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32635: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32636: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32637: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32638: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32639: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32640: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32641: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32642: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32643: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32644: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32645: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32646: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32647: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32648: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32649: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32650: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32651: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32652: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32653: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32654: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32655: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32656: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32657: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32658: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32659: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32660: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32661: "+proj=stere +lat_0=89.99999999999991 +lon_0=0 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            32662: "+proj=eqc +ellps=WGS84 +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32663: "+proj=eqc +lat_0=0 +x_0=0 +y_0=0 +lon_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32664: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en +to_meter=0.3048006096",
            32665: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en +to_meter=0.3048006096",
            32666: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en +to_meter=0.3048006096",
            32667: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en +to_meter=0.3048006096",
            32701: "+proj=tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32702: "+proj=tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32703: "+proj=tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32704: "+proj=tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32705: "+proj=tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32706: "+proj=tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32707: "+proj=tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32708: "+proj=tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32709: "+proj=tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32710: "+proj=tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32711: "+proj=tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32712: "+proj=tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32713: "+proj=tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32714: "+proj=tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32715: "+proj=tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32716: "+proj=tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32717: "+proj=tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32718: "+proj=tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32719: "+proj=tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32720: "+proj=tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32721: "+proj=tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32722: "+proj=tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32723: "+proj=tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32724: "+proj=tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32725: "+proj=tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32726: "+proj=tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32727: "+proj=tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32728: "+proj=tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32729: "+proj=tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32730: "+proj=tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32731: "+proj=tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32732: "+proj=tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32733: "+proj=tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32734: "+proj=tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32735: "+proj=tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32736: "+proj=tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32737: "+proj=tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32738: "+proj=tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32739: "+proj=tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32740: "+proj=tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32741: "+proj=tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32742: "+proj=tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32743: "+proj=tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32744: "+proj=tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32745: "+proj=tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32746: "+proj=tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32747: "+proj=tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32748: "+proj=tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32749: "+proj=tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32750: "+proj=tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32751: "+proj=tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32752: "+proj=tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32753: "+proj=tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32754: "+proj=tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32755: "+proj=tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32756: "+proj=tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32757: "+proj=tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32758: "+proj=tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32759: "+proj=tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32760: "+proj=tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            32761: "+proj=stere +lat_0=-89.99999999999991 +lon_0=0 +k_0=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=ne",
            32766: "+proj=tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000 +ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +axis=en",
            37001: "+proj=longlat +ellps=WGS66 +no_defs",
            37002: "+proj=longlat +a=6378166 +b=6356784.283607107 +no_defs",
            37003: "+proj=longlat +a=6378150 +b=6356768.337244385 +no_defs",
            37004: "+proj=longlat +ellps=fschr60m +no_defs",
            37005: "+proj=longlat +a=6378270 +b=6356794.343434343 +no_defs",
            37006: "+proj=longlat +a=6377295.664 +b=6356094.667915204 +no_defs",
            37007: "+proj=longlat +a=6376896 +b=6355834.846687363 +no_defs",
            37008: "+proj=longlat +a=6370997 +b=6370997 +no_defs",
            37201: "+proj=longlat +ellps=intl +no_defs",
            37202: "+proj=longlat +a=6377276.345 +b=6356075.413140239 +no_defs",
            37203: "+proj=longlat +a=6377301.243 +b=6356100.230165385 +no_defs",
            37204: "+proj=longlat +ellps=intl +no_defs",
            37205: "+proj=longlat +ellps=intl +no_defs",
            37206: "+proj=longlat +ellps=clrk80 +no_defs",
            37207: "+proj=longlat +ellps=fschr60m +no_defs",
            37208: "+proj=longlat +ellps=clrk80 +no_defs",
            37211: "+proj=longlat +ellps=clrk80 +no_defs",
            37212: "+proj=longlat +ellps=intl +no_defs",
            37213: "+proj=longlat +ellps=intl +no_defs",
            37214: "+proj=longlat +ellps=intl +no_defs",
            37215: "+proj=longlat +ellps=intl +no_defs",
            37216: "+proj=longlat +ellps=intl +no_defs",
            37217: "+proj=longlat +ellps=intl +no_defs",
            37218: "+proj=longlat +ellps=intl +no_defs",
            37219: "+proj=longlat +ellps=intl +no_defs",
            37220: "+proj=longlat +ellps=clrk66 +no_defs",
            37221: "+proj=longlat +ellps=intl +no_defs",
            37222: "+proj=longlat +ellps=intl +no_defs",
            37223: "+proj=longlat +a=6378249.2 +b=6356514.999904194 +no_defs",
            37224: "+proj=longlat +ellps=intl +no_defs",
            37226: "+proj=longlat +ellps=intl +no_defs",
            37227: "+proj=longlat +ellps=intl +no_defs",
            37228: "+proj=longlat +ellps=clrk80 +no_defs",
            37229: "+proj=longlat +a=6378270 +b=6356794.343434343 +no_defs",
            37230: "+proj=longlat +ellps=intl +no_defs",
            37231: "+proj=longlat +ellps=aust_SA +no_defs",
            37232: "+proj=longlat +ellps=intl +no_defs",
            37233: "+proj=longlat +ellps=intl +no_defs",
            37234: "+proj=longlat +ellps=intl +no_defs",
            37235: "+proj=longlat +ellps=intl +no_defs",
            37237: "+proj=longlat +ellps=intl +no_defs",
            37238: "+proj=longlat +ellps=intl +no_defs",
            37239: "+proj=longlat +ellps=clrk66 +no_defs",
            37240: "+proj=longlat +ellps=clrk80 +no_defs",
            37241: "+proj=longlat +ellps=intl +no_defs",
            37242: "+proj=longlat +ellps=intl +no_defs",
            37243: "+proj=longlat +ellps=clrk66 +no_defs",
            37245: "+proj=longlat +ellps=intl +no_defs",
            37246: "+proj=longlat +ellps=intl +no_defs",
            37247: "+proj=longlat +ellps=intl +no_defs",
            37249: "+proj=longlat +ellps=intl +no_defs",
            37250: "+proj=longlat +ellps=intl +no_defs",
            37251: "+proj=longlat +ellps=intl +no_defs",
            37252: "+proj=longlat +ellps=clrk66 +no_defs",
            37253: "+proj=longlat +ellps=intl +no_defs",
            37254: "+proj=longlat +ellps=clrk80 +no_defs",
            37255: "+proj=longlat +ellps=bessel +no_defs",
            37257: "+proj=longlat +ellps=krass +no_defs",
            37259: "+proj=longlat +ellps=intl +no_defs",
            37260: "+proj=longlat +ellps=clrk66 +no_defs",
            41001: "+proj=merc +lat_ts=0 +lon_0=0 +k=1.000000 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            42101: "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=0 +lon_0=-95 +x_0=0 +y_0=-8000000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            42102: "+proj=aea +ellps=GRS80 +lat_0=45 +lon_0=-126.0 +lat_1=50.0 +lat_2=58.5 +x_0=1000000.0 +y_0=0 +datum=NAD83 +units=m",
            42103: "+proj=lcc +lat_1=33 +lat_2=45 +lat_0=0 +lon_0=-100 +x_0=0 +y_0=0 +ellps=WGS72 +datum=WGS84 +units=m +no_defs",
            42104: "+proj=tmerc +lat_0=0 +lon_0=-73.5 +k=0.999900 +x_0=304800 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            42105: "+proj=merc +lat_ts=0 +lon_0=-96 +k=1.000000 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            42106: "+proj=laea +lat_0=5 +lon_0=20 +x_0=0 +y_0=0 +a=6370997 +b=6370997 +datum=WGS84 +units=m +no_defs",
            42301: "+proj=stere +lat_0=90 +lon_0=-98 +x_0=0 +y_0=0 +ellps=clrk66 +datum=NAD27 +units=m +no_defs",
            42302: "+proj=tmerc +lat_0=36 +lon_0=139.833333333333 +k=0.999900 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
            42303: "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=23 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            42304: "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=49 +lon_0=-95 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            42305: "+proj=lcc +lat_1=45.898918964419 +lat_2=47.696014502038 +lat_0=46.8 +lon_0=2.337229166666667 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356514.999904194 +pm=2.337229166666667 +units=m +no_defs",
            42306: "+proj=lcc +lat_1=46 +lat_2=60 +lat_0=44 +lon_0=-68.5 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            42307: "+proj=lcc +lat_1=31.8833333333333 +lat_2=30.1166666666667 +lat_0=29.6666666666667 +lon_0=-100.333333333333 +x_0=700000.0000000001 +y_0=3000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            42308: "+proj=aea +lat_1=34 +lat_2=40.5 +lat_0=0 +lon_0=-120 +x_0=0 +y_0=-4000000 +ellps=clrk66 +datum=NAD27 +units=m +no_defs",
            42309: "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=0 +lon_0=-95 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            42310: "+proj=merc +lat_ts=0 +lon_0=0 +k=1.000000 +x_0=0 +y_0=0 +ellps=GRS80 +datum=WGS84 +units=m +no_defs",
            42311: "+proj=lcc +lat_1=49 +lat_2=77 +lat_0=63.390675 +lon_0=-91.86666700000001 +x_0=6200000 +y_0=3000000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            53001: "+a=6371000 +b=6371000 +units=m +no_defs",
            53002: "+a=6371000 +b=6371000 +units=m +no_defs",
            53003: "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +a=6371000 +b=6371000 +units=m +no_defs",
            53004: "+proj=merc +lat_ts=0 +lon_0=0 +k=1.000000 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53008: "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53009: "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53010: "+proj=eck6 +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53011: "+a=6371000 +b=6371000 +units=m +no_defs",
            53012: "+proj=eck4 +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53013: "+a=6371000 +b=6371000 +units=m +no_defs",
            53014: "+a=6371000 +b=6371000 +units=m +no_defs",
            53015: "+a=6371000 +b=6371000 +units=m +no_defs",
            53016: "+proj=gall +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53017: "+a=6371000 +b=6371000 +units=m +no_defs",
            53018: "+a=6371000 +b=6371000 +units=m +no_defs",
            53019: "+a=6371000 +b=6371000 +units=m +no_defs",
            53021: "+proj=poly +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53022: "+a=6371000 +b=6371000 +units=m +no_defs",
            53023: "+a=6371000 +b=6371000 +units=m +no_defs",
            53024: "+a=6371000 +b=6371000 +units=m +no_defs",
            53025: "+a=6371000 +b=6371000 +units=m +no_defs",
            53026: "+proj=stere +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53027: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=60 +lat_2=60 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53028: "+proj=cass +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53029: "+proj=vandg +lon_0=0 +x_0=0 +y_0=0 +R_A +a=6371000 +b=6371000 +units=m +no_defs",
            53030: "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            53031: "+a=6371000 +b=6371000 +units=m +no_defs",
            53032: "+proj=aeqd +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs",
            54001: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54002: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54003: "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54004: "+proj=merc +lat_ts=0 +lon_0=0 +k=1.000000 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54008: "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54009: "+proj=moll +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54010: "+proj=eck6 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54011: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54012: "+proj=eck4 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54013: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54014: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54015: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54016: "+proj=gall +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54017: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54018: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54019: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54021: "+proj=poly +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54022: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54023: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54024: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54025: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54026: "+proj=stere +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54027: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=60 +lat_2=60 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54028: "+proj=cass +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54029: "+proj=vandg +lon_0=0 +x_0=0 +y_0=0 +R_A +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54030: "+proj=robin +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54031: "+ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            54032: "+proj=aeqd +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            65061: "+proj=poly +lat_0=13.47246635277778 +lon_0=-144.7487507055556 +x_0=50000.00000000001 +y_0=50000.00000000001 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            65161: "+proj=poly +lat_0=13.47246635277778 +lon_0=-144.7487507055556 +x_0=50000 +y_0=50000 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102001: "+proj=aea +lat_1=50 +lat_2=70 +lat_0=40 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102002: "+proj=lcc +lat_1=50 +lat_2=70 +lat_0=40 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102003: "+proj=aea +lat_1=29.5 +lat_2=45.5 +lat_0=37.5 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102004: "+proj=lcc +lat_1=33 +lat_2=45 +lat_0=39 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102005: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=33 +lat_2=45 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102006: "+proj=aea +lat_1=55 +lat_2=65 +lat_0=50 +lon_0=-154 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102007: "+proj=aea +lat_1=8 +lat_2=18 +lat_0=13 +lon_0=-157 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102008: "+proj=aea +lat_1=20 +lat_2=60 +lat_0=40 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102009: "+proj=lcc +lat_1=20 +lat_2=60 +lat_0=40 +lon_0=-96 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102010: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=20 +lat_2=60 +x_0=0 +y_0=0 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102011: "+proj=sinu +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102012: "+proj=lcc +lat_1=30 +lat_2=62 +lat_0=0 +lon_0=105 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102013: "+proj=aea +lat_1=43 +lat_2=62 +lat_0=30 +lon_0=10 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
            102014: "+proj=lcc +lat_1=43 +lat_2=62 +lat_0=30 +lon_0=10 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
            102015: "+proj=lcc +lat_1=-5 +lat_2=-42 +lat_0=-32 +lon_0=-60 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs",
            102016: "+proj=aeqd +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102017: "+proj=laea +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102018: "+proj=stere +lat_0=90 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102019: "+proj=aeqd +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102020: "+proj=laea +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102021: "+proj=stere +lat_0=-90 +lon_0=0 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102022: "+proj=aea +lat_1=20 +lat_2=-23 +lat_0=0 +lon_0=25 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102023: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=20 +lat_2=-23 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102024: "+proj=lcc +lat_1=20 +lat_2=-23 +lat_0=0 +lon_0=25 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102025: "+proj=aea +lat_1=15 +lat_2=65 +lat_0=30 +lon_0=95 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102026: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=15 +lat_2=65 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102027: "+proj=lcc +lat_1=15 +lat_2=65 +lat_0=30 +lon_0=95 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102028: "+proj=aea +lat_1=7 +lat_2=-32 +lat_0=-15 +lon_0=125 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102029: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=7 +lat_2=-32 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102030: "+proj=lcc +lat_1=7 +lat_2=-32 +lat_0=-15 +lon_0=125 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs",
            102031: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=43 +lat_2=62 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
            102032: "+proj=eqdc +lat_0=0 +lon_0=0 +lat_1=-5 +lat_2=-42 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs",
            102033: "+proj=aea +lat_1=-5 +lat_2=-42 +lat_0=-32 +lon_0=-60 +x_0=0 +y_0=0 +ellps=aust_SA +units=m +no_defs",
            102065: "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813975277778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
            102066: "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813975277778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +pm=-17.66666666666667 +units=m +no_defs",
            102067: "+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813975277778 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +units=m +no_defs",
            102091: "+proj=tmerc +lat_0=0 +lon_0=9 +k=0.999600 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs",
            102092: "+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999600 +x_0=2520000 +y_0=0 +ellps=intl +units=m +no_defs",
            102101: "+proj=tmerc +lat_0=58 +lon_0=6.05625 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102102: "+proj=tmerc +lat_0=58 +lon_0=8.389583333333333 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102103: "+proj=tmerc +lat_0=58 +lon_0=10.72291666666667 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102104: "+proj=tmerc +lat_0=58 +lon_0=13.22291666666667 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102105: "+proj=tmerc +lat_0=58 +lon_0=16.88958333333333 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102106: "+proj=tmerc +lat_0=58 +lon_0=20.88958333333333 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102107: "+proj=tmerc +lat_0=58 +lon_0=24.88958333333333 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102108: "+proj=tmerc +lat_0=58 +lon_0=29.05625 +k=1.000000 +x_0=0 +y_0=0 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102110: "+proj=lcc +lat_1=44 +lat_2=49 +lat_0=46.5 +lon_0=3 +x_0=700000 +y_0=6600000 +ellps=GRS80 +units=m +no_defs",
            102114: "+proj=utm +zone=4 +ellps=clrk66 +units=m +no_defs",
            102115: "+proj=utm +zone=5 +ellps=clrk66 +units=m +no_defs",
            102120: "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.255555555556 +k=0.9996 +x_0=2546731.495961392 +y_0=-4354009.816002033 +ellps=clrk66 +datum=NAD27 +to_meter=0.3048006096012192 +no_defs",
            102121: "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.255555555556 +k=0.9996 +x_0=2546731.495961392 +y_0=-4354009.816002033 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102122: "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.255555555556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=clrk66 +datum=NAD27 +units=m +no_defs",
            102123: "+proj=omerc +lat_0=45.30916666666666 +lonc=-86 +alpha=337.255555555556 +k=0.9996 +x_0=2546731.496 +y_0=-4354009.816 +ellps=GRS80 +datum=NAD83 +units=m +no_defs",
            102132: "+proj=utm +zone=32 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102133: "+proj=utm +zone=33 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102134: "+proj=utm +zone=34 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102135: "+proj=utm +zone=35 +a=6377492.018 +b=6356173.508712696 +units=m +no_defs",
            102140: "+proj=tmerc +lat_0=22.31213333333334 +lon_0=114.1785555555556 +k=1.000000 +x_0=836694.05 +y_0=819069.8 +ellps=intl +units=m +no_defs",
            102141: "+proj=utm +zone=49 +ellps=intl +units=m +no_defs",
            102142: "+proj=utm +zone=50 +ellps=intl +units=m +no_defs",
            102151: "+proj=utm +zone=51 +ellps=bessel +units=m +no_defs",
            102152: "+proj=utm +zone=52 +ellps=bessel +units=m +no_defs",
            102153: "+proj=utm +zone=53 +ellps=bessel +units=m +no_defs",
            102154: "+proj=utm +zone=54 +ellps=bessel +units=m +no_defs",
            102155: "+proj=utm +zone=55 +ellps=bessel +units=m +no_defs",
            102156: "+proj=utm +zone=56 +ellps=bessel +units=m +no_defs",
            102160: "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1.000000 +x_0=200180.598 +y_0=299913.01 +ellps=intl +units=m +no_defs",
            102161: "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1.000000 +x_0=180.598 +y_0=-86.98999999999999 +ellps=intl +units=m +no_defs",
            102162: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs",
            102163: "+ellps=bessel +units=m +no_defs",
            102164: "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1.000000 +x_0=200000 +y_0=300000 +ellps=intl +units=m +no_defs",
            102165: "+proj=tmerc +lat_0=39.66666666666666 +lon_0=-8.131906111111112 +k=1.000000 +x_0=0 +y_0=0 +ellps=intl +units=m +no_defs",
            102166: "+proj=utm +zone=25 +ellps=intl +units=m +no_defs",
            102167: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs",
            102168: "+proj=utm +zone=26 +ellps=intl +units=m +no_defs",
            102169: "+proj=utm +zone=28 +ellps=intl +units=m +no_defs",
            102191: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=-5.4 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102192: "+proj=lcc +lat_1=29.7 +lat_0=29.7 +lon_0=-5.4 +k_0=0.9996155960000001 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102193: "+proj=lcc +lat_1=26.1 +lat_0=26.1 +lon_0=-5.4 +k_0=0.9996 +x_0=1200000 +y_0=400000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102229: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.999960 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102230: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102241: "+proj=lcc +lat_1=40 +lat_2=41.66666666666666 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
            102242: "+proj=lcc +lat_1=38.33333333333334 +lat_2=39.83333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
            102243: "+proj=lcc +lat_1=37.06666666666667 +lat_2=38.43333333333333 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
            102244: "+proj=lcc +lat_1=36 +lat_2=37.25 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
            102245: "+proj=lcc +lat_1=34.03333333333333 +lat_2=35.46666666666667 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
            102246: "+proj=lcc +lat_1=32.78333333333333 +lat_2=33.88333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
            102248: "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.999900 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102249: "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.999900 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102250: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933 +x_0=213360 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102251: "+proj=lcc +lat_1=34.93333333333333 +lat_2=36.23333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102252: "+proj=lcc +lat_1=33.3 +lat_2=34.76666666666667 +lat_0=32.66666666666666 +lon_0=-92 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs",
            102253: "+proj=lcc +lat_1=39.71666666666667 +lat_2=40.78333333333333 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs",
            102254: "+proj=lcc +lat_1=38.45 +lat_2=39.75 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs",
            102255: "+proj=lcc +lat_1=37.23333333333333 +lat_2=38.43333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +units=m +no_defs",
            102256: "+proj=lcc +lat_1=41.2 +lat_2=41.86666666666667 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +units=m +no_defs",
            102257: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102258: "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102259: "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102260: "+proj=lcc +lat_1=29.58333333333333 +lat_2=30.75 +lat_0=29 +lon_0=-84.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102261: "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999967 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102262: "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999967 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102263: "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.999990 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102264: "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.999990 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102265: "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1.000000 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102266: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.999900 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102267: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.999900 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102268: "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.999947 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102269: "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.999947 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102270: "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933 +x_0=800000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102271: "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102272: "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102273: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999967 +x_0=100000 +y_0=250000 +ellps=GRS80 +units=m +no_defs",
            102274: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999967 +x_0=900000 +y_0=250000 +ellps=GRS80 +units=m +no_defs",
            102277: "+proj=lcc +lat_1=38.71666666666667 +lat_2=39.78333333333333 +lat_0=38.33333333333334 +lon_0=-98 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102278: "+proj=lcc +lat_1=37.26666666666667 +lat_2=38.56666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=400000 +y_0=400000 +ellps=GRS80 +units=m +no_defs",
            102279: "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102280: "+proj=lcc +lat_1=36.73333333333333 +lat_2=37.93333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000 +y_0=500000 +ellps=GRS80 +units=m +no_defs",
            102281: "+proj=lcc +lat_1=31.16666666666667 +lat_2=32.66666666666666 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102282: "+proj=lcc +lat_1=29.3 +lat_2=30.7 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102283: "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.999900 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102284: "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999967 +x_0=900000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102285: "+proj=lcc +lat_1=38.3 +lat_2=39.45 +lat_0=37.66666666666666 +lon_0=-77 +x_0=400000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102286: "+proj=lcc +lat_1=41.71666666666667 +lat_2=42.68333333333333 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000 +ellps=GRS80 +units=m +no_defs",
            102287: "+proj=lcc +lat_1=41.28333333333333 +lat_2=41.48333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102288: "+proj=lcc +lat_1=45.48333333333333 +lat_2=47.08333333333334 +lat_0=44.78333333333333 +lon_0=-87 +x_0=8000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102289: "+proj=lcc +lat_1=44.18333333333333 +lat_2=45.7 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102290: "+proj=lcc +lat_1=42.1 +lat_2=43.66666666666666 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102291: "+proj=lcc +lat_1=47.03333333333333 +lat_2=48.63333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
            102292: "+proj=lcc +lat_1=45.61666666666667 +lat_2=47.05 +lat_0=45 +lon_0=-94.25 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
            102293: "+proj=lcc +lat_1=43.78333333333333 +lat_2=45.21666666666667 +lat_0=43 +lon_0=-94 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
            102294: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.999950 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102295: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.999950 +x_0=700000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102296: "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102297: "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102298: "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941 +x_0=850000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102300: "+proj=lcc +lat_1=45 +lat_2=49 +lat_0=44.25 +lon_0=-109.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102304: "+proj=lcc +lat_1=40 +lat_2=43 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102307: "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.999900 +x_0=200000 +y_0=8000000 +ellps=GRS80 +units=m +no_defs",
            102308: "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.999900 +x_0=500000 +y_0=6000000 +ellps=GRS80 +units=m +no_defs",
            102309: "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.999900 +x_0=800000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs",
            102310: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999967 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102311: "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.999900 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102312: "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909 +x_0=165000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102313: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.999900 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102314: "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999917 +x_0=830000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102315: "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.999900 +x_0=150000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102316: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.999938 +x_0=250000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102317: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.999938 +x_0=350000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102318: "+proj=lcc +lat_1=40.66666666666666 +lat_2=41.03333333333333 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102320: "+proj=lcc +lat_1=47.43333333333333 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102321: "+proj=lcc +lat_1=46.18333333333333 +lat_2=47.48333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102322: "+proj=lcc +lat_1=40.43333333333333 +lat_2=41.7 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102323: "+proj=lcc +lat_1=38.73333333333333 +lat_2=40.03333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102324: "+proj=lcc +lat_1=35.56666666666667 +lat_2=36.76666666666667 +lat_0=35 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102325: "+proj=lcc +lat_1=33.93333333333333 +lat_2=35.23333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102326: "+proj=lcc +lat_1=44.33333333333334 +lat_2=46 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102327: "+proj=lcc +lat_1=42.33333333333334 +lat_2=44 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102330: "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.999994 +x_0=100000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102334: "+proj=lcc +lat_1=44.41666666666666 +lat_2=45.68333333333333 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102335: "+proj=lcc +lat_1=42.83333333333334 +lat_2=44.4 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102336: "+proj=lcc +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102337: "+proj=lcc +lat_1=34.65 +lat_2=36.18333333333333 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
            102338: "+proj=lcc +lat_1=32.13333333333333 +lat_2=33.96666666666667 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
            102339: "+proj=lcc +lat_1=30.11666666666667 +lat_2=31.88333333333333 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs",
            102340: "+proj=lcc +lat_1=28.38333333333333 +lat_2=30.28333333333334 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000 +y_0=4000000 +ellps=GRS80 +units=m +no_defs",
            102341: "+proj=lcc +lat_1=26.16666666666667 +lat_2=27.83333333333333 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=5000000 +ellps=GRS80 +units=m +no_defs",
            102342: "+proj=lcc +lat_1=40.71666666666667 +lat_2=41.78333333333333 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
            102343: "+proj=lcc +lat_1=39.01666666666667 +lat_2=40.65 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
            102344: "+proj=lcc +lat_1=37.21666666666667 +lat_2=38.35 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000 +y_0=3000000 +ellps=GRS80 +units=m +no_defs",
            102345: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102346: "+proj=lcc +lat_1=38.03333333333333 +lat_2=39.2 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3500000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs",
            102347: "+proj=lcc +lat_1=36.76666666666667 +lat_2=37.96666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3500000 +y_0=1000000 +ellps=GRS80 +units=m +no_defs",
            102348: "+proj=lcc +lat_1=47.5 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102349: "+proj=lcc +lat_1=45.83333333333334 +lat_2=47.33333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102350: "+proj=lcc +lat_1=39 +lat_2=40.25 +lat_0=38.5 +lon_0=-79.5 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102351: "+proj=lcc +lat_1=37.48333333333333 +lat_2=38.88333333333333 +lat_0=37 +lon_0=-81 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102352: "+proj=lcc +lat_1=45.56666666666667 +lat_2=46.76666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102353: "+proj=lcc +lat_1=44.25 +lat_2=45.5 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102354: "+proj=lcc +lat_1=42.73333333333333 +lat_2=44.06666666666667 +lat_0=42 +lon_0=-90 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102355: "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.999938 +x_0=200000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102356: "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.999938 +x_0=400000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
            102357: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.999938 +x_0=600000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
            102358: "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.999938 +x_0=800000 +y_0=100000 +ellps=GRS80 +units=m +no_defs",
            102361: "+proj=lcc +lat_1=18.03333333333334 +lat_2=18.43333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +units=m +no_defs",
            102491: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102492: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500000 +y_0=300000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102581: "+proj=lcc +lat_1=49.5 +lat_0=49.5 +lon_0=2.337229166666667 +k_0=0.999877341 +x_0=600000 +y_0=1200000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102582: "+proj=lcc +lat_1=46.8 +lat_0=46.8 +lon_0=2.337229166666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102583: "+proj=lcc +lat_1=44.1 +lat_0=44.1 +lon_0=2.337229166666667 +k_0=0.999877499 +x_0=600000 +y_0=3200000 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102584: "+proj=lcc +lat_1=42.165 +lat_0=42.165 +lon_0=2.337229166666667 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369 +a=6378249.2 +b=6356514.999904194 +units=m +no_defs",
            102591: "+proj=lcc +lat_1=36 +lat_0=36 +lon_0=2.7 +k_0=0.999625544 +x_0=500135 +y_0=300090 +ellps=clrk80 +units=m +no_defs",
            102592: "+proj=lcc +lat_1=33.3 +lat_0=33.3 +lon_0=2.7 +k_0=0.999625769 +x_0=500135 +y_0=300090 +ellps=clrk80 +units=m +no_defs",
            102629: "+proj=tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k=0.999960 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102630: "+proj=tmerc +lat_0=30 +lon_0=-87.5 +k=0.999933 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102631: "+proj=omerc +lat_0=57 +lonc=-133.6666666666667 +alpha=-36.86989764583333 +k=0.9999 +x_0=4999999.999999999 +y_0=-4999999.999999999 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102632: "+proj=tmerc +lat_0=54 +lon_0=-142 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102633: "+proj=tmerc +lat_0=54 +lon_0=-146 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102634: "+proj=tmerc +lat_0=54 +lon_0=-150 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102635: "+proj=tmerc +lat_0=54 +lon_0=-154 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102636: "+proj=tmerc +lat_0=54 +lon_0=-158 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102637: "+proj=tmerc +lat_0=54 +lon_0=-162 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102638: "+proj=tmerc +lat_0=54 +lon_0=-166 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102639: "+proj=tmerc +lat_0=54 +lon_0=-170 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102640: "+proj=lcc +lat_1=51.83333333333334 +lat_2=53.83333333333334 +lat_0=51 +lon_0=-176 +x_0=1000000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102641: "+proj=lcc +lat_1=40 +lat_2=41.66666666666666 +lat_0=39.33333333333334 +lon_0=-122 +x_0=2000000 +y_0=500000.0000000002 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102642: "+proj=lcc +lat_1=38.33333333333334 +lat_2=39.83333333333334 +lat_0=37.66666666666666 +lon_0=-122 +x_0=2000000 +y_0=500000.0000000002 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102643: "+proj=lcc +lat_1=37.06666666666667 +lat_2=38.43333333333333 +lat_0=36.5 +lon_0=-120.5 +x_0=2000000 +y_0=500000.0000000002 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102644: "+proj=lcc +lat_1=36 +lat_2=37.25 +lat_0=35.33333333333334 +lon_0=-119 +x_0=2000000 +y_0=500000.0000000002 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102645: "+proj=lcc +lat_1=34.03333333333333 +lat_2=35.46666666666667 +lat_0=33.5 +lon_0=-118 +x_0=2000000 +y_0=500000.0000000002 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102646: "+proj=lcc +lat_1=32.78333333333333 +lat_2=33.88333333333333 +lat_0=32.16666666666666 +lon_0=-116.25 +x_0=2000000 +y_0=500000.0000000002 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102648: "+proj=tmerc +lat_0=31 +lon_0=-110.1666666666667 +k=0.999900 +x_0=213360 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102649: "+proj=tmerc +lat_0=31 +lon_0=-111.9166666666667 +k=0.999900 +x_0=213360 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102650: "+proj=tmerc +lat_0=31 +lon_0=-113.75 +k=0.999933 +x_0=213360 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102651: "+proj=lcc +lat_1=34.93333333333333 +lat_2=36.23333333333333 +lat_0=34.33333333333334 +lon_0=-92 +x_0=399999.9999999999 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102652: "+proj=lcc +lat_1=33.3 +lat_2=34.76666666666667 +lat_0=32.66666666666666 +lon_0=-92 +x_0=399999.9999999999 +y_0=399999.9999999999 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102653: "+proj=lcc +lat_1=39.71666666666667 +lat_2=40.78333333333333 +lat_0=39.33333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102654: "+proj=lcc +lat_1=38.45 +lat_2=39.75 +lat_0=37.83333333333334 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102655: "+proj=lcc +lat_1=37.23333333333333 +lat_2=38.43333333333333 +lat_0=36.66666666666666 +lon_0=-105.5 +x_0=914401.8289 +y_0=304800.6096 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102656: "+proj=lcc +lat_1=41.2 +lat_2=41.86666666666667 +lat_0=40.83333333333334 +lon_0=-72.75 +x_0=304800.6096 +y_0=152400.3048 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102657: "+proj=tmerc +lat_0=38 +lon_0=-75.41666666666667 +k=0.999995 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102658: "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102659: "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-82 +k=0.999941 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102660: "+proj=lcc +lat_1=29.58333333333333 +lat_2=30.75 +lat_0=29 +lon_0=-84.5 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102661: "+proj=tmerc +lat_0=18.83333333333333 +lon_0=-155.5 +k=0.999967 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102662: "+proj=tmerc +lat_0=20.33333333333333 +lon_0=-156.6666666666667 +k=0.999967 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102663: "+proj=tmerc +lat_0=21.16666666666667 +lon_0=-158 +k=0.999990 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102664: "+proj=tmerc +lat_0=21.83333333333333 +lon_0=-159.5 +k=0.999990 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102665: "+proj=tmerc +lat_0=21.66666666666667 +lon_0=-160.1666666666667 +k=1.000000 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102666: "+proj=tmerc +lat_0=30 +lon_0=-82.16666666666667 +k=0.999900 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102667: "+proj=tmerc +lat_0=30 +lon_0=-84.16666666666667 +k=0.999900 +x_0=700000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102668: "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.999947 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102669: "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.999947 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102670: "+proj=tmerc +lat_0=41.66666666666666 +lon_0=-115.75 +k=0.999933 +x_0=799999.9999999999 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102671: "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-88.33333333333333 +k=0.999975 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102672: "+proj=tmerc +lat_0=36.66666666666666 +lon_0=-90.16666666666667 +k=0.999941 +x_0=700000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102673: "+proj=tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k=0.999967 +x_0=100000 +y_0=250000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102674: "+proj=tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k=0.999967 +x_0=900000.0000000001 +y_0=250000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102675: "+proj=lcc +lat_1=42.06666666666667 +lat_2=43.26666666666667 +lat_0=41.5 +lon_0=-93.5 +x_0=1500000 +y_0=1000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102676: "+proj=lcc +lat_1=40.61666666666667 +lat_2=41.78333333333333 +lat_0=40 +lon_0=-93.5 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102677: "+proj=lcc +lat_1=38.71666666666667 +lat_2=39.78333333333333 +lat_0=38.33333333333334 +lon_0=-98 +x_0=399999.9999999999 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102678: "+proj=lcc +lat_1=37.26666666666667 +lat_2=38.56666666666667 +lat_0=36.66666666666666 +lon_0=-98.5 +x_0=399999.9999999999 +y_0=399999.9999999999 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102679: "+proj=lcc +lat_1=37.96666666666667 +lat_2=38.96666666666667 +lat_0=37.5 +lon_0=-84.25 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102680: "+proj=lcc +lat_1=36.73333333333333 +lat_2=37.93333333333333 +lat_0=36.33333333333334 +lon_0=-85.75 +x_0=500000.0000000002 +y_0=500000.0000000002 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102681: "+proj=lcc +lat_1=31.16666666666667 +lat_2=32.66666666666666 +lat_0=30.5 +lon_0=-92.5 +x_0=1000000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102682: "+proj=lcc +lat_1=29.3 +lat_2=30.7 +lat_0=28.5 +lon_0=-91.33333333333333 +x_0=1000000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102683: "+proj=tmerc +lat_0=43.66666666666666 +lon_0=-68.5 +k=0.999900 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102684: "+proj=tmerc +lat_0=42.83333333333334 +lon_0=-70.16666666666667 +k=0.999967 +x_0=900000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102685: "+proj=lcc +lat_1=38.3 +lat_2=39.45 +lat_0=37.66666666666666 +lon_0=-77 +x_0=399999.9999999999 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102686: "+proj=lcc +lat_1=41.71666666666667 +lat_2=42.68333333333333 +lat_0=41 +lon_0=-71.5 +x_0=200000 +y_0=750000.0000000001 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102687: "+proj=lcc +lat_1=41.28333333333333 +lat_2=41.48333333333333 +lat_0=41 +lon_0=-70.5 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102688: "+proj=lcc +lat_1=45.48333333333333 +lat_2=47.08333333333334 +lat_0=44.78333333333333 +lon_0=-87 +x_0=7999999.999999999 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102689: "+proj=lcc +lat_1=44.18333333333333 +lat_2=45.7 +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +x_0=6000000.000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102690: "+proj=lcc +lat_1=42.1 +lat_2=43.66666666666666 +lat_0=41.5 +lon_0=-84.36666666666666 +x_0=4000000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102691: "+proj=lcc +lat_1=47.03333333333333 +lat_2=48.63333333333333 +lat_0=46.5 +lon_0=-93.09999999999999 +x_0=799999.9999999999 +y_0=100000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102692: "+proj=lcc +lat_1=45.61666666666667 +lat_2=47.05 +lat_0=45 +lon_0=-94.25 +x_0=799999.9999999999 +y_0=100000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102693: "+proj=lcc +lat_1=43.78333333333333 +lat_2=45.21666666666667 +lat_0=43 +lon_0=-94 +x_0=799999.9999999999 +y_0=100000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102694: "+proj=tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k=0.999950 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102695: "+proj=tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k=0.999950 +x_0=700000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102696: "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-90.5 +k=0.999933 +x_0=250000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102697: "+proj=tmerc +lat_0=35.83333333333334 +lon_0=-92.5 +k=0.999933 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102698: "+proj=tmerc +lat_0=36.16666666666666 +lon_0=-94.5 +k=0.999941 +x_0=850000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102700: "+proj=lcc +lat_1=45 +lat_2=49 +lat_0=44.25 +lon_0=-109.5 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102704: "+proj=lcc +lat_1=40 +lat_2=43 +lat_0=39.83333333333334 +lon_0=-100 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102707: "+proj=tmerc +lat_0=34.75 +lon_0=-115.5833333333333 +k=0.999900 +x_0=200000 +y_0=7999999.999999999 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102708: "+proj=tmerc +lat_0=34.75 +lon_0=-116.6666666666667 +k=0.999900 +x_0=500000.0000000002 +y_0=6000000.000000001 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102709: "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.999900 +x_0=799999.9999999999 +y_0=4000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102710: "+proj=tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k=0.999967 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102711: "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.999900 +x_0=150000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102712: "+proj=tmerc +lat_0=31 +lon_0=-104.3333333333333 +k=0.999909 +x_0=165000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102713: "+proj=tmerc +lat_0=31 +lon_0=-106.25 +k=0.999900 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102714: "+proj=tmerc +lat_0=31 +lon_0=-107.8333333333333 +k=0.999917 +x_0=829999.9999999999 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102715: "+proj=tmerc +lat_0=38.83333333333334 +lon_0=-74.5 +k=0.999900 +x_0=150000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102716: "+proj=tmerc +lat_0=40 +lon_0=-76.58333333333333 +k=0.999938 +x_0=250000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102717: "+proj=tmerc +lat_0=40 +lon_0=-78.58333333333333 +k=0.999938 +x_0=350000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102718: "+proj=lcc +lat_1=40.66666666666666 +lat_2=41.03333333333333 +lat_0=40.16666666666666 +lon_0=-74 +x_0=300000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102719: "+proj=lcc +lat_1=34.33333333333334 +lat_2=36.16666666666666 +lat_0=33.75 +lon_0=-79 +x_0=609601.2199999999 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102720: "+proj=lcc +lat_1=47.43333333333333 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-100.5 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102721: "+proj=lcc +lat_1=46.18333333333333 +lat_2=47.48333333333333 +lat_0=45.66666666666666 +lon_0=-100.5 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102722: "+proj=lcc +lat_1=40.43333333333333 +lat_2=41.7 +lat_0=39.66666666666666 +lon_0=-82.5 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102723: "+proj=lcc +lat_1=38.73333333333333 +lat_2=40.03333333333333 +lat_0=38 +lon_0=-82.5 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102724: "+proj=lcc +lat_1=35.56666666666667 +lat_2=36.76666666666667 +lat_0=35 +lon_0=-98 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102725: "+proj=lcc +lat_1=33.93333333333333 +lat_2=35.23333333333333 +lat_0=33.33333333333334 +lon_0=-98 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102726: "+proj=lcc +lat_1=44.33333333333334 +lat_2=46 +lat_0=43.66666666666666 +lon_0=-120.5 +x_0=2500000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102727: "+proj=lcc +lat_1=42.33333333333334 +lat_2=44 +lat_0=41.66666666666666 +lon_0=-120.5 +x_0=1500000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102728: "+proj=lcc +lat_1=40.88333333333333 +lat_2=41.95 +lat_0=40.16666666666666 +lon_0=-77.75 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102729: "+proj=lcc +lat_1=39.93333333333333 +lat_2=40.96666666666667 +lat_0=39.33333333333334 +lon_0=-77.75 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102730: "+proj=tmerc +lat_0=41.08333333333334 +lon_0=-71.5 +k=0.999994 +x_0=100000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102733: "+proj=lcc +lat_1=32.5 +lat_2=34.83333333333334 +lat_0=31.83333333333333 +lon_0=-81 +x_0=609600.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102734: "+proj=lcc +lat_1=44.41666666666666 +lat_2=45.68333333333333 +lat_0=43.83333333333334 +lon_0=-100 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102735: "+proj=lcc +lat_1=42.83333333333334 +lat_2=44.4 +lat_0=42.33333333333334 +lon_0=-100.3333333333333 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102736: "+proj=lcc +lat_1=35.25 +lat_2=36.41666666666666 +lat_0=34.33333333333334 +lon_0=-86 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102737: "+proj=lcc +lat_1=34.65 +lat_2=36.18333333333333 +lat_0=34 +lon_0=-101.5 +x_0=200000 +y_0=1000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102738: "+proj=lcc +lat_1=32.13333333333333 +lat_2=33.96666666666667 +lat_0=31.66666666666667 +lon_0=-98.5 +x_0=600000.0000000001 +y_0=2000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102739: "+proj=lcc +lat_1=30.11666666666667 +lat_2=31.88333333333333 +lat_0=29.66666666666667 +lon_0=-100.3333333333333 +x_0=700000 +y_0=3000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102740: "+proj=lcc +lat_1=28.38333333333333 +lat_2=30.28333333333334 +lat_0=27.83333333333333 +lon_0=-99 +x_0=600000.0000000001 +y_0=4000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102741: "+proj=lcc +lat_1=26.16666666666667 +lat_2=27.83333333333333 +lat_0=25.66666666666667 +lon_0=-98.5 +x_0=300000 +y_0=4999999.999999999 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102742: "+proj=lcc +lat_1=40.71666666666667 +lat_2=41.78333333333333 +lat_0=40.33333333333334 +lon_0=-111.5 +x_0=500000.0000000002 +y_0=1000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102743: "+proj=lcc +lat_1=39.01666666666667 +lat_2=40.65 +lat_0=38.33333333333334 +lon_0=-111.5 +x_0=500000.0000000002 +y_0=2000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102744: "+proj=lcc +lat_1=37.21666666666667 +lat_2=38.35 +lat_0=36.66666666666666 +lon_0=-111.5 +x_0=500000.0000000002 +y_0=3000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102745: "+proj=tmerc +lat_0=42.5 +lon_0=-72.5 +k=0.999964 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102746: "+proj=lcc +lat_1=38.03333333333333 +lat_2=39.2 +lat_0=37.66666666666666 +lon_0=-78.5 +x_0=3499999.999999999 +y_0=2000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102747: "+proj=lcc +lat_1=36.76666666666667 +lat_2=37.96666666666667 +lat_0=36.33333333333334 +lon_0=-78.5 +x_0=3499999.999999999 +y_0=1000000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102748: "+proj=lcc +lat_1=47.5 +lat_2=48.73333333333333 +lat_0=47 +lon_0=-120.8333333333333 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102749: "+proj=lcc +lat_1=45.83333333333334 +lat_2=47.33333333333334 +lat_0=45.33333333333334 +lon_0=-120.5 +x_0=500000.0000000002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102750: "+proj=lcc +lat_1=39 +lat_2=40.25 +lat_0=38.5 +lon_0=-79.5 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102751: "+proj=lcc +lat_1=37.48333333333333 +lat_2=38.88333333333333 +lat_0=37 +lon_0=-81 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102752: "+proj=lcc +lat_1=45.56666666666667 +lat_2=46.76666666666667 +lat_0=45.16666666666666 +lon_0=-90 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102753: "+proj=lcc +lat_1=44.25 +lat_2=45.5 +lat_0=43.83333333333334 +lon_0=-90 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102754: "+proj=lcc +lat_1=42.73333333333333 +lat_2=44.06666666666667 +lat_0=42 +lon_0=-90 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102755: "+proj=tmerc +lat_0=40.5 +lon_0=-105.1666666666667 +k=0.999938 +x_0=200000 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102756: "+proj=tmerc +lat_0=40.5 +lon_0=-107.3333333333333 +k=0.999938 +x_0=399999.9999999999 +y_0=100000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102757: "+proj=tmerc +lat_0=40.5 +lon_0=-108.75 +k=0.999938 +x_0=600000.0000000001 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102758: "+proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.999938 +x_0=799999.9999999999 +y_0=100000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102761: "+proj=lcc +lat_1=18.03333333333334 +lat_2=18.43333333333333 +lat_0=17.83333333333333 +lon_0=-66.43333333333334 +x_0=200000 +y_0=200000 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            102766: "+proj=poly +lat_0=13.47246635277778 +lon_0=-144.7487507055556 +x_0=49999.99999999999 +y_0=49999.99999999999 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs",
            103300: "+proj=lcc +lat_1=49.8333339 +lat_2=51.16666733333333 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.01256 +y_0=5400088.4378 +ellps=intl +units=m +no_defs",
            104e3: "+proj=longlat +ellps=clrk66 +datum=NAD27 +no_defs",
            104101: "+proj=longlat +ellps=bessel +no_defs",
            104102: "+proj=longlat +ellps=bessel +no_defs",
            104103: "+proj=longlat +ellps=clrk80 +no_defs",
            104104: "+proj=longlat +ellps=intl +no_defs",
            104105: "+proj=longlat +ellps=bessel +no_defs",
            104106: "+proj=longlat +ellps=intl +no_defs",
            104107: "+proj=longlat +ellps=GRS80 +no_defs",
            104108: "+proj=longlat +ellps=GRS80 +no_defs",
            104261: "+proj=longlat +a=6378249.2 +b=6356514.999904194 +no_defs",
            104304: "+proj=longlat +a=6378249.2 +b=6356514.999904194 +no_defs",
            104305: "+proj=longlat +ellps=clrk80 +no_defs",
            900913: "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +no_defs"
          };
        },
        {}
      ],
      2: [function(a2, b2, e3) {
        b2.exports = {
          1024: "+a=6378137 +b=6356752.314140356",
          1025: "+ellps=GSK2011 +a=6378136.5 +b=6356751.757955603",
          1026: "+a=6376045 +b=6355477.112903226",
          7001: "+ellps=airy +a=6377563.396 +b=6356256.909237285",
          7002: "+ellps=mod_airy +a=6377340.189 +b=6356034.447938534",
          7003: "+ellps=aust_SA +a=6378160 +b=6356774.719195306",
          7004: "+ellps=bessel +a=6377397.155 +b=6356078.962818189",
          7005: "+ellps=bessel +a=6377492.018 +b=6356173.508712696",
          7006: "+ellps=bess_nam +a=6377483.865 +b=6356165.382966326",
          7007: "+a=6378293.645208759 +b=6356617.987679838",
          7008: "+ellps=clrk66 +a=6378206.4 +b=6356583.8",
          7009: "+ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444",
          7010: "+ellps=clrk80 +a=6378300.789 +b=6356566.435",
          7011: "+ellps=clrk80ign +a=6378249.2 +b=6356515",
          7012: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755",
          7013: "+ellps=clrk80 +a=6378249.145 +b=6356514.966398753",
          7014: "+ellps=clrk80 +a=6378249.2 +b=6356514.996941779",
          7015: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239",
          7016: "+ellps=evrst30 +a=6377298.556 +b=6356097.550300896",
          7018: "+ellps=evrst30 +a=6377304.063 +b=6356103.038993155",
          7019: "+ellps=GRS80 +a=6378137 +b=6356752.314140356",
          7020: "+ellps=helmert +a=6378200 +b=6356818.169627891",
          7021: "+a=6378160 +b=6356774.50408554",
          7022: "+ellps=intl +a=6378388 +b=6356911.9461279465",
          7024: "+ellps=krass +a=6378245 +b=6356863.018773047",
          7025: "+ellps=NWL9D +a=6378145 +b=6356759.769488684",
          7027: "+ellps=plessis +a=6376523 +b=6355862.933255573",
          7028: "+a=6378298.3 +b=6356657.142669562",
          7029: "+a=6378300 +b=6356751.689189189",
          7030: "+ellps=WGS84 +a=6378137 +b=6356752.314245179",
          7031: "+a=6378137 +b=6356752.314245179",
          7032: "+a=6378136.2 +b=6356751.516927429",
          7033: "+a=6378136.3 +b=6356751.616592146",
          7034: "+ellps=clrk80 +a=6378249.144808011 +b=6356514.966204134",
          7035: "+ellps=sphere +a=6371000 +b=6371000",
          7036: "+ellps=GRS67 +a=6378160 +b=6356774.516090714",
          7041: "+a=6378135 +b=6356750.304921594",
          7042: "+a=6377299.36559538 +b=6356098.359005156",
          7043: "+ellps=WGS72 +a=6378135 +b=6356750.520016094",
          7044: "+ellps=evrst30 +a=6377301.243 +b=6356100.230165385",
          7045: "+ellps=evrst30 +a=6377299.151 +b=6356098.145120132",
          7046: "+ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807",
          7047: "+ellps=GRS80 +a=6370997 +b=6370997",
          7048: "+ellps=GRS80 +a=6371007 +b=6371007",
          7049: "+a=6378140 +b=6356755.288157528",
          7050: "+ellps=GRS67 +a=6378160 +b=6356774.719195306",
          7051: "+a=6377019.27 +b=6355762.5391",
          7052: "+ellps=clrk66 +a=6370997 +b=6370997",
          7053: "+ellps=hough +a=6378270 +b=6356794.343434343",
          7054: "+ellps=PZ90 +a=6378136 +b=6356751.361745712",
          7055: "+ellps=clrk80 +a=6378306.3696 +b=6356571.996",
          7056: "+ellps=evrst69 +a=6377295.664 +b=6356094.667915204",
          7057: "+a=6371228 +b=6371228",
          7058: "+a=6378273 +b=6356889.449",
          7059: "+a=6378137 +b=6378137"
        };
      }, {}],
      3: [
        function(a2, b2, e3) {
          b2.exports = {
            1024: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            1025: "+ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0",
            1026: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1029: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1031: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            1032: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1033: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1034: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1035: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1036: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1037: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1038: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1041: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1042: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1043: "+a=6378137 +b=6356752.314140356 +pm=0",
            1044: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1045: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            1046: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1047: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1048: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            1052: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            1053: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0",
            1055: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668",
            1056: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1057: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1058: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1060: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1061: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1062: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1063: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1064: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1065: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1066: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1067: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1068: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1069: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1070: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            1071: "+a=6378293.645208759 +b=6356617.987679838 +pm=0",
            1072: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            1073: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1074: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6",
            1075: "+ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0",
            1076: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1077: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            1078: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1081: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            1095: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1100: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1111: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0",
            1112: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1113: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1114: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1115: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1116: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            1117: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            1118: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            1120: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1128: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1132: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1133: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            1135: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            1136: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1137: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            1138: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            1139: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            1141: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1142: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1143: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1144: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1145: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1147: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-346,-1,224",
            1152: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1153: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1154: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1155: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1156: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1157: "+ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0",
            1158: "+ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0",
            1159: "+ellps=GSK2011 +a=6378136.5 +b=6356751.757955603 +pm=0",
            1160: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1165: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1166: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1167: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1168: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1173: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1174: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1178: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1179: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1180: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1181: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1182: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1183: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1184: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1185: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1186: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1187: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1188: "+a=6376045 +b=6355477.112903226 +pm=-17.666666666666668",
            1189: "+a=6376045 +b=6355477.112903226 +pm=-17.666666666666668",
            1191: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1192: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1193: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1194: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1195: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1196: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1197: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1198: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1201: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            1204: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1206: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1207: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1208: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1209: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1211: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            1212: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            1214: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1217: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            1218: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1220: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1221: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1223: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1225: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1227: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1228: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1229: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1230: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1231: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1232: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1233: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1234: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1235: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1236: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1237: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1238: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1239: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1240: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1241: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1242: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1243: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1244: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1245: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1246: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1247: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1248: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1249: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1251: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1252: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1253: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1254: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1257: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1258: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1259: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1263: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1264: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1266: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1268: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1271: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1272: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1273: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1286: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1289: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1291: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1293: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1295: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1304: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1305: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1308: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1309: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            1310: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1311: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=89.5,93.8,123.1,-1.2,0.0,0.0,0.156",
            1312: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1313: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1314: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=-446.448,125.157,-542.060, 20.4894,-0.1502, -0.2470,-0.8421",
            1315: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1317: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1319: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1320: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1321: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1322: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1324: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1327: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1329: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1332: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1333: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1334: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1335: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1336: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1337: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1338: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1339: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1340: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1341: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1342: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1343: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1344: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1345: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1346: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            1347: "+a=6377019.27 +b=6355762.5391 +pm=0",
            1348: "+a=6377019.27 +b=6355762.5391 +pm=0",
            1349: "+a=6377019.27 +b=6355762.5391 +pm=0",
            1350: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            1351: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1352: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1353: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1355: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1356: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1357: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1358: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1359: "+a=6378273 +b=6356889.449 +pm=0",
            1360: "+a=6371228 +b=6371228 +pm=0",
            1365: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1366: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            1367: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6001: "+ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0",
            6002: "+ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0",
            6003: "+ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0",
            6004: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6005: "+ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=0",
            6006: "+ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0",
            6007: "+a=6378293.645208759 +b=6356617.987679838 +pm=0",
            6008: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6009: "+ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0",
            6010: "+ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0",
            6011: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6012: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6013: "+ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0",
            6014: "+ellps=clrk80 +a=6378249.2 +b=6356514.996941779 +pm=0",
            6015: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0",
            6016: "+ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0",
            6018: "+ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0",
            6019: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6020: "+ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0",
            6021: "+a=6378160 +b=6356774.50408554 +pm=0",
            6022: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6024: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6025: "+ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0",
            6027: "+ellps=plessis +a=6376523 +b=6355862.933255573 +pm=0",
            6028: "+a=6378298.3 +b=6356657.142669562 +pm=0",
            6029: "+a=6378300 +b=6356751.689189189 +pm=0",
            6030: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0 +towgs84=0,0,0",
            6031: "+a=6378137 +b=6356752.314245179 +pm=0",
            6032: "+a=6378136.2 +b=6356751.516927429 +pm=0",
            6033: "+a=6378136.3 +b=6356751.616592146 +pm=0",
            6034: "+ellps=clrk80 +a=6378249.144808011 +b=6356514.966204134 +pm=0",
            6035: "+ellps=sphere +a=6371000 +b=6371000 +pm=0",
            6036: "+ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0 +towgs84=0,0,0",
            6041: "+a=6378135 +b=6356750.304921594 +pm=0",
            6042: "+a=6377299.36559538 +b=6356098.359005156 +pm=0",
            6043: "+ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0 +towgs84=0,8,10",
            6044: "+ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0",
            6045: "+ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0",
            6047: "+ellps=GRS80 +a=6371007 +b=6371007 +pm=0",
            6052: "+ellps=clrk66 +a=6370997 +b=6370997 +pm=0",
            6053: "+a=6371228 +b=6371228 +pm=0",
            6054: "+a=6378273 +b=6356889.449 +pm=0",
            6055: "+a=6378137 +b=6378137 +pm=0",
            6120: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6121: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6122: "+a=6378135 +b=6356750.304921594 +pm=0",
            6123: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6124: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=419.3836,99.3335,591.3451,-0.850389,-1.817277,7.862238,-0.99496",
            6125: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6126: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6127: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6128: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6129: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6130: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6131: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=198,881,317",
            6132: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6133: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6134: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6135: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=61,-285,-181",
            6136: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6137: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6138: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6139: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=11,72,-101",
            6140: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6141: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6142: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6143: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6144: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0",
            6145: "+ellps=evrst30 +a=6377301.243 +b=6356100.230165385 +pm=0",
            6146: "+ellps=evrst30 +a=6377299.151 +b=6356098.145120132 +pm=0",
            6147: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6148: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6149: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6150: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6151: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6152: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6153: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6154: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6155: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-83,37,124",
            6156: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6157: "+a=6378293.645208759 +b=6356617.987679838 +pm=0",
            6158: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-2,374,172",
            6159: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6160: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6161: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6162: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6163: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6164: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6165: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6166: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6167: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6168: "+a=6378300 +b=6356751.689189189 +pm=0",
            6169: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-115,118,426",
            6170: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6171: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6172: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6173: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6174: "+a=6378300 +b=6356751.689189189 +pm=0",
            6175: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-88,4,101",
            6176: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6178: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6179: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6180: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6181: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6182: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6183: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-104,167,-38",
            6184: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6185: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314",
            6188: "+ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0",
            6189: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6190: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6191: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6192: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6193: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6194: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=164,138,-189",
            6195: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6196: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6197: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6198: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6199: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6200: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6201: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-162,-12,206",
            6202: "+ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-133,-48,148",
            6203: "+ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-134,-48,149",
            6204: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6205: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-43,-163,45",
            6206: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6207: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6208: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6209: "+ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-143,-90,-294",
            6210: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-160,-8,-300",
            6211: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6212: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6213: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6214: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=-31.4,144.3,81.2",
            6215: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6216: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-73,213,296",
            6218: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=307,304,-318",
            6219: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-384,664,-48",
            6220: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6221: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-148,136,90",
            6222: "+ellps=clrk80 +a=6378249.145 +b=6356514.966398753 +pm=0 +towgs84=-136,-108,-292",
            6223: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-263,6,431",
            6224: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-134,229,-29",
            6225: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-206,172,-6",
            6226: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6227: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6228: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6229: "+ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0",
            6230: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-87,-98,-121",
            6231: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-83,-96,-113",
            6232: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6233: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6234: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6235: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6236: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-634,-549,-201",
            6237: "+ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0",
            6238: "+a=6378160 +b=6356774.50408554 +pm=0 +towgs84=-24,-15,5",
            6239: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=217,823,299",
            6240: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=210,814,289",
            6241: "+ellps=clrk80 +a=6378249.144808011 +b=6356514.966204134 +pm=0",
            6242: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6243: "+a=6377299.36559538 +b=6356098.359005156 +pm=0",
            6244: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0 +towgs84=-97,787,86",
            6245: "+ellps=evrst30 +a=6377304.063 +b=6356103.038993155 +pm=0",
            6246: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6247: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6248: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6249: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6250: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-130,29,364",
            6251: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-90,40,88",
            6252: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6253: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-133,-77,-51",
            6254: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=16,196,93",
            6255: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-333,-222,114",
            6256: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=41,-220,-134",
            6257: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6258: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6259: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6260: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6261: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=31,146,47",
            6262: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=639,405,60",
            6263: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-92,-93,122",
            6264: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6265: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6266: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-74,-130,42",
            6267: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6268: "+ellps=clrk66 +a=6378450.047548896 +b=6356826.621488444 +pm=0 +towgs84=-8,160,176",
            6269: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6270: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6271: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-2,374,172",
            6272: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=59.47,-5.04,187.44,-0.47,0.1,-1.024,-4.5993,0",
            6273: "+ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=0",
            6274: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6275: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6276: "+ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0",
            6277: "+ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0",
            6278: "+ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0",
            6279: "+ellps=airy +a=6377563.396 +b=6356256.909237285 +pm=0",
            6280: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6281: "+ellps=clrk80 +a=6378300.789 +b=6356566.435 +pm=0",
            6282: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6283: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6284: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0 +towgs84=24,-123,-94,-0.02,0.25,0.13,1.1",
            6285: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6286: "+ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0",
            6287: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6288: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6289: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6291: "+ellps=GRS67 +a=6378160 +b=6356774.516090714 +pm=0",
            6292: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-355,16,74",
            6293: "+ellps=bess_nam +a=6377483.865280419 +b=6356165.383245807 +pm=0 +towgs84=616,97,-251",
            6294: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6295: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6296: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6297: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-189,-242,-91",
            6298: "+ellps=evrst30 +a=6377298.556 +b=6356097.550300896 +pm=0 +towgs84=-689,691,-46",
            6299: "+ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0",
            6300: "+ellps=mod_airy +a=6377340.189 +b=6356034.447938534 +pm=0 +towgs84=506,-122,611",
            6301: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0 +towgs84=-128,481,664",
            6302: "+a=6378293.645208759 +b=6356617.987679838 +pm=0",
            6303: "+ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0",
            6304: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0 +towgs84=-73,-247,227",
            6306: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6307: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-186,-93,310",
            6308: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6309: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-155,171,37",
            6310: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6311: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-265,120,-358",
            6312: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6313: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6314: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6315: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6316: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6317: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6318: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6319: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6322: "+ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0",
            6324: "+ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0",
            6326: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6600: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6601: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-270,13,62",
            6602: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6603: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6604: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=174,359,365",
            6605: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6606: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6607: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6608: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6609: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6610: "+a=6378140 +b=6356755.288157528 +pm=0 +towgs84=24,-123,-94,-0.02,-0.25,0.13,1.1",
            6611: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6612: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6613: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6614: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-128,-283,22",
            6615: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314",
            6616: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-289,-124,60",
            6618: "+ellps=GRS67 +a=6378160 +b=6356774.719195306 +pm=0 +towgs84=-57,1,-41",
            6619: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6620: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-106,-129,165",
            6621: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6622: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6623: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6624: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6625: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6626: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=94,-948,-1262",
            6627: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6628: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6629: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6630: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6631: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6632: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6633: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6634: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6635: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6636: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6637: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6638: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6639: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6640: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6641: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6642: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6643: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6644: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6645: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6646: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6647: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6648: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6649: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6650: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6651: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6652: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6653: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6654: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6655: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6656: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6657: "+a=6377019.27 +b=6355762.5391 +pm=0",
            6658: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-73,46,-86",
            6659: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6660: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6661: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6663: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-499,-249,314",
            6664: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6665: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-104,167,-38",
            6666: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6667: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6668: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-86,-98,-119",
            6670: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6671: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=0",
            6672: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=175,-38,113",
            6673: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6674: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6675: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-100,-248,259",
            6676: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6677: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6678: "+ellps=krass +a=6378245 +b=6356863.018773047 +pm=0",
            6679: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6680: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6681: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6682: "+ellps=evrst30 +a=6377276.345 +b=6356075.413140239 +pm=0",
            6683: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6684: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6685: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-133,-321,50",
            6686: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6687: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6688: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6689: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6690: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6691: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6692: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6693: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6694: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6695: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6696: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6697: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6698: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6699: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6700: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6701: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6702: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6703: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6704: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6705: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6706: "+ellps=helmert +a=6378200 +b=6356818.169627891 +pm=0",
            6707: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6708: "+ellps=aust_SA +a=6378160 +b=6356774.719195306 +pm=0",
            6709: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6710: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-320,550,-494",
            6711: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6712: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-207,107,52",
            6713: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=-79,-129,145",
            6714: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-127,-769,472",
            6715: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6716: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6717: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0 +towgs84=-2,150,181",
            6718: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6719: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=211,147,111",
            6720: "+ellps=WGS72 +a=6378135 +b=6356750.520016094 +pm=0",
            6721: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6722: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6723: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6724: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6725: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=191,-77,-204",
            6726: "+ellps=clrk66 +a=6378206.4 +b=6356583.8 +pm=0",
            6727: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=912,-58,1227",
            6728: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-307,-92,127",
            6729: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=185,165,42",
            6730: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=170,42,84",
            6731: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=51,391,-36",
            6732: "+ellps=hough +a=6378270 +b=6356794.343434343 +pm=0 +towgs84=101,52,-39",
            6733: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6734: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=-632,438,-609",
            6735: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0 +towgs84=647,1777,-1124",
            6736: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0 +towgs84=260,12,-147",
            6737: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6738: "+a=6378293.645208759 +b=6356617.987679838 +pm=0 +towgs84=-156,-271,-189",
            6739: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6740: "+ellps=PZ90 +a=6378136 +b=6356751.361745712 +pm=0",
            6741: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6742: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6743: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6744: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=0",
            6745: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6746: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=0",
            6747: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6748: "+ellps=clrk80 +a=6378306.3696 +b=6356571.996 +pm=0",
            6749: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6750: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6751: "+ellps=evrst69 +a=6377295.664 +b=6356094.667915204 +pm=0",
            6752: "+ellps=clrk80 +a=6378306.3696 +b=6356571.996 +pm=0",
            6753: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6754: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=0",
            6755: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6756: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6757: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6758: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6759: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0 +towgs84=0,0,0",
            6760: "+ellps=NWL9D +a=6378145 +b=6356759.769488684 +pm=0",
            6761: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6762: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6763: "+ellps=WGS84 +a=6378137 +b=6356752.314245179 +pm=0",
            6764: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6765: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6801: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=7.439583333333333",
            6802: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=-74.08091666666667 +towgs84=307,304,-318",
            6803: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=-9.131906111111112",
            6804: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444",
            6805: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668",
            6806: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=12.452333333333332 +towgs84=-225,-65,9",
            6807: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998",
            6808: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444",
            6809: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=4.3679749999999995",
            6810: "+ellps=intl +a=6378388 +b=6356911.9461279465 +pm=2.337229169999998 +towgs84=-189,-242,-91",
            6811: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998 +towgs84=-73,-247,227",
            6813: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444 +towgs84=-377,681,-50",
            6814: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=18.05827777777778",
            6815: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=23.716337499999998",
            6816: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998",
            6817: "+ellps=bessel +a=6377492.018 +b=6356173.508712696 +pm=10.722916666666666",
            6818: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-17.666666666666668",
            6819: "+ellps=clrk80 +a=6378249.145 +b=6356514.8695497755 +pm=2.337229169999998",
            6820: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=106.80771944444444",
            6821: "+ellps=clrk80ign +a=6378249.2 +b=6356515 +pm=2.337229169999998",
            6896: "+ellps=GRS80 +a=6378137 +b=6356752.314140356 +pm=0",
            6901: "+ellps=plessis +a=6376523 +b=6355862.933255573 +pm=2.3372083333333333",
            6902: "+ellps=plessis +a=6376523 +b=6355862.933255573 +pm=2.337229169999998",
            6903: "+a=6378298.3 +b=6356657.142669562 +pm=-3.6873750000000003",
            6904: "+ellps=bessel +a=6377397.155 +b=6356078.962818189 +pm=-9.131906111111112"
          };
        },
        {}
      ],
      4: [function(a2, b2, e3) {
        b2.exports = { 1026: 12.57775, 8901: 0, 8902: -9.131906111111112, 8903: 2.337229169999998, 8904: -74.08091666666667, 8905: -3.6873750000000003, 8906: 12.452333333333332, 8907: 7.439583333333333, 8908: 106.80771944444444, 8909: -17.666666666666668, 8910: 4.3679749999999995, 8911: 18.05827777777778, 8912: 23.716337499999998, 8913: 10.722916666666666, 8914: 2.3372083333333333 };
      }, {}],
      5: [function(a2, b2, e3) {
        b2.exports = function(c2) {
          var d2 = c2["+proj"], f2 = c2["+a"], h2 = c2["+b"];
          "cea" === d2 && (c2["+lat_ts"] = c2["+lat_1"], delete c2["+lat_1"]);
          f2 !== h2 || void 0 === f2 || "tmerc" !== d2 && "utm" !== d2 && "etmerc" !== d2 || (c2["+approx"] = null);
        };
      }, {}],
      6: [function(a2, b2, e3) {
        a2 = { o1: { ProjStdParallel1GeoKey: { u: 1, p: "lat_1" }, ProjStdParallel2GeoKey: { u: 1, p: "lat_2" }, ProjCenterLongGeoKey: { u: 1, p: "lon_0" }, ProjCenterLatGeoKey: { u: 1, p: "lat_0" }, ProjCenterEastingGeoKey: { u: 2, p: "x_0" }, ProjCenterNorthingGeoKey: { u: 2, p: "y_0" }, ProjScaleAtCenterGeoKey: { u: 3, p: "k_0" } }, o2: {
          ProjNatOriginLongGeoKey: { u: 1, p: "lon_0" },
          ProjNatOriginLatGeoKey: { u: 1, p: "lat_0" },
          ProjFalseOriginEastingGeoKey: { u: 2, p: "x_0" },
          ProjFalseOriginNorthingGeoKey: { u: 2, p: "y_0" },
          ProjScaleAtNatOriginGeoKey: { u: 3, p: "k_0" }
        }, o3: { ProjFalseOriginLongGeoKey: { u: 1, p: "lon_0" }, ProjFalseOriginLatGeoKey: { u: 1, p: "lat_0" }, ProjFalseEastingGeoKey: { u: 2, p: "x_0" }, ProjFalseNorthingGeoKey: { u: 2, p: "y_0" } } };
        a2.o2.ProjStdParallelGeoKey = a2.o1.ProjStdParallel1GeoKey;
        a2.o3.ProjOriginLongGeoKey = a2.o2.ProjNatOriginLongGeoKey;
        a2.o3.ProjOriginLatGeoKey = a2.o2.ProjNatOriginLatGeoKey;
        a2.o3.ProjScaleAtOriginGeoKey = a2.o2.ProjScaleAtNatOriginGeoKey;
        b2.exports = a2;
      }, {}],
      7: [function(a2, b2, e3) {
        b2.exports = { 1: "tmerc", 3: "omerc", 4: "labrd", 6: "omerc +ellps=sphere", 7: "merc", 8: "lcc", 9: "lcc", 10: "laea", 11: "aea", 12: "aeqd", 13: "eqdc", 14: "stere", 15: "stere", 16: "sterea", 17: "eqc", 18: "cass", 19: "gnom", 20: "mill", 21: "ortho", 22: "poly", 23: "robin", 24: "sinu", 25: "vandg", 26: "nzmg", 27: "tmerc +k_0=1", 28: "cea" };
      }, {}],
      8: [function(a2, b2, e3) {
        b2.exports = {
          3811: "lcc +lat_0=50.797815 +lon_0=4.359215833333333 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=649328 +y_0=665262",
          3813: "tmerc +lat_0=32.5 +lon_0=-89.75 +k_0=0.9998335 +x_0=500000 +y_0=1300000",
          3818: "tmerc +lat_0=0 +lon_0=118.99999999999989 +k_0=0.9999 +x_0=250000 +y_0=0",
          3820: "tmerc +lat_0=0 +lon_0=120.99999999999987 +k_0=0.9999 +x_0=250000 +y_0=0",
          3831: "merc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=0 +y_0=0",
          3853: "tmerc +lat_0=0 +lon_0=18.05787 +k_0=0.99999506 +x_0=100182.7406 +y_0=-6500620.1207",
          3856: "merc +lat_0=0 +lon_0=0 +x_0=0 +y_0=0",
          3860: "tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=1 +x_0=19500000 +y_0=0",
          3861: "tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=1 +x_0=20500000 +y_0=0",
          3862: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=21500000 +y_0=0",
          3863: "tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=1 +x_0=22500000 +y_0=0",
          3864: "tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=1 +x_0=23500000 +y_0=0",
          3865: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=24500000 +y_0=0",
          3866: "tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=1 +x_0=25500000 +y_0=0",
          3867: "tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=1 +x_0=26500000 +y_0=0",
          3868: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=27500000 +y_0=0",
          3869: "tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=28500000 +y_0=0",
          3870: "tmerc +lat_0=0 +lon_0=28.99999999999997 +k_0=1 +x_0=29500000 +y_0=0",
          3871: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=30500000 +y_0=0",
          3872: "tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=31500000 +y_0=0",
          3897: "laea +ellps=sphere +lat_0=89.99999999999991 +lon_0=0 +x_0=0 +y_0=0",
          3898: "laea +ellps=sphere +lat_0=-89.99999999999991 +lon_0=0 +x_0=0 +y_0=0",
          3899: "laea +ellps=sphere +lat_0=44.99999999999996 +lon_0=-99.9999999999999 +x_0=0 +y_0=0",
          3967: "lcc +lat_0=35.999999999999964 +lon_0=-79.49999999999991 +lat_1=36.999999999999964 +lat_2=39.49999999999996 +x_0=0 +y_0=0",
          3977: "lcc +lat_0=48.99999999999995 +lon_0=-94.9999999999999 +lat_1=48.99999999999995 +lat_2=76.99999999999993 +x_0=0 +y_0=0",
          3980: "lcc +lat_0=8.999999999999991 +lon_0=25.999999999999975 +lat_1=-6.499999999999994 +lat_2=-11.49999999999999 +x_0=500000 +y_0=500000",
          3981: "tmerc +lat_0=-8.999999999999991 +lon_0=29.99999999999997 +k_0=1 +x_0=200000 +y_0=500000",
          3982: "tmerc +lat_0=-8.999999999999991 +lon_0=27.99999999999997 +k_0=1 +x_0=200000 +y_0=500000",
          3983: "tmerc +lat_0=-8.999999999999991 +lon_0=25.999999999999975 +k_0=1 +x_0=200000 +y_0=500000",
          3984: "tmerc +lat_0=-8.999999999999991 +lon_0=23.999999999999975 +k_0=1 +x_0=200000 +y_0=500000",
          3999: "tmerc +lat_0=0 +lon_0=28.4 +k_0=0.99994 +x_0=200000 +y_0=-5000000",
          4085: "eqc +lon_0=0 +x_0=0 +y_0=0 +lat_1=0",
          4086: "eqc +ellps=sphere +lon_0=0 +x_0=0 +y_0=0 +lat_1=0",
          4089: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.99998 +x_0=200000 +y_0=-5000000",
          4090: "tmerc +lat_0=0 +lon_0=9.99999999999999 +k_0=0.99998 +x_0=400000 +y_0=-5000000",
          4091: "tmerc +lat_0=0 +lon_0=11.749999999999988 +k_0=0.99998 +x_0=600000 +y_0=-5000000",
          4092: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=800000 +y_0=-5000000",
          4101: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4102: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4103: "tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4104: "tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4105: "tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4106: "tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4107: "tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4108: "tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4109: "tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4110: "tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4111: "tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4112: "tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4113: "tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4114: "cass +lat_0=2.0425833333333334 +lon_0=103.56275833333333 +x_0=0 +y_0=0",
          4115: "cass +lat_0=2.7122833333333336 +lon_0=101.94116666666667 +x_0=-242.005 +y_0=-948.547",
          4116: "cass +lat_0=3.7109722222222223 +lon_0=102.43617777777779 +x_0=0 +y_0=0",
          4117: "cass +lat_0=3.680344444444444 +lon_0=101.50824444444444 +x_0=-21759.438 +y_0=55960.906",
          4118: "tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4119: "tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4177: "cass +lat_0=4.946141666666667 +lon_0=102.89520833333334 +x_0=0 +y_0=0",
          4186: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4187: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          4305: "cass +lat_0=5.421325 +lon_0=100.34586944444445 +x_0=0 +y_0=0",
          4320: "cass +lat_0=5.965147222222223 +lon_0=100.63759444444445 +x_0=0 +y_0=0",
          4321: "cass +lat_0=4.859380555555555 +lon_0=100.81676666666667 +x_0=0 +y_0=133453.669",
          4323: "cass +lat_0=5.893922222222222 +lon_0=102.17729166666668 +x_0=0 +y_0=0",
          4325: "tmerc +lat_0=13.5 +lon_0=144.75 +k_0=1 +x_0=100000 +y_0=200000",
          4416: "lcc +lat_0=-8.999999999999991 +lon_0=25.999999999999975 +lat_1=-6.499999999999994 +lat_2=-11.49999999999999 +x_0=500000 +y_0=500000",
          4436: "lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=609601.2192024385 +y_0=0",
          4454: "lcc +lat_0=40.5 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=609601.2192024385 +y_0=30480.060960121926",
          4460: "lcc +lat_0=-26.99999999999997 +lon_0=131.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0",
          4648: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=32500000 +y_0=0",
          4825: "lcc +lat_0=15.833333333333334 +lon_0=-24 +lat_1=15 +lat_2=16.666666666666668 +x_0=161587.83 +y_0=128511.202",
          4838: "lcc +lat_0=50.99999999999995 +lon_0=10.5 +lat_1=48.666666666666664 +lat_2=53.666666666666664 +x_0=0 +y_0=0",
          4841: "tmerc +lat_0=0 +lon_0=15.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4842: "tmerc +lat_0=0 +lon_0=16.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4843: "tmerc +lat_0=0 +lon_0=17.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4844: "tmerc +lat_0=0 +lon_0=18.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4845: "tmerc +lat_0=0 +lon_0=5.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4846: "tmerc +lat_0=0 +lon_0=6.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4847: "tmerc +lat_0=0 +lon_0=7.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4848: "tmerc +lat_0=0 +lon_0=8.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4849: "tmerc +lat_0=0 +lon_0=9.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4850: "tmerc +lat_0=0 +lon_0=10.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4851: "tmerc +lat_0=0 +lon_0=11.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4852: "tmerc +lat_0=0 +lon_0=12.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4853: "tmerc +lat_0=0 +lon_0=13.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4854: "tmerc +lat_0=0 +lon_0=14.5 +k_0=1 +x_0=100000 +y_0=1000000",
          4881: "tmerc +lat_0=0 +lon_0=19.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5e3: "tmerc +lat_0=0 +lon_0=20.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5001: "tmerc +lat_0=0 +lon_0=21.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5002: "tmerc +lat_0=0 +lon_0=22.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5003: "tmerc +lat_0=0 +lon_0=23.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5004: "tmerc +lat_0=0 +lon_0=24.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5005: "tmerc +lat_0=0 +lon_0=25.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5006: "tmerc +lat_0=0 +lon_0=26.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5007: "tmerc +lat_0=0 +lon_0=27.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5008: "tmerc +lat_0=0 +lon_0=28.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5009: "tmerc +lat_0=0 +lon_0=29.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5010: "tmerc +lat_0=0 +lon_0=30.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5020: "tmerc +lat_0=39.666666666666664 +lon_0=-8.131906111111112 +k_0=1 +x_0=0 +y_0=0",
          5049: "tmerc +lat_0=37.999999999999964 +lon_0=130.99999999999986 +k_0=1 +x_0=200000 +y_0=500000",
          5068: "aea +lat_0=22.99999999999998 +lon_0=-95.9999999999999 +lat_1=29.5 +lat_2=45.5 +x_0=0 +y_0=0",
          5100: "tmerc +lat_0=37.999999999999964 +lon_0=127.5 +k_0=0.9996 +x_0=1000000 +y_0=2000000",
          5101: "tmerc +lat_0=37.999999999999964 +lon_0=124.99999999999987 +k_0=1 +x_0=200000 +y_0=600000",
          5102: "tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=600000",
          5103: "tmerc +lat_0=37.999999999999964 +lon_0=128.99999999999986 +k_0=1 +x_0=200000 +y_0=600000",
          5104: "tmerc +lat_0=37.999999999999964 +lon_0=130.99999999999986 +k_0=1 +x_0=200000 +y_0=600000",
          5131: "tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=550000",
          5135: "tmerc +lat_0=58 +lon_0=5.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5136: "tmerc +lat_0=58 +lon_0=6.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5137: "tmerc +lat_0=58 +lon_0=7.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5138: "tmerc +lat_0=58 +lon_0=8.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5139: "tmerc +lat_0=58 +lon_0=9.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5140: "tmerc +lat_0=58 +lon_0=10.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5141: "tmerc +lat_0=58 +lon_0=11.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5142: "tmerc +lat_0=58 +lon_0=12.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5143: "tmerc +lat_0=58 +lon_0=13.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5144: "tmerc +lat_0=58 +lon_0=14.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5145: "tmerc +lat_0=58 +lon_0=15.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5146: "tmerc +lat_0=58 +lon_0=16.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5147: "tmerc +lat_0=58 +lon_0=17.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5148: "tmerc +lat_0=58 +lon_0=18.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5149: "tmerc +lat_0=58 +lon_0=19.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5150: "tmerc +lat_0=58 +lon_0=20.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5151: "tmerc +lat_0=58 +lon_0=21.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5152: "tmerc +lat_0=58 +lon_0=22.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5153: "tmerc +lat_0=58 +lon_0=23.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5154: "tmerc +lat_0=58 +lon_0=24.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5155: "tmerc +lat_0=58 +lon_0=25.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5156: "tmerc +lat_0=58 +lon_0=26.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5157: "tmerc +lat_0=58 +lon_0=27.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5158: "tmerc +lat_0=58 +lon_0=28.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5159: "tmerc +lat_0=58 +lon_0=29.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5160: "tmerc +lat_0=58 +lon_0=30.5 +k_0=1 +x_0=100000 +y_0=1000000",
          5161: "tmerc +lat_0=37.999999999999964 +lon_0=125.00289027777778 +k_0=1 +x_0=200000 +y_0=500000",
          5162: "tmerc +lat_0=37.999999999999964 +lon_0=127.00289027777778 +k_0=1 +x_0=200000 +y_0=500000",
          5163: "tmerc +lat_0=37.999999999999964 +lon_0=127.00289027777778 +k_0=1 +x_0=200000 +y_0=550000",
          5164: "tmerc +lat_0=37.999999999999964 +lon_0=129.00289027777777 +k_0=1 +x_0=200000 +y_0=500000",
          5165: "tmerc +lat_0=37.999999999999964 +lon_0=131.00289027777777 +k_0=1 +x_0=200000 +y_0=500000",
          5218: "krovak +lat_0=49.5 +alpha=30.2881397527778 +k=0.9999 +alpha=30.28813975277778 +x_0=0 +y_0=0 +lat_0=49.5 +k_0=0.9999 +lon_0=42.5",
          5222: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=500000",
          5231: "tmerc +lat_0=7.000480277777778 +lon_0=80.77171111111112 +k_0=0.9999238418 +x_0=200000 +y_0=200000",
          5232: "tmerc +lat_0=7.000471527777778 +lon_0=80.77171308333334 +k_0=0.9999238418 +x_0=500000 +y_0=500000",
          5265: "tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=250000 +y_0=0",
          5268: "tmerc +lat_0=0 +lon_0=90.73333333333333 +k_0=1 +x_0=250000 +y_0=-2500000",
          5276: "tmerc +lat_0=0 +lon_0=89.55 +k_0=1 +x_0=250000 +y_0=-2500000",
          5277: "tmerc +lat_0=0 +lon_0=89.85 +k_0=1 +x_0=250000 +y_0=-2500000",
          5278: "tmerc +lat_0=0 +lon_0=90.03333333333333 +k_0=1 +x_0=250000 +y_0=-2500000",
          5279: "tmerc +lat_0=0 +lon_0=90.15 +k_0=1 +x_0=250000 +y_0=-2500000",
          5280: "tmerc +lat_0=0 +lon_0=91.13333333333334 +k_0=1 +x_0=250000 +y_0=-2500000",
          5281: "tmerc +lat_0=0 +lon_0=91.23333333333333 +k_0=1 +x_0=250000 +y_0=-2500000",
          5282: "tmerc +lat_0=0 +lon_0=89.35 +k_0=1 +x_0=250000 +y_0=-2500000",
          5283: "tmerc +lat_0=0 +lon_0=91.35 +k_0=1 +x_0=250000 +y_0=-2500000",
          5284: "tmerc +lat_0=0 +lon_0=90.16666666666667 +k_0=1 +x_0=250000 +y_0=-2500000",
          5285: "tmerc +lat_0=0 +lon_0=91.56666666666666 +k_0=1 +x_0=250000 +y_0=-2500000",
          5286: "tmerc +lat_0=0 +lon_0=89.06666666666666 +k_0=1 +x_0=250000 +y_0=-2500000",
          5287: "tmerc +lat_0=0 +lon_0=90.26666666666667 +k_0=1 +x_0=250000 +y_0=-2500000",
          5288: "tmerc +lat_0=0 +lon_0=90.11666666666666 +k_0=1 +x_0=250000 +y_0=-2500000",
          5289: "tmerc +lat_0=0 +lon_0=91.75 +k_0=1 +x_0=250000 +y_0=-2500000",
          5290: "tmerc +lat_0=0 +lon_0=90.5 +k_0=1 +x_0=250000 +y_0=-2500000",
          5291: "tmerc +lat_0=0 +lon_0=90.86666666666666 +k_0=1 +x_0=250000 +y_0=-2500000",
          5312: "tmerc +lat_0=0 +lon_0=89.55 +k_0=1 +x_0=250000 +y_0=-2500000",
          5313: "tmerc +lat_0=0 +lon_0=89.85 +k_0=1 +x_0=250000 +y_0=-2500000",
          5314: "tmerc +lat_0=0 +lon_0=91.56666666666666 +k_0=1 +x_0=250000 +y_0=-2500000",
          5315: "tmerc +lat_0=0 +lon_0=-6.999999999999993 +k_0=0.999997 +x_0=200000 +y_0=-6000000",
          5319: "lcc +lat_0=0 +lon_0=-83.99999999999991 +lat_1=44.5 +lat_2=54.5 +x_0=1000000 +y_0=0",
          5326: "lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=1700000 +y_0=300000",
          5328: "merc +lat_0=0 +lon_0=3.1922805555555556 +k_0=0.997 +x_0=3900000 +y_0=900000",
          5366: "tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=500000 +y_0=0",
          5390: "lcc +lat_0=10.466666666666667 +lon_0=-84.33333333333333 +k_0=0.99995696 +x_0=500000 +y_0=271820.522",
          5394: "lcc +lat_0=9 +lon_0=-83.66666666666667 +k_0=0.99995696 +x_0=500000 +y_0=327987.436",
          5397: "lcc +lat_0=15.5 +lon_0=-86.16666666666667 +k_0=0.99993273 +x_0=500000 +y_0=296917.439",
          5398: "lcc +lat_0=13.783333333333333 +lon_0=-86.16666666666667 +k_0=0.9999514 +x_0=500000 +y_0=296215.903",
          5399: "lcc +lat_0=13.783333333333333 +lon_0=-89 +k_0=0.99996704 +x_0=500000 +y_0=295809.184",
          5439: "lcc +lat_0=13.866666666666667 +lon_0=-85.5 +k_0=0.99990314 +x_0=500000 +y_0=359891.816",
          5444: "lcc +lat_0=11.733333333333333 +lon_0=-85.5 +k_0=0.99992228 +x_0=500000 +y_0=288876.327",
          5465: "tmerc +lat_0=17.061241944444443 +lon_0=-88.6318575 +k_0=1 +x_0=66220.02833082761 +y_0=135779.5099885299",
          5468: "lcc +lat_0=8.416666666666666 +lon_0=-80 +k_0=0.99989909 +x_0=500000 +y_0=294865.303",
          5471: "poly +lat_0=8.25 +lon_0=-81 +x_0=914391.7962 +y_0=999404.7217154861",
          5475: "lcc +lat_0=-78 +lon_0=163 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=7000000 +y_0=5000000",
          5476: "lcc +lat_0=-74.5 +lon_0=165 +lat_1=-73.66666666666667 +lat_2=-75.33333333333333 +x_0=5000000 +y_0=3000000",
          5477: "lcc +lat_0=-71.5 +lon_0=166 +lat_1=-70.66666666666667 +lat_2=-72.33333333333333 +x_0=3000000 +y_0=1000000",
          5478: "stere +lat_0=-89.99999999999991 +lon_0=179.99999999999983 +k_0=0.994 +x_0=5000000 +y_0=1000000",
          5509: "krovak +alpha=30.28813975277778 +x_0=0 +y_0=0 +lat_0=49.5 +k_0=0.9999 +lon_0=24.833333333333332",
          5510: "krovak +lat_0=49.5 +alpha=30.2881397527778 +k=0.9999 +alpha=30.28813975277778 +x_0=0 +y_0=0 +lat_0=49.5 +k_0=0.9999 +lon_0=24.833333333333332",
          5517: "tmerc +lat_0=-44 +lon_0=-176.5 +k_0=1 +x_0=350000 +y_0=650000",
          5522: "tmerc +lat_0=0 +lon_0=11.5 +k_0=0.9996 +x_0=1500000 +y_0=5500000",
          5547: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          5548: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          5549: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          5587: "sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=304800 +y_0=304800",
          5595: "tmerc +lat_0=0 +lon_0=11.333333333333334 +k_0=1 +x_0=1000000 +y_0=0",
          5640: "merc +lon_0=-42.99999999999996 +x_0=5000000 +y_0=10000000 +lat_1=-1.999999999999998",
          5642: "lcc +lat_0=47.99999999999995 +lon_0=9.99999999999999 +lat_1=52.666666666666664 +lat_2=54.333333333333336 +x_0=815000 +y_0=0",
          5645: "tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000.0000101601 +y_0=0",
          5647: "tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=31500000 +y_0=0",
          5648: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=33500000 +y_0=0",
          5658: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500053 +y_0=-3999820",
          5824: "tmerc +lat_0=-35.31773627777778 +lon_0=149.00929483055555 +k_0=1.000086 +x_0=200000 +y_0=600000",
          5883: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=1500000 +y_0=5000000",
          5889: "stere +x_0=0 +y_0=0 +lat_ts=69.99999999999993 +lon_0=89.99999999999991",
          5892: "tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=0.9999 +x_0=500000 +y_0=0",
          5893: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9999 +x_0=500000 +y_0=0",
          5894: "tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=0.9999 +x_0=500000 +y_0=0",
          5895: "tmerc +lat_0=0 +lon_0=107.75 +k_0=0.9999 +x_0=500000 +y_0=0",
          5901: "stere +lat_0=89.99999999999991 +lon_0=-149.99999999999986 +k_0=0.994 +x_0=2000000 +y_0=2000000",
          5902: "stere +lat_0=89.99999999999991 +lon_0=-99.9999999999999 +k_0=0.994 +x_0=2000000 +y_0=2000000",
          5903: "stere +lat_0=89.99999999999991 +lon_0=-32.999999999999964 +k_0=0.994 +x_0=2000000 +y_0=2000000",
          5904: "stere +lat_0=89.99999999999991 +lon_0=17.999999999999982 +k_0=0.994 +x_0=2000000 +y_0=2000000",
          5905: "stere +lat_0=89.99999999999991 +lon_0=104.9999999999999 +k_0=0.994 +x_0=2000000 +y_0=2000000",
          5906: "lcc +lat_0=81.31722599999999 +lon_0=-110.99999999999989 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0",
          5907: "lcc +lat_0=81.31722599999999 +lon_0=-38.999999999999964 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0",
          5908: "lcc +lat_0=81.31722599999999 +lon_0=32.999999999999964 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0",
          5909: "lcc +lat_0=81.31722599999999 +lon_0=104.9999999999999 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0",
          5910: "lcc +lat_0=81.31722599999999 +lon_0=176.99999999999983 +lat_1=84.99999999999991 +lat_2=76.99999999999993 +x_0=0 +y_0=0",
          5911: "lcc +lat_0=73.15574086111111 +lon_0=-110.99999999999989 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0",
          5912: "lcc +lat_0=73.15574086111111 +lon_0=-38.999999999999964 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0",
          5913: "lcc +lat_0=73.15574086111111 +lon_0=32.999999999999964 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0",
          5914: "lcc +lat_0=73.15574086111111 +lon_0=104.9999999999999 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0",
          5915: "lcc +lat_0=73.15574086111111 +lon_0=176.99999999999983 +lat_1=76.99999999999993 +lat_2=68.99999999999993 +x_0=0 +y_0=0",
          5916: "lcc +lat_0=65.10127088888888 +lon_0=-110.99999999999989 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0",
          5917: "lcc +lat_0=65.10127088888888 +lon_0=-38.999999999999964 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0",
          5918: "lcc +lat_0=65.10127088888888 +lon_0=32.999999999999964 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0",
          5919: "lcc +lat_0=65.10127088888888 +lon_0=104.9999999999999 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0",
          5920: "lcc +lat_0=65.10127088888888 +lon_0=176.99999999999983 +lat_1=68.99999999999993 +lat_2=60.999999999999936 +x_0=0 +y_0=0",
          5943: "lcc +lat_0=62.01530688888889 +lon_0=-52 +lat_1=63.666666666666664 +lat_2=60.333333333333336 +x_0=20500000 +y_0=8500000",
          5944: "lcc +lat_0=62.01530688888889 +lon_0=-37 +lat_1=63.666666666666664 +lat_2=60.333333333333336 +x_0=22500000 +y_0=8500000",
          5977: "lcc +lat_0=85.43711833333333 +lon_0=-150 +lat_1=87 +lat_2=83.66666666666667 +x_0=21500000 +y_0=1500000",
          5978: "lcc +lat_0=85.43711833333333 +lon_0=-90 +lat_1=87 +lat_2=83.66666666666667 +x_0=23500000 +y_0=1500000",
          5979: "lcc +lat_0=85.43711833333333 +lon_0=-30 +lat_1=87 +lat_2=83.66666666666667 +x_0=25500000 +y_0=1500000",
          5980: "lcc +lat_0=85.43711833333333 +lon_0=30 +lat_1=87 +lat_2=83.66666666666667 +x_0=27500000 +y_0=1500000",
          5981: "lcc +lat_0=85.43711833333333 +lon_0=90 +lat_1=87 +lat_2=83.66666666666667 +x_0=29500000 +y_0=1500000",
          5982: "lcc +lat_0=85.43711833333333 +lon_0=150 +lat_1=87 +lat_2=83.66666666666667 +x_0=31500000 +y_0=1500000",
          5983: "lcc +lat_0=82.05842488888888 +lon_0=166 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=10500000 +y_0=2500000",
          5984: "lcc +lat_0=82.05842488888888 +lon_0=-154 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=12500000 +y_0=2500000",
          5985: "lcc +lat_0=82.05842488888888 +lon_0=-115 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=14500000 +y_0=2500000",
          5986: "lcc +lat_0=82.05842488888888 +lon_0=-75 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=16500000 +y_0=2500000",
          5987: "lcc +lat_0=82.05842488888888 +lon_0=-52 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=18500000 +y_0=2500000",
          5988: "lcc +lat_0=82.05842488888888 +lon_0=-12 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=20500000 +y_0=2500000",
          5989: "lcc +lat_0=82.05842488888888 +lon_0=16 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=22500000 +y_0=2500000",
          5990: "lcc +lat_0=82.05842488888888 +lon_0=53 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=24500000 +y_0=2500000",
          5991: "lcc +lat_0=82.05842488888888 +lon_0=93 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=26500000 +y_0=2500000",
          5992: "lcc +lat_0=82.05842488888888 +lon_0=133 +lat_1=83.66666666666667 +lat_2=80.33333333333333 +x_0=28500000 +y_0=2500000",
          5993: "lcc +lat_0=78.70733752777778 +lon_0=21 +lat_1=80.33333333333333 +lat_2=77 +x_0=11500000 +y_0=3500000",
          5994: "lcc +lat_0=78.70733752777778 +lon_0=52 +lat_1=80.33333333333333 +lat_2=77 +x_0=13500000 +y_0=3500000",
          5995: "lcc +lat_0=78.70733752777778 +lon_0=83 +lat_1=80.33333333333333 +lat_2=77 +x_0=15500000 +y_0=3500000",
          5996: "lcc +lat_0=78.70733752777778 +lon_0=114 +lat_1=80.33333333333333 +lat_2=77 +x_0=17500000 +y_0=3500000",
          5997: "lcc +lat_0=78.70733752777778 +lon_0=145 +lat_1=80.33333333333333 +lat_2=77 +x_0=19500000 +y_0=3500000",
          5998: "lcc +lat_0=78.70733752777778 +lon_0=176 +lat_1=80.33333333333333 +lat_2=77 +x_0=21500000 +y_0=3500000",
          5999: "lcc +lat_0=78.70733752777778 +lon_0=-153 +lat_1=80.33333333333333 +lat_2=77 +x_0=23500000 +y_0=3500000",
          6e3: "lcc +lat_0=78.70733752777778 +lon_0=-129 +lat_1=80.33333333333333 +lat_2=77 +x_0=25500000 +y_0=3500000",
          6001: "lcc +lat_0=78.70733752777778 +lon_0=-99 +lat_1=80.33333333333333 +lat_2=77 +x_0=27500000 +y_0=3500000",
          6002: "lcc +lat_0=78.70733752777778 +lon_0=-69 +lat_1=80.33333333333333 +lat_2=77 +x_0=29500000 +y_0=3500000",
          6003: "lcc +lat_0=78.70733752777778 +lon_0=-39 +lat_1=80.33333333333333 +lat_2=77 +x_0=31500000 +y_0=3500000",
          6004: "lcc +lat_0=78.70733752777778 +lon_0=-10 +lat_1=80.33333333333333 +lat_2=77 +x_0=33500000 +y_0=3500000",
          6005: "lcc +lat_0=75.36440330555556 +lon_0=-155 +lat_1=77 +lat_2=73.66666666666667 +x_0=12500000 +y_0=4500000",
          6006: "lcc +lat_0=75.36440330555556 +lon_0=-129 +lat_1=77 +lat_2=73.66666666666667 +x_0=14500000 +y_0=4500000",
          6007: "lcc +lat_0=75.36440330555556 +lon_0=-104 +lat_1=77 +lat_2=73.66666666666667 +x_0=16500000 +y_0=4500000",
          6008: "lcc +lat_0=75.36440330555556 +lon_0=-79 +lat_1=77 +lat_2=73.66666666666667 +x_0=18500000 +y_0=4500000",
          6009: "lcc +lat_0=75.36440330555556 +lon_0=-64 +lat_1=77 +lat_2=73.66666666666667 +x_0=20500000 +y_0=4500000",
          6010: "lcc +lat_0=75.36440330555556 +lon_0=-39 +lat_1=77 +lat_2=73.66666666666667 +x_0=22500000 +y_0=4500000",
          6011: "lcc +lat_0=75.36440330555556 +lon_0=-14 +lat_1=77 +lat_2=73.66666666666667 +x_0=24500000 +y_0=4500000",
          6012: "lcc +lat_0=75.36440330555556 +lon_0=10 +lat_1=77 +lat_2=73.66666666666667 +x_0=26500000 +y_0=4500000",
          6013: "lcc +lat_0=75.36440330555556 +lon_0=34 +lat_1=77 +lat_2=73.66666666666667 +x_0=28500000 +y_0=4500000",
          6014: "lcc +lat_0=75.36440330555556 +lon_0=58 +lat_1=77 +lat_2=73.66666666666667 +x_0=30500000 +y_0=4500000",
          6015: "lcc +lat_0=75.36440330555556 +lon_0=82 +lat_1=77 +lat_2=73.66666666666667 +x_0=32500000 +y_0=4500000",
          6016: "lcc +lat_0=75.36440330555556 +lon_0=106 +lat_1=77 +lat_2=73.66666666666667 +x_0=34500000 +y_0=4500000",
          6017: "lcc +lat_0=75.36440330555556 +lon_0=130 +lat_1=77 +lat_2=73.66666666666667 +x_0=36500000 +y_0=4500000",
          6018: "lcc +lat_0=75.36440330555556 +lon_0=154 +lat_1=77 +lat_2=73.66666666666667 +x_0=38500000 +y_0=4500000",
          6019: "lcc +lat_0=75.36440330555556 +lon_0=179 +lat_1=77 +lat_2=73.66666666666667 +x_0=40500000 +y_0=4500000",
          6020: "lcc +lat_0=72.02500919444445 +lon_0=14 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=11500000 +y_0=5500000",
          6021: "lcc +lat_0=72.02500919444445 +lon_0=34 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=13500000 +y_0=5500000",
          6022: "lcc +lat_0=72.02500919444445 +lon_0=54 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=15500000 +y_0=5500000",
          6023: "lcc +lat_0=72.02500919444445 +lon_0=74 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=17500000 +y_0=5500000",
          6024: "lcc +lat_0=72.02500919444445 +lon_0=95 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=19500000 +y_0=5500000",
          6025: "lcc +lat_0=72.02500919444445 +lon_0=116 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=21500000 +y_0=5500000",
          6026: "lcc +lat_0=72.02500919444445 +lon_0=137 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=23500000 +y_0=5500000",
          6027: "lcc +lat_0=72.02500919444445 +lon_0=158 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=25500000 +y_0=5500000",
          6028: "lcc +lat_0=72.02500919444445 +lon_0=179 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=27500000 +y_0=5500000",
          6029: "lcc +lat_0=72.02500919444445 +lon_0=-163 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=29500000 +y_0=5500000",
          6030: "lcc +lat_0=72.02500919444445 +lon_0=-147 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=31500000 +y_0=5500000",
          6031: "lcc +lat_0=72.02500919444445 +lon_0=-131 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=33500000 +y_0=5500000",
          6032: "lcc +lat_0=72.02500919444445 +lon_0=-111 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=35500000 +y_0=5500000",
          6033: "lcc +lat_0=72.02500919444445 +lon_0=-91 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=37500000 +y_0=5500000",
          6034: "lcc +lat_0=72.02500919444445 +lon_0=-71 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=39500000 +y_0=5500000",
          6035: "lcc +lat_0=72.02500919444445 +lon_0=-62 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=41500000 +y_0=5500000",
          6036: "lcc +lat_0=72.02500919444445 +lon_0=-42 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=43500000 +y_0=5500000",
          6037: "lcc +lat_0=72.02500919444445 +lon_0=-22 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=45500000 +y_0=5500000",
          6038: "lcc +lat_0=72.02500919444445 +lon_0=-5 +lat_1=73.66666666666667 +lat_2=70.33333333333333 +x_0=47500000 +y_0=5500000",
          6039: "lcc +lat_0=68.68747555555557 +lon_0=-165 +lat_1=70.33333333333333 +lat_2=67 +x_0=14500000 +y_0=6500000",
          6040: "lcc +lat_0=68.68747555555557 +lon_0=-147 +lat_1=70.33333333333333 +lat_2=67 +x_0=16500000 +y_0=6500000",
          6041: "lcc +lat_0=68.68747555555557 +lon_0=-132 +lat_1=70.33333333333333 +lat_2=67 +x_0=18500000 +y_0=6500000",
          6042: "lcc +lat_0=68.68747555555557 +lon_0=-113 +lat_1=70.33333333333333 +lat_2=67 +x_0=20500000 +y_0=6500000",
          6043: "lcc +lat_0=68.68747555555557 +lon_0=-94 +lat_1=70.33333333333333 +lat_2=67 +x_0=22500000 +y_0=6500000",
          6044: "lcc +lat_0=68.68747555555557 +lon_0=-75 +lat_1=70.33333333333333 +lat_2=67 +x_0=24500000 +y_0=6500000",
          6045: "lcc +lat_0=68.68747555555557 +lon_0=-56 +lat_1=70.33333333333333 +lat_2=67 +x_0=26500000 +y_0=6500000",
          6046: "lcc +lat_0=68.68747555555557 +lon_0=-38 +lat_1=70.33333333333333 +lat_2=67 +x_0=28500000 +y_0=6500000",
          6047: "lcc +lat_0=68.68747555555557 +lon_0=-20 +lat_1=70.33333333333333 +lat_2=67 +x_0=30500000 +y_0=6500000",
          6048: "lcc +lat_0=65.35103930555555 +lon_0=-51 +lat_1=67 +lat_2=63.666666666666664 +x_0=11500000 +y_0=7500000",
          6049: "lcc +lat_0=65.35103930555555 +lon_0=-34 +lat_1=67 +lat_2=63.666666666666664 +x_0=13500000 +y_0=7500000",
          6126: "lcc +lat_0=19.333333333333332 +lon_0=80.56666666666666 +lat_1=19.333333333333332 +lat_2=19.7 +x_0=899160 +y_0=579120",
          6127: "tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=499999.99999800004 +y_0=0",
          6197: "lcc +k_0=1.0000382 +lat_0=45.45 +lon_0=-87 +lat_1=45.483333333333334 +lat_2=47.083333333333336 +x_0=609601.2192024385 +y_0=0",
          6198: "lcc +k_0=1.0000382 +lat_0=43.31666666666667 +lon_0=-84.33333333333333 +lat_1=44.18333333333333 +lat_2=45.7 +x_0=609601.2192024385 +y_0=0",
          6199: "lcc +k_0=1.0000382 +lat_0=41.5 +lon_0=-84.33333333333333 +lat_1=42.1 +lat_2=43.666666666666664 +x_0=609601.2192024385 +y_0=0",
          6203: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=0",
          6212: "col_urban +h_0=100 +lat_0=7.087606391666666 +lon_0=-70.75830965555555 +x_0=1035263.443 +y_0=1275526.621",
          6213: "col_urban +h_0=1470 +lat_0=4.532325 +lon_0=-75.67348916666667 +x_0=1155824.666 +y_0=993087.465",
          6214: "col_urban +h_0=100 +lat_0=10.923183083333333 +lon_0=-74.83433133333332 +x_0=917264.406 +y_0=1699839.935",
          6215: "col_urban +h_0=2550 +lat_0=4.680486111111112 +lon_0=-74.14659166666668 +x_0=92334.879 +y_0=109320.965",
          6216: "col_urban +h_0=931 +lat_0=7.078887141666667 +lon_0=-73.19734322222223 +x_0=1097241.305 +y_0=1274642.278",
          6217: "col_urban +h_0=1000 +lat_0=3.4418833333333336 +lon_0=-76.5205625 +x_0=1061900.18 +y_0=872364.63",
          6218: "col_urban +h_0=0 +lat_0=10.3970475 +lon_0=-75.51120694444444 +x_0=842981.41 +y_0=1641887.09",
          6219: "col_urban +h_0=308 +lat_0=7.888936736111111 +lon_0=-72.50287095 +x_0=842805.406 +y_0=1364404.57",
          6220: "col_urban +h_0=300 +lat_0=1.6210122944444445 +lon_0=-75.61911760277778 +x_0=1162300.348 +y_0=671068.716",
          6221: "col_urban +h_0=1100 +lat_0=4.419412827777778 +lon_0=-75.17992593333334 +x_0=877634.33 +y_0=980541.348",
          6222: "col_urban +h_0=96 +lat_0=3.8454381833333335 +lon_0=-67.9052320888889 +x_0=1019177.687 +y_0=491791.326",
          6223: "col_urban +h_0=89.7 +lat_0=-4.197684047222222 +lon_0=-69.94281105833333 +x_0=25978.217 +y_0=27501.365",
          6224: "col_urban +h_0=2100 +lat_0=5.068153888888888 +lon_0=-75.51109472222223 +x_0=1173727.04 +y_0=1052391.13",
          6225: "col_urban +h_0=1510 +lat_0=6.229208888888889 +lon_0=-75.56488694444444 +x_0=835378.647 +y_0=1180816.875",
          6226: "col_urban +h_0=170 +lat_0=1.2499693666666667 +lon_0=-70.23546165555555 +x_0=1093717.398 +y_0=629997.236",
          6227: "col_urban +h_0=655.2 +lat_0=1.1400233583333332 +lon_0=-76.65102121944444 +x_0=1047467.388 +y_0=617828.474",
          6228: "col_urban +h_0=15 +lat_0=8.773085755555556 +lon_0=-75.87955333055555 +x_0=1131814.934 +y_0=1462131.119",
          6229: "col_urban +h_0=430 +lat_0=2.9424150555555557 +lon_0=-75.29643672222223 +x_0=864476.923 +y_0=817199.827",
          6230: "col_urban +h_0=2530 +lat_0=1.2009895138888889 +lon_0=-77.25312563333334 +x_0=980469.695 +y_0=624555.332",
          6231: "col_urban +h_0=1500 +lat_0=4.813593611111111 +lon_0=-75.69395138888889 +x_0=1153492.012 +y_0=1024195.255",
          6232: "col_urban +h_0=1740 +lat_0=2.4561598833333336 +lon_0=-76.6060916361111 +x_0=1052430.525 +y_0=763366.548",
          6233: "col_urban +h_0=51.58 +lat_0=6.1807214138888895 +lon_0=-67.50075024722223 +x_0=1063834.703 +y_0=1175257.481",
          6234: "col_urban +h_0=44 +lat_0=5.6942476611111115 +lon_0=-76.65075385833335 +x_0=1047273.617 +y_0=1121443.09",
          6235: "col_urban +h_0=6 +lat_0=11.536913327777778 +lon_0=-72.90276886944444 +x_0=1128154.73 +y_0=1767887.914",
          6236: "col_urban +h_0=6 +lat_0=12.523794325 +lon_0=-81.72937595 +x_0=820439.298 +y_0=1877357.828",
          6237: "col_urban +h_0=185 +lat_0=2.5640789416666663 +lon_0=-72.640033325 +x_0=1159876.62 +y_0=775380.342",
          6238: "col_urban +h_0=29 +lat_0=11.219643055555556 +lon_0=-74.22500527777778 +x_0=983892.409 +y_0=1732533.518",
          6239: "col_urban +h_0=20 +lat_0=8.810550366666668 +lon_0=-74.722466825 +x_0=929043.607 +y_0=1466125.658",
          6240: "col_urban +h_0=2800 +lat_0=5.534194738888889 +lon_0=-73.3519389 +x_0=1080514.91 +y_0=1103772.028",
          6241: "col_urban +h_0=200 +lat_0=10.44726111111111 +lon_0=-73.2465713888889 +x_0=1090979.66 +y_0=1647208.93",
          6242: "col_urban +h_0=427.19 +lat_0=4.1553751000000005 +lon_0=-73.62448598611111 +x_0=1050678.757 +y_0=950952.124",
          6243: "col_urban +h_0=300 +lat_0=5.353927222222222 +lon_0=-72.42004027777779 +x_0=851184.177 +y_0=1083954.137",
          6308: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.99995 +x_0=200000 +y_0=-3500000",
          6361: "lcc +lat_0=11.999999999999988 +lon_0=-101.9999999999999 +lat_1=17.499999999999982 +lat_2=29.49999999999997 +x_0=2500000 +y_0=0",
          6374: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=300000 +y_0=0",
          6375: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=300000 +y_0=0",
          6376: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=300000 +y_0=0",
          6377: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=300000 +y_0=0",
          6378: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=300000 +y_0=0",
          6379: "tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=300000 +y_0=0",
          6380: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=300000 +y_0=0",
          6390: "lcc +lat_0=19.333333333333332 +lon_0=-80.56666666666666 +lat_1=19.333333333333332 +lat_2=19.7 +x_0=899160 +y_0=579120",
          6645: "aea +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0",
          6702: "tmerc +lat_0=0 +lon_0=-59.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6716: "tmerc +lat_0=0 +lon_0=105.625 +k_0=1.000024 +x_0=50000 +y_0=1300000",
          6717: "tmerc +lat_0=0 +lon_0=105.625 +k_0=1.00002514 +x_0=50000 +y_0=1300000",
          6718: "tmerc +lat_0=0 +lon_0=96.875 +k_0=1 +x_0=50000 +y_0=1400000",
          6719: "tmerc +lat_0=0 +lon_0=96.875 +k_0=0.99999387 +x_0=50000 +y_0=1500000",
          6725: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6726: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6727: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6728: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6729: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6730: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6731: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          6741: "tmerc +lat_0=44.5 +lon_0=-117.83333333333333 +k_0=1.00016 +x_0=40000 +y_0=0",
          6742: "tmerc +lat_0=44.5 +lon_0=-117.83333333333333 +k_0=1.00016 +x_0=39999.99999984 +y_0=0",
          6743: "tmerc +lat_0=41.75 +lon_0=-121.75 +k_0=1.0002 +x_0=80000 +y_0=0",
          6744: "tmerc +lat_0=41.75 +lon_0=-121.75 +k_0=1.0002 +x_0=79999.99999968 +y_0=0",
          6745: "lcc +lat_0=44.666666666666664 +lon_0=-121.25 +k_0=1.00012 +x_0=80000 +y_0=130000",
          6746: "lcc +lat_0=44.666666666666664 +lon_0=-121.25 +k_0=1.00012 +x_0=79999.99999968 +y_0=130000.00001472",
          6747: "lcc +lat_0=43.666666666666664 +lon_0=-119.75 +k_0=1.0002 +x_0=120000 +y_0=60000",
          6748: "lcc +lat_0=43.666666666666664 +lon_0=-119.75 +k_0=1.0002 +x_0=119999.99999951999 +y_0=59999.999999759995",
          6749: "tmerc +lat_0=42.5 +lon_0=-123.33333333333333 +k_0=1.00007 +x_0=40000 +y_0=0",
          6750: "tmerc +lat_0=42.5 +lon_0=-123.33333333333333 +k_0=1.00007 +x_0=39999.99999984 +y_0=0",
          6751: "lcc +lat_0=45.666666666666664 +lon_0=-120.5 +k_0=1.000008 +x_0=150000 +y_0=30000",
          6752: "lcc +lat_0=45.666666666666664 +lon_0=-120.5 +k_0=1.000008 +x_0=150000.00001464 +y_0=30000.00001512",
          6753: "omerc +x_0=7000000 +y_0=-3000000 +lat_0=45.916666666666664 +lonc=-123 +alpha=294.9999999999997 +gamma=294.9999999999997 +k_0=1",
          6754: "omerc +x_0=7000000.00000248 +y_0=-2999999.9999880004 +lat_0=45.916666666666664 +lonc=-123 +alpha=294.9999999999997 +gamma=294.9999999999997 +k_0=1",
          6755: "tmerc +lat_0=42.833333333333336 +lon_0=-123.33333333333333 +k_0=1.000023 +x_0=50000 +y_0=0",
          6756: "tmerc +lat_0=42.833333333333336 +lon_0=-123.33333333333333 +k_0=1.000023 +x_0=50000.00001504 +y_0=0",
          6757: "tmerc +lat_0=44.5 +lon_0=-121 +k_0=1.00011 +x_0=80000 +y_0=0",
          6758: "tmerc +lat_0=44.5 +lon_0=-121 +k_0=1.00011 +x_0=79999.99999968 +y_0=0",
          6759: "tmerc +lat_0=43.75 +lon_0=-123.16666666666667 +k_0=1.000015 +x_0=50000 +y_0=0",
          6760: "tmerc +lat_0=43.75 +lon_0=-123.16666666666667 +k_0=1.000015 +x_0=50000.00001504 +y_0=0",
          6761: "tmerc +lat_0=41.75 +lon_0=-123.33333333333333 +k_0=1.000043 +x_0=50000 +y_0=0",
          6762: "tmerc +lat_0=41.75 +lon_0=-123.33333333333333 +k_0=1.000043 +x_0=50000.00001504 +y_0=0",
          6763: "tmerc +lat_0=45 +lon_0=-122.33333333333333 +k_0=1.00005 +x_0=10000 +y_0=0",
          6764: "tmerc +lat_0=45 +lon_0=-122.33333333333333 +k_0=1.00005 +x_0=10000.0000152 +y_0=0",
          6765: "tmerc +lat_0=44.99999999999996 +lon_0=-117.99999999999989 +k_0=1.00013 +x_0=40000 +y_0=0",
          6766: "tmerc +lat_0=44.99999999999996 +lon_0=-117.99999999999989 +k_0=1.00013 +x_0=39999.99999984 +y_0=0",
          6767: "tmerc +lat_0=43.25 +lon_0=-117 +k_0=1.0001 +x_0=80000 +y_0=0",
          6768: "tmerc +lat_0=43.25 +lon_0=-117 +k_0=1.0001 +x_0=79999.99999968 +y_0=0",
          6769: "omerc +x_0=-300000 +y_0=-4600000 +lat_0=44.75 +lonc=-124.05 +alpha=4.999999999999995 +gamma=4.999999999999995 +k_0=1",
          6770: "omerc +x_0=-299999.9999988 +y_0=-4600000.00001208 +lat_0=44.75 +lonc=-124.05 +alpha=4.999999999999995 +gamma=4.999999999999995 +k_0=1",
          6771: "tmerc +lat_0=45.25 +lon_0=-119.16666666666667 +k_0=1.000045 +x_0=60000 +y_0=0",
          6772: "tmerc +lat_0=45.25 +lon_0=-119.16666666666667 +k_0=1.000045 +x_0=59999.999999759995 +y_0=0",
          6773: "tmerc +lat_0=45.083333333333336 +lon_0=-118.33333333333333 +k_0=1.000175 +x_0=30000 +y_0=0",
          6774: "tmerc +lat_0=45.083333333333336 +lon_0=-118.33333333333333 +k_0=1.000175 +x_0=30000.00001512 +y_0=0",
          6775: "lcc +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=100000 +y_0=50000",
          6776: "lcc +lat_0=45.5 +lon_0=-122.75 +k_0=1.000002 +x_0=99999.99999960001 +y_0=50000.00001504",
          6777: "tmerc +lat_0=44.333333333333336 +lon_0=-123.08333333333333 +k_0=1.00001 +x_0=50000 +y_0=0",
          6778: "tmerc +lat_0=44.333333333333336 +lon_0=-123.08333333333333 +k_0=1.00001 +x_0=50000.00001504 +y_0=0",
          6779: "tmerc +lat_0=44.083333333333336 +lon_0=-122.5 +k_0=1.000155 +x_0=0 +y_0=0",
          6780: "tmerc +lat_0=44.083333333333336 +lon_0=-122.5 +k_0=1.000155 +x_0=0 +y_0=0",
          6869: "tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          6877: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9985 +x_0=7000000 +y_0=0",
          6878: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=3000000 +y_0=0",
          6920: "lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=400000 +y_0=0",
          6921: "lcc +lat_0=36 +lon_0=-98.25 +lat_1=39.5 +lat_2=37.5 +x_0=399999.99998984 +y_0=0",
          6928: "cea +lon_0=0 +x_0=0 +y_0=0 +lat_1=29.99999999999997",
          6929: "laea +lat_0=89.99999999999991 +lon_0=0 +x_0=0 +y_0=0",
          6930: "laea +lat_0=-89.99999999999991 +lon_0=0 +x_0=0 +y_0=0",
          6952: "tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=0.9999 +x_0=0 +y_0=500000",
          6953: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9999 +x_0=0 +y_0=500000",
          6954: "tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=0.9999 +x_0=0 +y_0=500000",
          6955: "tmerc +lat_0=0 +lon_0=107.75 +k_0=0.9999 +x_0=0 +y_0=500000",
          6961: "lcc +lat_0=40.99999999999996 +lon_0=19.99999999999998 +lat_1=38.999999999999964 +lat_2=42.99999999999996 +x_0=0 +y_0=0",
          6965: "lcc +k_0=1.0000382 +lat_0=44.78333333333333 +lon_0=-87 +lat_1=45.483333333333334 +lat_2=47.083333333333336 +x_0=609601.2192024385 +y_0=0",
          6994: "tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=0.0000010000070000000001 +x_0=48000 +y_0=24000",
          6995: "tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=0.0000010000070000000001 +x_0=48000.00000000001 +y_0=24000.000000000004",
          7043: "lcc +lat_0=43.2 +lon_0=-95.25 +k_0=1.000052 +x_0=3505207.010414021 +y_0=2926085.8521717046",
          7044: "lcc +lat_0=43.166666666666664 +lon_0=-92.75 +k_0=1.000043 +x_0=3810007.6200152407 +y_0=2987045.9740919485",
          7045: "tmerc +lat_0=40.25 +lon_0=-91.2 +k_0=1.000035 +x_0=4114808.22961646 +y_0=2529845.0596901197",
          7046: "lcc +lat_0=42.53333333333333 +lon_0=-94.83333333333333 +k_0=1.000045 +x_0=4419608.839217679 +y_0=2621285.2425704855",
          7047: "lcc +lat_0=42.65 +lon_0=-92.25 +k_0=1.000032 +x_0=4724409.448818898 +y_0=2712725.425450851",
          7048: "tmerc +lat_0=40.25 +lon_0=-95.73333333333333 +k_0=1.000039 +x_0=5029210.058420118 +y_0=2011684.023368047",
          7049: "tmerc +lat_0=40.25 +lon_0=-94.63333333333334 +k_0=1.000045 +x_0=5334010.668021337 +y_0=2072644.145288291",
          7050: "tmerc +lat_0=40.25 +lon_0=-93.71666666666667 +k_0=1.000033 +x_0=5638811.277622556 +y_0=2133604.2672085348",
          7051: "tmerc +lat_0=40.25 +lon_0=-92.81666666666666 +k_0=1.000027 +x_0=5943611.8872237755 +y_0=2194564.3891287786",
          7052: "lcc +lat_0=41.833333333333336 +lon_0=-91.66666666666667 +k_0=1.00002 +x_0=6248412.496824995 +y_0=2438404.876809754",
          7053: "tmerc +lat_0=40.25 +lon_0=-90.53333333333333 +k_0=1.000027 +x_0=6553213.106426214 +y_0=2316484.6329692663",
          7054: "lcc +lat_0=40.916666666666664 +lon_0=-93.75 +k_0=1.000037 +x_0=6858013.716027433 +y_0=1889763.7795275594",
          7055: "tmerc +lat_0=40.25 +lon_0=-91.91666666666667 +k_0=1.00002 +x_0=7162814.325628652 +y_0=1950723.9014478032",
          7056: "tmerc +lat_0=40.25 +lon_0=-91.25 +k_0=1.000018 +x_0=7467614.935229871 +y_0=1889763.7795275594",
          7089: "tmerc +lat_0=48.5 +lon_0=-112.5 +k_0=1.00016 +x_0=150000 +y_0=0",
          7090: "tmerc +lat_0=48.5 +lon_0=-112.5 +k_0=1.00016 +x_0=150000.00001464 +y_0=0",
          7091: "tmerc +lat_0=48 +lon_0=-112.5 +k_0=1.00019 +x_0=100000 +y_0=0",
          7092: "tmerc +lat_0=48 +lon_0=-112.5 +k_0=1.00019 +x_0=99999.99999960001 +y_0=0",
          7093: "lcc +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000 +y_0=200000",
          7094: "lcc +lat_0=48.5 +lon_0=-111 +k_0=1.000145 +x_0=150000.00001464 +y_0=199999.99999920002",
          7095: "lcc +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=200000 +y_0=150000",
          7096: "lcc +lat_0=48.5 +lon_0=-108.5 +k_0=1.00012 +x_0=199999.99999920002 +y_0=150000.00001464",
          7097: "lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00012 +x_0=200000 +y_0=100000",
          7098: "lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00012 +x_0=199999.99999920002 +y_0=99999.99999960001",
          7099: "lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00009 +x_0=100000 +y_0=50000",
          7100: "lcc +lat_0=48.333333333333336 +lon_0=-105.5 +k_0=1.00009 +x_0=99999.99999960001 +y_0=49999.99971024",
          7101: "tmerc +lat_0=44.75 +lon_0=-107.75 +k_0=1.000148 +x_0=200000 +y_0=0",
          7102: "tmerc +lat_0=44.75 +lon_0=-107.75 +k_0=1.000148 +x_0=199999.99999920002 +y_0=0",
          7103: "lcc +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=100000 +y_0=100000",
          7104: "lcc +lat_0=46.25 +lon_0=-111.25 +k_0=1.000185 +x_0=99999.99999960001 +y_0=99999.99999960001",
          7105: "lcc +lat_0=45.78333333333333 +lon_0=-108.41666666666667 +k_0=1.0001515 +x_0=200000 +y_0=50000",
          7106: "lcc +lat_0=45.78333333333333 +lon_0=-108.41666666666667 +k_0=1.0001515 +x_0=199999.99999920002 +y_0=50000.00001504",
          7107: "tmerc +lat_0=42.666666666666664 +lon_0=-108.33333333333333 +k_0=1.00024 +x_0=100000 +y_0=0",
          7108: "tmerc +lat_0=42.666666666666664 +lon_0=-108.33333333333333 +k_0=1.00024 +x_0=99999.99998984 +y_0=0",
          7129: "tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=1.000007 +x_0=48000 +y_0=24000",
          7130: "tmerc +lat_0=37.749999999999964 +lon_0=-122.44999999999987 +k_0=1.000007 +x_0=48000.00000000001 +y_0=24000.000000000004",
          7141: "tmerc +lat_0=31.734096944444445 +lon_0=35.21208055555556 +k_0=1 +x_0=170251.555 +y_0=126867.909",
          7143: "tmerc +lat_0=40.55 +lon_0=-84.95 +k_0=1.000034 +x_0=240000 +y_0=36000",
          7144: "tmerc +lat_0=40.55 +lon_0=-84.95 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7145: "tmerc +lat_0=40.9 +lon_0=-85.05 +k_0=1.000031 +x_0=240000 +y_0=36000",
          7146: "tmerc +lat_0=40.9 +lon_0=-85.05 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7147: "tmerc +lat_0=39 +lon_0=-85.85 +k_0=1.000026 +x_0=240000 +y_0=36000",
          7148: "tmerc +lat_0=39 +lon_0=-85.85 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7149: "tmerc +lat_0=40.45 +lon_0=-87.3 +k_0=1.000029 +x_0=240000 +y_0=36000",
          7150: "tmerc +lat_0=40.45 +lon_0=-87.3 +k_0=1.000029 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7151: "tmerc +lat_0=40.05 +lon_0=-85.4 +k_0=1.000038 +x_0=240000 +y_0=36000",
          7152: "tmerc +lat_0=40.05 +lon_0=-85.4 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7153: "tmerc +lat_0=39.6 +lon_0=-86.5 +k_0=1.000036 +x_0=240000 +y_0=36000",
          7154: "tmerc +lat_0=39.6 +lon_0=-86.5 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7155: "tmerc +lat_0=39 +lon_0=-86.3 +k_0=1.00003 +x_0=240000 +y_0=36000",
          7156: "tmerc +lat_0=39 +lon_0=-86.3 +k_0=1.00003 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7157: "tmerc +lat_0=40.4 +lon_0=-86.65 +k_0=1.000026 +x_0=240000 +y_0=36000",
          7158: "tmerc +lat_0=40.4 +lon_0=-86.65 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7159: "tmerc +lat_0=40.55 +lon_0=-86.4 +k_0=1.000028 +x_0=240000 +y_0=36000",
          7160: "tmerc +lat_0=40.55 +lon_0=-86.4 +k_0=1.000028 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7161: "tmerc +lat_0=38.15 +lon_0=-85.6 +k_0=1.000021 +x_0=240000 +y_0=36000",
          7162: "tmerc +lat_0=38.15 +lon_0=-85.6 +k_0=1.000021 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7163: "tmerc +lat_0=39.15 +lon_0=-87.15 +k_0=1.000024 +x_0=240000 +y_0=36000",
          7164: "tmerc +lat_0=39.15 +lon_0=-87.15 +k_0=1.000024 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7165: "tmerc +lat_0=40.15 +lon_0=-86.6 +k_0=1.000032 +x_0=240000 +y_0=36000",
          7166: "tmerc +lat_0=40.15 +lon_0=-86.6 +k_0=1.000032 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7167: "tmerc +lat_0=38.1 +lon_0=-86.5 +k_0=1.000025 +x_0=240000 +y_0=36000",
          7168: "tmerc +lat_0=38.1 +lon_0=-86.5 +k_0=1.000025 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7169: "tmerc +lat_0=38.45 +lon_0=-87.1 +k_0=1.000018 +x_0=240000 +y_0=36000",
          7170: "tmerc +lat_0=38.45 +lon_0=-87.1 +k_0=1.000018 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7171: "tmerc +lat_0=38.65 +lon_0=-84.9 +k_0=1.000029 +x_0=240000 +y_0=36000",
          7172: "tmerc +lat_0=38.65 +lon_0=-84.9 +k_0=1.000029 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7173: "tmerc +lat_0=39.1 +lon_0=-85.65 +k_0=1.000036 +x_0=240000 +y_0=36000",
          7174: "tmerc +lat_0=39.1 +lon_0=-85.65 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7175: "tmerc +lat_0=41.25 +lon_0=-84.95 +k_0=1.000036 +x_0=240000 +y_0=36000",
          7176: "tmerc +lat_0=41.25 +lon_0=-84.95 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7177: "tmerc +lat_0=38.2 +lon_0=-86.95 +k_0=1.00002 +x_0=240000 +y_0=36000",
          7178: "tmerc +lat_0=38.2 +lon_0=-86.95 +k_0=1.00002 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7179: "tmerc +lat_0=40.65 +lon_0=-85.85 +k_0=1.000033 +x_0=240000 +y_0=36000",
          7180: "tmerc +lat_0=40.65 +lon_0=-85.85 +k_0=1.000033 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7181: "tmerc +lat_0=39.25 +lon_0=-85.05 +k_0=1.000038 +x_0=240000 +y_0=36000",
          7182: "tmerc +lat_0=39.25 +lon_0=-85.05 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7183: "tmerc +lat_0=39.95 +lon_0=-87.3 +k_0=1.000025 +x_0=240000 +y_0=36000",
          7184: "tmerc +lat_0=39.95 +lon_0=-87.3 +k_0=1.000025 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7185: "tmerc +lat_0=40.9 +lon_0=-86.3 +k_0=1.000031 +x_0=240000 +y_0=36000",
          7186: "tmerc +lat_0=40.9 +lon_0=-86.3 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7187: "tmerc +lat_0=38.15 +lon_0=-87.65 +k_0=1.000013 +x_0=240000 +y_0=36000",
          7188: "tmerc +lat_0=38.15 +lon_0=-87.65 +k_0=1.000013 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7189: "tmerc +lat_0=40.35 +lon_0=-85.7 +k_0=1.000034 +x_0=240000 +y_0=36000",
          7190: "tmerc +lat_0=40.35 +lon_0=-85.7 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7191: "tmerc +lat_0=39.9 +lon_0=-86 +k_0=1.000034 +x_0=240000 +y_0=36000",
          7192: "tmerc +lat_0=39.9 +lon_0=-86 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7193: "tmerc +lat_0=39.65 +lon_0=-85.8 +k_0=1.000036 +x_0=240000 +y_0=36000",
          7194: "tmerc +lat_0=39.65 +lon_0=-85.8 +k_0=1.000036 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7195: "tmerc +lat_0=37.95 +lon_0=-86.15 +k_0=1.000027 +x_0=240000 +y_0=36000",
          7196: "tmerc +lat_0=37.95 +lon_0=-86.15 +k_0=1.000027 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7197: "tmerc +lat_0=39.75 +lon_0=-85.45 +k_0=1.000043 +x_0=240000 +y_0=36000",
          7198: "tmerc +lat_0=39.75 +lon_0=-85.45 +k_0=1.000043 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7199: "tmerc +lat_0=40.35 +lon_0=-86.15 +k_0=1.000031 +x_0=240000 +y_0=36000",
          7200: "tmerc +lat_0=40.35 +lon_0=-86.15 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7201: "tmerc +lat_0=40.65 +lon_0=-85.5 +k_0=1.000034 +x_0=240000 +y_0=36000",
          7202: "tmerc +lat_0=40.65 +lon_0=-85.5 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7203: "tmerc +lat_0=38.7 +lon_0=-85.95 +k_0=1.000022 +x_0=240000 +y_0=36000",
          7204: "tmerc +lat_0=38.7 +lon_0=-85.95 +k_0=1.000022 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7205: "tmerc +lat_0=40.7 +lon_0=-87.1 +k_0=1.000027 +x_0=240000 +y_0=36000",
          7206: "tmerc +lat_0=40.7 +lon_0=-87.1 +k_0=1.000027 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7207: "tmerc +lat_0=40.3 +lon_0=-85 +k_0=1.000038 +x_0=240000 +y_0=36000",
          7208: "tmerc +lat_0=40.3 +lon_0=-85 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7209: "tmerc +lat_0=38.55 +lon_0=-85.35 +k_0=1.000028 +x_0=240000 +y_0=36000",
          7210: "tmerc +lat_0=38.55 +lon_0=-85.35 +k_0=1.000028 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7211: "tmerc +lat_0=38.8 +lon_0=-85.8 +k_0=1.000025 +x_0=240000 +y_0=36000",
          7212: "tmerc +lat_0=38.8 +lon_0=-85.8 +k_0=1.000025 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7213: "tmerc +lat_0=39.3 +lon_0=-86.15 +k_0=1.000031 +x_0=240000 +y_0=36000",
          7214: "tmerc +lat_0=39.3 +lon_0=-86.15 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7215: "tmerc +lat_0=38.4 +lon_0=-87.45 +k_0=1.000015 +x_0=240000 +y_0=36000",
          7216: "tmerc +lat_0=38.4 +lon_0=-87.45 +k_0=1.000015 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7217: "tmerc +lat_0=41.25 +lon_0=-85.45 +k_0=1.000037 +x_0=240000 +y_0=36000",
          7218: "tmerc +lat_0=41.25 +lon_0=-85.45 +k_0=1.000037 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7219: "tmerc +lat_0=40.7 +lon_0=-87.4 +k_0=1.000026 +x_0=240000 +y_0=36000",
          7220: "tmerc +lat_0=40.7 +lon_0=-87.4 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7221: "tmerc +lat_0=40.9 +lon_0=-86.75 +k_0=1.000027 +x_0=240000 +y_0=36000",
          7222: "tmerc +lat_0=40.9 +lon_0=-86.75 +k_0=1.000027 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7223: "tmerc +lat_0=38.95 +lon_0=-86.5 +k_0=1.000028 +x_0=240000 +y_0=36000",
          7224: "tmerc +lat_0=38.95 +lon_0=-86.5 +k_0=1.000028 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7225: "tmerc +lat_0=39.45 +lon_0=-86.95 +k_0=1.000031 +x_0=240000 +y_0=36000",
          7226: "tmerc +lat_0=39.45 +lon_0=-86.95 +k_0=1.000031 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7227: "tmerc +lat_0=39.15 +lon_0=-86.9 +k_0=1.000026 +x_0=240000 +y_0=36000",
          7228: "tmerc +lat_0=39.15 +lon_0=-86.9 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7229: "tmerc +lat_0=39.6 +lon_0=-87.35 +k_0=1.000022 +x_0=240000 +y_0=36000",
          7230: "tmerc +lat_0=39.6 +lon_0=-87.35 +k_0=1.000022 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7231: "tmerc +lat_0=37.8 +lon_0=-86.7 +k_0=1.00002 +x_0=240000 +y_0=36000",
          7232: "tmerc +lat_0=37.8 +lon_0=-86.7 +k_0=1.00002 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7233: "tmerc +lat_0=37.85 +lon_0=-87.3 +k_0=1.000015 +x_0=240000 +y_0=36000",
          7234: "tmerc +lat_0=37.85 +lon_0=-87.3 +k_0=1.000015 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7235: "tmerc +lat_0=37.75 +lon_0=-87.95 +k_0=1.000013 +x_0=240000 +y_0=36000",
          7236: "tmerc +lat_0=37.75 +lon_0=-87.95 +k_0=1.000013 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7237: "tmerc +lat_0=39.7 +lon_0=-85.05 +k_0=1.000044 +x_0=240000 +y_0=36000",
          7238: "tmerc +lat_0=39.7 +lon_0=-85.05 +k_0=1.000044 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7239: "tmerc +lat_0=38.9 +lon_0=-85.3 +k_0=1.000038 +x_0=240000 +y_0=36000",
          7240: "tmerc +lat_0=38.9 +lon_0=-85.3 +k_0=1.000038 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7241: "tmerc +lat_0=39.3 +lon_0=-85.9 +k_0=1.00003 +x_0=240000 +y_0=36000",
          7242: "tmerc +lat_0=39.3 +lon_0=-85.9 +k_0=1.00003 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7243: "tmerc +lat_0=37.75 +lon_0=-87.05 +k_0=1.000014 +x_0=240000 +y_0=36000",
          7244: "tmerc +lat_0=37.75 +lon_0=-87.05 +k_0=1.000014 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7245: "tmerc +lat_0=41.5 +lon_0=-85 +k_0=1.000041 +x_0=240000 +y_0=36000",
          7246: "tmerc +lat_0=41.5 +lon_0=-85 +k_0=1.000041 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7247: "tmerc +lat_0=38.9 +lon_0=-87.5 +k_0=1.000017 +x_0=240000 +y_0=36000",
          7248: "tmerc +lat_0=38.9 +lon_0=-87.5 +k_0=1.000017 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7249: "tmerc +lat_0=40.2 +lon_0=-86.9 +k_0=1.000026 +x_0=240000 +y_0=36000",
          7250: "tmerc +lat_0=40.2 +lon_0=-86.9 +k_0=1.000026 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7251: "tmerc +lat_0=37.8 +lon_0=-87.55 +k_0=1.000015 +x_0=240000 +y_0=36000",
          7252: "tmerc +lat_0=37.8 +lon_0=-87.55 +k_0=1.000015 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7253: "tmerc +lat_0=39.25 +lon_0=-87.45 +k_0=1.00002 +x_0=240000 +y_0=36000",
          7254: "tmerc +lat_0=39.25 +lon_0=-87.45 +k_0=1.00002 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7255: "tmerc +lat_0=40.55 +lon_0=-85.25 +k_0=1.000034 +x_0=240000 +y_0=36000",
          7256: "tmerc +lat_0=40.55 +lon_0=-85.25 +k_0=1.000034 +x_0=240000.00000000003 +y_0=36000.00000000001",
          7378: "tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k_0=1.0000495683 +x_0=172821.9461 +y_0=0.0017",
          7379: "tmerc +lat_0=45.70611111111111 +lon_0=-90.62222222222222 +k_0=1.0000495683 +x_0=172821.94594869192 +y_0=0.0018288036576073155",
          7380: "lcc +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.4575 +y_0=148551.4837",
          7381: "lcc +lat_0=46.66964837722222 +lon_0=-91.15277777777779 +k_0=1.0000331195 +x_0=228600.45750571505 +y_0=148551.48356616715",
          7382: "lcc +lat_0=45.898714865833334 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.1276 +y_0=59445.9043",
          7383: "lcc +lat_0=45.898714865833334 +lon_0=-92.45777777777778 +k_0=1.0000383841 +x_0=64008.12771145543 +y_0=59445.90419100839",
          7384: "tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k_0=1.0000385418 +x_0=59131.3183 +y_0=0.0041",
          7385: "tmerc +lat_0=45.88333333333333 +lon_0=-91.91666666666667 +k_0=1.0000385418 +x_0=59131.31826263653 +y_0=0.00396240792481585",
          7386: "tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k_0=1.0000552095 +x_0=133502.6683 +y_0=0.0063",
          7387: "tmerc +lat_0=45.43888888888888 +lon_0=-88.14166666666668 +k_0=1.0000552095 +x_0=133502.66822453646 +y_0=0.006400812801625604",
          7388: "tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k_0=1.0000673004 +x_0=275844.5533 +y_0=0.0157",
          7389: "tmerc +lat_0=44.00555555555555 +lon_0=-88.63333333333334 +k_0=1.0000673004 +x_0=275844.55321310647 +y_0=0.0158496316992634",
          7390: "tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k_0=1.0000677153 +x_0=220980.4419 +y_0=0.0085",
          7391: "tmerc +lat_0=45.43333333333333 +lon_0=-90.25555555555556 +k_0=1.0000677153 +x_0=220980.44196088394 +y_0=0.008534417068834139",
          7392: "lcc +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.1401 +y_0=57588.0346",
          7393: "lcc +lat_0=45.70422377027778 +lon_0=-89.54444444444444 +k_0=1.0000686968 +x_0=70104.14020828043 +y_0=57588.03474726951",
          7394: "tmerc +lat_0=44.55555555555555 +lon_0=-90.4888888888889 +k_0=1.0000649554 +x_0=227990.8546 +y_0=0.0109",
          7395: "tmerc +lat_0=44.55555555555555 +lon_0=-90.4888888888889 +k_0=1.0000649554 +x_0=227990.85445770895 +y_0=0.010972821945643892",
          7396: "lcc +lat_0=45.900099131388885 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2336 +y_0=120734.1631",
          7397: "lcc +lat_0=45.900099131388885 +lon_0=-91.11666666666666 +k_0=1.0000573461 +x_0=216713.2337312675 +y_0=120734.16316992637",
          7398: "lcc +lat_0=46.07784409055556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0689 +y_0=50337.1092",
          7399: "lcc +lat_0=46.07784409055556 +lon_0=-89.4888888888889 +k_0=1.0000730142 +x_0=134417.0688341377 +y_0=50337.10927101855",
          7424: "lcc +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.8682 +y_0=188358.6058",
          7425: "lcc +lat_0=45.96121983333334 +lon_0=-91.78333333333333 +k_0=1.0000475376 +x_0=234086.86817373638 +y_0=188358.6059436119",
          7426: "tmerc +lat_0=45.13333333333333 +lon_0=-91.85 +k_0=1.0000486665 +x_0=93150 +y_0=0.0029",
          7427: "tmerc +lat_0=45.13333333333333 +lon_0=-91.85 +k_0=1.0000486665 +x_0=93150.00000000001 +y_0=0.0030480060960121924",
          7428: "tmerc +lat_0=42.99999999999996 +lon_0=-87.99999999999991 +k_0=1.00002 +x_0=31600 +y_0=4600",
          7429: "tmerc +lat_0=43 +lon_0=-88 +k_0=1.00002 +x_0=31599.9998983998 +y_0=4599.9998983997975",
          7430: "tmerc +lat_0=43.481388888888894 +lon_0=-91.79722222222222 +k_0=1.0000382778 +x_0=175260.3502 +y_0=0.0048",
          7431: "tmerc +lat_0=43.481388888888894 +lon_0=-91.79722222222222 +k_0=1.0000382778 +x_0=175260.35021590043 +y_0=0.004876809753619508",
          7432: "lcc +lat_0=44.977856898611115 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72 +y_0=44091.4346",
          7433: "lcc +lat_0=44.977856898611115 +lon_0=-91.29444444444444 +k_0=1.0000391127 +x_0=60045.72009144019 +y_0=44091.434493268986",
          7434: "tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k_0=1.0000463003 +x_0=199949.1989 +y_0=0.0086",
          7435: "tmerc +lat_0=43.6 +lon_0=-90.70833333333334 +k_0=1.0000463003 +x_0=199949.19898399798 +y_0=0.008534417068834139",
          7436: "tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k_0=1.0000187521 +x_0=158801.1176 +y_0=0.0023",
          7437: "tmerc +lat_0=44.4 +lon_0=-87.27222222222223 +k_0=1.0000187521 +x_0=158801.11760223523 +y_0=0.002438404876809754",
          7438: "tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k_0=1.0000410324 +x_0=51816.104 +y_0=0.003",
          7439: "tmerc +lat_0=44.40833333333333 +lon_0=-91.89444444444445 +k_0=1.0000410324 +x_0=51816.10393700788 +y_0=0.0030480060960121924",
          7440: "lcc +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.4402 +y_0=91687.9239",
          7441: "lcc +lat_0=44.87228112638889 +lon_0=-91.28888888888889 +k_0=1.000035079 +x_0=120091.44018288038 +y_0=91687.92390144782",
          7450: "tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k_0=1.0000353 +x_0=27000 +y_0=25000",
          7451: "tmerc +lat_0=44.25333512777778 +lon_0=-90.84429651944444 +k_0=1.0000353 +x_0=27000.000000000004 +y_0=24999.9998983998",
          7452: "lcc +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.197 +y_0=105279.7829",
          7453: "lcc +lat_0=45.15423710527778 +lon_0=-89.03333333333333 +k_0=1.0000627024 +x_0=198425.19685039372 +y_0=105279.78288036576",
          7454: "tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k_0=1.0000599003 +x_0=116129.0323 +y_0=0.0058",
          7455: "tmerc +lat_0=44.84444444444445 +lon_0=-89.73333333333333 +k_0=1.0000599003 +x_0=116129.03225806453 +y_0=0.005791211582423165",
          7456: "lcc +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.1493 +y_0=55049.2669",
          7457: "lcc +lat_0=44.90090442361111 +lon_0=-89.77 +k_0=1.000053289 +x_0=74676.14935229871 +y_0=55049.266954533916",
          7458: "tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k_0=1.0000234982 +x_0=238658.8794 +y_0=0.0032",
          7459: "tmerc +lat_0=44.69166666666666 +lon_0=-87.71111111111111 +k_0=1.0000234982 +x_0=238658.87945135892 +y_0=0.0030480060960121924",
          7460: "tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k_0=1.0000362499 +x_0=105461.0121 +y_0=0.0029",
          7461: "tmerc +lat_0=44.71666666666667 +lon_0=-88.41666666666667 +k_0=1.0000362499 +x_0=105461.0121412243 +y_0=0.0030480060960121924",
          7462: "tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k_0=1.0000236869 +x_0=182880.3676 +y_0=0.0033",
          7463: "tmerc +lat_0=44.39722222222222 +lon_0=-87.90833333333335 +k_0=1.0000236869 +x_0=182880.36758953522 +y_0=0.0033528067056134113",
          7464: "lcc +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.3354 +y_0=86033.0876",
          7465: "lcc +lat_0=44.63614887194444 +lon_0=-92.22777777777777 +k_0=1.0000362977 +x_0=167640.33528067058 +y_0=86033.08773177548",
          7466: "tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k_0=1.0000433849 +x_0=141732.2823 +y_0=0.0059",
          7467: "tmerc +lat_0=44.66111111111111 +lon_0=-92.63333333333334 +k_0=1.0000433849 +x_0=141732.2822453645 +y_0=0.005791211582423165",
          7468: "lcc +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.1128 +y_0=50022.1874",
          7469: "lcc +lat_0=44.41682397527777 +lon_0=-89.5 +k_0=1.000039936 +x_0=56388.11277622556 +y_0=50022.18745237491",
          7470: "tmerc +lat_0=43.919444444444444 +lon_0=-91.06666666666666 +k_0=1.0000495976 +x_0=250546.1013 +y_0=0.0234",
          7471: "tmerc +lat_0=43.919444444444444 +lon_0=-91.06666666666666 +k_0=1.0000495976 +x_0=250546.10139700284 +y_0=0.023469646939293883",
          7472: "tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k_0=1.000032144 +x_0=262433.3253 +y_0=0.0096",
          7473: "tmerc +lat_0=44.03611111111111 +lon_0=-88.60555555555555 +k_0=1.000032144 +x_0=262433.3251714504 +y_0=0.009448818897637797",
          7474: "tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k_0=1.0000381803 +x_0=165506.7302 +y_0=0.0103",
          7475: "tmerc +lat_0=44.03611111111111 +lon_0=-92.63333333333334 +k_0=1.0000381803 +x_0=165506.73009906022 +y_0=0.010363220726441455",
          7476: "lcc +lat_0=45.177822085833334 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5744 +y_0=107746.7522",
          7477: "lcc +lat_0=45.177822085833334 +lon_0=-90.48333333333333 +k_0=1.0000597566 +x_0=187147.5742951486 +y_0=107746.75214630431",
          7478: "tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k_0=1.0000361538 +x_0=256946.9138 +y_0=0.0041",
          7479: "tmerc +lat_0=43.16111111111111 +lon_0=-91.36666666666666 +k_0=1.0000361538 +x_0=256946.91389382782 +y_0=0.00396240792481585",
          7480: "tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k_0=1.0000333645 +x_0=185013.9709 +y_0=0.007",
          7481: "tmerc +lat_0=43.42027777777778 +lon_0=-88.81666666666666 +k_0=1.0000333645 +x_0=185013.97094234193 +y_0=0.007010414020828043",
          7482: "lcc +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.6173 +y_0=134589.754",
          7483: "lcc +lat_0=44.36259546944444 +lon_0=-90 +k_0=1.0000421209 +x_0=208483.61727203458 +y_0=134589.75392430785",
          7484: "tmerc +lat_0=43.36666666666667 +lon_0=-90 +k_0=1.0000365285 +x_0=147218.6942 +y_0=0.0037",
          7485: "tmerc +lat_0=43.36666666666667 +lon_0=-90 +k_0=1.0000365285 +x_0=147218.69413258828 +y_0=0.003657607315214631",
          7486: "tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k_0=1.0000286569 +x_0=244754.8893 +y_0=0.0049",
          7487: "tmerc +lat_0=42.71944444444445 +lon_0=-88.5 +k_0=1.0000286569 +x_0=244754.88920497842 +y_0=0.004876809753619508",
          7488: "lcc +lat_0=43.462546645833335 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.3381 +y_0=111569.6134",
          7489: "lcc +lat_0=43.462546645833335 +lon_0=-89.39444444444445 +k_0=1.00003498 +x_0=169164.33802387604 +y_0=111569.61351282703",
          7490: "lcc +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.6274 +y_0=53703.1201",
          7491: "lcc +lat_0=43.200055605 +lon_0=-90.9388888888889 +k_0=1.0000349151 +x_0=113690.62738125477 +y_0=53703.120243840494",
          7492: "lcc +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2944 +y_0=146591.9896",
          7493: "lcc +lat_0=43.0695160375 +lon_0=-89.42222222222223 +k_0=1.0000384786 +x_0=247193.2943865888 +y_0=146591.9896367793",
          7494: "tmerc +lat_0=41.47222222222222 +lon_0=-88.775 +k_0=1.0000346418 +x_0=263347.7263 +y_0=0.0076",
          7495: "tmerc +lat_0=41.47222222222222 +lon_0=-88.775 +k_0=1.0000346418 +x_0=263347.7263906528 +y_0=0.0076200152400304816",
          7496: "tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k_0=1.0000349452 +x_0=242316.4841 +y_0=0.01",
          7497: "tmerc +lat_0=41.41111111111111 +lon_0=-90.8 +k_0=1.0000349452 +x_0=242316.48402336807 +y_0=0.010058420116840236",
          7498: "lcc +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.7403 +y_0=45830.2947",
          7499: "lcc +lat_0=42.63756227694444 +lon_0=-89.83888888888889 +k_0=1.0000390487 +x_0=170078.74015748032 +y_0=45830.2948437897",
          7500: "lcc +lat_0=43.807000117777775 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.3018 +y_0=79170.7795",
          7501: "lcc +lat_0=43.807000117777775 +lon_0=-89.24166666666667 +k_0=1.0000344057 +x_0=150876.30175260353 +y_0=79170.77937515876",
          7502: "tmerc +lat_0=42.538888888888884 +lon_0=-90.16111111111111 +k_0=1.0000394961 +x_0=113081.0261 +y_0=0.0045",
          7503: "tmerc +lat_0=42.538888888888884 +lon_0=-90.16111111111111 +k_0=1.0000394961 +x_0=113081.02616205234 +y_0=0.004572009144018289",
          7504: "tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k_0=1.0000260649 +x_0=185928.3728 +y_0=0.0009",
          7505: "tmerc +lat_0=42.21666666666667 +lon_0=-87.89444444444445 +k_0=1.0000260649 +x_0=185928.37277114557 +y_0=0.0009144018288036578",
          7506: "tmerc +lat_0=43.266666666666666 +lon_0=-87.55 +k_0=1.0000233704 +x_0=79857.7614 +y_0=0.0012",
          7507: "tmerc +lat_0=43.266666666666666 +lon_0=-87.55 +k_0=1.0000233704 +x_0=79857.76154432309 +y_0=0.001219202438404877",
          7508: "tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k_0=1.0000319985 +x_0=130454.6598 +y_0=0.0033",
          7509: "tmerc +lat_0=43.45111111111111 +lon_0=-91.31666666666666 +k_0=1.0000319985 +x_0=130454.6596901194 +y_0=0.0033528067056134113",
          7510: "lcc +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.209 +y_0=121923.9861",
          7511: "lcc +lat_0=44.00007392861111 +lon_0=-90.64166666666668 +k_0=1.0000434122 +x_0=204521.2090424181 +y_0=121923.98618237238",
          7512: "lcc +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.6048 +y_0=134255.4253",
          7513: "lcc +lat_0=43.3223129275 +lon_0=-90.43055555555556 +k_0=1.0000375653 +x_0=202387.60477520956 +y_0=134255.42545085092",
          7514: "tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k_0=1.0000337311 +x_0=146304.2926 +y_0=0.0068",
          7515: "tmerc +lat_0=41.94444444444444 +lon_0=-89.07222222222222 +k_0=1.0000337311 +x_0=146304.29260858524 +y_0=0.006705613411226823",
          7516: "tmerc +lat_0=42.81944444444445 +lon_0=-89.9 +k_0=1.0000373868 +x_0=185623.5716 +y_0=0.0051",
          7517: "tmerc +lat_0=42.81944444444445 +lon_0=-89.9 +k_0=1.0000373868 +x_0=185623.57155194314 +y_0=0.0051816103632207275",
          7518: "lcc +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.4451 +y_0=47532.0602",
          7519: "lcc +lat_0=43.57503293972223 +lon_0=-90.78333333333333 +k_0=1.0000408158 +x_0=222504.44500889003 +y_0=47532.06035052071",
          7520: "lcc +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.8651 +y_0=111088.2224",
          7521: "lcc +lat_0=42.66946209694444 +lon_0=-88.54166666666667 +k_0=1.0000367192 +x_0=232562.86512573028 +y_0=111088.22240284483",
          7522: "tmerc +lat_0=42.918055555555554 +lon_0=-88.06388888888888 +k_0=1.00003738 +x_0=120091.4415 +y_0=0.003",
          7523: "tmerc +lat_0=42.918055555555554 +lon_0=-88.06388888888888 +k_0=1.00003738 +x_0=120091.44140208283 +y_0=0.0030480060960121924",
          7524: "tmerc +lat_0=42.56944444444445 +lon_0=-88.22500000000001 +k_0=1.0000346179 +x_0=208788.418 +y_0=0.0034",
          7525: "tmerc +lat_0=42.56944444444445 +lon_0=-88.22500000000001 +k_0=1.0000346179 +x_0=208788.4178816358 +y_0=0.0033528067056134113",
          7526: "lcc +lat_0=44.113944045833335 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.4402 +y_0=45069.7587",
          7527: "lcc +lat_0=44.113944045833335 +lon_0=-89.24166666666667 +k_0=1.0000392096 +x_0=120091.44018288038 +y_0=45069.758801117605",
          7687: "tmerc +lat_0=0 +lon_0=68.51666666666667 +k_0=1 +x_0=1300000 +y_0=14743.5",
          7688: "tmerc +lat_0=0 +lon_0=71.51666666666667 +k_0=1 +x_0=2300000 +y_0=14743.5",
          7689: "tmerc +lat_0=0 +lon_0=74.51666666666667 +k_0=1 +x_0=3300000 +y_0=14743.5",
          7690: "tmerc +lat_0=0 +lon_0=77.51666666666667 +k_0=1 +x_0=4300000 +y_0=14743.5",
          7691: "tmerc +lat_0=0 +lon_0=80.51666666666667 +k_0=1 +x_0=5300000 +y_0=14743.5",
          7722: "lcc +lat_0=23.999999999999975 +lon_0=79.99999999999991 +lat_1=12.472955 +lat_2=35.172804444444445 +x_0=4000000 +y_0=4000000",
          7723: "lcc +lat_0=16.25543297999998 +lon_0=80.87499999999991 +lat_1=13.749999999999986 +lat_2=18.749999999999982 +x_0=1000000 +y_0=1000000",
          7724: "lcc +lat_0=28.001578969999972 +lon_0=94.4999999999999 +lat_1=26.99999999999997 +lat_2=28.99999999999997 +x_0=1000000 +y_0=1000000",
          7725: "lcc +lat_0=26.002577029999976 +lon_0=92.7499999999999 +lat_1=24.666666666666668 +lat_2=27.333333333333332 +x_0=1000000 +y_0=1000000",
          7726: "lcc +lat_0=25.877252469999974 +lon_0=85.87499999999991 +lat_1=24.624999999999975 +lat_2=27.12499999999997 +x_0=1000000 +y_0=1000000",
          7727: "lcc +lat_0=28.625101259999973 +lon_0=76.99999999999993 +lat_1=28.375 +lat_2=28.875 +x_0=1000000 +y_0=1000000",
          7728: "lcc +lat_0=22.37807120999998 +lon_0=71.37499999999993 +lat_1=20.791666666666668 +lat_2=23.958333333333332 +x_0=1000000 +y_0=1000000",
          7729: "lcc +lat_0=29.25226265999997 +lon_0=75.99999999999993 +lat_1=28.083333333333332 +lat_2=30.416666666666668 +x_0=1000000 +y_0=1000000",
          7730: "lcc +lat_0=31.75183496999997 +lon_0=77.37499999999993 +lat_1=30.749999999999968 +lat_2=32.749999999999964 +x_0=1000000 +y_0=1000000",
          7731: "lcc +lat_0=34.75570873999997 +lon_0=76.49999999999993 +lat_1=33.083333333333336 +lat_2=36.416666666666664 +x_0=1000000 +y_0=1000000",
          7732: "lcc +lat_0=23.626526819999974 +lon_0=85.62499999999991 +lat_1=22.541666666666668 +lat_2=24.708333333333332 +x_0=1000000 +y_0=1000000",
          7733: "lcc +lat_0=24.005298209999975 +lon_0=78.37499999999991 +lat_1=21.99999999999998 +lat_2=25.999999999999975 +x_0=1000000 +y_0=1000000",
          7734: "lcc +lat_0=18.880157739999984 +lon_0=76.74999999999993 +lat_1=16.625 +lat_2=21.125 +x_0=1000000 +y_0=1000000",
          7735: "lcc +lat_0=24.750609109999974 +lon_0=93.9999999999999 +lat_1=24.083333333333332 +lat_2=25.416666666666668 +x_0=1000000 +y_0=1000000",
          7736: "lcc +lat_0=25.625247469999977 +lon_0=91.37499999999991 +lat_1=25.208333333333332 +lat_2=26.041666666666668 +x_0=1000000 +y_0=1000000",
          7737: "lcc +lat_0=26.125819739999976 +lon_0=94.3749999999999 +lat_1=25.375 +lat_2=26.875 +x_0=1000000 +y_0=1000000",
          7738: "lcc +lat_0=25.634521349999975 +lon_0=93.4999999999999 +lat_1=23.041666666666668 +lat_2=28.208333333333332 +x_0=1000000 +y_0=1000000",
          7739: "lcc +lat_0=20.25305173999998 +lon_0=84.37499999999991 +lat_1=18.583333333333332 +lat_2=21.916666666666668 +x_0=1000000 +y_0=1000000",
          7740: "lcc +lat_0=31.001782259999967 +lon_0=75.37499999999993 +lat_1=29.99999999999997 +lat_2=31.999999999999968 +x_0=1000000 +y_0=1000000",
          7741: "lcc +lat_0=26.885055459999972 +lon_0=73.87499999999993 +lat_1=24.291666666666668 +lat_2=29.458333333333332 +x_0=1000000 +y_0=1000000",
          7742: "lcc +lat_0=27.13270822999997 +lon_0=80.87499999999991 +lat_1=24.875 +lat_2=29.375 +x_0=1000000 +y_0=1000000",
          7743: "lcc +lat_0=30.001713199999973 +lon_0=79.37499999999991 +lat_1=28.99999999999997 +lat_2=30.999999999999968 +x_0=1000000 +y_0=1000000",
          7744: "tmerc +lat_0=10.24999999999999 +lon_0=93.2499999999999 +k_0=0.9999428 +x_0=1000000 +y_0=1000000",
          7745: "tmerc +lat_0=20.99999999999998 +lon_0=82.24999999999991 +k_0=0.9998332 +x_0=1000000 +y_0=1000000",
          7746: "tmerc +lat_0=15.374999999999984 +lon_0=73.99999999999993 +k_0=0.9999913 +x_0=1000000 +y_0=1000000",
          7747: "tmerc +lat_0=15.124999999999984 +lon_0=76.37499999999993 +k_0=0.9998012 +x_0=1000000 +y_0=1000000",
          7748: "tmerc +lat_0=10.49999999999999 +lon_0=75.99999999999993 +k_0=0.9999177 +x_0=1000000 +y_0=1000000",
          7749: "tmerc +lat_0=9.99999999999999 +lon_0=73.12499999999993 +k_0=0.9999536 +x_0=1000000 +y_0=1000000",
          7750: "tmerc +lat_0=23.124999999999975 +lon_0=92.7499999999999 +k_0=0.9999821 +x_0=1000000 +y_0=1000000",
          7751: "tmerc +lat_0=27.62499999999997 +lon_0=88.49999999999991 +k_0=0.9999926 +x_0=1000000 +y_0=1000000",
          7752: "tmerc +lat_0=10.87499999999999 +lon_0=78.37499999999991 +k_0=0.9997942 +x_0=1000000 +y_0=1000000",
          7753: "tmerc +lat_0=23.749999999999975 +lon_0=91.74999999999991 +k_0=0.9999822 +x_0=1000000 +y_0=1000000",
          7754: "tmerc +lat_0=24.374999999999975 +lon_0=87.87499999999991 +k_0=0.9998584 +x_0=1000000 +y_0=1000000",
          7802: "lcc +lat_0=42.66787568333333 +lon_0=25.5 +lat_1=42 +lat_2=43.333333333333336 +x_0=500000 +y_0=4725824.3591",
          7818: "tmerc +lat_0=0.08333333333333333 +lon_0=23.5 +k_0=1 +x_0=1300000 +y_0=0",
          7819: "tmerc +lat_0=0.08333333333333333 +lon_0=26.5 +k_0=1 +x_0=2300000 +y_0=0",
          7820: "tmerc +lat_0=0.08333333333333333 +lon_0=29.5 +k_0=1 +x_0=3300000 +y_0=0",
          7821: "tmerc +lat_0=0.08333333333333333 +lon_0=32.5 +k_0=1 +x_0=4300000 +y_0=0",
          7822: "tmerc +lat_0=0.08333333333333333 +lon_0=35.5 +k_0=1 +x_0=5300000 +y_0=0",
          7823: "tmerc +lat_0=0.08333333333333333 +lon_0=38.5 +k_0=1 +x_0=6300000 +y_0=0",
          7824: "tmerc +lat_0=0.08333333333333333 +lon_0=41.5 +k_0=1 +x_0=7300000 +y_0=0",
          7875: "tmerc +lat_0=-15.966666666666667 +lon_0=-5.716666666666667 +k_0=1 +x_0=300000 +y_0=2000000",
          7876: "tmerc +lat_0=-15.966666666666667 +lon_0=-5.716666666666667 +k_0=1 +x_0=299483.737 +y_0=2000527.879",
          7993: "tmerc +lat_0=0 +lon_0=117.88333333333334 +k_0=1.0000044 +x_0=50000 +y_0=4100000",
          7994: "tmerc +lat_0=0 +lon_0=115.25 +k_0=1.0000022 +x_0=60000 +y_0=2700000",
          7995: "tmerc +lat_0=0 +lon_0=122.33333333333333 +k_0=1.00000298 +x_0=50000 +y_0=2300000",
          7996: "tmerc +lat_0=0 +lon_0=115.43333333333334 +k_0=0.99999592 +x_0=50000 +y_0=4000000",
          7997: "tmerc +lat_0=0 +lon_0=113.66666666666667 +k_0=0.99999796 +x_0=50000 +y_0=3050000",
          7998: "tmerc +lat_0=0 +lon_0=105.625 +k_0=1.00002514 +x_0=50000 +y_0=1400000",
          7999: "tmerc +lat_0=0 +lon_0=96.875 +k_0=0.99999387 +x_0=50000 +y_0=1600000",
          8e3: "tmerc +lat_0=0 +lon_0=115.93333333333334 +k_0=1.000019 +x_0=40000 +y_0=4100000",
          8001: "tmerc +lat_0=0 +lon_0=121.88333333333334 +k_0=1.0000055 +x_0=50000 +y_0=4050000",
          8002: "tmerc +lat_0=0 +lon_0=114.06666666666666 +k_0=1.00000236 +x_0=50000 +y_0=2750000",
          8003: "tmerc +lat_0=0 +lon_0=114.58333333333333 +k_0=1.00000628 +x_0=50000 +y_0=3450000",
          8004: "tmerc +lat_0=0 +lon_0=121.5 +k_0=1.00004949 +x_0=60000 +y_0=3800000",
          8005: "tmerc +lat_0=0 +lon_0=114.98333333333333 +k_0=1.00000314 +x_0=50000 +y_0=3650000",
          8006: "tmerc +lat_0=0 +lon_0=114.31527777777778 +k_0=1.000014 +x_0=55000 +y_0=3700000",
          8007: "tmerc +lat_0=0 +lon_0=116.93333333333334 +k_0=0.9999989 +x_0=50000 +y_0=2550000",
          8008: "tmerc +lat_0=0 +lon_0=128.75 +k_0=1.0000165 +x_0=50000 +y_0=2100000",
          8009: "tmerc +lat_0=0 +lon_0=115.36666666666666 +k_0=1.00000157 +x_0=50000 +y_0=3750000",
          8010: "tmerc +lat_0=0 +lon_0=115.16666666666667 +k_0=1.0000055 +x_0=50000 +y_0=4050000",
          8011: "tmerc +lat_0=0 +lon_0=115.81666666666666 +k_0=0.99999906 +x_0=50000 +y_0=3900000",
          8012: "tmerc +lat_0=0 +lon_0=118.6 +k_0=1.00000135 +x_0=50000 +y_0=2500000",
          8033: "tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000.00010160025 +y_0=0",
          8034: "tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000.00010160025 +y_0=0",
          8040: "cass +lat_0=48.038463888888884 +lon_0=31.804180555555558 +x_0=0 +y_0=0",
          8041: "cass +lat_0=48.208761111111116 +lon_0=34.04092222222222 +x_0=0 +y_0=0",
          8061: "omerc +lat_0=32.25 +lonc=-111.4 +alpha=44.99999999999996 +gamma=44.99999999999996 +k_0=1.00011 +x_0=48768 +y_0=243840",
          8062: "tmerc +lat_0=31.25 +lon_0=-112.16666666666667 +k_0=1.00009 +x_0=548640 +y_0=304800",
          8063: "tmerc +lat_0=31.5 +lon_0=-113.16666666666667 +k_0=1.000055 +x_0=182880 +y_0=0",
          8064: "lcc +lat_0=30.5 +lon_0=-110.75 +k_0=0.9998 +x_0=9144 +y_0=-188976",
          8080: "tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=24500000 +y_0=0",
          8081: "tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=25500000 +y_0=0",
          8087: "lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=2700000 +y_0=300000",
          8273: "tmerc +lat_0=43.5 +lon_0=-117.66666666666667 +k_0=1.00014 +x_0=90000 +y_0=0",
          8274: "tmerc +lat_0=43.5 +lon_0=-117.66666666666667 +k_0=1.00014 +x_0=90000.00001488 +y_0=0",
          8275: "tmerc +lat_0=43.5 +lon_0=-119 +k_0=1.00022 +x_0=20000 +y_0=0",
          8276: "tmerc +lat_0=43.5 +lon_0=-119 +k_0=1.00022 +x_0=19999.99999992 +y_0=0",
          8277: "lcc +lat_0=45.583333333333336 +lon_0=-123.41666666666667 +k_0=1.000045 +x_0=30000 +y_0=20000",
          8278: "lcc +lat_0=45.583333333333336 +lon_0=-123.41666666666667 +k_0=1.000045 +x_0=30000.00001512 +y_0=19999.99999992",
          8279: "tmerc +lat_0=44.25 +lon_0=-119.63333333333334 +k_0=1.00012 +x_0=20000 +y_0=0",
          8280: "tmerc +lat_0=44.25 +lon_0=-119.63333333333334 +k_0=1.00012 +x_0=19999.99999992 +y_0=0",
          8281: "tmerc +lat_0=41.75 +lon_0=-118.41666666666667 +k_0=1.00019 +x_0=80000 +y_0=0",
          8282: "tmerc +lat_0=41.75 +lon_0=-118.41666666666667 +k_0=1.00019 +x_0=79999.99999968 +y_0=0",
          8283: "lcc +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=40000 +y_0=70000",
          8284: "lcc +lat_0=45.25 +lon_0=-117.25 +k_0=1.000085 +x_0=39999.99999984 +y_0=70000.00001496",
          8285: "lcc +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=60000 +y_0=-60000",
          8286: "lcc +lat_0=42 +lon_0=-122.25 +k_0=1.00004 +x_0=59999.999999759995 +y_0=-59999.999999759995",
          8287: "lcc +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000 +y_0=290000",
          8288: "lcc +lat_0=47 +lon_0=-120.25 +k_0=0.99927 +x_0=30000.00001512 +y_0=290000.00001408",
          8289: "lcc +lat_0=46.166666666666664 +lon_0=-120.5 +k_0=1 +x_0=100000 +y_0=140000",
          8290: "lcc +lat_0=46.166666666666664 +lon_0=-120.5 +k_0=1 +x_0=99999.99999960001 +y_0=139999.99999944",
          8291: "lcc +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=40000 +y_0=-80000",
          8292: "lcc +lat_0=43.5 +lon_0=-120.5 +k_0=1.00006 +x_0=39999.99999984 +y_0=-79999.99999968",
          8293: "tmerc +lat_0=41.75 +lon_0=-117.58333333333333 +k_0=1.00018 +x_0=70000 +y_0=0",
          8294: "tmerc +lat_0=41.75 +lon_0=-117.58333333333333 +k_0=1.00018 +x_0=70000.00001496 +y_0=0",
          8295: "lcc +lat_0=46.166666666666664 +lon_0=-119 +k_0=1.000025 +x_0=50000 +y_0=130000",
          8296: "lcc +lat_0=46.166666666666664 +lon_0=-119 +k_0=1.000025 +x_0=50000.00001504 +y_0=130000.00001472",
          8297: "lcc +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=60000 +y_0=0",
          8298: "lcc +lat_0=44 +lon_0=-118 +k_0=1.00017 +x_0=59999.999999759995 +y_0=0",
          8299: "tmerc +lat_0=41.75 +lon_0=-120.33333333333333 +k_0=1.000215 +x_0=70000 +y_0=0",
          8300: "tmerc +lat_0=41.75 +lon_0=-120.33333333333333 +k_0=1.000215 +x_0=70000.00001496 +y_0=0",
          8301: "lcc +lat_0=42.5 +lon_0=-122.58333333333333 +k_0=1.00015 +x_0=10000 +y_0=60000",
          8302: "lcc +lat_0=42.5 +lon_0=-122.58333333333333 +k_0=1.00015 +x_0=10000.0000152 +y_0=59999.999999759995",
          8303: "lcc +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000 +y_0=90000",
          8304: "lcc +lat_0=45.25 +lon_0=-119 +k_0=1.00014 +x_0=30000.00001512 +y_0=90000.00001488",
          8305: "tmerc +lat_0=45.25 +lon_0=-117.5 +k_0=1.000195 +x_0=60000 +y_0=0",
          8306: "tmerc +lat_0=45.25 +lon_0=-117.5 +k_0=1.000195 +x_0=59999.999999759995 +y_0=0",
          8307: "lcc +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=40000 +y_0=60000",
          8308: "lcc +lat_0=42.5 +lon_0=-120 +k_0=1.000245 +x_0=39999.99999984 +y_0=59999.999999759995",
          8309: "tmerc +lat_0=43 +lon_0=-122 +k_0=1.000223 +x_0=20000 +y_0=0",
          8310: "tmerc +lat_0=43 +lon_0=-122 +k_0=1.000223 +x_0=19999.99999992 +y_0=0",
          8373: "tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.0001 +x_0=100000 +y_0=200000",
          8374: "tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.0001 +x_0=99999.99998984 +y_0=200000.00001016003",
          8375: "tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.000135 +x_0=300000 +y_0=400000",
          8376: "tmerc +lat_0=36.25 +lon_0=-114.96666666666667 +k_0=1.000135 +x_0=300000.00000000006 +y_0=399999.99998984",
          8389: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.999929 +x_0=300000 +y_0=2000000",
          8432: "tmerc +lat_0=22.212397222222222 +lon_0=113.53646944444445 +k_0=1 +x_0=20000 +y_0=20000",
          8440: "labrd +x_0=400000 +y_0=800000 +lat_0=-18.9 +lonc=46.43722916666666 +alpha=18.9 +k_0=0.9995",
          8458: "tmerc +lat_0=37.5 +lon_0=-101.6 +k_0=1.000156 +x_0=457200.91440182884 +y_0=0",
          8459: "tmerc +lat_0=37.5 +lon_0=-100.95 +k_0=1.000134 +x_0=762001.5240030481 +y_0=0",
          8490: "tmerc +lat_0=37.5 +lon_0=-100.35 +k_0=1.000116 +x_0=1066802.1336042674 +y_0=0",
          8491: "tmerc +lat_0=37.5 +lon_0=-99.45 +k_0=1.000082 +x_0=1371602.7432054866 +y_0=0",
          8492: "tmerc +lat_0=37.5 +lon_0=-98.66666666666667 +k_0=1.000078 +x_0=1676403.3528067057 +y_0=0",
          8493: "tmerc +lat_0=37.5 +lon_0=-98.15 +k_0=1.000068 +x_0=1981203.9624079252 +y_0=0",
          8494: "tmerc +lat_0=37.5 +lon_0=-97.33333333333333 +k_0=1.000049 +x_0=2286004.5720091444 +y_0=0",
          8495: "lcc +lat_0=39.166666666666664 +lon_0=-96.5 +k_0=1.000044 +x_0=2590805.1816103635 +y_0=182880.36576073154",
          8498: "lcc +lat_0=38.5 +lon_0=-96.5 +k_0=1.00005 +x_0=2895605.7912115827 +y_0=91440.18288036577",
          8499: "lcc +lat_0=39.63333333333333 +lon_0=-95.75 +k_0=1.00004 +x_0=3200406.400812802 +y_0=213360.42672085346",
          8500: "lcc +lat_0=39.1 +lon_0=-95.25 +k_0=1.000033 +x_0=3505207.010414021 +y_0=182880.36576073154",
          8501: "tmerc +lat_0=36.75 +lon_0=-101.41666666666667 +k_0=1.00014 +x_0=3810007.6200152407 +y_0=0",
          8502: "tmerc +lat_0=36.75 +lon_0=-100.4 +k_0=1.000109 +x_0=4114808.22961646 +y_0=0",
          8503: "tmerc +lat_0=36.75 +lon_0=-99.66666666666667 +k_0=1.000097 +x_0=4419608.839217679 +y_0=0",
          8504: "tmerc +lat_0=36.75 +lon_0=-99.2 +k_0=1.000087 +x_0=4724409.448818898 +y_0=0",
          8505: "tmerc +lat_0=36.75 +lon_0=-98.55 +k_0=1.000069 +x_0=5029210.058420118 +y_0=0",
          8506: "lcc +lat_0=37.766666666666666 +lon_0=-97.5 +k_0=1.000059 +x_0=5334010.668021337 +y_0=121920.2438404877",
          8507: "lcc +lat_0=37.18333333333333 +lon_0=-97.5 +k_0=1.000055 +x_0=5638811.277622556 +y_0=60960.12192024385",
          8515: "tmerc +lat_0=36.75 +lon_0=-95.96666666666667 +k_0=1.000034 +x_0=5943611.8872237755 +y_0=0",
          8516: "tmerc +lat_0=36.75 +lon_0=-95.08333333333333 +k_0=1.000031 +x_0=6248412.496824995 +y_0=0",
          8825: "tmerc +lat_0=42 +lon_0=-114 +k_0=0.9996 +x_0=2500000 +y_0=1200000",
          8854: "eqearth +lon_0=0 +x_0=0 +y_0=0",
          8855: "eqearth +lon_0=-89.99999999999991 +x_0=0 +y_0=0",
          8856: "eqearth +lon_0=149.99999999999986 +x_0=0 +y_0=0",
          9058: "tmerc +lat_0=0 +lon_0=103 +k_0=0.9999 +x_0=500000 +y_0=0",
          9190: "aea +lat_0=-39.99999999999996 +lon_0=174.99999999999983 +lat_1=-29.99999999999997 +lat_2=-49.99999999999995 +x_0=0 +y_0=0",
          9192: "tmerc +lat_0=0 +lon_0=104 +k_0=0.9999 +x_0=500000 +y_0=0",
          9193: "tmerc +lat_0=0 +lon_0=104.5 +k_0=0.9999 +x_0=500000 +y_0=0",
          9194: "tmerc +lat_0=0 +lon_0=104.75 +k_0=0.9999 +x_0=500000 +y_0=0",
          9195: "tmerc +lat_0=0 +lon_0=105.5 +k_0=0.9999 +x_0=500000 +y_0=0",
          9196: "tmerc +lat_0=0 +lon_0=105.75 +k_0=0.9999 +x_0=500000 +y_0=0",
          9197: "tmerc +lat_0=0 +lon_0=106 +k_0=0.9999 +x_0=500000 +y_0=0",
          9198: "tmerc +lat_0=0 +lon_0=106.25 +k_0=0.9999 +x_0=500000 +y_0=0",
          9199: "tmerc +lat_0=0 +lon_0=106.5 +k_0=0.9999 +x_0=500000 +y_0=0",
          9200: "tmerc +lat_0=0 +lon_0=107 +k_0=0.9999 +x_0=500000 +y_0=0",
          9201: "tmerc +lat_0=0 +lon_0=107.25 +k_0=0.9999 +x_0=500000 +y_0=0",
          9202: "tmerc +lat_0=0 +lon_0=107.5 +k_0=0.9999 +x_0=500000 +y_0=0",
          9203: "tmerc +lat_0=0 +lon_0=108.25 +k_0=0.9999 +x_0=500000 +y_0=0",
          9204: "tmerc +lat_0=0 +lon_0=108.5 +k_0=0.9999 +x_0=500000 +y_0=0",
          9219: "aea +lat_0=-29.99999999999997 +lon_0=24.999999999999975 +lat_1=-21.99999999999998 +lat_2=-37.999999999999964 +x_0=1400000 +y_0=1300000",
          9220: "aea +lat_0=-41.99999999999996 +lon_0=43.99999999999996 +lat_1=-33.999999999999964 +lat_2=-49.99999999999995 +x_0=1200000 +y_0=1300000",
          9268: "tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=0 +y_0=0",
          9269: "tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=0 +y_0=0",
          9270: "tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=0 +y_0=0",
          9301: "tmerc +lat_0=52.29999999999995 +lon_0=-1.4999999999999984 +k_0=1 +x_0=198873.0046 +y_0=375064.3871",
          9353: "stere +x_0=0 +y_0=0 +lat_ts=-64.99999999999993 +lon_0=0",
          9366: "tmerc +lat_0=53.5 +lon_0=-2.25 +k_0=1 +x_0=203252.175 +y_0=407512.765",
          9370: "tmerc +lat_0=52.45 +lon_0=-0.85 +k_0=1 +x_0=49350.157 +y_0=108398.212",
          9376: "tmerc +lat_0=3.999999999999996 +lon_0=-72.99999999999993 +k_0=0.9992 +x_0=5000000 +y_0=2000000",
          9385: "tmerc +lat_0=57.4 +lon_0=-3.2 +k_0=1 +x_0=155828.702 +y_0=115225.707",
          9455: "tmerc +lat_0=55.75 +lon_0=-4.35 +k_0=1 +x_0=93720.394 +y_0=113870.493",
          9497: "tmerc +lat_0=-34.629266666666666 +lon_0=-58.46330833333334 +k_0=1 +x_0=20000 +y_0=70000",
          9673: "aea +lat_0=33.999999999999964 +lon_0=-119.99999999999989 +lat_1=42.99999999999996 +lat_2=47.99999999999995 +x_0=600000 +y_0=0",
          9677: "tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=-2000000",
          9738: "tmerc +lat_0=56.35 +lon_0=-2.75 +k_0=1 +x_0=74996.927 +y_0=133508.35",
          9746: "tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000.00010160022 +y_0=0",
          9747: "tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000.0000000001 +y_0=0",
          9760: "tmerc +lat_0=55.05 +lon_0=-1.55 +k_0=1 +x_0=112242.8512 +y_0=402313.7432",
          9765: "tmerc +lat_0=51.95 +lon_0=-0.9 +k_0=1 +x_0=192519.9715 +y_0=146942.6806",
          9796: "tmerc +lat_0=0 +lon_0=30.5 +k_0=1 +x_0=300000 +y_0=0",
          9797: "tmerc +lat_0=0 +lon_0=34.5 +k_0=1 +x_0=300000 +y_0=0",
          9798: "tmerc +lat_0=0 +lon_0=28.666666666666668 +k_0=1 +x_0=300000 +y_0=0",
          9799: "tmerc +lat_0=0 +lon_0=24.833333333333332 +k_0=1 +x_0=300000 +y_0=0",
          9800: "tmerc +lat_0=0 +lon_0=34.999999999999964 +k_0=1 +x_0=300000 +y_0=0",
          9801: "tmerc +lat_0=0 +lon_0=37.5 +k_0=1 +x_0=300000 +y_0=0",
          9802: "tmerc +lat_0=0 +lon_0=28.5 +k_0=1 +x_0=300000 +y_0=0",
          9803: "tmerc +lat_0=0 +lon_0=23.5 +k_0=1 +x_0=300000 +y_0=0",
          9804: "tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=300000 +y_0=0",
          9805: "tmerc +lat_0=0 +lon_0=24.75 +k_0=1 +x_0=300000 +y_0=0",
          9806: "tmerc +lat_0=0 +lon_0=31.999999999999968 +k_0=1 +x_0=300000 +y_0=0",
          9807: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=300000 +y_0=0",
          9808: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=300000 +y_0=0",
          9809: "tmerc +lat_0=0 +lon_0=31.833333333333332 +k_0=1 +x_0=300000 +y_0=0",
          9810: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=300000 +y_0=0",
          9811: "tmerc +lat_0=0 +lon_0=33.833333333333336 +k_0=1 +x_0=300000 +y_0=0",
          9812: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=300000 +y_0=0",
          9813: "tmerc +lat_0=0 +lon_0=34.5 +k_0=1 +x_0=300000 +y_0=0",
          9814: "tmerc +lat_0=0 +lon_0=25.5 +k_0=1 +x_0=300000 +y_0=0",
          9815: "tmerc +lat_0=0 +lon_0=36.5 +k_0=1 +x_0=300000 +y_0=0",
          9816: "tmerc +lat_0=0 +lon_0=33.5 +k_0=1 +x_0=300000 +y_0=0",
          9817: "tmerc +lat_0=0 +lon_0=31.5 +k_0=1 +x_0=300000 +y_0=0",
          9818: "tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=1 +x_0=300000 +y_0=0",
          9819: "tmerc +lat_0=0 +lon_0=31.999999999999968 +k_0=1 +x_0=300000 +y_0=0",
          9820: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=300000 +y_0=0",
          9868: "tmerc +lat_0=52.3 +lon_0=-1.8 +k_0=1 +x_0=227286.9881 +y_0=265751.2874",
          9872: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          9873: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          9879: "tmerc +lat_0=53.35 +lon_0=-1.9 +k_0=1 +x_0=226574.2032 +y_0=390894.838",
          9894: "tmerc +k_0=1 +lat_0=49.833333333333336 +lon_0=6.166666666666667 +k_0=1 +x_0=80000 +y_0=100000",
          9911: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=-4000000",
          9942: "tmerc +lat_0=51.75 +lon_0=-3.1 +k_0=1 +x_0=106702.326 +y_0=119968.1395",
          9946: "laea +lat_0=64.99999999999993 +lon_0=-18.999999999999982 +x_0=1700000 +y_0=1300000",
          9966: "tmerc +lat_0=53.75 +lon_0=-0.95 +k_0=1 +x_0=140859.7394 +y_0=247512.2812",
          9971: "tmerc +lat_0=56.6 +lon_0=-3.85 +k_0=1 +x_0=108600.972 +y_0=239087.349",
          9976: "tmerc +lat_0=58 +lon_0=-3.8 +k_0=1 +x_0=139618.9493 +y_0=183110.794",
          9981: "tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=14500000 +y_0=0",
          9982: "tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=15500000 +y_0=0",
          10101: "tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=152400.30480060962 +y_0=0",
          10102: "tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0",
          10127: "tmerc +lat_0=53.35 +lon_0=-2.55 +k_0=1 +x_0=171975.9382 +y_0=116744.6938",
          10131: "tmerc +lat_0=30.5 +lon_0=-85.83333333333333 +k_0=0.99996 +x_0=200000 +y_0=0",
          10132: "tmerc +lat_0=30 +lon_0=-87.5 +k_0=0.999933333 +x_0=600000 +y_0=0",
          10147: "tmerc +lat_0=-27.99999999999997 +lon_0=152.99999999999986 +k_0=0.99999 +x_0=150000 +y_0=200000",
          10148: "omerc +lat_0=40.833333333333336 +lonc=-74 +alpha=58 +gamma=58 +k_0=0.99999 +x_0=457200 +y_0=457200",
          10159: "tmerc +lat_0=0 +lon_0=10.369999999999989 +k_0=1 +x_0=-210327 +y_0=-6034310",
          10182: "tmerc +lat_0=52.7 +lon_0=-4.15 +k_0=1 +x_0=64859.6557 +y_0=122266.5277",
          10187: "tmerc +lat_0=52.6 +lon_0=-3.35 +k_0=1 +x_0=56023.5377 +y_0=24567.6764",
          10193: "lcc +lat_0=53.25 +lon_0=-3.5 +lat_1=53.1 +lat_2=53.4 +x_0=212548.8756 +y_0=495230.9254",
          10198: "tmerc +lat_0=52.4 +lon_0=-2.9 +k_0=1 +x_0=199668.0926 +y_0=89354.3229",
          10201: "tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          10202: "tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          10203: "tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0",
          10206: "tmerc +lat_0=51.85 +lon_0=-1.3 +k_0=1 +x_0=511622.854 +y_0=324737.4633",
          10211: "lcc +lat_0=51.65 +lon_0=-2.65 +lat_1=51.4 +lat_2=51.9 +x_0=168854.016 +y_0=193447.117",
          10226: "tmerc +lat_0=52.2 +lon_0=-1.15 +k_0=1 +x_0=175262.1809 +y_0=174688.2508",
          10231: "tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0",
          10232: "tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0",
          10233: "tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0",
          10234: "tmerc +lat_0=51.95 +lon_0=-1.7 +k_0=1 +x_0=134791.6965 +y_0=121872.5056",
          10239: "tmerc +lat_0=52.9 +lon_0=-2.6 +k_0=1 +x_0=110094.4312 +y_0=120623.8396",
          10253: "tmerc +lat_0=55.111709999999945 +lon_0=14.889269999999986 +k_0=1 +x_0=-50000 +y_0=50000",
          10269: "tmerc +lat_0=54.46849999999994 +lon_0=9.232999999999992 +k_0=1 +x_0=0 +y_0=0",
          10274: "tmerc +lat_0=50.75 +lon_0=-3.85 +k_0=1 +x_0=110693.666 +y_0=102089.2943",
          10279: "lcc +lat_0=50.85 +lon_0=-3.25 +lat_1=50.3 +lat_2=51.45 +x_0=372382.8292 +y_0=217764.7796",
          10301: "lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=609601.2192024385 +y_0=0",
          10302: "lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=609601.2192024385 +y_0=0",
          10313: "lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.666666666666668 +lat_2=-22.333333333333332 +x_0=2400000 +y_0=2300000",
          10325: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=500000 +y_0=0",
          10331: "lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=400000 +y_0=0",
          10332: "lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=400000 +y_0=400000",
          10401: "lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=609601.2192024385 +y_0=0",
          10402: "lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=609601.2192024385 +y_0=0",
          10403: "lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=609601.2192024385 +y_0=0",
          10404: "lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=609601.2192024385 +y_0=0",
          10405: "lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=609601.2192024385 +y_0=0",
          10406: "lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=609601.2192024385 +y_0=0",
          10407: "lcc +lat_0=34.13333333333333 +lon_0=-118.33333333333333 +lat_1=34.416666666666664 +lat_2=33.86666666666667 +x_0=1276106.4505969014 +y_0=127079.52451104904",
          10408: "lcc +lat_0=34.13333333333333 +lon_0=-118.33333333333333 +lat_1=34.416666666666664 +lat_2=33.86666666666667 +x_0=1276106.4505969014 +y_0=1268253.006858014",
          10420: "aea +lat_0=0 +lon_0=-119.99999999999989 +lat_1=33.999999999999964 +lat_2=40.49999999999996 +x_0=0 +y_0=-4000000",
          10424: "tmerc +lat_0=0 +lon_0=117.88333333333334 +k_0=1.0000044 +x_0=50000 +y_0=4000000",
          10425: "tmerc +lat_0=0 +lon_0=115.25 +k_0=1.0000022 +x_0=60000 +y_0=2600000",
          10426: "tmerc +lat_0=0 +lon_0=122.33333333333333 +k_0=1.00000298 +x_0=50000 +y_0=2200000",
          10427: "tmerc +lat_0=0 +lon_0=115.43333333333334 +k_0=0.99999592 +x_0=50000 +y_0=3900000",
          10428: "tmerc +lat_0=0 +lon_0=113.66666666666667 +k_0=0.99999796 +x_0=50000 +y_0=2950000",
          10429: "tmerc +lat_0=0 +lon_0=115.93333333333334 +k_0=1.000019 +x_0=40000 +y_0=4000000",
          10430: "tmerc +lat_0=0 +lon_0=121.88333333333334 +k_0=1.0000055 +x_0=50000 +y_0=3950000",
          10431: "lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000 +y_0=500000",
          10432: "lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000 +y_0=500000",
          10433: "lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000 +y_0=500000",
          10434: "lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000 +y_0=500000",
          10435: "lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000 +y_0=500000",
          10436: "lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000 +y_0=500000",
          10437: "tmerc +lat_0=0 +lon_0=114.06666666666666 +k_0=1.00000236 +x_0=50000 +y_0=2650000",
          10438: "tmerc +lat_0=0 +lon_0=114.58333333333333 +k_0=1.00000628 +x_0=50000 +y_0=3350000",
          10439: "tmerc +lat_0=0 +lon_0=121.5 +k_0=1.00004949 +x_0=60000 +y_0=3700000",
          10440: "tmerc +lat_0=0 +lon_0=114.98333333333333 +k_0=1.00000314 +x_0=50000 +y_0=3550000",
          10441: "tmerc +lat_0=0 +lon_0=114.31527777777778 +k_0=1.000014 +x_0=55000 +y_0=3600000",
          10442: "tmerc +lat_0=0 +lon_0=116.93333333333334 +k_0=0.9999989 +x_0=50000 +y_0=2450000",
          10443: "tmerc +lat_0=0 +lon_0=128.75 +k_0=1.0000165 +x_0=50000 +y_0=2000000",
          10444: "tmerc +lat_0=0 +lon_0=115.36666666666666 +k_0=1.00000157 +x_0=50000 +y_0=3650000",
          10445: "tmerc +lat_0=0 +lon_0=115.16666666666667 +k_0=1.0000055 +x_0=50000 +y_0=3950000",
          10446: "tmerc +lat_0=0 +lon_0=115.81666666666666 +k_0=0.99999906 +x_0=50000 +y_0=3800000",
          10447: "tmerc +lat_0=0 +lon_0=118.6 +k_0=1.00000135 +x_0=50000 +y_0=2400000",
          10470: "tmerc +lat_0=52.4 +lon_0=-1.55 +k_0=1 +x_0=116887.9989 +y_0=102194.9369",
          10476: "tmerc +lat_0=46.98077630555556 +lon_0=11.52849375 +k_0=1.000121 +x_0=20000 +y_0=100000",
          10479: "aea +lat_0=31.249999999999968 +lon_0=-99.9999999999999 +lat_1=27.49999999999997 +lat_2=34.999999999999964 +x_0=1500000.0000000002 +y_0=6000000.000000001",
          10501: "lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=39.71666666666667 +lat_2=40.78333333333333 +x_0=609601.2192024385 +y_0=0",
          10502: "lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=609601.2192024385 +y_0=0",
          10503: "lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=609601.2192024385 +y_0=0",
          10515: "tmerc +lat_0=44.25333532222222 +lon_0=-90.84429651388888 +k_0=1.0000353 +x_0=27000.000000000004 +y_0=24999.9998983998",
          10531: "lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8289 +y_0=304800.6096",
          10532: "lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8289 +y_0=304800.6096",
          10533: "lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8289 +y_0=304800.6096",
          10600: "lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=182880.36576073154 +y_0=0",
          10630: "lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.6096 +y_0=152400.3048",
          10700: "tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=152400.30480060962 +y_0=0",
          10730: "tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000 +y_0=0",
          10901: "tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          10902: "tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          10903: "lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=609601.2192024385 +y_0=0",
          10931: "tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000 +y_0=0",
          10932: "tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000 +y_0=0",
          10933: "lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000 +y_0=0",
          10934: "aea +lat_0=24 +lon_0=-84 +lat_1=24 +lat_2=31.5 +x_0=400000 +y_0=0",
          11001: "tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          11002: "tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          11031: "tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000 +y_0=0",
          11032: "tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=700000 +y_0=0",
          11101: "tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=152400.30480060962 +y_0=0",
          11102: "tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=152400.30480060962 +y_0=0",
          11103: "tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0",
          11131: "tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000 +y_0=0",
          11132: "tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000 +y_0=0",
          11133: "tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000 +y_0=0",
          11201: "tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=152400.30480060962 +y_0=0",
          11202: "tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          11231: "tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000 +y_0=0",
          11232: "tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=700000 +y_0=0",
          11233: "tmerc +lat_0=41.25 +lon_0=-88.5 +k_0=1.00003 +x_0=1150012.7000254001 +y_0=149961.89992379988",
          11234: "tmerc +lat_0=41.25 +lon_0=-87.8 +k_0=1.000023 +x_0=1449936.499873 +y_0=149961.89992379988",
          11235: "lcc +lat_0=41.55 +lon_0=-90.6 +k_0=1.000024 +x_0=1749860.2997205995 +y_0=230124.4602489205",
          11236: "lcc +lat_0=41.55 +lon_0=-90.05 +k_0=1.00002 +x_0=2050088.9001778006 +y_0=230124.4602489205",
          11237: "lcc +lat_0=41.3 +lon_0=-89.05 +k_0=1.000023 +x_0=2360071.1201422405 +y_0=230124.4602489205",
          11238: "tmerc +lat_0=40.55 +lon_0=-88 +k_0=1.000022 +x_0=2649936.499873 +y_0=149961.89992379988",
          11239: "tmerc +lat_0=40.2 +lon_0=-90.85 +k_0=1.000024 +x_0=2949860.2997206 +y_0=149961.89992379988",
          11240: "tmerc +lat_0=37.25 +lon_0=-90.1 +k_0=1.000023 +x_0=70104.14020828043 +y_0=149961.89992379988",
          11241: "tmerc +lat_0=37.4 +lon_0=-89.65 +k_0=1.000023 +x_0=420015.24003048014 +y_0=189585.97917195837",
          11242: "tmerc +lat_0=37.45 +lon_0=-89.3 +k_0=1.000025 +x_0=840030.4800609603 +y_0=130149.86029972062",
          11243: "lcc +lat_0=40.5 +lon_0=-88.85 +k_0=1.000031 +x_0=1150012.7000254001 +y_0=530048.2600965203",
          11244: "lcc +lat_0=40.9 +lon_0=-88.55 +k_0=1.000025 +x_0=1449936.499873 +y_0=530048.2600965203",
          11245: "lcc +lat_0=40.75 +lon_0=-87.95 +k_0=1.000024 +x_0=1749860.2997205995 +y_0=530048.2600965203",
          11246: "tmerc +lat_0=36.75 +lon_0=-91.25 +k_0=1.000023 +x_0=2050088.9001778006 +y_0=149961.89992379988",
          11247: "tmerc +lat_0=36.8 +lon_0=-90.6 +k_0=1.000024 +x_0=2350012.7000254 +y_0=149961.89992379988",
          11248: "lcc +lat_0=40.15 +lon_0=-89.8 +k_0=1.000018 +x_0=2670053.3401066805 +y_0=530048.2600965203",
          11249: "tmerc +lat_0=36.3 +lon_0=-88.8 +k_0=1.000024 +x_0=2949860.2997206 +y_0=149961.89992379988",
          11250: "lcc +lat_0=40.15 +lon_0=-88 +k_0=1.000026 +x_0=99974.59994919991 +y_0=860147.3202946407",
          11251: "lcc +lat_0=39.65 +lon_0=-90.6 +k_0=1.000023 +x_0=380086.3601727204 +y_0=860147.3202946407",
          11252: "lcc +lat_0=39.75 +lon_0=-89.65 +k_0=1.000022 +x_0=709880.6197612396 +y_0=879959.35991872",
          11253: "lcc +lat_0=39.65 +lon_0=-88 +k_0=1.000024 +x_0=1150012.7000254001 +y_0=840030.4800609603",
          11254: "tmerc +lat_0=32.85 +lon_0=-90.5 +k_0=1.000019 +x_0=1449936.499873 +y_0=149961.89992379988",
          11255: "lcc +lat_0=39.3 +lon_0=-90.15 +k_0=1.00002 +x_0=1749860.2997205995 +y_0=840030.4800609603",
          11256: "tmerc +lat_0=33.15 +lon_0=-89.4 +k_0=1.000023 +x_0=2050088.9001778006 +y_0=149961.89992379988",
          11257: "lcc +lat_0=38.95 +lon_0=-89 +k_0=1.000019 +x_0=2350012.7000254 +y_0=840030.4800609603",
          11258: "lcc +lat_0=39.1 +lon_0=-88 +k_0=1.000017 +x_0=2649936.499873 +y_0=840030.4800609603",
          11259: "tmerc +lat_0=32.35 +lon_0=-90 +k_0=1.000016 +x_0=2949860.2997206 +y_0=149961.89992379988",
          11260: "lcc +lat_0=38.45 +lon_0=-89.15 +k_0=1.000015 +x_0=99974.59994919991 +y_0=1150012.7000254001",
          11261: "lcc +lat_0=38.55 +lon_0=-88.15 +k_0=1.000013 +x_0=380086.3601727204 +y_0=1150012.7000254001",
          11262: "lcc +lat_0=37.9 +lon_0=-88.95 +k_0=1.000012 +x_0=729997.4599949201 +y_0=1150012.7000254001",
          11263: "lcc +lat_0=37.2 +lon_0=-88.9 +k_0=1.00001 +x_0=1110083.8201676405 +y_0=1170129.5402590807",
          11264: "lcc +lat_0=42.2 +lon_0=-89.95 +k_0=1.000029 +x_0=549860.2997205995 +y_0=230124.4602489205",
          11265: "tmerc +lat_0=41.25 +lon_0=-89.25 +k_0=1.000029 +x_0=860147.3202946407 +y_0=149961.89992379988",
          11301: "tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0",
          11302: "tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0",
          11331: "tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=100000 +y_0=250000",
          11332: "tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000 +y_0=250000",
          11401: "lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=609601.2192024385 +y_0=0",
          11402: "lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=609601.2192024385 +y_0=0",
          11431: "lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000 +y_0=1000000",
          11432: "lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000 +y_0=0",
          11501: "lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=609601.2192024385 +y_0=0",
          11502: "lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=609601.2192024385 +y_0=0",
          11531: "lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=400000 +y_0=0",
          11532: "lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=400000 +y_0=400000",
          11601: "lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=609601.2192024385 +y_0=0",
          11602: "lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=36.733333333333334 +lat_2=37.93333333333333 +x_0=609601.2192024385 +y_0=0",
          11630: "lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000 +y_0=1000000",
          11631: "lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=37.96666666666667 +x_0=500000 +y_0=0",
          11632: "lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000 +y_0=500000",
          11701: "lcc +lat_0=30.666666666666668 +lon_0=-92.5 +lat_1=31.166666666666668 +lat_2=32.666666666666664 +x_0=609601.2192024385 +y_0=0",
          11702: "lcc +lat_0=28.666666666666668 +lon_0=-91.33333333333333 +lat_1=29.3 +lat_2=30.7 +x_0=609601.2192024385 +y_0=0",
          11703: "lcc +lat_0=25.666666666666668 +lon_0=-91.33333333333333 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=609601.2192024385 +y_0=0",
          11731: "lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=1000000 +y_0=0",
          11732: "lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=1000000 +y_0=0",
          11733: "lcc +lat_0=25.5 +lon_0=-91.33333333333333 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=1000000 +y_0=0",
          11801: "tmerc +lat_0=43.833333333333336 +lon_0=-68.5 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          11802: "tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0",
          11831: "tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000 +y_0=0",
          11832: "tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000 +y_0=0",
          11833: "tmerc +lat_0=43.666666666666664 +lon_0=-68.5 +k_0=0.9999 +x_0=300000.00000000006 +y_0=0",
          11834: "tmerc +lat_0=42.833333333333336 +lon_0=-70.16666666666667 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=0",
          11851: "tmerc +lat_0=43.833333333333336 +lon_0=-67.875 +k_0=0.99998 +x_0=700000 +y_0=0",
          11852: "tmerc +lat_0=43 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0",
          11853: "tmerc +lat_0=42.833333333333336 +lon_0=-70.375 +k_0=0.99998 +x_0=300000 +y_0=0",
          11854: "tmerc +lat_0=43.5 +lon_0=-69.125 +k_0=0.99998 +x_0=500000 +y_0=0",
          11900: "lcc +lat_0=37.833333333333336 +lon_0=-77 +lat_1=38.3 +lat_2=39.45 +x_0=243840.4876809754 +y_0=0",
          11930: "lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=400000 +y_0=0",
          12001: "lcc +lat_0=41 +lon_0=-71.5 +lat_1=41.71666666666667 +lat_2=42.68333333333333 +x_0=182880.36576073154 +y_0=0",
          12002: "lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.28333333333333 +lat_2=41.483333333333334 +x_0=60960.12192024385 +y_0=0",
          12031: "lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000 +y_0=750000",
          12032: "lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000 +y_0=0",
          12101: "tmerc +lat_0=41.5 +lon_0=-83.66666666666667 +k_0=0.999942857 +x_0=152400.30480060962 +y_0=0",
          12102: "tmerc +lat_0=41.5 +lon_0=-85.75 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0",
          12103: "tmerc +lat_0=41.5 +lon_0=-88.75 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0",
          12111: "lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=45.483333333333334 +lat_2=47.083333333333336 +x_0=609601.2192024385 +y_0=0",
          12112: "lcc +lat_0=43.31666666666667 +lon_0=-84.33333333333333 +lat_1=44.18333333333333 +lat_2=45.7 +x_0=609601.2192024385 +y_0=0",
          12113: "lcc +lat_0=41.5 +lon_0=-84.33333333333333 +lat_1=42.1 +lat_2=43.666666666666664 +x_0=609601.2192024385 +y_0=0",
          12141: "lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=8000000 +y_0=0",
          12142: "lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=6000000 +y_0=0",
          12143: "lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=4000000 +y_0=0",
          12150: "omerc +x_0=2546731.496 +y_0=-4354009.816 +lat_0=45.30916666666666 +lonc=-86 +alpha=337.25555999999966 +gamma=337.25555999999966 +k_0=0.9996",
          12201: "lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=47.03333333333333 +lat_2=48.63333333333333 +x_0=609601.2192024385 +y_0=0",
          12202: "lcc +lat_0=45 +lon_0=-94.25 +lat_1=45.61666666666667 +lat_2=47.05 +x_0=609601.2192024385 +y_0=0",
          12203: "lcc +lat_0=43 +lon_0=-94 +lat_1=43.78333333333333 +lat_2=45.21666666666667 +x_0=609601.2192024385 +y_0=0",
          12231: "lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000 +y_0=100000",
          12232: "lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000 +y_0=100000",
          12233: "lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000 +y_0=100000",
          12234: "lcc +lat_0=46.5 +lon_0=-93.1 +lat_1=48.63333333333333 +lat_2=47.03333333333333 +x_0=800000.0000101601 +y_0=99999.99998984",
          12235: "lcc +lat_0=45 +lon_0=-94.25 +lat_1=47.05 +lat_2=45.61666666666667 +x_0=800000.0000101601 +y_0=99999.99998984",
          12236: "lcc +lat_0=43 +lon_0=-94 +lat_1=45.21666666666667 +lat_2=43.78333333333333 +x_0=800000.0000101601 +y_0=99999.99998984",
          12301: "tmerc +lat_0=29.666666666666668 +lon_0=-88.83333333333333 +k_0=0.99996 +x_0=152400.30480060962 +y_0=0",
          12302: "tmerc +lat_0=30.5 +lon_0=-90.33333333333333 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          12331: "tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000 +y_0=0",
          12332: "tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=700000 +y_0=0",
          12401: "tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0",
          12402: "tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=152400.30480060962 +y_0=0",
          12403: "tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          12431: "tmerc +lat_0=35.833333333333336 +lon_0=-90.5 +k_0=0.999933333 +x_0=250000 +y_0=0",
          12432: "tmerc +lat_0=35.833333333333336 +lon_0=-92.5 +k_0=0.999933333 +x_0=500000 +y_0=0",
          12433: "tmerc +lat_0=36.166666666666664 +lon_0=-94.5 +k_0=0.999941177 +x_0=850000 +y_0=0",
          12501: "lcc +lat_0=47 +lon_0=-109.5 +lat_1=48.71666666666667 +lat_2=47.85 +x_0=609601.2192024385 +y_0=0",
          12502: "lcc +lat_0=45.833333333333336 +lon_0=-109.5 +lat_1=47.88333333333333 +lat_2=46.45 +x_0=609601.2192024385 +y_0=0",
          12503: "lcc +lat_0=44 +lon_0=-109.5 +lat_1=46.4 +lat_2=44.86666666666667 +x_0=609601.2192024385 +y_0=0",
          12530: "lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=600000 +y_0=0",
          12601: "lcc +lat_0=41.333333333333336 +lon_0=-100 +lat_1=41.85 +lat_2=42.81666666666667 +x_0=609601.2192024385 +y_0=0",
          12602: "lcc +lat_0=39.666666666666664 +lon_0=-99.5 +lat_1=40.28333333333333 +lat_2=41.71666666666667 +x_0=609601.2192024385 +y_0=0",
          12630: "lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000 +y_0=0",
          12701: "tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          12702: "tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          12703: "tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          12731: "tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000 +y_0=8000000",
          12732: "tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000 +y_0=6000000",
          12733: "tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000 +y_0=4000000",
          12800: "tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0",
          12830: "tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000 +y_0=0",
          12900: "tmerc +lat_0=38.833333333333336 +lon_0=-74.66666666666667 +k_0=0.999975 +x_0=609601.2192024385 +y_0=0",
          12930: "tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0",
          13001: "tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=152400.30480060962 +y_0=0",
          13002: "tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          13003: "tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=152400.30480060962 +y_0=0",
          13031: "tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000 +y_0=0",
          13032: "tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000 +y_0=0",
          13033: "tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000 +y_0=0",
          13101: "tmerc +lat_0=40 +lon_0=-74.33333333333333 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0",
          13102: "tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=152400.30480060962 +y_0=0",
          13103: "tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=152400.30480060962 +y_0=0",
          13104: "lcc +lat_0=40.5 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=304800.60960121924 +y_0=0",
          13131: "tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000 +y_0=0",
          13132: "tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=250000 +y_0=0",
          13133: "tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000 +y_0=0",
          13134: "lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000 +y_0=0",
          13200: "lcc +lat_0=33.75 +lon_0=-79 +lat_1=34.333333333333336 +lat_2=36.166666666666664 +x_0=609601.2192024385 +y_0=0",
          13230: "lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.22 +y_0=0",
          13301: "lcc +lat_0=47 +lon_0=-100.5 +lat_1=47.43333333333333 +lat_2=48.733333333333334 +x_0=609601.2192024385 +y_0=0",
          13302: "lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=46.18333333333333 +lat_2=47.483333333333334 +x_0=609601.2192024385 +y_0=0",
          13331: "lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=600000 +y_0=0",
          13332: "lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=600000 +y_0=0",
          13401: "lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=40.43333333333333 +lat_2=41.7 +x_0=609601.2192024385 +y_0=0",
          13402: "lcc +lat_0=38 +lon_0=-82.5 +lat_1=38.733333333333334 +lat_2=40.03333333333333 +x_0=609601.2192024385 +y_0=0",
          13431: "lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000 +y_0=0",
          13432: "lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000 +y_0=0",
          13433: "lcc +lat_0=39.666666666666664 +lon_0=-82.5 +lat_1=41.7 +lat_2=40.43333333333333 +x_0=600000.0000000001 +y_0=0",
          13434: "lcc +lat_0=38 +lon_0=-82.5 +lat_1=40.03333333333333 +lat_2=38.733333333333334 +x_0=600000.0000000001 +y_0=0",
          13501: "lcc +lat_0=35 +lon_0=-98 +lat_1=35.56666666666667 +lat_2=36.766666666666666 +x_0=609601.2192024385 +y_0=0",
          13502: "lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=33.93333333333333 +lat_2=35.233333333333334 +x_0=609601.2192024385 +y_0=0",
          13531: "lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000 +y_0=0",
          13532: "lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000 +y_0=0",
          13601: "lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=44.333333333333336 +lat_2=46 +x_0=609601.2192024385 +y_0=0",
          13602: "lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=42.333333333333336 +lat_2=44 +x_0=609601.2192024385 +y_0=0",
          13631: "lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000 +y_0=0",
          13632: "lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000 +y_0=0",
          13633: "lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=400000 +y_0=0",
          13701: "lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=40.88333333333333 +lat_2=41.95 +x_0=609601.2192024385 +y_0=0",
          13702: "lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=39.93333333333333 +lat_2=40.8 +x_0=609601.2192024385 +y_0=0",
          13731: "lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000 +y_0=0",
          13732: "lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000 +y_0=0",
          13800: "tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.9999938 +x_0=152400.30480060962 +y_0=0",
          13830: "tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=100000 +y_0=0",
          13901: "lcc +lat_0=33 +lon_0=-81 +lat_1=33.766666666666666 +lat_2=34.96666666666667 +x_0=609601.2192024385 +y_0=0",
          13902: "lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=32.333333333333336 +lat_2=33.666666666666664 +x_0=609601.2192024385 +y_0=0",
          13930: "lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0",
          14001: "lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=44.416666666666664 +lat_2=45.68333333333333 +x_0=609601.2192024385 +y_0=0",
          14002: "lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=42.833333333333336 +lat_2=44.4 +x_0=609601.2192024385 +y_0=0",
          14031: "lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000 +y_0=0",
          14032: "lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000 +y_0=0",
          14100: "lcc +lat_0=34.666666666666664 +lon_0=-86 +lat_1=35.25 +lat_2=36.416666666666664 +x_0=30480.060960121926 +y_0=0",
          14130: "lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000 +y_0=0",
          14201: "lcc +lat_0=34 +lon_0=-101.5 +lat_1=34.65 +lat_2=36.18333333333333 +x_0=609601.2192024385 +y_0=0",
          14202: "lcc +lat_0=31.666666666666668 +lon_0=-97.5 +lat_1=32.13333333333333 +lat_2=33.96666666666667 +x_0=609601.2192024385 +y_0=0",
          14203: "lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=30.116666666666667 +lat_2=31.883333333333333 +x_0=609601.2192024385 +y_0=0",
          14204: "lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=28.383333333333333 +lat_2=30.283333333333335 +x_0=609601.2192024385 +y_0=0",
          14205: "lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=26.166666666666668 +lat_2=27.833333333333332 +x_0=609601.2192024385 +y_0=0",
          14231: "lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000 +y_0=1000000",
          14232: "lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000 +y_0=2000000",
          14233: "lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=700000 +y_0=3000000",
          14234: "lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000 +y_0=4000000",
          14235: "lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000 +y_0=5000000",
          14251: "lcc +lat_0=31.166666666666668 +lon_0=-100 +lat_1=27.416666666666668 +lat_2=34.916666666666664 +x_0=1000000 +y_0=1000000",
          14252: "lcc +lat_0=31.166666666666668 +lon_0=-100 +lat_1=27.416666666666668 +lat_2=34.916666666666664 +x_0=914400 +y_0=914400",
          14253: "lcc +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=5000000",
          14254: "aea +lat_0=18 +lon_0=-100 +lat_1=27.5 +lat_2=35 +x_0=1500000 +y_0=6000000",
          14301: "lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=40.71666666666667 +lat_2=41.78333333333333 +x_0=609601.2192024385 +y_0=0",
          14302: "lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=39.016666666666666 +lat_2=40.65 +x_0=609601.2192024385 +y_0=0",
          14303: "lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=37.21666666666667 +lat_2=38.35 +x_0=609601.2192024385 +y_0=0",
          14331: "lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000 +y_0=1000000",
          14332: "lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000 +y_0=2000000",
          14333: "lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000 +y_0=3000000",
          14400: "tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=152400.30480060962 +y_0=0",
          14430: "tmerc +lat_0=42.5 +lon_0=-72.5 +k_0=0.999964286 +x_0=500000 +y_0=0",
          14501: "lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=38.03333333333333 +lat_2=39.2 +x_0=609601.2192024385 +y_0=0",
          14502: "lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=36.766666666666666 +lat_2=37.96666666666667 +x_0=609601.2192024385 +y_0=0",
          14531: "lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000 +y_0=2000000",
          14532: "lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000 +y_0=1000000",
          14601: "lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=47.5 +lat_2=48.733333333333334 +x_0=609601.2192024385 +y_0=0",
          14602: "lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=45.833333333333336 +lat_2=47.333333333333336 +x_0=609601.2192024385 +y_0=0",
          14631: "lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000 +y_0=0",
          14632: "lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000 +y_0=0",
          14701: "lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=39 +lat_2=40.25 +x_0=609601.2192024385 +y_0=0",
          14702: "lcc +lat_0=37 +lon_0=-81 +lat_1=37.483333333333334 +lat_2=38.88333333333333 +x_0=609601.2192024385 +y_0=0",
          14731: "lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000 +y_0=0",
          14732: "lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000 +y_0=0",
          14733: "lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=1968500 +y_0=0",
          14734: "lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=1968500 +y_0=0",
          14735: "lcc +lat_0=38.5 +lon_0=-79.5 +lat_1=40.25 +lat_2=39 +x_0=600000.0000000001 +y_0=0",
          14736: "lcc +lat_0=37 +lon_0=-81 +lat_1=38.88333333333333 +lat_2=37.483333333333334 +x_0=600000.0000000001 +y_0=0",
          14801: "lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=45.56666666666667 +lat_2=46.766666666666666 +x_0=609601.2192024385 +y_0=0",
          14802: "lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=44.25 +lat_2=45.5 +x_0=609601.2192024385 +y_0=0",
          14803: "lcc +lat_0=42 +lon_0=-90 +lat_1=42.733333333333334 +lat_2=44.06666666666667 +x_0=609601.2192024385 +y_0=0",
          14811: "tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=-4500000",
          14831: "lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000 +y_0=0",
          14832: "lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000 +y_0=0",
          14833: "lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000 +y_0=0",
          14841: "tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9996 +x_0=520000 +y_0=-4480000",
          14901: "tmerc +lat_0=40.666666666666664 +lon_0=-105.16666666666667 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          14902: "tmerc +lat_0=40.666666666666664 +lon_0=-107.33333333333333 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          14903: "tmerc +lat_0=40.666666666666664 +lon_0=-108.75 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          14904: "tmerc +lat_0=40.666666666666664 +lon_0=-110.08333333333333 +k_0=0.999941177 +x_0=152400.30480060962 +y_0=0",
          14930: "lcc +lat_0=41 +lon_0=-107.5 +lat_1=41 +lat_2=45 +x_0=500000 +y_0=200000",
          14931: "tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000 +y_0=0",
          14932: "tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=400000 +y_0=100000",
          14933: "tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000 +y_0=0",
          14934: "tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000 +y_0=100000",
          14935: "tmerc +lat_0=40.5 +lon_0=-105.16666666666667 +k_0=0.9999375 +x_0=200000.00001016003 +y_0=0",
          14936: "tmerc +lat_0=40.5 +lon_0=-107.33333333333333 +k_0=0.9999375 +x_0=399999.99998984 +y_0=99999.99998984",
          14937: "tmerc +lat_0=40.5 +lon_0=-108.75 +k_0=0.9999375 +x_0=600000.0000000001 +y_0=0",
          14938: "tmerc +lat_0=40.5 +lon_0=-110.08333333333333 +k_0=0.9999375 +x_0=800000.0000101601 +y_0=99999.99998984",
          15001: "omerc +x_0=5000000.001016003 +y_0=-5000000.001016003 +lat_0=57 +lonc=-133.66666666666666 +alpha=323.13010236111114 +gamma=323.13010236111114 +k_0=0.9999",
          15002: "tmerc +lat_0=53.99999999999994 +lon_0=-141.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          15003: "tmerc +lat_0=53.99999999999994 +lon_0=-145.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          15004: "tmerc +lat_0=53.99999999999994 +lon_0=-149.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          15005: "tmerc +lat_0=53.99999999999994 +lon_0=-153.99999999999986 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          15006: "tmerc +lat_0=53.99999999999994 +lon_0=-157.99999999999983 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          15007: "tmerc +lat_0=53.99999999999994 +lon_0=-161.99999999999983 +k_0=0.9999 +x_0=213360.42672085346 +y_0=0",
          15008: "tmerc +lat_0=53.99999999999994 +lon_0=-165.99999999999983 +k_0=0.9999 +x_0=152400.30480060962 +y_0=0",
          15009: "tmerc +lat_0=53.99999999999994 +lon_0=-169.99999999999983 +k_0=0.9999 +x_0=182880.36576073154 +y_0=0",
          15010: "lcc +lat_0=51 +lon_0=-176 +lat_1=53.833333333333336 +lat_2=51.833333333333336 +x_0=914401.8288036577 +y_0=0",
          15020: "aea +lat_0=49.99999999999995 +lon_0=-153.99999999999986 +lat_1=54.99999999999994 +lat_2=64.99999999999993 +x_0=0 +y_0=0",
          15021: "aea +lat_0=49.99999999999995 +lon_0=-153.99999999999986 +lat_1=54.99999999999994 +lat_2=64.99999999999993 +x_0=0 +y_0=0",
          15031: "omerc +x_0=5000000 +y_0=-5000000 +lat_0=57 +lonc=-133.66666666666666 +alpha=323.13010236111114 +gamma=323.13010236111114 +k_0=0.9999",
          15032: "tmerc +lat_0=53.99999999999994 +lon_0=-141.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0",
          15033: "tmerc +lat_0=53.99999999999994 +lon_0=-145.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0",
          15034: "tmerc +lat_0=53.99999999999994 +lon_0=-149.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0",
          15035: "tmerc +lat_0=53.99999999999994 +lon_0=-153.99999999999986 +k_0=0.9999 +x_0=500000 +y_0=0",
          15036: "tmerc +lat_0=53.99999999999994 +lon_0=-157.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0",
          15037: "tmerc +lat_0=53.99999999999994 +lon_0=-161.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0",
          15038: "tmerc +lat_0=53.99999999999994 +lon_0=-165.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0",
          15039: "tmerc +lat_0=53.99999999999994 +lon_0=-169.99999999999983 +k_0=0.9999 +x_0=500000 +y_0=0",
          15040: "lcc +lat_0=51 +lon_0=-176 +lat_1=53.833333333333336 +lat_2=51.833333333333336 +x_0=1000000 +y_0=0",
          15101: "tmerc +lat_0=18.833333333333332 +lon_0=-155.5 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0",
          15102: "tmerc +lat_0=20.333333333333332 +lon_0=-156.66666666666666 +k_0=0.999966667 +x_0=152400.30480060962 +y_0=0",
          15103: "tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=152400.30480060962 +y_0=0",
          15104: "tmerc +lat_0=21.833333333333332 +lon_0=-159.5 +k_0=0.99999 +x_0=152400.30480060962 +y_0=0",
          15105: "tmerc +lat_0=21.666666666666668 +lon_0=-160.16666666666666 +k_0=1 +x_0=152400.30480060962 +y_0=0",
          15131: "tmerc +lat_0=18.833333333333332 +lon_0=-155.5 +k_0=0.999966667 +x_0=500000 +y_0=0",
          15132: "tmerc +lat_0=20.333333333333332 +lon_0=-156.66666666666666 +k_0=0.999966667 +x_0=500000 +y_0=0",
          15133: "tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000 +y_0=0",
          15134: "tmerc +lat_0=21.833333333333332 +lon_0=-159.5 +k_0=0.99999 +x_0=500000 +y_0=0",
          15135: "tmerc +lat_0=21.666666666666668 +lon_0=-160.16666666666666 +k_0=1 +x_0=500000 +y_0=0",
          15138: "tmerc +lat_0=21.166666666666668 +lon_0=-158 +k_0=0.99999 +x_0=500000.0000101601 +y_0=0",
          15201: "lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=152400.30480060962 +y_0=0",
          15202: "lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=152400.30480060962 +y_0=30480.060960121926",
          15230: "lcc +lat_0=17.833333333333332 +lon_0=-66.43333333333334 +lat_1=18.433333333333334 +lat_2=18.033333333333335 +x_0=200000 +y_0=200000",
          15297: "lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.0000101601 +y_0=999999.9999898401",
          15298: "lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.0000101601 +y_0=2000000.0000101603",
          15299: "lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.0000101601 +y_0=3000000.0000000005",
          15300: "lcc +lat_0=-14.266666666666667 +lon_0=170 +k_0=1 +x_0=152400.30480060962 +y_0=0",
          15301: "lcc +lat_0=-14.266666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480060962 +y_0=0",
          15302: "lcc +lat_0=34.666666666666664 +lon_0=-86 +lat_1=35.25 +lat_2=36.416666666666664 +x_0=609601.2192024385 +y_0=30480.060960121926",
          15303: "lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000 +y_0=0",
          15304: "tmerc +lat_0=31 +lon_0=-110.16666666666667 +k_0=0.9999 +x_0=213360 +y_0=0",
          15305: "tmerc +lat_0=31 +lon_0=-111.91666666666667 +k_0=0.9999 +x_0=213360 +y_0=0",
          15306: "tmerc +lat_0=31 +lon_0=-113.75 +k_0=0.999933333 +x_0=213360 +y_0=0",
          15307: "lcc +lat_0=39.333333333333336 +lon_0=-122 +lat_1=41.666666666666664 +lat_2=40 +x_0=2000000.0001016005 +y_0=500000.00010160025",
          15308: "lcc +lat_0=37.666666666666664 +lon_0=-122 +lat_1=39.833333333333336 +lat_2=38.333333333333336 +x_0=2000000.0001016005 +y_0=500000.00010160025",
          15309: "lcc +lat_0=36.5 +lon_0=-120.5 +lat_1=38.43333333333333 +lat_2=37.06666666666667 +x_0=2000000.0001016005 +y_0=500000.00010160025",
          15310: "lcc +lat_0=35.333333333333336 +lon_0=-119 +lat_1=37.25 +lat_2=36 +x_0=2000000.0001016005 +y_0=500000.00010160025",
          15311: "lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.46666666666667 +lat_2=34.03333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025",
          15312: "lcc +lat_0=32.166666666666664 +lon_0=-116.25 +lat_1=33.88333333333333 +lat_2=32.78333333333333 +x_0=2000000.0001016005 +y_0=500000.00010160025",
          15313: "lcc +lat_0=39.333333333333336 +lon_0=-105.5 +lat_1=40.78333333333333 +lat_2=39.71666666666667 +x_0=914401.8288036577 +y_0=304800.60960121924",
          15314: "lcc +lat_0=37.833333333333336 +lon_0=-105.5 +lat_1=39.75 +lat_2=38.45 +x_0=914401.8288036577 +y_0=304800.60960121924",
          15315: "lcc +lat_0=36.666666666666664 +lon_0=-105.5 +lat_1=38.43333333333333 +lat_2=37.233333333333334 +x_0=914401.8288036577 +y_0=304800.60960121924",
          15316: "lcc +lat_0=40.833333333333336 +lon_0=-72.75 +lat_1=41.86666666666667 +lat_2=41.2 +x_0=304800.60960121924 +y_0=152400.30480060962",
          15317: "tmerc +lat_0=38 +lon_0=-75.41666666666667 +k_0=0.999995 +x_0=200000.00010160022 +y_0=0",
          15318: "tmerc +lat_0=24.333333333333332 +lon_0=-81 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0",
          15319: "tmerc +lat_0=24.333333333333332 +lon_0=-82 +k_0=0.999941177 +x_0=200000.00010160022 +y_0=0",
          15320: "lcc +lat_0=29 +lon_0=-84.5 +lat_1=30.75 +lat_2=29.583333333333332 +x_0=600000.0000000001 +y_0=0",
          15321: "tmerc +lat_0=30 +lon_0=-82.16666666666667 +k_0=0.9999 +x_0=200000.00010160022 +y_0=0",
          15322: "tmerc +lat_0=30 +lon_0=-84.16666666666667 +k_0=0.9999 +x_0=699999.9998983999 +y_0=0",
          15323: "tmerc +lat_0=41.666666666666664 +lon_0=-112.16666666666667 +k_0=0.999947368 +x_0=200000.00010160022 +y_0=0",
          15324: "tmerc +lat_0=41.666666666666664 +lon_0=-114 +k_0=0.999947368 +x_0=500000.00010160025 +y_0=0",
          15325: "tmerc +lat_0=41.666666666666664 +lon_0=-115.75 +k_0=0.999933333 +x_0=800000.0001016003 +y_0=0",
          15326: "tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249364.9987299975",
          15327: "tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249364.9987299975",
          15328: "lcc +lat_0=37.5 +lon_0=-84.25 +lat_1=37.96666666666667 +lat_2=38.96666666666667 +x_0=500000.00010160025 +y_0=0",
          15329: "lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.93333333333333 +lat_2=36.733333333333334 +x_0=500000.00010160025 +y_0=500000.00010160025",
          15330: "lcc +lat_0=37.666666666666664 +lon_0=-77 +lat_1=39.45 +lat_2=38.3 +x_0=399999.99989839987 +y_0=0",
          15331: "lcc +lat_0=41 +lon_0=-71.5 +lat_1=42.68333333333333 +lat_2=41.71666666666667 +x_0=200000.00010160022 +y_0=750000.0000000001",
          15332: "lcc +lat_0=41 +lon_0=-70.5 +lat_1=41.483333333333334 +lat_2=41.28333333333333 +x_0=500000.00010160025 +y_0=0",
          15333: "lcc +lat_0=44.78333333333333 +lon_0=-87 +lat_1=47.083333333333336 +lat_2=45.483333333333334 +x_0=7999999.999968001 +y_0=0",
          15334: "lcc +lat_0=43.31666666666667 +lon_0=-84.36666666666666 +lat_1=45.7 +lat_2=44.18333333333333 +x_0=5999999.999976001 +y_0=0",
          15335: "lcc +lat_0=41.5 +lon_0=-84.36666666666666 +lat_1=43.666666666666664 +lat_2=42.1 +x_0=3999999.9999840003 +y_0=0",
          15336: "tmerc +lat_0=29.5 +lon_0=-88.83333333333333 +k_0=0.99995 +x_0=300000.00000000006 +y_0=0",
          15337: "tmerc +lat_0=29.5 +lon_0=-90.33333333333333 +k_0=0.99995 +x_0=699999.9998983999 +y_0=0",
          15338: "lcc +lat_0=44.25 +lon_0=-109.5 +lat_1=49 +lat_2=45 +x_0=599999.9999976 +y_0=0",
          15339: "tmerc +lat_0=31 +lon_0=-104.33333333333333 +k_0=0.999909091 +x_0=165000.00000000003 +y_0=0",
          15340: "tmerc +lat_0=31 +lon_0=-106.25 +k_0=0.9999 +x_0=500000.00010160025 +y_0=0",
          15341: "tmerc +lat_0=31 +lon_0=-107.83333333333333 +k_0=0.999916667 +x_0=830000.0001016003 +y_0=0",
          15342: "tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0",
          15343: "tmerc +lat_0=40 +lon_0=-76.58333333333333 +k_0=0.9999375 +x_0=249999.99989839984 +y_0=0",
          15344: "tmerc +lat_0=40 +lon_0=-78.58333333333333 +k_0=0.9999375 +x_0=350000.0001016002 +y_0=0",
          15345: "lcc +lat_0=40.166666666666664 +lon_0=-74 +lat_1=41.03333333333333 +lat_2=40.666666666666664 +x_0=300000.00000000006 +y_0=0",
          15346: "lcc +lat_0=33.75 +lon_0=-79 +lat_1=36.166666666666664 +lat_2=34.333333333333336 +x_0=609601.2192024385 +y_0=0",
          15347: "lcc +lat_0=47 +lon_0=-100.5 +lat_1=48.733333333333334 +lat_2=47.43333333333333 +x_0=599999.9999976 +y_0=0",
          15348: "lcc +lat_0=45.666666666666664 +lon_0=-100.5 +lat_1=47.483333333333334 +lat_2=46.18333333333333 +x_0=599999.9999976 +y_0=0",
          15349: "lcc +lat_0=35 +lon_0=-98 +lat_1=36.766666666666666 +lat_2=35.56666666666667 +x_0=600000.0000000001 +y_0=0",
          15350: "lcc +lat_0=33.333333333333336 +lon_0=-98 +lat_1=35.233333333333334 +lat_2=33.93333333333333 +x_0=600000.0000000001 +y_0=0",
          15351: "lcc +lat_0=43.666666666666664 +lon_0=-120.5 +lat_1=46 +lat_2=44.333333333333336 +x_0=2500000.0001424 +y_0=0",
          15352: "lcc +lat_0=41.666666666666664 +lon_0=-120.5 +lat_1=44 +lat_2=42.333333333333336 +x_0=1500000.0001464002 +y_0=0",
          15353: "lcc +lat_0=40.166666666666664 +lon_0=-77.75 +lat_1=41.95 +lat_2=40.88333333333333 +x_0=600000.0000000001 +y_0=0",
          15354: "lcc +lat_0=39.333333333333336 +lon_0=-77.75 +lat_1=40.96666666666667 +lat_2=39.93333333333333 +x_0=600000.0000000001 +y_0=0",
          15355: "lcc +lat_0=31.833333333333332 +lon_0=-81 +lat_1=34.833333333333336 +lat_2=32.5 +x_0=609600 +y_0=0",
          15356: "lcc +lat_0=34.333333333333336 +lon_0=-86 +lat_1=36.416666666666664 +lat_2=35.25 +x_0=600000.0000000001 +y_0=0",
          15357: "lcc +lat_0=34 +lon_0=-101.5 +lat_1=36.18333333333333 +lat_2=34.65 +x_0=200000.00010160022 +y_0=999999.9998983999",
          15358: "lcc +lat_0=31.666666666666668 +lon_0=-98.5 +lat_1=33.96666666666667 +lat_2=32.13333333333333 +x_0=600000.0000000001 +y_0=2000000.0001016005",
          15359: "lcc +lat_0=29.666666666666668 +lon_0=-100.33333333333333 +lat_1=31.883333333333333 +lat_2=30.116666666666667 +x_0=699999.9998983999 +y_0=3000000.0000000005",
          15360: "lcc +lat_0=27.833333333333332 +lon_0=-99 +lat_1=30.283333333333335 +lat_2=28.383333333333333 +x_0=600000.0000000001 +y_0=3999999.9998984006",
          15361: "lcc +lat_0=25.666666666666668 +lon_0=-98.5 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=300000.00000000006 +y_0=5000000.000101601",
          15362: "lcc +lat_0=40.333333333333336 +lon_0=-111.5 +lat_1=41.78333333333333 +lat_2=40.71666666666667 +x_0=500000.00015040004 +y_0=999999.9999960001",
          15363: "lcc +lat_0=38.333333333333336 +lon_0=-111.5 +lat_1=40.65 +lat_2=39.016666666666666 +x_0=500000.00015040004 +y_0=1999999.9999920002",
          15364: "lcc +lat_0=36.666666666666664 +lon_0=-111.5 +lat_1=38.35 +lat_2=37.21666666666667 +x_0=500000.00015040004 +y_0=2999999.9999880004",
          15365: "lcc +lat_0=37.666666666666664 +lon_0=-78.5 +lat_1=39.2 +lat_2=38.03333333333333 +x_0=3500000.0001016003 +y_0=2000000.0001016005",
          15366: "lcc +lat_0=36.333333333333336 +lon_0=-78.5 +lat_1=37.96666666666667 +lat_2=36.766666666666666 +x_0=3500000.0001016003 +y_0=999999.9998983999",
          15367: "lcc +lat_0=47 +lon_0=-120.83333333333333 +lat_1=48.733333333333334 +lat_2=47.5 +x_0=500000.00010160025 +y_0=0",
          15368: "lcc +lat_0=45.333333333333336 +lon_0=-120.5 +lat_1=47.333333333333336 +lat_2=45.833333333333336 +x_0=500000.00010160025 +y_0=0",
          15369: "lcc +lat_0=45.166666666666664 +lon_0=-90 +lat_1=46.766666666666666 +lat_2=45.56666666666667 +x_0=600000.0000000001 +y_0=0",
          15370: "lcc +lat_0=43.833333333333336 +lon_0=-90 +lat_1=45.5 +lat_2=44.25 +x_0=600000.0000000001 +y_0=0",
          15371: "lcc +lat_0=42 +lon_0=-90 +lat_1=44.06666666666667 +lat_2=42.733333333333334 +x_0=600000.0000000001 +y_0=0",
          15372: "tmerc +lat_0=37.5 +lon_0=-85.66666666666667 +k_0=0.999966667 +x_0=99999.99989839981 +y_0=249999.99989839984",
          15373: "tmerc +lat_0=37.5 +lon_0=-87.08333333333333 +k_0=0.999966667 +x_0=900000.0000000001 +y_0=249999.99989839984",
          15374: "lcc +lat_0=41.75 +lon_0=-120.5 +lat_1=43 +lat_2=45.5 +x_0=399999.99999840005 +y_0=0",
          15375: "lcc +lat_0=36.333333333333336 +lon_0=-85.75 +lat_1=37.083333333333336 +lat_2=38.666666666666664 +x_0=1500000.0000000002 +y_0=999999.9998983999",
          15376: "lcc +lat_0=-14.266666666666667 +lon_0=-170 +k_0=1 +x_0=152400.30480060962 +y_0=95169.31165862334",
          15377: "lcc +lat_0=41.5 +lon_0=-93.5 +lat_1=43.266666666666666 +lat_2=42.06666666666667 +x_0=1500000.0000000002 +y_0=999999.9999898401",
          15378: "lcc +lat_0=40 +lon_0=-93.5 +lat_1=41.78333333333333 +lat_2=40.61666666666667 +x_0=500000.0000101601 +y_0=0",
          15379: "lcc +lat_0=38.333333333333336 +lon_0=-98 +lat_1=39.78333333333333 +lat_2=38.71666666666667 +x_0=399999.99998984 +y_0=0",
          15380: "lcc +lat_0=36.666666666666664 +lon_0=-98.5 +lat_1=38.56666666666667 +lat_2=37.266666666666666 +x_0=399999.99998984 +y_0=399999.99998984",
          15381: "tmerc +lat_0=34.75 +lon_0=-115.58333333333333 +k_0=0.9999 +x_0=200000.00001016003 +y_0=8000000.000010162",
          15382: "tmerc +lat_0=34.75 +lon_0=-116.66666666666667 +k_0=0.9999 +x_0=500000.0000101601 +y_0=6000000.000000001",
          15383: "tmerc +lat_0=34.75 +lon_0=-118.58333333333333 +k_0=0.9999 +x_0=800000.0000101601 +y_0=3999999.9999898407",
          15384: "tmerc +lat_0=38.833333333333336 +lon_0=-74.5 +k_0=0.9999 +x_0=150000.00000000003 +y_0=0",
          15385: "lcc +lat_0=34.333333333333336 +lon_0=-92 +lat_1=36.233333333333334 +lat_2=34.93333333333333 +x_0=399999.99998984 +y_0=0",
          15386: "lcc +lat_0=32.666666666666664 +lon_0=-92 +lat_1=34.766666666666666 +lat_2=33.3 +x_0=399999.99998984 +y_0=399999.99998984",
          15387: "tmerc +lat_0=36.666666666666664 +lon_0=-88.33333333333333 +k_0=0.999975 +x_0=300000.00000000006 +y_0=0",
          15388: "tmerc +lat_0=36.666666666666664 +lon_0=-90.16666666666667 +k_0=0.999941177 +x_0=699999.9999898401 +y_0=0",
          15389: "tmerc +lat_0=42.5 +lon_0=-71.66666666666667 +k_0=0.999966667 +x_0=300000.00000000006 +y_0=0",
          15390: "tmerc +lat_0=41.083333333333336 +lon_0=-71.5 +k_0=0.99999375 +x_0=99999.99998984 +y_0=0",
          15391: "lcc +lat_0=30.5 +lon_0=-92.5 +lat_1=32.666666666666664 +lat_2=31.166666666666668 +x_0=999999.9999898401 +y_0=0",
          15392: "lcc +lat_0=28.5 +lon_0=-91.33333333333333 +lat_1=30.7 +lat_2=29.3 +x_0=999999.9999898401 +y_0=0",
          15393: "lcc +lat_0=25.5 +lon_0=-91.33333333333333 +lat_1=27.833333333333332 +lat_2=26.166666666666668 +x_0=999999.9999898401 +y_0=0",
          15394: "lcc +lat_0=43.833333333333336 +lon_0=-100 +lat_1=45.68333333333333 +lat_2=44.416666666666664 +x_0=600000.0000000001 +y_0=0",
          15395: "lcc +lat_0=42.333333333333336 +lon_0=-100.33333333333333 +lat_1=44.4 +lat_2=42.833333333333336 +x_0=600000.0000000001 +y_0=0",
          15396: "lcc +lat_0=39.833333333333336 +lon_0=-100 +lat_1=43 +lat_2=40 +x_0=500000.0000101601 +y_0=0",
          15397: "aea +lat_0=45.568976999999954 +lon_0=-84.45595499999992 +lat_1=42.12277399999996 +lat_2=49.01517999999995 +x_0=1000000 +y_0=1000000",
          15398: "aea +lat_0=45.568976999999954 +lon_0=-83.24862699999991 +lat_1=42.12277399999996 +lat_2=49.01517999999995 +x_0=1000000 +y_0=1000000",
          15399: "aeqd +lat_0=9.546708333333333 +lon_0=138.16874444444443 +x_0=40000 +y_0=60000",
          15400: "aeqd +guam +lat_0=13.472466352777777 +lon_0=144.74875070555555 +x_0=50000 +y_0=50000",
          15914: "tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          15915: "tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          15916: "tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          15917: "tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000.0010160021 +y_0=0",
          16001: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16002: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16003: "tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16004: "tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16005: "tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16006: "tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16007: "tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16008: "tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16009: "tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16010: "tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0",
          16011: "tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0",
          16012: "tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0",
          16013: "tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16014: "tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16015: "tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16016: "tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0",
          16017: "tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0",
          16018: "tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0",
          16019: "tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0",
          16020: "tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0",
          16021: "tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0",
          16022: "tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0",
          16023: "tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0",
          16024: "tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0",
          16025: "tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0",
          16026: "tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0",
          16027: "tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0",
          16028: "tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16029: "tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0",
          16030: "tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0",
          16031: "tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=0",
          16032: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=0",
          16033: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16034: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=0",
          16035: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0",
          16036: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0",
          16037: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=0",
          16038: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=0",
          16039: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0",
          16040: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0",
          16041: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=0",
          16042: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0",
          16043: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=0",
          16044: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0",
          16045: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0",
          16046: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16047: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16048: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16049: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0",
          16050: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=0",
          16051: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=0",
          16052: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16053: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16054: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16055: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16056: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          16057: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16058: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16059: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16060: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=0",
          16061: "stere +lat_0=89.99999999999991 +lon_0=0 +k_0=0.994 +x_0=2000000 +y_0=2000000",
          16065: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0",
          16070: "tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40500000 +y_0=0",
          16071: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41500000 +y_0=0",
          16072: "tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42500000 +y_0=0",
          16073: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43500000 +y_0=0",
          16074: "tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44500000 +y_0=0",
          16075: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45500000 +y_0=0",
          16076: "tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=46500000 +y_0=0",
          16077: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=47500000 +y_0=0",
          16078: "tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=48500000 +y_0=0",
          16079: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=49500000 +y_0=0",
          16080: "tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=50500000 +y_0=0",
          16081: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=51500000 +y_0=0",
          16082: "tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=52500000 +y_0=0",
          16083: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=53500000 +y_0=0",
          16084: "tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=54500000 +y_0=0",
          16085: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=55500000 +y_0=0",
          16086: "tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=56500000 +y_0=0",
          16087: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=57500000 +y_0=0",
          16088: "tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=58500000 +y_0=0",
          16089: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=59500000 +y_0=0",
          16090: "tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60000000 +y_0=0",
          16091: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=61500000 +y_0=0",
          16092: "tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=62500000 +y_0=0",
          16093: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=63500000 +y_0=0",
          16094: "tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=64500000 +y_0=0",
          16099: "tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60500000 +y_0=0",
          16101: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16102: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16103: "tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16104: "tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16105: "tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16106: "tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16107: "tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16108: "tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16109: "tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16110: "tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16111: "tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16112: "tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16113: "tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16114: "tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16115: "tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16116: "tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16117: "tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16118: "tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16119: "tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16120: "tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16121: "tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16122: "tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16123: "tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16124: "tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16125: "tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16126: "tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16127: "tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16128: "tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16129: "tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16130: "tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16131: "tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16132: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16133: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16134: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16135: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16136: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16137: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16138: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16139: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16140: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16141: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16142: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16143: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16144: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16145: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16146: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16147: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16148: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16149: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16150: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16151: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16152: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16153: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16154: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16155: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16156: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16157: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16158: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16159: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16160: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16161: "stere +lat_0=-89.99999999999991 +lon_0=0 +k_0=0.994 +x_0=2000000 +y_0=2000000",
          16170: "tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16171: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0",
          16172: "tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=500000 +y_0=0",
          16173: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16174: "tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16175: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16176: "tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16177: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16178: "tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16179: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16180: "tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16181: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16182: "tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16183: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16184: "tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16185: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16186: "tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16187: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16188: "tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16189: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16190: "tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16191: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16192: "tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16193: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16194: "tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16201: "tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=1 +x_0=1500000 +y_0=0",
          16202: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=2500000 +y_0=0",
          16203: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=3500000 +y_0=0",
          16204: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=4500000 +y_0=0",
          16205: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=5500000 +y_0=0",
          16206: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=6500000 +y_0=0",
          16207: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=7500000 +y_0=0",
          16208: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=8500000 +y_0=0",
          16209: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=9500000 +y_0=0",
          16210: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=10500000 +y_0=0",
          16211: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=11500000 +y_0=0",
          16212: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=12500000 +y_0=0",
          16213: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=13500000 +y_0=0",
          16214: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=14500000 +y_0=0",
          16215: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=15500000 +y_0=0",
          16216: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=16500000 +y_0=0",
          16217: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=17500000 +y_0=0",
          16218: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=18500000 +y_0=0",
          16219: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=19500000 +y_0=0",
          16220: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=20500000 +y_0=0",
          16221: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=21500000 +y_0=0",
          16222: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=22500000 +y_0=0",
          16223: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=23500000 +y_0=0",
          16224: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=24500000 +y_0=0",
          16225: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=25500000 +y_0=0",
          16226: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=26500000 +y_0=0",
          16227: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=27500000 +y_0=0",
          16228: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=28500000 +y_0=0",
          16229: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=29500000 +y_0=0",
          16230: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=30500000 +y_0=0",
          16231: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=31500000 +y_0=0",
          16232: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=32500000 +y_0=0",
          16233: "tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=1 +x_0=33500000 +y_0=0",
          16234: "tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=1 +x_0=34500000 +y_0=0",
          16235: "tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=1 +x_0=35500000 +y_0=0",
          16236: "tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=1 +x_0=36500000 +y_0=0",
          16237: "tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=1 +x_0=37500000 +y_0=0",
          16238: "tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=1 +x_0=38500000 +y_0=0",
          16239: "tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=1 +x_0=39500000 +y_0=0",
          16240: "tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=1 +x_0=40500000 +y_0=0",
          16241: "tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=1 +x_0=41500000 +y_0=0",
          16242: "tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=1 +x_0=42500000 +y_0=0",
          16243: "tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=1 +x_0=43500000 +y_0=0",
          16244: "tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=1 +x_0=44500000 +y_0=0",
          16245: "tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=1 +x_0=45500000 +y_0=0",
          16246: "tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=1 +x_0=46500000 +y_0=0",
          16247: "tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=1 +x_0=47500000 +y_0=0",
          16248: "tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=1 +x_0=48500000 +y_0=0",
          16249: "tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=1 +x_0=49500000 +y_0=0",
          16250: "tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=1 +x_0=50500000 +y_0=0",
          16251: "tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=1 +x_0=51500000 +y_0=0",
          16252: "tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=1 +x_0=52500000 +y_0=0",
          16253: "tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=1 +x_0=53500000 +y_0=0",
          16254: "tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=1 +x_0=54500000 +y_0=0",
          16255: "tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=1 +x_0=55500000 +y_0=0",
          16256: "tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=1 +x_0=56500000 +y_0=0",
          16257: "tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=1 +x_0=57500000 +y_0=0",
          16258: "tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=1 +x_0=58500000 +y_0=0",
          16259: "tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=1 +x_0=59500000 +y_0=0",
          16260: "tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=1 +x_0=60500000 +y_0=0",
          16261: "tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=1 +x_0=1500000 +y_0=0",
          16262: "tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=2500000 +y_0=0",
          16263: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=3500000 +y_0=0",
          16264: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=4500000 +y_0=0",
          16265: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=5500000 +y_0=0",
          16266: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=6500000 +y_0=0",
          16267: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7500000 +y_0=0",
          16268: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8500000 +y_0=0",
          16269: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9500000 +y_0=0",
          16270: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10500000 +y_0=0",
          16271: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11500000 +y_0=0",
          16272: "tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12500000 +y_0=0",
          16273: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13500000 +y_0=0",
          16274: "tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=14500000 +y_0=0",
          16275: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=15500000 +y_0=0",
          16276: "tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=16500000 +y_0=0",
          16277: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=17500000 +y_0=0",
          16278: "tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=18500000 +y_0=0",
          16279: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=19500000 +y_0=0",
          16280: "tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=20500000 +y_0=0",
          16281: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=21500000 +y_0=0",
          16282: "tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=22500000 +y_0=0",
          16283: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=23500000 +y_0=0",
          16284: "tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=24500000 +y_0=0",
          16285: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25500000 +y_0=0",
          16286: "tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26500000 +y_0=0",
          16287: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27500000 +y_0=0",
          16288: "tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28500000 +y_0=0",
          16289: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29500000 +y_0=0",
          16290: "tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30500000 +y_0=0",
          16291: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31500000 +y_0=0",
          16292: "tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32500000 +y_0=0",
          16293: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33500000 +y_0=0",
          16294: "tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34500000 +y_0=0",
          16295: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35500000 +y_0=0",
          16296: "tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36500000 +y_0=0",
          16297: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37500000 +y_0=0",
          16298: "tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38500000 +y_0=0",
          16299: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39500000 +y_0=0",
          16301: "tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=1 +x_0=500000 +y_0=0",
          16302: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16303: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16304: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          16305: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          16306: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0",
          16307: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0",
          16308: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0",
          16309: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0",
          16310: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0",
          16311: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0",
          16312: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16313: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16314: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16315: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16316: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16317: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16318: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16319: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16320: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16321: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=500000 +y_0=0",
          16322: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16323: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16324: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16325: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16326: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16327: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16328: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16329: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16330: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16331: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16332: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16333: "tmerc +lat_0=0 +lon_0=-164.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16334: "tmerc +lat_0=0 +lon_0=-158.99999999999983 +k_0=1 +x_0=500000 +y_0=0",
          16335: "tmerc +lat_0=0 +lon_0=-152.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16336: "tmerc +lat_0=0 +lon_0=-146.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16337: "tmerc +lat_0=0 +lon_0=-140.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16338: "tmerc +lat_0=0 +lon_0=-134.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16339: "tmerc +lat_0=0 +lon_0=-128.99999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16340: "tmerc +lat_0=0 +lon_0=-122.99999999999987 +k_0=1 +x_0=500000 +y_0=0",
          16341: "tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16342: "tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16343: "tmerc +lat_0=0 +lon_0=-104.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16344: "tmerc +lat_0=0 +lon_0=-98.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16345: "tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16346: "tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16347: "tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16348: "tmerc +lat_0=0 +lon_0=-74.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16349: "tmerc +lat_0=0 +lon_0=-68.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16350: "tmerc +lat_0=0 +lon_0=-62.999999999999936 +k_0=1 +x_0=500000 +y_0=0",
          16351: "tmerc +lat_0=0 +lon_0=-56.99999999999994 +k_0=1 +x_0=500000 +y_0=0",
          16352: "tmerc +lat_0=0 +lon_0=-50.99999999999995 +k_0=1 +x_0=500000 +y_0=0",
          16353: "tmerc +lat_0=0 +lon_0=-44.99999999999996 +k_0=1 +x_0=500000 +y_0=0",
          16354: "tmerc +lat_0=0 +lon_0=-38.999999999999964 +k_0=1 +x_0=500000 +y_0=0",
          16355: "tmerc +lat_0=0 +lon_0=-32.999999999999964 +k_0=1 +x_0=500000 +y_0=0",
          16356: "tmerc +lat_0=0 +lon_0=-26.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          16357: "tmerc +lat_0=0 +lon_0=-20.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          16358: "tmerc +lat_0=0 +lon_0=-14.999999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16359: "tmerc +lat_0=0 +lon_0=-8.999999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16360: "tmerc +lat_0=0 +lon_0=-2.999999999999997 +k_0=1 +x_0=500000 +y_0=0",
          16361: "tmerc +lat_0=0 +lon_0=2.999999999999997 +k_0=1 +x_0=500000 +y_0=0",
          16362: "tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=1 +x_0=500000 +y_0=0",
          16363: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16364: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=500000 +y_0=0",
          16365: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=500000 +y_0=0",
          16366: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=500000 +y_0=0",
          16367: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          16368: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=500000 +y_0=0",
          16369: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          16370: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          16371: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=500000 +y_0=0",
          16372: "tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=500000 +y_0=0",
          16373: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=500000 +y_0=0",
          16374: "tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=500000 +y_0=0",
          16375: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=500000 +y_0=0",
          16376: "tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=500000 +y_0=0",
          16377: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=500000 +y_0=0",
          16378: "tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=500000 +y_0=0",
          16379: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=500000 +y_0=0",
          16380: "tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=500000 +y_0=0",
          16381: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=500000 +y_0=0",
          16382: "tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16383: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16384: "tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16385: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16386: "tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=500000 +y_0=0",
          16387: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16388: "tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16389: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16390: "tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=500000 +y_0=0",
          16391: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16392: "tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16393: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16394: "tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16395: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16396: "tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16397: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16398: "tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16399: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=500000 +y_0=0",
          16400: "tmerc +lat_0=0 +lon_0=0 +k_0=0.9996 +x_0=500000 +y_0=0",
          16405: "tmerc +lat_0=0 +lon_0=4.999999999999995 +k_0=0.9996 +x_0=500000 +y_0=0",
          16406: "tmerc +lat_0=0 +lon_0=5.999999999999994 +k_0=0.9996 +x_0=500000 +y_0=0",
          16411: "tmerc +lat_0=0 +lon_0=10.99999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16412: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=0",
          16413: "tmerc +lat_0=0 +lon_0=12.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=0",
          16430: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=0.9996 +x_0=500000 +y_0=0",
          16490: "tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=0.9996 +x_0=500000 +y_0=0",
          16506: "tmerc +lat_0=0 +lon_0=105.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          16586: "tmerc +lat_0=0 +lon_0=105.9999999999999 +k_0=1 +x_0=500000 +y_0=0",
          16611: "tmerc +lat_0=0 +lon_0=11.5 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16612: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16636: "tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16709: "tmerc +lat_0=0 +lon_0=108.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16716: "tmerc +lat_0=0 +lon_0=115.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16732: "tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          16907: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=7250000 +y_0=0",
          16908: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=8250000 +y_0=0",
          16909: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=9250000 +y_0=0",
          16910: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=10250000 +y_0=0",
          16911: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=11250000 +y_0=0",
          16912: "tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=12250000 +y_0=0",
          16913: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=13250000 +y_0=0",
          16914: "tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=14250000 +y_0=0",
          16915: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=15250000 +y_0=0",
          16916: "tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=16250000 +y_0=0",
          16917: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=17250000 +y_0=0",
          16918: "tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=18250000 +y_0=0",
          16919: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=19250000 +y_0=0",
          16920: "tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=20250000 +y_0=0",
          16921: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=21250000 +y_0=0",
          16922: "tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=22250000 +y_0=0",
          16923: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=23250000 +y_0=0",
          16924: "tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=24250000 +y_0=0",
          16925: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=25250000 +y_0=0",
          16926: "tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=26250000 +y_0=0",
          16927: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=27250000 +y_0=0",
          16928: "tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=28250000 +y_0=0",
          16929: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=29250000 +y_0=0",
          16930: "tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=30250000 +y_0=0",
          16931: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=31250000 +y_0=0",
          16932: "tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=32250000 +y_0=0",
          16933: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=33250000 +y_0=0",
          16934: "tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=34250000 +y_0=0",
          16935: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=35250000 +y_0=0",
          16936: "tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=36250000 +y_0=0",
          16937: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=37250000 +y_0=0",
          16938: "tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=38250000 +y_0=0",
          16939: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=39250000 +y_0=0",
          16940: "tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=40250000 +y_0=0",
          16941: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=41250000 +y_0=0",
          16942: "tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=42250000 +y_0=0",
          16943: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=43250000 +y_0=0",
          16944: "tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=44250000 +y_0=0",
          16945: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=45250000 +y_0=0",
          16946: "tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=46250000 +y_0=0",
          16947: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=47250000 +y_0=0",
          16948: "tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=48250000 +y_0=0",
          16949: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=49250000 +y_0=0",
          16950: "tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=50250000 +y_0=0",
          16951: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=51250000 +y_0=0",
          16952: "tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=52250000 +y_0=0",
          16953: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=53250000 +y_0=0",
          16954: "tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=54250000 +y_0=0",
          16955: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=55250000 +y_0=0",
          16956: "tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=56250000 +y_0=0",
          16957: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=57250000 +y_0=0",
          16958: "tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=58250000 +y_0=0",
          16959: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=59250000 +y_0=0",
          16960: "tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=60250000 +y_0=0",
          16961: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=61250000 +y_0=0",
          16962: "tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=62250000 +y_0=0",
          16963: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=63250000 +y_0=0",
          16964: "tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=64250000 +y_0=0",
          17001: "tmerc +lat_0=0 +lon_0=-0.999999999999999 +k_0=0.9996 +x_0=500000 +y_0=0",
          17005: "tmerc +lat_0=0 +lon_0=-4.999999999999995 +k_0=0.9996 +x_0=500000 +y_0=0",
          17054: "tmerc +lat_0=0 +lon_0=-53.99999999999994 +k_0=0.9996 +x_0=500000 +y_0=0",
          17107: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=250000 +y_0=0",
          17108: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=250000 +y_0=0",
          17109: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=250000 +y_0=0",
          17110: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=250000 +y_0=0",
          17111: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=250000 +y_0=0",
          17112: "tmerc +lat_0=0 +lon_0=35.999999999999964 +k_0=1 +x_0=250000 +y_0=0",
          17113: "tmerc +lat_0=0 +lon_0=38.999999999999964 +k_0=1 +x_0=250000 +y_0=0",
          17114: "tmerc +lat_0=0 +lon_0=41.99999999999996 +k_0=1 +x_0=250000 +y_0=0",
          17115: "tmerc +lat_0=0 +lon_0=44.99999999999996 +k_0=1 +x_0=250000 +y_0=0",
          17116: "tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=250000 +y_0=0",
          17117: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=1 +x_0=250000 +y_0=0",
          17118: "tmerc +lat_0=0 +lon_0=53.99999999999994 +k_0=1 +x_0=250000 +y_0=0",
          17119: "tmerc +lat_0=0 +lon_0=56.99999999999994 +k_0=1 +x_0=250000 +y_0=0",
          17120: "tmerc +lat_0=0 +lon_0=59.99999999999994 +k_0=1 +x_0=250000 +y_0=0",
          17121: "tmerc +lat_0=0 +lon_0=62.999999999999936 +k_0=1 +x_0=250000 +y_0=0",
          17122: "tmerc +lat_0=0 +lon_0=65.99999999999993 +k_0=1 +x_0=250000 +y_0=0",
          17123: "tmerc +lat_0=0 +lon_0=68.99999999999993 +k_0=1 +x_0=250000 +y_0=0",
          17124: "tmerc +lat_0=0 +lon_0=71.99999999999993 +k_0=1 +x_0=250000 +y_0=0",
          17125: "tmerc +lat_0=0 +lon_0=74.99999999999993 +k_0=1 +x_0=250000 +y_0=0",
          17126: "tmerc +lat_0=0 +lon_0=77.99999999999993 +k_0=1 +x_0=250000 +y_0=0",
          17127: "tmerc +lat_0=0 +lon_0=80.99999999999991 +k_0=1 +x_0=250000 +y_0=0",
          17128: "tmerc +lat_0=0 +lon_0=83.99999999999991 +k_0=1 +x_0=250000 +y_0=0",
          17129: "tmerc +lat_0=0 +lon_0=86.99999999999991 +k_0=1 +x_0=250000 +y_0=0",
          17130: "tmerc +lat_0=0 +lon_0=89.99999999999991 +k_0=1 +x_0=250000 +y_0=0",
          17131: "tmerc +lat_0=0 +lon_0=92.9999999999999 +k_0=1 +x_0=250000 +y_0=0",
          17132: "tmerc +lat_0=0 +lon_0=95.9999999999999 +k_0=1 +x_0=250000 +y_0=0",
          17133: "tmerc +lat_0=0 +lon_0=98.9999999999999 +k_0=1 +x_0=250000 +y_0=0",
          17134: "tmerc +lat_0=0 +lon_0=101.9999999999999 +k_0=1 +x_0=250000 +y_0=0",
          17135: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=1 +x_0=250000 +y_0=0",
          17136: "tmerc +lat_0=0 +lon_0=107.99999999999989 +k_0=1 +x_0=250000 +y_0=0",
          17137: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=1 +x_0=250000 +y_0=0",
          17138: "tmerc +lat_0=0 +lon_0=113.99999999999989 +k_0=1 +x_0=250000 +y_0=0",
          17139: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=1 +x_0=250000 +y_0=0",
          17140: "tmerc +lat_0=0 +lon_0=119.99999999999989 +k_0=1 +x_0=250000 +y_0=0",
          17141: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=1 +x_0=250000 +y_0=0",
          17142: "tmerc +lat_0=0 +lon_0=125.99999999999987 +k_0=1 +x_0=250000 +y_0=0",
          17143: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17144: "tmerc +lat_0=0 +lon_0=131.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17145: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17146: "tmerc +lat_0=0 +lon_0=137.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17147: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17148: "tmerc +lat_0=0 +lon_0=143.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17149: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17150: "tmerc +lat_0=0 +lon_0=149.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17151: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17152: "tmerc +lat_0=0 +lon_0=155.99999999999986 +k_0=1 +x_0=250000 +y_0=0",
          17153: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17154: "tmerc +lat_0=0 +lon_0=161.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17155: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17156: "tmerc +lat_0=0 +lon_0=167.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17157: "tmerc +lat_0=0 +lon_0=170.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17158: "tmerc +lat_0=0 +lon_0=173.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17159: "tmerc +lat_0=0 +lon_0=176.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17160: "tmerc +lat_0=0 +lon_0=179.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17161: "tmerc +lat_0=0 +lon_0=-176.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17162: "tmerc +lat_0=0 +lon_0=-173.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17163: "tmerc +lat_0=0 +lon_0=-170.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17164: "tmerc +lat_0=0 +lon_0=-167.99999999999983 +k_0=1 +x_0=250000 +y_0=0",
          17204: "lcc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +lat_1=-60.666666666666664 +lat_2=-63.333333333333336 +x_0=0 +y_0=0",
          17205: "lcc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +lat_1=-60.666666666666664 +lat_2=-63.333333333333336 +x_0=0 +y_0=0",
          17206: "lcc +lat_0=-89.99999999999991 +lon_0=-41.99999999999996 +lat_1=-60.666666666666664 +lat_2=-63.333333333333336 +x_0=0 +y_0=0",
          17207: "lcc +lat_0=-89.99999999999991 +lon_0=-173.99999999999983 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17208: "lcc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17209: "lcc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17210: "lcc +lat_0=-89.99999999999991 +lon_0=41.99999999999996 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17211: "lcc +lat_0=-89.99999999999991 +lon_0=53.99999999999994 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17212: "lcc +lat_0=-89.99999999999991 +lon_0=65.99999999999993 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17213: "lcc +lat_0=-89.99999999999991 +lon_0=77.99999999999993 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17214: "lcc +lat_0=-89.99999999999991 +lon_0=89.99999999999991 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17215: "lcc +lat_0=-89.99999999999991 +lon_0=101.9999999999999 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17216: "lcc +lat_0=-89.99999999999991 +lon_0=113.99999999999989 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17217: "lcc +lat_0=-89.99999999999991 +lon_0=125.99999999999987 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17218: "lcc +lat_0=-89.99999999999991 +lon_0=137.99999999999986 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17219: "lcc +lat_0=-89.99999999999991 +lon_0=149.99999999999986 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17220: "lcc +lat_0=-89.99999999999991 +lon_0=161.99999999999983 +lat_1=-64.66666666666667 +lat_2=-67.33333333333333 +x_0=0 +y_0=0",
          17221: "lcc +lat_0=-89.99999999999991 +lon_0=-101.9999999999999 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17222: "lcc +lat_0=-89.99999999999991 +lon_0=-89.99999999999991 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17223: "lcc +lat_0=-89.99999999999991 +lon_0=-77.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17224: "lcc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17225: "lcc +lat_0=-89.99999999999991 +lon_0=-17.999999999999982 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17226: "lcc +lat_0=-89.99999999999991 +lon_0=-5.999999999999994 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17227: "lcc +lat_0=-89.99999999999991 +lon_0=5.999999999999994 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17228: "lcc +lat_0=-89.99999999999991 +lon_0=17.999999999999982 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17229: "lcc +lat_0=-89.99999999999991 +lon_0=29.99999999999997 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17230: "lcc +lat_0=-89.99999999999991 +lon_0=41.99999999999996 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17231: "lcc +lat_0=-89.99999999999991 +lon_0=53.99999999999994 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17232: "lcc +lat_0=-89.99999999999991 +lon_0=65.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17233: "lcc +lat_0=-89.99999999999991 +lon_0=77.99999999999993 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17234: "lcc +lat_0=-89.99999999999991 +lon_0=89.99999999999991 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17235: "lcc +lat_0=-89.99999999999991 +lon_0=101.9999999999999 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17236: "lcc +lat_0=-89.99999999999991 +lon_0=113.99999999999989 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17237: "lcc +lat_0=-89.99999999999991 +lon_0=125.99999999999987 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17238: "lcc +lat_0=-89.99999999999991 +lon_0=137.99999999999986 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17239: "lcc +lat_0=-89.99999999999991 +lon_0=149.99999999999986 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17240: "lcc +lat_0=-89.99999999999991 +lon_0=161.99999999999983 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17241: "lcc +lat_0=-89.99999999999991 +lon_0=173.99999999999983 +lat_1=-68.66666666666667 +lat_2=-71.33333333333333 +x_0=0 +y_0=0",
          17242: "lcc +lat_0=-89.99999999999991 +lon_0=-152.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17243: "lcc +lat_0=-89.99999999999991 +lon_0=-134.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17244: "lcc +lat_0=-89.99999999999991 +lon_0=-116.99999999999989 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17245: "lcc +lat_0=-89.99999999999991 +lon_0=-98.9999999999999 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17246: "lcc +lat_0=-89.99999999999991 +lon_0=-80.99999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17247: "lcc +lat_0=-89.99999999999991 +lon_0=-62.999999999999936 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17248: "lcc +lat_0=-89.99999999999991 +lon_0=-26.99999999999997 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17249: "lcc +lat_0=-89.99999999999991 +lon_0=-8.999999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17250: "lcc +lat_0=-89.99999999999991 +lon_0=8.999999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17251: "lcc +lat_0=-89.99999999999991 +lon_0=26.99999999999997 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17252: "lcc +lat_0=-89.99999999999991 +lon_0=44.99999999999996 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17253: "lcc +lat_0=-89.99999999999991 +lon_0=62.999999999999936 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17254: "lcc +lat_0=-89.99999999999991 +lon_0=80.99999999999991 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17255: "lcc +lat_0=-89.99999999999991 +lon_0=98.9999999999999 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17256: "lcc +lat_0=-89.99999999999991 +lon_0=116.99999999999989 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17257: "lcc +lat_0=-89.99999999999991 +lon_0=134.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17258: "lcc +lat_0=-89.99999999999991 +lon_0=152.99999999999986 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17259: "lcc +lat_0=-89.99999999999991 +lon_0=170.99999999999983 +lat_1=-72.66666666666667 +lat_2=-75.33333333333333 +x_0=0 +y_0=0",
          17260: "lcc +lat_0=-89.99999999999991 +lon_0=-167.99999999999983 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17261: "lcc +lat_0=-89.99999999999991 +lon_0=-143.99999999999986 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17262: "lcc +lat_0=-89.99999999999991 +lon_0=-119.99999999999989 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17263: "lcc +lat_0=-89.99999999999991 +lon_0=-95.9999999999999 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17264: "lcc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17265: "lcc +lat_0=-89.99999999999991 +lon_0=-47.99999999999995 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17266: "lcc +lat_0=-89.99999999999991 +lon_0=-23.999999999999975 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17267: "lcc +lat_0=-89.99999999999991 +lon_0=0 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17268: "lcc +lat_0=-89.99999999999991 +lon_0=23.999999999999975 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17269: "lcc +lat_0=-89.99999999999991 +lon_0=47.99999999999995 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17270: "lcc +lat_0=-89.99999999999991 +lon_0=71.99999999999993 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17271: "lcc +lat_0=-89.99999999999991 +lon_0=95.9999999999999 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17272: "lcc +lat_0=-89.99999999999991 +lon_0=119.99999999999989 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17273: "lcc +lat_0=-89.99999999999991 +lon_0=143.99999999999986 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17274: "lcc +lat_0=-89.99999999999991 +lon_0=167.99999999999983 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17275: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-164.99999999999983",
          17276: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-134.99999999999986",
          17277: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-104.9999999999999",
          17278: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-74.99999999999993",
          17279: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-44.99999999999996",
          17280: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-14.999999999999986",
          17281: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=14.999999999999986",
          17282: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=44.99999999999996",
          17283: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=74.99999999999993",
          17284: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=104.9999999999999",
          17285: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=134.99999999999986",
          17286: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=164.99999999999983",
          17287: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-149.99999999999986",
          17288: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-89.99999999999991",
          17289: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=-29.99999999999997",
          17290: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=29.99999999999997",
          17291: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=89.99999999999991",
          17292: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=149.99999999999986",
          17293: "stere +x_0=0 +y_0=0 +lat_ts=-80.23861111111111 +lon_0=0",
          17294: "lcc +lat_0=-77.99999999999993 +lon_0=161.99999999999983 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=0 +y_0=0",
          17295: "laea +lat_0=89.99999999999991 +lon_0=179.99999999999983 +x_0=0 +y_0=0",
          17296: "laea +lat_0=89.99999999999991 +lon_0=-149.99999999999986 +x_0=0 +y_0=0",
          17297: "laea +lat_0=89.99999999999991 +lon_0=-99.9999999999999 +x_0=0 +y_0=0",
          17298: "laea +lat_0=89.99999999999991 +lon_0=-39.99999999999996 +x_0=0 +y_0=0",
          17299: "laea +lat_0=89.99999999999991 +lon_0=9.99999999999999 +x_0=0 +y_0=0",
          17300: "laea +lat_0=89.99999999999991 +lon_0=89.99999999999991 +x_0=0 +y_0=0",
          17321: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=1 +x_0=150000 +y_0=0",
          17322: "tmerc +lat_0=0 +lon_0=13.5 +k_0=1 +x_0=150000 +y_0=0",
          17323: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=150000 +y_0=0",
          17324: "tmerc +lat_0=0 +lon_0=16.5 +k_0=1 +x_0=150000 +y_0=0",
          17325: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=150000 +y_0=0",
          17326: "tmerc +lat_0=0 +lon_0=14.25 +k_0=1 +x_0=150000 +y_0=0",
          17327: "tmerc +lat_0=0 +lon_0=15.75 +k_0=1 +x_0=150000 +y_0=0",
          17328: "tmerc +lat_0=0 +lon_0=17.25 +k_0=1 +x_0=150000 +y_0=0",
          17329: "tmerc +lat_0=0 +lon_0=18.75 +k_0=1 +x_0=150000 +y_0=0",
          17330: "tmerc +lat_0=0 +lon_0=20.25 +k_0=1 +x_0=150000 +y_0=0",
          17331: "tmerc +lat_0=0 +lon_0=21.75 +k_0=1 +x_0=150000 +y_0=0",
          17332: "tmerc +lat_0=0 +lon_0=23.25 +k_0=1 +x_0=150000 +y_0=0",
          17333: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=500000 +y_0=0",
          17334: "tmerc +lat_0=0 +lon_0=11.308277777777779 +k_0=1 +x_0=1500000 +y_0=0",
          17335: "tmerc +lat_0=0 +lon_0=13.558277777777779 +k_0=1 +x_0=1500000 +y_0=0",
          17336: "tmerc +lat_0=0 +lon_0=18.05827777777778 +k_0=1 +x_0=1500000 +y_0=0",
          17337: "tmerc +lat_0=0 +lon_0=20.30827777777778 +k_0=1 +x_0=1500000 +y_0=0",
          17338: "tmerc +lat_0=0 +lon_0=22.55827777777778 +k_0=1 +x_0=1500000 +y_0=0",
          17339: "tmerc +lat_0=0 +lon_0=11.30625 +k_0=1.000006 +x_0=1500025.141 +y_0=-667.282",
          17340: "tmerc +lat_0=0 +lon_0=13.556266666666668 +k_0=1.0000058 +x_0=1500044.695 +y_0=-667.13",
          17341: "tmerc +lat_0=0 +lon_0=15.806284529444445 +k_0=1.00000561024 +x_0=1500064.274 +y_0=-667.711",
          17342: "tmerc +lat_0=0 +lon_0=18.0563 +k_0=1.0000054 +x_0=1500083.521 +y_0=-668.844",
          17343: "tmerc +lat_0=0 +lon_0=20.306316666666667 +k_0=1.0000052 +x_0=1500102.765 +y_0=-670.706",
          17344: "tmerc +lat_0=0 +lon_0=22.556333333333335 +k_0=1.0000049 +x_0=1500121.846 +y_0=-672.557",
          17348: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17349: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17350: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17351: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17352: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17353: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17354: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17355: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17356: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17357: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17358: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17359: "lcc +lat_0=-31.999999999999968 +lon_0=134.99999999999986 +lat_1=-27.99999999999997 +lat_2=-35.999999999999964 +x_0=1000000 +y_0=2000000",
          17360: "lcc +lat_0=-36.999999999999964 +lon_0=144.99999999999986 +lat_1=-35.999999999999964 +lat_2=-37.999999999999964 +x_0=2500000 +y_0=4500000",
          17361: "lcc +lat_0=-36.999999999999964 +lon_0=144.99999999999986 +lat_1=-35.999999999999964 +lat_2=-37.999999999999964 +x_0=2500000 +y_0=2500000",
          17362: "lcc +lat_0=0 +lon_0=133.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0",
          17363: "tmerc +lat_0=-27.99999999999997 +lon_0=152.99999999999986 +k_0=0.99999 +x_0=50000 +y_0=100000",
          17364: "lcc +lat_0=-33.249999999999964 +lon_0=146.99999999999986 +lat_1=-30.749999999999968 +lat_2=-35.749999999999964 +x_0=9300000 +y_0=4500000",
          17365: "aea +lat_0=0 +lon_0=131.99999999999986 +lat_1=-17.999999999999982 +lat_2=-35.999999999999964 +x_0=0 +y_0=0",
          17401: "lcc +lat_0=0 +lon_0=25.999999999999975 +lat_1=-6.499999999999994 +lat_2=-11.49999999999999 +x_0=0 +y_0=0",
          17402: "tmerc +lat_0=-8.999999999999991 +lon_0=25.999999999999975 +k_0=0.9998 +x_0=0 +y_0=0",
          17412: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17414: "tmerc +lat_0=0 +lon_0=13.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17416: "tmerc +lat_0=0 +lon_0=15.999999999999984 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17418: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17420: "tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17422: "tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17424: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17426: "tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17428: "tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17430: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=0.9999 +x_0=500000 +y_0=10000000",
          17432: "tmerc +lat_0=0 +lon_0=94.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17433: "tmerc +lat_0=0 +lon_0=97.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17434: "tmerc +lat_0=0 +lon_0=100.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17435: "tmerc +lat_0=0 +lon_0=103.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17436: "tmerc +lat_0=0 +lon_0=106.4999999999999 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17437: "tmerc +lat_0=0 +lon_0=109.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17438: "tmerc +lat_0=0 +lon_0=112.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17439: "tmerc +lat_0=0 +lon_0=115.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17440: "tmerc +lat_0=0 +lon_0=118.49999999999989 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17441: "tmerc +lat_0=0 +lon_0=121.49999999999987 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17442: "tmerc +lat_0=0 +lon_0=124.49999999999987 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17443: "tmerc +lat_0=0 +lon_0=127.49999999999987 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17444: "tmerc +lat_0=0 +lon_0=130.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17445: "tmerc +lat_0=0 +lon_0=133.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17446: "tmerc +lat_0=0 +lon_0=136.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17447: "tmerc +lat_0=0 +lon_0=139.49999999999986 +k_0=0.9999 +x_0=200000 +y_0=1500000",
          17448: "tmerc +lat_0=0 +lon_0=104.9999999999999 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17449: "tmerc +lat_0=0 +lon_0=110.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17450: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17451: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17452: "tmerc +lat_0=0 +lon_0=128.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17453: "tmerc +lat_0=0 +lon_0=134.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17454: "tmerc +lat_0=0 +lon_0=140.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17455: "tmerc +lat_0=0 +lon_0=146.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17456: "tmerc +lat_0=0 +lon_0=152.99999999999986 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17457: "tmerc +lat_0=0 +lon_0=158.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17458: "tmerc +lat_0=0 +lon_0=164.99999999999983 +k_0=0.9996 +x_0=500000 +y_0=10000000",
          17515: "tmerc +k_0=1 +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=0 +y_0=0",
          17517: "tmerc +k_0=1 +lat_0=0 +lon_0=16.999999999999982 +k_0=1 +x_0=0 +y_0=0",
          17519: "tmerc +k_0=1 +lat_0=0 +lon_0=18.999999999999982 +k_0=1 +x_0=0 +y_0=0",
          17521: "tmerc +k_0=1 +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=0 +y_0=0",
          17523: "tmerc +k_0=1 +lat_0=0 +lon_0=22.99999999999998 +k_0=1 +x_0=0 +y_0=0",
          17525: "tmerc +k_0=1 +lat_0=0 +lon_0=24.999999999999975 +k_0=1 +x_0=0 +y_0=0",
          17527: "tmerc +k_0=1 +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=0 +y_0=0",
          17529: "tmerc +k_0=1 +lat_0=0 +lon_0=28.99999999999997 +k_0=1 +x_0=0 +y_0=0",
          17531: "tmerc +k_0=1 +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=0 +y_0=0",
          17533: "tmerc +k_0=1 +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=0 +y_0=0",
          17611: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=10.99999999999999 +k_0=1 +x_0=0 +y_0=0",
          17613: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=12.999999999999988 +k_0=1 +x_0=0 +y_0=0",
          17615: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=14.999999999999986 +k_0=1 +x_0=0 +y_0=0",
          17617: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=16.999999999999982 +k_0=1 +x_0=0 +y_0=0",
          17619: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=18.999999999999982 +k_0=1 +x_0=0 +y_0=0",
          17621: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=20.99999999999998 +k_0=1 +x_0=0 +y_0=0",
          17623: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=22.99999999999998 +k_0=1 +x_0=0 +y_0=0",
          17625: "tmerc +k_0=1 +lat_0=-21.99999999999998 +lon_0=24.999999999999975 +k_0=1 +x_0=0 +y_0=0",
          17700: "tmerc +lat_0=0 +lon_0=-55.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17701: "tmerc +lat_0=0 +lon_0=-52.99999999999995 +k_0=0.9999 +x_0=304800 +y_0=0",
          17702: "tmerc +lat_0=0 +lon_0=-55.99999999999994 +k_0=0.9999 +x_0=304800 +y_0=0",
          17703: "tmerc +lat_0=0 +lon_0=-58.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17704: "tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17705: "tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17706: "tmerc +lat_0=0 +lon_0=-67.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17707: "tmerc +lat_0=0 +lon_0=-70.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17708: "tmerc +lat_0=0 +lon_0=-73.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17709: "tmerc +lat_0=0 +lon_0=-76.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17710: "tmerc +lat_0=0 +lon_0=-79.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17711: "tmerc +lat_0=0 +lon_0=-82.5 +k_0=0.9999 +x_0=304800 +y_0=0",
          17712: "tmerc +lat_0=0 +lon_0=-80.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0",
          17713: "tmerc +lat_0=0 +lon_0=-83.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0",
          17714: "tmerc +lat_0=0 +lon_0=-86.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0",
          17715: "tmerc +lat_0=0 +lon_0=-89.99999999999991 +k_0=0.9999 +x_0=304800 +y_0=0",
          17716: "tmerc +lat_0=0 +lon_0=-92.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0",
          17717: "tmerc +lat_0=0 +lon_0=-95.9999999999999 +k_0=0.9999 +x_0=304800 +y_0=0",
          17722: "tmerc +lat_0=0 +lon_0=-110.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0",
          17723: "tmerc +lat_0=0 +lon_0=-113.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0",
          17724: "tmerc +lat_0=0 +lon_0=-116.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0",
          17725: "tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0",
          17726: "tmerc +lat_0=0 +lon_0=-119.99999999999989 +k_0=0.9999 +x_0=0 +y_0=0",
          17794: "tmerc +lat_0=0 +lon_0=-61.5 +k_0=0.9999 +x_0=4500000 +y_0=0",
          17795: "tmerc +lat_0=0 +lon_0=-64.5 +k_0=0.9999 +x_0=5500000 +y_0=0",
          17801: "tmerc +lat_0=33 +lon_0=129.5 +k_0=0.9999 +x_0=0 +y_0=0",
          17802: "tmerc +lat_0=33 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0",
          17803: "tmerc +lat_0=36 +lon_0=132.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0",
          17804: "tmerc +lat_0=33 +lon_0=133.5 +k_0=0.9999 +x_0=0 +y_0=0",
          17805: "tmerc +lat_0=36 +lon_0=134.33333333333334 +k_0=0.9999 +x_0=0 +y_0=0",
          17806: "tmerc +lat_0=36 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0",
          17807: "tmerc +lat_0=36 +lon_0=137.16666666666666 +k_0=0.9999 +x_0=0 +y_0=0",
          17808: "tmerc +lat_0=36 +lon_0=138.5 +k_0=0.9999 +x_0=0 +y_0=0",
          17809: "tmerc +lat_0=36 +lon_0=139.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0",
          17810: "tmerc +lat_0=40 +lon_0=140.83333333333334 +k_0=0.9999 +x_0=0 +y_0=0",
          17811: "tmerc +lat_0=44 +lon_0=140.25 +k_0=0.9999 +x_0=0 +y_0=0",
          17812: "tmerc +lat_0=44 +lon_0=142.25 +k_0=0.9999 +x_0=0 +y_0=0",
          17813: "tmerc +lat_0=44 +lon_0=144.25 +k_0=0.9999 +x_0=0 +y_0=0",
          17814: "tmerc +lat_0=26 +lon_0=142 +k_0=0.9999 +x_0=0 +y_0=0",
          17815: "tmerc +lat_0=26 +lon_0=127.5 +k_0=0.9999 +x_0=0 +y_0=0",
          17816: "tmerc +lat_0=26 +lon_0=124 +k_0=0.9999 +x_0=0 +y_0=0",
          17817: "tmerc +lat_0=26 +lon_0=131 +k_0=0.9999 +x_0=0 +y_0=0",
          17818: "tmerc +lat_0=20 +lon_0=136 +k_0=0.9999 +x_0=0 +y_0=0",
          17819: "tmerc +lat_0=26 +lon_0=154 +k_0=0.9999 +x_0=0 +y_0=0",
          17901: "tmerc +lat_0=-36.87986527777778 +lon_0=174.7643393611111 +k_0=0.9999 +x_0=300000 +y_0=700000",
          17902: "tmerc +lat_0=-37.76124980555556 +lon_0=176.46619725 +k_0=1 +x_0=300000 +y_0=700000",
          17903: "tmerc +lat_0=-38.62470277777778 +lon_0=177.88563627777776 +k_0=1 +x_0=300000 +y_0=700000",
          17904: "tmerc +lat_0=-39.65092930555556 +lon_0=176.67368052777778 +k_0=1 +x_0=300000 +y_0=700000",
          17905: "tmerc +lat_0=-39.135758305555555 +lon_0=174.22801175 +k_0=1 +x_0=300000 +y_0=700000",
          17906: "tmerc +lat_0=-39.512470388888886 +lon_0=175.64003680555555 +k_0=1 +x_0=300000 +y_0=700000",
          17907: "tmerc +lat_0=-40.24194713888889 +lon_0=175.4880996111111 +k_0=1 +x_0=300000 +y_0=700000",
          17908: "tmerc +lat_0=-40.92553263888889 +lon_0=175.64734966666666 +k_0=1 +x_0=300000 +y_0=700000",
          17909: "tmerc +lat_0=-41.301319638888884 +lon_0=174.77662311111112 +k_0=1 +x_0=300000 +y_0=700000",
          17910: "tmerc +lat_0=-40.71475905555556 +lon_0=172.6720465 +k_0=1 +x_0=300000 +y_0=700000",
          17911: "tmerc +lat_0=-41.274544722222224 +lon_0=173.29931680555555 +k_0=1 +x_0=300000 +y_0=700000",
          17912: "tmerc +lat_0=-41.289911527777775 +lon_0=172.10902819444445 +k_0=1 +x_0=300000 +y_0=700000",
          17913: "tmerc +lat_0=-41.81080286111111 +lon_0=171.58126005555556 +k_0=1 +x_0=300000 +y_0=700000",
          17914: "tmerc +lat_0=-42.33369427777778 +lon_0=171.54977130555557 +k_0=1 +x_0=300000 +y_0=700000",
          17915: "tmerc +lat_0=-42.68911658333333 +lon_0=173.0101333888889 +k_0=1 +x_0=300000 +y_0=700000",
          17916: "tmerc +lat_0=-41.544486666666664 +lon_0=173.80207411111112 +k_0=1 +x_0=300000 +y_0=700000",
          17917: "tmerc +lat_0=-42.88632236111111 +lon_0=170.9799935 +k_0=1 +x_0=300000 +y_0=700000",
          17918: "tmerc +lat_0=-43.11012813888889 +lon_0=170.26092583333335 +k_0=1 +x_0=300000 +y_0=700000",
          17919: "tmerc +lat_0=-43.97780288888889 +lon_0=168.606267 +k_0=1 +x_0=300000 +y_0=700000",
          17920: "tmerc +lat_0=-43.59063758333333 +lon_0=172.72719358333333 +k_0=1 +x_0=300000 +y_0=700000",
          17921: "tmerc +lat_0=-43.74871155555556 +lon_0=171.3607484722222 +k_0=1 +x_0=300000 +y_0=700000",
          17922: "tmerc +lat_0=-44.40222036111111 +lon_0=171.05725083333334 +k_0=1 +x_0=300000 +y_0=700000",
          17923: "tmerc +lat_0=-44.735267972222225 +lon_0=169.46775508333334 +k_0=1 +x_0=300000 +y_0=700000",
          17924: "tmerc +lat_0=-45.13290258333333 +lon_0=168.39864119444442 +k_0=1 +x_0=300000 +y_0=700000",
          17925: "tmerc +lat_0=-45.56372616666666 +lon_0=167.73886177777777 +k_0=1 +x_0=300000 +y_0=700000",
          17926: "tmerc +lat_0=-45.81619661111111 +lon_0=170.62859516666668 +k_0=1 +x_0=300000 +y_0=700000",
          17927: "tmerc +lat_0=-45.861513361111115 +lon_0=170.28258911111112 +k_0=0.99996 +x_0=300000 +y_0=700000",
          17928: "tmerc +lat_0=-46.60000961111111 +lon_0=168.342872 +k_0=1 +x_0=300002.66 +y_0=699999.58",
          17931: "tmerc +lat_0=-36.87972222222222 +lon_0=174.76416666666665 +k_0=0.9999 +x_0=400000 +y_0=800000",
          17932: "tmerc +lat_0=-37.76111111111111 +lon_0=176.4661111111111 +k_0=1 +x_0=400000 +y_0=800000",
          17933: "tmerc +lat_0=-38.62444444444444 +lon_0=177.88555555555556 +k_0=1 +x_0=400000 +y_0=800000",
          17934: "tmerc +lat_0=-39.65083333333333 +lon_0=176.67361111111111 +k_0=1 +x_0=400000 +y_0=800000",
          17935: "tmerc +lat_0=-39.135555555555555 +lon_0=174.2277777777778 +k_0=1 +x_0=400000 +y_0=800000",
          17936: "tmerc +lat_0=-39.51222222222222 +lon_0=175.64 +k_0=1 +x_0=400000 +y_0=800000",
          17937: "tmerc +lat_0=-40.24194444444444 +lon_0=175.48805555555555 +k_0=1 +x_0=400000 +y_0=800000",
          17938: "tmerc +lat_0=-40.92527777777777 +lon_0=175.6472222222222 +k_0=1 +x_0=400000 +y_0=800000",
          17939: "tmerc +lat_0=-41.301111111111105 +lon_0=174.7763888888889 +k_0=1 +x_0=400000 +y_0=800000",
          17940: "tmerc +lat_0=-40.71472222222223 +lon_0=172.67194444444445 +k_0=1 +x_0=400000 +y_0=800000",
          17941: "tmerc +lat_0=-41.27444444444444 +lon_0=173.29916666666668 +k_0=1 +x_0=400000 +y_0=800000",
          17942: "tmerc +lat_0=-41.28972222222222 +lon_0=172.10888888888888 +k_0=1 +x_0=400000 +y_0=800000",
          17943: "tmerc +lat_0=-41.81055555555555 +lon_0=171.5811111111111 +k_0=1 +x_0=400000 +y_0=800000",
          17944: "tmerc +lat_0=-42.33361111111111 +lon_0=171.54972222222221 +k_0=1 +x_0=400000 +y_0=800000",
          17945: "tmerc +lat_0=-42.68888888888888 +lon_0=173.01 +k_0=1 +x_0=400000 +y_0=800000",
          17946: "tmerc +lat_0=-41.544444444444444 +lon_0=173.80194444444444 +k_0=1 +x_0=400000 +y_0=800000",
          17947: "tmerc +lat_0=-42.88611111111111 +lon_0=170.97972222222222 +k_0=1 +x_0=400000 +y_0=800000",
          17948: "tmerc +lat_0=-43.11 +lon_0=170.26083333333332 +k_0=1 +x_0=400000 +y_0=800000",
          17949: "tmerc +lat_0=-43.97777777777778 +lon_0=168.60611111111112 +k_0=1 +x_0=400000 +y_0=800000",
          17950: "tmerc +lat_0=-43.59055555555556 +lon_0=172.72694444444446 +k_0=1 +x_0=400000 +y_0=800000",
          17951: "tmerc +lat_0=-43.74861111111111 +lon_0=171.36055555555555 +k_0=1 +x_0=400000 +y_0=800000",
          17952: "tmerc +lat_0=-44.401944444444446 +lon_0=171.05722222222224 +k_0=1 +x_0=400000 +y_0=800000",
          17953: "tmerc +lat_0=-44.735 +lon_0=169.4675 +k_0=1 +x_0=400000 +y_0=800000",
          17954: "tmerc +lat_0=-45.132777777777775 +lon_0=168.3986111111111 +k_0=1 +x_0=400000 +y_0=800000",
          17955: "tmerc +lat_0=-45.56361111111111 +lon_0=167.7386111111111 +k_0=1 +x_0=400000 +y_0=800000",
          17956: "tmerc +lat_0=-45.816111111111105 +lon_0=170.62833333333333 +k_0=1 +x_0=400000 +y_0=800000",
          17957: "tmerc +lat_0=-45.86138888888889 +lon_0=170.28250000000003 +k_0=0.99996 +x_0=400000 +y_0=800000",
          17958: "tmerc +lat_0=-46.6 +lon_0=168.3427777777778 +k_0=1 +x_0=400000 +y_0=800000",
          17959: "tmerc +lat_0=-44 +lon_0=-176.5 +k_0=1 +x_0=400000 +y_0=800000",
          17960: "tmerc +lat_0=0 +lon_0=165.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000",
          17961: "tmerc +lat_0=0 +lon_0=168.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000",
          17962: "tmerc +lat_0=0 +lon_0=178.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000",
          17963: "tmerc +lat_0=0 +lon_0=-177.99999999999983 +k_0=1 +x_0=3500000 +y_0=10000000",
          17964: "lcc +lat_0=-41 +lon_0=173 +lat_1=-37.5 +lat_2=-44.5 +x_0=3000000 +y_0=7000000",
          17965: "tmerc +lat_0=0 +lon_0=-176.5 +k_0=1 +x_0=3500000 +y_0=10000000",
          17966: "lcc +lat_0=-90 +lon_0=157 +lat_1=-76.66666666666667 +lat_2=-79.33333333333333 +x_0=500000 +y_0=0",
          18001: "tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=0 +y_0=-5000000",
          18002: "tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=0 +y_0=-5000000",
          18003: "tmerc +lat_0=0 +lon_0=33.999999999999964 +k_0=1 +x_0=0 +y_0=-5000000",
          18004: "tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=0 +y_0=-5000000",
          18005: "tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=0 +y_0=-5000000",
          18006: "tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=0 +y_0=-5000000",
          18007: "tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=150000 +y_0=-5000000",
          18008: "tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=450000 +y_0=-5000000",
          18009: "tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=750000 +y_0=-5000000",
          18011: "lcc +lat_0=35.999999999999964 +lon_0=2.6999999999999975 +k_0=0.999625544 +x_0=500000 +y_0=300000",
          18012: "lcc +lat_0=33.29999999999997 +lon_0=2.6999999999999975 +k_0=0.999625769 +x_0=500000 +y_0=300000",
          18021: "lcc +lat_0=35.999999999999964 +lon_0=2.6999999999999975 +k_0=0.999625544 +x_0=500135 +y_0=300090",
          18022: "lcc +lat_0=33.29999999999997 +lon_0=2.6999999999999975 +k_0=0.999625769 +x_0=500135 +y_0=300090",
          18031: "tmerc +lat_0=-89.99999999999991 +lon_0=-71.99999999999993 +k_0=1 +x_0=1500000 +y_0=0",
          18032: "tmerc +lat_0=-89.99999999999991 +lon_0=-68.99999999999993 +k_0=1 +x_0=2500000 +y_0=0",
          18033: "tmerc +lat_0=-89.99999999999991 +lon_0=-65.99999999999993 +k_0=1 +x_0=3500000 +y_0=0",
          18034: "tmerc +lat_0=-89.99999999999991 +lon_0=-62.999999999999936 +k_0=1 +x_0=4500000 +y_0=0",
          18035: "tmerc +lat_0=-89.99999999999991 +lon_0=-59.99999999999994 +k_0=1 +x_0=5500000 +y_0=0",
          18036: "tmerc +lat_0=-89.99999999999991 +lon_0=-56.99999999999994 +k_0=1 +x_0=6500000 +y_0=0",
          18037: "tmerc +lat_0=-89.99999999999991 +lon_0=-53.99999999999994 +k_0=1 +x_0=7500000 +y_0=0",
          18041: "tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=0 +y_0=0",
          18042: "tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=0 +y_0=0",
          18043: "tmerc +lat_0=0 +lon_0=33.999999999999964 +k_0=1 +x_0=0 +y_0=0",
          18044: "tmerc +lat_0=0 +lon_0=10.333333333333334 +k_0=1 +x_0=150000 +y_0=0",
          18045: "tmerc +lat_0=0 +lon_0=13.333333333333334 +k_0=1 +x_0=450000 +y_0=0",
          18046: "tmerc +lat_0=0 +lon_0=16.333333333333332 +k_0=1 +x_0=750000 +y_0=0",
          18047: "tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=150000 +y_0=0",
          18048: "tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=450000 +y_0=0",
          18049: "tmerc +lat_0=0 +lon_0=33.999999999999964 +k_0=1 +x_0=750000 +y_0=0",
          18051: "tmerc +lat_0=4.599047222222222 +lon_0=-77.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000",
          18052: "tmerc +lat_0=4.599047222222222 +lon_0=-74.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000",
          18053: "tmerc +lat_0=4.599047222222222 +lon_0=-71.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000",
          18054: "tmerc +lat_0=4.599047222222222 +lon_0=-68.08091666666667 +k_0=1 +x_0=1000000 +y_0=1000000",
          18055: "tmerc +lat_0=4.596200416666666 +lon_0=-80.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000",
          18056: "tmerc +lat_0=4.596200416666666 +lon_0=-77.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000",
          18057: "tmerc +lat_0=4.596200416666666 +lon_0=-74.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000",
          18058: "tmerc +lat_0=4.596200416666666 +lon_0=-71.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000",
          18059: "tmerc +lat_0=4.596200416666666 +lon_0=-68.07750791666666 +k_0=1 +x_0=1000000 +y_0=1000000",
          18061: "lcc +lat_0=22.35 +lon_0=-81 +k_0=0.99993602 +x_0=500000 +y_0=280296.016",
          18062: "lcc +lat_0=20.716666666666665 +lon_0=-76.83333333333333 +k_0=0.99994848 +x_0=500000 +y_0=229126.939",
          18063: "lcc +lat_0=22.35 +lon_0=-81 +lat_1=23 +lat_2=21.7 +x_0=500000 +y_0=280296.016",
          18064: "lcc +lat_0=20.716666666666665 +lon_0=-76.83333333333333 +lat_1=21.3 +lat_2=20.133333333333333 +x_0=500000 +y_0=229126.939",
          18065: "tmerc +lat_0=4.596203222222222 +lon_0=-80.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000",
          18066: "tmerc +lat_0=4.596203222222222 +lon_0=-77.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000",
          18067: "tmerc +lat_0=4.596203222222222 +lon_0=-74.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000",
          18068: "tmerc +lat_0=4.596203222222222 +lon_0=-71.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000",
          18069: "tmerc +lat_0=4.596203222222222 +lon_0=-68.07750776944444 +k_0=1 +x_0=1000000 +y_0=1000000",
          18071: "tmerc +lat_0=29.99999999999997 +lon_0=34.999999999999964 +k_0=1 +x_0=300000 +y_0=1100000",
          18072: "tmerc +lat_0=29.99999999999997 +lon_0=30.999999999999968 +k_0=1 +x_0=615000 +y_0=810000",
          18073: "tmerc +lat_0=29.99999999999997 +lon_0=26.99999999999997 +k_0=1 +x_0=700000 +y_0=200000",
          18074: "tmerc +lat_0=29.99999999999997 +lon_0=26.99999999999997 +k_0=1 +x_0=700000 +y_0=1200000",
          18081: "lcc +lat_0=49.49999999999995 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=1200000",
          18082: "lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=2200000",
          18083: "lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=3200000",
          18084: "lcc +lat_0=42.164999999999964 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=4185861.369",
          18085: "lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000",
          18086: "lcc +lat_0=46.8 +lon_0=2.337229166666667 +k_0=0.99987742 +x_0=600000 +y_0=2200000",
          18091: "lcc +lat_0=49.49999999999995 +lon_0=0 +k_0=0.999877341 +x_0=600000 +y_0=200000",
          18092: "lcc +lat_0=46.799999999999955 +lon_0=0 +k_0=0.99987742 +x_0=600000 +y_0=200000",
          18093: "lcc +lat_0=44.09999999999996 +lon_0=0 +k_0=0.999877499 +x_0=600000 +y_0=200000",
          18094: "lcc +lat_0=42.164999999999964 +lon_0=0 +k_0=0.99994471 +x_0=234.358 +y_0=185861.369",
          18101: "lcc +lat_0=41.99999999999996 +lon_0=2.999999999999997 +lat_1=41.24999999999996 +lat_2=42.74999999999996 +x_0=1700000 +y_0=1200000",
          18102: "lcc +lat_0=42.99999999999996 +lon_0=2.999999999999997 +lat_1=42.24999999999996 +lat_2=43.74999999999996 +x_0=1700000 +y_0=2200000",
          18103: "lcc +lat_0=43.99999999999996 +lon_0=2.999999999999997 +lat_1=43.24999999999996 +lat_2=44.74999999999996 +x_0=1700000 +y_0=3200000",
          18104: "lcc +lat_0=44.99999999999996 +lon_0=2.999999999999997 +lat_1=44.24999999999996 +lat_2=45.74999999999996 +x_0=1700000 +y_0=4200000",
          18105: "lcc +lat_0=45.99999999999996 +lon_0=2.999999999999997 +lat_1=45.24999999999996 +lat_2=46.74999999999995 +x_0=1700000 +y_0=5200000",
          18106: "lcc +lat_0=46.99999999999995 +lon_0=2.999999999999997 +lat_1=46.24999999999995 +lat_2=47.74999999999995 +x_0=1700000 +y_0=6200000",
          18107: "lcc +lat_0=47.99999999999995 +lon_0=2.999999999999997 +lat_1=47.24999999999995 +lat_2=48.74999999999995 +x_0=1700000 +y_0=7200000",
          18108: "lcc +lat_0=48.99999999999995 +lon_0=2.999999999999997 +lat_1=48.24999999999995 +lat_2=49.74999999999995 +x_0=1700000 +y_0=8200000",
          18109: "lcc +lat_0=49.99999999999995 +lon_0=2.999999999999997 +lat_1=49.24999999999995 +lat_2=50.74999999999995 +x_0=1700000 +y_0=9200000",
          18110: "lcc +lat_0=39.5 +lon_0=68 +k_0=0.99846154 +x_0=2153865.7391685303 +y_0=2368292.194628102",
          18111: "lcc +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407",
          18112: "lcc +lat_0=25.999999999999975 +lon_0=73.99999999999993 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407",
          18113: "lcc +lat_0=25.999999999999975 +lon_0=89.99999999999991 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407",
          18114: "lcc +lat_0=18.999999999999982 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407",
          18115: "lcc +lat_0=18.999999999999982 +lon_0=99.9999999999999 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407",
          18116: "lcc +lat_0=11.999999999999988 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407",
          18117: "lcc +lat_0=11.999999999999988 +lon_0=99.9999999999999 +k_0=0.99878641 +x_0=2743195.592233322 +y_0=914398.5307444407",
          18121: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9996 +x_0=1500000 +y_0=0",
          18122: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9996 +x_0=2520000 +y_0=0",
          18131: "lcc +lat_0=33.29999999999997 +lon_0=-5.399999999999995 +k_0=0.999625769 +x_0=500000 +y_0=300000",
          18132: "lcc +lat_0=29.69999999999997 +lon_0=-5.399999999999995 +k_0=0.999615596 +x_0=500000 +y_0=300000",
          18133: "lcc +lat_0=26.099999999999977 +lon_0=-5.399999999999995 +k_0=0.9996 +x_0=1200000 +y_0=400000",
          18134: "lcc +lat_0=26.099999999999977 +lon_0=-5.399999999999995 +k_0=0.999616304 +x_0=1200000 +y_0=400000",
          18135: "lcc +lat_0=22.49999999999998 +lon_0=-5.399999999999995 +k_0=0.999616437 +x_0=1500000 +y_0=400000",
          18141: "tmerc +lat_0=-39 +lon_0=175.5 +k_0=1 +x_0=274319.5243848086 +y_0=365759.36584641144",
          18142: "tmerc +lat_0=-44 +lon_0=171.5 +k_0=1 +x_0=457199.20730801433 +y_0=457199.20730801433",
          18151: "tmerc +lat_0=4 +lon_0=4.5 +k_0=0.99975 +x_0=230738.26 +y_0=0",
          18152: "tmerc +lat_0=4 +lon_0=8.5 +k_0=0.99975 +x_0=670553.98 +y_0=0",
          18153: "tmerc +lat_0=4 +lon_0=12.5 +k_0=0.99975 +x_0=1110369.7 +y_0=0",
          18161: "tmerc +lat_0=-6 +lon_0=-80.5 +k_0=0.99983008 +x_0=222000 +y_0=1426834.743",
          18162: "tmerc +lat_0=-9.5 +lon_0=-76 +k_0=0.99932994 +x_0=720000 +y_0=1039979.159",
          18163: "tmerc +lat_0=-9.5 +lon_0=-70.5 +k_0=0.99952992 +x_0=1324000 +y_0=1040084.558",
          18171: "tmerc +lat_0=0 +lon_0=116.99999999999989 +k_0=0.99995 +x_0=500000 +y_0=0",
          18172: "tmerc +lat_0=0 +lon_0=118.99999999999989 +k_0=0.99995 +x_0=500000 +y_0=0",
          18173: "tmerc +lat_0=0 +lon_0=120.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0",
          18174: "tmerc +lat_0=0 +lon_0=122.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0",
          18175: "tmerc +lat_0=0 +lon_0=124.99999999999987 +k_0=0.99995 +x_0=500000 +y_0=0",
          18180: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=1 +x_0=500000 +y_0=0",
          18181: "lcc +lat_0=35.999999999999964 +lon_0=9.89999999999999 +k_0=0.999625544 +x_0=500000 +y_0=300000",
          18182: "lcc +lat_0=33.29999999999997 +lon_0=9.89999999999999 +k_0=0.999625769 +x_0=500000 +y_0=300000",
          18183: "tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=1 +x_0=500000 +y_0=0",
          18184: "tmerc +lat_0=0 +lon_0=19.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          18185: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          18186: "tmerc +lat_0=0 +lon_0=21.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          18187: "tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=1 +x_0=500000 +y_0=0",
          18188: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=500000 +y_0=0",
          18189: "tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=1 +x_0=500000 +y_0=0",
          18190: "tmerc +lat_0=0 +lon_0=25.999999999999975 +k_0=1 +x_0=500000 +y_0=0",
          18191: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=1 +x_0=1500000 +y_0=0",
          18192: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=1 +x_0=2500000 +y_0=0",
          18193: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=3500000 +y_0=0",
          18194: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=4500000 +y_0=0",
          18195: "tmerc +lat_0=0 +lon_0=26.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          18196: "tmerc +lat_0=0 +lon_0=27.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          18197: "tmerc +lat_0=0 +lon_0=28.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          18198: "tmerc +lat_0=0 +lon_0=29.99999999999997 +k_0=1 +x_0=500000 +y_0=0",
          18199: "tmerc +lat_0=0 +lon_0=30.999999999999968 +k_0=1 +x_0=500000 +y_0=0",
          18201: "cass +lat_0=31.734096944444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=126867.909",
          18202: "tmerc +lat_0=31.734096944444445 +lon_0=35.21208055555556 +k_0=1 +x_0=170251.555 +y_0=1126867.909",
          18203: "cass +lat_0=31.734096944444445 +lon_0=35.21208055555556 +x_0=170251.555 +y_0=1126867.909",
          18204: "tmerc +lat_0=31.734393611111113 +lon_0=35.20451694444445 +k_0=1.0000067 +x_0=219529.584 +y_0=626907.39",
          18205: "tmerc +lat_0=0 +lon_0=32.999999999999964 +k_0=1 +x_0=5500000 +y_0=0",
          18211: "lcc +lat_0=16.816666666666666 +lon_0=-90.33333333333333 +k_0=0.99992226 +x_0=500000 +y_0=292209.579",
          18212: "lcc +lat_0=14.9 +lon_0=-90.33333333333333 +k_0=0.99989906 +x_0=500000 +y_0=325992.681",
          18221: "tmerc +lat_0=58 +lon_0=-4.666666666666667 +k_0=1 +x_0=0 +y_0=0",
          18222: "tmerc +lat_0=58 +lon_0=-2.3333333333333335 +k_0=1 +x_0=0 +y_0=0",
          18223: "tmerc +lat_0=58 +lon_0=0 +k_0=1 +x_0=0 +y_0=0",
          18224: "tmerc +lat_0=58 +lon_0=2.5 +k_0=1 +x_0=0 +y_0=0",
          18225: "tmerc +lat_0=58 +lon_0=6.166666666666667 +k_0=1 +x_0=0 +y_0=0",
          18226: "tmerc +lat_0=58 +lon_0=10.166666666666666 +k_0=1 +x_0=0 +y_0=0",
          18227: "tmerc +lat_0=58 +lon_0=14.166666666666666 +k_0=1 +x_0=0 +y_0=0",
          18228: "tmerc +lat_0=58 +lon_0=18.333333333333332 +k_0=1 +x_0=0 +y_0=0",
          18231: "lcc +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5",
          18232: "lcc +lat_0=25.999999999999975 +lon_0=73.99999999999993 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5",
          18233: "lcc +lat_0=18.999999999999982 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5",
          18234: "lcc +lat_0=11.999999999999988 +lon_0=79.99999999999991 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5",
          18235: "lcc +lat_0=25.999999999999975 +lon_0=89.99999999999991 +k_0=0.99878641 +x_0=2743195.5 +y_0=914398.5",
          18236: "lcc +lat_0=32.5 +lon_0=68 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8",
          18237: "lcc +lat_0=25.999999999999975 +lon_0=73.99999999999993 +k_0=0.99878641 +x_0=2743196.4 +y_0=914398.8",
          18238: "lcc +lat_0=25.999999999999975 +lon_0=89.99999999999991 +k_0=0.99878641 +x_0=2743185.69 +y_0=914395.23",
          18240: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.9999 +x_0=200000 +y_0=0",
          18241: "tmerc +lat_0=0 +lon_0=10.99999999999999 +k_0=0.9999 +x_0=200000 +y_0=0",
          18242: "tmerc +lat_0=0 +lon_0=12.999999999999988 +k_0=0.9999 +x_0=200000 +y_0=0",
          18243: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=200000 +y_0=0",
          18244: "tmerc +lat_0=0 +lon_0=16.999999999999982 +k_0=0.9999 +x_0=200000 +y_0=0",
          18245: "tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=0.9999 +x_0=200000 +y_0=0",
          18246: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=200000 +y_0=0",
          18247: "tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=0.9999 +x_0=200000 +y_0=0",
          18248: "tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=0.9999 +x_0=200000 +y_0=0",
          18251: "tmerc +lat_0=37.999999999999964 +lon_0=128.99999999999986 +k_0=1 +x_0=200000 +y_0=500000",
          18252: "tmerc +lat_0=37.999999999999964 +lon_0=126.99999999999987 +k_0=1 +x_0=200000 +y_0=500000",
          18253: "tmerc +lat_0=37.999999999999964 +lon_0=124.99999999999987 +k_0=1 +x_0=200000 +y_0=500000",
          18260: "lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=0 +y_0=-52684.972",
          18261: "lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=200000 +y_0=147315.028",
          18262: "lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=500000 +y_0=447315.028",
          18263: "lcc +lat_0=10.166666666666666 +lon_0=-71.60561777777777 +k_0=1 +x_0=-17044 +y_0=-23139.97",
          18275: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=5500000 +y_0=0",
          18276: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.9999 +x_0=6500000 +y_0=0",
          18277: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.9999 +x_0=7500000 +y_0=0",
          18278: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9999 +x_0=8500000 +y_0=0",
          18280: "sterea +lat_0=50.625 +lon_0=21.083333333333332 +k_0=0.9998 +x_0=4637000 +y_0=5467000",
          18281: "sterea +lat_0=50.625 +lon_0=21.083333333333332 +k_0=0.9998 +x_0=4637000 +y_0=5647000",
          18282: "sterea +lat_0=53.00194444444445 +lon_0=21.502777777777776 +k_0=0.9998 +x_0=4603000 +y_0=5806000",
          18283: "sterea +lat_0=53.583333333333336 +lon_0=17.008333333333333 +k_0=0.9998 +x_0=3501000 +y_0=5999000",
          18284: "sterea +lat_0=51.670833333333334 +lon_0=16.672222222222224 +k_0=0.9998 +x_0=3703000 +y_0=5627000",
          18285: "tmerc +lat_0=0 +lon_0=18.958333333333332 +k_0=0.999983 +x_0=237000 +y_0=-4700000",
          18286: "sterea +lat_0=52.166666666666664 +lon_0=19.166666666666668 +k_0=0.999714 +x_0=500000 +y_0=500000",
          18300: "tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=0.9993 +x_0=500000 +y_0=-5300000",
          18305: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.999923 +x_0=5500000 +y_0=0",
          18306: "tmerc +lat_0=0 +lon_0=17.999999999999982 +k_0=0.999923 +x_0=6500000 +y_0=0",
          18307: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.999923 +x_0=7500000 +y_0=0",
          18308: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.999923 +x_0=8500000 +y_0=0",
          18310: "tmerc +lat_0=0 +lon_0=8.999999999999991 +k_0=0.99995 +x_0=200000 +y_0=0",
          18311: "tmerc +lat_0=0 +lon_0=10.99999999999999 +k_0=0.99995 +x_0=200000 +y_0=0",
          18312: "tmerc +lat_0=0 +lon_0=12.999999999999988 +k_0=0.99995 +x_0=200000 +y_0=0",
          18313: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.99995 +x_0=200000 +y_0=0",
          18314: "tmerc +lat_0=0 +lon_0=16.999999999999982 +k_0=0.99995 +x_0=200000 +y_0=0",
          18315: "tmerc +lat_0=0 +lon_0=18.999999999999982 +k_0=0.99995 +x_0=200000 +y_0=0",
          18316: "tmerc +lat_0=0 +lon_0=20.99999999999998 +k_0=0.99995 +x_0=200000 +y_0=0",
          18317: "tmerc +lat_0=0 +lon_0=22.99999999999998 +k_0=0.99995 +x_0=200000 +y_0=0",
          18318: "tmerc +lat_0=0 +lon_0=24.999999999999975 +k_0=0.99995 +x_0=200000 +y_0=0",
          18319: "tmerc +lat_0=0 +lon_0=16.999999999999982 +k_0=0.9965 +x_0=1000000 +y_0=0",
          18401: "tmerc +lat_0=0 +lon_0=9.5 +k_0=0.99995 +x_0=200000 +y_0=0",
          18402: "tmerc +lat_0=0 +lon_0=11.999999999999988 +k_0=0.99995 +x_0=500000 +y_0=0",
          18403: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=1 +x_0=900000 +y_0=0",
          18411: "tmerc +lat_0=0 +lon_0=-13.5 +k_0=0.999 +x_0=1000000 +y_0=1000000",
          18412: "tmerc +lat_0=0 +lon_0=-6.5 +k_0=0.999 +x_0=1000000 +y_0=1000000",
          18413: "tmerc +lat_0=0 +lon_0=0.5 +k_0=0.999 +x_0=1000000 +y_0=1000000",
          18414: "tmerc +lat_0=0 +lon_0=7.5 +k_0=0.999 +x_0=1000000 +y_0=1000000",
          18415: "tmerc +lat_0=0 +lon_0=10.5 +k_0=0.999 +x_0=1000000 +y_0=1000000",
          18416: "tmerc +lat_0=0 +lon_0=17.666666666666668 +k_0=0.999 +x_0=1000000 +y_0=1000000",
          18417: "tmerc +lat_0=0 +lon_0=24.5 +k_0=0.999 +x_0=1000000 +y_0=1000000",
          18441: "tmerc +lat_0=0.11666666666666667 +lon_0=41.53333333333333 +k_0=1 +x_0=1300000 +y_0=0",
          18442: "tmerc +lat_0=0.11666666666666667 +lon_0=44.53333333333333 +k_0=1 +x_0=2300000 +y_0=0",
          18443: "tmerc +lat_0=0.11666666666666667 +lon_0=47.53333333333333 +k_0=1 +x_0=3300000 +y_0=0",
          18444: "tmerc +lat_0=0.11666666666666667 +lon_0=50.53333333333333 +k_0=1 +x_0=4300000 +y_0=0",
          18446: "tmerc +lat_0=0.13333333333333333 +lon_0=50.766666666666666 +k_0=1 +x_0=2300000 +y_0=0",
          18447: "tmerc +lat_0=0.13333333333333333 +lon_0=53.766666666666666 +k_0=1 +x_0=3300000 +y_0=0",
          18448: "tmerc +lat_0=0.13333333333333333 +lon_0=56.766666666666666 +k_0=1 +x_0=4300000 +y_0=0",
          18450: "tmerc +lat_0=0.1 +lon_0=21.95 +k_0=1 +x_0=250000 +y_0=0",
          18451: "tmerc +lat_0=0.1 +lon_0=24.95 +k_0=1 +x_0=1250000 +y_0=0",
          18452: "tmerc +lat_0=0.1 +lon_0=27.95 +k_0=1 +x_0=2250000 +y_0=0",
          19838: "omerc +x_0=2000000 +y_0=5000000 +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984",
          19839: "tmerc +lat_0=0 +lon_0=55.333333333333336 +k_0=1 +x_0=500000 +y_0=0",
          19840: "stere +x_0=0 +y_0=0 +lat_ts=74.99999999999993 +lon_0=0",
          19841: "omerc +lat_0=46.95240555555556 +lonc=7.439583333333333 +alpha=90 +gamma=90 +k_0=1 +x_0=0 +y_0=0",
          19842: "stere +x_0=0 +y_0=0 +lat_ts=70.99999999999993 +lon_0=0",
          19843: "merc +lon_0=99.9999999999999 +x_0=0 +y_0=0 +lat_1=-40.99999999999996",
          19844: "lcc +lat_0=43.99999999999996 +lon_0=-69.99999999999993 +lat_1=49.99999999999995 +lat_2=45.99999999999996 +x_0=800000 +y_0=0",
          19845: "tmerc +lat_0=0 +lon_0=14.999999999999986 +k_0=0.9999 +x_0=500000 +y_0=-5000000",
          19846: "eqc +lat_0=0 +x_0=0 +y_0=0 +lon_0=0",
          19847: "merc +ellps=sphere +lat_0=0 +lon_0=0 +k_0=1 +x_0=0 +y_0=0",
          19848: "tmerc +lat_0=-25.068552611111112 +lon_0=-130.11296711111112 +k_0=1 +x_0=14200 +y_0=15500",
          19849: "tmerc +lat_0=32 +lon_0=-64.75 +k_0=1 +x_0=550000 +y_0=100000",
          19851: "tmerc +lat_0=0 +lon_0=16.499999999999982 +k_0=0.9999 +x_0=500000 +y_0=0",
          19852: "lcc +lat_0=0 +lon_0=16.5 +lat_1=45.916666666666664 +lat_2=43.083333333333336 +x_0=0 +y_0=0",
          19853: "tmerc +lat_0=39.668258333333334 +lon_0=-8.133108333333334 +k_0=1 +x_0=0 +y_0=0",
          19854: "lcc +lat_0=-54.99999999999994 +lon_0=-36.999999999999964 +lat_1=-54 +lat_2=-54.75 +x_0=0 +y_0=0",
          19855: "merc +lat_0=-40.99999999999996 +lon_0=99.9999999999999 +k_0=1 +x_0=0 +y_0=0",
          19856: "tmerc +lat_0=-21.116666666666667 +lon_0=55.53333333333333 +k_0=1 +x_0=160000 +y_0=50000",
          19857: "lcc +lat_0=0 +lon_0=-111.99999999999989 +lat_1=61.999999999999936 +lat_2=69.99999999999993 +x_0=0 +y_0=0",
          19858: "aea +lat_0=59 +lon_0=-132.5 +lat_1=61.666666666666664 +lat_2=68 +x_0=500000 +y_0=500000",
          19859: "tmerc +lat_0=-17 +lon_0=178.75 +k_0=0.99985 +x_0=2000000 +y_0=4000000",
          19860: "lcc +lat_0=17.999999999999982 +lon_0=-76.99999999999993 +k_0=1 +x_0=750000 +y_0=650000",
          19861: "labrd +x_0=400000 +y_0=800000 +lat_0=-18.89999999999998 +lonc=44.09999999999996 +alpha=18.89999999999998 +k_0=0.9995",
          19862: "lcc +lat_0=50.797815 +lon_0=4.359215833333333 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=150328 +y_0=166262",
          19863: "lcc +lat_0=20.99999999999998 +lon_0=113.99999999999989 +lat_1=17.999999999999982 +lat_2=23.999999999999975 +x_0=500000 +y_0=500000",
          19864: "tmerc +lat_0=1.3666666666666667 +lon_0=103.83333333333333 +k_0=1 +x_0=28001.642 +y_0=38744.572",
          19865: "stere +x_0=0 +y_0=0 +lat_ts=69.99999999999993 +lon_0=-44.99999999999996",
          19866: "stere +x_0=0 +y_0=0 +lat_ts=-69.99999999999993 +lon_0=0",
          19867: "laea +ellps=sphere +x_0=0 +y_0=0 +lat_0=89.99999999999991 +lon_0=0",
          19868: "laea +ellps=sphere +x_0=0 +y_0=0 +lat_0=-89.99999999999991 +lon_0=0",
          19869: "cea +ellps=sphere +lon_0=0 +x_0=0 +y_0=0 +lat_1=29.99999999999997",
          19871: "omerc +x_0=804670.24 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579049999997 +gamma=323.13010236111114 +k_0=0.99984",
          19872: "omerc +x_0=804670.24 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579049999997 +gamma=323.13010236111114 +k_0=0.99984",
          19873: "lcc +lat_0=-22.26969175 +lon_0=166.44242575 +lat_1=-22.24469175 +lat_2=-22.294691750000002 +x_0=0.66 +y_0=1.02",
          19874: "lcc +lat_0=-22.26972222222222 +lon_0=166.4425 +lat_1=-22.244722222222222 +lat_2=-22.294722222222223 +x_0=8.313 +y_0=-2.354",
          19875: "lcc +lat_0=0 +lon_0=-84.99999999999991 +lat_1=44.49999999999996 +lat_2=53.49999999999994 +x_0=930000 +y_0=6430000",
          19876: "tmerc +lat_0=0 +lon_0=18.05779 +k_0=0.99999425 +x_0=100178.1808 +y_0=-6500614.7836",
          19878: "cass +hyperbolic +lat_0=-16.25 +lon_0=179.33333333333334 +x_0=251727.91554240003 +y_0=334519.953768",
          19879: "cass +lat_0=-17.999999999999982 +lon_0=177.99999999999983 +x_0=109435.392 +y_0=141622.272",
          19880: "tmerc +lat_0=-17 +lon_0=178.75 +k_0=0.99985 +x_0=2000000 +y_0=4000000",
          19881: "tmerc +lat_0=0 +lon_0=-114.99999999999989 +k_0=0.9992 +x_0=500000 +y_0=0",
          19882: "tmerc +lat_0=0 +lon_0=-114.99999999999989 +k_0=0.9992 +x_0=0 +y_0=0",
          19883: "merc +lat_0=0 +lon_0=0 +k_0=1 +x_0=0 +y_0=0",
          19884: "merc +lon_0=50.99999999999995 +x_0=0 +y_0=0 +lat_1=41.99999999999996",
          19885: "cass +lat_0=5.972543658333334 +lon_0=102.29524166944444 +x_0=13227.851 +y_0=8739.894",
          19886: "cass +lat_0=4.859063022222222 +lon_0=100.81541058611111 +x_0=-1.769 +y_0=133454.779",
          19887: "cass +lat_0=5.964672713888889 +lon_0=100.63637111111112 +x_0=0 +y_0=0",
          19888: "cass +lat_0=5.421517541666667 +lon_0=100.34437696388889 +x_0=-23.414 +y_0=62.283",
          19889: "cass +lat_0=4.9762852 +lon_0=103.070275625 +x_0=19594.245 +y_0=3371.895",
          19890: "cass +lat_0=3.6846490500000004 +lon_0=101.38910791388889 +x_0=-34836.161 +y_0=56464.049",
          19891: "cass +lat_0=3.769388088888889 +lon_0=102.36829898333333 +x_0=-7368.228 +y_0=6485.858",
          19892: "cass +lat_0=2.682347636111111 +lon_0=101.97490504166667 +x_0=3673.785 +y_0=-4240.573",
          19893: "cass +lat_0=2.1216797444444446 +lon_0=103.42793623611112 +x_0=-14810.562 +y_0=8758.32",
          19894: "omerc +x_0=0 +y_0=0 +lat_0=4 +lonc=115 +alpha=53.315809949999995 +gamma=53.13010236111111 +k_0=0.99984",
          19895: "omerc +x_0=804671 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579646666663 +gamma=323.13010236111114 +k_0=0.99984",
          19896: "cass +lat_0=22.312133333333335 +lon_0=114.17855555555556 +x_0=40243.577756042374 +y_0=19069.933515125784",
          19897: "lcc +lat_0=63.39067499999994 +lon_0=-91.86666666666666 +lat_1=48.99999999999995 +lat_2=76.99999999999993 +x_0=6200000 +y_0=3000000",
          19898: "merc +lat_0=0 +lon_0=-149.99999999999986 +k_0=1 +x_0=0 +y_0=0",
          19899: "lcc +lat_0=-20.195069444444446 +lon_0=57.52182777777778 +k_0=1 +x_0=1000000 +y_0=1000000",
          19900: "tmerc +lat_0=0 +lon_0=50.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0",
          19901: "lcc +lat_0=90 +lon_0=0 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=150000 +y_0=5400000",
          19902: "lcc +lat_0=90 +lon_0=4.356939722222222 +lat_1=49.833333333333336 +lat_2=51.166666666666664 +x_0=150000.01256 +y_0=5400088.4378",
          19903: "lcc +lat_0=49.49999999999995 +lon_0=5.399999999999995 +k_0=0.99950908 +x_0=500000 +y_0=300000",
          19904: "tmerc +lat_0=4.666666666666667 +lon_0=-1 +k_0=0.99975 +x_0=274319.51 +y_0=0",
          19905: "merc +lat_0=0 +lon_0=109.99999999999989 +k_0=0.997 +x_0=3900000 +y_0=900000",
          19906: "lcc +lat_0=32.5 +lon_0=45 +k_0=0.9987864078 +x_0=1500000 +y_0=1166200",
          19907: "tmerc +lat_0=29.02626833333333 +lon_0=46.5 +k_0=0.9994 +x_0=800000 +y_0=0",
          19908: "tmerc +lat_0=53.5 +lon_0=-8 +k_0=1.000035 +x_0=200000 +y_0=250000",
          19909: "lcc +lat_0=17.999999999999982 +lon_0=-76.99999999999993 +k_0=1 +x_0=167638.49597000002 +y_0=121918.90616000001",
          19910: "lcc +lat_0=17.999999999999982 +lon_0=-76.99999999999993 +k_0=1 +x_0=250000 +y_0=150000",
          19911: "omerc +lat_0=-18.89999999999998 +lonc=44.09999999999996 +alpha=18.89999999999998 +gamma=18.89999999999998 +k_0=0.9995 +x_0=400000 +y_0=800000",
          19913: "sterea +lat_0=52.15616055555555 +lon_0=5.3876388888888895 +k_0=0.9999079 +x_0=0 +y_0=0",
          19914: "sterea +lat_0=52.15616055555555 +lon_0=5.3876388888888895 +k_0=0.9999079 +x_0=155000 +y_0=463000",
          19915: "lcc +lat_0=14.999999999999986 +lon_0=44.99999999999996 +k_0=0.999365678 +x_0=1500000 +y_0=1000000",
          19916: "tmerc +lat_0=48.99999999999995 +lon_0=-1.999999999999998 +k_0=0.9996012717 +x_0=400000 +y_0=-100000",
          19917: "nzmg +lat_0=-40.99999999999996 +lon_0=172.99999999999983 +x_0=2510000 +y_0=6023150",
          19919: "tmerc +lat_0=24.45 +lon_0=51.21666666666667 +k_0=0.99999 +x_0=200000 +y_0=300000",
          19920: "cass +lat_0=1.2876466666666666 +lon_0=103.85300222222222 +x_0=30000 +y_0=30000",
          19921: "lcc +lat_0=39.99999999999996 +lon_0=0 +k_0=0.9988085293 +x_0=600000 +y_0=600000",
          19922: "omerc +lat_0=46.95240555555556 +lonc=7.439583333333333 +alpha=90 +gamma=90 +k_0=1 +x_0=600000 +y_0=200000",
          19923: "omerc +lat_0=46.95240555555556 +lonc=0 +alpha=90 +gamma=90 +k_0=1 +x_0=0 +y_0=0",
          19924: "cass +lat_0=11.25217861111111 +lon_0=-60.686008888888885 +x_0=37718.66159325 +y_0=36209.91512952",
          19925: "cass +lat_0=10.441666666666666 +lon_0=-61.333333333333336 +x_0=86501.46392052 +y_0=65379.0134283",
          19926: "sterea +lat_0=45.99999999999996 +lon_0=24.999999999999975 +k_0=0.99975 +x_0=500000 +y_0=500000",
          19927: "sterea +lat_0=45.9 +lon_0=25.39246588888889 +k_0=0.9996667 +x_0=500000 +y_0=500000",
          19928: "tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=0.9996 +x_0=500000 +y_0=0",
          19929: "tmerc +lat_0=0 +lon_0=15.808277777777779 +k_0=1 +x_0=1500000 +y_0=0",
          19930: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9996 +x_0=500000 +y_0=0",
          19931: "omerc +lat_0=47.14439372222222 +lonc=19.04857177777778 +alpha=90 +gamma=90 +k_0=0.99993 +x_0=650000 +y_0=200000",
          19933: "sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=700000 +y_0=400000",
          19934: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9998 +x_0=500000 +y_0=0",
          19935: "omerc +x_0=804671.2997750349 +y_0=0 +lat_0=4 +lonc=102.25 +alpha=323.02579049999997 +gamma=323.13010236111114 +k_0=0.99984",
          19936: "tmerc +lat_0=39.666666666666664 +lon_0=1 +k_0=1 +x_0=200000 +y_0=300000",
          19938: "lcc +lat_0=57.51755393055556 +lon_0=24 +lat_1=59.333333333333336 +lat_2=58 +x_0=500000 +y_0=6375000",
          19939: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9996 +x_0=500000 +y_0=0",
          19940: "lcc +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000",
          19941: "poly +lat_0=0 +lon_0=-53.99999999999994 +x_0=5000000 +y_0=10000000",
          19942: "tmerc +lat_0=0 +lon_0=-61.999999999999936 +k_0=0.9995 +x_0=400000 +y_0=0",
          19943: "tmerc +lat_0=13.176388888888889 +lon_0=-59.55972222222222 +k_0=0.9999986 +x_0=30000 +y_0=75000",
          19944: "lcc +lat_0=44 +lon_0=-68.5 +lat_1=60 +lat_2=46 +x_0=0 +y_0=0",
          19945: "sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=300000 +y_0=800000",
          19946: "sterea +lat_0=46.5 +lon_0=-66.5 +k_0=0.999912 +x_0=2500000 +y_0=7500000",
          19947: "lcc +lat_0=47.5 +lon_0=13.333333333333334 +lat_1=49 +lat_2=46 +x_0=400000 +y_0=400000",
          19948: "lcc +lat_0=34.65 +lon_0=37.35 +k_0=0.9996256 +x_0=300000 +y_0=300000",
          19949: "sterea +lat_0=34.19999999999997 +lon_0=39.14999999999996 +k_0=0.9995341 +x_0=0 +y_0=0",
          19950: "omerc +lat_0=46.95240555555556 +lonc=7.439583333333333 +alpha=90 +gamma=90 +k_0=1 +x_0=2600000 +y_0=1200000",
          19951: "omerc +lat_0=27.518828805555554 +lonc=52.60353916666667 +alpha=0.5716611944444444 +gamma=0.5716611944444444 +k_0=0.999895934 +x_0=658377.437 +y_0=3044969.194",
          19952: "krovak +alpha=30.28813975277778 +x_0=0 +y_0=0 +lat_0=49.5 +k_0=0.9999 +lon_0=42.5",
          19953: "cass +lat_0=25.382361111111113 +lon_0=50.76138888888889 +x_0=100000 +y_0=100000",
          19954: "tmerc +lat_0=0 +lon_0=-55.68333333333333 +k_0=0.9996 +x_0=500000 +y_0=0",
          19955: "tmerc +lat_0=0 +lon_0=-55.68333333333333 +k_0=0.9999 +x_0=500000 +y_0=0",
          19956: "omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984 +x_0=590476.8714630402 +y_0=442857.653094361",
          19957: "omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984 +x_0=590476.872743198 +y_0=442857.65455739846",
          19958: "omerc +lat_0=4 +lonc=115 +alpha=53.31582047222222 +gamma=53.13010236111111 +k_0=0.99984 +x_0=590476.87 +y_0=442857.65",
          19959: "tmerc +lat_0=4.666666666666667 +lon_0=-1 +k_0=0.99975 +x_0=274319.73916335794 +y_0=0",
          19960: "sterea +lat_0=47.25 +lon_0=-63 +k_0=0.999912 +x_0=400000 +y_0=800000",
          19961: "lcc +lat_0=90 +lon_0=4.367486666666666 +lat_1=51.16666723333333 +lat_2=49.8333339 +x_0=150000.013 +y_0=5400088.438",
          19962: "tmerc +lat_0=53.5 +lon_0=-8 +k_0=0.99982 +x_0=600000 +y_0=750000",
          19963: "tmerc +lat_0=6.666666666666667 +lon_0=-12 +k_0=1 +x_0=152399.8550907544 +y_0=0",
          19964: "tmerc +lat_0=6.666666666666667 +lon_0=-12 +k_0=1 +x_0=243839.76814520705 +y_0=182879.82610890528",
          19965: "laea +ellps=sphere +x_0=0 +y_0=0 +lat_0=44.99999999999996 +lon_0=-99.9999999999999",
          19966: "tmerc +lat_0=49.833333333333336 +lon_0=6.166666666666667 +k_0=1 +x_0=80000 +y_0=100000",
          19967: "tmerc +lat_0=0 +lon_0=15 +k_0=0.9999 +x_0=500000 +y_0=0",
          19968: "eqc +ellps=sphere +lat_0=0 +lon_0=0 +x_0=0 +y_0=0",
          19969: "tmerc +lat_0=39.666666666666664 +lon_0=1 +k_0=1 +x_0=0 +y_0=0",
          19971: "tmerc +lat_0=0 +lon_0=172.99999999999983 +k_0=0.9996 +x_0=1600000 +y_0=10000000",
          19972: "tmerc +lat_0=53.5 +lon_0=-8 +k_0=1.000035 +x_0=200000 +y_0=250000",
          19973: "tmerc +lat_0=53.5 +lon_0=-8 +k_0=1 +x_0=200000 +y_0=250000",
          19974: "tmerc +lat_0=39.666666666666664 +lon_0=-8.131906111111112 +k_0=1 +x_0=180.598 +y_0=-86.99",
          19975: "cass +lat_0=10.441666666666666 +lon_0=-61.333333333333336 +x_0=86501.46392052001 +y_0=65379.0134283",
          19976: "lcc +lat_0=5.999999999999994 +lon_0=-65.99999999999993 +lat_1=8.999999999999991 +lat_2=2.999999999999997 +x_0=1000000 +y_0=1000000",
          19977: "lcc +lat_0=25.089509999999997 +lon_0=47.99999999999995 +lat_1=16.999999999999982 +lat_2=32.999999999999964 +x_0=0 +y_0=0",
          19978: "tmerc +lat_0=22.312133333333335 +lon_0=114.17855555555556 +k_0=1 +x_0=836694.05 +y_0=819069.8",
          19981: "lcc +lat_0=-21.5 +lon_0=166 +lat_1=-20.666666666666668 +lat_2=-22.333333333333332 +x_0=400000 +y_0=300000",
          19982: "tmerc +lat_0=-21.116666666666667 +lon_0=55.53333333333333 +k_0=1 +x_0=50000 +y_0=160000",
          19984: "aea +lat_0=44.99999999999996 +lon_0=-125.99999999999987 +lat_1=50 +lat_2=58.5 +x_0=1000000 +y_0=0",
          19985: "lcc +lat_0=51.99999999999995 +lon_0=9.99999999999999 +lat_1=34.999999999999964 +lat_2=64.99999999999993 +x_0=4000000 +y_0=2800000",
          19986: "laea +lat_0=51.99999999999995 +lon_0=9.99999999999999 +x_0=4321000 +y_0=3210000",
          19989: "lcc +lat_0=65 +lon_0=-19 +lat_1=64.25 +lat_2=65.75 +x_0=500000 +y_0=500000",
          19990: "tmerc +lat_0=0 +lon_0=23.999999999999975 +k_0=0.9996 +x_0=500000 +y_0=-6000000",
          19991: "tmerc +lat_0=0 +lon_0=-8.5 +k_0=1 +x_0=50000 +y_0=-7800000",
          19992: "stere +x_0=0 +y_0=0 +lat_ts=-70.99999999999993 +lon_0=0",
          19993: "stere +x_0=6000000 +y_0=6000000 +lat_ts=-70.99999999999993 +lon_0=69.99999999999993",
          19994: "lcc +lat_0=-50 +lon_0=70 +lat_1=-68.5 +lat_2=-74.5 +x_0=6000000 +y_0=6000000",
          19995: "tmerc +lat_0=0 +lon_0=36.999999999999964 +k_0=0.9998 +x_0=500000 +y_0=-3000000",
          19996: "cass +lat_0=52.41864827777778 +lon_0=13.627203666666666 +x_0=40000 +y_0=10000",
          19997: "tmerc +lat_0=0 +lon_0=47.99999999999995 +k_0=1 +x_0=500000 +y_0=0",
          19998: "tmerc +lat_0=49.5 +lon_0=-2.4166666666666665 +k_0=0.999997 +x_0=47000 +y_0=50000",
          19999: "tmerc +lat_0=49.22499999999995 +lon_0=-2.1349999999999976 +k_0=0.9999999 +x_0=40000 +y_0=70000"
        };
      }, {}],
      9: [function(a2, b2, e3) {
        b2.exports = {
          1024: { m: 1, t: "scale" },
          1025: { m: 1e-3, t: "metre" },
          1026: { m: 1, t: "metre per second" },
          1027: { m: 3168876517273149e-26, t: "metre per second" },
          1028: { m: 1e-9, t: "scale" },
          1029: { m: 31556925445e-3, t: "second" },
          1030: { m: 31688765172731483e-33, t: "scale per second" },
          1031: { m: 4848136811095355e-24, t: "radian" },
          1032: { m: 15363146893207598e-32, t: "radian per second" },
          1033: { m: 0.01, t: "metre" },
          1034: { m: 31688765172731484e-26, t: "metre per second" },
          1035: { m: 1, t: "radian per second" },
          1036: { m: 1, t: "scale per second" },
          1040: { m: 1, t: "second" },
          1041: { m: 31688765172731486e-30, t: "scale per second" },
          1042: { m: 31688765172731486e-24, t: "metre per second" },
          1043: {
            m: 15363146893207598e-29,
            t: "radian per second"
          },
          9001: { m: 1, t: "metre" },
          9002: { m: 0.3048, t: "metre" },
          9003: { m: 0.30480060960121924, t: "metre" },
          9005: { m: 0.3047972654, t: "metre" },
          9014: { m: 1.8288, t: "metre" },
          9030: { m: 1852, t: "metre" },
          9031: { m: 1.0000135965, t: "metre" },
          9033: { m: 20.11684023368047, t: "metre" },
          9034: { m: 0.2011684023368047, t: "metre" },
          9035: { m: 1609.3472186944375, t: "metre" },
          9036: { m: 1e3, t: "metre" },
          9037: { m: 0.9143917962, t: "metre" },
          9038: { m: 20.1166195164, t: "metre" },
          9039: { m: 0.201166195164, t: "metre" },
          9040: { m: 0.9143984146160287, t: "metre" },
          9041: {
            m: 0.3047994715386762,
            t: "metre"
          },
          9042: { m: 20.116765121552632, t: "metre" },
          9043: { m: 0.2011676512155263, t: "metre" },
          9050: { m: 0.9143992, t: "metre" },
          9051: { m: 0.3047997333333333, t: "metre" },
          9052: { m: 20.1167824, t: "metre" },
          9053: { m: 0.201167824, t: "metre" },
          9060: { m: 0.9143992042898124, t: "metre" },
          9061: { m: 0.30479973476327077, t: "metre" },
          9062: { m: 20.116782494375872, t: "metre" },
          9063: { m: 0.2011678249437587, t: "metre" },
          9070: { m: 0.30480083333333335, t: "metre" },
          9080: { m: 0.30479951024814694, t: "metre" },
          9081: { m: 0.30479841, t: "metre" },
          9082: { m: 0.3047996, t: "metre" },
          9083: {
            m: 0.3047995,
            t: "metre"
          },
          9084: { m: 0.9143985307444408, t: "metre" },
          9085: { m: 0.91439523, t: "metre" },
          9086: { m: 0.9143988, t: "metre" },
          9087: { m: 0.9143985, t: "metre" },
          9093: { m: 1609.344, t: "metre" },
          9094: { m: 0.3047997101815088, t: "metre" },
          9095: { m: 0.3048007491, t: "metre" },
          9096: { m: 0.9144, t: "metre" },
          9097: { m: 20.1168, t: "metre" },
          9098: { m: 0.201168, t: "metre" },
          9099: { m: 0.914398, t: "metre" },
          9101: { m: 1, t: "radian" },
          9102: { m: 0.017453292519943278, t: "radian" },
          9103: { m: 2908882086657213e-19, t: "radian" },
          9104: { m: 4848136811095355e-21, t: "radian" },
          9105: {
            m: 0.01570796326794895,
            t: "radian"
          },
          9106: { m: 0.01570796326794895, t: "radian" },
          9109: { m: 1e-6, t: "radian" },
          9112: { m: 1570796326794895e-19, t: "radian" },
          9113: { m: 1570796326794895e-21, t: "radian" },
          9114: { m: 9817477042468094e-19, t: "radian" },
          9122: { m: 0.017453292519943278, t: "radian" },
          9201: { m: 1, t: "scale" },
          9202: { m: 1e-6, t: "scale" },
          9203: { m: 1, t: "scale" },
          9204: { m: 100.58420116840234, t: "metre" },
          9205: { m: 50.29210058420117, t: "metre" },
          9206: { m: 25.146050292100586, t: "metre" },
          9207: { m: 37.5, t: "metre" },
          9208: { m: 25, t: "metre" },
          9209: { m: 12.5, t: "metre" },
          9210: {
            m: 6.25,
            t: "metre"
          },
          9211: { m: 3.125, t: "metre" },
          9300: { m: 0.30479933333333337, t: "metre" },
          9301: { m: 20.116756, t: "metre" },
          9302: { m: 0.20116756, t: "metre" }
        };
      }, {}],
      10: [function(a2, b2, e3) {
        a2("core-js/stable/object/keys");
        a2("core-js/stable/string/trim");
        var c2 = a2("./EPSG/data/CRS.js"), d2 = a2("./EPSG/data/Units.js"), f2 = a2("./EPSG/data/ProjCoordTransGeoKey.js"), h2 = a2("./EPSG/data/ProjectionGeoKey.js"), k2 = a2("./EPSG/data/PCSKeys.js"), p2 = a2("./EPSG/data/Overrides.js"), l2 = [
          { names: ["GeodeticDatumGeoKey", "GeogGeodeticDatumGeoKey"], obj: a2("./EPSG/data/GeogGeodeticDatumGeoKey.js") },
          { names: ["PrimeMeridianGeoKey", "GeogPrimeMeridianGeoKey"], obj: a2("./EPSG/data/GeogPrimeMeridianGeoKey.js") },
          { names: ["EllipsoidGeoKey", "GeogEllipsoidGeoKey"], obj: a2("./EPSG/data/GeogEllipsoidGeoKey.js") }
        ], r2 = "+proj +lat_0 +lon_0 +lat_1 +lat_ts +lon_1 +lat_2 +lon_2 +k_0 +x_0 +y_0 +ellps +a +b +pm +towgs84 +approx".split(" "), v5 = function(g2) {
          return isNaN(g2) ? g2 : parseFloat(parseFloat(g2).toFixed(12));
        };
        b2.exports = { toProj4: function(g2) {
          var m2 = "", w2 = 1, z2 = 1, y2 = 1, n2 = {}, q2 = g2.GeodeticCRSGeoKey || g2.GeographicTypeGeoKey, u2 = g2.ProjectedCRSGeoKey || g2.ProjectedCSTypeGeoKey;
          q2 && u2 && (n2.bothGCSAndPCSAreSet = true);
          if (q2 = q2 || u2)
            (u2 = c2[q2 + ""]) && "number" !== typeof u2 ? "string" === typeof u2 ? m2 = u2 : (m2 = u2.p, w2 = u2.x, z2 = u2.y, y2 = u2.z || y2) : 32767 !== q2 && (n2.CRSNotSupported = q2);
          (q2 = g2.VerticalGeoKey || g2.VerticalCSTypeGeoKey) && 32767 !== q2 ? (u2 = c2[q2 + ""], "number" === typeof u2 ? y2 = u2 : u2.z || (n2.verticalCsNotSupported = q2)) : g2.VerticalUnitsGeoKey && (y2 = (q2 = d2[g2.VerticalUnitsGeoKey]) || y2, q2 || (n2.verticalCsUnitsNotSupported = g2.VerticalUnitsGeoKey), g2.VerticalDatumGeoKey && (n2.verticalDatumsNotSupported = g2.VerticalDatumGeoKey));
          m2 || (m2 = "+proj=longlat");
          q2 = $jscomp.makeIterator(l2);
          for (u2 = q2.next(); !u2.done; u2 = q2.next()) {
            u2 = u2.value;
            for (var A2 = $jscomp.makeIterator(u2.names), t2 = A2.next(); !t2.done; t2 = A2.next())
              if (t2 = g2[t2.value])
                t2 = u2.obj[t2 + ""], void 0 !== t2 && (m2 += " " + t2);
          }
          q2 = { GeogLinearUnitsGeoKey: 1, GeogAngularUnitsGeoKey: 1, ProjLinearUnitsGeoKey: 1 };
          u2 = {};
          for (var x2 in q2)
            if (t2 = void 0, A2 = g2[x2]) {
              if (32767 === A2) {
                var C2 = x2.substr(0, x2.length - 7) + "SizeGeoKey", D2 = g2[C2];
                D2 ? t2 = D2 : n2[C2 + "NotDefined"] = true;
              } else
                A2 && (C2 = void 0, t2 = null == (C2 = d2[A2.toString()]) ? void 0 : C2.m);
              t2 ? (u2[x2] = true, "GeogAngularUnitsGeoKey" === x2 && (t2 *= 180 / Math.PI)) : (t2 = 1, n2[x2 + "NotSupported"] = A2);
              q2[x2] = t2;
            }
          x2 = (g2.EllipsoidSemiMajorAxisGeoKey || g2.GeogSemiMajorAxisGeoKey || 0) * q2.GeogLinearUnitsGeoKey;
          t2 = (g2.EllipsoidSemiMinorAxisGeoKey || g2.GeogSemiMinorAxisGeoKey || 0) * q2.GeogLinearUnitsGeoKey;
          (A2 = g2.EllipsoidInvFlatteningGeoKey || g2.GeogInvFlatteningGeoKey) && x2 && (t2 = x2 - x2 / A2);
          x2 && (m2 += " +a=" + x2);
          t2 || -1 !== m2.indexOf("+b") || (t2 = x2);
          t2 && (m2 += " +b=" + t2);
          (x2 = g2.PrimeMeridianLongitudeGeoKey || g2.GeogPrimeMeridianLongGeoKey) && (m2 += " +pm=" + x2 * q2.GeogAngularUnitsGeoKey);
          g2.GeogTOWGS84GeoKey && (m2 += " +towgs84=" + g2.GeogTOWGS84GeoKey.join());
          g2.ProjectionGeoKey && 32767 !== g2.ProjectionGeoKey && ((x2 = h2[g2.ProjectionGeoKey + ""]) ? m2 += " +proj=" + x2 : n2.conversionNotSupported = g2.ProjectionGeoKey);
          x2 = $jscomp.makeIterator(["o1", "o2", "o3"]);
          for (t2 = x2.next(); !t2.done; t2 = x2.next()) {
            t2 = k2[t2.value];
            for (var B2 in t2)
              t2.hasOwnProperty(B2) && (A2 = g2[B2], void 0 !== A2 && (C2 = t2[B2], A2 *= 1 === C2.u ? q2.GeogAngularUnitsGeoKey : 2 === C2.u ? q2.ProjLinearUnitsGeoKey : 1, m2 += " +" + C2.p + "=" + A2));
          }
          (g2 = g2.ProjMethodGeoKey || g2.ProjCoordTransGeoKey) && 32767 !== g2 && ((B2 = f2[g2 + ""]) ? m2 += " +proj=" + B2 : n2.coordinateTransformationNotSupported = g2);
          m2 = (m2 + " +no_defs").split(" ");
          g2 = {};
          m2 = $jscomp.makeIterator(m2);
          for (B2 = m2.next(); !B2.done; B2 = m2.next())
            B2 = B2.value.trim().split("="), 1 === B2.length ? g2[B2[0]] = null : g2[B2[0].trim()] = B2[1].trim();
          p2(g2);
          m2 = "";
          x2 = [r2, Object.keys(g2)];
          B2 = {};
          x2 = $jscomp.makeIterator(x2);
          for (t2 = x2.next(); !t2.done; t2 = x2.next())
            for (t2 = $jscomp.makeIterator(t2.value), A2 = t2.next(); !A2.done; A2 = t2.next())
              A2 = A2.value, A2 in g2 && !B2[A2] && (m2 += A2, C2 = g2[A2], null !== C2 && (m2 += "=" + v5(C2)), m2 += " ", B2[A2] = true);
          (g2 = "longlat" === g2["+proj"]) ? (B2 = "degree", u2.GeogAngularUnitsGeoKey && (z2 = w2 = q2.GeogAngularUnitsGeoKey)) : (B2 = "metre", u2.ProjLinearUnitsGeoKey && ("number" === typeof q2.ProjLinearUnitsGeoKey ? z2 = q2.ProjLinearUnitsGeoKey : (z2 = q2.ProjLinearUnitsGeoKey.m, B2 = q2.ProjLinearUnitsGeoKey.t), w2 = z2));
          w2 = v5(w2);
          z2 = v5(z2);
          y2 = v5(y2);
          return { proj4: m2, coordinatesConversionParameters: { x: w2, y: z2, z: y2 }, shouldConvertCoordinates: 1 !== w2 || 1 !== z2 || 1 !== y2, coordinatesUnits: B2, isGCS: g2, errors: n2 };
        }, convertCoordinates: function(g2, m2, w2, z2) {
          return { x: g2 * z2.x, y: m2 * z2.y, z: w2 * z2.z };
        } };
      }, {
        "./EPSG/data/CRS.js": 1,
        "./EPSG/data/GeogEllipsoidGeoKey.js": 2,
        "./EPSG/data/GeogGeodeticDatumGeoKey.js": 3,
        "./EPSG/data/GeogPrimeMeridianGeoKey.js": 4,
        "./EPSG/data/Overrides.js": 5,
        "./EPSG/data/PCSKeys.js": 6,
        "./EPSG/data/ProjCoordTransGeoKey.js": 7,
        "./EPSG/data/ProjectionGeoKey.js": 8,
        "./EPSG/data/Units.js": 9,
        "core-js/stable/object/keys": 66,
        "core-js/stable/string/trim": 67
      }],
      11: [function(a2, b2, e3) {
        a2("../../modules/es.object.keys");
        a2 = a2("../../internals/path");
        b2.exports = a2.Object.keys;
      }, { "../../internals/path": 47, "../../modules/es.object.keys": 64 }],
      12: [function(a2, b2, e3) {
        a2("../../modules/es.string.trim");
        a2 = a2("../../internals/entry-unbind");
        b2.exports = a2("String", "trim");
      }, { "../../internals/entry-unbind": 22, "../../modules/es.string.trim": 65 }],
      13: [function(a2, b2, e3) {
        b2.exports = function(c2) {
          if ("function" != typeof c2)
            throw TypeError(String(c2) + " is not a function");
          return c2;
        };
      }, {}],
      14: [function(a2, b2, e3) {
        var c2 = a2("../internals/is-object");
        b2.exports = function(d2) {
          if (!c2(d2))
            throw TypeError(String(d2) + " is not an object");
          return d2;
        };
      }, { "../internals/is-object": 36 }],
      15: [function(a2, b2, e3) {
        var c2 = a2("../internals/to-indexed-object"), d2 = a2("../internals/to-length"), f2 = a2("../internals/to-absolute-index");
        a2 = function(h2) {
          return function(k2, p2, l2) {
            k2 = c2(k2);
            var r2 = d2(k2.length);
            l2 = f2(l2, r2);
            if (h2 && p2 != p2)
              for (; r2 > l2; ) {
                if (p2 = k2[l2++], p2 != p2)
                  return true;
              }
            else
              for (; r2 > l2; l2++)
                if ((h2 || l2 in k2) && k2[l2] === p2)
                  return h2 || l2 || 0;
            return !h2 && -1;
          };
        };
        b2.exports = { includes: a2(true), indexOf: a2(false) };
      }, { "../internals/to-absolute-index": 56, "../internals/to-indexed-object": 57, "../internals/to-length": 59 }],
      16: [function(a2, b2, e3) {
        var c2 = {}.toString;
        b2.exports = function(d2) {
          return c2.call(d2).slice(8, -1);
        };
      }, {}],
      17: [function(a2, b2, e3) {
        var c2 = a2("../internals/has"), d2 = a2("../internals/own-keys"), f2 = a2("../internals/object-get-own-property-descriptor"), h2 = a2("../internals/object-define-property");
        b2.exports = function(k2, p2) {
          for (var l2 = d2(p2), r2 = h2.f, v5 = f2.f, g2 = 0; g2 < l2.length; g2++) {
            var m2 = l2[g2];
            c2(k2, m2) || r2(k2, m2, v5(p2, m2));
          }
        };
      }, { "../internals/has": 29, "../internals/object-define-property": 39, "../internals/object-get-own-property-descriptor": 40, "../internals/own-keys": 46 }],
      18: [function(a2, b2, e3) {
        e3 = a2("../internals/descriptors");
        var c2 = a2("../internals/object-define-property"), d2 = a2("../internals/create-property-descriptor");
        b2.exports = e3 ? function(f2, h2, k2) {
          return c2.f(f2, h2, d2(1, k2));
        } : function(f2, h2, k2) {
          f2[h2] = k2;
          return f2;
        };
      }, { "../internals/create-property-descriptor": 19, "../internals/descriptors": 20, "../internals/object-define-property": 39 }],
      19: [function(a2, b2, e3) {
        b2.exports = function(c2, d2) {
          return { enumerable: !(c2 & 1), configurable: !(c2 & 2), writable: !(c2 & 4), value: d2 };
        };
      }, {}],
      20: [
        function(a2, b2, e3) {
          a2 = a2("../internals/fails");
          b2.exports = !a2(function() {
            return 7 != Object.defineProperty({}, 1, { get: function() {
              return 7;
            } })[1];
          });
        },
        { "../internals/fails": 25 }
      ],
      21: [function(a2, b2, e3) {
        e3 = a2("../internals/global");
        a2 = a2("../internals/is-object");
        var c2 = e3.document, d2 = a2(c2) && a2(c2.createElement);
        b2.exports = function(f2) {
          return d2 ? c2.createElement(f2) : {};
        };
      }, { "../internals/global": 28, "../internals/is-object": 36 }],
      22: [function(a2, b2, e3) {
        var c2 = a2("../internals/global"), d2 = a2("../internals/function-bind-context"), f2 = Function.call;
        b2.exports = function(h2, k2, p2) {
          return d2(f2, c2[h2].prototype[k2], p2);
        };
      }, { "../internals/function-bind-context": 26, "../internals/global": 28 }],
      23: [function(a2, b2, e3) {
        b2.exports = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
      }, {}],
      24: [function(a2, b2, e3) {
        var c2 = a2("../internals/global"), d2 = a2("../internals/object-get-own-property-descriptor").f, f2 = a2("../internals/create-non-enumerable-property"), h2 = a2("../internals/redefine"), k2 = a2("../internals/set-global"), p2 = a2("../internals/copy-constructor-properties"), l2 = a2("../internals/is-forced");
        b2.exports = function(r2, v5) {
          var g2 = r2.target, m2 = r2.global, w2 = r2.stat, z2, y2, n2;
          if (y2 = m2 ? c2 : w2 ? c2[g2] || k2(g2, {}) : (c2[g2] || {}).prototype)
            for (n2 in v5) {
              var q2 = v5[n2];
              var u2 = r2.noTargetGet ? (z2 = d2(y2, n2)) && z2.value : y2[n2];
              z2 = l2(m2 ? n2 : g2 + (w2 ? "." : "#") + n2, r2.forced);
              if (!z2 && void 0 !== u2) {
                if (typeof q2 === typeof u2)
                  continue;
                p2(q2, u2);
              }
              (r2.sham || u2 && u2.sham) && f2(q2, "sham", true);
              h2(y2, n2, q2, r2);
            }
        };
      }, { "../internals/copy-constructor-properties": 17, "../internals/create-non-enumerable-property": 18, "../internals/global": 28, "../internals/is-forced": 35, "../internals/object-get-own-property-descriptor": 40, "../internals/redefine": 48, "../internals/set-global": 50 }],
      25: [function(a2, b2, e3) {
        b2.exports = function(c2) {
          try {
            return !!c2();
          } catch (d2) {
            return true;
          }
        };
      }, {}],
      26: [function(a2, b2, e3) {
        var c2 = a2("../internals/a-function");
        b2.exports = function(d2, f2, h2) {
          c2(d2);
          if (void 0 === f2)
            return d2;
          switch (h2) {
            case 0:
              return function() {
                return d2.call(f2);
              };
            case 1:
              return function(k2) {
                return d2.call(f2, k2);
              };
            case 2:
              return function(k2, p2) {
                return d2.call(f2, k2, p2);
              };
            case 3:
              return function(k2, p2, l2) {
                return d2.call(f2, k2, p2, l2);
              };
          }
          return function() {
            return d2.apply(f2, arguments);
          };
        };
      }, { "../internals/a-function": 13 }],
      27: [function(a2, b2, e3) {
        var c2 = a2("../internals/path"), d2 = a2("../internals/global"), f2 = function(h2) {
          return "function" == typeof h2 ? h2 : void 0;
        };
        b2.exports = function(h2, k2) {
          return 2 > arguments.length ? f2(c2[h2]) || f2(d2[h2]) : c2[h2] && c2[h2][k2] || d2[h2] && d2[h2][k2];
        };
      }, { "../internals/global": 28, "../internals/path": 47 }],
      28: [function(a2, b2, e3) {
        (function(c2) {
          (function() {
            var d2 = function(f2) {
              return f2 && f2.Math == Math && f2;
            };
            b2.exports = d2("object" == typeof globalThis && globalThis) || d2("object" == typeof window && window) || d2("object" == typeof self && self) || d2("object" == typeof c2 && c2) || function() {
              return this;
            }() || Function("return this")();
          }).call(this);
        }).call(
          this,
          "undefined" !== typeof commonjsGlobal$1 ? commonjsGlobal$1 : "undefined" !== typeof self ? self : "undefined" !== typeof window ? window : {}
        );
      }, {}],
      29: [function(a2, b2, e3) {
        var c2 = a2("../internals/to-object"), d2 = {}.hasOwnProperty;
        b2.exports = Object.hasOwn || function(f2, h2) {
          return d2.call(c2(f2), h2);
        };
      }, { "../internals/to-object": 60 }],
      30: [function(a2, b2, e3) {
        b2.exports = {};
      }, {}],
      31: [function(a2, b2, e3) {
        e3 = a2("../internals/descriptors");
        var c2 = a2("../internals/fails"), d2 = a2("../internals/document-create-element");
        b2.exports = !e3 && !c2(function() {
          return 7 != Object.defineProperty(
            d2("div"),
            "a",
            { get: function() {
              return 7;
            } }
          ).a;
        });
      }, { "../internals/descriptors": 20, "../internals/document-create-element": 21, "../internals/fails": 25 }],
      32: [function(a2, b2, e3) {
        e3 = a2("../internals/fails");
        var c2 = a2("../internals/classof-raw"), d2 = "".split;
        b2.exports = e3(function() {
          return !Object("z").propertyIsEnumerable(0);
        }) ? function(f2) {
          return "String" == c2(f2) ? d2.call(f2, "") : Object(f2);
        } : Object;
      }, { "../internals/classof-raw": 16, "../internals/fails": 25 }],
      33: [function(a2, b2, e3) {
        a2 = a2("../internals/shared-store");
        var c2 = Function.toString;
        "function" != typeof a2.inspectSource && (a2.inspectSource = function(d2) {
          return c2.call(d2);
        });
        b2.exports = a2.inspectSource;
      }, { "../internals/shared-store": 52 }],
      34: [function(a2, b2, e3) {
        e3 = a2("../internals/native-weak-map");
        var c2 = a2("../internals/global"), d2 = a2("../internals/is-object"), f2 = a2("../internals/create-non-enumerable-property"), h2 = a2("../internals/has"), k2 = a2("../internals/shared-store"), p2 = a2("../internals/shared-key");
        a2 = a2("../internals/hidden-keys");
        c2 = c2.WeakMap;
        if (e3 || k2.state) {
          var l2 = k2.state || (k2.state = new c2()), r2 = l2.get, v5 = l2.has, g2 = l2.set;
          var m2 = function(n2, q2) {
            if (v5.call(l2, n2))
              throw new TypeError("Object already initialized");
            q2.facade = n2;
            g2.call(l2, n2, q2);
            return q2;
          };
          var w2 = function(n2) {
            return r2.call(l2, n2) || {};
          };
          var z2 = function(n2) {
            return v5.call(l2, n2);
          };
        } else {
          var y2 = p2("state");
          a2[y2] = true;
          m2 = function(n2, q2) {
            if (h2(n2, y2))
              throw new TypeError("Object already initialized");
            q2.facade = n2;
            f2(n2, y2, q2);
            return q2;
          };
          w2 = function(n2) {
            return h2(n2, y2) ? n2[y2] : {};
          };
          z2 = function(n2) {
            return h2(n2, y2);
          };
        }
        b2.exports = { set: m2, get: w2, has: z2, enforce: function(n2) {
          return z2(n2) ? w2(n2) : m2(n2, {});
        }, getterFor: function(n2) {
          return function(q2) {
            var u2;
            if (!d2(q2) || (u2 = w2(q2)).type !== n2)
              throw TypeError("Incompatible receiver, " + n2 + " required");
            return u2;
          };
        } };
      }, { "../internals/create-non-enumerable-property": 18, "../internals/global": 28, "../internals/has": 29, "../internals/hidden-keys": 30, "../internals/is-object": 36, "../internals/native-weak-map": 38, "../internals/shared-key": 51, "../internals/shared-store": 52 }],
      35: [function(a2, b2, e3) {
        var c2 = a2("../internals/fails"), d2 = /#|\.prototype\./;
        a2 = function(l2, r2) {
          var v5 = h2[f2(l2)];
          return v5 == p2 ? true : v5 == k2 ? false : "function" == typeof r2 ? c2(r2) : !!r2;
        };
        var f2 = a2.normalize = function(l2) {
          return String(l2).replace(d2, ".").toLowerCase();
        }, h2 = a2.data = {}, k2 = a2.NATIVE = "N", p2 = a2.POLYFILL = "P";
        b2.exports = a2;
      }, { "../internals/fails": 25 }],
      36: [function(a2, b2, e3) {
        b2.exports = function(c2) {
          return "object" === typeof c2 ? null !== c2 : "function" === typeof c2;
        };
      }, {}],
      37: [function(a2, b2, e3) {
        b2.exports = false;
      }, {}],
      38: [function(a2, b2, e3) {
        e3 = a2("../internals/global");
        a2 = a2("../internals/inspect-source");
        e3 = e3.WeakMap;
        b2.exports = "function" === typeof e3 && /native code/.test(a2(e3));
      }, { "../internals/global": 28, "../internals/inspect-source": 33 }],
      39: [function(a2, b2, e3) {
        b2 = a2("../internals/descriptors");
        var c2 = a2("../internals/ie8-dom-define"), d2 = a2("../internals/an-object"), f2 = a2("../internals/to-primitive"), h2 = Object.defineProperty;
        e3.f = b2 ? h2 : function(k2, p2, l2) {
          d2(k2);
          p2 = f2(p2, true);
          d2(l2);
          if (c2)
            try {
              return h2(k2, p2, l2);
            } catch (r2) {
            }
          if ("get" in l2 || "set" in l2)
            throw TypeError("Accessors not supported");
          "value" in l2 && (k2[p2] = l2.value);
          return k2;
        };
      }, { "../internals/an-object": 14, "../internals/descriptors": 20, "../internals/ie8-dom-define": 31, "../internals/to-primitive": 61 }],
      40: [function(a2, b2, e3) {
        b2 = a2("../internals/descriptors");
        var c2 = a2("../internals/object-property-is-enumerable"), d2 = a2("../internals/create-property-descriptor"), f2 = a2("../internals/to-indexed-object"), h2 = a2("../internals/to-primitive"), k2 = a2("../internals/has"), p2 = a2("../internals/ie8-dom-define"), l2 = Object.getOwnPropertyDescriptor;
        e3.f = b2 ? l2 : function(r2, v5) {
          r2 = f2(r2);
          v5 = h2(v5, true);
          if (p2)
            try {
              return l2(r2, v5);
            } catch (g2) {
            }
          if (k2(r2, v5))
            return d2(!c2.f.call(r2, v5), r2[v5]);
        };
      }, {
        "../internals/create-property-descriptor": 19,
        "../internals/descriptors": 20,
        "../internals/has": 29,
        "../internals/ie8-dom-define": 31,
        "../internals/object-property-is-enumerable": 45,
        "../internals/to-indexed-object": 57,
        "../internals/to-primitive": 61
      }],
      41: [function(a2, b2, e3) {
        var c2 = a2("../internals/object-keys-internal"), d2 = a2("../internals/enum-bug-keys").concat("length", "prototype");
        e3.f = Object.getOwnPropertyNames || function(f2) {
          return c2(f2, d2);
        };
      }, { "../internals/enum-bug-keys": 23, "../internals/object-keys-internal": 43 }],
      42: [function(a2, b2, e3) {
        e3.f = Object.getOwnPropertySymbols;
      }, {}],
      43: [function(a2, b2, e3) {
        var c2 = a2("../internals/has"), d2 = a2("../internals/to-indexed-object"), f2 = a2("../internals/array-includes").indexOf, h2 = a2("../internals/hidden-keys");
        b2.exports = function(k2, p2) {
          var l2 = d2(k2), r2 = 0, v5 = [], g2;
          for (g2 in l2)
            !c2(h2, g2) && c2(l2, g2) && v5.push(g2);
          for (; p2.length > r2; )
            c2(l2, g2 = p2[r2++]) && (~f2(v5, g2) || v5.push(g2));
          return v5;
        };
      }, { "../internals/array-includes": 15, "../internals/has": 29, "../internals/hidden-keys": 30, "../internals/to-indexed-object": 57 }],
      44: [function(a2, b2, e3) {
        var c2 = a2("../internals/object-keys-internal"), d2 = a2("../internals/enum-bug-keys");
        b2.exports = Object.keys || function(f2) {
          return c2(f2, d2);
        };
      }, { "../internals/enum-bug-keys": 23, "../internals/object-keys-internal": 43 }],
      45: [function(a2, b2, e3) {
        a2 = {}.propertyIsEnumerable;
        var c2 = Object.getOwnPropertyDescriptor;
        b2 = c2 && !a2.call({ 1: 2 }, 1);
        e3.f = b2 ? function(d2) {
          d2 = c2(this, d2);
          return !!d2 && d2.enumerable;
        } : a2;
      }, {}],
      46: [function(a2, b2, e3) {
        e3 = a2("../internals/get-built-in");
        var c2 = a2("../internals/object-get-own-property-names"), d2 = a2("../internals/object-get-own-property-symbols"), f2 = a2("../internals/an-object");
        b2.exports = e3("Reflect", "ownKeys") || function(h2) {
          var k2 = c2.f(f2(h2)), p2 = d2.f;
          return p2 ? k2.concat(p2(h2)) : k2;
        };
      }, { "../internals/an-object": 14, "../internals/get-built-in": 27, "../internals/object-get-own-property-names": 41, "../internals/object-get-own-property-symbols": 42 }],
      47: [function(a2, b2, e3) {
        a2 = a2("../internals/global");
        b2.exports = a2;
      }, { "../internals/global": 28 }],
      48: [function(a2, b2, e3) {
        var c2 = a2("../internals/global"), d2 = a2("../internals/create-non-enumerable-property"), f2 = a2("../internals/has"), h2 = a2("../internals/set-global"), k2 = a2("../internals/inspect-source");
        a2 = a2("../internals/internal-state");
        var p2 = a2.get, l2 = a2.enforce, r2 = String(String).split("String");
        (b2.exports = function(v5, g2, m2, w2) {
          var z2 = w2 ? !!w2.unsafe : false, y2 = w2 ? !!w2.enumerable : false;
          w2 = w2 ? !!w2.noTargetGet : false;
          if ("function" == typeof m2) {
            "string" != typeof g2 || f2(m2, "name") || d2(m2, "name", g2);
            var n2 = l2(m2);
            n2.source || (n2.source = r2.join("string" == typeof g2 ? g2 : ""));
          }
          v5 === c2 ? y2 ? v5[g2] = m2 : h2(g2, m2) : (z2 ? !w2 && v5[g2] && (y2 = true) : delete v5[g2], y2 ? v5[g2] = m2 : d2(v5, g2, m2));
        })(Function.prototype, "toString", function() {
          return "function" == typeof this && p2(this).source || k2(this);
        });
      }, {
        "../internals/create-non-enumerable-property": 18,
        "../internals/global": 28,
        "../internals/has": 29,
        "../internals/inspect-source": 33,
        "../internals/internal-state": 34,
        "../internals/set-global": 50
      }],
      49: [function(a2, b2, e3) {
        b2.exports = function(c2) {
          if (void 0 == c2)
            throw TypeError("Can't call method on " + c2);
          return c2;
        };
      }, {}],
      50: [function(a2, b2, e3) {
        var c2 = a2("../internals/global"), d2 = a2("../internals/create-non-enumerable-property");
        b2.exports = function(f2, h2) {
          try {
            d2(c2, f2, h2);
          } catch (k2) {
            c2[f2] = h2;
          }
          return h2;
        };
      }, { "../internals/create-non-enumerable-property": 18, "../internals/global": 28 }],
      51: [function(a2, b2, e3) {
        e3 = a2("../internals/shared");
        var c2 = a2("../internals/uid"), d2 = e3("keys");
        b2.exports = function(f2) {
          return d2[f2] || (d2[f2] = c2(f2));
        };
      }, { "../internals/shared": 53, "../internals/uid": 62 }],
      52: [function(a2, b2, e3) {
        e3 = a2("../internals/global");
        a2 = a2("../internals/set-global");
        a2 = e3["__core-js_shared__"] || a2("__core-js_shared__", {});
        b2.exports = a2;
      }, { "../internals/global": 28, "../internals/set-global": 50 }],
      53: [function(a2, b2, e3) {
        e3 = a2("../internals/is-pure");
        var c2 = a2("../internals/shared-store");
        (b2.exports = function(d2, f2) {
          return c2[d2] || (c2[d2] = void 0 !== f2 ? f2 : {});
        })("versions", []).push({ version: "3.15.2", mode: e3 ? "pure" : "global", copyright: "© 2021 Denis Pushkarev (zloirock.ru)" });
      }, { "../internals/is-pure": 37, "../internals/shared-store": 52 }],
      54: [function(a2, b2, e3) {
        var c2 = a2("../internals/fails"), d2 = a2("../internals/whitespaces");
        b2.exports = function(f2) {
          return c2(function() {
            return !!d2[f2]() || "​᠎" != "​᠎"[f2]() || d2[f2].name !== f2;
          });
        };
      }, { "../internals/fails": 25, "../internals/whitespaces": 63 }],
      55: [function(a2, b2, e3) {
        var c2 = a2("../internals/require-object-coercible");
        a2 = "[" + a2("../internals/whitespaces") + "]";
        var d2 = RegExp("^" + a2 + a2 + "*"), f2 = RegExp(a2 + a2 + "*$");
        a2 = function(h2) {
          return function(k2) {
            k2 = String(c2(k2));
            h2 & 1 && (k2 = k2.replace(d2, ""));
            h2 & 2 && (k2 = k2.replace(f2, ""));
            return k2;
          };
        };
        b2.exports = { start: a2(1), end: a2(2), trim: a2(3) };
      }, { "../internals/require-object-coercible": 49, "../internals/whitespaces": 63 }],
      56: [function(a2, b2, e3) {
        var c2 = a2("../internals/to-integer"), d2 = Math.max, f2 = Math.min;
        b2.exports = function(h2, k2) {
          var p2 = c2(h2);
          return 0 > p2 ? d2(p2 + k2, 0) : f2(p2, k2);
        };
      }, { "../internals/to-integer": 58 }],
      57: [function(a2, b2, e3) {
        var c2 = a2("../internals/indexed-object"), d2 = a2("../internals/require-object-coercible");
        b2.exports = function(f2) {
          return c2(d2(f2));
        };
      }, { "../internals/indexed-object": 32, "../internals/require-object-coercible": 49 }],
      58: [function(a2, b2, e3) {
        var c2 = Math.ceil, d2 = Math.floor;
        b2.exports = function(f2) {
          return isNaN(f2 = +f2) ? 0 : (0 < f2 ? d2 : c2)(f2);
        };
      }, {}],
      59: [function(a2, b2, e3) {
        var c2 = a2("../internals/to-integer"), d2 = Math.min;
        b2.exports = function(f2) {
          return 0 < f2 ? d2(c2(f2), 9007199254740991) : 0;
        };
      }, { "../internals/to-integer": 58 }],
      60: [function(a2, b2, e3) {
        var c2 = a2("../internals/require-object-coercible");
        b2.exports = function(d2) {
          return Object(c2(d2));
        };
      }, { "../internals/require-object-coercible": 49 }],
      61: [function(a2, b2, e3) {
        var c2 = a2("../internals/is-object");
        b2.exports = function(d2, f2) {
          if (!c2(d2))
            return d2;
          var h2, k2;
          if (f2 && "function" == typeof (h2 = d2.toString) && !c2(k2 = h2.call(d2)) || "function" == typeof (h2 = d2.valueOf) && !c2(k2 = h2.call(d2)) || !f2 && "function" == typeof (h2 = d2.toString) && !c2(k2 = h2.call(d2)))
            return k2;
          throw TypeError("Can't convert object to primitive value");
        };
      }, { "../internals/is-object": 36 }],
      62: [function(a2, b2, e3) {
        var c2 = 0, d2 = Math.random();
        b2.exports = function(f2) {
          return "Symbol(" + String(void 0 === f2 ? "" : f2) + ")_" + (++c2 + d2).toString(36);
        };
      }, {}],
      63: [function(a2, b2, e3) {
        b2.exports = "	\n\v\f\r                　\u2028\u2029\uFEFF";
      }, {}],
      64: [
        function(a2, b2, e3) {
          b2 = a2("../internals/export");
          var c2 = a2("../internals/to-object"), d2 = a2("../internals/object-keys");
          a2 = a2("../internals/fails")(function() {
            d2(1);
          });
          b2({ target: "Object", stat: true, forced: a2 }, { keys: function(f2) {
            return d2(c2(f2));
          } });
        },
        { "../internals/export": 24, "../internals/fails": 25, "../internals/object-keys": 44, "../internals/to-object": 60 }
      ],
      65: [function(a2, b2, e3) {
        b2 = a2("../internals/export");
        var c2 = a2("../internals/string-trim").trim;
        a2 = a2("../internals/string-trim-forced");
        b2({ target: "String", proto: true, forced: a2("trim") }, { trim: function() {
          return c2(this);
        } });
      }, { "../internals/export": 24, "../internals/string-trim": 55, "../internals/string-trim-forced": 54 }],
      66: [function(a2, b2, e3) {
        a2 = a2("../../es/object/keys");
        b2.exports = a2;
      }, { "../../es/object/keys": 11 }],
      67: [function(a2, b2, e3) {
        a2 = a2("../../es/string/trim");
        b2.exports = a2;
      }, { "../../es/string/trim": 12 }]
    }, {}, [10])(10);
  });
})(mainDist);
class GeoTiffUtil {
  static async extractImageAndBox(buffer3) {
    const tiff = await fromArrayBuffer(buffer3);
    const imageCount = await tiff.getImageCount();
    const result = [];
    for (let i2 = 0; i2 < imageCount; i2 += 1) {
      const image = await tiff.getImage(i2);
      const geoKeys = image.getGeoKeys();
      const width = image.getWidth();
      const height = image.getHeight();
      const rgbData = await image.readRGB();
      const canvas2 = document.createElement("canvas");
      canvas2.width = width;
      canvas2.height = height;
      const context2 = canvas2.getContext("2d", {
        alpha: true
      });
      const imageData = context2.createImageData(width, height);
      for (let i3 = 0; i3 < rgbData.length; i3 += 3) {
        const r2 = parseInt(rgbData[i3] * 255, 10);
        const g2 = parseInt(rgbData[i3 + 1] * 255, 10);
        const b2 = parseInt(rgbData[i3 + 2] * 255, 10);
        const dataIndex = i3 * 4 / 3;
        imageData.data[dataIndex] = r2;
        imageData.data[dataIndex + 1] = g2;
        imageData.data[dataIndex + 2] = b2;
        imageData.data[dataIndex + 3] = 255;
      }
      context2.putImageData(imageData, 0, 0);
      const dataUrl = canvas2.toDataURL("image/png");
      let box = null;
      if (geoKeys) {
        const projObj = mainDistExports.toProj4(geoKeys);
        const minMax = image.getBoundingBox();
        const minProjection = proj4(projObj.proj4, "WGS84", [minMax[0], minMax[1]]);
        const maxProjection = proj4(projObj.proj4, "WGS84", [minMax[2], minMax[3]]);
        const coordinates2 = [
          [minProjection[0], maxProjection[1]],
          // [west, north] , [minLon, maxLat]
          [maxProjection[0], maxProjection[1]],
          // [east, north] , [maxLon, maxLat]
          [maxProjection[0], minProjection[1]],
          // [east, south] , [maxLon, minLat]
          [minProjection[0], minProjection[1]]
          // [west, south] , [minLon, minLat]
        ];
        box = coordinates2;
      }
      if (dataUrl)
        result.push({
          dataUrl,
          box,
          extension: "png"
        });
    }
    return result;
  }
}
var browser$1 = function(t2) {
  var e3 = {};
  function r2(n2) {
    if (e3[n2])
      return e3[n2].exports;
    var i2 = e3[n2] = { i: n2, l: false, exports: {} };
    return t2[n2].call(i2.exports, i2, i2.exports, r2), i2.l = true, i2.exports;
  }
  return r2.m = t2, r2.c = e3, r2.d = function(t3, e4, n2) {
    r2.o(t3, e4) || Object.defineProperty(t3, e4, { enumerable: true, get: n2 });
  }, r2.r = function(t3) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t3, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t3, "__esModule", { value: true });
  }, r2.t = function(t3, e4) {
    if (1 & e4 && (t3 = r2(t3)), 8 & e4)
      return t3;
    if (4 & e4 && "object" == typeof t3 && t3 && t3.__esModule)
      return t3;
    var n2 = /* @__PURE__ */ Object.create(null);
    if (r2.r(n2), Object.defineProperty(n2, "default", { enumerable: true, value: t3 }), 2 & e4 && "string" != typeof t3)
      for (var i2 in t3)
        r2.d(n2, i2, function(e5) {
          return t3[e5];
        }.bind(null, i2));
    return n2;
  }, r2.n = function(t3) {
    var e4 = t3 && t3.__esModule ? function() {
      return t3.default;
    } : function() {
      return t3;
    };
    return r2.d(e4, "a", e4), e4;
  }, r2.o = function(t3, e4) {
    return Object.prototype.hasOwnProperty.call(t3, e4);
  }, r2.p = "", r2(r2.s = 32);
}([function(t2, e3) {
  var r2;
  r2 = function() {
    return this;
  }();
  try {
    r2 = r2 || Function("return this")() || (0, eval)("this");
  } catch (t3) {
    "object" == typeof window && (r2 = window);
  }
  t2.exports = r2;
}, function(t2, e3, r2) {
  var n2 = r2(6), i2 = Object.keys || function(t3) {
    var e4 = [];
    for (var r3 in t3)
      e4.push(r3);
    return e4;
  };
  t2.exports = f2;
  var o2 = r2(5);
  o2.inherits = r2(2);
  var s2 = r2(23), a2 = r2(14);
  o2.inherits(f2, s2);
  for (var u2 = i2(a2.prototype), c2 = 0; c2 < u2.length; c2++) {
    var l2 = u2[c2];
    f2.prototype[l2] || (f2.prototype[l2] = a2.prototype[l2]);
  }
  function f2(t3) {
    if (!(this instanceof f2))
      return new f2(t3);
    s2.call(this, t3), a2.call(this, t3), t3 && false === t3.readable && (this.readable = false), t3 && false === t3.writable && (this.writable = false), this.allowHalfOpen = true, t3 && false === t3.allowHalfOpen && (this.allowHalfOpen = false), this.once("end", h2);
  }
  function h2() {
    this.allowHalfOpen || this._writableState.ended || n2.nextTick(p2, this);
  }
  function p2(t3) {
    t3.end();
  }
  Object.defineProperty(f2.prototype, "writableHighWaterMark", { enumerable: false, get: function() {
    return this._writableState.highWaterMark;
  } }), Object.defineProperty(f2.prototype, "destroyed", { get: function() {
    return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
  }, set: function(t3) {
    void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t3, this._writableState.destroyed = t3);
  } }), f2.prototype._destroy = function(t3, e4) {
    this.push(null), this.end(), n2.nextTick(e4, t3);
  };
}, function(t2, e3) {
  "function" == typeof Object.create ? t2.exports = function(t3, e4) {
    t3.super_ = e4, t3.prototype = Object.create(e4.prototype, { constructor: { value: t3, enumerable: false, writable: true, configurable: true } });
  } : t2.exports = function(t3, e4) {
    t3.super_ = e4;
    var r2 = function() {
    };
    r2.prototype = e4.prototype, t3.prototype = new r2(), t3.prototype.constructor = t3;
  };
}, function(t2, e3, r2) {
  (function(t3) {
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */
    var n2 = r2(38), i2 = r2(39), o2 = r2(40);
    function s2() {
      return u2.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }
    function a2(t4, e4) {
      if (s2() < e4)
        throw new RangeError("Invalid typed array length");
      return u2.TYPED_ARRAY_SUPPORT ? (t4 = new Uint8Array(e4)).__proto__ = u2.prototype : (null === t4 && (t4 = new u2(e4)), t4.length = e4), t4;
    }
    function u2(t4, e4, r3) {
      if (!(u2.TYPED_ARRAY_SUPPORT || this instanceof u2))
        return new u2(t4, e4, r3);
      if ("number" == typeof t4) {
        if ("string" == typeof e4)
          throw new Error("If encoding is specified then the first argument must be a string");
        return f2(this, t4);
      }
      return c2(this, t4, e4, r3);
    }
    function c2(t4, e4, r3, n3) {
      if ("number" == typeof e4)
        throw new TypeError('"value" argument must not be a number');
      return "undefined" != typeof ArrayBuffer && e4 instanceof ArrayBuffer ? function(t5, e5, r4, n4) {
        if (e5.byteLength, r4 < 0 || e5.byteLength < r4)
          throw new RangeError("'offset' is out of bounds");
        if (e5.byteLength < r4 + (n4 || 0))
          throw new RangeError("'length' is out of bounds");
        return e5 = void 0 === r4 && void 0 === n4 ? new Uint8Array(e5) : void 0 === n4 ? new Uint8Array(e5, r4) : new Uint8Array(e5, r4, n4), u2.TYPED_ARRAY_SUPPORT ? (t5 = e5).__proto__ = u2.prototype : t5 = h2(t5, e5), t5;
      }(t4, e4, r3, n3) : "string" == typeof e4 ? function(t5, e5, r4) {
        if ("string" == typeof r4 && "" !== r4 || (r4 = "utf8"), !u2.isEncoding(r4))
          throw new TypeError('"encoding" must be a valid string encoding');
        var n4 = 0 | d2(e5, r4), i3 = (t5 = a2(t5, n4)).write(e5, r4);
        return i3 !== n4 && (t5 = t5.slice(0, i3)), t5;
      }(t4, e4, r3) : function(t5, e5) {
        if (u2.isBuffer(e5)) {
          var r4 = 0 | p2(e5.length);
          return 0 === (t5 = a2(t5, r4)).length ? t5 : (e5.copy(t5, 0, 0, r4), t5);
        }
        if (e5) {
          if ("undefined" != typeof ArrayBuffer && e5.buffer instanceof ArrayBuffer || "length" in e5)
            return "number" != typeof e5.length || function(t6) {
              return t6 != t6;
            }(e5.length) ? a2(t5, 0) : h2(t5, e5);
          if ("Buffer" === e5.type && o2(e5.data))
            return h2(t5, e5.data);
        }
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(t4, e4);
    }
    function l2(t4) {
      if ("number" != typeof t4)
        throw new TypeError('"size" argument must be a number');
      if (t4 < 0)
        throw new RangeError('"size" argument must not be negative');
    }
    function f2(t4, e4) {
      if (l2(e4), t4 = a2(t4, e4 < 0 ? 0 : 0 | p2(e4)), !u2.TYPED_ARRAY_SUPPORT)
        for (var r3 = 0; r3 < e4; ++r3)
          t4[r3] = 0;
      return t4;
    }
    function h2(t4, e4) {
      var r3 = e4.length < 0 ? 0 : 0 | p2(e4.length);
      t4 = a2(t4, r3);
      for (var n3 = 0; n3 < r3; n3 += 1)
        t4[n3] = 255 & e4[n3];
      return t4;
    }
    function p2(t4) {
      if (t4 >= s2())
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s2().toString(16) + " bytes");
      return 0 | t4;
    }
    function d2(t4, e4) {
      if (u2.isBuffer(t4))
        return t4.length;
      if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t4) || t4 instanceof ArrayBuffer))
        return t4.byteLength;
      "string" != typeof t4 && (t4 = "" + t4);
      var r3 = t4.length;
      if (0 === r3)
        return 0;
      for (var n3 = false; ; )
        switch (e4) {
          case "ascii":
          case "latin1":
          case "binary":
            return r3;
          case "utf8":
          case "utf-8":
          case void 0:
            return N2(t4).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * r3;
          case "hex":
            return r3 >>> 1;
          case "base64":
            return H2(t4).length;
          default:
            if (n3)
              return N2(t4).length;
            e4 = ("" + e4).toLowerCase(), n3 = true;
        }
    }
    function _2(t4, e4, r3) {
      var n3 = t4[e4];
      t4[e4] = t4[r3], t4[r3] = n3;
    }
    function v5(t4, e4, r3, n3, i3) {
      if (0 === t4.length)
        return -1;
      if ("string" == typeof r3 ? (n3 = r3, r3 = 0) : r3 > 2147483647 ? r3 = 2147483647 : r3 < -2147483648 && (r3 = -2147483648), r3 = +r3, isNaN(r3) && (r3 = i3 ? 0 : t4.length - 1), r3 < 0 && (r3 = t4.length + r3), r3 >= t4.length) {
        if (i3)
          return -1;
        r3 = t4.length - 1;
      } else if (r3 < 0) {
        if (!i3)
          return -1;
        r3 = 0;
      }
      if ("string" == typeof e4 && (e4 = u2.from(e4, n3)), u2.isBuffer(e4))
        return 0 === e4.length ? -1 : y2(t4, e4, r3, n3, i3);
      if ("number" == typeof e4)
        return e4 &= 255, u2.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i3 ? Uint8Array.prototype.indexOf.call(t4, e4, r3) : Uint8Array.prototype.lastIndexOf.call(t4, e4, r3) : y2(t4, [e4], r3, n3, i3);
      throw new TypeError("val must be string, number or Buffer");
    }
    function y2(t4, e4, r3, n3, i3) {
      var o3, s3 = 1, a3 = t4.length, u3 = e4.length;
      if (void 0 !== n3 && ("ucs2" === (n3 = String(n3).toLowerCase()) || "ucs-2" === n3 || "utf16le" === n3 || "utf-16le" === n3)) {
        if (t4.length < 2 || e4.length < 2)
          return -1;
        s3 = 2, a3 /= 2, u3 /= 2, r3 /= 2;
      }
      function c3(t5, e5) {
        return 1 === s3 ? t5[e5] : t5.readUInt16BE(e5 * s3);
      }
      if (i3) {
        var l3 = -1;
        for (o3 = r3; o3 < a3; o3++)
          if (c3(t4, o3) === c3(e4, -1 === l3 ? 0 : o3 - l3)) {
            if (-1 === l3 && (l3 = o3), o3 - l3 + 1 === u3)
              return l3 * s3;
          } else
            -1 !== l3 && (o3 -= o3 - l3), l3 = -1;
      } else
        for (r3 + u3 > a3 && (r3 = a3 - u3), o3 = r3; o3 >= 0; o3--) {
          for (var f3 = true, h3 = 0; h3 < u3; h3++)
            if (c3(t4, o3 + h3) !== c3(e4, h3)) {
              f3 = false;
              break;
            }
          if (f3)
            return o3;
        }
      return -1;
    }
    function m2(t4, e4, r3, n3) {
      r3 = Number(r3) || 0;
      var i3 = t4.length - r3;
      n3 ? (n3 = Number(n3)) > i3 && (n3 = i3) : n3 = i3;
      var o3 = e4.length;
      if (o3 % 2 != 0)
        throw new TypeError("Invalid hex string");
      n3 > o3 / 2 && (n3 = o3 / 2);
      for (var s3 = 0; s3 < n3; ++s3) {
        var a3 = parseInt(e4.substr(2 * s3, 2), 16);
        if (isNaN(a3))
          return s3;
        t4[r3 + s3] = a3;
      }
      return s3;
    }
    function g2(t4, e4, r3, n3) {
      return V2(N2(e4, t4.length - r3), t4, r3, n3);
    }
    function b2(t4, e4, r3, n3) {
      return V2(function(t5) {
        for (var e5 = [], r4 = 0; r4 < t5.length; ++r4)
          e5.push(255 & t5.charCodeAt(r4));
        return e5;
      }(e4), t4, r3, n3);
    }
    function w2(t4, e4, r3, n3) {
      return b2(t4, e4, r3, n3);
    }
    function E3(t4, e4, r3, n3) {
      return V2(H2(e4), t4, r3, n3);
    }
    function C2(t4, e4, r3, n3) {
      return V2(function(t5, e5) {
        for (var r4, n4, i3, o3 = [], s3 = 0; s3 < t5.length && !((e5 -= 2) < 0); ++s3)
          n4 = (r4 = t5.charCodeAt(s3)) >> 8, i3 = r4 % 256, o3.push(i3), o3.push(n4);
        return o3;
      }(e4, t4.length - r3), t4, r3, n3);
    }
    function x2(t4, e4, r3) {
      return 0 === e4 && r3 === t4.length ? n2.fromByteArray(t4) : n2.fromByteArray(t4.slice(e4, r3));
    }
    function j2(t4, e4, r3) {
      r3 = Math.min(t4.length, r3);
      for (var n3 = [], i3 = e4; i3 < r3; ) {
        var o3, s3, a3, u3, c3 = t4[i3], l3 = null, f3 = c3 > 239 ? 4 : c3 > 223 ? 3 : c3 > 191 ? 2 : 1;
        if (i3 + f3 <= r3)
          switch (f3) {
            case 1:
              c3 < 128 && (l3 = c3);
              break;
            case 2:
              128 == (192 & (o3 = t4[i3 + 1])) && (u3 = (31 & c3) << 6 | 63 & o3) > 127 && (l3 = u3);
              break;
            case 3:
              o3 = t4[i3 + 1], s3 = t4[i3 + 2], 128 == (192 & o3) && 128 == (192 & s3) && (u3 = (15 & c3) << 12 | (63 & o3) << 6 | 63 & s3) > 2047 && (u3 < 55296 || u3 > 57343) && (l3 = u3);
              break;
            case 4:
              o3 = t4[i3 + 1], s3 = t4[i3 + 2], a3 = t4[i3 + 3], 128 == (192 & o3) && 128 == (192 & s3) && 128 == (192 & a3) && (u3 = (15 & c3) << 18 | (63 & o3) << 12 | (63 & s3) << 6 | 63 & a3) > 65535 && u3 < 1114112 && (l3 = u3);
          }
        null === l3 ? (l3 = 65533, f3 = 1) : l3 > 65535 && (l3 -= 65536, n3.push(l3 >>> 10 & 1023 | 55296), l3 = 56320 | 1023 & l3), n3.push(l3), i3 += f3;
      }
      return function(t5) {
        var e5 = t5.length;
        if (e5 <= S2)
          return String.fromCharCode.apply(String, t5);
        for (var r4 = "", n4 = 0; n4 < e5; )
          r4 += String.fromCharCode.apply(String, t5.slice(n4, n4 += S2));
        return r4;
      }(n3);
    }
    e3.Buffer = u2, e3.SlowBuffer = function(t4) {
      return +t4 != t4 && (t4 = 0), u2.alloc(+t4);
    }, e3.INSPECT_MAX_BYTES = 50, u2.TYPED_ARRAY_SUPPORT = void 0 !== t3.TYPED_ARRAY_SUPPORT ? t3.TYPED_ARRAY_SUPPORT : function() {
      try {
        var t4 = new Uint8Array(1);
        return t4.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
          return 42;
        } }, 42 === t4.foo() && "function" == typeof t4.subarray && 0 === t4.subarray(1, 1).byteLength;
      } catch (t5) {
        return false;
      }
    }(), e3.kMaxLength = s2(), u2.poolSize = 8192, u2._augment = function(t4) {
      return t4.__proto__ = u2.prototype, t4;
    }, u2.from = function(t4, e4, r3) {
      return c2(null, t4, e4, r3);
    }, u2.TYPED_ARRAY_SUPPORT && (u2.prototype.__proto__ = Uint8Array.prototype, u2.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u2[Symbol.species] === u2 && Object.defineProperty(u2, Symbol.species, { value: null, configurable: true })), u2.alloc = function(t4, e4, r3) {
      return function(t5, e5, r4, n3) {
        return l2(e5), e5 <= 0 ? a2(t5, e5) : void 0 !== r4 ? "string" == typeof n3 ? a2(t5, e5).fill(r4, n3) : a2(t5, e5).fill(r4) : a2(t5, e5);
      }(null, t4, e4, r3);
    }, u2.allocUnsafe = function(t4) {
      return f2(null, t4);
    }, u2.allocUnsafeSlow = function(t4) {
      return f2(null, t4);
    }, u2.isBuffer = function(t4) {
      return !(null == t4 || !t4._isBuffer);
    }, u2.compare = function(t4, e4) {
      if (!u2.isBuffer(t4) || !u2.isBuffer(e4))
        throw new TypeError("Arguments must be Buffers");
      if (t4 === e4)
        return 0;
      for (var r3 = t4.length, n3 = e4.length, i3 = 0, o3 = Math.min(r3, n3); i3 < o3; ++i3)
        if (t4[i3] !== e4[i3]) {
          r3 = t4[i3], n3 = e4[i3];
          break;
        }
      return r3 < n3 ? -1 : n3 < r3 ? 1 : 0;
    }, u2.isEncoding = function(t4) {
      switch (String(t4).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    }, u2.concat = function(t4, e4) {
      if (!o2(t4))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (0 === t4.length)
        return u2.alloc(0);
      var r3;
      if (void 0 === e4)
        for (e4 = 0, r3 = 0; r3 < t4.length; ++r3)
          e4 += t4[r3].length;
      var n3 = u2.allocUnsafe(e4), i3 = 0;
      for (r3 = 0; r3 < t4.length; ++r3) {
        var s3 = t4[r3];
        if (!u2.isBuffer(s3))
          throw new TypeError('"list" argument must be an Array of Buffers');
        s3.copy(n3, i3), i3 += s3.length;
      }
      return n3;
    }, u2.byteLength = d2, u2.prototype._isBuffer = true, u2.prototype.swap16 = function() {
      var t4 = this.length;
      if (t4 % 2 != 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (var e4 = 0; e4 < t4; e4 += 2)
        _2(this, e4, e4 + 1);
      return this;
    }, u2.prototype.swap32 = function() {
      var t4 = this.length;
      if (t4 % 4 != 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (var e4 = 0; e4 < t4; e4 += 4)
        _2(this, e4, e4 + 3), _2(this, e4 + 1, e4 + 2);
      return this;
    }, u2.prototype.swap64 = function() {
      var t4 = this.length;
      if (t4 % 8 != 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (var e4 = 0; e4 < t4; e4 += 8)
        _2(this, e4, e4 + 7), _2(this, e4 + 1, e4 + 6), _2(this, e4 + 2, e4 + 5), _2(this, e4 + 3, e4 + 4);
      return this;
    }, u2.prototype.toString = function() {
      var t4 = 0 | this.length;
      return 0 === t4 ? "" : 0 === arguments.length ? j2(this, 0, t4) : function(t5, e4, r3) {
        var n3 = false;
        if ((void 0 === e4 || e4 < 0) && (e4 = 0), e4 > this.length)
          return "";
        if ((void 0 === r3 || r3 > this.length) && (r3 = this.length), r3 <= 0)
          return "";
        if ((r3 >>>= 0) <= (e4 >>>= 0))
          return "";
        for (t5 || (t5 = "utf8"); ; )
          switch (t5) {
            case "hex":
              return T2(this, e4, r3);
            case "utf8":
            case "utf-8":
              return j2(this, e4, r3);
            case "ascii":
              return R2(this, e4, r3);
            case "latin1":
            case "binary":
              return k2(this, e4, r3);
            case "base64":
              return x2(this, e4, r3);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return P2(this, e4, r3);
            default:
              if (n3)
                throw new TypeError("Unknown encoding: " + t5);
              t5 = (t5 + "").toLowerCase(), n3 = true;
          }
      }.apply(this, arguments);
    }, u2.prototype.equals = function(t4) {
      if (!u2.isBuffer(t4))
        throw new TypeError("Argument must be a Buffer");
      return this === t4 || 0 === u2.compare(this, t4);
    }, u2.prototype.inspect = function() {
      var t4 = "", r3 = e3.INSPECT_MAX_BYTES;
      return this.length > 0 && (t4 = this.toString("hex", 0, r3).match(/.{2}/g).join(" "), this.length > r3 && (t4 += " ... ")), "<Buffer " + t4 + ">";
    }, u2.prototype.compare = function(t4, e4, r3, n3, i3) {
      if (!u2.isBuffer(t4))
        throw new TypeError("Argument must be a Buffer");
      if (void 0 === e4 && (e4 = 0), void 0 === r3 && (r3 = t4 ? t4.length : 0), void 0 === n3 && (n3 = 0), void 0 === i3 && (i3 = this.length), e4 < 0 || r3 > t4.length || n3 < 0 || i3 > this.length)
        throw new RangeError("out of range index");
      if (n3 >= i3 && e4 >= r3)
        return 0;
      if (n3 >= i3)
        return -1;
      if (e4 >= r3)
        return 1;
      if (e4 >>>= 0, r3 >>>= 0, n3 >>>= 0, i3 >>>= 0, this === t4)
        return 0;
      for (var o3 = i3 - n3, s3 = r3 - e4, a3 = Math.min(o3, s3), c3 = this.slice(n3, i3), l3 = t4.slice(e4, r3), f3 = 0; f3 < a3; ++f3)
        if (c3[f3] !== l3[f3]) {
          o3 = c3[f3], s3 = l3[f3];
          break;
        }
      return o3 < s3 ? -1 : s3 < o3 ? 1 : 0;
    }, u2.prototype.includes = function(t4, e4, r3) {
      return -1 !== this.indexOf(t4, e4, r3);
    }, u2.prototype.indexOf = function(t4, e4, r3) {
      return v5(this, t4, e4, r3, true);
    }, u2.prototype.lastIndexOf = function(t4, e4, r3) {
      return v5(this, t4, e4, r3, false);
    }, u2.prototype.write = function(t4, e4, r3, n3) {
      if (void 0 === e4)
        n3 = "utf8", r3 = this.length, e4 = 0;
      else if (void 0 === r3 && "string" == typeof e4)
        n3 = e4, r3 = this.length, e4 = 0;
      else {
        if (!isFinite(e4))
          throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        e4 |= 0, isFinite(r3) ? (r3 |= 0, void 0 === n3 && (n3 = "utf8")) : (n3 = r3, r3 = void 0);
      }
      var i3 = this.length - e4;
      if ((void 0 === r3 || r3 > i3) && (r3 = i3), t4.length > 0 && (r3 < 0 || e4 < 0) || e4 > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      n3 || (n3 = "utf8");
      for (var o3 = false; ; )
        switch (n3) {
          case "hex":
            return m2(this, t4, e4, r3);
          case "utf8":
          case "utf-8":
            return g2(this, t4, e4, r3);
          case "ascii":
            return b2(this, t4, e4, r3);
          case "latin1":
          case "binary":
            return w2(this, t4, e4, r3);
          case "base64":
            return E3(this, t4, e4, r3);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return C2(this, t4, e4, r3);
          default:
            if (o3)
              throw new TypeError("Unknown encoding: " + n3);
            n3 = ("" + n3).toLowerCase(), o3 = true;
        }
    }, u2.prototype.toJSON = function() {
      return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
    };
    var S2 = 4096;
    function R2(t4, e4, r3) {
      var n3 = "";
      r3 = Math.min(t4.length, r3);
      for (var i3 = e4; i3 < r3; ++i3)
        n3 += String.fromCharCode(127 & t4[i3]);
      return n3;
    }
    function k2(t4, e4, r3) {
      var n3 = "";
      r3 = Math.min(t4.length, r3);
      for (var i3 = e4; i3 < r3; ++i3)
        n3 += String.fromCharCode(t4[i3]);
      return n3;
    }
    function T2(t4, e4, r3) {
      var n3 = t4.length;
      (!e4 || e4 < 0) && (e4 = 0), (!r3 || r3 < 0 || r3 > n3) && (r3 = n3);
      for (var i3 = "", o3 = e4; o3 < r3; ++o3)
        i3 += U2(t4[o3]);
      return i3;
    }
    function P2(t4, e4, r3) {
      for (var n3 = t4.slice(e4, r3), i3 = "", o3 = 0; o3 < n3.length; o3 += 2)
        i3 += String.fromCharCode(n3[o3] + 256 * n3[o3 + 1]);
      return i3;
    }
    function O2(t4, e4, r3) {
      if (t4 % 1 != 0 || t4 < 0)
        throw new RangeError("offset is not uint");
      if (t4 + e4 > r3)
        throw new RangeError("Trying to access beyond buffer length");
    }
    function A2(t4, e4, r3, n3, i3, o3) {
      if (!u2.isBuffer(t4))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (e4 > i3 || e4 < o3)
        throw new RangeError('"value" argument is out of bounds');
      if (r3 + n3 > t4.length)
        throw new RangeError("Index out of range");
    }
    function F2(t4, e4, r3, n3) {
      e4 < 0 && (e4 = 65535 + e4 + 1);
      for (var i3 = 0, o3 = Math.min(t4.length - r3, 2); i3 < o3; ++i3)
        t4[r3 + i3] = (e4 & 255 << 8 * (n3 ? i3 : 1 - i3)) >>> 8 * (n3 ? i3 : 1 - i3);
    }
    function L2(t4, e4, r3, n3) {
      e4 < 0 && (e4 = 4294967295 + e4 + 1);
      for (var i3 = 0, o3 = Math.min(t4.length - r3, 4); i3 < o3; ++i3)
        t4[r3 + i3] = e4 >>> 8 * (n3 ? i3 : 3 - i3) & 255;
    }
    function M2(t4, e4, r3, n3, i3, o3) {
      if (r3 + n3 > t4.length)
        throw new RangeError("Index out of range");
      if (r3 < 0)
        throw new RangeError("Index out of range");
    }
    function B2(t4, e4, r3, n3, o3) {
      return o3 || M2(t4, 0, r3, 4), i2.write(t4, e4, r3, n3, 23, 4), r3 + 4;
    }
    function D2(t4, e4, r3, n3, o3) {
      return o3 || M2(t4, 0, r3, 8), i2.write(t4, e4, r3, n3, 52, 8), r3 + 8;
    }
    u2.prototype.slice = function(t4, e4) {
      var r3, n3 = this.length;
      if (t4 = ~~t4, e4 = void 0 === e4 ? n3 : ~~e4, t4 < 0 ? (t4 += n3) < 0 && (t4 = 0) : t4 > n3 && (t4 = n3), e4 < 0 ? (e4 += n3) < 0 && (e4 = 0) : e4 > n3 && (e4 = n3), e4 < t4 && (e4 = t4), u2.TYPED_ARRAY_SUPPORT)
        (r3 = this.subarray(t4, e4)).__proto__ = u2.prototype;
      else {
        var i3 = e4 - t4;
        r3 = new u2(i3, void 0);
        for (var o3 = 0; o3 < i3; ++o3)
          r3[o3] = this[o3 + t4];
      }
      return r3;
    }, u2.prototype.readUIntLE = function(t4, e4, r3) {
      t4 |= 0, e4 |= 0, r3 || O2(t4, e4, this.length);
      for (var n3 = this[t4], i3 = 1, o3 = 0; ++o3 < e4 && (i3 *= 256); )
        n3 += this[t4 + o3] * i3;
      return n3;
    }, u2.prototype.readUIntBE = function(t4, e4, r3) {
      t4 |= 0, e4 |= 0, r3 || O2(t4, e4, this.length);
      for (var n3 = this[t4 + --e4], i3 = 1; e4 > 0 && (i3 *= 256); )
        n3 += this[t4 + --e4] * i3;
      return n3;
    }, u2.prototype.readUInt8 = function(t4, e4) {
      return e4 || O2(t4, 1, this.length), this[t4];
    }, u2.prototype.readUInt16LE = function(t4, e4) {
      return e4 || O2(t4, 2, this.length), this[t4] | this[t4 + 1] << 8;
    }, u2.prototype.readUInt16BE = function(t4, e4) {
      return e4 || O2(t4, 2, this.length), this[t4] << 8 | this[t4 + 1];
    }, u2.prototype.readUInt32LE = function(t4, e4) {
      return e4 || O2(t4, 4, this.length), (this[t4] | this[t4 + 1] << 8 | this[t4 + 2] << 16) + 16777216 * this[t4 + 3];
    }, u2.prototype.readUInt32BE = function(t4, e4) {
      return e4 || O2(t4, 4, this.length), 16777216 * this[t4] + (this[t4 + 1] << 16 | this[t4 + 2] << 8 | this[t4 + 3]);
    }, u2.prototype.readIntLE = function(t4, e4, r3) {
      t4 |= 0, e4 |= 0, r3 || O2(t4, e4, this.length);
      for (var n3 = this[t4], i3 = 1, o3 = 0; ++o3 < e4 && (i3 *= 256); )
        n3 += this[t4 + o3] * i3;
      return n3 >= (i3 *= 128) && (n3 -= Math.pow(2, 8 * e4)), n3;
    }, u2.prototype.readIntBE = function(t4, e4, r3) {
      t4 |= 0, e4 |= 0, r3 || O2(t4, e4, this.length);
      for (var n3 = e4, i3 = 1, o3 = this[t4 + --n3]; n3 > 0 && (i3 *= 256); )
        o3 += this[t4 + --n3] * i3;
      return o3 >= (i3 *= 128) && (o3 -= Math.pow(2, 8 * e4)), o3;
    }, u2.prototype.readInt8 = function(t4, e4) {
      return e4 || O2(t4, 1, this.length), 128 & this[t4] ? -1 * (255 - this[t4] + 1) : this[t4];
    }, u2.prototype.readInt16LE = function(t4, e4) {
      e4 || O2(t4, 2, this.length);
      var r3 = this[t4] | this[t4 + 1] << 8;
      return 32768 & r3 ? 4294901760 | r3 : r3;
    }, u2.prototype.readInt16BE = function(t4, e4) {
      e4 || O2(t4, 2, this.length);
      var r3 = this[t4 + 1] | this[t4] << 8;
      return 32768 & r3 ? 4294901760 | r3 : r3;
    }, u2.prototype.readInt32LE = function(t4, e4) {
      return e4 || O2(t4, 4, this.length), this[t4] | this[t4 + 1] << 8 | this[t4 + 2] << 16 | this[t4 + 3] << 24;
    }, u2.prototype.readInt32BE = function(t4, e4) {
      return e4 || O2(t4, 4, this.length), this[t4] << 24 | this[t4 + 1] << 16 | this[t4 + 2] << 8 | this[t4 + 3];
    }, u2.prototype.readFloatLE = function(t4, e4) {
      return e4 || O2(t4, 4, this.length), i2.read(this, t4, true, 23, 4);
    }, u2.prototype.readFloatBE = function(t4, e4) {
      return e4 || O2(t4, 4, this.length), i2.read(this, t4, false, 23, 4);
    }, u2.prototype.readDoubleLE = function(t4, e4) {
      return e4 || O2(t4, 8, this.length), i2.read(this, t4, true, 52, 8);
    }, u2.prototype.readDoubleBE = function(t4, e4) {
      return e4 || O2(t4, 8, this.length), i2.read(this, t4, false, 52, 8);
    }, u2.prototype.writeUIntLE = function(t4, e4, r3, n3) {
      t4 = +t4, e4 |= 0, r3 |= 0, n3 || A2(this, t4, e4, r3, Math.pow(2, 8 * r3) - 1, 0);
      var i3 = 1, o3 = 0;
      for (this[e4] = 255 & t4; ++o3 < r3 && (i3 *= 256); )
        this[e4 + o3] = t4 / i3 & 255;
      return e4 + r3;
    }, u2.prototype.writeUIntBE = function(t4, e4, r3, n3) {
      t4 = +t4, e4 |= 0, r3 |= 0, n3 || A2(this, t4, e4, r3, Math.pow(2, 8 * r3) - 1, 0);
      var i3 = r3 - 1, o3 = 1;
      for (this[e4 + i3] = 255 & t4; --i3 >= 0 && (o3 *= 256); )
        this[e4 + i3] = t4 / o3 & 255;
      return e4 + r3;
    }, u2.prototype.writeUInt8 = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 1, 255, 0), u2.TYPED_ARRAY_SUPPORT || (t4 = Math.floor(t4)), this[e4] = 255 & t4, e4 + 1;
    }, u2.prototype.writeUInt16LE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 2, 65535, 0), u2.TYPED_ARRAY_SUPPORT ? (this[e4] = 255 & t4, this[e4 + 1] = t4 >>> 8) : F2(this, t4, e4, true), e4 + 2;
    }, u2.prototype.writeUInt16BE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 2, 65535, 0), u2.TYPED_ARRAY_SUPPORT ? (this[e4] = t4 >>> 8, this[e4 + 1] = 255 & t4) : F2(this, t4, e4, false), e4 + 2;
    }, u2.prototype.writeUInt32LE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 4, 4294967295, 0), u2.TYPED_ARRAY_SUPPORT ? (this[e4 + 3] = t4 >>> 24, this[e4 + 2] = t4 >>> 16, this[e4 + 1] = t4 >>> 8, this[e4] = 255 & t4) : L2(this, t4, e4, true), e4 + 4;
    }, u2.prototype.writeUInt32BE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 4, 4294967295, 0), u2.TYPED_ARRAY_SUPPORT ? (this[e4] = t4 >>> 24, this[e4 + 1] = t4 >>> 16, this[e4 + 2] = t4 >>> 8, this[e4 + 3] = 255 & t4) : L2(this, t4, e4, false), e4 + 4;
    }, u2.prototype.writeIntLE = function(t4, e4, r3, n3) {
      if (t4 = +t4, e4 |= 0, !n3) {
        var i3 = Math.pow(2, 8 * r3 - 1);
        A2(this, t4, e4, r3, i3 - 1, -i3);
      }
      var o3 = 0, s3 = 1, a3 = 0;
      for (this[e4] = 255 & t4; ++o3 < r3 && (s3 *= 256); )
        t4 < 0 && 0 === a3 && 0 !== this[e4 + o3 - 1] && (a3 = 1), this[e4 + o3] = (t4 / s3 >> 0) - a3 & 255;
      return e4 + r3;
    }, u2.prototype.writeIntBE = function(t4, e4, r3, n3) {
      if (t4 = +t4, e4 |= 0, !n3) {
        var i3 = Math.pow(2, 8 * r3 - 1);
        A2(this, t4, e4, r3, i3 - 1, -i3);
      }
      var o3 = r3 - 1, s3 = 1, a3 = 0;
      for (this[e4 + o3] = 255 & t4; --o3 >= 0 && (s3 *= 256); )
        t4 < 0 && 0 === a3 && 0 !== this[e4 + o3 + 1] && (a3 = 1), this[e4 + o3] = (t4 / s3 >> 0) - a3 & 255;
      return e4 + r3;
    }, u2.prototype.writeInt8 = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 1, 127, -128), u2.TYPED_ARRAY_SUPPORT || (t4 = Math.floor(t4)), t4 < 0 && (t4 = 255 + t4 + 1), this[e4] = 255 & t4, e4 + 1;
    }, u2.prototype.writeInt16LE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 2, 32767, -32768), u2.TYPED_ARRAY_SUPPORT ? (this[e4] = 255 & t4, this[e4 + 1] = t4 >>> 8) : F2(this, t4, e4, true), e4 + 2;
    }, u2.prototype.writeInt16BE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 2, 32767, -32768), u2.TYPED_ARRAY_SUPPORT ? (this[e4] = t4 >>> 8, this[e4 + 1] = 255 & t4) : F2(this, t4, e4, false), e4 + 2;
    }, u2.prototype.writeInt32LE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 4, 2147483647, -2147483648), u2.TYPED_ARRAY_SUPPORT ? (this[e4] = 255 & t4, this[e4 + 1] = t4 >>> 8, this[e4 + 2] = t4 >>> 16, this[e4 + 3] = t4 >>> 24) : L2(this, t4, e4, true), e4 + 4;
    }, u2.prototype.writeInt32BE = function(t4, e4, r3) {
      return t4 = +t4, e4 |= 0, r3 || A2(this, t4, e4, 4, 2147483647, -2147483648), t4 < 0 && (t4 = 4294967295 + t4 + 1), u2.TYPED_ARRAY_SUPPORT ? (this[e4] = t4 >>> 24, this[e4 + 1] = t4 >>> 16, this[e4 + 2] = t4 >>> 8, this[e4 + 3] = 255 & t4) : L2(this, t4, e4, false), e4 + 4;
    }, u2.prototype.writeFloatLE = function(t4, e4, r3) {
      return B2(this, t4, e4, true, r3);
    }, u2.prototype.writeFloatBE = function(t4, e4, r3) {
      return B2(this, t4, e4, false, r3);
    }, u2.prototype.writeDoubleLE = function(t4, e4, r3) {
      return D2(this, t4, e4, true, r3);
    }, u2.prototype.writeDoubleBE = function(t4, e4, r3) {
      return D2(this, t4, e4, false, r3);
    }, u2.prototype.copy = function(t4, e4, r3, n3) {
      if (r3 || (r3 = 0), n3 || 0 === n3 || (n3 = this.length), e4 >= t4.length && (e4 = t4.length), e4 || (e4 = 0), n3 > 0 && n3 < r3 && (n3 = r3), n3 === r3)
        return 0;
      if (0 === t4.length || 0 === this.length)
        return 0;
      if (e4 < 0)
        throw new RangeError("targetStart out of bounds");
      if (r3 < 0 || r3 >= this.length)
        throw new RangeError("sourceStart out of bounds");
      if (n3 < 0)
        throw new RangeError("sourceEnd out of bounds");
      n3 > this.length && (n3 = this.length), t4.length - e4 < n3 - r3 && (n3 = t4.length - e4 + r3);
      var i3, o3 = n3 - r3;
      if (this === t4 && r3 < e4 && e4 < n3)
        for (i3 = o3 - 1; i3 >= 0; --i3)
          t4[i3 + e4] = this[i3 + r3];
      else if (o3 < 1e3 || !u2.TYPED_ARRAY_SUPPORT)
        for (i3 = 0; i3 < o3; ++i3)
          t4[i3 + e4] = this[i3 + r3];
      else
        Uint8Array.prototype.set.call(t4, this.subarray(r3, r3 + o3), e4);
      return o3;
    }, u2.prototype.fill = function(t4, e4, r3, n3) {
      if ("string" == typeof t4) {
        if ("string" == typeof e4 ? (n3 = e4, e4 = 0, r3 = this.length) : "string" == typeof r3 && (n3 = r3, r3 = this.length), 1 === t4.length) {
          var i3 = t4.charCodeAt(0);
          i3 < 256 && (t4 = i3);
        }
        if (void 0 !== n3 && "string" != typeof n3)
          throw new TypeError("encoding must be a string");
        if ("string" == typeof n3 && !u2.isEncoding(n3))
          throw new TypeError("Unknown encoding: " + n3);
      } else
        "number" == typeof t4 && (t4 &= 255);
      if (e4 < 0 || this.length < e4 || this.length < r3)
        throw new RangeError("Out of range index");
      if (r3 <= e4)
        return this;
      var o3;
      if (e4 >>>= 0, r3 = void 0 === r3 ? this.length : r3 >>> 0, t4 || (t4 = 0), "number" == typeof t4)
        for (o3 = e4; o3 < r3; ++o3)
          this[o3] = t4;
      else {
        var s3 = u2.isBuffer(t4) ? t4 : N2(new u2(t4, n3).toString()), a3 = s3.length;
        for (o3 = 0; o3 < r3 - e4; ++o3)
          this[o3 + e4] = s3[o3 % a3];
      }
      return this;
    };
    var I2 = /[^+\/0-9A-Za-z-_]/g;
    function U2(t4) {
      return t4 < 16 ? "0" + t4.toString(16) : t4.toString(16);
    }
    function N2(t4, e4) {
      var r3;
      e4 = e4 || 1 / 0;
      for (var n3 = t4.length, i3 = null, o3 = [], s3 = 0; s3 < n3; ++s3) {
        if ((r3 = t4.charCodeAt(s3)) > 55295 && r3 < 57344) {
          if (!i3) {
            if (r3 > 56319) {
              (e4 -= 3) > -1 && o3.push(239, 191, 189);
              continue;
            }
            if (s3 + 1 === n3) {
              (e4 -= 3) > -1 && o3.push(239, 191, 189);
              continue;
            }
            i3 = r3;
            continue;
          }
          if (r3 < 56320) {
            (e4 -= 3) > -1 && o3.push(239, 191, 189), i3 = r3;
            continue;
          }
          r3 = 65536 + (i3 - 55296 << 10 | r3 - 56320);
        } else
          i3 && (e4 -= 3) > -1 && o3.push(239, 191, 189);
        if (i3 = null, r3 < 128) {
          if ((e4 -= 1) < 0)
            break;
          o3.push(r3);
        } else if (r3 < 2048) {
          if ((e4 -= 2) < 0)
            break;
          o3.push(r3 >> 6 | 192, 63 & r3 | 128);
        } else if (r3 < 65536) {
          if ((e4 -= 3) < 0)
            break;
          o3.push(r3 >> 12 | 224, r3 >> 6 & 63 | 128, 63 & r3 | 128);
        } else {
          if (!(r3 < 1114112))
            throw new Error("Invalid code point");
          if ((e4 -= 4) < 0)
            break;
          o3.push(r3 >> 18 | 240, r3 >> 12 & 63 | 128, r3 >> 6 & 63 | 128, 63 & r3 | 128);
        }
      }
      return o3;
    }
    function H2(t4) {
      return n2.toByteArray(function(t5) {
        if ((t5 = function(t6) {
          return t6.trim ? t6.trim() : t6.replace(/^\s+|\s+$/g, "");
        }(t5).replace(I2, "")).length < 2)
          return "";
        for (; t5.length % 4 != 0; )
          t5 += "=";
        return t5;
      }(t4));
    }
    function V2(t4, e4, r3, n3) {
      for (var i3 = 0; i3 < n3 && !(i3 + r3 >= e4.length || i3 >= t4.length); ++i3)
        e4[i3 + r3] = t4[i3];
      return i3;
    }
  }).call(this, r2(0));
}, function(t2, e3) {
  var r2, n2, i2 = t2.exports = {};
  function o2() {
    throw new Error("setTimeout has not been defined");
  }
  function s2() {
    throw new Error("clearTimeout has not been defined");
  }
  function a2(t3) {
    if (r2 === setTimeout)
      return setTimeout(t3, 0);
    if ((r2 === o2 || !r2) && setTimeout)
      return r2 = setTimeout, setTimeout(t3, 0);
    try {
      return r2(t3, 0);
    } catch (e4) {
      try {
        return r2.call(null, t3, 0);
      } catch (e5) {
        return r2.call(this, t3, 0);
      }
    }
  }
  !function() {
    try {
      r2 = "function" == typeof setTimeout ? setTimeout : o2;
    } catch (t3) {
      r2 = o2;
    }
    try {
      n2 = "function" == typeof clearTimeout ? clearTimeout : s2;
    } catch (t3) {
      n2 = s2;
    }
  }();
  var u2, c2 = [], l2 = false, f2 = -1;
  function h2() {
    l2 && u2 && (l2 = false, u2.length ? c2 = u2.concat(c2) : f2 = -1, c2.length && p2());
  }
  function p2() {
    if (!l2) {
      var t3 = a2(h2);
      l2 = true;
      for (var e4 = c2.length; e4; ) {
        for (u2 = c2, c2 = []; ++f2 < e4; )
          u2 && u2[f2].run();
        f2 = -1, e4 = c2.length;
      }
      u2 = null, l2 = false, function(t4) {
        if (n2 === clearTimeout)
          return clearTimeout(t4);
        if ((n2 === s2 || !n2) && clearTimeout)
          return n2 = clearTimeout, clearTimeout(t4);
        try {
          n2(t4);
        } catch (e5) {
          try {
            return n2.call(null, t4);
          } catch (e6) {
            return n2.call(this, t4);
          }
        }
      }(t3);
    }
  }
  function d2(t3, e4) {
    this.fun = t3, this.array = e4;
  }
  function _2() {
  }
  i2.nextTick = function(t3) {
    var e4 = new Array(arguments.length - 1);
    if (arguments.length > 1)
      for (var r3 = 1; r3 < arguments.length; r3++)
        e4[r3 - 1] = arguments[r3];
    c2.push(new d2(t3, e4)), 1 !== c2.length || l2 || a2(p2);
  }, d2.prototype.run = function() {
    this.fun.apply(null, this.array);
  }, i2.title = "browser", i2.browser = true, i2.env = {}, i2.argv = [], i2.version = "", i2.versions = {}, i2.on = _2, i2.addListener = _2, i2.once = _2, i2.off = _2, i2.removeListener = _2, i2.removeAllListeners = _2, i2.emit = _2, i2.prependListener = _2, i2.prependOnceListener = _2, i2.listeners = function(t3) {
    return [];
  }, i2.binding = function(t3) {
    throw new Error("process.binding is not supported");
  }, i2.cwd = function() {
    return "/";
  }, i2.chdir = function(t3) {
    throw new Error("process.chdir is not supported");
  }, i2.umask = function() {
    return 0;
  };
}, function(t2, e3, r2) {
  (function(t3) {
    function r3(t4) {
      return Object.prototype.toString.call(t4);
    }
    e3.isArray = function(t4) {
      return Array.isArray ? Array.isArray(t4) : "[object Array]" === r3(t4);
    }, e3.isBoolean = function(t4) {
      return "boolean" == typeof t4;
    }, e3.isNull = function(t4) {
      return null === t4;
    }, e3.isNullOrUndefined = function(t4) {
      return null == t4;
    }, e3.isNumber = function(t4) {
      return "number" == typeof t4;
    }, e3.isString = function(t4) {
      return "string" == typeof t4;
    }, e3.isSymbol = function(t4) {
      return "symbol" == typeof t4;
    }, e3.isUndefined = function(t4) {
      return void 0 === t4;
    }, e3.isRegExp = function(t4) {
      return "[object RegExp]" === r3(t4);
    }, e3.isObject = function(t4) {
      return "object" == typeof t4 && null !== t4;
    }, e3.isDate = function(t4) {
      return "[object Date]" === r3(t4);
    }, e3.isError = function(t4) {
      return "[object Error]" === r3(t4) || t4 instanceof Error;
    }, e3.isFunction = function(t4) {
      return "function" == typeof t4;
    }, e3.isPrimitive = function(t4) {
      return null === t4 || "boolean" == typeof t4 || "number" == typeof t4 || "string" == typeof t4 || "symbol" == typeof t4 || void 0 === t4;
    }, e3.isBuffer = t3.isBuffer;
  }).call(this, r2(3).Buffer);
}, function(t2, e3, r2) {
  (function(e4) {
    !e4.version || 0 === e4.version.indexOf("v0.") || 0 === e4.version.indexOf("v1.") && 0 !== e4.version.indexOf("v1.8.") ? t2.exports = { nextTick: function(t3, r3, n2, i2) {
      if ("function" != typeof t3)
        throw new TypeError('"callback" argument must be a function');
      var o2, s2, a2 = arguments.length;
      switch (a2) {
        case 0:
        case 1:
          return e4.nextTick(t3);
        case 2:
          return e4.nextTick(function() {
            t3.call(null, r3);
          });
        case 3:
          return e4.nextTick(function() {
            t3.call(null, r3, n2);
          });
        case 4:
          return e4.nextTick(function() {
            t3.call(null, r3, n2, i2);
          });
        default:
          for (o2 = new Array(a2 - 1), s2 = 0; s2 < o2.length; )
            o2[s2++] = arguments[s2];
          return e4.nextTick(function() {
            t3.apply(null, o2);
          });
      }
    } } : t2.exports = e4;
  }).call(this, r2(4));
}, function(t2, e3, r2) {
  var n2 = r2(3), i2 = n2.Buffer;
  function o2(t3, e4) {
    for (var r3 in t3)
      e4[r3] = t3[r3];
  }
  function s2(t3, e4, r3) {
    return i2(t3, e4, r3);
  }
  i2.from && i2.alloc && i2.allocUnsafe && i2.allocUnsafeSlow ? t2.exports = n2 : (o2(n2, e3), e3.Buffer = s2), o2(i2, s2), s2.from = function(t3, e4, r3) {
    if ("number" == typeof t3)
      throw new TypeError("Argument must not be a number");
    return i2(t3, e4, r3);
  }, s2.alloc = function(t3, e4, r3) {
    if ("number" != typeof t3)
      throw new TypeError("Argument must be a number");
    var n3 = i2(t3);
    return void 0 !== e4 ? "string" == typeof r3 ? n3.fill(e4, r3) : n3.fill(e4) : n3.fill(0), n3;
  }, s2.allocUnsafe = function(t3) {
    if ("number" != typeof t3)
      throw new TypeError("Argument must be a number");
    return i2(t3);
  }, s2.allocUnsafeSlow = function(t3) {
    if ("number" != typeof t3)
      throw new TypeError("Argument must be a number");
    return n2.SlowBuffer(t3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(17)(Object, "create");
  t2.exports = n2;
}, function(t2, e3, r2) {
  var n2 = r2(31);
  t2.exports = function(t3, e4) {
    for (var r3 = t3.length; r3--; )
      if (n2(t3[r3][0], e4))
        return r3;
    return -1;
  };
}, function(t2, e3, r2) {
  var n2 = r2(96);
  t2.exports = function(t3, e4) {
    var r3 = t3.__data__;
    return n2(e4) ? r3["string" == typeof e4 ? "string" : "hash"] : r3.map;
  };
}, function(t2, e3, r2) {
  (function(t3) {
    var n2 = void 0 !== t3 && t3 || "undefined" != typeof self && self || window, i2 = Function.prototype.apply;
    function o2(t4, e4) {
      this._id = t4, this._clearFn = e4;
    }
    e3.setTimeout = function() {
      return new o2(i2.call(setTimeout, n2, arguments), clearTimeout);
    }, e3.setInterval = function() {
      return new o2(i2.call(setInterval, n2, arguments), clearInterval);
    }, e3.clearTimeout = e3.clearInterval = function(t4) {
      t4 && t4.close();
    }, o2.prototype.unref = o2.prototype.ref = function() {
    }, o2.prototype.close = function() {
      this._clearFn.call(n2, this._id);
    }, e3.enroll = function(t4, e4) {
      clearTimeout(t4._idleTimeoutId), t4._idleTimeout = e4;
    }, e3.unenroll = function(t4) {
      clearTimeout(t4._idleTimeoutId), t4._idleTimeout = -1;
    }, e3._unrefActive = e3.active = function(t4) {
      clearTimeout(t4._idleTimeoutId);
      var e4 = t4._idleTimeout;
      e4 >= 0 && (t4._idleTimeoutId = setTimeout(function() {
        t4._onTimeout && t4._onTimeout();
      }, e4));
    }, r2(35), e3.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t3 && t3.setImmediate || this && this.setImmediate, e3.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t3 && t3.clearImmediate || this && this.clearImmediate;
  }).call(this, r2(0));
}, function(t2, e3) {
  function r2() {
    this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
  }
  function n2(t3) {
    return "function" == typeof t3;
  }
  function i2(t3) {
    return "object" == typeof t3 && null !== t3;
  }
  function o2(t3) {
    return void 0 === t3;
  }
  t2.exports = r2, r2.EventEmitter = r2, r2.prototype._events = void 0, r2.prototype._maxListeners = void 0, r2.defaultMaxListeners = 10, r2.prototype.setMaxListeners = function(t3) {
    if (!function(t4) {
      return "number" == typeof t4;
    }(t3) || t3 < 0 || isNaN(t3))
      throw TypeError("n must be a positive number");
    return this._maxListeners = t3, this;
  }, r2.prototype.emit = function(t3) {
    var e4, r3, s2, a2, u2, c2;
    if (this._events || (this._events = {}), "error" === t3 && (!this._events.error || i2(this._events.error) && !this._events.error.length)) {
      if ((e4 = arguments[1]) instanceof Error)
        throw e4;
      var l2 = new Error('Uncaught, unspecified "error" event. (' + e4 + ")");
      throw l2.context = e4, l2;
    }
    if (o2(r3 = this._events[t3]))
      return false;
    if (n2(r3))
      switch (arguments.length) {
        case 1:
          r3.call(this);
          break;
        case 2:
          r3.call(this, arguments[1]);
          break;
        case 3:
          r3.call(this, arguments[1], arguments[2]);
          break;
        default:
          a2 = Array.prototype.slice.call(arguments, 1), r3.apply(this, a2);
      }
    else if (i2(r3))
      for (a2 = Array.prototype.slice.call(arguments, 1), s2 = (c2 = r3.slice()).length, u2 = 0; u2 < s2; u2++)
        c2[u2].apply(this, a2);
    return true;
  }, r2.prototype.addListener = function(t3, e4) {
    var s2;
    if (!n2(e4))
      throw TypeError("listener must be a function");
    return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", t3, n2(e4.listener) ? e4.listener : e4), this._events[t3] ? i2(this._events[t3]) ? this._events[t3].push(e4) : this._events[t3] = [this._events[t3], e4] : this._events[t3] = e4, i2(this._events[t3]) && !this._events[t3].warned && (s2 = o2(this._maxListeners) ? r2.defaultMaxListeners : this._maxListeners) && s2 > 0 && this._events[t3].length > s2 && (this._events[t3].warned = true, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[t3].length), "function" == typeof console.trace && console.trace()), this;
  }, r2.prototype.on = r2.prototype.addListener, r2.prototype.once = function(t3, e4) {
    if (!n2(e4))
      throw TypeError("listener must be a function");
    var r3 = false;
    function i3() {
      this.removeListener(t3, i3), r3 || (r3 = true, e4.apply(this, arguments));
    }
    return i3.listener = e4, this.on(t3, i3), this;
  }, r2.prototype.removeListener = function(t3, e4) {
    var r3, o3, s2, a2;
    if (!n2(e4))
      throw TypeError("listener must be a function");
    if (!this._events || !this._events[t3])
      return this;
    if (s2 = (r3 = this._events[t3]).length, o3 = -1, r3 === e4 || n2(r3.listener) && r3.listener === e4)
      delete this._events[t3], this._events.removeListener && this.emit("removeListener", t3, e4);
    else if (i2(r3)) {
      for (a2 = s2; a2-- > 0; )
        if (r3[a2] === e4 || r3[a2].listener && r3[a2].listener === e4) {
          o3 = a2;
          break;
        }
      if (o3 < 0)
        return this;
      1 === r3.length ? (r3.length = 0, delete this._events[t3]) : r3.splice(o3, 1), this._events.removeListener && this.emit("removeListener", t3, e4);
    }
    return this;
  }, r2.prototype.removeAllListeners = function(t3) {
    var e4, r3;
    if (!this._events)
      return this;
    if (!this._events.removeListener)
      return 0 === arguments.length ? this._events = {} : this._events[t3] && delete this._events[t3], this;
    if (0 === arguments.length) {
      for (e4 in this._events)
        "removeListener" !== e4 && this.removeAllListeners(e4);
      return this.removeAllListeners("removeListener"), this._events = {}, this;
    }
    if (n2(r3 = this._events[t3]))
      this.removeListener(t3, r3);
    else if (r3)
      for (; r3.length; )
        this.removeListener(t3, r3[r3.length - 1]);
    return delete this._events[t3], this;
  }, r2.prototype.listeners = function(t3) {
    return this._events && this._events[t3] ? n2(this._events[t3]) ? [this._events[t3]] : this._events[t3].slice() : [];
  }, r2.prototype.listenerCount = function(t3) {
    if (this._events) {
      var e4 = this._events[t3];
      if (n2(e4))
        return 1;
      if (e4)
        return e4.length;
    }
    return 0;
  }, r2.listenerCount = function(t3, e4) {
    return t3.listenerCount(e4);
  };
}, function(t2, e3, r2) {
  (e3 = t2.exports = r2(23)).Stream = e3, e3.Readable = e3, e3.Writable = r2(14), e3.Duplex = r2(1), e3.Transform = r2(27), e3.PassThrough = r2(45);
}, function(t2, e3, r2) {
  (function(e4, n2, i2) {
    var o2 = r2(6);
    function s2(t3) {
      var e5 = this;
      this.next = null, this.entry = null, this.finish = function() {
        !function(t4, e6, r3) {
          var n3 = t4.entry;
          for (t4.entry = null; n3; ) {
            var i3 = n3.callback;
            e6.pendingcb--, i3(void 0), n3 = n3.next;
          }
          e6.corkedRequestsFree ? e6.corkedRequestsFree.next = t4 : e6.corkedRequestsFree = t4;
        }(e5, t3);
      };
    }
    t2.exports = m2;
    var a2, u2 = !e4.browser && ["v0.10", "v0.9."].indexOf(e4.version.slice(0, 5)) > -1 ? n2 : o2.nextTick;
    m2.WritableState = y2;
    var c2 = r2(5);
    c2.inherits = r2(2);
    var l2, f2 = { deprecate: r2(44) }, h2 = r2(24), p2 = r2(7).Buffer, d2 = i2.Uint8Array || function() {
    }, _2 = r2(25);
    function v5() {
    }
    function y2(t3, e5) {
      a2 = a2 || r2(1), t3 = t3 || {};
      var n3 = e5 instanceof a2;
      this.objectMode = !!t3.objectMode, n3 && (this.objectMode = this.objectMode || !!t3.writableObjectMode);
      var i3 = t3.highWaterMark, c3 = t3.writableHighWaterMark, l3 = this.objectMode ? 16 : 16384;
      this.highWaterMark = i3 || 0 === i3 ? i3 : n3 && (c3 || 0 === c3) ? c3 : l3, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = false, this.needDrain = false, this.ending = false, this.ended = false, this.finished = false, this.destroyed = false;
      var f3 = false === t3.decodeStrings;
      this.decodeStrings = !f3, this.defaultEncoding = t3.defaultEncoding || "utf8", this.length = 0, this.writing = false, this.corked = 0, this.sync = true, this.bufferProcessing = false, this.onwrite = function(t4) {
        !function(t5, e6) {
          var r3 = t5._writableState, n4 = r3.sync, i4 = r3.writecb;
          if (function(t6) {
            t6.writing = false, t6.writecb = null, t6.length -= t6.writelen, t6.writelen = 0;
          }(r3), e6)
            !function(t6, e7, r4, n5, i5) {
              --e7.pendingcb, r4 ? (o2.nextTick(i5, n5), o2.nextTick(x2, t6, e7), t6._writableState.errorEmitted = true, t6.emit("error", n5)) : (i5(n5), t6._writableState.errorEmitted = true, t6.emit("error", n5), x2(t6, e7));
            }(t5, r3, n4, e6, i4);
          else {
            var s3 = E3(r3);
            s3 || r3.corked || r3.bufferProcessing || !r3.bufferedRequest || w2(t5, r3), n4 ? u2(b2, t5, r3, s3, i4) : b2(t5, r3, s3, i4);
          }
        }(e5, t4);
      }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = false, this.errorEmitted = false, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s2(this);
    }
    function m2(t3) {
      if (a2 = a2 || r2(1), !(l2.call(m2, this) || this instanceof a2))
        return new m2(t3);
      this._writableState = new y2(t3, this), this.writable = true, t3 && ("function" == typeof t3.write && (this._write = t3.write), "function" == typeof t3.writev && (this._writev = t3.writev), "function" == typeof t3.destroy && (this._destroy = t3.destroy), "function" == typeof t3.final && (this._final = t3.final)), h2.call(this);
    }
    function g2(t3, e5, r3, n3, i3, o3, s3) {
      e5.writelen = n3, e5.writecb = s3, e5.writing = true, e5.sync = true, r3 ? t3._writev(i3, e5.onwrite) : t3._write(i3, o3, e5.onwrite), e5.sync = false;
    }
    function b2(t3, e5, r3, n3) {
      r3 || function(t4, e6) {
        0 === e6.length && e6.needDrain && (e6.needDrain = false, t4.emit("drain"));
      }(t3, e5), e5.pendingcb--, n3(), x2(t3, e5);
    }
    function w2(t3, e5) {
      e5.bufferProcessing = true;
      var r3 = e5.bufferedRequest;
      if (t3._writev && r3 && r3.next) {
        var n3 = e5.bufferedRequestCount, i3 = new Array(n3), o3 = e5.corkedRequestsFree;
        o3.entry = r3;
        for (var a3 = 0, u3 = true; r3; )
          i3[a3] = r3, r3.isBuf || (u3 = false), r3 = r3.next, a3 += 1;
        i3.allBuffers = u3, g2(t3, e5, true, e5.length, i3, "", o3.finish), e5.pendingcb++, e5.lastBufferedRequest = null, o3.next ? (e5.corkedRequestsFree = o3.next, o3.next = null) : e5.corkedRequestsFree = new s2(e5), e5.bufferedRequestCount = 0;
      } else {
        for (; r3; ) {
          var c3 = r3.chunk, l3 = r3.encoding, f3 = r3.callback;
          if (g2(t3, e5, false, e5.objectMode ? 1 : c3.length, c3, l3, f3), r3 = r3.next, e5.bufferedRequestCount--, e5.writing)
            break;
        }
        null === r3 && (e5.lastBufferedRequest = null);
      }
      e5.bufferedRequest = r3, e5.bufferProcessing = false;
    }
    function E3(t3) {
      return t3.ending && 0 === t3.length && null === t3.bufferedRequest && !t3.finished && !t3.writing;
    }
    function C2(t3, e5) {
      t3._final(function(r3) {
        e5.pendingcb--, r3 && t3.emit("error", r3), e5.prefinished = true, t3.emit("prefinish"), x2(t3, e5);
      });
    }
    function x2(t3, e5) {
      var r3 = E3(e5);
      return r3 && (function(t4, e6) {
        e6.prefinished || e6.finalCalled || ("function" == typeof t4._final ? (e6.pendingcb++, e6.finalCalled = true, o2.nextTick(C2, t4, e6)) : (e6.prefinished = true, t4.emit("prefinish")));
      }(t3, e5), 0 === e5.pendingcb && (e5.finished = true, t3.emit("finish"))), r3;
    }
    c2.inherits(m2, h2), y2.prototype.getBuffer = function() {
      for (var t3 = this.bufferedRequest, e5 = []; t3; )
        e5.push(t3), t3 = t3.next;
      return e5;
    }, function() {
      try {
        Object.defineProperty(y2.prototype, "buffer", { get: f2.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
      } catch (t3) {
      }
    }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (l2 = Function.prototype[Symbol.hasInstance], Object.defineProperty(m2, Symbol.hasInstance, { value: function(t3) {
      return !!l2.call(this, t3) || this === m2 && t3 && t3._writableState instanceof y2;
    } })) : l2 = function(t3) {
      return t3 instanceof this;
    }, m2.prototype.pipe = function() {
      this.emit("error", new Error("Cannot pipe, not readable"));
    }, m2.prototype.write = function(t3, e5, r3) {
      var n3 = this._writableState, i3 = false, s3 = !n3.objectMode && function(t4) {
        return p2.isBuffer(t4) || t4 instanceof d2;
      }(t3);
      return s3 && !p2.isBuffer(t3) && (t3 = function(t4) {
        return p2.from(t4);
      }(t3)), "function" == typeof e5 && (r3 = e5, e5 = null), s3 ? e5 = "buffer" : e5 || (e5 = n3.defaultEncoding), "function" != typeof r3 && (r3 = v5), n3.ended ? function(t4, e6) {
        var r4 = new Error("write after end");
        t4.emit("error", r4), o2.nextTick(e6, r4);
      }(this, r3) : (s3 || function(t4, e6, r4, n4) {
        var i4 = true, s4 = false;
        return null === r4 ? s4 = new TypeError("May not write null values to stream") : "string" == typeof r4 || void 0 === r4 || e6.objectMode || (s4 = new TypeError("Invalid non-string/buffer chunk")), s4 && (t4.emit("error", s4), o2.nextTick(n4, s4), i4 = false), i4;
      }(this, n3, t3, r3)) && (n3.pendingcb++, i3 = function(t4, e6, r4, n4, i4, o3) {
        if (!r4) {
          var s4 = function(t5, e7, r5) {
            return t5.objectMode || false === t5.decodeStrings || "string" != typeof e7 || (e7 = p2.from(e7, r5)), e7;
          }(e6, n4, i4);
          n4 !== s4 && (r4 = true, i4 = "buffer", n4 = s4);
        }
        var a3 = e6.objectMode ? 1 : n4.length;
        e6.length += a3;
        var u3 = e6.length < e6.highWaterMark;
        if (u3 || (e6.needDrain = true), e6.writing || e6.corked) {
          var c3 = e6.lastBufferedRequest;
          e6.lastBufferedRequest = { chunk: n4, encoding: i4, isBuf: r4, callback: o3, next: null }, c3 ? c3.next = e6.lastBufferedRequest : e6.bufferedRequest = e6.lastBufferedRequest, e6.bufferedRequestCount += 1;
        } else
          g2(t4, e6, false, a3, n4, i4, o3);
        return u3;
      }(this, n3, s3, t3, e5, r3)), i3;
    }, m2.prototype.cork = function() {
      this._writableState.corked++;
    }, m2.prototype.uncork = function() {
      var t3 = this._writableState;
      t3.corked && (t3.corked--, t3.writing || t3.corked || t3.finished || t3.bufferProcessing || !t3.bufferedRequest || w2(this, t3));
    }, m2.prototype.setDefaultEncoding = function(t3) {
      if ("string" == typeof t3 && (t3 = t3.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t3 + "").toLowerCase()) > -1))
        throw new TypeError("Unknown encoding: " + t3);
      return this._writableState.defaultEncoding = t3, this;
    }, Object.defineProperty(m2.prototype, "writableHighWaterMark", { enumerable: false, get: function() {
      return this._writableState.highWaterMark;
    } }), m2.prototype._write = function(t3, e5, r3) {
      r3(new Error("_write() is not implemented"));
    }, m2.prototype._writev = null, m2.prototype.end = function(t3, e5, r3) {
      var n3 = this._writableState;
      "function" == typeof t3 ? (r3 = t3, t3 = null, e5 = null) : "function" == typeof e5 && (r3 = e5, e5 = null), null !== t3 && void 0 !== t3 && this.write(t3, e5), n3.corked && (n3.corked = 1, this.uncork()), n3.ending || n3.finished || function(t4, e6, r4) {
        e6.ending = true, x2(t4, e6), r4 && (e6.finished ? o2.nextTick(r4) : t4.once("finish", r4)), e6.ended = true, t4.writable = false;
      }(this, n3, r3);
    }, Object.defineProperty(m2.prototype, "destroyed", { get: function() {
      return void 0 !== this._writableState && this._writableState.destroyed;
    }, set: function(t3) {
      this._writableState && (this._writableState.destroyed = t3);
    } }), m2.prototype.destroy = _2.destroy, m2.prototype._undestroy = _2.undestroy, m2.prototype._destroy = function(t3, e5) {
      this.end(), e5(t3);
    };
  }).call(this, r2(4), r2(11).setImmediate, r2(0));
}, function(t2, e3, r2) {
  (function(e4, r3, n2) {
    t2.exports = function t3(e5, r4, n3) {
      function i2(s3, a2) {
        if (!r4[s3]) {
          if (!e5[s3]) {
            var u2 = "function" == typeof _dereq_ && _dereq_;
            if (!a2 && u2)
              return u2(s3, true);
            if (o2)
              return o2(s3, true);
            var c2 = new Error("Cannot find module '" + s3 + "'");
            throw c2.code = "MODULE_NOT_FOUND", c2;
          }
          var l2 = r4[s3] = { exports: {} };
          e5[s3][0].call(l2.exports, function(t4) {
            return i2(e5[s3][1][t4] || t4);
          }, l2, l2.exports, t3, e5, r4, n3);
        }
        return r4[s3].exports;
      }
      for (var o2 = "function" == typeof _dereq_ && _dereq_, s2 = 0; s2 < n3.length; s2++)
        i2(n3[s2]);
      return i2;
    }({ 1: [function(t3, e5, r4) {
      e5.exports = function(t4) {
        var e6 = t4._SomePromiseArray;
        function r5(t5) {
          var r6 = new e6(t5), n3 = r6.promise();
          return r6.setHowMany(1), r6.setUnwrap(), r6.init(), n3;
        }
        t4.any = function(t5) {
          return r5(t5);
        }, t4.prototype.any = function() {
          return r5(this);
        };
      };
    }, {}], 2: [function(t3, r4, n3) {
      var i2;
      try {
        throw new Error();
      } catch (t4) {
        i2 = t4;
      }
      var o2 = t3("./schedule"), s2 = t3("./queue"), a2 = t3("./util");
      function u2() {
        this._customScheduler = false, this._isTickUsed = false, this._lateQueue = new s2(16), this._normalQueue = new s2(16), this._haveDrainedQueues = false, this._trampolineEnabled = true;
        var t4 = this;
        this.drainQueues = function() {
          t4._drainQueues();
        }, this._schedule = o2;
      }
      function c2(t4, e5, r5) {
        this._lateQueue.push(t4, e5, r5), this._queueTick();
      }
      function l2(t4, e5, r5) {
        this._normalQueue.push(t4, e5, r5), this._queueTick();
      }
      function f2(t4) {
        this._normalQueue._pushOne(t4), this._queueTick();
      }
      u2.prototype.setScheduler = function(t4) {
        var e5 = this._schedule;
        return this._schedule = t4, this._customScheduler = true, e5;
      }, u2.prototype.hasCustomScheduler = function() {
        return this._customScheduler;
      }, u2.prototype.enableTrampoline = function() {
        this._trampolineEnabled = true;
      }, u2.prototype.disableTrampolineIfNecessary = function() {
        a2.hasDevTools && (this._trampolineEnabled = false);
      }, u2.prototype.haveItemsQueued = function() {
        return this._isTickUsed || this._haveDrainedQueues;
      }, u2.prototype.fatalError = function(t4, r5) {
        r5 ? (e4.stderr.write("Fatal " + (t4 instanceof Error ? t4.stack : t4) + "\n"), e4.exit(2)) : this.throwLater(t4);
      }, u2.prototype.throwLater = function(t4, e5) {
        if (1 === arguments.length && (e5 = t4, t4 = function() {
          throw e5;
        }), "undefined" != typeof setTimeout)
          setTimeout(function() {
            t4(e5);
          }, 0);
        else
          try {
            this._schedule(function() {
              t4(e5);
            });
          } catch (t5) {
            throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
          }
      }, a2.hasDevTools ? (u2.prototype.invokeLater = function(t4, e5, r5) {
        this._trampolineEnabled ? c2.call(this, t4, e5, r5) : this._schedule(function() {
          setTimeout(function() {
            t4.call(e5, r5);
          }, 100);
        });
      }, u2.prototype.invoke = function(t4, e5, r5) {
        this._trampolineEnabled ? l2.call(this, t4, e5, r5) : this._schedule(function() {
          t4.call(e5, r5);
        });
      }, u2.prototype.settlePromises = function(t4) {
        this._trampolineEnabled ? f2.call(this, t4) : this._schedule(function() {
          t4._settlePromises();
        });
      }) : (u2.prototype.invokeLater = c2, u2.prototype.invoke = l2, u2.prototype.settlePromises = f2), u2.prototype._drainQueue = function(t4) {
        for (; t4.length() > 0; ) {
          var e5 = t4.shift();
          if ("function" == typeof e5) {
            var r5 = t4.shift(), n4 = t4.shift();
            e5.call(r5, n4);
          } else
            e5._settlePromises();
        }
      }, u2.prototype._drainQueues = function() {
        this._drainQueue(this._normalQueue), this._reset(), this._haveDrainedQueues = true, this._drainQueue(this._lateQueue);
      }, u2.prototype._queueTick = function() {
        this._isTickUsed || (this._isTickUsed = true, this._schedule(this.drainQueues));
      }, u2.prototype._reset = function() {
        this._isTickUsed = false;
      }, r4.exports = u2, r4.exports.firstLineError = i2;
    }, { "./queue": 26, "./schedule": 29, "./util": 36 }], 3: [function(t3, e5, r4) {
      e5.exports = function(t4, e6, r5, n3) {
        var i2 = false, o2 = function(t5, e7) {
          this._reject(e7);
        }, s2 = function(t5, e7) {
          e7.promiseRejectionQueued = true, e7.bindingPromise._then(o2, o2, null, this, t5);
        }, a2 = function(t5, e7) {
          0 == (50397184 & this._bitField) && this._resolveCallback(e7.target);
        }, u2 = function(t5, e7) {
          e7.promiseRejectionQueued || this._reject(t5);
        };
        t4.prototype.bind = function(o3) {
          i2 || (i2 = true, t4.prototype._propagateFrom = n3.propagateFromFunction(), t4.prototype._boundValue = n3.boundValueFunction());
          var c2 = r5(o3), l2 = new t4(e6);
          l2._propagateFrom(this, 1);
          var f2 = this._target();
          if (l2._setBoundTo(c2), c2 instanceof t4) {
            var h2 = { promiseRejectionQueued: false, promise: l2, target: f2, bindingPromise: c2 };
            f2._then(e6, s2, void 0, l2, h2), c2._then(a2, u2, void 0, l2, h2), l2._setOnCancel(c2);
          } else
            l2._resolveCallback(f2);
          return l2;
        }, t4.prototype._setBoundTo = function(t5) {
          void 0 !== t5 ? (this._bitField = 2097152 | this._bitField, this._boundTo = t5) : this._bitField = -2097153 & this._bitField;
        }, t4.prototype._isBound = function() {
          return 2097152 == (2097152 & this._bitField);
        }, t4.bind = function(e7, r6) {
          return t4.resolve(r6).bind(e7);
        };
      };
    }, {}], 4: [function(t3, e5, r4) {
      var n3;
      "undefined" != typeof Promise && (n3 = Promise);
      var i2 = t3("./promise")();
      i2.noConflict = function() {
        try {
          Promise === i2 && (Promise = n3);
        } catch (t4) {
        }
        return i2;
      }, e5.exports = i2;
    }, { "./promise": 22 }], 5: [function(t3, e5, r4) {
      var n3 = Object.create;
      if (n3) {
        var i2 = n3(null), o2 = n3(null);
        i2[" size"] = o2[" size"] = 0;
      }
      e5.exports = function(e6) {
        var r5 = t3("./util"), n4 = r5.canEvaluate;
        function i3(t4) {
          return function(t5, n5) {
            var i4;
            if (null != t5 && (i4 = t5[n5]), "function" != typeof i4) {
              var o4 = "Object " + r5.classString(t5) + " has no method '" + r5.toString(n5) + "'";
              throw new e6.TypeError(o4);
            }
            return i4;
          }(t4, this.pop()).apply(t4, this);
        }
        function o3(t4) {
          return t4[this];
        }
        function s2(t4) {
          var e7 = +this;
          return e7 < 0 && (e7 = Math.max(0, e7 + t4.length)), t4[e7];
        }
        r5.isIdentifier, e6.prototype.call = function(t4) {
          var e7 = [].slice.call(arguments, 1);
          return e7.push(t4), this._then(i3, void 0, void 0, e7, void 0);
        }, e6.prototype.get = function(t4) {
          var e7;
          if ("number" == typeof t4)
            e7 = s2;
          else if (n4) {
            var r6 = (void 0)(t4);
            e7 = null !== r6 ? r6 : o3;
          } else
            e7 = o3;
          return this._then(e7, void 0, void 0, t4, void 0);
        };
      };
    }, { "./util": 36 }], 6: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2) {
        var o2 = t3("./util"), s2 = o2.tryCatch, a2 = o2.errorObj, u2 = e6._async;
        e6.prototype.break = e6.prototype.cancel = function() {
          if (!i2.cancellation())
            return this._warn("cancellation is disabled");
          for (var t4 = this, e7 = t4; t4._isCancellable(); ) {
            if (!t4._cancelBy(e7)) {
              e7._isFollowing() ? e7._followee().cancel() : e7._cancelBranched();
              break;
            }
            var r6 = t4._cancellationParent;
            if (null == r6 || !r6._isCancellable()) {
              t4._isFollowing() ? t4._followee().cancel() : t4._cancelBranched();
              break;
            }
            t4._isFollowing() && t4._followee().cancel(), t4._setWillBeCancelled(), e7 = t4, t4 = r6;
          }
        }, e6.prototype._branchHasCancelled = function() {
          this._branchesRemainingToCancel--;
        }, e6.prototype._enoughBranchesHaveCancelled = function() {
          return void 0 === this._branchesRemainingToCancel || this._branchesRemainingToCancel <= 0;
        }, e6.prototype._cancelBy = function(t4) {
          return t4 === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), true) : (this._branchHasCancelled(), !!this._enoughBranchesHaveCancelled() && (this._invokeOnCancel(), true));
        }, e6.prototype._cancelBranched = function() {
          this._enoughBranchesHaveCancelled() && this._cancel();
        }, e6.prototype._cancel = function() {
          this._isCancellable() && (this._setCancelled(), u2.invoke(this._cancelPromises, this, void 0));
        }, e6.prototype._cancelPromises = function() {
          this._length() > 0 && this._settlePromises();
        }, e6.prototype._unsetOnCancel = function() {
          this._onCancelField = void 0;
        }, e6.prototype._isCancellable = function() {
          return this.isPending() && !this._isCancelled();
        }, e6.prototype.isCancellable = function() {
          return this.isPending() && !this.isCancelled();
        }, e6.prototype._doInvokeOnCancel = function(t4, e7) {
          if (o2.isArray(t4))
            for (var r6 = 0; r6 < t4.length; ++r6)
              this._doInvokeOnCancel(t4[r6], e7);
          else if (void 0 !== t4)
            if ("function" == typeof t4) {
              if (!e7) {
                var n4 = s2(t4).call(this._boundValue());
                n4 === a2 && (this._attachExtraTrace(n4.e), u2.throwLater(n4.e));
              }
            } else
              t4._resultCancelled(this);
        }, e6.prototype._invokeOnCancel = function() {
          var t4 = this._onCancel();
          this._unsetOnCancel(), u2.invoke(this._doInvokeOnCancel, this, t4);
        }, e6.prototype._invokeInternalOnCancel = function() {
          this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), true), this._unsetOnCancel());
        }, e6.prototype._resultCancelled = function() {
          this.cancel();
        };
      };
    }, { "./util": 36 }], 7: [function(t3, e5, r4) {
      e5.exports = function(e6) {
        var r5 = t3("./util"), n3 = t3("./es5").keys, i2 = r5.tryCatch, o2 = r5.errorObj;
        return function(t4, s2, a2) {
          return function(u2) {
            var c2 = a2._boundValue();
            t:
              for (var l2 = 0; l2 < t4.length; ++l2) {
                var f2 = t4[l2];
                if (f2 === Error || null != f2 && f2.prototype instanceof Error) {
                  if (u2 instanceof f2)
                    return i2(s2).call(c2, u2);
                } else if ("function" == typeof f2) {
                  var h2 = i2(f2).call(c2, u2);
                  if (h2 === o2)
                    return h2;
                  if (h2)
                    return i2(s2).call(c2, u2);
                } else if (r5.isObject(u2)) {
                  for (var p2 = n3(f2), d2 = 0; d2 < p2.length; ++d2) {
                    var _2 = p2[d2];
                    if (f2[_2] != u2[_2])
                      continue t;
                  }
                  return i2(s2).call(c2, u2);
                }
              }
            return e6;
          };
        };
      };
    }, { "./es5": 13, "./util": 36 }], 8: [function(t3, e5, r4) {
      e5.exports = function(t4) {
        var e6 = false, r5 = [];
        function n3() {
          this._trace = new n3.CapturedTrace(i2());
        }
        function i2() {
          var t5 = r5.length - 1;
          if (t5 >= 0)
            return r5[t5];
        }
        return t4.prototype._promiseCreated = function() {
        }, t4.prototype._pushContext = function() {
        }, t4.prototype._popContext = function() {
          return null;
        }, t4._peekContext = t4.prototype._peekContext = function() {
        }, n3.prototype._pushContext = function() {
          void 0 !== this._trace && (this._trace._promiseCreated = null, r5.push(this._trace));
        }, n3.prototype._popContext = function() {
          if (void 0 !== this._trace) {
            var t5 = r5.pop(), e7 = t5._promiseCreated;
            return t5._promiseCreated = null, e7;
          }
          return null;
        }, n3.CapturedTrace = null, n3.create = function() {
          if (e6)
            return new n3();
        }, n3.deactivateLongStackTraces = function() {
        }, n3.activateLongStackTraces = function() {
          var r6 = t4.prototype._pushContext, o2 = t4.prototype._popContext, s2 = t4._peekContext, a2 = t4.prototype._peekContext, u2 = t4.prototype._promiseCreated;
          n3.deactivateLongStackTraces = function() {
            t4.prototype._pushContext = r6, t4.prototype._popContext = o2, t4._peekContext = s2, t4.prototype._peekContext = a2, t4.prototype._promiseCreated = u2, e6 = false;
          }, e6 = true, t4.prototype._pushContext = n3.prototype._pushContext, t4.prototype._popContext = n3.prototype._popContext, t4._peekContext = t4.prototype._peekContext = i2, t4.prototype._promiseCreated = function() {
            var t5 = this._peekContext();
            t5 && null == t5._promiseCreated && (t5._promiseCreated = this);
          };
        }, n3;
      };
    }, {}], 9: [function(t3, r4, n3) {
      r4.exports = function(r5, n4) {
        var i2, o2, s2, a2 = r5._getDomain, u2 = r5._async, c2 = t3("./errors").Warning, l2 = t3("./util"), f2 = l2.canAttachTrace, h2 = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/, p2 = /\((?:timers\.js):\d+:\d+\)/, d2 = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/, _2 = null, v5 = null, y2 = false, m2 = !(0 == l2.env("BLUEBIRD_DEBUG")), g2 = !(0 == l2.env("BLUEBIRD_WARNINGS") || !m2 && !l2.env("BLUEBIRD_WARNINGS")), b2 = !(0 == l2.env("BLUEBIRD_LONG_STACK_TRACES") || !m2 && !l2.env("BLUEBIRD_LONG_STACK_TRACES")), w2 = 0 != l2.env("BLUEBIRD_W_FORGOTTEN_RETURN") && (g2 || !!l2.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
        r5.prototype.suppressUnhandledRejections = function() {
          var t4 = this._target();
          t4._bitField = -1048577 & t4._bitField | 524288;
        }, r5.prototype._ensurePossibleRejectionHandled = function() {
          if (0 == (524288 & this._bitField)) {
            this._setRejectionIsUnhandled();
            var t4 = this;
            setTimeout(function() {
              t4._notifyUnhandledRejection();
            }, 1);
          }
        }, r5.prototype._notifyUnhandledRejectionIsHandled = function() {
          q2("rejectionHandled", i2, void 0, this);
        }, r5.prototype._setReturnedNonUndefined = function() {
          this._bitField = 268435456 | this._bitField;
        }, r5.prototype._returnedNonUndefined = function() {
          return 0 != (268435456 & this._bitField);
        }, r5.prototype._notifyUnhandledRejection = function() {
          if (this._isRejectionUnhandled()) {
            var t4 = this._settledValue();
            this._setUnhandledRejectionIsNotified(), q2("unhandledRejection", o2, t4, this);
          }
        }, r5.prototype._setUnhandledRejectionIsNotified = function() {
          this._bitField = 262144 | this._bitField;
        }, r5.prototype._unsetUnhandledRejectionIsNotified = function() {
          this._bitField = -262145 & this._bitField;
        }, r5.prototype._isUnhandledRejectionNotified = function() {
          return (262144 & this._bitField) > 0;
        }, r5.prototype._setRejectionIsUnhandled = function() {
          this._bitField = 1048576 | this._bitField;
        }, r5.prototype._unsetRejectionIsUnhandled = function() {
          this._bitField = -1048577 & this._bitField, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled());
        }, r5.prototype._isRejectionUnhandled = function() {
          return (1048576 & this._bitField) > 0;
        }, r5.prototype._warn = function(t4, e5, r6) {
          return U2(t4, e5, r6 || this);
        }, r5.onPossiblyUnhandledRejection = function(t4) {
          var e5 = a2();
          o2 = "function" == typeof t4 ? null === e5 ? t4 : l2.domainBind(e5, t4) : void 0;
        }, r5.onUnhandledRejectionHandled = function(t4) {
          var e5 = a2();
          i2 = "function" == typeof t4 ? null === e5 ? t4 : l2.domainBind(e5, t4) : void 0;
        };
        var E3 = function() {
        };
        r5.longStackTraces = function() {
          if (u2.haveItemsQueued() && !J2.longStackTraces)
            throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
          if (!J2.longStackTraces && Y2()) {
            var t4 = r5.prototype._captureStackTrace, e5 = r5.prototype._attachExtraTrace;
            J2.longStackTraces = true, E3 = function() {
              if (u2.haveItemsQueued() && !J2.longStackTraces)
                throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
              r5.prototype._captureStackTrace = t4, r5.prototype._attachExtraTrace = e5, n4.deactivateLongStackTraces(), u2.enableTrampoline(), J2.longStackTraces = false;
            }, r5.prototype._captureStackTrace = D2, r5.prototype._attachExtraTrace = I2, n4.activateLongStackTraces(), u2.disableTrampolineIfNecessary();
          }
        }, r5.hasLongStackTraces = function() {
          return J2.longStackTraces && Y2();
        };
        var C2 = function() {
          try {
            if ("function" == typeof CustomEvent) {
              var t4 = new CustomEvent("CustomEvent");
              return l2.global.dispatchEvent(t4), function(t5, e5) {
                var r6 = new CustomEvent(t5.toLowerCase(), { detail: e5, cancelable: true });
                return !l2.global.dispatchEvent(r6);
              };
            }
            return "function" == typeof Event ? (t4 = new Event("CustomEvent"), l2.global.dispatchEvent(t4), function(t5, e5) {
              var r6 = new Event(t5.toLowerCase(), { cancelable: true });
              return r6.detail = e5, !l2.global.dispatchEvent(r6);
            }) : ((t4 = document.createEvent("CustomEvent")).initCustomEvent("testingtheevent", false, true, {}), l2.global.dispatchEvent(t4), function(t5, e5) {
              var r6 = document.createEvent("CustomEvent");
              return r6.initCustomEvent(t5.toLowerCase(), false, true, e5), !l2.global.dispatchEvent(r6);
            });
          } catch (t5) {
          }
          return function() {
            return false;
          };
        }(), x2 = l2.isNode ? function() {
          return e4.emit.apply(e4, arguments);
        } : l2.global ? function(t4) {
          var e5 = "on" + t4.toLowerCase(), r6 = l2.global[e5];
          return !!r6 && (r6.apply(l2.global, [].slice.call(arguments, 1)), true);
        } : function() {
          return false;
        };
        function j2(t4, e5) {
          return { promise: e5 };
        }
        var S2 = { promiseCreated: j2, promiseFulfilled: j2, promiseRejected: j2, promiseResolved: j2, promiseCancelled: j2, promiseChained: function(t4, e5, r6) {
          return { promise: e5, child: r6 };
        }, warning: function(t4, e5) {
          return { warning: e5 };
        }, unhandledRejection: function(t4, e5, r6) {
          return { reason: e5, promise: r6 };
        }, rejectionHandled: j2 }, R2 = function(t4) {
          var e5 = false;
          try {
            e5 = x2.apply(null, arguments);
          } catch (t5) {
            u2.throwLater(t5), e5 = true;
          }
          var r6 = false;
          try {
            r6 = C2(t4, S2[t4].apply(null, arguments));
          } catch (t5) {
            u2.throwLater(t5), r6 = true;
          }
          return r6 || e5;
        };
        function k2() {
          return false;
        }
        function T2(t4, e5, r6) {
          var n5 = this;
          try {
            t4(e5, r6, function(t5) {
              if ("function" != typeof t5)
                throw new TypeError("onCancel must be a function, got: " + l2.toString(t5));
              n5._attachCancellationCallback(t5);
            });
          } catch (t5) {
            return t5;
          }
        }
        function P2(t4) {
          if (!this._isCancellable())
            return this;
          var e5 = this._onCancel();
          void 0 !== e5 ? l2.isArray(e5) ? e5.push(t4) : this._setOnCancel([e5, t4]) : this._setOnCancel(t4);
        }
        function O2() {
          return this._onCancelField;
        }
        function A2(t4) {
          this._onCancelField = t4;
        }
        function F2() {
          this._cancellationParent = void 0, this._onCancelField = void 0;
        }
        function L2(t4, e5) {
          if (0 != (1 & e5)) {
            this._cancellationParent = t4;
            var r6 = t4._branchesRemainingToCancel;
            void 0 === r6 && (r6 = 0), t4._branchesRemainingToCancel = r6 + 1;
          }
          0 != (2 & e5) && t4._isBound() && this._setBoundTo(t4._boundTo);
        }
        r5.config = function(t4) {
          if ("longStackTraces" in (t4 = Object(t4)) && (t4.longStackTraces ? r5.longStackTraces() : !t4.longStackTraces && r5.hasLongStackTraces() && E3()), "warnings" in t4) {
            var e5 = t4.warnings;
            J2.warnings = !!e5, w2 = J2.warnings, l2.isObject(e5) && "wForgottenReturn" in e5 && (w2 = !!e5.wForgottenReturn);
          }
          if ("cancellation" in t4 && t4.cancellation && !J2.cancellation) {
            if (u2.haveItemsQueued())
              throw new Error("cannot enable cancellation after promises are in use");
            r5.prototype._clearCancellationData = F2, r5.prototype._propagateFrom = L2, r5.prototype._onCancel = O2, r5.prototype._setOnCancel = A2, r5.prototype._attachCancellationCallback = P2, r5.prototype._execute = T2, M2 = L2, J2.cancellation = true;
          }
          return "monitoring" in t4 && (t4.monitoring && !J2.monitoring ? (J2.monitoring = true, r5.prototype._fireEvent = R2) : !t4.monitoring && J2.monitoring && (J2.monitoring = false, r5.prototype._fireEvent = k2)), r5;
        }, r5.prototype._fireEvent = k2, r5.prototype._execute = function(t4, e5, r6) {
          try {
            t4(e5, r6);
          } catch (t5) {
            return t5;
          }
        }, r5.prototype._onCancel = function() {
        }, r5.prototype._setOnCancel = function(t4) {
        }, r5.prototype._attachCancellationCallback = function(t4) {
        }, r5.prototype._captureStackTrace = function() {
        }, r5.prototype._attachExtraTrace = function() {
        }, r5.prototype._clearCancellationData = function() {
        }, r5.prototype._propagateFrom = function(t4, e5) {
        };
        var M2 = function(t4, e5) {
          0 != (2 & e5) && t4._isBound() && this._setBoundTo(t4._boundTo);
        };
        function B2() {
          var t4 = this._boundTo;
          return void 0 !== t4 && t4 instanceof r5 ? t4.isFulfilled() ? t4.value() : void 0 : t4;
        }
        function D2() {
          this._trace = new X2(this._peekContext());
        }
        function I2(t4, e5) {
          if (f2(t4)) {
            var r6 = this._trace;
            if (void 0 !== r6 && e5 && (r6 = r6._parent), void 0 !== r6)
              r6.attachExtraTrace(t4);
            else if (!t4.__stackCleaned__) {
              var n5 = H2(t4);
              l2.notEnumerableProp(t4, "stack", n5.message + "\n" + n5.stack.join("\n")), l2.notEnumerableProp(t4, "__stackCleaned__", true);
            }
          }
        }
        function U2(t4, e5, n5) {
          if (J2.warnings) {
            var i3, o3 = new c2(t4);
            if (e5)
              n5._attachExtraTrace(o3);
            else if (J2.longStackTraces && (i3 = r5._peekContext()))
              i3.attachExtraTrace(o3);
            else {
              var s3 = H2(o3);
              o3.stack = s3.message + "\n" + s3.stack.join("\n");
            }
            R2("warning", o3) || V2(o3, "", true);
          }
        }
        function N2(t4) {
          for (var e5 = [], r6 = 0; r6 < t4.length; ++r6) {
            var n5 = t4[r6], i3 = "    (No stack trace)" === n5 || _2.test(n5), o3 = i3 && $(n5);
            i3 && !o3 && (y2 && " " !== n5.charAt(0) && (n5 = "    " + n5), e5.push(n5));
          }
          return e5;
        }
        function H2(t4) {
          var e5 = t4.stack, r6 = t4.toString();
          return e5 = "string" == typeof e5 && e5.length > 0 ? function(t5) {
            for (var e6 = t5.stack.replace(/\s+$/g, "").split("\n"), r7 = 0; r7 < e6.length; ++r7) {
              var n5 = e6[r7];
              if ("    (No stack trace)" === n5 || _2.test(n5))
                break;
            }
            return r7 > 0 && "SyntaxError" != t5.name && (e6 = e6.slice(r7)), e6;
          }(t4) : ["    (No stack trace)"], { message: r6, stack: "SyntaxError" == t4.name ? e5 : N2(e5) };
        }
        function V2(t4, e5, r6) {
          if ("undefined" != typeof console) {
            var n5;
            if (l2.isObject(t4)) {
              var i3 = t4.stack;
              n5 = e5 + v5(i3, t4);
            } else
              n5 = e5 + String(t4);
            "function" == typeof s2 ? s2(n5, r6) : "function" != typeof console.log && "object" != typeof console.log || console.log(n5);
          }
        }
        function q2(t4, e5, r6, n5) {
          var i3 = false;
          try {
            "function" == typeof e5 && (i3 = true, "rejectionHandled" === t4 ? e5(n5) : e5(r6, n5));
          } catch (t5) {
            u2.throwLater(t5);
          }
          "unhandledRejection" === t4 ? R2(t4, r6, n5) || i3 || V2(r6, "Unhandled rejection ") : R2(t4, n5);
        }
        function W2(t4) {
          var e5;
          if ("function" == typeof t4)
            e5 = "[function " + (t4.name || "anonymous") + "]";
          else {
            if (e5 = t4 && "function" == typeof t4.toString ? t4.toString() : l2.toString(t4), /\[object [a-zA-Z0-9$_]+\]/.test(e5))
              try {
                e5 = JSON.stringify(t4);
              } catch (t5) {
              }
            0 === e5.length && (e5 = "(empty array)");
          }
          return "(<" + function(t5) {
            return t5.length < 41 ? t5 : t5.substr(0, 38) + "...";
          }(e5) + ">, no stack trace)";
        }
        function Y2() {
          return "function" == typeof G2;
        }
        var $ = function() {
          return false;
        }, z2 = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
        function Q2(t4) {
          var e5 = t4.match(z2);
          if (e5)
            return { fileName: e5[1], line: parseInt(e5[2], 10) };
        }
        function X2(t4) {
          this._parent = t4, this._promisesCreated = 0;
          var e5 = this._length = 1 + (void 0 === t4 ? 0 : t4._length);
          G2(this, X2), e5 > 32 && this.uncycle();
        }
        l2.inherits(X2, Error), n4.CapturedTrace = X2, X2.prototype.uncycle = function() {
          var t4 = this._length;
          if (!(t4 < 2)) {
            for (var e5 = [], r6 = {}, n5 = 0, i3 = this; void 0 !== i3; ++n5)
              e5.push(i3), i3 = i3._parent;
            for (n5 = (t4 = this._length = n5) - 1; n5 >= 0; --n5) {
              var o3 = e5[n5].stack;
              void 0 === r6[o3] && (r6[o3] = n5);
            }
            for (n5 = 0; n5 < t4; ++n5) {
              var s3 = r6[e5[n5].stack];
              if (void 0 !== s3 && s3 !== n5) {
                s3 > 0 && (e5[s3 - 1]._parent = void 0, e5[s3 - 1]._length = 1), e5[n5]._parent = void 0, e5[n5]._length = 1;
                var a3 = n5 > 0 ? e5[n5 - 1] : this;
                s3 < t4 - 1 ? (a3._parent = e5[s3 + 1], a3._parent.uncycle(), a3._length = a3._parent._length + 1) : (a3._parent = void 0, a3._length = 1);
                for (var u3 = a3._length + 1, c3 = n5 - 2; c3 >= 0; --c3)
                  e5[c3]._length = u3, u3++;
                return;
              }
            }
          }
        }, X2.prototype.attachExtraTrace = function(t4) {
          if (!t4.__stackCleaned__) {
            this.uncycle();
            for (var e5 = H2(t4), r6 = e5.message, n5 = [e5.stack], i3 = this; void 0 !== i3; )
              n5.push(N2(i3.stack.split("\n"))), i3 = i3._parent;
            !function(t5) {
              for (var e6 = t5[0], r7 = 1; r7 < t5.length; ++r7) {
                for (var n6 = t5[r7], i4 = e6.length - 1, o3 = e6[i4], s3 = -1, a3 = n6.length - 1; a3 >= 0; --a3)
                  if (n6[a3] === o3) {
                    s3 = a3;
                    break;
                  }
                for (a3 = s3; a3 >= 0; --a3) {
                  var u3 = n6[a3];
                  if (e6[i4] !== u3)
                    break;
                  e6.pop(), i4--;
                }
                e6 = n6;
              }
            }(n5), function(t5) {
              for (var e6 = 0; e6 < t5.length; ++e6)
                (0 === t5[e6].length || e6 + 1 < t5.length && t5[e6][0] === t5[e6 + 1][0]) && (t5.splice(e6, 1), e6--);
            }(n5), l2.notEnumerableProp(t4, "stack", function(t5, e6) {
              for (var r7 = 0; r7 < e6.length - 1; ++r7)
                e6[r7].push("From previous event:"), e6[r7] = e6[r7].join("\n");
              return r7 < e6.length && (e6[r7] = e6[r7].join("\n")), t5 + "\n" + e6.join("\n");
            }(r6, n5)), l2.notEnumerableProp(t4, "__stackCleaned__", true);
          }
        };
        var G2 = function() {
          var t4 = /^\s*at\s*/, e5 = function(t5, e6) {
            return "string" == typeof t5 ? t5 : void 0 !== e6.name && void 0 !== e6.message ? e6.toString() : W2(e6);
          };
          if ("number" == typeof Error.stackTraceLimit && "function" == typeof Error.captureStackTrace) {
            Error.stackTraceLimit += 6, _2 = t4, v5 = e5;
            var r6 = Error.captureStackTrace;
            return $ = function(t5) {
              return h2.test(t5);
            }, function(t5, e6) {
              Error.stackTraceLimit += 6, r6(t5, e6), Error.stackTraceLimit -= 6;
            };
          }
          var n5, i3 = new Error();
          if ("string" == typeof i3.stack && i3.stack.split("\n")[0].indexOf("stackDetection@") >= 0)
            return _2 = /@/, v5 = e5, y2 = true, function(t5) {
              t5.stack = new Error().stack;
            };
          try {
            throw new Error();
          } catch (t5) {
            n5 = "stack" in t5;
          }
          return "stack" in i3 || !n5 || "number" != typeof Error.stackTraceLimit ? (v5 = function(t5, e6) {
            return "string" == typeof t5 ? t5 : "object" != typeof e6 && "function" != typeof e6 || void 0 === e6.name || void 0 === e6.message ? W2(e6) : e6.toString();
          }, null) : (_2 = t4, v5 = e5, function(t5) {
            Error.stackTraceLimit += 6;
            try {
              throw new Error();
            } catch (e6) {
              t5.stack = e6.stack;
            }
            Error.stackTraceLimit -= 6;
          });
        }();
        "undefined" != typeof console && void 0 !== console.warn && (s2 = function(t4) {
          console.warn(t4);
        }, l2.isNode && e4.stderr.isTTY ? s2 = function(t4, e5) {
          var r6 = e5 ? "\x1B[33m" : "\x1B[31m";
          console.warn(r6 + t4 + "\x1B[0m\n");
        } : l2.isNode || "string" != typeof new Error().stack || (s2 = function(t4, e5) {
          console.warn("%c" + t4, e5 ? "color: darkorange" : "color: red");
        }));
        var J2 = { warnings: g2, longStackTraces: false, cancellation: false, monitoring: false };
        return b2 && r5.longStackTraces(), { longStackTraces: function() {
          return J2.longStackTraces;
        }, warnings: function() {
          return J2.warnings;
        }, cancellation: function() {
          return J2.cancellation;
        }, monitoring: function() {
          return J2.monitoring;
        }, propagateFromFunction: function() {
          return M2;
        }, boundValueFunction: function() {
          return B2;
        }, checkForgottenReturns: function(t4, e5, r6, n5, i3) {
          if (void 0 === t4 && null !== e5 && w2) {
            if (void 0 !== i3 && i3._returnedNonUndefined())
              return;
            if (0 == (65535 & n5._bitField))
              return;
            r6 && (r6 += " ");
            var o3 = "", s3 = "";
            if (e5._trace) {
              for (var a3 = e5._trace.stack.split("\n"), u3 = N2(a3), c3 = u3.length - 1; c3 >= 0; --c3) {
                var l3 = u3[c3];
                if (!p2.test(l3)) {
                  var f3 = l3.match(d2);
                  f3 && (o3 = "at " + f3[1] + ":" + f3[2] + ":" + f3[3] + " ");
                  break;
                }
              }
              if (u3.length > 0) {
                var h3 = u3[0];
                for (c3 = 0; c3 < a3.length; ++c3)
                  if (a3[c3] === h3) {
                    c3 > 0 && (s3 = "\n" + a3[c3 - 1]);
                    break;
                  }
              }
            }
            var _3 = "a promise was created in a " + r6 + "handler " + o3 + "but was not returned from it, see http://goo.gl/rRqMUw" + s3;
            n5._warn(_3, true, e5);
          }
        }, setBounds: function(t4, e5) {
          if (Y2()) {
            for (var r6, n5, i3 = t4.stack.split("\n"), o3 = e5.stack.split("\n"), s3 = -1, a3 = -1, u3 = 0; u3 < i3.length; ++u3)
              if (c3 = Q2(i3[u3])) {
                r6 = c3.fileName, s3 = c3.line;
                break;
              }
            for (u3 = 0; u3 < o3.length; ++u3) {
              var c3;
              if (c3 = Q2(o3[u3])) {
                n5 = c3.fileName, a3 = c3.line;
                break;
              }
            }
            s3 < 0 || a3 < 0 || !r6 || !n5 || r6 !== n5 || s3 >= a3 || ($ = function(t5) {
              if (h2.test(t5))
                return true;
              var e6 = Q2(t5);
              return !!(e6 && e6.fileName === r6 && s3 <= e6.line && e6.line <= a3);
            });
          }
        }, warn: U2, deprecated: function(t4, e5) {
          var r6 = t4 + " is deprecated and will be removed in a future version.";
          return e5 && (r6 += " Use " + e5 + " instead."), U2(r6);
        }, CapturedTrace: X2, fireDomEvent: C2, fireGlobalEvent: x2 };
      };
    }, { "./errors": 12, "./util": 36 }], 10: [function(t3, e5, r4) {
      e5.exports = function(t4) {
        function e6() {
          return this.value;
        }
        function r5() {
          throw this.reason;
        }
        t4.prototype.return = t4.prototype.thenReturn = function(r6) {
          return r6 instanceof t4 && r6.suppressUnhandledRejections(), this._then(e6, void 0, void 0, { value: r6 }, void 0);
        }, t4.prototype.throw = t4.prototype.thenThrow = function(t5) {
          return this._then(r5, void 0, void 0, { reason: t5 }, void 0);
        }, t4.prototype.catchThrow = function(t5) {
          if (arguments.length <= 1)
            return this._then(void 0, r5, void 0, { reason: t5 }, void 0);
          var e7 = arguments[1];
          return this.caught(t5, function() {
            throw e7;
          });
        }, t4.prototype.catchReturn = function(r6) {
          if (arguments.length <= 1)
            return r6 instanceof t4 && r6.suppressUnhandledRejections(), this._then(void 0, e6, void 0, { value: r6 }, void 0);
          var n3 = arguments[1];
          return n3 instanceof t4 && n3.suppressUnhandledRejections(), this.caught(r6, function() {
            return n3;
          });
        };
      };
    }, {}], 11: [function(t3, e5, r4) {
      e5.exports = function(t4, e6) {
        var r5 = t4.reduce, n3 = t4.all;
        function i2() {
          return n3(this);
        }
        t4.prototype.each = function(t5) {
          return r5(this, t5, e6, 0)._then(i2, void 0, void 0, this, void 0);
        }, t4.prototype.mapSeries = function(t5) {
          return r5(this, t5, e6, e6);
        }, t4.each = function(t5, n4) {
          return r5(t5, n4, e6, 0)._then(i2, void 0, void 0, t5, void 0);
        }, t4.mapSeries = function(t5, n4) {
          return r5(t5, n4, e6, e6);
        };
      };
    }, {}], 12: [function(t3, e5, r4) {
      var n3, i2, o2 = t3("./es5"), s2 = o2.freeze, a2 = t3("./util"), u2 = a2.inherits, c2 = a2.notEnumerableProp;
      function l2(t4, e6) {
        function r5(n4) {
          if (!(this instanceof r5))
            return new r5(n4);
          c2(this, "message", "string" == typeof n4 ? n4 : e6), c2(this, "name", t4), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this);
        }
        return u2(r5, Error), r5;
      }
      var f2 = l2("Warning", "warning"), h2 = l2("CancellationError", "cancellation error"), p2 = l2("TimeoutError", "timeout error"), d2 = l2("AggregateError", "aggregate error");
      try {
        n3 = TypeError, i2 = RangeError;
      } catch (t4) {
        n3 = l2("TypeError", "type error"), i2 = l2("RangeError", "range error");
      }
      for (var _2 = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), v5 = 0; v5 < _2.length; ++v5)
        "function" == typeof Array.prototype[_2[v5]] && (d2.prototype[_2[v5]] = Array.prototype[_2[v5]]);
      o2.defineProperty(d2.prototype, "length", { value: 0, configurable: false, writable: true, enumerable: true }), d2.prototype.isOperational = true;
      var y2 = 0;
      function m2(t4) {
        if (!(this instanceof m2))
          return new m2(t4);
        c2(this, "name", "OperationalError"), c2(this, "message", t4), this.cause = t4, this.isOperational = true, t4 instanceof Error ? (c2(this, "message", t4.message), c2(this, "stack", t4.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
      }
      d2.prototype.toString = function() {
        var t4 = Array(4 * y2 + 1).join(" "), e6 = "\n" + t4 + "AggregateError of:\n";
        y2++, t4 = Array(4 * y2 + 1).join(" ");
        for (var r5 = 0; r5 < this.length; ++r5) {
          for (var n4 = this[r5] === this ? "[Circular AggregateError]" : this[r5] + "", i3 = n4.split("\n"), o3 = 0; o3 < i3.length; ++o3)
            i3[o3] = t4 + i3[o3];
          e6 += (n4 = i3.join("\n")) + "\n";
        }
        return y2--, e6;
      }, u2(m2, Error);
      var g2 = Error.__BluebirdErrorTypes__;
      g2 || (g2 = s2({ CancellationError: h2, TimeoutError: p2, OperationalError: m2, RejectionError: m2, AggregateError: d2 }), o2.defineProperty(Error, "__BluebirdErrorTypes__", { value: g2, writable: false, enumerable: false, configurable: false })), e5.exports = { Error, TypeError: n3, RangeError: i2, CancellationError: g2.CancellationError, OperationalError: g2.OperationalError, TimeoutError: g2.TimeoutError, AggregateError: g2.AggregateError, Warning: f2 };
    }, { "./es5": 13, "./util": 36 }], 13: [function(t3, e5, r4) {
      var n3 = function() {
        return void 0 === this;
      }();
      if (n3)
        e5.exports = { freeze: Object.freeze, defineProperty: Object.defineProperty, getDescriptor: Object.getOwnPropertyDescriptor, keys: Object.keys, names: Object.getOwnPropertyNames, getPrototypeOf: Object.getPrototypeOf, isArray: Array.isArray, isES5: n3, propertyIsWritable: function(t4, e6) {
          var r5 = Object.getOwnPropertyDescriptor(t4, e6);
          return !(r5 && !r5.writable && !r5.set);
        } };
      else {
        var i2 = {}.hasOwnProperty, o2 = {}.toString, s2 = {}.constructor.prototype, a2 = function(t4) {
          var e6 = [];
          for (var r5 in t4)
            i2.call(t4, r5) && e6.push(r5);
          return e6;
        };
        e5.exports = { isArray: function(t4) {
          try {
            return "[object Array]" === o2.call(t4);
          } catch (t5) {
            return false;
          }
        }, keys: a2, names: a2, defineProperty: function(t4, e6, r5) {
          return t4[e6] = r5.value, t4;
        }, getDescriptor: function(t4, e6) {
          return { value: t4[e6] };
        }, freeze: function(t4) {
          return t4;
        }, getPrototypeOf: function(t4) {
          try {
            return Object(t4).constructor.prototype;
          } catch (t5) {
            return s2;
          }
        }, isES5: n3, propertyIsWritable: function() {
          return true;
        } };
      }
    }, {}], 14: [function(t3, e5, r4) {
      e5.exports = function(t4, e6) {
        var r5 = t4.map;
        t4.prototype.filter = function(t5, n3) {
          return r5(this, t5, n3, e6);
        }, t4.filter = function(t5, n3, i2) {
          return r5(t5, n3, i2, e6);
        };
      };
    }, {}], 15: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3) {
        var i2 = t3("./util"), o2 = e6.CancellationError, s2 = i2.errorObj, a2 = t3("./catch_filter")(n3);
        function u2(t4, e7, r6) {
          this.promise = t4, this.type = e7, this.handler = r6, this.called = false, this.cancelPromise = null;
        }
        function c2(t4) {
          this.finallyHandler = t4;
        }
        function l2(t4, e7) {
          return null != t4.cancelPromise && (arguments.length > 1 ? t4.cancelPromise._reject(e7) : t4.cancelPromise._cancel(), t4.cancelPromise = null, true);
        }
        function f2() {
          return p2.call(this, this.promise._target()._settledValue());
        }
        function h2(t4) {
          if (!l2(this, t4))
            return s2.e = t4, s2;
        }
        function p2(t4) {
          var i3 = this.promise, a3 = this.handler;
          if (!this.called) {
            this.called = true;
            var u3 = this.isFinallyHandler() ? a3.call(i3._boundValue()) : a3.call(i3._boundValue(), t4);
            if (u3 === n3)
              return u3;
            if (void 0 !== u3) {
              i3._setReturnedNonUndefined();
              var p3 = r5(u3, i3);
              if (p3 instanceof e6) {
                if (null != this.cancelPromise) {
                  if (p3._isCancelled()) {
                    var d2 = new o2("late cancellation observer");
                    return i3._attachExtraTrace(d2), s2.e = d2, s2;
                  }
                  p3.isPending() && p3._attachCancellationCallback(new c2(this));
                }
                return p3._then(f2, h2, void 0, this, void 0);
              }
            }
          }
          return i3.isRejected() ? (l2(this), s2.e = t4, s2) : (l2(this), t4);
        }
        return u2.prototype.isFinallyHandler = function() {
          return 0 === this.type;
        }, c2.prototype._resultCancelled = function() {
          l2(this.finallyHandler);
        }, e6.prototype._passThrough = function(t4, e7, r6, n4) {
          return "function" != typeof t4 ? this.then() : this._then(r6, n4, void 0, new u2(this, e7, t4), void 0);
        }, e6.prototype.lastly = e6.prototype.finally = function(t4) {
          return this._passThrough(t4, 0, p2, p2);
        }, e6.prototype.tap = function(t4) {
          return this._passThrough(t4, 1, p2);
        }, e6.prototype.tapCatch = function(t4) {
          var r6 = arguments.length;
          if (1 === r6)
            return this._passThrough(t4, 1, void 0, p2);
          var n4, o3 = new Array(r6 - 1), s3 = 0;
          for (n4 = 0; n4 < r6 - 1; ++n4) {
            var u3 = arguments[n4];
            if (!i2.isObject(u3))
              return e6.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + i2.classString(u3)));
            o3[s3++] = u3;
          }
          o3.length = s3;
          var c3 = arguments[n4];
          return this._passThrough(a2(o3, c3, this), 1, void 0, p2);
        }, u2;
      };
    }, { "./catch_filter": 7, "./util": 36 }], 16: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2, o2, s2) {
        var a2 = t3("./errors").TypeError, u2 = t3("./util"), c2 = u2.errorObj, l2 = u2.tryCatch, f2 = [];
        function h2(t4, r6, i3, o3) {
          if (s2.cancellation()) {
            var a3 = new e6(n3), u3 = this._finallyPromise = new e6(n3);
            this._promise = a3.lastly(function() {
              return u3;
            }), a3._captureStackTrace(), a3._setOnCancel(this);
          } else
            (this._promise = new e6(n3))._captureStackTrace();
          this._stack = o3, this._generatorFunction = t4, this._receiver = r6, this._generator = void 0, this._yieldHandlers = "function" == typeof i3 ? [i3].concat(f2) : f2, this._yieldedPromise = null, this._cancellationPhase = false;
        }
        u2.inherits(h2, o2), h2.prototype._isResolved = function() {
          return null === this._promise;
        }, h2.prototype._cleanup = function() {
          this._promise = this._generator = null, s2.cancellation() && null !== this._finallyPromise && (this._finallyPromise._fulfill(), this._finallyPromise = null);
        }, h2.prototype._promiseCancelled = function() {
          if (!this._isResolved()) {
            var t4;
            if (void 0 !== this._generator.return)
              this._promise._pushContext(), t4 = l2(this._generator.return).call(this._generator, void 0), this._promise._popContext();
            else {
              var r6 = new e6.CancellationError("generator .return() sentinel");
              e6.coroutine.returnSentinel = r6, this._promise._attachExtraTrace(r6), this._promise._pushContext(), t4 = l2(this._generator.throw).call(this._generator, r6), this._promise._popContext();
            }
            this._cancellationPhase = true, this._yieldedPromise = null, this._continue(t4);
          }
        }, h2.prototype._promiseFulfilled = function(t4) {
          this._yieldedPromise = null, this._promise._pushContext();
          var e7 = l2(this._generator.next).call(this._generator, t4);
          this._promise._popContext(), this._continue(e7);
        }, h2.prototype._promiseRejected = function(t4) {
          this._yieldedPromise = null, this._promise._attachExtraTrace(t4), this._promise._pushContext();
          var e7 = l2(this._generator.throw).call(this._generator, t4);
          this._promise._popContext(), this._continue(e7);
        }, h2.prototype._resultCancelled = function() {
          if (this._yieldedPromise instanceof e6) {
            var t4 = this._yieldedPromise;
            this._yieldedPromise = null, t4.cancel();
          }
        }, h2.prototype.promise = function() {
          return this._promise;
        }, h2.prototype._run = function() {
          this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = void 0, this._promiseFulfilled(void 0);
        }, h2.prototype._continue = function(t4) {
          var r6 = this._promise;
          if (t4 === c2)
            return this._cleanup(), this._cancellationPhase ? r6.cancel() : r6._rejectCallback(t4.e, false);
          var n4 = t4.value;
          if (true === t4.done)
            return this._cleanup(), this._cancellationPhase ? r6.cancel() : r6._resolveCallback(n4);
          var o3 = i2(n4, this._promise);
          if (o3 instanceof e6 || null !== (o3 = function(t5, r7, n5) {
            for (var o4 = 0; o4 < r7.length; ++o4) {
              n5._pushContext();
              var s4 = l2(r7[o4])(t5);
              if (n5._popContext(), s4 === c2) {
                n5._pushContext();
                var a3 = e6.reject(c2.e);
                return n5._popContext(), a3;
              }
              var u3 = i2(s4, n5);
              if (u3 instanceof e6)
                return u3;
            }
            return null;
          }(o3, this._yieldHandlers, this._promise))) {
            var s3 = (o3 = o3._target())._bitField;
            0 == (50397184 & s3) ? (this._yieldedPromise = o3, o3._proxy(this, null)) : 0 != (33554432 & s3) ? e6._async.invoke(this._promiseFulfilled, this, o3._value()) : 0 != (16777216 & s3) ? e6._async.invoke(this._promiseRejected, this, o3._reason()) : this._promiseCancelled();
          } else
            this._promiseRejected(new a2("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(n4)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
        }, e6.coroutine = function(t4, e7) {
          if ("function" != typeof t4)
            throw new a2("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
          var r6 = Object(e7).yieldHandler, n4 = h2, i3 = new Error().stack;
          return function() {
            var e8 = t4.apply(this, arguments), o3 = new n4(void 0, void 0, r6, i3), s3 = o3.promise();
            return o3._generator = e8, o3._promiseFulfilled(void 0), s3;
          };
        }, e6.coroutine.addYieldHandler = function(t4) {
          if ("function" != typeof t4)
            throw new a2("expecting a function but got " + u2.classString(t4));
          f2.push(t4);
        }, e6.spawn = function(t4) {
          if (s2.deprecated("Promise.spawn()", "Promise.coroutine()"), "function" != typeof t4)
            return r5("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
          var n4 = new h2(t4, this), i3 = n4.promise();
          return n4._run(e6.spawn), i3;
        };
      };
    }, { "./errors": 12, "./util": 36 }], 17: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2, o2, s2) {
        var a2 = t3("./util");
        a2.canEvaluate, a2.tryCatch, a2.errorObj, e6.join = function() {
          var t4, e7 = arguments.length - 1;
          e7 > 0 && "function" == typeof arguments[e7] && (t4 = arguments[e7]);
          var n4 = [].slice.call(arguments);
          t4 && n4.pop();
          var i3 = new r5(n4).promise();
          return void 0 !== t4 ? i3.spread(t4) : i3;
        };
      };
    }, { "./util": 36 }], 18: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2, o2, s2) {
        var a2 = e6._getDomain, u2 = t3("./util"), c2 = u2.tryCatch, l2 = u2.errorObj, f2 = e6._async;
        function h2(t4, e7, r6, n4) {
          this.constructor$(t4), this._promise._captureStackTrace();
          var i3 = a2();
          this._callback = null === i3 ? e7 : u2.domainBind(i3, e7), this._preservedValues = n4 === o2 ? new Array(this.length()) : null, this._limit = r6, this._inFlight = 0, this._queue = [], f2.invoke(this._asyncInit, this, void 0);
        }
        function p2(t4, r6, i3, o3) {
          if ("function" != typeof r6)
            return n3("expecting a function but got " + u2.classString(r6));
          var s3 = 0;
          if (void 0 !== i3) {
            if ("object" != typeof i3 || null === i3)
              return e6.reject(new TypeError("options argument must be an object but it is " + u2.classString(i3)));
            if ("number" != typeof i3.concurrency)
              return e6.reject(new TypeError("'concurrency' must be a number but it is " + u2.classString(i3.concurrency)));
            s3 = i3.concurrency;
          }
          return new h2(t4, r6, s3 = "number" == typeof s3 && isFinite(s3) && s3 >= 1 ? s3 : 0, o3).promise();
        }
        u2.inherits(h2, r5), h2.prototype._asyncInit = function() {
          this._init$(void 0, -2);
        }, h2.prototype._init = function() {
        }, h2.prototype._promiseFulfilled = function(t4, r6) {
          var n4 = this._values, o3 = this.length(), a3 = this._preservedValues, u3 = this._limit;
          if (r6 < 0) {
            if (n4[r6 = -1 * r6 - 1] = t4, u3 >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved()))
              return true;
          } else {
            if (u3 >= 1 && this._inFlight >= u3)
              return n4[r6] = t4, this._queue.push(r6), false;
            null !== a3 && (a3[r6] = t4);
            var f3 = this._promise, h3 = this._callback, p3 = f3._boundValue();
            f3._pushContext();
            var d2 = c2(h3).call(p3, t4, r6, o3), _2 = f3._popContext();
            if (s2.checkForgottenReturns(d2, _2, null !== a3 ? "Promise.filter" : "Promise.map", f3), d2 === l2)
              return this._reject(d2.e), true;
            var v5 = i2(d2, this._promise);
            if (v5 instanceof e6) {
              var y2 = (v5 = v5._target())._bitField;
              if (0 == (50397184 & y2))
                return u3 >= 1 && this._inFlight++, n4[r6] = v5, v5._proxy(this, -1 * (r6 + 1)), false;
              if (0 == (33554432 & y2))
                return 0 != (16777216 & y2) ? (this._reject(v5._reason()), true) : (this._cancel(), true);
              d2 = v5._value();
            }
            n4[r6] = d2;
          }
          return ++this._totalResolved >= o3 && (null !== a3 ? this._filter(n4, a3) : this._resolve(n4), true);
        }, h2.prototype._drainQueue = function() {
          for (var t4 = this._queue, e7 = this._limit, r6 = this._values; t4.length > 0 && this._inFlight < e7; ) {
            if (this._isResolved())
              return;
            var n4 = t4.pop();
            this._promiseFulfilled(r6[n4], n4);
          }
        }, h2.prototype._filter = function(t4, e7) {
          for (var r6 = e7.length, n4 = new Array(r6), i3 = 0, o3 = 0; o3 < r6; ++o3)
            t4[o3] && (n4[i3++] = e7[o3]);
          n4.length = i3, this._resolve(n4);
        }, h2.prototype.preservedValues = function() {
          return this._preservedValues;
        }, e6.prototype.map = function(t4, e7) {
          return p2(this, t4, e7, null);
        }, e6.map = function(t4, e7, r6, n4) {
          return p2(t4, e7, r6, n4);
        };
      };
    }, { "./util": 36 }], 19: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2, o2) {
        var s2 = t3("./util"), a2 = s2.tryCatch;
        e6.method = function(t4) {
          if ("function" != typeof t4)
            throw new e6.TypeError("expecting a function but got " + s2.classString(t4));
          return function() {
            var n4 = new e6(r5);
            n4._captureStackTrace(), n4._pushContext();
            var i3 = a2(t4).apply(this, arguments), s3 = n4._popContext();
            return o2.checkForgottenReturns(i3, s3, "Promise.method", n4), n4._resolveFromSyncValue(i3), n4;
          };
        }, e6.attempt = e6.try = function(t4) {
          if ("function" != typeof t4)
            return i2("expecting a function but got " + s2.classString(t4));
          var n4, u2 = new e6(r5);
          if (u2._captureStackTrace(), u2._pushContext(), arguments.length > 1) {
            o2.deprecated("calling Promise.try with more than 1 argument");
            var c2 = arguments[1], l2 = arguments[2];
            n4 = s2.isArray(c2) ? a2(t4).apply(l2, c2) : a2(t4).call(l2, c2);
          } else
            n4 = a2(t4)();
          var f2 = u2._popContext();
          return o2.checkForgottenReturns(n4, f2, "Promise.try", u2), u2._resolveFromSyncValue(n4), u2;
        }, e6.prototype._resolveFromSyncValue = function(t4) {
          t4 === s2.errorObj ? this._rejectCallback(t4.e, false) : this._resolveCallback(t4, true);
        };
      };
    }, { "./util": 36 }], 20: [function(t3, e5, r4) {
      var n3 = t3("./util"), i2 = n3.maybeWrapAsError, o2 = t3("./errors").OperationalError, s2 = t3("./es5"), a2 = /^(?:name|message|stack|cause)$/;
      function u2(t4) {
        var e6;
        if (function(t5) {
          return t5 instanceof Error && s2.getPrototypeOf(t5) === Error.prototype;
        }(t4)) {
          (e6 = new o2(t4)).name = t4.name, e6.message = t4.message, e6.stack = t4.stack;
          for (var r5 = s2.keys(t4), i3 = 0; i3 < r5.length; ++i3) {
            var u3 = r5[i3];
            a2.test(u3) || (e6[u3] = t4[u3]);
          }
          return e6;
        }
        return n3.markAsOriginatingFromRejection(t4), t4;
      }
      e5.exports = function(t4, e6) {
        return function(r5, n4) {
          if (null !== t4) {
            if (r5) {
              var o3 = u2(i2(r5));
              t4._attachExtraTrace(o3), t4._reject(o3);
            } else if (e6) {
              var s3 = [].slice.call(arguments, 1);
              t4._fulfill(s3);
            } else
              t4._fulfill(n4);
            t4 = null;
          }
        };
      };
    }, { "./errors": 12, "./es5": 13, "./util": 36 }], 21: [function(t3, e5, r4) {
      e5.exports = function(e6) {
        var r5 = t3("./util"), n3 = e6._async, i2 = r5.tryCatch, o2 = r5.errorObj;
        function s2(t4, e7) {
          if (!r5.isArray(t4))
            return a2.call(this, t4, e7);
          var s3 = i2(e7).apply(this._boundValue(), [null].concat(t4));
          s3 === o2 && n3.throwLater(s3.e);
        }
        function a2(t4, e7) {
          var r6 = this._boundValue(), s3 = void 0 === t4 ? i2(e7).call(r6, null) : i2(e7).call(r6, null, t4);
          s3 === o2 && n3.throwLater(s3.e);
        }
        function u2(t4, e7) {
          if (!t4) {
            var r6 = new Error(t4 + "");
            r6.cause = t4, t4 = r6;
          }
          var s3 = i2(e7).call(this._boundValue(), t4);
          s3 === o2 && n3.throwLater(s3.e);
        }
        e6.prototype.asCallback = e6.prototype.nodeify = function(t4, e7) {
          if ("function" == typeof t4) {
            var r6 = a2;
            void 0 !== e7 && Object(e7).spread && (r6 = s2), this._then(r6, u2, void 0, this, t4);
          }
          return this;
        };
      };
    }, { "./util": 36 }], 22: [function(t3, r4, n3) {
      r4.exports = function() {
        var n4 = function() {
          return new d2("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
        }, i2 = function() {
          return new T2.PromiseInspection(this._target());
        }, o2 = function(t4) {
          return T2.reject(new d2(t4));
        };
        function s2() {
        }
        var a2, u2 = {}, c2 = t3("./util");
        a2 = c2.isNode ? function() {
          var t4 = e4.domain;
          return void 0 === t4 && (t4 = null), t4;
        } : function() {
          return null;
        }, c2.notEnumerableProp(T2, "_getDomain", a2);
        var l2 = t3("./es5"), f2 = t3("./async"), h2 = new f2();
        l2.defineProperty(T2, "_async", { value: h2 });
        var p2 = t3("./errors"), d2 = T2.TypeError = p2.TypeError;
        T2.RangeError = p2.RangeError;
        var _2 = T2.CancellationError = p2.CancellationError;
        T2.TimeoutError = p2.TimeoutError, T2.OperationalError = p2.OperationalError, T2.RejectionError = p2.OperationalError, T2.AggregateError = p2.AggregateError;
        var v5 = function() {
        }, y2 = {}, m2 = {}, g2 = t3("./thenables")(T2, v5), b2 = t3("./promise_array")(T2, v5, g2, o2, s2), w2 = t3("./context")(T2), E3 = w2.create, C2 = t3("./debuggability")(T2, w2), x2 = (C2.CapturedTrace, t3("./finally")(T2, g2, m2)), j2 = t3("./catch_filter")(m2), S2 = t3("./nodeback"), R2 = c2.errorObj, k2 = c2.tryCatch;
        function T2(t4) {
          t4 !== v5 && function(t5, e5) {
            if (null == t5 || t5.constructor !== T2)
              throw new d2("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
            if ("function" != typeof e5)
              throw new d2("expecting a function but got " + c2.classString(e5));
          }(this, t4), this._bitField = 0, this._fulfillmentHandler0 = void 0, this._rejectionHandler0 = void 0, this._promise0 = void 0, this._receiver0 = void 0, this._resolveFromExecutor(t4), this._promiseCreated(), this._fireEvent("promiseCreated", this);
        }
        function P2(t4) {
          this.promise._resolveCallback(t4);
        }
        function O2(t4) {
          this.promise._rejectCallback(t4, false);
        }
        function A2(t4) {
          var e5 = new T2(v5);
          e5._fulfillmentHandler0 = t4, e5._rejectionHandler0 = t4, e5._promise0 = t4, e5._receiver0 = t4;
        }
        return T2.prototype.toString = function() {
          return "[object Promise]";
        }, T2.prototype.caught = T2.prototype.catch = function(t4) {
          var e5 = arguments.length;
          if (e5 > 1) {
            var r5, n5 = new Array(e5 - 1), i3 = 0;
            for (r5 = 0; r5 < e5 - 1; ++r5) {
              var s3 = arguments[r5];
              if (!c2.isObject(s3))
                return o2("Catch statement predicate: expecting an object but got " + c2.classString(s3));
              n5[i3++] = s3;
            }
            return n5.length = i3, t4 = arguments[r5], this.then(void 0, j2(n5, t4, this));
          }
          return this.then(void 0, t4);
        }, T2.prototype.reflect = function() {
          return this._then(i2, i2, void 0, this, void 0);
        }, T2.prototype.then = function(t4, e5) {
          if (C2.warnings() && arguments.length > 0 && "function" != typeof t4 && "function" != typeof e5) {
            var r5 = ".then() only accepts functions but was passed: " + c2.classString(t4);
            arguments.length > 1 && (r5 += ", " + c2.classString(e5)), this._warn(r5);
          }
          return this._then(t4, e5, void 0, void 0, void 0);
        }, T2.prototype.done = function(t4, e5) {
          this._then(t4, e5, void 0, void 0, void 0)._setIsFinal();
        }, T2.prototype.spread = function(t4) {
          return "function" != typeof t4 ? o2("expecting a function but got " + c2.classString(t4)) : this.all()._then(t4, void 0, void 0, y2, void 0);
        }, T2.prototype.toJSON = function() {
          var t4 = { isFulfilled: false, isRejected: false, fulfillmentValue: void 0, rejectionReason: void 0 };
          return this.isFulfilled() ? (t4.fulfillmentValue = this.value(), t4.isFulfilled = true) : this.isRejected() && (t4.rejectionReason = this.reason(), t4.isRejected = true), t4;
        }, T2.prototype.all = function() {
          return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new b2(this).promise();
        }, T2.prototype.error = function(t4) {
          return this.caught(c2.originatesFromRejection, t4);
        }, T2.getNewLibraryCopy = r4.exports, T2.is = function(t4) {
          return t4 instanceof T2;
        }, T2.fromNode = T2.fromCallback = function(t4) {
          var e5 = new T2(v5);
          e5._captureStackTrace();
          var r5 = arguments.length > 1 && !!Object(arguments[1]).multiArgs, n5 = k2(t4)(S2(e5, r5));
          return n5 === R2 && e5._rejectCallback(n5.e, true), e5._isFateSealed() || e5._setAsyncGuaranteed(), e5;
        }, T2.all = function(t4) {
          return new b2(t4).promise();
        }, T2.cast = function(t4) {
          var e5 = g2(t4);
          return e5 instanceof T2 || ((e5 = new T2(v5))._captureStackTrace(), e5._setFulfilled(), e5._rejectionHandler0 = t4), e5;
        }, T2.resolve = T2.fulfilled = T2.cast, T2.reject = T2.rejected = function(t4) {
          var e5 = new T2(v5);
          return e5._captureStackTrace(), e5._rejectCallback(t4, true), e5;
        }, T2.setScheduler = function(t4) {
          if ("function" != typeof t4)
            throw new d2("expecting a function but got " + c2.classString(t4));
          return h2.setScheduler(t4);
        }, T2.prototype._then = function(t4, e5, r5, n5, i3) {
          var o3 = void 0 !== i3, s3 = o3 ? i3 : new T2(v5), u3 = this._target(), l3 = u3._bitField;
          o3 || (s3._propagateFrom(this, 3), s3._captureStackTrace(), void 0 === n5 && 0 != (2097152 & this._bitField) && (n5 = 0 != (50397184 & l3) ? this._boundValue() : u3 === this ? void 0 : this._boundTo), this._fireEvent("promiseChained", this, s3));
          var f3 = a2();
          if (0 != (50397184 & l3)) {
            var p3, d3, y3 = u3._settlePromiseCtx;
            0 != (33554432 & l3) ? (d3 = u3._rejectionHandler0, p3 = t4) : 0 != (16777216 & l3) ? (d3 = u3._fulfillmentHandler0, p3 = e5, u3._unsetRejectionIsUnhandled()) : (y3 = u3._settlePromiseLateCancellationObserver, d3 = new _2("late cancellation observer"), u3._attachExtraTrace(d3), p3 = e5), h2.invoke(y3, u3, { handler: null === f3 ? p3 : "function" == typeof p3 && c2.domainBind(f3, p3), promise: s3, receiver: n5, value: d3 });
          } else
            u3._addCallbacks(t4, e5, s3, n5, f3);
          return s3;
        }, T2.prototype._length = function() {
          return 65535 & this._bitField;
        }, T2.prototype._isFateSealed = function() {
          return 0 != (117506048 & this._bitField);
        }, T2.prototype._isFollowing = function() {
          return 67108864 == (67108864 & this._bitField);
        }, T2.prototype._setLength = function(t4) {
          this._bitField = -65536 & this._bitField | 65535 & t4;
        }, T2.prototype._setFulfilled = function() {
          this._bitField = 33554432 | this._bitField, this._fireEvent("promiseFulfilled", this);
        }, T2.prototype._setRejected = function() {
          this._bitField = 16777216 | this._bitField, this._fireEvent("promiseRejected", this);
        }, T2.prototype._setFollowing = function() {
          this._bitField = 67108864 | this._bitField, this._fireEvent("promiseResolved", this);
        }, T2.prototype._setIsFinal = function() {
          this._bitField = 4194304 | this._bitField;
        }, T2.prototype._isFinal = function() {
          return (4194304 & this._bitField) > 0;
        }, T2.prototype._unsetCancelled = function() {
          this._bitField = -65537 & this._bitField;
        }, T2.prototype._setCancelled = function() {
          this._bitField = 65536 | this._bitField, this._fireEvent("promiseCancelled", this);
        }, T2.prototype._setWillBeCancelled = function() {
          this._bitField = 8388608 | this._bitField;
        }, T2.prototype._setAsyncGuaranteed = function() {
          h2.hasCustomScheduler() || (this._bitField = 134217728 | this._bitField);
        }, T2.prototype._receiverAt = function(t4) {
          var e5 = 0 === t4 ? this._receiver0 : this[4 * t4 - 4 + 3];
          if (e5 !== u2)
            return void 0 === e5 && this._isBound() ? this._boundValue() : e5;
        }, T2.prototype._promiseAt = function(t4) {
          return this[4 * t4 - 4 + 2];
        }, T2.prototype._fulfillmentHandlerAt = function(t4) {
          return this[4 * t4 - 4 + 0];
        }, T2.prototype._rejectionHandlerAt = function(t4) {
          return this[4 * t4 - 4 + 1];
        }, T2.prototype._boundValue = function() {
        }, T2.prototype._migrateCallback0 = function(t4) {
          t4._bitField;
          var e5 = t4._fulfillmentHandler0, r5 = t4._rejectionHandler0, n5 = t4._promise0, i3 = t4._receiverAt(0);
          void 0 === i3 && (i3 = u2), this._addCallbacks(e5, r5, n5, i3, null);
        }, T2.prototype._migrateCallbackAt = function(t4, e5) {
          var r5 = t4._fulfillmentHandlerAt(e5), n5 = t4._rejectionHandlerAt(e5), i3 = t4._promiseAt(e5), o3 = t4._receiverAt(e5);
          void 0 === o3 && (o3 = u2), this._addCallbacks(r5, n5, i3, o3, null);
        }, T2.prototype._addCallbacks = function(t4, e5, r5, n5, i3) {
          var o3 = this._length();
          if (o3 >= 65531 && (o3 = 0, this._setLength(0)), 0 === o3)
            this._promise0 = r5, this._receiver0 = n5, "function" == typeof t4 && (this._fulfillmentHandler0 = null === i3 ? t4 : c2.domainBind(i3, t4)), "function" == typeof e5 && (this._rejectionHandler0 = null === i3 ? e5 : c2.domainBind(i3, e5));
          else {
            var s3 = 4 * o3 - 4;
            this[s3 + 2] = r5, this[s3 + 3] = n5, "function" == typeof t4 && (this[s3 + 0] = null === i3 ? t4 : c2.domainBind(i3, t4)), "function" == typeof e5 && (this[s3 + 1] = null === i3 ? e5 : c2.domainBind(i3, e5));
          }
          return this._setLength(o3 + 1), o3;
        }, T2.prototype._proxy = function(t4, e5) {
          this._addCallbacks(void 0, void 0, e5, t4, null);
        }, T2.prototype._resolveCallback = function(t4, e5) {
          if (0 == (117506048 & this._bitField)) {
            if (t4 === this)
              return this._rejectCallback(n4(), false);
            var r5 = g2(t4, this);
            if (!(r5 instanceof T2))
              return this._fulfill(t4);
            e5 && this._propagateFrom(r5, 2);
            var i3 = r5._target();
            if (i3 !== this) {
              var o3 = i3._bitField;
              if (0 == (50397184 & o3)) {
                var s3 = this._length();
                s3 > 0 && i3._migrateCallback0(this);
                for (var a3 = 1; a3 < s3; ++a3)
                  i3._migrateCallbackAt(this, a3);
                this._setFollowing(), this._setLength(0), this._setFollowee(i3);
              } else if (0 != (33554432 & o3))
                this._fulfill(i3._value());
              else if (0 != (16777216 & o3))
                this._reject(i3._reason());
              else {
                var u3 = new _2("late cancellation observer");
                i3._attachExtraTrace(u3), this._reject(u3);
              }
            } else
              this._reject(n4());
          }
        }, T2.prototype._rejectCallback = function(t4, e5, r5) {
          var n5 = c2.ensureErrorObject(t4), i3 = n5 === t4;
          if (!i3 && !r5 && C2.warnings()) {
            var o3 = "a promise was rejected with a non-error: " + c2.classString(t4);
            this._warn(o3, true);
          }
          this._attachExtraTrace(n5, !!e5 && i3), this._reject(t4);
        }, T2.prototype._resolveFromExecutor = function(t4) {
          if (t4 !== v5) {
            var e5 = this;
            this._captureStackTrace(), this._pushContext();
            var r5 = true, n5 = this._execute(t4, function(t5) {
              e5._resolveCallback(t5);
            }, function(t5) {
              e5._rejectCallback(t5, r5);
            });
            r5 = false, this._popContext(), void 0 !== n5 && e5._rejectCallback(n5, true);
          }
        }, T2.prototype._settlePromiseFromHandler = function(t4, e5, r5, n5) {
          var i3 = n5._bitField;
          if (0 == (65536 & i3)) {
            var o3;
            n5._pushContext(), e5 === y2 ? r5 && "number" == typeof r5.length ? o3 = k2(t4).apply(this._boundValue(), r5) : (o3 = R2).e = new d2("cannot .spread() a non-array: " + c2.classString(r5)) : o3 = k2(t4).call(e5, r5);
            var s3 = n5._popContext();
            0 == (65536 & (i3 = n5._bitField)) && (o3 === m2 ? n5._reject(r5) : o3 === R2 ? n5._rejectCallback(o3.e, false) : (C2.checkForgottenReturns(o3, s3, "", n5, this), n5._resolveCallback(o3)));
          }
        }, T2.prototype._target = function() {
          for (var t4 = this; t4._isFollowing(); )
            t4 = t4._followee();
          return t4;
        }, T2.prototype._followee = function() {
          return this._rejectionHandler0;
        }, T2.prototype._setFollowee = function(t4) {
          this._rejectionHandler0 = t4;
        }, T2.prototype._settlePromise = function(t4, e5, r5, n5) {
          var o3 = t4 instanceof T2, a3 = this._bitField, u3 = 0 != (134217728 & a3);
          0 != (65536 & a3) ? (o3 && t4._invokeInternalOnCancel(), r5 instanceof x2 && r5.isFinallyHandler() ? (r5.cancelPromise = t4, k2(e5).call(r5, n5) === R2 && t4._reject(R2.e)) : e5 === i2 ? t4._fulfill(i2.call(r5)) : r5 instanceof s2 ? r5._promiseCancelled(t4) : o3 || t4 instanceof b2 ? t4._cancel() : r5.cancel()) : "function" == typeof e5 ? o3 ? (u3 && t4._setAsyncGuaranteed(), this._settlePromiseFromHandler(e5, r5, n5, t4)) : e5.call(r5, n5, t4) : r5 instanceof s2 ? r5._isResolved() || (0 != (33554432 & a3) ? r5._promiseFulfilled(n5, t4) : r5._promiseRejected(n5, t4)) : o3 && (u3 && t4._setAsyncGuaranteed(), 0 != (33554432 & a3) ? t4._fulfill(n5) : t4._reject(n5));
        }, T2.prototype._settlePromiseLateCancellationObserver = function(t4) {
          var e5 = t4.handler, r5 = t4.promise, n5 = t4.receiver, i3 = t4.value;
          "function" == typeof e5 ? r5 instanceof T2 ? this._settlePromiseFromHandler(e5, n5, i3, r5) : e5.call(n5, i3, r5) : r5 instanceof T2 && r5._reject(i3);
        }, T2.prototype._settlePromiseCtx = function(t4) {
          this._settlePromise(t4.promise, t4.handler, t4.receiver, t4.value);
        }, T2.prototype._settlePromise0 = function(t4, e5, r5) {
          var n5 = this._promise0, i3 = this._receiverAt(0);
          this._promise0 = void 0, this._receiver0 = void 0, this._settlePromise(n5, t4, i3, e5);
        }, T2.prototype._clearCallbackDataAtIndex = function(t4) {
          var e5 = 4 * t4 - 4;
          this[e5 + 2] = this[e5 + 3] = this[e5 + 0] = this[e5 + 1] = void 0;
        }, T2.prototype._fulfill = function(t4) {
          var e5 = this._bitField;
          if (!((117506048 & e5) >>> 16)) {
            if (t4 === this) {
              var r5 = n4();
              return this._attachExtraTrace(r5), this._reject(r5);
            }
            this._setFulfilled(), this._rejectionHandler0 = t4, (65535 & e5) > 0 && (0 != (134217728 & e5) ? this._settlePromises() : h2.settlePromises(this));
          }
        }, T2.prototype._reject = function(t4) {
          var e5 = this._bitField;
          if (!((117506048 & e5) >>> 16)) {
            if (this._setRejected(), this._fulfillmentHandler0 = t4, this._isFinal())
              return h2.fatalError(t4, c2.isNode);
            (65535 & e5) > 0 ? h2.settlePromises(this) : this._ensurePossibleRejectionHandled();
          }
        }, T2.prototype._fulfillPromises = function(t4, e5) {
          for (var r5 = 1; r5 < t4; r5++) {
            var n5 = this._fulfillmentHandlerAt(r5), i3 = this._promiseAt(r5), o3 = this._receiverAt(r5);
            this._clearCallbackDataAtIndex(r5), this._settlePromise(i3, n5, o3, e5);
          }
        }, T2.prototype._rejectPromises = function(t4, e5) {
          for (var r5 = 1; r5 < t4; r5++) {
            var n5 = this._rejectionHandlerAt(r5), i3 = this._promiseAt(r5), o3 = this._receiverAt(r5);
            this._clearCallbackDataAtIndex(r5), this._settlePromise(i3, n5, o3, e5);
          }
        }, T2.prototype._settlePromises = function() {
          var t4 = this._bitField, e5 = 65535 & t4;
          if (e5 > 0) {
            if (0 != (16842752 & t4)) {
              var r5 = this._fulfillmentHandler0;
              this._settlePromise0(this._rejectionHandler0, r5, t4), this._rejectPromises(e5, r5);
            } else {
              var n5 = this._rejectionHandler0;
              this._settlePromise0(this._fulfillmentHandler0, n5, t4), this._fulfillPromises(e5, n5);
            }
            this._setLength(0);
          }
          this._clearCancellationData();
        }, T2.prototype._settledValue = function() {
          var t4 = this._bitField;
          return 0 != (33554432 & t4) ? this._rejectionHandler0 : 0 != (16777216 & t4) ? this._fulfillmentHandler0 : void 0;
        }, T2.defer = T2.pending = function() {
          return C2.deprecated("Promise.defer", "new Promise"), { promise: new T2(v5), resolve: P2, reject: O2 };
        }, c2.notEnumerableProp(T2, "_makeSelfResolutionError", n4), t3("./method")(T2, v5, g2, o2, C2), t3("./bind")(T2, v5, g2, C2), t3("./cancel")(T2, b2, o2, C2), t3("./direct_resolve")(T2), t3("./synchronous_inspection")(T2), t3("./join")(T2, b2, g2, v5, h2, a2), T2.Promise = T2, T2.version = "3.5.1", t3("./map.js")(T2, b2, o2, g2, v5, C2), t3("./call_get.js")(T2), t3("./using.js")(T2, o2, g2, E3, v5, C2), t3("./timers.js")(T2, v5, C2), t3("./generators.js")(T2, o2, v5, g2, s2, C2), t3("./nodeify.js")(T2), t3("./promisify.js")(T2, v5), t3("./props.js")(T2, b2, g2, o2), t3("./race.js")(T2, v5, g2, o2), t3("./reduce.js")(T2, b2, o2, g2, v5, C2), t3("./settle.js")(T2, b2, C2), t3("./some.js")(T2, b2, o2), t3("./filter.js")(T2, v5), t3("./each.js")(T2, v5), t3("./any.js")(T2), c2.toFastProperties(T2), c2.toFastProperties(T2.prototype), A2({ a: 1 }), A2({ b: 2 }), A2({ c: 3 }), A2(1), A2(function() {
        }), A2(void 0), A2(false), A2(new T2(v5)), C2.setBounds(f2.firstLineError, c2.lastLineError), T2;
      };
    }, { "./any.js": 1, "./async": 2, "./bind": 3, "./call_get.js": 5, "./cancel": 6, "./catch_filter": 7, "./context": 8, "./debuggability": 9, "./direct_resolve": 10, "./each.js": 11, "./errors": 12, "./es5": 13, "./filter.js": 14, "./finally": 15, "./generators.js": 16, "./join": 17, "./map.js": 18, "./method": 19, "./nodeback": 20, "./nodeify.js": 21, "./promise_array": 23, "./promisify.js": 24, "./props.js": 25, "./race.js": 27, "./reduce.js": 28, "./settle.js": 30, "./some.js": 31, "./synchronous_inspection": 32, "./thenables": 33, "./timers.js": 34, "./using.js": 35, "./util": 36 }], 23: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2, o2) {
        var s2 = t3("./util");
        function a2(t4) {
          var n4 = this._promise = new e6(r5);
          t4 instanceof e6 && n4._propagateFrom(t4, 3), n4._setOnCancel(this), this._values = t4, this._length = 0, this._totalResolved = 0, this._init(void 0, -2);
        }
        return s2.isArray, s2.inherits(a2, o2), a2.prototype.length = function() {
          return this._length;
        }, a2.prototype.promise = function() {
          return this._promise;
        }, a2.prototype._init = function t4(r6, o3) {
          var a3 = n3(this._values, this._promise);
          if (a3 instanceof e6) {
            var u2 = (a3 = a3._target())._bitField;
            if (this._values = a3, 0 == (50397184 & u2))
              return this._promise._setAsyncGuaranteed(), a3._then(t4, this._reject, void 0, this, o3);
            if (0 == (33554432 & u2))
              return 0 != (16777216 & u2) ? this._reject(a3._reason()) : this._cancel();
            a3 = a3._value();
          }
          if (null !== (a3 = s2.asArray(a3)))
            0 !== a3.length ? this._iterate(a3) : -5 === o3 ? this._resolveEmptyArray() : this._resolve(function(t5) {
              switch (o3) {
                case -2:
                  return [];
                case -3:
                  return {};
                case -6:
                  return /* @__PURE__ */ new Map();
              }
            }());
          else {
            var c2 = i2("expecting an array or an iterable object but got " + s2.classString(a3)).reason();
            this._promise._rejectCallback(c2, false);
          }
        }, a2.prototype._iterate = function(t4) {
          var r6 = this.getActualLength(t4.length);
          this._length = r6, this._values = this.shouldCopyValues() ? new Array(r6) : this._values;
          for (var i3 = this._promise, o3 = false, s3 = null, a3 = 0; a3 < r6; ++a3) {
            var u2 = n3(t4[a3], i3);
            s3 = u2 instanceof e6 ? (u2 = u2._target())._bitField : null, o3 ? null !== s3 && u2.suppressUnhandledRejections() : null !== s3 ? 0 == (50397184 & s3) ? (u2._proxy(this, a3), this._values[a3] = u2) : o3 = 0 != (33554432 & s3) ? this._promiseFulfilled(u2._value(), a3) : 0 != (16777216 & s3) ? this._promiseRejected(u2._reason(), a3) : this._promiseCancelled(a3) : o3 = this._promiseFulfilled(u2, a3);
          }
          o3 || i3._setAsyncGuaranteed();
        }, a2.prototype._isResolved = function() {
          return null === this._values;
        }, a2.prototype._resolve = function(t4) {
          this._values = null, this._promise._fulfill(t4);
        }, a2.prototype._cancel = function() {
          !this._isResolved() && this._promise._isCancellable() && (this._values = null, this._promise._cancel());
        }, a2.prototype._reject = function(t4) {
          this._values = null, this._promise._rejectCallback(t4, false);
        }, a2.prototype._promiseFulfilled = function(t4, e7) {
          return this._values[e7] = t4, ++this._totalResolved >= this._length && (this._resolve(this._values), true);
        }, a2.prototype._promiseCancelled = function() {
          return this._cancel(), true;
        }, a2.prototype._promiseRejected = function(t4) {
          return this._totalResolved++, this._reject(t4), true;
        }, a2.prototype._resultCancelled = function() {
          if (!this._isResolved()) {
            var t4 = this._values;
            if (this._cancel(), t4 instanceof e6)
              t4.cancel();
            else
              for (var r6 = 0; r6 < t4.length; ++r6)
                t4[r6] instanceof e6 && t4[r6].cancel();
          }
        }, a2.prototype.shouldCopyValues = function() {
          return true;
        }, a2.prototype.getActualLength = function(t4) {
          return t4;
        }, a2;
      };
    }, { "./util": 36 }], 24: [function(t3, e5, r4) {
      e5.exports = function(e6, r5) {
        var n3 = {}, i2 = t3("./util"), o2 = t3("./nodeback"), s2 = i2.withAppended, a2 = i2.maybeWrapAsError, u2 = i2.canEvaluate, c2 = t3("./errors").TypeError, l2 = { __isPromisified__: true }, f2 = new RegExp("^(?:" + ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"].join("|") + ")$"), h2 = function(t4) {
          return i2.isIdentifier(t4) && "_" !== t4.charAt(0) && "constructor" !== t4;
        };
        function p2(t4) {
          return !f2.test(t4);
        }
        function d2(t4) {
          try {
            return true === t4.__isPromisified__;
          } catch (t5) {
            return false;
          }
        }
        function _2(t4, e7, r6) {
          var n4 = i2.getDataPropertyOrDefault(t4, e7 + r6, l2);
          return !!n4 && d2(n4);
        }
        function v5(t4, e7, r6, n4) {
          for (var o3 = i2.inheritedDataKeys(t4), s3 = [], a3 = 0; a3 < o3.length; ++a3) {
            var u3 = o3[a3], l3 = t4[u3], f3 = n4 === h2 || h2(u3);
            "function" != typeof l3 || d2(l3) || _2(t4, u3, e7) || !n4(u3, l3, t4, f3) || s3.push(u3, l3);
          }
          return function(t5, e8, r7) {
            for (var n5 = 0; n5 < t5.length; n5 += 2) {
              var i3 = t5[n5];
              if (r7.test(i3)) {
                for (var o4 = i3.replace(r7, ""), s4 = 0; s4 < t5.length; s4 += 2)
                  if (t5[s4] === o4)
                    throw new c2("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", e8));
              }
            }
          }(s3, e7, r6), s3;
        }
        var y2 = function(t4) {
          return t4.replace(/([$])/, "\\$");
        }, m2 = u2 ? void 0 : function(t4, u3, c3, l3, f3, h3) {
          var p3 = function() {
            return this;
          }(), d3 = t4;
          function _3() {
            var i3 = u3;
            u3 === n3 && (i3 = this);
            var c4 = new e6(r5);
            c4._captureStackTrace();
            var l4 = "string" == typeof d3 && this !== p3 ? this[d3] : t4, f4 = o2(c4, h3);
            try {
              l4.apply(i3, s2(arguments, f4));
            } catch (t5) {
              c4._rejectCallback(a2(t5), true, true);
            }
            return c4._isFateSealed() || c4._setAsyncGuaranteed(), c4;
          }
          return "string" == typeof d3 && (t4 = l3), i2.notEnumerableProp(_3, "__isPromisified__", true), _3;
        };
        function g2(t4, e7, r6, o3, s3) {
          for (var a3 = new RegExp(y2(e7) + "$"), u3 = v5(t4, e7, a3, r6), c3 = 0, l3 = u3.length; c3 < l3; c3 += 2) {
            var f3 = u3[c3], h3 = u3[c3 + 1], p3 = f3 + e7;
            if (o3 === m2)
              t4[p3] = m2(f3, n3, f3, h3, e7, s3);
            else {
              var d3 = o3(h3, function() {
                return m2(f3, n3, f3, h3, e7, s3);
              });
              i2.notEnumerableProp(d3, "__isPromisified__", true), t4[p3] = d3;
            }
          }
          return i2.toFastProperties(t4), t4;
        }
        e6.promisify = function(t4, e7) {
          if ("function" != typeof t4)
            throw new c2("expecting a function but got " + i2.classString(t4));
          if (d2(t4))
            return t4;
          var r6 = void 0 === (e7 = Object(e7)).context ? n3 : e7.context, o3 = !!e7.multiArgs, s3 = function(t5, e8, r7) {
            return m2(t5, e8, void 0, t5, null, o3);
          }(t4, r6);
          return i2.copyDescriptors(t4, s3, p2), s3;
        }, e6.promisifyAll = function(t4, e7) {
          if ("function" != typeof t4 && "object" != typeof t4)
            throw new c2("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
          var r6 = !!(e7 = Object(e7)).multiArgs, n4 = e7.suffix;
          "string" != typeof n4 && (n4 = "Async");
          var o3 = e7.filter;
          "function" != typeof o3 && (o3 = h2);
          var s3 = e7.promisifier;
          if ("function" != typeof s3 && (s3 = m2), !i2.isIdentifier(n4))
            throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
          for (var a3 = i2.inheritedDataKeys(t4), u3 = 0; u3 < a3.length; ++u3) {
            var l3 = t4[a3[u3]];
            "constructor" !== a3[u3] && i2.isClass(l3) && (g2(l3.prototype, n4, o3, s3, r6), g2(l3, n4, o3, s3, r6));
          }
          return g2(t4, n4, o3, s3, r6);
        };
      };
    }, { "./errors": 12, "./nodeback": 20, "./util": 36 }], 25: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2) {
        var o2, s2 = t3("./util"), a2 = s2.isObject, u2 = t3("./es5");
        "function" == typeof Map && (o2 = Map);
        var c2 = function() {
          var t4 = 0, e7 = 0;
          function r6(r7, n4) {
            this[t4] = r7, this[t4 + e7] = n4, t4++;
          }
          return function(n4) {
            e7 = n4.size, t4 = 0;
            var i3 = new Array(2 * n4.size);
            return n4.forEach(r6, i3), i3;
          };
        }();
        function l2(t4) {
          var e7, r6 = false;
          if (void 0 !== o2 && t4 instanceof o2)
            e7 = c2(t4), r6 = true;
          else {
            var n4 = u2.keys(t4), i3 = n4.length;
            e7 = new Array(2 * i3);
            for (var s3 = 0; s3 < i3; ++s3) {
              var a3 = n4[s3];
              e7[s3] = t4[a3], e7[s3 + i3] = a3;
            }
          }
          this.constructor$(e7), this._isMap = r6, this._init$(void 0, r6 ? -6 : -3);
        }
        function f2(t4) {
          var r6, o3 = n3(t4);
          return a2(o3) ? (r6 = o3 instanceof e6 ? o3._then(e6.props, void 0, void 0, void 0, void 0) : new l2(o3).promise(), o3 instanceof e6 && r6._propagateFrom(o3, 2), r6) : i2("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
        }
        s2.inherits(l2, r5), l2.prototype._init = function() {
        }, l2.prototype._promiseFulfilled = function(t4, e7) {
          if (this._values[e7] = t4, ++this._totalResolved >= this._length) {
            var r6;
            if (this._isMap)
              r6 = function(t5) {
                for (var e8 = new o2(), r7 = t5.length / 2 | 0, n5 = 0; n5 < r7; ++n5) {
                  var i4 = t5[r7 + n5], s4 = t5[n5];
                  e8.set(i4, s4);
                }
                return e8;
              }(this._values);
            else {
              r6 = {};
              for (var n4 = this.length(), i3 = 0, s3 = this.length(); i3 < s3; ++i3)
                r6[this._values[i3 + n4]] = this._values[i3];
            }
            return this._resolve(r6), true;
          }
          return false;
        }, l2.prototype.shouldCopyValues = function() {
          return false;
        }, l2.prototype.getActualLength = function(t4) {
          return t4 >> 1;
        }, e6.prototype.props = function() {
          return f2(this);
        }, e6.props = function(t4) {
          return f2(t4);
        };
      };
    }, { "./es5": 13, "./util": 36 }], 26: [function(t3, e5, r4) {
      function n3(t4) {
        this._capacity = t4, this._length = 0, this._front = 0;
      }
      n3.prototype._willBeOverCapacity = function(t4) {
        return this._capacity < t4;
      }, n3.prototype._pushOne = function(t4) {
        var e6 = this.length();
        this._checkCapacity(e6 + 1), this[this._front + e6 & this._capacity - 1] = t4, this._length = e6 + 1;
      }, n3.prototype.push = function(t4, e6, r5) {
        var n4 = this.length() + 3;
        if (this._willBeOverCapacity(n4))
          return this._pushOne(t4), this._pushOne(e6), void this._pushOne(r5);
        var i2 = this._front + n4 - 3;
        this._checkCapacity(n4);
        var o2 = this._capacity - 1;
        this[i2 + 0 & o2] = t4, this[i2 + 1 & o2] = e6, this[i2 + 2 & o2] = r5, this._length = n4;
      }, n3.prototype.shift = function() {
        var t4 = this._front, e6 = this[t4];
        return this[t4] = void 0, this._front = t4 + 1 & this._capacity - 1, this._length--, e6;
      }, n3.prototype.length = function() {
        return this._length;
      }, n3.prototype._checkCapacity = function(t4) {
        this._capacity < t4 && this._resizeTo(this._capacity << 1);
      }, n3.prototype._resizeTo = function(t4) {
        var e6 = this._capacity;
        this._capacity = t4, function(t5, e7, r5, n4, i2) {
          for (var o2 = 0; o2 < i2; ++o2)
            r5[o2 + n4] = t5[o2 + 0], t5[o2 + 0] = void 0;
        }(this, 0, this, e6, this._front + this._length & e6 - 1);
      }, e5.exports = n3;
    }, {}], 27: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2) {
        var o2 = t3("./util"), s2 = function(t4) {
          return t4.then(function(e7) {
            return a2(e7, t4);
          });
        };
        function a2(t4, a3) {
          var u2 = n3(t4);
          if (u2 instanceof e6)
            return s2(u2);
          if (null === (t4 = o2.asArray(t4)))
            return i2("expecting an array or an iterable object but got " + o2.classString(t4));
          var c2 = new e6(r5);
          void 0 !== a3 && c2._propagateFrom(a3, 3);
          for (var l2 = c2._fulfill, f2 = c2._reject, h2 = 0, p2 = t4.length; h2 < p2; ++h2) {
            var d2 = t4[h2];
            (void 0 !== d2 || h2 in t4) && e6.cast(d2)._then(l2, f2, void 0, c2, null);
          }
          return c2;
        }
        e6.race = function(t4) {
          return a2(t4, void 0);
        }, e6.prototype.race = function() {
          return a2(this, void 0);
        };
      };
    }, { "./util": 36 }], 28: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2, o2, s2) {
        var a2 = e6._getDomain, u2 = t3("./util"), c2 = u2.tryCatch;
        function l2(t4, r6, n4, i3) {
          this.constructor$(t4);
          var s3 = a2();
          this._fn = null === s3 ? r6 : u2.domainBind(s3, r6), void 0 !== n4 && (n4 = e6.resolve(n4))._attachCancellationCallback(this), this._initialValue = n4, this._currentCancellable = null, this._eachValues = i3 === o2 ? Array(this._length) : 0 === i3 ? null : void 0, this._promise._captureStackTrace(), this._init$(void 0, -5);
        }
        function f2(t4, e7) {
          this.isFulfilled() ? e7._resolve(t4) : e7._reject(t4);
        }
        function h2(t4, e7, r6, i3) {
          return "function" != typeof e7 ? n3("expecting a function but got " + u2.classString(e7)) : new l2(t4, e7, r6, i3).promise();
        }
        function p2(t4) {
          this.accum = t4, this.array._gotAccum(t4);
          var r6 = i2(this.value, this.array._promise);
          return r6 instanceof e6 ? (this.array._currentCancellable = r6, r6._then(d2, void 0, void 0, this, void 0)) : d2.call(this, r6);
        }
        function d2(t4) {
          var r6, n4 = this.array, i3 = n4._promise, o3 = c2(n4._fn);
          i3._pushContext(), (r6 = void 0 !== n4._eachValues ? o3.call(i3._boundValue(), t4, this.index, this.length) : o3.call(i3._boundValue(), this.accum, t4, this.index, this.length)) instanceof e6 && (n4._currentCancellable = r6);
          var a3 = i3._popContext();
          return s2.checkForgottenReturns(r6, a3, void 0 !== n4._eachValues ? "Promise.each" : "Promise.reduce", i3), r6;
        }
        u2.inherits(l2, r5), l2.prototype._gotAccum = function(t4) {
          void 0 !== this._eachValues && null !== this._eachValues && t4 !== o2 && this._eachValues.push(t4);
        }, l2.prototype._eachComplete = function(t4) {
          return null !== this._eachValues && this._eachValues.push(t4), this._eachValues;
        }, l2.prototype._init = function() {
        }, l2.prototype._resolveEmptyArray = function() {
          this._resolve(void 0 !== this._eachValues ? this._eachValues : this._initialValue);
        }, l2.prototype.shouldCopyValues = function() {
          return false;
        }, l2.prototype._resolve = function(t4) {
          this._promise._resolveCallback(t4), this._values = null;
        }, l2.prototype._resultCancelled = function(t4) {
          if (t4 === this._initialValue)
            return this._cancel();
          this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof e6 && this._currentCancellable.cancel(), this._initialValue instanceof e6 && this._initialValue.cancel());
        }, l2.prototype._iterate = function(t4) {
          var r6, n4;
          this._values = t4;
          var i3 = t4.length;
          if (void 0 !== this._initialValue ? (r6 = this._initialValue, n4 = 0) : (r6 = e6.resolve(t4[0]), n4 = 1), this._currentCancellable = r6, !r6.isRejected())
            for (; n4 < i3; ++n4) {
              var o3 = { accum: null, value: t4[n4], index: n4, length: i3, array: this };
              r6 = r6._then(p2, void 0, void 0, o3, void 0);
            }
          void 0 !== this._eachValues && (r6 = r6._then(this._eachComplete, void 0, void 0, this, void 0)), r6._then(f2, f2, void 0, r6, this);
        }, e6.prototype.reduce = function(t4, e7) {
          return h2(this, t4, e7, null);
        }, e6.reduce = function(t4, e7, r6, n4) {
          return h2(t4, e7, r6, n4);
        };
      };
    }, { "./util": 36 }], 29: [function(t3, i2, o2) {
      var s2, a2 = t3("./util"), u2 = a2.getNativePromise();
      if (a2.isNode && "undefined" == typeof MutationObserver) {
        var c2 = r3.setImmediate, l2 = e4.nextTick;
        s2 = a2.isRecentNode ? function(t4) {
          c2.call(r3, t4);
        } : function(t4) {
          l2.call(e4, t4);
        };
      } else if ("function" == typeof u2 && "function" == typeof u2.resolve) {
        var f2 = u2.resolve();
        s2 = function(t4) {
          f2.then(t4);
        };
      } else
        s2 = "undefined" == typeof MutationObserver || "undefined" != typeof window && window.navigator && (window.navigator.standalone || window.cordova) ? void 0 !== n2 ? function(t4) {
          n2(t4);
        } : "undefined" != typeof setTimeout ? function(t4) {
          setTimeout(t4, 0);
        } : function() {
          throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
        } : function() {
          var t4 = document.createElement("div"), e5 = { attributes: true }, r4 = false, n3 = document.createElement("div");
          return new MutationObserver(function() {
            t4.classList.toggle("foo"), r4 = false;
          }).observe(n3, e5), function(i3) {
            var o3 = new MutationObserver(function() {
              o3.disconnect(), i3();
            });
            o3.observe(t4, e5), r4 || (r4 = true, n3.classList.toggle("foo"));
          };
        }();
      i2.exports = s2;
    }, { "./util": 36 }], 30: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3) {
        var i2 = e6.PromiseInspection;
        function o2(t4) {
          this.constructor$(t4);
        }
        t3("./util").inherits(o2, r5), o2.prototype._promiseResolved = function(t4, e7) {
          return this._values[t4] = e7, ++this._totalResolved >= this._length && (this._resolve(this._values), true);
        }, o2.prototype._promiseFulfilled = function(t4, e7) {
          var r6 = new i2();
          return r6._bitField = 33554432, r6._settledValueField = t4, this._promiseResolved(e7, r6);
        }, o2.prototype._promiseRejected = function(t4, e7) {
          var r6 = new i2();
          return r6._bitField = 16777216, r6._settledValueField = t4, this._promiseResolved(e7, r6);
        }, e6.settle = function(t4) {
          return n3.deprecated(".settle()", ".reflect()"), new o2(t4).promise();
        }, e6.prototype.settle = function() {
          return e6.settle(this);
        };
      };
    }, { "./util": 36 }], 31: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3) {
        var i2 = t3("./util"), o2 = t3("./errors").RangeError, s2 = t3("./errors").AggregateError, a2 = i2.isArray, u2 = {};
        function c2(t4) {
          this.constructor$(t4), this._howMany = 0, this._unwrap = false, this._initialized = false;
        }
        function l2(t4, e7) {
          if ((0 | e7) !== e7 || e7 < 0)
            return n3("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
          var r6 = new c2(t4), i3 = r6.promise();
          return r6.setHowMany(e7), r6.init(), i3;
        }
        i2.inherits(c2, r5), c2.prototype._init = function() {
          if (this._initialized)
            if (0 !== this._howMany) {
              this._init$(void 0, -5);
              var t4 = a2(this._values);
              !this._isResolved() && t4 && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()));
            } else
              this._resolve([]);
        }, c2.prototype.init = function() {
          this._initialized = true, this._init();
        }, c2.prototype.setUnwrap = function() {
          this._unwrap = true;
        }, c2.prototype.howMany = function() {
          return this._howMany;
        }, c2.prototype.setHowMany = function(t4) {
          this._howMany = t4;
        }, c2.prototype._promiseFulfilled = function(t4) {
          return this._addFulfilled(t4), this._fulfilled() === this.howMany() && (this._values.length = this.howMany(), 1 === this.howMany() && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), true);
        }, c2.prototype._promiseRejected = function(t4) {
          return this._addRejected(t4), this._checkOutcome();
        }, c2.prototype._promiseCancelled = function() {
          return this._values instanceof e6 || null == this._values ? this._cancel() : (this._addRejected(u2), this._checkOutcome());
        }, c2.prototype._checkOutcome = function() {
          if (this.howMany() > this._canPossiblyFulfill()) {
            for (var t4 = new s2(), e7 = this.length(); e7 < this._values.length; ++e7)
              this._values[e7] !== u2 && t4.push(this._values[e7]);
            return t4.length > 0 ? this._reject(t4) : this._cancel(), true;
          }
          return false;
        }, c2.prototype._fulfilled = function() {
          return this._totalResolved;
        }, c2.prototype._rejected = function() {
          return this._values.length - this.length();
        }, c2.prototype._addRejected = function(t4) {
          this._values.push(t4);
        }, c2.prototype._addFulfilled = function(t4) {
          this._values[this._totalResolved++] = t4;
        }, c2.prototype._canPossiblyFulfill = function() {
          return this.length() - this._rejected();
        }, c2.prototype._getRangeError = function(t4) {
          var e7 = "Input array must contain at least " + this._howMany + " items but contains only " + t4 + " items";
          return new o2(e7);
        }, c2.prototype._resolveEmptyArray = function() {
          this._reject(this._getRangeError(0));
        }, e6.some = function(t4, e7) {
          return l2(t4, e7);
        }, e6.prototype.some = function(t4) {
          return l2(this, t4);
        }, e6._SomePromiseArray = c2;
      };
    }, { "./errors": 12, "./util": 36 }], 32: [function(t3, e5, r4) {
      e5.exports = function(t4) {
        function e6(t5) {
          void 0 !== t5 ? (t5 = t5._target(), this._bitField = t5._bitField, this._settledValueField = t5._isFateSealed() ? t5._settledValue() : void 0) : (this._bitField = 0, this._settledValueField = void 0);
        }
        e6.prototype._settledValue = function() {
          return this._settledValueField;
        };
        var r5 = e6.prototype.value = function() {
          if (!this.isFulfilled())
            throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
          return this._settledValue();
        }, n3 = e6.prototype.error = e6.prototype.reason = function() {
          if (!this.isRejected())
            throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
          return this._settledValue();
        }, i2 = e6.prototype.isFulfilled = function() {
          return 0 != (33554432 & this._bitField);
        }, o2 = e6.prototype.isRejected = function() {
          return 0 != (16777216 & this._bitField);
        }, s2 = e6.prototype.isPending = function() {
          return 0 == (50397184 & this._bitField);
        }, a2 = e6.prototype.isResolved = function() {
          return 0 != (50331648 & this._bitField);
        };
        e6.prototype.isCancelled = function() {
          return 0 != (8454144 & this._bitField);
        }, t4.prototype.__isCancelled = function() {
          return 65536 == (65536 & this._bitField);
        }, t4.prototype._isCancelled = function() {
          return this._target().__isCancelled();
        }, t4.prototype.isCancelled = function() {
          return 0 != (8454144 & this._target()._bitField);
        }, t4.prototype.isPending = function() {
          return s2.call(this._target());
        }, t4.prototype.isRejected = function() {
          return o2.call(this._target());
        }, t4.prototype.isFulfilled = function() {
          return i2.call(this._target());
        }, t4.prototype.isResolved = function() {
          return a2.call(this._target());
        }, t4.prototype.value = function() {
          return r5.call(this._target());
        }, t4.prototype.reason = function() {
          var t5 = this._target();
          return t5._unsetRejectionIsUnhandled(), n3.call(t5);
        }, t4.prototype._value = function() {
          return this._settledValue();
        }, t4.prototype._reason = function() {
          return this._unsetRejectionIsUnhandled(), this._settledValue();
        }, t4.PromiseInspection = e6;
      };
    }, {}], 33: [function(t3, e5, r4) {
      e5.exports = function(e6, r5) {
        var n3 = t3("./util"), i2 = n3.errorObj, o2 = n3.isObject, s2 = {}.hasOwnProperty;
        return function(t4, a2) {
          if (o2(t4)) {
            if (t4 instanceof e6)
              return t4;
            var u2 = function(t5) {
              try {
                return function(t6) {
                  return t6.then;
                }(t5);
              } catch (t6) {
                return i2.e = t6, i2;
              }
            }(t4);
            if (u2 === i2) {
              a2 && a2._pushContext();
              var c2 = e6.reject(u2.e);
              return a2 && a2._popContext(), c2;
            }
            if ("function" == typeof u2)
              return function(t5) {
                try {
                  return s2.call(t5, "_promise0");
                } catch (t6) {
                  return false;
                }
              }(t4) ? (c2 = new e6(r5), t4._then(c2._fulfill, c2._reject, void 0, c2, null), c2) : function(t5, o3, s3) {
                var a3 = new e6(r5), u3 = a3;
                s3 && s3._pushContext(), a3._captureStackTrace(), s3 && s3._popContext();
                var c3 = true, l2 = n3.tryCatch(o3).call(t5, function(t6) {
                  a3 && (a3._resolveCallback(t6), a3 = null);
                }, function(t6) {
                  a3 && (a3._rejectCallback(t6, c3, true), a3 = null);
                });
                return c3 = false, a3 && l2 === i2 && (a3._rejectCallback(l2.e, true, true), a3 = null), u3;
              }(t4, u2, a2);
          }
          return t4;
        };
      };
    }, { "./util": 36 }], 34: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3) {
        var i2 = t3("./util"), o2 = e6.TimeoutError;
        function s2(t4) {
          this.handle = t4;
        }
        s2.prototype._resultCancelled = function() {
          clearTimeout(this.handle);
        };
        var a2 = function(t4) {
          return u2(+this).thenReturn(t4);
        }, u2 = e6.delay = function(t4, i3) {
          var o3, u3;
          return void 0 !== i3 ? (o3 = e6.resolve(i3)._then(a2, null, null, t4, void 0), n3.cancellation() && i3 instanceof e6 && o3._setOnCancel(i3)) : (o3 = new e6(r5), u3 = setTimeout(function() {
            o3._fulfill();
          }, +t4), n3.cancellation() && o3._setOnCancel(new s2(u3)), o3._captureStackTrace()), o3._setAsyncGuaranteed(), o3;
        };
        function c2(t4) {
          return clearTimeout(this.handle), t4;
        }
        function l2(t4) {
          throw clearTimeout(this.handle), t4;
        }
        e6.prototype.delay = function(t4) {
          return u2(t4, this);
        }, e6.prototype.timeout = function(t4, e7) {
          var r6, a3;
          t4 = +t4;
          var u3 = new s2(setTimeout(function() {
            r6.isPending() && function(t5, e8, r7) {
              var n4;
              n4 = "string" != typeof e8 ? e8 instanceof Error ? e8 : new o2("operation timed out") : new o2(e8), i2.markAsOriginatingFromRejection(n4), t5._attachExtraTrace(n4), t5._reject(n4), null != r7 && r7.cancel();
            }(r6, e7, a3);
          }, t4));
          return n3.cancellation() ? (a3 = this.then(), (r6 = a3._then(c2, l2, void 0, u3, void 0))._setOnCancel(u3)) : r6 = this._then(c2, l2, void 0, u3, void 0), r6;
        };
      };
    }, { "./util": 36 }], 35: [function(t3, e5, r4) {
      e5.exports = function(e6, r5, n3, i2, o2, s2) {
        var a2 = t3("./util"), u2 = t3("./errors").TypeError, c2 = t3("./util").inherits, l2 = a2.errorObj, f2 = a2.tryCatch, h2 = {};
        function p2(t4) {
          setTimeout(function() {
            throw t4;
          }, 0);
        }
        function d2(t4, r6) {
          var i3 = 0, s3 = t4.length, a3 = new e6(o2);
          return function o3() {
            if (i3 >= s3)
              return a3._fulfill();
            var u3 = function(t5) {
              var e7 = n3(t5);
              return e7 !== t5 && "function" == typeof t5._isDisposable && "function" == typeof t5._getDisposer && t5._isDisposable() && e7._setDisposable(t5._getDisposer()), e7;
            }(t4[i3++]);
            if (u3 instanceof e6 && u3._isDisposable()) {
              try {
                u3 = n3(u3._getDisposer().tryDispose(r6), t4.promise);
              } catch (t5) {
                return p2(t5);
              }
              if (u3 instanceof e6)
                return u3._then(o3, p2, null, null, null);
            }
            o3();
          }(), a3;
        }
        function _2(t4, e7, r6) {
          this._data = t4, this._promise = e7, this._context = r6;
        }
        function v5(t4, e7, r6) {
          this.constructor$(t4, e7, r6);
        }
        function y2(t4) {
          return _2.isDisposer(t4) ? (this.resources[this.index]._setDisposable(t4), t4.promise()) : t4;
        }
        function m2(t4) {
          this.length = t4, this.promise = null, this[t4 - 1] = null;
        }
        _2.prototype.data = function() {
          return this._data;
        }, _2.prototype.promise = function() {
          return this._promise;
        }, _2.prototype.resource = function() {
          return this.promise().isFulfilled() ? this.promise().value() : h2;
        }, _2.prototype.tryDispose = function(t4) {
          var e7 = this.resource(), r6 = this._context;
          void 0 !== r6 && r6._pushContext();
          var n4 = e7 !== h2 ? this.doDispose(e7, t4) : null;
          return void 0 !== r6 && r6._popContext(), this._promise._unsetDisposable(), this._data = null, n4;
        }, _2.isDisposer = function(t4) {
          return null != t4 && "function" == typeof t4.resource && "function" == typeof t4.tryDispose;
        }, c2(v5, _2), v5.prototype.doDispose = function(t4, e7) {
          return this.data().call(t4, t4, e7);
        }, m2.prototype._resultCancelled = function() {
          for (var t4 = this.length, r6 = 0; r6 < t4; ++r6) {
            var n4 = this[r6];
            n4 instanceof e6 && n4.cancel();
          }
        }, e6.using = function() {
          var t4 = arguments.length;
          if (t4 < 2)
            return r5("you must pass at least 2 arguments to Promise.using");
          var i3, o3 = arguments[t4 - 1];
          if ("function" != typeof o3)
            return r5("expecting a function but got " + a2.classString(o3));
          var u3 = true;
          2 === t4 && Array.isArray(arguments[0]) ? (t4 = (i3 = arguments[0]).length, u3 = false) : (i3 = arguments, t4--);
          for (var c3 = new m2(t4), h3 = 0; h3 < t4; ++h3) {
            var p3 = i3[h3];
            if (_2.isDisposer(p3)) {
              var v6 = p3;
              (p3 = p3.promise())._setDisposable(v6);
            } else {
              var g2 = n3(p3);
              g2 instanceof e6 && (p3 = g2._then(y2, null, null, { resources: c3, index: h3 }, void 0));
            }
            c3[h3] = p3;
          }
          var b2 = new Array(c3.length);
          for (h3 = 0; h3 < b2.length; ++h3)
            b2[h3] = e6.resolve(c3[h3]).reflect();
          var w2 = e6.all(b2).then(function(t5) {
            for (var e7 = 0; e7 < t5.length; ++e7) {
              var r6 = t5[e7];
              if (r6.isRejected())
                return l2.e = r6.error(), l2;
              if (!r6.isFulfilled())
                return void w2.cancel();
              t5[e7] = r6.value();
            }
            E3._pushContext(), o3 = f2(o3);
            var n4 = u3 ? o3.apply(void 0, t5) : o3(t5), i4 = E3._popContext();
            return s2.checkForgottenReturns(n4, i4, "Promise.using", E3), n4;
          }), E3 = w2.lastly(function() {
            var t5 = new e6.PromiseInspection(w2);
            return d2(c3, t5);
          });
          return c3.promise = E3, E3._setOnCancel(c3), E3;
        }, e6.prototype._setDisposable = function(t4) {
          this._bitField = 131072 | this._bitField, this._disposer = t4;
        }, e6.prototype._isDisposable = function() {
          return (131072 & this._bitField) > 0;
        }, e6.prototype._getDisposer = function() {
          return this._disposer;
        }, e6.prototype._unsetDisposable = function() {
          this._bitField = -131073 & this._bitField, this._disposer = void 0;
        }, e6.prototype.disposer = function(t4) {
          if ("function" == typeof t4)
            return new v5(t4, this, i2());
          throw new u2();
        };
      };
    }, { "./errors": 12, "./util": 36 }], 36: [function(t3, n3, i2) {
      var o2, s2 = t3("./es5"), a2 = "undefined" == typeof navigator, u2 = { e: {} }, c2 = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== r3 ? r3 : void 0 !== this ? this : null;
      function l2() {
        try {
          var t4 = o2;
          return o2 = null, t4.apply(this, arguments);
        } catch (t5) {
          return u2.e = t5, u2;
        }
      }
      function f2(t4) {
        return null == t4 || true === t4 || false === t4 || "string" == typeof t4 || "number" == typeof t4;
      }
      function h2(t4, e5, r4) {
        if (f2(t4))
          return t4;
        var n4 = { value: r4, configurable: true, enumerable: false, writable: true };
        return s2.defineProperty(t4, e5, n4), t4;
      }
      var p2 = function() {
        var t4 = [Array.prototype, Object.prototype, Function.prototype], e5 = function(e6) {
          for (var r5 = 0; r5 < t4.length; ++r5)
            if (t4[r5] === e6)
              return true;
          return false;
        };
        if (s2.isES5) {
          var r4 = Object.getOwnPropertyNames;
          return function(t5) {
            for (var n5 = [], i3 = /* @__PURE__ */ Object.create(null); null != t5 && !e5(t5); ) {
              var o3;
              try {
                o3 = r4(t5);
              } catch (t6) {
                return n5;
              }
              for (var a3 = 0; a3 < o3.length; ++a3) {
                var u3 = o3[a3];
                if (!i3[u3]) {
                  i3[u3] = true;
                  var c3 = Object.getOwnPropertyDescriptor(t5, u3);
                  null != c3 && null == c3.get && null == c3.set && n5.push(u3);
                }
              }
              t5 = s2.getPrototypeOf(t5);
            }
            return n5;
          };
        }
        var n4 = {}.hasOwnProperty;
        return function(r5) {
          if (e5(r5))
            return [];
          var i3 = [];
          t:
            for (var o3 in r5)
              if (n4.call(r5, o3))
                i3.push(o3);
              else {
                for (var s3 = 0; s3 < t4.length; ++s3)
                  if (n4.call(t4[s3], o3))
                    continue t;
                i3.push(o3);
              }
          return i3;
        };
      }(), d2 = /this\s*\.\s*\S+\s*=/, _2 = /^[a-z$_][a-z$_0-9]*$/i;
      function v5(t4) {
        try {
          return t4 + "";
        } catch (t5) {
          return "[no string representation]";
        }
      }
      function y2(t4) {
        return t4 instanceof Error || null !== t4 && "object" == typeof t4 && "string" == typeof t4.message && "string" == typeof t4.name;
      }
      function m2(t4) {
        return y2(t4) && s2.propertyIsWritable(t4, "stack");
      }
      var g2 = "stack" in new Error() ? function(t4) {
        return m2(t4) ? t4 : new Error(v5(t4));
      } : function(t4) {
        if (m2(t4))
          return t4;
        try {
          throw new Error(v5(t4));
        } catch (t5) {
          return t5;
        }
      };
      function b2(t4) {
        return {}.toString.call(t4);
      }
      var w2 = function(t4) {
        return s2.isArray(t4) ? t4 : null;
      };
      if ("undefined" != typeof Symbol && Symbol.iterator) {
        var E3 = "function" == typeof Array.from ? function(t4) {
          return Array.from(t4);
        } : function(t4) {
          for (var e5, r4 = [], n4 = t4[Symbol.iterator](); !(e5 = n4.next()).done; )
            r4.push(e5.value);
          return r4;
        };
        w2 = function(t4) {
          return s2.isArray(t4) ? t4 : null != t4 && "function" == typeof t4[Symbol.iterator] ? E3(t4) : null;
        };
      }
      var C2 = void 0 !== e4 && "[object process]" === b2(e4).toLowerCase(), x2 = void 0 !== e4 && void 0 !== e4.env, j2 = { isClass: function(t4) {
        try {
          if ("function" == typeof t4) {
            var e5 = s2.names(t4.prototype), r4 = s2.isES5 && e5.length > 1, n4 = e5.length > 0 && !(1 === e5.length && "constructor" === e5[0]), i3 = d2.test(t4 + "") && s2.names(t4).length > 0;
            if (r4 || n4 || i3)
              return true;
          }
          return false;
        } catch (t5) {
          return false;
        }
      }, isIdentifier: function(t4) {
        return _2.test(t4);
      }, inheritedDataKeys: p2, getDataPropertyOrDefault: function(t4, e5, r4) {
        if (!s2.isES5)
          return {}.hasOwnProperty.call(t4, e5) ? t4[e5] : void 0;
        var n4 = Object.getOwnPropertyDescriptor(t4, e5);
        return null != n4 ? null == n4.get && null == n4.set ? n4.value : r4 : void 0;
      }, thrower: function(t4) {
        throw t4;
      }, isArray: s2.isArray, asArray: w2, notEnumerableProp: h2, isPrimitive: f2, isObject: function(t4) {
        return "function" == typeof t4 || "object" == typeof t4 && null !== t4;
      }, isError: y2, canEvaluate: a2, errorObj: u2, tryCatch: function(t4) {
        return o2 = t4, l2;
      }, inherits: function(t4, e5) {
        var r4 = {}.hasOwnProperty;
        function n4() {
          for (var n5 in this.constructor = t4, this.constructor$ = e5, e5.prototype)
            r4.call(e5.prototype, n5) && "$" !== n5.charAt(n5.length - 1) && (this[n5 + "$"] = e5.prototype[n5]);
        }
        return n4.prototype = e5.prototype, t4.prototype = new n4(), t4.prototype;
      }, withAppended: function(t4, e5) {
        var r4, n4 = t4.length, i3 = new Array(n4 + 1);
        for (r4 = 0; r4 < n4; ++r4)
          i3[r4] = t4[r4];
        return i3[r4] = e5, i3;
      }, maybeWrapAsError: function(t4) {
        return f2(t4) ? new Error(v5(t4)) : t4;
      }, toFastProperties: function(t4) {
        return t4;
      }, filledRange: function(t4, e5, r4) {
        for (var n4 = new Array(t4), i3 = 0; i3 < t4; ++i3)
          n4[i3] = e5 + i3 + r4;
        return n4;
      }, toString: v5, canAttachTrace: m2, ensureErrorObject: g2, originatesFromRejection: function(t4) {
        return null != t4 && (t4 instanceof Error.__BluebirdErrorTypes__.OperationalError || true === t4.isOperational);
      }, markAsOriginatingFromRejection: function(t4) {
        try {
          h2(t4, "isOperational", true);
        } catch (t5) {
        }
      }, classString: b2, copyDescriptors: function(t4, e5, r4) {
        for (var n4 = s2.names(t4), i3 = 0; i3 < n4.length; ++i3) {
          var o3 = n4[i3];
          if (r4(o3))
            try {
              s2.defineProperty(e5, o3, s2.getDescriptor(t4, o3));
            } catch (t5) {
            }
        }
      }, hasDevTools: "undefined" != typeof chrome && chrome && "function" == typeof chrome.loadTimes, isNode: C2, hasEnvVariables: x2, env: function(t4) {
        return x2 ? e4.env[t4] : void 0;
      }, global: c2, getNativePromise: function() {
        if ("function" == typeof Promise)
          try {
            var t4 = new Promise(function() {
            });
            if ("[object Promise]" === {}.toString.call(t4))
              return Promise;
          } catch (t5) {
          }
      }, domainBind: function(t4, e5) {
        return t4.bind(e5);
      } };
      j2.isRecentNode = j2.isNode && function() {
        var t4 = e4.versions.node.split(".").map(Number);
        return 0 === t4[0] && t4[1] > 10 || t4[0] > 0;
      }(), j2.isNode && j2.toFastProperties(e4);
      try {
        throw new Error();
      } catch (t4) {
        j2.lastLineError = t4;
      }
      n3.exports = j2;
    }, { "./es5": 13 }] }, {}, [4])(4), "undefined" != typeof window && null !== window ? window.P = window.Promise : "undefined" != typeof self && null !== self && (self.P = self.Promise);
  }).call(this, r2(4), r2(0), r2(11).setImmediate);
}, function(t2, e3, r2) {
  Object.defineProperty(e3, "__esModule", { value: true }), e3.default = function(t3, e4) {
    if (!e4.eol && t3) {
      for (var r3 = 0, n2 = t3.length; r3 < n2; r3++)
        if ("\r" === t3[r3]) {
          if ("\n" === t3[r3 + 1]) {
            e4.eol = "\r\n";
            break;
          }
          if (t3[r3 + 1]) {
            e4.eol = "\r";
            break;
          }
        } else if ("\n" === t3[r3]) {
          e4.eol = "\n";
          break;
        }
    }
    return e4.eol || "\n";
  };
}, function(t2, e3, r2) {
  var n2 = r2(65), i2 = r2(73);
  t2.exports = function(t3, e4) {
    var r3 = i2(t3, e4);
    return n2(r3) ? r3 : void 0;
  };
}, function(t2, e3, r2) {
  var n2 = r2(19).Symbol;
  t2.exports = n2;
}, function(t2, e3, r2) {
  var n2 = r2(67), i2 = "object" == typeof self && self && self.Object === Object && self, o2 = n2 || i2 || Function("return this")();
  t2.exports = o2;
}, function(t2, e3) {
  t2.exports = function(t3) {
    var e4 = typeof t3;
    return null != t3 && ("object" == e4 || "function" == e4);
  };
}, function(t2, e3) {
  var r2 = Array.isArray;
  t2.exports = r2;
}, function(t2, e3, r2) {
  var n2 = r2(30), i2 = r2(76);
  t2.exports = function(t3) {
    return "symbol" == typeof t3 || i2(t3) && "[object Symbol]" == n2(t3);
  };
}, function(t2, e3, r2) {
  (function(e4, n2) {
    var i2 = r2(6);
    t2.exports = g2;
    var o2, s2 = r2(37);
    g2.ReadableState = m2, r2(12).EventEmitter;
    var a2 = function(t3, e5) {
      return t3.listeners(e5).length;
    }, u2 = r2(24), c2 = r2(7).Buffer, l2 = e4.Uint8Array || function() {
    }, f2 = r2(5);
    f2.inherits = r2(2);
    var h2 = r2(41), p2 = void 0;
    p2 = h2 && h2.debuglog ? h2.debuglog("stream") : function() {
    };
    var d2, _2 = r2(42), v5 = r2(25);
    f2.inherits(g2, u2);
    var y2 = ["error", "close", "destroy", "pause", "resume"];
    function m2(t3, e5) {
      o2 = o2 || r2(1), t3 = t3 || {};
      var n3 = e5 instanceof o2;
      this.objectMode = !!t3.objectMode, n3 && (this.objectMode = this.objectMode || !!t3.readableObjectMode);
      var i3 = t3.highWaterMark, s3 = t3.readableHighWaterMark, a3 = this.objectMode ? 16 : 16384;
      this.highWaterMark = i3 || 0 === i3 ? i3 : n3 && (s3 || 0 === s3) ? s3 : a3, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new _2(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = false, this.endEmitted = false, this.reading = false, this.sync = true, this.needReadable = false, this.emittedReadable = false, this.readableListening = false, this.resumeScheduled = false, this.destroyed = false, this.defaultEncoding = t3.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = false, this.decoder = null, this.encoding = null, t3.encoding && (d2 || (d2 = r2(26).StringDecoder), this.decoder = new d2(t3.encoding), this.encoding = t3.encoding);
    }
    function g2(t3) {
      if (o2 = o2 || r2(1), !(this instanceof g2))
        return new g2(t3);
      this._readableState = new m2(t3, this), this.readable = true, t3 && ("function" == typeof t3.read && (this._read = t3.read), "function" == typeof t3.destroy && (this._destroy = t3.destroy)), u2.call(this);
    }
    function b2(t3, e5, r3, n3, i3) {
      var o3, s3 = t3._readableState;
      return null === e5 ? (s3.reading = false, function(t4, e6) {
        if (!e6.ended) {
          if (e6.decoder) {
            var r4 = e6.decoder.end();
            r4 && r4.length && (e6.buffer.push(r4), e6.length += e6.objectMode ? 1 : r4.length);
          }
          e6.ended = true, x2(t4);
        }
      }(t3, s3)) : (i3 || (o3 = function(t4, e6) {
        var r4;
        return function(t5) {
          return c2.isBuffer(t5) || t5 instanceof l2;
        }(e6) || "string" == typeof e6 || void 0 === e6 || t4.objectMode || (r4 = new TypeError("Invalid non-string/buffer chunk")), r4;
      }(s3, e5)), o3 ? t3.emit("error", o3) : s3.objectMode || e5 && e5.length > 0 ? ("string" == typeof e5 || s3.objectMode || Object.getPrototypeOf(e5) === c2.prototype || (e5 = function(t4) {
        return c2.from(t4);
      }(e5)), n3 ? s3.endEmitted ? t3.emit("error", new Error("stream.unshift() after end event")) : w2(t3, s3, e5, true) : s3.ended ? t3.emit("error", new Error("stream.push() after EOF")) : (s3.reading = false, s3.decoder && !r3 ? (e5 = s3.decoder.write(e5), s3.objectMode || 0 !== e5.length ? w2(t3, s3, e5, false) : S2(t3, s3)) : w2(t3, s3, e5, false))) : n3 || (s3.reading = false)), function(t4) {
        return !t4.ended && (t4.needReadable || t4.length < t4.highWaterMark || 0 === t4.length);
      }(s3);
    }
    function w2(t3, e5, r3, n3) {
      e5.flowing && 0 === e5.length && !e5.sync ? (t3.emit("data", r3), t3.read(0)) : (e5.length += e5.objectMode ? 1 : r3.length, n3 ? e5.buffer.unshift(r3) : e5.buffer.push(r3), e5.needReadable && x2(t3)), S2(t3, e5);
    }
    Object.defineProperty(g2.prototype, "destroyed", { get: function() {
      return void 0 !== this._readableState && this._readableState.destroyed;
    }, set: function(t3) {
      this._readableState && (this._readableState.destroyed = t3);
    } }), g2.prototype.destroy = v5.destroy, g2.prototype._undestroy = v5.undestroy, g2.prototype._destroy = function(t3, e5) {
      this.push(null), e5(t3);
    }, g2.prototype.push = function(t3, e5) {
      var r3, n3 = this._readableState;
      return n3.objectMode ? r3 = true : "string" == typeof t3 && ((e5 = e5 || n3.defaultEncoding) !== n3.encoding && (t3 = c2.from(t3, e5), e5 = ""), r3 = true), b2(this, t3, e5, false, r3);
    }, g2.prototype.unshift = function(t3) {
      return b2(this, t3, null, true, false);
    }, g2.prototype.isPaused = function() {
      return false === this._readableState.flowing;
    }, g2.prototype.setEncoding = function(t3) {
      return d2 || (d2 = r2(26).StringDecoder), this._readableState.decoder = new d2(t3), this._readableState.encoding = t3, this;
    };
    var E3 = 8388608;
    function C2(t3, e5) {
      return t3 <= 0 || 0 === e5.length && e5.ended ? 0 : e5.objectMode ? 1 : t3 != t3 ? e5.flowing && e5.length ? e5.buffer.head.data.length : e5.length : (t3 > e5.highWaterMark && (e5.highWaterMark = function(t4) {
        return t4 >= E3 ? t4 = E3 : (t4--, t4 |= t4 >>> 1, t4 |= t4 >>> 2, t4 |= t4 >>> 4, t4 |= t4 >>> 8, t4 |= t4 >>> 16, t4++), t4;
      }(t3)), t3 <= e5.length ? t3 : e5.ended ? e5.length : (e5.needReadable = true, 0));
    }
    function x2(t3) {
      var e5 = t3._readableState;
      e5.needReadable = false, e5.emittedReadable || (p2("emitReadable", e5.flowing), e5.emittedReadable = true, e5.sync ? i2.nextTick(j2, t3) : j2(t3));
    }
    function j2(t3) {
      p2("emit readable"), t3.emit("readable"), P2(t3);
    }
    function S2(t3, e5) {
      e5.readingMore || (e5.readingMore = true, i2.nextTick(R2, t3, e5));
    }
    function R2(t3, e5) {
      for (var r3 = e5.length; !e5.reading && !e5.flowing && !e5.ended && e5.length < e5.highWaterMark && (p2("maybeReadMore read 0"), t3.read(0), r3 !== e5.length); )
        r3 = e5.length;
      e5.readingMore = false;
    }
    function k2(t3) {
      p2("readable nexttick read 0"), t3.read(0);
    }
    function T2(t3, e5) {
      e5.reading || (p2("resume read 0"), t3.read(0)), e5.resumeScheduled = false, e5.awaitDrain = 0, t3.emit("resume"), P2(t3), e5.flowing && !e5.reading && t3.read(0);
    }
    function P2(t3) {
      var e5 = t3._readableState;
      for (p2("flow", e5.flowing); e5.flowing && null !== t3.read(); )
        ;
    }
    function O2(t3, e5) {
      return 0 === e5.length ? null : (e5.objectMode ? r3 = e5.buffer.shift() : !t3 || t3 >= e5.length ? (r3 = e5.decoder ? e5.buffer.join("") : 1 === e5.buffer.length ? e5.buffer.head.data : e5.buffer.concat(e5.length), e5.buffer.clear()) : r3 = function(t4, e6, r4) {
        var n3;
        return t4 < e6.head.data.length ? (n3 = e6.head.data.slice(0, t4), e6.head.data = e6.head.data.slice(t4)) : n3 = t4 === e6.head.data.length ? e6.shift() : r4 ? function(t5, e7) {
          var r5 = e7.head, n4 = 1, i3 = r5.data;
          for (t5 -= i3.length; r5 = r5.next; ) {
            var o3 = r5.data, s3 = t5 > o3.length ? o3.length : t5;
            if (s3 === o3.length ? i3 += o3 : i3 += o3.slice(0, t5), 0 == (t5 -= s3)) {
              s3 === o3.length ? (++n4, r5.next ? e7.head = r5.next : e7.head = e7.tail = null) : (e7.head = r5, r5.data = o3.slice(s3));
              break;
            }
            ++n4;
          }
          return e7.length -= n4, i3;
        }(t4, e6) : function(t5, e7) {
          var r5 = c2.allocUnsafe(t5), n4 = e7.head, i3 = 1;
          for (n4.data.copy(r5), t5 -= n4.data.length; n4 = n4.next; ) {
            var o3 = n4.data, s3 = t5 > o3.length ? o3.length : t5;
            if (o3.copy(r5, r5.length - t5, 0, s3), 0 == (t5 -= s3)) {
              s3 === o3.length ? (++i3, n4.next ? e7.head = n4.next : e7.head = e7.tail = null) : (e7.head = n4, n4.data = o3.slice(s3));
              break;
            }
            ++i3;
          }
          return e7.length -= i3, r5;
        }(t4, e6), n3;
      }(t3, e5.buffer, e5.decoder), r3);
      var r3;
    }
    function A2(t3) {
      var e5 = t3._readableState;
      if (e5.length > 0)
        throw new Error('"endReadable()" called on non-empty stream');
      e5.endEmitted || (e5.ended = true, i2.nextTick(F2, e5, t3));
    }
    function F2(t3, e5) {
      t3.endEmitted || 0 !== t3.length || (t3.endEmitted = true, e5.readable = false, e5.emit("end"));
    }
    function L2(t3, e5) {
      for (var r3 = 0, n3 = t3.length; r3 < n3; r3++)
        if (t3[r3] === e5)
          return r3;
      return -1;
    }
    g2.prototype.read = function(t3) {
      p2("read", t3), t3 = parseInt(t3, 10);
      var e5 = this._readableState, r3 = t3;
      if (0 !== t3 && (e5.emittedReadable = false), 0 === t3 && e5.needReadable && (e5.length >= e5.highWaterMark || e5.ended))
        return p2("read: emitReadable", e5.length, e5.ended), 0 === e5.length && e5.ended ? A2(this) : x2(this), null;
      if (0 === (t3 = C2(t3, e5)) && e5.ended)
        return 0 === e5.length && A2(this), null;
      var n3, i3 = e5.needReadable;
      return p2("need readable", i3), (0 === e5.length || e5.length - t3 < e5.highWaterMark) && p2("length less than watermark", i3 = true), e5.ended || e5.reading ? p2("reading or ended", i3 = false) : i3 && (p2("do read"), e5.reading = true, e5.sync = true, 0 === e5.length && (e5.needReadable = true), this._read(e5.highWaterMark), e5.sync = false, e5.reading || (t3 = C2(r3, e5))), null === (n3 = t3 > 0 ? O2(t3, e5) : null) ? (e5.needReadable = true, t3 = 0) : e5.length -= t3, 0 === e5.length && (e5.ended || (e5.needReadable = true), r3 !== t3 && e5.ended && A2(this)), null !== n3 && this.emit("data", n3), n3;
    }, g2.prototype._read = function(t3) {
      this.emit("error", new Error("_read() is not implemented"));
    }, g2.prototype.pipe = function(t3, e5) {
      var r3 = this, o3 = this._readableState;
      switch (o3.pipesCount) {
        case 0:
          o3.pipes = t3;
          break;
        case 1:
          o3.pipes = [o3.pipes, t3];
          break;
        default:
          o3.pipes.push(t3);
      }
      o3.pipesCount += 1, p2("pipe count=%d opts=%j", o3.pipesCount, e5);
      var u3 = e5 && false === e5.end || t3 === n2.stdout || t3 === n2.stderr ? m3 : c3;
      function c3() {
        p2("onend"), t3.end();
      }
      o3.endEmitted ? i2.nextTick(u3) : r3.once("end", u3), t3.on("unpipe", function e6(n3, i3) {
        p2("onunpipe"), n3 === r3 && i3 && false === i3.hasUnpiped && (i3.hasUnpiped = true, p2("cleanup"), t3.removeListener("close", v6), t3.removeListener("finish", y3), t3.removeListener("drain", l3), t3.removeListener("error", _3), t3.removeListener("unpipe", e6), r3.removeListener("end", c3), r3.removeListener("end", m3), r3.removeListener("data", d3), f3 = true, !o3.awaitDrain || t3._writableState && !t3._writableState.needDrain || l3());
      });
      var l3 = function(t4) {
        return function() {
          var e6 = t4._readableState;
          p2("pipeOnDrain", e6.awaitDrain), e6.awaitDrain && e6.awaitDrain--, 0 === e6.awaitDrain && a2(t4, "data") && (e6.flowing = true, P2(t4));
        };
      }(r3);
      t3.on("drain", l3);
      var f3 = false, h3 = false;
      function d3(e6) {
        p2("ondata"), h3 = false, false !== t3.write(e6) || h3 || ((1 === o3.pipesCount && o3.pipes === t3 || o3.pipesCount > 1 && -1 !== L2(o3.pipes, t3)) && !f3 && (p2("false write response, pause", r3._readableState.awaitDrain), r3._readableState.awaitDrain++, h3 = true), r3.pause());
      }
      function _3(e6) {
        p2("onerror", e6), m3(), t3.removeListener("error", _3), 0 === a2(t3, "error") && t3.emit("error", e6);
      }
      function v6() {
        t3.removeListener("finish", y3), m3();
      }
      function y3() {
        p2("onfinish"), t3.removeListener("close", v6), m3();
      }
      function m3() {
        p2("unpipe"), r3.unpipe(t3);
      }
      return r3.on("data", d3), function(t4, e6, r4) {
        if ("function" == typeof t4.prependListener)
          return t4.prependListener(e6, r4);
        t4._events && t4._events[e6] ? s2(t4._events[e6]) ? t4._events[e6].unshift(r4) : t4._events[e6] = [r4, t4._events[e6]] : t4.on(e6, r4);
      }(t3, "error", _3), t3.once("close", v6), t3.once("finish", y3), t3.emit("pipe", r3), o3.flowing || (p2("pipe resume"), r3.resume()), t3;
    }, g2.prototype.unpipe = function(t3) {
      var e5 = this._readableState, r3 = { hasUnpiped: false };
      if (0 === e5.pipesCount)
        return this;
      if (1 === e5.pipesCount)
        return t3 && t3 !== e5.pipes ? this : (t3 || (t3 = e5.pipes), e5.pipes = null, e5.pipesCount = 0, e5.flowing = false, t3 && t3.emit("unpipe", this, r3), this);
      if (!t3) {
        var n3 = e5.pipes, i3 = e5.pipesCount;
        e5.pipes = null, e5.pipesCount = 0, e5.flowing = false;
        for (var o3 = 0; o3 < i3; o3++)
          n3[o3].emit("unpipe", this, r3);
        return this;
      }
      var s3 = L2(e5.pipes, t3);
      return -1 === s3 ? this : (e5.pipes.splice(s3, 1), e5.pipesCount -= 1, 1 === e5.pipesCount && (e5.pipes = e5.pipes[0]), t3.emit("unpipe", this, r3), this);
    }, g2.prototype.on = function(t3, e5) {
      var r3 = u2.prototype.on.call(this, t3, e5);
      if ("data" === t3)
        false !== this._readableState.flowing && this.resume();
      else if ("readable" === t3) {
        var n3 = this._readableState;
        n3.endEmitted || n3.readableListening || (n3.readableListening = n3.needReadable = true, n3.emittedReadable = false, n3.reading ? n3.length && x2(this) : i2.nextTick(k2, this));
      }
      return r3;
    }, g2.prototype.addListener = g2.prototype.on, g2.prototype.resume = function() {
      var t3 = this._readableState;
      return t3.flowing || (p2("resume"), t3.flowing = true, function(t4, e5) {
        e5.resumeScheduled || (e5.resumeScheduled = true, i2.nextTick(T2, t4, e5));
      }(this, t3)), this;
    }, g2.prototype.pause = function() {
      return p2("call pause flowing=%j", this._readableState.flowing), false !== this._readableState.flowing && (p2("pause"), this._readableState.flowing = false, this.emit("pause")), this;
    }, g2.prototype.wrap = function(t3) {
      var e5 = this, r3 = this._readableState, n3 = false;
      for (var i3 in t3.on("end", function() {
        if (p2("wrapped end"), r3.decoder && !r3.ended) {
          var t4 = r3.decoder.end();
          t4 && t4.length && e5.push(t4);
        }
        e5.push(null);
      }), t3.on("data", function(i4) {
        p2("wrapped data"), r3.decoder && (i4 = r3.decoder.write(i4)), (!r3.objectMode || null !== i4 && void 0 !== i4) && (r3.objectMode || i4 && i4.length) && (e5.push(i4) || (n3 = true, t3.pause()));
      }), t3)
        void 0 === this[i3] && "function" == typeof t3[i3] && (this[i3] = function(e6) {
          return function() {
            return t3[e6].apply(t3, arguments);
          };
        }(i3));
      for (var o3 = 0; o3 < y2.length; o3++)
        t3.on(y2[o3], this.emit.bind(this, y2[o3]));
      return this._read = function(e6) {
        p2("wrapped _read", e6), n3 && (n3 = false, t3.resume());
      }, this;
    }, Object.defineProperty(g2.prototype, "readableHighWaterMark", { enumerable: false, get: function() {
      return this._readableState.highWaterMark;
    } }), g2._fromList = O2;
  }).call(this, r2(0), r2(4));
}, function(t2, e3, r2) {
  t2.exports = r2(12).EventEmitter;
}, function(t2, e3, r2) {
  var n2 = r2(6);
  function i2(t3, e4) {
    t3.emit("error", e4);
  }
  t2.exports = { destroy: function(t3, e4) {
    var r3 = this, o2 = this._readableState && this._readableState.destroyed, s2 = this._writableState && this._writableState.destroyed;
    return o2 || s2 ? (e4 ? e4(t3) : !t3 || this._writableState && this._writableState.errorEmitted || n2.nextTick(i2, this, t3), this) : (this._readableState && (this._readableState.destroyed = true), this._writableState && (this._writableState.destroyed = true), this._destroy(t3 || null, function(t4) {
      !e4 && t4 ? (n2.nextTick(i2, r3, t4), r3._writableState && (r3._writableState.errorEmitted = true)) : e4 && e4(t4);
    }), this);
  }, undestroy: function() {
    this._readableState && (this._readableState.destroyed = false, this._readableState.reading = false, this._readableState.ended = false, this._readableState.endEmitted = false), this._writableState && (this._writableState.destroyed = false, this._writableState.ended = false, this._writableState.ending = false, this._writableState.finished = false, this._writableState.errorEmitted = false);
  } };
}, function(t2, e3, r2) {
  var n2 = r2(7).Buffer, i2 = n2.isEncoding || function(t3) {
    switch ((t3 = "" + t3) && t3.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return true;
      default:
        return false;
    }
  };
  function o2(t3) {
    var e4;
    switch (this.encoding = function(t4) {
      var e5 = function(t5) {
        if (!t5)
          return "utf8";
        for (var e6; ; )
          switch (t5) {
            case "utf8":
            case "utf-8":
              return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return "utf16le";
            case "latin1":
            case "binary":
              return "latin1";
            case "base64":
            case "ascii":
            case "hex":
              return t5;
            default:
              if (e6)
                return;
              t5 = ("" + t5).toLowerCase(), e6 = true;
          }
      }(t4);
      if ("string" != typeof e5 && (n2.isEncoding === i2 || !i2(t4)))
        throw new Error("Unknown encoding: " + t4);
      return e5 || t4;
    }(t3), this.encoding) {
      case "utf16le":
        this.text = u2, this.end = c2, e4 = 4;
        break;
      case "utf8":
        this.fillLast = a2, e4 = 4;
        break;
      case "base64":
        this.text = l2, this.end = f2, e4 = 3;
        break;
      default:
        return this.write = h2, void (this.end = p2);
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n2.allocUnsafe(e4);
  }
  function s2(t3) {
    return t3 <= 127 ? 0 : t3 >> 5 == 6 ? 2 : t3 >> 4 == 14 ? 3 : t3 >> 3 == 30 ? 4 : t3 >> 6 == 2 ? -1 : -2;
  }
  function a2(t3) {
    var e4 = this.lastTotal - this.lastNeed, r3 = function(t4, e5, r4) {
      if (128 != (192 & e5[0]))
        return t4.lastNeed = 0, "�";
      if (t4.lastNeed > 1 && e5.length > 1) {
        if (128 != (192 & e5[1]))
          return t4.lastNeed = 1, "�";
        if (t4.lastNeed > 2 && e5.length > 2 && 128 != (192 & e5[2]))
          return t4.lastNeed = 2, "�";
      }
    }(this, t3);
    return void 0 !== r3 ? r3 : this.lastNeed <= t3.length ? (t3.copy(this.lastChar, e4, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t3.copy(this.lastChar, e4, 0, t3.length), void (this.lastNeed -= t3.length));
  }
  function u2(t3, e4) {
    if ((t3.length - e4) % 2 == 0) {
      var r3 = t3.toString("utf16le", e4);
      if (r3) {
        var n3 = r3.charCodeAt(r3.length - 1);
        if (n3 >= 55296 && n3 <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t3[t3.length - 2], this.lastChar[1] = t3[t3.length - 1], r3.slice(0, -1);
      }
      return r3;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t3[t3.length - 1], t3.toString("utf16le", e4, t3.length - 1);
  }
  function c2(t3) {
    var e4 = t3 && t3.length ? this.write(t3) : "";
    if (this.lastNeed) {
      var r3 = this.lastTotal - this.lastNeed;
      return e4 + this.lastChar.toString("utf16le", 0, r3);
    }
    return e4;
  }
  function l2(t3, e4) {
    var r3 = (t3.length - e4) % 3;
    return 0 === r3 ? t3.toString("base64", e4) : (this.lastNeed = 3 - r3, this.lastTotal = 3, 1 === r3 ? this.lastChar[0] = t3[t3.length - 1] : (this.lastChar[0] = t3[t3.length - 2], this.lastChar[1] = t3[t3.length - 1]), t3.toString("base64", e4, t3.length - r3));
  }
  function f2(t3) {
    var e4 = t3 && t3.length ? this.write(t3) : "";
    return this.lastNeed ? e4 + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e4;
  }
  function h2(t3) {
    return t3.toString(this.encoding);
  }
  function p2(t3) {
    return t3 && t3.length ? this.write(t3) : "";
  }
  e3.StringDecoder = o2, o2.prototype.write = function(t3) {
    if (0 === t3.length)
      return "";
    var e4, r3;
    if (this.lastNeed) {
      if (void 0 === (e4 = this.fillLast(t3)))
        return "";
      r3 = this.lastNeed, this.lastNeed = 0;
    } else
      r3 = 0;
    return r3 < t3.length ? e4 ? e4 + this.text(t3, r3) : this.text(t3, r3) : e4 || "";
  }, o2.prototype.end = function(t3) {
    var e4 = t3 && t3.length ? this.write(t3) : "";
    return this.lastNeed ? e4 + "�" : e4;
  }, o2.prototype.text = function(t3, e4) {
    var r3 = function(t4, e5, r4) {
      var n4 = e5.length - 1;
      if (n4 < r4)
        return 0;
      var i3 = s2(e5[n4]);
      return i3 >= 0 ? (i3 > 0 && (t4.lastNeed = i3 - 1), i3) : --n4 < r4 || -2 === i3 ? 0 : (i3 = s2(e5[n4])) >= 0 ? (i3 > 0 && (t4.lastNeed = i3 - 2), i3) : --n4 < r4 || -2 === i3 ? 0 : (i3 = s2(e5[n4])) >= 0 ? (i3 > 0 && (2 === i3 ? i3 = 0 : t4.lastNeed = i3 - 3), i3) : 0;
    }(this, t3, e4);
    if (!this.lastNeed)
      return t3.toString("utf8", e4);
    this.lastTotal = r3;
    var n3 = t3.length - (r3 - this.lastNeed);
    return t3.copy(this.lastChar, 0, n3), t3.toString("utf8", e4, n3);
  }, o2.prototype.fillLast = function(t3) {
    if (this.lastNeed <= t3.length)
      return t3.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    t3.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t3.length), this.lastNeed -= t3.length;
  };
}, function(t2, e3, r2) {
  t2.exports = o2;
  var n2 = r2(1), i2 = r2(5);
  function o2(t3) {
    if (!(this instanceof o2))
      return new o2(t3);
    n2.call(this, t3), this._transformState = { afterTransform: function(t4, e4) {
      var r3 = this._transformState;
      r3.transforming = false;
      var n3 = r3.writecb;
      if (!n3)
        return this.emit("error", new Error("write callback called multiple times"));
      r3.writechunk = null, r3.writecb = null, null != e4 && this.push(e4), n3(t4);
      var i3 = this._readableState;
      i3.reading = false, (i3.needReadable || i3.length < i3.highWaterMark) && this._read(i3.highWaterMark);
    }.bind(this), needTransform: false, transforming: false, writecb: null, writechunk: null, writeencoding: null }, this._readableState.needReadable = true, this._readableState.sync = false, t3 && ("function" == typeof t3.transform && (this._transform = t3.transform), "function" == typeof t3.flush && (this._flush = t3.flush)), this.on("prefinish", s2);
  }
  function s2() {
    var t3 = this;
    "function" == typeof this._flush ? this._flush(function(e4, r3) {
      a2(t3, e4, r3);
    }) : a2(this, null, null);
  }
  function a2(t3, e4, r3) {
    if (e4)
      return t3.emit("error", e4);
    if (null != r3 && t3.push(r3), t3._writableState.length)
      throw new Error("Calling transform done when ws.length != 0");
    if (t3._transformState.transforming)
      throw new Error("Calling transform done when still transforming");
    return t3.push(null);
  }
  i2.inherits = r2(2), i2.inherits(o2, n2), o2.prototype.push = function(t3, e4) {
    return this._transformState.needTransform = false, n2.prototype.push.call(this, t3, e4);
  }, o2.prototype._transform = function(t3, e4, r3) {
    throw new Error("_transform() is not implemented");
  }, o2.prototype._write = function(t3, e4, r3) {
    var n3 = this._transformState;
    if (n3.writecb = r3, n3.writechunk = t3, n3.writeencoding = e4, !n3.transforming) {
      var i3 = this._readableState;
      (n3.needTransform || i3.needReadable || i3.length < i3.highWaterMark) && this._read(i3.highWaterMark);
    }
  }, o2.prototype._read = function(t3) {
    var e4 = this._transformState;
    null !== e4.writechunk && e4.writecb && !e4.transforming ? (e4.transforming = true, this._transform(e4.writechunk, e4.writeencoding, e4.afterTransform)) : e4.needTransform = true;
  }, o2.prototype._destroy = function(t3, e4) {
    var r3 = this;
    n2.prototype._destroy.call(this, t3, function(t4) {
      e4(t4), r3.emit("close");
    });
  };
}, function(t2, e3, r2) {
  (function(t3) {
    Object.defineProperty(e3, "__esModule", { value: true }), e3.bufFromString = function(e4) {
      var r3 = t3.byteLength(e4), n2 = t3.allocUnsafe ? t3.allocUnsafe(r3) : new t3(r3);
      return n2.write(e4), n2;
    }, e3.emptyBuffer = function() {
      return t3.allocUnsafe ? t3.allocUnsafe(0) : new t3(0);
    }, e3.filterArray = function(t4, e4) {
      for (var r3 = [], n2 = 0; n2 < t4.length; n2++)
        e4.indexOf(n2) > -1 && r3.push(t4[n2]);
      return r3;
    }, e3.trimLeft = String.prototype.trimLeft ? function(t4) {
      return t4.trimLeft();
    } : function(t4) {
      return t4.replace(/^\s+/, "");
    }, e3.trimRight = String.prototype.trimRight ? function(t4) {
      return t4.trimRight();
    } : function(t4) {
      return t4.replace(/\s+$/, "");
    };
  }).call(this, r2(3).Buffer);
}, function(t2, e3, r2) {
  var n2 = this && this.__extends || function() {
    var t3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t4, e4) {
      t4.__proto__ = e4;
    } || function(t4, e4) {
      for (var r3 in e4)
        e4.hasOwnProperty(r3) && (t4[r3] = e4[r3]);
    };
    return function(e4, r3) {
      function n3() {
        this.constructor = e4;
      }
      t3(e4, r3), e4.prototype = null === r3 ? Object.create(r3) : (n3.prototype = r3.prototype, new n3());
    };
  }();
  Object.defineProperty(e3, "__esModule", { value: true });
  var i2 = function(t3) {
    function e4(e5, r3, n3) {
      var i3 = t3.call(this, "Error: " + e5 + ". JSON Line number: " + r3 + (n3 ? " near: " + n3 : "")) || this;
      return i3.err = e5, i3.line = r3, i3.extra = n3, i3.name = "CSV Parse Error", i3;
    }
    return n2(e4, t3), e4.column_mismatched = function(t4, r3) {
      return new e4("column_mismatched", t4, r3);
    }, e4.unclosed_quote = function(t4, r3) {
      return new e4("unclosed_quote", t4, r3);
    }, e4.fromJSON = function(t4) {
      return new e4(t4.err, t4.line, t4.extra);
    }, e4.prototype.toJSON = function() {
      return { err: this.err, line: this.line, extra: this.extra };
    }, e4;
  }(Error);
  e3.default = i2;
}, function(t2, e3, r2) {
  var n2 = r2(18), i2 = r2(68), o2 = r2(69), s2 = n2 ? n2.toStringTag : void 0;
  t2.exports = function(t3) {
    return null == t3 ? void 0 === t3 ? "[object Undefined]" : "[object Null]" : s2 && s2 in Object(t3) ? i2(t3) : o2(t3);
  };
}, function(t2, e3) {
  t2.exports = function(t3, e4) {
    return t3 === e4 || t3 != t3 && e4 != e4;
  };
}, function(t2, e3, r2) {
  t2.exports = r2(33);
}, function(t2, e3, r2) {
  var n2 = r2(34), i2 = function(t3, e4) {
    return new n2.Converter(t3, e4);
  };
  i2.csv = i2, i2.Converter = n2.Converter, t2.exports = i2;
}, function(t2, e3, r2) {
  (function(t3) {
    var n2 = this && this.__extends || function() {
      var t4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t5, e4) {
        t5.__proto__ = e4;
      } || function(t5, e4) {
        for (var r3 in e4)
          e4.hasOwnProperty(r3) && (t5[r3] = e4[r3]);
      };
      return function(e4, r3) {
        function n3() {
          this.constructor = e4;
        }
        t4(e4, r3), e4.prototype = null === r3 ? Object.create(r3) : (n3.prototype = r3.prototype, new n3());
      };
    }(), i2 = this && this.__importDefault || function(t4) {
      return t4 && t4.__esModule ? t4 : { default: t4 };
    };
    Object.defineProperty(e3, "__esModule", { value: true });
    var o2 = r2(36), s2 = r2(50), a2 = r2(51), u2 = i2(r2(15)), c2 = r2(52), l2 = r2(105), f2 = function(e4) {
      function i3(r3, n3) {
        void 0 === n3 && (n3 = {});
        var i4 = e4.call(this, n3) || this;
        return i4.options = n3, i4.params = s2.mergeParams(r3), i4.runtime = a2.initParseRuntime(i4), i4.result = new l2.Result(i4), i4.processor = new c2.ProcessorLocal(i4), i4.once("error", function(e5) {
          t3(function() {
            i4.result.processError(e5), i4.emit("done", e5);
          });
        }), i4.once("done", function() {
          i4.processor.destroy();
        }), i4;
      }
      return n2(i3, e4), i3.prototype.preRawData = function(t4) {
        return this.runtime.preRawDataHook = t4, this;
      }, i3.prototype.preFileLine = function(t4) {
        return this.runtime.preFileLineHook = t4, this;
      }, i3.prototype.subscribe = function(t4, e5, r3) {
        return this.parseRuntime.subscribe = { onNext: t4, onError: e5, onCompleted: r3 }, this;
      }, i3.prototype.fromFile = function(t4, e5) {
        var n3 = this, i4 = r2(!function() {
          var t5 = new Error("Cannot find module 'fs'");
          throw t5.code = "MODULE_NOT_FOUND", t5;
        }());
        return i4.exists(t4, function(r3) {
          r3 ? i4.createReadStream(t4, e5).pipe(n3) : n3.emit("error", new Error("File does not exist. Check to make sure the file path to your csv is correct."));
        }), this;
      }, i3.prototype.fromStream = function(t4) {
        return t4.pipe(this), this;
      }, i3.prototype.fromString = function(t4) {
        t4.toString();
        var e5 = new o2.Readable(), r3 = 0;
        return e5._read = function(e6) {
          if (r3 >= t4.length)
            this.push(null);
          else {
            var n3 = t4.substr(r3, e6);
            this.push(n3), r3 += e6;
          }
        }, this.fromStream(e5);
      }, i3.prototype.then = function(t4, e5) {
        var r3 = this;
        return new u2.default(function(n3, i4) {
          r3.parseRuntime.then = { onfulfilled: function(e6) {
            n3(t4 ? t4(e6) : e6);
          }, onrejected: function(t5) {
            e5 ? n3(e5(t5)) : i4(t5);
          } };
        });
      }, Object.defineProperty(i3.prototype, "parseParam", { get: function() {
        return this.params;
      }, enumerable: true, configurable: true }), Object.defineProperty(i3.prototype, "parseRuntime", { get: function() {
        return this.runtime;
      }, enumerable: true, configurable: true }), i3.prototype._transform = function(t4, e5, r3) {
        var n3 = this;
        this.processor.process(t4).then(function(t5) {
          if (t5.length > 0)
            return n3.runtime.started = true, n3.result.processResult(t5);
        }).then(function() {
          n3.emit("drained"), r3();
        }, function(t5) {
          n3.runtime.hasError = true, n3.runtime.error = t5, n3.emit("error", t5), r3();
        });
      }, i3.prototype._flush = function(t4) {
        var e5 = this;
        this.processor.flush().then(function(t5) {
          if (t5.length > 0)
            return e5.result.processResult(t5);
        }).then(function() {
          e5.processEnd(t4);
        }, function(r3) {
          e5.emit("error", r3), t4();
        });
      }, i3.prototype.processEnd = function(t4) {
        this.result.endProcess(), this.emit("done"), t4();
      }, Object.defineProperty(i3.prototype, "parsedLineNumber", { get: function() {
        return this.runtime.parsedLineNumber;
      }, enumerable: true, configurable: true }), i3;
    }(o2.Transform);
    e3.Converter = f2;
  }).call(this, r2(11).setImmediate);
}, function(t2, e3, r2) {
  (function(t3, e4) {
    !function(t4, r3) {
      if (!t4.setImmediate) {
        var n2, i2 = 1, o2 = {}, s2 = false, a2 = t4.document, u2 = Object.getPrototypeOf && Object.getPrototypeOf(t4);
        u2 = u2 && u2.setTimeout ? u2 : t4, "[object process]" === {}.toString.call(t4.process) ? n2 = function(t5) {
          e4.nextTick(function() {
            l2(t5);
          });
        } : function() {
          if (t4.postMessage && !t4.importScripts) {
            var e5 = true, r4 = t4.onmessage;
            return t4.onmessage = function() {
              e5 = false;
            }, t4.postMessage("", "*"), t4.onmessage = r4, e5;
          }
        }() ? function() {
          var e5 = "setImmediate$" + Math.random() + "$", r4 = function(r5) {
            r5.source === t4 && "string" == typeof r5.data && 0 === r5.data.indexOf(e5) && l2(+r5.data.slice(e5.length));
          };
          t4.addEventListener ? t4.addEventListener("message", r4, false) : t4.attachEvent("onmessage", r4), n2 = function(r5) {
            t4.postMessage(e5 + r5, "*");
          };
        }() : t4.MessageChannel ? function() {
          var t5 = new MessageChannel();
          t5.port1.onmessage = function(t6) {
            l2(t6.data);
          }, n2 = function(e5) {
            t5.port2.postMessage(e5);
          };
        }() : a2 && "onreadystatechange" in a2.createElement("script") ? function() {
          var t5 = a2.documentElement;
          n2 = function(e5) {
            var r4 = a2.createElement("script");
            r4.onreadystatechange = function() {
              l2(e5), r4.onreadystatechange = null, t5.removeChild(r4), r4 = null;
            }, t5.appendChild(r4);
          };
        }() : n2 = function(t5) {
          setTimeout(l2, 0, t5);
        }, u2.setImmediate = function(t5) {
          "function" != typeof t5 && (t5 = new Function("" + t5));
          for (var e5 = new Array(arguments.length - 1), r4 = 0; r4 < e5.length; r4++)
            e5[r4] = arguments[r4 + 1];
          var s3 = { callback: t5, args: e5 };
          return o2[i2] = s3, n2(i2), i2++;
        }, u2.clearImmediate = c2;
      }
      function c2(t5) {
        delete o2[t5];
      }
      function l2(t5) {
        if (s2)
          setTimeout(l2, 0, t5);
        else {
          var e5 = o2[t5];
          if (e5) {
            s2 = true;
            try {
              !function(t6) {
                var e6 = t6.callback, n3 = t6.args;
                switch (n3.length) {
                  case 0:
                    e6();
                    break;
                  case 1:
                    e6(n3[0]);
                    break;
                  case 2:
                    e6(n3[0], n3[1]);
                    break;
                  case 3:
                    e6(n3[0], n3[1], n3[2]);
                    break;
                  default:
                    e6.apply(r3, n3);
                }
              }(e5);
            } finally {
              c2(t5), s2 = false;
            }
          }
        }
      }
    }("undefined" == typeof self ? void 0 === t3 ? this : t3 : self);
  }).call(this, r2(0), r2(4));
}, function(t2, e3, r2) {
  t2.exports = i2;
  var n2 = r2(12).EventEmitter;
  function i2() {
    n2.call(this);
  }
  r2(2)(i2, n2), i2.Readable = r2(13), i2.Writable = r2(46), i2.Duplex = r2(47), i2.Transform = r2(48), i2.PassThrough = r2(49), i2.Stream = i2, i2.prototype.pipe = function(t3, e4) {
    var r3 = this;
    function i3(e5) {
      t3.writable && false === t3.write(e5) && r3.pause && r3.pause();
    }
    function o2() {
      r3.readable && r3.resume && r3.resume();
    }
    r3.on("data", i3), t3.on("drain", o2), t3._isStdio || e4 && false === e4.end || (r3.on("end", a2), r3.on("close", u2));
    var s2 = false;
    function a2() {
      s2 || (s2 = true, t3.end());
    }
    function u2() {
      s2 || (s2 = true, "function" == typeof t3.destroy && t3.destroy());
    }
    function c2(t4) {
      if (l2(), 0 === n2.listenerCount(this, "error"))
        throw t4;
    }
    function l2() {
      r3.removeListener("data", i3), t3.removeListener("drain", o2), r3.removeListener("end", a2), r3.removeListener("close", u2), r3.removeListener("error", c2), t3.removeListener("error", c2), r3.removeListener("end", l2), r3.removeListener("close", l2), t3.removeListener("close", l2);
    }
    return r3.on("error", c2), t3.on("error", c2), r3.on("end", l2), r3.on("close", l2), t3.on("close", l2), t3.emit("pipe", r3), t3;
  };
}, function(t2, e3) {
  var r2 = {}.toString;
  t2.exports = Array.isArray || function(t3) {
    return "[object Array]" == r2.call(t3);
  };
}, function(t2, e3, r2) {
  e3.byteLength = function(t3) {
    var e4 = c2(t3), r3 = e4[0], n3 = e4[1];
    return 3 * (r3 + n3) / 4 - n3;
  }, e3.toByteArray = function(t3) {
    for (var e4, r3 = c2(t3), n3 = r3[0], s3 = r3[1], a3 = new o2(3 * (n3 + s3) / 4 - s3), u3 = 0, l3 = s3 > 0 ? n3 - 4 : n3, f3 = 0; f3 < l3; f3 += 4)
      e4 = i2[t3.charCodeAt(f3)] << 18 | i2[t3.charCodeAt(f3 + 1)] << 12 | i2[t3.charCodeAt(f3 + 2)] << 6 | i2[t3.charCodeAt(f3 + 3)], a3[u3++] = e4 >> 16 & 255, a3[u3++] = e4 >> 8 & 255, a3[u3++] = 255 & e4;
    return 2 === s3 && (e4 = i2[t3.charCodeAt(f3)] << 2 | i2[t3.charCodeAt(f3 + 1)] >> 4, a3[u3++] = 255 & e4), 1 === s3 && (e4 = i2[t3.charCodeAt(f3)] << 10 | i2[t3.charCodeAt(f3 + 1)] << 4 | i2[t3.charCodeAt(f3 + 2)] >> 2, a3[u3++] = e4 >> 8 & 255, a3[u3++] = 255 & e4), a3;
  }, e3.fromByteArray = function(t3) {
    for (var e4, r3 = t3.length, i3 = r3 % 3, o3 = [], s3 = 0, a3 = r3 - i3; s3 < a3; s3 += 16383)
      o3.push(f2(t3, s3, s3 + 16383 > a3 ? a3 : s3 + 16383));
    return 1 === i3 ? (e4 = t3[r3 - 1], o3.push(n2[e4 >> 2] + n2[e4 << 4 & 63] + "==")) : 2 === i3 && (e4 = (t3[r3 - 2] << 8) + t3[r3 - 1], o3.push(n2[e4 >> 10] + n2[e4 >> 4 & 63] + n2[e4 << 2 & 63] + "=")), o3.join("");
  };
  for (var n2 = [], i2 = [], o2 = "undefined" != typeof Uint8Array ? Uint8Array : Array, s2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a2 = 0, u2 = s2.length; a2 < u2; ++a2)
    n2[a2] = s2[a2], i2[s2.charCodeAt(a2)] = a2;
  function c2(t3) {
    var e4 = t3.length;
    if (e4 % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var r3 = t3.indexOf("=");
    return -1 === r3 && (r3 = e4), [r3, r3 === e4 ? 0 : 4 - r3 % 4];
  }
  function l2(t3) {
    return n2[t3 >> 18 & 63] + n2[t3 >> 12 & 63] + n2[t3 >> 6 & 63] + n2[63 & t3];
  }
  function f2(t3, e4, r3) {
    for (var n3, i3 = [], o3 = e4; o3 < r3; o3 += 3)
      n3 = (t3[o3] << 16 & 16711680) + (t3[o3 + 1] << 8 & 65280) + (255 & t3[o3 + 2]), i3.push(l2(n3));
    return i3.join("");
  }
  i2["-".charCodeAt(0)] = 62, i2["_".charCodeAt(0)] = 63;
}, function(t2, e3) {
  e3.read = function(t3, e4, r2, n2, i2) {
    var o2, s2, a2 = 8 * i2 - n2 - 1, u2 = (1 << a2) - 1, c2 = u2 >> 1, l2 = -7, f2 = r2 ? i2 - 1 : 0, h2 = r2 ? -1 : 1, p2 = t3[e4 + f2];
    for (f2 += h2, o2 = p2 & (1 << -l2) - 1, p2 >>= -l2, l2 += a2; l2 > 0; o2 = 256 * o2 + t3[e4 + f2], f2 += h2, l2 -= 8)
      ;
    for (s2 = o2 & (1 << -l2) - 1, o2 >>= -l2, l2 += n2; l2 > 0; s2 = 256 * s2 + t3[e4 + f2], f2 += h2, l2 -= 8)
      ;
    if (0 === o2)
      o2 = 1 - c2;
    else {
      if (o2 === u2)
        return s2 ? NaN : 1 / 0 * (p2 ? -1 : 1);
      s2 += Math.pow(2, n2), o2 -= c2;
    }
    return (p2 ? -1 : 1) * s2 * Math.pow(2, o2 - n2);
  }, e3.write = function(t3, e4, r2, n2, i2, o2) {
    var s2, a2, u2, c2 = 8 * o2 - i2 - 1, l2 = (1 << c2) - 1, f2 = l2 >> 1, h2 = 23 === i2 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p2 = n2 ? 0 : o2 - 1, d2 = n2 ? 1 : -1, _2 = e4 < 0 || 0 === e4 && 1 / e4 < 0 ? 1 : 0;
    for (e4 = Math.abs(e4), isNaN(e4) || e4 === 1 / 0 ? (a2 = isNaN(e4) ? 1 : 0, s2 = l2) : (s2 = Math.floor(Math.log(e4) / Math.LN2), e4 * (u2 = Math.pow(2, -s2)) < 1 && (s2--, u2 *= 2), (e4 += s2 + f2 >= 1 ? h2 / u2 : h2 * Math.pow(2, 1 - f2)) * u2 >= 2 && (s2++, u2 /= 2), s2 + f2 >= l2 ? (a2 = 0, s2 = l2) : s2 + f2 >= 1 ? (a2 = (e4 * u2 - 1) * Math.pow(2, i2), s2 += f2) : (a2 = e4 * Math.pow(2, f2 - 1) * Math.pow(2, i2), s2 = 0)); i2 >= 8; t3[r2 + p2] = 255 & a2, p2 += d2, a2 /= 256, i2 -= 8)
      ;
    for (s2 = s2 << i2 | a2, c2 += i2; c2 > 0; t3[r2 + p2] = 255 & s2, p2 += d2, s2 /= 256, c2 -= 8)
      ;
    t3[r2 + p2 - d2] |= 128 * _2;
  };
}, function(t2, e3) {
  var r2 = {}.toString;
  t2.exports = Array.isArray || function(t3) {
    return "[object Array]" == r2.call(t3);
  };
}, function(t2, e3) {
}, function(t2, e3, r2) {
  var n2 = r2(7).Buffer, i2 = r2(43);
  function o2(t3, e4, r3) {
    t3.copy(e4, r3);
  }
  t2.exports = function() {
    function t3() {
      !function(t4, e4) {
        if (!(t4 instanceof e4))
          throw new TypeError("Cannot call a class as a function");
      }(this, t3), this.head = null, this.tail = null, this.length = 0;
    }
    return t3.prototype.push = function(t4) {
      var e4 = { data: t4, next: null };
      this.length > 0 ? this.tail.next = e4 : this.head = e4, this.tail = e4, ++this.length;
    }, t3.prototype.unshift = function(t4) {
      var e4 = { data: t4, next: this.head };
      0 === this.length && (this.tail = e4), this.head = e4, ++this.length;
    }, t3.prototype.shift = function() {
      if (0 !== this.length) {
        var t4 = this.head.data;
        return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t4;
      }
    }, t3.prototype.clear = function() {
      this.head = this.tail = null, this.length = 0;
    }, t3.prototype.join = function(t4) {
      if (0 === this.length)
        return "";
      for (var e4 = this.head, r3 = "" + e4.data; e4 = e4.next; )
        r3 += t4 + e4.data;
      return r3;
    }, t3.prototype.concat = function(t4) {
      if (0 === this.length)
        return n2.alloc(0);
      if (1 === this.length)
        return this.head.data;
      for (var e4 = n2.allocUnsafe(t4 >>> 0), r3 = this.head, i3 = 0; r3; )
        o2(r3.data, e4, i3), i3 += r3.data.length, r3 = r3.next;
      return e4;
    }, t3;
  }(), i2 && i2.inspect && i2.inspect.custom && (t2.exports.prototype[i2.inspect.custom] = function() {
    var t3 = i2.inspect({ length: this.length });
    return this.constructor.name + " " + t3;
  });
}, function(t2, e3) {
}, function(t2, e3, r2) {
  (function(e4) {
    function r3(t3) {
      try {
        if (!e4.localStorage)
          return false;
      } catch (t4) {
        return false;
      }
      var r4 = e4.localStorage[t3];
      return null != r4 && "true" === String(r4).toLowerCase();
    }
    t2.exports = function(t3, e5) {
      if (r3("noDeprecation"))
        return t3;
      var n2 = false;
      return function() {
        if (!n2) {
          if (r3("throwDeprecation"))
            throw new Error(e5);
          r3("traceDeprecation") ? console.trace(e5) : console.warn(e5), n2 = true;
        }
        return t3.apply(this, arguments);
      };
    };
  }).call(this, r2(0));
}, function(t2, e3, r2) {
  t2.exports = o2;
  var n2 = r2(27), i2 = r2(5);
  function o2(t3) {
    if (!(this instanceof o2))
      return new o2(t3);
    n2.call(this, t3);
  }
  i2.inherits = r2(2), i2.inherits(o2, n2), o2.prototype._transform = function(t3, e4, r3) {
    r3(null, t3);
  };
}, function(t2, e3, r2) {
  t2.exports = r2(14);
}, function(t2, e3, r2) {
  t2.exports = r2(1);
}, function(t2, e3, r2) {
  t2.exports = r2(13).Transform;
}, function(t2, e3, r2) {
  t2.exports = r2(13).PassThrough;
}, function(t2, e3, r2) {
  Object.defineProperty(e3, "__esModule", { value: true }), e3.mergeParams = function(t3) {
    var e4 = { delimiter: ",", ignoreColumns: void 0, includeColumns: void 0, quote: '"', trim: true, checkType: false, ignoreEmpty: false, noheader: false, headers: void 0, flatKeys: false, maxRowLength: 0, checkColumn: false, escape: '"', colParser: {}, eol: void 0, alwaysSplitAtEOL: false, output: "json", nullObject: false, downstreamFormat: "line", needEmitAll: true };
    for (var r3 in t3 || (t3 = {}), t3)
      t3.hasOwnProperty(r3) && (Array.isArray(t3[r3]) ? e4[r3] = [].concat(t3[r3]) : e4[r3] = t3[r3]);
    return e4;
  };
}, function(t2, e3, r2) {
  Object.defineProperty(e3, "__esModule", { value: true }), e3.initParseRuntime = function(t3) {
    var e4 = t3.parseParam, r3 = { needProcessIgnoreColumn: false, needProcessIncludeColumn: false, selectedColumns: void 0, ended: false, hasError: false, error: void 0, delimiter: t3.parseParam.delimiter, eol: t3.parseParam.eol, columnConv: [], headerType: [], headerTitle: [], headerFlag: [], headers: void 0, started: false, parsedLineNumber: 0, columnValueSetter: [] };
    return e4.ignoreColumns && (r3.needProcessIgnoreColumn = true), e4.includeColumns && (r3.needProcessIncludeColumn = true), r3;
  };
}, function(t2, e3, r2) {
  (function(t3) {
    var n2 = this && this.__extends || function() {
      var t4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t5, e4) {
        t5.__proto__ = e4;
      } || function(t5, e4) {
        for (var r3 in e4)
          e4.hasOwnProperty(r3) && (t5[r3] = e4[r3]);
      };
      return function(e4, r3) {
        function n3() {
          this.constructor = e4;
        }
        t4(e4, r3), e4.prototype = null === r3 ? Object.create(r3) : (n3.prototype = r3.prototype, new n3());
      };
    }(), i2 = this && this.__importDefault || function(t4) {
      return t4 && t4.__esModule ? t4 : { default: t4 };
    };
    Object.defineProperty(e3, "__esModule", { value: true });
    var o2 = r2(53), s2 = i2(r2(15)), a2 = r2(54), u2 = i2(r2(16)), c2 = r2(57), l2 = r2(28), f2 = r2(58), h2 = i2(r2(59)), p2 = i2(r2(29)), d2 = function(e4) {
      function r3() {
        var t4 = null !== e4 && e4.apply(this, arguments) || this;
        return t4.rowSplit = new f2.RowSplit(t4.converter), t4.eolEmitted = false, t4._needEmitEol = void 0, t4.headEmitted = false, t4._needEmitHead = void 0, t4;
      }
      return n2(r3, e4), r3.prototype.flush = function() {
        var t4 = this;
        if (this.runtime.csvLineBuffer && this.runtime.csvLineBuffer.length > 0) {
          var e5 = this.runtime.csvLineBuffer;
          return this.runtime.csvLineBuffer = void 0, this.process(e5, true).then(function(e6) {
            return t4.runtime.csvLineBuffer && t4.runtime.csvLineBuffer.length > 0 ? s2.default.reject(p2.default.unclosed_quote(t4.runtime.parsedLineNumber, t4.runtime.csvLineBuffer.toString())) : s2.default.resolve(e6);
          });
        }
        return s2.default.resolve([]);
      }, r3.prototype.destroy = function() {
        return s2.default.resolve();
      }, Object.defineProperty(r3.prototype, "needEmitEol", { get: function() {
        return void 0 === this._needEmitEol && (this._needEmitEol = this.converter.listeners("eol").length > 0), this._needEmitEol;
      }, enumerable: true, configurable: true }), Object.defineProperty(r3.prototype, "needEmitHead", { get: function() {
        return void 0 === this._needEmitHead && (this._needEmitHead = this.converter.listeners("header").length > 0), this._needEmitHead;
      }, enumerable: true, configurable: true }), r3.prototype.process = function(t4, e5) {
        var r4, n3 = this;
        return void 0 === e5 && (e5 = false), r4 = e5 ? t4.toString() : a2.prepareData(t4, this.converter.parseRuntime), s2.default.resolve().then(function() {
          return n3.runtime.preRawDataHook ? n3.runtime.preRawDataHook(r4) : r4;
        }).then(function(t5) {
          return t5 && t5.length > 0 ? n3.processCSV(t5, e5) : s2.default.resolve([]);
        });
      }, r3.prototype.processCSV = function(t4, e5) {
        var r4 = this, n3 = this.params, i3 = this.runtime;
        i3.eol || u2.default(t4, i3), this.needEmitEol && !this.eolEmitted && i3.eol && (this.converter.emit("eol", i3.eol), this.eolEmitted = true), n3.ignoreEmpty && !i3.started && (t4 = l2.trimLeft(t4));
        var o3 = c2.stringToLines(t4, i3);
        return e5 ? (o3.lines.push(o3.partial), o3.partial = "") : this.prependLeftBuf(l2.bufFromString(o3.partial)), o3.lines.length > 0 ? (i3.preFileLineHook ? this.runPreLineHook(o3.lines) : s2.default.resolve(o3.lines)).then(function(t5) {
          return i3.started || r4.runtime.headers ? r4.processCSVBody(t5) : r4.processDataWithHead(t5);
        }) : s2.default.resolve([]);
      }, r3.prototype.processDataWithHead = function(t4) {
        if (this.params.noheader)
          this.params.headers ? this.runtime.headers = this.params.headers : this.runtime.headers = [];
        else {
          for (var e5 = "", r4 = []; t4.length; ) {
            var n3 = e5 + t4.shift(), i3 = this.rowSplit.parse(n3);
            if (i3.closed) {
              r4 = i3.cells, e5 = "";
              break;
            }
            e5 = n3 + u2.default(n3, this.runtime);
          }
          if (this.prependLeftBuf(l2.bufFromString(e5)), 0 === r4.length)
            return [];
          this.params.headers ? this.runtime.headers = this.params.headers : this.runtime.headers = r4;
        }
        return (this.runtime.needProcessIgnoreColumn || this.runtime.needProcessIncludeColumn) && this.filterHeader(), this.needEmitHead && !this.headEmitted && (this.converter.emit("header", this.runtime.headers), this.headEmitted = true), this.processCSVBody(t4);
      }, r3.prototype.filterHeader = function() {
        if (this.runtime.selectedColumns = [], this.runtime.headers) {
          for (var t4 = this.runtime.headers, e5 = 0; e5 < t4.length; e5++)
            if (this.params.ignoreColumns)
              if (this.params.ignoreColumns.test(t4[e5])) {
                if (!this.params.includeColumns || !this.params.includeColumns.test(t4[e5]))
                  continue;
                this.runtime.selectedColumns.push(e5);
              } else
                this.runtime.selectedColumns.push(e5);
            else
              this.params.includeColumns ? this.params.includeColumns.test(t4[e5]) && this.runtime.selectedColumns.push(e5) : this.runtime.selectedColumns.push(e5);
          this.runtime.headers = l2.filterArray(this.runtime.headers, this.runtime.selectedColumns);
        }
      }, r3.prototype.processCSVBody = function(t4) {
        if ("line" === this.params.output)
          return t4;
        var e5 = this.rowSplit.parseMultiLines(t4);
        return this.prependLeftBuf(l2.bufFromString(e5.partial)), "csv" === this.params.output ? e5.rowsCells : h2.default(e5.rowsCells, this.converter);
      }, r3.prototype.prependLeftBuf = function(e5) {
        e5 && (this.runtime.csvLineBuffer ? this.runtime.csvLineBuffer = t3.concat([e5, this.runtime.csvLineBuffer]) : this.runtime.csvLineBuffer = e5);
      }, r3.prototype.runPreLineHook = function(t4) {
        var e5 = this;
        return new s2.default(function(r4, n3) {
          !function t5(e6, r5, n4, i3) {
            if (n4 >= e6.length)
              i3();
            else if (r5.preFileLineHook) {
              var o3 = e6[n4], s3 = r5.preFileLineHook(o3, r5.parsedLineNumber + n4);
              if (n4++, s3 && s3.then)
                s3.then(function(o4) {
                  e6[n4 - 1] = o4, t5(e6, r5, n4, i3);
                });
              else {
                for (e6[n4 - 1] = s3; n4 < e6.length; )
                  e6[n4] = r5.preFileLineHook(e6[n4], r5.parsedLineNumber + n4), n4++;
                i3();
              }
            } else
              i3();
          }(t4, e5.runtime, 0, function(e6) {
            e6 ? n3(e6) : r4(t4);
          });
        });
      }, r3;
    }(o2.Processor);
    e3.ProcessorLocal = d2;
  }).call(this, r2(3).Buffer);
}, function(t2, e3, r2) {
  Object.defineProperty(e3, "__esModule", { value: true });
  var n2 = function(t3) {
    this.converter = t3, this.params = t3.parseParam, this.runtime = t3.parseRuntime;
  };
  e3.Processor = n2;
}, function(t2, e3, r2) {
  (function(t3) {
    var n2 = this && this.__importDefault || function(t4) {
      return t4 && t4.__esModule ? t4 : { default: t4 };
    };
    Object.defineProperty(e3, "__esModule", { value: true });
    var i2 = n2(r2(55));
    e3.prepareData = function(e4, r3) {
      var n3 = function(e5, r4) {
        return r4.csvLineBuffer && r4.csvLineBuffer.length > 0 ? t3.concat([r4.csvLineBuffer, e5]) : e5;
      }(e4, r3);
      r3.csvLineBuffer = void 0;
      var o2 = function(t4, e5) {
        var r4 = t4.length - 1;
        if (0 != (128 & t4[r4])) {
          for (; 128 == (192 & t4[r4]); )
            r4--;
          r4--;
        }
        return r4 != t4.length - 1 ? (e5.csvLineBuffer = t4.slice(r4 + 1), t4.slice(0, r4 + 1)) : t4;
      }(n3, r3).toString("utf8");
      return false === r3.started ? i2.default(o2) : o2;
    };
  }).call(this, r2(3).Buffer);
}, function(t2, e3, r2) {
  (function(e4) {
    var n2 = r2(56);
    t2.exports = function(t3) {
      return "string" == typeof t3 && 65279 === t3.charCodeAt(0) ? t3.slice(1) : e4.isBuffer(t3) && n2(t3) && 239 === t3[0] && 187 === t3[1] && 191 === t3[2] ? t3.slice(3) : t3;
    };
  }).call(this, r2(3).Buffer);
}, function(t2, e3) {
  t2.exports = function(t3) {
    for (var e4 = 0; e4 < t3.length; )
      if (9 == t3[e4] || 10 == t3[e4] || 13 == t3[e4] || 32 <= t3[e4] && t3[e4] <= 126)
        e4 += 1;
      else if (194 <= t3[e4] && t3[e4] <= 223 && 128 <= t3[e4 + 1] && t3[e4 + 1] <= 191)
        e4 += 2;
      else if (224 == t3[e4] && 160 <= t3[e4 + 1] && t3[e4 + 1] <= 191 && 128 <= t3[e4 + 2] && t3[e4 + 2] <= 191 || (225 <= t3[e4] && t3[e4] <= 236 || 238 == t3[e4] || 239 == t3[e4]) && 128 <= t3[e4 + 1] && t3[e4 + 1] <= 191 && 128 <= t3[e4 + 2] && t3[e4 + 2] <= 191 || 237 == t3[e4] && 128 <= t3[e4 + 1] && t3[e4 + 1] <= 159 && 128 <= t3[e4 + 2] && t3[e4 + 2] <= 191)
        e4 += 3;
      else {
        if (!(240 == t3[e4] && 144 <= t3[e4 + 1] && t3[e4 + 1] <= 191 && 128 <= t3[e4 + 2] && t3[e4 + 2] <= 191 && 128 <= t3[e4 + 3] && t3[e4 + 3] <= 191 || 241 <= t3[e4] && t3[e4] <= 243 && 128 <= t3[e4 + 1] && t3[e4 + 1] <= 191 && 128 <= t3[e4 + 2] && t3[e4 + 2] <= 191 && 128 <= t3[e4 + 3] && t3[e4 + 3] <= 191 || 244 == t3[e4] && 128 <= t3[e4 + 1] && t3[e4 + 1] <= 143 && 128 <= t3[e4 + 2] && t3[e4 + 2] <= 191 && 128 <= t3[e4 + 3] && t3[e4 + 3] <= 191))
          return false;
        e4 += 4;
      }
    return true;
  };
}, function(t2, e3, r2) {
  var n2 = this && this.__importDefault || function(t3) {
    return t3 && t3.__esModule ? t3 : { default: t3 };
  };
  Object.defineProperty(e3, "__esModule", { value: true });
  var i2 = n2(r2(16));
  e3.stringToLines = function(t3, e4) {
    var r3 = i2.default(t3, e4), n3 = t3.split(r3);
    return { lines: n3, partial: n3.pop() || "" };
  };
}, function(t2, e3, r2) {
  var n2 = this && this.__importDefault || function(t3) {
    return t3 && t3.__esModule ? t3 : { default: t3 };
  };
  Object.defineProperty(e3, "__esModule", { value: true });
  var i2 = n2(r2(16)), o2 = r2(28), s2 = [",", "|", "	", ";", ":"], a2 = function() {
    function t3(t4) {
      this.conv = t4, this.cachedRegExp = {}, this.delimiterEmitted = false, this._needEmitDelimiter = void 0, this.quote = t4.parseParam.quote, this.trim = t4.parseParam.trim, this.escape = t4.parseParam.escape;
    }
    return Object.defineProperty(t3.prototype, "needEmitDelimiter", { get: function() {
      return void 0 === this._needEmitDelimiter && (this._needEmitDelimiter = this.conv.listeners("delimiter").length > 0), this._needEmitDelimiter;
    }, enumerable: true, configurable: true }), t3.prototype.parse = function(t4) {
      if (0 === t4.length || this.conv.parseParam.ignoreEmpty && 0 === t4.trim().length)
        return { cells: [], closed: true };
      var e4 = this.quote, r3 = this.trim;
      this.escape, (this.conv.parseRuntime.delimiter instanceof Array || "auto" === this.conv.parseRuntime.delimiter.toLowerCase()) && (this.conv.parseRuntime.delimiter = this.getDelimiter(t4)), this.needEmitDelimiter && !this.delimiterEmitted && (this.conv.emit("delimiter", this.conv.parseRuntime.delimiter), this.delimiterEmitted = true);
      var n3 = this.conv.parseRuntime.delimiter, i3 = t4.split(n3);
      if ("off" === e4) {
        if (r3)
          for (var o3 = 0; o3 < i3.length; o3++)
            i3[o3] = i3[o3].trim();
        return { cells: i3, closed: true };
      }
      return this.toCSVRow(i3, r3, e4, n3);
    }, t3.prototype.toCSVRow = function(t4, e4, r3, n3) {
      for (var i3 = [], s3 = false, a3 = "", u2 = 0, c2 = t4.length; u2 < c2; u2++) {
        var l2 = t4[u2];
        !s3 && e4 && (l2 = o2.trimLeft(l2));
        var f2 = l2.length;
        if (s3)
          this.isQuoteClose(l2) ? (s3 = false, a3 += n3 + (l2 = l2.substr(0, f2 - 1)), a3 = this.escapeQuote(a3), e4 && (a3 = o2.trimRight(a3)), i3.push(a3), a3 = "") : a3 += n3 + l2;
        else {
          if (2 === f2 && l2 === this.quote + this.quote) {
            i3.push("");
            continue;
          }
          if (this.isQuoteOpen(l2)) {
            if (l2 = l2.substr(1), this.isQuoteClose(l2)) {
              l2 = l2.substring(0, l2.lastIndexOf(r3)), l2 = this.escapeQuote(l2), i3.push(l2);
              continue;
            }
            if (-1 !== l2.indexOf(r3)) {
              for (var h2 = 0, p2 = "", d2 = 0, _2 = l2; d2 < _2.length; d2++) {
                var v5 = _2[d2];
                v5 === r3 && p2 !== this.escape ? (h2++, p2 = "") : p2 = v5;
              }
              if (h2 % 2 == 1) {
                e4 && (l2 = o2.trimRight(l2)), i3.push(r3 + l2);
                continue;
              }
              s3 = true, a3 += l2;
              continue;
            }
            s3 = true, a3 += l2;
            continue;
          }
          e4 && (l2 = o2.trimRight(l2)), i3.push(l2);
        }
      }
      return { cells: i3, closed: !s3 };
    }, t3.prototype.getDelimiter = function(t4) {
      var e4;
      if ("auto" === this.conv.parseParam.delimiter)
        e4 = s2;
      else {
        if (!(this.conv.parseParam.delimiter instanceof Array))
          return this.conv.parseParam.delimiter;
        e4 = this.conv.parseParam.delimiter;
      }
      var r3 = 0, n3 = ",";
      return e4.forEach(function(e5) {
        var i3 = t4.split(e5).length;
        i3 > r3 && (n3 = e5, r3 = i3);
      }), n3;
    }, t3.prototype.isQuoteOpen = function(t4) {
      var e4 = this.quote, r3 = this.escape;
      return t4[0] === e4 && (t4[1] !== e4 || t4[1] === r3 && (t4[2] === e4 || 2 === t4.length));
    }, t3.prototype.isQuoteClose = function(t4) {
      var e4 = this.quote, r3 = this.escape;
      this.conv.parseParam.trim && (t4 = o2.trimRight(t4));
      for (var n3 = 0, i3 = t4.length - 1; t4[i3] === e4 || t4[i3] === r3; )
        i3--, n3++;
      return n3 % 2 != 0;
    }, t3.prototype.escapeQuote = function(t4) {
      var e4 = "es|" + this.quote + "|" + this.escape;
      void 0 === this.cachedRegExp[e4] && (this.cachedRegExp[e4] = new RegExp("\\" + this.escape + "\\" + this.quote, "g"));
      var r3 = this.cachedRegExp[e4];
      return t4.replace(r3, this.quote);
    }, t3.prototype.parseMultiLines = function(t4) {
      for (var e4 = [], r3 = ""; t4.length; ) {
        var n3 = r3 + t4.shift(), s3 = this.parse(n3);
        0 === s3.cells.length && this.conv.parseParam.ignoreEmpty || (s3.closed || this.conv.parseParam.alwaysSplitAtEOL ? (this.conv.parseRuntime.selectedColumns ? e4.push(o2.filterArray(s3.cells, this.conv.parseRuntime.selectedColumns)) : e4.push(s3.cells), r3 = "") : r3 = n3 + (i2.default(n3, this.conv.parseRuntime) || "\n"));
      }
      return { rowsCells: e4, partial: r3 };
    }, t3;
  }();
  e3.RowSplit = a2;
}, function(t2, e3, r2) {
  var n2 = this && this.__importDefault || function(t3) {
    return t3 && t3.__esModule ? t3 : { default: t3 };
  };
  Object.defineProperty(e3, "__esModule", { value: true });
  var i2 = n2(r2(29)), o2 = n2(r2(60)), s2 = /^[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?$/;
  function a2(t3, e4, r3) {
    if (e4.parseParam.checkColumn && e4.parseRuntime.headers && t3.length !== e4.parseRuntime.headers.length)
      throw i2.default.column_mismatched(e4.parseRuntime.parsedLineNumber + r3);
    return function(t4, e5, r4) {
      for (var n3 = false, i3 = {}, o3 = 0, s3 = t4.length; o3 < s3; o3++) {
        var a3 = t4[o3];
        if (!r4.parseParam.ignoreEmpty || "" !== a3) {
          n3 = true;
          var u3 = e5[o3];
          u3 && "" !== u3 || (u3 = e5[o3] = "field" + (o3 + 1));
          var f3 = c2(u3, o3, r4);
          if (f3) {
            var h3 = f3(a3, u3, i3, t4, o3);
            void 0 !== h3 && l2(i3, u3, h3, r4, o3);
          } else {
            if (r4.parseParam.checkType)
              a3 = p2(a3, u3, o3, r4)(a3);
            void 0 !== a3 && l2(i3, u3, a3, r4, o3);
          }
        }
      }
      return n3 ? i3 : null;
    }(t3, e4.parseRuntime.headers || [], e4) || null;
  }
  e3.default = function(t3, e4) {
    for (var r3 = [], n3 = 0, i3 = t3.length; n3 < i3; n3++) {
      var o3 = a2(t3[n3], e4, n3);
      o3 && r3.push(o3);
    }
    return r3;
  };
  var u2 = { string: _2, number: d2, omit: function() {
  } };
  function c2(t3, e4, r3) {
    if (void 0 !== r3.parseRuntime.columnConv[e4])
      return r3.parseRuntime.columnConv[e4];
    var n3 = r3.parseParam.colParser[t3];
    if (void 0 === n3)
      return r3.parseRuntime.columnConv[e4] = null;
    if ("object" == typeof n3 && (n3 = n3.cellParser || "string"), "string" == typeof n3) {
      n3 = n3.trim().toLowerCase();
      var i3 = u2[n3];
      return r3.parseRuntime.columnConv[e4] = i3 || null;
    }
    return r3.parseRuntime.columnConv[e4] = "function" == typeof n3 ? n3 : null;
  }
  function l2(t3, e4, r3, n3, i3) {
    if (!n3.parseRuntime.columnValueSetter[i3])
      if (n3.parseParam.flatKeys)
        n3.parseRuntime.columnValueSetter[i3] = f2;
      else if (e4.indexOf(".") > -1) {
        for (var o3 = e4.split("."), s3 = true; o3.length > 0; )
          if (0 === o3.shift().length) {
            s3 = false;
            break;
          }
        !s3 || n3.parseParam.colParser[e4] && n3.parseParam.colParser[e4].flat ? n3.parseRuntime.columnValueSetter[i3] = f2 : n3.parseRuntime.columnValueSetter[i3] = h2;
      } else
        n3.parseRuntime.columnValueSetter[i3] = f2;
    true === n3.parseParam.nullObject && "null" === r3 && (r3 = null), n3.parseRuntime.columnValueSetter[i3](t3, e4, r3);
  }
  function f2(t3, e4, r3) {
    t3[e4] = r3;
  }
  function h2(t3, e4, r3) {
    o2.default(t3, e4, r3);
  }
  function p2(t3, e4, r3, n3) {
    return n3.parseRuntime.headerType[r3] ? n3.parseRuntime.headerType[r3] : e4.indexOf("number#!") > -1 ? n3.parseRuntime.headerType[r3] = d2 : e4.indexOf("string#!") > -1 ? n3.parseRuntime.headerType[r3] = _2 : n3.parseParam.checkType ? n3.parseRuntime.headerType[r3] = v5 : n3.parseRuntime.headerType[r3] = _2;
  }
  function d2(t3) {
    var e4 = parseFloat(t3);
    return isNaN(e4) ? t3 : e4;
  }
  function _2(t3) {
    return t3.toString();
  }
  function v5(t3) {
    var e4 = t3.trim();
    return "" === e4 ? _2(t3) : s2.test(e4) ? d2(t3) : 5 === e4.length && "false" === e4.toLowerCase() || 4 === e4.length && "true" === e4.toLowerCase() ? function(t4) {
      var e5 = t4.trim();
      return 5 !== e5.length || "false" !== e5.toLowerCase();
    }(t3) : "{" === e4[0] && "}" === e4[e4.length - 1] || "[" === e4[0] && "]" === e4[e4.length - 1] ? function(t4) {
      try {
        return JSON.parse(t4);
      } catch (e5) {
        return t4;
      }
    }(t3) : _2(t3);
  }
}, function(t2, e3, r2) {
  var n2 = r2(61);
  t2.exports = function(t3, e4, r3) {
    return null == t3 ? t3 : n2(t3, e4, r3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(62), i2 = r2(74), o2 = r2(103), s2 = r2(20), a2 = r2(104);
  t2.exports = function(t3, e4, r3, u2) {
    if (!s2(t3))
      return t3;
    for (var c2 = -1, l2 = (e4 = i2(e4, t3)).length, f2 = l2 - 1, h2 = t3; null != h2 && ++c2 < l2; ) {
      var p2 = a2(e4[c2]), d2 = r3;
      if (c2 != f2) {
        var _2 = h2[p2];
        void 0 === (d2 = u2 ? u2(_2, p2, h2) : void 0) && (d2 = s2(_2) ? _2 : o2(e4[c2 + 1]) ? [] : {});
      }
      n2(h2, p2, d2), h2 = h2[p2];
    }
    return t3;
  };
}, function(t2, e3, r2) {
  var n2 = r2(63), i2 = r2(31), o2 = Object.prototype.hasOwnProperty;
  t2.exports = function(t3, e4, r3) {
    var s2 = t3[e4];
    o2.call(t3, e4) && i2(s2, r3) && (void 0 !== r3 || e4 in t3) || n2(t3, e4, r3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(64);
  t2.exports = function(t3, e4, r3) {
    "__proto__" == e4 && n2 ? n2(t3, e4, { configurable: true, enumerable: true, value: r3, writable: true }) : t3[e4] = r3;
  };
}, function(t2, e3, r2) {
  var n2 = r2(17), i2 = function() {
    try {
      var t3 = n2(Object, "defineProperty");
      return t3({}, "", {}), t3;
    } catch (t4) {
    }
  }();
  t2.exports = i2;
}, function(t2, e3, r2) {
  var n2 = r2(66), i2 = r2(70), o2 = r2(20), s2 = r2(72), a2 = /^\[object .+?Constructor\]$/, u2 = Function.prototype, c2 = Object.prototype, l2 = u2.toString, f2 = c2.hasOwnProperty, h2 = RegExp("^" + l2.call(f2).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  t2.exports = function(t3) {
    return !(!o2(t3) || i2(t3)) && (n2(t3) ? h2 : a2).test(s2(t3));
  };
}, function(t2, e3, r2) {
  var n2 = r2(30), i2 = r2(20);
  t2.exports = function(t3) {
    if (!i2(t3))
      return false;
    var e4 = n2(t3);
    return "[object Function]" == e4 || "[object GeneratorFunction]" == e4 || "[object AsyncFunction]" == e4 || "[object Proxy]" == e4;
  };
}, function(t2, e3, r2) {
  (function(e4) {
    var r3 = "object" == typeof e4 && e4 && e4.Object === Object && e4;
    t2.exports = r3;
  }).call(this, r2(0));
}, function(t2, e3, r2) {
  var n2 = r2(18), i2 = Object.prototype, o2 = i2.hasOwnProperty, s2 = i2.toString, a2 = n2 ? n2.toStringTag : void 0;
  t2.exports = function(t3) {
    var e4 = o2.call(t3, a2), r3 = t3[a2];
    try {
      t3[a2] = void 0;
      var n3 = true;
    } catch (t4) {
    }
    var i3 = s2.call(t3);
    return n3 && (e4 ? t3[a2] = r3 : delete t3[a2]), i3;
  };
}, function(t2, e3) {
  var r2 = Object.prototype.toString;
  t2.exports = function(t3) {
    return r2.call(t3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(71), i2 = function() {
    var t3 = /[^.]+$/.exec(n2 && n2.keys && n2.keys.IE_PROTO || "");
    return t3 ? "Symbol(src)_1." + t3 : "";
  }();
  t2.exports = function(t3) {
    return !!i2 && i2 in t3;
  };
}, function(t2, e3, r2) {
  var n2 = r2(19)["__core-js_shared__"];
  t2.exports = n2;
}, function(t2, e3) {
  var r2 = Function.prototype.toString;
  t2.exports = function(t3) {
    if (null != t3) {
      try {
        return r2.call(t3);
      } catch (t4) {
      }
      try {
        return t3 + "";
      } catch (t4) {
      }
    }
    return "";
  };
}, function(t2, e3) {
  t2.exports = function(t3, e4) {
    return null == t3 ? void 0 : t3[e4];
  };
}, function(t2, e3, r2) {
  var n2 = r2(21), i2 = r2(75), o2 = r2(77), s2 = r2(100);
  t2.exports = function(t3, e4) {
    return n2(t3) ? t3 : i2(t3, e4) ? [t3] : o2(s2(t3));
  };
}, function(t2, e3, r2) {
  var n2 = r2(21), i2 = r2(22), o2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, s2 = /^\w*$/;
  t2.exports = function(t3, e4) {
    if (n2(t3))
      return false;
    var r3 = typeof t3;
    return !("number" != r3 && "symbol" != r3 && "boolean" != r3 && null != t3 && !i2(t3)) || s2.test(t3) || !o2.test(t3) || null != e4 && t3 in Object(e4);
  };
}, function(t2, e3) {
  t2.exports = function(t3) {
    return null != t3 && "object" == typeof t3;
  };
}, function(t2, e3, r2) {
  var n2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, i2 = /\\(\\)?/g, o2 = r2(78)(function(t3) {
    var e4 = [];
    return 46 === t3.charCodeAt(0) && e4.push(""), t3.replace(n2, function(t4, r3, n3, o3) {
      e4.push(n3 ? o3.replace(i2, "$1") : r3 || t4);
    }), e4;
  });
  t2.exports = o2;
}, function(t2, e3, r2) {
  var n2 = r2(79);
  t2.exports = function(t3) {
    var e4 = n2(t3, function(t4) {
      return 500 === r3.size && r3.clear(), t4;
    }), r3 = e4.cache;
    return e4;
  };
}, function(t2, e3, r2) {
  var n2 = r2(80), i2 = "Expected a function";
  function o2(t3, e4) {
    if ("function" != typeof t3 || null != e4 && "function" != typeof e4)
      throw new TypeError(i2);
    var r3 = function() {
      var n3 = arguments, i3 = e4 ? e4.apply(this, n3) : n3[0], o3 = r3.cache;
      if (o3.has(i3))
        return o3.get(i3);
      var s2 = t3.apply(this, n3);
      return r3.cache = o3.set(i3, s2) || o3, s2;
    };
    return r3.cache = new (o2.Cache || n2)(), r3;
  }
  o2.Cache = n2, t2.exports = o2;
}, function(t2, e3, r2) {
  var n2 = r2(81), i2 = r2(95), o2 = r2(97), s2 = r2(98), a2 = r2(99);
  function u2(t3) {
    var e4 = -1, r3 = null == t3 ? 0 : t3.length;
    for (this.clear(); ++e4 < r3; ) {
      var n3 = t3[e4];
      this.set(n3[0], n3[1]);
    }
  }
  u2.prototype.clear = n2, u2.prototype.delete = i2, u2.prototype.get = o2, u2.prototype.has = s2, u2.prototype.set = a2, t2.exports = u2;
}, function(t2, e3, r2) {
  var n2 = r2(82), i2 = r2(88), o2 = r2(94);
  t2.exports = function() {
    this.size = 0, this.__data__ = { hash: new n2(), map: new (o2 || i2)(), string: new n2() };
  };
}, function(t2, e3, r2) {
  var n2 = r2(83), i2 = r2(84), o2 = r2(85), s2 = r2(86), a2 = r2(87);
  function u2(t3) {
    var e4 = -1, r3 = null == t3 ? 0 : t3.length;
    for (this.clear(); ++e4 < r3; ) {
      var n3 = t3[e4];
      this.set(n3[0], n3[1]);
    }
  }
  u2.prototype.clear = n2, u2.prototype.delete = i2, u2.prototype.get = o2, u2.prototype.has = s2, u2.prototype.set = a2, t2.exports = u2;
}, function(t2, e3, r2) {
  var n2 = r2(8);
  t2.exports = function() {
    this.__data__ = n2 ? n2(null) : {}, this.size = 0;
  };
}, function(t2, e3) {
  t2.exports = function(t3) {
    var e4 = this.has(t3) && delete this.__data__[t3];
    return this.size -= e4 ? 1 : 0, e4;
  };
}, function(t2, e3, r2) {
  var n2 = r2(8), i2 = Object.prototype.hasOwnProperty;
  t2.exports = function(t3) {
    var e4 = this.__data__;
    if (n2) {
      var r3 = e4[t3];
      return "__lodash_hash_undefined__" === r3 ? void 0 : r3;
    }
    return i2.call(e4, t3) ? e4[t3] : void 0;
  };
}, function(t2, e3, r2) {
  var n2 = r2(8), i2 = Object.prototype.hasOwnProperty;
  t2.exports = function(t3) {
    var e4 = this.__data__;
    return n2 ? void 0 !== e4[t3] : i2.call(e4, t3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(8);
  t2.exports = function(t3, e4) {
    var r3 = this.__data__;
    return this.size += this.has(t3) ? 0 : 1, r3[t3] = n2 && void 0 === e4 ? "__lodash_hash_undefined__" : e4, this;
  };
}, function(t2, e3, r2) {
  var n2 = r2(89), i2 = r2(90), o2 = r2(91), s2 = r2(92), a2 = r2(93);
  function u2(t3) {
    var e4 = -1, r3 = null == t3 ? 0 : t3.length;
    for (this.clear(); ++e4 < r3; ) {
      var n3 = t3[e4];
      this.set(n3[0], n3[1]);
    }
  }
  u2.prototype.clear = n2, u2.prototype.delete = i2, u2.prototype.get = o2, u2.prototype.has = s2, u2.prototype.set = a2, t2.exports = u2;
}, function(t2, e3) {
  t2.exports = function() {
    this.__data__ = [], this.size = 0;
  };
}, function(t2, e3, r2) {
  var n2 = r2(9), i2 = Array.prototype.splice;
  t2.exports = function(t3) {
    var e4 = this.__data__, r3 = n2(e4, t3);
    return !(r3 < 0 || (r3 == e4.length - 1 ? e4.pop() : i2.call(e4, r3, 1), --this.size, 0));
  };
}, function(t2, e3, r2) {
  var n2 = r2(9);
  t2.exports = function(t3) {
    var e4 = this.__data__, r3 = n2(e4, t3);
    return r3 < 0 ? void 0 : e4[r3][1];
  };
}, function(t2, e3, r2) {
  var n2 = r2(9);
  t2.exports = function(t3) {
    return n2(this.__data__, t3) > -1;
  };
}, function(t2, e3, r2) {
  var n2 = r2(9);
  t2.exports = function(t3, e4) {
    var r3 = this.__data__, i2 = n2(r3, t3);
    return i2 < 0 ? (++this.size, r3.push([t3, e4])) : r3[i2][1] = e4, this;
  };
}, function(t2, e3, r2) {
  var n2 = r2(17)(r2(19), "Map");
  t2.exports = n2;
}, function(t2, e3, r2) {
  var n2 = r2(10);
  t2.exports = function(t3) {
    var e4 = n2(this, t3).delete(t3);
    return this.size -= e4 ? 1 : 0, e4;
  };
}, function(t2, e3) {
  t2.exports = function(t3) {
    var e4 = typeof t3;
    return "string" == e4 || "number" == e4 || "symbol" == e4 || "boolean" == e4 ? "__proto__" !== t3 : null === t3;
  };
}, function(t2, e3, r2) {
  var n2 = r2(10);
  t2.exports = function(t3) {
    return n2(this, t3).get(t3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(10);
  t2.exports = function(t3) {
    return n2(this, t3).has(t3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(10);
  t2.exports = function(t3, e4) {
    var r3 = n2(this, t3), i2 = r3.size;
    return r3.set(t3, e4), this.size += r3.size == i2 ? 0 : 1, this;
  };
}, function(t2, e3, r2) {
  var n2 = r2(101);
  t2.exports = function(t3) {
    return null == t3 ? "" : n2(t3);
  };
}, function(t2, e3, r2) {
  var n2 = r2(18), i2 = r2(102), o2 = r2(21), s2 = r2(22), a2 = n2 ? n2.prototype : void 0, u2 = a2 ? a2.toString : void 0;
  t2.exports = function t3(e4) {
    if ("string" == typeof e4)
      return e4;
    if (o2(e4))
      return i2(e4, t3) + "";
    if (s2(e4))
      return u2 ? u2.call(e4) : "";
    var r3 = e4 + "";
    return "0" == r3 && 1 / e4 == -1 / 0 ? "-0" : r3;
  };
}, function(t2, e3) {
  t2.exports = function(t3, e4) {
    for (var r2 = -1, n2 = null == t3 ? 0 : t3.length, i2 = Array(n2); ++r2 < n2; )
      i2[r2] = e4(t3[r2], r2, t3);
    return i2;
  };
}, function(t2, e3) {
  var r2 = /^(?:0|[1-9]\d*)$/;
  t2.exports = function(t3, e4) {
    var n2 = typeof t3;
    return !!(e4 = null == e4 ? 9007199254740991 : e4) && ("number" == n2 || "symbol" != n2 && r2.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < e4;
  };
}, function(t2, e3, r2) {
  var n2 = r2(22);
  t2.exports = function(t3) {
    if ("string" == typeof t3 || n2(t3))
      return t3;
    var e4 = t3 + "";
    return "0" == e4 && 1 / t3 == -1 / 0 ? "-0" : e4;
  };
}, function(t2, e3, r2) {
  var n2 = this && this.__importDefault || function(t3) {
    return t3 && t3.__esModule ? t3 : { default: t3 };
  };
  Object.defineProperty(e3, "__esModule", { value: true });
  var i2 = n2(r2(15)), o2 = r2(106), s2 = function() {
    function t3(t4) {
      this.converter = t4, this.finalResult = [];
    }
    return Object.defineProperty(t3.prototype, "needEmitLine", { get: function() {
      return !!this.converter.parseRuntime.subscribe && !!this.converter.parseRuntime.subscribe.onNext || this.needPushDownstream;
    }, enumerable: true, configurable: true }), Object.defineProperty(t3.prototype, "needPushDownstream", { get: function() {
      return void 0 === this._needPushDownstream && (this._needPushDownstream = this.converter.listeners("data").length > 0 || this.converter.listeners("readable").length > 0), this._needPushDownstream;
    }, enumerable: true, configurable: true }), Object.defineProperty(t3.prototype, "needEmitAll", { get: function() {
      return !!this.converter.parseRuntime.then && this.converter.parseParam.needEmitAll;
    }, enumerable: true, configurable: true }), t3.prototype.processResult = function(t4) {
      var e4 = this, r3 = this.converter.parseRuntime.parsedLineNumber;
      return this.needPushDownstream && "array" === this.converter.parseParam.downstreamFormat && 0 === r3 && a2(this.converter, "[" + o2.EOL), new i2.default(function(r4, n3) {
        e4.needEmitLine ? function t5(e5, r5, n4, i3, o3) {
          if (n4 >= e5.length)
            o3();
          else if (r5.parseRuntime.subscribe && r5.parseRuntime.subscribe.onNext) {
            var s3 = r5.parseRuntime.subscribe.onNext, u2 = e5[n4], c2 = s3(u2, r5.parseRuntime.parsedLineNumber + n4);
            if (n4++, c2 && c2.then)
              c2.then(function() {
                !function(e6, r6, n5, i4, o4, s4, u3) {
                  o4 && a2(n5, u3), t5(e6, n5, i4, o4, s4);
                }(e5, 0, r5, n4, i3, o3, u2);
              }, o3);
            else {
              for (i3 && a2(r5, u2); n4 < e5.length; ) {
                var l2 = e5[n4];
                s3(l2, r5.parseRuntime.parsedLineNumber + n4), n4++, i3 && a2(r5, l2);
              }
              o3();
            }
          } else {
            if (i3)
              for (; n4 < e5.length; )
                l2 = e5[n4++], a2(r5, l2);
            o3();
          }
        }(t4, e4.converter, 0, e4.needPushDownstream, function(i3) {
          i3 ? n3(i3) : (e4.appendFinalResult(t4), r4());
        }) : (e4.appendFinalResult(t4), r4());
      });
    }, t3.prototype.appendFinalResult = function(t4) {
      this.needEmitAll && (this.finalResult = this.finalResult.concat(t4)), this.converter.parseRuntime.parsedLineNumber += t4.length;
    }, t3.prototype.processError = function(t4) {
      this.converter.parseRuntime.subscribe && this.converter.parseRuntime.subscribe.onError && this.converter.parseRuntime.subscribe.onError(t4), this.converter.parseRuntime.then && this.converter.parseRuntime.then.onrejected && this.converter.parseRuntime.then.onrejected(t4);
    }, t3.prototype.endProcess = function() {
      this.converter.parseRuntime.then && this.converter.parseRuntime.then.onfulfilled && (this.needEmitAll ? this.converter.parseRuntime.then.onfulfilled(this.finalResult) : this.converter.parseRuntime.then.onfulfilled([])), this.converter.parseRuntime.subscribe && this.converter.parseRuntime.subscribe.onCompleted && this.converter.parseRuntime.subscribe.onCompleted(), this.needPushDownstream && "array" === this.converter.parseParam.downstreamFormat && a2(this.converter, "]" + o2.EOL);
    }, t3;
  }();
  function a2(t3, e4) {
    if ("object" != typeof e4 || t3.options.objectMode)
      t3.push(e4);
    else {
      var r3 = JSON.stringify(e4);
      t3.push(r3 + ("array" === t3.parseParam.downstreamFormat ? "," + o2.EOL : o2.EOL), "utf8");
    }
  }
  e3.Result = s2;
}, function(t2, e3) {
  e3.endianness = function() {
    return "LE";
  }, e3.hostname = function() {
    return "undefined" != typeof location ? location.hostname : "";
  }, e3.loadavg = function() {
    return [];
  }, e3.uptime = function() {
    return 0;
  }, e3.freemem = function() {
    return Number.MAX_VALUE;
  }, e3.totalmem = function() {
    return Number.MAX_VALUE;
  }, e3.cpus = function() {
    return [];
  }, e3.type = function() {
    return "Browser";
  }, e3.release = function() {
    return "undefined" != typeof navigator ? navigator.appVersion : "";
  }, e3.networkInterfaces = e3.getNetworkInterfaces = function() {
    return {};
  }, e3.arch = function() {
    return "javascript";
  }, e3.platform = function() {
    return "browser";
  }, e3.tmpdir = e3.tmpDir = function() {
    return "/tmp";
  }, e3.EOL = "\n", e3.homedir = function() {
    return "/";
  };
}]);
const KNOWN_PROPERTIES = {
  id: ["id"],
  lng: ["lon", "lng", "long", "longitude"],
  lat: ["lat", "latitude"],
  category: ["category"]
};
class CsvUtil {
  static getProperty(key, row) {
    const allKeys = KNOWN_PROPERTIES[key] || [key];
    let value;
    allKeys.some((key2) => {
      value = row[key2];
      return value !== void 0;
    });
    return value;
  }
  static async convertToGeoJson(data2) {
    const jsonArrayObj = await browser$1().fromString(data2);
    const features = [];
    jsonArrayObj.forEach((row) => {
      const id = CsvUtil.getProperty("id", row);
      let lng = CsvUtil.getProperty("lng", row);
      let lat = CsvUtil.getProperty("lat", row);
      if (!lng || !lat)
        return;
      lng = parseFloat(lng);
      lat = parseFloat(lat);
      features.push({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [lng, lat]
        },
        properties: row,
        id
      });
    });
    const featureCollection2 = {
      type: "FeatureCollection",
      features
    };
    return featureCollection2;
  }
}
class FileParserUtil {
  static async parseFile(data2, options2) {
    let result = null;
    const supportedImageFileFormats = FileUtil.SUPPORTED_IMAGE_FORMATS;
    const supportedCadFileFormats2 = FileUtil.SUPPORTED_CAD_FORMATS;
    try {
      if (data2) {
        if (data2.extension === "pdf") {
          result = await FileParserUtil.onPdfLoad(data2, options2);
        } else if (data2.extension === "csv") {
          result = await FileParserUtil.onCsvLoad(data2, options2);
        } else if (data2.extension === "tif" || data2.extension === "tiff") {
          result = await FileParserUtil.onGeoTiffLoad(data2, options2);
        } else if (["kml", "kmz"].includes(data2.extension)) {
          result = await FileParserUtil.onKmxLoad(data2, options2);
        } else if (data2.extension === "shp" || data2.extension === "zip") {
          result = await FileParserUtil.onShapeLoad(data2, options2);
        } else if (["json", "geojson"].includes(data2.extension)) {
          result = await FileParserUtil.onJsonFileLoad(data2, data2.extension === "geojson", options2);
        } else if (data2.extension === "dxf") {
          result = await FileParserUtil.onDxfFileLoad(data2, options2);
        } else if (data2.extension === "dwg") {
          result = await FileParserUtil.onDwgFileLoad(data2, options2);
        } else if (supportedCadFileFormats2 == null ? void 0 : supportedCadFileFormats2.includes(data2.extension)) {
          result = await FileParserUtil.onModel3dLoad(data2, options2);
        } else if (supportedImageFileFormats == null ? void 0 : supportedImageFileFormats.includes(data2.extension)) {
          result = await FileParserUtil.onImageFileLoad(data2, options2);
        }
      }
    } catch (error2) {
      console.error(error2);
    }
    if (result) {
      result.sourceFile = data2;
    }
    return result;
  }
  static async onCsvLoad(data2, options2) {
    const geoJsonData = await CsvUtil.convertToGeoJson(data2.data);
    const result = await FileParserUtil.onJsonFileLoad(geoJsonData, true, options2);
    return result;
  }
  static async onKmxLoad(data2, options2) {
    const geoJsonData = await KmlUtil.convertToGeoJson(data2.data, data2.extension);
    const result = await FileParserUtil.onJsonFileLoad(geoJsonData, true, options2);
    return result;
  }
  static async onShapeLoad(data2, options2) {
    const geoJsonData = await ShpUtil.convertToGeoJson(data2.data, data2.extension);
    const result = await FileParserUtil.onJsonFileLoad(geoJsonData, true, options2);
    return result;
  }
  static async onDxfFileLoad(data2, options2) {
    const convertedData = await DxfUtil.convertToGeoJson(data2.data, options2 == null ? void 0 : options2.center);
    if (!convertedData)
      return null;
    const {
      geojson,
      layers
    } = convertedData;
    const result = await FileParserUtil.onJsonFileLoad(geojson, true, options2);
    if (!result)
      return null;
    result.displayMode = "2d";
    result.layers = layers;
    if (!(options2 == null ? void 0 : options2.center)) {
      result.type = "NOT_GEOREFERENCED";
    }
    return result;
  }
  static async onDwgFileLoad(data2, options2) {
    const dxfDataUri = await DwgApsUtil.convertToDxf(data2.data);
    const dxfData = {
      data: dxfDataUri,
      dataType: "dataUrl",
      extension: "dxf",
      filename: data2.filename.replace(".dwg", ".dxf")
    };
    const result = await FileParserUtil.onDxfFileLoad(dxfData, options2);
    return result;
  }
  static async onPdfLoad(data2) {
    if (!(data2 == null ? void 0 : data2.data))
      return null;
    const thumbnails = await PdfUtil.converToImages(data2.data);
    const pdfAsset = {
      id: generateUid(),
      type: "PDF",
      displayMode: "2d",
      sourceFile: data2,
      thumbnails,
      // center: useSiteStore.getState().getDefaultCenter(),
      scale: [1, 1, 1],
      dip: 0,
      head: 0,
      azimuth: 0
    };
    return pdfAsset;
  }
  static async onModel3dLoad(data2) {
    if (!data2)
      return null;
    const model3d = {
      id: generateUid(),
      type: data2.extension === "dxf" ? "DXF" : "GLTF",
      displayMode: data2.extension === "dxf" ? "2d" : "3d",
      sourceFile: data2,
      // center: useSiteStore.getState().getDefaultCenter(),
      scale: [1, 1, 1],
      dip: 0,
      head: 0,
      azimuth: 0
      // parentId,
      // parentType,
    };
    return model3d;
  }
  static async onGeoTiffLoad(dataIn) {
    const data2 = dataIn;
    if (data2 == null ? void 0 : data2.data) {
      const geotiff = await GeoTiffUtil.extractImageAndBox(data2.data);
      if (!(geotiff == null ? void 0 : geotiff.length))
        return null;
      const assets = [];
      geotiff.forEach(({
        dataUrl,
        extension,
        box
      }) => {
        assets.push({
          id: generateUid(),
          type: "IMAGE",
          displayMode: "2d",
          sourceFile: {
            ...data2,
            dataType: "dataUrl",
            data: dataUrl,
            extension
          },
          thumbnail: dataUrl,
          visible: true,
          box
        });
      });
      return {
        type: "STORE",
        features: [],
        assetStore: {
          assets
        }
      };
    }
    return null;
  }
  static async onImageFileLoad(data2) {
    if (data2 == null ? void 0 : data2.data) {
      const assetData = {
        id: generateUid(),
        type: "IMAGE",
        displayMode: "2d",
        sourceFile: data2,
        // parentId,
        // parentType,
        visible: true,
        thumbnail: data2.data
      };
      return assetData;
    }
    return null;
  }
  static async onJsonFileLoad(dataIn, isGeoJsonIn, options2) {
    const {
      extractSite
    } = options2 || {};
    const {
      jsonData,
      isGeoJson
    } = ImportUtil.curateJsonForImport(dataIn, isGeoJsonIn, {
      // parentId,
      // parentType,
      category: "custom",
      extractSite
    });
    const assetsData = ImportUtil.importAssetsFromJson(jsonData, isGeoJson);
    if (!extractSite && isGeoJson) {
      const features = (jsonData == null ? void 0 : jsonData.type) === "Feature" ? [jsonData] : (jsonData == null ? void 0 : jsonData.features) || [];
      return {
        type: "STORE",
        features,
        // raw features
        assetStore: {
          assets: assetsData
        },
        siteStore: {}
      };
    }
    const projects = ImportUtil.importProjectFromJson(jsonData, isGeoJson);
    const existingState = {};
    const siteData = ImportUtil.importSiteFromJson(jsonData, isGeoJson, existingState);
    const result = siteData || {};
    if ((assetsData == null ? void 0 : assetsData.length) && !result.assets)
      result.assets = [];
    assetsData == null ? void 0 : assetsData.forEach((asset) => result.assets.push(asset));
    const {
      assets,
      ...siteStore
    } = result;
    return {
      type: "STORE",
      features: [],
      assetStore: {
        assets
      },
      siteStore,
      projectStore: {
        projects
      }
    };
  }
}
const debounce$3 = (func2, delay) => {
  let debounceTimer;
  return (...args) => {
    const context2 = globalThis;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func2.apply(context2, args), delay);
  };
};
const MAPBOX_BASE_URL = "https://api.mapbox.com/geocoding/v5/mapbox.places";
class GeocoderUtil {
  static getToken() {
    return useEnvStore.getState().env.mapboxToken;
  }
  // Convert address to latitude & longitude
  static async geocode(address = {}) {
    try {
      const queryParts = [];
      if (address.addressLine1)
        queryParts.push(address.addressLine1);
      if (address.addressLine2)
        queryParts.push(address.addressLine2);
      if (address.city)
        queryParts.push(address.city);
      if (address.state)
        queryParts.push(address.state);
      if (address.country)
        queryParts.push(address.country);
      if (address.postalCode)
        queryParts.push(address.postalCode);
      const query6 = queryParts.join(", ");
      const mapboxToken = this.getToken();
      if (!mapboxToken)
        throw new Error("Invalid Mapbox Token");
      const response = await fetch(`${MAPBOX_BASE_URL}/${encodeURIComponent(query6)}.json?access_token=${mapboxToken}&limit=1&language=en`);
      const data2 = await response.json();
      const result = GeocoderUtil.parseMapboxAddress(data2);
      if (!result)
        return address;
      if (address.addressLine1)
        result.addressLine1 = address.addressLine1;
      if (address.addressLine2)
        result.addressLine2 = address.addressLine2;
      if (address.city)
        result.city = address.city;
      if (address.state)
        result.state = address.state;
      if (address.country)
        result.country = address.country;
      if (address.postalCode)
        result.postalCode = address.postalCode;
      return result;
    } catch (error2) {
      console.error("Geocoding error:", error2);
    }
    return address;
  }
  // Convert latitude & longitude to address
  static async reverseGeocode(coordinate2) {
    try {
      if (!coordinate2 || Number.isNaN(coordinate2.longitude) || Number.isNaN(coordinate2.latitude))
        throw new Error("Not a valid coordinate");
      const mapboxToken = this.getToken();
      if (!mapboxToken)
        throw new Error("Invalid Mapbox Token");
      const response = await fetch(`${MAPBOX_BASE_URL}/${coordinate2.longitude},${coordinate2.latitude}.json?access_token=${mapboxToken}&limit=1&language=en`);
      const data2 = await (response == null ? void 0 : response.json());
      const result = GeocoderUtil.parseMapboxAddress(data2);
      return {
        ...result,
        ...coordinate2
      };
    } catch (error2) {
      console.error("Reverse geocoding error:", error2);
    }
    return coordinate2;
  }
  static parseMapboxAddress(data2) {
    var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h;
    if (((_a3 = data2 == null ? void 0 : data2.features) == null ? void 0 : _a3.length) > 0) {
      const place = data2 == null ? void 0 : data2.features[0];
      if (!place)
        return {};
      const context2 = place.context || [];
      const placeAddress = place.address || "";
      const placeText = place.text || "";
      const contextPostcode = ((_b3 = context2.find((c2) => c2.id.includes("postcode"))) == null ? void 0 : _b3.text) || "";
      const contextLocality = ((_c2 = context2.find((c2) => c2.id.includes("locality"))) == null ? void 0 : _c2.text) || "";
      const contextPlace = ((_d2 = context2.find((c2) => c2.id.includes("place"))) == null ? void 0 : _d2.text) || "";
      const contextDistrict = ((_e2 = context2.find((c2) => c2.id.includes("district"))) == null ? void 0 : _e2.text) || "";
      const contextRegion = ((_f3 = context2.find((c2) => c2.id.includes("region"))) == null ? void 0 : _f3.text) || "";
      const contextCountry = ((_g = context2.find((c2) => c2.id.includes("country"))) == null ? void 0 : _g.text) || "";
      const coord = (_h = place.geometry) == null ? void 0 : _h.coordinates;
      const latlng = {};
      if (coord) {
        latlng.longitude = coord[0];
        latlng.latitude = coord[1];
      }
      return {
        addressLine1: `${placeAddress} ${placeText}`,
        addressLine2: `${contextLocality} ${contextPlace}`,
        city: contextDistrict,
        country: contextCountry,
        postalCode: contextPostcode,
        state: contextRegion,
        ...latlng
      };
    }
    return {};
  }
}
class FeatureHelper {
  static updateFeatures(state, {
    category: categoryIn,
    features,
    parentId,
    parentType
  }, onChange) {
    const ids = [];
    const onFeatureChange = (id) => {
      ids.push(id);
    };
    features == null ? void 0 : features.forEach((feature2) => {
      const category = categoryIn || feature2.properties.category;
      FeatureHelper.updateFeature(state, {
        category,
        feature: feature2,
        parentId,
        parentType
      }, onFeatureChange);
    });
    onChange == null ? void 0 : onChange(ids);
  }
  static updateFeature(state, {
    category,
    feature: featureIn,
    parentId: parentIdInput,
    parentType
  }, onChange) {
    const {
      id: featureId,
      properties
    } = featureIn || {};
    const {
      [SiteStoreHelper.parentType2ParentIdName(parentType)]: parentIdFeature
    } = properties || {};
    const parentId = parentIdInput || parentIdFeature;
    if (!parentId || !category)
      throw new Error("Invalid input to updateFeature");
    const collection = state[SiteStoreHelper.parentType2CollectionName(parentType)];
    if (!collection)
      throw new Error("Invalid input to updateFeature");
    let feature2 = featureIn || {};
    const {
      feature: existingFeature,
      collectionType: existingParentType,
      collectionItem: existingParent
    } = SiteStoreHelper.getObjectById(featureId, false, state, {
      parentId,
      parentType
    });
    let needsInsertion = true;
    if (existingParent && existingParentType && existingFeature) {
      feature2 = {
        ...existingFeature,
        ...feature2,
        parentId
      };
      const theExistingList = state[SiteStoreHelper.parentType2CollectionName(existingParentType)];
      const theElementIndex = theExistingList.findIndex((element) => existingParent.id === element.id);
      if (theElementIndex > -1) {
        const theObject = theExistingList[theElementIndex];
        const theFeatureIndex = theObject.indices[featureId];
        if (theFeatureIndex >= 0) {
          if (existingParent.id === parentId && existingParentType === parentType) {
            theObject.features[theFeatureIndex] = feature2;
            needsInsertion = false;
          } else {
            const deleteResult = FeatureHelper.deleteFeatureFromObject(existingParent, theFeatureIndex);
            theObject.features = deleteResult.features;
            theObject.indices = deleteResult.indices;
          }
        }
      }
    }
    if (needsInsertion) {
      const theElementIndex = collection.findIndex((element) => parentId === element.id);
      if (theElementIndex > -1) {
        const theObject = collection[theElementIndex];
        if (!feature2.id)
          feature2.id = generateUid();
        if (!feature2.properties)
          feature2.properties = {};
        if (!feature2.name)
          feature2.name = feature2.properties.name || `feature_${theObject.features.length}`;
        delete feature2.properties.levelId;
        delete feature2.properties.venueId;
        delete feature2.properties.buildingId;
        delete feature2.properties.clusterId;
        delete feature2.properties.marketId;
        delete feature2.properties.regionId;
        delete feature2.properties.countryId;
        delete feature2.properties.orphanId;
        delete feature2.properties.zoneId;
        feature2.properties.category = category;
        if (parentType === "zone") {
          feature2.properties.zoneId = parentId;
        } else if (parentType === "level") {
          feature2.properties.levelId = parentId;
        } else if (parentType === "building") {
          feature2.properties.buildingId = parentId;
        } else if (parentType === "venue") {
          feature2.properties.venueId = parentId;
        } else if (parentType === "cluster") {
          feature2.properties.clusterId = parentId;
        } else if (parentType === "market") {
          feature2.properties.marketId = parentId;
        } else if (parentType === "region") {
          feature2.properties.regionId = parentId;
        } else if (parentType === "country") {
          feature2.properties.countryId = parentId;
        } else if (parentType === "orphan") {
          feature2.properties.orphanId = parentId;
        }
        theObject.features.push({
          ...feature2
        });
        theObject.indices[feature2.id] = theObject.features.length - 1;
      }
    }
    onChange == null ? void 0 : onChange(feature2.id);
  }
  static deleteFilteredFeatures({
    parentId,
    parentType: parentTypeIn
  }, filter17, state) {
    var _a3;
    if (!state)
      return;
    if (!filter17 || typeof filter17 !== "function")
      return;
    for (let ct = 0; ct < SiteStoreHelper.COLLECTION_TYPES.length; ct += 1) {
      const parentType = SiteStoreHelper.COLLECTION_TYPES[ct];
      if (!parentTypeIn || parentTypeIn === parentType) {
        const collectionName = SiteStoreHelper.parentType2CollectionName(parentType);
        const collection = state[collectionName];
        for (let it = 0; it < collection.length; it += 1) {
          const item = collection[it];
          if (!parentId || parentId === (item == null ? void 0 : item.id)) {
            const indices = {};
            let delCount = 0;
            for (let i2 = 0; i2 < (((_a3 = item == null ? void 0 : item.features) == null ? void 0 : _a3.length) || 0) - delCount; i2 += 1) {
              item.features[i2] = item.features[i2 + delCount];
              indices[item.features[i2].id] = i2;
              if (filter17(item.features[i2 + delCount])) {
                delCount += 1;
                i2 -= 1;
              }
            }
            for (let i2 = 0; i2 < delCount; i2 += 1) {
              const popedFeature = item.features.pop();
              delete indices[popedFeature.id];
            }
            item.indices = indices;
          }
          if (parentId)
            break;
        }
      }
    }
  }
  static deleteFeatureFromObject(object2, index2) {
    const {
      features
    } = object2;
    features.splice(index2, 1);
    const indices = {
      ...object2.indices
    };
    delete indices[index2];
    let idx = index2;
    const maxIdx = features.length - 1;
    while (idx <= maxIdx) {
      const featureId = features[idx].id;
      indices[featureId] = idx;
      idx += 1;
    }
    return {
      features,
      indices
    };
  }
  static addZoneToFeature(state, {
    feature: featureIn,
    zoneId,
    parentId,
    parentType
  }, onChange) {
    if (!featureIn)
      return;
    let feature2 = featureIn;
    if (typeof featureIn === "string") {
      const featureId = featureIn;
      const found = SiteStoreHelper.getObjectById(featureId, false, state, {
        parentId,
        parentType
      });
      if (!found)
        return;
      feature2 = found;
    }
    const {
      properties
    } = feature2;
    const newZoneIds = properties.zoneIds && Array.isArray(properties.zoneIds) ? [...properties.zoneIds] : [];
    newZoneIds.push(zoneId);
    FeatureHelper.updateFeature(state, {
      feature: {
        ...feature2,
        properties: {
          ...properties,
          zoneIds: newZoneIds
        }
      },
      parentId: properties.parentId,
      category: properties.category,
      parentType: properties.parentType
    });
    onChange == null ? void 0 : onChange(newZoneIds);
  }
  static removeZoneFromFeature(state, {
    feature: featureIn,
    zoneId,
    parentId,
    parentType
  }, onChange) {
    if (!featureIn)
      return;
    let feature2 = featureIn;
    if (typeof featureIn === "string") {
      const featureId = featureIn;
      const found = SiteStoreHelper.getObjectById(featureId, false, state, {
        parentId,
        parentType
      });
      if (!found)
        return;
      feature2 = found;
    }
    const {
      properties
    } = feature2;
    let newZoneIds = [];
    if (properties.zoneIds && Array.isArray(properties.zoneIds)) {
      newZoneIds = [...properties.zoneIds];
      const index2 = properties.zoneIds.findIndex((z2) => z2 === zoneId);
      newZoneIds = [...newZoneIds.slice(0, index2), ...newZoneIds.slice(index2 + 1, newZoneIds.length)];
    }
    FeatureHelper.updateFeature(state, {
      feature: {
        ...feature2,
        properties: {
          ...properties,
          zoneIds: newZoneIds
        }
      },
      parentId: properties.parentId,
      category: properties.category,
      parentType: properties.parentType
    });
    onChange == null ? void 0 : onChange(newZoneIds);
  }
  static filterFeatureByCategory(state, parentId, category, parentType) {
    var _a3;
    if (!parentId || !category)
      return [];
    const {
      collectionItem
    } = state.getObjectById(parentId, false, {
      parentType,
      parentId
    }) || {};
    return ((_a3 = collectionItem == null ? void 0 : collectionItem.features) == null ? void 0 : _a3.filter((f2) => f2.properties.category === category)) || [];
  }
  static filterFootprints(state, parentId, parentType) {
    return FeatureHelper.filterFeatureByCategory(state, parentId, "footprint", parentType);
  }
  static filterFootprintsFor(state, parentIds) {
    const footprints = [];
    parentIds == null ? void 0 : parentIds.forEach((pId) => {
      const features = FeatureHelper.filterFootprints(state, pId);
      if (features.length)
        footprints.push(...features);
    });
    return footprints;
  }
  static isFeatureInBoundaries(feature2, boundaries) {
    var _a3, _b3;
    let isInside = true;
    const polygon4 = boundaries == null ? void 0 : boundaries.find((b2) => b2.geometry.type === "Polygon");
    if (polygon4) {
      isInside = ((_a3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a3.type) === "Point" && GeoUtil.isPointInsidePolygon(feature2.geometry.coordinates, polygon4) || ((_b3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _b3.type) === "Polygon" && GeoUtil.isPolygonIntersectingAnyPolygons(feature2, [polygon4]);
    }
    return isInside;
  }
}
const showMessageBox_module = {};
const showMessageBox = ({
  content,
  duration = 3,
  type = "success"
}) => {
  const popup2 = message$1[type];
  if (!popup2)
    return null;
  return popup2({
    content: /* @__PURE__ */ jsx("div", { style: {
      display: "inline-flex",
      alignItems: "center"
    }, children: /* @__PURE__ */ jsxs("span", { children: [
      content,
      /* @__PURE__ */ jsx(CloseOutlined, { style: {
        marginLeft: "10px",
        cursor: "pointer"
      }, onClick: () => message$1.destroy() })
    ] }) }),
    duration
  });
};
const DEFAULT_CATEGORIES = [{
  id: "footprint",
  label: "Boundaries"
}, {
  id: "room",
  label: "Rooms"
}, {
  id: "wall",
  label: "Walls"
}, {
  id: "marker",
  label: "Marker"
}, {
  id: "accessPoint",
  label: "Access Points"
}, {
  id: "custom",
  label: "Others"
}, {
  id: "window",
  label: "Windows"
}, {
  id: "object",
  label: "Objects"
}, {
  id: "asset",
  label: "Others"
}, {
  id: "layer",
  label: "Layers"
}];
const useSiteStore = createZustandStore((set, get6) => ({
  defaultCenter: null,
  countries: [],
  // { name, id, type, center, features, indices = {} }
  regions: [],
  // { name, id, type, center, features, indices = {} }
  clusters: [],
  // { name, id, type, center, features, indices = {} }
  markets: [],
  // { name, id, type, center, features, indices = {} }
  venues: [],
  // { name, id, type, center, features, indices = {} }
  buildings: [],
  // { name, id, type, center, features, indices = {} }
  levels: [],
  // { name, id, type, buildingId, features, height, indices = {} }
  zones: [],
  // { name, id, type, center, features, indices = {} }
  orphans: [{
    id: generateUid(),
    type: "orphan",
    name: "World",
    features: [],
    indices: {}
  }],
  categories: [...DEFAULT_CATEGORIES],
  visiblePropertyKeys: [...SiteStoreHelper.DEFAULT_VISIBLE_PROPERTY_KEYS],
  deletedObjectIds: [],
  // ids of category objects e.g. venue, building , ..
  reset: () => {
    set((state) => {
      state.defaultCenter = null;
      state.countries = [];
      state.regions = [];
      state.clusters = [];
      state.markets = [];
      state.venues = [];
      state.orphans = [{
        id: generateUid(),
        type: "orphan",
        name: "World",
        features: [],
        indices: {}
      }];
      state.buildings = [];
      state.levels = [];
      state.zones = [];
      state.categories = [...DEFAULT_CATEGORIES];
      state.visiblePropertyKeys = [...SiteStoreHelper.DEFAULT_VISIBLE_PROPERTY_KEYS];
      state.deletedObjectIds = [];
    });
  },
  saveToJson: (geojson, selectedIds = []) => ExportUtil.exportSiteToJson(get6(), geojson, selectedIds),
  loadUpdate: (result) => {
    if (!result)
      return;
    const {
      defaultCenter,
      countries,
      regions,
      clusters,
      markets,
      venues,
      buildings,
      levels,
      categories: categories2,
      orphans,
      visiblePropertyKeys,
      assets,
      zones
    } = result;
    assets == null ? void 0 : assets.forEach((asset) => useAssetStore.getState().updateAsset(asset));
    get6().setDefaultCenter(defaultCenter);
    get6().setCollections("country", countries);
    get6().setCollections("region", regions);
    get6().setCollections("market", markets);
    get6().setCollections("cluster", clusters);
    get6().setCollections("venue", venues);
    get6().setCollections("building", buildings);
    get6().setCollections("level", levels);
    get6().setCollections("zone", zones);
    get6().setCategories(categories2);
    get6().setOrphans(orphans);
    get6().setVisiblePropertyKeys(visiblePropertyKeys);
  },
  loadFromJson: (json, geojson) => {
    const result = ImportUtil.importSiteFromJson(json, geojson, get6());
    get6().loadUpdate(result);
    return result;
  },
  setDefaultCenter: (center2) => {
    set((state) => {
      if (center2) {
        state.defaultCenter = center2;
      }
    });
  },
  // Non-reactive method for convenience
  getDefaultCenter: (defaulValue = [-77.45499, 39.050081]) => get6().defaultCenter || defaulValue,
  addToCollection: (type, {
    id,
    name: name2,
    features,
    ...rest
  }, onAdd) => {
    const collectionName = SiteStoreHelper.parentType2CollectionName(type);
    const {
      collectionItem: parentNode
    } = get6().getObjectById(rest.parentId) || {};
    const parentId = id || generateUid();
    const index2 = get6()[collectionName].findIndex((c2) => c2.id === parentId);
    const indices = {};
    features == null ? void 0 : features.forEach((f2, index22) => indices[f2.id] = index22);
    const parentNodeId = (parentNode == null ? void 0 : parentNode.id) ? {
      [SiteStoreHelper.parentType2ParentIdName(parentNode.type)]: parentNode.id
    } : null;
    if (index2 < 0) {
      set((state) => {
        const inCollectionObj = {
          id: parentId,
          type,
          name: name2,
          features: (features == null ? void 0 : features.map((f2) => ({
            ...f2,
            properties: {
              ...f2.properties,
              parentId,
              parentType: type
            }
          }))) || [],
          indices,
          ...rest,
          ...parentNodeId
        };
        state[collectionName].push(inCollectionObj);
      });
      onAdd == null ? void 0 : onAdd(parentId);
    } else {
      set((state) => {
        state[collectionName][index2] = {
          ...get6()[collectionName][index2],
          name: name2,
          ...rest,
          type,
          ...parentNodeId
        };
        if (features) {
          state[collectionName][index2].features = features.map((f2) => ({
            ...f2,
            properties: {
              ...f2.properties,
              parentId,
              parentType: type
            }
          }));
          state[collectionName][index2].indices = indices;
        }
      });
      onAdd == null ? void 0 : onAdd(parentId);
    }
  },
  removeFromCollection: (type, {
    id,
    validate: validate2 = false,
    filter: filter17 = () => false
  }) => {
    if (validate2) {
      const skipRemoval = get6().hasSubHierarchy(type, id);
      if (skipRemoval) {
        showMessageBox({
          content: `Operation failed - cannot delete ${type} with hierarchy`,
          type: "error"
        });
        return;
      }
    }
    if (type === "accessPoint") {
      SiteStoreHelper.ACCESS_POINT_PARENTS.forEach((parentType) => {
        get6().deleteFilteredFeatures({
          parentType
        }, (feature2) => feature2.id === id);
      });
      set((state) => {
        state.deletedObjectIds.push(id);
      });
      return;
    }
    if (type === "layer") {
      const deletedFeatureIds = [];
      const filter22 = (feature2) => {
        const isFiltered = filter17(feature2);
        if (isFiltered) {
          deletedFeatureIds.push(feature2.id);
        }
        return isFiltered;
      };
      get6().deleteFilteredFeatures({
        parentId: id,
        parentType: "level"
      }, filter22);
      set((state) => {
        state.deletedObjectIds.push(...deletedFeatureIds);
      });
      return;
    }
    const collectionName = SiteStoreHelper.parentType2CollectionName(type);
    const parentId = id;
    const index2 = get6()[collectionName].findIndex((c2) => c2.id === parentId);
    const collection = get6()[collectionName];
    if (index2 >= 0) {
      set((state) => {
        state.deletedObjectIds.push(parentId);
        state[collectionName] = [...collection.slice(0, index2), ...collection.slice(index2 + 1, collection.length)];
      });
    }
    if (type === "zone") {
      set((state) => {
        SiteStoreHelper.ZONE_PARENTS.forEach((parentType) => {
          const collectionName2 = SiteStoreHelper.parentType2CollectionName(parentType);
          state == null ? void 0 : state[collectionName2].forEach((l2) => {
            l2.features.forEach((f2) => {
              if (f2.properties.category === "accessPoint" && f2.properties.zoneIds) {
                const index22 = f2.properties.zoneIds.findIndex((zId) => zId === id);
                if (index22 > -1) {
                  f2.properties.zoneIds.splice(index22, 1);
                }
              }
            });
          });
        });
      });
    }
  },
  setCollections: (type, collections, onAdd) => {
    const ids = [];
    const collectionName = SiteStoreHelper.parentType2CollectionName(type);
    const existing = get6()[collectionName];
    collections == null ? void 0 : collections.forEach((c2) => {
      const found = existing.find((r2) => r2.id === c2.id);
      if (!found)
        get6().addToCollection(type, c2, (id) => ids.push(id));
      else
        ids.push(c2.id);
    });
    onAdd == null ? void 0 : onAdd(ids);
  },
  setOrphans: (orphans, onAdd) => {
    if (!orphans)
      return;
    const orphan = Array.isArray(orphans) ? orphans[0] : orphans;
    if (!orphan)
      return;
    set((state) => {
      var _a3, _b3, _c2, _d2;
      if (!((_a3 = state.orphans) == null ? void 0 : _a3.length))
        state.orphans = [];
      if (orphan.id)
        state.orphans[0].id = orphan.id;
      if (!((_b3 = state.orphans[0].features) == null ? void 0 : _b3.length)) {
        state.orphans[0].features = [];
        state.orphans[0].indices = {};
      }
      if ((_c2 = orphan.features) == null ? void 0 : _c2.length) {
        const offset = state.orphans[0].features.length;
        (_d2 = orphan.features) == null ? void 0 : _d2.forEach((feature2, index2) => {
          state.orphans[0].features.push(feature2);
          state.orphans[0].indices[feature2.id] = index2 + offset;
        });
      }
    });
    onAdd == null ? void 0 : onAdd(orphan.id);
  },
  setCategories: (categories2) => {
    set((state) => {
      if (!categories2 || categories2.length === 0)
        return;
      const updatedCategories = [...DEFAULT_CATEGORIES];
      categories2.forEach((inputCategory) => {
        const foundIndex = updatedCategories.findIndex((category) => category.id === inputCategory.id);
        if (foundIndex > -1) {
          const found = updatedCategories[foundIndex];
          updatedCategories.splice(foundIndex, 1, {
            ...found,
            ...inputCategory,
            label: found.label
          });
        } else {
          updatedCategories.push({
            ...inputCategory
          });
        }
      });
      state.categories = updatedCategories;
    });
  },
  setVisiblePropertyKeys: (visiblePropertyKeys) => {
    if (!visiblePropertyKeys)
      return;
    set((state) => {
      state.visiblePropertyKeys = uniqueArray(mergeArray(state.visiblePropertyKeys, visiblePropertyKeys));
    });
  },
  addVisiblePropertyKey: (visiblePropertyKey, onAdd) => {
    set((state) => {
      var _a3;
      if (visiblePropertyKey && !((_a3 = state.visiblePropertyKeys) == null ? void 0 : _a3.find((pKey) => pKey === visiblePropertyKey))) {
        state.visiblePropertyKeys.push(visiblePropertyKey);
      }
    });
    onAdd == null ? void 0 : onAdd(visiblePropertyKey);
  },
  updateFeatures: ({
    category,
    features,
    parentId,
    parentType
  }, onChange) => {
    set((state) => {
      FeatureHelper.updateFeatures(state, {
        category,
        features,
        parentId,
        parentType
      }, onChange);
    });
  },
  deleteFilteredFeatures: ({
    parentId,
    parentType
  }, filter17) => {
    set((state) => {
      FeatureHelper.deleteFilteredFeatures({
        parentId,
        parentType
      }, filter17, state);
    });
  },
  updateFeature: ({
    category,
    feature: feature2,
    parentId,
    parentType
  }, onChange) => {
    set((state) => {
      FeatureHelper.updateFeature(state, {
        category,
        feature: feature2,
        parentId,
        parentType
      }, onChange);
    });
  },
  updateCategories: (inCategories) => {
    if (!inCategories || inCategories.length === 0)
      return;
    set((state) => {
      state.categories = [...inCategories];
    });
  },
  updateFeatureStyle: (featureIn, style2) => {
    if (!style2 || !featureIn)
      return;
    const featureId = typeof featureIn === "string" ? featureIn : featureIn == null ? void 0 : featureIn.id;
    const {
      feature: existingFeature,
      collectionType: existingParentType,
      collectionItem: existingParent
    } = get6().getObjectById(featureId);
    if (!existingParent || existingParentType || existingFeature)
      return;
    set((state) => {
      const theExistingList = state[SiteStoreHelper.parentType2CollectionName(existingParentType)];
      const theElementIndex = theExistingList.findIndex((element) => existingParent.id === element.id);
      if (theElementIndex > -1) {
        const theObject = theExistingList[theElementIndex];
        const theFeatureIndex = theObject.indices[featureId] || -1;
        if (theFeatureIndex > -1) {
          const theFeature = theObject.features[theFeatureIndex];
          applyFeatureStyle(theFeature, style2);
          theObject.features = [...existingParent.features.slice(0, theFeatureIndex), theFeature, ...existingParent.features.slice(theFeatureIndex + 1, existingParent.features.length)];
        }
      }
    });
  },
  // Non-reactive GET methods
  getObjectDetail: (idOrItem, collectionTypeIn) => SiteStoreHelper.getObjectDetail(idOrItem, collectionTypeIn, get6()),
  getObjectById: (featureId, detailed, seed) => SiteStoreHelper.getObjectById(featureId, detailed, get6(), seed),
  getObjectFeatures: (idOrItem, collectionTypeIn, recursive = true) => SiteStoreHelper.getObjectFeatures(idOrItem, collectionTypeIn, recursive, get6()),
  getObjectsFootprints: (parentIds) => FeatureHelper.filterFootprintsFor(get6(), parentIds),
  getDrawMode: (categoryOrGeometryType, defaultValue2) => SiteStoreHelper.getDrawMode(categoryOrGeometryType, defaultValue2),
  getFeatureCategoryByKey: (lowerKey) => SiteStoreHelper.getFeatureCategoryByKey(lowerKey),
  getAllSiteFeatures: () => SiteStoreHelper.getAllSiteFeatures(get6()),
  hasSubHierarchy: (type, id) => SiteStoreHelper.hasSubHierarchy(type, id, get6())
}), "SiteStore");
const blank = {
  version: 8,
  name: "Empty",
  metadata: {
    "mapbox:autocomposite": true
  },
  sources: {},
  layers: [],
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
};
const MapTilesConstants = {
  Streets: {
    tilesetUrl: "mapbox://styles/mapbox/streets-v11",
    // value in Select
    imageUrl: Images$1.StreetsMapbox
  },
  Satellite: {
    tilesetUrl: "mapbox://styles/mapbox/satellite-v9",
    imageUrl: Images$1.SatelliteMapbox
  },
  Outdoors: {
    tilesetUrl: "mapbox://styles/mapbox/outdoors-v11",
    imageUrl: Images$1.OutdoorsMapbox
  },
  Standard: {
    tilesetUrl: "mapbox://styles/mapbox/standard",
    imageUrl: Images$1.StandardMapbox
  },
  Light: {
    // tilesetUrl: 'mapbox://styles/mapbox/light-v10',
    tilesetUrl: "mapbox://styles/c3spectrainc/clyim2meo00ze01qp0e41571e",
    imageUrl: Images$1.LightMapbox
  },
  Dark: {
    // tilesetUrl: 'mapbox://styles/mapbox/dark-v10',
    tilesetUrl: "mapbox://styles/c3spectrainc/clyim1w9x00zi01nwgn86d6nq",
    imageUrl: Images$1.DarkMapbox
  },
  None: {
    tilesetUrl: blank
    // imageUrl: Images.None,
  }
};
const getActiveType = (viewState) => {
  const activeTypes = [{
    key: "activeApFeatureId",
    type: "accessPoint"
  }, {
    key: "activeZoneId",
    type: "zone"
  }, {
    key: "activeLevelId",
    type: "level"
  }, {
    key: "activeBuildingId",
    type: "building"
  }, {
    key: "activeVenueId",
    type: "venue"
  }, {
    key: "activeClusterId",
    type: "cluster"
  }, {
    key: "activeMarketId",
    type: "market"
  }, {
    key: "activeRegionId",
    type: "region"
  }, {
    key: "activeCountryId",
    type: "country"
  }];
  const active3 = activeTypes.find(({
    key
  }) => viewState[key]);
  return active3 ? {
    activeId: viewState[active3.key],
    activeType: active3.type
  } : {
    activeType: null,
    activeId: null
  };
};
const checkSiteObjectTypeCreate = (objectType, viewState) => {
  let error2 = null;
  const {
    activeType,
    activeId
  } = getActiveType(viewState);
  const subTreeError = {
    invalid: "subtree",
    hidden: true
  };
  const parentTypes = SiteStoreHelper[`${objectType.toUpperCase()}_PARENTS`];
  switch (objectType) {
    case "uploadAssets":
      if (activeType !== "level") {
        error2 = {
          invalid: "subtree",
          hidden: true,
          disabled: true
        };
      }
      break;
    case "upload":
      if (activeId) {
        error2 = {
          invalid: "upload",
          hidden: true
        };
      } else if (viewState.enableVenueSubTree) {
        error2 = subTreeError;
      }
      break;
    case "country":
      if (activeId) {
        error2 = {
          invalid: "country",
          disabled: true,
          hidden: viewState.enableVenueSubTree
        };
      } else if (viewState.enableVenueSubTree) {
        error2 = subTreeError;
      }
      break;
    case "region":
    case "market":
    case "cluster":
    case "venue":
      if (activeId && !parentTypes.includes(activeType)) {
        error2 = {
          invalid: objectType,
          disabled: true,
          hidden: viewState.enableVenueSubTree
        };
      } else if (viewState.enableVenueSubTree) {
        error2 = subTreeError;
      }
      break;
    case "building":
    case "level":
      if (!parentTypes.includes(activeType)) {
        error2 = {
          invalid: objectType,
          disabled: true,
          hidden: !viewState.enableVenueSubTree
        };
      } else if (!viewState.enableVenueSubTree) {
        error2 = subTreeError;
      }
      break;
    case "layer":
      if (!SiteStoreHelper.LEVEL_PARENTS.includes(activeType)) {
        error2 = {
          required: "level",
          disabled: true,
          hidden: !viewState.enableVenueSubTree
        };
      } else if (viewState.activeLayerId) {
        error2 = {
          invalid: "layer",
          disabled: true,
          hidden: !viewState.enableVenueSubTree
        };
      } else if (!viewState.enableVenueSubTree) {
        error2 = subTreeError;
      }
      break;
    case "zone":
      if (!SiteStoreHelper.ZONE_PARENTS.includes(activeType)) {
        error2 = {
          required: SiteStoreHelper.ZONE_PARENTS[0],
          disabled: true
        };
      } else if (activeType === "venue" && !viewState.enableVenueSubTree) {
        error2 = {
          invalid: "subtree",
          disabled: true
        };
      }
      break;
    case "accessPoint":
    case "accesspoint":
      if (!SiteStoreHelper.ACCESS_POINT_PARENTS.includes(activeType)) {
        error2 = {
          required: SiteStoreHelper.ACCESS_POINT_PARENTS[0],
          disabled: true
        };
      } else if (activeType === "venue" && !viewState.enableVenueSubTree) {
        error2 = {
          invalid: "subtree",
          disabled: true
        };
      }
      break;
  }
  return error2;
};
const TILE_STREET = MapTilesConstants.Streets.tilesetUrl;
const useViewStore = createZustandStore((set, get6) => ({
  defaultTiles: TILE_STREET,
  activeTiles: "",
  displayMode: "2d",
  // 2d or 3d
  undergroundView: false,
  // boolean
  activeCountryId: null,
  activeRegionId: null,
  activeClusterId: null,
  activeMarketId: null,
  activeVenueId: null,
  activeBuildingId: null,
  activeLevelId: null,
  activeLayerId: null,
  activeZoneId: null,
  activeFeatureId: null,
  // any general feature (including access point)
  activeApFeatureId: null,
  // specifically access point feature
  activeCollectionItemId: null,
  activeFormFeatureIds: [],
  // features currently used in create/edit map-tools
  autoFocusItem: null,
  autoFocusParams: {},
  autoFocusForceCounter: 0,
  activeTool: null,
  activeSubTool: null,
  disabledToolButtons: [],
  // shown but on clickable
  visiblilityChecker: () => true,
  invisibleCategories: [],
  // default all are visible. categories are venue, building etc.
  invisibleObjectIds: [],
  // default all are visible. objectId are e.g. venueId, buildingId etc.
  invisibleLayers: [],
  // default all are visible
  invisibleFlags: [],
  // more invisible flags based on LayerDropdown
  windowSplit: false,
  closing: false,
  // closing the app
  saving: false,
  // saving the data
  imageSnapPoints: [],
  mapSnapPoints: [],
  clickPosition: null,
  activeFormControl: {},
  enableVenueSubTree: false,
  reset: () => {
    set((state) => {
      state.defaultTiles = TILE_STREET;
      state.activeTiles = "";
      state.displayMode = "2d";
      state.undergroundView = false;
      state.activeCollectionItemId = null;
      state.activeTool = null;
      state.activeSubTool = null;
      state.disabledToolButtons = [];
      state.activeFeatureId = null;
      state.autoFocusItem = null;
      state.autoFocusParams = {};
      state.autoFocusForceCounter = 0;
      state.visiblilityChecker = () => true;
      state.invisibleCategories = [];
      state.invisibleLayers = [];
      state.invisibleObjectIds = [];
      state.invisibleFlags = [];
      state.windowSplit = false;
      state.closing = false;
      state.saving = false;
      state.imageSnapPoints = [];
      state.mapSnapPoints = [];
      state.clickPosition = null;
      state.activeFormControl = {};
      state.enableVenueSubTree = false;
      state.activeFormFeatureIds = [];
    });
  },
  resetActive: () => {
    set((state) => {
      state.activeCountryId = null;
      state.activeRegionId = null;
      state.activeClusterId = null;
      state.activeMarketId = null;
      state.activeVenueId = null;
      state.activeBuildingId = null;
      state.activeLevelId = null;
      state.activeFeatureId = null;
      state.activeLayerId = null;
      state.activeZoneId = null;
      state.activeApFeatureId = null;
      state.activeCollectionItemId = null;
      state.activeSubTool = "";
      state.autoFocusItem = null;
      state.autoFocusParams = {};
      state.autoFocusForceCounter = 0;
      state.activeFormControl = {};
      state.enableVenueSubTree = false;
      state.activeFormFeatureIds = [];
    });
  },
  getActive: () => {
    const state = get6();
    return {
      activeCountryId: state.activeCountryId,
      activeRegionId: state.activeRegionId,
      activeClusterId: state.activeClusterId,
      activeMarketId: state.activeMarketId,
      activeVenueId: state.activeVenueId,
      activeBuildingId: state.activeBuildingId,
      activeLevelId: state.activeLevelId,
      activeFeatureId: state.activeFeatureId,
      activeLayerId: state.activeLayerId,
      activeZoneId: state.activeZoneId,
      activeApFeatureId: state.activeApFeatureId,
      activeCollectionItemId: state.activeCollectionItemId,
      activeSubTool: state.activeSubTool,
      enableVenueSubTree: state.enableVenueSubTree
    };
  },
  getActiveParentIds: () => {
    const state = get6();
    const activeParentIds = [];
    if (state.activeLevelId)
      activeParentIds.push(state.activeLevelId);
    if (state.activeBuildingId)
      activeParentIds.push(state.activeBuildingId);
    if (state.activeVenueId)
      activeParentIds.push(state.activeVenueId);
    if (state.activeClusterId)
      activeParentIds.push(state.activeClusterId);
    if (state.activeMarketId)
      activeParentIds.push(state.activeMarketId);
    if (state.activeRegionId)
      activeParentIds.push(state.activeRegionId);
    if (state.activeCountryId)
      activeParentIds.push(state.activeCountryId);
    return activeParentIds;
  },
  setInitialCollectionId: (id) => {
    set((state) => {
      var _a3, _b3, _c2, _d2, _e2;
      const siteState = useSiteStore.getState();
      const firstVenue = (_a3 = siteState == null ? void 0 : siteState.venues) == null ? void 0 : _a3[0];
      state.activeRegionId = null;
      state.activeClusterId = null;
      state.activeMarketId = null;
      state.activeVenueId = (firstVenue == null ? void 0 : firstVenue.id) || null;
      state.activeBuildingId = null;
      state.activeLevelId = null;
      state.activeFeatureId = null;
      state.activeLayerId = null;
      state.activeZoneId = null;
      state.activeApFeatureId = null;
      state.activeCollectionItemId = id || ((_c2 = (_b3 = siteState == null ? void 0 : siteState.venues) == null ? void 0 : _b3[0]) == null ? void 0 : _c2.id) || ((_e2 = (_d2 = siteState == null ? void 0 : siteState.orphans) == null ? void 0 : _d2[0]) == null ? void 0 : _e2.id);
    });
  },
  loadFromJson: (json) => {
    var _a3, _b3, _c2;
    const {
      venues,
      levels,
      orphans
    } = json || {};
    ((_a3 = levels == null ? void 0 : levels[0]) == null ? void 0 : _a3.id) || ((_b3 = venues == null ? void 0 : venues[0]) == null ? void 0 : _b3.id) || ((_c2 = orphans == null ? void 0 : orphans[0]) == null ? void 0 : _c2.id);
  },
  setDefaultTiles: (tiles, makeActive) => {
    set((state) => {
      if (tiles) {
        state.defaultTiles = tiles;
        if (makeActive)
          state.activeTiles = tiles;
      }
    });
  },
  setActiveTiles: (activeTiles) => {
    set((state) => {
      state.activeTiles = activeTiles;
    });
  },
  setDisplayMode: (displayMode2) => {
    set((state) => {
      state.displayMode = displayMode2;
    });
  },
  setUndergroundView: (input) => {
    set((state) => {
      const value = typeof input === "function" ? input(get6().undergroundView) : !!input;
      state.undergroundView = value;
    });
  },
  setWindowSplit: (windowSplit) => {
    set((state) => {
      state.windowSplit = !!windowSplit;
    });
  },
  setClosing: (closing) => {
    set((state) => {
      state.closing = !!closing;
      if (get6().saving)
        state.saving = false;
    });
  },
  setSaving: (saving) => {
    set((state) => {
      state.saving = !!saving;
      if (get6().closing)
        state.closing = false;
    });
  },
  setImageSnapPoints: (imageSnapPoints) => {
    set((state) => {
      state.imageSnapPoints = imageSnapPoints;
    });
  },
  setMapSnapPoints: (mapSnapPoints) => {
    set((state) => {
      state.mapSnapPoints = mapSnapPoints;
    });
  },
  setActiveCollectionItemId: (id) => {
    set((state) => {
      if (id && state.activeCollectionItemId && id !== state.activeCollectionItemId) {
        state.activeTool = null;
        state.activeSubTool = null;
        state.activeFeatureId = null;
      }
      state.activeCollectionItemId = id;
    });
  },
  setActiveFeatureId: (featureId) => {
    set((state) => {
      state.activeFeatureId = featureId;
    });
  },
  setActiveApFeatureId: (activeApFeatureId) => {
    set((state) => {
      state.activeApFeatureId = activeApFeatureId;
      if (activeApFeatureId)
        state.activeFeatureId = activeApFeatureId;
    });
  },
  setAutoFocusItem: (featureId, params2 = {}, forceUpdate = false) => {
    set((state) => {
      state.autoFocusItem = featureId;
      state.autoFocusParams = params2;
      if (forceUpdate)
        state.autoFocusForceCounter = get6().autoFocusForceCounter + 1;
    });
  },
  setActiveLayerId: (layerId) => {
    set((state) => {
      state.activeLayerId = layerId;
    });
  },
  setActiveTool: (tool) => {
    set((state) => {
      state.activeTool = tool;
      if (!tool)
        state.activeSubTool = null;
      if (tool !== "editProperty")
        state.activeFeatureId = null;
    });
  },
  setActiveSubTool: (tool) => {
    set((state) => {
      const previousSubTool = state.activeSubTool;
      if (tool == null ? void 0 : tool.startsWith("create")) {
        const which = tool.toLowerCase().replace("create", "");
        const error2 = checkSiteObjectTypeCreate(which, state);
        if (error2) {
          showMessageBox({
            type: "error",
            content: "Invalid operation!"
          });
          return;
        }
      }
      state.activeSubTool = tool;
      if (tool == null ? void 0 : tool.endsWith("Split")) {
        state.windowSplit = true;
      } else if (previousSubTool == null ? void 0 : previousSubTool.endsWith("Split")) {
        state.windowSplit = false;
      }
    });
  },
  resetActiveFormControl: () => {
    set((state) => {
      state.activeFormControl = {};
    });
  },
  setActiveFormControl: (key, value) => {
    set((state) => {
      state.activeFormControl[key] = value;
    });
  },
  disableToolButton: (tool) => {
    set((state) => {
      if (!get6().disabledToolButtons.includes(tool)) {
        state.disabledToolButtons.push(tool);
      }
    });
  },
  enableToolButton: (tool) => {
    set((state) => {
      const disabled = get6().disabledToolButtons;
      const index2 = disabled.indexOf(tool);
      if (index2 > -1) {
        state.disabledToolButtons = [...disabled.slice(0, index2), ...disabled.slice(index2 + 1, disabled.length)];
      }
    });
  },
  setVisibilityChecker: (checker = () => false) => {
    set((state) => {
      state.visiblilityChecker = checker;
    });
  },
  updateCategoryVisibility: (category, visible) => {
    set((state) => {
      const invisibles = get6().invisibleCategories;
      const index2 = invisibles.findIndex((item) => item === category);
      if (visible) {
        if (index2 > -1) {
          state.invisibleCategories = [...invisibles.slice(0, index2), ...invisibles.slice(index2 + 1, invisibles.length)];
        }
      } else if (index2 < 0) {
        state.invisibleCategories.push(category);
      }
    });
  },
  updateLayerVisibility: (layer, visible) => {
    set((state) => {
      const invisibles = get6().invisibleLayers;
      const index2 = invisibles.findIndex((item) => item === layer);
      if (visible) {
        if (index2 > -1) {
          state.invisibleLayers = [...invisibles.slice(0, index2), ...invisibles.slice(index2 + 1, invisibles.length)];
        }
      } else if (index2 < 0) {
        state.invisibleLayers.push(layer);
      }
    });
  },
  updateObjectVisibility: (level, visible) => {
    set((state) => {
      const invisibles = get6().invisibleObjectIds;
      const index2 = invisibles.findIndex((item) => item === level);
      if (visible) {
        if (index2 > -1) {
          state.invisibleObjectIds = [...invisibles.slice(0, index2), ...invisibles.slice(index2 + 1, invisibles.length)];
        }
      } else if (index2 < 0) {
        state.invisibleObjectIds.push(level);
      }
    });
  },
  updateVisibilityFlags: (layer, visible) => {
    set((state) => {
      const invisibles = get6().invisibleFlags;
      const index2 = invisibles.findIndex((item) => item === layer);
      if (visible) {
        if (index2 > -1) {
          state.invisibleFlags = [...invisibles.slice(0, index2), ...invisibles.slice(index2 + 1, invisibles.length)];
        }
      } else if (index2 < 0) {
        state.invisibleFlags.push(layer);
      }
    });
  },
  setEnableVenueSubTree: (value) => {
    set((state) => {
      state.enableVenueSubTree = !!value;
    });
  },
  getActiveObject: () => {
    const state = get6();
    const ids = SiteStoreHelper.COLLECTION_TYPES.map((type) => `${type}Id`);
    ids.push(...["layerId", "featureId"]);
    const object2 = {};
    ids.forEach((key) => {
      const entryKey = `active${makeFirstLetterCapital(key)}`;
      object2[key] = state[entryKey];
    });
    return object2;
  },
  setActiveObject: (object2) => {
    set((state) => {
      const ids = SiteStoreHelper.COLLECTION_TYPES.map((type) => `${type}Id`);
      ids.push(...["layerId", "featureId"]);
      let lastValue = "";
      ids.forEach((key) => {
        const entryKey = `active${makeFirstLetterCapital(key)}`;
        state[entryKey] = object2 == null ? void 0 : object2[key];
        if (object2 == null ? void 0 : object2[key]) {
          lastValue = object2[key];
        }
      });
      state.activeCollectionItemId = lastValue;
    });
  },
  setActiveObjectId: (type, activeObjectId) => {
    set((state) => {
      if (!type)
        return;
      const key = `active${makeFirstLetterCapital(type)}Id`;
      state[key] = activeObjectId;
      if (activeObjectId)
        state.activeCollectionItemId = activeObjectId;
    });
  },
  setActiveCountryId: (activeCountryId) => {
    set((state) => {
      state.activeCountryId = activeCountryId;
      if (activeCountryId)
        state.activeCollectionItemId = activeCountryId;
    });
  },
  setActiveRegionId: (activeRegionId) => {
    set((state) => {
      state.activeRegionId = activeRegionId;
      if (activeRegionId)
        state.activeCollectionItemId = activeRegionId;
    });
  },
  setActiveMarketId: (activeMarketId) => {
    set((state) => {
      state.activeMarketId = activeMarketId;
      if (activeMarketId)
        state.activeCollectionItemId = activeMarketId;
    });
  },
  setActiveClusterId: (activeClusterId) => {
    set((state) => {
      state.activeClusterId = activeClusterId;
      if (activeClusterId)
        state.activeCollectionItemId = activeClusterId;
    });
  },
  setActiveVenueId: (activeVenueId) => {
    set((state) => {
      state.activeVenueId = activeVenueId;
      if (activeVenueId)
        state.activeCollectionItemId = activeVenueId;
    });
  },
  setActiveBuildingId: (activeBuildingId) => {
    set((state) => {
      state.activeBuildingId = activeBuildingId;
      if (activeBuildingId)
        state.activeCollectionItemId = activeBuildingId;
    });
  },
  setActiveLevelId: (activeLevelId) => {
    set((state) => {
      state.activeLevelId = activeLevelId;
      if (activeLevelId)
        state.activeCollectionItemId = activeLevelId;
    });
  },
  setActiveZoneId: (activeZoneId) => {
    set((state) => {
      state.activeZoneId = activeZoneId;
      if (activeZoneId)
        state.activeCollectionItemId = activeZoneId;
    });
  },
  setActiveFormFeatureIds: (ids) => {
    set((state) => {
      state.activeFormFeatureIds = ids || [];
    });
  }
}), "ViewStore");
const useConfigStore = createZustandStore((set, get6) => ({
  headerHeight: 64,
  // 106, // 80, // in pixels
  footerHeight: 0,
  // 24, // in pixels
  leftPanelWidth: 372,
  // in pixels
  rightPanelWidth: 50,
  // in pixels
  defaultVenueName: "Venue1",
  defaultBuildingName: "Building1",
  defaultLevelName: "Level0",
  defaultStoreyHeight: 4,
  // in meters
  supportedImageFileFormats: FileUtil.SUPPORTED_IMAGE_FORMATS,
  supportedCadFileFormats: FileUtil.SUPPORTED_CAD_FORMATS,
  supportedFileFormats: FileUtil.SUPPORTED_FILE_FORMATS,
  preferredReaderTypes: FileUtil.PREFERRED_READER_TYPES,
  reset: () => {
    set((state) => {
      state.headerHeight = 72;
      state.footerHeight = 0;
      state.leftPanelWidth = 372;
      state.rightPanelWidth = 50;
      state.defaultVenueName = "Venue1";
      state.defaultBuildingName = "Building1";
      state.defaultLevelName = "Level0";
      state.defaultStoreyHeight = 4;
      state.supportedImageFileFormats = FileUtil.SUPPORTED_IMAGE_FORMATS;
      state.supportedCadFileFormats = FileUtil.SUPPORTED_CAD_FORMATS;
      state.supportedFileFormats = FileUtil.SUPPORTED_FILE_FORMATS;
      state.preferredReaderTypes = FileUtil.PREFERRED_READER_TYPES;
    });
  },
  saveToJson: () => {
    const {
      headerHeight,
      footerHeight,
      leftPanelWidth,
      rightPanelWidth,
      defaultVenueName,
      defaultBuildingName,
      defaultLevelName,
      defaultStoreyHeight,
      supportedImageFileFormats,
      supportedCadFileFormats: supportedCadFileFormats2,
      supportedFileFormats,
      preferredReaderTypes
    } = get6();
    return {
      headerHeight,
      footerHeight,
      leftPanelWidth,
      rightPanelWidth,
      defaultVenueName,
      defaultBuildingName,
      defaultLevelName,
      defaultStoreyHeight,
      supportedImageFileFormats,
      supportedCadFileFormats: supportedCadFileFormats2,
      supportedFileFormats,
      preferredReaderTypes
    };
  },
  loadFromJson: (json) => {
    const {
      headerHeight,
      footerHeight,
      leftPanelWidth,
      rightPanelWidth,
      defaultVenueName,
      defaultBuildingName,
      defaultLevelName,
      defaultStoreyHeight,
      supportedImageFileFormats,
      supportedCadFileFormats: supportedCadFileFormats2,
      supportedFileFormats,
      preferredReaderTypes
    } = json;
    get6().setHeaderHeight(headerHeight);
    get6().setFooterHeight(footerHeight);
    get6().setLeftPanelWidth(leftPanelWidth);
    get6().setRightPanelWidth(rightPanelWidth);
    get6().setDefaultVenueName(defaultVenueName);
    get6().setDefaultBuildingName(defaultBuildingName);
    get6().setDefaultLevelName(defaultLevelName);
    get6().setDefaultStoreyHeight(defaultStoreyHeight);
    get6().setSupportedImageFileFormats(supportedImageFileFormats);
    get6().setSupportedCadFileFormats(supportedCadFileFormats2);
    get6().setSupportedFileFormats(supportedFileFormats);
    get6().setPreferredReaderTypes(preferredReaderTypes);
    return json;
  },
  setHeaderHeight: (headerHeight) => {
    set((state) => {
      state.headerHeight = headerHeight;
    });
  },
  setFooterHeight: (footerHeight) => {
    set((state) => {
      state.footerHeight = footerHeight;
    });
  },
  setLeftPanelWidth: (leftPanelWidth) => {
    set((state) => {
      state.leftPanelWidth = leftPanelWidth;
    });
  },
  setRightPanelWidth: (rightPanelWidth) => {
    set((state) => {
      state.rightPanelWidth = rightPanelWidth;
    });
  },
  setDefaultVenueName: (defaultVenueName) => {
    set((state) => {
      state.defaultVenueName = defaultVenueName;
    });
  },
  setDefaultBuildingName: (defaultBuildingName) => {
    set((state) => {
      state.defaultBuildingName = defaultBuildingName;
    });
  },
  setDefaultLevelName: (defaultLevelName) => {
    set((state) => {
      state.defaultLevelName = defaultLevelName;
    });
  },
  setDefaultStoreyHeight: (defaultStoreyHeight) => {
    set((state) => {
      state.defaultStoreyHeight = defaultStoreyHeight;
    });
  },
  setSupportedImageFileFormats: (supportedImageFileFormats) => {
    set((state) => {
      state.supportedImageFileFormats = supportedImageFileFormats;
    });
  },
  setSupportedCadFileFormats: (supportedCadFileFormats2) => {
    set((state) => {
      state.supportedCadFileFormats = supportedCadFileFormats2;
    });
  },
  setSupportedFileFormats: (supportedFileFormats) => {
    set((state) => {
      state.supportedFileFormats = supportedFileFormats;
    });
  },
  setPreferredReaderTypes: (preferredReaderTypes) => {
    set((state) => {
      state.preferredReaderTypes = preferredReaderTypes;
    });
  }
}), "ConfigStore");
const SvgDeviceObjType = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6348_52534)" }, /* @__PURE__ */ React.createElement("path", { d: "M17.5 6.25L10 10M10 10L2.5 6.25M10 10V17.9167", stroke: "#868B98", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.9827 2.81961L14.6494 3.69423C16.4424 4.63519 17.339 5.10566 17.8368 5.95109C18.3346 6.79651 18.3346 7.84853 18.3346 9.95256V10.05C18.3346 12.1541 18.3346 13.2061 17.8368 14.0515C17.339 14.8969 16.4424 15.3674 14.6494 16.3084L12.9827 17.183C11.5197 17.9508 10.7882 18.3346 10.0013 18.3346C9.21441 18.3346 8.4829 17.9508 7.01988 17.183L5.35321 16.3084C3.56016 15.3674 2.66363 14.8969 2.1658 14.0515C1.66797 13.2061 1.66797 12.1541 1.66797 10.05V9.95256C1.66797 7.84853 1.66797 6.79651 2.1658 5.95109C2.66363 5.10566 3.56016 4.63519 5.35321 3.69423L7.01988 2.81961C8.4829 2.05185 9.21441 1.66797 10.0013 1.66797C10.7882 1.66797 11.5197 2.05185 12.9827 2.81961Z", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6348_52534" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white" }))));
const Object$1 = SvgDeviceObjType;
const SvgDoorObjType = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 4.7, y: 1.7, width: 10.6, height: 16.6, rx: 1.3, stroke: "white", strokeWidth: 1.4 }), /* @__PURE__ */ React.createElement("rect", { x: 11, y: 9, width: 2, height: 2, fill: "#868B98" }));
const Door = SvgDoorObjType;
const SvgStarredObjType = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6348_41797)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.62894 4.50828C8.68448 2.61474 9.21225 1.66797 10.0013 1.66797C10.7904 1.66797 11.3181 2.61474 12.3737 4.50828L12.6467 4.99816C12.9467 5.53625 13.0967 5.80529 13.3305 5.98281C13.5644 6.16032 13.8556 6.22622 14.4381 6.35801L14.9684 6.47799C17.0181 6.94176 18.043 7.17365 18.2868 7.95774C18.5306 8.74184 17.8319 9.55886 16.4346 11.1929L16.073 11.6157C15.6759 12.08 15.4774 12.3122 15.3881 12.5994C15.2988 12.8866 15.3288 13.1964 15.3888 13.8159L15.4435 14.38C15.6547 16.5601 15.7604 17.6502 15.122 18.1348C14.4837 18.6194 13.5241 18.1776 11.6049 17.2939L11.1084 17.0653C10.563 16.8142 10.2903 16.6887 10.0013 16.6887C9.71226 16.6887 9.43957 16.8142 8.89421 17.0653L8.3977 17.2939C6.47853 18.1776 5.51895 18.6194 4.88059 18.1348C4.24224 17.6502 4.34787 16.5601 4.55913 14.38L4.61379 13.8159C4.67382 13.1964 4.70384 12.8866 4.61452 12.5994C4.5252 12.3122 4.32666 12.08 3.92957 11.6157L3.56805 11.1929C2.17068 9.55886 1.47199 8.74184 1.71582 7.95774C1.95965 7.17365 2.98452 6.94176 5.03425 6.47799L5.56454 6.35801C6.14701 6.22622 6.43825 6.16032 6.67209 5.98281C6.90593 5.80529 7.05591 5.53625 7.35586 4.99816L7.62894 4.50828Z", stroke: "white", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6348_41797" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 5, fill: "white" }))));
const Starred = SvgStarredObjType;
const SvgWallObjType = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "path-1-inside-1_6348_41801", fill: "white" }, /* @__PURE__ */ React.createElement("path", { d: "M0 1C0 0.447715 0.447715 0 1 0H12V7H1C0.447715 7 0 6.55228 0 6V1Z" })), /* @__PURE__ */ React.createElement("path", { d: "M0 1C0 0.447715 0.447715 0 1 0H12V7H1C0.447715 7 0 6.55228 0 6V1Z", stroke: "white", strokeWidth: 2.6, mask: "url(#path-1-inside-1_6348_41801)" }), /* @__PURE__ */ React.createElement("mask", { id: "path-2-inside-2_6348_41801", fill: "white" }, /* @__PURE__ */ React.createElement("path", { d: "M20 13C20 12.4477 19.5523 12 19 12H8V19H19C19.5523 19 20 18.5523 20 18V13Z" })), /* @__PURE__ */ React.createElement("path", { d: "M20 13C20 12.4477 19.5523 12 19 12H8V19H19C19.5523 19 20 18.5523 20 18V13Z", stroke: "white", strokeWidth: 2.6, mask: "url(#path-2-inside-2_6348_41801)" }), /* @__PURE__ */ React.createElement("mask", { id: "path-3-inside-3_6348_41801", fill: "white" }, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 6, width: 11, height: 7, rx: 1 })), /* @__PURE__ */ React.createElement("rect", { x: 4, y: 6, width: 11, height: 7, rx: 1, stroke: "white", strokeWidth: 2.6, mask: "url(#path-3-inside-3_6348_41801)" }), /* @__PURE__ */ React.createElement("mask", { id: "path-4-inside-4_6348_41801", fill: "white" }, /* @__PURE__ */ React.createElement("rect", { x: 11, width: 9, height: 7, rx: 1 })), /* @__PURE__ */ React.createElement("rect", { x: 11, width: 9, height: 7, rx: 1, stroke: "white", strokeWidth: 2.6, mask: "url(#path-4-inside-4_6348_41801)" }), /* @__PURE__ */ React.createElement("mask", { id: "path-5-inside-5_6348_41801", fill: "white" }, /* @__PURE__ */ React.createElement("rect", { y: 12, width: 9, height: 7, rx: 1 })), /* @__PURE__ */ React.createElement("rect", { y: 12, width: 9, height: 7, rx: 1, stroke: "white", strokeWidth: 2.6, mask: "url(#path-5-inside-5_6348_41801)" }));
const Wall = SvgWallObjType;
const SvgWindowObjType = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6348_41809)" }, /* @__PURE__ */ React.createElement("path", { d: "M1.66797 9.16406C1.25376 9.16406 0.917969 9.49985 0.917969 9.91406C0.917969 10.3283 1.25376 10.6641 1.66797 10.6641V9.16406ZM18.3346 10.6641C18.7488 10.6641 19.0846 10.3283 19.0846 9.91406C19.0846 9.49985 18.7488 9.16406 18.3346 9.16406V10.6641ZM1.66797 10.6641H18.3346V9.16406H1.66797V10.6641Z", fill: "#868B98" }), /* @__PURE__ */ React.createElement("path", { d: "M9.25 18C9.25 18.4142 9.58579 18.75 10 18.75C10.4142 18.75 10.75 18.4142 10.75 18H9.25ZM10.75 2C10.75 1.58579 10.4142 1.25 10 1.25C9.58579 1.25 9.25 1.58579 9.25 2H10.75ZM10.75 18L10.75 2H9.25L9.25 18H10.75Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M1.66797 10.0013C1.66797 6.07293 1.66797 4.10875 2.88836 2.88836C4.10875 1.66797 6.07293 1.66797 10.0013 1.66797C13.9297 1.66797 15.8939 1.66797 17.1142 2.88836C18.3346 4.10875 18.3346 6.07293 18.3346 10.0013C18.3346 13.9297 18.3346 15.8939 17.1142 17.1142C15.8939 18.3346 13.9297 18.3346 10.0013 18.3346C6.07293 18.3346 4.10875 18.3346 2.88836 17.1142C1.66797 15.8939 1.66797 13.9297 1.66797 10.0013Z", stroke: "white", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6348_41809" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 5, fill: "white" }))));
const Window = SvgWindowObjType;
const svg2Icon = (Svg) => function SvgIcon(props) {
  return /* @__PURE__ */ jsx(Svg, { ...props });
};
const ObjectTypeIcons = {
  Starred: svg2Icon(Starred),
  Wall: svg2Icon(Wall),
  Window: svg2Icon(Window),
  Door: svg2Icon(Door),
  Object: svg2Icon(Object$1),
  Room: svg2Icon(Starred),
  Stair: svg2Icon(Starred),
  Column: svg2Icon(Starred),
  Escalator: svg2Icon(Starred),
  Zone: svg2Icon(Starred)
};
const ObjectTypes = [
  {
    id: "starred",
    icon: ObjectTypeIcons.Starred,
    label: "Starred"
  },
  {
    id: "wall",
    icon: ObjectTypeIcons.Wall,
    label: "Wall"
  },
  {
    id: "window",
    icon: ObjectTypeIcons.Window,
    label: "Window"
  },
  {
    id: "door",
    icon: ObjectTypeIcons.Door,
    label: "Door"
  },
  {
    id: "object",
    icon: ObjectTypeIcons.Object,
    label: "Object"
  }
  // { id: 'stair', icon: ObjectTypeIcons.Stair, label: 'Stair' },
  // { id: 'room', icon: ObjectTypeIcons.Room, label: 'Room' },
  // { id: 'column', icon: ObjectTypeIcons.Column, label: 'Column' },
  // { id: 'escalator', icon: ObjectTypeIcons.Escalator, label: 'Escalator' },
  // { id: 'zone', icon: ObjectTypeIcons.Zone, label: 'Zone' },
];
const ObjectSubTypesDefault = [
  // room
  {
    id: "shelf",
    typeId: "room",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "room",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "room",
    label: "Table"
  },
  // wall
  {
    id: "shelf",
    typeId: "wall",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "wall",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "wall",
    label: "Table"
  },
  // window
  {
    id: "shelf",
    typeId: "window",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "window",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "window",
    label: "Table"
  },
  // door
  {
    id: "shelf",
    typeId: "door",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "door",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "door",
    label: "Table"
  },
  // stair
  {
    id: "shelf",
    typeId: "stair",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "stair",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "stair",
    label: "Table"
  },
  // column
  {
    id: "shelf",
    typeId: "column",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "column",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "column",
    label: "Table"
  },
  // object
  {
    id: "shelf",
    typeId: "object",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "object",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "object",
    label: "Table"
  },
  // escalator
  {
    id: "shelf",
    typeId: "escalator",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "escalator",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "escalator",
    label: "Table"
  },
  // zone
  {
    id: "shelf",
    typeId: "zone",
    label: "Shelf"
  },
  {
    id: "cupboard",
    typeId: "zone",
    label: "Cup Board"
  },
  {
    id: "table",
    typeId: "zone",
    label: "Table"
  }
];
const MaterialsDefault = [...ObjectSubTypesDefault.map((st, i2) => [{
  id: `concrete_${i2}`,
  name: "Concrete",
  typeId: st.typeId,
  subtypeId: st.id,
  isFav: false,
  attenuation: "20",
  attenuationUnit: "db",
  height: "0.8",
  heightUnit: "m",
  color: "#FFA08C",
  opacity: "55"
}, {
  id: `brick_${i2}`,
  name: "Brick",
  typeId: st.typeId,
  subtypeId: st.id,
  isFav: false,
  attenuation: "15",
  attenuationUnit: "db",
  height: "0.8",
  heightUnit: "m",
  color: "#8F9779",
  opacity: "96"
}, {
  id: `stone_${i2}`,
  name: "Stone",
  typeId: st.typeId,
  subtypeId: st.id,
  isFav: true,
  attenuation: "10",
  attenuationUnit: "db",
  height: "0.8",
  heightUnit: "m",
  color: "#7B3F00",
  opacity: "90"
}, {
  id: `glass_${i2}`,
  name: "Glass",
  typeId: st.typeId,
  subtypeId: st.id,
  isFav: false,
  attenuation: "5",
  attenuationUnit: "db",
  height: "0.8",
  heightUnit: "m",
  color: "#24B1C5",
  opacity: "55"
}, {
  id: `wood_${i2}`,
  name: "Wood",
  typeId: st.typeId,
  subtypeId: st.id,
  isFav: false,
  attenuation: "5",
  attenuationUnit: "db",
  height: "0.8",
  heightUnit: "m",
  color: "#6A0DAD",
  opacity: "96"
}, {
  id: `metal_${i2}`,
  name: "Metal",
  typeId: st.typeId,
  subtypeId: st.id,
  isFav: true,
  attenuation: "5",
  attenuationUnit: "db",
  height: "0.8",
  heightUnit: "m",
  color: "#557FEB",
  opacity: "90"
}, {
  id: `drywall_${i2}`,
  name: "Dry Wall",
  typeId: st.typeId,
  subtypeId: st.id,
  isFav: true,
  attenuation: "5",
  attenuationUnit: "db",
  height: "0.8",
  heightUnit: "m",
  color: "#E0B0FF",
  opacity: "90"
}]).flat()];
const useMaterialStore = createZustandStore((set) => ({
  objectSubTypes: ObjectSubTypesDefault,
  materials: MaterialsDefault,
  addMaterial: (material) => {
    set((state) => {
      state.materials = [...state.materials, material];
    });
  },
  deleteMaterial: (material) => {
    set((state) => {
      const filtered = state.materials.filter((m2) => m2.id !== material.id);
      state.materials = filtered;
    });
  },
  updateMaterial: (material) => {
    set((state) => {
      const filtered = state.materials.map((m2) => m2.id === material.id ? material : m2);
      state.materials = filtered;
    });
  }
}), "MaterialStore");
function useFeatures(props) {
  const {
    id: activeId,
    fallback: fallbackToWorld,
    recursive,
    all: fallbackToAll,
    skipFeatures: skipFeatureIds,
    fallbackToParent
  } = props || {};
  const visiblilityChecker = useViewStore((state) => state.visiblilityChecker);
  const invisibleCategories = useViewStore((state) => state.invisibleCategories);
  const invisibleLayers = useViewStore((state) => state.invisibleLayers);
  const invisibleObjectIds = useViewStore((state) => state.invisibleObjectIds);
  const invisibleFlags = useViewStore((state) => state.invisibleFlags);
  const getObjectDetail = useSiteStore((state) => state.getObjectDetail);
  const getObjectFeatures = useSiteStore((state) => state.getObjectFeatures);
  const getAllSiteFeatures = useSiteStore((state) => state.getAllSiteFeatures);
  const activeLayerId = useViewStore((state) => state.activeLayerId);
  const numVenues = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.venues) == null ? void 0 : _a3.length;
  });
  const world = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.orphans) == null ? void 0 : _a3[0];
  });
  const getData6 = React__default.useCallback(() => {
    const result2 = {
      center: useSiteStore.getState().getDefaultCenter()
    };
    if (activeId) {
      const {
        collectionItem: parent2,
        collectionType: parentType2,
        center: center22
      } = getObjectDetail(activeId);
      if (parent2 && parentType2 && center22) {
        result2.parent = parent2;
        result2.parentType = parentType2;
        result2.center = center22 || result2.center;
      }
    }
    if (!result2.parent && world && fallbackToWorld) {
      result2.parent = world;
      result2.parentType = "orphan";
    }
    return result2;
  }, [activeId, fallbackToWorld, getObjectDetail, world]);
  const {
    parent,
    parentType,
    center: center2
  } = getData6();
  const {
    allFeatures,
    visibleFeatures,
    activeLayerFeatures,
    territories,
    rest
  } = React__default.useMemo(() => {
    var _a3;
    let allFeatures2;
    if (parent) {
      allFeatures2 = (_a3 = getObjectFeatures(parent, parentType, recursive)) == null ? void 0 : _a3.features;
      if (fallbackToParent && !(allFeatures2 == null ? void 0 : allFeatures2.length) && (parent == null ? void 0 : parent.type) === "level") {
        const buildingObj = {
          id: parent == null ? void 0 : parent.buildingId,
          type: "building"
        };
        const result2 = getObjectFeatures(buildingObj, "building", false);
        allFeatures2 = result2 == null ? void 0 : result2.features;
      }
    } else if (fallbackToAll) {
      allFeatures2 = getAllSiteFeatures();
    }
    const visibleFeatures2 = [];
    const activeLayerFeatures2 = [];
    const territories2 = [];
    allFeatures2 == null ? void 0 : allFeatures2.forEach((f2) => {
      var _a4, _b3, _c2, _d2, _e2, _f3, _g;
      if ((_a4 = f2.properties) == null ? void 0 : _a4.territoryType) {
        const isTerritoryVisible = !(invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes((_b3 = f2.properties) == null ? void 0 : _b3.countryId));
        if (isTerritoryVisible) {
          const cloned = {
            ...f2,
            properties: {
              filterKey: f2.properties.name,
              ...f2.properties
            }
          };
          delete cloned.properties.visible;
          territories2.push(cloned);
        }
      } else if ((_c2 = f2.properties) == null ? void 0 : _c2.layer) {
        const isSkipFeature = skipFeatureIds == null ? void 0 : skipFeatureIds.includes(f2.id);
        const layerVisible = !(invisibleLayers == null ? void 0 : invisibleLayers.includes((_d2 = f2.properties) == null ? void 0 : _d2.layer));
        const categoryVisible = !(invisibleCategories == null ? void 0 : invisibleCategories.includes((_e2 = f2.properties) == null ? void 0 : _e2.category));
        const featureVisibleFinal = !isSkipFeature && layerVisible && categoryVisible ? visiblilityChecker(f2, invisibleFlags) : false;
        const isActiveLayerFeature = activeLayerId && ((_f3 = f2.properties) == null ? void 0 : _f3.layer) === activeLayerId || false;
        if (featureVisibleFinal) {
          visibleFeatures2.push(f2);
        }
        if (isActiveLayerFeature) {
          activeLayerFeatures2.push(f2);
        }
      } else {
        const {
          collectionType: parentType2,
          collectionItem: parent2
        } = getObjectDetail(f2.id) || {};
        const isSkipFeature = skipFeatureIds == null ? void 0 : skipFeatureIds.includes(f2.id);
        const categoryVisible = !(invisibleCategories == null ? void 0 : invisibleCategories.includes((_g = f2.properties) == null ? void 0 : _g.category));
        const parentTypeVisible = !(invisibleCategories == null ? void 0 : invisibleCategories.includes(parentType2));
        const flagVisible = !(invisibleFlags == null ? void 0 : invisibleFlags.includes(parentType2));
        const featureVisible = !("visible" in f2.properties) || f2.properties.visible;
        const parentIdVisible = !parent2 || !(invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(parent2.id));
        const featureVisibleFinal = !isSkipFeature && categoryVisible && featureVisible && parentTypeVisible && flagVisible && parentIdVisible ? visiblilityChecker(f2, invisibleFlags) : false;
        if (featureVisibleFinal) {
          visibleFeatures2.push(f2);
        }
      }
    });
    const rest2 = {
      ...parent
    };
    delete rest2.type;
    delete rest2.id;
    delete rest2.features;
    return {
      visibleFeatures: visibleFeatures2,
      allFeatures: allFeatures2,
      activeLayerFeatures: activeLayerFeatures2,
      territories: territories2,
      rest: rest2
    };
  }, [numVenues, fallbackToAll, parent, getObjectFeatures, invisibleObjectIds, parentType, recursive, fallbackToParent, getAllSiteFeatures, invisibleLayers, invisibleCategories, visiblilityChecker, invisibleFlags, activeLayerId, getObjectDetail, skipFeatureIds]);
  const result = {
    ...rest,
    allFeatures,
    visibleFeatures,
    activeLayerFeatures,
    name: parent == null ? void 0 : parent.name,
    type: parentType,
    id: parent == null ? void 0 : parent.id,
    territories,
    center: center2
  };
  return result;
}
const defaultFloorHeight = 4;
function useFeaturesAdvanced(props) {
  const {
    id: activeId,
    fallback,
    recursive,
    skipFeatures
  } = props || {};
  const invisibleObjectIds = useViewStore((state) => state.invisibleObjectIds);
  const singleFloorActive = useViewStore((state) => !!state.activeLevelId);
  const found = useFeatures({
    id: activeId,
    fallback,
    recursive,
    skipFeatures
  });
  const prepareBuilding = React__default.useCallback((object2) => {
    const {
      building,
      levels
    } = object2 || {};
    if (!building)
      return null;
    const buildingHeight = building.height;
    const buildingFeatures = building.features || building.allFeatures;
    const buildingFootprints = buildingFeatures == null ? void 0 : buildingFeatures.filter((feature2) => {
      var _a3;
      return ((_a3 = feature2.properties) == null ? void 0 : _a3.category) === "footprint";
    });
    if (!(buildingFootprints == null ? void 0 : buildingFootprints.length))
      return null;
    const buildingFootprint = buildingFootprints[0];
    const buildingId = building.id;
    const features = [];
    levels.forEach((level) => {
      var _a3;
      if (level.buildingId !== buildingId || invisibleObjectIds.includes(level.id))
        return;
      if (typeof level.levelNumber !== "number" || !Number.isFinite(level.levelNumber))
        return;
      const levelFootprints = (_a3 = level.features) == null ? void 0 : _a3.filter((feature2) => {
        var _a4, _b3;
        return ((_a4 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a4.type) === "Polygon" && !((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.layer);
      });
      const footprintToUse = (levelFootprints == null ? void 0 : levelFootprints[0]) || buildingFootprint;
      if (!footprintToUse)
        return;
      const baseHeightFromGround = level.elevation || 0;
      const floorHeightFromGround = baseHeightFromGround + (level.height || defaultFloorHeight);
      const levelFeature = {
        ...footprintToUse,
        id: level.id,
        properties: {
          ...footprintToUse.properties,
          levelNumber: level.levelNumber,
          // OBJECTID: level.id,
          base_height: baseHeightFromGround,
          height: floorHeightFromGround
        }
      };
      features.push(levelFeature);
    });
    if (!features.length && buildingHeight) {
      const buildingFeature = {
        ...buildingFootprint,
        properties: {
          ...buildingFootprint.properties,
          levelNumber: 0,
          // OBJECTID: buildingId, // do we need this?
          base_height: building.elevation || 0,
          height: buildingHeight,
          color: "#f5fefd"
        }
      };
      features.push(buildingFeature);
    }
    if (!(features == null ? void 0 : features.length)) {
      return null;
    }
    const data2 = {
      type: "FeatureCollection",
      features
    };
    return {
      data: data2,
      buildingHeight,
      buildingId: building.id
    };
  }, [invisibleObjectIds]);
  const flooredBuildings = React__default.useMemo(() => {
    var _a3, _b3, _c2, _d2;
    const result = [];
    if (!(found == null ? void 0 : found.id))
      return result;
    if (found.id !== activeId)
      return result;
    if (found.type === "venue") {
      const buildings = (_a3 = useSiteStore.getState().buildings) == null ? void 0 : _a3.filter((b2) => b2.venueId === activeId);
      buildings == null ? void 0 : buildings.forEach((building) => {
        var _a4;
        result.push(prepareBuilding({
          building,
          levels: (_a4 = useSiteStore.getState().levels) == null ? void 0 : _a4.filter((l2) => l2.buildingId === building.id)
        }));
      });
    }
    if (found.type === "building") {
      result.push(prepareBuilding({
        building: found,
        levels: (_b3 = useSiteStore.getState().levels) == null ? void 0 : _b3.filter((l2) => l2.buildingId === activeId)
      }));
    }
    if (found.type === "level") {
      result.push(prepareBuilding({
        building: (_c2 = useSiteStore.getState().buildings) == null ? void 0 : _c2.find((b2) => b2.id === found.buildingId),
        levels: (_d2 = useSiteStore.getState().levels) == null ? void 0 : _d2.filter((l2) => l2.id === found.id)
      }));
    }
    return result.filter((i2) => !!i2);
  }, [activeId, found, prepareBuilding]);
  const finalResult = React__default.useMemo(() => {
    const {
      allFeatures,
      visibleFeatures
    } = found || {};
    const buildingIdSet = new Set(...(flooredBuildings == null ? void 0 : flooredBuildings.map((f2) => f2.buildingId)) || []);
    const filterFeature = (feature2) => !buildingIdSet.has(feature2.parentId);
    const finalResult2 = {
      ...found || {},
      defaultFloorHeight,
      flooredBuildings,
      allFeatures: allFeatures == null ? void 0 : allFeatures.filter(filterFeature),
      visibleFeatures: visibleFeatures == null ? void 0 : visibleFeatures.filter(filterFeature),
      singleFloorActive
    };
    return finalResult2;
  }, [flooredBuildings, found, singleFloorActive]);
  return finalResult;
}
function useAssets(props) {
  const {
    id: activeId,
    visible = true
  } = props || {};
  const assets = useAssetStore((state) => state.assets);
  const [filteredAssets, setFilteredAssets] = React__default.useState([]);
  React__default.useLayoutEffect(() => {
    if (!activeId)
      return;
    const filtered = assets.filter((asset) => asset.parentId === activeId);
    setFilteredAssets(filtered);
  }, [activeId, assets, visible]);
  return filteredAssets;
}
const useProjectStore = createZustandStore((set, get6) => ({
  projects: [],
  projectSelected: null,
  projectCategoryOptionSelect: null,
  gsFeatureData: [],
  featureFocusId: null,
  isNewFileAdded: false,
  focusFeatures: [],
  exportFile: null,
  setExportFile: (exportFileId, exportFileName) => set(() => ({
    exportFile: {
      exportFileID: exportFileId,
      exportFileName
    }
  })),
  setFeatureFocusId: (featureId) => set(() => ({
    featureFocusId: featureId
  })),
  setIsNewFileAdded: (newFileAdded) => set(() => ({
    isNewFileAdded: newFileAdded
  })),
  addProject: (projectName) => set((state) => {
    const index2 = state.projects.findIndex((item) => item.name === projectName);
    if (index2 === -1) {
      const newProject = {
        id: generateUid(),
        name: projectName,
        type: "project",
        categories: []
      };
      return {
        projects: [...state.projects, newProject]
      };
    }
    return state;
  }),
  setProjects: (projects) => {
    set((state) => {
      projects == null ? void 0 : projects.forEach((project3) => {
        if (project3.id && project3.name) {
          const found = get6().projects.find((item) => item.name === project3.name);
          if (!found) {
            state.projects.push(project3);
          }
        }
      });
    });
  },
  addProjectCategory: (projectId, categoryDetails) => set((state) => {
    const updatedProjects = state.projects.map((project3) => project3.id === projectId ? {
      ...project3,
      categories: [...project3.categories, categoryDetails]
    } : project3);
    return {
      projects: updatedProjects
    };
  }),
  updateProjectCategory: (projectId, categoryId, categoryDetails) => set((state) => {
    const updatedProjects = state.projects.map((project3) => project3.id === projectId ? {
      ...project3,
      categories: project3.categories.map((category) => category.id === categoryId ? categoryDetails : category)
    } : project3);
    return {
      projects: updatedProjects
    };
  }),
  deleteProjectCategory: (projectId, categoryId) => set((state) => {
    const updatedProjects = state.projects.map((project3) => project3.id === projectId ? {
      ...project3,
      categories: project3.categories.filter((category) => category.id !== categoryId)
    } : project3);
    return {
      projects: updatedProjects
    };
  }),
  setprojectCategoryOptionSelect: (actionOption) => set(() => ({
    projectCategoryOptionSelect: actionOption
  })),
  updateCategoryName: (projectId, categoryId, newName) => set((state) => {
    const updatedProjects = state.projects.map((project3) => project3.id === projectId ? {
      ...project3,
      categories: project3.categories.map((category) => category.id === categoryId ? {
        ...category,
        name: newName
      } : category)
    } : project3);
    return {
      projects: updatedProjects
    };
  }),
  updateProjectName: (id, newName) => set((state) => {
    const updatedProjects = state.projects.map((project3) => project3.id === id ? {
      ...project3,
      name: newName
    } : project3);
    return {
      projects: updatedProjects
    };
  }),
  updateCategoryShowStatus: (projectId, categoryId, showStatus) => set((state) => {
    const updatedProjects = state.projects.map((project3) => project3.id === projectId ? {
      ...project3,
      categories: project3.categories.map((category) => category.id === categoryId ? {
        ...category,
        show: showStatus
      } : category)
    } : project3);
    return {
      projects: updatedProjects
    };
  }),
  updateFeatureName: (projectId, categoryId, featureId, newFeatureName) => set((state) => {
    const updatedProjects = state.projects.map((project3) => {
      if (project3.id === projectId) {
        const updatedCategories = project3.categories.map((category) => {
          if (category.id === categoryId) {
            const updatedFeatures = category.features.map((feature2) => {
              if (feature2.properties.id === featureId) {
                return {
                  ...feature2,
                  properties: {
                    ...feature2.properties,
                    name: newFeatureName
                  }
                };
              }
              return feature2;
            });
            return {
              ...category,
              features: updatedFeatures
            };
          }
          return category;
        });
        return {
          ...project3,
          categories: updatedCategories
        };
      }
      return project3;
    });
    return {
      projects: updatedProjects
    };
  }),
  addProjectSelected: (projectDetails) => set(() => ({
    projectSelected: projectDetails
  })),
  updateProjectSelected: (updatedDetails) => set((state) => ({
    projectSelected: {
      ...state.projectSelected,
      ...updatedDetails
    }
  })),
  removeProjectSelected: () => set(() => ({
    projectSelected: null
  })),
  setGSFeatureData: (categoryId = null, type = null, features = null) => {
    set((state) => {
      if (categoryId === null && type === null && features === null) {
        return {
          gsFeatureData: []
        };
      }
      if (categoryId !== null && type === null && features === null) {
        const projectContainingCategory = state.projects.find((project3) => project3.categories.some((category) => category.id === categoryId));
        if (projectContainingCategory) {
          const categoryData = projectContainingCategory.categories.find((category) => category.id === categoryId);
          const index2 = state.gsFeatureData.findIndex((data2) => data2.id === categoryData.id);
          if (index2 === -1) {
            const gsFeatureData = mergeArray(state.gsFeatureData, [categoryData]);
            return {
              gsFeatureData
            };
          }
          return {
            gsFeatureData: state.gsFeatureData.filter((_2, idx) => idx !== index2)
          };
        }
      } else if (features !== null) {
        const index2 = state.gsFeatureData.findIndex((data2) => data2.id === features.id);
        if (index2 === -1) {
          const gsFeatureData = mergeArray(state.gsFeatureData, [features]);
          return {
            gsFeatureData
          };
        }
        return {
          gsFeatureData: state.gsFeatureData.filter((_2, idx) => idx !== index2)
        };
      }
      return state;
    });
  },
  setFocusFeatures: (categoryId = null, type = null, features = null) => {
    set((state) => {
      if (categoryId === null && type === null && features === null) {
        return {
          focusFeatures: []
        };
      }
      if (categoryId !== null && type === null && features === null) {
        const projectContainingCategory = state.projects.find((project3) => project3.categories.some((category) => category.id === categoryId));
        if (projectContainingCategory) {
          const categoryData = projectContainingCategory.categories.find((category) => category.id === categoryId);
          const index2 = state.focusFeatures.findIndex((data2) => data2.id === categoryData.id);
          if (index2 === -1) {
            const focusFeatures = mergeArray(state.focusFeatures, [categoryData]);
            return {
              focusFeatures
            };
          }
          return {
            focusFeatures: state.focusFeatures.filter((_2, idx) => idx !== index2)
          };
        }
      } else if (features !== null) {
        const index2 = state.focusFeatures.findIndex((data2) => data2.id === features.id);
        if (index2 === -1) {
          const focusFeatures = mergeArray(state.focusFeatures, [features]);
          return {
            focusFeatures
          };
        }
        return {
          focusFeatures: state.focusFeatures.filter((_2, idx) => idx !== index2)
        };
      }
      return state;
    });
  },
  updateShowGSfeatureData: (id, showStatus) => {
    set((state) => {
      const updatedGsFeatureData = state.gsFeatureData.map((data2) => data2.id === id ? {
        ...data2,
        show: showStatus
      } : data2);
      return {
        gsFeatureData: updatedGsFeatureData
      };
    });
  }
}), "ProjectStore");
const DefaultColors = ["#B3BD97", "#2B6829", "#333", "#F0E68C", "#FF6F61", "#7B3F00", "#87CEEB", "#40E0D0", "#E0B0FF", "#B62F22", "#FFD700", "#808000"];
const DefaultAttenUnit = [{
  label: "db/m",
  value: "db",
  key: "db"
}];
const DefaultHeightUnit = [{
  label: "m",
  value: "m",
  key: "m"
}];
const useMaterialPropStore = createZustandStore((set) => ({
  colors: DefaultColors,
  attenuationUnits: DefaultAttenUnit,
  heightUnits: DefaultHeightUnit,
  addColor: (color) => {
    set((state) => {
      state.colors = [.../* @__PURE__ */ new Set([...state.colors, color])];
    });
  }
}), "MaterialPropStore");
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var propTypes = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b2 = "function" === typeof Symbol && Symbol.for, c2 = b2 ? Symbol.for("react.element") : 60103, d2 = b2 ? Symbol.for("react.portal") : 60106, e3 = b2 ? Symbol.for("react.fragment") : 60107, f2 = b2 ? Symbol.for("react.strict_mode") : 60108, g2 = b2 ? Symbol.for("react.profiler") : 60114, h2 = b2 ? Symbol.for("react.provider") : 60109, k2 = b2 ? Symbol.for("react.context") : 60110, l2 = b2 ? Symbol.for("react.async_mode") : 60111, m2 = b2 ? Symbol.for("react.concurrent_mode") : 60111, n2 = b2 ? Symbol.for("react.forward_ref") : 60112, p2 = b2 ? Symbol.for("react.suspense") : 60113, q2 = b2 ? Symbol.for("react.suspense_list") : 60120, r2 = b2 ? Symbol.for("react.memo") : 60115, t2 = b2 ? Symbol.for("react.lazy") : 60116, v5 = b2 ? Symbol.for("react.block") : 60121, w2 = b2 ? Symbol.for("react.fundamental") : 60117, x2 = b2 ? Symbol.for("react.responder") : 60118, y2 = b2 ? Symbol.for("react.scope") : 60119;
  function z2(a2) {
    if ("object" === typeof a2 && null !== a2) {
      var u2 = a2.$$typeof;
      switch (u2) {
        case c2:
          switch (a2 = a2.type, a2) {
            case l2:
            case m2:
            case e3:
            case g2:
            case f2:
            case p2:
              return a2;
            default:
              switch (a2 = a2 && a2.$$typeof, a2) {
                case k2:
                case n2:
                case t2:
                case r2:
                case h2:
                  return a2;
                default:
                  return u2;
              }
          }
        case d2:
          return u2;
      }
    }
  }
  function A2(a2) {
    return z2(a2) === m2;
  }
  reactIs_production_min.AsyncMode = l2;
  reactIs_production_min.ConcurrentMode = m2;
  reactIs_production_min.ContextConsumer = k2;
  reactIs_production_min.ContextProvider = h2;
  reactIs_production_min.Element = c2;
  reactIs_production_min.ForwardRef = n2;
  reactIs_production_min.Fragment = e3;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r2;
  reactIs_production_min.Portal = d2;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f2;
  reactIs_production_min.Suspense = p2;
  reactIs_production_min.isAsyncMode = function(a2) {
    return A2(a2) || z2(a2) === l2;
  };
  reactIs_production_min.isConcurrentMode = A2;
  reactIs_production_min.isContextConsumer = function(a2) {
    return z2(a2) === k2;
  };
  reactIs_production_min.isContextProvider = function(a2) {
    return z2(a2) === h2;
  };
  reactIs_production_min.isElement = function(a2) {
    return "object" === typeof a2 && null !== a2 && a2.$$typeof === c2;
  };
  reactIs_production_min.isForwardRef = function(a2) {
    return z2(a2) === n2;
  };
  reactIs_production_min.isFragment = function(a2) {
    return z2(a2) === e3;
  };
  reactIs_production_min.isLazy = function(a2) {
    return z2(a2) === t2;
  };
  reactIs_production_min.isMemo = function(a2) {
    return z2(a2) === r2;
  };
  reactIs_production_min.isPortal = function(a2) {
    return z2(a2) === d2;
  };
  reactIs_production_min.isProfiler = function(a2) {
    return z2(a2) === g2;
  };
  reactIs_production_min.isStrictMode = function(a2) {
    return z2(a2) === f2;
  };
  reactIs_production_min.isSuspense = function(a2) {
    return z2(a2) === p2;
  };
  reactIs_production_min.isValidElementType = function(a2) {
    return "string" === typeof a2 || "function" === typeof a2 || a2 === e3 || a2 === m2 || a2 === g2 || a2 === f2 || a2 === p2 || a2 === q2 || "object" === typeof a2 && null !== a2 && (a2.$$typeof === t2 || a2.$$typeof === r2 || a2.$$typeof === h2 || a2.$$typeof === k2 || a2.$$typeof === n2 || a2.$$typeof === w2 || a2.$$typeof === x2 || a2.$$typeof === y2 || a2.$$typeof === v5);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object2.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
        return test2[n2];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s2 = 1; s2 < arguments.length; s2++) {
      from = Object(arguments[s2]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from, symbols[i2])) {
            to[symbols[i2]] = from[symbols[i2]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has$1;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has$1;
  hasRequiredHas = 1;
  has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$1;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has2 = requireHas();
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values4, location2, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has2(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values4, typeSpecName, componentName, location2, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location2 + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack2 = getStack ? getStack() : "";
            printWarning(
              "Failed " + location2 + " type: " + error2.message + (stack2 != null ? stack2 : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs2 = requireReactIs();
  var assign3 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has2 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text) {
      var message2 = "Warning: " + text;
      if (typeof console !== "undefined") {
        console.error(message2);
      }
      try {
        throw new Error(message2);
      } catch (x2) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess2) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is3(x2, y2) {
      if (x2 === y2) {
        return x2 !== 0 || 1 / x2 === 1 / y2;
      } else {
        return x2 !== x2 && y2 !== y2;
      }
    }
    function PropTypeError(message2, data2) {
      this.message = message2;
      this.data = data2 && typeof data2 === "object" ? data2 : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate2) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName2, componentName, location2, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName2;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess2) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey = componentName + ":" + propName2;
            if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName2] == null) {
          if (isRequired) {
            if (props[propName2] === null) {
              return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location2 + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate2(props, propName2, componentName, location2, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate2(props, propName2, componentName, location2, propFullName, secret) {
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props[propName2];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error2 = typeChecker(propValue, i2, componentName, location2, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeChecker() {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createElementTypeTypeChecker() {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        if (!ReactIs2.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (!(props[propName2] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName2]);
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is3(propValue, expectedValues[i2])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has2(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate2(props, propName2, componentName, location2, propFullName) {
        var expectedTypes = [];
        for (var i22 = 0; i22 < arrayOfTypeCheckers.length; i22++) {
          var checker2 = arrayOfTypeCheckers[i22];
          var checkerResult = checker2(props, propName2, componentName, location2, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has2(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate2);
    }
    function createNodeChecker() {
      function validate2(props, propName2, componentName, location2, propFullName) {
        if (!isNode(props[propName2])) {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function invalidValidatorError(componentName, location2, propFullName, key, type) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location2 + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate2(props, propName2, componentName, location2, propFullName) {
        var propValue = props[propName2];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location2 + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign3({}, props[propName2], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has2(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location2, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location2 + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName2], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key, componentName, location2, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate2);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator7 = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator7.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              while (!(step = iterator7.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case "array":
        case "object":
          return "an " + type;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type;
        default:
          return type;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim2(props, propName2, componentName, location2, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const BoxRotateAnchor$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjciIGhlaWdodD0iMjciIHZpZXdCb3g9IjAgMCAyNyAyNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSI5LjIzMDQ3IiB5PSI3LjU2NDQ1IiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiByeD0iNCIgZmlsbD0iIzEzMTYxQiIgLz4KICA8cmVjdCB4PSI5LjIzMDQ3IiB5PSI3LjU2NDQ1IiB3aWR0aD0iOCIgaGVpZ2h0PSI4IiByeD0iNCIgc3Ryb2tlPSIjMUQ2OEQxIiAvPgogIDxwYXRoCiAgICBvcGFjaXR5PSIwLjYiCiAgICBkPSJNMjMuMzk0MyAxNS41NjUzTDI2LjI4MSAxMC41NjUzSDIwLjUwNzVMMjMuMzk0MyAxNS41NjUzWk0zLjA2ODM2IDE1LjU2NTNMNS45NTUxMSAxMC41NjUzSDAuMTgxNjA4TDMuMDY4MzYgMTUuNTY1M1pNMy41NjgzNiAxMS41NjUzQzMuNTY4MzYgNi4yMjg2IDcuODk0NjEgMS45MDIzNCAxMy4yMzEzIDEuOTAyMzRWMC45MDIzNDRDNy4zNDIzMyAwLjkwMjM0NCAyLjU2ODM2IDUuNjc2MzEgMi41NjgzNiAxMS41NjUzSDMuNTY4MzZaTTEzLjIzMTMgMS45MDIzNEMxOC41NjggMS45MDIzNCAyMi44OTQzIDYuMjI4NiAyMi44OTQzIDExLjU2NTNIMjMuODk0M0MyMy44OTQzIDUuNjc2MzEgMTkuMTIwMyAwLjkwMjM0NCAxMy4yMzEzIDAuOTAyMzQ0VjEuOTAyMzRaIgogICAgZmlsbD0iI0Q4OTYxNCIKICAvPgo8L3N2Zz4K";
const BoxPointAnchor$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIwLjk2NDg0NCIgeT0iMC45NjA5MzgiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICA8cmVjdCB4PSIwLjk2NDg0NCIgeT0iMC45NjA5MzgiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHN0cm9rZT0iIzAwODBGRiIgLz4KPC9zdmc+Cg==";
const VenueIcon$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIwLjkzMTY0MSIgeT0iMC4yNSIgd2lkdGg9IjIzLjUiIGhlaWdodD0iMjMuNSIgcng9IjEuNzUiIGZpbGw9IiMxM0MyQzIiIC8+CiAgPHJlY3QKICAgIHg9IjAuOTMxNjQxIgogICAgeT0iMC4yNSIKICAgIHdpZHRoPSIyMy41IgogICAgaGVpZ2h0PSIyMy41IgogICAgcng9IjEuNzUiCiAgICBzdHJva2U9IiNENUQ2RDciCiAgICBzdHJva2Utd2lkdGg9IjAuNSIKICAvPgogIDxwYXRoCiAgICBkPSJNNS40NTcwMyAxOC40MzIxVjUuMzA3MTNIMTIuNDQ1VjguMzcySDE5LjkwODhWMTguNDMyMUg1LjQ1NzAzWk02LjMwNzkxIDE3LjU4MTFIOC41MjkwM1YxNS4zNTk5SDYuMzA3OTFWMTcuNTgxMVpNNi4zMDc5MSAxNC41MDkxSDguNTI5MDNWMTIuMjk1MUg2LjMwNzkxVjE0LjUwOTFaTTYuMzA3OTEgMTEuNDQ0SDguNTI5MDNWOS4yMjI4OEg2LjMwNzkxVjExLjQ0NFpNNi4zMDc5MSA4LjM3Mkg4LjUyOTAzVjYuMTU4SDYuMzA3OTFWOC4zNzJaTTkuMzgwMDkgMTcuNTgxMUgxMS41OTM5VjE1LjM1OTlIOS4zODAwOVYxNy41ODExWk05LjM4MDA5IDE0LjUwOTFIMTEuNTkzOVYxMi4yOTUxSDkuMzgwMDlWMTQuNTA5MVpNOS4zODAwOSAxMS40NDRIMTEuNTkzOVY5LjIyMjg4SDkuMzgwMDlWMTEuNDQ0Wk05LjM4MDA5IDguMzcySDExLjU5MzlWNi4xNThIOS4zODAwOVY4LjM3MlpNMTIuNDQ1IDE3LjU4MTFIMTkuMDU3OVY5LjIyMjg4SDEyLjQ0NVYxMS40NDRIMTQuMDg5MlYxMi4yOTUxSDEyLjQ0NVYxNC41MDkxSDE0LjA4OTJWMTUuMzU5OUgxMi40NDVWMTcuNTgxMVpNMTYuMDc5NSAxMi4yOTUxVjExLjQ0NEgxNi45MzA1VjEyLjI5NTFIMTYuMDc5NVpNMTYuMDc5NSAxNS4zNTk5VjE0LjUwOTFIMTYuOTMwNVYxNS4zNTk5SDE2LjA3OTVaIgogICAgZmlsbD0iYmxhY2siCiAgLz4KPC9zdmc+Cg==";
const BuildingIcon$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIxLjA5Mjc3IiB5PSIwLjUwNDg4MyIgd2lkdGg9IjIzLjUiIGhlaWdodD0iMjMuNSIgcng9IjEuNzUiIGZpbGw9IiM0MDk2RkYiIC8+CiAgPHJlY3QKICAgIHg9IjEuMDkyNzciCiAgICB5PSIwLjUwNDg4MyIKICAgIHdpZHRoPSIyMy41IgogICAgaGVpZ2h0PSIyMy41IgogICAgcng9IjEuNzUiCiAgICBzdHJva2U9IiNENUQ2RDciCiAgICBzdHJva2Utd2lkdGg9IjAuNSIKICAvPgogIDxwYXRoCiAgICBkPSJNNi4yODAyNyAxOC42ODc3VjguNjI3NjJIOS4zNTI0NlY1LjU2Mjc0SDE2LjM0MDRWMTEuNjk5NkgxOS40MDUzVjE4LjY4NzdIMTMuOTU5MVYxNS42MTU2SDExLjcyNjRWMTguNjg3N0g2LjI4MDI3Wk03LjEzMTE1IDE3LjgzNjdIOS4zNTI0NlYxNS42MTU2SDcuMTMxMTVWMTcuODM2N1pNNy4xMzExNSAxNC43NjQ3SDkuMzUyNDZWMTIuNTUwN0g3LjEzMTE1VjE0Ljc2NDdaTTcuMTMxMTUgMTEuNjk5Nkg5LjM1MjQ2VjkuNDc4NDlINy4xMzExNVYxMS42OTk2Wk0xMC4yMDMzIDE0Ljc2NDdIMTIuNDE3M1YxMi41NTA3SDEwLjIwMzNWMTQuNzY0N1pNMTAuMjAzMyAxMS42OTk2SDEyLjQxNzNWOS40Nzg0OUgxMC4yMDMzVjExLjY5OTZaTTEwLjIwMzMgOC42Mjc2MkgxMi40MTczVjYuNDEzNjJIMTAuMjAzM1Y4LjYyNzYyWk0xMy4yNjgyIDE0Ljc2NDdIMTUuNDg5M1YxMi41NTA3SDEzLjI2ODJWMTQuNzY0N1pNMTMuMjY4MiAxMS42OTk2SDE1LjQ4OTNWOS40Nzg0OUgxMy4yNjgyVjExLjY5OTZaTTEzLjI2ODIgOC42Mjc2MkgxNS40ODkzVjYuNDEzNjJIMTMuMjY4MlY4LjYyNzYyWk0xNi4zNDA0IDE3LjgzNjdIMTguNTU0NFYxNS42MTU2SDE2LjM0MDRWMTcuODM2N1pNMTYuMzQwNCAxNC43NjQ3SDE4LjU1NDRWMTIuNTUwN0gxNi4zNDA0VjE0Ljc2NDdaIgogICAgZmlsbD0id2hpdGUiCiAgLz4KPC9zdmc+Cg==";
const Undefined$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTI5Ljg0MzggMTAuOTcyN0MyOS4yOTY5IDkuNzc3MzQgMjguNTE5NSA4LjcwMzEyIDI3LjUyNzMgNy43ODUxNkMyNS41MTE3IDUuOTE0MDYgMjIuODM1OSA0Ljg4MjgxIDIwIDQuODgyODFDMTcuMTY0MSA0Ljg4MjgxIDE0LjQ4ODMgNS45MTQwNiAxMi40NzI3IDcuNzgxMjVDMTEuNDgwNSA4LjcwMzEyIDEwLjcwMzEgOS43NzM0NCAxMC4xNTYyIDEwLjk3MjdDOS41ODU5NCAxMi4yMjI3IDkuMjk2ODggMTMuNTQ2OSA5LjI5Njg4IDE0LjkxNDFWMTUuOTY4OEM5LjI5Njg4IDE2LjIxMDkgOS40OTIxOSAxNi40MDYyIDkuNzM0MzcgMTYuNDA2MkgxMS44NDM4QzEyLjA4NTkgMTYuNDA2MiAxMi4yODEyIDE2LjIxMDkgMTIuMjgxMiAxNS45Njg4VjE0LjkxNDFDMTIuMjgxMiAxMS4wMjczIDE1Ljc0MjIgNy44NjcxOSAyMCA3Ljg2NzE5QzI0LjI1NzggNy44NjcxOSAyNy43MTg4IDExLjAyNzMgMjcuNzE4OCAxNC45MTQxQzI3LjcxODggMTYuNTA3OCAyNy4xNTIzIDE4LjAwNzggMjYuMDc4MSAxOS4yNTc4QzI1LjAxNTYgMjAuNDk2MSAyMy41MTU2IDIxLjM4MjggMjEuODU1NSAyMS43NTc4QzIwLjkwNjIgMjEuOTcyNyAyMC4wNTA4IDIyLjUwNzggMTkuNDQ1MyAyMy4yNzM0QzE4Ljg0MiAyNC4wMzY0IDE4LjUxMzEgMjQuOTgwNCAxOC41MTE3IDI1Ljk1MzFWMjcuMTc5N0MxOC41MTE3IDI3LjQyMTkgMTguNzA3IDI3LjYxNzIgMTguOTQ5MiAyNy42MTcySDIxLjA1ODZDMjEuMzAwOCAyNy42MTcyIDIxLjQ5NjEgMjcuNDIxOSAyMS40OTYxIDI3LjE3OTdWMjUuOTUzMUMyMS40OTYxIDI1LjMzOTggMjEuOTIxOSAyNC44MDA4IDIyLjUxMTcgMjQuNjY4QzI0Ljc5MyAyNC4xNTIzIDI2Ljg2MzMgMjIuOTIxOSAyOC4zNDM4IDIxLjIwMzFDMjkuMDg5OCAyMC4zMzIgMjkuNjcxOSAxOS4zNjMzIDMwLjA3NDIgMTguMzEyNUMzMC40OTIyIDE3LjIyMjcgMzAuNzAzMSAxNi4wNzgxIDMwLjcwMzEgMTQuOTE0MUMzMC43MDMxIDEzLjU0NjkgMzAuNDE0MSAxMi4yMTg3IDI5Ljg0MzggMTAuOTcyN1pNMjAgMzAuNzQyMkMxOC43OTMgMzAuNzQyMiAxNy44MTI1IDMxLjcyMjcgMTcuODEyNSAzMi45Mjk3QzE3LjgxMjUgMzQuMTM2NyAxOC43OTMgMzUuMTE3MiAyMCAzNS4xMTcyQzIxLjIwNyAzNS4xMTcyIDIyLjE4NzUgMzQuMTM2NyAyMi4xODc1IDMyLjkyOTdDMjIuMTg3NSAzMS43MjI3IDIxLjIwNyAzMC43NDIyIDIwIDMwLjc0MjJaIgogICAgZmlsbD0iY3VycmVudENvbG9yIgogICAgZmlsbC1vcGFjaXR5PSIwLjQ1IgogIC8+Cjwvc3ZnPgo=";
const DirectionLeaf$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0MCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjczNTQgMC45ODQ2MTlDMTkuOTU5MSAwLjk4NDYxOSAyMC4xODc2IDEuMDkwMDUgMjAuMzk4NCAxLjIyODc2QzIwLjYxNTQgMS4zNzE1IDIwLjg0NTggMS41NzEyOSAyMS4wODExIDEuODA0OTNDMjEuNTUyMiAyLjI3MjkzIDIyLjA2NzEgMi45MDIzNyAyMi41NTk2IDMuNTU4ODRDMjMuNTQ1NyA0Ljg3MzM2IDI0LjQ2NDUgNi4zMjM5OCAyNC44MDY2IDYuODc0MjdDMjQuOTc0NyA3LjE0NDU3IDI0Ljc5NTggNy40Nzg1MyAyNC40OTcxIDcuNTE1ODdMMjIuNzk1OSA3LjcyODc2QzIxLjYxMTIgNy44NzY4NSAyMC41NzggOC42MDcyIDIwLjA0MzkgOS42NzUwNUMxOS45MTY2IDkuOTI5NzIgMTkuNTU0MSA5LjkyOTcyIDE5LjQyNjggOS42NzUwNUMxOC44OTI3IDguNjA3MTkgMTcuODU5NSA3Ljg3Njg1IDE2LjY3NDggNy43Mjg3NkwxNC45NzM2IDcuNTE1ODdDMTQuNjc0OSA3LjQ3ODUzIDE0LjQ5NiA3LjE0NDU3IDE0LjY2NDEgNi44NzQyN0MxNS4wMDYyIDYuMzIzOTggMTUuOTI1IDQuODczMzYgMTYuOTExMSAzLjU1ODg0QzE3LjQwMzYgMi45MDIzNyAxNy45MTg1IDIuMjcyOTMgMTguMzg5NiAxLjgwNDkzQzE4LjYyNDkgMS41NzEyOSAxOC44NTUzIDEuMzcxNSAxOS4wNzIzIDEuMjI4NzZDMTkuMjgzMSAxLjA5MDA1IDE5LjUxMTYgMC45ODQ2MTkgMTkuNzM1NCAwLjk4NDYxOVoiIGZpbGw9IiM0MDk2RkYiIHN0cm9rZT0iIzQwOTZGRiIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9zdmc+Cg==";
const FilterDark$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTYuNjY2NjkgNi4zMzM5OEM2LjY2NjY5IDcuNDM4NTUgNS43NzEyNiA4LjMzMzk5IDQuNjY2NjkgOC4zMzM5OUMzLjU2MjEyIDguMzMzOTkgMi42NjY2OSA3LjQzODU1IDIuNjY2NjkgNi4zMzM5OEMyLjY2NjY5IDUuMjI5NDIgMy41NjIxMiA0LjMzMzk4IDQuNjY2NjkgNC4zMzM5OEM1Ljc3MTI2IDQuMzMzOTggNi42NjY2OSA1LjIyOTQyIDYuNjY2NjkgNi4zMzM5OFoiCiAgICBzdHJva2U9IndoaXRlIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgLz4KICA8cGF0aAogICAgZD0iTTEzLjMzMzMgOS42NjYwMkMxMy4zMzMzIDguNTYxNDUgMTIuNDM3OSA3LjY2NjAyIDExLjMzMzMgNy42NjYwMkMxMC4yMjg4IDcuNjY2MDIgOS4zMzMzNCA4LjU2MTQ1IDkuMzMzMzQgOS42NjYwMkM5LjMzMzM0IDEwLjc3MDYgMTAuMjI4OCAxMS42NjYgMTEuMzMzMyAxMS42NjZDMTIuNDM3OSAxMS42NjYgMTMuMzMzMyAxMC43NzA2IDEzLjMzMzMgOS42NjYwMloiCiAgICBzdHJva2U9IndoaXRlIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgLz4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTExLjMzMzMgNy4zMzM5OEwxMS4zNjEgMS4zMzM5OE00LjY2NjY3IDEuMzMzOThMNC42NjY2NyA0LjAwMDY1IgogICAgc3Ryb2tlPSJ3aGl0ZSIKICAgIHN0cm9rZS13aWR0aD0iMS41IgogICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIC8+CiAgPHBhdGgKICAgIG9wYWNpdHk9IjAuNSIKICAgIGQ9Ik00LjY2NjY3IDguNjY2MDJMNC42NjY2NyAxNC42NjZNMTEuMzMzMyAxNC42NjZWMTEuOTk5MyIKICAgIHN0cm9rZT0id2hpdGUiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgo8L3N2Zz4K";
const FilterLight$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aAogICAgZD0iTTYuNjY2MDIgNi4zMzMzNEM2LjY2NjAyIDcuNDM3OTEgNS43NzA1OCA4LjMzMzM0IDQuNjY2MDIgOC4zMzMzNEMzLjU2MTQ1IDguMzMzMzQgMi42NjYwMiA3LjQzNzkxIDIuNjY2MDIgNi4zMzMzNEMyLjY2NjAyIDUuMjI4NzcgMy41NjE0NSA0LjMzMzM0IDQuNjY2MDIgNC4zMzMzNEM1Ljc3MDU4IDQuMzMzMzQgNi42NjYwMiA1LjIyODc3IDYuNjY2MDIgNi4zMzMzNFoiCiAgICBzdHJva2U9IiM2QjcyODAiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAvPgogIDxwYXRoCiAgICBkPSJNMTMuMzM0IDkuNjY2NjZDMTMuMzM0IDguNTYyMDkgMTIuNDM4NiA3LjY2NjY2IDExLjMzNCA3LjY2NjY2QzEwLjIyOTQgNy42NjY2NiA5LjMzMzk4IDguNTYyMDkgOS4zMzM5OCA5LjY2NjY2QzkuMzMzOTggMTAuNzcxMiAxMC4yMjk0IDExLjY2NjcgMTEuMzM0IDExLjY2NjdDMTIuNDM4NiAxMS42NjY3IDEzLjMzNCAxMC43NzEyIDEzLjMzNCA5LjY2NjY2WiIKICAgIHN0cm9rZT0iIzZCNzI4MCIKICAgIHN0cm9rZS13aWR0aD0iMS41IgogIC8+CiAgPHBhdGgKICAgIG9wYWNpdHk9IjAuNSIKICAgIGQ9Ik0xMS4zMzI3IDcuMzMzMzRMMTEuMzYwNCAxLjMzMzM0TTQuNjY2MDIgMS4zMzMzNEw0LjY2NjAyIDQuMDAwMDEiCiAgICBzdHJva2U9IiM2QjcyODAiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgogIDxwYXRoCiAgICBvcGFjaXR5PSIwLjUiCiAgICBkPSJNNC42NjYwMiA4LjY2NjY2TDQuNjY2MDIgMTQuNjY2N00xMS4zMzI3IDE0LjY2NjdWMTIiCiAgICBzdHJva2U9IiM2QjcyODAiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgo8L3N2Zz4K";
const MoreDark$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjYiIHI9IjIiIGZpbGw9IndoaXRlIiAvPgogIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTQiIHI9IjIiIGZpbGw9IndoaXRlIiAvPgo8L3N2Zz4K";
const MoreLight$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjYiIHI9IjIiIGZpbGw9IiMwRDE3MzAiIC8+CiAgPGNpcmNsZSBjeD0iMTAiIGN5PSIxNCIgcj0iMiIgZmlsbD0iIzBEMTczMCIgLz4KPC9zdmc+Cg==";
const AgentDark$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQ0OV82Mjk3NykiPgogICAgPHBhdGgKICAgICAgb3BhY2l0eT0iMC41IgogICAgICBkPSJNMTEuNjY2NiAxOC4zMzI3QzE0LjgwOTMgMTguMzMyNyAxNi4zODA2IDE4LjMzMjcgMTcuMzU2OSAxNy4zMjI4QzE4LjMzMzIgMTYuMzEyOSAxOC4zMzMyIDE0LjY4NzYgMTguMzMzMiAxMS40MzY4VjEwLjE2OTNDMTguMzMzMiA4LjI2MjI2IDE4LjMzMzIgNy4zMDg3NSAxNy45MDA2IDYuNTE4M0MxNy40Njc5IDUuNzI3ODYgMTYuNjc3NCA1LjIzNzI4IDE1LjA5NjUgNC4yNTYxMkwxMy40Mjk5IDMuMjIxNzRDMTEuNzU4NyAyLjE4NDU5IDEwLjkyMzIgMS42NjYwMiA5Ljk5OTg5IDEuNjY2MDJDOS4wNzY2MSAxLjY2NjAyIDguMjQxMDUgMi4xODQ1OSA2LjU2OTkyIDMuMjIxNzRMNC45MDMyNSA0LjI1NjEyQzMuMzIyMzQgNS4yMzcyOCAyLjUzMTg5IDUuNzI3ODYgMi4wOTkyMiA2LjUxODNDMS44MzQ1OCA3LjAwMTc5IDEuNzMxOCA3LjU0NjI5IDEuNjkxODkgOC4zMzI2OCIKICAgICAgc3Ryb2tlPSJ3aGl0ZSIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+CiAgICA8cGF0aAogICAgICBkPSJNOS4xNjY1IDE4LjMzNEM5LjE2NjUgMTQuMTkxOCA1LjgwODY0IDEwLjgzNCAxLjY2NjUgMTAuODM0IgogICAgICBzdHJva2U9IndoaXRlIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgLz4KICAgIDxwYXRoCiAgICAgIGQ9Ik02LjY2NjUgMTguMzM0QzYuNjY2NSAxNS41NzI2IDQuNDI3OTMgMTMuMzM0IDEuNjY2NSAxMy4zMzQiCiAgICAgIHN0cm9rZT0id2hpdGUiCiAgICAgIHN0cm9rZS13aWR0aD0iMS41IgogICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAvPgogICAgPHBhdGgKICAgICAgZD0iTTQuMTY2NSAxOC4zMzRDNC4xNjY1IDE2Ljk1MzMgMy4wNDcyMiAxNS44MzQgMS42NjY1IDE1LjgzNCIKICAgICAgc3Ryb2tlPSJ3aGl0ZSIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8yNDQ5XzYyOTc3Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const AgentLight$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTM4OF8zNzkzKSI+CiAgICA8cGF0aAogICAgICBvcGFjaXR5PSIwLjUiCiAgICAgIGQ9Ik0xMS42NjY3IDE4LjMzMzVDMTQuODA5NCAxOC4zMzM1IDE2LjM4MDcgMTguMzMzNSAxNy4zNTcgMTcuMzIzN0MxOC4zMzMzIDE2LjMxMzggMTguMzMzMyAxNC42ODg0IDE4LjMzMzMgMTEuNDM3N1YxMC4xNzAxQzE4LjMzMzMgOC4yNjMxMSAxOC4zMzMzIDcuMzA5NiAxNy45MDA3IDYuNTE5MTVDMTcuNDY4IDUuNzI4NzEgMTYuNjc3NiA1LjIzODEzIDE1LjA5NjYgNC4yNTY5N0wxMy40MyAzLjIyMjU5QzExLjc1ODkgMi4xODU0NCAxMC45MjMzIDEuNjY2ODcgMTAgMS42NjY4N0M5LjA3NjczIDEuNjY2ODcgOC4yNDExNyAyLjE4NTQ1IDYuNTcwMDQgMy4yMjI2TDQuOTAzMzcgNC4yNTY5OEMzLjMyMjQ3IDUuMjM4MTMgMi41MzIwMSA1LjcyODcxIDIuMDk5MzUgNi41MTkxNUMxLjgzNDcgNy4wMDI2NCAxLjczMTkzIDcuNTQ3MTQgMS42OTIwMiA4LjMzMzU0IgogICAgICBzdHJva2U9IiM2QjcyODAiCiAgICAgIHN0cm9rZS13aWR0aD0iMS41IgogICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAvPgogICAgPHBhdGgKICAgICAgZD0iTTkuMTY2NjkgMTguMzMzM0M5LjE2NjY5IDE0LjE5MTIgNS44MDg4MiAxMC44MzMzIDEuNjY2NjkgMTAuODMzMyIKICAgICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgLz4KICAgIDxwYXRoCiAgICAgIGQ9Ik02LjY2NjY5IDE4LjMzMzNDNi42NjY2OSAxNS41NzE5IDQuNDI4MTEgMTMuMzMzMyAxLjY2NjY5IDEzLjMzMzMiCiAgICAgIHN0cm9rZT0iIzZCNzI4MCIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+CiAgICA8cGF0aAogICAgICBkPSJNNC4xNjY2OSAxOC4zMzMzQzQuMTY2NjkgMTYuOTUyNiAzLjA0NzQgMTUuODMzMyAxLjY2NjY5IDE1LjgzMzMiCiAgICAgIHN0cm9rZT0iIzZCNzI4MCIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8xMzg4XzM3OTMiPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIiAvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+Cjwvc3ZnPgo=";
const VenueDark$1 = "data:image/svg+xml;base64,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";
const VenueLight$1 = "data:image/svg+xml;base64,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";
const MappedLocatonDark$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTIuNjY2NzUgNi43NjI4NUMyLjY2Njc1IDMuNzY0NTcgNS4wNTQ1NiAxLjMzMzk4IDguMDAwMDggMS4zMzM5OEMxMC45NDU2IDEuMzMzOTggMTMuMzMzNCAzLjc2NDU3IDEzLjMzMzQgNi43NjI4NUMxMy4zMzM0IDkuNzM3NjMgMTEuNjMxMiAxMy4yMDg5IDguOTc1MzcgMTQuNDUwM0M4LjM1NjI1IDE0LjczOTcgNy42NDM5MSAxNC43Mzk3IDcuMDI0NzkgMTQuNDUwM0M0LjM2ODk2IDEzLjIwODkgMi42NjY3NSA5LjczNzYzIDIuNjY2NzUgNi43NjI4NVoiCiAgICBzdHJva2U9IndoaXRlIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgLz4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iNi42NjYwMiIgcj0iMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIC8+Cjwvc3ZnPgo=";
const MappedLocatonLight$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTIuNjY2NjkgNi43NjIyNEMyLjY2NjY5IDMuNzYzOTYgNS4wNTQ1IDEuMzMzMzcgOC4wMDAwMiAxLjMzMzM3QzEwLjk0NTUgMS4zMzMzNyAxMy4zMzM0IDMuNzYzOTYgMTMuMzMzNCA2Ljc2MjI0QzEzLjMzMzQgOS43MzcwMiAxMS42MzExIDEzLjIwODMgOC45NzUzMSAxNC40NDk3QzguMzU2MTkgMTQuNzM5MSA3LjY0Mzg1IDE0LjczOTEgNy4wMjQ3MyAxNC40NDk3QzQuMzY4OSAxMy4yMDgzIDIuNjY2NjkgOS43MzcwMiAyLjY2NjY5IDYuNzYyMjRaIgogICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgLz4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iNi42NjY2MyIgcj0iMiIgc3Ryb2tlPSIjNkI3MjgwIiBzdHJva2Utd2lkdGg9IjEuNSIgLz4KPC9zdmc+Cg==";
const UnMappedLocatonDark$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjI2MF82NDU5NSkiPgogICAgPHBhdGgKICAgICAgb3BhY2l0eT0iMC41IgogICAgICBkPSJNMi42NjY3NSA2Ljc2Mjg1QzIuNjY2NzUgMy43NjQ1NyA1LjA1NDU2IDEuMzMzOTggOC4wMDAwOCAxLjMzMzk4QzEwLjk0NTYgMS4zMzM5OCAxMy4zMzM0IDMuNzY0NTcgMTMuMzMzNCA2Ljc2Mjg1QzEzLjMzMzQgOS43Mzc2MyAxMS42MzEyIDEzLjIwODkgOC45NzUzNyAxNC40NTAzQzguMzU2MjUgMTQuNzM5NyA3LjY0MzkxIDE0LjczOTcgNy4wMjQ3OSAxNC40NTAzQzQuMzY4OTYgMTMuMjA4OSAyLjY2Njc1IDkuNzM3NjMgMi42NjY3NSA2Ljc2Mjg1WiIKICAgICAgc3Ryb2tlPSJ3aGl0ZSIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAvPgogICAgPHJlY3QKICAgICAgeD0iMC45ODQzNzUiCiAgICAgIHk9IjAuNjkxNDA2IgogICAgICB3aWR0aD0iMSIKICAgICAgaGVpZ2h0PSIxOS4zOTEyIgogICAgICByeD0iMC41IgogICAgICB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMC45ODQzNzUgMC42OTE0MDYpIgogICAgICBmaWxsPSJ3aGl0ZSIKICAgIC8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8yMjYwXzY0NTk1Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const UnMappedLocatonLight$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTM4OF80MDcwKSI+CiAgICA8cGF0aAogICAgICBvcGFjaXR5PSIwLjUiCiAgICAgIGQ9Ik0yLjY2NjY5IDYuNzYyMjRDMi42NjY2OSAzLjc2Mzk2IDUuMDU0NSAxLjMzMzM3IDguMDAwMDIgMS4zMzMzN0MxMC45NDU1IDEuMzMzMzcgMTMuMzMzNCAzLjc2Mzk2IDEzLjMzMzQgNi43NjIyNEMxMy4zMzM0IDkuNzM3MDIgMTEuNjMxMSAxMy4yMDgzIDguOTc1MzEgMTQuNDQ5N0M4LjM1NjE5IDE0LjczOTEgNy42NDM4NSAxNC43MzkxIDcuMDI0NzMgMTQuNDQ5N0M0LjM2ODkgMTMuMjA4MyAyLjY2NjY5IDkuNzM3MDIgMi42NjY2OSA2Ljc2MjI0WiIKICAgICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIC8+CiAgICA8cmVjdAogICAgICB4PSIwLjk4NDMxNCIKICAgICAgeT0iMC42OTE0MDYiCiAgICAgIHdpZHRoPSIxIgogICAgICBoZWlnaHQ9IjE5LjM5MTIiCiAgICAgIHJ4PSIwLjUiCiAgICAgIHRyYW5zZm9ybT0icm90YXRlKC00NSAwLjk4NDMxNCAwLjY5MTQwNikiCiAgICAgIGZpbGw9IiM2QjcyODAiCiAgICAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMTM4OF80MDcwIj4KICAgICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const DetailsDark$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjczN183NjU5MSkiPgogICAgPHBhdGgKICAgICAgZD0iTTIuNSAxNy41MDA3TDkuMTY2NjcgMTAuODM0TTkuMTY2NjcgMTAuODM0SDQuMTY2NjdNOS4xNjY2NyAxMC44MzRWMTUuODM0IgogICAgICBzdHJva2U9IndoaXRlIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogICAgLz4KICAgIDxwYXRoCiAgICAgIG9wYWNpdHk9IjAuNSIKICAgICAgZD0iTTEwLjAwMDEgMTguMzMyN0MxNC42MDI1IDE4LjMzMjcgMTguMzMzNCAxNC42MDE3IDE4LjMzMzQgOS45OTkzNUMxOC4zMzM0IDUuMzk2OTggMTQuNjAyNSAxLjY2NjAyIDEwLjAwMDEgMS42NjYwMkM1LjM5NzcxIDEuNjY2MDIgMS42NjY3NSA1LjM5Njk4IDEuNjY2NzUgOS45OTkzNSIKICAgICAgc3Ryb2tlPSJ3aGl0ZSIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8yNzM3Xzc2NTkxIj4KICAgICAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iNSIgZmlsbD0id2hpdGUiIC8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg==";
const DetailsLight$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTM4OF8zODE0KSI+CiAgICA8cGF0aAogICAgICBkPSJNMi41IDE3LjVMOS4xNjY2NyAxMC44MzMzTTkuMTY2NjcgMTAuODMzM0g0LjE2NjY3TTkuMTY2NjcgMTAuODMzM1YxNS44MzMzIgogICAgICBzdHJva2U9IiM2QjcyODAiCiAgICAgIHN0cm9rZS13aWR0aD0iMS41IgogICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgICAvPgogICAgPHBhdGgKICAgICAgb3BhY2l0eT0iMC41IgogICAgICBkPSJNMTAgMTguMzMzNEMxNC42MDI0IDE4LjMzMzQgMTguMzMzNCAxNC42MDI0IDE4LjMzMzQgMTBDMTguMzMzNCA1LjM5NzY1IDE0LjYwMjQgMS42NjY2OSAxMCAxLjY2NjY5QzUuMzk3NjUgMS42NjY2OSAxLjY2NjY5IDUuMzk3NjUgMS42NjY2OSAxMCIKICAgICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzEzODhfMzgxNCI+CiAgICAgIDxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjUiIGZpbGw9IndoaXRlIiAvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+Cjwvc3ZnPgo=";
const WorldDark$1 = "data:image/svg+xml;base64,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";
const WorldLight$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTM4OF80MDY1KSI+CiAgICA8cGF0aAogICAgICBvcGFjaXR5PSIwLjUiCiAgICAgIGQ9Ik0xLjMzMzMxIDguMDAwMDRIMTQuNjY2Nk0xMC42NjY2IDguMDAwMDRDMTAuNjY2NiA4Ljg3NTUyIDEwLjU5NzcgOS43NDI0MyAxMC40NjM3IDEwLjU1MTNDMTAuMzI5NiAxMS4zNjAxIDEwLjEzMzIgMTIuMDk1IDkuODg1NiAxMi43MTQxQzkuNjM3OTggMTMuMzMzMSA5LjM0NCAxMy44MjQyIDkuMDIwNDcgMTQuMTU5MkM4LjY5NjkzIDE0LjQ5NDMgOC4zNTAxNyAxNC42NjY3IDcuOTk5OTggMTQuNjY2N0M3LjY0OTc5IDE0LjY2NjcgNy4zMDMwMyAxNC40OTQzIDYuOTc5NDkgMTQuMTU5MkM2LjY1NTk2IDEzLjgyNDIgNi4zNjE5OCAxMy4zMzMxIDYuMTE0MzYgMTIuNzE0MUM1Ljg2Njc0IDEyLjA5NSA1LjY3MDMxIDExLjM2MDEgNS41MzYzIDEwLjU1MTNDNS40MDIyOSA5Ljc0MjQzIDUuMzMzMzEgOC44NzU1MiA1LjMzMzMxIDguMDAwMDRDNS4zMzMzMSA3LjEyNDU2IDUuNDAyMjkgNi4yNTc2NiA1LjUzNjMgNS40NDg4MkM1LjY3MDMxIDQuNjM5OTggNS44NjY3NCAzLjkwNTA1IDYuMTE0MzYgMy4yODZDNi4zNjE5OSAyLjY2Njk0IDYuNjU1OTYgMi4xNzU4NyA2Ljk3OTQ5IDEuODQwODRDNy4zMDMwMyAxLjUwNTgxIDcuNjQ5NzkgMS4zMzMzNyA3Ljk5OTk4IDEuMzMzMzdDOC4zNTAxNyAxLjMzMzM3IDguNjk2OTQgMS41MDU4MSA5LjAyMDQ3IDEuODQwODRDOS4zNDQgMi4xNzU4OCA5LjYzNzk4IDIuNjY2OTQgOS44ODU2IDMuMjg2QzEwLjEzMzIgMy45MDUwNSAxMC4zMjk2IDQuNjM5OTggMTAuNDYzNyA1LjQ0ODgyQzEwLjU5NzcgNi4yNTc2NiAxMC42NjY2IDcuMTI0NTYgMTAuNjY2NiA4LjAwMDA0WiIKICAgICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgLz4KICAgIDxwYXRoCiAgICAgIGQ9Ik0xNC42NjY2IDguMDAwMDRDMTQuNjY2NiA4Ljg3NTUyIDE0LjQ5NDIgOS43NDI0MyAxNC4xNTkyIDEwLjU1MTNDMTMuODI0MSAxMS4zNjAxIDEzLjMzMzEgMTIuMDk1IDEyLjcxNCAxMi43MTQxQzEyLjA5NSAxMy4zMzMxIDExLjM2IDEzLjgyNDIgMTAuNTUxMiAxNC4xNTkyQzkuNzQyMzcgMTQuNDk0MyA4Ljg3NTQ2IDE0LjY2NjcgNy45OTk5OCAxNC42NjY3QzcuMTI0NSAxNC42NjY3IDYuMjU3NTkgMTQuNDk0MyA1LjQ0ODc2IDE0LjE1OTJDNC42Mzk5MiAxMy44MjQyIDMuOTA0OTkgMTMuMzMzMSAzLjI4NTkzIDEyLjcxNDFDMi42NjY4OCAxMi4wOTUgMi4xNzU4MSAxMS4zNjAxIDEuODQwNzggMTAuNTUxM0MxLjUwNTc1IDkuNzQyNDMgMS4zMzMzMSA4Ljg3NTUyIDEuMzMzMzEgOC4wMDAwNEMxLjMzMzMxIDcuMTI0NTYgMS41MDU3NSA2LjI1NzY2IDEuODQwNzggNS40NDg4MkMyLjE3NTgxIDQuNjM5OTggMi42NjY4OCAzLjkwNTA1IDMuMjg1OTQgMy4yODZDMy45MDQ5OSAyLjY2Njk0IDQuNjM5OTIgMi4xNzU4NyA1LjQ0ODc2IDEuODQwODRDNi4yNTc2IDEuNTA1ODEgNy4xMjQ1IDEuMzMzMzcgNy45OTk5OCAxLjMzMzM3QzguODc1NDYgMS4zMzMzNyA5Ljc0MjM3IDEuNTA1ODEgMTAuNTUxMiAxLjg0MDg0QzExLjM2IDIuMTc1ODggMTIuMDk1IDIuNjY2OTQgMTIuNzE0IDMuMjg2QzEzLjMzMzEgMy45MDUwNSAxMy44MjQxIDQuNjM5OTggMTQuMTU5MiA1LjQ0ODgyQzE0LjQ5NDIgNi4yNTc2NiAxNC42NjY2IDcuMTI0NTYgMTQuNjY2NiA4LjAwMDA0TDE0LjY2NjYgOC4wMDAwNFoiCiAgICAgIHN0cm9rZT0iIzZCNzI4MCIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMTM4OF80MDY1Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const Next$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aAogICAgZD0iTTEwLjk3NjIgMTAuMDAwNkw3LjQ0MDY5IDYuNDY1MDNDNy4xMTUyNiA2LjEzOTU5IDcuMTE1MjYgNS42MTE5NiA3LjQ0MDY5IDUuMjg2NTJDNy43NjYxMyA0Ljk2MTA4IDguMjkzNzcgNC45NjEwOCA4LjYxOTIxIDUuMjg2NTJMMTMuMzMzMyAxMC4wMDA2TDguNjE5MiAxNC43MTQ2QzguMjkzNzcgMTUuMDQgNy43NjYxMyAxNS4wNCA3LjQ0MDcgMTQuNzE0NkM3LjExNTI2IDE0LjM4OTIgNy4xMTUyNiAxMy44NjE1IDcuNDQwNyAxMy41MzYxTDEwLjk3NjIgMTAuMDAwNloiCiAgICBmaWxsPSJ3aGl0ZSIKICAvPgo8L3N2Zz4K";
const SuperNext$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTE0LjYwNjkgMTAuMzAzMUwxMS4wNzE0IDEzLjgzODdDMTAuNzQ2IDE0LjE2NDEgMTAuNzQ2IDE0LjY5MTggMTEuMDcxNCAxNS4wMTcyQzExLjM5NjkgMTUuMzQyNiAxMS45MjQ1IDE1LjM0MjYgMTIuMjQ5OSAxNS4wMTcyTDE2Ljk2NCAxMC4zMDMxTDEyLjI0OTkgNS41ODkxMkMxMS45MjQ1IDUuMjYzNjkgMTEuMzk2OSA1LjI2MzY5IDExLjA3MTQgNS41ODkxMkMxMC43NDYgNS45MTQ1NiAxMC43NDYgNi40NDIyIDExLjA3MTQgNi43Njc2NEwxNC42MDY5IDEwLjMwMzFaIgogICAgZmlsbD0id2hpdGUiCiAgLz4KICA8cGF0aAogICAgZD0iTTguMTI1MDEgMTAuMzAzMUw0LjU4OTUgMTMuODM4N0M0LjI2NDA2IDE0LjE2NDEgNC4yNjQwNiAxNC42OTE4IDQuNTg5NSAxNS4wMTcyQzQuOTE0OTMgMTUuMzQyNiA1LjQ0MjU3IDE1LjM0MjYgNS43NjgwMSAxNS4wMTcyTDEwLjQ4MjEgMTAuMzAzMUw1Ljc2ODAxIDUuNTg5MTJDNS40NDI1NyA1LjI2MzY5IDQuOTE0OTQgNS4yNjM2OSA0LjU4OTUgNS41ODkxMkM0LjI2NDA3IDUuOTE0NTYgNC4yNjQwNiA2LjQ0MjIgNC41ODk1IDYuNzY3NjRMOC4xMjUwMSAxMC4zMDMxWiIKICAgIGZpbGw9IndoaXRlIgogIC8+Cjwvc3ZnPgo=";
const Prev$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aAogICAgZD0iTTkuMjA4NTUgMTAuMDAwNUwxMi43NDQxIDEzLjUzNjFDMTMuMDY5NSAxMy44NjE1IDEzLjA2OTUgMTQuMzg5MSAxMi43NDQxIDE0LjcxNDZDMTIuNDE4NiAxNS4wNCAxMS44OTEgMTUuMDQgMTEuNTY1NSAxNC43MTQ2TDYuODUxNDYgMTAuMDAwNUwxMS41NjU2IDUuMjg2NTFDMTEuODkxIDQuOTYxMDggMTIuNDE4NiA0Ljk2MTA4IDEyLjc0NDEgNS4yODY1MUMxMy4wNjk1IDUuNjExOTUgMTMuMDY5NSA2LjEzOTU5IDEyLjc0NDEgNi40NjUwMkw5LjIwODU1IDEwLjAwMDVaIgogICAgZmlsbD0id2hpdGUiCiAgLz4KPC9zdmc+Cg==";
const SuperPrev$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTYuMzU3MTcgMTAuMzAzMUw5Ljg5MjY4IDEzLjgzODdDMTAuMjE4MSAxNC4xNjQxIDEwLjIxODEgMTQuNjkxOCA5Ljg5MjY4IDE1LjAxNzJDOS41NjcyNCAxNS4zNDI2IDkuMDM5NjEgMTUuMzQyNiA4LjcxNDE3IDE1LjAxNzJMNC4wMDAwOCAxMC4zMDMxTDguNzE0MTcgNS41ODkxMkM5LjAzOTYxIDUuMjYzNjkgOS41NjcyNCA1LjI2MzY5IDkuODkyNjcgNS41ODkxMkMxMC4yMTgxIDUuOTE0NTYgMTAuMjE4MSA2LjQ0MjIgOS44OTI2NyA2Ljc2NzY0TDYuMzU3MTcgMTAuMzAzMVoiCiAgICBmaWxsPSJ3aGl0ZSIKICAvPgogIDxwYXRoCiAgICBkPSJNMTIuODM5IDEwLjMwMzFMMTYuMzc0NSAxMy44Mzg3QzE2LjY5OTkgMTQuMTY0MSAxNi42OTk5IDE0LjY5MTggMTYuMzc0NSAxNS4wMTcyQzE2LjA0OTEgMTUuMzQyNiAxNS41MjE0IDE1LjM0MjYgMTUuMTk2IDE1LjAxNzJMMTAuNDgxOSAxMC4zMDMxTDE1LjE5NiA1LjU4OTEyQzE1LjUyMTQgNS4yNjM2OSAxNi4wNDkxIDUuMjYzNjkgMTYuMzc0NSA1LjU4OTEyQzE2LjY5OTkgNS45MTQ1NiAxNi42OTk5IDYuNDQyMiAxNi4zNzQ1IDYuNzY3NjRMMTIuODM5IDEwLjMwMzFaIgogICAgZmlsbD0id2hpdGUiCiAgLz4KPC9zdmc+Cg==";
const CalendarDark$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEuNjY2MDIgMTAuMDAwN0MxLjY2NjAyIDYuODU3OTUgMS42NjYwMiA1LjI4NjYxIDIuNjQyMzMgNC4zMTAzQzMuNjE4NjQgMy4zMzM5OCA1LjE4OTk5IDMuMzMzOTggOC4zMzI2OCAzLjMzMzk4SDExLjY2NkMxNC44MDg3IDMuMzMzOTggMTYuMzgwMSAzLjMzMzk4IDE3LjM1NjQgNC4zMTAzQzE4LjMzMjcgNS4yODY2MSAxOC4zMzI3IDYuODU3OTUgMTguMzMyNyAxMC4wMDA3VjExLjY2NzNDMTguMzMyNyAxNC44MSAxOC4zMzI3IDE2LjM4MTQgMTcuMzU2NCAxNy4zNTc3QzE2LjM4MDEgMTguMzM0IDE0LjgwODcgMTguMzM0IDExLjY2NiAxOC4zMzRIOC4zMzI2OEM1LjE4OTk5IDE4LjMzNCAzLjYxODY0IDE4LjMzNCAyLjY0MjMzIDE3LjM1NzdDMS42NjYwMiAxNi4zODE0IDEuNjY2MDIgMTQuODEgMS42NjYwMiAxMS42NjczVjEwLjAwMDdaIgogICAgc3Ryb2tlPSJ3aGl0ZSIKICAgIHN0cm9rZS13aWR0aD0iMS41IgogIC8+CiAgPHBhdGgKICAgIG9wYWNpdHk9IjAuNSIKICAgIGQ9Ik01LjgzMzk4IDMuMzMzOThWMi4wODM5OCIKICAgIHN0cm9rZT0id2hpdGUiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgogIDxwYXRoCiAgICBvcGFjaXR5PSIwLjUiCiAgICBkPSJNMTQuMTY2IDMuMzMzOThWMi4wODM5OCIKICAgIHN0cm9rZT0id2hpdGUiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgogIDxwYXRoCiAgICBvcGFjaXR5PSIwLjUiCiAgICBkPSJNMS42NjYwMiA3LjVIMTguMzMyNyIKICAgIHN0cm9rZT0id2hpdGUiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgo8L3N2Zz4K";
const CalendarLight$1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aAogICAgZD0iTTEuNjY2NjkgMTBDMS42NjY2OSA2Ljg1NzM0IDEuNjY2NjkgNS4yODYgMi42NDMgNC4zMDk2OEMzLjYxOTMxIDMuMzMzMzcgNS4xOTA2NiAzLjMzMzM3IDguMzMzMzUgMy4zMzMzN0gxMS42NjY3QzE0LjgwOTQgMy4zMzMzNyAxNi4zODA3IDMuMzMzMzcgMTcuMzU3IDQuMzA5NjhDMTguMzMzNCA1LjI4NiAxOC4zMzM0IDYuODU3MzQgMTguMzMzNCAxMFYxMS42NjY3QzE4LjMzMzQgMTQuODA5NCAxOC4zMzM0IDE2LjM4MDggMTcuMzU3IDE3LjM1NzFDMTYuMzgwNyAxOC4zMzM0IDE0LjgwOTQgMTguMzMzNCAxMS42NjY3IDE4LjMzMzRIOC4zMzMzNUM1LjE5MDY2IDE4LjMzMzQgMy42MTkzMSAxOC4zMzM0IDIuNjQzIDE3LjM1NzFDMS42NjY2OSAxNi4zODA4IDEuNjY2NjkgMTQuODA5NCAxLjY2NjY5IDExLjY2NjdWMTBaIgogICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgLz4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTUuODMzMzEgMy4zMzMzN1YyLjA4MzM3IgogICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgLz4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTE0LjE2NjcgMy4zMzMzN1YyLjA4MzM3IgogICAgc3Ryb2tlPSIjNkI3MjgwIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgLz4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTEuNjY2NjkgNy41SDE4LjMzMzQiCiAgICBzdHJva2U9IiM2QjcyODAiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgo8L3N2Zz4K";
const Drag$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDggMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTIgNEg2IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW9wYWNpdHk9IjEuMCIgLz4KICA8cGF0aCBkPSJNMiA4SDYiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utb3BhY2l0eT0iMS4wIiAvPgogIDxwYXRoIGQ9Ik0yIDEySDYiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utb3BhY2l0eT0iMS4wIiAvPgo8L3N2Zz4K";
const Pen$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMzc1NF85MDU4MSkiPgogICAgPHBhdGgKICAgICAgZD0iTTE2IDIxLjgzMzNMMjEuODMzMyAxNkwyNC4zMzMzIDE4LjVMMTguNSAyNC4zMzMzTDE2IDIxLjgzMzNaIgogICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKICAgIC8+CiAgICA8cGF0aAogICAgICBkPSJNMjEuMDAxMyAxNi44MzQ2TDE5Ljc1MTMgMTAuNTg0Nkw3LjY2Nzk3IDcuNjY3OTdMMTAuNTg0NiAxOS43NTEzTDE2LjgzNDYgMjEuMDAxM0wyMS4wMDEzIDE2LjgzNDZaIgogICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKICAgIC8+CiAgICA8cGF0aAogICAgICBkPSJNNy42Njc5NyA3LjY2Nzk3TDEzLjk4OTYgMTMuOTg5NiIKICAgICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiCiAgICAgIHN0cm9rZS13aWR0aD0iMS41IgogICAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgICAvPgogICAgPHBhdGgKICAgICAgZD0iTTE1LjE2NjcgMTYuODMzM0MxNi4wODcxIDE2LjgzMzMgMTYuODMzMyAxNi4wODcxIDE2LjgzMzMgMTUuMTY2N0MxNi44MzMzIDE0LjI0NjIgMTYuMDg3MSAxMy41IDE1LjE2NjcgMTMuNUMxNC4yNDYyIDEzLjUgMTMuNSAxNC4yNDYyIDEzLjUgMTUuMTY2N0MxMy41IDE2LjA4NzEgMTQuMjQ2MiAxNi44MzMzIDE1LjE2NjcgMTYuODMzM1oiCiAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIgogICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogICAgLz4KICA8L2c+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzM3NTRfOTA1ODEiPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiA2KSIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const LocationDark$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTMuMzMzNSA4LjQ1MjU4QzMuMzMzNSA0LjcwNDczIDYuMzE4MjYgMS42NjY1IDEwLjAwMDIgMS42NjY1QzEzLjY4MjEgMS42NjY1IDE2LjY2NjggNC43MDQ3MyAxNi42NjY4IDguNDUyNThDMTYuNjY2OCAxMi4xNzExIDE0LjUzOTEgMTYuNTEwMiAxMS4yMTkzIDE4LjA2MTlDMTAuNDQ1NCAxOC40MjM2IDkuNTU0OTUgMTguNDIzNiA4Ljc4MTA1IDE4LjA2MTlDNS40NjEyNyAxNi41MTAyIDMuMzMzNSAxMi4xNzExIDMuMzMzNSA4LjQ1MjU4WiIKICAgIHN0cm9rZT0iY3VycmVudENvbG9yIgogICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgLz4KICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjguMzMzNSIgcj0iMi41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIC8+Cjwvc3ZnPgo=";
const PenToolDark$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEwIDE1LjgzMzNMMTUuODMzMyAxMEwxOC4zMzMzIDEyLjVMMTIuNSAxOC4zMzMzTDEwIDE1LjgzMzNaIgogICAgc3Ryb2tlPSJyZ2JhKDI5LCAxMDQsIDIwOSwgMSkiCiAgICBzdHJva2Utd2lkdGg9IjEuMyIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgLz4KICA8cGF0aAogICAgZD0iTTEuNjY2NjMgMS42NjY2OUwxMy43NSA0LjU4MzM1TDE1IDEwLjgzMzRMMTAuODMzMyAxNUw0LjU4MzI5IDEzLjc1TDEuNjY2NjMgMS42NjY2OVpNMS42NjY2MyAxLjY2NjY5TDcuOTg4MjkgNy45ODgzNSIKICAgIHN0cm9rZT0icmdiYSgyOSwgMTA0LCAyMDksIDEpIgogICAgc3Ryb2tlLXdpZHRoPSIxLjMiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogIC8+CiAgPHBhdGgKICAgIGQ9Ik05LjE2NjY3IDEwLjgzMzNDMTAuMDg3MSAxMC44MzMzIDEwLjgzMzMgMTAuMDg3MSAxMC44MzMzIDkuMTY2NjdDMTAuODMzMyA4LjI0NjE5IDEwLjA4NzEgNy41IDkuMTY2NjcgNy41QzguMjQ2MTkgNy41IDcuNSA4LjI0NjE5IDcuNSA5LjE2NjY3QzcuNSAxMC4wODcxIDguMjQ2MTkgMTAuODMzMyA5LjE2NjY3IDEwLjgzMzNaIgogICAgc3Ryb2tlPSJyZ2JhKDI5LCAxMDQsIDIwOSwgMSkiCiAgICBzdHJva2Utd2lkdGg9IjEuMyIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgLz4KPC9zdmc+Cg==";
const PenToolDisable$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEwIDE1LjgzMzNMMTUuODMzMyAxMEwxOC4zMzMzIDEyLjVMMTIuNSAxOC4zMzMzTDEwIDE1LjgzMzNaIgogICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiCiAgICBzdHJva2Utd2lkdGg9IjEuMyIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgLz4KICA8cGF0aAogICAgZD0iTTEuNjY2NjMgMS42NjY2OUwxMy43NSA0LjU4MzM1TDE1IDEwLjgzMzRMMTAuODMzMyAxNUw0LjU4MzI5IDEzLjc1TDEuNjY2NjMgMS42NjY2OVpNMS42NjY2MyAxLjY2NjY5TDcuOTg4MjkgNy45ODgzNSIKICAgIHN0cm9rZT0iY3VycmVudENvbG9yIgogICAgc3Ryb2tlLXdpZHRoPSIxLjMiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogIC8+CiAgPHBhdGgKICAgIGQ9Ik05LjE2NjY3IDEwLjgzMzNDMTAuMDg3MSAxMC44MzMzIDEwLjgzMzMgMTAuMDg3MSAxMC44MzMzIDkuMTY2NjdDMTAuODMzMyA4LjI0NjE5IDEwLjA4NzEgNy41IDkuMTY2NjcgNy41QzguMjQ2MTkgNy41IDcuNSA4LjI0NjE5IDcuNSA5LjE2NjY3QzcuNSAxMC4wODcxIDguMjQ2MTkgMTAuODMzMyA5LjE2NjY3IDEwLjgzMzNaIgogICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiCiAgICBzdHJva2Utd2lkdGg9IjEuMyIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgLz4KPC9zdmc+Cg==";
const ProjectSearch$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNjY3N182Nzc3OSkiPgogICAgPGNpcmNsZSBvcGFjaXR5PSIwLjUiIGN4PSI5LjE2Nzk3IiBjeT0iOS4xNjYwMiIgcj0iNy41IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIC8+CiAgICA8cGF0aAogICAgICBkPSJNMTguMTc1NCAxNy40Nzk2QzE4LjEyMzEgMTcuNTU4NSAxOC4wMjg3IDE3LjY1MyAxNy44Mzk5IDE3Ljg0MThDMTcuNjUxIDE4LjAzMDcgMTcuNTU2NiAxOC4xMjUxIDE3LjQ3NzcgMTguMTc3M0MxNy4wMTU1IDE4LjQ4MzQgMTYuMzkwMyAxOC4zMjU2IDE2LjEyODYgMTcuODM3QzE2LjA4NCAxNy43NTM2IDE2LjA0NTYgMTcuNjI1NiAxNS45NjkgMTcuMzY5OEMxNS44ODUyIDE3LjA5MDMgMTUuODQzMyAxNi45NTA1IDE1LjgzNTIgMTYuODUyMUMxNS43ODc2IDE2LjI3MyAxNi4yNzExIDE1Ljc4OTUgMTYuODUwMiAxNS44MzcyQzE2Ljk0ODYgMTUuODQ1MyAxNy4wODgzIDE1Ljg4NzIgMTcuMzY3OSAxNS45NzA5QzE3LjYyMzcgMTYuMDQ3NiAxNy43NTE2IDE2LjA4NTkgMTcuODM1IDE2LjEzMDZDMTguMzIzNyAxNi4zOTIzIDE4LjQ4MTQgMTcuMDE3NSAxOC4xNzU0IDE3LjQ3OTZaIgogICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIC8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMF82Njc3XzY3Nzc5Ij4KICAgICAgPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJjdXJyZW50Q29sb3IiIC8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg==";
const ProjectList$1 = "data:image/svg+xml;base64,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";
const Import$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgb3BhY2l0eT0iMC41IgogICAgZD0iTTE0LjY2OCA3LjUwMTk1QzE2LjQ4MDUgNy41MTIwNCAxNy40NjIxIDcuNTkyNDIgMTguMTAyNCA4LjIzMjc0QzE4LjgzNDYgOC45NjQ5NyAxOC44MzQ2IDEwLjE0MzUgMTguODM0NiAxMi41MDA1VjEzLjMzMzhDMTguODM0NiAxNS42OTA5IDE4LjgzNDYgMTYuODY5NCAxOC4xMDI0IDE3LjYwMTZDMTcuMzcwMiAxOC4zMzM4IDE2LjE5MTcgMTguMzMzOCAxMy44MzQ2IDE4LjMzMzhINy4xNjc5N0M0LjgxMDk1IDE4LjMzMzggMy42MzI0MyAxOC4zMzM4IDIuOTAwMiAxNy42MDE2QzIuMTY3OTcgMTYuODY5NCAyLjE2Nzk3IDE1LjY5MDkgMi4xNjc5NyAxMy4zMzM4TDIuMTY3OTcgMTIuNTAwNUMyLjE2Nzk3IDEwLjE0MzUgMi4xNjc5NyA4Ljk2NDk3IDIuOTAwMiA4LjIzMjc0QzMuNTQwNTIgNy41OTI0MiA0LjUyMjExIDcuNTEyMDQgNi4zMzQ2NCA3LjUwMTk1IgogICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgogIDxwYXRoCiAgICBkPSJNMTAuNSAxMi41TDEwLjUgMS42NjY2N00xMC41IDEuNjY2NjdMMTMgNC41ODMzM00xMC41IDEuNjY2NjdMOCA0LjU4MzMzIgogICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiCiAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgLz4KPC9zdmc+Cg==";
const FileDoc$1 = "data:image/svg+xml;base64,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";
const strokeWidth$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTg0M18xMTI5NTkpIj4KICAgIDxwYXRoIGQ9Ik0zIDcuNUgyMVY4LjI1SDNWNy41WiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgogICAgPHBhdGggZD0iTTMgMTAuNUgyMVYxMkgzVjEwLjVaIiBmaWxsPSJjdXJyZW50Q29sb3IiIC8+CiAgICA8cGF0aCBkPSJNMyAxNUgyMVYxNy4yNUgzVjE1WiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfNTg0M18xMTI5NTkiPgogICAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const Compass$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTkxOF8xNTgzMTEpIj4KICAgIDxjaXJjbGUgb3BhY2l0eT0iMC41IiBjeD0iMTAuMDAxMyIgY3k9IjEwLjAwMTMiIHI9IjguMzMzMzMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgLz4KICAgIDxwYXRoCiAgICAgIGQ9Ik0xMC44NTM4IDEyLjEzMzlDOC45Mjg5OCAxMi45MDM4IDcuOTY2NTcgMTMuMjg4OCA3LjQxNjg2IDEyLjkxNTJDNy4yODY1MiAxMi44MjY3IDcuMTc0MSAxMi43MTQzIDcuMDg1NTQgMTIuNTgzOUM2LjcxMTk5IDEyLjAzNDIgNy4wOTY5NSAxMS4wNzE4IDcuODY2ODggOS4xNDY5OEM4LjAzMTEgOC43MzY0MiA4LjExMzIxIDguNTMxMTQgOC4yNTQ0NCA4LjM3MDFDOC4yOTA0MiA4LjMyOTA2IDguMzI5MDYgOC4yOTA0MiA4LjM3MDEgOC4yNTQ0NEM4LjUzMTE0IDguMTEzMjEgOC43MzY0MiA4LjAzMTEgOS4xNDY5OCA3Ljg2Njg4QzExLjA3MTggNy4wOTY5NSAxMi4wMzQyIDYuNzExOTkgMTIuNTgzOSA3LjA4NTU0QzEyLjcxNDMgNy4xNzQxIDEyLjgyNjcgNy4yODY1MiAxMi45MTUyIDcuNDE2ODZDMTMuMjg4OCA3Ljk2NjU3IDEyLjkwMzggOC45Mjg5OCAxMi4xMzM5IDEwLjg1MzhDMTEuOTY5NyAxMS4yNjQzIDExLjg4NzYgMTEuNDY5NiAxMS43NDYzIDExLjYzMDdDMTEuNzEwNCAxMS42NzE3IDExLjY3MTcgMTEuNzEwNCAxMS42MzA3IDExLjc0NjNDMTEuNDY5NiAxMS44ODc2IDExLjI2NDMgMTEuOTY5NyAxMC44NTM4IDEyLjEzMzlaIgogICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfNTkxOF8xNTgzMTEiPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const MouseCursor$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iY3VycmVudENvbG9yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoCiAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNOC41OTU5NSAzLjg1NTIxTDEzLjIzNTIgNS41NjQ0MkMxMy44NzY2IDUuODAwNjcgMTQuNDIzMyA2LjAwMjA2IDE0LjgxOTcgNi4yMTg3M0MxNS4yMzUgNi40NDU3MyAxNS42Mjg3IDYuNzY1MTQgMTUuNzQ3IDcuMzAzNjZDMTUuODY1MiA3Ljg0MjE4IDE1LjY0MTcgOC4yOTcxNSAxNS4zNTk3IDguNjc3MjhDMTUuMDkwNiA5LjA0MDEzIDE0LjY3ODYgOS40NTIwOCAxNC4xOTUzIDkuOTM1MzVMMTMuNjAwMyAxMC41MzA0TDE2LjQ1MzggMTMuMzgzOUMxNi42MTIxIDEzLjU0MjIgMTYuNzUyNSAxMy42ODI2IDE2Ljg2MTQgMTMuODA3NEMxNi45NzcxIDEzLjk0MDEgMTcuMDg3OSAxNC4wODg4IDE3LjE2MzkgMTQuMjcyNEMxNy4zMzIxIDE0LjY3ODMgMTcuMzMyMSAxNS4xMzQzIDE3LjE2MzkgMTUuNTQwMUMxNy4wODc5IDE1LjcyMzggMTYuOTc3MSAxNS44NzI0IDE2Ljg2MTQgMTYuMDA1MUMxNi43NTI1IDE2LjEzIDE2LjYxMjEgMTYuMjcwMyAxNi40NTM4IDE2LjQyODZMMTYuNDI2NiAxNi40NTU4QzE2LjI2ODMgMTYuNjE0MSAxNi4xMjggMTYuNzU0NCAxNi4wMDMxIDE2Ljg2MzNDMTUuODcwNCAxNi45NzkxIDE1LjcyMTggMTcuMDg5OCAxNS41MzgyIDE3LjE2NTlDMTUuMTMyMyAxNy4zMzQgMTQuNjc2MyAxNy4zMzQgMTQuMjcwNCAxNy4xNjU5QzE0LjA4NjggMTcuMDg5OCAxMy45MzgyIDE2Ljk3OTEgMTMuODA1NSAxNi44NjMzQzEzLjY4MDYgMTYuNzU0NCAxMy41NDAzIDE2LjYxNCAxMy4zODE5IDE2LjQ1NTdMMTAuNTI4NCAxMy42MDIyTDkuOTMzNCAxNC4xOTcyQzkuNDUwMTMgMTQuNjgwNSA5LjAzODE4IDE1LjA5MjUgOC42NzUzMyAxNS4zNjE3QzguMjk1MiAxNS42NDM2IDcuODQwMjIgMTUuODY3MiA3LjMwMTcgMTUuNzQ4OUM2Ljc2MzE4IDE1LjYzMDYgNi40NDM3OCAxNS4yMzcgNi4yMTY3OCAxNC44MjE3QzYuMDAwMTEgMTQuNDI1MyA1Ljc5ODcyIDEzLjg3ODYgNS41NjI0NyAxMy4yMzcyTDMuODUzMjYgOC41OTc5QzMuMzY5MTkgNy4yODQwNyAyLjk4MTM3IDYuMjMxNDYgMi44MDkyOSA1LjQyMDYxQzIuNjM3NDUgNC42MTA5MiAyLjYyNzYgMy44MDYyMiAzLjIxNTkzIDMuMjE3ODlDMy44MDQyNiAyLjYyOTU2IDQuNjA4OTYgMi42Mzk0IDUuNDE4NjUgMi44MTEyNEM2LjIyOTUgMi45ODMzMiA3LjI4MjExIDMuMzcxMTQgOC41OTU5NSAzLjg1NTIxWk01LjE1OTE1IDQuMDM0MDFDNC40MzU3NyAzLjg4MDQ5IDQuMjExNDUgMy45OTAxNCA0LjA5OTgyIDQuMTAxNzdDMy45ODgxOSA0LjIxMzQgMy44Nzg1MyA0LjQzNzcyIDQuMDMyMDUgNS4xNjExQzQuMTgzMDUgNS44NzI2MiA0LjUzNzc0IDYuODM5OTkgNS4wNDU0MiA4LjIxNzk3TDYuNzE4NDEgMTIuNzU5QzYuOTc2NDEgMTMuNDU5MiA3LjE0NjgxIDEzLjkxNyA3LjMxMzYyIDE0LjIyMjFDNy40NzAwNyAxNC41MDg0IDcuNTUxNjMgMTQuNTI0NCA3LjU2ODQgMTQuNTI3N0M3LjU2ODk1IDE0LjUyNzggNy41Njk0NCAxNC41Mjc5IDcuNTY5ODYgMTQuNTI4QzcuNTcwMjcgMTQuNTI4MSA3LjU3MDc1IDE0LjUyODIgNy41NzEzMSAxNC41Mjg0QzcuNTg3OTEgMTQuNTMyNCA3LjY2ODY5IDE0LjU1MiA3LjkzMDY4IDE0LjM1NzdDOC4yMTAwMyAxNC4xNTA1IDguNTU2NTYgMTMuODA2MyA5LjA4NDI3IDEzLjI3ODZMMTAuMDg2NSAxMi4yNzY0QzEwLjMzMDYgMTIuMDMyMyAxMC43MjYzIDEyLjAzMjMgMTAuOTcwNCAxMi4yNzY0TDE0LjI1MjMgMTUuNTU4M0MxNC40MjgyIDE1LjczNDMgMTQuNTM4MyAxNS44NDM4IDE0LjYyNzIgMTUuOTIxM0MxNC43MTE4IDE1Ljk5NTEgMTQuNzQyOSAxNi4wMDg2IDE0Ljc0ODggMTYuMDExMUMxNC44NDg0IDE2LjA1MjMgMTQuOTYwMyAxNi4wNTIzIDE1LjA1OTggMTYuMDExMUMxNS4wNjU4IDE2LjAwODYgMTUuMDk2OSAxNS45OTUxIDE1LjE4MTUgMTUuOTIxM0MxNS4yNzAzIDE1Ljg0MzggMTUuMzgwNCAxNS43MzQzIDE1LjU1NjMgMTUuNTU4M0MxNS43MzIzIDE1LjM4MjMgMTUuODQxOSAxNS4yNzIzIDE1LjkxOTQgMTUuMTgzNEMxNS45OTMyIDE1LjA5ODggMTYuMDA2NiAxNS4wNjc3IDE2LjAwOTEgMTUuMDYxOEMxNi4wNTAzIDE0Ljk2MjIgMTYuMDUwMyAxNC44NTAzIDE2LjAwOTEgMTQuNzUwN0MxNi4wMDY2IDE0Ljc0NDggMTUuOTkzMiAxNC43MTM3IDE1LjkxOTQgMTQuNjI5MUMxNS44NDE5IDE0LjU0MDMgMTUuNzMyMyAxNC40MzAyIDE1LjU1NjMgMTQuMjU0MkwxMi4yNzQ0IDEwLjk3MjNDMTIuMDMwMyAxMC43MjgyIDEyLjAzMDMgMTAuMzMyNSAxMi4yNzQ0IDEwLjA4ODRMMTMuMjc2NiA5LjA4NjIyQzEzLjgwNDMgOC41NTg1MSAxNC4xNDg1IDguMjExOTkgMTQuMzU1NyA3LjkzMjYzQzE0LjU1IDcuNjcwNjUgMTQuNTMwNCA3LjU4OTg3IDE0LjUyNjQgNy41NzMyNkMxNC41MjYzIDcuNTcyNzEgMTQuNTI2MiA3LjU3MjIzIDE0LjUyNjEgNy41NzE4MUMxNC41MjYgNy41NzEzOSAxNC41MjU5IDcuNTcwOTEgMTQuNTI1OCA3LjU3MDM1QzE0LjUyMjUgNy41NTM1OCAxNC41MDY0IDcuNDcyMDIgMTQuMjIwMiA3LjMxNTU4QzEzLjkxNSA3LjE0ODc2IDEzLjQ1NzMgNi45NzgzNyAxMi43NTcgNi43MjAzN0w4LjIxNjAzIDUuMDQ3MzhDNi44MzgwNCA0LjUzOTcgNS44NzA2NyA0LjE4NTAxIDUuMTU5MTUgNC4wMzQwMVoiCiAgLz4KPC9zdmc+Cg==";
const ArrowCursor$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgY2xpcC1ydWxlPSJldmVub2RkIgogICAgZD0iTTAuMTU4MjAzIDAuMTU4MjAzTDExLjkwNzcgMy42NzU1NUMxMi4yODA1IDMuNzg3MTcgMTIuMjkwNSA0LjMxMTUyIDExLjkyMjIgNC40MzcyOUw2LjM0MjU0IDYuMzQyNTRMNC40MzcyOSAxMS45MjIyQzQuMzExNTIgMTIuMjkwNSAzLjc4NzE3IDEyLjI4MDUgMy42NzU1NSAxMS45MDc3TDAuMTU4MjAzIDAuMTU4MjAzWk0xLjcwNzY1IDEuNzA3NjVMNC4wOTg4IDkuNjk1MTFMNS41MjMzMiA1LjUyMzMyTDkuNjk1MTEgNC4wOTg4TDEuNzA3NjUgMS43MDc2NVoiCiAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICBmaWxsLW9wYWNpdHk9IjAuODUiCiAgLz4KPC9zdmc+Cg==";
const AllDirection$1 = "data:image/svg+xml;base64,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";
const PenDrawTool$1 = "data:image/svg+xml;base64,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";
const LineDrawTool$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTg4MV8xNzQ4NjcpIj4KICAgIDxsaW5lIHgxPSIxOS41MDAxIiB5MT0iMi41NTg5MyIgeDI9IjAuNTAwMDk2IiB5Mj0iMTkuNTU4OSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfNTg4MV8xNzQ4NjciPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const ReactangleDrawTool$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEyLjc1IDAuNzVIMS4yNUMwLjk3MzQzNyAwLjc1IDAuNzUgMC45NzM0MzcgMC43NSAxLjI1VjEyLjc1QzAuNzUgMTMuMDI2NiAwLjk3MzQzNyAxMy4yNSAxLjI1IDEzLjI1SDEyLjc1QzEzLjAyNjYgMTMuMjUgMTMuMjUgMTMuMDI2NiAxMy4yNSAxMi43NVYxLjI1QzEzLjI1IDAuOTczNDM3IDEzLjAyNjYgMC43NSAxMi43NSAwLjc1Wk0xMi4xMjUgMTIuMTI1SDEuODc1VjEuODc1SDEyLjEyNVYxMi4xMjVaIgogICAgZmlsbD0iY3VycmVudENvbG9yIgogICAgZmlsbC1vcGFjaXR5PSIwLjg1IgogIC8+Cjwvc3ZnPgo=";
const CircleDrawTool$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNTg4MV8xNzQ4NzIpIj4KICAgIDxwYXRoCiAgICAgIGQ9Ik0xOC4zMzQ2IDkuOTk5MzVDMTguMzM0NiAxNC42MDE3IDE0LjYwMzcgMTguMzMyNyAxMC4wMDEzIDE4LjMzMjdDNS4zOTg5MyAxOC4zMzI3IDEuNjY3OTcgMTQuNjAxNyAxLjY2Nzk3IDkuOTk5MzVDMS42Njc5NyA1LjM5Njk4IDUuMzk4OTMgMS42NjYwMiAxMC4wMDEzIDEuNjY2MDJDMTQuNjAzNyAxLjY2NjAyIDE4LjMzNDYgNS4zOTY5OCAxOC4zMzQ2IDkuOTk5MzVaIgogICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICAgICAgc3Ryb2tlLXdpZHRoPSIxLjUiCiAgICAvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfNTg4MV8xNzQ4NzIiPgogICAgICA8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIgLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";
const MeasureDraw$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTExLjEyNSAxMi4wNjI1SDAuODc1QzAuODA2MjUgMTIuMDYyNSAwLjc1IDEyLjExODcgMC43NSAxMi4xODc1VjEzLjEyNUMwLjc1IDEzLjE5MzggMC44MDYyNSAxMy4yNSAwLjg3NSAxMy4yNUgxMS4xMjVDMTEuMTkzOCAxMy4yNSAxMS4yNSAxMy4xOTM4IDExLjI1IDEzLjEyNVYxMi4xODc1QzExLjI1IDEyLjExODcgMTEuMTkzOCAxMi4wNjI1IDExLjEyNSAxMi4wNjI1Wk0xMS4xMjUgMC43NUgwLjg3NUMwLjgwNjI1IDAuNzUgMC43NSAwLjgwNjI1IDAuNzUgMC44NzVWMS44MTI1QzAuNzUgMS44ODEyNSAwLjgwNjI1IDEuOTM3NSAwLjg3NSAxLjkzNzVIMTEuMTI1QzExLjE5MzggMS45Mzc1IDExLjI1IDEuODgxMjUgMTEuMjUgMS44MTI1VjAuODc1QzExLjI1IDAuODA2MjUgMTEuMTkzOCAwLjc1IDExLjEyNSAwLjc1Wk03LjU0Mzc1IDQuOTA2MjVDNy42Mzc1IDQuOTA2MjUgNy42OTA2MyA0Ljc5Njg4IDcuNjMyODEgNC43MjM0NEw2LjA1NzgxIDIuNzI5NjlDNi4wNDczOSAyLjcxNjIgNi4wMzQwMSAyLjcwNTI3IDYuMDE4NzEgMi42OTc3NkM2LjAwMzQgMi42OTAyNCA1Ljk4NjU4IDIuNjg2MzQgNS45Njk1MyAyLjY4NjM0QzUuOTUyNDggMi42ODYzNCA1LjkzNTY2IDIuNjkwMjQgNS45MjAzNiAyLjY5Nzc2QzUuOTA1MDUgMi43MDUyNyA1Ljg5MTY3IDIuNzE2MiA1Ljg4MTI1IDIuNzI5NjlMNC4zMDYyNSA0LjcyMzQ0QzQuMjkzMTMgNC43NDAxMiA0LjI4NDk3IDQuNzYwMTYgNC4yODI3MSA0Ljc4MTI2QzQuMjgwNDUgNC44MDIzNyA0LjI4NDE5IDQuODIzNjggNC4yOTM0OCA0Ljg0Mjc2QzQuMzAyNzggNC44NjE4NCA0LjMxNzI2IDQuODc3OTEgNC4zMzUyNyA0Ljg4OTE0QzQuMzUzMjggNC45MDAzNyA0LjM3NDA5IDQuOTA2MyA0LjM5NTMxIDQuOTA2MjVINS40Mzc1VjkuMDkzNzVINC40NTYyNUM0LjM2MjUgOS4wOTM3NSA0LjMwOTM4IDkuMjAzMTIgNC4zNjcxOSA5LjI3NjU2TDUuOTQyMTkgMTEuMjY4OEM1Ljk4NzUgMTEuMzI2NiA2LjA3NSAxMS4zMjY2IDYuMTE4NzUgMTEuMjY4OEw3LjY5Mzc1IDkuMjc2NTZDNy43NTE1NiA5LjIwMzEyIDcuNyA5LjA5Mzc1IDcuNjA0NjkgOS4wOTM3NUg2LjU2MjVWNC45MDYyNUg3LjU0Mzc1WiIKICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAgIGZpbGwtb3BhY2l0eT0iMC44NSIKICAvPgo8L3N2Zz4K";
const Export$1 = "data:image/svg+xml;base64,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";
const PointData$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSI5LjUiIHk9IjYiIHdpZHRoPSIxIiBoZWlnaHQ9IjEyIiByeD0iMC41IiBmaWxsPSJjdXJyZW50Q29sb3IiIC8+CiAgPGNpcmNsZSBjeD0iMTAiIGN5PSI1IiByPSIzIiBmaWxsPSJjdXJyZW50Q29sb3IiIC8+Cjwvc3ZnPgo=";
const LineData$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTYuNzY3NTIgMTMuMjMyNUM2LjUzNTM1IDEzLjAwMDMgNi4yNTk3MyAxMi44MTYyIDUuOTU2MzkgMTIuNjkwNUM1LjY1MzA1IDEyLjU2NDkgNS4zMjc5MyAxMi41MDAyIDQuOTk5NiAxMi41MDAyQzQuNjcxMjcgMTIuNTAwMiA0LjM0NjE1IDEyLjU2NDkgNC4wNDI4MSAxMi42OTA1QzMuNzM5NDcgMTIuODE2MiAzLjQ2Mzg1IDEzLjAwMDMgMy4yMzE2OCAxMy4yMzI1QzIuNzYyOCAxMy43MDE0IDIuNDk5MzkgMTQuMzM3MyAyLjQ5OTM5IDE1LjAwMDRDMi40OTkzOSAxNS42NjM1IDIuNzYyOCAxNi4yOTk0IDMuMjMxNjggMTYuNzY4M0MzLjcwMDU3IDE3LjIzNzIgNC4zMzY1IDE3LjUwMDYgNC45OTk2IDE3LjUwMDZDNS42NjI3IDE3LjUwMDYgNi4yOTg2NCAxNy4yMzcyIDYuNzY3NTIgMTYuNzY4M0M3LjIzNjQgMTYuMjk5NCA3LjQ5OTgxIDE1LjY2MzUgNy40OTk4MSAxNS4wMDA0QzcuNDk5ODEgMTQuMzM3MyA3LjIzNjQgMTMuNzAxNCA2Ljc2NzUyIDEzLjIzMjVaTTYuNzY3NTIgMTMuMjMyNUwxMy4yMzM0IDYuNzY2NjZNMTMuMjMzNCA2Ljc2NjY2QzEzLjQ2NTUgNi45OTg4MyAxMy43NDExIDcuMTgyOTkgMTQuMDQ0NSA3LjMwODY0QzE0LjM0NzggNy40MzQyOSAxNC42NzI5IDcuNDk4OTYgMTUuMDAxMyA3LjQ5ODk2QzE1LjMyOTYgNy40OTg5NiAxNS42NTQ3IDcuNDM0MjkgMTUuOTU4MSA3LjMwODY0QzE2LjI2MTQgNy4xODI5OSAxNi41MzcgNi45OTg4MyAxNi43NjkyIDYuNzY2NjZDMTcuMDAxMyA2LjUzNDUgMTcuMTg1NSA2LjI1ODg4IDE3LjMxMTIgNS45NTU1NEMxNy40MzY4IDUuNjUyMiAxNy41MDE1IDUuMzI3MDggMTcuNTAxNSA0Ljk5ODc1QzE3LjUwMTUgNC42NzA0MSAxNy40MzY4IDQuMzQ1MyAxNy4zMTEyIDQuMDQxOTZDMTcuMTg1NSAzLjczODYyIDE3LjAwMTMgMy40NjMgMTYuNzY5MiAzLjIzMDgzQzE2LjMwMDMgMi43NjE5NSAxNS42NjQ0IDIuNDk4NTQgMTUuMDAxMyAyLjQ5ODU0QzE0LjMzODIgMi40OTg1NCAxMy43MDIyIDIuNzYxOTUgMTMuMjMzNCAzLjIzMDgzQzEyLjc2NDUgMy42OTk3MSAxMi41MDExIDQuMzM1NjUgMTIuNTAxMSA0Ljk5ODc1QzEyLjUwMTEgNS42NjE4NCAxMi43NjQ1IDYuMjk3NzggMTMuMjMzNCA2Ljc2NjY2Wk0xMy4yMzM0IDYuNzY2NjZMMTMuMjM2NyA2Ljc2MzMzIgogICAgc3Ryb2tlPSJjdXJyZW50Q29sb3IiCiAgICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIgogIC8+Cjwvc3ZnPgo=";
const PolygonData$1 = "data:image/svg+xml;base64,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";
const RasterData$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEuNjY2NjMgOS45OTk5NkMxLjY2NjYzIDYuMDcxNTkgMS42NjY2MyA0LjEwNzQgMi44ODcwMSAyLjg4NzAxQzQuMTA3NCAxLjY2NjYzIDYuMDcxNTkgMS42NjY2MyA5Ljk5OTk2IDEuNjY2NjNDMTMuOTI4MyAxLjY2NjYzIDE1Ljg5MjUgMS42NjY2MyAxNy4xMTI5IDIuODg3MDFDMTguMzMzMyA0LjEwNzQgMTguMzMzMyA2LjA3MTU5IDE4LjMzMzMgOS45OTk5NkMxOC4zMzMzIDEzLjkyODMgMTguMzMzMyAxNS44OTI1IDE3LjExMjkgMTcuMTEyOUMxNS44OTI1IDE4LjMzMzMgMTMuOTI4MyAxOC4zMzMzIDkuOTk5OTYgMTguMzMzM0M2LjA3MTU5IDE4LjMzMzMgNC4xMDc0IDE4LjMzMzMgMi44ODcwMSAxNy4xMTI5QzEuNjY2NjMgMTUuODkyNSAxLjY2NjYzIDEzLjkyODMgMS42NjY2MyA5Ljk5OTk2WiIKICAgIHN0cm9rZT0iY3VycmVudENvbG9yIgogIC8+CiAgPGNpcmNsZSBjeD0iMTMuMzMzMyIgY3k9IjYuNjY2NjciIHI9IjEuNjY2NjciIHN0cm9rZT0iY3VycmVudENvbG9yIiAvPgogIDxwYXRoCiAgICBkPSJNMS42NjY2MyAxMC40MTY4TDMuMTI2MjggOS4xMzk2M0MzLjg4NTY3IDguNDc1MTcgNS4wMzAxOSA4LjUxMzI4IDUuNzQzNyA5LjIyNjc5TDkuMzE4NDcgMTIuODAxNkM5Ljg5MTE2IDEzLjM3NDMgMTAuNzkyNyAxMy40NTIzIDExLjQ1NTMgMTIuOTg2NkwxMS43MDM4IDEyLjgxMkMxMi42NTczIDEyLjE0MTkgMTMuOTQ3NCAxMi4yMTk1IDE0LjgxMzcgMTIuOTk5MkwxNy41IDE1LjQxNjgiCiAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAvPgo8L3N2Zz4K";
const Region$1 = "data:image/svg+xml;base64,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";
const Venue$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEzLjc1IDQuNzY1NjJIOS43NVYzQzkuNzUgMi43MjM0NCA5LjUyNjU2IDIuNSA5LjI1IDIuNUgyLjg3NVYxLjg3NUMyLjg3NSAxLjgwNjI1IDIuODE4NzUgMS43NSAyLjc1IDEuNzVIMS44NzVDMS44MDYyNSAxLjc1IDEuNzUgMS44MDYyNSAxLjc1IDEuODc1VjE0LjEyNUMxLjc1IDE0LjE5MzggMS44MDYyNSAxNC4yNSAxLjg3NSAxNC4yNUgyLjc1QzIuODE4NzUgMTQuMjUgMi44NzUgMTQuMTkzOCAyLjg3NSAxNC4xMjVWMTBINi43NVYxMS43NjU2QzYuNzUgMTIuMDQyMiA2Ljk3MzQ0IDEyLjI2NTYgNy4yNSAxMi4yNjU2SDEzLjc1QzE0LjAyNjYgMTIuMjY1NiAxNC4yNSAxMi4wNDIyIDE0LjI1IDExLjc2NTZWNS4yNjU2MkMxNC4yNSA0Ljk4OTA2IDE0LjAyNjYgNC43NjU2MiAxMy43NSA0Ljc2NTYyWiIKICAgIGZpbGw9ImN1cnJlbnRDb2xvciIKICAvPgo8L3N2Zz4K";
const Building$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNjcxOTUgMTEuNzIwOEgxMi4zMDQyVjEzLjA0NzRINy42NzE5NVYxMS43MjA4WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTEyLjMwNDIgMTQuMjcxOUg3LjY3MTk1VjE1LjU5ODVIMTIuMzA0MlYxNC4yNzE5WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjMyMzM2IDFDMi45NjQyNCAxIDIuNjczMTMgMS4yOTcxNCAyLjY3MzEzIDEuNjYzNjlWNi4yNjYyOUMyLjIxMyA2LjI2NjI5IDEuODQgNi42MzkzIDEuODQgNy4wOTk0MkwxLjg0IDE5SDE4LjE1TDE4LjE1IDQuMzgyOTVDMTguMTUgMy44OTkzMyAxNy44MTc0IDMuNDgyMTMgMTcuMzUzNSAzLjM4MzgxTDExLjM3NDMgMi4xMTY1NkMxMC43NTM2IDEuOTg1MDEgMTAuMTcxMyAyLjQ2ODY4IDEwLjE3MTMgMy4xMTU2OUwxMC4xNzEzIDguNjQ3MzRIOS44MDQ3M0w5LjgwNDczIDcuMDk5NDJDOS44MDQ3MyA2LjYzOTI5IDkuNDMxNzIgNi4yNjYyOSA4Ljk3MTU5IDYuMjY2MjlMOC45NzE1OSAxLjY2MzI5QzguOTcxNTkgMS4yOTY5NyA4LjY4MDY1IDEgOC4zMjE3NSAxTDMuMzIzMzYgMVpNOC41MDUwNCA4LjY0NzM0TDguNTA1MDQgNy41OTI4OEwzLjEzOTY4IDcuNTkyODhMMy4xMzk2OCAxNy42NzM0SDUuMTcyNTZMNS4xNzI1NiAxMC42ODgyQzUuMTcyNTYgOS43MjYxNiA1LjE3MjU2IDkuMjQ1MTEgNS40NjUzOCA4Ljk0NjIzQzUuNzU4MiA4LjY0NzM0IDYuMjI5NDkgOC42NDczNCA3LjE3MjA3IDguNjQ3MzRIOC41MDUwNFpNNi40NzIyNSAxNy42NzM0SDEzLjUwMzlMMTMuNTAzOSA5Ljk3MzkzSDYuNDcyMjRMNi40NzIyNSAxNy42NzM0Wk0xNC44MDM1IDE3LjY3MzRIMTYuODIyNEwxNi44MjI0IDQuNjI3NzVMMTEuNDcxIDMuNTA1OVY4LjY0NzM0SDEyLjgwNEMxMy43NDY2IDguNjQ3MzQgMTQuMjE3OSA4LjY0NzM0IDE0LjUxMDcgOC45NDYyM0MxNC44MDM1IDkuMjQ1MTEgMTQuODAzNSA5LjcyNjE1IDE0LjgwMzUgMTAuNjg4MkwxNC44MDM1IDE3LjY3MzRaTTMuOTcyODEgNi4yNjYyOVYyLjMyNjU5TDcuNjcxOTEgMi4zMjY1OVY2LjI2NjI5TDMuOTcyODEgNi4yNjYyOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const Level$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgY2xpcC1ydWxlPSJldmVub2RkIgogICAgZD0iTTguMDAwOSAyLjEwNjQ1TDE0LjIxMDggNC41OTAzOUMxNC45OTc0IDQuOTA1MDMgMTUuMzkwNyA1LjA2MjM2IDE1LjM5MDcgNS4zMzMxN0MxNS4zOTA3IDUuNjAzOTggMTQuOTk3NCA1Ljc2MTMgMTQuMjEwOCA2LjA3NTk1TDguMDAwOSA4LjU1OTg5TDEuNzkxMDQgNi4wNzU5NUMxLjAwNDQzIDUuNzYxMzEgMC42MTExMTkgNS42MDM5OCAwLjYxMTExOSA1LjMzMzE3QzAuNjExMTE5IDUuMDYyMzYgMS4wMDQ0MyA0LjkwNTAzIDEuNzkxMDQgNC41OTAzOUw4LjAwMDkgMi4xMDY0NVpNMi43MzQzNyA1LjMzMzE3TDguMDAwOSA3LjQzOTc4TDEzLjI2NzQgNS4zMzMxN0w4LjAwMDkgMy4yMjY1NkwyLjczNDM3IDUuMzMzMTdaIgogICAgZmlsbD0iY3VycmVudENvbG9yIgogIC8+CiAgPHBhdGgKICAgIGQ9Ik04LjAwMDg2IDEwLjIzOEwwLjU3NDIxOSA3LjE5OTg0VjguMzIzNUw4LjAwMDg2IDExLjM2MTdMMTUuNDI3NSA4LjMyMzVWNy4xOTk4NEw4LjAwMDg2IDEwLjIzOFoiCiAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgLz4KICA8cGF0aAogICAgZD0iTTguMDAwODYgMTMuMDM4TDAuNTc0MjE5IDkuOTk5ODRWMTEuMTIzNUw4LjAwMDg2IDE0LjE2MTdMMTUuNDI3NSAxMS4xMjM1VjkuOTk5ODRMOC4wMDA4NiAxMy4wMzhaIgogICAgZmlsbD0iY3VycmVudENvbG9yIgogIC8+Cjwvc3ZnPgo=";
const Zone$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjc1IDkuMTg3NUMyMS45NTYyIDkuMTg3NSAyMi4xMjUgOS4wMTg3NSAyMi4xMjUgOC44MTI1VjQuNUMyMi4xMjUgNC4yOTM3NSAyMS45NTYyIDQuMTI1IDIxLjc1IDQuMTI1SDE3LjQzNzVDMTcuMjMxMiA0LjEyNSAxNy4wNjI1IDQuMjkzNzUgMTcuMDYyNSA0LjVWNS44MTI1SDYuOTM3NVY0LjVDNi45Mzc1IDQuMjkzNzUgNi43Njg3NSA0LjEyNSA2LjU2MjUgNC4xMjVIMi4yNUMyLjA0Mzc1IDQuMTI1IDEuODc1IDQuMjkzNzUgMS44NzUgNC41VjguODEyNUMxLjg3NSA5LjAxODc1IDIuMDQzNzUgOS4xODc1IDIuMjUgOS4xODc1SDMuNTYyNVYxNC44MTI1SDIuMjVDMi4wNDM3NSAxNC44MTI1IDEuODc1IDE0Ljk4MTIgMS44NzUgMTUuMTg3NVYxOS41QzEuODc1IDE5LjcwNjMgMi4wNDM3NSAxOS44NzUgMi4yNSAxOS44NzVINi41NjI1QzYuNzY4NzUgMTkuODc1IDYuOTM3NSAxOS43MDYzIDYuOTM3NSAxOS41VjE4LjE4NzVIMTcuMDYyNVYxOS41QzE3LjA2MjUgMTkuNzA2MyAxNy4yMzEyIDE5Ljg3NSAxNy40Mzc1IDE5Ljg3NUgyMS43NUMyMS45NTYyIDE5Ljg3NSAyMi4xMjUgMTkuNzA2MyAyMi4xMjUgMTkuNVYxNS4xODc1QzIyLjEyNSAxNC45ODEyIDIxLjk1NjIgMTQuODEyNSAyMS43NSAxNC44MTI1SDIwLjQzNzVWOS4xODc1SDIxLjc1Wk0xOC41NjI1IDUuNjI1SDIwLjYyNVY3LjY4NzVIMTguNTYyNVY1LjYyNVpNMy4zNzUgNy42ODc1VjUuNjI1SDUuNDM3NVY3LjY4NzVIMy4zNzVaTTUuNDM3NSAxOC4zNzVIMy4zNzVWMTYuMzEyNUg1LjQzNzVWMTguMzc1Wk0yMC42MjUgMTYuMzEyNVYxOC4zNzVIMTguNTYyNVYxNi4zMTI1SDIwLjYyNVpNMTguNzUgMTQuODEyNUgxNy40Mzc1QzE3LjIzMTIgMTQuODEyNSAxNy4wNjI1IDE0Ljk4MTIgMTcuMDYyNSAxNS4xODc1VjE2LjVINi45Mzc1VjE1LjE4NzVDNi45Mzc1IDE0Ljk4MTIgNi43Njg3NSAxNC44MTI1IDYuNTYyNSAxNC44MTI1SDUuMjVWOS4xODc1SDYuNTYyNUM2Ljc2ODc1IDkuMTg3NSA2LjkzNzUgOS4wMTg3NSA2LjkzNzUgOC44MTI1VjcuNUgxNy4wNjI1VjguODEyNUMxNy4wNjI1IDkuMDE4NzUgMTcuMjMxMiA5LjE4NzUgMTcuNDM3NSA5LjE4NzVIMTguNzVWMTQuODEyNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const Dot$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTggNi4xMjQ5OUM3LjQ5ODQ0IDYuMTI0OTkgNy4wMjk2OSA2LjMxODc0IDYuNjc1IDYuNjc0OTlDNi4zMjAzMSA3LjAyOTY4IDYuMTI1IDcuNDk4NDMgNi4xMjUgNy45OTk5OUM2LjEyNSA4LjUwMTU1IDYuMzIwMzEgOC45NzAzIDYuNjc1IDkuMzI0OTlDNy4wMjk2OSA5LjY3ODExIDcuNSA5Ljg3NDk5IDggOS44NzQ5OUM4LjUgOS44NzQ5OSA4Ljk3MDMxIDkuNjc5NjggOS4zMjUgOS4zMjQ5OUM5LjY3ODEyIDguOTcwMyA5Ljg3NSA4LjQ5OTk5IDkuODc1IDcuOTk5OTlDOS44NzUgNy40OTk5OSA5LjY3OTY5IDcuMDI5NjggOS4zMjUgNi42NzQ5OUM4Ljk3MDMxIDYuMzE4NzQgOC41MDE1NiA2LjEyNDk5IDggNi4xMjQ5OVoiCiAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgLz4KICA8cGF0aAogICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgY2xpcC1ydWxlPSJldmVub2RkIgogICAgZD0iTTggMTIuMTMzM0MxMC4yODI4IDEyLjEzMzMgMTIuMTMzMyAxMC4yODI4IDEyLjEzMzMgOEMxMi4xMzMzIDUuNzE3MjIgMTAuMjgyOCAzLjg2NjY3IDggMy44NjY2N0M1LjcxNzIyIDMuODY2NjcgMy44NjY2NyA1LjcxNzIyIDMuODY2NjcgOEMzLjg2NjY3IDEwLjI4MjggNS43MTcyMiAxMi4xMzMzIDggMTIuMTMzM1pNOCAxM0MxMC43NjE0IDEzIDEzIDEwLjc2MTQgMTMgOEMxMyA1LjIzODU4IDEwLjc2MTQgMyA4IDNDNS4yMzg1OCAzIDMgNS4yMzg1OCAzIDhDMyAxMC43NjE0IDUuMjM4NTggMTMgOCAxM1oiCiAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgLz4KPC9zdmc+Cg==";
const Country$1 = "data:image/svg+xml;base64,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";
const Market$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Zz4KICAgIDxwYXRoCiAgICAgIGQ9Ik0xMS4wODc1IDMuMjgxMjVMMTEuMDkzOCAzLjI3ODEzSDExLjA5NjlMOCAxLjVMNC45MDQ2OSAzLjI3ODEzSDQuOTAxNTZMNC45MTI1IDMuMjgyODFMMi4zNjcxOSA0Ljc1VjExLjI1TDggMTQuNUwxMy42MzI4IDExLjI1VjQuNzVMMTEuMDg3NSAzLjI4MTI1Wk03LjU0MjE5IDEzLjE4MTJMNS4zMDYyNSAxMS44OTA2VjkuNzA5MzhMMy4yODEyNSA4LjU1OTM3VjUuODI2NTZMNy41NDIxOSA4LjI4NDM4VjEzLjE4MTJaTTMuNzIxODcgNS4wMjM0NEw1LjgyNjU2IDMuODA3ODFMNy45OTY4NyA1LjA1MzEyTDEwLjE3MDMgMy44MDQ2OUwxMi4yODI4IDUuMDIzNDRMOC4wMDMxMyA3LjQ5MjE5TDMuNzIxODcgNS4wMjM0NFpNMTIuNzE4OCA4LjU2NzE5TDEwLjcwNjMgOS43MDkzOFYxMS44ODI4TDguNDU3ODEgMTMuMTc5N1Y4LjI4NzVMMTIuNzE4OCA1LjgyOTY5VjguNTY3MTlaIgogICAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICAvPgogIDwvZz4KPC9zdmc+Cg==";
const Cluster$1 = "data:image/svg+xml;base64,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";
const Search$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEzLjIxMjUgMTIuMzUxNkw5LjE1NDY5IDguMjkzNzVDOS43ODQzOCA3LjQ3OTY5IDEwLjEyNSA2LjQ4NDM4IDEwLjEyNSA1LjQzNzVDMTAuMTI1IDQuMTg0MzggOS42MzU5NCAzLjAwOTM3IDguNzUxNTYgMi4xMjM0NEM3Ljg2NzE5IDEuMjM3NSA2LjY4OTA2IDAuNzUgNS40Mzc1IDAuNzVDNC4xODU5NCAwLjc1IDMuMDA3ODEgMS4yMzkwNiAyLjEyMzQ0IDIuMTIzNDRDMS4yMzc1IDMuMDA3ODEgMC43NSA0LjE4NDM4IDAuNzUgNS40Mzc1QzAuNzUgNi42ODkwNiAxLjIzOTA2IDcuODY3MTkgMi4xMjM0NCA4Ljc1MTU2QzMuMDA3ODEgOS42Mzc1IDQuMTg0MzggMTAuMTI1IDUuNDM3NSAxMC4xMjVDNi40ODQzOCAxMC4xMjUgNy40NzgxMyA5Ljc4NDM4IDguMjkyMTkgOS4xNTYyNUwxMi4zNSAxMy4yMTI1QzEyLjM2MTkgMTMuMjI0NCAxMi4zNzYgMTMuMjMzOCAxMi4zOTE2IDEzLjI0MDNDMTIuNDA3MSAxMy4yNDY3IDEyLjQyMzggMTMuMjUwMSAxMi40NDA2IDEzLjI1MDFDMTIuNDU3NSAxMy4yNTAxIDEyLjQ3NDEgMTMuMjQ2NyAxMi40ODk3IDEzLjI0MDNDMTIuNTA1MiAxMy4yMzM4IDEyLjUxOTQgMTMuMjI0NCAxMi41MzEyIDEzLjIxMjVMMTMuMjEyNSAxMi41MzI4QzEzLjIyNDQgMTIuNTIwOSAxMy4yMzM4IDEyLjUwNjggMTMuMjQwMyAxMi40OTEyQzEzLjI0NjcgMTIuNDc1NyAxMy4yNTAxIDEyLjQ1OSAxMy4yNTAxIDEyLjQ0MjJDMTMuMjUwMSAxMi40MjU0IDEzLjI0NjcgMTIuNDA4NyAxMy4yNDAzIDEyLjM5MzFDMTMuMjMzOCAxMi4zNzc2IDEzLjIyNDQgMTIuMzYzNSAxMy4yMTI1IDEyLjM1MTZaTTcuOTEyNSA3LjkxMjVDNy4yNSA4LjU3MzQ0IDYuMzcxODcgOC45Mzc1IDUuNDM3NSA4LjkzNzVDNC41MDMxMiA4LjkzNzUgMy42MjUgOC41NzM0NCAyLjk2MjUgNy45MTI1QzIuMzAxNTYgNy4yNSAxLjkzNzUgNi4zNzE4NyAxLjkzNzUgNS40Mzc1QzEuOTM3NSA0LjUwMzEyIDIuMzAxNTYgMy42MjM0NCAyLjk2MjUgMi45NjI1QzMuNjI1IDIuMzAxNTYgNC41MDMxMiAxLjkzNzUgNS40Mzc1IDEuOTM3NUM2LjM3MTg3IDEuOTM3NSA3LjI1MTU2IDIuMyA3LjkxMjUgMi45NjI1QzguNTczNDQgMy42MjUgOC45Mzc1IDQuNTAzMTIgOC45Mzc1IDUuNDM3NUM4LjkzNzUgNi4zNzE4NyA4LjU3MzQ0IDcuMjUxNTYgNy45MTI1IDcuOTEyNVoiCiAgICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgICBmaWxsLW9wYWNpdHk9IjAuODUiCiAgLz4KPC9zdmc+Cg==";
const Polygon$1$1 = "data:image/svg+xml;base64,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";
const cpe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjg1IDAuOTk5OTk0QzEyLjg1IDAuNTMwNTUyIDEyLjQ2OTUgMC4xNDk5OTQgMTIgMC4xNDk5OTRDMTEuNTMwNiAwLjE0OTk5NCAxMS4xNSAwLjUzMDU1MiAxMS4xNSAwLjk5OTk5NFYxNEMxMS4xNSAxNC40Njk0IDExLjUzMDYgMTQuODUgMTIgMTQuODVDMTIuNDY5NSAxNC44NSAxMi44NSAxNC40Njk0IDEyLjg1IDE0VjAuOTk5OTk0WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTQgMTVDNCAxMS4yNzIzIDYuNTQ5NTUgOC4xNDAxMSAxMCA3LjI1MjAzVjkuMDI0MDhDNy41MDEgOS44NjAwNyA1LjcgMTIuMjE5NyA1LjcgMTVDNS43IDE4LjQ3OTQgOC41MjA2MSAyMS4zIDEyIDIxLjNDMTUuNDc5NCAyMS4zIDE4LjMgMTguNDc5NCAxOC4zIDE1QzE4LjMgMTIuMjE5NyAxNi40OTkgOS44NjAwNyAxNCA5LjAyNDA4VjcuMjUyMDNDMTcuNDUwNSA4LjE0MDExIDIwIDExLjI3MjMgMjAgMTVDMjAgMTkuNDE4MyAxNi40MTgzIDIzIDEyIDIzQzcuNTgxNzIgMjMgNCAxOS40MTgzIDQgMTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const floor = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS42MTQyIDMuMjQxMzJDMTEuODU5OCAzLjEzMjE0IDEyLjE0MDIgMy4xMzIxNSAxMi4zODU4IDMuMjQxMzJMMjEuMTM5NiA3LjEzMTg5QzIxLjg5MTggNy40NjYyMSAyMS44OTE5IDguNTMzOCAyMS4xMzk2IDguODY4MTNMMTIuMzg1OCAxMi43NTg3QzEyLjE0MDIgMTIuODY3OSAxMS44NTk4IDEyLjg2NzkgMTEuNjE0MiAxMi43NTg3TDIuODYwNCA4Ljg2ODEzQzIuMTA4MTggOC41MzM4MSAyLjEwODE3IDcuNDY2MjEgMi44NjA0IDcuMTMxODlMMTEuNjE0MiAzLjI0MTMyWk0xMiA0LjkzMDE4TDUuMDkyODkgOC4wMDAwMUwxMiAxMS4wNjk4TDE4LjkwNzEgOC4wMDAwMUwxMiA0LjkzMDE4WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTEyIDE1LjA2OThMMy4xNTcxMSAxMUwyLjg2MDQgMTEuMTMxOUMyLjEwODE3IDExLjQ2NjIgMi4xMDgxOCAxMi41MzM4IDIuODYwNCAxMi44NjgxTDExLjYxNDIgMTYuNzU4N0MxMS44NTk4IDE2Ljg2NzkgMTIuMTQwMiAxNi44Njc5IDEyLjM4NTggMTYuNzU4N0wyMS4xMzk2IDEyLjg2ODFDMjEuODkxOSAxMi41MzM4IDIxLjg5MTggMTEuNDY2MiAyMS4xMzk2IDExLjEzMTlMMjEgMTEuMDY5OEwxMiAxNS4wNjk4WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTMuMTU3MTEgMTVMMTIgMTkuMDY5OEwyMC44NDI5IDE1TDIxLjEzOTYgMTUuMTMxOUMyMS44OTE4IDE1LjQ2NjIgMjEuODkxOSAxNi41MzM4IDIxLjEzOTYgMTYuODY4MUwxMi4zODU4IDIwLjc1ODdDMTIuMTQwMiAyMC44Njc5IDExLjg1OTggMjAuODY3OSAxMS42MTQyIDIwLjc1ODdMMi44NjA0IDE2Ljg2ODFDMi4xMDgxOCAxNi41MzM4IDIuMTA4MTcgMTUuNDY2MiAyLjg2MDQgMTUuMTMxOUwzLjE1NzExIDE1WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPC9zdmc+Cg==";
const infrastructure = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUwMzMgNC4zMDk1NUM0LjY1OTM1IDQuMjA1NTEgNC44NDI3IDQuMTQ5OTkgNS4wMzAyNiA0LjE0OTk5SDIwLjlDMjEuNDI0NyA0LjE0OTk5IDIxLjg1IDQuNTc1MzIgMjEuODUgNS4wOTk5OVY4Ljg5OTk5QzIxLjg1IDkuNDI0NjcgMjEuNDI0NyA5Ljg0OTk5IDIwLjkgOS44NDk5OUg1LjAzMDI2QzQuODQyNzEgOS44NDk5OSA0LjY1OTM1IDkuNzk0NDggNC41MDMzIDkuNjkwNDRMMS42NTMzIDcuNzkwNDRDMS4wODkyNSA3LjQxNDQxIDEuMDg5MjUgNi41ODU1OCAxLjY1MzMgNi4yMDk1NUw0LjUwMzMgNC4zMDk1NVpNNS4yNTczNSA1Ljg0OTk5TDMuNTMyMzUgNi45OTk5OUw1LjI1NzM1IDguMTQ5OTlIMjAuMTVWNS44NDk5OUg1LjI1NzM1WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjg0OTk5IDE0LjM1VjIwLjE1SDYuMTQ5OTlWMThINy44NDk5OVYyMC4xNUgxMS4xNVYxOEgxMi44NVYyMC4xNUgxNi4xNVYxOEgxNy44NVYyMC4xNUgyMS4xNVYxNC4zNUgyLjg0OTk5Wk0xLjE0OTk5IDEzLjZDMS4xNDk5OSAxMy4wNzUzIDEuNTc1MzIgMTIuNjUgMi4wOTk5OSAxMi42NUgyMS45QzIyLjQyNDcgMTIuNjUgMjIuODUgMTMuMDc1MyAyMi44NSAxMy42VjIwLjlDMjIuODUgMjEuNDI0NyAyMi40MjQ3IDIxLjg1IDIxLjkgMjEuODVIMi4wOTk5OUMxLjU3NTMyIDIxLjg1IDEuMTQ5OTkgMjEuNDI0NyAxLjE0OTk5IDIwLjlWMTMuNloiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const scanner = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMDc1IDQuN0g0LjdWOC4wNzVIM1Y0LjA1QzMgMy40NzAxMSAzLjQ3MDEgMyA0LjA1IDNIOC4wNzVWNC43WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTE2LjEyNSA0LjdIMTkuNVY4LjA3NUgyMS4yVjQuMDVDMjEuMiAzLjQ3MDEgMjAuNzI5OSAzIDIwLjE1IDNIMTYuMTI1VjQuN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik0xOS41IDE2LjEyNVYxOS41SDE2LjEyNVYyMS4ySDIwLjE1QzIwLjcyOTkgMjEuMiAyMS4yIDIwLjcyOTkgMjEuMiAyMC4xNVYxNi4xMjVIMTkuNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik00LjcgMTYuMTI1VjE5LjVIOC4wNzVWMjEuMkg0LjA1QzMuNDcwMTEgMjEuMiAzIDIwLjcyOTkgMyAyMC4xNVYxNi4xMjVINC43WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4wMzMgMTQuNjc1MkMxNS41NzQxIDE0LjIxNTkgMTUuMDM3OSAxMy44NDExIDE0LjQ0OSAxMy41Njc5QzE1LjI3OTUgMTIuODk1IDE1LjgwOTMgMTEuODY4NCAxNS44MDkzIDEwLjcxNzFDMTUuODA5MyA4LjY4NTc1IDE0LjExNTMgNy4wMTkyNiAxMi4wODQgNy4wNTA0M0MxMC4wODM5IDcuMDgxNTkgOC40NzIzOSA4LjcxMTQxIDguNDcyMzkgMTAuNzE3MUM4LjQ3MjM5IDExLjg2ODQgOS4wMDQwNSAxMi44OTUgOS44MzI3MSAxMy41Njc5QzkuMjQzNjggMTMuODQwOSA4LjcwNzQ2IDE0LjIxNTggOC4yNDg3MiAxNC42NzUyQzcuNTc4NzkgMTUuMzQ2NCA3LjEwMjY2IDE2LjE2MTIgNi44NSAxNy4wNUg4LjI0MTYxQzguNDQ4OTcgMTYuNTE1NiA4Ljc2NzUzIDE2LjAyNTQgOS4xODU1NSAxNS42MDg0QzkuNTczIDE1LjIxODggMTAuMDMzOSAxNC45MSAxMC41NDE1IDE0LjY5OThDMTEuMDQ5IDE0LjQ4OTYgMTEuNTkzMyAxNC4zODIyIDEyLjE0MjcgMTQuMzgzN0MxMy4yNTkyIDE0LjM4MzcgMTQuMzA5NyAxNC44MTgyIDE1LjA5OTggMTUuNjA4NEMxNS41MTY4IDE2LjAyNTQgMTUuODM0OSAxNi41MTU2IDE2LjA0MjQgMTcuMDVIMTcuNDM1M0MxNy4xODIzIDE2LjE2MTIgMTYuNzA1NCAxNS4zNDY0IDE2LjAzMyAxNC42NzUyWk0xMi4xNDI3IDEzLjA2MzdDMTEuNTE1NyAxMy4wNjM3IDEwLjkyNTQgMTIuODE5OSAxMC40ODM1IDEyLjM3NjJDMTAuMjYxOCAxMi4xNTYyIDEwLjA4NjcgMTEuODkzOCA5Ljk2ODU0IDExLjYwNDdDOS44NTA0MiAxMS4zMTU1IDkuNzkxNzUgMTEuMDA1NSA5Ljc5NjA0IDEwLjY5MzJDOS44MDE1NCAxMC4wOTE5IDEwLjA0MTcgOS41MTA3NCAxMC40NjE1IDkuMDc5OTFDMTAuOTAxNSA4LjYyODkxIDExLjQ5IDguMzc3NzUgMTIuMTE4OSA4LjM3MDQyQzEyLjc0MDQgOC4zNjQ5MiAxMy4zNDM1IDguNjA2OTEgMTMuNzg3MiA5LjA0MTQxQzE0LjI0MTggOS40ODY5MSAxNC40OTEyIDEwLjA4MjcgMTQuNDkxMiAxMC43MTcxQzE0LjQ5MTIgMTEuMzQ0MSAxNC4yNDczIDExLjkzMjYgMTMuODAzNyAxMi4zNzYyQzEzLjU4NiAxMi41OTQ5IDEzLjMyNzEgMTIuNzY4MyAxMy4wNDIgMTIuODg2M0MxMi43NTY5IDEzLjAwNDMgMTIuNDUxMyAxMy4wNjQ2IDEyLjE0MjcgMTMuMDYzN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const gps = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjMzMzMgMTJDMTUuMzMzMyAxMy44NDA5IDEzLjg0MDkgMTUuMzMzMyAxMiAxNS4zMzMzQzEwLjE1OSAxNS4zMzMzIDguNjY2NjcgMTMuODQwOSA4LjY2NjY3IDEyQzguNjY2NjcgMTAuMTU5MSAxMC4xNTkgOC42NjY2OCAxMiA4LjY2NjY4QzEzLjg0MDkgOC42NjY2OCAxNS4zMzMzIDEwLjE1OTEgMTUuMzMzMyAxMloiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuNDUwOCAxMS4xNjY3SDIxLjU4MzNDMjEuODEzNiAxMS4xNjY3IDIyIDExLjM1MyAyMiAxMS41ODMzVjEyLjQxNjZDMjIgMTIuNjQ3IDIxLjgxMzYgMTIuODMzMyAyMS41ODMzIDEyLjgzMzNIMTkuNDUwOEMxOS4wNjUxIDE2LjMwMzUgMTYuMzAzOSAxOS4wNjUxIDEyLjgzMzMgMTkuNDUwOVYyMS41ODMzQzEyLjgzMzMgMjEuODEzNiAxMi42NDcgMjIgMTIuNDE2NyAyMkgxMS41ODMzQzExLjM1MyAyMiAxMS4xNjY3IDIxLjgxMzYgMTEuMTY2NyAyMS41ODMzVjE5LjQ1MDlDNy42OTYwOCAxOS4wNjUxIDQuOTM0OTIgMTYuMzAzNSA0LjU0OTE4IDEyLjgzMzNIMi40MTY2OEMyLjE4NjM3IDEyLjgzMzMgMiAxMi42NDcgMiAxMi40MTY2VjExLjU4MzNDMiAxMS4zNTMgMi4xODYzNyAxMS4xNjY3IDIuNDE2NjggMTEuMTY2N0g0LjU0OTE4QzQuOTM0OTIgNy42OTY0NSA3LjY5NjA4IDQuOTM0OTIgMTEuMTY2NyA0LjU0OTE0VjIuNDE2NjhDMTEuMTY2NyAyLjE4NjM3IDExLjM1MyAyIDExLjU4MzMgMkgxMi40MTY3QzEyLjY0NyAyIDEyLjgzMzMgMi4xODYzNyAxMi44MzMzIDIuNDE2NjhWNC41NDkxNEMxNi4zMDM5IDQuOTM0OTIgMTkuMDY1IDcuNjk2NDggMTkuNDUwOCAxMS4xNjY3Wk02LjE2NjY3IDEyQzYuMTY2NjcgMTUuMjE2NSA4Ljc4Mzg1IDE3LjgzMzMgMTIgMTcuODMzM0MxNS4yMTYxIDE3LjgzMzMgMTcuODMzMyAxNS4yMTY2IDE3LjgzMzMgMTJDMTcuODMzMyA4Ljc4MzQ0IDE1LjIxNjEgNi4xNjY2OCAxMiA2LjE2NjY4QzguNzgzODUgNi4xNjY2OCA2LjE2NjY3IDguNzgzNDggNi4xNjY2NyAxMloiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const inspect = "data:image/svg+xml;base64,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";
const arvr = "data:image/svg+xml;base64,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";
const laptop = "data:image/svg+xml;base64,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";
const phone = "data:image/svg+xml;base64,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";
const sensors = "data:image/svg+xml;base64,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";
const smartToy = "data:image/svg+xml;base64,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";
const vehicle = "data:image/svg+xml;base64,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";
const cellTower$1 = "data:image/svg+xml;base64,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";
const cloud$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzE5MTlfMzczIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzE5MTlfMzczKSI+CjxwYXRoIGQ9Ik02LjUgMTkuNUM1LjExOCAxOS41IDMuOTM5MTcgMTkuMDE5OCAyLjk2MzUgMTguMDU5NUMxLjk4NzgzIDE3LjA5OTMgMS41IDE1LjkyODMgMS41IDE0LjU0NjNDMS41IDEzLjMyMzEgMS44OTE2NyAxMi4yMzUyIDIuNjc1IDExLjI4MjhDMy40NTgzMyAxMC4zMzAxIDQuNDU3NjcgOS43NjY1OCA1LjY3MyA5LjU5MjI1QzUuOTkzNSA4LjA5NzQyIDYuNzQ1MTcgNi44NzUgNy45MjggNS45MjVDOS4xMTA2NyA0Ljk3NSAxMC40NjggNC41IDEyIDQuNUMxMy44MDkgNC41IDE1LjM0NDYgNS4xMzEwOCAxNi42MDY4IDYuMzkzMjVDMTcuODY4OSA3LjY1NTQyIDE4LjUgOS4xOTEgMTguNSAxMVYxMS41SDE4LjgwNzhDMTkuODYxNiAxMS41ODIgMjAuNzQwNCAxMi4wMDU4IDIxLjQ0NDMgMTIuNzcxM0MyMi4xNDgxIDEzLjUzNjYgMjIuNSAxNC40NDYyIDIyLjUgMTUuNUMyMi41IDE2LjYxNTMgMjIuMTEyMiAxNy41NjA4IDIxLjMzNjUgMTguMzM2NUMyMC41NjA4IDE5LjExMjIgMTkuNjE1MyAxOS41IDE4LjUgMTkuNUg2LjVaTTYuNSAxOEgxOC41QzE5LjIgMTggMTkuNzkxNyAxNy43NTgzIDIwLjI3NSAxNy4yNzVDMjAuNzU4MyAxNi43OTE3IDIxIDE2LjIgMjEgMTUuNUMyMSAxNC44IDIwLjc1ODMgMTQuMjA4MyAyMC4yNzUgMTMuNzI1QzE5Ljc5MTcgMTMuMjQxNyAxOS4yIDEzIDE4LjUgMTNIMTdWMTFDMTcgOS42MTY2NyAxNi41MTI1IDguNDM3NSAxNS41Mzc1IDcuNDYyNUMxNC41NjI1IDYuNDg3NSAxMy4zODMzIDYgMTIgNkMxMC42MTY3IDYgOS40Mzc1IDYuNDg3NSA4LjQ2MjUgNy40NjI1QzcuNDg3NSA4LjQzNzUgNyA5LjYxNjY3IDcgMTFINi41QzUuNTMzMzMgMTEgNC43MDgzMyAxMS4zNDE3IDQuMDI1IDEyLjAyNUMzLjM0MTY3IDEyLjcwODMgMyAxMy41MzMzIDMgMTQuNUMzIDE1LjQ2NjcgMy4zNDE2NyAxNi4yOTE3IDQuMDI1IDE2Ljk3NUM0LjcwODMzIDE3LjY1ODMgNS41MzMzMyAxOCA2LjUgMThaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L2c+Cjwvc3ZnPgo=";
const dns$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzE5MTlfMzAxIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzE5MTlfMzAxKSI+CjxwYXRoIGQ9Ik03LjUwMTI1IDYuNTU3NzRDNy4xNTQyNSA2LjU1Nzc0IDYuODU5IDYuNjc5MTYgNi42MTU1IDYuOTIxOTlDNi4zNzE4MyA3LjE2NDgyIDYuMjUgNy40NTk2NiA2LjI1IDcuODA2NDlDNi4yNSA4LjE1MzQ5IDYuMzcxNDIgOC40NDg3NCA2LjYxNDI1IDguNjkyMjRDNi44NTcwOCA4LjkzNTkxIDcuMTUxOTIgOS4wNTc3NCA3LjQ5ODc1IDkuMDU3NzRDNy44NDU3NSA5LjA1Nzc0IDguMTQxIDguOTM2MzIgOC4zODQ1IDguNjkzNDlDOC42MjgxNyA4LjQ1MDY2IDguNzUgOC4xNTU3NCA4Ljc1IDcuODA4NzRDOC43NSA3LjQ2MTkxIDguNjI4NTggNy4xNjY2NiA4LjM4NTc1IDYuOTIyOTlDOC4xNDI5MiA2LjY3OTQ5IDcuODQ4MDggNi41NTc3NCA3LjUwMTI1IDYuNTU3NzRaTTcuNTAxMjUgMTUuOTQyMkM3LjE1NDI1IDE1Ljk0MjIgNi44NTkgMTYuMDYzNyA2LjYxNTUgMTYuMzA2NUM2LjM3MTgzIDE2LjU0OTMgNi4yNSAxNi44NDQyIDYuMjUgMTcuMTkxMkM2LjI1IDE3LjUzODEgNi4zNzE0MiAxNy44MzMzIDYuNjE0MjUgMTguMDc3QzYuODU3MDggMTguMzIwNSA3LjE1MTkyIDE4LjQ0MjIgNy40OTg3NSAxOC40NDIyQzcuODQ1NzUgMTguNDQyMiA4LjE0MSAxOC4zMjA4IDguMzg0NSAxOC4wNzhDOC42MjgxNyAxNy44MzUyIDguNzUgMTcuNTQwMyA4Ljc1IDE3LjE5MzVDOC43NSAxNi44NDY1IDguNjI4NTggMTYuNTUxMiA4LjM4NTc1IDE2LjMwNzdDOC4xNDI5MiAxNi4wNjQxIDcuODQ4MDggMTUuOTQyMiA3LjUwMTI1IDE1Ljk0MjJaTTQuMzg0NzUgMy44MDc3NEgxOS42MTUyQzE5Ljg2NTkgMy44MDc3NCAyMC4wNzYxIDMuODkyMzIgMjAuMjQ1OCA0LjA2MTQ5QzIwLjQxNTMgNC4yMzA0OSAyMC41IDQuNDM5OTkgMjAuNSA0LjY4OTk5VjEwLjg2NTJDMjAuNSAxMS4xMzU5IDIwLjQxNTMgMTEuMzYwNyAyMC4yNDU4IDExLjUzOTVDMjAuMDc2MSAxMS43MTgzIDE5Ljg2NTkgMTEuODA3NyAxOS42MTUyIDExLjgwNzdINC4zODQ3NUM0LjEzNDA4IDExLjgwNzcgMy45MjM5MiAxMS43MTgzIDMuNzU0MjUgMTEuNTM5NUMzLjU4NDc1IDExLjM2MDcgMy41IDExLjEzNTkgMy41IDEwLjg2NTJWNC42ODk5OUMzLjUgNC40Mzk5OSAzLjU4NDc1IDQuMjMwNDkgMy43NTQyNSA0LjA2MTQ5QzMuOTIzOTIgMy44OTIzMiA0LjEzNDA4IDMuODA3NzQgNC4zODQ3NSAzLjgwNzc0Wk01IDUuMzA3NzRWMTAuMzA3N0gxOVY1LjMwNzc0SDVaTTQuMzg0NzUgMTMuMTkyMkgxOS41OTZDMTkuODYwMiAxMy4xOTIyIDIwLjA3NjggMTMuMjgwNyAyMC4yNDYgMTMuNDU3N0MyMC40MTUzIDEzLjYzNDYgMjAuNSAxMy44NTM4IDIwLjUgMTQuMTE1NVYyMC4yMzA3QzIwLjUgMjAuNTE0MSAyMC40MTUzIDIwLjc0NTIgMjAuMjQ2IDIwLjkyNEMyMC4wNzY4IDIxLjEwMjggMTkuODYwMiAyMS4xOTIyIDE5LjU5NiAyMS4xOTIySDQuNDA0QzQuMTM5ODMgMjEuMTkyMiAzLjkyMzE3IDIxLjEwMjggMy43NTQgMjAuOTI0QzMuNTg0NjcgMjAuNzQ1MiAzLjUgMjAuNTE0MSAzLjUgMjAuMjMwN1YxNC4xMTU1QzMuNSAxMy44NTM4IDMuNTgxNDIgMTMuNjM0NiAzLjc0NDI1IDEzLjQ1NzdDMy45MDcwOCAxMy4yODA3IDQuMTIwNTggMTMuMTkyMiA0LjM4NDc1IDEzLjE5MjJaTTUgMTQuNjkyMlYxOS42OTIySDE5VjE0LjY5MjJINVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjwvZz4KPC9zdmc+Cg==";
const structureElevator$1 = "data:image/svg+xml;base64,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";
const fiberCabinet$1 = "data:image/svg+xml;base64,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";
const fiberPedestal$1 = "data:image/svg+xml;base64,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";
const flowerpot$1 = "data:image/svg+xml;base64,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";
const hardDriver$1 = "data:image/svg+xml;base64,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";
const structureBuilding$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMTQ4NDQgMjEuODQ4NlYxLjg0ODYzSDE5LjQ4NzhWMjEuODQ4NkgxMy42MTIzVjE2Ljk3M0gxMC4wNDJWMjEuODQ4Nkg0LjE0ODQ0Wk01LjQ4MzQ0IDIwLjUxMzZIOC43MDcyNlYxNS42MzgzSDE0Ljk0N1YyMC41MTM2SDE4LjE1MjlWMy4xODM2M0g1LjQ4MzQ0VjIwLjUxMzZaTTguNzA3MjYgMTIuNjI5MkgxMC4zMTM3VjExLjAyMjhIOC43MDcyNlYxMi42MjkyWk04LjcwNzI2IDguMDEzOTNIMTAuMzEzN1Y2LjQwNzQ2SDguNzA3MjZWOC4wMTM5M1pNMTMuMzIyNiAxMi42MjkySDE0LjkyOVYxMS4wMjI4SDEzLjMyMjZWMTIuNjI5MlpNMTMuMzIyNiA4LjAxMzkzSDE0LjkyOVY2LjQwNzQ2SDEzLjMyMjZWOC4wMTM5M1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const latticeTower$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjcyMzYgMi4xMDY0NUwyMC45NzQ2IDYuMjA1MDhMMjEuMjY3NiA2LjM5NzQ2VjguNDMzNTlIMTkuOTY3OFY3LjM5OTQxSDE1LjI2NDZMMTkuMDM2MSAyMC4wMjA1SDIwLjk2NzhWMjEuMzIxM0gzLjMwMTc2VjIwLjAyMDVINS4yMzI0Mkw5LjAwMzkxIDcuMzk5NDFINC4zMDA3OFY4LjQzMzU5SDNWNi4zOTc0NkwzLjI5Mzk1IDYuMjA1MDhMOS41MzUxNiAyLjEwNjQ1TDkuNjk3MjcgMkgxNC41NjE1TDE0LjcyMzYgMi4xMDY0NVpNNy43NDMxNiAyMC4wMjA1SDE2LjUyNTRMMTIuMTMzOCAxNi44Nzk5TDcuNzQzMTYgMjAuMDIwNVpNNi44ODI4MSAxOS4wMzcxTDExLjAxNTYgMTYuMDgxMUw4LjMzNzg5IDE0LjE2Nkw2Ljg4MjgxIDE5LjAzNzFaTTEzLjI1MSAxNi4wODExTDE3LjM4NDggMTkuMDM3MUwxNS45Mjg3IDE0LjE2N0wxMy4yNTEgMTYuMDgxMVpNOS4yNzUzOSAxMy4yMzgzTDEyLjEzMjggMTUuMjgyMkwxNC45OTIyIDEzLjIzODNMMTIuMTMyOCAxMS4xOTQzTDkuMjc1MzkgMTMuMjM4M1pNOS4wNDI5NyAxMS44MDY2TDExLjAxNTYgMTAuMzk1NUw5LjczNzMgOS40ODE0NUw5LjA0Mjk3IDExLjgwNjZaTTEzLjI1IDEwLjM5NTVMMTUuMjIzNiAxMS44MDY2TDE0LjUyOTMgOS40ODE0NUwxMy4yNSAxMC4zOTU1Wk0xMC4xMzE4IDguMTY1MDRMMTIuMTMyOCA5LjU5NjY4TDE0LjEzNTcgOC4xNjUwNEwxMy45MDcyIDcuMzk5NDFIMTAuMzYxM0wxMC4xMzE4IDguMTY1MDRaTTE1LjA0MiA2LjA5ODYzSDE4LjQ0MTRMMTUuMDQyIDMuODY5MTRWNi4wOTg2M1pNMTAuNTI3MyA2LjA5ODYzSDEzLjc0MTJWMy4yOTk4SDEwLjUyNzNWNi4wOTg2M1pNNS44MjUyIDYuMDk4NjNIOS4yMjY1NlYzLjg2NDI2TDUuODI1MiA2LjA5ODYzWiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPC9zdmc+Cg==";
const gasStation$1 = "data:image/svg+xml;base64,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";
const stadium$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzE5MTlfMzQzIiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjUiIGhlaWdodD0iMjUiPgo8cmVjdCB4PSIwLjAwMjA3NTIiIHk9IjAuNDE2NzQ4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiNEOUQ5RDkiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swXzE5MTlfMzQzKSI+CjxwYXRoIGQ9Ik0zLjczMjg0IDcuNDE2NzZWMy43MjQ1MUw3LjQyNTA5IDUuNTcwNTFMMy43MzI4NCA3LjQxNjc2Wk0xNy41NzkxIDcuNDE2NzZWMy43MjQ1MUwyMS4yNzEzIDUuNTcwNTFMMTcuNTc5MSA3LjQxNjc2Wk0xMS4xMTc2IDYuNDkzNzZWMi44MDE1MUwxNC44MDk4IDQuNjQ3NTFMMTEuMTE3NiA2LjQ5Mzc2Wk0xMC43NTIxIDIyLjA2MUM5LjU0MzA5IDIyLjAyMTIgOC40MzI4NCAyMS45MjAyIDcuNDIxMzQgMjEuNzU4QzYuNDA5ODQgMjEuNTk1OCA1LjUzNTE3IDIxLjM5MjcgNC43OTczNCAyMS4xNDg1QzQuMDU5NSAyMC45MDQyIDMuNDgyOTIgMjAuNjI0NyAzLjA2NzU5IDIwLjMxQzIuNjUyMDkgMTkuOTk1MyAyLjQ0NDM0IDE5LjY2NTUgMi40NDQzNCAxOS4zMjA1VjEwLjcwNTNDMi40NDQzNCAxMC4zMjA2IDIuNjg5MjUgOS45NjM1MSAzLjE3OTA5IDkuNjM0MDFDMy42Njg3NSA5LjMwNDUxIDQuMzQxMTcgOS4wMTUxIDUuMTk2MzQgOC43NjU3NkM2LjA1MTUgOC41MTY0MyA3LjA2MTc1IDguMzE5MDEgOC4yMjcwOSA4LjE3MzUxQzkuMzkyNDIgOC4wMjgwMSAxMC42NTA4IDcuOTU1MjYgMTIuMDAyMSA3Ljk1NTI2QzEzLjM1MzQgNy45NTUyNiAxNC42MTE4IDguMDI4MDEgMTUuNzc3MSA4LjE3MzUxQzE2Ljk0MjQgOC4zMTkwMSAxNy45NTI3IDguNTE2NDMgMTguODA3OCA4Ljc2NTc2QzE5LjY2MyA5LjAxNTEgMjAuMzM1NCA5LjMwNDUxIDIwLjgyNTEgOS42MzQwMUMyMS4zMTQ5IDkuOTYzNTEgMjEuNTU5OCAxMC4zMjA2IDIxLjU1OTggMTAuNzA1M1YxOS4zMjA1QzIxLjU1OTggMTkuNjY1NSAyMS4zNTIxIDE5Ljk5NTMgMjAuOTM2NiAyMC4zMUMyMC41MjEzIDIwLjYyNDcgMTkuOTQ0NyAyMC45MDQyIDE5LjIwNjggMjEuMTQ4NUMxOC40NjkgMjEuMzkyNyAxNy41OTQzIDIxLjU5NTggMTYuNTgyOCAyMS43NThDMTUuNTcxMyAyMS45MjAyIDE0LjQ2MTEgMjIuMDIxMiAxMy4yNTIxIDIyLjA2MVYxOC4wNzA1SDEwLjc1MjFWMjIuMDYxWk0xMi4wMDIxIDExLjk1NTNDMTMuNjM3OSAxMS45NTUzIDE1LjExMDcgMTEuODQxOCAxNi40MjAzIDExLjYxNDhDMTcuNzMgMTEuMzg3OSAxOC43MzggMTEuMTA0NiAxOS40NDQzIDEwLjc2NDhDMTkuMzM1MyAxMC41NDY5IDE4LjYyMDMgMTAuMjc0MiAxNy4yOTkzIDkuOTQ2NTFDMTUuOTc4MiA5LjYxOTAxIDE0LjIxMjQgOS40NTUyNiAxMi4wMDIxIDkuNDU1MjZDOS43OTE3NSA5LjQ1NTI2IDguMDI2IDkuNjE5MDEgNi43MDQ4NCA5Ljk0NjUxQzUuMzgzODQgMTAuMjc0MiA0LjY2ODg0IDEwLjU0NjkgNC41NTk4NCAxMC43NjQ4QzUuMjY2MTcgMTEuMTA0NiA2LjIzNzM0IDExLjM4NzkgNy40NzMzNCAxMS42MTQ4QzguNzA5MTcgMTEuODQxOCAxMC4yMTg4IDExLjk1NTMgMTIuMDAyMSAxMS45NTUzWk05LjI1MjA5IDIwLjQ0OTVWMTYuNTcwNUgxNC43NTIxVjIwLjQ0OTVDMTYuMjA3MyAyMC4zMjI1IDE3LjM4NzEgMjAuMTIwMyAxOC4yOTE2IDE5Ljg0MjhDMTkuMTk2MSAxOS41NjUzIDE5Ljc4NTUgMTkuMzA0IDIwLjA1OTggMTkuMDU5VjEyLjEzOThDMTkuMDUzMyAxMi41NzY5IDE3Ljg2ODEgMTIuOTA1NSAxNi41MDQxIDEzLjEyNTVDMTUuMTM5OSAxMy4zNDUzIDEzLjYzOTMgMTMuNDU1MyAxMi4wMDIxIDEzLjQ1NTNDMTAuMzY0OSAxMy40NTUzIDguODY0MjUgMTMuMzQ1MyA3LjUwMDA5IDEzLjEyNTVDNi4xMzYwOSAxMi45MDU1IDQuOTUwODQgMTIuNTc2OSAzLjk0NDM0IDEyLjEzOThWMTkuMDU5QzQuMjE4NjcgMTkuMzA0IDQuNzg4OTIgMTkuNTY1MyA1LjY1NTA5IDE5Ljg0MjhDNi41MjEwOSAyMC4xMjAzIDcuNzIwMDkgMjAuMzIyNSA5LjI1MjA5IDIwLjQ0OTVaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L2c+Cjwvc3ZnPgo=";
const structureStairs$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjUwODkgNy40MTQwOUwxMS45OTY4IDMuNjgwODhDMTIuMDExNSAzLjU3MzU1IDExLjkyMTMgMy40ODEwOSAxMS44MTM3IDMuNDkyOThMOC4wNjkyNCAzLjg4NTY4QzcuOTI5MTQgMy45MDAwOSA3Ljg2OTU2IDQuMDY4NyA3Ljk2Njk2IDQuMTY4NjJMOS4wNzE4NSA1LjMwMjAxTDQuMjQwMDUgMTAuMDEyM0M0LjE3NDQzIDEwLjA3NjMgNC4xNzMwOCAxMC4xODIzIDQuMjM3MDUgMTAuMjQ4TDUuMDUxMTggMTEuMDgzMUM1LjExNTE1IDExLjE0ODcgNS4yMjExNyAxMS4xNSA1LjI4Njc5IDExLjA4NjFMMTAuMTE4NiA2LjM3NTc0TDExLjIyMzUgNy41MDkxM0MxMS4zMjA5IDcuNjA5MDUgMTEuNDkxIDcuNTUwODMgMTEuNTA4OSA3LjQxNDA5WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC40MTg3IDcuNDAxNzdDMTMuOTM4MiA3LjQwMTc3IDEzLjU0ODcgNy43OTEyOSAxMy41NDg3IDguMjcxNzdWMTEuNDAxOEgxMC40MTg3QzkuOTM4MTkgMTEuNDAxOCA5LjU0ODY4IDExLjc5MTMgOS41NDg2OCAxMi4yNzE4VjE1LjQwMThINS45MTg2N0M1LjQzODE4IDE1LjQwMTggNS4wNDg2OCAxNS43OTEzIDUuMDQ4NjggMTYuMjcxOFYyMC4yMzE4QzUuMDQ4NjggMjAuNzEyMyA1LjQzODE5IDIxLjEwMTggNS45MTg2OCAyMS4xMDE4SDE4Ljg3ODdDMTkuMzU5MSAyMS4xMDE4IDE5Ljc0ODcgMjAuNzEyMyAxOS43NDg3IDIwLjIzMThWOC4yNzE3N0MxOS43NDg3IDcuNzkxMzIgMTkuMzU5MiA3LjQwMTc3IDE4Ljg3ODcgNy40MDE3N0gxNC40MTg3Wk0xNS4yNDg3IDEyLjIzMThWOS4xMDE3N0gxOC4wNDg3VjE5LjQwMThINi43NDg2OFYxNy4xMDE4SDEwLjM3ODdDMTAuODU5MiAxNy4xMDE4IDExLjI0ODcgMTYuNzEyMyAxMS4yNDg3IDE2LjIzMThWMTMuMTAxOEgxNC4zNzg3QzE0Ljg1OTIgMTMuMTAxOCAxNS4yNDg3IDEyLjcxMjMgMTUuMjQ4NyAxMi4yMzE4WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPC9zdmc+Cg==";
const structures$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDJWMjFIMTFWMkgxM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik05LjUgNkg3VjMuNUg5LjVWNloiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik05LjUgM0g3VjJIOS41VjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8cGF0aCBkPSJNMTcgNkgxNC41VjMuNUgxN1Y2WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTE3IDNIMTQuNVYySDE3VjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const tower$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4Ljg5OSA5LjM5OTMyQzE4Ljc3NTIgOS4yNDU4OCAxOC41ODg2IDkuMTU2NjcgMTguMzkxNSA5LjE1NjY3SDE2LjQxNzNMMTcuNzE3MSA0LjI0OTUxQzE3Ljc2OSA0LjA1Mzg3IDE3LjcyNyAzLjg0NTE4IDE3LjYwMzYgMy42ODQ4MkMxNy40ODAxIDMuNTI0NDYgMTcuMjg5MiAzLjQzMDQgMTcuMDg2OCAzLjQzMDRIMTIuMTc0MVYxLjY1MjE0QzEyLjE3NDEgMS4yOTE5NyAxMS44ODIxIDEgMTEuNTIyIDFDMTEuMTYxOCAxIDEwLjg2OTggMS4yOTE5NyAxMC44Njk4IDEuNjUyMTRWMy40MzA0NEg1Ljk1NjgxQzUuNzU0MzkgMy40MzA0NCA1LjU2MzQ0IDMuNTI0NDYgNS40NDAwMyAzLjY4NDg2QzUuMzE2NTggMy44NDUyMiA1LjI3NDYgNC4wNTM5MiA1LjMyNjQyIDQuMjQ5NTVMNi42MjYzMSA5LjE1NjcxSDQuNjUyMTFDNC40NTQ5MyA5LjE1NjcxIDQuMjY4MzYgOS4yNDU5MiA0LjE0NDU2IDkuMzk5MzZDNC4wMjA3MyA5LjU1Mjg0IDMuOTczMDggOS43NTQwMiA0LjAxNDc2IDkuOTQ2NzRMNS4wNjU2IDE0LjgwMzVDNS4xMzA1MyAxNS4xMDM1IDUuMzk1OTkgMTUuMzE3NyA1LjcwMyAxNS4zMTc3SDcuMDg3MTVWMjIuMzQ3OUM3LjA4NzE1IDIyLjcwOCA3LjM3OTEyIDIzIDcuNzM5MjkgMjNIMTUuMzA0MkMxNS42NjQ0IDIzIDE1Ljk1NjQgMjIuNzA4IDE1Ljk1NjQgMjIuMzQ3OVYxNS4zMTc3SDE3LjM0MDZDMTcuNjQ3NiAxNS4zMTc3IDE3LjkxMyAxNS4xMDM1IDE3Ljk3OCAxNC44MDM1TDE5LjAyODkgOS45NDY3NEMxOS4wNzA2IDkuNzU0MDIgMTkuMDIyOCA5LjU1Mjg0IDE4Ljg5OSA5LjM5OTMyWk0xNi4yMzk0IDQuNzM0NzFMMTUuOTY3MiA1Ljc2MjFINy4wNzYzMkw2LjgwNDE2IDQuNzM0NzFIMTYuMjM5NFpNNy45NzU2MiA5LjE1NjcxTDcuNDIxODggNy4wNjYzM0gxNS42MjE4TDE1LjA2OCA5LjE1NjcxSDcuOTc1NjJaTTEzLjA4MjQgMTAuNDYwOUwxMi44Mjk0IDE0LjAxMzRIMTAuMjE0MUw5Ljk2MTA3IDEwLjQ2MDlIMTMuMDgyNFpNNi4yMjkxMSAxNC4wMTM0TDUuNDYwNDggMTAuNDYwOUg4LjY1MzYyTDguOTA2NjIgMTQuMDEzNEg2LjIyOTExWk0xNC42NTIxIDIxLjY5NTdIOC4zOTE0MlYxNS4zMTc3SDE0LjY1MjFWMjEuNjk1N0gxNC42NTIxWk0xNi44MTQ1IDE0LjAxMzRIMTQuMTM3TDE0LjM5IDEwLjQ2MDlIMTcuNTgzMkwxNi44MTQ1IDE0LjAxMzRaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const waterTower$1 = "data:image/svg+xml;base64,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";
const otherTowers$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4Ljg5OSA5LjM5OTMyQzE4Ljc3NTIgOS4yNDU4OCAxOC41ODg2IDkuMTU2NjcgMTguMzkxNSA5LjE1NjY3SDE2LjQxNzNMMTcuNzE3MSA0LjI0OTUxQzE3Ljc2OSA0LjA1Mzg3IDE3LjcyNyAzLjg0NTE4IDE3LjYwMzYgMy42ODQ4MkMxNy40ODAxIDMuNTI0NDYgMTcuMjg5MiAzLjQzMDQgMTcuMDg2OCAzLjQzMDRIMTIuMTc0MVYxLjY1MjE0QzEyLjE3NDEgMS4yOTE5NyAxMS44ODIxIDEgMTEuNTIyIDFDMTEuMTYxOCAxIDEwLjg2OTggMS4yOTE5NyAxMC44Njk4IDEuNjUyMTRWMy40MzA0NEg1Ljk1NjgxQzUuNzU0MzkgMy40MzA0NCA1LjU2MzQ0IDMuNTI0NDYgNS40NDAwMyAzLjY4NDg2QzUuMzE2NTggMy44NDUyMiA1LjI3NDYgNC4wNTM5MiA1LjMyNjQyIDQuMjQ5NTVMNi42MjYzMSA5LjE1NjcxSDQuNjUyMTFDNC40NTQ5MyA5LjE1NjcxIDQuMjY4MzYgOS4yNDU5MiA0LjE0NDU2IDkuMzk5MzZDNC4wMjA3MyA5LjU1Mjg0IDMuOTczMDggOS43NTQwMiA0LjAxNDc2IDkuOTQ2NzRMNS4wNjU2IDE0LjgwMzVDNS4xMzA1MyAxNS4xMDM1IDUuMzk1OTkgMTUuMzE3NyA1LjcwMyAxNS4zMTc3SDcuMDg3MTVWMjIuMzQ3OUM3LjA4NzE1IDIyLjcwOCA3LjM3OTEyIDIzIDcuNzM5MjkgMjNIMTUuMzA0MkMxNS42NjQ0IDIzIDE1Ljk1NjQgMjIuNzA4IDE1Ljk1NjQgMjIuMzQ3OVYxNS4zMTc3SDE3LjM0MDZDMTcuNjQ3NiAxNS4zMTc3IDE3LjkxMyAxNS4xMDM1IDE3Ljk3OCAxNC44MDM1TDE5LjAyODkgOS45NDY3NEMxOS4wNzA2IDkuNzU0MDIgMTkuMDIyOCA5LjU1Mjg0IDE4Ljg5OSA5LjM5OTMyWk0xNi4yMzk0IDQuNzM0NzFMMTUuOTY3MiA1Ljc2MjFINy4wNzYzMkw2LjgwNDE2IDQuNzM0NzFIMTYuMjM5NFpNNy45NzU2MiA5LjE1NjcxTDcuNDIxODggNy4wNjYzM0gxNS42MjE4TDE1LjA2OCA5LjE1NjcxSDcuOTc1NjJaTTEzLjA4MjQgMTAuNDYwOUwxMi44Mjk0IDE0LjAxMzRIMTAuMjE0MUw5Ljk2MTA3IDEwLjQ2MDlIMTMuMDgyNFpNNi4yMjkxMSAxNC4wMTM0TDUuNDYwNDggMTAuNDYwOUg4LjY1MzYyTDguOTA2NjIgMTQuMDEzNEg2LjIyOTExWk0xNC42NTIxIDIxLjY5NTdIOC4zOTE0MlYxNS4zMTc3SDE0LjY1MjFWMjEuNjk1N0gxNC42NTIxWk0xNi44MTQ1IDE0LjAxMzRIMTQuMTM3TDE0LjM5IDEwLjQ2MDlIMTcuNTgzMkwxNi44MTQ1IDE0LjAxMzRaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const cbsd$1 = "data:image/svg+xml;base64,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";
const emergencyTruck$1 = "data:image/svg+xml;base64,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";
const escalator$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjI5NzYgMy4wMDcyM0wxMS4xMDMzIDYuNzY3MTdDMTEuMDk2MSA2LjkwNDkgMTAuOTMxMSA2Ljk3NjI1IDEwLjgyNjIgNi44ODQyNUw5LjYzNiA1Ljg0MDc5TDUuMTg3NTMgMTAuOTE0N0M1LjEyNzEyIDEwLjk4MzYgNS4wMjEzMSAxMC45OTA2IDQuOTUyNDEgMTAuOTMwMkw0LjA3NTQzIDEwLjE2MTNDNC4wMDY1MyAxMC4xMDA5IDMuOTk5NTggOS45OTUwNiA0LjA1OTk5IDkuOTI2MTZMOC41MDg0NiA0Ljg1MjI0TDcuMzE4MjkgMy44MDg3N0M3LjIxMzM2IDMuNzE2NzggNy4yNTk1NyAzLjU0NDAyIDcuMzk4MTEgMy41MTg2OUwxMS4xMDAzIDIuODM0MjRDMTEuMjA2NyAyLjgxMzk3IDExLjMwMzggMi44OTkwOSAxMS4yOTc2IDMuMDA3MjNaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjUxMTMgNC45Njg3NkMxNC4yMDMgNC45Njg3NiAxMy45MTc4IDUuMTMxOTMgMTMuNzYxNSA1LjM5NzY2TDkuMDEzNzUgMTMuNDY4OEg0LjUxOTlDNC4wMzk0MiAxMy40Njg4IDMuNjQ5OSAxMy44NTgzIDMuNjQ5OSAxNC4zMzg4VjIwLjI5ODhDMy42NDk5IDIwLjc3OTMgNC4wMzk0MiAyMS4xNjg4IDQuNTE5OSAyMS4xNjg4SDE5LjQ3OTlDMTkuOTYwNCAyMS4xNjg4IDIwLjM0OTkgMjAuNzc5MyAyMC4zNDk5IDIwLjI5ODhWNS44Mzg3NkMyMC4zNDk5IDUuMzU4MjcgMTkuOTYwNCA0Ljk2ODc2IDE5LjQ3OTkgNC45Njg3NkgxNC41MTEzWk0xMC4yMzgzIDE0LjczOTlMMTQuOTg2MSA2LjY2ODc2SDE4LjY0OTlWNy45Njg3NkgxNi4wMTEzQzE1LjcwMyA3Ljk2ODc2IDE1LjQxNzggOC4xMzE5MyAxNS4yNjE1IDguMzk3NjZMMTAuNTEzNyAxNi40Njg4SDUuMzQ5OVYxNS4xNjg4SDkuNDg4NDZDOS43OTY3NyAxNS4xNjg4IDEwLjA4MiAxNS4wMDU2IDEwLjIzODMgMTQuNzM5OVpNMTYuNDg2MSA5LjY2ODc2SDE4LjY0OTlWMTkuNDY4OEg1LjM0OTlWMTguMTY4OEgxMC45ODg1QzExLjI5NjggMTguMTY4OCAxMS41ODIgMTguMDA1NiAxMS43MzgzIDE3LjczOTlMMTYuNDg2MSA5LjY2ODc2WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPC9zdmc+Cg==";
const idf$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMzA5NyAxNy4xMjgzSDE5LjY5NDJDMTkuNzg0IDE3LjEyODMgMTkuODU3OCAxNy4wOTk0IDE5LjkxNTUgMTcuMDQxOEMxOS45NzMxIDE2Ljk4NDEgMjAuMDAyIDE2LjkxMDQgMjAuMDAyIDE2LjgyMDVWMTEuMjQzOEg0LjAwMTk1VjE2LjgyMDVDNC4wMDE5NSAxNi45MTA0IDQuMDMwNzkgMTYuOTg0MSA0LjA4ODQ1IDE3LjA0MThDNC4xNDYxMiAxNy4wOTk0IDQuMjE5ODcgMTcuMTI4MyA0LjMwOTcgMTcuMTI4M1pNMTcuMDU4NSAxNS40MzZDMTcuNDA1NSAxNS40MzYgMTcuNzAwNyAxNS4zMTQ2IDE3Ljk0NDIgMTUuMDcxOEMxOC4xODc5IDE0LjgyODkgMTguMzA5NyAxNC41MzQgMTguMzA5NyAxNC4xODdDMTguMzA5NyAxMy44NDAyIDE4LjE4ODMgMTMuNTQ0OSAxNy45NDU1IDEzLjMwMTNDMTcuNzAyNiAxMy4wNTc4IDE3LjQwNzcgMTIuOTM2IDE3LjA2MDcgMTIuOTM2QzE2LjcxMzkgMTIuOTM2IDE2LjQxODYgMTMuMDU3NCAxNi4xNzUgMTMuMzAwM0MxNS45MzE1IDEzLjU0MzEgMTUuODA5NyAxMy44Mzc5IDE1LjgwOTcgMTQuMTg0OEMxNS44MDk3IDE0LjUzMTggMTUuOTMxMSAxNC44MjcgMTYuMTc0IDE1LjA3MDVDMTYuNDE2OCAxNS4zMTQyIDE2LjcxMTYgMTUuNDM2IDE3LjA1ODUgMTUuNDM2Wk0yMS41MDIgOS43NDM3N0gxOS4zODg1TDE3LjE3NyA3LjQ5Mzc3SDYuODI2OTVMNC42MTU0NSA5Ljc0Mzc3SDIuNTAxOTVMNS42ODY3IDYuNTIwNzdDNS44NTA3IDYuMzUwMTEgNi4wNDMyIDYuMjE5NjEgNi4yNjQyIDYuMTI5MjdDNi40ODUyIDYuMDM4OTQgNi43MTc3IDUuOTkzNzcgNi45NjE3IDUuOTkzNzdIMTcuMDQyMkMxNy4yODYyIDUuOTkzNzcgMTcuNTE4NyA2LjAzODk0IDE3LjczOTcgNi4xMjkyN0MxNy45NjA3IDYuMjE5NjEgMTguMTUzMiA2LjM1MDExIDE4LjMxNzIgNi41MjA3N0wyMS41MDIgOS43NDM3N1pNNC4zMDk3IDE4LjYyODNDMy44MTI1NCAxOC42MjgzIDMuMzg2OTUgMTguNDUxMyAzLjAzMjk1IDE4LjA5NzNDMi42Nzg5NSAxNy43NDMzIDIuNTAxOTUgMTcuMzE3NyAyLjUwMTk1IDE2LjgyMDVWOS43NDM3N0gyMS41MDJWMTYuODIwNUMyMS41MDIgMTcuMzE3NyAyMS4zMjUgMTcuNzQzMyAyMC45NzEgMTguMDk3M0MyMC42MTcgMTguNDUxMyAyMC4xOTE0IDE4LjYyODMgMTkuNjk0MiAxOC42MjgzSDQuMzA5N1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const mdf$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDE5LjE5MjFWMTYuMTYzNEg1VjE5LjE5MjFDNSAxOS4yODIgNS4wMjg4MyAxOS4zNTU3IDUuMDg2NSAxOS40MTM0QzUuMTQ0MTcgMTkuNDcxIDUuMjE3OTIgMTkuNDk5OSA1LjMwNzc1IDE5LjQ5OTlIMTguNjkyM0MxOC43ODIxIDE5LjQ5OTkgMTguODU1OCAxOS40NzEgMTguOTEzNSAxOS40MTM0QzE4Ljk3MTIgMTkuMzU1NyAxOSAxOS4yODIgMTkgMTkuMTkyMVpNMTkgMTQuNjYzNFYxMC4zMzY0SDVWMTQuNjYzNEgxOVpNMTkgOC44MzYzOFY1LjgwNzYzQzE5IDUuNzE3NzkgMTguOTcxMiA1LjY0NDA1IDE4LjkxMzUgNS41ODYzOEMxOC44NTU4IDUuNTI4NzEgMTguNzgyMSA1LjQ5OTg4IDE4LjY5MjMgNS40OTk4OEg1LjMwNzc1QzUuMjE3OTIgNS40OTk4OCA1LjE0NDE3IDUuNTI4NzEgNS4wODY1IDUuNTg2MzhDNS4wMjg4MyA1LjY0NDA1IDUgNS43MTc3OSA1IDUuODA3NjNWOC44MzYzOEgxOVpNNS4zMDc3NSAyMC45OTk5QzQuODAyNTggMjAuOTk5OSA0LjM3NSAyMC44MjQ5IDQuMDI1IDIwLjQ3NDlDMy42NzUgMjAuMTI0OSAzLjUgMTkuNjk3MyAzLjUgMTkuMTkyMVY1LjgwNzYzQzMuNSA1LjMwMjQ2IDMuNjc1IDQuODc0ODggNC4wMjUgNC41MjQ4OEM0LjM3NSA0LjE3NDg4IDQuODAyNTggMy45OTk4OCA1LjMwNzc1IDMuOTk5ODhIMTguNjkyM0MxOS4xOTc0IDMuOTk5ODggMTkuNjI1IDQuMTc0ODggMTkuOTc1IDQuNTI0ODhDMjAuMzI1IDQuODc0ODggMjAuNSA1LjMwMjQ2IDIwLjUgNS44MDc2M1YxOS4xOTIxQzIwLjUgMTkuNjk3MyAyMC4zMjUgMjAuMTI0OSAxOS45NzUgMjAuNDc0OUMxOS42MjUgMjAuODI0OSAxOS4xOTc0IDIwLjk5OTkgMTguNjkyMyAyMC45OTk5SDUuMzA3NzVaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const mines$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjE0OTggNS45ODQ2NkwxMi4yODUyIDguODQ5MTlDMTIuMTI3IDkuMDA3MzkgMTIuMTI3IDkuMjYzODkgMTIuMjg1MiA5LjQyMjA5TDE0LjU3NjggMTEuNzEzN0MxNC43MzUgMTEuODcxOSAxNC45OTE1IDExLjg3MTkgMTUuMTQ5OCAxMS43MTM3TDE4LjAxNDMgOC44NDkxOUMxOC4xNzI1IDguNjkwOTggMTguMTcyNSA4LjQzNDQ4IDE4LjAxNDMgOC4yNzYyOEwxNS43MjI3IDUuOTg0NjZDMTUuNTY0NSA1LjgyNjQ2IDE1LjMwOCA1LjgyNjQ2IDE1LjE0OTggNS45ODQ2NloiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik0xNC4yNjA1IDUuNzI5MDRDMTEuNDYyMiAzLjI5MDU1IDkuMjgwNjYgMy4wMTM3NCA5LjE4MDA2IDMuMDAyNDdDOS4wOTY2MSAyLjk5MzIxIDkuMDEyMzUgMy4wMTAxIDguOTM4OTIgMy4wNTA4MUM4Ljg2NTQ5IDMuMDkxNTIgOC44MDY1MiAzLjE1NDAzIDguNzcwMTYgMy4yMjk3QzguNzMzOCAzLjMwNTM4IDguNzIxODUgMy4zOTA0OCA4LjczNTk2IDMuNDczMjRDOC43NTAwNiAzLjU1NjAxIDguNzg5NTMgMy42MzIzNCA4Ljg0ODkxIDMuNjkxN0wxMi41NzM0IDcuNDE2MTVMMTQuMjYwNSA1LjcyOTA0WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTIwLjk5NzUgMTQuODJDMjAuOTg2MyAxNC43MTk0IDIwLjcwOTQgMTIuNTM4MiAxOC4yNzE0IDkuNzQwMjNMMTYuNTg0MyAxMS40MjczTDIwLjMwODMgMTUuMTUxMkMyMC4zNjc2IDE1LjIxMDYgMjAuNDQ0IDE1LjI1IDIwLjUyNjcgMTUuMjY0MUMyMC42MDk1IDE1LjI3ODIgMjAuNjk0NiAxNS4yNjYzIDIwLjc3MDMgMTUuMjI5OUMyMC44NDYgMTUuMTkzNiAyMC45MDg1IDE1LjEzNDYgMjAuOTQ5MiAxNS4wNjEyQzIwLjk4OTkgMTQuOTg3NyAyMS4wMDY4IDE0LjkwMzUgMjAuOTk3NSAxNC44MloiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik0xMi4wMDAzIDEwLjI4MTFMMy4xMTg2NyAxOS4xNjI1QzMuMDQyNjkgMTkuMjM4NSAzIDE5LjM0MTUgMyAxOS40NDlDMyAxOS41NTY0IDMuMDQyNjkgMTkuNjU5NSAzLjExODY3IDE5LjczNTVMNC4yNjQ4MiAyMC44ODEzQzQuMzQwODEgMjAuOTU3MyA0LjQ0Mzg2IDIxIDQuNTUxMzIgMjFDNC42NTg3OCAyMSA0Ljc2MTgzIDIwLjk1NzMgNC44Mzc4MiAyMC44ODEzTDEzLjcxOTMgMTIuMDAwMUwxMi4wMDAzIDEwLjI4MTFaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const monopole$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDNWMjJIMTFWM0gxM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik05LjUgN0g3VjQuNUg5LjVWN1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+CjxwYXRoIGQ9Ik05LjUgNEg3VjNIOS41VjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8cGF0aCBkPSJNMTcgN0gxNC41VjQuNUgxN1Y3WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPHBhdGggZD0iTTE3IDRIMTQuNVYzSDE3VjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const singleLevelBuilding$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMDE3MTQgNS4yMzMxM1Y0LjA5ODYzSDE5LjYzNDRWNS4yMzMxM0g0LjAxNzE0Wk00LjE1MTg5IDE5LjU5ODZWMTMuMjczNkgyLjg2OTE0VjEyLjEzOTFMNC4wMTcxNCA3LjA5ODYzSDE5LjYwOTRMMjAuNzY3MSAxMi4xMzkxVjEzLjI3MzZIMTkuNDg0NFYxOS41OTg2SDE4LjM0OTlWMTMuMjczNkgxMy4zMTcxVjE5LjU5ODZINC4xNTE4OVpNNS4yODYzOSAxOC40NjQxSDEyLjE4MjZWMTMuMjczNkg1LjI4NjM5VjE4LjQ2NDFaTTMuOTc4NjQgMTIuMTM5MUgxOS42NDc5TDE4Ljc1NzYgOC4yMzMxM0g0Ljg2OTE0TDMuOTc4NjQgMTIuMTM5MVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const multiLevelBuilding$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMDY4MTIgMjAuNTk4NlY3LjE4NTEzSDcuMTY0MzdWMy4wOTg2M0gxNi40ODE2VjExLjI4MTFIMjAuNTY4MVYyMC41OTg2SDEzLjMwNjZWMTYuNTAyNEgxMC4zMjk2VjIwLjU5ODZIMy4wNjgxMlpNNC4yMDI2MiAxOS40NjM5SDcuMTY0MzdWMTYuNTAyNEg0LjIwMjYyVjE5LjQ2MzlaTTQuMjAyNjIgMTUuMzY3OUg3LjE2NDM3VjEyLjQxNTlINC4yMDI2MlYxNS4zNjc5Wk00LjIwMjYyIDExLjI4MTFINy4xNjQzN1Y4LjMxOTYzSDQuMjAyNjJWMTEuMjgxMVpNOC4yOTg4NyAxNS4zNjc5SDExLjI1MDlWMTIuNDE1OUg4LjI5ODg3VjE1LjM2NzlaTTguMjk4ODcgMTEuMjgxMUgxMS4yNTA5VjguMzE5NjNIOC4yOTg4N1YxMS4yODExWk04LjI5ODg3IDcuMTg1MTNIMTEuMjUwOVY0LjIzMzEzSDguMjk4ODdWNy4xODUxM1pNMTIuMzg1NCAxNS4zNjc5SDE1LjM0NjlWMTIuNDE1OUgxMi4zODU0VjE1LjM2NzlaTTEyLjM4NTQgMTEuMjgxMUgxNS4zNDY5VjguMzE5NjNIMTIuMzg1NFYxMS4yODExWk0xMi4zODU0IDcuMTg1MTNIMTUuMzQ2OVY0LjIzMzEzSDEyLjM4NTRWNy4xODUxM1pNMTYuNDgxNiAxOS40NjM5SDE5LjQzMzZWMTYuNTAyNEgxNi40ODE2VjE5LjQ2MzlaTTE2LjQ4MTYgMTUuMzY3OUgxOS40MzM2VjEyLjQxNTlIMTYuNDgxNlYxNS4zNjc5WiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPC9zdmc+Cg==";
const multiBuildings$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMTgzNTkgMjAuNTk4NlYzLjA5ODYzSDExLjUwMDhWNy4xODUxM0gyMS40NTI2VjIwLjU5ODZIMi4xODM1OVpNMy4zMTgwOSAxOS40NjM5SDYuMjc5NTlWMTYuNTAyNEgzLjMxODA5VjE5LjQ2MzlaTTMuMzE4MDkgMTUuMzY3OUg2LjI3OTU5VjEyLjQxNTlIMy4zMTgwOVYxNS4zNjc5Wk0zLjMxODA5IDExLjI4MTFINi4yNzk1OVY4LjMxOTYzSDMuMzE4MDlWMTEuMjgxMVpNMy4zMTgwOSA3LjE4NTEzSDYuMjc5NTlWNC4yMzMxM0gzLjMxODA5VjcuMTg1MTNaTTcuNDE0MzQgMTkuNDYzOUgxMC4zNjYxVjE2LjUwMjRINy40MTQzNFYxOS40NjM5Wk03LjQxNDM0IDE1LjM2NzlIMTAuMzY2MVYxMi40MTU5SDcuNDE0MzRWMTUuMzY3OVpNNy40MTQzNCAxMS4yODExSDEwLjM2NjFWOC4zMTk2M0g3LjQxNDM0VjExLjI4MTFaTTcuNDE0MzQgNy4xODUxM0gxMC4zNjYxVjQuMjMzMTNINy40MTQzNFY3LjE4NTEzWk0xMS41MDA4IDE5LjQ2MzlIMjAuMzE4MVY4LjMxOTYzSDExLjUwMDhWMTEuMjgxMUgxMy42OTMxVjEyLjQxNTlIMTEuNTAwOFYxNS4zNjc5SDEzLjY5MzFWMTYuNTAyNEgxMS41MDA4VjE5LjQ2MzlaTTE2LjM0NjggMTIuNDE1OVYxMS4yODExSDE3LjQ4MTZWMTIuNDE1OUgxNi4zNDY4Wk0xNi4zNDY4IDE2LjUwMjRWMTUuMzY3OUgxNy40ODE2VjE2LjUwMjRIMTYuMzQ2OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const otherBuildings$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMjAuNVYzSDEwLjMxNzNWNy4wODY1SDIwLjI2OVYxNS42MDU4SDE5LjEzNDVWOC4yMjFIMTAuMzE3M1YxMS4xODI1SDEyLjUwOTVWMTIuMzE3MkgxMC4zMTczVjE1LjI2OTJIMTIuNTA5NVYxNi40MDM4SDEwLjMxNzNWMTkuMzY1MkgxNS4zNDZWMjAuNUgxWk0yLjEzNDUgMTkuMzY1Mkg1LjA5NlYxNi40MDM4SDIuMTM0NVYxOS4zNjUyWk0yLjEzNDUgMTUuMjY5Mkg1LjA5NlYxMi4zMTcySDIuMTM0NVYxNS4yNjkyWk0yLjEzNDUgMTEuMTgyNUg1LjA5NlY4LjIyMUgyLjEzNDVWMTEuMTgyNVpNMi4xMzQ1IDcuMDg2NUg1LjA5NlY0LjEzNDVIMi4xMzQ1VjcuMDg2NVpNNi4yMzA3NSAxOS4zNjUySDkuMTgyNVYxNi40MDM4SDYuMjMwNzVWMTkuMzY1MlpNNi4yMzA3NSAxNS4yNjkySDkuMTgyNVYxMi4zMTcySDYuMjMwNzVWMTUuMjY5MlpNNi4yMzA3NSAxMS4xODI1SDkuMTgyNVY4LjIyMUg2LjIzMDc1VjExLjE4MjVaTTYuMjMwNzUgNy4wODY1SDkuMTgyNVY0LjEzNDVINi4yMzA3NVY3LjA4NjVaTTE5LjAwNzUgMjIuNVYyMC4zNzNIMTYuODY1MlYxOS4yMzg1SDE5LjAwNzVWMTcuMDg2NUgyMC4xNDIzVjE5LjIzODVIMjIuMjY5VjIwLjM3M0gyMC4xNDIzVjIyLjVIMTkuMDA3NVpNMTUuMTYzMyAxMi4zMTcyVjExLjE4MjVIMTYuMjk4VjEyLjMxNzJIMTUuMTYzM1pNMTUuMTYzMyAxNi40MDM4VjE1LjI2OTJIMTYuMjk4VjE2LjQwMzhIMTUuMTYzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const oilRigs$1 = "data:image/svg+xml;base64,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";
const parking$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjExNDQgMjAuODI3NVYxNS4yMjJMMTEuNTEwNCAxMS4xMzUzQzExLjUzNzQgMTEuMDUwNiAxMS41ODQ4IDEwLjk4MSAxMS42NTI2IDEwLjkyNjVDMTEuNzIwNiAxMC44NzIgMTEuODI3IDEwLjg0NDggMTEuOTcxOSAxMC44NDQ4SDE5LjQwMjZDMTkuNTMxOCAxMC44NDQ4IDE5LjYzMTcgMTAuODY5NCAxOS43MDI0IDEwLjkxODdDMTkuNzczIDEwLjk2ODEgMTkuODI2OSAxMS4wNDAzIDE5Ljg2NDEgMTEuMTM1M0wyMS4yNjA0IDE1LjIyMlYyMC44Mjc1QzIxLjI2MDQgMjAuOTYyOCAyMS4yMTY5IDIxLjA3MzkgMjEuMTMwMSAyMS4xNjA3QzIxLjA0MzQgMjEuMjQ3NiAyMC45MzMxIDIxLjI5MSAyMC43OTkxIDIxLjI5MUgyMC40NjkxQzIwLjM0NDYgMjEuMjkxIDIwLjIzNzcgMjEuMjQ3NiAyMC4xNDg0IDIxLjE2MDdDMjAuMDU5IDIxLjA3MzkgMjAuMDE0NCAyMC45NjI4IDIwLjAxNDQgMjAuODI3NVYxOS41Njc4SDExLjM2MDRWMjAuODI3NUMxMS4zNjA0IDIwLjk2MjggMTEuMzE1NCAyMS4wNzM5IDExLjIyNTYgMjEuMTYwN0MxMS4xMzU4IDIxLjI0NzYgMTEuMDI1IDIxLjI5MSAxMC44OTM0IDIxLjI5MUgxMC41NzE0QzEwLjQ0NTQgMjEuMjkxIDEwLjMzNzcgMjEuMjQ3NiAxMC4yNDg0IDIxLjE2MDdDMTAuMTU5IDIxLjA3MzkgMTAuMTE0NCAyMC45NjI4IDEwLjExNDQgMjAuODI3NVpNMTEuMjM3NCAxNC41MzdIMjAuMTM3NEwxOS4xNzc2IDExLjY3MThIMTIuMTk2OUwxMS4yMzc0IDE0LjUzN1pNMTIuNjA2NiAxNy45NTYzQzEyLjg2OTMgMTcuOTU2MyAxMy4wODk0IDE3Ljg2NzQgMTMuMjY3MSAxNy42ODk4QzEzLjQ0NDYgMTcuNTEyMSAxMy41MzM0IDE3LjI5MTkgMTMuNTMzNCAxNy4wMjkzQzEzLjUzMzQgMTYuNzc1OCAxMy40NDQ2IDE2LjU1OTUgMTMuMjY3MSAxNi4zODA1QzEzLjA4OTQgMTYuMjAxNSAxMi44NjkzIDE2LjExMiAxMi42MDY2IDE2LjExMkMxMi4zNDM5IDE2LjExMiAxMi4xMjM4IDE2LjIwMTUgMTEuOTQ2MSAxNi4zODA1QzExLjc2ODQgMTYuNTU5NSAxMS42Nzk2IDE2Ljc3NzQgMTEuNjc5NiAxNy4wMzQzQzExLjY3OTYgMTcuMjkwOSAxMS43Njg0IDE3LjUwODggMTEuOTQ2MSAxNy42ODc4QzEyLjEyMzggMTcuODY2OCAxMi4zNDM5IDE3Ljk1NjMgMTIuNjA2NiAxNy45NTYzWk0xOC43NjgxIDE3Ljk1NjNDMTkuMDIxNiAxNy45NTYzIDE5LjIzOTQgMTcuODY3NCAxOS40MjE2IDE3LjY4OThDMTkuNjAzOSAxNy41MTIxIDE5LjY5NTEgMTcuMjkxOSAxOS42OTUxIDE3LjAyOTNDMTkuNjk1MSAxNi43NzU4IDE5LjYwMzkgMTYuNTU5NSAxOS40MjE2IDE2LjM4MDVDMTkuMjM5NCAxNi4yMDE1IDE5LjAyIDE2LjExMiAxOC43NjM0IDE2LjExMkMxOC41MDY1IDE2LjExMiAxOC4yODg2IDE2LjIwMTUgMTguMTA5NiAxNi4zODA1QzE3LjkzMDYgMTYuNTU5NSAxNy44NDExIDE2Ljc3NzQgMTcuODQxMSAxNy4wMzQzQzE3Ljg0MTEgMTcuMjkwOSAxNy45Mjk5IDE3LjUwODggMTguMTA3NiAxNy42ODc4QzE4LjI4NTMgMTcuODY2OCAxOC41MDU0IDE3Ljk1NjMgMTguNzY4MSAxNy45NTYzWk01Ljk5MTEgMTMuNTE0VjExLjg3MThINy42MzM2VjEzLjUxNEg1Ljk5MTFaTTEwLjYxODEgNy42NjRWNi4wMjE3NUgxMi4yNjA0VjcuNjY0SDEwLjYxODFaTTUuOTkxMSAxNy40MDI1VjE1Ljc2MDNINy42MzM2VjE3LjQwMjVINS45OTExWk01Ljk5MTEgMjEuMjkxVjE5LjY0ODVINy42MzM2VjIxLjI5MUg1Ljk5MTFaTTIuMzc1ODUgMjEuMjkxVjguMjU2MjVINy4wMDI2VjIuNDA2MjVIMTUuODc1NlY4LjI1MjVIMTQuNzQxMVYzLjU0MUg4LjEzNzM1VjkuMzkxSDMuNTEwMzVWMjEuMjkxSDIuMzc1ODVaTTEwLjk0MTEgMTguNzQxSDIwLjQzMzRWMTUuMzY0SDEwLjk0MTFWMTguNzQxWiIgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLW9wYWNpdHk9IjAuNDUiLz4KPC9zdmc+Cg==";
const podium$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjczOTM4IDIuNjk2NzhDMy4yNTg5IDIuNjk2NzggMi44NjkzOCAzLjA4NjI5IDIuODY5MzggMy41NjY3OFY2LjUyNjc4QzIuODY5MzggNy4wMDcyNyAzLjI1ODkgNy4zOTY3OCAzLjczOTM4IDcuMzk2NzhINC44NjkzOFYxNy4xOTY4SDMuNzM5MzhDMy4yNTg5IDE3LjE5NjggMi44NjkzOCAxNy41ODYzIDIuODY5MzggMTguMDY2OFYyMS4wMjY4QzIuODY5MzggMjEuNTA3MyAzLjI1ODkgMjEuODk2OCAzLjczOTM4IDIxLjg5NjhIMjAuMTk5NEMyMC42Nzk5IDIxLjg5NjggMjEuMDY5NCAyMS41MDczIDIxLjA2OTQgMjEuMDI2OFYxOC4wNjY4QzIxLjA2OTQgMTcuNTg2MyAyMC42Nzk5IDE3LjE5NjggMjAuMTk5NCAxNy4xOTY4SDE5LjA2OTRWNy4zOTY3OEgyMC4xOTk0QzIwLjY3OTkgNy4zOTY3OCAyMS4wNjk0IDcuMDA3MjcgMjEuMDY5NCA2LjUyNjc4VjMuNTY2NzhDMjEuMDY5NCAzLjA4NjI5IDIwLjY3OTkgMi42OTY3OCAyMC4xOTk0IDIuNjk2NzhIMy43MzkzOFpNNC41NjkzOCA1LjY5Njc4VjQuMzk2NzhIMTkuMzY5NFY1LjY5Njc4SDQuNTY5MzhaTTE2Ljg2OTQgNy4zOTY3OEg3LjA2NzEyVjE3LjE5NjhIMTYuODY5NFY3LjM5Njc4Wk00LjU2OTM4IDIwLjE5NjhWMTguODk2OEgxOS4zNjk0VjIwLjE5NjhINC41NjkzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const ramp$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC4wNDIzIDMuMDU1MTZDMjAuNjIxNyAyLjc0ODQ1IDIxLjMxOTQgMy4xNjg0MyAyMS4zMTk0IDMuODI0MDdWMjAuNzcwOUMyMS4zMTk0IDIxLjI1MTMgMjAuOTI5OSAyMS42NDA5IDIwLjQ0OTQgMjEuNjQwOUgyLjYxOTM4VjEyLjgwMjlDMi42MTkzOCAxMi40ODA2IDIuNzk3NTEgMTIuMTg0OCAzLjA4MjI5IDEyLjAzNEwyMC4wNDIzIDMuMDU1MTZaTTE5LjYxOTQgNS4yMDI2MkwxNi44MTk0IDYuNjg0OTdWMTIuMzU2OEwxOS42MTk0IDEwLjc5MjFWNS4yMDI2MlpNMTkuNjE5NCAxMi43Mzk2TDYuNzMyODggMTkuOTQwOUgxOS42MTk0VjEyLjczOTZaTTQuMzE5MzggMTkuMzQyMVYxMy4zMDI2TDYuODY5MzggMTEuOTUyNlYxNy45MTcxTDQuMzE5MzggMTkuMzQyMVpNOC41NjkzOCAxNi45NjcxTDExLjExOTQgMTUuNTQyMVY5LjcwMjYyTDguNTY5MzggMTEuMDUyNlYxNi45NjcxWk0xMi44MTk0IDguODAyNjJWMTQuNTkyMUwxNS4xMTk0IDEzLjMwNjhWNy41ODQ5N0wxMi44MTk0IDguODAyNjJaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8L3N2Zz4K";
const restRoom$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNjg5OTQgNy43ODEyNUM3Ljc4ODQzIDcuNzgxMjUgOC42ODIxMyA2Ljg4NzU1IDguNjgyMTMgNS43ODkwNkM4LjY4MjEzIDQuNjkwNTcgNy43ODg0MyAzLjc5Njg4IDYuNjg5OTQgMy43OTY4OEM1LjU5MTQ1IDMuNzk2ODggNC42OTc3NSA0LjY5MDU3IDQuNjk3NzUgNS43ODkwNkM0LjY5Nzc1IDYuODg3NTUgNS41OTE0NSA3Ljc4MTI1IDYuNjg5OTQgNy43ODEyNVpNNi42ODk5NCA1LjEyNUM3LjA1NjExIDUuMTI1IDcuMzU0IDUuNDIyOSA3LjM1NCA1Ljc4OTA2QzcuMzU0IDYuMTU1MjMgNy4wNTYxMSA2LjQ1MzEyIDYuNjg5OTQgNi40NTMxMkM2LjMyMzc4IDYuNDUzMTIgNi4wMjU4OCA2LjE1NTIzIDYuMDI1ODggNS43ODkwNkM2LjAyNTg4IDUuNDIyOSA2LjMyMzc4IDUuMTI1IDYuNjg5OTQgNS4xMjVaTTkuOTc3MDUgOS40MDgyVjE1LjMxODRDOS45NzcwNSAxNS42ODUxIDkuNjc5NzUgMTUuOTgyNCA5LjMxMjk5IDE1Ljk4MjRIOC43MTUzM1YyMC4xMzI4QzguNzE1MzMgMjAuNDk5NiA4LjQxODAzIDIwLjc5NjkgOC4wNTEyNyAyMC43OTY5QzcuNjg0NTEgMjAuNzk2OSA3LjM4NzIxIDIwLjQ5OTYgNy4zODcyMSAyMC4xMzI4VjE1LjMxODRDNy4zODcyMSAxNC45NTE2IDcuNjg0NTEgMTQuNjU0MyA4LjA1MTI3IDE0LjY1NDNIOC42NDg5M1YxMC4wNzIzSDQuNzk3MzZWMTQuNjU0M0g1LjM5NTAyQzUuNzYxNzggMTQuNjU0MyA2LjA1OTA4IDE0Ljk1MTYgNi4wNTkwOCAxNS4zMTg0VjIwLjEzMjhDNi4wNTkwOCAyMC40OTk2IDUuNzYxNzggMjAuNzk2OSA1LjM5NTAyIDIwLjc5NjlDNS4wMjgyNiAyMC43OTY5IDQuNzMwOTYgMjAuNDk5NiA0LjczMDk2IDIwLjEzMjhWMTUuOTgyNEg0LjEzMzNDMy43NjY1NCAxNS45ODI0IDMuNDY5MjQgMTUuNjg1MSAzLjQ2OTI0IDE1LjMxODRWOS40MDgyQzMuNDY5MjQgOS4wNDE0NCAzLjc2NjU0IDguNzQ0MTQgNC4xMzMzIDguNzQ0MTRIOS4zMTI5OUM5LjY3OTc1IDguNzQ0MTQgOS45NzcwNSA5LjA0MTQ0IDkuOTc3MDUgOS40MDgyWk0yMC4zMDQyIDE3LjQ4MzFDMjAuMTc4MSAxNy42MjY3IDE5Ljk5NjMgMTcuNzA5IDE5LjgwNTIgMTcuNzA5SDE5LjIwNzVWMjAuMTMyOEMxOS4yMDc1IDIwLjQ5OTYgMTguOTEwMiAyMC43OTY5IDE4LjU0MzUgMjAuNzk2OUMxOC4xNzY3IDIwLjc5NjkgMTcuODc5NCAyMC40OTk2IDE3Ljg3OTQgMjAuMTMyOFYxNy4wNDQ5QzE3Ljg3OTQgMTYuNjc4MiAxOC4xNzY3IDE2LjM4MDkgMTguNTQzNSAxNi4zODA5SDE5LjA0ODlMMTguMjI2IDEwLjA3MjNIMTYuMjA0N0wxNS4zODE4IDE2LjM4MDlIMTUuODg3MkMxNi4yNTQgMTYuMzgwOSAxNi41NTEzIDE2LjY3ODIgMTYuNTUxMyAxNy4wNDQ5VjIwLjEzMjhDMTYuNTUxMyAyMC40OTk2IDE2LjI1NCAyMC43OTY5IDE1Ljg4NzIgMjAuNzk2OUMxNS41MjA0IDIwLjc5NjkgMTUuMjIzMSAyMC40OTk2IDE1LjIyMzEgMjAuMTMyOFYxNy43MDlIMTQuNjI1NUMxNC40MzQ0IDE3LjcwOSAxNC4yNTI2IDE3LjYyNjcgMTQuMTI2NSAxNy40ODMxQzE0LjAwMDQgMTcuMzM5NSAxMy45NDIzIDE3LjE0ODUgMTMuOTY3IDE2Ljk1OUwxNC45NjMxIDkuMzIyMzFDMTUuMDA2MiA4Ljk5MTU3IDE1LjI4OCA4Ljc0NDE0IDE1LjYyMTYgOC43NDQxNEgxOC44MDkxQzE5LjE0MjYgOC43NDQxNCAxOS40MjQ0IDguOTkxNTcgMTkuNDY3NiA5LjMyMjMxTDIwLjQ2MzcgMTYuOTU5QzIwLjQ4ODQgMTcuMTQ4NSAyMC40MzAzIDE3LjMzOTUgMjAuMzA0MiAxNy40ODMxWk0xMi42MDAxIDQuNDYwOTRWMjAuMTMyOEMxMi42MDAxIDIwLjQ5OTYgMTIuMzAyOCAyMC43OTY5IDExLjkzNiAyMC43OTY5QzExLjU2OTMgMjAuNzk2OSAxMS4yNzIgMjAuNDk5NiAxMS4yNzIgMjAuMTMyOFY0LjQ2MDk0QzExLjI3MiA0LjA5NDE4IDExLjU2OTMgMy43OTY4OCAxMS45MzYgMy43OTY4OEMxMi4zMDI4IDMuNzk2ODggMTIuNjAwMSA0LjA5NDE4IDEyLjYwMDEgNC40NjA5NFpNMTcuMjQ4NSA3Ljc4MTI1QzE4LjM0NyA3Ljc4MTI1IDE5LjI0MDcgNi44ODc1NSAxOS4yNDA3IDUuNzg5MDZDMTkuMjQwNyA0LjY5MDU3IDE4LjM0NyAzLjc5Njg4IDE3LjI0ODUgMy43OTY4OEMxNi4xNSAzLjc5Njg4IDE1LjI1NjMgNC42OTA1NyAxNS4yNTYzIDUuNzg5MDZDMTUuMjU2MyA2Ljg4NzU1IDE2LjE1IDcuNzgxMjUgMTcuMjQ4NSA3Ljc4MTI1Wk0xNy4yNDg1IDUuMTI1QzE3LjYxNDcgNS4xMjUgMTcuOTEyNiA1LjQyMjkgMTcuOTEyNiA1Ljc4OTA2QzE3LjkxMjYgNi4xNTUyMyAxNy42MTQ3IDYuNDUzMTIgMTcuMjQ4NSA2LjQ1MzEyQzE2Ljg4MjQgNi40NTMxMiAxNi41ODQ1IDYuMTU1MjMgMTYuNTg0NSA1Ljc4OTA2QzE2LjU4NDUgNS40MjI5IDE2Ljg4MjQgNS4xMjUgMTcuMjQ4NSA1LjEyNVoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const turnstile$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjExOTM4IDQuMDY2NzhDMi4xMTkzOCAzLjU4NjI5IDIuNTA4OSAzLjE5Njc4IDIuOTg5MzggMy4xOTY3OEg2LjQ0OTM4QzYuOTI5ODcgMy4xOTY3OCA3LjMxOTM4IDMuNTg2MjkgNy4zMTkzOCA0LjA2Njc4VjYuOTQ2NzhIMTQuMTE5NEMxNC44MDk3IDYuOTQ2NzggMTQuODE5NCA3LjQwNjQyIDE0LjgxOTQgOC4wOTY3OEMxNC44MTk0IDguNzg3MTMgMTQuODA5NyA5LjE5Njc4IDE0LjExOTQgOS4xOTY3OEg5LjExOTM4TDExLjgxMjggMTMuNjk2OEMxMi4xOTU3IDE0LjI3MTIgMTIuMDQzNSAxNC41MDcyIDExLjQ2OTEgMTQuODkwMkMxMC44OTQ3IDE1LjI3MzEgMTAuNDYyMyAxNS40NjQ2IDEwLjA3OTMgMTQuODkwMkw3LjMxOTM4IDEwLjc1MDJWMjAuNTI2OEM3LjMxOTM4IDIxLjAwNzMgNi45Mjk4NyAyMS4zOTY4IDYuNDQ5MzggMjEuMzk2OEgyLjk4OTM4QzIuNTA4OSAyMS4zOTY4IDIuMTE5MzggMjEuMDA3MyAyLjExOTM4IDIwLjUyNjhWNC4wNjY3OFpNMy44MTkzOCA0Ljg5Njc4VjE5LjY5NjhINS42MTkzOFY0Ljg5Njc4SDMuODE5MzhaIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC40NSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjYxOTQgNC4wNjY3OEMxNi42MTk0IDMuNTg2MjkgMTcuMDA4OSAzLjE5Njc4IDE3LjQ4OTQgMy4xOTY3OEgyMC45NDk0QzIxLjQyOTkgMy4xOTY3OCAyMS44MTk0IDMuNTg2MjkgMjEuODE5NCA0LjA2Njc4VjIwLjUyNjhDMjEuODE5NCAyMS4wMDczIDIxLjQyOTkgMjEuMzk2OCAyMC45NDk0IDIxLjM5NjhIMTcuNDg5NEMxNy4wMDg5IDIxLjM5NjggMTYuNjE5NCAyMS4wMDczIDE2LjYxOTQgMjAuNTI2OFY0LjA2Njc4Wk0xOC4zMTk0IDQuODk2NzhWMTkuNjk2OEgyMC4xMTk0VjQuODk2NzhIMTguMzE5NFoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjQ1Ii8+Cjwvc3ZnPgo=";
const IconUrls = {
  // Entity Icons
  venue: VenueIcon$1,
  building: BuildingIcon$1,
  unknown: Undefined$1,
  directionLeaf: DirectionLeaf$1,
  moreLight: MoreLight$1,
  more: MoreDark$1,
  filter: FilterDark$1,
  filterLight: FilterLight$1,
  calendarDark: CalendarDark$1,
  calendarLight: CalendarLight$1,
  next: Next$1,
  superNext: SuperNext$1,
  prev: Prev$1,
  superPrev: SuperPrev$1,
  venueDark: VenueDark$1,
  agentDark: AgentDark$1,
  mappedLocationDark: MappedLocatonDark$1,
  unMappedLocatonDark: UnMappedLocatonDark$1,
  detailsDark: DetailsDark$1,
  worldDark: WorldDark$1,
  venueLight: VenueLight$1,
  agentLight: AgentLight$1,
  mappedLocatonLight: MappedLocatonLight$1,
  unMappedLocatonLight: UnMappedLocatonLight$1,
  detailsLight: DetailsLight$1,
  worldLight: WorldLight$1,
  boxRotateAnchor: BoxRotateAnchor$1,
  boxPointAnchor: BoxPointAnchor$1,
  drag: Drag$1,
  pen: Pen$1,
  locationDark: LocationDark$1,
  penToolDark: PenToolDark$1,
  penToolDisable: PenToolDisable$1,
  projectSearch: ProjectSearch$1,
  projectList: ProjectList$1,
  import: Import$1,
  fileDoc: FileDoc$1,
  strokeWidth: strokeWidth$1,
  compass: Compass$1,
  mouseCursor: MouseCursor$1,
  arrowCursor: ArrowCursor$1,
  allDirection: AllDirection$1,
  penDrawTool: PenDrawTool$1,
  lineDrawTool: LineDrawTool$1,
  rectangleDrawTool: ReactangleDrawTool$1,
  circleDrawTool: CircleDrawTool$1,
  measureDraw: MeasureDraw$1,
  export: Export$1,
  pointData: PointData$1,
  lineData: LineData$1,
  polygonData: PolygonData$1,
  rasterData: RasterData$1,
  region: Region$1,
  venue2: Venue$1,
  building2: Building$1,
  level: Level$1,
  zone: Zone$1,
  dot: Dot$1,
  country: Country$1,
  market: Market$1,
  cluster: Cluster$1,
  search: Search$1,
  polygon: Polygon$1$1,
  cpe,
  floor,
  infrastructure,
  scanner,
  gps,
  inspect,
  UserDevices: {
    arvr,
    laptop,
    phone,
    sensors,
    smartToy,
    vehicle
  },
  Structures: {
    cellTower: cellTower$1,
    cloud: cloud$1,
    dns: dns$1,
    elevator: structureElevator$1,
    fiberCabinet: fiberCabinet$1,
    fiberPedestal: fiberPedestal$1,
    flowerpot: flowerpot$1,
    hardDriver: hardDriver$1,
    structureBuilding: structureBuilding$1,
    latticeTower: latticeTower$1,
    gasStation: gasStation$1,
    stadium: stadium$1,
    stairs: structureStairs$1,
    structures: structures$1,
    tower: tower$1,
    waterTower: waterTower$1,
    otherTowers: otherTowers$1,
    cbsd: cbsd$1,
    emergencyTruck: emergencyTruck$1,
    escalator: escalator$1,
    idf: idf$1,
    mdf: mdf$1,
    mines: mines$1,
    monopole: monopole$1,
    singleLevelBuilding: singleLevelBuilding$1,
    multiLevelBuilding: multiLevelBuilding$1,
    multiBuildings: multiBuildings$1,
    otherBuildings: otherBuildings$1,
    oilRigs: oilRigs$1,
    parking: parking$1,
    podium: podium$1,
    ramp: ramp$1,
    restRoom: restRoom$1,
    turnstile: turnstile$1
  }
};
function SvgDataUrlToReact({
  dataUrl
}) {
  const [svgContent, setSvgContent] = useState("");
  useEffect(() => {
    if (!dataUrl)
      return;
    const base64Data = dataUrl.split(",")[1];
    const svgMarkup = atob(base64Data);
    setSvgContent(svgMarkup);
  }, [dataUrl]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      dangerouslySetInnerHTML: {
        __html: svgContent
      },
      style: {
        width: "100%",
        height: "100%"
      }
    }
  );
}
SvgDataUrlToReact.propTypes = {
  dataUrl: PropTypes.string
};
SvgDataUrlToReact.defaultProps = {
  dataUrl: ""
};
class IconHelper {
  static svg2Icon(Svg) {
    return function SvgIcon(props) {
      return /* @__PURE__ */ jsx(Icon, { component: Svg, style: {
        fontSize: "16px"
      }, ...props });
    };
  }
  static svgDataUrl2Icon(dataUrl) {
    function Svg(props) {
      return /* @__PURE__ */ jsx(SvgDataUrlToReact, { dataUrl, ...props });
    }
    return IconHelper.svg2Icon(Svg);
  }
  static img2Icon(src2) {
    function Component2(prop) {
      const {
        style: style2
      } = prop || {};
      const {
        fontSize = 14,
        ...restStyle
      } = style2 || {};
      return /* @__PURE__ */ jsx("img", { width: fontSize, height: fontSize, src: src2, alt: "icon", style: restStyle });
    }
    return function ImgIcon(props) {
      return /* @__PURE__ */ jsx(Icon, { component: Component2, ...props });
    };
  }
}
const SvgDragIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 16, viewBox: "0 0 8 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 4H6", stroke: "currentColor", strokeOpacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M2 8H6", stroke: "currentColor", strokeOpacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M2 12H6", stroke: "currentColor", strokeOpacity: 1 }));
const Drag = SvgDragIcon;
const SvgPen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_3754_90581)" }, /* @__PURE__ */ React.createElement("path", { d: "M16 21.8333L21.8333 16L24.3333 18.5L18.5 24.3333L16 21.8333Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21.0013 16.8346L19.7513 10.5846L7.66797 7.66797L10.5846 19.7513L16.8346 21.0013L21.0013 16.8346Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.66797 7.66797L13.9896 13.9896", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15.1667 16.8333C16.0871 16.8333 16.8333 16.0871 16.8333 15.1667C16.8333 14.2462 16.0871 13.5 15.1667 13.5C14.2462 13.5 13.5 14.2462 13.5 15.1667C13.5 16.0871 14.2462 16.8333 15.1667 16.8333Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_3754_90581" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "currentColor", transform: "translate(6 6)" }))));
const Pen = SvgPen;
const SvgLocation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M3.3335 8.45258C3.3335 4.70473 6.31826 1.6665 10.0002 1.6665C13.6821 1.6665 16.6668 4.70473 16.6668 8.45258C16.6668 12.1711 14.5391 16.5102 11.2193 18.0619C10.4454 18.4236 9.55495 18.4236 8.78105 18.0619C5.46127 16.5102 3.3335 12.1711 3.3335 8.45258Z", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 8.3335, r: 2.5, stroke: "currentColor", strokeWidth: 1.5 }));
const LocationDark = SvgLocation;
const SvgPenTool = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 15.8333L15.8333 10L18.3333 12.5L12.5 18.3333L10 15.8333Z", stroke: "rgba(29, 104, 209, 1)", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.66663 1.66669L13.75 4.58335L15 10.8334L10.8333 15L4.58329 13.75L1.66663 1.66669ZM1.66663 1.66669L7.98829 7.98835", stroke: "rgba(29, 104, 209, 1)", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9.16667 10.8333C10.0871 10.8333 10.8333 10.0871 10.8333 9.16667C10.8333 8.24619 10.0871 7.5 9.16667 7.5C8.24619 7.5 7.5 8.24619 7.5 9.16667C7.5 10.0871 8.24619 10.8333 9.16667 10.8333Z", stroke: "rgba(29, 104, 209, 1)", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
const PenToolDark = SvgPenTool;
const SvgPenToolDisable = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 15.8333L15.8333 10L18.3333 12.5L12.5 18.3333L10 15.8333Z", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.66663 1.66669L13.75 4.58335L15 10.8334L10.8333 15L4.58329 13.75L1.66663 1.66669ZM1.66663 1.66669L7.98829 7.98835", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9.16667 10.8333C10.0871 10.8333 10.8333 10.0871 10.8333 9.16667C10.8333 8.24619 10.0871 7.5 9.16667 7.5C8.24619 7.5 7.5 8.24619 7.5 9.16667C7.5 10.0871 8.24619 10.8333 9.16667 10.8333Z", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
const PenToolDisable = SvgPenToolDisable;
const SvgProjectSearch = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_6677_67779)" }, /* @__PURE__ */ React.createElement("circle", { opacity: 0.5, cx: 9.16797, cy: 9.16602, r: 7.5, stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M18.1754 17.4796C18.1231 17.5585 18.0287 17.653 17.8399 17.8418C17.651 18.0307 17.5566 18.1251 17.4777 18.1773C17.0155 18.4834 16.3903 18.3256 16.1286 17.837C16.084 17.7536 16.0456 17.6256 15.969 17.3698C15.8852 17.0903 15.8433 16.9505 15.8352 16.8521C15.7876 16.273 16.2711 15.7895 16.8502 15.8372C16.9486 15.8453 17.0883 15.8872 17.3679 15.9709C17.6237 16.0476 17.7516 16.0859 17.835 16.1306C18.3237 16.3923 18.4814 17.0175 18.1754 17.4796Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_6677_67779" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "currentColor" }))));
const ProjectSearch = SvgProjectSearch;
const SvgProjectList = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5740_100250)" }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M5.83464 10H5.0013C3.42995 10 2.64428 10 2.15612 10.4882C1.66797 10.9763 1.66797 11.762 1.66797 13.3333V15C1.66797 16.5713 1.66797 17.357 2.15612 17.8452C2.64428 18.3333 3.42995 18.3333 5.0013 18.3333H6.66797C8.23932 18.3333 9.02499 18.3333 9.51315 17.8452C10.0013 17.357 10.0013 16.5713 10.0013 15V14.1667", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9.9987 5.83398H9.16536C7.59402 5.83398 6.80834 5.83398 6.32019 6.32214C5.83203 6.8103 5.83203 7.59597 5.83203 9.16732V10.834C5.83203 12.4053 5.83203 13.191 6.32019 13.6792C6.80834 14.1673 7.59402 14.1673 9.16536 14.1673H10.832C12.4034 14.1673 13.1891 14.1673 13.6772 13.6792C14.1654 13.191 14.1654 12.4053 14.1654 10.834V10.0007", stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 4.99935C10 3.428 10 2.64233 10.4882 2.15417C10.9763 1.66602 11.762 1.66602 13.3333 1.66602H15C16.5713 1.66602 17.357 1.66602 17.8452 2.15417C18.3333 2.64233 18.3333 3.428 18.3333 4.99935V6.66602C18.3333 8.23736 18.3333 9.02304 17.8452 9.51119C17.357 9.99935 16.5713 9.99935 15 9.99935H13.3333C11.762 9.99935 10.9763 9.99935 10.4882 9.51119C10 9.02304 10 8.23736 10 6.66602V4.99935Z", stroke: "currentColor", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5740_100250" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 5, fill: "currentColor" }))));
const ProjectList = SvgProjectList;
const SvgImport = (props) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 20, viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M14.668 7.50195C16.4805 7.51204 17.4621 7.59242 18.1024 8.23274C18.8346 8.96497 18.8346 10.1435 18.8346 12.5005V13.3338C18.8346 15.6909 18.8346 16.8694 18.1024 17.6016C17.3702 18.3338 16.1917 18.3338 13.8346 18.3338H7.16797C4.81095 18.3338 3.63243 18.3338 2.9002 17.6016C2.16797 16.8694 2.16797 15.6909 2.16797 13.3338L2.16797 12.5005C2.16797 10.1435 2.16797 8.96497 2.9002 8.23274C3.54052 7.59242 4.52211 7.51204 6.33464 7.50195", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5 12.5L10.5 1.66667M10.5 1.66667L13 4.58333M10.5 1.66667L8 4.58333", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const Import = SvgImport;
const SvgDocIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { filter: "url(#filter0_ii_5643_145925)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.33255 2.66602C6.15434 2.66602 5.19922 3.62114 5.19922 4.79935V27.1994C5.19922 28.3776 6.15435 29.3327 7.33255 29.3327H24.6659C25.8441 29.3327 26.7992 28.3776 26.7992 27.1994V9.33267L20.1326 2.66606H24.6792C24.6748 2.66603 24.6703 2.66602 24.6659 2.66602H7.33255Z", fill: "#E9342E" })), /* @__PURE__ */ React.createElement("path", { d: "M20.3308 20.6251C19.431 20.5583 18.5647 20.2241 17.8648 19.6226C16.4985 19.9233 15.1987 20.3576 13.899 20.8925C12.866 22.7303 11.8995 23.666 11.0663 23.666C10.8997 23.666 10.6998 23.6326 10.5665 23.5323C10.1998 23.3653 10 22.9976 10 22.6301C10 22.3293 10.0667 21.494 13.2325 20.1238C13.9658 18.7871 14.5322 17.4171 14.9988 15.9803C14.5988 15.1783 13.7325 13.2066 14.3322 12.2043C14.5322 11.8366 14.9322 11.6361 15.3655 11.6696C15.6987 11.6696 16.0318 11.8366 16.2318 12.104C16.6652 12.7055 16.6318 13.9753 16.0652 15.8466C16.5985 16.8477 17.297 17.7515 18.1313 18.52C18.8313 18.3861 19.531 18.286 20.2308 18.286C21.7972 18.3193 22.0305 19.0545 21.9972 19.489C21.9972 20.6251 20.8973 20.6251 20.3308 20.6251ZM10.9998 22.6968L11.0998 22.6635C11.5663 22.4965 11.9328 22.1623 12.1995 21.7278C11.6995 21.9283 11.2997 22.2625 10.9998 22.697V22.6968ZM15.432 12.6721H15.332C15.2987 12.6721 15.232 12.6721 15.1987 12.7055C15.0653 13.2735 15.1653 13.875 15.3987 14.4096C15.5987 13.8416 15.5987 13.2401 15.432 12.6721ZM15.6653 17.5175L15.632 17.5841L15.5987 17.5508C15.2987 18.3195 14.9653 19.088 14.5988 19.8231L14.6655 19.7898V19.8565C15.4066 19.5878 16.1634 19.3646 16.9317 19.1881L16.8983 19.1548H16.9983C16.4983 18.6535 16.0318 18.0855 15.6653 17.5175ZM20.1975 19.2885C19.8975 19.2885 19.631 19.2885 19.331 19.3551C19.6643 19.5223 19.9977 19.5891 20.3308 19.6226C20.5642 19.656 20.7975 19.6226 20.9973 19.5558C20.9973 19.4555 20.864 19.2885 20.1975 19.2885Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M26.174 8.70898H20.7578L26.7995 14.7507L26.7995 9.33398L26.174 8.70898Z", fill: "url(#paint0_linear_5643_145925)" }), /* @__PURE__ */ React.createElement("path", { d: "M22.2674 9.33398L26.8008 9.33398L20.1341 2.66732L20.1341 7.20065C20.1341 8.37886 21.0892 9.33398 22.2674 9.33398Z", fill: "#FDB8B8" }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("filter", { id: "filter0_ii_5643_145925", x: 5.19922, y: 2.53268, width: 21.6016, height: 26.9327, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: -0.266667 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 0.0666667 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_5643_145925" }), /* @__PURE__ */ React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React.createElement("feOffset", { dy: 0.266667 }), /* @__PURE__ */ React.createElement("feGaussianBlur", { stdDeviation: 0.0666667 }), /* @__PURE__ */ React.createElement("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }), /* @__PURE__ */ React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0" }), /* @__PURE__ */ React.createElement("feBlend", { mode: "normal", in2: "effect1_innerShadow_5643_145925", result: "effect2_innerShadow_5643_145925" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_5643_145925", x1: 22.112, y1: 7.35482, x2: 28.1536, y2: 13.3965, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopOpacity: 0.2 }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopOpacity: 0 }))));
const FileDoc = SvgDocIcon;
const SvgStrokeWidth = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5843_112959)" }, /* @__PURE__ */ React.createElement("path", { d: "M3 7.5H21V8.25H3V7.5Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M3 10.5H21V12H3V10.5Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M3 15H21V17.25H3V15Z", fill: "currentColor" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5843_112959" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "currentColor" }))));
const strokeWidth = SvgStrokeWidth;
const SvgCompass = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5918_158311)" }, /* @__PURE__ */ React.createElement("circle", { opacity: 0.5, cx: 10.0013, cy: 10.0013, r: 8.33333, stroke: "currentColor", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10.8538 12.1339C8.92898 12.9038 7.96657 13.2888 7.41686 12.9152C7.28652 12.8267 7.1741 12.7143 7.08554 12.5839C6.71199 12.0342 7.09695 11.0718 7.86688 9.14698C8.0311 8.73642 8.11321 8.53114 8.25444 8.3701C8.29042 8.32906 8.32906 8.29042 8.3701 8.25444C8.53114 8.11321 8.73642 8.0311 9.14698 7.86688C11.0718 7.09695 12.0342 6.71199 12.5839 7.08554C12.7143 7.1741 12.8267 7.28652 12.9152 7.41686C13.2888 7.96657 12.9038 8.92898 12.1339 10.8538C11.9697 11.2643 11.8876 11.4696 11.7463 11.6307C11.7104 11.6717 11.6717 11.7104 11.6307 11.7463C11.4696 11.8876 11.2643 11.9697 10.8538 12.1339Z", stroke: "currentColor", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5918_158311" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "currentColor" }))));
const Compass = SvgCompass;
const SvgMouse = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.59595 3.85521L13.2352 5.56442C13.8766 5.80067 14.4233 6.00206 14.8197 6.21873C15.235 6.44573 15.6287 6.76514 15.747 7.30366C15.8652 7.84218 15.6417 8.29715 15.3597 8.67728C15.0906 9.04013 14.6786 9.45208 14.1953 9.93535L13.6003 10.5304L16.4538 13.3839C16.6121 13.5422 16.7525 13.6826 16.8614 13.8074C16.9771 13.9401 17.0879 14.0888 17.1639 14.2724C17.3321 14.6783 17.3321 15.1343 17.1639 15.5401C17.0879 15.7238 16.9771 15.8724 16.8614 16.0051C16.7525 16.13 16.6121 16.2703 16.4538 16.4286L16.4266 16.4558C16.2683 16.6141 16.128 16.7544 16.0031 16.8633C15.8704 16.9791 15.7218 17.0898 15.5382 17.1659C15.1323 17.334 14.6763 17.334 14.2704 17.1659C14.0868 17.0898 13.9382 16.9791 13.8055 16.8633C13.6806 16.7544 13.5403 16.614 13.3819 16.4557L10.5284 13.6022L9.9334 14.1972C9.45013 14.6805 9.03818 15.0925 8.67533 15.3617C8.2952 15.6436 7.84022 15.8672 7.3017 15.7489C6.76318 15.6306 6.44378 15.237 6.21678 14.8217C6.00011 14.4253 5.79872 13.8786 5.56247 13.2372L3.85326 8.5979C3.36919 7.28407 2.98137 6.23146 2.80929 5.42061C2.63745 4.61092 2.6276 3.80622 3.21593 3.21789C3.80426 2.62956 4.60896 2.6394 5.41865 2.81124C6.2295 2.98332 7.28211 3.37114 8.59595 3.85521ZM5.15915 4.03401C4.43577 3.88049 4.21145 3.99014 4.09982 4.10177C3.98819 4.2134 3.87853 4.43772 4.03205 5.1611C4.18305 5.87262 4.53774 6.83999 5.04542 8.21797L6.71841 12.759C6.97641 13.4592 7.14681 13.917 7.31362 14.2221C7.47007 14.5084 7.55163 14.5244 7.5684 14.5277C7.56895 14.5278 7.56944 14.5279 7.56986 14.528C7.57027 14.5281 7.57075 14.5282 7.57131 14.5284C7.58791 14.5324 7.66869 14.552 7.93068 14.3577C8.21003 14.1505 8.55656 13.8063 9.08427 13.2786L10.0865 12.2764C10.3306 12.0323 10.7263 12.0323 10.9704 12.2764L14.2523 15.5583C14.4282 15.7343 14.5383 15.8438 14.6272 15.9213C14.7118 15.9951 14.7429 16.0086 14.7488 16.0111C14.8484 16.0523 14.9603 16.0523 15.0598 16.0111C15.0658 16.0086 15.0969 15.9951 15.1815 15.9213C15.2703 15.8438 15.3804 15.7343 15.5563 15.5583C15.7323 15.3823 15.8419 15.2723 15.9194 15.1834C15.9932 15.0988 16.0066 15.0677 16.0091 15.0618C16.0503 14.9622 16.0503 14.8503 16.0091 14.7507C16.0066 14.7448 15.9932 14.7137 15.9194 14.6291C15.8419 14.5403 15.7323 14.4302 15.5563 14.2542L12.2744 10.9723C12.0303 10.7282 12.0303 10.3325 12.2744 10.0884L13.2766 9.08622C13.8043 8.55851 14.1485 8.21199 14.3557 7.93263C14.55 7.67065 14.5304 7.58987 14.5264 7.57326C14.5263 7.57271 14.5262 7.57223 14.5261 7.57181C14.526 7.57139 14.5259 7.57091 14.5258 7.57035C14.5225 7.55358 14.5064 7.47202 14.2202 7.31558C13.915 7.14876 13.4573 6.97837 12.757 6.72037L8.21603 5.04738C6.83804 4.5397 5.87067 4.18501 5.15915 4.03401Z" }));
const MouseCursor = SvgMouse;
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 13, viewBox: "0 0 13 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0.158203 0.158203L11.9077 3.67555C12.2805 3.78717 12.2905 4.31152 11.9222 4.43729L6.34254 6.34254L4.43729 11.9222C4.31152 12.2905 3.78717 12.2805 3.67555 11.9077L0.158203 0.158203ZM1.70765 1.70765L4.0988 9.69511L5.52332 5.52332L9.69511 4.0988L1.70765 1.70765Z", fill: "currentColor", fillOpacity: 0.85 }));
const ArrowCursor = SvgArrow;
const SvgAllScroll = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.4232 1.24188C10.3107 1.12952 10.1582 1.06641 9.99921 1.06641C9.84021 1.06641 9.68771 1.12952 9.57521 1.24188L7.24188 3.57521C7.18293 3.63014 7.13565 3.69638 7.10285 3.76998C7.07006 3.84358 7.05243 3.92303 7.05101 4.00359C7.04958 4.08416 7.0644 4.16418 7.09458 4.23889C7.12476 4.3136 7.16967 4.38147 7.22665 4.43844C7.28362 4.49542 7.35149 4.54033 7.4262 4.57051C7.50091 4.60069 7.58093 4.61551 7.6615 4.61408C7.74206 4.61266 7.82151 4.59503 7.89511 4.56224C7.96871 4.52944 8.03495 4.48216 8.08988 4.42321L9.33255 3.18054V7.33255C9.33255 7.50936 9.40278 7.67893 9.52781 7.80395C9.65283 7.92897 9.8224 7.99921 9.99921 7.99921C10.176 7.99921 10.3456 7.92897 10.4706 7.80395C10.5956 7.67893 10.6659 7.50936 10.6659 7.33255V3.18054L11.9085 4.42321C12.0223 4.5292 12.1727 4.58689 12.3282 4.58415C12.4836 4.58141 12.6319 4.51844 12.7418 4.40851C12.8518 4.29858 12.9147 4.15027 12.9175 3.99483C12.9202 3.83939 12.8625 3.68895 12.7565 3.57521L10.4232 1.24188ZM10.6659 12.6659C10.6659 12.4891 10.5956 12.3195 10.4706 12.1945C10.3456 12.0694 10.176 11.9992 9.99921 11.9992C9.8224 11.9992 9.65283 12.0694 9.52781 12.1945C9.40278 12.3195 9.33255 12.4891 9.33255 12.6659V16.8179L8.08988 15.5752C7.97614 15.4692 7.8257 15.4115 7.67026 15.4143C7.51482 15.417 7.36651 15.48 7.25658 15.5899C7.14665 15.6998 7.08368 15.8482 7.08094 16.0036C7.0782 16.159 7.13589 16.3095 7.24188 16.4232L9.57521 18.7565C9.68771 18.8689 9.84021 18.932 9.99921 18.932C10.1582 18.932 10.3107 18.8689 10.4232 18.7565L12.7565 16.4232C12.8625 16.3095 12.9202 16.159 12.9175 16.0036C12.9147 15.8482 12.8518 15.6998 12.7418 15.5899C12.6319 15.48 12.4836 15.417 12.3282 15.4143C12.1727 15.4115 12.0223 15.4692 11.9085 15.5752L10.6659 16.8179V12.6659ZM11.9992 9.99921C11.9992 9.8224 12.0694 9.65283 12.1945 9.52781C12.3195 9.40278 12.4891 9.33255 12.6659 9.33255H16.8179L15.5752 8.08988C15.4692 7.97614 15.4115 7.8257 15.4143 7.67026C15.417 7.51482 15.48 7.36651 15.5899 7.25658C15.6998 7.14665 15.8482 7.08368 16.0036 7.08094C16.159 7.0782 16.3095 7.13589 16.4232 7.24188L18.7565 9.57521C18.8689 9.68771 18.932 9.84021 18.932 9.99921C18.932 10.1582 18.8689 10.3107 18.7565 10.4232L16.4232 12.7565C16.3095 12.8625 16.159 12.9202 16.0036 12.9175C15.8482 12.9147 15.6998 12.8518 15.5899 12.7418C15.48 12.6319 15.417 12.4836 15.4143 12.3282C15.4115 12.1727 15.4692 12.0223 15.5752 11.9085L16.8179 10.6659H12.6659C12.4891 10.6659 12.3195 10.5956 12.1945 10.4706C12.0694 10.3456 11.9992 10.176 11.9992 9.99921ZM4.42321 8.08988L3.18054 9.33255H7.33255C7.50936 9.33255 7.67893 9.40278 7.80395 9.52781C7.92897 9.65283 7.99921 9.8224 7.99921 9.99921C7.99921 10.176 7.92897 10.3456 7.80395 10.4706C7.67893 10.5956 7.50936 10.6659 7.33255 10.6659H3.18054L4.42321 11.9085C4.5292 12.0223 4.58689 12.1727 4.58415 12.3282C4.58141 12.4836 4.51844 12.6319 4.40851 12.7418C4.29858 12.8518 4.15027 12.9147 3.99483 12.9175C3.83939 12.9202 3.68895 12.8625 3.57521 12.7565L1.24188 10.4232C1.12952 10.3107 1.06641 10.1582 1.06641 9.99921C1.06641 9.84021 1.12952 9.68771 1.24188 9.57521L3.57521 7.24188C3.63014 7.18293 3.69638 7.13565 3.76998 7.10285C3.84358 7.07006 3.92303 7.05243 4.00359 7.05101C4.08416 7.04958 4.16418 7.0644 4.23889 7.09458C4.3136 7.12476 4.38147 7.16967 4.43844 7.22665C4.49542 7.28362 4.54033 7.35149 4.57051 7.4262C4.60069 7.50091 4.61551 7.58093 4.61408 7.6615C4.61266 7.74206 4.59503 7.82151 4.56224 7.89511C4.52944 7.96871 4.48216 8.03495 4.42321 8.08988Z" }));
const AllDirection = SvgAllScroll;
const SvgPenDraw = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1199 9.71789L12.9502 7.54818C12.794 7.39197 12.5408 7.39197 12.3846 7.54818L12.3201 7.61267L11.5457 3.74072C11.4846 3.43526 11.2517 3.19304 10.9489 3.11995L0.628906 0.628906L3.11995 10.9489C3.19304 11.2517 3.43526 11.4846 3.74072 11.5457L7.61267 12.3201L7.54818 12.3846C7.39197 12.5408 7.39197 12.794 7.54818 12.9502L9.71789 15.1199C9.8741 15.2762 10.1274 15.2762 10.2836 15.1199L15.1199 10.2836C15.2762 10.1274 15.2762 9.8741 15.1199 9.71789ZM8.73612 12.6674L10.0007 13.932L13.932 10.0007L12.6674 8.73612L8.73612 12.6674ZM4.09495 10.5559L2.27318 3.00857L5.70825 6.44364C5.87819 6.13401 6.13401 5.87819 6.44364 5.70825L3.00857 2.27318L10.5559 4.09495L11.4362 8.49647L8.49647 11.4362L4.09495 10.5559Z", fill: "currentColor", fillOpacity: 0.85 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.48073 7.33406C5.48073 7.01135 5.56321 6.70789 5.70825 6.44364C5.87819 6.13401 6.13401 5.87819 6.44364 5.70825C6.70789 5.56321 7.01135 5.48073 7.33406 5.48073C8.35763 5.48073 9.1874 6.3105 9.1874 7.33406C9.1874 8.35763 8.35763 9.1874 7.33406 9.1874C6.3105 9.1874 5.48073 8.35763 5.48073 7.33406ZM6.75141 6.76658C6.60866 6.91313 6.52073 7.11333 6.52073 7.33406C6.52073 7.78325 6.88487 8.1474 7.33406 8.1474C7.78325 8.1474 8.1474 7.78325 8.1474 7.33406C8.1474 6.88487 7.78325 6.52073 7.33406 6.52073C7.11333 6.52073 6.91313 6.60866 6.76658 6.75141L6.75908 6.75908L6.75141 6.76658Z", fill: "currentColor", fillOpacity: 0.85 }));
const PenDrawTool = SvgPenDraw;
const SvgLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5881_174867)" }, /* @__PURE__ */ React.createElement("line", { x1: 19.5001, y1: 2.55893, x2: 0.500096, y2: 19.5589, stroke: "currentColor", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5881_174867" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "currentColor" }))));
const LineDrawTool = SvgLine;
const SvgRectangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.75 0.75H1.25C0.973437 0.75 0.75 0.973437 0.75 1.25V12.75C0.75 13.0266 0.973437 13.25 1.25 13.25H12.75C13.0266 13.25 13.25 13.0266 13.25 12.75V1.25C13.25 0.973437 13.0266 0.75 12.75 0.75ZM12.125 12.125H1.875V1.875H12.125V12.125Z", fill: "currentColor", fillOpacity: 0.85 }));
const ReactangleDrawTool = SvgRectangle;
const SvgCircleTool = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_5881_174872)" }, /* @__PURE__ */ React.createElement("path", { d: "M18.3346 9.99935C18.3346 14.6017 14.6037 18.3327 10.0013 18.3327C5.39893 18.3327 1.66797 14.6017 1.66797 9.99935C1.66797 5.39698 5.39893 1.66602 10.0013 1.66602C14.6037 1.66602 18.3346 5.39698 18.3346 9.99935Z", stroke: "currentColor", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_5881_174872" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "currentColor" }))));
const CircleDrawTool = SvgCircleTool;
const SvgMeasure = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 14, viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.125 12.0625H0.875C0.80625 12.0625 0.75 12.1187 0.75 12.1875V13.125C0.75 13.1938 0.80625 13.25 0.875 13.25H11.125C11.1938 13.25 11.25 13.1938 11.25 13.125V12.1875C11.25 12.1187 11.1938 12.0625 11.125 12.0625ZM11.125 0.75H0.875C0.80625 0.75 0.75 0.80625 0.75 0.875V1.8125C0.75 1.88125 0.80625 1.9375 0.875 1.9375H11.125C11.1938 1.9375 11.25 1.88125 11.25 1.8125V0.875C11.25 0.80625 11.1938 0.75 11.125 0.75ZM7.54375 4.90625C7.6375 4.90625 7.69063 4.79688 7.63281 4.72344L6.05781 2.72969C6.04739 2.7162 6.03401 2.70527 6.01871 2.69776C6.0034 2.69024 5.98658 2.68634 5.96953 2.68634C5.95248 2.68634 5.93566 2.69024 5.92036 2.69776C5.90505 2.70527 5.89167 2.7162 5.88125 2.72969L4.30625 4.72344C4.29313 4.74012 4.28497 4.76016 4.28271 4.78126C4.28045 4.80237 4.28419 4.82368 4.29348 4.84276C4.30278 4.86184 4.31726 4.87791 4.33527 4.88914C4.35328 4.90037 4.37409 4.9063 4.39531 4.90625H5.4375V9.09375H4.45625C4.3625 9.09375 4.30938 9.20312 4.36719 9.27656L5.94219 11.2688C5.9875 11.3266 6.075 11.3266 6.11875 11.2688L7.69375 9.27656C7.75156 9.20312 7.7 9.09375 7.60469 9.09375H6.5625V4.90625H7.54375Z", fill: "currentColor", fillOpacity: 0.85 }));
const MeasureDraw = SvgMeasure;
const SvgExport = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.4613 13.7551C10.3429 13.8846 10.1755 13.9583 10 13.9583C9.82453 13.9583 9.65714 13.8846 9.53873 13.7551L6.2054 10.1092C5.97248 9.85448 5.99019 9.45915 6.24494 9.22623C6.49969 8.99332 6.89502 9.01102 7.12794 9.26577L9.375 11.7235V2.5C9.375 2.15482 9.65482 1.875 10 1.875C10.3452 1.875 10.625 2.15482 10.625 2.5V11.7235L12.8721 9.26577C13.105 9.01102 13.5003 8.99332 13.7551 9.22623C14.0098 9.45915 14.0275 9.85448 13.7946 10.1092L10.4613 13.7551Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M3.125 12.5C3.125 12.1548 2.84518 11.875 2.5 11.875C2.15482 11.875 1.875 12.1548 1.875 12.5V12.5457C1.87498 13.6854 1.87497 14.604 1.9721 15.3265C2.07295 16.0765 2.2887 16.7081 2.79029 17.2097C3.29189 17.7113 3.92345 17.927 4.67354 18.0279C5.39602 18.125 6.31462 18.125 7.45428 18.125H12.5457C13.6854 18.125 14.604 18.125 15.3265 18.0279C16.0766 17.927 16.7081 17.7113 17.2097 17.2097C17.7113 16.7081 17.9271 16.0765 18.0279 15.3265C18.125 14.604 18.125 13.6854 18.125 12.5457V12.5C18.125 12.1548 17.8452 11.875 17.5 11.875C17.1548 11.875 16.875 12.1548 16.875 12.5C16.875 13.6962 16.8737 14.5304 16.789 15.1599C16.7068 15.7714 16.5565 16.0952 16.3258 16.3258C16.0952 16.5565 15.7714 16.7068 15.1599 16.789C14.5304 16.8737 13.6962 16.875 12.5 16.875H7.5C6.30382 16.875 5.46956 16.8737 4.8401 16.789C4.22862 16.7068 3.90481 16.5565 3.67418 16.3258C3.44354 16.0952 3.29317 15.7714 3.21096 15.1599C3.12633 14.5304 3.125 13.6962 3.125 12.5Z", fill: "currentColor" }));
const Export = SvgExport;
const SvgPointData = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 9.5, y: 6, width: 1, height: 12, rx: 0.5, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 5, r: 3, fill: "currentColor" }));
const PointData = SvgPointData;
const SvgLineData = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.76752 13.2325C6.53535 13.0003 6.25973 12.8162 5.95639 12.6905C5.65305 12.5649 5.32793 12.5002 4.9996 12.5002C4.67127 12.5002 4.34615 12.5649 4.04281 12.6905C3.73947 12.8162 3.46385 13.0003 3.23168 13.2325C2.7628 13.7014 2.49939 14.3373 2.49939 15.0004C2.49939 15.6635 2.7628 16.2994 3.23168 16.7683C3.70057 17.2372 4.3365 17.5006 4.9996 17.5006C5.6627 17.5006 6.29864 17.2372 6.76752 16.7683C7.2364 16.2994 7.49981 15.6635 7.49981 15.0004C7.49981 14.3373 7.2364 13.7014 6.76752 13.2325ZM6.76752 13.2325L13.2334 6.76666M13.2334 6.76666C13.4655 6.99883 13.7411 7.18299 14.0445 7.30864C14.3478 7.43429 14.6729 7.49896 15.0013 7.49896C15.3296 7.49896 15.6547 7.43429 15.9581 7.30864C16.2614 7.18299 16.537 6.99883 16.7692 6.76666C17.0013 6.5345 17.1855 6.25888 17.3112 5.95554C17.4368 5.6522 17.5015 5.32708 17.5015 4.99875C17.5015 4.67041 17.4368 4.3453 17.3112 4.04196C17.1855 3.73862 17.0013 3.463 16.7692 3.23083C16.3003 2.76195 15.6644 2.49854 15.0013 2.49854C14.3382 2.49854 13.7022 2.76195 13.2334 3.23083C12.7645 3.69971 12.5011 4.33565 12.5011 4.99875C12.5011 5.66184 12.7645 6.29778 13.2334 6.76666ZM13.2334 6.76666L13.2367 6.76333", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const LineData = SvgLineData;
const SvgPolygonData = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.9086 3.96718C17.6909 3.74938 17.4325 3.57661 17.1481 3.45873C16.8636 3.34085 16.5587 3.28018 16.2508 3.28018C15.9429 3.28018 15.638 3.34085 15.3535 3.45873C15.0691 3.57661 14.8106 3.74938 14.593 3.96718C14.417 4.14297 14.2704 4.3458 14.1586 4.56796L11.7125 3.90077C11.7433 3.42542 11.6284 2.95198 11.3833 2.54353C11.1382 2.13508 10.7745 1.81101 10.3405 1.6145C9.90662 1.41799 9.42311 1.35836 8.95444 1.44356C8.48578 1.52876 8.0542 1.75474 7.7172 2.0914C7.35096 2.45915 7.11671 2.93776 7.051 3.4526C6.98528 3.96743 7.09179 4.48954 7.35392 4.93749L4.51798 7.48984C4.06606 7.15692 3.50986 6.99682 2.95011 7.03852C2.39035 7.08022 1.86402 7.32097 1.46642 7.71718C1.02613 8.14813 0.773226 8.73512 0.762444 9.35112C0.751662 9.96712 0.983864 10.5626 1.4088 11.0087C1.83374 11.4548 2.41725 11.7156 3.03304 11.7348C3.64884 11.7539 4.24741 11.5298 4.69923 11.1109L10.3711 15.2711C10.1922 15.6602 10.1233 16.0908 10.1719 16.5163C10.2205 16.9417 10.3848 17.3458 10.6468 17.6845C10.9089 18.0231 11.2587 18.2836 11.6584 18.4374C12.058 18.5913 12.4921 18.6328 12.9137 18.5573C13.3352 18.4818 13.728 18.2923 14.0494 18.0093C14.3708 17.7263 14.6085 17.3606 14.7367 16.952C14.865 16.5435 14.8788 16.1075 14.7767 15.6916C14.6747 15.2758 14.4606 14.8958 14.1578 14.593C14.0227 14.4576 13.8712 14.3395 13.707 14.2414L15.9289 7.94531C16.0353 7.9601 16.1426 7.96793 16.25 7.96874C16.7134 7.96864 17.1663 7.83119 17.5516 7.57374C17.9369 7.3163 18.2373 6.95042 18.4147 6.52235C18.5921 6.09428 18.6386 5.62322 18.5484 5.1687C18.4582 4.71418 18.2353 4.29661 17.9078 3.96874L17.9086 3.96718ZM8.37735 2.75468C8.57404 2.55806 8.82461 2.42417 9.09738 2.36995C9.37016 2.31573 9.65288 2.3436 9.90982 2.45005C10.1667 2.5565 10.3863 2.73674 10.5408 2.96799C10.6953 3.19924 10.7778 3.4711 10.7778 3.74921C10.7778 4.02732 10.6953 4.29919 10.5408 4.53043C10.3863 4.76168 10.1667 4.94192 9.90982 5.04837C9.65288 5.15482 9.37016 5.1827 9.09738 5.12847C8.82461 5.07425 8.57404 4.94036 8.37735 4.74374C8.24693 4.61295 8.14355 4.45774 8.07312 4.28699C8.00268 4.11623 7.96658 3.93327 7.96687 3.74856C7.96716 3.56385 8.00384 3.38101 8.07481 3.21048C8.14577 3.03995 8.24964 2.88506 8.38048 2.75468H8.37735ZM2.12735 10.3695C1.93073 10.1728 1.79685 9.92227 1.74262 9.6495C1.6884 9.37672 1.71627 9.094 1.82272 8.83706C1.92917 8.58013 2.10942 8.36053 2.34066 8.20603C2.57191 8.05153 2.84377 7.96907 3.12189 7.96907C3.4 7.96907 3.67186 8.05153 3.90311 8.20603C4.13435 8.36053 4.3146 8.58013 4.42105 8.83706C4.5275 9.094 4.55537 9.37672 4.50115 9.6495C4.44692 9.92227 4.31304 10.1728 4.11642 10.3695C3.85278 10.6326 3.49552 10.7804 3.12306 10.7804C2.75059 10.7804 2.39334 10.6326 2.1297 10.3695H2.12735ZM13.4922 17.2445C13.2955 17.4411 13.0449 17.575 12.7722 17.6293C12.4994 17.6835 12.2167 17.6556 11.9597 17.5492C11.7028 17.4427 11.4832 17.2625 11.3287 17.0312C11.1742 16.8 11.0917 16.5281 11.0917 16.25C11.0917 15.9719 11.1742 15.7 11.3287 15.4688C11.4832 15.2375 11.7028 15.0573 11.9597 14.9508C12.2167 14.8444 12.4994 14.8165 12.7722 14.8707C13.0449 14.925 13.2955 15.0588 13.4922 15.2555C13.6231 15.3859 13.727 15.5409 13.798 15.7115C13.8689 15.8821 13.9056 16.0651 13.9058 16.2499C13.906 16.4347 13.8698 16.6177 13.7992 16.7885C13.7287 16.9593 13.6251 17.1145 13.4945 17.2453L13.4922 17.2445ZM12.8195 13.9297C12.48 13.8825 12.1342 13.9104 11.8066 14.0113C11.479 14.1123 11.1775 14.2839 10.9234 14.5141L5.25313 10.3547C5.4104 10.0112 5.48271 9.63486 5.46394 9.25753C5.44518 8.8802 5.3359 8.51292 5.14532 8.18671L7.98126 5.63437C8.25564 5.83724 8.57101 5.97775 8.90534 6.04608C9.23966 6.11441 9.58487 6.10891 9.91685 6.02997C10.2488 5.95103 10.5596 5.80055 10.8273 5.58905C11.0951 5.37755 11.3135 5.11012 11.4672 4.80546L13.9133 5.47265C13.8914 5.80523 13.9407 6.13865 14.0579 6.45066C14.1751 6.76268 14.3575 7.0461 14.593 7.28202C14.7288 7.41722 14.8804 7.53552 15.0445 7.63437L12.8195 13.9297ZM17.243 6.61796C17.0463 6.81458 16.7957 6.94847 16.5229 7.00269C16.2502 7.05692 15.9674 7.02904 15.7105 6.92259C15.4536 6.81614 15.234 6.6359 15.0795 6.40465C14.925 6.17341 14.8425 5.90154 14.8425 5.62343C14.8425 5.34532 14.925 5.07345 15.0795 4.84221C15.234 4.61096 15.4536 4.43072 15.7105 4.32427C15.9674 4.21782 16.2502 4.18994 16.5229 4.24417C16.7957 4.29839 17.0463 4.43228 17.243 4.6289C17.3739 4.75935 17.4778 4.91432 17.5488 5.08495C17.6197 5.25558 17.6564 5.43853 17.6566 5.62334C17.6568 5.80814 17.6206 5.99117 17.55 6.16197C17.4795 6.33277 17.3759 6.48799 17.2453 6.61874L17.243 6.61796Z" }));
const PolygonData = SvgPolygonData;
const SvgRasterData = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.66663 9.99996C1.66663 6.07159 1.66663 4.1074 2.88701 2.88701C4.1074 1.66663 6.07159 1.66663 9.99996 1.66663C13.9283 1.66663 15.8925 1.66663 17.1129 2.88701C18.3333 4.1074 18.3333 6.07159 18.3333 9.99996C18.3333 13.9283 18.3333 15.8925 17.1129 17.1129C15.8925 18.3333 13.9283 18.3333 9.99996 18.3333C6.07159 18.3333 4.1074 18.3333 2.88701 17.1129C1.66663 15.8925 1.66663 13.9283 1.66663 9.99996Z", stroke: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 13.3333, cy: 6.66667, r: 1.66667, stroke: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M1.66663 10.4168L3.12628 9.13963C3.88567 8.47517 5.03019 8.51328 5.7437 9.22679L9.31847 12.8016C9.89116 13.3743 10.7927 13.4523 11.4553 12.9866L11.7038 12.812C12.6573 12.1419 13.9474 12.2195 14.8137 12.9992L17.5 15.4168", stroke: "currentColor", strokeLinecap: "round" }));
const RasterData = SvgRasterData;
const SvgRegion = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_347_46)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.19694 14.2626C4.08268 14.2626 3.98297 14.3401 3.95471 14.4508L2.04518 21.9297C2.00481 22.0878 2.12425 22.2416 2.28741 22.2416H21.7126C21.8758 22.2416 21.9952 22.0878 21.9548 21.9298L20.0453 14.4508C20.017 14.3401 19.9173 14.2626 19.8031 14.2626H18L19 12.7626H19.8031C20.6028 12.7626 21.3008 13.3048 21.4987 14.0797L23.4082 21.5587C23.6908 22.6653 22.8547 23.7416 21.7126 23.7416H2.28741C1.1453 23.7416 0.30926 22.6653 0.5918 21.5587L2.50133 14.0797C2.69918 13.3048 3.39718 12.7626 4.19694 12.7626H5.00001L6.00001 14.2626H4.19694Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.2354 14.7275C15.9294 12.5042 17.3572 9.92734 17.3572 7.7647C17.3572 4.80604 14.9587 2.40756 12 2.40756C9.04134 2.40756 6.64287 4.80604 6.64287 7.7647C6.64287 9.92734 8.07064 12.5042 9.76458 14.7275C10.5734 15.789 11.3856 16.697 12 17.3431C12.6144 16.697 13.4267 15.789 14.2354 14.7275ZM12 19.4622C12 19.4622 18.8572 13.1597 18.8572 7.7647C18.8572 3.97761 15.7871 0.907562 12 0.907562C8.21291 0.907562 5.14286 3.97761 5.14286 7.7647C5.14286 13.1597 12 19.4622 12 19.4622Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 8.98739C12.6753 8.98739 13.2227 8.43998 13.2227 7.7647C13.2227 7.08943 12.6753 6.54202 12 6.54202C11.3247 6.54202 10.7773 7.08943 10.7773 7.7647C10.7773 8.43998 11.3247 8.98739 12 8.98739ZM12 10.4874C13.5037 10.4874 14.7227 9.2684 14.7227 7.7647C14.7227 6.26101 13.5037 5.04202 12 5.04202C10.4963 5.04202 9.27732 6.26101 9.27732 7.7647C9.27732 9.2684 10.4963 10.4874 12 10.4874Z", fill: "currentColor", fillOpacity: 0.45 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_347_46" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "currentColor" }))));
const Region = SvgRegion;
const SvgVenue$2 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.75 4.76562H9.75V3C9.75 2.72344 9.52656 2.5 9.25 2.5H2.875V1.875C2.875 1.80625 2.81875 1.75 2.75 1.75H1.875C1.80625 1.75 1.75 1.80625 1.75 1.875V14.125C1.75 14.1938 1.80625 14.25 1.875 14.25H2.75C2.81875 14.25 2.875 14.1938 2.875 14.125V10H6.75V11.7656C6.75 12.0422 6.97344 12.2656 7.25 12.2656H13.75C14.0266 12.2656 14.25 12.0422 14.25 11.7656V5.26562C14.25 4.98906 14.0266 4.76562 13.75 4.76562Z", fill: "currentColor" }));
const Venue = SvgVenue$2;
const SvgBuilding = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.67195 11.7208H12.3042V13.0474H7.67195V11.7208Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M12.3042 14.2719H7.67195V15.5985H12.3042V14.2719Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.32336 1C2.96424 1 2.67313 1.29714 2.67313 1.66369V6.26629C2.213 6.26629 1.84 6.6393 1.84 7.09942L1.84 19H18.15L18.15 4.38295C18.15 3.89933 17.8174 3.48213 17.3535 3.38381L11.3743 2.11656C10.7536 1.98501 10.1713 2.46868 10.1713 3.11569L10.1713 8.64734H9.80473L9.80473 7.09942C9.80473 6.63929 9.43172 6.26629 8.97159 6.26629L8.97159 1.66329C8.97159 1.29697 8.68065 1 8.32175 1L3.32336 1ZM8.50504 8.64734L8.50504 7.59288L3.13968 7.59288L3.13968 17.6734H5.17256L5.17256 10.6882C5.17256 9.72616 5.17256 9.24511 5.46538 8.94623C5.7582 8.64734 6.22949 8.64734 7.17207 8.64734H8.50504ZM6.47225 17.6734H13.5039L13.5039 9.97393H6.47224L6.47225 17.6734ZM14.8035 17.6734H16.8224L16.8224 4.62775L11.471 3.5059V8.64734H12.804C13.7466 8.64734 14.2179 8.64734 14.5107 8.94623C14.8035 9.24511 14.8035 9.72615 14.8035 10.6882L14.8035 17.6734ZM3.97281 6.26629V2.32659L7.67191 2.32659V6.26629L3.97281 6.26629Z", fill: "currentColor", fillOpacity: 0.45 }));
const Building = SvgBuilding;
const SvgLevel = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.0009 2.10645L14.2108 4.59039C14.9974 4.90503 15.3907 5.06236 15.3907 5.33317C15.3907 5.60398 14.9974 5.7613 14.2108 6.07595L8.0009 8.55989L1.79104 6.07595C1.00443 5.76131 0.611119 5.60398 0.611119 5.33317C0.611119 5.06236 1.00443 4.90503 1.79104 4.59039L8.0009 2.10645ZM2.73437 5.33317L8.0009 7.43978L13.2674 5.33317L8.0009 3.22656L2.73437 5.33317Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M8.00086 10.238L0.574219 7.19984V8.3235L8.00086 11.3617L15.4275 8.3235V7.19984L8.00086 10.238Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M8.00086 13.038L0.574219 9.99984V11.1235L8.00086 14.1617L15.4275 11.1235V9.99984L8.00086 13.038Z", fill: "currentColor" }));
const Level$2 = SvgLevel;
const SvgZone = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21.75 9.1875C21.9562 9.1875 22.125 9.01875 22.125 8.8125V4.5C22.125 4.29375 21.9562 4.125 21.75 4.125H17.4375C17.2312 4.125 17.0625 4.29375 17.0625 4.5V5.8125H6.9375V4.5C6.9375 4.29375 6.76875 4.125 6.5625 4.125H2.25C2.04375 4.125 1.875 4.29375 1.875 4.5V8.8125C1.875 9.01875 2.04375 9.1875 2.25 9.1875H3.5625V14.8125H2.25C2.04375 14.8125 1.875 14.9812 1.875 15.1875V19.5C1.875 19.7063 2.04375 19.875 2.25 19.875H6.5625C6.76875 19.875 6.9375 19.7063 6.9375 19.5V18.1875H17.0625V19.5C17.0625 19.7063 17.2312 19.875 17.4375 19.875H21.75C21.9562 19.875 22.125 19.7063 22.125 19.5V15.1875C22.125 14.9812 21.9562 14.8125 21.75 14.8125H20.4375V9.1875H21.75ZM18.5625 5.625H20.625V7.6875H18.5625V5.625ZM3.375 7.6875V5.625H5.4375V7.6875H3.375ZM5.4375 18.375H3.375V16.3125H5.4375V18.375ZM20.625 16.3125V18.375H18.5625V16.3125H20.625ZM18.75 14.8125H17.4375C17.2312 14.8125 17.0625 14.9812 17.0625 15.1875V16.5H6.9375V15.1875C6.9375 14.9812 6.76875 14.8125 6.5625 14.8125H5.25V9.1875H6.5625C6.76875 9.1875 6.9375 9.01875 6.9375 8.8125V7.5H17.0625V8.8125C17.0625 9.01875 17.2312 9.1875 17.4375 9.1875H18.75V14.8125Z", fill: "currentColor", fillOpacity: 0.45 }));
const Zone = SvgZone;
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 6.12499C7.49844 6.12499 7.02969 6.31874 6.675 6.67499C6.32031 7.02968 6.125 7.49843 6.125 7.99999C6.125 8.50155 6.32031 8.9703 6.675 9.32499C7.02969 9.67811 7.5 9.87499 8 9.87499C8.5 9.87499 8.97031 9.67968 9.325 9.32499C9.67812 8.9703 9.875 8.49999 9.875 7.99999C9.875 7.49999 9.67969 7.02968 9.325 6.67499C8.97031 6.31874 8.50156 6.12499 8 6.12499Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 12.1333C10.2828 12.1333 12.1333 10.2828 12.1333 8C12.1333 5.71722 10.2828 3.86667 8 3.86667C5.71722 3.86667 3.86667 5.71722 3.86667 8C3.86667 10.2828 5.71722 12.1333 8 12.1333ZM8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13Z", fill: "currentColor" }));
const Dot = SvgDot;
const SvgCountry = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { opacity: 0.5 }, /* @__PURE__ */ React.createElement("path", { d: "M13.35 12.5141C13.3531 12.5094 13.3578 12.5047 13.3609 12.5C14.3844 11.2828 15 9.71406 15 8C15 6.28594 14.3844 4.71719 13.3625 3.5C13.3594 3.49531 13.3547 3.49219 13.3516 3.4875C13.3344 3.46719 13.3187 3.44844 13.3016 3.42969C13.2953 3.42188 13.2891 3.41563 13.2828 3.40781L13.2188 3.33437L13.2172 3.33281C13.1938 3.30625 13.1687 3.27969 13.1453 3.25312L13.1438 3.25156C13.0938 3.19844 13.0437 3.14531 12.9922 3.09375L12.9906 3.09219L12.9156 3.01719L12.9109 3.0125C12.8875 2.98906 12.8641 2.96719 12.8406 2.94531C12.8328 2.9375 12.825 2.92969 12.8156 2.92188C12.8 2.90625 12.7844 2.89219 12.7688 2.87812C12.7641 2.87344 12.7578 2.86875 12.7531 2.8625C11.5063 1.70625 9.83594 1 8 1C6.16406 1 4.49375 1.70625 3.24531 2.8625C3.24062 2.86719 3.23438 2.87187 3.22969 2.87812C3.21406 2.89219 3.19844 2.90781 3.18281 2.92344C3.175 2.93125 3.16719 2.93906 3.15781 2.94688C3.13438 2.96875 3.11094 2.99219 3.0875 3.01406L3.08281 3.01875L3.00781 3.09375L3.00625 3.09531C2.95469 3.14688 2.90469 3.2 2.85469 3.25312L2.85313 3.25469C2.82813 3.28125 2.80469 3.30781 2.78125 3.33437L2.77969 3.33594C2.75781 3.35938 2.73594 3.38437 2.71563 3.40937C2.70938 3.41719 2.70313 3.42344 2.69688 3.43125C2.67969 3.45 2.66406 3.47031 2.64687 3.48906C2.64375 3.49375 2.63906 3.49688 2.63594 3.50156C1.61562 4.71719 1 6.28594 1 8C1 9.71406 1.61563 11.2828 2.6375 12.5C2.64062 12.5047 2.64531 12.5094 2.64844 12.5141L2.69688 12.5719C2.70313 12.5797 2.70938 12.5859 2.71563 12.5938L2.77969 12.6672C2.77969 12.6687 2.78125 12.6688 2.78125 12.6703C2.80469 12.6969 2.82813 12.7234 2.85313 12.7484L2.85469 12.75C2.90469 12.8031 2.95469 12.8562 3.00469 12.9078L3.00625 12.9094C3.03125 12.9344 3.05469 12.9594 3.07969 12.9828L3.08437 12.9875C3.13594 13.0391 3.18906 13.0891 3.24219 13.1375C4.49375 14.2937 6.16406 15 8 15C9.83594 15 11.5062 14.2937 12.7547 13.1375C12.8079 13.0887 12.86 13.0387 12.9109 12.9875L12.9156 12.9828C12.9406 12.9578 12.9656 12.9344 12.9891 12.9094L12.9906 12.9078C13.0422 12.8562 13.0922 12.8031 13.1406 12.75L13.1422 12.7484C13.1656 12.7219 13.1906 12.6969 13.2141 12.6703C13.2141 12.6688 13.2156 12.6687 13.2156 12.6672C13.2375 12.6438 13.2594 12.6187 13.2797 12.5938C13.2859 12.5859 13.2922 12.5797 13.2984 12.5719C13.3161 12.553 13.3333 12.5338 13.35 12.5141ZM13.4141 10.2859C13.1984 10.7953 12.9141 11.2672 12.5672 11.6953C12.1765 11.3577 11.7494 11.0647 11.2937 10.8219C11.475 10.0891 11.5875 9.28438 11.6172 8.4375H13.8594C13.8125 9.07656 13.6625 9.69687 13.4141 10.2859ZM13.8594 7.5625H11.6172C11.5875 6.71562 11.475 5.91094 11.2937 5.17812C11.7516 4.93437 12.1781 4.64062 12.5672 4.30469C13.3212 5.23277 13.7722 6.3699 13.8594 7.5625ZM10.2859 2.58594C10.9062 2.84844 11.4703 3.21094 11.9672 3.66719C11.6785 3.91296 11.3679 4.13159 11.0391 4.32031C10.7937 3.61719 10.4797 3.00625 10.1141 2.51719C10.1719 2.53906 10.2297 2.5625 10.2859 2.58594ZM8.87031 13.5328C8.72656 13.6453 8.58281 13.7312 8.4375 13.7891V10.8906C9.05749 10.9339 9.66717 11.0719 10.2453 11.3C10.1156 11.6844 9.96562 12.0391 9.79219 12.3594C9.52031 12.8656 9.20156 13.2703 8.87031 13.5328ZM9.79219 3.64062C9.96406 3.9625 10.1156 4.31719 10.2453 4.7C9.66717 4.92806 9.05749 5.06612 8.4375 5.10938V2.2125C8.58125 2.27031 8.72656 2.35469 8.87031 2.46875C9.20156 2.72969 9.52031 3.13438 9.79219 3.64062ZM8.4375 10.0141V8.4375H10.7422C10.7172 9.12813 10.6313 9.79844 10.4875 10.4344L10.4828 10.4531C9.82708 10.2045 9.13751 10.0564 8.4375 10.0141ZM8.4375 7.5625V5.98594C9.15312 5.94219 9.84063 5.79063 10.4828 5.54688L10.4875 5.56563C10.6313 6.20156 10.7172 6.87031 10.7422 7.5625H8.4375ZM7.5625 8.4375V10.0141C6.84688 10.0578 6.15938 10.2094 5.51719 10.4531L5.5125 10.4344C5.36875 9.79844 5.28281 9.12969 5.25781 8.4375H7.5625ZM5.25781 7.5625C5.28281 6.87187 5.36875 6.20156 5.5125 5.56563L5.51719 5.54688C6.15938 5.79063 6.84531 5.94219 7.5625 5.98594V7.5625H5.25781ZM7.5625 10.8906V13.7875C7.41875 13.7297 7.27344 13.6453 7.12969 13.5312C6.79844 13.2703 6.47813 12.8641 6.20625 12.3578C6.03438 12.0359 5.88281 11.6812 5.75313 11.2984C6.33438 11.0703 6.93906 10.9344 7.5625 10.8906ZM7.5625 5.10938C6.94251 5.06612 6.33283 4.92806 5.75469 4.7C5.88437 4.31562 6.03437 3.96094 6.20781 3.64062C6.47969 3.13438 6.79844 2.72812 7.13125 2.46719C7.275 2.35469 7.41875 2.26875 7.56406 2.21094V5.10938H7.5625ZM5.71406 2.58594C5.77188 2.5625 5.82812 2.53906 5.88594 2.51719C5.52031 3.00625 5.20625 3.61719 4.96094 4.32031C4.63281 4.13281 4.32188 3.91406 4.03281 3.66719C4.52969 3.21094 5.09375 2.84844 5.71406 2.58594ZM2.58594 5.71406C2.80156 5.20469 3.08594 4.73281 3.43281 4.30469C3.82187 4.64062 4.24844 4.93437 4.70625 5.17812C4.525 5.91094 4.4125 6.71562 4.38281 7.5625H2.14062C2.1875 6.92344 2.3375 6.30313 2.58594 5.71406ZM2.14062 8.4375H4.38281C4.4125 9.28438 4.525 10.0891 4.70625 10.8219C4.25059 11.0647 3.82347 11.3577 3.43281 11.6953C2.6788 10.7672 2.22776 9.6301 2.14062 8.4375ZM5.71406 13.4141C5.09375 13.1516 4.52969 12.7891 4.03281 12.3328C4.32188 12.0859 4.63281 11.8687 4.96094 11.6797C5.20625 12.3828 5.52031 12.9938 5.88594 13.4828C5.82812 13.4609 5.77031 13.4375 5.71406 13.4141ZM10.2859 13.4141C10.2281 13.4375 10.1719 13.4609 10.1141 13.4828C10.4797 12.9938 10.7937 12.3828 11.0391 11.6797C11.3672 11.8672 11.6781 12.0859 11.9672 12.3328C11.4731 12.7872 10.9043 13.1529 10.2859 13.4141Z", fill: "currentColor" })));
const Country = SvgCountry;
const SvgMarket = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M11.0875 3.28125L11.0938 3.27813H11.0969L8 1.5L4.90469 3.27813H4.90156L4.9125 3.28281L2.36719 4.75V11.25L8 14.5L13.6328 11.25V4.75L11.0875 3.28125ZM7.54219 13.1812L5.30625 11.8906V9.70938L3.28125 8.55937V5.82656L7.54219 8.28438V13.1812ZM3.72187 5.02344L5.82656 3.80781L7.99687 5.05312L10.1703 3.80469L12.2828 5.02344L8.00313 7.49219L3.72187 5.02344ZM12.7188 8.56719L10.7063 9.70938V11.8828L8.45781 13.1797V8.2875L12.7188 5.82969V8.56719Z", fill: "currentColor" })));
const Market = SvgMarket;
const SvgCluster = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M13.8798 10.8313C13.2157 10.4469 12.4063 10.55 11.861 11.0312L11.0329 10.5516V8.18125C11.0329 7.93594 10.9017 7.70781 10.6892 7.58594L8.56416 6.3625V5.31406C9.25478 5.07969 9.75166 4.42656 9.75166 3.65625C9.75166 2.68906 8.96885 1.90625 8.00166 1.90625C7.03447 1.90625 6.25166 2.68906 6.25166 3.65625C6.25166 4.42656 6.74854 5.07969 7.43916 5.31406V6.3625L5.31416 7.58594C5.10166 7.70781 4.97041 7.93594 4.97041 8.18125V10.55L4.14229 11.0297C3.59697 10.5484 2.78604 10.4453 2.12354 10.8297C1.2876 11.3141 1.00322 12.3828 1.48291 13.2188C1.96416 14.0547 3.02822 14.3422 3.86104 13.8594C4.5251 13.475 4.84072 12.7188 4.69854 12.0031L5.45947 11.5609L7.65635 12.8266C7.7626 12.8875 7.88135 12.9187 8.0001 12.9187C8.11885 12.9187 8.2376 12.8875 8.34385 12.8266L10.5392 11.5625L11.3001 12.0047C11.1579 12.7188 11.4751 13.4766 12.1376 13.8609C12.9704 14.3438 14.036 14.0578 14.5157 13.2203C14.997 12.3828 14.7126 11.3141 13.8798 10.8313ZM3.36416 12.9937C3.27929 13.0429 3.18554 13.0748 3.0883 13.0876C2.99106 13.1003 2.89226 13.0938 2.79757 13.0682C2.70288 13.0426 2.61419 12.9986 2.53659 12.9386C2.45899 12.8787 2.39402 12.8039 2.34541 12.7188C2.13916 12.3609 2.26104 11.9016 2.61885 11.6953C2.70372 11.6462 2.79747 11.6143 2.89471 11.6015C2.99195 11.5887 3.09075 11.5953 3.18544 11.6209C3.28012 11.6464 3.36882 11.6905 3.44642 11.7504C3.52402 11.8104 3.58899 11.8851 3.6376 11.9703C3.84385 12.3281 3.72197 12.7875 3.36416 12.9937ZM7.2501 3.65625C7.2541 3.45999 7.33488 3.27312 7.4751 3.13573C7.61531 2.99835 7.8038 2.9214 8.0001 2.9214C8.1964 2.9214 8.38488 2.99835 8.5251 3.13573C8.66531 3.27312 8.74609 3.45999 8.7501 3.65625C8.74609 3.85251 8.66531 4.03938 8.5251 4.17677C8.38488 4.31415 8.1964 4.3911 8.0001 4.3911C7.8038 4.3911 7.61531 4.31415 7.4751 4.17677C7.33488 4.03938 7.2541 3.85251 7.2501 3.65625ZM9.90635 10.6281L8.0001 11.7266L6.09385 10.6281V8.43437L8.0001 7.33594L9.90635 8.43437V10.6281ZM13.6548 12.7203C13.4485 13.0781 12.9923 13.2016 12.636 12.9953C12.2798 12.7891 12.1563 12.3297 12.3626 11.9719C12.5688 11.6141 13.0251 11.4906 13.3813 11.6969C13.7392 11.9031 13.861 12.3609 13.6548 12.7203Z", fill: "currentColor" })));
const Cluster = SvgCluster;
const SvgSearchIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.2125 12.3516L9.15469 8.29375C9.78438 7.47969 10.125 6.48438 10.125 5.4375C10.125 4.18438 9.63594 3.00937 8.75156 2.12344C7.86719 1.2375 6.68906 0.75 5.4375 0.75C4.18594 0.75 3.00781 1.23906 2.12344 2.12344C1.2375 3.00781 0.75 4.18438 0.75 5.4375C0.75 6.68906 1.23906 7.86719 2.12344 8.75156C3.00781 9.6375 4.18438 10.125 5.4375 10.125C6.48438 10.125 7.47813 9.78438 8.29219 9.15625L12.35 13.2125C12.3619 13.2244 12.376 13.2338 12.3916 13.2403C12.4071 13.2467 12.4238 13.2501 12.4406 13.2501C12.4575 13.2501 12.4741 13.2467 12.4897 13.2403C12.5052 13.2338 12.5194 13.2244 12.5312 13.2125L13.2125 12.5328C13.2244 12.5209 13.2338 12.5068 13.2403 12.4912C13.2467 12.4757 13.2501 12.459 13.2501 12.4422C13.2501 12.4254 13.2467 12.4087 13.2403 12.3931C13.2338 12.3776 13.2244 12.3635 13.2125 12.3516ZM7.9125 7.9125C7.25 8.57344 6.37187 8.9375 5.4375 8.9375C4.50312 8.9375 3.625 8.57344 2.9625 7.9125C2.30156 7.25 1.9375 6.37187 1.9375 5.4375C1.9375 4.50312 2.30156 3.62344 2.9625 2.9625C3.625 2.30156 4.50312 1.9375 5.4375 1.9375C6.37187 1.9375 7.25156 2.3 7.9125 2.9625C8.57344 3.625 8.9375 4.50312 8.9375 5.4375C8.9375 6.37187 8.57344 7.25156 7.9125 7.9125Z", fill: "currentColor", fillOpacity: 0.85 }));
const Search = SvgSearchIcon;
const SvgPolygon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12330_15984)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.51961 12.5182L3.68434 9.1335C3.33694 9.42467 2.88914 9.59999 2.40039 9.59999C1.29582 9.59999 0.400391 8.70456 0.400391 7.59999C0.400391 6.49542 1.29582 5.59999 2.40039 5.59999C2.81885 5.59999 3.2073 5.72851 3.52842 5.94822L6.19532 3.6623C6.07037 3.4012 6.00039 3.10877 6.00039 2.79999C6.00039 1.69542 6.89582 0.799988 8.00039 0.799988C9.10496 0.799988 10.0004 1.69542 10.0004 2.79999L10.0002 2.83055L11.886 3.36937C12.236 2.78849 12.8728 2.39999 13.6004 2.39999C14.705 2.39999 15.6004 3.29542 15.6004 4.39999C15.6004 5.50456 14.705 6.39999 13.6004 6.39999C13.5427 6.39999 13.4855 6.39754 13.4291 6.39275L11.5491 11.5626C12.0639 11.9244 12.4004 12.5229 12.4004 13.2C12.4004 14.3046 11.505 15.2 10.4004 15.2C9.29582 15.2 8.40039 14.3046 8.40039 13.2C8.40039 12.9606 8.44246 12.731 8.51961 12.5182ZM8.00039 3.75999C8.53058 3.75999 8.96039 3.33018 8.96039 2.79999C8.96039 2.26979 8.53058 1.83999 8.00039 1.83999C7.4702 1.83999 7.04039 2.26979 7.04039 2.79999C7.04039 3.33018 7.4702 3.75999 8.00039 3.75999ZM8.00039 4.79999C8.72796 4.79999 9.36479 4.41149 9.71474 3.83062L11.6006 4.36944L11.6004 4.39999C11.6004 5.07705 11.9368 5.67554 12.4517 6.03739L10.5717 11.2072C10.5152 11.2024 10.4581 11.2 10.4004 11.2C9.91164 11.2 9.46383 11.3753 9.11643 11.6665L4.28116 8.2818C4.35832 8.06902 4.40039 7.83941 4.40039 7.59999C4.40039 7.29121 4.33041 6.99877 4.20545 6.73766L6.87236 4.45175C7.19347 4.67147 7.58192 4.79999 8.00039 4.79999ZM14.5604 4.39999C14.5604 4.93018 14.1306 5.35999 13.6004 5.35999C13.0702 5.35999 12.6404 4.93018 12.6404 4.39999C12.6404 3.86979 13.0702 3.43999 13.6004 3.43999C14.1306 3.43999 14.5604 3.86979 14.5604 4.39999ZM2.40039 8.55999C2.93058 8.55999 3.36039 8.13018 3.36039 7.59999C3.36039 7.06979 2.93058 6.63999 2.40039 6.63999C1.8702 6.63999 1.44039 7.06979 1.44039 7.59999C1.44039 8.13018 1.8702 8.55999 2.40039 8.55999ZM11.3604 13.2C11.3604 13.7302 10.9306 14.16 10.4004 14.16C9.8702 14.16 9.44039 13.7302 9.44039 13.2C9.44039 12.6698 9.8702 12.24 10.4004 12.24C10.9306 12.24 11.3604 12.6698 11.3604 13.2Z", fill: "#1D68D1" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12330_15984" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const Polygon$4 = SvgPolygon;
const SvgBoxRotate = (props) => /* @__PURE__ */ React.createElement("svg", { width: 27, height: 27, viewBox: "0 0 27 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 9.23047, y: 7.56445, width: 8, height: 8, rx: 4, fill: "#13161B" }), /* @__PURE__ */ React.createElement("rect", { x: 9.23047, y: 7.56445, width: 8, height: 8, rx: 4, stroke: "#1D68D1" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.6, d: "M23.3943 15.5653L26.281 10.5653H20.5075L23.3943 15.5653ZM3.06836 15.5653L5.95511 10.5653H0.181608L3.06836 15.5653ZM3.56836 11.5653C3.56836 6.2286 7.89461 1.90234 13.2313 1.90234V0.902344C7.34233 0.902344 2.56836 5.67631 2.56836 11.5653H3.56836ZM13.2313 1.90234C18.568 1.90234 22.8943 6.2286 22.8943 11.5653H23.8943C23.8943 5.67631 19.1203 0.902344 13.2313 0.902344V1.90234Z", fill: "#D89614" }));
const BoxRotateAnchor = SvgBoxRotate;
const SvgBoxPoint = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.964844, y: 0.960938, width: 8, height: 8, fill: "currentColor" }), /* @__PURE__ */ React.createElement("rect", { x: 0.964844, y: 0.960938, width: 8, height: 8, stroke: "#0080FF" }));
const BoxPointAnchor = SvgBoxPoint;
const SvgCampusIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.931641, y: 0.25, width: 23.5, height: 23.5, rx: 1.75, fill: "#13C2C2" }), /* @__PURE__ */ React.createElement("rect", { x: 0.931641, y: 0.25, width: 23.5, height: 23.5, rx: 1.75, stroke: "#D5D6D7", strokeWidth: 0.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5.45703 18.4321V5.30713H12.445V8.372H19.9088V18.4321H5.45703ZM6.30791 17.5811H8.52903V15.3599H6.30791V17.5811ZM6.30791 14.5091H8.52903V12.2951H6.30791V14.5091ZM6.30791 11.444H8.52903V9.22288H6.30791V11.444ZM6.30791 8.372H8.52903V6.158H6.30791V8.372ZM9.38009 17.5811H11.5939V15.3599H9.38009V17.5811ZM9.38009 14.5091H11.5939V12.2951H9.38009V14.5091ZM9.38009 11.444H11.5939V9.22288H9.38009V11.444ZM9.38009 8.372H11.5939V6.158H9.38009V8.372ZM12.445 17.5811H19.0579V9.22288H12.445V11.444H14.0892V12.2951H12.445V14.5091H14.0892V15.3599H12.445V17.5811ZM16.0795 12.2951V11.444H16.9305V12.2951H16.0795ZM16.0795 15.3599V14.5091H16.9305V15.3599H16.0795Z", fill: "black" }));
const VenueIcon = SvgCampusIcon;
const SvgBuildingIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1.09277, y: 0.504883, width: 23.5, height: 23.5, rx: 1.75, fill: "#4096FF" }), /* @__PURE__ */ React.createElement("rect", { x: 1.09277, y: 0.504883, width: 23.5, height: 23.5, rx: 1.75, stroke: "#D5D6D7", strokeWidth: 0.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6.28027 18.6877V8.62762H9.35246V5.56274H16.3404V11.6996H19.4053V18.6877H13.9591V15.6156H11.7264V18.6877H6.28027ZM7.13115 17.8367H9.35246V15.6156H7.13115V17.8367ZM7.13115 14.7647H9.35246V12.5507H7.13115V14.7647ZM7.13115 11.6996H9.35246V9.47849H7.13115V11.6996ZM10.2033 14.7647H12.4173V12.5507H10.2033V14.7647ZM10.2033 11.6996H12.4173V9.47849H10.2033V11.6996ZM10.2033 8.62762H12.4173V6.41362H10.2033V8.62762ZM13.2682 14.7647H15.4893V12.5507H13.2682V14.7647ZM13.2682 11.6996H15.4893V9.47849H13.2682V11.6996ZM13.2682 8.62762H15.4893V6.41362H13.2682V8.62762ZM16.3404 17.8367H18.5544V15.6156H16.3404V17.8367ZM16.3404 14.7647H18.5544V12.5507H16.3404V14.7647Z", fill: "white" }));
const BuildingIcon = SvgBuildingIcon;
const SvgUndefined = (props) => /* @__PURE__ */ React.createElement("svg", { width: 50, height: 50, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M29.8438 10.9727C29.2969 9.77734 28.5195 8.70312 27.5273 7.78516C25.5117 5.91406 22.8359 4.88281 20 4.88281C17.1641 4.88281 14.4883 5.91406 12.4727 7.78125C11.4805 8.70312 10.7031 9.77344 10.1562 10.9727C9.58594 12.2227 9.29688 13.5469 9.29688 14.9141V15.9688C9.29688 16.2109 9.49219 16.4062 9.73437 16.4062H11.8438C12.0859 16.4062 12.2812 16.2109 12.2812 15.9688V14.9141C12.2812 11.0273 15.7422 7.86719 20 7.86719C24.2578 7.86719 27.7188 11.0273 27.7188 14.9141C27.7188 16.5078 27.1523 18.0078 26.0781 19.2578C25.0156 20.4961 23.5156 21.3828 21.8555 21.7578C20.9062 21.9727 20.0508 22.5078 19.4453 23.2734C18.842 24.0364 18.5131 24.9804 18.5117 25.9531V27.1797C18.5117 27.4219 18.707 27.6172 18.9492 27.6172H21.0586C21.3008 27.6172 21.4961 27.4219 21.4961 27.1797V25.9531C21.4961 25.3398 21.9219 24.8008 22.5117 24.668C24.793 24.1523 26.8633 22.9219 28.3438 21.2031C29.0898 20.332 29.6719 19.3633 30.0742 18.3125C30.4922 17.2227 30.7031 16.0781 30.7031 14.9141C30.7031 13.5469 30.4141 12.2187 29.8438 10.9727ZM20 30.7422C18.793 30.7422 17.8125 31.7227 17.8125 32.9297C17.8125 34.1367 18.793 35.1172 20 35.1172C21.207 35.1172 22.1875 34.1367 22.1875 32.9297C22.1875 31.7227 21.207 30.7422 20 30.7422Z", fill: "currentColor", fillOpacity: 0.45 }));
const Undefined = SvgUndefined;
const SvgDirectionLeaf = (props) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 45, viewBox: "0 0 40 45", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.7354 0.984619C19.9591 0.984619 20.1876 1.09005 20.3984 1.22876C20.6154 1.3715 20.8458 1.57129 21.0811 1.80493C21.5522 2.27293 22.0671 2.90237 22.5596 3.55884C23.5457 4.87336 24.4645 6.32398 24.8066 6.87427C24.9747 7.14457 24.7958 7.47853 24.4971 7.51587L22.7959 7.72876C21.6112 7.87685 20.578 8.6072 20.0439 9.67505C19.9166 9.92972 19.5541 9.92972 19.4268 9.67505C18.8927 8.60719 17.8595 7.87685 16.6748 7.72876L14.9736 7.51587C14.6749 7.47853 14.496 7.14457 14.6641 6.87427C15.0062 6.32398 15.925 4.87336 16.9111 3.55884C17.4036 2.90237 17.9185 2.27293 18.3896 1.80493C18.6249 1.57129 18.8553 1.3715 19.0723 1.22876C19.2831 1.09005 19.5116 0.984619 19.7354 0.984619Z", fill: "#4096FF", stroke: "#4096FF", strokeWidth: 0.5 }));
const DirectionLeaf = SvgDirectionLeaf;
const SvgFilterIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.66669 6.33398C6.66669 7.43855 5.77126 8.33399 4.66669 8.33399C3.56212 8.33399 2.66669 7.43855 2.66669 6.33398C2.66669 5.22942 3.56212 4.33398 4.66669 4.33398C5.77126 4.33398 6.66669 5.22942 6.66669 6.33398Z", stroke: "white", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13.3333 9.66602C13.3333 8.56145 12.4379 7.66602 11.3333 7.66602C10.2288 7.66602 9.33334 8.56145 9.33334 9.66602C9.33334 10.7706 10.2288 11.666 11.3333 11.666C12.4379 11.666 13.3333 10.7706 13.3333 9.66602Z", stroke: "white", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M11.3333 7.33398L11.361 1.33398M4.66667 1.33398L4.66667 4.00065", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M4.66667 8.66602L4.66667 14.666M11.3333 14.666V11.9993", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }));
const FilterDark = SvgFilterIcon;
const SvgFilterLight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.66602 6.33334C6.66602 7.43791 5.77058 8.33334 4.66602 8.33334C3.56145 8.33334 2.66602 7.43791 2.66602 6.33334C2.66602 5.22877 3.56145 4.33334 4.66602 4.33334C5.77058 4.33334 6.66602 5.22877 6.66602 6.33334Z", stroke: "#6B7280", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13.334 9.66666C13.334 8.56209 12.4386 7.66666 11.334 7.66666C10.2294 7.66666 9.33398 8.56209 9.33398 9.66666C9.33398 10.7712 10.2294 11.6667 11.334 11.6667C12.4386 11.6667 13.334 10.7712 13.334 9.66666Z", stroke: "#6B7280", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M11.3327 7.33334L11.3604 1.33334M4.66602 1.33334L4.66602 4.00001", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M4.66602 8.66666L4.66602 14.6667M11.3327 14.6667V12", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }));
const FilterLight = SvgFilterLight;
const SvgTwoDots = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 6, r: 2, fill: "white" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 14, r: 2, fill: "white" }));
const MoreDark = SvgTwoDots;
const SvgTwoDotsLight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 6, r: 2, fill: "#0D1730" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 14, r: 2, fill: "#0D1730" }));
const MoreLight = SvgTwoDotsLight;
const SvgAgentDark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2449_62977)" }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M11.6666 18.3327C14.8093 18.3327 16.3806 18.3327 17.3569 17.3228C18.3332 16.3129 18.3332 14.6876 18.3332 11.4368V10.1693C18.3332 8.26226 18.3332 7.30875 17.9006 6.5183C17.4679 5.72786 16.6774 5.23728 15.0965 4.25612L13.4299 3.22174C11.7587 2.18459 10.9232 1.66602 9.99989 1.66602C9.07661 1.66602 8.24105 2.18459 6.56992 3.22174L4.90325 4.25612C3.32234 5.23728 2.53189 5.72786 2.09922 6.5183C1.83458 7.00179 1.7318 7.54629 1.69189 8.33268", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9.1665 18.334C9.1665 14.1918 5.80864 10.834 1.6665 10.834", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.6665 18.334C6.6665 15.5726 4.42793 13.334 1.6665 13.334", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.1665 18.334C4.1665 16.9533 3.04722 15.834 1.6665 15.834", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2449_62977" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white" }))));
const AgentDark = SvgAgentDark;
const SvgAgentLight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1388_3793)" }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M11.6667 18.3335C14.8094 18.3335 16.3807 18.3335 17.357 17.3237C18.3333 16.3138 18.3333 14.6884 18.3333 11.4377V10.1701C18.3333 8.26311 18.3333 7.3096 17.9007 6.51915C17.468 5.72871 16.6776 5.23813 15.0966 4.25697L13.43 3.22259C11.7589 2.18544 10.9233 1.66687 10 1.66687C9.07673 1.66687 8.24117 2.18545 6.57004 3.2226L4.90337 4.25698C3.32247 5.23813 2.53201 5.72871 2.09935 6.51915C1.8347 7.00264 1.73193 7.54714 1.69202 8.33354", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9.16669 18.3333C9.16669 14.1912 5.80882 10.8333 1.66669 10.8333", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.66669 18.3333C6.66669 15.5719 4.42811 13.3333 1.66669 13.3333", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4.16669 18.3333C4.16669 16.9526 3.0474 15.8333 1.66669 15.8333", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1388_3793" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "white" }))));
const AgentLight = SvgAgentLight;
const SvgVenue$1 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_921_807)" }, /* @__PURE__ */ React.createElement("path", { d: "M14.1668 18.3333V13.3333C14.1668 11.762 14.1668 10.9763 13.6787 10.4882C13.1905 10 12.4048 10 10.8335 10H9.16683C7.59548 10 6.80981 10 6.32165 10.4882C5.8335 10.9763 5.8335 11.762 5.8335 13.3333V18.3333", stroke: "white", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M17.5002 18.3333V6.4766C17.5002 5.35923 17.5002 4.80055 17.2034 4.37228C16.9066 3.94401 16.3835 3.74784 15.3372 3.35551C13.2912 2.58824 12.2682 2.20461 11.5508 2.70173C10.8335 3.19884 10.8335 4.29143 10.8335 6.4766V9.99993", stroke: "white", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M2.58333 6.6665C2.58333 7.08072 2.91912 7.4165 3.33333 7.4165C3.74755 7.4165 4.08333 7.08072 4.08333 6.6665H2.58333ZM7.58333 6.6665C7.58333 7.08072 7.91912 7.4165 8.33333 7.4165C8.74755 7.4165 9.08333 7.08072 9.08333 6.6665H7.58333ZM8.08926 3.99391L7.55893 4.52424L7.55893 4.52425L8.08926 3.99391ZM5.08333 3.33317C5.08333 3.74738 5.41912 4.08317 5.83333 4.08317C6.24755 4.08317 6.58333 3.74738 6.58333 3.33317H5.08333ZM6.58333 1.6665C6.58333 1.25229 6.24755 0.916504 5.83333 0.916504C5.41912 0.916504 5.08333 1.25229 5.08333 1.6665H6.58333ZM3.25 18.3332V9.99984H1.75V18.3332H3.25ZM5.83333 7.4165C6.64021 7.4165 7.16992 7.4181 7.56218 7.47084C7.93287 7.52067 8.06668 7.60349 8.14818 7.68499L9.20884 6.62433C8.80219 6.21767 8.29908 6.05641 7.76206 5.98421C7.24661 5.91491 6.59781 5.9165 5.83333 5.9165V7.4165ZM9.91667 9.99984C9.91667 9.23537 9.91826 8.58656 9.84896 8.07112C9.77676 7.53409 9.6155 7.03098 9.20884 6.62433L8.14818 7.68499C8.22968 7.76649 8.3125 7.9003 8.36234 8.27099C8.41507 8.66325 8.41667 9.19296 8.41667 9.99984H9.91667ZM5.83333 5.9165C5.06886 5.9165 4.42006 5.91491 3.90461 5.98421C3.36759 6.05641 2.86448 6.21767 2.45783 6.62433L3.51849 7.68499C3.59999 7.60349 3.73379 7.52067 4.10448 7.47084C4.49675 7.4181 5.02646 7.4165 5.83333 7.4165V5.9165ZM3.25 9.99984C3.25 9.19296 3.25159 8.66325 3.30433 8.27099C3.35417 7.9003 3.43698 7.76649 3.51849 7.68499L2.45783 6.62433C2.05117 7.03098 1.88991 7.53409 1.81771 8.07112C1.74841 8.58656 1.75 9.23537 1.75 9.99984H3.25ZM4.08333 6.6665V5.4165H2.58333V6.6665H4.08333ZM5 4.49984H6.66667V2.99984H5V4.49984ZM7.58333 5.4165V6.6665H9.08333V5.4165H7.58333ZM6.66667 4.49984C7.08071 4.49984 7.31579 4.50143 7.48112 4.52366C7.62489 4.54299 7.59946 4.56478 7.55893 4.52424L8.61959 3.46359C8.33497 3.17897 7.99109 3.07873 7.681 3.03703C7.39248 2.99824 7.0383 2.99984 6.66667 2.99984V4.49984ZM9.08333 5.4165C9.08333 5.04487 9.08493 4.69069 9.04614 4.40217C9.00444 4.09208 8.9042 3.7482 8.61959 3.46358L7.55893 4.52425C7.51839 4.48371 7.54018 4.45828 7.55951 4.60205C7.58174 4.76738 7.58333 5.00246 7.58333 5.4165H9.08333ZM4.08333 5.4165C4.08333 5.00246 4.08493 4.76738 4.10716 4.60205C4.12648 4.45828 4.14828 4.48371 4.10774 4.52425L3.04708 3.46358C2.76247 3.7482 2.66222 4.09208 2.62053 4.40217C2.58174 4.69069 2.58333 5.04487 2.58333 5.4165H4.08333ZM5 2.99984C4.62837 2.99984 4.27419 2.99824 3.98567 3.03703C3.67558 3.07873 3.3317 3.17897 3.04708 3.46358L4.10774 4.52425C4.0672 4.56478 4.04178 4.54299 4.18554 4.52366C4.35088 4.50143 4.58596 4.49984 5 4.49984V2.99984ZM6.58333 3.33317V1.6665H5.08333V3.33317H6.58333Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M18.3332 18.3335L1.6665 18.3335", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M8.3335 12.5H11.6668", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M8.3335 15H11.6668", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_921_807" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 3, fill: "white" }))));
const VenueDark = SvgVenue$1;
const SvgVenue = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1388_3786)" }, /* @__PURE__ */ React.createElement("path", { d: "M14.1666 18.3333V13.3333C14.1666 11.762 14.1666 10.9763 13.6785 10.4882C13.1903 10 12.4047 10 10.8333 10H9.16665C7.5953 10 6.80962 10 6.32147 10.4882C5.83331 10.9763 5.83331 11.762 5.83331 13.3333V18.3333", stroke: "#6B7280", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M17.5 18.3333V6.47666C17.5 5.35929 17.5 4.80061 17.2032 4.37234C16.9064 3.94407 16.3833 3.7479 15.3371 3.35557C13.291 2.5883 12.268 2.20467 11.5507 2.70179C10.8333 3.19891 10.8333 4.29149 10.8333 6.47666V10", stroke: "#6B7280", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M2.58333 6.66669C2.58333 7.0809 2.91912 7.41669 3.33333 7.41669C3.74755 7.41669 4.08333 7.0809 4.08333 6.66669H2.58333ZM7.58333 6.66669C7.58333 7.0809 7.91912 7.41669 8.33333 7.41669C8.74755 7.41669 9.08333 7.0809 9.08333 6.66669H7.58333ZM8.08926 3.9941L7.55893 4.52443L7.55893 4.52443L8.08926 3.9941ZM5.08333 3.33335C5.08333 3.74757 5.41912 4.08335 5.83333 4.08335C6.24755 4.08335 6.58333 3.74757 6.58333 3.33335H5.08333ZM6.58333 1.66669C6.58333 1.25247 6.24755 0.916687 5.83333 0.916687C5.41912 0.916687 5.08333 1.25247 5.08333 1.66669H6.58333ZM3.25 18.3334V10H1.75V18.3334H3.25ZM5.83333 7.41669C6.64021 7.41669 7.16992 7.41828 7.56218 7.47102C7.93287 7.52086 8.06668 7.60367 8.14818 7.68517L9.20884 6.62451C8.80219 6.21786 8.29908 6.05659 7.76206 5.98439C7.24661 5.91509 6.59781 5.91669 5.83333 5.91669V7.41669ZM9.91667 10C9.91667 9.23555 9.91826 8.58675 9.84896 8.0713C9.77676 7.53428 9.6155 7.03117 9.20884 6.62451L8.14818 7.68517C8.22968 7.76667 8.3125 7.90048 8.36234 8.27117C8.41507 8.66343 8.41667 9.19314 8.41667 10H9.91667ZM5.83333 5.91669C5.06886 5.91669 4.42006 5.91509 3.90461 5.98439C3.36759 6.05659 2.86448 6.21786 2.45783 6.62451L3.51849 7.68517C3.59999 7.60367 3.73379 7.52086 4.10448 7.47102C4.49675 7.41828 5.02646 7.41669 5.83333 7.41669V5.91669ZM3.25 10C3.25 9.19314 3.25159 8.66343 3.30433 8.27117C3.35417 7.90048 3.43698 7.76667 3.51849 7.68517L2.45783 6.62451C2.05117 7.03117 1.88991 7.53428 1.81771 8.0713C1.74841 8.58675 1.75 9.23555 1.75 10H3.25ZM4.08333 6.66669V5.41669H2.58333V6.66669H4.08333ZM5 4.50002H6.66667V3.00002H5V4.50002ZM7.58333 5.41669V6.66669H9.08333V5.41669H7.58333ZM6.66667 4.50002C7.08071 4.50002 7.31579 4.50161 7.48112 4.52384C7.62489 4.54317 7.59946 4.56497 7.55893 4.52443L8.61959 3.46377C8.33497 3.17915 7.99109 3.07891 7.681 3.03722C7.39248 2.99843 7.0383 3.00002 6.66667 3.00002V4.50002ZM9.08333 5.41669C9.08333 5.04505 9.08493 4.69088 9.04614 4.40236C9.00444 4.09226 8.9042 3.74838 8.61959 3.46377L7.55893 4.52443C7.51839 4.48389 7.54018 4.45847 7.55951 4.60223C7.58174 4.76757 7.58333 5.00265 7.58333 5.41669H9.08333ZM4.08333 5.41669C4.08333 5.00265 4.08493 4.76757 4.10716 4.60223C4.12648 4.45847 4.14828 4.48389 4.10774 4.52443L3.04708 3.46377C2.76247 3.74838 2.66222 4.09226 2.62053 4.40236C2.58174 4.69088 2.58333 5.04505 2.58333 5.41669H4.08333ZM5 3.00002C4.62837 3.00002 4.27419 2.99843 3.98567 3.03722C3.67558 3.07891 3.3317 3.17915 3.04708 3.46377L4.10774 4.52443C4.0672 4.56497 4.04178 4.54317 4.18554 4.52384C4.35088 4.50161 4.58596 4.50002 5 4.50002V3.00002ZM6.58333 3.33335V1.66669H5.08333V3.33335H6.58333Z", fill: "#6B7280" }), /* @__PURE__ */ React.createElement("path", { d: "M18.3334 18.3333L1.66669 18.3333", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M8.33331 12.5H11.6666", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M8.33331 15H11.6666", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1388_3786" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 3, fill: "white" }))));
const VenueLight = SvgVenue;
const SvgLocationDark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M2.66675 6.76285C2.66675 3.76457 5.05456 1.33398 8.00008 1.33398C10.9456 1.33398 13.3334 3.76457 13.3334 6.76285C13.3334 9.73763 11.6312 13.2089 8.97537 14.4503C8.35625 14.7397 7.64391 14.7397 7.02479 14.4503C4.36896 13.2089 2.66675 9.73763 2.66675 6.76285Z", stroke: "white", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 6.66602, r: 2, stroke: "white", strokeWidth: 1.5 }));
const MappedLocatonDark = SvgLocationDark;
const SvgMappedLocation = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M2.66669 6.76224C2.66669 3.76396 5.0545 1.33337 8.00002 1.33337C10.9455 1.33337 13.3334 3.76396 13.3334 6.76224C13.3334 9.73702 11.6311 13.2083 8.97531 14.4497C8.35619 14.7391 7.64385 14.7391 7.02473 14.4497C4.3689 13.2083 2.66669 9.73702 2.66669 6.76224Z", stroke: "#6B7280", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 6.66663, r: 2, stroke: "#6B7280", strokeWidth: 1.5 }));
const MappedLocatonLight = SvgMappedLocation;
const SvgUnmappedLocationDark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2260_64595)" }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M2.66675 6.76285C2.66675 3.76457 5.05456 1.33398 8.00008 1.33398C10.9456 1.33398 13.3334 3.76457 13.3334 6.76285C13.3334 9.73763 11.6312 13.2089 8.97537 14.4503C8.35625 14.7397 7.64391 14.7397 7.02479 14.4503C4.36896 13.2089 2.66675 9.73763 2.66675 6.76285Z", stroke: "white", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("rect", { x: 0.984375, y: 0.691406, width: 1, height: 19.3912, rx: 0.5, transform: "rotate(-45 0.984375 0.691406)", fill: "white" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2260_64595" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const UnMappedLocatonDark = SvgUnmappedLocationDark;
const SvgUnmappedLocation = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1388_4070)" }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M2.66669 6.76224C2.66669 3.76396 5.0545 1.33337 8.00002 1.33337C10.9455 1.33337 13.3334 3.76396 13.3334 6.76224C13.3334 9.73702 11.6311 13.2083 8.97531 14.4497C8.35619 14.7391 7.64385 14.7391 7.02473 14.4497C4.3689 13.2083 2.66669 9.73702 2.66669 6.76224Z", stroke: "#6B7280", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("rect", { x: 0.984314, y: 0.691406, width: 1, height: 19.3912, rx: 0.5, transform: "rotate(-45 0.984314 0.691406)", fill: "#6B7280" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1388_4070" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const UnMappedLocatonLight = SvgUnmappedLocation;
const SvgDetailsDark = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2737_76591)" }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 17.5007L9.16667 10.834M9.16667 10.834H4.16667M9.16667 10.834V15.834", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M10.0001 18.3327C14.6025 18.3327 18.3334 14.6017 18.3334 9.99935C18.3334 5.39698 14.6025 1.66602 10.0001 1.66602C5.39771 1.66602 1.66675 5.39698 1.66675 9.99935", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2737_76591" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 5, fill: "white" }))));
const DetailsDark = SvgDetailsDark;
const SvgDetailsLight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1388_3814)" }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 17.5L9.16667 10.8333M9.16667 10.8333H4.16667M9.16667 10.8333V15.8333", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M10 18.3334C14.6024 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6024 1.66669 10 1.66669C5.39765 1.66669 1.66669 5.39765 1.66669 10", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1388_3814" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 5, fill: "white" }))));
const DetailsLight = SvgDetailsLight;
const SvgWorldDark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1382_2297)" }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M1.33325 8.00004H14.6666M10.6666 8.00004C10.6666 8.87552 10.5976 9.74243 10.4636 10.5513C10.3296 11.3601 10.1332 12.095 9.88554 12.7141C9.63791 13.3331 9.34394 13.8242 9.02041 14.1592C8.69687 14.4943 8.35011 14.6667 7.99992 14.6667C7.64973 14.6667 7.30296 14.4943 6.97943 14.1592C6.65589 13.8242 6.36192 13.3331 6.1143 12.7141C5.86668 12.095 5.67025 11.3601 5.53624 10.5513C5.40223 9.74243 5.33325 8.87552 5.33325 8.00004C5.33325 7.12456 5.40223 6.25766 5.53624 5.44882C5.67025 4.63998 5.86668 3.90505 6.1143 3.286C6.36192 2.66694 6.6559 2.17587 6.97943 1.84084C7.30297 1.50581 7.64973 1.33337 7.99992 1.33337C8.35011 1.33337 8.69687 1.50581 9.02041 1.84084C9.34394 2.17588 9.63791 2.66694 9.88554 3.286C10.1332 3.90505 10.3296 4.63998 10.4636 5.44882C10.5976 6.25766 10.6666 7.12456 10.6666 8.00004Z", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.6666 8.00004C14.6666 8.87552 14.4941 9.74243 14.1591 10.5513C13.8241 11.3601 13.333 12.095 12.714 12.7141C12.0949 13.3331 11.36 13.8242 10.5511 14.1592C9.74231 14.4943 8.8754 14.6667 7.99992 14.6667C7.12444 14.6667 6.25753 14.4943 5.4487 14.1592C4.63986 13.8242 3.90493 13.3331 3.28587 12.7141C2.66682 12.095 2.17575 11.3601 1.84072 10.5513C1.50569 9.74243 1.33325 8.87552 1.33325 8.00004C1.33325 7.12456 1.50569 6.25766 1.84072 5.44882C2.17575 4.63998 2.66682 3.90505 3.28587 3.286C3.90493 2.66694 4.63986 2.17587 5.4487 1.84084C6.25753 1.50581 7.12444 1.33337 7.99992 1.33337C8.8754 1.33337 9.74231 1.50581 10.5511 1.84084C11.36 2.17588 12.0949 2.66694 12.714 3.286C13.333 3.90505 13.8241 4.63998 14.1591 5.44882C14.4941 6.25766 14.6666 7.12456 14.6666 8.00004L14.6666 8.00004Z", stroke: "white", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1382_2297" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const WorldDark = SvgWorldDark;
const SvgWorldLight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1388_4065)" }, /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M1.33331 8.00004H14.6666M10.6666 8.00004C10.6666 8.87552 10.5977 9.74243 10.4637 10.5513C10.3296 11.3601 10.1332 12.095 9.8856 12.7141C9.63798 13.3331 9.344 13.8242 9.02047 14.1592C8.69693 14.4943 8.35017 14.6667 7.99998 14.6667C7.64979 14.6667 7.30303 14.4943 6.97949 14.1592C6.65596 13.8242 6.36198 13.3331 6.11436 12.7141C5.86674 12.095 5.67031 11.3601 5.5363 10.5513C5.40229 9.74243 5.33331 8.87552 5.33331 8.00004C5.33331 7.12456 5.40229 6.25766 5.5363 5.44882C5.67031 4.63998 5.86674 3.90505 6.11436 3.286C6.36199 2.66694 6.65596 2.17587 6.97949 1.84084C7.30303 1.50581 7.64979 1.33337 7.99998 1.33337C8.35017 1.33337 8.69694 1.50581 9.02047 1.84084C9.344 2.17588 9.63798 2.66694 9.8856 3.286C10.1332 3.90505 10.3296 4.63998 10.4637 5.44882C10.5977 6.25766 10.6666 7.12456 10.6666 8.00004Z", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.6666 8.00004C14.6666 8.87552 14.4942 9.74243 14.1592 10.5513C13.8241 11.3601 13.3331 12.095 12.714 12.7141C12.095 13.3331 11.36 13.8242 10.5512 14.1592C9.74237 14.4943 8.87546 14.6667 7.99998 14.6667C7.1245 14.6667 6.25759 14.4943 5.44876 14.1592C4.63992 13.8242 3.90499 13.3331 3.28593 12.7141C2.66688 12.095 2.17581 11.3601 1.84078 10.5513C1.50575 9.74243 1.33331 8.87552 1.33331 8.00004C1.33331 7.12456 1.50575 6.25766 1.84078 5.44882C2.17581 4.63998 2.66688 3.90505 3.28594 3.286C3.90499 2.66694 4.63992 2.17587 5.44876 1.84084C6.2576 1.50581 7.1245 1.33337 7.99998 1.33337C8.87546 1.33337 9.74237 1.50581 10.5512 1.84084C11.36 2.17588 12.095 2.66694 12.714 3.286C13.3331 3.90505 13.8241 4.63998 14.1592 5.44882C14.4942 6.25766 14.6666 7.12456 14.6666 8.00004L14.6666 8.00004Z", stroke: "#6B7280", strokeWidth: 1.5 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1388_4065" }, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white" }))));
const WorldLight = SvgWorldLight;
const SvgNextIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.9762 10.0006L7.44069 6.46503C7.11526 6.13959 7.11526 5.61196 7.44069 5.28652C7.76613 4.96108 8.29377 4.96108 8.61921 5.28652L13.3333 10.0006L8.6192 14.7146C8.29377 15.04 7.76613 15.04 7.4407 14.7146C7.11526 14.3892 7.11526 13.8615 7.4407 13.5361L10.9762 10.0006Z", fill: "white" }));
const Next = SvgNextIcon;
const SvgSuperNextIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.6069 10.3031L11.0714 13.8387C10.746 14.1641 10.746 14.6918 11.0714 15.0172C11.3969 15.3426 11.9245 15.3426 12.2499 15.0172L16.964 10.3031L12.2499 5.58912C11.9245 5.26369 11.3969 5.26369 11.0714 5.58912C10.746 5.91456 10.746 6.4422 11.0714 6.76764L14.6069 10.3031Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M8.12501 10.3031L4.5895 13.8387C4.26406 14.1641 4.26406 14.6918 4.5895 15.0172C4.91493 15.3426 5.44257 15.3426 5.76801 15.0172L10.4821 10.3031L5.76801 5.58912C5.44257 5.26369 4.91494 5.26369 4.5895 5.58912C4.26407 5.91456 4.26406 6.4422 4.5895 6.76764L8.12501 10.3031Z", fill: "white" }));
const SuperNext = SvgSuperNextIcon;
const SvgPrevIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.20855 10.0005L12.7441 13.5361C13.0695 13.8615 13.0695 14.3891 12.7441 14.7146C12.4186 15.04 11.891 15.04 11.5655 14.7146L6.85146 10.0005L11.5656 5.28651C11.891 4.96108 12.4186 4.96108 12.7441 5.28651C13.0695 5.61195 13.0695 6.13959 12.7441 6.46502L9.20855 10.0005Z", fill: "white" }));
const Prev = SvgPrevIcon;
const SvgSuperPrevIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.35717 10.3031L9.89268 13.8387C10.2181 14.1641 10.2181 14.6918 9.89268 15.0172C9.56724 15.3426 9.03961 15.3426 8.71417 15.0172L4.00008 10.3031L8.71417 5.58912C9.03961 5.26369 9.56724 5.26369 9.89267 5.58912C10.2181 5.91456 10.2181 6.4422 9.89267 6.76764L6.35717 10.3031Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M12.839 10.3031L16.3745 13.8387C16.6999 14.1641 16.6999 14.6918 16.3745 15.0172C16.0491 15.3426 15.5214 15.3426 15.196 15.0172L10.4819 10.3031L15.196 5.58912C15.5214 5.26369 16.0491 5.26369 16.3745 5.58912C16.6999 5.91456 16.6999 6.4422 16.3745 6.76764L12.839 10.3031Z", fill: "white" }));
const SuperPrev = SvgSuperPrevIcon;
const SvgCalendar$1 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.66602 10.0007C1.66602 6.85795 1.66602 5.28661 2.64233 4.3103C3.61864 3.33398 5.18999 3.33398 8.33268 3.33398H11.666C14.8087 3.33398 16.3801 3.33398 17.3564 4.3103C18.3327 5.28661 18.3327 6.85795 18.3327 10.0007V11.6673C18.3327 14.81 18.3327 16.3814 17.3564 17.3577C16.3801 18.334 14.8087 18.334 11.666 18.334H8.33268C5.18999 18.334 3.61864 18.334 2.64233 17.3577C1.66602 16.3814 1.66602 14.81 1.66602 11.6673V10.0007Z", stroke: "white", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M5.83398 3.33398V2.08398", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M14.166 3.33398V2.08398", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M1.66602 7.5H18.3327", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }));
const CalendarDark = SvgCalendar$1;
const SvgCalendar = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.66669 10C1.66669 6.85734 1.66669 5.286 2.643 4.30968C3.61931 3.33337 5.19066 3.33337 8.33335 3.33337H11.6667C14.8094 3.33337 16.3807 3.33337 17.357 4.30968C18.3334 5.286 18.3334 6.85734 18.3334 10V11.6667C18.3334 14.8094 18.3334 16.3808 17.357 17.3571C16.3807 18.3334 14.8094 18.3334 11.6667 18.3334H8.33335C5.19066 18.3334 3.61931 18.3334 2.643 17.3571C1.66669 16.3808 1.66669 14.8094 1.66669 11.6667V10Z", stroke: "#6B7280", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M5.83331 3.33337V2.08337", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M14.1667 3.33337V2.08337", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.5, d: "M1.66669 7.5H18.3334", stroke: "#6B7280", strokeWidth: 1.5, strokeLinecap: "round" }));
const CalendarLight = SvgCalendar;
const SvgCpe = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.85 0.999994C12.85 0.530552 12.4695 0.149994 12 0.149994C11.5306 0.149994 11.15 0.530552 11.15 0.999994V14C11.15 14.4694 11.5306 14.85 12 14.85C12.4695 14.85 12.85 14.4694 12.85 14V0.999994Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M4 15C4 11.2723 6.54955 8.14011 10 7.25203V9.02408C7.501 9.86007 5.7 12.2197 5.7 15C5.7 18.4794 8.52061 21.3 12 21.3C15.4794 21.3 18.3 18.4794 18.3 15C18.3 12.2197 16.499 9.86007 14 9.02408V7.25203C17.4505 8.14011 20 11.2723 20 15C20 19.4183 16.4183 23 12 23C7.58172 23 4 19.4183 4 15Z", fill: "currentColor", fillOpacity: 0.45 }));
const Cpe = SvgCpe;
const SvgFloor = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6142 3.24132C11.8598 3.13214 12.1402 3.13215 12.3858 3.24132L21.1396 7.13189C21.8918 7.46621 21.8919 8.5338 21.1396 8.86813L12.3858 12.7587C12.1402 12.8679 11.8598 12.8679 11.6142 12.7587L2.8604 8.86813C2.10818 8.53381 2.10817 7.46621 2.8604 7.13189L11.6142 3.24132ZM12 4.93018L5.09289 8.00001L12 11.0698L18.9071 8.00001L12 4.93018Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M12 15.0698L3.15711 11L2.8604 11.1319C2.10817 11.4662 2.10818 12.5338 2.8604 12.8681L11.6142 16.7587C11.8598 16.8679 12.1402 16.8679 12.3858 16.7587L21.1396 12.8681C21.8919 12.5338 21.8918 11.4662 21.1396 11.1319L21 11.0698L12 15.0698Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M3.15711 15L12 19.0698L20.8429 15L21.1396 15.1319C21.8918 15.4662 21.8919 16.5338 21.1396 16.8681L12.3858 20.7587C12.1402 20.8679 11.8598 20.8679 11.6142 20.7587L2.8604 16.8681C2.10818 16.5338 2.10817 15.4662 2.8604 15.1319L3.15711 15Z", fill: "currentColor", fillOpacity: 0.45 }));
const Floor = SvgFloor;
const SvgInfrastructure = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5033 4.30955C4.65935 4.20551 4.8427 4.14999 5.03026 4.14999H20.9C21.4247 4.14999 21.85 4.57532 21.85 5.09999V8.89999C21.85 9.42467 21.4247 9.84999 20.9 9.84999H5.03026C4.84271 9.84999 4.65935 9.79448 4.5033 9.69044L1.6533 7.79044C1.08925 7.41441 1.08925 6.58558 1.6533 6.20955L4.5033 4.30955ZM5.25735 5.84999L3.53235 6.99999L5.25735 8.14999H20.15V5.84999H5.25735Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.84999 14.35V20.15H6.14999V18H7.84999V20.15H11.15V18H12.85V20.15H16.15V18H17.85V20.15H21.15V14.35H2.84999ZM1.14999 13.6C1.14999 13.0753 1.57532 12.65 2.09999 12.65H21.9C22.4247 12.65 22.85 13.0753 22.85 13.6V20.9C22.85 21.4247 22.4247 21.85 21.9 21.85H2.09999C1.57532 21.85 1.14999 21.4247 1.14999 20.9V13.6Z", fill: "currentColor", fillOpacity: 0.45 }));
const Infrastructure = SvgInfrastructure;
const SvgScanner = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.075 4.7H4.7V8.075H3V4.05C3 3.47011 3.4701 3 4.05 3H8.075V4.7Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M16.125 4.7H19.5V8.075H21.2V4.05C21.2 3.4701 20.7299 3 20.15 3H16.125V4.7Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M19.5 16.125V19.5H16.125V21.2H20.15C20.7299 21.2 21.2 20.7299 21.2 20.15V16.125H19.5Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M4.7 16.125V19.5H8.075V21.2H4.05C3.47011 21.2 3 20.7299 3 20.15V16.125H4.7Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.033 14.6752C15.5741 14.2159 15.0379 13.8411 14.449 13.5679C15.2795 12.895 15.8093 11.8684 15.8093 10.7171C15.8093 8.68575 14.1153 7.01926 12.084 7.05043C10.0839 7.08159 8.47239 8.71141 8.47239 10.7171C8.47239 11.8684 9.00405 12.895 9.83271 13.5679C9.24368 13.8409 8.70746 14.2158 8.24872 14.6752C7.57879 15.3464 7.10266 16.1612 6.85 17.05H8.24161C8.44897 16.5156 8.76753 16.0254 9.18555 15.6084C9.573 15.2188 10.0339 14.91 10.5415 14.6998C11.049 14.4896 11.5933 14.3822 12.1427 14.3837C13.2592 14.3837 14.3097 14.8182 15.0998 15.6084C15.5168 16.0254 15.8349 16.5156 16.0424 17.05H17.4353C17.1823 16.1612 16.7054 15.3464 16.033 14.6752ZM12.1427 13.0637C11.5157 13.0637 10.9254 12.8199 10.4835 12.3762C10.2618 12.1562 10.0867 11.8938 9.96854 11.6047C9.85042 11.3155 9.79175 11.0055 9.79604 10.6932C9.80154 10.0919 10.0417 9.51074 10.4615 9.07991C10.9015 8.62891 11.49 8.37775 12.1189 8.37042C12.7404 8.36492 13.3435 8.60691 13.7872 9.04141C14.2418 9.48691 14.4912 10.0827 14.4912 10.7171C14.4912 11.3441 14.2473 11.9326 13.8037 12.3762C13.586 12.5949 13.3271 12.7683 13.042 12.8863C12.7569 13.0043 12.4513 13.0646 12.1427 13.0637Z", fill: "currentColor", fillOpacity: 0.45 }));
const Scanner = SvgScanner;
const SvgGps = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.3333 12C15.3333 13.8409 13.8409 15.3333 12 15.3333C10.159 15.3333 8.66667 13.8409 8.66667 12C8.66667 10.1591 10.159 8.66668 12 8.66668C13.8409 8.66668 15.3333 10.1591 15.3333 12Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.4508 11.1667H21.5833C21.8136 11.1667 22 11.353 22 11.5833V12.4166C22 12.647 21.8136 12.8333 21.5833 12.8333H19.4508C19.0651 16.3035 16.3039 19.0651 12.8333 19.4509V21.5833C12.8333 21.8136 12.647 22 12.4167 22H11.5833C11.353 22 11.1667 21.8136 11.1667 21.5833V19.4509C7.69608 19.0651 4.93492 16.3035 4.54918 12.8333H2.41668C2.18637 12.8333 2 12.647 2 12.4166V11.5833C2 11.353 2.18637 11.1667 2.41668 11.1667H4.54918C4.93492 7.69645 7.69608 4.93492 11.1667 4.54914V2.41668C11.1667 2.18637 11.353 2 11.5833 2H12.4167C12.647 2 12.8333 2.18637 12.8333 2.41668V4.54914C16.3039 4.93492 19.065 7.69648 19.4508 11.1667ZM6.16667 12C6.16667 15.2165 8.78385 17.8333 12 17.8333C15.2161 17.8333 17.8333 15.2166 17.8333 12C17.8333 8.78344 15.2161 6.16668 12 6.16668C8.78385 6.16668 6.16667 8.78348 6.16667 12Z", fill: "currentColor", fillOpacity: 0.45 }));
const Gps = SvgGps;
const SvgInspect = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.8125 2.0625H8.01562C8.22188 2.0625 8.39062 2.23125 8.39062 2.4375V3.5625C8.39062 3.76875 8.22188 3.9375 8.01562 3.9375H3.9375V8.0625C3.9375 8.26875 3.76875 8.4375 3.5625 8.4375H2.4375C2.23125 8.4375 2.0625 8.26875 2.0625 8.0625V2.8125C2.0625 2.39766 2.39766 2.0625 2.8125 2.0625Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M20.4375 15.5625H21.5625C21.7687 15.5625 21.9375 15.7312 21.9375 15.9375V21.1875C21.9375 21.6023 21.6023 21.9375 21.1875 21.9375H15.9844C15.7781 21.9375 15.6094 21.7687 15.6094 21.5625V20.4375C15.6094 20.2313 15.7781 20.0625 15.9844 20.0625H20.0625V15.9375C20.0625 15.7312 20.2313 15.5625 20.4375 15.5625Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M3.9375 20.0625H8.01562C8.22188 20.0625 8.39062 20.2313 8.39062 20.4375V21.5625C8.39062 21.7687 8.22188 21.9375 8.01562 21.9375H2.8125C2.39766 21.9375 2.0625 21.6023 2.0625 21.1875V15.9375C2.0625 15.7312 2.23125 15.5625 2.4375 15.5625H3.5625C3.76875 15.5625 3.9375 15.7312 3.9375 15.9375V20.0625Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M15.9844 2.0625H21.1875C21.6023 2.0625 21.9375 2.39766 21.9375 2.8125V8.0625C21.9375 8.26875 21.7687 8.4375 21.5625 8.4375H20.4375C20.2313 8.4375 20.0625 8.26875 20.0625 8.0625V3.9375H15.9844C15.7781 3.9375 15.6094 3.76875 15.6094 3.5625V2.4375C15.6094 2.23125 15.7781 2.0625 15.9844 2.0625Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M12.009 15C13.6478 15 15 13.6478 15 11.991C15 10.3612 13.6478 9 12.009 9C10.3612 9 9 10.3612 9 11.991C9 13.6478 10.3612 15 12.009 15Z", fill: "black", fillOpacity: 0.45 }));
const Inspect = SvgInspect;
const SvgArVr = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1902_3607", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1902_3607)" }, /* @__PURE__ */ React.createElement("path", { d: "M8.30777 16.6923V16.1653C8.30777 15.4898 8.64718 14.9472 9.32602 14.5375C10.0048 14.1278 10.8962 13.923 12 13.923C13.1038 13.923 13.9952 14.1278 14.674 14.5375C15.3528 14.9472 15.6923 15.4898 15.6923 16.1653V16.6923H8.30777ZM12 13C11.4948 13 11.0608 12.8186 10.698 12.4558C10.3352 12.0929 10.1538 11.6589 10.1538 11.1538C10.1538 10.6488 10.3352 10.2148 10.698 9.852C11.0608 9.48917 11.4948 9.30775 12 9.30775C12.5052 9.30775 12.9392 9.48917 13.302 9.852C13.6648 10.2148 13.8463 10.6488 13.8463 11.1538C13.8463 11.6589 13.6648 12.0929 13.302 12.4558C12.9392 12.8186 12.5052 13 12 13ZM3.00952 8.9595V16.8595C3.19802 17.1212 3.5006 17.3536 3.91727 17.5568C4.33393 17.7599 4.82952 17.9128 5.40402 18.0155V9.8405C4.89618 9.73784 4.44102 9.61309 4.03852 9.46625C3.63585 9.31959 3.29285 9.15067 3.00952 8.9595ZM20.9905 8.94425C20.7072 9.13525 20.3668 9.30417 19.9693 9.451C19.5718 9.59784 19.114 9.7225 18.596 9.825V18.0155C19.1705 17.9128 19.6661 17.7599 20.0828 17.5568C20.4994 17.3536 20.802 17.1212 20.9905 16.8595V8.94425ZM6.90377 19.8423C5.19227 19.6283 3.87018 19.2734 2.93752 18.7778C2.00485 18.2823 1.52893 17.6865 1.50977 16.9905V7.202C1.50977 6.32884 2.4011 5.66284 4.18377 5.204C5.96643 4.745 8.57185 4.5155 12 4.5155C15.4282 4.5155 18.0336 4.745 19.8163 5.204C21.5989 5.66284 22.4903 6.32884 22.4903 7.202V16.9905C22.4711 17.6865 21.9952 18.2823 21.0625 18.7778C20.1298 19.2734 18.8078 19.6283 17.0963 19.8423V8.5635C18.0039 8.411 18.7805 8.22125 19.426 7.99425C20.0715 7.76725 20.5264 7.52367 20.7905 7.2635C20.17 6.884 19.0492 6.5785 17.428 6.347C15.8068 6.11567 13.9975 6 12 6C9.97685 6 8.13868 6.1205 6.48552 6.3615C4.83235 6.6025 3.74035 6.90317 3.20952 7.2635C3.45452 7.534 3.89977 7.78017 4.54527 8.002C5.19077 8.22384 5.97693 8.411 6.90377 8.5635V19.8423Z", fill: "currentColor", fillOpacity: 0.45 })));
const ArVr = SvgArVr;
const SvgLaptopMac = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1902_3565", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1902_3565)" }, /* @__PURE__ */ React.createElement("path", { d: "M2.13475 19.6345C1.68725 19.6345 1.30292 19.4739 0.98175 19.1528C0.660583 18.8317 0.5 18.4475 0.5 18H4.30775C3.80258 18 3.375 17.825 3.025 17.475C2.675 17.125 2.5 16.6974 2.5 16.1923V5.30775C2.5 4.80258 2.675 4.375 3.025 4.025C3.375 3.675 3.80258 3.5 4.30775 3.5H19.6923C20.1974 3.5 20.625 3.675 20.975 4.025C21.325 4.375 21.5 4.80258 21.5 5.30775V16.1923C21.5 16.6974 21.325 17.125 20.975 17.475C20.625 17.825 20.1974 18 19.6923 18H23.5C23.5 18.4475 23.3394 18.8317 23.0182 19.1528C22.6971 19.4739 22.3127 19.6345 21.8652 19.6345H2.13475ZM12 18.8845C12.2257 18.8845 12.4167 18.8063 12.573 18.65C12.7295 18.4937 12.8077 18.3027 12.8077 18.077C12.8077 17.8513 12.7295 17.6603 12.573 17.5038C12.4167 17.3474 12.2257 17.2693 12 17.2693C11.7743 17.2693 11.5833 17.3474 11.427 17.5038C11.2705 17.6603 11.1923 17.8513 11.1923 18.077C11.1923 18.3027 11.2705 18.4937 11.427 18.65C11.5833 18.8063 11.7743 18.8845 12 18.8845ZM4.30775 16.5H19.6923C19.7693 16.5 19.8398 16.468 19.9038 16.404C19.9679 16.3398 20 16.2692 20 16.1923V5.30775C20 5.23075 19.9679 5.16025 19.9038 5.09625C19.8398 5.03208 19.7693 5 19.6923 5H4.30775C4.23075 5 4.16025 5.03208 4.09625 5.09625C4.03208 5.16025 4 5.23075 4 5.30775V16.1923C4 16.2692 4.03208 16.3398 4.09625 16.404C4.16025 16.468 4.23075 16.5 4.30775 16.5Z", fill: "currentColor", fillOpacity: 0.45 })));
const Laptop = SvgLaptopMac;
const SvgPhoneIphone = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1902_3580", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1902_3580)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.30775 22.5C6.80908 22.5 6.38308 22.3234 6.02975 21.9703C5.67658 21.6169 5.5 21.1909 5.5 20.6923V3.30775C5.5 2.80258 5.675 2.375 6.025 2.025C6.375 1.675 6.80258 1.5 7.30775 1.5H16.7308C17.2294 1.5 17.6553 1.67658 18.0085 2.02975C18.3618 2.38308 18.5385 2.80908 18.5385 3.30775V6.4655C18.8128 6.53717 19.0417 6.68042 19.225 6.89525C19.4083 7.10992 19.5 7.35958 19.5 7.64425V9.52875C19.5 9.81342 19.4083 10.0632 19.225 10.278C19.0417 10.4927 18.8128 10.6359 18.5385 10.7078V20.6923C18.5385 21.1909 18.3618 21.6169 18.0085 21.9703C17.6553 22.3234 17.2294 22.5 16.7308 22.5H7.30775ZM7.30775 21H16.7308C16.8204 21 16.8942 20.9712 16.952 20.9135C17.0097 20.8558 17.0385 20.7821 17.0385 20.6923V3.30775C17.0385 3.21792 17.0097 3.14417 16.952 3.0865C16.8942 3.02883 16.8204 3 16.7308 3H7.30775C7.21792 3 7.14417 3.02883 7.0865 3.0865C7.02883 3.14417 7 3.21792 7 3.30775V20.6923C7 20.7821 7.02883 20.8558 7.0865 20.9135C7.14417 20.9712 7.21792 21 7.30775 21ZM9.94225 19.6152H14.0962C14.3091 19.6152 14.4872 19.5435 14.6307 19.4C14.7744 19.2563 14.8462 19.0781 14.8462 18.8652C14.8462 18.6526 14.7744 18.4744 14.6307 18.3307C14.4872 18.1873 14.3091 18.1155 14.0962 18.1155H9.94225C9.72942 18.1155 9.55125 18.1873 9.40775 18.3307C9.26408 18.4744 9.19225 18.6526 9.19225 18.8652C9.19225 19.0781 9.26408 19.2563 9.40775 19.4C9.55125 19.5435 9.72942 19.6152 9.94225 19.6152Z", fill: "currentColor", fillOpacity: 0.45 })));
const Phone = SvgPhoneIphone;
const SvgSensorsKrx = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1902_3621", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1902_3621)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.1135 17.2963C3.60583 16.5346 3.21 15.707 2.926 14.8135C2.642 13.9198 2.5 12.982 2.5 12C2.5 11.0077 2.642 10.0673 2.926 9.17876C3.21 8.29043 3.60583 7.46543 4.1135 6.70376L5.3655 7.52501C4.93217 8.15834 4.59625 8.85418 4.35775 9.61251C4.11925 10.3708 4 11.1667 4 12C4 12.8333 4.11925 13.6266 4.35775 14.3798C4.59625 15.1329 4.93217 15.8262 5.3655 16.4595L4.1135 17.2963ZM12 17.8078C10.391 17.8078 9.02083 17.242 7.8895 16.1105C6.758 14.9792 6.19225 13.609 6.19225 12C6.19225 10.391 6.758 9.02084 7.8895 7.88951C9.02083 6.75801 10.391 6.19226 12 6.19226C13.609 6.19226 14.9792 6.75801 16.1105 7.88951C17.242 9.02084 17.8077 10.391 17.8077 12C17.8077 13.609 17.242 14.9792 16.1105 16.1105C14.9792 17.242 13.609 17.8078 12 17.8078ZM12 16.3078C13.1898 16.3078 14.2052 15.8873 15.0462 15.0463C15.8872 14.2053 16.3077 13.1898 16.3077 12C16.3077 10.8102 15.8872 9.79476 15.0462 8.95376C14.2052 8.11276 13.1898 7.69226 12 7.69226C10.8102 7.69226 9.79475 8.11276 8.95375 8.95376C8.11275 9.79476 7.69225 10.8102 7.69225 12C7.69225 13.1898 8.11275 14.2053 8.95375 15.0463C9.79475 15.8873 10.8102 16.3078 12 16.3078ZM19.8615 17.2963L18.625 16.4595C19.0583 15.8262 19.3958 15.1329 19.6375 14.3798C19.8792 13.6266 20 12.8333 20 12C20 11.1667 19.8792 10.3708 19.6375 9.61251C19.3958 8.85418 19.0583 8.15834 18.625 7.52501L19.8615 6.70376C20.3757 7.46543 20.7773 8.29043 21.0663 9.17876C21.3554 10.0673 21.5 11.0077 21.5 12C21.5 12.982 21.3554 13.9198 21.0663 14.8135C20.7773 15.707 20.3757 16.5346 19.8615 17.2963Z", fill: "currentColor", fillOpacity: 0.45 })));
const Sensors = SvgSensorsKrx;
const SvgSmartToy = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1902_3635", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1902_3635)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 14.5C3.80133 14.5 3.21 14.258 2.726 13.774C2.242 13.29 2 12.6987 2 12C2 11.3013 2.242 10.71 2.726 10.226C3.21 9.742 3.80133 9.5 4.5 9.5V7.30775C4.5 6.81058 4.677 6.385 5.031 6.031C5.385 5.677 5.81058 5.5 6.30775 5.5H9.5C9.5 4.80133 9.742 4.21 10.226 3.726C10.71 3.242 11.3013 3 12 3C12.6987 3 13.29 3.242 13.774 3.726C14.258 4.21 14.5 4.80133 14.5 5.5H17.6923C18.1894 5.5 18.615 5.677 18.969 6.031C19.323 6.385 19.5 6.81058 19.5 7.30775V9.5C20.1987 9.5 20.79 9.742 21.274 10.226C21.758 10.71 22 11.3013 22 12C22 12.6987 21.758 13.29 21.274 13.774C20.79 14.258 20.1987 14.5 19.5 14.5V18.6923C19.5 19.1894 19.323 19.615 18.969 19.969C18.615 20.323 18.1894 20.5 17.6923 20.5H6.30775C5.81058 20.5 5.385 20.323 5.031 19.969C4.677 19.615 4.5 19.1894 4.5 18.6923V14.5ZM8.99875 12.75C9.34575 12.75 9.641 12.6286 9.8845 12.3857C10.1282 12.1429 10.25 11.8481 10.25 11.5013C10.25 11.1543 10.1286 10.859 9.88575 10.6155C9.64292 10.3718 9.34808 10.25 9.00125 10.25C8.65425 10.25 8.359 10.3714 8.1155 10.6143C7.87183 10.8571 7.75 11.1519 7.75 11.4988C7.75 11.8458 7.87142 12.141 8.11425 12.3845C8.35708 12.6282 8.65192 12.75 8.99875 12.75ZM14.9988 12.75C15.3458 12.75 15.641 12.6286 15.8845 12.3857C16.1282 12.1429 16.25 11.8481 16.25 11.5013C16.25 11.1543 16.1286 10.859 15.8857 10.6155C15.6429 10.3718 15.3481 10.25 15.0013 10.25C14.6543 10.25 14.359 10.3714 14.1155 10.6143C13.8718 10.8571 13.75 11.1519 13.75 11.4988C13.75 11.8458 13.8714 12.141 14.1143 12.3845C14.3571 12.6282 14.6519 12.75 14.9988 12.75ZM8.25 16.75H15.75V15.25H8.25V16.75ZM6.30775 19H17.6923C17.7821 19 17.8558 18.9712 17.9135 18.9135C17.9712 18.8558 18 18.7821 18 18.6923V7.30775C18 7.21792 17.9712 7.14417 17.9135 7.0865C17.8558 7.02883 17.7821 7 17.6923 7H6.30775C6.21792 7 6.14417 7.02883 6.0865 7.0865C6.02883 7.14417 6 7.21792 6 7.30775V18.6923C6 18.7821 6.02883 18.8558 6.0865 18.9135C6.14417 18.9712 6.21792 19 6.30775 19Z", fill: "currentColor", fillOpacity: 0.45 })));
const SmartToy = SvgSmartToy;
const SvgVehicle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.48 11.52H19.48C19.26 11.52 19.08 11.7 19.08 11.92V13.348L18.86 13.432C18.732 12.816 18.456 11.72 17.972 10.74C17.716 10.228 17.172 9.89601 16.584 9.89601H14.732L14.372 8.46001C14.328 8.28401 14.168 8.15601 13.984 8.15601H10.024C9.84 8.15601 9.68 8.28001 9.636 8.46001L9.276 9.89601H7.424C6.836 9.89601 6.288 10.228 6.036 10.74C5.552 11.72 5.272 12.816 5.144 13.432L4.924 13.352V11.92C4.924 11.7 4.744 11.52 4.524 11.52H3.52C2.684 11.52 2 12.2 2 13.04V13.624C2 13.844 2.18 14.024 2.4 14.024H4.448L4.48 14.036C4.128 14.356 3.904 14.816 3.904 15.328V18.448C3.904 18.988 4.272 19.436 4.772 19.568V20.192C4.772 20.748 5.224 21.2 5.78 21.2H7.164C7.72 21.2 8.172 20.748 8.172 20.192V19.612H15.832V20.192C15.832 20.748 16.284 21.2 16.84 21.2H18.224C18.78 21.2 19.232 20.748 19.232 20.192V19.568C19.728 19.436 20.1 18.984 20.1 18.448V15.328C20.1 14.816 19.876 14.356 19.524 14.036L19.556 14.024H21.6C21.82 14.024 22 13.844 22 13.624V13.04C22 12.2 21.32 11.52 20.48 11.52ZM10.332 8.95201H13.664L13.9 9.89201H10.096L10.332 8.95201ZM6.748 11.092C6.868 10.848 7.132 10.692 7.42 10.692H9.584H14.416H16.58C16.868 10.692 17.132 10.848 17.252 11.092C17.688 11.976 17.948 12.992 18.068 13.568H5.928C6.052 12.992 6.308 11.976 6.748 11.092ZM4.124 13.224H2.8V13.04C2.8 12.644 3.124 12.32 3.52 12.32H4.124V13.224ZM7.372 20.192C7.372 20.304 7.28 20.4 7.164 20.4H5.78C5.668 20.4 5.572 20.308 5.572 20.192V19.612H7.372V20.192ZM18.428 20.192C18.428 20.304 18.336 20.4 18.22 20.4H16.836C16.724 20.4 16.628 20.308 16.628 20.192V19.612H18.428V20.192ZM19.296 18.444C19.296 18.644 19.132 18.808 18.932 18.808H18.832H16.232H7.772H5.172H5.072C4.872 18.808 4.708 18.644 4.708 18.444V15.324C4.708 14.796 5.136 14.368 5.664 14.368H18.34C18.868 14.368 19.296 14.796 19.296 15.324V18.444ZM21.2 13.224H19.88V12.32H20.484C20.88 12.32 21.204 12.644 21.204 13.04V13.224H21.2Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M13.9844 8.0564C14.2147 8.05657 14.4137 8.21592 14.4688 8.4353L14.8096 9.79565H16.584C17.1699 9.79565 17.7157 10.106 18.0068 10.5955L18.0615 10.6951V10.696C18.5219 11.6282 18.7937 12.6618 18.9316 13.2966L18.9805 13.2781V11.9197C18.9806 11.6446 19.2053 11.4197 19.4805 11.4197H20.4805C21.3754 11.4199 22.0995 12.1448 22.0996 13.0398V13.6238C22.0996 13.899 21.8748 14.1238 21.5996 14.1238H19.7471C20.0271 14.4471 20.2002 14.8669 20.2002 15.3279V18.448C20.2002 19.004 19.832 19.4734 19.332 19.6404V20.1921C19.332 20.8033 18.8348 21.2996 18.2236 21.2996H16.8398C16.2287 21.2995 15.7325 20.8033 15.7324 20.1921V19.7117H8.27246V20.1921C8.27239 20.8033 7.77522 21.2995 7.16406 21.2996H5.78027C5.16909 21.2996 4.67195 20.8033 4.67188 20.1921V19.6414C4.16826 19.4749 3.80371 19.0079 3.80371 18.448V15.3279C3.80374 14.8669 3.97681 14.4471 4.25684 14.1238H2.40039C2.12516 14.1238 1.90039 13.899 1.90039 13.6238V13.0398C1.90051 12.1446 2.62876 11.4199 3.51953 11.4197H4.52441C4.79934 11.4199 5.02424 11.6447 5.02441 11.9197V13.281L5.07129 13.2986C5.20954 12.6637 5.48552 11.6291 5.94629 10.696L6 10.5955C6.28848 10.1054 6.83846 9.79571 7.42383 9.79565H9.19824L9.53906 8.4353C9.59443 8.21065 9.79507 8.0564 10.0244 8.0564H13.9844ZM5.67188 20.1921C5.67195 20.2516 5.72229 20.2996 5.78027 20.2996H7.16406C7.22352 20.2995 7.27239 20.2501 7.27246 20.1921V19.7117H5.67188V20.1921ZM16.7275 20.1921C16.7276 20.2516 16.778 20.2995 16.8359 20.2996H18.2197C18.2792 20.2996 18.3281 20.2501 18.3281 20.1921V19.7117H16.7275V20.1921ZM5.66406 14.4675C5.1913 14.4675 4.80763 14.8512 4.80762 15.324V18.4441C4.80766 18.5888 4.92752 18.7078 5.07227 18.7078H18.9316C19.0764 18.7078 19.1962 18.5888 19.1963 18.4441V15.324C19.1963 14.8512 18.8126 14.4675 18.3398 14.4675H5.66406ZM7.41992 10.7917C7.19835 10.7918 6.99695 10.8973 6.88184 11.0623L6.83789 11.1365C6.43283 11.9503 6.18549 12.8806 6.05371 13.4675H17.9424C17.8136 12.8814 17.5637 11.9507 17.1621 11.1365C17.0604 10.9296 16.8333 10.7918 16.5801 10.7917H7.41992ZM19.9805 13.1238H21.1035V13.0398C21.1034 12.6992 20.8249 12.4199 20.4844 12.4197H19.9805V13.1238ZM3.51953 12.4197C3.17904 12.4199 2.90051 12.6993 2.90039 13.0398V13.1238H4.02441V12.4197H3.51953ZM10.2246 9.79175H13.7715L13.5869 9.05249H10.4092L10.2246 9.79175Z", stroke: "currentColor", strokeOpacity: 0.45, strokeWidth: 0.2 }), /* @__PURE__ */ React.createElement("path", { d: "M7.50396 15.168C6.71996 15.168 6.07996 15.808 6.07996 16.592C6.07996 17.376 6.71996 18.016 7.50396 18.016C8.28796 18.016 8.92796 17.376 8.92796 16.592C8.92796 15.808 8.28796 15.168 7.50396 15.168ZM7.50396 17.212C7.15996 17.212 6.87996 16.932 6.87996 16.588C6.87996 16.244 7.15996 15.964 7.50396 15.964C7.84796 15.964 8.12796 16.244 8.12796 16.588C8.12796 16.932 7.84796 17.212 7.50396 17.212Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M7.50378 15.0684C8.34296 15.0684 9.0281 15.7526 9.0282 16.5918C9.0282 17.431 8.34301 18.1162 7.50378 18.1162C6.66463 18.1161 5.98035 17.431 5.98035 16.5918C5.98044 15.7527 6.66469 15.0685 7.50378 15.0684ZM7.50378 16.0645C7.21512 16.0645 6.98039 16.2992 6.98035 16.5879C6.98035 16.8766 7.21509 17.1122 7.50378 17.1123C7.79256 17.1123 8.0282 16.8767 8.0282 16.5879C8.02816 16.2992 7.79253 16.0645 7.50378 16.0645Z", stroke: "currentColor", strokeOpacity: 0.45, strokeWidth: 0.2 }), /* @__PURE__ */ React.createElement("path", { d: "M16.496 15.168C15.712 15.168 15.072 15.808 15.072 16.592C15.072 17.376 15.712 18.016 16.496 18.016C17.28 18.016 17.92 17.376 17.92 16.592C17.92 15.808 17.28 15.168 16.496 15.168ZM16.496 17.212C16.152 17.212 15.872 16.932 15.872 16.588C15.872 16.244 16.152 15.964 16.496 15.964C16.84 15.964 17.12 16.244 17.12 16.588C17.12 16.932 16.84 17.212 16.496 17.212Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M16.4958 15.0684C17.335 15.0684 18.0202 15.7526 18.0203 16.5918C18.0203 17.431 17.3351 18.1162 16.4958 18.1162C15.6567 18.1161 14.9724 17.431 14.9724 16.5918C14.9725 15.7527 15.6568 15.0685 16.4958 15.0684ZM16.4958 16.0645C16.2072 16.0645 15.9725 16.2992 15.9724 16.5879C15.9724 16.8766 16.2072 17.1122 16.4958 17.1123C16.7846 17.1123 17.0203 16.8767 17.0203 16.5879C17.0202 16.2992 16.7846 16.0645 16.4958 16.0645Z", stroke: "currentColor", strokeOpacity: 0.45, strokeWidth: 0.2 }), /* @__PURE__ */ React.createElement("path", { d: "M13.528 16.188H10.476C10.256 16.188 10.076 16.368 10.076 16.588C10.076 16.808 10.256 16.988 10.476 16.988H13.528C13.748 16.988 13.928 16.808 13.928 16.588C13.928 16.368 13.748 16.188 13.528 16.188Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M13.5282 16.0884C13.8034 16.0885 14.0282 16.3132 14.0282 16.5884C14.028 16.8634 13.8032 17.0883 13.5282 17.0884H10.4764C10.2013 17.0884 9.97665 16.8634 9.97644 16.5884C9.97644 16.3132 10.2012 16.0884 10.4764 16.0884H13.5282Z", stroke: "currentColor", strokeOpacity: 0.45, strokeWidth: 0.2 }), /* @__PURE__ */ React.createElement("path", { d: "M15.528 5.06005C15.632 5.06005 15.732 5.02005 15.812 4.94405C15.968 4.78805 15.968 4.53605 15.812 4.38005C13.712 2.28005 10.292 2.28005 8.19195 4.38005C8.03595 4.53605 8.03595 4.78805 8.19195 4.94405C8.34795 5.10005 8.59995 5.10005 8.75595 4.94405C10.544 3.15605 13.456 3.15605 15.244 4.94405C15.324 5.02005 15.424 5.06005 15.528 5.06005Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M8.12085 4.30896C10.2598 2.16999 13.7435 2.17015 15.8826 4.30896C16.0776 4.50401 16.0776 4.81996 15.8826 5.01501L15.8806 5.01697C15.7827 5.1098 15.6584 5.16049 15.5281 5.16052C15.3978 5.16052 15.2734 5.10975 15.1755 5.01697L15.1736 5.01501C13.4246 3.26607 10.5759 3.26607 8.8269 5.01501C8.63185 5.21006 8.3159 5.21007 8.12085 5.01501C7.92587 4.81996 7.92582 4.50399 8.12085 4.30896Z", stroke: "currentColor", strokeOpacity: 0.45, strokeWidth: 0.2 }), /* @__PURE__ */ React.createElement("path", { d: "M9.60003 5.78802C9.44403 5.94402 9.44403 6.19602 9.60003 6.35202C9.75603 6.50802 10.008 6.50802 10.164 6.35202C10.652 5.86402 11.304 5.59202 11.996 5.59202C12.688 5.59202 13.34 5.86002 13.828 6.35202C13.908 6.43202 14.008 6.46802 14.112 6.46802C14.216 6.46802 14.316 6.42802 14.396 6.35202C14.552 6.19602 14.552 5.94402 14.396 5.78802C13.756 5.14802 12.904 4.79602 11.996 4.79602C11.088 4.79602 10.24 5.14802 9.60003 5.78802Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M11.9957 4.69641C12.93 4.69641 13.8076 5.05831 14.4664 5.71692C14.6615 5.91197 14.6615 6.22792 14.4664 6.42297L14.4645 6.42493C14.3666 6.51772 14.2422 6.56848 14.1119 6.56848C13.9838 6.56846 13.8577 6.52315 13.7574 6.42297V6.422C13.2885 5.94918 12.6614 5.6925 11.9957 5.6925C11.3305 5.69258 10.7043 5.95369 10.235 6.42297C10.0399 6.61803 9.72398 6.61803 9.52893 6.42297C9.33395 6.22792 9.3339 5.91195 9.52893 5.71692C10.1876 5.05824 11.0613 4.69649 11.9957 4.69641Z", stroke: "currentColor", strokeOpacity: 0.45, strokeWidth: 0.2 }));
const Vehicle = SvgVehicle;
const SvgCellTower = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1919_329", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 25, height: 25 }, /* @__PURE__ */ React.createElement("rect", { x: 20752e-7, y: 0.416748, width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1919_329)" }, /* @__PURE__ */ React.createElement("path", { d: "M5.19059 17.2282C4.25342 16.2602 3.55184 15.1936 3.08584 14.0282C2.61984 12.8629 2.38684 11.6591 2.38684 10.4167C2.38684 9.17439 2.61984 7.97056 3.08584 6.80522C3.55184 5.63989 4.25342 4.57322 5.19059 3.60522L6.12134 4.53598C5.30851 5.35514 4.70209 6.27756 4.30209 7.30323C3.90209 8.32889 3.70209 9.36672 3.70209 10.4167C3.70209 11.4667 3.90209 12.5046 4.30209 13.5302C4.70209 14.5559 5.30851 15.4783 6.12134 16.2975L5.19059 17.2282ZM7.55209 14.8667C6.94059 14.2424 6.47684 13.5443 6.16084 12.7725C5.84484 12.0006 5.68684 11.2154 5.68684 10.4167C5.68684 9.61806 5.84484 8.83281 6.16084 8.06098C6.47684 7.28914 6.94059 6.59106 7.55209 5.96673L8.48284 6.89747C7.98934 7.36031 7.61917 7.90164 7.37234 8.52148C7.12551 9.14131 7.00209 9.77306 7.00209 10.4167C7.00209 11.0296 7.12392 11.6443 7.36759 12.261C7.61109 12.8776 7.98284 13.436 8.48284 13.936L7.55209 14.8667ZM7.54059 21.5897L10.6848 12.157C10.4053 11.9558 10.1864 11.7017 10.0281 11.3947C9.86976 11.0876 9.79059 10.7616 9.79059 10.4167C9.79059 9.80006 10.005 9.27731 10.4338 8.84848C10.8627 8.41964 11.3854 8.20522 12.0021 8.20522C12.6188 8.20522 13.1415 8.41964 13.5703 8.84848C13.9992 9.27731 14.2136 9.80006 14.2136 10.4167C14.2136 10.7616 14.1377 11.0843 13.9858 11.385C13.8338 11.6856 13.6117 11.943 13.3193 12.157L16.4636 21.5897H14.9443L14.2943 19.5897H9.72509L9.06934 21.5897H7.54059ZM10.2213 18.0897H13.7828L12.0021 12.7435L10.2213 18.0897ZM16.4521 14.8667L15.5213 13.936C16.0148 13.4731 16.385 12.9318 16.6318 12.312C16.8787 11.6921 17.0021 11.0604 17.0021 10.4167C17.0021 9.82306 16.8787 9.21473 16.6318 8.59173C16.385 7.96873 16.0148 7.40397 15.5213 6.89747L16.4521 5.96673C17.0636 6.59106 17.5197 7.29231 17.8203 8.07048C18.121 8.84881 18.2867 9.63406 18.3173 10.4262C18.3173 11.2251 18.161 12.0087 17.8483 12.7772C17.5355 13.5459 17.0701 14.2424 16.4521 14.8667ZM18.8136 17.2282L17.8828 16.2975C18.6957 15.4783 19.3021 14.5559 19.7021 13.5302C20.1021 12.5046 20.3021 11.4667 20.3021 10.4167C20.3021 9.36672 20.1021 8.32889 19.7021 7.30323C19.3021 6.27756 18.6957 5.35514 17.8828 4.53598L18.8136 3.60522C19.7444 4.57322 20.4444 5.63989 20.9136 6.80522C21.3828 7.97056 21.6173 9.17439 21.6173 10.4167C21.6173 11.6591 21.3937 12.8629 20.9463 14.0282C20.4988 15.1936 19.7879 16.2602 18.8136 17.2282Z", fill: "currentColor", fillOpacity: 0.45 })));
const cellTower = SvgCellTower;
const SvgCloud = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1919_373", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1919_373)" }, /* @__PURE__ */ React.createElement("path", { d: "M6.5 19.5C5.118 19.5 3.93917 19.0198 2.9635 18.0595C1.98783 17.0993 1.5 15.9283 1.5 14.5463C1.5 13.3231 1.89167 12.2352 2.675 11.2828C3.45833 10.3301 4.45767 9.76658 5.673 9.59225C5.9935 8.09742 6.74517 6.875 7.928 5.925C9.11067 4.975 10.468 4.5 12 4.5C13.809 4.5 15.3446 5.13108 16.6068 6.39325C17.8689 7.65542 18.5 9.191 18.5 11V11.5H18.8078C19.8616 11.582 20.7404 12.0058 21.4443 12.7713C22.1481 13.5366 22.5 14.4462 22.5 15.5C22.5 16.6153 22.1122 17.5608 21.3365 18.3365C20.5608 19.1122 19.6153 19.5 18.5 19.5H6.5ZM6.5 18H18.5C19.2 18 19.7917 17.7583 20.275 17.275C20.7583 16.7917 21 16.2 21 15.5C21 14.8 20.7583 14.2083 20.275 13.725C19.7917 13.2417 19.2 13 18.5 13H17V11C17 9.61667 16.5125 8.4375 15.5375 7.4625C14.5625 6.4875 13.3833 6 12 6C10.6167 6 9.4375 6.4875 8.4625 7.4625C7.4875 8.4375 7 9.61667 7 11H6.5C5.53333 11 4.70833 11.3417 4.025 12.025C3.34167 12.7083 3 13.5333 3 14.5C3 15.4667 3.34167 16.2917 4.025 16.975C4.70833 17.6583 5.53333 18 6.5 18Z", fill: "currentColor", fillOpacity: 0.45 })));
const cloud = SvgCloud;
const SvgDns = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1919_301", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1919_301)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.50125 6.55774C7.15425 6.55774 6.859 6.67916 6.6155 6.92199C6.37183 7.16482 6.25 7.45966 6.25 7.80649C6.25 8.15349 6.37142 8.44874 6.61425 8.69224C6.85708 8.93591 7.15192 9.05774 7.49875 9.05774C7.84575 9.05774 8.141 8.93632 8.3845 8.69349C8.62817 8.45066 8.75 8.15574 8.75 7.80874C8.75 7.46191 8.62858 7.16666 8.38575 6.92299C8.14292 6.67949 7.84808 6.55774 7.50125 6.55774ZM7.50125 15.9422C7.15425 15.9422 6.859 16.0637 6.6155 16.3065C6.37183 16.5493 6.25 16.8442 6.25 17.1912C6.25 17.5381 6.37142 17.8333 6.61425 18.077C6.85708 18.3205 7.15192 18.4422 7.49875 18.4422C7.84575 18.4422 8.141 18.3208 8.3845 18.078C8.62817 17.8352 8.75 17.5403 8.75 17.1935C8.75 16.8465 8.62858 16.5512 8.38575 16.3077C8.14292 16.0641 7.84808 15.9422 7.50125 15.9422ZM4.38475 3.80774H19.6152C19.8659 3.80774 20.0761 3.89232 20.2458 4.06149C20.4153 4.23049 20.5 4.43999 20.5 4.68999V10.8652C20.5 11.1359 20.4153 11.3607 20.2458 11.5395C20.0761 11.7183 19.8659 11.8077 19.6152 11.8077H4.38475C4.13408 11.8077 3.92392 11.7183 3.75425 11.5395C3.58475 11.3607 3.5 11.1359 3.5 10.8652V4.68999C3.5 4.43999 3.58475 4.23049 3.75425 4.06149C3.92392 3.89232 4.13408 3.80774 4.38475 3.80774ZM5 5.30774V10.3077H19V5.30774H5ZM4.38475 13.1922H19.596C19.8602 13.1922 20.0768 13.2807 20.246 13.4577C20.4153 13.6346 20.5 13.8538 20.5 14.1155V20.2307C20.5 20.5141 20.4153 20.7452 20.246 20.924C20.0768 21.1028 19.8602 21.1922 19.596 21.1922H4.404C4.13983 21.1922 3.92317 21.1028 3.754 20.924C3.58467 20.7452 3.5 20.5141 3.5 20.2307V14.1155C3.5 13.8538 3.58142 13.6346 3.74425 13.4577C3.90708 13.2807 4.12058 13.1922 4.38475 13.1922ZM5 14.6922V19.6922H19V14.6922H5Z", fill: "currentColor", fillOpacity: 0.45 })));
const dns = SvgDns;
const SvgElevator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1919_359", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1919_359)" }, /* @__PURE__ */ React.createElement("path", { d: "M7.44225 17.75H9.94225V13.8463H10.9423V11.3078C10.9423 10.8218 10.7721 10.4086 10.4317 10.0682C10.0914 9.72792 9.67825 9.55775 9.19225 9.55775H8.19225C7.70642 9.55775 7.29333 9.72792 6.953 10.0682C6.6125 10.4086 6.44225 10.8218 6.44225 11.3078V13.8463H7.44225V17.75ZM8.69225 8.59625C9.01658 8.59625 9.29 8.485 9.5125 8.2625C9.735 8.04 9.84625 7.76658 9.84625 7.44225C9.84625 7.11792 9.735 6.84458 9.5125 6.62225C9.29 6.39975 9.01658 6.2885 8.69225 6.2885C8.36792 6.2885 8.09458 6.39975 7.87225 6.62225C7.64975 6.84458 7.5385 7.11792 7.5385 7.44225C7.5385 7.76658 7.64975 8.04 7.87225 8.2625C8.09458 8.485 8.36792 8.59625 8.69225 8.59625ZM13.3558 10.75H17.452L15.4038 7.47125L13.3558 10.75ZM15.4038 16.5288L17.452 13.25H13.3558L15.4038 16.5288ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V5.30775C19 5.21792 18.9712 5.14417 18.9135 5.0865C18.8558 5.02883 18.7821 5 18.6923 5H5.30775C5.21792 5 5.14417 5.02883 5.0865 5.0865C5.02883 5.14417 5 5.21792 5 5.30775V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19Z", fill: "currentColor", fillOpacity: 0.45 })));
const structureElevator = SvgElevator;
const SvgFiberCabinet = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.75 21C2.98617 21 2.33683 20.7327 1.802 20.198C1.26733 19.6632 1 19.0138 1 18.25V6.75C1 5.98617 1.26733 5.33683 1.802 4.802C2.33683 4.26733 2.98617 4 3.75 4H11.25C12.0138 4 12.6632 4.26733 13.198 4.802C13.7327 5.33683 14 5.98617 14 6.75V13.05H15.327C15.8128 13.05 16.2259 13.2202 16.5663 13.5605C16.9068 13.901 17.077 14.3142 17.077 14.8V17.923C17.077 18.1397 17.1543 18.3253 17.3088 18.4798C17.4631 18.6343 17.6486 18.7115 17.8652 18.7115C18.0821 18.7115 18.2677 18.6343 18.422 18.4798C18.5765 18.3253 18.6538 18.1397 18.6538 17.923V11.25C18.1294 11.25 17.6842 11.067 17.3183 10.701C16.9523 10.335 16.7693 9.88975 16.7693 9.36525V6.75H17.6538V4.94225H18.8463V6.75H19.9615V4.94225H21.1538V6.75H22.0385V9.36525C22.0385 9.88975 21.8555 10.335 21.4895 10.701C21.1233 11.067 20.6781 11.25 20.1538 11.25V17.8615C20.1538 18.4973 19.9313 19.0378 19.4865 19.4827C19.0417 19.9276 18.5012 20.15 17.8652 20.15C17.2294 20.15 16.6891 19.9276 16.2443 19.4827C15.7994 19.0378 15.577 18.4973 15.577 17.8615V14.7578C15.577 14.6679 15.5482 14.5942 15.4905 14.5365C15.4327 14.4788 15.3589 14.45 15.2693 14.45H14V17.5577C14 18.5044 13.6629 19.3147 12.9887 19.9887C12.3147 20.6629 11.5044 21 10.5577 21H3.75ZM3.75 19.5H10.5608C11.0959 19.5 11.5529 19.3098 11.9318 18.9295C12.3106 18.5492 12.5 18.0919 12.5 17.5577C12.5 17.0236 12.3098 16.5663 11.9295 16.186C11.5492 15.8057 11.0919 15.6155 10.5577 15.6155H5.7885C5.623 15.6155 5.48225 15.6735 5.36625 15.7895C5.25025 15.9055 5.19225 16.0462 5.19225 16.2115C5.19225 16.377 5.25025 16.5177 5.36625 16.6337C5.48225 16.7498 5.623 16.8077 5.7885 16.8077H10.5577C10.7702 16.8077 10.9483 16.8797 11.092 17.0235C11.2358 17.1673 11.3077 17.3455 11.3077 17.558C11.3077 17.7707 11.2358 17.9487 11.092 18.0922C10.9483 18.2359 10.7702 18.3077 10.5577 18.3077H5.7885C5.2015 18.3077 4.70542 18.1051 4.30025 17.6997C3.89492 17.2946 3.69225 16.7985 3.69225 16.2115C3.69225 15.6247 3.89492 15.1286 4.30025 14.7233C4.70542 14.3181 5.2015 14.1155 5.7885 14.1155H10.5577C10.9034 14.1155 11.2449 14.1623 11.5823 14.2558C11.9198 14.3494 12.2257 14.5058 12.5 14.725V6.75C12.5 6.4025 12.3785 6.10733 12.1355 5.8645C11.8927 5.6215 11.5975 5.5 11.25 5.5H3.75C3.4025 5.5 3.10733 5.6215 2.8645 5.8645C2.6215 6.10733 2.5 6.4025 2.5 6.75V18.25C2.5 18.5975 2.6215 18.8927 2.8645 19.1355C3.10733 19.3785 3.4025 19.5 3.75 19.5ZM3.75 19.5H10.5577H2.5H3.75Z", fill: "currentColor", fillOpacity: 0.45 }));
const fiberCabinet = SvgFiberCabinet;
const SvgFiberPedestal = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1919_491)" }, /* @__PURE__ */ React.createElement("path", { d: "M23.25 9.1875H22.3125V7.5C22.3125 7.18945 22.0605 6.9375 21.75 6.9375H19.3125V4.5C19.3125 3.36255 18.3867 2.4375 17.25 2.4375H6.75C5.61328 2.4375 4.6875 3.36255 4.6875 4.5V6.9375H2.25C1.93945 6.9375 1.6875 7.18945 1.6875 7.5V9.1875H0.75C0.439453 9.1875 0.1875 9.43945 0.1875 9.75C0.1875 10.0605 0.439453 10.3125 0.75 10.3125H1.6875V12C1.6875 12.3105 1.93945 12.5625 2.25 12.5625H4.6875V15C4.6875 16.1375 5.61328 17.0625 6.75 17.0625H9.1875V19.5C9.1875 19.8105 9.43945 20.0625 9.75 20.0625H11.4375V21C11.4375 21.3105 11.6895 21.5625 12 21.5625C12.3105 21.5625 12.5625 21.3105 12.5625 21V20.0625H14.25C14.5605 20.0625 14.8125 19.8105 14.8125 19.5V17.0625H17.25C18.3867 17.0625 19.3125 16.1375 19.3125 15V12.5625H21.75C22.0605 12.5625 22.3125 12.3105 22.3125 12V10.3125H23.25C23.5605 10.3125 23.8125 10.0605 23.8125 9.75C23.8125 9.43945 23.5605 9.1875 23.25 9.1875ZM2.8125 11.4375V8.0625H4.6875V11.4375H2.8125ZM13.6875 18.9375H10.3125V17.0625H13.6875V18.9375ZM18.1875 15C18.1875 15.5171 17.7671 15.9375 17.25 15.9375H6.75C6.23291 15.9375 5.8125 15.5171 5.8125 15V4.5C5.8125 3.98291 6.23291 3.5625 6.75 3.5625H17.25C17.7671 3.5625 18.1875 3.98291 18.1875 4.5V15ZM21.1875 11.4375H19.3125V8.0625H21.1875V11.4375Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M17.25 2.33789C18.4419 2.33789 19.4121 3.3073 19.4121 4.5V6.83789H21.75C22.1158 6.83789 22.4121 7.13422 22.4121 7.5V9.08789H23.25C23.6158 9.08789 23.9121 9.38422 23.9121 9.75C23.9121 10.1158 23.6158 10.4121 23.25 10.4121H22.4121V12C22.4121 12.3658 22.1158 12.6621 21.75 12.6621H19.4121V15C19.4121 16.1927 18.4419 17.1621 17.25 17.1621H14.9121V19.5C14.9121 19.8658 14.6158 20.1621 14.25 20.1621H12.6621V21C12.6621 21.3658 12.3658 21.6621 12 21.6621C11.6342 21.6621 11.3379 21.3658 11.3379 21V20.1621H9.75C9.38422 20.1621 9.08789 19.8658 9.08789 19.5V17.1621H6.75C5.55808 17.1621 4.58789 16.1927 4.58789 15V12.6621H2.25C1.88422 12.6621 1.58789 12.3658 1.58789 12V10.4121H0.75C0.384225 10.4121 0.0878906 10.1158 0.0878906 9.75C0.0878906 9.38422 0.384225 9.08789 0.75 9.08789H1.58789V7.5C1.58789 7.13422 1.88422 6.83789 2.25 6.83789H4.58789V4.5C4.58789 3.3073 5.55808 2.33789 6.75 2.33789H17.25ZM10.4121 18.8379H13.5879V17.1621H10.4121V18.8379ZM6.75 3.66211C6.28814 3.66211 5.91211 4.03814 5.91211 4.5V15C5.91211 15.4619 6.28814 15.8379 6.75 15.8379H17.25C17.7119 15.8379 18.0879 15.4619 18.0879 15V4.5C18.0879 4.03814 17.7119 3.66211 17.25 3.66211H6.75ZM19.4121 11.3379H21.0879V8.16211H19.4121V11.3379ZM2.91211 11.3379H4.58789V8.16211H2.91211V11.3379Z", stroke: "currentColor", strokeOpacity: 0.45, strokeWidth: 0.2 }), /* @__PURE__ */ React.createElement("path", { d: "M8.25 6.5625C8.56066 6.5625 8.8125 6.31066 8.8125 6C8.8125 5.68934 8.56066 5.4375 8.25 5.4375C7.93934 5.4375 7.6875 5.68934 7.6875 6C7.6875 6.31066 7.93934 6.5625 8.25 6.5625Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M8.25 14.0625C8.56066 14.0625 8.8125 13.8107 8.8125 13.5C8.8125 13.1893 8.56066 12.9375 8.25 12.9375C7.93934 12.9375 7.6875 13.1893 7.6875 13.5C7.6875 13.8107 7.93934 14.0625 8.25 14.0625Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M15.75 6.5625C16.0607 6.5625 16.3125 6.31066 16.3125 6C16.3125 5.68934 16.0607 5.4375 15.75 5.4375C15.4393 5.4375 15.1875 5.68934 15.1875 6C15.1875 6.31066 15.4393 6.5625 15.75 6.5625Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M15.75 14.0625C16.0607 14.0625 16.3125 13.8107 16.3125 13.5C16.3125 13.1893 16.0607 12.9375 15.75 12.9375C15.4393 12.9375 15.1875 13.1893 15.1875 13.5C15.1875 13.8107 15.4393 14.0625 15.75 14.0625Z", fill: "currentColor", fillOpacity: 0.45 })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1919_491" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "currentColor" }))));
const fiberPedestal = SvgFiberPedestal;
const SvgFlowerpot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.6691 0.00292969C12.0557 0.00292969 12.3693 0.316526 12.3693 0.703125V10.3154H13.7814V6.71777C13.7814 4.77625 14.8002 2.9765 16.465 1.97754C16.7965 1.77866 17.227 1.88635 17.426 2.21777C17.6249 2.54928 17.5172 2.97981 17.1857 3.17871C15.9426 3.92466 15.1818 5.26802 15.1818 6.71777V10.3154H16.5939V8.85254C16.5939 7.04177 17.6969 5.41279 19.3781 4.74023C19.7369 4.59691 20.1447 4.77207 20.2883 5.13086C20.4316 5.48973 20.2565 5.89748 19.8976 6.04102C18.7482 6.50104 17.9943 7.61435 17.9943 8.85254V10.3154H18.7004L18.841 10.3301C19.1602 10.3952 19.4006 10.6772 19.4006 11.0156V15.0029H19.6379L19.7785 15.0176C20.0977 15.0827 20.3381 15.3647 20.3381 15.7031V23.2969C20.3381 23.6835 20.0245 23.9971 19.6379 23.9971H3.70037C3.31388 23.9969 3.00017 23.6834 3.00017 23.2969V15.7031L3.01482 15.5625C3.07993 15.2434 3.36206 15.003 3.70037 15.0029H3.93767V11.0156L3.95232 10.875C4.01743 10.5559 4.29956 10.3155 4.63787 10.3154H5.34392V8.85254C5.34392 7.69171 4.68152 6.64067 3.65154 6.13477L3.4406 6.04102L3.31463 5.97461C3.04309 5.79555 2.92467 5.44469 3.04998 5.13086C3.17561 4.81677 3.50398 4.6433 3.82439 4.70117L3.96014 4.74023L4.26873 4.87793C5.77514 5.61761 6.74432 7.15491 6.74432 8.85254V10.3154H8.15642V6.71777C8.15642 5.35857 7.48801 4.09274 6.38006 3.3252L6.15252 3.17871L6.03924 3.09375C5.79929 2.8737 5.73831 2.50784 5.91228 2.21777C6.08624 1.92784 6.43731 1.81008 6.74432 1.91797L6.87322 1.97754L7.17791 2.1748C8.6614 3.20271 9.55682 4.89772 9.55682 6.71777V10.3154H10.9689V0.703125C10.9689 0.316602 11.2826 0.00305395 11.6691 0.00292969ZM4.40057 22.5967H18.9377V16.4033H4.40057V22.5967ZM5.33807 15.0029H18.0002V11.7158H5.33807V15.0029Z", fill: "currentColor", fillOpacity: 0.45 }));
const flowerpot = SvgFlowerpot;
const SvgHardDrive = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1919_315", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 25, height: 25 }, /* @__PURE__ */ React.createElement("rect", { x: 20752e-7, y: 0.416748, width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1919_315)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.30983 17.1283H19.6943C19.7842 17.1283 19.8579 17.0994 19.9156 17.0418C19.9732 16.9841 20.0021 16.9104 20.0021 16.8205V11.2438H4.00208V16.8205C4.00208 16.9104 4.03091 16.9841 4.08858 17.0418C4.14624 17.0994 4.21999 17.1283 4.30983 17.1283ZM17.0586 15.436C17.4056 15.436 17.7008 15.3146 17.9443 15.0718C18.188 14.8289 18.3098 14.534 18.3098 14.187C18.3098 13.8402 18.1884 13.5449 17.9456 13.3013C17.7027 13.0578 17.4078 12.936 17.0608 12.936C16.714 12.936 16.4187 13.0574 16.1751 13.3003C15.9316 13.5431 15.8098 13.8379 15.8098 14.1848C15.8098 14.5318 15.9312 14.827 16.1741 15.0705C16.4169 15.3142 16.7117 15.436 17.0586 15.436ZM21.5021 9.74377H19.3886L17.1771 7.49377H6.82708L4.61558 9.74377H2.50208L5.68683 6.52077C5.85083 6.35011 6.04333 6.21961 6.26433 6.12927C6.48533 6.03894 6.71783 5.99377 6.96183 5.99377H17.0423C17.2863 5.99377 17.5188 6.03894 17.7398 6.12927C17.9608 6.21961 18.1533 6.35011 18.3173 6.52077L21.5021 9.74377ZM4.30983 18.6283C3.81266 18.6283 3.38708 18.4513 3.03308 18.0973C2.67908 17.7433 2.50208 17.3177 2.50208 16.8205V9.74377H21.5021V16.8205C21.5021 17.3177 21.3251 17.7433 20.9711 18.0973C20.6171 18.4513 20.1915 18.6283 19.6943 18.6283H4.30983Z", fill: "currentColor", fillOpacity: 0.45 })));
const hardDriver = SvgHardDrive;
const SvgIconBuilding = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.14844 21.8486V1.84863H19.4878V21.8486H13.6123V16.973H10.042V21.8486H4.14844ZM5.48344 20.5136H8.70726V15.6383H14.947V20.5136H18.1529V3.18363H5.48344V20.5136ZM8.70726 12.6292H10.3137V11.0228H8.70726V12.6292ZM8.70726 8.01393H10.3137V6.40746H8.70726V8.01393ZM13.3226 12.6292H14.929V11.0228H13.3226V12.6292ZM13.3226 8.01393H14.929V6.40746H13.3226V8.01393Z", fill: "currentColor", fillOpacity: 0.45 }));
const structureBuilding = SvgIconBuilding;
const SvgLatticeTower = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.7236 2.10645L20.9746 6.20508L21.2676 6.39746V8.43359H19.9678V7.39941H15.2646L19.0361 20.0205H20.9678V21.3213H3.30176V20.0205H5.23242L9.00391 7.39941H4.30078V8.43359H3V6.39746L3.29395 6.20508L9.53516 2.10645L9.69727 2H14.5615L14.7236 2.10645ZM7.74316 20.0205H16.5254L12.1338 16.8799L7.74316 20.0205ZM6.88281 19.0371L11.0156 16.0811L8.33789 14.166L6.88281 19.0371ZM13.251 16.0811L17.3848 19.0371L15.9287 14.167L13.251 16.0811ZM9.27539 13.2383L12.1328 15.2822L14.9922 13.2383L12.1328 11.1943L9.27539 13.2383ZM9.04297 11.8066L11.0156 10.3955L9.7373 9.48145L9.04297 11.8066ZM13.25 10.3955L15.2236 11.8066L14.5293 9.48145L13.25 10.3955ZM10.1318 8.16504L12.1328 9.59668L14.1357 8.16504L13.9072 7.39941H10.3613L10.1318 8.16504ZM15.042 6.09863H18.4414L15.042 3.86914V6.09863ZM10.5273 6.09863H13.7412V3.2998H10.5273V6.09863ZM5.8252 6.09863H9.22656V3.86426L5.8252 6.09863Z", fill: "currentColor", fillOpacity: 0.45 }));
const latticeTower = SvgLatticeTower;
const SvgLocalGasStation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1919_387", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1919_387)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 20.5V5.30775C4.5 4.80258 4.675 4.375 5.025 4.025C5.375 3.675 5.80258 3.5 6.30775 3.5H11.6923C12.1974 3.5 12.625 3.675 12.975 4.025C13.325 4.375 13.5 4.80258 13.5 5.30775V11.8077H14.4615C14.9587 11.8077 15.3843 11.9847 15.7383 12.3387C16.0923 12.6927 16.2693 13.1182 16.2693 13.6152V18.1538C16.2693 18.4756 16.3811 18.7483 16.6048 18.972C16.8284 19.1958 17.1012 19.3077 17.423 19.3077C17.7448 19.3077 18.0176 19.1958 18.2413 18.972C18.4651 18.7483 18.577 18.4756 18.577 18.1538V11.1462C18.427 11.2359 18.2687 11.2981 18.102 11.3327C17.9353 11.3672 17.7603 11.3845 17.577 11.3845C16.9632 11.3845 16.4443 11.1726 16.0203 10.7488C15.5964 10.3249 15.3845 9.80608 15.3845 9.19225C15.3845 8.69742 15.5256 8.25675 15.8077 7.87025C16.0897 7.48375 16.4628 7.22442 16.927 7.09225L14.673 4.8385L15.5115 4L19.0768 7.504C19.3013 7.72833 19.4728 7.98825 19.5913 8.28375C19.7099 8.57925 19.7693 8.88208 19.7693 9.19225V18.1538C19.7693 18.8108 19.5426 19.366 19.0893 19.8195C18.6361 20.2732 18.0813 20.5 17.425 20.5C16.7685 20.5 16.213 20.2732 15.7585 19.8195C15.3042 19.366 15.077 18.8108 15.077 18.1538V13.3077C15.077 13.2179 15.0481 13.1442 14.9902 13.0865C14.9326 13.0288 14.8589 13 14.7693 13H13.5V20.5H4.5ZM6 10.25H12V5.30775C12 5.23075 11.9679 5.16025 11.9037 5.09625C11.8397 5.03208 11.7693 5 11.6923 5H6.30775C6.23075 5 6.16025 5.03208 6.09625 5.09625C6.03208 5.16025 6 5.23075 6 5.30775V10.25ZM17.577 10.1923C17.8603 10.1923 18.0978 10.0964 18.2895 9.90475C18.4812 9.71308 18.577 9.47558 18.577 9.19225C18.577 8.90892 18.4812 8.67142 18.2895 8.47975C18.0978 8.28808 17.8603 8.19225 17.577 8.19225C17.2937 8.19225 17.0562 8.28808 16.8645 8.47975C16.6728 8.67142 16.577 8.90892 16.577 9.19225C16.577 9.47558 16.6728 9.71308 16.8645 9.90475C17.0562 10.0964 17.2937 10.1923 17.577 10.1923ZM6 19H12V11.75H6V19Z", fill: "currentColor", fillOpacity: 0.45 })));
const gasStation = SvgLocalGasStation;
const SvgStadium = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("mask", { id: "mask0_1919_343", style: {
  maskType: "alpha"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 25, height: 25 }, /* @__PURE__ */ React.createElement("rect", { x: 20752e-7, y: 0.416748, width: 24, height: 24, fill: "#D9D9D9" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_1919_343)" }, /* @__PURE__ */ React.createElement("path", { d: "M3.73284 7.41676V3.72451L7.42509 5.57051L3.73284 7.41676ZM17.5791 7.41676V3.72451L21.2713 5.57051L17.5791 7.41676ZM11.1176 6.49376V2.80151L14.8098 4.64751L11.1176 6.49376ZM10.7521 22.061C9.54309 22.0212 8.43284 21.9202 7.42134 21.758C6.40984 21.5958 5.53517 21.3927 4.79734 21.1485C4.0595 20.9042 3.48292 20.6247 3.06759 20.31C2.65209 19.9953 2.44434 19.6655 2.44434 19.3205V10.7053C2.44434 10.3206 2.68925 9.96351 3.17909 9.63401C3.66875 9.30451 4.34117 9.0151 5.19634 8.76576C6.0515 8.51643 7.06175 8.31901 8.22709 8.17351C9.39242 8.02801 10.6508 7.95526 12.0021 7.95526C13.3534 7.95526 14.6118 8.02801 15.7771 8.17351C16.9424 8.31901 17.9527 8.51643 18.8078 8.76576C19.663 9.0151 20.3354 9.30451 20.8251 9.63401C21.3149 9.96351 21.5598 10.3206 21.5598 10.7053V19.3205C21.5598 19.6655 21.3521 19.9953 20.9366 20.31C20.5213 20.6247 19.9447 20.9042 19.2068 21.1485C18.469 21.3927 17.5943 21.5958 16.5828 21.758C15.5713 21.9202 14.4611 22.0212 13.2521 22.061V18.0705H10.7521V22.061ZM12.0021 11.9553C13.6379 11.9553 15.1107 11.8418 16.4203 11.6148C17.73 11.3879 18.738 11.1046 19.4443 10.7648C19.3353 10.5469 18.6203 10.2742 17.2993 9.94651C15.9782 9.61901 14.2124 9.45526 12.0021 9.45526C9.79175 9.45526 8.026 9.61901 6.70484 9.94651C5.38384 10.2742 4.66884 10.5469 4.55984 10.7648C5.26617 11.1046 6.23734 11.3879 7.47334 11.6148C8.70917 11.8418 10.2188 11.9553 12.0021 11.9553ZM9.25209 20.4495V16.5705H14.7521V20.4495C16.2073 20.3225 17.3871 20.1203 18.2916 19.8428C19.1961 19.5653 19.7855 19.304 20.0598 19.059V12.1398C19.0533 12.5769 17.8681 12.9055 16.5041 13.1255C15.1399 13.3453 13.6393 13.4553 12.0021 13.4553C10.3649 13.4553 8.86425 13.3453 7.50009 13.1255C6.13609 12.9055 4.95084 12.5769 3.94434 12.1398V19.059C4.21867 19.304 4.78892 19.5653 5.65509 19.8428C6.52109 20.1203 7.72009 20.3225 9.25209 20.4495Z", fill: "currentColor", fillOpacity: 0.45 })));
const stadium = SvgStadium;
const SvgStairs = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.5089 7.41409L11.9968 3.68088C12.0115 3.57355 11.9213 3.48109 11.8137 3.49298L8.06924 3.88568C7.92914 3.90009 7.86956 4.0687 7.96696 4.16862L9.07185 5.30201L4.24005 10.0123C4.17443 10.0763 4.17308 10.1823 4.23705 10.248L5.05118 11.0831C5.11515 11.1487 5.22117 11.15 5.28679 11.0861L10.1186 6.37574L11.2235 7.50913C11.3209 7.60905 11.491 7.55083 11.5089 7.41409Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.4187 7.40177C13.9382 7.40177 13.5487 7.79129 13.5487 8.27177V11.4018H10.4187C9.93819 11.4018 9.54868 11.7913 9.54868 12.2718V15.4018H5.91867C5.43818 15.4018 5.04868 15.7913 5.04868 16.2718V20.2318C5.04868 20.7123 5.43819 21.1018 5.91868 21.1018H18.8787C19.3591 21.1018 19.7487 20.7123 19.7487 20.2318V8.27177C19.7487 7.79132 19.3592 7.40177 18.8787 7.40177H14.4187ZM15.2487 12.2318V9.10177H18.0487V19.4018H6.74868V17.1018H10.3787C10.8592 17.1018 11.2487 16.7123 11.2487 16.2318V13.1018H14.3787C14.8592 13.1018 15.2487 12.7123 15.2487 12.2318Z", fill: "currentColor", fillOpacity: 0.45 }));
const structureStairs = SvgStairs;
const SvgStructures = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 2V21H11V2H13Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M9.5 6H7V3.5H9.5V6Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M9.5 3H7V2H9.5V3Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M17 6H14.5V3.5H17V6Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M17 3H14.5V2H17V3Z", fill: "currentColor", fillOpacity: 0.45 }));
const structures = SvgStructures;
const SvgTower = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.899 9.39932C18.7752 9.24588 18.5886 9.15667 18.3915 9.15667H16.4173L17.7171 4.24951C17.769 4.05387 17.727 3.84518 17.6036 3.68482C17.4801 3.52446 17.2892 3.4304 17.0868 3.4304H12.1741V1.65214C12.1741 1.29197 11.8821 1 11.522 1C11.1618 1 10.8698 1.29197 10.8698 1.65214V3.43044H5.95681C5.75439 3.43044 5.56344 3.52446 5.44003 3.68486C5.31658 3.84522 5.2746 4.05392 5.32642 4.24955L6.62631 9.15671H4.65211C4.45493 9.15671 4.26836 9.24592 4.14456 9.39936C4.02073 9.55284 3.97308 9.75402 4.01476 9.94674L5.0656 14.8035C5.13053 15.1035 5.39599 15.3177 5.703 15.3177H7.08715V22.3479C7.08715 22.708 7.37912 23 7.73929 23H15.3042C15.6644 23 15.9564 22.708 15.9564 22.3479V15.3177H17.3406C17.6476 15.3177 17.913 15.1035 17.978 14.8035L19.0289 9.94674C19.0706 9.75402 19.0228 9.55284 18.899 9.39932ZM16.2394 4.73471L15.9672 5.7621H7.07632L6.80416 4.73471H16.2394ZM7.97562 9.15671L7.42188 7.06633H15.6218L15.068 9.15671H7.97562ZM13.0824 10.4609L12.8294 14.0134H10.2141L9.96107 10.4609H13.0824ZM6.22911 14.0134L5.46048 10.4609H8.65362L8.90662 14.0134H6.22911ZM14.6521 21.6957H8.39142V15.3177H14.6521V21.6957H14.6521ZM16.8145 14.0134H14.137L14.39 10.4609H17.5832L16.8145 14.0134Z", fill: "currentColor", fillOpacity: 0.45 }));
const tower = SvgTower;
const SvgWaterTower = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1919_138)" }, /* @__PURE__ */ React.createElement("mask", { id: "path-1-outside-1_1919_138", maskUnits: "userSpaceOnUse", x: -1.06445, y: -1.06445, width: 22, height: 22, fill: "currentColor" }, /* @__PURE__ */ React.createElement("rect", { fill: "currentColor", x: -1.06445, y: -1.06445, width: 22, height: 22 }), /* @__PURE__ */ React.createElement("path", { d: "M5.92383 1.10742H8.13867V-0.0644531H11.7832V1.10742H12.3047C13.3108 1.10742 14.127 1.92346 14.127 2.92969V4.66211H15.8984C18.1991 4.66211 20.0645 6.5275 20.0645 8.82812V20.0645H16.4199V8.82812C16.4199 8.5399 16.1867 8.30664 15.8984 8.30664H14.127V10C14.127 11.0062 13.3108 11.8223 12.3047 11.8223H11.7832V18.7637H12.8906V20.0645H9.375V18.7637H10.4824V16.5098H3.58008V18.7637H4.6875V20.0645H1.17188V18.7637H2.2793V11.8223H1.75781C0.751654 11.8223 -0.0644531 11.0062 -0.0644531 10V2.92969C-0.0644527 1.92346 0.751654 1.10742 1.75781 1.10742H2.2793V-0.0644531H5.92383V1.10742ZM14.127 7.00586H15.8984C16.9046 7.00586 17.7207 7.8219 17.7207 8.82812V18.7637H18.7637V8.82812C18.7637 7.24547 17.4811 5.96289 15.8984 5.96289H14.127V7.00586ZM3.58008 15.209H10.4824V14.166H3.58008V15.209ZM3.58008 12.8652H10.4824V11.8223H3.58008V12.8652ZM3.58008 2.4082H1.75781C1.4696 2.4082 1.23633 2.64146 1.23633 2.92969V10C1.23633 10.2882 1.4696 10.5215 1.75781 10.5215H12.3047C12.5929 10.5215 12.8262 10.2882 12.8262 10V2.92969C12.8262 2.64146 12.5929 2.4082 12.3047 2.4082H10.4824V1.23633H9.43945V2.4082H4.62305V1.23633H3.58008V2.4082ZM7.56641 4.35742L7.56738 4.35938C7.56808 4.36038 7.56917 4.36161 7.57031 4.36328C7.57289 4.36704 7.57638 4.37303 7.58105 4.37988C7.59039 4.39358 7.60427 4.41345 7.62109 4.43848C7.65479 4.48859 7.70286 4.55984 7.75977 4.64746C7.87348 4.82255 8.02616 5.06446 8.17969 5.3291C8.33202 5.59171 8.49163 5.88859 8.61523 6.16992C8.72708 6.42453 8.85352 6.761 8.85352 7.07031C8.85352 8.07654 8.03741 8.89258 7.03125 8.89258C6.02509 8.89258 5.20898 8.07654 5.20898 7.07031C5.20898 6.761 5.33542 6.42453 5.44727 6.16992C5.57087 5.88859 5.73048 5.59171 5.88281 5.3291C6.03634 5.06446 6.18902 4.82255 6.30273 4.64746C6.35964 4.55984 6.40771 4.48859 6.44141 4.43848C6.45823 4.41345 6.47211 4.39358 6.48145 4.37988C6.48612 4.37303 6.48961 4.36704 6.49219 4.36328C6.49333 4.36161 6.49442 4.36038 6.49512 4.35938L6.49609 4.35742L7.03125 3.58301L7.56641 4.35742ZM7.00781 5.98145C6.86721 6.22382 6.73382 6.47362 6.6377 6.69238C6.58978 6.80144 6.55506 6.89397 6.5332 6.96777C6.5142 7.03201 6.5105 7.06425 6.50977 7.07031C6.50977 7.35854 6.74303 7.5918 7.03125 7.5918C7.31947 7.5918 7.55273 7.35854 7.55273 7.07031C7.552 7.06425 7.5483 7.03201 7.5293 6.96777C7.50744 6.89397 7.47272 6.80144 7.4248 6.69238C7.32868 6.47362 7.19529 6.22382 7.05469 5.98145C7.04704 5.96827 7.03889 5.95544 7.03125 5.94238C7.02361 5.95544 7.01546 5.96827 7.00781 5.98145Z" })), /* @__PURE__ */ React.createElement("path", { d: "M5.92383 1.10742H8.13867V-0.0644531H11.7832V1.10742H12.3047C13.3108 1.10742 14.127 1.92346 14.127 2.92969V4.66211H15.8984C18.1991 4.66211 20.0645 6.5275 20.0645 8.82812V20.0645H16.4199V8.82812C16.4199 8.5399 16.1867 8.30664 15.8984 8.30664H14.127V10C14.127 11.0062 13.3108 11.8223 12.3047 11.8223H11.7832V18.7637H12.8906V20.0645H9.375V18.7637H10.4824V16.5098H3.58008V18.7637H4.6875V20.0645H1.17188V18.7637H2.2793V11.8223H1.75781C0.751654 11.8223 -0.0644531 11.0062 -0.0644531 10V2.92969C-0.0644527 1.92346 0.751654 1.10742 1.75781 1.10742H2.2793V-0.0644531H5.92383V1.10742ZM14.127 7.00586H15.8984C16.9046 7.00586 17.7207 7.8219 17.7207 8.82812V18.7637H18.7637V8.82812C18.7637 7.24547 17.4811 5.96289 15.8984 5.96289H14.127V7.00586ZM3.58008 15.209H10.4824V14.166H3.58008V15.209ZM3.58008 12.8652H10.4824V11.8223H3.58008V12.8652ZM3.58008 2.4082H1.75781C1.4696 2.4082 1.23633 2.64146 1.23633 2.92969V10C1.23633 10.2882 1.4696 10.5215 1.75781 10.5215H12.3047C12.5929 10.5215 12.8262 10.2882 12.8262 10V2.92969C12.8262 2.64146 12.5929 2.4082 12.3047 2.4082H10.4824V1.23633H9.43945V2.4082H4.62305V1.23633H3.58008V2.4082ZM7.56641 4.35742L7.56738 4.35938C7.56808 4.36038 7.56917 4.36161 7.57031 4.36328C7.57289 4.36704 7.57638 4.37303 7.58105 4.37988C7.59039 4.39358 7.60427 4.41345 7.62109 4.43848C7.65479 4.48859 7.70286 4.55984 7.75977 4.64746C7.87348 4.82255 8.02616 5.06446 8.17969 5.3291C8.33202 5.59171 8.49163 5.88859 8.61523 6.16992C8.72708 6.42453 8.85352 6.761 8.85352 7.07031C8.85352 8.07654 8.03741 8.89258 7.03125 8.89258C6.02509 8.89258 5.20898 8.07654 5.20898 7.07031C5.20898 6.761 5.33542 6.42453 5.44727 6.16992C5.57087 5.88859 5.73048 5.59171 5.88281 5.3291C6.03634 5.06446 6.18902 4.82255 6.30273 4.64746C6.35964 4.55984 6.40771 4.48859 6.44141 4.43848C6.45823 4.41345 6.47211 4.39358 6.48145 4.37988C6.48612 4.37303 6.48961 4.36704 6.49219 4.36328C6.49333 4.36161 6.49442 4.36038 6.49512 4.35938L6.49609 4.35742L7.03125 3.58301L7.56641 4.35742ZM7.00781 5.98145C6.86721 6.22382 6.73382 6.47362 6.6377 6.69238C6.58978 6.80144 6.55506 6.89397 6.5332 6.96777C6.5142 7.03201 6.5105 7.06425 6.50977 7.07031C6.50977 7.35854 6.74303 7.5918 7.03125 7.5918C7.31947 7.5918 7.55273 7.35854 7.55273 7.07031C7.552 7.06425 7.5483 7.03201 7.5293 6.96777C7.50744 6.89397 7.47272 6.80144 7.4248 6.69238C7.32868 6.47362 7.19529 6.22382 7.05469 5.98145C7.04704 5.96827 7.03889 5.95544 7.03125 5.94238C7.02361 5.95544 7.01546 5.96827 7.00781 5.98145Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M5.92383 1.10742H5.82383V1.20742H5.92383V1.10742ZM8.13867 1.10742V1.20742H8.23867V1.10742H8.13867ZM8.13867 -0.0644531V-0.164453H8.03867V-0.0644531H8.13867ZM11.7832 -0.0644531H11.8832V-0.164453H11.7832V-0.0644531ZM11.7832 1.10742H11.6832V1.20742H11.7832V1.10742ZM14.127 2.92969H14.227H14.127ZM14.127 4.66211H14.027V4.76211H14.127V4.66211ZM15.8984 4.66211V4.56211V4.66211ZM20.0645 8.82812H20.1645H20.0645ZM20.0645 20.0645V20.1645H20.1645V20.0645H20.0645ZM16.4199 20.0645H16.3199V20.1645H16.4199V20.0645ZM16.4199 8.82812H16.5199H16.4199ZM15.8984 8.30664V8.20664V8.30664ZM14.127 8.30664V8.20664H14.027V8.30664H14.127ZM11.7832 11.8223V11.7223H11.6832V11.8223H11.7832ZM11.7832 18.7637H11.6832V18.8637H11.7832V18.7637ZM12.8906 18.7637H12.9906V18.6637H12.8906V18.7637ZM12.8906 20.0645V20.1645H12.9906V20.0645H12.8906ZM9.375 20.0645H9.275V20.1645H9.375V20.0645ZM9.375 18.7637V18.6637H9.275V18.7637H9.375ZM10.4824 18.7637V18.8637H10.5824V18.7637H10.4824ZM10.4824 16.5098H10.5824V16.4098H10.4824V16.5098ZM3.58008 16.5098V16.4098H3.48008V16.5098H3.58008ZM3.58008 18.7637H3.48008V18.8637H3.58008V18.7637ZM4.6875 18.7637H4.7875V18.6637H4.6875V18.7637ZM4.6875 20.0645V20.1645H4.7875V20.0645H4.6875ZM1.17188 20.0645H1.07187V20.1645H1.17188V20.0645ZM1.17188 18.7637V18.6637H1.07187V18.7637H1.17188ZM2.2793 18.7637V18.8637H2.3793V18.7637H2.2793ZM2.2793 11.8223H2.3793V11.7223H2.2793V11.8223ZM-0.0644531 2.92969H-0.164453H-0.0644531ZM2.2793 1.10742V1.20742H2.3793V1.10742H2.2793ZM2.2793 -0.0644531V-0.164453H2.1793V-0.0644531H2.2793ZM5.92383 -0.0644531H6.02383V-0.164453H5.92383V-0.0644531ZM14.127 7.00586H14.027V7.10586H14.127V7.00586ZM15.8984 7.00586V6.90586V7.00586ZM17.7207 8.82812H17.8207H17.7207ZM17.7207 18.7637H17.6207V18.8637H17.7207V18.7637ZM18.7637 18.7637V18.8637H18.8637V18.7637H18.7637ZM18.7637 8.82812H18.8637H18.7637ZM15.8984 5.96289V5.86289V5.96289ZM14.127 5.96289V5.86289H14.027V5.96289H14.127ZM3.58008 15.209H3.48008V15.309H3.58008V15.209ZM10.4824 15.209V15.309H10.5824V15.209H10.4824ZM10.4824 14.166H10.5824V14.066H10.4824V14.166ZM3.58008 14.166V14.066H3.48008V14.166H3.58008ZM3.58008 12.8652H3.48008V12.9652H3.58008V12.8652ZM10.4824 12.8652V12.9652H10.5824V12.8652H10.4824ZM10.4824 11.8223H10.5824V11.7223H10.4824V11.8223ZM3.58008 11.8223V11.7223H3.48008V11.8223H3.58008ZM3.58008 2.4082V2.5082H3.68008V2.4082H3.58008ZM1.23633 2.92969L1.13633 2.92969V2.92969H1.23633ZM12.8262 2.92969H12.9262V2.92969L12.8262 2.92969ZM10.4824 2.4082H10.3824V2.5082H10.4824V2.4082ZM10.4824 1.23633H10.5824V1.13633H10.4824V1.23633ZM9.43945 1.23633V1.13633H9.33945V1.23633H9.43945ZM9.43945 2.4082V2.5082H9.53945V2.4082H9.43945ZM4.62305 2.4082H4.52305V2.5082H4.62305V2.4082ZM4.62305 1.23633H4.72305V1.13633H4.62305V1.23633ZM3.58008 1.23633V1.13633H3.48008V1.23633H3.58008ZM7.56641 4.35742L7.65675 4.31225L7.64867 4.30057L7.56641 4.35742ZM7.56738 4.35938L7.47706 4.40453L7.48502 4.41609L7.56738 4.35938ZM7.57031 4.36328L7.65275 4.30668L7.65275 4.30668L7.57031 4.36328ZM7.58105 4.37988L7.66367 4.32354L7.66367 4.32353L7.58105 4.37988ZM7.62109 4.43848L7.70408 4.38268L7.70408 4.38268L7.62109 4.43848ZM7.75977 4.64746L7.84363 4.59299V4.59299L7.75977 4.64746ZM8.17969 5.3291L8.26619 5.27892L8.26619 5.27892L8.17969 5.3291ZM8.61523 6.16992L8.70679 6.1297L8.70679 6.1297L8.61523 6.16992ZM5.44727 6.16992L5.35571 6.1297L5.35571 6.1297L5.44727 6.16992ZM5.88281 5.3291L5.79631 5.27892L5.79631 5.27892L5.88281 5.3291ZM6.30273 4.64746L6.21887 4.59299V4.59299L6.30273 4.64746ZM6.44141 4.43848L6.35842 4.38268L6.35842 4.38268L6.44141 4.43848ZM6.48145 4.37988L6.39883 4.32353L6.39883 4.32354L6.48145 4.37988ZM6.49219 4.36328L6.40975 4.30668L6.40975 4.30668L6.49219 4.36328ZM6.49512 4.35938L6.57829 4.41664L6.58456 4.4041L6.49512 4.35938ZM6.49609 4.35742L6.413 4.3L6.40665 4.3127L6.49609 4.35742ZM7.03125 3.58301L7.11352 3.52616L7.03125 3.40711L6.94898 3.52616L7.03125 3.58301ZM7.00781 5.98145L6.92132 5.93126L6.92131 5.93127L7.00781 5.98145ZM6.6377 6.69238L6.54614 6.65216L6.54614 6.65216L6.6377 6.69238ZM6.5332 6.96777L6.43732 6.93938L6.43731 6.93941L6.5332 6.96777ZM6.50977 7.07031L6.40977 7.05817V7.07031H6.50977ZM7.55273 7.07031H7.65347L7.65201 7.05826L7.55273 7.07031ZM7.5293 6.96777L7.62519 6.93941L7.62518 6.93938L7.5293 6.96777ZM7.4248 6.69238L7.51636 6.65216L7.51636 6.65216L7.4248 6.69238ZM7.05469 5.98145L7.14119 5.93127L7.14118 5.93126L7.05469 5.98145ZM7.03125 5.94238L7.11756 5.89188L7.03125 5.74438L6.94494 5.89188L7.03125 5.94238ZM5.92383 1.10742V1.20742H8.13867V1.10742V1.00742H5.92383V1.10742ZM8.13867 1.10742H8.23867V-0.0644531H8.13867H8.03867V1.10742H8.13867ZM8.13867 -0.0644531V0.0355469H11.7832V-0.0644531V-0.164453H8.13867V-0.0644531ZM11.7832 -0.0644531H11.6832V1.10742H11.7832H11.8832V-0.0644531H11.7832ZM11.7832 1.10742V1.20742H12.3047V1.10742V1.00742H11.7832V1.10742ZM12.3047 1.10742V1.20742C13.2556 1.20742 14.027 1.97869 14.027 2.92969H14.127H14.227C14.227 1.86823 13.3661 1.00742 12.3047 1.00742V1.10742ZM14.127 2.92969H14.027V4.66211H14.127H14.227V2.92969H14.127ZM14.127 4.66211V4.76211H15.8984V4.66211V4.56211H14.127V4.66211ZM15.8984 4.66211V4.76211C18.1438 4.76211 19.9645 6.58273 19.9645 8.82812H20.0645H20.1645C20.1645 6.47227 18.2543 4.56211 15.8984 4.56211V4.66211ZM20.0645 8.82812H19.9645V20.0645H20.0645H20.1645V8.82812H20.0645ZM20.0645 20.0645V19.9645H16.4199V20.0645V20.1645H20.0645V20.0645ZM16.4199 20.0645H16.5199V8.82812H16.4199H16.3199V20.0645H16.4199ZM16.4199 8.82812H16.5199C16.5199 8.48467 16.2419 8.20664 15.8984 8.20664V8.30664V8.40664C16.1314 8.40664 16.3199 8.59513 16.3199 8.82812H16.4199ZM15.8984 8.30664V8.20664H14.127V8.30664V8.40664H15.8984V8.30664ZM14.127 8.30664H14.027V10H14.127H14.227V8.30664H14.127ZM14.127 10H14.027C14.027 10.951 13.2556 11.7223 12.3047 11.7223V11.8223V11.9223C13.3661 11.9223 14.227 11.0615 14.227 10H14.127ZM12.3047 11.8223V11.7223H11.7832V11.8223V11.9223H12.3047V11.8223ZM11.7832 11.8223H11.6832V18.7637H11.7832H11.8832V11.8223H11.7832ZM11.7832 18.7637V18.8637H12.8906V18.7637V18.6637H11.7832V18.7637ZM12.8906 18.7637H12.7906V20.0645H12.8906H12.9906V18.7637H12.8906ZM12.8906 20.0645V19.9645H9.375V20.0645V20.1645H12.8906V20.0645ZM9.375 20.0645H9.475V18.7637H9.375H9.275V20.0645H9.375ZM9.375 18.7637V18.8637H10.4824V18.7637V18.6637H9.375V18.7637ZM10.4824 18.7637H10.5824V16.5098H10.4824H10.3824V18.7637H10.4824ZM10.4824 16.5098V16.4098H3.58008V16.5098V16.6098H10.4824V16.5098ZM3.58008 16.5098H3.48008V18.7637H3.58008H3.68008V16.5098H3.58008ZM3.58008 18.7637V18.8637H4.6875V18.7637V18.6637H3.58008V18.7637ZM4.6875 18.7637H4.5875V20.0645H4.6875H4.7875V18.7637H4.6875ZM4.6875 20.0645V19.9645H1.17188V20.0645V20.1645H4.6875V20.0645ZM1.17188 20.0645H1.27188V18.7637H1.17188H1.07187V20.0645H1.17188ZM1.17188 18.7637V18.8637H2.2793V18.7637V18.6637H1.17188V18.7637ZM2.2793 18.7637H2.3793V11.8223H2.2793H2.1793V18.7637H2.2793ZM2.2793 11.8223V11.7223H1.75781V11.8223V11.9223H2.2793V11.8223ZM1.75781 11.8223V11.7223C0.80688 11.7223 0.0355469 10.951 0.0355469 10H-0.0644531H-0.164453C-0.164453 11.0615 0.696428 11.9223 1.75781 11.9223V11.8223ZM-0.0644531 10H0.0355469V2.92969H-0.0644531H-0.164453V10H-0.0644531ZM-0.0644531 2.92969H0.0355469C0.0355473 1.97869 0.80688 1.20742 1.75781 1.20742V1.10742V1.00742C0.696428 1.00742 -0.164453 1.86823 -0.164453 2.92969H-0.0644531ZM1.75781 1.10742V1.20742H2.2793V1.10742V1.00742H1.75781V1.10742ZM2.2793 1.10742H2.3793V-0.0644531H2.2793H2.1793V1.10742H2.2793ZM2.2793 -0.0644531V0.0355469H5.92383V-0.0644531V-0.164453H2.2793V-0.0644531ZM5.92383 -0.0644531H5.82383V1.10742H5.92383H6.02383V-0.0644531H5.92383ZM14.127 7.00586V7.10586H15.8984V7.00586V6.90586H14.127V7.00586ZM15.8984 7.00586V7.10586C16.8494 7.10586 17.6207 7.87713 17.6207 8.82812H17.7207H17.8207C17.8207 7.76667 16.9598 6.90586 15.8984 6.90586V7.00586ZM17.7207 8.82812H17.6207V18.7637H17.7207H17.8207V8.82812H17.7207ZM17.7207 18.7637V18.8637H18.7637V18.7637V18.6637H17.7207V18.7637ZM18.7637 18.7637H18.8637V8.82812H18.7637H18.6637V18.7637H18.7637ZM18.7637 8.82812H18.8637C18.8637 7.19024 17.5363 5.86289 15.8984 5.86289V5.96289V6.06289C17.4259 6.06289 18.6637 7.3007 18.6637 8.82812H18.7637ZM15.8984 5.96289V5.86289H14.127V5.96289V6.06289H15.8984V5.96289ZM14.127 5.96289H14.027V7.00586H14.127H14.227V5.96289H14.127ZM3.58008 15.209V15.309H10.4824V15.209V15.109H3.58008V15.209ZM10.4824 15.209H10.5824V14.166H10.4824H10.3824V15.209H10.4824ZM10.4824 14.166V14.066H3.58008V14.166V14.266H10.4824V14.166ZM3.58008 14.166H3.48008V15.209H3.58008H3.68008V14.166H3.58008ZM3.58008 12.8652V12.9652H10.4824V12.8652V12.7652H3.58008V12.8652ZM10.4824 12.8652H10.5824V11.8223H10.4824H10.3824V12.8652H10.4824ZM10.4824 11.8223V11.7223H3.58008V11.8223V11.9223H10.4824V11.8223ZM3.58008 11.8223H3.48008V12.8652H3.58008H3.68008V11.8223H3.58008ZM3.58008 2.4082V2.3082H1.75781V2.4082V2.5082H3.58008V2.4082ZM1.75781 2.4082V2.3082C1.41437 2.3082 1.13633 2.58623 1.13633 2.92969L1.23633 2.92969L1.33633 2.92969C1.33633 2.69669 1.52482 2.5082 1.75781 2.5082V2.4082ZM1.23633 2.92969H1.13633V10H1.23633H1.33633V2.92969H1.23633ZM1.23633 10H1.13633C1.13633 10.3435 1.41437 10.6215 1.75781 10.6215V10.5215V10.4215C1.52482 10.4215 1.33633 10.233 1.33633 10H1.23633ZM1.75781 10.5215V10.6215H12.3047V10.5215V10.4215H1.75781V10.5215ZM12.3047 10.5215V10.6215C12.6481 10.6215 12.9262 10.3435 12.9262 10H12.8262H12.7262C12.7262 10.233 12.5377 10.4215 12.3047 10.4215V10.5215ZM12.8262 10H12.9262V2.92969H12.8262H12.7262V10H12.8262ZM12.8262 2.92969L12.9262 2.92969C12.9262 2.58623 12.6481 2.3082 12.3047 2.3082V2.4082V2.5082C12.5377 2.5082 12.7262 2.69669 12.7262 2.92969L12.8262 2.92969ZM12.3047 2.4082V2.3082H10.4824V2.4082V2.5082H12.3047V2.4082ZM10.4824 2.4082H10.5824V1.23633H10.4824H10.3824V2.4082H10.4824ZM10.4824 1.23633V1.13633H9.43945V1.23633V1.33633H10.4824V1.23633ZM9.43945 1.23633H9.33945V2.4082H9.43945H9.53945V1.23633H9.43945ZM9.43945 2.4082V2.3082H4.62305V2.4082V2.5082H9.43945V2.4082ZM4.62305 2.4082H4.72305V1.23633H4.62305H4.52305V2.4082H4.62305ZM4.62305 1.23633V1.13633H3.58008V1.23633V1.33633H4.62305V1.23633ZM3.58008 1.23633H3.48008V2.4082H3.58008H3.68008V1.23633H3.58008ZM7.56641 4.35742L7.47696 4.40214L7.47794 4.4041L7.56738 4.35938L7.65683 4.31465L7.65585 4.3127L7.56641 4.35742ZM7.56738 4.35938L7.48502 4.41609C7.48663 4.41843 7.48804 4.42027 7.4887 4.42113C7.48907 4.42161 7.48939 4.42202 7.48957 4.42226C7.48966 4.42238 7.48976 4.42249 7.48981 4.42256C7.48987 4.42264 7.4899 4.42268 7.48993 4.42271C7.49015 4.42299 7.48913 4.42172 7.48787 4.41989L7.57031 4.36328L7.65275 4.30668C7.65035 4.30318 7.64821 4.30045 7.64743 4.29945C7.6468 4.29865 7.64711 4.29905 7.64724 4.29922C7.64747 4.29951 7.64848 4.30082 7.64975 4.30266L7.56738 4.35938ZM7.57031 4.36328L7.48787 4.41988C7.48755 4.41942 7.48754 4.41937 7.48809 4.42023C7.48866 4.42114 7.4892 4.422 7.49028 4.42372C7.4922 4.42675 7.49503 4.43123 7.49844 4.43623L7.58105 4.37988L7.66367 4.32353C7.6624 4.32168 7.66116 4.31974 7.65951 4.31712C7.65881 4.31602 7.65771 4.31425 7.65676 4.31276C7.65578 4.31122 7.65436 4.30902 7.65275 4.30668L7.57031 4.36328ZM7.58105 4.37988L7.49844 4.43623C7.50867 4.45122 7.5214 4.46942 7.53811 4.49428L7.62109 4.43848L7.70408 4.38268C7.68713 4.35748 7.67212 4.33593 7.66367 4.32354L7.58105 4.37988ZM7.62109 4.43848L7.53811 4.49427C7.57186 4.54447 7.6195 4.61508 7.6759 4.70193L7.75977 4.64746L7.84363 4.59299C7.78623 4.5046 7.73772 4.43271 7.70408 4.38268L7.62109 4.43848ZM7.75977 4.64746L7.6759 4.70193C7.78903 4.87611 7.94076 5.11653 8.09319 5.37928L8.17969 5.3291L8.26619 5.27892C8.11156 5.01239 7.95793 4.76898 7.84363 4.59299L7.75977 4.64746ZM8.17969 5.3291L8.09319 5.37928C8.24456 5.64022 8.40216 5.93355 8.52368 6.21014L8.61523 6.16992L8.70679 6.1297C8.58111 5.84363 8.41949 5.54319 8.26619 5.27892L8.17969 5.3291ZM8.61523 6.16992L8.52368 6.21014C8.63515 6.4639 8.75352 6.78364 8.75352 7.07031H8.85352H8.95352C8.95352 6.73836 8.819 6.38515 8.70679 6.1297L8.61523 6.16992ZM8.85352 7.07031H8.75352C8.75352 8.02131 7.98218 8.79258 7.03125 8.79258V8.89258V8.99258C8.09263 8.99258 8.95352 8.13177 8.95352 7.07031H8.85352ZM7.03125 8.89258V8.79258C6.08032 8.79258 5.30898 8.02131 5.30898 7.07031H5.20898H5.10898C5.10898 8.13177 5.96987 8.99258 7.03125 8.99258V8.89258ZM5.20898 7.07031H5.30898C5.30898 6.78364 5.42735 6.4639 5.53882 6.21014L5.44727 6.16992L5.35571 6.1297C5.2435 6.38515 5.10898 6.73836 5.10898 7.07031H5.20898ZM5.44727 6.16992L5.53882 6.21014C5.66034 5.93355 5.81794 5.64022 5.96931 5.37928L5.88281 5.3291L5.79631 5.27892C5.64301 5.54319 5.48139 5.84363 5.35571 6.1297L5.44727 6.16992ZM5.88281 5.3291L5.96931 5.37928C6.12174 5.11653 6.27347 4.87611 6.3866 4.70193L6.30273 4.64746L6.21887 4.59299C6.10457 4.76898 5.95094 5.01239 5.79631 5.27892L5.88281 5.3291ZM6.30273 4.64746L6.3866 4.70193C6.443 4.61508 6.49064 4.54447 6.52439 4.49427L6.44141 4.43848L6.35842 4.38268C6.32478 4.43271 6.27627 4.5046 6.21887 4.59299L6.30273 4.64746ZM6.44141 4.43848L6.52439 4.49428C6.5411 4.46942 6.55383 4.45122 6.56406 4.43623L6.48145 4.37988L6.39883 4.32354C6.39038 4.33593 6.37537 4.35748 6.35842 4.38268L6.44141 4.43848ZM6.48145 4.37988L6.56406 4.43623C6.56747 4.43123 6.5703 4.42675 6.57222 4.42372C6.5733 4.422 6.57384 4.42114 6.57441 4.42023C6.57496 4.41937 6.57495 4.41942 6.57463 4.41988L6.49219 4.36328L6.40975 4.30668C6.40814 4.30902 6.40672 4.31122 6.40574 4.31276C6.40479 4.31425 6.40369 4.31602 6.40299 4.31712C6.40134 4.31974 6.4001 4.32168 6.39883 4.32353L6.48145 4.37988ZM6.49219 4.36328L6.57463 4.41989C6.57337 4.42172 6.57235 4.42299 6.57257 4.42271C6.5726 4.42268 6.57263 4.42264 6.57269 4.42256C6.57274 4.42249 6.57284 4.42238 6.57293 4.42226C6.57311 4.42202 6.57343 4.42161 6.5738 4.42113C6.57446 4.42027 6.57587 4.41843 6.57748 4.41609L6.49512 4.35938L6.41275 4.30266C6.41402 4.30082 6.41503 4.29951 6.41526 4.29922C6.41539 4.29905 6.4157 4.29865 6.41507 4.29945C6.41429 4.30045 6.41215 4.30318 6.40975 4.30668L6.49219 4.36328ZM6.49512 4.35938L6.58456 4.4041L6.58554 4.40214L6.49609 4.35742L6.40665 4.3127L6.40567 4.31465L6.49512 4.35938ZM6.49609 4.35742L6.57836 4.41427L7.11352 3.63986L7.03125 3.58301L6.94898 3.52616L6.41383 4.30057L6.49609 4.35742ZM7.03125 3.58301L6.94898 3.63986L7.48414 4.41427L7.56641 4.35742L7.64867 4.30057L7.11352 3.52616L7.03125 3.58301ZM7.00781 5.98145L6.92131 5.93127C6.77981 6.1752 6.64438 6.42859 6.54614 6.65216L6.6377 6.69238L6.72925 6.73261C6.82326 6.51865 6.95461 6.27244 7.09431 6.03162L7.00781 5.98145ZM6.6377 6.69238L6.54614 6.65216C6.49717 6.76363 6.46074 6.86028 6.43732 6.93938L6.5332 6.96777L6.62909 6.99617C6.64937 6.92766 6.6824 6.83925 6.72925 6.73261L6.6377 6.69238ZM6.5332 6.96777L6.43731 6.93941C6.41653 7.00966 6.41181 7.04743 6.41049 7.05826L6.50977 7.07031L6.60904 7.08237C6.60919 7.08107 6.61188 7.05435 6.6291 6.99614L6.5332 6.96777ZM6.50977 7.07031H6.40977C6.40977 7.41377 6.68781 7.6918 7.03125 7.6918V7.5918V7.4918C6.79826 7.4918 6.60977 7.30331 6.60977 7.07031H6.50977ZM7.03125 7.5918V7.6918C7.37469 7.6918 7.65273 7.41377 7.65273 7.07031H7.55273H7.45273C7.45273 7.30331 7.26424 7.4918 7.03125 7.4918V7.5918ZM7.55273 7.07031L7.65201 7.05826C7.65069 7.04743 7.64597 7.00966 7.62519 6.93941L7.5293 6.96777L7.4334 6.99614C7.45062 7.05435 7.45331 7.08107 7.45346 7.08237L7.55273 7.07031ZM7.5293 6.96777L7.62518 6.93938C7.60176 6.86028 7.56533 6.76363 7.51636 6.65216L7.4248 6.69238L7.33325 6.73261C7.3801 6.83925 7.41313 6.92766 7.43341 6.99617L7.5293 6.96777ZM7.4248 6.69238L7.51636 6.65216C7.41812 6.42859 7.28269 6.1752 7.14119 5.93127L7.05469 5.98145L6.96819 6.03162C7.10789 6.27244 7.23924 6.51865 7.33325 6.73261L7.4248 6.69238ZM7.05469 5.98145L7.14118 5.93126C7.13676 5.92364 7.13229 5.91629 7.12839 5.90987C7.12431 5.90318 7.12085 5.89751 7.11756 5.89188L7.03125 5.94238L6.94494 5.99289C6.94929 6.00032 6.95373 6.00759 6.95755 6.01387C6.96154 6.02043 6.96497 6.02608 6.96819 6.03163L7.05469 5.98145ZM7.03125 5.94238L6.94494 5.89188C6.94165 5.89751 6.93819 5.90318 6.93411 5.90987C6.93021 5.91629 6.92574 5.92364 6.92132 5.93126L7.00781 5.98145L7.09431 6.03163C7.09753 6.02608 7.10096 6.02043 7.10495 6.01387C7.10877 6.00759 7.11321 6.00032 7.11756 5.99289L7.03125 5.94238Z", fill: "currentColor", fillOpacity: 0.45, mask: "url(#path-1-outside-1_1919_138)" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1919_138" }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, fill: "currentColor" }))));
const waterTower = SvgWaterTower;
const SvgOtherTowers = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18.899 9.39932C18.7752 9.24588 18.5886 9.15667 18.3915 9.15667H16.4173L17.7171 4.24951C17.769 4.05387 17.727 3.84518 17.6036 3.68482C17.4801 3.52446 17.2892 3.4304 17.0868 3.4304H12.1741V1.65214C12.1741 1.29197 11.8821 1 11.522 1C11.1618 1 10.8698 1.29197 10.8698 1.65214V3.43044H5.95681C5.75439 3.43044 5.56344 3.52446 5.44003 3.68486C5.31658 3.84522 5.2746 4.05392 5.32642 4.24955L6.62631 9.15671H4.65211C4.45493 9.15671 4.26836 9.24592 4.14456 9.39936C4.02073 9.55284 3.97308 9.75402 4.01476 9.94674L5.0656 14.8035C5.13053 15.1035 5.39599 15.3177 5.703 15.3177H7.08715V22.3479C7.08715 22.708 7.37912 23 7.73929 23H15.3042C15.6644 23 15.9564 22.708 15.9564 22.3479V15.3177H17.3406C17.6476 15.3177 17.913 15.1035 17.978 14.8035L19.0289 9.94674C19.0706 9.75402 19.0228 9.55284 18.899 9.39932ZM16.2394 4.73471L15.9672 5.7621H7.07632L6.80416 4.73471H16.2394ZM7.97562 9.15671L7.42188 7.06633H15.6218L15.068 9.15671H7.97562ZM13.0824 10.4609L12.8294 14.0134H10.2141L9.96107 10.4609H13.0824ZM6.22911 14.0134L5.46048 10.4609H8.65362L8.90662 14.0134H6.22911ZM14.6521 21.6957H8.39142V15.3177H14.6521V21.6957H14.6521ZM16.8145 14.0134H14.137L14.39 10.4609H17.5832L16.8145 14.0134Z", fill: "currentColor", fillOpacity: 0.45 }));
const otherTowers = SvgOtherTowers;
const SvgCbsd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1354 8.06717C15.2282 7.89942 15.3112 7.72309 15.383 7.53921C15.5571 7.09392 15.6661 6.60432 15.6924 6.08481C15.6965 6.00365 15.6985 5.92177 15.6985 5.83921H15.6924C15.6924 3.36371 13.8729 1.63086 11.9667 1.63086C10.0606 1.63086 8.24109 3.35752 8.24109 5.83921C8.24109 6.66851 8.45151 7.42972 8.80427 8.06717L8.82283 8.09811L11.7749 13.6432C11.8615 13.798 12.0843 13.798 12.1648 13.6432L15.1168 8.09811L15.1354 8.08573V8.06717ZM13.5862 7.35563L13.4354 7.62815V7.63891L11.9698 10.3918L10.303 7.2608L10.2792 7.22118C10.0725 6.8387 9.94109 6.36875 9.94109 5.83921C9.94109 4.18575 11.1064 3.33086 11.9667 3.33086C12.8254 3.33086 13.9924 4.19022 13.9924 5.83921V6.03717C13.9673 6.43548 13.8676 6.79589 13.7194 7.10543L13.5862 7.35563Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0757 20.7665C16.4594 21.3916 17.0164 21.9424 17.7405 22.3508L17.7529 22.357C19.9127 23.5762 22.314 22.8397 23.2485 21.175C24.183 19.5102 23.5641 17.0718 21.4042 15.8588C20.6801 15.4504 19.9127 15.2585 19.1825 15.2585H19.1453L12.8637 15.11C12.6843 15.11 12.5791 15.3018 12.6719 15.4504L16.0633 20.7417V20.7541L16.0757 20.7665ZM15.6044 16.8752L17.4175 19.7041L17.4196 19.7062L17.4368 19.7342L17.6308 20.037C17.8508 20.3431 18.1514 20.6246 18.5427 20.8513L18.5514 20.8556L18.5885 20.8766C20.0271 21.6886 21.345 21.093 21.7661 20.3428C22.189 19.5894 22.0091 18.1483 20.5718 17.3411L20.569 17.3395C20.0952 17.0722 19.6148 16.9585 19.1825 16.9585H19.1252L15.6044 16.8752Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2669 15.4504L7.87544 20.7417V20.7541L7.86306 20.7665C7.47936 21.3916 6.92237 21.9424 6.19829 22.3508L6.18591 22.357C4.02603 23.5762 1.62479 22.8397 0.690291 21.175C-0.244211 19.5102 0.374665 17.0718 2.53454 15.8588C3.25863 15.4504 4.02603 15.2585 4.7563 15.2585H4.79344L11.075 15.11C11.2545 15.11 11.3597 15.3018 11.2669 15.4504ZM5.38737 20.8556L5.39605 20.8513C5.78733 20.6246 6.08796 20.3431 6.30791 20.037L6.50202 19.7342L6.51916 19.7062L6.52127 19.7041L8.3344 16.8752L4.81353 16.9585H4.7563C4.32394 16.9585 3.84359 17.0722 3.36979 17.3395L3.36698 17.3411C1.92966 18.1483 1.74979 19.5894 2.1727 20.3428C2.5938 21.093 3.91167 21.6886 5.35025 20.8766L5.38737 20.8556Z", fill: "currentColor", fillOpacity: 0.45 }));
const cbsd = SvgCbsd;
const SvgEmergencyTruck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.3918 5.00823V1.50848H11.8918V5.00823H10.3918ZM6.3901 6.32748L3.74585 3.68348L4.8151 2.61423L7.4591 5.25848L6.3901 6.32748ZM3.39185 23.0852C3.17935 23.0852 3.00126 23.0133 2.8576 22.8695C2.71376 22.7258 2.64185 22.5477 2.64185 22.3352V14.6622L4.6841 8.83523C4.7586 8.60573 4.89518 8.4234 5.09385 8.28823C5.29251 8.1529 5.51368 8.08523 5.75735 8.08523H8.60335V6.31598H11.0226C10.7316 6.79298 10.5056 7.30407 10.3446 7.84923C10.1838 8.3944 10.1033 8.9699 10.1033 9.57573V9.58523H6.0111L4.46885 13.7775H11.6381C11.8638 14.075 12.1131 14.3513 12.3861 14.6065C12.6591 14.8615 12.961 15.0852 13.2918 15.2775H4.14185V19.5852H18.1418V16.1062C18.4085 16.0627 18.6653 16.0006 18.9121 15.9197C19.1588 15.8391 19.402 15.743 19.6418 15.6315V22.3352C19.6418 22.5477 19.5699 22.7258 19.4261 22.8695C19.2824 23.0133 19.1043 23.0852 18.8918 23.0852H18.2766C18.0641 23.0852 17.8859 23.0133 17.7421 22.8695C17.5984 22.7258 17.5266 22.5477 17.5266 22.3352V21.0852H4.7571V22.3352C4.7571 22.5477 4.68526 22.7258 4.5416 22.8695C4.39776 23.0133 4.2196 23.0852 4.0071 23.0852H3.39185ZM5.43035 18.2967H8.2766C8.52176 18.2967 8.72726 18.2138 8.8931 18.048C9.05893 17.8822 9.14185 17.6767 9.14185 17.4317C9.14185 17.1866 9.05893 16.981 8.8931 16.815C8.72726 16.649 8.52176 16.566 8.2766 16.566H5.43035V18.2967ZM16.8533 18.2967V16.566H14.0071C13.7619 16.566 13.5564 16.6489 13.3906 16.8147C13.2248 16.9806 13.1418 17.186 13.1418 17.431C13.1418 17.6762 13.2248 17.8817 13.3906 18.0477C13.5564 18.2137 13.7619 18.2967 14.0071 18.2967H16.8533ZM16.0803 11.7102L19.3918 8.41398L18.5533 7.57573L16.0803 10.018L15.0378 8.97573L14.1996 9.82948L16.0803 11.7102ZM16.7956 5.07573C18.0444 5.07573 19.1066 5.51348 19.9821 6.38898C20.8578 7.26465 21.2956 8.3269 21.2956 9.57573C21.2956 10.8244 20.8578 11.8866 19.9821 12.7622C19.1066 13.6377 18.0444 14.0755 16.7956 14.0755C15.5469 14.0755 14.4848 13.6377 13.6091 12.7622C12.7334 11.8866 12.2956 10.8244 12.2956 9.57573C12.2956 8.3269 12.7334 7.26465 13.6091 6.38898C14.4848 5.51348 15.5469 5.07573 16.7956 5.07573Z", fill: "currentColor", fillOpacity: 0.45 }));
const emergencyTruck = SvgEmergencyTruck;
const SvgEscalator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.2976 3.00723L11.1033 6.76717C11.0961 6.9049 10.9311 6.97625 10.8262 6.88425L9.636 5.84079L5.18753 10.9147C5.12712 10.9836 5.02131 10.9906 4.95241 10.9302L4.07543 10.1613C4.00653 10.1009 3.99958 9.99506 4.05999 9.92616L8.50846 4.85224L7.31829 3.80877C7.21336 3.71678 7.25957 3.54402 7.39811 3.51869L11.1003 2.83424C11.2067 2.81397 11.3038 2.89909 11.2976 3.00723Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.5113 4.96876C14.203 4.96876 13.9178 5.13193 13.7615 5.39766L9.01375 13.4688H4.5199C4.03942 13.4688 3.6499 13.8583 3.6499 14.3388V20.2988C3.6499 20.7793 4.03942 21.1688 4.5199 21.1688H19.4799C19.9604 21.1688 20.3499 20.7793 20.3499 20.2988V5.83876C20.3499 5.35827 19.9604 4.96876 19.4799 4.96876H14.5113ZM10.2383 14.7399L14.9861 6.66876H18.6499V7.96876H16.0113C15.703 7.96876 15.4178 8.13193 15.2615 8.39766L10.5137 16.4688H5.3499V15.1688H9.48846C9.79677 15.1688 10.082 15.0056 10.2383 14.7399ZM16.4861 9.66876H18.6499V19.4688H5.3499V18.1688H10.9885C11.2968 18.1688 11.582 18.0056 11.7383 17.7399L16.4861 9.66876Z", fill: "currentColor", fillOpacity: 0.45 }));
const escalator = SvgEscalator;
const SvgIdf = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.3097 17.1283H19.6942C19.784 17.1283 19.8578 17.0994 19.9155 17.0418C19.9731 16.9841 20.002 16.9104 20.002 16.8205V11.2438H4.00195V16.8205C4.00195 16.9104 4.03079 16.9841 4.08845 17.0418C4.14612 17.0994 4.21987 17.1283 4.3097 17.1283ZM17.0585 15.436C17.4055 15.436 17.7007 15.3146 17.9442 15.0718C18.1879 14.8289 18.3097 14.534 18.3097 14.187C18.3097 13.8402 18.1883 13.5449 17.9455 13.3013C17.7026 13.0578 17.4077 12.936 17.0607 12.936C16.7139 12.936 16.4186 13.0574 16.175 13.3003C15.9315 13.5431 15.8097 13.8379 15.8097 14.1848C15.8097 14.5318 15.9311 14.827 16.174 15.0705C16.4168 15.3142 16.7116 15.436 17.0585 15.436ZM21.502 9.74377H19.3885L17.177 7.49377H6.82695L4.61545 9.74377H2.50195L5.6867 6.52077C5.8507 6.35011 6.0432 6.21961 6.2642 6.12927C6.4852 6.03894 6.7177 5.99377 6.9617 5.99377H17.0422C17.2862 5.99377 17.5187 6.03894 17.7397 6.12927C17.9607 6.21961 18.1532 6.35011 18.3172 6.52077L21.502 9.74377ZM4.3097 18.6283C3.81254 18.6283 3.38695 18.4513 3.03295 18.0973C2.67895 17.7433 2.50195 17.3177 2.50195 16.8205V9.74377H21.502V16.8205C21.502 17.3177 21.325 17.7433 20.971 18.0973C20.617 18.4513 20.1914 18.6283 19.6942 18.6283H4.3097Z", fill: "currentColor", fillOpacity: 0.45 }));
const idf = SvgIdf;
const SvgMdf = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19 19.1921V16.1634H5V19.1921C5 19.282 5.02883 19.3557 5.0865 19.4134C5.14417 19.471 5.21792 19.4999 5.30775 19.4999H18.6923C18.7821 19.4999 18.8558 19.471 18.9135 19.4134C18.9712 19.3557 19 19.282 19 19.1921ZM19 14.6634V10.3364H5V14.6634H19ZM19 8.83638V5.80763C19 5.71779 18.9712 5.64405 18.9135 5.58638C18.8558 5.52871 18.7821 5.49988 18.6923 5.49988H5.30775C5.21792 5.49988 5.14417 5.52871 5.0865 5.58638C5.02883 5.64405 5 5.71779 5 5.80763V8.83638H19ZM5.30775 20.9999C4.80258 20.9999 4.375 20.8249 4.025 20.4749C3.675 20.1249 3.5 19.6973 3.5 19.1921V5.80763C3.5 5.30246 3.675 4.87488 4.025 4.52488C4.375 4.17488 4.80258 3.99988 5.30775 3.99988H18.6923C19.1974 3.99988 19.625 4.17488 19.975 4.52488C20.325 4.87488 20.5 5.30246 20.5 5.80763V19.1921C20.5 19.6973 20.325 20.1249 19.975 20.4749C19.625 20.8249 19.1974 20.9999 18.6923 20.9999H5.30775Z", fill: "currentColor", fillOpacity: 0.45 }));
const mdf = SvgMdf;
const SvgMines = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.1498 5.98466L12.2852 8.84919C12.127 9.00739 12.127 9.26389 12.2852 9.42209L14.5768 11.7137C14.735 11.8719 14.9915 11.8719 15.1498 11.7137L18.0143 8.84919C18.1725 8.69098 18.1725 8.43448 18.0143 8.27628L15.7227 5.98466C15.5645 5.82646 15.308 5.82646 15.1498 5.98466Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M14.2605 5.72904C11.4622 3.29055 9.28066 3.01374 9.18006 3.00247C9.09661 2.99321 9.01235 3.0101 8.93892 3.05081C8.86549 3.09152 8.80652 3.15403 8.77016 3.2297C8.7338 3.30538 8.72185 3.39048 8.73596 3.47324C8.75006 3.55601 8.78953 3.63234 8.84891 3.6917L12.5734 7.41615L14.2605 5.72904Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M20.9975 14.82C20.9863 14.7194 20.7094 12.5382 18.2714 9.74023L16.5843 11.4273L20.3083 15.1512C20.3676 15.2106 20.444 15.25 20.5267 15.2641C20.6095 15.2782 20.6946 15.2663 20.7703 15.2299C20.846 15.1936 20.9085 15.1346 20.9492 15.0612C20.9899 14.9877 21.0068 14.9035 20.9975 14.82Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M12.0003 10.2811L3.11867 19.1625C3.04269 19.2385 3 19.3415 3 19.449C3 19.5564 3.04269 19.6595 3.11867 19.7355L4.26482 20.8813C4.34081 20.9573 4.44386 21 4.55132 21C4.65878 21 4.76183 20.9573 4.83782 20.8813L13.7193 12.0001L12.0003 10.2811Z", fill: "currentColor", fillOpacity: 0.45 }));
const mines = SvgMines;
const SvgMonopole = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 3V22H11V3H13Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M9.5 7H7V4.5H9.5V7Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M9.5 4H7V3H9.5V4Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M17 7H14.5V4.5H17V7Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { d: "M17 4H14.5V3H17V4Z", fill: "currentColor", fillOpacity: 0.45 }));
const monopole = SvgMonopole;
const SvgSingleLevelBuilding = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.01714 5.23313V4.09863H19.6344V5.23313H4.01714ZM4.15189 19.5986V13.2736H2.86914V12.1391L4.01714 7.09863H19.6094L20.7671 12.1391V13.2736H19.4844V19.5986H18.3499V13.2736H13.3171V19.5986H4.15189ZM5.28639 18.4641H12.1826V13.2736H5.28639V18.4641ZM3.97864 12.1391H19.6479L18.7576 8.23313H4.86914L3.97864 12.1391Z", fill: "currentColor", fillOpacity: 0.45 }));
const singleLevelBuilding = SvgSingleLevelBuilding;
const SvgMultiLevelBuilding = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.06812 20.5986V7.18513H7.16437V3.09863H16.4816V11.2811H20.5681V20.5986H13.3066V16.5024H10.3296V20.5986H3.06812ZM4.20262 19.4639H7.16437V16.5024H4.20262V19.4639ZM4.20262 15.3679H7.16437V12.4159H4.20262V15.3679ZM4.20262 11.2811H7.16437V8.31963H4.20262V11.2811ZM8.29887 15.3679H11.2509V12.4159H8.29887V15.3679ZM8.29887 11.2811H11.2509V8.31963H8.29887V11.2811ZM8.29887 7.18513H11.2509V4.23313H8.29887V7.18513ZM12.3854 15.3679H15.3469V12.4159H12.3854V15.3679ZM12.3854 11.2811H15.3469V8.31963H12.3854V11.2811ZM12.3854 7.18513H15.3469V4.23313H12.3854V7.18513ZM16.4816 19.4639H19.4336V16.5024H16.4816V19.4639ZM16.4816 15.3679H19.4336V12.4159H16.4816V15.3679Z", fill: "currentColor", fillOpacity: 0.45 }));
const multiLevelBuilding = SvgMultiLevelBuilding;
const SvgMultipleBuildings = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.18359 20.5986V3.09863H11.5008V7.18513H21.4526V20.5986H2.18359ZM3.31809 19.4639H6.27959V16.5024H3.31809V19.4639ZM3.31809 15.3679H6.27959V12.4159H3.31809V15.3679ZM3.31809 11.2811H6.27959V8.31963H3.31809V11.2811ZM3.31809 7.18513H6.27959V4.23313H3.31809V7.18513ZM7.41434 19.4639H10.3661V16.5024H7.41434V19.4639ZM7.41434 15.3679H10.3661V12.4159H7.41434V15.3679ZM7.41434 11.2811H10.3661V8.31963H7.41434V11.2811ZM7.41434 7.18513H10.3661V4.23313H7.41434V7.18513ZM11.5008 19.4639H20.3181V8.31963H11.5008V11.2811H13.6931V12.4159H11.5008V15.3679H13.6931V16.5024H11.5008V19.4639ZM16.3468 12.4159V11.2811H17.4816V12.4159H16.3468ZM16.3468 16.5024V15.3679H17.4816V16.5024H16.3468Z", fill: "currentColor", fillOpacity: 0.45 }));
const multiBuildings = SvgMultipleBuildings;
const SvgOtherBuildings = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 20.5V3H10.3173V7.0865H20.269V15.6058H19.1345V8.221H10.3173V11.1825H12.5095V12.3172H10.3173V15.2692H12.5095V16.4038H10.3173V19.3652H15.346V20.5H1ZM2.1345 19.3652H5.096V16.4038H2.1345V19.3652ZM2.1345 15.2692H5.096V12.3172H2.1345V15.2692ZM2.1345 11.1825H5.096V8.221H2.1345V11.1825ZM2.1345 7.0865H5.096V4.1345H2.1345V7.0865ZM6.23075 19.3652H9.1825V16.4038H6.23075V19.3652ZM6.23075 15.2692H9.1825V12.3172H6.23075V15.2692ZM6.23075 11.1825H9.1825V8.221H6.23075V11.1825ZM6.23075 7.0865H9.1825V4.1345H6.23075V7.0865ZM19.0075 22.5V20.373H16.8652V19.2385H19.0075V17.0865H20.1423V19.2385H22.269V20.373H20.1423V22.5H19.0075ZM15.1633 12.3172V11.1825H16.298V12.3172H15.1633ZM15.1633 16.4038V15.2692H16.298V16.4038H15.1633Z", fill: "currentColor", fillOpacity: 0.45 }));
const otherBuildings = SvgOtherBuildings;
const SvgOilRigs = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.21411 20.7969C4.00161 20.7969 3.82344 20.725 3.67961 20.5811C3.53594 20.4373 3.46411 20.2591 3.46411 20.0466C3.46411 19.834 3.53594 19.6559 3.67961 19.5124C3.82344 19.3687 4.00161 19.2969 4.21411 19.2969H5.31986V13.0469H4.21411C4.00161 13.0469 3.82344 12.975 3.67961 12.8311C3.53594 12.6873 3.46411 12.5091 3.46411 12.2966C3.46411 12.084 3.53594 11.9059 3.67961 11.7624C3.82344 11.6187 4.00161 11.5469 4.21411 11.5469H5.31986V5.29688H4.21411C4.00161 5.29688 3.82344 5.22496 3.67961 5.08112C3.53594 4.93729 3.46411 4.75912 3.46411 4.54662C3.46411 4.33396 3.53594 4.15587 3.67961 4.01237C3.82344 3.86871 4.00161 3.79688 4.21411 3.79688H19.7236C19.9361 3.79688 20.1142 3.86879 20.2579 4.01263C20.4017 4.15646 20.4736 4.33463 20.4736 4.54713C20.4736 4.75979 20.4017 4.93788 20.2579 5.08138C20.1142 5.22504 19.9361 5.29688 19.7236 5.29688H18.6274V11.5469H19.7236C19.9361 11.5469 20.1142 11.6188 20.2579 11.7626C20.4017 11.9065 20.4736 12.0846 20.4736 12.2971C20.4736 12.5098 20.4017 12.6879 20.2579 12.8314C20.1142 12.975 19.9361 13.0469 19.7236 13.0469H18.6274V19.2969H19.7236C19.9361 19.2969 20.1142 19.3688 20.2579 19.5126C20.4017 19.6565 20.4736 19.8346 20.4736 20.0471C20.4736 20.2598 20.4017 20.4379 20.2579 20.5814C20.1142 20.725 19.9361 20.7969 19.7236 20.7969H4.21411ZM6.81986 19.2969H17.1274V13.0469H16.8774C16.6649 13.0469 16.4868 12.975 16.3431 12.8311C16.1993 12.6873 16.1274 12.5091 16.1274 12.2966C16.1274 12.084 16.1993 11.9059 16.3431 11.7624C16.4868 11.6187 16.6649 11.5469 16.8774 11.5469H17.1274V5.29688H6.81986V11.5469H7.06986C7.28236 11.5469 7.46044 11.6188 7.60411 11.7626C7.74794 11.9065 7.81986 12.0846 7.81986 12.2971C7.81986 12.5098 7.74794 12.6879 7.60411 12.8314C7.46044 12.975 7.28236 13.0469 7.06986 13.0469H6.81986V19.2969ZM11.9724 15.9796C12.736 15.9796 13.3854 15.716 13.9206 15.1889C14.4559 14.6617 14.7236 14.0239 14.7236 13.2754C14.7236 12.6794 14.5517 12.1675 14.2079 11.7399C13.8642 11.312 13.1194 10.4336 11.9736 9.10463C10.8326 10.4226 10.089 11.299 9.74286 11.7336C9.39669 12.1683 9.22361 12.683 9.22361 13.2779C9.22361 14.0252 9.49086 14.6623 10.0254 15.1891C10.5599 15.7161 11.2089 15.9796 11.9724 15.9796Z", fill: "currentColor", fillOpacity: 0.45 }));
const oilRigs = SvgOilRigs;
const SvgParking = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.1144 20.8275V15.222L11.5104 11.1353C11.5374 11.0506 11.5848 10.981 11.6526 10.9265C11.7206 10.872 11.827 10.8448 11.9719 10.8448H19.4026C19.5318 10.8448 19.6317 10.8694 19.7024 10.9187C19.773 10.9681 19.8269 11.0403 19.8641 11.1353L21.2604 15.222V20.8275C21.2604 20.9628 21.2169 21.0739 21.1301 21.1607C21.0434 21.2476 20.9331 21.291 20.7991 21.291H20.4691C20.3446 21.291 20.2377 21.2476 20.1484 21.1607C20.059 21.0739 20.0144 20.9628 20.0144 20.8275V19.5678H11.3604V20.8275C11.3604 20.9628 11.3154 21.0739 11.2256 21.1607C11.1358 21.2476 11.025 21.291 10.8934 21.291H10.5714C10.4454 21.291 10.3377 21.2476 10.2484 21.1607C10.159 21.0739 10.1144 20.9628 10.1144 20.8275ZM11.2374 14.537H20.1374L19.1776 11.6718H12.1969L11.2374 14.537ZM12.6066 17.9563C12.8693 17.9563 13.0894 17.8674 13.2671 17.6898C13.4446 17.5121 13.5334 17.2919 13.5334 17.0293C13.5334 16.7758 13.4446 16.5595 13.2671 16.3805C13.0894 16.2015 12.8693 16.112 12.6066 16.112C12.3439 16.112 12.1238 16.2015 11.9461 16.3805C11.7684 16.5595 11.6796 16.7774 11.6796 17.0343C11.6796 17.2909 11.7684 17.5088 11.9461 17.6878C12.1238 17.8668 12.3439 17.9563 12.6066 17.9563ZM18.7681 17.9563C19.0216 17.9563 19.2394 17.8674 19.4216 17.6898C19.6039 17.5121 19.6951 17.2919 19.6951 17.0293C19.6951 16.7758 19.6039 16.5595 19.4216 16.3805C19.2394 16.2015 19.02 16.112 18.7634 16.112C18.5065 16.112 18.2886 16.2015 18.1096 16.3805C17.9306 16.5595 17.8411 16.7774 17.8411 17.0343C17.8411 17.2909 17.9299 17.5088 18.1076 17.6878C18.2853 17.8668 18.5054 17.9563 18.7681 17.9563ZM5.9911 13.514V11.8718H7.6336V13.514H5.9911ZM10.6181 7.664V6.02175H12.2604V7.664H10.6181ZM5.9911 17.4025V15.7603H7.6336V17.4025H5.9911ZM5.9911 21.291V19.6485H7.6336V21.291H5.9911ZM2.37585 21.291V8.25625H7.0026V2.40625H15.8756V8.2525H14.7411V3.541H8.13735V9.391H3.51035V21.291H2.37585ZM10.9411 18.741H20.4334V15.364H10.9411V18.741Z", fill: "currentColor", fillOpacity: 0.45 }));
const parking = SvgParking;
const SvgPodium = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.73938 2.69678C3.2589 2.69678 2.86938 3.08629 2.86938 3.56678V6.52678C2.86938 7.00727 3.2589 7.39678 3.73938 7.39678H4.86938V17.1968H3.73938C3.2589 17.1968 2.86938 17.5863 2.86938 18.0668V21.0268C2.86938 21.5073 3.2589 21.8968 3.73938 21.8968H20.1994C20.6799 21.8968 21.0694 21.5073 21.0694 21.0268V18.0668C21.0694 17.5863 20.6799 17.1968 20.1994 17.1968H19.0694V7.39678H20.1994C20.6799 7.39678 21.0694 7.00727 21.0694 6.52678V3.56678C21.0694 3.08629 20.6799 2.69678 20.1994 2.69678H3.73938ZM4.56938 5.69678V4.39678H19.3694V5.69678H4.56938ZM16.8694 7.39678H7.06712V17.1968H16.8694V7.39678ZM4.56938 20.1968V18.8968H19.3694V20.1968H4.56938Z", fill: "currentColor", fillOpacity: 0.45 }));
const podium = SvgPodium;
const SvgRamp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.0423 3.05516C20.6217 2.74845 21.3194 3.16843 21.3194 3.82407V20.7709C21.3194 21.2513 20.9299 21.6409 20.4494 21.6409H2.61938V12.8029C2.61938 12.4806 2.79751 12.1848 3.08229 12.034L20.0423 3.05516ZM19.6194 5.20262L16.8194 6.68497V12.3568L19.6194 10.7921V5.20262ZM19.6194 12.7396L6.73288 19.9409H19.6194V12.7396ZM4.31938 19.3421V13.3026L6.86938 11.9526V17.9171L4.31938 19.3421ZM8.56938 16.9671L11.1194 15.5421V9.70262L8.56938 11.0526V16.9671ZM12.8194 8.80262V14.5921L15.1194 13.3068V7.58497L12.8194 8.80262Z", fill: "currentColor", fillOpacity: 0.45 }));
const ramp = SvgRamp;
const SvgRestRoom = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.68994 7.78125C7.78843 7.78125 8.68213 6.88755 8.68213 5.78906C8.68213 4.69057 7.78843 3.79688 6.68994 3.79688C5.59145 3.79688 4.69775 4.69057 4.69775 5.78906C4.69775 6.88755 5.59145 7.78125 6.68994 7.78125ZM6.68994 5.125C7.05611 5.125 7.354 5.4229 7.354 5.78906C7.354 6.15523 7.05611 6.45312 6.68994 6.45312C6.32378 6.45312 6.02588 6.15523 6.02588 5.78906C6.02588 5.4229 6.32378 5.125 6.68994 5.125ZM9.97705 9.4082V15.3184C9.97705 15.6851 9.67975 15.9824 9.31299 15.9824H8.71533V20.1328C8.71533 20.4996 8.41803 20.7969 8.05127 20.7969C7.68451 20.7969 7.38721 20.4996 7.38721 20.1328V15.3184C7.38721 14.9516 7.68451 14.6543 8.05127 14.6543H8.64893V10.0723H4.79736V14.6543H5.39502C5.76178 14.6543 6.05908 14.9516 6.05908 15.3184V20.1328C6.05908 20.4996 5.76178 20.7969 5.39502 20.7969C5.02826 20.7969 4.73096 20.4996 4.73096 20.1328V15.9824H4.1333C3.76654 15.9824 3.46924 15.6851 3.46924 15.3184V9.4082C3.46924 9.04144 3.76654 8.74414 4.1333 8.74414H9.31299C9.67975 8.74414 9.97705 9.04144 9.97705 9.4082ZM20.3042 17.4831C20.1781 17.6267 19.9963 17.709 19.8052 17.709H19.2075V20.1328C19.2075 20.4996 18.9102 20.7969 18.5435 20.7969C18.1767 20.7969 17.8794 20.4996 17.8794 20.1328V17.0449C17.8794 16.6782 18.1767 16.3809 18.5435 16.3809H19.0489L18.226 10.0723H16.2047L15.3818 16.3809H15.8872C16.254 16.3809 16.5513 16.6782 16.5513 17.0449V20.1328C16.5513 20.4996 16.254 20.7969 15.8872 20.7969C15.5204 20.7969 15.2231 20.4996 15.2231 20.1328V17.709H14.6255C14.4344 17.709 14.2526 17.6267 14.1265 17.4831C14.0004 17.3395 13.9423 17.1485 13.967 16.959L14.9631 9.32231C15.0062 8.99157 15.288 8.74414 15.6216 8.74414H18.8091C19.1426 8.74414 19.4244 8.99157 19.4676 9.32231L20.4637 16.959C20.4884 17.1485 20.4303 17.3395 20.3042 17.4831ZM12.6001 4.46094V20.1328C12.6001 20.4996 12.3028 20.7969 11.936 20.7969C11.5693 20.7969 11.272 20.4996 11.272 20.1328V4.46094C11.272 4.09418 11.5693 3.79688 11.936 3.79688C12.3028 3.79688 12.6001 4.09418 12.6001 4.46094ZM17.2485 7.78125C18.347 7.78125 19.2407 6.88755 19.2407 5.78906C19.2407 4.69057 18.347 3.79688 17.2485 3.79688C16.15 3.79688 15.2563 4.69057 15.2563 5.78906C15.2563 6.88755 16.15 7.78125 17.2485 7.78125ZM17.2485 5.125C17.6147 5.125 17.9126 5.4229 17.9126 5.78906C17.9126 6.15523 17.6147 6.45312 17.2485 6.45312C16.8824 6.45312 16.5845 6.15523 16.5845 5.78906C16.5845 5.4229 16.8824 5.125 17.2485 5.125Z", fill: "currentColor", fillOpacity: 0.45 }));
const restRoom = SvgRestRoom;
const SvgTurnstile = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.11938 4.06678C2.11938 3.58629 2.5089 3.19678 2.98938 3.19678H6.44938C6.92987 3.19678 7.31938 3.58629 7.31938 4.06678V6.94678H14.1194C14.8097 6.94678 14.8194 7.40642 14.8194 8.09678C14.8194 8.78713 14.8097 9.19678 14.1194 9.19678H9.11938L11.8128 13.6968C12.1957 14.2712 12.0435 14.5072 11.4691 14.8902C10.8947 15.2731 10.4623 15.4646 10.0793 14.8902L7.31938 10.7502V20.5268C7.31938 21.0073 6.92987 21.3968 6.44938 21.3968H2.98938C2.5089 21.3968 2.11938 21.0073 2.11938 20.5268V4.06678ZM3.81938 4.89678V19.6968H5.61938V4.89678H3.81938Z", fill: "currentColor", fillOpacity: 0.45 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.6194 4.06678C16.6194 3.58629 17.0089 3.19678 17.4894 3.19678H20.9494C21.4299 3.19678 21.8194 3.58629 21.8194 4.06678V20.5268C21.8194 21.0073 21.4299 21.3968 20.9494 21.3968H17.4894C17.0089 21.3968 16.6194 21.0073 16.6194 20.5268V4.06678ZM18.3194 4.89678V19.6968H20.1194V4.89678H18.3194Z", fill: "currentColor", fillOpacity: 0.45 }));
const turnstile = SvgTurnstile;
const dotIconPng = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAqUlEQVR4nGNgGAWjgOZAZeItdqXup3lKXU9PKHU9/QLFJ5S7nuaC5CgyXLX3kbRS17MLSt3P/uPA50FqyHd5F17D4ZaQ5RNwsHQTNByMFbuf5pBjwUliLVDqenqcZAsUu55+JtoHXU8/09qCj4MviJS7nubSNJIhGezZeWKSqVb9FTYGsjNaN15LyM9oMKBVf4UNFASgcAZFPBh3PzsGEiPb5aNgFDCQAgDztD9XpnX6xQAAAABJRU5ErkJggg==";
const Icons = {
  Drag: IconHelper.svg2Icon(Drag),
  DotIcon: IconHelper.img2Icon(dotIconPng),
  PenIcon: IconHelper.svg2Icon(Pen),
  LocationDark: IconHelper.svg2Icon(LocationDark),
  PenIconDark: IconHelper.svg2Icon(PenToolDark),
  PenToolDisable: IconHelper.svg2Icon(PenToolDisable),
  ProjectSearchDark: IconHelper.svg2Icon(ProjectSearch),
  ProjectList: IconHelper.svg2Icon(ProjectList),
  Import: IconHelper.svg2Icon(Import),
  FileDoc: IconHelper.svg2Icon(FileDoc),
  StrokeWidth: IconHelper.svg2Icon(strokeWidth),
  Compass: IconHelper.svg2Icon(Compass),
  ArrowCursor: IconHelper.svg2Icon(ArrowCursor),
  MouseCursor: IconHelper.svg2Icon(MouseCursor),
  AllDirection: IconHelper.svg2Icon(AllDirection),
  PenDraw: IconHelper.svg2Icon(PenDrawTool),
  LineDraw: IconHelper.svg2Icon(LineDrawTool),
  RectangleDraw: IconHelper.svg2Icon(ReactangleDrawTool),
  MeasureDraw: IconHelper.svg2Icon(MeasureDraw),
  CircleDraw: IconHelper.svg2Icon(CircleDrawTool),
  Export: IconHelper.svg2Icon(Export),
  PointData: IconHelper.svg2Icon(PointData),
  LineData: IconHelper.svg2Icon(LineData),
  PolygonData: IconHelper.svg2Icon(PolygonData),
  RasterData: IconHelper.svg2Icon(RasterData),
  Country: IconHelper.svg2Icon(Country),
  Region: IconHelper.svg2Icon(Region),
  Market: IconHelper.svg2Icon(Market),
  Cluster: IconHelper.svg2Icon(Cluster),
  Venue: IconHelper.svg2Icon(Venue),
  Building: IconHelper.svg2Icon(Building),
  Level: IconHelper.svg2Icon(Level$2),
  Zone: IconHelper.svg2Icon(Zone),
  Dot: IconHelper.svg2Icon(Dot),
  Search: IconHelper.svg2Icon(Search),
  Polygon: IconHelper.svg2Icon(Polygon$4),
  BoxRotateAnchor: IconHelper.svg2Icon(BoxRotateAnchor),
  BoxPointAnchor: IconHelper.svg2Icon(BoxPointAnchor),
  VenueIcon: IconHelper.svg2Icon(VenueIcon),
  BuildingIcon: IconHelper.svg2Icon(BuildingIcon),
  Undefined: IconHelper.svg2Icon(Undefined),
  DirectionLeaf: IconHelper.svg2Icon(DirectionLeaf),
  FilterDark: IconHelper.svg2Icon(FilterDark),
  FilterLight: IconHelper.svg2Icon(FilterLight),
  MoreDark: IconHelper.svg2Icon(MoreDark),
  MoreLight: IconHelper.svg2Icon(MoreLight),
  AgentDark: IconHelper.svg2Icon(AgentDark),
  AgentLight: IconHelper.svg2Icon(AgentLight),
  VenueDark: IconHelper.svg2Icon(VenueDark),
  VenueLight: IconHelper.svg2Icon(VenueLight),
  MappedLocatonDark: IconHelper.svg2Icon(MappedLocatonDark),
  MappedLocatonLight: IconHelper.svg2Icon(MappedLocatonLight),
  UnMappedLocatonDark: IconHelper.svg2Icon(UnMappedLocatonDark),
  UnMappedLocatonLight: IconHelper.svg2Icon(UnMappedLocatonLight),
  DetailsDark: IconHelper.svg2Icon(DetailsDark),
  DetailsLight: IconHelper.svg2Icon(DetailsLight),
  WorldDark: IconHelper.svg2Icon(WorldDark),
  WorldLight: IconHelper.svg2Icon(WorldLight),
  Next: IconHelper.svg2Icon(Next),
  SuperNext: IconHelper.svg2Icon(SuperNext),
  Prev: IconHelper.svg2Icon(Prev),
  SuperPrev: IconHelper.svg2Icon(SuperPrev),
  CalendarDark: IconHelper.svg2Icon(CalendarDark),
  CalendarLight: IconHelper.svg2Icon(CalendarLight),
  Cpe: IconHelper.svg2Icon(Cpe),
  Floor: IconHelper.svg2Icon(Floor),
  Infrastructure: IconHelper.svg2Icon(Infrastructure),
  Scanner: IconHelper.svg2Icon(Scanner),
  Gps: IconHelper.svg2Icon(Gps),
  Inspect: IconHelper.svg2Icon(Inspect),
  UserDevices: {
    ArVr: IconHelper.svg2Icon(ArVr),
    Laptop: IconHelper.svg2Icon(Laptop),
    Phone: IconHelper.svg2Icon(Phone),
    Sensors: IconHelper.svg2Icon(Sensors),
    SmartToy: IconHelper.svg2Icon(SmartToy),
    Vehicle: IconHelper.svg2Icon(Vehicle)
  },
  Structures: {
    CellTower: IconHelper.svg2Icon(cellTower),
    Cloud: IconHelper.svg2Icon(cloud),
    Elevator: IconHelper.svg2Icon(structureElevator),
    Dns: IconHelper.svg2Icon(dns),
    FiberCabinet: IconHelper.svg2Icon(fiberCabinet),
    FiberPedestal: IconHelper.svg2Icon(fiberPedestal),
    Flowerpot: IconHelper.svg2Icon(flowerpot),
    HardDriver: IconHelper.svg2Icon(hardDriver),
    Building: IconHelper.svg2Icon(structureBuilding),
    LatticeTower: IconHelper.svg2Icon(latticeTower),
    GasStation: IconHelper.svg2Icon(gasStation),
    Stadium: IconHelper.svg2Icon(stadium),
    Stairs: IconHelper.svg2Icon(structureStairs),
    Structures: IconHelper.svg2Icon(structures),
    Tower: IconHelper.svg2Icon(tower),
    WaterTower: IconHelper.svg2Icon(waterTower),
    OtherTowers: IconHelper.svg2Icon(otherTowers),
    Cbsd: IconHelper.svg2Icon(cbsd),
    EmergencyTruck: IconHelper.svg2Icon(emergencyTruck),
    Escalator: IconHelper.svg2Icon(escalator),
    Idf: IconHelper.svg2Icon(idf),
    Mdf: IconHelper.svg2Icon(mdf),
    Mines: IconHelper.svg2Icon(mines),
    Monopole: IconHelper.svg2Icon(monopole),
    SingleLevelBuilding: IconHelper.svg2Icon(singleLevelBuilding),
    MultiLevelBuilding: IconHelper.svg2Icon(multiLevelBuilding),
    MultiBuildings: IconHelper.svg2Icon(multiBuildings),
    OtherBuildings: IconHelper.svg2Icon(otherBuildings),
    OilRigs: IconHelper.svg2Icon(oilRigs),
    Parking: IconHelper.svg2Icon(parking),
    Podium: IconHelper.svg2Icon(podium),
    Ramp: IconHelper.svg2Icon(ramp),
    RestRoom: IconHelper.svg2Icon(restRoom),
    Turnstile: IconHelper.svg2Icon(turnstile)
  }
};
!function() {
  try {
    if ("undefined" != typeof document) {
      var t2 = document.createElement("style");
      t2.appendChild(document.createTextNode("._smartTable_1u16d_1 ._dropdown-card_1u16d_1{padding:16px;width:200px;background:white;box-shadow:0 4px 8px #0000001a;border-radius:8px}._smartTable_1u16d_1 .ant-popover-arrow{display:none}._smartTable_1u16d_1 .ant-popover-inner-content{background:transparent}._smartTable_1u16d_1 .ant-popover-inner{background:transparent!important;box-shadow:none!important}._smartTable_1u16d_1 .ant-table-cell{box-shadow:none!important}:where(._css-dev-only-do-not-override-5vuzlr_1u16d_28)._ant-table-wrapper_1u16d_28 ._ant-table-tbody_1u16d_28 ._ant-table-row_1u16d_28._ant-table-row-selected_1u16d_28>._ant-table-cell_1u16d_24{background:#FAFAFA!important}:where(._css-dev-only-do-not-override-3pb7gj_1u16d_31)._ant-table-wrapper_1u16d_28 ._ant-table-tbody_1u16d_28 ._ant-table-row_1u16d_28._ant-table-row-selected_1u16d_28>._ant-table-cell_1u16d_24{background:#FAFAFA!important}.ant-select-item-option-active{border-radius:0!important}.list_selection_dropdown_dark{width:fit-content!important;border-radius:0;background:#0A1225}.list_selection_dropdown_light{width:fit-content!important;border-radius:0;background:#F1F4F4}.list_selection_dropdown_dark .ant-select-item-option-active{background-color:#0d1730!important}.route_menu_dark .ant-menu-item-selected,.route_menu_light .ant-menu-item-selected{background-color:transparent;color:var(--button_active_color)}.titleWrapper{display:flex;justify-content:flex-start;align-items:center;gap:16px}.titleWrapper .title{margin-block:0!important;font-size:36px;font-style:normal;font-weight:500}.customSearchInput{background:transparent;color:#868b98;box-shadow:none!important;height:40px}.customSearchInput input,.custom-auto-complete input{background:transparent;color:#868b98}.customSearchInput input::placeholder,.custom-auto-complete input::placeholder{color:#868b98;opacity:.5}.custom-auto-complete .ant-input-affix-wrapper{height:40px;background:#162650!important;box-shadow:none!important;border:none;color:#868b98}.custom-auto-complete .ant-input-group-addon{display:none}.custom-auto-complete{background:#162650;height:fit-content!important}.light-mode .custom-auto-complete{background:#F1F4F4}.custom-auto-complete-popup{border-radius:0}.custom-auto-complete-popup-dark{background:#0A1225}.custom-auto-complete-popup-light{background:#F1F4F4}.noBorder{border:none}.searchDark{background:#162650;border:none}.searchLight{background:#F1F4F4;border:none}.search-border-bottom{background:transparent;border-bottom:1px solid #263454}.customSelect .ant-select-selector{padding:0!important}.customSelect{padding:0!important;border-bottom:1px solid #263454}.customFilter .ant-select-selector{padding:0!important;background-color:transparent!important;border:none!important;align-items:center;height:40px!important;box-shadow:none!important}.customFilter.ant-select-focused .ant-select-selector{border:1px solid rgba(1,102,255,.5)!important}.deviceFilter .ant-select-selector{color:#fff!important;margin-left:10px}.customFilter .ant-select-selection-placeholder{margin-left:10px}.custom-filter-dark .ant-select-selection-placeholder{color:#fff!important}.custom-filter-light .ant-select-selection-placeholder{color:#0d1730!important}.customFilter{padding:0!important;border-bottom:none!important;height:40px!important}.deviceFilter .ant-select-selection-item{color:var(--secondary-text, #868B98)}.deviceFilter .ant-select-selector{padding:0!important;background-color:transparent!important}.deviceFilter .ant-select-selection-placeholder{color:var(--secondary-text, #868B98)}.deviceList .ant-collapse-header{padding-left:1px!important}.deviceList .ant-collapse-expand-icon{padding-inline-start:0px!important}.deviceList .ant-input{background-color:transparent!important}.customNumberInput .ant-input-number-input{padding-inline:0!important}.popupDark .ant-picker-panel-container{background:#162650}.popupLight .ant-picker-panel-container{background:#FFFFFF}.customDatePicker{height:40px}.customDatePicker .ant-picker-clear{background:transparent}.rangeDatePickerDark .ant-picker-clear{color:#fff}.rangeDatePickerLight .ant-picker-clear{color:#0d1730}.rangeDatePickerDark{background:#162650}.rangeDatePickerLight{background:#F1F4F4}.datePickerPopup .ant-picker-panel-container{border-radius:unset}.datePickerPopup .ant-picker-date-panel{align-items:center}.datePickerPopup .ant-picker-header{width:100%;padding:24px 16px 0;border:none}.datePickerPopup .ant-picker-body{padding:0 16px 16px!important}.datePickerPopup .ant-picker-content{width:auto!important}.datePickerPopup .ant-picker-cell{height:36px;min-width:40px;background-color:transparent}.datePickerPopup .ant-picker-cell:before{height:100%;min-width:100%;background-color:transparent}.datePickerPopup .ant-picker-cell-in-view.ant-picker-cell-in-range:before{height:100%;min-width:100%}.popupDark .ant-picker-cell-in-view.ant-picker-cell-in-range:before{background-color:#192c5c}.popupLight .ant-picker-cell-in-view.ant-picker-cell-in-range:before{background-color:#f1f4f4}.datePickerPopup td:hover .ant-picker-cell-inner{background-color:transparent!important}.datePickerPopup .ant-picker-cell-range-end:before,.datePickerPopup .ant-picker-cell-range-start{background:var(--active, #0166FF)!important}.datePickerPopup .ant-picker-cell-range-start:before{background-color:transparent!important}.datePickerPopup .ant-picker-cell-range-start .ant-picker-cell-inner,.datePickerPopup .ant-picker-cell-range-end .ant-picker-cell-inner{background-color:transparent!important}.datePickerPopup .ant-picker-cell-range-end .ant-picker-cell-inner:before{border:none!important}.datePickerPopup .ant-picker-cell-disabled.ant-picker-cell-today .ant-picker-cell-inner:before{border:none!important}.datePickerPopup .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-end .ant-picker-cell-inner:after,.datePickerPopup .ant-picker-cell-in-view.ant-picker-cell-in-range.ant-picker-cell-range-hover-start .ant-picker-cell-inner:after{background:none!important}.customDatePicker .ant-picker-active-bar{background:var(--active, #0166FF)}.customDatePicker .ant-picker-range-separator{padding:0 24px 0 8px}.customDatePicker,.ant-picker-focused{box-shadow:none}.customAntTabPanel{width:100%}.customAntTabPanel .ant-tabs-tab-active>.ant-tabs-tab-btn{color:#868b98!important}.customAntTabPanel .ant-tabs-tab:hover{color:#868b98!important}.customAntTabPanel .ant-tabs-nav{background-color:#1e2941!important;border:1px solid #303a51;padding-inline:8px;border-radius:8px}.customAntTabPanel .ant-tabs-nav:before{display:none}.disabled-number-input .ant-input-number-input{color:#868b98}.dark-mode .ant-pagination-options .ant-select-item-option-active{background-color:#0d1730!important}.dark-mode .ant-select-dropdown{background-color:#0a1225!important}.dark-mode .ant-table-thead th{border-bottom:1px solid #263454!important}.light-mode .ant-table-thead th{border-bottom:1px solid #F1F4F4!important}.select-checkbox-content{padding:12px;display:flex;justify-content:center;align-items:center;min-height:80px,}.select-checkbox-list-dark .select-checkbox-content{background:#0A1225}.select-checkbox-list-light .select-checkbox-content{background:#F1F4F4}.dark-mode .ant-segmented-item{background:var(--side-modal-cards, #162650);color:var(--main-text, #FFF)}.light-mode .ant-segmented-item{background:var(--side-modal-cards, #F1F4F4);color:var(--main-text, #0D1730)}.dark-mode .ant-segmented-item-selected,.light-mode .ant-segmented-item-selected{background-color:#0166ff!important;color:var(--colors-white-100, #FFF)}.single-date-selection-popup .ant-picker-cell{min-width:40px;height:40px;padding:0}.single-date-selection-popup .ant-picker-cell-inner{border:none;border-radius:0;display:flex!important;align-items:center;justify-content:center;background:none!important;height:100%!important;width:100%!important}.single-date-selection-popup .ant-picker-cell-inner:before{border:none;border-radius:0;background:none!important}.single-date-selection-popup .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner{border:none;border-radius:0;background:var(--button-secondary-hover, #192C5C)!important}.single-date-selection-popup .ant-picker-cell-selected:before{background:var(--statistics-1, #0166FF)!important}.single-date-selection-popup .ant-picker-cell-in-view.ant-picker-cell-today .ant-picker-cell-inner:before{border:none;border-radius:0;background:none}.single-date-selection-popup .ant-picker-cell:hover .ant-picker-cell-inner{background:var(--button-secondary-hover, #192C5C)!important;border-radius:unset!important}.dark-mode .asset-creation-form label{color:var(--tertiary-text, #BCBEC3)}.light-mode .asset-creation-form label{color:var(--secondary-text, #868B98)}input::placeholder{color:var(--secondary-text, #868B98)!important}.ant-tree-treenode-selected{color:var(--active, #0166FF)}.select-device-type-dropdown{width:200px!important}.table-action-overlay-dark .ant-dropdown-menu{background-color:#0d1730;border-radius:0;padding:12px}.table-action-overlay-light .ant-dropdown-menu{background-color:#f1f4f4;border-radius:0;padding:12px}.table-action-overlay-dark .ant-dropdown-menu-item,.table-action-overlay-light .ant-dropdown-menu-item{padding-block:8px!important}")), document.head.appendChild(t2);
    }
  } catch (t3) {
    console.error("vite-plugin-css-injected-by-js", t3);
  }
}();
class ImageUtil {
  static utf8ToBase64(t2) {
    return window.btoa(unescape(encodeURIComponent(t2)));
  }
  static svgToUri(t2, e3) {
    return e3 ? `data:image/svg+xml;base64,${ImageUtil.utf8ToBase64(t2)}` : `data:image/svg+xml;utf8,${t2}`;
  }
  static async imageFromUrl(t2) {
    return new Promise((e3, n2) => {
      const r2 = new Image();
      r2.src = t2, r2.onload = () => {
        e3(r2);
      }, r2.onerror = () => {
        n2();
      };
    });
  }
  static async convertToCanvas(t2, e3 = 40) {
    const n2 = await ImageUtil.imageFromUrl(t2), r2 = document.createElement("canvas"), i2 = e3 / n2.width;
    r2.width = e3, r2.height = n2.height * i2;
    const a2 = r2.getContext("2d", { alpha: true });
    return a2.imageSmoothingEnabled = false, a2.drawImage(n2, 0, 0, r2.width, r2.height), r2;
  }
  static async convertToPng(t2, e3 = 40) {
    return (await ImageUtil.convertToCanvas(t2, e3)).toDataURL();
  }
  static async svgToPng(t2, e3) {
    const n2 = ImageUtil.svgToUri(t2, true);
    return await ImageUtil.convertToPng(n2, e3);
  }
  static generateCircleImage(t2, e3, { radius: n2, fill: r2, stroke: i2 = "white", strokeWidth: a2 = 2 }) {
    const o2 = document.createElement("canvas");
    o2.width = t2, o2.height = e3;
    const s2 = o2.getContext("2d", { alpha: true }), l2 = n2 || t2 / 2;
    return s2.beginPath(), s2.arc(t2 / 2, e3 / 2, l2, 0, 2 * Math.PI), s2.fillStyle = r2, s2.strokeStyle = i2, s2.lineWidth = a2, s2.fill(), s2.stroke(), s2.closePath(), o2;
  }
}
var eve$1 = { exports: {} };
!function(t2) {
  var e3, n2, r2, i2, a2, o2, s2, l2, c2, u2, d2, p2, h2, f2, g2;
  e3 = "undefined" != typeof window ? window : commonjsGlobal, i2 = "0.5.4", a2 = "hasOwnProperty", o2 = /[\.\/]/, s2 = /\s*,\s*/, l2 = function(t3, e4) {
    return t3 - e4;
  }, c2 = { n: {} }, u2 = function() {
    for (var t3 = 0, e4 = this.length; t3 < e4; t3++)
      if (void 0 !== this[t3])
        return this[t3];
  }, d2 = function() {
    for (var t3 = this.length; --t3; )
      if (void 0 !== this[t3])
        return this[t3];
  }, p2 = Object.prototype.toString, h2 = String, f2 = Array.isArray || function(t3) {
    return t3 instanceof Array || "[object Array]" == p2.call(t3);
  }, g2 = function(t3, e4) {
    var i3, a3 = r2, o3 = Array.prototype.slice.call(arguments, 2), s3 = g2.listeners(t3), c3 = 0, p3 = [], h3 = {}, f3 = [], m2 = n2;
    f3.firstDefined = u2, f3.lastDefined = d2, n2 = t3, r2 = 0;
    for (var v5 = 0, y2 = s3.length; v5 < y2; v5++)
      "zIndex" in s3[v5] && (p3.push(s3[v5].zIndex), s3[v5].zIndex < 0 && (h3[s3[v5].zIndex] = s3[v5]));
    for (p3.sort(l2); p3[c3] < 0; )
      if (i3 = h3[p3[c3++]], f3.push(i3.apply(e4, o3)), r2)
        return r2 = a3, f3;
    for (v5 = 0; v5 < y2; v5++)
      if ("zIndex" in (i3 = s3[v5]))
        if (i3.zIndex == p3[c3]) {
          if (f3.push(i3.apply(e4, o3)), r2)
            break;
          do {
            if ((i3 = h3[p3[++c3]]) && f3.push(i3.apply(e4, o3)), r2)
              break;
          } while (i3);
        } else
          h3[i3.zIndex] = i3;
      else if (f3.push(i3.apply(e4, o3)), r2)
        break;
    return r2 = a3, n2 = m2, f3;
  }, g2._events = c2, g2.listeners = function(t3) {
    var e4, n3, r3, i3, a3, s3, l3, u3, d3 = f2(t3) ? t3 : t3.split(o2), p3 = c2, h3 = [p3], g3 = [];
    for (i3 = 0, a3 = d3.length; i3 < a3; i3++) {
      for (u3 = [], s3 = 0, l3 = h3.length; s3 < l3; s3++)
        for (n3 = [(p3 = h3[s3].n)[d3[i3]], p3["*"]], r3 = 2; r3--; )
          (e4 = n3[r3]) && (u3.push(e4), g3 = g3.concat(e4.f || []));
      h3 = u3;
    }
    return g3;
  }, g2.separator = function(t3) {
    t3 ? (t3 = "[" + (t3 = h2(t3).replace(/(?=[\.\^\]\[\-])/g, "\\")) + "]", o2 = new RegExp(t3)) : o2 = /[\.\/]/;
  }, g2.on = function(t3, e4) {
    if ("function" != typeof e4)
      return function() {
      };
    for (var n3 = f2(t3) ? f2(t3[0]) ? t3 : [t3] : h2(t3).split(s2), r3 = 0, i3 = n3.length; r3 < i3; r3++)
      !function(t4) {
        for (var n4, r4 = f2(t4) ? t4 : h2(t4).split(o2), i4 = c2, a3 = 0, s3 = r4.length; a3 < s3; a3++)
          i4 = (i4 = i4.n).hasOwnProperty(r4[a3]) && i4[r4[a3]] || (i4[r4[a3]] = { n: {} });
        for (i4.f = i4.f || [], a3 = 0, s3 = i4.f.length; a3 < s3; a3++)
          if (i4.f[a3] == e4) {
            n4 = true;
            break;
          }
        !n4 && i4.f.push(e4);
      }(n3[r3]);
    return function(t4) {
      +t4 == +t4 && (e4.zIndex = +t4);
    };
  }, g2.f = function(t3) {
    var e4 = [].slice.call(arguments, 1);
    return function() {
      g2.apply(null, [t3, null].concat(e4).concat([].slice.call(arguments, 0)));
    };
  }, g2.stop = function() {
    r2 = 1;
  }, g2.nt = function(t3) {
    var e4 = f2(n2) ? n2.join(".") : n2;
    return t3 ? new RegExp("(?:\\.|\\/|^)" + t3 + "(?:\\.|\\/|$)").test(e4) : e4;
  }, g2.nts = function() {
    return f2(n2) ? n2 : n2.split(o2);
  }, g2.off = g2.unbind = function(t3, e4) {
    if (t3) {
      var n3 = f2(t3) ? f2(t3[0]) ? t3 : [t3] : h2(t3).split(s2);
      if (n3.length > 1)
        for (var r3 = 0, i3 = n3.length; r3 < i3; r3++)
          g2.off(n3[r3], e4);
      else {
        n3 = f2(t3) ? t3 : h2(t3).split(o2);
        var l3, u3, d3, p3, m2, v5 = [c2], y2 = [];
        for (r3 = 0, i3 = n3.length; r3 < i3; r3++)
          for (p3 = 0; p3 < v5.length; p3 += d3.length - 2) {
            if (d3 = [p3, 1], l3 = v5[p3].n, "*" != n3[r3])
              l3[n3[r3]] && (d3.push(l3[n3[r3]]), y2.unshift({ n: l3, name: n3[r3] }));
            else
              for (u3 in l3)
                l3[a2](u3) && (d3.push(l3[u3]), y2.unshift({ n: l3, name: u3 }));
            v5.splice.apply(v5, d3);
          }
        for (r3 = 0, i3 = v5.length; r3 < i3; r3++)
          for (l3 = v5[r3]; l3.n; ) {
            if (e4) {
              if (l3.f) {
                for (p3 = 0, m2 = l3.f.length; p3 < m2; p3++)
                  if (l3.f[p3] == e4) {
                    l3.f.splice(p3, 1);
                    break;
                  }
                !l3.f.length && delete l3.f;
              }
              for (u3 in l3.n)
                if (l3.n[a2](u3) && l3.n[u3].f) {
                  var b2 = l3.n[u3].f;
                  for (p3 = 0, m2 = b2.length; p3 < m2; p3++)
                    if (b2[p3] == e4) {
                      b2.splice(p3, 1);
                      break;
                    }
                  !b2.length && delete l3.n[u3].f;
                }
            } else
              for (u3 in delete l3.f, l3.n)
                l3.n[a2](u3) && l3.n[u3].f && delete l3.n[u3].f;
            l3 = l3.n;
          }
        t:
          for (r3 = 0, i3 = y2.length; r3 < i3; r3++) {
            for (u3 in (l3 = y2[r3]).n[l3.name].f)
              continue t;
            for (u3 in l3.n[l3.name].n)
              continue t;
            delete l3.n[l3.name];
          }
      }
    } else
      g2._events = c2 = { n: {} };
  }, g2.once = function(t3, e4) {
    var n3 = function() {
      return g2.off(t3, n3), e4.apply(this, arguments);
    };
    return g2.on(t3, n3);
  }, g2.version = i2, g2.toString = function() {
    return "You are running Eve " + i2;
  }, e3.eve = g2, t2.exports ? t2.exports = g2 : e3.eve = g2;
}(eve$1);
var eveExports = eve$1.exports, snap_svg = { exports: {} };
!function(t2) {
  var e3, n2, r2, i2, a2, o2, s2, l2, c2, u2, d2, p2, h2, f2;
  e3 = commonjsGlobal, i2 = "0.5.0", a2 = "hasOwnProperty", o2 = /[\.\/]/, s2 = /\s*,\s*/, l2 = function(t3, e4) {
    return t3 - e4;
  }, c2 = { n: {} }, u2 = function() {
    for (var t3 = 0, e4 = this.length; t3 < e4; t3++)
      if (void 0 !== this[t3])
        return this[t3];
  }, d2 = function() {
    for (var t3 = this.length; --t3; )
      if (void 0 !== this[t3])
        return this[t3];
  }, p2 = Object.prototype.toString, h2 = String, f2 = Array.isArray || function(t3) {
    return t3 instanceof Array || "[object Array]" == p2.call(t3);
  }, eve = function(t3, e4) {
    var i3, a3 = r2, o3 = Array.prototype.slice.call(arguments, 2), s3 = eve.listeners(t3), c3 = 0, p3 = [], h3 = {}, f3 = [], g2 = n2;
    f3.firstDefined = u2, f3.lastDefined = d2, n2 = t3, r2 = 0;
    for (var m2 = 0, v5 = s3.length; m2 < v5; m2++)
      "zIndex" in s3[m2] && (p3.push(s3[m2].zIndex), s3[m2].zIndex < 0 && (h3[s3[m2].zIndex] = s3[m2]));
    for (p3.sort(l2); p3[c3] < 0; )
      if (i3 = h3[p3[c3++]], f3.push(i3.apply(e4, o3)), r2)
        return r2 = a3, f3;
    for (m2 = 0; m2 < v5; m2++)
      if ("zIndex" in (i3 = s3[m2]))
        if (i3.zIndex == p3[c3]) {
          if (f3.push(i3.apply(e4, o3)), r2)
            break;
          do {
            if ((i3 = h3[p3[++c3]]) && f3.push(i3.apply(e4, o3)), r2)
              break;
          } while (i3);
        } else
          h3[i3.zIndex] = i3;
      else if (f3.push(i3.apply(e4, o3)), r2)
        break;
    return r2 = a3, n2 = g2, f3;
  }, eve._events = c2, eve.listeners = function(t3) {
    var e4, n3, r3, i3, a3, s3, l3, u3, d3 = f2(t3) ? t3 : t3.split(o2), p3 = c2, h3 = [p3], g2 = [];
    for (i3 = 0, a3 = d3.length; i3 < a3; i3++) {
      for (u3 = [], s3 = 0, l3 = h3.length; s3 < l3; s3++)
        for (n3 = [(p3 = h3[s3].n)[d3[i3]], p3["*"]], r3 = 2; r3--; )
          (e4 = n3[r3]) && (u3.push(e4), g2 = g2.concat(e4.f || []));
      h3 = u3;
    }
    return g2;
  }, eve.separator = function(t3) {
    t3 ? (t3 = "[" + (t3 = h2(t3).replace(/(?=[\.\^\]\[\-])/g, "\\")) + "]", o2 = new RegExp(t3)) : o2 = /[\.\/]/;
  }, eve.on = function(t3, e4) {
    if ("function" != typeof e4)
      return function() {
      };
    for (var n3 = f2(t3) ? f2(t3[0]) ? t3 : [t3] : h2(t3).split(s2), r3 = 0, i3 = n3.length; r3 < i3; r3++)
      !function(t4) {
        for (var n4, r4 = f2(t4) ? t4 : h2(t4).split(o2), i4 = c2, a3 = 0, s3 = r4.length; a3 < s3; a3++)
          i4 = (i4 = i4.n).hasOwnProperty(r4[a3]) && i4[r4[a3]] || (i4[r4[a3]] = { n: {} });
        for (i4.f = i4.f || [], a3 = 0, s3 = i4.f.length; a3 < s3; a3++)
          if (i4.f[a3] == e4) {
            n4 = true;
            break;
          }
        !n4 && i4.f.push(e4);
      }(n3[r3]);
    return function(t4) {
      +t4 == +t4 && (e4.zIndex = +t4);
    };
  }, eve.f = function(t3) {
    var e4 = [].slice.call(arguments, 1);
    return function() {
      eve.apply(null, [t3, null].concat(e4).concat([].slice.call(arguments, 0)));
    };
  }, eve.stop = function() {
    r2 = 1;
  }, eve.nt = function(t3) {
    var e4 = f2(n2) ? n2.join(".") : n2;
    return t3 ? new RegExp("(?:\\.|\\/|^)" + t3 + "(?:\\.|\\/|$)").test(e4) : e4;
  }, eve.nts = function() {
    return f2(n2) ? n2 : n2.split(o2);
  }, eve.off = eve.unbind = function(t3, e4) {
    if (t3) {
      var n3 = f2(t3) ? f2(t3[0]) ? t3 : [t3] : h2(t3).split(s2);
      if (n3.length > 1)
        for (var r3 = 0, i3 = n3.length; r3 < i3; r3++)
          eve.off(n3[r3], e4);
      else {
        n3 = f2(t3) ? t3 : h2(t3).split(o2);
        var l3, u3, d3, p3, g2, m2 = [c2], v5 = [];
        for (r3 = 0, i3 = n3.length; r3 < i3; r3++)
          for (p3 = 0; p3 < m2.length; p3 += d3.length - 2) {
            if (d3 = [p3, 1], l3 = m2[p3].n, "*" != n3[r3])
              l3[n3[r3]] && (d3.push(l3[n3[r3]]), v5.unshift({ n: l3, name: n3[r3] }));
            else
              for (u3 in l3)
                l3[a2](u3) && (d3.push(l3[u3]), v5.unshift({ n: l3, name: u3 }));
            m2.splice.apply(m2, d3);
          }
        for (r3 = 0, i3 = m2.length; r3 < i3; r3++)
          for (l3 = m2[r3]; l3.n; ) {
            if (e4) {
              if (l3.f) {
                for (p3 = 0, g2 = l3.f.length; p3 < g2; p3++)
                  if (l3.f[p3] == e4) {
                    l3.f.splice(p3, 1);
                    break;
                  }
                !l3.f.length && delete l3.f;
              }
              for (u3 in l3.n)
                if (l3.n[a2](u3) && l3.n[u3].f) {
                  var y2 = l3.n[u3].f;
                  for (p3 = 0, g2 = y2.length; p3 < g2; p3++)
                    if (y2[p3] == e4) {
                      y2.splice(p3, 1);
                      break;
                    }
                  !y2.length && delete l3.n[u3].f;
                }
            } else
              for (u3 in delete l3.f, l3.n)
                l3.n[a2](u3) && l3.n[u3].f && delete l3.n[u3].f;
            l3 = l3.n;
          }
        t:
          for (r3 = 0, i3 = v5.length; r3 < i3; r3++) {
            for (u3 in (l3 = v5[r3]).n[l3.name].f)
              continue t;
            for (u3 in l3.n[l3.name].n)
              continue t;
            delete l3.n[l3.name];
          }
      }
    } else
      eve._events = c2 = { n: {} };
  }, eve.once = function(t3, e4) {
    var n3 = function() {
      return eve.off(t3, n3), e4.apply(this, arguments);
    };
    return eve.on(t3, n3);
  }, eve.version = i2, eve.toString = function() {
    return "You are running Eve " + i2;
  }, t2.exports ? t2.exports = eve : e3.eve = eve, function(e4) {
    var n3 = eveExports;
    t2.exports = function(t3, e5) {
      var n4 = function(e6) {
        var n5, r4 = {}, i3 = t3.requestAnimationFrame || t3.webkitRequestAnimationFrame || t3.mozRequestAnimationFrame || t3.oRequestAnimationFrame || t3.msRequestAnimationFrame || function(t4) {
          return setTimeout(t4, 16, (/* @__PURE__ */ new Date()).getTime()), true;
        }, a3 = Array.isArray || function(t4) {
          return t4 instanceof Array || "[object Array]" == Object.prototype.toString.call(t4);
        }, o3 = 0, s3 = "M" + (+/* @__PURE__ */ new Date()).toString(36), l3 = function() {
          return s3 + (o3++).toString(36);
        }, c3 = Date.now || function() {
          return +/* @__PURE__ */ new Date();
        }, u3 = function(t4) {
          var e7 = this;
          if (null == t4)
            return e7.s;
          var n6 = e7.s - t4;
          e7.b += e7.dur * n6, e7.B += e7.dur * n6, e7.s = t4;
        }, d3 = function(t4) {
          var e7 = this;
          if (null == t4)
            return e7.spd;
          e7.spd = t4;
        }, p3 = function(t4) {
          var e7 = this;
          if (null == t4)
            return e7.dur;
          e7.s = e7.s * t4 / e7.dur, e7.dur = t4;
        }, h3 = function() {
          var t4 = this;
          delete r4[t4.id], t4.update(), e6("mina.stop." + t4.id, t4);
        }, f3 = function() {
          var t4 = this;
          t4.pdif || (delete r4[t4.id], t4.update(), t4.pdif = t4.get() - t4.b);
        }, g2 = function() {
          var t4 = this;
          t4.pdif && (t4.b = t4.get() - t4.pdif, delete t4.pdif, r4[t4.id] = t4, v5());
        }, m2 = function() {
          var t4, e7 = this;
          if (a3(e7.start)) {
            t4 = [];
            for (var n6 = 0, r5 = e7.start.length; n6 < r5; n6++)
              t4[n6] = +e7.start[n6] + (e7.end[n6] - e7.start[n6]) * e7.easing(e7.s);
          } else
            t4 = +e7.start + (e7.end - e7.start) * e7.easing(e7.s);
          e7.set(t4);
        }, v5 = function(t4) {
          if (t4) {
            var a4 = 0;
            for (var o4 in r4)
              if (r4.hasOwnProperty(o4)) {
                var s4 = r4[o4], l4 = s4.get();
                a4++, s4.s = (l4 - s4.b) / (s4.dur / s4.spd), s4.s >= 1 && (delete r4[o4], s4.s = 1, a4--, function(t5) {
                  setTimeout(function() {
                    e6("mina.finish." + t5.id, t5);
                  });
                }(s4)), s4.update();
              }
            n5 = !!a4 && i3(v5);
          } else
            n5 || (n5 = i3(v5));
        }, y2 = function(t4, e7, n6, i4, a4, o4, s4) {
          var c4 = { id: l3(), start: t4, end: e7, b: n6, s: 0, dur: i4 - n6, spd: 1, get: a4, set: o4, easing: s4 || y2.linear, status: u3, speed: d3, duration: p3, stop: h3, pause: f3, resume: g2, update: m2 };
          r4[c4.id] = c4;
          var b2, x2 = 0;
          for (b2 in r4)
            if (r4.hasOwnProperty(b2) && 2 == ++x2)
              break;
          return 1 == x2 && v5(), c4;
        };
        return y2.time = c3, y2.getById = function(t4) {
          return r4[t4] || null;
        }, y2.linear = function(t4) {
          return t4;
        }, y2.easeout = function(t4) {
          return Math.pow(t4, 1.7);
        }, y2.easein = function(t4) {
          return Math.pow(t4, 0.48);
        }, y2.easeinout = function(t4) {
          if (1 == t4)
            return 1;
          if (0 == t4)
            return 0;
          var e7 = 0.48 - t4 / 1.04, n6 = Math.sqrt(0.1734 + e7 * e7), r5 = n6 - e7, i4 = -n6 - e7, a4 = Math.pow(Math.abs(r5), 1 / 3) * (r5 < 0 ? -1 : 1) + Math.pow(Math.abs(i4), 1 / 3) * (i4 < 0 ? -1 : 1) + 0.5;
          return 3 * (1 - a4) * a4 * a4 + a4 * a4 * a4;
        }, y2.backin = function(t4) {
          if (1 == t4)
            return 1;
          var e7 = 1.70158;
          return t4 * t4 * ((e7 + 1) * t4 - e7);
        }, y2.backout = function(t4) {
          if (0 == t4)
            return 0;
          var e7 = 1.70158;
          return (t4 -= 1) * t4 * ((e7 + 1) * t4 + e7) + 1;
        }, y2.elastic = function(t4) {
          return t4 == !!t4 ? t4 : Math.pow(2, -10 * t4) * Math.sin((t4 - 0.075) * (2 * Math.PI) / 0.3) + 1;
        }, y2.bounce = function(t4) {
          var e7 = 7.5625, n6 = 2.75;
          return t4 < 1 / n6 ? e7 * t4 * t4 : t4 < 2 / n6 ? e7 * (t4 -= 1.5 / n6) * t4 + 0.75 : t4 < 2.5 / n6 ? e7 * (t4 -= 2.25 / n6) * t4 + 0.9375 : e7 * (t4 -= 2.625 / n6) * t4 + 0.984375;
        }, t3.mina = y2, y2;
      }(void 0 === e5 ? function() {
      } : e5), r3 = function(t4) {
        function n5(t5, e6) {
          if (t5) {
            if (t5.nodeType)
              return nt(t5);
            if (T2(t5, "array") && n5.set)
              return n5.set.apply(n5, t5);
            if (t5 instanceof J2)
              return t5;
            if (null == e6)
              return nt(t5 = r4.doc.querySelector(String(t5)));
          }
          return new et(t5 = null == t5 ? "100%" : t5, e6 = null == e6 ? "100%" : e6);
        }
        n5.version = "0.5.1", n5.toString = function() {
          return "Snap v" + this.version;
        }, n5._ = {};
        var r4 = { win: t4.window, doc: t4.window.document };
        n5._.glob = r4;
        var i3 = "hasOwnProperty", a3 = String, o3 = parseFloat, s3 = parseInt, l3 = Math, c3 = l3.max, u3 = l3.min, d3 = l3.abs, p3 = l3.PI, h3 = "", f3 = Object.prototype.toString, m2 = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i;
        n5._.separator = /[,\s]+/;
        var v5, y2, b2, x2 = /[\s]*,[\s]*/, F2 = { hs: 1, rg: 1 }, k2 = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi, w2 = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/gi, S2 = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/gi, C2 = 0, A2 = "S" + (+/* @__PURE__ */ new Date()).toString(36), E3 = function(t5) {
          return (t5 && t5.type ? t5.type : h3) + A2 + (C2++).toString(36);
        }, I2 = "http://www.w3.org/1999/xlink", B2 = "http://www.w3.org/2000/svg", _2 = {};
        function D2(t5, e6) {
          if (e6) {
            if ("#text" == t5 && (t5 = r4.doc.createTextNode(e6.text || e6["#text"] || "")), "#comment" == t5 && (t5 = r4.doc.createComment(e6.text || e6["#text"] || "")), "string" == typeof t5 && (t5 = D2(t5)), "string" == typeof e6)
              return 1 == t5.nodeType ? "xlink:" == e6.substring(0, 6) ? t5.getAttributeNS(I2, e6.substring(6)) : "xml:" == e6.substring(0, 4) ? t5.getAttributeNS(B2, e6.substring(4)) : t5.getAttribute(e6) : "text" == e6 ? t5.nodeValue : null;
            if (1 == t5.nodeType) {
              for (var n6 in e6)
                if (e6[i3](n6)) {
                  var o4 = a3(e6[n6]);
                  o4 ? "xlink:" == n6.substring(0, 6) ? t5.setAttributeNS(I2, n6.substring(6), o4) : "xml:" == n6.substring(0, 4) ? t5.setAttributeNS(B2, n6.substring(4), o4) : t5.setAttribute(n6, o4) : t5.removeAttribute(n6);
                }
            } else
              "text" in e6 && (t5.nodeValue = e6.text);
          } else
            t5 = r4.doc.createElementNS(B2, t5);
          return t5;
        }
        function T2(t5, e6) {
          return "finite" == (e6 = a3.prototype.toLowerCase.call(e6)) ? isFinite(t5) : !("array" != e6 || !(t5 instanceof Array || Array.isArray && Array.isArray(t5))) || ("null" == e6 && null === t5 || e6 == typeof t5 && null !== t5 || "object" == e6 && t5 === Object(t5) || f3.call(t5).slice(8, -1).toLowerCase() == e6);
        }
        function U2(t5) {
          if ("function" == typeof t5 || Object(t5) !== t5)
            return t5;
          var e6 = new t5.constructor();
          for (var n6 in t5)
            t5[i3](n6) && (e6[n6] = U2(t5[n6]));
          return e6;
        }
        function M2(t5, e6) {
          for (var n6 = 0, r5 = t5.length; n6 < r5; n6++)
            if (t5[n6] === e6)
              return t5.push(t5.splice(n6, 1)[0]);
        }
        function P2(t5, e6, n6) {
          function r5() {
            var a4 = Array.prototype.slice.call(arguments, 0), o4 = a4.join("␀"), s4 = r5.cache = r5.cache || {}, l4 = r5.count = r5.count || [];
            return s4[i3](o4) ? (M2(l4, o4), n6 ? n6(s4[o4]) : s4[o4]) : (l4.length >= 1e3 && delete s4[l4.shift()], l4.push(o4), s4[o4] = t5.apply(e6, a4), n6 ? n6(s4[o4]) : s4[o4]);
          }
          return r5;
        }
        function N2(t5, e6, n6, r5, i4, a4) {
          if (null == i4) {
            var o4 = t5 - n6, s4 = e6 - r5;
            return o4 || s4 ? (180 + 180 * l3.atan2(-s4, -o4) / p3 + 360) % 360 : 0;
          }
          return N2(t5, e6, i4, a4) - N2(n6, r5, i4, a4);
        }
        function O2(t5) {
          return t5 % 360 * p3 / 180;
        }
        function j2(t5) {
          return 180 * t5 / p3 % 360;
        }
        n5.url = function(t5) {
          return "url('#" + t5 + "')";
        }, n5._.$ = D2, n5._.id = E3, n5.format = (v5 = /\{([^\}]+)\}/g, y2 = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, b2 = function(t5, e6, n6) {
          var r5 = n6;
          return e6.replace(y2, function(t6, e7, n7, i4, a4) {
            e7 = e7 || i4, r5 && (e7 in r5 && (r5 = r5[e7]), "function" == typeof r5 && a4 && (r5 = r5()));
          }), r5 = (null == r5 || r5 == n6 ? t5 : r5) + "";
        }, function(t5, e6) {
          return a3(t5).replace(v5, function(t6, n6) {
            return b2(t6, n6, e6);
          });
        }), n5._.clone = U2, n5._.cacher = P2, n5.rad = O2, n5.deg = j2, n5.sin = function(t5) {
          return l3.sin(n5.rad(t5));
        }, n5.tan = function(t5) {
          return l3.tan(n5.rad(t5));
        }, n5.cos = function(t5) {
          return l3.cos(n5.rad(t5));
        }, n5.asin = function(t5) {
          return n5.deg(l3.asin(t5));
        }, n5.acos = function(t5) {
          return n5.deg(l3.acos(t5));
        }, n5.atan = function(t5) {
          return n5.deg(l3.atan(t5));
        }, n5.atan2 = function(t5) {
          return n5.deg(l3.atan2(t5));
        }, n5.angle = N2, n5.len = function(t5, e6, r5, i4) {
          return Math.sqrt(n5.len2(t5, e6, r5, i4));
        }, n5.len2 = function(t5, e6, n6, r5) {
          return (t5 - n6) * (t5 - n6) + (e6 - r5) * (e6 - r5);
        }, n5.closestPoint = function(t5, e6, n6) {
          function r5(t6) {
            var r6 = t6.x - e6, i5 = t6.y - n6;
            return r6 * r6 + i5 * i5;
          }
          for (var i4, a4, o4, s4, l4 = t5.node, c4 = l4.getTotalLength(), u4 = c4 / l4.pathSegList.numberOfItems * 0.125, d4 = 1 / 0, p4 = 0; p4 <= c4; p4 += u4)
            (s4 = r5(o4 = l4.getPointAtLength(p4))) < d4 && (i4 = o4, a4 = p4, d4 = s4);
          for (u4 *= 0.5; u4 > 0.5; ) {
            var h4, f4, g2, m3, v6, y3;
            (g2 = a4 - u4) >= 0 && (v6 = r5(h4 = l4.getPointAtLength(g2))) < d4 ? (i4 = h4, a4 = g2, d4 = v6) : (m3 = a4 + u4) <= c4 && (y3 = r5(f4 = l4.getPointAtLength(m3))) < d4 ? (i4 = f4, a4 = m3, d4 = y3) : u4 *= 0.5;
          }
          return i4 = { x: i4.x, y: i4.y, length: a4, distance: Math.sqrt(d4) };
        }, n5.is = T2, n5.snapTo = function(t5, e6, n6) {
          if (n6 = T2(n6, "finite") ? n6 : 10, T2(t5, "array")) {
            for (var r5 = t5.length; r5--; )
              if (d3(t5[r5] - e6) <= n6)
                return t5[r5];
          } else {
            var i4 = e6 % (t5 = +t5);
            if (i4 < n6)
              return e6 - i4;
            if (i4 > t5 - n6)
              return e6 - i4 + t5;
          }
          return e6;
        }, n5.getRGB = P2(function(t5) {
          if (!t5 || (t5 = a3(t5)).indexOf("-") + 1)
            return { r: -1, g: -1, b: -1, hex: "none", error: 1, toString: G2 };
          if ("none" == t5)
            return { r: -1, g: -1, b: -1, hex: "none", toString: G2 };
          if (!F2[i3](t5.toLowerCase().substring(0, 2)) && "#" != t5.charAt() && (t5 = L2(t5)), !t5)
            return { r: -1, g: -1, b: -1, hex: "none", error: 1, toString: G2 };
          var e6, r5, d4, p4, h4, f4, g2 = t5.match(m2);
          return g2 ? (g2[2] && (d4 = s3(g2[2].substring(5), 16), r5 = s3(g2[2].substring(3, 5), 16), e6 = s3(g2[2].substring(1, 3), 16)), g2[3] && (d4 = s3((h4 = g2[3].charAt(3)) + h4, 16), r5 = s3((h4 = g2[3].charAt(2)) + h4, 16), e6 = s3((h4 = g2[3].charAt(1)) + h4, 16)), g2[4] && (f4 = g2[4].split(x2), e6 = o3(f4[0]), "%" == f4[0].slice(-1) && (e6 *= 2.55), r5 = o3(f4[1]), "%" == f4[1].slice(-1) && (r5 *= 2.55), d4 = o3(f4[2]), "%" == f4[2].slice(-1) && (d4 *= 2.55), "rgba" == g2[1].toLowerCase().slice(0, 4) && (p4 = o3(f4[3])), f4[3] && "%" == f4[3].slice(-1) && (p4 /= 100)), g2[5] ? (f4 = g2[5].split(x2), e6 = o3(f4[0]), "%" == f4[0].slice(-1) && (e6 /= 100), r5 = o3(f4[1]), "%" == f4[1].slice(-1) && (r5 /= 100), d4 = o3(f4[2]), "%" == f4[2].slice(-1) && (d4 /= 100), ("deg" == f4[0].slice(-3) || "°" == f4[0].slice(-1)) && (e6 /= 360), "hsba" == g2[1].toLowerCase().slice(0, 4) && (p4 = o3(f4[3])), f4[3] && "%" == f4[3].slice(-1) && (p4 /= 100), n5.hsb2rgb(e6, r5, d4, p4)) : g2[6] ? (f4 = g2[6].split(x2), e6 = o3(f4[0]), "%" == f4[0].slice(-1) && (e6 /= 100), r5 = o3(f4[1]), "%" == f4[1].slice(-1) && (r5 /= 100), d4 = o3(f4[2]), "%" == f4[2].slice(-1) && (d4 /= 100), ("deg" == f4[0].slice(-3) || "°" == f4[0].slice(-1)) && (e6 /= 360), "hsla" == g2[1].toLowerCase().slice(0, 4) && (p4 = o3(f4[3])), f4[3] && "%" == f4[3].slice(-1) && (p4 /= 100), n5.hsl2rgb(e6, r5, d4, p4)) : (e6 = u3(l3.round(e6), 255), r5 = u3(l3.round(r5), 255), d4 = u3(l3.round(d4), 255), p4 = u3(c3(p4, 0), 1), (g2 = { r: e6, g: r5, b: d4, toString: G2 }).hex = "#" + (16777216 | d4 | r5 << 8 | e6 << 16).toString(16).slice(1), g2.opacity = T2(p4, "finite") ? p4 : 1, g2)) : { r: -1, g: -1, b: -1, hex: "none", error: 1, toString: G2 };
        }, n5), n5.hsb = P2(function(t5, e6, r5) {
          return n5.hsb2rgb(t5, e6, r5).hex;
        }), n5.hsl = P2(function(t5, e6, r5) {
          return n5.hsl2rgb(t5, e6, r5).hex;
        }), n5.rgb = P2(function(t5, e6, n6, r5) {
          if (T2(r5, "finite")) {
            var i4 = l3.round;
            return "rgba(" + [i4(t5), i4(e6), i4(n6), +r5.toFixed(2)] + ")";
          }
          return "#" + (16777216 | n6 | e6 << 8 | t5 << 16).toString(16).slice(1);
        });
        var L2 = function(t5) {
          var e6 = r4.doc.getElementsByTagName("head")[0] || r4.doc.getElementsByTagName("svg")[0], n6 = "rgb(255, 0, 0)";
          return (L2 = P2(function(t6) {
            if ("red" == t6.toLowerCase())
              return n6;
            e6.style.color = n6, e6.style.color = t6;
            var i4 = r4.doc.defaultView.getComputedStyle(e6, h3).getPropertyValue("color");
            return i4 == n6 ? null : i4;
          }))(t5);
        }, R2 = function() {
          return "hsb(" + [this.h, this.s, this.b] + ")";
        }, z2 = function() {
          return "hsl(" + [this.h, this.s, this.l] + ")";
        }, G2 = function() {
          return 1 == this.opacity || null == this.opacity ? this.hex : "rgba(" + [this.r, this.g, this.b, this.opacity] + ")";
        }, q2 = function(t5, e6, r5) {
          if (null == e6 && T2(t5, "object") && "r" in t5 && "g" in t5 && "b" in t5 && (r5 = t5.b, e6 = t5.g, t5 = t5.r), null == e6 && T2(t5, string)) {
            var i4 = n5.getRGB(t5);
            t5 = i4.r, e6 = i4.g, r5 = i4.b;
          }
          return (t5 > 1 || e6 > 1 || r5 > 1) && (t5 /= 255, e6 /= 255, r5 /= 255), [t5, e6, r5];
        }, V2 = function(t5, e6, r5, i4) {
          var a4 = { r: t5 = l3.round(255 * t5), g: e6 = l3.round(255 * e6), b: r5 = l3.round(255 * r5), opacity: T2(i4, "finite") ? i4 : 1, hex: n5.rgb(t5, e6, r5), toString: G2 };
          return T2(i4, "finite") && (a4.opacity = i4), a4;
        };
        n5.color = function(t5) {
          var e6;
          return T2(t5, "object") && "h" in t5 && "s" in t5 && "b" in t5 ? (e6 = n5.hsb2rgb(t5), t5.r = e6.r, t5.g = e6.g, t5.b = e6.b, t5.opacity = 1, t5.hex = e6.hex) : T2(t5, "object") && "h" in t5 && "s" in t5 && "l" in t5 ? (e6 = n5.hsl2rgb(t5), t5.r = e6.r, t5.g = e6.g, t5.b = e6.b, t5.opacity = 1, t5.hex = e6.hex) : (T2(t5, "string") && (t5 = n5.getRGB(t5)), T2(t5, "object") && "r" in t5 && "g" in t5 && "b" in t5 && !("error" in t5) ? (e6 = n5.rgb2hsl(t5), t5.h = e6.h, t5.s = e6.s, t5.l = e6.l, e6 = n5.rgb2hsb(t5), t5.v = e6.b) : ((t5 = { hex: "none" }).r = t5.g = t5.b = t5.h = t5.s = t5.v = t5.l = -1, t5.error = 1)), t5.toString = G2, t5;
        }, n5.hsb2rgb = function(t5, e6, n6, r5) {
          var i4, a4, o4, s4, l4;
          return T2(t5, "object") && "h" in t5 && "s" in t5 && "b" in t5 && (n6 = t5.b, e6 = t5.s, r5 = t5.o, t5 = t5.h), s4 = (l4 = n6 * e6) * (1 - d3((t5 = (t5 *= 360) % 360 / 60) % 2 - 1)), i4 = a4 = o4 = n6 - l4, V2(i4 += [l4, s4, 0, 0, s4, l4][t5 = ~~t5], a4 += [s4, l4, l4, s4, 0, 0][t5], o4 += [0, 0, s4, l4, l4, s4][t5], r5);
        }, n5.hsl2rgb = function(t5, e6, n6, r5) {
          var i4, a4, o4, s4, l4;
          return T2(t5, "object") && "h" in t5 && "s" in t5 && "l" in t5 && (n6 = t5.l, e6 = t5.s, t5 = t5.h), (t5 > 1 || e6 > 1 || n6 > 1) && (t5 /= 360, e6 /= 100, n6 /= 100), s4 = (l4 = 2 * e6 * (n6 < 0.5 ? n6 : 1 - n6)) * (1 - d3((t5 = (t5 *= 360) % 360 / 60) % 2 - 1)), i4 = a4 = o4 = n6 - l4 / 2, V2(i4 += [l4, s4, 0, 0, s4, l4][t5 = ~~t5], a4 += [s4, l4, l4, s4, 0, 0][t5], o4 += [0, 0, s4, l4, l4, s4][t5], r5);
        }, n5.rgb2hsb = function(t5, e6, n6) {
          var r5, i4;
          return t5 = (n6 = q2(t5, e6, n6))[0], e6 = n6[1], n6 = n6[2], { h: ((0 == (i4 = (r5 = c3(t5, e6, n6)) - u3(t5, e6, n6)) ? null : r5 == t5 ? (e6 - n6) / i4 : r5 == e6 ? (n6 - t5) / i4 + 2 : (t5 - e6) / i4 + 4) + 360) % 6 * 60 / 360, s: 0 == i4 ? 0 : i4 / r5, b: r5, toString: R2 };
        }, n5.rgb2hsl = function(t5, e6, n6) {
          var r5, i4, a4, o4;
          return t5 = (n6 = q2(t5, e6, n6))[0], e6 = n6[1], n6 = n6[2], r5 = ((i4 = c3(t5, e6, n6)) + (a4 = u3(t5, e6, n6))) / 2, { h: ((0 == (o4 = i4 - a4) ? null : i4 == t5 ? (e6 - n6) / o4 : i4 == e6 ? (n6 - t5) / o4 + 2 : (t5 - e6) / o4 + 4) + 360) % 6 * 60 / 360, s: 0 == o4 ? 0 : r5 < 0.5 ? o4 / (2 * r5) : o4 / (2 - 2 * r5), l: r5, toString: z2 };
        }, n5.parsePathString = function(t5) {
          if (!t5)
            return null;
          var e6 = n5.path(t5);
          if (e6.arr)
            return n5.path.clone(e6.arr);
          var r5 = { a: 7, c: 6, o: 2, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, u: 3, z: 0 }, i4 = [];
          return T2(t5, "array") && T2(t5[0], "array") && (i4 = n5.path.clone(t5)), i4.length || a3(t5).replace(k2, function(t6, e7, n6) {
            var a4 = [], o4 = e7.toLowerCase();
            if (n6.replace(S2, function(t7, e8) {
              e8 && a4.push(+e8);
            }), "m" == o4 && a4.length > 2 && (i4.push([e7].concat(a4.splice(0, 2))), o4 = "l", e7 = "m" == e7 ? "l" : "L"), "o" == o4 && 1 == a4.length && i4.push([e7, a4[0]]), "r" == o4)
              i4.push([e7].concat(a4));
            else
              for (; a4.length >= r5[o4] && (i4.push([e7].concat(a4.splice(0, r5[o4]))), r5[o4]); )
                ;
          }), i4.toString = n5.path.toString, e6.arr = n5.path.clone(i4), i4;
        };
        var $ = n5.parseTransformString = function(t5) {
          if (!t5)
            return null;
          var e6 = [];
          return T2(t5, "array") && T2(t5[0], "array") && (e6 = n5.path.clone(t5)), e6.length || a3(t5).replace(w2, function(t6, n6, r5) {
            var i4 = [];
            n6.toLowerCase(), r5.replace(S2, function(t7, e7) {
              e7 && i4.push(+e7);
            }), e6.push([n6].concat(i4));
          }), e6.toString = n5.path.toString, e6;
        };
        function Y2(t5) {
          var e6 = [];
          return t5 = t5.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function(t6, n6, r5) {
            return r5 = r5.split(/\s*,\s*|\s+/), "rotate" == n6 && 1 == r5.length && r5.push(0, 0), "scale" == n6 && (r5.length > 2 ? r5 = r5.slice(0, 2) : 2 == r5.length && r5.push(0, 0), 1 == r5.length && r5.push(r5[0], 0, 0)), "skewX" == n6 ? e6.push(["m", 1, 0, l3.tan(O2(r5[0])), 1, 0, 0]) : "skewY" == n6 ? e6.push(["m", 1, l3.tan(O2(r5[0])), 0, 1, 0, 0]) : e6.push([n6.charAt(0)].concat(r5)), t6;
          }), e6;
        }
        function H2(t5, e6) {
          var r5 = $(t5), i4 = new n5.Matrix();
          if (r5)
            for (var o4 = 0, s4 = r5.length; o4 < s4; o4++) {
              var l4, c4, u4, d4, p4, h4 = r5[o4], f4 = h4.length, g2 = a3(h4[0]).toLowerCase(), m3 = h4[0] != g2, v6 = m3 ? i4.invert() : 0;
              "t" == g2 && 2 == f4 ? i4.translate(h4[1], 0) : "t" == g2 && 3 == f4 ? m3 ? (l4 = v6.x(0, 0), c4 = v6.y(0, 0), u4 = v6.x(h4[1], h4[2]), d4 = v6.y(h4[1], h4[2]), i4.translate(u4 - l4, d4 - c4)) : i4.translate(h4[1], h4[2]) : "r" == g2 ? 2 == f4 ? (p4 = p4 || e6, i4.rotate(h4[1], p4.x + p4.width / 2, p4.y + p4.height / 2)) : 4 == f4 && (m3 ? (u4 = v6.x(h4[2], h4[3]), d4 = v6.y(h4[2], h4[3]), i4.rotate(h4[1], u4, d4)) : i4.rotate(h4[1], h4[2], h4[3])) : "s" == g2 ? 2 == f4 || 3 == f4 ? (p4 = p4 || e6, i4.scale(h4[1], h4[f4 - 1], p4.x + p4.width / 2, p4.y + p4.height / 2)) : 4 == f4 ? m3 ? (u4 = v6.x(h4[2], h4[3]), d4 = v6.y(h4[2], h4[3]), i4.scale(h4[1], h4[1], u4, d4)) : i4.scale(h4[1], h4[1], h4[2], h4[3]) : 5 == f4 && (m3 ? (u4 = v6.x(h4[3], h4[4]), d4 = v6.y(h4[3], h4[4]), i4.scale(h4[1], h4[2], u4, d4)) : i4.scale(h4[1], h4[2], h4[3], h4[4])) : "m" == g2 && 7 == f4 && i4.add(h4[1], h4[2], h4[3], h4[4], h4[5], h4[6]);
            }
          return i4;
        }
        function W2(t5) {
          var e6 = t5.node.ownerSVGElement && nt(t5.node.ownerSVGElement) || t5.node.parentNode && nt(t5.node.parentNode) || n5.select("svg") || n5(0, 0), r5 = e6.select("defs"), i4 = null != r5 && r5.node;
          return i4 || (i4 = tt("defs", e6.node).node), i4;
        }
        function X2(t5) {
          return t5.node.ownerSVGElement && nt(t5.node.ownerSVGElement) || n5.select("svg");
        }
        function Z2(t5, e6, n6) {
          var r5 = X2(t5).node, i4 = {}, a4 = r5.querySelector(".svg---mgr");
          function o4(t6) {
            if (null == t6)
              return h3;
            if (t6 == +t6)
              return t6;
            D2(a4, { width: t6 });
            try {
              return a4.getBBox().width;
            } catch (t7) {
              return 0;
            }
          }
          function s4(t6) {
            if (null == t6)
              return h3;
            if (t6 == +t6)
              return t6;
            D2(a4, { height: t6 });
            try {
              return a4.getBBox().height;
            } catch (t7) {
              return 0;
            }
          }
          function l4(r6, a5) {
            null == e6 ? i4[r6] = a5(t5.attr(r6) || 0) : r6 == e6 && (i4 = a5(null == n6 ? t5.attr(r6) || 0 : n6));
          }
          switch (a4 || (a4 = D2("rect"), D2(a4, { x: -9e9, y: -9e9, width: 10, height: 10, class: "svg---mgr", fill: "none" }), r5.appendChild(a4)), t5.type) {
            case "rect":
              l4("rx", o4), l4("ry", s4);
            case "image":
              l4("width", o4), l4("height", s4);
            case "text":
              l4("x", o4), l4("y", s4);
              break;
            case "circle":
              l4("cx", o4), l4("cy", s4), l4("r", o4);
              break;
            case "ellipse":
              l4("cx", o4), l4("cy", s4), l4("rx", o4), l4("ry", s4);
              break;
            case "line":
              l4("x1", o4), l4("x2", o4), l4("y1", s4), l4("y2", s4);
              break;
            case "marker":
              l4("refX", o4), l4("markerWidth", o4), l4("refY", s4), l4("markerHeight", s4);
              break;
            case "radialGradient":
              l4("fx", o4), l4("fy", s4);
              break;
            case "tspan":
              l4("dx", o4), l4("dy", s4);
              break;
            default:
              l4(e6, o4);
          }
          return r5.removeChild(a4), i4;
        }
        function Q2(t5) {
          T2(t5, "array") || (t5 = Array.prototype.slice.call(arguments, 0));
          for (var e6 = 0, n6 = 0, r5 = this.node; this[e6]; )
            delete this[e6++];
          for (e6 = 0; e6 < t5.length; e6++)
            "set" == t5[e6].type ? t5[e6].forEach(function(t6) {
              r5.appendChild(t6.node);
            }) : r5.appendChild(t5[e6].node);
          var i4 = r5.childNodes;
          for (e6 = 0; e6 < i4.length; e6++)
            this[n6++] = nt(i4[e6]);
          return this;
        }
        function J2(t5) {
          if (t5.snap in _2)
            return _2[t5.snap];
          var e6;
          try {
            e6 = t5.ownerSVGElement;
          } catch (t6) {
          }
          this.node = t5, e6 && (this.paper = new et(e6)), this.type = t5.tagName || t5.nodeName;
          var n6 = this.id = E3(this);
          if (this.anims = {}, this._ = { transform: [] }, t5.snap = n6, _2[n6] = this, "g" == this.type && (this.add = Q2), this.type in { g: 1, mask: 1, pattern: 1, symbol: 1 })
            for (var r5 in et.prototype)
              et.prototype[i3](r5) && (this[r5] = et.prototype[r5]);
        }
        function K2(t5) {
          this.node = t5;
        }
        function tt(t5, e6) {
          var n6 = D2(t5);
          return e6.appendChild(n6), nt(n6);
        }
        function et(t5, e6) {
          var n6, a4, o4, s4 = et.prototype;
          if (t5 && t5.tagName && "svg" == t5.tagName.toLowerCase()) {
            if (t5.snap in _2)
              return _2[t5.snap];
            var l4 = t5.ownerDocument;
            for (var c4 in n6 = new J2(t5), a4 = t5.getElementsByTagName("desc")[0], o4 = t5.getElementsByTagName("defs")[0], a4 || ((a4 = D2("desc")).appendChild(l4.createTextNode("Created with Snap")), n6.node.appendChild(a4)), o4 || (o4 = D2("defs"), n6.node.appendChild(o4)), n6.defs = o4, s4)
              s4[i3](c4) && (n6[c4] = s4[c4]);
            n6.paper = n6.root = n6;
          } else
            D2((n6 = tt("svg", r4.doc.body)).node, { height: e6, version: 1.1, width: t5, xmlns: B2 });
          return n6;
        }
        function nt(t5) {
          return t5 ? t5 instanceof J2 || t5 instanceof K2 ? t5 : t5.tagName && "svg" == t5.tagName.toLowerCase() ? new et(t5) : t5.tagName && "object" == t5.tagName.toLowerCase() && "image/svg+xml" == t5.type ? new et(t5.contentDocument.getElementsByTagName("svg")[0]) : new J2(t5) : t5;
        }
        function rt(t5, e6) {
          for (var n6 = 0, r5 = t5.length; n6 < r5; n6++) {
            var i4 = { type: t5[n6].type, attr: t5[n6].attr() }, a4 = t5[n6].children();
            e6.push(i4), a4.length && rt(a4, i4.childNodes = []);
          }
        }
        n5._.svgTransform2string = Y2, n5._.rgTransform = /^[a-z][\s]*-?\.?\d/i, n5._.transform2matrix = H2, n5._unit2px = Z2, r4.doc.contains || r4.doc.compareDocumentPosition, n5._.getSomeDefs = W2, n5._.getSomeSVG = X2, n5.select = function(t5) {
          return t5 = a3(t5).replace(/([^\\]):/g, "$1\\:"), nt(r4.doc.querySelector(t5));
        }, n5.selectAll = function(t5) {
          for (var e6 = r4.doc.querySelectorAll(t5), i4 = (n5.set || Array)(), a4 = 0; a4 < e6.length; a4++)
            i4.push(nt(e6[a4]));
          return i4;
        }, setInterval(function() {
          for (var t5 in _2)
            if (_2[i3](t5)) {
              var e6 = _2[t5], n6 = e6.node;
              ("svg" != e6.type && !n6.ownerSVGElement || "svg" == e6.type && (!n6.parentNode || "ownerSVGElement" in n6.parentNode && !n6.ownerSVGElement)) && delete _2[t5];
            }
        }, 1e4), J2.prototype.attr = function(t5, n6) {
          var r5 = this, a4 = r5.node;
          if (!t5) {
            if (1 != a4.nodeType)
              return { text: a4.nodeValue };
            for (var o4 = a4.attributes, s4 = {}, l4 = 0, c4 = o4.length; l4 < c4; l4++)
              s4[o4[l4].nodeName] = o4[l4].nodeValue;
            return s4;
          }
          if (T2(t5, "string")) {
            if (!(arguments.length > 1))
              return e5("snap.util.getattr." + t5, r5).firstDefined();
            var u4 = {};
            u4[t5] = n6, t5 = u4;
          }
          for (var d4 in t5)
            t5[i3](d4) && e5("snap.util.attr." + d4, r5, t5[d4]);
          return r5;
        }, n5.parse = function(t5) {
          var e6 = r4.doc.createDocumentFragment(), n6 = true, i4 = r4.doc.createElement("div");
          if ((t5 = a3(t5)).match(/^\s*<\s*svg(?:\s|>)/) || (t5 = "<svg>" + t5 + "</svg>", n6 = false), i4.innerHTML = t5, t5 = i4.getElementsByTagName("svg")[0])
            if (n6)
              e6 = t5;
            else
              for (; t5.firstChild; )
                e6.appendChild(t5.firstChild);
          return new K2(e6);
        }, n5.fragment = function() {
          for (var t5 = Array.prototype.slice.call(arguments, 0), e6 = r4.doc.createDocumentFragment(), i4 = 0, a4 = t5.length; i4 < a4; i4++) {
            var o4 = t5[i4];
            o4.node && o4.node.nodeType && e6.appendChild(o4.node), o4.nodeType && e6.appendChild(o4), "string" == typeof o4 && e6.appendChild(n5.parse(o4).node);
          }
          return new K2(e6);
        }, n5._.make = tt, n5._.wrap = nt, et.prototype.el = function(t5, e6) {
          var n6 = tt(t5, this.node);
          return e6 && n6.attr(e6), n6;
        }, J2.prototype.children = function() {
          for (var t5 = [], e6 = this.node.childNodes, r5 = 0, i4 = e6.length; r5 < i4; r5++)
            t5[r5] = n5(e6[r5]);
          return t5;
        }, J2.prototype.toJSON = function() {
          var t5 = [];
          return rt([this], t5), t5[0];
        }, e5.on("snap.util.getattr", function() {
          var t5 = e5.nt(), n6 = (t5 = t5.substring(t5.lastIndexOf(".") + 1)).replace(/[A-Z]/g, function(t6) {
            return "-" + t6.toLowerCase();
          });
          return it[i3](n6) ? this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(n6) : D2(this.node, t5);
        });
        var it = { "alignment-baseline": 0, "baseline-shift": 0, clip: 0, "clip-path": 0, "clip-rule": 0, color: 0, "color-interpolation": 0, "color-interpolation-filters": 0, "color-profile": 0, "color-rendering": 0, cursor: 0, direction: 0, display: 0, "dominant-baseline": 0, "enable-background": 0, fill: 0, "fill-opacity": 0, "fill-rule": 0, filter: 0, "flood-color": 0, "flood-opacity": 0, font: 0, "font-family": 0, "font-size": 0, "font-size-adjust": 0, "font-stretch": 0, "font-style": 0, "font-variant": 0, "font-weight": 0, "glyph-orientation-horizontal": 0, "glyph-orientation-vertical": 0, "image-rendering": 0, kerning: 0, "letter-spacing": 0, "lighting-color": 0, marker: 0, "marker-end": 0, "marker-mid": 0, "marker-start": 0, mask: 0, opacity: 0, overflow: 0, "pointer-events": 0, "shape-rendering": 0, "stop-color": 0, "stop-opacity": 0, stroke: 0, "stroke-dasharray": 0, "stroke-dashoffset": 0, "stroke-linecap": 0, "stroke-linejoin": 0, "stroke-miterlimit": 0, "stroke-opacity": 0, "stroke-width": 0, "text-anchor": 0, "text-decoration": 0, "text-rendering": 0, "unicode-bidi": 0, visibility: 0, "word-spacing": 0, "writing-mode": 0 };
        e5.on("snap.util.attr", function(t5) {
          var n6 = e5.nt(), r5 = {};
          r5[n6 = n6.substring(n6.lastIndexOf(".") + 1)] = t5;
          var a4 = n6.replace(/-(\w)/gi, function(t6, e6) {
            return e6.toUpperCase();
          }), o4 = n6.replace(/[A-Z]/g, function(t6) {
            return "-" + t6.toLowerCase();
          });
          it[i3](o4) ? this.node.style[a4] = null == t5 ? h3 : t5 : D2(this.node, r5);
        }), n5.ajax = function(t5, n6, r5, i4) {
          var a4 = new XMLHttpRequest(), o4 = E3();
          if (a4) {
            if (T2(n6, "function"))
              i4 = r5, r5 = n6, n6 = null;
            else if (T2(n6, "object")) {
              var s4 = [];
              for (var l4 in n6)
                n6.hasOwnProperty(l4) && s4.push(encodeURIComponent(l4) + "=" + encodeURIComponent(n6[l4]));
              n6 = s4.join("&");
            }
            return a4.open(n6 ? "POST" : "GET", t5, true), n6 && (a4.setRequestHeader("X-Requested-With", "XMLHttpRequest"), a4.setRequestHeader("Content-type", "application/x-www-form-urlencoded")), r5 && (e5.once("snap.ajax." + o4 + ".0", r5), e5.once("snap.ajax." + o4 + ".200", r5), e5.once("snap.ajax." + o4 + ".304", r5)), a4.onreadystatechange = function() {
              4 == a4.readyState && e5("snap.ajax." + o4 + "." + a4.status, i4, a4);
            }, 4 == a4.readyState ? a4 : (a4.send(n6), a4);
          }
        }, n5.load = function(t5, e6, r5) {
          n5.ajax(t5, function(t6) {
            var i4 = n5.parse(t6.responseText);
            r5 ? e6.call(r5, i4) : e6(i4);
          });
        };
        var at2 = function(t5) {
          var e6 = t5.getBoundingClientRect(), n6 = t5.ownerDocument, r5 = n6.body, i4 = n6.documentElement, a4 = i4.clientTop || r5.clientTop || 0, o4 = i4.clientLeft || r5.clientLeft || 0;
          return { y: e6.top + (g.win.pageYOffset || i4.scrollTop || r5.scrollTop) - a4, x: e6.left + (g.win.pageXOffset || i4.scrollLeft || r5.scrollLeft) - o4 };
        };
        return n5.getElementByPoint = function(t5, e6) {
          this.canvas;
          var n6 = r4.doc.elementFromPoint(t5, e6);
          if (r4.win.opera && "svg" == n6.tagName) {
            var i4 = at2(n6), a4 = n6.createSVGRect();
            a4.x = t5 - i4.x, a4.y = e6 - i4.y, a4.width = a4.height = 1;
            var o4 = n6.getIntersectionList(a4, null);
            o4.length && (n6 = o4[o4.length - 1]);
          }
          return n6 ? nt(n6) : null;
        }, n5.plugin = function(t5) {
          t5(n5, J2, et, r4, K2);
        }, r4.win.Snap = n5, n5;
      }(t3 || this);
      return r3.plugin(function(n5, r4, i3, a3, o3) {
        var s3 = r4.prototype, l3 = n5.is, c3 = String, u3 = n5._unit2px, d3 = n5._.$, p3 = n5._.make, h3 = n5._.getSomeDefs, f3 = "hasOwnProperty", g2 = n5._.wrap;
        s3.getBBox = function(t4) {
          if ("tspan" == this.type)
            return n5._.box(this.node.getClientRects().item(0));
          if (!n5.Matrix || !n5.path)
            return this.node.getBBox();
          var e6 = this, r5 = new n5.Matrix();
          if (e6.removed)
            return n5._.box();
          for (; "use" == e6.type; )
            if (t4 || (r5 = r5.add(e6.transform().localMatrix.translate(e6.attr("x") || 0, e6.attr("y") || 0))), e6.original)
              e6 = e6.original;
            else {
              var i4 = e6.attr("xlink:href");
              e6 = e6.original = e6.node.ownerDocument.getElementById(i4.substring(i4.indexOf("#") + 1));
            }
          var a4 = e6._, o4 = n5.path.get[e6.type] || n5.path.get.deflt;
          try {
            return t4 ? (a4.bboxwt = o4 ? n5.path.getBBox(e6.realPath = o4(e6)) : n5._.box(e6.node.getBBox()), n5._.box(a4.bboxwt)) : (e6.realPath = o4(e6), e6.matrix = e6.transform().localMatrix, a4.bbox = n5.path.getBBox(n5.path.map(e6.realPath, r5.add(e6.matrix))), n5._.box(a4.bbox));
          } catch (t5) {
            return n5._.box();
          }
        };
        var m2 = function() {
          return this.string;
        };
        function v5(t4, e6) {
          if (null == e6) {
            var r5 = true;
            if (!(e6 = "linearGradient" == t4.type || "radialGradient" == t4.type ? t4.node.getAttribute("gradientTransform") : "pattern" == t4.type ? t4.node.getAttribute("patternTransform") : t4.node.getAttribute("transform")))
              return new n5.Matrix();
            e6 = n5._.svgTransform2string(e6);
          } else
            e6 = n5._.rgTransform.test(e6) ? c3(e6).replace(/\.{3}|\u2026/g, t4._.transform || "") : n5._.svgTransform2string(e6), l3(e6, "array") && (e6 = n5.path ? n5.path.toString.call(e6) : c3(e6)), t4._.transform = e6;
          var i4 = n5._.transform2matrix(e6, t4.getBBox(1));
          if (r5)
            return i4;
          t4.matrix = i4;
        }
        function y2(t4) {
          var e6, r5 = t4.selectAll("*"), i4 = /^\s*url\(("|'|)(.*)\1\)\s*$/, a4 = [], o4 = {};
          function s4(t5, e7) {
            var r6 = d3(t5.node, e7);
            (r6 = (r6 = r6 && r6.match(i4)) && r6[2]) && "#" == r6.charAt() && (r6 = r6.substring(1)) && (o4[r6] = (o4[r6] || []).concat(function(r7) {
              var i5 = {};
              i5[e7] = n5.url(r7), d3(t5.node, i5);
            }));
          }
          function l4(t5) {
            var e7 = d3(t5.node, "xlink:href");
            e7 && "#" == e7.charAt() && (e7 = e7.substring(1)) && (o4[e7] = (o4[e7] || []).concat(function(e8) {
              t5.attr("xlink:href", "#" + e8);
            }));
          }
          for (var c4 = 0, u4 = r5.length; c4 < u4; c4++) {
            s4(e6 = r5[c4], "fill"), s4(e6, "stroke"), s4(e6, "filter"), s4(e6, "mask"), s4(e6, "clip-path"), l4(e6);
            var p4 = d3(e6.node, "id");
            p4 && (d3(e6.node, { id: e6.id }), a4.push({ old: p4, id: e6.id }));
          }
          for (c4 = 0, u4 = a4.length; c4 < u4; c4++) {
            var h4 = o4[a4[c4].old];
            if (h4)
              for (var f4 = 0, g3 = h4.length; f4 < g3; f4++)
                h4[f4](a4[c4].id);
          }
        }
        s3.transform = function(t4) {
          var e6 = this._;
          if (null == t4) {
            for (var r5, i4 = this, a4 = new n5.Matrix(this.node.getCTM()), o4 = v5(this), s4 = [o4], l4 = new n5.Matrix(), u4 = o4.toTransformString(), p4 = c3(o4) == c3(this.matrix) ? c3(e6.transform) : u4; "svg" != i4.type && (i4 = i4.parent()); )
              s4.push(v5(i4));
            for (r5 = s4.length; r5--; )
              l4.add(s4[r5]);
            return { string: p4, globalMatrix: a4, totalMatrix: l4, localMatrix: o4, diffMatrix: a4.clone().add(o4.invert()), global: a4.toTransformString(), total: l4.toTransformString(), local: u4, toString: m2 };
          }
          return t4 instanceof n5.Matrix ? (this.matrix = t4, this._.transform = t4.toTransformString()) : v5(this, t4), this.node && ("linearGradient" == this.type || "radialGradient" == this.type ? d3(this.node, { gradientTransform: this.matrix }) : "pattern" == this.type ? d3(this.node, { patternTransform: this.matrix }) : d3(this.node, { transform: this.matrix })), this;
        }, s3.parent = function() {
          return g2(this.node.parentNode);
        }, s3.append = s3.add = function(t4) {
          if (t4) {
            if ("set" == t4.type) {
              var e6 = this;
              return t4.forEach(function(t5) {
                e6.add(t5);
              }), this;
            }
            t4 = g2(t4), this.node.appendChild(t4.node), t4.paper = this.paper;
          }
          return this;
        }, s3.appendTo = function(t4) {
          return t4 && (t4 = g2(t4)).append(this), this;
        }, s3.prepend = function(t4) {
          if (t4) {
            if ("set" == t4.type) {
              var e6, n6 = this;
              return t4.forEach(function(t5) {
                e6 ? e6.after(t5) : n6.prepend(t5), e6 = t5;
              }), this;
            }
            var r5 = (t4 = g2(t4)).parent();
            this.node.insertBefore(t4.node, this.node.firstChild), this.add && this.add(), t4.paper = this.paper, this.parent() && this.parent().add(), r5 && r5.add();
          }
          return this;
        }, s3.prependTo = function(t4) {
          return (t4 = g2(t4)).prepend(this), this;
        }, s3.before = function(t4) {
          if ("set" == t4.type) {
            var e6 = this;
            return t4.forEach(function(t5) {
              var n7 = t5.parent();
              e6.node.parentNode.insertBefore(t5.node, e6.node), n7 && n7.add();
            }), this.parent().add(), this;
          }
          var n6 = (t4 = g2(t4)).parent();
          return this.node.parentNode.insertBefore(t4.node, this.node), this.parent() && this.parent().add(), n6 && n6.add(), t4.paper = this.paper, this;
        }, s3.after = function(t4) {
          var e6 = (t4 = g2(t4)).parent();
          return this.node.nextSibling ? this.node.parentNode.insertBefore(t4.node, this.node.nextSibling) : this.node.parentNode.appendChild(t4.node), this.parent() && this.parent().add(), e6 && e6.add(), t4.paper = this.paper, this;
        }, s3.insertBefore = function(t4) {
          t4 = g2(t4);
          var e6 = this.parent();
          return t4.node.parentNode.insertBefore(this.node, t4.node), this.paper = t4.paper, e6 && e6.add(), t4.parent() && t4.parent().add(), this;
        }, s3.insertAfter = function(t4) {
          t4 = g2(t4);
          var e6 = this.parent();
          return t4.node.parentNode.insertBefore(this.node, t4.node.nextSibling), this.paper = t4.paper, e6 && e6.add(), t4.parent() && t4.parent().add(), this;
        }, s3.remove = function() {
          var t4 = this.parent();
          return this.node.parentNode && this.node.parentNode.removeChild(this.node), delete this.paper, this.removed = true, t4 && t4.add(), this;
        }, s3.select = function(t4) {
          return g2(this.node.querySelector(t4));
        }, s3.selectAll = function(t4) {
          for (var e6 = this.node.querySelectorAll(t4), r5 = (n5.set || Array)(), i4 = 0; i4 < e6.length; i4++)
            r5.push(g2(e6[i4]));
          return r5;
        }, s3.asPX = function(t4, e6) {
          return null == e6 && (e6 = this.attr(t4)), +u3(this, t4, e6);
        }, s3.use = function() {
          var t4, e6 = this.node.id;
          return e6 || (e6 = this.id, d3(this.node, { id: e6 })), t4 = "linearGradient" == this.type || "radialGradient" == this.type || "pattern" == this.type ? p3(this.type, this.node.parentNode) : p3("use", this.node.parentNode), d3(t4.node, { "xlink:href": "#" + e6 }), t4.original = this, t4;
        }, s3.clone = function() {
          var t4 = g2(this.node.cloneNode(true));
          return d3(t4.node, "id") && d3(t4.node, { id: t4.id }), y2(t4), t4.insertAfter(this), t4;
        }, s3.toDefs = function() {
          return h3(this).appendChild(this.node), this;
        }, s3.pattern = s3.toPattern = function(t4, e6, n6, r5) {
          var i4 = p3("pattern", h3(this));
          return null == t4 && (t4 = this.getBBox()), l3(t4, "object") && "x" in t4 && (e6 = t4.y, n6 = t4.width, r5 = t4.height, t4 = t4.x), d3(i4.node, { x: t4, y: e6, width: n6, height: r5, patternUnits: "userSpaceOnUse", id: i4.id, viewBox: [t4, e6, n6, r5].join(" ") }), i4.node.appendChild(this.node), i4;
        }, s3.marker = function(t4, e6, n6, r5, i4, a4) {
          var o4 = p3("marker", h3(this));
          return null == t4 && (t4 = this.getBBox()), l3(t4, "object") && "x" in t4 && (e6 = t4.y, n6 = t4.width, r5 = t4.height, i4 = t4.refX || t4.cx, a4 = t4.refY || t4.cy, t4 = t4.x), d3(o4.node, { viewBox: [t4, e6, n6, r5].join(" "), markerWidth: n6, markerHeight: r5, orient: "auto", refX: i4 || 0, refY: a4 || 0, id: o4.id }), o4.node.appendChild(this.node), o4;
        };
        var b2 = {};
        function x2(t4) {
          return function() {
            var e6 = t4 ? "<" + this.type : "", n6 = this.node.attributes, r5 = this.node.childNodes;
            if (t4)
              for (var i4 = 0, a4 = n6.length; i4 < a4; i4++)
                e6 += " " + n6[i4].name + '="' + n6[i4].value.replace(/"/g, '\\"') + '"';
            if (r5.length) {
              for (t4 && (e6 += ">"), i4 = 0, a4 = r5.length; i4 < a4; i4++)
                3 == r5[i4].nodeType ? e6 += r5[i4].nodeValue : 1 == r5[i4].nodeType && (e6 += g2(r5[i4]).toString());
              t4 && (e6 += "</" + this.type + ">");
            } else
              t4 && (e6 += "/>");
            return e6;
          };
        }
        s3.data = function(t4, r5) {
          var i4 = b2[this.id] = b2[this.id] || {};
          if (0 == arguments.length)
            return e5("snap.data.get." + this.id, this, i4, null), i4;
          if (1 == arguments.length) {
            if (n5.is(t4, "object")) {
              for (var a4 in t4)
                t4[f3](a4) && this.data(a4, t4[a4]);
              return this;
            }
            return e5("snap.data.get." + this.id, this, i4[t4], t4), i4[t4];
          }
          return i4[t4] = r5, e5("snap.data.set." + this.id, this, r5, t4), this;
        }, s3.removeData = function(t4) {
          return null == t4 ? b2[this.id] = {} : b2[this.id] && delete b2[this.id][t4], this;
        }, s3.outerSVG = s3.toString = x2(1), s3.innerSVG = x2(), s3.toDataURL = function() {
          if (t3 && t3.btoa) {
            var e6 = this.getBBox(), r5 = n5.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', { x: +e6.x.toFixed(3), y: +e6.y.toFixed(3), width: +e6.width.toFixed(3), height: +e6.height.toFixed(3), contents: this.outerSVG() });
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(r5)));
          }
        }, o3.prototype.select = s3.select, o3.prototype.selectAll = s3.selectAll;
      }), r3.plugin(function(t4, r4, i3, a3, o3) {
        var s3 = r4.prototype, l3 = t4.is, c3 = String, u3 = "hasOwnProperty";
        function d3(t5, e6, n5) {
          return function(r5) {
            var i4 = r5.slice(t5, e6);
            return 1 == i4.length && (i4 = i4[0]), n5 ? n5(i4) : i4;
          };
        }
        var p3 = function(t5, e6, r5, i4) {
          "function" != typeof r5 || r5.length || (i4 = r5, r5 = n4.linear), this.attr = t5, this.dur = e6, r5 && (this.easing = r5), i4 && (this.callback = i4);
        };
        t4._.Animation = p3, t4.animation = function(t5, e6, n5, r5) {
          return new p3(t5, e6, n5, r5);
        }, s3.inAnim = function() {
          var t5 = this, e6 = [];
          for (var n5 in t5.anims)
            t5.anims[u3](n5) && function(t6) {
              e6.push({ anim: new p3(t6._attrs, t6.dur, t6.easing, t6._callback), mina: t6, curStatus: t6.status(), status: function(e7) {
                return t6.status(e7);
              }, stop: function() {
                t6.stop();
              } });
            }(t5.anims[n5]);
          return e6;
        }, t4.animate = function(t5, r5, i4, a4, o4, s4) {
          "function" != typeof o4 || o4.length || (s4 = o4, o4 = n4.linear);
          var l4 = n4.time(), c4 = n4(t5, r5, l4, l4 + a4, n4.time, i4, o4);
          return s4 && e5.once("mina.finish." + c4.id, s4), c4;
        }, s3.stop = function() {
          for (var t5 = this.inAnim(), e6 = 0, n5 = t5.length; e6 < n5; e6++)
            t5[e6].stop();
          return this;
        }, s3.animate = function(t5, r5, i4, a4) {
          "function" != typeof i4 || i4.length || (a4 = i4, i4 = n4.linear), t5 instanceof p3 && (a4 = t5.callback, i4 = t5.easing, r5 = t5.dur, t5 = t5.attr);
          var o4, s4, h3, f3, g2 = [], m2 = [], v5 = {}, y2 = this;
          for (var b2 in t5)
            if (t5[u3](b2)) {
              y2.equal ? (o4 = (f3 = y2.equal(b2, c3(t5[b2]))).from, s4 = f3.to, h3 = f3.f) : (o4 = +y2.attr(b2), s4 = +t5[b2]);
              var x2 = l3(o4, "array") ? o4.length : 1;
              v5[b2] = d3(g2.length, g2.length + x2, h3), g2 = g2.concat(o4), m2 = m2.concat(s4);
            }
          var F2 = n4.time(), k2 = n4(g2, m2, F2, F2 + r5, n4.time, function(t6) {
            var e6 = {};
            for (var n5 in v5)
              v5[u3](n5) && (e6[n5] = v5[n5](t6));
            y2.attr(e6);
          }, i4);
          return y2.anims[k2.id] = k2, k2._attrs = t5, k2._callback = a4, e5("snap.animcreated." + y2.id, k2), e5.once("mina.finish." + k2.id, function() {
            e5.off("mina.*." + k2.id), delete y2.anims[k2.id], a4 && a4.call(y2);
          }), e5.once("mina.stop." + k2.id, function() {
            e5.off("mina.*." + k2.id), delete y2.anims[k2.id];
          }), y2;
        };
      }), r3.plugin(function(t4, e6, n5, r4, i3) {
        var a3 = Object.prototype.toString, o3 = String, s3 = Math, l3 = "";
        function c3(t5, e7, n6, r5, i4, o4) {
          if (null == e7 && "[object SVGMatrix]" == a3.call(t5))
            return this.a = t5.a, this.b = t5.b, this.c = t5.c, this.d = t5.d, this.e = t5.e, void (this.f = t5.f);
          null != t5 ? (this.a = +t5, this.b = +e7, this.c = +n6, this.d = +r5, this.e = +i4, this.f = +o4) : (this.a = 1, this.b = 0, this.c = 0, this.d = 1, this.e = 0, this.f = 0);
        }
        !function(e7) {
          function n6(t5) {
            return t5[0] * t5[0] + t5[1] * t5[1];
          }
          function r5(t5) {
            var e8 = s3.sqrt(n6(t5));
            t5[0] && (t5[0] /= e8), t5[1] && (t5[1] /= e8);
          }
          e7.add = function(t5, e8, n7, r6, i4, a4) {
            if (t5 && t5 instanceof c3)
              return this.add(t5.a, t5.b, t5.c, t5.d, t5.e, t5.f);
            var o4 = t5 * this.a + e8 * this.c, s4 = t5 * this.b + e8 * this.d;
            return this.e += i4 * this.a + a4 * this.c, this.f += i4 * this.b + a4 * this.d, this.c = n7 * this.a + r6 * this.c, this.d = n7 * this.b + r6 * this.d, this.a = o4, this.b = s4, this;
          }, c3.prototype.multLeft = function(t5, e8, n7, r6, i4, a4) {
            if (t5 && t5 instanceof c3)
              return this.multLeft(t5.a, t5.b, t5.c, t5.d, t5.e, t5.f);
            var o4 = t5 * this.a + n7 * this.b, s4 = t5 * this.c + n7 * this.d, l4 = t5 * this.e + n7 * this.f + i4;
            return this.b = e8 * this.a + r6 * this.b, this.d = e8 * this.c + r6 * this.d, this.f = e8 * this.e + r6 * this.f + a4, this.a = o4, this.c = s4, this.e = l4, this;
          }, e7.invert = function() {
            var t5 = this, e8 = t5.a * t5.d - t5.b * t5.c;
            return new c3(t5.d / e8, -t5.b / e8, -t5.c / e8, t5.a / e8, (t5.c * t5.f - t5.d * t5.e) / e8, (t5.b * t5.e - t5.a * t5.f) / e8);
          }, e7.clone = function() {
            return new c3(this.a, this.b, this.c, this.d, this.e, this.f);
          }, e7.translate = function(t5, e8) {
            return this.e += t5 * this.a + e8 * this.c, this.f += t5 * this.b + e8 * this.d, this;
          }, e7.scale = function(t5, e8, n7, r6) {
            return null == e8 && (e8 = t5), (n7 || r6) && this.translate(n7, r6), this.a *= t5, this.b *= t5, this.c *= e8, this.d *= e8, (n7 || r6) && this.translate(-n7, -r6), this;
          }, e7.rotate = function(e8, n7, r6) {
            e8 = t4.rad(e8), n7 = n7 || 0, r6 = r6 || 0;
            var i4 = +s3.cos(e8).toFixed(9), a4 = +s3.sin(e8).toFixed(9);
            return this.add(i4, a4, -a4, i4, n7, r6), this.add(1, 0, 0, 1, -n7, -r6);
          }, e7.skewX = function(t5) {
            return this.skew(t5, 0);
          }, e7.skewY = function(t5) {
            return this.skew(0, t5);
          }, e7.skew = function(e8, n7) {
            e8 = e8 || 0, n7 = n7 || 0, e8 = t4.rad(e8), n7 = t4.rad(n7);
            var r6 = s3.tan(e8).toFixed(9), i4 = s3.tan(n7).toFixed(9);
            return this.add(1, i4, r6, 1, 0, 0);
          }, e7.x = function(t5, e8) {
            return t5 * this.a + e8 * this.c + this.e;
          }, e7.y = function(t5, e8) {
            return t5 * this.b + e8 * this.d + this.f;
          }, e7.get = function(t5) {
            return +this[o3.fromCharCode(97 + t5)].toFixed(4);
          }, e7.toString = function() {
            return "matrix(" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)].join() + ")";
          }, e7.offset = function() {
            return [this.e.toFixed(4), this.f.toFixed(4)];
          }, e7.determinant = function() {
            return this.a * this.d - this.b * this.c;
          }, e7.split = function() {
            var e8 = {};
            e8.dx = this.e, e8.dy = this.f;
            var i4 = [[this.a, this.b], [this.c, this.d]];
            e8.scalex = s3.sqrt(n6(i4[0])), r5(i4[0]), e8.shear = i4[0][0] * i4[1][0] + i4[0][1] * i4[1][1], i4[1] = [i4[1][0] - i4[0][0] * e8.shear, i4[1][1] - i4[0][1] * e8.shear], e8.scaley = s3.sqrt(n6(i4[1])), r5(i4[1]), e8.shear /= e8.scaley, this.determinant() < 0 && (e8.scalex = -e8.scalex);
            var a4 = i4[0][1], o4 = i4[1][1];
            return o4 < 0 ? (e8.rotate = t4.deg(s3.acos(o4)), a4 < 0 && (e8.rotate = 360 - e8.rotate)) : e8.rotate = t4.deg(s3.asin(a4)), e8.isSimple = !(+e8.shear.toFixed(9) || e8.scalex.toFixed(9) != e8.scaley.toFixed(9) && e8.rotate), e8.isSuperSimple = !+e8.shear.toFixed(9) && e8.scalex.toFixed(9) == e8.scaley.toFixed(9) && !e8.rotate, e8.noRotation = !+e8.shear.toFixed(9) && !e8.rotate, e8;
          }, e7.toTransformString = function(t5) {
            var e8 = t5 || this.split();
            return +e8.shear.toFixed(9) ? "m" + [this.get(0), this.get(1), this.get(2), this.get(3), this.get(4), this.get(5)] : (e8.scalex = +e8.scalex.toFixed(4), e8.scaley = +e8.scaley.toFixed(4), e8.rotate = +e8.rotate.toFixed(4), (e8.dx || e8.dy ? "t" + [+e8.dx.toFixed(4), +e8.dy.toFixed(4)] : l3) + (e8.rotate ? "r" + [+e8.rotate.toFixed(4), 0, 0] : l3) + (1 != e8.scalex || 1 != e8.scaley ? "s" + [e8.scalex, e8.scaley, 0, 0] : l3));
          };
        }(c3.prototype), t4.Matrix = c3, t4.matrix = function(t5, e7, n6, r5, i4, a4) {
          return new c3(t5, e7, n6, r5, i4, a4);
        };
      }), r3.plugin(function(t4, n5, r4, i3, a3) {
        var o3, s3 = t4._.make, l3 = t4._.wrap, c3 = t4.is, u3 = t4._.getSomeDefs, d3 = /^url\((['"]?)([^)]+)\1\)$/, p3 = t4._.$, h3 = t4.url, f3 = String, g2 = t4._.separator, m2 = "";
        function v5(r5) {
          return function(i4) {
            if (e5.stop(), i4 instanceof a3 && 1 == i4.node.childNodes.length && ("radialGradient" == i4.node.firstChild.tagName || "linearGradient" == i4.node.firstChild.tagName || "pattern" == i4.node.firstChild.tagName) && (i4 = i4.node.firstChild, u3(this).appendChild(i4), i4 = l3(i4)), i4 instanceof n5)
              if ("radialGradient" == i4.type || "linearGradient" == i4.type || "pattern" == i4.type) {
                i4.node.id || p3(i4.node, { id: i4.id });
                var o4 = h3(i4.node.id);
              } else
                o4 = i4.attr(r5);
            else if ((o4 = t4.color(i4)).error) {
              var s4 = t4(u3(this).ownerSVGElement).gradient(i4);
              s4 ? (s4.node.id || p3(s4.node, { id: s4.id }), o4 = h3(s4.node.id)) : o4 = i4;
            } else
              o4 = f3(o4);
            var c4 = {};
            c4[r5] = o4, p3(this.node, c4), this.node.style[r5] = m2;
          };
        }
        t4.deurl = function(t5) {
          var e6 = String(t5).match(d3);
          return e6 ? e6[2] : t5;
        }, e5.on("snap.util.attr.mask", function(t5) {
          if (t5 instanceof n5 || t5 instanceof a3) {
            if (e5.stop(), t5 instanceof a3 && 1 == t5.node.childNodes.length && (t5 = t5.node.firstChild, u3(this).appendChild(t5), t5 = l3(t5)), "mask" == t5.type)
              var r5 = t5;
            else
              (r5 = s3("mask", u3(this))).node.appendChild(t5.node);
            !r5.node.id && p3(r5.node, { id: r5.id }), p3(this.node, { mask: h3(r5.id) });
          }
        }), o3 = function(t5) {
          if (t5 instanceof n5 || t5 instanceof a3) {
            e5.stop();
            for (var r5, i4 = t5.node; i4; ) {
              if ("clipPath" === i4.nodeName) {
                r5 = new n5(i4);
                break;
              }
              if ("svg" === i4.nodeName) {
                r5 = void 0;
                break;
              }
              i4 = i4.parentNode;
            }
            r5 || ((r5 = s3("clipPath", u3(this))).node.appendChild(t5.node), !r5.node.id && p3(r5.node, { id: r5.id })), p3(this.node, { "clip-path": h3(r5.node.id || r5.id) });
          }
        }, e5.on("snap.util.attr.clip", o3), e5.on("snap.util.attr.clip-path", o3), e5.on("snap.util.attr.clipPath", o3), e5.on("snap.util.attr.fill", v5("fill")), e5.on("snap.util.attr.stroke", v5("stroke"));
        var y2 = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
        function b2(t5) {
          e5.stop(), t5 == +t5 && (t5 += "px"), this.node.style.fontSize = t5;
        }
        function x2(t5) {
          for (var e6 = [], n6 = t5.childNodes, r5 = 0, i4 = n6.length; r5 < i4; r5++) {
            var a4 = n6[r5];
            3 == a4.nodeType && e6.push(a4.nodeValue), "tspan" == a4.tagName && (1 == a4.childNodes.length && 3 == a4.firstChild.nodeType ? e6.push(a4.firstChild.nodeValue) : e6.push(x2(a4)));
          }
          return e6;
        }
        function F2() {
          return e5.stop(), this.node.style.fontSize;
        }
        e5.on("snap.util.grad.parse", function(t5) {
          var e6 = (t5 = f3(t5)).match(y2);
          if (!e6)
            return null;
          var n6 = e6[1], r5 = e6[2], i4 = e6[3];
          1 == (r5 = r5.split(/\s*,\s*/).map(function(t6) {
            return +t6 == t6 ? +t6 : t6;
          })).length && 0 == r5[0] && (r5 = []);
          var a4 = (i4 = (i4 = i4.split("-")).map(function(t6) {
            var e7 = { color: (t6 = t6.split(":"))[0] };
            return t6[1] && (e7.offset = parseFloat(t6[1])), e7;
          })).length, o4 = 0, s4 = 0;
          function l4(t6, e7) {
            for (var n7 = (e7 - o4) / (t6 - s4), r6 = s4; r6 < t6; r6++)
              i4[r6].offset = +(+o4 + n7 * (r6 - s4)).toFixed(2);
            s4 = t6, o4 = e7;
          }
          a4--;
          for (var c4 = 0; c4 < a4; c4++)
            "offset" in i4[c4] && l4(c4, i4[c4].offset);
          return i4[a4].offset = i4[a4].offset || 100, l4(a4, i4[a4].offset), { type: n6, params: r5, stops: i4 };
        }), e5.on("snap.util.attr.d", function(n6) {
          e5.stop(), c3(n6, "array") && c3(n6[0], "array") && (n6 = t4.path.toString.call(n6)), (n6 = f3(n6)).match(/[ruo]/i) && (n6 = t4.path.toAbsolute(n6)), p3(this.node, { d: n6 });
        })(-1), e5.on("snap.util.attr.#text", function(t5) {
          e5.stop(), t5 = f3(t5);
          for (var n6 = i3.doc.createTextNode(t5); this.node.firstChild; )
            this.node.removeChild(this.node.firstChild);
          this.node.appendChild(n6);
        })(-1), e5.on("snap.util.attr.path", function(t5) {
          e5.stop(), this.attr({ d: t5 });
        })(-1), e5.on("snap.util.attr.class", function(t5) {
          e5.stop(), this.node.className.baseVal = t5;
        })(-1), e5.on("snap.util.attr.viewBox", function(t5) {
          var n6;
          n6 = c3(t5, "object") && "x" in t5 ? [t5.x, t5.y, t5.width, t5.height].join(" ") : c3(t5, "array") ? t5.join(" ") : t5, p3(this.node, { viewBox: n6 }), e5.stop();
        })(-1), e5.on("snap.util.attr.transform", function(t5) {
          this.transform(t5), e5.stop();
        })(-1), e5.on("snap.util.attr.r", function(t5) {
          "rect" == this.type && (e5.stop(), p3(this.node, { rx: t5, ry: t5 }));
        })(-1), e5.on("snap.util.attr.textpath", function(t5) {
          if (e5.stop(), "text" == this.type) {
            var r5, i4, a4;
            if (!t5 && this.textPath) {
              for (i4 = this.textPath; i4.node.firstChild; )
                this.node.appendChild(i4.node.firstChild);
              return i4.remove(), void delete this.textPath;
            }
            if (c3(t5, "string")) {
              var o4 = u3(this), s4 = l3(o4.parentNode).path(t5);
              o4.appendChild(s4.node), r5 = s4.id, s4.attr({ id: r5 });
            } else
              (t5 = l3(t5)) instanceof n5 && ((r5 = t5.attr("id")) || (r5 = t5.id, t5.attr({ id: r5 })));
            if (r5)
              if (i4 = this.textPath, a4 = this.node, i4)
                i4.attr({ "xlink:href": "#" + r5 });
              else {
                for (i4 = p3("textPath", { "xlink:href": "#" + r5 }); a4.firstChild; )
                  i4.appendChild(a4.firstChild);
                a4.appendChild(i4), this.textPath = l3(i4);
              }
          }
        })(-1), e5.on("snap.util.attr.text", function(t5) {
          if ("text" == this.type) {
            for (var n6 = this.node, r5 = function(t6) {
              var e6 = p3("tspan");
              if (c3(t6, "array"))
                for (var n7 = 0; n7 < t6.length; n7++)
                  e6.appendChild(r5(t6[n7]));
              else
                e6.appendChild(i3.doc.createTextNode(t6));
              return e6.normalize && e6.normalize(), e6;
            }; n6.firstChild; )
              n6.removeChild(n6.firstChild);
            for (var a4 = r5(t5); a4.firstChild; )
              n6.appendChild(a4.firstChild);
          }
          e5.stop();
        })(-1), e5.on("snap.util.attr.fontSize", b2)(-1), e5.on("snap.util.attr.font-size", b2)(-1), e5.on("snap.util.getattr.transform", function() {
          return e5.stop(), this.transform();
        })(-1), e5.on("snap.util.getattr.textpath", function() {
          return e5.stop(), this.textPath;
        })(-1), function() {
          function n6(n7) {
            return function() {
              e5.stop();
              var r6 = i3.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + n7);
              return "none" == r6 ? r6 : t4(i3.doc.getElementById(r6.match(d3)[1]));
            };
          }
          function r5(t5) {
            return function(n7) {
              e5.stop();
              var r6 = "marker" + t5.charAt(0).toUpperCase() + t5.substring(1);
              if ("" != n7 && n7) {
                if ("marker" == n7.type) {
                  var i4 = n7.node.id;
                  return i4 || p3(n7.node, { id: n7.id }), void (this.node.style[r6] = h3(i4));
                }
              } else
                this.node.style[r6] = "none";
            };
          }
          e5.on("snap.util.getattr.marker-end", n6("end"))(-1), e5.on("snap.util.getattr.markerEnd", n6("end"))(-1), e5.on("snap.util.getattr.marker-start", n6("start"))(-1), e5.on("snap.util.getattr.markerStart", n6("start"))(-1), e5.on("snap.util.getattr.marker-mid", n6("mid"))(-1), e5.on("snap.util.getattr.markerMid", n6("mid"))(-1), e5.on("snap.util.attr.marker-end", r5("end"))(-1), e5.on("snap.util.attr.markerEnd", r5("end"))(-1), e5.on("snap.util.attr.marker-start", r5("start"))(-1), e5.on("snap.util.attr.markerStart", r5("start"))(-1), e5.on("snap.util.attr.marker-mid", r5("mid"))(-1), e5.on("snap.util.attr.markerMid", r5("mid"))(-1);
        }(), e5.on("snap.util.getattr.r", function() {
          if ("rect" == this.type && p3(this.node, "rx") == p3(this.node, "ry"))
            return e5.stop(), p3(this.node, "rx");
        })(-1), e5.on("snap.util.getattr.text", function() {
          if ("text" == this.type || "tspan" == this.type) {
            e5.stop();
            var t5 = x2(this.node);
            return 1 == t5.length ? t5[0] : t5;
          }
        })(-1), e5.on("snap.util.getattr.#text", function() {
          return this.node.textContent;
        })(-1), e5.on("snap.util.getattr.fill", function(n6) {
          if (!n6) {
            e5.stop();
            var r5 = e5("snap.util.getattr.fill", this, true).firstDefined();
            return t4(t4.deurl(r5)) || r5;
          }
        })(-1), e5.on("snap.util.getattr.stroke", function(n6) {
          if (!n6) {
            e5.stop();
            var r5 = e5("snap.util.getattr.stroke", this, true).firstDefined();
            return t4(t4.deurl(r5)) || r5;
          }
        })(-1), e5.on("snap.util.getattr.viewBox", function() {
          e5.stop();
          var n6 = p3(this.node, "viewBox");
          return n6 ? (n6 = n6.split(g2), t4._.box(+n6[0], +n6[1], +n6[2], +n6[3])) : void 0;
        })(-1), e5.on("snap.util.getattr.points", function() {
          var t5 = p3(this.node, "points");
          return e5.stop(), t5 ? t5.split(g2) : void 0;
        })(-1), e5.on("snap.util.getattr.path", function() {
          var t5 = p3(this.node, "d");
          return e5.stop(), t5;
        })(-1), e5.on("snap.util.getattr.class", function() {
          return this.node.className.baseVal;
        })(-1), e5.on("snap.util.getattr.fontSize", F2)(-1), e5.on("snap.util.getattr.font-size", F2)(-1);
      }), r3.plugin(function(t4, e6, n5, r4, i3) {
        var a3 = /\S+/g, o3 = String, s3 = e6.prototype;
        s3.addClass = function(t5) {
          var e7, n6, r5, i4 = o3(t5 || "").match(a3) || [], s4 = this.node, l3 = s4.className.baseVal, c3 = l3.match(a3) || [];
          if (i4.length) {
            for (e7 = 0; n6 = i4[e7++]; )
              ~c3.indexOf(n6) || c3.push(n6);
            l3 != (r5 = c3.join(" ")) && (s4.className.baseVal = r5);
          }
          return this;
        }, s3.removeClass = function(t5) {
          var e7, n6, r5, i4, s4 = o3(t5 || "").match(a3) || [], l3 = this.node, c3 = l3.className.baseVal, u3 = c3.match(a3) || [];
          if (u3.length) {
            for (e7 = 0; r5 = s4[e7++]; )
              ~(n6 = u3.indexOf(r5)) && u3.splice(n6, 1);
            c3 != (i4 = u3.join(" ")) && (l3.className.baseVal = i4);
          }
          return this;
        }, s3.hasClass = function(t5) {
          return !!~(this.node.className.baseVal.match(a3) || []).indexOf(t5);
        }, s3.toggleClass = function(t5, e7) {
          if (null != e7)
            return e7 ? this.addClass(t5) : this.removeClass(t5);
          var n6, r5, i4, o4, s4 = (t5 || "").match(a3) || [], l3 = this.node, c3 = l3.className.baseVal, u3 = c3.match(a3) || [];
          for (n6 = 0; i4 = s4[n6++]; )
            ~(r5 = u3.indexOf(i4)) ? u3.splice(r5, 1) : u3.push(i4);
          return c3 != (o4 = u3.join(" ")) && (l3.className.baseVal = o4), this;
        };
      }), r3.plugin(function(t4, n5, r4, i3, a3) {
        var o3 = { "+": function(t5, e6) {
          return t5 + e6;
        }, "-": function(t5, e6) {
          return t5 - e6;
        }, "/": function(t5, e6) {
          return t5 / e6;
        }, "*": function(t5, e6) {
          return t5 * e6;
        } }, s3 = String, l3 = /[a-z]+$/i, c3 = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
        function u3(t5) {
          return t5;
        }
        function d3(t5) {
          return function(e6) {
            return +e6.toFixed(3) + t5;
          };
        }
        e5.on("snap.util.attr", function(t5) {
          var n6 = s3(t5).match(c3);
          if (n6) {
            var r5 = e5.nt(), i4 = r5.substring(r5.lastIndexOf(".") + 1), a4 = this.attr(i4), u4 = {};
            e5.stop();
            var d4 = n6[3] || "", p3 = a4.match(l3), h3 = o3[n6[1]];
            if (p3 && p3 == d4 ? t5 = h3(parseFloat(a4), +n6[2]) : (a4 = this.asPX(i4), t5 = h3(this.asPX(i4), this.asPX(i4, n6[2] + d4))), isNaN(a4) || isNaN(t5))
              return;
            u4[i4] = t5, this.attr(u4);
          }
        })(-10), e5.on("snap.util.equal", function(t5, n6) {
          var r5 = s3(this.attr(t5) || ""), i4 = s3(n6).match(c3);
          if (i4) {
            e5.stop();
            var a4 = i4[3] || "", p3 = r5.match(l3), h3 = o3[i4[1]];
            return p3 && p3 == a4 ? { from: parseFloat(r5), to: h3(parseFloat(r5), +i4[2]), f: d3(p3) } : { from: r5 = this.asPX(t5), to: h3(r5, this.asPX(t5, i4[2] + a4)), f: u3 };
          }
        })(-10);
      }), r3.plugin(function(n5, r4, i3, a3, o3) {
        var s3 = i3.prototype, l3 = n5.is;
        s3.rect = function(t4, e6, n6, r5, i4, a4) {
          var o4;
          return null == a4 && (a4 = i4), l3(t4, "object") && "[object Object]" == t4 ? o4 = t4 : null != t4 && (o4 = { x: t4, y: e6, width: n6, height: r5 }, null != i4 && (o4.rx = i4, o4.ry = a4)), this.el("rect", o4);
        }, s3.circle = function(t4, e6, n6) {
          var r5;
          return l3(t4, "object") && "[object Object]" == t4 ? r5 = t4 : null != t4 && (r5 = { cx: t4, cy: e6, r: n6 }), this.el("circle", r5);
        };
        var c3 = function() {
          function t4() {
            this.parentNode.removeChild(this);
          }
          return function(e6, n6) {
            var r5 = a3.doc.createElement("img"), i4 = a3.doc.body;
            r5.style.cssText = "position:absolute;left:-9999em;top:-9999em", r5.onload = function() {
              n6.call(r5), r5.onload = r5.onerror = null, i4.removeChild(r5);
            }, r5.onerror = t4, i4.appendChild(r5), r5.src = e6;
          };
        }();
        s3.image = function(t4, e6, r5, i4, a4) {
          var o4 = this.el("image");
          if (l3(t4, "object") && "src" in t4)
            o4.attr(t4);
          else if (null != t4) {
            var s4 = { "xlink:href": t4, preserveAspectRatio: "none" };
            null != e6 && null != r5 && (s4.x = e6, s4.y = r5), null != i4 && null != a4 ? (s4.width = i4, s4.height = a4) : c3(t4, function() {
              n5._.$(o4.node, { width: this.offsetWidth, height: this.offsetHeight });
            }), n5._.$(o4.node, s4);
          }
          return o4;
        }, s3.ellipse = function(t4, e6, n6, r5) {
          var i4;
          return l3(t4, "object") && "[object Object]" == t4 ? i4 = t4 : null != t4 && (i4 = { cx: t4, cy: e6, rx: n6, ry: r5 }), this.el("ellipse", i4);
        }, s3.path = function(t4) {
          var e6;
          return l3(t4, "object") && !l3(t4, "array") ? e6 = t4 : t4 && (e6 = { d: t4 }), this.el("path", e6);
        }, s3.group = s3.g = function(t4) {
          var e6 = this.el("g");
          return 1 == arguments.length && t4 && !t4.type ? e6.attr(t4) : arguments.length && e6.add(Array.prototype.slice.call(arguments, 0)), e6;
        }, s3.svg = function(t4, e6, n6, r5, i4, a4, o4, s4) {
          var c4 = {};
          return l3(t4, "object") && null == e6 ? c4 = t4 : (null != t4 && (c4.x = t4), null != e6 && (c4.y = e6), null != n6 && (c4.width = n6), null != r5 && (c4.height = r5), null != i4 && null != a4 && null != o4 && null != s4 && (c4.viewBox = [i4, a4, o4, s4])), this.el("svg", c4);
        }, s3.mask = function(t4) {
          var e6 = this.el("mask");
          return 1 == arguments.length && t4 && !t4.type ? e6.attr(t4) : arguments.length && e6.add(Array.prototype.slice.call(arguments, 0)), e6;
        }, s3.ptrn = function(t4, e6, n6, r5, i4, a4, o4, s4) {
          if (l3(t4, "object"))
            var c4 = t4;
          else
            c4 = { patternUnits: "userSpaceOnUse" }, t4 && (c4.x = t4), e6 && (c4.y = e6), null != n6 && (c4.width = n6), null != r5 && (c4.height = r5), c4.viewBox = null != i4 && null != a4 && null != o4 && null != s4 ? [i4, a4, o4, s4] : [t4 || 0, e6 || 0, n6 || 0, r5 || 0];
          return this.el("pattern", c4);
        }, s3.use = function(t4) {
          return null != t4 ? (t4 instanceof r4 && (t4.attr("id") || t4.attr({ id: n5._.id(t4) }), t4 = t4.attr("id")), "#" == String(t4).charAt() && (t4 = t4.substring(1)), this.el("use", { "xlink:href": "#" + t4 })) : r4.prototype.use.call(this);
        }, s3.symbol = function(t4, e6, n6, r5) {
          var i4 = {};
          return null != t4 && null != e6 && null != n6 && null != r5 && (i4.viewBox = [t4, e6, n6, r5]), this.el("symbol", i4);
        }, s3.text = function(t4, e6, n6) {
          var r5 = {};
          return l3(t4, "object") ? r5 = t4 : null != t4 && (r5 = { x: t4, y: e6, text: n6 || "" }), this.el("text", r5);
        }, s3.line = function(t4, e6, n6, r5) {
          var i4 = {};
          return l3(t4, "object") ? i4 = t4 : null != t4 && (i4 = { x1: t4, x2: n6, y1: e6, y2: r5 }), this.el("line", i4);
        }, s3.polyline = function(t4) {
          arguments.length > 1 && (t4 = Array.prototype.slice.call(arguments, 0));
          var e6 = {};
          return l3(t4, "object") && !l3(t4, "array") ? e6 = t4 : null != t4 && (e6 = { points: t4 }), this.el("polyline", e6);
        }, s3.polygon = function(t4) {
          arguments.length > 1 && (t4 = Array.prototype.slice.call(arguments, 0));
          var e6 = {};
          return l3(t4, "object") && !l3(t4, "array") ? e6 = t4 : null != t4 && (e6 = { points: t4 }), this.el("polygon", e6);
        }, function() {
          var r5 = n5._.$;
          function i4() {
            return this.selectAll("stop");
          }
          function a4(t4, e6) {
            var i5 = r5("stop"), a5 = { offset: +e6 + "%" };
            t4 = n5.color(t4), a5["stop-color"] = t4.hex, t4.opacity < 1 && (a5["stop-opacity"] = t4.opacity), r5(i5, a5);
            for (var o5, s4 = this.stops(), l5 = 0; l5 < s4.length; l5++) {
              if (parseFloat(s4[l5].attr("offset")) > e6) {
                this.node.insertBefore(i5, s4[l5].node), o5 = true;
                break;
              }
            }
            return o5 || this.node.appendChild(i5), this;
          }
          function o4() {
            if ("linearGradient" == this.type) {
              var t4 = r5(this.node, "x1") || 0, e6 = r5(this.node, "x2") || 1, i5 = r5(this.node, "y1") || 0, a5 = r5(this.node, "y2") || 0;
              return n5._.box(t4, i5, math.abs(e6 - t4), math.abs(a5 - i5));
            }
            var o5 = this.node.cx || 0.5, s4 = this.node.cy || 0.5, l5 = this.node.r || 0;
            return n5._.box(o5 - l5, s4 - l5, 2 * l5, 2 * l5);
          }
          function l4(t4) {
            var r6 = t4, i5 = this.stops();
            if ("string" == typeof t4 && (r6 = e5("snap.util.grad.parse", null, "l(0,0,0,1)" + t4).firstDefined().stops), n5.is(r6, "array")) {
              for (var a5 = 0; a5 < i5.length; a5++)
                if (r6[a5]) {
                  var o5 = n5.color(r6[a5].color), s4 = { offset: r6[a5].offset + "%" };
                  s4["stop-color"] = o5.hex, o5.opacity < 1 && (s4["stop-opacity"] = o5.opacity), i5[a5].attr(s4);
                } else
                  i5[a5].remove();
              for (a5 = i5.length; a5 < r6.length; a5++)
                this.addStop(r6[a5].color, r6[a5].offset);
              return this;
            }
          }
          function c4(t4, n6) {
            var i5, a5 = e5("snap.util.grad.parse", null, n6).firstDefined();
            if (!a5)
              return null;
            a5.params.unshift(t4), i5 = "l" == a5.type.toLowerCase() ? u3.apply(0, a5.params) : d3.apply(0, a5.params), a5.type != a5.type.toLowerCase() && r5(i5.node, { gradientUnits: "userSpaceOnUse" });
            for (var o5 = a5.stops, s4 = o5.length, l5 = 0; l5 < s4; l5++) {
              var c5 = o5[l5];
              i5.addStop(c5.color, c5.offset);
            }
            return i5;
          }
          function u3(t4, e6, s4, c5, u4) {
            var d4 = n5._.make("linearGradient", t4);
            return d4.stops = i4, d4.addStop = a4, d4.getBBox = o4, d4.setStops = l4, null != e6 && r5(d4.node, { x1: e6, y1: s4, x2: c5, y2: u4 }), d4;
          }
          function d3(t4, e6, s4, l5, c5, u4) {
            var d4 = n5._.make("radialGradient", t4);
            return d4.stops = i4, d4.addStop = a4, d4.getBBox = o4, null != e6 && r5(d4.node, { cx: e6, cy: s4, r: l5 }), null != c5 && null != u4 && r5(d4.node, { fx: c5, fy: u4 }), d4;
          }
          s3.gradient = function(t4) {
            return c4(this.defs, t4);
          }, s3.gradientLinear = function(t4, e6, n6, r6) {
            return u3(this.defs, t4, e6, n6, r6);
          }, s3.gradientRadial = function(t4, e6, n6, r6, i5) {
            return d3(this.defs, t4, e6, n6, r6, i5);
          }, s3.toString = function() {
            var t4, e6 = this.node.ownerDocument, r6 = e6.createDocumentFragment(), i5 = e6.createElement("div"), a5 = this.node.cloneNode(true);
            return r6.appendChild(i5), i5.appendChild(a5), n5._.$(a5, { xmlns: "http://www.w3.org/2000/svg" }), t4 = i5.innerHTML, r6.removeChild(r6.firstChild), t4;
          }, s3.toDataURL = function() {
            if (t3 && t3.btoa)
              return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
          }, s3.clear = function() {
            for (var t4, e6 = this.node.firstChild; e6; )
              t4 = e6.nextSibling, "defs" != e6.tagName ? e6.parentNode.removeChild(e6) : s3.clear.call({ node: e6 }), e6 = t4;
          };
        }();
      }), r3.plugin(function(t4, e6, n5, r4) {
        var i3 = e6.prototype, a3 = t4.is, o3 = t4._.clone, s3 = "hasOwnProperty", l3 = /,?([a-z]),?/gi, c3 = parseFloat, u3 = Math, d3 = u3.PI, p3 = u3.min, h3 = u3.max, f3 = u3.pow, g2 = u3.abs;
        function m2(t5) {
          var e7 = m2.ps = m2.ps || {};
          return e7[t5] ? e7[t5].sleep = 100 : e7[t5] = { sleep: 100 }, setTimeout(function() {
            for (var n6 in e7)
              e7[s3](n6) && n6 != t5 && (e7[n6].sleep--, !e7[n6].sleep && delete e7[n6]);
          }), e7[t5];
        }
        function v5(t5, e7, n6, r5) {
          return null == t5 && (t5 = e7 = n6 = r5 = 0), null == e7 && (e7 = t5.y, n6 = t5.width, r5 = t5.height, t5 = t5.x), { x: t5, y: e7, width: n6, w: n6, height: r5, h: r5, x2: t5 + n6, y2: e7 + r5, cx: t5 + n6 / 2, cy: e7 + r5 / 2, r1: u3.min(n6, r5) / 2, r2: u3.max(n6, r5) / 2, r0: u3.sqrt(n6 * n6 + r5 * r5) / 2, path: L2(t5, e7, n6, r5), vb: [t5, e7, n6, r5].join(" ") };
        }
        function y2() {
          return this.join(",").replace(l3, "$1");
        }
        function b2(t5) {
          var e7 = o3(t5);
          return e7.toString = y2, e7;
        }
        function x2(t5, e7, n6, r5, i4, a4, o4, s4, l4) {
          return null == l4 ? _2(t5, e7, n6, r5, i4, a4, o4, s4) : C2(t5, e7, n6, r5, i4, a4, o4, s4, D2(t5, e7, n6, r5, i4, a4, o4, s4, l4));
        }
        function F2(n6, r5) {
          function i4(t5) {
            return +(+t5).toFixed(3);
          }
          return t4._.cacher(function(t5, a4, o4) {
            t5 instanceof e6 && (t5 = t5.attr("d"));
            for (var s4, l4, c4, u4, d4, p4 = "", h4 = {}, f4 = 0, g3 = 0, m3 = (t5 = X2(t5)).length; g3 < m3; g3++) {
              if ("M" == (c4 = t5[g3])[0])
                s4 = +c4[1], l4 = +c4[2];
              else {
                if (f4 + (u4 = x2(s4, l4, c4[1], c4[2], c4[3], c4[4], c4[5], c4[6])) > a4) {
                  if (r5 && !h4.start) {
                    if (p4 += ["C" + i4((d4 = x2(s4, l4, c4[1], c4[2], c4[3], c4[4], c4[5], c4[6], a4 - f4)).start.x), i4(d4.start.y), i4(d4.m.x), i4(d4.m.y), i4(d4.x), i4(d4.y)], o4)
                      return p4;
                    h4.start = p4, p4 = ["M" + i4(d4.x), i4(d4.y) + "C" + i4(d4.n.x), i4(d4.n.y), i4(d4.end.x), i4(d4.end.y), i4(c4[5]), i4(c4[6])].join(), f4 += u4, s4 = +c4[5], l4 = +c4[6];
                    continue;
                  }
                  if (!n6 && !r5)
                    return d4 = x2(s4, l4, c4[1], c4[2], c4[3], c4[4], c4[5], c4[6], a4 - f4);
                }
                f4 += u4, s4 = +c4[5], l4 = +c4[6];
              }
              p4 += c4.shift() + c4;
            }
            return h4.end = p4, d4 = n6 ? f4 : r5 ? h4 : C2(s4, l4, c4[0], c4[1], c4[2], c4[3], c4[4], c4[5], 1);
          }, null, t4._.clone);
        }
        var k2 = F2(1), w2 = F2(), S2 = F2(0, 1);
        function C2(t5, e7, n6, r5, i4, a4, o4, s4, l4) {
          var c4 = 1 - l4, p4 = f3(c4, 3), h4 = f3(c4, 2), g3 = l4 * l4, m3 = g3 * l4, v6 = t5 + 2 * l4 * (n6 - t5) + g3 * (i4 - 2 * n6 + t5), y3 = e7 + 2 * l4 * (r5 - e7) + g3 * (a4 - 2 * r5 + e7), b3 = n6 + 2 * l4 * (i4 - n6) + g3 * (o4 - 2 * i4 + n6), x3 = r5 + 2 * l4 * (a4 - r5) + g3 * (s4 - 2 * a4 + r5);
          return { x: p4 * t5 + 3 * h4 * l4 * n6 + 3 * c4 * l4 * l4 * i4 + m3 * o4, y: p4 * e7 + 3 * h4 * l4 * r5 + 3 * c4 * l4 * l4 * a4 + m3 * s4, m: { x: v6, y: y3 }, n: { x: b3, y: x3 }, start: { x: c4 * t5 + l4 * n6, y: c4 * e7 + l4 * r5 }, end: { x: c4 * i4 + l4 * o4, y: c4 * a4 + l4 * s4 }, alpha: 90 - 180 * u3.atan2(v6 - b3, y3 - x3) / d3 };
        }
        function A2(e7, n6, r5, i4, a4, o4, s4, l4) {
          t4.is(e7, "array") || (e7 = [e7, n6, r5, i4, a4, o4, s4, l4]);
          var c4 = W2.apply(null, e7);
          return v5(c4.min.x, c4.min.y, c4.max.x - c4.min.x, c4.max.y - c4.min.y);
        }
        function E3(t5, e7, n6) {
          return e7 >= t5.x && e7 <= t5.x + t5.width && n6 >= t5.y && n6 <= t5.y + t5.height;
        }
        function I2(t5, e7) {
          return t5 = v5(t5), E3(e7 = v5(e7), t5.x, t5.y) || E3(e7, t5.x2, t5.y) || E3(e7, t5.x, t5.y2) || E3(e7, t5.x2, t5.y2) || E3(t5, e7.x, e7.y) || E3(t5, e7.x2, e7.y) || E3(t5, e7.x, e7.y2) || E3(t5, e7.x2, e7.y2) || (t5.x < e7.x2 && t5.x > e7.x || e7.x < t5.x2 && e7.x > t5.x) && (t5.y < e7.y2 && t5.y > e7.y || e7.y < t5.y2 && e7.y > t5.y);
        }
        function B2(t5, e7, n6, r5, i4) {
          return t5 * (t5 * (-3 * e7 + 9 * n6 - 9 * r5 + 3 * i4) + 6 * e7 - 12 * n6 + 6 * r5) - 3 * e7 + 3 * n6;
        }
        function _2(t5, e7, n6, r5, i4, a4, o4, s4, l4) {
          null == l4 && (l4 = 1);
          for (var c4 = (l4 = l4 > 1 ? 1 : l4 < 0 ? 0 : l4) / 2, d4 = 12, p4 = [-0.1252, 0.1252, -0.3678, 0.3678, -0.5873, 0.5873, -0.7699, 0.7699, -0.9041, 0.9041, -0.9816, 0.9816], h4 = [0.2491, 0.2491, 0.2335, 0.2335, 0.2032, 0.2032, 0.1601, 0.1601, 0.1069, 0.1069, 0.0472, 0.0472], f4 = 0, g3 = 0; g3 < d4; g3++) {
            var m3 = c4 * p4[g3] + c4, v6 = B2(m3, t5, n6, i4, o4), y3 = B2(m3, e7, r5, a4, s4), b3 = v6 * v6 + y3 * y3;
            f4 += h4[g3] * u3.sqrt(b3);
          }
          return c4 * f4;
        }
        function D2(t5, e7, n6, r5, i4, a4, o4, s4, l4) {
          if (!(l4 < 0 || _2(t5, e7, n6, r5, i4, a4, o4, s4) < l4)) {
            var c4, u4 = 1, d4 = u4 / 2, p4 = u4 - d4, h4 = 0.01;
            for (c4 = _2(t5, e7, n6, r5, i4, a4, o4, s4, p4); g2(c4 - l4) > h4; )
              c4 = _2(t5, e7, n6, r5, i4, a4, o4, s4, p4 += (c4 < l4 ? 1 : -1) * (d4 /= 2));
            return p4;
          }
        }
        function T2(t5, e7, n6, r5, i4, a4, o4, s4) {
          if (!(h3(t5, n6) < p3(i4, o4) || p3(t5, n6) > h3(i4, o4) || h3(e7, r5) < p3(a4, s4) || p3(e7, r5) > h3(a4, s4))) {
            var l4 = (t5 - n6) * (a4 - s4) - (e7 - r5) * (i4 - o4);
            if (l4) {
              var c4 = ((t5 * r5 - e7 * n6) * (i4 - o4) - (t5 - n6) * (i4 * s4 - a4 * o4)) / l4, u4 = ((t5 * r5 - e7 * n6) * (a4 - s4) - (e7 - r5) * (i4 * s4 - a4 * o4)) / l4, d4 = +c4.toFixed(2), f4 = +u4.toFixed(2);
              if (!(d4 < +p3(t5, n6).toFixed(2) || d4 > +h3(t5, n6).toFixed(2) || d4 < +p3(i4, o4).toFixed(2) || d4 > +h3(i4, o4).toFixed(2) || f4 < +p3(e7, r5).toFixed(2) || f4 > +h3(e7, r5).toFixed(2) || f4 < +p3(a4, s4).toFixed(2) || f4 > +h3(a4, s4).toFixed(2)))
                return { x: c4, y: u4 };
            }
          }
        }
        function U2(t5, e7, n6) {
          if (!I2(A2(t5), A2(e7)))
            return n6 ? 0 : [];
          for (var r5 = ~~(_2.apply(0, t5) / 8), i4 = ~~(_2.apply(0, e7) / 8), a4 = [], o4 = [], s4 = {}, l4 = n6 ? 0 : [], c4 = 0; c4 < r5 + 1; c4++) {
            var u4 = C2.apply(0, t5.concat(c4 / r5));
            a4.push({ x: u4.x, y: u4.y, t: c4 / r5 });
          }
          for (c4 = 0; c4 < i4 + 1; c4++)
            u4 = C2.apply(0, e7.concat(c4 / i4)), o4.push({ x: u4.x, y: u4.y, t: c4 / i4 });
          for (c4 = 0; c4 < r5; c4++)
            for (var d4 = 0; d4 < i4; d4++) {
              var p4 = a4[c4], h4 = a4[c4 + 1], f4 = o4[d4], m3 = o4[d4 + 1], v6 = g2(h4.x - p4.x) < 1e-3 ? "y" : "x", y3 = g2(m3.x - f4.x) < 1e-3 ? "y" : "x", b3 = T2(p4.x, p4.y, h4.x, h4.y, f4.x, f4.y, m3.x, m3.y);
              if (b3) {
                if (s4[b3.x.toFixed(4)] == b3.y.toFixed(4))
                  continue;
                s4[b3.x.toFixed(4)] = b3.y.toFixed(4);
                var x3 = p4.t + g2((b3[v6] - p4[v6]) / (h4[v6] - p4[v6])) * (h4.t - p4.t), F3 = f4.t + g2((b3[y3] - f4[y3]) / (m3[y3] - f4[y3])) * (m3.t - f4.t);
                x3 >= 0 && x3 <= 1 && F3 >= 0 && F3 <= 1 && (n6 ? l4++ : l4.push({ x: b3.x, y: b3.y, t1: x3, t2: F3 }));
              }
            }
          return l4;
        }
        function M2(t5, e7) {
          return N2(t5, e7);
        }
        function P2(t5, e7) {
          return N2(t5, e7, 1);
        }
        function N2(t5, e7, n6) {
          t5 = X2(t5), e7 = X2(e7);
          for (var r5, i4, a4, o4, s4, l4, c4, u4, d4, p4, h4 = n6 ? 0 : [], f4 = 0, g3 = t5.length; f4 < g3; f4++) {
            var m3 = t5[f4];
            if ("M" == m3[0])
              r5 = s4 = m3[1], i4 = l4 = m3[2];
            else {
              "C" == m3[0] ? (d4 = [r5, i4].concat(m3.slice(1)), r5 = d4[6], i4 = d4[7]) : (d4 = [r5, i4, r5, i4, s4, l4, s4, l4], r5 = s4, i4 = l4);
              for (var v6 = 0, y3 = e7.length; v6 < y3; v6++) {
                var b3 = e7[v6];
                if ("M" == b3[0])
                  a4 = c4 = b3[1], o4 = u4 = b3[2];
                else {
                  "C" == b3[0] ? (p4 = [a4, o4].concat(b3.slice(1)), a4 = p4[6], o4 = p4[7]) : (p4 = [a4, o4, a4, o4, c4, u4, c4, u4], a4 = c4, o4 = u4);
                  var x3 = U2(d4, p4, n6);
                  if (n6)
                    h4 += x3;
                  else {
                    for (var F3 = 0, k3 = x3.length; F3 < k3; F3++)
                      x3[F3].segment1 = f4, x3[F3].segment2 = v6, x3[F3].bez1 = d4, x3[F3].bez2 = p4;
                    h4 = h4.concat(x3);
                  }
                }
              }
            }
          }
          return h4;
        }
        function O2(t5, e7, n6) {
          var r5 = j2(t5);
          return E3(r5, e7, n6) && N2(t5, [["M", e7, n6], ["H", r5.x2 + 10]], 1) % 2 == 1;
        }
        function j2(t5) {
          var e7 = m2(t5);
          if (e7.bbox)
            return o3(e7.bbox);
          if (!t5)
            return v5();
          for (var n6, r5 = 0, i4 = 0, a4 = [], s4 = [], l4 = 0, c4 = (t5 = X2(t5)).length; l4 < c4; l4++)
            if ("M" == (n6 = t5[l4])[0])
              r5 = n6[1], i4 = n6[2], a4.push(r5), s4.push(i4);
            else {
              var u4 = W2(r5, i4, n6[1], n6[2], n6[3], n6[4], n6[5], n6[6]);
              a4 = a4.concat(u4.min.x, u4.max.x), s4 = s4.concat(u4.min.y, u4.max.y), r5 = n6[5], i4 = n6[6];
            }
          var d4 = p3.apply(0, a4), f4 = p3.apply(0, s4), g3 = v5(d4, f4, h3.apply(0, a4) - d4, h3.apply(0, s4) - f4);
          return e7.bbox = o3(g3), g3;
        }
        function L2(t5, e7, n6, r5, i4) {
          if (i4)
            return [["M", +t5 + +i4, e7], ["l", n6 - 2 * i4, 0], ["a", i4, i4, 0, 0, 1, i4, i4], ["l", 0, r5 - 2 * i4], ["a", i4, i4, 0, 0, 1, -i4, i4], ["l", 2 * i4 - n6, 0], ["a", i4, i4, 0, 0, 1, -i4, -i4], ["l", 0, 2 * i4 - r5], ["a", i4, i4, 0, 0, 1, i4, -i4], ["z"]];
          var a4 = [["M", t5, e7], ["l", n6, 0], ["l", 0, r5], ["l", -n6, 0], ["z"]];
          return a4.toString = y2, a4;
        }
        function R2(t5, e7, n6, r5, i4) {
          if (null == i4 && null == r5 && (r5 = n6), t5 = +t5, e7 = +e7, n6 = +n6, r5 = +r5, null != i4)
            var a4 = Math.PI / 180, o4 = t5 + n6 * Math.cos(-r5 * a4), s4 = t5 + n6 * Math.cos(-i4 * a4), l4 = [["M", o4, e7 + n6 * Math.sin(-r5 * a4)], ["A", n6, n6, 0, +(i4 - r5 > 180), 0, s4, e7 + n6 * Math.sin(-i4 * a4)]];
          else
            l4 = [["M", t5, e7], ["m", 0, -r5], ["a", n6, r5, 0, 1, 1, 0, 2 * r5], ["a", n6, r5, 0, 1, 1, 0, -2 * r5], ["z"]];
          return l4.toString = y2, l4;
        }
        var z2 = t4._unit2px, G2 = { path: function(t5) {
          return t5.attr("path");
        }, circle: function(t5) {
          var e7 = z2(t5);
          return R2(e7.cx, e7.cy, e7.r);
        }, ellipse: function(t5) {
          var e7 = z2(t5);
          return R2(e7.cx || 0, e7.cy || 0, e7.rx, e7.ry);
        }, rect: function(t5) {
          var e7 = z2(t5);
          return L2(e7.x || 0, e7.y || 0, e7.width, e7.height, e7.rx, e7.ry);
        }, image: function(t5) {
          var e7 = z2(t5);
          return L2(e7.x || 0, e7.y || 0, e7.width, e7.height);
        }, line: function(t5) {
          return "M" + [t5.attr("x1") || 0, t5.attr("y1") || 0, t5.attr("x2"), t5.attr("y2")];
        }, polyline: function(t5) {
          return "M" + t5.attr("points");
        }, polygon: function(t5) {
          return "M" + t5.attr("points") + "z";
        }, deflt: function(t5) {
          var e7 = t5.node.getBBox();
          return L2(e7.x, e7.y, e7.width, e7.height);
        } };
        function q2(e7) {
          var n6 = m2(e7), r5 = String.prototype.toLowerCase;
          if (n6.rel)
            return b2(n6.rel);
          t4.is(e7, "array") && t4.is(e7 && e7[0], "array") || (e7 = t4.parsePathString(e7));
          var i4 = [], a4 = 0, o4 = 0, s4 = 0, l4 = 0, c4 = 0;
          "M" == e7[0][0] && (s4 = a4 = e7[0][1], l4 = o4 = e7[0][2], c4++, i4.push(["M", a4, o4]));
          for (var u4 = c4, d4 = e7.length; u4 < d4; u4++) {
            var p4 = i4[u4] = [], h4 = e7[u4];
            if (h4[0] != r5.call(h4[0]))
              switch (p4[0] = r5.call(h4[0]), p4[0]) {
                case "a":
                  p4[1] = h4[1], p4[2] = h4[2], p4[3] = h4[3], p4[4] = h4[4], p4[5] = h4[5], p4[6] = +(h4[6] - a4).toFixed(3), p4[7] = +(h4[7] - o4).toFixed(3);
                  break;
                case "v":
                  p4[1] = +(h4[1] - o4).toFixed(3);
                  break;
                case "m":
                  s4 = h4[1], l4 = h4[2];
                default:
                  for (var f4 = 1, g3 = h4.length; f4 < g3; f4++)
                    p4[f4] = +(h4[f4] - (f4 % 2 ? a4 : o4)).toFixed(3);
              }
            else {
              p4 = i4[u4] = [], "m" == h4[0] && (s4 = h4[1] + a4, l4 = h4[2] + o4);
              for (var v6 = 0, x3 = h4.length; v6 < x3; v6++)
                i4[u4][v6] = h4[v6];
            }
            var F3 = i4[u4].length;
            switch (i4[u4][0]) {
              case "z":
                a4 = s4, o4 = l4;
                break;
              case "h":
                a4 += +i4[u4][F3 - 1];
                break;
              case "v":
                o4 += +i4[u4][F3 - 1];
                break;
              default:
                a4 += +i4[u4][F3 - 2], o4 += +i4[u4][F3 - 1];
            }
          }
          return i4.toString = y2, n6.rel = b2(i4), i4;
        }
        function V2(e7) {
          var n6 = m2(e7);
          if (n6.abs)
            return b2(n6.abs);
          if (a3(e7, "array") && a3(e7 && e7[0], "array") || (e7 = t4.parsePathString(e7)), !e7 || !e7.length)
            return [["M", 0, 0]];
          var r5, i4 = [], o4 = 0, s4 = 0, l4 = 0, c4 = 0, u4 = 0;
          "M" == e7[0][0] && (l4 = o4 = +e7[0][1], c4 = s4 = +e7[0][2], u4++, i4[0] = ["M", o4, s4]);
          for (var d4, p4, h4 = 3 == e7.length && "M" == e7[0][0] && "R" == e7[1][0].toUpperCase() && "Z" == e7[2][0].toUpperCase(), f4 = u4, g3 = e7.length; f4 < g3; f4++) {
            if (i4.push(d4 = []), (r5 = (p4 = e7[f4])[0]) != r5.toUpperCase())
              switch (d4[0] = r5.toUpperCase(), d4[0]) {
                case "A":
                  d4[1] = p4[1], d4[2] = p4[2], d4[3] = p4[3], d4[4] = p4[4], d4[5] = p4[5], d4[6] = +p4[6] + o4, d4[7] = +p4[7] + s4;
                  break;
                case "V":
                  d4[1] = +p4[1] + s4;
                  break;
                case "H":
                  d4[1] = +p4[1] + o4;
                  break;
                case "R":
                  for (var v6 = [o4, s4].concat(p4.slice(1)), x3 = 2, F3 = v6.length; x3 < F3; x3++)
                    v6[x3] = +v6[x3] + o4, v6[++x3] = +v6[x3] + s4;
                  i4.pop(), i4 = i4.concat(Q2(v6, h4));
                  break;
                case "O":
                  i4.pop(), (v6 = R2(o4, s4, p4[1], p4[2])).push(v6[0]), i4 = i4.concat(v6);
                  break;
                case "U":
                  i4.pop(), i4 = i4.concat(R2(o4, s4, p4[1], p4[2], p4[3])), d4 = ["U"].concat(i4[i4.length - 1].slice(-2));
                  break;
                case "M":
                  l4 = +p4[1] + o4, c4 = +p4[2] + s4;
                default:
                  for (x3 = 1, F3 = p4.length; x3 < F3; x3++)
                    d4[x3] = +p4[x3] + (x3 % 2 ? o4 : s4);
              }
            else if ("R" == r5)
              v6 = [o4, s4].concat(p4.slice(1)), i4.pop(), i4 = i4.concat(Q2(v6, h4)), d4 = ["R"].concat(p4.slice(-2));
            else if ("O" == r5)
              i4.pop(), (v6 = R2(o4, s4, p4[1], p4[2])).push(v6[0]), i4 = i4.concat(v6);
            else if ("U" == r5)
              i4.pop(), i4 = i4.concat(R2(o4, s4, p4[1], p4[2], p4[3])), d4 = ["U"].concat(i4[i4.length - 1].slice(-2));
            else
              for (var k3 = 0, w3 = p4.length; k3 < w3; k3++)
                d4[k3] = p4[k3];
            if ("O" != (r5 = r5.toUpperCase()))
              switch (d4[0]) {
                case "Z":
                  o4 = +l4, s4 = +c4;
                  break;
                case "H":
                  o4 = d4[1];
                  break;
                case "V":
                  s4 = d4[1];
                  break;
                case "M":
                  l4 = d4[d4.length - 2], c4 = d4[d4.length - 1];
                default:
                  o4 = d4[d4.length - 2], s4 = d4[d4.length - 1];
              }
          }
          return i4.toString = y2, n6.abs = b2(i4), i4;
        }
        function $(t5, e7, n6, r5) {
          return [t5, e7, n6, r5, n6, r5];
        }
        function Y2(t5, e7, n6, r5, i4, a4) {
          var o4 = 1 / 3, s4 = 2 / 3;
          return [o4 * t5 + s4 * n6, o4 * e7 + s4 * r5, o4 * i4 + s4 * n6, o4 * a4 + s4 * r5, i4, a4];
        }
        function H2(e7, n6, r5, i4, a4, o4, s4, l4, c4, p4) {
          var h4, f4 = 120 * d3 / 180, m3 = d3 / 180 * (+a4 || 0), v6 = [], y3 = t4._.cacher(function(t5, e8, n7) {
            return { x: t5 * u3.cos(n7) - e8 * u3.sin(n7), y: t5 * u3.sin(n7) + e8 * u3.cos(n7) };
          });
          if (!r5 || !i4)
            return [e7, n6, l4, c4, l4, c4];
          if (p4)
            E4 = p4[0], I3 = p4[1], C3 = p4[2], A3 = p4[3];
          else {
            e7 = (h4 = y3(e7, n6, -m3)).x, n6 = h4.y;
            var b3 = (e7 - (l4 = (h4 = y3(l4, c4, -m3)).x)) / 2, x3 = (n6 - (c4 = h4.y)) / 2, F3 = b3 * b3 / (r5 * r5) + x3 * x3 / (i4 * i4);
            F3 > 1 && (r5 *= F3 = u3.sqrt(F3), i4 *= F3);
            var k3 = r5 * r5, w3 = i4 * i4, S3 = (o4 == s4 ? -1 : 1) * u3.sqrt(g2((k3 * w3 - k3 * x3 * x3 - w3 * b3 * b3) / (k3 * x3 * x3 + w3 * b3 * b3))), C3 = S3 * r5 * x3 / i4 + (e7 + l4) / 2, A3 = S3 * -i4 * b3 / r5 + (n6 + c4) / 2, E4 = u3.asin(((n6 - A3) / i4).toFixed(9)), I3 = u3.asin(((c4 - A3) / i4).toFixed(9));
            (E4 = e7 < C3 ? d3 - E4 : E4) < 0 && (E4 = 2 * d3 + E4), (I3 = l4 < C3 ? d3 - I3 : I3) < 0 && (I3 = 2 * d3 + I3), s4 && E4 > I3 && (E4 -= 2 * d3), !s4 && I3 > E4 && (I3 -= 2 * d3);
          }
          var B3 = I3 - E4;
          if (g2(B3) > f4) {
            var _3 = I3, D3 = l4, T3 = c4;
            I3 = E4 + f4 * (s4 && I3 > E4 ? 1 : -1), v6 = H2(l4 = C3 + r5 * u3.cos(I3), c4 = A3 + i4 * u3.sin(I3), r5, i4, a4, 0, s4, D3, T3, [I3, _3, C3, A3]);
          }
          B3 = I3 - E4;
          var U3 = u3.cos(E4), M3 = u3.sin(E4), P3 = u3.cos(I3), N3 = u3.sin(I3), O3 = u3.tan(B3 / 4), j3 = 4 / 3 * r5 * O3, L3 = 4 / 3 * i4 * O3, R3 = [e7, n6], z3 = [e7 + j3 * M3, n6 - L3 * U3], G3 = [l4 + j3 * N3, c4 - L3 * P3], q3 = [l4, c4];
          if (z3[0] = 2 * R3[0] - z3[0], z3[1] = 2 * R3[1] - z3[1], p4)
            return [z3, G3, q3].concat(v6);
          for (var V3 = [], $2 = 0, Y3 = (v6 = [z3, G3, q3].concat(v6).join().split(",")).length; $2 < Y3; $2++)
            V3[$2] = $2 % 2 ? y3(v6[$2 - 1], v6[$2], m3).y : y3(v6[$2], v6[$2 + 1], m3).x;
          return V3;
        }
        function W2(t5, e7, n6, r5, i4, a4, o4, s4) {
          for (var l4, c4, d4, f4, m3, v6, y3, b3, x3 = [], F3 = [[], []], k3 = 0; k3 < 2; ++k3)
            if (0 == k3 ? (c4 = 6 * t5 - 12 * n6 + 6 * i4, l4 = -3 * t5 + 9 * n6 - 9 * i4 + 3 * o4, d4 = 3 * n6 - 3 * t5) : (c4 = 6 * e7 - 12 * r5 + 6 * a4, l4 = -3 * e7 + 9 * r5 - 9 * a4 + 3 * s4, d4 = 3 * r5 - 3 * e7), g2(l4) < 1e-12) {
              if (g2(c4) < 1e-12)
                continue;
              0 < (f4 = -d4 / c4) && f4 < 1 && x3.push(f4);
            } else
              y3 = c4 * c4 - 4 * d4 * l4, b3 = u3.sqrt(y3), y3 < 0 || (0 < (m3 = (-c4 + b3) / (2 * l4)) && m3 < 1 && x3.push(m3), 0 < (v6 = (-c4 - b3) / (2 * l4)) && v6 < 1 && x3.push(v6));
          for (var w3, S3 = x3.length, C3 = S3; S3--; )
            w3 = 1 - (f4 = x3[S3]), F3[0][S3] = w3 * w3 * w3 * t5 + 3 * w3 * w3 * f4 * n6 + 3 * w3 * f4 * f4 * i4 + f4 * f4 * f4 * o4, F3[1][S3] = w3 * w3 * w3 * e7 + 3 * w3 * w3 * f4 * r5 + 3 * w3 * f4 * f4 * a4 + f4 * f4 * f4 * s4;
          return F3[0][C3] = t5, F3[1][C3] = e7, F3[0][C3 + 1] = o4, F3[1][C3 + 1] = s4, F3[0].length = F3[1].length = C3 + 2, { min: { x: p3.apply(0, F3[0]), y: p3.apply(0, F3[1]) }, max: { x: h3.apply(0, F3[0]), y: h3.apply(0, F3[1]) } };
        }
        function X2(t5, e7) {
          var n6 = !e7 && m2(t5);
          if (!e7 && n6.curve)
            return b2(n6.curve);
          for (var r5 = V2(t5), i4 = e7 && V2(e7), a4 = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null }, o4 = { x: 0, y: 0, bx: 0, by: 0, X: 0, Y: 0, qx: null, qy: null }, s4 = function(t6, e8, n7) {
            var r6, i5;
            if (!t6)
              return ["C", e8.x, e8.y, e8.x, e8.y, e8.x, e8.y];
            switch (!(t6[0] in { T: 1, Q: 1 }) && (e8.qx = e8.qy = null), t6[0]) {
              case "M":
                e8.X = t6[1], e8.Y = t6[2];
                break;
              case "A":
                t6 = ["C"].concat(H2.apply(0, [e8.x, e8.y].concat(t6.slice(1))));
                break;
              case "S":
                "C" == n7 || "S" == n7 ? (r6 = 2 * e8.x - e8.bx, i5 = 2 * e8.y - e8.by) : (r6 = e8.x, i5 = e8.y), t6 = ["C", r6, i5].concat(t6.slice(1));
                break;
              case "T":
                "Q" == n7 || "T" == n7 ? (e8.qx = 2 * e8.x - e8.qx, e8.qy = 2 * e8.y - e8.qy) : (e8.qx = e8.x, e8.qy = e8.y), t6 = ["C"].concat(Y2(e8.x, e8.y, e8.qx, e8.qy, t6[1], t6[2]));
                break;
              case "Q":
                e8.qx = t6[1], e8.qy = t6[2], t6 = ["C"].concat(Y2(e8.x, e8.y, t6[1], t6[2], t6[3], t6[4]));
                break;
              case "L":
                t6 = ["C"].concat($(e8.x, e8.y, t6[1], t6[2]));
                break;
              case "H":
                t6 = ["C"].concat($(e8.x, e8.y, t6[1], e8.y));
                break;
              case "V":
                t6 = ["C"].concat($(e8.x, e8.y, e8.x, t6[1]));
                break;
              case "Z":
                t6 = ["C"].concat($(e8.x, e8.y, e8.X, e8.Y));
            }
            return t6;
          }, l4 = function(t6, e8) {
            if (t6[e8].length > 7) {
              t6[e8].shift();
              for (var n7 = t6[e8]; n7.length; )
                d4[e8] = "A", i4 && (p4[e8] = "A"), t6.splice(e8++, 0, ["C"].concat(n7.splice(0, 6)));
              t6.splice(e8, 1), y3 = h3(r5.length, i4 && i4.length || 0);
            }
          }, u4 = function(t6, e8, n7, a5, o5) {
            t6 && e8 && "M" == t6[o5][0] && "M" != e8[o5][0] && (e8.splice(o5, 0, ["M", a5.x, a5.y]), n7.bx = 0, n7.by = 0, n7.x = t6[o5][1], n7.y = t6[o5][2], y3 = h3(r5.length, i4 && i4.length || 0));
          }, d4 = [], p4 = [], f4 = "", g3 = "", v6 = 0, y3 = h3(r5.length, i4 && i4.length || 0); v6 < y3; v6++) {
            r5[v6] && (f4 = r5[v6][0]), "C" != f4 && (d4[v6] = f4, v6 && (g3 = d4[v6 - 1])), r5[v6] = s4(r5[v6], a4, g3), "A" != d4[v6] && "C" == f4 && (d4[v6] = "C"), l4(r5, v6), i4 && (i4[v6] && (f4 = i4[v6][0]), "C" != f4 && (p4[v6] = f4, v6 && (g3 = p4[v6 - 1])), i4[v6] = s4(i4[v6], o4, g3), "A" != p4[v6] && "C" == f4 && (p4[v6] = "C"), l4(i4, v6)), u4(r5, i4, a4, o4, v6), u4(i4, r5, o4, a4, v6);
            var x3 = r5[v6], F3 = i4 && i4[v6], k3 = x3.length, w3 = i4 && F3.length;
            a4.x = x3[k3 - 2], a4.y = x3[k3 - 1], a4.bx = c3(x3[k3 - 4]) || a4.x, a4.by = c3(x3[k3 - 3]) || a4.y, o4.bx = i4 && (c3(F3[w3 - 4]) || o4.x), o4.by = i4 && (c3(F3[w3 - 3]) || o4.y), o4.x = i4 && F3[w3 - 2], o4.y = i4 && F3[w3 - 1];
          }
          return i4 || (n6.curve = b2(r5)), i4 ? [r5, i4] : r5;
        }
        function Z2(t5, e7) {
          if (!e7)
            return t5;
          var n6, r5, i4, a4, o4, s4, l4;
          for (i4 = 0, o4 = (t5 = X2(t5)).length; i4 < o4; i4++)
            for (a4 = 1, s4 = (l4 = t5[i4]).length; a4 < s4; a4 += 2)
              n6 = e7.x(l4[a4], l4[a4 + 1]), r5 = e7.y(l4[a4], l4[a4 + 1]), l4[a4] = n6, l4[a4 + 1] = r5;
          return t5;
        }
        function Q2(t5, e7) {
          for (var n6 = [], r5 = 0, i4 = t5.length; i4 - 2 * !e7 > r5; r5 += 2) {
            var a4 = [{ x: +t5[r5 - 2], y: +t5[r5 - 1] }, { x: +t5[r5], y: +t5[r5 + 1] }, { x: +t5[r5 + 2], y: +t5[r5 + 3] }, { x: +t5[r5 + 4], y: +t5[r5 + 5] }];
            e7 ? r5 ? i4 - 4 == r5 ? a4[3] = { x: +t5[0], y: +t5[1] } : i4 - 2 == r5 && (a4[2] = { x: +t5[0], y: +t5[1] }, a4[3] = { x: +t5[2], y: +t5[3] }) : a4[0] = { x: +t5[i4 - 2], y: +t5[i4 - 1] } : i4 - 4 == r5 ? a4[3] = a4[2] : r5 || (a4[0] = { x: +t5[r5], y: +t5[r5 + 1] }), n6.push(["C", (-a4[0].x + 6 * a4[1].x + a4[2].x) / 6, (-a4[0].y + 6 * a4[1].y + a4[2].y) / 6, (a4[1].x + 6 * a4[2].x - a4[3].x) / 6, (a4[1].y + 6 * a4[2].y - a4[3].y) / 6, a4[2].x, a4[2].y]);
          }
          return n6;
        }
        t4.path = m2, t4.path.getTotalLength = k2, t4.path.getPointAtLength = w2, t4.path.getSubpath = function(t5, e7, n6) {
          if (this.getTotalLength(t5) - n6 < 1e-6)
            return S2(t5, e7).end;
          var r5 = S2(t5, n6, 1);
          return e7 ? S2(r5, e7).end : r5;
        }, i3.getTotalLength = function() {
          if (this.node.getTotalLength)
            return this.node.getTotalLength();
        }, i3.getPointAtLength = function(t5) {
          return w2(this.attr("d"), t5);
        }, i3.getSubpath = function(e7, n6) {
          return t4.path.getSubpath(this.attr("d"), e7, n6);
        }, t4._.box = v5, t4.path.findDotsAtSegment = C2, t4.path.bezierBBox = A2, t4.path.isPointInsideBBox = E3, t4.closest = function(e7, n6, r5, i4) {
          for (var a4 = 100, o4 = v5(e7 - a4 / 2, n6 - a4 / 2, a4, a4), s4 = [], l4 = r5[0].hasOwnProperty("x") ? function(t5) {
            return { x: r5[t5].x, y: r5[t5].y };
          } : function(t5) {
            return { x: r5[t5], y: i4[t5] };
          }, c4 = 0; a4 <= 1e6 && !c4; ) {
            for (var u4 = 0, d4 = r5.length; u4 < d4; u4++) {
              var p4 = l4(u4);
              if (E3(o4, p4.x, p4.y)) {
                c4++, s4.push(p4);
                break;
              }
            }
            c4 || (o4 = v5(e7 - (a4 *= 2) / 2, n6 - a4 / 2, a4, a4));
          }
          if (1e6 != a4) {
            var h4, f4 = 1 / 0;
            for (u4 = 0, d4 = s4.length; u4 < d4; u4++) {
              var g3 = t4.len(e7, n6, s4[u4].x, s4[u4].y);
              f4 > g3 && (f4 = g3, s4[u4].len = g3, h4 = s4[u4]);
            }
            return h4;
          }
        }, t4.path.isBBoxIntersect = I2, t4.path.intersection = M2, t4.path.intersectionNumber = P2, t4.path.isPointInside = O2, t4.path.getBBox = j2, t4.path.get = G2, t4.path.toRelative = q2, t4.path.toAbsolute = V2, t4.path.toCubic = X2, t4.path.map = Z2, t4.path.toString = y2, t4.path.clone = b2;
      }), r3.plugin(function(t4, r4, i3, a3) {
        var o3 = Math.max, s3 = Math.min, l3 = function(t5) {
          if (this.items = [], this.bindings = {}, this.length = 0, this.type = "set", t5)
            for (var e6 = 0, n5 = t5.length; e6 < n5; e6++)
              t5[e6] && (this[this.items.length] = this.items[this.items.length] = t5[e6], this.length++);
        }, c3 = l3.prototype;
        c3.push = function() {
          for (var t5, e6, n5 = 0, r5 = arguments.length; n5 < r5; n5++)
            (t5 = arguments[n5]) && (this[e6 = this.items.length] = this.items[e6] = t5, this.length++);
          return this;
        }, c3.pop = function() {
          return this.length && delete this[this.length--], this.items.pop();
        }, c3.forEach = function(t5, e6) {
          for (var n5 = 0, r5 = this.items.length; n5 < r5; n5++)
            if (false === t5.call(e6, this.items[n5], n5))
              return this;
          return this;
        }, c3.animate = function(r5, i4, a4, o4) {
          "function" != typeof a4 || a4.length || (o4 = a4, a4 = n4.linear), r5 instanceof t4._.Animation && (o4 = r5.callback, a4 = r5.easing, i4 = a4.dur, r5 = r5.attr);
          var s4 = arguments;
          if (t4.is(r5, "array") && t4.is(s4[s4.length - 1], "array"))
            var l4 = true;
          var c4, u3 = function() {
            c4 ? this.b = c4 : c4 = this.b;
          }, d3 = 0, p3 = this, h3 = o4 && function() {
            ++d3 == p3.length && o4.call(this);
          };
          return this.forEach(function(t5, n5) {
            e5.once("snap.animcreated." + t5.id, u3), l4 ? s4[n5] && t5.animate.apply(t5, s4[n5]) : t5.animate(r5, i4, a4, h3);
          });
        }, c3.remove = function() {
          for (; this.length; )
            this.pop().remove();
          return this;
        }, c3.bind = function(t5, e6, n5) {
          var r5 = {};
          if ("function" == typeof e6)
            this.bindings[t5] = e6;
          else {
            var i4 = n5 || t5;
            this.bindings[t5] = function(t6) {
              r5[i4] = t6, e6.attr(r5);
            };
          }
          return this;
        }, c3.attr = function(t5) {
          var e6 = {};
          for (var n5 in t5)
            this.bindings[n5] ? this.bindings[n5](t5[n5]) : e6[n5] = t5[n5];
          for (var r5 = 0, i4 = this.items.length; r5 < i4; r5++)
            this.items[r5].attr(e6);
          return this;
        }, c3.clear = function() {
          for (; this.length; )
            this.pop();
        }, c3.splice = function(t5, e6, n5) {
          t5 = t5 < 0 ? o3(this.length + t5, 0) : t5, e6 = o3(0, s3(this.length - t5, e6));
          var r5, i4 = [], a4 = [], c4 = [];
          for (r5 = 2; r5 < arguments.length; r5++)
            c4.push(arguments[r5]);
          for (r5 = 0; r5 < e6; r5++)
            a4.push(this[t5 + r5]);
          for (; r5 < this.length - t5; r5++)
            i4.push(this[t5 + r5]);
          var u3 = c4.length;
          for (r5 = 0; r5 < u3 + i4.length; r5++)
            this.items[t5 + r5] = this[t5 + r5] = r5 < u3 ? c4[r5] : i4[r5 - u3];
          for (r5 = this.items.length = this.length -= e6 - u3; this[r5]; )
            delete this[r5++];
          return new l3(a4);
        }, c3.exclude = function(t5) {
          for (var e6 = 0, n5 = this.length; e6 < n5; e6++)
            if (this[e6] == t5)
              return this.splice(e6, 1), true;
          return false;
        }, c3.insertAfter = function(t5) {
          for (var e6 = this.items.length; e6--; )
            this.items[e6].insertAfter(t5);
          return this;
        }, c3.getBBox = function() {
          for (var t5 = [], e6 = [], n5 = [], r5 = [], i4 = this.items.length; i4--; )
            if (!this.items[i4].removed) {
              var a4 = this.items[i4].getBBox();
              t5.push(a4.x), e6.push(a4.y), n5.push(a4.x + a4.width), r5.push(a4.y + a4.height);
            }
          return { x: t5 = s3.apply(0, t5), y: e6 = s3.apply(0, e6), x2: n5 = o3.apply(0, n5), y2: r5 = o3.apply(0, r5), width: n5 - t5, height: r5 - e6, cx: t5 + (n5 - t5) / 2, cy: e6 + (r5 - e6) / 2 };
        }, c3.clone = function(t5) {
          t5 = new l3();
          for (var e6 = 0, n5 = this.items.length; e6 < n5; e6++)
            t5.push(this.items[e6].clone());
          return t5;
        }, c3.toString = function() {
          return "Snap‘s set";
        }, c3.type = "set", t4.Set = l3, t4.set = function() {
          var t5 = new l3();
          return arguments.length && t5.push.apply(t5, Array.prototype.slice.call(arguments, 0)), t5;
        };
      }), r3.plugin(function(t4, n5, r4, i3) {
        var a3 = {}, o3 = /[%a-z]+$/i, s3 = String;
        function l3(t5) {
          var e6 = t5[0];
          switch (e6.toLowerCase()) {
            case "t":
              return [e6, 0, 0];
            case "m":
              return [e6, 1, 0, 0, 1, 0, 0];
            case "r":
              return 4 == t5.length ? [e6, 0, t5[2], t5[3]] : [e6, 0];
            case "s":
              return 5 == t5.length ? [e6, 1, 1, t5[3], t5[4]] : 3 == t5.length ? [e6, 1, 1] : [e6, 1];
          }
        }
        function c3(e6, n6, r5) {
          e6 = e6 || new t4.Matrix(), n6 = n6 || new t4.Matrix(), e6 = t4.parseTransformString(e6.toTransformString()) || [], n6 = t4.parseTransformString(n6.toTransformString()) || [];
          for (var i4, a4, o4, s4, c4 = Math.max(e6.length, n6.length), u4 = [], d4 = [], p4 = 0; p4 < c4; p4++) {
            if (o4 = e6[p4] || l3(n6[p4]), s4 = n6[p4] || l3(o4), o4[0] != s4[0] || "r" == o4[0].toLowerCase() && (o4[2] != s4[2] || o4[3] != s4[3]) || "s" == o4[0].toLowerCase() && (o4[3] != s4[3] || o4[4] != s4[4])) {
              e6 = t4._.transform2matrix(e6, r5()), n6 = t4._.transform2matrix(n6, r5()), u4 = [["m", e6.a, e6.b, e6.c, e6.d, e6.e, e6.f]], d4 = [["m", n6.a, n6.b, n6.c, n6.d, n6.e, n6.f]];
              break;
            }
            for (u4[p4] = [], d4[p4] = [], i4 = 0, a4 = Math.max(o4.length, s4.length); i4 < a4; i4++)
              i4 in o4 && (u4[p4][i4] = o4[i4]), i4 in s4 && (d4[p4][i4] = s4[i4]);
          }
          return { from: g2(u4), to: g2(d4), f: f3(u4) };
        }
        function u3(t5) {
          return t5;
        }
        function d3(t5) {
          return function(e6) {
            return +e6.toFixed(3) + t5;
          };
        }
        function p3(t5) {
          return t5.join(" ");
        }
        function h3(e6) {
          return t4.rgb(e6[0], e6[1], e6[2], e6[3]);
        }
        function f3(t5) {
          var e6, n6, r5, i4, a4, o4, s4 = 0, l4 = [];
          for (e6 = 0, n6 = t5.length; e6 < n6; e6++) {
            for (a4 = "[", o4 = ['"' + t5[e6][0] + '"'], r5 = 1, i4 = t5[e6].length; r5 < i4; r5++)
              o4[r5] = "val[" + s4++ + "]";
            a4 += o4 + "]", l4[e6] = a4;
          }
          return Function("val", "return Snap.path.toString.call([" + l4 + "])");
        }
        function g2(t5) {
          for (var e6 = [], n6 = 0, r5 = t5.length; n6 < r5; n6++)
            for (var i4 = 1, a4 = t5[n6].length; i4 < a4; i4++)
              e6.push(t5[n6][i4]);
          return e6;
        }
        function m2(t5) {
          return isFinite(t5);
        }
        function v5(e6, n6) {
          return !(!t4.is(e6, "array") || !t4.is(n6, "array")) && e6.toString() == n6.toString();
        }
        a3.stroke = a3.fill = "colour", n5.prototype.equal = function(t5, n6) {
          return e5("snap.util.equal", this, t5, n6).firstDefined();
        }, e5.on("snap.util.equal", function(e6, n6) {
          var r5, i4, l4 = s3(this.attr(e6) || ""), y2 = this;
          if ("colour" == a3[e6])
            return r5 = t4.color(l4), i4 = t4.color(n6), { from: [r5.r, r5.g, r5.b, r5.opacity], to: [i4.r, i4.g, i4.b, i4.opacity], f: h3 };
          if ("viewBox" == e6)
            return { from: r5 = this.attr(e6).vb.split(" ").map(Number), to: i4 = n6.split(" ").map(Number), f: p3 };
          if ("transform" == e6 || "gradientTransform" == e6 || "patternTransform" == e6)
            return "string" == typeof n6 && (n6 = s3(n6).replace(/\.{3}|\u2026/g, l4)), c3(l4 = this.matrix, n6 = t4._.rgTransform.test(n6) ? t4._.transform2matrix(n6, this.getBBox()) : t4._.transform2matrix(t4._.svgTransform2string(n6), this.getBBox()), function() {
              return y2.getBBox(1);
            });
          if ("d" == e6 || "path" == e6)
            return { from: g2((r5 = t4.path.toCubic(l4, n6))[0]), to: g2(r5[1]), f: f3(r5[0]) };
          if ("points" == e6)
            return { from: r5 = s3(l4).split(t4._.separator), to: i4 = s3(n6).split(t4._.separator), f: function(t5) {
              return t5;
            } };
          if (m2(l4) && m2(n6))
            return { from: parseFloat(l4), to: parseFloat(n6), f: u3 };
          var b2 = l4.match(o3), x2 = s3(n6).match(o3);
          return b2 && v5(b2, x2) ? { from: parseFloat(l4), to: parseFloat(n6), f: d3(b2) } : { from: this.asPX(e6), to: this.asPX(e6, n6), f: u3 };
        });
      }), r3.plugin(function(t4, n5, r4, i3) {
        for (var a3 = n5.prototype, o3 = "hasOwnProperty", s3 = ("createTouch" in i3.doc), l3 = ["click", "dblclick", "mousedown", "mousemove", "mouseout", "mouseover", "mouseup", "touchstart", "touchmove", "touchend", "touchcancel"], c3 = { mousedown: "touchstart", mousemove: "touchmove", mouseup: "touchend" }, u3 = function(t5, e6) {
          var n6 = "y" == t5 ? "scrollTop" : "scrollLeft", r5 = e6 && e6.node ? e6.node.ownerDocument : i3.doc;
          return r5[n6 in r5.documentElement ? "documentElement" : "body"][n6];
        }, d3 = function() {
          return this.originalEvent.preventDefault();
        }, p3 = function() {
          return this.originalEvent.stopPropagation();
        }, h3 = function(t5, e6, n6, r5) {
          var i4 = s3 && c3[e6] ? c3[e6] : e6, a4 = function(i5) {
            var a5 = u3("y", r5), l4 = u3("x", r5);
            if (s3 && c3[o3](e6)) {
              for (var h4 = 0, f4 = i5.targetTouches && i5.targetTouches.length; h4 < f4; h4++)
                if (i5.targetTouches[h4].target == t5 || t5.contains(i5.targetTouches[h4].target)) {
                  var g3 = i5;
                  (i5 = i5.targetTouches[h4]).originalEvent = g3, i5.preventDefault = d3, i5.stopPropagation = p3;
                  break;
                }
            }
            var m3 = i5.clientX + l4, v6 = i5.clientY + a5;
            return n6.call(r5, i5, m3, v6);
          };
          return e6 !== i4 && t5.addEventListener(e6, a4, false), t5.addEventListener(i4, a4, false), function() {
            return e6 !== i4 && t5.removeEventListener(e6, a4, false), t5.removeEventListener(i4, a4, false), true;
          };
        }, f3 = [], g2 = function(t5) {
          for (var n6, r5 = t5.clientX, i4 = t5.clientY, a4 = u3("y"), o4 = u3("x"), l4 = f3.length; l4--; ) {
            if (n6 = f3[l4], s3) {
              for (var c4, d4 = t5.touches && t5.touches.length; d4--; )
                if ((c4 = t5.touches[d4]).identifier == n6.el._drag.id || n6.el.node.contains(c4.target)) {
                  r5 = c4.clientX, i4 = c4.clientY, (t5.originalEvent ? t5.originalEvent : t5).preventDefault();
                  break;
                }
            } else
              t5.preventDefault();
            var p4 = n6.el.node;
            p4.nextSibling, p4.parentNode, p4.style.display, r5 += o4, i4 += a4, e5("snap.drag.move." + n6.el.id, n6.move_scope || n6.el, r5 - n6.el._drag.x, i4 - n6.el._drag.y, r5, i4, t5);
          }
        }, m2 = function(n6) {
          t4.unmousemove(g2).unmouseup(m2);
          for (var r5, i4 = f3.length; i4--; )
            (r5 = f3[i4]).el._drag = {}, e5("snap.drag.end." + r5.el.id, r5.end_scope || r5.start_scope || r5.move_scope || r5.el, n6), e5.off("snap.drag.*." + r5.el.id);
          f3 = [];
        }, v5 = l3.length; v5--; )
          !function(e6) {
            t4[e6] = a3[e6] = function(n6, r5) {
              if (t4.is(n6, "function"))
                this.events = this.events || [], this.events.push({ name: e6, f: n6, unbind: h3(this.node || document, e6, n6, r5 || this) });
              else
                for (var i4 = 0, a4 = this.events.length; i4 < a4; i4++)
                  if (this.events[i4].name == e6)
                    try {
                      this.events[i4].f.call(this);
                    } catch (t5) {
                    }
              return this;
            }, t4["un" + e6] = a3["un" + e6] = function(t5) {
              for (var n6 = this.events || [], r5 = n6.length; r5--; )
                if (n6[r5].name == e6 && (n6[r5].f == t5 || !t5))
                  return n6[r5].unbind(), n6.splice(r5, 1), !n6.length && delete this.events, this;
              return this;
            };
          }(l3[v5]);
        a3.hover = function(t5, e6, n6, r5) {
          return this.mouseover(t5, n6).mouseout(e6, r5 || n6);
        }, a3.unhover = function(t5, e6) {
          return this.unmouseover(t5).unmouseout(e6);
        };
        var y2 = [];
        a3.drag = function(n6, r5, i4, a4, o4, s4) {
          var l4, c4 = this;
          if (!arguments.length)
            return c4.drag(function(t5, e6) {
              this.attr({ transform: l4 + (l4 ? "T" : "t") + [t5, e6] });
            }, function() {
              l4 = this.transform().local;
            });
          function u4(l5, u5, d5) {
            (l5.originalEvent || l5).preventDefault(), c4._drag.x = u5, c4._drag.y = d5, c4._drag.id = l5.identifier, !f3.length && t4.mousemove(g2).mouseup(m2), f3.push({ el: c4, move_scope: a4, start_scope: o4, end_scope: s4 }), r5 && e5.on("snap.drag.start." + c4.id, r5), n6 && e5.on("snap.drag.move." + c4.id, n6), i4 && e5.on("snap.drag.end." + c4.id, i4), e5("snap.drag.start." + c4.id, o4 || a4 || c4, u5, d5, l5);
          }
          function d4(t5, n7, r6) {
            e5("snap.draginit." + c4.id, c4, t5, n7, r6);
          }
          return e5.on("snap.draginit." + c4.id, u4), c4._drag = {}, y2.push({ el: c4, start: u4, init: d4 }), c4.mousedown(d4), c4;
        }, a3.undrag = function() {
          for (var n6 = y2.length; n6--; )
            y2[n6].el == this && (this.unmousedown(y2[n6].init), y2.splice(n6, 1), e5.unbind("snap.drag.*." + this.id), e5.unbind("snap.draginit." + this.id));
          return !y2.length && t4.unmousemove(g2).unmouseup(m2), this;
        };
      }), r3.plugin(function(t4, n5, r4, i3) {
        n5.prototype;
        var a3 = r4.prototype, o3 = /^\s*url\((.+)\)/, s3 = String, l3 = t4._.$;
        t4.filter = {}, a3.filter = function(e6) {
          var r5 = this;
          "svg" != r5.type && (r5 = r5.paper);
          var i4 = t4.parse(s3(e6)), a4 = t4._.id();
          r5.node.offsetWidth, r5.node.offsetHeight;
          var o4 = l3("filter");
          return l3(o4, { id: a4, filterUnits: "userSpaceOnUse" }), o4.appendChild(i4.node), r5.defs.appendChild(o4), new n5(o4);
        }, e5.on("snap.util.getattr.filter", function() {
          e5.stop();
          var n6 = l3(this.node, "filter");
          if (n6) {
            var r5 = s3(n6).match(o3);
            return r5 && t4.select(r5[1]);
          }
        }), e5.on("snap.util.attr.filter", function(r5) {
          if (r5 instanceof n5 && "filter" == r5.type) {
            e5.stop();
            var i4 = r5.node.id;
            i4 || (l3(r5.node, { id: r5.id }), i4 = r5.id), l3(this.node, { filter: t4.url(i4) });
          }
          r5 && "none" != r5 || (e5.stop(), this.node.removeAttribute("filter"));
        }), t4.filter.blur = function(e6, n6) {
          null == e6 && (e6 = 2);
          var r5 = null == n6 ? e6 : [e6, n6];
          return t4.format('<feGaussianBlur stdDeviation="{def}"/>', { def: r5 });
        }, t4.filter.blur.toString = function() {
          return this();
        }, t4.filter.shadow = function(e6, n6, r5, i4, a4) {
          return null == a4 && (null == i4 ? (a4 = r5, r5 = 4, i4 = "#000") : (a4 = i4, i4 = r5, r5 = 4)), null == r5 && (r5 = 4), null == a4 && (a4 = 1), null == e6 && (e6 = 0, n6 = 2), null == n6 && (n6 = e6), i4 = t4.color(i4), t4.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', { color: i4, dx: e6, dy: n6, blur: r5, opacity: a4 });
        }, t4.filter.shadow.toString = function() {
          return this();
        }, t4.filter.grayscale = function(e6) {
          return null == e6 && (e6 = 1), t4.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', { a: 0.2126 + 0.7874 * (1 - e6), b: 0.7152 - 0.7152 * (1 - e6), c: 0.0722 - 0.0722 * (1 - e6), d: 0.2126 - 0.2126 * (1 - e6), e: 0.7152 + 0.2848 * (1 - e6), f: 0.0722 - 0.0722 * (1 - e6), g: 0.2126 - 0.2126 * (1 - e6), h: 0.0722 + 0.9278 * (1 - e6) });
        }, t4.filter.grayscale.toString = function() {
          return this();
        }, t4.filter.sepia = function(e6) {
          return null == e6 && (e6 = 1), t4.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', { a: 0.393 + 0.607 * (1 - e6), b: 0.769 - 0.769 * (1 - e6), c: 0.189 - 0.189 * (1 - e6), d: 0.349 - 0.349 * (1 - e6), e: 0.686 + 0.314 * (1 - e6), f: 0.168 - 0.168 * (1 - e6), g: 0.272 - 0.272 * (1 - e6), h: 0.534 - 0.534 * (1 - e6), i: 0.131 + 0.869 * (1 - e6) });
        }, t4.filter.sepia.toString = function() {
          return this();
        }, t4.filter.saturate = function(e6) {
          return null == e6 && (e6 = 1), t4.format('<feColorMatrix type="saturate" values="{amount}"/>', { amount: 1 - e6 });
        }, t4.filter.saturate.toString = function() {
          return this();
        }, t4.filter.hueRotate = function(e6) {
          return e6 = e6 || 0, t4.format('<feColorMatrix type="hueRotate" values="{angle}"/>', { angle: e6 });
        }, t4.filter.hueRotate.toString = function() {
          return this();
        }, t4.filter.invert = function(e6) {
          return null == e6 && (e6 = 1), t4.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', { amount: e6, amount2: 1 - e6 });
        }, t4.filter.invert.toString = function() {
          return this();
        }, t4.filter.brightness = function(e6) {
          return null == e6 && (e6 = 1), t4.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', { amount: e6 });
        }, t4.filter.brightness.toString = function() {
          return this();
        }, t4.filter.contrast = function(e6) {
          return null == e6 && (e6 = 1), t4.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', { amount: e6, amount2: 0.5 - e6 / 2 });
        }, t4.filter.contrast.toString = function() {
          return this();
        };
      }), r3.plugin(function(t4, e6, n5, r4, i3) {
        var a3 = t4._.box, o3 = t4.is, s3 = /^[^a-z]*([tbmlrc])/i, l3 = function() {
          return "T" + this.dx + "," + this.dy;
        };
        e6.prototype.getAlign = function(t5, e7) {
          null == e7 && o3(t5, "string") && (e7 = t5, t5 = null);
          var n6 = (t5 = t5 || this.paper).getBBox ? t5.getBBox() : a3(t5), r5 = this.getBBox(), i4 = {};
          switch (e7 = (e7 = e7 && e7.match(s3)) ? e7[1].toLowerCase() : "c") {
            case "t":
              i4.dx = 0, i4.dy = n6.y - r5.y;
              break;
            case "b":
              i4.dx = 0, i4.dy = n6.y2 - r5.y2;
              break;
            case "m":
              i4.dx = 0, i4.dy = n6.cy - r5.cy;
              break;
            case "l":
              i4.dx = n6.x - r5.x, i4.dy = 0;
              break;
            case "r":
              i4.dx = n6.x2 - r5.x2, i4.dy = 0;
              break;
            default:
              i4.dx = n6.cx - r5.cx, i4.dy = 0;
          }
          return i4.toString = l3, i4;
        }, e6.prototype.align = function(t5, e7) {
          return this.transform("..." + this.getAlign(t5, e7));
        };
      }), r3.plugin(function(e6, n5, r4, i3) {
        var a3 = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000", o3 = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162", s3 = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF", l3 = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA", c3 = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE", u3 = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF", d3 = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA", p3 = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4", h3 = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5", f3 = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853", g2 = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17", m2 = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00", v5 = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600", y2 = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00", b2 = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00", x2 = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00", F2 = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723", k2 = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121", w2 = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
        function S2(t4) {
          t4 = t4.split(/(?=#)/);
          var e7 = new String(t4[5]);
          return e7[50] = t4[0], e7[100] = t4[1], e7[200] = t4[2], e7[300] = t4[3], e7[400] = t4[4], e7[500] = t4[5], e7[600] = t4[6], e7[700] = t4[7], e7[800] = t4[8], e7[900] = t4[9], t4[10] && (e7.A100 = t4[10], e7.A200 = t4[11], e7.A400 = t4[12], e7.A700 = t4[13]), e7;
        }
        e6.mui = {}, e6.flat = {}, e6.mui.red = S2(a3), e6.mui.pink = S2(o3), e6.mui.purple = S2(s3), e6.mui.deeppurple = S2(l3), e6.mui.indigo = S2(c3), e6.mui.blue = S2(u3), e6.mui.lightblue = S2(d3), e6.mui.cyan = S2(p3), e6.mui.teal = S2(h3), e6.mui.green = S2(f3), e6.mui.lightgreen = S2(g2), e6.mui.lime = S2(m2), e6.mui.yellow = S2(v5), e6.mui.amber = S2(y2), e6.mui.orange = S2(b2), e6.mui.deeporange = S2(x2), e6.mui.brown = S2(F2), e6.mui.grey = S2(k2), e6.mui.bluegrey = S2(w2), e6.flat.turquoise = "#1abc9c", e6.flat.greensea = "#16a085", e6.flat.sunflower = "#f1c40f", e6.flat.orange = "#f39c12", e6.flat.emerland = "#2ecc71", e6.flat.nephritis = "#27ae60", e6.flat.carrot = "#e67e22", e6.flat.pumpkin = "#d35400", e6.flat.peterriver = "#3498db", e6.flat.belizehole = "#2980b9", e6.flat.alizarin = "#e74c3c", e6.flat.pomegranate = "#c0392b", e6.flat.amethyst = "#9b59b6", e6.flat.wisteria = "#8e44ad", e6.flat.clouds = "#ecf0f1", e6.flat.silver = "#bdc3c7", e6.flat.wetasphalt = "#34495e", e6.flat.midnightblue = "#2c3e50", e6.flat.concrete = "#95a5a6", e6.flat.asbestos = "#7f8c8d", e6.importMUIColors = function() {
          for (var n6 in e6.mui)
            e6.mui.hasOwnProperty(n6) && (t3[n6] = e6.mui[n6]);
        };
      }), r3;
    }(e4, n3);
  }(window || commonjsGlobal);
}(snap_svg);
var snap_svgExports = snap_svg.exports;
const SnapSvg = getDefaultExportFromCjs(snap_svgExports), RENDERING_TYPE = "optimizeQuality";
class SvgUtil {
  static createSvgObject(t2, e3) {
    return SnapSvg(t2, e3);
  }
  static async svgToCanvas(t2, e3, n2) {
    const r2 = t2.node, i2 = new XMLSerializer().serializeToString(r2), a2 = ImageUtil.svgToUri(i2, true), o2 = await ImageUtil.imageFromUrl(a2), s2 = document.createElement("canvas");
    s2.width = e3, s2.height = n2;
    const l2 = s2.getContext("2d", { alpha: true });
    return l2.imageSmoothingEnabled = false, l2.drawImage(o2, 0, 0, s2.width, s2.height), t2.remove(), s2;
  }
  static addTextToSvg(t2, { label: e3, center: n2 = [0, 0], color: r2 = "#FF0000", fontSize: i2 = "10px", fontFamily: a2 = "Arial, Helvetica, sans-serif" }) {
    t2.text(n2[0], n2[1], e3).attr({ fill: r2, stroke: r2, dominantBaseline: "middle", textAnchor: "middle", fontSize: i2, fontFamily: a2, shapeRendering: RENDERING_TYPE });
  }
  static addCircleToSvg(t2, { center: e3 = [0, 0], radius: n2 = 1, color: r2 = "#FF0000", stroke: i2 = "none", strokeWidth: a2 = 1 }) {
    t2.circle(e3[0], e3[1], n2).attr({ stroke: i2, strokeWidth: a2, fill: r2, shapeRendering: RENDERING_TYPE });
  }
  static addArcToSvg(t2, { center: e3 = [0, 0], startAngle: n2 = 0, endAngle: r2 = Math.PI, radius: i2 = 1, strokeWidth: a2 = 1, color: o2 = "#FF0000", correction: s2 = 0 }) {
    if (Math.abs(r2 - n2 - 2 * Math.PI) < 1e-6)
      return void SvgUtil.addCircleToSvg(t2, { center: e3, radius: i2, stroke: o2, strokeWidth: a2, color: "none" });
    const l2 = s2 / i2, c2 = e3[0] + i2 * Math.cos(n2 + l2), u2 = e3[1] + i2 * Math.sin(n2 + l2), d2 = e3[0] + i2 * Math.cos(r2 - l2), p2 = e3[1] + i2 * Math.sin(r2 - l2), h2 = `M ${c2} ${u2} A ${i2} ${i2} 0 ${Math.abs(r2 - n2) > Math.PI ? 1 : 0} 1 ${d2} ${p2}`;
    t2.path(h2).attr({ stroke: o2, strokeWidth: a2, fill: "none", shapeRendering: RENDERING_TYPE });
  }
  static addSquareToSvg(t2, { center: e3 = [0, 0], color: n2 = "#FF0000", stroke: r2 = "none", borderRadius: i2 = 0, radius: a2, strokeWidth: o2 = 1 }) {
    const s2 = e3[0] - a2, l2 = e3[1] - a2, c2 = t2.rect(s2, l2, 2 * a2, 2 * a2, i2, i2);
    return c2.attr({ fill: n2, stroke: r2, strokeWidth: o2 }), c2;
  }
  static addArcsToSvg(t2, { radius: e3, numArcs: n2 = 1, pattern: r2 = [1, 1], ...i2 }) {
    const [a2, o2] = r2;
    for (let r3 = 0; r3 < n2; r3 += 1) {
      const n3 = e3 + r3 * (a2 + o2);
      SvgUtil.addArcToSvg(t2, { radius: n3, strokeWidth: a2, ...i2 });
    }
  }
  static addDonutToSvg(t2, e3, { center: n2 = [0, 0], radius: r2 = 1, strokeWidth: i2 = 1, correction: a2 = 0 }) {
    null == e3 || e3.forEach((e4) => {
      const { startAngle: o2, endAngle: s2, color: l2 } = e4;
      SvgUtil.addArcsToSvg(t2, { startAngle: o2, endAngle: s2, color: l2, center: n2, radius: r2, strokeWidth: i2, correction: a2 });
    });
  }
  static getBBox(t2) {
    var e3;
    return null == (e3 = null == t2 ? void 0 : t2.node) ? void 0 : e3.getBBox();
  }
  static addImageToSvg(t2, { dataUrl: e3, center: n2 = [0, 0], size: r2 = [50, 50] }) {
    if (!e3)
      return;
    const i2 = Math.ceil(n2[0] - r2[0] / 2), a2 = Math.ceil(n2[1] - r2[1] / 2);
    t2.image(e3, i2, a2, r2[0], r2[1]);
  }
  static rotateObject(t2, e3, n2, r2 = null) {
    let i2 = "";
    if (r2)
      i2 = `rotate(${n2} ${r2[0]} ${r2[1]})`;
    else {
      const t3 = e3.getBBox();
      i2 = `rotate(${n2} ${t3.x + t3.width / 2} ${t3.y + t3.height / 2})`;
    }
    const a2 = t2.group();
    return a2.append(e3), a2.transform(i2), a2;
  }
  static scaleObject(t2, e3, n2, r2) {
    const i2 = `scale(${n2} ${r2})`, a2 = t2.group();
    return a2.append(e3), a2.transform(i2), a2;
  }
  static translateObject(t2, e3, n2, r2) {
    const i2 = `translate(${n2} ${r2})`, a2 = t2.group();
    return a2.append(e3), a2.transform(i2), a2;
  }
  static resizeObject(t2, e3, n2 = {}) {
    var r2, i2;
    const { size: a2 = [50, 50] } = n2;
    let { currentSize: o2 } = n2 || {};
    if (!o2) {
      const t3 = e3.node, n3 = null == (i2 = null == (r2 = t3.getAttributeNode("viewBox")) ? void 0 : r2.value) ? void 0 : i2.split(" "), [, , a3, s3] = n3 || [];
      if (n3) {
        o2 = [Number(a3), Number(s3)];
        const e4 = (e5, n4) => {
          const r3 = document.createAttribute(e5);
          r3.value = n4, t3.setAttributeNode(r3);
        };
        e4("width", a3), e4("height", s3);
      }
    }
    if (!o2)
      return e3;
    const s2 = a2[0] / o2[0] * 1, l2 = a2[1] / o2[1] * 1, c2 = SvgUtil.translateObject(t2, e3, -o2[0] / 2, -o2[1] / 2), u2 = SvgUtil.scaleObject(t2, c2, s2, l2);
    return SvgUtil.translateObject(t2, u2, a2[0] / 2 * 1, a2[1] / 2 * 1);
  }
  static async addSvgToSvg(t2, { dataUrl: e3, center: n2 = [0, 0], size: r2 = [50, 50], rotate: i2 = 0 }) {
    return e3 ? new Promise((a2) => {
      SnapSvg.load(e3, (e4) => {
        let o2 = e4;
        if (r2 && (o2 = SvgUtil.resizeObject(t2, o2, { size: r2 })), n2) {
          const [e5, i3] = r2, a3 = `translate(${Math.ceil(n2[0] - e5 / 2)} ${Math.ceil(n2[1] - i3 / 2)})`, s2 = t2.group();
          s2.append(o2), s2.transform(a3), o2 = s2;
        }
        i2 && (o2 = SvgUtil.rotateObject(t2, o2, i2, n2)), t2.append(o2), a2(o2);
      });
    }) : t2;
  }
  static addIndicatorToSvg(t2, { parentCenter: e3 = [0, 0], parentRadius: n2 = 1, angle: r2 = 0.25 * -Math.PI, isSquareGeometry: i2, ...a2 }) {
    const o2 = n2 * (1 - 1 / Math.sqrt(2));
    let s2;
    if (i2) {
      const t3 = Math.cos(r2), i3 = Math.sin(r2), a3 = n2 / Math.abs(t3), o3 = n2 / Math.abs(i3), l2 = Math.min(a3, o3);
      s2 = [e3[0] + t3 * l2, e3[1] + i3 * l2];
    } else
      s2 = [e3[0] + n2 * Math.cos(r2), e3[1] + n2 * Math.sin(r2)];
    SvgUtil.addCircleToSvg(t2, { center: s2, radius: o2, ...a2 });
  }
}
const STATUS_SYMBOL_STYLE = [{ label: "Critical", isAlert: true, type: "critical", startAngle: Math.PI, endAngle: Math.PI * (1 + 1 / 3), color: "#FF4D4F80", pattern: [6, 0.6], correction: 0.4 }, { label: "Major", isAlert: true, type: "major", startAngle: Math.PI * (1 + 1 / 3), endAngle: Math.PI * (1 + 2 / 3), color: "#FAAD1480", pattern: [6, 0.6], correction: 0.4 }, { label: "Minor", isAlert: true, type: "minor", startAngle: Math.PI * (1 + 2 / 3), endAngle: 2 * Math.PI, color: "#52C41A80", pattern: [6, 0.6], correction: 0.4 }, { label: "2.4GHz", isBand: true, type: "2.4ghz", color: "#36CFC9", pattern: [6, 0], correction: 0 }, { label: "5GHz", isBand: true, type: "5ghz", color: "#0958D9", pattern: [6, 0], correction: 0 }, { label: "6GHz", isBand: true, type: "6ghz", color: "#722ED1", pattern: [6, 0], correction: 0 }], STATUS_SYMBOL_FOUR_FANS = [{ label: "Critical", isAlert: true, type: "critical", startAngle: Math.PI, endAngle: Math.PI * (1 + 1 / 3), color: "#722ED180", pattern: [6, 0.6], correction: 0.4 }, { label: "Major", isAlert: true, type: "major", startAngle: Math.PI * (1 + 1 / 3), endAngle: Math.PI * (1 + 2 / 3), color: "#0958D9", pattern: [6, 0.6], correction: 0.4 }, { label: "Minor", isAlert: true, type: "minor", startAngle: Math.PI * (1 + 2 / 3), endAngle: 2 * Math.PI, color: "#642AB5", pattern: [6, 0.6], correction: 0.4 }, { label: "Inactive", isAlert: true, startAngle: Math.PI * (1 / 3), endAngle: Math.PI * (2 / 3), type: "inactive", color: "#cc7c21", pattern: [6, 0.6], correction: 0.4 }, { label: "2.4GHz", isBand: true, type: "2.4ghz", color: "#36CFC9", pattern: [6, 0], correction: 0 }, { label: "5GHz", isBand: true, type: "5ghz", color: "#0958D9", pattern: [6, 0], correction: 0 }, { label: "6GHz", isBand: true, type: "6ghz", color: "#722ED1", pattern: [6, 0], correction: 0 }], DEVICE_DEPLOYMENT_STATUS = { InDesign: { color: "#D5D6D7", label: "In Design" }, InConstruction: { color: "#A79A7F", label: "In Construction" }, IntegrationComplete: { color: "#FAAD14", label: "Integrated" }, OnAir: { color: "#52C41A", label: "On Air" }, NeedReplacement: { color: "#AD6800", label: "Need to Replace" }, RMA: { color: "#EB2F96", label: "RMA" }, Undefined: { color: "#D5D6D7", label: "Undefined" }, FieldTech: { color: "#1890FF", label: "Field Tech" } }, DEVICE_BADGE_STATUS = { active: { color: "#52C41A", stroke: "#D5D6D7", strokeWidth: 1, opacity: 1 }, inactive: { color: "#D5D6D7", stroke: "#D5D6D7", strokeWidth: 1, opacity: 1 }, warning: { color: "#FAAD14", stroke: "#D5D6D7", strokeWidth: 1, opacity: 1 }, error: { color: "#FF4D4F", stroke: "#D5D6D7", strokeWidth: 1, opacity: 1 } }, generateHash = (t2) => {
  if (!t2)
    return 0;
  let e3 = 0;
  const n2 = t2.length;
  for (let r2 = 0; r2 < n2; r2 += 1) {
    e3 = (e3 << 5) - e3 + t2[r2].charCodeAt(0), e3 |= 0;
  }
  return e3;
};
function getFiveFansStyle(t2 = 0.035) {
  return [{ label: "Critical", isAlert: true, type: "critical", startAngle: 0, endAngle: 0.4 * Math.PI - t2, color: "#642AB5", pattern: [6, 0.6], correction: 0.4 }, { label: "Major", isAlert: true, type: "major", startAngle: 0.4 * Math.PI + t2, endAngle: 0.8 * Math.PI - t2, color: "#36CFC980", pattern: [6, 0.6], correction: 0.4 }, { label: "Minor", isAlert: true, type: "minor", startAngle: 0.8 * Math.PI + t2, endAngle: 1.2 * Math.PI - t2, color: "#722ED180", pattern: [6, 0.6], correction: 0.4 }, { label: "Inactive1", isAlert: true, startAngle: 1.2 * Math.PI + t2, endAngle: 1.6 * Math.PI - t2, type: "inactive1", color: "#0958D9", pattern: [6, 0.6], correction: 0.4 }, { label: "Inactive2", isAlert: true, startAngle: 1.6 * Math.PI + t2, endAngle: 2 * Math.PI - t2, type: "inactive2", color: "#13858580", pattern: [6, 0.6], correction: 0.4 }, { label: "2.4GHz", isBand: true, type: "2.4ghz", color: "#36CFC9", pattern: [6, 0], correction: 0 }, { label: "5GHz", isBand: true, type: "5ghz", color: "#0958D9", pattern: [6, 0], correction: 0 }, { label: "6GHz", isBand: true, type: "6ghz", color: "#722ED1", pattern: [6, 0], correction: 0 }];
}
function readFile(t2, e3) {
  return new Promise((n2, r2) => {
    if ("file" === e3 || "blob" === e3)
      return void n2(t2);
    const i2 = new FileReader();
    i2.onload = (t3) => {
      let r3 = t3.target.result;
      if ("blobUrl" === e3) {
        const t4 = new Blob([new Uint8Array(r3)], { type: "data:application/octet-stream" });
        r3 = URL.createObjectURL(t4);
      }
      n2(r3);
    }, i2.onerror = () => r2(new Error("Failed to load data")), "buffer" === e3 || "blobUrl" === e3 ? i2.readAsArrayBuffer(t2) : "dataUrl" === e3 ? i2.readAsDataURL(t2) : "text" === e3 ? i2.readAsText(t2) : r2(new Error("Unknown output type!"));
  });
}
async function importFromFile(t2, e3) {
  var n2, r2;
  if (!t2)
    return new Error("Invalid file");
  const i2 = await readFile((null == t2 ? void 0 : t2.originFileObj) || t2, e3), a2 = null == t2 ? void 0 : t2.name, o2 = null == (r2 = null == (n2 = null == a2 ? void 0 : a2.split(".")) ? void 0 : n2.pop()) ? void 0 : r2.toLowerCase();
  return { data: i2, filename: a2, extension: o2, dataType: e3 };
}
async function importFromUrl(t2, e3) {
  if (!t2)
    return new Error("Invalid Url");
  const n2 = await fetch(t2), r2 = await n2.blob();
  return await importFromFile(r2, e3);
}
const DOT_SVG = (t2) => `<svg height="100" width="100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><circle cx="50" cy="50" r="40" stroke="white" stroke-width="20" fill="${t2}" /></svg>`;
class IconUtil {
  static getDotSvgUrl(t2 = "#%233bb2d0") {
    return ImageUtil.svgToUri(DOT_SVG(t2));
  }
  static async loadDotImageOnMap(t2, e3 = "%233bb2d0", n2 = "") {
    const r2 = IconUtil.coloredIconUrls[e3];
    if (r2)
      return r2;
    const i2 = await ImageUtil.svgToPng(DOT_SVG(e3), 20), a2 = `${n2}-${e3}-icon`, o2 = await IconUtil.loadImageUrlOnMap(t2, i2, a2);
    return IconUtil.coloredIconUrls[e3] = a2, o2;
  }
  static async loadImageUrlOnMap(t2, e3, n2, r2 = 1) {
    if (!t2)
      return n2;
    if (IconUtil.mapLoadedIds[n2])
      return n2;
    if (t2.hasImage(n2))
      return IconUtil.mapLoadedIds[n2] = true, n2;
    const i2 = IconUtil.mapLoadingIds[n2];
    return i2 ? (await i2, delete IconUtil.mapLoadingIds[n2], n2) : (IconUtil.mapLoadingIds[n2] = new Promise((i3) => {
      t2.loadImage(e3, (e4, a2) => {
        e4 || t2.addImage(n2, a2, { pixelRatio: r2 }), i3(n2);
      });
    }), n2);
  }
  static loadImageCanvasOnMap(t2, e3, n2, r2 = 1) {
    if (!t2 || !e3)
      return n2;
    const i2 = e3.getContext("2d", { alpha: true }), { width: a2, height: o2 } = e3, s2 = new Uint8Array(i2.getImageData(0, 0, a2, o2).data.buffer);
    return t2.hasImage(n2) || t2.addImage(n2, { width: a2, height: o2, data: s2, isSdf: true, pixelRatio: r2 }), n2;
  }
  static async generateIconIdForFeature(t2, e3, n2) {
    const { colorPropName: r2, iconUrlPropName: i2, defaultIconUrl: a2, defaultIconColor: o2, textValuePropName: s2, iconIdPropName: l2, prefix: c2, getCustomIcon: u2 } = n2;
    let d2 = null;
    if (u2) {
      const n3 = await u2(e3, t2);
      if (false === n3)
        return null;
      const { canvas: r3, keys: i3, iconId: a3, pixelRatio: o3 } = n3 || {};
      !r3 || !i3 && a3 || (d2 = IconUtil.loadImageCanvasOnMap(t2, r3, a3 || `${c2}-${i3.join("-")}-icon`, o3));
    }
    const p2 = d2 || e3.properties[l2];
    if (p2)
      return p2;
    let h2;
    if (i2 && (h2 = e3.properties[i2]), h2 = h2 || a2, h2) {
      return await IconUtil.loadImageUrlOnMap(t2, h2, `${c2}-${h2}-custom-icon`);
    }
    if (!e3.properties[s2]) {
      let n3 = null;
      r2 && (n3 = e3.properties[r2]), n3 = n3 || ("random" === o2 ? void 0 : o2);
      return await IconUtil.loadDotImageOnMap(t2, n3, `${c2}-dot`);
    }
    return null;
  }
  static async loadSymbolsOnMap(t2, e3, n2) {
    if (!(null == e3 ? void 0 : e3.length))
      return null;
    const { iconUrlPropName: r2, iconIdPropName: i2 } = n2, a2 = [];
    null == e3 || e3.forEach((e4) => {
      const r3 = IconUtil.generateIconIdForFeature(t2, e4, n2);
      a2.push(r3);
    });
    const o2 = await Promise.all(a2), s2 = { type: "FeatureCollection", features: [] };
    return e3.forEach((t3, e4) => {
      const n3 = o2[e4];
      if (n3) {
        const e5 = { ...t3, properties: { ...t3.properties, [i2]: n3 } };
        delete e5.properties[r2], s2.features.push(e5);
      } else
        s2.features.push(t3);
    }), s2;
  }
  static generateSampleCanvas(t2) {
    const e3 = t2.properties.fill || "white", n2 = 10 * t2.properties.mag || 50;
    return { canvas: ImageUtil.generateCircleImage(n2, n2, { radius: n2 / 2, fill: e3, stroke: "white", strokeWidth: 2 }), keys: [e3, n2] };
  }
  static async createFannedIcon(t2, e3) {
    const { enableBands: n2 = true, enableAlerts: r2 = true, coreColor: i2 = "#25282D", coreOutlineColor: a2 = "#13161B", textColor: o2 = "#FFFFFFD9" } = t2 || {}, s2 = [], l2 = [], c2 = [];
    let u2 = 1;
    const d2 = n2 ? 40 : 30;
    c2.push(r2 ? "alerts" : "noalerts"), c2.push(n2 ? "bands" : "nobands"), e3.forEach((e4) => {
      if (e4.isAlert && r2) {
        const n3 = t2[e4.type];
        s2.push({ ...e4, numArcs: n3, radius: d2 }), u2 = Math.max(u2, n3), c2.push(n3);
      } else if (e4.isBand && n2) {
        const n3 = t2[e4.type];
        l2.push({ ...e4, numArcs: 1, value: n3, radius: 30 }), c2.push(n3);
      }
    });
    const p2 = 2 * Math.ceil(d2 + 6.6 * u2 - 3), h2 = SvgUtil.createSvgObject(p2, p2), f2 = [p2 / 2, p2 / 2];
    SvgUtil.addCircleToSvg(h2, { center: f2, radius: d2 - 3, color: i2, stroke: a2 }), s2.forEach((t3) => {
      SvgUtil.addArcsToSvg(h2, { center: f2, ...t3 });
    });
    const g2 = l2.reduce((t3, e4) => t3 + e4.value, 0);
    let m2 = 1.5 * Math.PI;
    const v5 = 2 * Math.PI;
    l2.forEach((t3) => {
      const e4 = m2 + t3.value / g2 * v5, n3 = m2 > v5, r3 = { ...t3, center: f2, startAngle: n3 ? m2 % v5 : m2, endAngle: n3 ? e4 % v5 : e4 };
      SvgUtil.addArcsToSvg(h2, r3), m2 = e4;
    }), SvgUtil.addTextToSvg(h2, { center: f2, label: t2.symbolLabel || "125", color: o2, fontSize: "20px" });
    return { canvas: await SvgUtil.svgToCanvas(h2, p2, p2), keys: c2, svgObject: h2 };
  }
  static async createStatusSymbol(t2, e3 = "3fans") {
    switch (e3) {
      case "4fans":
        return IconUtil.createFannedIcon(t2, STATUS_SYMBOL_FOUR_FANS);
      case "5fans":
        return IconUtil.createFannedIcon(t2, getFiveFansStyle(t2.gapAngleInRad));
      default:
        return IconUtil.createFannedIcon(t2, STATUS_SYMBOL_STYLE);
    }
  }
  static async createSectorSymbol(t2) {
    const { sectors: e3 = [], indicator: n2 = null, sectorColor: r2 = "#003EB3", coreIconUrl: i2, overrideCoreIconUrlColor: a2, isSvgIcon: o2 = false, coreColor: s2 = "#F5F5F580", coreOutlineColor: l2 = "none", coreRadius: c2 = 15, sectorStroke: u2 = 6, gap: d2 = 6 } = t2 || {}, p2 = c2 + u2 / 2 + d2 / 2, h2 = Math.ceil(2 * p2 + u2), f2 = [h2 / 2, h2 / 2], g2 = { isSector: true, color: r2, pattern: [u2, 0], correction: 0 }, m2 = [], v5 = [generateHash(i2), s2, l2, null == n2 ? void 0 : n2.color, null == n2 ? void 0 : n2.stroke, null == n2 ? void 0 : n2.strokeWidth], y2 = 1.5 * Math.PI, b2 = 2 * Math.PI;
    null == e3 || e3.forEach((t3) => {
      const e4 = Number(t3.azimuth || 0) * Math.PI / 180 + y2, n3 = Number(t3.beamWidth || 0) * Math.PI / 180 + e4, r3 = e4 > b2;
      m2.push({ ...g2, center: f2, startAngle: r3 ? e4 % b2 : e4, endAngle: r3 ? n3 % b2 : n3, numArcs: 1, radius: p2 }), v5.push(n3 - e4);
    });
    const x2 = SvgUtil.createSvgObject(h2, h2);
    m2.forEach((t3) => {
      SvgUtil.addArcsToSvg(x2, t3);
    });
    let F2 = !a2;
    if (a2 && SvgUtil.addCircleToSvg(x2, { center: f2, radius: c2, color: s2, stroke: l2 }), i2) {
      const t3 = await importFromUrl(i2, "dataUrl"), { data: e4 } = t3 || {};
      e4 && (o2 ? await SvgUtil.addSvgToSvg(x2, { dataUrl: e4, center: f2, size: [2 * c2, 2 * c2] }) : await SvgUtil.addImageToSvg(x2, { dataUrl: e4, center: f2, size: [2 * c2, 2 * c2] }), F2 = false);
    }
    F2 && SvgUtil.addCircleToSvg(x2, { center: f2, radius: c2, color: s2, stroke: l2 }), n2 && SvgUtil.addIndicatorToSvg(x2, { parentCenter: f2, parentRadius: c2, ...n2 });
    return { canvas: await SvgUtil.svgToCanvas(x2, h2, h2), keys: v5, svgObject: x2 };
  }
  static async createDeviceSymbol(t2) {
    const { sectors: e3 = [], activityStatus: n2, deploymentStatus: r2, isSquare: i2 = false, coreColor: a2 = "none", coreIconUrl: o2, sectorIconUrl: s2, coreRadius: l2 = 14, coreStroke: c2 = 2, coreIconPadding: u2 = 4, sectorSize: d2 = 14, pixelRatio: p2 = 1 } = t2 || {}, { color: h2 = "#003EB3" } = DEVICE_DEPLOYMENT_STATUS[r2] || DEVICE_DEPLOYMENT_STATUS.Undefined, f2 = DEVICE_BADGE_STATUS[n2] || DEVICE_BADGE_STATUS.inactive, g2 = 2 * (l2 - u2), m2 = l2 + c2 / 2, v5 = l2 * (1 - 1 / Math.sqrt(2)), y2 = s2 && (null == e3 ? void 0 : e3.length) ? d2 : 0, b2 = y2 / 2, x2 = Math.max(y2 + 2 * b2, v5), F2 = Math.ceil(2 * l2 + 2 * c2 + x2), k2 = [F2 / 2, F2 / 2], w2 = [generateHash(o2), a2, h2, null == f2 ? void 0 : f2.color, null == f2 ? void 0 : f2.stroke, null == f2 ? void 0 : f2.strokeWidth, p2], S2 = [];
    s2 && (null == e3 || e3.forEach((t3) => {
      const e4 = Number(t3.azimuth || 0), n3 = e4 > 360 ? e4 % 360 : e4;
      S2.push(n3), w2.push(n3);
    }));
    const C2 = SvgUtil.createSvgObject(F2, F2);
    if (S2.length) {
      const t3 = await importFromUrl(s2, "dataUrl"), { data: e4 } = t3 || {};
      if (e4) {
        const t4 = 2 * m2 + y2;
        S2.forEach(async (n3) => {
          const r3 = n3 * Math.PI / 180, i3 = Math.sin(r3) * b2, a3 = -Math.cos(r3) * b2;
          await SvgUtil.addSvgToSvg(C2, { dataUrl: e4, center: [k2[0] + i3, k2[1] + a3], size: [t4, t4], rotate: n3 });
        });
      }
    }
    if (i2 ? SvgUtil.addSquareToSvg(C2, { center: k2, color: a2, stroke: h2, borderRadius: 4, radius: l2, strokeWidth: c2 }) : SvgUtil.addCircleToSvg(C2, { center: k2, color: a2, stroke: h2, borderRadius: 4, radius: m2, strokeWidth: c2 }), o2) {
      const t3 = await importFromUrl(o2, "dataUrl"), { data: e4 } = t3 || {};
      e4 && await SvgUtil.addSvgToSvg(C2, { dataUrl: e4, center: k2, size: [g2, g2] });
    }
    f2 && SvgUtil.addIndicatorToSvg(C2, { parentCenter: k2, parentRadius: l2, isSquareGeometry: i2, ...f2 });
    return { canvas: await SvgUtil.svgToCanvas(C2, F2 * p2, F2 * p2), keys: w2, svgObject: C2, pixelRatio: p2 };
  }
  static async createSvgSymbol(t2) {
    const { url: e3, size: n2 = 50 } = t2 || {}, r2 = [n2 / 2, n2 / 2], i2 = SvgUtil.createSvgObject(n2, n2), a2 = await importFromUrl(e3, "dataUrl"), { data: o2 } = a2 || {};
    o2 && await SvgUtil.addSvgToSvg(i2, { dataUrl: o2, center: r2, size: [n2, n2] });
    return { canvas: await SvgUtil.svgToCanvas(i2, n2, n2), keys: [e3], svgObject: i2 };
  }
  static async createAssetIconUrl(t2, e3, n2 = []) {
    if (!t2)
      return null;
    try {
      const r2 = n2.find((e4) => e4.key === t2), i2 = null == r2 ? void 0 : r2.url;
      if (!i2)
        return null;
      const a2 = await IconUtil.createDeviceSymbol({ ...e3 || {}, coreIconUrl: i2 });
      if (!a2)
        return null;
      const { canvas: o2 } = a2;
      if (!o2)
        return null;
      return o2.toDataURL();
    } catch (t3) {
      console.error("Error in getOrCreateAssetIconUrl:", t3);
    }
    return null;
  }
  static async getOrCreateAssetIcon(t2, e3, n2 = []) {
    if (!t2)
      return null;
    const { coreColor: r2, coreOutlineColor: i2, indicator: a2, sectors: o2, sectorIconUrl: s2, pixelRatio: l2 = 1 } = e3 || {}, c2 = [t2, r2, i2, null == a2 ? void 0 : a2.color, null == a2 ? void 0 : a2.stroke, null == a2 ? void 0 : a2.strokeWidth, (null == o2 ? void 0 : o2.length) ? JSON.stringify(o2) : void 0, s2 ? generateHash(s2) : void 0, l2].join("-");
    let u2 = IconUtil.cachedAssetIconUrl[c2];
    u2 || (u2 = IconUtil.createAssetIconUrl(t2, e3, n2), IconUtil.cachedAssetIconUrl[c2] = u2);
    return { url: await u2, key: c2 };
  }
  static async getDeviceIconForMap(t2, e3, n2 = null, r2 = []) {
    let i2 = null;
    return i2 = await IconUtil.getOrCreateAssetIcon(t2, e3, r2), i2 || (i2 = await IconUtil.getOrCreateAssetIcon("Other", e3), i2 = i2 || { url: IconUtil.MapPin, key: "default-pin" }), n2 && (null == i2 ? void 0 : i2.url) && (null == i2 ? void 0 : i2.key) && (i2.id = await IconUtil.loadImageUrlOnMap(n2, i2.url, i2.key)), i2;
  }
  static prepareDeviceIcons(t2) {
    return (null == t2 ? void 0 : t2.map((t3) => ({ key: t3.key || t3.asset_type || t3.assetType, value: t3.value || t3.asset_type || t3.assetType, label: t3.label || t3.asset_type || t3.assetType, Icon: t3.Icon || IconHelper.svgDataUrl2Icon(t3.icon), url: t3.url || t3.icon || t3.iconUrl, deviceCategory: t3.device_category || t3.deviceCategory, displayState: t3.display_state || t3.displayState }))) || {};
  }
}
IconUtil.mapLoadedIds = {}, IconUtil.mapLoadingIds = {}, IconUtil.coloredIconUrls = {}, IconUtil.cachedAssetIconUrl = {}, IconUtil.STATUS_SYMBOL_STYLE = STATUS_SYMBOL_STYLE, IconUtil.STATUS_SYMBOL_FOUR_FANS = STATUS_SYMBOL_FOUR_FANS, IconUtil.DEVICE_DEPLOYMENT_STATUS = DEVICE_DEPLOYMENT_STATUS, IconUtil.DEVICE_BADGE_STATUS = DEVICE_BADGE_STATUS;
const ICONS = {
  country: /* @__PURE__ */ jsx(Icons.Country, {}),
  region: /* @__PURE__ */ jsx(Icons.Region, {}),
  cluster: /* @__PURE__ */ jsx(Icons.Cluster, {}),
  market: /* @__PURE__ */ jsx(Icons.Market, {}),
  venue: /* @__PURE__ */ jsx(Icons.Venue, {}),
  building: /* @__PURE__ */ jsx(Icons.Building, {}),
  level: /* @__PURE__ */ jsx(Icons.Level, {}),
  zone: /* @__PURE__ */ jsx(Icons.Zone, {}),
  accessPoint: /* @__PURE__ */ jsx(Icons.Dot, {}),
  upload: /* @__PURE__ */ jsx(Icons.Export, {})
};
function useMCRTypesMeta(subRootId) {
  const icons = ICONS;
  const mcrTypesMeta = React__default.useMemo(() => [
    {
      objectType: "country",
      icon: icons.country,
      collectionName: "countries",
      idKey: "countryId"
    },
    {
      objectType: "region",
      icon: icons.region,
      collectionName: "regions",
      idKey: "regionId"
    },
    {
      objectType: "market",
      icon: icons.market,
      collectionName: "markets",
      idKey: "marketId"
    },
    {
      objectType: "cluster",
      icon: icons.cluster,
      collectionName: "clusters",
      idKey: "clusterId"
    },
    {
      objectType: "venue",
      icon: icons.venue,
      collectionName: "venues",
      idKey: "venueId"
    },
    {
      objectType: "building",
      icon: icons.building,
      collectionName: "buildings",
      idKey: "buildingId"
    },
    {
      objectType: "level",
      icon: icons.level,
      collectionName: "levels",
      idKey: "levelId"
    },
    // {
    //   objectType: 'layer',
    //   icon: icons.layer,
    //   collectionName: 'layers',
    //   idKey: 'layerId',
    // },
    {
      objectType: "zone",
      icon: icons.zone,
      collectionName: "zones",
      idKey: "zoneId"
    },
    {
      objectType: "accessPoint",
      icon: icons.accessPoint,
      collectionName: "accessPoints",
      idKey: "accessPointId"
    }
  ], [icons]);
  const aboveVenueSubTypesMeta = React__default.useMemo(() => {
    const buildingIdx = mcrTypesMeta.findIndex((item) => item.objectType === "building");
    const zoneIdx = mcrTypesMeta.findIndex((item) => item.objectType === "zone");
    const accessPointIdx = mcrTypesMeta.findIndex((item) => item.objectType === "accessPoint");
    return mcrTypesMeta.toSpliced(buildingIdx, mcrTypesMeta.length - buildingIdx, mcrTypesMeta[zoneIdx], mcrTypesMeta[accessPointIdx]);
  }, [mcrTypesMeta]);
  const belowViewSubTypesMeta = React__default.useMemo(() => {
    const countryIdx = mcrTypesMeta.findIndex((item) => item.objectType === "country");
    const venueIdx = mcrTypesMeta.findIndex((item) => item.objectType === "venue");
    return mcrTypesMeta.toSpliced(countryIdx, venueIdx - countryIdx);
  }, [mcrTypesMeta]);
  const subTypesMeta = subRootId ? belowViewSubTypesMeta : aboveVenueSubTypesMeta;
  const mcrParentKeys = mcrTypesMeta.map((item) => item.idKey).reverse();
  return {
    mcrTypesMeta,
    subTypesMeta,
    mcrParentKeys
  };
}
function useSiteObjectTypes(skipUpload) {
  const state = useViewStore();
  const icons = ICONS;
  const layerType = React__default.useMemo(() => [{
    key: "country",
    value: "country",
    label: "Country",
    icon: icons.country,
    description: "Identifies global national boundaries."
  }, {
    key: "region",
    value: "region",
    label: "Region",
    icon: icons.region,
    description: "Include one or more locations within a country"
  }, {
    key: "market",
    value: "market",
    label: "Market",
    icon: icons.market,
    description: "Defines the regions by specific business"
  }, {
    key: "cluster",
    value: "cluster",
    label: "Cluster",
    icon: icons.cluster,
    description: "Organized group of interconnected data points or elements"
  }, {
    key: "venue",
    value: "venue",
    label: "Venue",
    icon: icons.venue,
    description: "Specific place which can include more buildings"
  }, {
    key: "building",
    value: "building",
    label: "Building",
    icon: icons.building,
    description: "2D/3D construction with 1 or more floors"
  }, {
    key: "level",
    value: "level",
    label: "Floor",
    icon: icons.level,
    description: "2D/3D layer which is part of a building"
  }, {
    key: "zone",
    value: "zone",
    label: "Zone",
    icon: icons.zone,
    description: "Includes individual zones of one or more floors"
  }, {
    key: "accessPoint",
    value: "accessPoint",
    label: "Point",
    icon: icons.accessPoint,
    description: "Access Points, Locations, etc."
  }, {
    key: "upload",
    value: "upload",
    label: "Import Data",
    icon: icons.upload,
    description: ""
  }, {
    // to be used in venue subtree for asset import flow
    key: "uploadAssets",
    value: "uploadAssets",
    label: "Import Data",
    icon: icons.upload,
    description: ""
  }], [icons]);
  return React__default.useMemo(() => layerType.map((item) => {
    const {
      disabled,
      hidden
    } = checkSiteObjectTypeCreate(item.key, state) || {};
    if (hidden)
      return null;
    if (skipUpload && item.key === "upload")
      return null;
    return {
      ...item,
      disabled
    };
  }).filter((i2) => !!i2), [layerType, skipUpload, state]);
}
function useSiteObjectStatistics() {
  const {
    orphans,
    zones,
    levels,
    buildings,
    venues,
    markets,
    clusters,
    regions,
    countries
  } = useSiteStore();
  return React__default.useMemo(() => {
    var _a3;
    const layerStates = {
      country: (countries == null ? void 0 : countries.length) || 0,
      region: (regions == null ? void 0 : regions.length) || 0,
      cluster: (clusters == null ? void 0 : clusters.length) || 0,
      market: (markets == null ? void 0 : markets.length) || 0,
      venue: (venues == null ? void 0 : venues.length) || 0,
      building: (buildings == null ? void 0 : buildings.length) || 0,
      level: (levels == null ? void 0 : levels.length) || 0,
      zone: (zones == null ? void 0 : zones.length) || 0,
      orphan: ((_a3 = orphans == null ? void 0 : orphans.filter((o2) => o2.name !== "World")) == null ? void 0 : _a3.length) || 0
    };
    const keys4 = Object.keys(layerStates);
    const foundFirstIndex = keys4.findIndex((key) => layerStates[key] > 0);
    if (foundFirstIndex > -1) {
      layerStates.hierachyTop = keys4[foundFirstIndex];
      const foundLastIndex = keys4.reverse().findIndex((key) => layerStates[key] > 0);
      layerStates.hierachyBottom = keys4[foundLastIndex];
      if (foundLastIndex - 1 > -1) {
        layerStates.hierachyNext = keys4[foundLastIndex - 1];
      } else {
        layerStates.hierachyNext = "country";
      }
      layerStates.hasHierarchy = true;
    } else {
      layerStates.hierachyTop = "";
      layerStates.hierachyBottom = "";
      layerStates.hierachyNext = "country";
      layerStates.hasHierarchy = false;
    }
    return layerStates;
  }, [buildings == null ? void 0 : buildings.length, clusters == null ? void 0 : clusters.length, countries == null ? void 0 : countries.length, levels == null ? void 0 : levels.length, markets == null ? void 0 : markets.length, orphans, regions == null ? void 0 : regions.length, venues == null ? void 0 : venues.length, zones == null ? void 0 : zones.length]);
}
function findHierarchy(tree, targetKey) {
  let path2 = [];
  const traverse2 = (nodes, currentPath) => {
    if (!(nodes == null ? void 0 : nodes.length))
      return false;
    return nodes.some((node) => {
      const newPath = [...currentPath, node.key];
      if (node.key === targetKey) {
        path2 = newPath;
        return true;
      }
      if (node.children) {
        if (traverse2(node.children, newPath)) {
          return true;
        }
      }
      return false;
    });
  };
  traverse2(tree, []);
  return path2;
}
const useDeviceTypeStore = createZustandStore((set) => ({
  deviceTypes: [],
  reset: () => {
    set((state) => {
      state.deviceTypes = [];
    });
  },
  setDeviceTypes: (deviceTypes) => {
    set((state) => {
      state.deviceTypes = IconUtil.prepareDeviceIcons(deviceTypes);
    });
  }
}), "AssetTypeStore");
const globalCache$1 = [];
function shallowEqualArrays$1(arrA, arrB, equal3 = (a2, b2) => a2 === b2) {
  if (arrA === arrB)
    return true;
  if (!arrA || !arrB)
    return false;
  const len2 = arrA.length;
  if (arrB.length !== len2)
    return false;
  for (let i2 = 0; i2 < len2; i2++)
    if (!equal3(arrA[i2], arrB[i2]))
      return false;
  return true;
}
function query$1(fn2, keys4, preload2 = false, config2 = {}) {
  for (const entry2 of globalCache$1) {
    if (shallowEqualArrays$1(keys4, entry2.keys, entry2.equal)) {
      if (preload2)
        return void 0;
      if (Object.prototype.hasOwnProperty.call(entry2, "error"))
        throw entry2.error;
      if (Object.prototype.hasOwnProperty.call(entry2, "response"))
        return entry2.response;
      if (!preload2)
        throw entry2.promise;
    }
  }
  const entry = {
    keys: keys4,
    equal: config2.equal,
    promise: (
      // Execute the promise
      fn2(...keys4).then((response) => entry.response = response).then(() => {
        if (config2.lifespan && config2.lifespan > 0) {
          setTimeout(() => {
            const index2 = globalCache$1.indexOf(entry);
            if (index2 !== -1)
              globalCache$1.splice(index2, 1);
          }, config2.lifespan);
        }
      }).catch((error2) => entry.error = error2)
    )
  };
  globalCache$1.push(entry);
  if (!preload2)
    throw entry.promise;
  return void 0;
}
const suspend$1 = (fn2, keys4, config2) => query$1(fn2, keys4, false, config2);
const preload$1 = (fn2, keys4, config2) => void query$1(fn2, keys4, true, config2);
const clear$2 = (keys4) => {
  if (keys4 === void 0 || keys4.length === 0)
    globalCache$1.splice(0, globalCache$1.length);
  else {
    const entry = globalCache$1.find((entry2) => shallowEqualArrays$1(keys4, entry2.keys, entry2.equal));
    if (entry) {
      const index2 = globalCache$1.indexOf(entry);
      if (index2 !== -1)
        globalCache$1.splice(index2, 1);
    }
  }
};
function useEditGeojson(props) {
  const {
    data: dataIn,
    onFeature,
    onAllFeatures
  } = props;
  const dataAsync = suspend$1(async () => {
    if (!dataIn)
      return null;
    let json = dataIn;
    let shouldClone = true;
    if (typeof dataIn === "string") {
      shouldClone = false;
      const response = await fetch(dataIn);
      json = await (response == null ? void 0 : response.json());
    }
    const features = (json == null ? void 0 : json.features) || ((json == null ? void 0 : json.type) === "Feature" ? [json] : []);
    let modifiedFeatures = [];
    if (onFeature) {
      features.forEach((feature2, index2, array2) => {
        if (!feature2)
          return;
        try {
          const cloned = shouldClone ? JSON.parse(JSON.stringify(feature2)) : feature2;
          onFeature(cloned, index2, array2);
          if (shouldClone)
            modifiedFeatures.push(cloned);
        } catch (err) {
          console.error(err);
        }
      });
      if (!shouldClone)
        modifiedFeatures = features;
    } else {
      modifiedFeatures = features;
    }
    if (onAllFeatures) {
      onAllFeatures(modifiedFeatures);
    }
    return {
      type: "FeatureCollection",
      features: modifiedFeatures
    };
  }, [dataIn]);
  return dataAsync;
}
var resizeObservers = [];
var hasActiveObservations = function() {
  return resizeObservers.some(function(ro) {
    return ro.activeTargets.length > 0;
  });
};
var hasSkippedObservations = function() {
  return resizeObservers.some(function(ro) {
    return ro.skippedTargets.length > 0;
  });
};
var msg = "ResizeObserver loop completed with undelivered notifications.";
var deliverResizeLoopError = function() {
  var event;
  if (typeof ErrorEvent === "function") {
    event = new ErrorEvent("error", {
      message: msg
    });
  } else {
    event = document.createEvent("Event");
    event.initEvent("error", false, false);
    event.message = msg;
  }
  window.dispatchEvent(event);
};
var ResizeObserverBoxOptions;
(function(ResizeObserverBoxOptions2) {
  ResizeObserverBoxOptions2["BORDER_BOX"] = "border-box";
  ResizeObserverBoxOptions2["CONTENT_BOX"] = "content-box";
  ResizeObserverBoxOptions2["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));
var freeze = function(obj) {
  return Object.freeze(obj);
};
var ResizeObserverSize = function() {
  function ResizeObserverSize2(inlineSize, blockSize) {
    this.inlineSize = inlineSize;
    this.blockSize = blockSize;
    freeze(this);
  }
  return ResizeObserverSize2;
}();
var DOMRectReadOnly = function() {
  function DOMRectReadOnly2(x2, y2, width, height) {
    this.x = x2;
    this.y = y2;
    this.width = width;
    this.height = height;
    this.top = this.y;
    this.left = this.x;
    this.bottom = this.top + this.height;
    this.right = this.left + this.width;
    return freeze(this);
  }
  DOMRectReadOnly2.prototype.toJSON = function() {
    var _a3 = this, x2 = _a3.x, y2 = _a3.y, top = _a3.top, right = _a3.right, bottom = _a3.bottom, left = _a3.left, width = _a3.width, height = _a3.height;
    return { x: x2, y: y2, top, right, bottom, left, width, height };
  };
  DOMRectReadOnly2.fromRect = function(rectangle) {
    return new DOMRectReadOnly2(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
  };
  return DOMRectReadOnly2;
}();
var isSVG$2 = function(target) {
  return target instanceof SVGElement && "getBBox" in target;
};
var isHidden = function(target) {
  if (isSVG$2(target)) {
    var _a3 = target.getBBox(), width = _a3.width, height = _a3.height;
    return !width && !height;
  }
  var _b3 = target, offsetWidth = _b3.offsetWidth, offsetHeight = _b3.offsetHeight;
  return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var isElement = function(obj) {
  var _a3;
  if (obj instanceof Element) {
    return true;
  }
  var scope = (_a3 = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a3 === void 0 ? void 0 : _a3.defaultView;
  return !!(scope && obj instanceof scope.Element);
};
var isReplacedElement = function(target) {
  switch (target.tagName) {
    case "INPUT":
      if (target.type !== "image") {
        break;
      }
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return true;
  }
  return false;
};
var global$1 = typeof window !== "undefined" ? window : {};
var cache$2 = /* @__PURE__ */ new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = /msie|trident/i.test(global$1.navigator && global$1.navigator.userAgent);
var parseDimension = function(pixel) {
  return parseFloat(pixel || "0");
};
var size$1 = function(inlineSize, blockSize, switchSizes) {
  if (inlineSize === void 0) {
    inlineSize = 0;
  }
  if (blockSize === void 0) {
    blockSize = 0;
  }
  if (switchSizes === void 0) {
    switchSizes = false;
  }
  return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var zeroBoxes = freeze({
  devicePixelContentBoxSize: size$1(),
  borderBoxSize: size$1(),
  contentBoxSize: size$1(),
  contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});
var calculateBoxSizes = function(target, forceRecalculation) {
  if (forceRecalculation === void 0) {
    forceRecalculation = false;
  }
  if (cache$2.has(target) && !forceRecalculation) {
    return cache$2.get(target);
  }
  if (isHidden(target)) {
    cache$2.set(target, zeroBoxes);
    return zeroBoxes;
  }
  var cs = getComputedStyle(target);
  var svg = isSVG$2(target) && target.ownerSVGElement && target.getBBox();
  var removePadding = !IE && cs.boxSizing === "border-box";
  var switchSizes = verticalRegexp.test(cs.writingMode || "");
  var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || "");
  var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || "");
  var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
  var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
  var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
  var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
  var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
  var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
  var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
  var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
  var horizontalPadding = paddingLeft + paddingRight;
  var verticalPadding = paddingTop + paddingBottom;
  var horizontalBorderArea = borderLeft + borderRight;
  var verticalBorderArea = borderTop + borderBottom;
  var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
  var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
  var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
  var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
  var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
  var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
  var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
  var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
  var boxes = freeze({
    devicePixelContentBoxSize: size$1(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
    borderBoxSize: size$1(borderBoxWidth, borderBoxHeight, switchSizes),
    contentBoxSize: size$1(contentWidth, contentHeight, switchSizes),
    contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
  });
  cache$2.set(target, boxes);
  return boxes;
};
var calculateBoxSize = function(target, observedBox, forceRecalculation) {
  var _a3 = calculateBoxSizes(target, forceRecalculation), borderBoxSize = _a3.borderBoxSize, contentBoxSize = _a3.contentBoxSize, devicePixelContentBoxSize = _a3.devicePixelContentBoxSize;
  switch (observedBox) {
    case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
      return devicePixelContentBoxSize;
    case ResizeObserverBoxOptions.BORDER_BOX:
      return borderBoxSize;
    default:
      return contentBoxSize;
  }
};
var ResizeObserverEntry = function() {
  function ResizeObserverEntry2(target) {
    var boxes = calculateBoxSizes(target);
    this.target = target;
    this.contentRect = boxes.contentRect;
    this.borderBoxSize = freeze([boxes.borderBoxSize]);
    this.contentBoxSize = freeze([boxes.contentBoxSize]);
    this.devicePixelContentBoxSize = freeze([boxes.devicePixelContentBoxSize]);
  }
  return ResizeObserverEntry2;
}();
var calculateDepthForNode = function(node) {
  if (isHidden(node)) {
    return Infinity;
  }
  var depth2 = 0;
  var parent = node.parentNode;
  while (parent) {
    depth2 += 1;
    parent = parent.parentNode;
  }
  return depth2;
};
var broadcastActiveObservations = function() {
  var shallowestDepth = Infinity;
  var callbacks2 = [];
  resizeObservers.forEach(function processObserver(ro) {
    if (ro.activeTargets.length === 0) {
      return;
    }
    var entries = [];
    ro.activeTargets.forEach(function processTarget(ot) {
      var entry = new ResizeObserverEntry(ot.target);
      var targetDepth = calculateDepthForNode(ot.target);
      entries.push(entry);
      ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);
      if (targetDepth < shallowestDepth) {
        shallowestDepth = targetDepth;
      }
    });
    callbacks2.push(function resizeObserverCallback() {
      ro.callback.call(ro.observer, entries, ro.observer);
    });
    ro.activeTargets.splice(0, ro.activeTargets.length);
  });
  for (var _i = 0, callbacks_1 = callbacks2; _i < callbacks_1.length; _i++) {
    var callback = callbacks_1[_i];
    callback();
  }
  return shallowestDepth;
};
var gatherActiveObservationsAtDepth = function(depth2) {
  resizeObservers.forEach(function processObserver(ro) {
    ro.activeTargets.splice(0, ro.activeTargets.length);
    ro.skippedTargets.splice(0, ro.skippedTargets.length);
    ro.observationTargets.forEach(function processTarget(ot) {
      if (ot.isActive()) {
        if (calculateDepthForNode(ot.target) > depth2) {
          ro.activeTargets.push(ot);
        } else {
          ro.skippedTargets.push(ot);
        }
      }
    });
  });
};
var process$1 = function() {
  var depth2 = 0;
  gatherActiveObservationsAtDepth(depth2);
  while (hasActiveObservations()) {
    depth2 = broadcastActiveObservations();
    gatherActiveObservationsAtDepth(depth2);
  }
  if (hasSkippedObservations()) {
    deliverResizeLoopError();
  }
  return depth2 > 0;
};
var trigger;
var callbacks = [];
var notify = function() {
  return callbacks.splice(0).forEach(function(cb2) {
    return cb2();
  });
};
var queueMicroTask = function(callback) {
  if (!trigger) {
    var toggle_1 = 0;
    var el_1 = document.createTextNode("");
    var config2 = { characterData: true };
    new MutationObserver(function() {
      return notify();
    }).observe(el_1, config2);
    trigger = function() {
      el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
    };
  }
  callbacks.push(callback);
  trigger();
};
var queueResizeObserver = function(cb2) {
  queueMicroTask(function ResizeObserver2() {
    requestAnimationFrame(cb2);
  });
};
var watching = 0;
var isWatching = function() {
  return !!watching;
};
var CATCH_PERIOD = 250;
var observerConfig = { attributes: true, characterData: true, childList: true, subtree: true };
var events$7 = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
];
var time = function(timeout) {
  if (timeout === void 0) {
    timeout = 0;
  }
  return Date.now() + timeout;
};
var scheduled = false;
var Scheduler = function() {
  function Scheduler2() {
    var _this = this;
    this.stopped = true;
    this.listener = function() {
      return _this.schedule();
    };
  }
  Scheduler2.prototype.run = function(timeout) {
    var _this = this;
    if (timeout === void 0) {
      timeout = CATCH_PERIOD;
    }
    if (scheduled) {
      return;
    }
    scheduled = true;
    var until = time(timeout);
    queueResizeObserver(function() {
      var elementsHaveResized = false;
      try {
        elementsHaveResized = process$1();
      } finally {
        scheduled = false;
        timeout = until - time();
        if (!isWatching()) {
          return;
        }
        if (elementsHaveResized) {
          _this.run(1e3);
        } else if (timeout > 0) {
          _this.run(timeout);
        } else {
          _this.start();
        }
      }
    });
  };
  Scheduler2.prototype.schedule = function() {
    this.stop();
    this.run();
  };
  Scheduler2.prototype.observe = function() {
    var _this = this;
    var cb2 = function() {
      return _this.observer && _this.observer.observe(document.body, observerConfig);
    };
    document.body ? cb2() : global$1.addEventListener("DOMContentLoaded", cb2);
  };
  Scheduler2.prototype.start = function() {
    var _this = this;
    if (this.stopped) {
      this.stopped = false;
      this.observer = new MutationObserver(this.listener);
      this.observe();
      events$7.forEach(function(name2) {
        return global$1.addEventListener(name2, _this.listener, true);
      });
    }
  };
  Scheduler2.prototype.stop = function() {
    var _this = this;
    if (!this.stopped) {
      this.observer && this.observer.disconnect();
      events$7.forEach(function(name2) {
        return global$1.removeEventListener(name2, _this.listener, true);
      });
      this.stopped = true;
    }
  };
  return Scheduler2;
}();
var scheduler$1 = new Scheduler();
var updateCount = function(n2) {
  !watching && n2 > 0 && scheduler$1.start();
  watching += n2;
  !watching && scheduler$1.stop();
};
var skipNotifyOnElement = function(target) {
  return !isSVG$2(target) && !isReplacedElement(target) && getComputedStyle(target).display === "inline";
};
var ResizeObservation = function() {
  function ResizeObservation2(target, observedBox) {
    this.target = target;
    this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
    this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  ResizeObservation2.prototype.isActive = function() {
    var size12 = calculateBoxSize(this.target, this.observedBox, true);
    if (skipNotifyOnElement(this.target)) {
      this.lastReportedSize = size12;
    }
    if (this.lastReportedSize.inlineSize !== size12.inlineSize || this.lastReportedSize.blockSize !== size12.blockSize) {
      return true;
    }
    return false;
  };
  return ResizeObservation2;
}();
var ResizeObserverDetail = function() {
  function ResizeObserverDetail2(resizeObserver, callback) {
    this.activeTargets = [];
    this.skippedTargets = [];
    this.observationTargets = [];
    this.observer = resizeObserver;
    this.callback = callback;
  }
  return ResizeObserverDetail2;
}();
var observerMap = /* @__PURE__ */ new WeakMap();
var getObservationIndex = function(observationTargets, target) {
  for (var i2 = 0; i2 < observationTargets.length; i2 += 1) {
    if (observationTargets[i2].target === target) {
      return i2;
    }
  }
  return -1;
};
var ResizeObserverController = function() {
  function ResizeObserverController2() {
  }
  ResizeObserverController2.connect = function(resizeObserver, callback) {
    var detail = new ResizeObserverDetail(resizeObserver, callback);
    observerMap.set(resizeObserver, detail);
  };
  ResizeObserverController2.observe = function(resizeObserver, target, options2) {
    var detail = observerMap.get(resizeObserver);
    var firstObservation = detail.observationTargets.length === 0;
    if (getObservationIndex(detail.observationTargets, target) < 0) {
      firstObservation && resizeObservers.push(detail);
      detail.observationTargets.push(new ResizeObservation(target, options2 && options2.box));
      updateCount(1);
      scheduler$1.schedule();
    }
  };
  ResizeObserverController2.unobserve = function(resizeObserver, target) {
    var detail = observerMap.get(resizeObserver);
    var index2 = getObservationIndex(detail.observationTargets, target);
    var lastObservation = detail.observationTargets.length === 1;
    if (index2 >= 0) {
      lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
      detail.observationTargets.splice(index2, 1);
      updateCount(-1);
    }
  };
  ResizeObserverController2.disconnect = function(resizeObserver) {
    var _this = this;
    var detail = observerMap.get(resizeObserver);
    detail.observationTargets.slice().forEach(function(ot) {
      return _this.unobserve(resizeObserver, ot.target);
    });
    detail.activeTargets.splice(0, detail.activeTargets.length);
  };
  return ResizeObserverController2;
}();
var ResizeObserver$2 = function() {
  function ResizeObserver2(callback) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (typeof callback !== "function") {
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    }
    ResizeObserverController.connect(this, callback);
  }
  ResizeObserver2.prototype.observe = function(target, options2) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (!isElement(target)) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }
    ResizeObserverController.observe(this, target, options2);
  };
  ResizeObserver2.prototype.unobserve = function(target) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }
    if (!isElement(target)) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }
    ResizeObserverController.unobserve(this, target);
  };
  ResizeObserver2.prototype.disconnect = function() {
    ResizeObserverController.disconnect(this);
  };
  ResizeObserver2.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  };
  return ResizeObserver2;
}();
const usePassiveLayoutEffect = React__default[typeof document !== "undefined" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"];
const useLayoutEffect = usePassiveLayoutEffect;
const useLatest = (current) => {
  const storedValue = React.useRef(current);
  React.useEffect(() => {
    storedValue.current = current;
  });
  return storedValue;
};
const useLatest$1 = useLatest;
const ResizeObserver$1 = typeof window !== "undefined" && "ResizeObserver" in window ? (
  // @ts-ignore
  window.ResizeObserver
) : ResizeObserver$2;
function _ref() {
}
function useResizeObserver(target, callback) {
  const resizeObserver = getResizeObserver();
  const storedCallback = useLatest$1(callback);
  useLayoutEffect(() => {
    let didUnsubscribe = false;
    const targetEl = target && "current" in target ? target.current : target;
    if (!targetEl)
      return _ref;
    function cb2(entry, observer) {
      if (didUnsubscribe)
        return;
      storedCallback.current(entry, observer);
    }
    resizeObserver.subscribe(targetEl, cb2);
    return () => {
      didUnsubscribe = true;
      resizeObserver.unsubscribe(targetEl, cb2);
    };
  }, [target, resizeObserver, storedCallback]);
  return resizeObserver.observer;
}
function createResizeObserver() {
  let ticking = false;
  let allEntries = [];
  const callbacks2 = /* @__PURE__ */ new Map();
  const observer = new ResizeObserver$1((entries, obs) => {
    allEntries = allEntries.concat(entries);
    function _ref2() {
      const triggered = /* @__PURE__ */ new Set();
      for (let i2 = 0; i2 < allEntries.length; i2++) {
        if (triggered.has(allEntries[i2].target))
          continue;
        triggered.add(allEntries[i2].target);
        const cbs = callbacks2.get(allEntries[i2].target);
        cbs === null || cbs === void 0 ? void 0 : cbs.forEach((cb2) => cb2(allEntries[i2], obs));
      }
      allEntries = [];
      ticking = false;
    }
    if (!ticking) {
      window.requestAnimationFrame(_ref2);
    }
    ticking = true;
  });
  return {
    observer,
    subscribe(target, callback) {
      var _callbacks$get;
      observer.observe(target);
      const cbs = (_callbacks$get = callbacks2.get(target)) !== null && _callbacks$get !== void 0 ? _callbacks$get : [];
      cbs.push(callback);
      callbacks2.set(target, cbs);
    },
    unsubscribe(target, callback) {
      var _callbacks$get2;
      const cbs = (_callbacks$get2 = callbacks2.get(target)) !== null && _callbacks$get2 !== void 0 ? _callbacks$get2 : [];
      if (cbs.length === 1) {
        observer.unobserve(target);
        callbacks2.delete(target);
        return;
      }
      const cbIndex = cbs.indexOf(callback);
      if (cbIndex !== -1)
        cbs.splice(cbIndex, 1);
      callbacks2.set(target, cbs);
    }
  };
}
let _resizeObserver;
const getResizeObserver = () => !_resizeObserver ? _resizeObserver = createResizeObserver() : _resizeObserver;
function useLayoutDimensions() {
  const targetRef = React__default.useRef(null);
  const [size12, setSize] = React__default.useState({});
  useResizeObserver(targetRef, (entry) => {
    const {
      bottom,
      height,
      left,
      right,
      top,
      width,
      x: x2,
      y: y2
    } = (entry == null ? void 0 : entry.contentRect) || {};
    const size22 = {
      bottom,
      height,
      left,
      right,
      top,
      width,
      x: x2,
      y: y2
    };
    setSize(size22);
  });
  return {
    ...size12,
    ref: targetRef
  };
}
const useMapbox = (props) => {
  var _a3;
  const {
    log: log3,
    id = null,
    enableViewInfo = false
  } = props || {};
  const maps = useMap();
  const mapWrapper = id ? maps == null ? void 0 : maps[id] : maps == null ? void 0 : maps.current;
  const map5 = mapWrapper == null ? void 0 : mapWrapper.getMap();
  const mapId = id || maps ? (_a3 = Object.keys(maps).filter((k2) => maps[k2] === map5)) == null ? void 0 : _a3[0] : null;
  const [viewInfo, setViewInfo] = React__default.useState({});
  React__default.useLayoutEffect(() => {
    if (map5) {
      const listener = () => {
        if (log3 || enableViewInfo) {
          const viewInfo2 = {
            center: [Number(map5.getCenter().lng.toFixed(6)), Number(map5.getCenter().lat.toFixed(6))],
            zoom: Number(map5.getZoom().toFixed(2)),
            pitch: map5.getPitch(),
            bearing: map5.getBearing()
          };
          if (log3) {
            console.debug(viewInfo2);
          }
          if (enableViewInfo) {
            setViewInfo(viewInfo2);
          }
        }
      };
      map5.on("move", listener);
      return () => map5.off("move", listener);
    }
    return null;
  }, [enableViewInfo, log3, map5]);
  return {
    map: map5,
    id: mapId,
    viewInfo
  };
};
function useValueRef(value) {
  const valueRef = React__default.useRef(value);
  React__default.useEffect(() => {
    valueRef.current = value;
  }, [value]);
  return valueRef;
}
function useMutableFunc(func2) {
  const funcRef = useValueRef(func2);
  const mutFunc = React__default.useCallback((...args) => {
    var _a3;
    return (_a3 = funcRef.current) == null ? void 0 : _a3.call(funcRef, ...args);
  }, [funcRef]);
  return mutFunc;
}
function useUserLocation(enableHighAccuracy = true, timeout = 1e4) {
  const [location2, setLocation3] = useState(null);
  const [loading2, setLoading] = useState(true);
  const [error2, setError] = useState(null);
  useEffect(() => {
    if (!window || !(navigator == null ? void 0 : navigator.geolocation)) {
      setError(new Error("Geolocation is not supported by your browser"));
      setLoading(false);
      return;
    }
    const successCallback = (position) => {
      const {
        latitude,
        longitude
      } = position.coords;
      setLocation3([longitude, latitude]);
      setTimeout(() => setLoading(false), 50);
      setError(null);
    };
    const errorCallback = (err) => {
      setError(err);
      setLoading(false);
    };
    navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
      enableHighAccuracy,
      timeout
    });
  }, [enableHighAccuracy, timeout]);
  return {
    location: location2,
    loading: loading2,
    error: error2
  };
}
const useJsonLoader = () => {
  const setSiteFromJson = useSiteStore((state) => state.loadFromJson);
  const setViewFromJson = useViewStore((state) => state.loadFromJson);
  const getObjectDetail = useSiteStore((state) => state.getObjectDetail);
  const setAssetsFromJson = useAssetStore((state) => state.loadFromJson);
  const updateAsset = useAssetStore((state) => state.updateAsset);
  const setEditAssetId = useAssetStore((state) => state.setEditAssetId);
  const setProjects = useProjectStore((state) => state.setProjects);
  const onJsonFileLoad = React__default.useCallback((dataIn, isGeoJsonIn, options2) => {
    const {
      jsonData,
      isGeoJson
    } = ImportUtil.curateJsonForImport(dataIn, isGeoJsonIn, options2);
    const projects = ImportUtil.importProjectFromJson(jsonData, isGeoJson);
    const assets = setAssetsFromJson(jsonData, isGeoJson);
    const result = setSiteFromJson(jsonData, isGeoJson);
    setProjects(projects);
    setViewFromJson(isGeoJson ? result : jsonData);
    assets == null ? void 0 : assets.forEach((asset) => {
      var _a3, _b3;
      let editAssetId;
      const data2 = {
        id: asset.id
      };
      if (asset.type === "IMAGE" && !asset.box) {
        editAssetId = asset.id;
      } else if (asset.type === "GLTF" && !asset.center) {
        data2.center = useSiteStore.getState().getDefaultCenter();
        data2.needsGeoReferencing = true;
        editAssetId = asset.id;
      }
      const {
        parentId,
        parentType
      } = asset;
      const {
        collectionType,
        collectionItem
      } = getObjectDetail(parentId, parentType);
      if (!collectionItem || !collectionType) {
        data2.parentId = (_b3 = (_a3 = useSiteStore.getState().orphans) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.id;
        data2.parentType = "orphan";
      }
      if (editAssetId) {
        updateAsset(data2);
        setEditAssetId(editAssetId);
      }
    });
  }, [setAssetsFromJson, setSiteFromJson, setViewFromJson, getObjectDetail, updateAsset, setEditAssetId, setProjects]);
  return {
    onLoad: useMutableFunc(onJsonFileLoad)
  };
};
const useJsonExporter = () => {
  const siteState = useSiteStore((state) => state);
  const assetState = useAssetStore((state) => state);
  const projectState = useProjectStore((state) => {
    return {};
  });
  const onJsonExport = React__default.useCallback((options2) => {
    const {
      isGeoJson,
      activeId = null,
      onlyVisible = true,
      skipChildren = true,
      allowedCollectionTypes = null
    } = options2 || {};
    return ExportUtil.exportToJson(siteState, assetState, projectState, isGeoJson, activeId, onlyVisible, skipChildren, allowedCollectionTypes);
  }, [siteState, assetState, projectState]);
  return {
    onExport: useMutableFunc(onJsonExport),
    siteState,
    assetState,
    projectState
  };
};
function ArrayInput(props) {
  const {
    value: valueIn,
    defaultValue: defaultValue2,
    length: lengthIn,
    disabled: disabledIn,
    onChange,
    direction,
    placeholder: placeholder2,
    component: components,
    ...restProps
  } = props;
  const lengthRef = React__default.useRef(null);
  const arrayRef = React__default.useRef(null);
  const [array2, length2] = React__default.useMemo(() => {
    if (!arrayRef.current) {
      let length22 = 2;
      if (typeof lengthIn === "number" && lengthIn >= 2) {
        length22 = lengthIn;
      } else {
        const maxLength = Math.max((valueIn == null ? void 0 : valueIn.length) || 0, (defaultValue2 == null ? void 0 : defaultValue2.length) || 0);
        length22 = maxLength;
      }
      arrayRef.current = Array(length22).fill(0);
      lengthRef.current = length22;
    }
    return [arrayRef.current, lengthRef.current];
  }, [defaultValue2 == null ? void 0 : defaultValue2.length, lengthIn, valueIn == null ? void 0 : valueIn.length]);
  const value = React__default.useMemo(() => array2.map((_2, index2) => valueIn == null ? void 0 : valueIn[index2]), [array2, valueIn]);
  const disabled = React__default.useMemo(() => Array.isArray(disabledIn) ? disabledIn : array2 == null ? void 0 : array2.map(() => disabledIn), [array2, disabledIn]);
  const onChangeItem = React__default.useCallback((index2, valueAtIndex) => {
    if (index2 > -1 && index2 < length2) {
      const newValue = [...value];
      newValue[index2] = valueAtIndex || "";
      onChange(newValue);
    }
  }, [length2, onChange, value]);
  return /* @__PURE__ */ jsx(Space, { direction, size: 3, children: array2.map((_2, index2) => {
    const Component2 = components[index2] || Input$2;
    return /* @__PURE__ */ jsx(Component2, { ...restProps, disabled: disabled[index2], placeholder: placeholder2[index2] || "", value: value[index2], onChange: (e3) => {
      var _a3;
      return onChangeItem(index2, Component2 === Input$2 ? (_a3 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a3.value : e3);
    }, defaultValue: defaultValue2 == null ? void 0 : defaultValue2[index2] }, index2);
  }) });
}
ArrayInput.propTypes = {
  value: propTypesExports$1.array,
  defaultValue: propTypesExports$1.arrayOf(propTypesExports$1.string),
  disabled: propTypesExports$1.oneOfType([propTypesExports$1.bool, propTypesExports$1.arrayOf(propTypesExports$1.bool)]),
  placeholder: propTypesExports$1.arrayOf(propTypesExports$1.string),
  length: propTypesExports$1.number,
  onChange: propTypesExports$1.func,
  direction: propTypesExports$1.string,
  component: propTypesExports$1.arrayOf(propTypesExports$1.object)
};
ArrayInput.defaultProps = {
  value: [],
  defaultValue: null,
  length: null,
  disabled: false,
  placeholder: [],
  onChange: () => {
  },
  direction: "horizontal",
  component: []
};
var lib$4 = {};
var flattenNames$1 = {};
var freeGlobal$4 = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
var _freeGlobal = freeGlobal$4;
var freeGlobal$3 = _freeGlobal;
var freeSelf$2 = typeof self == "object" && self && self.Object === Object && self;
var root$b = freeGlobal$3 || freeSelf$2 || Function("return this")();
var _root = root$b;
var root$a = _root;
var Symbol$8 = root$a.Symbol;
var _Symbol = Symbol$8;
var Symbol$7 = _Symbol;
var objectProto$v = Object.prototype;
var hasOwnProperty$s = objectProto$v.hasOwnProperty;
var nativeObjectToString$3 = objectProto$v.toString;
var symToStringTag$3 = Symbol$7 ? Symbol$7.toStringTag : void 0;
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$s.call(value, symToStringTag$3), tag2 = value[symToStringTag$3];
  try {
    value[symToStringTag$3] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag2;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}
var _getRawTag = getRawTag$2;
var objectProto$u = Object.prototype;
var nativeObjectToString$2 = objectProto$u.toString;
function objectToString$3(value) {
  return nativeObjectToString$2.call(value);
}
var _objectToString = objectToString$3;
var Symbol$6 = _Symbol, getRawTag$1 = _getRawTag, objectToString$2 = _objectToString;
var nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]";
var symToStringTag$2 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function baseGetTag$8(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag$1 : nullTag$1;
  }
  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$1(value) : objectToString$2(value);
}
var _baseGetTag = baseGetTag$8;
var isArray$h = Array.isArray;
var isArray_1 = isArray$h;
function isObjectLike$b(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$b;
var baseGetTag$7 = _baseGetTag, isArray$g = isArray_1, isObjectLike$a = isObjectLike_1;
var stringTag$6 = "[object String]";
function isString$1(value) {
  return typeof value == "string" || !isArray$g(value) && isObjectLike$a(value) && baseGetTag$7(value) == stringTag$6;
}
var isString_1 = isString$1;
function createBaseFor$2(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length2 = props.length;
    while (length2--) {
      var key = props[fromRight ? length2 : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var _createBaseFor = createBaseFor$2;
var createBaseFor$1 = _createBaseFor;
var baseFor$3 = createBaseFor$1();
var _baseFor = baseFor$3;
function baseTimes$2(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$2;
var baseGetTag$6 = _baseGetTag, isObjectLike$9 = isObjectLike_1;
var argsTag$6 = "[object Arguments]";
function baseIsArguments$2(value) {
  return isObjectLike$9(value) && baseGetTag$6(value) == argsTag$6;
}
var _baseIsArguments = baseIsArguments$2;
var baseIsArguments$1 = _baseIsArguments, isObjectLike$8 = isObjectLike_1;
var objectProto$t = Object.prototype;
var hasOwnProperty$r = objectProto$t.hasOwnProperty;
var propertyIsEnumerable$3 = objectProto$t.propertyIsEnumerable;
var isArguments$4 = baseIsArguments$1(function() {
  return arguments;
}()) ? baseIsArguments$1 : function(value) {
  return isObjectLike$8(value) && hasOwnProperty$r.call(value, "callee") && !propertyIsEnumerable$3.call(value, "callee");
};
var isArguments_1 = isArguments$4;
var isBufferExports = {};
var isBuffer$7 = {
  get exports() {
    return isBufferExports;
  },
  set exports(v5) {
    isBufferExports = v5;
  }
};
function stubFalse$1() {
  return false;
}
var stubFalse_1 = stubFalse$1;
(function(module2, exports2) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports2 = exports2 && !exports2.nodeType && exports2;
  var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var Buffer2 = moduleExports2 ? root2.Buffer : void 0;
  var nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer2 || stubFalse2;
  module2.exports = isBuffer2;
})(isBuffer$7, isBufferExports);
var MAX_SAFE_INTEGER$3 = 9007199254740991;
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;
function isIndex$4(value, length2) {
  var type = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER$3 : length2;
  return !!length2 && (type == "number" || type != "symbol" && reIsUint$1.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
var _isIndex = isIndex$4;
var MAX_SAFE_INTEGER$2 = 9007199254740991;
function isLength$4(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}
var isLength_1 = isLength$4;
var baseGetTag$5 = _baseGetTag, isLength$3 = isLength_1, isObjectLike$7 = isObjectLike_1;
var argsTag$5 = "[object Arguments]", arrayTag$4 = "[object Array]", boolTag$5 = "[object Boolean]", dateTag$5 = "[object Date]", errorTag$4 = "[object Error]", funcTag$4 = "[object Function]", mapTag$8 = "[object Map]", numberTag$5 = "[object Number]", objectTag$8 = "[object Object]", regexpTag$5 = "[object RegExp]", setTag$8 = "[object Set]", stringTag$5 = "[object String]", weakMapTag$4 = "[object WeakMap]";
var arrayBufferTag$5 = "[object ArrayBuffer]", dataViewTag$7 = "[object DataView]", float32Tag$3 = "[object Float32Array]", float64Tag$3 = "[object Float64Array]", int8Tag$3 = "[object Int8Array]", int16Tag$3 = "[object Int16Array]", int32Tag$3 = "[object Int32Array]", uint8Tag$3 = "[object Uint8Array]", uint8ClampedTag$3 = "[object Uint8ClampedArray]", uint16Tag$3 = "[object Uint16Array]", uint32Tag$3 = "[object Uint32Array]";
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] = typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$5] = typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$4] = typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$5] = typedArrayTags$1[objectTag$8] = typedArrayTags$1[regexpTag$5] = typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$5] = typedArrayTags$1[weakMapTag$4] = false;
function baseIsTypedArray$2(value) {
  return isObjectLike$7(value) && isLength$3(value.length) && !!typedArrayTags$1[baseGetTag$5(value)];
}
var _baseIsTypedArray = baseIsTypedArray$2;
function baseUnary$4(func2) {
  return function(value) {
    return func2(value);
  };
}
var _baseUnary = baseUnary$4;
var _nodeUtilExports = {};
var _nodeUtil = {
  get exports() {
    return _nodeUtilExports;
  },
  set exports(v5) {
    _nodeUtilExports = v5;
  }
};
(function(module2, exports2) {
  var freeGlobal2 = _freeGlobal;
  var freeExports2 = exports2 && !exports2.nodeType && exports2;
  var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess2 = moduleExports2 && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types2 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
      if (types2) {
        return types2;
      }
      return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
    } catch (e3) {
    }
  }();
  module2.exports = nodeUtil2;
})(_nodeUtil, _nodeUtilExports);
var baseIsTypedArray$1 = _baseIsTypedArray, baseUnary$3 = _baseUnary, nodeUtil$4 = _nodeUtilExports;
var nodeIsTypedArray$1 = nodeUtil$4 && nodeUtil$4.isTypedArray;
var isTypedArray$5 = nodeIsTypedArray$1 ? baseUnary$3(nodeIsTypedArray$1) : baseIsTypedArray$1;
var isTypedArray_1 = isTypedArray$5;
var baseTimes$1 = _baseTimes, isArguments$3 = isArguments_1, isArray$f = isArray_1, isBuffer$6 = isBufferExports, isIndex$3 = _isIndex, isTypedArray$4 = isTypedArray_1;
var objectProto$s = Object.prototype;
var hasOwnProperty$q = objectProto$s.hasOwnProperty;
function arrayLikeKeys$3(value, inherited) {
  var isArr = isArray$f(value), isArg = !isArr && isArguments$3(value), isBuff = !isArr && !isArg && isBuffer$6(value), isType = !isArr && !isArg && !isBuff && isTypedArray$4(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes$1(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$q.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$3(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$3;
var objectProto$r = Object.prototype;
function isPrototype$4(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$r;
  return value === proto;
}
var _isPrototype = isPrototype$4;
function overArg$3(func2, transform4) {
  return function(arg) {
    return func2(transform4(arg));
  };
}
var _overArg = overArg$3;
var overArg$2 = _overArg;
var nativeKeys$3 = overArg$2(Object.keys, Object);
var _nativeKeys = nativeKeys$3;
var isPrototype$3 = _isPrototype, nativeKeys$2 = _nativeKeys;
var objectProto$q = Object.prototype;
var hasOwnProperty$p = objectProto$q.hasOwnProperty;
function baseKeys$2(object2) {
  if (!isPrototype$3(object2)) {
    return nativeKeys$2(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$p.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$2;
function isObject$j(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$j;
var baseGetTag$4 = _baseGetTag, isObject$i = isObject_1;
var asyncTag$1 = "[object AsyncFunction]", funcTag$3 = "[object Function]", genTag$2 = "[object GeneratorFunction]", proxyTag$1 = "[object Proxy]";
function isFunction$5(value) {
  if (!isObject$i(value)) {
    return false;
  }
  var tag2 = baseGetTag$4(value);
  return tag2 == funcTag$3 || tag2 == genTag$2 || tag2 == asyncTag$1 || tag2 == proxyTag$1;
}
var isFunction_1 = isFunction$5;
var isFunction$4 = isFunction_1, isLength$2 = isLength_1;
function isArrayLike$5(value) {
  return value != null && isLength$2(value.length) && !isFunction$4(value);
}
var isArrayLike_1 = isArrayLike$5;
var arrayLikeKeys$2 = _arrayLikeKeys, baseKeys$1 = _baseKeys, isArrayLike$4 = isArrayLike_1;
function keys$6(object2) {
  return isArrayLike$4(object2) ? arrayLikeKeys$2(object2) : baseKeys$1(object2);
}
var keys_1 = keys$6;
var baseFor$2 = _baseFor, keys$5 = keys_1;
function baseForOwn$3(object2, iteratee) {
  return object2 && baseFor$2(object2, iteratee, keys$5);
}
var _baseForOwn = baseForOwn$3;
function identity$7(value) {
  return value;
}
var identity_1 = identity$7;
var identity$6 = identity_1;
function castFunction$2(value) {
  return typeof value == "function" ? value : identity$6;
}
var _castFunction = castFunction$2;
var baseForOwn$2 = _baseForOwn, castFunction$1 = _castFunction;
function forOwn(object2, iteratee) {
  return object2 && baseForOwn$2(object2, castFunction$1(iteratee));
}
var forOwn_1 = forOwn;
var overArg$1 = _overArg;
var getPrototype$5 = overArg$1(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$5;
var baseGetTag$3 = _baseGetTag, getPrototype$4 = _getPrototype, isObjectLike$6 = isObjectLike_1;
var objectTag$7 = "[object Object]";
var funcProto$5 = Function.prototype, objectProto$p = Object.prototype;
var funcToString$5 = funcProto$5.toString;
var hasOwnProperty$o = objectProto$p.hasOwnProperty;
var objectCtorString$1 = funcToString$5.call(Object);
function isPlainObject$4(value) {
  if (!isObjectLike$6(value) || baseGetTag$3(value) != objectTag$7) {
    return false;
  }
  var proto = getPrototype$4(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$o.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$5.call(Ctor) == objectCtorString$1;
}
var isPlainObject_1 = isPlainObject$4;
function arrayMap$3(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
var _arrayMap = arrayMap$3;
function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$2;
function eq$4(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$4;
var eq$3 = eq_1;
function assocIndexOf$5(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq$3(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$5;
var assocIndexOf$4 = _assocIndexOf;
var arrayProto$1 = Array.prototype;
var splice$1 = arrayProto$1.splice;
function listCacheDelete$2(key) {
  var data2 = this.__data__, index2 = assocIndexOf$4(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice$1.call(data2, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$2;
var assocIndexOf$3 = _assocIndexOf;
function listCacheGet$2(key) {
  var data2 = this.__data__, index2 = assocIndexOf$3(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
var _listCacheGet = listCacheGet$2;
var assocIndexOf$2 = _assocIndexOf;
function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$2;
var assocIndexOf$1 = _assocIndexOf;
function listCacheSet$2(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf$1(data2, key);
  if (index2 < 0) {
    ++this.size;
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$2;
var listCacheClear$1 = _listCacheClear, listCacheDelete$1 = _listCacheDelete, listCacheGet$1 = _listCacheGet, listCacheHas$1 = _listCacheHas, listCacheSet$1 = _listCacheSet;
function ListCache$5(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype["delete"] = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;
var _ListCache = ListCache$5;
var ListCache$4 = _ListCache;
function stackClear$2() {
  this.__data__ = new ListCache$4();
  this.size = 0;
}
var _stackClear = stackClear$2;
function stackDelete$2(key) {
  var data2 = this.__data__, result = data2["delete"](key);
  this.size = data2.size;
  return result;
}
var _stackDelete = stackDelete$2;
function stackGet$2(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$2;
function stackHas$2(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$2;
var root$9 = _root;
var coreJsData$3 = root$9["__core-js_shared__"];
var _coreJsData = coreJsData$3;
var coreJsData$2 = _coreJsData;
var maskSrcKey$1 = function() {
  var uid2 = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || "");
  return uid2 ? "Symbol(src)_1." + uid2 : "";
}();
function isMasked$2(func2) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func2;
}
var _isMasked = isMasked$2;
var funcProto$4 = Function.prototype;
var funcToString$4 = funcProto$4.toString;
function toSource$3(func2) {
  if (func2 != null) {
    try {
      return funcToString$4.call(func2);
    } catch (e3) {
    }
    try {
      return func2 + "";
    } catch (e3) {
    }
  }
  return "";
}
var _toSource = toSource$3;
var isFunction$3 = isFunction_1, isMasked$1 = _isMasked, isObject$h = isObject_1, toSource$2 = _toSource;
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
var funcProto$3 = Function.prototype, objectProto$o = Object.prototype;
var funcToString$3 = funcProto$3.toString;
var hasOwnProperty$n = objectProto$o.hasOwnProperty;
var reIsNative$1 = RegExp(
  "^" + funcToString$3.call(hasOwnProperty$n).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$2(value) {
  if (!isObject$h(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$2(value));
}
var _baseIsNative = baseIsNative$2;
function getValue$3(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
var _getValue = getValue$3;
var baseIsNative$1 = _baseIsNative, getValue$2 = _getValue;
function getNative$8(object2, key) {
  var value = getValue$2(object2, key);
  return baseIsNative$1(value) ? value : void 0;
}
var _getNative = getNative$8;
var getNative$7 = _getNative, root$8 = _root;
var Map$6 = getNative$7(root$8, "Map");
var _Map = Map$6;
var getNative$6 = _getNative;
var nativeCreate$6 = getNative$6(Object, "create");
var _nativeCreate = nativeCreate$6;
var nativeCreate$5 = _nativeCreate;
function hashClear$2() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$2;
function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$2;
var nativeCreate$4 = _nativeCreate;
var HASH_UNDEFINED$5 = "__lodash_hash_undefined__";
var objectProto$n = Object.prototype;
var hasOwnProperty$m = objectProto$n.hasOwnProperty;
function hashGet$2(key) {
  var data2 = this.__data__;
  if (nativeCreate$4) {
    var result = data2[key];
    return result === HASH_UNDEFINED$5 ? void 0 : result;
  }
  return hasOwnProperty$m.call(data2, key) ? data2[key] : void 0;
}
var _hashGet = hashGet$2;
var nativeCreate$3 = _nativeCreate;
var objectProto$m = Object.prototype;
var hasOwnProperty$l = objectProto$m.hasOwnProperty;
function hashHas$2(key) {
  var data2 = this.__data__;
  return nativeCreate$3 ? data2[key] !== void 0 : hasOwnProperty$l.call(data2, key);
}
var _hashHas = hashHas$2;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$4 = "__lodash_hash_undefined__";
function hashSet$2(key, value) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate$2 && value === void 0 ? HASH_UNDEFINED$4 : value;
  return this;
}
var _hashSet = hashSet$2;
var hashClear$1 = _hashClear, hashDelete$1 = _hashDelete, hashGet$1 = _hashGet, hashHas$1 = _hashHas, hashSet$1 = _hashSet;
function Hash$2(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype["delete"] = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;
var _Hash = Hash$2;
var Hash$1 = _Hash, ListCache$3 = _ListCache, Map$5 = _Map;
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash$1(),
    "map": new (Map$5 || ListCache$3)(),
    "string": new Hash$1()
  };
}
var _mapCacheClear = mapCacheClear$2;
function isKeyable$2(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$2;
var isKeyable$1 = _isKeyable;
function getMapData$5(map5, key) {
  var data2 = map5.__data__;
  return isKeyable$1(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
var _getMapData = getMapData$5;
var getMapData$4 = _getMapData;
function mapCacheDelete$2(key) {
  var result = getMapData$4(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$2;
var getMapData$3 = _getMapData;
function mapCacheGet$2(key) {
  return getMapData$3(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$2;
var getMapData$2 = _getMapData;
function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$2;
var getMapData$1 = _getMapData;
function mapCacheSet$2(key, value) {
  var data2 = getMapData$1(this, key), size12 = data2.size;
  data2.set(key, value);
  this.size += data2.size == size12 ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$2;
var mapCacheClear$1 = _mapCacheClear, mapCacheDelete$1 = _mapCacheDelete, mapCacheGet$1 = _mapCacheGet, mapCacheHas$1 = _mapCacheHas, mapCacheSet$1 = _mapCacheSet;
function MapCache$4(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype["delete"] = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;
var _MapCache = MapCache$4;
var ListCache$2 = _ListCache, Map$4 = _Map, MapCache$3 = _MapCache;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$2(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache$2) {
    var pairs2 = data2.__data__;
    if (!Map$4 || pairs2.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs2.push([key, value]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache$3(pairs2);
  }
  data2.set(key, value);
  this.size = data2.size;
  return this;
}
var _stackSet = stackSet$2;
var ListCache$1 = _ListCache, stackClear$1 = _stackClear, stackDelete$1 = _stackDelete, stackGet$1 = _stackGet, stackHas$1 = _stackHas, stackSet$1 = _stackSet;
function Stack$4(entries) {
  var data2 = this.__data__ = new ListCache$1(entries);
  this.size = data2.size;
}
Stack$4.prototype.clear = stackClear$1;
Stack$4.prototype["delete"] = stackDelete$1;
Stack$4.prototype.get = stackGet$1;
Stack$4.prototype.has = stackHas$1;
Stack$4.prototype.set = stackSet$1;
var _Stack = Stack$4;
var HASH_UNDEFINED$3 = "__lodash_hash_undefined__";
function setCacheAdd$2(value) {
  this.__data__.set(value, HASH_UNDEFINED$3);
  return this;
}
var _setCacheAdd = setCacheAdd$2;
function setCacheHas$2(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$2;
var MapCache$2 = _MapCache, setCacheAdd$1 = _setCacheAdd, setCacheHas$1 = _setCacheHas;
function SetCache$2(values4) {
  var index2 = -1, length2 = values4 == null ? 0 : values4.length;
  this.__data__ = new MapCache$2();
  while (++index2 < length2) {
    this.add(values4[index2]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd$1;
SetCache$2.prototype.has = setCacheHas$1;
var _SetCache = SetCache$2;
function arraySome$2(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$2;
function cacheHas$2(cache2, key) {
  return cache2.has(key);
}
var _cacheHas = cacheHas$2;
var SetCache$1 = _SetCache, arraySome$1 = _arraySome, cacheHas$1 = _cacheHas;
var COMPARE_PARTIAL_FLAG$b = 1, COMPARE_UNORDERED_FLAG$7 = 2;
function equalArrays$3(array2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$b, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack2.get(array2);
  var othStacked = stack2.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$7 ? new SetCache$1() : void 0;
  stack2.set(array2, other);
  stack2.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack2) : customizer(arrValue, othValue, index2, array2, other, stack2);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome$1(other, function(othValue2, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
      result = false;
      break;
    }
  }
  stack2["delete"](array2);
  stack2["delete"](other);
  return result;
}
var _equalArrays = equalArrays$3;
var root$7 = _root;
var Uint8Array$5 = root$7.Uint8Array;
var _Uint8Array = Uint8Array$5;
function mapToArray$2(map5) {
  var index2 = -1, result = Array(map5.size);
  map5.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$2;
function setToArray$2(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$2;
var Symbol$5 = _Symbol, Uint8Array$4 = _Uint8Array, eq$2 = eq_1, equalArrays$2 = _equalArrays, mapToArray$1 = _mapToArray, setToArray$1 = _setToArray;
var COMPARE_PARTIAL_FLAG$a = 1, COMPARE_UNORDERED_FLAG$6 = 2;
var boolTag$4 = "[object Boolean]", dateTag$4 = "[object Date]", errorTag$3 = "[object Error]", mapTag$7 = "[object Map]", numberTag$4 = "[object Number]", regexpTag$4 = "[object RegExp]", setTag$7 = "[object Set]", stringTag$4 = "[object String]", symbolTag$6 = "[object Symbol]";
var arrayBufferTag$4 = "[object ArrayBuffer]", dataViewTag$6 = "[object DataView]";
var symbolProto$4 = Symbol$5 ? Symbol$5.prototype : void 0, symbolValueOf$2 = symbolProto$4 ? symbolProto$4.valueOf : void 0;
function equalByTag$2(object2, other, tag2, bitmask, customizer, equalFunc, stack2) {
  switch (tag2) {
    case dataViewTag$6:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag$4:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$4(object2), new Uint8Array$4(other))) {
        return false;
      }
      return true;
    case boolTag$4:
    case dateTag$4:
    case numberTag$4:
      return eq$2(+object2, +other);
    case errorTag$3:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$4:
    case stringTag$4:
      return object2 == other + "";
    case mapTag$7:
      var convert = mapToArray$1;
    case setTag$7:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$a;
      convert || (convert = setToArray$1);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack2.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$6;
      stack2.set(object2, other);
      var result = equalArrays$2(convert(object2), convert(other), bitmask, customizer, equalFunc, stack2);
      stack2["delete"](object2);
      return result;
    case symbolTag$6:
      if (symbolValueOf$2) {
        return symbolValueOf$2.call(object2) == symbolValueOf$2.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$2;
function arrayPush$3(array2, values4) {
  var index2 = -1, length2 = values4.length, offset = array2.length;
  while (++index2 < length2) {
    array2[offset + index2] = values4[index2];
  }
  return array2;
}
var _arrayPush = arrayPush$3;
var arrayPush$2 = _arrayPush, isArray$e = isArray_1;
function baseGetAllKeys$3(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$e(object2) ? result : arrayPush$2(result, symbolsFunc(object2));
}
var _baseGetAllKeys = baseGetAllKeys$3;
function arrayFilter$2(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array2[index2];
    if (predicate(value, index2, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$2;
function stubArray$3() {
  return [];
}
var stubArray_1 = stubArray$3;
var arrayFilter$1 = _arrayFilter, stubArray$2 = stubArray_1;
var objectProto$l = Object.prototype;
var propertyIsEnumerable$2 = objectProto$l.propertyIsEnumerable;
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;
var getSymbols$5 = !nativeGetSymbols$2 ? stubArray$2 : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter$1(nativeGetSymbols$2(object2), function(symbol) {
    return propertyIsEnumerable$2.call(object2, symbol);
  });
};
var _getSymbols = getSymbols$5;
var baseGetAllKeys$2 = _baseGetAllKeys, getSymbols$4 = _getSymbols, keys$4 = keys_1;
function getAllKeys$3(object2) {
  return baseGetAllKeys$2(object2, keys$4, getSymbols$4);
}
var _getAllKeys = getAllKeys$3;
var getAllKeys$2 = _getAllKeys;
var COMPARE_PARTIAL_FLAG$9 = 1;
var objectProto$k = Object.prototype;
var hasOwnProperty$k = objectProto$k.hasOwnProperty;
function equalObjects$2(object2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$9, objProps = getAllKeys$2(object2), objLength = objProps.length, othProps = getAllKeys$2(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$k.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack2.get(object2);
  var othStacked = stack2.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack2.set(object2, other);
  stack2.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack2) : customizer(objValue, othValue, key, object2, other, stack2);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack2["delete"](object2);
  stack2["delete"](other);
  return result;
}
var _equalObjects = equalObjects$2;
var getNative$5 = _getNative, root$6 = _root;
var DataView$4 = getNative$5(root$6, "DataView");
var _DataView = DataView$4;
var getNative$4 = _getNative, root$5 = _root;
var Promise$4 = getNative$4(root$5, "Promise");
var _Promise = Promise$4;
var getNative$3 = _getNative, root$4 = _root;
var Set$4 = getNative$3(root$4, "Set");
var _Set = Set$4;
var getNative$2 = _getNative, root$3 = _root;
var WeakMap$4 = getNative$2(root$3, "WeakMap");
var _WeakMap = WeakMap$4;
var DataView$3 = _DataView, Map$3 = _Map, Promise$3 = _Promise, Set$3 = _Set, WeakMap$3 = _WeakMap, baseGetTag$2 = _baseGetTag, toSource$1 = _toSource;
var mapTag$6 = "[object Map]", objectTag$6 = "[object Object]", promiseTag$1 = "[object Promise]", setTag$6 = "[object Set]", weakMapTag$3 = "[object WeakMap]";
var dataViewTag$5 = "[object DataView]";
var dataViewCtorString$1 = toSource$1(DataView$3), mapCtorString$1 = toSource$1(Map$3), promiseCtorString$1 = toSource$1(Promise$3), setCtorString$1 = toSource$1(Set$3), weakMapCtorString$1 = toSource$1(WeakMap$3);
var getTag$6 = baseGetTag$2;
if (DataView$3 && getTag$6(new DataView$3(new ArrayBuffer(1))) != dataViewTag$5 || Map$3 && getTag$6(new Map$3()) != mapTag$6 || Promise$3 && getTag$6(Promise$3.resolve()) != promiseTag$1 || Set$3 && getTag$6(new Set$3()) != setTag$6 || WeakMap$3 && getTag$6(new WeakMap$3()) != weakMapTag$3) {
  getTag$6 = function(value) {
    var result = baseGetTag$2(value), Ctor = result == objectTag$6 ? value.constructor : void 0, ctorString = Ctor ? toSource$1(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$5;
        case mapCtorString$1:
          return mapTag$6;
        case promiseCtorString$1:
          return promiseTag$1;
        case setCtorString$1:
          return setTag$6;
        case weakMapCtorString$1:
          return weakMapTag$3;
      }
    }
    return result;
  };
}
var _getTag = getTag$6;
var Stack$3 = _Stack, equalArrays$1 = _equalArrays, equalByTag$1 = _equalByTag, equalObjects$1 = _equalObjects, getTag$5 = _getTag, isArray$d = isArray_1, isBuffer$5 = isBufferExports, isTypedArray$3 = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$8 = 1;
var argsTag$4 = "[object Arguments]", arrayTag$3 = "[object Array]", objectTag$5 = "[object Object]";
var objectProto$j = Object.prototype;
var hasOwnProperty$j = objectProto$j.hasOwnProperty;
function baseIsEqualDeep$2(object2, other, bitmask, customizer, equalFunc, stack2) {
  var objIsArr = isArray$d(object2), othIsArr = isArray$d(other), objTag = objIsArr ? arrayTag$3 : getTag$5(object2), othTag = othIsArr ? arrayTag$3 : getTag$5(other);
  objTag = objTag == argsTag$4 ? objectTag$5 : objTag;
  othTag = othTag == argsTag$4 ? objectTag$5 : othTag;
  var objIsObj = objTag == objectTag$5, othIsObj = othTag == objectTag$5, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$5(object2)) {
    if (!isBuffer$5(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack2 || (stack2 = new Stack$3());
    return objIsArr || isTypedArray$3(object2) ? equalArrays$1(object2, other, bitmask, customizer, equalFunc, stack2) : equalByTag$1(object2, other, objTag, bitmask, customizer, equalFunc, stack2);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$8)) {
    var objIsWrapped = objIsObj && hasOwnProperty$j.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$j.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack2 || (stack2 = new Stack$3());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack2 || (stack2 = new Stack$3());
  return equalObjects$1(object2, other, bitmask, customizer, equalFunc, stack2);
}
var _baseIsEqualDeep = baseIsEqualDeep$2;
var baseIsEqualDeep$1 = _baseIsEqualDeep, isObjectLike$5 = isObjectLike_1;
function baseIsEqual$3(value, other, bitmask, customizer, stack2) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$5(value) && !isObjectLike$5(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep$1(value, other, bitmask, customizer, baseIsEqual$3, stack2);
}
var _baseIsEqual = baseIsEqual$3;
var Stack$2 = _Stack, baseIsEqual$2 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$7 = 1, COMPARE_UNORDERED_FLAG$5 = 2;
function baseIsMatch$2(object2, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
  if (object2 == null) {
    return !length2;
  }
  object2 = Object(object2);
  while (index2--) {
    var data2 = matchData[index2];
    if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack2 = new Stack$2();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object2, source, stack2);
      }
      if (!(result === void 0 ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, customizer, stack2) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$2;
var isObject$g = isObject_1;
function isStrictComparable$3(value) {
  return value === value && !isObject$g(value);
}
var _isStrictComparable = isStrictComparable$3;
var isStrictComparable$2 = _isStrictComparable, keys$3 = keys_1;
function getMatchData$2(object2) {
  var result = keys$3(object2), length2 = result.length;
  while (length2--) {
    var key = result[length2], value = object2[key];
    result[length2] = [key, value, isStrictComparable$2(value)];
  }
  return result;
}
var _getMatchData = getMatchData$2;
function matchesStrictComparable$3(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
var _matchesStrictComparable = matchesStrictComparable$3;
var baseIsMatch$1 = _baseIsMatch, getMatchData$1 = _getMatchData, matchesStrictComparable$2 = _matchesStrictComparable;
function baseMatches$2(source) {
  var matchData = getMatchData$1(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$2(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch$1(object2, source, matchData);
  };
}
var _baseMatches = baseMatches$2;
var baseGetTag$1 = _baseGetTag, isObjectLike$4 = isObjectLike_1;
var symbolTag$5 = "[object Symbol]";
function isSymbol$5(value) {
  return typeof value == "symbol" || isObjectLike$4(value) && baseGetTag$1(value) == symbolTag$5;
}
var isSymbol_1 = isSymbol$5;
var isArray$c = isArray_1, isSymbol$4 = isSymbol_1;
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp$1 = /^\w*$/;
function isKey$4(value, object2) {
  if (isArray$c(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object2 != null && value in Object(object2);
}
var _isKey = isKey$4;
var MapCache$1 = _MapCache;
var FUNC_ERROR_TEXT$4 = "Expected a function";
function memoize$4(func2, resolver) {
  if (typeof func2 != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$4);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func2.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$4.Cache || MapCache$1)();
  return memoized;
}
memoize$4.Cache = MapCache$1;
var memoize_1 = memoize$4;
var memoize$3 = memoize_1;
var MAX_MEMOIZE_SIZE$1 = 500;
function memoizeCapped$2(func2) {
  var result = memoize$3(func2, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE$1) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$2;
var memoizeCapped$1 = _memoizeCapped;
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$3 = memoizeCapped$1(function(string3) {
  var result = [];
  if (string3.charCodeAt(0) === 46) {
    result.push("");
  }
  string3.replace(rePropName$1, function(match2, number2, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, "$1") : number2 || match2);
  });
  return result;
});
var _stringToPath = stringToPath$3;
var Symbol$4 = _Symbol, arrayMap$2 = _arrayMap, isArray$b = isArray_1, isSymbol$3 = isSymbol_1;
var INFINITY$3 = 1 / 0;
var symbolProto$3 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : void 0;
function baseToString$2(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$b(value)) {
    return arrayMap$2(value, baseToString$2) + "";
  }
  if (isSymbol$3(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$3 ? "-0" : result;
}
var _baseToString = baseToString$2;
var baseToString$1 = _baseToString;
function toString$3(value) {
  return value == null ? "" : baseToString$1(value);
}
var toString_1 = toString$3;
var isArray$a = isArray_1, isKey$3 = _isKey, stringToPath$2 = _stringToPath, toString$2 = toString_1;
function castPath$3(value, object2) {
  if (isArray$a(value)) {
    return value;
  }
  return isKey$3(value, object2) ? [value] : stringToPath$2(toString$2(value));
}
var _castPath = castPath$3;
var isSymbol$2 = isSymbol_1;
var INFINITY$2 = 1 / 0;
function toKey$5(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
var _toKey = toKey$5;
var castPath$2 = _castPath, toKey$4 = _toKey;
function baseGet$3(object2, path2) {
  path2 = castPath$2(path2, object2);
  var index2 = 0, length2 = path2.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey$4(path2[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
var _baseGet = baseGet$3;
var baseGet$2 = _baseGet;
function get$3(object2, path2, defaultValue2) {
  var result = object2 == null ? void 0 : baseGet$2(object2, path2);
  return result === void 0 ? defaultValue2 : result;
}
var get_1 = get$3;
function baseHasIn$2(object2, key) {
  return object2 != null && key in Object(object2);
}
var _baseHasIn = baseHasIn$2;
var castPath$1 = _castPath, isArguments$2 = isArguments_1, isArray$9 = isArray_1, isIndex$2 = _isIndex, isLength$1 = isLength_1, toKey$3 = _toKey;
function hasPath$2(object2, path2, hasFunc) {
  path2 = castPath$1(path2, object2);
  var index2 = -1, length2 = path2.length, result = false;
  while (++index2 < length2) {
    var key = toKey$3(path2[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength$1(length2) && isIndex$2(key, length2) && (isArray$9(object2) || isArguments$2(object2));
}
var _hasPath = hasPath$2;
var baseHasIn$1 = _baseHasIn, hasPath$1 = _hasPath;
function hasIn$2(object2, path2) {
  return object2 != null && hasPath$1(object2, path2, baseHasIn$1);
}
var hasIn_1 = hasIn$2;
var baseIsEqual$1 = _baseIsEqual, get$2 = get_1, hasIn$1 = hasIn_1, isKey$2 = _isKey, isStrictComparable$1 = _isStrictComparable, matchesStrictComparable$1 = _matchesStrictComparable, toKey$2 = _toKey;
var COMPARE_PARTIAL_FLAG$6 = 1, COMPARE_UNORDERED_FLAG$4 = 2;
function baseMatchesProperty$2(path2, srcValue) {
  if (isKey$2(path2) && isStrictComparable$1(srcValue)) {
    return matchesStrictComparable$1(toKey$2(path2), srcValue);
  }
  return function(object2) {
    var objValue = get$2(object2, path2);
    return objValue === void 0 && objValue === srcValue ? hasIn$1(object2, path2) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}
var _baseMatchesProperty = baseMatchesProperty$2;
function baseProperty$2(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
var _baseProperty = baseProperty$2;
var baseGet$1 = _baseGet;
function basePropertyDeep$2(path2) {
  return function(object2) {
    return baseGet$1(object2, path2);
  };
}
var _basePropertyDeep = basePropertyDeep$2;
var baseProperty$1 = _baseProperty, basePropertyDeep$1 = _basePropertyDeep, isKey$1 = _isKey, toKey$1 = _toKey;
function property$2(path2) {
  return isKey$1(path2) ? baseProperty$1(toKey$1(path2)) : basePropertyDeep$1(path2);
}
var property_1 = property$2;
var baseMatches$1 = _baseMatches, baseMatchesProperty$1 = _baseMatchesProperty, identity$5 = identity_1, isArray$8 = isArray_1, property$1 = property_1;
function baseIteratee$2(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$5;
  }
  if (typeof value == "object") {
    return isArray$8(value) ? baseMatchesProperty$1(value[0], value[1]) : baseMatches$1(value);
  }
  return property$1(value);
}
var _baseIteratee = baseIteratee$2;
var isArrayLike$3 = isArrayLike_1;
function createBaseEach$2(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$3(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$2;
var baseForOwn$1 = _baseForOwn, createBaseEach$1 = _createBaseEach;
var baseEach$3 = createBaseEach$1(baseForOwn$1);
var _baseEach = baseEach$3;
var baseEach$2 = _baseEach, isArrayLike$2 = isArrayLike_1;
function baseMap$2(collection, iteratee) {
  var index2 = -1, result = isArrayLike$2(collection) ? Array(collection.length) : [];
  baseEach$2(collection, function(value, key, collection2) {
    result[++index2] = iteratee(value, key, collection2);
  });
  return result;
}
var _baseMap = baseMap$2;
var arrayMap$1 = _arrayMap, baseIteratee$1 = _baseIteratee, baseMap$1 = _baseMap, isArray$7 = isArray_1;
function map$3(collection, iteratee) {
  var func2 = isArray$7(collection) ? arrayMap$1 : baseMap$1;
  return func2(collection, baseIteratee$1(iteratee));
}
var map_1 = map$3;
Object.defineProperty(flattenNames$1, "__esModule", {
  value: true
});
flattenNames$1.flattenNames = void 0;
var _isString2 = isString_1;
var _isString3 = _interopRequireDefault$7(_isString2);
var _forOwn2$2 = forOwn_1;
var _forOwn3$2 = _interopRequireDefault$7(_forOwn2$2);
var _isPlainObject2 = isPlainObject_1;
var _isPlainObject3 = _interopRequireDefault$7(_isPlainObject2);
var _map2 = map_1;
var _map3 = _interopRequireDefault$7(_map2);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var flattenNames = flattenNames$1.flattenNames = function flattenNames2() {
  var things = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var names2 = [];
  (0, _map3.default)(things, function(thing) {
    if (Array.isArray(thing)) {
      flattenNames2(thing).map(function(name2) {
        return names2.push(name2);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3$2.default)(thing, function(value, key) {
        value === true && names2.push(key);
        names2.push(key + "-" + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names2.push(thing);
    }
  });
  return names2;
};
flattenNames$1.default = flattenNames;
var mergeClasses$1 = {};
function arrayEach$2(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (iteratee(array2[index2], index2, array2) === false) {
      break;
    }
  }
  return array2;
}
var _arrayEach = arrayEach$2;
var getNative$1 = _getNative;
var defineProperty$3 = function() {
  try {
    var func2 = getNative$1(Object, "defineProperty");
    func2({}, "", {});
    return func2;
  } catch (e3) {
  }
}();
var _defineProperty$4 = defineProperty$3;
var defineProperty$2 = _defineProperty$4;
function baseAssignValue$3(object2, key, value) {
  if (key == "__proto__" && defineProperty$2) {
    defineProperty$2(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$3;
var baseAssignValue$2 = _baseAssignValue, eq$1 = eq_1;
var objectProto$i = Object.prototype;
var hasOwnProperty$i = objectProto$i.hasOwnProperty;
function assignValue$3(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$i.call(object2, key) && eq$1(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue$2(object2, key, value);
  }
}
var _assignValue = assignValue$3;
var assignValue$2 = _assignValue, baseAssignValue$1 = _baseAssignValue;
function copyObject$5(source, props, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index2 = -1, length2 = props.length;
  while (++index2 < length2) {
    var key = props[index2];
    var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$1(object2, key, newValue);
    } else {
      assignValue$2(object2, key, newValue);
    }
  }
  return object2;
}
var _copyObject = copyObject$5;
var copyObject$4 = _copyObject, keys$2 = keys_1;
function baseAssign$1(object2, source) {
  return object2 && copyObject$4(source, keys$2(source), object2);
}
var _baseAssign = baseAssign$1;
function nativeKeysIn$2(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn$2;
var isObject$f = isObject_1, isPrototype$2 = _isPrototype, nativeKeysIn$1 = _nativeKeysIn;
var objectProto$h = Object.prototype;
var hasOwnProperty$h = objectProto$h.hasOwnProperty;
function baseKeysIn$2(object2) {
  if (!isObject$f(object2)) {
    return nativeKeysIn$1(object2);
  }
  var isProto = isPrototype$2(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$h.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn$2;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeysIn$1 = _baseKeysIn, isArrayLike$1 = isArrayLike_1;
function keysIn$4(object2) {
  return isArrayLike$1(object2) ? arrayLikeKeys$1(object2, true) : baseKeysIn$1(object2);
}
var keysIn_1 = keysIn$4;
var copyObject$3 = _copyObject, keysIn$3 = keysIn_1;
function baseAssignIn$1(object2, source) {
  return object2 && copyObject$3(source, keysIn$3(source), object2);
}
var _baseAssignIn = baseAssignIn$1;
var _cloneBufferExports = {};
var _cloneBuffer = {
  get exports() {
    return _cloneBufferExports;
  },
  set exports(v5) {
    _cloneBufferExports = v5;
  }
};
(function(module2, exports2) {
  var root2 = _root;
  var freeExports2 = exports2 && !exports2.nodeType && exports2;
  var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var Buffer2 = moduleExports2 ? root2.Buffer : void 0, allocUnsafe2 = Buffer2 ? Buffer2.allocUnsafe : void 0;
  function cloneBuffer2(buffer3, isDeep) {
    if (isDeep) {
      return buffer3.slice();
    }
    var length2 = buffer3.length, result = allocUnsafe2 ? allocUnsafe2(length2) : new buffer3.constructor(length2);
    buffer3.copy(result);
    return result;
  }
  module2.exports = cloneBuffer2;
})(_cloneBuffer, _cloneBufferExports);
function copyArray$2(source, array2) {
  var index2 = -1, length2 = source.length;
  array2 || (array2 = Array(length2));
  while (++index2 < length2) {
    array2[index2] = source[index2];
  }
  return array2;
}
var _copyArray = copyArray$2;
var copyObject$2 = _copyObject, getSymbols$3 = _getSymbols;
function copySymbols$1(source, object2) {
  return copyObject$2(source, getSymbols$3(source), object2);
}
var _copySymbols = copySymbols$1;
var arrayPush$1 = _arrayPush, getPrototype$3 = _getPrototype, getSymbols$2 = _getSymbols, stubArray$1 = stubArray_1;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbolsIn$2 = !nativeGetSymbols$1 ? stubArray$1 : function(object2) {
  var result = [];
  while (object2) {
    arrayPush$1(result, getSymbols$2(object2));
    object2 = getPrototype$3(object2);
  }
  return result;
};
var _getSymbolsIn = getSymbolsIn$2;
var copyObject$1 = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
function copySymbolsIn$1(source, object2) {
  return copyObject$1(source, getSymbolsIn$1(source), object2);
}
var _copySymbolsIn = copySymbolsIn$1;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$2 = keysIn_1;
function getAllKeysIn$1(object2) {
  return baseGetAllKeys$1(object2, keysIn$2, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$1;
var objectProto$g = Object.prototype;
var hasOwnProperty$g = objectProto$g.hasOwnProperty;
function initCloneArray$1(array2) {
  var length2 = array2.length, result = new array2.constructor(length2);
  if (length2 && typeof array2[0] == "string" && hasOwnProperty$g.call(array2, "index")) {
    result.index = array2.index;
    result.input = array2.input;
  }
  return result;
}
var _initCloneArray = initCloneArray$1;
var Uint8Array$3 = _Uint8Array;
function cloneArrayBuffer$4(arrayBuffer2) {
  var result = new arrayBuffer2.constructor(arrayBuffer2.byteLength);
  new Uint8Array$3(result).set(new Uint8Array$3(arrayBuffer2));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer$4;
var cloneArrayBuffer$3 = _cloneArrayBuffer;
function cloneDataView$1(dataView, isDeep) {
  var buffer3 = isDeep ? cloneArrayBuffer$3(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer3, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView$1;
var reFlags = /\w*$/;
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var _cloneRegExp = cloneRegExp$1;
var Symbol$3 = _Symbol;
var symbolProto$2 = Symbol$3 ? Symbol$3.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function cloneSymbol$1(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol$1;
var cloneArrayBuffer$2 = _cloneArrayBuffer;
function cloneTypedArray$2(typedArray, isDeep) {
  var buffer3 = isDeep ? cloneArrayBuffer$2(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer3, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$2;
var cloneArrayBuffer$1 = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray$1 = _cloneTypedArray;
var boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", symbolTag$4 = "[object Symbol]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
function initCloneByTag$1(object2, tag2, isDeep) {
  var Ctor = object2.constructor;
  switch (tag2) {
    case arrayBufferTag$3:
      return cloneArrayBuffer$1(object2);
    case boolTag$3:
    case dateTag$3:
      return new Ctor(+object2);
    case dataViewTag$4:
      return cloneDataView(object2, isDeep);
    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray$1(object2, isDeep);
    case mapTag$5:
      return new Ctor();
    case numberTag$3:
    case stringTag$3:
      return new Ctor(object2);
    case regexpTag$3:
      return cloneRegExp(object2);
    case setTag$5:
      return new Ctor();
    case symbolTag$4:
      return cloneSymbol(object2);
  }
}
var _initCloneByTag = initCloneByTag$1;
var isObject$e = isObject_1;
var objectCreate$1 = Object.create;
var baseCreate$3 = function() {
  function object2() {
  }
  return function(proto) {
    if (!isObject$e(proto)) {
      return {};
    }
    if (objectCreate$1) {
      return objectCreate$1(proto);
    }
    object2.prototype = proto;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
}();
var _baseCreate = baseCreate$3;
var baseCreate$2 = _baseCreate, getPrototype$2 = _getPrototype, isPrototype$1 = _isPrototype;
function initCloneObject$2(object2) {
  return typeof object2.constructor == "function" && !isPrototype$1(object2) ? baseCreate$2(getPrototype$2(object2)) : {};
}
var _initCloneObject = initCloneObject$2;
var getTag$4 = _getTag, isObjectLike$3 = isObjectLike_1;
var mapTag$4 = "[object Map]";
function baseIsMap$1(value) {
  return isObjectLike$3(value) && getTag$4(value) == mapTag$4;
}
var _baseIsMap = baseIsMap$1;
var baseIsMap = _baseIsMap, baseUnary$2 = _baseUnary, nodeUtil$3 = _nodeUtilExports;
var nodeIsMap = nodeUtil$3 && nodeUtil$3.isMap;
var isMap$1 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;
var isMap_1 = isMap$1;
var getTag$3 = _getTag, isObjectLike$2 = isObjectLike_1;
var setTag$4 = "[object Set]";
function baseIsSet$1(value) {
  return isObjectLike$2(value) && getTag$3(value) == setTag$4;
}
var _baseIsSet = baseIsSet$1;
var baseIsSet = _baseIsSet, baseUnary$1 = _baseUnary, nodeUtil$2 = _nodeUtilExports;
var nodeIsSet = nodeUtil$2 && nodeUtil$2.isSet;
var isSet$1 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;
var isSet_1 = isSet$1;
var Stack$1 = _Stack, arrayEach$1 = _arrayEach, assignValue$1 = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer$1 = _cloneBufferExports, copyArray$1 = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys$1 = _getAllKeys, getAllKeysIn = _getAllKeysIn, getTag$2 = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject$1 = _initCloneObject, isArray$6 = isArray_1, isBuffer$4 = isBufferExports, isMap = isMap_1, isObject$d = isObject_1, isSet = isSet_1, keys$1 = keys_1, keysIn$1 = keysIn_1;
var CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4;
var argsTag$3 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$2 = "[object Error]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$3 = "[object Symbol]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] = cloneableTags[numberTag$2] = cloneableTags[objectTag$4] = cloneableTags[regexpTag$2] = cloneableTags[setTag$3] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$2] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;
function baseClone$1(value, bitmask, customizer, key, object2, stack2) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$1, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object2 ? customizer(value, key, object2, stack2) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject$d(value)) {
    return value;
  }
  var isArr = isArray$6(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag2 = getTag$2(value), isFunc = tag2 == funcTag$2 || tag2 == genTag$1;
    if (isBuffer$4(value)) {
      return cloneBuffer$1(value, isDeep);
    }
    if (tag2 == objectTag$4 || tag2 == argsTag$3 || isFunc && !object2) {
      result = isFlat || isFunc ? {} : initCloneObject$1(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag2]) {
        return object2 ? value : {};
      }
      result = initCloneByTag(value, tag2, isDeep);
    }
  }
  stack2 || (stack2 = new Stack$1());
  var stacked = stack2.get(value);
  if (stacked) {
    return stacked;
  }
  stack2.set(value, result);
  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack2));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone$1(subValue, bitmask, customizer, key2, value, stack2));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys$1 : isFlat ? keysIn$1 : keys$1;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach$1(props || value, function(subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue$1(result, key2, baseClone$1(subValue, bitmask, customizer, key2, value, stack2));
  });
  return result;
}
var _baseClone = baseClone$1;
var baseClone = _baseClone;
var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var cloneDeep_1 = cloneDeep;
Object.defineProperty(mergeClasses$1, "__esModule", {
  value: true
});
mergeClasses$1.mergeClasses = void 0;
var _forOwn2$1 = forOwn_1;
var _forOwn3$1 = _interopRequireDefault$6(_forOwn2$1);
var _cloneDeep2 = cloneDeep_1;
var _cloneDeep3 = _interopRequireDefault$6(_cloneDeep2);
var _extends$g = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var mergeClasses = mergeClasses$1.mergeClasses = function mergeClasses2(classes2) {
  var activeNames = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var styles2 = classes2.default && (0, _cloneDeep3.default)(classes2.default) || {};
  activeNames.map(function(name2) {
    var toMerge = classes2[name2];
    if (toMerge) {
      (0, _forOwn3$1.default)(toMerge, function(value, key) {
        if (!styles2[key]) {
          styles2[key] = {};
        }
        styles2[key] = _extends$g({}, styles2[key], toMerge[key]);
      });
    }
    return name2;
  });
  return styles2;
};
mergeClasses$1.default = mergeClasses;
var autoprefix$1 = {};
Object.defineProperty(autoprefix$1, "__esModule", {
  value: true
});
autoprefix$1.autoprefix = void 0;
var _forOwn2 = forOwn_1;
var _forOwn3 = _interopRequireDefault$5(_forOwn2);
var _extends$f = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },
  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },
  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },
  transform: function transform3(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(" ");
    return {
      position: "absolute",
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend3(name2, otherElementStyles) {
    var otherStyle = otherElementStyles[name2];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      "extend": name2
    };
  }
};
var autoprefix = autoprefix$1.autoprefix = function autoprefix2(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function(styles2, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles2, function(value, key) {
      var transform4 = transforms[key];
      if (transform4) {
        expanded = _extends$f({}, expanded, transform4(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};
autoprefix$1.default = autoprefix;
var hover$1 = {};
Object.defineProperty(hover$1, "__esModule", {
  value: true
});
hover$1.hover = void 0;
var _extends$e = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$3 = React__default;
var _react2$3 = _interopRequireDefault$4(_react$3);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck$b(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$a(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$a(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var hover = hover$1.hover = function hover2(Component2) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(_React$Component) {
    _inherits$a(Hover, _React$Component);
    function Hover() {
      var _ref2;
      var _temp, _this, _ret;
      _classCallCheck$b(this, Hover);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$a(this, (_ref2 = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function() {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function() {
        return _this.setState({ hover: false });
      }, _this.render = function() {
        return _react2$3.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2$3.default.createElement(Component2, _extends$e({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$a(_this, _ret);
    }
    return Hover;
  }(_react2$3.default.Component);
};
hover$1.default = hover;
var active$1 = {};
Object.defineProperty(active$1, "__esModule", {
  value: true
});
active$1.active = void 0;
var _extends$d = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$2 = React__default;
var _react2$2 = _interopRequireDefault$3(_react$2);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck$a(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$9(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$9(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var active = active$1.active = function active2(Component2) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(_React$Component) {
    _inherits$9(Active, _React$Component);
    function Active() {
      var _ref2;
      var _temp, _this, _ret;
      _classCallCheck$a(this, Active);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$9(this, (_ref2 = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function() {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function() {
        return _this.setState({ active: false });
      }, _this.render = function() {
        return _react2$2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2$2.default.createElement(Component2, _extends$d({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$9(_this, _ret);
    }
    return Active;
  }(_react2$2.default.Component);
};
active$1.default = active;
var loop = {};
Object.defineProperty(loop, "__esModule", {
  value: true
});
var loopable = function loopable2(i2, length2) {
  var props = {};
  var setProp = function setProp2(name2) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    props[name2] = value;
  };
  i2 === 0 && setProp("first-child");
  i2 === length2 - 1 && setProp("last-child");
  (i2 === 0 || i2 % 2 === 0) && setProp("even");
  Math.abs(i2 % 2) === 1 && setProp("odd");
  setProp("nth-child", i2);
  return props;
};
loop.default = loopable;
Object.defineProperty(lib$4, "__esModule", {
  value: true
});
lib$4.ReactCSS = lib$4.loop = lib$4.handleActive = handleHover = lib$4.handleHover = lib$4.hover = void 0;
var _flattenNames = flattenNames$1;
var _flattenNames2 = _interopRequireDefault$2(_flattenNames);
var _mergeClasses = mergeClasses$1;
var _mergeClasses2 = _interopRequireDefault$2(_mergeClasses);
var _autoprefix = autoprefix$1;
var _autoprefix2 = _interopRequireDefault$2(_autoprefix);
var _hover2 = hover$1;
var _hover3 = _interopRequireDefault$2(_hover2);
var _active = active$1;
var _active2 = _interopRequireDefault$2(_active);
var _loop2 = loop;
var _loop3 = _interopRequireDefault$2(_loop2);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
lib$4.hover = _hover3.default;
var handleHover = lib$4.handleHover = _hover3.default;
lib$4.handleActive = _active2.default;
lib$4.loop = _loop3.default;
var ReactCSS = lib$4.ReactCSS = function ReactCSS2(classes2) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }
  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes2, activeNames);
  return (0, _autoprefix2.default)(merged);
};
var _default$3 = lib$4.default = ReactCSS;
var calculateChange$2 = function calculateChange2(e3, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x2 = typeof e3.pageX === "number" ? e3.pageX : e3.touches[0].pageX;
  var y2 = typeof e3.pageY === "number" ? e3.pageY : e3.touches[0].pageY;
  var left = x2 - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y2 - (container.getBoundingClientRect().top + window.pageYOffset);
  if (direction === "vertical") {
    var a2 = void 0;
    if (top < 0) {
      a2 = 0;
    } else if (top > containerHeight) {
      a2 = 1;
    } else {
      a2 = Math.round(top * 100 / containerHeight) / 100;
    }
    if (hsl.a !== a2) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a2,
        source: "rgb"
      };
    }
  } else {
    var _a3 = void 0;
    if (left < 0) {
      _a3 = 0;
    } else if (left > containerWidth) {
      _a3 = 1;
    } else {
      _a3 = Math.round(left * 100 / containerWidth) / 100;
    }
    if (initialA !== _a3) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a3,
        source: "rgb"
      };
    }
  }
  return null;
};
var checkboardCache = {};
var render$5 = function render2(c1, c2, size12, serverCanvas) {
  if (typeof document === "undefined" && !serverCanvas) {
    return null;
  }
  var canvas2 = serverCanvas ? new serverCanvas() : document.createElement("canvas");
  canvas2.width = size12 * 2;
  canvas2.height = size12 * 2;
  var ctx2 = canvas2.getContext("2d");
  if (!ctx2) {
    return null;
  }
  ctx2.fillStyle = c1;
  ctx2.fillRect(0, 0, canvas2.width, canvas2.height);
  ctx2.fillStyle = c2;
  ctx2.fillRect(0, 0, size12, size12);
  ctx2.translate(size12, size12);
  ctx2.fillRect(0, 0, size12, size12);
  return canvas2.toDataURL();
};
var get$1 = function get5(c1, c2, size12, serverCanvas) {
  var key = c1 + "-" + c2 + "-" + size12 + (serverCanvas ? "-server" : "");
  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  var checkboard = render$5(c1, c2, size12, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};
var _extends$c = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var Checkboard = function Checkboard2(_ref2) {
  var white = _ref2.white, grey = _ref2.grey, size12 = _ref2.size, renderers = _ref2.renderers, borderRadius2 = _ref2.borderRadius, boxShadow2 = _ref2.boxShadow, children = _ref2.children;
  var styles2 = _default$3({
    "default": {
      grid: {
        borderRadius: borderRadius2,
        boxShadow: boxShadow2,
        absolute: "0px 0px 0px 0px",
        background: "url(" + get$1(white, grey, size12, renderers.canvas) + ") center left"
      }
    }
  });
  return isValidElement(children) ? React__default.cloneElement(children, _extends$c({}, children.props, { style: _extends$c({}, children.props.style, styles2.grid) })) : React__default.createElement("div", { style: styles2.grid });
};
Checkboard.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var _extends$b = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$9 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$9(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$8(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$8(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Alpha$2 = function(_ref2) {
  _inherits$8(Alpha2, _ref2);
  function Alpha2() {
    var _ref22;
    var _temp, _this, _ret;
    _classCallCheck$9(this, Alpha2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$8(this, (_ref22 = Alpha2.__proto__ || Object.getPrototypeOf(Alpha2)).call.apply(_ref22, [this].concat(args))), _this), _this.handleChange = function(e3) {
      var change3 = calculateChange$2(e3, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change3 && typeof _this.props.onChange === "function" && _this.props.onChange(change3, e3);
    }, _this.handleMouseDown = function(e3) {
      _this.handleChange(e3);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleChange);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$8(_this, _ret);
  }
  _createClass$9(Alpha2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function render5() {
      var _this2 = this;
      var rgb = this.props.rgb;
      var styles2 = _default$3({
        "default": {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: rgb.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + "%"
          }
        },
        "overwrite": _extends$b({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: true
      });
      return React__default.createElement(
        "div",
        { style: styles2.alpha },
        React__default.createElement(
          "div",
          { style: styles2.checkboard },
          React__default.createElement(Checkboard, { renderers: this.props.renderers })
        ),
        React__default.createElement("div", { style: styles2.gradient }),
        React__default.createElement(
          "div",
          {
            style: styles2.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "div",
            { style: styles2.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: styles2.slider })
          )
        )
      );
    }
  }]);
  return Alpha2;
}(PureComponent || Component$1);
var _createClass$8 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck$8(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$7(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$7(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var DEFAULT_ARROW_OFFSET = 1;
var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode2(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue2(value) {
  return Number(String(value).replace(/%/g, ""));
};
var idCounter = 1;
var EditableInput = function(_ref2) {
  _inherits$7(EditableInput2, _ref2);
  function EditableInput2(props) {
    _classCallCheck$8(this, EditableInput2);
    var _this = _possibleConstructorReturn$7(this, (EditableInput2.__proto__ || Object.getPrototypeOf(EditableInput2)).call(this));
    _this.handleBlur = function() {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };
    _this.handleChange = function(e3) {
      _this.setUpdatedValue(e3.target.value, e3);
    };
    _this.handleKeyDown = function(e3) {
      var value = getNumberValue(e3.target.value);
      if (!isNaN(value) && isValidKeyCode(e3.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e3.keyCode === UP_KEY_CODE ? value + offset : value - offset;
        _this.setUpdatedValue(updatedValue, e3);
      }
    };
    _this.handleDrag = function(e3) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e3.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e3);
        }
      }
    };
    _this.handleMouseDown = function(e3) {
      if (_this.props.dragLabel) {
        e3.preventDefault();
        _this.handleDrag(e3);
        window.addEventListener("mousemove", _this.handleDrag);
        window.addEventListener("mouseup", _this.handleMouseUp);
      }
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.unbindEventListeners = function() {
      window.removeEventListener("mousemove", _this.handleDrag);
      window.removeEventListener("mouseup", _this.handleMouseUp);
    };
    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    _this.inputId = "rc-editable-input-" + idCounter++;
    return _this;
  }
  _createClass$8(EditableInput2, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function getValueObjectWithLabel(value) {
      return _defineProperty$3({}, this.props.label, value);
    }
  }, {
    key: "getArrowOffset",
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: "setUpdatedValue",
    value: function setUpdatedValue(value, e3) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e3);
      this.setState({ value });
    }
  }, {
    key: "render",
    value: function render5() {
      var _this2 = this;
      var styles2 = _default$3({
        "default": {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": true
      }, this.props);
      return React__default.createElement(
        "div",
        { style: styles2.wrap },
        React__default.createElement("input", {
          id: this.inputId,
          style: styles2.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? React__default.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: styles2.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);
  return EditableInput2;
}(PureComponent || Component$1);
var calculateChange$1 = function calculateChange3(e3, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x2 = typeof e3.pageX === "number" ? e3.pageX : e3.touches[0].pageX;
  var y2 = typeof e3.pageY === "number" ? e3.pageY : e3.touches[0].pageY;
  var left = x2 - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y2 - (container.getBoundingClientRect().top + window.pageYOffset);
  if (direction === "vertical") {
    var h2 = void 0;
    if (top < 0) {
      h2 = 359;
    } else if (top > containerHeight) {
      h2 = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h2 = 360 * percent / 100;
    }
    if (hsl.h !== h2) {
      return {
        h: h2,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: "hsl"
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }
    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: "hsl"
      };
    }
  }
  return null;
};
var _createClass$7 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$7(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$6(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$6(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Hue = function(_ref2) {
  _inherits$6(Hue2, _ref2);
  function Hue2() {
    var _ref22;
    var _temp, _this, _ret;
    _classCallCheck$7(this, Hue2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn$6(this, (_ref22 = Hue2.__proto__ || Object.getPrototypeOf(Hue2)).call.apply(_ref22, [this].concat(args))), _this), _this.handleChange = function(e3) {
      var change3 = calculateChange$1(e3, _this.props.direction, _this.props.hsl, _this.container);
      change3 && typeof _this.props.onChange === "function" && _this.props.onChange(change3, e3);
    }, _this.handleMouseDown = function(e3) {
      _this.handleChange(e3);
      window.addEventListener("mousemove", _this.handleChange);
      window.addEventListener("mouseup", _this.handleMouseUp);
    }, _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$6(_this, _ret);
  }
  _createClass$7(Hue2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      window.removeEventListener("mousemove", this.handleChange);
      window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render5() {
      var _this2 = this;
      var _props$direction = this.props.direction, direction = _props$direction === void 0 ? "horizontal" : _props$direction;
      var styles2 = _default$3({
        "default": {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        "vertical": {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: direction === "vertical" });
      return React__default.createElement(
        "div",
        { style: styles2.hue },
        React__default.createElement(
          "div",
          {
            className: "hue-" + direction,
            style: styles2.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "style",
            null,
            "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "
          ),
          React__default.createElement(
            "div",
            { style: styles2.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: styles2.slider })
          )
        )
      );
    }
  }]);
  return Hue2;
}(PureComponent || Component$1);
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
function assocIndexOf(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    ++this.size;
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data2 = this.__data__, result = data2["delete"](key);
  this.size = data2.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
var freeGlobal$1 = typeof global == "object" && global && global.Object === Object && global;
const freeGlobal$2 = freeGlobal$1;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal$2 || freeSelf$1 || Function("return this")();
const root$2 = root$1;
var Symbol$1 = root$2.Symbol;
const Symbol$2 = Symbol$1;
var objectProto$f = Object.prototype;
var hasOwnProperty$f = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$f.call(value, symToStringTag$1), tag2 = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag2;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
}
function isObject$c(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$c(value)) {
    return false;
  }
  var tag2 = baseGetTag(value);
  return tag2 == funcTag$1 || tag2 == genTag || tag2 == asyncTag || tag2 == proxyTag;
}
var coreJsData = root$2["__core-js_shared__"];
const coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid2 = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid2 ? "Symbol(src)_1." + uid2 : "";
}();
function isMasked(func2) {
  return !!maskSrcKey && maskSrcKey in func2;
}
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource(func2) {
  if (func2 != null) {
    try {
      return funcToString$2.call(func2);
    } catch (e3) {
    }
    try {
      return func2 + "";
    } catch (e3) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$d = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$e = objectProto$d.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$e).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject$c(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue$1(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
  var value = getValue$1(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var Map$1 = getNative(root$2, "Map");
const Map$2 = Map$1;
var nativeCreate = getNative(Object, "create");
const nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$c = Object.prototype;
var hasOwnProperty$d = objectProto$c.hasOwnProperty;
function hashGet(key) {
  var data2 = this.__data__;
  if (nativeCreate$1) {
    var result = data2[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$d.call(data2, key) ? data2[key] : void 0;
}
var objectProto$b = Object.prototype;
var hasOwnProperty$c = objectProto$b.hasOwnProperty;
function hashHas(key) {
  var data2 = this.__data__;
  return nativeCreate$1 ? data2[key] !== void 0 : hasOwnProperty$c.call(data2, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map5, key) {
  var data2 = map5.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data2 = getMapData(this, key), size12 = data2.size;
  data2.set(key, value);
  this.size += data2.size == size12 ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length2 = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache) {
    var pairs2 = data2.__data__;
    if (!Map$2 || pairs2.length < LARGE_ARRAY_SIZE - 1) {
      pairs2.push([key, value]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache(pairs2);
  }
  data2.set(key, value);
  this.size = data2.size;
  return this;
}
function Stack(entries) {
  var data2 = this.__data__ = new ListCache(entries);
  this.size = data2.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var defineProperty = function() {
  try {
    var func2 = getNative(Object, "defineProperty");
    func2({}, "", {});
    return func2;
  } catch (e3) {
  }
}();
const defineProperty$1 = defineProperty;
function baseAssignValue(object2, key, value) {
  if (key == "__proto__" && defineProperty$1) {
    defineProperty$1(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
function assignMergeValue(object2, key, value) {
  if (value !== void 0 && !eq(object2[key], value) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function createBaseFor(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props = keysFunc(object2), length2 = props.length;
    while (length2--) {
      var key = props[fromRight ? length2 : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var baseFor = createBaseFor();
const baseFor$1 = baseFor;
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$3 = moduleExports$2 ? root$2.Buffer : void 0, allocUnsafe = Buffer$3 ? Buffer$3.allocUnsafe : void 0;
function cloneBuffer(buffer3, isDeep) {
  if (isDeep) {
    return buffer3.slice();
  }
  var length2 = buffer3.length, result = allocUnsafe ? allocUnsafe(length2) : new buffer3.constructor(length2);
  buffer3.copy(result);
  return result;
}
var Uint8Array$1 = root$2.Uint8Array;
const Uint8Array$2 = Uint8Array$1;
function cloneArrayBuffer(arrayBuffer2) {
  var result = new arrayBuffer2.constructor(arrayBuffer2.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer2));
  return result;
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer3 = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer3, typedArray.byteOffset, typedArray.length);
}
function copyArray(source, array2) {
  var index2 = -1, length2 = source.length;
  array2 || (array2 = Array(length2));
  while (++index2 < length2) {
    array2[index2] = source[index2];
  }
  return array2;
}
var objectCreate = Object.create;
var baseCreate = function() {
  function object2() {
  }
  return function(proto) {
    if (!isObject$c(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object2.prototype = proto;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
}();
const baseCreate$1 = baseCreate;
function overArg(func2, transform4) {
  return function(arg) {
    return func2(transform4(arg));
  };
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
const getPrototype$1 = getPrototype;
var objectProto$a = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$a;
  return value === proto;
}
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate$1(getPrototype$1(object2)) : {};
}
function isObjectLike$1(value) {
  return value != null && typeof value == "object";
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike$1(value) && baseGetTag(value) == argsTag$2;
}
var objectProto$9 = Object.prototype;
var hasOwnProperty$b = objectProto$9.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$1(value) && hasOwnProperty$b.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
const isArguments$1 = isArguments;
var isArray$4 = Array.isArray;
const isArray$5 = isArray$4;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$2(value);
}
function isArrayLikeObject(value) {
  return isObjectLike$1(value) && isArrayLike(value);
}
function stubFalse() {
  return false;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var Buffer$2 = moduleExports$1 ? root$2.Buffer : void 0;
var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0;
var isBuffer$2 = nativeIsBuffer || stubFalse;
const isBuffer$3 = isBuffer$2;
var objectTag$3 = "[object Object]";
var funcProto = Function.prototype, objectProto$8 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$a = objectProto$8.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$3(value) {
  if (!isObjectLike$1(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$a.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray(value) {
  return isObjectLike$1(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func2) {
  return function(value) {
    return func2(value);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var freeProcess = moduleExports && freeGlobal$2.process;
var nodeUtil = function() {
  try {
    var types2 = freeModule && freeModule.require && freeModule.require("util").types;
    if (types2) {
      return types2;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e3) {
  }
}();
const nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray$1 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
const isTypedArray$2 = isTypedArray$1;
function safeGet(object2, key) {
  if (key === "constructor" && typeof object2[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object2[key];
}
var objectProto$7 = Object.prototype;
var hasOwnProperty$9 = objectProto$7.hasOwnProperty;
function assignValue(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$9.call(object2, key) && eq(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function copyObject(source, props, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index2 = -1, length2 = props.length;
  while (++index2 < length2) {
    var key = props[index2];
    var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object2, key, newValue);
    } else {
      assignValue(object2, key, newValue);
    }
  }
  return object2;
}
function baseTimes(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var MAX_SAFE_INTEGER = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$1(value, length2) {
  var type = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
  return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
var objectProto$6 = Object.prototype;
var hasOwnProperty$8 = objectProto$6.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$5(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$3(value), isType = !isArr && !isArg && !isBuff && isTypedArray$2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$8.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$1(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
function nativeKeysIn(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$5 = Object.prototype;
var hasOwnProperty$7 = objectProto$5.hasOwnProperty;
function baseKeysIn(object2) {
  if (!isObject$c(object2)) {
    return nativeKeysIn(object2);
  }
  var isProto = isPrototype(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$7.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}
function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack2) {
  var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack2.get(srcValue);
  if (stacked) {
    assignMergeValue(object2, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack2) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$5(srcValue), isBuff = !isArr && isBuffer$3(srcValue), isTyped = !isArr && !isBuff && isTypedArray$2(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$5(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$3(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$c(objValue) || isFunction$2(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack2.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack2);
    stack2["delete"](srcValue);
  }
  assignMergeValue(object2, key, newValue);
}
function baseMerge(object2, source, srcIndex, customizer, stack2) {
  if (object2 === source) {
    return;
  }
  baseFor$1(source, function(srcValue, key) {
    stack2 || (stack2 = new Stack());
    if (isObject$c(srcValue)) {
      baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack2);
    } else {
      var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source, stack2) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object2, key, newValue);
    }
  }, keysIn);
}
function identity$4(value) {
  return value;
}
function apply(func2, thisArg, args) {
  switch (args.length) {
    case 0:
      return func2.call(thisArg);
    case 1:
      return func2.call(thisArg, args[0]);
    case 2:
      return func2.call(thisArg, args[0], args[1]);
    case 3:
      return func2.call(thisArg, args[0], args[1], args[2]);
  }
  return func2.apply(thisArg, args);
}
var nativeMax$2 = Math.max;
function overRest(func2, start2, transform4) {
  start2 = nativeMax$2(start2 === void 0 ? func2.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax$2(args.length - start2, 0), array2 = Array(length2);
    while (++index2 < length2) {
      array2[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform4(array2);
    return apply(func2, this, otherArgs);
  };
}
function constant(value) {
  return function() {
    return value;
  };
}
var baseSetToString = !defineProperty$1 ? identity$4 : function(func2, string3) {
  return defineProperty$1(func2, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string3),
    "writable": true
  });
};
const baseSetToString$1 = baseSetToString;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut(func2) {
  var count3 = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count3 >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count3 = 0;
    }
    return func2.apply(void 0, arguments);
  };
}
var setToString = shortOut(baseSetToString$1);
const setToString$1 = setToString;
function baseRest(func2, start2) {
  return setToString$1(overRest(func2, start2, identity$4), func2 + "");
}
function isIterateeCall(value, index2, object2) {
  if (!isObject$c(object2)) {
    return false;
  }
  var type = typeof index2;
  if (type == "number" ? isArrayLike(object2) && isIndex$1(index2, object2.length) : type == "string" && index2 in object2) {
    return eq(object2[index2], value);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest(function(object2, sources2) {
    var index2 = -1, length2 = sources2.length, customizer = length2 > 1 ? sources2[length2 - 1] : void 0, guard = length2 > 2 ? sources2[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : void 0;
    if (guard && isIterateeCall(sources2[0], sources2[1], guard)) {
      customizer = length2 < 3 ? void 0 : customizer;
      length2 = 1;
    }
    object2 = Object(object2);
    while (++index2 < length2) {
      var source = sources2[index2];
      if (source) {
        assigner(object2, source, index2, customizer);
      }
    }
    return object2;
  });
}
var merge = createAssigner(function(object2, source, srcIndex) {
  baseMerge(object2, source, srcIndex);
});
const merge$1 = merge;
var Raised = function Raised2(_ref2) {
  var zDepth = _ref2.zDepth, radius = _ref2.radius, background = _ref2.background, children = _ref2.children, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles;
  var styles2 = _default$3(merge$1({
    "default": {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
        borderRadius: radius,
        background
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    "square": {
      bg: {
        borderRadius: "0"
      }
    },
    "circle": {
      bg: {
        borderRadius: "50%"
      }
    }
  }, passedStyles), { "zDepth-1": zDepth === 1 });
  return React__default.createElement(
    "div",
    { style: styles2.wrap },
    React__default.createElement("div", { style: styles2.bg }),
    React__default.createElement(
      "div",
      { style: styles2.content },
      children
    )
  );
};
Raised.propTypes = {
  background: propTypesExports$1.string,
  zDepth: propTypesExports$1.oneOf([0, 1, 2, 3, 4, 5]),
  radius: propTypesExports$1.number,
  styles: propTypesExports$1.object
};
Raised.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var now$1 = function() {
  return root$2.Date.now();
};
const now$2 = now$1;
var reWhitespace = /\s/;
function trimmedEndIndex(string3) {
  var index2 = string3.length;
  while (index2-- && reWhitespace.test(string3.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string3) {
  return string3 ? string3.slice(0, trimmedEndIndex(string3) + 1).replace(reTrimStart, "") : string3;
}
var symbolTag$2 = "[object Symbol]";
function isSymbol$1(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && baseGetTag(value) == symbolTag$2;
}
var NAN$1 = 0 / 0;
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary$1 = /^0b[01]+$/i;
var reIsOctal$1 = /^0o[0-7]+$/i;
var freeParseInt$1 = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$c(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$c(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}
var FUNC_ERROR_TEXT$3 = "Expected a function";
var nativeMax$1 = Math.max, nativeMin$1 = Math.min;
function debounce$2(func2, wait, options2) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func2 != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$c(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax$1(toNumber$1(options2.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func2.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$2();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel2() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$2());
  }
  function debounced() {
    var time2 = now$2(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel2;
  debounced.flush = flush;
  return debounced;
}
var FUNC_ERROR_TEXT$2 = "Expected a function";
function throttle$2(func2, wait, options2) {
  var leading = true, trailing = true;
  if (typeof func2 != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  if (isObject$c(options2)) {
    leading = "leading" in options2 ? !!options2.leading : leading;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  return debounce$2(func2, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var calculateChange = function calculateChange4(e3, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
  var x2 = typeof e3.pageX === "number" ? e3.pageX : e3.touches[0].pageX;
  var y2 = typeof e3.pageY === "number" ? e3.pageY : e3.touches[0].pageY;
  var left = x2 - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y2 - (container.getBoundingClientRect().top + window.pageYOffset);
  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }
  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }
  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;
  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: "hsv"
  };
};
var _createClass$6 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$6(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$5(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Saturation = function(_ref2) {
  _inherits$5(Saturation2, _ref2);
  function Saturation2(props) {
    _classCallCheck$6(this, Saturation2);
    var _this = _possibleConstructorReturn$5(this, (Saturation2.__proto__ || Object.getPrototypeOf(Saturation2)).call(this, props));
    _this.handleChange = function(e3) {
      typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, calculateChange(e3, _this.props.hsl, _this.container), e3);
    };
    _this.handleMouseDown = function(e3) {
      _this.handleChange(e3);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener("mousemove", _this.handleChange);
      renderWindow.addEventListener("mouseup", _this.handleMouseUp);
    };
    _this.handleMouseUp = function() {
      _this.unbindEventListeners();
    };
    _this.throttle = throttle$2(function(fn2, data2, e3) {
      fn2(data2, e3);
    }, 50);
    return _this;
  }
  _createClass$6(Saturation2, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function getContainerRenderWindow() {
      var container = this.container;
      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: "unbindEventListeners",
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener("mousemove", this.handleChange);
      renderWindow.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function render5() {
      var _this2 = this;
      var _ref22 = this.props.style || {}, color = _ref22.color, white = _ref22.white, black = _ref22.black, pointer = _ref22.pointer, circle2 = _ref22.circle;
      var styles2 = _default$3({
        "default": {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        "custom": {
          color,
          white,
          black,
          pointer,
          circle: circle2
        }
      }, { "custom": !!this.props.style });
      return React__default.createElement(
        "div",
        {
          style: styles2.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        React__default.createElement(
          "style",
          null,
          "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "
        ),
        React__default.createElement(
          "div",
          { style: styles2.white, className: "saturation-white" },
          React__default.createElement("div", { style: styles2.black, className: "saturation-black" }),
          React__default.createElement(
            "div",
            { style: styles2.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: styles2.circle })
          )
        )
      );
    }
  }]);
  return Saturation2;
}(PureComponent || Component$1);
function arrayEach(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (iteratee(array2[index2], index2, array2) === false) {
      break;
    }
  }
  return array2;
}
var nativeKeys = overArg(Object.keys, Object);
const nativeKeys$1 = nativeKeys;
var objectProto$4 = Object.prototype;
var hasOwnProperty$6 = objectProto$4.hasOwnProperty;
function baseKeys(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys$1(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$6.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function keys(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
function baseForOwn(object2, iteratee) {
  return object2 && baseFor$1(object2, iteratee, keys);
}
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var baseEach = createBaseEach(baseForOwn);
const baseEach$1 = baseEach;
function castFunction(value) {
  return typeof value == "function" ? value : identity$4;
}
function forEach$2(collection, iteratee) {
  var func2 = isArray$5(collection) ? arrayEach : baseEach$1;
  return func2(collection, castFunction(iteratee));
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {};
  if (color instanceof tinycolor) {
    return color;
  }
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }
  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType;
  if (this._r < 1)
    this._r = Math.round(this._r);
  if (this._g < 1)
    this._g = Math.round(this._g);
  if (this._b < 1)
    this._b = Math.round(this._b);
  this._ok = rgb.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid7() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
  },
  getLuminance: function getLuminance() {
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R2, G2, B2;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928)
      R2 = RsRGB / 12.92;
    else
      R2 = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928)
      G2 = GsRGB / 12.92;
    else
      G2 = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928)
      B2 = BsRGB / 12.92;
    else
      B2 = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R2 + 0.7152 * G2 + 0.0722 * B2;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h2 = Math.round(hsv.h * 360), s2 = Math.round(hsv.s * 100), v5 = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h2 + ", " + s2 + "%, " + v5 + "%)" : "hsva(" + h2 + ", " + s2 + "%, " + v5 + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h2 = Math.round(hsl.h * 360), s2 = Math.round(hsl.s * 100), l2 = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h2 + ", " + s2 + "%, " + l2 + "%)" : "hsla(" + h2 + ", " + s2 + "%, " + l2 + "%, " + this._roundA + ")";
  },
  toHex: function toHex2(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s2 = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s2._r, s2._g, s2._b, s2._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString26(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
    if (needsAlphaFormat) {
      if (format === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone6() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn2, args) {
    var color = fn2.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn2, args) {
    return fn2.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};
tinycolor.fromRatio = function(color, opts) {
  if (_typeof$1(color) == "object") {
    var newColor = {};
    for (var i2 in color) {
      if (color.hasOwnProperty(i2)) {
        if (i2 === "a") {
          newColor[i2] = color[i2];
        } else {
          newColor[i2] = convertToPercentage(color[i2]);
        }
      }
    }
    color = newColor;
  }
  return tinycolor(color, opts);
};
function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a2 = 1;
  var s2 = null;
  var v5 = null;
  var l2 = null;
  var ok = false;
  var format = false;
  if (typeof color == "string") {
    color = stringInputToObject(color);
  }
  if (_typeof$1(color) == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s2 = convertToPercentage(color.s);
      v5 = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s2, v5);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s2 = convertToPercentage(color.s);
      l2 = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s2, l2);
      ok = true;
      format = "hsl";
    }
    if (color.hasOwnProperty("a")) {
      a2 = color.a;
    }
  }
  a2 = boundAlpha(a2);
  return {
    ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a2
  };
}
function rgbToRgb(r2, g2, b2) {
  return {
    r: bound01(r2, 255) * 255,
    g: bound01(g2, 255) * 255,
    b: bound01(b2, 255) * 255
  };
}
function rgbToHsl(r2, g2, b2) {
  r2 = bound01(r2, 255);
  g2 = bound01(g2, 255);
  b2 = bound01(b2, 255);
  var max3 = Math.max(r2, g2, b2), min4 = Math.min(r2, g2, b2);
  var h2, s2, l2 = (max3 + min4) / 2;
  if (max3 == min4) {
    h2 = s2 = 0;
  } else {
    var d2 = max3 - min4;
    s2 = l2 > 0.5 ? d2 / (2 - max3 - min4) : d2 / (max3 + min4);
    switch (max3) {
      case r2:
        h2 = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
        break;
      case g2:
        h2 = (b2 - r2) / d2 + 2;
        break;
      case b2:
        h2 = (r2 - g2) / d2 + 4;
        break;
    }
    h2 /= 6;
  }
  return {
    h: h2,
    s: s2,
    l: l2
  };
}
function hslToRgb(h2, s2, l2) {
  var r2, g2, b2;
  h2 = bound01(h2, 360);
  s2 = bound01(s2, 100);
  l2 = bound01(l2, 100);
  function hue2rgb2(p3, q3, t2) {
    if (t2 < 0)
      t2 += 1;
    if (t2 > 1)
      t2 -= 1;
    if (t2 < 1 / 6)
      return p3 + (q3 - p3) * 6 * t2;
    if (t2 < 1 / 2)
      return q3;
    if (t2 < 2 / 3)
      return p3 + (q3 - p3) * (2 / 3 - t2) * 6;
    return p3;
  }
  if (s2 === 0) {
    r2 = g2 = b2 = l2;
  } else {
    var q2 = l2 < 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
    var p2 = 2 * l2 - q2;
    r2 = hue2rgb2(p2, q2, h2 + 1 / 3);
    g2 = hue2rgb2(p2, q2, h2);
    b2 = hue2rgb2(p2, q2, h2 - 1 / 3);
  }
  return {
    r: r2 * 255,
    g: g2 * 255,
    b: b2 * 255
  };
}
function rgbToHsv(r2, g2, b2) {
  r2 = bound01(r2, 255);
  g2 = bound01(g2, 255);
  b2 = bound01(b2, 255);
  var max3 = Math.max(r2, g2, b2), min4 = Math.min(r2, g2, b2);
  var h2, s2, v5 = max3;
  var d2 = max3 - min4;
  s2 = max3 === 0 ? 0 : d2 / max3;
  if (max3 == min4) {
    h2 = 0;
  } else {
    switch (max3) {
      case r2:
        h2 = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
        break;
      case g2:
        h2 = (b2 - r2) / d2 + 2;
        break;
      case b2:
        h2 = (r2 - g2) / d2 + 4;
        break;
    }
    h2 /= 6;
  }
  return {
    h: h2,
    s: s2,
    v: v5
  };
}
function hsvToRgb(h2, s2, v5) {
  h2 = bound01(h2, 360) * 6;
  s2 = bound01(s2, 100);
  v5 = bound01(v5, 100);
  var i2 = Math.floor(h2), f2 = h2 - i2, p2 = v5 * (1 - s2), q2 = v5 * (1 - f2 * s2), t2 = v5 * (1 - (1 - f2) * s2), mod2 = i2 % 6, r2 = [v5, q2, p2, p2, t2, v5][mod2], g2 = [t2, v5, v5, q2, p2, p2][mod2], b2 = [p2, p2, t2, v5, v5, q2][mod2];
  return {
    r: r2 * 255,
    g: g2 * 255,
    b: b2 * 255
  };
}
function rgbToHex(r2, g2, b2, allow3Char) {
  var hex = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g2).toString(16)), pad2(Math.round(b2).toString(16))];
  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}
function rgbaToHex(r2, g2, b2, a2, allow4Char) {
  var hex = [pad2(Math.round(r2).toString(16)), pad2(Math.round(g2).toString(16)), pad2(Math.round(b2).toString(16)), pad2(convertDecimalToHex(a2))];
  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}
function rgbaToArgbHex(r2, g2, b2, a2) {
  var hex = [pad2(convertDecimalToHex(a2)), pad2(Math.round(r2).toString(16)), pad2(Math.round(g2).toString(16)), pad2(Math.round(b2).toString(16))];
  return hex.join("");
}
tinycolor.equals = function(color1, color2) {
  if (!color1 || !color2)
    return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function() {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}
function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}
function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
}
function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}
function polyad(color, number2) {
  if (isNaN(number2) || number2 <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number2;
  for (var i2 = 1; i2 < number2; i2++) {
    result.push(tinycolor({
      h: (hsl.h + i2 * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }
  return result;
}
function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h2 = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h2 + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h2 + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}
function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];
  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }
  return ret;
}
function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h2 = hsv.h, s2 = hsv.s, v5 = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h: h2,
      s: s2,
      v: v5
    }));
    v5 = (v5 + modification) % 1;
  }
  return ret;
}
tinycolor.mix = function(color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p2 = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p2 + rgb1.r,
    g: (rgb2.g - rgb1.g) * p2 + rgb1.g,
    b: (rgb2.b - rgb1.b) * p2 + rgb1.b,
    a: (rgb2.a - rgb1.a) * p2 + rgb1.a
  };
  return tinycolor(rgba);
};
tinycolor.readability = function(color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
tinycolor.isReadable = function(color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};
tinycolor.mostReadable = function(baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size12;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size12 = args.size;
  for (var i2 = 0; i2 < colorList.length; i2++) {
    readability = tinycolor.readability(baseColor, colorList[i2]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i2]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level,
    size: size12
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
var hexNames = tinycolor.hexNames = flip(names);
function flip(o2) {
  var flipped = {};
  for (var i2 in o2) {
    if (o2.hasOwnProperty(i2)) {
      flipped[o2[i2]] = i2;
    }
  }
  return flipped;
}
function boundAlpha(a2) {
  a2 = parseFloat(a2);
  if (isNaN(a2) || a2 < 0 || a2 > 1) {
    a2 = 1;
  }
  return a2;
}
function bound01(n2, max3) {
  if (isOnePointZero(n2))
    n2 = "100%";
  var processPercent = isPercentage(n2);
  n2 = Math.min(max3, Math.max(0, parseFloat(n2)));
  if (processPercent) {
    n2 = parseInt(n2 * max3, 10) / 100;
  }
  if (Math.abs(n2 - max3) < 1e-6) {
    return 1;
  }
  return n2 % max3 / parseFloat(max3);
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function isOnePointZero(n2) {
  return typeof n2 == "string" && n2.indexOf(".") != -1 && parseFloat(n2) === 1;
}
function isPercentage(n2) {
  return typeof n2 === "string" && n2.indexOf("%") != -1;
}
function pad2(c2) {
  return c2.length == 1 ? "0" + c2 : "" + c2;
}
function convertToPercentage(n2) {
  if (n2 <= 1) {
    n2 = n2 * 100 + "%";
  }
  return n2;
}
function convertDecimalToHex(d2) {
  return Math.round(parseFloat(d2) * 255).toString(16);
}
function convertHexToDecimal(h2) {
  return parseIntFromHex(h2) / 255;
}
var matchers = function() {
  var CSS_INTEGER = "[-\\+]?\\d+%?";
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
}
function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }
  var match2;
  if (match2 = matchers.rgb.exec(color)) {
    return {
      r: match2[1],
      g: match2[2],
      b: match2[3]
    };
  }
  if (match2 = matchers.rgba.exec(color)) {
    return {
      r: match2[1],
      g: match2[2],
      b: match2[3],
      a: match2[4]
    };
  }
  if (match2 = matchers.hsl.exec(color)) {
    return {
      h: match2[1],
      s: match2[2],
      l: match2[3]
    };
  }
  if (match2 = matchers.hsla.exec(color)) {
    return {
      h: match2[1],
      s: match2[2],
      l: match2[3],
      a: match2[4]
    };
  }
  if (match2 = matchers.hsv.exec(color)) {
    return {
      h: match2[1],
      s: match2[2],
      v: match2[3]
    };
  }
  if (match2 = matchers.hsva.exec(color)) {
    return {
      h: match2[1],
      s: match2[2],
      v: match2[3],
      a: match2[4]
    };
  }
  if (match2 = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      a: convertHexToDecimal(match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match2 = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      format: named ? "name" : "hex"
    };
  }
  if (match2 = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match2[1] + "" + match2[1]),
      g: parseIntFromHex(match2[2] + "" + match2[2]),
      b: parseIntFromHex(match2[3] + "" + match2[3]),
      a: convertHexToDecimal(match2[4] + "" + match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match2 = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match2[1] + "" + match2[1]),
      g: parseIntFromHex(match2[2] + "" + match2[2]),
      b: parseIntFromHex(match2[3] + "" + match2[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  var level, size12;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size12 = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size12 !== "small" && size12 !== "large") {
    size12 = "small";
  }
  return {
    level,
    size: size12
  };
}
var simpleCheckForValidColor = function simpleCheckForValidColor2(data2) {
  var keysToCheck = ["r", "g", "b", "a", "h", "s", "l", "v"];
  var checked = 0;
  var passed = 0;
  forEach$2(keysToCheck, function(letter) {
    if (data2[letter]) {
      checked += 1;
      if (!isNaN(data2[letter])) {
        passed += 1;
      }
      if (letter === "s" || letter === "l") {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data2[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data2 : false;
};
var toState = function toState2(data2, oldHue) {
  var color = data2.hex ? tinycolor(data2.hex) : tinycolor(data2);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === "000000" && rgb.a === 0;
  return {
    hsl,
    hex: transparent ? "transparent" : "#" + hex,
    rgb,
    hsv,
    oldHue: data2.h || oldHue || hsl.h,
    source: data2.source
  };
};
var isValidHex = function isValidHex2(hex) {
  if (hex === "transparent") {
    return true;
  }
  var lh = String(hex).charAt(0) === "#" ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && tinycolor(hex).isValid();
};
var getContrastingColor = function getContrastingColor2(data2) {
  if (!data2) {
    return "#fff";
  }
  var col = toState(data2);
  if (col.hex === "transparent") {
    return "rgba(0,0,0,0.4)";
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1e3;
  return yiq >= 128 ? "#000" : "#fff";
};
var isvalidColorString = function isvalidColorString2(string3, type) {
  var stringWithoutDegree = string3.replace("°", "");
  return tinycolor(type + " (" + stringWithoutDegree + ")")._ok;
};
var _extends$a = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$5 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$5(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$4(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColorWrap = function ColorWrap2(Picker) {
  var ColorPicker2 = function(_ref2) {
    _inherits$4(ColorPicker3, _ref2);
    function ColorPicker3(props) {
      _classCallCheck$5(this, ColorPicker3);
      var _this = _possibleConstructorReturn$4(this, (ColorPicker3.__proto__ || Object.getPrototypeOf(ColorPicker3)).call(this));
      _this.handleChange = function(data2, event) {
        var isValidColor = simpleCheckForValidColor(data2);
        if (isValidColor) {
          var colors = toState(data2, data2.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };
      _this.handleSwatchHover = function(data2, event) {
        var isValidColor = simpleCheckForValidColor(data2);
        if (isValidColor) {
          var colors = toState(data2, data2.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };
      _this.state = _extends$a({}, toState(props.color, 0));
      _this.debounce = debounce$2(function(fn2, data2, event) {
        fn2(data2, event);
      }, 100);
      return _this;
    }
    _createClass$5(ColorPicker3, [{
      key: "render",
      value: function render5() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }
        return React__default.createElement(Picker, _extends$a({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$a({}, toState(nextProps.color, state.oldHue));
      }
    }]);
    return ColorPicker3;
  }(PureComponent || Component$1);
  ColorPicker2.propTypes = _extends$a({}, Picker.propTypes);
  ColorPicker2.defaultProps = _extends$a({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  });
  return ColorPicker2;
};
var _extends$9 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$4 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$4(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$3(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var handleFocus = function handleFocus2(Component2) {
  var Span = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(_React$Component) {
    _inherits$3(Focus, _React$Component);
    function Focus() {
      var _ref2;
      var _temp, _this, _ret;
      _classCallCheck$4(this, Focus);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, (_ref2 = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function() {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function() {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn$3(_this, _ret);
    }
    _createClass$4(Focus, [{
      key: "render",
      value: function render5() {
        return React__default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          React__default.createElement(Component2, _extends$9({}, this.props, this.state))
        );
      }
    }]);
    return Focus;
  }(React__default.Component);
};
var _extends$8 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var ENTER = 13;
var Swatch = function Swatch2(_ref2) {
  var color = _ref2.color, style2 = _ref2.style, _ref$onClick = _ref2.onClick, onClick2 = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onHover = _ref2.onHover, _ref$title = _ref2.title, title = _ref$title === void 0 ? color : _ref$title, children = _ref2.children, focus = _ref2.focus, _ref$focusStyle = _ref2.focusStyle, focusStyle = _ref$focusStyle === void 0 ? {} : _ref$focusStyle;
  var transparent = color === "transparent";
  var styles2 = _default$3({
    default: {
      swatch: _extends$8({
        background: color,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, style2, focus ? focusStyle : {})
    }
  });
  var handleClick = function handleClick2(e3) {
    return onClick2(color, e3);
  };
  var handleKeyDown = function handleKeyDown2(e3) {
    return e3.keyCode === ENTER && onClick2(color, e3);
  };
  var handleHover2 = function handleHover3(e3) {
    return onHover(color, e3);
  };
  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover2;
  }
  return React__default.createElement(
    "div",
    _extends$8({
      style: styles2.swatch,
      onClick: handleClick,
      title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && React__default.createElement(Checkboard, {
      borderRadius: styles2.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const Swatch$1 = handleFocus(Swatch);
var AlphaPointer = function AlphaPointer2(_ref2) {
  var direction = _ref2.direction;
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: direction === "vertical" });
  return React__default.createElement("div", { style: styles2.picker });
};
var _extends$7 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var AlphaPicker$1 = function AlphaPicker2(_ref2) {
  var rgb = _ref2.rgb, hsl = _ref2.hsl, width = _ref2.width, height = _ref2.height, onChange = _ref2.onChange, direction = _ref2.direction, style2 = _ref2.style, renderers = _ref2.renderers, pointer = _ref2.pointer, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3({
    "default": {
      picker: {
        position: "relative",
        width,
        height
      },
      alpha: {
        radius: "2px",
        style: style2
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: styles2.picker, className: "alpha-picker " + className },
    React__default.createElement(Alpha$2, _extends$7({}, styles2.alpha, {
      rgb,
      hsl,
      pointer,
      renderers,
      onChange,
      direction
    }))
  );
};
AlphaPicker$1.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: AlphaPointer
};
ColorWrap(AlphaPicker$1);
function arrayMap(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values4) {
  var index2 = -1, length2 = values4 == null ? 0 : values4.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values4[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache2, key) {
  return cache2.has(key);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(array2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack2.get(array2);
  var othStacked = stack2.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack2.set(array2, other);
  stack2.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack2) : customizer(arrValue, othValue, index2, array2, other, stack2);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
      result = false;
      break;
    }
  }
  stack2["delete"](array2);
  stack2["delete"](other);
  return result;
}
function mapToArray(map5) {
  var index2 = -1, result = Array(map5.size);
  map5.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
function setToArray(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]";
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : void 0;
function equalByTag(object2, other, tag2, bitmask, customizer, equalFunc, stack2) {
  switch (tag2) {
    case dataViewTag$1:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$2(object2), new Uint8Array$2(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+object2, +other);
    case errorTag:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag:
    case stringTag:
      return object2 == other + "";
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack2.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack2.set(object2, other);
      var result = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack2);
      stack2["delete"](object2);
      return result;
    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
      }
  }
  return false;
}
function arrayPush(array2, values4) {
  var index2 = -1, length2 = values4.length, offset = array2.length;
  while (++index2 < length2) {
    array2[offset + index2] = values4[index2];
  }
  return array2;
}
function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$5(object2) ? result : arrayPush(result, symbolsFunc(object2));
}
function arrayFilter(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array2[index2];
    if (predicate(value, index2, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols(object2), function(symbol) {
    return propertyIsEnumerable.call(object2, symbol);
  });
};
const getSymbols$1 = getSymbols;
function getAllKeys(object2) {
  return baseGetAllKeys(object2, keys, getSymbols$1);
}
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$5 = objectProto$2.hasOwnProperty;
function equalObjects(object2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$5.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack2.get(object2);
  var othStacked = stack2.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack2.set(object2, other);
  stack2.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack2) : customizer(objValue, othValue, key, object2, other, stack2);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack2["delete"](object2);
  stack2["delete"](other);
  return result;
}
var DataView$1 = getNative(root$2, "DataView");
const DataView$2 = DataView$1;
var Promise$1 = getNative(root$2, "Promise");
const Promise$2 = Promise$1;
var Set$1 = getNative(root$2, "Set");
const Set$2 = Set$1;
var WeakMap$1 = getNative(root$2, "WeakMap");
const WeakMap$2 = WeakMap$1;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView$2), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2);
var getTag = baseGetTag;
if (DataView$2 && getTag(new DataView$2(new ArrayBuffer(1))) != dataViewTag || Map$2 && getTag(new Map$2()) != mapTag || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
const getTag$1 = getTag;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto$1 = Object.prototype;
var hasOwnProperty$4 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack2) {
  var objIsArr = isArray$5(object2), othIsArr = isArray$5(other), objTag = objIsArr ? arrayTag : getTag$1(object2), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$3(object2)) {
    if (!isBuffer$3(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack2 || (stack2 = new Stack());
    return objIsArr || isTypedArray$2(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack2) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack2);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$4.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$4.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack2 || (stack2 = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack2 || (stack2 = new Stack());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack2);
}
function baseIsEqual(value, other, bitmask, customizer, stack2) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$1(value) && !isObjectLike$1(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack2);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(object2, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
  if (object2 == null) {
    return !length2;
  }
  object2 = Object(object2);
  while (index2--) {
    var data2 = matchData[index2];
    if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object2[key], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack2 = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object2, source, stack2);
      }
      if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack2) : result)) {
        return false;
      }
    }
  }
  return true;
}
function isStrictComparable(value) {
  return value === value && !isObject$c(value);
}
function getMatchData(object2) {
  var result = keys(object2), length2 = result.length;
  while (length2--) {
    var key = result[length2], value = object2[key];
    result[length2] = [key, value, isStrictComparable(value)];
  }
  return result;
}
function matchesStrictComparable(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(value, object2) {
  if (isArray$5(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$1(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$2(func2, resolver) {
  if (typeof func2 != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func2.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache)();
  return memoized;
}
memoize$2.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func2) {
  var result = memoize$2(func2, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string3) {
  var result = [];
  if (string3.charCodeAt(0) === 46) {
    result.push("");
  }
  string3.replace(rePropName, function(match2, number2, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match2);
  });
  return result;
});
const stringToPath$1 = stringToPath;
var INFINITY$1 = 1 / 0;
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$5(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
function toString$1(value) {
  return value == null ? "" : baseToString(value);
}
function castPath(value, object2) {
  if (isArray$5(value)) {
    return value;
  }
  return isKey(value, object2) ? [value] : stringToPath$1(toString$1(value));
}
var INFINITY = 1 / 0;
function toKey(value) {
  if (typeof value == "string" || isSymbol$1(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function baseGet(object2, path2) {
  path2 = castPath(path2, object2);
  var index2 = 0, length2 = path2.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey(path2[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
function get(object2, path2, defaultValue2) {
  var result = object2 == null ? void 0 : baseGet(object2, path2);
  return result === void 0 ? defaultValue2 : result;
}
function baseHasIn(object2, key) {
  return object2 != null && key in Object(object2);
}
function hasPath(object2, path2, hasFunc) {
  path2 = castPath(path2, object2);
  var index2 = -1, length2 = path2.length, result = false;
  while (++index2 < length2) {
    var key = toKey(path2[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength(length2) && isIndex$1(key, length2) && (isArray$5(object2) || isArguments$1(object2));
}
function hasIn(object2, path2) {
  return object2 != null && hasPath(object2, path2, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(path2, srcValue) {
  if (isKey(path2) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path2), srcValue);
  }
  return function(object2) {
    var objValue = get(object2, path2);
    return objValue === void 0 && objValue === srcValue ? hasIn(object2, path2) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
function basePropertyDeep(path2) {
  return function(object2) {
    return baseGet(object2, path2);
  };
}
function property(path2) {
  return isKey(path2) ? baseProperty(toKey(path2)) : basePropertyDeep(path2);
}
function baseIteratee(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$4;
  }
  if (typeof value == "object") {
    return isArray$5(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
function baseMap(collection, iteratee) {
  var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach$1(collection, function(value, key, collection2) {
    result[++index2] = iteratee(value, key, collection2);
  });
  return result;
}
function map$2(collection, iteratee) {
  var func2 = isArray$5(collection) ? arrayMap : baseMap;
  return func2(collection, baseIteratee(iteratee));
}
var BlockSwatches = function BlockSwatches2(_ref2) {
  var colors = _ref2.colors, onClick2 = _ref2.onClick, onSwatchHover = _ref2.onSwatchHover;
  var styles2 = _default$3({
    "default": {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: styles2.swatches },
    map$2(colors, function(c2) {
      return React__default.createElement(Swatch$1, {
        key: c2,
        color: c2,
        style: styles2.swatch,
        onClick: onClick2,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: "0 0 4px " + c2
        }
      });
    }),
    React__default.createElement("div", { style: styles2.clear })
  );
};
var Block$1 = function Block2(_ref2) {
  var onChange = _ref2.onChange, onSwatchHover = _ref2.onSwatchHover, hex = _ref2.hex, colors = _ref2.colors, width = _ref2.width, triangle = _ref2.triangle, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var transparent = hex === "transparent";
  var handleChange = function handleChange2(hexCode, e3) {
    isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: "hex"
    }, e3);
  };
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: hex,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: getContrastingColor(hex),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + hex + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, passedStyles), { "hide-triangle": triangle === "hide" });
  return React__default.createElement(
    "div",
    { style: styles2.card, className: "block-picker " + className },
    React__default.createElement("div", { style: styles2.triangle }),
    React__default.createElement(
      "div",
      { style: styles2.head },
      transparent && React__default.createElement(Checkboard, { borderRadius: "6px 6px 0 0" }),
      React__default.createElement(
        "div",
        { style: styles2.label },
        hex
      )
    ),
    React__default.createElement(
      "div",
      { style: styles2.body },
      React__default.createElement(BlockSwatches, { colors, onClick: handleChange, onSwatchHover }),
      React__default.createElement(EditableInput, {
        style: { input: styles2.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};
Block$1.propTypes = {
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  colors: propTypesExports$1.arrayOf(propTypesExports$1.string),
  triangle: propTypesExports$1.oneOf(["top", "hide"]),
  styles: propTypesExports$1.object
};
Block$1.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
ColorWrap(Block$1);
var red = { "50": "#ffebee", "100": "#ffcdd2", "200": "#ef9a9a", "300": "#e57373", "400": "#ef5350", "500": "#f44336", "600": "#e53935", "700": "#d32f2f", "800": "#c62828", "900": "#b71c1c", "a100": "#ff8a80", "a200": "#ff5252", "a400": "#ff1744", "a700": "#d50000" };
var pink = { "50": "#fce4ec", "100": "#f8bbd0", "200": "#f48fb1", "300": "#f06292", "400": "#ec407a", "500": "#e91e63", "600": "#d81b60", "700": "#c2185b", "800": "#ad1457", "900": "#880e4f", "a100": "#ff80ab", "a200": "#ff4081", "a400": "#f50057", "a700": "#c51162" };
var purple = { "50": "#f3e5f5", "100": "#e1bee7", "200": "#ce93d8", "300": "#ba68c8", "400": "#ab47bc", "500": "#9c27b0", "600": "#8e24aa", "700": "#7b1fa2", "800": "#6a1b9a", "900": "#4a148c", "a100": "#ea80fc", "a200": "#e040fb", "a400": "#d500f9", "a700": "#aa00ff" };
var deepPurple = { "50": "#ede7f6", "100": "#d1c4e9", "200": "#b39ddb", "300": "#9575cd", "400": "#7e57c2", "500": "#673ab7", "600": "#5e35b1", "700": "#512da8", "800": "#4527a0", "900": "#311b92", "a100": "#b388ff", "a200": "#7c4dff", "a400": "#651fff", "a700": "#6200ea" };
var indigo = { "50": "#e8eaf6", "100": "#c5cae9", "200": "#9fa8da", "300": "#7986cb", "400": "#5c6bc0", "500": "#3f51b5", "600": "#3949ab", "700": "#303f9f", "800": "#283593", "900": "#1a237e", "a100": "#8c9eff", "a200": "#536dfe", "a400": "#3d5afe", "a700": "#304ffe" };
var blue = { "50": "#e3f2fd", "100": "#bbdefb", "200": "#90caf9", "300": "#64b5f6", "400": "#42a5f5", "500": "#2196f3", "600": "#1e88e5", "700": "#1976d2", "800": "#1565c0", "900": "#0d47a1", "a100": "#82b1ff", "a200": "#448aff", "a400": "#2979ff", "a700": "#2962ff" };
var lightBlue = { "50": "#e1f5fe", "100": "#b3e5fc", "200": "#81d4fa", "300": "#4fc3f7", "400": "#29b6f6", "500": "#03a9f4", "600": "#039be5", "700": "#0288d1", "800": "#0277bd", "900": "#01579b", "a100": "#80d8ff", "a200": "#40c4ff", "a400": "#00b0ff", "a700": "#0091ea" };
var cyan = { "50": "#e0f7fa", "100": "#b2ebf2", "200": "#80deea", "300": "#4dd0e1", "400": "#26c6da", "500": "#00bcd4", "600": "#00acc1", "700": "#0097a7", "800": "#00838f", "900": "#006064", "a100": "#84ffff", "a200": "#18ffff", "a400": "#00e5ff", "a700": "#00b8d4" };
var teal = { "50": "#e0f2f1", "100": "#b2dfdb", "200": "#80cbc4", "300": "#4db6ac", "400": "#26a69a", "500": "#009688", "600": "#00897b", "700": "#00796b", "800": "#00695c", "900": "#004d40", "a100": "#a7ffeb", "a200": "#64ffda", "a400": "#1de9b6", "a700": "#00bfa5" };
var green = { "50": "#e8f5e9", "100": "#c8e6c9", "200": "#a5d6a7", "300": "#81c784", "400": "#66bb6a", "500": "#4caf50", "600": "#43a047", "700": "#388e3c", "800": "#2e7d32", "900": "#1b5e20", "a100": "#b9f6ca", "a200": "#69f0ae", "a400": "#00e676", "a700": "#00c853" };
var lightGreen = { "50": "#f1f8e9", "100": "#dcedc8", "200": "#c5e1a5", "300": "#aed581", "400": "#9ccc65", "500": "#8bc34a", "600": "#7cb342", "700": "#689f38", "800": "#558b2f", "900": "#33691e", "a100": "#ccff90", "a200": "#b2ff59", "a400": "#76ff03", "a700": "#64dd17" };
var lime = { "50": "#f9fbe7", "100": "#f0f4c3", "200": "#e6ee9c", "300": "#dce775", "400": "#d4e157", "500": "#cddc39", "600": "#c0ca33", "700": "#afb42b", "800": "#9e9d24", "900": "#827717", "a100": "#f4ff81", "a200": "#eeff41", "a400": "#c6ff00", "a700": "#aeea00" };
var yellow = { "50": "#fffde7", "100": "#fff9c4", "200": "#fff59d", "300": "#fff176", "400": "#ffee58", "500": "#ffeb3b", "600": "#fdd835", "700": "#fbc02d", "800": "#f9a825", "900": "#f57f17", "a100": "#ffff8d", "a200": "#ffff00", "a400": "#ffea00", "a700": "#ffd600" };
var amber = { "50": "#fff8e1", "100": "#ffecb3", "200": "#ffe082", "300": "#ffd54f", "400": "#ffca28", "500": "#ffc107", "600": "#ffb300", "700": "#ffa000", "800": "#ff8f00", "900": "#ff6f00", "a100": "#ffe57f", "a200": "#ffd740", "a400": "#ffc400", "a700": "#ffab00" };
var orange = { "50": "#fff3e0", "100": "#ffe0b2", "200": "#ffcc80", "300": "#ffb74d", "400": "#ffa726", "500": "#ff9800", "600": "#fb8c00", "700": "#f57c00", "800": "#ef6c00", "900": "#e65100", "a100": "#ffd180", "a200": "#ffab40", "a400": "#ff9100", "a700": "#ff6d00" };
var deepOrange = { "50": "#fbe9e7", "100": "#ffccbc", "200": "#ffab91", "300": "#ff8a65", "400": "#ff7043", "500": "#ff5722", "600": "#f4511e", "700": "#e64a19", "800": "#d84315", "900": "#bf360c", "a100": "#ff9e80", "a200": "#ff6e40", "a400": "#ff3d00", "a700": "#dd2c00" };
var brown = { "50": "#efebe9", "100": "#d7ccc8", "200": "#bcaaa4", "300": "#a1887f", "400": "#8d6e63", "500": "#795548", "600": "#6d4c41", "700": "#5d4037", "800": "#4e342e", "900": "#3e2723" };
var blueGrey = { "50": "#eceff1", "100": "#cfd8dc", "200": "#b0bec5", "300": "#90a4ae", "400": "#78909c", "500": "#607d8b", "600": "#546e7a", "700": "#455a64", "800": "#37474f", "900": "#263238" };
var CircleSwatch = function CircleSwatch2(_ref2) {
  var color = _ref2.color, onClick2 = _ref2.onClick, onSwatchHover = _ref2.onSwatchHover, hover3 = _ref2.hover, active3 = _ref2.active, circleSize = _ref2.circleSize, circleSpacing = _ref2.circleSpacing;
  var styles2 = _default$3({
    "default": {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
        transition: "100ms box-shadow ease"
      }
    },
    "hover": {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    "active": {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + color
      }
    }
  }, { hover: hover3, active: active3 });
  return React__default.createElement(
    "div",
    { style: styles2.swatch },
    React__default.createElement(Swatch$1, {
      style: styles2.Swatch,
      color,
      onClick: onClick2,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles2.Swatch.boxShadow + ", 0 0 5px " + color }
    })
  );
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const CircleSwatch$1 = handleHover(CircleSwatch);
var Circle = function Circle2(_ref2) {
  var width = _ref2.width, onChange = _ref2.onChange, onSwatchHover = _ref2.onSwatchHover, colors = _ref2.colors, hex = _ref2.hex, circleSize = _ref2.circleSize, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, circleSpacing = _ref2.circleSpacing, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(hexCode, e3) {
    return onChange({ hex: hexCode, source: "hex" }, e3);
  };
  return React__default.createElement(
    "div",
    { style: styles2.card, className: "circle-picker " + className },
    map$2(colors, function(c2) {
      return React__default.createElement(CircleSwatch$1, {
        key: c2,
        color: c2,
        onClick: handleChange,
        onSwatchHover,
        active: hex === c2.toLowerCase(),
        circleSize,
        circleSpacing
      });
    })
  );
};
Circle.propTypes = {
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  circleSize: propTypesExports$1.number,
  circleSpacing: propTypesExports$1.number,
  styles: propTypesExports$1.object
};
Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red["500"], pink["500"], purple["500"], deepPurple["500"], indigo["500"], blue["500"], lightBlue["500"], cyan["500"], teal["500"], green["500"], lightGreen["500"], lime["500"], yellow["500"], amber["500"], orange["500"], deepOrange["500"], brown["500"], blueGrey["500"]],
  styles: {}
};
ColorWrap(Circle);
function isUndefined$1(value) {
  return value === void 0;
}
var UnfoldMoreHorizontalIcon = {};
Object.defineProperty(UnfoldMoreHorizontalIcon, "__esModule", {
  value: true
});
var _extends$6 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react$1 = React__default;
var _react2$1 = _interopRequireDefault$1(_react$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties$2(obj, keys4) {
  var target = {};
  for (var i2 in obj) {
    if (keys4.indexOf(i2) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i2))
      continue;
    target[i2] = obj[i2];
  }
  return target;
}
var DEFAULT_SIZE$1 = 24;
var _default$2 = UnfoldMoreHorizontalIcon.default = function(_ref2) {
  var _ref$fill = _ref2.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$width = _ref2.width, width = _ref$width === void 0 ? DEFAULT_SIZE$1 : _ref$width, _ref$height = _ref2.height, height = _ref$height === void 0 ? DEFAULT_SIZE$1 : _ref$height, _ref$style = _ref2.style, style2 = _ref$style === void 0 ? {} : _ref$style, props = _objectWithoutProperties$2(_ref2, ["fill", "width", "height", "style"]);
  return _react2$1.default.createElement(
    "svg",
    _extends$6({
      viewBox: "0 0 " + DEFAULT_SIZE$1 + " " + DEFAULT_SIZE$1,
      style: _extends$6({ fill, width, height }, style2)
    }, props),
    _react2$1.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
};
var _createClass$3 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$3(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$2(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChromeFields = function(_React$Component) {
  _inherits$2(ChromeFields2, _React$Component);
  function ChromeFields2(props) {
    _classCallCheck$3(this, ChromeFields2);
    var _this = _possibleConstructorReturn$2(this, (ChromeFields2.__proto__ || Object.getPrototypeOf(ChromeFields2)).call(this));
    _this.toggleViews = function() {
      if (_this.state.view === "hex") {
        _this.setState({ view: "rgb" });
      } else if (_this.state.view === "rgb") {
        _this.setState({ view: "hsl" });
      } else if (_this.state.view === "hsl") {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: "hex" });
        } else {
          _this.setState({ view: "rgb" });
        }
      }
    };
    _this.handleChange = function(data2, e3) {
      if (data2.hex) {
        isValidHex(data2.hex) && _this.props.onChange({
          hex: data2.hex,
          source: "hex"
        }, e3);
      } else if (data2.r || data2.g || data2.b) {
        _this.props.onChange({
          r: data2.r || _this.props.rgb.r,
          g: data2.g || _this.props.rgb.g,
          b: data2.b || _this.props.rgb.b,
          source: "rgb"
        }, e3);
      } else if (data2.a) {
        if (data2.a < 0) {
          data2.a = 0;
        } else if (data2.a > 1) {
          data2.a = 1;
        }
        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data2.a * 100) / 100,
          source: "rgb"
        }, e3);
      } else if (data2.h || data2.s || data2.l) {
        if (typeof data2.s === "string" && data2.s.includes("%")) {
          data2.s = data2.s.replace("%", "");
        }
        if (typeof data2.l === "string" && data2.l.includes("%")) {
          data2.l = data2.l.replace("%", "");
        }
        if (data2.s == 1) {
          data2.s = 0.01;
        } else if (data2.l == 1) {
          data2.l = 0.01;
        }
        _this.props.onChange({
          h: data2.h || _this.props.hsl.h,
          s: Number(!isUndefined$1(data2.s) ? data2.s : _this.props.hsl.s),
          l: Number(!isUndefined$1(data2.l) ? data2.l : _this.props.hsl.l),
          source: "hsl"
        }, e3);
      }
    };
    _this.showHighlight = function(e3) {
      e3.currentTarget.style.background = "#eee";
    };
    _this.hideHighlight = function(e3) {
      e3.currentTarget.style.background = "transparent";
    };
    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }
  _createClass$3(ChromeFields2, [{
    key: "render",
    value: function render5() {
      var _this2 = this;
      var styles2 = _default$3({
        "default": {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        "disableAlpha": {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state);
      var fields = void 0;
      if (this.state.view === "hex") {
        fields = React__default.createElement(
          "div",
          { style: styles2.fields, className: "flexbox-fix" },
          React__default.createElement(
            "div",
            { style: styles2.field },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "hex",
              value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === "rgb") {
        fields = React__default.createElement(
          "div",
          { style: styles2.fields, className: "flexbox-fix" },
          React__default.createElement(
            "div",
            { style: styles2.field },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "r",
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.field },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "g",
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.field },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "b",
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.alpha },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "a",
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === "hsl") {
        fields = React__default.createElement(
          "div",
          { style: styles2.fields, className: "flexbox-fix" },
          React__default.createElement(
            "div",
            { style: styles2.field },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "h",
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.field },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "s",
              value: Math.round(this.props.hsl.s * 100) + "%",
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.field },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "l",
              value: Math.round(this.props.hsl.l * 100) + "%",
              onChange: this.handleChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.alpha },
            React__default.createElement(EditableInput, {
              style: { input: styles2.input, label: styles2.label },
              label: "a",
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }
      return React__default.createElement(
        "div",
        { style: styles2.wrap, className: "flexbox-fix" },
        fields,
        React__default.createElement(
          "div",
          { style: styles2.toggle },
          React__default.createElement(
            "div",
            { style: styles2.icon, onClick: this.toggleViews, ref: function ref(icon) {
              return _this2.icon = icon;
            } },
            React__default.createElement(_default$2, {
              style: styles2.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === "hex") {
        return { view: "rgb" };
      }
      return null;
    }
  }]);
  return ChromeFields2;
}(React__default.Component);
ChromeFields.defaultProps = {
  view: "hex"
};
var ChromePointer = function ChromePointer2() {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: styles2.picker });
};
var ChromePointerCircle = function ChromePointerCircle2() {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return React__default.createElement("div", { style: styles2.picker });
};
var Chrome = function Chrome2(_ref2) {
  var width = _ref2.width, onChange = _ref2.onChange, disableAlpha = _ref2.disableAlpha, rgb = _ref2.rgb, hsl = _ref2.hsl, hsv = _ref2.hsv, hex = _ref2.hex, renderers = _ref2.renderers, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className, defaultView = _ref2.defaultView;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        width,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    "disableAlpha": {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, passedStyles), { disableAlpha });
  return React__default.createElement(
    "div",
    { style: styles2.picker, className: "chrome-picker " + className },
    React__default.createElement(
      "div",
      { style: styles2.saturation },
      React__default.createElement(Saturation, {
        style: styles2.Saturation,
        hsl,
        hsv,
        pointer: ChromePointerCircle,
        onChange
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.body },
      React__default.createElement(
        "div",
        { style: styles2.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: styles2.color },
          React__default.createElement(
            "div",
            { style: styles2.swatch },
            React__default.createElement("div", { style: styles2.active }),
            React__default.createElement(Checkboard, { renderers })
          )
        ),
        React__default.createElement(
          "div",
          { style: styles2.toggles },
          React__default.createElement(
            "div",
            { style: styles2.hue },
            React__default.createElement(Hue, {
              style: styles2.Hue,
              hsl,
              pointer: ChromePointer,
              onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.alpha },
            React__default.createElement(Alpha$2, {
              style: styles2.Alpha,
              rgb,
              hsl,
              pointer: ChromePointer,
              renderers,
              onChange
            })
          )
        )
      ),
      React__default.createElement(ChromeFields, {
        rgb,
        hsl,
        hex,
        view: defaultView,
        onChange,
        disableAlpha
      })
    )
  );
};
Chrome.propTypes = {
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  disableAlpha: propTypesExports$1.bool,
  styles: propTypesExports$1.object,
  defaultView: propTypesExports$1.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};
const ChromePicker = ColorWrap(Chrome);
var CompactColor = function CompactColor2(_ref2) {
  var color = _ref2.color, _ref$onClick = _ref2.onClick, onClick2 = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref2.onSwatchHover, active3 = _ref2.active;
  var styles2 = _default$3({
    "default": {
      color: {
        background: color,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: getContrastingColor(color),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    "active": {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    "transparent": {
      dot: {
        background: "#000"
      }
    }
  }, { active: active3, "color-#FFFFFF": color === "#FFFFFF", "transparent": color === "transparent" });
  return React__default.createElement(
    Swatch$1,
    {
      style: styles2.color,
      color,
      onClick: onClick2,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: "0 0 4px " + color }
    },
    React__default.createElement("div", { style: styles2.dot })
  );
};
var CompactFields = function CompactFields2(_ref2) {
  var hex = _ref2.hex, rgb = _ref2.rgb, onChange = _ref2.onChange;
  var styles2 = _default$3({
    "default": {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: hex
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  });
  var handleChange = function handleChange2(data2, e3) {
    if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb.r,
        g: data2.g || rgb.g,
        b: data2.b || rgb.b,
        source: "rgb"
      }, e3);
    } else {
      onChange({
        hex: data2.hex,
        source: "hex"
      }, e3);
    }
  };
  return React__default.createElement(
    "div",
    { style: styles2.fields, className: "flexbox-fix" },
    React__default.createElement("div", { style: styles2.active }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.HEXwrap, input: styles2.HEXinput, label: styles2.HEXlabel },
      label: "hex",
      value: hex,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "r",
      value: rgb.r,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "g",
      value: rgb.g,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "b",
      value: rgb.b,
      onChange: handleChange
    })
  );
};
var Compact = function Compact2(_ref2) {
  var onChange = _ref2.onChange, onSwatchHover = _ref2.onSwatchHover, colors = _ref2.colors, hex = _ref2.hex, rgb = _ref2.rgb, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e3) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e3);
    } else {
      onChange(data2, e3);
    }
  };
  return React__default.createElement(
    Raised,
    { style: styles2.Compact, styles: passedStyles },
    React__default.createElement(
      "div",
      { style: styles2.compact, className: "compact-picker " + className },
      React__default.createElement(
        "div",
        null,
        map$2(colors, function(c2) {
          return React__default.createElement(CompactColor, {
            key: c2,
            color: c2,
            active: c2.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover
          });
        }),
        React__default.createElement("div", { style: styles2.clear })
      ),
      React__default.createElement(CompactFields, { hex, rgb, onChange: handleChange })
    )
  );
};
Compact.propTypes = {
  colors: propTypesExports$1.arrayOf(propTypesExports$1.string),
  styles: propTypesExports$1.object
};
Compact.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
ColorWrap(Compact);
var GithubSwatch = function GithubSwatch2(_ref2) {
  var hover3 = _ref2.hover, color = _ref2.color, onClick2 = _ref2.onClick, onSwatchHover = _ref2.onSwatchHover;
  var hoverSwatch = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  };
  var styles2 = _default$3({
    "default": {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    "hover": {
      swatch: hoverSwatch
    }
  }, { hover: hover3 });
  return React__default.createElement(
    "div",
    { style: styles2.swatch },
    React__default.createElement(Swatch$1, {
      color,
      onClick: onClick2,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};
const GithubSwatch$1 = handleHover(GithubSwatch);
var Github = function Github2(_ref2) {
  var width = _ref2.width, colors = _ref2.colors, onChange = _ref2.onChange, onSwatchHover = _ref2.onSwatchHover, triangle = _ref2.triangle, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle === "hide",
    "top-left-triangle": triangle === "top-left",
    "top-right-triangle": triangle === "top-right",
    "bottom-left-triangle": triangle === "bottom-left",
    "bottom-right-triangle": triangle === "bottom-right"
  });
  var handleChange = function handleChange2(hex, e3) {
    return onChange({ hex, source: "hex" }, e3);
  };
  return React__default.createElement(
    "div",
    { style: styles2.card, className: "github-picker " + className },
    React__default.createElement("div", { style: styles2.triangleShadow }),
    React__default.createElement("div", { style: styles2.triangle }),
    map$2(colors, function(c2) {
      return React__default.createElement(GithubSwatch$1, {
        color: c2,
        key: c2,
        onClick: handleChange,
        onSwatchHover
      });
    })
  );
};
Github.propTypes = {
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  colors: propTypesExports$1.arrayOf(propTypesExports$1.string),
  triangle: propTypesExports$1.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: propTypesExports$1.object
};
Github.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Github);
var SliderPointer$1 = function SliderPointer2(_ref2) {
  var direction = _ref2.direction;
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    "vertical": {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: direction === "vertical" });
  return React__default.createElement("div", { style: styles2.picker });
};
var _extends$5 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var HuePicker = function HuePicker2(_ref2) {
  var width = _ref2.width, height = _ref2.height, onChange = _ref2.onChange, hsl = _ref2.hsl, direction = _ref2.direction, pointer = _ref2.pointer, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        position: "relative",
        width,
        height
      },
      hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2) {
    return onChange({ a: 1, h: data2.h, l: 0.5, s: 1 });
  };
  return React__default.createElement(
    "div",
    { style: styles2.picker, className: "hue-picker " + className },
    React__default.createElement(Hue, _extends$5({}, styles2.hue, {
      hsl,
      pointer,
      onChange: handleChange,
      direction
    }))
  );
};
HuePicker.propTypes = {
  styles: propTypesExports$1.object
};
HuePicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap(HuePicker);
var Material = function Material3(_ref2) {
  var onChange = _ref2.onChange, hex = _ref2.hex, rgb = _ref2.rgb, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + hex,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e3) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e3);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb.r,
        g: data2.g || rgb.g,
        b: data2.b || rgb.b,
        source: "rgb"
      }, e3);
    }
  };
  return React__default.createElement(
    Raised,
    { styles: passedStyles },
    React__default.createElement(
      "div",
      { style: styles2.material, className: "material-picker " + className },
      React__default.createElement(EditableInput, {
        style: { wrap: styles2.HEXwrap, input: styles2.HEXinput, label: styles2.HEXlabel },
        label: "hex",
        value: hex,
        onChange: handleChange
      }),
      React__default.createElement(
        "div",
        { style: styles2.split, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: styles2.third },
          React__default.createElement(EditableInput, {
            style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
            label: "r",
            value: rgb.r,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: styles2.third },
          React__default.createElement(EditableInput, {
            style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
            label: "g",
            value: rgb.g,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: styles2.third },
          React__default.createElement(EditableInput, {
            style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
            label: "b",
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};
ColorWrap(Material);
var PhotoshopPicker = function PhotoshopPicker2(_ref2) {
  var onChange = _ref2.onChange, rgb = _ref2.rgb, hsv = _ref2.hsv, hex = _ref2.hex;
  var styles2 = _default$3({
    "default": {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  });
  var handleChange = function handleChange2(data2, e3) {
    if (data2["#"]) {
      isValidHex(data2["#"]) && onChange({
        hex: data2["#"],
        source: "hex"
      }, e3);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb.r,
        g: data2.g || rgb.g,
        b: data2.b || rgb.b,
        source: "rgb"
      }, e3);
    } else if (data2.h || data2.s || data2.v) {
      onChange({
        h: data2.h || hsv.h,
        s: data2.s || hsv.s,
        v: data2.v || hsv.v,
        source: "hsv"
      }, e3);
    }
  };
  return React__default.createElement(
    "div",
    { style: styles2.fields },
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "h",
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "s",
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "v",
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    React__default.createElement("div", { style: styles2.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "r",
      value: rgb.r,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "g",
      value: rgb.g,
      onChange: handleChange
    }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.RGBwrap, input: styles2.RGBinput, label: styles2.RGBlabel },
      label: "b",
      value: rgb.b,
      onChange: handleChange
    }),
    React__default.createElement("div", { style: styles2.divider }),
    React__default.createElement(EditableInput, {
      style: { wrap: styles2.HEXwrap, input: styles2.HEXinput, label: styles2.HEXlabel },
      label: "#",
      value: hex.replace("#", ""),
      onChange: handleChange
    }),
    React__default.createElement(
      "div",
      { style: styles2.fieldSymbols },
      React__default.createElement(
        "div",
        { style: styles2.symbol },
        "°"
      ),
      React__default.createElement(
        "div",
        { style: styles2.symbol },
        "%"
      ),
      React__default.createElement(
        "div",
        { style: styles2.symbol },
        "%"
      )
    )
  );
};
var PhotoshopPointerCircle$1 = function PhotoshopPointerCircle2(_ref2) {
  var hsl = _ref2.hsl;
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": hsl.l > 0.5 });
  return React__default.createElement("div", { style: styles2.picker });
};
var PhotoshopPointerCircle = function PhotoshopPointerCircle3() {
  var styles2 = _default$3({
    "default": {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: styles2.pointer },
    React__default.createElement(
      "div",
      { style: styles2.left },
      React__default.createElement("div", { style: styles2.leftInside })
    ),
    React__default.createElement(
      "div",
      { style: styles2.right },
      React__default.createElement("div", { style: styles2.rightInside })
    )
  );
};
var PhotoshopButton = function PhotoshopButton2(_ref2) {
  var onClick2 = _ref2.onClick, label = _ref2.label, children = _ref2.children, active3 = _ref2.active;
  var styles2 = _default$3({
    "default": {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    "active": {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: active3 });
  return React__default.createElement(
    "div",
    { style: styles2.button, onClick: onClick2 },
    label || children
  );
};
var PhotoshopPreviews = function PhotoshopPreviews2(_ref2) {
  var rgb = _ref2.rgb, currentColor = _ref2.currentColor;
  var styles2 = _default$3({
    "default": {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: currentColor,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      "div",
      { style: styles2.label },
      "new"
    ),
    React__default.createElement(
      "div",
      { style: styles2.swatches },
      React__default.createElement("div", { style: styles2.new }),
      React__default.createElement("div", { style: styles2.current })
    ),
    React__default.createElement(
      "div",
      { style: styles2.label },
      "current"
    )
  );
};
var _createClass$2 = function() {
  function defineProperties2(target, props) {
    for (var i2 = 0; i2 < props.length; i2++) {
      var descriptor = props[i2];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties2(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties2(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck$2(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1(self2, call2) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call2 && (typeof call2 === "object" || typeof call2 === "function") ? call2 : self2;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Photoshop = function(_React$Component) {
  _inherits$1(Photoshop2, _React$Component);
  function Photoshop2(props) {
    _classCallCheck$2(this, Photoshop2);
    var _this = _possibleConstructorReturn$1(this, (Photoshop2.__proto__ || Object.getPrototypeOf(Photoshop2)).call(this));
    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }
  _createClass$2(Photoshop2, [{
    key: "render",
    value: function render5() {
      var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === void 0 ? {} : _props$styles, _props$className = _props.className, className = _props$className === void 0 ? "" : _props$className;
      var styles2 = _default$3(merge$1({
        "default": {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, passedStyles));
      return React__default.createElement(
        "div",
        { style: styles2.picker, className: "photoshop-picker " + className },
        React__default.createElement(
          "div",
          { style: styles2.head },
          this.props.header
        ),
        React__default.createElement(
          "div",
          { style: styles2.body, className: "flexbox-fix" },
          React__default.createElement(
            "div",
            { style: styles2.saturation },
            React__default.createElement(Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: PhotoshopPointerCircle$1,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.hue },
            React__default.createElement(Hue, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: PhotoshopPointerCircle,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: styles2.controls },
            React__default.createElement(
              "div",
              { style: styles2.top, className: "flexbox-fix" },
              React__default.createElement(
                "div",
                { style: styles2.previews },
                React__default.createElement(PhotoshopPreviews, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              React__default.createElement(
                "div",
                { style: styles2.actions },
                React__default.createElement(PhotoshopButton, { label: "OK", onClick: this.props.onAccept, active: true }),
                React__default.createElement(PhotoshopButton, { label: "Cancel", onClick: this.props.onCancel }),
                React__default.createElement(PhotoshopPicker, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);
  return Photoshop2;
}(React__default.Component);
Photoshop.propTypes = {
  header: propTypesExports$1.string,
  styles: propTypesExports$1.object
};
Photoshop.defaultProps = {
  header: "Color Picker",
  styles: {}
};
ColorWrap(Photoshop);
var SketchFields = function SketchFields2(_ref2) {
  var onChange = _ref2.onChange, rgb = _ref2.rgb, hsl = _ref2.hsl, hex = _ref2.hex, disableAlpha = _ref2.disableAlpha;
  var styles2 = _default$3({
    "default": {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    "disableAlpha": {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha });
  var handleChange = function handleChange2(data2, e3) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e3);
    } else if (data2.r || data2.g || data2.b) {
      onChange({
        r: data2.r || rgb.r,
        g: data2.g || rgb.g,
        b: data2.b || rgb.b,
        a: rgb.a,
        source: "rgb"
      }, e3);
    } else if (data2.a) {
      if (data2.a < 0) {
        data2.a = 0;
      } else if (data2.a > 100) {
        data2.a = 100;
      }
      data2.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data2.a,
        source: "rgb"
      }, e3);
    }
  };
  return React__default.createElement(
    "div",
    { style: styles2.fields, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: styles2.double },
      React__default.createElement(EditableInput, {
        style: { input: styles2.input, label: styles2.label },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.single },
      React__default.createElement(EditableInput, {
        style: { input: styles2.input, label: styles2.label },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.single },
      React__default.createElement(EditableInput, {
        style: { input: styles2.input, label: styles2.label },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.single },
      React__default.createElement(EditableInput, {
        style: { input: styles2.input, label: styles2.label },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.alpha },
      React__default.createElement(EditableInput, {
        style: { input: styles2.input, label: styles2.label },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
};
var _extends$4 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var SketchPresetColors = function SketchPresetColors2(_ref2) {
  var colors = _ref2.colors, _ref$onClick = _ref2.onClick, onClick2 = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref2.onSwatchHover;
  var styles2 = _default$3({
    "default": {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !colors || !colors.length
  });
  var handleClick = function handleClick2(hex, e3) {
    onClick2({
      hex,
      source: "hex"
    }, e3);
  };
  return React__default.createElement(
    "div",
    { style: styles2.colors, className: "flexbox-fix" },
    colors.map(function(colorObjOrString) {
      var c2 = typeof colorObjOrString === "string" ? { color: colorObjOrString } : colorObjOrString;
      var key = "" + c2.color + (c2.title || "");
      return React__default.createElement(
        "div",
        { key, style: styles2.swatchWrap },
        React__default.createElement(Swatch$1, _extends$4({}, c2, {
          style: styles2.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c2.color
          }
        }))
      );
    })
  );
};
SketchPresetColors.propTypes = {
  colors: propTypesExports$1.arrayOf(propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.shape({
    color: propTypesExports$1.string,
    title: propTypesExports$1.string
  })])).isRequired
};
var _extends$3 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var Sketch = function Sketch2(_ref2) {
  var width = _ref2.width, rgb = _ref2.rgb, hex = _ref2.hex, hsv = _ref2.hsv, hsl = _ref2.hsl, onChange = _ref2.onChange, onSwatchHover = _ref2.onSwatchHover, disableAlpha = _ref2.disableAlpha, presetColors = _ref2.presetColors, renderers = _ref2.renderers, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": _extends$3({
      picker: {
        width,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, passedStyles),
    "disableAlpha": {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, passedStyles), { disableAlpha });
  return React__default.createElement(
    "div",
    { style: styles2.picker, className: "sketch-picker " + className },
    React__default.createElement(
      "div",
      { style: styles2.saturation },
      React__default.createElement(Saturation, {
        style: styles2.Saturation,
        hsl,
        hsv,
        onChange
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.controls, className: "flexbox-fix" },
      React__default.createElement(
        "div",
        { style: styles2.sliders },
        React__default.createElement(
          "div",
          { style: styles2.hue },
          React__default.createElement(Hue, {
            style: styles2.Hue,
            hsl,
            onChange
          })
        ),
        React__default.createElement(
          "div",
          { style: styles2.alpha },
          React__default.createElement(Alpha$2, {
            style: styles2.Alpha,
            rgb,
            hsl,
            renderers,
            onChange
          })
        )
      ),
      React__default.createElement(
        "div",
        { style: styles2.color },
        React__default.createElement(Checkboard, null),
        React__default.createElement("div", { style: styles2.activeColor })
      )
    ),
    React__default.createElement(SketchFields, {
      rgb,
      hsl,
      hex,
      onChange,
      disableAlpha
    }),
    React__default.createElement(SketchPresetColors, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover
    })
  );
};
Sketch.propTypes = {
  disableAlpha: propTypesExports$1.bool,
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  styles: propTypesExports$1.object
};
Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
ColorWrap(Sketch);
var SliderSwatch = function SliderSwatch2(_ref2) {
  var hsl = _ref2.hsl, offset = _ref2.offset, _ref$onClick = _ref2.onClick, onClick2 = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, active3 = _ref2.active, first = _ref2.first, last = _ref2.last;
  var styles2 = _default$3({
    "default": {
      swatch: {
        height: "12px",
        background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
        cursor: "pointer"
      }
    },
    "first": {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    "last": {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    "active": {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: active3, first, last });
  var handleClick = function handleClick2(e3) {
    return onClick2({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: "hsl"
    }, e3);
  };
  return React__default.createElement("div", { style: styles2.swatch, onClick: handleClick });
};
var SliderSwatches = function SliderSwatches2(_ref2) {
  var onClick2 = _ref2.onClick, hsl = _ref2.hsl;
  var styles2 = _default$3({
    "default": {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  });
  var epsilon2 = 0.1;
  return React__default.createElement(
    "div",
    { style: styles2.swatches },
    React__default.createElement(
      "div",
      { style: styles2.swatch },
      React__default.createElement(SliderSwatch, {
        hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.8) < epsilon2 && Math.abs(hsl.s - 0.5) < epsilon2,
        onClick: onClick2,
        first: true
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.swatch },
      React__default.createElement(SliderSwatch, {
        hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon2 && Math.abs(hsl.s - 0.5) < epsilon2,
        onClick: onClick2
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.swatch },
      React__default.createElement(SliderSwatch, {
        hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.5) < epsilon2 && Math.abs(hsl.s - 0.5) < epsilon2,
        onClick: onClick2
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.swatch },
      React__default.createElement(SliderSwatch, {
        hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon2 && Math.abs(hsl.s - 0.5) < epsilon2,
        onClick: onClick2
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.swatch },
      React__default.createElement(SliderSwatch, {
        hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.2) < epsilon2 && Math.abs(hsl.s - 0.5) < epsilon2,
        onClick: onClick2,
        last: true
      })
    ),
    React__default.createElement("div", { style: styles2.clear })
  );
};
var SliderPointer = function SliderPointer3() {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: styles2.picker });
};
var Slider = function Slider2(_ref2) {
  var hsl = _ref2.hsl, onChange = _ref2.onChange, pointer = _ref2.pointer, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  return React__default.createElement(
    "div",
    { style: styles2.wrap || {}, className: "slider-picker " + className },
    React__default.createElement(
      "div",
      { style: styles2.hue },
      React__default.createElement(Hue, {
        style: styles2.Hue,
        hsl,
        pointer,
        onChange
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.swatches },
      React__default.createElement(SliderSwatches, { hsl, onClick: onChange })
    )
  );
};
Slider.propTypes = {
  styles: propTypesExports$1.object
};
Slider.defaultProps = {
  pointer: SliderPointer,
  styles: {}
};
ColorWrap(Slider);
var CheckIcon = {};
Object.defineProperty(CheckIcon, "__esModule", {
  value: true
});
var _extends$2 = Object.assign || function(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = React__default;
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties$1(obj, keys4) {
  var target = {};
  for (var i2 in obj) {
    if (keys4.indexOf(i2) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i2))
      continue;
    target[i2] = obj[i2];
  }
  return target;
}
var DEFAULT_SIZE = 24;
var _default$1 = CheckIcon.default = function(_ref2) {
  var _ref$fill = _ref2.fill, fill = _ref$fill === void 0 ? "currentColor" : _ref$fill, _ref$width = _ref2.width, width = _ref$width === void 0 ? DEFAULT_SIZE : _ref$width, _ref$height = _ref2.height, height = _ref$height === void 0 ? DEFAULT_SIZE : _ref$height, _ref$style = _ref2.style, style2 = _ref$style === void 0 ? {} : _ref$style, props = _objectWithoutProperties$1(_ref2, ["fill", "width", "height", "style"]);
  return _react2.default.createElement(
    "svg",
    _extends$2({
      viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
      style: _extends$2({ fill, width, height }, style2)
    }, props),
    _react2.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
};
var SwatchesColor = function SwatchesColor2(_ref2) {
  var color = _ref2.color, _ref$onClick = _ref2.onClick, onClick2 = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, onSwatchHover = _ref2.onSwatchHover, first = _ref2.first, last = _ref2.last, active3 = _ref2.active;
  var styles2 = _default$3({
    "default": {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: color,
        marginBottom: "1px"
      },
      check: {
        color: getContrastingColor(color),
        marginLeft: "8px",
        display: "none"
      }
    },
    "first": {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    "last": {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    "active": {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    "transparent": {
      check: {
        color: "#333"
      }
    }
  }, {
    first,
    last,
    active: active3,
    "color-#FFFFFF": color === "#FFFFFF",
    "transparent": color === "transparent"
  });
  return React__default.createElement(
    Swatch$1,
    {
      color,
      style: styles2.color,
      onClick: onClick2,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: "0 0 4px " + color }
    },
    React__default.createElement(
      "div",
      { style: styles2.check },
      React__default.createElement(_default$1, null)
    )
  );
};
var SwatchesGroup = function SwatchesGroup2(_ref2) {
  var onClick2 = _ref2.onClick, onSwatchHover = _ref2.onSwatchHover, group = _ref2.group, active3 = _ref2.active;
  var styles2 = _default$3({
    "default": {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: styles2.group },
    map$2(group, function(color, i2) {
      return React__default.createElement(SwatchesColor, {
        key: color,
        color,
        active: color.toLowerCase() === active3,
        first: i2 === 0,
        last: i2 === group.length - 1,
        onClick: onClick2,
        onSwatchHover
      });
    })
  );
};
var Swatches = function Swatches2(_ref2) {
  var width = _ref2.width, height = _ref2.height, onChange = _ref2.onChange, onSwatchHover = _ref2.onSwatchHover, colors = _ref2.colors, hex = _ref2.hex, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        width,
        height
      },
      overflow: {
        height,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, passedStyles));
  var handleChange = function handleChange2(data2, e3) {
    return onChange({ hex: data2, source: "hex" }, e3);
  };
  return React__default.createElement(
    "div",
    { style: styles2.picker, className: "swatches-picker " + className },
    React__default.createElement(
      Raised,
      null,
      React__default.createElement(
        "div",
        { style: styles2.overflow },
        React__default.createElement(
          "div",
          { style: styles2.body },
          map$2(colors, function(group) {
            return React__default.createElement(SwatchesGroup, {
              key: group.toString(),
              group,
              active: hex,
              onClick: handleChange,
              onSwatchHover
            });
          }),
          React__default.createElement("div", { style: styles2.clear })
        )
      )
    )
  );
};
Swatches.propTypes = {
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  colors: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.string)),
  styles: propTypesExports$1.object
  /* eslint-disable max-len */
};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red["900"], red["700"], red["500"], red["300"], red["100"]], [pink["900"], pink["700"], pink["500"], pink["300"], pink["100"]], [purple["900"], purple["700"], purple["500"], purple["300"], purple["100"]], [deepPurple["900"], deepPurple["700"], deepPurple["500"], deepPurple["300"], deepPurple["100"]], [indigo["900"], indigo["700"], indigo["500"], indigo["300"], indigo["100"]], [blue["900"], blue["700"], blue["500"], blue["300"], blue["100"]], [lightBlue["900"], lightBlue["700"], lightBlue["500"], lightBlue["300"], lightBlue["100"]], [cyan["900"], cyan["700"], cyan["500"], cyan["300"], cyan["100"]], [teal["900"], teal["700"], teal["500"], teal["300"], teal["100"]], ["#194D33", green["700"], green["500"], green["300"], green["100"]], [lightGreen["900"], lightGreen["700"], lightGreen["500"], lightGreen["300"], lightGreen["100"]], [lime["900"], lime["700"], lime["500"], lime["300"], lime["100"]], [yellow["900"], yellow["700"], yellow["500"], yellow["300"], yellow["100"]], [amber["900"], amber["700"], amber["500"], amber["300"], amber["100"]], [orange["900"], orange["700"], orange["500"], orange["300"], orange["100"]], [deepOrange["900"], deepOrange["700"], deepOrange["500"], deepOrange["300"], deepOrange["100"]], [brown["900"], brown["700"], brown["500"], brown["300"], brown["100"]], [blueGrey["900"], blueGrey["700"], blueGrey["500"], blueGrey["300"], blueGrey["100"]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
ColorWrap(Swatches);
var Twitter = function Twitter2(_ref2) {
  var onChange = _ref2.onChange, onSwatchHover = _ref2.onSwatchHover, hex = _ref2.hex, colors = _ref2.colors, width = _ref2.width, triangle = _ref2.triangle, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      card: {
        width,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, passedStyles), {
    "hide-triangle": triangle === "hide",
    "top-left-triangle": triangle === "top-left",
    "top-right-triangle": triangle === "top-right"
  });
  var handleChange = function handleChange2(hexcode, e3) {
    isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: "hex"
    }, e3);
  };
  return React__default.createElement(
    "div",
    { style: styles2.card, className: "twitter-picker " + className },
    React__default.createElement("div", { style: styles2.triangleShadow }),
    React__default.createElement("div", { style: styles2.triangle }),
    React__default.createElement(
      "div",
      { style: styles2.body },
      map$2(colors, function(c2, i2) {
        return React__default.createElement(Swatch$1, {
          key: i2,
          color: c2,
          hex: c2,
          style: styles2.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: "0 0 4px " + c2
          }
        });
      }),
      React__default.createElement(
        "div",
        { style: styles2.hash },
        "#"
      ),
      React__default.createElement(EditableInput, {
        label: null,
        style: { input: styles2.input },
        value: hex.replace("#", ""),
        onChange: handleChange
      }),
      React__default.createElement("div", { style: styles2.clear })
    )
  );
};
Twitter.propTypes = {
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  triangle: propTypesExports$1.oneOf(["hide", "top-left", "top-right"]),
  colors: propTypesExports$1.arrayOf(propTypesExports$1.string),
  styles: propTypesExports$1.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
ColorWrap(Twitter);
var GooglePointerCircle = function GooglePointerCircle2(props) {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
      }
    }
  });
  return React__default.createElement("div", { style: styles2.picker });
};
GooglePointerCircle.propTypes = {
  hsl: propTypesExports$1.shape({
    h: propTypesExports$1.number,
    s: propTypesExports$1.number,
    l: propTypesExports$1.number,
    a: propTypesExports$1.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GooglePointer = function GooglePointer2(props) {
  var styles2 = _default$3({
    "default": {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return React__default.createElement("div", { style: styles2.picker });
};
GooglePointer.propTypes = {
  hsl: propTypesExports$1.shape({
    h: propTypesExports$1.number,
    s: propTypesExports$1.number,
    l: propTypesExports$1.number,
    a: propTypesExports$1.number
  })
};
GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GoogleFields = function GoogleFields2(_ref2) {
  var onChange = _ref2.onChange, rgb = _ref2.rgb, hsl = _ref2.hsl, hex = _ref2.hex, hsv = _ref2.hsv;
  var handleChange = function handleChange2(data2, e3) {
    if (data2.hex) {
      isValidHex(data2.hex) && onChange({
        hex: data2.hex,
        source: "hex"
      }, e3);
    } else if (data2.rgb) {
      var values4 = data2.rgb.split(",");
      isvalidColorString(data2.rgb, "rgb") && onChange({
        r: values4[0],
        g: values4[1],
        b: values4[2],
        a: 1,
        source: "rgb"
      }, e3);
    } else if (data2.hsv) {
      var _values = data2.hsv.split(",");
      if (isvalidColorString(data2.hsv, "hsv")) {
        _values[2] = _values[2].replace("%", "");
        _values[1] = _values[1].replace("%", "");
        _values[0] = _values[0].replace("°", "");
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: "hsv"
        }, e3);
      }
    } else if (data2.hsl) {
      var _values2 = data2.hsl.split(",");
      if (isvalidColorString(data2.hsl, "hsl")) {
        _values2[2] = _values2[2].replace("%", "");
        _values2[1] = _values2[1].replace("%", "");
        _values2[0] = _values2[0].replace("°", "");
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: "hsl"
        }, e3);
      }
    }
  };
  var styles2 = _default$3({
    "default": {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  });
  var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
  var hslValue = Math.round(hsl.h) + "°, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
  var hsvValue = Math.round(hsv.h) + "°, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
  return React__default.createElement(
    "div",
    { style: styles2.wrap, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: styles2.fields },
      React__default.createElement(
        "div",
        { style: styles2.double },
        React__default.createElement(EditableInput, {
          style: { input: styles2.input, label: styles2.label },
          label: "hex",
          value: hex,
          onChange: handleChange
        })
      ),
      React__default.createElement(
        "div",
        { style: styles2.column },
        React__default.createElement(
          "div",
          { style: styles2.single },
          React__default.createElement(EditableInput, {
            style: { input: styles2.input2, label: styles2.label2 },
            label: "rgb",
            value: rgbValue,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: styles2.single },
          React__default.createElement(EditableInput, {
            style: { input: styles2.input2, label: styles2.label2 },
            label: "hsv",
            value: hsvValue,
            onChange: handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: styles2.single },
          React__default.createElement(EditableInput, {
            style: { input: styles2.input2, label: styles2.label2 },
            label: "hsl",
            value: hslValue,
            onChange: handleChange
          })
        )
      )
    )
  );
};
var Google = function Google2(_ref2) {
  var width = _ref2.width, onChange = _ref2.onChange, rgb = _ref2.rgb, hsl = _ref2.hsl, hsv = _ref2.hsv, hex = _ref2.hex, header = _ref2.header, _ref$styles = _ref2.styles, passedStyles = _ref$styles === void 0 ? {} : _ref$styles, _ref$className = _ref2.className, className = _ref$className === void 0 ? "" : _ref$className;
  var styles2 = _default$3(merge$1({
    "default": {
      picker: {
        width,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, passedStyles));
  return React__default.createElement(
    "div",
    { style: styles2.picker, className: "google-picker " + className },
    React__default.createElement(
      "div",
      { style: styles2.head },
      header
    ),
    React__default.createElement("div", { style: styles2.swatch }),
    React__default.createElement(
      "div",
      { style: styles2.saturation },
      React__default.createElement(Saturation, {
        hsl,
        hsv,
        pointer: GooglePointerCircle,
        onChange
      })
    ),
    React__default.createElement(
      "div",
      { style: styles2.body },
      React__default.createElement(
        "div",
        { style: styles2.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: styles2.hue },
          React__default.createElement(Hue, {
            style: styles2.Hue,
            hsl,
            radius: "4px",
            pointer: GooglePointer,
            onChange
          })
        )
      ),
      React__default.createElement(GoogleFields, {
        rgb,
        hsl,
        hex,
        hsv,
        onChange
      })
    )
  );
};
Google.propTypes = {
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  styles: propTypesExports$1.object,
  header: propTypesExports$1.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
ColorWrap(Google);
const curatedColor = (value, defaultValue2) => {
  if (value || value === 0)
    return ColorUtil.convertToRGB(value);
  return ColorUtil.convertToRGB(defaultValue2);
};
function ColorInput(props) {
  const {
    value,
    onChange,
    disabled,
    fallbackValue,
    height,
    ...restProps
  } = props;
  const getColor2 = React__default.useCallback((v5) => curatedColor(v5, fallbackValue), [fallbackValue]);
  const [rgba, setRgba] = React__default.useState(getColor2(value));
  React__default.useLayoutEffect(() => {
    setRgba(getColor2(value));
  }, [getColor2, value]);
  const onChangeInput = React__default.useCallback((e3) => {
    const rgba2 = getColor2(e3.target.value);
    setRgba(rgba2);
    onChange(rgba2);
  }, [getColor2, onChange]);
  const onChangePicker = React__default.useCallback((c2) => {
    const rgba2 = c2.rgb;
    setRgba(rgba2);
    onChange(rgba2);
  }, [onChange]);
  const overlay = React__default.useCallback(() => /* @__PURE__ */ jsxs("div", { children: [
    " ",
    /* @__PURE__ */ jsx(ChromePicker, { color: rgba, enableAlpha: true, onChange: onChangePicker }),
    " "
  ] }), [onChangePicker, rgba]);
  return /* @__PURE__ */ jsx(Input$2, { ...restProps, disabled, value: ColorUtil.convertToHex(rgba), onChange: onChangeInput, style: {
    height
  }, suffix: /* @__PURE__ */ jsx(Dropdown, { trigger: ["click"], overlay, disabled, children: /* @__PURE__ */ jsx(Button, { style: {
    background: `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`
  }, disabled, children: " " }) }) });
}
ColorInput.propTypes = {
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.shape({
    r: propTypesExports$1.number,
    // [0-255]
    g: propTypesExports$1.number,
    // [0-255]
    b: propTypesExports$1.number,
    // [0-255]
    a: propTypesExports$1.number
    // [0-1]
  })]),
  color: propTypesExports$1.string,
  disabled: propTypesExports$1.bool,
  fallbackValue: propTypesExports$1.string,
  height: propTypesExports$1.string
};
ColorInput.defaultProps = {
  onChange: () => {
  },
  value: void 0,
  color: void 0,
  disabled: false,
  fallbackValue: "#FFFFFF",
  height: "32px"
};
function MapLayout(props) {
  var _a3, _b3, _c2, _d2, _e2;
  const {
    rightContent,
    footerContent,
    headerContent,
    leftContent,
    children,
    pixelSize
  } = props;
  const {
    ref: targetRef,
    ...size12
  } = useLayoutDimensions();
  const windowHeight = (size12 == null ? void 0 : size12.height) || 0;
  const windowWidth = (size12 == null ? void 0 : size12.width) || 0;
  const dimensions = React__default.useMemo(() => {
    const dimensions2 = {
      ...pixelSize,
      center: {
        width: windowWidth,
        height: windowHeight
      }
    };
    if (!leftContent)
      delete dimensions2.leftPanel;
    if (!rightContent)
      delete dimensions2.rightPanel;
    if (!headerContent)
      delete dimensions2.header;
    if (!footerContent)
      delete dimensions2.footer;
    Object.keys(dimensions2).forEach((key) => {
      var _a4, _b4;
      if (key === "leftPanel" || key === "rightPanel") {
        dimensions2.center.width -= ((_a4 = dimensions2[key]) == null ? void 0 : _a4.width) || 0;
      }
      if (key === "header" || key === "footer") {
        dimensions2.center.height -= ((_b4 = dimensions2[key]) == null ? void 0 : _b4.height) || 0;
      }
    });
    if (dimensions2.center && dimensions2.leftPanel) {
      dimensions2.leftPanel.height = dimensions2.center.height;
    }
    if (dimensions2.center && dimensions2.rightPanel) {
      dimensions2.rightPanel.height = dimensions2.center.height;
    }
    Object.keys(dimensions2).forEach((key) => {
      if (!dimensions2[key])
        return;
      const {
        width,
        height
      } = dimensions2[key] || {};
      dimensions2[key] = {
        width: `${width}px`,
        height: `${height}px`
      };
    });
    return dimensions2;
  }, [footerContent, headerContent, leftContent, pixelSize, rightContent, windowHeight, windowWidth]);
  const styles2 = React__default.useMemo(() => ({
    container: {
      width: "100%",
      height: "100%"
    },
    clientAreaContainer: {
      display: "flex",
      overflow: "hidden",
      width: "100%",
      height: "100%"
    },
    centerPanel: {
      width: dimensions.center.width,
      height: dimensions.center.height,
      position: "relative"
    }
  }), [dimensions.center.height, dimensions.center.width]);
  const hasValidHeight = !!((_a3 = dimensions == null ? void 0 : dimensions.center) == null ? void 0 : _a3.height) && dimensions.center.height !== "0px";
  return /* @__PURE__ */ jsxs(Layout, { ref: targetRef, style: styles2.container, children: [
    headerContent && ((_b3 = dimensions.header) == null ? void 0 : _b3.height) && /* @__PURE__ */ jsx(Layout.Header, { style: {
      width: dimensions.header.width,
      height: dimensions.header.height,
      position: "sticky",
      alignItems: "center",
      padding: 0,
      margin: 0,
      zIndex: 2
    }, children: headerContent }),
    /* @__PURE__ */ jsxs(Layout, { style: styles2.clientAreaContainer, children: [
      leftContent && ((_c2 = dimensions.leftPanel) == null ? void 0 : _c2.width) && /* @__PURE__ */ jsx(Layout.Sider, { style: {
        height: dimensions.leftPanel.height,
        zIndex: 1
      }, width: dimensions.leftPanel.width, children: leftContent }),
      /* @__PURE__ */ jsx("div", { style: styles2.centerPanel, children: hasValidHeight && children }),
      rightContent && ((_d2 = dimensions.rightPanel) == null ? void 0 : _d2.width) && /* @__PURE__ */ jsx(Layout.Sider, { style: {
        height: dimensions.rightPanel.height,
        zIndex: 1
      }, width: dimensions.rightPanel.width, children: rightContent })
    ] }),
    footerContent && ((_e2 = dimensions.footer) == null ? void 0 : _e2.height) && /* @__PURE__ */ jsx(Layout.Footer, { style: {
      width: dimensions.footer.width,
      height: dimensions.footer.height,
      alignItems: "center",
      justifyContent: "center"
    }, children: footerContent })
  ] });
}
const PropTypesSize = propTypesExports$1.shape({
  width: propTypesExports$1.number,
  // px size number
  height: propTypesExports$1.number
  // px size number
});
MapLayout.propTypes = {
  children: propTypesExports$1.node,
  headerContent: propTypesExports$1.node,
  footerContent: propTypesExports$1.node,
  leftContent: propTypesExports$1.node,
  rightContent: propTypesExports$1.node,
  pixelSize: propTypesExports$1.shape({
    header: PropTypesSize,
    footer: PropTypesSize,
    left: PropTypesSize,
    right: PropTypesSize
  })
};
MapLayout.defaultProps = {
  children: null,
  headerContent: null,
  footerContent: null,
  leftContent: null,
  rightContent: null,
  pixelSize: {}
};
function MenuBar(props) {
  const {
    items,
    width,
    onClick: onClickIn,
    active: active3,
    ...restProps
  } = props;
  const onClick2 = React__default.useCallback((state) => {
    const {
      key
    } = state || {};
    let final = null;
    if (items.map((item) => item.key).includes(key)) {
      if (active3 === key)
        final = null;
      else
        final = key;
    }
    onClickIn(final);
  }, [active3, items, onClickIn]);
  const selectedKeys = React__default.useMemo(() => {
    const selectedKeys2 = [];
    if (active3)
      selectedKeys2.push(active3);
    return selectedKeys2;
  }, [active3]);
  return /* @__PURE__ */ jsx(Menu, { mode: "inline", theme: "dark", inlineCollapsed: true, items, onClick: onClick2, style: {
    width
  }, selectedKeys, ...restProps });
}
MenuBar.propTypes = {
  items: propTypesExports$1.array,
  width: propTypesExports$1.string,
  onClick: propTypesExports$1.func,
  active: propTypesExports$1.string
};
MenuBar.defaultProps = {
  items: [],
  width: "100%",
  onClick: () => {
  },
  active: ""
};
function createItem(key, icon, disabled, tooltip, children, type) {
  let finalDisabled = disabled;
  if (typeof disabled !== "boolean") {
    finalDisabled = Array.isArray(disabled) ? disabled.includes(key) : false;
  }
  return {
    key,
    icon,
    disabled: finalDisabled,
    children,
    label: tooltip && /* @__PURE__ */ jsx("span", { children: tooltip }),
    type
  };
}
MenuBar.createItem = createItem;
const ModalForm = React__default.forwardRef((props, refIn) => {
  const {
    component: Component2,
    onCancel: onCancelIn,
    onSubmit,
    active: active3,
    formProps,
    children,
    title,
    formValues,
    onChange,
    style: style2,
    validateOnCancel,
    okText,
    showErrors,
    ...restProps
  } = props;
  const [form] = Form.useForm();
  React__default.useLayoutEffect(() => {
    if (refIn) {
      if (typeof refIn === "function") {
        refIn(form);
      } else {
        refIn.current = form;
      }
    }
    return () => {
      if (refIn) {
        if (typeof refIn === "function") {
          refIn(null);
        } else {
          refIn.current = null;
        }
      }
    };
  }, [form, refIn]);
  React__default.useLayoutEffect(() => {
    if (!active3)
      return;
    if (Object.keys(formValues).length) {
      form.setFieldsValue({
        ...formValues
      });
    }
  }, [active3, form, formValues]);
  const customizeRequiredMark = (label, {
    required: required2
  }) => /* @__PURE__ */ jsxs(Fragment, { children: [
    label,
    required2 && /* @__PURE__ */ jsx("span", { style: {
      color: "red",
      paddingRight: "4px"
    }, children: "*" })
  ] });
  const onOk = React__default.useCallback(() => {
    if (restProps == null ? void 0 : restProps.ignoreValidation) {
      onSubmit();
      return;
    }
    form.validateFields().then((values4) => {
      form.resetFields();
      onSubmit(values4);
    }).catch((info) => {
      var _a3;
      if (!showErrors)
        console.error("Validation Failed:", info);
      const data2 = form.getFieldsError().find(({
        errors
      }) => !!(errors == null ? void 0 : errors.length));
      if (((_a3 = data2 == null ? void 0 : data2.errors) == null ? void 0 : _a3[0]) && showErrors) {
        message$1.error(data2.errors[0]);
      }
    });
  }, [form, onSubmit, showErrors, restProps == null ? void 0 : restProps.ignoreValidation]);
  const onCancel = React__default.useCallback(() => {
    if (!validateOnCancel) {
      onCancelIn();
    } else {
      form.validateFields().then((values4) => {
        form.resetFields();
        onCancelIn(values4);
      }).catch((info) => {
        console.error("Validation Failed:", info);
      });
    }
  }, [form, onCancelIn, validateOnCancel]);
  if (!active3)
    return null;
  return /* @__PURE__ */ jsx(Component2, { title, style: {
    top: 20,
    ...style2
  }, open: true, okText, onOk, onCancel, ...restProps, children: /* @__PURE__ */ jsx(Form, { form, layout: "vertical", autoComplete: "off", requiredMark: customizeRequiredMark, onValuesChange: (changedData, allData) => onChange(allData, form), onFinish: onOk, ...formProps, children }) });
});
ModalForm.propTypes = {
  title: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.node]),
  onCancel: propTypesExports$1.func,
  onSubmit: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  showErrors: propTypesExports$1.bool,
  formProps: propTypesExports$1.object,
  formValues: propTypesExports$1.object,
  validateOnCancel: propTypesExports$1.bool,
  children: propTypesExports$1.node,
  active: propTypesExports$1.bool,
  component: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.func]),
  style: propTypesExports$1.object,
  okText: propTypesExports$1.string,
  nofooter: propTypesExports$1.bool
};
ModalForm.defaultProps = {
  title: "",
  onCancel: () => {
  },
  onSubmit: () => {
  },
  onChange: () => {
  },
  showErrors: false,
  formProps: {},
  formValues: {},
  validateOnCancel: false,
  children: null,
  active: false,
  component: Modal$1,
  style: {},
  okText: "Submit",
  nofooter: false
};
function TextLabel(props) {
  const {
    children,
    style: style2
  } = props;
  const {
    Text: Text2
  } = Typography;
  const styles2 = React__default.useMemo(() => ({
    label: {
      ...style2
    }
  }), [style2]);
  return /* @__PURE__ */ jsx(Text2, { style: styles2.label, children });
}
TextLabel.propTypes = {
  children: propTypesExports$1.node,
  style: propTypesExports$1.object
};
TextLabel.defaultProps = {
  children: "",
  style: {}
};
function ToggleButton(props) {
  const {
    icon,
    active: active3,
    onToggle,
    disabled,
    tooltip
  } = props;
  return /* @__PURE__ */ jsx(Tooltip$1, { tooltip, children: /* @__PURE__ */ jsx(Button, { onClick: () => onToggle(!active3), type: active3 ? "primary" : "default", style: {
    borderRadius: 7,
    border: "none",
    padding: 0
  }, icon, disabled }) });
}
ToggleButton.propTypes = {
  icon: propTypesExports$1.node,
  active: propTypesExports$1.bool,
  disabled: propTypesExports$1.bool,
  onToggle: propTypesExports$1.func,
  tooltip: propTypesExports$1.node
};
ToggleButton.defaultProps = {
  icon: null,
  active: false,
  disabled: false,
  onToggle: () => {
  },
  tooltip: null
};
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default.createContext && React__default.createContext(DefaultContext);
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s2, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s2 = arguments[i2];
      for (var p2 in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p2))
          t2[p2] = s2[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __rest = globalThis && globalThis.__rest || function(s2, e3) {
  var t2 = {};
  for (var p2 in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p2) && e3.indexOf(p2) < 0)
      t2[p2] = s2[p2];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s2); i2 < p2.length; i2++) {
      if (e3.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p2[i2]))
        t2[p2[i2]] = s2[p2[i2]];
    }
  return t2;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i2) {
    return React__default.createElement(node.tag, __assign({
      key: i2
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data2) {
  return function(props) {
    return React__default.createElement(IconBase, __assign({
      attr: __assign({}, data2.attr)
    }, props), Tree2Element(data2.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr2 = props.attr, size12 = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size12 || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return React__default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr2, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && React__default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? React__default.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
function AiOutlineUpload(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 1024 1024" }, "child": [{ "tag": "path", "attr": { "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z" } }] })(props);
}
const SupportedFilesText = [
  "CAD files (DWG, DXF)",
  // '3D models',
  "JSON files",
  "GEOJSON files",
  "KML/KMZ files",
  "SHP files",
  "TIFF files",
  "CSV files"
];
const {
  useToken: useToken$C
} = theme$2;
function UploadBox(props) {
  const {
    extensions,
    onLoad,
    outputType,
    progressBar,
    onCancel,
    ...restProps
  } = props;
  const {
    token
  } = useToken$C();
  const preferredReaderTypes = useConfigStore((state) => state.preferredReaderTypes);
  const accept = React__default.useMemo(() => extensions.map((ext) => `.${ext}`).join(",").replaceAll(" ", "") || "*.*", [extensions]);
  const [isLoading, setIsLoading] = React__default.useState(false);
  const onSelect = React__default.useCallback((file2) => {
    var _a3, _b3, _c2;
    const extension = (_c2 = (_b3 = (_a3 = file2 == null ? void 0 : file2.name) == null ? void 0 : _a3.split(".")) == null ? void 0 : _b3.pop()) == null ? void 0 : _c2.toLowerCase();
    const finalOutputType = outputType || preferredReaderTypes[extension];
    if (finalOutputType) {
      setIsLoading(true);
      FileUtil.importFromFile(file2, finalOutputType).then((result) => {
        setIsLoading(false);
        onLoad(result);
      }).catch((error2) => {
        setIsLoading(false);
        console.error(error2);
      });
    } else {
      onLoad(file2);
    }
  }, [onLoad, setIsLoading, outputType, preferredReaderTypes]);
  const onChange = React__default.useCallback((info) => {
    const {
      status
    } = info.file;
    if (status === "done") {
      message$1.success(`${info.file.name} file uploaded successfully.`);
      onSelect(info.file);
    } else if (status === "error") {
      message$1.error(`${info.file.name} file upload failed.`);
    }
  }, [onSelect]);
  const onDrop = React__default.useCallback((e3) => {
    var _a3, _b3, _c2;
    const filename2 = (_c2 = (_b3 = (_a3 = e3 == null ? void 0 : e3.dataTransfer) == null ? void 0 : _a3.files) == null ? void 0 : _b3[0]) == null ? void 0 : _c2.name;
    const extension = filename2 == null ? void 0 : filename2.split(".").pop().toLowerCase();
    if (extension && !extensions.includes(extension)) {
      message$1.error(`Unsupported file type ${filename2}.`);
      return false;
    }
    return true;
  }, [extensions]);
  const customRequest = React__default.useCallback(({
    onSuccess
  }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  }, []);
  const styles2 = React__default.useMemo(() => ({
    container: {
      textAlign: "center",
      width: "80%",
      height: "300px",
      margin: "10%",
      alignSelf: "center"
    },
    dropZone: {
      width: "485px"
    },
    icon: {
      marginInline: "1%",
      fontSize: "36px",
      color: token.colorText
    }
  }), [token.colorText]);
  if (isLoading && progressBar)
    return progressBar();
  return /* @__PURE__ */ jsx(Space, { style: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, children: /* @__PURE__ */ jsxs(Upload.Dragger, { ...restProps, maxCount: 1, onChange, onDrop, accept, customRequest, showUploadList: false, style: styles2.dropZone, children: [
    /* @__PURE__ */ jsx(Space, { style: {
      position: "relative",
      borderRadius: "50%"
    }, children: /* @__PURE__ */ jsx(AiOutlineUpload, { style: {
      position: "relative",
      width: "40px",
      height: "40px",
      color: token.colorLink
    } }) }),
    /* @__PURE__ */ jsxs(Space, { style: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        margin: 0
      }, children: "Click or drag file to this area to upload" }),
      /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", style: {
        margin: 0
      }, children: "Supported Formats:" }),
      /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", style: {
        margin: 0
      }, children: SupportedFilesText.join(" · ") })
    ] })
  ] }) });
}
UploadBox.propTypes = {
  name: propTypesExports$1.string,
  extensions: propTypesExports$1.arrayOf(propTypesExports$1.string),
  onLoad: propTypesExports$1.func,
  progressBar: propTypesExports$1.func,
  onCancel: propTypesExports$1.func,
  outputType: propTypesExports$1.oneOf(["dataUrl", "buffer", "text"])
};
UploadBox.defaultProps = {
  name: "file",
  extensions: [],
  onLoad: () => {
  },
  progressBar: null,
  onCancel: () => {
  },
  outputType: null
};
const {
  useToken: useToken$B
} = theme$2;
function Input$1(props) {
  const {
    placeholder: placeholder2,
    onChange,
    style: styleIn,
    filled,
    ...rest
  } = props;
  const {
    token
  } = useToken$B();
  const style2 = React__default.useMemo(() => ({
    ...styleIn,
    ...filled ? {
      borderRadius: "4px",
      border: `1px solid ${token.colorBorder}`
    } : {}
  }), [styleIn, filled, token.colorBorder]);
  return /* @__PURE__ */ jsx(Input$2, { placeholder: placeholder2, style: style2, onChange, variant: filled ? "filled" : void 0, ...rest });
}
Input$1.propTypes = {
  placeholder: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  style: propTypesExports$1.object,
  filled: propTypesExports$1.bool
};
Input$1.defaultProps = {
  onChange: () => {
  },
  placeholder: "Name",
  style: {},
  filled: false
};
const {
  useToken: useToken$A
} = theme$2;
function InputNumber(props) {
  const {
    placeholder: placeholder2,
    onChange,
    style: styleIn,
    filled,
    ...rest
  } = props;
  const {
    token
  } = useToken$A();
  const style2 = React__default.useMemo(() => ({
    ...styleIn,
    ...filled ? {
      borderRadius: "4px",
      border: `1px solid ${token.colorBorder}`
    } : {}
  }), [styleIn, filled, token.colorBorder]);
  return /* @__PURE__ */ jsx(InputNumber$1, { placeholder: placeholder2, style: {
    padding: "3px 0px",
    ...style2
  }, onChange, controls: false, variant: filled ? "filled" : null, ...rest });
}
InputNumber.propTypes = {
  placeholder: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  style: propTypesExports$1.object,
  filled: propTypesExports$1.bool
};
InputNumber.defaultProps = {
  onChange: () => {
  },
  placeholder: "Enter number",
  style: {},
  filled: false
};
const customSelect = "";
const {
  useToken: useToken$z
} = theme$2;
function Select(props) {
  const {
    style: styleIn,
    data: data2,
    ...restProps
  } = props;
  const {
    token
  } = useToken$z();
  const options2 = React__default.useMemo(() => {
    const options22 = data2 == null ? void 0 : data2.map((item) => ({
      value: item.value,
      disabled: item.disabled,
      label: /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        alignItems: "center",
        gap: 12
      }, children: [
        (item == null ? void 0 : item.icon) && item.icon,
        item.label
      ] })
    }));
    return options22;
  }, [data2]);
  const allProps = React__default.useMemo(() => ({
    variant: "filled",
    ...restProps
  }), [restProps]);
  const style2 = React__default.useMemo(() => ({
    border: `1px solid ${token == null ? void 0 : token.colorBorder}`,
    borderRadius: token.borderRadius,
    fontColor: token.colorText,
    ...styleIn
  }), [token, styleIn]);
  return /* @__PURE__ */ jsx(ConfigProvider, { theme: {
    components: {
      Select: {
        colorText: style2.fontColor
      }
    }
  }, children: /* @__PURE__ */ jsx(Select$1, { style: {
    height: "32px",
    ...style2
  }, ...allProps, options: options2, suffixIcon: /* @__PURE__ */ jsx(DownOutlined, { style: {
    fontSize: "12px"
  } }) }) });
}
Select.propTypes = {
  data: propTypesExports$1.arrayOf(propTypesExports$1.object),
  style: propTypesExports$1.object
};
Select.defaultProps = {
  data: [],
  style: {}
};
function Modal(props) {
  const {
    children,
    style: style2,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsx(Modal$1, { closable: false, style: {
    border: 0,
    position: "relative",
    top: "20%",
    ...style2
  }, footer: null, maskClosable: true, ...restProps, children });
}
const fullModal = "";
function FullModal(props) {
  const {
    children,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsx(Modal$1, { ...restProps, width: "100%", styles: {
    height: "100vh",
    content: {
      overflow: "hidden"
    }
  }, className: "full-modal", style: {
    top: 0,
    left: "0px",
    margin: 0,
    padding: 0,
    width: "100%",
    height: "100vh",
    maxWidth: "100%",
    maxHeight: "100vh"
  }, children });
}
FullModal.propTypes = {
  children: propTypesExports$1.node
};
FullModal.defaultProps = {
  children: null
};
function OverlayPanel(props) {
  const {
    children,
    placement: placementIn,
    width,
    height,
    marginHorizontal,
    marginVertical,
    backgroundColor,
    containerStyle: containerStyle2,
    style: style2
  } = props;
  const placement = React__default.useMemo(() => {
    var _a3, _b3;
    const vertical = ((_a3 = placementIn == null ? void 0 : placementIn.split("-")) == null ? void 0 : _a3[0]) || "bottom";
    const horizontal = ((_b3 = placementIn == null ? void 0 : placementIn.split("-")) == null ? void 0 : _b3[1]) || "left";
    return {
      vertical,
      horizontal
    };
  }, [placementIn]);
  const parentStyle = React__default.useMemo(() => {
    const parentPlacement = {};
    if (placement.vertical === "top") {
      parentPlacement.top = marginVertical;
    } else {
      parentPlacement.bottom = marginVertical;
    }
    if (placement.horizontal === "left") {
      parentPlacement.left = marginHorizontal;
    } else {
      parentPlacement.right = marginHorizontal;
    }
    return {
      position: "absolute",
      zIndex: 1e3,
      backgroundColor,
      width,
      height,
      display: "initial",
      ...parentPlacement,
      ...containerStyle2
    };
  }, [placement.vertical, placement.horizontal, backgroundColor, width, height, marginVertical, marginHorizontal, containerStyle2]);
  if (!height || !width)
    return null;
  return /* @__PURE__ */ jsx("div", { style: {
    ...parentStyle
  }, children: /* @__PURE__ */ jsx("div", { style: {
    height: "100%",
    padding: "0",
    overflow: "hidden",
    position: "relative",
    marginTop: "0px",
    ...style2
  }, children }) });
}
OverlayPanel.propTypes = {
  children: propTypesExports$1.node,
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  backgroundColor: propTypesExports$1.string,
  containerStyle: propTypesExports$1.object,
  style: propTypesExports$1.object
};
OverlayPanel.defaultProps = {
  children: "",
  placement: "bottom-left",
  width: 0,
  height: 0,
  marginHorizontal: 0,
  marginVertical: 0,
  backgroundColor: "transparent",
  containerStyle: {},
  style: {}
};
const STYLE$1 = {
  height: "100%",
  padding: "6px 6px 6px 6px",
  overflow: "auto",
  borderRadius: "0px",
  border: "none"
};
function NoModalOverlay(props) {
  const {
    title,
    onOk,
    onCancel,
    children,
    open: open2,
    okText,
    cancelText,
    placement,
    marginVertical,
    marginHorizontal,
    closable,
    closeIcon,
    nofooter,
    verticalAction,
    showCancel,
    footerStyle: footerStyle2
  } = props;
  const extra = React__default.useMemo(() => {
    if (!closable || !closeIcon)
      return null;
    return /* @__PURE__ */ jsx(Button, { type: "text", icon: closeIcon, onClick: onCancel });
  }, [closable, closeIcon, onCancel]);
  if (!open2)
    return null;
  return /* @__PURE__ */ jsx(OverlayPanel, { placement, width: 344, height: `calc(100% - ${marginVertical}px)`, marginHorizontal, marginVertical, containerStyle: {
    zIndex: 1001
  }, children: /* @__PURE__ */ jsxs(Card, { title, style: STYLE$1, bordered: 0, extra, styles: {
    header: {
      border: "none"
    }
  }, children: [
    children,
    !nofooter && /* @__PURE__ */ jsxs("div", { style: {
      display: "flex",
      justifyContent: "center",
      gap: 10,
      marginLeft: verticalAction ? 0 : "25px",
      borderRadius: 0,
      flexDirection: verticalAction ? "column" : "row",
      ...footerStyle2
    }, children: [
      showCancel && /* @__PURE__ */ jsx(Form.Item, { children: /* @__PURE__ */ jsx(Button, { type: "default", style: {
        width: verticalAction ? "100%" : 100,
        height: 40
      }, onClick: onCancel, children: cancelText }) }),
      /* @__PURE__ */ jsx(Form.Item, { children: /* @__PURE__ */ jsx(Button, { type: "primary", style: {
        width: verticalAction ? "100%" : 100,
        height: 40
      }, htmlType: "submit", onClick: onOk, children: okText }) })
    ] })
  ] }) });
}
NoModalOverlay.propTypes = {
  title: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.node]),
  onOk: propTypesExports$1.func,
  onCancel: propTypesExports$1.func,
  open: propTypesExports$1.bool,
  children: propTypesExports$1.node,
  okText: propTypesExports$1.string,
  cancelText: propTypesExports$1.string,
  placement: propTypesExports$1.string,
  marginVertical: propTypesExports$1.number,
  marginHorizontal: propTypesExports$1.number,
  closable: propTypesExports$1.bool,
  closeIcon: propTypesExports$1.node,
  nofooter: propTypesExports$1.bool,
  verticalAction: propTypesExports$1.bool,
  showCancel: propTypesExports$1.bool,
  footerStyle: propTypesExports$1.object
};
NoModalOverlay.defaultProps = {
  title: "",
  onOk: null,
  onCancel: null,
  open: false,
  children: null,
  okText: "Save",
  cancelText: "Cancel",
  placement: "top-left",
  marginVertical: 72,
  // 106
  marginHorizontal: 344,
  closable: false,
  // whether to show closeIcon on top-right
  closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}),
  nofooter: false,
  verticalAction: false,
  showCancel: true,
  footerStyle: {}
};
const unitOptions$1 = [
  {
    key: "m",
    label: "m",
    value: "m"
  },
  // { key: 'mm', label: 'mm', value: 'mm' },
  // { key: 'cm', label: 'cm', value: 'cm' },
  {
    key: "in",
    label: "in",
    value: "in"
  }
  // { key: 'ft', label: 'ft', value: 'ft' },
];
function UnitSelect(props) {
  return /* @__PURE__ */ jsx(Select, { placeholder: "Select unit", showSearch: false, data: unitOptions$1, ...props });
}
function useInputLength(props) {
  const {
    precision = 6
  } = props || {};
  const rounding2 = React__default.useCallback((number2) => {
    const multiplier = 10 ** precision;
    const inflated = number2 * multiplier;
    return Math.round(inflated) / multiplier;
  }, [precision]);
  const convert = React__default.useCallback(({
    number: number2,
    from,
    to
  }) => {
    if (typeof number2 !== "number")
      return number2;
    const conversionFactor = {
      // m to others
      "m-m": 1,
      "m-in": 39.37007874015748,
      // in to others
      "in-in": 1,
      "in-m": 0.0254
    };
    if (!number2 || from === to)
      return rounding2(number2);
    const key = `${from.toLowerCase()}-${to.toLowerCase()}`;
    return rounding2(number2 * conversionFactor[key]);
  }, [rounding2]);
  const getDisplayLength = React__default.useCallback((lengthInMeter, dispayUnit) => convert({
    number: lengthInMeter,
    from: "m",
    to: dispayUnit
  }), [convert]);
  const getMeterLength = React__default.useCallback((lengthInDisplayUnit, dispayUnit) => convert({
    number: lengthInDisplayUnit,
    from: dispayUnit,
    to: "m"
  }), [convert]);
  return {
    getDisplayLength,
    getMeterLength
  };
}
const inputLength_module = {};
function InputLength(props) {
  const {
    onChange,
    value: formValues,
    inputNumberProps,
    selectProps,
    parentId,
    filled
  } = props;
  const {
    getDisplayLength,
    getMeterLength
  } = useInputLength();
  const displayLength = React__default.useMemo(() => getDisplayLength(formValues.lengthInMeter, formValues.displayUnit), [getDisplayLength, formValues.lengthInMeter, formValues.displayUnit]);
  const onChangeInputNumber = React__default.useCallback((displayLength2) => {
    onChange({
      lengthInMeter: getMeterLength(displayLength2, formValues.displayUnit),
      displayUnit: formValues.displayUnit
    });
  }, [formValues.displayUnit, getMeterLength, onChange]);
  const onChangeUnitSelect = React__default.useCallback((displayUnit) => {
    onChange({
      lengthInMeter: formValues.lengthInMeter,
      displayUnit
    });
  }, [formValues.lengthInMeter, onChange]);
  return /* @__PURE__ */ jsxs(Row, { gutter: 8, children: [
    /* @__PURE__ */ jsx(Col, { span: 17, style: {
      height: "100%"
    }, children: /* @__PURE__ */ jsx(InputNumber, { controls: false, style: {
      width: "100%",
      height: "100%"
    }, placeholder: "Enter number", value: displayLength, onChange: onChangeInputNumber, filled, ...inputNumberProps }, `${parentId}-input`) }),
    /* @__PURE__ */ jsx(Col, { span: 7, style: {
      height: "100%"
    }, children: /* @__PURE__ */ jsx(UnitSelect, { onChange: (data2) => onChangeUnitSelect(data2), value: formValues.displayUnit, ...selectProps, style: {
      height: "100%"
    } }, `${parentId}-unit-select`) })
  ] });
}
InputLength.propTypes = {
  parentId: propTypesExports$1.string.isRequired,
  value: propTypesExports$1.object,
  onChange: propTypesExports$1.func,
  inputNumberProps: propTypesExports$1.object,
  selectProps: propTypesExports$1.object,
  filled: propTypesExports$1.bool
};
InputLength.defaultProps = {
  value: {},
  onChange: () => {
  },
  inputNumberProps: {},
  selectProps: {},
  filled: false
};
function NumberSlider(props) {
  const {
    value,
    onChange,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsxs("div", { style: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, children: [
    /* @__PURE__ */ jsx("div", { style: {
      width: "65%"
    }, children: /* @__PURE__ */ jsx(Slider$1, { onChange, value, ...restProps }) }),
    /* @__PURE__ */ jsx(InputNumber$1, { onChange, value, ...restProps })
  ] });
}
NumberSlider.propTypes = {
  value: propTypesExports$1.oneOfType([propTypesExports$1.number, propTypesExports$1.object]),
  onChange: propTypesExports$1.func
};
NumberSlider.defaultProps = {
  value: {},
  onChange: () => {
  }
};
function FormItemLatLon(props) {
  const {
    onPickerClick,
    readOnly,
    compact
  } = props;
  const latLngValidator = React__default.useCallback((limit) => async (rule, val) => {
    if (!val) {
      throw new Error("Values must be Defined");
    }
    if (val > limit || val < -limit) {
      throw new Error(`Must be within -${limit} +${limit} degree`);
    }
  }, []);
  return /* @__PURE__ */ jsxs(Form.Item, { style: {
    width: "100%",
    ...compact ? {
      margin: 0,
      padding: 0
    } : {}
  }, label: /* @__PURE__ */ jsx(Typography.Text, { strong: true, style: {
    margin: 0,
    padding: 0
  }, children: "Location Coordinates" }), children: [
    onPickerClick && /* @__PURE__ */ jsx(Form.Item, { name: "locationPicker", style: {
      paddingTop: "10px",
      marginBottom: "16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start"
    }, children: /* @__PURE__ */ jsx(Button, { type: "primary", style: {
      padding: "5px"
    }, ghost: true, icon: /* @__PURE__ */ jsx(PushpinFilled, { style: {
      fontSize: "15px"
    } }), onClick: () => onPickerClick(), block: true, children: "Pick a location" }) }),
    /* @__PURE__ */ jsxs(Row, { gutter: 8, children: [
      /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsx(Form.Item, { name: "latitude", label: "Latitude", rules: [{
        required: true,
        validator: latLngValidator(90)
      }], getValueFromEvent: truncateDecimal, children: /* @__PURE__ */ jsx(InputNumber, { placeholder: "Enter or Pick", style: {
        width: "100%"
      }, filled: true, readOnly }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsx(Form.Item, { name: "longitude", label: "Longitude", rules: [{
        required: true,
        validator: latLngValidator(180)
      }], getValueFromEvent: truncateDecimal, children: /* @__PURE__ */ jsx(InputNumber, { placeholder: "Enter or Pick", style: {
        width: "100%"
      }, filled: true, readOnly }) }) })
    ] })
  ] });
}
FormItemLatLon.propTypes = {
  onPickerClick: propTypesExports$1.func,
  readOnly: propTypesExports$1.bool,
  compact: propTypesExports$1.bool
};
FormItemLatLon.defaultProps = {
  onPickerClick: null,
  readOnly: false,
  compact: false
};
function Indicator$1(props) {
  const {
    display,
    color,
    size: size12,
    type,
    height
  } = props;
  return /* @__PURE__ */ jsx("span", { style: {
    display,
    width: size12,
    height: type === "line" ? height : size12,
    backgroundColor: color,
    borderRadius: type === "line" ? "0%" : "50%",
    marginRight: 4
  } });
}
Indicator$1.propTypes = {
  display: propTypesExports$1.string,
  color: propTypesExports$1.string,
  size: propTypesExports$1.number,
  type: propTypesExports$1.oneOf(["dot", "line"]),
  height: propTypesExports$1.number
};
Indicator$1.defaultProps = {
  display: "block",
  color: "red",
  size: 8,
  type: "dot",
  height: 2
};
function ColorLegend(props) {
  const {
    startColor: color1,
    endColor: color2,
    step,
    stepWidth = 15,
    stepHeight = 8,
    showBubbles = true
  } = props;
  const {
    minRadius,
    maxRadius,
    stepRadius
  } = React__default.useMemo(() => {
    const halfStepWidth = stepWidth * 0.5;
    const minRadius2 = 0.3 * halfStepWidth;
    const maxRadius2 = 0.7 * halfStepWidth;
    const stepRadius2 = (maxRadius2 - minRadius2) / step;
    return {
      minRadius: minRadius2,
      maxRadius: maxRadius2,
      stepRadius: stepRadius2
    };
  }, [step, stepWidth]);
  const interpolateColors = React__default.useMemo(() => {
    const interpolate2 = (start2, end, factor) => start2 + (end - start2) * factor;
    const hex2Rgb = (hex) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    };
    const rgb2Hex = (r2, g2, b2) => `#${((1 << 24) + (r2 << 16) + (g2 << 8) + b2).toString(16).slice(1)}`;
    const startColor = hex2Rgb(color1);
    const endColor = hex2Rgb(color2);
    const interpolatedColors = [];
    for (let i2 = 0; i2 <= step; i2 += 1) {
      const factor = i2 / step;
      const r2 = Math.round(interpolate2(startColor.r, endColor.r, factor));
      const g2 = Math.round(interpolate2(startColor.g, endColor.g, factor));
      const b2 = Math.round(interpolate2(startColor.b, endColor.b, factor));
      interpolatedColors.push(rgb2Hex(r2, g2, b2));
    }
    return interpolatedColors;
  }, [color1, color2, step]);
  const borderRadius2 = React__default.useCallback((ind, length2) => ind === 0 ? "4px 0 0 4px" : ind === length2 - 1 ? " 0 4px 4px 0" : "0px", []);
  return /* @__PURE__ */ jsx("span", { style: {
    display: "flex",
    alignItems: "flex-end",
    borderRadius: "4px",
    position: "relative"
  }, children: interpolateColors.map((color, ind, arr) => {
    const radius = minRadius + (ind + 1) * stepRadius;
    return /* @__PURE__ */ jsxs("span", { style: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }, children: [
      showBubbles && /* @__PURE__ */ jsx("div", { style: {
        height: `${maxRadius}px`,
        display: "flex",
        alignItems: "flex-end"
      }, children: /* @__PURE__ */ jsx("span", { style: {
        width: radius * 2,
        height: radius,
        backgroundColor: color,
        borderRadius: `${radius}px ${radius}px 0 0`,
        // Semi-circle
        marginBottom: "1px"
      } }) }),
      /* @__PURE__ */ jsx("span", { style: {
        display: "inline-block",
        width: stepWidth,
        height: stepHeight,
        backgroundColor: color,
        borderRadius: borderRadius2(ind, arr.length),
        marginTop: "2px"
      } })
    ] }, ind);
  }) });
}
ColorLegend.propTypes = {
  startColor: propTypesExports$1.string,
  // Must be of type #RRGGBB
  endColor: propTypesExports$1.string,
  // Must be of type #RRGGBB
  step: propTypesExports$1.number,
  stepWidth: propTypesExports$1.number,
  stepHeight: propTypesExports$1.number,
  showBubbles: propTypesExports$1.bool
};
ColorLegend.defaultProps = {
  startColor: "#dfe8f6",
  endColor: "#327de7",
  step: 4,
  stepWidth: 15,
  stepHeight: 8,
  showBubbles: true
};
const {
  useToken: useToken$y
} = theme$2;
function CollapsibleOverlayPanel(props) {
  const {
    header,
    children,
    title,
    initialCollapsed,
    placement,
    styles: styles2,
    collapsedStyles,
    ...restProps
  } = props;
  const {
    token
  } = useToken$y();
  const [collapsed, setCollapsed] = React__default.useState(initialCollapsed);
  const isBottomPlacement = placement == null ? void 0 : placement.startsWith("bottom");
  const toggleCollapsed = React__default.useCallback(() => {
    setCollapsed((prevState) => !prevState);
  }, []);
  const description2 = React__default.useMemo(() => collapsed ? header : children, [children, collapsed, header]);
  const collapseIcon = React__default.useMemo(() => {
    const isDown = isBottomPlacement ? collapsed : !collapsed;
    return isDown ? /* @__PURE__ */ jsx(DownOutlined, {}) : /* @__PURE__ */ jsx(UpOutlined, {});
  }, [collapsed, isBottomPlacement]);
  const collapseToggleButton = React__default.useMemo(() => /* @__PURE__ */ jsx(Button, { type: "text", icon: collapseIcon, onClick: toggleCollapsed }), [collapseIcon, toggleCollapsed]);
  const footerTitle = React__default.useMemo(() => {
    if (!isBottomPlacement)
      return null;
    return /* @__PURE__ */ jsx(Card, { styles: {
      body: {
        padding: 0,
        margin: 0
      }
    }, title, extra: collapseToggleButton, style: {
      border: "none",
      borderRadius: description2 ? "0px 0px 6px 6px" : "6px"
    } });
  }, [collapseToggleButton, description2, isBottomPlacement, title]);
  return /* @__PURE__ */ jsxs(OverlayPanel, { ...restProps, placement, children: [
    /* @__PURE__ */ jsx(Card, { style: {
      width: "100%",
      border: "none",
      borderRadius: description2 && isBottomPlacement ? "6px 6px 0px 0px" : "6px",
      borderBottom: description2 && isBottomPlacement ? `1px solid ${token.colorBorder}` : "none"
    }, styles: {
      body: !description2 ? {
        padding: 0,
        margin: 0
      } : void 0,
      ...collapsed ? collapsedStyles : styles2
    }, title: !isBottomPlacement ? title : void 0, extra: !isBottomPlacement ? collapseToggleButton : void 0, children: description2 && /* @__PURE__ */ jsx(Card.Meta, { description: description2 }) }),
    footerTitle
  ] });
}
CollapsibleOverlayPanel.propTypes = {
  header: propTypesExports$1.node,
  children: propTypesExports$1.node,
  title: propTypesExports$1.string,
  initialCollapsed: propTypesExports$1.bool,
  placement: propTypesExports$1.string,
  styles: propTypesExports$1.object,
  collapsedStyles: propTypesExports$1.object
};
CollapsibleOverlayPanel.defaultProps = {
  header: null,
  children: null,
  title: "",
  initialCollapsed: false,
  placement: "top-left",
  styles: {},
  collapsedStyles: {}
};
const {
  Text: Text$g
} = Typography;
function LegendInfo(props) {
  const {
    initialCollapsed,
    placement,
    marginHorizontal,
    marginVertical,
    types: types2,
    alerts,
    bands,
    boundaries,
    heatmap,
    heatmapStep,
    width
  } = props;
  const renderBlock = React__default.useCallback((title, children) => /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    width: "100%"
  }, children: [
    /* @__PURE__ */ jsx(Text$g, { children: title }),
    children
  ] }), []);
  const renderIndicatorBlock = React__default.useCallback((title, array2) => (array2 == null ? void 0 : array2.length) && renderBlock(title, /* @__PURE__ */ jsx(Space, { direction: "vertical", children: array2.map((v5) => {
    if (!(v5.color && v5.type && v5.name))
      return null;
    return /* @__PURE__ */ jsxs(Space, { direction: "horizontal", style: {
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ jsx(Indicator$1, { color: v5.color, type: v5.type, size: 10, height: 4 }),
      /* @__PURE__ */ jsx(Text$g, { type: "secondary", children: v5.name })
    ] }, v5.name);
  }) })), [renderBlock]);
  const renderTypes = React__default.useMemo(() => {
    if (!(types2 == null ? void 0 : types2.length))
      return null;
    return renderIndicatorBlock("Type", types2.map((d2) => ({
      ...d2,
      type: "dot"
    })));
  }, [renderIndicatorBlock, types2]);
  const renderBoundaries = React__default.useMemo(() => {
    if (!(boundaries == null ? void 0 : boundaries.length))
      return null;
    return renderIndicatorBlock("Boundary", boundaries.map((d2) => ({
      ...d2,
      type: "line"
    })));
  }, [renderIndicatorBlock, boundaries]);
  const renderAlerts = React__default.useMemo(() => {
    if (!(alerts == null ? void 0 : alerts.length))
      return null;
    return renderIndicatorBlock("Alerts", alerts.map((d2) => ({
      ...d2,
      type: "dot"
    })));
  }, [renderIndicatorBlock, alerts]);
  const renderBands = React__default.useMemo(() => {
    if (!(bands == null ? void 0 : bands.length))
      return null;
    return renderIndicatorBlock("Bands", bands.map((d2) => ({
      ...d2,
      type: "dot"
    })));
  }, [renderIndicatorBlock, bands]);
  const renderHeatmap = React__default.useMemo(() => {
    if (!(heatmap == null ? void 0 : heatmap.length))
      return null;
    const [low, high] = heatmap;
    if (!low || !high)
      return null;
    return renderBlock("Heatmap", /* @__PURE__ */ jsxs(Space, { direction: "vertical", align: "center", children: [
      /* @__PURE__ */ jsx(ColorLegend, { startColor: low.color, endColor: high.color, step: heatmapStep, stepWidth: 32 }),
      /* @__PURE__ */ jsxs(Space, { direction: "horizontal", style: {
        justifyContent: "space-between",
        width: "160px"
      }, children: [
        /* @__PURE__ */ jsx(Text$g, { type: "secondary", children: low.name }),
        /* @__PURE__ */ jsx(Text$g, { type: "secondary", children: high.name })
      ] })
    ] }));
  }, [heatmap, heatmapStep, renderBlock]);
  if (!(alerts == null ? void 0 : alerts.length) && !(boundaries == null ? void 0 : boundaries.length) && !(heatmap == null ? void 0 : heatmap.length) && !(types2 == null ? void 0 : types2.length) && !(bands == null ? void 0 : bands.length))
    return null;
  return /* @__PURE__ */ jsx(CollapsibleOverlayPanel, { title: "Legend", placement, width, height: "auto", marginHorizontal, marginVertical, initialCollapsed, children: /* @__PURE__ */ jsxs(Space, { direction: "vertical", children: [
    renderTypes,
    renderBoundaries,
    renderBands,
    renderAlerts,
    renderHeatmap
  ] }) });
}
LegendInfo.propTypes = {
  initialCollapsed: propTypesExports$1.bool,
  width: propTypesExports$1.number,
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  types: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    color: propTypesExports$1.string,
    name: propTypesExports$1.string
  })),
  boundaries: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    color: propTypesExports$1.string,
    name: propTypesExports$1.string
  })),
  alerts: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    color: propTypesExports$1.string,
    name: propTypesExports$1.string
  })),
  bands: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    color: propTypesExports$1.string,
    name: propTypesExports$1.string
  })),
  heatmap: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    color: propTypesExports$1.string,
    name: propTypesExports$1.string
  })),
  heatmapStep: propTypesExports$1.number
};
LegendInfo.defaultProps = {
  initialCollapsed: true,
  width: 200,
  placement: "bottom-left",
  marginHorizontal: 16,
  marginVertical: 16,
  types: [],
  boundaries: [],
  alerts: [],
  bands: [],
  heatmap: [],
  heatmapStep: 4
};
const STYLE = {
  height: "100%",
  padding: "0px 0px 6px 0px",
  overflow: "auto",
  borderRadius: "0px",
  border: "none",
  margin: 0
};
const {
  useToken: useToken$x
} = theme$2;
function NoModalNoOverlay(props) {
  const {
    id,
    title,
    onOk,
    onCancel,
    children,
    open: open2,
    okText,
    cancelText,
    placement: placementIn,
    marginVertical,
    marginHorizontal,
    closable,
    closeIcon,
    nofooter,
    // eslint-disable-next-line no-unused-vars
    verticalAction,
    // used in material pr, to be fixed in next pr
    showCancel,
    footerStyle: footerStyle2,
    bodyStyle,
    importDetails,
    exportDetails,
    customButtonDetails
  } = props;
  const {
    token
  } = useToken$x();
  const isBottomOptionsShown = exportDetails || importDetails || customButtonDetails;
  const extra = React__default.useMemo(() => {
    if (!closable || !closeIcon)
      return null;
    return /* @__PURE__ */ jsx(Button, { type: "text", icon: closeIcon, onClick: onCancel, iconPosition: "end", style: {
      width: "100%"
    } });
  }, [closable, closeIcon, onCancel]);
  const placement = React__default.useMemo(() => {
    var _a3, _b3;
    const vertical = ((_a3 = placementIn == null ? void 0 : placementIn.split("-")) == null ? void 0 : _a3[0]) || "bottom";
    const horizontal = ((_b3 = placementIn == null ? void 0 : placementIn.split("-")) == null ? void 0 : _b3[1]) || "left";
    return {
      vertical,
      horizontal
    };
  }, [placementIn]);
  const parentStyle = React__default.useMemo(() => {
    if (placement.vertical === "top")
      ;
    if (placement.horizontal === "left")
      ;
    return {
      position: "absolute",
      zIndex: 1e3,
      width: 372,
      height: `calc(100% - ${marginVertical}px)`,
      display: "initial"
    };
  }, [placement.vertical, placement.horizontal, marginVertical, marginHorizontal]);
  const parentPadding = React__default.useMemo(() => parsePadding(bodyStyle.padding), [bodyStyle.padding]);
  if (!open2)
    return null;
  return /* @__PURE__ */ jsx("div", { style: parentStyle, id, children: /* @__PURE__ */ jsx("div", { style: {
    height: "100%",
    padding: "0",
    overflow: "hidden",
    position: "relative",
    marginTop: "0px"
  }, children: /* @__PURE__ */ jsx(ConfigProvider, { theme: {
    components: {
      Card: {
        headerHeight: "64px",
        headerFontSize: "16px"
      }
    }
  }, children: /* @__PURE__ */ jsxs(Card, { title, style: STYLE, bordered: 0, extra, styles: {
    body: {
      padding: "8px 24px",
      ...bodyStyle
    },
    header: {
      borderRadius: "0px",
      margin: 0,
      padding: "0px 24px"
    },
    title: {
      margin: 0,
      padding: 0
    }
  }, children: [
    children,
    !nofooter && /* @__PURE__ */ jsxs("div", { style: {
      display: "flex",
      justifyContent: "space-between",
      gap: 12,
      borderRadius: 0,
      flexDirection: "row",
      marginBottom: isBottomOptionsShown ? 60 : 0,
      ...footerStyle2
    }, children: [
      showCancel && /* @__PURE__ */ jsx(Form.Item, { style: {
        width: "48%"
      }, children: /* @__PURE__ */ jsx(Button, { type: "default", style: {
        width: "100%",
        height: 40,
        boxShadow: "none"
      }, onClick: onCancel, children: cancelText }) }),
      /* @__PURE__ */ jsx(Form.Item, { style: {
        width: showCancel ? "48%" : "100%"
      }, children: /* @__PURE__ */ jsx(Button, { type: "primary", style: {
        width: "100%",
        height: 40
      }, htmlType: "submit", onClick: onOk, children: okText }) })
    ] }),
    isBottomOptionsShown && /* @__PURE__ */ jsxs(Flex, { style: {
      position: "fixed",
      padding: "5px 24px",
      margin: `0px ${(parentPadding == null ? void 0 : parentPadding.left) ? `-${parentPadding.left}${parentPadding.leftUnit}` : "0px"}`,
      bottom: 0,
      width: parentStyle.width,
      backgroundColor: token.colorBgContainer
    }, gap: 12, justify: "center", children: [
      importDetails && /* @__PURE__ */ jsx(Form.Item, { name: "upload", style: {
        width: !exportDetails && !customButtonDetails ? "100%" : "50%"
      }, rules: importDetails.rules, hidden: importDetails.hidden, children: /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, style: {
        width: "100%",
        height: 40,
        fontSize: 14
      }, size: "large", onClick: importDetails.onClick, disabled: importDetails.disabled, children: "Import" }) }),
      exportDetails && /* @__PURE__ */ jsx(Form.Item, { name: "download", style: {
        width: !importDetails && !customButtonDetails ? "100%" : "45%"
      }, rules: exportDetails.rules, hidden: exportDetails.hidden, children: /* @__PURE__ */ jsx(Button, { type: "default", style: {
        width: "100%",
        height: 40,
        fontSize: 14
      }, onClick: exportDetails.onClick, disabled: exportDetails.disabled, children: "Export" }) }),
      customButtonDetails && /* @__PURE__ */ jsx(Form.Item, { style: {
        width: !importDetails && !exportDetails ? "100%" : "50%"
      }, children: /* @__PURE__ */ jsx(Button, { type: customButtonDetails.type, style: {
        width: "100%",
        height: 40,
        fontSize: 14
      }, onClick: customButtonDetails.onClick, ...customButtonDetails.buttonProps, children: customButtonDetails.text }) })
    ] })
  ] }) }) }) });
}
NoModalNoOverlay.propTypes = {
  id: propTypesExports$1.string,
  title: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.node]),
  onOk: propTypesExports$1.func,
  onCancel: propTypesExports$1.func,
  open: propTypesExports$1.bool,
  children: propTypesExports$1.node,
  okText: propTypesExports$1.string,
  cancelText: propTypesExports$1.string,
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginVertical: propTypesExports$1.number,
  marginHorizontal: propTypesExports$1.number,
  closable: propTypesExports$1.bool,
  closeIcon: propTypesExports$1.node,
  nofooter: propTypesExports$1.bool,
  verticalAction: propTypesExports$1.bool,
  showCancel: propTypesExports$1.bool,
  footerStyle: propTypesExports$1.object,
  bodyStyle: propTypesExports$1.object,
  importDetails: propTypesExports$1.shape({
    hidden: propTypesExports$1.bool,
    rules: propTypesExports$1.array,
    onClick: propTypesExports$1.func,
    disabled: propTypesExports$1.bool
  }),
  exportDetails: propTypesExports$1.shape({
    hidden: propTypesExports$1.bool,
    rules: propTypesExports$1.array,
    onClick: propTypesExports$1.func,
    disabled: propTypesExports$1.bool
  }),
  customButtonDetails: propTypesExports$1.shape({
    type: propTypesExports$1.string,
    onClick: propTypesExports$1.func,
    text: propTypesExports$1.string,
    buttonProps: propTypesExports$1.object
  })
};
NoModalNoOverlay.defaultProps = {
  id: "no-modal-no-overlay",
  title: "",
  onOk: null,
  onCancel: null,
  open: false,
  children: null,
  okText: "Save",
  cancelText: "Cancel",
  placement: "top-left",
  marginVertical: 72,
  // 106
  marginHorizontal: 344,
  closable: false,
  // whether to show closeIcon on top-right
  closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}),
  nofooter: false,
  verticalAction: false,
  showCancel: true,
  footerStyle: {},
  bodyStyle: {},
  importDetails: null,
  exportDetails: null,
  customButtonDetails: null
};
function RightPanel(props) {
  const {
    id,
    containerId,
    placement: placementIn,
    ...restProps
  } = props;
  const placement = React__default.useMemo(() => {
    var _a3;
    const vertical = ((_a3 = placementIn == null ? void 0 : placementIn.split("-")) == null ? void 0 : _a3[0]) || "top";
    return `${vertical}-right`;
  }, [placementIn]);
  return createPortal(/* @__PURE__ */ jsx(NoModalNoOverlay, { id, placement, ...restProps }), document.getElementById(containerId));
}
RightPanel.propTypes = {
  id: propTypesExports$1.string,
  containerId: propTypesExports$1.string,
  placement: propTypesExports$1.oneOf(["top-right", "bottom-right"])
};
RightPanel.defaultProps = {
  id: "right-panel",
  containerId: "right-panel-container",
  placement: "top-right"
};
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SV_MAX = 100;
var hsvaToHslaString = (hsva) => {
  var {
    h: h2,
    s: s2,
    l: l2,
    a: a2
  } = hsvaToHsla(hsva);
  return "hsla(" + h2 + ", " + s2 + "%, " + l2 + "%, " + a2 + ")";
};
var hsvaToHsla = (_ref5) => {
  var {
    h: h2,
    s: s2,
    v: v5,
    a: a2
  } = _ref5;
  var hh2 = (200 - s2) * v5 / SV_MAX;
  return {
    h: h2,
    s: hh2 > 0 && hh2 < 200 ? s2 * v5 / SV_MAX / (hh2 <= SV_MAX ? hh2 : 200 - hh2) * SV_MAX : 0,
    l: hh2 / 2,
    a: a2
  };
};
function useEventCallback(handler) {
  var callbackRef = useRef(handler);
  useEffect(() => {
    callbackRef.current = handler;
  });
  return useCallback((value, event) => callbackRef.current && callbackRef.current(value, event), []);
}
var isTouch$1 = (event) => "touches" in event;
var preventDefaultMove = (event) => {
  !isTouch$1(event) && event.preventDefault && event.preventDefault();
};
var clamp$4 = function clamp3(number2, min4, max3) {
  if (min4 === void 0) {
    min4 = 0;
  }
  if (max3 === void 0) {
    max3 = 1;
  }
  return number2 > max3 ? max3 : number2 < min4 ? min4 : number2;
};
var getRelativePosition = (node, event) => {
  var rect = node.getBoundingClientRect();
  var pointer = isTouch$1(event) ? event.touches[0] : event;
  return {
    left: clamp$4((pointer.pageX - (rect.left + window.pageXOffset)) / rect.width),
    top: clamp$4((pointer.pageY - (rect.top + window.pageYOffset)) / rect.height),
    width: rect.width,
    height: rect.height,
    x: pointer.pageX - (rect.left + window.pageXOffset),
    y: pointer.pageY - (rect.top + window.pageYOffset)
  };
};
var _excluded$3 = ["prefixCls", "className", "onMove", "onDown"];
var Interactive = /* @__PURE__ */ React__default.forwardRef((props, ref) => {
  var {
    prefixCls = "w-color-interactive",
    className,
    onMove,
    onDown
  } = props, reset2 = _objectWithoutPropertiesLoose$1(props, _excluded$3);
  var container = useRef(null);
  var hasTouched = useRef(false);
  var [isDragging, setDragging] = useState(false);
  var onMoveCallback = useEventCallback(onMove);
  var onKeyCallback = useEventCallback(onDown);
  var isValid8 = (event) => {
    if (hasTouched.current && !isTouch$1(event))
      return false;
    hasTouched.current = isTouch$1(event);
    return true;
  };
  var handleMove = useCallback((event) => {
    preventDefaultMove(event);
    var isDown = isTouch$1(event) ? event.touches.length > 0 : event.buttons > 0;
    if (isDown && container.current) {
      onMoveCallback && onMoveCallback(getRelativePosition(container.current, event), event);
    } else {
      setDragging(false);
    }
  }, [onMoveCallback]);
  var handleMoveEnd = useCallback(() => setDragging(false), []);
  var toggleDocumentEvents = useCallback((state) => {
    var toggleEvent = state ? window.addEventListener : window.removeEventListener;
    toggleEvent(hasTouched.current ? "touchmove" : "mousemove", handleMove);
    toggleEvent(hasTouched.current ? "touchend" : "mouseup", handleMoveEnd);
  }, []);
  useEffect(() => {
    toggleDocumentEvents(isDragging);
    return () => {
      isDragging && toggleDocumentEvents(false);
    };
  }, [isDragging, toggleDocumentEvents]);
  var handleMoveStart = useCallback((event) => {
    preventDefaultMove(event.nativeEvent);
    if (!isValid8(event.nativeEvent))
      return;
    onKeyCallback && onKeyCallback(getRelativePosition(container.current, event.nativeEvent), event.nativeEvent);
    setDragging(true);
  }, [onKeyCallback]);
  return /* @__PURE__ */ jsx("div", _extends$1({}, reset2, {
    className: [prefixCls, className || ""].filter(Boolean).join(" "),
    style: _extends$1({}, reset2.style, {
      touchAction: "none"
    }),
    ref: container,
    tabIndex: 0,
    onMouseDown: handleMoveStart,
    onTouchStart: handleMoveStart
  }));
});
Interactive.displayName = "Interactive";
const Interactive$1 = Interactive;
var _excluded$2 = ["className", "prefixCls", "left", "top", "style", "fillProps"];
var Pointer = (_ref2) => {
  var {
    className,
    prefixCls,
    left,
    top,
    style: style2,
    fillProps
  } = _ref2, reset2 = _objectWithoutPropertiesLoose$1(_ref2, _excluded$2);
  var styleWrapper = _extends$1({}, style2, {
    position: "absolute",
    left,
    top
  });
  var stylePointer = _extends$1({
    width: 18,
    height: 18,
    boxShadow: "var(--alpha-pointer-box-shadow)",
    borderRadius: "50%",
    backgroundColor: "var(--alpha-pointer-background-color)"
  }, fillProps == null ? void 0 : fillProps.style, {
    transform: left ? "translate(-9px, -1px)" : "translate(-1px, -9px)"
  });
  return /* @__PURE__ */ jsx("div", _extends$1({
    className: prefixCls + "-pointer " + (className || ""),
    style: styleWrapper
  }, reset2, {
    children: /* @__PURE__ */ jsx("div", _extends$1({
      className: prefixCls + "-fill"
    }, fillProps, {
      style: stylePointer
    }))
  }));
};
var _excluded$1 = ["prefixCls", "className", "hsva", "background", "bgProps", "innerProps", "pointerProps", "radius", "width", "height", "direction", "style", "onChange", "pointer"];
var BACKGROUND_IMG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMUlEQVQ4T2NkYGAQYcAP3uCTZhw1gGGYhAGBZIA/nYDCgBDAm9BGDWAAJyRCgLaBCAAgXwixzAS0pgAAAABJRU5ErkJggg==";
var Alpha = /* @__PURE__ */ React__default.forwardRef((props, ref) => {
  var {
    prefixCls = "w-color-alpha",
    className,
    hsva,
    background,
    bgProps = {},
    innerProps = {},
    pointerProps = {},
    radius = 0,
    width,
    height = 16,
    direction = "horizontal",
    style: style2,
    onChange,
    pointer
  } = props, other = _objectWithoutPropertiesLoose$1(props, _excluded$1);
  var handleChange = (offset) => {
    onChange && onChange(_extends$1({}, hsva, {
      a: direction === "horizontal" ? offset.left : offset.top
    }), offset);
  };
  var colorTo = hsvaToHslaString(Object.assign({}, hsva, {
    a: 1
  }));
  var innerBackground = "linear-gradient(to " + (direction === "horizontal" ? "right" : "bottom") + ", rgba(244, 67, 54, 0) 0%, " + colorTo + " 100%)";
  var comProps = {};
  if (direction === "horizontal") {
    comProps.left = hsva.a * 100 + "%";
  } else {
    comProps.top = hsva.a * 100 + "%";
  }
  var styleWrapper = _extends$1({
    "--alpha-background-color": "#fff",
    "--alpha-pointer-background-color": "rgb(248, 248, 248)",
    "--alpha-pointer-box-shadow": "rgb(0 0 0 / 37%) 0px 1px 4px 0px",
    borderRadius: radius,
    background: "url(" + BACKGROUND_IMG + ") left center",
    backgroundColor: "var(--alpha-background-color)"
  }, {
    width,
    height
  }, style2, {
    position: "relative"
  });
  var pointerElement = pointer && typeof pointer === "function" ? pointer(_extends$1({
    prefixCls
  }, pointerProps, comProps)) : /* @__PURE__ */ jsx(Pointer, _extends$1({}, pointerProps, {
    prefixCls
  }, comProps));
  return /* @__PURE__ */ jsxs("div", _extends$1({}, other, {
    className: [prefixCls, prefixCls + "-" + direction, className || ""].filter(Boolean).join(" "),
    style: styleWrapper,
    ref,
    children: [/* @__PURE__ */ jsx("div", _extends$1({}, bgProps, {
      style: _extends$1({
        inset: 0,
        position: "absolute",
        background: background || innerBackground,
        borderRadius: radius
      }, bgProps.style)
    })), /* @__PURE__ */ jsx(Interactive$1, _extends$1({}, innerProps, {
      style: _extends$1({}, innerProps.style, {
        inset: 0,
        zIndex: 1,
        position: "absolute"
      }),
      onMove: handleChange,
      onDown: handleChange,
      children: pointerElement
    }))]
  }));
});
Alpha.displayName = "Alpha";
const Alpha$1 = Alpha;
const CHECKER_BG = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAKtJREFUKFOFkCEOhDAQRV8FIKAV1QTNJTgAR9wLYTEoElRTB6ZgAMGmm2wDhM2OnLz58/8XwIvTFEVB27akacq2bcRxzDiOiCew73uSJAnn8zw/g13XIaX8D94V13VFaK2DR+9Ja03TNCil2PedKIpwziGmaQqgXxpjqOuaZVnC6yzLEMdxXFJba8nz/FwEP8GyLC+K3s6j4h38KDrnwmtf7jAMVFUVyv4GfANkTlojr3SAxgAAAABJRU5ErkJggg==";
function AlphaPicker(props) {
  const {
    value,
    onChange,
    direction,
    color: colorIn,
    ...restProps
  } = props;
  const {
    token
  } = theme$2.useToken();
  const onChangeAlpha = React__default.useCallback((newAlpha) => {
    const alpha = (newAlpha == null ? void 0 : newAlpha.a) || 0;
    onChange(alpha);
  }, [onChange]);
  const onChangeInput = React__default.useCallback((percent) => {
    onChange(percent / 100);
  }, [onChange]);
  const color = React__default.useMemo(() => {
    const rgba = ColorUtil.convertToRGB(colorIn);
    const hsv = ColorUtil.rgbToHsv(rgba.r, rgba.g, rgba.b);
    if (!hsv)
      return colorIn;
    hsv.a = value;
    return hsv;
  }, [colorIn, value]);
  const renderPointer = React__default.useCallback((props2) => {
    const style2 = {
      width: "12px",
      height: "12px",
      borderRadius: "50%",
      transform: "translate(-9px, -1px)",
      backgroundColor: colorIn,
      border: `3px solid ${token.colorBgContainer}`,
      cursor: "pointer",
      position: "relative",
      ...props2
    };
    return /* @__PURE__ */ jsx("div", { style: style2 });
  }, [colorIn, token.colorBgContainer]);
  return /* @__PURE__ */ jsxs(Space, { direction, size: "large", style: {
    height: "10%",
    columnGap: "10px"
  }, children: [
    /* @__PURE__ */ jsx("div", { style: {
      width: "100%",
      backgroundColor: "grey",
      borderRadius: "8px"
    }, children: /* @__PURE__ */ jsx(Alpha$1, { hsva: color, onChange: onChangeAlpha, direction, pointer: renderPointer, bgProps: {
      style: {
        backgroundImage: `linear-gradient(to right, rgba(244, 67, 54, 0) -30%, ${colorIn} 60%), url(${CHECKER_BG})`
      }
    }, ...restProps }) }),
    /* @__PURE__ */ jsx(InputNumber$1, { min: 0, max: 100, step: 1, value: Math.round(value * 100), onChange: onChangeInput, formatter: (value2) => `${value2}%`, parser: (value2) => value2 == null ? void 0 : value2.replace("%", ""), style: {
      height: "24px",
      width: "65px"
    } })
  ] });
}
AlphaPicker.propTypes = {
  value: propTypesExports$1.number,
  onChange: propTypesExports$1.func,
  direction: propTypesExports$1.oneOf(["horizontal", "vertical"]),
  color: propTypesExports$1.string
  // hex
};
AlphaPicker.defaultProps = {
  value: 1,
  onChange: () => {
  },
  direction: "horizontal",
  color: "#FFFF00"
};
function LevelSelector$1(props) {
  const {
    placement,
    width,
    height,
    marginHorizontal,
    marginVertical,
    levels,
    onLevelSelect,
    activeLevelId
  } = props;
  const {
    token
  } = theme$2.useToken();
  const options2 = React__default.useMemo(() => levels == null ? void 0 : levels.map((level) => ({
    label: level.name,
    value: level.id
  })), [levels]);
  return /* @__PURE__ */ jsx(OverlayPanel, { width, height, marginHorizontal, marginVertical, placement, children: (options2 == null ? void 0 : options2.length) > 0 && /* @__PURE__ */ jsx(Select$1, { options: options2, style: {
    width: 200
  }, onChange: onLevelSelect, value: activeLevelId, suffixIcon: /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    gap: 0
  }, children: [
    /* @__PURE__ */ jsx(CaretUpOutlined, { style: {
      color: token.colorText
    } }),
    /* @__PURE__ */ jsx(CaretDownOutlined, { style: {
      color: token.colorText
    } })
  ] }) }) });
}
LevelSelector$1.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  levels: propTypesExports$1.array,
  onLevelSelect: propTypesExports$1.func,
  activeLevelId: propTypesExports$1.string
};
LevelSelector$1.defaultProps = {
  placement: "top-right",
  width: 200,
  height: 58,
  marginHorizontal: 54,
  marginVertical: 0,
  levels: [],
  onLevelSelect: () => {
  },
  activeLevelId: ""
};
const nonBlockingModal_module = {};
const CLASS_NAME = "custom-modal";
function NonBlockingModal(props) {
  React__default.useEffect(() => {
    const elements = document.getElementsByClassName(CLASS_NAME);
    for (let i2 = 0; i2 < elements.length; i2 += 1) {
      if (!elements[i2].classList.contains("ant-modal-root"))
        elements[i2].parentElement.classList.add(CLASS_NAME);
    }
  }, []);
  return /* @__PURE__ */ jsx(Modal$1, { wrapClassName: CLASS_NAME, ...props, mask: false, maskCloseable: false });
}
const {
  Text: Text$f
} = Typography;
const {
  useToken: useToken$w
} = theme$2;
function ObjectButton(props) {
  const {
    token: {
      activeColor,
      colorBgLayout
    }
  } = useToken$w();
  const {
    label,
    isActive,
    onClick: onClick2
  } = props;
  return /* @__PURE__ */ jsxs(Flex, { vertical: true, justify: "center", align: "center", onClick: onClick2, children: [
    /* @__PURE__ */ jsx(props.icon, { style: {
      padding: "8px",
      marginBottom: "5px",
      border: `1px solid ${colorBgLayout}`,
      background: isActive ? activeColor : null
    } }),
    /* @__PURE__ */ jsx(Text$f, { children: label })
  ] });
}
ObjectButton.propTypes = {
  label: propTypesExports$1.string.isRequired,
  isActive: propTypesExports$1.bool.isRequired,
  onClick: propTypesExports$1.func.isRequired
};
const {
  useToken: useToken$v
} = theme$2;
function PopOverMenuItems({
  label,
  itemKey,
  onAction,
  icon,
  disabled
}) {
  const {
    token: {
      activeColor
    }
  } = useToken$v();
  const [hover3, setHover] = useState(false);
  const hoverStyle = {
    backgroundColor: hover3 ? activeColor : "transparent"
  };
  return /* @__PURE__ */ jsx(Menu.Item, { style: hoverStyle, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), onClick: () => onAction(itemKey), disabled, icon, children: label }, itemKey);
}
PopOverMenuItems.propTypes = {
  label: propTypesExports$1.string,
  itemKey: propTypesExports$1.string,
  onAction: propTypesExports$1.func,
  disabled: propTypesExports$1.bool,
  icon: propTypesExports$1.node
};
PopOverMenuItems.defaultProps = {
  label: "",
  itemKey: "",
  onAction: () => {
  },
  disabled: false,
  icon: null
};
const mapboxGl = "";
function MapProvider(props) {
  const {
    children,
    env
  } = props;
  const [isLoading, setIsLoading] = React__default.useState(true);
  const setEnv = useEnvStore((state) => state.setEnv);
  const accessToken = useEnvStore((state) => state.env.mapboxToken);
  React__default.useLayoutEffect(() => {
    if (env) {
      const curate = (token) => {
        const startRegex = /^"|^%22/;
        const endRegex = /"$|%22$/;
        return token.replace(startRegex, "").replace(endRegex, "");
      };
      setEnv({
        ...env,
        mapboxToken: curate(env.mapboxToken)
      });
    }
  }, [env, setEnv]);
  React__default.useLayoutEffect(() => {
    if (accessToken) {
      setIsLoading(false);
    }
  }, [accessToken]);
  if (isLoading)
    return null;
  return /* @__PURE__ */ jsx(MapProvider$1, { children });
}
MapProvider.propTypes = {
  children: propTypesExports$1.node,
  env: propTypesExports$1.object
};
MapProvider.defaultProps = {
  children: null,
  env: {}
};
function CameraFocus(props) {
  const {
    enabled,
    center: destination2,
    flyTo,
    easeTo,
    freeCameraOptions,
    target: targetIn,
    bearing: bearing2,
    pitch,
    zoom: zoom2,
    altitude,
    pitchWithRotate,
    enableRotate,
    reset: reset2
  } = props;
  const {
    map: map5
  } = useMapbox();
  const camera = React__default.useMemo(() => map5 == null ? void 0 : map5.getFreeCameraOptions(), [map5]);
  React__default.useLayoutEffect(() => {
    if (map5 && reset2) {
      if (enableRotate) {
        map5.dragRotate.enable();
        map5.touchZoomRotate.enableRotation();
      } else {
        map5.dragRotate.disable();
        map5.touchZoomRotate.disableRotation();
      }
    }
  }, [enableRotate, map5, reset2]);
  React__default.useLayoutEffect(() => {
    if (map5 && reset2) {
      if (pitchWithRotate) {
        map5.setMinPitch(0);
        map5.setMaxPitch(85);
      } else {
        map5.setMinPitch(0);
        map5.setMaxPitch(0);
        map5.setPitch(0);
      }
    }
  }, [pitchWithRotate, map5, reset2]);
  React__default.useEffect(() => {
    if (bearing2 && map5 && reset2) {
      map5.setBearing(bearing2);
    }
  }, [bearing2, map5, reset2]);
  React__default.useEffect(() => {
    if (pitch && map5 && reset2) {
      map5.setPitch(pitch);
    }
  }, [map5, pitch, reset2]);
  React__default.useEffect(() => {
    if (zoom2 && map5 && reset2) {
      map5.setZoom(zoom2);
    }
  }, [map5, reset2, zoom2]);
  const resetCamera = React__default.useCallback((reset22) => {
    if (!map5 || !enabled || !destination2 || !camera)
      return;
    if (freeCameraOptions && altitude) {
      camera.position = mapboxgl__default.MercatorCoordinate.fromLngLat(destination2, altitude);
      camera.lookAtPoint(targetIn || destination2);
      map5.setFreeCameraOptions(camera);
    } else if (flyTo) {
      map5.flyTo({
        center: destination2
      });
    } else if (easeTo) {
      map5.easeTo({
        center: destination2
      });
    } else if (reset22) {
      map5.easeTo({
        center: destination2
      });
    }
  }, [altitude, camera, destination2, easeTo, enabled, flyTo, freeCameraOptions, map5, targetIn]);
  React__default.useEffect(() => {
    if (reset2) {
      resetCamera(reset2);
    }
  }, [resetCamera, reset2]);
  return null;
}
CameraFocus.propTypes = {
  enabled: propTypesExports$1.bool,
  center: propTypesExports$1.array,
  flyTo: propTypesExports$1.oneOfType([propTypesExports$1.bool, propTypesExports$1.object]),
  easeTo: propTypesExports$1.oneOfType([propTypesExports$1.bool, propTypesExports$1.object]),
  target: propTypesExports$1.object,
  freeCameraOptions: propTypesExports$1.bool,
  bearing: propTypesExports$1.number,
  pitch: propTypesExports$1.number,
  zoom: propTypesExports$1.number,
  altitude: propTypesExports$1.number,
  pitchWithRotate: propTypesExports$1.bool,
  enableRotate: propTypesExports$1.bool,
  reset: propTypesExports$1.bool
};
CameraFocus.defaultProps = {
  enabled: true,
  center: null,
  flyTo: false,
  easeTo: false,
  target: null,
  freeCameraOptions: false,
  bearing: null,
  pitch: null,
  zoom: 15.4,
  altitude: null,
  pitchWithRotate: true,
  enableRotate: true,
  reset: true
};
async function parseFromContext$1(data2, loaders, options2, context2) {
  return context2._parse(data2, loaders, options2, context2);
}
function assert$e(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "loader assertion failed.");
  }
}
const isBrowser$5 = (
  // @ts-ignore process does not exist on browser
  Boolean(typeof process !== "object" || String(process) !== "[object process]" || process.browser)
);
const matches$3 = typeof process !== "undefined" && process.version && /v([0-9]*)/.exec(process.version);
matches$3 && parseFloat(matches$3[1]) || 0;
const window_$1 = globalThis;
const process_ = globalThis.process || {};
const navigator_ = globalThis.navigator || {};
function isElectron(mockUserAgent) {
  var _a3, _b3;
  if (typeof window !== "undefined" && ((_a3 = window.process) == null ? void 0 : _a3.type) === "renderer") {
    return true;
  }
  if (typeof process !== "undefined" && Boolean((_b3 = process.versions) == null ? void 0 : _b3["electron"])) {
    return true;
  }
  const realUserAgent = typeof navigator !== "undefined" && navigator.userAgent;
  const userAgent2 = mockUserAgent || realUserAgent;
  return Boolean(userAgent2 && userAgent2.indexOf("Electron") >= 0);
}
function isBrowser$4() {
  const isNode = (
    // @ts-expect-error
    typeof process === "object" && String(process) === "[object process]" && !(process == null ? void 0 : process.browser)
  );
  return !isNode || isElectron();
}
function getBrowser(mockUserAgent) {
  if (!mockUserAgent && !isBrowser$4()) {
    return "Node";
  }
  if (isElectron(mockUserAgent)) {
    return "Electron";
  }
  const userAgent2 = mockUserAgent || navigator_.userAgent || "";
  if (userAgent2.indexOf("Edge") > -1) {
    return "Edge";
  }
  if (globalThis.chrome) {
    return "Chrome";
  }
  if (globalThis.safari) {
    return "Safari";
  }
  if (globalThis.mozInnerScreenX) {
    return "Firefox";
  }
  return "Unknown";
}
const VERSION$f = "4.0.7";
function getStorage(type) {
  try {
    const storage = window[type];
    const x2 = "__storage_test__";
    storage.setItem(x2, x2);
    storage.removeItem(x2);
    return storage;
  } catch (e3) {
    return null;
  }
}
class LocalStorage {
  constructor(id, defaultConfig, type = "sessionStorage") {
    this.storage = getStorage(type);
    this.id = id;
    this.config = defaultConfig;
    this._loadConfiguration();
  }
  getConfiguration() {
    return this.config;
  }
  setConfiguration(configuration) {
    Object.assign(this.config, configuration);
    if (this.storage) {
      const serialized = JSON.stringify(this.config);
      this.storage.setItem(this.id, serialized);
    }
  }
  // Get config from persistent store, if available
  _loadConfiguration() {
    let configuration = {};
    if (this.storage) {
      const serializedConfiguration = this.storage.getItem(this.id);
      configuration = serializedConfiguration ? JSON.parse(serializedConfiguration) : {};
    }
    Object.assign(this.config, configuration);
    return this;
  }
}
function formatTime(ms) {
  let formatted;
  if (ms < 10) {
    formatted = `${ms.toFixed(2)}ms`;
  } else if (ms < 100) {
    formatted = `${ms.toFixed(1)}ms`;
  } else if (ms < 1e3) {
    formatted = `${ms.toFixed(0)}ms`;
  } else {
    formatted = `${(ms / 1e3).toFixed(2)}s`;
  }
  return formatted;
}
function leftPad(string3, length2 = 8) {
  const padLength = Math.max(length2 - string3.length, 0);
  return `${" ".repeat(padLength)}${string3}`;
}
var COLOR;
(function(COLOR2) {
  COLOR2[COLOR2["BLACK"] = 30] = "BLACK";
  COLOR2[COLOR2["RED"] = 31] = "RED";
  COLOR2[COLOR2["GREEN"] = 32] = "GREEN";
  COLOR2[COLOR2["YELLOW"] = 33] = "YELLOW";
  COLOR2[COLOR2["BLUE"] = 34] = "BLUE";
  COLOR2[COLOR2["MAGENTA"] = 35] = "MAGENTA";
  COLOR2[COLOR2["CYAN"] = 36] = "CYAN";
  COLOR2[COLOR2["WHITE"] = 37] = "WHITE";
  COLOR2[COLOR2["BRIGHT_BLACK"] = 90] = "BRIGHT_BLACK";
  COLOR2[COLOR2["BRIGHT_RED"] = 91] = "BRIGHT_RED";
  COLOR2[COLOR2["BRIGHT_GREEN"] = 92] = "BRIGHT_GREEN";
  COLOR2[COLOR2["BRIGHT_YELLOW"] = 93] = "BRIGHT_YELLOW";
  COLOR2[COLOR2["BRIGHT_BLUE"] = 94] = "BRIGHT_BLUE";
  COLOR2[COLOR2["BRIGHT_MAGENTA"] = 95] = "BRIGHT_MAGENTA";
  COLOR2[COLOR2["BRIGHT_CYAN"] = 96] = "BRIGHT_CYAN";
  COLOR2[COLOR2["BRIGHT_WHITE"] = 97] = "BRIGHT_WHITE";
})(COLOR || (COLOR = {}));
const BACKGROUND_INCREMENT = 10;
function getColor(color) {
  if (typeof color !== "string") {
    return color;
  }
  color = color.toUpperCase();
  return COLOR[color] || COLOR.WHITE;
}
function addColor(string3, color, background) {
  if (!isBrowser$4 && typeof string3 === "string") {
    if (color) {
      const colorCode = getColor(color);
      string3 = `\x1B[${colorCode}m${string3}\x1B[39m`;
    }
    if (background) {
      const colorCode = getColor(background);
      string3 = `\x1B[${colorCode + BACKGROUND_INCREMENT}m${string3}\x1B[49m`;
    }
  }
  return string3;
}
function autobind(obj, predefined = ["constructor"]) {
  const proto = Object.getPrototypeOf(obj);
  const propNames = Object.getOwnPropertyNames(proto);
  const object2 = obj;
  for (const key of propNames) {
    const value = object2[key];
    if (typeof value === "function") {
      if (!predefined.find((name2) => key === name2)) {
        object2[key] = value.bind(obj);
      }
    }
  }
}
function assert$d(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "Assertion failed");
  }
}
function getHiResTimestamp$1() {
  var _a3, _b3, _c2;
  let timestamp2;
  if (isBrowser$4() && window_$1.performance) {
    timestamp2 = (_b3 = (_a3 = window_$1 == null ? void 0 : window_$1.performance) == null ? void 0 : _a3.now) == null ? void 0 : _b3.call(_a3);
  } else if ("hrtime" in process_) {
    const timeParts = (_c2 = process_ == null ? void 0 : process_.hrtime) == null ? void 0 : _c2.call(process_);
    timestamp2 = timeParts[0] * 1e3 + timeParts[1] / 1e6;
  } else {
    timestamp2 = Date.now();
  }
  return timestamp2;
}
const originalConsole = {
  debug: isBrowser$4() ? console.debug || console.log : console.log,
  log: console.log,
  info: console.info,
  warn: console.warn,
  error: console.error
};
const DEFAULT_LOG_CONFIGURATION = {
  enabled: true,
  level: 0
};
function noop$5() {
}
const cache$1 = {};
const ONCE = { once: true };
class Log {
  constructor({ id } = { id: "" }) {
    this.VERSION = VERSION$f;
    this._startTs = getHiResTimestamp$1();
    this._deltaTs = getHiResTimestamp$1();
    this.userData = {};
    this.LOG_THROTTLE_TIMEOUT = 0;
    this.id = id;
    this.userData = {};
    this._storage = new LocalStorage(`__probe-${this.id}__`, DEFAULT_LOG_CONFIGURATION);
    this.timeStamp(`${this.id} started`);
    autobind(this);
    Object.seal(this);
  }
  set level(newLevel) {
    this.setLevel(newLevel);
  }
  get level() {
    return this.getLevel();
  }
  isEnabled() {
    return this._storage.config.enabled;
  }
  getLevel() {
    return this._storage.config.level;
  }
  /** @return milliseconds, with fractions */
  getTotal() {
    return Number((getHiResTimestamp$1() - this._startTs).toPrecision(10));
  }
  /** @return milliseconds, with fractions */
  getDelta() {
    return Number((getHiResTimestamp$1() - this._deltaTs).toPrecision(10));
  }
  /** @deprecated use logLevel */
  set priority(newPriority) {
    this.level = newPriority;
  }
  /** @deprecated use logLevel */
  get priority() {
    return this.level;
  }
  /** @deprecated use logLevel */
  getPriority() {
    return this.level;
  }
  // Configure
  enable(enabled = true) {
    this._storage.setConfiguration({ enabled });
    return this;
  }
  setLevel(level) {
    this._storage.setConfiguration({ level });
    return this;
  }
  /** return the current status of the setting */
  get(setting) {
    return this._storage.config[setting];
  }
  // update the status of the setting
  set(setting, value) {
    this._storage.setConfiguration({ [setting]: value });
  }
  /** Logs the current settings as a table */
  settings() {
    if (console.table) {
      console.table(this._storage.config);
    } else {
      console.log(this._storage.config);
    }
  }
  // Unconditional logging
  assert(condition, message2) {
    if (!condition) {
      throw new Error(message2 || "Assertion failed");
    }
  }
  warn(message2) {
    return this._getLogFunction(0, message2, originalConsole.warn, arguments, ONCE);
  }
  error(message2) {
    return this._getLogFunction(0, message2, originalConsole.error, arguments);
  }
  /** Print a deprecation warning */
  deprecated(oldUsage, newUsage) {
    return this.warn(`\`${oldUsage}\` is deprecated and will be removed in a later version. Use \`${newUsage}\` instead`);
  }
  /** Print a removal warning */
  removed(oldUsage, newUsage) {
    return this.error(`\`${oldUsage}\` has been removed. Use \`${newUsage}\` instead`);
  }
  probe(logLevel, message2) {
    return this._getLogFunction(logLevel, message2, originalConsole.log, arguments, {
      time: true,
      once: true
    });
  }
  log(logLevel, message2) {
    return this._getLogFunction(logLevel, message2, originalConsole.debug, arguments);
  }
  info(logLevel, message2) {
    return this._getLogFunction(logLevel, message2, console.info, arguments);
  }
  once(logLevel, message2) {
    return this._getLogFunction(logLevel, message2, originalConsole.debug || originalConsole.info, arguments, ONCE);
  }
  /** Logs an object as a table */
  table(logLevel, table, columns) {
    if (table) {
      return this._getLogFunction(logLevel, table, console.table || noop$5, columns && [columns], {
        tag: getTableHeader(table)
      });
    }
    return noop$5;
  }
  time(logLevel, message2) {
    return this._getLogFunction(logLevel, message2, console.time ? console.time : console.info);
  }
  timeEnd(logLevel, message2) {
    return this._getLogFunction(logLevel, message2, console.timeEnd ? console.timeEnd : console.info);
  }
  timeStamp(logLevel, message2) {
    return this._getLogFunction(logLevel, message2, console.timeStamp || noop$5);
  }
  group(logLevel, message2, opts = { collapsed: false }) {
    const options2 = normalizeArguments({ logLevel, message: message2, opts });
    const { collapsed } = opts;
    options2.method = (collapsed ? console.groupCollapsed : console.group) || console.info;
    return this._getLogFunction(options2);
  }
  groupCollapsed(logLevel, message2, opts = {}) {
    return this.group(logLevel, message2, Object.assign({}, opts, { collapsed: true }));
  }
  groupEnd(logLevel) {
    return this._getLogFunction(logLevel, "", console.groupEnd || noop$5);
  }
  // EXPERIMENTAL
  withGroup(logLevel, message2, func2) {
    this.group(logLevel, message2)();
    try {
      func2();
    } finally {
      this.groupEnd(logLevel)();
    }
  }
  trace() {
    if (console.trace) {
      console.trace();
    }
  }
  // PRIVATE METHODS
  /** Deduces log level from a variety of arguments */
  _shouldLog(logLevel) {
    return this.isEnabled() && this.getLevel() >= normalizeLogLevel(logLevel);
  }
  _getLogFunction(logLevel, message2, method, args, opts) {
    if (this._shouldLog(logLevel)) {
      opts = normalizeArguments({ logLevel, message: message2, args, opts });
      method = method || opts.method;
      assert$d(method);
      opts.total = this.getTotal();
      opts.delta = this.getDelta();
      this._deltaTs = getHiResTimestamp$1();
      const tag2 = opts.tag || opts.message;
      if (opts.once && tag2) {
        if (!cache$1[tag2]) {
          cache$1[tag2] = getHiResTimestamp$1();
        } else {
          return noop$5;
        }
      }
      message2 = decorateMessage(this.id, opts.message, opts);
      return method.bind(console, message2, ...opts.args);
    }
    return noop$5;
  }
}
Log.VERSION = VERSION$f;
function normalizeLogLevel(logLevel) {
  if (!logLevel) {
    return 0;
  }
  let resolvedLevel;
  switch (typeof logLevel) {
    case "number":
      resolvedLevel = logLevel;
      break;
    case "object":
      resolvedLevel = logLevel.logLevel || logLevel.priority || 0;
      break;
    default:
      return 0;
  }
  assert$d(Number.isFinite(resolvedLevel) && resolvedLevel >= 0);
  return resolvedLevel;
}
function normalizeArguments(opts) {
  const { logLevel, message: message2 } = opts;
  opts.logLevel = normalizeLogLevel(logLevel);
  const args = opts.args ? Array.from(opts.args) : [];
  while (args.length && args.shift() !== message2) {
  }
  switch (typeof logLevel) {
    case "string":
    case "function":
      if (message2 !== void 0) {
        args.unshift(message2);
      }
      opts.message = logLevel;
      break;
    case "object":
      Object.assign(opts, logLevel);
      break;
  }
  if (typeof opts.message === "function") {
    opts.message = opts.message();
  }
  const messageType = typeof opts.message;
  assert$d(messageType === "string" || messageType === "object");
  return Object.assign(opts, { args }, opts.opts);
}
function decorateMessage(id, message2, opts) {
  if (typeof message2 === "string") {
    const time2 = opts.time ? leftPad(formatTime(opts.total)) : "";
    message2 = opts.time ? `${id}: ${time2}  ${message2}` : `${id}: ${message2}`;
    message2 = addColor(message2, opts.color, opts.background);
  }
  return message2;
}
function getTableHeader(table) {
  for (const key in table) {
    for (const title in table[key]) {
      return title || "untitled";
    }
  }
  return "empty";
}
globalThis.probe = {};
const log$3 = new Log({ id: "@probe.gl/log" });
function mergeLoaderOptions(baseOptions, newOptions) {
  return mergeOptionsRecursively(baseOptions || {}, newOptions);
}
function mergeOptionsRecursively(baseOptions, newOptions, level = 0) {
  if (level > 3) {
    return newOptions;
  }
  const options2 = { ...baseOptions };
  for (const [key, newValue] of Object.entries(newOptions)) {
    if (newValue && typeof newValue === "object" && !Array.isArray(newValue)) {
      options2[key] = mergeOptionsRecursively(options2[key] || {}, newOptions[key], level + 1);
    } else {
      options2[key] = newOptions[key];
    }
  }
  return options2;
}
function registerJSModules$1(modules) {
  var _a3;
  globalThis.loaders || (globalThis.loaders = {});
  (_a3 = globalThis.loaders).modules || (_a3.modules = {});
  Object.assign(globalThis.loaders.modules, modules);
}
function getJSModuleOrNull$1(name2) {
  var _a3, _b3;
  const module2 = (_b3 = (_a3 = globalThis.loaders) == null ? void 0 : _a3.modules) == null ? void 0 : _b3[name2];
  return module2 || null;
}
const NPM_TAG = "latest";
function getVersion$1() {
  var _a3;
  if (!((_a3 = globalThis._loadersgl_) == null ? void 0 : _a3.version)) {
    globalThis._loadersgl_ = globalThis._loadersgl_ || {};
    {
      globalThis._loadersgl_.version = "4.2.0";
    }
  }
  return globalThis._loadersgl_.version;
}
const VERSION$e = getVersion$1();
function assert$c(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "loaders.gl assertion failed.");
  }
}
const isBrowser$3 = (
  // @ts-ignore process.browser
  typeof process !== "object" || String(process) !== "[object process]" || process.browser
);
const isWorker$1 = typeof importScripts === "function";
const isMobile = typeof window !== "undefined" && typeof window.orientation !== "undefined";
const matches$2 = typeof process !== "undefined" && process.version && /v([0-9]*)/.exec(process.version);
matches$2 && parseFloat(matches$2[1]) || 0;
class WorkerJob {
  constructor(jobName, workerThread) {
    __publicField2(this, "name");
    __publicField2(this, "workerThread");
    __publicField2(this, "isRunning", true);
    /** Promise that resolves when Job is done */
    __publicField2(this, "result");
    __publicField2(this, "_resolve", () => {
    });
    __publicField2(this, "_reject", () => {
    });
    this.name = jobName;
    this.workerThread = workerThread;
    this.result = new Promise((resolve2, reject) => {
      this._resolve = resolve2;
      this._reject = reject;
    });
  }
  /**
   * Send a message to the job's worker thread
   * @param data any data structure, ideally consisting mostly of transferrable objects
   */
  postMessage(type, payload) {
    this.workerThread.postMessage({
      source: "loaders.gl",
      // Lets worker ignore unrelated messages
      type,
      payload
    });
  }
  /**
   * Call to resolve the `result` Promise with the supplied value
   */
  done(value) {
    assert$c(this.isRunning);
    this.isRunning = false;
    this._resolve(value);
  }
  /**
   * Call to reject the `result` Promise with the supplied error
   */
  error(error2) {
    assert$c(this.isRunning);
    this.isRunning = false;
    this._reject(error2);
  }
}
class NodeWorker {
  terminate() {
  }
}
const workerURLCache = /* @__PURE__ */ new Map();
function getLoadableWorkerURL(props) {
  assert$c(props.source && !props.url || !props.source && props.url);
  let workerURL = workerURLCache.get(props.source || props.url);
  if (!workerURL) {
    if (props.url) {
      workerURL = getLoadableWorkerURLFromURL(props.url);
      workerURLCache.set(props.url, workerURL);
    }
    if (props.source) {
      workerURL = getLoadableWorkerURLFromSource(props.source);
      workerURLCache.set(props.source, workerURL);
    }
  }
  assert$c(workerURL);
  return workerURL;
}
function getLoadableWorkerURLFromURL(url2) {
  if (!url2.startsWith("http")) {
    return url2;
  }
  const workerSource = buildScriptSource(url2);
  return getLoadableWorkerURLFromSource(workerSource);
}
function getLoadableWorkerURLFromSource(workerSource) {
  const blob = new Blob([workerSource], { type: "application/javascript" });
  return URL.createObjectURL(blob);
}
function buildScriptSource(workerUrl) {
  return `try {
  importScripts('${workerUrl}');
} catch (error) {
  console.error(error);
  throw error;
}`;
}
function getTransferList(object2, recursive = true, transfers) {
  const transfersSet = transfers || /* @__PURE__ */ new Set();
  if (!object2)
    ;
  else if (isTransferable(object2)) {
    transfersSet.add(object2);
  } else if (isTransferable(object2.buffer)) {
    transfersSet.add(object2.buffer);
  } else if (ArrayBuffer.isView(object2))
    ;
  else if (recursive && typeof object2 === "object") {
    for (const key in object2) {
      getTransferList(object2[key], recursive, transfersSet);
    }
  }
  return transfers === void 0 ? Array.from(transfersSet) : [];
}
function isTransferable(object2) {
  if (!object2) {
    return false;
  }
  if (object2 instanceof ArrayBuffer) {
    return true;
  }
  if (typeof MessagePort !== "undefined" && object2 instanceof MessagePort) {
    return true;
  }
  if (typeof ImageBitmap !== "undefined" && object2 instanceof ImageBitmap) {
    return true;
  }
  if (typeof OffscreenCanvas !== "undefined" && object2 instanceof OffscreenCanvas) {
    return true;
  }
  return false;
}
const NOOP = () => {
};
class WorkerThread {
  constructor(props) {
    __publicField2(this, "name");
    __publicField2(this, "source");
    __publicField2(this, "url");
    __publicField2(this, "terminated", false);
    __publicField2(this, "worker");
    __publicField2(this, "onMessage");
    __publicField2(this, "onError");
    __publicField2(this, "_loadableURL", "");
    const { name: name2, source, url: url2 } = props;
    assert$c(source || url2);
    this.name = name2;
    this.source = source;
    this.url = url2;
    this.onMessage = NOOP;
    this.onError = (error2) => console.log(error2);
    this.worker = isBrowser$3 ? this._createBrowserWorker() : this._createNodeWorker();
  }
  /** Checks if workers are supported on this platform */
  static isSupported() {
    return typeof Worker !== "undefined" && isBrowser$3 || typeof NodeWorker !== "undefined" && !isBrowser$3;
  }
  /**
   * Terminate this worker thread
   * @note Can free up significant memory
   */
  destroy() {
    this.onMessage = NOOP;
    this.onError = NOOP;
    this.worker.terminate();
    this.terminated = true;
  }
  get isRunning() {
    return Boolean(this.onMessage);
  }
  /**
   * Send a message to this worker thread
   * @param data any data structure, ideally consisting mostly of transferrable objects
   * @param transferList If not supplied, calculated automatically by traversing data
   */
  postMessage(data2, transferList) {
    transferList = transferList || getTransferList(data2);
    this.worker.postMessage(data2, transferList);
  }
  // PRIVATE
  /**
   * Generate a standard Error from an ErrorEvent
   * @param event
   */
  _getErrorFromErrorEvent(event) {
    let message2 = "Failed to load ";
    message2 += `worker ${this.name} from ${this.url}. `;
    if (event.message) {
      message2 += `${event.message} in `;
    }
    if (event.lineno) {
      message2 += `:${event.lineno}:${event.colno}`;
    }
    return new Error(message2);
  }
  /**
   * Creates a worker thread on the browser
   */
  _createBrowserWorker() {
    this._loadableURL = getLoadableWorkerURL({ source: this.source, url: this.url });
    const worker2 = new Worker(this._loadableURL, { name: this.name });
    worker2.onmessage = (event) => {
      if (!event.data) {
        this.onError(new Error("No data received"));
      } else {
        this.onMessage(event.data);
      }
    };
    worker2.onerror = (error2) => {
      this.onError(this._getErrorFromErrorEvent(error2));
      this.terminated = true;
    };
    worker2.onmessageerror = (event) => console.error(event);
    return worker2;
  }
  /**
   * Creates a worker thread in node.js
   * @todo https://nodejs.org/api/async_hooks.html#async-resource-worker-pool
   */
  _createNodeWorker() {
    let worker2;
    if (this.url) {
      const absolute2 = this.url.includes(":/") || this.url.startsWith("/");
      const url2 = absolute2 ? this.url : `./${this.url}`;
      worker2 = new NodeWorker(url2, { eval: false });
    } else if (this.source) {
      worker2 = new NodeWorker(this.source, { eval: true });
    } else {
      throw new Error("no worker");
    }
    worker2.on("message", (data2) => {
      this.onMessage(data2);
    });
    worker2.on("error", (error2) => {
      this.onError(error2);
    });
    worker2.on("exit", (code) => {
    });
    return worker2;
  }
}
class WorkerPool {
  /**
   * @param processor - worker function
   * @param maxConcurrency - max count of workers
   */
  constructor(props) {
    __publicField2(this, "name", "unnamed");
    __publicField2(this, "source");
    // | Function;
    __publicField2(this, "url");
    __publicField2(this, "maxConcurrency", 1);
    __publicField2(this, "maxMobileConcurrency", 1);
    __publicField2(this, "onDebug", () => {
    });
    __publicField2(this, "reuseWorkers", true);
    __publicField2(this, "props", {});
    __publicField2(this, "jobQueue", []);
    __publicField2(this, "idleQueue", []);
    __publicField2(this, "count", 0);
    __publicField2(this, "isDestroyed", false);
    this.source = props.source;
    this.url = props.url;
    this.setProps(props);
  }
  /** Checks if workers are supported on this platform */
  static isSupported() {
    return WorkerThread.isSupported();
  }
  /**
   * Terminates all workers in the pool
   * @note Can free up significant memory
   */
  destroy() {
    this.idleQueue.forEach((worker2) => worker2.destroy());
    this.isDestroyed = true;
  }
  setProps(props) {
    this.props = { ...this.props, ...props };
    if (props.name !== void 0) {
      this.name = props.name;
    }
    if (props.maxConcurrency !== void 0) {
      this.maxConcurrency = props.maxConcurrency;
    }
    if (props.maxMobileConcurrency !== void 0) {
      this.maxMobileConcurrency = props.maxMobileConcurrency;
    }
    if (props.reuseWorkers !== void 0) {
      this.reuseWorkers = props.reuseWorkers;
    }
    if (props.onDebug !== void 0) {
      this.onDebug = props.onDebug;
    }
  }
  async startJob(name2, onMessage2 = (job, type, data2) => job.done(data2), onError = (job, error2) => job.error(error2)) {
    const startPromise = new Promise((onStart) => {
      this.jobQueue.push({ name: name2, onMessage: onMessage2, onError, onStart });
      return this;
    });
    this._startQueuedJob();
    return await startPromise;
  }
  // PRIVATE
  /**
   * Starts first queued job if worker is available or can be created
   * Called when job is started and whenever a worker returns to the idleQueue
   */
  async _startQueuedJob() {
    if (!this.jobQueue.length) {
      return;
    }
    const workerThread = this._getAvailableWorker();
    if (!workerThread) {
      return;
    }
    const queuedJob = this.jobQueue.shift();
    if (queuedJob) {
      this.onDebug({
        message: "Starting job",
        name: queuedJob.name,
        workerThread,
        backlog: this.jobQueue.length
      });
      const job = new WorkerJob(queuedJob.name, workerThread);
      workerThread.onMessage = (data2) => queuedJob.onMessage(job, data2.type, data2.payload);
      workerThread.onError = (error2) => queuedJob.onError(job, error2);
      queuedJob.onStart(job);
      try {
        await job.result;
      } catch (error2) {
        console.error(`Worker exception: ${error2}`);
      } finally {
        this.returnWorkerToQueue(workerThread);
      }
    }
  }
  /**
   * Returns a worker to the idle queue
   * Destroys the worker if
   *  - pool is destroyed
   *  - if this pool doesn't reuse workers
   *  - if maxConcurrency has been lowered
   * @param worker
   */
  returnWorkerToQueue(worker2) {
    const shouldDestroyWorker = (
      // Workers on Node.js prevent the process from exiting.
      // Until we figure out how to close them before exit, we always destroy them
      !isBrowser$3 || // If the pool is destroyed, there is no reason to keep the worker around
      this.isDestroyed || // If the app has disabled worker reuse, any completed workers should be destroyed
      !this.reuseWorkers || // If concurrency has been lowered, this worker might be surplus to requirements
      this.count > this._getMaxConcurrency()
    );
    if (shouldDestroyWorker) {
      worker2.destroy();
      this.count--;
    } else {
      this.idleQueue.push(worker2);
    }
    if (!this.isDestroyed) {
      this._startQueuedJob();
    }
  }
  /**
   * Returns idle worker or creates new worker if maxConcurrency has not been reached
   */
  _getAvailableWorker() {
    if (this.idleQueue.length > 0) {
      return this.idleQueue.shift() || null;
    }
    if (this.count < this._getMaxConcurrency()) {
      this.count++;
      const name2 = `${this.name.toLowerCase()} (#${this.count} of ${this.maxConcurrency})`;
      return new WorkerThread({ name: name2, source: this.source, url: this.url });
    }
    return null;
  }
  _getMaxConcurrency() {
    return isMobile ? this.maxMobileConcurrency : this.maxConcurrency;
  }
}
const DEFAULT_PROPS$4 = {
  maxConcurrency: 3,
  maxMobileConcurrency: 1,
  reuseWorkers: true,
  onDebug: () => {
  }
};
const _WorkerFarm = class {
  /** get global instance with WorkerFarm.getWorkerFarm() */
  constructor(props) {
    __publicField2(this, "props");
    __publicField2(this, "workerPools", /* @__PURE__ */ new Map());
    this.props = { ...DEFAULT_PROPS$4 };
    this.setProps(props);
    this.workerPools = /* @__PURE__ */ new Map();
  }
  /** Checks if workers are supported on this platform */
  static isSupported() {
    return WorkerThread.isSupported();
  }
  /** Get the singleton instance of the global worker farm */
  static getWorkerFarm(props = {}) {
    _WorkerFarm._workerFarm = _WorkerFarm._workerFarm || new _WorkerFarm({});
    _WorkerFarm._workerFarm.setProps(props);
    return _WorkerFarm._workerFarm;
  }
  /**
   * Terminate all workers in the farm
   * @note Can free up significant memory
   */
  destroy() {
    for (const workerPool of this.workerPools.values()) {
      workerPool.destroy();
    }
    this.workerPools = /* @__PURE__ */ new Map();
  }
  /**
   * Set props used when initializing worker pools
   * @param props
   */
  setProps(props) {
    this.props = { ...this.props, ...props };
    for (const workerPool of this.workerPools.values()) {
      workerPool.setProps(this._getWorkerPoolProps());
    }
  }
  /**
   * Returns a worker pool for the specified worker
   * @param options - only used first time for a specific worker name
   * @param options.name - the name of the worker - used to identify worker pool
   * @param options.url -
   * @param options.source -
   * @example
   *   const job = WorkerFarm.getWorkerFarm().getWorkerPool({name, url}).startJob(...);
   */
  getWorkerPool(options2) {
    const { name: name2, source, url: url2 } = options2;
    let workerPool = this.workerPools.get(name2);
    if (!workerPool) {
      workerPool = new WorkerPool({
        name: name2,
        source,
        url: url2
      });
      workerPool.setProps(this._getWorkerPoolProps());
      this.workerPools.set(name2, workerPool);
    }
    return workerPool;
  }
  _getWorkerPoolProps() {
    return {
      maxConcurrency: this.props.maxConcurrency,
      maxMobileConcurrency: this.props.maxMobileConcurrency,
      reuseWorkers: this.props.reuseWorkers,
      onDebug: this.props.onDebug
    };
  }
};
let WorkerFarm = _WorkerFarm;
// singleton
__publicField2(WorkerFarm, "_workerFarm");
function getWorkerURL(worker2, options2 = {}) {
  const workerOptions = options2[worker2.id] || {};
  const workerFile = isBrowser$3 ? `${worker2.id}-worker.js` : `${worker2.id}-worker-node.js`;
  let url2 = workerOptions.workerUrl;
  if (!url2 && worker2.id === "compression") {
    url2 = options2.workerUrl;
  }
  if (options2._workerType === "test") {
    if (isBrowser$3) {
      url2 = `modules/${worker2.module}/dist/${workerFile}`;
    } else {
      url2 = `modules/${worker2.module}/src/workers/${worker2.id}-worker-node.ts`;
    }
  }
  if (!url2) {
    let version2 = worker2.version;
    if (version2 === "latest") {
      version2 = NPM_TAG;
    }
    const versionTag = version2 ? `@${version2}` : "";
    url2 = `https://unpkg.com/@loaders.gl/${worker2.module}${versionTag}/dist/${workerFile}`;
  }
  assert$c(url2);
  return url2;
}
function validateWorkerVersion(worker2, coreVersion = VERSION$e) {
  assert$c(worker2, "no worker provided");
  const workerVersion = worker2.version;
  if (!coreVersion || !workerVersion) {
    return false;
  }
  return true;
}
const loadLibraryPromises$1 = {};
async function loadLibrary$1(libraryUrl, moduleName = null, options2 = {}, libraryName = null) {
  if (moduleName) {
    libraryUrl = getLibraryUrl$1(libraryUrl, moduleName, options2, libraryName);
  }
  loadLibraryPromises$1[libraryUrl] = // eslint-disable-next-line @typescript-eslint/no-misused-promises
  loadLibraryPromises$1[libraryUrl] || loadLibraryFromFile$1(libraryUrl);
  return await loadLibraryPromises$1[libraryUrl];
}
function getLibraryUrl$1(library, moduleName, options2 = {}, libraryName = null) {
  if (!options2.useLocalLibraries && library.startsWith("http")) {
    return library;
  }
  libraryName = libraryName || library;
  const modules = options2.modules || {};
  if (modules[libraryName]) {
    return modules[libraryName];
  }
  if (!isBrowser$3) {
    return `modules/${moduleName}/dist/libs/${libraryName}`;
  }
  if (options2.CDN) {
    assert$c(options2.CDN.startsWith("http"));
    return `${options2.CDN}/${moduleName}@${VERSION$e}/dist/libs/${libraryName}`;
  }
  if (isWorker$1) {
    return `../src/libs/${libraryName}`;
  }
  return `modules/${moduleName}/src/libs/${libraryName}`;
}
async function loadLibraryFromFile$1(libraryUrl) {
  if (libraryUrl.endsWith("wasm")) {
    return await loadAsArrayBuffer$1(libraryUrl);
  }
  if (!isBrowser$3) {
    try {
      const { requireFromFile } = globalThis.loaders || {};
      return await (requireFromFile == null ? void 0 : requireFromFile(libraryUrl));
    } catch (error2) {
      console.error(error2);
      return null;
    }
  }
  if (isWorker$1) {
    return importScripts(libraryUrl);
  }
  const scriptSource = await loadAsText$1(libraryUrl);
  return loadLibraryFromString$1(scriptSource, libraryUrl);
}
function loadLibraryFromString$1(scriptSource, id) {
  if (!isBrowser$3) {
    const { requireFromString } = globalThis.loaders || {};
    return requireFromString == null ? void 0 : requireFromString(scriptSource, id);
  }
  if (isWorker$1) {
    eval.call(globalThis, scriptSource);
    return null;
  }
  const script = document.createElement("script");
  script.id = id;
  try {
    script.appendChild(document.createTextNode(scriptSource));
  } catch (e3) {
    script.text = scriptSource;
  }
  document.body.appendChild(script);
  return null;
}
async function loadAsArrayBuffer$1(url2) {
  const { readFileAsArrayBuffer } = globalThis.loaders || {};
  if (isBrowser$3 || !readFileAsArrayBuffer || url2.startsWith("http")) {
    const response = await fetch(url2);
    return await response.arrayBuffer();
  }
  return await readFileAsArrayBuffer(url2);
}
async function loadAsText$1(url2) {
  const { readFileAsText } = globalThis.loaders || {};
  if (isBrowser$3 || !readFileAsText || url2.startsWith("http")) {
    const response = await fetch(url2);
    return await response.text();
  }
  return await readFileAsText(url2);
}
function canParseWithWorker(loader2, options2) {
  if (!WorkerFarm.isSupported()) {
    return false;
  }
  if (!isBrowser$3 && !(options2 == null ? void 0 : options2._nodeWorkers)) {
    return false;
  }
  return loader2.worker && (options2 == null ? void 0 : options2.worker);
}
async function parseWithWorker(loader2, data2, options2, context2, parseOnMainThread) {
  const name2 = loader2.id;
  const url2 = getWorkerURL(loader2, options2);
  const workerFarm = WorkerFarm.getWorkerFarm(options2);
  const workerPool = workerFarm.getWorkerPool({ name: name2, url: url2 });
  options2 = JSON.parse(JSON.stringify(options2));
  context2 = JSON.parse(JSON.stringify(context2 || {}));
  const job = await workerPool.startJob(
    "process-on-worker",
    // @ts-expect-error
    onMessage.bind(null, parseOnMainThread)
    // eslint-disable-line @typescript-eslint/no-misused-promises
  );
  job.postMessage("process", {
    // @ts-ignore
    input: data2,
    options: options2,
    context: context2
  });
  const result = await job.result;
  return await result.result;
}
async function onMessage(parseOnMainThread, job, type, payload) {
  switch (type) {
    case "done":
      job.done(payload);
      break;
    case "error":
      job.error(new Error(payload.error));
      break;
    case "process":
      const { id, input, options: options2 } = payload;
      try {
        const result = await parseOnMainThread(input, options2);
        job.postMessage("done", { id, result });
      } catch (error2) {
        const message2 = error2 instanceof Error ? error2.message : "unknown error";
        job.postMessage("error", { id, error: message2 });
      }
      break;
    default:
      console.warn(`parse-with-worker unknown message ${type}`);
  }
}
function getFirstCharacters$2(data2, length2 = 5) {
  if (typeof data2 === "string") {
    return data2.slice(0, length2);
  } else if (ArrayBuffer.isView(data2)) {
    return getMagicString$6(data2.buffer, data2.byteOffset, length2);
  } else if (data2 instanceof ArrayBuffer) {
    const byteOffset = 0;
    return getMagicString$6(data2, byteOffset, length2);
  }
  return "";
}
function getMagicString$6(arrayBuffer2, byteOffset, length2) {
  if (arrayBuffer2.byteLength <= byteOffset + length2) {
    return "";
  }
  const dataView = new DataView(arrayBuffer2);
  let magic = "";
  for (let i2 = 0; i2 < length2; i2++) {
    magic += String.fromCharCode(dataView.getUint8(byteOffset + i2));
  }
  return magic;
}
function parseJSON$1(string3) {
  try {
    return JSON.parse(string3);
  } catch (_2) {
    throw new Error(`Failed to parse JSON from data starting with "${getFirstCharacters$2(string3)}"`);
  }
}
function compareArrayBuffers(arrayBuffer1, arrayBuffer2, byteLength) {
  byteLength = byteLength || arrayBuffer1.byteLength;
  if (arrayBuffer1.byteLength < byteLength || arrayBuffer2.byteLength < byteLength) {
    return false;
  }
  const array1 = new Uint8Array(arrayBuffer1);
  const array2 = new Uint8Array(arrayBuffer2);
  for (let i2 = 0; i2 < array1.length; ++i2) {
    if (array1[i2] !== array2[i2]) {
      return false;
    }
  }
  return true;
}
function concatenateArrayBuffers(...sources2) {
  return concatenateArrayBuffersFromArray(sources2);
}
function concatenateArrayBuffersFromArray(sources2) {
  const sourceArrays = sources2.map((source2) => source2 instanceof ArrayBuffer ? new Uint8Array(source2) : source2);
  const byteLength = sourceArrays.reduce((length2, typedArray) => length2 + typedArray.byteLength, 0);
  const result = new Uint8Array(byteLength);
  let offset = 0;
  for (const sourceArray of sourceArrays) {
    result.set(sourceArray, offset);
    offset += sourceArray.byteLength;
  }
  return result.buffer;
}
function sliceArrayBuffer$1(arrayBuffer2, byteOffset, byteLength) {
  const subArray = byteLength !== void 0 ? new Uint8Array(arrayBuffer2).subarray(byteOffset, byteOffset + byteLength) : new Uint8Array(arrayBuffer2).subarray(byteOffset);
  const arrayCopy2 = new Uint8Array(subArray);
  return arrayCopy2.buffer;
}
function padToNBytes$1(byteLength, padding) {
  assert$e(byteLength >= 0);
  assert$e(padding > 0);
  return byteLength + (padding - 1) & ~(padding - 1);
}
function copyToArray$1(source, target, targetOffset) {
  let sourceArray;
  if (source instanceof ArrayBuffer) {
    sourceArray = new Uint8Array(source);
  } else {
    const srcByteOffset = source.byteOffset;
    const srcByteLength = source.byteLength;
    sourceArray = new Uint8Array(source.buffer || source.arrayBuffer, srcByteOffset, srcByteLength);
  }
  target.set(sourceArray, targetOffset);
  return targetOffset + padToNBytes$1(sourceArray.byteLength, 4);
}
async function concatenateArrayBuffersAsync(asyncIterator) {
  const arrayBuffers = [];
  for await (const chunk of asyncIterator) {
    arrayBuffers.push(chunk);
  }
  return concatenateArrayBuffers(...arrayBuffers);
}
function getHiResTimestamp() {
  let timestamp2;
  if (typeof window !== "undefined" && window.performance) {
    timestamp2 = window.performance.now();
  } else if (typeof process !== "undefined" && process.hrtime) {
    const timeParts = process.hrtime();
    timestamp2 = timeParts[0] * 1e3 + timeParts[1] / 1e6;
  } else {
    timestamp2 = Date.now();
  }
  return timestamp2;
}
class Stat {
  constructor(name2, type) {
    this.sampleSize = 1;
    this.time = 0;
    this.count = 0;
    this.samples = 0;
    this.lastTiming = 0;
    this.lastSampleTime = 0;
    this.lastSampleCount = 0;
    this._count = 0;
    this._time = 0;
    this._samples = 0;
    this._startTime = 0;
    this._timerPending = false;
    this.name = name2;
    this.type = type;
    this.reset();
  }
  reset() {
    this.time = 0;
    this.count = 0;
    this.samples = 0;
    this.lastTiming = 0;
    this.lastSampleTime = 0;
    this.lastSampleCount = 0;
    this._count = 0;
    this._time = 0;
    this._samples = 0;
    this._startTime = 0;
    this._timerPending = false;
    return this;
  }
  setSampleSize(samples) {
    this.sampleSize = samples;
    return this;
  }
  /** Call to increment count (+1) */
  incrementCount() {
    this.addCount(1);
    return this;
  }
  /** Call to decrement count (-1) */
  decrementCount() {
    this.subtractCount(1);
    return this;
  }
  /** Increase count */
  addCount(value) {
    this._count += value;
    this._samples++;
    this._checkSampling();
    return this;
  }
  /** Decrease count */
  subtractCount(value) {
    this._count -= value;
    this._samples++;
    this._checkSampling();
    return this;
  }
  /** Add an arbitrary timing and bump the count */
  addTime(time2) {
    this._time += time2;
    this.lastTiming = time2;
    this._samples++;
    this._checkSampling();
    return this;
  }
  /** Start a timer */
  timeStart() {
    this._startTime = getHiResTimestamp();
    this._timerPending = true;
    return this;
  }
  /** End a timer. Adds to time and bumps the timing count. */
  timeEnd() {
    if (!this._timerPending) {
      return this;
    }
    this.addTime(getHiResTimestamp() - this._startTime);
    this._timerPending = false;
    this._checkSampling();
    return this;
  }
  getSampleAverageCount() {
    return this.sampleSize > 0 ? this.lastSampleCount / this.sampleSize : 0;
  }
  /** Calculate average time / count for the previous window */
  getSampleAverageTime() {
    return this.sampleSize > 0 ? this.lastSampleTime / this.sampleSize : 0;
  }
  /** Calculate counts per second for the previous window */
  getSampleHz() {
    return this.lastSampleTime > 0 ? this.sampleSize / (this.lastSampleTime / 1e3) : 0;
  }
  getAverageCount() {
    return this.samples > 0 ? this.count / this.samples : 0;
  }
  /** Calculate average time / count */
  getAverageTime() {
    return this.samples > 0 ? this.time / this.samples : 0;
  }
  /** Calculate counts per second */
  getHz() {
    return this.time > 0 ? this.samples / (this.time / 1e3) : 0;
  }
  _checkSampling() {
    if (this._samples === this.sampleSize) {
      this.lastSampleTime = this._time;
      this.lastSampleCount = this._count;
      this.count += this._count;
      this.time += this._time;
      this.samples += this._samples;
      this._time = 0;
      this._count = 0;
      this._samples = 0;
    }
  }
}
class Stats {
  constructor(options2) {
    this.stats = {};
    this.id = options2.id;
    this.stats = {};
    this._initializeStats(options2.stats);
    Object.seal(this);
  }
  /** Acquire a stat. Create if it doesn't exist. */
  get(name2, type = "count") {
    return this._getOrCreate({ name: name2, type });
  }
  get size() {
    return Object.keys(this.stats).length;
  }
  /** Reset all stats */
  reset() {
    for (const stat of Object.values(this.stats)) {
      stat.reset();
    }
    return this;
  }
  forEach(fn2) {
    for (const stat of Object.values(this.stats)) {
      fn2(stat);
    }
  }
  getTable() {
    const table = {};
    this.forEach((stat) => {
      table[stat.name] = {
        time: stat.time || 0,
        count: stat.count || 0,
        average: stat.getAverageTime() || 0,
        hz: stat.getHz() || 0
      };
    });
    return table;
  }
  _initializeStats(stats = []) {
    stats.forEach((stat) => this._getOrCreate(stat));
  }
  _getOrCreate(stat) {
    const { name: name2, type } = stat;
    let result = this.stats[name2];
    if (!result) {
      if (stat instanceof Stat) {
        result = stat;
      } else {
        result = new Stat(name2, type);
      }
      this.stats[name2] = result;
    }
    return result;
  }
}
const STAT_QUEUED_REQUESTS = "Queued Requests";
const STAT_ACTIVE_REQUESTS = "Active Requests";
const STAT_CANCELLED_REQUESTS = "Cancelled Requests";
const STAT_QUEUED_REQUESTS_EVER = "Queued Requests Ever";
const STAT_ACTIVE_REQUESTS_EVER = "Active Requests Ever";
const DEFAULT_PROPS$3 = {
  id: "request-scheduler",
  /** Specifies if the request scheduler should throttle incoming requests, mainly for comparative testing. */
  throttleRequests: true,
  /** The maximum number of simultaneous active requests. Un-throttled requests do not observe this limit. */
  maxRequests: 6,
  /**
   * Specifies a debounce time, in milliseconds. All requests are queued, until no new requests have
   * been added to the queue for this amount of time.
   */
  debounceTime: 0
};
class RequestScheduler {
  constructor(props = {}) {
    __publicField2(this, "props");
    __publicField2(this, "stats");
    __publicField2(this, "activeRequestCount", 0);
    /** Tracks the number of active requests and prioritizes/cancels queued requests. */
    __publicField2(this, "requestQueue", []);
    __publicField2(this, "requestMap", /* @__PURE__ */ new Map());
    __publicField2(this, "updateTimer", null);
    this.props = { ...DEFAULT_PROPS$3, ...props };
    this.stats = new Stats({ id: this.props.id });
    this.stats.get(STAT_QUEUED_REQUESTS);
    this.stats.get(STAT_ACTIVE_REQUESTS);
    this.stats.get(STAT_CANCELLED_REQUESTS);
    this.stats.get(STAT_QUEUED_REQUESTS_EVER);
    this.stats.get(STAT_ACTIVE_REQUESTS_EVER);
  }
  /**
   * Called by an application that wants to issue a request, without having it deeply queued by the browser
   *
   * When the returned promise resolved, it is OK for the application to issue a request.
   * The promise resolves to an object that contains a `done` method.
   * When the application's request has completed (or failed), the application must call the `done` function
   *
   * @param handle
   * @param getPriority will be called when request "slots" open up,
   *    allowing the caller to update priority or cancel the request
   *    Highest priority executes first, priority < 0 cancels the request
   * @returns a promise
   *   - resolves to a object (with a `done` field) when the request can be issued without queueing,
   *   - resolves to `null` if the request has been cancelled (by the callback return < 0).
   *     In this case the application should not issue the request
   */
  scheduleRequest(handle, getPriority = () => 0) {
    if (!this.props.throttleRequests) {
      return Promise.resolve({ done: () => {
      } });
    }
    if (this.requestMap.has(handle)) {
      return this.requestMap.get(handle);
    }
    const request = { handle, priority: 0, getPriority };
    const promise = new Promise((resolve2) => {
      request.resolve = resolve2;
      return request;
    });
    this.requestQueue.push(request);
    this.requestMap.set(handle, promise);
    this._issueNewRequests();
    return promise;
  }
  // PRIVATE
  _issueRequest(request) {
    const { handle, resolve: resolve2 } = request;
    let isDone10 = false;
    const done = () => {
      if (!isDone10) {
        isDone10 = true;
        this.requestMap.delete(handle);
        this.activeRequestCount--;
        this._issueNewRequests();
      }
    };
    this.activeRequestCount++;
    return resolve2 ? resolve2({ done }) : Promise.resolve({ done });
  }
  /** We check requests asynchronously, to prevent multiple updates */
  _issueNewRequests() {
    if (this.updateTimer !== null) {
      clearTimeout(this.updateTimer);
    }
    this.updateTimer = setTimeout(() => this._issueNewRequestsAsync(), this.props.debounceTime);
  }
  /** Refresh all requests  */
  _issueNewRequestsAsync() {
    if (this.updateTimer !== null) {
      clearTimeout(this.updateTimer);
    }
    this.updateTimer = null;
    const freeSlots = Math.max(this.props.maxRequests - this.activeRequestCount, 0);
    if (freeSlots === 0) {
      return;
    }
    this._updateAllRequests();
    for (let i2 = 0; i2 < freeSlots; ++i2) {
      const request = this.requestQueue.shift();
      if (request) {
        this._issueRequest(request);
      }
    }
  }
  /** Ensure all requests have updated priorities, and that no longer valid requests are cancelled */
  _updateAllRequests() {
    const requestQueue = this.requestQueue;
    for (let i2 = 0; i2 < requestQueue.length; ++i2) {
      const request = requestQueue[i2];
      if (!this._updateRequest(request)) {
        requestQueue.splice(i2, 1);
        this.requestMap.delete(request.handle);
        i2--;
      }
    }
    requestQueue.sort((a2, b2) => a2.priority - b2.priority);
  }
  /** Update a single request by calling the callback */
  _updateRequest(request) {
    request.priority = request.getPriority(request.handle);
    if (request.priority < 0) {
      request.resolve(null);
      return false;
    }
    return true;
  }
}
let pathPrefix$1 = "";
const fileAliases = {};
function resolvePath(filename2) {
  for (const alias in fileAliases) {
    if (filename2.startsWith(alias)) {
      const replacement = fileAliases[alias];
      filename2 = filename2.replace(alias, replacement);
    }
  }
  if (!filename2.startsWith("http://") && !filename2.startsWith("https://")) {
    filename2 = `${pathPrefix$1}${filename2}`;
  }
  return filename2;
}
function toArrayBuffer$1(buffer3) {
  return buffer3;
}
function isBuffer$1(value) {
  return value && typeof value === "object" && value.isBuffer;
}
function toArrayBuffer(data2) {
  if (isBuffer$1(data2)) {
    return toArrayBuffer$1(data2);
  }
  if (data2 instanceof ArrayBuffer) {
    return data2;
  }
  if (ArrayBuffer.isView(data2)) {
    if (data2.byteOffset === 0 && data2.byteLength === data2.buffer.byteLength) {
      return data2.buffer;
    }
    return data2.buffer.slice(data2.byteOffset, data2.byteOffset + data2.byteLength);
  }
  if (typeof data2 === "string") {
    const text = data2;
    const uint8Array = new TextEncoder().encode(text);
    return uint8Array.buffer;
  }
  if (data2 && typeof data2 === "object" && data2._toArrayBuffer) {
    return data2._toArrayBuffer();
  }
  throw new Error("toArrayBuffer");
}
function getCWD$1() {
  var _a3;
  if (typeof process !== "undefined" && typeof process.cwd !== "undefined") {
    return process.cwd();
  }
  const pathname = (_a3 = window.location) == null ? void 0 : _a3.pathname;
  return (pathname == null ? void 0 : pathname.slice(0, pathname.lastIndexOf("/") + 1)) || "";
}
function filename(url2) {
  const slashIndex = url2 ? url2.lastIndexOf("/") : -1;
  return slashIndex >= 0 ? url2.substr(slashIndex + 1) : "";
}
function dirname$1(url2) {
  const slashIndex = url2 ? url2.lastIndexOf("/") : -1;
  return slashIndex >= 0 ? url2.substr(0, slashIndex) : "";
}
function resolve$2(...components) {
  const paths = [];
  for (let _i = 0; _i < components.length; _i++) {
    paths[_i] = components[_i];
  }
  let resolvedPath2 = "";
  let resolvedAbsolute = false;
  let cwd;
  for (let i2 = paths.length - 1; i2 >= -1 && !resolvedAbsolute; i2--) {
    let path2;
    if (i2 >= 0) {
      path2 = paths[i2];
    } else {
      if (cwd === void 0) {
        cwd = getCWD$1();
      }
      path2 = cwd;
    }
    if (path2.length === 0) {
      continue;
    }
    resolvedPath2 = `${path2}/${resolvedPath2}`;
    resolvedAbsolute = path2.charCodeAt(0) === SLASH$1;
  }
  resolvedPath2 = normalizeStringPosix$1(resolvedPath2, !resolvedAbsolute);
  if (resolvedAbsolute) {
    return `/${resolvedPath2}`;
  } else if (resolvedPath2.length > 0) {
    return resolvedPath2;
  }
  return ".";
}
const SLASH$1 = 47;
const DOT$1 = 46;
function normalizeStringPosix$1(path2, allowAboveRoot) {
  let res = "";
  let lastSlash = -1;
  let dots = 0;
  let code;
  let isAboveRoot = false;
  for (let i2 = 0; i2 <= path2.length; ++i2) {
    if (i2 < path2.length) {
      code = path2.charCodeAt(i2);
    } else if (code === SLASH$1) {
      break;
    } else {
      code = SLASH$1;
    }
    if (code === SLASH$1) {
      if (lastSlash === i2 - 1 || dots === 1)
        ;
      else if (lastSlash !== i2 - 1 && dots === 2) {
        if (res.length < 2 || !isAboveRoot || res.charCodeAt(res.length - 1) !== DOT$1 || res.charCodeAt(res.length - 2) !== DOT$1) {
          if (res.length > 2) {
            const start2 = res.length - 1;
            let j2 = start2;
            for (; j2 >= 0; --j2) {
              if (res.charCodeAt(j2) === SLASH$1) {
                break;
              }
            }
            if (j2 !== start2) {
              res = j2 === -1 ? "" : res.slice(0, j2);
              lastSlash = i2;
              dots = 0;
              isAboveRoot = false;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = "";
            lastSlash = i2;
            dots = 0;
            isAboveRoot = false;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0) {
            res += "/..";
          } else {
            res = "..";
          }
          isAboveRoot = true;
        }
      } else {
        const slice2 = path2.slice(lastSlash + 1, i2);
        if (res.length > 0) {
          res += `/${slice2}`;
        } else {
          res = slice2;
        }
        isAboveRoot = false;
      }
      lastSlash = i2;
      dots = 0;
    } else if (code === DOT$1 && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}
const isBoolean$1 = (x2) => typeof x2 === "boolean";
const isFunction$1 = (x2) => typeof x2 === "function";
const isObject$b = (x2) => x2 !== null && typeof x2 === "object";
const isPureObject = (x2) => isObject$b(x2) && x2.constructor === {}.constructor;
const isIterable = (x2) => Boolean(x2) && typeof x2[Symbol.iterator] === "function";
const isAsyncIterable$1 = (x2) => x2 && typeof x2[Symbol.asyncIterator] === "function";
const isResponse = (x2) => typeof Response !== "undefined" && x2 instanceof Response || x2 && x2.arrayBuffer && x2.text && x2.json;
const isBlob = (x2) => typeof Blob !== "undefined" && x2 instanceof Blob;
const isBuffer = (x2) => x2 && typeof x2 === "object" && x2.isBuffer;
const isReadableDOMStream = (x2) => typeof ReadableStream !== "undefined" && x2 instanceof ReadableStream || isObject$b(x2) && isFunction$1(x2.tee) && isFunction$1(x2.cancel) && isFunction$1(x2.getReader);
const isReadableNodeStream = (x2) => isObject$b(x2) && isFunction$1(x2.read) && isFunction$1(x2.pipe) && isBoolean$1(x2.readable);
const isReadableStream = (x2) => isReadableDOMStream(x2) || isReadableNodeStream(x2);
class FetchError extends Error {
  constructor(message2, info) {
    super(message2);
    /** A best effort reason for why the fetch failed */
    __publicField2(this, "reason");
    /** The URL that failed to load. Empty string if not available. */
    __publicField2(this, "url");
    /** The Response object, if any. */
    __publicField2(this, "response");
    this.reason = info.reason;
    this.url = info.url;
    this.response = info.response;
  }
}
const DATA_URL_PATTERN = /^data:([-\w.]+\/[-\w.+]+)(;|,)/;
const MIME_TYPE_PATTERN = /^([-\w.]+\/[-\w.+]+)/;
function compareMIMETypes(mimeType1, mimeType2) {
  if (mimeType1.toLowerCase() === mimeType2.toLowerCase()) {
    return true;
  }
  return false;
}
function parseMIMEType(mimeString) {
  const matches2 = MIME_TYPE_PATTERN.exec(mimeString);
  if (matches2) {
    return matches2[1];
  }
  return mimeString;
}
function parseMIMETypeFromURL(url2) {
  const matches2 = DATA_URL_PATTERN.exec(url2);
  if (matches2) {
    return matches2[1];
  }
  return "";
}
const QUERY_STRING_PATTERN = /\?.*/;
function extractQueryString(url2) {
  const matches2 = url2.match(QUERY_STRING_PATTERN);
  return matches2 && matches2[0];
}
function stripQueryString(url2) {
  return url2.replace(QUERY_STRING_PATTERN, "");
}
function shortenUrlForDisplay(url2) {
  if (url2.length < 50) {
    return url2;
  }
  const urlEnd = url2.slice(url2.length - 15);
  const urlStart = url2.substr(0, 32);
  return `${urlStart}...${urlEnd}`;
}
function getResourceUrl(resource) {
  if (isResponse(resource)) {
    const response = resource;
    return response.url;
  }
  if (isBlob(resource)) {
    const blob = resource;
    return blob.name || "";
  }
  if (typeof resource === "string") {
    return resource;
  }
  return "";
}
function getResourceMIMEType(resource) {
  if (isResponse(resource)) {
    const response = resource;
    const contentTypeHeader = response.headers.get("content-type") || "";
    const noQueryUrl = stripQueryString(response.url);
    return parseMIMEType(contentTypeHeader) || parseMIMETypeFromURL(noQueryUrl);
  }
  if (isBlob(resource)) {
    const blob = resource;
    return blob.type || "";
  }
  if (typeof resource === "string") {
    return parseMIMETypeFromURL(resource);
  }
  return "";
}
function getResourceContentLength(resource) {
  if (isResponse(resource)) {
    const response = resource;
    return response.headers["content-length"] || -1;
  }
  if (isBlob(resource)) {
    const blob = resource;
    return blob.size;
  }
  if (typeof resource === "string") {
    return resource.length;
  }
  if (resource instanceof ArrayBuffer) {
    return resource.byteLength;
  }
  if (ArrayBuffer.isView(resource)) {
    return resource.byteLength;
  }
  return -1;
}
async function makeResponse(resource) {
  if (isResponse(resource)) {
    return resource;
  }
  const headers = {};
  const contentLength = getResourceContentLength(resource);
  if (contentLength >= 0) {
    headers["content-length"] = String(contentLength);
  }
  const url2 = getResourceUrl(resource);
  const type = getResourceMIMEType(resource);
  if (type) {
    headers["content-type"] = type;
  }
  const initialDataUrl = await getInitialDataUrl(resource);
  if (initialDataUrl) {
    headers["x-first-bytes"] = initialDataUrl;
  }
  if (typeof resource === "string") {
    resource = new TextEncoder().encode(resource);
  }
  const response = new Response(resource, { headers });
  Object.defineProperty(response, "url", { value: url2 });
  return response;
}
async function checkResponse(response) {
  if (!response.ok) {
    const error2 = await getResponseError(response);
    throw error2;
  }
}
async function getResponseError(response) {
  const shortUrl = shortenUrlForDisplay(response.url);
  let message2 = `Failed to fetch resource (${response.status}) ${response.statusText}: ${shortUrl}`;
  message2 = message2.length > 100 ? `${message2.slice(0, 100)}...` : message2;
  const info = {
    reason: response.statusText,
    url: response.url,
    response
  };
  try {
    const contentType = response.headers.get("Content-Type");
    info.reason = (contentType == null ? void 0 : contentType.includes("application/json")) ? await response.json() : response.text();
  } catch (error2) {
  }
  return new FetchError(message2, info);
}
async function getInitialDataUrl(resource) {
  const INITIAL_DATA_LENGTH = 5;
  if (typeof resource === "string") {
    return `data:,${resource.slice(0, INITIAL_DATA_LENGTH)}`;
  }
  if (resource instanceof Blob) {
    const blobSlice = resource.slice(0, 5);
    return await new Promise((resolve2) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        var _a3;
        return resolve2((_a3 = event == null ? void 0 : event.target) == null ? void 0 : _a3.result);
      };
      reader.readAsDataURL(blobSlice);
    });
  }
  if (resource instanceof ArrayBuffer) {
    const slice2 = resource.slice(0, INITIAL_DATA_LENGTH);
    const base642 = arrayBufferToBase64(slice2);
    return `data:base64,${base642}`;
  }
  return null;
}
function arrayBufferToBase64(buffer3) {
  let binary = "";
  const bytes = new Uint8Array(buffer3);
  for (let i2 = 0; i2 < bytes.byteLength; i2++) {
    binary += String.fromCharCode(bytes[i2]);
  }
  return btoa(binary);
}
function isNodePath(url2) {
  return !isRequestURL(url2) && !isDataURL(url2);
}
function isRequestURL(url2) {
  return url2.startsWith("http:") || url2.startsWith("https:");
}
function isDataURL(url2) {
  return url2.startsWith("data:");
}
async function fetchFile(urlOrData, fetchOptions) {
  var _a3, _b3;
  if (typeof urlOrData === "string") {
    const url2 = resolvePath(urlOrData);
    if (isNodePath(url2)) {
      if ((_a3 = globalThis.loaders) == null ? void 0 : _a3.fetchNode) {
        return (_b3 = globalThis.loaders) == null ? void 0 : _b3.fetchNode(url2, fetchOptions);
      }
    }
    return await fetch(url2, fetchOptions);
  }
  return await makeResponse(urlOrData);
}
const probeLog = new Log({ id: "loaders.gl" });
class NullLog {
  log() {
    return () => {
    };
  }
  info() {
    return () => {
    };
  }
  warn() {
    return () => {
    };
  }
  error() {
    return () => {
    };
  }
}
class ConsoleLog {
  constructor() {
    __publicField2(this, "console");
    this.console = console;
  }
  log(...args) {
    return this.console.log.bind(this.console, ...args);
  }
  info(...args) {
    return this.console.info.bind(this.console, ...args);
  }
  warn(...args) {
    return this.console.warn.bind(this.console, ...args);
  }
  error(...args) {
    return this.console.error.bind(this.console, ...args);
  }
}
const DEFAULT_LOADER_OPTIONS = {
  // baseUri
  fetch: null,
  mimeType: void 0,
  nothrow: false,
  log: new ConsoleLog(),
  // A probe.gl compatible (`log.log()()` syntax) that just logs to console
  useLocalLibraries: false,
  CDN: "https://unpkg.com/@loaders.gl",
  worker: true,
  // By default, use worker if provided by loader.
  maxConcurrency: 3,
  // How many worker instances should be created for each loader.
  maxMobileConcurrency: 1,
  // How many worker instances should be created for each loader on mobile devices.
  reuseWorkers: isBrowser$5,
  // By default reuse workers in browser (Node.js refuses to terminate if browsers are running)
  _nodeWorkers: false,
  // By default do not support node workers
  _workerType: "",
  // 'test' to use locally generated workers
  limit: 0,
  _limitMB: 0,
  batchSize: "auto",
  batchDebounceMs: 0,
  metadata: false,
  // TODO - currently only implemented for parseInBatches, adds initial metadata batch,
  transforms: []
};
const REMOVED_LOADER_OPTIONS = {
  throws: "nothrow",
  dataType: "(no longer used)",
  uri: "baseUri",
  // Warn if fetch options are used on top-level
  method: "fetch.method",
  headers: "fetch.headers",
  body: "fetch.body",
  mode: "fetch.mode",
  credentials: "fetch.credentials",
  cache: "fetch.cache",
  redirect: "fetch.redirect",
  referrer: "fetch.referrer",
  referrerPolicy: "fetch.referrerPolicy",
  integrity: "fetch.integrity",
  keepalive: "fetch.keepalive",
  signal: "fetch.signal"
};
function getGlobalLoaderState() {
  globalThis.loaders = globalThis.loaders || {};
  const { loaders } = globalThis;
  if (!loaders._state) {
    loaders._state = {};
  }
  return loaders._state;
}
function getGlobalLoaderOptions() {
  const state = getGlobalLoaderState();
  state.globalOptions = state.globalOptions || { ...DEFAULT_LOADER_OPTIONS };
  return state.globalOptions;
}
function normalizeOptions$1(options2, loader2, loaders, url2) {
  loaders = loaders || [];
  loaders = Array.isArray(loaders) ? loaders : [loaders];
  validateOptions(options2, loaders);
  return normalizeOptionsInternal(loader2, options2, url2);
}
function validateOptions(options2, loaders) {
  validateOptionsObject(options2, null, DEFAULT_LOADER_OPTIONS, REMOVED_LOADER_OPTIONS, loaders);
  for (const loader2 of loaders) {
    const idOptions = options2 && options2[loader2.id] || {};
    const loaderOptions = loader2.options && loader2.options[loader2.id] || {};
    const deprecatedOptions = loader2.deprecatedOptions && loader2.deprecatedOptions[loader2.id] || {};
    validateOptionsObject(idOptions, loader2.id, loaderOptions, deprecatedOptions, loaders);
  }
}
function validateOptionsObject(options2, id, defaultOptions2, deprecatedOptions, loaders) {
  const loaderName = id || "Top level";
  const prefix = id ? `${id}.` : "";
  for (const key in options2) {
    const isSubOptions = !id && isObject$b(options2[key]);
    const isBaseUriOption = key === "baseUri" && !id;
    const isWorkerUrlOption = key === "workerUrl" && id;
    if (!(key in defaultOptions2) && !isBaseUriOption && !isWorkerUrlOption) {
      if (key in deprecatedOptions) {
        probeLog.warn(`${loaderName} loader option '${prefix}${key}' no longer supported, use '${deprecatedOptions[key]}'`)();
      } else if (!isSubOptions) {
        const suggestion = findSimilarOption(key, loaders);
        probeLog.warn(`${loaderName} loader option '${prefix}${key}' not recognized. ${suggestion}`)();
      }
    }
  }
}
function findSimilarOption(optionKey, loaders) {
  const lowerCaseOptionKey = optionKey.toLowerCase();
  let bestSuggestion = "";
  for (const loader2 of loaders) {
    for (const key in loader2.options) {
      if (optionKey === key) {
        return `Did you mean '${loader2.id}.${key}'?`;
      }
      const lowerCaseKey = key.toLowerCase();
      const isPartialMatch = lowerCaseOptionKey.startsWith(lowerCaseKey) || lowerCaseKey.startsWith(lowerCaseOptionKey);
      if (isPartialMatch) {
        bestSuggestion = bestSuggestion || `Did you mean '${loader2.id}.${key}'?`;
      }
    }
  }
  return bestSuggestion;
}
function normalizeOptionsInternal(loader2, options2, url2) {
  const loaderDefaultOptions = loader2.options || {};
  const mergedOptions = { ...loaderDefaultOptions };
  addUrlOptions(mergedOptions, url2);
  if (mergedOptions.log === null) {
    mergedOptions.log = new NullLog();
  }
  mergeNestedFields(mergedOptions, getGlobalLoaderOptions());
  mergeNestedFields(mergedOptions, options2);
  return mergedOptions;
}
function mergeNestedFields(mergedOptions, options2) {
  for (const key in options2) {
    if (key in options2) {
      const value = options2[key];
      if (isPureObject(value) && isPureObject(mergedOptions[key])) {
        mergedOptions[key] = {
          ...mergedOptions[key],
          ...options2[key]
        };
      } else {
        mergedOptions[key] = options2[key];
      }
    }
  }
}
function addUrlOptions(options2, url2) {
  if (url2 && !("baseUri" in options2)) {
    options2.baseUri = url2;
  }
}
function isLoaderObject(loader2) {
  if (!loader2) {
    return false;
  }
  if (Array.isArray(loader2)) {
    loader2 = loader2[0];
  }
  const hasExtensions = Array.isArray(loader2 == null ? void 0 : loader2.extensions);
  return hasExtensions;
}
function normalizeLoader(loader2) {
  assert$e(loader2, "null loader");
  assert$e(isLoaderObject(loader2), "invalid loader");
  let options2;
  if (Array.isArray(loader2)) {
    options2 = loader2[1];
    loader2 = loader2[0];
    loader2 = {
      ...loader2,
      options: { ...loader2.options, ...options2 }
    };
  }
  if ((loader2 == null ? void 0 : loader2.parseTextSync) || (loader2 == null ? void 0 : loader2.parseText)) {
    loader2.text = true;
  }
  if (!loader2.text) {
    loader2.binary = true;
  }
  return loader2;
}
const getGlobalLoaderRegistry = () => {
  const state = getGlobalLoaderState();
  state.loaderRegistry = state.loaderRegistry || [];
  return state.loaderRegistry;
};
function registerLoaders(loaders) {
  const loaderRegistry = getGlobalLoaderRegistry();
  loaders = Array.isArray(loaders) ? loaders : [loaders];
  for (const loader2 of loaders) {
    const normalizedLoader = normalizeLoader(loader2);
    if (!loaderRegistry.find((registeredLoader) => normalizedLoader === registeredLoader)) {
      loaderRegistry.unshift(normalizedLoader);
    }
  }
}
function getRegisteredLoaders() {
  return getGlobalLoaderRegistry();
}
const log$2 = new Log({ id: "loaders.gl" });
const EXT_PATTERN = /\.([^.]+)$/;
async function selectLoader(data2, loaders = [], options2, context2) {
  if (!validHTTPResponse(data2)) {
    return null;
  }
  let loader2 = selectLoaderSync(data2, loaders, { ...options2, nothrow: true }, context2);
  if (loader2) {
    return loader2;
  }
  if (isBlob(data2)) {
    data2 = await data2.slice(0, 10).arrayBuffer();
    loader2 = selectLoaderSync(data2, loaders, options2, context2);
  }
  if (!loader2 && !(options2 == null ? void 0 : options2.nothrow)) {
    throw new Error(getNoValidLoaderMessage(data2));
  }
  return loader2;
}
function selectLoaderSync(data2, loaders = [], options2, context2) {
  if (!validHTTPResponse(data2)) {
    return null;
  }
  if (loaders && !Array.isArray(loaders)) {
    return normalizeLoader(loaders);
  }
  let candidateLoaders = [];
  if (loaders) {
    candidateLoaders = candidateLoaders.concat(loaders);
  }
  if (!(options2 == null ? void 0 : options2.ignoreRegisteredLoaders)) {
    candidateLoaders.push(...getRegisteredLoaders());
  }
  normalizeLoaders(candidateLoaders);
  const loader2 = selectLoaderInternal(data2, candidateLoaders, options2, context2);
  if (!loader2 && !(options2 == null ? void 0 : options2.nothrow)) {
    throw new Error(getNoValidLoaderMessage(data2));
  }
  return loader2;
}
function selectLoaderInternal(data2, loaders, options2, context2) {
  const url2 = getResourceUrl(data2);
  const type = getResourceMIMEType(data2);
  const testUrl = stripQueryString(url2) || (context2 == null ? void 0 : context2.url);
  let loader2 = null;
  let reason = "";
  if (options2 == null ? void 0 : options2.mimeType) {
    loader2 = findLoaderByMIMEType(loaders, options2 == null ? void 0 : options2.mimeType);
    reason = `match forced by supplied MIME type ${options2 == null ? void 0 : options2.mimeType}`;
  }
  loader2 = loader2 || findLoaderByUrl(loaders, testUrl);
  reason = reason || (loader2 ? `matched url ${testUrl}` : "");
  loader2 = loader2 || findLoaderByMIMEType(loaders, type);
  reason = reason || (loader2 ? `matched MIME type ${type}` : "");
  loader2 = loader2 || findLoaderByInitialBytes(loaders, data2);
  reason = reason || (loader2 ? `matched initial data ${getFirstCharacters$1(data2)}` : "");
  if (options2 == null ? void 0 : options2.fallbackMimeType) {
    loader2 = loader2 || findLoaderByMIMEType(loaders, options2 == null ? void 0 : options2.fallbackMimeType);
    reason = reason || (loader2 ? `matched fallback MIME type ${type}` : "");
  }
  if (reason) {
    log$2.log(1, `selectLoader selected ${loader2 == null ? void 0 : loader2.name}: ${reason}.`);
  }
  return loader2;
}
function validHTTPResponse(data2) {
  if (data2 instanceof Response) {
    if (data2.status === 204) {
      return false;
    }
  }
  return true;
}
function getNoValidLoaderMessage(data2) {
  const url2 = getResourceUrl(data2);
  const type = getResourceMIMEType(data2);
  let message2 = "No valid loader found (";
  message2 += url2 ? `${filename(url2)}, ` : "no url provided, ";
  message2 += `MIME type: ${type ? `"${type}"` : "not provided"}, `;
  const firstCharacters = data2 ? getFirstCharacters$1(data2) : "";
  message2 += firstCharacters ? ` first bytes: "${firstCharacters}"` : "first bytes: not available";
  message2 += ")";
  return message2;
}
function normalizeLoaders(loaders) {
  for (const loader2 of loaders) {
    normalizeLoader(loader2);
  }
}
function findLoaderByUrl(loaders, url2) {
  const match2 = url2 && EXT_PATTERN.exec(url2);
  const extension = match2 && match2[1];
  return extension ? findLoaderByExtension(loaders, extension) : null;
}
function findLoaderByExtension(loaders, extension) {
  extension = extension.toLowerCase();
  for (const loader2 of loaders) {
    for (const loaderExtension of loader2.extensions) {
      if (loaderExtension.toLowerCase() === extension) {
        return loader2;
      }
    }
  }
  return null;
}
function findLoaderByMIMEType(loaders, mimeType) {
  var _a3;
  for (const loader2 of loaders) {
    if ((_a3 = loader2.mimeTypes) == null ? void 0 : _a3.some((mimeType1) => compareMIMETypes(mimeType, mimeType1))) {
      return loader2;
    }
    if (compareMIMETypes(mimeType, `application/x.${loader2.id}`)) {
      return loader2;
    }
  }
  return null;
}
function findLoaderByInitialBytes(loaders, data2) {
  if (!data2) {
    return null;
  }
  for (const loader2 of loaders) {
    if (typeof data2 === "string") {
      if (testDataAgainstText(data2, loader2)) {
        return loader2;
      }
    } else if (ArrayBuffer.isView(data2)) {
      if (testDataAgainstBinary(data2.buffer, data2.byteOffset, loader2)) {
        return loader2;
      }
    } else if (data2 instanceof ArrayBuffer) {
      const byteOffset = 0;
      if (testDataAgainstBinary(data2, byteOffset, loader2)) {
        return loader2;
      }
    }
  }
  return null;
}
function testDataAgainstText(data2, loader2) {
  if (loader2.testText) {
    return loader2.testText(data2);
  }
  const tests = Array.isArray(loader2.tests) ? loader2.tests : [loader2.tests];
  return tests.some((test) => data2.startsWith(test));
}
function testDataAgainstBinary(data2, byteOffset, loader2) {
  const tests = Array.isArray(loader2.tests) ? loader2.tests : [loader2.tests];
  return tests.some((test) => testBinary(data2, byteOffset, loader2, test));
}
function testBinary(data2, byteOffset, loader2, test) {
  if (test instanceof ArrayBuffer) {
    return compareArrayBuffers(test, data2, test.byteLength);
  }
  switch (typeof test) {
    case "function":
      return test(data2);
    case "string":
      const magic = getMagicString$5(data2, byteOffset, test.length);
      return test === magic;
    default:
      return false;
  }
}
function getFirstCharacters$1(data2, length2 = 5) {
  if (typeof data2 === "string") {
    return data2.slice(0, length2);
  } else if (ArrayBuffer.isView(data2)) {
    return getMagicString$5(data2.buffer, data2.byteOffset, length2);
  } else if (data2 instanceof ArrayBuffer) {
    const byteOffset = 0;
    return getMagicString$5(data2, byteOffset, length2);
  }
  return "";
}
function getMagicString$5(arrayBuffer2, byteOffset, length2) {
  if (arrayBuffer2.byteLength < byteOffset + length2) {
    return "";
  }
  const dataView = new DataView(arrayBuffer2);
  let magic = "";
  for (let i2 = 0; i2 < length2; i2++) {
    magic += String.fromCharCode(dataView.getUint8(byteOffset + i2));
  }
  return magic;
}
const DEFAULT_CHUNK_SIZE$2 = 256 * 1024;
function* makeStringIterator(string3, options2) {
  const chunkSize = (options2 == null ? void 0 : options2.chunkSize) || DEFAULT_CHUNK_SIZE$2;
  let offset = 0;
  const textEncoder = new TextEncoder();
  while (offset < string3.length) {
    const chunkLength = Math.min(string3.length - offset, chunkSize);
    const chunk = string3.slice(offset, offset + chunkLength);
    offset += chunkLength;
    yield textEncoder.encode(chunk);
  }
}
const DEFAULT_CHUNK_SIZE$1 = 256 * 1024;
function* makeArrayBufferIterator(arrayBuffer2, options2 = {}) {
  const { chunkSize = DEFAULT_CHUNK_SIZE$1 } = options2;
  let byteOffset = 0;
  while (byteOffset < arrayBuffer2.byteLength) {
    const chunkByteLength = Math.min(arrayBuffer2.byteLength - byteOffset, chunkSize);
    const chunk = new ArrayBuffer(chunkByteLength);
    const sourceArray = new Uint8Array(arrayBuffer2, byteOffset, chunkByteLength);
    const chunkArray = new Uint8Array(chunk);
    chunkArray.set(sourceArray);
    byteOffset += chunkByteLength;
    yield chunk;
  }
}
const DEFAULT_CHUNK_SIZE = 1024 * 1024;
async function* makeBlobIterator(blob, options2) {
  const chunkSize = (options2 == null ? void 0 : options2.chunkSize) || DEFAULT_CHUNK_SIZE;
  let offset = 0;
  while (offset < blob.size) {
    const end = offset + chunkSize;
    const chunk = await blob.slice(offset, end).arrayBuffer();
    offset = end;
    yield chunk;
  }
}
function makeStreamIterator(stream2, options2) {
  return isBrowser$5 ? makeBrowserStreamIterator(stream2, options2) : makeNodeStreamIterator(stream2);
}
async function* makeBrowserStreamIterator(stream2, options2) {
  const reader = stream2.getReader();
  let nextBatchPromise;
  try {
    while (true) {
      const currentBatchPromise = nextBatchPromise || reader.read();
      if (options2 == null ? void 0 : options2._streamReadAhead) {
        nextBatchPromise = reader.read();
      }
      const { done, value } = await currentBatchPromise;
      if (done) {
        return;
      }
      yield toArrayBuffer(value);
    }
  } catch (error2) {
    reader.releaseLock();
  }
}
async function* makeNodeStreamIterator(stream2, options2) {
  for await (const chunk of stream2) {
    yield toArrayBuffer(chunk);
  }
}
function makeIterator(data2, options2) {
  if (typeof data2 === "string") {
    return makeStringIterator(data2, options2);
  }
  if (data2 instanceof ArrayBuffer) {
    return makeArrayBufferIterator(data2, options2);
  }
  if (isBlob(data2)) {
    return makeBlobIterator(data2, options2);
  }
  if (isReadableStream(data2)) {
    return makeStreamIterator(data2, options2);
  }
  if (isResponse(data2)) {
    const response = data2;
    return makeStreamIterator(response.body, options2);
  }
  throw new Error("makeIterator");
}
const ERR_DATA = "Cannot convert supplied data type";
function getArrayBufferOrStringFromDataSync(data2, loader2, options2) {
  if (loader2.text && typeof data2 === "string") {
    return data2;
  }
  if (isBuffer(data2)) {
    data2 = data2.buffer;
  }
  if (data2 instanceof ArrayBuffer) {
    const arrayBuffer2 = data2;
    if (loader2.text && !loader2.binary) {
      const textDecoder = new TextDecoder("utf8");
      return textDecoder.decode(arrayBuffer2);
    }
    return arrayBuffer2;
  }
  if (ArrayBuffer.isView(data2)) {
    if (loader2.text && !loader2.binary) {
      const textDecoder = new TextDecoder("utf8");
      return textDecoder.decode(data2);
    }
    let arrayBuffer2 = data2.buffer;
    const byteLength = data2.byteLength || data2.length;
    if (data2.byteOffset !== 0 || byteLength !== arrayBuffer2.byteLength) {
      arrayBuffer2 = arrayBuffer2.slice(data2.byteOffset, data2.byteOffset + byteLength);
    }
    return arrayBuffer2;
  }
  throw new Error(ERR_DATA);
}
async function getArrayBufferOrStringFromData(data2, loader2, options2) {
  const isArrayBuffer2 = data2 instanceof ArrayBuffer || ArrayBuffer.isView(data2);
  if (typeof data2 === "string" || isArrayBuffer2) {
    return getArrayBufferOrStringFromDataSync(data2, loader2);
  }
  if (isBlob(data2)) {
    data2 = await makeResponse(data2);
  }
  if (isResponse(data2)) {
    const response = data2;
    await checkResponse(response);
    return loader2.binary ? await response.arrayBuffer() : await response.text();
  }
  if (isReadableStream(data2)) {
    data2 = makeIterator(data2, options2);
  }
  if (isIterable(data2) || isAsyncIterable$1(data2)) {
    return concatenateArrayBuffersAsync(data2);
  }
  throw new Error(ERR_DATA);
}
function getFetchFunction(options2, context2) {
  const globalOptions = getGlobalLoaderOptions();
  const loaderOptions = options2 || globalOptions;
  if (typeof loaderOptions.fetch === "function") {
    return loaderOptions.fetch;
  }
  if (isObject$b(loaderOptions.fetch)) {
    return (url2) => fetchFile(url2, loaderOptions.fetch);
  }
  if (context2 == null ? void 0 : context2.fetch) {
    return context2 == null ? void 0 : context2.fetch;
  }
  return fetchFile;
}
function getLoaderContext(context2, options2, parentContext) {
  if (parentContext) {
    return parentContext;
  }
  const newContext = {
    fetch: getFetchFunction(options2, context2),
    ...context2
  };
  if (newContext.url) {
    const baseUrl = stripQueryString(newContext.url);
    newContext.baseUrl = baseUrl;
    newContext.queryString = extractQueryString(newContext.url);
    newContext.filename = filename(baseUrl);
    newContext.baseUrl = dirname$1(baseUrl);
  }
  if (!Array.isArray(newContext.loaders)) {
    newContext.loaders = null;
  }
  return newContext;
}
function getLoadersFromContext(loaders, context2) {
  if (loaders && !Array.isArray(loaders)) {
    return loaders;
  }
  let candidateLoaders;
  if (loaders) {
    candidateLoaders = Array.isArray(loaders) ? loaders : [loaders];
  }
  if (context2 && context2.loaders) {
    const contextLoaders = Array.isArray(context2.loaders) ? context2.loaders : [context2.loaders];
    candidateLoaders = candidateLoaders ? [...candidateLoaders, ...contextLoaders] : contextLoaders;
  }
  return candidateLoaders && candidateLoaders.length ? candidateLoaders : void 0;
}
async function parse$7(data2, loaders, options2, context2) {
  if (loaders && !Array.isArray(loaders) && !isLoaderObject(loaders)) {
    context2 = void 0;
    options2 = loaders;
    loaders = void 0;
  }
  data2 = await data2;
  options2 = options2 || {};
  const url2 = getResourceUrl(data2);
  const typedLoaders = loaders;
  const candidateLoaders = getLoadersFromContext(typedLoaders, context2);
  const loader2 = await selectLoader(data2, candidateLoaders, options2);
  if (!loader2) {
    return null;
  }
  options2 = normalizeOptions$1(options2, loader2, candidateLoaders, url2);
  context2 = getLoaderContext(
    // @ts-expect-error
    { url: url2, _parse: parse$7, loaders: candidateLoaders },
    options2,
    context2 || null
  );
  return await parseWithLoader(loader2, data2, options2, context2);
}
async function parseWithLoader(loader2, data2, options2, context2) {
  validateWorkerVersion(loader2);
  options2 = mergeLoaderOptions(loader2.options, options2);
  if (isResponse(data2)) {
    const response = data2;
    const { ok, redirected, status, statusText, type, url: url2 } = response;
    const headers = Object.fromEntries(response.headers.entries());
    context2.response = { headers, ok, redirected, status, statusText, type, url: url2 };
  }
  data2 = await getArrayBufferOrStringFromData(data2, loader2, options2);
  const loaderWithParser = loader2;
  if (loaderWithParser.parseTextSync && typeof data2 === "string") {
    return loaderWithParser.parseTextSync(data2, options2, context2);
  }
  if (canParseWithWorker(loader2, options2)) {
    return await parseWithWorker(loader2, data2, options2, context2, parse$7);
  }
  if (loaderWithParser.parseText && typeof data2 === "string") {
    return await loaderWithParser.parseText(data2, options2, context2);
  }
  if (loaderWithParser.parse) {
    return await loaderWithParser.parse(data2, options2, context2);
  }
  assert$c(!loaderWithParser.parseSync);
  throw new Error(`${loader2.id} loader - no parser found and worker is disabled`);
}
function getDataTypeFromTypedArray$2(array2) {
  switch (array2.constructor) {
    case Int8Array:
      return "int8";
    case Uint8Array:
    case Uint8ClampedArray:
      return "uint8";
    case Int16Array:
      return "int16";
    case Uint16Array:
      return "uint16";
    case Int32Array:
      return "int32";
    case Uint32Array:
      return "uint32";
    case Float32Array:
      return "float32";
    case Float64Array:
      return "float64";
    default:
      return "null";
  }
}
function getMeshBoundingBox$1(attributes) {
  let minX2 = Infinity;
  let minY2 = Infinity;
  let minZ = Infinity;
  let maxX2 = -Infinity;
  let maxY2 = -Infinity;
  let maxZ = -Infinity;
  const positions = attributes.POSITION ? attributes.POSITION.value : [];
  const len2 = positions && positions.length;
  for (let i2 = 0; i2 < len2; i2 += 3) {
    const x2 = positions[i2];
    const y2 = positions[i2 + 1];
    const z2 = positions[i2 + 2];
    minX2 = x2 < minX2 ? x2 : minX2;
    minY2 = y2 < minY2 ? y2 : minY2;
    minZ = z2 < minZ ? z2 : minZ;
    maxX2 = x2 > maxX2 ? x2 : maxX2;
    maxY2 = y2 > maxY2 ? y2 : maxY2;
    maxZ = z2 > maxZ ? z2 : maxZ;
  }
  return [
    [minX2, minY2, minZ],
    [maxX2, maxY2, maxZ]
  ];
}
function deduceMeshField$1(name2, attribute, optionalMetadata) {
  const type = getDataTypeFromTypedArray$2(attribute.value);
  const metadata = optionalMetadata ? optionalMetadata : makeMeshAttributeMetadata$1(attribute);
  return {
    name: name2,
    type: { type: "fixed-size-list", listSize: attribute.size, children: [{ name: "value", type }] },
    nullable: false,
    metadata
  };
}
function makeMeshAttributeMetadata$1(attribute) {
  const result = {};
  if ("byteOffset" in attribute) {
    result.byteOffset = attribute.byteOffset.toString(10);
  }
  if ("byteStride" in attribute) {
    result.byteStride = attribute.byteStride.toString(10);
  }
  if ("normalized" in attribute) {
    result.normalized = attribute.normalized.toString();
  }
  return result;
}
async function load(url2, loaders, options2, context2) {
  let resolvedLoaders;
  let resolvedOptions;
  if (!Array.isArray(loaders) && !isLoaderObject(loaders)) {
    resolvedLoaders = [];
    resolvedOptions = loaders;
  } else {
    resolvedLoaders = loaders;
    resolvedOptions = options2;
  }
  const fetch2 = getFetchFunction(resolvedOptions);
  let data2 = url2;
  if (typeof url2 === "string") {
    data2 = await fetch2(url2);
  }
  if (isBlob(url2)) {
    data2 = await fetch2(url2);
  }
  return Array.isArray(resolvedLoaders) ? await parse$7(data2, resolvedLoaders, resolvedOptions) : await parse$7(data2, resolvedLoaders, resolvedOptions);
}
const VERSION$d = "4.2.0";
const parseImageNode$1 = (_a2 = globalThis.loaders) == null ? void 0 : _a2.parseImageNode;
const IMAGE_SUPPORTED$1 = typeof Image !== "undefined";
const IMAGE_BITMAP_SUPPORTED$1 = typeof ImageBitmap !== "undefined";
const NODE_IMAGE_SUPPORTED$1 = Boolean(parseImageNode$1);
const DATA_SUPPORTED$1 = isBrowser$5 ? true : NODE_IMAGE_SUPPORTED$1;
function isImageTypeSupported$1(type) {
  switch (type) {
    case "auto":
      return IMAGE_BITMAP_SUPPORTED$1 || IMAGE_SUPPORTED$1 || DATA_SUPPORTED$1;
    case "imagebitmap":
      return IMAGE_BITMAP_SUPPORTED$1;
    case "image":
      return IMAGE_SUPPORTED$1;
    case "data":
      return DATA_SUPPORTED$1;
    default:
      throw new Error(`@loaders.gl/images: image ${type} not supported in this environment`);
  }
}
function getDefaultImageType$1() {
  if (IMAGE_BITMAP_SUPPORTED$1) {
    return "imagebitmap";
  }
  if (IMAGE_SUPPORTED$1) {
    return "image";
  }
  if (DATA_SUPPORTED$1) {
    return "data";
  }
  throw new Error("Install '@loaders.gl/polyfills' to parse images under Node.js");
}
function getImageType$1(image) {
  const format = getImageTypeOrNull$1(image);
  if (!format) {
    throw new Error("Not an image");
  }
  return format;
}
function getImageData$1(image) {
  switch (getImageType$1(image)) {
    case "data":
      return image;
    case "image":
    case "imagebitmap":
      const canvas2 = document.createElement("canvas");
      const context2 = canvas2.getContext("2d");
      if (!context2) {
        throw new Error("getImageData");
      }
      canvas2.width = image.width;
      canvas2.height = image.height;
      context2.drawImage(image, 0, 0);
      return context2.getImageData(0, 0, image.width, image.height);
    default:
      throw new Error("getImageData");
  }
}
function getImageTypeOrNull$1(image) {
  if (typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return "imagebitmap";
  }
  if (typeof Image !== "undefined" && image instanceof Image) {
    return "image";
  }
  if (image && typeof image === "object" && image.data && image.width && image.height) {
    return "data";
  }
  return null;
}
const SVG_DATA_URL_PATTERN$1 = /^data:image\/svg\+xml/;
const SVG_URL_PATTERN$1 = /\.svg((\?|#).*)?$/;
function isSVG$1(url2) {
  return url2 && (SVG_DATA_URL_PATTERN$1.test(url2) || SVG_URL_PATTERN$1.test(url2));
}
function getBlobOrSVGDataUrl$1(arrayBuffer2, url2) {
  if (isSVG$1(url2)) {
    const textDecoder = new TextDecoder();
    let xmlText = textDecoder.decode(arrayBuffer2);
    try {
      if (typeof unescape === "function" && typeof encodeURIComponent === "function") {
        xmlText = unescape(encodeURIComponent(xmlText));
      }
    } catch (error2) {
      throw new Error(error2.message);
    }
    const src2 = `data:image/svg+xml;base64,${btoa(xmlText)}`;
    return src2;
  }
  return getBlob$1(arrayBuffer2, url2);
}
function getBlob$1(arrayBuffer2, url2) {
  if (isSVG$1(url2)) {
    throw new Error("SVG cannot be parsed directly to imagebitmap");
  }
  return new Blob([new Uint8Array(arrayBuffer2)]);
}
async function parseToImage$1(arrayBuffer2, options2, url2) {
  const blobOrDataUrl = getBlobOrSVGDataUrl$1(arrayBuffer2, url2);
  const URL2 = self.URL || self.webkitURL;
  const objectUrl = typeof blobOrDataUrl !== "string" && URL2.createObjectURL(blobOrDataUrl);
  try {
    return await loadToImage$1(objectUrl || blobOrDataUrl, options2);
  } finally {
    if (objectUrl) {
      URL2.revokeObjectURL(objectUrl);
    }
  }
}
async function loadToImage$1(url2, options2) {
  const image = new Image();
  image.src = url2;
  if (options2.image && options2.image.decode && image.decode) {
    await image.decode();
    return image;
  }
  return await new Promise((resolve2, reject) => {
    try {
      image.onload = () => resolve2(image);
      image.onerror = (error2) => {
        const message2 = error2 instanceof Error ? error2.message : "error";
        reject(new Error(message2));
      };
    } catch (error2) {
      reject(error2);
    }
  });
}
const EMPTY_OBJECT$1 = {};
let imagebitmapOptionsSupported$1 = true;
async function parseToImageBitmap$1(arrayBuffer2, options2, url2) {
  let blob;
  if (isSVG$1(url2)) {
    const image = await parseToImage$1(arrayBuffer2, options2, url2);
    blob = image;
  } else {
    blob = getBlob$1(arrayBuffer2, url2);
  }
  const imagebitmapOptions = options2 && options2.imagebitmap;
  return await safeCreateImageBitmap$1(blob, imagebitmapOptions);
}
async function safeCreateImageBitmap$1(blob, imagebitmapOptions = null) {
  if (isEmptyObject$1(imagebitmapOptions) || !imagebitmapOptionsSupported$1) {
    imagebitmapOptions = null;
  }
  if (imagebitmapOptions) {
    try {
      return await createImageBitmap(blob, imagebitmapOptions);
    } catch (error2) {
      console.warn(error2);
      imagebitmapOptionsSupported$1 = false;
    }
  }
  return await createImageBitmap(blob);
}
function isEmptyObject$1(object2) {
  for (const key in object2 || EMPTY_OBJECT$1) {
    return false;
  }
  return true;
}
function getISOBMFFMediaType$1(buffer3) {
  if (!checkString$1(buffer3, "ftyp", 4)) {
    return null;
  }
  if ((buffer3[8] & 96) === 0) {
    return null;
  }
  return decodeMajorBrand$1(buffer3);
}
function decodeMajorBrand$1(buffer3) {
  const brandMajor = getUTF8String$1(buffer3, 8, 12).replace("\0", " ").trim();
  switch (brandMajor) {
    case "avif":
    case "avis":
      return { extension: "avif", mimeType: "image/avif" };
    default:
      return null;
  }
}
function getUTF8String$1(array2, start2, end) {
  return String.fromCharCode(...array2.slice(start2, end));
}
function stringToBytes$1(string3) {
  return [...string3].map((character) => character.charCodeAt(0));
}
function checkString$1(buffer3, header, offset = 0) {
  const headerBytes = stringToBytes$1(header);
  for (let i2 = 0; i2 < headerBytes.length; ++i2) {
    if (headerBytes[i2] !== buffer3[i2 + offset]) {
      return false;
    }
  }
  return true;
}
const BIG_ENDIAN$1 = false;
const LITTLE_ENDIAN$3 = true;
function getBinaryImageMetadata$1(binaryData) {
  const dataView = toDataView$1(binaryData);
  return getPngMetadata$1(dataView) || getJpegMetadata$1(dataView) || getGifMetadata$1(dataView) || getBmpMetadata$1(dataView) || getISOBMFFMetadata$1(dataView);
}
function getISOBMFFMetadata$1(binaryData) {
  const buffer3 = new Uint8Array(binaryData instanceof DataView ? binaryData.buffer : binaryData);
  const mediaType = getISOBMFFMediaType$1(buffer3);
  if (!mediaType) {
    return null;
  }
  return {
    mimeType: mediaType.mimeType,
    // TODO - decode width and height
    width: 0,
    height: 0
  };
}
function getPngMetadata$1(binaryData) {
  const dataView = toDataView$1(binaryData);
  const isPng = dataView.byteLength >= 24 && dataView.getUint32(0, BIG_ENDIAN$1) === 2303741511;
  if (!isPng) {
    return null;
  }
  return {
    mimeType: "image/png",
    width: dataView.getUint32(16, BIG_ENDIAN$1),
    height: dataView.getUint32(20, BIG_ENDIAN$1)
  };
}
function getGifMetadata$1(binaryData) {
  const dataView = toDataView$1(binaryData);
  const isGif = dataView.byteLength >= 10 && dataView.getUint32(0, BIG_ENDIAN$1) === 1195984440;
  if (!isGif) {
    return null;
  }
  return {
    mimeType: "image/gif",
    width: dataView.getUint16(6, LITTLE_ENDIAN$3),
    height: dataView.getUint16(8, LITTLE_ENDIAN$3)
  };
}
function getBmpMetadata$1(binaryData) {
  const dataView = toDataView$1(binaryData);
  const isBmp = dataView.byteLength >= 14 && dataView.getUint16(0, BIG_ENDIAN$1) === 16973 && dataView.getUint32(2, LITTLE_ENDIAN$3) === dataView.byteLength;
  if (!isBmp) {
    return null;
  }
  return {
    mimeType: "image/bmp",
    width: dataView.getUint32(18, LITTLE_ENDIAN$3),
    height: dataView.getUint32(22, LITTLE_ENDIAN$3)
  };
}
function getJpegMetadata$1(binaryData) {
  const dataView = toDataView$1(binaryData);
  const isJpeg = dataView.byteLength >= 3 && dataView.getUint16(0, BIG_ENDIAN$1) === 65496 && dataView.getUint8(2) === 255;
  if (!isJpeg) {
    return null;
  }
  const { tableMarkers, sofMarkers } = getJpegMarkers$1();
  let i2 = 2;
  while (i2 + 9 < dataView.byteLength) {
    const marker2 = dataView.getUint16(i2, BIG_ENDIAN$1);
    if (sofMarkers.has(marker2)) {
      return {
        mimeType: "image/jpeg",
        height: dataView.getUint16(i2 + 5, BIG_ENDIAN$1),
        // Number of lines
        width: dataView.getUint16(i2 + 7, BIG_ENDIAN$1)
        // Number of pixels per line
      };
    }
    if (!tableMarkers.has(marker2)) {
      return null;
    }
    i2 += 2;
    i2 += dataView.getUint16(i2, BIG_ENDIAN$1);
  }
  return null;
}
function getJpegMarkers$1() {
  const tableMarkers = /* @__PURE__ */ new Set([65499, 65476, 65484, 65501, 65534]);
  for (let i2 = 65504; i2 < 65520; ++i2) {
    tableMarkers.add(i2);
  }
  const sofMarkers = /* @__PURE__ */ new Set([
    65472,
    65473,
    65474,
    65475,
    65477,
    65478,
    65479,
    65481,
    65482,
    65483,
    65485,
    65486,
    65487,
    65502
  ]);
  return { tableMarkers, sofMarkers };
}
function toDataView$1(data2) {
  if (data2 instanceof DataView) {
    return data2;
  }
  if (ArrayBuffer.isView(data2)) {
    return new DataView(data2.buffer);
  }
  if (data2 instanceof ArrayBuffer) {
    return new DataView(data2);
  }
  throw new Error("toDataView");
}
async function parseToNodeImage$1(arrayBuffer2, options2) {
  var _a3;
  const { mimeType } = getBinaryImageMetadata$1(arrayBuffer2) || {};
  const parseImageNode2 = (_a3 = globalThis.loaders) == null ? void 0 : _a3.parseImageNode;
  assert$e(parseImageNode2);
  return await parseImageNode2(arrayBuffer2, mimeType);
}
async function parseImage$1(arrayBuffer2, options2, context2) {
  options2 = options2 || {};
  const imageOptions = options2.image || {};
  const imageType = imageOptions.type || "auto";
  const { url: url2 } = context2 || {};
  const loadType = getLoadableImageType$1(imageType);
  let image;
  switch (loadType) {
    case "imagebitmap":
      image = await parseToImageBitmap$1(arrayBuffer2, options2, url2);
      break;
    case "image":
      image = await parseToImage$1(arrayBuffer2, options2, url2);
      break;
    case "data":
      image = await parseToNodeImage$1(arrayBuffer2);
      break;
    default:
      assert$e(false);
  }
  if (imageType === "data") {
    image = getImageData$1(image);
  }
  return image;
}
function getLoadableImageType$1(type) {
  switch (type) {
    case "auto":
    case "data":
      return getDefaultImageType$1();
    default:
      isImageTypeSupported$1(type);
      return type;
  }
}
const EXTENSIONS$9 = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "ico", "svg", "avif"];
const MIME_TYPES$1 = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/avif",
  "image/bmp",
  "image/vnd.microsoft.icon",
  "image/svg+xml"
];
const DEFAULT_IMAGE_LOADER_OPTIONS$1 = {
  image: {
    type: "auto",
    decode: true
    // if format is HTML
  }
  // imagebitmap: {} - passes (platform dependent) parameters to ImageBitmap constructor
};
const ImageLoader$1 = {
  dataType: null,
  batchType: null,
  id: "image",
  module: "images",
  name: "Images",
  version: VERSION$d,
  mimeTypes: MIME_TYPES$1,
  extensions: EXTENSIONS$9,
  parse: parseImage$1,
  // TODO: byteOffset, byteLength;
  tests: [(arrayBuffer2) => Boolean(getBinaryImageMetadata$1(new DataView(arrayBuffer2)))],
  options: DEFAULT_IMAGE_LOADER_OPTIONS$1
};
const mimeTypeSupportedSync$1 = {};
function isImageFormatSupported$1(mimeType) {
  if (mimeTypeSupportedSync$1[mimeType] === void 0) {
    const supported = isBrowser$5 ? checkBrowserImageFormatSupport$1(mimeType) : checkNodeImageFormatSupport$1(mimeType);
    mimeTypeSupportedSync$1[mimeType] = supported;
  }
  return mimeTypeSupportedSync$1[mimeType];
}
function checkNodeImageFormatSupport$1(mimeType) {
  var _a3, _b3;
  const NODE_FORMAT_SUPPORT = ["image/png", "image/jpeg", "image/gif"];
  const imageFormatsNode = ((_a3 = globalThis.loaders) == null ? void 0 : _a3.imageFormatsNode) || NODE_FORMAT_SUPPORT;
  const parseImageNode2 = (_b3 = globalThis.loaders) == null ? void 0 : _b3.parseImageNode;
  return Boolean(parseImageNode2) && imageFormatsNode.includes(mimeType);
}
function checkBrowserImageFormatSupport$1(mimeType) {
  switch (mimeType) {
    case "image/avif":
    case "image/webp":
      return testBrowserImageFormatSupport$1(mimeType);
    default:
      return true;
  }
}
function testBrowserImageFormatSupport$1(mimeType) {
  try {
    const element = document.createElement("canvas");
    const dataURL = element.toDataURL(mimeType);
    return dataURL.indexOf(`data:${mimeType}`) === 0;
  } catch {
    return false;
  }
}
const defaultLogger = new Log({ id: "deck" });
const log$1 = defaultLogger;
const logState = {
  attributeUpdateStart: -1,
  attributeManagerUpdateStart: -1,
  attributeUpdateMessages: []
};
const LOG_LEVEL_MAJOR_UPDATE = 1;
const LOG_LEVEL_MINOR_UPDATE = 2;
const LOG_LEVEL_UPDATE_DETAIL = 3;
const LOG_LEVEL_INFO = 4;
const LOG_LEVEL_DRAW = 2;
const getLoggers = (log3) => ({
  /* Layer events */
  "layer.changeFlag": (layer, key, flags2) => {
    log3.log(LOG_LEVEL_UPDATE_DETAIL, `${layer.id} ${key}: `, flags2[key])();
  },
  "layer.initialize": (layer) => {
    log3.log(LOG_LEVEL_MAJOR_UPDATE, `Initializing ${layer}`)();
  },
  "layer.update": (layer, needsUpdate) => {
    if (needsUpdate) {
      const flags2 = layer.getChangeFlags();
      log3.log(LOG_LEVEL_MINOR_UPDATE, `Updating ${layer} because: ${Object.keys(flags2).filter((key) => flags2[key]).join(", ")}`)();
    } else {
      log3.log(LOG_LEVEL_INFO, `${layer} does not need update`)();
    }
  },
  "layer.matched": (layer, changed) => {
    if (changed) {
      log3.log(LOG_LEVEL_INFO, `Matched ${layer}, state transfered`)();
    }
  },
  "layer.finalize": (layer) => {
    log3.log(LOG_LEVEL_MAJOR_UPDATE, `Finalizing ${layer}`)();
  },
  /* CompositeLayer events */
  "compositeLayer.renderLayers": (layer, updated, subLayers) => {
    if (updated) {
      log3.log(LOG_LEVEL_MINOR_UPDATE, `Composite layer rendered new subLayers ${layer}`, subLayers)();
    } else {
      log3.log(LOG_LEVEL_INFO, `Composite layer reused subLayers ${layer}`, subLayers)();
    }
  },
  /* LayerManager events */
  "layerManager.setLayers": (layerManager, updated, layers) => {
    if (updated) {
      log3.log(LOG_LEVEL_MINOR_UPDATE, `Updating ${layers.length} deck layers`)();
    }
  },
  "layerManager.activateViewport": (layerManager, viewport) => {
    log3.log(LOG_LEVEL_UPDATE_DETAIL, "Viewport changed", viewport)();
  },
  /* AttributeManager events */
  "attributeManager.invalidate": (attributeManager, trigger2, attributeNames) => {
    log3.log(LOG_LEVEL_MAJOR_UPDATE, attributeNames ? `invalidated attributes ${attributeNames} (${trigger2}) for ${attributeManager.id}` : `invalidated all attributes for ${attributeManager.id}`)();
  },
  "attributeManager.updateStart": (attributeManager) => {
    logState.attributeUpdateMessages.length = 0;
    logState.attributeManagerUpdateStart = Date.now();
  },
  "attributeManager.updateEnd": (attributeManager, numInstances) => {
    const timeMs = Math.round(Date.now() - logState.attributeManagerUpdateStart);
    log3.groupCollapsed(LOG_LEVEL_MINOR_UPDATE, `Updated attributes for ${numInstances} instances in ${attributeManager.id} in ${timeMs}ms`)();
    for (const updateMessage of logState.attributeUpdateMessages) {
      log3.log(LOG_LEVEL_UPDATE_DETAIL, updateMessage)();
    }
    log3.groupEnd(LOG_LEVEL_MINOR_UPDATE)();
  },
  /* Attribute events */
  "attribute.updateStart": (attribute) => {
    logState.attributeUpdateStart = Date.now();
  },
  "attribute.allocate": (attribute, numInstances) => {
    const message2 = `${attribute.id} allocated ${numInstances}`;
    logState.attributeUpdateMessages.push(message2);
  },
  "attribute.updateEnd": (attribute, numInstances) => {
    const timeMs = Math.round(Date.now() - logState.attributeUpdateStart);
    const message2 = `${attribute.id} updated ${numInstances} in ${timeMs}ms`;
    logState.attributeUpdateMessages.push(message2);
  },
  /* Render events */
  "deckRenderer.renderLayers": (deckRenderer, renderStats, opts) => {
    const { pass: pass2, redrawReason, stats } = opts;
    for (const status of renderStats) {
      const { totalCount, visibleCount, compositeCount, pickableCount } = status;
      const primitiveCount = totalCount - compositeCount;
      const hiddenCount = primitiveCount - visibleCount;
      log3.log(LOG_LEVEL_DRAW, `RENDER #${deckRenderer.renderCount}   ${visibleCount} (of ${totalCount} layers) to ${pass2} because ${redrawReason}   (${hiddenCount} hidden, ${compositeCount} composite ${pickableCount} pickable)`)();
      if (stats) {
        stats.get("Redraw Layers").add(visibleCount);
      }
    }
  }
});
let loggers = {};
if (process.env.NODE_ENV !== "production") {
  loggers = getLoggers(log$1);
}
function register(handlers2) {
  loggers = handlers2;
}
function debug(eventType, arg1, arg2, arg3) {
  if (log$1.level > 0 && loggers[eventType]) {
    loggers[eventType].call(null, arg1, arg2, arg3);
  }
}
function isJSON(text) {
  const firstChar = text[0];
  const lastChar = text[text.length - 1];
  return firstChar === "{" && lastChar === "}" || firstChar === "[" && lastChar === "]";
}
const jsonLoader = {
  dataType: null,
  batchType: null,
  id: "JSON",
  name: "JSON",
  module: "",
  version: "",
  options: {},
  extensions: ["json", "geojson"],
  mimeTypes: ["application/json", "application/geo+json"],
  testText: isJSON,
  parseTextSync: JSON.parse
};
function checkVersion() {
  const version2 = "9.0.14";
  const existingVersion = globalThis.deck && globalThis.deck.VERSION;
  if (existingVersion && existingVersion !== version2) {
    throw new Error(`deck.gl - multiple versions detected: ${existingVersion} vs ${version2}`);
  }
  if (!existingVersion) {
    log$1.log(1, `deck.gl ${version2}`)();
    globalThis.deck = {
      ...globalThis.deck,
      VERSION: version2,
      version: version2,
      log: log$1,
      // experimental
      _registerLoggers: register
    };
    registerLoaders([
      jsonLoader,
      // @ts-expect-error non-standard Loader format
      [ImageLoader$1, { imagebitmap: { premultiplyAlpha: "none" } }]
    ]);
  }
  return version2;
}
const VERSION$c = checkVersion();
function assert$b(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "shadertools: assertion failed.");
  }
}
const DEFAULT_PROP_VALIDATORS = {
  number: {
    type: "number",
    validate(value, propType) {
      return Number.isFinite(value) && typeof propType === "object" && (propType.max === void 0 || value <= propType.max) && (propType.min === void 0 || value >= propType.min);
    }
  },
  array: {
    type: "array",
    validate(value, propType) {
      return Array.isArray(value) || ArrayBuffer.isView(value);
    }
  }
};
function makePropValidators(propTypes2) {
  const propValidators = {};
  for (const [name2, propType] of Object.entries(propTypes2)) {
    propValidators[name2] = makePropValidator(propType);
  }
  return propValidators;
}
function getValidatedProperties(properties, propValidators, errorMessage) {
  const validated = {};
  for (const [key, propsValidator] of Object.entries(propValidators)) {
    if (properties && key in properties && !propsValidator.private) {
      if (propsValidator.validate) {
        assert$b(propsValidator.validate(properties[key], propsValidator), `${errorMessage}: invalid ${key}`);
      }
      validated[key] = properties[key];
    } else {
      validated[key] = propsValidator.value;
    }
  }
  return validated;
}
function makePropValidator(propType) {
  let type = getTypeOf$1(propType);
  if (type !== "object") {
    return { value: propType, ...DEFAULT_PROP_VALIDATORS[type], type };
  }
  if (typeof propType === "object") {
    if (!propType) {
      return { type: "object", value: null };
    }
    if (propType.type !== void 0) {
      return { ...propType, ...DEFAULT_PROP_VALIDATORS[propType.type], type: propType.type };
    }
    if (propType.value === void 0) {
      return { type: "object", value: propType };
    }
    type = getTypeOf$1(propType.value);
    return { ...propType, ...DEFAULT_PROP_VALIDATORS[type], type };
  }
  throw new Error("props");
}
function getTypeOf$1(value) {
  if (Array.isArray(value) || ArrayBuffer.isView(value)) {
    return "array";
  }
  return typeof value;
}
const MODULE_INJECTORS_VS = `#ifdef MODULE_LOGDEPTH
logdepth_adjustPosition(gl_Position);
#endif
`;
const MODULE_INJECTORS_FS = `#ifdef MODULE_MATERIAL
gl_FragColor = material_filterColor(gl_FragColor);
#endif
#ifdef MODULE_LIGHTING
gl_FragColor = lighting_filterColor(gl_FragColor);
#endif
#ifdef MODULE_FOG
gl_FragColor = fog_filterColor(gl_FragColor);
#endif
#ifdef MODULE_PICKING
gl_FragColor = picking_filterHighlightColor(gl_FragColor);
gl_FragColor = picking_filterPickingColor(gl_FragColor);
#endif
#ifdef MODULE_LOGDEPTH
logdepth_setFragDepth();
#endif
`;
const MODULE_INJECTORS = {
  vertex: MODULE_INJECTORS_VS,
  fragment: MODULE_INJECTORS_FS
};
const REGEX_START_OF_MAIN = /void\s+main\s*\([^)]*\)\s*\{\n?/;
const REGEX_END_OF_MAIN = /}\n?[^{}]*$/;
const fragments = [];
const DECLARATION_INJECT_MARKER = "__LUMA_INJECT_DECLARATIONS__";
function normalizeInjections(injections) {
  const result = { vertex: {}, fragment: {} };
  for (const hook in injections) {
    let injection = injections[hook];
    const stage = getHookStage(hook);
    if (typeof injection === "string") {
      injection = {
        order: 0,
        injection
      };
    }
    result[stage][hook] = injection;
  }
  return result;
}
function getHookStage(hook) {
  const type = hook.slice(0, 2);
  switch (type) {
    case "vs":
      return "vertex";
    case "fs":
      return "fragment";
    default:
      throw new Error(type);
  }
}
function injectShader(source, stage, inject, injectStandardStubs = false) {
  const isVertex2 = stage === "vertex";
  for (const key in inject) {
    const fragmentData = inject[key];
    fragmentData.sort((a2, b2) => a2.order - b2.order);
    fragments.length = fragmentData.length;
    for (let i2 = 0, len2 = fragmentData.length; i2 < len2; ++i2) {
      fragments[i2] = fragmentData[i2].injection;
    }
    const fragmentString = `${fragments.join("\n")}
`;
    switch (key) {
      case "vs:#decl":
        if (isVertex2) {
          source = source.replace(DECLARATION_INJECT_MARKER, fragmentString);
        }
        break;
      case "vs:#main-start":
        if (isVertex2) {
          source = source.replace(REGEX_START_OF_MAIN, (match2) => match2 + fragmentString);
        }
        break;
      case "vs:#main-end":
        if (isVertex2) {
          source = source.replace(REGEX_END_OF_MAIN, (match2) => fragmentString + match2);
        }
        break;
      case "fs:#decl":
        if (!isVertex2) {
          source = source.replace(DECLARATION_INJECT_MARKER, fragmentString);
        }
        break;
      case "fs:#main-start":
        if (!isVertex2) {
          source = source.replace(REGEX_START_OF_MAIN, (match2) => match2 + fragmentString);
        }
        break;
      case "fs:#main-end":
        if (!isVertex2) {
          source = source.replace(REGEX_END_OF_MAIN, (match2) => fragmentString + match2);
        }
        break;
      default:
        source = source.replace(key, (match2) => match2 + fragmentString);
    }
  }
  source = source.replace(DECLARATION_INJECT_MARKER, "");
  if (injectStandardStubs) {
    source = source.replace(/\}\s*$/, (match2) => match2 + MODULE_INJECTORS[stage]);
  }
  return source;
}
let index = 1;
class ShaderModuleInstance {
  constructor(props) {
    __publicField2(this, "name");
    __publicField2(this, "vs");
    __publicField2(this, "fs");
    __publicField2(this, "getModuleUniforms");
    __publicField2(this, "dependencies");
    __publicField2(this, "deprecations");
    __publicField2(this, "defines");
    __publicField2(this, "injections");
    __publicField2(this, "uniforms", {});
    __publicField2(this, "uniformTypes", {});
    const { name: name2, vs: vs2, fs: fs2, dependencies: dependencies2 = [], uniformTypes = {}, uniformPropTypes = {}, getUniforms: getUniforms2, deprecations = [], defines: defines2 = {}, inject = {} } = props;
    assert$b(typeof name2 === "string");
    this.name = name2;
    this.vs = vs2;
    this.fs = fs2;
    this.getModuleUniforms = getUniforms2;
    this.dependencies = ShaderModuleInstance.instantiateModules(dependencies2);
    this.deprecations = this._parseDeprecationDefinitions(deprecations);
    this.defines = defines2;
    this.injections = normalizeInjections(inject);
    this.uniformTypes = uniformTypes;
    if (uniformPropTypes) {
      this.uniforms = makePropValidators(uniformPropTypes);
    }
  }
  static instantiateModules(modules) {
    return modules.map((module2) => {
      if (module2 instanceof ShaderModuleInstance) {
        return module2;
      }
      assert$b(typeof module2 !== "string", `Shader module use by name is deprecated. Import shader module '${JSON.stringify(module2)}' and use it directly.`);
      if (!module2.name) {
        console.warn("shader module has no name");
        module2.name = `shader-module-${index++}`;
      }
      const moduleObject = new ShaderModuleInstance(module2);
      moduleObject.dependencies = ShaderModuleInstance.instantiateModules(module2.dependencies || []);
      return moduleObject;
    });
  }
  // Extracts the source code chunk for the specified shader type from the named shader module
  getModuleSource(stage) {
    let moduleSource;
    switch (stage) {
      case "vertex":
        moduleSource = this.vs || "";
        break;
      case "fragment":
        moduleSource = this.fs || "";
        break;
      default:
        assert$b(false);
    }
    const moduleName = this.name.toUpperCase().replace(/[^0-9a-z]/gi, "_");
    return `// ----- MODULE ${this.name} ---------------

#define MODULE_${moduleName}
${moduleSource}

`;
  }
  getUniforms(userProps, uniforms) {
    if (this.getModuleUniforms) {
      return this.getModuleUniforms(userProps, uniforms);
    }
    return getValidatedProperties(userProps, this.uniforms, this.name);
  }
  getDefines() {
    return this.defines;
  }
  // Warn about deprecated uniforms or functions
  checkDeprecations(shaderSource, log3) {
    this.deprecations.forEach((def) => {
      var _a3;
      if ((_a3 = def.regex) == null ? void 0 : _a3.test(shaderSource)) {
        if (def.deprecated) {
          log3.deprecated(def.old, def.new)();
        } else {
          log3.removed(def.old, def.new)();
        }
      }
    });
  }
  _parseDeprecationDefinitions(deprecations) {
    deprecations.forEach((def) => {
      switch (def.type) {
        case "function":
          def.regex = new RegExp(`\\b${def.old}\\(`);
          break;
        default:
          def.regex = new RegExp(`${def.type} ${def.old};`);
      }
    });
    return deprecations;
  }
  _defaultGetUniforms(opts = {}) {
    const uniforms = {};
    const propTypes2 = this.uniforms;
    for (const key in propTypes2) {
      const propDef = propTypes2[key];
      if (key in opts && !propDef.private) {
        if (propDef.validate) {
          assert$b(propDef.validate(opts[key], propDef), `${this.name}: invalid ${key}`);
        }
        uniforms[key] = opts[key];
      } else {
        uniforms[key] = propDef.value;
      }
    }
    return uniforms;
  }
}
function selectShaders(props) {
  if (props.source && props.platformInfo.type === "webgpu") {
    const propsCopy = { ...props, vs: void 0, fs: void 0 };
    return propsCopy;
  }
  if (!props.vs) {
    throw new Error("no vertex shader");
  }
  const vs2 = getShaderSource(props.platformInfo, props.vs);
  let fs2;
  if (props.fs) {
    fs2 = getShaderSource(props.platformInfo, props.fs);
  }
  return { ...props, vs: vs2, fs: fs2 };
}
function getShaderSource(platformInfo, shader) {
  if (typeof shader === "string") {
    return shader;
  }
  switch (platformInfo.type) {
    case "webgpu":
      if (shader == null ? void 0 : shader.wgsl) {
        return shader.wgsl;
      }
      throw new Error("WebGPU does not support GLSL shaders");
    default:
      if (shader == null ? void 0 : shader.glsl) {
        return shader.glsl;
      }
      throw new Error("WebGL does not support WGSL shaders");
  }
}
function resolveModules(modules) {
  const instances = ShaderModuleInstance.instantiateModules(modules);
  return getShaderDependencies(instances);
}
function getShaderDependencies(modules) {
  const moduleMap = {};
  const moduleDepth = {};
  getDependencyGraph({ modules, level: 0, moduleMap, moduleDepth });
  return Object.keys(moduleDepth).sort((a2, b2) => moduleDepth[b2] - moduleDepth[a2]).map((name2) => moduleMap[name2]);
}
function getDependencyGraph(options2) {
  const { modules, level, moduleMap, moduleDepth } = options2;
  if (level >= 5) {
    throw new Error("Possible loop in shader dependency graph");
  }
  for (const module2 of modules) {
    moduleMap[module2.name] = module2;
    if (moduleDepth[module2.name] === void 0 || moduleDepth[module2.name] < level) {
      moduleDepth[module2.name] = level;
    }
  }
  for (const module2 of modules) {
    if (module2.dependencies) {
      getDependencyGraph({ modules: module2.dependencies, level: level + 1, moduleMap, moduleDepth });
    }
  }
}
function getPlatformShaderDefines(platformInfo) {
  switch (platformInfo == null ? void 0 : platformInfo.gpu.toLowerCase()) {
    case "apple":
      return `#define APPLE_GPU
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
    case "nvidia":
      return `#define NVIDIA_GPU
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
`;
    case "intel":
      return `#define INTEL_GPU
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
    case "amd":
      return `#define AMD_GPU
`;
    default:
      return `#define DEFAULT_GPU
#define LUMA_FP64_CODE_ELIMINATION_WORKAROUND 1
#define LUMA_FP32_TAN_PRECISION_WORKAROUND 1
#define LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND 1
`;
  }
}
function transpileGLSLShader(source, stage) {
  var _a3;
  const sourceGLSLVersion = Number(((_a3 = source.match(/^#version[ \t]+(\d+)/m)) == null ? void 0 : _a3[1]) || 100);
  if (sourceGLSLVersion !== 300) {
    throw new Error("luma.gl v9 only supports GLSL 3.00 shader sources");
  }
  switch (stage) {
    case "vertex":
      source = convertShader(source, ES300_VERTEX_REPLACEMENTS);
      return source;
    case "fragment":
      source = convertShader(source, ES300_FRAGMENT_REPLACEMENTS);
      return source;
    default:
      throw new Error(stage);
  }
}
const ES300_REPLACEMENTS = [
  // Fix poorly formatted version directive
  [/^(#version[ \t]+(100|300[ \t]+es))?[ \t]*\n/, "#version 300 es\n"],
  // The individual `texture...()` functions were replaced with `texture()` overloads
  [/\btexture(2D|2DProj|Cube)Lod(EXT)?\(/g, "textureLod("],
  [/\btexture(2D|2DProj|Cube)(EXT)?\(/g, "texture("]
];
const ES300_VERTEX_REPLACEMENTS = [
  ...ES300_REPLACEMENTS,
  // `attribute` keyword replaced with `in`
  [makeVariableTextRegExp("attribute"), "in $1"],
  // `varying` keyword replaced with `out`
  [makeVariableTextRegExp("varying"), "out $1"]
];
const ES300_FRAGMENT_REPLACEMENTS = [
  ...ES300_REPLACEMENTS,
  // `varying` keyword replaced with `in`
  [makeVariableTextRegExp("varying"), "in $1"]
];
function convertShader(source, replacements) {
  for (const [pattern, replacement] of replacements) {
    source = source.replace(pattern, replacement);
  }
  return source;
}
function makeVariableTextRegExp(qualifier) {
  return new RegExp(`\\b${qualifier}[ \\t]+(\\w+[ \\t]+\\w+(\\[\\w+\\])?;)`, "g");
}
function getShaderHooks(hookFunctions, hookInjections) {
  let result = "";
  for (const hookName in hookFunctions) {
    const hookFunction = hookFunctions[hookName];
    result += `void ${hookFunction.signature} {
`;
    if (hookFunction.header) {
      result += `  ${hookFunction.header}`;
    }
    if (hookInjections[hookName]) {
      const injections = hookInjections[hookName];
      injections.sort((a2, b2) => a2.order - b2.order);
      for (const injection of injections) {
        result += `  ${injection.injection}
`;
      }
    }
    if (hookFunction.footer) {
      result += `  ${hookFunction.footer}`;
    }
    result += "}\n";
  }
  return result;
}
function normalizeShaderHooks(hookFunctions) {
  const result = { vertex: {}, fragment: {} };
  for (const hookFunction of hookFunctions) {
    let opts;
    let hook;
    if (typeof hookFunction !== "string") {
      opts = hookFunction;
      hook = opts.hook;
    } else {
      opts = {};
      hook = hookFunction;
    }
    hook = hook.trim();
    const [shaderStage, signature] = hook.split(":");
    const name2 = hook.replace(/\(.+/, "");
    const normalizedHook = Object.assign(opts, { signature });
    switch (shaderStage) {
      case "vs":
        result.vertex[name2] = normalizedHook;
        break;
      case "fs":
        result.fragment[name2] = normalizedHook;
        break;
      default:
        throw new Error(shaderStage);
    }
  }
  return result;
}
function getShaderInfo$1(source, defaultName) {
  return {
    name: getShaderName$1(source, defaultName),
    language: "glsl",
    version: getShaderVersion$1(source)
  };
}
function getShaderName$1(shader, defaultName = "unnamed") {
  const SHADER_NAME_REGEXP = /#define[^\S\r\n]*SHADER_NAME[^\S\r\n]*([A-Za-z0-9_-]+)\s*/;
  const match2 = SHADER_NAME_REGEXP.exec(shader);
  return match2 ? match2[1] : defaultName;
}
function getShaderVersion$1(source) {
  let version2 = 100;
  const words = source.match(/[^\s]+/g);
  if (words && words.length >= 2 && words[0] === "#version") {
    const parsedVersion = parseInt(words[1], 10);
    if (Number.isFinite(parsedVersion)) {
      version2 = parsedVersion;
    }
  }
  if (version2 !== 100 && version2 !== 300) {
    throw new Error(`Invalid GLSL version ${version2}`);
  }
  return version2;
}
const INJECT_SHADER_DECLARATIONS = `

${DECLARATION_INJECT_MARKER}
`;
const FRAGMENT_SHADER_PROLOGUE = `precision highp float;
`;
function assembleShaderWGSL(options2) {
  const modules = resolveModules(options2.modules || []);
  return {
    source: assembleWGSLShader(options2.platformInfo, {
      ...options2,
      source: options2.source,
      stage: "vertex",
      modules
    }),
    getUniforms: assembleGetUniforms(modules)
  };
}
function assembleShaderPairWGSL(options2) {
  const modules = resolveModules(options2.modules || []);
  return {
    vs: assembleWGSLShader(options2.platformInfo, {
      ...options2,
      source: options2.vs,
      stage: "vertex",
      modules
    }),
    fs: assembleWGSLShader(options2.platformInfo, {
      ...options2,
      source: options2.fs,
      stage: "fragment",
      modules
    }),
    getUniforms: assembleGetUniforms(modules)
  };
}
function assembleShaderPairGLSL(options2) {
  const { vs: vs2, fs: fs2 } = options2;
  const modules = resolveModules(options2.modules || []);
  return {
    vs: assembleGLSLShader(options2.platformInfo, {
      ...options2,
      source: vs2,
      stage: "vertex",
      modules
    }),
    fs: assembleGLSLShader(options2.platformInfo, {
      ...options2,
      source: fs2,
      stage: "fragment",
      modules
    }),
    getUniforms: assembleGetUniforms(modules)
  };
}
function assembleWGSLShader(platformInfo, options2) {
  const {
    // id,
    source,
    stage,
    modules,
    // defines = {},
    hookFunctions = [],
    inject = {},
    log: log3
  } = options2;
  assert$b(typeof source === "string", "shader source must be a string");
  const coreSource = source;
  let assembledSource = "";
  const hookFunctionMap = normalizeShaderHooks(hookFunctions);
  const hookInjections = {};
  const declInjections = {};
  const mainInjections = {};
  for (const key in inject) {
    const injection = typeof inject[key] === "string" ? { injection: inject[key], order: 0 } : inject[key];
    const match2 = /^(v|f)s:(#)?([\w-]+)$/.exec(key);
    if (match2) {
      const hash = match2[2];
      const name2 = match2[3];
      if (hash) {
        if (name2 === "decl") {
          declInjections[key] = [injection];
        } else {
          mainInjections[key] = [injection];
        }
      } else {
        hookInjections[key] = [injection];
      }
    } else {
      mainInjections[key] = [injection];
    }
  }
  const modulesToInject = platformInfo.type !== "webgpu" ? modules : [];
  for (const module2 of modulesToInject) {
    if (log3) {
      module2.checkDeprecations(coreSource, log3);
    }
    const moduleSource = module2.getModuleSource(stage, "wgsl");
    assembledSource += moduleSource;
    const injections = module2.injections[stage];
    for (const key in injections) {
      const match2 = /^(v|f)s:#([\w-]+)$/.exec(key);
      if (match2) {
        const name2 = match2[2];
        const injectionType = name2 === "decl" ? declInjections : mainInjections;
        injectionType[key] = injectionType[key] || [];
        injectionType[key].push(injections[key]);
      } else {
        hookInjections[key] = hookInjections[key] || [];
        hookInjections[key].push(injections[key]);
      }
    }
  }
  assembledSource += INJECT_SHADER_DECLARATIONS;
  assembledSource = injectShader(assembledSource, stage, declInjections);
  assembledSource += getShaderHooks(hookFunctionMap[stage], hookInjections);
  assembledSource += coreSource;
  assembledSource = injectShader(assembledSource, stage, mainInjections);
  return assembledSource;
}
function assembleGLSLShader(platformInfo, options2) {
  const { id, source, stage, language = "glsl", modules, defines: defines2 = {}, hookFunctions = [], inject = {}, prologue = true, log: log3 } = options2;
  assert$b(typeof source === "string", "shader source must be a string");
  const sourceVersion = language === "glsl" ? getShaderInfo$1(source).version : -1;
  const targetVersion = platformInfo.shaderLanguageVersion;
  const sourceVersionDirective = sourceVersion === 100 ? "#version 100" : "#version 300 es";
  const sourceLines = source.split("\n");
  const coreSource = sourceLines.slice(1).join("\n");
  const allDefines = {};
  modules.forEach((module2) => {
    Object.assign(allDefines, module2.getDefines());
  });
  Object.assign(allDefines, defines2);
  let assembledSource = "";
  switch (language) {
    case "wgsl":
      break;
    case "glsl":
      assembledSource = prologue ? `${sourceVersionDirective}

// ----- PROLOGUE -------------------------
${getShaderNameDefine({ id, source, stage })}
${`#define SHADER_TYPE_${stage.toUpperCase()}`}
${getPlatformShaderDefines(platformInfo)}
${stage === "fragment" ? FRAGMENT_SHADER_PROLOGUE : ""}

// ----- APPLICATION DEFINES -------------------------

${getApplicationDefines(allDefines)}

` : `${sourceVersionDirective}
`;
      break;
  }
  const hookFunctionMap = normalizeShaderHooks(hookFunctions);
  const hookInjections = {};
  const declInjections = {};
  const mainInjections = {};
  for (const key in inject) {
    const injection = typeof inject[key] === "string" ? { injection: inject[key], order: 0 } : inject[key];
    const match2 = /^(v|f)s:(#)?([\w-]+)$/.exec(key);
    if (match2) {
      const hash = match2[2];
      const name2 = match2[3];
      if (hash) {
        if (name2 === "decl") {
          declInjections[key] = [injection];
        } else {
          mainInjections[key] = [injection];
        }
      } else {
        hookInjections[key] = [injection];
      }
    } else {
      mainInjections[key] = [injection];
    }
  }
  for (const module2 of modules) {
    if (log3) {
      module2.checkDeprecations(coreSource, log3);
    }
    const moduleSource = module2.getModuleSource(stage);
    assembledSource += moduleSource;
    const injections = module2.injections[stage];
    for (const key in injections) {
      const match2 = /^(v|f)s:#([\w-]+)$/.exec(key);
      if (match2) {
        const name2 = match2[2];
        const injectionType = name2 === "decl" ? declInjections : mainInjections;
        injectionType[key] = injectionType[key] || [];
        injectionType[key].push(injections[key]);
      } else {
        hookInjections[key] = hookInjections[key] || [];
        hookInjections[key].push(injections[key]);
      }
    }
  }
  assembledSource += "// ----- MAIN SHADER SOURCE -------------------------";
  assembledSource += INJECT_SHADER_DECLARATIONS;
  assembledSource = injectShader(assembledSource, stage, declInjections);
  assembledSource += getShaderHooks(hookFunctionMap[stage], hookInjections);
  assembledSource += coreSource;
  assembledSource = injectShader(assembledSource, stage, mainInjections);
  if (language === "glsl" && sourceVersion !== targetVersion) {
    assembledSource = transpileGLSLShader(assembledSource, stage);
  }
  return assembledSource.trim();
}
function assembleGetUniforms(modules) {
  return function getUniforms2(opts) {
    const uniforms = {};
    for (const module2 of modules) {
      const moduleUniforms = module2.getUniforms(opts, uniforms);
      Object.assign(uniforms, moduleUniforms);
    }
    return uniforms;
  };
}
function getShaderNameDefine(options2) {
  const { id, source, stage } = options2;
  const injectShaderName = id && source.indexOf("SHADER_NAME") === -1;
  return injectShaderName ? `
#define SHADER_NAME ${id}_${stage}

` : "";
}
function getApplicationDefines(defines2 = {}) {
  let sourceText = "";
  for (const define2 in defines2) {
    const value = defines2[define2];
    if (value || Number.isFinite(value)) {
      sourceText += `#define ${define2.toUpperCase()} ${defines2[define2]}
`;
    }
  }
  return sourceText;
}
const _ShaderAssembler = class {
  constructor() {
    /** Hook functions */
    __publicField2(this, "_hookFunctions", []);
    /** Shader modules */
    __publicField2(this, "_defaultModules", []);
  }
  /**
   * A default shader assembler instance - the natural place to register default modules and hooks
   * @returns
   */
  static getDefaultShaderAssembler() {
    _ShaderAssembler.defaultShaderAssembler = _ShaderAssembler.defaultShaderAssembler || new _ShaderAssembler();
    return _ShaderAssembler.defaultShaderAssembler;
  }
  /**
   * Add a default module that does not have to be provided with every call to assembleShaders()
   */
  addDefaultModule(module2) {
    if (!this._defaultModules.find((m2) => m2.name === (typeof module2 === "string" ? module2 : module2.name))) {
      this._defaultModules.push(module2);
    }
  }
  /**
   * Remove a default module
   */
  removeDefaultModule(module2) {
    const moduleName = typeof module2 === "string" ? module2 : module2.name;
    this._defaultModules = this._defaultModules.filter((m2) => m2.name !== moduleName);
  }
  /**
   * Register a shader hook
   * @param hook
   * @param opts
   */
  addShaderHook(hook, opts) {
    if (opts) {
      hook = Object.assign(opts, { hook });
    }
    this._hookFunctions.push(hook);
  }
  /**
   * Assemble a pair of shaders into a single shader program
   * @param platformInfo
   * @param props
   * @returns
   */
  assembleShader(props) {
    const modules = this._getModuleList(props.modules);
    const hookFunctions = this._hookFunctions;
    const options2 = selectShaders(props);
    const assembled = assembleShaderWGSL({
      platformInfo: props.platformInfo,
      ...options2,
      modules,
      hookFunctions
    });
    return { ...assembled, modules };
  }
  /**
   * Assemble a pair of shaders into a single shader program
   * @param platformInfo
   * @param props
   * @returns
   */
  assembleShaderPair(props) {
    const options2 = selectShaders(props);
    const modules = this._getModuleList(props.modules);
    const hookFunctions = this._hookFunctions;
    const { platformInfo } = props;
    const isWGSL = props.platformInfo.shaderLanguage === "wgsl";
    const assembled = isWGSL ? assembleShaderPairWGSL({ platformInfo, ...options2, modules, hookFunctions }) : assembleShaderPairGLSL({ platformInfo, ...options2, modules, hookFunctions });
    return { ...assembled, modules };
  }
  /**
   * Dedupe and combine with default modules
   */
  _getModuleList(appModules = []) {
    const modules = new Array(this._defaultModules.length + appModules.length);
    const seen = {};
    let count3 = 0;
    for (let i2 = 0, len2 = this._defaultModules.length; i2 < len2; ++i2) {
      const module2 = this._defaultModules[i2];
      const name2 = module2.name;
      modules[count3++] = module2;
      seen[name2] = true;
    }
    for (let i2 = 0, len2 = appModules.length; i2 < len2; ++i2) {
      const module2 = appModules[i2];
      const name2 = module2.name;
      if (!seen[name2]) {
        modules[count3++] = module2;
        seen[name2] = true;
      }
    }
    modules.length = count3;
    return ShaderModuleInstance.instantiateModules(modules);
  }
};
let ShaderAssembler = _ShaderAssembler;
/** Default ShaderAssembler instance */
__publicField2(ShaderAssembler, "defaultShaderAssembler");
const FS_GLES = `out vec4 transform_output;
void main() {
transform_output = vec4(0);
}`;
const FS300 = `#version 300 es
${FS_GLES}`;
function getPassthroughFS(options2) {
  const { input, inputChannels, output: output2 } = options2 || {};
  if (!input) {
    return FS300;
  }
  if (!inputChannels) {
    throw new Error("inputChannels");
  }
  const inputType = channelCountToType(inputChannels);
  const outputValue = convertToVec4(input, inputChannels);
  return `#version 300 es
in ${inputType} ${input};
out vec4 ${output2};
void main() {
  ${output2} = ${outputValue};
}`;
}
function channelCountToType(channels) {
  switch (channels) {
    case 1:
      return "float";
    case 2:
      return "vec2";
    case 3:
      return "vec3";
    case 4:
      return "vec4";
    default:
      throw new Error(`invalid channels: ${channels}`);
  }
}
function convertToVec4(variable, channels) {
  switch (channels) {
    case 1:
      return `vec4(${variable}, 0.0, 0.0, 1.0)`;
    case 2:
      return `vec4(${variable}, 0.0, 1.0)`;
    case 3:
      return `vec4(${variable}, 1.0)`;
    case 4:
      return variable;
    default:
      throw new Error(`invalid channels: ${channels}`);
  }
}
const log = new Log({ id: "luma.gl" });
class StatsManager {
  constructor() {
    __publicField2(this, "stats", /* @__PURE__ */ new Map());
  }
  getStats(name2) {
    return this.get(name2);
  }
  get(name2) {
    if (!this.stats.has(name2)) {
      this.stats.set(name2, new Stats({ id: name2 }));
    }
    return this.stats.get(name2);
  }
}
const lumaStats = new StatsManager();
function initializeLuma() {
  const VERSION2 = "9.0.14";
  const STARTUP_MESSAGE = "set luma.log.level=1 (or higher) to trace rendering";
  if (globalThis.luma && globalThis.luma.VERSION !== VERSION2) {
    throw new Error(`luma.gl - multiple VERSIONs detected: ${globalThis.luma.VERSION} vs ${VERSION2}`);
  }
  if (!globalThis.luma) {
    if (isBrowser$4()) {
      log.log(1, `${VERSION2} - ${STARTUP_MESSAGE}`)();
    }
    globalThis.luma = globalThis.luma || {
      VERSION: VERSION2,
      version: VERSION2,
      log,
      // A global stats object that various components can add information to
      // E.g. see webgl/resource.js
      stats: lumaStats
    };
  }
  return VERSION2;
}
const VERSION$b = initializeLuma();
function isTypedArray(value) {
  return ArrayBuffer.isView(value) && !(value instanceof DataView) ? value : null;
}
function isNumberArray(value) {
  if (Array.isArray(value)) {
    return value.length === 0 || typeof value[0] === "number" ? value : null;
  }
  return isTypedArray(value);
}
const uidCounters = {};
function uid(id = "id") {
  uidCounters[id] = uidCounters[id] || 1;
  const count3 = uidCounters[id]++;
  return `${id}-${count3}`;
}
function isObjectEmpty$3(obj) {
  let isEmpty6 = true;
  for (const key in obj) {
    isEmpty6 = false;
    break;
  }
  return isEmpty6;
}
let Resource$1 = (_b2 = class {
  /**
   * Create a new Resource. Called from Subclass
   */
  constructor(device, props, defaultProps2) {
    /** props.id, for debugging. */
    __publicField2(this, "id");
    __publicField2(this, "props");
    __publicField2(this, "userData", {});
    __publicField2(this, "_device");
    /** Whether this resource has been destroyed */
    __publicField2(this, "destroyed", false);
    /** For resources that allocate GPU memory */
    __publicField2(this, "allocatedBytes", 0);
    /** Attached resources will be destroyed when this resource is destroyed. Tracks auto-created "sub" resources. */
    __publicField2(this, "_attachedResources", /* @__PURE__ */ new Set());
    if (!device) {
      throw new Error("no device");
    }
    this._device = device;
    this.props = selectivelyMerge(props, defaultProps2);
    const id = this.props.id !== "undefined" ? this.props.id : uid(this[Symbol.toStringTag]);
    this.props.id = id;
    this.id = id;
    this.userData = this.props.userData || {};
    this.addStats();
  }
  /**
   * destroy can be called on any resource to release it before it is garbage collected.
   */
  destroy() {
    this.destroyResource();
  }
  /** @deprecated Use destroy() */
  delete() {
    this.destroy();
    return this;
  }
  toString() {
    return `${this[Symbol.toStringTag] || this.constructor.name}(${this.id})`;
  }
  /**
   * Combines a map of user props and default props, only including props from defaultProps
   * @returns returns a map of overridden default props
   */
  getProps() {
    return this.props;
  }
  // ATTACHED RESOURCES
  /**
   * Attaches a resource. Attached resources are auto destroyed when this resource is destroyed
   * Called automatically when sub resources are auto created but can be called by application
   */
  attachResource(resource) {
    this._attachedResources.add(resource);
  }
  /**
   * Detach an attached resource. The resource will no longer be auto-destroyed when this resource is destroyed.
   */
  detachResource(resource) {
    this._attachedResources.delete(resource);
  }
  /**
   * Destroys a resource (only if owned), and removes from the owned (auto-destroy) list for this resource.
   */
  destroyAttachedResource(resource) {
    if (this._attachedResources.delete(resource)) {
      resource.destroy();
    }
  }
  /** Destroy all owned resources. Make sure the resources are no longer needed before calling. */
  destroyAttachedResources() {
    for (const resource of Object.values(this._attachedResources)) {
      resource.destroy();
    }
    this._attachedResources = /* @__PURE__ */ new Set();
  }
  // PROTECTED METHODS
  /** Perform all destroy steps. Can be called by derived resources when overriding destroy() */
  destroyResource() {
    this.destroyAttachedResources();
    this.removeStats();
    this.destroyed = true;
  }
  /** Called by .destroy() to track object destruction. Subclass must call if overriding destroy() */
  removeStats() {
    const stats = this._device.statsManager.getStats("Resource Counts");
    const name2 = this[Symbol.toStringTag];
    stats.get(`${name2}s Active`).decrementCount();
  }
  /** Called by subclass to track memory allocations */
  trackAllocatedMemory(bytes, name2 = this[Symbol.toStringTag]) {
    const stats = this._device.statsManager.getStats("Resource Counts");
    stats.get("GPU Memory").addCount(bytes);
    stats.get(`${name2} Memory`).addCount(bytes);
    this.allocatedBytes = bytes;
  }
  /** Called by subclass to track memory deallocations */
  trackDeallocatedMemory(name2 = this[Symbol.toStringTag]) {
    const stats = this._device.statsManager.getStats("Resource Counts");
    stats.get("GPU Memory").subtractCount(this.allocatedBytes);
    stats.get(`${name2} Memory`).subtractCount(this.allocatedBytes);
    this.allocatedBytes = 0;
  }
  /** Called by resource constructor to track object creation */
  addStats() {
    const stats = this._device.statsManager.getStats("Resource Counts");
    const name2 = this[Symbol.toStringTag];
    stats.get("Resources Created").incrementCount();
    stats.get(`${name2}s Created`).incrementCount();
    stats.get(`${name2}s Active`).incrementCount();
  }
}, /** Default properties for resource */
__publicField2(_b2, "defaultProps", {
  id: "undefined",
  handle: void 0,
  userData: void 0
}), _b2);
function selectivelyMerge(props, defaultProps2) {
  const mergedProps = { ...defaultProps2 };
  for (const key in props) {
    if (props[key] !== void 0) {
      mergedProps[key] = props[key];
    }
  }
  return mergedProps;
}
let Buffer$1 = (_c = class extends Resource$1 {
  constructor(device, props) {
    const deducedProps = { ...props };
    if ((props.usage || 0) & _c.INDEX && !props.indexType) {
      if (props.data instanceof Uint32Array) {
        deducedProps.indexType = "uint32";
      } else if (props.data instanceof Uint16Array) {
        deducedProps.indexType = "uint16";
      }
    }
    super(device, deducedProps, _c.defaultProps);
    /** The usage with which this buffer was created */
    __publicField2(this, "usage");
    /** For index buffers, whether indices are 16 or 32 bit */
    __publicField2(this, "indexType");
    /** "Time" of last update */
    __publicField2(this, "updateTimestamp");
    /** A partial CPU-side copy of the data in this buffer, for debugging purposes */
    __publicField2(this, "debugData", new ArrayBuffer(0));
    this.usage = props.usage || 0;
    this.indexType = deducedProps.indexType;
    this.updateTimestamp = device.incrementTimestamp();
  }
  get [Symbol.toStringTag]() {
    return "Buffer";
  }
  /** Read data synchronously. @note WebGL2 only */
  readSyncWebGL(byteOffset, byteLength) {
    throw new Error("not implemented");
  }
  /** This doesn't handle partial non-zero offset updates correctly */
  _setDebugData(data2, byteOffset, byteLength) {
    const buffer3 = ArrayBuffer.isView(data2) ? data2.buffer : data2;
    const debugDataLength = Math.min(data2 ? data2.byteLength : byteLength, _c.DEBUG_DATA_MAX_LENGTH);
    if (data2 === null) {
      this.debugData = new ArrayBuffer(debugDataLength);
    } else if (byteOffset === 0 && byteLength === data2.byteLength) {
      this.debugData = buffer3.slice(0, debugDataLength);
    } else {
      this.debugData = buffer3.slice(byteOffset, byteOffset + debugDataLength);
    }
  }
}, __publicField2(_c, "defaultProps", {
  ...Resource$1.defaultProps,
  usage: 0,
  // Buffer.COPY_DST | Buffer.COPY_SRC
  byteLength: 0,
  byteOffset: 0,
  data: null,
  indexType: "uint16",
  mappedAtCreation: false
}), // Usage Flags
__publicField2(_c, "MAP_READ", 1), __publicField2(_c, "MAP_WRITE", 2), __publicField2(_c, "COPY_SRC", 4), __publicField2(_c, "COPY_DST", 8), /** Index buffer */
__publicField2(_c, "INDEX", 16), /** Vertex buffer */
__publicField2(_c, "VERTEX", 32), /** Uniform buffer */
__publicField2(_c, "UNIFORM", 64), /** Storage buffer */
__publicField2(_c, "STORAGE", 128), __publicField2(_c, "INDIRECT", 256), __publicField2(_c, "QUERY_RESOLVE", 512), // PROTECTED METHODS (INTENDED FOR USE BY OTHER FRAMEWORK CODE ONLY)
/** Max amount of debug data saved. Two vec4's */
__publicField2(_c, "DEBUG_DATA_MAX_LENGTH", 32), _c);
function decodeVertexType(type) {
  const dataType = TYPE_MAP[type];
  const bytes = getDataTypeBytes(dataType);
  const normalized = type.includes("norm");
  const integer = !normalized && !type.startsWith("float");
  const signed = type.startsWith("s");
  return {
    dataType: TYPE_MAP[type],
    byteLength: bytes,
    integer,
    signed,
    normalized
  };
}
function getDataTypeBytes(type) {
  const bytes = TYPE_SIZES$2[type];
  return bytes;
}
const TYPE_MAP = {
  uint8: "uint8",
  sint8: "sint8",
  unorm8: "uint8",
  snorm8: "sint8",
  uint16: "uint16",
  sint16: "sint16",
  unorm16: "uint16",
  snorm16: "sint16",
  float16: "float16",
  float32: "float32",
  uint32: "uint32",
  sint32: "sint32"
};
const TYPE_SIZES$2 = {
  uint8: 1,
  sint8: 1,
  uint16: 2,
  sint16: 2,
  float16: 2,
  float32: 4,
  uint32: 4,
  sint32: 4
};
const COMPRESSED_TEXTURE_FORMAT_PREFIXES = [
  "bc1",
  "bc2",
  "bc3",
  "bc4",
  "bc5",
  "bc6",
  "bc7",
  "etc1",
  "etc2",
  "eac",
  "atc",
  "astc",
  "pvrtc"
];
const REGEX = /^(rg?b?a?)([0-9]*)([a-z]*)(-srgb)?(-webgl|-unsized)?$/;
function isTextureFormatCompressed(textureFormat) {
  return COMPRESSED_TEXTURE_FORMAT_PREFIXES.some((prefix) => textureFormat.startsWith(prefix));
}
function decodeTextureFormat(format) {
  const matches2 = REGEX.exec(format);
  if (matches2) {
    const [, format2, length2, type, srgb, suffix] = matches2;
    if (format2) {
      const dataType = `${type}${length2}`;
      const decodedType = decodeVertexType(dataType);
      return {
        format: format2,
        components: format2.length,
        // dataType - overwritten by decodedType
        srgb: srgb === "-srgb",
        unsized: suffix === "-unsized",
        webgl: suffix === "-webgl",
        ...decodedType
      };
    }
  }
  return decodeNonStandardFormat(format);
}
const EXCEPTIONS = {
  // Packed 16 bit formats
  "rgba4unorm-webgl": { format: "rgba", bpp: 2 },
  "rgb565unorm-webgl": { format: "rgb", bpp: 2 },
  "rgb5a1unorm-webgl": { format: "rgba", bbp: 2 },
  // Packed 32 bit formats
  rgb9e5ufloat: { format: "rgb", bbp: 4 },
  rg11b10ufloat: { format: "rgb", bbp: 4 },
  rgb10a2unorm: { format: "rgba", bbp: 4 },
  "rgb10a2uint-webgl": { format: "rgba", bbp: 4 },
  // Depth/stencil
  stencil8: { components: 1, bpp: 1, a: "stencil" },
  depth16unorm: { components: 1, bpp: 2, a: "depth" },
  depth24plus: { components: 1, bpp: 3, a: "depth" },
  depth32float: { components: 1, bpp: 4, a: "depth" },
  "depth24plus-stencil8": { components: 2, bpp: 4, a: "depth-stencil" },
  // "depth24unorm-stencil8" feature
  "depth24unorm-stencil8": { components: 2, bpp: 4, a: "depth-stencil" },
  // "depth32float-stencil8" feature
  "depth32float-stencil8": { components: 2, bpp: 4, a: "depth-stencil" }
};
function decodeNonStandardFormat(format) {
  var _a3;
  const data2 = EXCEPTIONS[format];
  if (!data2) {
    throw new Error(`Unknown format ${format}`);
  }
  return {
    format: data2.format || "",
    components: data2.components || ((_a3 = data2.format) == null ? void 0 : _a3.length) || 1,
    byteLength: data2.bpp || 1,
    srgb: false,
    unsized: false
  };
}
class DeviceLimits {
}
class DeviceFeatures {
  constructor(features = [], disabledFeatures) {
    __publicField2(this, "features");
    __publicField2(this, "disabledFeatures");
    this.features = new Set(features);
    this.disabledFeatures = disabledFeatures || {};
  }
  *[Symbol.iterator]() {
    yield* this.features;
  }
  has(feature2) {
    return !this.disabledFeatures[feature2] && this.features.has(feature2);
  }
}
const _Device = class {
  constructor(props) {
    /** id of this device, primarily for debugging */
    __publicField2(this, "id");
    /** A copy of the device props  */
    __publicField2(this, "props");
    /** Available for the application to store data on the device */
    __publicField2(this, "userData", {});
    /** stats */
    __publicField2(this, "statsManager", lumaStats);
    /** Used by other luma.gl modules to store data on the device */
    __publicField2(this, "_lumaData", {});
    __publicField2(this, "timestamp", 0);
    this.props = { ..._Device.defaultProps, ...props };
    this.id = this.props.id || uid(this[Symbol.toStringTag].toLowerCase());
  }
  get [Symbol.toStringTag]() {
    return "Device";
  }
  /** Check if a specific texture format is GPU compressed */
  isTextureFormatCompressed(format) {
    return isTextureFormatCompressed(format);
  }
  /**
   * Trigger device loss.
   * @returns `true` if context loss could actually be triggered.
   * @note primarily intended for testing how application reacts to device loss
   */
  loseDevice() {
    return false;
  }
  /** Returns the default / primary canvas context. Throws an error if no canvas context is available (a WebGPU compute device) */
  getCanvasContext() {
    if (!this.canvasContext) {
      throw new Error("Device has no CanvasContext");
    }
    return this.canvasContext;
  }
  createTexture(props) {
    if (props instanceof Promise || typeof props === "string") {
      props = { data: props };
    }
    return this._createTexture(props);
  }
  createCommandEncoder(props = {}) {
    throw new Error("not implemented");
  }
  // WebGL specific HACKS - enables app to remove webgl import
  // Use until we have a better way to handle these
  /** @deprecated - will be removed - should use command encoder */
  readPixelsToArrayWebGL(source, options2) {
    throw new Error("not implemented");
  }
  /** @deprecated - will be removed - should use command encoder */
  readPixelsToBufferWebGL(source, options2) {
    throw new Error("not implemented");
  }
  /** @deprecated - will be removed - should use WebGPU parameters (pipeline) */
  setParametersWebGL(parameters) {
    throw new Error("not implemented");
  }
  /** @deprecated - will be removed - should use WebGPU parameters (pipeline) */
  getParametersWebGL(parameters) {
    throw new Error("not implemented");
  }
  /** @deprecated - will be removed - should use WebGPU parameters (pipeline) */
  withParametersWebGL(parameters, func2) {
    throw new Error("not implemented");
  }
  /** @deprecated - will be removed - should use clear arguments in RenderPass */
  clearWebGL(options2) {
    throw new Error("not implemented");
  }
  /** @deprecated - will be removed - should use for debugging only */
  resetWebGL() {
    throw new Error("not implemented");
  }
  /** A monotonic counter for tracking buffer and texture updates */
  incrementTimestamp() {
    return this.timestamp++;
  }
  // Error Handling
  /** Report unhandled device errors */
  onError(error2) {
    this.props.onError(error2);
  }
  // IMPLEMENTATION
  _getBufferProps(props) {
    if (props instanceof ArrayBuffer || ArrayBuffer.isView(props)) {
      props = { data: props };
    }
    const newProps = { ...props };
    if ((props.usage || 0) & Buffer$1.INDEX && !props.indexType) {
      if (props.data instanceof Uint32Array) {
        newProps.indexType = "uint32";
      } else if (props.data instanceof Uint16Array) {
        newProps.indexType = "uint16";
      } else {
        log.warn("indices buffer content must be of integer type")();
      }
    }
    return newProps;
  }
};
let Device = _Device;
__publicField2(Device, "defaultProps", {
  id: null,
  canvas: null,
  container: null,
  manageState: true,
  width: 800,
  // width are height are only used by headless gl
  height: 600,
  requestMaxLimits: true,
  debug: Boolean(log.get("debug")),
  // Instrument context (at the expense of performance)
  spector: Boolean(log.get("spector") || log.get("spectorjs")),
  // Initialize the SpectorJS WebGL debugger
  break: [],
  // TODO - Change these after confirming things work as expected
  initalizeFeatures: true,
  disabledFeatures: {
    "compilation-status-async-webgl": true
  },
  // alpha: undefined,
  // depth: undefined,
  // stencil: undefined,
  // antialias: undefined,
  // premultipliedAlpha: undefined,
  // preserveDrawingBuffer: undefined,
  // failIfMajorPerformanceCaveat: undefined
  gl: null,
  // Callbacks
  onError: (error2) => log.error(error2.message)
});
__publicField2(Device, "VERSION", VERSION$b);
function assert$a(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "luma.gl: assertion failed.");
  }
}
const deviceMap = /* @__PURE__ */ new Map();
const _luma = class {
  static registerDevices(deviceClasses) {
    for (const deviceClass of deviceClasses) {
      assert$a(deviceClass.type && deviceClass.isSupported && deviceClass.create);
      deviceMap.set(deviceClass.type, deviceClass);
    }
  }
  static getAvailableDevices() {
    return Array.from(deviceMap).map((Device2) => Device2.type);
  }
  static getSupportedDevices() {
    return Array.from(deviceMap).filter((Device2) => Device2.isSupported()).map((Device2) => Device2.type);
  }
  static setDefaultDeviceProps(props) {
    Object.assign(Device.defaultProps, props);
  }
  /** Attach to an existing GPU API handle (WebGL2RenderingContext or GPUDevice). */
  static async attachDevice(props) {
    const devices = getDeviceMap(props.devices) || deviceMap;
    if (props.handle instanceof WebGL2RenderingContext) {
      const WebGLDevice2 = devices.get("webgl");
      if (WebGLDevice2) {
        return await WebGLDevice2.attach(props.handle);
      }
    }
    if (props.handle === null) {
      const UnknownDevice = devices.get("unknown");
      if (UnknownDevice) {
        return await UnknownDevice.attach(null);
      }
    }
    throw new Error("Failed to attach device. Ensure `@luma.gl/webgl` and/or `@luma.gl/webgpu` modules are imported.");
  }
  /** Creates a device. Asynchronously. */
  static async createDevice(props = {}) {
    var _a3, _b3;
    props = { ..._luma.defaultProps, ...props };
    if (props.gl) {
      props.type = "webgl";
    }
    const devices = getDeviceMap(props.devices) || deviceMap;
    switch (props.type) {
      case "webgpu":
        let WebGPUDevice = devices.get("webgpu");
        if (WebGPUDevice) {
          return await WebGPUDevice.create(props);
        }
        break;
      case "webgl":
        let WebGLDevice2 = devices.get("webgl");
        if (WebGLDevice2) {
          return await WebGLDevice2.create(props);
        }
        break;
      case "unknown":
        const UnknownDevice = devices.get("unknown");
        if (UnknownDevice) {
          return await UnknownDevice.create(props);
        }
        break;
      case "best-available":
        WebGPUDevice = devices.get("webgpu");
        if ((_a3 = WebGPUDevice == null ? void 0 : WebGPUDevice.isSupported) == null ? void 0 : _a3.call(WebGPUDevice)) {
          return await WebGPUDevice.create(props);
        }
        WebGLDevice2 = devices.get("webgl");
        if ((_b3 = WebGLDevice2 == null ? void 0 : WebGLDevice2.isSupported) == null ? void 0 : _b3.call(WebGLDevice2)) {
          return await WebGLDevice2.create(props);
        }
        break;
    }
    throw new Error("No matching device found. Ensure `@luma.gl/webgl` and/or `@luma.gl/webgpu` modules are imported.");
  }
  static enforceWebGL2(enforce = true) {
    const prototype2 = HTMLCanvasElement.prototype;
    if (!enforce && prototype2.originalGetContext) {
      prototype2.getContext = prototype2.originalGetContext;
      prototype2.originalGetContext = void 0;
      return;
    }
    prototype2.originalGetContext = prototype2.getContext;
    prototype2.getContext = function(contextId, options2) {
      if (contextId === "webgl" || contextId === "experimental-webgl") {
        return this.originalGetContext("webgl2", options2);
      }
      return this.originalGetContext(contextId, options2);
    };
  }
};
let luma = _luma;
__publicField2(luma, "defaultProps", {
  ...Device.defaultProps,
  type: "best-available",
  devices: void 0
});
/** Global stats for all devices */
__publicField2(luma, "stats", lumaStats);
/** Global log */
__publicField2(luma, "log", log);
function getDeviceMap(deviceClasses) {
  if (!deviceClasses || (deviceClasses == null ? void 0 : deviceClasses.length) === 0) {
    return null;
  }
  const map5 = /* @__PURE__ */ new Map();
  for (const deviceClass of deviceClasses) {
    map5.set(deviceClass.type, deviceClass);
  }
  return map5;
}
const isPage = isBrowser$4() && typeof document !== "undefined";
const isPageLoaded = () => isPage && document.readyState === "complete";
const DEFAULT_CANVAS_CONTEXT_PROPS = {
  canvas: null,
  width: 800,
  // width are height are only used by headless gl
  height: 600,
  useDevicePixels: true,
  autoResize: true,
  container: null,
  visible: true,
  colorSpace: "srgb",
  alphaMode: "opaque"
};
class CanvasContext {
  constructor(props) {
    __publicField2(this, "id");
    __publicField2(this, "props");
    __publicField2(this, "canvas");
    __publicField2(this, "htmlCanvas");
    __publicField2(this, "offscreenCanvas");
    __publicField2(this, "type");
    __publicField2(this, "width", 1);
    __publicField2(this, "height", 1);
    __publicField2(this, "resizeObserver");
    /** State used by luma.gl classes: TODO - move to canvasContext*/
    __publicField2(this, "_canvasSizeInfo", { clientWidth: 0, clientHeight: 0, devicePixelRatio: 1 });
    this.props = { ...DEFAULT_CANVAS_CONTEXT_PROPS, ...props };
    props = this.props;
    if (!isBrowser$4()) {
      this.id = "node-canvas-context";
      this.type = "node";
      this.width = this.props.width;
      this.height = this.props.height;
      this.canvas = null;
      return;
    }
    if (!props.canvas) {
      const canvas2 = createCanvas(props);
      const container = getContainer((props == null ? void 0 : props.container) || null);
      container.insertBefore(canvas2, container.firstChild);
      this.canvas = canvas2;
      if (!(props == null ? void 0 : props.visible)) {
        this.canvas.style.visibility = "hidden";
      }
    } else if (typeof props.canvas === "string") {
      this.canvas = getCanvasFromDOM(props.canvas);
    } else {
      this.canvas = props.canvas;
    }
    if (this.canvas instanceof HTMLCanvasElement) {
      this.id = this.canvas.id;
      this.type = "html-canvas";
      this.htmlCanvas = this.canvas;
    } else {
      this.id = "offscreen-canvas";
      this.type = "offscreen-canvas";
      this.offscreenCanvas = this.canvas;
    }
    if (this.canvas instanceof HTMLCanvasElement && props.autoResize) {
      this.resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === this.canvas) {
            this.update();
          }
        }
      });
      this.resizeObserver.observe(this.canvas);
    }
  }
  /** Check if the DOM is loaded */
  static get isPageLoaded() {
    return isPageLoaded();
  }
  /**
   * Returns the current DPR, if props.useDevicePixels is true
   * Device refers to physical
   */
  getDevicePixelRatio(useDevicePixels) {
    if (typeof OffscreenCanvas !== "undefined" && this.canvas instanceof OffscreenCanvas) {
      return 1;
    }
    useDevicePixels = useDevicePixels === void 0 ? this.props.useDevicePixels : useDevicePixels;
    if (!useDevicePixels || useDevicePixels <= 0) {
      return 1;
    }
    if (useDevicePixels === true) {
      const dpr = typeof window !== "undefined" && window.devicePixelRatio;
      return dpr || 1;
    }
    return useDevicePixels;
  }
  /**
   * Returns the size of drawing buffer in device pixels.
   * @note This can be different from the 'CSS' size of a canvas, and also from the
   * canvas' internal drawing buffer size (.width, .height).
   * This is the size required to cover the canvas, adjusted for DPR
   */
  getPixelSize() {
    switch (this.type) {
      case "node":
        return [this.width, this.height];
      case "offscreen-canvas":
        return [this.canvas.width, this.canvas.height];
      case "html-canvas":
        const dpr = this.getDevicePixelRatio();
        const canvas2 = this.canvas;
        return canvas2.parentElement ? [canvas2.clientWidth * dpr, canvas2.clientHeight * dpr] : [this.canvas.width, this.canvas.height];
      default:
        throw new Error(this.type);
    }
  }
  getAspect() {
    const [width, height] = this.getPixelSize();
    return width / height;
  }
  /**
   * Returns multiplier need to convert CSS size to Device size
   */
  cssToDeviceRatio() {
    try {
      const [drawingBufferWidth] = this.getDrawingBufferSize();
      const { clientWidth } = this._canvasSizeInfo;
      return clientWidth ? drawingBufferWidth / clientWidth : 1;
    } catch {
      return 1;
    }
  }
  /**
   * Maps CSS pixel position to device pixel position
   */
  cssToDevicePixels(cssPixel, yInvert = true) {
    const ratio = this.cssToDeviceRatio();
    const [width, height] = this.getDrawingBufferSize();
    return scalePixels(cssPixel, ratio, width, height, yInvert);
  }
  /**
   * Use devicePixelRatio to set canvas width and height
   * @note this is a raw port of luma.gl v8 code. Might be worth a review
   */
  setDevicePixelRatio(devicePixelRatio2, options2 = {}) {
    if (!this.htmlCanvas) {
      return;
    }
    let clientWidth = "width" in options2 ? options2.width : this.htmlCanvas.clientWidth;
    let clientHeight = "height" in options2 ? options2.height : this.htmlCanvas.clientHeight;
    if (!clientWidth || !clientHeight) {
      log.log(1, "Canvas clientWidth/clientHeight is 0")();
      devicePixelRatio2 = 1;
      clientWidth = this.htmlCanvas.width || 1;
      clientHeight = this.htmlCanvas.height || 1;
    }
    const cachedSize = this._canvasSizeInfo;
    if (cachedSize.clientWidth !== clientWidth || cachedSize.clientHeight !== clientHeight || cachedSize.devicePixelRatio !== devicePixelRatio2) {
      let clampedPixelRatio = devicePixelRatio2;
      const canvasWidth = Math.floor(clientWidth * clampedPixelRatio);
      const canvasHeight = Math.floor(clientHeight * clampedPixelRatio);
      this.htmlCanvas.width = canvasWidth;
      this.htmlCanvas.height = canvasHeight;
      const [drawingBufferWidth, drawingBufferHeight] = this.getDrawingBufferSize();
      if (drawingBufferWidth !== canvasWidth || drawingBufferHeight !== canvasHeight) {
        clampedPixelRatio = Math.min(drawingBufferWidth / clientWidth, drawingBufferHeight / clientHeight);
        this.htmlCanvas.width = Math.floor(clientWidth * clampedPixelRatio);
        this.htmlCanvas.height = Math.floor(clientHeight * clampedPixelRatio);
        log.warn("Device pixel ratio clamped")();
      }
      this._canvasSizeInfo.clientWidth = clientWidth;
      this._canvasSizeInfo.clientHeight = clientHeight;
      this._canvasSizeInfo.devicePixelRatio = devicePixelRatio2;
    }
  }
  // PRIVATE
  /** @todo Major hack done to port the CSS methods above, base canvas context should not depend on WebGL */
  getDrawingBufferSize() {
    const gl = this.device.gl;
    if (!gl) {
      throw new Error("canvas size");
    }
    return [gl.drawingBufferWidth, gl.drawingBufferHeight];
  }
  /**
   * Allows subclass constructor to override the canvas id for auto created canvases.
   * This can really help when debugging DOM in apps that create multiple devices
   */
  _setAutoCreatedCanvasId(id) {
    var _a3;
    if (((_a3 = this.htmlCanvas) == null ? void 0 : _a3.id) === "lumagl-auto-created-canvas") {
      this.htmlCanvas.id = id;
    }
  }
}
/**
 * Get a 'lazy' promise that resolves when the DOM is loaded.
 * @note Since there may be limitations on number of `load` event listeners,
 * it is recommended avoid calling this function until actually needed.
 * I.e. don't call it until you know that you will be looking up a string in the DOM.
 */
__publicField2(CanvasContext, "pageLoaded", getPageLoadPromise());
function getPageLoadPromise() {
  if (isPageLoaded() || typeof window === "undefined") {
    return Promise.resolve();
  }
  return new Promise((resolve2) => {
    window.addEventListener("load", () => resolve2());
  });
}
function getContainer(container) {
  if (typeof container === "string") {
    const element = document.getElementById(container);
    if (!element && !isPageLoaded()) {
      throw new Error(`Accessing '${container}' before page was loaded`);
    }
    if (!element) {
      throw new Error(`${container} is not an HTML element`);
    }
    return element;
  } else if (container) {
    return container;
  }
  return document.body;
}
function getCanvasFromDOM(canvasId) {
  const canvas2 = document.getElementById(canvasId);
  if (!canvas2 && !isPageLoaded()) {
    throw new Error(`Accessing '${canvasId}' before page was loaded`);
  }
  if (!(canvas2 instanceof HTMLCanvasElement)) {
    throw new Error("Object is not a canvas element");
  }
  return canvas2;
}
function createCanvas(props) {
  const { width, height } = props;
  const targetCanvas = document.createElement("canvas");
  targetCanvas.id = "lumagl-auto-created-canvas";
  targetCanvas.width = width || 1;
  targetCanvas.height = height || 1;
  targetCanvas.style.width = Number.isFinite(width) ? `${width}px` : "100%";
  targetCanvas.style.height = Number.isFinite(height) ? `${height}px` : "100%";
  return targetCanvas;
}
function scalePixels(pixel, ratio, width, height, yInvert) {
  const point4 = pixel;
  const x2 = scaleX(point4[0], ratio, width);
  let y2 = scaleY(point4[1], ratio, height, yInvert);
  let t2 = scaleX(point4[0] + 1, ratio, width);
  const xHigh = t2 === width - 1 ? t2 : t2 - 1;
  t2 = scaleY(point4[1] + 1, ratio, height, yInvert);
  let yHigh;
  if (yInvert) {
    t2 = t2 === 0 ? t2 : t2 + 1;
    yHigh = y2;
    y2 = t2;
  } else {
    yHigh = t2 === height - 1 ? t2 : t2 - 1;
  }
  return {
    x: x2,
    y: y2,
    // when ratio < 1, current css pixel and next css pixel may point to same device pixel, set width/height to 1 in those cases.
    width: Math.max(xHigh - x2 + 1, 1),
    height: Math.max(yHigh - y2 + 1, 1)
  };
}
function scaleX(x2, ratio, width) {
  const r2 = Math.min(Math.round(x2 * ratio), width - 1);
  return r2;
}
function scaleY(y2, ratio, height, yInvert) {
  return yInvert ? Math.max(0, height - 1 - Math.round(y2 * ratio)) : Math.min(Math.round(y2 * ratio), height - 1);
}
const _Texture = class extends Resource$1 {
  /** Do not use directly. Create with device.createTexture() */
  constructor(device, props, defaultProps2 = _Texture.defaultProps) {
    super(device, props, defaultProps2);
    /** dimension of this texture */
    __publicField2(this, "dimension");
    /** format of this texture */
    __publicField2(this, "format");
    /** width in pixels of this texture */
    __publicField2(this, "width");
    /** height in pixels of this texture */
    __publicField2(this, "height");
    /** depth of this texture */
    __publicField2(this, "depth");
    /** "Time" of last update. Monotonically increasing timestamp */
    __publicField2(this, "updateTimestamp");
    this.dimension = this.props.dimension;
    this.format = this.props.format;
    this.width = this.props.width;
    this.height = this.props.height;
    this.depth = this.props.depth;
    this.updateTimestamp = device.incrementTimestamp();
  }
  get [Symbol.toStringTag]() {
    return "Texture";
  }
};
let Texture = _Texture;
__publicField2(Texture, "defaultProps", {
  ...Resource$1.defaultProps,
  data: null,
  dimension: "2d",
  format: "rgba8unorm",
  width: void 0,
  height: void 0,
  depth: 1,
  mipmaps: true,
  // type: undefined,
  compressed: false,
  // mipLevels: 1,
  usage: 0,
  // usage: GPUTextureUsage.COPY_DST
  mipLevels: void 0,
  samples: void 0,
  type: void 0,
  sampler: {},
  view: void 0
});
__publicField2(Texture, "COPY_SRC", 1);
__publicField2(Texture, "COPY_DST", 2);
__publicField2(Texture, "TEXTURE_BINDING", 4);
__publicField2(Texture, "STORAGE_BINDING", 8);
__publicField2(Texture, "RENDER_ATTACHMENT", 16);
const _TextureView = class extends Resource$1 {
  get [Symbol.toStringTag]() {
    return "TextureView";
  }
  /** Should not be constructed directly. Use `texture.createView(props)` */
  constructor(device, props) {
    super(device, props, _TextureView.defaultProps);
  }
};
let TextureView = _TextureView;
__publicField2(TextureView, "defaultProps", {
  ...Resource$1.defaultProps,
  format: void 0,
  dimension: void 0,
  aspect: "all",
  baseMipLevel: 0,
  mipLevelCount: void 0,
  baseArrayLayer: 0,
  arrayLayerCount: void 0
});
function formatCompilerLog(shaderLog, source, options2) {
  let formattedLog = "";
  const lines = source.split(/\r?\n/);
  const log3 = shaderLog.slice().sort((a2, b2) => a2.lineNum - b2.lineNum);
  switch ((options2 == null ? void 0 : options2.showSourceCode) || "no") {
    case "all":
      let currentMessage = 0;
      for (let lineNum = 1; lineNum <= lines.length; lineNum++) {
        formattedLog += getNumberedLine(lines[lineNum - 1], lineNum, options2);
        while (log3.length > currentMessage && log3[currentMessage].lineNum === lineNum) {
          const message2 = log3[currentMessage++];
          formattedLog += formatCompilerMessage(message2, lines, message2.lineNum, {
            ...options2,
            inlineSource: false
          });
        }
      }
      return formattedLog;
    case "issues":
    case "no":
      for (const message2 of shaderLog) {
        formattedLog += formatCompilerMessage(message2, lines, message2.lineNum, {
          inlineSource: (options2 == null ? void 0 : options2.showSourceCode) !== "no"
        });
      }
      return formattedLog;
  }
}
function formatCompilerMessage(message2, lines, lineNum, options2) {
  if (options2 == null ? void 0 : options2.inlineSource) {
    const numberedLines = getNumberedLines(lines, lineNum);
    const positionIndicator = message2.linePos > 0 ? `${" ".repeat(message2.linePos + 5)}^^^
` : "";
    return `
${numberedLines}${positionIndicator}${message2.type.toUpperCase()}: ${message2.message}

`;
  }
  return (options2 == null ? void 0 : options2.html) ? `<div class='luma-compiler-log-error' style="color:red;"><b> ${message2.type.toUpperCase()}: ${message2.message}</b></div>` : `${message2.type.toUpperCase()}: ${message2.message}`;
}
function getNumberedLines(lines, lineNum, options2) {
  let numberedLines = "";
  for (let lineIndex = lineNum - 2; lineIndex <= lineNum; lineIndex++) {
    const sourceLine = lines[lineIndex - 1];
    if (sourceLine !== void 0) {
      numberedLines += getNumberedLine(sourceLine, lineNum, options2);
    }
  }
  return numberedLines;
}
function getNumberedLine(line, lineNum, options2) {
  const escapedLine = (options2 == null ? void 0 : options2.html) ? escapeHTML(line) : line;
  return `${padLeft(String(lineNum), 4)}: ${escapedLine}${(options2 == null ? void 0 : options2.html) ? "<br/>" : "\n"}`;
}
function padLeft(string3, paddedLength) {
  let result = "";
  for (let i2 = string3.length; i2 < paddedLength; ++i2) {
    result += " ";
  }
  return result + string3;
}
function escapeHTML(unsafe) {
  return unsafe.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;").replaceAll("'", "&#039;");
}
function getShaderInfo(source, defaultName) {
  return {
    name: getShaderName(source, defaultName),
    language: "glsl",
    version: getShaderVersion(source)
  };
}
function getShaderName(shader, defaultName = "unnamed") {
  const SHADER_NAME_REGEXP = /#define[\s*]SHADER_NAME[\s*]([A-Za-z0-9_-]+)[\s*]/;
  const match2 = SHADER_NAME_REGEXP.exec(shader);
  return match2 ? match2[1] : defaultName;
}
function getShaderVersion(source) {
  let version2 = 100;
  const words = source.match(/[^\s]+/g);
  if (words && words.length >= 2 && words[0] === "#version") {
    const v5 = parseInt(words[1], 10);
    if (Number.isFinite(v5)) {
      version2 = v5;
    }
  }
  return version2;
}
const _Shader = class extends Resource$1 {
  /** Create a new Shader instance */
  constructor(device, props) {
    super(device, { id: getShaderIdFromProps(props), ...props }, _Shader.defaultProps);
    /** The stage of this shader */
    __publicField2(this, "stage");
    /** The source code of this shader */
    __publicField2(this, "source");
    /** The compilation status of the shader. 'pending' if compilation is asynchronous, and on production */
    __publicField2(this, "compilationStatus", "pending");
    this.stage = this.props.stage;
    this.source = this.props.source;
  }
  get [Symbol.toStringTag]() {
    return "Shader";
  }
  /** Get compiler log synchronously (WebGL only) */
  getCompilationInfoSync() {
    return null;
  }
  /** Get translated shader source in host platform's native language (HLSL, GLSL, and even GLSL ES), if available */
  getTranslatedSource() {
    return null;
  }
  // PORTABLE HELPERS
  /** In browser logging of errors */
  async debugShader(trigger2 = this.props.debug) {
    switch (trigger2) {
      case "never":
        return;
      case "errors":
        if (this.compilationStatus === "success") {
          return;
        }
        break;
    }
    const messages = await this.getCompilationInfo();
    if (this.props.debug === "warnings" && (messages == null ? void 0 : messages.length) === 0) {
      return;
    }
    this._displayShaderLog(messages);
  }
  // PRIVATE
  /** In-browser UI logging of errors */
  _displayShaderLog(messages) {
    var _a3;
    if (typeof document === "undefined" || !(document == null ? void 0 : document.createElement)) {
      return;
    }
    const shaderName = getShaderInfo(this.source).name;
    const shaderTitle = `${this.stage} ${shaderName}`;
    let htmlLog = formatCompilerLog(messages, this.source, { showSourceCode: "all", html: true });
    const translatedSource = this.getTranslatedSource();
    if (translatedSource) {
      htmlLog += `<br /><br /><h1>Translated Source</h1><br /><br /><code style="user-select:text;"><pre>${translatedSource}</pre></code>`;
    }
    const button = document.createElement("Button");
    button.innerHTML = `
<h1>Shader Compilation Error in ${shaderTitle}</h1><br /><br />
<code style="user-select:text;"><pre>
${htmlLog}
</pre></code>`;
    button.style.top = "10px";
    button.style.left = "10px";
    button.style.position = "absolute";
    button.style.zIndex = "9999";
    button.style.width = "100%";
    button.style.textAlign = "left";
    document.body.appendChild(button);
    const errors = document.getElementsByClassName("luma-compiler-log-error");
    if ((_a3 = errors[0]) == null ? void 0 : _a3.scrollIntoView) {
      errors[0].scrollIntoView();
    }
    button.onclick = () => {
      const dataURI = `data:text/plain,${encodeURIComponent(this.source)}`;
      navigator.clipboard.writeText(dataURI);
    };
  }
};
let Shader = _Shader;
__publicField2(Shader, "defaultProps", {
  ...Resource$1.defaultProps,
  language: "auto",
  stage: void 0,
  source: "",
  sourceMap: null,
  entryPoint: "main",
  debug: "errors"
});
function getShaderIdFromProps(props) {
  return getShaderInfo(props.source).name || props.id || uid(`unnamed ${props.stage}-shader`);
}
const _Sampler = class extends Resource$1 {
  get [Symbol.toStringTag]() {
    return "Sampler";
  }
  constructor(device, props) {
    super(device, props, _Sampler.defaultProps);
  }
};
let Sampler = _Sampler;
__publicField2(Sampler, "defaultProps", {
  ...Resource$1.defaultProps,
  type: "color-sampler",
  addressModeU: "clamp-to-edge",
  addressModeV: "clamp-to-edge",
  addressModeW: "clamp-to-edge",
  magFilter: "nearest",
  minFilter: "nearest",
  mipmapFilter: "nearest",
  lodMinClamp: 0,
  lodMaxClamp: 32,
  // Per WebGPU spec
  compare: "less-equal",
  maxAnisotropy: 1
});
const _Framebuffer = class extends Resource$1 {
  constructor(device, props = {}) {
    super(device, props, _Framebuffer.defaultProps);
    /** Width of all attachments in this framebuffer */
    __publicField2(this, "width");
    /** Height of all attachments in this framebuffer */
    __publicField2(this, "height");
    /** Color attachments */
    __publicField2(this, "colorAttachments", []);
    /** Depth-stencil attachment, if provided */
    __publicField2(this, "depthStencilAttachment", null);
    this.width = this.props.width;
    this.height = this.props.height;
  }
  get [Symbol.toStringTag]() {
    return "Framebuffer";
  }
  resize(size12) {
    let updateSize = !size12;
    if (size12) {
      const [width, height] = Array.isArray(size12) ? size12 : [size12.width, size12.height];
      updateSize = updateSize || height !== this.height || width !== this.width;
      this.width = width;
      this.height = height;
    }
    if (updateSize) {
      log.log(2, `Resizing framebuffer ${this.id} to ${this.width}x${this.height}`)();
      this.resizeAttachments(this.width, this.height);
    }
  }
  /** Auto creates any textures */
  autoCreateAttachmentTextures() {
    if (this.props.colorAttachments.length === 0 && !this.props.depthStencilAttachment) {
      throw new Error("Framebuffer has noattachments");
    }
    this.colorAttachments = this.props.colorAttachments.map((attachment2) => {
      if (typeof attachment2 === "string") {
        const texture = this.createColorTexture(attachment2);
        this.attachResource(texture);
        return texture.view;
      }
      if (attachment2 instanceof Texture) {
        return attachment2.view;
      }
      return attachment2;
    });
    const attachment = this.props.depthStencilAttachment;
    if (attachment) {
      if (typeof attachment === "string") {
        const texture = this.createDepthStencilTexture(attachment);
        this.attachResource(texture);
        this.depthStencilAttachment = texture.view;
      } else if (attachment instanceof Texture) {
        this.depthStencilAttachment = attachment.view;
      } else {
        this.depthStencilAttachment = attachment;
      }
    }
  }
  /** Create a color texture */
  createColorTexture(format) {
    return this.device.createTexture({
      id: "color-attachment",
      usage: Texture.RENDER_ATTACHMENT,
      format,
      width: this.width,
      height: this.height
    });
  }
  /** Create depth stencil texture */
  createDepthStencilTexture(format) {
    return this.device.createTexture({
      id: "depth-stencil-attachment",
      usage: Texture.RENDER_ATTACHMENT,
      format,
      width: this.width,
      height: this.height
    });
  }
  /**
   * Default implementation of resize
   * Creates new textures with correct size for all attachments.
   * and destroys existing textures if owned
   */
  resizeAttachments(width, height) {
    for (let i2 = 0; i2 < this.colorAttachments.length; ++i2) {
      if (this.colorAttachments[i2]) {
        const resizedTexture = this.device._createTexture({
          ...this.colorAttachments[i2].props,
          width,
          height
        });
        this.destroyAttachedResource(this.colorAttachments[i2]);
        this.colorAttachments[i2] = resizedTexture.view;
        this.attachResource(resizedTexture.view);
      }
    }
    if (this.depthStencilAttachment) {
      const resizedTexture = this.device._createTexture({
        ...this.depthStencilAttachment.props,
        width,
        height
      });
      this.destroyAttachedResource(this.depthStencilAttachment);
      this.depthStencilAttachment = resizedTexture.view;
      this.attachResource(resizedTexture);
    }
  }
};
let Framebuffer = _Framebuffer;
__publicField2(Framebuffer, "defaultProps", {
  ...Resource$1.defaultProps,
  width: 1,
  height: 1,
  colorAttachments: [],
  // ['rgba8unorm'],
  depthStencilAttachment: null
  // 'depth24plus-stencil8'
});
const _RenderPipeline = class extends Resource$1 {
  constructor(device, props) {
    super(device, props, _RenderPipeline.defaultProps);
    /** The merged layout */
    __publicField2(this, "shaderLayout");
    /** Buffer map describing buffer interleaving etc */
    __publicField2(this, "bufferLayout");
    /** The linking status of the pipeline. 'pending' if linking is asynchronous, and on production */
    __publicField2(this, "linkStatus", "pending");
    /** The hash of the pipeline */
    __publicField2(this, "hash", "");
    this.shaderLayout = this.props.shaderLayout;
    this.bufferLayout = this.props.bufferLayout || [];
  }
  get [Symbol.toStringTag]() {
    return "RenderPipeline";
  }
  // DEPRECATED METHODS
  /**
   * Uniforms
   * @deprecated Use uniforms buffers
   * @note textures, samplers and uniform buffers should be set via `setBindings()`, these are not considered uniforms.
   * @note In WebGL uniforms have a performance penalty, they are reset before each call to enable pipeline sharing.
   */
  setUniformsWebGL(uniforms) {
    throw new Error("Use uniform blocks");
  }
};
let RenderPipeline = _RenderPipeline;
__publicField2(RenderPipeline, "defaultProps", {
  ...Resource$1.defaultProps,
  vs: null,
  vertexEntryPoint: "vertexMain",
  vsConstants: {},
  fs: null,
  fragmentEntryPoint: "fragmentMain",
  fsConstants: {},
  shaderLayout: null,
  bufferLayout: [],
  topology: "triangle-list",
  parameters: {},
  // isInstanced: false,
  // instanceCount: 0,
  // vertexCount: 0,
  bindings: {},
  uniforms: {}
});
const _RenderPass = class extends Resource$1 {
  get [Symbol.toStringTag]() {
    return "RenderPass";
  }
  constructor(device, props) {
    super(device, props, _RenderPass.defaultProps);
  }
};
let RenderPass = _RenderPass;
/** Default properties for RenderPass */
__publicField2(RenderPass, "defaultProps", {
  ...Resource$1.defaultProps,
  framebuffer: null,
  parameters: void 0,
  clearColor: [0, 0, 0, 0],
  clearDepth: 1,
  clearStencil: 0,
  depthReadOnly: false,
  stencilReadOnly: false,
  discard: false,
  occlusionQuerySet: void 0,
  timestampQuerySet: void 0,
  beginTimestampIndex: void 0,
  endTimestampIndex: void 0
});
const _ComputePipeline = class extends Resource$1 {
  constructor(device, props) {
    super(device, props, _ComputePipeline.defaultProps);
    __publicField2(this, "hash", "");
  }
  get [Symbol.toStringTag]() {
    return "ComputePipeline";
  }
};
let ComputePipeline = _ComputePipeline;
__publicField2(ComputePipeline, "defaultProps", {
  ...Resource$1.defaultProps,
  shader: void 0,
  entryPoint: void 0,
  constants: {},
  shaderLayout: void 0
});
const _CommandEncoder = class extends Resource$1 {
  get [Symbol.toStringTag]() {
    return "CommandEncoder";
  }
  constructor(device, props) {
    super(device, props, _CommandEncoder.defaultProps);
  }
};
let CommandEncoder = _CommandEncoder;
__publicField2(CommandEncoder, "defaultProps", {
  ...Resource$1.defaultProps,
  measureExecutionTime: void 0
});
const _CommandBuffer = class extends Resource$1 {
  get [Symbol.toStringTag]() {
    return "CommandBuffer";
  }
  constructor(device, props) {
    super(device, props, _CommandBuffer.defaultProps);
  }
};
let CommandBuffer = _CommandBuffer;
__publicField2(CommandBuffer, "defaultProps", {
  ...Resource$1.defaultProps
});
function decodeShaderAttributeType(attributeType) {
  const [dataType, components] = TYPE_INFO[attributeType];
  const integer = dataType === "i32" || dataType === "u32";
  const signed = dataType !== "u32";
  const byteLength = TYPE_SIZES$1[dataType] * components;
  const defaultVertexFormat = getCompatibleVertexFormat(dataType, components);
  return {
    dataType,
    components,
    defaultVertexFormat,
    byteLength,
    integer,
    signed
  };
}
function getCompatibleVertexFormat(dataType, components) {
  let vertexType;
  switch (dataType) {
    case "f32":
      vertexType = "float32";
      break;
    case "i32":
      vertexType = "sint32";
      break;
    case "u32":
      vertexType = "uint32";
      break;
    case "f16":
      return components <= 2 ? "float16x2" : "float16x4";
  }
  if (components === 1) {
    return vertexType;
  }
  return `${vertexType}x${components}`;
}
const TYPE_INFO = {
  f32: ["f32", 1],
  "vec2<f32>": ["f32", 2],
  "vec3<f32>": ["f32", 3],
  "vec4<f32>": ["f32", 4],
  f16: ["f16", 1],
  "vec2<f16>": ["f16", 2],
  "vec3<f16>": ["f16", 3],
  "vec4<f16>": ["f16", 4],
  i32: ["i32", 1],
  "vec2<i32>": ["i32", 2],
  "vec3<i32>": ["i32", 3],
  "vec4<i32>": ["i32", 4],
  u32: ["u32", 1],
  "vec2<u32>": ["u32", 2],
  "vec3<u32>": ["u32", 3],
  "vec4<u32>": ["u32", 4]
};
const TYPE_SIZES$1 = {
  f32: 4,
  f16: 2,
  i32: 4,
  u32: 4
  // 'bool-webgl': 4,
};
function decodeVertexFormat(format) {
  let webglOnly;
  if (format.endsWith("-webgl")) {
    format.replace("-webgl", "");
    webglOnly = true;
  }
  const [type_, count3] = format.split("x");
  const type = type_;
  const components = count3 ? parseInt(count3) : 1;
  const decodedType = decodeVertexType(type);
  const result = {
    type,
    components,
    byteLength: decodedType.byteLength * components,
    integer: decodedType.integer,
    signed: decodedType.signed,
    normalized: decodedType.normalized
  };
  if (webglOnly) {
    result.webglOnly = true;
  }
  return result;
}
function getAttributeInfosFromLayouts(shaderLayout, bufferLayout) {
  const attributeInfos = {};
  for (const attribute of shaderLayout.attributes) {
    attributeInfos[attribute.name] = getAttributeInfoFromLayouts(shaderLayout, bufferLayout, attribute.name);
  }
  return attributeInfos;
}
function getAttributeInfosByLocation(shaderLayout, bufferLayout, maxVertexAttributes = 16) {
  const attributeInfos = getAttributeInfosFromLayouts(shaderLayout, bufferLayout);
  const locationInfos = new Array(maxVertexAttributes).fill(null);
  for (const attributeInfo of Object.values(attributeInfos)) {
    locationInfos[attributeInfo.location] = attributeInfo;
  }
  return locationInfos;
}
function getAttributeInfoFromLayouts(shaderLayout, bufferLayout, name2) {
  const shaderDeclaration = getAttributeFromShaderLayout(shaderLayout, name2);
  const bufferMapping = getAttributeFromBufferLayout(bufferLayout, name2);
  if (!shaderDeclaration) {
    return null;
  }
  const attributeTypeInfo = decodeShaderAttributeType(shaderDeclaration.type);
  const vertexFormat = (bufferMapping == null ? void 0 : bufferMapping.vertexFormat) || attributeTypeInfo.defaultVertexFormat;
  const vertexFormatInfo = decodeVertexFormat(vertexFormat);
  return {
    attributeName: (bufferMapping == null ? void 0 : bufferMapping.attributeName) || shaderDeclaration.name,
    bufferName: (bufferMapping == null ? void 0 : bufferMapping.bufferName) || shaderDeclaration.name,
    location: shaderDeclaration.location,
    shaderType: shaderDeclaration.type,
    shaderDataType: attributeTypeInfo.dataType,
    shaderComponents: attributeTypeInfo.components,
    vertexFormat,
    bufferDataType: vertexFormatInfo.type,
    bufferComponents: vertexFormatInfo.components,
    // normalized is a property of the buffer's vertex format
    normalized: vertexFormatInfo.normalized,
    // integer is a property of the shader declaration
    integer: attributeTypeInfo.integer,
    stepMode: (bufferMapping == null ? void 0 : bufferMapping.stepMode) || shaderDeclaration.stepMode,
    byteOffset: (bufferMapping == null ? void 0 : bufferMapping.byteOffset) || 0,
    byteStride: (bufferMapping == null ? void 0 : bufferMapping.byteStride) || 0
  };
}
function getAttributeFromShaderLayout(shaderLayout, name2) {
  const attribute = shaderLayout.attributes.find((attr2) => attr2.name === name2);
  if (!attribute) {
    log.warn(`shader layout attribute "${name2}" not present in shader`);
  }
  return attribute || null;
}
function getAttributeFromBufferLayout(bufferLayouts, name2) {
  checkBufferLayouts(bufferLayouts);
  let bufferLayoutInfo = getAttributeFromShortHand(bufferLayouts, name2);
  if (bufferLayoutInfo) {
    return bufferLayoutInfo;
  }
  bufferLayoutInfo = getAttributeFromAttributesList(bufferLayouts, name2);
  if (bufferLayoutInfo) {
    return bufferLayoutInfo;
  }
  log.warn(`layout for attribute "${name2}" not present in buffer layout`);
  return null;
}
function checkBufferLayouts(bufferLayouts) {
  for (const bufferLayout of bufferLayouts) {
    if (bufferLayout.attributes && bufferLayout.format || !bufferLayout.attributes && !bufferLayout.format) {
      log.warn(`BufferLayout ${name} must have either 'attributes' or 'format' field`);
    }
  }
}
function getAttributeFromShortHand(bufferLayouts, name2) {
  for (const bufferLayout of bufferLayouts) {
    if (bufferLayout.format && bufferLayout.name === name2) {
      return {
        attributeName: bufferLayout.name,
        bufferName: name2,
        stepMode: bufferLayout.stepMode,
        vertexFormat: bufferLayout.format,
        // If offset is needed, use `attributes` field.
        byteOffset: 0,
        byteStride: bufferLayout.byteStride || 0
      };
    }
  }
  return null;
}
function getAttributeFromAttributesList(bufferLayouts, name2) {
  var _a3;
  for (const bufferLayout of bufferLayouts) {
    let byteStride = bufferLayout.byteStride;
    if (typeof bufferLayout.byteStride !== "number") {
      for (const attributeMapping2 of bufferLayout.attributes || []) {
        const info = decodeVertexFormat(attributeMapping2.format);
        byteStride += info.byteLength;
      }
    }
    const attributeMapping = (_a3 = bufferLayout.attributes) == null ? void 0 : _a3.find((mapping) => mapping.attribute === name2);
    if (attributeMapping) {
      return {
        attributeName: attributeMapping.attribute,
        bufferName: bufferLayout.name,
        stepMode: bufferLayout.stepMode,
        vertexFormat: attributeMapping.format,
        byteOffset: attributeMapping.byteOffset,
        byteStride
      };
    }
  }
  return null;
}
function mergeShaderLayout(baseLayout, overrideLayout) {
  const mergedLayout = {
    ...baseLayout,
    attributes: baseLayout.attributes.map((attribute) => ({ ...attribute }))
  };
  for (const attribute of (overrideLayout == null ? void 0 : overrideLayout.attributes) || []) {
    const baseAttribute = mergedLayout.attributes.find((attr2) => attr2.name === attribute.name);
    if (!baseAttribute) {
      log.warn(`shader layout attribute ${attribute.name} not present in shader`);
    } else {
      baseAttribute.type = attribute.type || baseAttribute.type;
      baseAttribute.stepMode = attribute.stepMode || baseAttribute.stepMode;
    }
  }
  return mergedLayout;
}
const _VertexArray = class extends Resource$1 {
  constructor(device, props) {
    super(device, props, _VertexArray.defaultProps);
    /** Max number of vertex attributes */
    __publicField2(this, "maxVertexAttributes");
    /** Attribute infos indexed by location - TODO only needed by webgl module? */
    __publicField2(this, "attributeInfos");
    /** Index buffer */
    __publicField2(this, "indexBuffer", null);
    /** Attributes indexed by buffer slot */
    __publicField2(this, "attributes");
    this.maxVertexAttributes = device.limits.maxVertexAttributes;
    this.attributes = new Array(this.maxVertexAttributes).fill(null);
    this.attributeInfos = getAttributeInfosByLocation(props.renderPipeline.shaderLayout, props.renderPipeline.bufferLayout, this.maxVertexAttributes);
  }
  get [Symbol.toStringTag]() {
    return "VertexArray";
  }
  // DEPRECATED METHODS
  /** @deprecated Set constant attributes (WebGL only) */
  setConstantWebGL(location2, value) {
    throw new Error("constant attributes not supported");
  }
};
let VertexArray = _VertexArray;
__publicField2(VertexArray, "defaultProps", {
  ...Resource$1.defaultProps,
  renderPipeline: null
});
const _TransformFeedback = class extends Resource$1 {
  get [Symbol.toStringTag]() {
    return "TransformFeedback";
  }
  constructor(device, props) {
    super(device, props, _TransformFeedback.defaultProps);
  }
};
let TransformFeedback = _TransformFeedback;
__publicField2(TransformFeedback, "defaultProps", {
  ...Resource$1.defaultProps,
  layout: void 0,
  buffers: {}
});
const _QuerySet = class extends Resource$1 {
  get [Symbol.toStringTag]() {
    return "QuerySet";
  }
  constructor(device, props) {
    super(device, props, _QuerySet.defaultProps);
  }
};
let QuerySet = _QuerySet;
__publicField2(QuerySet, "defaultProps", {
  ...Resource$1.defaultProps,
  type: void 0,
  count: void 0
});
const UNIFORM_FORMATS = {
  f32: { type: "f32", components: 1 },
  i32: { type: "i32", components: 1 },
  u32: { type: "u32", components: 1 },
  // 'bool-webgl': {type: 'bool-webgl', components: 1},
  "vec2<f32>": { type: "f32", components: 2 },
  "vec3<f32>": { type: "f32", components: 3 },
  "vec4<f32>": { type: "f32", components: 4 },
  "vec2<i32>": { type: "i32", components: 2 },
  "vec3<i32>": { type: "i32", components: 3 },
  "vec4<i32>": { type: "i32", components: 4 },
  "vec2<u32>": { type: "u32", components: 2 },
  "vec3<u32>": { type: "u32", components: 3 },
  "vec4<u32>": { type: "u32", components: 4 },
  "mat2x2<f32>": { type: "f32", components: 4 },
  "mat2x3<f32>": { type: "f32", components: 6 },
  "mat2x4<f32>": { type: "f32", components: 8 },
  "mat3x2<f32>": { type: "f32", components: 6 },
  "mat3x3<f32>": { type: "f32", components: 9 },
  "mat3x4<f32>": { type: "f32", components: 12 },
  "mat4x2<f32>": { type: "f32", components: 8 },
  "mat4x3<f32>": { type: "f32", components: 12 },
  "mat4x4<f32>": { type: "f32", components: 16 }
};
function decodeShaderUniformType(format) {
  const decoded = UNIFORM_FORMATS[format];
  assert$a(format);
  return decoded;
}
function alignTo(size12, count3) {
  switch (count3) {
    case 1:
      return size12;
    case 2:
      return size12 + size12 % 2;
    default:
      return size12 + (4 - size12 % 4) % 4;
  }
}
let arrayBuffer;
function getScratchArrayBuffer(byteLength) {
  if (!arrayBuffer || arrayBuffer.byteLength < byteLength) {
    arrayBuffer = new ArrayBuffer(byteLength);
  }
  return arrayBuffer;
}
function getScratchArray(Type3, length2) {
  const scratchArrayBuffer = getScratchArrayBuffer(Type3.BYTES_PER_ELEMENT * length2);
  return new Type3(scratchArrayBuffer, 0, length2);
}
function fillArray$1(options2) {
  const { target, source, start: start2 = 0, count: count3 = 1 } = options2;
  const length2 = source.length;
  const total = count3 * length2;
  let copied = 0;
  for (let i2 = start2; copied < length2; copied++) {
    target[i2++] = source[copied];
  }
  while (copied < total) {
    if (copied < total - copied) {
      target.copyWithin(start2 + copied, start2, start2 + copied);
      copied *= 2;
    } else {
      target.copyWithin(start2 + copied, start2, start2 + total - copied);
      copied = total;
    }
  }
  return options2.target;
}
const minBufferSize = 1024;
class UniformBufferLayout {
  /** Create a new UniformBufferLayout given a map of attributes. */
  constructor(uniformTypes) {
    __publicField2(this, "layout", {});
    /** number of bytes needed for buffer allocation */
    __publicField2(this, "byteLength");
    let size12 = 0;
    for (const [key, uniformType] of Object.entries(uniformTypes)) {
      const typeAndComponents = decodeShaderUniformType(uniformType);
      const { type, components: count3 } = typeAndComponents;
      size12 = alignTo(size12, count3);
      const offset = size12;
      size12 += count3;
      this.layout[key] = { type, size: count3, offset };
    }
    size12 += (4 - size12 % 4) % 4;
    const actualByteLength = size12 * 4;
    this.byteLength = Math.max(actualByteLength, minBufferSize);
  }
  /** Get the data for the complete buffer */
  getData(uniformValues) {
    const bufferSize = Math.max(this.byteLength, minBufferSize);
    const arrayBuffer2 = getScratchArrayBuffer(bufferSize);
    const typedArrays = {
      i32: new Int32Array(arrayBuffer2),
      u32: new Uint32Array(arrayBuffer2),
      f32: new Float32Array(arrayBuffer2),
      // TODO not implemented
      f16: new Uint16Array(arrayBuffer2)
    };
    for (const [name2, value] of Object.entries(uniformValues)) {
      const uniformLayout = this.layout[name2];
      if (!uniformLayout) {
        log.warn(`Supplied uniform value ${name2} not present in uniform block layout`)();
        continue;
      }
      const { type, size: size12, offset } = uniformLayout;
      const typedArray = typedArrays[type];
      if (size12 === 1) {
        if (typeof value !== "number" && typeof value !== "boolean") {
          log.warn(`Supplied value for single component uniform ${name2} is not a number: ${value}`)();
          continue;
        }
        typedArray[offset] = Number(value);
      } else {
        const numericArray = isNumberArray(value);
        if (!numericArray) {
          log.warn(`Supplied value for multi component / array uniform ${name2} is not a numeric array: ${value}`)();
          continue;
        }
        typedArray.set(numericArray, offset);
      }
    }
    return new Uint8Array(arrayBuffer2);
  }
  /** Does this layout have a field with specified name */
  has(name2) {
    return Boolean(this.layout[name2]);
  }
  /** Get offset and size for a field with specified name */
  get(name2) {
    const layout = this.layout[name2];
    return layout;
  }
}
function arrayEqual(a2, b2, limit = 16) {
  if (a2 !== b2) {
    return false;
  }
  const arrayA = isNumberArray(a2);
  if (!arrayA) {
    return false;
  }
  const arrayB = isNumberArray(b2);
  if (arrayB && arrayA.length === arrayB.length) {
    for (let i2 = 0; i2 < arrayA.length; ++i2) {
      if (arrayB[i2] !== arrayA[i2]) {
        return false;
      }
    }
  }
  return true;
}
function arrayCopy(a2) {
  const numberArray = isNumberArray(a2);
  if (numberArray) {
    return numberArray.slice();
  }
  return a2;
}
class UniformBlock {
  constructor(props) {
    __publicField2(this, "name");
    __publicField2(this, "uniforms", {});
    __publicField2(this, "modifiedUniforms", {});
    __publicField2(this, "modified", true);
    __publicField2(this, "bindingLayout", {});
    __publicField2(this, "needsRedraw", "initialized");
    var _a3;
    this.name = props == null ? void 0 : props.name;
    if ((props == null ? void 0 : props.name) && (props == null ? void 0 : props.shaderLayout)) {
      const binding = (_a3 = props == null ? void 0 : props.shaderLayout.bindings) == null ? void 0 : _a3.find((binding2) => binding2.type === "uniform" && binding2.name === (props == null ? void 0 : props.name));
      if (!binding) {
        throw new Error(props == null ? void 0 : props.name);
      }
      const uniformBlock = binding;
      for (const uniform of uniformBlock.uniforms || []) {
        this.bindingLayout[uniform.name] = uniform;
      }
    }
  }
  /** Set a map of uniforms */
  setUniforms(uniforms) {
    for (const [key, value] of Object.entries(uniforms)) {
      this._setUniform(key, value);
      if (!this.needsRedraw) {
        this.setNeedsRedraw(`${this.name}.${key}=${value}`);
      }
    }
  }
  setNeedsRedraw(reason) {
    this.needsRedraw = this.needsRedraw || reason;
  }
  /** Returns all uniforms */
  getAllUniforms() {
    this.modifiedUniforms = {};
    this.needsRedraw = false;
    return this.uniforms || {};
  }
  /** Set a single uniform */
  _setUniform(key, value) {
    if (arrayEqual(this.uniforms[key], value)) {
      return;
    }
    this.uniforms[key] = arrayCopy(value);
    this.modifiedUniforms[key] = true;
    this.modified = true;
  }
}
class UniformStore {
  /**
   * Create a new UniformStore instance
   * @param blocks
   */
  constructor(blocks) {
    /** Stores the uniform values for each uniform block */
    __publicField2(this, "uniformBlocks", /* @__PURE__ */ new Map());
    /** Can generate data for a uniform buffer for each block from data */
    __publicField2(this, "uniformBufferLayouts", /* @__PURE__ */ new Map());
    /** Actual buffer for the blocks */
    __publicField2(this, "uniformBuffers", /* @__PURE__ */ new Map());
    for (const [bufferName, block] of Object.entries(blocks)) {
      const uniformBufferName = bufferName;
      const uniformBufferLayout = new UniformBufferLayout(block.uniformTypes || {});
      this.uniformBufferLayouts.set(uniformBufferName, uniformBufferLayout);
      const uniformBlock = new UniformBlock({ name: bufferName });
      uniformBlock.setUniforms(block.defaultUniforms || {});
      this.uniformBlocks.set(uniformBufferName, uniformBlock);
    }
  }
  /** Destroy any managed uniform buffers */
  destroy() {
    for (const uniformBuffer of this.uniformBuffers.values()) {
      uniformBuffer.destroy();
    }
  }
  /**
   * Set uniforms
   * Makes all properties partial
   */
  setUniforms(uniforms) {
    for (const [blockName, uniformValues] of Object.entries(uniforms)) {
      this.uniformBlocks.get(blockName).setUniforms(uniformValues);
    }
    this.updateUniformBuffers();
  }
  /** Get the required minimum length of the uniform buffer */
  getUniformBufferByteLength(uniformBufferName) {
    return this.uniformBufferLayouts.get(uniformBufferName).byteLength;
  }
  /** Get formatted binary memory that can be uploaded to a buffer */
  getUniformBufferData(uniformBufferName) {
    const uniformValues = this.uniformBlocks.get(uniformBufferName).getAllUniforms();
    return this.uniformBufferLayouts.get(uniformBufferName).getData(uniformValues);
  }
  /**
   * Creates an unmanaged uniform buffer (umnanaged means that application is responsible for destroying it)
   * The new buffer is initialized with current / supplied values
   */
  createUniformBuffer(device, uniformBufferName, uniforms) {
    if (uniforms) {
      this.setUniforms(uniforms);
    }
    const byteLength = this.getUniformBufferByteLength(uniformBufferName);
    const uniformBuffer = device.createBuffer({
      usage: Buffer$1.UNIFORM | Buffer$1.COPY_DST,
      byteLength
    });
    const uniformBufferData = this.getUniformBufferData(uniformBufferName);
    uniformBuffer.write(uniformBufferData);
    return uniformBuffer;
  }
  /** Get the managed uniform buffer. "managed" resources are destroyed when the uniformStore is destroyed. */
  getManagedUniformBuffer(device, uniformBufferName) {
    if (!this.uniformBuffers.get(uniformBufferName)) {
      const byteLength = this.getUniformBufferByteLength(uniformBufferName);
      const uniformBuffer = device.createBuffer({
        usage: Buffer$1.UNIFORM | Buffer$1.COPY_DST,
        byteLength
      });
      this.uniformBuffers.set(uniformBufferName, uniformBuffer);
    }
    return this.uniformBuffers.get(uniformBufferName);
  }
  /** Updates all uniform buffers where values have changed */
  updateUniformBuffers() {
    let reason = false;
    for (const uniformBufferName of this.uniformBlocks.keys()) {
      const bufferReason = this.updateUniformBuffer(uniformBufferName);
      reason || (reason = bufferReason);
    }
    if (reason) {
      log.log(3, `UniformStore.updateUniformBuffers(): ${reason}`)();
    }
    return reason;
  }
  /** Update one uniform buffer. Only updates if values have changed */
  updateUniformBuffer(uniformBufferName) {
    const uniformBlock = this.uniformBlocks.get(uniformBufferName);
    const uniformBuffer = this.uniformBuffers.get(uniformBufferName);
    let reason = false;
    if (uniformBuffer && uniformBlock.needsRedraw) {
      reason || (reason = uniformBlock.needsRedraw);
      const uniformBufferData = this.getUniformBufferData(uniformBufferName);
      const uniformBuffer2 = this.uniformBuffers.get(uniformBufferName);
      uniformBuffer2.write(uniformBufferData);
      const uniformValues = this.uniformBlocks.get(uniformBufferName).getAllUniforms();
      log.log(4, `Writing to uniform buffer ${String(uniformBufferName)}`, uniformBufferData, uniformValues)();
    }
    return reason;
  }
}
function getDataTypeFromTypedArray$1(arrayOrType) {
  const type = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
  switch (type) {
    case Float32Array:
      return "float32";
    case Uint16Array:
      return "uint16";
    case Uint32Array:
      return "uint32";
    case Uint8Array:
    case Uint8ClampedArray:
      return "uint8";
    case Int8Array:
      return "sint8";
    case Int16Array:
      return "sint16";
    case Int32Array:
      return "sint32";
    default:
      throw new Error(type.constructor.name);
  }
}
function getTypedArrayFromDataType(dataType) {
  switch (dataType) {
    case "float32":
      return Float32Array;
    case "uint32":
      return Uint32Array;
    case "sint32":
      return Int32Array;
    case "uint16":
    case "unorm16":
      return Uint16Array;
    case "sint16":
    case "snorm16":
      return Int16Array;
    case "uint8":
    case "unorm8":
      return Uint8Array;
    case "sint8":
    case "snorm8":
      return Int8Array;
    default:
      throw new Error(dataType);
  }
}
function getVertexFormatFromAttribute(typedArray, size12, normalized) {
  if (!size12 || size12 > 4) {
    throw new Error(`size ${size12}`);
  }
  const components = size12;
  let dataType = getDataTypeFromTypedArray$1(typedArray);
  if (dataType === "uint8" || dataType === "sint8") {
    if (components === 1 || components === 3) {
      throw new Error(`size: ${size12}`);
    }
    if (normalized) {
      dataType = dataType.replace("int", "norm");
    }
    return `${dataType}x${components}`;
  }
  if (dataType === "uint16" || dataType === "sint16") {
    if (components === 1 || components === 3) {
      throw new Error(`size: ${size12}`);
    }
    if (normalized) {
      dataType = dataType.replace("int", "norm");
    }
    return `${dataType}x${components}`;
  }
  if (components === 1) {
    return dataType;
  }
  return `${dataType}x${components}`;
}
function cast$1(value) {
  return value;
}
function isUniformValue(value) {
  return isNumberArray(value) !== null || typeof value === "number" || typeof value === "boolean";
}
function splitUniformsAndBindings(uniforms) {
  const result = { bindings: {}, uniforms: {} };
  Object.keys(uniforms).forEach((name2) => {
    const uniform = uniforms[name2];
    if (isUniformValue(uniform)) {
      result.uniforms[name2] = uniform;
    } else {
      result.bindings[name2] = uniform;
    }
  });
  return result;
}
function checkProps(className, props, propChecks) {
  const { removedProps = {}, deprecatedProps = {}, replacedProps = {} } = propChecks;
  for (const propName2 in removedProps) {
    if (propName2 in props) {
      const replacementProp = removedProps[propName2];
      const replacement = replacementProp ? `${className}.${removedProps[propName2]}` : "N/A";
      log.removed(`${className}.${propName2}`, replacement)();
    }
  }
  for (const propName2 in deprecatedProps) {
    if (propName2 in props) {
      const replacementProp = deprecatedProps[propName2];
      log.deprecated(`${className}.${propName2}`, `${className}.${replacementProp}`)();
    }
  }
  let newProps = null;
  for (const [propName2, replacementProp] of Object.entries(replacedProps)) {
    if (propName2 in props) {
      log.deprecated(`${className}.${propName2}`, `${className}.${replacementProp}`)();
      newProps = newProps || Object.assign({}, props);
      newProps[replacementProp] = props[propName2];
      delete newProps[propName2];
    }
  }
  return newProps || props;
}
let pathPrefix = "";
async function loadImage$2(url2, opts) {
  return await new Promise((resolve2, reject) => {
    try {
      const image = new Image();
      image.onload = () => resolve2(image);
      image.onerror = () => reject(new Error(`Could not load image ${url2}.`));
      image.crossOrigin = (opts == null ? void 0 : opts.crossOrigin) || "anonymous";
      image.src = url2.startsWith("http") ? url2 : pathPrefix + url2;
    } catch (error2) {
      reject(error2);
    }
  });
}
async function loadScript(scriptUrl, scriptId) {
  const head = document.getElementsByTagName("head")[0];
  if (!head) {
    throw new Error("loadScript");
  }
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("src", scriptUrl);
  if (scriptId) {
    script.id = scriptId;
  }
  return new Promise((resolve2, reject) => {
    script.onload = resolve2;
    script.onerror = (error2) => reject(new Error(`Unable to load script '${scriptUrl}': ${error2}`));
    head.appendChild(script);
  });
}
function deepEqual$1(a2, b2, depth2) {
  if (a2 === b2) {
    return true;
  }
  if (!depth2 || !a2 || !b2) {
    return false;
  }
  if (Array.isArray(a2)) {
    if (!Array.isArray(b2) || a2.length !== b2.length) {
      return false;
    }
    for (let i2 = 0; i2 < a2.length; i2++) {
      if (!deepEqual$1(a2[i2], b2[i2], depth2 - 1)) {
        return false;
      }
    }
    return true;
  }
  if (Array.isArray(b2)) {
    return false;
  }
  if (typeof a2 === "object" && typeof b2 === "object") {
    const aKeys = Object.keys(a2);
    const bKeys = Object.keys(b2);
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    for (const key of aKeys) {
      if (!b2.hasOwnProperty(key)) {
        return false;
      }
      if (!deepEqual$1(a2[key], b2[key], depth2 - 1)) {
        return false;
      }
    }
    return true;
  }
  return false;
}
function requestAnimationFrame$1(callback) {
  return typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame(callback) : setTimeout(callback, 1e3 / 60);
}
function cancelAnimationFrame$1(timerId) {
  return typeof window !== "undefined" && window.cancelAnimationFrame ? window.cancelAnimationFrame(timerId) : clearTimeout(timerId);
}
class ParseContext {
  constructor() {
    this.constants = /* @__PURE__ */ new Map();
    this.aliases = /* @__PURE__ */ new Map();
    this.structs = /* @__PURE__ */ new Map();
  }
}
class Node {
  constructor() {
  }
  get isAstNode() {
    return true;
  }
  get astNodeType() {
    return "";
  }
  evaluate(context2) {
    throw new Error("Cannot evaluate node");
  }
  evaluateString(context2) {
    return this.evaluate(context2).toString();
  }
}
class Statement extends Node {
  constructor() {
    super();
  }
}
let Function$1 = class Function2 extends Statement {
  constructor(name2, args, returnType, body) {
    super();
    this.name = name2;
    this.args = args;
    this.returnType = returnType;
    this.body = body;
  }
  get astNodeType() {
    return "function";
  }
};
class StaticAssert extends Statement {
  constructor(expression) {
    super();
    this.expression = expression;
  }
  get astNodeType() {
    return "staticAssert";
  }
}
class While extends Statement {
  constructor(condition, body) {
    super();
    this.condition = condition;
    this.body = body;
  }
  get astNodeType() {
    return "while";
  }
}
class Continuing extends Statement {
  constructor(body) {
    super();
    this.body = body;
  }
  get astNodeType() {
    return "continuing";
  }
}
class For extends Statement {
  constructor(init9, condition, increment, body) {
    super();
    this.init = init9;
    this.condition = condition;
    this.increment = increment;
    this.body = body;
  }
  get astNodeType() {
    return "for";
  }
}
class Var extends Statement {
  constructor(name2, type, storage, access, value) {
    super();
    this.name = name2;
    this.type = type;
    this.storage = storage;
    this.access = access;
    this.value = value;
  }
  get astNodeType() {
    return "var";
  }
}
class Override extends Statement {
  constructor(name2, type, value) {
    super();
    this.name = name2;
    this.type = type;
    this.value = value;
  }
  get astNodeType() {
    return "override";
  }
}
class Let extends Statement {
  constructor(name2, type, storage, access, value) {
    super();
    this.name = name2;
    this.type = type;
    this.storage = storage;
    this.access = access;
    this.value = value;
  }
  get astNodeType() {
    return "let";
  }
}
class Const extends Statement {
  constructor(name2, type, storage, access, value) {
    super();
    this.name = name2;
    this.type = type;
    this.storage = storage;
    this.access = access;
    this.value = value;
  }
  get astNodeType() {
    return "const";
  }
  evaluate(context2) {
    return this.value.evaluate(context2);
  }
}
var IncrementOperator;
(function(IncrementOperator2) {
  IncrementOperator2["increment"] = "++";
  IncrementOperator2["decrement"] = "--";
})(IncrementOperator || (IncrementOperator = {}));
(function(IncrementOperator2) {
  function parse3(val) {
    const key = val;
    if (key == "parse")
      throw new Error("Invalid value for IncrementOperator");
    return IncrementOperator2[key];
  }
  IncrementOperator2.parse = parse3;
})(IncrementOperator || (IncrementOperator = {}));
class Increment extends Statement {
  constructor(operator, variable) {
    super();
    this.operator = operator;
    this.variable = variable;
  }
  get astNodeType() {
    return "increment";
  }
}
var AssignOperator;
(function(AssignOperator2) {
  AssignOperator2["assign"] = "=";
  AssignOperator2["addAssign"] = "+=";
  AssignOperator2["subtractAssin"] = "-=";
  AssignOperator2["multiplyAssign"] = "*=";
  AssignOperator2["divideAssign"] = "/=";
  AssignOperator2["moduloAssign"] = "%=";
  AssignOperator2["andAssign"] = "&=";
  AssignOperator2["orAssign"] = "|=";
  AssignOperator2["xorAssign"] = "^=";
  AssignOperator2["shiftLeftAssign"] = "<<=";
  AssignOperator2["shiftRightAssign"] = ">>=";
})(AssignOperator || (AssignOperator = {}));
(function(AssignOperator2) {
  function parse3(val) {
    const key = val;
    if (key == "parse")
      throw new Error("Invalid value for AssignOperator");
    return AssignOperator2[key];
  }
  AssignOperator2.parse = parse3;
})(AssignOperator || (AssignOperator = {}));
class Assign extends Statement {
  constructor(operator, variable, value) {
    super();
    this.operator = operator;
    this.variable = variable;
    this.value = value;
  }
  get astNodeType() {
    return "assign";
  }
}
class Call extends Statement {
  constructor(name2, args) {
    super();
    this.name = name2;
    this.args = args;
  }
  get astNodeType() {
    return "call";
  }
}
class Loop extends Statement {
  constructor(body, continuing) {
    super();
    this.body = body;
    this.continuing = continuing;
  }
  get astNodeType() {
    return "loop";
  }
}
class Switch extends Statement {
  constructor(condition, body) {
    super();
    this.condition = condition;
    this.body = body;
  }
  get astNodeType() {
    return "body";
  }
}
class If extends Statement {
  constructor(condition, body, elseif, _else) {
    super();
    this.condition = condition;
    this.body = body;
    this.elseif = elseif;
    this.else = _else;
  }
  get astNodeType() {
    return "if";
  }
}
class Return extends Statement {
  constructor(value) {
    super();
    this.value = value;
  }
  get astNodeType() {
    return "return";
  }
}
class Enable extends Statement {
  constructor(name2) {
    super();
    this.name = name2;
  }
  get astNodeType() {
    return "enable";
  }
}
class Alias extends Statement {
  constructor(name2, type) {
    super();
    this.name = name2;
    this.type = type;
  }
  get astNodeType() {
    return "alias";
  }
}
class Discard extends Statement {
  constructor() {
    super();
  }
  get astNodeType() {
    return "discard";
  }
}
class Break extends Statement {
  constructor() {
    super();
  }
  get astNodeType() {
    return "break";
  }
}
class Continue extends Statement {
  constructor() {
    super();
  }
  get astNodeType() {
    return "continue";
  }
}
class Type extends Statement {
  constructor(name2) {
    super();
    this.name = name2;
  }
  get astNodeType() {
    return "type";
  }
  get isStruct() {
    return false;
  }
  get isArray() {
    return false;
  }
}
class Struct extends Type {
  constructor(name2, members) {
    super(name2);
    this.members = members;
  }
  get astNodeType() {
    return "struct";
  }
  get isStruct() {
    return true;
  }
  /// Return the index of the member with the given name, or -1 if not found.
  getMemberIndex(name2) {
    for (let i2 = 0; i2 < this.members.length; i2++) {
      if (this.members[i2].name == name2)
        return i2;
    }
    return -1;
  }
}
class TemplateType extends Type {
  constructor(name2, format, access) {
    super(name2);
    this.format = format;
    this.access = access;
  }
  get astNodeType() {
    return "template";
  }
}
class PointerType extends Type {
  constructor(name2, storage, type, access) {
    super(name2);
    this.storage = storage;
    this.type = type;
    this.access = access;
  }
  get astNodeType() {
    return "pointer";
  }
}
class ArrayType extends Type {
  constructor(name2, attributes, format, count3) {
    super(name2);
    this.attributes = attributes;
    this.format = format;
    this.count = count3;
  }
  get astNodeType() {
    return "array";
  }
  get isArray() {
    return true;
  }
}
class SamplerType extends Type {
  constructor(name2, format, access) {
    super(name2);
    this.format = format;
    this.access = access;
  }
  get astNodeType() {
    return "sampler";
  }
}
class Expression extends Node {
  constructor() {
    super();
  }
}
class StringExpr extends Expression {
  constructor(value) {
    super();
    this.value = value;
  }
  get astNodeType() {
    return "stringExpr";
  }
  toString() {
    return this.value;
  }
  evaluateString() {
    return this.value;
  }
}
class CreateExpr extends Expression {
  constructor(type, args) {
    super();
    this.type = type;
    this.args = args;
  }
  get astNodeType() {
    return "createExpr";
  }
}
class CallExpr extends Expression {
  constructor(name2, args) {
    super();
    this.name = name2;
    this.args = args;
  }
  get astNodeType() {
    return "callExpr";
  }
  evaluate(context2) {
    switch (this.name) {
      case "abs":
        return Math.abs(this.args[0].evaluate(context2));
      case "acos":
        return Math.acos(this.args[0].evaluate(context2));
      case "acosh":
        return Math.acosh(this.args[0].evaluate(context2));
      case "asin":
        return Math.asin(this.args[0].evaluate(context2));
      case "asinh":
        return Math.asinh(this.args[0].evaluate(context2));
      case "atan":
        return Math.atan(this.args[0].evaluate(context2));
      case "atan2":
        return Math.atan2(this.args[0].evaluate(context2), this.args[1].evaluate(context2));
      case "atanh":
        return Math.atanh(this.args[0].evaluate(context2));
      case "ceil":
        return Math.ceil(this.args[0].evaluate(context2));
      case "clamp":
        return Math.min(Math.max(this.args[0].evaluate(context2), this.args[1].evaluate(context2)), this.args[2].evaluate(context2));
      case "cos":
        return Math.cos(this.args[0].evaluate(context2));
      case "degrees":
        return this.args[0].evaluate(context2) * 180 / Math.PI;
      case "distance":
        return Math.sqrt(Math.pow(this.args[0].evaluate(context2) - this.args[1].evaluate(context2), 2));
      case "dot":
      case "exp":
        return Math.exp(this.args[0].evaluate(context2));
      case "exp2":
        return Math.pow(2, this.args[0].evaluate(context2));
      case "floor":
        return Math.floor(this.args[0].evaluate(context2));
      case "fma":
        return this.args[0].evaluate(context2) * this.args[1].evaluate(context2) + this.args[2].evaluate(context2);
      case "fract":
        return this.args[0].evaluate(context2) - Math.floor(this.args[0].evaluate(context2));
      case "inverseSqrt":
        return 1 / Math.sqrt(this.args[0].evaluate(context2));
      case "log":
        return Math.log(this.args[0].evaluate(context2));
      case "log2":
        return Math.log2(this.args[0].evaluate(context2));
      case "max":
        return Math.max(this.args[0].evaluate(context2), this.args[1].evaluate(context2));
      case "min":
        return Math.min(this.args[0].evaluate(context2), this.args[1].evaluate(context2));
      case "mix":
        return this.args[0].evaluate(context2) * (1 - this.args[2].evaluate(context2)) + this.args[1].evaluate(context2) * this.args[2].evaluate(context2);
      case "modf":
        return this.args[0].evaluate(context2) - Math.floor(this.args[0].evaluate(context2));
      case "pow":
        return Math.pow(this.args[0].evaluate(context2), this.args[1].evaluate(context2));
      case "radians":
        return this.args[0].evaluate(context2) * Math.PI / 180;
      case "round":
        return Math.round(this.args[0].evaluate(context2));
      case "sign":
        return Math.sign(this.args[0].evaluate(context2));
      case "sin":
        return Math.sin(this.args[0].evaluate(context2));
      case "sinh":
        return Math.sinh(this.args[0].evaluate(context2));
      case "saturate":
        return Math.min(Math.max(this.args[0].evaluate(context2), 0), 1);
      case "smoothstep":
        return this.args[0].evaluate(context2) * this.args[0].evaluate(context2) * (3 - 2 * this.args[0].evaluate(context2));
      case "sqrt":
        return Math.sqrt(this.args[0].evaluate(context2));
      case "step":
        return this.args[0].evaluate(context2) < this.args[1].evaluate(context2) ? 0 : 1;
      case "tan":
        return Math.tan(this.args[0].evaluate(context2));
      case "tanh":
        return Math.tanh(this.args[0].evaluate(context2));
      case "trunc":
        return Math.trunc(this.args[0].evaluate(context2));
      default:
        throw new Error("Non const function: " + this.name);
    }
  }
}
class VariableExpr extends Expression {
  constructor(name2) {
    super();
    this.name = name2;
  }
  get astNodeType() {
    return "varExpr";
  }
}
class ConstExpr extends Expression {
  constructor(name2, initializer) {
    super();
    this.name = name2;
    this.initializer = initializer;
  }
  get astNodeType() {
    return "constExpr";
  }
  evaluate(context2) {
    var _a3, _b3;
    if (this.initializer instanceof CreateExpr) {
      const property2 = (_a3 = this.postfix) === null || _a3 === void 0 ? void 0 : _a3.evaluateString(context2);
      const type = (_b3 = this.initializer.type) === null || _b3 === void 0 ? void 0 : _b3.name;
      const struct = context2.structs.get(type);
      const memberIndex = struct === null || struct === void 0 ? void 0 : struct.getMemberIndex(property2);
      if (memberIndex != -1) {
        const value = this.initializer.args[memberIndex].evaluate(context2);
        return value;
      }
      console.log(memberIndex);
    }
    return this.initializer.evaluate(context2);
  }
}
class LiteralExpr extends Expression {
  constructor(value) {
    super();
    this.value = value;
  }
  get astNodeType() {
    return "literalExpr";
  }
  evaluate() {
    return this.value;
  }
}
class BitcastExpr extends Expression {
  constructor(type, value) {
    super();
    this.type = type;
    this.value = value;
  }
  get astNodeType() {
    return "bitcastExpr";
  }
}
class TypecastExpr extends Expression {
  constructor(type, args) {
    super();
    this.type = type;
    this.args = args;
  }
  get astNodeType() {
    return "typecastExpr";
  }
  evaluate(context2) {
    return this.args[0].evaluate(context2);
  }
}
class GroupingExpr extends Expression {
  constructor(contents) {
    super();
    this.contents = contents;
  }
  get astNodeType() {
    return "groupExpr";
  }
  evaluate(context2) {
    return this.contents[0].evaluate(context2);
  }
}
class Operator extends Expression {
  constructor() {
    super();
  }
}
class UnaryOperator extends Operator {
  constructor(operator, right) {
    super();
    this.operator = operator;
    this.right = right;
  }
  get astNodeType() {
    return "unaryOp";
  }
  evaluate(context2) {
    switch (this.operator) {
      case "+":
        return this.right.evaluate(context2);
      case "-":
        return -this.right.evaluate(context2);
      case "!":
        return this.right.evaluate(context2) ? 0 : 1;
      case "~":
        return ~this.right.evaluate(context2);
      default:
        throw new Error("Unknown unary operator: " + this.operator);
    }
  }
}
class BinaryOperator extends Operator {
  constructor(operator, left, right) {
    super();
    this.operator = operator;
    this.left = left;
    this.right = right;
  }
  get astNodeType() {
    return "binaryOp";
  }
  evaluate(context2) {
    switch (this.operator) {
      case "+":
        return this.left.evaluate(context2) + this.right.evaluate(context2);
      case "-":
        return this.left.evaluate(context2) - this.right.evaluate(context2);
      case "*":
        return this.left.evaluate(context2) * this.right.evaluate(context2);
      case "/":
        return this.left.evaluate(context2) / this.right.evaluate(context2);
      case "%":
        return this.left.evaluate(context2) % this.right.evaluate(context2);
      case "==":
        return this.left.evaluate(context2) == this.right.evaluate(context2) ? 1 : 0;
      case "!=":
        return this.left.evaluate(context2) != this.right.evaluate(context2) ? 1 : 0;
      case "<":
        return this.left.evaluate(context2) < this.right.evaluate(context2) ? 1 : 0;
      case ">":
        return this.left.evaluate(context2) > this.right.evaluate(context2) ? 1 : 0;
      case "<=":
        return this.left.evaluate(context2) <= this.right.evaluate(context2) ? 1 : 0;
      case ">=":
        return this.left.evaluate(context2) >= this.right.evaluate(context2) ? 1 : 0;
      case "&&":
        return this.left.evaluate(context2) && this.right.evaluate(context2) ? 1 : 0;
      case "||":
        return this.left.evaluate(context2) || this.right.evaluate(context2) ? 1 : 0;
      default:
        throw new Error(`Unknown operator ${this.operator}`);
    }
  }
}
class SwitchCase extends Node {
  constructor() {
    super();
  }
}
class Case extends SwitchCase {
  constructor(selector, body) {
    super();
    this.selector = selector;
    this.body = body;
  }
  get astNodeType() {
    return "case";
  }
}
class Default extends SwitchCase {
  constructor(body) {
    super();
    this.body = body;
  }
  get astNodeType() {
    return "default";
  }
}
class Argument extends Node {
  constructor(name2, type, attributes) {
    super();
    this.name = name2;
    this.type = type;
    this.attributes = attributes;
  }
  get astNodeType() {
    return "argument";
  }
}
class ElseIf extends Node {
  constructor(condition, body) {
    super();
    this.condition = condition;
    this.body = body;
  }
  get astNodeType() {
    return "elseif";
  }
}
class Member extends Node {
  constructor(name2, type, attributes) {
    super();
    this.name = name2;
    this.type = type;
    this.attributes = attributes;
  }
  get astNodeType() {
    return "member";
  }
}
let Attribute$1 = class Attribute2 extends Node {
  constructor(name2, value) {
    super();
    this.name = name2;
    this.value = value;
  }
  get astNodeType() {
    return "attribute";
  }
};
var _a$1;
var TokenClass;
(function(TokenClass2) {
  TokenClass2[TokenClass2["token"] = 0] = "token";
  TokenClass2[TokenClass2["keyword"] = 1] = "keyword";
  TokenClass2[TokenClass2["reserved"] = 2] = "reserved";
})(TokenClass || (TokenClass = {}));
class TokenType {
  constructor(name2, type, rule) {
    this.name = name2;
    this.type = type;
    this.rule = rule;
  }
  toString() {
    return this.name;
  }
}
class TokenTypes {
}
_a$1 = TokenTypes;
TokenTypes.none = new TokenType("", TokenClass.reserved, "");
TokenTypes.eof = new TokenType("EOF", TokenClass.token, "");
TokenTypes.reserved = {
  asm: new TokenType("asm", TokenClass.reserved, "asm"),
  bf16: new TokenType("bf16", TokenClass.reserved, "bf16"),
  do: new TokenType("do", TokenClass.reserved, "do"),
  enum: new TokenType("enum", TokenClass.reserved, "enum"),
  f16: new TokenType("f16", TokenClass.reserved, "f16"),
  f64: new TokenType("f64", TokenClass.reserved, "f64"),
  handle: new TokenType("handle", TokenClass.reserved, "handle"),
  i8: new TokenType("i8", TokenClass.reserved, "i8"),
  i16: new TokenType("i16", TokenClass.reserved, "i16"),
  i64: new TokenType("i64", TokenClass.reserved, "i64"),
  mat: new TokenType("mat", TokenClass.reserved, "mat"),
  premerge: new TokenType("premerge", TokenClass.reserved, "premerge"),
  regardless: new TokenType("regardless", TokenClass.reserved, "regardless"),
  typedef: new TokenType("typedef", TokenClass.reserved, "typedef"),
  u8: new TokenType("u8", TokenClass.reserved, "u8"),
  u16: new TokenType("u16", TokenClass.reserved, "u16"),
  u64: new TokenType("u64", TokenClass.reserved, "u64"),
  unless: new TokenType("unless", TokenClass.reserved, "unless"),
  using: new TokenType("using", TokenClass.reserved, "using"),
  vec: new TokenType("vec", TokenClass.reserved, "vec"),
  void: new TokenType("void", TokenClass.reserved, "void")
};
TokenTypes.keywords = {
  array: new TokenType("array", TokenClass.keyword, "array"),
  atomic: new TokenType("atomic", TokenClass.keyword, "atomic"),
  bool: new TokenType("bool", TokenClass.keyword, "bool"),
  f32: new TokenType("f32", TokenClass.keyword, "f32"),
  i32: new TokenType("i32", TokenClass.keyword, "i32"),
  mat2x2: new TokenType("mat2x2", TokenClass.keyword, "mat2x2"),
  mat2x3: new TokenType("mat2x3", TokenClass.keyword, "mat2x3"),
  mat2x4: new TokenType("mat2x4", TokenClass.keyword, "mat2x4"),
  mat3x2: new TokenType("mat3x2", TokenClass.keyword, "mat3x2"),
  mat3x3: new TokenType("mat3x3", TokenClass.keyword, "mat3x3"),
  mat3x4: new TokenType("mat3x4", TokenClass.keyword, "mat3x4"),
  mat4x2: new TokenType("mat4x2", TokenClass.keyword, "mat4x2"),
  mat4x3: new TokenType("mat4x3", TokenClass.keyword, "mat4x3"),
  mat4x4: new TokenType("mat4x4", TokenClass.keyword, "mat4x4"),
  ptr: new TokenType("ptr", TokenClass.keyword, "ptr"),
  sampler: new TokenType("sampler", TokenClass.keyword, "sampler"),
  sampler_comparison: new TokenType("sampler_comparison", TokenClass.keyword, "sampler_comparison"),
  struct: new TokenType("struct", TokenClass.keyword, "struct"),
  texture_1d: new TokenType("texture_1d", TokenClass.keyword, "texture_1d"),
  texture_2d: new TokenType("texture_2d", TokenClass.keyword, "texture_2d"),
  texture_2d_array: new TokenType("texture_2d_array", TokenClass.keyword, "texture_2d_array"),
  texture_3d: new TokenType("texture_3d", TokenClass.keyword, "texture_3d"),
  texture_cube: new TokenType("texture_cube", TokenClass.keyword, "texture_cube"),
  texture_cube_array: new TokenType("texture_cube_array", TokenClass.keyword, "texture_cube_array"),
  texture_multisampled_2d: new TokenType("texture_multisampled_2d", TokenClass.keyword, "texture_multisampled_2d"),
  texture_storage_1d: new TokenType("texture_storage_1d", TokenClass.keyword, "texture_storage_1d"),
  texture_storage_2d: new TokenType("texture_storage_2d", TokenClass.keyword, "texture_storage_2d"),
  texture_storage_2d_array: new TokenType("texture_storage_2d_array", TokenClass.keyword, "texture_storage_2d_array"),
  texture_storage_3d: new TokenType("texture_storage_3d", TokenClass.keyword, "texture_storage_3d"),
  texture_depth_2d: new TokenType("texture_depth_2d", TokenClass.keyword, "texture_depth_2d"),
  texture_depth_2d_array: new TokenType("texture_depth_2d_array", TokenClass.keyword, "texture_depth_2d_array"),
  texture_depth_cube: new TokenType("texture_depth_cube", TokenClass.keyword, "texture_depth_cube"),
  texture_depth_cube_array: new TokenType("texture_depth_cube_array", TokenClass.keyword, "texture_depth_cube_array"),
  texture_depth_multisampled_2d: new TokenType("texture_depth_multisampled_2d", TokenClass.keyword, "texture_depth_multisampled_2d"),
  texture_external: new TokenType("texture_external", TokenClass.keyword, "texture_external"),
  u32: new TokenType("u32", TokenClass.keyword, "u32"),
  vec2: new TokenType("vec2", TokenClass.keyword, "vec2"),
  vec3: new TokenType("vec3", TokenClass.keyword, "vec3"),
  vec4: new TokenType("vec4", TokenClass.keyword, "vec4"),
  bitcast: new TokenType("bitcast", TokenClass.keyword, "bitcast"),
  block: new TokenType("block", TokenClass.keyword, "block"),
  break: new TokenType("break", TokenClass.keyword, "break"),
  case: new TokenType("case", TokenClass.keyword, "case"),
  continue: new TokenType("continue", TokenClass.keyword, "continue"),
  continuing: new TokenType("continuing", TokenClass.keyword, "continuing"),
  default: new TokenType("default", TokenClass.keyword, "default"),
  discard: new TokenType("discard", TokenClass.keyword, "discard"),
  else: new TokenType("else", TokenClass.keyword, "else"),
  enable: new TokenType("enable", TokenClass.keyword, "enable"),
  fallthrough: new TokenType("fallthrough", TokenClass.keyword, "fallthrough"),
  false: new TokenType("false", TokenClass.keyword, "false"),
  fn: new TokenType("fn", TokenClass.keyword, "fn"),
  for: new TokenType("for", TokenClass.keyword, "for"),
  function: new TokenType("function", TokenClass.keyword, "function"),
  if: new TokenType("if", TokenClass.keyword, "if"),
  let: new TokenType("let", TokenClass.keyword, "let"),
  const: new TokenType("const", TokenClass.keyword, "const"),
  loop: new TokenType("loop", TokenClass.keyword, "loop"),
  while: new TokenType("while", TokenClass.keyword, "while"),
  private: new TokenType("private", TokenClass.keyword, "private"),
  read: new TokenType("read", TokenClass.keyword, "read"),
  read_write: new TokenType("read_write", TokenClass.keyword, "read_write"),
  return: new TokenType("return", TokenClass.keyword, "return"),
  storage: new TokenType("storage", TokenClass.keyword, "storage"),
  switch: new TokenType("switch", TokenClass.keyword, "switch"),
  true: new TokenType("true", TokenClass.keyword, "true"),
  alias: new TokenType("alias", TokenClass.keyword, "alias"),
  type: new TokenType("type", TokenClass.keyword, "type"),
  uniform: new TokenType("uniform", TokenClass.keyword, "uniform"),
  var: new TokenType("var", TokenClass.keyword, "var"),
  override: new TokenType("override", TokenClass.keyword, "override"),
  workgroup: new TokenType("workgroup", TokenClass.keyword, "workgroup"),
  write: new TokenType("write", TokenClass.keyword, "write"),
  r8unorm: new TokenType("r8unorm", TokenClass.keyword, "r8unorm"),
  r8snorm: new TokenType("r8snorm", TokenClass.keyword, "r8snorm"),
  r8uint: new TokenType("r8uint", TokenClass.keyword, "r8uint"),
  r8sint: new TokenType("r8sint", TokenClass.keyword, "r8sint"),
  r16uint: new TokenType("r16uint", TokenClass.keyword, "r16uint"),
  r16sint: new TokenType("r16sint", TokenClass.keyword, "r16sint"),
  r16float: new TokenType("r16float", TokenClass.keyword, "r16float"),
  rg8unorm: new TokenType("rg8unorm", TokenClass.keyword, "rg8unorm"),
  rg8snorm: new TokenType("rg8snorm", TokenClass.keyword, "rg8snorm"),
  rg8uint: new TokenType("rg8uint", TokenClass.keyword, "rg8uint"),
  rg8sint: new TokenType("rg8sint", TokenClass.keyword, "rg8sint"),
  r32uint: new TokenType("r32uint", TokenClass.keyword, "r32uint"),
  r32sint: new TokenType("r32sint", TokenClass.keyword, "r32sint"),
  r32float: new TokenType("r32float", TokenClass.keyword, "r32float"),
  rg16uint: new TokenType("rg16uint", TokenClass.keyword, "rg16uint"),
  rg16sint: new TokenType("rg16sint", TokenClass.keyword, "rg16sint"),
  rg16float: new TokenType("rg16float", TokenClass.keyword, "rg16float"),
  rgba8unorm: new TokenType("rgba8unorm", TokenClass.keyword, "rgba8unorm"),
  rgba8unorm_srgb: new TokenType("rgba8unorm_srgb", TokenClass.keyword, "rgba8unorm_srgb"),
  rgba8snorm: new TokenType("rgba8snorm", TokenClass.keyword, "rgba8snorm"),
  rgba8uint: new TokenType("rgba8uint", TokenClass.keyword, "rgba8uint"),
  rgba8sint: new TokenType("rgba8sint", TokenClass.keyword, "rgba8sint"),
  bgra8unorm: new TokenType("bgra8unorm", TokenClass.keyword, "bgra8unorm"),
  bgra8unorm_srgb: new TokenType("bgra8unorm_srgb", TokenClass.keyword, "bgra8unorm_srgb"),
  rgb10a2unorm: new TokenType("rgb10a2unorm", TokenClass.keyword, "rgb10a2unorm"),
  rg11b10float: new TokenType("rg11b10float", TokenClass.keyword, "rg11b10float"),
  rg32uint: new TokenType("rg32uint", TokenClass.keyword, "rg32uint"),
  rg32sint: new TokenType("rg32sint", TokenClass.keyword, "rg32sint"),
  rg32float: new TokenType("rg32float", TokenClass.keyword, "rg32float"),
  rgba16uint: new TokenType("rgba16uint", TokenClass.keyword, "rgba16uint"),
  rgba16sint: new TokenType("rgba16sint", TokenClass.keyword, "rgba16sint"),
  rgba16float: new TokenType("rgba16float", TokenClass.keyword, "rgba16float"),
  rgba32uint: new TokenType("rgba32uint", TokenClass.keyword, "rgba32uint"),
  rgba32sint: new TokenType("rgba32sint", TokenClass.keyword, "rgba32sint"),
  rgba32float: new TokenType("rgba32float", TokenClass.keyword, "rgba32float"),
  static_assert: new TokenType("static_assert", TokenClass.keyword, "static_assert")
  // WGSL grammar has a few keywords that have different token names than the strings they
  // represent. Aliasing them here.
  /*int32: new TokenType("i32", TokenClass.keyword, "i32"),
      uint32: new TokenType("u32", TokenClass.keyword, "u32"),
      float32: new TokenType("f32", TokenClass.keyword, "f32"),
      pointer: new TokenType("ptr", TokenClass.keyword, "ptr"),*/
};
TokenTypes.tokens = {
  decimal_float_literal: new TokenType("decimal_float_literal", TokenClass.token, /((-?[0-9]*\.[0-9]+|-?[0-9]+\.[0-9]*)((e|E)(\+|-)?[0-9]+)?f?)|(-?[0-9]+(e|E)(\+|-)?[0-9]+f?)|([0-9]+f)/),
  hex_float_literal: new TokenType("hex_float_literal", TokenClass.token, /-?0x((([0-9a-fA-F]*\.[0-9a-fA-F]+|[0-9a-fA-F]+\.[0-9a-fA-F]*)((p|P)(\+|-)?[0-9]+f?)?)|([0-9a-fA-F]+(p|P)(\+|-)?[0-9]+f?))/),
  int_literal: new TokenType("int_literal", TokenClass.token, /-?0x[0-9a-fA-F]+|0i?|-?[1-9][0-9]*i?/),
  uint_literal: new TokenType("uint_literal", TokenClass.token, /0x[0-9a-fA-F]+u|0u|[1-9][0-9]*u/),
  ident: new TokenType("ident", TokenClass.token, /[a-zA-Z][0-9a-zA-Z_]*/),
  and: new TokenType("and", TokenClass.token, "&"),
  and_and: new TokenType("and_and", TokenClass.token, "&&"),
  arrow: new TokenType("arrow ", TokenClass.token, "->"),
  attr: new TokenType("attr", TokenClass.token, "@"),
  attr_left: new TokenType("attr_left", TokenClass.token, "[["),
  attr_right: new TokenType("attr_right", TokenClass.token, "]]"),
  forward_slash: new TokenType("forward_slash", TokenClass.token, "/"),
  bang: new TokenType("bang", TokenClass.token, "!"),
  bracket_left: new TokenType("bracket_left", TokenClass.token, "["),
  bracket_right: new TokenType("bracket_right", TokenClass.token, "]"),
  brace_left: new TokenType("brace_left", TokenClass.token, "{"),
  brace_right: new TokenType("brace_right", TokenClass.token, "}"),
  colon: new TokenType("colon", TokenClass.token, ":"),
  comma: new TokenType("comma", TokenClass.token, ","),
  equal: new TokenType("equal", TokenClass.token, "="),
  equal_equal: new TokenType("equal_equal", TokenClass.token, "=="),
  not_equal: new TokenType("not_equal", TokenClass.token, "!="),
  greater_than: new TokenType("greater_than", TokenClass.token, ">"),
  greater_than_equal: new TokenType("greater_than_equal", TokenClass.token, ">="),
  shift_right: new TokenType("shift_right", TokenClass.token, ">>"),
  less_than: new TokenType("less_than", TokenClass.token, "<"),
  less_than_equal: new TokenType("less_than_equal", TokenClass.token, "<="),
  shift_left: new TokenType("shift_left", TokenClass.token, "<<"),
  modulo: new TokenType("modulo", TokenClass.token, "%"),
  minus: new TokenType("minus", TokenClass.token, "-"),
  minus_minus: new TokenType("minus_minus", TokenClass.token, "--"),
  period: new TokenType("period", TokenClass.token, "."),
  plus: new TokenType("plus", TokenClass.token, "+"),
  plus_plus: new TokenType("plus_plus", TokenClass.token, "++"),
  or: new TokenType("or", TokenClass.token, "|"),
  or_or: new TokenType("or_or", TokenClass.token, "||"),
  paren_left: new TokenType("paren_left", TokenClass.token, "("),
  paren_right: new TokenType("paren_right", TokenClass.token, ")"),
  semicolon: new TokenType("semicolon", TokenClass.token, ";"),
  star: new TokenType("star", TokenClass.token, "*"),
  tilde: new TokenType("tilde", TokenClass.token, "~"),
  underscore: new TokenType("underscore", TokenClass.token, "_"),
  xor: new TokenType("xor", TokenClass.token, "^"),
  plus_equal: new TokenType("plus_equal", TokenClass.token, "+="),
  minus_equal: new TokenType("minus_equal", TokenClass.token, "-="),
  times_equal: new TokenType("times_equal", TokenClass.token, "*="),
  division_equal: new TokenType("division_equal", TokenClass.token, "/="),
  modulo_equal: new TokenType("modulo_equal", TokenClass.token, "%="),
  and_equal: new TokenType("and_equal", TokenClass.token, "&="),
  or_equal: new TokenType("or_equal", TokenClass.token, "|="),
  xor_equal: new TokenType("xor_equal", TokenClass.token, "^="),
  shift_right_equal: new TokenType("shift_right_equal", TokenClass.token, ">>="),
  shift_left_equal: new TokenType("shift_left_equal", TokenClass.token, "<<=")
};
TokenTypes.storage_class = [
  _a$1.keywords.function,
  _a$1.keywords.private,
  _a$1.keywords.workgroup,
  _a$1.keywords.uniform,
  _a$1.keywords.storage
];
TokenTypes.access_mode = [
  _a$1.keywords.read,
  _a$1.keywords.write,
  _a$1.keywords.read_write
];
TokenTypes.sampler_type = [
  _a$1.keywords.sampler,
  _a$1.keywords.sampler_comparison
];
TokenTypes.sampled_texture_type = [
  _a$1.keywords.texture_1d,
  _a$1.keywords.texture_2d,
  _a$1.keywords.texture_2d_array,
  _a$1.keywords.texture_3d,
  _a$1.keywords.texture_cube,
  _a$1.keywords.texture_cube_array
];
TokenTypes.multisampled_texture_type = [
  _a$1.keywords.texture_multisampled_2d
];
TokenTypes.storage_texture_type = [
  _a$1.keywords.texture_storage_1d,
  _a$1.keywords.texture_storage_2d,
  _a$1.keywords.texture_storage_2d_array,
  _a$1.keywords.texture_storage_3d
];
TokenTypes.depth_texture_type = [
  _a$1.keywords.texture_depth_2d,
  _a$1.keywords.texture_depth_2d_array,
  _a$1.keywords.texture_depth_cube,
  _a$1.keywords.texture_depth_cube_array,
  _a$1.keywords.texture_depth_multisampled_2d
];
TokenTypes.texture_external_type = [_a$1.keywords.texture_external];
TokenTypes.any_texture_type = [
  ..._a$1.sampled_texture_type,
  ..._a$1.multisampled_texture_type,
  ..._a$1.storage_texture_type,
  ..._a$1.depth_texture_type,
  ..._a$1.texture_external_type
];
TokenTypes.texel_format = [
  _a$1.keywords.r8unorm,
  _a$1.keywords.r8snorm,
  _a$1.keywords.r8uint,
  _a$1.keywords.r8sint,
  _a$1.keywords.r16uint,
  _a$1.keywords.r16sint,
  _a$1.keywords.r16float,
  _a$1.keywords.rg8unorm,
  _a$1.keywords.rg8snorm,
  _a$1.keywords.rg8uint,
  _a$1.keywords.rg8sint,
  _a$1.keywords.r32uint,
  _a$1.keywords.r32sint,
  _a$1.keywords.r32float,
  _a$1.keywords.rg16uint,
  _a$1.keywords.rg16sint,
  _a$1.keywords.rg16float,
  _a$1.keywords.rgba8unorm,
  _a$1.keywords.rgba8unorm_srgb,
  _a$1.keywords.rgba8snorm,
  _a$1.keywords.rgba8uint,
  _a$1.keywords.rgba8sint,
  _a$1.keywords.bgra8unorm,
  _a$1.keywords.bgra8unorm_srgb,
  _a$1.keywords.rgb10a2unorm,
  _a$1.keywords.rg11b10float,
  _a$1.keywords.rg32uint,
  _a$1.keywords.rg32sint,
  _a$1.keywords.rg32float,
  _a$1.keywords.rgba16uint,
  _a$1.keywords.rgba16sint,
  _a$1.keywords.rgba16float,
  _a$1.keywords.rgba32uint,
  _a$1.keywords.rgba32sint,
  _a$1.keywords.rgba32float
];
TokenTypes.const_literal = [
  _a$1.tokens.int_literal,
  _a$1.tokens.uint_literal,
  _a$1.tokens.decimal_float_literal,
  _a$1.tokens.hex_float_literal,
  _a$1.keywords.true,
  _a$1.keywords.false
];
TokenTypes.literal_or_ident = [
  _a$1.tokens.ident,
  _a$1.tokens.int_literal,
  _a$1.tokens.uint_literal,
  _a$1.tokens.decimal_float_literal,
  _a$1.tokens.hex_float_literal
];
TokenTypes.element_count_expression = [
  _a$1.tokens.int_literal,
  _a$1.tokens.uint_literal,
  _a$1.tokens.ident
];
TokenTypes.template_types = [
  _a$1.keywords.vec2,
  _a$1.keywords.vec3,
  _a$1.keywords.vec4,
  _a$1.keywords.mat2x2,
  _a$1.keywords.mat2x3,
  _a$1.keywords.mat2x4,
  _a$1.keywords.mat3x2,
  _a$1.keywords.mat3x3,
  _a$1.keywords.mat3x4,
  _a$1.keywords.mat4x2,
  _a$1.keywords.mat4x3,
  _a$1.keywords.mat4x4,
  _a$1.keywords.atomic,
  _a$1.keywords.bitcast,
  ..._a$1.any_texture_type
];
TokenTypes.attribute_name = [_a$1.tokens.ident, _a$1.keywords.block];
TokenTypes.assignment_operators = [
  _a$1.tokens.equal,
  _a$1.tokens.plus_equal,
  _a$1.tokens.minus_equal,
  _a$1.tokens.times_equal,
  _a$1.tokens.division_equal,
  _a$1.tokens.modulo_equal,
  _a$1.tokens.and_equal,
  _a$1.tokens.or_equal,
  _a$1.tokens.xor_equal,
  _a$1.tokens.shift_right_equal,
  _a$1.tokens.shift_left_equal
];
TokenTypes.increment_operators = [
  _a$1.tokens.plus_plus,
  _a$1.tokens.minus_minus
];
class Token {
  constructor(type, lexeme, line) {
    this.type = type;
    this.lexeme = lexeme;
    this.line = line;
  }
  toString() {
    return this.lexeme;
  }
  isTemplateType() {
    return TokenTypes.template_types.indexOf(this.type) != -1;
  }
  isArrayType() {
    return this.type == TokenTypes.keywords.array;
  }
  isArrayOrTemplateType() {
    return this.isArrayType() || this.isTemplateType();
  }
}
class WgslScanner {
  constructor(source) {
    this._tokens = [];
    this._start = 0;
    this._current = 0;
    this._line = 1;
    this._source = source !== null && source !== void 0 ? source : "";
  }
  /// Scan all tokens from the source.
  scanTokens() {
    while (!this._isAtEnd()) {
      this._start = this._current;
      if (!this.scanToken())
        throw `Invalid syntax at line ${this._line}`;
    }
    this._tokens.push(new Token(TokenTypes.eof, "", this._line));
    return this._tokens;
  }
  /// Scan a single token from the source.
  scanToken() {
    let lexeme = this._advance();
    if (lexeme == "\n") {
      this._line++;
      return true;
    }
    if (this._isWhitespace(lexeme)) {
      return true;
    }
    if (lexeme == "/") {
      if (this._peekAhead() == "/") {
        while (lexeme != "\n") {
          if (this._isAtEnd())
            return true;
          lexeme = this._advance();
        }
        this._line++;
        return true;
      } else if (this._peekAhead() == "*") {
        this._advance();
        let commentLevel = 1;
        while (commentLevel > 0) {
          if (this._isAtEnd())
            return true;
          lexeme = this._advance();
          if (lexeme == "\n") {
            this._line++;
          } else if (lexeme == "*") {
            if (this._peekAhead() == "/") {
              this._advance();
              commentLevel--;
              if (commentLevel == 0) {
                return true;
              }
            }
          } else if (lexeme == "/") {
            if (this._peekAhead() == "*") {
              this._advance();
              commentLevel++;
            }
          }
        }
        return true;
      }
    }
    let matchType = TokenTypes.none;
    for (; ; ) {
      let matchedType = this._findType(lexeme);
      const nextLexeme = this._peekAhead();
      if (lexeme == ">" && (nextLexeme == ">" || nextLexeme == "=")) {
        let foundLessThan = false;
        let ti = this._tokens.length - 1;
        for (let count3 = 0; count3 < 5 && ti >= 0; ++count3, --ti) {
          if (this._tokens[ti].type === TokenTypes.tokens.less_than) {
            if (ti > 0 && this._tokens[ti - 1].isArrayOrTemplateType()) {
              foundLessThan = true;
            }
            break;
          }
        }
        if (foundLessThan) {
          this._addToken(matchedType);
          return true;
        }
      }
      if (matchedType === TokenTypes.none) {
        let lookAheadLexeme = lexeme;
        let lookAhead = 0;
        const maxLookAhead = 2;
        for (let li = 0; li < maxLookAhead; ++li) {
          lookAheadLexeme += this._peekAhead(li);
          matchedType = this._findType(lookAheadLexeme);
          if (matchedType !== TokenTypes.none) {
            lookAhead = li;
            break;
          }
        }
        if (matchedType === TokenTypes.none) {
          if (matchType === TokenTypes.none)
            return false;
          this._current--;
          this._addToken(matchType);
          return true;
        }
        lexeme = lookAheadLexeme;
        this._current += lookAhead + 1;
      }
      matchType = matchedType;
      if (this._isAtEnd())
        break;
      lexeme += this._advance();
    }
    if (matchType === TokenTypes.none)
      return false;
    this._addToken(matchType);
    return true;
  }
  _findType(lexeme) {
    for (const name2 in TokenTypes.keywords) {
      const type = TokenTypes.keywords[name2];
      if (this._match(lexeme, type.rule)) {
        return type;
      }
    }
    for (const name2 in TokenTypes.tokens) {
      const type = TokenTypes.tokens[name2];
      if (this._match(lexeme, type.rule)) {
        return type;
      }
    }
    return TokenTypes.none;
  }
  _match(lexeme, rule) {
    if (typeof rule === "string") {
      if (rule == lexeme) {
        return true;
      }
    } else {
      const match2 = rule.exec(lexeme);
      if (match2 && match2.index == 0 && match2[0] == lexeme)
        return true;
    }
    return false;
  }
  _isAtEnd() {
    return this._current >= this._source.length;
  }
  _isWhitespace(c2) {
    return c2 == " " || c2 == "	" || c2 == "\r";
  }
  _advance(amount = 0) {
    let c2 = this._source[this._current];
    amount = amount || 0;
    amount++;
    this._current += amount;
    return c2;
  }
  _peekAhead(offset = 0) {
    offset = offset || 0;
    if (this._current + offset >= this._source.length)
      return "\0";
    return this._source[this._current + offset];
  }
  _addToken(type) {
    const text = this._source.substring(this._start, this._current);
    this._tokens.push(new Token(type, text, this._line));
  }
}
class WgslParser {
  constructor() {
    this._tokens = [];
    this._current = 0;
    this._context = new ParseContext();
  }
  parse(tokensOrCode) {
    this._initialize(tokensOrCode);
    let statements = [];
    while (!this._isAtEnd()) {
      const statement = this._global_decl_or_directive();
      if (!statement)
        break;
      statements.push(statement);
    }
    return statements;
  }
  _initialize(tokensOrCode) {
    if (tokensOrCode) {
      if (typeof tokensOrCode == "string") {
        const scanner2 = new WgslScanner(tokensOrCode);
        this._tokens = scanner2.scanTokens();
      } else {
        this._tokens = tokensOrCode;
      }
    } else {
      this._tokens = [];
    }
    this._current = 0;
  }
  _error(token, message2) {
    console.error(token, message2);
    return {
      token,
      message: message2,
      toString: function() {
        return `${message2}`;
      }
    };
  }
  _isAtEnd() {
    return this._current >= this._tokens.length || this._peek().type == TokenTypes.eof;
  }
  _match(types2) {
    if (types2 instanceof TokenType) {
      if (this._check(types2)) {
        this._advance();
        return true;
      }
      return false;
    }
    for (let i2 = 0, l2 = types2.length; i2 < l2; ++i2) {
      const type = types2[i2];
      if (this._check(type)) {
        this._advance();
        return true;
      }
    }
    return false;
  }
  _consume(types2, message2) {
    if (this._check(types2))
      return this._advance();
    throw this._error(this._peek(), message2);
  }
  _check(types2) {
    if (this._isAtEnd())
      return false;
    const tk = this._peek();
    if (types2 instanceof Array) {
      let t2 = tk.type;
      let index2 = types2.indexOf(t2);
      return index2 != -1;
    }
    return tk.type == types2;
  }
  _advance() {
    if (!this._isAtEnd())
      this._current++;
    return this._previous();
  }
  _peek() {
    return this._tokens[this._current];
  }
  _previous() {
    return this._tokens[this._current - 1];
  }
  _global_decl_or_directive() {
    while (this._match(TokenTypes.tokens.semicolon) && !this._isAtEnd())
      ;
    if (this._match(TokenTypes.keywords.alias)) {
      const type = this._type_alias();
      this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
      return type;
    }
    if (this._match(TokenTypes.keywords.enable)) {
      const enable4 = this._enable_directive();
      this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
      return enable4;
    }
    const attrs = this._attribute();
    if (this._check(TokenTypes.keywords.var)) {
      const _var = this._global_variable_decl();
      if (_var != null)
        _var.attributes = attrs;
      this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
      return _var;
    }
    if (this._check(TokenTypes.keywords.override)) {
      const _override = this._override_variable_decl();
      if (_override != null)
        _override.attributes = attrs;
      this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
      return _override;
    }
    if (this._check(TokenTypes.keywords.let)) {
      const _let = this._global_let_decl();
      if (_let != null)
        _let.attributes = attrs;
      this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
      return _let;
    }
    if (this._check(TokenTypes.keywords.const)) {
      const _const = this._global_const_decl();
      if (_const != null)
        _const.attributes = attrs;
      this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
      return _const;
    }
    if (this._check(TokenTypes.keywords.struct)) {
      const _struct = this._struct_decl();
      if (_struct != null)
        _struct.attributes = attrs;
      return _struct;
    }
    if (this._check(TokenTypes.keywords.fn)) {
      const _fn = this._function_decl();
      if (_fn != null)
        _fn.attributes = attrs;
      return _fn;
    }
    return null;
  }
  _function_decl() {
    if (!this._match(TokenTypes.keywords.fn))
      return null;
    const name2 = this._consume(TokenTypes.tokens.ident, "Expected function name.").toString();
    this._consume(TokenTypes.tokens.paren_left, "Expected '(' for function arguments.");
    const args = [];
    if (!this._check(TokenTypes.tokens.paren_right)) {
      do {
        if (this._check(TokenTypes.tokens.paren_right))
          break;
        const argAttrs = this._attribute();
        const name3 = this._consume(TokenTypes.tokens.ident, "Expected argument name.").toString();
        this._consume(TokenTypes.tokens.colon, "Expected ':' for argument type.");
        const typeAttrs = this._attribute();
        const type = this._type_decl();
        if (type != null) {
          type.attributes = typeAttrs;
          args.push(new Argument(name3, type, argAttrs));
        }
      } while (this._match(TokenTypes.tokens.comma));
    }
    this._consume(TokenTypes.tokens.paren_right, "Expected ')' after function arguments.");
    let _return = null;
    if (this._match(TokenTypes.tokens.arrow)) {
      const attrs = this._attribute();
      _return = this._type_decl();
      if (_return != null)
        _return.attributes = attrs;
    }
    const body = this._compound_statement();
    return new Function$1(name2, args, _return, body);
  }
  _compound_statement() {
    const statements = [];
    this._consume(TokenTypes.tokens.brace_left, "Expected '{' for block.");
    while (!this._check(TokenTypes.tokens.brace_right)) {
      const statement = this._statement();
      if (statement !== null)
        statements.push(statement);
    }
    this._consume(TokenTypes.tokens.brace_right, "Expected '}' for block.");
    return statements;
  }
  _statement() {
    while (this._match(TokenTypes.tokens.semicolon) && !this._isAtEnd())
      ;
    if (this._check(TokenTypes.keywords.if))
      return this._if_statement();
    if (this._check(TokenTypes.keywords.switch))
      return this._switch_statement();
    if (this._check(TokenTypes.keywords.loop))
      return this._loop_statement();
    if (this._check(TokenTypes.keywords.for))
      return this._for_statement();
    if (this._check(TokenTypes.keywords.while))
      return this._while_statement();
    if (this._check(TokenTypes.keywords.continuing))
      return this._continuing_statement();
    if (this._check(TokenTypes.keywords.static_assert))
      return this._static_assert_statement();
    if (this._check(TokenTypes.tokens.brace_left))
      return this._compound_statement();
    let result = null;
    if (this._check(TokenTypes.keywords.return))
      result = this._return_statement();
    else if (this._check([
      TokenTypes.keywords.var,
      TokenTypes.keywords.let,
      TokenTypes.keywords.const
    ]))
      result = this._variable_statement();
    else if (this._match(TokenTypes.keywords.discard))
      result = new Discard();
    else if (this._match(TokenTypes.keywords.break))
      result = new Break();
    else if (this._match(TokenTypes.keywords.continue))
      result = new Continue();
    else
      result = this._increment_decrement_statement() || this._func_call_statement() || this._assignment_statement();
    if (result != null)
      this._consume(TokenTypes.tokens.semicolon, "Expected ';' after statement.");
    return result;
  }
  _static_assert_statement() {
    if (!this._match(TokenTypes.keywords.static_assert))
      return null;
    let expression = this._optional_paren_expression();
    return new StaticAssert(expression);
  }
  _while_statement() {
    if (!this._match(TokenTypes.keywords.while))
      return null;
    let condition = this._optional_paren_expression();
    const block = this._compound_statement();
    return new While(condition, block);
  }
  _continuing_statement() {
    if (!this._match(TokenTypes.keywords.continuing))
      return null;
    const block = this._compound_statement();
    return new Continuing(block);
  }
  _for_statement() {
    if (!this._match(TokenTypes.keywords.for))
      return null;
    this._consume(TokenTypes.tokens.paren_left, "Expected '('.");
    const init9 = !this._check(TokenTypes.tokens.semicolon) ? this._for_init() : null;
    this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
    const condition = !this._check(TokenTypes.tokens.semicolon) ? this._short_circuit_or_expression() : null;
    this._consume(TokenTypes.tokens.semicolon, "Expected ';'.");
    const increment = !this._check(TokenTypes.tokens.paren_right) ? this._for_increment() : null;
    this._consume(TokenTypes.tokens.paren_right, "Expected ')'.");
    const body = this._compound_statement();
    return new For(init9, condition, increment, body);
  }
  _for_init() {
    return this._variable_statement() || this._func_call_statement() || this._assignment_statement();
  }
  _for_increment() {
    return this._func_call_statement() || this._increment_decrement_statement() || this._assignment_statement();
  }
  _variable_statement() {
    if (this._check(TokenTypes.keywords.var)) {
      const _var = this._variable_decl();
      if (_var === null)
        throw this._error(this._peek(), "Variable declaration expected.");
      let value = null;
      if (this._match(TokenTypes.tokens.equal))
        value = this._short_circuit_or_expression();
      return new Var(_var.name, _var.type, _var.storage, _var.access, value);
    }
    if (this._match(TokenTypes.keywords.let)) {
      const name2 = this._consume(TokenTypes.tokens.ident, "Expected name for let.").toString();
      let type = null;
      if (this._match(TokenTypes.tokens.colon)) {
        const typeAttrs = this._attribute();
        type = this._type_decl();
        if (type != null)
          type.attributes = typeAttrs;
      }
      this._consume(TokenTypes.tokens.equal, "Expected '=' for let.");
      const value = this._short_circuit_or_expression();
      return new Let(name2, type, null, null, value);
    }
    if (this._match(TokenTypes.keywords.const)) {
      const name2 = this._consume(TokenTypes.tokens.ident, "Expected name for const.").toString();
      let type = null;
      if (this._match(TokenTypes.tokens.colon)) {
        const typeAttrs = this._attribute();
        type = this._type_decl();
        if (type != null)
          type.attributes = typeAttrs;
      }
      this._consume(TokenTypes.tokens.equal, "Expected '=' for const.");
      const value = this._short_circuit_or_expression();
      return new Const(name2, type, null, null, value);
    }
    return null;
  }
  _increment_decrement_statement() {
    const savedPos = this._current;
    const _var = this._unary_expression();
    if (_var == null)
      return null;
    if (!this._check(TokenTypes.increment_operators)) {
      this._current = savedPos;
      return null;
    }
    const token = this._consume(TokenTypes.increment_operators, "Expected increment operator");
    return new Increment(token.type === TokenTypes.tokens.plus_plus ? IncrementOperator.increment : IncrementOperator.decrement, _var);
  }
  _assignment_statement() {
    let _var = null;
    if (this._check(TokenTypes.tokens.brace_right))
      return null;
    let isUnderscore = this._match(TokenTypes.tokens.underscore);
    if (!isUnderscore)
      _var = this._unary_expression();
    if (!isUnderscore && _var == null)
      return null;
    const type = this._consume(TokenTypes.assignment_operators, "Expected assignment operator.");
    const value = this._short_circuit_or_expression();
    return new Assign(AssignOperator.parse(type.lexeme), _var, value);
  }
  _func_call_statement() {
    if (!this._check(TokenTypes.tokens.ident))
      return null;
    const savedPos = this._current;
    const name2 = this._consume(TokenTypes.tokens.ident, "Expected function name.");
    const args = this._argument_expression_list();
    if (args === null) {
      this._current = savedPos;
      return null;
    }
    return new Call(name2.lexeme, args);
  }
  _loop_statement() {
    if (!this._match(TokenTypes.keywords.loop))
      return null;
    this._consume(TokenTypes.tokens.brace_left, "Expected '{' for loop.");
    const statements = [];
    let statement = this._statement();
    while (statement !== null) {
      if (Array.isArray(statement)) {
        for (let s2 of statement) {
          statements.push(s2);
        }
      } else {
        statements.push(statement);
      }
      statement = this._statement();
    }
    let continuing = null;
    if (this._match(TokenTypes.keywords.continuing))
      continuing = this._compound_statement();
    this._consume(TokenTypes.tokens.brace_right, "Expected '}' for loop.");
    return new Loop(statements, continuing);
  }
  _switch_statement() {
    if (!this._match(TokenTypes.keywords.switch))
      return null;
    const condition = this._optional_paren_expression();
    this._consume(TokenTypes.tokens.brace_left, "Expected '{' for switch.");
    const body = this._switch_body();
    if (body == null || body.length == 0)
      throw this._error(this._previous(), "Expected 'case' or 'default'.");
    this._consume(TokenTypes.tokens.brace_right, "Expected '}' for switch.");
    return new Switch(condition, body);
  }
  _switch_body() {
    const cases = [];
    if (this._match(TokenTypes.keywords.case)) {
      const selector = this._case_selectors();
      this._match(TokenTypes.tokens.colon);
      this._consume(TokenTypes.tokens.brace_left, "Exected '{' for switch case.");
      const body = this._case_body();
      this._consume(TokenTypes.tokens.brace_right, "Exected '}' for switch case.");
      cases.push(new Case(selector, body));
    }
    if (this._match(TokenTypes.keywords.default)) {
      this._match(TokenTypes.tokens.colon);
      this._consume(TokenTypes.tokens.brace_left, "Exected '{' for switch default.");
      const body = this._case_body();
      this._consume(TokenTypes.tokens.brace_right, "Exected '}' for switch default.");
      cases.push(new Default(body));
    }
    if (this._check([TokenTypes.keywords.default, TokenTypes.keywords.case])) {
      const _cases = this._switch_body();
      cases.push(_cases[0]);
    }
    return cases;
  }
  _case_selectors() {
    var _a3, _b3, _c2, _d2;
    const selectors = [
      (_b3 = (_a3 = this._shift_expression()) === null || _a3 === void 0 ? void 0 : _a3.evaluate(this._context).toString()) !== null && _b3 !== void 0 ? _b3 : ""
    ];
    while (this._match(TokenTypes.tokens.comma)) {
      selectors.push((_d2 = (_c2 = this._shift_expression()) === null || _c2 === void 0 ? void 0 : _c2.evaluate(this._context).toString()) !== null && _d2 !== void 0 ? _d2 : "");
    }
    return selectors;
  }
  _case_body() {
    if (this._match(TokenTypes.keywords.fallthrough)) {
      this._consume(TokenTypes.tokens.semicolon, "Expected ';'");
      return [];
    }
    let statement = this._statement();
    if (statement == null)
      return [];
    if (!(statement instanceof Array)) {
      statement = [statement];
    }
    const nextStatement = this._case_body();
    if (nextStatement.length == 0)
      return statement;
    return [...statement, nextStatement[0]];
  }
  _if_statement() {
    if (!this._match(TokenTypes.keywords.if))
      return null;
    const condition = this._optional_paren_expression();
    const block = this._compound_statement();
    let elseif = [];
    if (this._match_elseif()) {
      elseif = this._elseif_statement(elseif);
    }
    let _else = null;
    if (this._match(TokenTypes.keywords.else))
      _else = this._compound_statement();
    return new If(condition, block, elseif, _else);
  }
  _match_elseif() {
    if (this._tokens[this._current].type === TokenTypes.keywords.else && this._tokens[this._current + 1].type === TokenTypes.keywords.if) {
      this._advance();
      this._advance();
      return true;
    }
    return false;
  }
  _elseif_statement(elseif = []) {
    const condition = this._optional_paren_expression();
    const block = this._compound_statement();
    elseif.push(new ElseIf(condition, block));
    if (this._match_elseif()) {
      this._elseif_statement(elseif);
    }
    return elseif;
  }
  _return_statement() {
    if (!this._match(TokenTypes.keywords.return))
      return null;
    const value = this._short_circuit_or_expression();
    return new Return(value);
  }
  _short_circuit_or_expression() {
    let expr = this._short_circuit_and_expr();
    while (this._match(TokenTypes.tokens.or_or)) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._short_circuit_and_expr());
    }
    return expr;
  }
  _short_circuit_and_expr() {
    let expr = this._inclusive_or_expression();
    while (this._match(TokenTypes.tokens.and_and)) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._inclusive_or_expression());
    }
    return expr;
  }
  _inclusive_or_expression() {
    let expr = this._exclusive_or_expression();
    while (this._match(TokenTypes.tokens.or)) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._exclusive_or_expression());
    }
    return expr;
  }
  _exclusive_or_expression() {
    let expr = this._and_expression();
    while (this._match(TokenTypes.tokens.xor)) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._and_expression());
    }
    return expr;
  }
  _and_expression() {
    let expr = this._equality_expression();
    while (this._match(TokenTypes.tokens.and)) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._equality_expression());
    }
    return expr;
  }
  _equality_expression() {
    const expr = this._relational_expression();
    if (this._match([TokenTypes.tokens.equal_equal, TokenTypes.tokens.not_equal])) {
      return new BinaryOperator(this._previous().toString(), expr, this._relational_expression());
    }
    return expr;
  }
  _relational_expression() {
    let expr = this._shift_expression();
    while (this._match([
      TokenTypes.tokens.less_than,
      TokenTypes.tokens.greater_than,
      TokenTypes.tokens.less_than_equal,
      TokenTypes.tokens.greater_than_equal
    ])) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._shift_expression());
    }
    return expr;
  }
  _shift_expression() {
    let expr = this._additive_expression();
    while (this._match([TokenTypes.tokens.shift_left, TokenTypes.tokens.shift_right])) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._additive_expression());
    }
    return expr;
  }
  _additive_expression() {
    let expr = this._multiplicative_expression();
    while (this._match([TokenTypes.tokens.plus, TokenTypes.tokens.minus])) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._multiplicative_expression());
    }
    return expr;
  }
  _multiplicative_expression() {
    let expr = this._unary_expression();
    while (this._match([
      TokenTypes.tokens.star,
      TokenTypes.tokens.forward_slash,
      TokenTypes.tokens.modulo
    ])) {
      expr = new BinaryOperator(this._previous().toString(), expr, this._unary_expression());
    }
    return expr;
  }
  _unary_expression() {
    if (this._match([
      TokenTypes.tokens.minus,
      TokenTypes.tokens.bang,
      TokenTypes.tokens.tilde,
      TokenTypes.tokens.star,
      TokenTypes.tokens.and
    ])) {
      return new UnaryOperator(this._previous().toString(), this._unary_expression());
    }
    return this._singular_expression();
  }
  _singular_expression() {
    const expr = this._primary_expression();
    const p2 = this._postfix_expression();
    if (p2)
      expr.postfix = p2;
    return expr;
  }
  _postfix_expression() {
    if (this._match(TokenTypes.tokens.bracket_left)) {
      const expr = this._short_circuit_or_expression();
      this._consume(TokenTypes.tokens.bracket_right, "Expected ']'.");
      const p2 = this._postfix_expression();
      if (p2)
        expr.postfix = p2;
      return expr;
    }
    if (this._match(TokenTypes.tokens.period)) {
      const name2 = this._consume(TokenTypes.tokens.ident, "Expected member name.");
      const p2 = this._postfix_expression();
      const expr = new StringExpr(name2.lexeme);
      if (p2)
        expr.postfix = p2;
      return expr;
    }
    return null;
  }
  _getStruct(name2) {
    if (this._context.aliases.has(name2)) {
      const alias = this._context.aliases.get(name2).type;
      return alias;
    }
    if (this._context.structs.has(name2)) {
      const struct = this._context.structs.get(name2);
      return struct;
    }
    return null;
  }
  _primary_expression() {
    if (this._match(TokenTypes.tokens.ident)) {
      const name2 = this._previous().toString();
      if (this._check(TokenTypes.tokens.paren_left)) {
        const args2 = this._argument_expression_list();
        const struct = this._getStruct(name2);
        if (struct != null) {
          return new CreateExpr(struct, args2);
        }
        return new CallExpr(name2, args2);
      }
      if (this._context.constants.has(name2)) {
        const c2 = this._context.constants.get(name2);
        return new ConstExpr(name2, c2.value);
      }
      return new VariableExpr(name2);
    }
    if (this._match(TokenTypes.const_literal)) {
      return new LiteralExpr(parseFloat(this._previous().toString()));
    }
    if (this._check(TokenTypes.tokens.paren_left)) {
      return this._paren_expression();
    }
    if (this._match(TokenTypes.keywords.bitcast)) {
      this._consume(TokenTypes.tokens.less_than, "Expected '<'.");
      const type2 = this._type_decl();
      this._consume(TokenTypes.tokens.greater_than, "Expected '>'.");
      const value = this._paren_expression();
      return new BitcastExpr(type2, value);
    }
    const type = this._type_decl();
    const args = this._argument_expression_list();
    return new TypecastExpr(type, args);
  }
  _argument_expression_list() {
    if (!this._match(TokenTypes.tokens.paren_left))
      return null;
    const args = [];
    do {
      if (this._check(TokenTypes.tokens.paren_right))
        break;
      const arg = this._short_circuit_or_expression();
      args.push(arg);
    } while (this._match(TokenTypes.tokens.comma));
    this._consume(TokenTypes.tokens.paren_right, "Expected ')' for agument list");
    return args;
  }
  _optional_paren_expression() {
    this._match(TokenTypes.tokens.paren_left);
    const expr = this._short_circuit_or_expression();
    this._match(TokenTypes.tokens.paren_right);
    return new GroupingExpr([expr]);
  }
  _paren_expression() {
    this._consume(TokenTypes.tokens.paren_left, "Expected '('.");
    const expr = this._short_circuit_or_expression();
    this._consume(TokenTypes.tokens.paren_right, "Expected ')'.");
    return new GroupingExpr([expr]);
  }
  _struct_decl() {
    if (!this._match(TokenTypes.keywords.struct))
      return null;
    const name2 = this._consume(TokenTypes.tokens.ident, "Expected name for struct.").toString();
    this._consume(TokenTypes.tokens.brace_left, "Expected '{' for struct body.");
    const members = [];
    while (!this._check(TokenTypes.tokens.brace_right)) {
      const memberAttrs = this._attribute();
      const memberName = this._consume(TokenTypes.tokens.ident, "Expected variable name.").toString();
      this._consume(TokenTypes.tokens.colon, "Expected ':' for struct member type.");
      const typeAttrs = this._attribute();
      const memberType = this._type_decl();
      if (memberType != null)
        memberType.attributes = typeAttrs;
      if (!this._check(TokenTypes.tokens.brace_right))
        this._consume(TokenTypes.tokens.comma, "Expected ',' for struct member.");
      else
        this._match(TokenTypes.tokens.comma);
      members.push(new Member(memberName, memberType, memberAttrs));
    }
    this._consume(TokenTypes.tokens.brace_right, "Expected '}' after struct body.");
    const structNode = new Struct(name2, members);
    this._context.structs.set(name2, structNode);
    return structNode;
  }
  _global_variable_decl() {
    const _var = this._variable_decl();
    if (_var && this._match(TokenTypes.tokens.equal))
      _var.value = this._const_expression();
    return _var;
  }
  _override_variable_decl() {
    const _override = this._override_decl();
    if (_override && this._match(TokenTypes.tokens.equal))
      _override.value = this._const_expression();
    return _override;
  }
  _global_const_decl() {
    if (!this._match(TokenTypes.keywords.const))
      return null;
    const name2 = this._consume(TokenTypes.tokens.ident, "Expected variable name");
    let type = null;
    if (this._match(TokenTypes.tokens.colon)) {
      const attrs = this._attribute();
      type = this._type_decl();
      if (type != null)
        type.attributes = attrs;
    }
    let value = null;
    if (this._match(TokenTypes.tokens.equal)) {
      const valueExpr = this._short_circuit_or_expression();
      if (valueExpr instanceof CreateExpr) {
        value = valueExpr;
      } else if (valueExpr instanceof ConstExpr && valueExpr.initializer instanceof CreateExpr) {
        value = valueExpr.initializer;
      } else {
        try {
          const constValue = valueExpr.evaluate(this._context);
          value = new LiteralExpr(constValue);
        } catch (_a3) {
          value = valueExpr;
        }
      }
    }
    const c2 = new Const(name2.toString(), type, "", "", value);
    this._context.constants.set(c2.name, c2);
    return c2;
  }
  _global_let_decl() {
    if (!this._match(TokenTypes.keywords.let))
      return null;
    const name2 = this._consume(TokenTypes.tokens.ident, "Expected variable name");
    let type = null;
    if (this._match(TokenTypes.tokens.colon)) {
      const attrs = this._attribute();
      type = this._type_decl();
      if (type != null)
        type.attributes = attrs;
    }
    let value = null;
    if (this._match(TokenTypes.tokens.equal)) {
      value = this._const_expression();
    }
    return new Let(name2.toString(), type, "", "", value);
  }
  _const_expression() {
    if (this._match(TokenTypes.const_literal))
      return new StringExpr(this._previous().toString());
    const type = this._type_decl();
    this._consume(TokenTypes.tokens.paren_left, "Expected '('.");
    let args = [];
    while (!this._check(TokenTypes.tokens.paren_right)) {
      args.push(this._const_expression());
      if (!this._check(TokenTypes.tokens.comma))
        break;
      this._advance();
    }
    this._consume(TokenTypes.tokens.paren_right, "Expected ')'.");
    return new CreateExpr(type, args);
  }
  _variable_decl() {
    if (!this._match(TokenTypes.keywords.var))
      return null;
    let storage = "";
    let access = "";
    if (this._match(TokenTypes.tokens.less_than)) {
      storage = this._consume(TokenTypes.storage_class, "Expected storage_class.").toString();
      if (this._match(TokenTypes.tokens.comma))
        access = this._consume(TokenTypes.access_mode, "Expected access_mode.").toString();
      this._consume(TokenTypes.tokens.greater_than, "Expected '>'.");
    }
    const name2 = this._consume(TokenTypes.tokens.ident, "Expected variable name");
    let type = null;
    if (this._match(TokenTypes.tokens.colon)) {
      const attrs = this._attribute();
      type = this._type_decl();
      if (type != null)
        type.attributes = attrs;
    }
    return new Var(name2.toString(), type, storage, access, null);
  }
  _override_decl() {
    if (!this._match(TokenTypes.keywords.override))
      return null;
    const name2 = this._consume(TokenTypes.tokens.ident, "Expected variable name");
    let type = null;
    if (this._match(TokenTypes.tokens.colon)) {
      const attrs = this._attribute();
      type = this._type_decl();
      if (type != null)
        type.attributes = attrs;
    }
    return new Override(name2.toString(), type, null);
  }
  _enable_directive() {
    const name2 = this._consume(TokenTypes.tokens.ident, "identity expected.");
    return new Enable(name2.toString());
  }
  _type_alias() {
    const name2 = this._consume(TokenTypes.tokens.ident, "identity expected.");
    this._consume(TokenTypes.tokens.equal, "Expected '=' for type alias.");
    let aliasType = this._type_decl();
    if (aliasType === null) {
      throw this._error(this._peek(), "Expected Type for Alias.");
    }
    if (this._context.aliases.has(aliasType.name)) {
      aliasType = this._context.aliases.get(aliasType.name).type;
    }
    const aliasNode = new Alias(name2.toString(), aliasType);
    this._context.aliases.set(aliasNode.name, aliasNode);
    return aliasNode;
  }
  _type_decl() {
    if (this._check([
      TokenTypes.tokens.ident,
      ...TokenTypes.texel_format,
      TokenTypes.keywords.bool,
      TokenTypes.keywords.f32,
      TokenTypes.keywords.i32,
      TokenTypes.keywords.u32
    ])) {
      const type2 = this._advance();
      const typeName = type2.toString();
      if (this._context.structs.has(typeName)) {
        return this._context.structs.get(typeName);
      }
      if (this._context.aliases.has(typeName)) {
        return this._context.aliases.get(typeName).type;
      }
      return new Type(type2.toString());
    }
    let type = this._texture_sampler_types();
    if (type)
      return type;
    if (this._check(TokenTypes.template_types)) {
      let type2 = this._advance().toString();
      let format = null;
      let access = null;
      if (this._match(TokenTypes.tokens.less_than)) {
        format = this._type_decl();
        access = null;
        if (this._match(TokenTypes.tokens.comma))
          access = this._consume(TokenTypes.access_mode, "Expected access_mode for pointer").toString();
        this._consume(TokenTypes.tokens.greater_than, "Expected '>' for type.");
      }
      return new TemplateType(type2, format, access);
    }
    if (this._match(TokenTypes.keywords.ptr)) {
      let pointer = this._previous().toString();
      this._consume(TokenTypes.tokens.less_than, "Expected '<' for pointer.");
      const storage = this._consume(TokenTypes.storage_class, "Expected storage_class for pointer");
      this._consume(TokenTypes.tokens.comma, "Expected ',' for pointer.");
      const decl = this._type_decl();
      let access = null;
      if (this._match(TokenTypes.tokens.comma))
        access = this._consume(TokenTypes.access_mode, "Expected access_mode for pointer").toString();
      this._consume(TokenTypes.tokens.greater_than, "Expected '>' for pointer.");
      return new PointerType(pointer, storage.toString(), decl, access);
    }
    const attrs = this._attribute();
    if (this._match(TokenTypes.keywords.array)) {
      let format = null;
      let countInt = -1;
      const array2 = this._previous();
      if (this._match(TokenTypes.tokens.less_than)) {
        format = this._type_decl();
        if (this._context.aliases.has(format.name)) {
          format = this._context.aliases.get(format.name).type;
        }
        let count3 = "";
        if (this._match(TokenTypes.tokens.comma)) {
          let c2 = this._shift_expression();
          count3 = c2.evaluate(this._context).toString();
        }
        this._consume(TokenTypes.tokens.greater_than, "Expected '>' for array.");
        countInt = count3 ? parseInt(count3) : 0;
      }
      return new ArrayType(array2.toString(), attrs, format, countInt);
    }
    return null;
  }
  _texture_sampler_types() {
    if (this._match(TokenTypes.sampler_type))
      return new SamplerType(this._previous().toString(), null, null);
    if (this._match(TokenTypes.depth_texture_type))
      return new SamplerType(this._previous().toString(), null, null);
    if (this._match(TokenTypes.sampled_texture_type) || this._match(TokenTypes.multisampled_texture_type)) {
      const sampler = this._previous();
      this._consume(TokenTypes.tokens.less_than, "Expected '<' for sampler type.");
      const format = this._type_decl();
      this._consume(TokenTypes.tokens.greater_than, "Expected '>' for sampler type.");
      return new SamplerType(sampler.toString(), format, null);
    }
    if (this._match(TokenTypes.storage_texture_type)) {
      const sampler = this._previous();
      this._consume(TokenTypes.tokens.less_than, "Expected '<' for sampler type.");
      const format = this._consume(TokenTypes.texel_format, "Invalid texel format.").toString();
      this._consume(TokenTypes.tokens.comma, "Expected ',' after texel format.");
      const access = this._consume(TokenTypes.access_mode, "Expected access mode for storage texture type.").toString();
      this._consume(TokenTypes.tokens.greater_than, "Expected '>' for sampler type.");
      return new SamplerType(sampler.toString(), format, access);
    }
    return null;
  }
  _attribute() {
    let attributes = [];
    while (this._match(TokenTypes.tokens.attr)) {
      const name2 = this._consume(TokenTypes.attribute_name, "Expected attribute name");
      const attr2 = new Attribute$1(name2.toString(), null);
      if (this._match(TokenTypes.tokens.paren_left)) {
        attr2.value = this._consume(TokenTypes.literal_or_ident, "Expected attribute value").toString();
        if (this._check(TokenTypes.tokens.comma)) {
          this._advance();
          do {
            const v5 = this._consume(TokenTypes.literal_or_ident, "Expected attribute value").toString();
            if (!(attr2.value instanceof Array)) {
              attr2.value = [attr2.value];
            }
            attr2.value.push(v5);
          } while (this._match(TokenTypes.tokens.comma));
        }
        this._consume(TokenTypes.tokens.paren_right, "Expected ')'");
      }
      attributes.push(attr2);
    }
    while (this._match(TokenTypes.tokens.attr_left)) {
      if (!this._check(TokenTypes.tokens.attr_right)) {
        do {
          const name2 = this._consume(TokenTypes.attribute_name, "Expected attribute name");
          const attr2 = new Attribute$1(name2.toString(), null);
          if (this._match(TokenTypes.tokens.paren_left)) {
            attr2.value = [
              this._consume(TokenTypes.literal_or_ident, "Expected attribute value").toString()
            ];
            if (this._check(TokenTypes.tokens.comma)) {
              this._advance();
              do {
                const v5 = this._consume(TokenTypes.literal_or_ident, "Expected attribute value").toString();
                attr2.value.push(v5);
              } while (this._match(TokenTypes.tokens.comma));
            }
            this._consume(TokenTypes.tokens.paren_right, "Expected ')'");
          }
          attributes.push(attr2);
        } while (this._match(TokenTypes.tokens.comma));
      }
      this._consume(TokenTypes.tokens.attr_right, "Expected ']]' after attribute declarations");
    }
    if (attributes.length == 0)
      return null;
    return attributes;
  }
}
class TypeInfo {
  constructor(name2, attributes) {
    this.name = name2;
    this.attributes = attributes;
    this.size = 0;
  }
  get isArray() {
    return false;
  }
  get isStruct() {
    return false;
  }
  get isTemplate() {
    return false;
  }
}
class MemberInfo {
  constructor(name2, type, attributes) {
    this.name = name2;
    this.type = type;
    this.attributes = attributes;
    this.offset = 0;
    this.size = 0;
  }
  get isArray() {
    return this.type.isArray;
  }
  get isStruct() {
    return this.type.isStruct;
  }
  get isTemplate() {
    return this.type.isTemplate;
  }
  get align() {
    return this.type.isStruct ? this.type.align : 0;
  }
  get members() {
    return this.type.isStruct ? this.type.members : null;
  }
  get format() {
    return this.type.isArray ? this.type.format : this.type.isTemplate ? this.type.format : null;
  }
  get count() {
    return this.type.isArray ? this.type.count : 0;
  }
  get stride() {
    return this.type.isArray ? this.type.stride : this.size;
  }
}
class StructInfo extends TypeInfo {
  constructor(name2, attributes) {
    super(name2, attributes);
    this.members = [];
    this.align = 0;
  }
  get isStruct() {
    return true;
  }
}
class ArrayInfo extends TypeInfo {
  constructor(name2, attributes) {
    super(name2, attributes);
    this.count = 0;
    this.stride = 0;
  }
  get isArray() {
    return true;
  }
}
class TemplateInfo extends TypeInfo {
  constructor(name2, format, attributes, access) {
    super(name2, attributes);
    this.format = format;
    this.access = access;
  }
  get isTemplate() {
    return true;
  }
}
var ResourceType;
(function(ResourceType2) {
  ResourceType2[ResourceType2["Uniform"] = 0] = "Uniform";
  ResourceType2[ResourceType2["Storage"] = 1] = "Storage";
  ResourceType2[ResourceType2["Texture"] = 2] = "Texture";
  ResourceType2[ResourceType2["Sampler"] = 3] = "Sampler";
  ResourceType2[ResourceType2["StorageTexture"] = 4] = "StorageTexture";
})(ResourceType || (ResourceType = {}));
class VariableInfo {
  constructor(name2, type, group, binding, attributes, resourceType, access) {
    this.name = name2;
    this.type = type;
    this.group = group;
    this.binding = binding;
    this.attributes = attributes;
    this.resourceType = resourceType;
    this.access = access;
  }
  get isArray() {
    return this.type.isArray;
  }
  get isStruct() {
    return this.type.isStruct;
  }
  get isTemplate() {
    return this.type.isTemplate;
  }
  get size() {
    return this.type.size;
  }
  get align() {
    return this.type.isStruct ? this.type.align : 0;
  }
  get members() {
    return this.type.isStruct ? this.type.members : null;
  }
  get format() {
    return this.type.isArray ? this.type.format : this.type.isTemplate ? this.type.format : null;
  }
  get count() {
    return this.type.isArray ? this.type.count : 0;
  }
  get stride() {
    return this.type.isArray ? this.type.stride : this.size;
  }
}
class AliasInfo {
  constructor(name2, type) {
    this.name = name2;
    this.type = type;
  }
}
class _TypeSize {
  constructor(align, size12) {
    this.align = align;
    this.size = size12;
  }
}
class InputInfo {
  constructor(name2, type, locationType, location2) {
    this.name = name2;
    this.type = type;
    this.locationType = locationType;
    this.location = location2;
    this.interpolation = null;
  }
}
class OutputInfo {
  constructor(name2, type, locationType, location2) {
    this.name = name2;
    this.type = type;
    this.locationType = locationType;
    this.location = location2;
  }
}
class FunctionInfo {
  constructor(name2, stage = null) {
    this.stage = null;
    this.inputs = [];
    this.outputs = [];
    this.name = name2;
    this.stage = stage;
  }
}
class EntryFunctions {
  constructor() {
    this.vertex = [];
    this.fragment = [];
    this.compute = [];
  }
}
class OverrideInfo {
  constructor(name2, type, attributes, id) {
    this.name = name2;
    this.type = type;
    this.attributes = attributes;
    this.id = id;
  }
}
class WgslReflect {
  constructor(code) {
    this.uniforms = [];
    this.storage = [];
    this.textures = [];
    this.samplers = [];
    this.aliases = [];
    this.overrides = [];
    this.structs = [];
    this.entry = new EntryFunctions();
    this._types = /* @__PURE__ */ new Map();
    if (code) {
      this.update(code);
    }
  }
  _isStorageTexture(type) {
    return type.name == "texture_storage_1d" || type.name == "texture_storage_2d" || type.name == "texture_storage_2d_array" || type.name == "texture_storage_3d";
  }
  update(code) {
    const parser = new WgslParser();
    const ast = parser.parse(code);
    for (const node of ast) {
      if (node instanceof Struct) {
        const info = this._getTypeInfo(node, null);
        if (info instanceof StructInfo) {
          this.structs.push(info);
        }
        continue;
      }
      if (node instanceof Alias) {
        this.aliases.push(this._getAliasInfo(node));
        continue;
      }
      if (node instanceof Override) {
        const v5 = node;
        const id = this._getAttributeNum(v5.attributes, "id", 0);
        const type = v5.type != null ? this._getTypeInfo(v5.type, v5.attributes) : null;
        this.overrides.push(new OverrideInfo(v5.name, type, v5.attributes, id));
        continue;
      }
      if (this._isUniformVar(node)) {
        const v5 = node;
        const g2 = this._getAttributeNum(v5.attributes, "group", 0);
        const b2 = this._getAttributeNum(v5.attributes, "binding", 0);
        const type = this._getTypeInfo(v5.type, v5.attributes);
        const varInfo = new VariableInfo(v5.name, type, g2, b2, v5.attributes, ResourceType.Uniform, v5.access);
        this.uniforms.push(varInfo);
        continue;
      }
      if (this._isStorageVar(node)) {
        const v5 = node;
        const g2 = this._getAttributeNum(v5.attributes, "group", 0);
        const b2 = this._getAttributeNum(v5.attributes, "binding", 0);
        const type = this._getTypeInfo(v5.type, v5.attributes);
        const isStorageTexture = this._isStorageTexture(type);
        const varInfo = new VariableInfo(v5.name, type, g2, b2, v5.attributes, isStorageTexture ? ResourceType.StorageTexture : ResourceType.Storage, v5.access);
        this.storage.push(varInfo);
        continue;
      }
      if (this._isTextureVar(node)) {
        const v5 = node;
        const g2 = this._getAttributeNum(v5.attributes, "group", 0);
        const b2 = this._getAttributeNum(v5.attributes, "binding", 0);
        const type = this._getTypeInfo(v5.type, v5.attributes);
        const isStorageTexture = this._isStorageTexture(type);
        const varInfo = new VariableInfo(v5.name, type, g2, b2, v5.attributes, isStorageTexture ? ResourceType.StorageTexture : ResourceType.Texture, v5.access);
        if (isStorageTexture) {
          this.storage.push(varInfo);
        } else {
          this.textures.push(varInfo);
        }
        continue;
      }
      if (this._isSamplerVar(node)) {
        const v5 = node;
        const g2 = this._getAttributeNum(v5.attributes, "group", 0);
        const b2 = this._getAttributeNum(v5.attributes, "binding", 0);
        const type = this._getTypeInfo(v5.type, v5.attributes);
        const varInfo = new VariableInfo(v5.name, type, g2, b2, v5.attributes, ResourceType.Sampler, v5.access);
        this.samplers.push(varInfo);
        continue;
      }
      if (node instanceof Function$1) {
        const vertexStage = this._getAttribute(node, "vertex");
        const fragmentStage = this._getAttribute(node, "fragment");
        const computeStage = this._getAttribute(node, "compute");
        const stage = vertexStage || fragmentStage || computeStage;
        if (stage) {
          const fn2 = new FunctionInfo(node.name, stage.name);
          fn2.inputs = this._getInputs(node.args);
          fn2.outputs = this._getOutputs(node.returnType);
          this.entry[stage.name].push(fn2);
        }
        continue;
      }
    }
  }
  getBindGroups() {
    const groups = [];
    function _makeRoom(group, binding) {
      if (group >= groups.length)
        groups.length = group + 1;
      if (groups[group] === void 0)
        groups[group] = [];
      if (binding >= groups[group].length)
        groups[group].length = binding + 1;
    }
    for (const u2 of this.uniforms) {
      _makeRoom(u2.group, u2.binding);
      const group = groups[u2.group];
      group[u2.binding] = u2;
    }
    for (const u2 of this.storage) {
      _makeRoom(u2.group, u2.binding);
      const group = groups[u2.group];
      group[u2.binding] = u2;
    }
    for (const t2 of this.textures) {
      _makeRoom(t2.group, t2.binding);
      const group = groups[t2.group];
      group[t2.binding] = t2;
    }
    for (const t2 of this.samplers) {
      _makeRoom(t2.group, t2.binding);
      const group = groups[t2.group];
      group[t2.binding] = t2;
    }
    return groups;
  }
  _getOutputs(type, outputs = void 0) {
    if (outputs === void 0)
      outputs = [];
    if (type instanceof Struct) {
      this._getStructOutputs(type, outputs);
    } else {
      const output2 = this._getOutputInfo(type);
      if (output2 !== null)
        outputs.push(output2);
    }
    return outputs;
  }
  _getStructOutputs(struct, outputs) {
    for (const m2 of struct.members) {
      if (m2.type instanceof Struct) {
        this._getStructOutputs(m2.type, outputs);
      } else {
        const location2 = this._getAttribute(m2, "location") || this._getAttribute(m2, "builtin");
        if (location2 !== null) {
          const typeInfo = this._getTypeInfo(m2.type, m2.type.attributes);
          const locationValue = this._parseInt(location2.value);
          const info = new OutputInfo(m2.name, typeInfo, location2.name, locationValue);
          outputs.push(info);
        }
      }
    }
  }
  _getOutputInfo(type) {
    const location2 = this._getAttribute(type, "location") || this._getAttribute(type, "builtin");
    if (location2 !== null) {
      const typeInfo = this._getTypeInfo(type, type.attributes);
      const locationValue = this._parseInt(location2.value);
      const info = new OutputInfo("", typeInfo, location2.name, locationValue);
      return info;
    }
    return null;
  }
  _getInputs(args, inputs = void 0) {
    if (inputs === void 0)
      inputs = [];
    for (const arg of args) {
      if (arg.type instanceof Struct) {
        this._getStructInputs(arg.type, inputs);
      } else {
        const input = this._getInputInfo(arg);
        if (input !== null)
          inputs.push(input);
      }
    }
    return inputs;
  }
  _getStructInputs(struct, inputs) {
    for (const m2 of struct.members) {
      if (m2.type instanceof Struct) {
        this._getStructInputs(m2.type, inputs);
      } else {
        const input = this._getInputInfo(m2);
        if (input !== null)
          inputs.push(input);
      }
    }
  }
  _getInputInfo(node) {
    const location2 = this._getAttribute(node, "location") || this._getAttribute(node, "builtin");
    if (location2 !== null) {
      const interpolation = this._getAttribute(node, "interpolation");
      const type = this._getTypeInfo(node.type, node.attributes);
      const locationValue = this._parseInt(location2.value);
      const info = new InputInfo(node.name, type, location2.name, locationValue);
      if (interpolation !== null) {
        info.interpolation = this._parseString(interpolation.value);
      }
      return info;
    }
    return null;
  }
  _parseString(s2) {
    if (s2 instanceof Array) {
      s2 = s2[0];
    }
    return s2;
  }
  _parseInt(s2) {
    if (s2 instanceof Array) {
      s2 = s2[0];
    }
    const n2 = parseInt(s2);
    return isNaN(n2) ? s2 : n2;
  }
  _getAlias(name2) {
    for (const a2 of this.aliases) {
      if (a2.name == name2)
        return a2.type;
    }
    return null;
  }
  _getAliasInfo(node) {
    return new AliasInfo(node.name, this._getTypeInfo(node.type, null));
  }
  _getTypeInfo(type, attributes) {
    if (this._types.has(type)) {
      return this._types.get(type);
    }
    if (type instanceof ArrayType) {
      const a2 = type;
      const t2 = this._getTypeInfo(a2.format, a2.attributes);
      const info2 = new ArrayInfo(a2.name, attributes);
      info2.format = t2;
      info2.count = a2.count;
      this._types.set(type, info2);
      this._updateTypeInfo(info2);
      return info2;
    }
    if (type instanceof Struct) {
      const s2 = type;
      const info2 = new StructInfo(s2.name, attributes);
      for (const m2 of s2.members) {
        const t2 = this._getTypeInfo(m2.type, m2.attributes);
        info2.members.push(new MemberInfo(m2.name, t2, m2.attributes));
      }
      this._types.set(type, info2);
      this._updateTypeInfo(info2);
      return info2;
    }
    if (type instanceof SamplerType) {
      const s2 = type;
      const formatIsType = s2.format instanceof Type;
      const format = s2.format ? formatIsType ? this._getTypeInfo(s2.format, null) : new TypeInfo(s2.format, null) : null;
      const info2 = new TemplateInfo(s2.name, format, attributes, s2.access);
      this._types.set(type, info2);
      this._updateTypeInfo(info2);
      return info2;
    }
    if (type instanceof TemplateType) {
      const t2 = type;
      const format = t2.format ? this._getTypeInfo(t2.format, null) : null;
      const info2 = new TemplateInfo(t2.name, format, attributes, t2.access);
      this._types.set(type, info2);
      this._updateTypeInfo(info2);
      return info2;
    }
    const info = new TypeInfo(type.name, attributes);
    this._types.set(type, info);
    this._updateTypeInfo(info);
    return info;
  }
  _updateTypeInfo(type) {
    var _a3, _b3;
    const typeSize = this._getTypeSize(type);
    type.size = (_a3 = typeSize === null || typeSize === void 0 ? void 0 : typeSize.size) !== null && _a3 !== void 0 ? _a3 : 0;
    if (type instanceof ArrayInfo) {
      const formatInfo = this._getTypeSize(type["format"]);
      type.stride = (_b3 = formatInfo === null || formatInfo === void 0 ? void 0 : formatInfo.size) !== null && _b3 !== void 0 ? _b3 : 0;
      this._updateTypeInfo(type["format"]);
    }
    if (type instanceof StructInfo) {
      this._updateStructInfo(type);
    }
  }
  _updateStructInfo(struct) {
    var _a3;
    let offset = 0;
    let lastSize = 0;
    let lastOffset = 0;
    let structAlign = 0;
    for (let mi = 0, ml = struct.members.length; mi < ml; ++mi) {
      const member = struct.members[mi];
      const sizeInfo = this._getTypeSize(member);
      if (!sizeInfo)
        continue;
      (_a3 = this._getAlias(member.type.name)) !== null && _a3 !== void 0 ? _a3 : member.type;
      const align = sizeInfo.align;
      const size12 = sizeInfo.size;
      offset = this._roundUp(align, offset + lastSize);
      lastSize = size12;
      lastOffset = offset;
      structAlign = Math.max(structAlign, align);
      member.offset = offset;
      member.size = size12;
      this._updateTypeInfo(member.type);
    }
    struct.size = this._roundUp(structAlign, lastOffset + lastSize);
    struct.align = structAlign;
  }
  _getTypeSize(type) {
    var _a3;
    if (type === null || type === void 0)
      return null;
    const explicitSize = this._getAttributeNum(type.attributes, "size", 0);
    const explicitAlign = this._getAttributeNum(type.attributes, "align", 0);
    if (type instanceof MemberInfo)
      type = type.type;
    if (type instanceof TypeInfo) {
      const alias = this._getAlias(type.name);
      if (alias !== null) {
        type = alias;
      }
    }
    {
      const info = WgslReflect._typeInfo[type.name];
      if (info !== void 0) {
        const divisor = type["format"] === "f16" ? 2 : 1;
        return new _TypeSize(Math.max(explicitAlign, info.align / divisor), Math.max(explicitSize, info.size / divisor));
      }
    }
    {
      const info = WgslReflect._typeInfo[type.name.substring(0, type.name.length - 1)];
      if (info) {
        const divisor = type.name[type.name.length - 1] === "h" ? 2 : 1;
        return new _TypeSize(Math.max(explicitAlign, info.align / divisor), Math.max(explicitSize, info.size / divisor));
      }
    }
    if (type instanceof ArrayInfo) {
      let arrayType = type;
      let align = 8;
      let size12 = 8;
      const E3 = this._getTypeSize(arrayType.format);
      if (E3 !== null) {
        size12 = E3.size;
        align = E3.align;
      }
      const N2 = arrayType.count;
      const stride = this._getAttributeNum((_a3 = type === null || type === void 0 ? void 0 : type.attributes) !== null && _a3 !== void 0 ? _a3 : null, "stride", this._roundUp(align, size12));
      size12 = N2 * stride;
      if (explicitSize)
        size12 = explicitSize;
      return new _TypeSize(Math.max(explicitAlign, align), Math.max(explicitSize, size12));
    }
    if (type instanceof StructInfo) {
      let align = 0;
      let size12 = 0;
      let offset = 0;
      let lastSize = 0;
      let lastOffset = 0;
      for (const m2 of type.members) {
        const mi = this._getTypeSize(m2.type);
        if (mi !== null) {
          align = Math.max(mi.align, align);
          offset = this._roundUp(mi.align, offset + lastSize);
          lastSize = mi.size;
          lastOffset = offset;
        }
      }
      size12 = this._roundUp(align, lastOffset + lastSize);
      return new _TypeSize(Math.max(explicitAlign, align), Math.max(explicitSize, size12));
    }
    return null;
  }
  _isUniformVar(node) {
    return node instanceof Var && node.storage == "uniform";
  }
  _isStorageVar(node) {
    return node instanceof Var && node.storage == "storage";
  }
  _isTextureVar(node) {
    return node instanceof Var && node.type !== null && WgslReflect._textureTypes.indexOf(node.type.name) != -1;
  }
  _isSamplerVar(node) {
    return node instanceof Var && node.type !== null && WgslReflect._samplerTypes.indexOf(node.type.name) != -1;
  }
  _getAttribute(node, name2) {
    const obj = node;
    if (!obj || !obj["attributes"])
      return null;
    const attrs = obj["attributes"];
    for (let a2 of attrs) {
      if (a2.name == name2)
        return a2;
    }
    return null;
  }
  _getAttributeNum(attributes, name2, defaultValue2) {
    if (attributes === null)
      return defaultValue2;
    for (let a2 of attributes) {
      if (a2.name == name2) {
        let v5 = a2 !== null && a2.value !== null ? a2.value : defaultValue2;
        if (v5 instanceof Array) {
          v5 = v5[0];
        }
        if (typeof v5 === "number") {
          return v5;
        }
        if (typeof v5 === "string") {
          return parseInt(v5);
        }
        return defaultValue2;
      }
    }
    return defaultValue2;
  }
  _roundUp(k2, n2) {
    return Math.ceil(n2 / k2) * k2;
  }
}
WgslReflect._typeInfo = {
  f16: { align: 2, size: 2 },
  i32: { align: 4, size: 4 },
  u32: { align: 4, size: 4 },
  f32: { align: 4, size: 4 },
  atomic: { align: 4, size: 4 },
  vec2: { align: 8, size: 8 },
  vec3: { align: 16, size: 12 },
  vec4: { align: 16, size: 16 },
  mat2x2: { align: 8, size: 16 },
  mat3x2: { align: 8, size: 24 },
  mat4x2: { align: 8, size: 32 },
  mat2x3: { align: 16, size: 32 },
  mat3x3: { align: 16, size: 48 },
  mat4x3: { align: 16, size: 64 },
  mat2x4: { align: 16, size: 32 },
  mat3x4: { align: 16, size: 48 },
  mat4x4: { align: 16, size: 64 }
};
WgslReflect._textureTypes = TokenTypes.any_texture_type.map((t2) => {
  return t2.name;
});
WgslReflect._samplerTypes = TokenTypes.sampler_type.map((t2) => {
  return t2.name;
});
function getShaderLayoutFromWGSL(source) {
  const shaderLayout = { attributes: [], bindings: [] };
  let parsedWGSL;
  try {
    parsedWGSL = parseWGSL(source);
  } catch (error2) {
    log.error(error2.message)();
    return shaderLayout;
  }
  for (const uniform of parsedWGSL.uniforms) {
    const members = [];
    for (const member of uniform.type.members) {
      members.push({
        name: member.name,
        type: getType$1(member.type)
      });
    }
    shaderLayout.bindings.push({
      type: "uniform",
      name: uniform.name,
      location: uniform.binding,
      // @ts-expect-error
      group: uniform.group,
      members
    });
  }
  const vertex2 = parsedWGSL.entry.vertex[0];
  const attributeCount = (vertex2 == null ? void 0 : vertex2.inputs.length) || 0;
  for (let i2 = 0; i2 < attributeCount; i2++) {
    const wgslAttribute = vertex2.inputs[i2];
    if (wgslAttribute.locationType === "location") {
      const type = getType$1(wgslAttribute.type);
      shaderLayout.attributes.push({
        name: wgslAttribute.name,
        location: wgslAttribute.location,
        type
      });
    }
  }
  return shaderLayout;
}
function getType$1(type) {
  return type.format ? `${type.name}<${type.format.name}>` : type.name;
}
function parseWGSL(source) {
  try {
    return new WgslReflect(source);
  } catch (error2) {
    if (error2 instanceof Error) {
      throw error2;
    }
    let message2 = "WGSL parse error";
    if (typeof error2 === "object" && (error2 == null ? void 0 : error2.message)) {
      message2 += `: ${error2.message} `;
    }
    if (typeof error2 === "object" && (error2 == null ? void 0 : error2.token)) {
      message2 += error2.token.line || "";
    }
    throw new Error(message2, { cause: error2 });
  }
}
const fp32shader = `#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND
const float TWO_PI = 6.2831854820251465;
const float PI_2 = 1.5707963705062866;
const float PI_16 = 0.1963495463132858;
const float SIN_TABLE_0 = 0.19509032368659973;
const float SIN_TABLE_1 = 0.3826834261417389;
const float SIN_TABLE_2 = 0.5555702447891235;
const float SIN_TABLE_3 = 0.7071067690849304;
const float COS_TABLE_0 = 0.9807852506637573;
const float COS_TABLE_1 = 0.9238795042037964;
const float COS_TABLE_2 = 0.8314695954322815;
const float COS_TABLE_3 = 0.7071067690849304;
const float INVERSE_FACTORIAL_3 = 1.666666716337204e-01;
const float INVERSE_FACTORIAL_5 = 8.333333767950535e-03;
const float INVERSE_FACTORIAL_7 = 1.9841270113829523e-04;
const float INVERSE_FACTORIAL_9 = 2.75573188446287533e-06;
float sin_taylor_fp32(float a) {
float r, s, t, x;
if (a == 0.0) {
return 0.0;
}
x = -a * a;
s = a;
r = a;
r = r * x;
t = r * INVERSE_FACTORIAL_3;
s = s + t;
r = r * x;
t = r * INVERSE_FACTORIAL_5;
s = s + t;
r = r * x;
t = r * INVERSE_FACTORIAL_7;
s = s + t;
r = r * x;
t = r * INVERSE_FACTORIAL_9;
s = s + t;
return s;
}
void sincos_taylor_fp32(float a, out float sin_t, out float cos_t) {
if (a == 0.0) {
sin_t = 0.0;
cos_t = 1.0;
}
sin_t = sin_taylor_fp32(a);
cos_t = sqrt(1.0 - sin_t * sin_t);
}
float tan_taylor_fp32(float a) {
float sin_a;
float cos_a;
if (a == 0.0) {
return 0.0;
}
float z = floor(a / TWO_PI);
float r = a - TWO_PI * z;
float t;
float q = floor(r / PI_2 + 0.5);
int j = int(q);
if (j < -2 || j > 2) {
return 1.0 / 0.0;
}
t = r - PI_2 * q;
q = floor(t / PI_16 + 0.5);
int k = int(q);
int abs_k = int(abs(float(k)));
if (abs_k > 4) {
return 1.0 / 0.0;
} else {
t = t - PI_16 * q;
}
float u = 0.0;
float v = 0.0;
float sin_t, cos_t;
float s, c;
sincos_taylor_fp32(t, sin_t, cos_t);
if (k == 0) {
s = sin_t;
c = cos_t;
} else {
if (abs(float(abs_k) - 1.0) < 0.5) {
u = COS_TABLE_0;
v = SIN_TABLE_0;
} else if (abs(float(abs_k) - 2.0) < 0.5) {
u = COS_TABLE_1;
v = SIN_TABLE_1;
} else if (abs(float(abs_k) - 3.0) < 0.5) {
u = COS_TABLE_2;
v = SIN_TABLE_2;
} else if (abs(float(abs_k) - 4.0) < 0.5) {
u = COS_TABLE_3;
v = SIN_TABLE_3;
}
if (k > 0) {
s = u * sin_t + v * cos_t;
c = u * cos_t - v * sin_t;
} else {
s = u * sin_t - v * cos_t;
c = u * cos_t + v * sin_t;
}
}
if (j == 0) {
sin_a = s;
cos_a = c;
} else if (j == 1) {
sin_a = c;
cos_a = -s;
} else if (j == -1) {
sin_a = -c;
cos_a = s;
} else {
sin_a = -s;
cos_a = -c;
}
return sin_a / cos_a;
}
#endif
float tan_fp32(float a) {
#ifdef LUMA_FP32_TAN_PRECISION_WORKAROUND
return tan_taylor_fp32(a);
#else
return tan(a);
#endif
}
`;
const fp32 = {
  name: "fp32",
  vs: fp32shader
};
const DEFAULT_HIGHLIGHT_COLOR = new Float32Array([0, 1, 1, 1]);
const vs$i = `uniform pickingUniforms {
float isActive;
float isAttribute;
float isHighlightActive;
float useFloatColors;
vec3 highlightedObjectColor;
vec4 highlightColor;
} picking;
out vec4 picking_vRGBcolor_Avalid;
vec3 picking_normalizeColor(vec3 color) {
return picking.useFloatColors > 0.5 ? color : color / 255.0;
}
vec4 picking_normalizeColor(vec4 color) {
return picking.useFloatColors > 0.5 ? color : color / 255.0;
}
bool picking_isColorZero(vec3 color) {
return dot(color, vec3(1.0)) < 0.00001;
}
bool picking_isColorValid(vec3 color) {
return dot(color, vec3(1.0)) > 0.00001;
}
bool isVertexHighlighted(vec3 vertexColor) {
vec3 highlightedObjectColor = picking_normalizeColor(picking.highlightedObjectColor);
return
bool(picking.isHighlightActive) && picking_isColorZero(abs(vertexColor - highlightedObjectColor));
}
void picking_setPickingColor(vec3 pickingColor) {
pickingColor = picking_normalizeColor(pickingColor);
if (bool(picking.isActive)) {
picking_vRGBcolor_Avalid.a = float(picking_isColorValid(pickingColor));
if (!bool(picking.isAttribute)) {
picking_vRGBcolor_Avalid.rgb = pickingColor;
}
} else {
picking_vRGBcolor_Avalid.a = float(isVertexHighlighted(pickingColor));
}
}
void picking_setPickingAttribute(float value) {
if (bool(picking.isAttribute)) {
picking_vRGBcolor_Avalid.r = value;
}
}
void picking_setPickingAttribute(vec2 value) {
if (bool(picking.isAttribute)) {
picking_vRGBcolor_Avalid.rg = value;
}
}
void picking_setPickingAttribute(vec3 value) {
if (bool(picking.isAttribute)) {
picking_vRGBcolor_Avalid.rgb = value;
}
}
`;
const fs$i = `uniform pickingUniforms {
float isActive;
float isAttribute;
float isHighlightActive;
float useFloatColors;
vec3 highlightedObjectColor;
vec4 highlightColor;
} picking;
in vec4 picking_vRGBcolor_Avalid;
vec4 picking_filterHighlightColor(vec4 color) {
if (picking.isActive > 0.5) {
return color;
}
bool selected = bool(picking_vRGBcolor_Avalid.a);
if (selected) {
float highLightAlpha = picking.highlightColor.a;
float blendedAlpha = highLightAlpha + color.a * (1.0 - highLightAlpha);
float highLightRatio = highLightAlpha / blendedAlpha;
vec3 blendedRGB = mix(color.rgb, picking.highlightColor.rgb, highLightRatio);
return vec4(blendedRGB, blendedAlpha);
} else {
return color;
}
}
vec4 picking_filterPickingColor(vec4 color) {
if (bool(picking.isActive)) {
if (picking_vRGBcolor_Avalid.a == 0.0) {
discard;
}
return picking_vRGBcolor_Avalid;
}
return color;
}
vec4 picking_filterColor(vec4 color) {
vec4 highlightColor = picking_filterHighlightColor(color);
return picking_filterPickingColor(highlightColor);
}
`;
const picking$1 = {
  name: "picking",
  vs: vs$i,
  fs: fs$i,
  uniformTypes: {
    isActive: "f32",
    isAttribute: "f32",
    isHighlightActive: "f32",
    useFloatColors: "f32",
    highlightedObjectColor: "vec3<f32>",
    highlightColor: "vec4<f32>"
  },
  defaultUniforms: {
    isActive: false,
    isAttribute: false,
    isHighlightActive: false,
    useFloatColors: true,
    highlightedObjectColor: new Float32Array([0, 0, 0]),
    highlightColor: DEFAULT_HIGHLIGHT_COLOR
  },
  getUniforms: getUniforms$5
};
function getUniforms$5(opts = {}, prevUniforms) {
  const uniforms = {};
  if (opts.highlightedObjectColor === void 0)
    ;
  else if (opts.highlightedObjectColor === null) {
    uniforms.isHighlightActive = false;
  } else {
    uniforms.isHighlightActive = true;
    const highlightedObjectColor = opts.highlightedObjectColor.slice(0, 3);
    uniforms.highlightedObjectColor = highlightedObjectColor;
  }
  if (opts.highlightColor) {
    const color = Array.from(opts.highlightColor, (x2) => x2 / 255);
    if (!Number.isFinite(color[3])) {
      color[3] = 1;
    }
    uniforms.highlightColor = color;
  }
  if (opts.isActive !== void 0) {
    uniforms.isActive = Boolean(opts.isActive);
    uniforms.isAttribute = Boolean(opts.isAttribute);
  }
  if (opts.useFloatColors !== void 0) {
    uniforms.useFloatColors = Boolean(opts.useFloatColors);
  }
  return uniforms;
}
function fp64ify(a2, out = [], startIndex = 0) {
  const hiPart = Math.fround(a2);
  const loPart = a2 - hiPart;
  out[startIndex] = hiPart;
  out[startIndex + 1] = loPart;
  return out;
}
function fp64LowPart$1(a2) {
  return a2 - Math.fround(a2);
}
function fp64ifyMatrix4(matrix) {
  const matrixFP64 = new Float32Array(32);
  for (let i2 = 0; i2 < 4; ++i2) {
    for (let j2 = 0; j2 < 4; ++j2) {
      const index2 = i2 * 4 + j2;
      fp64ify(matrix[j2 * 4 + i2], matrixFP64, index2 * 2);
    }
  }
  return matrixFP64;
}
const fp64arithmeticShader = `uniform float ONE;
vec2 split(float a) {
const float SPLIT = 4097.0;
float t = a * SPLIT;
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
float a_hi = t * ONE - (t - a);
float a_lo = a * ONE - a_hi;
#else
float a_hi = t - (t - a);
float a_lo = a - a_hi;
#endif
return vec2(a_hi, a_lo);
}
vec2 split2(vec2 a) {
vec2 b = split(a.x);
b.y += a.y;
return b;
}
vec2 quickTwoSum(float a, float b) {
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
float sum = (a + b) * ONE;
float err = b - (sum - a) * ONE;
#else
float sum = a + b;
float err = b - (sum - a);
#endif
return vec2(sum, err);
}
vec2 twoSum(float a, float b) {
float s = (a + b);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
float v = (s * ONE - a) * ONE;
float err = (a - (s - v) * ONE) * ONE * ONE * ONE + (b - v);
#else
float v = s - a;
float err = (a - (s - v)) + (b - v);
#endif
return vec2(s, err);
}
vec2 twoSub(float a, float b) {
float s = (a - b);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
float v = (s * ONE - a) * ONE;
float err = (a - (s - v) * ONE) * ONE * ONE * ONE - (b + v);
#else
float v = s - a;
float err = (a - (s - v)) - (b + v);
#endif
return vec2(s, err);
}
vec2 twoSqr(float a) {
float prod = a * a;
vec2 a_fp64 = split(a);
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
float err = ((a_fp64.x * a_fp64.x - prod) * ONE + 2.0 * a_fp64.x *
a_fp64.y * ONE * ONE) + a_fp64.y * a_fp64.y * ONE * ONE * ONE;
#else
float err = ((a_fp64.x * a_fp64.x - prod) + 2.0 * a_fp64.x * a_fp64.y) + a_fp64.y * a_fp64.y;
#endif
return vec2(prod, err);
}
vec2 twoProd(float a, float b) {
float prod = a * b;
vec2 a_fp64 = split(a);
vec2 b_fp64 = split(b);
float err = ((a_fp64.x * b_fp64.x - prod) + a_fp64.x * b_fp64.y +
a_fp64.y * b_fp64.x) + a_fp64.y * b_fp64.y;
return vec2(prod, err);
}
vec2 sum_fp64(vec2 a, vec2 b) {
vec2 s, t;
s = twoSum(a.x, b.x);
t = twoSum(a.y, b.y);
s.y += t.x;
s = quickTwoSum(s.x, s.y);
s.y += t.y;
s = quickTwoSum(s.x, s.y);
return s;
}
vec2 sub_fp64(vec2 a, vec2 b) {
vec2 s, t;
s = twoSub(a.x, b.x);
t = twoSub(a.y, b.y);
s.y += t.x;
s = quickTwoSum(s.x, s.y);
s.y += t.y;
s = quickTwoSum(s.x, s.y);
return s;
}
vec2 mul_fp64(vec2 a, vec2 b) {
vec2 prod = twoProd(a.x, b.x);
prod.y += a.x * b.y;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
prod = split2(prod);
#endif
prod = quickTwoSum(prod.x, prod.y);
prod.y += a.y * b.x;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
prod = split2(prod);
#endif
prod = quickTwoSum(prod.x, prod.y);
return prod;
}
vec2 div_fp64(vec2 a, vec2 b) {
float xn = 1.0 / b.x;
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
vec2 yn = mul_fp64(a, vec2(xn, 0));
#else
vec2 yn = a * xn;
#endif
float diff = (sub_fp64(a, mul_fp64(b, yn))).x;
vec2 prod = twoProd(xn, diff);
return sum_fp64(yn, prod);
}
vec2 sqrt_fp64(vec2 a) {
if (a.x == 0.0 && a.y == 0.0) return vec2(0.0, 0.0);
if (a.x < 0.0) return vec2(0.0 / 0.0, 0.0 / 0.0);
float x = 1.0 / sqrt(a.x);
float yn = a.x * x;
#if defined(LUMA_FP64_CODE_ELIMINATION_WORKAROUND)
vec2 yn_sqr = twoSqr(yn) * ONE;
#else
vec2 yn_sqr = twoSqr(yn);
#endif
float diff = sub_fp64(a, yn_sqr).x;
vec2 prod = twoProd(x * 0.5, diff);
#if defined(LUMA_FP64_HIGH_BITS_OVERFLOW_WORKAROUND)
return sum_fp64(split(yn), prod);
#else
return sum_fp64(vec2(yn, 0.0), prod);
#endif
}
`;
const CONST_UNIFORMS = {
  // Used in LUMA_FP64_CODE_ELIMINATION_WORKAROUND
  ONE: 1
};
function getUniforms$4() {
  return CONST_UNIFORMS;
}
const fp64arithmetic = {
  name: "fp64-arithmetic",
  vs: fp64arithmeticShader,
  getUniforms: getUniforms$4,
  fp64ify,
  fp64LowPart: fp64LowPart$1,
  fp64ifyMatrix4
};
const RADIANS_TO_DEGREES$2 = 1 / Math.PI * 180;
const DEGREES_TO_RADIANS$5 = 1 / 180 * Math.PI;
const DEFAULT_CONFIG = {
  EPSILON: 1e-12,
  debug: false,
  precision: 4,
  printTypes: false,
  printDegrees: false,
  printRowMajor: true,
  _cartographicRadians: false
};
globalThis.mathgl = globalThis.mathgl || { config: { ...DEFAULT_CONFIG } };
const config = globalThis.mathgl.config;
function formatValue(value, { precision = config.precision } = {}) {
  value = round$1(value);
  return `${parseFloat(value.toPrecision(precision))}`;
}
function isArray$3(value) {
  return Array.isArray(value) || ArrayBuffer.isView(value) && !(value instanceof DataView);
}
function toRadians(degrees2) {
  return radians(degrees2);
}
function toDegrees(radians2) {
  return degrees(radians2);
}
function radians(degrees2, result) {
  return map$1(degrees2, (degrees3) => degrees3 * DEGREES_TO_RADIANS$5, result);
}
function degrees(radians2, result) {
  return map$1(radians2, (radians3) => radians3 * RADIANS_TO_DEGREES$2, result);
}
function clamp$3(value, min4, max3) {
  return map$1(value, (value2) => Math.max(min4, Math.min(max3, value2)));
}
function lerp$4(a2, b2, t2) {
  if (isArray$3(a2)) {
    return a2.map((ai2, i2) => lerp$4(ai2, b2[i2], t2));
  }
  return t2 * b2 + (1 - t2) * a2;
}
function equals$1(a2, b2, epsilon2) {
  const oldEpsilon = config.EPSILON;
  if (epsilon2) {
    config.EPSILON = epsilon2;
  }
  try {
    if (a2 === b2) {
      return true;
    }
    if (isArray$3(a2) && isArray$3(b2)) {
      if (a2.length !== b2.length) {
        return false;
      }
      for (let i2 = 0; i2 < a2.length; ++i2) {
        if (!equals$1(a2[i2], b2[i2])) {
          return false;
        }
      }
      return true;
    }
    if (a2 && a2.equals) {
      return a2.equals(b2);
    }
    if (b2 && b2.equals) {
      return b2.equals(a2);
    }
    if (typeof a2 === "number" && typeof b2 === "number") {
      return Math.abs(a2 - b2) <= config.EPSILON * Math.max(1, Math.abs(a2), Math.abs(b2));
    }
    return false;
  } finally {
    config.EPSILON = oldEpsilon;
  }
}
function round$1(value) {
  return Math.round(value / config.EPSILON) * config.EPSILON;
}
function duplicateArray(array2) {
  return array2.clone ? array2.clone() : new Array(array2.length);
}
function map$1(value, func2, result) {
  if (isArray$3(value)) {
    const array2 = value;
    result = result || duplicateArray(array2);
    for (let i2 = 0; i2 < result.length && i2 < array2.length; ++i2) {
      const val = typeof value === "number" ? value : value[i2];
      result[i2] = func2(val, i2, result);
    }
    return result;
  }
  return func2(value);
}
class MathArray extends Array {
  // Common methods
  /**
   * Clone the current object
   * @returns a new copy of this object
   */
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(array2, offset = 0) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] = array2[i2 + offset];
    }
    return this.check();
  }
  toArray(targetArray = [], offset = 0) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      targetArray[offset + i2] = this[i2];
    }
    return targetArray;
  }
  toObject(targetObject) {
    return targetObject;
  }
  from(arrayOrObject) {
    return Array.isArray(arrayOrObject) ? this.copy(arrayOrObject) : (
      // @ts-ignore
      this.fromObject(arrayOrObject)
    );
  }
  to(arrayOrObject) {
    if (arrayOrObject === this) {
      return this;
    }
    return isArray$3(arrayOrObject) ? this.toArray(arrayOrObject) : this.toObject(arrayOrObject);
  }
  toTarget(target) {
    return target ? this.to(target) : this;
  }
  /** @deprecated */
  toFloat32Array() {
    return new Float32Array(this);
  }
  toString() {
    return this.formatString(config);
  }
  /** Formats string according to options */
  formatString(opts) {
    let string3 = "";
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      string3 += (i2 > 0 ? ", " : "") + formatValue(this[i2], opts);
    }
    return `${opts.printTypes ? this.constructor.name : ""}[${string3}]`;
  }
  equals(array2) {
    if (!array2 || this.length !== array2.length) {
      return false;
    }
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      if (!equals$1(this[i2], array2[i2])) {
        return false;
      }
    }
    return true;
  }
  exactEquals(array2) {
    if (!array2 || this.length !== array2.length) {
      return false;
    }
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      if (this[i2] !== array2[i2]) {
        return false;
      }
    }
    return true;
  }
  // Modifiers
  /** Negates all values in this object */
  negate() {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] = -this[i2];
    }
    return this.check();
  }
  lerp(a2, b2, t2) {
    if (t2 === void 0) {
      return this.lerp(this, a2, b2);
    }
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      const ai2 = a2[i2];
      const endValue = typeof b2 === "number" ? b2 : b2[i2];
      this[i2] = ai2 + t2 * (endValue - ai2);
    }
    return this.check();
  }
  /** Minimal */
  min(vector) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] = Math.min(vector[i2], this[i2]);
    }
    return this.check();
  }
  /** Maximal */
  max(vector) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] = Math.max(vector[i2], this[i2]);
    }
    return this.check();
  }
  clamp(minVector, maxVector) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] = Math.min(Math.max(this[i2], minVector[i2]), maxVector[i2]);
    }
    return this.check();
  }
  add(...vectors) {
    for (const vector of vectors) {
      for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
        this[i2] += vector[i2];
      }
    }
    return this.check();
  }
  subtract(...vectors) {
    for (const vector of vectors) {
      for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
        this[i2] -= vector[i2];
      }
    }
    return this.check();
  }
  scale(scale5) {
    if (typeof scale5 === "number") {
      for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
        this[i2] *= scale5;
      }
    } else {
      for (let i2 = 0; i2 < this.ELEMENTS && i2 < scale5.length; ++i2) {
        this[i2] *= scale5[i2];
      }
    }
    return this.check();
  }
  /**
   * Multiplies all elements by `scale`
   * Note: `Matrix4.multiplyByScalar` only scales its 3x3 "minor"
   */
  multiplyByScalar(scalar) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] *= scalar;
    }
    return this.check();
  }
  // Debug checks
  /** Throws an error if array length is incorrect or contains illegal values */
  check() {
    if (config.debug && !this.validate()) {
      throw new Error(`math.gl: ${this.constructor.name} some fields set to invalid numbers'`);
    }
    return this;
  }
  /** Returns false if the array length is incorrect or contains illegal values */
  validate() {
    let valid = this.length === this.ELEMENTS;
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      valid = valid && Number.isFinite(this[i2]);
    }
    return valid;
  }
  // three.js compatibility
  /** @deprecated */
  sub(a2) {
    return this.subtract(a2);
  }
  /** @deprecated */
  setScalar(a2) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] = a2;
    }
    return this.check();
  }
  /** @deprecated */
  addScalar(a2) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] += a2;
    }
    return this.check();
  }
  /** @deprecated */
  subScalar(a2) {
    return this.addScalar(-a2);
  }
  /** @deprecated */
  multiplyScalar(scalar) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] *= scalar;
    }
    return this.check();
  }
  /** @deprecated */
  divideScalar(a2) {
    return this.multiplyByScalar(1 / a2);
  }
  /** @deprecated */
  clampScalar(min4, max3) {
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      this[i2] = Math.min(Math.max(this[i2], min4), max3);
    }
    return this.check();
  }
  /** @deprecated */
  get elements() {
    return this;
  }
}
function validateVector(v5, length2) {
  if (v5.length !== length2) {
    return false;
  }
  for (let i2 = 0; i2 < v5.length; ++i2) {
    if (!Number.isFinite(v5[i2])) {
      return false;
    }
  }
  return true;
}
function checkNumber(value) {
  if (!Number.isFinite(value)) {
    throw new Error(`Invalid number ${JSON.stringify(value)}`);
  }
  return value;
}
function checkVector(v5, length2, callerName = "") {
  if (config.debug && !validateVector(v5, length2)) {
    throw new Error(`math.gl: ${callerName} some fields set to invalid numbers'`);
  }
  return v5;
}
function assert$9(condition, message2) {
  if (!condition) {
    throw new Error(`math.gl assertion ${message2}`);
  }
}
class Vector extends MathArray {
  // ACCESSORS
  get x() {
    return this[0];
  }
  set x(value) {
    this[0] = checkNumber(value);
  }
  get y() {
    return this[1];
  }
  set y(value) {
    this[1] = checkNumber(value);
  }
  /**
   * Returns the length of the vector from the origin to the point described by this vector
   *
   * @note `length` is a reserved word for Arrays, so `v.length()` will return number of elements
   * Instead we provide `len` and `magnitude`
   */
  len() {
    return Math.sqrt(this.lengthSquared());
  }
  /**
   * Returns the length of the vector from the origin to the point described by this vector
   */
  magnitude() {
    return this.len();
  }
  /**
   * Returns the squared length of the vector from the origin to the point described by this vector
   */
  lengthSquared() {
    let length2 = 0;
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      length2 += this[i2] * this[i2];
    }
    return length2;
  }
  /**
   * Returns the squared length of the vector from the origin to the point described by this vector
   */
  magnitudeSquared() {
    return this.lengthSquared();
  }
  distance(mathArray) {
    return Math.sqrt(this.distanceSquared(mathArray));
  }
  distanceSquared(mathArray) {
    let length2 = 0;
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      const dist2 = this[i2] - mathArray[i2];
      length2 += dist2 * dist2;
    }
    return checkNumber(length2);
  }
  dot(mathArray) {
    let product = 0;
    for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
      product += this[i2] * mathArray[i2];
    }
    return checkNumber(product);
  }
  // MODIFIERS
  normalize() {
    const length2 = this.magnitude();
    if (length2 !== 0) {
      for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
        this[i2] /= length2;
      }
    }
    return this.check();
  }
  multiply(...vectors) {
    for (const vector of vectors) {
      for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
        this[i2] *= vector[i2];
      }
    }
    return this.check();
  }
  divide(...vectors) {
    for (const vector of vectors) {
      for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
        this[i2] /= vector[i2];
      }
    }
    return this.check();
  }
  // THREE.js compatibility
  lengthSq() {
    return this.lengthSquared();
  }
  distanceTo(vector) {
    return this.distance(vector);
  }
  distanceToSquared(vector) {
    return this.distanceSquared(vector);
  }
  getComponent(i2) {
    assert$9(i2 >= 0 && i2 < this.ELEMENTS, "index is out of range");
    return checkNumber(this[i2]);
  }
  setComponent(i2, value) {
    assert$9(i2 >= 0 && i2 < this.ELEMENTS, "index is out of range");
    this[i2] = value;
    return this.check();
  }
  addVectors(a2, b2) {
    return this.copy(a2).add(b2);
  }
  subVectors(a2, b2) {
    return this.copy(a2).subtract(b2);
  }
  multiplyVectors(a2, b2) {
    return this.copy(a2).multiply(b2);
  }
  addScaledVector(a2, b2) {
    return this.add(new this.constructor(a2).multiplyScalar(b2));
  }
}
const EPSILON$1 = 1e-6;
let ARRAY_TYPE = typeof Float32Array !== "undefined" ? Float32Array : Array;
function create$5() {
  const out = new ARRAY_TYPE(2);
  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }
  return out;
}
function add$3(out, a2, b2) {
  out[0] = a2[0] + b2[0];
  out[1] = a2[1] + b2[1];
  return out;
}
function negate$1(out, a2) {
  out[0] = -a2[0];
  out[1] = -a2[1];
  return out;
}
function lerp$3(out, a2, b2, t2) {
  const ax2 = a2[0];
  const ay2 = a2[1];
  out[0] = ax2 + t2 * (b2[0] - ax2);
  out[1] = ay2 + t2 * (b2[1] - ay2);
  return out;
}
function transformMat2(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  out[0] = m2[0] * x2 + m2[2] * y2;
  out[1] = m2[1] * x2 + m2[3] * y2;
  return out;
}
function transformMat2d(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  out[0] = m2[0] * x2 + m2[2] * y2 + m2[4];
  out[1] = m2[1] * x2 + m2[3] * y2 + m2[5];
  return out;
}
function transformMat3$1(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  out[0] = m2[0] * x2 + m2[3] * y2 + m2[6];
  out[1] = m2[1] * x2 + m2[4] * y2 + m2[7];
  return out;
}
function transformMat4$2(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  out[0] = m2[0] * x2 + m2[4] * y2 + m2[12];
  out[1] = m2[1] * x2 + m2[5] * y2 + m2[13];
  return out;
}
(function() {
  const vec = create$5();
  return function(a2, stride, offset, count3, fn2, arg) {
    let i2;
    let l2;
    if (!stride) {
      stride = 2;
    }
    if (!offset) {
      offset = 0;
    }
    if (count3) {
      l2 = Math.min(count3 * stride + offset, a2.length);
    } else {
      l2 = a2.length;
    }
    for (i2 = offset; i2 < l2; i2 += stride) {
      vec[0] = a2[i2];
      vec[1] = a2[i2 + 1];
      fn2(vec, vec, arg);
      a2[i2] = vec[0];
      a2[i2 + 1] = vec[1];
    }
    return a2;
  };
})();
function vec2_transformMat4AsVector(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const w2 = m2[3] * x2 + m2[7] * y2 || 1;
  out[0] = (m2[0] * x2 + m2[4] * y2) / w2;
  out[1] = (m2[1] * x2 + m2[5] * y2) / w2;
  return out;
}
function vec3_transformMat4AsVector(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  const w2 = m2[3] * x2 + m2[7] * y2 + m2[11] * z2 || 1;
  out[0] = (m2[0] * x2 + m2[4] * y2 + m2[8] * z2) / w2;
  out[1] = (m2[1] * x2 + m2[5] * y2 + m2[9] * z2) / w2;
  out[2] = (m2[2] * x2 + m2[6] * y2 + m2[10] * z2) / w2;
  return out;
}
function vec3_transformMat2(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  out[0] = m2[0] * x2 + m2[2] * y2;
  out[1] = m2[1] * x2 + m2[3] * y2;
  out[2] = a2[2];
  return out;
}
function vec4_transformMat2(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  out[0] = m2[0] * x2 + m2[2] * y2;
  out[1] = m2[1] * x2 + m2[3] * y2;
  out[2] = a2[2];
  out[3] = a2[3];
  return out;
}
function vec4_transformMat3(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  out[0] = m2[0] * x2 + m2[3] * y2 + m2[6] * z2;
  out[1] = m2[1] * x2 + m2[4] * y2 + m2[7] * z2;
  out[2] = m2[2] * x2 + m2[5] * y2 + m2[8] * z2;
  out[3] = a2[3];
  return out;
}
class Vector2 extends Vector {
  // Creates a new, empty vec2
  constructor(x2 = 0, y2 = 0) {
    super(2);
    if (isArray$3(x2) && arguments.length === 1) {
      this.copy(x2);
    } else {
      if (config.debug) {
        checkNumber(x2);
        checkNumber(y2);
      }
      this[0] = x2;
      this[1] = y2;
    }
  }
  set(x2, y2) {
    this[0] = x2;
    this[1] = y2;
    return this.check();
  }
  copy(array2) {
    this[0] = array2[0];
    this[1] = array2[1];
    return this.check();
  }
  fromObject(object2) {
    if (config.debug) {
      checkNumber(object2.x);
      checkNumber(object2.y);
    }
    this[0] = object2.x;
    this[1] = object2.y;
    return this.check();
  }
  toObject(object2) {
    object2.x = this[0];
    object2.y = this[1];
    return object2;
  }
  // Getters/setters
  get ELEMENTS() {
    return 2;
  }
  /**
   * Returns angle from x axis
   * @returns
   */
  horizontalAngle() {
    return Math.atan2(this.y, this.x);
  }
  /**
   * Returns angle from y axis
   * @returns
   */
  verticalAngle() {
    return Math.atan2(this.x, this.y);
  }
  // Transforms
  /**
   * Transforms as point
   * @param matrix4
   * @returns
   */
  transform(matrix4) {
    return this.transformAsPoint(matrix4);
  }
  /**
   * transforms as point (4th component is implicitly 1)
   * @param matrix4
   * @returns
   */
  transformAsPoint(matrix4) {
    transformMat4$2(this, this, matrix4);
    return this.check();
  }
  /**
   * transforms as vector (4th component is implicitly 0, ignores translation. slightly faster)
   * @param matrix4
   * @returns
   */
  transformAsVector(matrix4) {
    vec2_transformMat4AsVector(this, this, matrix4);
    return this.check();
  }
  transformByMatrix3(matrix3) {
    transformMat3$1(this, this, matrix3);
    return this.check();
  }
  transformByMatrix2x3(matrix2x3) {
    transformMat2d(this, this, matrix2x3);
    return this.check();
  }
  transformByMatrix2(matrix2) {
    transformMat2(this, this, matrix2);
    return this.check();
  }
}
function create$4() {
  const out = new ARRAY_TYPE(3);
  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }
  return out;
}
function length$4(a2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  return Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2);
}
function fromValues(x2, y2, z2) {
  const out = new ARRAY_TYPE(3);
  out[0] = x2;
  out[1] = y2;
  out[2] = z2;
  return out;
}
function subtract(out, a2, b2) {
  out[0] = a2[0] - b2[0];
  out[1] = a2[1] - b2[1];
  out[2] = a2[2] - b2[2];
  return out;
}
function squaredLength$2(a2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  return x2 * x2 + y2 * y2 + z2 * z2;
}
function negate(out, a2) {
  out[0] = -a2[0];
  out[1] = -a2[1];
  out[2] = -a2[2];
  return out;
}
function normalize$5(out, a2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  let len2 = x2 * x2 + y2 * y2 + z2 * z2;
  if (len2 > 0) {
    len2 = 1 / Math.sqrt(len2);
  }
  out[0] = a2[0] * len2;
  out[1] = a2[1] * len2;
  out[2] = a2[2] * len2;
  return out;
}
function dot$2(a2, b2) {
  return a2[0] * b2[0] + a2[1] * b2[1] + a2[2] * b2[2];
}
function cross(out, a2, b2) {
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const bx2 = b2[0];
  const by2 = b2[1];
  const bz2 = b2[2];
  out[0] = ay2 * bz2 - az2 * by2;
  out[1] = az2 * bx2 - ax2 * bz2;
  out[2] = ax2 * by2 - ay2 * bx2;
  return out;
}
function lerp$2(out, a2, b2, t2) {
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  out[0] = ax2 + t2 * (b2[0] - ax2);
  out[1] = ay2 + t2 * (b2[1] - ay2);
  out[2] = az2 + t2 * (b2[2] - az2);
  return out;
}
function transformMat4$1(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  let w2 = m2[3] * x2 + m2[7] * y2 + m2[11] * z2 + m2[15];
  w2 = w2 || 1;
  out[0] = (m2[0] * x2 + m2[4] * y2 + m2[8] * z2 + m2[12]) / w2;
  out[1] = (m2[1] * x2 + m2[5] * y2 + m2[9] * z2 + m2[13]) / w2;
  out[2] = (m2[2] * x2 + m2[6] * y2 + m2[10] * z2 + m2[14]) / w2;
  return out;
}
function transformMat3(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  out[0] = x2 * m2[0] + y2 * m2[3] + z2 * m2[6];
  out[1] = x2 * m2[1] + y2 * m2[4] + z2 * m2[7];
  out[2] = x2 * m2[2] + y2 * m2[5] + z2 * m2[8];
  return out;
}
function transformQuat$1(out, a2, q2) {
  const qx = q2[0];
  const qy = q2[1];
  const qz = q2[2];
  const qw = q2[3];
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  let uvx = qy * z2 - qz * y2;
  let uvy = qz * x2 - qx * z2;
  let uvz = qx * y2 - qy * x2;
  let uuvx = qy * uvz - qz * uvy;
  let uuvy = qz * uvx - qx * uvz;
  let uuvz = qx * uvy - qy * uvx;
  const w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2;
  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2;
  out[0] = x2 + uvx + uuvx;
  out[1] = y2 + uvy + uuvy;
  out[2] = z2 + uvz + uuvz;
  return out;
}
function rotateX$2(out, a2, b2, rad2) {
  const p2 = [];
  const r2 = [];
  p2[0] = a2[0] - b2[0];
  p2[1] = a2[1] - b2[1];
  p2[2] = a2[2] - b2[2];
  r2[0] = p2[0];
  r2[1] = p2[1] * Math.cos(rad2) - p2[2] * Math.sin(rad2);
  r2[2] = p2[1] * Math.sin(rad2) + p2[2] * Math.cos(rad2);
  out[0] = r2[0] + b2[0];
  out[1] = r2[1] + b2[1];
  out[2] = r2[2] + b2[2];
  return out;
}
function rotateY$2(out, a2, b2, rad2) {
  const p2 = [];
  const r2 = [];
  p2[0] = a2[0] - b2[0];
  p2[1] = a2[1] - b2[1];
  p2[2] = a2[2] - b2[2];
  r2[0] = p2[2] * Math.sin(rad2) + p2[0] * Math.cos(rad2);
  r2[1] = p2[1];
  r2[2] = p2[2] * Math.cos(rad2) - p2[0] * Math.sin(rad2);
  out[0] = r2[0] + b2[0];
  out[1] = r2[1] + b2[1];
  out[2] = r2[2] + b2[2];
  return out;
}
function rotateZ$2(out, a2, b2, rad2) {
  const p2 = [];
  const r2 = [];
  p2[0] = a2[0] - b2[0];
  p2[1] = a2[1] - b2[1];
  p2[2] = a2[2] - b2[2];
  r2[0] = p2[0] * Math.cos(rad2) - p2[1] * Math.sin(rad2);
  r2[1] = p2[0] * Math.sin(rad2) + p2[1] * Math.cos(rad2);
  r2[2] = p2[2];
  out[0] = r2[0] + b2[0];
  out[1] = r2[1] + b2[1];
  out[2] = r2[2] + b2[2];
  return out;
}
function angle(a2, b2) {
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const bx2 = b2[0];
  const by2 = b2[1];
  const bz2 = b2[2];
  const mag = Math.sqrt((ax2 * ax2 + ay2 * ay2 + az2 * az2) * (bx2 * bx2 + by2 * by2 + bz2 * bz2));
  const cosine = mag && dot$2(a2, b2) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
const sub = subtract;
const len = length$4;
const sqrLen = squaredLength$2;
(function() {
  const vec = create$4();
  return function(a2, stride, offset, count3, fn2, arg) {
    let i2;
    let l2;
    if (!stride) {
      stride = 3;
    }
    if (!offset) {
      offset = 0;
    }
    if (count3) {
      l2 = Math.min(count3 * stride + offset, a2.length);
    } else {
      l2 = a2.length;
    }
    for (i2 = offset; i2 < l2; i2 += stride) {
      vec[0] = a2[i2];
      vec[1] = a2[i2 + 1];
      vec[2] = a2[i2 + 2];
      fn2(vec, vec, arg);
      a2[i2] = vec[0];
      a2[i2 + 1] = vec[1];
      a2[i2 + 2] = vec[2];
    }
    return a2;
  };
})();
const ORIGIN = [0, 0, 0];
let ZERO$4;
class Vector3 extends Vector {
  static get ZERO() {
    if (!ZERO$4) {
      ZERO$4 = new Vector3(0, 0, 0);
      Object.freeze(ZERO$4);
    }
    return ZERO$4;
  }
  /**
   * @class
   * @param x
   * @param y
   * @param z
   */
  constructor(x2 = 0, y2 = 0, z2 = 0) {
    super(-0, -0, -0);
    if (arguments.length === 1 && isArray$3(x2)) {
      this.copy(x2);
    } else {
      if (config.debug) {
        checkNumber(x2);
        checkNumber(y2);
        checkNumber(z2);
      }
      this[0] = x2;
      this[1] = y2;
      this[2] = z2;
    }
  }
  set(x2, y2, z2) {
    this[0] = x2;
    this[1] = y2;
    this[2] = z2;
    return this.check();
  }
  copy(array2) {
    this[0] = array2[0];
    this[1] = array2[1];
    this[2] = array2[2];
    return this.check();
  }
  fromObject(object2) {
    if (config.debug) {
      checkNumber(object2.x);
      checkNumber(object2.y);
      checkNumber(object2.z);
    }
    this[0] = object2.x;
    this[1] = object2.y;
    this[2] = object2.z;
    return this.check();
  }
  toObject(object2) {
    object2.x = this[0];
    object2.y = this[1];
    object2.z = this[2];
    return object2;
  }
  // Getters/setters
  get ELEMENTS() {
    return 3;
  }
  get z() {
    return this[2];
  }
  set z(value) {
    this[2] = checkNumber(value);
  }
  // ACCESSORS
  angle(vector) {
    return angle(this, vector);
  }
  // MODIFIERS
  cross(vector) {
    cross(this, this, vector);
    return this.check();
  }
  rotateX({ radians: radians2, origin = ORIGIN }) {
    rotateX$2(this, this, origin, radians2);
    return this.check();
  }
  rotateY({ radians: radians2, origin = ORIGIN }) {
    rotateY$2(this, this, origin, radians2);
    return this.check();
  }
  rotateZ({ radians: radians2, origin = ORIGIN }) {
    rotateZ$2(this, this, origin, radians2);
    return this.check();
  }
  // Transforms
  // transforms as point (4th component is implicitly 1)
  transform(matrix4) {
    return this.transformAsPoint(matrix4);
  }
  // transforms as point (4th component is implicitly 1)
  transformAsPoint(matrix4) {
    transformMat4$1(this, this, matrix4);
    return this.check();
  }
  // transforms as vector  (4th component is implicitly 0, ignores translation. slightly faster)
  transformAsVector(matrix4) {
    vec3_transformMat4AsVector(this, this, matrix4);
    return this.check();
  }
  transformByMatrix3(matrix3) {
    transformMat3(this, this, matrix3);
    return this.check();
  }
  transformByMatrix2(matrix2) {
    vec3_transformMat2(this, this, matrix2);
    return this.check();
  }
  transformByQuaternion(quaternion2) {
    transformQuat$1(this, this, quaternion2);
    return this.check();
  }
}
let ZERO$3;
class Vector4 extends Vector {
  static get ZERO() {
    if (!ZERO$3) {
      ZERO$3 = new Vector4(0, 0, 0, 0);
      Object.freeze(ZERO$3);
    }
    return ZERO$3;
  }
  constructor(x2 = 0, y2 = 0, z2 = 0, w2 = 0) {
    super(-0, -0, -0, -0);
    if (isArray$3(x2) && arguments.length === 1) {
      this.copy(x2);
    } else {
      if (config.debug) {
        checkNumber(x2);
        checkNumber(y2);
        checkNumber(z2);
        checkNumber(w2);
      }
      this[0] = x2;
      this[1] = y2;
      this[2] = z2;
      this[3] = w2;
    }
  }
  set(x2, y2, z2, w2) {
    this[0] = x2;
    this[1] = y2;
    this[2] = z2;
    this[3] = w2;
    return this.check();
  }
  copy(array2) {
    this[0] = array2[0];
    this[1] = array2[1];
    this[2] = array2[2];
    this[3] = array2[3];
    return this.check();
  }
  fromObject(object2) {
    if (config.debug) {
      checkNumber(object2.x);
      checkNumber(object2.y);
      checkNumber(object2.z);
      checkNumber(object2.w);
    }
    this[0] = object2.x;
    this[1] = object2.y;
    this[2] = object2.z;
    this[3] = object2.w;
    return this;
  }
  toObject(object2) {
    object2.x = this[0];
    object2.y = this[1];
    object2.z = this[2];
    object2.w = this[3];
    return object2;
  }
  // Getters/setters
  /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
  get ELEMENTS() {
    return 4;
  }
  get z() {
    return this[2];
  }
  set z(value) {
    this[2] = checkNumber(value);
  }
  get w() {
    return this[3];
  }
  set w(value) {
    this[3] = checkNumber(value);
  }
  transform(matrix4) {
    transformMat4$1(this, this, matrix4);
    return this.check();
  }
  transformByMatrix3(matrix3) {
    vec4_transformMat3(this, this, matrix3);
    return this.check();
  }
  transformByMatrix2(matrix2) {
    vec4_transformMat2(this, this, matrix2);
    return this.check();
  }
  transformByQuaternion(quaternion2) {
    transformQuat$1(this, this, quaternion2);
    return this.check();
  }
  // three.js compatibility
  applyMatrix4(m2) {
    m2.transform(this, this);
    return this;
  }
}
class Matrix extends MathArray {
  // fromObject(object) {
  //   const array = object.elements;
  //   return this.fromRowMajor(array);
  // }
  // toObject(object) {
  //   const array = object.elements;
  //   this.toRowMajor(array);
  //   return object;
  // }
  // TODO better override formatString?
  toString() {
    let string3 = "[";
    if (config.printRowMajor) {
      string3 += "row-major:";
      for (let row = 0; row < this.RANK; ++row) {
        for (let col = 0; col < this.RANK; ++col) {
          string3 += ` ${this[col * this.RANK + row]}`;
        }
      }
    } else {
      string3 += "column-major:";
      for (let i2 = 0; i2 < this.ELEMENTS; ++i2) {
        string3 += ` ${this[i2]}`;
      }
    }
    string3 += "]";
    return string3;
  }
  getElementIndex(row, col) {
    return col * this.RANK + row;
  }
  // By default assumes row major indices
  getElement(row, col) {
    return this[col * this.RANK + row];
  }
  // By default assumes row major indices
  setElement(row, col, value) {
    this[col * this.RANK + row] = checkNumber(value);
    return this;
  }
  getColumn(columnIndex, result = new Array(this.RANK).fill(-0)) {
    const firstIndex = columnIndex * this.RANK;
    for (let i2 = 0; i2 < this.RANK; ++i2) {
      result[i2] = this[firstIndex + i2];
    }
    return result;
  }
  setColumn(columnIndex, columnVector) {
    const firstIndex = columnIndex * this.RANK;
    for (let i2 = 0; i2 < this.RANK; ++i2) {
      this[firstIndex + i2] = columnVector[i2];
    }
    return this;
  }
}
function create$3() {
  const out = new ARRAY_TYPE(9);
  if (ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
  }
  out[0] = 1;
  out[4] = 1;
  out[8] = 1;
  return out;
}
function transpose$1(out, a2) {
  if (out === a2) {
    const a01 = a2[1];
    const a02 = a2[2];
    const a12 = a2[5];
    out[1] = a2[3];
    out[2] = a2[6];
    out[3] = a01;
    out[5] = a2[7];
    out[6] = a02;
    out[7] = a12;
  } else {
    out[0] = a2[0];
    out[1] = a2[3];
    out[2] = a2[6];
    out[3] = a2[1];
    out[4] = a2[4];
    out[5] = a2[7];
    out[6] = a2[2];
    out[7] = a2[5];
    out[8] = a2[8];
  }
  return out;
}
function invert$2(out, a2) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a10 = a2[3];
  const a11 = a2[4];
  const a12 = a2[5];
  const a20 = a2[6];
  const a21 = a2[7];
  const a22 = a2[8];
  const b01 = a22 * a11 - a12 * a21;
  const b11 = -a22 * a10 + a12 * a20;
  const b21 = a21 * a10 - a11 * a20;
  let det2 = a00 * b01 + a01 * b11 + a02 * b21;
  if (!det2) {
    return null;
  }
  det2 = 1 / det2;
  out[0] = b01 * det2;
  out[1] = (-a22 * a01 + a02 * a21) * det2;
  out[2] = (a12 * a01 - a02 * a11) * det2;
  out[3] = b11 * det2;
  out[4] = (a22 * a00 - a02 * a20) * det2;
  out[5] = (-a12 * a00 + a02 * a10) * det2;
  out[6] = b21 * det2;
  out[7] = (-a21 * a00 + a01 * a20) * det2;
  out[8] = (a11 * a00 - a01 * a10) * det2;
  return out;
}
function determinant$1(a2) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a10 = a2[3];
  const a11 = a2[4];
  const a12 = a2[5];
  const a20 = a2[6];
  const a21 = a2[7];
  const a22 = a2[8];
  return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function multiply$2(out, a2, b2) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a10 = a2[3];
  const a11 = a2[4];
  const a12 = a2[5];
  const a20 = a2[6];
  const a21 = a2[7];
  const a22 = a2[8];
  const b00 = b2[0];
  const b01 = b2[1];
  const b02 = b2[2];
  const b10 = b2[3];
  const b11 = b2[4];
  const b12 = b2[5];
  const b20 = b2[6];
  const b21 = b2[7];
  const b22 = b2[8];
  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;
  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;
  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}
function translate$1(out, a2, v5) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a10 = a2[3];
  const a11 = a2[4];
  const a12 = a2[5];
  const a20 = a2[6];
  const a21 = a2[7];
  const a22 = a2[8];
  const x2 = v5[0];
  const y2 = v5[1];
  out[0] = a00;
  out[1] = a01;
  out[2] = a02;
  out[3] = a10;
  out[4] = a11;
  out[5] = a12;
  out[6] = x2 * a00 + y2 * a10 + a20;
  out[7] = x2 * a01 + y2 * a11 + a21;
  out[8] = x2 * a02 + y2 * a12 + a22;
  return out;
}
function rotate$1(out, a2, rad2) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a10 = a2[3];
  const a11 = a2[4];
  const a12 = a2[5];
  const a20 = a2[6];
  const a21 = a2[7];
  const a22 = a2[8];
  const s2 = Math.sin(rad2);
  const c2 = Math.cos(rad2);
  out[0] = c2 * a00 + s2 * a10;
  out[1] = c2 * a01 + s2 * a11;
  out[2] = c2 * a02 + s2 * a12;
  out[3] = c2 * a10 - s2 * a00;
  out[4] = c2 * a11 - s2 * a01;
  out[5] = c2 * a12 - s2 * a02;
  out[6] = a20;
  out[7] = a21;
  out[8] = a22;
  return out;
}
function scale$3(out, a2, v5) {
  const x2 = v5[0];
  const y2 = v5[1];
  out[0] = x2 * a2[0];
  out[1] = x2 * a2[1];
  out[2] = x2 * a2[2];
  out[3] = y2 * a2[3];
  out[4] = y2 * a2[4];
  out[5] = y2 * a2[5];
  out[6] = a2[6];
  out[7] = a2[7];
  out[8] = a2[8];
  return out;
}
function fromQuat$1(out, q2) {
  const x2 = q2[0];
  const y2 = q2[1];
  const z2 = q2[2];
  const w2 = q2[3];
  const x22 = x2 + x2;
  const y22 = y2 + y2;
  const z22 = z2 + z2;
  const xx = x2 * x22;
  const yx = y2 * x22;
  const yy = y2 * y22;
  const zx = z2 * x22;
  const zy = z2 * y22;
  const zz = z2 * z22;
  const wx = w2 * x22;
  const wy = w2 * y22;
  const wz = w2 * z22;
  out[0] = 1 - yy - zz;
  out[3] = yx - wz;
  out[6] = zx + wy;
  out[1] = yx + wz;
  out[4] = 1 - xx - zz;
  out[7] = zy - wx;
  out[2] = zx - wy;
  out[5] = zy + wx;
  out[8] = 1 - xx - yy;
  return out;
}
var INDICES$1;
(function(INDICES2) {
  INDICES2[INDICES2["COL0ROW0"] = 0] = "COL0ROW0";
  INDICES2[INDICES2["COL0ROW1"] = 1] = "COL0ROW1";
  INDICES2[INDICES2["COL0ROW2"] = 2] = "COL0ROW2";
  INDICES2[INDICES2["COL1ROW0"] = 3] = "COL1ROW0";
  INDICES2[INDICES2["COL1ROW1"] = 4] = "COL1ROW1";
  INDICES2[INDICES2["COL1ROW2"] = 5] = "COL1ROW2";
  INDICES2[INDICES2["COL2ROW0"] = 6] = "COL2ROW0";
  INDICES2[INDICES2["COL2ROW1"] = 7] = "COL2ROW1";
  INDICES2[INDICES2["COL2ROW2"] = 8] = "COL2ROW2";
})(INDICES$1 || (INDICES$1 = {}));
const IDENTITY_MATRIX$2 = Object.freeze([1, 0, 0, 0, 1, 0, 0, 0, 1]);
class Matrix3 extends Matrix {
  static get IDENTITY() {
    return getIdentityMatrix$1();
  }
  static get ZERO() {
    return getZeroMatrix$1();
  }
  get ELEMENTS() {
    return 9;
  }
  get RANK() {
    return 3;
  }
  get INDICES() {
    return INDICES$1;
  }
  constructor(array2, ...args) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0);
    if (arguments.length === 1 && Array.isArray(array2)) {
      this.copy(array2);
    } else if (args.length > 0) {
      this.copy([array2, ...args]);
    } else {
      this.identity();
    }
  }
  copy(array2) {
    this[0] = array2[0];
    this[1] = array2[1];
    this[2] = array2[2];
    this[3] = array2[3];
    this[4] = array2[4];
    this[5] = array2[5];
    this[6] = array2[6];
    this[7] = array2[7];
    this[8] = array2[8];
    return this.check();
  }
  // Constructors
  identity() {
    return this.copy(IDENTITY_MATRIX$2);
  }
  /**
   *
   * @param object
   * @returns self
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fromObject(object2) {
    return this.check();
  }
  /** Calculates a 3x3 matrix from the given quaternion
   * q quat  Quaternion to create matrix from
   */
  fromQuaternion(q2) {
    fromQuat$1(this, q2);
    return this.check();
  }
  /**
   * accepts column major order, stores in column major order
   */
  // eslint-disable-next-line max-params
  set(m00, m10, m20, m01, m11, m21, m02, m12, m22) {
    this[0] = m00;
    this[1] = m10;
    this[2] = m20;
    this[3] = m01;
    this[4] = m11;
    this[5] = m21;
    this[6] = m02;
    this[7] = m12;
    this[8] = m22;
    return this.check();
  }
  /**
   * accepts row major order, stores as column major
   */
  // eslint-disable-next-line max-params
  setRowMajor(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    this[0] = m00;
    this[1] = m10;
    this[2] = m20;
    this[3] = m01;
    this[4] = m11;
    this[5] = m21;
    this[6] = m02;
    this[7] = m12;
    this[8] = m22;
    return this.check();
  }
  // Accessors
  determinant() {
    return determinant$1(this);
  }
  // Modifiers
  transpose() {
    transpose$1(this, this);
    return this.check();
  }
  /** Invert a matrix. Note that this can fail if the matrix is not invertible */
  invert() {
    invert$2(this, this);
    return this.check();
  }
  // Operations
  multiplyLeft(a2) {
    multiply$2(this, a2, this);
    return this.check();
  }
  multiplyRight(a2) {
    multiply$2(this, this, a2);
    return this.check();
  }
  rotate(radians2) {
    rotate$1(this, this, radians2);
    return this.check();
  }
  scale(factor) {
    if (Array.isArray(factor)) {
      scale$3(this, this, factor);
    } else {
      scale$3(this, this, [factor, factor]);
    }
    return this.check();
  }
  translate(vec) {
    translate$1(this, this, vec);
    return this.check();
  }
  // Transforms
  transform(vector, result) {
    let out;
    switch (vector.length) {
      case 2:
        out = transformMat3$1(result || [-0, -0], vector, this);
        break;
      case 3:
        out = transformMat3(result || [-0, -0, -0], vector, this);
        break;
      case 4:
        out = vec4_transformMat3(result || [-0, -0, -0, -0], vector, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    checkVector(out, vector.length);
    return out;
  }
  /** @deprecated */
  transformVector(vector, result) {
    return this.transform(vector, result);
  }
  /** @deprecated */
  transformVector2(vector, result) {
    return this.transform(vector, result);
  }
  /** @deprecated */
  transformVector3(vector, result) {
    return this.transform(vector, result);
  }
}
let ZERO_MATRIX3;
let IDENTITY_MATRIX3 = null;
function getZeroMatrix$1() {
  if (!ZERO_MATRIX3) {
    ZERO_MATRIX3 = new Matrix3([0, 0, 0, 0, 0, 0, 0, 0, 0]);
    Object.freeze(ZERO_MATRIX3);
  }
  return ZERO_MATRIX3;
}
function getIdentityMatrix$1() {
  if (!IDENTITY_MATRIX3) {
    IDENTITY_MATRIX3 = new Matrix3();
    Object.freeze(IDENTITY_MATRIX3);
  }
  return IDENTITY_MATRIX3;
}
function identity$3(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
function transpose(out, a2) {
  if (out === a2) {
    const a01 = a2[1];
    const a02 = a2[2];
    const a03 = a2[3];
    const a12 = a2[6];
    const a13 = a2[7];
    const a23 = a2[11];
    out[1] = a2[4];
    out[2] = a2[8];
    out[3] = a2[12];
    out[4] = a01;
    out[6] = a2[9];
    out[7] = a2[13];
    out[8] = a02;
    out[9] = a12;
    out[11] = a2[14];
    out[12] = a03;
    out[13] = a13;
    out[14] = a23;
  } else {
    out[0] = a2[0];
    out[1] = a2[4];
    out[2] = a2[8];
    out[3] = a2[12];
    out[4] = a2[1];
    out[5] = a2[5];
    out[6] = a2[9];
    out[7] = a2[13];
    out[8] = a2[2];
    out[9] = a2[6];
    out[10] = a2[10];
    out[11] = a2[14];
    out[12] = a2[3];
    out[13] = a2[7];
    out[14] = a2[11];
    out[15] = a2[15];
  }
  return out;
}
function invert$1(out, a2) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a03 = a2[3];
  const a10 = a2[4];
  const a11 = a2[5];
  const a12 = a2[6];
  const a13 = a2[7];
  const a20 = a2[8];
  const a21 = a2[9];
  const a22 = a2[10];
  const a23 = a2[11];
  const a30 = a2[12];
  const a31 = a2[13];
  const a32 = a2[14];
  const a33 = a2[15];
  const b00 = a00 * a11 - a01 * a10;
  const b01 = a00 * a12 - a02 * a10;
  const b02 = a00 * a13 - a03 * a10;
  const b03 = a01 * a12 - a02 * a11;
  const b04 = a01 * a13 - a03 * a11;
  const b05 = a02 * a13 - a03 * a12;
  const b06 = a20 * a31 - a21 * a30;
  const b07 = a20 * a32 - a22 * a30;
  const b08 = a20 * a33 - a23 * a30;
  const b09 = a21 * a32 - a22 * a31;
  const b10 = a21 * a33 - a23 * a31;
  const b11 = a22 * a33 - a23 * a32;
  let det2 = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  if (!det2) {
    return null;
  }
  det2 = 1 / det2;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det2;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det2;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det2;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det2;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det2;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det2;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det2;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det2;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det2;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det2;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det2;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det2;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det2;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det2;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det2;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det2;
  return out;
}
function determinant(a2) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a03 = a2[3];
  const a10 = a2[4];
  const a11 = a2[5];
  const a12 = a2[6];
  const a13 = a2[7];
  const a20 = a2[8];
  const a21 = a2[9];
  const a22 = a2[10];
  const a23 = a2[11];
  const a30 = a2[12];
  const a31 = a2[13];
  const a32 = a2[14];
  const a33 = a2[15];
  const b0 = a00 * a11 - a01 * a10;
  const b1 = a00 * a12 - a02 * a10;
  const b2 = a01 * a12 - a02 * a11;
  const b3 = a20 * a31 - a21 * a30;
  const b4 = a20 * a32 - a22 * a30;
  const b5 = a21 * a32 - a22 * a31;
  const b6 = a00 * b5 - a01 * b4 + a02 * b3;
  const b7 = a10 * b5 - a11 * b4 + a12 * b3;
  const b8 = a20 * b2 - a21 * b1 + a22 * b0;
  const b9 = a30 * b2 - a31 * b1 + a32 * b0;
  return a13 * b6 - a03 * b7 + a33 * b8 - a23 * b9;
}
function multiply$1(out, a2, b2) {
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a03 = a2[3];
  const a10 = a2[4];
  const a11 = a2[5];
  const a12 = a2[6];
  const a13 = a2[7];
  const a20 = a2[8];
  const a21 = a2[9];
  const a22 = a2[10];
  const a23 = a2[11];
  const a30 = a2[12];
  const a31 = a2[13];
  const a32 = a2[14];
  const a33 = a2[15];
  let b0 = b2[0];
  let b1 = b2[1];
  let b22 = b2[2];
  let b3 = b2[3];
  out[0] = b0 * a00 + b1 * a10 + b22 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b22 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b22 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b22 * a23 + b3 * a33;
  b0 = b2[4];
  b1 = b2[5];
  b22 = b2[6];
  b3 = b2[7];
  out[4] = b0 * a00 + b1 * a10 + b22 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b22 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b22 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b22 * a23 + b3 * a33;
  b0 = b2[8];
  b1 = b2[9];
  b22 = b2[10];
  b3 = b2[11];
  out[8] = b0 * a00 + b1 * a10 + b22 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b22 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b22 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b22 * a23 + b3 * a33;
  b0 = b2[12];
  b1 = b2[13];
  b22 = b2[14];
  b3 = b2[15];
  out[12] = b0 * a00 + b1 * a10 + b22 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b22 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b22 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b22 * a23 + b3 * a33;
  return out;
}
function translate(out, a2, v5) {
  const x2 = v5[0];
  const y2 = v5[1];
  const z2 = v5[2];
  let a00;
  let a01;
  let a02;
  let a03;
  let a10;
  let a11;
  let a12;
  let a13;
  let a20;
  let a21;
  let a22;
  let a23;
  if (a2 === out) {
    out[12] = a2[0] * x2 + a2[4] * y2 + a2[8] * z2 + a2[12];
    out[13] = a2[1] * x2 + a2[5] * y2 + a2[9] * z2 + a2[13];
    out[14] = a2[2] * x2 + a2[6] * y2 + a2[10] * z2 + a2[14];
    out[15] = a2[3] * x2 + a2[7] * y2 + a2[11] * z2 + a2[15];
  } else {
    a00 = a2[0];
    a01 = a2[1];
    a02 = a2[2];
    a03 = a2[3];
    a10 = a2[4];
    a11 = a2[5];
    a12 = a2[6];
    a13 = a2[7];
    a20 = a2[8];
    a21 = a2[9];
    a22 = a2[10];
    a23 = a2[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x2 + a10 * y2 + a20 * z2 + a2[12];
    out[13] = a01 * x2 + a11 * y2 + a21 * z2 + a2[13];
    out[14] = a02 * x2 + a12 * y2 + a22 * z2 + a2[14];
    out[15] = a03 * x2 + a13 * y2 + a23 * z2 + a2[15];
  }
  return out;
}
function scale$2(out, a2, v5) {
  const x2 = v5[0];
  const y2 = v5[1];
  const z2 = v5[2];
  out[0] = a2[0] * x2;
  out[1] = a2[1] * x2;
  out[2] = a2[2] * x2;
  out[3] = a2[3] * x2;
  out[4] = a2[4] * y2;
  out[5] = a2[5] * y2;
  out[6] = a2[6] * y2;
  out[7] = a2[7] * y2;
  out[8] = a2[8] * z2;
  out[9] = a2[9] * z2;
  out[10] = a2[10] * z2;
  out[11] = a2[11] * z2;
  out[12] = a2[12];
  out[13] = a2[13];
  out[14] = a2[14];
  out[15] = a2[15];
  return out;
}
function rotate(out, a2, rad2, axis) {
  let x2 = axis[0];
  let y2 = axis[1];
  let z2 = axis[2];
  let len2 = Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2);
  let c2;
  let s2;
  let t2;
  let a00;
  let a01;
  let a02;
  let a03;
  let a10;
  let a11;
  let a12;
  let a13;
  let a20;
  let a21;
  let a22;
  let a23;
  let b00;
  let b01;
  let b02;
  let b10;
  let b11;
  let b12;
  let b20;
  let b21;
  let b22;
  if (len2 < EPSILON$1) {
    return null;
  }
  len2 = 1 / len2;
  x2 *= len2;
  y2 *= len2;
  z2 *= len2;
  s2 = Math.sin(rad2);
  c2 = Math.cos(rad2);
  t2 = 1 - c2;
  a00 = a2[0];
  a01 = a2[1];
  a02 = a2[2];
  a03 = a2[3];
  a10 = a2[4];
  a11 = a2[5];
  a12 = a2[6];
  a13 = a2[7];
  a20 = a2[8];
  a21 = a2[9];
  a22 = a2[10];
  a23 = a2[11];
  b00 = x2 * x2 * t2 + c2;
  b01 = y2 * x2 * t2 + z2 * s2;
  b02 = z2 * x2 * t2 - y2 * s2;
  b10 = x2 * y2 * t2 - z2 * s2;
  b11 = y2 * y2 * t2 + c2;
  b12 = z2 * y2 * t2 + x2 * s2;
  b20 = x2 * z2 * t2 + y2 * s2;
  b21 = y2 * z2 * t2 - x2 * s2;
  b22 = z2 * z2 * t2 + c2;
  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;
  if (a2 !== out) {
    out[12] = a2[12];
    out[13] = a2[13];
    out[14] = a2[14];
    out[15] = a2[15];
  }
  return out;
}
function rotateX$1(out, a2, rad2) {
  const s2 = Math.sin(rad2);
  const c2 = Math.cos(rad2);
  const a10 = a2[4];
  const a11 = a2[5];
  const a12 = a2[6];
  const a13 = a2[7];
  const a20 = a2[8];
  const a21 = a2[9];
  const a22 = a2[10];
  const a23 = a2[11];
  if (a2 !== out) {
    out[0] = a2[0];
    out[1] = a2[1];
    out[2] = a2[2];
    out[3] = a2[3];
    out[12] = a2[12];
    out[13] = a2[13];
    out[14] = a2[14];
    out[15] = a2[15];
  }
  out[4] = a10 * c2 + a20 * s2;
  out[5] = a11 * c2 + a21 * s2;
  out[6] = a12 * c2 + a22 * s2;
  out[7] = a13 * c2 + a23 * s2;
  out[8] = a20 * c2 - a10 * s2;
  out[9] = a21 * c2 - a11 * s2;
  out[10] = a22 * c2 - a12 * s2;
  out[11] = a23 * c2 - a13 * s2;
  return out;
}
function rotateY$1(out, a2, rad2) {
  const s2 = Math.sin(rad2);
  const c2 = Math.cos(rad2);
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a03 = a2[3];
  const a20 = a2[8];
  const a21 = a2[9];
  const a22 = a2[10];
  const a23 = a2[11];
  if (a2 !== out) {
    out[4] = a2[4];
    out[5] = a2[5];
    out[6] = a2[6];
    out[7] = a2[7];
    out[12] = a2[12];
    out[13] = a2[13];
    out[14] = a2[14];
    out[15] = a2[15];
  }
  out[0] = a00 * c2 - a20 * s2;
  out[1] = a01 * c2 - a21 * s2;
  out[2] = a02 * c2 - a22 * s2;
  out[3] = a03 * c2 - a23 * s2;
  out[8] = a00 * s2 + a20 * c2;
  out[9] = a01 * s2 + a21 * c2;
  out[10] = a02 * s2 + a22 * c2;
  out[11] = a03 * s2 + a23 * c2;
  return out;
}
function rotateZ$1(out, a2, rad2) {
  const s2 = Math.sin(rad2);
  const c2 = Math.cos(rad2);
  const a00 = a2[0];
  const a01 = a2[1];
  const a02 = a2[2];
  const a03 = a2[3];
  const a10 = a2[4];
  const a11 = a2[5];
  const a12 = a2[6];
  const a13 = a2[7];
  if (a2 !== out) {
    out[8] = a2[8];
    out[9] = a2[9];
    out[10] = a2[10];
    out[11] = a2[11];
    out[12] = a2[12];
    out[13] = a2[13];
    out[14] = a2[14];
    out[15] = a2[15];
  }
  out[0] = a00 * c2 + a10 * s2;
  out[1] = a01 * c2 + a11 * s2;
  out[2] = a02 * c2 + a12 * s2;
  out[3] = a03 * c2 + a13 * s2;
  out[4] = a10 * c2 - a00 * s2;
  out[5] = a11 * c2 - a01 * s2;
  out[6] = a12 * c2 - a02 * s2;
  out[7] = a13 * c2 - a03 * s2;
  return out;
}
function getScaling(out, mat) {
  const m11 = mat[0];
  const m12 = mat[1];
  const m13 = mat[2];
  const m21 = mat[4];
  const m22 = mat[5];
  const m23 = mat[6];
  const m31 = mat[8];
  const m32 = mat[9];
  const m33 = mat[10];
  out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
  out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
  out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
  return out;
}
function fromQuat(out, q2) {
  const x2 = q2[0];
  const y2 = q2[1];
  const z2 = q2[2];
  const w2 = q2[3];
  const x22 = x2 + x2;
  const y22 = y2 + y2;
  const z22 = z2 + z2;
  const xx = x2 * x22;
  const yx = y2 * x22;
  const yy = y2 * y22;
  const zx = z2 * x22;
  const zy = z2 * y22;
  const zz = z2 * z22;
  const wx = w2 * x22;
  const wy = w2 * y22;
  const wz = w2 * z22;
  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;
  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;
  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
function frustum(out, left, right, bottom, top, near, far) {
  const rl = 1 / (right - left);
  const tb = 1 / (top - bottom);
  const nf = 1 / (near - far);
  out[0] = near * 2 * rl;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = near * 2 * tb;
  out[6] = 0;
  out[7] = 0;
  out[8] = (right + left) * rl;
  out[9] = (top + bottom) * tb;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = far * near * 2 * nf;
  out[15] = 0;
  return out;
}
function perspectiveNO(out, fovy, aspect2, near, far) {
  const f2 = 1 / Math.tan(fovy / 2);
  out[0] = f2 / aspect2;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f2;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;
  if (far != null && far !== Infinity) {
    const nf = 1 / (near - far);
    out[10] = (far + near) * nf;
    out[14] = 2 * far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -2 * near;
  }
  return out;
}
const perspective = perspectiveNO;
function orthoNO(out, left, right, bottom, top, near, far) {
  const lr = 1 / (left - right);
  const bt2 = 1 / (bottom - top);
  const nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt2;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt2;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
const ortho = orthoNO;
function lookAt(out, eye, center2, up) {
  let len2;
  let x02;
  let x12;
  let x2;
  let y02;
  let y12;
  let y2;
  let z0;
  let z1;
  let z2;
  const eyex = eye[0];
  const eyey = eye[1];
  const eyez = eye[2];
  const upx = up[0];
  const upy = up[1];
  const upz = up[2];
  const centerx = center2[0];
  const centery = center2[1];
  const centerz = center2[2];
  if (Math.abs(eyex - centerx) < EPSILON$1 && Math.abs(eyey - centery) < EPSILON$1 && Math.abs(eyez - centerz) < EPSILON$1) {
    return identity$3(out);
  }
  z0 = eyex - centerx;
  z1 = eyey - centery;
  z2 = eyez - centerz;
  len2 = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
  z0 *= len2;
  z1 *= len2;
  z2 *= len2;
  x02 = upy * z2 - upz * z1;
  x12 = upz * z0 - upx * z2;
  x2 = upx * z1 - upy * z0;
  len2 = Math.sqrt(x02 * x02 + x12 * x12 + x2 * x2);
  if (!len2) {
    x02 = 0;
    x12 = 0;
    x2 = 0;
  } else {
    len2 = 1 / len2;
    x02 *= len2;
    x12 *= len2;
    x2 *= len2;
  }
  y02 = z1 * x2 - z2 * x12;
  y12 = z2 * x02 - z0 * x2;
  y2 = z0 * x12 - z1 * x02;
  len2 = Math.sqrt(y02 * y02 + y12 * y12 + y2 * y2);
  if (!len2) {
    y02 = 0;
    y12 = 0;
    y2 = 0;
  } else {
    len2 = 1 / len2;
    y02 *= len2;
    y12 *= len2;
    y2 *= len2;
  }
  out[0] = x02;
  out[1] = y02;
  out[2] = z0;
  out[3] = 0;
  out[4] = x12;
  out[5] = y12;
  out[6] = z1;
  out[7] = 0;
  out[8] = x2;
  out[9] = y2;
  out[10] = z2;
  out[11] = 0;
  out[12] = -(x02 * eyex + x12 * eyey + x2 * eyez);
  out[13] = -(y02 * eyex + y12 * eyey + y2 * eyez);
  out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
  out[15] = 1;
  return out;
}
function create$2() {
  const out = new ARRAY_TYPE(4);
  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
  }
  return out;
}
function add$2(out, a2, b2) {
  out[0] = a2[0] + b2[0];
  out[1] = a2[1] + b2[1];
  out[2] = a2[2] + b2[2];
  out[3] = a2[3] + b2[3];
  return out;
}
function scale$1(out, a2, b2) {
  out[0] = a2[0] * b2;
  out[1] = a2[1] * b2;
  out[2] = a2[2] * b2;
  out[3] = a2[3] * b2;
  return out;
}
function length$3(a2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  const w2 = a2[3];
  return Math.sqrt(x2 * x2 + y2 * y2 + z2 * z2 + w2 * w2);
}
function squaredLength$1(a2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  const w2 = a2[3];
  return x2 * x2 + y2 * y2 + z2 * z2 + w2 * w2;
}
function normalize$4(out, a2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  const w2 = a2[3];
  let len2 = x2 * x2 + y2 * y2 + z2 * z2 + w2 * w2;
  if (len2 > 0) {
    len2 = 1 / Math.sqrt(len2);
  }
  out[0] = x2 * len2;
  out[1] = y2 * len2;
  out[2] = z2 * len2;
  out[3] = w2 * len2;
  return out;
}
function dot$1(a2, b2) {
  return a2[0] * b2[0] + a2[1] * b2[1] + a2[2] * b2[2] + a2[3] * b2[3];
}
function lerp$1(out, a2, b2, t2) {
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const aw2 = a2[3];
  out[0] = ax2 + t2 * (b2[0] - ax2);
  out[1] = ay2 + t2 * (b2[1] - ay2);
  out[2] = az2 + t2 * (b2[2] - az2);
  out[3] = aw2 + t2 * (b2[3] - aw2);
  return out;
}
function transformMat4(out, a2, m2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  const w2 = a2[3];
  out[0] = m2[0] * x2 + m2[4] * y2 + m2[8] * z2 + m2[12] * w2;
  out[1] = m2[1] * x2 + m2[5] * y2 + m2[9] * z2 + m2[13] * w2;
  out[2] = m2[2] * x2 + m2[6] * y2 + m2[10] * z2 + m2[14] * w2;
  out[3] = m2[3] * x2 + m2[7] * y2 + m2[11] * z2 + m2[15] * w2;
  return out;
}
function transformQuat(out, a2, q2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  const qx = q2[0];
  const qy = q2[1];
  const qz = q2[2];
  const qw = q2[3];
  const ix = qw * x2 + qy * z2 - qz * y2;
  const iy = qw * y2 + qz * x2 - qx * z2;
  const iz = qw * z2 + qx * y2 - qy * x2;
  const iw = -qx * x2 - qy * y2 - qz * z2;
  out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
  out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
  out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
  out[3] = a2[3];
  return out;
}
(function() {
  const vec = create$2();
  return function(a2, stride, offset, count3, fn2, arg) {
    let i2;
    let l2;
    if (!stride) {
      stride = 4;
    }
    if (!offset) {
      offset = 0;
    }
    if (count3) {
      l2 = Math.min(count3 * stride + offset, a2.length);
    } else {
      l2 = a2.length;
    }
    for (i2 = offset; i2 < l2; i2 += stride) {
      vec[0] = a2[i2];
      vec[1] = a2[i2 + 1];
      vec[2] = a2[i2 + 2];
      vec[3] = a2[i2 + 3];
      fn2(vec, vec, arg);
      a2[i2] = vec[0];
      a2[i2 + 1] = vec[1];
      a2[i2 + 2] = vec[2];
      a2[i2 + 3] = vec[3];
    }
    return a2;
  };
})();
var INDICES;
(function(INDICES2) {
  INDICES2[INDICES2["COL0ROW0"] = 0] = "COL0ROW0";
  INDICES2[INDICES2["COL0ROW1"] = 1] = "COL0ROW1";
  INDICES2[INDICES2["COL0ROW2"] = 2] = "COL0ROW2";
  INDICES2[INDICES2["COL0ROW3"] = 3] = "COL0ROW3";
  INDICES2[INDICES2["COL1ROW0"] = 4] = "COL1ROW0";
  INDICES2[INDICES2["COL1ROW1"] = 5] = "COL1ROW1";
  INDICES2[INDICES2["COL1ROW2"] = 6] = "COL1ROW2";
  INDICES2[INDICES2["COL1ROW3"] = 7] = "COL1ROW3";
  INDICES2[INDICES2["COL2ROW0"] = 8] = "COL2ROW0";
  INDICES2[INDICES2["COL2ROW1"] = 9] = "COL2ROW1";
  INDICES2[INDICES2["COL2ROW2"] = 10] = "COL2ROW2";
  INDICES2[INDICES2["COL2ROW3"] = 11] = "COL2ROW3";
  INDICES2[INDICES2["COL3ROW0"] = 12] = "COL3ROW0";
  INDICES2[INDICES2["COL3ROW1"] = 13] = "COL3ROW1";
  INDICES2[INDICES2["COL3ROW2"] = 14] = "COL3ROW2";
  INDICES2[INDICES2["COL3ROW3"] = 15] = "COL3ROW3";
})(INDICES || (INDICES = {}));
const DEFAULT_FOVY = 45 * Math.PI / 180;
const DEFAULT_ASPECT = 1;
const DEFAULT_NEAR = 0.1;
const DEFAULT_FAR = 500;
const IDENTITY_MATRIX$1 = Object.freeze([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
class Matrix4 extends Matrix {
  static get IDENTITY() {
    return getIdentityMatrix();
  }
  static get ZERO() {
    return getZeroMatrix();
  }
  get ELEMENTS() {
    return 16;
  }
  get RANK() {
    return 4;
  }
  get INDICES() {
    return INDICES;
  }
  constructor(array2) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0);
    if (arguments.length === 1 && Array.isArray(array2)) {
      this.copy(array2);
    } else {
      this.identity();
    }
  }
  copy(array2) {
    this[0] = array2[0];
    this[1] = array2[1];
    this[2] = array2[2];
    this[3] = array2[3];
    this[4] = array2[4];
    this[5] = array2[5];
    this[6] = array2[6];
    this[7] = array2[7];
    this[8] = array2[8];
    this[9] = array2[9];
    this[10] = array2[10];
    this[11] = array2[11];
    this[12] = array2[12];
    this[13] = array2[13];
    this[14] = array2[14];
    this[15] = array2[15];
    return this.check();
  }
  // eslint-disable-next-line max-params
  set(m00, m10, m20, m30, m01, m11, m21, m31, m02, m12, m22, m32, m03, m13, m23, m33) {
    this[0] = m00;
    this[1] = m10;
    this[2] = m20;
    this[3] = m30;
    this[4] = m01;
    this[5] = m11;
    this[6] = m21;
    this[7] = m31;
    this[8] = m02;
    this[9] = m12;
    this[10] = m22;
    this[11] = m32;
    this[12] = m03;
    this[13] = m13;
    this[14] = m23;
    this[15] = m33;
    return this.check();
  }
  // accepts row major order, stores as column major
  // eslint-disable-next-line max-params
  setRowMajor(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    this[0] = m00;
    this[1] = m10;
    this[2] = m20;
    this[3] = m30;
    this[4] = m01;
    this[5] = m11;
    this[6] = m21;
    this[7] = m31;
    this[8] = m02;
    this[9] = m12;
    this[10] = m22;
    this[11] = m32;
    this[12] = m03;
    this[13] = m13;
    this[14] = m23;
    this[15] = m33;
    return this.check();
  }
  toRowMajor(result) {
    result[0] = this[0];
    result[1] = this[4];
    result[2] = this[8];
    result[3] = this[12];
    result[4] = this[1];
    result[5] = this[5];
    result[6] = this[9];
    result[7] = this[13];
    result[8] = this[2];
    result[9] = this[6];
    result[10] = this[10];
    result[11] = this[14];
    result[12] = this[3];
    result[13] = this[7];
    result[14] = this[11];
    result[15] = this[15];
    return result;
  }
  // Constructors
  /** Set to identity matrix */
  identity() {
    return this.copy(IDENTITY_MATRIX$1);
  }
  /**
   *
   * @param object
   * @returns self
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fromObject(object2) {
    return this.check();
  }
  /**
   * Calculates a 4x4 matrix from the given quaternion
   * @param quaternion Quaternion to create matrix from
   * @returns self
   */
  fromQuaternion(quaternion2) {
    fromQuat(this, quaternion2);
    return this.check();
  }
  /**
   * Generates a frustum matrix with the given bounds
   * @param view.left - Left bound of the frustum
   * @param view.right - Right bound of the frustum
   * @param view.bottom - Bottom bound of the frustum
   * @param view.top - Top bound of the frustum
   * @param view.near - Near bound of the frustum
   * @param view.far - Far bound of the frustum. Can be set to Infinity.
   * @returns self
   */
  frustum(view2) {
    const { left, right, bottom, top, near = DEFAULT_NEAR, far = DEFAULT_FAR } = view2;
    if (far === Infinity) {
      computeInfinitePerspectiveOffCenter(this, left, right, bottom, top, near);
    } else {
      frustum(this, left, right, bottom, top, near, far);
    }
    return this.check();
  }
  /**
   * Generates a look-at matrix with the given eye position, focal point,
   * and up axis
   * @param view.eye - (vector) Position of the viewer
   * @param view.center - (vector) Point the viewer is looking at
   * @param view.up - (vector) Up axis
   * @returns self
   */
  lookAt(view2) {
    const { eye, center: center2 = [0, 0, 0], up = [0, 1, 0] } = view2;
    lookAt(this, eye, center2, up);
    return this.check();
  }
  /**
   * Generates a orthogonal projection matrix with the given bounds
   * from "traditional" view space parameters
   * @param view.left - Left bound of the frustum
   * @param view.right number  Right bound of the frustum
   * @param view.bottom - Bottom bound of the frustum
   * @param view.top number  Top bound of the frustum
   * @param view.near - Near bound of the frustum
   * @param view.far number  Far bound of the frustum
   * @returns self
   */
  ortho(view2) {
    const { left, right, bottom, top, near = DEFAULT_NEAR, far = DEFAULT_FAR } = view2;
    ortho(this, left, right, bottom, top, near, far);
    return this.check();
  }
  /**
   * Generates an orthogonal projection matrix with the same parameters
   * as a perspective matrix (plus focalDistance)
   * @param view.fovy Vertical field of view in radians
   * @param view.aspect Aspect ratio. Typically viewport width / viewport height
   * @param view.focalDistance Distance in the view frustum used for extent calculations
   * @param view.near Near bound of the frustum
   * @param view.far Far bound of the frustum
   * @returns self
   */
  orthographic(view2) {
    const { fovy = DEFAULT_FOVY, aspect: aspect2 = DEFAULT_ASPECT, focalDistance = 1, near = DEFAULT_NEAR, far = DEFAULT_FAR } = view2;
    checkRadians(fovy);
    const halfY = fovy / 2;
    const top = focalDistance * Math.tan(halfY);
    const right = top * aspect2;
    return this.ortho({
      left: -right,
      right,
      bottom: -top,
      top,
      near,
      far
    });
  }
  /**
   * Generates a perspective projection matrix with the given bounds
   * @param view.fovy Vertical field of view in radians
   * @param view.aspect Aspect ratio. typically viewport width/height
   * @param view.near Near bound of the frustum
   * @param view.far Far bound of the frustum
   * @returns self
   */
  perspective(view2) {
    const { fovy = 45 * Math.PI / 180, aspect: aspect2 = 1, near = 0.1, far = 500 } = view2;
    checkRadians(fovy);
    perspective(this, fovy, aspect2, near, far);
    return this.check();
  }
  // Accessors
  determinant() {
    return determinant(this);
  }
  /**
   * Extracts the non-uniform scale assuming the matrix is an affine transformation.
   * The scales are the "lengths" of the column vectors in the upper-left 3x3 matrix.
   * @param result
   * @returns self
   */
  getScale(result = [-0, -0, -0]) {
    result[0] = Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]);
    result[1] = Math.sqrt(this[4] * this[4] + this[5] * this[5] + this[6] * this[6]);
    result[2] = Math.sqrt(this[8] * this[8] + this[9] * this[9] + this[10] * this[10]);
    return result;
  }
  /**
   * Gets the translation portion, assuming the matrix is a affine transformation matrix.
   * @param result
   * @returns self
   */
  getTranslation(result = [-0, -0, -0]) {
    result[0] = this[12];
    result[1] = this[13];
    result[2] = this[14];
    return result;
  }
  /**
   * Gets upper left 3x3 pure rotation matrix (non-scaling), assume affine transformation matrix
   * @param result
   * @param scaleResult
   * @returns self
   */
  getRotation(result, scaleResult) {
    result = result || [-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0];
    scaleResult = scaleResult || [-0, -0, -0];
    const scale5 = this.getScale(scaleResult);
    const inverseScale0 = 1 / scale5[0];
    const inverseScale1 = 1 / scale5[1];
    const inverseScale2 = 1 / scale5[2];
    result[0] = this[0] * inverseScale0;
    result[1] = this[1] * inverseScale1;
    result[2] = this[2] * inverseScale2;
    result[3] = 0;
    result[4] = this[4] * inverseScale0;
    result[5] = this[5] * inverseScale1;
    result[6] = this[6] * inverseScale2;
    result[7] = 0;
    result[8] = this[8] * inverseScale0;
    result[9] = this[9] * inverseScale1;
    result[10] = this[10] * inverseScale2;
    result[11] = 0;
    result[12] = 0;
    result[13] = 0;
    result[14] = 0;
    result[15] = 1;
    return result;
  }
  /**
   *
   * @param result
   * @param scaleResult
   * @returns self
   */
  getRotationMatrix3(result, scaleResult) {
    result = result || [-0, -0, -0, -0, -0, -0, -0, -0, -0];
    scaleResult = scaleResult || [-0, -0, -0];
    const scale5 = this.getScale(scaleResult);
    const inverseScale0 = 1 / scale5[0];
    const inverseScale1 = 1 / scale5[1];
    const inverseScale2 = 1 / scale5[2];
    result[0] = this[0] * inverseScale0;
    result[1] = this[1] * inverseScale1;
    result[2] = this[2] * inverseScale2;
    result[3] = this[4] * inverseScale0;
    result[4] = this[5] * inverseScale1;
    result[5] = this[6] * inverseScale2;
    result[6] = this[8] * inverseScale0;
    result[7] = this[9] * inverseScale1;
    result[8] = this[10] * inverseScale2;
    return result;
  }
  // Modifiers
  transpose() {
    transpose(this, this);
    return this.check();
  }
  invert() {
    invert$1(this, this);
    return this.check();
  }
  // Operations
  multiplyLeft(a2) {
    multiply$1(this, a2, this);
    return this.check();
  }
  multiplyRight(a2) {
    multiply$1(this, this, a2);
    return this.check();
  }
  // Rotates a matrix by the given angle around the X axis
  rotateX(radians2) {
    rotateX$1(this, this, radians2);
    return this.check();
  }
  // Rotates a matrix by the given angle around the Y axis.
  rotateY(radians2) {
    rotateY$1(this, this, radians2);
    return this.check();
  }
  /**
   * Rotates a matrix by the given angle around the Z axis.
   * @param radians
   * @returns self
   */
  rotateZ(radians2) {
    rotateZ$1(this, this, radians2);
    return this.check();
  }
  /**
   *
   * @param param0
   * @returns self
   */
  rotateXYZ(angleXYZ) {
    return this.rotateX(angleXYZ[0]).rotateY(angleXYZ[1]).rotateZ(angleXYZ[2]);
  }
  /**
   *
   * @param radians
   * @param axis
   * @returns self
   */
  rotateAxis(radians2, axis) {
    rotate(this, this, radians2, axis);
    return this.check();
  }
  /**
   *
   * @param factor
   * @returns self
   */
  scale(factor) {
    scale$2(this, this, Array.isArray(factor) ? factor : [factor, factor, factor]);
    return this.check();
  }
  /**
   *
   * @param vec
   * @returns self
   */
  translate(vector) {
    translate(this, this, vector);
    return this.check();
  }
  // Transforms
  /**
   * Transforms any 2, 3 or 4 element vector. 2 and 3 elements are treated as points
   * @param vector
   * @param result
   * @returns self
   */
  transform(vector, result) {
    if (vector.length === 4) {
      result = transformMat4(result || [-0, -0, -0, -0], vector, this);
      checkVector(result, 4);
      return result;
    }
    return this.transformAsPoint(vector, result);
  }
  /**
   * Transforms any 2 or 3 element array as point (w implicitly 1)
   * @param vector
   * @param result
   * @returns self
   */
  transformAsPoint(vector, result) {
    const { length: length2 } = vector;
    let out;
    switch (length2) {
      case 2:
        out = transformMat4$2(result || [-0, -0], vector, this);
        break;
      case 3:
        out = transformMat4$1(result || [-0, -0, -0], vector, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    checkVector(out, vector.length);
    return out;
  }
  /**
   * Transforms any 2 or 3 element array as vector (w implicitly 0)
   * @param vector
   * @param result
   * @returns self
   */
  transformAsVector(vector, result) {
    let out;
    switch (vector.length) {
      case 2:
        out = vec2_transformMat4AsVector(result || [-0, -0], vector, this);
        break;
      case 3:
        out = vec3_transformMat4AsVector(result || [-0, -0, -0], vector, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    checkVector(out, vector.length);
    return out;
  }
  /** @deprecated */
  transformPoint(vector, result) {
    return this.transformAsPoint(vector, result);
  }
  /** @deprecated */
  transformVector(vector, result) {
    return this.transformAsPoint(vector, result);
  }
  /** @deprecated */
  transformDirection(vector, result) {
    return this.transformAsVector(vector, result);
  }
  // three.js math API compatibility
  makeRotationX(radians2) {
    return this.identity().rotateX(radians2);
  }
  makeTranslation(x2, y2, z2) {
    return this.identity().translate([x2, y2, z2]);
  }
}
let ZERO$2;
let IDENTITY$1;
function getZeroMatrix() {
  if (!ZERO$2) {
    ZERO$2 = new Matrix4([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    Object.freeze(ZERO$2);
  }
  return ZERO$2;
}
function getIdentityMatrix() {
  if (!IDENTITY$1) {
    IDENTITY$1 = new Matrix4();
    Object.freeze(IDENTITY$1);
  }
  return IDENTITY$1;
}
function checkRadians(possiblyDegrees) {
  if (possiblyDegrees > Math.PI * 2) {
    throw Error("expected radians");
  }
}
function computeInfinitePerspectiveOffCenter(result, left, right, bottom, top, near) {
  const column0Row0 = 2 * near / (right - left);
  const column1Row1 = 2 * near / (top - bottom);
  const column2Row0 = (right + left) / (right - left);
  const column2Row1 = (top + bottom) / (top - bottom);
  const column2Row2 = -1;
  const column2Row3 = -1;
  const column3Row2 = -2 * near;
  result[0] = column0Row0;
  result[1] = 0;
  result[2] = 0;
  result[3] = 0;
  result[4] = 0;
  result[5] = column1Row1;
  result[6] = 0;
  result[7] = 0;
  result[8] = column2Row0;
  result[9] = column2Row1;
  result[10] = column2Row2;
  result[11] = column2Row3;
  result[12] = 0;
  result[13] = 0;
  result[14] = column3Row2;
  result[15] = 0;
  return result;
}
function create$1() {
  const out = new ARRAY_TYPE(4);
  if (ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }
  out[3] = 1;
  return out;
}
function identity$2(out) {
  out[0] = 0;
  out[1] = 0;
  out[2] = 0;
  out[3] = 1;
  return out;
}
function setAxisAngle(out, axis, rad2) {
  rad2 = rad2 * 0.5;
  const s2 = Math.sin(rad2);
  out[0] = s2 * axis[0];
  out[1] = s2 * axis[1];
  out[2] = s2 * axis[2];
  out[3] = Math.cos(rad2);
  return out;
}
function multiply(out, a2, b2) {
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const aw2 = a2[3];
  const bx2 = b2[0];
  const by2 = b2[1];
  const bz2 = b2[2];
  const bw2 = b2[3];
  out[0] = ax2 * bw2 + aw2 * bx2 + ay2 * bz2 - az2 * by2;
  out[1] = ay2 * bw2 + aw2 * by2 + az2 * bx2 - ax2 * bz2;
  out[2] = az2 * bw2 + aw2 * bz2 + ax2 * by2 - ay2 * bx2;
  out[3] = aw2 * bw2 - ax2 * bx2 - ay2 * by2 - az2 * bz2;
  return out;
}
function rotateX(out, a2, rad2) {
  rad2 *= 0.5;
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const aw2 = a2[3];
  const bx2 = Math.sin(rad2);
  const bw2 = Math.cos(rad2);
  out[0] = ax2 * bw2 + aw2 * bx2;
  out[1] = ay2 * bw2 + az2 * bx2;
  out[2] = az2 * bw2 - ay2 * bx2;
  out[3] = aw2 * bw2 - ax2 * bx2;
  return out;
}
function rotateY(out, a2, rad2) {
  rad2 *= 0.5;
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const aw2 = a2[3];
  const by2 = Math.sin(rad2);
  const bw2 = Math.cos(rad2);
  out[0] = ax2 * bw2 - az2 * by2;
  out[1] = ay2 * bw2 + aw2 * by2;
  out[2] = az2 * bw2 + ax2 * by2;
  out[3] = aw2 * bw2 - ay2 * by2;
  return out;
}
function rotateZ(out, a2, rad2) {
  rad2 *= 0.5;
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const aw2 = a2[3];
  const bz2 = Math.sin(rad2);
  const bw2 = Math.cos(rad2);
  out[0] = ax2 * bw2 + ay2 * bz2;
  out[1] = ay2 * bw2 - ax2 * bz2;
  out[2] = az2 * bw2 + aw2 * bz2;
  out[3] = aw2 * bw2 - az2 * bz2;
  return out;
}
function calculateW(out, a2) {
  const x2 = a2[0];
  const y2 = a2[1];
  const z2 = a2[2];
  out[0] = x2;
  out[1] = y2;
  out[2] = z2;
  out[3] = Math.sqrt(Math.abs(1 - x2 * x2 - y2 * y2 - z2 * z2));
  return out;
}
function slerp(out, a2, b2, t2) {
  const ax2 = a2[0];
  const ay2 = a2[1];
  const az2 = a2[2];
  const aw2 = a2[3];
  let bx2 = b2[0];
  let by2 = b2[1];
  let bz2 = b2[2];
  let bw2 = b2[3];
  let cosom;
  let omega;
  let scale0;
  let scale1;
  let sinom;
  cosom = ax2 * bx2 + ay2 * by2 + az2 * bz2 + aw2 * bw2;
  if (cosom < 0) {
    cosom = -cosom;
    bx2 = -bx2;
    by2 = -by2;
    bz2 = -bz2;
    bw2 = -bw2;
  }
  if (1 - cosom > EPSILON$1) {
    omega = Math.acos(cosom);
    sinom = Math.sin(omega);
    scale0 = Math.sin((1 - t2) * omega) / sinom;
    scale1 = Math.sin(t2 * omega) / sinom;
  } else {
    scale0 = 1 - t2;
    scale1 = t2;
  }
  out[0] = scale0 * ax2 + scale1 * bx2;
  out[1] = scale0 * ay2 + scale1 * by2;
  out[2] = scale0 * az2 + scale1 * bz2;
  out[3] = scale0 * aw2 + scale1 * bw2;
  return out;
}
function invert(out, a2) {
  const a0 = a2[0];
  const a1 = a2[1];
  const a22 = a2[2];
  const a3 = a2[3];
  const dot2 = a0 * a0 + a1 * a1 + a22 * a22 + a3 * a3;
  const invDot = dot2 ? 1 / dot2 : 0;
  out[0] = -a0 * invDot;
  out[1] = -a1 * invDot;
  out[2] = -a22 * invDot;
  out[3] = a3 * invDot;
  return out;
}
function conjugate(out, a2) {
  out[0] = -a2[0];
  out[1] = -a2[1];
  out[2] = -a2[2];
  out[3] = a2[3];
  return out;
}
function fromMat3(out, m2) {
  const fTrace = m2[0] + m2[4] + m2[8];
  let fRoot;
  if (fTrace > 0) {
    fRoot = Math.sqrt(fTrace + 1);
    out[3] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[0] = (m2[5] - m2[7]) * fRoot;
    out[1] = (m2[6] - m2[2]) * fRoot;
    out[2] = (m2[1] - m2[3]) * fRoot;
  } else {
    let i2 = 0;
    if (m2[4] > m2[0])
      i2 = 1;
    if (m2[8] > m2[i2 * 3 + i2])
      i2 = 2;
    const j2 = (i2 + 1) % 3;
    const k2 = (i2 + 2) % 3;
    fRoot = Math.sqrt(m2[i2 * 3 + i2] - m2[j2 * 3 + j2] - m2[k2 * 3 + k2] + 1);
    out[i2] = 0.5 * fRoot;
    fRoot = 0.5 / fRoot;
    out[3] = (m2[j2 * 3 + k2] - m2[k2 * 3 + j2]) * fRoot;
    out[j2] = (m2[j2 * 3 + i2] + m2[i2 * 3 + j2]) * fRoot;
    out[k2] = (m2[k2 * 3 + i2] + m2[i2 * 3 + k2]) * fRoot;
  }
  return out;
}
const add$1 = add$2;
const scale = scale$1;
const dot = dot$1;
const lerp = lerp$1;
const length$2 = length$3;
const squaredLength = squaredLength$1;
const normalize$3 = normalize$4;
const rotationTo = function() {
  const tmpvec3 = create$4();
  const xUnitVec3 = fromValues(1, 0, 0);
  const yUnitVec3 = fromValues(0, 1, 0);
  return function(out, a2, b2) {
    const dot2 = dot$2(a2, b2);
    if (dot2 < -0.999999) {
      cross(tmpvec3, xUnitVec3, a2);
      if (len(tmpvec3) < 1e-6)
        cross(tmpvec3, yUnitVec3, a2);
      normalize$5(tmpvec3, tmpvec3);
      setAxisAngle(out, tmpvec3, Math.PI);
      return out;
    } else if (dot2 > 0.999999) {
      out[0] = 0;
      out[1] = 0;
      out[2] = 0;
      out[3] = 1;
      return out;
    }
    cross(tmpvec3, a2, b2);
    out[0] = tmpvec3[0];
    out[1] = tmpvec3[1];
    out[2] = tmpvec3[2];
    out[3] = 1 + dot2;
    return normalize$3(out, out);
  };
}();
(function() {
  const temp1 = create$1();
  const temp2 = create$1();
  return function(out, a2, b2, c2, d2, t2) {
    slerp(temp1, a2, d2, t2);
    slerp(temp2, b2, c2, t2);
    slerp(out, temp1, temp2, 2 * t2 * (1 - t2));
    return out;
  };
})();
(function() {
  const matr = create$3();
  return function(out, view2, right, up) {
    matr[0] = right[0];
    matr[3] = right[1];
    matr[6] = right[2];
    matr[1] = up[0];
    matr[4] = up[1];
    matr[7] = up[2];
    matr[2] = -view2[0];
    matr[5] = -view2[1];
    matr[8] = -view2[2];
    return normalize$3(out, fromMat3(out, matr));
  };
})();
const IDENTITY_QUATERNION = [0, 0, 0, 1];
class Quaternion extends MathArray {
  constructor(x2 = 0, y2 = 0, z2 = 0, w2 = 1) {
    super(-0, -0, -0, -0);
    if (Array.isArray(x2) && arguments.length === 1) {
      this.copy(x2);
    } else {
      this.set(x2, y2, z2, w2);
    }
  }
  copy(array2) {
    this[0] = array2[0];
    this[1] = array2[1];
    this[2] = array2[2];
    this[3] = array2[3];
    return this.check();
  }
  set(x2, y2, z2, w2) {
    this[0] = x2;
    this[1] = y2;
    this[2] = z2;
    this[3] = w2;
    return this.check();
  }
  fromObject(object2) {
    this[0] = object2.x;
    this[1] = object2.y;
    this[2] = object2.z;
    this[3] = object2.w;
    return this.check();
  }
  /**
   * Creates a quaternion from the given 3x3 rotation matrix.
   * NOTE: The resultant quaternion is not normalized, so you should
   * be sure to renormalize the quaternion yourself where necessary.
   * @param m
   * @returns
   */
  fromMatrix3(m2) {
    fromMat3(this, m2);
    return this.check();
  }
  fromAxisRotation(axis, rad2) {
    setAxisAngle(this, axis, rad2);
    return this.check();
  }
  /** Set a quat to the identity quaternion */
  identity() {
    identity$2(this);
    return this.check();
  }
  // Set the components of a quat to the given values
  // set(i, j, k, l) {
  //   quat_set(this, i, j, k, l);
  //   return this.check();
  // }
  // Sets a quat from the given angle and rotation axis, then returns it.
  setAxisAngle(axis, rad2) {
    return this.fromAxisRotation(axis, rad2);
  }
  // Getters/setters
  get ELEMENTS() {
    return 4;
  }
  get x() {
    return this[0];
  }
  set x(value) {
    this[0] = checkNumber(value);
  }
  get y() {
    return this[1];
  }
  set y(value) {
    this[1] = checkNumber(value);
  }
  get z() {
    return this[2];
  }
  set z(value) {
    this[2] = checkNumber(value);
  }
  get w() {
    return this[3];
  }
  set w(value) {
    this[3] = checkNumber(value);
  }
  // Calculates the length of a quat
  len() {
    return length$2(this);
  }
  // Calculates the squared length of a quat
  lengthSquared() {
    return squaredLength(this);
  }
  // Calculates the dot product of two quat's
  // @return {Number}
  dot(a2) {
    return dot(this, a2);
  }
  // Gets the rotation axis and angle for a given quaternion.
  // If a quaternion is created with setAxisAngle, this method will
  // return the same values as providied in the original parameter
  // list OR functionally equivalent values.
  // Example: The quaternion formed by axis [0, 0, 1] and angle -90
  // is the same as the quaternion formed by [0, 0, 1] and 270.
  // This method favors the latter.
  // @return {{[x,y,z], Number}}
  // getAxisAngle() {
  //   const axis = [];
  // //   const angle = quat_getAxisAngle(axis, this);
  //   return {axis, angle};
  // }
  // MODIFIERS
  // Sets a quaternion to represent the shortest rotation from one vector
  // to another. Both vectors are assumed to be unit length.
  rotationTo(vectorA, vectorB) {
    rotationTo(this, vectorA, vectorB);
    return this.check();
  }
  // Sets the specified quaternion with values corresponding to the given axes.
  // Each axis is a vec3 and is expected to be unit length and perpendicular
  // to all other specified axes.
  // setAxes() {
  //   Number
  // }
  // Performs a spherical linear interpolation with two control points
  // sqlerp() {
  //   Number;
  // }
  // Adds two quat's
  add(a2) {
    add$1(this, this, a2);
    return this.check();
  }
  // Calculates the W component of a quat from the X, Y, and Z components.
  // Any existing W component will be ignored.
  calculateW() {
    calculateW(this, this);
    return this.check();
  }
  // Calculates the conjugate of a quat If the quaternion is normalized,
  // this function is faster than quat_invert and produces the same result.
  conjugate() {
    conjugate(this, this);
    return this.check();
  }
  // Calculates the inverse of a quat
  invert() {
    invert(this, this);
    return this.check();
  }
  // Performs a linear interpolation between two quat's
  lerp(a2, b2, t2) {
    if (t2 === void 0) {
      return this.lerp(this, a2, b2);
    }
    lerp(this, a2, b2, t2);
    return this.check();
  }
  // Multiplies two quat's
  multiplyRight(a2) {
    multiply(this, this, a2);
    return this.check();
  }
  multiplyLeft(a2) {
    multiply(this, a2, this);
    return this.check();
  }
  // Normalize a quat
  normalize() {
    const length2 = this.len();
    const l2 = length2 > 0 ? 1 / length2 : 0;
    this[0] = this[0] * l2;
    this[1] = this[1] * l2;
    this[2] = this[2] * l2;
    this[3] = this[3] * l2;
    if (length2 === 0) {
      this[3] = 1;
    }
    return this.check();
  }
  // Rotates a quaternion by the given angle about the X axis
  rotateX(rad2) {
    rotateX(this, this, rad2);
    return this.check();
  }
  // Rotates a quaternion by the given angle about the Y axis
  rotateY(rad2) {
    rotateY(this, this, rad2);
    return this.check();
  }
  // Rotates a quaternion by the given angle about the Z axis
  rotateZ(rad2) {
    rotateZ(this, this, rad2);
    return this.check();
  }
  // Scales a quat by a scalar number
  scale(b2) {
    scale(this, this, b2);
    return this.check();
  }
  // Performs a spherical linear interpolation between two quat
  slerp(arg0, arg1, arg2) {
    let start2;
    let target;
    let ratio;
    switch (arguments.length) {
      case 1:
        ({
          start: start2 = IDENTITY_QUATERNION,
          target,
          ratio
        } = arg0);
        break;
      case 2:
        start2 = this;
        target = arg0;
        ratio = arg1;
        break;
      default:
        start2 = arg0;
        target = arg1;
        ratio = arg2;
    }
    slerp(this, start2, target, ratio);
    return this.check();
  }
  transformVector4(vector, result = new Vector4()) {
    transformQuat(result, vector, this);
    return checkVector(result, 4);
  }
  // THREE.js Math API compatibility
  lengthSq() {
    return this.lengthSquared();
  }
  setFromAxisAngle(axis, rad2) {
    return this.setAxisAngle(axis, rad2);
  }
  premultiply(a2) {
    return this.multiplyLeft(a2);
  }
  multiply(a2) {
    return this.multiplyRight(a2);
  }
}
const EPSILON1 = 0.1;
const EPSILON12 = 1e-12;
const EPSILON15 = 1e-15;
const EPSILON20 = 1e-20;
const lightingShader$2 = `#if (defined(SHADER_TYPE_FRAGMENT) && defined(LIGHTING_FRAGMENT)) || (defined(SHADER_TYPE_VERTEX) && defined(LIGHTING_VERTEX))
struct AmbientLight {
vec3 color;
};
struct PointLight {
vec3 color;
vec3 position;
vec3 attenuation;
};
struct DirectionalLight {
vec3 color;
vec3 direction;
};
uniform AmbientLight lighting_uAmbientLight;
uniform PointLight lighting_uPointLight[MAX_LIGHTS];
uniform DirectionalLight lighting_uDirectionalLight[MAX_LIGHTS];
uniform int lighting_uPointLightCount;
uniform int lighting_uDirectionalLightCount;
uniform bool lighting_uEnabled;
float getPointLightAttenuation(PointLight pointLight, float distance) {
return pointLight.attenuation.x
+ pointLight.attenuation.y * distance
+ pointLight.attenuation.z * distance * distance;
}
#endif
`;
const INITIAL_MODULE_OPTIONS$3 = {
  lightSources: {}
};
function convertColor$1(colorDef = {}) {
  const { color = [0, 0, 0], intensity = 1 } = colorDef;
  return color.map((component) => component * intensity / 255);
}
function getLightSourceUniforms$1({ ambientLight, pointLights = [], directionalLights = [] }) {
  const lightSourceUniforms = {};
  if (ambientLight) {
    lightSourceUniforms["lighting_uAmbientLight.color"] = convertColor$1(ambientLight);
  } else {
    lightSourceUniforms["lighting_uAmbientLight.color"] = [0, 0, 0];
  }
  pointLights.forEach((pointLight, index2) => {
    lightSourceUniforms[`lighting_uPointLight[${index2}].color`] = convertColor$1(pointLight);
    lightSourceUniforms[`lighting_uPointLight[${index2}].position`] = pointLight.position;
    lightSourceUniforms[`lighting_uPointLight[${index2}].attenuation`] = pointLight.attenuation || [
      1,
      0,
      0
    ];
  });
  lightSourceUniforms.lighting_uPointLightCount = pointLights.length;
  directionalLights.forEach((directionalLight, index2) => {
    lightSourceUniforms[`lighting_uDirectionalLight[${index2}].color`] = convertColor$1(directionalLight);
    lightSourceUniforms[`lighting_uDirectionalLight[${index2}].direction`] = directionalLight.direction;
  });
  lightSourceUniforms.lighting_uDirectionalLightCount = directionalLights.length;
  return lightSourceUniforms;
}
function getUniforms$3(opts = INITIAL_MODULE_OPTIONS$3) {
  var _a3, _b3;
  if ("lightSources" in opts) {
    const { ambientLight, pointLights, directionalLights } = opts.lightSources || {};
    const hasLights = ambientLight || pointLights && pointLights.length > 0 || directionalLights && directionalLights.length > 0;
    if (!hasLights) {
      return { lighting_uEnabled: false };
    }
    return Object.assign({}, getLightSourceUniforms$1({ ambientLight, pointLights, directionalLights }), {
      lighting_uEnabled: true
    });
  }
  if ("lights" in opts) {
    const lightSources = { pointLights: [], directionalLights: [] };
    for (const light of opts.lights || []) {
      switch (light.type) {
        case "ambient":
          lightSources.ambientLight = light;
          break;
        case "directional":
          (_a3 = lightSources.directionalLights) == null ? void 0 : _a3.push(light);
          break;
        case "point":
          (_b3 = lightSources.pointLights) == null ? void 0 : _b3.push(light);
          break;
      }
    }
    return getUniforms$3({ lightSources });
  }
  return {};
}
const lights$1 = {
  name: "lights",
  vs: lightingShader$2,
  fs: lightingShader$2,
  getUniforms: getUniforms$3,
  defines: {
    MAX_LIGHTS: 3
  }
};
const lightingShader$1 = `uniform float lighting_uAmbient;
uniform float lighting_uDiffuse;
uniform float lighting_uShininess;
uniform vec3  lighting_uSpecularColor;
vec3 lighting_getLightColor(vec3 surfaceColor, vec3 light_direction, vec3 view_direction, vec3 normal_worldspace, vec3 color) {
vec3 halfway_direction = normalize(light_direction + view_direction);
float lambertian = dot(light_direction, normal_worldspace);
float specular = 0.0;
if (lambertian > 0.0) {
float specular_angle = max(dot(normal_worldspace, halfway_direction), 0.0);
specular = pow(specular_angle, lighting_uShininess);
}
lambertian = max(lambertian, 0.0);
return (lambertian * lighting_uDiffuse * surfaceColor + specular * lighting_uSpecularColor) * color;
}
vec3 lighting_getLightColor(vec3 surfaceColor, vec3 cameraPosition, vec3 position_worldspace, vec3 normal_worldspace) {
vec3 lightColor = surfaceColor;
if (lighting_uEnabled) {
vec3 view_direction = normalize(cameraPosition - position_worldspace);
lightColor = lighting_uAmbient * surfaceColor * lighting_uAmbientLight.color;
for (int i = 0; i < MAX_LIGHTS; i++) {
if (i >= lighting_uPointLightCount) {
break;
}
PointLight pointLight = lighting_uPointLight[i];
vec3 light_position_worldspace = pointLight.position;
vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
}
for (int i = 0; i < MAX_LIGHTS; i++) {
if (i >= lighting_uDirectionalLightCount) {
break;
}
DirectionalLight directionalLight = lighting_uDirectionalLight[i];
lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
}
}
return lightColor;
}
vec3 lighting_getSpecularLightColor(vec3 cameraPosition, vec3 position_worldspace, vec3 normal_worldspace) {
vec3 lightColor = vec3(0, 0, 0);
vec3 surfaceColor = vec3(0, 0, 0);
if (lighting_uEnabled) {
vec3 view_direction = normalize(cameraPosition - position_worldspace);
for (int i = 0; i < MAX_LIGHTS; i++) {
if (i >= lighting_uPointLightCount) {
break;
}
PointLight pointLight = lighting_uPointLight[i];
vec3 light_position_worldspace = pointLight.position;
vec3 light_direction = normalize(light_position_worldspace - position_worldspace);
lightColor += lighting_getLightColor(surfaceColor, light_direction, view_direction, normal_worldspace, pointLight.color);
}
for (int i = 0; i < MAX_LIGHTS; i++) {
if (i >= lighting_uDirectionalLightCount) {
break;
}
DirectionalLight directionalLight = lighting_uDirectionalLight[i];
lightColor += lighting_getLightColor(surfaceColor, -directionalLight.direction, view_direction, normal_worldspace, directionalLight.color);
}
}
return lightColor;
}
`;
const INITIAL_MODULE_OPTIONS$2 = {};
function getMaterialUniforms(material) {
  const { ambient = 0.35, diffuse = 0.6, shininess = 32, specularColor = [30, 30, 30] } = material;
  return {
    lighting_uAmbient: ambient,
    lighting_uDiffuse: diffuse,
    lighting_uShininess: shininess,
    lighting_uSpecularColor: specularColor.map((x2) => x2 / 255)
  };
}
function getUniforms$2(opts = INITIAL_MODULE_OPTIONS$2) {
  if (!("material" in opts)) {
    return {};
  }
  const { material } = opts;
  if (!material) {
    return { lighting_uEnabled: false };
  }
  return getMaterialUniforms(material);
}
const gouraudLighting = {
  name: "gouraud-lighting",
  dependencies: [lights$1],
  vs: lightingShader$1,
  defines: {
    LIGHTING_VERTEX: 1
  },
  getUniforms: getUniforms$2
};
const phongLighting = {
  name: "phong-lighting",
  dependencies: [lights$1],
  fs: lightingShader$1,
  defines: {
    LIGHTING_FRAGMENT: 1
  },
  getUniforms: getUniforms$2
};
const vs$h = `uniform mat4 u_MVPMatrix;
uniform mat4 u_ModelMatrix;
uniform mat4 u_NormalMatrix;
out vec3 pbr_vPosition;
out vec2 pbr_vUV;
#ifdef HAS_NORMALS
# ifdef HAS_TANGENTS
out mat3 pbr_vTBN;
# else
out vec3 pbr_vNormal;
# endif
#endif
void pbr_setPositionNormalTangentUV(vec4 position, vec4 normal, vec4 tangent, vec2 uv)
{
vec4 pos = u_ModelMatrix * position;
pbr_vPosition = vec3(pos.xyz) / pos.w;
#ifdef HAS_NORMALS
#ifdef HAS_TANGENTS
vec3 normalW = normalize(vec3(u_NormalMatrix * vec4(normal.xyz, 0.0)));
vec3 tangentW = normalize(vec3(u_ModelMatrix * vec4(tangent.xyz, 0.0)));
vec3 bitangentW = cross(normalW, tangentW) * tangent.w;
pbr_vTBN = mat3(tangentW, bitangentW, normalW);
#else
pbr_vNormal = normalize(vec3(u_ModelMatrix * vec4(normal.xyz, 0.0)));
#endif
#endif
#ifdef HAS_UV
pbr_vUV = uv;
#else
pbr_vUV = vec2(0.,0.);
#endif
}
`;
const fs$h = `precision highp float;
uniform bool pbr_uUnlit;
#ifdef USE_IBL
uniform samplerCube u_DiffuseEnvSampler;
uniform samplerCube u_SpecularEnvSampler;
uniform sampler2D u_brdfLUT;
uniform vec2 u_ScaleIBLAmbient;
#endif
#ifdef HAS_BASECOLORMAP
uniform sampler2D u_BaseColorSampler;
#endif
#ifdef HAS_NORMALMAP
uniform sampler2D u_NormalSampler;
uniform float u_NormalScale;
#endif
#ifdef HAS_EMISSIVEMAP
uniform sampler2D u_EmissiveSampler;
uniform vec3 u_EmissiveFactor;
#endif
#ifdef HAS_METALROUGHNESSMAP
uniform sampler2D u_MetallicRoughnessSampler;
#endif
#ifdef HAS_OCCLUSIONMAP
uniform sampler2D u_OcclusionSampler;
uniform float u_OcclusionStrength;
#endif
#ifdef ALPHA_CUTOFF
uniform float u_AlphaCutoff;
#endif
uniform vec2 u_MetallicRoughnessValues;
uniform vec4 u_BaseColorFactor;
uniform vec3 u_Camera;
#ifdef PBR_DEBUG
uniform vec4 u_ScaleDiffBaseMR;
uniform vec4 u_ScaleFGDSpec;
#endif
in vec3 pbr_vPosition;
in vec2 pbr_vUV;
#ifdef HAS_NORMALS
#ifdef HAS_TANGENTS
in mat3 pbr_vTBN;
#else
in vec3 pbr_vNormal;
#endif
#endif
struct PBRInfo
{
float NdotL;
float NdotV;
float NdotH;
float LdotH;
float VdotH;
float perceptualRoughness;
float metalness;
vec3 reflectance0;
vec3 reflectance90;
float alphaRoughness;
vec3 diffuseColor;
vec3 specularColor;
vec3 n;
vec3 v;
};
const float M_PI = 3.141592653589793;
const float c_MinRoughness = 0.04;
vec4 SRGBtoLINEAR(vec4 srgbIn)
{
#ifdef MANUAL_SRGB
#ifdef SRGB_FAST_APPROXIMATION
vec3 linOut = pow(srgbIn.xyz,vec3(2.2));
#else
vec3 bLess = step(vec3(0.04045),srgbIn.xyz);
vec3 linOut = mix( srgbIn.xyz/vec3(12.92), pow((srgbIn.xyz+vec3(0.055))/vec3(1.055),vec3(2.4)), bLess );
#endif
return vec4(linOut,srgbIn.w);;
#else
return srgbIn;
#endif
}
vec3 getNormal()
{
#ifndef HAS_TANGENTS
vec3 pos_dx = dFdx(pbr_vPosition);
vec3 pos_dy = dFdy(pbr_vPosition);
vec3 tex_dx = dFdx(vec3(pbr_vUV, 0.0));
vec3 tex_dy = dFdy(vec3(pbr_vUV, 0.0));
vec3 t = (tex_dy.t * pos_dx - tex_dx.t * pos_dy) / (tex_dx.s * tex_dy.t - tex_dy.s * tex_dx.t);
#ifdef HAS_NORMALS
vec3 ng = normalize(pbr_vNormal);
#else
vec3 ng = cross(pos_dx, pos_dy);
#endif
t = normalize(t - ng * dot(ng, t));
vec3 b = normalize(cross(ng, t));
mat3 tbn = mat3(t, b, ng);
#else
mat3 tbn = pbr_vTBN;
#endif
#ifdef HAS_NORMALMAP
vec3 n = texture(u_NormalSampler, pbr_vUV).rgb;
n = normalize(tbn * ((2.0 * n - 1.0) * vec3(u_NormalScale, u_NormalScale, 1.0)));
#else
vec3 n = normalize(tbn[2].xyz);
#endif
return n;
}
#ifdef USE_IBL
vec3 getIBLContribution(PBRInfo pbrInputs, vec3 n, vec3 reflection)
{
float mipCount = 9.0;
float lod = (pbrInputs.perceptualRoughness * mipCount);
vec3 brdf = SRGBtoLINEAR(texture(u_brdfLUT,
vec2(pbrInputs.NdotV, 1.0 - pbrInputs.perceptualRoughness))).rgb;
vec3 diffuseLight = SRGBtoLINEAR(textureCube(u_DiffuseEnvSampler, n)).rgb;
#ifdef USE_TEX_LOD
vec3 specularLight = SRGBtoLINEAR(textureCubeLod(u_SpecularEnvSampler, reflection, lod)).rgb;
#else
vec3 specularLight = SRGBtoLINEAR(textureCube(u_SpecularEnvSampler, reflection)).rgb;
#endif
vec3 diffuse = diffuseLight * pbrInputs.diffuseColor;
vec3 specular = specularLight * (pbrInputs.specularColor * brdf.x + brdf.y);
diffuse *= u_ScaleIBLAmbient.x;
specular *= u_ScaleIBLAmbient.y;
return diffuse + specular;
}
#endif
vec3 diffuse(PBRInfo pbrInputs)
{
return pbrInputs.diffuseColor / M_PI;
}
vec3 specularReflection(PBRInfo pbrInputs)
{
return pbrInputs.reflectance0 +
(pbrInputs.reflectance90 - pbrInputs.reflectance0) *
pow(clamp(1.0 - pbrInputs.VdotH, 0.0, 1.0), 5.0);
}
float geometricOcclusion(PBRInfo pbrInputs)
{
float NdotL = pbrInputs.NdotL;
float NdotV = pbrInputs.NdotV;
float r = pbrInputs.alphaRoughness;
float attenuationL = 2.0 * NdotL / (NdotL + sqrt(r * r + (1.0 - r * r) * (NdotL * NdotL)));
float attenuationV = 2.0 * NdotV / (NdotV + sqrt(r * r + (1.0 - r * r) * (NdotV * NdotV)));
return attenuationL * attenuationV;
}
float microfacetDistribution(PBRInfo pbrInputs)
{
float roughnessSq = pbrInputs.alphaRoughness * pbrInputs.alphaRoughness;
float f = (pbrInputs.NdotH * roughnessSq - pbrInputs.NdotH) * pbrInputs.NdotH + 1.0;
return roughnessSq / (M_PI * f * f);
}
void PBRInfo_setAmbientLight(inout PBRInfo pbrInputs) {
pbrInputs.NdotL = 1.0;
pbrInputs.NdotH = 0.0;
pbrInputs.LdotH = 0.0;
pbrInputs.VdotH = 1.0;
}
void PBRInfo_setDirectionalLight(inout PBRInfo pbrInputs, vec3 lightDirection) {
vec3 n = pbrInputs.n;
vec3 v = pbrInputs.v;
vec3 l = normalize(lightDirection);
vec3 h = normalize(l+v);
pbrInputs.NdotL = clamp(dot(n, l), 0.001, 1.0);
pbrInputs.NdotH = clamp(dot(n, h), 0.0, 1.0);
pbrInputs.LdotH = clamp(dot(l, h), 0.0, 1.0);
pbrInputs.VdotH = clamp(dot(v, h), 0.0, 1.0);
}
void PBRInfo_setPointLight(inout PBRInfo pbrInputs, PointLight pointLight) {
vec3 light_direction = normalize(pointLight.position - pbr_vPosition);
PBRInfo_setDirectionalLight(pbrInputs, light_direction);
}
vec3 calculateFinalColor(PBRInfo pbrInputs, vec3 lightColor) {
vec3 F = specularReflection(pbrInputs);
float G = geometricOcclusion(pbrInputs);
float D = microfacetDistribution(pbrInputs);
vec3 diffuseContrib = (1.0 - F) * diffuse(pbrInputs);
vec3 specContrib = F * G * D / (4.0 * pbrInputs.NdotL * pbrInputs.NdotV);
return pbrInputs.NdotL * lightColor * (diffuseContrib + specContrib);
}
vec4 pbr_filterColor(vec4 colorUnused)
{
#ifdef HAS_BASECOLORMAP
vec4 baseColor = SRGBtoLINEAR(texture(u_BaseColorSampler, pbr_vUV)) * u_BaseColorFactor;
#else
vec4 baseColor = u_BaseColorFactor;
#endif
#ifdef ALPHA_CUTOFF
if (baseColor.a < u_AlphaCutoff) {
discard;
}
#endif
vec3 color = vec3(0, 0, 0);
if(pbr_uUnlit){
color.rgb = baseColor.rgb;
}
else{
float perceptualRoughness = u_MetallicRoughnessValues.y;
float metallic = u_MetallicRoughnessValues.x;
#ifdef HAS_METALROUGHNESSMAP
vec4 mrSample = texture(u_MetallicRoughnessSampler, pbr_vUV);
perceptualRoughness = mrSample.g * perceptualRoughness;
metallic = mrSample.b * metallic;
#endif
perceptualRoughness = clamp(perceptualRoughness, c_MinRoughness, 1.0);
metallic = clamp(metallic, 0.0, 1.0);
float alphaRoughness = perceptualRoughness * perceptualRoughness;
vec3 f0 = vec3(0.04);
vec3 diffuseColor = baseColor.rgb * (vec3(1.0) - f0);
diffuseColor *= 1.0 - metallic;
vec3 specularColor = mix(f0, baseColor.rgb, metallic);
float reflectance = max(max(specularColor.r, specularColor.g), specularColor.b);
float reflectance90 = clamp(reflectance * 25.0, 0.0, 1.0);
vec3 specularEnvironmentR0 = specularColor.rgb;
vec3 specularEnvironmentR90 = vec3(1.0, 1.0, 1.0) * reflectance90;
vec3 n = getNormal();
vec3 v = normalize(u_Camera - pbr_vPosition);
float NdotV = clamp(abs(dot(n, v)), 0.001, 1.0);
vec3 reflection = -normalize(reflect(v, n));
PBRInfo pbrInputs = PBRInfo(
0.0,
NdotV,
0.0,
0.0,
0.0,
perceptualRoughness,
metallic,
specularEnvironmentR0,
specularEnvironmentR90,
alphaRoughness,
diffuseColor,
specularColor,
n,
v
);
#ifdef USE_LIGHTS
PBRInfo_setAmbientLight(pbrInputs);
color += calculateFinalColor(pbrInputs, lighting_uAmbientLight.color);
for(int i = 0; i < lighting_uDirectionalLightCount; i++) {
if (i < lighting_uDirectionalLightCount) {
PBRInfo_setDirectionalLight(pbrInputs, lighting_uDirectionalLight[i].direction);
color += calculateFinalColor(pbrInputs, lighting_uDirectionalLight[i].color);
}
}
for(int i = 0; i < lighting_uPointLightCount; i++) {
if (i < lighting_uPointLightCount) {
PBRInfo_setPointLight(pbrInputs, lighting_uPointLight[i]);
float attenuation = getPointLightAttenuation(lighting_uPointLight[i], distance(lighting_uPointLight[i].position, pbr_vPosition));
color += calculateFinalColor(pbrInputs, lighting_uPointLight[i].color / attenuation);
}
}
#endif
#ifdef USE_IBL
color += getIBLContribution(pbrInputs, n, reflection);
#endif
#ifdef HAS_OCCLUSIONMAP
float ao = texture(u_OcclusionSampler, pbr_vUV).r;
color = mix(color, color * ao, u_OcclusionStrength);
#endif
#ifdef HAS_EMISSIVEMAP
vec3 emissive = SRGBtoLINEAR(texture(u_EmissiveSampler, pbr_vUV)).rgb * u_EmissiveFactor;
color += emissive;
#endif
#ifdef PBR_DEBUG
color = mix(color, baseColor.rgb, u_ScaleDiffBaseMR.y);
color = mix(color, vec3(metallic), u_ScaleDiffBaseMR.z);
color = mix(color, vec3(perceptualRoughness), u_ScaleDiffBaseMR.w);
#endif
}
return vec4(pow(color,vec3(1.0/2.2)), baseColor.a);
}
`;
const pbr$1 = {
  name: "pbr",
  vs: vs$h,
  fs: fs$h,
  defines: {
    LIGHTING_FRAGMENT: 1
  },
  dependencies: [lights$1]
};
const defines = "#define SMOOTH_EDGE_RADIUS 0.5";
const vs$g = `
${defines}

struct VertexGeometry {
  vec4 position;
  vec3 worldPosition;
  vec3 worldPositionAlt;
  vec3 normal;
  vec2 uv;
  vec3 pickingColor;
} geometry = VertexGeometry(
  vec4(0.0, 0.0, 1.0, 0.0),
  vec3(0.0),
  vec3(0.0),
  vec3(0.0),
  vec2(0.0),
  vec3(0.0)
);
`;
const fs$g = `
${defines}

struct FragmentGeometry {
  vec2 uv;
} geometry;

float smoothedge(float edge, float x) {
  return smoothstep(edge - SMOOTH_EDGE_RADIUS, edge + SMOOTH_EDGE_RADIUS, x);
}
`;
const geometry$2 = { name: "geometry", vs: vs$g, fs: fs$g };
const COORDINATE_SYSTEM = {
  /**
   * `LNGLAT` if rendering into a geospatial viewport, `CARTESIAN` otherwise
   */
  DEFAULT: -1,
  /**
   * Positions are interpreted as [longitude, latitude, elevation]
   * longitude/latitude are in degrees, elevation is in meters.
   * Dimensions are in meters.
   */
  LNGLAT: 1,
  /**
   * Positions are interpreted as [x, y, z] in meter offsets from the coordinate origin.
   * Dimensions are in meters.
   */
  METER_OFFSETS: 2,
  /**
   * Positions are interpreted as [deltaLng, deltaLat, elevation] from the coordinate origin.
   * deltaLng/deltaLat are in degrees, elevation is in meters.
   * Dimensions are in meters.
   */
  LNGLAT_OFFSETS: 3,
  /**
   * Positions and dimensions are in the common units of the viewport.
   */
  CARTESIAN: 0
};
Object.defineProperty(COORDINATE_SYSTEM, "IDENTITY", {
  get: () => {
    log$1.deprecated("COORDINATE_SYSTEM.IDENTITY", "COORDINATE_SYSTEM.CARTESIAN")();
    return 0;
  }
});
const PROJECTION_MODE = {
  /**
   * Render geospatial data in Web Mercator projection
   */
  WEB_MERCATOR: 1,
  /**
   * Render geospatial data as a 3D globe
   */
  GLOBE: 2,
  /**
   * (Internal use only) Web Mercator projection at high zoom
   */
  WEB_MERCATOR_AUTO_OFFSET: 4,
  /**
   * No transformation
   */
  IDENTITY: 0
};
const UNIT = {
  common: 0,
  meters: 1,
  pixels: 2
};
const EVENTS$1 = {
  click: { handler: "onClick" },
  panstart: { handler: "onDragStart" },
  panmove: { handler: "onDrag" },
  panend: { handler: "onDragEnd" }
};
const COORDINATE_SYSTEM_GLSL_CONSTANTS = Object.keys(COORDINATE_SYSTEM).map((key) => `const int COORDINATE_SYSTEM_${key} = ${COORDINATE_SYSTEM[key]};`).join("");
const PROJECTION_MODE_GLSL_CONSTANTS = Object.keys(PROJECTION_MODE).map((key) => `const int PROJECTION_MODE_${key} = ${PROJECTION_MODE[key]};`).join("");
const UNIT_GLSL_CONSTANTS = Object.keys(UNIT).map((key) => `const int UNIT_${key.toUpperCase()} = ${UNIT[key]};`).join("");
const projectShader = `${COORDINATE_SYSTEM_GLSL_CONSTANTS}
${PROJECTION_MODE_GLSL_CONSTANTS}
${UNIT_GLSL_CONSTANTS}
uniform int project_uCoordinateSystem;
uniform int project_uProjectionMode;
uniform float project_uScale;
uniform bool project_uWrapLongitude;
uniform vec3 project_uCommonUnitsPerMeter;
uniform vec3 project_uCommonUnitsPerWorldUnit;
uniform vec3 project_uCommonUnitsPerWorldUnit2;
uniform vec4 project_uCenter;
uniform mat4 project_uModelMatrix;
uniform mat4 project_uViewProjectionMatrix;
uniform vec2 project_uViewportSize;
uniform float project_uDevicePixelRatio;
uniform float project_uFocalDistance;
uniform vec3 project_uCameraPosition;
uniform vec3 project_uCoordinateOrigin;
uniform vec3 project_uCommonOrigin;
uniform bool project_uPseudoMeters;
const float TILE_SIZE = 512.0;
const float PI = 3.1415926536;
const float WORLD_SCALE = TILE_SIZE / (PI * 2.0);
const vec3 ZERO_64_LOW = vec3(0.0);
const float EARTH_RADIUS = 6370972.0;
const float GLOBE_RADIUS = 256.0;
float project_size_at_latitude(float lat) {
float y = clamp(lat, -89.9, 89.9);
return 1.0 / cos(radians(y));
}
float project_size() {
if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR &&
project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT &&
project_uPseudoMeters == false) {
if (geometry.position.w == 0.0) {
return project_size_at_latitude(geometry.worldPosition.y);
}
float y = geometry.position.y / TILE_SIZE * 2.0 - 1.0;
float y2 = y * y;
float y4 = y2 * y2;
float y6 = y4 * y2;
return 1.0 + 4.9348 * y2 + 4.0587 * y4 + 1.5642 * y6;
}
return 1.0;
}
float project_size_at_latitude(float meters, float lat) {
return meters * project_uCommonUnitsPerMeter.z * project_size_at_latitude(lat);
}
float project_size(float meters) {
return meters * project_uCommonUnitsPerMeter.z * project_size();
}
vec2 project_size(vec2 meters) {
return meters * project_uCommonUnitsPerMeter.xy * project_size();
}
vec3 project_size(vec3 meters) {
return meters * project_uCommonUnitsPerMeter * project_size();
}
vec4 project_size(vec4 meters) {
return vec4(meters.xyz * project_uCommonUnitsPerMeter, meters.w);
}
mat3 project_get_orientation_matrix(vec3 up) {
vec3 uz = normalize(up);
vec3 ux = abs(uz.z) == 1.0 ? vec3(1.0, 0.0, 0.0) : normalize(vec3(uz.y, -uz.x, 0));
vec3 uy = cross(uz, ux);
return mat3(ux, uy, uz);
}
bool project_needs_rotation(vec3 commonPosition, out mat3 transform) {
if (project_uProjectionMode == PROJECTION_MODE_GLOBE) {
transform = project_get_orientation_matrix(commonPosition);
return true;
}
return false;
}
vec3 project_normal(vec3 vector) {
vec4 normal_modelspace = project_uModelMatrix * vec4(vector, 0.0);
vec3 n = normalize(normal_modelspace.xyz * project_uCommonUnitsPerMeter);
mat3 rotation;
if (project_needs_rotation(geometry.position.xyz, rotation)) {
n = rotation * n;
}
return n;
}
vec4 project_offset_(vec4 offset) {
float dy = offset.y;
vec3 commonUnitsPerWorldUnit = project_uCommonUnitsPerWorldUnit + project_uCommonUnitsPerWorldUnit2 * dy;
return vec4(offset.xyz * commonUnitsPerWorldUnit, offset.w);
}
vec2 project_mercator_(vec2 lnglat) {
float x = lnglat.x;
if (project_uWrapLongitude) {
x = mod(x + 180., 360.0) - 180.;
}
float y = clamp(lnglat.y, -89.9, 89.9);
return vec2(
radians(x) + PI,
PI + log(tan_fp32(PI * 0.25 + radians(y) * 0.5))
) * WORLD_SCALE;
}
vec3 project_globe_(vec3 lnglatz) {
float lambda = radians(lnglatz.x);
float phi = radians(lnglatz.y);
float cosPhi = cos(phi);
float D = (lnglatz.z / EARTH_RADIUS + 1.0) * GLOBE_RADIUS;
return vec3(
sin(lambda) * cosPhi,
-cos(lambda) * cosPhi,
sin(phi)
) * D;
}
vec4 project_position(vec4 position, vec3 position64Low) {
vec4 position_world = project_uModelMatrix * position;
if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR) {
if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
return vec4(
project_mercator_(position_world.xy),
project_size_at_latitude(position_world.z, position_world.y),
position_world.w
);
}
if (project_uCoordinateSystem == COORDINATE_SYSTEM_CARTESIAN) {
position_world.xyz += project_uCoordinateOrigin;
}
}
if (project_uProjectionMode == PROJECTION_MODE_GLOBE) {
if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
return vec4(
project_globe_(position_world.xyz),
position_world.w
);
}
}
if (project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET) {
if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT) {
if (abs(position_world.y - project_uCoordinateOrigin.y) > 0.25) {
return vec4(
project_mercator_(position_world.xy) - project_uCommonOrigin.xy,
project_size(position_world.z),
position_world.w
);
}
}
}
if (project_uProjectionMode == PROJECTION_MODE_IDENTITY ||
(project_uProjectionMode == PROJECTION_MODE_WEB_MERCATOR_AUTO_OFFSET &&
(project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT ||
project_uCoordinateSystem == COORDINATE_SYSTEM_CARTESIAN))) {
position_world.xyz -= project_uCoordinateOrigin;
}
return project_offset_(position_world) + project_offset_(project_uModelMatrix * vec4(position64Low, 0.0));
}
vec4 project_position(vec4 position) {
return project_position(position, ZERO_64_LOW);
}
vec3 project_position(vec3 position, vec3 position64Low) {
vec4 projected_position = project_position(vec4(position, 1.0), position64Low);
return projected_position.xyz;
}
vec3 project_position(vec3 position) {
vec4 projected_position = project_position(vec4(position, 1.0), ZERO_64_LOW);
return projected_position.xyz;
}
vec2 project_position(vec2 position) {
vec4 projected_position = project_position(vec4(position, 0.0, 1.0), ZERO_64_LOW);
return projected_position.xy;
}
vec4 project_common_position_to_clipspace(vec4 position, mat4 viewProjectionMatrix, vec4 center) {
return viewProjectionMatrix * position + center;
}
vec4 project_common_position_to_clipspace(vec4 position) {
return project_common_position_to_clipspace(position, project_uViewProjectionMatrix, project_uCenter);
}
vec2 project_pixel_size_to_clipspace(vec2 pixels) {
vec2 offset = pixels / project_uViewportSize * project_uDevicePixelRatio * 2.0;
return offset * project_uFocalDistance;
}
float project_size_to_pixel(float meters) {
return project_size(meters) * project_uScale;
}
float project_size_to_pixel(float size, int unit) {
if (unit == UNIT_METERS) return project_size_to_pixel(size);
if (unit == UNIT_COMMON) return size * project_uScale;
return size;
}
float project_pixel_size(float pixels) {
return pixels / project_uScale;
}
vec2 project_pixel_size(vec2 pixels) {
return pixels / project_uScale;
}
`;
function isEqual$3(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (Array.isArray(a2)) {
    const len2 = a2.length;
    if (!b2 || b2.length !== len2) {
      return false;
    }
    for (let i2 = 0; i2 < len2; i2++) {
      if (a2[i2] !== b2[i2]) {
        return false;
      }
    }
    return true;
  }
  return false;
}
function memoize$1(compute2) {
  let cachedArgs = {};
  let cachedResult;
  return (args) => {
    for (const key in args) {
      if (!isEqual$3(args[key], cachedArgs[key])) {
        cachedResult = compute2(args);
        cachedArgs = args;
        break;
      }
    }
    return cachedResult;
  };
}
const ZERO_VECTOR$1 = [0, 0, 0, 0];
const VECTOR_TO_POINT_MATRIX$1 = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0];
const IDENTITY_MATRIX = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
const DEFAULT_PIXELS_PER_UNIT2 = [0, 0, 0];
const DEFAULT_COORDINATE_ORIGIN$1 = [0, 0, 0];
const getMemoizedViewportUniforms = memoize$1(calculateViewportUniforms);
function getOffsetOrigin(viewport, coordinateSystem, coordinateOrigin = DEFAULT_COORDINATE_ORIGIN$1) {
  if (coordinateOrigin.length < 3) {
    coordinateOrigin = [coordinateOrigin[0], coordinateOrigin[1], 0];
  }
  let shaderCoordinateOrigin = coordinateOrigin;
  let geospatialOrigin;
  let offsetMode = true;
  if (coordinateSystem === COORDINATE_SYSTEM.LNGLAT_OFFSETS || coordinateSystem === COORDINATE_SYSTEM.METER_OFFSETS) {
    geospatialOrigin = coordinateOrigin;
  } else {
    geospatialOrigin = viewport.isGeospatial ? (
      // @ts-expect-error longitude and latitude are not defined on the base Viewport, but is expected on geospatial viewports
      [Math.fround(viewport.longitude), Math.fround(viewport.latitude), 0]
    ) : null;
  }
  switch (viewport.projectionMode) {
    case PROJECTION_MODE.WEB_MERCATOR:
      if (coordinateSystem === COORDINATE_SYSTEM.LNGLAT || coordinateSystem === COORDINATE_SYSTEM.CARTESIAN) {
        geospatialOrigin = [0, 0, 0];
        offsetMode = false;
      }
      break;
    case PROJECTION_MODE.WEB_MERCATOR_AUTO_OFFSET:
      if (coordinateSystem === COORDINATE_SYSTEM.LNGLAT) {
        shaderCoordinateOrigin = geospatialOrigin;
      } else if (coordinateSystem === COORDINATE_SYSTEM.CARTESIAN) {
        shaderCoordinateOrigin = [
          Math.fround(viewport.center[0]),
          Math.fround(viewport.center[1]),
          0
        ];
        geospatialOrigin = viewport.unprojectPosition(shaderCoordinateOrigin);
        shaderCoordinateOrigin[0] -= coordinateOrigin[0];
        shaderCoordinateOrigin[1] -= coordinateOrigin[1];
        shaderCoordinateOrigin[2] -= coordinateOrigin[2];
      }
      break;
    case PROJECTION_MODE.IDENTITY:
      shaderCoordinateOrigin = viewport.position.map(Math.fround);
      shaderCoordinateOrigin[2] = shaderCoordinateOrigin[2] || 0;
      break;
    case PROJECTION_MODE.GLOBE:
      offsetMode = false;
      geospatialOrigin = null;
      break;
    default:
      offsetMode = false;
  }
  return { geospatialOrigin, shaderCoordinateOrigin, offsetMode };
}
function calculateMatrixAndOffset(viewport, coordinateSystem, coordinateOrigin) {
  const { viewMatrixUncentered, projectionMatrix } = viewport;
  let { viewMatrix, viewProjectionMatrix } = viewport;
  let projectionCenter = ZERO_VECTOR$1;
  let originCommon = ZERO_VECTOR$1;
  let cameraPosCommon = viewport.cameraPosition;
  const { geospatialOrigin, shaderCoordinateOrigin, offsetMode } = getOffsetOrigin(viewport, coordinateSystem, coordinateOrigin);
  if (offsetMode) {
    originCommon = viewport.projectPosition(geospatialOrigin || shaderCoordinateOrigin);
    cameraPosCommon = [
      cameraPosCommon[0] - originCommon[0],
      cameraPosCommon[1] - originCommon[1],
      cameraPosCommon[2] - originCommon[2]
    ];
    originCommon[3] = 1;
    projectionCenter = transformMat4([], originCommon, viewProjectionMatrix);
    viewMatrix = viewMatrixUncentered || viewMatrix;
    viewProjectionMatrix = multiply$1([], projectionMatrix, viewMatrix);
    viewProjectionMatrix = multiply$1([], viewProjectionMatrix, VECTOR_TO_POINT_MATRIX$1);
  }
  return {
    viewMatrix,
    viewProjectionMatrix,
    projectionCenter,
    originCommon,
    cameraPosCommon,
    shaderCoordinateOrigin,
    geospatialOrigin
  };
}
function getUniformsFromViewport({
  viewport,
  devicePixelRatio: devicePixelRatio2 = 1,
  modelMatrix: modelMatrix2 = null,
  // Match Layer.defaultProps
  coordinateSystem = COORDINATE_SYSTEM.DEFAULT,
  coordinateOrigin = DEFAULT_COORDINATE_ORIGIN$1,
  autoWrapLongitude = false
}) {
  if (coordinateSystem === COORDINATE_SYSTEM.DEFAULT) {
    coordinateSystem = viewport.isGeospatial ? COORDINATE_SYSTEM.LNGLAT : COORDINATE_SYSTEM.CARTESIAN;
  }
  const uniforms = getMemoizedViewportUniforms({
    viewport,
    devicePixelRatio: devicePixelRatio2,
    coordinateSystem,
    coordinateOrigin
  });
  uniforms.project_uWrapLongitude = autoWrapLongitude;
  uniforms.project_uModelMatrix = modelMatrix2 || IDENTITY_MATRIX;
  return uniforms;
}
function calculateViewportUniforms({ viewport, devicePixelRatio: devicePixelRatio2, coordinateSystem, coordinateOrigin }) {
  const { projectionCenter, viewProjectionMatrix, originCommon, cameraPosCommon, shaderCoordinateOrigin, geospatialOrigin } = calculateMatrixAndOffset(viewport, coordinateSystem, coordinateOrigin);
  const distanceScales = viewport.getDistanceScales();
  const viewportSize = [
    viewport.width * devicePixelRatio2,
    viewport.height * devicePixelRatio2
  ];
  const focalDistance = transformMat4([], [0, 0, -viewport.focalDistance, 1], viewport.projectionMatrix)[3] || 1;
  const uniforms = {
    // Projection mode values
    project_uCoordinateSystem: coordinateSystem,
    project_uProjectionMode: viewport.projectionMode,
    project_uCoordinateOrigin: shaderCoordinateOrigin,
    project_uCommonOrigin: originCommon.slice(0, 3),
    project_uCenter: projectionCenter,
    // Backward compatibility
    // TODO: remove in v9
    // @ts-expect-error _pseudoMeters is only defined on WebMercator viewport
    project_uPseudoMeters: Boolean(viewport._pseudoMeters),
    // Screen size
    project_uViewportSize: viewportSize,
    project_uDevicePixelRatio: devicePixelRatio2,
    project_uFocalDistance: focalDistance,
    project_uCommonUnitsPerMeter: distanceScales.unitsPerMeter,
    project_uCommonUnitsPerWorldUnit: distanceScales.unitsPerMeter,
    project_uCommonUnitsPerWorldUnit2: DEFAULT_PIXELS_PER_UNIT2,
    project_uScale: viewport.scale,
    // This is the mercator scale (2 ** zoom)
    project_uWrapLongitude: false,
    project_uViewProjectionMatrix: viewProjectionMatrix,
    project_uModelMatrix: IDENTITY_MATRIX,
    // This is for lighting calculations
    project_uCameraPosition: cameraPosCommon
  };
  if (geospatialOrigin) {
    const distanceScalesAtOrigin = viewport.getDistanceScales(geospatialOrigin);
    switch (coordinateSystem) {
      case COORDINATE_SYSTEM.METER_OFFSETS:
        uniforms.project_uCommonUnitsPerWorldUnit = distanceScalesAtOrigin.unitsPerMeter;
        uniforms.project_uCommonUnitsPerWorldUnit2 = distanceScalesAtOrigin.unitsPerMeter2;
        break;
      case COORDINATE_SYSTEM.LNGLAT:
      case COORDINATE_SYSTEM.LNGLAT_OFFSETS:
        if (!viewport._pseudoMeters) {
          uniforms.project_uCommonUnitsPerMeter = distanceScalesAtOrigin.unitsPerMeter;
        }
        uniforms.project_uCommonUnitsPerWorldUnit = distanceScalesAtOrigin.unitsPerDegree;
        uniforms.project_uCommonUnitsPerWorldUnit2 = distanceScalesAtOrigin.unitsPerDegree2;
        break;
      case COORDINATE_SYSTEM.CARTESIAN:
        uniforms.project_uCommonUnitsPerWorldUnit = [1, 1, distanceScalesAtOrigin.unitsPerMeter[2]];
        uniforms.project_uCommonUnitsPerWorldUnit2 = [
          0,
          0,
          distanceScalesAtOrigin.unitsPerMeter2[2]
        ];
        break;
    }
  }
  return uniforms;
}
const INITIAL_MODULE_OPTIONS$1 = {};
function getUniforms$1(opts = INITIAL_MODULE_OPTIONS$1) {
  if ("viewport" in opts) {
    return getUniformsFromViewport(opts);
  }
  return {};
}
const project$1 = {
  name: "project",
  dependencies: [fp32, geometry$2],
  vs: projectShader,
  getUniforms: getUniforms$1
};
const vs$f = `
vec4 project_position_to_clipspace(
  vec3 position, vec3 position64Low, vec3 offset, out vec4 commonPosition
) {
  vec3 projectedPosition = project_position(position, position64Low);
  mat3 rotation;
  if (project_needs_rotation(projectedPosition, rotation)) {
    // offset is specified as ENU
    // when in globe projection, rotate offset so that the ground alighs with the surface of the globe
    offset = rotation * offset;
  }
  commonPosition = vec4(projectedPosition + offset, 1.0);
  return project_common_position_to_clipspace(commonPosition);
}

vec4 project_position_to_clipspace(
  vec3 position, vec3 position64Low, vec3 offset
) {
  vec4 commonPosition;
  return project_position_to_clipspace(position, position64Low, offset, commonPosition);
}
`;
const project32 = {
  name: "project32",
  dependencies: [project$1],
  vs: vs$f
};
function createMat4$1() {
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}
function transformVector$1(matrix, vector) {
  const result = transformMat4([], vector, matrix);
  scale$1(result, result, 1 / result[3]);
  return result;
}
function mod(value, divisor) {
  const modulus = value % divisor;
  return modulus < 0 ? divisor + modulus : modulus;
}
function clamp$2(x2, min4, max3) {
  return x2 < min4 ? min4 : x2 > max3 ? max3 : x2;
}
function ieLog2(x2) {
  return Math.log(x2) * Math.LOG2E;
}
const log2 = Math.log2 || ieLog2;
function assert$8(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "@math.gl/web-mercator: assertion failed.");
  }
}
const PI = Math.PI;
const PI_4 = PI / 4;
const DEGREES_TO_RADIANS$4 = PI / 180;
const RADIANS_TO_DEGREES$1 = 180 / PI;
const TILE_SIZE$5 = 512;
const EARTH_CIRCUMFERENCE$1 = 4003e4;
const MAX_LATITUDE = 85.051129;
const DEFAULT_ALTITUDE = 1.5;
function scaleToZoom(scale5) {
  return log2(scale5);
}
function lngLatToWorld(lngLat) {
  const [lng, lat] = lngLat;
  assert$8(Number.isFinite(lng));
  assert$8(Number.isFinite(lat) && lat >= -90 && lat <= 90, "invalid latitude");
  const lambda2 = lng * DEGREES_TO_RADIANS$4;
  const phi2 = lat * DEGREES_TO_RADIANS$4;
  const x2 = TILE_SIZE$5 * (lambda2 + PI) / (2 * PI);
  const y2 = TILE_SIZE$5 * (PI + Math.log(Math.tan(PI_4 + phi2 * 0.5))) / (2 * PI);
  return [x2, y2];
}
function worldToLngLat(xy) {
  const [x2, y2] = xy;
  const lambda2 = x2 / TILE_SIZE$5 * (2 * PI) - PI;
  const phi2 = 2 * (Math.atan(Math.exp(y2 / TILE_SIZE$5 * (2 * PI) - PI)) - PI_4);
  return [lambda2 * RADIANS_TO_DEGREES$1, phi2 * RADIANS_TO_DEGREES$1];
}
function getMeterZoom(options2) {
  const { latitude } = options2;
  assert$8(Number.isFinite(latitude));
  const latCosine = Math.cos(latitude * DEGREES_TO_RADIANS$4);
  return scaleToZoom(EARTH_CIRCUMFERENCE$1 * latCosine) - 9;
}
function unitsPerMeter(latitude) {
  const latCosine = Math.cos(latitude * DEGREES_TO_RADIANS$4);
  return TILE_SIZE$5 / EARTH_CIRCUMFERENCE$1 / latCosine;
}
function getDistanceScales$1(options2) {
  const { latitude, longitude, highPrecision = false } = options2;
  assert$8(Number.isFinite(latitude) && Number.isFinite(longitude));
  const worldSize = TILE_SIZE$5;
  const latCosine = Math.cos(latitude * DEGREES_TO_RADIANS$4);
  const unitsPerDegreeX = worldSize / 360;
  const unitsPerDegreeY = unitsPerDegreeX / latCosine;
  const altUnitsPerMeter = worldSize / EARTH_CIRCUMFERENCE$1 / latCosine;
  const result = {
    unitsPerMeter: [altUnitsPerMeter, altUnitsPerMeter, altUnitsPerMeter],
    metersPerUnit: [1 / altUnitsPerMeter, 1 / altUnitsPerMeter, 1 / altUnitsPerMeter],
    unitsPerDegree: [unitsPerDegreeX, unitsPerDegreeY, altUnitsPerMeter],
    degreesPerUnit: [1 / unitsPerDegreeX, 1 / unitsPerDegreeY, 1 / altUnitsPerMeter]
  };
  if (highPrecision) {
    const latCosine2 = DEGREES_TO_RADIANS$4 * Math.tan(latitude * DEGREES_TO_RADIANS$4) / latCosine;
    const unitsPerDegreeY2 = unitsPerDegreeX * latCosine2 / 2;
    const altUnitsPerDegree2 = worldSize / EARTH_CIRCUMFERENCE$1 * latCosine2;
    const altUnitsPerMeter2 = altUnitsPerDegree2 / unitsPerDegreeY * altUnitsPerMeter;
    result.unitsPerDegree2 = [0, unitsPerDegreeY2, altUnitsPerDegree2];
    result.unitsPerMeter2 = [altUnitsPerMeter2, 0, altUnitsPerMeter2];
  }
  return result;
}
function addMetersToLngLat(lngLatZ, xyz) {
  const [longitude, latitude, z0] = lngLatZ;
  const [x2, y2, z2] = xyz;
  const { unitsPerMeter: unitsPerMeter2, unitsPerMeter2: unitsPerMeter22 } = getDistanceScales$1({
    longitude,
    latitude,
    highPrecision: true
  });
  const worldspace = lngLatToWorld(lngLatZ);
  worldspace[0] += x2 * (unitsPerMeter2[0] + unitsPerMeter22[0] * y2);
  worldspace[1] += y2 * (unitsPerMeter2[1] + unitsPerMeter22[1] * y2);
  const newLngLat = worldToLngLat(worldspace);
  const newZ = (z0 || 0) + (z2 || 0);
  return Number.isFinite(z0) || Number.isFinite(z2) ? [newLngLat[0], newLngLat[1], newZ] : newLngLat;
}
function getViewMatrix(options2) {
  const {
    // Viewport props
    height,
    pitch,
    bearing: bearing2,
    altitude,
    // Pre-calculated parameters
    scale: scale5,
    center: center2
  } = options2;
  const vm = createMat4$1();
  translate(vm, vm, [0, 0, -altitude]);
  rotateX$1(vm, vm, -pitch * DEGREES_TO_RADIANS$4);
  rotateZ$1(vm, vm, bearing2 * DEGREES_TO_RADIANS$4);
  const relativeScale = scale5 / height;
  scale$2(vm, vm, [relativeScale, relativeScale, relativeScale]);
  if (center2) {
    translate(vm, vm, negate([], center2));
  }
  return vm;
}
function getProjectionParameters(options2) {
  const { width, height, altitude, pitch = 0, offset, center: center2, scale: scale5, nearZMultiplier = 1, farZMultiplier = 1 } = options2;
  let { fovy = altitudeToFovy(DEFAULT_ALTITUDE) } = options2;
  if (altitude !== void 0) {
    fovy = altitudeToFovy(altitude);
  }
  const fovRadians = fovy * DEGREES_TO_RADIANS$4;
  const pitchRadians = pitch * DEGREES_TO_RADIANS$4;
  const focalDistance = fovyToAltitude(fovy);
  let cameraToSeaLevelDistance = focalDistance;
  if (center2) {
    cameraToSeaLevelDistance += center2[2] * scale5 / Math.cos(pitchRadians) / height;
  }
  const fovAboveCenter = fovRadians * (0.5 + (offset ? offset[1] : 0) / height);
  const topHalfSurfaceDistance = Math.sin(fovAboveCenter) * cameraToSeaLevelDistance / Math.sin(clamp$2(Math.PI / 2 - pitchRadians - fovAboveCenter, 0.01, Math.PI - 0.01));
  const furthestDistance = Math.sin(pitchRadians) * topHalfSurfaceDistance + cameraToSeaLevelDistance;
  const horizonDistance = cameraToSeaLevelDistance * 10;
  const farZ = Math.min(furthestDistance * farZMultiplier, horizonDistance);
  return {
    fov: fovRadians,
    aspect: width / height,
    focalDistance,
    near: nearZMultiplier,
    far: farZ
  };
}
function altitudeToFovy(altitude) {
  return 2 * Math.atan(0.5 / altitude) * RADIANS_TO_DEGREES$1;
}
function fovyToAltitude(fovy) {
  return 0.5 / Math.tan(0.5 * fovy * DEGREES_TO_RADIANS$4);
}
function worldToPixels(xyz, pixelProjectionMatrix) {
  const [x2, y2, z2 = 0] = xyz;
  assert$8(Number.isFinite(x2) && Number.isFinite(y2) && Number.isFinite(z2));
  return transformVector$1(pixelProjectionMatrix, [x2, y2, z2, 1]);
}
function pixelsToWorld(xyz, pixelUnprojectionMatrix, targetZ = 0) {
  const [x2, y2, z2] = xyz;
  assert$8(Number.isFinite(x2) && Number.isFinite(y2), "invalid pixel coordinate");
  if (Number.isFinite(z2)) {
    const coord = transformVector$1(pixelUnprojectionMatrix, [x2, y2, z2, 1]);
    return coord;
  }
  const coord0 = transformVector$1(pixelUnprojectionMatrix, [x2, y2, 0, 1]);
  const coord1 = transformVector$1(pixelUnprojectionMatrix, [x2, y2, 1, 1]);
  const z0 = coord0[2];
  const z1 = coord1[2];
  const t2 = z0 === z1 ? 0 : ((targetZ || 0) - z0) / (z1 - z0);
  return lerp$3([], coord0, coord1, t2);
}
function fitBounds(options2) {
  const {
    width,
    height,
    bounds,
    minExtent: minExtent2 = 0,
    // 0.01 would be about 1000 meters (degree is ~110KM)
    maxZoom = 24,
    // ~x4,000,000 => About 10 meter extents
    offset = [0, 0]
  } = options2;
  const [[west, south], [east, north]] = bounds;
  const padding = getPaddingObject(options2.padding);
  const nw = lngLatToWorld([west, clamp$2(north, -MAX_LATITUDE, MAX_LATITUDE)]);
  const se = lngLatToWorld([east, clamp$2(south, -MAX_LATITUDE, MAX_LATITUDE)]);
  const size12 = [
    Math.max(Math.abs(se[0] - nw[0]), minExtent2),
    Math.max(Math.abs(se[1] - nw[1]), minExtent2)
  ];
  const targetSize = [
    width - padding.left - padding.right - Math.abs(offset[0]) * 2,
    height - padding.top - padding.bottom - Math.abs(offset[1]) * 2
  ];
  assert$8(targetSize[0] > 0 && targetSize[1] > 0);
  const scaleX3 = targetSize[0] / size12[0];
  const scaleY3 = targetSize[1] / size12[1];
  const offsetX = (padding.right - padding.left) / 2 / scaleX3;
  const offsetY = (padding.top - padding.bottom) / 2 / scaleY3;
  const center2 = [(se[0] + nw[0]) / 2 + offsetX, (se[1] + nw[1]) / 2 + offsetY];
  const centerLngLat = worldToLngLat(center2);
  const zoom2 = Math.min(maxZoom, log2(Math.abs(Math.min(scaleX3, scaleY3))));
  assert$8(Number.isFinite(zoom2));
  return {
    longitude: centerLngLat[0],
    latitude: centerLngLat[1],
    zoom: zoom2
  };
}
function getPaddingObject(padding = 0) {
  if (typeof padding === "number") {
    return {
      top: padding,
      bottom: padding,
      left: padding,
      right: padding
    };
  }
  assert$8(Number.isFinite(padding.top) && Number.isFinite(padding.bottom) && Number.isFinite(padding.left) && Number.isFinite(padding.right));
  return padding;
}
const DEGREES_TO_RADIANS$3 = Math.PI / 180;
function getBounds$1(viewport, z2 = 0) {
  const { width, height, unproject } = viewport;
  const unprojectOps = { targetZ: z2 };
  const bottomLeft = unproject([0, height], unprojectOps);
  const bottomRight = unproject([width, height], unprojectOps);
  let topLeft;
  let topRight;
  const halfFov = viewport.fovy ? 0.5 * viewport.fovy * DEGREES_TO_RADIANS$3 : Math.atan(0.5 / viewport.altitude);
  const angleToGround = (90 - viewport.pitch) * DEGREES_TO_RADIANS$3;
  if (halfFov > angleToGround - 0.01) {
    topLeft = unprojectOnFarPlane(viewport, 0, z2);
    topRight = unprojectOnFarPlane(viewport, width, z2);
  } else {
    topLeft = unproject([0, 0], unprojectOps);
    topRight = unproject([width, 0], unprojectOps);
  }
  return [bottomLeft, bottomRight, topRight, topLeft];
}
function unprojectOnFarPlane(viewport, x2, targetZ) {
  const { pixelUnprojectionMatrix } = viewport;
  const coord0 = transformVector$1(pixelUnprojectionMatrix, [x2, 0, 1, 1]);
  const coord1 = transformVector$1(pixelUnprojectionMatrix, [x2, viewport.height, 1, 1]);
  const z2 = targetZ * viewport.distanceScales.unitsPerMeter[2];
  const t2 = (z2 - coord0[2]) / (coord1[2] - coord0[2]);
  const coord = lerp$3([], coord0, coord1, t2);
  const result = worldToLngLat(coord);
  result.push(targetZ);
  return result;
}
const TILE_SIZE$4 = 512;
function normalizeViewportProps(props) {
  const { width, height, pitch = 0 } = props;
  let { longitude, latitude, zoom: zoom2, bearing: bearing2 = 0 } = props;
  if (longitude < -180 || longitude > 180) {
    longitude = mod(longitude + 180, 360) - 180;
  }
  if (bearing2 < -180 || bearing2 > 180) {
    bearing2 = mod(bearing2 + 180, 360) - 180;
  }
  const minZoom = log2(height / TILE_SIZE$4);
  if (zoom2 <= minZoom) {
    zoom2 = minZoom;
    latitude = 0;
  } else {
    const halfHeightPixels = height / 2 / Math.pow(2, zoom2);
    const minLatitude = worldToLngLat([0, halfHeightPixels])[1];
    if (latitude < minLatitude) {
      latitude = minLatitude;
    } else {
      const maxLatitude = worldToLngLat([0, TILE_SIZE$4 - halfHeightPixels])[1];
      if (latitude > maxLatitude) {
        latitude = maxLatitude;
      }
    }
  }
  return { width, height, longitude, latitude, zoom: zoom2, pitch, bearing: bearing2 };
}
const vs$e = `
const int max_lights = 2;
uniform mat4 shadow_uViewProjectionMatrices[max_lights];
uniform vec4 shadow_uProjectCenters[max_lights];
uniform bool shadow_uDrawShadowMap;
uniform bool shadow_uUseShadowMap;
uniform int shadow_uLightId;
uniform float shadow_uLightCount;

out vec3 shadow_vPosition[max_lights];

vec4 shadow_setVertexPosition(vec4 position_commonspace) {
  if (shadow_uDrawShadowMap) {
    return project_common_position_to_clipspace(position_commonspace, shadow_uViewProjectionMatrices[shadow_uLightId], shadow_uProjectCenters[shadow_uLightId]);
  }
  if (shadow_uUseShadowMap) {
    for (int i = 0; i < max_lights; i++) {
      if(i < int(shadow_uLightCount)) {
        vec4 shadowMap_position = project_common_position_to_clipspace(position_commonspace, shadow_uViewProjectionMatrices[i], shadow_uProjectCenters[i]);
        shadow_vPosition[i] = (shadowMap_position.xyz / shadowMap_position.w + 1.0) / 2.0;
      }
    }
  }
  return gl_Position;
}
`;
const fs$f = `
const int max_lights = 2;
uniform bool shadow_uDrawShadowMap;
uniform bool shadow_uUseShadowMap;
uniform sampler2D shadow_uShadowMap0;
uniform sampler2D shadow_uShadowMap1;
uniform vec4 shadow_uColor;
uniform float shadow_uLightCount;

in vec3 shadow_vPosition[max_lights];

const vec4 bitPackShift = vec4(1.0, 255.0, 65025.0, 16581375.0);
const vec4 bitUnpackShift = 1.0 / bitPackShift;
const vec4 bitMask = vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0,  0.0);

float shadow_getShadowWeight(vec3 position, sampler2D shadowMap) {
  vec4 rgbaDepth = texture(shadowMap, position.xy);

  float z = dot(rgbaDepth, bitUnpackShift);
  return smoothstep(0.001, 0.01, position.z - z);
}

vec4 shadow_filterShadowColor(vec4 color) {
  if (shadow_uDrawShadowMap) {
    vec4 rgbaDepth = fract(gl_FragCoord.z * bitPackShift);
    rgbaDepth -= rgbaDepth.gbaa * bitMask;
    return rgbaDepth;
  }
  if (shadow_uUseShadowMap) {
    float shadowAlpha = 0.0;
    shadowAlpha += shadow_getShadowWeight(shadow_vPosition[0], shadow_uShadowMap0);
    if(shadow_uLightCount > 1.0) {
      shadowAlpha += shadow_getShadowWeight(shadow_vPosition[1], shadow_uShadowMap1);
    }
    shadowAlpha *= shadow_uColor.a / shadow_uLightCount;
    float blendedAlpha = shadowAlpha + color.a * (1.0 - shadowAlpha);

    return vec4(
      mix(color.rgb, shadow_uColor.rgb, shadowAlpha / blendedAlpha),
      blendedAlpha
    );
  }
  return color;
}
`;
const getMemoizedViewportCenterPosition = memoize$1(getViewportCenterPosition);
const getMemoizedViewProjectionMatrices = memoize$1(getViewProjectionMatrices);
const DEFAULT_SHADOW_COLOR$1 = [0, 0, 0, 1];
const VECTOR_TO_POINT_MATRIX = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0];
function screenToCommonSpace(xyz, pixelUnprojectionMatrix) {
  const [x2, y2, z2] = xyz;
  const coord = pixelsToWorld([x2, y2, z2], pixelUnprojectionMatrix);
  if (Number.isFinite(z2)) {
    return coord;
  }
  return [coord[0], coord[1], 0];
}
function getViewportCenterPosition({ viewport, center: center2 }) {
  return new Matrix4(viewport.viewProjectionMatrix).invert().transform(center2);
}
function getViewProjectionMatrices({ viewport, shadowMatrices }) {
  const projectionMatrices = [];
  const pixelUnprojectionMatrix = viewport.pixelUnprojectionMatrix;
  const farZ = viewport.isGeospatial ? void 0 : 1;
  const corners = [
    [0, 0, farZ],
    // top left ground
    [viewport.width, 0, farZ],
    // top right ground
    [0, viewport.height, farZ],
    // bottom left ground
    [viewport.width, viewport.height, farZ],
    // bottom right ground
    [0, 0, -1],
    // top left near
    [viewport.width, 0, -1],
    // top right near
    [0, viewport.height, -1],
    // bottom left near
    [viewport.width, viewport.height, -1]
    // bottom right near
  ].map((pixel) => (
    // @ts-expect-error z may be undefined
    screenToCommonSpace(pixel, pixelUnprojectionMatrix)
  ));
  for (const shadowMatrix of shadowMatrices) {
    const viewMatrix = shadowMatrix.clone().translate(new Vector3(viewport.center).negate());
    const positions = corners.map((corner) => viewMatrix.transform(corner));
    const projectionMatrix = new Matrix4().ortho({
      left: Math.min(...positions.map((position) => position[0])),
      right: Math.max(...positions.map((position) => position[0])),
      bottom: Math.min(...positions.map((position) => position[1])),
      top: Math.max(...positions.map((position) => position[1])),
      near: Math.min(...positions.map((position) => -position[2])),
      far: Math.max(...positions.map((position) => -position[2]))
    });
    projectionMatrices.push(projectionMatrix.multiplyRight(shadowMatrix));
  }
  return projectionMatrices;
}
function createShadowUniforms(opts, context2) {
  const { shadowEnabled = true } = opts;
  if (!shadowEnabled || !opts.shadowMatrices || !opts.shadowMatrices.length) {
    return {
      shadow_uDrawShadowMap: false,
      shadow_uUseShadowMap: false,
      shadow_uShadowMap0: opts.dummyShadowMap,
      shadow_uShadowMap1: opts.dummyShadowMap
    };
  }
  const uniforms = {
    shadow_uDrawShadowMap: Boolean(opts.drawToShadowMap),
    shadow_uUseShadowMap: opts.shadowMaps ? opts.shadowMaps.length > 0 : false,
    shadow_uColor: opts.shadowColor || DEFAULT_SHADOW_COLOR$1,
    shadow_uLightId: opts.shadowLightId || 0,
    shadow_uLightCount: opts.shadowMatrices.length
  };
  const center2 = getMemoizedViewportCenterPosition({
    viewport: opts.viewport,
    center: context2.project_uCenter
  });
  const projectCenters = [];
  const viewProjectionMatrices = getMemoizedViewProjectionMatrices({
    shadowMatrices: opts.shadowMatrices,
    viewport: opts.viewport
  }).slice();
  for (let i2 = 0; i2 < opts.shadowMatrices.length; i2++) {
    const viewProjectionMatrix = viewProjectionMatrices[i2];
    const viewProjectionMatrixCentered = viewProjectionMatrix.clone().translate(new Vector3(opts.viewport.center).negate());
    if (context2.project_uCoordinateSystem === COORDINATE_SYSTEM.LNGLAT && context2.project_uProjectionMode === PROJECTION_MODE.WEB_MERCATOR) {
      viewProjectionMatrices[i2] = viewProjectionMatrixCentered;
      projectCenters[i2] = center2;
    } else {
      viewProjectionMatrices[i2] = viewProjectionMatrix.clone().multiplyRight(VECTOR_TO_POINT_MATRIX);
      projectCenters[i2] = viewProjectionMatrixCentered.transform(center2);
    }
  }
  for (let i2 = 0; i2 < viewProjectionMatrices.length; i2++) {
    uniforms[`shadow_uViewProjectionMatrices[${i2}]`] = viewProjectionMatrices[i2];
    uniforms[`shadow_uProjectCenters[${i2}]`] = projectCenters[i2];
  }
  for (let i2 = 0; i2 < 2; i2++) {
    uniforms[`shadow_uShadowMap${i2}`] = opts.shadowMaps && opts.shadowMaps[i2] || opts.dummyShadowMap;
  }
  return uniforms;
}
const shadow = {
  name: "shadow",
  dependencies: [project$1],
  vs: vs$e,
  fs: fs$f,
  inject: {
    "vs:DECKGL_FILTER_GL_POSITION": `
    position = shadow_setVertexPosition(geometry.position);
    `,
    "fs:DECKGL_FILTER_COLOR": `
    color = shadow_filterShadowColor(color);
    `
  },
  getUniforms: (opts = {}, context2 = {}) => {
    if ("viewport" in opts && (opts.drawToShadowMap || opts.shadowMaps && opts.shadowMaps.length > 0)) {
      return createShadowUniforms(opts, context2);
    }
    return {};
  }
};
const picking = {
  ...picking$1,
  defaultUniforms: { ...picking$1.defaultUniforms, useFloatColors: false },
  inject: {
    "vs:DECKGL_FILTER_GL_POSITION": `
    // for picking depth values
    picking_setPickingAttribute(position.z / position.w);
  `,
    "vs:DECKGL_FILTER_COLOR": `
  picking_setPickingColor(geometry.pickingColor);
  `,
    "fs:DECKGL_FILTER_COLOR": {
      order: 99,
      injection: `
  // use highlight color if this fragment belongs to the selected object.
  color = picking_filterHighlightColor(color);

  // use picking color if rendering to picking FBO.
  color = picking_filterPickingColor(color);
    `
    }
  }
};
const DEFAULT_MODULES = [project$1];
const SHADER_HOOKS = [
  "vs:DECKGL_FILTER_SIZE(inout vec3 size, VertexGeometry geometry)",
  "vs:DECKGL_FILTER_GL_POSITION(inout vec4 position, VertexGeometry geometry)",
  "vs:DECKGL_FILTER_COLOR(inout vec4 color, VertexGeometry geometry)",
  "fs:DECKGL_FILTER_COLOR(inout vec4 color, FragmentGeometry geometry)"
];
function getShaderAssembler() {
  const shaderAssembler = ShaderAssembler.getDefaultShaderAssembler();
  for (const shaderModule of DEFAULT_MODULES) {
    shaderAssembler.addDefaultModule(shaderModule);
  }
  for (const shaderHook of SHADER_HOOKS) {
    shaderAssembler.addShaderHook(shaderHook);
  }
  return shaderAssembler;
}
const DEFAULT_LIGHT_COLOR$1 = [255, 255, 255];
const DEFAULT_LIGHT_INTENSITY$1 = 1;
let idCount$1 = 0;
class AmbientLight {
  constructor(props = {}) {
    this.type = "ambient";
    const { color = DEFAULT_LIGHT_COLOR$1 } = props;
    const { intensity = DEFAULT_LIGHT_INTENSITY$1 } = props;
    this.id = props.id || `ambient-${idCount$1++}`;
    this.color = color;
    this.intensity = intensity;
  }
}
const DEFAULT_LIGHT_COLOR = [255, 255, 255];
const DEFAULT_LIGHT_INTENSITY = 1;
const DEFAULT_LIGHT_DIRECTION = [0, 0, -1];
let idCount = 0;
class DirectionalLight {
  constructor(props = {}) {
    this.type = "directional";
    const { color = DEFAULT_LIGHT_COLOR } = props;
    const { intensity = DEFAULT_LIGHT_INTENSITY } = props;
    const { direction = DEFAULT_LIGHT_DIRECTION } = props;
    const { _shadow = false } = props;
    this.id = props.id || `directional-${idCount++}`;
    this.color = color;
    this.intensity = intensity;
    this.type = "directional";
    this.direction = new Vector3(direction).normalize().toArray();
    this.shadow = _shadow;
  }
  getProjectedLight(opts) {
    return this;
  }
}
class Pass {
  /** Create a new Pass instance */
  constructor(device, props = { id: "pass" }) {
    const { id } = props;
    this.id = id;
    this.device = device;
    this.props = { ...props };
  }
  setProps(props) {
    Object.assign(this.props, props);
  }
  render(params2) {
  }
  // eslint-disable-line @typescript-eslint/no-empty-function
  cleanup() {
  }
  // eslint-disable-line @typescript-eslint/no-empty-function
}
class LayersPass extends Pass {
  constructor() {
    super(...arguments);
    this._lastRenderIndex = -1;
  }
  render(options2) {
    const [width, height] = this.device.canvasContext.getDrawingBufferSize();
    const clearCanvas = options2.clearCanvas ?? true;
    const clearColor = options2.clearColor ?? (clearCanvas ? [0, 0, 0, 0] : false);
    const clearDepth = clearCanvas ? 1 : false;
    const clearStencil = clearCanvas ? 0 : false;
    const colorMask = options2.colorMask ?? 15;
    const parameters = { viewport: [0, 0, width, height] };
    if (options2.colorMask) {
      parameters.colorMask = colorMask;
    }
    if (options2.scissorRect) {
      parameters.scissorRect = options2.scissorRect;
    }
    const renderPass = this.device.beginRenderPass({
      framebuffer: options2.target,
      parameters,
      clearColor,
      clearDepth,
      clearStencil
    });
    try {
      return this._drawLayers(renderPass, options2);
    } finally {
      renderPass.end();
    }
  }
  /** Draw a list of layers in a list of viewports */
  _drawLayers(renderPass, options2) {
    const { target, moduleParameters, viewports, views, onViewportActive, clearStack = true } = options2;
    options2.pass = options2.pass || "unknown";
    if (clearStack) {
      this._lastRenderIndex = -1;
    }
    const renderStats = [];
    for (const viewport of viewports) {
      const view2 = views && views[viewport.id];
      onViewportActive == null ? void 0 : onViewportActive(viewport);
      const drawLayerParams = this._getDrawLayerParams(viewport, options2);
      const subViewports = viewport.subViewports || [viewport];
      for (const subViewport of subViewports) {
        const stats = this._drawLayersInViewport(renderPass, {
          target,
          moduleParameters,
          viewport: subViewport,
          view: view2,
          pass: options2.pass,
          layers: options2.layers
        }, drawLayerParams);
        renderStats.push(stats);
      }
    }
    return renderStats;
  }
  // When a viewport contains multiple subviewports (e.g. repeated web mercator map),
  // this is only done once for the parent viewport
  /* Resolve the parameters needed to draw each layer */
  _getDrawLayerParams(viewport, { layers, pass: pass2, isPicking = false, layerFilter, cullRect, effects, moduleParameters }, evaluateShouldDrawOnly = false) {
    var _a3;
    const drawLayerParams = [];
    const indexResolver = layerIndexResolver(this._lastRenderIndex + 1);
    const drawContext = {
      layer: layers[0],
      viewport,
      isPicking,
      renderPass: pass2,
      cullRect
    };
    const layerFilterCache = {};
    for (let layerIndex = 0; layerIndex < layers.length; layerIndex++) {
      const layer = layers[layerIndex];
      const shouldDrawLayer = this._shouldDrawLayer(layer, drawContext, layerFilter, layerFilterCache);
      const layerParam = {
        shouldDrawLayer
      };
      if (shouldDrawLayer && !evaluateShouldDrawOnly) {
        layerParam.layerRenderIndex = indexResolver(layer, shouldDrawLayer);
        layerParam.moduleParameters = this._getModuleParameters(layer, effects, pass2, moduleParameters);
        layerParam.layerParameters = {
          ...(_a3 = layer.context.deck) == null ? void 0 : _a3.props.parameters,
          ...this.getLayerParameters(layer, layerIndex, viewport)
        };
      }
      drawLayerParams[layerIndex] = layerParam;
    }
    return drawLayerParams;
  }
  // Draws a list of layers in one viewport
  // TODO - when picking we could completely skip rendering viewports that dont
  // intersect with the picking rect
  /* eslint-disable max-depth, max-statements */
  _drawLayersInViewport(renderPass, { layers, moduleParameters: globalModuleParameters, pass: pass2, target, viewport, view: view2 }, drawLayerParams) {
    const glViewport = getGLViewport(this.device, {
      moduleParameters: globalModuleParameters,
      target,
      viewport
    });
    if (view2 && view2.props.clear) {
      const clearOpts = view2.props.clear === true ? { color: true, depth: true } : view2.props.clear;
      this.device.withParametersWebGL({
        scissorTest: true,
        scissor: glViewport
      }, () => this.device.clearWebGL(clearOpts));
    }
    const renderStatus = {
      totalCount: layers.length,
      visibleCount: 0,
      compositeCount: 0,
      pickableCount: 0
    };
    renderPass.setParameters({ viewport: glViewport });
    for (let layerIndex = 0; layerIndex < layers.length; layerIndex++) {
      const layer = layers[layerIndex];
      const { shouldDrawLayer, layerRenderIndex, moduleParameters, layerParameters } = drawLayerParams[layerIndex];
      if (shouldDrawLayer && layer.props.pickable) {
        renderStatus.pickableCount++;
      }
      if (layer.isComposite) {
        renderStatus.compositeCount++;
      } else if (shouldDrawLayer) {
        renderStatus.visibleCount++;
        this._lastRenderIndex = Math.max(this._lastRenderIndex, layerRenderIndex);
        moduleParameters.viewport = viewport;
        layer.context.renderPass = renderPass;
        try {
          layer._drawLayer({
            renderPass,
            moduleParameters,
            uniforms: { layerIndex: layerRenderIndex },
            parameters: layerParameters
          });
        } catch (err) {
          layer.raiseError(err, `drawing ${layer} to ${pass2}`);
        }
      }
    }
    return renderStatus;
  }
  /* eslint-enable max-depth, max-statements */
  /* Methods for subclass overrides */
  shouldDrawLayer(layer) {
    return true;
  }
  getModuleParameters(layer, effects) {
    return null;
  }
  getLayerParameters(layer, layerIndex, viewport) {
    return layer.props.parameters;
  }
  /* Private */
  _shouldDrawLayer(layer, drawContext, layerFilter, layerFilterCache) {
    const shouldDrawLayer = layer.props.visible && this.shouldDrawLayer(layer);
    if (!shouldDrawLayer) {
      return false;
    }
    drawContext.layer = layer;
    let parent = layer.parent;
    while (parent) {
      if (!parent.props.visible || !parent.filterSubLayer(drawContext)) {
        return false;
      }
      drawContext.layer = parent;
      parent = parent.parent;
    }
    if (layerFilter) {
      const rootLayerId = drawContext.layer.id;
      if (!(rootLayerId in layerFilterCache)) {
        layerFilterCache[rootLayerId] = layerFilter(drawContext);
      }
      if (!layerFilterCache[rootLayerId]) {
        return false;
      }
    }
    layer.activateViewport(drawContext.viewport);
    return true;
  }
  _getModuleParameters(layer, effects, pass2, overrides) {
    var _a3, _b3;
    const devicePixelRatio2 = this.device.canvasContext.cssToDeviceRatio();
    const moduleParameters = Object.assign(Object.create(((_a3 = layer.internalState) == null ? void 0 : _a3.propsInTransition) || layer.props), {
      autoWrapLongitude: layer.wrapLongitude,
      viewport: layer.context.viewport,
      mousePosition: layer.context.mousePosition,
      picking: {
        isActive: 0
      },
      devicePixelRatio: devicePixelRatio2
    });
    if (effects) {
      for (const effect of effects) {
        Object.assign(moduleParameters, (_b3 = effect.getModuleParameters) == null ? void 0 : _b3.call(effect, layer));
      }
    }
    return Object.assign(moduleParameters, this.getModuleParameters(layer, effects), overrides);
  }
}
function layerIndexResolver(startIndex = 0, layerIndices = {}) {
  const resolvers = {};
  const resolveLayerIndex = (layer, isDrawn) => {
    const indexOverride = layer.props._offset;
    const layerId = layer.id;
    const parentId = layer.parent && layer.parent.id;
    let index2;
    if (parentId && !(parentId in layerIndices)) {
      resolveLayerIndex(layer.parent, false);
    }
    if (parentId in resolvers) {
      const resolver = resolvers[parentId] = resolvers[parentId] || layerIndexResolver(layerIndices[parentId], layerIndices);
      index2 = resolver(layer, isDrawn);
      resolvers[layerId] = resolver;
    } else if (Number.isFinite(indexOverride)) {
      index2 = indexOverride + (layerIndices[parentId] || 0);
      resolvers[layerId] = null;
    } else {
      index2 = startIndex;
    }
    if (isDrawn && index2 >= startIndex) {
      startIndex = index2 + 1;
    }
    layerIndices[layerId] = index2;
    return index2;
  };
  return resolveLayerIndex;
}
function getGLViewport(device, { moduleParameters, target, viewport }) {
  const pixelRatio = moduleParameters && moduleParameters.devicePixelRatio || // @ts-expect-error TODO - assuming WebGL context
  device.canvasContext.cssToDeviceRatio();
  const [, drawingBufferHeight] = device.canvasContext.getDrawingBufferSize();
  const height = target ? target.height : drawingBufferHeight;
  const dimensions = viewport;
  return [
    dimensions.x * pixelRatio,
    height - (dimensions.y + dimensions.height) * pixelRatio,
    dimensions.width * pixelRatio,
    dimensions.height * pixelRatio
  ];
}
class ShadowPass extends LayersPass {
  constructor(device, props) {
    super(device, props);
    this.shadowMap = device.createTexture({
      width: 1,
      height: 1,
      sampler: {
        minFilter: "linear",
        magFilter: "linear",
        addressModeU: "clamp-to-edge",
        addressModeV: "clamp-to-edge"
      }
    });
    this.depthBuffer = device.createTexture({
      format: "depth16unorm",
      width: 1,
      height: 1,
      mipmaps: false,
      // TODO fix getWebGLTextureParameters() in luma to avoid passing deprecated parameters
      dataFormat: 6402,
      // gl.DEPTH_COMPONENT
      type: 5125
      // gl.UNSIGNED_INT
    });
    this.fbo = device.createFramebuffer({
      id: "shadowmap",
      width: 1,
      height: 1,
      colorAttachments: [this.shadowMap],
      // Depth attachment has to be specified for depth test to work
      depthStencilAttachment: this.depthBuffer
    });
  }
  render(params2) {
    const target = this.fbo;
    const pixelRatio = this.device.canvasContext.cssToDeviceRatio();
    const viewport = params2.viewports[0];
    const width = viewport.width * pixelRatio;
    const height = viewport.height * pixelRatio;
    const clearColor = [1, 1, 1, 1];
    if (width !== target.width || height !== target.height) {
      target.resize({ width, height });
    }
    super.render({ ...params2, clearColor, target, pass: "shadow" });
  }
  getLayerParameters(layer, layerIndex, viewport) {
    return { ...layer.props.parameters, blend: false, depthRange: [0, 1], depthTest: true };
  }
  shouldDrawLayer(layer) {
    return layer.props.shadowEnabled !== false;
  }
  getModuleParameters() {
    return {
      drawToShadowMap: true
    };
  }
  delete() {
    if (this.fbo) {
      this.fbo.destroy();
      this.fbo = null;
    }
    if (this.shadowMap) {
      this.shadowMap.destroy();
      this.shadowMap = null;
    }
    if (this.depthBuffer) {
      this.depthBuffer.destroy();
      this.depthBuffer = null;
    }
  }
}
const DEFAULT_AMBIENT_LIGHT_PROPS = { color: [255, 255, 255], intensity: 1 };
const DEFAULT_DIRECTIONAL_LIGHT_PROPS = [
  {
    color: [255, 255, 255],
    intensity: 1,
    direction: [-1, 3, -1]
  },
  {
    color: [255, 255, 255],
    intensity: 0.9,
    direction: [1, -8, -2.5]
  }
];
const DEFAULT_SHADOW_COLOR = [0, 0, 0, 200 / 255];
class LightingEffect {
  constructor(props = {}) {
    this.id = "lighting-effect";
    this.shadowColor = DEFAULT_SHADOW_COLOR;
    this.shadow = false;
    this.ambientLight = null;
    this.directionalLights = [];
    this.pointLights = [];
    this.shadowPasses = [];
    this.shadowMaps = [];
    this.dummyShadowMap = null;
    this.setProps(props);
  }
  setup(context2) {
    this.context = context2;
    const { device, deck } = context2;
    if (this.shadow && !this.dummyShadowMap) {
      this._createShadowPasses(device);
      deck._addDefaultShaderModule(shadow);
      this.dummyShadowMap = device.createTexture({
        width: 1,
        height: 1
      });
    }
  }
  setProps(props) {
    this.ambientLight = null;
    this.directionalLights = [];
    this.pointLights = [];
    for (const key in props) {
      const lightSource = props[key];
      switch (lightSource.type) {
        case "ambient":
          this.ambientLight = lightSource;
          break;
        case "directional":
          this.directionalLights.push(lightSource);
          break;
        case "point":
          this.pointLights.push(lightSource);
          break;
      }
    }
    this._applyDefaultLights();
    this.shadow = this.directionalLights.some((light) => light.shadow);
    if (this.context) {
      this.setup(this.context);
    }
    this.props = props;
  }
  preRender({ layers, layerFilter, viewports, onViewportActive, views }) {
    if (!this.shadow)
      return;
    this.shadowMatrices = this._calculateMatrices();
    for (let i2 = 0; i2 < this.shadowPasses.length; i2++) {
      const shadowPass = this.shadowPasses[i2];
      shadowPass.render({
        layers,
        layerFilter,
        viewports,
        onViewportActive,
        views,
        moduleParameters: {
          shadowLightId: i2,
          dummyShadowMap: this.dummyShadowMap,
          shadowMatrices: this.shadowMatrices
        }
      });
    }
  }
  getModuleParameters(layer) {
    const parameters = this.shadow ? {
      shadowMaps: this.shadowMaps,
      dummyShadowMap: this.dummyShadowMap,
      shadowColor: this.shadowColor,
      shadowMatrices: this.shadowMatrices
    } : {};
    parameters.lightSources = {
      ambientLight: this.ambientLight,
      directionalLights: this.directionalLights.map((directionalLight) => directionalLight.getProjectedLight({ layer })),
      pointLights: this.pointLights.map((pointLight) => pointLight.getProjectedLight({ layer }))
    };
    return parameters;
  }
  cleanup(context2) {
    for (const shadowPass of this.shadowPasses) {
      shadowPass.delete();
    }
    this.shadowPasses.length = 0;
    this.shadowMaps.length = 0;
    if (this.dummyShadowMap) {
      this.dummyShadowMap.destroy();
      this.dummyShadowMap = null;
      context2.deck._removeDefaultShaderModule(shadow);
    }
  }
  _calculateMatrices() {
    const lightMatrices = [];
    for (const light of this.directionalLights) {
      const viewMatrix = new Matrix4().lookAt({
        eye: new Vector3(light.direction).negate()
      });
      lightMatrices.push(viewMatrix);
    }
    return lightMatrices;
  }
  _createShadowPasses(device) {
    for (let i2 = 0; i2 < this.directionalLights.length; i2++) {
      const shadowPass = new ShadowPass(device);
      this.shadowPasses[i2] = shadowPass;
      this.shadowMaps[i2] = shadowPass.shadowMap;
    }
  }
  _applyDefaultLights() {
    const { ambientLight, pointLights, directionalLights } = this;
    if (!ambientLight && pointLights.length === 0 && directionalLights.length === 0) {
      this.ambientLight = new AmbientLight(DEFAULT_AMBIENT_LIGHT_PROPS);
      this.directionalLights.push(new DirectionalLight(DEFAULT_DIRECTIONAL_LIGHT_PROPS[0]), new DirectionalLight(DEFAULT_DIRECTIONAL_LIGHT_PROPS[1]));
    }
  }
}
class TypedArrayManager {
  constructor(options2 = {}) {
    this._pool = [];
    this.opts = { overAlloc: 2, poolSize: 100 };
    this.setOptions(options2);
  }
  setOptions(options2) {
    Object.assign(this.opts, options2);
  }
  allocate(typedArray, count3, { size: size12 = 1, type, padding = 0, copy: copy8 = false, initialize: initialize3 = false, maxCount }) {
    const Type3 = type || typedArray && typedArray.constructor || Float32Array;
    const newSize = count3 * size12 + padding;
    if (ArrayBuffer.isView(typedArray)) {
      if (newSize <= typedArray.length) {
        return typedArray;
      }
      if (newSize * typedArray.BYTES_PER_ELEMENT <= typedArray.buffer.byteLength) {
        return new Type3(typedArray.buffer, 0, newSize);
      }
    }
    let maxSize = Infinity;
    if (maxCount) {
      maxSize = maxCount * size12 + padding;
    }
    const newArray = this._allocate(Type3, newSize, initialize3, maxSize);
    if (typedArray && copy8) {
      newArray.set(typedArray);
    } else if (!initialize3) {
      newArray.fill(0, 0, 4);
    }
    this._release(typedArray);
    return newArray;
  }
  release(typedArray) {
    this._release(typedArray);
  }
  _allocate(Type3, size12, initialize3, maxSize) {
    let sizeToAllocate = Math.max(Math.ceil(size12 * this.opts.overAlloc), 1);
    if (sizeToAllocate > maxSize) {
      sizeToAllocate = maxSize;
    }
    const pool = this._pool;
    const byteLength = Type3.BYTES_PER_ELEMENT * sizeToAllocate;
    const i2 = pool.findIndex((b2) => b2.byteLength >= byteLength);
    if (i2 >= 0) {
      const array2 = new Type3(pool.splice(i2, 1)[0], 0, sizeToAllocate);
      if (initialize3) {
        array2.fill(0);
      }
      return array2;
    }
    return new Type3(sizeToAllocate);
  }
  _release(typedArray) {
    if (!ArrayBuffer.isView(typedArray)) {
      return;
    }
    const pool = this._pool;
    const { buffer: buffer3 } = typedArray;
    const { byteLength } = buffer3;
    const i2 = pool.findIndex((b2) => b2.byteLength >= byteLength);
    if (i2 < 0) {
      pool.push(buffer3);
    } else if (i2 > 0 || pool.length < this.opts.poolSize) {
      pool.splice(i2, 0, buffer3);
    }
    if (pool.length > this.opts.poolSize) {
      pool.shift();
    }
  }
}
const defaultTypedArrayManager = new TypedArrayManager();
function createMat4() {
  return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}
function getCameraPosition(viewMatrixInverse) {
  return [viewMatrixInverse[12], viewMatrixInverse[13], viewMatrixInverse[14]];
}
function getFrustumPlanes(viewProjectionMatrix) {
  return {
    left: getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[0], viewProjectionMatrix[7] + viewProjectionMatrix[4], viewProjectionMatrix[11] + viewProjectionMatrix[8], viewProjectionMatrix[15] + viewProjectionMatrix[12]),
    right: getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[0], viewProjectionMatrix[7] - viewProjectionMatrix[4], viewProjectionMatrix[11] - viewProjectionMatrix[8], viewProjectionMatrix[15] - viewProjectionMatrix[12]),
    bottom: getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[1], viewProjectionMatrix[7] + viewProjectionMatrix[5], viewProjectionMatrix[11] + viewProjectionMatrix[9], viewProjectionMatrix[15] + viewProjectionMatrix[13]),
    top: getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[1], viewProjectionMatrix[7] - viewProjectionMatrix[5], viewProjectionMatrix[11] - viewProjectionMatrix[9], viewProjectionMatrix[15] - viewProjectionMatrix[13]),
    near: getFrustumPlane(viewProjectionMatrix[3] + viewProjectionMatrix[2], viewProjectionMatrix[7] + viewProjectionMatrix[6], viewProjectionMatrix[11] + viewProjectionMatrix[10], viewProjectionMatrix[15] + viewProjectionMatrix[14]),
    far: getFrustumPlane(viewProjectionMatrix[3] - viewProjectionMatrix[2], viewProjectionMatrix[7] - viewProjectionMatrix[6], viewProjectionMatrix[11] - viewProjectionMatrix[10], viewProjectionMatrix[15] - viewProjectionMatrix[14])
  };
}
const scratchVector$9 = new Vector3();
function getFrustumPlane(a2, b2, c2, d2) {
  scratchVector$9.set(a2, b2, c2);
  const L2 = scratchVector$9.len();
  return { distance: d2 / L2, normal: new Vector3(-a2 / L2, -b2 / L2, -c2 / L2) };
}
function fp64LowPart(x2) {
  return x2 - Math.fround(x2);
}
let scratchArray$1;
function toDoublePrecisionArray(typedArray, options2) {
  const { size: size12 = 1, startIndex = 0 } = options2;
  const endIndex = options2.endIndex !== void 0 ? options2.endIndex : typedArray.length;
  const count3 = (endIndex - startIndex) / size12;
  scratchArray$1 = defaultTypedArrayManager.allocate(scratchArray$1, count3, {
    type: Float32Array,
    size: size12 * 2
  });
  let sourceIndex = startIndex;
  let targetIndex = 0;
  while (sourceIndex < endIndex) {
    for (let j2 = 0; j2 < size12; j2++) {
      const value = typedArray[sourceIndex++];
      scratchArray$1[targetIndex + j2] = value;
      scratchArray$1[targetIndex + j2 + size12] = fp64LowPart(value);
    }
    targetIndex += size12 * 2;
  }
  return scratchArray$1.subarray(0, count3 * size12 * 2);
}
function mergeBounds(boundsList) {
  let mergedBounds = null;
  let isMerged = false;
  for (const bounds of boundsList) {
    if (!bounds)
      continue;
    if (!mergedBounds) {
      mergedBounds = bounds;
    } else {
      if (!isMerged) {
        mergedBounds = [
          [mergedBounds[0][0], mergedBounds[0][1]],
          [mergedBounds[1][0], mergedBounds[1][1]]
        ];
        isMerged = true;
      }
      mergedBounds[0][0] = Math.min(mergedBounds[0][0], bounds[0][0]);
      mergedBounds[0][1] = Math.min(mergedBounds[0][1], bounds[0][1]);
      mergedBounds[1][0] = Math.max(mergedBounds[1][0], bounds[1][0]);
      mergedBounds[1][1] = Math.max(mergedBounds[1][1], bounds[1][1]);
    }
  }
  return mergedBounds;
}
const DEGREES_TO_RADIANS$2 = Math.PI / 180;
const IDENTITY = createMat4();
const ZERO_VECTOR = [0, 0, 0];
const DEFAULT_DISTANCE_SCALES = {
  unitsPerMeter: [1, 1, 1],
  metersPerUnit: [1, 1, 1]
};
function createProjectionMatrix({ width, height, orthographic, fovyRadians, focalDistance, padding, near, far }) {
  const aspect2 = width / height;
  const matrix = orthographic ? new Matrix4().orthographic({ fovy: fovyRadians, aspect: aspect2, focalDistance, near, far }) : new Matrix4().perspective({ fovy: fovyRadians, aspect: aspect2, near, far });
  if (padding) {
    const { left = 0, right = 0, top = 0, bottom = 0 } = padding;
    const offsetX = clamp$3((left + width - right) / 2, 0, width) - width / 2;
    const offsetY = clamp$3((top + height - bottom) / 2, 0, height) - height / 2;
    matrix[8] -= offsetX * 2 / width;
    matrix[9] += offsetY * 2 / height;
  }
  return matrix;
}
const _Viewport = class {
  // eslint-disable-next-line complexity
  constructor(opts = {}) {
    this._frustumPlanes = {};
    this.id = opts.id || this.constructor.displayName || "viewport";
    this.x = opts.x || 0;
    this.y = opts.y || 0;
    this.width = opts.width || 1;
    this.height = opts.height || 1;
    this.zoom = opts.zoom || 0;
    this.padding = opts.padding;
    this.distanceScales = opts.distanceScales || DEFAULT_DISTANCE_SCALES;
    this.focalDistance = opts.focalDistance || 1;
    this.position = opts.position || ZERO_VECTOR;
    this.modelMatrix = opts.modelMatrix || null;
    const { longitude, latitude } = opts;
    this.isGeospatial = Number.isFinite(latitude) && Number.isFinite(longitude);
    this._initProps(opts);
    this._initMatrices(opts);
    this.equals = this.equals.bind(this);
    this.project = this.project.bind(this);
    this.unproject = this.unproject.bind(this);
    this.projectPosition = this.projectPosition.bind(this);
    this.unprojectPosition = this.unprojectPosition.bind(this);
    this.projectFlat = this.projectFlat.bind(this);
    this.unprojectFlat = this.unprojectFlat.bind(this);
  }
  get subViewports() {
    return null;
  }
  get metersPerPixel() {
    return this.distanceScales.metersPerUnit[2] / this.scale;
  }
  get projectionMode() {
    if (this.isGeospatial) {
      return this.zoom < 12 ? PROJECTION_MODE.WEB_MERCATOR : PROJECTION_MODE.WEB_MERCATOR_AUTO_OFFSET;
    }
    return PROJECTION_MODE.IDENTITY;
  }
  // Two viewports are equal if width and height are identical, and if
  // their view and projection matrices are (approximately) equal.
  equals(viewport) {
    if (!(viewport instanceof _Viewport)) {
      return false;
    }
    if (this === viewport) {
      return true;
    }
    return viewport.width === this.width && viewport.height === this.height && viewport.scale === this.scale && equals$1(viewport.projectionMatrix, this.projectionMatrix) && equals$1(viewport.viewMatrix, this.viewMatrix);
  }
  /**
   * Projects xyz (possibly latitude and longitude) to pixel coordinates in window
   * using viewport projection parameters
   * - [longitude, latitude] to [x, y]
   * - [longitude, latitude, Z] => [x, y, z]
   * Note: By default, returns top-left coordinates for canvas/SVG type render
   *
   * @param {Array} lngLatZ - [lng, lat] or [lng, lat, Z]
   * @param {Object} opts - options
   * @param {Object} opts.topLeft=true - Whether projected coords are top left
   * @return {Array} - [x, y] or [x, y, z] in top left coords
   */
  project(xyz, { topLeft = true } = {}) {
    const worldPosition = this.projectPosition(xyz);
    const coord = worldToPixels(worldPosition, this.pixelProjectionMatrix);
    const [x2, y2] = coord;
    const y22 = topLeft ? y2 : this.height - y2;
    return xyz.length === 2 ? [x2, y22] : [x2, y22, coord[2]];
  }
  /**
   * Unproject pixel coordinates on screen onto world coordinates,
   * (possibly [lon, lat]) on map.
   * - [x, y] => [lng, lat]
   * - [x, y, z] => [lng, lat, Z]
   * @param {Array} xyz -
   * @param {Object} opts - options
   * @param {Object} opts.topLeft=true - Whether origin is top left
   * @return {Array|null} - [lng, lat, Z] or [X, Y, Z]
   */
  unproject(xyz, { topLeft = true, targetZ } = {}) {
    const [x2, y2, z2] = xyz;
    const y22 = topLeft ? y2 : this.height - y2;
    const targetZWorld = targetZ && targetZ * this.distanceScales.unitsPerMeter[2];
    const coord = pixelsToWorld([x2, y22, z2], this.pixelUnprojectionMatrix, targetZWorld);
    const [X2, Y2, Z2] = this.unprojectPosition(coord);
    if (Number.isFinite(z2)) {
      return [X2, Y2, Z2];
    }
    return Number.isFinite(targetZ) ? [X2, Y2, targetZ] : [X2, Y2];
  }
  // NON_LINEAR PROJECTION HOOKS
  // Used for web meractor projection
  projectPosition(xyz) {
    const [X2, Y2] = this.projectFlat(xyz);
    const Z2 = (xyz[2] || 0) * this.distanceScales.unitsPerMeter[2];
    return [X2, Y2, Z2];
  }
  unprojectPosition(xyz) {
    const [X2, Y2] = this.unprojectFlat(xyz);
    const Z2 = (xyz[2] || 0) * this.distanceScales.metersPerUnit[2];
    return [X2, Y2, Z2];
  }
  /**
   * Project [lng,lat] on sphere onto [x,y] on 512*512 Mercator Zoom 0 tile.
   * Performs the nonlinear part of the web mercator projection.
   * Remaining projection is done with 4x4 matrices which also handles
   * perspective.
   * @param {Array} lngLat - [lng, lat] coordinates
   *   Specifies a point on the sphere to project onto the map.
   * @return {Array} [x,y] coordinates.
   */
  projectFlat(xyz) {
    if (this.isGeospatial) {
      const result = lngLatToWorld(xyz);
      result[1] = clamp$3(result[1], -318, 830);
      return result;
    }
    return xyz;
  }
  /**
   * Unproject world point [x,y] on map onto {lat, lon} on sphere
   * @param {object|Vector} xy - object with {x,y} members
   *  representing point on projected map plane
   * @return {GeoCoordinates} - object with {lat,lon} of point on sphere.
   *   Has toArray method if you need a GeoJSON Array.
   *   Per cartographic tradition, lat and lon are specified as degrees.
   */
  unprojectFlat(xyz) {
    if (this.isGeospatial) {
      return worldToLngLat(xyz);
    }
    return xyz;
  }
  /**
   * Get bounds of the current viewport
   * @return {Array} - [minX, minY, maxX, maxY]
   */
  getBounds(options2 = {}) {
    const unprojectOption = { targetZ: options2.z || 0 };
    const topLeft = this.unproject([0, 0], unprojectOption);
    const topRight = this.unproject([this.width, 0], unprojectOption);
    const bottomLeft = this.unproject([0, this.height], unprojectOption);
    const bottomRight = this.unproject([this.width, this.height], unprojectOption);
    return [
      Math.min(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
      Math.min(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1]),
      Math.max(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
      Math.max(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1])
    ];
  }
  getDistanceScales(coordinateOrigin) {
    if (coordinateOrigin) {
      return getDistanceScales$1({
        longitude: coordinateOrigin[0],
        latitude: coordinateOrigin[1],
        highPrecision: true
      });
    }
    return this.distanceScales;
  }
  containsPixel({ x: x2, y: y2, width = 1, height = 1 }) {
    return x2 < this.x + this.width && this.x < x2 + width && y2 < this.y + this.height && this.y < y2 + height;
  }
  // Extract frustum planes in common space
  getFrustumPlanes() {
    if (this._frustumPlanes.near) {
      return this._frustumPlanes;
    }
    Object.assign(this._frustumPlanes, getFrustumPlanes(this.viewProjectionMatrix));
    return this._frustumPlanes;
  }
  // EXPERIMENTAL METHODS
  /**
   * Needed by panning and linear transition
   * Pan the viewport to place a given world coordinate at screen point [x, y]
   *
   * @param {Array} coords - world coordinates
   * @param {Array} pixel - [x,y] coordinates on screen
   * @return {Object} props of the new viewport
   */
  panByPosition(coords, pixel) {
    return null;
  }
  // INTERNAL METHODS
  /* eslint-disable complexity, max-statements */
  _initProps(opts) {
    const longitude = opts.longitude;
    const latitude = opts.latitude;
    if (this.isGeospatial) {
      if (!Number.isFinite(opts.zoom)) {
        this.zoom = getMeterZoom({ latitude }) + Math.log2(this.focalDistance);
      }
      this.distanceScales = opts.distanceScales || getDistanceScales$1({ latitude, longitude });
    }
    const scale5 = Math.pow(2, this.zoom);
    this.scale = scale5;
    const { position, modelMatrix: modelMatrix2 } = opts;
    let meterOffset = ZERO_VECTOR;
    if (position) {
      meterOffset = modelMatrix2 ? new Matrix4(modelMatrix2).transformAsVector(position, []) : position;
    }
    if (this.isGeospatial) {
      const center2 = this.projectPosition([longitude, latitude, 0]);
      this.center = new Vector3(meterOffset).scale(this.distanceScales.unitsPerMeter).add(center2);
    } else {
      this.center = this.projectPosition(meterOffset);
    }
  }
  /* eslint-enable complexity, max-statements */
  _initMatrices(opts) {
    const {
      // View matrix
      viewMatrix = IDENTITY,
      // Projection matrix
      projectionMatrix = null,
      // Projection matrix parameters, used if projectionMatrix not supplied
      orthographic = false,
      fovyRadians,
      fovy = 75,
      near = 0.1,
      // Distance of near clipping plane
      far = 1e3,
      // Distance of far clipping plane
      padding = null,
      // Center offset in pixels
      focalDistance = 1
    } = opts;
    this.viewMatrixUncentered = viewMatrix;
    this.viewMatrix = new Matrix4().multiplyRight(viewMatrix).translate(new Vector3(this.center).negate());
    this.projectionMatrix = projectionMatrix || createProjectionMatrix({
      width: this.width,
      height: this.height,
      orthographic,
      fovyRadians: fovyRadians || fovy * DEGREES_TO_RADIANS$2,
      focalDistance,
      padding,
      near,
      far
    });
    const vpm = createMat4();
    multiply$1(vpm, vpm, this.projectionMatrix);
    multiply$1(vpm, vpm, this.viewMatrix);
    this.viewProjectionMatrix = vpm;
    this.viewMatrixInverse = invert$1([], this.viewMatrix) || this.viewMatrix;
    this.cameraPosition = getCameraPosition(this.viewMatrixInverse);
    const viewportMatrix = createMat4();
    const pixelProjectionMatrix = createMat4();
    scale$2(viewportMatrix, viewportMatrix, [this.width / 2, -this.height / 2, 1]);
    translate(viewportMatrix, viewportMatrix, [1, -1, 0]);
    multiply$1(pixelProjectionMatrix, viewportMatrix, this.viewProjectionMatrix);
    this.pixelProjectionMatrix = pixelProjectionMatrix;
    this.pixelUnprojectionMatrix = invert$1(createMat4(), this.pixelProjectionMatrix);
    if (!this.pixelUnprojectionMatrix) {
      log$1.warn("Pixel project matrix not invertible")();
    }
  }
};
let Viewport = _Viewport;
(() => {
  _Viewport.displayName = "Viewport";
})();
const _WebMercatorViewport = class extends Viewport {
  /* eslint-disable complexity, max-statements */
  constructor(opts = {}) {
    const {
      latitude = 0,
      longitude = 0,
      zoom: zoom2 = 0,
      pitch = 0,
      bearing: bearing2 = 0,
      nearZMultiplier = 0.1,
      farZMultiplier = 1.01,
      nearZ,
      farZ,
      orthographic = false,
      projectionMatrix,
      repeat = false,
      worldOffset = 0,
      position,
      padding,
      // backward compatibility
      // TODO: remove in v9
      legacyMeterSizes = false
    } = opts;
    let { width, height, altitude = 1.5 } = opts;
    const scale5 = Math.pow(2, zoom2);
    width = width || 1;
    height = height || 1;
    let fovy;
    let projectionParameters = null;
    if (projectionMatrix) {
      altitude = projectionMatrix[5] / 2;
      fovy = altitudeToFovy(altitude);
    } else {
      if (opts.fovy) {
        fovy = opts.fovy;
        altitude = fovyToAltitude(fovy);
      } else {
        fovy = altitudeToFovy(altitude);
      }
      let offset;
      if (padding) {
        const { top = 0, bottom = 0 } = padding;
        offset = [0, clamp$3((top + height - bottom) / 2, 0, height) - height / 2];
      }
      projectionParameters = getProjectionParameters({
        width,
        height,
        scale: scale5,
        center: position && [0, 0, position[2] * unitsPerMeter(latitude)],
        offset,
        pitch,
        fovy,
        nearZMultiplier,
        farZMultiplier
      });
      if (Number.isFinite(nearZ)) {
        projectionParameters.near = nearZ;
      }
      if (Number.isFinite(farZ)) {
        projectionParameters.far = farZ;
      }
    }
    let viewMatrixUncentered = getViewMatrix({
      height,
      pitch,
      bearing: bearing2,
      scale: scale5,
      altitude
    });
    if (worldOffset) {
      const viewOffset = new Matrix4().translate([512 * worldOffset, 0, 0]);
      viewMatrixUncentered = viewOffset.multiplyLeft(viewMatrixUncentered);
    }
    super({
      ...opts,
      // x, y,
      width,
      height,
      // view matrix
      viewMatrix: viewMatrixUncentered,
      longitude,
      latitude,
      zoom: zoom2,
      // projection matrix parameters
      ...projectionParameters,
      fovy,
      focalDistance: altitude
    });
    this.latitude = latitude;
    this.longitude = longitude;
    this.zoom = zoom2;
    this.pitch = pitch;
    this.bearing = bearing2;
    this.altitude = altitude;
    this.fovy = fovy;
    this.orthographic = orthographic;
    this._subViewports = repeat ? [] : null;
    this._pseudoMeters = legacyMeterSizes;
    Object.freeze(this);
  }
  /* eslint-enable complexity, max-statements */
  get subViewports() {
    if (this._subViewports && !this._subViewports.length) {
      const bounds = this.getBounds();
      const minOffset = Math.floor((bounds[0] + 180) / 360);
      const maxOffset = Math.ceil((bounds[2] - 180) / 360);
      for (let x2 = minOffset; x2 <= maxOffset; x2++) {
        const offsetViewport = x2 ? new _WebMercatorViewport({
          ...this,
          worldOffset: x2
        }) : this;
        this._subViewports.push(offsetViewport);
      }
    }
    return this._subViewports;
  }
  projectPosition(xyz) {
    if (this._pseudoMeters) {
      return super.projectPosition(xyz);
    }
    const [X2, Y2] = this.projectFlat(xyz);
    const Z2 = (xyz[2] || 0) * unitsPerMeter(xyz[1]);
    return [X2, Y2, Z2];
  }
  unprojectPosition(xyz) {
    if (this._pseudoMeters) {
      return super.unprojectPosition(xyz);
    }
    const [X2, Y2] = this.unprojectFlat(xyz);
    const Z2 = (xyz[2] || 0) / unitsPerMeter(Y2);
    return [X2, Y2, Z2];
  }
  /**
   * Add a meter delta to a base lnglat coordinate, returning a new lnglat array
   *
   * Note: Uses simple linear approximation around the viewport center
   * Error increases with size of offset (roughly 1% per 100km)
   *
   * @param {[Number,Number]|[Number,Number,Number]) lngLatZ - base coordinate
   * @param {[Number,Number]|[Number,Number,Number]) xyz - array of meter deltas
   * @return {[Number,Number]|[Number,Number,Number]) array of [lng,lat,z] deltas
   */
  addMetersToLngLat(lngLatZ, xyz) {
    return addMetersToLngLat(lngLatZ, xyz);
  }
  panByPosition(coords, pixel) {
    const fromLocation = pixelsToWorld(pixel, this.pixelUnprojectionMatrix);
    const toLocation = this.projectFlat(coords);
    const translate3 = add$3([], toLocation, negate$1([], fromLocation));
    const newCenter = add$3([], this.center, translate3);
    const [longitude, latitude] = this.unprojectFlat(newCenter);
    return { longitude, latitude };
  }
  getBounds(options2 = {}) {
    const corners = getBounds$1(this, options2.z || 0);
    return [
      Math.min(corners[0][0], corners[1][0], corners[2][0], corners[3][0]),
      Math.min(corners[0][1], corners[1][1], corners[2][1], corners[3][1]),
      Math.max(corners[0][0], corners[1][0], corners[2][0], corners[3][0]),
      Math.max(corners[0][1], corners[1][1], corners[2][1], corners[3][1])
    ];
  }
  /**
   * Returns a new viewport that fit around the given rectangle.
   * Only supports non-perspective mode.
   */
  fitBounds(bounds, options2 = {}) {
    const { width, height } = this;
    const { longitude, latitude, zoom: zoom2 } = fitBounds({ width, height, bounds, ...options2 });
    return new _WebMercatorViewport({ width, height, longitude, latitude, zoom: zoom2 });
  }
};
let WebMercatorViewport = _WebMercatorViewport;
(() => {
  _WebMercatorViewport.displayName = "WebMercatorViewport";
})();
const DEFAULT_COORDINATE_ORIGIN = [0, 0, 0];
function lngLatZToWorldPosition(lngLatZ, viewport, offsetMode = false) {
  const p2 = viewport.projectPosition(lngLatZ);
  if (offsetMode && viewport instanceof WebMercatorViewport) {
    const [longitude, latitude, z2 = 0] = lngLatZ;
    const distanceScales = viewport.getDistanceScales([longitude, latitude]);
    p2[2] = z2 * distanceScales.unitsPerMeter[2];
  }
  return p2;
}
function normalizeParameters(opts) {
  const { viewport, modelMatrix: modelMatrix2, coordinateOrigin } = opts;
  let { coordinateSystem, fromCoordinateSystem, fromCoordinateOrigin } = opts;
  if (coordinateSystem === COORDINATE_SYSTEM.DEFAULT) {
    coordinateSystem = viewport.isGeospatial ? COORDINATE_SYSTEM.LNGLAT : COORDINATE_SYSTEM.CARTESIAN;
  }
  if (fromCoordinateSystem === void 0) {
    fromCoordinateSystem = coordinateSystem;
  }
  if (fromCoordinateOrigin === void 0) {
    fromCoordinateOrigin = coordinateOrigin;
  }
  return {
    viewport,
    coordinateSystem,
    coordinateOrigin,
    modelMatrix: modelMatrix2,
    fromCoordinateSystem,
    fromCoordinateOrigin
  };
}
function getWorldPosition(position, { viewport, modelMatrix: modelMatrix2, coordinateSystem, coordinateOrigin, offsetMode }) {
  let [x2, y2, z2 = 0] = position;
  if (modelMatrix2) {
    [x2, y2, z2] = transformMat4([], [x2, y2, z2, 1], modelMatrix2);
  }
  switch (coordinateSystem) {
    case COORDINATE_SYSTEM.LNGLAT:
      return lngLatZToWorldPosition([x2, y2, z2], viewport, offsetMode);
    case COORDINATE_SYSTEM.LNGLAT_OFFSETS:
      return lngLatZToWorldPosition([x2 + coordinateOrigin[0], y2 + coordinateOrigin[1], z2 + (coordinateOrigin[2] || 0)], viewport, offsetMode);
    case COORDINATE_SYSTEM.METER_OFFSETS:
      return lngLatZToWorldPosition(addMetersToLngLat(coordinateOrigin, [x2, y2, z2]), viewport, offsetMode);
    case COORDINATE_SYSTEM.CARTESIAN:
    default:
      return viewport.isGeospatial ? [x2 + coordinateOrigin[0], y2 + coordinateOrigin[1], z2 + coordinateOrigin[2]] : viewport.projectPosition([x2, y2, z2]);
  }
}
function projectPosition(position, params2) {
  const { viewport, coordinateSystem, coordinateOrigin, modelMatrix: modelMatrix2, fromCoordinateSystem, fromCoordinateOrigin } = normalizeParameters(params2);
  const { autoOffset = true } = params2;
  const { geospatialOrigin = DEFAULT_COORDINATE_ORIGIN, shaderCoordinateOrigin = DEFAULT_COORDINATE_ORIGIN, offsetMode = false } = autoOffset ? getOffsetOrigin(viewport, coordinateSystem, coordinateOrigin) : {};
  const worldPosition = getWorldPosition(position, {
    viewport,
    modelMatrix: modelMatrix2,
    coordinateSystem: fromCoordinateSystem,
    coordinateOrigin: fromCoordinateOrigin,
    offsetMode
  });
  if (offsetMode) {
    const positionCommonSpace = viewport.projectPosition(geospatialOrigin || shaderCoordinateOrigin);
    sub(worldPosition, worldPosition, positionCommonSpace);
  }
  return worldPosition;
}
let channelHandles = 1;
let animationHandles = 1;
class Timeline {
  constructor() {
    __publicField2(this, "time", 0);
    __publicField2(this, "channels", /* @__PURE__ */ new Map());
    __publicField2(this, "animations", /* @__PURE__ */ new Map());
    __publicField2(this, "playing", false);
    __publicField2(this, "lastEngineTime", -1);
  }
  addChannel(props) {
    const { delay = 0, duration = Number.POSITIVE_INFINITY, rate = 1, repeat = 1 } = props;
    const channelId = channelHandles++;
    const channel = {
      time: 0,
      delay,
      duration,
      rate,
      repeat
    };
    this._setChannelTime(channel, this.time);
    this.channels.set(channelId, channel);
    return channelId;
  }
  removeChannel(channelId) {
    this.channels.delete(channelId);
    for (const [animationHandle, animation] of this.animations) {
      if (animation.channel === channelId) {
        this.detachAnimation(animationHandle);
      }
    }
  }
  isFinished(channelId) {
    const channel = this.channels.get(channelId);
    if (channel === void 0) {
      return false;
    }
    return this.time >= channel.delay + channel.duration * channel.repeat;
  }
  getTime(channelId) {
    if (channelId === void 0) {
      return this.time;
    }
    const channel = this.channels.get(channelId);
    if (channel === void 0) {
      return -1;
    }
    return channel.time;
  }
  setTime(time2) {
    this.time = Math.max(0, time2);
    const channels = this.channels.values();
    for (const channel of channels) {
      this._setChannelTime(channel, this.time);
    }
    const animations = this.animations.values();
    for (const animationData of animations) {
      const { animation, channel } = animationData;
      animation.setTime(this.getTime(channel));
    }
  }
  play() {
    this.playing = true;
  }
  pause() {
    this.playing = false;
    this.lastEngineTime = -1;
  }
  reset() {
    this.setTime(0);
  }
  attachAnimation(animation, channelHandle) {
    const animationHandle = animationHandles++;
    this.animations.set(animationHandle, {
      animation,
      channel: channelHandle
    });
    animation.setTime(this.getTime(channelHandle));
    return animationHandle;
  }
  detachAnimation(channelId) {
    this.animations.delete(channelId);
  }
  update(engineTime) {
    if (this.playing) {
      if (this.lastEngineTime === -1) {
        this.lastEngineTime = engineTime;
      }
      this.setTime(this.time + (engineTime - this.lastEngineTime));
      this.lastEngineTime = engineTime;
    }
  }
  _setChannelTime(channel, time2) {
    const offsetTime = time2 - channel.delay;
    const totalDuration = channel.duration * channel.repeat;
    if (offsetTime >= totalDuration) {
      channel.time = channel.duration * channel.rate;
    } else {
      channel.time = Math.max(0, offsetTime) % channel.duration;
      channel.time *= channel.rate;
    }
  }
}
let statIdCounter = 0;
const DEFAULT_ANIMATION_LOOP_PROPS = {
  device: null,
  onAddHTML: () => "",
  onInitialize: async () => {
    return null;
  },
  onRender: () => {
  },
  onFinalize: () => {
  },
  onError: (error2) => console.error(error2),
  // eslint-disable-line no-console
  stats: luma.stats.get(`animation-loop-${statIdCounter++}`),
  // view parameters
  useDevicePixels: true,
  autoResizeViewport: false,
  autoResizeDrawingBuffer: false
};
class AnimationLoop {
  // _gpuTimeQuery: Query | null = null;
  /*
   * @param {HTMLCanvasElement} canvas - if provided, width and height will be passed to context
   */
  constructor(props) {
    __publicField2(this, "device", null);
    __publicField2(this, "canvas", null);
    __publicField2(this, "props");
    __publicField2(this, "animationProps", null);
    __publicField2(this, "timeline", null);
    __publicField2(this, "stats");
    __publicField2(this, "cpuTime");
    __publicField2(this, "gpuTime");
    __publicField2(this, "frameRate");
    __publicField2(this, "display");
    __publicField2(this, "needsRedraw", "initialized");
    __publicField2(this, "_initialized", false);
    __publicField2(this, "_running", false);
    __publicField2(this, "_animationFrameId", null);
    __publicField2(this, "_nextFramePromise", null);
    __publicField2(this, "_resolveNextFrame", null);
    __publicField2(this, "_cpuStartTime", 0);
    this.props = { ...DEFAULT_ANIMATION_LOOP_PROPS, ...props };
    props = this.props;
    if (!props.device) {
      throw new Error("No device provided");
    }
    const { useDevicePixels = true } = this.props;
    this.stats = props.stats || new Stats({ id: "animation-loop-stats" });
    this.cpuTime = this.stats.get("CPU Time");
    this.gpuTime = this.stats.get("GPU Time");
    this.frameRate = this.stats.get("Frame Rate");
    this.setProps({
      autoResizeViewport: props.autoResizeViewport,
      autoResizeDrawingBuffer: props.autoResizeDrawingBuffer,
      useDevicePixels
    });
    this.start = this.start.bind(this);
    this.stop = this.stop.bind(this);
    this._onMousemove = this._onMousemove.bind(this);
    this._onMouseleave = this._onMouseleave.bind(this);
  }
  destroy() {
    this.stop();
    this._setDisplay(null);
  }
  /** @deprecated Use .destroy() */
  delete() {
    this.destroy();
  }
  /** Flags this animation loop as needing redraw */
  setNeedsRedraw(reason) {
    this.needsRedraw = this.needsRedraw || reason;
    return this;
  }
  /** TODO - move these props to CanvasContext? */
  setProps(props) {
    if ("autoResizeViewport" in props) {
      this.props.autoResizeViewport = props.autoResizeViewport || false;
    }
    if ("autoResizeDrawingBuffer" in props) {
      this.props.autoResizeDrawingBuffer = props.autoResizeDrawingBuffer || false;
    }
    if ("useDevicePixels" in props) {
      this.props.useDevicePixels = props.useDevicePixels || false;
    }
    return this;
  }
  /** Starts a render loop if not already running */
  async start() {
    if (this._running) {
      return this;
    }
    this._running = true;
    try {
      let appContext;
      if (!this._initialized) {
        this._initialized = true;
        await this._initDevice();
        this._initialize();
        await this.props.onInitialize(this._getAnimationProps());
      }
      if (!this._running) {
        return null;
      }
      if (appContext !== false) {
        this._cancelAnimationFrame();
        this._requestAnimationFrame();
      }
      return this;
    } catch (err) {
      const error2 = err instanceof Error ? err : new Error("Unknown error");
      this.props.onError(error2);
      throw error2;
    }
  }
  /** Stops a render loop if already running, finalizing */
  stop() {
    if (this._running) {
      if (this.animationProps) {
        this.props.onFinalize(this.animationProps);
      }
      this._cancelAnimationFrame();
      this._nextFramePromise = null;
      this._resolveNextFrame = null;
      this._running = false;
    }
    return this;
  }
  /** Explicitly draw a frame */
  redraw() {
    var _a3;
    if ((_a3 = this.device) == null ? void 0 : _a3.isLost) {
      return this;
    }
    this._beginFrameTimers();
    this._setupFrame();
    this._updateAnimationProps();
    this._renderFrame(this._getAnimationProps());
    this._clearNeedsRedraw();
    if (this._resolveNextFrame) {
      this._resolveNextFrame(this);
      this._nextFramePromise = null;
      this._resolveNextFrame = null;
    }
    this._endFrameTimers();
    return this;
  }
  /** Add a timeline, it will be automatically updated by the animation loop. */
  attachTimeline(timeline) {
    this.timeline = timeline;
    return this.timeline;
  }
  /** Remove a timeline */
  detachTimeline() {
    this.timeline = null;
  }
  /** Wait until a render completes */
  waitForRender() {
    this.setNeedsRedraw("waitForRender");
    if (!this._nextFramePromise) {
      this._nextFramePromise = new Promise((resolve2) => {
        this._resolveNextFrame = resolve2;
      });
    }
    return this._nextFramePromise;
  }
  /** TODO - should use device.deviceContext */
  async toDataURL() {
    this.setNeedsRedraw("toDataURL");
    await this.waitForRender();
    if (this.canvas instanceof HTMLCanvasElement) {
      return this.canvas.toDataURL();
    }
    throw new Error("OffscreenCanvas");
  }
  // PRIVATE METHODS
  _initialize() {
    this._startEventHandling();
    this._initializeAnimationProps();
    this._updateAnimationProps();
    this._resizeCanvasDrawingBuffer();
    this._resizeViewport();
  }
  _setDisplay(display) {
    if (this.display) {
      this.display.destroy();
      this.display.animationLoop = null;
    }
    if (display) {
      display.animationLoop = this;
    }
    this.display = display;
  }
  _requestAnimationFrame() {
    if (!this._running) {
      return;
    }
    this._animationFrameId = requestAnimationFrame$1(this._animationFrame.bind(this));
  }
  _cancelAnimationFrame() {
    if (this._animationFrameId === null) {
      return;
    }
    cancelAnimationFrame$1(this._animationFrameId);
    this._animationFrameId = null;
  }
  _animationFrame() {
    if (!this._running) {
      return;
    }
    this.redraw();
    this._requestAnimationFrame();
  }
  // Called on each frame, can be overridden to call onRender multiple times
  // to support e.g. stereoscopic rendering
  _renderFrame(animationProps) {
    if (this.display) {
      this.display._renderFrame(animationProps);
      return;
    }
    this.props.onRender(this._getAnimationProps());
    this.device.submit();
  }
  _clearNeedsRedraw() {
    this.needsRedraw = false;
  }
  _setupFrame() {
    this._resizeCanvasDrawingBuffer();
    this._resizeViewport();
  }
  // Initialize the  object that will be passed to app callbacks
  _initializeAnimationProps() {
    var _a3, _b3;
    if (!this.device) {
      throw new Error("loop");
    }
    this.animationProps = {
      animationLoop: this,
      device: this.device,
      canvas: (_b3 = (_a3 = this.device) == null ? void 0 : _a3.canvasContext) == null ? void 0 : _b3.canvas,
      timeline: this.timeline,
      // Initial values
      useDevicePixels: this.props.useDevicePixels,
      needsRedraw: false,
      // Placeholders
      width: 1,
      height: 1,
      aspect: 1,
      // Animation props
      time: 0,
      startTime: Date.now(),
      engineTime: 0,
      tick: 0,
      tock: 0,
      // Experimental
      _mousePosition: null
      // Event props
    };
  }
  _getAnimationProps() {
    if (!this.animationProps) {
      throw new Error("animationProps");
    }
    return this.animationProps;
  }
  // Update the context object that will be passed to app callbacks
  _updateAnimationProps() {
    if (!this.animationProps) {
      return;
    }
    const { width, height, aspect: aspect2 } = this._getSizeAndAspect();
    if (width !== this.animationProps.width || height !== this.animationProps.height) {
      this.setNeedsRedraw("drawing buffer resized");
    }
    if (aspect2 !== this.animationProps.aspect) {
      this.setNeedsRedraw("drawing buffer aspect changed");
    }
    this.animationProps.width = width;
    this.animationProps.height = height;
    this.animationProps.aspect = aspect2;
    this.animationProps.needsRedraw = this.needsRedraw;
    this.animationProps.engineTime = Date.now() - this.animationProps.startTime;
    if (this.timeline) {
      this.timeline.update(this.animationProps.engineTime);
    }
    this.animationProps.tick = Math.floor(this.animationProps.time / 1e3 * 60);
    this.animationProps.tock++;
    this.animationProps.time = this.timeline ? this.timeline.getTime() : this.animationProps.engineTime;
  }
  /** Wait for supplied device */
  async _initDevice() {
    var _a3;
    this.device = await this.props.device;
    if (!this.device) {
      throw new Error("No device provided");
    }
    this.canvas = ((_a3 = this.device.canvasContext) == null ? void 0 : _a3.canvas) || null;
  }
  _createInfoDiv() {
    if (this.canvas && this.props.onAddHTML) {
      const wrapperDiv = document.createElement("div");
      document.body.appendChild(wrapperDiv);
      wrapperDiv.style.position = "relative";
      const div = document.createElement("div");
      div.style.position = "absolute";
      div.style.left = "10px";
      div.style.bottom = "10px";
      div.style.width = "300px";
      div.style.background = "white";
      if (this.canvas instanceof HTMLCanvasElement) {
        wrapperDiv.appendChild(this.canvas);
      }
      wrapperDiv.appendChild(div);
      const html = this.props.onAddHTML(div);
      if (html) {
        div.innerHTML = html;
      }
    }
  }
  _getSizeAndAspect() {
    var _a3, _b3, _c2, _d2;
    if (!this.device) {
      return { width: 1, height: 1, aspect: 1 };
    }
    const [width, height] = ((_b3 = (_a3 = this.device) == null ? void 0 : _a3.canvasContext) == null ? void 0 : _b3.getPixelSize()) || [1, 1];
    let aspect2 = 1;
    const canvas2 = (_d2 = (_c2 = this.device) == null ? void 0 : _c2.canvasContext) == null ? void 0 : _d2.canvas;
    if (canvas2 && canvas2.clientHeight) {
      aspect2 = canvas2.clientWidth / canvas2.clientHeight;
    } else if (width > 0 && height > 0) {
      aspect2 = width / height;
    }
    return { width, height, aspect: aspect2 };
  }
  /** Default viewport setup */
  _resizeViewport() {
    if (this.props.autoResizeViewport && this.device.gl) {
      this.device.gl.viewport(
        0,
        0,
        // @ts-expect-error Expose canvasContext
        this.device.gl.drawingBufferWidth,
        // @ts-expect-error Expose canvasContext
        this.device.gl.drawingBufferHeight
      );
    }
  }
  /**
   * Resize the render buffer of the canvas to match canvas client size
   * Optionally multiplying with devicePixel ratio
   */
  _resizeCanvasDrawingBuffer() {
    var _a3, _b3;
    if (this.props.autoResizeDrawingBuffer) {
      (_b3 = (_a3 = this.device) == null ? void 0 : _a3.canvasContext) == null ? void 0 : _b3.resize({ useDevicePixels: this.props.useDevicePixels });
    }
  }
  _beginFrameTimers() {
    this.frameRate.timeEnd();
    this.frameRate.timeStart();
    this.cpuTime.timeStart();
  }
  _endFrameTimers() {
    this.cpuTime.timeEnd();
  }
  // Event handling
  _startEventHandling() {
    if (this.canvas) {
      this.canvas.addEventListener("mousemove", this._onMousemove.bind(this));
      this.canvas.addEventListener("mouseleave", this._onMouseleave.bind(this));
    }
  }
  _onMousemove(event) {
    if (event instanceof MouseEvent) {
      this._getAnimationProps()._mousePosition = [event.offsetX, event.offsetY];
    }
  }
  _onMouseleave(event) {
    this._getAnimationProps()._mousePosition = null;
  }
}
class GPUGeometry {
  constructor(props) {
    __publicField2(this, "id");
    __publicField2(this, "userData", {});
    /** Determines how vertices are read from the 'vertex' attributes */
    __publicField2(this, "topology");
    __publicField2(this, "bufferLayout", []);
    __publicField2(this, "vertexCount");
    __publicField2(this, "indices");
    __publicField2(this, "attributes");
    this.id = props.id || uid("geometry");
    this.topology = props.topology;
    this.indices = props.indices || null;
    this.attributes = props.attributes;
    this.vertexCount = props.vertexCount;
    this.bufferLayout = props.bufferLayout || [];
    if (this.indices) {
      assert$a(this.indices.usage === Buffer$1.INDEX);
    }
  }
  destroy() {
    var _a3;
    (_a3 = this.indices) == null ? void 0 : _a3.destroy();
    for (const attribute of Object.values(this.attributes)) {
      attribute.destroy();
    }
  }
  getVertexCount() {
    return this.vertexCount;
  }
  getAttributes() {
    return this.attributes;
  }
  getIndexes() {
    return this.indices;
  }
  _calculateVertexCount(positions) {
    const vertexCount = positions.byteLength / 12;
    return vertexCount;
  }
}
function makeGPUGeometry(device, geometry2) {
  if (geometry2 instanceof GPUGeometry) {
    return geometry2;
  }
  const indices = getIndexBufferFromGeometry(device, geometry2);
  const { attributes, bufferLayout } = getAttributeBuffersFromGeometry(device, geometry2);
  return new GPUGeometry({
    topology: geometry2.topology || "triangle-list",
    bufferLayout,
    vertexCount: geometry2.vertexCount,
    indices,
    attributes
  });
}
function getIndexBufferFromGeometry(device, geometry2) {
  if (!geometry2.indices) {
    return void 0;
  }
  const data2 = geometry2.indices.value;
  return device.createBuffer({ usage: Buffer$1.INDEX, data: data2 });
}
function getAttributeBuffersFromGeometry(device, geometry2) {
  const bufferLayout = [];
  const attributes = {};
  for (const [attributeName, attribute] of Object.entries(geometry2.attributes)) {
    let name2 = attributeName;
    switch (attributeName) {
      case "POSITION":
        name2 = "positions";
        break;
      case "NORMAL":
        name2 = "normals";
        break;
      case "TEXCOORD_0":
        name2 = "texCoords";
        break;
      case "COLOR_0":
        name2 = "colors";
        break;
    }
    attributes[name2] = device.createBuffer({ data: attribute.value, id: `${attributeName}-buffer` });
    const { value, size: size12, normalized } = attribute;
    bufferLayout.push({ name: name2, format: getVertexFormatFromAttribute(value, size12, normalized) });
  }
  const vertexCount = geometry2._calculateVertexCount(geometry2.attributes, geometry2.indices);
  return { attributes, bufferLayout, vertexCount };
}
class ShaderInputs {
  /**
   * Create a new UniformStore instance
   * @param modules
   */
  constructor(modules) {
    /**
     * The map of modules
     * @todo should should this include the resolved dependencies?
     */
    __publicField2(this, "modules");
    /** Stores the uniform values for each module */
    __publicField2(this, "moduleUniforms");
    /** Stores the uniform bindings for each module  */
    __publicField2(this, "moduleBindings");
    /** Tracks if uniforms have changed */
    __publicField2(this, "moduleUniformsChanged");
    const resolvedModules = resolveModules(Object.values(modules).filter((module2) => module2.dependencies));
    for (const resolvedModule of resolvedModules) {
      modules[resolvedModule.name] = resolvedModule;
    }
    log.log(1, "Creating ShaderInputs with modules", Object.keys(modules))();
    this.modules = modules;
    this.moduleUniforms = {};
    this.moduleBindings = {};
    for (const [name2, module2] of Object.entries(modules)) {
      const moduleName = name2;
      this.moduleUniforms[moduleName] = module2.defaultUniforms || {};
      this.moduleBindings[moduleName] = {};
    }
  }
  /** Destroy */
  destroy() {
  }
  /**
   * Set module props
   */
  setProps(props) {
    var _a3;
    for (const name2 of Object.keys(props)) {
      const moduleName = name2;
      const moduleProps = props[moduleName];
      const module2 = this.modules[moduleName];
      if (!module2) {
        log.warn(`Module ${name2} not found`)();
        continue;
      }
      const oldUniforms = this.moduleUniforms[moduleName];
      const uniforms = ((_a3 = module2.getUniforms) == null ? void 0 : _a3.call(module2, moduleProps, this.moduleUniforms[moduleName])) || moduleProps;
      this.moduleUniforms[moduleName] = { ...oldUniforms, ...uniforms };
    }
  }
  /** Merges all bindings for the shader (from the various modules) */
  // getUniformBlocks(): Record<string, Texture | Sampler> {
  //   return this.moduleUniforms;
  // }
  /**
   * Return the map of modules
   * @todo should should this include the resolved dependencies?
   */
  getModules() {
    return Object.values(this.modules);
  }
  /** Get all uniform values for all modules */
  getUniformValues() {
    return this.moduleUniforms;
  }
  /** Merges all bindings for the shader (from the various modules) */
  getBindings() {
    const bindings = {};
    for (const moduleBindings of Object.values(this.moduleBindings)) {
      Object.assign(bindings, moduleBindings);
    }
    return bindings;
  }
  getDebugTable() {
    var _a3;
    const table = {};
    for (const [moduleName, module2] of Object.entries(this.moduleUniforms)) {
      for (const [key, value] of Object.entries(module2)) {
        table[`${moduleName}.${key}`] = {
          type: (_a3 = this.modules[moduleName].uniformTypes) == null ? void 0 : _a3[key],
          value: String(value)
        };
      }
    }
    return table;
  }
}
const _PipelineFactory = class {
  constructor(device) {
    __publicField2(this, "device");
    __publicField2(this, "_hashCounter", 0);
    __publicField2(this, "_hashes", {});
    __publicField2(this, "_renderPipelineCache", {});
    __publicField2(this, "_computePipelineCache", {});
    this.device = device;
  }
  /** Get the singleton default pipeline factory for the specified device */
  static getDefaultPipelineFactory(device) {
    device._lumaData.defaultPipelineFactory = device._lumaData.defaultPipelineFactory || new _PipelineFactory(device);
    return device._lumaData.defaultPipelineFactory;
  }
  /** Return a RenderPipeline matching props. Reuses a similar pipeline if already created. */
  createRenderPipeline(props) {
    const allProps = { ...RenderPipeline.defaultProps, ...props };
    const hash = this._hashRenderPipeline(allProps);
    if (!this._renderPipelineCache[hash]) {
      const pipeline = this.device.createRenderPipeline({
        ...allProps,
        id: allProps.id ? `${allProps.id}-cached` : void 0
      });
      pipeline.hash = hash;
      this._renderPipelineCache[hash] = { pipeline, useCount: 0 };
    }
    this._renderPipelineCache[hash].useCount++;
    return this._renderPipelineCache[hash].pipeline;
  }
  createComputePipeline(props) {
    const allProps = { ...ComputePipeline.defaultProps, ...props };
    const hash = this._hashComputePipeline(allProps);
    if (!this._computePipelineCache[hash]) {
      const pipeline = this.device.createComputePipeline({
        ...allProps,
        id: allProps.id ? `${allProps.id}-cached` : void 0
      });
      pipeline.hash = hash;
      this._computePipelineCache[hash] = { pipeline, useCount: 0 };
    }
    this._computePipelineCache[hash].useCount++;
    return this._computePipelineCache[hash].pipeline;
  }
  release(pipeline) {
    const hash = pipeline.hash;
    const cache2 = pipeline instanceof ComputePipeline ? this._computePipelineCache : this._renderPipelineCache;
    cache2[hash].useCount--;
    if (cache2[hash].useCount === 0) {
      cache2[hash].pipeline.destroy();
      delete cache2[hash];
    }
  }
  // PRIVATE
  _hashComputePipeline(props) {
    const shaderHash = this._getHash(props.shader.source);
    return `${shaderHash}`;
  }
  /** Calculate a hash based on all the inputs for a render pipeline */
  _hashRenderPipeline(props) {
    const vsHash = this._getHash(props.vs.source);
    const fsHash = props.fs ? this._getHash(props.fs.source) : 0;
    const varyingHash = "-";
    const bufferLayoutHash = this._getHash(JSON.stringify(props.bufferLayout));
    switch (this.device.type) {
      case "webgl":
        return `${vsHash}/${fsHash}V${varyingHash}BL${bufferLayoutHash}`;
      default:
        const parameterHash = this._getHash(JSON.stringify(props.parameters));
        return `${vsHash}/${fsHash}V${varyingHash}T${props.topology}P${parameterHash}BL${bufferLayoutHash}`;
    }
  }
  _getHash(key) {
    if (this._hashes[key] === void 0) {
      this._hashes[key] = this._hashCounter++;
    }
    return this._hashes[key];
  }
};
let PipelineFactory = _PipelineFactory;
__publicField2(PipelineFactory, "defaultProps", { ...RenderPipeline.defaultProps });
const _ShaderFactory = class {
  /** @internal */
  constructor(device) {
    __publicField2(this, "device");
    __publicField2(this, "_cache", {});
    this.device = device;
  }
  /** Returns the default ShaderFactory for the given {@link Device}, creating one if necessary. */
  static getDefaultShaderFactory(device) {
    var _a3;
    (_a3 = device._lumaData).defaultShaderFactory || (_a3.defaultShaderFactory = new _ShaderFactory(device));
    return device._lumaData.defaultShaderFactory;
  }
  /** Requests a {@link Shader} from the cache, creating a new Shader only if necessary. */
  createShader(props) {
    const key = this._hashShader(props);
    let cacheEntry = this._cache[key];
    if (!cacheEntry) {
      const shader = this.device.createShader({
        ...props,
        id: props.id ? `${props.id}-cached` : void 0
      });
      this._cache[key] = cacheEntry = { shader, useCount: 0 };
    }
    cacheEntry.useCount++;
    return cacheEntry.shader;
  }
  /** Releases a previously-requested {@link Shader}, destroying it if no users remain. */
  release(shader) {
    const key = this._hashShader(shader);
    const cacheEntry = this._cache[key];
    if (cacheEntry) {
      cacheEntry.useCount--;
      if (cacheEntry.useCount === 0) {
        delete this._cache[key];
        cacheEntry.shader.destroy();
      }
    }
  }
  // PRIVATE
  _hashShader(value) {
    return `${value.stage}:${value.source}`;
  }
};
let ShaderFactory = _ShaderFactory;
__publicField2(ShaderFactory, "defaultProps", { ...Shader.defaultProps });
function getDebugTableForShaderLayout(layout, name2) {
  var _a3;
  const table = {};
  const header = "Values";
  if (layout.attributes.length === 0 && !((_a3 = layout.varyings) == null ? void 0 : _a3.length)) {
    return { "No attributes or varyings": { [header]: "N/A" } };
  }
  for (const attributeDeclaration of layout.attributes) {
    if (attributeDeclaration) {
      const glslDeclaration = `${attributeDeclaration.location} ${attributeDeclaration.name}: ${attributeDeclaration.type}`;
      table[`in ${glslDeclaration}`] = { [header]: attributeDeclaration.stepMode || "vertex" };
    }
  }
  for (const varyingDeclaration of layout.varyings || []) {
    const glslDeclaration = `${varyingDeclaration.location} ${varyingDeclaration.name}`;
    table[`out ${glslDeclaration}`] = { [header]: JSON.stringify(varyingDeclaration.accessor) };
  }
  return table;
}
let canvas = null;
let ctx = null;
function debugFramebuffer(fbo, { id, minimap, opaque, top = "0", left = "0", rgbaScale = 1 }) {
  if (!canvas) {
    canvas = document.createElement("canvas");
    canvas.id = id;
    canvas.title = id;
    canvas.style.zIndex = "100";
    canvas.style.position = "absolute";
    canvas.style.top = top;
    canvas.style.left = left;
    canvas.style.border = "blue 1px solid";
    canvas.style.transform = "scaleY(-1)";
    document.body.appendChild(canvas);
    ctx = canvas.getContext("2d");
  }
  if (canvas.width !== fbo.width || canvas.height !== fbo.height) {
    canvas.width = fbo.width / 2;
    canvas.height = fbo.height / 2;
    canvas.style.width = "400px";
    canvas.style.height = "400px";
  }
  const color = fbo.device.readPixelsToArrayWebGL(fbo);
  const imageData = ctx.createImageData(fbo.width, fbo.height);
  const offset = 0;
  for (let i2 = 0; i2 < color.length; i2 += 4) {
    imageData.data[offset + i2 + 0] = color[i2 + 0] * rgbaScale;
    imageData.data[offset + i2 + 1] = color[i2 + 1] * rgbaScale;
    imageData.data[offset + i2 + 2] = color[i2 + 2] * rgbaScale;
    imageData.data[offset + i2 + 3] = opaque ? 255 : color[i2 + 3] * rgbaScale;
  }
  ctx.putImageData(imageData, 0, 0);
}
const LOG_DRAW_PRIORITY = 2;
const LOG_DRAW_TIMEOUT = 1e4;
const _Model = class {
  constructor(device, props) {
    __publicField2(this, "device");
    __publicField2(this, "id");
    __publicField2(this, "source");
    __publicField2(this, "vs");
    __publicField2(this, "fs");
    __publicField2(this, "pipelineFactory");
    __publicField2(this, "shaderFactory");
    __publicField2(this, "userData", {});
    // Fixed properties (change can trigger pipeline rebuild)
    /** The render pipeline GPU parameters, depth testing etc */
    __publicField2(this, "parameters");
    /** The primitive topology */
    __publicField2(this, "topology");
    /** Buffer layout */
    __publicField2(this, "bufferLayout");
    // Dynamic properties
    /** Use instanced rendering */
    __publicField2(this, "isInstanced");
    /** instance count. `undefined` means not instanced */
    __publicField2(this, "instanceCount", 0);
    /** Vertex count */
    __publicField2(this, "vertexCount");
    /** Index buffer */
    __publicField2(this, "indexBuffer", null);
    /** Buffer-valued attributes */
    __publicField2(this, "bufferAttributes", {});
    /** Constant-valued attributes */
    __publicField2(this, "constantAttributes", {});
    /** Bindings (textures, samplers, uniform buffers) */
    __publicField2(this, "bindings", {});
    /** Sets uniforms @deprecated Use uniform buffers and setBindings() for portability*/
    __publicField2(this, "uniforms", {});
    /**
     * VertexArray
     * @note not implemented: if bufferLayout is updated, vertex array has to be rebuilt!
     * @todo - allow application to define multiple vertex arrays?
     * */
    __publicField2(this, "vertexArray");
    /** TransformFeedback, WebGL 2 only. */
    __publicField2(this, "transformFeedback", null);
    /** The underlying GPU "program". @note May be recreated if parameters change */
    __publicField2(this, "pipeline");
    /** ShaderInputs instance */
    __publicField2(this, "shaderInputs");
    __publicField2(this, "_uniformStore");
    __publicField2(this, "_attributeInfos", {});
    __publicField2(this, "_gpuGeometry", null);
    __publicField2(this, "_getModuleUniforms");
    __publicField2(this, "props");
    __publicField2(this, "_pipelineNeedsUpdate", "newly created");
    __publicField2(this, "_needsRedraw", "initializing");
    __publicField2(this, "_destroyed", false);
    /** "Time" of last draw. Monotonically increasing timestamp */
    __publicField2(this, "_lastDrawTimestamp", -1);
    /** Throttle draw call logging */
    __publicField2(this, "_lastLogTime", 0);
    __publicField2(this, "_logOpen", false);
    __publicField2(this, "_drawCount", 0);
    var _a3, _b3, _c2, _d2;
    this.props = { ..._Model.defaultProps, ...props };
    props = this.props;
    this.id = props.id || uid("model");
    this.device = device;
    Object.assign(this.userData, props.userData);
    const moduleMap = Object.fromEntries(((_a3 = this.props.modules) == null ? void 0 : _a3.map((module2) => [module2.name, module2])) || []);
    this.setShaderInputs(props.shaderInputs || new ShaderInputs(moduleMap));
    const platformInfo = getPlatformInfo(device);
    const modules = (((_b3 = this.props.modules) == null ? void 0 : _b3.length) > 0 ? this.props.modules : (_c2 = this.shaderInputs) == null ? void 0 : _c2.getModules()) || [];
    const isWebGPU = this.device.type === "webgpu";
    if (isWebGPU && this.props.source) {
      (_d2 = this.props).shaderLayout || (_d2.shaderLayout = getShaderLayoutFromWGSL(this.props.source));
      const { source, getUniforms: getUniforms2 } = this.props.shaderAssembler.assembleShader({
        platformInfo,
        ...this.props,
        modules
      });
      this.source = source;
      this._getModuleUniforms = getUniforms2;
    } else {
      const { vs: vs2, fs: fs2, getUniforms: getUniforms2 } = this.props.shaderAssembler.assembleShaderPair({
        platformInfo,
        ...this.props,
        modules
      });
      this.vs = vs2;
      this.fs = fs2;
      this._getModuleUniforms = getUniforms2;
    }
    this.vertexCount = this.props.vertexCount;
    this.instanceCount = this.props.instanceCount;
    this.topology = this.props.topology;
    this.bufferLayout = this.props.bufferLayout;
    this.parameters = this.props.parameters;
    if (props.geometry) {
      this.setGeometry(props.geometry);
    }
    this.pipelineFactory = props.pipelineFactory || PipelineFactory.getDefaultPipelineFactory(this.device);
    this.shaderFactory = props.shaderFactory || ShaderFactory.getDefaultShaderFactory(this.device);
    this.pipeline = this._updatePipeline();
    this.vertexArray = device.createVertexArray({
      renderPipeline: this.pipeline
    });
    if (this._gpuGeometry) {
      this._setGeometryAttributes(this._gpuGeometry);
    }
    if ("isInstanced" in props) {
      this.isInstanced = props.isInstanced;
    }
    if (props.instanceCount) {
      this.setInstanceCount(props.instanceCount);
    }
    if (props.vertexCount) {
      this.setVertexCount(props.vertexCount);
    }
    if (props.indexBuffer) {
      this.setIndexBuffer(props.indexBuffer);
    }
    if (props.attributes) {
      this.setAttributes(props.attributes);
    }
    if (props.constantAttributes) {
      this.setConstantAttributes(props.constantAttributes);
    }
    if (props.bindings) {
      this.setBindings(props.bindings);
    }
    if (props.uniforms) {
      this.setUniforms(props.uniforms);
    }
    if (props.moduleSettings) {
      this.updateModuleSettings(props.moduleSettings);
    }
    if (props.transformFeedback) {
      this.transformFeedback = props.transformFeedback;
    }
    Object.seal(this);
  }
  destroy() {
    var _a3;
    if (this._destroyed)
      return;
    this.pipelineFactory.release(this.pipeline);
    this.shaderFactory.release(this.pipeline.vs);
    if (this.pipeline.fs) {
      this.shaderFactory.release(this.pipeline.fs);
    }
    this._uniformStore.destroy();
    (_a3 = this._gpuGeometry) == null ? void 0 : _a3.destroy();
    this._destroyed = true;
  }
  // Draw call
  /** Query redraw status. Clears the status. */
  needsRedraw() {
    if (this._getBindingsUpdateTimestamp() > this._lastDrawTimestamp) {
      this.setNeedsRedraw("contents of bound textures or buffers updated");
    }
    const needsRedraw = this._needsRedraw;
    this._needsRedraw = false;
    return needsRedraw;
  }
  /** Mark the model as needing a redraw */
  setNeedsRedraw(reason) {
    this._needsRedraw || (this._needsRedraw = reason);
  }
  predraw() {
    this.updateShaderInputs();
    this.pipeline = this._updatePipeline();
  }
  draw(renderPass) {
    this.predraw();
    let drawSuccess;
    try {
      this._logDrawCallStart();
      this.pipeline = this._updatePipeline();
      this.pipeline.setBindings(this.bindings, { disableWarnings: this.props.disableWarnings });
      if (!isObjectEmpty$3(this.uniforms)) {
        this.pipeline.setUniformsWebGL(this.uniforms);
      }
      const { indexBuffer } = this.vertexArray;
      const indexCount = indexBuffer ? indexBuffer.byteLength / (indexBuffer.indexType === "uint32" ? 4 : 2) : void 0;
      drawSuccess = this.pipeline.draw({
        renderPass,
        vertexArray: this.vertexArray,
        isInstanced: this.isInstanced,
        vertexCount: this.vertexCount,
        instanceCount: this.instanceCount,
        indexCount,
        transformFeedback: this.transformFeedback || void 0,
        // WebGL shares underlying cached pipelines even for models that have different parameters and topology,
        // so we must provide our unique parameters to each draw
        // (In WebGPU most parameters are encoded in the pipeline and cannot be changed per draw call)
        parameters: this.parameters,
        topology: this.topology
      });
    } finally {
      this._logDrawCallEnd();
    }
    this._logFramebuffer(renderPass);
    if (drawSuccess) {
      this._lastDrawTimestamp = this.device.timestamp;
      this._needsRedraw = false;
    } else {
      this._needsRedraw = "waiting for resource initialization";
    }
    return drawSuccess;
  }
  // Update fixed fields (can trigger pipeline rebuild)
  /**
   * Updates the optional geometry
   * Geometry, set topology and bufferLayout
   * @note Can trigger a pipeline rebuild / pipeline cache fetch on WebGPU
   */
  setGeometry(geometry2) {
    var _a3;
    (_a3 = this._gpuGeometry) == null ? void 0 : _a3.destroy();
    const gpuGeometry = geometry2 && makeGPUGeometry(this.device, geometry2);
    if (gpuGeometry) {
      this.setTopology(gpuGeometry.topology || "triangle-list");
      this.bufferLayout = mergeBufferLayouts(gpuGeometry.bufferLayout, this.bufferLayout);
      if (this.vertexArray) {
        this._setGeometryAttributes(gpuGeometry);
      }
    }
    this._gpuGeometry = gpuGeometry;
  }
  /**
   * Updates the primitive topology ('triangle-list', 'triangle-strip' etc).
   * @note Triggers a pipeline rebuild / pipeline cache fetch on WebGPU
   */
  setTopology(topology) {
    if (topology !== this.topology) {
      this.topology = topology;
      this._setPipelineNeedsUpdate("topology");
    }
  }
  /**
   * Updates the buffer layout.
   * @note Triggers a pipeline rebuild / pipeline cache fetch
   */
  setBufferLayout(bufferLayout) {
    this.bufferLayout = this._gpuGeometry ? mergeBufferLayouts(bufferLayout, this._gpuGeometry.bufferLayout) : bufferLayout;
    this._setPipelineNeedsUpdate("bufferLayout");
    this.pipeline = this._updatePipeline();
    this.vertexArray = this.device.createVertexArray({
      renderPipeline: this.pipeline
    });
    if (this._gpuGeometry) {
      this._setGeometryAttributes(this._gpuGeometry);
    }
  }
  /**
   * Set GPU parameters.
   * @note Can trigger a pipeline rebuild / pipeline cache fetch.
   * @param parameters
   */
  setParameters(parameters) {
    if (!deepEqual$1(parameters, this.parameters, 2)) {
      this.parameters = parameters;
      this._setPipelineNeedsUpdate("parameters");
    }
  }
  // Update dynamic fields
  /**
   * Updates the instance count (used in draw calls)
   * @note Any attributes with stepMode=instance need to be at least this big
   */
  setInstanceCount(instanceCount) {
    this.instanceCount = instanceCount;
    if (this.isInstanced === void 0 && instanceCount > 0) {
      this.isInstanced = true;
    }
    this.setNeedsRedraw("instanceCount");
  }
  /**
   * Updates the vertex count (used in draw calls)
   * @note Any attributes with stepMode=vertex need to be at least this big
   */
  setVertexCount(vertexCount) {
    this.vertexCount = vertexCount;
    this.setNeedsRedraw("vertexCount");
  }
  /** Set the shader inputs */
  setShaderInputs(shaderInputs) {
    this.shaderInputs = shaderInputs;
    this._uniformStore = new UniformStore(this.shaderInputs.modules);
    for (const moduleName of Object.keys(this.shaderInputs.modules)) {
      const uniformBuffer = this._uniformStore.getManagedUniformBuffer(this.device, moduleName);
      this.bindings[`${moduleName}Uniforms`] = uniformBuffer;
    }
    this.setNeedsRedraw("shaderInputs");
  }
  /** Update uniform buffers from the model's shader inputs */
  updateShaderInputs() {
    this._uniformStore.setUniforms(this.shaderInputs.getUniformValues());
    this.setNeedsRedraw("shaderInputs");
  }
  /**
   * Sets bindings (textures, samplers, uniform buffers)
   */
  setBindings(bindings) {
    Object.assign(this.bindings, bindings);
    this.setNeedsRedraw("bindings");
  }
  /**
   * Updates optional transform feedback. WebGL only.
   */
  setTransformFeedback(transformFeedback) {
    this.transformFeedback = transformFeedback;
    this.setNeedsRedraw("transformFeedback");
  }
  /**
   * Sets the index buffer
   * @todo - how to unset it if we change geometry?
   */
  setIndexBuffer(indexBuffer) {
    this.vertexArray.setIndexBuffer(indexBuffer);
    this.setNeedsRedraw("indexBuffer");
  }
  /**
   * Sets attributes (buffers)
   * @note Overrides any attributes previously set with the same name
   */
  setAttributes(buffers, options2) {
    if (buffers.indices) {
      log.warn(`Model:${this.id} setAttributes() - indexBuffer should be set using setIndexBuffer()`)();
    }
    for (const [bufferName, buffer3] of Object.entries(buffers)) {
      const bufferLayout = this.bufferLayout.find((layout) => getAttributeNames(layout).includes(bufferName));
      if (!bufferLayout) {
        log.warn(`Model(${this.id}): Missing layout for buffer "${bufferName}".`)();
        continue;
      }
      const attributeNames = getAttributeNames(bufferLayout);
      let set = false;
      for (const attributeName of attributeNames) {
        const attributeInfo = this._attributeInfos[attributeName];
        if (attributeInfo) {
          this.vertexArray.setBuffer(attributeInfo.location, buffer3);
          set = true;
        }
      }
      if (!set && !((options2 == null ? void 0 : options2.disableWarnings) ?? this.props.disableWarnings)) {
        log.warn(`Model(${this.id}): Ignoring buffer "${buffer3.id}" for unknown attribute "${bufferName}"`)();
      }
    }
    this.setNeedsRedraw("attributes");
  }
  /**
   * Sets constant attributes
   * @note Overrides any attributes previously set with the same name
   * Constant attributes are only supported in WebGL, not in WebGPU
   * Any attribute that is disabled in the current vertex array object
   * is read from the context's global constant value for that attribute location.
   * @param constantAttributes
   */
  setConstantAttributes(attributes, options2) {
    for (const [attributeName, value] of Object.entries(attributes)) {
      const attributeInfo = this._attributeInfos[attributeName];
      if (attributeInfo) {
        this.vertexArray.setConstantWebGL(attributeInfo.location, value);
      } else if (!((options2 == null ? void 0 : options2.disableWarnings) ?? this.props.disableWarnings)) {
        log.warn(`Model "${this.id}: Ignoring constant supplied for unknown attribute "${attributeName}"`)();
      }
    }
    this.setNeedsRedraw("constants");
  }
  // DEPRECATED METHODS
  /**
   * Sets individual uniforms
   * @deprecated WebGL only, use uniform buffers for portability
   * @param uniforms
   */
  setUniforms(uniforms) {
    if (!isObjectEmpty$3(uniforms)) {
      this.pipeline.setUniformsWebGL(uniforms);
      Object.assign(this.uniforms, uniforms);
    }
    this.setNeedsRedraw("uniforms");
  }
  /**
   * @deprecated Updates shader module settings (which results in uniforms being set)
   */
  updateModuleSettings(props) {
    const { bindings, uniforms } = splitUniformsAndBindings(this._getModuleUniforms(props));
    Object.assign(this.bindings, bindings);
    Object.assign(this.uniforms, uniforms);
    this.setNeedsRedraw("moduleSettings");
  }
  // Internal methods
  /** Get the timestamp of the latest updated bound GPU memory resource (buffer/texture). */
  _getBindingsUpdateTimestamp() {
    let timestamp2 = 0;
    for (const binding of Object.values(this.bindings)) {
      if (binding instanceof TextureView) {
        timestamp2 = Math.max(timestamp2, binding.texture.updateTimestamp);
      } else if (binding instanceof Buffer$1 || binding instanceof Texture) {
        timestamp2 = Math.max(timestamp2, binding.updateTimestamp);
      } else if (!(binding instanceof Sampler)) {
        timestamp2 = Math.max(timestamp2, binding.buffer.updateTimestamp);
      }
    }
    return timestamp2;
  }
  /**
   * Updates the optional geometry attributes
   * Geometry, sets several attributes, indexBuffer, and also vertex count
   * @note Can trigger a pipeline rebuild / pipeline cache fetch on WebGPU
   */
  _setGeometryAttributes(gpuGeometry) {
    const attributes = { ...gpuGeometry.attributes };
    for (const [attributeName] of Object.entries(attributes)) {
      if (!this.pipeline.shaderLayout.attributes.find((layout) => layout.name === attributeName) && attributeName !== "positions") {
        delete attributes[attributeName];
      }
    }
    this.vertexCount = gpuGeometry.vertexCount;
    this.setIndexBuffer(gpuGeometry.indices || null);
    this.setAttributes(gpuGeometry.attributes, { disableWarnings: true });
    this.setAttributes(attributes, { disableWarnings: this.props.disableWarnings });
    this.setNeedsRedraw("geometry attributes");
  }
  /** Mark pipeline as needing update */
  _setPipelineNeedsUpdate(reason) {
    this._pipelineNeedsUpdate || (this._pipelineNeedsUpdate = reason);
    this.setNeedsRedraw(reason);
  }
  /** Update pipeline if needed */
  _updatePipeline() {
    if (this._pipelineNeedsUpdate) {
      let prevShaderVs = null;
      let prevShaderFs = null;
      if (this.pipeline) {
        log.log(1, `Model ${this.id}: Recreating pipeline because "${this._pipelineNeedsUpdate}".`)();
        prevShaderVs = this.pipeline.vs;
        prevShaderFs = this.pipeline.fs;
      }
      this._pipelineNeedsUpdate = false;
      const vs2 = this.shaderFactory.createShader({
        id: `${this.id}-vertex`,
        stage: "vertex",
        source: this.source || this.vs,
        debug: this.props.debugShaders
      });
      let fs2 = null;
      if (this.source) {
        fs2 = vs2;
      } else if (this.fs) {
        fs2 = this.shaderFactory.createShader({
          id: `${this.id}-fragment`,
          stage: "fragment",
          source: this.source || this.fs,
          debug: this.props.debugShaders
        });
      }
      this.pipeline = this.pipelineFactory.createRenderPipeline({
        ...this.props,
        bufferLayout: this.bufferLayout,
        topology: this.topology,
        parameters: this.parameters,
        vs: vs2,
        fs: fs2
      });
      this._attributeInfos = getAttributeInfosFromLayouts(this.pipeline.shaderLayout, this.bufferLayout);
      if (prevShaderVs)
        this.shaderFactory.release(prevShaderVs);
      if (prevShaderFs)
        this.shaderFactory.release(prevShaderFs);
    }
    return this.pipeline;
  }
  _logDrawCallStart() {
    const logDrawTimeout = log.level > 3 ? 0 : LOG_DRAW_TIMEOUT;
    if (log.level < 2 || Date.now() - this._lastLogTime < logDrawTimeout) {
      return;
    }
    this._lastLogTime = Date.now();
    this._logOpen = true;
    log.group(LOG_DRAW_PRIORITY, `>>> DRAWING MODEL ${this.id}`, { collapsed: log.level <= 2 })();
  }
  _logDrawCallEnd() {
    if (this._logOpen) {
      const shaderLayoutTable = getDebugTableForShaderLayout(this.pipeline.shaderLayout, this.id);
      log.table(LOG_DRAW_PRIORITY, shaderLayoutTable)();
      const uniformTable = this.shaderInputs.getDebugTable();
      for (const [name2, value] of Object.entries(this.uniforms)) {
        uniformTable[name2] = { value };
      }
      log.table(LOG_DRAW_PRIORITY, uniformTable)();
      const attributeTable = this._getAttributeDebugTable();
      log.table(LOG_DRAW_PRIORITY, this._attributeInfos)();
      log.table(LOG_DRAW_PRIORITY, attributeTable)();
      log.groupEnd(LOG_DRAW_PRIORITY)();
      this._logOpen = false;
    }
  }
  _logFramebuffer(renderPass) {
    const debugFramebuffers = log.get("framebuffer");
    this._drawCount++;
    if (!debugFramebuffers || this._drawCount++ > 3 && this._drawCount % 60) {
      return;
    }
    const framebuffer = renderPass.props.framebuffer;
    if (framebuffer) {
      debugFramebuffer(framebuffer, { id: framebuffer.id, minimap: true });
    }
  }
  _getAttributeDebugTable() {
    const table = {};
    for (const [name2, attributeInfo] of Object.entries(this._attributeInfos)) {
      table[attributeInfo.location] = {
        name: name2,
        type: attributeInfo.shaderType,
        values: this._getBufferOrConstantValues(this.vertexArray.attributes[attributeInfo.location], attributeInfo.bufferDataType)
      };
    }
    if (this.vertexArray.indexBuffer) {
      const { indexBuffer } = this.vertexArray;
      const values4 = indexBuffer.indexType === "uint32" ? new Uint32Array(indexBuffer.debugData) : new Uint16Array(indexBuffer.debugData);
      table.indices = {
        name: "indices",
        type: indexBuffer.indexType,
        values: values4.toString()
      };
    }
    return table;
  }
  // TODO - fix typing of luma data types
  _getBufferOrConstantValues(attribute, dataType) {
    const TypedArrayConstructor = getTypedArrayFromDataType(dataType);
    const typedArray = attribute instanceof Buffer$1 ? new TypedArrayConstructor(attribute.debugData) : attribute;
    return typedArray.toString();
  }
};
let Model = _Model;
__publicField2(Model, "defaultProps", {
  ...RenderPipeline.defaultProps,
  source: null,
  vs: null,
  fs: null,
  id: "unnamed",
  handle: void 0,
  userData: {},
  defines: {},
  modules: [],
  moduleSettings: void 0,
  geometry: null,
  indexBuffer: null,
  attributes: {},
  constantAttributes: {},
  varyings: [],
  isInstanced: void 0,
  instanceCount: 0,
  vertexCount: 0,
  shaderInputs: void 0,
  pipelineFactory: void 0,
  shaderFactory: void 0,
  transformFeedback: void 0,
  shaderAssembler: ShaderAssembler.getDefaultShaderAssembler(),
  debugShaders: void 0,
  disableWarnings: void 0
});
function mergeBufferLayouts(layouts1, layouts2) {
  const layouts = [...layouts1];
  for (const attribute of layouts2) {
    const index2 = layouts.findIndex((attribute2) => attribute2.name === attribute.name);
    if (index2 < 0) {
      layouts.push(attribute);
    } else {
      layouts[index2] = attribute;
    }
  }
  return layouts;
}
function getPlatformInfo(device) {
  return {
    type: device.type,
    shaderLanguage: device.info.shadingLanguage,
    shaderLanguageVersion: device.info.shadingLanguageVersion,
    gpu: device.info.gpu,
    // HACK - we pretend that the DeviceFeatures is a Set, it has a similar API
    features: device.features
  };
}
function getAttributeNames(bufferLayout) {
  var _a3;
  return bufferLayout.attributes ? (_a3 = bufferLayout.attributes) == null ? void 0 : _a3.map((layout) => layout.attribute) : [bufferLayout.name];
}
class BufferTransform {
  constructor(device, props = Model.defaultProps) {
    __publicField2(this, "device");
    __publicField2(this, "model");
    __publicField2(this, "transformFeedback");
    assert$a(BufferTransform.isSupported(device), "BufferTransform not yet implemented on WebGPU");
    this.device = device;
    this.model = new Model(this.device, {
      id: props.id || "buffer-transform-model",
      fs: props.fs || getPassthroughFS(),
      topology: props.topology || "point-list",
      ...props
    });
    this.transformFeedback = this.device.createTransformFeedback({
      layout: this.model.pipeline.shaderLayout,
      buffers: props.feedbackBuffers
    });
    this.model.setTransformFeedback(this.transformFeedback);
    Object.seal(this);
  }
  /** @deprecated Use device feature test. */
  static isSupported(device) {
    var _a3;
    return ((_a3 = device == null ? void 0 : device.info) == null ? void 0 : _a3.type) === "webgl";
  }
  /** Destroy owned resources. */
  destroy() {
    if (this.model) {
      this.model.destroy();
    }
  }
  /** @deprecated Use {@link destroy}. */
  delete() {
    this.destroy();
  }
  /** Run one transform loop. */
  run(options2) {
    const renderPass = this.device.beginRenderPass(options2);
    this.model.draw(renderPass);
    renderPass.end();
  }
  /** @deprecated */
  update(...args) {
    console.warn("TextureTransform#update() not implemented");
  }
  /** Returns the {@link Buffer} or {@link BufferRange} for given varying name. */
  getBuffer(varyingName) {
    return this.transformFeedback.getBuffer(varyingName);
  }
  readAsync(varyingName) {
    const result = this.getBuffer(varyingName);
    if (result instanceof Buffer$1) {
      return result.readAsync();
    }
    const { buffer: buffer3, byteOffset = 0, byteLength = buffer3.byteLength } = result;
    return buffer3.readAsync(byteOffset, byteLength);
  }
}
const FS_OUTPUT_VARIABLE = "transform_output";
class TextureTransform {
  // resources to be deleted
  constructor(device, props) {
    __publicField2(this, "device");
    __publicField2(this, "model");
    __publicField2(this, "sampler");
    __publicField2(this, "currentIndex", 0);
    __publicField2(this, "samplerTextureMap", null);
    __publicField2(this, "bindings", []);
    // each element is an object : {sourceTextures, targetTexture, framebuffer}
    __publicField2(this, "resources", {});
    this.device = device;
    this.sampler = device.createSampler({
      addressModeU: "clamp-to-edge",
      addressModeV: "clamp-to-edge",
      minFilter: "nearest",
      magFilter: "nearest",
      mipmapFilter: "nearest"
    });
    this.model = new Model(this.device, {
      id: props.id || "texture-transform-model",
      fs: props.fs || getPassthroughFS({
        input: props.targetTextureVarying,
        inputChannels: props.targetTextureChannels,
        output: FS_OUTPUT_VARIABLE
      }),
      vertexCount: props.vertexCount,
      // TODO(donmccurdy): Naming?
      ...props
    });
    this._initialize(props);
    Object.seal(this);
  }
  // Delete owned resources.
  destroy() {
  }
  /** @deprecated Use {@link destroy}. */
  delete() {
    this.destroy();
  }
  run(options2) {
    const { framebuffer } = this.bindings[this.currentIndex];
    const renderPass = this.device.beginRenderPass({ framebuffer, ...options2 });
    this.model.draw(renderPass);
    renderPass.end();
  }
  /** @deprecated */
  update(...args) {
    console.warn("TextureTransform#update() not implemented");
  }
  getData({ packed = false } = {}) {
    throw new Error("getData() not implemented");
  }
  getTargetTexture() {
    const { targetTexture } = this.bindings[this.currentIndex];
    return targetTexture;
  }
  getFramebuffer() {
    const currentResources = this.bindings[this.currentIndex];
    return currentResources.framebuffer;
  }
  // Private
  _initialize(props) {
    this._updateBindings(props);
  }
  _updateBindings(props) {
    this.bindings[this.currentIndex] = this._updateBinding(this.bindings[this.currentIndex], props);
  }
  _updateBinding(binding, { sourceBuffers, sourceTextures, targetTexture }) {
    if (!binding) {
      binding = {
        sourceBuffers: {},
        sourceTextures: {},
        targetTexture: null
      };
    }
    Object.assign(binding.sourceTextures, sourceTextures);
    Object.assign(binding.sourceBuffers, sourceBuffers);
    if (targetTexture) {
      binding.targetTexture = targetTexture;
      const { width, height } = targetTexture;
      if (binding.framebuffer) {
        binding.framebuffer.destroy();
      }
      binding.framebuffer = this.device.createFramebuffer({
        id: "transform-framebuffer",
        width,
        height,
        colorAttachments: [targetTexture]
      });
      binding.framebuffer.resize({ width, height });
    }
    return binding;
  }
  // set texture filtering parameters on source textures.
  _setSourceTextureParameters() {
    const index2 = this.currentIndex;
    const { sourceTextures } = this.bindings[index2];
    for (const name2 in sourceTextures) {
      sourceTextures[name2].sampler = this.sampler;
    }
  }
}
class Geometry {
  constructor(props) {
    __publicField2(this, "id");
    /** Determines how vertices are read from the 'vertex' attributes */
    __publicField2(this, "topology");
    __publicField2(this, "vertexCount");
    __publicField2(this, "indices");
    __publicField2(this, "attributes");
    __publicField2(this, "userData", {});
    const { attributes = {}, indices = null, vertexCount = null } = props;
    this.id = props.id || uid("geometry");
    this.topology = props.topology;
    if (indices) {
      this.indices = ArrayBuffer.isView(indices) ? { value: indices, size: 1 } : indices;
    }
    this.attributes = {};
    for (const [attributeName, attributeValue] of Object.entries(attributes)) {
      const attribute = ArrayBuffer.isView(attributeValue) ? { value: attributeValue } : attributeValue;
      assert$a(ArrayBuffer.isView(attribute.value), `${this._print(attributeName)}: must be typed array or object with value as typed array`);
      if ((attributeName === "POSITION" || attributeName === "positions") && !attribute.size) {
        attribute.size = 3;
      }
      if (attributeName === "indices") {
        assert$a(!this.indices);
        this.indices = attribute;
      } else {
        this.attributes[attributeName] = attribute;
      }
    }
    if (this.indices && this.indices.isIndexed !== void 0) {
      this.indices = Object.assign({}, this.indices);
      delete this.indices.isIndexed;
    }
    this.vertexCount = vertexCount || this._calculateVertexCount(this.attributes, this.indices);
  }
  getVertexCount() {
    return this.vertexCount;
  }
  /**
   * Return an object with all attributes plus indices added as a field.
   * TODO Geometry types are a mess
   */
  getAttributes() {
    return this.indices ? { indices: this.indices, ...this.attributes } : this.attributes;
  }
  // PRIVATE
  _print(attributeName) {
    return `Geometry ${this.id} attribute ${attributeName}`;
  }
  /**
   * GeometryAttribute
   * value: typed array
   * type: indices, vertices, uvs
   * size: elements per vertex
   * target: WebGL buffer type (string or constant)
   *
   * @param attributes
   * @param indices
   * @returns
   */
  _setAttributes(attributes, indices) {
    return this;
  }
  _calculateVertexCount(attributes, indices) {
    if (indices) {
      return indices.value.length;
    }
    let vertexCount = Infinity;
    for (const attribute of Object.values(attributes)) {
      const { value, size: size12, constant: constant2 } = attribute;
      if (!constant2 && value && size12 >= 1) {
        vertexCount = Math.min(vertexCount, value.length / size12);
      }
    }
    assert$a(Number.isFinite(vertexCount));
    return vertexCount;
  }
}
class ScenegraphNode {
  constructor(props = {}) {
    __publicField2(this, "id");
    __publicField2(this, "matrix", new Matrix4());
    __publicField2(this, "display", true);
    __publicField2(this, "position", new Vector3());
    __publicField2(this, "rotation", new Vector3());
    __publicField2(this, "scale", new Vector3(1, 1, 1));
    __publicField2(this, "userData", {});
    __publicField2(this, "props", {});
    const { id } = props;
    this.id = id || uid(this.constructor.name);
    this._setScenegraphNodeProps(props);
  }
  getBounds() {
    return null;
  }
  destroy() {
  }
  /** @deprecated use .destroy() */
  delete() {
    this.destroy();
  }
  setProps(props) {
    this._setScenegraphNodeProps(props);
    return this;
  }
  toString() {
    return `{type: ScenegraphNode, id: ${this.id})}`;
  }
  setPosition(position) {
    assert$a(position.length === 3, "setPosition requires vector argument");
    this.position = position;
    return this;
  }
  setRotation(rotation) {
    assert$a(rotation.length === 3, "setRotation requires vector argument");
    this.rotation = rotation;
    return this;
  }
  setScale(scale5) {
    assert$a(scale5.length === 3, "setScale requires vector argument");
    this.scale = scale5;
    return this;
  }
  setMatrix(matrix, copyMatrix = true) {
    if (copyMatrix) {
      this.matrix.copy(matrix);
    } else {
      this.matrix = matrix;
    }
  }
  setMatrixComponents(components) {
    const { position, rotation, scale: scale5, update = true } = components;
    if (position) {
      this.setPosition(position);
    }
    if (rotation) {
      this.setRotation(rotation);
    }
    if (scale5) {
      this.setScale(scale5);
    }
    if (update) {
      this.updateMatrix();
    }
    return this;
  }
  updateMatrix() {
    const pos = this.position;
    const rot = this.rotation;
    const scale5 = this.scale;
    this.matrix.identity();
    this.matrix.translate(pos);
    this.matrix.rotateXYZ(rot);
    this.matrix.scale(scale5);
    return this;
  }
  update(options2 = {}) {
    const { position, rotation, scale: scale5 } = options2;
    if (position) {
      this.setPosition(position);
    }
    if (rotation) {
      this.setRotation(rotation);
    }
    if (scale5) {
      this.setScale(scale5);
    }
    this.updateMatrix();
    return this;
  }
  getCoordinateUniforms(viewMatrix, modelMatrix2) {
    assert$a(viewMatrix);
    modelMatrix2 = modelMatrix2 || this.matrix;
    const worldMatrix = new Matrix4(viewMatrix).multiplyRight(modelMatrix2);
    const worldInverse = worldMatrix.invert();
    const worldInverseTranspose = worldInverse.transpose();
    return {
      viewMatrix,
      modelMatrix: modelMatrix2,
      objectMatrix: modelMatrix2,
      worldMatrix,
      worldInverseMatrix: worldInverse,
      worldInverseTransposeMatrix: worldInverseTranspose
    };
  }
  // TODO - copied code, not yet vetted
  /*
    transform() {
      if (!this.parent) {
        this.endPosition.set(this.position);
        this.endRotation.set(this.rotation);
        this.endScale.set(this.scale);
      } else {
        const parent = this.parent;
        this.endPosition.set(this.position.add(parent.endPosition));
        this.endRotation.set(this.rotation.add(parent.endRotation));
        this.endScale.set(this.scale.add(parent.endScale));
      }
  
      const ch = this.children;
      for (let i = 0; i < ch.length; ++i) {
        ch[i].transform();
      }
  
      return this;
    }
    */
  _setScenegraphNodeProps(props) {
    if ("display" in props) {
      this.display = props.display;
    }
    if ("position" in props) {
      this.setPosition(props.position);
    }
    if ("rotation" in props) {
      this.setRotation(props.rotation);
    }
    if ("scale" in props) {
      this.setScale(props.scale);
    }
    if ("matrix" in props) {
      this.setMatrix(props.matrix);
    }
    Object.assign(this.props, props);
  }
}
class GroupNode extends ScenegraphNode {
  constructor(props = {}) {
    props = Array.isArray(props) ? { children: props } : props;
    const { children = [] } = props;
    log.assert(children.every((child) => child instanceof ScenegraphNode), "every child must an instance of ScenegraphNode");
    super(props);
    __publicField2(this, "children");
    this.children = children;
  }
  getBounds() {
    const result = [
      [Infinity, Infinity, Infinity],
      [-Infinity, -Infinity, -Infinity]
    ];
    this.traverse((node, { worldMatrix }) => {
      const bounds = node.getBounds();
      if (!bounds) {
        return;
      }
      const [min4, max3] = bounds;
      const center2 = new Vector3(min4).add(max3).divide([2, 2, 2]);
      worldMatrix.transformAsPoint(center2, center2);
      const halfSize = new Vector3(max3).subtract(min4).divide([2, 2, 2]);
      worldMatrix.transformAsVector(halfSize, halfSize);
      for (let v5 = 0; v5 < 8; v5++) {
        const position = new Vector3(v5 & 1 ? -1 : 1, v5 & 2 ? -1 : 1, v5 & 4 ? -1 : 1).multiply(halfSize).add(center2);
        for (let i2 = 0; i2 < 3; i2++) {
          result[0][i2] = Math.min(result[0][i2], position[i2]);
          result[1][i2] = Math.max(result[1][i2], position[i2]);
        }
      }
    });
    if (!Number.isFinite(result[0][0])) {
      return null;
    }
    return result;
  }
  destroy() {
    this.children.forEach((child) => child.destroy());
    this.removeAll();
    super.destroy();
  }
  // Unpacks arrays and nested arrays of children
  add(...children) {
    for (const child of children) {
      if (Array.isArray(child)) {
        this.add(...child);
      } else {
        this.children.push(child);
      }
    }
    return this;
  }
  remove(child) {
    const children = this.children;
    const indexOf2 = children.indexOf(child);
    if (indexOf2 > -1) {
      children.splice(indexOf2, 1);
    }
    return this;
  }
  removeAll() {
    this.children = [];
    return this;
  }
  traverse(visitor, { worldMatrix = new Matrix4() } = {}) {
    const modelMatrix2 = new Matrix4(worldMatrix).multiplyRight(this.matrix);
    for (const child of this.children) {
      if (child instanceof GroupNode) {
        child.traverse(visitor, { worldMatrix: modelMatrix2 });
      } else {
        visitor(child, { worldMatrix: modelMatrix2 });
      }
    }
  }
}
class ModelNode extends ScenegraphNode {
  // TODO - is this used? override callbacks to make sure we call them with this
  // onBeforeRender = null;
  // onAfterRender = null;
  // AfterRender = null;
  constructor(props) {
    super(props);
    __publicField2(this, "model");
    __publicField2(this, "bounds", null);
    __publicField2(this, "managedResources");
    this.model = props.model;
    this.managedResources = props.managedResources || [];
    this.bounds = props.bounds || null;
    this.setProps(props);
  }
  getBounds() {
    return this.bounds;
  }
  destroy() {
    if (this.model) {
      this.model.destroy();
      this.model = null;
    }
    this.managedResources.forEach((resource) => resource.destroy());
    this.managedResources = [];
  }
  // Expose model methods
  draw(renderPass) {
    return this.model.draw(renderPass);
  }
}
const PICKING_BLENDING = {
  blendColorOperation: "add",
  blendColorSrcFactor: "one",
  blendColorDstFactor: "zero",
  blendAlphaOperation: "add",
  blendAlphaSrcFactor: "constant-alpha",
  blendAlphaDstFactor: "zero"
};
class PickLayersPass extends LayersPass {
  constructor() {
    super(...arguments);
    this._colorEncoderState = null;
  }
  render(props) {
    if ("pickingFBO" in props) {
      return this._drawPickingBuffer(props);
    }
    return super.render(props);
  }
  // Private
  // Draws list of layers and viewports into the picking buffer
  // Note: does not sample the buffer, that has to be done by the caller
  _drawPickingBuffer({ layers, layerFilter, views, viewports, onViewportActive, pickingFBO, deviceRect: { x: x2, y: y2, width, height }, cullRect, effects, pass: pass2 = "picking", pickZ, moduleParameters }) {
    this.pickZ = pickZ;
    const colorEncoderState = this._resetColorEncoder(pickZ);
    const scissorRect = [x2, y2, width, height];
    const renderStatus = super.render({
      target: pickingFBO,
      layers,
      layerFilter,
      views,
      viewports,
      onViewportActive,
      cullRect,
      effects: effects == null ? void 0 : effects.filter((e3) => e3.useInPicking),
      pass: pass2,
      isPicking: true,
      moduleParameters,
      clearColor: [0, 0, 0, 0],
      colorMask: 15,
      scissorRect
    });
    this._colorEncoderState = null;
    const decodePickingColor = colorEncoderState && decodeColor.bind(null, colorEncoderState);
    return { decodePickingColor, stats: renderStatus };
  }
  shouldDrawLayer(layer) {
    const { pickable, operation } = layer.props;
    return pickable && operation.includes("draw") || operation.includes("terrain") || operation.includes("mask");
  }
  getModuleParameters() {
    return {
      picking: {
        isActive: 1,
        isAttribute: this.pickZ
      },
      // turn off lighting by adding empty light source object
      // lights shader module relies on the `lightSources` to turn on/off lighting
      lightSources: {}
    };
  }
  getLayerParameters(layer, layerIndex, viewport) {
    const pickParameters = {
      // TODO - When used as a custom layer in older Mapbox versions, context
      // state was dirty. Mapbox fixed that; we should test and remove the workaround.
      // https://github.com/mapbox/mapbox-gl-js/issues/7801
      depthMask: true,
      depthTest: true,
      depthRange: [0, 1],
      ...layer.props.parameters
    };
    const { pickable, operation } = layer.props;
    if (!this._colorEncoderState || operation.includes("terrain")) {
      pickParameters.blend = false;
    } else if (pickable && operation.includes("draw")) {
      Object.assign(pickParameters, PICKING_BLENDING);
      pickParameters.blend = true;
      pickParameters.blendColor = encodeColor(this._colorEncoderState, layer, viewport);
    }
    return pickParameters;
  }
  _resetColorEncoder(pickZ) {
    this._colorEncoderState = pickZ ? null : {
      byLayer: /* @__PURE__ */ new Map(),
      byAlpha: []
    };
    return this._colorEncoderState;
  }
}
function encodeColor(encoded, layer, viewport) {
  const { byLayer, byAlpha } = encoded;
  let a2;
  let entry = byLayer.get(layer);
  if (entry) {
    entry.viewports.push(viewport);
    a2 = entry.a;
  } else {
    a2 = byLayer.size + 1;
    if (a2 <= 255) {
      entry = { a: a2, layer, viewports: [viewport] };
      byLayer.set(layer, entry);
      byAlpha[a2] = entry;
    } else {
      log$1.warn("Too many pickable layers, only picking the first 255")();
      a2 = 0;
    }
  }
  return [0, 0, 0, a2 / 255];
}
function decodeColor(encoded, pickedColor) {
  const entry = encoded.byAlpha[pickedColor[3]];
  return entry && {
    pickedLayer: entry.layer,
    pickedViewports: entry.viewports,
    pickedObjectIndex: entry.layer.decodePickingColor(pickedColor)
  };
}
const LIFECYCLE = {
  NO_STATE: "Awaiting state",
  MATCHED: "Matched. State transferred from previous layer",
  INITIALIZED: "Initialized",
  AWAITING_GC: "Discarded. Awaiting garbage collection",
  AWAITING_FINALIZATION: "No longer matched. Awaiting garbage collection",
  FINALIZED: "Finalized! Awaiting garbage collection"
};
const COMPONENT_SYMBOL = Symbol.for("component");
const PROP_TYPES_SYMBOL = Symbol.for("propTypes");
const DEPRECATED_PROPS_SYMBOL = Symbol.for("deprecatedProps");
const ASYNC_DEFAULTS_SYMBOL = Symbol.for("asyncPropDefaults");
const ASYNC_ORIGINAL_SYMBOL = Symbol.for("asyncPropOriginal");
const ASYNC_RESOLVED_SYMBOL = Symbol.for("asyncPropResolved");
function flatten$2(array2, filter17 = () => true) {
  if (!Array.isArray(array2)) {
    return filter17(array2) ? [array2] : [];
  }
  return flattenArray(array2, filter17, []);
}
function flattenArray(array2, filter17, result) {
  let index2 = -1;
  while (++index2 < array2.length) {
    const value = array2[index2];
    if (Array.isArray(value)) {
      flattenArray(value, filter17, result);
    } else if (filter17(value)) {
      result.push(value);
    }
  }
  return result;
}
function fillArray({ target, source, start: start2 = 0, count: count3 = 1 }) {
  const length2 = source.length;
  const total = count3 * length2;
  let copied = 0;
  for (let i2 = start2; copied < length2; copied++) {
    target[i2++] = source[copied];
  }
  while (copied < total) {
    if (copied < total - copied) {
      target.copyWithin(start2 + copied, start2, start2 + copied);
      copied *= 2;
    } else {
      target.copyWithin(start2 + copied, start2, start2 + total - copied);
      copied = total;
    }
  }
  return target;
}
class Resource {
  constructor(id, data2, context2) {
    this._loadCount = 0;
    this._subscribers = /* @__PURE__ */ new Set();
    this.id = id;
    this.context = context2;
    this.setData(data2);
  }
  // consumer: {onChange: Function}
  subscribe(consumer) {
    this._subscribers.add(consumer);
  }
  unsubscribe(consumer) {
    this._subscribers.delete(consumer);
  }
  inUse() {
    return this._subscribers.size > 0;
  }
  delete() {
  }
  getData() {
    return this.isLoaded ? this._error ? Promise.reject(this._error) : this._content : this._loader.then(() => this.getData());
  }
  setData(data2, forceUpdate) {
    if (data2 === this._data && !forceUpdate) {
      return;
    }
    this._data = data2;
    const loadCount = ++this._loadCount;
    let loader2 = data2;
    if (typeof data2 === "string") {
      loader2 = load(data2);
    }
    if (loader2 instanceof Promise) {
      this.isLoaded = false;
      this._loader = loader2.then((result) => {
        if (this._loadCount === loadCount) {
          this.isLoaded = true;
          this._error = void 0;
          this._content = result;
        }
      }).catch((error2) => {
        if (this._loadCount === loadCount) {
          this.isLoaded = true;
          this._error = error2 || true;
        }
      });
    } else {
      this.isLoaded = true;
      this._error = void 0;
      this._content = data2;
    }
    for (const subscriber of this._subscribers) {
      subscriber.onChange(this.getData());
    }
  }
}
class ResourceManager {
  constructor(props) {
    var _a3;
    this.protocol = props.protocol || "resource://";
    this._context = {
      device: props.device,
      // @ts-expect-error
      gl: (_a3 = props.device) == null ? void 0 : _a3.gl,
      resourceManager: this
    };
    this._resources = {};
    this._consumers = {};
    this._pruneRequest = null;
  }
  contains(resourceId) {
    if (resourceId.startsWith(this.protocol)) {
      return true;
    }
    return resourceId in this._resources;
  }
  add({ resourceId, data: data2, forceUpdate = false, persistent = true }) {
    let res = this._resources[resourceId];
    if (res) {
      res.setData(data2, forceUpdate);
    } else {
      res = new Resource(resourceId, data2, this._context);
      this._resources[resourceId] = res;
    }
    res.persistent = persistent;
  }
  remove(resourceId) {
    const res = this._resources[resourceId];
    if (res) {
      res.delete();
      delete this._resources[resourceId];
    }
  }
  unsubscribe({ consumerId }) {
    const consumer = this._consumers[consumerId];
    if (consumer) {
      for (const requestId2 in consumer) {
        const request = consumer[requestId2];
        const resource = this._resources[request.resourceId];
        if (resource) {
          resource.unsubscribe(request);
        }
      }
      delete this._consumers[consumerId];
      this.prune();
    }
  }
  subscribe({ resourceId, onChange, consumerId, requestId: requestId2 = "default" }) {
    const { _resources: resources, protocol } = this;
    if (resourceId.startsWith(protocol)) {
      resourceId = resourceId.replace(protocol, "");
      if (!resources[resourceId]) {
        this.add({ resourceId, data: null, persistent: false });
      }
    }
    const res = resources[resourceId];
    this._track(consumerId, requestId2, res, onChange);
    if (res) {
      return res.getData();
    }
    return void 0;
  }
  prune() {
    if (!this._pruneRequest) {
      this._pruneRequest = setTimeout(() => this._prune(), 0);
    }
  }
  finalize() {
    for (const key in this._resources) {
      this._resources[key].delete();
    }
  }
  _track(consumerId, requestId2, resource, onChange) {
    const consumers = this._consumers;
    const consumer = consumers[consumerId] = consumers[consumerId] || {};
    let request = consumer[requestId2];
    const oldResource = request && request.resourceId && this._resources[request.resourceId];
    if (oldResource) {
      oldResource.unsubscribe(request);
      this.prune();
    }
    if (resource) {
      if (request) {
        request.onChange = onChange;
        request.resourceId = resource.id;
      } else {
        request = {
          onChange,
          resourceId: resource.id
        };
      }
      consumer[requestId2] = request;
      resource.subscribe(request);
    }
  }
  _prune() {
    this._pruneRequest = null;
    for (const key of Object.keys(this._resources)) {
      const res = this._resources[key];
      if (!res.persistent && !res.inUse()) {
        res.delete();
        delete this._resources[key];
      }
    }
  }
}
const TRACE_SET_LAYERS = "layerManager.setLayers";
const TRACE_ACTIVATE_VIEWPORT = "layerManager.activateViewport";
class LayerManager {
  /**
   * @param device
   * @param param1
   */
  // eslint-disable-next-line
  constructor(device, props) {
    this._lastRenderedLayers = [];
    this._needsRedraw = false;
    this._needsUpdate = false;
    this._nextLayers = null;
    this._debug = false;
    this._defaultShaderModulesChanged = false;
    this.activateViewport = (viewport2) => {
      debug(TRACE_ACTIVATE_VIEWPORT, this, viewport2);
      if (viewport2) {
        this.context.viewport = viewport2;
      }
    };
    const { deck, stats, viewport, timeline } = props || {};
    this.layers = [];
    this.resourceManager = new ResourceManager({ device, protocol: "deck://" });
    this.context = {
      mousePosition: null,
      userData: {},
      layerManager: this,
      device,
      // @ts-expect-error
      gl: device == null ? void 0 : device.gl,
      deck,
      shaderAssembler: getShaderAssembler(),
      defaultShaderModules: [],
      renderPass: void 0,
      stats: stats || new Stats({ id: "deck.gl" }),
      // Make sure context.viewport is not empty on the first layer initialization
      viewport: viewport || new Viewport({ id: "DEFAULT-INITIAL-VIEWPORT" }),
      // Current viewport, exposed to layers for project* function
      timeline: timeline || new Timeline(),
      resourceManager: this.resourceManager,
      onError: void 0
    };
    Object.seal(this);
  }
  /** Method to call when the layer manager is not needed anymore. */
  finalize() {
    this.resourceManager.finalize();
    for (const layer of this.layers) {
      this._finalizeLayer(layer);
    }
  }
  /** Check if a redraw is needed */
  needsRedraw(opts = { clearRedrawFlags: false }) {
    let redraw = this._needsRedraw;
    if (opts.clearRedrawFlags) {
      this._needsRedraw = false;
    }
    for (const layer of this.layers) {
      const layerNeedsRedraw = layer.getNeedsRedraw(opts);
      redraw = redraw || layerNeedsRedraw;
    }
    return redraw;
  }
  /** Check if a deep update of all layers is needed */
  needsUpdate() {
    if (this._nextLayers && this._nextLayers !== this._lastRenderedLayers) {
      return "layers changed";
    }
    if (this._defaultShaderModulesChanged) {
      return "shader modules changed";
    }
    return this._needsUpdate;
  }
  /** Layers will be redrawn (in next animation frame) */
  setNeedsRedraw(reason) {
    this._needsRedraw = this._needsRedraw || reason;
  }
  /** Layers will be updated deeply (in next animation frame)
    Potentially regenerating attributes and sub layers */
  setNeedsUpdate(reason) {
    this._needsUpdate = this._needsUpdate || reason;
  }
  /** Gets a list of currently rendered layers. Optionally filter by id. */
  getLayers({ layerIds } = {}) {
    return layerIds ? this.layers.filter((layer) => layerIds.find((layerId) => layer.id.indexOf(layerId) === 0)) : this.layers;
  }
  /** Set props needed for layer rendering and picking. */
  setProps(props) {
    if ("debug" in props) {
      this._debug = props.debug;
    }
    if ("userData" in props) {
      this.context.userData = props.userData;
    }
    if ("layers" in props) {
      this._nextLayers = props.layers;
    }
    if ("onError" in props) {
      this.context.onError = props.onError;
    }
  }
  /** Supply a new layer list, initiating sublayer generation and layer matching */
  setLayers(newLayers, reason) {
    debug(TRACE_SET_LAYERS, this, reason, newLayers);
    this._lastRenderedLayers = newLayers;
    const flatLayers = flatten$2(newLayers, Boolean);
    for (const layer of flatLayers) {
      layer.context = this.context;
    }
    this._updateLayers(this.layers, flatLayers);
  }
  /** Update layers from last cycle if `setNeedsUpdate()` has been called */
  updateLayers() {
    const reason = this.needsUpdate();
    if (reason) {
      this.setNeedsRedraw(`updating layers: ${reason}`);
      this.setLayers(this._nextLayers || this._lastRenderedLayers, reason);
    }
    this._nextLayers = null;
  }
  /** Register a default shader module */
  addDefaultShaderModule(module2) {
    const { defaultShaderModules } = this.context;
    if (!defaultShaderModules.find((m2) => m2.name === module2.name)) {
      defaultShaderModules.push(module2);
      this._defaultShaderModulesChanged = true;
    }
  }
  /** Deregister a default shader module */
  removeDefaultShaderModule(module2) {
    const { defaultShaderModules } = this.context;
    const i2 = defaultShaderModules.findIndex((m2) => m2.name === module2.name);
    if (i2 >= 0) {
      defaultShaderModules.splice(i2, 1);
      this._defaultShaderModulesChanged = true;
    }
  }
  _handleError(stage, error2, layer) {
    layer.raiseError(error2, `${stage} of ${layer}`);
  }
  // TODO - mark layers with exceptions as bad and remove from rendering cycle?
  /** Match all layers, checking for caught errors
    to avoid having an exception in one layer disrupt other layers */
  _updateLayers(oldLayers, newLayers) {
    const oldLayerMap = {};
    for (const oldLayer of oldLayers) {
      if (oldLayerMap[oldLayer.id]) {
        log$1.warn(`Multiple old layers with same id ${oldLayer.id}`)();
      } else {
        oldLayerMap[oldLayer.id] = oldLayer;
      }
    }
    if (this._defaultShaderModulesChanged) {
      for (const layer of oldLayers) {
        layer.setNeedsUpdate();
        layer.setChangeFlags({ extensionsChanged: true });
      }
      this._defaultShaderModulesChanged = false;
    }
    const generatedLayers = [];
    this._updateSublayersRecursively(newLayers, oldLayerMap, generatedLayers);
    this._finalizeOldLayers(oldLayerMap);
    let needsUpdate = false;
    for (const layer of generatedLayers) {
      if (layer.hasUniformTransition()) {
        needsUpdate = `Uniform transition in ${layer}`;
        break;
      }
    }
    this._needsUpdate = needsUpdate;
    this.layers = generatedLayers;
  }
  /* eslint-disable complexity,max-statements */
  // Note: adds generated layers to `generatedLayers` array parameter
  _updateSublayersRecursively(newLayers, oldLayerMap, generatedLayers) {
    for (const newLayer of newLayers) {
      newLayer.context = this.context;
      const oldLayer = oldLayerMap[newLayer.id];
      if (oldLayer === null) {
        log$1.warn(`Multiple new layers with same id ${newLayer.id}`)();
      }
      oldLayerMap[newLayer.id] = null;
      let sublayers = null;
      try {
        if (this._debug && oldLayer !== newLayer) {
          newLayer.validateProps();
        }
        if (!oldLayer) {
          this._initializeLayer(newLayer);
        } else {
          this._transferLayerState(oldLayer, newLayer);
          this._updateLayer(newLayer);
        }
        generatedLayers.push(newLayer);
        sublayers = newLayer.isComposite ? newLayer.getSubLayers() : null;
      } catch (err) {
        this._handleError("matching", err, newLayer);
      }
      if (sublayers) {
        this._updateSublayersRecursively(sublayers, oldLayerMap, generatedLayers);
      }
    }
  }
  /* eslint-enable complexity,max-statements */
  // Finalize any old layers that were not matched
  _finalizeOldLayers(oldLayerMap) {
    for (const layerId in oldLayerMap) {
      const layer = oldLayerMap[layerId];
      if (layer) {
        this._finalizeLayer(layer);
      }
    }
  }
  // / EXCEPTION SAFE LAYER ACCESS
  /** Safely initializes a single layer, calling layer methods */
  _initializeLayer(layer) {
    try {
      layer._initialize();
      layer.lifecycle = LIFECYCLE.INITIALIZED;
    } catch (err) {
      this._handleError("initialization", err, layer);
    }
  }
  /** Transfer state from one layer to a newer version */
  _transferLayerState(oldLayer, newLayer) {
    newLayer._transferState(oldLayer);
    newLayer.lifecycle = LIFECYCLE.MATCHED;
    if (newLayer !== oldLayer) {
      oldLayer.lifecycle = LIFECYCLE.AWAITING_GC;
    }
  }
  /** Safely updates a single layer, cleaning all flags */
  _updateLayer(layer) {
    try {
      layer._update();
    } catch (err) {
      this._handleError("update", err, layer);
    }
  }
  /** Safely finalizes a single layer, removing all resources */
  _finalizeLayer(layer) {
    this._needsRedraw = this._needsRedraw || `finalized ${layer}`;
    layer.lifecycle = LIFECYCLE.AWAITING_FINALIZATION;
    try {
      layer._finalize();
      layer.lifecycle = LIFECYCLE.FINALIZED;
    } catch (err) {
      this._handleError("finalization", err, layer);
    }
  }
}
function deepEqual(a2, b2, depth2) {
  if (a2 === b2) {
    return true;
  }
  if (!depth2 || !a2 || !b2) {
    return false;
  }
  if (Array.isArray(a2)) {
    if (!Array.isArray(b2) || a2.length !== b2.length) {
      return false;
    }
    for (let i2 = 0; i2 < a2.length; i2++) {
      if (!deepEqual(a2[i2], b2[i2], depth2 - 1)) {
        return false;
      }
    }
    return true;
  }
  if (Array.isArray(b2)) {
    return false;
  }
  if (typeof a2 === "object" && typeof b2 === "object") {
    const aKeys = Object.keys(a2);
    const bKeys = Object.keys(b2);
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    for (const key of aKeys) {
      if (!b2.hasOwnProperty(key)) {
        return false;
      }
      if (!deepEqual(a2[key], b2[key], depth2 - 1)) {
        return false;
      }
    }
    return true;
  }
  return false;
}
class ViewManager {
  constructor(props) {
    this.views = [];
    this.width = 100;
    this.height = 100;
    this.viewState = {};
    this.controllers = {};
    this.timeline = props.timeline;
    this._viewports = [];
    this._viewportMap = {};
    this._isUpdating = false;
    this._needsRedraw = "First render";
    this._needsUpdate = "Initialize";
    this._eventManager = props.eventManager;
    this._eventCallbacks = {
      onViewStateChange: props.onViewStateChange,
      onInteractionStateChange: props.onInteractionStateChange
    };
    Object.seal(this);
    this.setProps(props);
  }
  /** Remove all resources and event listeners */
  finalize() {
    for (const key in this.controllers) {
      const controller = this.controllers[key];
      if (controller) {
        controller.finalize();
      }
    }
    this.controllers = {};
  }
  /** Check if a redraw is needed */
  needsRedraw(opts = { clearRedrawFlags: false }) {
    const redraw = this._needsRedraw;
    if (opts.clearRedrawFlags) {
      this._needsRedraw = false;
    }
    return redraw;
  }
  /** Mark the manager as dirty. Will rebuild all viewports and update controllers. */
  setNeedsUpdate(reason) {
    this._needsUpdate = this._needsUpdate || reason;
    this._needsRedraw = this._needsRedraw || reason;
  }
  /** Checks each viewport for transition updates */
  updateViewStates() {
    for (const viewId in this.controllers) {
      const controller = this.controllers[viewId];
      if (controller) {
        controller.updateTransition();
      }
    }
  }
  /** Get a set of viewports for a given width and height
   * TODO - Intention is for deck.gl to autodeduce width and height and drop the need for props
   * @param rect (object, optional) - filter the viewports
   *   + not provided - return all viewports
   *   + {x, y} - only return viewports that contain this pixel
   *   + {x, y, width, height} - only return viewports that overlap with this rectangle
   */
  getViewports(rect) {
    if (rect) {
      return this._viewports.filter((viewport) => viewport.containsPixel(rect));
    }
    return this._viewports;
  }
  /** Get a map of all views */
  getViews() {
    const viewMap = {};
    this.views.forEach((view2) => {
      viewMap[view2.id] = view2;
    });
    return viewMap;
  }
  /** Resolves a viewId string to a View */
  getView(viewId) {
    return this.views.find((view2) => view2.id === viewId);
  }
  /** Returns the viewState for a specific viewId. Matches the viewState by
    1. view.viewStateId
    2. view.id
    3. root viewState
    then applies the view's filter if any */
  getViewState(viewOrViewId) {
    const view2 = typeof viewOrViewId === "string" ? this.getView(viewOrViewId) : viewOrViewId;
    const viewState = view2 && this.viewState[view2.getViewStateId()] || this.viewState;
    return view2 ? view2.filterViewState(viewState) : viewState;
  }
  getViewport(viewId) {
    return this._viewportMap[viewId];
  }
  /**
   * Unproject pixel coordinates on screen onto world coordinates,
   * (possibly [lon, lat]) on map.
   * - [x, y] => [lng, lat]
   * - [x, y, z] => [lng, lat, Z]
   * @param {Array} xyz -
   * @param {Object} opts - options
   * @param {Object} opts.topLeft=true - Whether origin is top left
   * @return {Array|null} - [lng, lat, Z] or [X, Y, Z]
   */
  unproject(xyz, opts) {
    const viewports = this.getViewports();
    const pixel = { x: xyz[0], y: xyz[1] };
    for (let i2 = viewports.length - 1; i2 >= 0; --i2) {
      const viewport = viewports[i2];
      if (viewport.containsPixel(pixel)) {
        const p2 = xyz.slice();
        p2[0] -= viewport.x;
        p2[1] -= viewport.y;
        return viewport.unproject(p2, opts);
      }
    }
    return null;
  }
  /** Update the manager with new Deck props */
  setProps(props) {
    if (props.views) {
      this._setViews(props.views);
    }
    if (props.viewState) {
      this._setViewState(props.viewState);
    }
    if ("width" in props || "height" in props) {
      this._setSize(props.width, props.height);
    }
    if (!this._isUpdating) {
      this._update();
    }
  }
  //
  // PRIVATE METHODS
  //
  _update() {
    this._isUpdating = true;
    if (this._needsUpdate) {
      this._needsUpdate = false;
      this._rebuildViewports();
    }
    if (this._needsUpdate) {
      this._needsUpdate = false;
      this._rebuildViewports();
    }
    this._isUpdating = false;
  }
  _setSize(width, height) {
    if (width !== this.width || height !== this.height) {
      this.width = width;
      this.height = height;
      this.setNeedsUpdate("Size changed");
    }
  }
  // Update the view descriptor list and set change flag if needed
  // Does not actually rebuild the `Viewport`s until `getViewports` is called
  _setViews(views) {
    views = flatten$2(views, Boolean);
    const viewsChanged = this._diffViews(views, this.views);
    if (viewsChanged) {
      this.setNeedsUpdate("views changed");
    }
    this.views = views;
  }
  _setViewState(viewState) {
    if (viewState) {
      const viewStateChanged = !deepEqual(viewState, this.viewState, 3);
      if (viewStateChanged) {
        this.setNeedsUpdate("viewState changed");
      }
      this.viewState = viewState;
    } else {
      log$1.warn("missing `viewState` or `initialViewState`")();
    }
  }
  _createController(view2, props) {
    const Controller3 = props.type;
    const controller = new Controller3({
      timeline: this.timeline,
      eventManager: this._eventManager,
      // Set an internal callback that calls the prop callback if provided
      onViewStateChange: this._eventCallbacks.onViewStateChange,
      onStateChange: this._eventCallbacks.onInteractionStateChange,
      makeViewport: (viewState) => {
        var _a3;
        return (_a3 = this.getView(view2.id)) == null ? void 0 : _a3.makeViewport({
          viewState,
          width: this.width,
          height: this.height
        });
      }
    });
    return controller;
  }
  _updateController(view2, viewState, viewport, controller) {
    const controllerProps = view2.controller;
    if (controllerProps && viewport) {
      const resolvedProps = {
        ...viewState,
        ...controllerProps,
        id: view2.id,
        x: viewport.x,
        y: viewport.y,
        width: viewport.width,
        height: viewport.height
      };
      if (!controller || controller.constructor !== controllerProps.type) {
        controller = this._createController(view2, resolvedProps);
      }
      if (controller) {
        controller.setProps(resolvedProps);
      }
      return controller;
    }
    return null;
  }
  // Rebuilds viewports from descriptors towards a certain window size
  _rebuildViewports() {
    const { views } = this;
    const oldControllers = this.controllers;
    this._viewports = [];
    this.controllers = {};
    let invalidateControllers = false;
    for (let i2 = views.length; i2--; ) {
      const view2 = views[i2];
      const viewState = this.getViewState(view2);
      const viewport = view2.makeViewport({ viewState, width: this.width, height: this.height });
      let oldController = oldControllers[view2.id];
      const hasController = Boolean(view2.controller);
      if (hasController && !oldController) {
        invalidateControllers = true;
      }
      if ((invalidateControllers || !hasController) && oldController) {
        oldController.finalize();
        oldController = null;
      }
      this.controllers[view2.id] = this._updateController(view2, viewState, viewport, oldController);
      if (viewport) {
        this._viewports.unshift(viewport);
      }
    }
    for (const id in oldControllers) {
      const oldController = oldControllers[id];
      if (oldController && !this.controllers[id]) {
        oldController.finalize();
      }
    }
    this._buildViewportMap();
  }
  _buildViewportMap() {
    this._viewportMap = {};
    this._viewports.forEach((viewport) => {
      if (viewport.id) {
        this._viewportMap[viewport.id] = this._viewportMap[viewport.id] || viewport;
      }
    });
  }
  // Check if viewport array has changed, returns true if any change
  // Note that descriptors can be the same
  _diffViews(newViews, oldViews) {
    if (newViews.length !== oldViews.length) {
      return true;
    }
    return newViews.some((_2, i2) => !newViews[i2].equals(oldViews[i2]));
  }
}
const PERCENT_OR_PIXELS_REGEX = /([0-9]+\.?[0-9]*)(%|px)/;
function parsePosition(value) {
  switch (typeof value) {
    case "number":
      return {
        position: value,
        relative: false
      };
    case "string":
      const match2 = PERCENT_OR_PIXELS_REGEX.exec(value);
      if (match2 && match2.length >= 3) {
        const relative = match2[2] === "%";
        const position = parseFloat(match2[1]);
        return {
          position: relative ? position / 100 : position,
          relative
        };
      }
    default:
      throw new Error(`Could not parse position string ${value}`);
  }
}
function getPosition(position, extent2) {
  return position.relative ? Math.round(position.position * extent2) : position.position;
}
class View {
  constructor(props) {
    const { id, x: x2 = 0, y: y2 = 0, width = "100%", height = "100%", padding = null } = props;
    this.id = id || this.constructor.displayName || "view";
    this.props = { ...props, id: this.id };
    this._x = parsePosition(x2);
    this._y = parsePosition(y2);
    this._width = parsePosition(width);
    this._height = parsePosition(height);
    this._padding = padding && {
      left: parsePosition(padding.left || 0),
      right: parsePosition(padding.right || 0),
      top: parsePosition(padding.top || 0),
      bottom: parsePosition(padding.bottom || 0)
    };
    this.equals = this.equals.bind(this);
    Object.seal(this);
  }
  equals(view2) {
    if (this === view2) {
      return true;
    }
    return this.ViewportType === view2.ViewportType && deepEqual(this.props, view2.props, 2);
  }
  /** Make viewport from canvas dimensions and view state */
  makeViewport({ width, height, viewState }) {
    viewState = this.filterViewState(viewState);
    const viewportDimensions = this.getDimensions({ width, height });
    if (!viewportDimensions.height || !viewportDimensions.width) {
      return null;
    }
    return new this.ViewportType({ ...viewState, ...this.props, ...viewportDimensions });
  }
  getViewStateId() {
    const { viewState } = this.props;
    if (typeof viewState === "string") {
      return viewState;
    }
    return (viewState == null ? void 0 : viewState.id) || this.id;
  }
  // Allows view to override (or completely define) viewState
  filterViewState(viewState) {
    if (this.props.viewState && typeof this.props.viewState === "object") {
      if (!this.props.viewState.id) {
        return this.props.viewState;
      }
      const newViewState = { ...viewState };
      for (const key in this.props.viewState) {
        if (key !== "id") {
          newViewState[key] = this.props.viewState[key];
        }
      }
      return newViewState;
    }
    return viewState;
  }
  /** Resolve the dimensions of the view from overall canvas dimensions */
  getDimensions({ width, height }) {
    const dimensions = {
      x: getPosition(this._x, width),
      y: getPosition(this._y, height),
      width: getPosition(this._width, width),
      height: getPosition(this._height, height)
    };
    if (this._padding) {
      dimensions.padding = {
        left: getPosition(this._padding.left, width),
        top: getPosition(this._padding.top, height),
        right: getPosition(this._padding.right, width),
        bottom: getPosition(this._padding.bottom, height)
      };
    }
    return dimensions;
  }
  // Used by sub classes to resolve controller props
  get controller() {
    const opts = this.props.controller;
    if (!opts) {
      return null;
    }
    if (opts === true) {
      return { type: this.ControllerType };
    }
    if (typeof opts === "function") {
      return { type: opts };
    }
    return { type: this.ControllerType, ...opts };
  }
}
class Transition {
  /**
   * @params timeline {Timeline}
   */
  constructor(timeline) {
    this._inProgress = false;
    this._handle = null;
    this.time = 0;
    this.settings = {
      duration: 0
    };
    this._timeline = timeline;
  }
  /* Public API */
  get inProgress() {
    return this._inProgress;
  }
  /**
   * (re)start this transition.
   * @params props {object} - optional overriding props. see constructor
   */
  start(settings) {
    var _a3, _b3;
    this.cancel();
    this.settings = settings;
    this._inProgress = true;
    (_b3 = (_a3 = this.settings).onStart) == null ? void 0 : _b3.call(_a3, this);
  }
  /**
   * end this transition if it is in progress.
   */
  end() {
    var _a3, _b3;
    if (this._inProgress) {
      this._timeline.removeChannel(this._handle);
      this._handle = null;
      this._inProgress = false;
      (_b3 = (_a3 = this.settings).onEnd) == null ? void 0 : _b3.call(_a3, this);
    }
  }
  /**
   * cancel this transition if it is in progress.
   */
  cancel() {
    var _a3, _b3;
    if (this._inProgress) {
      (_b3 = (_a3 = this.settings).onInterrupt) == null ? void 0 : _b3.call(_a3, this);
      this._timeline.removeChannel(this._handle);
      this._handle = null;
      this._inProgress = false;
    }
  }
  /**
   * update this transition. Returns `true` if updated.
   */
  update() {
    var _a3, _b3;
    if (!this._inProgress) {
      return false;
    }
    if (this._handle === null) {
      const { _timeline: timeline, settings } = this;
      this._handle = timeline.addChannel({
        delay: timeline.getTime(),
        duration: settings.duration
      });
    }
    this.time = this._timeline.getTime(this._handle);
    this._onUpdate();
    (_b3 = (_a3 = this.settings).onUpdate) == null ? void 0 : _b3.call(_a3, this);
    if (this._timeline.isFinished(this._handle)) {
      this.end();
    }
    return true;
  }
  /* Private API */
  _onUpdate() {
  }
}
const noop$4 = () => {
};
const TRANSITION_EVENTS = {
  BREAK: 1,
  SNAP_TO_END: 2,
  IGNORE: 3
};
const DEFAULT_EASING = (t2) => t2;
const DEFAULT_INTERRUPTION = TRANSITION_EVENTS.BREAK;
class TransitionManager {
  constructor(opts) {
    this._onTransitionUpdate = (transition2) => {
      const { time: time2, settings: { interpolator, startProps, endProps, duration, easing } } = transition2;
      const t2 = easing(time2 / duration);
      const viewport = interpolator.interpolateProps(startProps, endProps, t2);
      this.propsInTransition = this.getControllerState({
        ...this.props,
        ...viewport
      }).getViewportProps();
      this.onViewStateChange({
        viewState: this.propsInTransition,
        oldViewState: this.props
      });
    };
    this.getControllerState = opts.getControllerState;
    this.propsInTransition = null;
    this.transition = new Transition(opts.timeline);
    this.onViewStateChange = opts.onViewStateChange || noop$4;
    this.onStateChange = opts.onStateChange || noop$4;
  }
  finalize() {
    this.transition.cancel();
  }
  // Returns current transitioned viewport.
  getViewportInTransition() {
    return this.propsInTransition;
  }
  // Process the vewiport change, either ignore or trigger a new transition.
  // Return true if a new transition is triggered, false otherwise.
  processViewStateChange(nextProps) {
    let transitionTriggered = false;
    const currentProps = this.props;
    this.props = nextProps;
    if (!currentProps || this._shouldIgnoreViewportChange(currentProps, nextProps)) {
      return false;
    }
    if (this._isTransitionEnabled(nextProps)) {
      let startProps = currentProps;
      if (this.transition.inProgress) {
        const { interruption, endProps } = this.transition.settings;
        startProps = {
          ...currentProps,
          ...interruption === TRANSITION_EVENTS.SNAP_TO_END ? endProps : this.propsInTransition || currentProps
        };
      }
      this._triggerTransition(startProps, nextProps);
      transitionTriggered = true;
    } else {
      this.transition.cancel();
    }
    return transitionTriggered;
  }
  updateTransition() {
    this.transition.update();
  }
  // Helper methods
  _isTransitionEnabled(props) {
    const { transitionDuration, transitionInterpolator } = props;
    return (transitionDuration > 0 || transitionDuration === "auto") && Boolean(transitionInterpolator);
  }
  _isUpdateDueToCurrentTransition(props) {
    if (this.transition.inProgress && this.propsInTransition) {
      return this.transition.settings.interpolator.arePropsEqual(props, this.propsInTransition);
    }
    return false;
  }
  _shouldIgnoreViewportChange(currentProps, nextProps) {
    if (this.transition.inProgress) {
      const transitionSettings = this.transition.settings;
      return transitionSettings.interruption === TRANSITION_EVENTS.IGNORE || // Ignore update if it is due to current active transition.
      this._isUpdateDueToCurrentTransition(nextProps);
    }
    if (this._isTransitionEnabled(nextProps)) {
      return nextProps.transitionInterpolator.arePropsEqual(currentProps, nextProps);
    }
    return true;
  }
  _triggerTransition(startProps, endProps) {
    const startViewstate = this.getControllerState(startProps);
    const endViewStateProps = this.getControllerState(endProps).shortestPathFrom(startViewstate);
    const transitionInterpolator = endProps.transitionInterpolator;
    const duration = transitionInterpolator.getDuration ? transitionInterpolator.getDuration(startProps, endProps) : endProps.transitionDuration;
    if (duration === 0) {
      return;
    }
    const initialProps = transitionInterpolator.initializeProps(startProps, endViewStateProps);
    this.propsInTransition = {};
    const transitionSettings = {
      duration,
      easing: endProps.transitionEasing || DEFAULT_EASING,
      interpolator: transitionInterpolator,
      interruption: endProps.transitionInterruption || DEFAULT_INTERRUPTION,
      startProps: initialProps.start,
      endProps: initialProps.end,
      onStart: endProps.onTransitionStart,
      onUpdate: this._onTransitionUpdate,
      onInterrupt: this._onTransitionEnd(endProps.onTransitionInterrupt),
      onEnd: this._onTransitionEnd(endProps.onTransitionEnd)
    };
    this.transition.start(transitionSettings);
    this.onStateChange({ inTransition: true });
    this.updateTransition();
  }
  _onTransitionEnd(callback) {
    return (transition2) => {
      this.propsInTransition = null;
      this.onStateChange({
        inTransition: false,
        isZooming: false,
        isPanning: false,
        isRotating: false
      });
      callback == null ? void 0 : callback(transition2);
    };
  }
}
function assert$7(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "deck.gl: assertion failed.");
  }
}
class TransitionInterpolator {
  /**
   * @param opts {array|object}
   * @param opts.compare {array} - prop names used in equality check
   * @param opts.extract {array} - prop names needed for interpolation
   * @param opts.required {array} - prop names that must be supplied
   * alternatively, supply one list of prop names as `opts` if all of the above are the same.
   */
  constructor(opts) {
    const { compare: compare12, extract: extract3, required: required2 } = opts;
    this._propsToCompare = compare12;
    this._propsToExtract = extract3 || compare12;
    this._requiredProps = required2;
  }
  /**
   * Checks if two sets of props need transition in between
   * @param currentProps {object} - a list of viewport props
   * @param nextProps {object} - a list of viewport props
   * @returns {bool} - true if two props are equivalent
   */
  arePropsEqual(currentProps, nextProps) {
    for (const key of this._propsToCompare) {
      if (!(key in currentProps) || !(key in nextProps) || !equals$1(currentProps[key], nextProps[key])) {
        return false;
      }
    }
    return true;
  }
  /**
   * Called before transition starts to validate/pre-process start and end props
   * @param startProps {object} - a list of starting viewport props
   * @param endProps {object} - a list of target viewport props
   * @returns {Object} {start, end} - start and end props to be passed
   *   to `interpolateProps`
   */
  initializeProps(startProps, endProps) {
    const startViewStateProps = {};
    const endViewStateProps = {};
    for (const key of this._propsToExtract) {
      if (key in startProps || key in endProps) {
        startViewStateProps[key] = startProps[key];
        endViewStateProps[key] = endProps[key];
      }
    }
    this._checkRequiredProps(startViewStateProps);
    this._checkRequiredProps(endViewStateProps);
    return { start: startViewStateProps, end: endViewStateProps };
  }
  /**
   * Returns transition duration
   * @param startProps {object} - a list of starting viewport props
   * @param endProps {object} - a list of target viewport props
   * @returns {Number} - transition duration in milliseconds
   */
  getDuration(startProps, endProps) {
    return endProps.transitionDuration;
  }
  _checkRequiredProps(props) {
    if (!this._requiredProps) {
      return;
    }
    this._requiredProps.forEach((propName2) => {
      const value = props[propName2];
      assert$7(Number.isFinite(value) || Array.isArray(value), `${propName2} is required for transition`);
    });
  }
}
const DEFAULT_PROPS$2 = ["longitude", "latitude", "zoom", "bearing", "pitch"];
const DEFAULT_REQUIRED_PROPS = ["longitude", "latitude", "zoom"];
class LinearInterpolator extends TransitionInterpolator {
  /**
   * @param {Object} opts
   * @param {Array} opts.transitionProps - list of props to apply linear transition to.
   * @param {Array} opts.around - a screen point to zoom/rotate around.
   * @param {Function} opts.makeViewport - construct a viewport instance with given props.
   */
  constructor(opts = {}) {
    const transitionProps = Array.isArray(opts) ? opts : opts.transitionProps;
    const normalizedOpts = Array.isArray(opts) ? {} : opts;
    normalizedOpts.transitionProps = Array.isArray(transitionProps) ? {
      compare: transitionProps,
      required: transitionProps
    } : transitionProps || {
      compare: DEFAULT_PROPS$2,
      required: DEFAULT_REQUIRED_PROPS
    };
    super(normalizedOpts.transitionProps);
    this.opts = normalizedOpts;
  }
  initializeProps(startProps, endProps) {
    const result = super.initializeProps(startProps, endProps);
    const { makeViewport, around } = this.opts;
    if (makeViewport && around) {
      const startViewport = makeViewport(startProps);
      const endViewport = makeViewport(endProps);
      const aroundPosition = startViewport.unproject(around);
      result.start.around = around;
      Object.assign(result.end, {
        around: endViewport.project(aroundPosition),
        aroundPosition,
        width: endProps.width,
        height: endProps.height
      });
    }
    return result;
  }
  interpolateProps(startProps, endProps, t2) {
    const propsInTransition = {};
    for (const key of this._propsToExtract) {
      propsInTransition[key] = lerp$4(startProps[key] || 0, endProps[key] || 0, t2);
    }
    if (endProps.aroundPosition && this.opts.makeViewport) {
      const viewport = this.opts.makeViewport({ ...endProps, ...propsInTransition });
      Object.assign(propsInTransition, viewport.panByPosition(
        endProps.aroundPosition,
        // anchor point in current screen coordinates
        lerp$4(startProps.around, endProps.around, t2)
      ));
    }
    return propsInTransition;
  }
}
const NO_TRANSITION_PROPS = {
  transitionDuration: 0
};
const DEFAULT_INERTIA = 300;
const INERTIA_EASING = (t2) => 1 - (1 - t2) * (1 - t2);
const EVENT_TYPES = {
  WHEEL: ["wheel"],
  PAN: ["panstart", "panmove", "panend"],
  PINCH: ["pinchstart", "pinchmove", "pinchend"],
  TRIPLE_PAN: ["tripanstart", "tripanmove", "tripanend"],
  DOUBLE_TAP: ["doubletap"],
  KEYBOARD: ["keydown"]
};
const pinchEventWorkaround = {};
let Controller$1 = class Controller2 {
  constructor(opts) {
    this.state = {};
    this._events = {};
    this._interactionState = {
      isDragging: false
    };
    this._customEvents = [];
    this._eventStartBlocked = null;
    this._panMove = false;
    this.invertPan = false;
    this.dragMode = "rotate";
    this.inertia = 0;
    this.scrollZoom = true;
    this.dragPan = true;
    this.dragRotate = true;
    this.doubleClickZoom = true;
    this.touchZoom = true;
    this.touchRotate = false;
    this.keyboard = true;
    this.transitionManager = new TransitionManager({
      ...opts,
      getControllerState: (props) => new this.ControllerState(props),
      onViewStateChange: this._onTransition.bind(this),
      onStateChange: this._setInteractionState.bind(this)
    });
    this.handleEvent = this.handleEvent.bind(this);
    this.eventManager = opts.eventManager;
    this.onViewStateChange = opts.onViewStateChange || (() => {
    });
    this.onStateChange = opts.onStateChange || (() => {
    });
    this.makeViewport = opts.makeViewport;
  }
  set events(customEvents) {
    this.toggleEvents(this._customEvents, false);
    this.toggleEvents(customEvents, true);
    this._customEvents = customEvents;
    if (this.props) {
      this.setProps(this.props);
    }
  }
  finalize() {
    var _a3;
    for (const eventName in this._events) {
      if (this._events[eventName]) {
        (_a3 = this.eventManager) == null ? void 0 : _a3.off(eventName, this.handleEvent);
      }
    }
    this.transitionManager.finalize();
  }
  /**
   * Callback for events
   */
  handleEvent(event) {
    this._controllerState = void 0;
    const eventStartBlocked = this._eventStartBlocked;
    switch (event.type) {
      case "panstart":
        return eventStartBlocked ? false : this._onPanStart(event);
      case "panmove":
        return this._onPan(event);
      case "panend":
        return this._onPanEnd(event);
      case "pinchstart":
        return eventStartBlocked ? false : this._onPinchStart(event);
      case "pinchmove":
        return this._onPinch(event);
      case "pinchend":
        return this._onPinchEnd(event);
      case "tripanstart":
        return eventStartBlocked ? false : this._onTriplePanStart(event);
      case "tripanmove":
        return this._onTriplePan(event);
      case "tripanend":
        return this._onTriplePanEnd(event);
      case "doubletap":
        return this._onDoubleTap(event);
      case "wheel":
        return this._onWheel(event);
      case "keydown":
        return this._onKeyDown(event);
      default:
        return false;
    }
  }
  /* Event utils */
  // Event object: http://hammerjs.github.io/api/#event-object
  get controllerState() {
    this._controllerState = this._controllerState || new this.ControllerState({
      makeViewport: this.makeViewport,
      ...this.props,
      ...this.state
    });
    return this._controllerState;
  }
  getCenter(event) {
    const { x: x2, y: y2 } = this.props;
    const { offsetCenter } = event;
    return [offsetCenter.x - x2, offsetCenter.y - y2];
  }
  isPointInBounds(pos, event) {
    const { width, height } = this.props;
    if (event && event.handled) {
      return false;
    }
    const inside = pos[0] >= 0 && pos[0] <= width && pos[1] >= 0 && pos[1] <= height;
    if (inside && event) {
      event.stopPropagation();
    }
    return inside;
  }
  isFunctionKeyPressed(event) {
    const { srcEvent } = event;
    return Boolean(srcEvent.metaKey || srcEvent.altKey || srcEvent.ctrlKey || srcEvent.shiftKey);
  }
  isDragging() {
    return this._interactionState.isDragging || false;
  }
  // When a multi-touch event ends, e.g. pinch, not all pointers are lifted at the same time.
  // This triggers a brief `pan` event.
  // Calling this method will temporarily disable *start events to avoid conflicting transitions.
  blockEvents(timeout) {
    const timer = setTimeout(() => {
      if (this._eventStartBlocked === timer) {
        this._eventStartBlocked = null;
      }
    }, timeout);
    this._eventStartBlocked = timer;
  }
  /**
   * Extract interactivity options
   */
  setProps(props) {
    if (props.dragMode) {
      this.dragMode = props.dragMode;
    }
    this.props = props;
    if (!("transitionInterpolator" in props)) {
      props.transitionInterpolator = this._getTransitionProps().transitionInterpolator;
    }
    this.transitionManager.processViewStateChange(props);
    const { inertia } = props;
    this.inertia = Number.isFinite(inertia) ? inertia : inertia === true ? DEFAULT_INERTIA : 0;
    const { scrollZoom = true, dragPan: dragPan2 = true, dragRotate = true, doubleClickZoom: doubleClickZoom2 = true, touchZoom = true, touchRotate = false, keyboard = true } = props;
    const isInteractive = Boolean(this.onViewStateChange);
    this.toggleEvents(EVENT_TYPES.WHEEL, isInteractive && scrollZoom);
    this.toggleEvents(EVENT_TYPES.PAN, isInteractive);
    this.toggleEvents(EVENT_TYPES.PINCH, isInteractive && (touchZoom || touchRotate));
    this.toggleEvents(EVENT_TYPES.TRIPLE_PAN, isInteractive && touchRotate);
    this.toggleEvents(EVENT_TYPES.DOUBLE_TAP, isInteractive && doubleClickZoom2);
    this.toggleEvents(EVENT_TYPES.KEYBOARD, isInteractive && keyboard);
    this.scrollZoom = scrollZoom;
    this.dragPan = dragPan2;
    this.dragRotate = dragRotate;
    this.doubleClickZoom = doubleClickZoom2;
    this.touchZoom = touchZoom;
    this.touchRotate = touchRotate;
    this.keyboard = keyboard;
  }
  updateTransition() {
    this.transitionManager.updateTransition();
  }
  toggleEvents(eventNames2, enabled) {
    if (this.eventManager) {
      eventNames2.forEach((eventName) => {
        if (this._events[eventName] !== enabled) {
          this._events[eventName] = enabled;
          if (enabled) {
            this.eventManager.on(eventName, this.handleEvent);
          } else {
            this.eventManager.off(eventName, this.handleEvent);
          }
        }
      });
    }
  }
  // Private Methods
  /* Callback util */
  // formats map state and invokes callback function
  updateViewport(newControllerState, extraProps = null, interactionState = {}) {
    const viewState = { ...newControllerState.getViewportProps(), ...extraProps };
    const changed = this.controllerState !== newControllerState;
    this.state = newControllerState.getState();
    this._setInteractionState(interactionState);
    if (changed) {
      const oldViewState = this.controllerState && this.controllerState.getViewportProps();
      if (this.onViewStateChange) {
        this.onViewStateChange({ viewState, interactionState: this._interactionState, oldViewState, viewId: this.props.id });
      }
    }
  }
  _onTransition(params2) {
    this.onViewStateChange({ ...params2, interactionState: this._interactionState, viewId: this.props.id });
  }
  _setInteractionState(newStates) {
    Object.assign(this._interactionState, newStates);
    this.onStateChange(this._interactionState);
  }
  /* Event handlers */
  // Default handler for the `panstart` event.
  _onPanStart(event) {
    const pos = this.getCenter(event);
    if (!this.isPointInBounds(pos, event)) {
      return false;
    }
    let alternateMode = this.isFunctionKeyPressed(event) || event.rightButton || false;
    if (this.invertPan || this.dragMode === "pan") {
      alternateMode = !alternateMode;
    }
    const newControllerState = this.controllerState[alternateMode ? "panStart" : "rotateStart"]({
      pos
    });
    this._panMove = alternateMode;
    this.updateViewport(newControllerState, NO_TRANSITION_PROPS, { isDragging: true });
    return true;
  }
  // Default handler for the `panmove` and `panend` event.
  _onPan(event) {
    if (!this.isDragging()) {
      return false;
    }
    return this._panMove ? this._onPanMove(event) : this._onPanRotate(event);
  }
  _onPanEnd(event) {
    if (!this.isDragging()) {
      return false;
    }
    return this._panMove ? this._onPanMoveEnd(event) : this._onPanRotateEnd(event);
  }
  // Default handler for panning to move.
  // Called by `_onPan` when panning without function key pressed.
  _onPanMove(event) {
    if (!this.dragPan) {
      return false;
    }
    const pos = this.getCenter(event);
    const newControllerState = this.controllerState.pan({ pos });
    this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
      isDragging: true,
      isPanning: true
    });
    return true;
  }
  _onPanMoveEnd(event) {
    const { inertia } = this;
    if (this.dragPan && inertia && event.velocity) {
      const pos = this.getCenter(event);
      const endPos2 = [
        pos[0] + event.velocityX * inertia / 2,
        pos[1] + event.velocityY * inertia / 2
      ];
      const newControllerState = this.controllerState.pan({ pos: endPos2 }).panEnd();
      this.updateViewport(newControllerState, {
        ...this._getTransitionProps(),
        transitionDuration: inertia,
        transitionEasing: INERTIA_EASING
      }, {
        isDragging: false,
        isPanning: true
      });
    } else {
      const newControllerState = this.controllerState.panEnd();
      this.updateViewport(newControllerState, null, {
        isDragging: false,
        isPanning: false
      });
    }
    return true;
  }
  // Default handler for panning to rotate.
  // Called by `_onPan` when panning with function key pressed.
  _onPanRotate(event) {
    if (!this.dragRotate) {
      return false;
    }
    const pos = this.getCenter(event);
    const newControllerState = this.controllerState.rotate({ pos });
    this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
      isDragging: true,
      isRotating: true
    });
    return true;
  }
  _onPanRotateEnd(event) {
    const { inertia } = this;
    if (this.dragRotate && inertia && event.velocity) {
      const pos = this.getCenter(event);
      const endPos2 = [
        pos[0] + event.velocityX * inertia / 2,
        pos[1] + event.velocityY * inertia / 2
      ];
      const newControllerState = this.controllerState.rotate({ pos: endPos2 }).rotateEnd();
      this.updateViewport(newControllerState, {
        ...this._getTransitionProps(),
        transitionDuration: inertia,
        transitionEasing: INERTIA_EASING
      }, {
        isDragging: false,
        isRotating: true
      });
    } else {
      const newControllerState = this.controllerState.rotateEnd();
      this.updateViewport(newControllerState, null, {
        isDragging: false,
        isRotating: false
      });
    }
    return true;
  }
  // Default handler for the `wheel` event.
  _onWheel(event) {
    if (!this.scrollZoom) {
      return false;
    }
    const pos = this.getCenter(event);
    if (!this.isPointInBounds(pos, event)) {
      return false;
    }
    event.srcEvent.preventDefault();
    const { speed = 0.01, smooth = false } = this.scrollZoom === true ? {} : this.scrollZoom;
    const { delta } = event;
    let scale5 = 2 / (1 + Math.exp(-Math.abs(delta * speed)));
    if (delta < 0 && scale5 !== 0) {
      scale5 = 1 / scale5;
    }
    const newControllerState = this.controllerState.zoom({ pos, scale: scale5 });
    this.updateViewport(newControllerState, { ...this._getTransitionProps({ around: pos }), transitionDuration: smooth ? 250 : 1 }, {
      isZooming: true,
      isPanning: true
    });
    return true;
  }
  _onTriplePanStart(event) {
    const pos = this.getCenter(event);
    if (!this.isPointInBounds(pos, event)) {
      return false;
    }
    const newControllerState = this.controllerState.rotateStart({ pos });
    this.updateViewport(newControllerState, NO_TRANSITION_PROPS, { isDragging: true });
    return true;
  }
  _onTriplePan(event) {
    if (!this.touchRotate) {
      return false;
    }
    if (!this.isDragging()) {
      return false;
    }
    const pos = this.getCenter(event);
    pos[0] -= event.deltaX;
    const newControllerState = this.controllerState.rotate({ pos });
    this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
      isDragging: true,
      isRotating: true
    });
    return true;
  }
  _onTriplePanEnd(event) {
    if (!this.isDragging()) {
      return false;
    }
    const { inertia } = this;
    if (this.touchRotate && inertia && event.velocityY) {
      const pos = this.getCenter(event);
      const endPos2 = [pos[0], pos[1] += event.velocityY * inertia / 2];
      const newControllerState = this.controllerState.rotate({ pos: endPos2 });
      this.updateViewport(newControllerState, {
        ...this._getTransitionProps(),
        transitionDuration: inertia,
        transitionEasing: INERTIA_EASING
      }, {
        isDragging: false,
        isRotating: true
      });
      this.blockEvents(inertia);
    } else {
      const newControllerState = this.controllerState.rotateEnd();
      this.updateViewport(newControllerState, null, {
        isDragging: false,
        isRotating: false
      });
    }
    return true;
  }
  // Default handler for the `pinchstart` event.
  _onPinchStart(event) {
    const pos = this.getCenter(event);
    if (!this.isPointInBounds(pos, event)) {
      return false;
    }
    const newControllerState = this.controllerState.zoomStart({ pos }).rotateStart({ pos });
    pinchEventWorkaround._startPinchRotation = event.rotation;
    pinchEventWorkaround._lastPinchEvent = event;
    this.updateViewport(newControllerState, NO_TRANSITION_PROPS, { isDragging: true });
    return true;
  }
  // Default handler for the `pinchmove` and `pinchend` events.
  _onPinch(event) {
    if (!this.touchZoom && !this.touchRotate) {
      return false;
    }
    if (!this.isDragging()) {
      return false;
    }
    let newControllerState = this.controllerState;
    if (this.touchZoom) {
      const { scale: scale5 } = event;
      const pos = this.getCenter(event);
      newControllerState = newControllerState.zoom({ pos, scale: scale5 });
    }
    if (this.touchRotate) {
      const { rotation } = event;
      newControllerState = newControllerState.rotate({
        deltaAngleX: pinchEventWorkaround._startPinchRotation - rotation
      });
    }
    this.updateViewport(newControllerState, NO_TRANSITION_PROPS, {
      isDragging: true,
      isPanning: this.touchZoom,
      isZooming: this.touchZoom,
      isRotating: this.touchRotate
    });
    pinchEventWorkaround._lastPinchEvent = event;
    return true;
  }
  _onPinchEnd(event) {
    if (!this.isDragging()) {
      return false;
    }
    const { inertia } = this;
    const { _lastPinchEvent } = pinchEventWorkaround;
    if (this.touchZoom && inertia && _lastPinchEvent && event.scale !== _lastPinchEvent.scale) {
      const pos = this.getCenter(event);
      let newControllerState = this.controllerState.rotateEnd();
      const z2 = Math.log2(event.scale);
      const velocityZ = (z2 - Math.log2(_lastPinchEvent.scale)) / (event.deltaTime - _lastPinchEvent.deltaTime);
      const endScale = Math.pow(2, z2 + velocityZ * inertia / 2);
      newControllerState = newControllerState.zoom({ pos, scale: endScale }).zoomEnd();
      this.updateViewport(newControllerState, {
        ...this._getTransitionProps({ around: pos }),
        transitionDuration: inertia,
        transitionEasing: INERTIA_EASING
      }, {
        isDragging: false,
        isPanning: this.touchZoom,
        isZooming: this.touchZoom,
        isRotating: false
      });
      this.blockEvents(inertia);
    } else {
      const newControllerState = this.controllerState.zoomEnd().rotateEnd();
      this.updateViewport(newControllerState, null, {
        isDragging: false,
        isPanning: false,
        isZooming: false,
        isRotating: false
      });
    }
    pinchEventWorkaround._startPinchRotation = null;
    pinchEventWorkaround._lastPinchEvent = null;
    return true;
  }
  // Default handler for the `doubletap` event.
  _onDoubleTap(event) {
    if (!this.doubleClickZoom) {
      return false;
    }
    const pos = this.getCenter(event);
    if (!this.isPointInBounds(pos, event)) {
      return false;
    }
    const isZoomOut = this.isFunctionKeyPressed(event);
    const newControllerState = this.controllerState.zoom({ pos, scale: isZoomOut ? 0.5 : 2 });
    this.updateViewport(newControllerState, this._getTransitionProps({ around: pos }), {
      isZooming: true,
      isPanning: true
    });
    this.blockEvents(100);
    return true;
  }
  // Default handler for the `keydown` event
  _onKeyDown(event) {
    if (!this.keyboard) {
      return false;
    }
    const funcKey = this.isFunctionKeyPressed(event);
    const { zoomSpeed, moveSpeed, rotateSpeedX, rotateSpeedY } = this.keyboard === true ? {} : this.keyboard;
    const { controllerState } = this;
    let newControllerState;
    const interactionState = {};
    switch (event.srcEvent.code) {
      case "Minus":
        newControllerState = funcKey ? controllerState.zoomOut(zoomSpeed).zoomOut(zoomSpeed) : controllerState.zoomOut(zoomSpeed);
        interactionState.isZooming = true;
        break;
      case "Equal":
        newControllerState = funcKey ? controllerState.zoomIn(zoomSpeed).zoomIn(zoomSpeed) : controllerState.zoomIn(zoomSpeed);
        interactionState.isZooming = true;
        break;
      case "ArrowLeft":
        if (funcKey) {
          newControllerState = controllerState.rotateLeft(rotateSpeedX);
          interactionState.isRotating = true;
        } else {
          newControllerState = controllerState.moveLeft(moveSpeed);
          interactionState.isPanning = true;
        }
        break;
      case "ArrowRight":
        if (funcKey) {
          newControllerState = controllerState.rotateRight(rotateSpeedX);
          interactionState.isRotating = true;
        } else {
          newControllerState = controllerState.moveRight(moveSpeed);
          interactionState.isPanning = true;
        }
        break;
      case "ArrowUp":
        if (funcKey) {
          newControllerState = controllerState.rotateUp(rotateSpeedY);
          interactionState.isRotating = true;
        } else {
          newControllerState = controllerState.moveUp(moveSpeed);
          interactionState.isPanning = true;
        }
        break;
      case "ArrowDown":
        if (funcKey) {
          newControllerState = controllerState.rotateDown(rotateSpeedY);
          interactionState.isRotating = true;
        } else {
          newControllerState = controllerState.moveDown(moveSpeed);
          interactionState.isPanning = true;
        }
        break;
      default:
        return false;
    }
    this.updateViewport(newControllerState, this._getTransitionProps(), interactionState);
    return true;
  }
  _getTransitionProps(opts) {
    const { transition: transition2 } = this;
    if (!transition2 || !transition2.transitionInterpolator) {
      return NO_TRANSITION_PROPS;
    }
    return opts ? {
      ...transition2,
      transitionInterpolator: new LinearInterpolator({
        ...opts,
        ...transition2.transitionInterpolator.opts,
        makeViewport: this.controllerState.makeViewport
      })
    } : transition2;
  }
};
class ViewState {
  constructor(props, state) {
    this._viewportProps = this.applyConstraints(props);
    this._state = state;
  }
  getViewportProps() {
    return this._viewportProps;
  }
  getState() {
    return this._state;
  }
}
const PITCH_MOUSE_THRESHOLD = 5;
const PITCH_ACCEL = 1.2;
class MapState extends ViewState {
  constructor(options2) {
    const {
      /** Mapbox viewport properties */
      /** The width of the viewport */
      width,
      /** The height of the viewport */
      height,
      /** The latitude at the center of the viewport */
      latitude,
      /** The longitude at the center of the viewport */
      longitude,
      /** The tile zoom level of the map. */
      zoom: zoom2,
      /** The bearing of the viewport in degrees */
      bearing: bearing2 = 0,
      /** The pitch of the viewport in degrees */
      pitch = 0,
      /**
       * Specify the altitude of the viewport camera
       * Unit: map heights, default 1.5
       * Non-public API, see https://github.com/mapbox/mapbox-gl-js/issues/1137
       */
      altitude = 1.5,
      /** Viewport position */
      position = [0, 0, 0],
      /** Viewport constraints */
      maxZoom = 20,
      minZoom = 0,
      maxPitch = 60,
      minPitch = 0,
      /** Interaction states, required to calculate change during transform */
      /* The point on map being grabbed when the operation first started */
      startPanLngLat,
      /* Center of the zoom when the operation first started */
      startZoomLngLat,
      /* Pointer position when rotation started */
      startRotatePos,
      /** Bearing when current perspective rotate operation started */
      startBearing,
      /** Pitch when current perspective rotate operation started */
      startPitch,
      /** Zoom when current zoom operation started */
      startZoom,
      /** Normalize viewport props to fit map height into viewport */
      normalize: normalize5 = true
    } = options2;
    assert$7(Number.isFinite(longitude));
    assert$7(Number.isFinite(latitude));
    assert$7(Number.isFinite(zoom2));
    super({
      width,
      height,
      latitude,
      longitude,
      zoom: zoom2,
      bearing: bearing2,
      pitch,
      altitude,
      maxZoom,
      minZoom,
      maxPitch,
      minPitch,
      normalize: normalize5,
      position
    }, {
      startPanLngLat,
      startZoomLngLat,
      startRotatePos,
      startBearing,
      startPitch,
      startZoom
    });
    this.makeViewport = options2.makeViewport;
  }
  /**
   * Start panning
   * @param {[Number, Number]} pos - position on screen where the pointer grabs
   */
  panStart({ pos }) {
    return this._getUpdatedState({
      startPanLngLat: this._unproject(pos)
    });
  }
  /**
   * Pan
   * @param {[Number, Number]} pos - position on screen where the pointer is
   * @param {[Number, Number], optional} startPos - where the pointer grabbed at
   *   the start of the operation. Must be supplied of `panStart()` was not called
   */
  pan({ pos, startPos }) {
    const startPanLngLat = this.getState().startPanLngLat || this._unproject(startPos);
    if (!startPanLngLat) {
      return this;
    }
    const viewport = this.makeViewport(this.getViewportProps());
    const newProps = viewport.panByPosition(startPanLngLat, pos);
    return this._getUpdatedState(newProps);
  }
  /**
   * End panning
   * Must call if `panStart()` was called
   */
  panEnd() {
    return this._getUpdatedState({
      startPanLngLat: null
    });
  }
  /**
   * Start rotating
   * @param {[Number, Number]} pos - position on screen where the center is
   */
  rotateStart({ pos }) {
    return this._getUpdatedState({
      startRotatePos: pos,
      startBearing: this.getViewportProps().bearing,
      startPitch: this.getViewportProps().pitch
    });
  }
  /**
   * Rotate
   * @param {[Number, Number]} pos - position on screen where the center is
   */
  rotate({ pos, deltaAngleX = 0, deltaAngleY = 0 }) {
    const { startRotatePos, startBearing, startPitch } = this.getState();
    if (!startRotatePos || startBearing === void 0 || startPitch === void 0) {
      return this;
    }
    let newRotation;
    if (pos) {
      newRotation = this._getNewRotation(pos, startRotatePos, startPitch, startBearing);
    } else {
      newRotation = {
        bearing: startBearing + deltaAngleX,
        pitch: startPitch + deltaAngleY
      };
    }
    return this._getUpdatedState(newRotation);
  }
  /**
   * End rotating
   * Must call if `rotateStart()` was called
   */
  rotateEnd() {
    return this._getUpdatedState({
      startBearing: null,
      startPitch: null
    });
  }
  /**
   * Start zooming
   * @param {[Number, Number]} pos - position on screen where the center is
   */
  zoomStart({ pos }) {
    return this._getUpdatedState({
      startZoomLngLat: this._unproject(pos),
      startZoom: this.getViewportProps().zoom
    });
  }
  /**
   * Zoom
   * @param {[Number, Number]} pos - position on screen where the current center is
   * @param {[Number, Number]} startPos - the center position at
   *   the start of the operation. Must be supplied of `zoomStart()` was not called
   * @param {Number} scale - a number between [0, 1] specifying the accumulated
   *   relative scale.
   */
  zoom({ pos, startPos, scale: scale5 }) {
    let { startZoom, startZoomLngLat } = this.getState();
    if (!startZoomLngLat) {
      startZoom = this.getViewportProps().zoom;
      startZoomLngLat = this._unproject(startPos) || this._unproject(pos);
    }
    if (!startZoomLngLat) {
      return this;
    }
    const { maxZoom, minZoom } = this.getViewportProps();
    let zoom2 = startZoom + Math.log2(scale5);
    zoom2 = clamp$3(zoom2, minZoom, maxZoom);
    const zoomedViewport = this.makeViewport({ ...this.getViewportProps(), zoom: zoom2 });
    return this._getUpdatedState({
      zoom: zoom2,
      ...zoomedViewport.panByPosition(startZoomLngLat, pos)
    });
  }
  /**
   * End zooming
   * Must call if `zoomStart()` was called
   */
  zoomEnd() {
    return this._getUpdatedState({
      startZoomLngLat: null,
      startZoom: null
    });
  }
  zoomIn(speed = 2) {
    return this._zoomFromCenter(speed);
  }
  zoomOut(speed = 2) {
    return this._zoomFromCenter(1 / speed);
  }
  moveLeft(speed = 100) {
    return this._panFromCenter([speed, 0]);
  }
  moveRight(speed = 100) {
    return this._panFromCenter([-speed, 0]);
  }
  moveUp(speed = 100) {
    return this._panFromCenter([0, speed]);
  }
  moveDown(speed = 100) {
    return this._panFromCenter([0, -speed]);
  }
  rotateLeft(speed = 15) {
    return this._getUpdatedState({
      bearing: this.getViewportProps().bearing - speed
    });
  }
  rotateRight(speed = 15) {
    return this._getUpdatedState({
      bearing: this.getViewportProps().bearing + speed
    });
  }
  rotateUp(speed = 10) {
    return this._getUpdatedState({
      pitch: this.getViewportProps().pitch + speed
    });
  }
  rotateDown(speed = 10) {
    return this._getUpdatedState({
      pitch: this.getViewportProps().pitch - speed
    });
  }
  shortestPathFrom(viewState) {
    const fromProps = viewState.getViewportProps();
    const props = { ...this.getViewportProps() };
    const { bearing: bearing2, longitude } = props;
    if (Math.abs(bearing2 - fromProps.bearing) > 180) {
      props.bearing = bearing2 < 0 ? bearing2 + 360 : bearing2 - 360;
    }
    if (Math.abs(longitude - fromProps.longitude) > 180) {
      props.longitude = longitude < 0 ? longitude + 360 : longitude - 360;
    }
    return props;
  }
  // Apply any constraints (mathematical or defined by _viewportProps) to map state
  applyConstraints(props) {
    const { maxZoom, minZoom, zoom: zoom2 } = props;
    props.zoom = clamp$3(zoom2, minZoom, maxZoom);
    const { maxPitch, minPitch, pitch } = props;
    props.pitch = clamp$3(pitch, minPitch, maxPitch);
    const { normalize: normalize5 = true } = props;
    if (normalize5) {
      Object.assign(props, normalizeViewportProps(props));
    }
    return props;
  }
  /* Private methods */
  _zoomFromCenter(scale5) {
    const { width, height } = this.getViewportProps();
    return this.zoom({
      pos: [width / 2, height / 2],
      scale: scale5
    });
  }
  _panFromCenter(offset) {
    const { width, height } = this.getViewportProps();
    return this.pan({
      startPos: [width / 2, height / 2],
      pos: [width / 2 + offset[0], height / 2 + offset[1]]
    });
  }
  _getUpdatedState(newProps) {
    return new this.constructor({
      makeViewport: this.makeViewport,
      ...this.getViewportProps(),
      ...this.getState(),
      ...newProps
    });
  }
  _unproject(pos) {
    const viewport = this.makeViewport(this.getViewportProps());
    return pos && viewport.unproject(pos);
  }
  _getNewRotation(pos, startPos, startPitch, startBearing) {
    const deltaX = pos[0] - startPos[0];
    const deltaY = pos[1] - startPos[1];
    const centerY = pos[1];
    const startY = startPos[1];
    const { width, height } = this.getViewportProps();
    const deltaScaleX = deltaX / width;
    let deltaScaleY = 0;
    if (deltaY > 0) {
      if (Math.abs(height - startY) > PITCH_MOUSE_THRESHOLD) {
        deltaScaleY = deltaY / (startY - height) * PITCH_ACCEL;
      }
    } else if (deltaY < 0) {
      if (startY > PITCH_MOUSE_THRESHOLD) {
        deltaScaleY = 1 - centerY / startY;
      }
    }
    deltaScaleY = clamp$3(deltaScaleY, -1, 1);
    const { minPitch, maxPitch } = this.getViewportProps();
    const bearing2 = startBearing + 180 * deltaScaleX;
    let pitch = startPitch;
    if (deltaScaleY > 0) {
      pitch = startPitch + deltaScaleY * (maxPitch - startPitch);
    } else if (deltaScaleY < 0) {
      pitch = startPitch - deltaScaleY * (minPitch - startPitch);
    }
    return {
      pitch,
      bearing: bearing2
    };
  }
}
class MapController extends Controller$1 {
  constructor() {
    super(...arguments);
    this.ControllerState = MapState;
    this.transition = {
      transitionDuration: 300,
      transitionInterpolator: new LinearInterpolator({
        transitionProps: {
          compare: ["longitude", "latitude", "zoom", "bearing", "pitch", "position"],
          required: ["longitude", "latitude", "zoom"]
        }
      })
    };
    this.dragMode = "pan";
  }
  setProps(props) {
    props.position = props.position || [0, 0, 0];
    const oldProps = this.props;
    super.setProps(props);
    const dimensionChanged = !oldProps || oldProps.height !== props.height;
    if (dimensionChanged) {
      this.updateViewport(new this.ControllerState({
        makeViewport: this.makeViewport,
        ...props,
        ...this.state
      }));
    }
  }
}
const _MapView = class extends View {
  constructor(props = {}) {
    super(props);
  }
  get ViewportType() {
    return WebMercatorViewport;
  }
  get ControllerType() {
    return MapController;
  }
};
let MapView = _MapView;
(() => {
  _MapView.displayName = "MapView";
})();
const DEFAULT_LIGHTING_EFFECT = new LightingEffect();
function compareEffects(e1, e22) {
  const o1 = e1.order ?? Infinity;
  const o2 = e22.order ?? Infinity;
  return o1 - o2;
}
class EffectManager {
  constructor(context2) {
    this._resolvedEffects = [];
    this._defaultEffects = [];
    this.effects = [];
    this._context = context2;
    this._needsRedraw = "Initial render";
    this._setEffects([]);
  }
  /**
   * Register a new default effect, i.e. an effect presents regardless of user supplied props.effects
   */
  addDefaultEffect(effect) {
    const defaultEffects = this._defaultEffects;
    if (!defaultEffects.find((e3) => e3.id === effect.id)) {
      const index2 = defaultEffects.findIndex((e3) => compareEffects(e3, effect) > 0);
      if (index2 < 0) {
        defaultEffects.push(effect);
      } else {
        defaultEffects.splice(index2, 0, effect);
      }
      effect.setup(this._context);
      this._setEffects(this.effects);
    }
  }
  setProps(props) {
    if ("effects" in props) {
      if (!deepEqual(props.effects, this.effects, 1)) {
        this._setEffects(props.effects);
      }
    }
  }
  needsRedraw(opts = { clearRedrawFlags: false }) {
    const redraw = this._needsRedraw;
    if (opts.clearRedrawFlags) {
      this._needsRedraw = false;
    }
    return redraw;
  }
  getEffects() {
    return this._resolvedEffects;
  }
  _setEffects(effects) {
    const oldEffectsMap = {};
    for (const effect of this.effects) {
      oldEffectsMap[effect.id] = effect;
    }
    const nextEffects = [];
    for (const effect of effects) {
      const oldEffect = oldEffectsMap[effect.id];
      let effectToAdd = effect;
      if (oldEffect && oldEffect !== effect) {
        if (oldEffect.setProps) {
          oldEffect.setProps(effect.props);
          effectToAdd = oldEffect;
        } else {
          oldEffect.cleanup(this._context);
        }
      } else if (!oldEffect) {
        effect.setup(this._context);
      }
      nextEffects.push(effectToAdd);
      delete oldEffectsMap[effect.id];
    }
    for (const removedEffectId in oldEffectsMap) {
      oldEffectsMap[removedEffectId].cleanup(this._context);
    }
    this.effects = nextEffects;
    this._resolvedEffects = nextEffects.concat(this._defaultEffects);
    if (!effects.some((effect) => effect instanceof LightingEffect)) {
      this._resolvedEffects.push(DEFAULT_LIGHTING_EFFECT);
    }
    this._needsRedraw = "effects changed";
  }
  finalize() {
    for (const effect of this._resolvedEffects) {
      effect.cleanup(this._context);
    }
    this.effects.length = 0;
    this._resolvedEffects.length = 0;
    this._defaultEffects.length = 0;
  }
}
class DrawLayersPass extends LayersPass {
  shouldDrawLayer(layer) {
    const { operation } = layer.props;
    return operation.includes("draw") || operation.includes("terrain");
  }
}
const TRACE_RENDER_LAYERS$1 = "deckRenderer.renderLayers";
class DeckRenderer {
  constructor(device) {
    this.device = device;
    this.gl = device.gl;
    this.layerFilter = null;
    this.drawPickingColors = false;
    this.drawLayersPass = new DrawLayersPass(device);
    this.pickLayersPass = new PickLayersPass(device);
    this.renderCount = 0;
    this._needsRedraw = "Initial render";
    this.renderBuffers = [];
    this.lastPostProcessEffect = null;
  }
  setProps(props) {
    if (this.layerFilter !== props.layerFilter) {
      this.layerFilter = props.layerFilter;
      this._needsRedraw = "layerFilter changed";
    }
    if (this.drawPickingColors !== props.drawPickingColors) {
      this.drawPickingColors = props.drawPickingColors;
      this._needsRedraw = "drawPickingColors changed";
    }
  }
  renderLayers(opts) {
    if (!opts.viewports.length) {
      return;
    }
    const layerPass = this.drawPickingColors ? this.pickLayersPass : this.drawLayersPass;
    const renderOpts = {
      layerFilter: this.layerFilter,
      isPicking: this.drawPickingColors,
      ...opts
    };
    if (renderOpts.effects) {
      this._preRender(renderOpts.effects, renderOpts);
    }
    const outputBuffer = this.lastPostProcessEffect ? this.renderBuffers[0] : renderOpts.target;
    if (this.lastPostProcessEffect) {
      renderOpts.clearColor = [0, 0, 0, 0];
      renderOpts.clearCanvas = true;
    }
    const renderStats = layerPass.render({ ...renderOpts, target: outputBuffer });
    if (renderOpts.effects) {
      this._postRender(renderOpts.effects, renderOpts);
    }
    this.renderCount++;
    debug(TRACE_RENDER_LAYERS$1, this, renderStats, opts);
  }
  needsRedraw(opts = { clearRedrawFlags: false }) {
    const redraw = this._needsRedraw;
    if (opts.clearRedrawFlags) {
      this._needsRedraw = false;
    }
    return redraw;
  }
  finalize() {
    const { renderBuffers } = this;
    for (const buffer3 of renderBuffers) {
      buffer3.delete();
    }
    renderBuffers.length = 0;
  }
  _preRender(effects, opts) {
    this.lastPostProcessEffect = null;
    opts.preRenderStats = opts.preRenderStats || {};
    for (const effect of effects) {
      opts.preRenderStats[effect.id] = effect.preRender(opts);
      if (effect.postRender) {
        this.lastPostProcessEffect = effect.id;
      }
    }
    if (this.lastPostProcessEffect) {
      this._resizeRenderBuffers();
    }
  }
  _resizeRenderBuffers() {
    const { renderBuffers } = this;
    const size12 = this.device.canvasContext.getDrawingBufferSize();
    if (renderBuffers.length === 0) {
      [0, 1].map((i2) => {
        const texture = this.device.createTexture({
          sampler: { minFilter: "linear", magFilter: "linear" }
        });
        renderBuffers.push(this.device.createFramebuffer({
          id: `deck-renderbuffer-${i2}`,
          colorAttachments: [texture]
        }));
      });
    }
    for (const buffer3 of renderBuffers) {
      buffer3.resize(size12);
    }
  }
  _postRender(effects, opts) {
    const { renderBuffers } = this;
    const params2 = {
      ...opts,
      inputBuffer: renderBuffers[0],
      swapBuffer: renderBuffers[1]
    };
    for (const effect of effects) {
      if (effect.postRender) {
        params2.target = effect.id === this.lastPostProcessEffect ? opts.target : void 0;
        const buffer3 = effect.postRender(params2);
        params2.inputBuffer = buffer3;
        params2.swapBuffer = buffer3 === renderBuffers[0] ? renderBuffers[1] : renderBuffers[0];
      }
    }
  }
}
const NO_PICKED_OBJECT = {
  pickedColor: null,
  pickedObjectIndex: -1
};
function getClosestObject({ pickedColors, decodePickingColor, deviceX, deviceY, deviceRadius, deviceRect }) {
  const { x: x2, y: y2, width, height } = deviceRect;
  let minSquareDistanceToCenter = deviceRadius * deviceRadius;
  let closestPixelIndex = -1;
  let i2 = 0;
  for (let row = 0; row < height; row++) {
    const dy = row + y2 - deviceY;
    const dy2 = dy * dy;
    if (dy2 > minSquareDistanceToCenter) {
      i2 += 4 * width;
    } else {
      for (let col = 0; col < width; col++) {
        const pickedLayerIndex = pickedColors[i2 + 3] - 1;
        if (pickedLayerIndex >= 0) {
          const dx = col + x2 - deviceX;
          const d2 = dx * dx + dy2;
          if (d2 <= minSquareDistanceToCenter) {
            minSquareDistanceToCenter = d2;
            closestPixelIndex = i2;
          }
        }
        i2 += 4;
      }
    }
  }
  if (closestPixelIndex >= 0) {
    const pickedColor = pickedColors.slice(closestPixelIndex, closestPixelIndex + 4);
    const pickedObject = decodePickingColor(pickedColor);
    if (pickedObject) {
      const dy = Math.floor(closestPixelIndex / 4 / width);
      const dx = closestPixelIndex / 4 - dy * width;
      return {
        ...pickedObject,
        pickedColor,
        pickedX: x2 + dx,
        pickedY: y2 + dy
      };
    }
    log$1.error("Picked non-existent layer. Is picking buffer corrupt?")();
  }
  return NO_PICKED_OBJECT;
}
function getUniqueObjects({ pickedColors, decodePickingColor }) {
  const uniqueColors = /* @__PURE__ */ new Map();
  if (pickedColors) {
    for (let i2 = 0; i2 < pickedColors.length; i2 += 4) {
      const pickedLayerIndex = pickedColors[i2 + 3] - 1;
      if (pickedLayerIndex >= 0) {
        const pickedColor = pickedColors.slice(i2, i2 + 4);
        const colorKey = pickedColor.join(",");
        if (!uniqueColors.has(colorKey)) {
          const pickedObject = decodePickingColor(pickedColor);
          if (pickedObject) {
            uniqueColors.set(colorKey, {
              ...pickedObject,
              color: pickedColor
            });
          } else {
            log$1.error("Picked non-existent layer. Is picking buffer corrupt?")();
          }
        }
      }
    }
  }
  return Array.from(uniqueColors.values());
}
function getEmptyPickingInfo({ pickInfo, viewports, pixelRatio, x: x2, y: y2, z: z2 }) {
  let pickedViewport = viewports[0];
  if (viewports.length > 1) {
    pickedViewport = getViewportFromCoordinates((pickInfo == null ? void 0 : pickInfo.pickedViewports) || viewports, { x: x2, y: y2 });
  }
  let coordinate2;
  if (pickedViewport) {
    const point4 = [x2 - pickedViewport.x, y2 - pickedViewport.y];
    if (z2 !== void 0) {
      point4[2] = z2;
    }
    coordinate2 = pickedViewport.unproject(point4);
  }
  return {
    color: null,
    layer: null,
    viewport: pickedViewport,
    index: -1,
    picked: false,
    x: x2,
    y: y2,
    pixel: [x2, y2],
    coordinate: coordinate2,
    devicePixel: pickInfo && "pickedX" in pickInfo ? [pickInfo.pickedX, pickInfo.pickedY] : void 0,
    pixelRatio
  };
}
function processPickInfo(opts) {
  const { pickInfo, lastPickedInfo, mode: mode2, layers } = opts;
  const { pickedColor, pickedLayer, pickedObjectIndex } = pickInfo;
  const affectedLayers = pickedLayer ? [pickedLayer] : [];
  if (mode2 === "hover") {
    const lastPickedPixelIndex = lastPickedInfo.index;
    const lastPickedLayerId = lastPickedInfo.layerId;
    const pickedLayerId = pickedLayer ? pickedLayer.props.id : null;
    if (pickedLayerId !== lastPickedLayerId || pickedObjectIndex !== lastPickedPixelIndex) {
      if (pickedLayerId !== lastPickedLayerId) {
        const lastPickedLayer = layers.find((layer) => layer.props.id === lastPickedLayerId);
        if (lastPickedLayer) {
          affectedLayers.unshift(lastPickedLayer);
        }
      }
      lastPickedInfo.layerId = pickedLayerId;
      lastPickedInfo.index = pickedObjectIndex;
      lastPickedInfo.info = null;
    }
  }
  const baseInfo = getEmptyPickingInfo(opts);
  const infos = /* @__PURE__ */ new Map();
  infos.set(null, baseInfo);
  affectedLayers.forEach((layer) => {
    let info = { ...baseInfo };
    if (layer === pickedLayer) {
      info.color = pickedColor;
      info.index = pickedObjectIndex;
      info.picked = true;
    }
    info = getLayerPickingInfo({ layer, info, mode: mode2 });
    const rootLayer = info.layer;
    if (layer === pickedLayer && mode2 === "hover") {
      lastPickedInfo.info = info;
    }
    infos.set(rootLayer.id, info);
    if (mode2 === "hover") {
      rootLayer.updateAutoHighlight(info);
    }
  });
  return infos;
}
function getLayerPickingInfo({ layer, info, mode: mode2 }) {
  while (layer && info) {
    const sourceLayer = info.layer || null;
    info.sourceLayer = sourceLayer;
    info.layer = layer;
    info = layer.getPickingInfo({ info, mode: mode2, sourceLayer });
    layer = layer.parent;
  }
  return info;
}
function getViewportFromCoordinates(viewports, pixel) {
  for (let i2 = viewports.length - 1; i2 >= 0; i2--) {
    const viewport = viewports[i2];
    if (viewport.containsPixel(pixel)) {
      return viewport;
    }
  }
  return viewports[0];
}
class DeckPicker {
  constructor(device) {
    this._pickable = true;
    this.device = device;
    this.pickLayersPass = new PickLayersPass(device);
    this.lastPickedInfo = {
      index: -1,
      layerId: null,
      info: null
    };
  }
  setProps(props) {
    if ("layerFilter" in props) {
      this.layerFilter = props.layerFilter;
    }
    if ("_pickable" in props) {
      this._pickable = props._pickable;
    }
  }
  finalize() {
    if (this.pickingFBO) {
      this.pickingFBO.destroy();
    }
    if (this.depthFBO) {
      this.depthFBO.destroy();
    }
  }
  /** Pick the closest info at given coordinate */
  pickObject(opts) {
    return this._pickClosestObject(opts);
  }
  /** Get all unique infos within a bounding box */
  pickObjects(opts) {
    return this._pickVisibleObjects(opts);
  }
  // Returns a new picking info object by assuming the last picked object is still picked
  getLastPickedObject({ x: x2, y: y2, layers, viewports }, lastPickedInfo = this.lastPickedInfo.info) {
    const lastPickedLayerId = lastPickedInfo && lastPickedInfo.layer && lastPickedInfo.layer.id;
    const lastPickedViewportId = lastPickedInfo && lastPickedInfo.viewport && lastPickedInfo.viewport.id;
    const layer = lastPickedLayerId ? layers.find((l2) => l2.id === lastPickedLayerId) : null;
    const viewport = lastPickedViewportId && viewports.find((v5) => v5.id === lastPickedViewportId) || viewports[0];
    const coordinate2 = viewport && viewport.unproject([x2 - viewport.x, y2 - viewport.y]);
    const info = {
      x: x2,
      y: y2,
      viewport,
      coordinate: coordinate2,
      layer
    };
    return { ...lastPickedInfo, ...info };
  }
  // Private
  /** Ensures that picking framebuffer exists and matches the canvas size */
  _resizeBuffer() {
    var _a3, _b3;
    if (!this.pickingFBO) {
      this.pickingFBO = this.device.createFramebuffer({
        colorAttachments: ["rgba8unorm"],
        depthStencilAttachment: "depth16unorm"
      });
      if (this.device.isTextureFormatRenderable("rgba32float")) {
        const depthFBO = this.device.createFramebuffer({
          colorAttachments: ["rgba32float"],
          depthStencilAttachment: "depth16unorm"
        });
        this.depthFBO = depthFBO;
      }
    }
    const gl = this.device.gl;
    (_a3 = this.pickingFBO) == null ? void 0 : _a3.resize({ width: gl.canvas.width, height: gl.canvas.height });
    (_b3 = this.depthFBO) == null ? void 0 : _b3.resize({ width: gl.canvas.width, height: gl.canvas.height });
  }
  /** Preliminary filtering of the layers list. Skid picking pass if no layer is pickable. */
  _getPickable(layers) {
    if (this._pickable === false) {
      return null;
    }
    const pickableLayers = layers.filter((layer) => this.pickLayersPass.shouldDrawLayer(layer) && !layer.isComposite);
    return pickableLayers.length ? pickableLayers : null;
  }
  /** Pick the closest object at the given coordinate */
  // eslint-disable-next-line max-statements,complexity
  _pickClosestObject({ layers, views, viewports, x: x2, y: y2, radius = 0, depth: depth2 = 1, mode: mode2 = "query", unproject3D, onViewportActive, effects }) {
    const pixelRatio = this.device.canvasContext.cssToDeviceRatio();
    const pickableLayers = this._getPickable(layers);
    if (!pickableLayers || viewports.length === 0) {
      return {
        result: [],
        emptyInfo: getEmptyPickingInfo({ viewports, x: x2, y: y2, pixelRatio })
      };
    }
    this._resizeBuffer();
    const devicePixelRange = this.device.canvasContext.cssToDevicePixels([x2, y2], true);
    const devicePixel = [
      devicePixelRange.x + Math.floor(devicePixelRange.width / 2),
      devicePixelRange.y + Math.floor(devicePixelRange.height / 2)
    ];
    const deviceRadius = Math.round(radius * pixelRatio);
    const { width, height } = this.pickingFBO;
    const deviceRect = this._getPickingRect({
      deviceX: devicePixel[0],
      deviceY: devicePixel[1],
      deviceRadius,
      deviceWidth: width,
      deviceHeight: height
    });
    const cullRect = {
      x: x2 - radius,
      y: y2 - radius,
      width: radius * 2 + 1,
      height: radius * 2 + 1
    };
    let infos;
    const result = [];
    const affectedLayers = /* @__PURE__ */ new Set();
    for (let i2 = 0; i2 < depth2; i2++) {
      let pickInfo;
      if (deviceRect) {
        const pickedResult = this._drawAndSample({
          layers: pickableLayers,
          views,
          viewports,
          onViewportActive,
          deviceRect,
          cullRect,
          effects,
          pass: `picking:${mode2}`
        });
        pickInfo = getClosestObject({
          ...pickedResult,
          deviceX: devicePixel[0],
          deviceY: devicePixel[1],
          deviceRadius,
          deviceRect
        });
      } else {
        pickInfo = {
          pickedColor: null,
          pickedObjectIndex: -1
        };
      }
      let z2;
      if (pickInfo.pickedLayer && unproject3D && this.depthFBO) {
        const { pickedColors: pickedColors2 } = this._drawAndSample({
          layers: [pickInfo.pickedLayer],
          views,
          viewports,
          onViewportActive,
          deviceRect: {
            x: pickInfo.pickedX,
            y: pickInfo.pickedY,
            width: 1,
            height: 1
          },
          cullRect,
          effects,
          pass: `picking:${mode2}:z`
        }, true);
        if (pickedColors2[3]) {
          z2 = pickedColors2[0];
        }
      }
      if (pickInfo.pickedLayer && i2 + 1 < depth2) {
        affectedLayers.add(pickInfo.pickedLayer);
        pickInfo.pickedLayer.disablePickingIndex(pickInfo.pickedObjectIndex);
      }
      infos = processPickInfo({
        pickInfo,
        lastPickedInfo: this.lastPickedInfo,
        mode: mode2,
        layers: pickableLayers,
        viewports,
        x: x2,
        y: y2,
        z: z2,
        pixelRatio
      });
      for (const info of infos.values()) {
        if (info.layer) {
          result.push(info);
        }
      }
      if (!pickInfo.pickedColor) {
        break;
      }
    }
    for (const layer of affectedLayers) {
      layer.restorePickingColors();
    }
    return { result, emptyInfo: infos.get(null) };
  }
  /** Pick all objects within the given bounding box */
  _pickVisibleObjects({ layers, views, viewports, x: x2, y: y2, width = 1, height = 1, mode: mode2 = "query", maxObjects = null, onViewportActive, effects }) {
    const pickableLayers = this._getPickable(layers);
    if (!pickableLayers || viewports.length === 0) {
      return [];
    }
    this._resizeBuffer();
    const pixelRatio = this.device.canvasContext.cssToDeviceRatio();
    const leftTop = this.device.canvasContext.cssToDevicePixels([x2, y2], true);
    const deviceLeft = leftTop.x;
    const deviceTop = leftTop.y + leftTop.height;
    const rightBottom = this.device.canvasContext.cssToDevicePixels([x2 + width, y2 + height], true);
    const deviceRight = rightBottom.x + rightBottom.width;
    const deviceBottom = rightBottom.y;
    const deviceRect = {
      x: deviceLeft,
      y: deviceBottom,
      // deviceTop and deviceRight represent the first pixel outside the desired rect
      width: deviceRight - deviceLeft,
      height: deviceTop - deviceBottom
    };
    const pickedResult = this._drawAndSample({
      layers: pickableLayers,
      views,
      viewports,
      onViewportActive,
      deviceRect,
      cullRect: { x: x2, y: y2, width, height },
      effects,
      pass: `picking:${mode2}`
    });
    const pickInfos = getUniqueObjects(pickedResult);
    const uniquePickedObjects = /* @__PURE__ */ new Map();
    const uniqueInfos = [];
    const limitMaxObjects = Number.isFinite(maxObjects);
    for (let i2 = 0; i2 < pickInfos.length; i2++) {
      if (limitMaxObjects && uniqueInfos.length >= maxObjects) {
        break;
      }
      const pickInfo = pickInfos[i2];
      let info = {
        color: pickInfo.pickedColor,
        layer: null,
        index: pickInfo.pickedObjectIndex,
        picked: true,
        x: x2,
        y: y2,
        pixelRatio
      };
      info = getLayerPickingInfo({ layer: pickInfo.pickedLayer, info, mode: mode2 });
      const pickedLayerId = info.layer.id;
      if (!uniquePickedObjects.has(pickedLayerId)) {
        uniquePickedObjects.set(pickedLayerId, /* @__PURE__ */ new Set());
      }
      const uniqueObjectsInLayer = uniquePickedObjects.get(pickedLayerId);
      const pickedObjectKey = info.object ?? info.index;
      if (!uniqueObjectsInLayer.has(pickedObjectKey)) {
        uniqueObjectsInLayer.add(pickedObjectKey);
        uniqueInfos.push(info);
      }
    }
    return uniqueInfos;
  }
  _drawAndSample({ layers, views, viewports, onViewportActive, deviceRect, cullRect, effects, pass: pass2 }, pickZ = false) {
    const pickingFBO = pickZ ? this.depthFBO : this.pickingFBO;
    const opts = {
      layers,
      layerFilter: this.layerFilter,
      views,
      viewports,
      onViewportActive,
      pickingFBO,
      deviceRect,
      cullRect,
      effects,
      pass: pass2,
      pickZ,
      preRenderStats: {}
    };
    for (const effect of effects) {
      if (effect.useInPicking) {
        opts.preRenderStats[effect.id] = effect.preRender(opts);
      }
    }
    const { decodePickingColor } = this.pickLayersPass.render(opts);
    const { x: x2, y: y2, width, height } = deviceRect;
    const pickedColors = new (pickZ ? Float32Array : Uint8Array)(width * height * 4);
    this.device.readPixelsToArrayWebGL(pickingFBO, {
      sourceX: x2,
      sourceY: y2,
      sourceWidth: width,
      sourceHeight: height,
      target: pickedColors
    });
    return { pickedColors, decodePickingColor };
  }
  // Calculate a picking rect centered on deviceX and deviceY and clipped to device
  // Returns null if pixel is outside of device
  _getPickingRect({ deviceX, deviceY, deviceRadius, deviceWidth, deviceHeight }) {
    const x2 = Math.max(0, deviceX - deviceRadius);
    const y2 = Math.max(0, deviceY - deviceRadius);
    const width = Math.min(deviceWidth, deviceX + deviceRadius + 1) - x2;
    const height = Math.min(deviceHeight, deviceY + deviceRadius + 1) - y2;
    if (width <= 0 || height <= 0) {
      return null;
    }
    return { x: x2, y: y2, width, height };
  }
}
const PLACEMENTS = {
  "top-left": { top: 0, left: 0 },
  "top-right": { top: 0, right: 0 },
  "bottom-left": { bottom: 0, left: 0 },
  "bottom-right": { bottom: 0, right: 0 },
  fill: { top: 0, left: 0, bottom: 0, right: 0 }
};
const DEFAULT_PLACEMENT = "top-left";
const ROOT_CONTAINER_ID = "__root";
class WidgetManager {
  constructor({ deck, parentElement }) {
    this.defaultWidgets = [];
    this.widgets = [];
    this.resolvedWidgets = [];
    this.containers = {};
    this.lastViewports = {};
    this.deck = deck;
    this.parentElement = parentElement;
  }
  getWidgets() {
    return this.resolvedWidgets;
  }
  /** Declarative API to configure widgets */
  setProps(props) {
    if (props.widgets && !deepEqual(props.widgets, this.widgets, 1)) {
      this._setWidgets(props.widgets);
    }
  }
  finalize() {
    for (const widget of this.getWidgets()) {
      this._remove(widget);
    }
    this.defaultWidgets.length = 0;
    this.resolvedWidgets.length = 0;
    for (const id in this.containers) {
      this.containers[id].remove();
    }
  }
  /** Imperative API. Widgets added this way are not affected by the declarative prop. */
  addDefault(widget) {
    if (!this.defaultWidgets.find((w2) => w2.id === widget.id)) {
      this._add(widget);
      this.defaultWidgets.push(widget);
      this._setWidgets(this.widgets);
    }
  }
  /** Resolve widgets from the declarative prop */
  _setWidgets(nextWidgets) {
    const oldWidgetMap = {};
    for (const widget of this.resolvedWidgets) {
      oldWidgetMap[widget.id] = widget;
    }
    this.resolvedWidgets.length = 0;
    for (const widget of this.defaultWidgets) {
      oldWidgetMap[widget.id] = null;
      this.resolvedWidgets.push(widget);
    }
    for (let widget of nextWidgets) {
      const oldWidget = oldWidgetMap[widget.id];
      if (!oldWidget) {
        this._add(widget);
      } else if (
        // Widget placement changed
        oldWidget.viewId !== widget.viewId || oldWidget.placement !== widget.placement
      ) {
        this._remove(oldWidget);
        this._add(widget);
      } else if (widget !== oldWidget) {
        oldWidget.setProps(widget.props);
        widget = oldWidget;
      }
      oldWidgetMap[widget.id] = null;
      this.resolvedWidgets.push(widget);
    }
    for (const id in oldWidgetMap) {
      const oldWidget = oldWidgetMap[id];
      if (oldWidget) {
        this._remove(oldWidget);
      }
    }
    this.widgets = nextWidgets;
  }
  _add(widget) {
    const { viewId = null, placement = DEFAULT_PLACEMENT } = widget;
    const element = widget.onAdd({ deck: this.deck, viewId });
    if (element) {
      this._getContainer(viewId, placement).append(element);
    }
    widget._element = element;
  }
  _remove(widget) {
    widget.onRemove();
    if (widget._element) {
      widget._element.remove();
    }
    widget._element = void 0;
  }
  /* global document */
  _getContainer(viewId, placement) {
    var _a3;
    const containerId = viewId || ROOT_CONTAINER_ID;
    let viewContainer = this.containers[containerId];
    if (!viewContainer) {
      viewContainer = document.createElement("div");
      viewContainer.style.pointerEvents = "none";
      viewContainer.style.position = "absolute";
      viewContainer.style.overflow = "hidden";
      (_a3 = this.parentElement) == null ? void 0 : _a3.append(viewContainer);
      this.containers[containerId] = viewContainer;
    }
    let container = viewContainer.querySelector(`.${placement}`);
    if (!container) {
      container = document.createElement("div");
      container.className = placement;
      container.style.position = "absolute";
      Object.assign(container.style, PLACEMENTS[placement]);
      viewContainer.append(container);
    }
    return container;
  }
  _updateContainers() {
    const canvasWidth = this.deck.width;
    const canvasHeight = this.deck.height;
    for (const id in this.containers) {
      const viewport = this.lastViewports[id] || null;
      const visible = id === ROOT_CONTAINER_ID || viewport;
      const container = this.containers[id];
      if (visible) {
        container.style.display = "block";
        container.style.left = `${viewport ? viewport.x : 0}px`;
        container.style.top = `${viewport ? viewport.y : 0}px`;
        container.style.width = `${viewport ? viewport.width : canvasWidth}px`;
        container.style.height = `${viewport ? viewport.height : canvasHeight}px`;
      } else {
        container.style.display = "none";
      }
    }
  }
  onRedraw({ viewports, layers }) {
    var _a3, _b3;
    const viewportsById = viewports.reduce((acc, v5) => {
      acc[v5.id] = v5;
      return acc;
    }, {});
    const { lastViewports } = this;
    for (const widget of this.getWidgets()) {
      const { viewId } = widget;
      if (viewId) {
        const viewport = viewportsById[viewId];
        if (viewport) {
          if (widget.onViewportChange && !viewport.equals(lastViewports[viewId])) {
            widget.onViewportChange(viewport);
          }
          (_a3 = widget.onRedraw) == null ? void 0 : _a3.call(widget, { viewports: [viewport], layers });
        }
      } else {
        if (widget.onViewportChange) {
          for (const viewport of viewports) {
            if (!viewport.equals(lastViewports[viewport.id])) {
              widget.onViewportChange(viewport);
            }
          }
        }
        (_b3 = widget.onRedraw) == null ? void 0 : _b3.call(widget, { viewports, layers });
      }
    }
    this.lastViewports = viewportsById;
    this._updateContainers();
  }
  onHover(info, event) {
    var _a3, _b3;
    for (const widget of this.getWidgets()) {
      const { viewId } = widget;
      if (!viewId || viewId === ((_a3 = info.viewport) == null ? void 0 : _a3.id)) {
        (_b3 = widget.onHover) == null ? void 0 : _b3.call(widget, info, event);
      }
    }
  }
  onEvent(info, event) {
    var _a3, _b3;
    const eventOptions = EVENTS$1[event.type];
    if (!eventOptions) {
      return;
    }
    for (const widget of this.getWidgets()) {
      const { viewId } = widget;
      if (!viewId || viewId === ((_a3 = info.viewport) == null ? void 0 : _a3.id)) {
        (_b3 = widget[eventOptions.handler]) == null ? void 0 : _b3.call(widget, info, event);
      }
    }
  }
}
const defaultStyle = {
  zIndex: "1",
  position: "absolute",
  pointerEvents: "none",
  color: "#a0a7b4",
  backgroundColor: "#29323c",
  padding: "10px",
  top: "0",
  left: "0",
  display: "none"
};
class Tooltip {
  constructor() {
    this.id = "default-tooltip";
    this.placement = "fill";
    this.props = {};
    this.isVisible = false;
  }
  onAdd({ deck }) {
    const el = document.createElement("div");
    el.className = "deck-tooltip";
    Object.assign(el.style, defaultStyle);
    this.deck = deck;
    this.element = el;
    return el;
  }
  onRemove() {
    this.deck = void 0;
    this.element = void 0;
  }
  setProps() {
  }
  onViewportChange(viewport) {
    var _a3;
    if (this.isVisible && viewport.id === ((_a3 = this.lastViewport) == null ? void 0 : _a3.id) && viewport !== this.lastViewport) {
      this.setTooltip(null);
    }
  }
  onHover(info) {
    const { deck } = this;
    const getTooltip = deck && deck.props.getTooltip;
    if (!getTooltip) {
      return;
    }
    const displayInfo = getTooltip(info);
    this.lastViewport = info.viewport;
    this.setTooltip(displayInfo, info.x, info.y);
  }
  setTooltip(displayInfo, x2, y2) {
    const el = this.element;
    if (!el) {
      return;
    }
    if (typeof displayInfo === "string") {
      el.innerText = displayInfo;
    } else if (!displayInfo) {
      this.isVisible = false;
      el.style.display = "none";
      return;
    } else {
      if (displayInfo.text) {
        el.innerText = displayInfo.text;
      }
      if (displayInfo.html) {
        el.innerHTML = displayInfo.html;
      }
      if (displayInfo.className) {
        el.className = displayInfo.className;
      }
    }
    this.isVisible = true;
    el.style.display = "block";
    el.style.transform = `translate(${x2}px, ${y2}px)`;
    if (displayInfo && typeof displayInfo === "object" && "style" in displayInfo) {
      Object.assign(el.style, displayInfo.style);
    }
  }
}
var GLEnum$3;
(function(GLEnum2) {
  GLEnum2[GLEnum2["DEPTH_BUFFER_BIT"] = 256] = "DEPTH_BUFFER_BIT";
  GLEnum2[GLEnum2["STENCIL_BUFFER_BIT"] = 1024] = "STENCIL_BUFFER_BIT";
  GLEnum2[GLEnum2["COLOR_BUFFER_BIT"] = 16384] = "COLOR_BUFFER_BIT";
  GLEnum2[GLEnum2["POINTS"] = 0] = "POINTS";
  GLEnum2[GLEnum2["LINES"] = 1] = "LINES";
  GLEnum2[GLEnum2["LINE_LOOP"] = 2] = "LINE_LOOP";
  GLEnum2[GLEnum2["LINE_STRIP"] = 3] = "LINE_STRIP";
  GLEnum2[GLEnum2["TRIANGLES"] = 4] = "TRIANGLES";
  GLEnum2[GLEnum2["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
  GLEnum2[GLEnum2["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
  GLEnum2[GLEnum2["ZERO"] = 0] = "ZERO";
  GLEnum2[GLEnum2["ONE"] = 1] = "ONE";
  GLEnum2[GLEnum2["SRC_COLOR"] = 768] = "SRC_COLOR";
  GLEnum2[GLEnum2["ONE_MINUS_SRC_COLOR"] = 769] = "ONE_MINUS_SRC_COLOR";
  GLEnum2[GLEnum2["SRC_ALPHA"] = 770] = "SRC_ALPHA";
  GLEnum2[GLEnum2["ONE_MINUS_SRC_ALPHA"] = 771] = "ONE_MINUS_SRC_ALPHA";
  GLEnum2[GLEnum2["DST_ALPHA"] = 772] = "DST_ALPHA";
  GLEnum2[GLEnum2["ONE_MINUS_DST_ALPHA"] = 773] = "ONE_MINUS_DST_ALPHA";
  GLEnum2[GLEnum2["DST_COLOR"] = 774] = "DST_COLOR";
  GLEnum2[GLEnum2["ONE_MINUS_DST_COLOR"] = 775] = "ONE_MINUS_DST_COLOR";
  GLEnum2[GLEnum2["SRC_ALPHA_SATURATE"] = 776] = "SRC_ALPHA_SATURATE";
  GLEnum2[GLEnum2["CONSTANT_COLOR"] = 32769] = "CONSTANT_COLOR";
  GLEnum2[GLEnum2["ONE_MINUS_CONSTANT_COLOR"] = 32770] = "ONE_MINUS_CONSTANT_COLOR";
  GLEnum2[GLEnum2["CONSTANT_ALPHA"] = 32771] = "CONSTANT_ALPHA";
  GLEnum2[GLEnum2["ONE_MINUS_CONSTANT_ALPHA"] = 32772] = "ONE_MINUS_CONSTANT_ALPHA";
  GLEnum2[GLEnum2["FUNC_ADD"] = 32774] = "FUNC_ADD";
  GLEnum2[GLEnum2["FUNC_SUBTRACT"] = 32778] = "FUNC_SUBTRACT";
  GLEnum2[GLEnum2["FUNC_REVERSE_SUBTRACT"] = 32779] = "FUNC_REVERSE_SUBTRACT";
  GLEnum2[GLEnum2["BLEND_EQUATION"] = 32777] = "BLEND_EQUATION";
  GLEnum2[GLEnum2["BLEND_EQUATION_RGB"] = 32777] = "BLEND_EQUATION_RGB";
  GLEnum2[GLEnum2["BLEND_EQUATION_ALPHA"] = 34877] = "BLEND_EQUATION_ALPHA";
  GLEnum2[GLEnum2["BLEND_DST_RGB"] = 32968] = "BLEND_DST_RGB";
  GLEnum2[GLEnum2["BLEND_SRC_RGB"] = 32969] = "BLEND_SRC_RGB";
  GLEnum2[GLEnum2["BLEND_DST_ALPHA"] = 32970] = "BLEND_DST_ALPHA";
  GLEnum2[GLEnum2["BLEND_SRC_ALPHA"] = 32971] = "BLEND_SRC_ALPHA";
  GLEnum2[GLEnum2["BLEND_COLOR"] = 32773] = "BLEND_COLOR";
  GLEnum2[GLEnum2["ARRAY_BUFFER_BINDING"] = 34964] = "ARRAY_BUFFER_BINDING";
  GLEnum2[GLEnum2["ELEMENT_ARRAY_BUFFER_BINDING"] = 34965] = "ELEMENT_ARRAY_BUFFER_BINDING";
  GLEnum2[GLEnum2["LINE_WIDTH"] = 2849] = "LINE_WIDTH";
  GLEnum2[GLEnum2["ALIASED_POINT_SIZE_RANGE"] = 33901] = "ALIASED_POINT_SIZE_RANGE";
  GLEnum2[GLEnum2["ALIASED_LINE_WIDTH_RANGE"] = 33902] = "ALIASED_LINE_WIDTH_RANGE";
  GLEnum2[GLEnum2["CULL_FACE_MODE"] = 2885] = "CULL_FACE_MODE";
  GLEnum2[GLEnum2["FRONT_FACE"] = 2886] = "FRONT_FACE";
  GLEnum2[GLEnum2["DEPTH_RANGE"] = 2928] = "DEPTH_RANGE";
  GLEnum2[GLEnum2["DEPTH_WRITEMASK"] = 2930] = "DEPTH_WRITEMASK";
  GLEnum2[GLEnum2["DEPTH_CLEAR_VALUE"] = 2931] = "DEPTH_CLEAR_VALUE";
  GLEnum2[GLEnum2["DEPTH_FUNC"] = 2932] = "DEPTH_FUNC";
  GLEnum2[GLEnum2["STENCIL_CLEAR_VALUE"] = 2961] = "STENCIL_CLEAR_VALUE";
  GLEnum2[GLEnum2["STENCIL_FUNC"] = 2962] = "STENCIL_FUNC";
  GLEnum2[GLEnum2["STENCIL_FAIL"] = 2964] = "STENCIL_FAIL";
  GLEnum2[GLEnum2["STENCIL_PASS_DEPTH_FAIL"] = 2965] = "STENCIL_PASS_DEPTH_FAIL";
  GLEnum2[GLEnum2["STENCIL_PASS_DEPTH_PASS"] = 2966] = "STENCIL_PASS_DEPTH_PASS";
  GLEnum2[GLEnum2["STENCIL_REF"] = 2967] = "STENCIL_REF";
  GLEnum2[GLEnum2["STENCIL_VALUE_MASK"] = 2963] = "STENCIL_VALUE_MASK";
  GLEnum2[GLEnum2["STENCIL_WRITEMASK"] = 2968] = "STENCIL_WRITEMASK";
  GLEnum2[GLEnum2["STENCIL_BACK_FUNC"] = 34816] = "STENCIL_BACK_FUNC";
  GLEnum2[GLEnum2["STENCIL_BACK_FAIL"] = 34817] = "STENCIL_BACK_FAIL";
  GLEnum2[GLEnum2["STENCIL_BACK_PASS_DEPTH_FAIL"] = 34818] = "STENCIL_BACK_PASS_DEPTH_FAIL";
  GLEnum2[GLEnum2["STENCIL_BACK_PASS_DEPTH_PASS"] = 34819] = "STENCIL_BACK_PASS_DEPTH_PASS";
  GLEnum2[GLEnum2["STENCIL_BACK_REF"] = 36003] = "STENCIL_BACK_REF";
  GLEnum2[GLEnum2["STENCIL_BACK_VALUE_MASK"] = 36004] = "STENCIL_BACK_VALUE_MASK";
  GLEnum2[GLEnum2["STENCIL_BACK_WRITEMASK"] = 36005] = "STENCIL_BACK_WRITEMASK";
  GLEnum2[GLEnum2["VIEWPORT"] = 2978] = "VIEWPORT";
  GLEnum2[GLEnum2["SCISSOR_BOX"] = 3088] = "SCISSOR_BOX";
  GLEnum2[GLEnum2["COLOR_CLEAR_VALUE"] = 3106] = "COLOR_CLEAR_VALUE";
  GLEnum2[GLEnum2["COLOR_WRITEMASK"] = 3107] = "COLOR_WRITEMASK";
  GLEnum2[GLEnum2["UNPACK_ALIGNMENT"] = 3317] = "UNPACK_ALIGNMENT";
  GLEnum2[GLEnum2["PACK_ALIGNMENT"] = 3333] = "PACK_ALIGNMENT";
  GLEnum2[GLEnum2["MAX_TEXTURE_SIZE"] = 3379] = "MAX_TEXTURE_SIZE";
  GLEnum2[GLEnum2["MAX_VIEWPORT_DIMS"] = 3386] = "MAX_VIEWPORT_DIMS";
  GLEnum2[GLEnum2["SUBPIXEL_BITS"] = 3408] = "SUBPIXEL_BITS";
  GLEnum2[GLEnum2["RED_BITS"] = 3410] = "RED_BITS";
  GLEnum2[GLEnum2["GREEN_BITS"] = 3411] = "GREEN_BITS";
  GLEnum2[GLEnum2["BLUE_BITS"] = 3412] = "BLUE_BITS";
  GLEnum2[GLEnum2["ALPHA_BITS"] = 3413] = "ALPHA_BITS";
  GLEnum2[GLEnum2["DEPTH_BITS"] = 3414] = "DEPTH_BITS";
  GLEnum2[GLEnum2["STENCIL_BITS"] = 3415] = "STENCIL_BITS";
  GLEnum2[GLEnum2["POLYGON_OFFSET_UNITS"] = 10752] = "POLYGON_OFFSET_UNITS";
  GLEnum2[GLEnum2["POLYGON_OFFSET_FACTOR"] = 32824] = "POLYGON_OFFSET_FACTOR";
  GLEnum2[GLEnum2["TEXTURE_BINDING_2D"] = 32873] = "TEXTURE_BINDING_2D";
  GLEnum2[GLEnum2["SAMPLE_BUFFERS"] = 32936] = "SAMPLE_BUFFERS";
  GLEnum2[GLEnum2["SAMPLES"] = 32937] = "SAMPLES";
  GLEnum2[GLEnum2["SAMPLE_COVERAGE_VALUE"] = 32938] = "SAMPLE_COVERAGE_VALUE";
  GLEnum2[GLEnum2["SAMPLE_COVERAGE_INVERT"] = 32939] = "SAMPLE_COVERAGE_INVERT";
  GLEnum2[GLEnum2["COMPRESSED_TEXTURE_FORMATS"] = 34467] = "COMPRESSED_TEXTURE_FORMATS";
  GLEnum2[GLEnum2["VENDOR"] = 7936] = "VENDOR";
  GLEnum2[GLEnum2["RENDERER"] = 7937] = "RENDERER";
  GLEnum2[GLEnum2["VERSION"] = 7938] = "VERSION";
  GLEnum2[GLEnum2["IMPLEMENTATION_COLOR_READ_TYPE"] = 35738] = "IMPLEMENTATION_COLOR_READ_TYPE";
  GLEnum2[GLEnum2["IMPLEMENTATION_COLOR_READ_FORMAT"] = 35739] = "IMPLEMENTATION_COLOR_READ_FORMAT";
  GLEnum2[GLEnum2["BROWSER_DEFAULT_WEBGL"] = 37444] = "BROWSER_DEFAULT_WEBGL";
  GLEnum2[GLEnum2["STATIC_DRAW"] = 35044] = "STATIC_DRAW";
  GLEnum2[GLEnum2["STREAM_DRAW"] = 35040] = "STREAM_DRAW";
  GLEnum2[GLEnum2["DYNAMIC_DRAW"] = 35048] = "DYNAMIC_DRAW";
  GLEnum2[GLEnum2["ARRAY_BUFFER"] = 34962] = "ARRAY_BUFFER";
  GLEnum2[GLEnum2["ELEMENT_ARRAY_BUFFER"] = 34963] = "ELEMENT_ARRAY_BUFFER";
  GLEnum2[GLEnum2["BUFFER_SIZE"] = 34660] = "BUFFER_SIZE";
  GLEnum2[GLEnum2["BUFFER_USAGE"] = 34661] = "BUFFER_USAGE";
  GLEnum2[GLEnum2["CURRENT_VERTEX_ATTRIB"] = 34342] = "CURRENT_VERTEX_ATTRIB";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_ENABLED"] = 34338] = "VERTEX_ATTRIB_ARRAY_ENABLED";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_SIZE"] = 34339] = "VERTEX_ATTRIB_ARRAY_SIZE";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_STRIDE"] = 34340] = "VERTEX_ATTRIB_ARRAY_STRIDE";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_TYPE"] = 34341] = "VERTEX_ATTRIB_ARRAY_TYPE";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_NORMALIZED"] = 34922] = "VERTEX_ATTRIB_ARRAY_NORMALIZED";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_POINTER"] = 34373] = "VERTEX_ATTRIB_ARRAY_POINTER";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_BUFFER_BINDING"] = 34975] = "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING";
  GLEnum2[GLEnum2["CULL_FACE"] = 2884] = "CULL_FACE";
  GLEnum2[GLEnum2["FRONT"] = 1028] = "FRONT";
  GLEnum2[GLEnum2["BACK"] = 1029] = "BACK";
  GLEnum2[GLEnum2["FRONT_AND_BACK"] = 1032] = "FRONT_AND_BACK";
  GLEnum2[GLEnum2["BLEND"] = 3042] = "BLEND";
  GLEnum2[GLEnum2["DEPTH_TEST"] = 2929] = "DEPTH_TEST";
  GLEnum2[GLEnum2["DITHER"] = 3024] = "DITHER";
  GLEnum2[GLEnum2["POLYGON_OFFSET_FILL"] = 32823] = "POLYGON_OFFSET_FILL";
  GLEnum2[GLEnum2["SAMPLE_ALPHA_TO_COVERAGE"] = 32926] = "SAMPLE_ALPHA_TO_COVERAGE";
  GLEnum2[GLEnum2["SAMPLE_COVERAGE"] = 32928] = "SAMPLE_COVERAGE";
  GLEnum2[GLEnum2["SCISSOR_TEST"] = 3089] = "SCISSOR_TEST";
  GLEnum2[GLEnum2["STENCIL_TEST"] = 2960] = "STENCIL_TEST";
  GLEnum2[GLEnum2["NO_ERROR"] = 0] = "NO_ERROR";
  GLEnum2[GLEnum2["INVALID_ENUM"] = 1280] = "INVALID_ENUM";
  GLEnum2[GLEnum2["INVALID_VALUE"] = 1281] = "INVALID_VALUE";
  GLEnum2[GLEnum2["INVALID_OPERATION"] = 1282] = "INVALID_OPERATION";
  GLEnum2[GLEnum2["OUT_OF_MEMORY"] = 1285] = "OUT_OF_MEMORY";
  GLEnum2[GLEnum2["CONTEXT_LOST_WEBGL"] = 37442] = "CONTEXT_LOST_WEBGL";
  GLEnum2[GLEnum2["CW"] = 2304] = "CW";
  GLEnum2[GLEnum2["CCW"] = 2305] = "CCW";
  GLEnum2[GLEnum2["DONT_CARE"] = 4352] = "DONT_CARE";
  GLEnum2[GLEnum2["FASTEST"] = 4353] = "FASTEST";
  GLEnum2[GLEnum2["NICEST"] = 4354] = "NICEST";
  GLEnum2[GLEnum2["GENERATE_MIPMAP_HINT"] = 33170] = "GENERATE_MIPMAP_HINT";
  GLEnum2[GLEnum2["BYTE"] = 5120] = "BYTE";
  GLEnum2[GLEnum2["UNSIGNED_BYTE"] = 5121] = "UNSIGNED_BYTE";
  GLEnum2[GLEnum2["SHORT"] = 5122] = "SHORT";
  GLEnum2[GLEnum2["UNSIGNED_SHORT"] = 5123] = "UNSIGNED_SHORT";
  GLEnum2[GLEnum2["INT"] = 5124] = "INT";
  GLEnum2[GLEnum2["UNSIGNED_INT"] = 5125] = "UNSIGNED_INT";
  GLEnum2[GLEnum2["FLOAT"] = 5126] = "FLOAT";
  GLEnum2[GLEnum2["DOUBLE"] = 5130] = "DOUBLE";
  GLEnum2[GLEnum2["DEPTH_COMPONENT"] = 6402] = "DEPTH_COMPONENT";
  GLEnum2[GLEnum2["ALPHA"] = 6406] = "ALPHA";
  GLEnum2[GLEnum2["RGB"] = 6407] = "RGB";
  GLEnum2[GLEnum2["RGBA"] = 6408] = "RGBA";
  GLEnum2[GLEnum2["LUMINANCE"] = 6409] = "LUMINANCE";
  GLEnum2[GLEnum2["LUMINANCE_ALPHA"] = 6410] = "LUMINANCE_ALPHA";
  GLEnum2[GLEnum2["UNSIGNED_SHORT_4_4_4_4"] = 32819] = "UNSIGNED_SHORT_4_4_4_4";
  GLEnum2[GLEnum2["UNSIGNED_SHORT_5_5_5_1"] = 32820] = "UNSIGNED_SHORT_5_5_5_1";
  GLEnum2[GLEnum2["UNSIGNED_SHORT_5_6_5"] = 33635] = "UNSIGNED_SHORT_5_6_5";
  GLEnum2[GLEnum2["FRAGMENT_SHADER"] = 35632] = "FRAGMENT_SHADER";
  GLEnum2[GLEnum2["VERTEX_SHADER"] = 35633] = "VERTEX_SHADER";
  GLEnum2[GLEnum2["COMPILE_STATUS"] = 35713] = "COMPILE_STATUS";
  GLEnum2[GLEnum2["DELETE_STATUS"] = 35712] = "DELETE_STATUS";
  GLEnum2[GLEnum2["LINK_STATUS"] = 35714] = "LINK_STATUS";
  GLEnum2[GLEnum2["VALIDATE_STATUS"] = 35715] = "VALIDATE_STATUS";
  GLEnum2[GLEnum2["ATTACHED_SHADERS"] = 35717] = "ATTACHED_SHADERS";
  GLEnum2[GLEnum2["ACTIVE_ATTRIBUTES"] = 35721] = "ACTIVE_ATTRIBUTES";
  GLEnum2[GLEnum2["ACTIVE_UNIFORMS"] = 35718] = "ACTIVE_UNIFORMS";
  GLEnum2[GLEnum2["MAX_VERTEX_ATTRIBS"] = 34921] = "MAX_VERTEX_ATTRIBS";
  GLEnum2[GLEnum2["MAX_VERTEX_UNIFORM_VECTORS"] = 36347] = "MAX_VERTEX_UNIFORM_VECTORS";
  GLEnum2[GLEnum2["MAX_VARYING_VECTORS"] = 36348] = "MAX_VARYING_VECTORS";
  GLEnum2[GLEnum2["MAX_COMBINED_TEXTURE_IMAGE_UNITS"] = 35661] = "MAX_COMBINED_TEXTURE_IMAGE_UNITS";
  GLEnum2[GLEnum2["MAX_VERTEX_TEXTURE_IMAGE_UNITS"] = 35660] = "MAX_VERTEX_TEXTURE_IMAGE_UNITS";
  GLEnum2[GLEnum2["MAX_TEXTURE_IMAGE_UNITS"] = 34930] = "MAX_TEXTURE_IMAGE_UNITS";
  GLEnum2[GLEnum2["MAX_FRAGMENT_UNIFORM_VECTORS"] = 36349] = "MAX_FRAGMENT_UNIFORM_VECTORS";
  GLEnum2[GLEnum2["SHADER_TYPE"] = 35663] = "SHADER_TYPE";
  GLEnum2[GLEnum2["SHADING_LANGUAGE_VERSION"] = 35724] = "SHADING_LANGUAGE_VERSION";
  GLEnum2[GLEnum2["CURRENT_PROGRAM"] = 35725] = "CURRENT_PROGRAM";
  GLEnum2[GLEnum2["NEVER"] = 512] = "NEVER";
  GLEnum2[GLEnum2["LESS"] = 513] = "LESS";
  GLEnum2[GLEnum2["EQUAL"] = 514] = "EQUAL";
  GLEnum2[GLEnum2["LEQUAL"] = 515] = "LEQUAL";
  GLEnum2[GLEnum2["GREATER"] = 516] = "GREATER";
  GLEnum2[GLEnum2["NOTEQUAL"] = 517] = "NOTEQUAL";
  GLEnum2[GLEnum2["GEQUAL"] = 518] = "GEQUAL";
  GLEnum2[GLEnum2["ALWAYS"] = 519] = "ALWAYS";
  GLEnum2[GLEnum2["KEEP"] = 7680] = "KEEP";
  GLEnum2[GLEnum2["REPLACE"] = 7681] = "REPLACE";
  GLEnum2[GLEnum2["INCR"] = 7682] = "INCR";
  GLEnum2[GLEnum2["DECR"] = 7683] = "DECR";
  GLEnum2[GLEnum2["INVERT"] = 5386] = "INVERT";
  GLEnum2[GLEnum2["INCR_WRAP"] = 34055] = "INCR_WRAP";
  GLEnum2[GLEnum2["DECR_WRAP"] = 34056] = "DECR_WRAP";
  GLEnum2[GLEnum2["NEAREST"] = 9728] = "NEAREST";
  GLEnum2[GLEnum2["LINEAR"] = 9729] = "LINEAR";
  GLEnum2[GLEnum2["NEAREST_MIPMAP_NEAREST"] = 9984] = "NEAREST_MIPMAP_NEAREST";
  GLEnum2[GLEnum2["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
  GLEnum2[GLEnum2["NEAREST_MIPMAP_LINEAR"] = 9986] = "NEAREST_MIPMAP_LINEAR";
  GLEnum2[GLEnum2["LINEAR_MIPMAP_LINEAR"] = 9987] = "LINEAR_MIPMAP_LINEAR";
  GLEnum2[GLEnum2["TEXTURE_MAG_FILTER"] = 10240] = "TEXTURE_MAG_FILTER";
  GLEnum2[GLEnum2["TEXTURE_MIN_FILTER"] = 10241] = "TEXTURE_MIN_FILTER";
  GLEnum2[GLEnum2["TEXTURE_WRAP_S"] = 10242] = "TEXTURE_WRAP_S";
  GLEnum2[GLEnum2["TEXTURE_WRAP_T"] = 10243] = "TEXTURE_WRAP_T";
  GLEnum2[GLEnum2["TEXTURE_2D"] = 3553] = "TEXTURE_2D";
  GLEnum2[GLEnum2["TEXTURE"] = 5890] = "TEXTURE";
  GLEnum2[GLEnum2["TEXTURE_CUBE_MAP"] = 34067] = "TEXTURE_CUBE_MAP";
  GLEnum2[GLEnum2["TEXTURE_BINDING_CUBE_MAP"] = 34068] = "TEXTURE_BINDING_CUBE_MAP";
  GLEnum2[GLEnum2["TEXTURE_CUBE_MAP_POSITIVE_X"] = 34069] = "TEXTURE_CUBE_MAP_POSITIVE_X";
  GLEnum2[GLEnum2["TEXTURE_CUBE_MAP_NEGATIVE_X"] = 34070] = "TEXTURE_CUBE_MAP_NEGATIVE_X";
  GLEnum2[GLEnum2["TEXTURE_CUBE_MAP_POSITIVE_Y"] = 34071] = "TEXTURE_CUBE_MAP_POSITIVE_Y";
  GLEnum2[GLEnum2["TEXTURE_CUBE_MAP_NEGATIVE_Y"] = 34072] = "TEXTURE_CUBE_MAP_NEGATIVE_Y";
  GLEnum2[GLEnum2["TEXTURE_CUBE_MAP_POSITIVE_Z"] = 34073] = "TEXTURE_CUBE_MAP_POSITIVE_Z";
  GLEnum2[GLEnum2["TEXTURE_CUBE_MAP_NEGATIVE_Z"] = 34074] = "TEXTURE_CUBE_MAP_NEGATIVE_Z";
  GLEnum2[GLEnum2["MAX_CUBE_MAP_TEXTURE_SIZE"] = 34076] = "MAX_CUBE_MAP_TEXTURE_SIZE";
  GLEnum2[GLEnum2["TEXTURE0"] = 33984] = "TEXTURE0";
  GLEnum2[GLEnum2["ACTIVE_TEXTURE"] = 34016] = "ACTIVE_TEXTURE";
  GLEnum2[GLEnum2["REPEAT"] = 10497] = "REPEAT";
  GLEnum2[GLEnum2["CLAMP_TO_EDGE"] = 33071] = "CLAMP_TO_EDGE";
  GLEnum2[GLEnum2["MIRRORED_REPEAT"] = 33648] = "MIRRORED_REPEAT";
  GLEnum2[GLEnum2["TEXTURE_WIDTH"] = 4096] = "TEXTURE_WIDTH";
  GLEnum2[GLEnum2["TEXTURE_HEIGHT"] = 4097] = "TEXTURE_HEIGHT";
  GLEnum2[GLEnum2["FLOAT_VEC2"] = 35664] = "FLOAT_VEC2";
  GLEnum2[GLEnum2["FLOAT_VEC3"] = 35665] = "FLOAT_VEC3";
  GLEnum2[GLEnum2["FLOAT_VEC4"] = 35666] = "FLOAT_VEC4";
  GLEnum2[GLEnum2["INT_VEC2"] = 35667] = "INT_VEC2";
  GLEnum2[GLEnum2["INT_VEC3"] = 35668] = "INT_VEC3";
  GLEnum2[GLEnum2["INT_VEC4"] = 35669] = "INT_VEC4";
  GLEnum2[GLEnum2["BOOL"] = 35670] = "BOOL";
  GLEnum2[GLEnum2["BOOL_VEC2"] = 35671] = "BOOL_VEC2";
  GLEnum2[GLEnum2["BOOL_VEC3"] = 35672] = "BOOL_VEC3";
  GLEnum2[GLEnum2["BOOL_VEC4"] = 35673] = "BOOL_VEC4";
  GLEnum2[GLEnum2["FLOAT_MAT2"] = 35674] = "FLOAT_MAT2";
  GLEnum2[GLEnum2["FLOAT_MAT3"] = 35675] = "FLOAT_MAT3";
  GLEnum2[GLEnum2["FLOAT_MAT4"] = 35676] = "FLOAT_MAT4";
  GLEnum2[GLEnum2["SAMPLER_2D"] = 35678] = "SAMPLER_2D";
  GLEnum2[GLEnum2["SAMPLER_CUBE"] = 35680] = "SAMPLER_CUBE";
  GLEnum2[GLEnum2["LOW_FLOAT"] = 36336] = "LOW_FLOAT";
  GLEnum2[GLEnum2["MEDIUM_FLOAT"] = 36337] = "MEDIUM_FLOAT";
  GLEnum2[GLEnum2["HIGH_FLOAT"] = 36338] = "HIGH_FLOAT";
  GLEnum2[GLEnum2["LOW_INT"] = 36339] = "LOW_INT";
  GLEnum2[GLEnum2["MEDIUM_INT"] = 36340] = "MEDIUM_INT";
  GLEnum2[GLEnum2["HIGH_INT"] = 36341] = "HIGH_INT";
  GLEnum2[GLEnum2["FRAMEBUFFER"] = 36160] = "FRAMEBUFFER";
  GLEnum2[GLEnum2["RENDERBUFFER"] = 36161] = "RENDERBUFFER";
  GLEnum2[GLEnum2["RGBA4"] = 32854] = "RGBA4";
  GLEnum2[GLEnum2["RGB5_A1"] = 32855] = "RGB5_A1";
  GLEnum2[GLEnum2["RGB565"] = 36194] = "RGB565";
  GLEnum2[GLEnum2["DEPTH_COMPONENT16"] = 33189] = "DEPTH_COMPONENT16";
  GLEnum2[GLEnum2["STENCIL_INDEX"] = 6401] = "STENCIL_INDEX";
  GLEnum2[GLEnum2["STENCIL_INDEX8"] = 36168] = "STENCIL_INDEX8";
  GLEnum2[GLEnum2["DEPTH_STENCIL"] = 34041] = "DEPTH_STENCIL";
  GLEnum2[GLEnum2["RENDERBUFFER_WIDTH"] = 36162] = "RENDERBUFFER_WIDTH";
  GLEnum2[GLEnum2["RENDERBUFFER_HEIGHT"] = 36163] = "RENDERBUFFER_HEIGHT";
  GLEnum2[GLEnum2["RENDERBUFFER_INTERNAL_FORMAT"] = 36164] = "RENDERBUFFER_INTERNAL_FORMAT";
  GLEnum2[GLEnum2["RENDERBUFFER_RED_SIZE"] = 36176] = "RENDERBUFFER_RED_SIZE";
  GLEnum2[GLEnum2["RENDERBUFFER_GREEN_SIZE"] = 36177] = "RENDERBUFFER_GREEN_SIZE";
  GLEnum2[GLEnum2["RENDERBUFFER_BLUE_SIZE"] = 36178] = "RENDERBUFFER_BLUE_SIZE";
  GLEnum2[GLEnum2["RENDERBUFFER_ALPHA_SIZE"] = 36179] = "RENDERBUFFER_ALPHA_SIZE";
  GLEnum2[GLEnum2["RENDERBUFFER_DEPTH_SIZE"] = 36180] = "RENDERBUFFER_DEPTH_SIZE";
  GLEnum2[GLEnum2["RENDERBUFFER_STENCIL_SIZE"] = 36181] = "RENDERBUFFER_STENCIL_SIZE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE"] = 36048] = "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_OBJECT_NAME"] = 36049] = "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL"] = 36050] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE"] = 36051] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT0"] = 36064] = "COLOR_ATTACHMENT0";
  GLEnum2[GLEnum2["DEPTH_ATTACHMENT"] = 36096] = "DEPTH_ATTACHMENT";
  GLEnum2[GLEnum2["STENCIL_ATTACHMENT"] = 36128] = "STENCIL_ATTACHMENT";
  GLEnum2[GLEnum2["DEPTH_STENCIL_ATTACHMENT"] = 33306] = "DEPTH_STENCIL_ATTACHMENT";
  GLEnum2[GLEnum2["NONE"] = 0] = "NONE";
  GLEnum2[GLEnum2["FRAMEBUFFER_COMPLETE"] = 36053] = "FRAMEBUFFER_COMPLETE";
  GLEnum2[GLEnum2["FRAMEBUFFER_INCOMPLETE_ATTACHMENT"] = 36054] = "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
  GLEnum2[GLEnum2["FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT"] = 36055] = "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
  GLEnum2[GLEnum2["FRAMEBUFFER_INCOMPLETE_DIMENSIONS"] = 36057] = "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
  GLEnum2[GLEnum2["FRAMEBUFFER_UNSUPPORTED"] = 36061] = "FRAMEBUFFER_UNSUPPORTED";
  GLEnum2[GLEnum2["FRAMEBUFFER_BINDING"] = 36006] = "FRAMEBUFFER_BINDING";
  GLEnum2[GLEnum2["RENDERBUFFER_BINDING"] = 36007] = "RENDERBUFFER_BINDING";
  GLEnum2[GLEnum2["READ_FRAMEBUFFER"] = 36008] = "READ_FRAMEBUFFER";
  GLEnum2[GLEnum2["DRAW_FRAMEBUFFER"] = 36009] = "DRAW_FRAMEBUFFER";
  GLEnum2[GLEnum2["MAX_RENDERBUFFER_SIZE"] = 34024] = "MAX_RENDERBUFFER_SIZE";
  GLEnum2[GLEnum2["INVALID_FRAMEBUFFER_OPERATION"] = 1286] = "INVALID_FRAMEBUFFER_OPERATION";
  GLEnum2[GLEnum2["UNPACK_FLIP_Y_WEBGL"] = 37440] = "UNPACK_FLIP_Y_WEBGL";
  GLEnum2[GLEnum2["UNPACK_PREMULTIPLY_ALPHA_WEBGL"] = 37441] = "UNPACK_PREMULTIPLY_ALPHA_WEBGL";
  GLEnum2[GLEnum2["UNPACK_COLORSPACE_CONVERSION_WEBGL"] = 37443] = "UNPACK_COLORSPACE_CONVERSION_WEBGL";
  GLEnum2[GLEnum2["READ_BUFFER"] = 3074] = "READ_BUFFER";
  GLEnum2[GLEnum2["UNPACK_ROW_LENGTH"] = 3314] = "UNPACK_ROW_LENGTH";
  GLEnum2[GLEnum2["UNPACK_SKIP_ROWS"] = 3315] = "UNPACK_SKIP_ROWS";
  GLEnum2[GLEnum2["UNPACK_SKIP_PIXELS"] = 3316] = "UNPACK_SKIP_PIXELS";
  GLEnum2[GLEnum2["PACK_ROW_LENGTH"] = 3330] = "PACK_ROW_LENGTH";
  GLEnum2[GLEnum2["PACK_SKIP_ROWS"] = 3331] = "PACK_SKIP_ROWS";
  GLEnum2[GLEnum2["PACK_SKIP_PIXELS"] = 3332] = "PACK_SKIP_PIXELS";
  GLEnum2[GLEnum2["TEXTURE_BINDING_3D"] = 32874] = "TEXTURE_BINDING_3D";
  GLEnum2[GLEnum2["UNPACK_SKIP_IMAGES"] = 32877] = "UNPACK_SKIP_IMAGES";
  GLEnum2[GLEnum2["UNPACK_IMAGE_HEIGHT"] = 32878] = "UNPACK_IMAGE_HEIGHT";
  GLEnum2[GLEnum2["MAX_3D_TEXTURE_SIZE"] = 32883] = "MAX_3D_TEXTURE_SIZE";
  GLEnum2[GLEnum2["MAX_ELEMENTS_VERTICES"] = 33e3] = "MAX_ELEMENTS_VERTICES";
  GLEnum2[GLEnum2["MAX_ELEMENTS_INDICES"] = 33001] = "MAX_ELEMENTS_INDICES";
  GLEnum2[GLEnum2["MAX_TEXTURE_LOD_BIAS"] = 34045] = "MAX_TEXTURE_LOD_BIAS";
  GLEnum2[GLEnum2["MAX_FRAGMENT_UNIFORM_COMPONENTS"] = 35657] = "MAX_FRAGMENT_UNIFORM_COMPONENTS";
  GLEnum2[GLEnum2["MAX_VERTEX_UNIFORM_COMPONENTS"] = 35658] = "MAX_VERTEX_UNIFORM_COMPONENTS";
  GLEnum2[GLEnum2["MAX_ARRAY_TEXTURE_LAYERS"] = 35071] = "MAX_ARRAY_TEXTURE_LAYERS";
  GLEnum2[GLEnum2["MIN_PROGRAM_TEXEL_OFFSET"] = 35076] = "MIN_PROGRAM_TEXEL_OFFSET";
  GLEnum2[GLEnum2["MAX_PROGRAM_TEXEL_OFFSET"] = 35077] = "MAX_PROGRAM_TEXEL_OFFSET";
  GLEnum2[GLEnum2["MAX_VARYING_COMPONENTS"] = 35659] = "MAX_VARYING_COMPONENTS";
  GLEnum2[GLEnum2["FRAGMENT_SHADER_DERIVATIVE_HINT"] = 35723] = "FRAGMENT_SHADER_DERIVATIVE_HINT";
  GLEnum2[GLEnum2["RASTERIZER_DISCARD"] = 35977] = "RASTERIZER_DISCARD";
  GLEnum2[GLEnum2["VERTEX_ARRAY_BINDING"] = 34229] = "VERTEX_ARRAY_BINDING";
  GLEnum2[GLEnum2["MAX_VERTEX_OUTPUT_COMPONENTS"] = 37154] = "MAX_VERTEX_OUTPUT_COMPONENTS";
  GLEnum2[GLEnum2["MAX_FRAGMENT_INPUT_COMPONENTS"] = 37157] = "MAX_FRAGMENT_INPUT_COMPONENTS";
  GLEnum2[GLEnum2["MAX_SERVER_WAIT_TIMEOUT"] = 37137] = "MAX_SERVER_WAIT_TIMEOUT";
  GLEnum2[GLEnum2["MAX_ELEMENT_INDEX"] = 36203] = "MAX_ELEMENT_INDEX";
  GLEnum2[GLEnum2["RED"] = 6403] = "RED";
  GLEnum2[GLEnum2["RGB8"] = 32849] = "RGB8";
  GLEnum2[GLEnum2["RGBA8"] = 32856] = "RGBA8";
  GLEnum2[GLEnum2["RGB10_A2"] = 32857] = "RGB10_A2";
  GLEnum2[GLEnum2["TEXTURE_3D"] = 32879] = "TEXTURE_3D";
  GLEnum2[GLEnum2["TEXTURE_WRAP_R"] = 32882] = "TEXTURE_WRAP_R";
  GLEnum2[GLEnum2["TEXTURE_MIN_LOD"] = 33082] = "TEXTURE_MIN_LOD";
  GLEnum2[GLEnum2["TEXTURE_MAX_LOD"] = 33083] = "TEXTURE_MAX_LOD";
  GLEnum2[GLEnum2["TEXTURE_BASE_LEVEL"] = 33084] = "TEXTURE_BASE_LEVEL";
  GLEnum2[GLEnum2["TEXTURE_MAX_LEVEL"] = 33085] = "TEXTURE_MAX_LEVEL";
  GLEnum2[GLEnum2["TEXTURE_COMPARE_MODE"] = 34892] = "TEXTURE_COMPARE_MODE";
  GLEnum2[GLEnum2["TEXTURE_COMPARE_FUNC"] = 34893] = "TEXTURE_COMPARE_FUNC";
  GLEnum2[GLEnum2["SRGB"] = 35904] = "SRGB";
  GLEnum2[GLEnum2["SRGB8"] = 35905] = "SRGB8";
  GLEnum2[GLEnum2["SRGB8_ALPHA8"] = 35907] = "SRGB8_ALPHA8";
  GLEnum2[GLEnum2["COMPARE_REF_TO_TEXTURE"] = 34894] = "COMPARE_REF_TO_TEXTURE";
  GLEnum2[GLEnum2["RGBA32F"] = 34836] = "RGBA32F";
  GLEnum2[GLEnum2["RGB32F"] = 34837] = "RGB32F";
  GLEnum2[GLEnum2["RGBA16F"] = 34842] = "RGBA16F";
  GLEnum2[GLEnum2["RGB16F"] = 34843] = "RGB16F";
  GLEnum2[GLEnum2["TEXTURE_2D_ARRAY"] = 35866] = "TEXTURE_2D_ARRAY";
  GLEnum2[GLEnum2["TEXTURE_BINDING_2D_ARRAY"] = 35869] = "TEXTURE_BINDING_2D_ARRAY";
  GLEnum2[GLEnum2["R11F_G11F_B10F"] = 35898] = "R11F_G11F_B10F";
  GLEnum2[GLEnum2["RGB9_E5"] = 35901] = "RGB9_E5";
  GLEnum2[GLEnum2["RGBA32UI"] = 36208] = "RGBA32UI";
  GLEnum2[GLEnum2["RGB32UI"] = 36209] = "RGB32UI";
  GLEnum2[GLEnum2["RGBA16UI"] = 36214] = "RGBA16UI";
  GLEnum2[GLEnum2["RGB16UI"] = 36215] = "RGB16UI";
  GLEnum2[GLEnum2["RGBA8UI"] = 36220] = "RGBA8UI";
  GLEnum2[GLEnum2["RGB8UI"] = 36221] = "RGB8UI";
  GLEnum2[GLEnum2["RGBA32I"] = 36226] = "RGBA32I";
  GLEnum2[GLEnum2["RGB32I"] = 36227] = "RGB32I";
  GLEnum2[GLEnum2["RGBA16I"] = 36232] = "RGBA16I";
  GLEnum2[GLEnum2["RGB16I"] = 36233] = "RGB16I";
  GLEnum2[GLEnum2["RGBA8I"] = 36238] = "RGBA8I";
  GLEnum2[GLEnum2["RGB8I"] = 36239] = "RGB8I";
  GLEnum2[GLEnum2["RED_INTEGER"] = 36244] = "RED_INTEGER";
  GLEnum2[GLEnum2["RGB_INTEGER"] = 36248] = "RGB_INTEGER";
  GLEnum2[GLEnum2["RGBA_INTEGER"] = 36249] = "RGBA_INTEGER";
  GLEnum2[GLEnum2["R8"] = 33321] = "R8";
  GLEnum2[GLEnum2["RG8"] = 33323] = "RG8";
  GLEnum2[GLEnum2["R16F"] = 33325] = "R16F";
  GLEnum2[GLEnum2["R32F"] = 33326] = "R32F";
  GLEnum2[GLEnum2["RG16F"] = 33327] = "RG16F";
  GLEnum2[GLEnum2["RG32F"] = 33328] = "RG32F";
  GLEnum2[GLEnum2["R8I"] = 33329] = "R8I";
  GLEnum2[GLEnum2["R8UI"] = 33330] = "R8UI";
  GLEnum2[GLEnum2["R16I"] = 33331] = "R16I";
  GLEnum2[GLEnum2["R16UI"] = 33332] = "R16UI";
  GLEnum2[GLEnum2["R32I"] = 33333] = "R32I";
  GLEnum2[GLEnum2["R32UI"] = 33334] = "R32UI";
  GLEnum2[GLEnum2["RG8I"] = 33335] = "RG8I";
  GLEnum2[GLEnum2["RG8UI"] = 33336] = "RG8UI";
  GLEnum2[GLEnum2["RG16I"] = 33337] = "RG16I";
  GLEnum2[GLEnum2["RG16UI"] = 33338] = "RG16UI";
  GLEnum2[GLEnum2["RG32I"] = 33339] = "RG32I";
  GLEnum2[GLEnum2["RG32UI"] = 33340] = "RG32UI";
  GLEnum2[GLEnum2["R8_SNORM"] = 36756] = "R8_SNORM";
  GLEnum2[GLEnum2["RG8_SNORM"] = 36757] = "RG8_SNORM";
  GLEnum2[GLEnum2["RGB8_SNORM"] = 36758] = "RGB8_SNORM";
  GLEnum2[GLEnum2["RGBA8_SNORM"] = 36759] = "RGBA8_SNORM";
  GLEnum2[GLEnum2["RGB10_A2UI"] = 36975] = "RGB10_A2UI";
  GLEnum2[GLEnum2["TEXTURE_IMMUTABLE_FORMAT"] = 37167] = "TEXTURE_IMMUTABLE_FORMAT";
  GLEnum2[GLEnum2["TEXTURE_IMMUTABLE_LEVELS"] = 33503] = "TEXTURE_IMMUTABLE_LEVELS";
  GLEnum2[GLEnum2["UNSIGNED_INT_2_10_10_10_REV"] = 33640] = "UNSIGNED_INT_2_10_10_10_REV";
  GLEnum2[GLEnum2["UNSIGNED_INT_10F_11F_11F_REV"] = 35899] = "UNSIGNED_INT_10F_11F_11F_REV";
  GLEnum2[GLEnum2["UNSIGNED_INT_5_9_9_9_REV"] = 35902] = "UNSIGNED_INT_5_9_9_9_REV";
  GLEnum2[GLEnum2["FLOAT_32_UNSIGNED_INT_24_8_REV"] = 36269] = "FLOAT_32_UNSIGNED_INT_24_8_REV";
  GLEnum2[GLEnum2["UNSIGNED_INT_24_8"] = 34042] = "UNSIGNED_INT_24_8";
  GLEnum2[GLEnum2["HALF_FLOAT"] = 5131] = "HALF_FLOAT";
  GLEnum2[GLEnum2["RG"] = 33319] = "RG";
  GLEnum2[GLEnum2["RG_INTEGER"] = 33320] = "RG_INTEGER";
  GLEnum2[GLEnum2["INT_2_10_10_10_REV"] = 36255] = "INT_2_10_10_10_REV";
  GLEnum2[GLEnum2["CURRENT_QUERY"] = 34917] = "CURRENT_QUERY";
  GLEnum2[GLEnum2["QUERY_RESULT"] = 34918] = "QUERY_RESULT";
  GLEnum2[GLEnum2["QUERY_RESULT_AVAILABLE"] = 34919] = "QUERY_RESULT_AVAILABLE";
  GLEnum2[GLEnum2["ANY_SAMPLES_PASSED"] = 35887] = "ANY_SAMPLES_PASSED";
  GLEnum2[GLEnum2["ANY_SAMPLES_PASSED_CONSERVATIVE"] = 36202] = "ANY_SAMPLES_PASSED_CONSERVATIVE";
  GLEnum2[GLEnum2["MAX_DRAW_BUFFERS"] = 34852] = "MAX_DRAW_BUFFERS";
  GLEnum2[GLEnum2["DRAW_BUFFER0"] = 34853] = "DRAW_BUFFER0";
  GLEnum2[GLEnum2["DRAW_BUFFER1"] = 34854] = "DRAW_BUFFER1";
  GLEnum2[GLEnum2["DRAW_BUFFER2"] = 34855] = "DRAW_BUFFER2";
  GLEnum2[GLEnum2["DRAW_BUFFER3"] = 34856] = "DRAW_BUFFER3";
  GLEnum2[GLEnum2["DRAW_BUFFER4"] = 34857] = "DRAW_BUFFER4";
  GLEnum2[GLEnum2["DRAW_BUFFER5"] = 34858] = "DRAW_BUFFER5";
  GLEnum2[GLEnum2["DRAW_BUFFER6"] = 34859] = "DRAW_BUFFER6";
  GLEnum2[GLEnum2["DRAW_BUFFER7"] = 34860] = "DRAW_BUFFER7";
  GLEnum2[GLEnum2["DRAW_BUFFER8"] = 34861] = "DRAW_BUFFER8";
  GLEnum2[GLEnum2["DRAW_BUFFER9"] = 34862] = "DRAW_BUFFER9";
  GLEnum2[GLEnum2["DRAW_BUFFER10"] = 34863] = "DRAW_BUFFER10";
  GLEnum2[GLEnum2["DRAW_BUFFER11"] = 34864] = "DRAW_BUFFER11";
  GLEnum2[GLEnum2["DRAW_BUFFER12"] = 34865] = "DRAW_BUFFER12";
  GLEnum2[GLEnum2["DRAW_BUFFER13"] = 34866] = "DRAW_BUFFER13";
  GLEnum2[GLEnum2["DRAW_BUFFER14"] = 34867] = "DRAW_BUFFER14";
  GLEnum2[GLEnum2["DRAW_BUFFER15"] = 34868] = "DRAW_BUFFER15";
  GLEnum2[GLEnum2["MAX_COLOR_ATTACHMENTS"] = 36063] = "MAX_COLOR_ATTACHMENTS";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT1"] = 36065] = "COLOR_ATTACHMENT1";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT2"] = 36066] = "COLOR_ATTACHMENT2";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT3"] = 36067] = "COLOR_ATTACHMENT3";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT4"] = 36068] = "COLOR_ATTACHMENT4";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT5"] = 36069] = "COLOR_ATTACHMENT5";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT6"] = 36070] = "COLOR_ATTACHMENT6";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT7"] = 36071] = "COLOR_ATTACHMENT7";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT8"] = 36072] = "COLOR_ATTACHMENT8";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT9"] = 36073] = "COLOR_ATTACHMENT9";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT10"] = 36074] = "COLOR_ATTACHMENT10";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT11"] = 36075] = "COLOR_ATTACHMENT11";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT12"] = 36076] = "COLOR_ATTACHMENT12";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT13"] = 36077] = "COLOR_ATTACHMENT13";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT14"] = 36078] = "COLOR_ATTACHMENT14";
  GLEnum2[GLEnum2["COLOR_ATTACHMENT15"] = 36079] = "COLOR_ATTACHMENT15";
  GLEnum2[GLEnum2["SAMPLER_3D"] = 35679] = "SAMPLER_3D";
  GLEnum2[GLEnum2["SAMPLER_2D_SHADOW"] = 35682] = "SAMPLER_2D_SHADOW";
  GLEnum2[GLEnum2["SAMPLER_2D_ARRAY"] = 36289] = "SAMPLER_2D_ARRAY";
  GLEnum2[GLEnum2["SAMPLER_2D_ARRAY_SHADOW"] = 36292] = "SAMPLER_2D_ARRAY_SHADOW";
  GLEnum2[GLEnum2["SAMPLER_CUBE_SHADOW"] = 36293] = "SAMPLER_CUBE_SHADOW";
  GLEnum2[GLEnum2["INT_SAMPLER_2D"] = 36298] = "INT_SAMPLER_2D";
  GLEnum2[GLEnum2["INT_SAMPLER_3D"] = 36299] = "INT_SAMPLER_3D";
  GLEnum2[GLEnum2["INT_SAMPLER_CUBE"] = 36300] = "INT_SAMPLER_CUBE";
  GLEnum2[GLEnum2["INT_SAMPLER_2D_ARRAY"] = 36303] = "INT_SAMPLER_2D_ARRAY";
  GLEnum2[GLEnum2["UNSIGNED_INT_SAMPLER_2D"] = 36306] = "UNSIGNED_INT_SAMPLER_2D";
  GLEnum2[GLEnum2["UNSIGNED_INT_SAMPLER_3D"] = 36307] = "UNSIGNED_INT_SAMPLER_3D";
  GLEnum2[GLEnum2["UNSIGNED_INT_SAMPLER_CUBE"] = 36308] = "UNSIGNED_INT_SAMPLER_CUBE";
  GLEnum2[GLEnum2["UNSIGNED_INT_SAMPLER_2D_ARRAY"] = 36311] = "UNSIGNED_INT_SAMPLER_2D_ARRAY";
  GLEnum2[GLEnum2["MAX_SAMPLES"] = 36183] = "MAX_SAMPLES";
  GLEnum2[GLEnum2["SAMPLER_BINDING"] = 35097] = "SAMPLER_BINDING";
  GLEnum2[GLEnum2["PIXEL_PACK_BUFFER"] = 35051] = "PIXEL_PACK_BUFFER";
  GLEnum2[GLEnum2["PIXEL_UNPACK_BUFFER"] = 35052] = "PIXEL_UNPACK_BUFFER";
  GLEnum2[GLEnum2["PIXEL_PACK_BUFFER_BINDING"] = 35053] = "PIXEL_PACK_BUFFER_BINDING";
  GLEnum2[GLEnum2["PIXEL_UNPACK_BUFFER_BINDING"] = 35055] = "PIXEL_UNPACK_BUFFER_BINDING";
  GLEnum2[GLEnum2["COPY_READ_BUFFER"] = 36662] = "COPY_READ_BUFFER";
  GLEnum2[GLEnum2["COPY_WRITE_BUFFER"] = 36663] = "COPY_WRITE_BUFFER";
  GLEnum2[GLEnum2["COPY_READ_BUFFER_BINDING"] = 36662] = "COPY_READ_BUFFER_BINDING";
  GLEnum2[GLEnum2["COPY_WRITE_BUFFER_BINDING"] = 36663] = "COPY_WRITE_BUFFER_BINDING";
  GLEnum2[GLEnum2["FLOAT_MAT2x3"] = 35685] = "FLOAT_MAT2x3";
  GLEnum2[GLEnum2["FLOAT_MAT2x4"] = 35686] = "FLOAT_MAT2x4";
  GLEnum2[GLEnum2["FLOAT_MAT3x2"] = 35687] = "FLOAT_MAT3x2";
  GLEnum2[GLEnum2["FLOAT_MAT3x4"] = 35688] = "FLOAT_MAT3x4";
  GLEnum2[GLEnum2["FLOAT_MAT4x2"] = 35689] = "FLOAT_MAT4x2";
  GLEnum2[GLEnum2["FLOAT_MAT4x3"] = 35690] = "FLOAT_MAT4x3";
  GLEnum2[GLEnum2["UNSIGNED_INT_VEC2"] = 36294] = "UNSIGNED_INT_VEC2";
  GLEnum2[GLEnum2["UNSIGNED_INT_VEC3"] = 36295] = "UNSIGNED_INT_VEC3";
  GLEnum2[GLEnum2["UNSIGNED_INT_VEC4"] = 36296] = "UNSIGNED_INT_VEC4";
  GLEnum2[GLEnum2["UNSIGNED_NORMALIZED"] = 35863] = "UNSIGNED_NORMALIZED";
  GLEnum2[GLEnum2["SIGNED_NORMALIZED"] = 36764] = "SIGNED_NORMALIZED";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_INTEGER"] = 35069] = "VERTEX_ATTRIB_ARRAY_INTEGER";
  GLEnum2[GLEnum2["VERTEX_ATTRIB_ARRAY_DIVISOR"] = 35070] = "VERTEX_ATTRIB_ARRAY_DIVISOR";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_BUFFER_MODE"] = 35967] = "TRANSFORM_FEEDBACK_BUFFER_MODE";
  GLEnum2[GLEnum2["MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS"] = 35968] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_VARYINGS"] = 35971] = "TRANSFORM_FEEDBACK_VARYINGS";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_BUFFER_START"] = 35972] = "TRANSFORM_FEEDBACK_BUFFER_START";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_BUFFER_SIZE"] = 35973] = "TRANSFORM_FEEDBACK_BUFFER_SIZE";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN"] = 35976] = "TRANSFORM_FEEDBACK_PRIMITIVES_WRITTEN";
  GLEnum2[GLEnum2["MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS"] = 35978] = "MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS";
  GLEnum2[GLEnum2["MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS"] = 35979] = "MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS";
  GLEnum2[GLEnum2["INTERLEAVED_ATTRIBS"] = 35980] = "INTERLEAVED_ATTRIBS";
  GLEnum2[GLEnum2["SEPARATE_ATTRIBS"] = 35981] = "SEPARATE_ATTRIBS";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_BUFFER"] = 35982] = "TRANSFORM_FEEDBACK_BUFFER";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_BUFFER_BINDING"] = 35983] = "TRANSFORM_FEEDBACK_BUFFER_BINDING";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK"] = 36386] = "TRANSFORM_FEEDBACK";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_PAUSED"] = 36387] = "TRANSFORM_FEEDBACK_PAUSED";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_ACTIVE"] = 36388] = "TRANSFORM_FEEDBACK_ACTIVE";
  GLEnum2[GLEnum2["TRANSFORM_FEEDBACK_BINDING"] = 36389] = "TRANSFORM_FEEDBACK_BINDING";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING"] = 33296] = "FRAMEBUFFER_ATTACHMENT_COLOR_ENCODING";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE"] = 33297] = "FRAMEBUFFER_ATTACHMENT_COMPONENT_TYPE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_RED_SIZE"] = 33298] = "FRAMEBUFFER_ATTACHMENT_RED_SIZE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_GREEN_SIZE"] = 33299] = "FRAMEBUFFER_ATTACHMENT_GREEN_SIZE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_BLUE_SIZE"] = 33300] = "FRAMEBUFFER_ATTACHMENT_BLUE_SIZE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE"] = 33301] = "FRAMEBUFFER_ATTACHMENT_ALPHA_SIZE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE"] = 33302] = "FRAMEBUFFER_ATTACHMENT_DEPTH_SIZE";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE"] = 33303] = "FRAMEBUFFER_ATTACHMENT_STENCIL_SIZE";
  GLEnum2[GLEnum2["FRAMEBUFFER_DEFAULT"] = 33304] = "FRAMEBUFFER_DEFAULT";
  GLEnum2[GLEnum2["DEPTH24_STENCIL8"] = 35056] = "DEPTH24_STENCIL8";
  GLEnum2[GLEnum2["DRAW_FRAMEBUFFER_BINDING"] = 36006] = "DRAW_FRAMEBUFFER_BINDING";
  GLEnum2[GLEnum2["READ_FRAMEBUFFER_BINDING"] = 36010] = "READ_FRAMEBUFFER_BINDING";
  GLEnum2[GLEnum2["RENDERBUFFER_SAMPLES"] = 36011] = "RENDERBUFFER_SAMPLES";
  GLEnum2[GLEnum2["FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER"] = 36052] = "FRAMEBUFFER_ATTACHMENT_TEXTURE_LAYER";
  GLEnum2[GLEnum2["FRAMEBUFFER_INCOMPLETE_MULTISAMPLE"] = 36182] = "FRAMEBUFFER_INCOMPLETE_MULTISAMPLE";
  GLEnum2[GLEnum2["UNIFORM_BUFFER"] = 35345] = "UNIFORM_BUFFER";
  GLEnum2[GLEnum2["UNIFORM_BUFFER_BINDING"] = 35368] = "UNIFORM_BUFFER_BINDING";
  GLEnum2[GLEnum2["UNIFORM_BUFFER_START"] = 35369] = "UNIFORM_BUFFER_START";
  GLEnum2[GLEnum2["UNIFORM_BUFFER_SIZE"] = 35370] = "UNIFORM_BUFFER_SIZE";
  GLEnum2[GLEnum2["MAX_VERTEX_UNIFORM_BLOCKS"] = 35371] = "MAX_VERTEX_UNIFORM_BLOCKS";
  GLEnum2[GLEnum2["MAX_FRAGMENT_UNIFORM_BLOCKS"] = 35373] = "MAX_FRAGMENT_UNIFORM_BLOCKS";
  GLEnum2[GLEnum2["MAX_COMBINED_UNIFORM_BLOCKS"] = 35374] = "MAX_COMBINED_UNIFORM_BLOCKS";
  GLEnum2[GLEnum2["MAX_UNIFORM_BUFFER_BINDINGS"] = 35375] = "MAX_UNIFORM_BUFFER_BINDINGS";
  GLEnum2[GLEnum2["MAX_UNIFORM_BLOCK_SIZE"] = 35376] = "MAX_UNIFORM_BLOCK_SIZE";
  GLEnum2[GLEnum2["MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS"] = 35377] = "MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS";
  GLEnum2[GLEnum2["MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS"] = 35379] = "MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS";
  GLEnum2[GLEnum2["UNIFORM_BUFFER_OFFSET_ALIGNMENT"] = 35380] = "UNIFORM_BUFFER_OFFSET_ALIGNMENT";
  GLEnum2[GLEnum2["ACTIVE_UNIFORM_BLOCKS"] = 35382] = "ACTIVE_UNIFORM_BLOCKS";
  GLEnum2[GLEnum2["UNIFORM_TYPE"] = 35383] = "UNIFORM_TYPE";
  GLEnum2[GLEnum2["UNIFORM_SIZE"] = 35384] = "UNIFORM_SIZE";
  GLEnum2[GLEnum2["UNIFORM_BLOCK_INDEX"] = 35386] = "UNIFORM_BLOCK_INDEX";
  GLEnum2[GLEnum2["UNIFORM_OFFSET"] = 35387] = "UNIFORM_OFFSET";
  GLEnum2[GLEnum2["UNIFORM_ARRAY_STRIDE"] = 35388] = "UNIFORM_ARRAY_STRIDE";
  GLEnum2[GLEnum2["UNIFORM_MATRIX_STRIDE"] = 35389] = "UNIFORM_MATRIX_STRIDE";
  GLEnum2[GLEnum2["UNIFORM_IS_ROW_MAJOR"] = 35390] = "UNIFORM_IS_ROW_MAJOR";
  GLEnum2[GLEnum2["UNIFORM_BLOCK_BINDING"] = 35391] = "UNIFORM_BLOCK_BINDING";
  GLEnum2[GLEnum2["UNIFORM_BLOCK_DATA_SIZE"] = 35392] = "UNIFORM_BLOCK_DATA_SIZE";
  GLEnum2[GLEnum2["UNIFORM_BLOCK_ACTIVE_UNIFORMS"] = 35394] = "UNIFORM_BLOCK_ACTIVE_UNIFORMS";
  GLEnum2[GLEnum2["UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES"] = 35395] = "UNIFORM_BLOCK_ACTIVE_UNIFORM_INDICES";
  GLEnum2[GLEnum2["UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER"] = 35396] = "UNIFORM_BLOCK_REFERENCED_BY_VERTEX_SHADER";
  GLEnum2[GLEnum2["UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER"] = 35398] = "UNIFORM_BLOCK_REFERENCED_BY_FRAGMENT_SHADER";
  GLEnum2[GLEnum2["OBJECT_TYPE"] = 37138] = "OBJECT_TYPE";
  GLEnum2[GLEnum2["SYNC_CONDITION"] = 37139] = "SYNC_CONDITION";
  GLEnum2[GLEnum2["SYNC_STATUS"] = 37140] = "SYNC_STATUS";
  GLEnum2[GLEnum2["SYNC_FLAGS"] = 37141] = "SYNC_FLAGS";
  GLEnum2[GLEnum2["SYNC_FENCE"] = 37142] = "SYNC_FENCE";
  GLEnum2[GLEnum2["SYNC_GPU_COMMANDS_COMPLETE"] = 37143] = "SYNC_GPU_COMMANDS_COMPLETE";
  GLEnum2[GLEnum2["UNSIGNALED"] = 37144] = "UNSIGNALED";
  GLEnum2[GLEnum2["SIGNALED"] = 37145] = "SIGNALED";
  GLEnum2[GLEnum2["ALREADY_SIGNALED"] = 37146] = "ALREADY_SIGNALED";
  GLEnum2[GLEnum2["TIMEOUT_EXPIRED"] = 37147] = "TIMEOUT_EXPIRED";
  GLEnum2[GLEnum2["CONDITION_SATISFIED"] = 37148] = "CONDITION_SATISFIED";
  GLEnum2[GLEnum2["WAIT_FAILED"] = 37149] = "WAIT_FAILED";
  GLEnum2[GLEnum2["SYNC_FLUSH_COMMANDS_BIT"] = 1] = "SYNC_FLUSH_COMMANDS_BIT";
  GLEnum2[GLEnum2["COLOR"] = 6144] = "COLOR";
  GLEnum2[GLEnum2["DEPTH"] = 6145] = "DEPTH";
  GLEnum2[GLEnum2["STENCIL"] = 6146] = "STENCIL";
  GLEnum2[GLEnum2["MIN"] = 32775] = "MIN";
  GLEnum2[GLEnum2["MAX"] = 32776] = "MAX";
  GLEnum2[GLEnum2["DEPTH_COMPONENT24"] = 33190] = "DEPTH_COMPONENT24";
  GLEnum2[GLEnum2["STREAM_READ"] = 35041] = "STREAM_READ";
  GLEnum2[GLEnum2["STREAM_COPY"] = 35042] = "STREAM_COPY";
  GLEnum2[GLEnum2["STATIC_READ"] = 35045] = "STATIC_READ";
  GLEnum2[GLEnum2["STATIC_COPY"] = 35046] = "STATIC_COPY";
  GLEnum2[GLEnum2["DYNAMIC_READ"] = 35049] = "DYNAMIC_READ";
  GLEnum2[GLEnum2["DYNAMIC_COPY"] = 35050] = "DYNAMIC_COPY";
  GLEnum2[GLEnum2["DEPTH_COMPONENT32F"] = 36012] = "DEPTH_COMPONENT32F";
  GLEnum2[GLEnum2["DEPTH32F_STENCIL8"] = 36013] = "DEPTH32F_STENCIL8";
  GLEnum2[GLEnum2["INVALID_INDEX"] = 4294967295] = "INVALID_INDEX";
  GLEnum2[GLEnum2["TIMEOUT_IGNORED"] = -1] = "TIMEOUT_IGNORED";
  GLEnum2[GLEnum2["MAX_CLIENT_WAIT_TIMEOUT_WEBGL"] = 37447] = "MAX_CLIENT_WAIT_TIMEOUT_WEBGL";
  GLEnum2[GLEnum2["UNMASKED_VENDOR_WEBGL"] = 37445] = "UNMASKED_VENDOR_WEBGL";
  GLEnum2[GLEnum2["UNMASKED_RENDERER_WEBGL"] = 37446] = "UNMASKED_RENDERER_WEBGL";
  GLEnum2[GLEnum2["MAX_TEXTURE_MAX_ANISOTROPY_EXT"] = 34047] = "MAX_TEXTURE_MAX_ANISOTROPY_EXT";
  GLEnum2[GLEnum2["TEXTURE_MAX_ANISOTROPY_EXT"] = 34046] = "TEXTURE_MAX_ANISOTROPY_EXT";
  GLEnum2[GLEnum2["R16_EXT"] = 33322] = "R16_EXT";
  GLEnum2[GLEnum2["RG16_EXT"] = 33324] = "RG16_EXT";
  GLEnum2[GLEnum2["RGB16_EXT"] = 32852] = "RGB16_EXT";
  GLEnum2[GLEnum2["RGBA16_EXT"] = 32859] = "RGBA16_EXT";
  GLEnum2[GLEnum2["R16_SNORM_EXT"] = 36760] = "R16_SNORM_EXT";
  GLEnum2[GLEnum2["RG16_SNORM_EXT"] = 36761] = "RG16_SNORM_EXT";
  GLEnum2[GLEnum2["RGB16_SNORM_EXT"] = 36762] = "RGB16_SNORM_EXT";
  GLEnum2[GLEnum2["RGBA16_SNORM_EXT"] = 36763] = "RGBA16_SNORM_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_S3TC_DXT1_EXT"] = 33777] = "COMPRESSED_RGBA_S3TC_DXT1_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_S3TC_DXT3_EXT"] = 33778] = "COMPRESSED_RGBA_S3TC_DXT3_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
  GLEnum2[GLEnum2["COMPRESSED_SRGB_S3TC_DXT1_EXT"] = 35916] = "COMPRESSED_SRGB_S3TC_DXT1_EXT";
  GLEnum2[GLEnum2["COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT"] = 35917] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT";
  GLEnum2[GLEnum2["COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT"] = 35918] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT";
  GLEnum2[GLEnum2["COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT"] = 35919] = "COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RED_RGTC1_EXT"] = 36283] = "COMPRESSED_RED_RGTC1_EXT";
  GLEnum2[GLEnum2["COMPRESSED_SIGNED_RED_RGTC1_EXT"] = 36284] = "COMPRESSED_SIGNED_RED_RGTC1_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RED_GREEN_RGTC2_EXT"] = 36285] = "COMPRESSED_RED_GREEN_RGTC2_EXT";
  GLEnum2[GLEnum2["COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT"] = 36286] = "COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_BPTC_UNORM_EXT"] = 36492] = "COMPRESSED_RGBA_BPTC_UNORM_EXT";
  GLEnum2[GLEnum2["COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT"] = 36493] = "COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT"] = 36494] = "COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT";
  GLEnum2[GLEnum2["COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT"] = 36495] = "COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT";
  GLEnum2[GLEnum2["COMPRESSED_R11_EAC"] = 37488] = "COMPRESSED_R11_EAC";
  GLEnum2[GLEnum2["COMPRESSED_SIGNED_R11_EAC"] = 37489] = "COMPRESSED_SIGNED_R11_EAC";
  GLEnum2[GLEnum2["COMPRESSED_RG11_EAC"] = 37490] = "COMPRESSED_RG11_EAC";
  GLEnum2[GLEnum2["COMPRESSED_SIGNED_RG11_EAC"] = 37491] = "COMPRESSED_SIGNED_RG11_EAC";
  GLEnum2[GLEnum2["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
  GLEnum2[GLEnum2["COMPRESSED_RGBA8_ETC2_EAC"] = 37493] = "COMPRESSED_RGBA8_ETC2_EAC";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ETC2"] = 37494] = "COMPRESSED_SRGB8_ETC2";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ETC2_EAC"] = 37495] = "COMPRESSED_SRGB8_ALPHA8_ETC2_EAC";
  GLEnum2[GLEnum2["COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37496] = "COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2"] = 37497] = "COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2";
  GLEnum2[GLEnum2["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
  GLEnum2[GLEnum2["COMPRESSED_RGB_PVRTC_2BPPV1_IMG"] = 35841] = "COMPRESSED_RGB_PVRTC_2BPPV1_IMG";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_PVRTC_2BPPV1_IMG"] = 35843] = "COMPRESSED_RGBA_PVRTC_2BPPV1_IMG";
  GLEnum2[GLEnum2["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL";
  GLEnum2[GLEnum2["COMPRESSED_RGB_ATC_WEBGL"] = 35986] = "COMPRESSED_RGB_ATC_WEBGL";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL"] = 35986] = "COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL"] = 34798] = "COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_4x4_KHR"] = 37808] = "COMPRESSED_RGBA_ASTC_4x4_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_5x4_KHR"] = 37809] = "COMPRESSED_RGBA_ASTC_5x4_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_5x5_KHR"] = 37810] = "COMPRESSED_RGBA_ASTC_5x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_6x5_KHR"] = 37811] = "COMPRESSED_RGBA_ASTC_6x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_6x6_KHR"] = 37812] = "COMPRESSED_RGBA_ASTC_6x6_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_8x5_KHR"] = 37813] = "COMPRESSED_RGBA_ASTC_8x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_8x6_KHR"] = 37814] = "COMPRESSED_RGBA_ASTC_8x6_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_8x8_KHR"] = 37815] = "COMPRESSED_RGBA_ASTC_8x8_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_10x5_KHR"] = 37816] = "COMPRESSED_RGBA_ASTC_10x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_10x6_KHR"] = 37817] = "COMPRESSED_RGBA_ASTC_10x6_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_10x8_KHR"] = 37818] = "COMPRESSED_RGBA_ASTC_10x8_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_10x10_KHR"] = 37819] = "COMPRESSED_RGBA_ASTC_10x10_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_12x10_KHR"] = 37820] = "COMPRESSED_RGBA_ASTC_12x10_KHR";
  GLEnum2[GLEnum2["COMPRESSED_RGBA_ASTC_12x12_KHR"] = 37821] = "COMPRESSED_RGBA_ASTC_12x12_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR"] = 37840] = "COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR"] = 37841] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR"] = 37842] = "COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR"] = 37843] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR"] = 37844] = "COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR"] = 37845] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR"] = 37846] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR"] = 37847] = "COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR"] = 37848] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR"] = 37849] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR"] = 37850] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR"] = 37851] = "COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR"] = 37852] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR";
  GLEnum2[GLEnum2["COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR"] = 37853] = "COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR";
  GLEnum2[GLEnum2["QUERY_COUNTER_BITS_EXT"] = 34916] = "QUERY_COUNTER_BITS_EXT";
  GLEnum2[GLEnum2["CURRENT_QUERY_EXT"] = 34917] = "CURRENT_QUERY_EXT";
  GLEnum2[GLEnum2["QUERY_RESULT_EXT"] = 34918] = "QUERY_RESULT_EXT";
  GLEnum2[GLEnum2["QUERY_RESULT_AVAILABLE_EXT"] = 34919] = "QUERY_RESULT_AVAILABLE_EXT";
  GLEnum2[GLEnum2["TIME_ELAPSED_EXT"] = 35007] = "TIME_ELAPSED_EXT";
  GLEnum2[GLEnum2["TIMESTAMP_EXT"] = 36392] = "TIMESTAMP_EXT";
  GLEnum2[GLEnum2["GPU_DISJOINT_EXT"] = 36795] = "GPU_DISJOINT_EXT";
  GLEnum2[GLEnum2["COMPLETION_STATUS_KHR"] = 37297] = "COMPLETION_STATUS_KHR";
  GLEnum2[GLEnum2["DEPTH_CLAMP_EXT"] = 34383] = "DEPTH_CLAMP_EXT";
  GLEnum2[GLEnum2["FIRST_VERTEX_CONVENTION_WEBGL"] = 36429] = "FIRST_VERTEX_CONVENTION_WEBGL";
  GLEnum2[GLEnum2["LAST_VERTEX_CONVENTION_WEBGL"] = 36430] = "LAST_VERTEX_CONVENTION_WEBGL";
  GLEnum2[GLEnum2["PROVOKING_VERTEX_WEBL"] = 36431] = "PROVOKING_VERTEX_WEBL";
  GLEnum2[GLEnum2["POLYGON_MODE_WEBGL"] = 2880] = "POLYGON_MODE_WEBGL";
  GLEnum2[GLEnum2["POLYGON_OFFSET_LINE_WEBGL"] = 10754] = "POLYGON_OFFSET_LINE_WEBGL";
  GLEnum2[GLEnum2["LINE_WEBGL"] = 6913] = "LINE_WEBGL";
  GLEnum2[GLEnum2["FILL_WEBGL"] = 6914] = "FILL_WEBGL";
  GLEnum2[GLEnum2["MAX_CLIP_DISTANCES_WEBGL"] = 3378] = "MAX_CLIP_DISTANCES_WEBGL";
  GLEnum2[GLEnum2["MAX_CULL_DISTANCES_WEBGL"] = 33529] = "MAX_CULL_DISTANCES_WEBGL";
  GLEnum2[GLEnum2["MAX_COMBINED_CLIP_AND_CULL_DISTANCES_WEBGL"] = 33530] = "MAX_COMBINED_CLIP_AND_CULL_DISTANCES_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE0_WEBGL"] = 12288] = "CLIP_DISTANCE0_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE1_WEBGL"] = 12289] = "CLIP_DISTANCE1_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE2_WEBGL"] = 12290] = "CLIP_DISTANCE2_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE3_WEBGL"] = 12291] = "CLIP_DISTANCE3_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE4_WEBGL"] = 12292] = "CLIP_DISTANCE4_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE5_WEBGL"] = 12293] = "CLIP_DISTANCE5_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE6_WEBGL"] = 12294] = "CLIP_DISTANCE6_WEBGL";
  GLEnum2[GLEnum2["CLIP_DISTANCE7_WEBGL"] = 12295] = "CLIP_DISTANCE7_WEBGL";
  GLEnum2[GLEnum2["POLYGON_OFFSET_CLAMP_EXT"] = 36379] = "POLYGON_OFFSET_CLAMP_EXT";
  GLEnum2[GLEnum2["LOWER_LEFT_EXT"] = 36001] = "LOWER_LEFT_EXT";
  GLEnum2[GLEnum2["UPPER_LEFT_EXT"] = 36002] = "UPPER_LEFT_EXT";
  GLEnum2[GLEnum2["NEGATIVE_ONE_TO_ONE_EXT"] = 37726] = "NEGATIVE_ONE_TO_ONE_EXT";
  GLEnum2[GLEnum2["ZERO_TO_ONE_EXT"] = 37727] = "ZERO_TO_ONE_EXT";
  GLEnum2[GLEnum2["CLIP_ORIGIN_EXT"] = 37724] = "CLIP_ORIGIN_EXT";
  GLEnum2[GLEnum2["CLIP_DEPTH_MODE_EXT"] = 37725] = "CLIP_DEPTH_MODE_EXT";
  GLEnum2[GLEnum2["SRC1_COLOR_WEBGL"] = 35065] = "SRC1_COLOR_WEBGL";
  GLEnum2[GLEnum2["SRC1_ALPHA_WEBGL"] = 34185] = "SRC1_ALPHA_WEBGL";
  GLEnum2[GLEnum2["ONE_MINUS_SRC1_COLOR_WEBGL"] = 35066] = "ONE_MINUS_SRC1_COLOR_WEBGL";
  GLEnum2[GLEnum2["ONE_MINUS_SRC1_ALPHA_WEBGL"] = 35067] = "ONE_MINUS_SRC1_ALPHA_WEBGL";
  GLEnum2[GLEnum2["MAX_DUAL_SOURCE_DRAW_BUFFERS_WEBGL"] = 35068] = "MAX_DUAL_SOURCE_DRAW_BUFFERS_WEBGL";
  GLEnum2[GLEnum2["MIRROR_CLAMP_TO_EDGE_EXT"] = 34627] = "MIRROR_CLAMP_TO_EDGE_EXT";
})(GLEnum$3 || (GLEnum$3 = {}));
const GL_PARAMETER_DEFAULTS = {
  [3042]: false,
  [32773]: new Float32Array([0, 0, 0, 0]),
  [32777]: 32774,
  [34877]: 32774,
  [32969]: 1,
  [32968]: 0,
  [32971]: 1,
  [32970]: 0,
  [3106]: new Float32Array([0, 0, 0, 0]),
  // TBD
  [3107]: [true, true, true, true],
  [2884]: false,
  [2885]: 1029,
  [2929]: false,
  [2931]: 1,
  [2932]: 513,
  [2928]: new Float32Array([0, 1]),
  // TBD
  [2930]: true,
  [3024]: true,
  [35725]: null,
  // FRAMEBUFFER_BINDING and DRAW_FRAMEBUFFER_BINDING(WebGL2) refer same state.
  [36006]: null,
  [36007]: null,
  [34229]: null,
  [34964]: null,
  [2886]: 2305,
  [33170]: 4352,
  [2849]: 1,
  [32823]: false,
  [32824]: 0,
  [10752]: 0,
  [32926]: false,
  [32928]: false,
  [32938]: 1,
  [32939]: false,
  [3089]: false,
  // Note: Dynamic value. If scissor test enabled we expect users to set correct scissor box
  [3088]: new Int32Array([0, 0, 1024, 1024]),
  [2960]: false,
  [2961]: 0,
  [2968]: 4294967295,
  [36005]: 4294967295,
  [2962]: 519,
  [2967]: 0,
  [2963]: 4294967295,
  [34816]: 519,
  [36003]: 0,
  [36004]: 4294967295,
  [2964]: 7680,
  [2965]: 7680,
  [2966]: 7680,
  [34817]: 7680,
  [34818]: 7680,
  [34819]: 7680,
  // Dynamic value: We use [0, 0, 1024, 1024] as default, but usually this is updated in each frame.
  [2978]: [0, 0, 1024, 1024],
  [36389]: null,
  [36662]: null,
  [36663]: null,
  [35053]: null,
  [35055]: null,
  [35723]: 4352,
  [36010]: null,
  [35977]: false,
  [3333]: 4,
  [3317]: 4,
  [37440]: false,
  [37441]: false,
  [37443]: 37444,
  [3330]: 0,
  [3332]: 0,
  [3331]: 0,
  [3314]: 0,
  [32878]: 0,
  [3316]: 0,
  [3315]: 0,
  [32877]: 0
};
const enable = (gl, value, key) => value ? gl.enable(key) : gl.disable(key);
const hint$4 = (gl, value, key) => gl.hint(key, value);
const pixelStorei = (gl, value, key) => gl.pixelStorei(key, value);
const bindFramebuffer = (gl, value, key) => {
  const target = key === 36006 ? 36009 : 36008;
  return gl.bindFramebuffer(target, value);
};
const bindBuffer = (gl, value, key) => {
  const bindingMap = {
    [34964]: 34962,
    [36662]: 36662,
    [36663]: 36663,
    [35053]: 35051,
    [35055]: 35052
  };
  const glTarget = bindingMap[key];
  gl.bindBuffer(glTarget, value);
};
function isArray$2(array2) {
  return Array.isArray(array2) || ArrayBuffer.isView(array2) && !(array2 instanceof DataView);
}
const GL_PARAMETER_SETTERS = {
  [3042]: enable,
  [32773]: (gl, value) => gl.blendColor(...value),
  [32777]: "blendEquation",
  [34877]: "blendEquation",
  [32969]: "blendFunc",
  [32968]: "blendFunc",
  [32971]: "blendFunc",
  [32970]: "blendFunc",
  [3106]: (gl, value) => gl.clearColor(...value),
  [3107]: (gl, value) => gl.colorMask(...value),
  [2884]: enable,
  [2885]: (gl, value) => gl.cullFace(value),
  [2929]: enable,
  [2931]: (gl, value) => gl.clearDepth(value),
  [2932]: (gl, value) => gl.depthFunc(value),
  [2928]: (gl, value) => gl.depthRange(...value),
  [2930]: (gl, value) => gl.depthMask(value),
  [3024]: enable,
  [35723]: hint$4,
  [35725]: (gl, value) => gl.useProgram(value),
  [36007]: (gl, value) => gl.bindRenderbuffer(36161, value),
  [36389]: (gl, value) => {
    var _a3;
    return (_a3 = gl.bindTransformFeedback) == null ? void 0 : _a3.call(gl, 36386, value);
  },
  [34229]: (gl, value) => gl.bindVertexArray(value),
  // NOTE: FRAMEBUFFER_BINDING and DRAW_FRAMEBUFFER_BINDING(WebGL2) refer same state.
  [36006]: bindFramebuffer,
  [36010]: bindFramebuffer,
  // Buffers
  [34964]: bindBuffer,
  [36662]: bindBuffer,
  [36663]: bindBuffer,
  [35053]: bindBuffer,
  [35055]: bindBuffer,
  [2886]: (gl, value) => gl.frontFace(value),
  [33170]: hint$4,
  [2849]: (gl, value) => gl.lineWidth(value),
  [32823]: enable,
  [32824]: "polygonOffset",
  [10752]: "polygonOffset",
  [35977]: enable,
  [32926]: enable,
  [32928]: enable,
  [32938]: "sampleCoverage",
  [32939]: "sampleCoverage",
  [3089]: enable,
  [3088]: (gl, value) => gl.scissor(...value),
  [2960]: enable,
  [2961]: (gl, value) => gl.clearStencil(value),
  [2968]: (gl, value) => gl.stencilMaskSeparate(1028, value),
  [36005]: (gl, value) => gl.stencilMaskSeparate(1029, value),
  [2962]: "stencilFuncFront",
  [2967]: "stencilFuncFront",
  [2963]: "stencilFuncFront",
  [34816]: "stencilFuncBack",
  [36003]: "stencilFuncBack",
  [36004]: "stencilFuncBack",
  [2964]: "stencilOpFront",
  [2965]: "stencilOpFront",
  [2966]: "stencilOpFront",
  [34817]: "stencilOpBack",
  [34818]: "stencilOpBack",
  [34819]: "stencilOpBack",
  [2978]: (gl, value) => gl.viewport(...value),
  // WEBGL2 EXTENSIONS
  // EXT_depth_clamp https://registry.khronos.org/webgl/extensions/EXT_depth_clamp/
  [34383]: enable,
  // WEBGL_provoking_vertex https://registry.khronos.org/webgl/extensions/WEBGL_provoking_vertex/
  // [GL.PROVOKING_VERTEX_WEBL]: TODO - extension function needed
  // WEBGL_polygon_mode https://registry.khronos.org/webgl/extensions/WEBGL_polygon_mode/
  // POLYGON_MODE_WEBGL  TODO - extension function needed
  [10754]: enable,
  // WEBGL_clip_cull_distance https://registry.khronos.org/webgl/extensions/WEBGL_clip_cull_distance/
  [12288]: enable,
  [12289]: enable,
  [12290]: enable,
  [12291]: enable,
  [12292]: enable,
  [12293]: enable,
  [12294]: enable,
  [12295]: enable,
  // PIXEL PACK/UNPACK MODES
  [3333]: pixelStorei,
  [3317]: pixelStorei,
  [37440]: pixelStorei,
  [37441]: pixelStorei,
  [37443]: pixelStorei,
  [3330]: pixelStorei,
  [3332]: pixelStorei,
  [3331]: pixelStorei,
  [3314]: pixelStorei,
  [32878]: pixelStorei,
  [3316]: pixelStorei,
  [3315]: pixelStorei,
  [32877]: pixelStorei,
  // Function-style setters
  framebuffer: (gl, framebuffer) => {
    const handle = framebuffer && "handle" in framebuffer ? framebuffer.handle : framebuffer;
    return gl.bindFramebuffer(36160, handle);
  },
  blend: (gl, value) => value ? gl.enable(3042) : gl.disable(3042),
  blendColor: (gl, value) => gl.blendColor(...value),
  blendEquation: (gl, args) => {
    const separateModes = typeof args === "number" ? [args, args] : args;
    gl.blendEquationSeparate(...separateModes);
  },
  blendFunc: (gl, args) => {
    const separateFuncs = (args == null ? void 0 : args.length) === 2 ? [...args, ...args] : args;
    gl.blendFuncSeparate(...separateFuncs);
  },
  clearColor: (gl, value) => gl.clearColor(...value),
  clearDepth: (gl, value) => gl.clearDepth(value),
  clearStencil: (gl, value) => gl.clearStencil(value),
  colorMask: (gl, value) => gl.colorMask(...value),
  cull: (gl, value) => value ? gl.enable(2884) : gl.disable(2884),
  cullFace: (gl, value) => gl.cullFace(value),
  depthTest: (gl, value) => value ? gl.enable(2929) : gl.disable(2929),
  depthFunc: (gl, value) => gl.depthFunc(value),
  depthMask: (gl, value) => gl.depthMask(value),
  depthRange: (gl, value) => gl.depthRange(...value),
  dither: (gl, value) => value ? gl.enable(3024) : gl.disable(3024),
  derivativeHint: (gl, value) => {
    gl.hint(35723, value);
  },
  frontFace: (gl, value) => gl.frontFace(value),
  mipmapHint: (gl, value) => gl.hint(33170, value),
  lineWidth: (gl, value) => gl.lineWidth(value),
  polygonOffsetFill: (gl, value) => value ? gl.enable(32823) : gl.disable(32823),
  polygonOffset: (gl, value) => gl.polygonOffset(...value),
  sampleCoverage: (gl, value) => gl.sampleCoverage(...value),
  scissorTest: (gl, value) => value ? gl.enable(3089) : gl.disable(3089),
  scissor: (gl, value) => gl.scissor(...value),
  stencilTest: (gl, value) => value ? gl.enable(2960) : gl.disable(2960),
  stencilMask: (gl, value) => {
    value = isArray$2(value) ? value : [value, value];
    const [mask, backMask] = value;
    gl.stencilMaskSeparate(1028, mask);
    gl.stencilMaskSeparate(1029, backMask);
  },
  stencilFunc: (gl, args) => {
    args = isArray$2(args) && args.length === 3 ? [...args, ...args] : args;
    const [func2, ref, mask, backFunc, backRef, backMask] = args;
    gl.stencilFuncSeparate(1028, func2, ref, mask);
    gl.stencilFuncSeparate(1029, backFunc, backRef, backMask);
  },
  stencilOp: (gl, args) => {
    args = isArray$2(args) && args.length === 3 ? [...args, ...args] : args;
    const [sfail, dpfail, dppass, backSfail, backDpfail, backDppass] = args;
    gl.stencilOpSeparate(1028, sfail, dpfail, dppass);
    gl.stencilOpSeparate(1029, backSfail, backDpfail, backDppass);
  },
  viewport: (gl, value) => gl.viewport(...value)
};
function getValue(glEnum, values4, cache2) {
  return values4[glEnum] !== void 0 ? values4[glEnum] : cache2[glEnum];
}
const GL_COMPOSITE_PARAMETER_SETTERS = {
  blendEquation: (gl, values4, cache2) => gl.blendEquationSeparate(getValue(32777, values4, cache2), getValue(34877, values4, cache2)),
  blendFunc: (gl, values4, cache2) => gl.blendFuncSeparate(getValue(32969, values4, cache2), getValue(32968, values4, cache2), getValue(32971, values4, cache2), getValue(32970, values4, cache2)),
  polygonOffset: (gl, values4, cache2) => gl.polygonOffset(getValue(32824, values4, cache2), getValue(10752, values4, cache2)),
  sampleCoverage: (gl, values4, cache2) => gl.sampleCoverage(getValue(32938, values4, cache2), getValue(32939, values4, cache2)),
  stencilFuncFront: (gl, values4, cache2) => gl.stencilFuncSeparate(1028, getValue(2962, values4, cache2), getValue(2967, values4, cache2), getValue(2963, values4, cache2)),
  stencilFuncBack: (gl, values4, cache2) => gl.stencilFuncSeparate(1029, getValue(34816, values4, cache2), getValue(36003, values4, cache2), getValue(36004, values4, cache2)),
  stencilOpFront: (gl, values4, cache2) => gl.stencilOpSeparate(1028, getValue(2964, values4, cache2), getValue(2965, values4, cache2), getValue(2966, values4, cache2)),
  stencilOpBack: (gl, values4, cache2) => gl.stencilOpSeparate(1029, getValue(34817, values4, cache2), getValue(34818, values4, cache2), getValue(34819, values4, cache2))
};
const GL_HOOKED_SETTERS = {
  // GENERIC SETTERS
  enable: (update, capability) => update({
    [capability]: true
  }),
  disable: (update, capability) => update({
    [capability]: false
  }),
  pixelStorei: (update, pname, value) => update({
    [pname]: value
  }),
  hint: (update, pname, hint2) => update({
    [pname]: hint2
  }),
  // SPECIFIC SETTERS
  useProgram: (update, value) => update({
    [35725]: value
  }),
  bindRenderbuffer: (update, target, value) => update({
    [36007]: value
  }),
  bindTransformFeedback: (update, target, value) => update({
    [36389]: value
  }),
  bindVertexArray: (update, value) => update({
    [34229]: value
  }),
  bindFramebuffer: (update, target, framebuffer) => {
    switch (target) {
      case 36160:
        return update({
          [36006]: framebuffer,
          [36010]: framebuffer
        });
      case 36009:
        return update({ [36006]: framebuffer });
      case 36008:
        return update({ [36010]: framebuffer });
      default:
        return null;
    }
  },
  bindBuffer: (update, target, buffer3) => {
    const pname = {
      [34962]: [34964],
      [36662]: [36662],
      [36663]: [36663],
      [35051]: [35053],
      [35052]: [35055]
    }[target];
    if (pname) {
      return update({ [pname]: buffer3 });
    }
    return { valueChanged: true };
  },
  blendColor: (update, r2, g2, b2, a2) => update({
    [32773]: new Float32Array([r2, g2, b2, a2])
  }),
  blendEquation: (update, mode2) => update({
    [32777]: mode2,
    [34877]: mode2
  }),
  blendEquationSeparate: (update, modeRGB, modeAlpha) => update({
    [32777]: modeRGB,
    [34877]: modeAlpha
  }),
  blendFunc: (update, src2, dst) => update({
    [32969]: src2,
    [32968]: dst,
    [32971]: src2,
    [32970]: dst
  }),
  blendFuncSeparate: (update, srcRGB, dstRGB, srcAlpha, dstAlpha) => update({
    [32969]: srcRGB,
    [32968]: dstRGB,
    [32971]: srcAlpha,
    [32970]: dstAlpha
  }),
  clearColor: (update, r2, g2, b2, a2) => update({
    [3106]: new Float32Array([r2, g2, b2, a2])
  }),
  clearDepth: (update, depth2) => update({
    [2931]: depth2
  }),
  clearStencil: (update, s2) => update({
    [2961]: s2
  }),
  colorMask: (update, r2, g2, b2, a2) => update({
    [3107]: [r2, g2, b2, a2]
  }),
  cullFace: (update, mode2) => update({
    [2885]: mode2
  }),
  depthFunc: (update, func2) => update({
    [2932]: func2
  }),
  depthRange: (update, zNear, zFar) => update({
    [2928]: new Float32Array([zNear, zFar])
  }),
  depthMask: (update, mask) => update({
    [2930]: mask
  }),
  frontFace: (update, face) => update({
    [2886]: face
  }),
  lineWidth: (update, width) => update({
    [2849]: width
  }),
  polygonOffset: (update, factor, units2) => update({
    [32824]: factor,
    [10752]: units2
  }),
  sampleCoverage: (update, value, invert2) => update({
    [32938]: value,
    [32939]: invert2
  }),
  scissor: (update, x2, y2, width, height) => update({
    [3088]: new Int32Array([x2, y2, width, height])
  }),
  stencilMask: (update, mask) => update({
    [2968]: mask,
    [36005]: mask
  }),
  stencilMaskSeparate: (update, face, mask) => update({
    [face === 1028 ? 2968 : 36005]: mask
  }),
  stencilFunc: (update, func2, ref, mask) => update({
    [2962]: func2,
    [2967]: ref,
    [2963]: mask,
    [34816]: func2,
    [36003]: ref,
    [36004]: mask
  }),
  stencilFuncSeparate: (update, face, func2, ref, mask) => update({
    [face === 1028 ? 2962 : 34816]: func2,
    [face === 1028 ? 2967 : 36003]: ref,
    [face === 1028 ? 2963 : 36004]: mask
  }),
  stencilOp: (update, fail, zfail, zpass) => update({
    [2964]: fail,
    [2965]: zfail,
    [2966]: zpass,
    [34817]: fail,
    [34818]: zfail,
    [34819]: zpass
  }),
  stencilOpSeparate: (update, face, fail, zfail, zpass) => update({
    [face === 1028 ? 2964 : 34817]: fail,
    [face === 1028 ? 2965 : 34818]: zfail,
    [face === 1028 ? 2966 : 34819]: zpass
  }),
  viewport: (update, x2, y2, width, height) => update({
    [2978]: [x2, y2, width, height]
  })
};
const isEnabled = (gl, key) => gl.isEnabled(key);
const GL_PARAMETER_GETTERS = {
  [3042]: isEnabled,
  [2884]: isEnabled,
  [2929]: isEnabled,
  [3024]: isEnabled,
  [32823]: isEnabled,
  [32926]: isEnabled,
  [32928]: isEnabled,
  [3089]: isEnabled,
  [2960]: isEnabled,
  [35977]: isEnabled
};
const NON_CACHE_PARAMETERS = /* @__PURE__ */ new Set([
  34016,
  36388,
  36387,
  35983,
  35368,
  34965,
  35739,
  35738,
  3074,
  34853,
  34854,
  34855,
  34856,
  34857,
  34858,
  34859,
  34860,
  34861,
  34862,
  34863,
  34864,
  34865,
  34866,
  34867,
  34868,
  35097,
  32873,
  35869,
  32874,
  34068
]);
function setGLParameters(gl, parameters) {
  if (isObjectEmpty$2(parameters)) {
    return;
  }
  const compositeSetters = {};
  for (const key in parameters) {
    const glConstant = Number(key);
    const setter = GL_PARAMETER_SETTERS[key];
    if (setter) {
      if (typeof setter === "string") {
        compositeSetters[setter] = true;
      } else {
        setter(gl, parameters[key], glConstant);
      }
    }
  }
  const cache2 = gl.state && gl.state.cache;
  if (cache2) {
    for (const key in compositeSetters) {
      const compositeSetter = GL_COMPOSITE_PARAMETER_SETTERS[key];
      compositeSetter(gl, parameters, cache2);
    }
  }
}
function getGLParameters(gl, parameters = GL_PARAMETER_DEFAULTS) {
  if (typeof parameters === "number") {
    const key = parameters;
    const getter = GL_PARAMETER_GETTERS[key];
    return getter ? getter(gl, key) : gl.getParameter(key);
  }
  const parameterKeys = Array.isArray(parameters) ? parameters : Object.keys(parameters);
  const state = {};
  for (const key of parameterKeys) {
    const getter = GL_PARAMETER_GETTERS[key];
    state[key] = getter ? getter(gl, Number(key)) : gl.getParameter(Number(key));
  }
  return state;
}
function resetGLParameters(gl) {
  setGLParameters(gl, GL_PARAMETER_DEFAULTS);
}
function isObjectEmpty$2(object2) {
  for (const key in object2) {
    return false;
  }
  return true;
}
function deepArrayEqual(x2, y2) {
  if (x2 === y2) {
    return true;
  }
  const isArrayX = Array.isArray(x2) || ArrayBuffer.isView(x2);
  const isArrayY = Array.isArray(y2) || ArrayBuffer.isView(y2);
  if (isArrayX && isArrayY && x2.length === y2.length) {
    for (let i2 = 0; i2 < x2.length; ++i2) {
      if (x2[i2] !== y2[i2]) {
        return false;
      }
    }
    return true;
  }
  return false;
}
class GLState {
  constructor(gl, {
    copyState = false,
    // Copy cache from params (slow) or initialize from WebGL defaults (fast)
    log: log3 = () => {
    }
    // Logging function, called when gl parameter change calls are actually issued
  } = {}) {
    __publicField2(this, "gl");
    __publicField2(this, "program", null);
    __publicField2(this, "stateStack", []);
    __publicField2(this, "enable", true);
    __publicField2(this, "cache");
    __publicField2(this, "log");
    this.gl = gl;
    this.cache = copyState ? getGLParameters(gl) : Object.assign({}, GL_PARAMETER_DEFAULTS);
    this.log = log3;
    this._updateCache = this._updateCache.bind(this);
    Object.seal(this);
  }
  push(values4 = {}) {
    this.stateStack.push({});
  }
  pop() {
    assert$a(this.stateStack.length > 0);
    const oldValues = this.stateStack[this.stateStack.length - 1];
    setGLParameters(this.gl, oldValues);
    this.stateStack.pop();
  }
  /**
  // interceptor for context set functions - update our cache and our stack
  // values (Object) - the key values for this setter
   * @param values
   * @returns
   */
  _updateCache(values4) {
    let valueChanged = false;
    let oldValue;
    const oldValues = this.stateStack.length > 0 ? this.stateStack[this.stateStack.length - 1] : null;
    for (const key in values4) {
      assert$a(key !== void 0);
      const value = values4[key];
      const cached = this.cache[key];
      if (!deepArrayEqual(value, cached)) {
        valueChanged = true;
        oldValue = cached;
        if (oldValues && !(key in oldValues)) {
          oldValues[key] = cached;
        }
        this.cache[key] = value;
      }
    }
    return { valueChanged, oldValue };
  }
}
function getContextState(gl) {
  return gl.state;
}
function trackContextState(gl, options2) {
  const { enable: enable4 = true, copyState } = options2;
  assert$a(copyState !== void 0);
  if (!gl.state) {
    gl.state = new GLState(gl, { copyState });
    installProgramSpy(gl);
    for (const key in GL_HOOKED_SETTERS) {
      const setter = GL_HOOKED_SETTERS[key];
      installSetterSpy(gl, key, setter);
    }
    installGetterOverride(gl, "getParameter");
    installGetterOverride(gl, "isEnabled");
  }
  const glState = getContextState(gl);
  glState.enable = enable4;
  return gl;
}
function pushContextState(gl) {
  let glState = getContextState(gl);
  if (!glState) {
    trackContextState(gl, { copyState: false });
    glState = getContextState(gl);
  }
  glState.push();
}
function popContextState(gl) {
  const glState = getContextState(gl);
  assert$a(glState);
  glState.pop();
}
function installGetterOverride(gl, functionName) {
  const originalGetterFunc = gl[functionName].bind(gl);
  gl[functionName] = function get6(pname) {
    if (pname === void 0 || NON_CACHE_PARAMETERS.has(pname)) {
      return originalGetterFunc(pname);
    }
    const glState = getContextState(gl);
    if (!(pname in glState.cache)) {
      glState.cache[pname] = originalGetterFunc(pname);
    }
    return glState.enable ? (
      // Call the getter the params so that it can e.g. serve from a cache
      glState.cache[pname]
    ) : (
      // Optionally call the original function to do a "hard" query from the WebGL2RenderingContext
      originalGetterFunc(pname)
    );
  };
  Object.defineProperty(gl[functionName], "name", {
    value: `${functionName}-from-cache`,
    configurable: false
  });
}
function installSetterSpy(gl, functionName, setter) {
  if (!gl[functionName]) {
    return;
  }
  const originalSetterFunc = gl[functionName].bind(gl);
  gl[functionName] = function set(...params2) {
    const glState = getContextState(gl);
    const { valueChanged, oldValue } = setter(glState._updateCache, ...params2);
    if (valueChanged) {
      originalSetterFunc(...params2);
    }
    return oldValue;
  };
  Object.defineProperty(gl[functionName], "name", {
    value: `${functionName}-to-cache`,
    configurable: false
  });
}
function installProgramSpy(gl) {
  const originalUseProgram = gl.useProgram.bind(gl);
  gl.useProgram = function useProgramLuma(handle) {
    const glState = getContextState(gl);
    if (glState.program !== handle) {
      originalUseProgram(handle);
      glState.program = handle;
    }
  };
}
const DEFAULT_CONTEXT_PROPS = {
  powerPreference: "high-performance",
  // After all, most apps are using WebGL for performance reasons
  // eslint-disable-next-line no-console
  onContextLost: () => console.error("WebGL context lost"),
  // eslint-disable-next-line no-console
  onContextRestored: () => console.info("WebGL context restored")
};
function createBrowserContext(canvas2, props) {
  props = { ...DEFAULT_CONTEXT_PROPS, ...props };
  let errorMessage = null;
  const onCreateError = (error2) => errorMessage = error2.statusMessage || errorMessage;
  canvas2.addEventListener("webglcontextcreationerror", onCreateError, false);
  let gl = null;
  gl || (gl = canvas2.getContext("webgl2", props));
  canvas2.removeEventListener("webglcontextcreationerror", onCreateError, false);
  if (!gl) {
    throw new Error(`Failed to create WebGL context: ${errorMessage || "Unknown error"}`);
  }
  if (props.onContextLost) {
    const { onContextLost } = props;
    canvas2.addEventListener("webglcontextlost", (event) => onContextLost(event), false);
  }
  if (props.onContextRestored) {
    const { onContextRestored } = props;
    canvas2.addEventListener("webglcontextrestored", (event) => onContextRestored(event), false);
  }
  return gl;
}
function getWebGLExtension(gl, name2, extensions) {
  if (extensions[name2] === void 0) {
    extensions[name2] = gl.getExtension(name2) || null;
  }
  return extensions[name2];
}
function getDeviceInfo(gl, extensions) {
  const vendorMasked = gl.getParameter(7936);
  const rendererMasked = gl.getParameter(7937);
  getWebGLExtension(gl, "WEBGL_debug_renderer_info", extensions);
  const ext = extensions.WEBGL_debug_renderer_info;
  const vendorUnmasked = gl.getParameter(ext ? ext.UNMASKED_VENDOR_WEBGL : 7936);
  const rendererUnmasked = gl.getParameter(ext ? ext.UNMASKED_RENDERER_WEBGL : 7937);
  const vendor = vendorUnmasked || vendorMasked;
  const renderer = rendererUnmasked || rendererMasked;
  const version2 = gl.getParameter(7938);
  const gpu = identifyGPUVendor(vendor, renderer);
  const gpuBackend = identifyGPUBackend(vendor, renderer);
  const gpuType = identifyGPUType(vendor, renderer);
  const shadingLanguage = "glsl";
  const shadingLanguageVersion = 300;
  return {
    type: "webgl",
    gpu,
    gpuType,
    gpuBackend,
    vendor,
    renderer,
    version: version2,
    shadingLanguage,
    shadingLanguageVersion
  };
}
function identifyGPUVendor(vendor, renderer) {
  if (/NVIDIA/i.exec(vendor) || /NVIDIA/i.exec(renderer)) {
    return "nvidia";
  }
  if (/INTEL/i.exec(vendor) || /INTEL/i.exec(renderer)) {
    return "intel";
  }
  if (/Apple/i.exec(vendor) || /Apple/i.exec(renderer)) {
    return "apple";
  }
  if (/AMD/i.exec(vendor) || /AMD/i.exec(renderer) || /ATI/i.exec(vendor) || /ATI/i.exec(renderer)) {
    return "amd";
  }
  if (/SwiftShader/i.exec(vendor) || /SwiftShader/i.exec(renderer)) {
    return "software";
  }
  return "unknown";
}
function identifyGPUBackend(vendor, renderer) {
  if (/Metal/i.exec(vendor) || /Metal/i.exec(renderer)) {
    return "metal";
  }
  if (/ANGLE/i.exec(vendor) || /ANGLE/i.exec(renderer)) {
    return "opengl";
  }
  return "unknown";
}
function identifyGPUType(vendor, renderer) {
  if (/SwiftShader/i.exec(vendor) || /SwiftShader/i.exec(renderer)) {
    return "cpu";
  }
  const gpuVendor = identifyGPUVendor(vendor, renderer);
  switch (gpuVendor) {
    case "intel":
      return "integrated";
    case "software":
      return "cpu";
    case "unknown":
      return "unknown";
    default:
      return "discrete";
  }
}
function getGLFromVertexType(dataType) {
  switch (dataType) {
    case "uint8":
      return 5121;
    case "sint8":
      return 5120;
    case "unorm8":
      return 5121;
    case "snorm8":
      return 5120;
    case "uint16":
      return 5123;
    case "sint16":
      return 5122;
    case "unorm16":
      return 5123;
    case "snorm16":
      return 5122;
    case "uint32":
      return 5125;
    case "sint32":
      return 5124;
    case "float16":
      return 5131;
    case "float32":
      return 5126;
  }
  throw new Error(String(dataType));
}
const texture_compression_bc = "texture-compression-bc";
const texture_compression_astc = "texture-compression-astc";
const texture_compression_etc2 = "texture-compression-etc2";
const texture_compression_etc1_webgl = "texture-compression-etc1-webgl";
const texture_compression_pvrtc_webgl = "texture-compression-pvrtc-webgl";
const texture_compression_atc_webgl = "texture-compression-atc-webgl";
const float32_renderable = "float32-renderable-webgl";
const float16_renderable = "float16-renderable-webgl";
const rgb9e5ufloat_renderable = "rgb9e5ufloat_renderable-webgl";
const snorm8_renderable = "snorm8-renderable-webgl";
const norm16_renderable = "norm16-renderable-webgl";
const snorm16_renderable = "snorm16-renderable-webgl";
const float32_filterable = "float32-filterable";
const float16_filterable = "float16-filterable-webgl";
const X_S3TC = "WEBGL_compressed_texture_s3tc";
const X_S3TC_SRGB = "WEBGL_compressed_texture_s3tc_srgb";
const X_RGTC = "EXT_texture_compression_rgtc";
const X_BPTC = "EXT_texture_compression_bptc";
const X_ETC2 = "WEBGL_compressed_texture_etc";
const X_ASTC = "WEBGL_compressed_texture_astc";
const X_ETC1 = "WEBGL_compressed_texture_etc1";
const X_PVRTC = "WEBGL_compressed_texture_pvrtc";
const X_ATC = "WEBGL_compressed_texture_atc";
const EXT_texture_norm16 = "EXT_texture_norm16";
const EXT_render_snorm = "EXT_render_snorm";
const EXT_color_buffer_float = "EXT_color_buffer_float";
const TEXTURE_FEATURES = {
  "float32-renderable-webgl": ["EXT_color_buffer_float"],
  "float16-renderable-webgl": ["EXT_color_buffer_half_float"],
  "rgb9e5ufloat_renderable-webgl": ["WEBGL_render_shared_exponent"],
  "snorm8-renderable-webgl": [EXT_render_snorm],
  "norm16-renderable-webgl": [EXT_texture_norm16],
  "snorm16-renderable-webgl": [EXT_texture_norm16, EXT_render_snorm],
  "float32-filterable": ["OES_texture_float_linear"],
  "float16-filterable-webgl": ["OES_texture_half_float_linear"],
  "texture-filterable-anisotropic-webgl": ["EXT_texture_filter_anisotropic"],
  "texture-blend-float-webgl": ["EXT_float_blend"],
  "texture-compression-bc": [X_S3TC, X_S3TC_SRGB, X_RGTC, X_BPTC],
  // 'texture-compression-bc3-srgb-webgl': [X_S3TC_SRGB],
  // 'texture-compression-bc3-webgl': [X_S3TC],
  "texture-compression-bc5-webgl": [X_RGTC],
  "texture-compression-bc7-webgl": [X_BPTC],
  "texture-compression-etc2": [X_ETC2],
  "texture-compression-astc": [X_ASTC],
  "texture-compression-etc1-webgl": [X_ETC1],
  "texture-compression-pvrtc-webgl": [X_PVRTC],
  "texture-compression-atc-webgl": [X_ATC]
};
function isTextureFeature(feature2) {
  return feature2 in TEXTURE_FEATURES;
}
function checkTextureFeature(gl, feature2, extensions) {
  const textureExtensions = TEXTURE_FEATURES[feature2] || [];
  return textureExtensions.every((extension) => getWebGLExtension(gl, extension, extensions));
}
const TEXTURE_FORMATS = {
  // Unsized formats that leave the precision up to the driver. TODO - Fix bpp constants
  "rgb8unorm-unsized": {
    gl: 6407,
    b: 4,
    c: 2,
    bpp: 4,
    dataFormat: 6407,
    types: [5121, 33635]
  },
  "rgba8unorm-unsized": {
    gl: 6408,
    b: 4,
    c: 2,
    bpp: 4,
    dataFormat: 6408,
    types: [5121, 32819, 32820]
  },
  // 'r8unorm-unsized': {gl: GL.LUMINANCE, b: 4, c: 2, bpp: 4},
  // 'rgb8unorm-srgb-unsized': {gl: GL.SRGB_EXT, b: 4, c: 2, bpp: 4, gl1Ext: SRGB},
  // 'rgba8unorm-srgb-unsized': {gl: GL.SRGB_ALPHA_EXT, b: 4, c: 2, bpp: 4, gl1Ext: SRGB},
  // 8-bit formats
  "r8unorm": { gl: 33321, b: 1, c: 1, rb: true },
  "r8snorm": { gl: 36756, b: 1, c: 1, render: snorm8_renderable },
  "r8uint": { gl: 33330, b: 1, c: 1, rb: true },
  "r8sint": { gl: 33329, b: 1, c: 1, rb: true },
  // 16-bit formats
  "rg8unorm": { gl: 33323, b: 2, c: 2, rb: true },
  "rg8snorm": { gl: 36757, b: 2, c: 2, render: snorm8_renderable },
  "rg8uint": { gl: 33336, b: 2, c: 2, rb: true },
  "rg8sint": { gl: 33335, b: 2, c: 2, rb: true },
  "r16uint": { gl: 33332, b: 2, c: 1, rb: true },
  "r16sint": { gl: 33331, b: 2, c: 1, rb: true },
  "r16float": { gl: 33325, b: 2, c: 1, render: float16_renderable, filter: "float16-filterable-webgl", rb: true },
  "r16unorm-webgl": { gl: 33322, b: 2, c: 1, f: norm16_renderable, rb: true },
  "r16snorm-webgl": { gl: 36760, b: 2, c: 1, f: snorm16_renderable },
  // Packed 16-bit formats
  "rgba4unorm-webgl": { gl: 32854, b: 2, c: 4, wgpu: false, rb: true },
  "rgb565unorm-webgl": { gl: 36194, b: 2, c: 4, wgpu: false, rb: true },
  "rgb5a1unorm-webgl": { gl: 32855, b: 2, c: 4, wgpu: false, rb: true },
  // 24-bit formats
  "rgb8unorm-webgl": { gl: 32849, b: 3, c: 3, wgpu: false },
  "rgb8snorm-webgl": { gl: 36758, b: 3, c: 3, wgpu: false },
  // 32-bit formats  
  "rgba8unorm": { gl: 32856, b: 4, c: 2, bpp: 4 },
  "rgba8unorm-srgb": { gl: 35907, b: 4, c: 4, bpp: 4 },
  "rgba8snorm": { gl: 36759, b: 4, c: 4, render: snorm8_renderable },
  "rgba8uint": { gl: 36220, b: 4, c: 4, bpp: 4 },
  "rgba8sint": { gl: 36238, b: 4, c: 4, bpp: 4 },
  // reverse colors, webgpu only
  "bgra8unorm": { b: 4, c: 4 },
  "bgra8unorm-srgb": { b: 4, c: 4 },
  "rg16uint": { gl: 33338, b: 4, c: 1, bpp: 4 },
  "rg16sint": { gl: 33337, b: 4, c: 2, bpp: 4 },
  // When using a WebGL 2 context and the EXT_color_buffer_float WebGL2 extension
  "rg16float": { gl: 33327, bpp: 4, b: 4, c: 2, render: float16_renderable, filter: float16_filterable, rb: true },
  "rg16unorm-webgl": { gl: 33324, b: 2, c: 2, render: norm16_renderable },
  "rg16snorm-webgl": { gl: 36761, b: 2, c: 2, render: snorm16_renderable },
  "r32uint": { gl: 33334, b: 4, c: 1, bpp: 4, rb: true },
  "r32sint": { gl: 33333, b: 4, c: 1, bpp: 4, rb: true },
  "r32float": { gl: 33326, bpp: 4, b: 4, c: 1, render: float32_renderable, filter: float32_filterable },
  // Packed 32-bit formats
  "rgb9e5ufloat": { gl: 35901, b: 4, c: 3, p: 1, render: rgb9e5ufloat_renderable },
  // , filter: true},
  "rg11b10ufloat": { gl: 35898, b: 4, c: 3, p: 1, render: float32_renderable, rb: true },
  "rgb10a2unorm": { gl: 32857, b: 4, c: 4, p: 1, rb: true },
  "rgb10a2uint-webgl": { b: 4, c: 4, gl: 36975, p: 1, wgpu: false, bpp: 4, rb: true },
  // 48-bit formats
  "rgb16unorm-webgl": { gl: 32852, b: 2, c: 3, f: norm16_renderable },
  // rgb not renderable
  "rgb16snorm-webgl": { gl: 36762, b: 2, c: 3, f: norm16_renderable },
  // rgb not renderable
  // 64-bit formats
  "rg32uint": { gl: 33340, b: 8, c: 2, rb: true },
  "rg32sint": { gl: 33339, b: 8, c: 2, rb: true },
  "rg32float": { gl: 33328, b: 8, c: 2, render: float32_renderable, filter: float32_filterable, rb: true },
  "rgba16uint": { gl: 36214, b: 8, c: 4, rb: true },
  "rgba16sint": { gl: 36232, b: 8, c: 4, rb: true },
  "rgba16float": { gl: 34842, b: 8, c: 4, render: float16_renderable, filter: float16_filterable },
  "rgba16unorm-webgl": { gl: 32859, b: 2, c: 4, render: norm16_renderable, rb: true },
  "rgba16snorm-webgl": { gl: 36763, b: 2, c: 4, render: snorm16_renderable },
  // 96-bit formats (deprecated!)
  "rgb32float-webgl": {
    gl: 34837,
    render: float32_renderable,
    filter: float32_filterable,
    gl2ext: EXT_color_buffer_float,
    dataFormat: 6407,
    types: [5126]
  },
  // 128-bit formats
  "rgba32uint": { gl: 36208, b: 16, c: 4, rb: true },
  "rgba32sint": { gl: 36226, b: 16, c: 4, rb: true },
  "rgba32float": { gl: 34836, b: 16, c: 4, render: float32_renderable, filter: float32_filterable, rb: true },
  // Depth and stencil formats
  "stencil8": { gl: 36168, b: 1, c: 1, attachment: 36128, rb: true },
  // 8 stencil bits
  "depth16unorm": {
    gl: 33189,
    b: 2,
    c: 1,
    attachment: 36096,
    dataFormat: 6402,
    types: [5123],
    rb: true
  },
  // 16 depth bits
  "depth24plus": {
    gl: 33190,
    b: 3,
    c: 1,
    attachment: 36096,
    dataFormat: 6402,
    types: [5125]
  },
  "depth32float": {
    gl: 36012,
    b: 4,
    c: 1,
    attachment: 36096,
    dataFormat: 6402,
    types: [5126],
    rb: true
  },
  // The depth component of the "depth24plus" and "depth24plus-stencil8" formats may be implemented as either a 24-bit depth value or a "depth32float" value.
  "depth24plus-stencil8": {
    gl: 35056,
    b: 4,
    c: 2,
    p: 1,
    attachment: 33306,
    rb: true,
    depthTexture: true,
    dataFormat: 34041,
    types: [34042]
  },
  // "depth24unorm-stencil8" feature
  "depth24unorm-stencil8": {
    gl: 35056,
    b: 4,
    c: 2,
    p: 1,
    attachment: 33306,
    dataFormat: 34041,
    types: [34042],
    rb: true
  },
  // "depth32float-stencil8" feature - TODO below is render buffer only?
  "depth32float-stencil8": {
    gl: 36013,
    b: 5,
    c: 2,
    p: 1,
    attachment: 33306,
    dataFormat: 34041,
    types: [36269],
    rb: true
  },
  // BC compressed formats: check device.features.has("texture-compression-bc");
  "bc1-rgb-unorm-webgl": { gl: 33776, x: X_S3TC, f: texture_compression_bc },
  "bc1-rgb-unorm-srgb-webgl": { gl: 35916, x: X_S3TC_SRGB, f: texture_compression_bc },
  "bc1-rgba-unorm": { gl: 33777, x: X_S3TC, f: texture_compression_bc },
  "bc1-rgba-unorm-srgb": { gl: 35916, x: X_S3TC_SRGB, f: texture_compression_bc },
  "bc2-rgba-unorm": { gl: 33778, x: X_S3TC, f: texture_compression_bc },
  "bc2-rgba-unorm-srgb": { gl: 35918, x: X_S3TC_SRGB, f: texture_compression_bc },
  "bc3-rgba-unorm": { gl: 33779, x: X_S3TC, f: texture_compression_bc },
  "bc3-rgba-unorm-srgb": { gl: 35919, x: X_S3TC_SRGB, f: texture_compression_bc },
  "bc4-r-unorm": { gl: 36283, x: X_RGTC, f: texture_compression_bc },
  "bc4-r-snorm": { gl: 36284, x: X_RGTC, f: texture_compression_bc },
  "bc5-rg-unorm": { gl: 36285, x: X_RGTC, f: texture_compression_bc },
  "bc5-rg-snorm": { gl: 36286, x: X_RGTC, f: texture_compression_bc },
  "bc6h-rgb-ufloat": { gl: 36495, x: X_BPTC, f: texture_compression_bc },
  "bc6h-rgb-float": { gl: 36494, x: X_BPTC, f: texture_compression_bc },
  "bc7-rgba-unorm": { gl: 36492, x: X_BPTC, f: texture_compression_bc },
  "bc7-rgba-unorm-srgb": { gl: 36493, x: X_BPTC, f: texture_compression_bc },
  // WEBGL_compressed_texture_etc: device.features.has("texture-compression-etc2")
  // Note: Supposedly guaranteed availability compressed formats in WebGL2, but through CPU decompression
  "etc2-rgb8unorm": { gl: 37492, f: texture_compression_etc2 },
  "etc2-rgb8unorm-srgb": { gl: 37494, f: texture_compression_etc2 },
  "etc2-rgb8a1unorm": { gl: 37496, f: texture_compression_etc2 },
  "etc2-rgb8a1unorm-srgb": { gl: 37497, f: texture_compression_etc2 },
  "etc2-rgba8unorm": { gl: 37493, f: texture_compression_etc2 },
  "etc2-rgba8unorm-srgb": { gl: 37495, f: texture_compression_etc2 },
  "eac-r11unorm": { gl: 37488, f: texture_compression_etc2 },
  "eac-r11snorm": { gl: 37489, f: texture_compression_etc2 },
  "eac-rg11unorm": { gl: 37490, f: texture_compression_etc2 },
  "eac-rg11snorm": { gl: 37491, f: texture_compression_etc2 },
  // X_ASTC compressed formats: device.features.has("texture-compression-astc")
  "astc-4x4-unorm": { gl: 37808, f: texture_compression_astc },
  "astc-4x4-unorm-srgb": { gl: 37840, f: texture_compression_astc },
  "astc-5x4-unorm": { gl: 37809, f: texture_compression_astc },
  "astc-5x4-unorm-srgb": { gl: 37841, f: texture_compression_astc },
  "astc-5x5-unorm": { gl: 37810, f: texture_compression_astc },
  "astc-5x5-unorm-srgb": { gl: 37842, f: texture_compression_astc },
  "astc-6x5-unorm": { gl: 37811, f: texture_compression_astc },
  "astc-6x5-unorm-srgb": { gl: 37843, f: texture_compression_astc },
  "astc-6x6-unorm": { gl: 37812, f: texture_compression_astc },
  "astc-6x6-unorm-srgb": { gl: 37844, f: texture_compression_astc },
  "astc-8x5-unorm": { gl: 37813, f: texture_compression_astc },
  "astc-8x5-unorm-srgb": { gl: 37845, f: texture_compression_astc },
  "astc-8x6-unorm": { gl: 37814, f: texture_compression_astc },
  "astc-8x6-unorm-srgb": { gl: 37846, f: texture_compression_astc },
  "astc-8x8-unorm": { gl: 37815, f: texture_compression_astc },
  "astc-8x8-unorm-srgb": { gl: 37847, f: texture_compression_astc },
  "astc-10x5-unorm": { gl: 37819, f: texture_compression_astc },
  "astc-10x5-unorm-srgb": { gl: 37851, f: texture_compression_astc },
  "astc-10x6-unorm": { gl: 37817, f: texture_compression_astc },
  "astc-10x6-unorm-srgb": { gl: 37849, f: texture_compression_astc },
  "astc-10x8-unorm": { gl: 37818, f: texture_compression_astc },
  "astc-10x8-unorm-srgb": { gl: 37850, f: texture_compression_astc },
  "astc-10x10-unorm": { gl: 37819, f: texture_compression_astc },
  "astc-10x10-unorm-srgb": { gl: 37851, f: texture_compression_astc },
  "astc-12x10-unorm": { gl: 37820, f: texture_compression_astc },
  "astc-12x10-unorm-srgb": { gl: 37852, f: texture_compression_astc },
  "astc-12x12-unorm": { gl: 37821, f: texture_compression_astc },
  "astc-12x12-unorm-srgb": { gl: 37853, f: texture_compression_astc },
  // WEBGL_compressed_texture_pvrtc
  "pvrtc-rgb4unorm-webgl": { gl: 35840, f: texture_compression_pvrtc_webgl },
  "pvrtc-rgba4unorm-webgl": { gl: 35842, f: texture_compression_pvrtc_webgl },
  "pvrtc-rbg2unorm-webgl": { gl: 35841, f: texture_compression_pvrtc_webgl },
  "pvrtc-rgba2unorm-webgl": { gl: 35843, f: texture_compression_pvrtc_webgl },
  // WEBGL_compressed_texture_etc1
  "etc1-rbg-unorm-webgl": { gl: 36196, f: texture_compression_etc1_webgl },
  // WEBGL_compressed_texture_atc
  "atc-rgb-unorm-webgl": { gl: 35986, f: texture_compression_atc_webgl },
  "atc-rgba-unorm-webgl": { gl: 35986, f: texture_compression_atc_webgl },
  "atc-rgbai-unorm-webgl": { gl: 34798, f: texture_compression_atc_webgl }
};
const DATA_FORMAT_CHANNELS = {
  [6403]: 1,
  [36244]: 1,
  [33319]: 2,
  [33320]: 2,
  [6407]: 3,
  [36248]: 3,
  [6408]: 4,
  [36249]: 4,
  [6402]: 1,
  [34041]: 1,
  [6406]: 1,
  [6409]: 1,
  [6410]: 2
};
const TYPE_SIZES = {
  [5126]: 4,
  [5125]: 4,
  [5124]: 4,
  [5123]: 2,
  [5122]: 2,
  [5131]: 2,
  [5120]: 1,
  [5121]: 1
};
function isTextureFormatSupported(gl, format, extensions) {
  const info = TEXTURE_FORMATS[format];
  if (!info) {
    return false;
  }
  if (info.gl === void 0) {
    return false;
  }
  const extension = info.x || info.gl2ext;
  if (extension) {
    return Boolean(getWebGLExtension(gl, extension, extensions));
  }
  return true;
}
function convertTextureFormatToGL(format) {
  const formatInfo = TEXTURE_FORMATS[format];
  const webglFormat = formatInfo == null ? void 0 : formatInfo.gl;
  if (webglFormat === void 0) {
    throw new Error(`Unsupported texture format ${format}`);
  }
  return webglFormat;
}
function isTextureFormatFilterable(gl, format, extensions) {
  if (!isTextureFormatSupported(gl, format, extensions)) {
    return false;
  }
  if (format.startsWith("depth") || format.startsWith("stencil")) {
    return false;
  }
  try {
    const decoded = decodeTextureFormat(format);
    if (decoded.signed) {
      return false;
    }
  } catch {
    return false;
  }
  if (format.endsWith("32float")) {
    return Boolean(getWebGLExtension(gl, "OES_texture_float_linear, extensions", extensions));
  }
  if (format.endsWith("16float")) {
    return Boolean(getWebGLExtension(gl, "OES_texture_half_float_linear, extensions", extensions));
  }
  return true;
}
function isTextureFormatRenderable(gl, format, extensions) {
  if (!isTextureFormatSupported(gl, format, extensions)) {
    return false;
  }
  if (typeof format === "number") {
    return false;
  }
  return true;
}
function getWebGLTextureParameters(format) {
  var _a3;
  const formatData = TEXTURE_FORMATS[format];
  const webglFormat = convertTextureFormatToGL(format);
  const decoded = decodeTextureFormat(format);
  return {
    format: webglFormat,
    dataFormat: (formatData == null ? void 0 : formatData.dataFormat) || getWebGLPixelDataFormat(decoded.format, decoded.integer, decoded.normalized, webglFormat),
    // depth formats don't have a type
    type: decoded.dataType ? getGLFromVertexType(decoded.dataType) : ((_a3 = formatData == null ? void 0 : formatData.types) == null ? void 0 : _a3[0]) || 5121,
    // @ts-expect-error
    compressed: decoded.compressed
  };
}
function getDepthStencilAttachmentWebGL(format) {
  const info = TEXTURE_FORMATS[format];
  if (!(info == null ? void 0 : info.attachment)) {
    throw new Error(`${format} is not a depth stencil format`);
  }
  return info.attachment;
}
function getTextureFormatBytesPerPixel(format) {
  const params2 = getWebGLTextureParameters(format);
  const channels = DATA_FORMAT_CHANNELS[params2.dataFormat] || 4;
  const channelSize = TYPE_SIZES[params2.type] || 1;
  return channels * channelSize;
}
function getWebGLPixelDataFormat(dataFormat, integer, normalized, format) {
  if (format === 6408 || format === 6407) {
    return format;
  }
  switch (dataFormat) {
    case "r":
      return integer && !normalized ? 36244 : 6403;
    case "rg":
      return integer && !normalized ? 33320 : 33319;
    case "rgb":
      return integer && !normalized ? 36248 : 6407;
    case "rgba":
      return integer && !normalized ? 36249 : 6408;
    default:
      return 6408;
  }
}
const WEBGL_FEATURES = {
  // optional WebGPU features
  "depth-clip-control": "EXT_depth_clamp",
  // TODO these seem subtly different
  // 'timestamp-query' // GPUQueryType "timestamp-query"
  // "indirect-first-instance"
  // Textures are handled by getTextureFeatures()
  // 'depth24unorm-stencil8' // GPUTextureFormat 'depth24unorm-stencil8'
  // 'depth32float-stencil8' // GPUTextureFormat 'depth32float-stencil8'
  // optional WebGL features
  "timer-query-webgl": "EXT_disjoint_timer_query_webgl2",
  "compilation-status-async-webgl": "KHR_parallel_shader_compile",
  "polygon-mode-webgl": "WEBGL_polygon_mode",
  "provoking-vertex-webgl": "WEBGL_provoking_vertex",
  "shader-clip-cull-distance-webgl": "WEBGL_clip_cull_distance",
  "shader-noperspective-interpolation-webgl": "NV_shader_noperspective_interpolation",
  "shader-conservative-depth-webgl": "EXT_conservative_depth"
  // Textures are handled by getTextureFeatures()
};
class WebGLDeviceFeatures extends DeviceFeatures {
  constructor(gl, extensions, disabledFeatures) {
    super([], disabledFeatures);
    __publicField2(this, "gl");
    __publicField2(this, "extensions");
    __publicField2(this, "testedFeatures", /* @__PURE__ */ new Set());
    this.gl = gl;
    this.extensions = extensions;
    getWebGLExtension(gl, "EXT_color_buffer_float", extensions);
  }
  *[Symbol.iterator]() {
    const features = this.getFeatures();
    for (const feature2 of features) {
      if (this.has(feature2)) {
        yield feature2;
      }
    }
    return [];
  }
  has(feature2) {
    if (this.disabledFeatures[feature2]) {
      return false;
    }
    if (!this.testedFeatures.has(feature2)) {
      this.testedFeatures.add(feature2);
      if (isTextureFeature(feature2) && checkTextureFeature(this.gl, feature2, this.extensions)) {
        this.features.add(feature2);
      }
      if (this.getWebGLFeature(feature2)) {
        this.features.add(feature2);
      }
    }
    return this.features.has(feature2);
  }
  // FOR DEVICE
  initializeFeatures() {
    const features = this.getFeatures().filter((feature2) => feature2 !== "polygon-mode-webgl");
    for (const feature2 of features) {
      this.has(feature2);
    }
  }
  // IMPLEMENTATION
  getFeatures() {
    return [...Object.keys(WEBGL_FEATURES), ...Object.keys(TEXTURE_FEATURES)];
  }
  /** Extract all WebGL features */
  getWebGLFeature(feature2) {
    const featureInfo = WEBGL_FEATURES[feature2];
    const isSupported = typeof featureInfo === "string" ? Boolean(getWebGLExtension(this.gl, featureInfo, this.extensions)) : Boolean(featureInfo);
    return isSupported;
  }
}
class WebGLDeviceLimits extends DeviceLimits {
  constructor(gl) {
    super();
    // WebGL does not support compute shaders
    // PRIVATE
    __publicField2(this, "gl");
    __publicField2(this, "limits", {});
    this.gl = gl;
  }
  get maxTextureDimension1D() {
    return 0;
  }
  // WebGL does not support 1D textures
  get maxTextureDimension2D() {
    return this.getParameter(3379);
  }
  get maxTextureDimension3D() {
    return this.getParameter(32883);
  }
  get maxTextureArrayLayers() {
    return this.getParameter(35071);
  }
  get maxBindGroups() {
    return 0;
  }
  get maxDynamicUniformBuffersPerPipelineLayout() {
    return 0;
  }
  // TBD
  get maxDynamicStorageBuffersPerPipelineLayout() {
    return 0;
  }
  // TBD
  get maxSampledTexturesPerShaderStage() {
    return this.getParameter(35660);
  }
  // ) TBD
  get maxSamplersPerShaderStage() {
    return this.getParameter(35661);
  }
  get maxStorageBuffersPerShaderStage() {
    return 0;
  }
  // TBD
  get maxStorageTexturesPerShaderStage() {
    return 0;
  }
  // TBD
  get maxUniformBuffersPerShaderStage() {
    return this.getParameter(35375);
  }
  get maxUniformBufferBindingSize() {
    return this.getParameter(35376);
  }
  get maxStorageBufferBindingSize() {
    return 0;
  }
  get minUniformBufferOffsetAlignment() {
    return this.getParameter(35380);
  }
  get minStorageBufferOffsetAlignment() {
    return 0;
  }
  get maxVertexBuffers() {
    return 16;
  }
  // WebGL 2 supports 16 buffers, see https://github.com/gpuweb/gpuweb/issues/4284
  get maxVertexAttributes() {
    return this.getParameter(34921);
  }
  get maxVertexBufferArrayStride() {
    return 2048;
  }
  // TBD, this is just the default value from WebGPU
  get maxInterStageShaderComponents() {
    return this.getParameter(35659);
  }
  get maxComputeWorkgroupStorageSize() {
    return 0;
  }
  // WebGL does not support compute shaders
  get maxComputeInvocationsPerWorkgroup() {
    return 0;
  }
  // WebGL does not support compute shaders
  get maxComputeWorkgroupSizeX() {
    return 0;
  }
  // WebGL does not support compute shaders
  get maxComputeWorkgroupSizeY() {
    return 0;
  }
  // WebGL does not support compute shaders
  get maxComputeWorkgroupSizeZ() {
    return 0;
  }
  // WebGL does not support compute shaders
  get maxComputeWorkgroupsPerDimension() {
    return 0;
  }
  getParameter(parameter) {
    if (this.limits[parameter] === void 0) {
      this.limits[parameter] = this.gl.getParameter(parameter);
    }
    return this.limits[parameter];
  }
}
function withGLParameters(gl, parameters, func2) {
  if (isObjectEmpty$1(parameters)) {
    return func2(gl);
  }
  const { nocatch = true } = parameters;
  pushContextState(gl);
  setGLParameters(gl, parameters);
  let value;
  if (nocatch) {
    value = func2(gl);
    popContextState(gl);
  } else {
    try {
      value = func2(gl);
    } finally {
      popContextState(gl);
    }
  }
  return value;
}
function isObjectEmpty$1(object2) {
  for (const key in object2) {
    return false;
  }
  return true;
}
function withDeviceAndGLParameters(device, parameters, glParameters, func2) {
  if (isObjectEmpty$3(parameters)) {
    return func2(device);
  }
  const webglDevice = device;
  pushContextState(webglDevice.gl);
  try {
    setDeviceParameters(device, parameters);
    setGLParameters(webglDevice.gl, glParameters);
    return func2(device);
  } finally {
    popContextState(webglDevice.gl);
  }
}
function setDeviceParameters(device, parameters) {
  const webglDevice = device;
  const { gl } = webglDevice;
  if (parameters.cullMode) {
    switch (parameters.cullMode) {
      case "none":
        gl.disable(2884);
        break;
      case "front":
        gl.enable(2884);
        gl.cullFace(1028);
        break;
      case "back":
        gl.enable(2884);
        gl.cullFace(1029);
        break;
    }
  }
  if (parameters.frontFace) {
    gl.frontFace(map("frontFace", parameters.frontFace, {
      ccw: 2305,
      cw: 2304
    }));
  }
  if (parameters.unclippedDepth) {
    if (device.features.has("depth-clip-control")) {
      gl.enable(34383);
    }
  }
  if (parameters.depthBias !== void 0) {
    gl.enable(32823);
    gl.polygonOffset(parameters.depthBias, parameters.depthBiasSlopeScale || 0);
  }
  if (parameters.provokingVertex) {
    if (device.features.has("provoking-vertex-webgl")) {
      const extensions = webglDevice.getExtension("WEBGL_provoking_vertex");
      const ext = extensions.WEBGL_provoking_vertex;
      const vertex2 = map("provokingVertex", parameters.provokingVertex, {
        first: 36429,
        last: 36430
      });
      ext == null ? void 0 : ext.provokingVertexWEBGL(vertex2);
    }
  }
  if (parameters.polygonMode || parameters.polygonOffsetLine) {
    if (device.features.has("polygon-mode-webgl")) {
      if (parameters.polygonMode) {
        const extensions = webglDevice.getExtension("WEBGL_polygon_mode");
        const ext = extensions.WEBGL_polygon_mode;
        const mode2 = map("polygonMode", parameters.polygonMode, {
          fill: 6914,
          line: 6913
        });
        ext == null ? void 0 : ext.polygonModeWEBGL(1028, mode2);
        ext == null ? void 0 : ext.polygonModeWEBGL(1029, mode2);
      }
      if (parameters.polygonOffsetLine) {
        gl.enable(10754);
      }
    }
  }
  if (device.features.has("shader-clip-cull-distance-webgl")) {
    if (parameters.clipDistance0) {
      gl.enable(12288);
    }
    if (parameters.clipDistance1) {
      gl.enable(12289);
    }
    if (parameters.clipDistance2) {
      gl.enable(12290);
    }
    if (parameters.clipDistance3) {
      gl.enable(12291);
    }
    if (parameters.clipDistance4) {
      gl.enable(12292);
    }
    if (parameters.clipDistance5) {
      gl.enable(12293);
    }
    if (parameters.clipDistance6) {
      gl.enable(12294);
    }
    if (parameters.clipDistance7) {
      gl.enable(12295);
    }
  }
  if (parameters.depthWriteEnabled !== void 0) {
    gl.depthMask(mapBoolean("depthWriteEnabled", parameters.depthWriteEnabled));
  }
  if (parameters.depthCompare) {
    parameters.depthCompare !== "always" ? gl.enable(2929) : gl.disable(2929);
    gl.depthFunc(convertCompareFunction("depthCompare", parameters.depthCompare));
  }
  if (parameters.stencilWriteMask) {
    const mask = parameters.stencilWriteMask;
    gl.stencilMaskSeparate(1028, mask);
    gl.stencilMaskSeparate(1029, mask);
  }
  if (parameters.stencilReadMask) {
    log.warn("stencilReadMask not supported under WebGL");
  }
  if (parameters.stencilCompare) {
    const mask = parameters.stencilReadMask || 4294967295;
    const glValue = convertCompareFunction("depthCompare", parameters.stencilCompare);
    parameters.stencilCompare !== "always" ? gl.enable(2960) : gl.disable(2960);
    gl.stencilFuncSeparate(1028, glValue, 0, mask);
    gl.stencilFuncSeparate(1029, glValue, 0, mask);
  }
  if (parameters.stencilPassOperation && parameters.stencilFailOperation && parameters.stencilDepthFailOperation) {
    const dppass = convertStencilOperation("stencilPassOperation", parameters.stencilPassOperation);
    const sfail = convertStencilOperation("stencilFailOperation", parameters.stencilFailOperation);
    const dpfail = convertStencilOperation("stencilDepthFailOperation", parameters.stencilDepthFailOperation);
    gl.stencilOpSeparate(1028, sfail, dpfail, dppass);
    gl.stencilOpSeparate(1029, sfail, dpfail, dppass);
  }
  if (parameters.blendColorOperation || parameters.blendAlphaOperation) {
    gl.enable(3042);
    const colorEquation = convertBlendOperationToEquation("blendColorOperation", parameters.blendColorOperation || "add");
    const alphaEquation = convertBlendOperationToEquation("blendAlphaOperation", parameters.blendAlphaOperation || "add");
    gl.blendEquationSeparate(colorEquation, alphaEquation);
    const colorSrcFactor = convertBlendFactorToFunction("blendColorSrcFactor", parameters.blendColorSrcFactor || "one");
    const colorDstFactor = convertBlendFactorToFunction("blendColorDstFactor", parameters.blendColorDstFactor || "zero");
    const alphaSrcFactor = convertBlendFactorToFunction("blendAlphaSrcFactor", parameters.blendAlphaSrcFactor || "one");
    const alphaDstFactor = convertBlendFactorToFunction("blendAlphaDstFactor", parameters.blendAlphaDstFactor || "zero");
    gl.blendFuncSeparate(colorSrcFactor, colorDstFactor, alphaSrcFactor, alphaDstFactor);
  }
}
function convertCompareFunction(parameter, value) {
  return map(parameter, value, {
    never: 512,
    less: 513,
    equal: 514,
    "less-equal": 515,
    greater: 516,
    "not-equal": 517,
    "greater-equal": 518,
    always: 519
  });
}
function convertStencilOperation(parameter, value) {
  return map(parameter, value, {
    keep: 7680,
    zero: 0,
    replace: 7681,
    invert: 5386,
    "increment-clamp": 7682,
    "decrement-clamp": 7683,
    "increment-wrap": 34055,
    "decrement-wrap": 34056
  });
}
function convertBlendOperationToEquation(parameter, value) {
  return map(parameter, value, {
    add: 32774,
    subtract: 32778,
    "reverse-subtract": 32779,
    min: 32775,
    max: 32776
  });
}
function convertBlendFactorToFunction(parameter, value) {
  return map(parameter, value, {
    one: 1,
    zero: 0,
    "src-color": 768,
    "one-minus-src-color": 769,
    "dst-color": 774,
    "one-minus-dst-color": 775,
    "src-alpha": 770,
    "one-minus-src-alpha": 771,
    "dst-alpha": 772,
    "one-minus-dst-alpha": 773,
    "src-alpha-saturated": 776,
    "constant-color": 32769,
    "one-minus-constant-color": 32770,
    "constant-alpha": 32771,
    "one-minus-constant-alpha": 32772
  });
}
function message(parameter, value) {
  return `Illegal parameter ${value} for ${parameter}`;
}
function map(parameter, value, valueMap) {
  if (!(value in valueMap)) {
    throw new Error(message(parameter, value));
  }
  return valueMap[value];
}
function mapBoolean(parameter, value) {
  return value;
}
function convertSamplerParametersToWebGL(props) {
  const params2 = {};
  if (props.addressModeU) {
    params2[10242] = convertAddressMode(props.addressModeU);
  }
  if (props.addressModeV) {
    params2[10243] = convertAddressMode(props.addressModeV);
  }
  if (props.addressModeW) {
    params2[32882] = convertAddressMode(props.addressModeW);
  }
  if (props.magFilter) {
    params2[10240] = convertMaxFilterMode(props.magFilter);
  }
  if (props.minFilter || props.mipmapFilter) {
    params2[10241] = convertMinFilterMode(props.minFilter || "linear", props.mipmapFilter);
  }
  if (props.lodMinClamp !== void 0) {
    params2[33082] = props.lodMinClamp;
  }
  if (props.lodMaxClamp !== void 0) {
    params2[33083] = props.lodMaxClamp;
  }
  if (props.type === "comparison-sampler") {
    params2[34892] = 34894;
  }
  if (props.compare) {
    params2[34893] = convertCompareFunction("compare", props.compare);
  }
  if (props.maxAnisotropy) {
    params2[34046] = props.maxAnisotropy;
  }
  return params2;
}
function convertAddressMode(addressMode) {
  switch (addressMode) {
    case "clamp-to-edge":
      return 33071;
    case "repeat":
      return 10497;
    case "mirror-repeat":
      return 33648;
  }
}
function convertMaxFilterMode(maxFilter) {
  switch (maxFilter) {
    case "nearest":
      return 9728;
    case "linear":
      return 9729;
  }
}
function convertMinFilterMode(minFilter, mipmapFilter) {
  if (!mipmapFilter) {
    return convertMaxFilterMode(minFilter);
  }
  switch (minFilter) {
    case "nearest":
      return mipmapFilter === "nearest" ? 9984 : 9986;
    case "linear":
      return mipmapFilter === "nearest" ? 9985 : 9987;
  }
}
class WEBGLBuffer extends Buffer$1 {
  constructor(device, props = {}) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "gl");
    __publicField2(this, "handle");
    /** Target in OpenGL defines the type of buffer */
    __publicField2(this, "glTarget");
    /** Usage is a hint on how frequently the buffer will be updates */
    __publicField2(this, "glUsage");
    /** Index type is needed when issuing draw calls, so we pre-compute it */
    __publicField2(this, "glIndexType", 5123);
    /** Number of bytes allocated on the GPU for this buffer */
    __publicField2(this, "byteLength");
    /** Number of bytes used */
    __publicField2(this, "bytesUsed");
    this.device = device;
    this.gl = this.device.gl;
    const handle = typeof props === "object" ? props.handle : void 0;
    this.handle = handle || this.gl.createBuffer();
    device.setSpectorMetadata(this.handle, { ...this.props, data: typeof this.props.data });
    this.glTarget = getWebGLTarget(this.props.usage);
    this.glUsage = getWebGLUsage(this.props.usage);
    this.glIndexType = this.props.indexType === "uint32" ? 5125 : 5123;
    if (props.data) {
      this._initWithData(props.data, props.byteOffset, props.byteLength);
    } else {
      this._initWithByteLength(props.byteLength || 0);
    }
  }
  // PRIVATE METHODS
  /** Allocate a new buffer and initialize to contents of typed array */
  _initWithData(data2, byteOffset = 0, byteLength = data2.byteLength + byteOffset) {
    const glTarget = this.glTarget;
    this.gl.bindBuffer(glTarget, this.handle);
    this.gl.bufferData(glTarget, byteLength, this.glUsage);
    this.gl.bufferSubData(glTarget, byteOffset, data2);
    this.gl.bindBuffer(glTarget, null);
    this.bytesUsed = byteLength;
    this.byteLength = byteLength;
    this._setDebugData(data2, byteOffset, byteLength);
    this.trackAllocatedMemory(byteLength);
  }
  // Allocate a GPU buffer of specified size.
  _initWithByteLength(byteLength) {
    assert$a(byteLength >= 0);
    let data2 = byteLength;
    if (byteLength === 0) {
      data2 = new Float32Array(0);
    }
    const glTarget = this.glTarget;
    this.gl.bindBuffer(glTarget, this.handle);
    this.gl.bufferData(glTarget, data2, this.glUsage);
    this.gl.bindBuffer(glTarget, null);
    this.bytesUsed = byteLength;
    this.byteLength = byteLength;
    this._setDebugData(null, 0, byteLength);
    this.trackAllocatedMemory(byteLength);
    return this;
  }
  destroy() {
    if (!this.destroyed && this.handle) {
      this.removeStats();
      this.trackDeallocatedMemory();
      this.gl.deleteBuffer(this.handle);
      this.destroyed = true;
      this.handle = null;
    }
  }
  write(data2, byteOffset = 0) {
    const glTarget = 36663;
    this.gl.bindBuffer(glTarget, this.handle);
    {
      this.gl.bufferSubData(glTarget, byteOffset, data2);
    }
    this.gl.bindBuffer(glTarget, null);
    this._setDebugData(data2, byteOffset, data2.byteLength);
  }
  /** Asynchronously read data from the buffer */
  async readAsync(byteOffset = 0, byteLength) {
    return this.readSyncWebGL(byteOffset, byteLength);
  }
  /** Synchronously read data from the buffer. WebGL only. */
  readSyncWebGL(byteOffset = 0, byteLength) {
    byteLength = byteLength ?? this.byteLength - byteOffset;
    const data2 = new Uint8Array(byteLength);
    const dstOffset = 0;
    this.gl.bindBuffer(36662, this.handle);
    this.gl.getBufferSubData(36662, byteOffset, data2, dstOffset, byteLength);
    this.gl.bindBuffer(36662, null);
    this._setDebugData(data2, byteOffset, byteLength);
    return data2;
  }
}
function getWebGLTarget(usage) {
  if (usage & Buffer$1.INDEX) {
    return 34963;
  }
  if (usage & Buffer$1.VERTEX) {
    return 34962;
  }
  if (usage & Buffer$1.UNIFORM) {
    return 35345;
  }
  return 34962;
}
function getWebGLUsage(usage) {
  if (usage & Buffer$1.INDEX) {
    return 35044;
  }
  if (usage & Buffer$1.VERTEX) {
    return 35044;
  }
  if (usage & Buffer$1.UNIFORM) {
    return 35048;
  }
  return 35044;
}
class WEBGLSampler extends Sampler {
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "handle");
    __publicField2(this, "parameters");
    this.device = device;
    this.parameters = convertSamplerParametersToWebGL(props);
    this.handle = this.handle || this.device.gl.createSampler();
    this._setSamplerParameters(this.parameters);
  }
  destroy() {
    if (this.handle) {
      this.device.gl.deleteSampler(this.handle);
      this.handle = void 0;
    }
  }
  toString() {
    return `Sampler(${this.id},${JSON.stringify(this.props)})`;
  }
  /** Set sampler parameters on the sampler */
  _setSamplerParameters(parameters) {
    for (const [pname, value] of Object.entries(parameters)) {
      const param = Number(pname);
      switch (param) {
        case 33082:
        case 33083:
          this.device.gl.samplerParameterf(this.handle, param, value);
          break;
        default:
          this.device.gl.samplerParameteri(this.handle, param, value);
          break;
      }
    }
  }
}
class WEBGLTextureView extends TextureView {
  constructor(device, props) {
    super(device, { ...Texture.defaultProps, ...props });
    __publicField2(this, "device");
    __publicField2(this, "gl");
    __publicField2(this, "handle");
    __publicField2(this, "texture");
    this.device = device;
    this.gl = this.device.gl;
    this.handle = null;
    this.texture = props.texture;
  }
}
const DEFAULT_WEBGL_TEXTURE_PROPS = {
  // deprecated
  parameters: {},
  pixelStore: {},
  pixels: null,
  border: 0,
  dataFormat: void 0,
  textureUnit: void 0,
  target: void 0
};
const _WEBGLTexture = class extends Texture {
  constructor(device, props) {
    var _a3;
    super(device, { ...DEFAULT_WEBGL_TEXTURE_PROPS, format: "rgba8unorm", ...props });
    __publicField2(this, "MAX_ATTRIBUTES");
    __publicField2(this, "device");
    __publicField2(this, "gl");
    __publicField2(this, "handle");
    // (TODO - currently unused in WebGL, but WebGL 2 does support sampler objects) */
    __publicField2(this, "sampler");
    __publicField2(this, "view");
    // data;
    __publicField2(this, "glFormat");
    __publicField2(this, "type");
    __publicField2(this, "dataFormat");
    __publicField2(this, "mipmaps");
    /**
     * @note `target` cannot be modified by bind:
     * textures are special because when you first bind them to a target,
     * they get special information. When you first bind a texture as a
     * GL_TEXTURE_2D, you are saying that this texture is a 2D texture.
     * And it will always be a 2D texture; this state cannot be changed ever.
     * A texture that was first bound as a GL_TEXTURE_2D, must always be bound as a GL_TEXTURE_2D;
     * attempting to bind it as GL_TEXTURE_3D will give rise to a run-time error
     * */
    __publicField2(this, "target");
    __publicField2(this, "textureUnit");
    /**
     * Program.draw() checks the loaded flag of all textures to avoid
     * Textures that are still loading from promises
     * Set to true as soon as texture has been initialized with valid data
     */
    __publicField2(this, "loaded", false);
    __publicField2(this, "_video");
    this.device = device;
    this.gl = this.device.gl;
    this.handle = this.props.handle || this.gl.createTexture();
    this.device.setSpectorMetadata(this.handle, { ...this.props, data: typeof this.props.data });
    this.glFormat = 6408;
    this.target = getWebGLTextureTarget(this.props);
    this.loaded = false;
    if (typeof ((_a3 = this.props) == null ? void 0 : _a3.data) === "string") {
      Object.assign(this.props, { data: loadImage$2(this.props.data) });
    }
    this.initialize(this.props);
    Object.seal(this);
  }
  destroy() {
    if (this.handle) {
      this.gl.deleteTexture(this.handle);
      this.removeStats();
      this.trackDeallocatedMemory("Texture");
      this.destroyed = true;
    }
  }
  toString() {
    return `Texture(${this.id},${this.width}x${this.height})`;
  }
  createView(props) {
    return new WEBGLTextureView(this.device, { ...props, texture: this });
  }
  // eslint-disable-next-line max-statements
  initialize(props = {}) {
    if (this.props.dimension === "cube") {
      return this.initializeCube(props);
    }
    let data2 = props.data;
    if (data2 instanceof Promise) {
      data2.then((resolvedImageData) => this.initialize(Object.assign({}, props, {
        pixels: resolvedImageData,
        data: resolvedImageData
      })));
      return this;
    }
    const isVideo = typeof HTMLVideoElement !== "undefined" && data2 instanceof HTMLVideoElement;
    if (isVideo && data2.readyState < HTMLVideoElement.HAVE_METADATA) {
      this._video = null;
      data2.addEventListener("loadeddata", () => this.initialize(props));
      return this;
    }
    const { parameters = {} } = props;
    const { pixels = null, pixelStore = {}, textureUnit = void 0, mipmaps = true } = props;
    if (!data2) {
      data2 = pixels;
    }
    let { width, height, dataFormat, type, compressed = false } = props;
    const { depth: depth2 = 0 } = props;
    const glFormat = convertTextureFormatToGL(props.format);
    ({ width, height, compressed, dataFormat, type } = this._deduceParameters({
      format: props.format,
      type,
      dataFormat,
      compressed,
      data: data2,
      width,
      height
    }));
    this.width = width;
    this.height = height;
    this.glFormat = glFormat;
    this.type = type;
    this.dataFormat = dataFormat;
    this.textureUnit = textureUnit;
    if (Number.isFinite(this.textureUnit)) {
      this.gl.activeTexture(33984 + this.textureUnit);
      this.gl.bindTexture(this.target, this.handle);
    }
    this.mipmaps = mipmaps;
    this.setImageData({
      data: data2,
      width,
      height,
      depth: depth2,
      format: glFormat,
      type,
      dataFormat,
      // @ts-expect-error
      parameters: pixelStore,
      compressed
    });
    this.setSampler(props.sampler);
    this._setSamplerParameters(parameters);
    this.view = this.createView({ ...this.props, mipLevelCount: 1, arrayLayerCount: 1 });
    if (mipmaps && this.device.isTextureFormatFilterable(props.format)) {
      this.generateMipmap();
    }
    if (isVideo) {
      this._video = {
        video: data2,
        parameters,
        // @ts-expect-error
        lastTime: data2.readyState >= HTMLVideoElement.HAVE_CURRENT_DATA ? data2.currentTime : -1
      };
    }
    return this;
  }
  initializeCube(props) {
    const { mipmaps = true, parameters = {} } = props;
    this.setCubeMapImageData(props).then(() => {
      this.loaded = true;
      if (mipmaps) {
        this.generateMipmap(props);
      }
      this.setSampler(props.sampler);
      this._setSamplerParameters(parameters);
    });
    return this;
  }
  setSampler(sampler = {}) {
    let samplerProps;
    if (sampler instanceof WEBGLSampler) {
      this.sampler = sampler;
      samplerProps = sampler.props;
    } else {
      this.sampler = new WEBGLSampler(this.device, sampler);
      samplerProps = sampler;
    }
    const parameters = convertSamplerParametersToWebGL(samplerProps);
    this._setSamplerParameters(parameters);
    return this;
  }
  /**
   * If size has changed, reinitializes with current format
   * @note note clears image and mipmaps
   */
  resize(options2) {
    const { height, width, mipmaps = false } = options2;
    if (width !== this.width || height !== this.height) {
      return this.initialize({
        width,
        height,
        format: this.format,
        type: this.type,
        dataFormat: this.dataFormat,
        mipmaps
      });
    }
    return this;
  }
  /** Update external texture (video frame) */
  update() {
    if (this._video) {
      const { video, parameters, lastTime } = this._video;
      if (lastTime === video.currentTime || video.readyState < HTMLVideoElement.HAVE_CURRENT_DATA) {
        return;
      }
      this.setSubImageData({
        data: video,
        parameters
      });
      if (this.mipmaps) {
        this.generateMipmap();
      }
      this._video.lastTime = video.currentTime;
    }
  }
  // Call to regenerate mipmaps after modifying texture(s)
  generateMipmap(params2 = {}) {
    this.mipmaps = true;
    this.gl.bindTexture(this.target, this.handle);
    withGLParameters(this.gl, params2, () => {
      this.gl.generateMipmap(this.target);
    });
    this.gl.bindTexture(this.target, null);
    return this;
  }
  /*
   * Allocates storage
   * @param {*} pixels -
   *  null - create empty texture of specified format
   *  Typed array - init from image data in typed array
   *  Buffer|WebGLBuffer - (WEBGL2) init from image data in WebGLBuffer
   *  HTMLImageElement|Image - Inits with content of image. Auto width/height
   *  HTMLCanvasElement - Inits with contents of canvas. Auto width/height
   *  HTMLVideoElement - Creates video texture. Auto width/height
   *
   * @param  width -
   * @param  height -
   * @param  mipMapLevel -
   * @param {GLenum} format - format of image data.
   * @param {GLenum} type
   *  - format of array (autodetect from type) or
   *  - (WEBGL2) format of buffer
   * @param {Number} offset - (WEBGL2) offset from start of buffer
   * @parameters - temporary settings to be applied, can be used to supply pixel store settings.
   */
  // eslint-disable-next-line max-statements, complexity
  setImageData(options2) {
    if (this.props.dimension === "3d" || this.props.dimension === "2d-array") {
      return this.setImageData3D(options2);
    }
    this.trackDeallocatedMemory("Texture");
    const { target = this.target, pixels = null, level = 0, glFormat = this.glFormat, offset = 0, parameters = {} } = options2;
    let { data: data2 = null, type = this.type, width = this.width, height = this.height, dataFormat = this.dataFormat, compressed = false } = options2;
    if (!data2) {
      data2 = pixels;
    }
    ({ type, dataFormat, compressed, width, height } = this._deduceParameters({
      format: this.props.format,
      type,
      dataFormat,
      compressed,
      data: data2,
      width,
      height
    }));
    const { gl } = this;
    gl.bindTexture(this.target, this.handle);
    let dataType = null;
    ({ data: data2, dataType } = this._getDataType({ data: data2, compressed }));
    withGLParameters(this.gl, parameters, () => {
      switch (dataType) {
        case "null":
          gl.texImage2D(target, level, glFormat, width, height, 0, dataFormat, type, data2);
          break;
        case "typed-array":
          gl.texImage2D(
            target,
            level,
            glFormat,
            width,
            height,
            0,
            // border (must be 0)
            dataFormat,
            type,
            data2,
            offset
          );
          break;
        case "buffer":
          this.device.gl.bindBuffer(35052, data2.handle || data2);
          this.device.gl.texImage2D(target, level, glFormat, width, height, 0, dataFormat, type, offset);
          this.device.gl.bindBuffer(35052, null);
          break;
        case "browser-object":
          gl.texImage2D(target, level, glFormat, width, height, 0, dataFormat, type, data2);
          break;
        case "compressed":
          for (const [levelIndex, levelData] of data2.entries()) {
            gl.compressedTexImage2D(target, levelIndex, levelData.format, levelData.width, levelData.height, 0, levelData.data);
          }
          break;
        default:
          assert$a(false, "Unknown image data type");
      }
    });
    if (data2 && data2.byteLength) {
      this.trackAllocatedMemory(data2.byteLength, "Texture");
    } else {
      const bytesPerPixel = getTextureFormatBytesPerPixel(this.props.format);
      this.trackAllocatedMemory(this.width * this.height * bytesPerPixel, "Texture");
    }
    this.loaded = true;
    return this;
  }
  /**
   * Redefines an area of an existing texture
   * Note: does not allocate storage
   * Redefines an area of an existing texture
   */
  setSubImageData({ target = this.target, pixels = null, data: data2 = null, x: x2 = 0, y: y2 = 0, width = this.width, height = this.height, level = 0, glFormat = this.glFormat, type = this.type, dataFormat = this.dataFormat, compressed = false, offset = 0, parameters = {} }) {
    ({ type, dataFormat, compressed, width, height } = this._deduceParameters({
      format: this.props.format,
      type,
      dataFormat,
      compressed,
      data: data2,
      width,
      height
    }));
    assert$a(this.depth === 1, "texSubImage not supported for 3D textures");
    if (!data2) {
      data2 = pixels;
    }
    if (data2 && data2.data) {
      const ndarray = data2;
      data2 = ndarray.data;
      width = ndarray.shape[0];
      height = ndarray.shape[1];
    }
    if (data2 instanceof WEBGLBuffer) {
      data2 = data2.handle;
    }
    this.gl.bindTexture(this.target, this.handle);
    withGLParameters(this.gl, parameters, () => {
      if (compressed) {
        this.gl.compressedTexSubImage2D(target, level, x2, y2, width, height, glFormat, data2);
      } else if (data2 === null) {
        this.gl.texSubImage2D(target, level, x2, y2, width, height, dataFormat, type, null);
      } else if (ArrayBuffer.isView(data2)) {
        this.gl.texSubImage2D(target, level, x2, y2, width, height, dataFormat, type, data2, offset);
      } else if (typeof WebGLBuffer !== "undefined" && data2 instanceof WebGLBuffer) {
        this.device.gl.bindBuffer(35052, data2);
        this.device.gl.texSubImage2D(target, level, x2, y2, width, height, dataFormat, type, offset);
        this.device.gl.bindBuffer(35052, null);
      } else {
        this.device.gl.texSubImage2D(target, level, x2, y2, width, height, dataFormat, type, data2);
      }
    });
    this.gl.bindTexture(this.target, null);
  }
  /**
   * Defines a two-dimensional texture image or cube-map texture image with
   * pixels from the current framebuffer (rather than from client memory).
   * (gl.copyTexImage2D wrapper)
   *
   * Note that binding a texture into a Framebuffer's color buffer and
   * rendering can be faster.
   */
  copyFramebuffer(opts = {}) {
    log.error("Texture.copyFramebuffer({...}) is no logner supported, use copyToTexture(source, target, opts})")();
    return null;
  }
  getActiveUnit() {
    return this.gl.getParameter(34016) - 33984;
  }
  bind(textureUnit = this.textureUnit) {
    const { gl } = this;
    if (textureUnit !== void 0) {
      this.textureUnit = textureUnit;
      gl.activeTexture(33984 + textureUnit);
    }
    gl.bindTexture(this.target, this.handle);
    return textureUnit;
  }
  unbind(textureUnit = this.textureUnit) {
    const { gl } = this;
    if (textureUnit !== void 0) {
      this.textureUnit = textureUnit;
      gl.activeTexture(33984 + textureUnit);
    }
    gl.bindTexture(this.target, null);
    return textureUnit;
  }
  // PRIVATE METHODS
  _getDataType({ data: data2, compressed = false }) {
    if (compressed) {
      return { data: data2, dataType: "compressed" };
    }
    if (data2 === null) {
      return { data: data2, dataType: "null" };
    }
    if (ArrayBuffer.isView(data2)) {
      return { data: data2, dataType: "typed-array" };
    }
    if (data2 instanceof WEBGLBuffer) {
      return { data: data2.handle, dataType: "buffer" };
    }
    if (typeof WebGLBuffer !== "undefined" && data2 instanceof WebGLBuffer) {
      return { data: data2, dataType: "buffer" };
    }
    return { data: data2, dataType: "browser-object" };
  }
  // HELPER METHODS
  _deduceParameters(opts) {
    const { format, data: data2 } = opts;
    let { width, height, dataFormat, type, compressed } = opts;
    const parameters = getWebGLTextureParameters(format);
    dataFormat = dataFormat || parameters.dataFormat;
    type = type || parameters.type;
    compressed = compressed || parameters.compressed;
    ({ width, height } = this._deduceImageSize(data2, width, height));
    return { dataFormat, type, compressed, width, height, format, data: data2 };
  }
  // eslint-disable-next-line complexity
  _deduceImageSize(data2, width, height) {
    let size12;
    if (typeof ImageData !== "undefined" && data2 instanceof ImageData) {
      size12 = { width: data2.width, height: data2.height };
    } else if (typeof HTMLImageElement !== "undefined" && data2 instanceof HTMLImageElement) {
      size12 = { width: data2.naturalWidth, height: data2.naturalHeight };
    } else if (typeof HTMLCanvasElement !== "undefined" && data2 instanceof HTMLCanvasElement) {
      size12 = { width: data2.width, height: data2.height };
    } else if (typeof ImageBitmap !== "undefined" && data2 instanceof ImageBitmap) {
      size12 = { width: data2.width, height: data2.height };
    } else if (typeof HTMLVideoElement !== "undefined" && data2 instanceof HTMLVideoElement) {
      size12 = { width: data2.videoWidth, height: data2.videoHeight };
    } else if (!data2) {
      size12 = { width: width >= 0 ? width : 1, height: height >= 0 ? height : 1 };
    } else {
      size12 = { width, height };
    }
    assert$a(size12, "Could not deduced texture size");
    assert$a(width === void 0 || size12.width === width, "Deduced texture width does not match supplied width");
    assert$a(height === void 0 || size12.height === height, "Deduced texture height does not match supplied height");
    return size12;
  }
  // CUBE MAP METHODS
  /* eslint-disable max-statements, max-len */
  async setCubeMapImageData(options2) {
    const { gl } = this;
    const { width, height, pixels, data: data2, format = 6408, type = 5121 } = options2;
    const imageDataMap = pixels || data2;
    const resolvedFaces = await Promise.all(_WEBGLTexture.FACES.map((face) => {
      const facePixels = imageDataMap[face];
      return Promise.all(Array.isArray(facePixels) ? facePixels : [facePixels]);
    }));
    this.bind();
    _WEBGLTexture.FACES.forEach((face, index2) => {
      if (resolvedFaces[index2].length > 1 && this.props.mipmaps !== false) {
        log.warn(`${this.id} has mipmap and multiple LODs.`)();
      }
      resolvedFaces[index2].forEach((image, lodLevel) => {
        if (width && height) {
          gl.texImage2D(face, lodLevel, format, width, height, 0, format, type, image);
        } else {
          gl.texImage2D(face, lodLevel, format, format, type, image);
        }
      });
    });
    this.unbind();
  }
  /** @todo update this method to accept LODs */
  setImageDataForFace(options2) {
    const {
      face,
      width,
      height,
      pixels,
      data: data2,
      format = 6408,
      type = 5121
      // generateMipmap = false // TODO
    } = options2;
    const { gl } = this;
    const imageData = pixels || data2;
    this.bind();
    if (imageData instanceof Promise) {
      imageData.then((resolvedImageData) => this.setImageDataForFace(Object.assign({}, options2, {
        face,
        data: resolvedImageData,
        pixels: resolvedImageData
      })));
    } else if (this.width || this.height) {
      gl.texImage2D(face, 0, format, width, height, 0, format, type, imageData);
    } else {
      gl.texImage2D(face, 0, format, format, type, imageData);
    }
    return this;
  }
  /** Image 3D copies from Typed Array or WebGLBuffer */
  setImageData3D(options2) {
    const {
      level = 0,
      dataFormat,
      format,
      type,
      // = GL.UNSIGNED_BYTE,
      width,
      height,
      depth: depth2 = 1,
      offset = 0,
      data: data2,
      parameters = {}
    } = options2;
    this.trackDeallocatedMemory("Texture");
    this.gl.bindTexture(this.target, this.handle);
    const webglTextureFormat = getWebGLTextureParameters(format);
    withGLParameters(this.gl, parameters, () => {
      if (ArrayBuffer.isView(data2)) {
        this.gl.texImage3D(
          this.target,
          level,
          webglTextureFormat.format,
          width,
          height,
          depth2,
          0,
          webglTextureFormat.dataFormat,
          webglTextureFormat.type,
          // dataType: getWebGL,
          data2
        );
      }
      if (data2 instanceof WEBGLBuffer) {
        this.gl.bindBuffer(35052, data2.handle);
        this.gl.texImage3D(this.target, level, dataFormat, width, height, depth2, 0, format, type, offset);
      }
    });
    if (data2 && data2.byteLength) {
      this.trackAllocatedMemory(data2.byteLength, "Texture");
    } else {
      const bytesPerPixel = getTextureFormatBytesPerPixel(this.props.format);
      this.trackAllocatedMemory(this.width * this.height * this.depth * bytesPerPixel, "Texture");
    }
    this.loaded = true;
    return this;
  }
  // RESOURCE METHODS
  /**
   * Sets sampler parameters on texture
   */
  _setSamplerParameters(parameters) {
    if (isObjectEmpty$3(parameters)) {
      return;
    }
    logParameters(parameters);
    this.gl.bindTexture(this.target, this.handle);
    for (const [pname, pvalue] of Object.entries(parameters)) {
      const param = Number(pname);
      const value = pvalue;
      switch (param) {
        case 33082:
        case 33083:
          this.gl.texParameterf(this.target, param, value);
          break;
        default:
          this.gl.texParameteri(this.target, param, value);
          break;
      }
    }
    this.gl.bindTexture(this.target, null);
    return;
  }
};
let WEBGLTexture = _WEBGLTexture;
// TODO - remove?
__publicField2(WEBGLTexture, "FACES", [
  34069,
  34070,
  34071,
  34072,
  34073,
  34074
]);
function getWebGLTextureTarget(props) {
  switch (props.dimension) {
    case "2d":
      return 3553;
    case "cube":
      return 34067;
    case "2d-array":
      return 35866;
    case "3d":
      return 32879;
    case "1d":
    case "cube-array":
    default:
      throw new Error(props.dimension);
  }
}
function logParameters(parameters) {
  log.log(1, "texture sampler parameters", parameters)();
}
class WEBGLFramebuffer extends Framebuffer {
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "gl");
    __publicField2(this, "handle");
    const isDefaultFramebuffer = props.handle === null;
    this.device = device;
    this.gl = device.gl;
    this.handle = this.props.handle || isDefaultFramebuffer ? this.props.handle : this.gl.createFramebuffer();
    if (!isDefaultFramebuffer) {
      device.setSpectorMetadata(this.handle, { id: this.props.id, props: this.props });
      this.autoCreateAttachmentTextures();
      const prevHandle = this.gl.bindFramebuffer(36160, this.handle);
      for (let i2 = 0; i2 < this.colorAttachments.length; ++i2) {
        const attachment = this.colorAttachments[i2];
        const attachmentPoint = 36064 + i2;
        if (attachment) {
          this._attachOne(attachmentPoint, attachment);
        }
      }
      if (this.depthStencilAttachment) {
        this._attachOne(getDepthStencilAttachmentWebGL(this.depthStencilAttachment.props.format), this.depthStencilAttachment);
      }
      if (props.check !== false) {
        const status = this.gl.checkFramebufferStatus(36160);
        if (status !== 36053) {
          throw new Error(`Framebuffer ${_getFrameBufferStatus(status)}`);
        }
      }
      this.gl.bindFramebuffer(36160, prevHandle);
    }
  }
  get texture() {
    return this.colorAttachments[0];
  }
  /** destroys any auto created resources etc. */
  destroy() {
    super.destroy();
    if (!this.destroyed && this.handle !== null) {
      this.gl.deleteFramebuffer(this.handle);
    }
  }
  // PRIVATE
  /** In WebGL we must use renderbuffers for depth/stencil attachments (unless we have extensions) */
  createDepthStencilTexture(format) {
    return new WEBGLTexture(this.device, {
      id: `${this.id}-depth-stencil`,
      format,
      width: this.width,
      height: this.height,
      mipmaps: false
    });
  }
  /**
   * Attachment resize is expected to be a noop if size is same
   */
  resizeAttachments(width, height) {
    if (this.handle === null) {
      this.width = this.gl.drawingBufferWidth;
      this.height = this.gl.drawingBufferHeight;
      return this;
    }
    if (width === void 0) {
      width = this.gl.drawingBufferWidth;
    }
    if (height === void 0) {
      height = this.gl.drawingBufferHeight;
    }
    for (const colorAttachment of this.colorAttachments) {
      colorAttachment.texture.resize({ width, height });
    }
    if (this.depthStencilAttachment) {
      this.depthStencilAttachment.texture.resize({ width, height });
    }
    return this;
  }
  /** Attach one attachment */
  _attachOne(attachmentPoint, attachment) {
    if (Array.isArray(attachment)) {
      const [texture, layer = 0, level = 0] = attachment;
      this._attachTexture(attachmentPoint, texture, layer, level);
      return texture;
    }
    if (attachment instanceof WEBGLTexture) {
      this._attachTexture(attachmentPoint, attachment, 0, 0);
      return attachment;
    }
    if (attachment instanceof WEBGLTextureView) {
      const textureView = attachment;
      this._attachTexture(attachmentPoint, textureView.texture, textureView.props.baseMipLevel, textureView.props.baseArrayLayer);
      return attachment.texture;
    }
    throw new Error("attach");
  }
  // TODO - we do not seem to need render buffers in WebGL 2
  // protected _attachWEBGLRenderbuffer(attachment: GL, renderbuffer: WEBGLRenderbuffer): void {
  //   this.gl.framebufferRenderbuffer(
  //     GL.FRAMEBUFFER,
  //     attachment,
  //     GL.RENDERBUFFER,
  //     renderbuffer.handle
  //   );
  // }
  /**
   * @param attachment
   * @param texture
   * @param layer = 0 - index into WEBGLTextureArray and Texture3D or face for `TextureCubeMap`
   * @param level = 0 - mipmapLevel
   */
  _attachTexture(attachment, texture, layer, level) {
    const { gl } = this.device;
    gl.bindTexture(texture.target, texture.handle);
    switch (texture.target) {
      case 35866:
      case 32879:
        gl.framebufferTextureLayer(36160, attachment, texture.target, level, layer);
        break;
      case 34067:
        const face = mapIndexToCubeMapFace(layer);
        gl.framebufferTexture2D(36160, attachment, face, texture.handle, level);
        break;
      case 3553:
        gl.framebufferTexture2D(36160, attachment, 3553, texture.handle, level);
        break;
      default:
        assert$a(false, "Illegal texture type");
    }
    gl.bindTexture(texture.target, null);
  }
}
function mapIndexToCubeMapFace(layer) {
  return layer < 34069 ? layer + 34069 : layer;
}
function _getFrameBufferStatus(status) {
  switch (status) {
    case 36053:
      return "success";
    case 36054:
      return "Mismatched attachments";
    case 36055:
      return "No attachments";
    case 36057:
      return "Height/width mismatch";
    case 36061:
      return "Unsupported or split attachments";
    case 36182:
      return "Samples mismatch";
    default:
      return `${status}`;
  }
}
class WebGLCanvasContext extends CanvasContext {
  constructor(device, props) {
    super(props);
    __publicField2(this, "device");
    __publicField2(this, "presentationSize");
    __publicField2(this, "_framebuffer", null);
    this.device = device;
    this.presentationSize = [-1, -1];
    this._setAutoCreatedCanvasId(`${this.device.id}-canvas`);
    this.update();
  }
  getCurrentFramebuffer() {
    this.update();
    this._framebuffer = this._framebuffer || new WEBGLFramebuffer(this.device, { handle: null });
    return this._framebuffer;
  }
  /** Resizes and updates render targets if necessary */
  update() {
    const size12 = this.getPixelSize();
    const sizeChanged = size12[0] !== this.presentationSize[0] || size12[1] !== this.presentationSize[1];
    if (sizeChanged) {
      this.presentationSize = size12;
      this.resize();
    }
  }
  /**
   * Resize the canvas' drawing buffer.
   *
   * Can match the canvas CSS size, and optionally also consider devicePixelRatio
   * Can be called every frame
   *
   * Regardless of size, the drawing buffer will always be scaled to the viewport, but
   * for best visual results, usually set to either:
   *  canvas CSS width x canvas CSS height
   *  canvas CSS width * devicePixelRatio x canvas CSS height * devicePixelRatio
   * See http://webgl2fundamentals.org/webgl/lessons/webgl-resizing-the-canvas.html
   */
  resize(options2) {
    if (!this.device.gl)
      return;
    if (this.canvas) {
      const devicePixelRatio2 = this.getDevicePixelRatio(options2 == null ? void 0 : options2.useDevicePixels);
      this.setDevicePixelRatio(devicePixelRatio2, options2);
      return;
    }
  }
  commit() {
  }
}
const DEFAULT_SPECTOR_PROPS = {
  spector: log.get("spector") || log.get("spectorjs")
};
const SPECTOR_CDN_URL = "https://cdn.jsdelivr.net/npm/spectorjs@0.9.30/dist/spector.bundle.js";
const LOG_LEVEL$1 = 1;
let spector = null;
let initialized = false;
async function loadSpectorJS(props) {
  if (!globalThis.SPECTOR) {
    try {
      await loadScript(SPECTOR_CDN_URL);
    } catch (error2) {
      log.warn(String(error2));
    }
  }
}
function initializeSpectorJS(props) {
  props = { ...DEFAULT_SPECTOR_PROPS, ...props };
  if (!(props == null ? void 0 : props.spector)) {
    return null;
  }
  if (!spector && globalThis.SPECTOR) {
    log.probe(LOG_LEVEL$1, "SPECTOR found and initialized")();
    spector = new globalThis.SPECTOR.Spector();
    if (globalThis.luma) {
      globalThis.luma.spector = spector;
    }
  }
  if (!spector) {
    return null;
  }
  if (!initialized) {
    initialized = true;
    spector.spyCanvases();
    spector == null ? void 0 : spector.onCaptureStarted.add((capture) => log.info("Spector capture started:", capture)());
    spector == null ? void 0 : spector.onCapture.add((capture) => {
      log.info("Spector capture complete:", capture)();
      spector == null ? void 0 : spector.getResultUI();
      spector == null ? void 0 : spector.resultView.display();
      spector == null ? void 0 : spector.resultView.addCapture(capture);
    });
  }
  if (props == null ? void 0 : props.canvas) {
    if (typeof props.spector === "string" && props.spector !== props.canvas.id) {
      return spector;
    }
    spector == null ? void 0 : spector.startCapture(props == null ? void 0 : props.canvas, 500);
    new Promise((resolve2) => setTimeout(resolve2, 2e3)).then((_2) => {
      log.info("Spector capture stopped after 2 seconds")();
      spector == null ? void 0 : spector.stopCapture();
    });
  }
  return spector;
}
const WEBGL_DEBUG_CDN_URL = "https://unpkg.com/webgl-debug@2.0.1/index.js";
function getWebGLContextData(gl) {
  gl.luma = gl.luma || {};
  return gl.luma;
}
async function loadWebGLDeveloperTools() {
  if (isBrowser$4() && !globalThis.WebGLDebugUtils) {
    globalThis.global = globalThis.global || globalThis;
    globalThis.global.module = {};
    await loadScript(WEBGL_DEBUG_CDN_URL);
  }
}
function makeDebugContext(gl, props = {}) {
  if (!gl) {
    return null;
  }
  return props.debug ? getDebugContext(gl, props) : getRealContext(gl);
}
function getRealContext(gl) {
  const data2 = getWebGLContextData(gl);
  return data2.realContext ? data2.realContext : gl;
}
function getDebugContext(gl, props) {
  if (!globalThis.WebGLDebugUtils) {
    log.warn("webgl-debug not loaded")();
    return gl;
  }
  const data2 = getWebGLContextData(gl);
  if (data2.debugContext) {
    return data2.debugContext;
  }
  globalThis.WebGLDebugUtils.init({ ...GLEnum$3, ...gl });
  const glDebug = globalThis.WebGLDebugUtils.makeDebugContext(gl, onGLError.bind(null, props), onValidateGLFunc.bind(null, props));
  for (const key in GLEnum$3) {
    if (!(key in glDebug) && typeof GLEnum$3[key] === "number") {
      glDebug[key] = GLEnum$3[key];
    }
  }
  class WebGLDebugContext {
  }
  Object.setPrototypeOf(glDebug, Object.getPrototypeOf(gl));
  Object.setPrototypeOf(WebGLDebugContext, glDebug);
  const debugContext = Object.create(WebGLDebugContext);
  data2.realContext = gl;
  data2.debugContext = debugContext;
  debugContext.debug = true;
  return debugContext;
}
function getFunctionString(functionName, functionArgs) {
  functionArgs = Array.from(functionArgs).map((arg) => arg === void 0 ? "undefined" : arg);
  let args = globalThis.WebGLDebugUtils.glFunctionArgsToString(functionName, functionArgs);
  args = `${args.slice(0, 100)}${args.length > 100 ? "..." : ""}`;
  return `gl.${functionName}(${args})`;
}
function onGLError(props, err, functionName, args) {
  args = Array.from(args).map((arg) => arg === void 0 ? "undefined" : arg);
  const errorMessage = globalThis.WebGLDebugUtils.glEnumToString(err);
  const functionArgs = globalThis.WebGLDebugUtils.glFunctionArgsToString(functionName, args);
  const message2 = `${errorMessage} in gl.${functionName}(${functionArgs})`;
  log.error(message2)();
  debugger;
  if (props.throwOnError) {
    throw new Error(message2);
  }
}
function onValidateGLFunc(props, functionName, functionArgs) {
  let functionString = "";
  if (log.level >= 1) {
    functionString = getFunctionString(functionName, functionArgs);
    log.log(1, functionString)();
  }
  if (props.break && props.break.length > 0) {
    functionString = functionString || getFunctionString(functionName, functionArgs);
    const isBreakpoint = props.break.every((breakOn) => functionString.indexOf(breakOn) !== -1);
    if (isBreakpoint) {
      debugger;
    }
  }
  for (const arg of functionArgs) {
    if (arg === void 0) {
      functionString = functionString || getFunctionString(functionName, functionArgs);
      if (props.throwOnError) {
        throw new Error(`Undefined argument: ${functionString}`);
      } else {
        log.error(`Undefined argument: ${functionString}`)();
        debugger;
      }
    }
  }
}
function parseShaderCompilerLog(errLog) {
  const lines = errLog.split(/\r?\n/);
  const messages = [];
  for (const line of lines) {
    if (line.length <= 1) {
      continue;
    }
    const segments = line.split(":");
    if (segments.length === 2) {
      const [messageType2, message2] = segments;
      messages.push({
        message: message2.trim(),
        type: getMessageType(messageType2),
        lineNum: 0,
        linePos: 0
      });
      continue;
    }
    const [messageType, linePosition, lineNumber, ...rest] = segments;
    let lineNum = parseInt(lineNumber, 10);
    if (isNaN(lineNum)) {
      lineNum = 0;
    }
    let linePos = parseInt(linePosition, 10);
    if (isNaN(linePos)) {
      linePos = 0;
    }
    messages.push({
      message: rest.join(":").trim(),
      type: getMessageType(messageType),
      lineNum,
      linePos
      // TODO
    });
  }
  return messages;
}
function getMessageType(messageType) {
  const MESSAGE_TYPES = ["warning", "error", "info"];
  const lowerCaseType = messageType.toLowerCase();
  return MESSAGE_TYPES.includes(lowerCaseType) ? lowerCaseType : "info";
}
class WEBGLShader extends Shader {
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "handle");
    this.device = device;
    switch (this.props.stage) {
      case "vertex":
        this.handle = this.props.handle || this.device.gl.createShader(35633);
        break;
      case "fragment":
        this.handle = this.props.handle || this.device.gl.createShader(35632);
        break;
      default:
        throw new Error(this.props.stage);
    }
    this._compile(this.source);
  }
  destroy() {
    if (this.handle) {
      this.removeStats();
      this.device.gl.deleteShader(this.handle);
      this.destroyed = true;
    }
  }
  async getCompilationInfo() {
    await this._waitForCompilationComplete();
    return this.getCompilationInfoSync();
  }
  getCompilationInfoSync() {
    const log3 = this.device.gl.getShaderInfoLog(this.handle);
    return parseShaderCompilerLog(log3);
  }
  getTranslatedSource() {
    const extensions = this.device.getExtension("WEBGL_debug_shaders");
    const ext = extensions.WEBGL_debug_shaders;
    return ext == null ? void 0 : ext.getTranslatedShaderSource(this.handle);
  }
  // PRIVATE METHODS
  /** Compile a shader and get compilation status */
  async _compile(source) {
    const addGLSLVersion = (source2) => source2.startsWith("#version ") ? source2 : `#version 100
${source2}`;
    source = addGLSLVersion(source);
    const { gl } = this.device;
    gl.shaderSource(this.handle, source);
    gl.compileShader(this.handle);
    if (log.level === 0) {
      this.compilationStatus = "pending";
      return;
    }
    if (!this.device.features.has("compilation-status-async-webgl")) {
      this._getCompilationStatus();
      this.debugShader();
      if (this.compilationStatus === "error") {
        throw new Error(`GLSL compilation errors in ${this.props.stage} shader ${this.props.id}`);
      }
      return;
    }
    log.once(1, "Shader compilation is asynchronous")();
    await this._waitForCompilationComplete();
    log.info(2, `Shader ${this.id} - async compilation complete: ${this.compilationStatus}`)();
    this._getCompilationStatus();
    this.debugShader();
  }
  /** Use KHR_parallel_shader_compile extension if available */
  async _waitForCompilationComplete() {
    const waitMs = async (ms) => await new Promise((resolve2) => setTimeout(resolve2, ms));
    const DELAY_MS = 10;
    if (!this.device.features.has("compilation-status-async-webgl")) {
      await waitMs(DELAY_MS);
      return;
    }
    const { gl } = this.device;
    for (; ; ) {
      const complete = gl.getShaderParameter(this.handle, 37297);
      if (complete) {
        return;
      }
      await waitMs(DELAY_MS);
    }
  }
  /**
   * Get the shader compilation status
   * TODO - Load log even when no error reported, to catch warnings?
   * https://gamedev.stackexchange.com/questions/30429/how-to-detect-glsl-warnings
   */
  _getCompilationStatus() {
    this.compilationStatus = this.device.gl.getShaderParameter(this.handle, 35713) ? "success" : "error";
  }
}
const GL_DEPTH_BUFFER_BIT$1 = 256;
const GL_STENCIL_BUFFER_BIT$1 = 1024;
const GL_COLOR_BUFFER_BIT$1 = 16384;
const GL_COLOR = 6144;
const COLOR_CHANNELS = [1, 2, 4, 8];
class WEBGLRenderPass extends RenderPass {
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    /** Parameters that should be applied before each draw call */
    __publicField2(this, "glParameters");
    this.device = device;
    pushContextState(this.device.gl);
    this.setParameters(this.props.parameters);
    this.clear();
  }
  end() {
    popContextState(this.device.gl);
  }
  pushDebugGroup(groupLabel) {
  }
  popDebugGroup() {
  }
  insertDebugMarker(markerLabel) {
  }
  // beginOcclusionQuery(queryIndex: number): void;
  // endOcclusionQuery(): void;
  // executeBundles(bundles: Iterable<GPURenderBundle>): void;
  /**
   * Maps RenderPass parameters to GL parameters
   */
  setParameters(parameters = {}) {
    const glParameters = { ...this.glParameters };
    if (this.props.framebuffer) {
      glParameters.framebuffer = this.props.framebuffer;
    }
    if (this.props.depthReadOnly) {
      glParameters.depthMask = !this.props.depthReadOnly;
    }
    glParameters.stencilMask = this.props.stencilReadOnly ? 0 : 1;
    glParameters[35977] = this.props.discard;
    if (parameters.viewport) {
      if (parameters.viewport.length >= 6) {
        glParameters.viewport = parameters.viewport.slice(0, 4);
        glParameters.depthRange = [parameters.viewport[4], parameters.viewport[5]];
      } else {
        glParameters.viewport = parameters.viewport;
      }
    }
    if (parameters.scissorRect) {
      glParameters.scissorTest = true;
      glParameters.scissor = parameters.scissorRect;
    }
    if (parameters.blendConstant) {
      glParameters.blendColor = parameters.blendConstant;
    }
    if (parameters.stencilReference) {
      console.warn("RenderPassParameters.stencilReference not yet implemented in WebGL");
      parameters[2967] = parameters.stencilReference;
    }
    if (parameters.colorMask) {
      glParameters.colorMask = COLOR_CHANNELS.map((channel) => Boolean(channel & parameters.colorMask));
    }
    this.glParameters = glParameters;
    setGLParameters(this.device.gl, glParameters);
  }
  beginOcclusionQuery(queryIndex) {
    const webglQuerySet = this.props.occlusionQuerySet;
    webglQuerySet == null ? void 0 : webglQuerySet.beginOcclusionQuery();
  }
  endOcclusionQuery() {
    const webglQuerySet = this.props.occlusionQuerySet;
    webglQuerySet == null ? void 0 : webglQuerySet.endOcclusionQuery();
  }
  // PRIVATE
  /**
   * Optionally clears depth, color and stencil buffers based on parameters
   */
  clear() {
    const glParameters = { ...this.glParameters };
    let clearMask = 0;
    if (this.props.clearColor !== false) {
      clearMask |= GL_COLOR_BUFFER_BIT$1;
      glParameters.clearColor = this.props.clearColor;
    }
    if (this.props.clearDepth !== false) {
      clearMask |= GL_DEPTH_BUFFER_BIT$1;
      glParameters.clearDepth = this.props.clearDepth;
    }
    if (this.props.clearStencil !== false) {
      clearMask |= GL_STENCIL_BUFFER_BIT$1;
      glParameters.clearStencil = this.props.clearStencil;
    }
    if (clearMask !== 0) {
      withGLParameters(this.device.gl, glParameters, () => {
        this.device.gl.clear(clearMask);
      });
    }
  }
  /**
   * WebGL2 - clear a specific color buffer
   */
  clearColorBuffer(drawBuffer = 0, value = [0, 0, 0, 0]) {
    withGLParameters(this.device.gl, { framebuffer: this.props.framebuffer }, () => {
      switch (value.constructor) {
        case Int32Array:
          this.device.gl.clearBufferiv(GL_COLOR, drawBuffer, value);
          break;
        case Uint32Array:
          this.device.gl.clearBufferuiv(GL_COLOR, drawBuffer, value);
          break;
        case Float32Array:
        default:
          this.device.gl.clearBufferfv(GL_COLOR, drawBuffer, value);
          break;
      }
    });
  }
}
const ERR_TYPE_DEDUCTION = "Failed to deduce GL constant from typed array";
function getGLTypeFromTypedArray(arrayOrType) {
  const type = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
  switch (type) {
    case Float32Array:
      return 5126;
    case Uint16Array:
      return 5123;
    case Uint32Array:
      return 5125;
    case Uint8Array:
      return 5121;
    case Uint8ClampedArray:
      return 5121;
    case Int8Array:
      return 5120;
    case Int16Array:
      return 5122;
    case Int32Array:
      return 5124;
    default:
      throw new Error(ERR_TYPE_DEDUCTION);
  }
}
function getTypedArrayFromGLType(glType, options2) {
  const { clamped = true } = options2 || {};
  switch (glType) {
    case 5126:
      return Float32Array;
    case 5123:
    case 33635:
    case 32819:
    case 32820:
      return Uint16Array;
    case 5125:
      return Uint32Array;
    case 5121:
      return clamped ? Uint8ClampedArray : Uint8Array;
    case 5120:
      return Int8Array;
    case 5122:
      return Int16Array;
    case 5124:
      return Int32Array;
    default:
      throw new Error("Failed to deduce typed array type from GL constant");
  }
}
const DEFAULT_ACCESSOR_VALUES = {
  offset: 0,
  stride: 0,
  type: 5126,
  size: 1,
  divisor: 0,
  normalized: false,
  integer: false
};
const PROP_CHECKS = {
  deprecatedProps: {
    instanced: "divisor",
    isInstanced: "divisor"
  }
};
class Accessor {
  constructor(...accessors) {
    __publicField2(this, "offset");
    __publicField2(this, "stride");
    __publicField2(this, "type");
    __publicField2(this, "size");
    __publicField2(this, "divisor");
    __publicField2(this, "normalized");
    __publicField2(this, "integer");
    __publicField2(this, "buffer");
    __publicField2(this, "index");
    accessors.forEach((accessor) => this._assign(accessor));
    Object.freeze(this);
  }
  static getBytesPerElement(accessor) {
    const ArrayType2 = getTypedArrayFromGLType(accessor.type || 5126);
    return ArrayType2.BYTES_PER_ELEMENT;
  }
  static getBytesPerVertex(accessor) {
    assert$a(accessor.size);
    const ArrayType2 = getTypedArrayFromGLType(accessor.type || 5126);
    return ArrayType2.BYTES_PER_ELEMENT * accessor.size;
  }
  // Combines (merges) a list of accessors. On top of default values
  // Usually [programAccessor, bufferAccessor, appAccessor]
  // All props will be set in the returned object.
  // TODO check for conflicts between values in the supplied accessors
  static resolve(...accessors) {
    return new Accessor(...[DEFAULT_ACCESSOR_VALUES, ...accessors]);
  }
  toString() {
    return JSON.stringify(this);
  }
  // ACCESSORS
  // TODO - remove>
  get BYTES_PER_ELEMENT() {
    return Accessor.getBytesPerElement(this);
  }
  get BYTES_PER_VERTEX() {
    return Accessor.getBytesPerVertex(this);
  }
  // PRIVATE
  // eslint-disable-next-line complexity, max-statements
  _assign(props = {}) {
    props = checkProps("Accessor", props, PROP_CHECKS);
    if (props.type !== void 0) {
      this.type = props.type;
      if (props.type === 5124 || props.type === 5125) {
        this.integer = true;
      }
    }
    if (props.size !== void 0) {
      this.size = props.size;
    }
    if (props.offset !== void 0) {
      this.offset = props.offset;
    }
    if (props.stride !== void 0) {
      this.stride = props.stride;
    }
    if (props.normalize !== void 0) {
      this.normalized = props.normalize;
    }
    if (props.normalized !== void 0) {
      this.normalized = props.normalized;
    }
    if (props.integer !== void 0) {
      this.integer = props.integer;
    }
    if (props.divisor !== void 0) {
      this.divisor = props.divisor;
    }
    if (props.buffer !== void 0) {
      this.buffer = props.buffer;
    }
    if (props.index !== void 0) {
      if (typeof props.index === "boolean") {
        this.index = props.index ? 1 : 0;
      } else {
        this.index = props.index;
      }
    }
    if (props.instanced !== void 0) {
      this.divisor = props.instanced ? 1 : 0;
    }
    if (props.isInstanced !== void 0) {
      this.divisor = props.isInstanced ? 1 : 0;
    }
    if (this.offset === void 0)
      delete this.offset;
    if (this.stride === void 0)
      delete this.stride;
    if (this.type === void 0)
      delete this.type;
    if (this.size === void 0)
      delete this.size;
    if (this.divisor === void 0)
      delete this.divisor;
    if (this.normalized === void 0)
      delete this.normalized;
    if (this.integer === void 0)
      delete this.integer;
    if (this.buffer === void 0)
      delete this.buffer;
    if (this.index === void 0)
      delete this.index;
    return this;
  }
}
function isSamplerUniform(type) {
  return SAMPLER_TYPES.includes(type);
}
const SAMPLER_TYPES = [
  35678,
  35680,
  35679,
  35682,
  36289,
  36292,
  36293,
  36298,
  36299,
  36300,
  36303,
  36306,
  36307,
  36308,
  36311
];
const COMPOSITE_GL_TYPES = {
  [5126]: [5126, 1, "float", "f32", "float32"],
  [35664]: [5126, 2, "vec2", "vec2<f32>", "float32x2"],
  [35665]: [5126, 3, "vec3", "vec3<f32>", "float32x3"],
  [35666]: [5126, 4, "vec4", "vec4<f32>", "float32x4"],
  [5124]: [5124, 1, "int", "i32", "sint32"],
  [35667]: [5124, 2, "ivec2", "vec2<i32>", "sint32x2"],
  [35668]: [5124, 3, "ivec3", "vec3<i32>", "sint32x3"],
  [35669]: [5124, 4, "ivec4", "vec4<i32>", "sint32x4"],
  [5125]: [5125, 1, "uint", "u32", "uint32"],
  [36294]: [5125, 2, "uvec2", "vec2<u32>", "uint32x2"],
  [36295]: [5125, 3, "uvec3", "vec3<u32>", "uint32x3"],
  [36296]: [5125, 4, "uvec4", "vec4<u32>", "uint32x4"],
  [35670]: [5126, 1, "bool", "f32", "float32"],
  [35671]: [5126, 2, "bvec2", "vec2<f32>", "float32x2"],
  [35672]: [5126, 3, "bvec3", "vec3<f32>", "float32x3"],
  [35673]: [5126, 4, "bvec4", "vec4<f32>", "float32x4"],
  // TODO - are sizes/components below correct?
  [35674]: [5126, 8, "mat2", "mat2x2<f32>"],
  // 4
  [35685]: [5126, 8, "mat2x3", "mat2x3<f32>"],
  // 6
  [35686]: [5126, 8, "mat2x4", "mat2x4<f32>"],
  // 8
  [35687]: [5126, 12, "mat3x2", "mat3x2<f32>"],
  // 6
  [35675]: [5126, 12, "mat3", "mat3x3<f32>"],
  // 9
  [35688]: [5126, 12, "mat3x4", "mat3x4<f32>"],
  // 12
  [35689]: [5126, 16, "mat4x2", "mat4x2<f32>"],
  // 8
  [35690]: [5126, 16, "mat4x3", "mat4x3<f32>"],
  // 12
  [35676]: [5126, 16, "mat4", "mat4x4<f32>"]
  // 16
};
function decodeGLUniformType(glUniformType) {
  const typeAndSize = COMPOSITE_GL_TYPES[glUniformType];
  if (!typeAndSize) {
    throw new Error("uniform");
  }
  const [glType, components, , format] = typeAndSize;
  return { format, components, glType };
}
function decodeGLAttributeType(glAttributeType) {
  const typeAndSize = COMPOSITE_GL_TYPES[glAttributeType];
  if (!typeAndSize) {
    throw new Error("attribute");
  }
  const [, components, , shaderType, vertexFormat] = typeAndSize;
  const attributeType = shaderType;
  return { attributeType, vertexFormat, components };
}
function getShaderLayout(gl, program) {
  const shaderLayout = {
    attributes: [],
    bindings: []
  };
  shaderLayout.attributes = readAttributeDeclarations(gl, program);
  const uniformBlocks = readUniformBlocks(gl, program);
  for (const uniformBlock of uniformBlocks) {
    const uniforms2 = uniformBlock.uniforms.map((uniform) => ({
      name: uniform.name,
      format: uniform.format,
      byteOffset: uniform.byteOffset,
      byteStride: uniform.byteStride,
      arrayLength: uniform.arrayLength
    }));
    shaderLayout.bindings.push({
      type: "uniform",
      name: uniformBlock.name,
      location: uniformBlock.location,
      visibility: (uniformBlock.vertex ? 1 : 0) & (uniformBlock.fragment ? 2 : 0),
      minBindingSize: uniformBlock.byteLength,
      uniforms: uniforms2
    });
  }
  const uniforms = readUniformBindings(gl, program);
  let textureUnit = 0;
  for (const uniform of uniforms) {
    if (isSamplerUniform(uniform.type)) {
      const { viewDimension, sampleType } = getSamplerInfo(uniform.type);
      shaderLayout.bindings.push({
        type: "texture",
        name: uniform.name,
        location: textureUnit,
        viewDimension,
        sampleType
      });
      uniform.textureUnit = textureUnit;
      textureUnit += 1;
    }
  }
  if (uniforms.length) {
    shaderLayout.uniforms = uniforms;
  }
  const varyings = readVaryings(gl, program);
  if (varyings == null ? void 0 : varyings.length) {
    shaderLayout.varyings = varyings;
  }
  return shaderLayout;
}
function readAttributeDeclarations(gl, program) {
  const attributes = [];
  const count3 = gl.getProgramParameter(program, 35721);
  for (let index2 = 0; index2 < count3; index2++) {
    const activeInfo = gl.getActiveAttrib(program, index2);
    if (!activeInfo) {
      throw new Error("activeInfo");
    }
    const {
      name: name2,
      type: compositeType
      /* , size*/
    } = activeInfo;
    const location2 = gl.getAttribLocation(program, name2);
    if (location2 >= 0) {
      const { attributeType } = decodeGLAttributeType(compositeType);
      const stepMode = /instance/i.test(name2) ? "instance" : "vertex";
      attributes.push({
        name: name2,
        location: location2,
        stepMode,
        type: attributeType
        // size - for arrays, size is the number of elements in the array
      });
    }
  }
  attributes.sort((a2, b2) => a2.location - b2.location);
  return attributes;
}
function readVaryings(gl, program) {
  const varyings = [];
  const count3 = gl.getProgramParameter(program, 35971);
  for (let location2 = 0; location2 < count3; location2++) {
    const activeInfo = gl.getTransformFeedbackVarying(program, location2);
    if (!activeInfo) {
      throw new Error("activeInfo");
    }
    const { name: name2, type: compositeType, size: size12 } = activeInfo;
    const { glType, components } = decodeGLUniformType(compositeType);
    const accessor = new Accessor({ type: glType, size: size12 * components });
    const varying = { location: location2, name: name2, accessor };
    varyings.push(varying);
  }
  varyings.sort((a2, b2) => a2.location - b2.location);
  return varyings;
}
function readUniformBindings(gl, program) {
  const uniforms = [];
  const uniformCount = gl.getProgramParameter(program, 35718);
  for (let i2 = 0; i2 < uniformCount; i2++) {
    const activeInfo = gl.getActiveUniform(program, i2);
    if (!activeInfo) {
      throw new Error("activeInfo");
    }
    const { name: rawName, size: size12, type } = activeInfo;
    const { name: name2, isArray: isArray3 } = parseUniformName(rawName);
    let webglLocation = gl.getUniformLocation(program, name2);
    const uniformInfo = {
      // WebGL locations are uniquely typed but just numbers
      location: webglLocation,
      name: name2,
      size: size12,
      type,
      isArray: isArray3
    };
    uniforms.push(uniformInfo);
    if (uniformInfo.size > 1) {
      for (let j2 = 0; j2 < uniformInfo.size; j2++) {
        const elementName = `${name2}[${j2}]`;
        webglLocation = gl.getUniformLocation(program, elementName);
        const arrayElementUniformInfo = {
          ...uniformInfo,
          name: elementName,
          location: webglLocation
        };
        uniforms.push(arrayElementUniformInfo);
      }
    }
  }
  return uniforms;
}
function readUniformBlocks(gl, program) {
  const getBlockParameter = (blockIndex, pname) => gl.getActiveUniformBlockParameter(program, blockIndex, pname);
  const uniformBlocks = [];
  const blockCount = gl.getProgramParameter(program, 35382);
  for (let blockIndex = 0; blockIndex < blockCount; blockIndex++) {
    const blockInfo = {
      name: gl.getActiveUniformBlockName(program, blockIndex) || "",
      location: getBlockParameter(blockIndex, 35391),
      byteLength: getBlockParameter(blockIndex, 35392),
      vertex: getBlockParameter(blockIndex, 35396),
      fragment: getBlockParameter(blockIndex, 35398),
      uniformCount: getBlockParameter(blockIndex, 35394),
      uniforms: []
    };
    const uniformIndices = getBlockParameter(blockIndex, 35395) || [];
    const uniformType = gl.getActiveUniforms(program, uniformIndices, 35383);
    const uniformArrayLength = gl.getActiveUniforms(program, uniformIndices, 35384);
    const uniformOffset = gl.getActiveUniforms(program, uniformIndices, 35387);
    const uniformStride = gl.getActiveUniforms(program, uniformIndices, 35388);
    for (let i2 = 0; i2 < blockInfo.uniformCount; ++i2) {
      const activeInfo = gl.getActiveUniform(program, uniformIndices[i2]);
      if (!activeInfo) {
        throw new Error("activeInfo");
      }
      blockInfo.uniforms.push({
        name: activeInfo.name,
        format: decodeGLUniformType(uniformType[i2]).format,
        type: uniformType[i2],
        arrayLength: uniformArrayLength[i2],
        byteOffset: uniformOffset[i2],
        byteStride: uniformStride[i2]
        // matrixStride: uniformStride[i],
        // rowMajor: uniformRowMajor[i]
      });
    }
    uniformBlocks.push(blockInfo);
  }
  uniformBlocks.sort((a2, b2) => a2.location - b2.location);
  return uniformBlocks;
}
const SAMPLER_UNIFORMS_GL_TO_GPU = {
  [35678]: ["2d", "float"],
  [35680]: ["cube", "float"],
  [35679]: ["3d", "float"],
  [35682]: ["3d", "depth"],
  [36289]: ["2d-array", "float"],
  [36292]: ["2d-array", "depth"],
  [36293]: ["cube", "float"],
  [36298]: ["2d", "sint"],
  [36299]: ["3d", "sint"],
  [36300]: ["cube", "sint"],
  [36303]: ["2d-array", "uint"],
  [36306]: ["2d", "uint"],
  [36307]: ["3d", "uint"],
  [36308]: ["cube", "uint"],
  [36311]: ["2d-array", "uint"]
};
function getSamplerInfo(type) {
  const sampler = SAMPLER_UNIFORMS_GL_TO_GPU[type];
  if (!sampler) {
    throw new Error("sampler");
  }
  const [viewDimension, sampleType] = sampler;
  return { viewDimension, sampleType };
}
function parseUniformName(name2) {
  if (name2[name2.length - 1] !== "]") {
    return {
      name: name2,
      length: 1,
      isArray: false
    };
  }
  const UNIFORM_NAME_REGEXP = /([^[]*)(\[[0-9]+\])?/;
  const matches2 = UNIFORM_NAME_REGEXP.exec(name2);
  if (!matches2 || matches2.length < 2) {
    throw new Error(`Failed to parse GLSL uniform name ${name2}`);
  }
  return {
    name: matches2[1],
    length: matches2[2] ? 1 : 0,
    isArray: Boolean(matches2[2])
  };
}
function setUniform(gl, location2, type, value) {
  const gl2 = gl;
  let uniformValue = value;
  if (uniformValue === true) {
    uniformValue = 1;
  }
  if (uniformValue === false) {
    uniformValue = 0;
  }
  const arrayValue = typeof uniformValue === "number" ? [uniformValue] : uniformValue;
  switch (type) {
    case 35678:
    case 35680:
    case 35679:
    case 35682:
    case 36289:
    case 36292:
    case 36293:
    case 36298:
    case 36299:
    case 36300:
    case 36303:
    case 36306:
    case 36307:
    case 36308:
    case 36311:
      if (typeof value !== "number") {
        throw new Error("samplers must be set to integers");
      }
      return gl.uniform1i(location2, value);
    case 5126:
      return gl.uniform1fv(location2, arrayValue);
    case 35664:
      return gl.uniform2fv(location2, arrayValue);
    case 35665:
      return gl.uniform3fv(location2, arrayValue);
    case 35666:
      return gl.uniform4fv(location2, arrayValue);
    case 5124:
      return gl.uniform1iv(location2, arrayValue);
    case 35667:
      return gl.uniform2iv(location2, arrayValue);
    case 35668:
      return gl.uniform3iv(location2, arrayValue);
    case 35669:
      return gl.uniform4iv(location2, arrayValue);
    case 35670:
      return gl.uniform1iv(location2, arrayValue);
    case 35671:
      return gl.uniform2iv(location2, arrayValue);
    case 35672:
      return gl.uniform3iv(location2, arrayValue);
    case 35673:
      return gl.uniform4iv(location2, arrayValue);
    case 5125:
      return gl2.uniform1uiv(location2, arrayValue, 1);
    case 36294:
      return gl2.uniform2uiv(location2, arrayValue, 2);
    case 36295:
      return gl2.uniform3uiv(location2, arrayValue, 3);
    case 36296:
      return gl2.uniform4uiv(location2, arrayValue, 4);
    case 35674:
      return gl.uniformMatrix2fv(location2, false, arrayValue);
    case 35675:
      return gl.uniformMatrix3fv(location2, false, arrayValue);
    case 35676:
      return gl.uniformMatrix4fv(location2, false, arrayValue);
    case 35685:
      return gl2.uniformMatrix2x3fv(location2, false, arrayValue);
    case 35686:
      return gl2.uniformMatrix2x4fv(location2, false, arrayValue);
    case 35687:
      return gl2.uniformMatrix3x2fv(location2, false, arrayValue);
    case 35688:
      return gl2.uniformMatrix3x4fv(location2, false, arrayValue);
    case 35689:
      return gl2.uniformMatrix4x2fv(location2, false, arrayValue);
    case 35690:
      return gl2.uniformMatrix4x3fv(location2, false, arrayValue);
  }
  throw new Error("Illegal uniform");
}
function getGLDrawMode(topology) {
  switch (topology) {
    case "point-list":
      return 0;
    case "line-list":
      return 1;
    case "line-strip":
      return 3;
    case "line-loop-webgl":
      return 2;
    case "triangle-list":
      return 4;
    case "triangle-strip":
      return 5;
    case "triangle-fan-webgl":
      return 6;
    default:
      throw new Error(topology);
  }
}
function getGLPrimitive(topology) {
  switch (topology) {
    case "point-list":
      return 0;
    case "line-list":
      return 1;
    case "line-strip":
      return 1;
    case "line-loop-webgl":
      return 1;
    case "triangle-list":
      return 4;
    case "triangle-strip":
      return 4;
    case "triangle-fan-webgl":
      return 4;
    default:
      throw new Error(topology);
  }
}
const LOG_PROGRAM_PERF_PRIORITY = 4;
class WEBGLRenderPipeline extends RenderPipeline {
  // TODO are these used?
  constructor(device, props) {
    super(device, props);
    /** The WebGL device that created this render pipeline */
    __publicField2(this, "device");
    /** Handle to underlying WebGL program */
    __publicField2(this, "handle");
    /** vertex shader */
    __publicField2(this, "vs");
    /** fragment shader */
    __publicField2(this, "fs");
    /** The layout extracted from shader by WebGL introspection APIs */
    __publicField2(this, "introspectedLayout");
    /** Uniforms set on this model */
    __publicField2(this, "uniforms", {});
    /** Bindings set on this model */
    __publicField2(this, "bindings", {});
    /** WebGL varyings */
    __publicField2(this, "varyings", null);
    __publicField2(this, "_uniformCount", 0);
    __publicField2(this, "_uniformSetters", {});
    this.device = device;
    this.handle = this.props.handle || this.device.gl.createProgram();
    this.device.setSpectorMetadata(this.handle, { id: this.props.id });
    this.vs = cast$1(props.vs);
    this.fs = cast$1(props.fs);
    const { varyings, bufferMode = 35981 } = props;
    if (varyings && varyings.length > 0) {
      this.varyings = varyings;
      this.device.gl.transformFeedbackVaryings(this.handle, varyings, bufferMode);
    }
    this._linkShaders();
    log.time(1, `RenderPipeline ${this.id} - shaderLayout introspection`)();
    this.introspectedLayout = getShaderLayout(this.device.gl, this.handle);
    log.timeEnd(1, `RenderPipeline ${this.id} - shaderLayout introspection`)();
    this.shaderLayout = mergeShaderLayout(this.introspectedLayout, props.shaderLayout);
    switch (this.props.topology) {
      case "triangle-fan-webgl":
      case "line-loop-webgl":
        log.warn(`Primitive topology ${this.props.topology} is deprecated and will be removed in v9.1`);
        break;
    }
  }
  destroy() {
    if (this.handle) {
      this.device.gl.deleteProgram(this.handle);
      this.destroyed = true;
    }
  }
  /**
   * Bindings include: textures, samplers and uniform buffers
   * @todo needed for portable model
   */
  setBindings(bindings, options2) {
    for (const [name2, value] of Object.entries(bindings)) {
      const binding = this.shaderLayout.bindings.find((binding2) => binding2.name === name2) || this.shaderLayout.bindings.find((binding2) => binding2.name === `${name2}Uniforms`);
      if (!binding) {
        const validBindings = this.shaderLayout.bindings.map((binding2) => `"${binding2.name}"`).join(", ");
        if (!(options2 == null ? void 0 : options2.disableWarnings)) {
          log.warn(`Unknown binding "${name2}" in render pipeline "${this.id}", expected one of ${validBindings}`)();
        }
        continue;
      }
      if (!value) {
        log.warn(`Unsetting binding "${name2}" in render pipeline "${this.id}"`)();
      }
      switch (binding.type) {
        case "uniform":
          if (!(value instanceof WEBGLBuffer) && !(value.buffer instanceof WEBGLBuffer)) {
            throw new Error("buffer value");
          }
          break;
        case "texture":
          if (!(value instanceof WEBGLTextureView || value instanceof WEBGLTexture || value instanceof WEBGLFramebuffer)) {
            throw new Error("texture value");
          }
          break;
        case "sampler":
          log.warn(`Ignoring sampler ${name2}`)();
          break;
        default:
          throw new Error(binding.type);
      }
      this.bindings[name2] = value;
    }
  }
  /** @todo needed for portable model
   * @note The WebGL API is offers many ways to draw things
   * This function unifies those ways into a single call using common parameters with sane defaults
   */
  draw(options2) {
    var _a3;
    const {
      renderPass,
      parameters = this.props.parameters,
      topology = this.props.topology,
      vertexArray,
      vertexCount,
      // indexCount,
      instanceCount,
      isInstanced = false,
      firstVertex = 0,
      // firstIndex,
      // firstInstance,
      // baseVertex,
      transformFeedback
    } = options2;
    const glDrawMode = getGLDrawMode(topology);
    const isIndexed = Boolean(vertexArray.indexBuffer);
    const glIndexType = (_a3 = vertexArray.indexBuffer) == null ? void 0 : _a3.glIndexType;
    if (this.linkStatus !== "success") {
      log.info(2, `RenderPipeline:${this.id}.draw() aborted - waiting for shader linking`)();
      return false;
    }
    if (!this._areTexturesRenderable() || vertexCount === 0) {
      log.info(2, `RenderPipeline:${this.id}.draw() aborted - textures not yet loaded`)();
      return false;
    }
    if (vertexCount === 0) {
      log.info(2, `RenderPipeline:${this.id}.draw() aborted - no vertices to draw`)();
      return true;
    }
    this.device.gl.useProgram(this.handle);
    vertexArray.bindBeforeRender(renderPass);
    if (transformFeedback) {
      transformFeedback.begin(this.props.topology);
    }
    this._applyBindings();
    this._applyUniforms();
    const webglRenderPass = renderPass;
    withDeviceAndGLParameters(this.device, parameters, webglRenderPass.glParameters, () => {
      if (isIndexed && isInstanced) {
        this.device.gl.drawElementsInstanced(
          glDrawMode,
          vertexCount || 0,
          // indexCount?
          glIndexType,
          firstVertex,
          instanceCount || 0
        );
      } else if (isIndexed) {
        this.device.gl.drawElements(glDrawMode, vertexCount || 0, glIndexType, firstVertex);
      } else if (isInstanced) {
        this.device.gl.drawArraysInstanced(glDrawMode, firstVertex, vertexCount || 0, instanceCount || 0);
      } else {
        this.device.gl.drawArrays(glDrawMode, firstVertex, vertexCount || 0);
      }
      if (transformFeedback) {
        transformFeedback.end();
      }
    });
    vertexArray.unbindAfterRender(renderPass);
    return true;
  }
  // DEPRECATED METHODS
  setUniformsWebGL(uniforms) {
    const { bindings } = splitUniformsAndBindings(uniforms);
    Object.keys(bindings).forEach((name2) => {
      log.warn(`Unsupported value "${JSON.stringify(bindings[name2])}" used in setUniforms() for key ${name2}. Use setBindings() instead?`)();
    });
    Object.assign(this.uniforms, uniforms);
  }
  // PRIVATE METHODS
  // setAttributes(attributes: Record<string, Buffer>): void {}
  // setBindings(bindings: Record<string, Binding>): void {}
  async _linkShaders() {
    const { gl } = this.device;
    gl.attachShader(this.handle, this.vs.handle);
    gl.attachShader(this.handle, this.fs.handle);
    log.time(LOG_PROGRAM_PERF_PRIORITY, `linkProgram for ${this.id}`)();
    gl.linkProgram(this.handle);
    log.timeEnd(LOG_PROGRAM_PERF_PRIORITY, `linkProgram for ${this.id}`)();
    if (log.level === 0)
      ;
    if (!this.device.features.has("compilation-status-async-webgl")) {
      const status2 = this._getLinkStatus();
      this._reportLinkStatus(status2);
      return;
    }
    log.once(1, "RenderPipeline linking is asynchronous")();
    await this._waitForLinkComplete();
    log.info(2, `RenderPipeline ${this.id} - async linking complete: ${this.linkStatus}`)();
    const status = this._getLinkStatus();
    this._reportLinkStatus(status);
  }
  /** Report link status. First, check for shader compilation failures if linking fails */
  _reportLinkStatus(status) {
    var _a3;
    switch (status) {
      case "success":
        return;
      default:
        if (this.vs.compilationStatus === "error") {
          this.vs.debugShader();
          throw new Error(`Error during compilation of shader ${this.vs.id}`);
        }
        if (((_a3 = this.fs) == null ? void 0 : _a3.compilationStatus) === "error") {
          this.fs.debugShader();
          throw new Error(`Error during compilation of shader ${this.fs.id}`);
        }
        throw new Error(`Error during ${status}: ${this.device.gl.getProgramInfoLog(this.handle)}`);
    }
  }
  /**
   * Get the shader compilation status
   * TODO - Load log even when no error reported, to catch warnings?
   * https://gamedev.stackexchange.com/questions/30429/how-to-detect-glsl-warnings
   */
  _getLinkStatus() {
    const { gl } = this.device;
    const linked = gl.getProgramParameter(this.handle, 35714);
    if (!linked) {
      this.linkStatus = "error";
      return "linking";
    }
    gl.validateProgram(this.handle);
    const validated = gl.getProgramParameter(this.handle, 35715);
    if (!validated) {
      this.linkStatus = "error";
      return "validation";
    }
    this.linkStatus = "success";
    return "success";
  }
  /** Use KHR_parallel_shader_compile extension if available */
  async _waitForLinkComplete() {
    const waitMs = async (ms) => await new Promise((resolve2) => setTimeout(resolve2, ms));
    const DELAY_MS = 10;
    if (!this.device.features.has("compilation-status-async-webgl")) {
      await waitMs(DELAY_MS);
      return;
    }
    const { gl } = this.device;
    for (; ; ) {
      const complete = gl.getProgramParameter(this.handle, 37297);
      if (complete) {
        return;
      }
      await waitMs(DELAY_MS);
    }
  }
  /**
   * Checks if all texture-values uniforms are renderable (i.e. loaded)
   * Update a texture if needed (e.g. from video)
   * Note: This is currently done before every draw call
   */
  _areTexturesRenderable() {
    let texturesRenderable = true;
    for (const [, texture] of Object.entries(this.bindings)) {
      if (texture instanceof WEBGLTexture) {
        texture.update();
        texturesRenderable = texturesRenderable && texture.loaded;
      }
    }
    return texturesRenderable;
  }
  /** Apply any bindings (before each draw call) */
  _applyBindings() {
    if (this.linkStatus !== "success") {
      return;
    }
    const { gl } = this.device;
    gl.useProgram(this.handle);
    let textureUnit = 0;
    let uniformBufferIndex = 0;
    for (const binding of this.shaderLayout.bindings) {
      const value = this.bindings[binding.name] || this.bindings[binding.name.replace(/Uniforms$/, "")];
      if (!value) {
        throw new Error(`No value for binding ${binding.name} in ${this.id}`);
      }
      switch (binding.type) {
        case "uniform":
          const { name: name2 } = binding;
          const location2 = gl.getUniformBlockIndex(this.handle, name2);
          if (location2 === 4294967295) {
            throw new Error(`Invalid uniform block name ${name2}`);
          }
          gl.uniformBlockBinding(this.handle, uniformBufferIndex, location2);
          if (value instanceof WEBGLBuffer) {
            gl.bindBufferBase(35345, uniformBufferIndex, value.handle);
          } else {
            gl.bindBufferRange(
              35345,
              uniformBufferIndex,
              // @ts-expect-error
              value.buffer.handle,
              // @ts-expect-error
              value.offset || 0,
              // @ts-expect-error
              value.size || value.buffer.byteLength - value.offset
            );
          }
          uniformBufferIndex += 1;
          break;
        case "texture":
          if (!(value instanceof WEBGLTextureView || value instanceof WEBGLTexture || value instanceof WEBGLFramebuffer)) {
            throw new Error("texture");
          }
          let texture;
          if (value instanceof WEBGLTextureView) {
            texture = value.texture;
          } else if (value instanceof WEBGLTexture) {
            texture = value;
          } else if (value instanceof WEBGLFramebuffer && value.colorAttachments[0] instanceof WEBGLTextureView) {
            log.warn("Passing framebuffer in texture binding may be deprecated. Use fbo.colorAttachments[0] instead")();
            texture = value.colorAttachments[0].texture;
          } else {
            throw new Error("No texture");
          }
          gl.activeTexture(33984 + textureUnit);
          gl.bindTexture(texture.target, texture.handle);
          textureUnit += 1;
          break;
        case "sampler":
          break;
        case "storage":
        case "read-only-storage":
          throw new Error(`binding type '${binding.type}' not supported in WebGL`);
      }
    }
  }
  /**
   * Due to program sharing, uniforms need to be reset before every draw call
   * (though caching will avoid redundant WebGL calls)
   */
  _applyUniforms() {
    for (const uniformLayout of this.shaderLayout.uniforms || []) {
      const { name: name2, location: location2, type, textureUnit } = uniformLayout;
      const value = this.uniforms[name2] ?? textureUnit;
      if (value !== void 0) {
        setUniform(this.device.gl, location2, type, value);
      }
    }
  }
}
function cast(value) {
  return value;
}
class WEBGLCommandBuffer extends CommandBuffer {
  constructor(device) {
    super(device, {});
    __publicField2(this, "device");
    __publicField2(this, "commands", []);
    this.device = device;
  }
  submitCommands(commands = this.commands) {
    for (const command of commands) {
      switch (command.name) {
        case "copy-buffer-to-buffer":
          _copyBufferToBuffer(this.device, command.options);
          break;
        case "copy-buffer-to-texture":
          _copyBufferToTexture(this.device, command.options);
          break;
        case "copy-texture-to-buffer":
          _copyTextureToBuffer(this.device, command.options);
          break;
        case "copy-texture-to-texture":
          _copyTextureToTexture(this.device, command.options);
          break;
      }
    }
  }
}
function _copyBufferToBuffer(device, options2) {
  const source = cast(options2.source);
  const destination2 = cast(options2.destination);
  device.gl.bindBuffer(36662, source.handle);
  device.gl.bindBuffer(36663, destination2.handle);
  device.gl.copyBufferSubData(36662, 36663, options2.sourceOffset ?? 0, options2.destinationOffset ?? 0, options2.size);
  device.gl.bindBuffer(36662, null);
  device.gl.bindBuffer(36663, null);
}
function _copyBufferToTexture(device, options2) {
  throw new Error("Not implemented");
}
function _copyTextureToBuffer(device, options2) {
  const {
    /** Texture to copy to/from. */
    source,
    /**  Mip-map level of the texture to copy to/from. (Default 0) */
    mipLevel = 0,
    /** Defines which aspects of the texture to copy to/from. */
    aspect: aspect2 = "all",
    /** Width to copy */
    width = options2.source.width,
    /** Height to copy */
    height = options2.source.height,
    depthOrArrayLayers = 0,
    /** Defines the origin of the copy - the minimum corner of the texture sub-region to copy to/from. */
    origin = [0, 0],
    /** Destination buffer */
    destination: destination2,
    /** Offset, in bytes, from the beginning of the buffer to the start of the image data (default 0) */
    byteOffset = 0,
    /**
     * The stride, in bytes, between the beginning of each block row and the subsequent block row.
     * Required if there are multiple block rows (i.e. the copy height or depth is more than one block).
     */
    bytesPerRow,
    /**
     * Number of block rows per single image of the texture.
     * rowsPerImage &times; bytesPerRow is the stride, in bytes, between the beginning of each image of data and the subsequent image.
     * Required if there are multiple images (i.e. the copy depth is more than one).
     */
    rowsPerImage
  } = options2;
  if (aspect2 !== "all") {
    throw new Error("not supported");
  }
  if (mipLevel !== 0 || depthOrArrayLayers !== 0 || bytesPerRow || rowsPerImage) {
    throw new Error("not implemented");
  }
  const { framebuffer, destroyFramebuffer } = getFramebuffer$2(source);
  let prevHandle;
  try {
    const webglBuffer = destination2;
    const sourceWidth = width || framebuffer.width;
    const sourceHeight = height || framebuffer.height;
    const sourceParams = getWebGLTextureParameters(framebuffer.texture.props.format);
    const sourceFormat = sourceParams.dataFormat;
    const sourceType = sourceParams.type;
    device.gl.bindBuffer(35051, webglBuffer.handle);
    prevHandle = device.gl.bindFramebuffer(36160, framebuffer.handle);
    device.gl.readPixels(origin[0], origin[1], sourceWidth, sourceHeight, sourceFormat, sourceType, byteOffset);
  } finally {
    device.gl.bindBuffer(35051, null);
    if (prevHandle !== void 0) {
      device.gl.bindFramebuffer(36160, prevHandle);
    }
    if (destroyFramebuffer) {
      framebuffer.destroy();
    }
  }
}
function _copyTextureToTexture(device, options2) {
  const {
    /** Texture to copy to/from. */
    source,
    /**  Mip-map level of the texture to copy to (Default 0) */
    destinationMipLevel = 0,
    /** Defines which aspects of the texture to copy to/from. */
    // aspect = 'all',
    /** Defines the origin of the copy - the minimum corner of the texture sub-region to copy from. */
    origin = [0, 0],
    /** Defines the origin of the copy - the minimum corner of the texture sub-region to copy to. */
    destinationOrigin = [0, 0],
    /** Texture to copy to/from. */
    destination: destination2
    /**  Mip-map level of the texture to copy to/from. (Default 0) */
    // destinationMipLevel = options.mipLevel,
    /** Defines the origin of the copy - the minimum corner of the texture sub-region to copy to/from. */
    // destinationOrigin = [0, 0],
    /** Defines which aspects of the texture to copy to/from. */
    // destinationAspect = options.aspect,
  } = options2;
  let {
    width = options2.destination.width,
    height = options2.destination.height
    // depthOrArrayLayers = 0
  } = options2;
  const { framebuffer, destroyFramebuffer } = getFramebuffer$2(source);
  const [sourceX, sourceY] = origin;
  const [destinationX, destinationY, destinationZ] = destinationOrigin;
  const prevHandle = device.gl.bindFramebuffer(36160, framebuffer.handle);
  let texture = null;
  let textureTarget;
  if (destination2 instanceof WEBGLTexture) {
    texture = destination2;
    width = Number.isFinite(width) ? width : texture.width;
    height = Number.isFinite(height) ? height : texture.height;
    texture.bind(0);
    textureTarget = texture.target;
  } else {
    throw new Error("invalid destination");
  }
  switch (textureTarget) {
    case 3553:
    case 34067:
      device.gl.copyTexSubImage2D(textureTarget, destinationMipLevel, destinationX, destinationY, sourceX, sourceY, width, height);
      break;
    case 35866:
    case 32879:
      device.gl.copyTexSubImage3D(textureTarget, destinationMipLevel, destinationX, destinationY, destinationZ, sourceX, sourceY, width, height);
      break;
  }
  if (texture) {
    texture.unbind();
  }
  device.gl.bindFramebuffer(36160, prevHandle);
  if (destroyFramebuffer) {
    framebuffer.destroy();
  }
}
function getFramebuffer$2(source) {
  if (source instanceof Texture) {
    const { width, height, id } = source;
    const framebuffer = source.device.createFramebuffer({
      id: `framebuffer-for-${id}`,
      width,
      height,
      colorAttachments: [source]
    });
    return { framebuffer, destroyFramebuffer: true };
  }
  return { framebuffer: source, destroyFramebuffer: false };
}
class WEBGLCommandEncoder extends CommandEncoder {
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "commandBuffer");
    this.device = device;
    this.commandBuffer = new WEBGLCommandBuffer(device);
  }
  destroy() {
  }
  finish() {
    this.commandBuffer.submitCommands();
  }
  // beginRenderPass(GPURenderPassDescriptor descriptor): GPURenderPassEncoder;
  // beginComputePass(optional GPUComputePassDescriptor descriptor = {}): GPUComputePassEncoder;
  // finish(options?: {id?: string}): GPUCommandBuffer;
  copyBufferToBuffer(options2) {
    this.commandBuffer.commands.push({ name: "copy-buffer-to-buffer", options: options2 });
  }
  copyBufferToTexture(options2) {
    this.commandBuffer.commands.push({ name: "copy-buffer-to-texture", options: options2 });
  }
  copyTextureToBuffer(options2) {
    this.commandBuffer.commands.push({ name: "copy-texture-to-buffer", options: options2 });
  }
  copyTextureToTexture(options2) {
    this.commandBuffer.commands.push({ name: "copy-texture-to-texture", options: options2 });
  }
  pushDebugGroup(groupLabel) {
  }
  popDebugGroup() {
  }
  insertDebugMarker(markerLabel) {
  }
  resolveQuerySet(querySet, destination2, options2) {
  }
}
class WEBGLVertexArray extends VertexArray {
  // Create a VertexArray
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "handle");
    /** Attribute 0 buffer constant */
    __publicField2(this, "buffer", null);
    __publicField2(this, "bufferValue", null);
    this.device = device;
    this.handle = this.device.gl.createVertexArray();
  }
  get [Symbol.toStringTag]() {
    return "VertexArray";
  }
  /** * Attribute 0 can not be disable on most desktop OpenGL based browsers */
  static isConstantAttributeZeroSupported(device) {
    return getBrowser() === "Chrome";
  }
  destroy() {
    var _a3;
    super.destroy();
    if (this.buffer) {
      (_a3 = this.buffer) == null ? void 0 : _a3.destroy();
    }
    if (this.handle) {
      this.device.gl.deleteVertexArray(this.handle);
      this.handle = void 0;
    }
  }
  /**
  // Set (bind/unbind) an elements buffer, for indexed rendering.
  // Must be a Buffer bound to GL.ELEMENT_ARRAY_BUFFER or null. Constants not supported
   *
   * @param elementBuffer
   */
  setIndexBuffer(indexBuffer) {
    const buffer3 = indexBuffer;
    if (buffer3 && buffer3.glTarget !== 34963) {
      throw new Error("Use .setBuffer()");
    }
    this.device.gl.bindVertexArray(this.handle);
    this.device.gl.bindBuffer(34963, buffer3 ? buffer3.handle : null);
    this.indexBuffer = buffer3;
    this.device.gl.bindVertexArray(null);
  }
  /** Set a location in vertex attributes array to a buffer, enables the location, sets divisor */
  setBuffer(location2, attributeBuffer) {
    const buffer3 = attributeBuffer;
    if (buffer3.glTarget === 34963) {
      throw new Error("Use .setIndexBuffer()");
    }
    const { size: size12, type, stride, offset, normalized, integer, divisor } = this._getAccessor(location2);
    this.device.gl.bindVertexArray(this.handle);
    this.device.gl.bindBuffer(34962, buffer3.handle);
    if (integer) {
      this.device.gl.vertexAttribIPointer(location2, size12, type, stride, offset);
    } else {
      this.device.gl.vertexAttribPointer(location2, size12, type, normalized, stride, offset);
    }
    this.device.gl.bindBuffer(34962, null);
    this.device.gl.enableVertexAttribArray(location2);
    this.device.gl.vertexAttribDivisor(location2, divisor || 0);
    this.attributes[location2] = buffer3;
    this.device.gl.bindVertexArray(null);
  }
  /** Set a location in vertex attributes array to a constant value, disables the location */
  setConstantWebGL(location2, value) {
    this._enable(location2, false);
    this.attributes[location2] = value;
  }
  bindBeforeRender() {
    this.device.gl.bindVertexArray(this.handle);
    this._applyConstantAttributes();
  }
  unbindAfterRender() {
    this.device.gl.bindVertexArray(null);
  }
  // Internal methods
  /**
   * Constant attributes need to be reset before every draw call
   * Any attribute that is disabled in the current vertex array object
   * is read from the context's global constant value for that attribute location.
   * @note Constant attributes are only supported in WebGL, not in WebGPU
   */
  _applyConstantAttributes() {
    for (let location2 = 0; location2 < this.maxVertexAttributes; ++location2) {
      const constant2 = this.attributes[location2];
      if (ArrayBuffer.isView(constant2)) {
        this.device.setConstantAttributeWebGL(location2, constant2);
      }
    }
  }
  /**
   * Set a location in vertex attributes array to a buffer, enables the location, sets divisor
   * @note requires vertex array to be bound
   */
  // protected _setAttributeLayout(location: number): void {
  //   const {size, type, stride, offset, normalized, integer, divisor} = this._getAccessor(location);
  //   // WebGL2 supports *integer* data formats, i.e. GPU will see integer values
  //   if (integer) {
  //     this.device.gl.vertexAttribIPointer(location, size, type, stride, offset);
  //   } else {
  //     // Attaches ARRAY_BUFFER with specified buffer format to location
  //     this.device.gl.vertexAttribPointer(location, size, type, normalized, stride, offset);
  //   }
  //   this.device.gl.vertexAttribDivisor(location, divisor || 0);
  // }
  /** Get an accessor from the  */
  _getAccessor(location2) {
    const attributeInfo = this.attributeInfos[location2];
    if (!attributeInfo) {
      throw new Error(`Unknown attribute location ${location2}`);
    }
    const glType = getGLFromVertexType(attributeInfo.bufferDataType);
    return {
      size: attributeInfo.bufferComponents,
      type: glType,
      stride: attributeInfo.byteStride,
      offset: attributeInfo.byteOffset,
      normalized: attributeInfo.normalized,
      // it is the shader attribute declaration, not the vertex memory format,
      // that determines if the data in the buffer will be treated as integers.
      //
      // Also note that WebGL supports assigning non-normalized integer data to floating point attributes,
      // but as far as we can tell, WebGPU does not.
      integer: attributeInfo.integer,
      divisor: attributeInfo.stepMode === "instance" ? 1 : 0
    };
  }
  /**
   * Enabling an attribute location makes it reference the currently bound buffer
   * Disabling an attribute location makes it reference the global constant value
   * TODO - handle single values for size 1 attributes?
   * TODO - convert classic arrays based on known type?
   */
  _enable(location2, enable4 = true) {
    const canDisableAttributeZero = WEBGLVertexArray.isConstantAttributeZeroSupported(this.device);
    const canDisableAttribute = canDisableAttributeZero || location2 !== 0;
    if (enable4 || canDisableAttribute) {
      location2 = Number(location2);
      this.device.gl.bindVertexArray(this.handle);
      if (enable4) {
        this.device.gl.enableVertexAttribArray(location2);
      } else {
        this.device.gl.disableVertexAttribArray(location2);
      }
      this.device.gl.bindVertexArray(null);
    }
  }
  /**
   * Provide a means to create a buffer that is equivalent to a constant.
   * NOTE: Desktop OpenGL cannot disable attribute 0.
   * https://stackoverflow.com/questions/20305231/webgl-warning-attribute-0-is-disabled-
   * this-has-significant-performance-penalty
   */
  getConstantBuffer(elementCount, value) {
    const constantValue = normalizeConstantArrayValue(value);
    const byteLength = constantValue.byteLength * elementCount;
    const length2 = constantValue.length * elementCount;
    if (this.buffer && byteLength !== this.buffer.byteLength) {
      throw new Error(`Buffer size is immutable, byte length ${byteLength} !== ${this.buffer.byteLength}.`);
    }
    let updateNeeded = !this.buffer;
    this.buffer = this.buffer || this.device.createBuffer({ byteLength });
    updateNeeded = updateNeeded || !compareConstantArrayValues$1(constantValue, this.bufferValue);
    if (updateNeeded) {
      const typedArray = getScratchArray(value.constructor, length2);
      fillArray$1({ target: typedArray, source: constantValue, start: 0, count: length2 });
      this.buffer.write(typedArray);
      this.bufferValue = value;
    }
    return this.buffer;
  }
}
function normalizeConstantArrayValue(arrayValue) {
  if (Array.isArray(arrayValue)) {
    return new Float32Array(arrayValue);
  }
  return arrayValue;
}
function compareConstantArrayValues$1(v12, v22) {
  if (!v12 || !v22 || v12.length !== v22.length || v12.constructor !== v22.constructor) {
    return false;
  }
  for (let i2 = 0; i2 < v12.length; ++i2) {
    if (v12[i2] !== v22[i2]) {
      return false;
    }
  }
  return true;
}
class WEBGLTransformFeedback extends TransformFeedback {
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "gl");
    __publicField2(this, "handle");
    /**
     * NOTE: The Model already has this information while drawing, but
     * TransformFeedback currently needs it internally, to look up
     * varying information outside of a draw() call.
     */
    __publicField2(this, "layout");
    __publicField2(this, "buffers", {});
    __publicField2(this, "unusedBuffers", {});
    /**
     * Allows us to avoid a Chrome bug where a buffer that is already bound to a
     * different target cannot be bound to 'TRANSFORM_FEEDBACK_BUFFER' target.
     * This a major workaround, see: https://github.com/KhronosGroup/WebGL/issues/2346
     */
    __publicField2(this, "bindOnUse", true);
    __publicField2(this, "_bound", false);
    this.device = device;
    this.gl = device.gl;
    this.handle = this.props.handle || this.gl.createTransformFeedback();
    this.layout = this.props.layout;
    if (props.buffers) {
      this.setBuffers(props.buffers);
    }
    Object.seal(this);
  }
  destroy() {
    this.gl.deleteTransformFeedback(this.handle);
    super.destroy();
  }
  begin(topology = "point-list") {
    this.gl.bindTransformFeedback(36386, this.handle);
    if (this.bindOnUse) {
      this._bindBuffers();
    }
    this.gl.beginTransformFeedback(getGLPrimitive(topology));
  }
  end() {
    this.gl.endTransformFeedback();
    if (this.bindOnUse) {
      this._unbindBuffers();
    }
    this.gl.bindTransformFeedback(36386, null);
  }
  // SUBCLASS
  setBuffers(buffers) {
    this.buffers = {};
    this.unusedBuffers = {};
    this.bind(() => {
      for (const bufferName in buffers) {
        this.setBuffer(bufferName, buffers[bufferName]);
      }
    });
  }
  setBuffer(locationOrName, bufferOrRange) {
    const location2 = this._getVaryingIndex(locationOrName);
    const { buffer: buffer3, byteLength, byteOffset } = this._getBufferRange(bufferOrRange);
    if (location2 < 0) {
      this.unusedBuffers[locationOrName] = buffer3;
      log.warn(`${this.id} unusedBuffers varying buffer ${locationOrName}`)();
      return;
    }
    this.buffers[location2] = { buffer: buffer3, byteLength, byteOffset };
    if (!this.bindOnUse) {
      this._bindBuffer(location2, buffer3, byteOffset, byteLength);
    }
  }
  getBuffer(locationOrName) {
    if (isIndex(locationOrName)) {
      return this.buffers[locationOrName] || null;
    }
    const location2 = this._getVaryingIndex(locationOrName);
    return location2 >= 0 ? this.buffers[location2] : null;
  }
  bind(funcOrHandle = this.handle) {
    if (typeof funcOrHandle !== "function") {
      this.gl.bindTransformFeedback(36386, funcOrHandle);
      return this;
    }
    let value;
    if (!this._bound) {
      this.gl.bindTransformFeedback(36386, this.handle);
      this._bound = true;
      value = funcOrHandle();
      this._bound = false;
      this.gl.bindTransformFeedback(36386, null);
    } else {
      value = funcOrHandle();
    }
    return value;
  }
  unbind() {
    this.bind(null);
  }
  // PRIVATE METHODS
  /** Extract offsets for bindBufferRange */
  _getBufferRange(bufferOrRange) {
    if (bufferOrRange instanceof WEBGLBuffer) {
      return { buffer: bufferOrRange, byteOffset: 0, byteLength: bufferOrRange.byteLength };
    }
    const { buffer: buffer3, byteOffset = 0, byteLength = bufferOrRange.buffer.byteLength } = bufferOrRange;
    return { buffer: buffer3, byteOffset, byteLength };
  }
  _getVaryingIndex(locationOrName) {
    if (isIndex(locationOrName)) {
      return Number(locationOrName);
    }
    for (const varying of this.layout.varyings) {
      if (locationOrName === varying.name) {
        return varying.location;
      }
    }
    return -1;
  }
  /**
   * Need to avoid chrome bug where buffer that is already bound to a different target
   * cannot be bound to 'TRANSFORM_FEEDBACK_BUFFER' target.
   */
  _bindBuffers() {
    for (const bufferIndex in this.buffers) {
      const { buffer: buffer3, byteLength, byteOffset } = this._getBufferRange(this.buffers[bufferIndex]);
      this._bindBuffer(Number(bufferIndex), buffer3, byteOffset, byteLength);
    }
  }
  _unbindBuffers() {
    for (const bufferIndex in this.buffers) {
      this.gl.bindBufferBase(35982, Number(bufferIndex), null);
    }
  }
  _bindBuffer(index2, buffer3, byteOffset = 0, byteLength) {
    const handle = buffer3 && buffer3.handle;
    if (!handle || byteLength === void 0) {
      this.gl.bindBufferBase(35982, index2, handle);
    } else {
      this.gl.bindBufferRange(35982, index2, handle, byteOffset, byteLength);
    }
  }
}
function isIndex(value) {
  if (typeof value === "number") {
    return Number.isInteger(value);
  }
  return /^\d+$/.test(value);
}
class WEBGLQuerySet extends QuerySet {
  // Create a query class
  constructor(device, props) {
    super(device, props);
    __publicField2(this, "device");
    __publicField2(this, "handle");
    __publicField2(this, "target", null);
    __publicField2(this, "_queryPending", false);
    __publicField2(this, "_pollingPromise", null);
    this.device = device;
    if (props.count > 1) {
      throw new Error("WebGL QuerySet can only have one value");
    }
    this.handle = this.device.gl.createQuery();
    Object.seal(this);
  }
  get [Symbol.toStringTag]() {
    return "Query";
  }
  destroy() {
    this.device.gl.deleteQuery(this.handle);
  }
  // FOR RENDER PASS AND COMMAND ENCODER
  /**
   * Shortcut for timer query (dependent on extension in both WebGL1 and 2)
   * Measures GPU time delta between this call and a matching `end` call in the
   * GPU instruction stream.
   */
  beginTimestampQuery() {
    return this._begin(35007);
  }
  endTimestampQuery() {
    this._end();
  }
  // Shortcut for occlusion queries
  beginOcclusionQuery(options2) {
    return this._begin((options2 == null ? void 0 : options2.conservative) ? 36202 : 35887);
  }
  endOcclusionQuery() {
    this._end();
  }
  // Shortcut for transformFeedbackQuery
  beginTransformFeedbackQuery() {
    return this._begin(35976);
  }
  endTransformFeedbackQuery() {
    this._end();
  }
  async resolveQuery() {
    const value = await this.pollQuery();
    return [value];
  }
  // PRIVATE METHODS
  /**
   * Due to OpenGL API limitations, after calling `begin()` on one Query
   * instance, `end()` must be called on that same instance before
   * calling `begin()` on another query. While there can be multiple
   * outstanding queries representing disjoint `begin()`/`end()` intervals.
   * It is not possible to interleave or overlap `begin` and `end` calls.
   */
  _begin(target) {
    if (this._queryPending) {
      return;
    }
    this.target = target;
    this.device.gl.beginQuery(this.target, this.handle);
    return;
  }
  // ends the current query
  _end() {
    if (this._queryPending) {
      return;
    }
    if (this.target) {
      this.device.gl.endQuery(this.target);
      this.target = null;
      this._queryPending = true;
    }
    return;
  }
  // Returns true if the query result is available
  isResultAvailable() {
    if (!this._queryPending) {
      return false;
    }
    const resultAvailable = this.device.gl.getQueryParameter(this.handle, 34919);
    if (resultAvailable) {
      this._queryPending = false;
    }
    return resultAvailable;
  }
  // Timing query is disjoint, i.e. results are invalid
  isTimerDisjoint() {
    return this.device.gl.getParameter(36795);
  }
  // Returns query result.
  getResult() {
    return this.device.gl.getQueryParameter(this.handle, 34918);
  }
  // Returns the query result, converted to milliseconds to match JavaScript conventions.
  getTimerMilliseconds() {
    return this.getResult() / 1e6;
  }
  // Polls the query
  pollQuery(limit = Number.POSITIVE_INFINITY) {
    if (this._pollingPromise) {
      return this._pollingPromise;
    }
    let counter2 = 0;
    this._pollingPromise = new Promise((resolve2, reject) => {
      const poll2 = () => {
        if (this.isResultAvailable()) {
          resolve2(this.getResult());
          this._pollingPromise = null;
        } else if (counter2++ > limit) {
          reject("Timed out");
          this._pollingPromise = null;
        } else {
          requestAnimationFrame(poll2);
        }
      };
      requestAnimationFrame(poll2);
    });
    return this._pollingPromise;
  }
}
function glFormatToComponents(format) {
  switch (format) {
    case 6406:
    case 33326:
    case 6403:
      return 1;
    case 33328:
    case 33319:
      return 2;
    case 6407:
    case 34837:
      return 3;
    case 6408:
    case 34836:
      return 4;
    default:
      assert$a(false);
      return 0;
  }
}
function glTypeToBytes(type) {
  switch (type) {
    case 5121:
      return 1;
    case 33635:
    case 32819:
    case 32820:
      return 2;
    case 5126:
      return 4;
    default:
      assert$a(false);
      return 0;
  }
}
function readPixelsToArray(source, options2) {
  var _a3, _b3;
  const {
    sourceX = 0,
    sourceY = 0,
    sourceFormat = 6408,
    sourceAttachment = 36064
    // TODO - support gl.readBuffer
  } = options2 || {};
  let {
    target = null,
    // following parameters are auto deduced if not provided
    sourceWidth,
    sourceHeight,
    sourceType
  } = options2 || {};
  const { framebuffer, deleteFramebuffer } = getFramebuffer$1(source);
  assert$a(framebuffer);
  const { gl, handle } = framebuffer;
  sourceWidth = sourceWidth || framebuffer.width;
  sourceHeight = sourceHeight || framebuffer.height;
  const attachment = sourceAttachment - 36064;
  sourceType = sourceType || ((_b3 = (_a3 = framebuffer.colorAttachments[attachment]) == null ? void 0 : _a3.texture) == null ? void 0 : _b3.type) || 5121;
  target = getPixelArray(target, sourceType, sourceFormat, sourceWidth, sourceHeight);
  sourceType = sourceType || getGLTypeFromTypedArray(target);
  const prevHandle = gl.bindFramebuffer(36160, handle);
  gl.readPixels(sourceX, sourceY, sourceWidth, sourceHeight, sourceFormat, sourceType, target);
  gl.bindFramebuffer(36160, prevHandle || null);
  if (deleteFramebuffer) {
    framebuffer.destroy();
  }
  return target;
}
function readPixelsToBuffer(source, options2) {
  const { target, sourceX = 0, sourceY = 0, sourceFormat = 6408, targetByteOffset = 0 } = options2 || {};
  let { sourceWidth, sourceHeight, sourceType } = options2 || {};
  const { framebuffer, deleteFramebuffer } = getFramebuffer$1(source);
  assert$a(framebuffer);
  sourceWidth = sourceWidth || framebuffer.width;
  sourceHeight = sourceHeight || framebuffer.height;
  const webglFramebuffer = framebuffer;
  sourceType = sourceType || 5121;
  let webglBufferTarget = target;
  if (!webglBufferTarget) {
    const components = glFormatToComponents(sourceFormat);
    const byteCount = glTypeToBytes(sourceType);
    const byteLength = targetByteOffset + sourceWidth * sourceHeight * components * byteCount;
    webglBufferTarget = webglFramebuffer.device.createBuffer({ byteLength });
  }
  const commandEncoder = source.device.createCommandEncoder();
  commandEncoder.copyTextureToBuffer({
    source,
    width: sourceWidth,
    height: sourceHeight,
    origin: [sourceX, sourceY],
    destination: webglBufferTarget,
    byteOffset: targetByteOffset
  });
  commandEncoder.destroy();
  if (deleteFramebuffer) {
    framebuffer.destroy();
  }
  return webglBufferTarget;
}
function getFramebuffer$1(source) {
  if (!(source instanceof Framebuffer)) {
    return { framebuffer: toFramebuffer(source), deleteFramebuffer: true };
  }
  return { framebuffer: source, deleteFramebuffer: false };
}
function toFramebuffer(texture, props) {
  const { device, width, height, id } = texture;
  const framebuffer = device.createFramebuffer({
    ...props,
    id: `framebuffer-for-${id}`,
    width,
    height,
    colorAttachments: [texture]
  });
  return framebuffer;
}
function getPixelArray(pixelArray, type, format, width, height) {
  if (pixelArray) {
    return pixelArray;
  }
  type = type || 5121;
  const ArrayType2 = getTypedArrayFromGLType(type, { clamped: false });
  const components = glFormatToComponents(format);
  return new ArrayType2(width * height * components);
}
const GL_DEPTH_BUFFER_BIT = 256;
const GL_STENCIL_BUFFER_BIT = 1024;
const GL_COLOR_BUFFER_BIT = 16384;
const ERR_ARGUMENTS = "clear: bad arguments";
function clear$1(device, options2) {
  const { framebuffer = null, color = null, depth: depth2 = null, stencil = null } = options2 || {};
  const parameters = {};
  if (framebuffer) {
    parameters.framebuffer = framebuffer;
  }
  let clearFlags = 0;
  if (color) {
    clearFlags |= GL_COLOR_BUFFER_BIT;
    if (color !== true) {
      parameters.clearColor = color;
    }
  }
  if (depth2) {
    clearFlags |= GL_DEPTH_BUFFER_BIT;
    if (depth2 !== true) {
      parameters.clearDepth = depth2;
    }
  }
  if (stencil) {
    clearFlags |= GL_STENCIL_BUFFER_BIT;
    if (depth2 !== true) {
      parameters.clearStencil = depth2;
    }
  }
  assert$a(clearFlags !== 0, ERR_ARGUMENTS);
  const gl = device.gl;
  withGLParameters(gl, parameters, () => {
    gl.clear(clearFlags);
  });
}
const LOG_LEVEL = 1;
const _WebGLDevice = class extends Device {
  //
  // Public API
  //
  constructor(props) {
    var _a3, _b3;
    super({ ...props, id: props.id || uid("webgl-device") });
    /** type of this device */
    __publicField2(this, "type", "webgl");
    /** The underlying WebGL context */
    __publicField2(this, "handle");
    __publicField2(this, "features");
    __publicField2(this, "limits");
    __publicField2(this, "info");
    __publicField2(this, "canvasContext");
    __publicField2(this, "lost");
    __publicField2(this, "_resolveContextLost");
    __publicField2(this, "renderPass", null);
    //
    // WebGL-only API (not part of `Device` API)
    //
    /** WebGL2 context. */
    __publicField2(this, "gl");
    __publicField2(this, "debug", false);
    /** State used by luma.gl classes: TODO - move to canvasContext*/
    __publicField2(this, "_canvasSizeInfo", { clientWidth: 0, clientHeight: 0, devicePixelRatio: 1 });
    /** State used by luma.gl classes - TODO - not used? */
    __publicField2(this, "_extensions", {});
    __publicField2(this, "_polyfilled", false);
    /** Instance of Spector.js (if initialized) */
    __publicField2(this, "spectorJS");
    /** Store constants */
    __publicField2(this, "_constants");
    const device = (_a3 = props.gl) == null ? void 0 : _a3.device;
    if (device) {
      throw new Error(`WebGL context already attached to device ${device.id}`);
    }
    const canvas2 = ((_b3 = props.gl) == null ? void 0 : _b3.canvas) || props.canvas;
    this.canvasContext = new WebGLCanvasContext(this, { ...props, canvas: canvas2 });
    this.lost = new Promise((resolve2) => {
      this._resolveContextLost = resolve2;
    });
    let gl = props.gl || null;
    gl || (gl = createBrowserContext(this.canvasContext.canvas, {
      ...props,
      onContextLost: (event) => {
        var _a4;
        return (_a4 = this._resolveContextLost) == null ? void 0 : _a4.call(this, {
          reason: "destroyed",
          message: "Entered sleep mode, or too many apps or browser tabs are using the GPU."
        });
      }
    }));
    if (!gl) {
      throw new Error("WebGL context creation failed");
    }
    this.handle = gl;
    this.gl = gl;
    this.gl.device = this;
    this.gl._version = 2;
    if (props.spector) {
      this.spectorJS = initializeSpectorJS({ ...this.props, canvas: this.handle.canvas });
    }
    this.info = getDeviceInfo(this.gl, this._extensions);
    this.limits = new WebGLDeviceLimits(this.gl);
    this.features = new WebGLDeviceFeatures(this.gl, this._extensions, this.props.disabledFeatures);
    if (this.props.initalizeFeatures) {
      this.features.initializeFeatures();
    }
    this.canvasContext.resize();
    const { enable: enable4 = true, copyState = false } = props;
    trackContextState(this.gl, {
      enable: enable4,
      copyState,
      log: (...args) => log.log(1, ...args)()
    });
    if (props.debug) {
      this.gl = makeDebugContext(this.gl, { ...props, throwOnError: true });
      this.debug = true;
      log.level = Math.max(log.level, 1);
      log.warn("WebGL debug mode activated. Performance reduced.")();
    }
  }
  //
  // Static methods, expected to be present by `luma.createDevice()`
  //
  /** Check if WebGL 2 is available */
  static isSupported() {
    return typeof WebGL2RenderingContext !== "undefined";
  }
  /**
   * Get a device instance from a GL context
   * Creates and instruments the device if not already created
   * @param gl
   * @returns
   */
  static attach(gl) {
    if (gl instanceof _WebGLDevice) {
      return gl;
    }
    if ((gl == null ? void 0 : gl.device) instanceof Device) {
      return gl.device;
    }
    if (!isWebGL(gl)) {
      throw new Error("Invalid WebGL2RenderingContext");
    }
    return new _WebGLDevice({ gl });
  }
  static async create(props = {}) {
    var _a3;
    log.groupCollapsed(LOG_LEVEL, "WebGLDevice created")();
    const promises = [];
    if (props.debug) {
      promises.push(loadWebGLDeveloperTools());
    }
    if (props.spector) {
      promises.push(loadSpectorJS());
    }
    if (typeof props.canvas === "string") {
      promises.push(CanvasContext.pageLoaded);
    }
    const results = await Promise.allSettled(promises);
    for (const result of results) {
      if (result.status === "rejected") {
        log.error(`Failed to initialize debug libraries ${result.reason}`)();
      }
    }
    log.probe(LOG_LEVEL + 1, "DOM is loaded")();
    if ((_a3 = props.gl) == null ? void 0 : _a3.device) {
      log.warn("reattaching existing device")();
      return _WebGLDevice.attach(props.gl);
    }
    const device = new _WebGLDevice(props);
    const message2 = `Created ${device.type}${device.debug ? " debug" : ""} context: ${device.info.vendor}, ${device.info.renderer} for canvas: ${device.canvasContext.id}`;
    log.probe(LOG_LEVEL, message2)();
    log.table(LOG_LEVEL, device.info)();
    log.groupEnd(LOG_LEVEL)();
    return device;
  }
  /**
   * Destroys the context
   * @note Has no effect for WebGL browser contexts, there is no browser API for destroying contexts
   */
  destroy() {
  }
  get isLost() {
    return this.gl.isContextLost();
  }
  getSize() {
    return [this.gl.drawingBufferWidth, this.gl.drawingBufferHeight];
  }
  isTextureFormatSupported(format) {
    return isTextureFormatSupported(this.gl, format, this._extensions);
  }
  isTextureFormatFilterable(format) {
    return isTextureFormatFilterable(this.gl, format, this._extensions);
  }
  isTextureFormatRenderable(format) {
    return isTextureFormatRenderable(this.gl, format, this._extensions);
  }
  // IMPLEMENTATION OF ABSTRACT DEVICE
  createCanvasContext(props) {
    throw new Error("WebGL only supports a single canvas");
  }
  createBuffer(props) {
    const newProps = this._getBufferProps(props);
    return new WEBGLBuffer(this, newProps);
  }
  _createTexture(props) {
    return new WEBGLTexture(this, props);
  }
  createExternalTexture(props) {
    throw new Error("createExternalTexture() not implemented");
  }
  createSampler(props) {
    return new WEBGLSampler(this, props);
  }
  createShader(props) {
    return new WEBGLShader(this, props);
  }
  createFramebuffer(props) {
    return new WEBGLFramebuffer(this, props);
  }
  createVertexArray(props) {
    return new WEBGLVertexArray(this, props);
  }
  createTransformFeedback(props) {
    return new WEBGLTransformFeedback(this, props);
  }
  createQuerySet(props) {
    return new WEBGLQuerySet(this, props);
  }
  createRenderPipeline(props) {
    return new WEBGLRenderPipeline(this, props);
  }
  beginRenderPass(props) {
    return new WEBGLRenderPass(this, props);
  }
  createComputePipeline(props) {
    throw new Error("ComputePipeline not supported in WebGL");
  }
  beginComputePass(props) {
    throw new Error("ComputePass not supported in WebGL");
  }
  createCommandEncoder(props) {
    return new WEBGLCommandEncoder(this, props);
  }
  /**
   * Offscreen Canvas Support: Commit the frame
   * https://developer.mozilla.org/en-US/docs/Web/API/WebGL2RenderingContext/commit
   * Chrome's offscreen canvas does not require gl.commit
   */
  submit() {
    var _a3;
    (_a3 = this.renderPass) == null ? void 0 : _a3.end();
    this.renderPass = null;
  }
  //
  // TEMPORARY HACKS - will be removed in v9.1
  //
  /** @deprecated - should use command encoder */
  readPixelsToArrayWebGL(source, options2) {
    return readPixelsToArray(source, options2);
  }
  /** @deprecated - should use command encoder */
  readPixelsToBufferWebGL(source, options2) {
    return readPixelsToBuffer(source, options2);
  }
  setParametersWebGL(parameters) {
    setGLParameters(this.gl, parameters);
  }
  getParametersWebGL(parameters) {
    return getGLParameters(this.gl, parameters);
  }
  withParametersWebGL(parameters, func2) {
    return withGLParameters(this.gl, parameters, func2);
  }
  clearWebGL(options2) {
    clear$1(this, options2);
  }
  resetWebGL() {
    log.warn("WebGLDevice.resetWebGL is deprecated, use only for debugging")();
    resetGLParameters(this.gl);
  }
  /**
   * Triggers device (or WebGL context) loss.
   * @note primarily intended for testing how application reacts to device loss
   */
  loseDevice() {
    var _a3;
    let deviceLossTriggered = false;
    const extensions = this.getExtension("WEBGL_lose_context");
    const ext = extensions.WEBGL_lose_context;
    if (ext) {
      deviceLossTriggered = true;
      ext.loseContext();
    }
    (_a3 = this._resolveContextLost) == null ? void 0 : _a3.call(this, {
      reason: "destroyed",
      message: "Application triggered context loss"
    });
    return deviceLossTriggered;
  }
  /** Save current WebGL context state onto an internal stack */
  pushState() {
    pushContextState(this.gl);
  }
  /** Restores previously saved context state */
  popState() {
    popContextState(this.gl);
  }
  /**
   * Storing data on a special field on WebGLObjects makes that data visible in SPECTOR chrome debug extension
   * luma.gl ids and props can be inspected
   */
  setSpectorMetadata(handle, props) {
    handle.__SPECTOR_Metadata = props;
  }
  /**
   * Returns the GL.<KEY> constant that corresponds to a numeric value of a GL constant
   * Be aware that there are some duplicates especially for constants that are 0,
   * so this isn't guaranteed to return the right key in all cases.
   */
  getGLKey(value, gl) {
    gl = gl || this.gl2 || this.gl;
    const number2 = Number(value);
    for (const key in gl) {
      if (gl[key] === number2) {
        return `GL.${key}`;
      }
    }
    return String(value);
  }
  /**
   * Set a constant value for a location. Disabled attributes at that location will read from this value
   * @note WebGL constants are stored globally on the WebGL context, not the VertexArray
   * so they need to be updated before every render
   * @todo - remember/cache values to avoid setting them unnecessarily?
   */
  setConstantAttributeWebGL(location2, constant2) {
    const maxVertexAttributes = this.limits.maxVertexAttributes;
    this._constants = this._constants || new Array(maxVertexAttributes).fill(null);
    const currentConstant = this._constants[location2];
    if (currentConstant && compareConstantArrayValues(currentConstant, constant2)) {
      log.info(1, `setConstantAttributeWebGL(${location2}) could have been skipped, value unchanged`)();
    }
    this._constants[location2] = constant2;
    switch (constant2.constructor) {
      case Float32Array:
        setConstantFloatArray(this, location2, constant2);
        break;
      case Int32Array:
        setConstantIntArray(this, location2, constant2);
        break;
      case Uint32Array:
        setConstantUintArray(this, location2, constant2);
        break;
      default:
        assert$a(false);
    }
  }
  /** Ensure extensions are only requested once */
  getExtension(name2) {
    getWebGLExtension(this.gl, name2, this._extensions);
    return this._extensions;
  }
};
let WebGLDevice = _WebGLDevice;
//
// Public `Device` API
//
/** type of this device */
__publicField2(WebGLDevice, "type", "webgl");
function isWebGL(gl) {
  if (typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext) {
    return true;
  }
  return Boolean(gl && Number.isFinite(gl._version));
}
function setConstantFloatArray(device, location2, array2) {
  switch (array2.length) {
    case 1:
      device.gl.vertexAttrib1fv(location2, array2);
      break;
    case 2:
      device.gl.vertexAttrib2fv(location2, array2);
      break;
    case 3:
      device.gl.vertexAttrib3fv(location2, array2);
      break;
    case 4:
      device.gl.vertexAttrib4fv(location2, array2);
      break;
    default:
      assert$a(false);
  }
}
function setConstantIntArray(device, location2, array2) {
  device.gl.vertexAttribI4iv(location2, array2);
}
function setConstantUintArray(device, location2, array2) {
  device.gl.vertexAttribI4uiv(location2, array2);
}
function compareConstantArrayValues(v12, v22) {
  if (!v12 || !v22 || v12.length !== v22.length || v12.constructor !== v22.constructor) {
    return false;
  }
  for (let i2 = 0; i2 < v12.length; ++i2) {
    if (v12[i2] !== v22[i2]) {
      return false;
    }
  }
  return true;
}
var hammerExports = {};
var hammer$1 = {
  get exports() {
    return hammerExports;
  },
  set exports(v5) {
    hammerExports = v5;
  }
};
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(module2) {
  (function(window2, document2, exportName, undefined$12) {
    var VENDOR_PREFIXES = ["", "webkit", "Moz", "MS", "ms", "o"];
    var TEST_ELEMENT = document2.createElement("div");
    var TYPE_FUNCTION = "function";
    var round2 = Math.round;
    var abs3 = Math.abs;
    var now2 = Date.now;
    function setTimeoutContext(fn2, timeout, context2) {
      return setTimeout(bindFn(fn2, context2), timeout);
    }
    function invokeArrayArg(arg, fn2, context2) {
      if (Array.isArray(arg)) {
        each(arg, context2[fn2], context2);
        return true;
      }
      return false;
    }
    function each(obj, iterator7, context2) {
      var i2;
      if (!obj) {
        return;
      }
      if (obj.forEach) {
        obj.forEach(iterator7, context2);
      } else if (obj.length !== undefined$12) {
        i2 = 0;
        while (i2 < obj.length) {
          iterator7.call(context2, obj[i2], i2, obj);
          i2++;
        }
      } else {
        for (i2 in obj) {
          obj.hasOwnProperty(i2) && iterator7.call(context2, obj[i2], i2, obj);
        }
      }
    }
    function deprecate(method, name2, message2) {
      var deprecationMessage = "DEPRECATED METHOD: " + name2 + "\n" + message2 + " AT \n";
      return function() {
        var e3 = new Error("get-stack-trace");
        var stack2 = e3 && e3.stack ? e3.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace";
        var log3 = window2.console && (window2.console.warn || window2.console.log);
        if (log3) {
          log3.call(window2.console, deprecationMessage, stack2);
        }
        return method.apply(this, arguments);
      };
    }
    var assign3;
    if (typeof Object.assign !== "function") {
      assign3 = function assign4(target) {
        if (target === undefined$12 || target === null) {
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var output2 = Object(target);
        for (var index2 = 1; index2 < arguments.length; index2++) {
          var source = arguments[index2];
          if (source !== undefined$12 && source !== null) {
            for (var nextKey in source) {
              if (source.hasOwnProperty(nextKey)) {
                output2[nextKey] = source[nextKey];
              }
            }
          }
        }
        return output2;
      };
    } else {
      assign3 = Object.assign;
    }
    var extend4 = deprecate(function extend5(dest, src2, merge5) {
      var keys4 = Object.keys(src2);
      var i2 = 0;
      while (i2 < keys4.length) {
        if (!merge5 || merge5 && dest[keys4[i2]] === undefined$12) {
          dest[keys4[i2]] = src2[keys4[i2]];
        }
        i2++;
      }
      return dest;
    }, "extend", "Use `assign`.");
    var merge4 = deprecate(function merge5(dest, src2) {
      return extend4(dest, src2, true);
    }, "merge", "Use `assign`.");
    function inherit(child, base, properties) {
      var baseP = base.prototype, childP;
      childP = child.prototype = Object.create(baseP);
      childP.constructor = child;
      childP._super = baseP;
      if (properties) {
        assign3(childP, properties);
      }
    }
    function bindFn(fn2, context2) {
      return function boundFn() {
        return fn2.apply(context2, arguments);
      };
    }
    function boolOrFn(val, args) {
      if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined$12 : undefined$12, args);
      }
      return val;
    }
    function ifUndefined(val1, val2) {
      return val1 === undefined$12 ? val2 : val1;
    }
    function addEventListeners(target, types2, handler) {
      each(splitStr(types2), function(type) {
        target.addEventListener(type, handler, false);
      });
    }
    function removeEventListeners(target, types2, handler) {
      each(splitStr(types2), function(type) {
        target.removeEventListener(type, handler, false);
      });
    }
    function hasParent(node, parent) {
      while (node) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    }
    function inStr(str, find3) {
      return str.indexOf(find3) > -1;
    }
    function splitStr(str) {
      return str.trim().split(/\s+/g);
    }
    function inArray(src2, find3, findByKey) {
      if (src2.indexOf && !findByKey) {
        return src2.indexOf(find3);
      } else {
        var i2 = 0;
        while (i2 < src2.length) {
          if (findByKey && src2[i2][findByKey] == find3 || !findByKey && src2[i2] === find3) {
            return i2;
          }
          i2++;
        }
        return -1;
      }
    }
    function toArray3(obj) {
      return Array.prototype.slice.call(obj, 0);
    }
    function uniqueArray2(src2, key, sort3) {
      var results = [];
      var values4 = [];
      var i2 = 0;
      while (i2 < src2.length) {
        var val = key ? src2[i2][key] : src2[i2];
        if (inArray(values4, val) < 0) {
          results.push(src2[i2]);
        }
        values4[i2] = val;
        i2++;
      }
      if (sort3) {
        if (!key) {
          results = results.sort();
        } else {
          results = results.sort(function sortUniqueArray(a2, b2) {
            return a2[key] > b2[key];
          });
        }
      }
      return results;
    }
    function prefixed(obj, property2) {
      var prefix, prop;
      var camelProp = property2[0].toUpperCase() + property2.slice(1);
      var i2 = 0;
      while (i2 < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i2];
        prop = prefix ? prefix + camelProp : property2;
        if (prop in obj) {
          return prop;
        }
        i2++;
      }
      return undefined$12;
    }
    var _uniqueId = 1;
    function uniqueId() {
      return _uniqueId++;
    }
    function getWindowForElement(element) {
      var doc = element.ownerDocument || element;
      return doc.defaultView || doc.parentWindow || window2;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = "ontouchstart" in window2;
    var SUPPORT_POINTER_EVENTS = prefixed(window2, "PointerEvent") !== undefined$12;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = "touch";
    var INPUT_TYPE_PEN = "pen";
    var INPUT_TYPE_MOUSE = "mouse";
    var INPUT_TYPE_KINECT = "kinect";
    var COMPUTE_INTERVAL = 25;
    var INPUT_START2 = 1;
    var INPUT_MOVE2 = 2;
    var INPUT_END2 = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = ["x", "y"];
    var PROPS_CLIENT_XY = ["clientX", "clientY"];
    function Input2(manager, callback) {
      var self2 = this;
      this.manager = manager;
      this.callback = callback;
      this.element = manager.element;
      this.target = manager.options.inputTarget;
      this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
          self2.handler(ev);
        }
      };
      this.init();
    }
    Input2.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
      }
    };
    function createInputInstance(manager) {
      var Type3;
      var inputClass = manager.options.inputClass;
      if (inputClass) {
        Type3 = inputClass;
      } else if (SUPPORT_POINTER_EVENTS) {
        Type3 = PointerEventInput;
      } else if (SUPPORT_ONLY_TOUCH) {
        Type3 = TouchInput;
      } else if (!SUPPORT_TOUCH) {
        Type3 = MouseInput;
      } else {
        Type3 = TouchMouseInput;
      }
      return new Type3(manager, inputHandler);
    }
    function inputHandler(manager, eventType, input) {
      var pointersLen = input.pointers.length;
      var changedPointersLen = input.changedPointers.length;
      var isFirst = eventType & INPUT_START2 && pointersLen - changedPointersLen === 0;
      var isFinal = eventType & (INPUT_END2 | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
      input.isFirst = !!isFirst;
      input.isFinal = !!isFinal;
      if (isFirst) {
        manager.session = {};
      }
      input.eventType = eventType;
      computeInputData(manager, input);
      manager.emit("hammer.input", input);
      manager.recognize(input);
      manager.session.prevInput = input;
    }
    function computeInputData(manager, input) {
      var session = manager.session;
      var pointers = input.pointers;
      var pointersLength = pointers.length;
      if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
      }
      if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
      } else if (pointersLength === 1) {
        session.firstMultiple = false;
      }
      var firstInput = session.firstInput;
      var firstMultiple = session.firstMultiple;
      var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
      var center2 = input.center = getCenter(pointers);
      input.timeStamp = now2();
      input.deltaTime = input.timeStamp - firstInput.timeStamp;
      input.angle = getAngle(offsetCenter, center2);
      input.distance = getDistance5(offsetCenter, center2);
      computeDeltaXY(session, input);
      input.offsetDirection = getDirection(input.deltaX, input.deltaY);
      var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
      input.overallVelocityX = overallVelocity.x;
      input.overallVelocityY = overallVelocity.y;
      input.overallVelocity = abs3(overallVelocity.x) > abs3(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
      input.scale = firstMultiple ? getScale3(firstMultiple.pointers, pointers) : 1;
      input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
      input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
      computeIntervalInputData(session, input);
      var target = manager.element;
      if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
      }
      input.target = target;
    }
    function computeDeltaXY(session, input) {
      var center2 = input.center;
      var offset = session.offsetDelta || {};
      var prevDelta = session.prevDelta || {};
      var prevInput = session.prevInput || {};
      if (input.eventType === INPUT_START2 || prevInput.eventType === INPUT_END2) {
        prevDelta = session.prevDelta = {
          x: prevInput.deltaX || 0,
          y: prevInput.deltaY || 0
        };
        offset = session.offsetDelta = {
          x: center2.x,
          y: center2.y
        };
      }
      input.deltaX = prevDelta.x + (center2.x - offset.x);
      input.deltaY = prevDelta.y + (center2.y - offset.y);
    }
    function computeIntervalInputData(session, input) {
      var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
      if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined$12)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;
        var v5 = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v5.x;
        velocityY = v5.y;
        velocity = abs3(v5.x) > abs3(v5.y) ? v5.x : v5.y;
        direction = getDirection(deltaX, deltaY);
        session.lastInterval = input;
      } else {
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
      }
      input.velocity = velocity;
      input.velocityX = velocityX;
      input.velocityY = velocityY;
      input.direction = direction;
    }
    function simpleCloneInputData(input) {
      var pointers = [];
      var i2 = 0;
      while (i2 < input.pointers.length) {
        pointers[i2] = {
          clientX: round2(input.pointers[i2].clientX),
          clientY: round2(input.pointers[i2].clientY)
        };
        i2++;
      }
      return {
        timeStamp: now2(),
        pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
      };
    }
    function getCenter(pointers) {
      var pointersLength = pointers.length;
      if (pointersLength === 1) {
        return {
          x: round2(pointers[0].clientX),
          y: round2(pointers[0].clientY)
        };
      }
      var x2 = 0, y2 = 0, i2 = 0;
      while (i2 < pointersLength) {
        x2 += pointers[i2].clientX;
        y2 += pointers[i2].clientY;
        i2++;
      }
      return {
        x: round2(x2 / pointersLength),
        y: round2(y2 / pointersLength)
      };
    }
    function getVelocity(deltaTime, x2, y2) {
      return {
        x: x2 / deltaTime || 0,
        y: y2 / deltaTime || 0
      };
    }
    function getDirection(x2, y2) {
      if (x2 === y2) {
        return DIRECTION_NONE;
      }
      if (abs3(x2) >= abs3(y2)) {
        return x2 < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
      }
      return y2 < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    function getDistance5(p1, p2, props) {
      if (!props) {
        props = PROPS_XY;
      }
      var x2 = p2[props[0]] - p1[props[0]], y2 = p2[props[1]] - p1[props[1]];
      return Math.sqrt(x2 * x2 + y2 * y2);
    }
    function getAngle(p1, p2, props) {
      if (!props) {
        props = PROPS_XY;
      }
      var x2 = p2[props[0]] - p1[props[0]], y2 = p2[props[1]] - p1[props[1]];
      return Math.atan2(y2, x2) * 180 / Math.PI;
    }
    function getRotation(start2, end) {
      return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start2[1], start2[0], PROPS_CLIENT_XY);
    }
    function getScale3(start2, end) {
      return getDistance5(end[0], end[1], PROPS_CLIENT_XY) / getDistance5(start2[0], start2[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP2 = {
      mousedown: INPUT_START2,
      mousemove: INPUT_MOVE2,
      mouseup: INPUT_END2
    };
    var MOUSE_ELEMENT_EVENTS = "mousedown";
    var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
    function MouseInput() {
      this.evEl = MOUSE_ELEMENT_EVENTS;
      this.evWin = MOUSE_WINDOW_EVENTS;
      this.pressed = false;
      Input2.apply(this, arguments);
    }
    inherit(MouseInput, Input2, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP2[ev.type];
        if (eventType & INPUT_START2 && ev.button === 0) {
          this.pressed = true;
        }
        if (eventType & INPUT_MOVE2 && ev.which !== 1) {
          eventType = INPUT_END2;
        }
        if (!this.pressed) {
          return;
        }
        if (eventType & INPUT_END2) {
          this.pressed = false;
        }
        this.callback(this.manager, eventType, {
          pointers: [ev],
          changedPointers: [ev],
          pointerType: INPUT_TYPE_MOUSE,
          srcEvent: ev
        });
      }
    });
    var POINTER_INPUT_MAP = {
      pointerdown: INPUT_START2,
      pointermove: INPUT_MOVE2,
      pointerup: INPUT_END2,
      pointercancel: INPUT_CANCEL,
      pointerout: INPUT_CANCEL
    };
    var IE10_POINTER_TYPE_ENUM = {
      2: INPUT_TYPE_TOUCH,
      3: INPUT_TYPE_PEN,
      4: INPUT_TYPE_MOUSE,
      5: INPUT_TYPE_KINECT
      // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = "pointerdown";
    var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
    if (window2.MSPointerEvent && !window2.PointerEvent) {
      POINTER_ELEMENT_EVENTS = "MSPointerDown";
      POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
    }
    function PointerEventInput() {
      this.evEl = POINTER_ELEMENT_EVENTS;
      this.evWin = POINTER_WINDOW_EVENTS;
      Input2.apply(this, arguments);
      this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input2, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function PEhandler(ev) {
        var store2 = this.store;
        var removePointer = false;
        var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
        var isTouch2 = pointerType == INPUT_TYPE_TOUCH;
        var storeIndex = inArray(store2, ev.pointerId, "pointerId");
        if (eventType & INPUT_START2 && (ev.button === 0 || isTouch2)) {
          if (storeIndex < 0) {
            store2.push(ev);
            storeIndex = store2.length - 1;
          }
        } else if (eventType & (INPUT_END2 | INPUT_CANCEL)) {
          removePointer = true;
        }
        if (storeIndex < 0) {
          return;
        }
        store2[storeIndex] = ev;
        this.callback(this.manager, eventType, {
          pointers: store2,
          changedPointers: [ev],
          pointerType,
          srcEvent: ev
        });
        if (removePointer) {
          store2.splice(storeIndex, 1);
        }
      }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
      touchstart: INPUT_START2,
      touchmove: INPUT_MOVE2,
      touchend: INPUT_END2,
      touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
    var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
    function SingleTouchInput() {
      this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
      this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
      this.started = false;
      Input2.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input2, {
      handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
        if (type === INPUT_START2) {
          this.started = true;
        }
        if (!this.started) {
          return;
        }
        var touches = normalizeSingleTouches.call(this, ev, type);
        if (type & (INPUT_END2 | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
          this.started = false;
        }
        this.callback(this.manager, type, {
          pointers: touches[0],
          changedPointers: touches[1],
          pointerType: INPUT_TYPE_TOUCH,
          srcEvent: ev
        });
      }
    });
    function normalizeSingleTouches(ev, type) {
      var all = toArray3(ev.touches);
      var changed = toArray3(ev.changedTouches);
      if (type & (INPUT_END2 | INPUT_CANCEL)) {
        all = uniqueArray2(all.concat(changed), "identifier", true);
      }
      return [all, changed];
    }
    var TOUCH_INPUT_MAP = {
      touchstart: INPUT_START2,
      touchmove: INPUT_MOVE2,
      touchend: INPUT_END2,
      touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
    function TouchInput() {
      this.evTarget = TOUCH_TARGET_EVENTS;
      this.targetIds = {};
      Input2.apply(this, arguments);
    }
    inherit(TouchInput, Input2, {
      handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
          return;
        }
        this.callback(this.manager, type, {
          pointers: touches[0],
          changedPointers: touches[1],
          pointerType: INPUT_TYPE_TOUCH,
          srcEvent: ev
        });
      }
    });
    function getTouches(ev, type) {
      var allTouches = toArray3(ev.touches);
      var targetIds = this.targetIds;
      if (type & (INPUT_START2 | INPUT_MOVE2) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
      }
      var i2, targetTouches, changedTouches = toArray3(ev.changedTouches), changedTargetTouches = [], target = this.target;
      targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
      });
      if (type === INPUT_START2) {
        i2 = 0;
        while (i2 < targetTouches.length) {
          targetIds[targetTouches[i2].identifier] = true;
          i2++;
        }
      }
      i2 = 0;
      while (i2 < changedTouches.length) {
        if (targetIds[changedTouches[i2].identifier]) {
          changedTargetTouches.push(changedTouches[i2]);
        }
        if (type & (INPUT_END2 | INPUT_CANCEL)) {
          delete targetIds[changedTouches[i2].identifier];
        }
        i2++;
      }
      if (!changedTargetTouches.length) {
        return;
      }
      return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray2(targetTouches.concat(changedTargetTouches), "identifier", true),
        changedTargetTouches
      ];
    }
    var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
      Input2.apply(this, arguments);
      var handler = bindFn(this.handler, this);
      this.touch = new TouchInput(this.manager, handler);
      this.mouse = new MouseInput(this.manager, handler);
      this.primaryTouch = null;
      this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input2, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch2 = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
          return;
        }
        if (isTouch2) {
          recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
          return;
        }
        this.callback(manager, inputEvent, inputData);
      },
      /**
       * remove the event listeners
       */
      destroy: function destroy2() {
        this.touch.destroy();
        this.mouse.destroy();
      }
    });
    function recordTouches(eventType, eventData) {
      if (eventType & INPUT_START2) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
      } else if (eventType & (INPUT_END2 | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
      }
    }
    function setLastTouch(eventData) {
      var touch = eventData.changedPointers[0];
      if (touch.identifier === this.primaryTouch) {
        var lastTouch = { x: touch.clientX, y: touch.clientY };
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
          var i2 = lts.indexOf(lastTouch);
          if (i2 > -1) {
            lts.splice(i2, 1);
          }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
      }
    }
    function isSyntheticEvent(eventData) {
      var x2 = eventData.srcEvent.clientX, y2 = eventData.srcEvent.clientY;
      for (var i2 = 0; i2 < this.lastTouches.length; i2++) {
        var t2 = this.lastTouches[i2];
        var dx = Math.abs(x2 - t2.x), dy = Math.abs(y2 - t2.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
          return true;
        }
      }
      return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined$12;
    var TOUCH_ACTION_COMPUTE = "compute";
    var TOUCH_ACTION_AUTO = "auto";
    var TOUCH_ACTION_MANIPULATION = "manipulation";
    var TOUCH_ACTION_NONE = "none";
    var TOUCH_ACTION_PAN_X = "pan-x";
    var TOUCH_ACTION_PAN_Y = "pan-y";
    var TOUCH_ACTION_MAP = getTouchActionProps();
    function TouchAction(manager, value) {
      this.manager = manager;
      this.set(value);
    }
    TouchAction.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(value) {
        if (value == TOUCH_ACTION_COMPUTE) {
          value = this.compute();
        }
        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
          this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
          if (boolOrFn(recognizer.options.enable, [recognizer])) {
            actions = actions.concat(recognizer.getTouchAction());
          }
        });
        return cleanTouchActions(actions.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;
        if (this.manager.session.prevented) {
          srcEvent.preventDefault();
          return;
        }
        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
        if (hasNone) {
          var isTapPointer = input.pointers.length === 1;
          var isTapMovement = input.distance < 2;
          var isTapTouchTime = input.deltaTime < 250;
          if (isTapPointer && isTapMovement && isTapTouchTime) {
            return;
          }
        }
        if (hasPanX && hasPanY) {
          return;
        }
        if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) {
          return this.preventSrc(srcEvent);
        }
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
      }
    };
    function cleanTouchActions(actions) {
      if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
      }
      var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
      var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
      if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
      }
      if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
      }
      if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
      }
      return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
      if (!NATIVE_TOUCH_ACTION) {
        return false;
      }
      var touchMap = {};
      var cssSupports = window2.CSS && window2.CSS.supports;
      ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(val) {
        touchMap[val] = cssSupports ? window2.CSS.supports("touch-action", val) : true;
      });
      return touchMap;
    }
    var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    function Recognizer(options2) {
      this.options = assign3({}, this.defaults, options2 || {});
      this.id = uniqueId();
      this.manager = null;
      this.options.enable = ifUndefined(this.options.enable, true);
      this.state = STATE_POSSIBLE;
      this.simultaneous = {};
      this.requireFail = [];
    }
    Recognizer.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(options2) {
        assign3(this.options, options2);
        this.manager && this.manager.touchAction.update();
        return this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) {
          return this;
        }
        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
          simultaneous[otherRecognizer.id] = otherRecognizer;
          otherRecognizer.recognizeWith(this);
        }
        return this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) {
          return this;
        }
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "requireFailure", this)) {
          return this;
        }
        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
          requireFail.push(otherRecognizer);
          otherRecognizer.requireFailure(this);
        }
        return this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) {
          return this;
        }
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index2 = inArray(this.requireFail, otherRecognizer);
        if (index2 > -1) {
          this.requireFail.splice(index2, 1);
        }
        return this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(input) {
        var self2 = this;
        var state = this.state;
        function emit2(event) {
          self2.manager.emit(event, input);
        }
        if (state < STATE_ENDED) {
          emit2(self2.options.event + stateStr(state));
        }
        emit2(self2.options.event);
        if (input.additionalEvent) {
          emit2(input.additionalEvent);
        }
        if (state >= STATE_ENDED) {
          emit2(self2.options.event + stateStr(state));
        }
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(input) {
        if (this.canEmit()) {
          return this.emit(input);
        }
        this.state = STATE_FAILED;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        var i2 = 0;
        while (i2 < this.requireFail.length) {
          if (!(this.requireFail[i2].state & (STATE_FAILED | STATE_POSSIBLE))) {
            return false;
          }
          i2++;
        }
        return true;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(inputData) {
        var inputDataClone = assign3({}, inputData);
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
          this.reset();
          this.state = STATE_FAILED;
          return;
        }
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
          this.state = STATE_POSSIBLE;
        }
        this.state = this.process(inputDataClone);
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
          this.tryEmit(inputDataClone);
        }
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(inputData) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function stateStr(state) {
      if (state & STATE_CANCELLED) {
        return "cancel";
      } else if (state & STATE_ENDED) {
        return "end";
      } else if (state & STATE_CHANGED) {
        return "move";
      } else if (state & STATE_BEGAN) {
        return "start";
      }
      return "";
    }
    function directionStr(direction) {
      if (direction == DIRECTION_DOWN) {
        return "down";
      } else if (direction == DIRECTION_UP) {
        return "up";
      } else if (direction == DIRECTION_LEFT) {
        return "left";
      } else if (direction == DIRECTION_RIGHT) {
        return "right";
      }
      return "";
    }
    function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
      var manager = recognizer.manager;
      if (manager) {
        return manager.get(otherRecognizer);
      }
      return otherRecognizer;
    }
    function AttrRecognizer() {
      Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(input) {
        var state = this.state;
        var eventType = input.eventType;
        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid8 = this.attrTest(input);
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid8)) {
          return state | STATE_CANCELLED;
        } else if (isRecognized || isValid8) {
          if (eventType & INPUT_END2) {
            return state | STATE_ENDED;
          } else if (!(state & STATE_BEGAN)) {
            return STATE_BEGAN;
          }
          return state | STATE_CHANGED;
        }
        return STATE_FAILED;
      }
    });
    function PanRecognizer() {
      AttrRecognizer.apply(this, arguments);
      this.pX = null;
      this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
      },
      getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
          actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
          actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
      },
      directionTest: function(input) {
        var options2 = this.options;
        var hasMoved = true;
        var distance11 = input.distance;
        var direction = input.direction;
        var x2 = input.deltaX;
        var y2 = input.deltaY;
        if (!(direction & options2.direction)) {
          if (options2.direction & DIRECTION_HORIZONTAL) {
            direction = x2 === 0 ? DIRECTION_NONE : x2 < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
            hasMoved = x2 != this.pX;
            distance11 = Math.abs(input.deltaX);
          } else {
            direction = y2 === 0 ? DIRECTION_NONE : y2 < 0 ? DIRECTION_UP : DIRECTION_DOWN;
            hasMoved = y2 != this.pY;
            distance11 = Math.abs(input.deltaY);
          }
        }
        input.direction = direction;
        return hasMoved && distance11 > options2.threshold && direction & options2.direction;
      },
      attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
      },
      emit: function(input) {
        this.pX = input.deltaX;
        this.pY = input.deltaY;
        var direction = directionStr(input.direction);
        if (direction) {
          input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
      }
    });
    function PinchRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
      },
      attrTest: function(input) {
        return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
      },
      emit: function(input) {
        if (input.scale !== 1) {
          var inOut = input.scale < 1 ? "in" : "out";
          input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
      }
    });
    function PressRecognizer() {
      Recognizer.apply(this, arguments);
      this._timer = null;
      this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
      },
      process: function(input) {
        var options2 = this.options;
        var validPointers = input.pointers.length === options2.pointers;
        var validMovement = input.distance < options2.threshold;
        var validTime = input.deltaTime > options2.time;
        this._input = input;
        if (!validMovement || !validPointers || input.eventType & (INPUT_END2 | INPUT_CANCEL) && !validTime) {
          this.reset();
        } else if (input.eventType & INPUT_START2) {
          this.reset();
          this._timer = setTimeoutContext(function() {
            this.state = STATE_RECOGNIZED;
            this.tryEmit();
          }, options2.time, this);
        } else if (input.eventType & INPUT_END2) {
          return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
          return;
        }
        if (input && input.eventType & INPUT_END2) {
          this.manager.emit(this.options.event + "up", input);
        } else {
          this._input.timeStamp = now2();
          this.manager.emit(this.options.event, this._input);
        }
      }
    });
    function RotateRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
      },
      attrTest: function(input) {
        return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
      }
    });
    function SwipeRecognizer() {
      AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
      },
      getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
      },
      attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;
        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
          velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
          velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
          velocity = input.overallVelocityY;
        }
        return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs3(velocity) > this.options.velocity && input.eventType & INPUT_END2;
      },
      emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
          this.manager.emit(this.options.event + direction, input);
        }
        this.manager.emit(this.options.event, input);
      }
    });
    function TapRecognizer() {
      Recognizer.apply(this, arguments);
      this.pTime = false;
      this.pCenter = false;
      this._timer = null;
      this._input = null;
      this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
      },
      process: function(input) {
        var options2 = this.options;
        var validPointers = input.pointers.length === options2.pointers;
        var validMovement = input.distance < options2.threshold;
        var validTouchTime = input.deltaTime < options2.time;
        this.reset();
        if (input.eventType & INPUT_START2 && this.count === 0) {
          return this.failTimeout();
        }
        if (validMovement && validTouchTime && validPointers) {
          if (input.eventType != INPUT_END2) {
            return this.failTimeout();
          }
          var validInterval = this.pTime ? input.timeStamp - this.pTime < options2.interval : true;
          var validMultiTap = !this.pCenter || getDistance5(this.pCenter, input.center) < options2.posThreshold;
          this.pTime = input.timeStamp;
          this.pCenter = input.center;
          if (!validMultiTap || !validInterval) {
            this.count = 1;
          } else {
            this.count += 1;
          }
          this._input = input;
          var tapCount = this.count % options2.taps;
          if (tapCount === 0) {
            if (!this.hasRequireFailures()) {
              return STATE_RECOGNIZED;
            } else {
              this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
              }, options2.interval, this);
              return STATE_BEGAN;
            }
          }
        }
        return STATE_FAILED;
      },
      failTimeout: function() {
        this._timer = setTimeoutContext(function() {
          this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        if (this.state == STATE_RECOGNIZED) {
          this._input.tapCount = this.count;
          this.manager.emit(this.options.event, this._input);
        }
      }
    });
    function Hammer(element, options2) {
      options2 = options2 || {};
      options2.recognizers = ifUndefined(options2.recognizers, Hammer.defaults.preset);
      return new Manager2(element, options2);
    }
    Hammer.VERSION = "2.0.7";
    Hammer.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: false,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: TOUCH_ACTION_COMPUTE,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: true,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, { enable: false }],
        [PinchRecognizer, { enable: false }, ["rotate"]],
        [SwipeRecognizer, { direction: DIRECTION_HORIZONTAL }],
        [PanRecognizer, { direction: DIRECTION_HORIZONTAL }, ["swipe"]],
        [TapRecognizer],
        [TapRecognizer, { event: "doubletap", taps: 2 }, ["tap"]],
        [PressRecognizer]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    function Manager2(element, options2) {
      this.options = assign3({}, Hammer.defaults, options2 || {});
      this.options.inputTarget = this.options.inputTarget || element;
      this.handlers = {};
      this.session = {};
      this.recognizers = [];
      this.oldCssProps = {};
      this.element = element;
      this.input = createInputInstance(this);
      this.touchAction = new TouchAction(this, this.options.touchAction);
      toggleCssProps(this, true);
      each(this.options.recognizers, function(item) {
        var recognizer = this.add(new item[0](item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
      }, this);
    }
    Manager2.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(options2) {
        assign3(this.options, options2);
        if (options2.touchAction) {
          this.touchAction.update();
        }
        if (options2.inputTarget) {
          this.input.destroy();
          this.input.target = options2.inputTarget;
          this.input.init();
        }
        return this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
          return;
        }
        this.touchAction.preventDefaults(inputData);
        var recognizer;
        var recognizers = this.recognizers;
        var curRecognizer = session.curRecognizer;
        if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) {
          curRecognizer = session.curRecognizer = null;
        }
        var i2 = 0;
        while (i2 < recognizers.length) {
          recognizer = recognizers[i2];
          if (session.stopped !== FORCED_STOP && // 1
          (!curRecognizer || recognizer == curRecognizer || // 2
          recognizer.canRecognizeWith(curRecognizer))) {
            recognizer.recognize(inputData);
          } else {
            recognizer.reset();
          }
          if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
            curRecognizer = session.curRecognizer = recognizer;
          }
          i2++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
          return recognizer;
        }
        var recognizers = this.recognizers;
        for (var i2 = 0; i2 < recognizers.length; i2++) {
          if (recognizers[i2].options.event == recognizer) {
            return recognizers[i2];
          }
        }
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(recognizer) {
        if (invokeArrayArg(recognizer, "add", this)) {
          return this;
        }
        var existing = this.get(recognizer.options.event);
        if (existing) {
          this.remove(existing);
        }
        this.recognizers.push(recognizer);
        recognizer.manager = this;
        this.touchAction.update();
        return recognizer;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(recognizer) {
        if (invokeArrayArg(recognizer, "remove", this)) {
          return this;
        }
        recognizer = this.get(recognizer);
        if (recognizer) {
          var recognizers = this.recognizers;
          var index2 = inArray(recognizers, recognizer);
          if (index2 !== -1) {
            recognizers.splice(index2, 1);
            this.touchAction.update();
          }
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(events2, handler) {
        if (events2 === undefined$12) {
          return;
        }
        if (handler === undefined$12) {
          return;
        }
        var handlers2 = this.handlers;
        each(splitStr(events2), function(event) {
          handlers2[event] = handlers2[event] || [];
          handlers2[event].push(handler);
        });
        return this;
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(events2, handler) {
        if (events2 === undefined$12) {
          return;
        }
        var handlers2 = this.handlers;
        each(splitStr(events2), function(event) {
          if (!handler) {
            delete handlers2[event];
          } else {
            handlers2[event] && handlers2[event].splice(inArray(handlers2[event], handler), 1);
          }
        });
        return this;
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(event, data2) {
        if (this.options.domEvents) {
          triggerDomEvent(event, data2);
        }
        var handlers2 = this.handlers[event] && this.handlers[event].slice();
        if (!handlers2 || !handlers2.length) {
          return;
        }
        data2.type = event;
        data2.preventDefault = function() {
          data2.srcEvent.preventDefault();
        };
        var i2 = 0;
        while (i2 < handlers2.length) {
          handlers2[i2](data2);
          i2++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && toggleCssProps(this, false);
        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
      }
    };
    function toggleCssProps(manager, add18) {
      var element = manager.element;
      if (!element.style) {
        return;
      }
      var prop;
      each(manager.options.cssProps, function(value, name2) {
        prop = prefixed(element.style, name2);
        if (add18) {
          manager.oldCssProps[prop] = element.style[prop];
          element.style[prop] = value;
        } else {
          element.style[prop] = manager.oldCssProps[prop] || "";
        }
      });
      if (!add18) {
        manager.oldCssProps = {};
      }
    }
    function triggerDomEvent(event, data2) {
      var gestureEvent = document2.createEvent("Event");
      gestureEvent.initEvent(event, true, true);
      gestureEvent.gesture = data2;
      data2.target.dispatchEvent(gestureEvent);
    }
    assign3(Hammer, {
      INPUT_START: INPUT_START2,
      INPUT_MOVE: INPUT_MOVE2,
      INPUT_END: INPUT_END2,
      INPUT_CANCEL,
      STATE_POSSIBLE,
      STATE_BEGAN,
      STATE_CHANGED,
      STATE_ENDED,
      STATE_RECOGNIZED,
      STATE_CANCELLED,
      STATE_FAILED,
      DIRECTION_NONE,
      DIRECTION_LEFT,
      DIRECTION_RIGHT,
      DIRECTION_UP,
      DIRECTION_DOWN,
      DIRECTION_HORIZONTAL,
      DIRECTION_VERTICAL,
      DIRECTION_ALL,
      Manager: Manager2,
      Input: Input2,
      TouchAction,
      TouchInput,
      MouseInput,
      PointerEventInput,
      TouchMouseInput,
      SingleTouchInput,
      Recognizer,
      AttrRecognizer,
      Tap: TapRecognizer,
      Pan: PanRecognizer,
      Swipe: SwipeRecognizer,
      Pinch: PinchRecognizer,
      Rotate: RotateRecognizer,
      Press: PressRecognizer,
      on: addEventListeners,
      off: removeEventListeners,
      each,
      merge: merge4,
      extend: extend4,
      assign: assign3,
      inherit,
      bindFn,
      prefixed
    });
    var freeGlobal2 = typeof window2 !== "undefined" ? window2 : typeof self !== "undefined" ? self : {};
    freeGlobal2.Hammer = Hammer;
    if (typeof undefined$12 === "function" && undefined$12.amd) {
      undefined$12(function() {
        return Hammer;
      });
    } else if (module2.exports) {
      module2.exports = Hammer;
    } else {
      window2[exportName] = Hammer;
    }
  })(window, document, "Hammer");
})(hammer$1);
const hammer = hammerExports;
const hammerjs = /* @__PURE__ */ _mergeNamespaces({
  __proto__: null,
  default: hammer
}, [hammerExports]);
const INPUT_START = 1;
const INPUT_MOVE = 2;
const INPUT_END = 4;
const MOUSE_INPUT_MAP = {
  mousedown: INPUT_START,
  mousemove: INPUT_MOVE,
  mouseup: INPUT_END
};
function some(array2, predict) {
  for (let i2 = 0; i2 < array2.length; i2++) {
    if (predict(array2[i2])) {
      return true;
    }
  }
  return false;
}
function enhancePointerEventInput(PointerEventInput) {
  const oldHandler = PointerEventInput.prototype.handler;
  PointerEventInput.prototype.handler = function handler(ev) {
    const store2 = this.store;
    if (ev.button > 0 && ev.type === "pointerdown") {
      if (!some(store2, (e3) => e3.pointerId === ev.pointerId)) {
        store2.push(ev);
      }
    }
    oldHandler.call(this, ev);
  };
}
function enhanceMouseInput(MouseInput) {
  MouseInput.prototype.handler = function handler(ev) {
    let eventType = MOUSE_INPUT_MAP[ev.type];
    if (eventType & INPUT_START && ev.button >= 0) {
      this.pressed = true;
    }
    if (eventType & INPUT_MOVE && ev.which === 0) {
      eventType = INPUT_END;
    }
    if (!this.pressed) {
      return;
    }
    if (eventType & INPUT_END) {
      this.pressed = false;
    }
    this.callback(this.manager, eventType, {
      pointers: [ev],
      changedPointers: [ev],
      pointerType: "mouse",
      srcEvent: ev
    });
  };
}
enhancePointerEventInput(hammerExports.PointerEventInput);
enhanceMouseInput(hammerExports.MouseInput);
const Manager = hammerExports.Manager;
class Input {
  constructor(element, callback, options2) {
    this.element = element;
    this.callback = callback;
    this.options = { enable: true, ...options2 };
  }
}
const RECOGNIZERS = hammerjs ? [
  [hammerjs.Pan, { event: "tripan", pointers: 3, threshold: 0, enable: false }],
  [hammerjs.Rotate, { enable: false }],
  [hammerjs.Pinch, { enable: false }],
  [hammerjs.Swipe, { enable: false }],
  [hammerjs.Pan, { threshold: 0, enable: false }],
  [hammerjs.Press, { enable: false }],
  [hammerjs.Tap, { event: "doubletap", taps: 2, enable: false }],
  // TODO - rename to 'tap' and 'singletap' in the next major release
  [hammerjs.Tap, { event: "anytap", enable: false }],
  [hammerjs.Tap, { enable: false }]
] : null;
const RECOGNIZER_COMPATIBLE_MAP = {
  tripan: ["rotate", "pinch", "pan"],
  rotate: ["pinch"],
  pinch: ["pan"],
  pan: ["press", "doubletap", "anytap", "tap"],
  doubletap: ["anytap"],
  anytap: ["tap"]
};
const RECOGNIZER_FALLBACK_MAP = {
  doubletap: ["tap"]
};
const BASIC_EVENT_ALIASES = {
  pointerdown: "pointerdown",
  pointermove: "pointermove",
  pointerup: "pointerup",
  touchstart: "pointerdown",
  touchmove: "pointermove",
  touchend: "pointerup",
  mousedown: "pointerdown",
  mousemove: "pointermove",
  mouseup: "pointerup"
};
const INPUT_EVENT_TYPES = {
  KEY_EVENTS: ["keydown", "keyup"],
  MOUSE_EVENTS: ["mousedown", "mousemove", "mouseup", "mouseover", "mouseout", "mouseleave"],
  WHEEL_EVENTS: [
    // Chrome, Safari
    "wheel",
    // IE
    "mousewheel"
  ]
};
const EVENT_RECOGNIZER_MAP = {
  tap: "tap",
  anytap: "anytap",
  doubletap: "doubletap",
  press: "press",
  pinch: "pinch",
  pinchin: "pinch",
  pinchout: "pinch",
  pinchstart: "pinch",
  pinchmove: "pinch",
  pinchend: "pinch",
  pinchcancel: "pinch",
  rotate: "rotate",
  rotatestart: "rotate",
  rotatemove: "rotate",
  rotateend: "rotate",
  rotatecancel: "rotate",
  tripan: "tripan",
  tripanstart: "tripan",
  tripanmove: "tripan",
  tripanup: "tripan",
  tripandown: "tripan",
  tripanleft: "tripan",
  tripanright: "tripan",
  tripanend: "tripan",
  tripancancel: "tripan",
  pan: "pan",
  panstart: "pan",
  panmove: "pan",
  panup: "pan",
  pandown: "pan",
  panleft: "pan",
  panright: "pan",
  panend: "pan",
  pancancel: "pan",
  swipe: "swipe",
  swipeleft: "swipe",
  swiperight: "swipe",
  swipeup: "swipe",
  swipedown: "swipe"
};
const GESTURE_EVENT_ALIASES = {
  click: "tap",
  anyclick: "anytap",
  dblclick: "doubletap",
  mousedown: "pointerdown",
  mousemove: "pointermove",
  mouseup: "pointerup",
  mouseover: "pointerover",
  mouseout: "pointerout",
  mouseleave: "pointerleave"
};
const userAgent = typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent.toLowerCase() : "";
const window_ = typeof window !== "undefined" ? window : global;
let passiveSupported = false;
try {
  const options2 = {
    // This function will be called when the browser
    // attempts to access the passive property.
    get passive() {
      passiveSupported = true;
      return true;
    }
  };
  window_.addEventListener("test", null, options2);
  window_.removeEventListener("test", null);
} catch (err) {
  passiveSupported = false;
}
const firefox = userAgent.indexOf("firefox") !== -1;
const { WHEEL_EVENTS } = INPUT_EVENT_TYPES;
const EVENT_TYPE$1 = "wheel";
const WHEEL_DELTA_MAGIC_SCALER = 4.000244140625;
const WHEEL_DELTA_PER_LINE = 40;
const SHIFT_MULTIPLIER = 0.25;
class WheelInput extends Input {
  constructor(element, callback, options2) {
    super(element, callback, options2);
    this.handleEvent = (event) => {
      if (!this.options.enable) {
        return;
      }
      let value = event.deltaY;
      if (window_.WheelEvent) {
        if (firefox && event.deltaMode === window_.WheelEvent.DOM_DELTA_PIXEL) {
          value /= window_.devicePixelRatio;
        }
        if (event.deltaMode === window_.WheelEvent.DOM_DELTA_LINE) {
          value *= WHEEL_DELTA_PER_LINE;
        }
      }
      if (value !== 0 && value % WHEEL_DELTA_MAGIC_SCALER === 0) {
        value = Math.floor(value / WHEEL_DELTA_MAGIC_SCALER);
      }
      if (event.shiftKey && value) {
        value = value * SHIFT_MULTIPLIER;
      }
      this.callback({
        type: EVENT_TYPE$1,
        center: {
          x: event.clientX,
          y: event.clientY
        },
        delta: -value,
        srcEvent: event,
        pointerType: "mouse",
        target: event.target
      });
    };
    this.events = (this.options.events || []).concat(WHEEL_EVENTS);
    this.events.forEach((event) => element.addEventListener(event, this.handleEvent, passiveSupported ? { passive: false } : false));
  }
  destroy() {
    this.events.forEach((event) => this.element.removeEventListener(event, this.handleEvent));
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(eventType, enabled) {
    if (eventType === EVENT_TYPE$1) {
      this.options.enable = enabled;
    }
  }
}
const { MOUSE_EVENTS: MOUSE_EVENTS$1 } = INPUT_EVENT_TYPES;
const MOVE_EVENT_TYPE = "pointermove";
const OVER_EVENT_TYPE = "pointerover";
const OUT_EVENT_TYPE = "pointerout";
const ENTER_EVENT_TYPE = "pointerenter";
const LEAVE_EVENT_TYPE = "pointerleave";
class MoveInput extends Input {
  constructor(element, callback, options2) {
    super(element, callback, options2);
    this.handleEvent = (event) => {
      this.handleOverEvent(event);
      this.handleOutEvent(event);
      this.handleEnterEvent(event);
      this.handleLeaveEvent(event);
      this.handleMoveEvent(event);
    };
    this.pressed = false;
    const { enable: enable4 } = this.options;
    this.enableMoveEvent = enable4;
    this.enableLeaveEvent = enable4;
    this.enableEnterEvent = enable4;
    this.enableOutEvent = enable4;
    this.enableOverEvent = enable4;
    this.events = (this.options.events || []).concat(MOUSE_EVENTS$1);
    this.events.forEach((event) => element.addEventListener(event, this.handleEvent));
  }
  destroy() {
    this.events.forEach((event) => this.element.removeEventListener(event, this.handleEvent));
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(eventType, enabled) {
    if (eventType === MOVE_EVENT_TYPE) {
      this.enableMoveEvent = enabled;
    }
    if (eventType === OVER_EVENT_TYPE) {
      this.enableOverEvent = enabled;
    }
    if (eventType === OUT_EVENT_TYPE) {
      this.enableOutEvent = enabled;
    }
    if (eventType === ENTER_EVENT_TYPE) {
      this.enableEnterEvent = enabled;
    }
    if (eventType === LEAVE_EVENT_TYPE) {
      this.enableLeaveEvent = enabled;
    }
  }
  handleOverEvent(event) {
    if (this.enableOverEvent) {
      if (event.type === "mouseover") {
        this._emit(OVER_EVENT_TYPE, event);
      }
    }
  }
  handleOutEvent(event) {
    if (this.enableOutEvent) {
      if (event.type === "mouseout") {
        this._emit(OUT_EVENT_TYPE, event);
      }
    }
  }
  handleEnterEvent(event) {
    if (this.enableEnterEvent) {
      if (event.type === "mouseenter") {
        this._emit(ENTER_EVENT_TYPE, event);
      }
    }
  }
  handleLeaveEvent(event) {
    if (this.enableLeaveEvent) {
      if (event.type === "mouseleave") {
        this._emit(LEAVE_EVENT_TYPE, event);
      }
    }
  }
  handleMoveEvent(event) {
    if (this.enableMoveEvent) {
      switch (event.type) {
        case "mousedown":
          if (event.button >= 0) {
            this.pressed = true;
          }
          break;
        case "mousemove":
          if (event.which === 0) {
            this.pressed = false;
          }
          if (!this.pressed) {
            this._emit(MOVE_EVENT_TYPE, event);
          }
          break;
        case "mouseup":
          this.pressed = false;
          break;
      }
    }
  }
  _emit(type, event) {
    this.callback({
      type,
      center: {
        x: event.clientX,
        y: event.clientY
      },
      srcEvent: event,
      pointerType: "mouse",
      target: event.target
    });
  }
}
const { KEY_EVENTS } = INPUT_EVENT_TYPES;
const DOWN_EVENT_TYPE = "keydown";
const UP_EVENT_TYPE = "keyup";
class KeyInput extends Input {
  constructor(element, callback, options2) {
    super(element, callback, options2);
    this.handleEvent = (event) => {
      const targetElement = event.target || event.srcElement;
      if (targetElement.tagName === "INPUT" && targetElement.type === "text" || targetElement.tagName === "TEXTAREA") {
        return;
      }
      if (this.enableDownEvent && event.type === "keydown") {
        this.callback({
          type: DOWN_EVENT_TYPE,
          srcEvent: event,
          key: event.key,
          target: event.target
        });
      }
      if (this.enableUpEvent && event.type === "keyup") {
        this.callback({
          type: UP_EVENT_TYPE,
          srcEvent: event,
          key: event.key,
          target: event.target
        });
      }
    };
    this.enableDownEvent = this.options.enable;
    this.enableUpEvent = this.options.enable;
    this.events = (this.options.events || []).concat(KEY_EVENTS);
    element.tabIndex = this.options.tabIndex || 0;
    element.style.outline = "none";
    this.events.forEach((event) => element.addEventListener(event, this.handleEvent));
  }
  destroy() {
    this.events.forEach((event) => this.element.removeEventListener(event, this.handleEvent));
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(eventType, enabled) {
    if (eventType === DOWN_EVENT_TYPE) {
      this.enableDownEvent = enabled;
    }
    if (eventType === UP_EVENT_TYPE) {
      this.enableUpEvent = enabled;
    }
  }
}
const EVENT_TYPE = "contextmenu";
class ContextmenuInput extends Input {
  constructor(element, callback, options2) {
    super(element, callback, options2);
    this.handleEvent = (event) => {
      if (!this.options.enable) {
        return;
      }
      this.callback({
        type: EVENT_TYPE,
        center: {
          x: event.clientX,
          y: event.clientY
        },
        srcEvent: event,
        pointerType: "mouse",
        target: event.target
      });
    };
    element.addEventListener("contextmenu", this.handleEvent);
  }
  destroy() {
    this.element.removeEventListener("contextmenu", this.handleEvent);
  }
  /**
   * Enable this input (begin processing events)
   * if the specified event type is among those handled by this input.
   */
  enableEventType(eventType, enabled) {
    if (eventType === EVENT_TYPE) {
      this.options.enable = enabled;
    }
  }
}
const DOWN_EVENT = 1;
const MOVE_EVENT = 2;
const UP_EVENT = 4;
const MOUSE_EVENTS = {
  pointerdown: DOWN_EVENT,
  pointermove: MOVE_EVENT,
  pointerup: UP_EVENT,
  mousedown: DOWN_EVENT,
  mousemove: MOVE_EVENT,
  mouseup: UP_EVENT
};
const MOUSE_EVENT_WHICH_LEFT = 1;
const MOUSE_EVENT_WHICH_MIDDLE = 2;
const MOUSE_EVENT_WHICH_RIGHT = 3;
const MOUSE_EVENT_BUTTON_LEFT = 0;
const MOUSE_EVENT_BUTTON_MIDDLE = 1;
const MOUSE_EVENT_BUTTON_RIGHT = 2;
const MOUSE_EVENT_BUTTONS_LEFT_MASK = 1;
const MOUSE_EVENT_BUTTONS_RIGHT_MASK = 2;
const MOUSE_EVENT_BUTTONS_MIDDLE_MASK = 4;
function whichButtons(event) {
  const eventType = MOUSE_EVENTS[event.srcEvent.type];
  if (!eventType) {
    return null;
  }
  const { buttons, button, which } = event.srcEvent;
  let leftButton = false;
  let middleButton = false;
  let rightButton = false;
  if (
    // button is up, need to find out which one was pressed before
    eventType === UP_EVENT || // moving but does not support `buttons` API
    eventType === MOVE_EVENT && !Number.isFinite(buttons)
  ) {
    leftButton = which === MOUSE_EVENT_WHICH_LEFT;
    middleButton = which === MOUSE_EVENT_WHICH_MIDDLE;
    rightButton = which === MOUSE_EVENT_WHICH_RIGHT;
  } else if (eventType === MOVE_EVENT) {
    leftButton = Boolean(buttons & MOUSE_EVENT_BUTTONS_LEFT_MASK);
    middleButton = Boolean(buttons & MOUSE_EVENT_BUTTONS_MIDDLE_MASK);
    rightButton = Boolean(buttons & MOUSE_EVENT_BUTTONS_RIGHT_MASK);
  } else if (eventType === DOWN_EVENT) {
    leftButton = button === MOUSE_EVENT_BUTTON_LEFT;
    middleButton = button === MOUSE_EVENT_BUTTON_MIDDLE;
    rightButton = button === MOUSE_EVENT_BUTTON_RIGHT;
  }
  return { leftButton, middleButton, rightButton };
}
function getOffsetPosition(event, rootElement) {
  const center2 = event.center;
  if (!center2) {
    return null;
  }
  const rect = rootElement.getBoundingClientRect();
  const scaleX3 = rect.width / rootElement.offsetWidth || 1;
  const scaleY3 = rect.height / rootElement.offsetHeight || 1;
  const offsetCenter = {
    x: (center2.x - rect.left - rootElement.clientLeft) / scaleX3,
    y: (center2.y - rect.top - rootElement.clientTop) / scaleY3
  };
  return { center: center2, offsetCenter };
}
const DEFAULT_OPTIONS$2 = {
  srcElement: "root",
  priority: 0
};
class EventRegistrar {
  constructor(eventManager) {
    this.handleEvent = (event) => {
      if (this.isEmpty()) {
        return;
      }
      const mjolnirEvent = this._normalizeEvent(event);
      let target = event.srcEvent.target;
      while (target && target !== mjolnirEvent.rootElement) {
        this._emit(mjolnirEvent, target);
        if (mjolnirEvent.handled) {
          return;
        }
        target = target.parentNode;
      }
      this._emit(mjolnirEvent, "root");
    };
    this.eventManager = eventManager;
    this.handlers = [];
    this.handlersByElement = /* @__PURE__ */ new Map();
    this._active = false;
  }
  // Returns true if there are no non-passive handlers
  isEmpty() {
    return !this._active;
  }
  add(type, handler, options2, once3 = false, passive = false) {
    const { handlers: handlers2, handlersByElement } = this;
    let opts = DEFAULT_OPTIONS$2;
    if (typeof options2 === "string" || options2 && options2.addEventListener) {
      opts = { ...DEFAULT_OPTIONS$2, srcElement: options2 };
    } else if (options2) {
      opts = { ...DEFAULT_OPTIONS$2, ...options2 };
    }
    let entries = handlersByElement.get(opts.srcElement);
    if (!entries) {
      entries = [];
      handlersByElement.set(opts.srcElement, entries);
    }
    const entry = {
      type,
      handler,
      srcElement: opts.srcElement,
      priority: opts.priority
    };
    if (once3) {
      entry.once = true;
    }
    if (passive) {
      entry.passive = true;
    }
    handlers2.push(entry);
    this._active = this._active || !entry.passive;
    let insertPosition = entries.length - 1;
    while (insertPosition >= 0) {
      if (entries[insertPosition].priority >= entry.priority) {
        break;
      }
      insertPosition--;
    }
    entries.splice(insertPosition + 1, 0, entry);
  }
  remove(type, handler) {
    const { handlers: handlers2, handlersByElement } = this;
    for (let i2 = handlers2.length - 1; i2 >= 0; i2--) {
      const entry = handlers2[i2];
      if (entry.type === type && entry.handler === handler) {
        handlers2.splice(i2, 1);
        const entries = handlersByElement.get(entry.srcElement);
        entries.splice(entries.indexOf(entry), 1);
        if (entries.length === 0) {
          handlersByElement.delete(entry.srcElement);
        }
      }
    }
    this._active = handlers2.some((entry) => !entry.passive);
  }
  /**
   * Invoke handlers on a particular element
   */
  _emit(event, srcElement) {
    const entries = this.handlersByElement.get(srcElement);
    if (entries) {
      let immediatePropagationStopped = false;
      const stopPropagation = () => {
        event.handled = true;
      };
      const stopImmediatePropagation = () => {
        event.handled = true;
        immediatePropagationStopped = true;
      };
      const entriesToRemove = [];
      for (let i2 = 0; i2 < entries.length; i2++) {
        const { type, handler, once: once3 } = entries[i2];
        handler({
          ...event,
          // @ts-ignore
          type,
          stopPropagation,
          stopImmediatePropagation
        });
        if (once3) {
          entriesToRemove.push(entries[i2]);
        }
        if (immediatePropagationStopped) {
          break;
        }
      }
      for (let i2 = 0; i2 < entriesToRemove.length; i2++) {
        const { type, handler } = entriesToRemove[i2];
        this.remove(type, handler);
      }
    }
  }
  /**
   * Normalizes hammerjs and custom events to have predictable fields.
   */
  _normalizeEvent(event) {
    const rootElement = this.eventManager.getElement();
    return {
      ...event,
      ...whichButtons(event),
      ...getOffsetPosition(event, rootElement),
      preventDefault: () => {
        event.srcEvent.preventDefault();
      },
      stopImmediatePropagation: null,
      stopPropagation: null,
      handled: false,
      rootElement
    };
  }
}
const DEFAULT_OPTIONS$1 = {
  // event handlers
  events: null,
  // custom recognizers
  recognizers: null,
  recognizerOptions: {},
  // Manager class
  Manager,
  // allow browser default touch action
  // https://github.com/uber/react-map-gl/issues/506
  touchAction: "none",
  tabIndex: 0
};
class EventManager {
  constructor(element = null, options2) {
    this._onBasicInput = (event) => {
      const { srcEvent } = event;
      const alias = BASIC_EVENT_ALIASES[srcEvent.type];
      if (alias) {
        this.manager.emit(alias, event);
      }
    };
    this._onOtherEvent = (event) => {
      this.manager.emit(event.type, event);
    };
    this.options = { ...DEFAULT_OPTIONS$1, ...options2 };
    this.events = /* @__PURE__ */ new Map();
    this.setElement(element);
    const { events: events2 } = this.options;
    if (events2) {
      this.on(events2);
    }
  }
  getElement() {
    return this.element;
  }
  setElement(element) {
    if (this.element) {
      this.destroy();
    }
    this.element = element;
    if (!element) {
      return;
    }
    const { options: options2 } = this;
    const ManagerClass = options2.Manager;
    this.manager = new ManagerClass(element, {
      touchAction: options2.touchAction,
      recognizers: options2.recognizers || RECOGNIZERS
    }).on("hammer.input", this._onBasicInput);
    if (!options2.recognizers) {
      Object.keys(RECOGNIZER_COMPATIBLE_MAP).forEach((name2) => {
        const recognizer = this.manager.get(name2);
        if (recognizer) {
          RECOGNIZER_COMPATIBLE_MAP[name2].forEach((otherName) => {
            recognizer.recognizeWith(otherName);
          });
        }
      });
    }
    for (const recognizerName in options2.recognizerOptions) {
      const recognizer = this.manager.get(recognizerName);
      if (recognizer) {
        const recognizerOption = options2.recognizerOptions[recognizerName];
        delete recognizerOption.enable;
        recognizer.set(recognizerOption);
      }
    }
    this.wheelInput = new WheelInput(element, this._onOtherEvent, {
      enable: false
    });
    this.moveInput = new MoveInput(element, this._onOtherEvent, {
      enable: false
    });
    this.keyInput = new KeyInput(element, this._onOtherEvent, {
      enable: false,
      tabIndex: options2.tabIndex
    });
    this.contextmenuInput = new ContextmenuInput(element, this._onOtherEvent, {
      enable: false
    });
    for (const [eventAlias, eventRegistrar] of this.events) {
      if (!eventRegistrar.isEmpty()) {
        this._toggleRecognizer(eventRegistrar.recognizerName, true);
        this.manager.on(eventAlias, eventRegistrar.handleEvent);
      }
    }
  }
  // Tear down internal event management implementations.
  destroy() {
    if (this.element) {
      this.wheelInput.destroy();
      this.moveInput.destroy();
      this.keyInput.destroy();
      this.contextmenuInput.destroy();
      this.manager.destroy();
      this.wheelInput = null;
      this.moveInput = null;
      this.keyInput = null;
      this.contextmenuInput = null;
      this.manager = null;
      this.element = null;
    }
  }
  /** Register an event handler function to be called on `event` */
  on(event, handler, opts) {
    this._addEventHandler(event, handler, opts, false);
  }
  once(event, handler, opts) {
    this._addEventHandler(event, handler, opts, true);
  }
  watch(event, handler, opts) {
    this._addEventHandler(event, handler, opts, false, true);
  }
  off(event, handler) {
    this._removeEventHandler(event, handler);
  }
  /*
   * Enable/disable recognizer for the given event
   */
  _toggleRecognizer(name2, enabled) {
    const { manager } = this;
    if (!manager) {
      return;
    }
    const recognizer = manager.get(name2);
    if (recognizer && recognizer.options.enable !== enabled) {
      recognizer.set({ enable: enabled });
      const fallbackRecognizers = RECOGNIZER_FALLBACK_MAP[name2];
      if (fallbackRecognizers && !this.options.recognizers) {
        fallbackRecognizers.forEach((otherName) => {
          const otherRecognizer = manager.get(otherName);
          if (enabled) {
            otherRecognizer.requireFailure(name2);
            recognizer.dropRequireFailure(otherName);
          } else {
            otherRecognizer.dropRequireFailure(name2);
          }
        });
      }
    }
    this.wheelInput.enableEventType(name2, enabled);
    this.moveInput.enableEventType(name2, enabled);
    this.keyInput.enableEventType(name2, enabled);
    this.contextmenuInput.enableEventType(name2, enabled);
  }
  /**
   * Process the event registration for a single event + handler.
   */
  _addEventHandler(event, handler, opts, once3, passive) {
    if (typeof event !== "string") {
      opts = handler;
      for (const eventName in event) {
        this._addEventHandler(eventName, event[eventName], opts, once3, passive);
      }
      return;
    }
    const { manager, events: events2 } = this;
    const eventAlias = GESTURE_EVENT_ALIASES[event] || event;
    let eventRegistrar = events2.get(eventAlias);
    if (!eventRegistrar) {
      eventRegistrar = new EventRegistrar(this);
      events2.set(eventAlias, eventRegistrar);
      eventRegistrar.recognizerName = EVENT_RECOGNIZER_MAP[eventAlias] || eventAlias;
      if (manager) {
        manager.on(eventAlias, eventRegistrar.handleEvent);
      }
    }
    eventRegistrar.add(event, handler, opts, once3, passive);
    if (!eventRegistrar.isEmpty()) {
      this._toggleRecognizer(eventRegistrar.recognizerName, true);
    }
  }
  /**
   * Process the event deregistration for a single event + handler.
   */
  _removeEventHandler(event, handler) {
    if (typeof event !== "string") {
      for (const eventName in event) {
        this._removeEventHandler(eventName, event[eventName]);
      }
      return;
    }
    const { events: events2 } = this;
    const eventAlias = GESTURE_EVENT_ALIASES[event] || event;
    const eventRegistrar = events2.get(eventAlias);
    if (!eventRegistrar) {
      return;
    }
    eventRegistrar.remove(event, handler);
    if (eventRegistrar.isEmpty()) {
      const { recognizerName } = eventRegistrar;
      let isRecognizerUsed = false;
      for (const eh of events2.values()) {
        if (eh.recognizerName === recognizerName && !eh.isEmpty()) {
          isRecognizerUsed = true;
          break;
        }
      }
      if (!isRecognizerUsed) {
        this._toggleRecognizer(recognizerName, false);
      }
    }
  }
}
function noop$3() {
}
const getCursor = ({ isDragging }) => isDragging ? "grabbing" : "grab";
const defaultProps$p = {
  id: "",
  width: "100%",
  height: "100%",
  style: null,
  viewState: null,
  initialViewState: null,
  pickingRadius: 0,
  layerFilter: null,
  parameters: {},
  parent: null,
  device: null,
  deviceProps: { type: "webgl" },
  gl: null,
  glOptions: {},
  canvas: null,
  layers: [],
  effects: [],
  views: null,
  controller: null,
  // Rely on external controller, e.g. react-map-gl
  useDevicePixels: true,
  touchAction: "none",
  eventRecognizerOptions: {},
  _framebuffer: null,
  _animate: false,
  _pickable: true,
  _typedArrayManagerProps: {},
  _customRender: null,
  widgets: [],
  onDeviceInitialized: noop$3,
  onWebGLInitialized: noop$3,
  onResize: noop$3,
  onViewStateChange: noop$3,
  onInteractionStateChange: noop$3,
  onBeforeRender: noop$3,
  onAfterRender: noop$3,
  onLoad: noop$3,
  onError: (error2) => log$1.error(error2.message, error2.cause)(),
  onHover: null,
  onClick: null,
  onDragStart: null,
  onDrag: null,
  onDragEnd: null,
  _onMetrics: null,
  getCursor,
  getTooltip: null,
  debug: false,
  drawPickingColors: false
};
const _Deck = class {
  constructor(props) {
    this.width = 0;
    this.height = 0;
    this.userData = {};
    this.device = null;
    this.canvas = null;
    this.viewManager = null;
    this.layerManager = null;
    this.effectManager = null;
    this.deckRenderer = null;
    this.deckPicker = null;
    this.eventManager = null;
    this.widgetManager = null;
    this.tooltip = null;
    this.animationLoop = null;
    this.cursorState = {
      isHovering: false,
      isDragging: false
    };
    this.stats = new Stats({ id: "deck.gl" });
    this.metrics = {
      fps: 0,
      setPropsTime: 0,
      updateAttributesTime: 0,
      framesRedrawn: 0,
      pickTime: 0,
      pickCount: 0,
      gpuTime: 0,
      gpuTimePerFrame: 0,
      cpuTime: 0,
      cpuTimePerFrame: 0,
      bufferMemory: 0,
      textureMemory: 0,
      renderbufferMemory: 0,
      gpuMemory: 0
    };
    this._metricsCounter = 0;
    this._needsRedraw = "Initial render";
    this._pickRequest = {
      mode: "hover",
      x: -1,
      y: -1,
      radius: 0,
      event: null
    };
    this._lastPointerDownInfo = null;
    this._onPointerMove = (event) => {
      const { _pickRequest } = this;
      if (event.type === "pointerleave") {
        _pickRequest.x = -1;
        _pickRequest.y = -1;
        _pickRequest.radius = 0;
      } else if (event.leftButton || event.rightButton) {
        return;
      } else {
        const pos = event.offsetCenter;
        if (!pos) {
          return;
        }
        _pickRequest.x = pos.x;
        _pickRequest.y = pos.y;
        _pickRequest.radius = this.props.pickingRadius;
      }
      if (this.layerManager) {
        this.layerManager.context.mousePosition = { x: _pickRequest.x, y: _pickRequest.y };
      }
      _pickRequest.event = event;
    };
    this._onEvent = (event) => {
      const eventOptions = EVENTS$1[event.type];
      const pos = event.offsetCenter;
      if (!eventOptions || !pos || !this.layerManager) {
        return;
      }
      const layers = this.layerManager.getLayers();
      const info = this.deckPicker.getLastPickedObject({
        x: pos.x,
        y: pos.y,
        layers,
        viewports: this.getViewports(pos)
      }, this._lastPointerDownInfo);
      const { layer } = info;
      const layerHandler = layer && (layer[eventOptions.handler] || layer.props[eventOptions.handler]);
      const rootHandler = this.props[eventOptions.handler];
      let handled = false;
      if (layerHandler) {
        handled = layerHandler.call(layer, info, event);
      }
      if (!handled) {
        rootHandler == null ? void 0 : rootHandler(info, event);
        this.widgetManager.onEvent(info, event);
      }
    };
    this._onPointerDown = (event) => {
      const pos = event.offsetCenter;
      const pickedInfo = this._pick("pickObject", "pickObject Time", {
        x: pos.x,
        y: pos.y,
        radius: this.props.pickingRadius
      });
      this._lastPointerDownInfo = pickedInfo.result[0] || pickedInfo.emptyInfo;
    };
    this.props = { ...defaultProps$p, ...props };
    props = this.props;
    if (props.viewState && props.initialViewState) {
      log$1.warn("View state tracking is disabled. Use either `initialViewState` for auto update or `viewState` for manual update.")();
    }
    this.viewState = this.props.initialViewState;
    if (props.device) {
      this.device = props.device;
    } else if (props.gl) {
      if (props.gl instanceof WebGLRenderingContext) {
        log$1.error("WebGL1 context not supported.")();
      }
      this.device = WebGLDevice.attach(props.gl);
    }
    let deviceOrPromise = this.device;
    if (!deviceOrPromise) {
      luma.registerDevices([WebGLDevice]);
      deviceOrPromise = luma.createDevice({
        ...props.deviceProps,
        canvas: this._createCanvas(props)
      });
    }
    this.animationLoop = this._createAnimationLoop(deviceOrPromise, props);
    this.setProps(props);
    if (props._typedArrayManagerProps) {
      defaultTypedArrayManager.setOptions(props._typedArrayManagerProps);
    }
    this.animationLoop.start();
  }
  /** Stop rendering and dispose all resources */
  finalize() {
    var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h, _i, _j;
    (_a3 = this.animationLoop) == null ? void 0 : _a3.stop();
    (_b3 = this.animationLoop) == null ? void 0 : _b3.destroy();
    this.animationLoop = null;
    this._lastPointerDownInfo = null;
    (_c2 = this.layerManager) == null ? void 0 : _c2.finalize();
    this.layerManager = null;
    (_d2 = this.viewManager) == null ? void 0 : _d2.finalize();
    this.viewManager = null;
    (_e2 = this.effectManager) == null ? void 0 : _e2.finalize();
    this.effectManager = null;
    (_f3 = this.deckRenderer) == null ? void 0 : _f3.finalize();
    this.deckRenderer = null;
    (_g = this.deckPicker) == null ? void 0 : _g.finalize();
    this.deckPicker = null;
    (_h = this.eventManager) == null ? void 0 : _h.destroy();
    this.eventManager = null;
    (_i = this.widgetManager) == null ? void 0 : _i.finalize();
    this.widgetManager = null;
    if (!this.props.canvas && !this.props.device && !this.props.gl && this.canvas) {
      (_j = this.canvas.parentElement) == null ? void 0 : _j.removeChild(this.canvas);
      this.canvas = null;
    }
  }
  /** Partially update props */
  setProps(props) {
    var _a3;
    this.stats.get("setProps Time").timeStart();
    if ("onLayerHover" in props) {
      log$1.removed("onLayerHover", "onHover")();
    }
    if ("onLayerClick" in props) {
      log$1.removed("onLayerClick", "onClick")();
    }
    if (props.initialViewState && // depth = 3 when comparing viewStates: viewId.position.0
    !deepEqual(this.props.initialViewState, props.initialViewState, 3)) {
      this.viewState = props.initialViewState;
    }
    Object.assign(this.props, props);
    this._setCanvasSize(this.props);
    const resolvedProps = Object.create(this.props);
    Object.assign(resolvedProps, {
      views: this._getViews(),
      width: this.width,
      height: this.height,
      viewState: this._getViewState()
    });
    (_a3 = this.animationLoop) == null ? void 0 : _a3.setProps(resolvedProps);
    if (this.layerManager) {
      this.viewManager.setProps(resolvedProps);
      this.layerManager.activateViewport(this.getViewports()[0]);
      this.layerManager.setProps(resolvedProps);
      this.effectManager.setProps(resolvedProps);
      this.deckRenderer.setProps(resolvedProps);
      this.deckPicker.setProps(resolvedProps);
      this.widgetManager.setProps(resolvedProps);
    }
    this.stats.get("setProps Time").timeEnd();
  }
  // Public API
  /**
   * Check if a redraw is needed
   * @returns `false` or a string summarizing the redraw reason
   */
  needsRedraw(opts = { clearRedrawFlags: false }) {
    if (!this.layerManager) {
      return false;
    }
    if (this.props._animate) {
      return "Deck._animate";
    }
    let redraw = this._needsRedraw;
    if (opts.clearRedrawFlags) {
      this._needsRedraw = false;
    }
    const viewManagerNeedsRedraw = this.viewManager.needsRedraw(opts);
    const layerManagerNeedsRedraw = this.layerManager.needsRedraw(opts);
    const effectManagerNeedsRedraw = this.effectManager.needsRedraw(opts);
    const deckRendererNeedsRedraw = this.deckRenderer.needsRedraw(opts);
    redraw = redraw || viewManagerNeedsRedraw || layerManagerNeedsRedraw || effectManagerNeedsRedraw || deckRendererNeedsRedraw;
    return redraw;
  }
  /**
   * Redraw the GL context
   * @param reason If not provided, only redraw if deemed necessary. Otherwise redraw regardless of internal states.
   * @returns
   */
  redraw(reason) {
    if (!this.layerManager) {
      return;
    }
    let redrawReason = this.needsRedraw({ clearRedrawFlags: true });
    redrawReason = reason || redrawReason;
    if (!redrawReason) {
      return;
    }
    this.stats.get("Redraw Count").incrementCount();
    if (this.props._customRender) {
      this.props._customRender(redrawReason);
    } else {
      this._drawLayers(redrawReason);
    }
  }
  /** Flag indicating that the Deck instance has initialized its resources and it's safe to call public methods. */
  get isInitialized() {
    return this.viewManager !== null;
  }
  /** Get a list of views that are currently rendered */
  getViews() {
    assert$7(this.viewManager);
    return this.viewManager.views;
  }
  /** Get a list of viewports that are currently rendered.
   * @param rect If provided, only returns viewports within the given bounding box.
   */
  getViewports(rect) {
    assert$7(this.viewManager);
    return this.viewManager.getViewports(rect);
  }
  /** Get the current canvas element. */
  getCanvas() {
    return this.canvas;
  }
  /** Query the object rendered on top at a given point */
  pickObject(opts) {
    const infos = this._pick("pickObject", "pickObject Time", opts).result;
    return infos.length ? infos[0] : null;
  }
  /* Query all rendered objects at a given point */
  pickMultipleObjects(opts) {
    opts.depth = opts.depth || 10;
    return this._pick("pickObject", "pickMultipleObjects Time", opts).result;
  }
  /* Query all objects rendered on top within a bounding box */
  pickObjects(opts) {
    return this._pick("pickObjects", "pickObjects Time", opts);
  }
  /** Experimental
   * Add a global resource for sharing among layers
   */
  _addResources(resources, forceUpdate = false) {
    for (const id in resources) {
      this.layerManager.resourceManager.add({ resourceId: id, data: resources[id], forceUpdate });
    }
  }
  /** Experimental
   * Remove a global resource
   */
  _removeResources(resourceIds) {
    for (const id of resourceIds) {
      this.layerManager.resourceManager.remove(id);
    }
  }
  /** Experimental
   * Register a default effect. Effects will be sorted by order, those with a low order will be rendered first
   */
  _addDefaultEffect(effect) {
    this.effectManager.addDefaultEffect(effect);
  }
  _addDefaultShaderModule(module2) {
    this.layerManager.addDefaultShaderModule(module2);
  }
  _removeDefaultShaderModule(module2) {
    var _a3;
    (_a3 = this.layerManager) == null ? void 0 : _a3.removeDefaultShaderModule(module2);
  }
  _pick(method, statKey, opts) {
    assert$7(this.deckPicker);
    const { stats } = this;
    stats.get("Pick Count").incrementCount();
    stats.get(statKey).timeStart();
    const infos = this.deckPicker[method]({
      // layerManager, viewManager and effectManager are always defined if deckPicker is
      layers: this.layerManager.getLayers(opts),
      views: this.viewManager.getViews(),
      viewports: this.getViewports(opts),
      onViewportActive: this.layerManager.activateViewport,
      effects: this.effectManager.getEffects(),
      ...opts
    });
    stats.get(statKey).timeEnd();
    return infos;
  }
  /** Resolve props.canvas to element */
  _createCanvas(props) {
    let canvas2 = props.canvas;
    if (typeof canvas2 === "string") {
      canvas2 = document.getElementById(canvas2);
      assert$7(canvas2);
    }
    if (!canvas2) {
      canvas2 = document.createElement("canvas");
      canvas2.id = props.id || "deckgl-overlay";
      const parent = props.parent || document.body;
      parent.appendChild(canvas2);
    }
    Object.assign(canvas2.style, props.style);
    return canvas2;
  }
  /** Updates canvas width and/or height, if provided as props */
  _setCanvasSize(props) {
    var _a3;
    if (!this.canvas) {
      return;
    }
    const { width, height } = props;
    if (width || width === 0) {
      const cssWidth = Number.isFinite(width) ? `${width}px` : width;
      this.canvas.style.width = cssWidth;
    }
    if (height || height === 0) {
      const cssHeight = Number.isFinite(height) ? `${height}px` : height;
      this.canvas.style.position = ((_a3 = props.style) == null ? void 0 : _a3.position) || "absolute";
      this.canvas.style.height = cssHeight;
    }
  }
  /** If canvas size has changed, reads out the new size and update */
  _updateCanvasSize() {
    var _a3, _b3;
    const { canvas: canvas2 } = this;
    if (!canvas2) {
      return;
    }
    const newWidth = canvas2.clientWidth ?? canvas2.width;
    const newHeight = canvas2.clientHeight ?? canvas2.height;
    if (newWidth !== this.width || newHeight !== this.height) {
      this.width = newWidth;
      this.height = newHeight;
      (_a3 = this.viewManager) == null ? void 0 : _a3.setProps({ width: newWidth, height: newHeight });
      (_b3 = this.layerManager) == null ? void 0 : _b3.activateViewport(this.getViewports()[0]);
      this.props.onResize({ width: newWidth, height: newHeight });
    }
  }
  _createAnimationLoop(deviceOrPromise, props) {
    const {
      // width,
      // height,
      gl,
      // deviceProps,
      // glOptions,
      // debug,
      onError,
      // onBeforeRender,
      // onAfterRender,
      useDevicePixels
    } = props;
    return new AnimationLoop({
      device: deviceOrPromise,
      useDevicePixels,
      // TODO v9
      autoResizeDrawingBuffer: !gl,
      // do not auto resize external context
      autoResizeViewport: false,
      // @ts-expect-error luma.gl needs to accept Promise<void> return value
      onInitialize: (context2) => this._setDevice(context2.device),
      onRender: this._onRenderFrame.bind(this),
      // @ts-expect-error typing mismatch: AnimationLoop does not accept onError:null
      onError
      // onBeforeRender,
      // onAfterRender,
    });
  }
  // Get the most relevant view state: props.viewState, if supplied, shadows internal viewState
  // TODO: For backwards compatibility ensure numeric width and height is added to the viewState
  _getViewState() {
    return this.props.viewState || this.viewState;
  }
  // Get the view descriptor list
  _getViews() {
    const { views } = this.props;
    const normalizedViews = Array.isArray(views) ? views : (
      // If null, default to a full screen map view port
      views ? [views] : [new MapView({ id: "default-view" })]
    );
    if (normalizedViews.length && this.props.controller) {
      normalizedViews[0].props.controller = this.props.controller;
    }
    return normalizedViews;
  }
  _onContextLost() {
    const { onError } = this.props;
    if (this.animationLoop && onError) {
      onError(new Error("WebGL context is lost"));
    }
  }
  /** Actually run picking */
  _pickAndCallback() {
    var _a3, _b3, _c2;
    const { _pickRequest } = this;
    if (_pickRequest.event) {
      const { result, emptyInfo } = this._pick("pickObject", "pickObject Time", _pickRequest);
      this.cursorState.isHovering = result.length > 0;
      let pickedInfo = emptyInfo;
      let handled = false;
      for (const info of result) {
        pickedInfo = info;
        handled = ((_a3 = info.layer) == null ? void 0 : _a3.onHover(info, _pickRequest.event)) || handled;
      }
      if (!handled) {
        (_c2 = (_b3 = this.props).onHover) == null ? void 0 : _c2.call(_b3, pickedInfo, _pickRequest.event);
        this.widgetManager.onHover(pickedInfo, _pickRequest.event);
      }
      _pickRequest.event = null;
    }
  }
  _updateCursor() {
    const container = this.props.parent || this.canvas;
    if (container) {
      container.style.cursor = this.props.getCursor(this.cursorState);
    }
  }
  _setDevice(device) {
    var _a3, _b3;
    this.device = device;
    if (!this.animationLoop) {
      return;
    }
    if (!this.canvas) {
      this.canvas = (_a3 = this.device.canvasContext) == null ? void 0 : _a3.canvas;
    }
    this.device.setParametersWebGL({
      blend: true,
      blendFunc: [770, 771, 1, 771],
      polygonOffsetFill: true,
      depthTest: true,
      depthFunc: 515
    });
    this.props.onDeviceInitialized(this.device);
    if (this.device instanceof WebGLDevice) {
      this.props.onWebGLInitialized(this.device.gl);
    }
    const timeline = new Timeline();
    timeline.play();
    this.animationLoop.attachTimeline(timeline);
    this.eventManager = new EventManager(this.props.parent || this.canvas, {
      touchAction: this.props.touchAction,
      recognizerOptions: this.props.eventRecognizerOptions,
      events: {
        pointerdown: this._onPointerDown,
        pointermove: this._onPointerMove,
        pointerleave: this._onPointerMove
      }
    });
    for (const eventType in EVENTS$1) {
      this.eventManager.on(eventType, this._onEvent);
    }
    this.viewManager = new ViewManager({
      timeline,
      eventManager: this.eventManager,
      onViewStateChange: this._onViewStateChange.bind(this),
      onInteractionStateChange: this._onInteractionStateChange.bind(this),
      views: this._getViews(),
      viewState: this._getViewState(),
      width: this.width,
      height: this.height
    });
    const viewport = this.viewManager.getViewports()[0];
    this.layerManager = new LayerManager(this.device, {
      deck: this,
      stats: this.stats,
      viewport,
      timeline
    });
    this.effectManager = new EffectManager({
      deck: this,
      device: this.device
    });
    this.deckRenderer = new DeckRenderer(this.device);
    this.deckPicker = new DeckPicker(this.device);
    this.widgetManager = new WidgetManager({
      deck: this,
      parentElement: (_b3 = this.canvas) == null ? void 0 : _b3.parentElement
    });
    this.widgetManager.addDefault(new Tooltip());
    this.setProps(this.props);
    this._updateCanvasSize();
    this.props.onLoad();
  }
  /** Internal only: default render function (redraw all layers and views) */
  _drawLayers(redrawReason, renderOptions) {
    var _a3;
    const { device, gl } = this.layerManager.context;
    this.props.onBeforeRender({ device, gl });
    const opts = {
      target: this.props._framebuffer,
      layers: this.layerManager.getLayers(),
      viewports: this.viewManager.getViewports(),
      onViewportActive: this.layerManager.activateViewport,
      views: this.viewManager.getViews(),
      pass: "screen",
      effects: this.effectManager.getEffects(),
      ...renderOptions
    };
    (_a3 = this.deckRenderer) == null ? void 0 : _a3.renderLayers(opts);
    if (opts.pass === "screen") {
      this.widgetManager.onRedraw({
        viewports: opts.viewports,
        layers: opts.layers
      });
    }
    this.props.onAfterRender({ device, gl });
  }
  // Callbacks
  _onRenderFrame() {
    this._getFrameStats();
    if (this._metricsCounter++ % 60 === 0) {
      this._getMetrics();
      this.stats.reset();
      log$1.table(4, this.metrics)();
      if (this.props._onMetrics) {
        this.props._onMetrics(this.metrics);
      }
    }
    this._updateCanvasSize();
    this._updateCursor();
    this.layerManager.updateLayers();
    this._pickAndCallback();
    this.redraw();
    if (this.viewManager) {
      this.viewManager.updateViewStates();
    }
  }
  // Callbacks
  _onViewStateChange(params2) {
    const viewState = this.props.onViewStateChange(params2) || params2.viewState;
    if (this.viewState) {
      this.viewState = { ...this.viewState, [params2.viewId]: viewState };
      if (!this.props.viewState) {
        if (this.viewManager) {
          this.viewManager.setProps({ viewState: this.viewState });
        }
      }
    }
  }
  _onInteractionStateChange(interactionState) {
    this.cursorState.isDragging = interactionState.isDragging || false;
    this.props.onInteractionStateChange(interactionState);
  }
  _getFrameStats() {
    const { stats } = this;
    stats.get("frameRate").timeEnd();
    stats.get("frameRate").timeStart();
    const animationLoopStats = this.animationLoop.stats;
    stats.get("GPU Time").addTime(animationLoopStats.get("GPU Time").lastTiming);
    stats.get("CPU Time").addTime(animationLoopStats.get("CPU Time").lastTiming);
  }
  _getMetrics() {
    const { metrics, stats } = this;
    metrics.fps = stats.get("frameRate").getHz();
    metrics.setPropsTime = stats.get("setProps Time").time;
    metrics.updateAttributesTime = stats.get("Update Attributes").time;
    metrics.framesRedrawn = stats.get("Redraw Count").count;
    metrics.pickTime = stats.get("pickObject Time").time + stats.get("pickMultipleObjects Time").time + stats.get("pickObjects Time").time;
    metrics.pickCount = stats.get("Pick Count").count;
    metrics.gpuTime = stats.get("GPU Time").time;
    metrics.cpuTime = stats.get("CPU Time").time;
    metrics.gpuTimePerFrame = stats.get("GPU Time").getAverageTime();
    metrics.cpuTimePerFrame = stats.get("CPU Time").getAverageTime();
    const memoryStats = luma.stats.get("Memory Usage");
    metrics.bufferMemory = memoryStats.get("Buffer Memory").count;
    metrics.textureMemory = memoryStats.get("Texture Memory").count;
    metrics.renderbufferMemory = memoryStats.get("Renderbuffer Memory").count;
    metrics.gpuMemory = memoryStats.get("GPU Memory").count;
  }
};
let Deck = _Deck;
(() => {
  _Deck.defaultProps = defaultProps$p;
})();
// This is used to defeat tree shaking of init.js
// https://github.com/visgl/deck.gl/issues/3213
(() => {
  _Deck.VERSION = VERSION$c;
})();
function typedArrayFromDataType(type) {
  switch (type) {
    case "float64":
      return Float64Array;
    case "uint8":
    case "unorm8":
      return Uint8ClampedArray;
    default:
      return getTypedArrayFromDataType(type);
  }
}
const dataTypeFromTypedArray = getDataTypeFromTypedArray$1;
function getBufferAttributeLayout(name2, accessor) {
  return {
    attribute: name2,
    // @ts-expect-error Not all combinations are valid vertex formats; it's up to DataColumn to ensure
    format: accessor.size > 1 ? `${accessor.type}x${accessor.size}` : accessor.type,
    byteOffset: accessor.offset || 0
    // Note stride is set on the top level
  };
}
function getStride(accessor) {
  return accessor.stride || accessor.size * accessor.bytesPerElement;
}
function bufferLayoutEqual(accessor1, accessor2) {
  return accessor1.type === accessor2.type && accessor1.size === accessor2.size && getStride(accessor1) === getStride(accessor2) && (accessor1.offset || 0) === (accessor2.offset || 0);
}
function resolveShaderAttribute(baseAccessor, shaderAttributeOptions) {
  if (shaderAttributeOptions.offset) {
    log$1.removed("shaderAttribute.offset", "vertexOffset, elementOffset")();
  }
  const stride = getStride(baseAccessor);
  const vertexOffset = shaderAttributeOptions.vertexOffset !== void 0 ? shaderAttributeOptions.vertexOffset : baseAccessor.vertexOffset || 0;
  const elementOffset = shaderAttributeOptions.elementOffset || 0;
  const offset = (
    // offsets defined by the attribute
    vertexOffset * stride + elementOffset * baseAccessor.bytesPerElement + // offsets defined by external buffers if any
    (baseAccessor.offset || 0)
  );
  return {
    ...shaderAttributeOptions,
    offset,
    stride
  };
}
function resolveDoublePrecisionShaderAttributes(baseAccessor, shaderAttributeOptions) {
  const resolvedOptions = resolveShaderAttribute(baseAccessor, shaderAttributeOptions);
  return {
    high: resolvedOptions,
    low: {
      ...resolvedOptions,
      offset: resolvedOptions.offset + baseAccessor.size * 4
    }
  };
}
class DataColumn {
  /* eslint-disable max-statements */
  constructor(device, opts, state) {
    this._buffer = null;
    this.device = device;
    this.id = opts.id || "";
    this.size = opts.size || 1;
    const logicalType = opts.logicalType || opts.type;
    const doublePrecision = logicalType === "float64";
    let { defaultValue: defaultValue2 } = opts;
    defaultValue2 = Number.isFinite(defaultValue2) ? [defaultValue2] : defaultValue2 || new Array(this.size).fill(0);
    let bufferType;
    if (doublePrecision) {
      bufferType = "float32";
    } else if (!logicalType && opts.isIndexed) {
      bufferType = "uint32";
    } else {
      bufferType = logicalType || "float32";
    }
    let defaultType = typedArrayFromDataType(logicalType || bufferType);
    this.doublePrecision = doublePrecision;
    if (doublePrecision && opts.fp64 === false) {
      defaultType = Float32Array;
    }
    this.value = null;
    this.settings = {
      ...opts,
      defaultType,
      defaultValue: defaultValue2,
      logicalType,
      type: bufferType,
      normalized: bufferType.includes("norm"),
      size: this.size,
      bytesPerElement: defaultType.BYTES_PER_ELEMENT
    };
    this.state = {
      ...state,
      externalBuffer: null,
      bufferAccessor: this.settings,
      allocatedValue: null,
      numInstances: 0,
      bounds: null,
      constant: false
    };
  }
  /* eslint-enable max-statements */
  get isConstant() {
    return this.state.constant;
  }
  get buffer() {
    return this._buffer;
  }
  get byteOffset() {
    const accessor = this.getAccessor();
    if (accessor.vertexOffset) {
      return accessor.vertexOffset * getStride(accessor);
    }
    return 0;
  }
  get numInstances() {
    return this.state.numInstances;
  }
  set numInstances(n2) {
    this.state.numInstances = n2;
  }
  delete() {
    if (this._buffer) {
      this._buffer.delete();
      this._buffer = null;
    }
    defaultTypedArrayManager.release(this.state.allocatedValue);
  }
  getBuffer() {
    if (this.state.constant) {
      return null;
    }
    return this.state.externalBuffer || this._buffer;
  }
  getValue(attributeName = this.id, options2 = null) {
    const result = {};
    if (this.state.constant) {
      const value = this.value;
      if (options2) {
        const shaderAttributeDef = resolveShaderAttribute(this.getAccessor(), options2);
        const offset = shaderAttributeDef.offset / value.BYTES_PER_ELEMENT;
        const size12 = shaderAttributeDef.size || this.size;
        result[attributeName] = value.subarray(offset, offset + size12);
      } else {
        result[attributeName] = value;
      }
    } else {
      result[attributeName] = this.getBuffer();
    }
    if (this.doublePrecision) {
      if (this.value instanceof Float64Array) {
        result[`${attributeName}64Low`] = result[attributeName];
      } else {
        result[`${attributeName}64Low`] = new Float32Array(this.size);
      }
    }
    return result;
  }
  _getBufferLayout(attributeName = this.id, options2 = null) {
    const accessor = this.getAccessor();
    const attributes = [];
    const result = {
      name: this.id,
      byteStride: getStride(accessor),
      attributes
    };
    if (this.doublePrecision) {
      const doubleShaderAttributeDefs = resolveDoublePrecisionShaderAttributes(accessor, options2 || {});
      attributes.push(getBufferAttributeLayout(attributeName, { ...accessor, ...doubleShaderAttributeDefs.high }), getBufferAttributeLayout(`${attributeName}64Low`, {
        ...accessor,
        ...doubleShaderAttributeDefs.low
      }));
    } else if (options2) {
      const shaderAttributeDef = resolveShaderAttribute(accessor, options2);
      attributes.push(getBufferAttributeLayout(attributeName, { ...accessor, ...shaderAttributeDef }));
    } else {
      attributes.push(getBufferAttributeLayout(attributeName, accessor));
    }
    return result;
  }
  setAccessor(accessor) {
    this.state.bufferAccessor = accessor;
  }
  getAccessor() {
    return this.state.bufferAccessor;
  }
  // Returns [min: Array(size), max: Array(size)]
  /* eslint-disable max-depth */
  getBounds() {
    if (this.state.bounds) {
      return this.state.bounds;
    }
    let result = null;
    if (this.state.constant && this.value) {
      const min4 = Array.from(this.value);
      result = [min4, min4];
    } else {
      const { value, numInstances, size: size12 } = this;
      const len2 = numInstances * size12;
      if (value && len2 && value.length >= len2) {
        const min4 = new Array(size12).fill(Infinity);
        const max3 = new Array(size12).fill(-Infinity);
        for (let i2 = 0; i2 < len2; ) {
          for (let j2 = 0; j2 < size12; j2++) {
            const v5 = value[i2++];
            if (v5 < min4[j2])
              min4[j2] = v5;
            if (v5 > max3[j2])
              max3[j2] = v5;
          }
        }
        result = [min4, max3];
      }
    }
    this.state.bounds = result;
    return result;
  }
  // returns true if success
  // eslint-disable-next-line max-statements
  setData(data2) {
    const { state } = this;
    let opts;
    if (ArrayBuffer.isView(data2)) {
      opts = { value: data2 };
    } else if (data2 instanceof Buffer$1) {
      opts = { buffer: data2 };
    } else {
      opts = data2;
    }
    const accessor = { ...this.settings, ...opts };
    if (ArrayBuffer.isView(opts.value)) {
      if (!opts.type) {
        const is64Bit = this.doublePrecision && opts.value instanceof Float64Array;
        if (is64Bit) {
          accessor.type = "float32";
        } else {
          const type = dataTypeFromTypedArray(opts.value);
          accessor.type = accessor.normalized ? type.replace("int", "norm") : type;
        }
      }
      accessor.bytesPerElement = opts.value.BYTES_PER_ELEMENT;
      accessor.stride = getStride(accessor);
    }
    state.bounds = null;
    if (opts.constant) {
      let value = opts.value;
      value = this._normalizeValue(value, [], 0);
      if (this.settings.normalized) {
        value = this.normalizeConstant(value);
      }
      const hasChanged = !state.constant || !this._areValuesEqual(value, this.value);
      if (!hasChanged) {
        return false;
      }
      state.externalBuffer = null;
      state.constant = true;
      this.value = ArrayBuffer.isView(value) ? value : new Float32Array(value);
    } else if (opts.buffer) {
      const buffer3 = opts.buffer;
      state.externalBuffer = buffer3;
      state.constant = false;
      this.value = opts.value || null;
    } else if (opts.value) {
      this._checkExternalBuffer(opts);
      let value = opts.value;
      state.externalBuffer = null;
      state.constant = false;
      this.value = value;
      let { buffer: buffer3 } = this;
      const stride = getStride(accessor);
      const byteOffset = (accessor.vertexOffset || 0) * stride;
      if (this.doublePrecision && value instanceof Float64Array) {
        value = toDoublePrecisionArray(value, accessor);
      }
      if (this.settings.isIndexed) {
        const ArrayType2 = this.settings.defaultType;
        if (value.constructor !== ArrayType2) {
          value = new ArrayType2(value);
        }
      }
      const requiredBufferSize = value.byteLength + byteOffset + stride * 2;
      if (!buffer3 || buffer3.byteLength < requiredBufferSize) {
        buffer3 = this._createBuffer(requiredBufferSize);
      }
      buffer3.write(value, byteOffset);
    }
    this.setAccessor(accessor);
    return true;
  }
  updateSubBuffer(opts = {}) {
    this.state.bounds = null;
    const value = this.value;
    const { startOffset = 0, endOffset } = opts;
    this.buffer.write(this.doublePrecision && value instanceof Float64Array ? toDoublePrecisionArray(value, {
      size: this.size,
      startIndex: startOffset,
      endIndex: endOffset
    }) : value.subarray(startOffset, endOffset), startOffset * value.BYTES_PER_ELEMENT + this.byteOffset);
  }
  allocate(numInstances, copy8 = false) {
    const { state } = this;
    const oldValue = state.allocatedValue;
    const value = defaultTypedArrayManager.allocate(oldValue, numInstances + 1, {
      size: this.size,
      type: this.settings.defaultType,
      copy: copy8
    });
    this.value = value;
    const { byteOffset } = this;
    let { buffer: buffer3 } = this;
    if (!buffer3 || buffer3.byteLength < value.byteLength + byteOffset) {
      buffer3 = this._createBuffer(value.byteLength + byteOffset);
      if (copy8 && oldValue) {
        buffer3.write(oldValue instanceof Float64Array ? toDoublePrecisionArray(oldValue, this) : oldValue, byteOffset);
      }
    }
    state.allocatedValue = value;
    state.constant = false;
    state.externalBuffer = null;
    this.setAccessor(this.settings);
    return true;
  }
  // PRIVATE HELPER METHODS
  _checkExternalBuffer(opts) {
    const { value } = opts;
    if (!ArrayBuffer.isView(value)) {
      throw new Error(`Attribute ${this.id} value is not TypedArray`);
    }
    const ArrayType2 = this.settings.defaultType;
    let illegalArrayType = false;
    if (this.doublePrecision) {
      illegalArrayType = value.BYTES_PER_ELEMENT < 4;
    }
    if (illegalArrayType) {
      throw new Error(`Attribute ${this.id} does not support ${value.constructor.name}`);
    }
    if (!(value instanceof ArrayType2) && this.settings.normalized && !("normalized" in opts)) {
      log$1.warn(`Attribute ${this.id} is normalized`)();
    }
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
  normalizeConstant(value) {
    switch (this.settings.type) {
      case "snorm8":
        return new Float32Array(value).map((x2) => (x2 + 128) / 255 * 2 - 1);
      case "snorm16":
        return new Float32Array(value).map((x2) => (x2 + 32768) / 65535 * 2 - 1);
      case "unorm8":
        return new Float32Array(value).map((x2) => x2 / 255);
      case "unorm16":
        return new Float32Array(value).map((x2) => x2 / 65535);
      default:
        return value;
    }
  }
  /* check user supplied values and apply fallback */
  _normalizeValue(value, out, start2) {
    const { defaultValue: defaultValue2, size: size12 } = this.settings;
    if (Number.isFinite(value)) {
      out[start2] = value;
      return out;
    }
    if (!value) {
      let i2 = size12;
      while (--i2 >= 0) {
        out[start2 + i2] = defaultValue2[i2];
      }
      return out;
    }
    switch (size12) {
      case 4:
        out[start2 + 3] = Number.isFinite(value[3]) ? value[3] : defaultValue2[3];
      case 3:
        out[start2 + 2] = Number.isFinite(value[2]) ? value[2] : defaultValue2[2];
      case 2:
        out[start2 + 1] = Number.isFinite(value[1]) ? value[1] : defaultValue2[1];
      case 1:
        out[start2 + 0] = Number.isFinite(value[0]) ? value[0] : defaultValue2[0];
        break;
      default:
        let i2 = size12;
        while (--i2 >= 0) {
          out[start2 + i2] = Number.isFinite(value[i2]) ? value[i2] : defaultValue2[i2];
        }
    }
    return out;
  }
  _areValuesEqual(value1, value2) {
    if (!value1 || !value2) {
      return false;
    }
    const { size: size12 } = this;
    for (let i2 = 0; i2 < size12; i2++) {
      if (value1[i2] !== value2[i2]) {
        return false;
      }
    }
    return true;
  }
  _createBuffer(byteLength) {
    var _a3;
    if (this._buffer) {
      this._buffer.destroy();
    }
    const { isIndexed, type } = this.settings;
    this._buffer = this.device.createBuffer({
      ...(_a3 = this._buffer) == null ? void 0 : _a3.props,
      id: this.id,
      usage: isIndexed ? Buffer$1.INDEX : Buffer$1.VERTEX,
      indexType: isIndexed ? type : void 0,
      byteLength
    });
    return this._buffer;
  }
}
const EMPTY_ARRAY$2 = [];
const placeholderArray = [];
function createIterable(data2, startRow = 0, endRow = Infinity) {
  let iterable = EMPTY_ARRAY$2;
  const objectInfo = {
    index: -1,
    data: data2,
    // visitor can optionally utilize this to avoid constructing a new array for every object
    target: []
  };
  if (!data2) {
    iterable = EMPTY_ARRAY$2;
  } else if (typeof data2[Symbol.iterator] === "function") {
    iterable = data2;
  } else if (data2.length > 0) {
    placeholderArray.length = data2.length;
    iterable = placeholderArray;
  }
  if (startRow > 0 || Number.isFinite(endRow)) {
    iterable = (Array.isArray(iterable) ? iterable : Array.from(iterable)).slice(startRow, endRow);
    objectInfo.index = startRow - 1;
  }
  return { iterable, objectInfo };
}
function isAsyncIterable(data2) {
  return data2 && data2[Symbol.asyncIterator];
}
function getAccessorFromBuffer(typedArray, options2) {
  const { size: size12, stride, offset, startIndices, nested } = options2;
  const bytesPerElement = typedArray.BYTES_PER_ELEMENT;
  const elementStride = stride ? stride / bytesPerElement : size12;
  const elementOffset = offset ? offset / bytesPerElement : 0;
  const vertexCount = Math.floor((typedArray.length - elementOffset) / elementStride);
  return (_2, { index: index2, target }) => {
    if (!startIndices) {
      const sourceIndex = index2 * elementStride + elementOffset;
      for (let j2 = 0; j2 < size12; j2++) {
        target[j2] = typedArray[sourceIndex + j2];
      }
      return target;
    }
    const startIndex = startIndices[index2];
    const endIndex = startIndices[index2 + 1] || vertexCount;
    let result;
    if (nested) {
      result = new Array(endIndex - startIndex);
      for (let i2 = startIndex; i2 < endIndex; i2++) {
        const sourceIndex = i2 * elementStride + elementOffset;
        target = new Array(size12);
        for (let j2 = 0; j2 < size12; j2++) {
          target[j2] = typedArray[sourceIndex + j2];
        }
        result[i2 - startIndex] = target;
      }
    } else if (elementStride === size12) {
      result = typedArray.subarray(startIndex * size12 + elementOffset, endIndex * size12 + elementOffset);
    } else {
      result = new typedArray.constructor((endIndex - startIndex) * size12);
      let targetIndex = 0;
      for (let i2 = startIndex; i2 < endIndex; i2++) {
        const sourceIndex = i2 * elementStride + elementOffset;
        for (let j2 = 0; j2 < size12; j2++) {
          result[targetIndex++] = typedArray[sourceIndex + j2];
        }
      }
    }
    return result;
  };
}
const EMPTY = [];
const FULL = [[0, Infinity]];
function add(rangeList, range2) {
  if (rangeList === FULL) {
    return rangeList;
  }
  if (range2[0] < 0) {
    range2[0] = 0;
  }
  if (range2[0] >= range2[1]) {
    return rangeList;
  }
  const newRangeList = [];
  const len2 = rangeList.length;
  let insertPosition = 0;
  for (let i2 = 0; i2 < len2; i2++) {
    const range0 = rangeList[i2];
    if (range0[1] < range2[0]) {
      newRangeList.push(range0);
      insertPosition = i2 + 1;
    } else if (range0[0] > range2[1]) {
      newRangeList.push(range0);
    } else {
      range2 = [Math.min(range0[0], range2[0]), Math.max(range0[1], range2[1])];
    }
  }
  newRangeList.splice(insertPosition, 0, range2);
  return newRangeList;
}
const DEFAULT_TRANSITION_SETTINGS = {
  interpolation: {
    duration: 0,
    easing: (t2) => t2
  },
  spring: {
    stiffness: 0.05,
    damping: 0.5
  }
};
function normalizeTransitionSettings(userSettings, layerSettings) {
  if (!userSettings) {
    return null;
  }
  if (Number.isFinite(userSettings)) {
    userSettings = { type: "interpolation", duration: userSettings };
  }
  const type = userSettings.type || "interpolation";
  return {
    ...DEFAULT_TRANSITION_SETTINGS[type],
    ...layerSettings,
    ...userSettings,
    type
  };
}
class Attribute extends DataColumn {
  constructor(device, opts) {
    super(device, opts, {
      startIndices: null,
      lastExternalBuffer: null,
      binaryValue: null,
      binaryAccessor: null,
      needsUpdate: true,
      needsRedraw: false,
      layoutChanged: false,
      updateRanges: FULL
    });
    this.constant = false;
    this.settings.update = opts.update || (opts.accessor ? this._autoUpdater : void 0);
    Object.seal(this.settings);
    Object.seal(this.state);
    this._validateAttributeUpdaters();
  }
  get startIndices() {
    return this.state.startIndices;
  }
  set startIndices(layout) {
    this.state.startIndices = layout;
  }
  needsUpdate() {
    return this.state.needsUpdate;
  }
  needsRedraw({ clearChangedFlags = false } = {}) {
    const needsRedraw = this.state.needsRedraw;
    this.state.needsRedraw = needsRedraw && !clearChangedFlags;
    return needsRedraw;
  }
  layoutChanged() {
    return this.state.layoutChanged;
  }
  setAccessor(accessor) {
    var _a3;
    (_a3 = this.state).layoutChanged || (_a3.layoutChanged = !bufferLayoutEqual(accessor, this.getAccessor()));
    super.setAccessor(accessor);
  }
  getUpdateTriggers() {
    const { accessor } = this.settings;
    return [this.id].concat(typeof accessor !== "function" && accessor || []);
  }
  supportsTransition() {
    return Boolean(this.settings.transition);
  }
  // Resolve transition settings object if transition is enabled, otherwise `null`
  getTransitionSetting(opts) {
    if (!opts || !this.supportsTransition()) {
      return null;
    }
    const { accessor } = this.settings;
    const layerSettings = this.settings.transition;
    const userSettings = Array.isArray(accessor) ? (
      // @ts-ignore
      opts[accessor.find((a2) => opts[a2])]
    ) : (
      // @ts-ignore
      opts[accessor]
    );
    return normalizeTransitionSettings(userSettings, layerSettings);
  }
  setNeedsUpdate(reason = this.id, dataRange) {
    this.state.needsUpdate = this.state.needsUpdate || reason;
    this.setNeedsRedraw(reason);
    if (dataRange) {
      const { startRow = 0, endRow = Infinity } = dataRange;
      this.state.updateRanges = add(this.state.updateRanges, [startRow, endRow]);
    } else {
      this.state.updateRanges = FULL;
    }
  }
  clearNeedsUpdate() {
    this.state.needsUpdate = false;
    this.state.updateRanges = EMPTY;
  }
  setNeedsRedraw(reason = this.id) {
    this.state.needsRedraw = this.state.needsRedraw || reason;
  }
  allocate(numInstances) {
    const { state, settings } = this;
    if (settings.noAlloc) {
      return false;
    }
    if (settings.update) {
      super.allocate(numInstances, state.updateRanges !== FULL);
      return true;
    }
    return false;
  }
  updateBuffer({ numInstances, data: data2, props, context: context2 }) {
    if (!this.needsUpdate()) {
      return false;
    }
    const { state: { updateRanges }, settings: { update, noAlloc } } = this;
    let updated = true;
    if (update) {
      for (const [startRow, endRow] of updateRanges) {
        update.call(context2, this, { data: data2, startRow, endRow, props, numInstances });
      }
      if (!this.value)
        ;
      else if (this.constant || !this.buffer || this.buffer.byteLength < this.value.byteLength + this.byteOffset) {
        this.setData({
          value: this.value,
          constant: this.constant
        });
        this.constant = false;
      } else {
        for (const [startRow, endRow] of updateRanges) {
          const startOffset = Number.isFinite(startRow) ? this.getVertexOffset(startRow) : 0;
          const endOffset = Number.isFinite(endRow) ? this.getVertexOffset(endRow) : noAlloc || !Number.isFinite(numInstances) ? this.value.length : numInstances * this.size;
          super.updateSubBuffer({ startOffset, endOffset });
        }
      }
      this._checkAttributeArray();
    } else {
      updated = false;
    }
    this.clearNeedsUpdate();
    this.setNeedsRedraw();
    return updated;
  }
  // Use generic value
  // Returns true if successful
  setConstantValue(value) {
    if (value === void 0 || typeof value === "function") {
      return false;
    }
    const hasChanged = this.setData({ constant: true, value });
    if (hasChanged) {
      this.setNeedsRedraw();
    }
    this.clearNeedsUpdate();
    return true;
  }
  // Use external buffer
  // Returns true if successful
  // eslint-disable-next-line max-statements
  setExternalBuffer(buffer3) {
    const { state } = this;
    if (!buffer3) {
      state.lastExternalBuffer = null;
      return false;
    }
    this.clearNeedsUpdate();
    if (state.lastExternalBuffer === buffer3) {
      return true;
    }
    state.lastExternalBuffer = buffer3;
    this.setNeedsRedraw();
    this.setData(buffer3);
    return true;
  }
  // Binary value is a typed array packed from mapping the source data with the accessor
  // If the returned value from the accessor is the same as the attribute value, set it directly
  // Otherwise use the auto updater for transform/normalization
  setBinaryValue(buffer3, startIndices = null) {
    const { state, settings } = this;
    if (!buffer3) {
      state.binaryValue = null;
      state.binaryAccessor = null;
      return false;
    }
    if (settings.noAlloc) {
      return false;
    }
    if (state.binaryValue === buffer3) {
      this.clearNeedsUpdate();
      return true;
    }
    state.binaryValue = buffer3;
    this.setNeedsRedraw();
    const needsUpdate = settings.transform || startIndices !== this.startIndices;
    if (needsUpdate) {
      if (ArrayBuffer.isView(buffer3)) {
        buffer3 = { value: buffer3 };
      }
      const binaryValue = buffer3;
      assert$7(ArrayBuffer.isView(binaryValue.value), `invalid ${settings.accessor}`);
      const needsNormalize = Boolean(binaryValue.size) && binaryValue.size !== this.size;
      state.binaryAccessor = getAccessorFromBuffer(binaryValue.value, {
        size: binaryValue.size || this.size,
        stride: binaryValue.stride,
        offset: binaryValue.offset,
        startIndices,
        nested: needsNormalize
      });
      return false;
    }
    this.clearNeedsUpdate();
    this.setData(buffer3);
    return true;
  }
  getVertexOffset(row) {
    const { startIndices } = this;
    const vertexIndex = startIndices ? row < startIndices.length ? startIndices[row] : this.numInstances : row;
    return vertexIndex * this.size;
  }
  getValue() {
    const shaderAttributeDefs = this.settings.shaderAttributes;
    const result = super.getValue();
    if (!shaderAttributeDefs) {
      return result;
    }
    for (const shaderAttributeName in shaderAttributeDefs) {
      Object.assign(result, super.getValue(shaderAttributeName, shaderAttributeDefs[shaderAttributeName]));
    }
    return result;
  }
  /** Generate WebGPU-style buffer layout descriptor from this attribute */
  getBufferLayout(modelInfo) {
    this.state.layoutChanged = false;
    const shaderAttributeDefs = this.settings.shaderAttributes;
    const result = super._getBufferLayout();
    const { stepMode } = this.settings;
    if (stepMode === "dynamic") {
      result.stepMode = modelInfo ? modelInfo.isInstanced ? "instance" : "vertex" : "instance";
    } else {
      result.stepMode = stepMode ?? "vertex";
    }
    if (!shaderAttributeDefs) {
      return result;
    }
    for (const shaderAttributeName in shaderAttributeDefs) {
      const map5 = super._getBufferLayout(shaderAttributeName, shaderAttributeDefs[shaderAttributeName]);
      result.attributes.push(...map5.attributes);
    }
    return result;
  }
  /* eslint-disable max-depth, max-statements */
  _autoUpdater(attribute, { data: data2, startRow, endRow, props, numInstances }) {
    if (attribute.constant) {
      return;
    }
    const { settings, state, value, size: size12, startIndices } = attribute;
    const { accessor, transform: transform4 } = settings;
    const accessorFunc = state.binaryAccessor || // @ts-ignore
    (typeof accessor === "function" ? accessor : props[accessor]);
    assert$7(typeof accessorFunc === "function", `accessor "${accessor}" is not a function`);
    let i2 = attribute.getVertexOffset(startRow);
    const { iterable, objectInfo } = createIterable(data2, startRow, endRow);
    for (const object2 of iterable) {
      objectInfo.index++;
      let objectValue = accessorFunc(object2, objectInfo);
      if (transform4) {
        objectValue = transform4.call(this, objectValue);
      }
      if (startIndices) {
        const numVertices = (objectInfo.index < startIndices.length - 1 ? startIndices[objectInfo.index + 1] : numInstances) - startIndices[objectInfo.index];
        if (objectValue && Array.isArray(objectValue[0])) {
          let startIndex = i2;
          for (const item of objectValue) {
            attribute._normalizeValue(item, value, startIndex);
            startIndex += size12;
          }
        } else if (objectValue && objectValue.length > size12) {
          value.set(objectValue, i2);
        } else {
          attribute._normalizeValue(objectValue, objectInfo.target, 0);
          fillArray({
            target: value,
            source: objectInfo.target,
            start: i2,
            count: numVertices
          });
        }
        i2 += numVertices * size12;
      } else {
        attribute._normalizeValue(objectValue, value, i2);
        i2 += size12;
      }
    }
  }
  /* eslint-enable max-depth, max-statements */
  // Validate deck.gl level fields
  _validateAttributeUpdaters() {
    const { settings } = this;
    const hasUpdater = settings.noAlloc || typeof settings.update === "function";
    if (!hasUpdater) {
      throw new Error(`Attribute ${this.id} missing update or accessor`);
    }
  }
  // check that the first few elements of the attribute are reasonable
  /* eslint-disable no-fallthrough */
  _checkAttributeArray() {
    const { value } = this;
    const limit = Math.min(4, this.size);
    if (value && value.length >= limit) {
      let valid = true;
      switch (limit) {
        case 4:
          valid = valid && Number.isFinite(value[3]);
        case 3:
          valid = valid && Number.isFinite(value[2]);
        case 2:
          valid = valid && Number.isFinite(value[1]);
        case 1:
          valid = valid && Number.isFinite(value[0]);
          break;
        default:
          valid = false;
      }
      if (!valid) {
        throw new Error(`Illegal attribute generated for ${this.id}`);
      }
    }
  }
}
function padArrayChunk(options2) {
  const { source, target, start: start2 = 0, size: size12, getData: getData6 } = options2;
  const end = options2.end || target.length;
  const sourceLength = source.length;
  const targetLength = end - start2;
  if (sourceLength > targetLength) {
    target.set(source.subarray(0, targetLength), start2);
    return;
  }
  target.set(source, start2);
  if (!getData6) {
    return;
  }
  let i2 = sourceLength;
  while (i2 < targetLength) {
    const datum2 = getData6(i2, source);
    for (let j2 = 0; j2 < size12; j2++) {
      target[start2 + i2] = datum2[j2] || 0;
      i2++;
    }
  }
}
function padArray({ source, target, size: size12, getData: getData6, sourceStartIndices, targetStartIndices }) {
  if (!sourceStartIndices || !targetStartIndices) {
    padArrayChunk({
      source,
      target,
      size: size12,
      getData: getData6
    });
    return target;
  }
  let sourceIndex = 0;
  let targetIndex = 0;
  const getChunkData = getData6 && ((i2, chunk) => getData6(i2 + targetIndex, chunk));
  const n2 = Math.min(sourceStartIndices.length, targetStartIndices.length);
  for (let i2 = 1; i2 < n2; i2++) {
    const nextSourceIndex = sourceStartIndices[i2] * size12;
    const nextTargetIndex = targetStartIndices[i2] * size12;
    padArrayChunk({
      source: source.subarray(sourceIndex, nextSourceIndex),
      target,
      start: targetIndex,
      end: nextTargetIndex,
      size: size12,
      getData: getChunkData
    });
    sourceIndex = nextSourceIndex;
    targetIndex = nextTargetIndex;
  }
  if (targetIndex < target.length) {
    padArrayChunk({
      // @ts-ignore
      source: [],
      target,
      start: targetIndex,
      size: size12,
      getData: getChunkData
    });
  }
  return target;
}
function cloneAttribute(attribute) {
  const { device, settings, value } = attribute;
  const newAttribute = new Attribute(device, settings);
  newAttribute.setData({
    value: value instanceof Float64Array ? new Float64Array(0) : new Float32Array(0),
    normalized: settings.normalized
  });
  return newAttribute;
}
function getAttributeTypeFromSize(size12) {
  switch (size12) {
    case 1:
      return "float";
    case 2:
      return "vec2";
    case 3:
      return "vec3";
    case 4:
      return "vec4";
    default:
      throw new Error(`No defined attribute type for size "${size12}"`);
  }
}
function getFloat32VertexFormat(size12) {
  switch (size12) {
    case 1:
      return "float32";
    case 2:
      return "float32x2";
    case 3:
      return "float32x3";
    case 4:
      return "float32x4";
    default:
      throw new Error("invalid type size");
  }
}
function cycleBuffers(buffers) {
  buffers.push(buffers.shift());
}
function getAttributeBufferLength(attribute, numInstances) {
  const { doublePrecision, settings, value, size: size12 } = attribute;
  const multiplier = doublePrecision && value instanceof Float64Array ? 2 : 1;
  let maxVertexOffset = 0;
  const { shaderAttributes } = attribute.settings;
  if (shaderAttributes) {
    for (const shaderAttribute of Object.values(shaderAttributes)) {
      maxVertexOffset = Math.max(maxVertexOffset, shaderAttribute.vertexOffset ?? 0);
    }
  }
  return (settings.noAlloc ? value.length : (numInstances + maxVertexOffset) * size12) * multiplier;
}
function matchBuffer({ device, source, target }) {
  if (!target || target.byteLength < source.byteLength) {
    target == null ? void 0 : target.destroy();
    target = device.createBuffer({
      byteLength: source.byteLength,
      usage: source.usage
    });
  }
  return target;
}
function padBuffer({ device, buffer: buffer3, attribute, fromLength, toLength, fromStartIndices, getData: getData6 = (x2) => x2 }) {
  const precisionMultiplier = attribute.doublePrecision && attribute.value instanceof Float64Array ? 2 : 1;
  const size12 = attribute.size * precisionMultiplier;
  const byteOffset = attribute.byteOffset;
  const targetByteOffset = attribute.settings.bytesPerElement < 4 ? byteOffset / attribute.settings.bytesPerElement * 4 : byteOffset;
  const toStartIndices = attribute.startIndices;
  const hasStartIndices = fromStartIndices && toStartIndices;
  const isConstant = attribute.isConstant;
  if (!hasStartIndices && buffer3 && fromLength >= toLength) {
    return buffer3;
  }
  const ArrayType2 = attribute.value instanceof Float64Array ? Float32Array : attribute.value.constructor;
  const toData = isConstant ? attribute.value : (
    // TODO(v9.1): Avoid non-portable synchronous reads.
    new ArrayType2(attribute.getBuffer().readSyncWebGL(byteOffset, toLength * ArrayType2.BYTES_PER_ELEMENT).buffer)
  );
  if (attribute.settings.normalized && !isConstant) {
    const getter = getData6;
    getData6 = (value, chunk) => attribute.normalizeConstant(getter(value, chunk));
  }
  const getMissingData = isConstant ? (i2, chunk) => getData6(toData, chunk) : (i2, chunk) => getData6(toData.subarray(i2 + byteOffset, i2 + byteOffset + size12), chunk);
  const source = buffer3 ? new Float32Array(buffer3.readSyncWebGL(targetByteOffset, fromLength * 4).buffer) : new Float32Array(0);
  const target = new Float32Array(toLength);
  padArray({
    source,
    target,
    sourceStartIndices: fromStartIndices,
    targetStartIndices: toStartIndices,
    size: size12,
    getData: getMissingData
  });
  if (!buffer3 || buffer3.byteLength < target.byteLength + targetByteOffset) {
    buffer3 == null ? void 0 : buffer3.destroy();
    buffer3 = device.createBuffer({
      byteLength: target.byteLength + targetByteOffset,
      usage: 35050
    });
  }
  buffer3.write(target, targetByteOffset);
  return buffer3;
}
class GPUTransitionBase {
  constructor({ device, attribute, timeline }) {
    this.buffers = [];
    this.currentLength = 0;
    this.device = device;
    this.transition = new Transition(timeline);
    this.attribute = attribute;
    this.attributeInTransition = cloneAttribute(attribute);
    this.currentStartIndices = attribute.startIndices;
  }
  get inProgress() {
    return this.transition.inProgress;
  }
  start(transitionSettings, numInstances, duration = Infinity) {
    this.settings = transitionSettings;
    this.currentStartIndices = this.attribute.startIndices;
    this.currentLength = getAttributeBufferLength(this.attribute, numInstances);
    this.transition.start({ ...transitionSettings, duration });
  }
  update() {
    const updated = this.transition.update();
    if (updated) {
      this.onUpdate();
    }
    return updated;
  }
  setBuffer(buffer3) {
    this.attributeInTransition.setData({
      buffer: buffer3,
      normalized: this.attribute.settings.normalized,
      // Retain placeholder value to generate correct shader layout
      value: this.attributeInTransition.value
    });
  }
  cancel() {
    this.transition.cancel();
  }
  delete() {
    this.cancel();
    for (const buffer3 of this.buffers) {
      buffer3.destroy();
    }
    this.buffers.length = 0;
  }
}
class GPUInterpolationTransition extends GPUTransitionBase {
  constructor({ device, attribute, timeline }) {
    super({ device, attribute, timeline });
    this.type = "interpolation";
    this.transform = getTransform$1(device, attribute);
  }
  start(transitionSettings, numInstances) {
    const prevLength = this.currentLength;
    const prevStartIndices = this.currentStartIndices;
    super.start(transitionSettings, numInstances, transitionSettings.duration);
    if (transitionSettings.duration <= 0) {
      this.transition.cancel();
      return;
    }
    const { buffers, attribute } = this;
    cycleBuffers(buffers);
    buffers[0] = padBuffer({
      device: this.device,
      buffer: buffers[0],
      attribute,
      fromLength: prevLength,
      toLength: this.currentLength,
      fromStartIndices: prevStartIndices,
      getData: transitionSettings.enter
    });
    buffers[1] = matchBuffer({
      device: this.device,
      source: buffers[0],
      target: buffers[1]
    });
    this.setBuffer(buffers[1]);
    const { transform: transform4 } = this;
    const model = transform4.model;
    let vertexCount = Math.floor(this.currentLength / attribute.size);
    if (useFp64(attribute)) {
      vertexCount /= 2;
    }
    model.setVertexCount(vertexCount);
    if (attribute.isConstant) {
      model.setAttributes({ aFrom: buffers[0] });
      model.setConstantAttributes({ aTo: attribute.value });
    } else {
      model.setAttributes({
        aFrom: buffers[0],
        aTo: attribute.getBuffer()
      });
    }
    transform4.transformFeedback.setBuffers({ vCurrent: buffers[1] });
  }
  onUpdate() {
    const { duration, easing } = this.settings;
    const { time: time2 } = this.transition;
    let t2 = time2 / duration;
    if (easing) {
      t2 = easing(t2);
    }
    const { model } = this.transform;
    model.setUniforms({ time: t2 });
    const gl = model.device.gl;
    gl.bindBuffer(34962, null);
    this.transform.run({ discard: true });
  }
  delete() {
    super.delete();
    this.transform.destroy();
  }
}
const vs$d = `#version 300 es
#define SHADER_NAME interpolation-transition-vertex-shader

uniform float time;
in ATTRIBUTE_TYPE aFrom;
in ATTRIBUTE_TYPE aTo;
out ATTRIBUTE_TYPE vCurrent;

void main(void) {
  vCurrent = mix(aFrom, aTo, time);
  gl_Position = vec4(0.0);
}
`;
const vs64 = `#version 300 es
#define SHADER_NAME interpolation-transition-vertex-shader

uniform float time;
in ATTRIBUTE_TYPE aFrom;
in ATTRIBUTE_TYPE aFrom64Low;
in ATTRIBUTE_TYPE aTo;
in ATTRIBUTE_TYPE aTo64Low;
out ATTRIBUTE_TYPE vCurrent;
out ATTRIBUTE_TYPE vCurrent64Low;

vec2 mix_fp64(vec2 a, vec2 b, float x) {
  vec2 range = sub_fp64(b, a);
  return sum_fp64(a, mul_fp64(range, vec2(x, 0.0)));
}

void main(void) {
  for (int i=0; i<ATTRIBUTE_SIZE; i++) {
    vec2 value = mix_fp64(vec2(aFrom[i], aFrom64Low[i]), vec2(aTo[i], aTo64Low[i]), time);
    vCurrent[i] = value.x;
    vCurrent64Low[i] = value.y;
  }
  gl_Position = vec4(0.0);
}
`;
function useFp64(attribute) {
  return attribute.doublePrecision && attribute.value instanceof Float64Array;
}
function getTransform$1(device, attribute) {
  const attributeSize = attribute.size;
  const attributeType = getAttributeTypeFromSize(attributeSize);
  const inputFormat = getFloat32VertexFormat(attributeSize);
  const bufferLayout = attribute.getBufferLayout();
  if (useFp64(attribute)) {
    return new BufferTransform(device, {
      vs: vs64,
      bufferLayout: [
        {
          name: "aFrom",
          byteStride: 8 * attributeSize,
          attributes: [
            { attribute: "aFrom", format: inputFormat, byteOffset: 0 },
            { attribute: "aFrom64Low", format: inputFormat, byteOffset: 4 * attributeSize }
          ]
        },
        {
          name: "aTo",
          byteStride: 8 * attributeSize,
          attributes: [
            { attribute: "aTo", format: inputFormat, byteOffset: 0 },
            { attribute: "aTo64Low", format: inputFormat, byteOffset: 4 * attributeSize }
          ]
        }
      ],
      modules: [fp64arithmetic],
      defines: {
        ATTRIBUTE_TYPE: attributeType,
        ATTRIBUTE_SIZE: attributeSize
      },
      // Default uniforms are not set without this
      moduleSettings: {},
      varyings: ["vCurrent", "vCurrent64Low"],
      // @ts-expect-error WebGLRenderPipeline only prop TODO - support in RenderPipeline?
      bufferMode: 35980,
      disableWarnings: true
    });
  }
  return new BufferTransform(device, {
    vs: vs$d,
    bufferLayout: [
      { name: "aFrom", format: inputFormat },
      { name: "aTo", format: bufferLayout.attributes[0].format }
    ],
    defines: {
      ATTRIBUTE_TYPE: attributeType
    },
    varyings: ["vCurrent"],
    disableWarnings: true
  });
}
class GPUSpringTransition extends GPUTransitionBase {
  constructor({ device, attribute, timeline }) {
    super({ device, attribute, timeline });
    this.type = "spring";
    this.texture = getTexture(device);
    this.framebuffer = getFramebuffer(device, this.texture);
    this.transform = getTransform(device, attribute);
  }
  start(transitionSettings, numInstances) {
    const prevLength = this.currentLength;
    const prevStartIndices = this.currentStartIndices;
    super.start(transitionSettings, numInstances);
    const { buffers, attribute } = this;
    for (let i2 = 0; i2 < 2; i2++) {
      buffers[i2] = padBuffer({
        device: this.device,
        buffer: buffers[i2],
        attribute,
        fromLength: prevLength,
        toLength: this.currentLength,
        fromStartIndices: prevStartIndices,
        getData: transitionSettings.enter
      });
    }
    buffers[2] = matchBuffer({
      device: this.device,
      source: buffers[0],
      target: buffers[2]
    });
    this.setBuffer(buffers[1]);
    const { model } = this.transform;
    model.setVertexCount(Math.floor(this.currentLength / attribute.size));
    if (attribute.isConstant) {
      model.setConstantAttributes({ aTo: attribute.value });
    } else {
      model.setAttributes({ aTo: attribute.getBuffer() });
    }
  }
  onUpdate() {
    const { buffers, transform: transform4, framebuffer, transition: transition2 } = this;
    const settings = this.settings;
    transform4.model.setAttributes({
      aPrev: buffers[0],
      aCur: buffers[1]
    });
    transform4.transformFeedback.setBuffers({ vNext: buffers[2] });
    transform4.model.setUniforms({
      stiffness: settings.stiffness,
      damping: settings.damping
    });
    transform4.run({
      framebuffer,
      discard: false,
      parameters: { viewport: [0, 0, 1, 1] },
      clearColor: [0, 0, 0, 0]
    });
    cycleBuffers(buffers);
    this.setBuffer(buffers[1]);
    const isTransitioning = this.device.readPixelsToArrayWebGL(framebuffer)[0] > 0;
    if (!isTransitioning) {
      transition2.end();
    }
  }
  delete() {
    super.delete();
    this.transform.destroy();
    this.texture.destroy();
    this.framebuffer.destroy();
  }
}
const vs$c = `#version 300 es
#define SHADER_NAME spring-transition-vertex-shader

#define EPSILON 0.00001

uniform float stiffness;
uniform float damping;
in ATTRIBUTE_TYPE aPrev;
in ATTRIBUTE_TYPE aCur;
in ATTRIBUTE_TYPE aTo;
out ATTRIBUTE_TYPE vNext;
out float vIsTransitioningFlag;

ATTRIBUTE_TYPE getNextValue(ATTRIBUTE_TYPE cur, ATTRIBUTE_TYPE prev, ATTRIBUTE_TYPE dest) {
  ATTRIBUTE_TYPE velocity = cur - prev;
  ATTRIBUTE_TYPE delta = dest - cur;
  ATTRIBUTE_TYPE spring = delta * stiffness;
  ATTRIBUTE_TYPE damper = velocity * -1.0 * damping;
  return spring + damper + velocity + cur;
}

void main(void) {
  bool isTransitioning = length(aCur - aPrev) > EPSILON || length(aTo - aCur) > EPSILON;
  vIsTransitioningFlag = isTransitioning ? 1.0 : 0.0;

  vNext = getNextValue(aCur, aPrev, aTo);
  gl_Position = vec4(0, 0, 0, 1);
  gl_PointSize = 100.0;
}
`;
const fs$e = `#version 300 es
#define SHADER_NAME spring-transition-is-transitioning-fragment-shader

in float vIsTransitioningFlag;

out vec4 fragColor;

void main(void) {
  if (vIsTransitioningFlag == 0.0) {
    discard;
  }
  fragColor = vec4(1.0);
}`;
function getTransform(device, attribute) {
  const attributeType = getAttributeTypeFromSize(attribute.size);
  const format = getFloat32VertexFormat(attribute.size);
  return new BufferTransform(device, {
    vs: vs$c,
    fs: fs$e,
    bufferLayout: [
      { name: "aPrev", format },
      { name: "aCur", format },
      { name: "aTo", format: attribute.getBufferLayout().attributes[0].format }
    ],
    varyings: ["vNext"],
    defines: { ATTRIBUTE_TYPE: attributeType },
    parameters: {
      depthCompare: "always",
      blendColorOperation: "max",
      blendColorSrcFactor: "one",
      blendColorDstFactor: "one",
      blendAlphaOperation: "max",
      blendAlphaSrcFactor: "one",
      blendAlphaDstFactor: "one"
    }
  });
}
function getTexture(device) {
  return device.createTexture({
    data: new Uint8Array(4),
    format: "rgba8unorm",
    mipmaps: false,
    // dataFormat: GL.RGBA,
    width: 1,
    height: 1
  });
}
function getFramebuffer(device, texture) {
  return device.createFramebuffer({
    id: "spring-transition-is-transitioning-framebuffer",
    width: 1,
    height: 1,
    colorAttachments: [texture]
  });
}
const TRANSITION_TYPES$1 = {
  interpolation: GPUInterpolationTransition,
  spring: GPUSpringTransition
};
class AttributeTransitionManager {
  constructor(device, { id, timeline }) {
    if (!device)
      throw new Error("AttributeTransitionManager is constructed without device");
    this.id = id;
    this.device = device;
    this.timeline = timeline;
    this.transitions = {};
    this.needsRedraw = false;
    this.numInstances = 1;
  }
  finalize() {
    for (const attributeName in this.transitions) {
      this._removeTransition(attributeName);
    }
  }
  /* Public methods */
  // Called when attribute manager updates
  // Check the latest attributes for updates.
  update({ attributes, transitions, numInstances }) {
    this.numInstances = numInstances || 1;
    for (const attributeName in attributes) {
      const attribute = attributes[attributeName];
      const settings = attribute.getTransitionSetting(transitions);
      if (!settings)
        continue;
      this._updateAttribute(attributeName, attribute, settings);
    }
    for (const attributeName in this.transitions) {
      const attribute = attributes[attributeName];
      if (!attribute || !attribute.getTransitionSetting(transitions)) {
        this._removeTransition(attributeName);
      }
    }
  }
  // Returns `true` if attribute is transition-enabled
  hasAttribute(attributeName) {
    const transition2 = this.transitions[attributeName];
    return transition2 && transition2.inProgress;
  }
  // Get all the animated attributes
  getAttributes() {
    const animatedAttributes = {};
    for (const attributeName in this.transitions) {
      const transition2 = this.transitions[attributeName];
      if (transition2.inProgress) {
        animatedAttributes[attributeName] = transition2.attributeInTransition;
      }
    }
    return animatedAttributes;
  }
  /* eslint-disable max-statements */
  // Called every render cycle, run transform feedback
  // Returns `true` if anything changes
  run() {
    if (this.numInstances === 0) {
      return false;
    }
    for (const attributeName in this.transitions) {
      const updated = this.transitions[attributeName].update();
      if (updated) {
        this.needsRedraw = true;
      }
    }
    const needsRedraw = this.needsRedraw;
    this.needsRedraw = false;
    return needsRedraw;
  }
  /* eslint-enable max-statements */
  /* Private methods */
  _removeTransition(attributeName) {
    this.transitions[attributeName].delete();
    delete this.transitions[attributeName];
  }
  // Check an attributes for updates
  // Returns a transition object if a new transition is triggered.
  _updateAttribute(attributeName, attribute, settings) {
    const transition2 = this.transitions[attributeName];
    let isNew = !transition2 || transition2.type !== settings.type;
    if (isNew) {
      if (transition2) {
        this._removeTransition(attributeName);
      }
      const TransitionType = TRANSITION_TYPES$1[settings.type];
      if (TransitionType) {
        this.transitions[attributeName] = new TransitionType({
          attribute,
          timeline: this.timeline,
          device: this.device
        });
      } else {
        log$1.error(`unsupported transition type '${settings.type}'`)();
        isNew = false;
      }
    }
    if (isNew || attribute.needsRedraw()) {
      this.needsRedraw = true;
      this.transitions[attributeName].start(settings, this.numInstances);
    }
  }
}
const TRACE_INVALIDATE = "attributeManager.invalidate";
const TRACE_UPDATE_START = "attributeManager.updateStart";
const TRACE_UPDATE_END = "attributeManager.updateEnd";
const TRACE_ATTRIBUTE_UPDATE_START = "attribute.updateStart";
const TRACE_ATTRIBUTE_ALLOCATE = "attribute.allocate";
const TRACE_ATTRIBUTE_UPDATE_END = "attribute.updateEnd";
class AttributeManager {
  constructor(device, { id = "attribute-manager", stats, timeline } = {}) {
    this.mergeBoundsMemoized = memoize$1(mergeBounds);
    this.id = id;
    this.device = device;
    this.attributes = {};
    this.updateTriggers = {};
    this.needsRedraw = true;
    this.userData = {};
    this.stats = stats;
    this.attributeTransitionManager = new AttributeTransitionManager(device, {
      id: `${id}-transitions`,
      timeline
    });
    Object.seal(this);
  }
  finalize() {
    for (const attributeName in this.attributes) {
      this.attributes[attributeName].delete();
    }
    this.attributeTransitionManager.finalize();
  }
  // Returns the redraw flag, optionally clearing it.
  // Redraw flag will be set if any attributes attributes changed since
  // flag was last cleared.
  //
  // @param {String} [clearRedrawFlags=false] - whether to clear the flag
  // @return {false|String} - reason a redraw is needed.
  getNeedsRedraw(opts = { clearRedrawFlags: false }) {
    const redraw = this.needsRedraw;
    this.needsRedraw = this.needsRedraw && !opts.clearRedrawFlags;
    return redraw && this.id;
  }
  // Sets the redraw flag.
  // @param {Boolean} redraw=true
  setNeedsRedraw() {
    this.needsRedraw = true;
  }
  // Adds attributes
  add(attributes) {
    this._add(attributes);
  }
  // Adds attributes
  addInstanced(attributes) {
    this._add(attributes, { stepMode: "instance" });
  }
  /**
   * Removes attributes
   * Takes an array of attribute names and delete them from
   * the attribute map if they exists
   *
   * @example
   * attributeManager.remove(['position']);
   *
   * @param {Object} attributeNameArray - attribute name array (see above)
   */
  remove(attributeNameArray) {
    for (const name2 of attributeNameArray) {
      if (this.attributes[name2] !== void 0) {
        this.attributes[name2].delete();
        delete this.attributes[name2];
      }
    }
  }
  // Marks an attribute for update
  invalidate(triggerName, dataRange) {
    const invalidatedAttributes = this._invalidateTrigger(triggerName, dataRange);
    debug(TRACE_INVALIDATE, this, triggerName, invalidatedAttributes);
  }
  invalidateAll(dataRange) {
    for (const attributeName in this.attributes) {
      this.attributes[attributeName].setNeedsUpdate(attributeName, dataRange);
    }
    debug(TRACE_INVALIDATE, this, "all");
  }
  // Ensure all attribute buffers are updated from props or data.
  // eslint-disable-next-line complexity
  update({ data: data2, numInstances, startIndices = null, transitions, props = {}, buffers = {}, context: context2 = {} }) {
    let updated = false;
    debug(TRACE_UPDATE_START, this);
    if (this.stats) {
      this.stats.get("Update Attributes").timeStart();
    }
    for (const attributeName in this.attributes) {
      const attribute = this.attributes[attributeName];
      const accessorName = attribute.settings.accessor;
      attribute.startIndices = startIndices;
      attribute.numInstances = numInstances;
      if (props[attributeName]) {
        log$1.removed(`props.${attributeName}`, `data.attributes.${attributeName}`)();
      }
      if (attribute.setExternalBuffer(buffers[attributeName]))
        ;
      else if (attribute.setBinaryValue(typeof accessorName === "string" ? buffers[accessorName] : void 0, data2.startIndices))
        ;
      else if (typeof accessorName === "string" && !buffers[accessorName] && attribute.setConstantValue(props[accessorName]))
        ;
      else if (attribute.needsUpdate()) {
        updated = true;
        this._updateAttribute({
          attribute,
          numInstances,
          data: data2,
          props,
          context: context2
        });
      }
      this.needsRedraw = this.needsRedraw || attribute.needsRedraw();
    }
    if (updated) {
      debug(TRACE_UPDATE_END, this, numInstances);
    }
    if (this.stats) {
      this.stats.get("Update Attributes").timeEnd();
    }
    this.attributeTransitionManager.update({
      attributes: this.attributes,
      numInstances,
      transitions
    });
  }
  // Update attribute transition to the current timestamp
  // Returns `true` if any transition is in progress
  updateTransition() {
    const { attributeTransitionManager } = this;
    const transitionUpdated = attributeTransitionManager.run();
    this.needsRedraw = this.needsRedraw || transitionUpdated;
    return transitionUpdated;
  }
  /**
   * Returns all attribute descriptors
   * Note: Format matches luma.gl Model/Program.setAttributes()
   * @return {Object} attributes - descriptors
   */
  getAttributes() {
    return { ...this.attributes, ...this.attributeTransitionManager.getAttributes() };
  }
  /**
   * Computes the spatial bounds of a given set of attributes
   */
  getBounds(attributeNames) {
    const bounds = attributeNames.map((attributeName) => {
      var _a3;
      return (_a3 = this.attributes[attributeName]) == null ? void 0 : _a3.getBounds();
    });
    return this.mergeBoundsMemoized(bounds);
  }
  /**
   * Returns changed attribute descriptors
   * This indicates which WebGLBuffers need to be updated
   * @return {Object} attributes - descriptors
   */
  getChangedAttributes(opts = { clearChangedFlags: false }) {
    const { attributes, attributeTransitionManager } = this;
    const changedAttributes = { ...attributeTransitionManager.getAttributes() };
    for (const attributeName in attributes) {
      const attribute = attributes[attributeName];
      if (attribute.needsRedraw(opts) && !attributeTransitionManager.hasAttribute(attributeName)) {
        changedAttributes[attributeName] = attribute;
      }
    }
    return changedAttributes;
  }
  /** Generate WebGPU-style buffer layout descriptors from all attributes */
  getBufferLayouts(modelInfo) {
    return Object.values(this.getAttributes()).map((attribute) => attribute.getBufferLayout(modelInfo));
  }
  // PRIVATE METHODS
  /** Register new attributes */
  _add(attributes, overrideOptions) {
    for (const attributeName in attributes) {
      const attribute = attributes[attributeName];
      const props = {
        ...attribute,
        id: attributeName,
        size: attribute.isIndexed && 1 || attribute.size || 1,
        ...overrideOptions
      };
      this.attributes[attributeName] = new Attribute(this.device, props);
    }
    this._mapUpdateTriggersToAttributes();
  }
  // build updateTrigger name to attribute name mapping
  _mapUpdateTriggersToAttributes() {
    const triggers = {};
    for (const attributeName in this.attributes) {
      const attribute = this.attributes[attributeName];
      attribute.getUpdateTriggers().forEach((triggerName) => {
        if (!triggers[triggerName]) {
          triggers[triggerName] = [];
        }
        triggers[triggerName].push(attributeName);
      });
    }
    this.updateTriggers = triggers;
  }
  _invalidateTrigger(triggerName, dataRange) {
    const { attributes, updateTriggers } = this;
    const invalidatedAttributes = updateTriggers[triggerName];
    if (invalidatedAttributes) {
      invalidatedAttributes.forEach((name2) => {
        const attribute = attributes[name2];
        if (attribute) {
          attribute.setNeedsUpdate(attribute.id, dataRange);
        }
      });
    }
    return invalidatedAttributes;
  }
  _updateAttribute(opts) {
    const { attribute, numInstances } = opts;
    debug(TRACE_ATTRIBUTE_UPDATE_START, attribute);
    if (attribute.constant) {
      attribute.setConstantValue(attribute.value);
      return;
    }
    if (attribute.allocate(numInstances)) {
      debug(TRACE_ATTRIBUTE_ALLOCATE, attribute, numInstances);
    }
    const updated = attribute.updateBuffer(opts);
    if (updated) {
      this.needsRedraw = true;
      debug(TRACE_ATTRIBUTE_UPDATE_END, attribute, numInstances);
    }
  }
}
class CPUInterpolationTransition extends Transition {
  get value() {
    return this._value;
  }
  _onUpdate() {
    const { time: time2, settings: { fromValue: fromValue2, toValue, duration, easing } } = this;
    const t2 = easing(time2 / duration);
    this._value = lerp$4(fromValue2, toValue, t2);
  }
}
const EPSILON = 1e-5;
function updateSpringElement(prev, cur, dest, damping, stiffness) {
  const velocity = cur - prev;
  const delta = dest - cur;
  const spring = delta * stiffness;
  const damper = -velocity * damping;
  return spring + damper + velocity + cur;
}
function updateSpring(prev, cur, dest, damping, stiffness) {
  if (Array.isArray(dest)) {
    const next5 = [];
    for (let i2 = 0; i2 < dest.length; i2++) {
      next5[i2] = updateSpringElement(prev[i2], cur[i2], dest[i2], damping, stiffness);
    }
    return next5;
  }
  return updateSpringElement(prev, cur, dest, damping, stiffness);
}
function distance$4(value1, value2) {
  if (Array.isArray(value1)) {
    let distanceSquare = 0;
    for (let i2 = 0; i2 < value1.length; i2++) {
      const d2 = value1[i2] - value2[i2];
      distanceSquare += d2 * d2;
    }
    return Math.sqrt(distanceSquare);
  }
  return Math.abs(value1 - value2);
}
class CPUSpringTransition extends Transition {
  get value() {
    return this._currValue;
  }
  _onUpdate() {
    const { fromValue: fromValue2, toValue, damping, stiffness } = this.settings;
    const { _prevValue = fromValue2, _currValue = fromValue2 } = this;
    let nextValue = updateSpring(_prevValue, _currValue, toValue, damping, stiffness);
    const delta = distance$4(nextValue, toValue);
    const velocity = distance$4(nextValue, _currValue);
    if (delta < EPSILON && velocity < EPSILON) {
      nextValue = toValue;
      this.end();
    }
    this._prevValue = _currValue;
    this._currValue = nextValue;
  }
}
const TRANSITION_TYPES = {
  interpolation: CPUInterpolationTransition,
  spring: CPUSpringTransition
};
class UniformTransitionManager {
  constructor(timeline) {
    this.transitions = /* @__PURE__ */ new Map();
    this.timeline = timeline;
  }
  get active() {
    return this.transitions.size > 0;
  }
  add(key, fromValue2, toValue, settings) {
    const { transitions } = this;
    if (transitions.has(key)) {
      const transition3 = transitions.get(key);
      const { value = transition3.settings.fromValue } = transition3;
      fromValue2 = value;
      this.remove(key);
    }
    settings = normalizeTransitionSettings(settings);
    if (!settings) {
      return;
    }
    const TransitionType = TRANSITION_TYPES[settings.type];
    if (!TransitionType) {
      log$1.error(`unsupported transition type '${settings.type}'`)();
      return;
    }
    const transition2 = new TransitionType(this.timeline);
    transition2.start({
      ...settings,
      fromValue: fromValue2,
      toValue
    });
    transitions.set(key, transition2);
  }
  remove(key) {
    const { transitions } = this;
    if (transitions.has(key)) {
      transitions.get(key).cancel();
      transitions.delete(key);
    }
  }
  update() {
    const propsInTransition = {};
    for (const [key, transition2] of this.transitions) {
      transition2.update();
      propsInTransition[key] = transition2.value;
      if (!transition2.inProgress) {
        this.remove(key);
      }
    }
    return propsInTransition;
  }
  clear() {
    for (const key of this.transitions.keys()) {
      this.remove(key);
    }
  }
}
function validateProps(props) {
  const propTypes2 = props[PROP_TYPES_SYMBOL];
  for (const propName2 in propTypes2) {
    const propType = propTypes2[propName2];
    const { validate: validate2 } = propType;
    if (validate2 && !validate2(props[propName2], propType)) {
      throw new Error(`Invalid prop ${propName2}: ${props[propName2]}`);
    }
  }
}
function diffProps$1(props, oldProps) {
  const propsChangedReason = compareProps({
    newProps: props,
    oldProps,
    propTypes: props[PROP_TYPES_SYMBOL],
    ignoreProps: { data: null, updateTriggers: null, extensions: null, transitions: null }
  });
  const dataChangedReason = diffDataProps(props, oldProps);
  let updateTriggersChangedReason = false;
  if (!dataChangedReason) {
    updateTriggersChangedReason = diffUpdateTriggers(props, oldProps);
  }
  return {
    dataChanged: dataChangedReason,
    propsChanged: propsChangedReason,
    updateTriggersChanged: updateTriggersChangedReason,
    extensionsChanged: diffExtensions(props, oldProps),
    transitionsChanged: diffTransitions(props, oldProps)
  };
}
function diffTransitions(props, oldProps) {
  if (!props.transitions) {
    return false;
  }
  const result = {};
  const propTypes2 = props[PROP_TYPES_SYMBOL];
  let changed = false;
  for (const key in props.transitions) {
    const propType = propTypes2[key];
    const type = propType && propType.type;
    const isTransitionable = type === "number" || type === "color" || type === "array";
    if (isTransitionable && comparePropValues(props[key], oldProps[key], propType)) {
      result[key] = true;
      changed = true;
    }
  }
  return changed ? result : false;
}
function compareProps({ newProps, oldProps, ignoreProps = {}, propTypes: propTypes2 = {}, triggerName = "props" }) {
  if (oldProps === newProps) {
    return false;
  }
  if (typeof newProps !== "object" || newProps === null) {
    return `${triggerName} changed shallowly`;
  }
  if (typeof oldProps !== "object" || oldProps === null) {
    return `${triggerName} changed shallowly`;
  }
  for (const key of Object.keys(newProps)) {
    if (!(key in ignoreProps)) {
      if (!(key in oldProps)) {
        return `${triggerName}.${key} added`;
      }
      const changed = comparePropValues(newProps[key], oldProps[key], propTypes2[key]);
      if (changed) {
        return `${triggerName}.${key} ${changed}`;
      }
    }
  }
  for (const key of Object.keys(oldProps)) {
    if (!(key in ignoreProps)) {
      if (!(key in newProps)) {
        return `${triggerName}.${key} dropped`;
      }
      if (!Object.hasOwnProperty.call(newProps, key)) {
        const changed = comparePropValues(newProps[key], oldProps[key], propTypes2[key]);
        if (changed) {
          return `${triggerName}.${key} ${changed}`;
        }
      }
    }
  }
  return false;
}
function comparePropValues(newProp, oldProp, propType) {
  let equal3 = propType && propType.equal;
  if (equal3 && !equal3(newProp, oldProp, propType)) {
    return "changed deeply";
  }
  if (!equal3) {
    equal3 = newProp && oldProp && newProp.equals;
    if (equal3 && !equal3.call(newProp, oldProp)) {
      return "changed deeply";
    }
  }
  if (!equal3 && oldProp !== newProp) {
    return "changed shallowly";
  }
  return null;
}
function diffDataProps(props, oldProps) {
  if (oldProps === null) {
    return "oldProps is null, initial diff";
  }
  let dataChanged = false;
  const { dataComparator, _dataDiff } = props;
  if (dataComparator) {
    if (!dataComparator(props.data, oldProps.data)) {
      dataChanged = "Data comparator detected a change";
    }
  } else if (props.data !== oldProps.data) {
    dataChanged = "A new data container was supplied";
  }
  if (dataChanged && _dataDiff) {
    dataChanged = _dataDiff(props.data, oldProps.data) || dataChanged;
  }
  return dataChanged;
}
function diffUpdateTriggers(props, oldProps) {
  if (oldProps === null) {
    return { all: true };
  }
  if ("all" in props.updateTriggers) {
    const diffReason = diffUpdateTrigger(props, oldProps, "all");
    if (diffReason) {
      return { all: true };
    }
  }
  const reason = {};
  let changed = false;
  for (const triggerName in props.updateTriggers) {
    if (triggerName !== "all") {
      const diffReason = diffUpdateTrigger(props, oldProps, triggerName);
      if (diffReason) {
        reason[triggerName] = true;
        changed = true;
      }
    }
  }
  return changed ? reason : false;
}
function diffExtensions(props, oldProps) {
  if (oldProps === null) {
    return true;
  }
  const oldExtensions = oldProps.extensions;
  const { extensions } = props;
  if (extensions === oldExtensions) {
    return false;
  }
  if (!oldExtensions || !extensions) {
    return true;
  }
  if (extensions.length !== oldExtensions.length) {
    return true;
  }
  for (let i2 = 0; i2 < extensions.length; i2++) {
    if (!extensions[i2].equals(oldExtensions[i2])) {
      return true;
    }
  }
  return false;
}
function diffUpdateTrigger(props, oldProps, triggerName) {
  let newTriggers = props.updateTriggers[triggerName];
  newTriggers = newTriggers === void 0 || newTriggers === null ? {} : newTriggers;
  let oldTriggers = oldProps.updateTriggers[triggerName];
  oldTriggers = oldTriggers === void 0 || oldTriggers === null ? {} : oldTriggers;
  const diffReason = compareProps({
    oldProps: oldTriggers,
    newProps: newTriggers,
    triggerName
  });
  return diffReason;
}
const ERR_NOT_OBJECT = "count(): argument not an object";
const ERR_NOT_CONTAINER = "count(): argument not a container";
function count(container) {
  if (!isObject$a(container)) {
    throw new Error(ERR_NOT_OBJECT);
  }
  if (typeof container.count === "function") {
    return container.count();
  }
  if (Number.isFinite(container.size)) {
    return container.size;
  }
  if (Number.isFinite(container.length)) {
    return container.length;
  }
  if (isPlainObject$2(container)) {
    return Object.keys(container).length;
  }
  throw new Error(ERR_NOT_CONTAINER);
}
function isPlainObject$2(value) {
  return value !== null && typeof value === "object" && value.constructor === Object;
}
function isObject$a(value) {
  return value !== null && typeof value === "object";
}
function mergeShaders(target, source) {
  if (!source) {
    return target;
  }
  const result = { ...target, ...source };
  if ("defines" in source) {
    result.defines = { ...target.defines, ...source.defines };
  }
  if ("modules" in source) {
    result.modules = (target.modules || []).concat(source.modules);
    if (source.modules.some((module2) => module2.name === "project64")) {
      const index2 = result.modules.findIndex((module2) => module2.name === "project32");
      if (index2 >= 0) {
        result.modules.splice(index2, 1);
      }
    }
  }
  if ("inject" in source) {
    if (!target.inject) {
      result.inject = source.inject;
    } else {
      const mergedInjection = { ...target.inject };
      for (const key in source.inject) {
        mergedInjection[key] = (mergedInjection[key] || "") + source.inject[key];
      }
      result.inject = mergedInjection;
    }
  }
  return result;
}
const DEFAULT_TEXTURE_PARAMETERS = {
  minFilter: "linear",
  mipmapFilter: "linear",
  magFilter: "linear",
  addressModeU: "clamp-to-edge",
  addressModeV: "clamp-to-edge"
};
const internalTextures = {};
function createTexture(owner, device, image, sampler) {
  if (image instanceof Texture) {
    return image;
  } else if (image.constructor && image.constructor.name !== "Object") {
    image = { data: image };
  }
  let samplerParameters = null;
  if (image.compressed) {
    samplerParameters = {
      minFilter: "linear",
      mipmapFilter: image.data.length > 1 ? "nearest" : "linear"
    };
  }
  const texture = device.createTexture({
    ...image,
    sampler: {
      ...DEFAULT_TEXTURE_PARAMETERS,
      ...samplerParameters,
      ...sampler
    }
  });
  internalTextures[texture.id] = owner;
  return texture;
}
function destroyTexture(owner, texture) {
  if (!texture || !(texture instanceof Texture)) {
    return;
  }
  if (internalTextures[texture.id] === owner) {
    texture.delete();
    delete internalTextures[texture.id];
  }
}
const TYPE_DEFINITIONS = {
  boolean: {
    validate(value, propType) {
      return true;
    },
    equal(value1, value2, propType) {
      return Boolean(value1) === Boolean(value2);
    }
  },
  number: {
    validate(value, propType) {
      return Number.isFinite(value) && (!("max" in propType) || value <= propType.max) && (!("min" in propType) || value >= propType.min);
    }
  },
  color: {
    validate(value, propType) {
      return propType.optional && !value || isArray$1(value) && (value.length === 3 || value.length === 4);
    },
    equal(value1, value2, propType) {
      return deepEqual(value1, value2, 1);
    }
  },
  accessor: {
    validate(value, propType) {
      const valueType = getTypeOf(value);
      return valueType === "function" || valueType === getTypeOf(propType.value);
    },
    equal(value1, value2, propType) {
      if (typeof value2 === "function") {
        return true;
      }
      return deepEqual(value1, value2, 1);
    }
  },
  array: {
    validate(value, propType) {
      return propType.optional && !value || isArray$1(value);
    },
    equal(value1, value2, propType) {
      const { compare: compare12 } = propType;
      const depth2 = Number.isInteger(compare12) ? compare12 : compare12 ? 1 : 0;
      return compare12 ? deepEqual(value1, value2, depth2) : value1 === value2;
    }
  },
  object: {
    equal(value1, value2, propType) {
      if (propType.ignore) {
        return true;
      }
      const { compare: compare12 } = propType;
      const depth2 = Number.isInteger(compare12) ? compare12 : compare12 ? 1 : 0;
      return compare12 ? deepEqual(value1, value2, depth2) : value1 === value2;
    }
  },
  function: {
    validate(value, propType) {
      return propType.optional && !value || typeof value === "function";
    },
    equal(value1, value2, propType) {
      const shouldIgnore = !propType.compare && propType.ignore !== false;
      return shouldIgnore || value1 === value2;
    }
  },
  data: {
    transform: (value, propType, component) => {
      if (!value) {
        return value;
      }
      const { dataTransform } = component.props;
      if (dataTransform) {
        return dataTransform(value);
      }
      if (typeof value.shape === "string" && value.shape.endsWith("-table") && Array.isArray(value.data)) {
        return value.data;
      }
      return value;
    }
  },
  image: {
    transform: (value, propType, component) => {
      const context2 = component.context;
      if (!context2 || !context2.device) {
        return null;
      }
      return createTexture(component.id, context2.device, value, {
        ...propType.parameters,
        ...component.props.textureParameters
      });
    },
    release: (value, propType, component) => {
      destroyTexture(component.id, value);
    }
  }
};
function parsePropTypes(propDefs) {
  const propTypes2 = {};
  const defaultProps2 = {};
  const deprecatedProps = {};
  for (const [propName2, propDef] of Object.entries(propDefs)) {
    const deprecated = propDef == null ? void 0 : propDef.deprecatedFor;
    if (deprecated) {
      deprecatedProps[propName2] = Array.isArray(deprecated) ? deprecated : [deprecated];
    } else {
      const propType = parsePropType(propName2, propDef);
      propTypes2[propName2] = propType;
      defaultProps2[propName2] = propType.value;
    }
  }
  return { propTypes: propTypes2, defaultProps: defaultProps2, deprecatedProps };
}
function parsePropType(name2, propDef) {
  switch (getTypeOf(propDef)) {
    case "object":
      return normalizePropDefinition(name2, propDef);
    case "array":
      return normalizePropDefinition(name2, { type: "array", value: propDef, compare: false });
    case "boolean":
      return normalizePropDefinition(name2, { type: "boolean", value: propDef });
    case "number":
      return normalizePropDefinition(name2, { type: "number", value: propDef });
    case "function":
      return normalizePropDefinition(name2, { type: "function", value: propDef, compare: true });
    default:
      return { name: name2, type: "unknown", value: propDef };
  }
}
function normalizePropDefinition(name2, propDef) {
  if (!("type" in propDef)) {
    if (!("value" in propDef)) {
      return { name: name2, type: "object", value: propDef };
    }
    return { name: name2, type: getTypeOf(propDef.value), ...propDef };
  }
  return { name: name2, ...TYPE_DEFINITIONS[propDef.type], ...propDef };
}
function isArray$1(value) {
  return Array.isArray(value) || ArrayBuffer.isView(value);
}
function getTypeOf(value) {
  if (isArray$1(value)) {
    return "array";
  }
  if (value === null) {
    return "null";
  }
  return typeof value;
}
function createProps(component, propObjects) {
  let extensions;
  for (let i2 = propObjects.length - 1; i2 >= 0; i2--) {
    const props = propObjects[i2];
    if ("extensions" in props) {
      extensions = props.extensions;
    }
  }
  const propsPrototype = getPropsPrototype(component.constructor, extensions);
  const propsInstance = Object.create(propsPrototype);
  propsInstance[COMPONENT_SYMBOL] = component;
  propsInstance[ASYNC_ORIGINAL_SYMBOL] = {};
  propsInstance[ASYNC_RESOLVED_SYMBOL] = {};
  for (let i2 = 0; i2 < propObjects.length; ++i2) {
    const props = propObjects[i2];
    for (const key in props) {
      propsInstance[key] = props[key];
    }
  }
  Object.freeze(propsInstance);
  return propsInstance;
}
const MergedDefaultPropsCacheKey = "_mergedDefaultProps";
function getPropsPrototype(componentClass, extensions) {
  let cacheKey = MergedDefaultPropsCacheKey;
  if (extensions) {
    for (const extension of extensions) {
      const ExtensionClass = extension.constructor;
      if (ExtensionClass) {
        cacheKey += `:${ExtensionClass.extensionName || ExtensionClass.name}`;
      }
    }
  }
  const defaultProps2 = getOwnProperty(componentClass, cacheKey);
  if (!defaultProps2) {
    return componentClass[cacheKey] = createPropsPrototypeAndTypes(componentClass, extensions || []);
  }
  return defaultProps2;
}
function createPropsPrototypeAndTypes(componentClass, extensions) {
  const parent = componentClass.prototype;
  if (!parent) {
    return null;
  }
  const parentClass = Object.getPrototypeOf(componentClass);
  const parentDefaultProps = getPropsPrototype(parentClass);
  const componentDefaultProps = getOwnProperty(componentClass, "defaultProps") || {};
  const componentPropDefs = parsePropTypes(componentDefaultProps);
  const defaultProps2 = Object.assign(/* @__PURE__ */ Object.create(null), parentDefaultProps, componentPropDefs.defaultProps);
  const propTypes2 = Object.assign(/* @__PURE__ */ Object.create(null), parentDefaultProps == null ? void 0 : parentDefaultProps[PROP_TYPES_SYMBOL], componentPropDefs.propTypes);
  const deprecatedProps = Object.assign(/* @__PURE__ */ Object.create(null), parentDefaultProps == null ? void 0 : parentDefaultProps[DEPRECATED_PROPS_SYMBOL], componentPropDefs.deprecatedProps);
  for (const extension of extensions) {
    const extensionDefaultProps = getPropsPrototype(extension.constructor);
    if (extensionDefaultProps) {
      Object.assign(defaultProps2, extensionDefaultProps);
      Object.assign(propTypes2, extensionDefaultProps[PROP_TYPES_SYMBOL]);
      Object.assign(deprecatedProps, extensionDefaultProps[DEPRECATED_PROPS_SYMBOL]);
    }
  }
  createPropsPrototype(defaultProps2, componentClass);
  addAsyncPropsToPropPrototype(defaultProps2, propTypes2);
  addDeprecatedPropsToPropPrototype(defaultProps2, deprecatedProps);
  defaultProps2[PROP_TYPES_SYMBOL] = propTypes2;
  defaultProps2[DEPRECATED_PROPS_SYMBOL] = deprecatedProps;
  if (extensions.length === 0 && !hasOwnProperty$3(componentClass, "_propTypes")) {
    componentClass._propTypes = propTypes2;
  }
  return defaultProps2;
}
function createPropsPrototype(defaultProps2, componentClass) {
  const id = getComponentName(componentClass);
  Object.defineProperties(defaultProps2, {
    // `id` is treated specially because layer might need to override it
    id: {
      writable: true,
      value: id
    }
  });
}
function addDeprecatedPropsToPropPrototype(defaultProps2, deprecatedProps) {
  for (const propName2 in deprecatedProps) {
    Object.defineProperty(defaultProps2, propName2, {
      enumerable: false,
      set(newValue) {
        const nameStr = `${this.id}: ${propName2}`;
        for (const newPropName of deprecatedProps[propName2]) {
          if (!hasOwnProperty$3(this, newPropName)) {
            this[newPropName] = newValue;
          }
        }
        log$1.deprecated(nameStr, deprecatedProps[propName2].join("/"))();
      }
    });
  }
}
function addAsyncPropsToPropPrototype(defaultProps2, propTypes2) {
  const defaultValues = {};
  const descriptors = {};
  for (const propName2 in propTypes2) {
    const propType = propTypes2[propName2];
    const { name: name2, value } = propType;
    if (propType.async) {
      defaultValues[name2] = value;
      descriptors[name2] = getDescriptorForAsyncProp(name2);
    }
  }
  defaultProps2[ASYNC_DEFAULTS_SYMBOL] = defaultValues;
  defaultProps2[ASYNC_ORIGINAL_SYMBOL] = {};
  Object.defineProperties(defaultProps2, descriptors);
}
function getDescriptorForAsyncProp(name2) {
  return {
    enumerable: true,
    // Save the provided value for async props in a special map
    set(newValue) {
      if (typeof newValue === "string" || newValue instanceof Promise || isAsyncIterable(newValue)) {
        this[ASYNC_ORIGINAL_SYMBOL][name2] = newValue;
      } else {
        this[ASYNC_RESOLVED_SYMBOL][name2] = newValue;
      }
    },
    // Only the component's state knows the true value of async prop
    get() {
      if (this[ASYNC_RESOLVED_SYMBOL]) {
        if (name2 in this[ASYNC_RESOLVED_SYMBOL]) {
          const value = this[ASYNC_RESOLVED_SYMBOL][name2];
          return value || this[ASYNC_DEFAULTS_SYMBOL][name2];
        }
        if (name2 in this[ASYNC_ORIGINAL_SYMBOL]) {
          const state = this[COMPONENT_SYMBOL] && this[COMPONENT_SYMBOL].internalState;
          if (state && state.hasAsyncProp(name2)) {
            return state.getAsyncProp(name2) || this[ASYNC_DEFAULTS_SYMBOL][name2];
          }
        }
      }
      return this[ASYNC_DEFAULTS_SYMBOL][name2];
    }
  };
}
function hasOwnProperty$3(object2, prop) {
  return Object.prototype.hasOwnProperty.call(object2, prop);
}
function getOwnProperty(object2, prop) {
  return hasOwnProperty$3(object2, prop) && object2[prop];
}
function getComponentName(componentClass) {
  const componentName = componentClass.componentName;
  if (!componentName) {
    log$1.warn(`${componentClass.name}.componentName not specified`)();
  }
  return componentName || componentClass.name;
}
let counter = 0;
const _Component = class {
  constructor(...propObjects) {
    this.props = createProps(this, propObjects);
    this.id = this.props.id;
    this.count = counter++;
  }
  // clone this layer with modified props
  clone(newProps) {
    const { props } = this;
    const asyncProps = {};
    for (const key in props[ASYNC_DEFAULTS_SYMBOL]) {
      if (key in props[ASYNC_RESOLVED_SYMBOL]) {
        asyncProps[key] = props[ASYNC_RESOLVED_SYMBOL][key];
      } else if (key in props[ASYNC_ORIGINAL_SYMBOL]) {
        asyncProps[key] = props[ASYNC_ORIGINAL_SYMBOL][key];
      }
    }
    return new this.constructor({ ...props, ...asyncProps, ...newProps });
  }
};
let Component = _Component;
(() => {
  _Component.componentName = "Component";
})();
(() => {
  _Component.defaultProps = {};
})();
const EMPTY_PROPS = Object.freeze({});
class ComponentState {
  constructor(component) {
    this.component = component;
    this.asyncProps = {};
    this.onAsyncPropUpdated = () => {
    };
    this.oldProps = null;
    this.oldAsyncProps = null;
  }
  finalize() {
    for (const propName2 in this.asyncProps) {
      const asyncProp = this.asyncProps[propName2];
      if (asyncProp && asyncProp.type && asyncProp.type.release) {
        asyncProp.type.release(asyncProp.resolvedValue, asyncProp.type, this.component);
      }
    }
    this.asyncProps = {};
    this.component = null;
    this.resetOldProps();
  }
  /* Layer-facing props API */
  getOldProps() {
    return this.oldAsyncProps || this.oldProps || EMPTY_PROPS;
  }
  resetOldProps() {
    this.oldAsyncProps = null;
    this.oldProps = this.component ? this.component.props : null;
  }
  // Checks if a prop is overridden
  hasAsyncProp(propName2) {
    return propName2 in this.asyncProps;
  }
  // Returns value of an overriden prop
  getAsyncProp(propName2) {
    const asyncProp = this.asyncProps[propName2];
    return asyncProp && asyncProp.resolvedValue;
  }
  isAsyncPropLoading(propName2) {
    if (propName2) {
      const asyncProp = this.asyncProps[propName2];
      return Boolean(asyncProp && asyncProp.pendingLoadCount > 0 && asyncProp.pendingLoadCount !== asyncProp.resolvedLoadCount);
    }
    for (const key in this.asyncProps) {
      if (this.isAsyncPropLoading(key)) {
        return true;
      }
    }
    return false;
  }
  // Without changing the original prop value, swap out the data resolution under the hood
  reloadAsyncProp(propName2, value) {
    this._watchPromise(propName2, Promise.resolve(value));
  }
  // Updates all async/overridden props (when new props come in)
  // Checks if urls have changed, starts loading, or removes override
  setAsyncProps(props) {
    this.component = props[COMPONENT_SYMBOL] || this.component;
    const resolvedValues = props[ASYNC_RESOLVED_SYMBOL] || {};
    const originalValues = props[ASYNC_ORIGINAL_SYMBOL] || props;
    const defaultValues = props[ASYNC_DEFAULTS_SYMBOL] || {};
    for (const propName2 in resolvedValues) {
      const value = resolvedValues[propName2];
      this._createAsyncPropData(propName2, defaultValues[propName2]);
      this._updateAsyncProp(propName2, value);
      resolvedValues[propName2] = this.getAsyncProp(propName2);
    }
    for (const propName2 in originalValues) {
      const value = originalValues[propName2];
      this._createAsyncPropData(propName2, defaultValues[propName2]);
      this._updateAsyncProp(propName2, value);
    }
  }
  /* Placeholder methods for subclassing */
  _fetch(propName2, url2) {
    return null;
  }
  _onResolve(propName2, value) {
  }
  // eslint-disable-line @typescript-eslint/no-empty-function
  _onError(propName2, error2) {
  }
  // eslint-disable-line @typescript-eslint/no-empty-function
  // Intercept strings (URLs) and Promises and activates loading and prop rewriting
  _updateAsyncProp(propName2, value) {
    if (!this._didAsyncInputValueChange(propName2, value)) {
      return;
    }
    if (typeof value === "string") {
      value = this._fetch(propName2, value);
    }
    if (value instanceof Promise) {
      this._watchPromise(propName2, value);
      return;
    }
    if (isAsyncIterable(value)) {
      this._resolveAsyncIterable(propName2, value);
      return;
    }
    this._setPropValue(propName2, value);
  }
  // Whenever async props are changing, we need to make a copy of oldProps
  // otherwise the prop rewriting will affect the value both in props and oldProps.
  // While the copy is relatively expensive, this only happens on load completion.
  _freezeAsyncOldProps() {
    if (!this.oldAsyncProps && this.oldProps) {
      this.oldAsyncProps = Object.create(this.oldProps);
      for (const propName2 in this.asyncProps) {
        Object.defineProperty(this.oldAsyncProps, propName2, {
          enumerable: true,
          value: this.oldProps[propName2]
        });
      }
    }
  }
  // Checks if an input value actually changed (to avoid reloading/rewatching promises/urls)
  _didAsyncInputValueChange(propName2, value) {
    const asyncProp = this.asyncProps[propName2];
    if (value === asyncProp.resolvedValue || value === asyncProp.lastValue) {
      return false;
    }
    asyncProp.lastValue = value;
    return true;
  }
  // Set normal, non-async value
  _setPropValue(propName2, value) {
    this._freezeAsyncOldProps();
    const asyncProp = this.asyncProps[propName2];
    if (asyncProp) {
      value = this._postProcessValue(asyncProp, value);
      asyncProp.resolvedValue = value;
      asyncProp.pendingLoadCount++;
      asyncProp.resolvedLoadCount = asyncProp.pendingLoadCount;
    }
  }
  // Set a just resolved async value, calling onAsyncPropUpdates if value changes asynchronously
  _setAsyncPropValue(propName2, value, loadCount) {
    const asyncProp = this.asyncProps[propName2];
    if (asyncProp && loadCount >= asyncProp.resolvedLoadCount && value !== void 0) {
      this._freezeAsyncOldProps();
      asyncProp.resolvedValue = value;
      asyncProp.resolvedLoadCount = loadCount;
      this.onAsyncPropUpdated(propName2, value);
    }
  }
  // Tracks a promise, sets the prop when loaded, handles load count
  _watchPromise(propName2, promise) {
    const asyncProp = this.asyncProps[propName2];
    if (asyncProp) {
      asyncProp.pendingLoadCount++;
      const loadCount = asyncProp.pendingLoadCount;
      promise.then((data2) => {
        if (!this.component) {
          return;
        }
        data2 = this._postProcessValue(asyncProp, data2);
        this._setAsyncPropValue(propName2, data2, loadCount);
        this._onResolve(propName2, data2);
      }).catch((error2) => {
        this._onError(propName2, error2);
      });
    }
  }
  async _resolveAsyncIterable(propName2, iterable) {
    if (propName2 !== "data") {
      this._setPropValue(propName2, iterable);
      return;
    }
    const asyncProp = this.asyncProps[propName2];
    if (!asyncProp) {
      return;
    }
    asyncProp.pendingLoadCount++;
    const loadCount = asyncProp.pendingLoadCount;
    let data2 = [];
    let count3 = 0;
    for await (const chunk of iterable) {
      if (!this.component) {
        return;
      }
      const { dataTransform } = this.component.props;
      if (dataTransform) {
        data2 = dataTransform(chunk, data2);
      } else {
        data2 = data2.concat(chunk);
      }
      Object.defineProperty(data2, "__diff", {
        enumerable: false,
        value: [{ startRow: count3, endRow: data2.length }]
      });
      count3 = data2.length;
      this._setAsyncPropValue(propName2, data2, loadCount);
    }
    this._onResolve(propName2, data2);
  }
  // Give the app a chance to post process the loaded data
  _postProcessValue(asyncProp, value) {
    const propType = asyncProp.type;
    if (propType && this.component) {
      if (propType.release) {
        propType.release(asyncProp.resolvedValue, propType, this.component);
      }
      if (propType.transform) {
        return propType.transform(value, propType, this.component);
      }
    }
    return value;
  }
  // Creating an asyncProp record if needed
  _createAsyncPropData(propName2, defaultValue2) {
    const asyncProp = this.asyncProps[propName2];
    if (!asyncProp) {
      const propTypes2 = this.component && this.component.props[PROP_TYPES_SYMBOL];
      this.asyncProps[propName2] = {
        type: propTypes2 && propTypes2[propName2],
        lastValue: null,
        resolvedValue: defaultValue2,
        pendingLoadCount: 0,
        resolvedLoadCount: 0
      };
    }
  }
}
class LayerState extends ComponentState {
  constructor({ attributeManager, layer }) {
    super(layer);
    this.attributeManager = attributeManager;
    this.needsRedraw = true;
    this.needsUpdate = true;
    this.subLayers = null;
    this.usesPickingColorCache = false;
  }
  get layer() {
    return this.component;
  }
  /* Override base Component methods with Layer-specific handling */
  _fetch(propName2, url2) {
    const layer = this.layer;
    const fetch2 = layer == null ? void 0 : layer.props.fetch;
    if (fetch2) {
      return fetch2(url2, { propName: propName2, layer });
    }
    return super._fetch(propName2, url2);
  }
  _onResolve(propName2, value) {
    const layer = this.layer;
    if (layer) {
      const onDataLoad = layer.props.onDataLoad;
      if (propName2 === "data" && onDataLoad) {
        onDataLoad(value, { propName: propName2, layer });
      }
    }
  }
  _onError(propName2, error2) {
    const layer = this.layer;
    if (layer) {
      layer.raiseError(error2, `loading ${propName2} of ${this.layer}`);
    }
  }
}
const TRACE_CHANGE_FLAG = "layer.changeFlag";
const TRACE_INITIALIZE = "layer.initialize";
const TRACE_UPDATE = "layer.update";
const TRACE_FINALIZE = "layer.finalize";
const TRACE_MATCHED = "layer.matched";
const MAX_PICKING_COLOR_CACHE_SIZE = 2 ** 24 - 1;
const EMPTY_ARRAY$1 = Object.freeze([]);
const areViewportsEqual = memoize$1(({ oldViewport, viewport }) => {
  return oldViewport.equals(viewport);
});
let pickingColorCache = new Uint8ClampedArray(0);
const defaultProps$o = {
  // data: Special handling for null, see below
  data: { type: "data", value: EMPTY_ARRAY$1, async: true },
  dataComparator: { type: "function", value: null, optional: true },
  _dataDiff: {
    type: "function",
    // @ts-ignore __diff is not defined on data
    value: (data2) => data2 && data2.__diff,
    optional: true
  },
  dataTransform: { type: "function", value: null, optional: true },
  onDataLoad: { type: "function", value: null, optional: true },
  onError: { type: "function", value: null, optional: true },
  fetch: {
    type: "function",
    value: (url2, { propName: propName2, layer, loaders, loadOptions, signal }) => {
      const { resourceManager } = layer.context;
      loadOptions = loadOptions || layer.getLoadOptions();
      loaders = loaders || layer.props.loaders;
      if (signal) {
        loadOptions = {
          ...loadOptions,
          fetch: {
            ...loadOptions == null ? void 0 : loadOptions.fetch,
            signal
          }
        };
      }
      let inResourceManager = resourceManager.contains(url2);
      if (!inResourceManager && !loadOptions) {
        resourceManager.add({ resourceId: url2, data: load(url2, loaders), persistent: false });
        inResourceManager = true;
      }
      if (inResourceManager) {
        return resourceManager.subscribe({
          resourceId: url2,
          onChange: (data2) => {
            var _a3;
            return (_a3 = layer.internalState) == null ? void 0 : _a3.reloadAsyncProp(propName2, data2);
          },
          consumerId: layer.id,
          requestId: propName2
        });
      }
      return load(url2, loaders, loadOptions);
    }
  },
  updateTriggers: {},
  // Update triggers: a core change detection mechanism in deck.gl
  visible: true,
  pickable: false,
  opacity: { type: "number", min: 0, max: 1, value: 1 },
  operation: "draw",
  onHover: { type: "function", value: null, optional: true },
  onClick: { type: "function", value: null, optional: true },
  onDragStart: { type: "function", value: null, optional: true },
  onDrag: { type: "function", value: null, optional: true },
  onDragEnd: { type: "function", value: null, optional: true },
  coordinateSystem: COORDINATE_SYSTEM.DEFAULT,
  coordinateOrigin: { type: "array", value: [0, 0, 0], compare: true },
  modelMatrix: { type: "array", value: null, compare: true, optional: true },
  wrapLongitude: false,
  positionFormat: "XYZ",
  colorFormat: "RGBA",
  parameters: { type: "object", value: {}, optional: true, compare: 2 },
  loadOptions: { type: "object", value: null, optional: true, ignore: true },
  transitions: null,
  extensions: [],
  loaders: { type: "array", value: [], optional: true, ignore: true },
  // Offset depth based on layer index to avoid z-fighting.
  // Negative values pull layer towards the camera
  // https://www.opengl.org/archives/resources/faq/technical/polygonoffset.htm
  getPolygonOffset: {
    type: "function",
    value: ({ layerIndex }) => [0, -layerIndex * 100]
  },
  // Selection/Highlighting
  highlightedObjectIndex: null,
  autoHighlight: false,
  highlightColor: { type: "accessor", value: [0, 0, 128, 128] }
};
const _Layer = class extends Component {
  constructor() {
    super(...arguments);
    this.internalState = null;
    this.lifecycle = LIFECYCLE.NO_STATE;
    this.parent = null;
  }
  static get componentName() {
    return Object.prototype.hasOwnProperty.call(this, "layerName") ? this.layerName : "";
  }
  get root() {
    let layer = this;
    while (layer.parent) {
      layer = layer.parent;
    }
    return layer;
  }
  toString() {
    const className = this.constructor.layerName || this.constructor.name;
    return `${className}({id: '${this.props.id}'})`;
  }
  // Public API for users
  /** Projects a point with current view state from the current layer's coordinate system to screen */
  project(xyz) {
    assert$7(this.internalState);
    const viewport = this.internalState.viewport || this.context.viewport;
    const worldPosition = getWorldPosition(xyz, {
      viewport,
      modelMatrix: this.props.modelMatrix,
      coordinateOrigin: this.props.coordinateOrigin,
      coordinateSystem: this.props.coordinateSystem
    });
    const [x2, y2, z2] = worldToPixels(worldPosition, viewport.pixelProjectionMatrix);
    return xyz.length === 2 ? [x2, y2] : [x2, y2, z2];
  }
  /** Unprojects a screen pixel to the current view's default coordinate system
      Note: this does not reverse `project`. */
  unproject(xy) {
    assert$7(this.internalState);
    const viewport = this.internalState.viewport || this.context.viewport;
    return viewport.unproject(xy);
  }
  /** Projects a point with current view state from the current layer's coordinate system to the world space */
  projectPosition(xyz, params2) {
    assert$7(this.internalState);
    const viewport = this.internalState.viewport || this.context.viewport;
    return projectPosition(xyz, {
      viewport,
      modelMatrix: this.props.modelMatrix,
      coordinateOrigin: this.props.coordinateOrigin,
      coordinateSystem: this.props.coordinateSystem,
      ...params2
    });
  }
  // Public API for custom layer implementation
  /** `true` if this layer renders other layers */
  get isComposite() {
    return false;
  }
  /** Updates selected state members and marks the layer for redraw */
  setState(partialState) {
    this.setChangeFlags({ stateChanged: true });
    Object.assign(this.state, partialState);
    this.setNeedsRedraw();
  }
  /** Sets the redraw flag for this layer, will trigger a redraw next animation frame */
  setNeedsRedraw() {
    if (this.internalState) {
      this.internalState.needsRedraw = true;
    }
  }
  /** Mark this layer as needs a deep update */
  setNeedsUpdate() {
    if (this.internalState) {
      this.context.layerManager.setNeedsUpdate(String(this));
      this.internalState.needsUpdate = true;
    }
  }
  /** Returns true if all async resources are loaded */
  get isLoaded() {
    return this.internalState ? !this.internalState.isAsyncPropLoading() : false;
  }
  /** Returns true if using shader-based WGS84 longitude wrapping */
  get wrapLongitude() {
    return this.props.wrapLongitude;
  }
  /** @deprecated Returns true if the layer is visible in the picking pass */
  isPickable() {
    return this.props.pickable && this.props.visible;
  }
  /** Returns an array of models used by this layer, can be overriden by layer subclass */
  getModels() {
    const state = this.state;
    return state && (state.models || state.model && [state.model]) || [];
  }
  // TODO deprecate in favour of setShaderModuleProps
  /** Update shader module parameters */
  setModuleParameters(moduleParameters) {
    for (const model of this.getModels()) {
      model.updateModuleSettings(moduleParameters);
    }
  }
  /** Update shader input parameters */
  setShaderModuleProps(...props) {
    for (const model of this.getModels()) {
      model.shaderInputs.setProps(...props);
    }
  }
  /** Returns the attribute manager of this layer */
  getAttributeManager() {
    return this.internalState && this.internalState.attributeManager;
  }
  /** Returns the most recent layer that matched to this state
    (When reacting to an async event, this layer may no longer be the latest) */
  getCurrentLayer() {
    return this.internalState && this.internalState.layer;
  }
  /** Returns the default parse options for async props */
  getLoadOptions() {
    return this.props.loadOptions;
  }
  use64bitPositions() {
    const { coordinateSystem } = this.props;
    return coordinateSystem === COORDINATE_SYSTEM.DEFAULT || coordinateSystem === COORDINATE_SYSTEM.LNGLAT || coordinateSystem === COORDINATE_SYSTEM.CARTESIAN;
  }
  // Event handling
  onHover(info, pickingEvent) {
    if (this.props.onHover) {
      return this.props.onHover(info, pickingEvent) || false;
    }
    return false;
  }
  onClick(info, pickingEvent) {
    if (this.props.onClick) {
      return this.props.onClick(info, pickingEvent) || false;
    }
    return false;
  }
  // Returns the picking color that doesn't match any subfeature
  // Use if some graphics do not belong to any pickable subfeature
  // @return {Array} - a black color
  nullPickingColor() {
    return [0, 0, 0];
  }
  // Returns the picking color that doesn't match any subfeature
  // Use if some graphics do not belong to any pickable subfeature
  encodePickingColor(i2, target = []) {
    target[0] = i2 + 1 & 255;
    target[1] = i2 + 1 >> 8 & 255;
    target[2] = i2 + 1 >> 8 >> 8 & 255;
    return target;
  }
  // Returns the index corresponding to a picking color that doesn't match any subfeature
  // @param {Uint8Array} color - color array to be decoded
  // @return {Array} - the decoded picking color
  decodePickingColor(color) {
    assert$7(color instanceof Uint8Array);
    const [i1, i2, i3] = color;
    const index2 = i1 + i2 * 256 + i3 * 65536 - 1;
    return index2;
  }
  /** Deduces number of instances. Intention is to support:
    - Explicit setting of numInstances
    - Auto-deduction for ES6 containers that define a size member
    - Auto-deduction for Classic Arrays via the built-in length attribute
    - Auto-deduction via arrays */
  getNumInstances() {
    if (Number.isFinite(this.props.numInstances)) {
      return this.props.numInstances;
    }
    if (this.state && this.state.numInstances !== void 0) {
      return this.state.numInstances;
    }
    return count(this.props.data);
  }
  /** Buffer layout describes how many attribute values are packed for each data object
      The default (null) is one value each object.
      Some data formats (e.g. paths, polygons) have various length. Their buffer layout
      is in the form of [L0, L1, L2, ...] */
  getStartIndices() {
    if (this.props.startIndices) {
      return this.props.startIndices;
    }
    if (this.state && this.state.startIndices) {
      return this.state.startIndices;
    }
    return null;
  }
  // Default implementation
  getBounds() {
    var _a3;
    return (_a3 = this.getAttributeManager()) == null ? void 0 : _a3.getBounds(["positions", "instancePositions"]);
  }
  getShaders(shaders) {
    shaders = mergeShaders(shaders, {
      disableWarnings: true,
      modules: this.context.defaultShaderModules
    });
    for (const extension of this.props.extensions) {
      shaders = mergeShaders(shaders, extension.getShaders.call(this, extension));
    }
    return shaders;
  }
  /** Controls if updateState should be called. By default returns true if any prop has changed */
  shouldUpdateState(params2) {
    return params2.changeFlags.propsOrDataChanged;
  }
  /** Default implementation, all attributes will be invalidated and updated when data changes */
  // eslint-disable-next-line complexity
  updateState(params2) {
    const attributeManager = this.getAttributeManager();
    const { dataChanged } = params2.changeFlags;
    if (dataChanged && attributeManager) {
      if (Array.isArray(dataChanged)) {
        for (const dataRange of dataChanged) {
          attributeManager.invalidateAll(dataRange);
        }
      } else {
        attributeManager.invalidateAll();
      }
    }
    if (attributeManager) {
      const { props } = params2;
      const hasPickingBuffer = this.internalState.hasPickingBuffer;
      const needsPickingBuffer = Number.isInteger(props.highlightedObjectIndex) || props.pickable || props.extensions.some((extension) => extension.getNeedsPickingBuffer.call(this, extension));
      if (hasPickingBuffer !== needsPickingBuffer) {
        this.internalState.hasPickingBuffer = needsPickingBuffer;
        const { pickingColors, instancePickingColors } = attributeManager.attributes;
        const pickingColorsAttribute = pickingColors || instancePickingColors;
        if (pickingColorsAttribute) {
          if (needsPickingBuffer && pickingColorsAttribute.constant) {
            pickingColorsAttribute.constant = false;
            attributeManager.invalidate(pickingColorsAttribute.id);
          }
          if (!pickingColorsAttribute.value && !needsPickingBuffer) {
            pickingColorsAttribute.constant = true;
            pickingColorsAttribute.value = [0, 0, 0];
          }
        }
      }
    }
  }
  /** Called once when layer is no longer matched and state will be discarded. Layers can destroy WebGL resources here. */
  finalizeState(context2) {
    for (const model of this.getModels()) {
      model.destroy();
    }
    const attributeManager = this.getAttributeManager();
    if (attributeManager) {
      attributeManager.finalize();
    }
    if (this.context) {
      this.context.resourceManager.unsubscribe({ consumerId: this.id });
    }
    if (this.internalState) {
      this.internalState.uniformTransitions.clear();
      this.internalState.finalize();
    }
  }
  // If state has a model, draw it with supplied uniforms
  draw(opts) {
    for (const model of this.getModels()) {
      model.draw(opts);
    }
  }
  // called to populate the info object that is passed to the event handler
  // @return null to cancel event
  getPickingInfo({ info, mode: mode2, sourceLayer }) {
    const { index: index2 } = info;
    if (index2 >= 0) {
      if (Array.isArray(this.props.data)) {
        info.object = this.props.data[index2];
      }
    }
    return info;
  }
  // END LIFECYCLE METHODS
  // / INTERNAL METHODS - called by LayerManager, DeckRenderer and DeckPicker
  /** (Internal) Propagate an error event through the system */
  raiseError(error2, message2) {
    var _a3, _b3, _c2, _d2;
    if (message2) {
      error2 = new Error(`${message2}: ${error2.message}`, { cause: error2 });
    }
    if (!((_b3 = (_a3 = this.props).onError) == null ? void 0 : _b3.call(_a3, error2))) {
      (_d2 = (_c2 = this.context) == null ? void 0 : _c2.onError) == null ? void 0 : _d2.call(_c2, error2, this);
    }
  }
  /** (Internal) Checks if this layer needs redraw */
  getNeedsRedraw(opts = { clearRedrawFlags: false }) {
    return this._getNeedsRedraw(opts);
  }
  /** (Internal) Checks if this layer needs a deep update */
  needsUpdate() {
    if (!this.internalState) {
      return false;
    }
    return this.internalState.needsUpdate || this.hasUniformTransition() || this.shouldUpdateState(this._getUpdateParams());
  }
  /** Checks if this layer has ongoing uniform transition */
  hasUniformTransition() {
    var _a3;
    return ((_a3 = this.internalState) == null ? void 0 : _a3.uniformTransitions.active) || false;
  }
  /** Called when this layer is rendered into the given viewport */
  activateViewport(viewport) {
    if (!this.internalState) {
      return;
    }
    const oldViewport = this.internalState.viewport;
    this.internalState.viewport = viewport;
    if (!oldViewport || !areViewportsEqual({ oldViewport, viewport })) {
      this.setChangeFlags({ viewportChanged: true });
      if (this.isComposite) {
        if (this.needsUpdate()) {
          this.setNeedsUpdate();
        }
      } else {
        this._update();
      }
    }
  }
  /** Default implementation of attribute invalidation, can be redefined */
  invalidateAttribute(name2 = "all") {
    const attributeManager = this.getAttributeManager();
    if (!attributeManager) {
      return;
    }
    if (name2 === "all") {
      attributeManager.invalidateAll();
    } else {
      attributeManager.invalidate(name2);
    }
  }
  /** Send updated attributes to the WebGL model */
  updateAttributes(changedAttributes) {
    let bufferLayoutChanged = false;
    for (const id in changedAttributes) {
      if (changedAttributes[id].layoutChanged()) {
        bufferLayoutChanged = true;
      }
    }
    for (const model of this.getModels()) {
      this._setModelAttributes(model, changedAttributes, bufferLayoutChanged);
    }
  }
  /** Recalculate any attributes if needed */
  _updateAttributes() {
    const attributeManager = this.getAttributeManager();
    if (!attributeManager) {
      return;
    }
    const props = this.props;
    const numInstances = this.getNumInstances();
    const startIndices = this.getStartIndices();
    attributeManager.update({
      data: props.data,
      numInstances,
      startIndices,
      props,
      transitions: props.transitions,
      // @ts-ignore (TS2339) property attribute is not present on some acceptable data types
      buffers: props.data.attributes,
      context: this
    });
    const changedAttributes = attributeManager.getChangedAttributes({ clearChangedFlags: true });
    this.updateAttributes(changedAttributes);
  }
  /** Update attribute transitions. This is called in drawLayer, no model updates required. */
  _updateAttributeTransition() {
    const attributeManager = this.getAttributeManager();
    if (attributeManager) {
      attributeManager.updateTransition();
    }
  }
  /** Update uniform (prop) transitions. This is called in updateState, may result in model updates. */
  _updateUniformTransition() {
    const { uniformTransitions } = this.internalState;
    if (uniformTransitions.active) {
      const propsInTransition = uniformTransitions.update();
      const props = Object.create(this.props);
      for (const key in propsInTransition) {
        Object.defineProperty(props, key, { value: propsInTransition[key] });
      }
      return props;
    }
    return this.props;
  }
  /** Updater for the automatically populated instancePickingColors attribute */
  calculateInstancePickingColors(attribute, { numInstances }) {
    if (attribute.constant) {
      return;
    }
    const cacheSize = Math.floor(pickingColorCache.length / 4);
    this.internalState.usesPickingColorCache = true;
    if (cacheSize < numInstances) {
      if (numInstances > MAX_PICKING_COLOR_CACHE_SIZE) {
        log$1.warn("Layer has too many data objects. Picking might not be able to distinguish all objects.")();
      }
      pickingColorCache = defaultTypedArrayManager.allocate(pickingColorCache, numInstances, {
        size: 4,
        copy: true,
        maxCount: Math.max(numInstances, MAX_PICKING_COLOR_CACHE_SIZE)
      });
      const newCacheSize = Math.floor(pickingColorCache.length / 4);
      const pickingColor = [];
      for (let i2 = cacheSize; i2 < newCacheSize; i2++) {
        this.encodePickingColor(i2, pickingColor);
        pickingColorCache[i2 * 4 + 0] = pickingColor[0];
        pickingColorCache[i2 * 4 + 1] = pickingColor[1];
        pickingColorCache[i2 * 4 + 2] = pickingColor[2];
      }
    }
    attribute.value = pickingColorCache.subarray(0, numInstances * 4);
  }
  /** Apply changed attributes to model */
  _setModelAttributes(model, changedAttributes, bufferLayoutChanged = false) {
    var _a3;
    if (!Object.keys(changedAttributes).length) {
      return;
    }
    if (bufferLayoutChanged) {
      const attributeManager = this.getAttributeManager();
      model.setBufferLayout(attributeManager.getBufferLayouts(model));
      changedAttributes = attributeManager.getAttributes();
    }
    const excludeAttributes = ((_a3 = model.userData) == null ? void 0 : _a3.excludeAttributes) || {};
    const attributeBuffers = {};
    const constantAttributes = {};
    for (const name2 in changedAttributes) {
      if (excludeAttributes[name2]) {
        continue;
      }
      const values4 = changedAttributes[name2].getValue();
      for (const attributeName in values4) {
        const value = values4[attributeName];
        if (value instanceof Buffer$1) {
          if (changedAttributes[name2].settings.isIndexed) {
            model.setIndexBuffer(value);
          } else {
            attributeBuffers[attributeName] = value;
          }
        } else if (value) {
          constantAttributes[attributeName] = value;
        }
      }
    }
    model.setAttributes(attributeBuffers);
    model.setConstantAttributes(constantAttributes);
  }
  /** (Internal) Sets the picking color at the specified index to null picking color. Used for multi-depth picking.
     This method may be overriden by layer implementations */
  disablePickingIndex(objectIndex) {
    const data2 = this.props.data;
    if (!("attributes" in data2)) {
      this._disablePickingIndex(objectIndex);
      return;
    }
    const { pickingColors, instancePickingColors } = this.getAttributeManager().attributes;
    const colors = pickingColors || instancePickingColors;
    const externalColorAttribute = colors && data2.attributes && data2.attributes[colors.id];
    if (externalColorAttribute && externalColorAttribute.value) {
      const values4 = externalColorAttribute.value;
      const objectColor = this.encodePickingColor(objectIndex);
      for (let index2 = 0; index2 < data2.length; index2++) {
        const i2 = colors.getVertexOffset(index2);
        if (values4[i2] === objectColor[0] && values4[i2 + 1] === objectColor[1] && values4[i2 + 2] === objectColor[2]) {
          this._disablePickingIndex(index2);
        }
      }
    } else {
      this._disablePickingIndex(objectIndex);
    }
  }
  // TODO - simplify subclassing interface
  _disablePickingIndex(objectIndex) {
    const { pickingColors, instancePickingColors } = this.getAttributeManager().attributes;
    const colors = pickingColors || instancePickingColors;
    if (!colors) {
      return;
    }
    const start2 = colors.getVertexOffset(objectIndex);
    const end = colors.getVertexOffset(objectIndex + 1);
    colors.buffer.write(new Uint8Array(end - start2), start2);
  }
  /** (Internal) Re-enable all picking indices after multi-depth picking */
  restorePickingColors() {
    const { pickingColors, instancePickingColors } = this.getAttributeManager().attributes;
    const colors = pickingColors || instancePickingColors;
    if (!colors) {
      return;
    }
    if (
      // @ts-ignore (TS2531) this method is only called internally with internalState defined
      this.internalState.usesPickingColorCache && colors.value.buffer !== pickingColorCache.buffer
    ) {
      colors.value = pickingColorCache.subarray(0, colors.value.length);
    }
    colors.updateSubBuffer({ startOffset: 0 });
  }
  /* eslint-disable max-statements */
  /* (Internal) Called by layer manager when a new layer is found */
  _initialize() {
    assert$7(!this.internalState);
    assert$7(Number.isFinite(this.props.coordinateSystem));
    debug(TRACE_INITIALIZE, this);
    const attributeManager = this._getAttributeManager();
    if (attributeManager) {
      attributeManager.addInstanced({
        instancePickingColors: {
          type: "uint8",
          size: 4,
          noAlloc: true,
          // Updaters are always called with `this` pointing to the layer
          // eslint-disable-next-line @typescript-eslint/unbound-method
          update: this.calculateInstancePickingColors
        }
      });
    }
    this.internalState = new LayerState({
      attributeManager,
      layer: this
    });
    this._clearChangeFlags();
    this.state = {};
    Object.defineProperty(this.state, "attributeManager", {
      get: () => {
        log$1.deprecated("layer.state.attributeManager", "layer.getAttributeManager()")();
        return attributeManager;
      }
    });
    this.internalState.uniformTransitions = new UniformTransitionManager(this.context.timeline);
    this.internalState.onAsyncPropUpdated = this._onAsyncPropUpdated.bind(this);
    this.internalState.setAsyncProps(this.props);
    this.initializeState(this.context);
    for (const extension of this.props.extensions) {
      extension.initializeState.call(this, this.context, extension);
    }
    this.setChangeFlags({
      dataChanged: "init",
      propsChanged: "init",
      viewportChanged: true,
      extensionsChanged: true
    });
    this._update();
  }
  /** (Internal) Called by layer manager to transfer state from an old layer */
  _transferState(oldLayer) {
    debug(TRACE_MATCHED, this, this === oldLayer);
    const { state, internalState } = oldLayer;
    if (this === oldLayer) {
      return;
    }
    this.internalState = internalState;
    this.state = state;
    this.internalState.setAsyncProps(this.props);
    this._diffProps(this.props, this.internalState.getOldProps());
  }
  /** (Internal) Called by layer manager when a new layer is added or an existing layer is matched with a new instance */
  _update() {
    const stateNeedsUpdate = this.needsUpdate();
    debug(TRACE_UPDATE, this, stateNeedsUpdate);
    if (!stateNeedsUpdate) {
      return;
    }
    const currentProps = this.props;
    const context2 = this.context;
    const internalState = this.internalState;
    const currentViewport = context2.viewport;
    const propsInTransition = this._updateUniformTransition();
    internalState.propsInTransition = propsInTransition;
    context2.viewport = internalState.viewport || currentViewport;
    this.props = propsInTransition;
    try {
      const updateParams = this._getUpdateParams();
      const oldModels = this.getModels();
      if (context2.device) {
        this.updateState(updateParams);
      } else {
        try {
          this.updateState(updateParams);
        } catch (error2) {
        }
      }
      for (const extension of this.props.extensions) {
        extension.updateState.call(this, updateParams, extension);
      }
      const modelChanged = this.getModels()[0] !== oldModels[0];
      this._postUpdate(updateParams, modelChanged);
    } finally {
      context2.viewport = currentViewport;
      this.props = currentProps;
      this._clearChangeFlags();
      internalState.needsUpdate = false;
      internalState.resetOldProps();
    }
  }
  /* eslint-enable max-statements */
  /** (Internal) Called by manager when layer is about to be disposed
      Note: not guaranteed to be called on application shutdown */
  _finalize() {
    debug(TRACE_FINALIZE, this);
    this.finalizeState(this.context);
    for (const extension of this.props.extensions) {
      extension.finalizeState.call(this, this.context, extension);
    }
  }
  // Calculates uniforms
  _drawLayer({ renderPass, moduleParameters = null, uniforms = {}, parameters = {} }) {
    this._updateAttributeTransition();
    const currentProps = this.props;
    const context2 = this.context;
    this.props = this.internalState.propsInTransition || currentProps;
    const opacity = this.props.opacity;
    uniforms.opacity = Math.pow(opacity, 1 / 2.2);
    try {
      if (moduleParameters) {
        const { isActive, isAttribute: isAttribute2 } = moduleParameters.picking;
        this.setModuleParameters(moduleParameters);
        this.setShaderModuleProps({ picking: { isActive, isAttribute: isAttribute2 } });
      }
      const { getPolygonOffset } = this.props;
      const offsets = getPolygonOffset && getPolygonOffset(uniforms) || [0, 0];
      context2.device.setParametersWebGL({ polygonOffset: offsets });
      for (const model of this.getModels()) {
        model.setParameters(parameters);
      }
      context2.device.withParametersWebGL(parameters, () => {
        const opts = { renderPass, moduleParameters, uniforms, parameters, context: context2 };
        for (const extension of this.props.extensions) {
          extension.draw.call(this, opts, extension);
        }
        this.draw(opts);
      });
    } finally {
      this.props = currentProps;
    }
  }
  // Helper methods
  /** Returns the current change flags */
  getChangeFlags() {
    var _a3;
    return (_a3 = this.internalState) == null ? void 0 : _a3.changeFlags;
  }
  /* eslint-disable complexity */
  /** Dirty some change flags, will be handled by updateLayer */
  setChangeFlags(flags2) {
    if (!this.internalState) {
      return;
    }
    const { changeFlags } = this.internalState;
    for (const key in flags2) {
      if (flags2[key]) {
        let flagChanged = false;
        switch (key) {
          case "dataChanged":
            const dataChangedReason = flags2[key];
            const prevDataChangedReason = changeFlags[key];
            if (dataChangedReason && Array.isArray(prevDataChangedReason)) {
              changeFlags.dataChanged = Array.isArray(dataChangedReason) ? prevDataChangedReason.concat(dataChangedReason) : dataChangedReason;
              flagChanged = true;
            }
          default:
            if (!changeFlags[key]) {
              changeFlags[key] = flags2[key];
              flagChanged = true;
            }
        }
        if (flagChanged) {
          debug(TRACE_CHANGE_FLAG, this, key, flags2);
        }
      }
    }
    const propsOrDataChanged = Boolean(changeFlags.dataChanged || changeFlags.updateTriggersChanged || changeFlags.propsChanged || changeFlags.extensionsChanged);
    changeFlags.propsOrDataChanged = propsOrDataChanged;
    changeFlags.somethingChanged = propsOrDataChanged || changeFlags.viewportChanged || changeFlags.stateChanged;
  }
  /* eslint-enable complexity */
  /** Clear all changeFlags, typically after an update */
  _clearChangeFlags() {
    this.internalState.changeFlags = {
      dataChanged: false,
      propsChanged: false,
      updateTriggersChanged: false,
      viewportChanged: false,
      stateChanged: false,
      extensionsChanged: false,
      propsOrDataChanged: false,
      somethingChanged: false
    };
  }
  /** Compares the layers props with old props from a matched older layer
      and extracts change flags that describe what has change so that state
      can be update correctly with minimal effort */
  _diffProps(newProps, oldProps) {
    var _a3;
    const changeFlags = diffProps$1(newProps, oldProps);
    if (changeFlags.updateTriggersChanged) {
      for (const key in changeFlags.updateTriggersChanged) {
        if (changeFlags.updateTriggersChanged[key]) {
          this.invalidateAttribute(key);
        }
      }
    }
    if (changeFlags.transitionsChanged) {
      for (const key in changeFlags.transitionsChanged) {
        this.internalState.uniformTransitions.add(key, oldProps[key], newProps[key], (_a3 = newProps.transitions) == null ? void 0 : _a3[key]);
      }
    }
    return this.setChangeFlags(changeFlags);
  }
  /** (Internal) called by layer manager to perform extra props validation (in development only) */
  validateProps() {
    validateProps(this.props);
  }
  /** (Internal) Called by deck picker when the hovered object changes to update the auto highlight */
  updateAutoHighlight(info) {
    if (this.props.autoHighlight && !Number.isInteger(this.props.highlightedObjectIndex)) {
      this._updateAutoHighlight(info);
    }
  }
  // May be overriden by subclasses
  // TODO - simplify subclassing interface
  /** Update picking module parameters to highlight the hovered object */
  _updateAutoHighlight(info) {
    const picking2 = {
      highlightedObjectColor: info.picked ? info.color : null
    };
    const { highlightColor } = this.props;
    if (info.picked && typeof highlightColor === "function") {
      picking2.highlightColor = highlightColor(info);
    }
    this.setShaderModuleProps({ picking: picking2 });
    this.setNeedsRedraw();
  }
  /** Create new attribute manager */
  _getAttributeManager() {
    const context2 = this.context;
    return new AttributeManager(context2.device, {
      id: this.props.id,
      stats: context2.stats,
      timeline: context2.timeline
    });
  }
  // Private methods
  /** Called after updateState to perform common tasks */
  _postUpdate(updateParams, forceUpdate) {
    const { props, oldProps } = updateParams;
    this.setNeedsRedraw();
    this._updateAttributes();
    const model = this.state.model;
    if (model == null ? void 0 : model.isInstanced) {
      model.setInstanceCount(this.getNumInstances());
    }
    const { autoHighlight, highlightedObjectIndex, highlightColor } = props;
    if (forceUpdate || oldProps.autoHighlight !== autoHighlight || oldProps.highlightedObjectIndex !== highlightedObjectIndex || oldProps.highlightColor !== highlightColor) {
      const picking2 = {};
      if (!autoHighlight) {
        picking2.highlightedObjectColor = null;
      }
      if (Array.isArray(highlightColor)) {
        picking2.highlightColor = highlightColor;
      }
      if (forceUpdate || highlightedObjectIndex !== oldProps.highlightedObjectIndex) {
        picking2.highlightedObjectColor = Number.isFinite(highlightedObjectIndex) && highlightedObjectIndex >= 0 ? this.encodePickingColor(highlightedObjectIndex) : null;
      }
      this.setShaderModuleProps({ picking: picking2 });
    }
  }
  _getUpdateParams() {
    return {
      props: this.props,
      // @ts-ignore TS2531 this method can only be called internally with internalState assigned
      oldProps: this.internalState.getOldProps(),
      context: this.context,
      // @ts-ignore TS2531 this method can only be called internally with internalState assigned
      changeFlags: this.internalState.changeFlags
    };
  }
  /** Checks state of attributes and model */
  _getNeedsRedraw(opts) {
    if (!this.internalState) {
      return false;
    }
    let redraw = false;
    redraw = redraw || this.internalState.needsRedraw && this.id;
    const attributeManager = this.getAttributeManager();
    const attributeManagerNeedsRedraw = attributeManager ? attributeManager.getNeedsRedraw(opts) : false;
    redraw = redraw || attributeManagerNeedsRedraw;
    if (redraw) {
      for (const extension of this.props.extensions) {
        extension.onNeedsRedraw.call(this, extension);
      }
    }
    this.internalState.needsRedraw = this.internalState.needsRedraw && !opts.clearRedrawFlags;
    return redraw;
  }
  /** Callback when asyn prop is loaded */
  _onAsyncPropUpdated() {
    this._diffProps(this.props, this.internalState.getOldProps());
    this.setNeedsUpdate();
  }
};
let Layer = _Layer;
(() => {
  _Layer.defaultProps = defaultProps$o;
})();
(() => {
  _Layer.layerName = "Layer";
})();
const TRACE_RENDER_LAYERS = "compositeLayer.renderLayers";
const _CompositeLayer = class extends Layer {
  /** `true` if this layer renders other layers */
  get isComposite() {
    return true;
  }
  /** Returns true if all async resources are loaded */
  get isLoaded() {
    return super.isLoaded && this.getSubLayers().every((layer) => layer.isLoaded);
  }
  /** Return last rendered sub layers */
  getSubLayers() {
    return this.internalState && this.internalState.subLayers || [];
  }
  // initializeState is usually not needed for composite layers
  // Provide empty definition to disable check for missing definition
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  initializeState(context2) {
  }
  /** Updates selected state members and marks the composite layer to need rerender */
  setState(updateObject) {
    super.setState(updateObject);
    this.setNeedsUpdate();
  }
  /** called to augment the info object that is bubbled up from a sublayer
      override Layer.getPickingInfo() because decoding / setting uniform do
      not apply to a composite layer. */
  getPickingInfo({ info }) {
    const { object: object2 } = info;
    const isDataWrapped = object2 && object2.__source && object2.__source.parent && object2.__source.parent.id === this.id;
    if (!isDataWrapped) {
      return info;
    }
    info.object = object2.__source.object;
    info.index = object2.__source.index;
    return info;
  }
  /**
   * Filters sub layers at draw time. Return true if the sub layer should be drawn.
   */
  filterSubLayer(context2) {
    return true;
  }
  /** Returns true if sub layer needs to be rendered */
  shouldRenderSubLayer(subLayerId, data2) {
    return data2 && data2.length;
  }
  /** Returns sub layer class for a specific sublayer */
  getSubLayerClass(subLayerId, DefaultLayerClass) {
    const { _subLayerProps: overridingProps } = this.props;
    return overridingProps && overridingProps[subLayerId] && overridingProps[subLayerId].type || DefaultLayerClass;
  }
  /** When casting user data into another format to pass to sublayers,
      add reference to the original object and object index */
  getSubLayerRow(row, sourceObject, sourceObjectIndex) {
    row.__source = {
      parent: this,
      object: sourceObject,
      index: sourceObjectIndex
    };
    return row;
  }
  /** Some composite layers cast user data into another format before passing to sublayers
    We need to unwrap them before calling the accessor so that they see the original data
    objects */
  getSubLayerAccessor(accessor) {
    if (typeof accessor === "function") {
      const objectInfo = {
        index: -1,
        // @ts-ignore accessing resolved data
        data: this.props.data,
        target: []
      };
      return (x2, i2) => {
        if (x2 && x2.__source) {
          objectInfo.index = x2.__source.index;
          return accessor(x2.__source.object, objectInfo);
        }
        return accessor(x2, i2);
      };
    }
    return accessor;
  }
  /** Returns sub layer props for a specific sublayer */
  // eslint-disable-next-line complexity
  getSubLayerProps(sublayerProps = {}) {
    var _a3;
    const { opacity, pickable, visible, parameters, getPolygonOffset, highlightedObjectIndex, autoHighlight, highlightColor, coordinateSystem, coordinateOrigin, wrapLongitude, positionFormat, modelMatrix: modelMatrix2, extensions, fetch: fetch2, operation, _subLayerProps: overridingProps } = this.props;
    const newProps = {
      id: "",
      updateTriggers: {},
      opacity,
      pickable,
      visible,
      parameters,
      getPolygonOffset,
      highlightedObjectIndex,
      autoHighlight,
      highlightColor,
      coordinateSystem,
      coordinateOrigin,
      wrapLongitude,
      positionFormat,
      modelMatrix: modelMatrix2,
      extensions,
      fetch: fetch2,
      operation
    };
    const overridingSublayerProps = overridingProps && sublayerProps.id && overridingProps[sublayerProps.id];
    const overridingSublayerTriggers = overridingSublayerProps && overridingSublayerProps.updateTriggers;
    const sublayerId = sublayerProps.id || "sublayer";
    if (overridingSublayerProps) {
      const propTypes2 = this.props[PROP_TYPES_SYMBOL];
      const subLayerPropTypes = sublayerProps.type ? sublayerProps.type._propTypes : {};
      for (const key in overridingSublayerProps) {
        const propType = subLayerPropTypes[key] || propTypes2[key];
        if (propType && propType.type === "accessor") {
          overridingSublayerProps[key] = this.getSubLayerAccessor(overridingSublayerProps[key]);
        }
      }
    }
    Object.assign(
      newProps,
      sublayerProps,
      // experimental feature that allows users to override sublayer props via parent layer prop
      overridingSublayerProps
    );
    newProps.id = `${this.props.id}-${sublayerId}`;
    newProps.updateTriggers = {
      all: (_a3 = this.props.updateTriggers) == null ? void 0 : _a3.all,
      ...sublayerProps.updateTriggers,
      ...overridingSublayerTriggers
    };
    for (const extension of extensions) {
      const passThroughProps = extension.getSubLayerProps.call(this, extension);
      if (passThroughProps) {
        Object.assign(newProps, passThroughProps, {
          updateTriggers: Object.assign(newProps.updateTriggers, passThroughProps.updateTriggers)
        });
      }
    }
    return newProps;
  }
  /** Update sub layers to highlight the hovered object */
  _updateAutoHighlight(info) {
    for (const layer of this.getSubLayers()) {
      layer.updateAutoHighlight(info);
    }
  }
  /** Override base Layer method */
  _getAttributeManager() {
    return null;
  }
  /** (Internal) Called after an update to rerender sub layers */
  _postUpdate(updateParams, forceUpdate) {
    let subLayers = this.internalState.subLayers;
    const shouldUpdate = !subLayers || this.needsUpdate();
    if (shouldUpdate) {
      const subLayersList = this.renderLayers();
      subLayers = flatten$2(subLayersList, Boolean);
      this.internalState.subLayers = subLayers;
    }
    debug(TRACE_RENDER_LAYERS, this, shouldUpdate, subLayers);
    for (const layer of subLayers) {
      layer.parent = this;
    }
  }
};
let CompositeLayer = _CompositeLayer;
(() => {
  _CompositeLayer.layerName = "CompositeLayer";
})();
const DEGREES_TO_RADIANS$1 = Math.PI / 180;
const RADIANS_TO_DEGREES = 180 / Math.PI;
const EARTH_RADIUS = 6370972;
const GLOBE_RADIUS = 256;
function getDistanceScales() {
  const unitsPerMeter2 = GLOBE_RADIUS / EARTH_RADIUS;
  const unitsPerDegree = Math.PI / 180 * GLOBE_RADIUS;
  return {
    unitsPerMeter: [unitsPerMeter2, unitsPerMeter2, unitsPerMeter2],
    unitsPerMeter2: [0, 0, 0],
    metersPerUnit: [1 / unitsPerMeter2, 1 / unitsPerMeter2, 1 / unitsPerMeter2],
    unitsPerDegree: [unitsPerDegree, unitsPerDegree, unitsPerMeter2],
    unitsPerDegree2: [0, 0, 0],
    degreesPerUnit: [1 / unitsPerDegree, 1 / unitsPerDegree, 1 / unitsPerMeter2]
  };
}
class GlobeViewport extends Viewport {
  constructor(opts = {}) {
    const { latitude = 0, longitude = 0, zoom: zoom2 = 0, nearZMultiplier = 0.1, farZMultiplier = 2, resolution = 10 } = opts;
    let { height, altitude = 1.5 } = opts;
    height = height || 1;
    altitude = Math.max(0.75, altitude);
    const viewMatrix = new Matrix4().lookAt({ eye: [0, -altitude, 0], up: [0, 0, 1] });
    const scale5 = Math.pow(2, zoom2);
    viewMatrix.rotateX(latitude * DEGREES_TO_RADIANS$1);
    viewMatrix.rotateZ(-longitude * DEGREES_TO_RADIANS$1);
    viewMatrix.scale(scale5 / height);
    const halfFov = Math.atan(0.5 / altitude);
    const relativeScale = GLOBE_RADIUS * 2 * scale5 / height;
    super({
      ...opts,
      // x, y, width,
      height,
      // view matrix
      viewMatrix,
      longitude,
      latitude,
      zoom: zoom2,
      // projection matrix parameters
      distanceScales: getDistanceScales(),
      fovyRadians: halfFov * 2,
      focalDistance: altitude,
      near: nearZMultiplier,
      far: Math.min(2, 1 / relativeScale + 1) * altitude * farZMultiplier
    });
    this.latitude = latitude;
    this.longitude = longitude;
    this.resolution = resolution;
  }
  get projectionMode() {
    return PROJECTION_MODE.GLOBE;
  }
  getDistanceScales() {
    return this.distanceScales;
  }
  getBounds(options2 = {}) {
    const unprojectOption = { targetZ: options2.z || 0 };
    const left = this.unproject([0, this.height / 2], unprojectOption);
    const top = this.unproject([this.width / 2, 0], unprojectOption);
    const right = this.unproject([this.width, this.height / 2], unprojectOption);
    const bottom = this.unproject([this.width / 2, this.height], unprojectOption);
    if (right[0] < this.longitude)
      right[0] += 360;
    if (left[0] > this.longitude)
      left[0] -= 360;
    return [
      Math.min(left[0], right[0], top[0], bottom[0]),
      Math.min(left[1], right[1], top[1], bottom[1]),
      Math.max(left[0], right[0], top[0], bottom[0]),
      Math.max(left[1], right[1], top[1], bottom[1])
    ];
  }
  unproject(xyz, { topLeft = true, targetZ } = {}) {
    const [x2, y2, z2] = xyz;
    const y22 = topLeft ? y2 : this.height - y2;
    const { pixelUnprojectionMatrix } = this;
    let coord;
    if (Number.isFinite(z2)) {
      coord = transformVector(pixelUnprojectionMatrix, [x2, y22, z2, 1]);
    } else {
      const coord0 = transformVector(pixelUnprojectionMatrix, [x2, y22, -1, 1]);
      const coord1 = transformVector(pixelUnprojectionMatrix, [x2, y22, 1, 1]);
      const lt2 = ((targetZ || 0) / EARTH_RADIUS + 1) * GLOBE_RADIUS;
      const lSqr = sqrLen(sub([], coord0, coord1));
      const l0Sqr = sqrLen(coord0);
      const l1Sqr = sqrLen(coord1);
      const sSqr = (4 * l0Sqr * l1Sqr - (lSqr - l0Sqr - l1Sqr) ** 2) / 16;
      const dSqr = 4 * sSqr / lSqr;
      const r0 = Math.sqrt(l0Sqr - dSqr);
      const dr = Math.sqrt(Math.max(0, lt2 * lt2 - dSqr));
      const t2 = (r0 - dr) / Math.sqrt(lSqr);
      coord = lerp$2([], coord0, coord1, t2);
    }
    const [X2, Y2, Z2] = this.unprojectPosition(coord);
    if (Number.isFinite(z2)) {
      return [X2, Y2, Z2];
    }
    return Number.isFinite(targetZ) ? [X2, Y2, targetZ] : [X2, Y2];
  }
  projectPosition(xyz) {
    const [lng, lat, Z2 = 0] = xyz;
    const lambda = lng * DEGREES_TO_RADIANS$1;
    const phi = lat * DEGREES_TO_RADIANS$1;
    const cosPhi = Math.cos(phi);
    const D2 = (Z2 / EARTH_RADIUS + 1) * GLOBE_RADIUS;
    return [Math.sin(lambda) * cosPhi * D2, -Math.cos(lambda) * cosPhi * D2, Math.sin(phi) * D2];
  }
  unprojectPosition(xyz) {
    const [x2, y2, z2] = xyz;
    const D2 = len(xyz);
    const phi = Math.asin(z2 / D2);
    const lambda = Math.atan2(x2, -y2);
    const lng = lambda * RADIANS_TO_DEGREES;
    const lat = phi * RADIANS_TO_DEGREES;
    const Z2 = (D2 / GLOBE_RADIUS - 1) * EARTH_RADIUS;
    return [lng, lat, Z2];
  }
  projectFlat(xyz) {
    return xyz;
  }
  unprojectFlat(xyz) {
    return xyz;
  }
  panByPosition(coords, pixel) {
    const fromPosition = this.unproject(pixel);
    return {
      longitude: coords[0] - fromPosition[0] + this.longitude,
      latitude: coords[1] - fromPosition[1] + this.latitude
    };
  }
}
function transformVector(matrix, vector) {
  const result = transformMat4([], vector, matrix);
  scale$1(result, result, 1 / result[3]);
  return result;
}
const _LayerExtension = class {
  static get componentName() {
    return Object.prototype.hasOwnProperty.call(this, "extensionName") ? this.extensionName : "";
  }
  constructor(opts) {
    if (opts) {
      this.opts = opts;
    }
  }
  /** Returns true if two extensions are equivalent */
  equals(extension) {
    if (this === extension) {
      return true;
    }
    return this.constructor === extension.constructor && deepEqual(this.opts, extension.opts, 1);
  }
  /** Only called if attached to a primitive layer */
  getShaders(extension) {
    return null;
  }
  /** Only called if attached to a CompositeLayer */
  getSubLayerProps(extension) {
    const { defaultProps: defaultProps2 } = extension.constructor;
    const newProps = {
      updateTriggers: {}
    };
    for (const key in defaultProps2) {
      if (key in this.props) {
        const propDef = defaultProps2[key];
        const propValue = this.props[key];
        newProps[key] = propValue;
        if (propDef && propDef.type === "accessor") {
          newProps.updateTriggers[key] = this.props.updateTriggers[key];
          if (typeof propValue === "function") {
            newProps[key] = this.getSubLayerAccessor(propValue);
          }
        }
      }
    }
    return newProps;
  }
  /* eslint-disable @typescript-eslint/no-empty-function */
  initializeState(context2, extension) {
  }
  updateState(params2, extension) {
  }
  onNeedsRedraw(extension) {
  }
  getNeedsPickingBuffer(extension) {
    return false;
  }
  draw(params2, extension) {
  }
  finalizeState(context2, extension) {
  }
};
let LayerExtension = _LayerExtension;
(() => {
  _LayerExtension.defaultProps = {};
})();
(() => {
  _LayerExtension.extensionName = "LayerExtension";
})();
class Tesselator {
  constructor(opts) {
    this.indexStarts = [0];
    this.vertexStarts = [0];
    this.vertexCount = 0;
    this.instanceCount = 0;
    const { attributes = {} } = opts;
    this.typedArrayManager = defaultTypedArrayManager;
    this.attributes = {};
    this._attributeDefs = attributes;
    this.opts = opts;
    this.updateGeometry(opts);
  }
  /* Public methods */
  updateGeometry(opts) {
    Object.assign(this.opts, opts);
    const { data: data2, buffers = {}, getGeometry: getGeometry4, geometryBuffer, positionFormat, dataChanged, normalize: normalize5 = true } = this.opts;
    this.data = data2;
    this.getGeometry = getGeometry4;
    this.positionSize = // @ts-ignore (2339) when geometryBuffer is a luma Buffer, size falls back to positionFormat
    geometryBuffer && geometryBuffer.size || (positionFormat === "XY" ? 2 : 3);
    this.buffers = buffers;
    this.normalize = normalize5;
    if (geometryBuffer) {
      assert$7(data2.startIndices);
      this.getGeometry = this.getGeometryFromBuffer(geometryBuffer);
      if (!normalize5) {
        buffers.vertexPositions = geometryBuffer;
      }
    }
    this.geometryBuffer = buffers.vertexPositions;
    if (Array.isArray(dataChanged)) {
      for (const dataRange of dataChanged) {
        this._rebuildGeometry(dataRange);
      }
    } else {
      this._rebuildGeometry();
    }
  }
  updatePartialGeometry({ startRow, endRow }) {
    this._rebuildGeometry({ startRow, endRow });
  }
  getGeometryFromBuffer(geometryBuffer) {
    const value = geometryBuffer.value || geometryBuffer;
    if (!ArrayBuffer.isView(value)) {
      return null;
    }
    return getAccessorFromBuffer(value, {
      size: this.positionSize,
      offset: geometryBuffer.offset,
      stride: geometryBuffer.stride,
      startIndices: this.data.startIndices
    });
  }
  /* Private utility methods */
  _allocate(instanceCount, copy8) {
    const { attributes, buffers, _attributeDefs, typedArrayManager } = this;
    for (const name2 in _attributeDefs) {
      if (name2 in buffers) {
        typedArrayManager.release(attributes[name2]);
        attributes[name2] = null;
      } else {
        const def = _attributeDefs[name2];
        def.copy = copy8;
        attributes[name2] = typedArrayManager.allocate(attributes[name2], instanceCount, def);
      }
    }
  }
  /**
   * Visit all objects
   * `data` is expected to be an iterable consistent with the base Layer expectation
   */
  _forEachGeometry(visitor, startRow, endRow) {
    const { data: data2, getGeometry: getGeometry4 } = this;
    const { iterable, objectInfo } = createIterable(data2, startRow, endRow);
    for (const object2 of iterable) {
      objectInfo.index++;
      const geometry2 = getGeometry4 ? getGeometry4(object2, objectInfo) : null;
      visitor(geometry2, objectInfo.index);
    }
  }
  /* eslint-disable complexity,max-statements */
  _rebuildGeometry(dataRange) {
    if (!this.data) {
      return;
    }
    let { indexStarts, vertexStarts, instanceCount } = this;
    const { data: data2, geometryBuffer } = this;
    const { startRow = 0, endRow = Infinity } = dataRange || {};
    const normalizedData = {};
    if (!dataRange) {
      indexStarts = [0];
      vertexStarts = [0];
    }
    if (this.normalize || !geometryBuffer) {
      this._forEachGeometry((geometry2, dataIndex) => {
        const normalizedGeometry = geometry2 && this.normalizeGeometry(geometry2);
        normalizedData[dataIndex] = normalizedGeometry;
        vertexStarts[dataIndex + 1] = vertexStarts[dataIndex] + (normalizedGeometry ? this.getGeometrySize(normalizedGeometry) : 0);
      }, startRow, endRow);
      instanceCount = vertexStarts[vertexStarts.length - 1];
    } else {
      vertexStarts = data2.startIndices;
      instanceCount = vertexStarts[data2.length] || 0;
      if (ArrayBuffer.isView(geometryBuffer)) {
        instanceCount = instanceCount || geometryBuffer.length / this.positionSize;
      } else if (geometryBuffer instanceof Buffer$1) {
        const byteStride = this.positionSize * 4;
        instanceCount = instanceCount || geometryBuffer.byteLength / byteStride;
      } else if (geometryBuffer.buffer) {
        const byteStride = geometryBuffer.stride || this.positionSize * 4;
        instanceCount = instanceCount || geometryBuffer.buffer.byteLength / byteStride;
      } else if (geometryBuffer.value) {
        const bufferValue = geometryBuffer.value;
        const elementStride = (
          // @ts-ignore (2339) if stride is not specified, will fall through to positionSize
          geometryBuffer.stride / bufferValue.BYTES_PER_ELEMENT || this.positionSize
        );
        instanceCount = instanceCount || bufferValue.length / elementStride;
      }
    }
    this._allocate(instanceCount, Boolean(dataRange));
    this.indexStarts = indexStarts;
    this.vertexStarts = vertexStarts;
    this.instanceCount = instanceCount;
    const context2 = {};
    this._forEachGeometry((geometry2, dataIndex) => {
      const normalizedGeometry = normalizedData[dataIndex] || geometry2;
      context2.vertexStart = vertexStarts[dataIndex];
      context2.indexStart = indexStarts[dataIndex];
      const vertexEnd = dataIndex < vertexStarts.length - 1 ? vertexStarts[dataIndex + 1] : instanceCount;
      context2.geometrySize = vertexEnd - vertexStarts[dataIndex];
      context2.geometryIndex = dataIndex;
      this.updateGeometryAttributes(normalizedGeometry, context2);
    }, startRow, endRow);
    this.vertexCount = indexStarts[indexStarts.length - 1];
  }
}
const TILE_SIZE$3 = 512;
const DEGREES_TO_RADIANS = Math.PI / 180;
function getDeckInstance({ map: map5, gl, deck }) {
  if (map5.__deck) {
    return map5.__deck;
  }
  const customRender = deck == null ? void 0 : deck.props._customRender;
  const onLoad = deck == null ? void 0 : deck.props.onLoad;
  const deckProps = getInterleavedProps({
    ...deck == null ? void 0 : deck.props,
    _customRender: () => {
      map5.triggerRepaint();
      customRender == null ? void 0 : customRender("");
    }
  });
  let deckInstance;
  if (!deck || deck.props.gl === gl) {
    Object.assign(deckProps, {
      gl,
      width: null,
      height: null,
      touchAction: "unset",
      viewState: getViewState(map5)
    });
    if (deck == null ? void 0 : deck.isInitialized) {
      watchMapMove(deck, map5);
    } else {
      deckProps.onLoad = () => {
        onLoad == null ? void 0 : onLoad();
        watchMapMove(deckInstance, map5);
      };
    }
  }
  if (deck) {
    deckInstance = deck;
    deck.setProps(deckProps);
    deck.userData.isExternal = true;
  } else {
    deckInstance = new Deck(deckProps);
    map5.on("remove", () => {
      removeDeckInstance(map5);
    });
  }
  deckInstance.userData.mapboxLayers = /* @__PURE__ */ new Set();
  map5.__deck = deckInstance;
  map5.on("render", () => {
    if (deckInstance.isInitialized)
      afterRender(deckInstance, map5);
  });
  return deckInstance;
}
function watchMapMove(deck, map5) {
  const _handleMapMove = () => {
    if (deck.isInitialized) {
      onMapMove(deck, map5);
    } else {
      map5.off("move", _handleMapMove);
    }
  };
  map5.on("move", _handleMapMove);
}
function removeDeckInstance(map5) {
  var _a3;
  (_a3 = map5.__deck) == null ? void 0 : _a3.finalize();
  map5.__deck = null;
}
function getInterleavedProps(currProps) {
  const nextProps = {
    ...currProps,
    // TODO: remove with withParametersWebGL
    parameters: {
      depthMask: true,
      depthTest: true,
      blend: true,
      blendFunc: [770, 771, 1, 771],
      polygonOffsetFill: true,
      depthFunc: 515,
      blendEquation: 32774,
      ...currProps.parameters
    },
    // @ts-ignore views prop is hidden by the types because it is not expected to work the same way as in standalone Deck, see documentation
    views: currProps.views || [new MapView({ id: "mapbox" })]
  };
  return nextProps;
}
function addLayer(deck, layer) {
  deck.userData.mapboxLayers.add(layer);
  updateLayers(deck);
}
function removeLayer(deck, layer) {
  deck.userData.mapboxLayers.delete(layer);
  updateLayers(deck);
}
function updateLayer(deck, layer) {
  updateLayers(deck);
}
function drawLayer(deck, map5, layer) {
  let { currentViewport } = deck.userData;
  let clearStack = false;
  if (!currentViewport) {
    currentViewport = getViewport(deck, map5, true);
    deck.userData.currentViewport = currentViewport;
    clearStack = true;
  }
  if (!deck.isInitialized) {
    return;
  }
  deck._drawLayers("mapbox-repaint", {
    viewports: [currentViewport],
    layerFilter: ({ layer: deckLayer }) => layer.id === deckLayer.id || deckLayer.props.operation.includes("terrain"),
    clearStack,
    clearCanvas: false
  });
}
function getViewState(map5) {
  var _a3;
  const { lng, lat } = map5.getCenter();
  const viewState = {
    // Longitude returned by getCenter can be outside of [-180, 180] when zooming near the anti meridian
    // https://github.com/visgl/deck.gl/issues/6894
    longitude: (lng + 540) % 360 - 180,
    latitude: lat,
    zoom: map5.getZoom(),
    bearing: map5.getBearing(),
    pitch: map5.getPitch(),
    padding: map5.getPadding(),
    repeat: map5.getRenderWorldCopies()
  };
  if ((_a3 = map5.getTerrain) == null ? void 0 : _a3.call(map5)) {
    centerCameraOnTerrain(map5, viewState);
  }
  return viewState;
}
function centerCameraOnTerrain(map5, viewState) {
  if (map5.getFreeCameraOptions) {
    const { position } = map5.getFreeCameraOptions();
    if (!position || position.z === void 0) {
      return;
    }
    const height = map5.transform.height;
    const { longitude, latitude, pitch } = viewState;
    const cameraX = position.x * TILE_SIZE$3;
    const cameraY = (1 - position.y) * TILE_SIZE$3;
    const cameraZ = position.z * TILE_SIZE$3;
    const center2 = lngLatToWorld([longitude, latitude]);
    const dx = cameraX - center2[0];
    const dy = cameraY - center2[1];
    const cameraToCenterDistanceGround = Math.sqrt(dx * dx + dy * dy);
    const pitchRadians = pitch * DEGREES_TO_RADIANS;
    const altitudePixels = 1.5 * height;
    const scale5 = pitchRadians < 1e-3 ? (
      // Pitch angle too small to deduce the look at point, assume elevation is 0
      altitudePixels * Math.cos(pitchRadians) / cameraZ
    ) : altitudePixels * Math.sin(pitchRadians) / cameraToCenterDistanceGround;
    viewState.zoom = Math.log2(scale5);
    const cameraZFromSurface = altitudePixels * Math.cos(pitchRadians) / scale5;
    const surfaceElevation = cameraZ - cameraZFromSurface;
    viewState.position = [0, 0, surfaceElevation / unitsPerMeter(latitude)];
  } else if (typeof map5.transform.elevation === "number") {
    viewState.position = [0, 0, map5.transform.elevation];
  }
}
function getViewport(deck, map5, useMapboxProjection = true) {
  return new WebMercatorViewport({
    id: "mapbox",
    x: 0,
    y: 0,
    width: deck.width,
    height: deck.height,
    ...getViewState(map5),
    nearZMultiplier: useMapboxProjection ? (
      // match mapbox-gl@>=1.3.0's projection matrix
      0.02
    ) : (
      // use deck.gl's own default
      0.1
    ),
    nearZ: map5.transform._nearZ / map5.transform.height,
    farZ: map5.transform._farZ / map5.transform.height
  });
}
function afterRender(deck, map5) {
  const { mapboxLayers, isExternal } = deck.userData;
  if (isExternal) {
    const mapboxLayerIds = Array.from(mapboxLayers, (layer) => layer.id);
    const deckLayers = flatten$2(deck.props.layers, Boolean);
    const hasNonMapboxLayers = deckLayers.some((layer) => layer && !mapboxLayerIds.includes(layer.id));
    let viewports = deck.getViewports();
    const mapboxViewportIdx = viewports.findIndex((vp) => vp.id === "mapbox");
    const hasNonMapboxViews = viewports.length > 1 || mapboxViewportIdx < 0;
    if (hasNonMapboxLayers || hasNonMapboxViews) {
      if (mapboxViewportIdx >= 0) {
        viewports = viewports.slice();
        viewports[mapboxViewportIdx] = getViewport(deck, map5, false);
      }
      deck._drawLayers("mapbox-repaint", {
        viewports,
        layerFilter: (params2) => (!deck.props.layerFilter || deck.props.layerFilter(params2)) && (params2.viewport.id !== "mapbox" || !mapboxLayerIds.includes(params2.layer.id)),
        clearCanvas: false
      });
    }
  }
  deck.userData.currentViewport = null;
}
function onMapMove(deck, map5) {
  deck.setProps({
    viewState: getViewState(map5)
  });
  deck.needsRedraw({ clearRedrawFlags: true });
}
function updateLayers(deck) {
  if (deck.userData.isExternal) {
    return;
  }
  const layers = [];
  deck.userData.mapboxLayers.forEach((deckLayer) => {
    const LayerType = deckLayer.props.type;
    const layer = new LayerType(deckLayer.props);
    layers.push(layer);
  });
  deck.setProps({ layers });
}
class MapboxLayer {
  /* eslint-disable no-this-before-super */
  constructor(props) {
    if (!props.id) {
      throw new Error("Layer must have an unique id");
    }
    this.id = props.id;
    this.type = "custom";
    this.renderingMode = props.renderingMode || "3d";
    this.map = null;
    this.deck = null;
    this.props = props;
  }
  /* Mapbox custom layer methods */
  onAdd(map5, gl) {
    this.map = map5;
    this.deck = getDeckInstance({ map: map5, gl, deck: this.props.deck });
    addLayer(this.deck, this);
  }
  onRemove() {
    if (this.deck) {
      removeLayer(this.deck, this);
    }
  }
  setProps(props) {
    Object.assign(this.props, props, { id: this.id });
    if (this.deck) {
      updateLayer(this.deck);
    }
  }
  render() {
    drawLayer(this.deck, this.map, this);
  }
}
const UNDEFINED_BEFORE_ID = "__UNDEFINED__";
function resolveLayers(map5, deck, oldLayers, newLayers) {
  if (!map5 || !deck || !map5.style || !map5.style._loaded) {
    return;
  }
  const layers = flatten$2(newLayers, Boolean);
  if (oldLayers !== newLayers) {
    const prevLayers = flatten$2(oldLayers, Boolean);
    const prevLayerIds = new Set(prevLayers.map((l2) => l2.id));
    for (const layer of layers) {
      prevLayerIds.delete(layer.id);
    }
    for (const id of prevLayerIds) {
      if (map5.getLayer(id)) {
        map5.removeLayer(id);
      }
    }
  }
  for (const layer of layers) {
    const mapboxLayer = map5.getLayer(layer.id);
    if (mapboxLayer) {
      mapboxLayer.implementation.setProps(layer.props);
    } else {
      map5.addLayer(
        new MapboxLayer({ id: layer.id, deck }),
        // @ts-expect-error beforeId is not defined in LayerProps
        layer.props.beforeId
      );
    }
  }
  const mapLayers = map5.style._order;
  const layerGroups = {};
  for (const layer of layers) {
    let { beforeId } = layer.props;
    if (!beforeId || !mapLayers.includes(beforeId)) {
      beforeId = UNDEFINED_BEFORE_ID;
    }
    layerGroups[beforeId] = layerGroups[beforeId] || [];
    layerGroups[beforeId].push(layer.id);
  }
  for (const beforeId in layerGroups) {
    const layerGroup = layerGroups[beforeId];
    let lastLayerIndex = beforeId === UNDEFINED_BEFORE_ID ? mapLayers.length : mapLayers.indexOf(beforeId);
    let lastLayerId = beforeId === UNDEFINED_BEFORE_ID ? void 0 : beforeId;
    for (let i2 = layerGroup.length - 1; i2 >= 0; i2--) {
      const layerId = layerGroup[i2];
      const layerIndex = mapLayers.indexOf(layerId);
      if (layerIndex !== lastLayerIndex - 1) {
        map5.moveLayer(layerId, lastLayerId);
        if (layerIndex > lastLayerIndex) {
          lastLayerIndex++;
        }
      }
      lastLayerIndex--;
      lastLayerId = layerId;
    }
  }
}
class MapboxOverlay {
  constructor(props) {
    this._handleStyleChange = () => {
      resolveLayers(this._map, this._deck, this._props.layers, this._props.layers);
    };
    this._updateContainerSize = () => {
      if (this._map && this._container) {
        const { clientWidth, clientHeight } = this._map.getContainer();
        Object.assign(this._container.style, {
          width: `${clientWidth}px`,
          height: `${clientHeight}px`
        });
      }
    };
    this._updateViewState = () => {
      const deck = this._deck;
      if (deck) {
        deck.setProps({ viewState: getViewState(this._map) });
        if (deck.isInitialized) {
          deck.redraw();
        }
      }
    };
    this._handleMouseEvent = (event) => {
      const deck = this._deck;
      if (!deck || !deck.isInitialized) {
        return;
      }
      const mockEvent = {
        type: event.type,
        offsetCenter: event.point,
        srcEvent: event
      };
      const lastDown = this._lastMouseDownPoint;
      if (!event.point && lastDown) {
        mockEvent.deltaX = event.originalEvent.clientX - lastDown.clientX;
        mockEvent.deltaY = event.originalEvent.clientY - lastDown.clientY;
        mockEvent.offsetCenter = {
          x: lastDown.x + mockEvent.deltaX,
          y: lastDown.y + mockEvent.deltaY
        };
      }
      switch (mockEvent.type) {
        case "mousedown":
          deck._onPointerDown(mockEvent);
          this._lastMouseDownPoint = {
            ...event.point,
            clientX: event.originalEvent.clientX,
            clientY: event.originalEvent.clientY
          };
          break;
        case "dragstart":
          mockEvent.type = "panstart";
          deck._onEvent(mockEvent);
          break;
        case "drag":
          mockEvent.type = "panmove";
          deck._onEvent(mockEvent);
          break;
        case "dragend":
          mockEvent.type = "panend";
          deck._onEvent(mockEvent);
          break;
        case "click":
          mockEvent.tapCount = 1;
          deck._onEvent(mockEvent);
          break;
        case "dblclick":
          mockEvent.type = "click";
          mockEvent.tapCount = 2;
          deck._onEvent(mockEvent);
          break;
        case "mousemove":
          mockEvent.type = "pointermove";
          deck._onPointerMove(mockEvent);
          break;
        case "mouseout":
          mockEvent.type = "pointerleave";
          deck._onPointerMove(mockEvent);
          break;
        default:
          return;
      }
    };
    const { interleaved = false, ...otherProps } = props;
    this._interleaved = interleaved;
    this._props = otherProps;
  }
  /** Update (partial) props of the underlying Deck instance. */
  setProps(props) {
    if (this._interleaved && props.layers) {
      resolveLayers(this._map, this._deck, this._props.layers, props.layers);
    }
    Object.assign(this._props, props);
    if (this._deck) {
      this._deck.setProps(this._interleaved ? getInterleavedProps(this._props) : this._props);
    }
  }
  /** Called when the control is added to a map */
  onAdd(map5) {
    this._map = map5;
    return this._interleaved ? this._onAddInterleaved(map5) : this._onAddOverlaid(map5);
  }
  _onAddOverlaid(map5) {
    const container = document.createElement("div");
    Object.assign(container.style, {
      position: "absolute",
      left: 0,
      top: 0,
      textAlign: "initial",
      pointerEvents: "none"
    });
    this._container = container;
    this._deck = new Deck({
      ...this._props,
      parent: container,
      viewState: getViewState(map5)
    });
    map5.on("resize", this._updateContainerSize);
    map5.on("render", this._updateViewState);
    map5.on("mousedown", this._handleMouseEvent);
    map5.on("dragstart", this._handleMouseEvent);
    map5.on("drag", this._handleMouseEvent);
    map5.on("dragend", this._handleMouseEvent);
    map5.on("mousemove", this._handleMouseEvent);
    map5.on("mouseout", this._handleMouseEvent);
    map5.on("click", this._handleMouseEvent);
    map5.on("dblclick", this._handleMouseEvent);
    this._updateContainerSize();
    return container;
  }
  _onAddInterleaved(map5) {
    const gl = map5.painter.context.gl;
    if (gl instanceof WebGLRenderingContext) {
      log$1.warn("Incompatible basemap library. See: https://deck.gl/docs/api-reference/mapbox/overview#compatibility")();
    }
    this._deck = getDeckInstance({
      map: map5,
      gl,
      deck: new Deck({
        ...this._props,
        gl
      })
    });
    map5.on("styledata", this._handleStyleChange);
    resolveLayers(map5, this._deck, [], this._props.layers);
    return document.createElement("div");
  }
  /** Called when the control is removed from a map */
  onRemove() {
    const map5 = this._map;
    if (map5) {
      if (this._interleaved) {
        this._onRemoveInterleaved(map5);
      } else {
        this._onRemoveOverlaid(map5);
      }
    }
    this._deck = void 0;
    this._map = void 0;
    this._container = void 0;
  }
  _onRemoveOverlaid(map5) {
    var _a3;
    map5.off("resize", this._updateContainerSize);
    map5.off("render", this._updateViewState);
    map5.off("mousedown", this._handleMouseEvent);
    map5.off("dragstart", this._handleMouseEvent);
    map5.off("drag", this._handleMouseEvent);
    map5.off("dragend", this._handleMouseEvent);
    map5.off("mousemove", this._handleMouseEvent);
    map5.off("mouseout", this._handleMouseEvent);
    map5.off("click", this._handleMouseEvent);
    map5.off("dblclick", this._handleMouseEvent);
    (_a3 = this._deck) == null ? void 0 : _a3.finalize();
  }
  _onRemoveInterleaved(map5) {
    map5.off("styledata", this._handleStyleChange);
    resolveLayers(map5, this._deck, this._props.layers, []);
    removeDeckInstance(map5);
  }
  getDefaultPosition() {
    return "top-left";
  }
  /** Forwards the Deck.pickObject method */
  pickObject(params2) {
    assert$7(this._deck);
    return this._deck.pickObject(params2);
  }
  /** Forwards the Deck.pickMultipleObjects method */
  pickMultipleObjects(params2) {
    assert$7(this._deck);
    return this._deck.pickMultipleObjects(params2);
  }
  /** Forwards the Deck.pickObjects method */
  pickObjects(params2) {
    assert$7(this._deck);
    return this._deck.pickObjects(params2);
  }
  /** Remove from map and releases all resources */
  finalize() {
    if (this._map) {
      this._map.removeControl(this);
    }
  }
  /** If interleaved: true, returns base map's canvas, otherwise forwards the Deck.getCanvas method. */
  getCanvas() {
    if (!this._map) {
      return null;
    }
    return this._interleaved ? this._map.getCanvas() : this._deck.getCanvas();
  }
}
const EVENTS = [
  "onDeviceInitialized",
  "onViewStateChange",
  "onInteractionStateChange",
  "onHover",
  "onClick",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onLoad",
  "onResize",
  "onBeforeRender",
  "onAfterRender",
  "onError"
  // '_onMetrics',
];
const MapboxDeckGlOverlayContext = React__default.createContext();
function MapboxDeckGlOverlayProvider(props) {
  const {
    children,
    enable: enable4,
    ...restPropsIn
  } = props;
  const [cursorCallbacks, setCursorCallbacks] = React__default.useState([]);
  const [listeners2, setListeners] = React__default.useState({});
  const listenersRef = useValueRef(listeners2);
  const addCursorCallback = React__default.useCallback((callback) => {
    if (callback) {
      setCursorCallbacks((previous) => {
        const updated = [...previous, callback];
        return updated;
      });
    }
  }, []);
  const removeCursorCallback = React__default.useCallback((callback) => {
    if (callback) {
      setCursorCallbacks((previous) => {
        const index2 = previous.indexOf(callback);
        if (index2 < 0)
          return previous;
        return [...previous.slice(0, index2), ...previous.slice(index2 + 1, previous.length)];
      });
    }
  }, []);
  const addListener3 = React__default.useCallback((eventType, callback) => {
    if (EVENTS.includes(eventType)) {
      setListeners((listeners22) => {
        let updates = [];
        const existing = listeners22[eventType] || [];
        if (existing.includes(callback)) {
          updates = existing;
        } else {
          updates = [...existing, callback];
        }
        return {
          ...listeners22,
          [eventType]: updates
        };
      });
    }
  }, []);
  const removeListener3 = React__default.useCallback((eventType, callback) => {
    if (EVENTS.includes(eventType)) {
      setListeners((listeners22) => {
        const existing = listeners22[eventType] || [];
        const index2 = existing.findIndex((cb2) => cb2 === callback);
        if (index2 < -1)
          return listeners22;
        const updates = [...existing.slice(0, index2), ...existing.slice(index2 + 1, existing.length)];
        return {
          ...listeners22,
          [eventType]: updates
        };
      });
    }
  }, []);
  const invokeListener = React__default.useCallback((eventType, ...args) => {
    const eventListeners = listenersRef.current[eventType] || [];
    eventListeners.forEach((callback) => {
      callback(...args);
    });
  }, [listenersRef]);
  React__default.useLayoutEffect(() => {
    EVENTS.forEach((key) => {
      const callbackIn = restPropsIn[key];
      if (callbackIn && typeof callbackIn === "function") {
        addListener3(key, callbackIn);
      }
    });
    return () => {
      EVENTS.forEach((key) => {
        const callbackIn = restPropsIn[key];
        if (callbackIn && typeof callbackIn === "function") {
          removeListener3(key, callbackIn);
        }
      });
    };
  }, [addListener3, removeListener3, restPropsIn]);
  const getCursorCb = React__default.useCallback((input) => {
    const len2 = cursorCallbacks.length;
    if (len2) {
      cursorCallbacks[len2 - 1](input);
    }
  }, [cursorCallbacks]);
  const getCursor2 = useMutableFunc(getCursorCb);
  const restProps = React__default.useMemo(() => {
    const restProps2 = {
      ...restPropsIn,
      getCursor: getCursor2
    };
    EVENTS.forEach((key) => {
      restProps2[key] = (...args) => invokeListener(key, ...args);
    });
    return restProps2;
  }, [getCursor2, invokeListener, restPropsIn]);
  const overlay = useControl(() => new MapboxOverlay({
    interleaved: true,
    ...restProps
  }));
  const value = React__default.useMemo(() => {
    if (!enable4)
      return {
        enable: enable4
      };
    return {
      enable: enable4,
      overlay,
      addListener: addListener3,
      removeListener: removeListener3,
      eventKeys: EVENTS,
      addCursorCallback,
      removeCursorCallback
    };
  }, [addCursorCallback, addListener3, enable4, overlay, removeCursorCallback, removeListener3]);
  return /* @__PURE__ */ jsx(MapboxDeckGlOverlayContext.Provider, { value, children });
}
MapboxDeckGlOverlayProvider.propTypes = {
  children: propTypesExports$1.node,
  enable: propTypesExports$1.bool
};
MapboxDeckGlOverlayProvider.defaultProps = {
  children: null,
  enable: true
};
const useMapboxDeckGlOverlay = () => React__default.useContext(MapboxDeckGlOverlayContext);
function DeckGlOverlay(props) {
  const {
    layer: layerIn,
    minZoom,
    maxZoom,
    ...restProps
  } = props;
  const [visible, setVisible] = React__default.useState(true);
  const {
    enable: enable4,
    overlay,
    addListener: addListener3,
    removeListener: removeListener3,
    eventKeys: eventKeys2
  } = useMapboxDeckGlOverlay();
  const {
    map: map5
  } = useMapbox();
  React__default.useLayoutEffect(() => {
    if (!map5 || !layerIn)
      return () => {
      };
    if (minZoom === 0 && maxZoom === 24)
      return () => {
      };
    const listener = () => {
      const currentZoom = map5.getZoom();
      if (currentZoom < minZoom || currentZoom > maxZoom) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    };
    map5.on("move", listener);
    return () => map5.off("move", listener);
  }, [layerIn, map5, maxZoom, minZoom]);
  React__default.useEffect(() => {
    var _a3;
    if (!enable4 || !overlay || !layerIn || !visible)
      return () => {
      };
    const filteredProps = {
      ...restProps
    };
    const registered = {};
    eventKeys2 == null ? void 0 : eventKeys2.forEach((key) => {
      const callback = filteredProps[key];
      if (callback) {
        delete filteredProps[key];
        addListener3(key, callback);
        registered[key] = callback;
      }
    });
    const existingLayers = ((_a3 = overlay._props) == null ? void 0 : _a3.layers) || [];
    const layersIn = Array.isArray(layerIn) ? layerIn : [layerIn];
    const layers = [...existingLayers];
    layersIn.forEach((lay) => {
      if (!lay)
        return;
      const layer = lay.clone();
      const found = existingLayers.find((l2) => l2.id === layer.id);
      if (!found) {
        layers.push(layer);
      }
    });
    overlay.setProps({
      layers,
      ...filteredProps
    });
    return () => {
      var _a4;
      try {
        Object.keys(registered).forEach((key) => {
          removeListener3(key, registered[key]);
          delete registered[key];
        });
        let existingLayers2 = ((_a4 = overlay == null ? void 0 : overlay._props) == null ? void 0 : _a4.layers) || [];
        layersIn.forEach((layer) => {
          const index2 = existingLayers2.findIndex((l2) => l2.id === layer.id);
          if (index2 > -1) {
            existingLayers2 = [...existingLayers2.slice(0, index2), ...existingLayers2.slice(index2 + 1, existingLayers2.length)];
          }
        });
        overlay.setProps({
          layers: existingLayers2
        });
      } catch (error2) {
        console.error(error2);
      }
    };
  }, [addListener3, enable4, eventKeys2, layerIn, overlay, removeListener3, restProps, visible]);
  return null;
}
DeckGlOverlay.propTypes = {
  layer: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.array]),
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number
};
DeckGlOverlay.defaultProps = {
  layer: null,
  minZoom: 0,
  maxZoom: 24
};
const vs$b = `#version 300 es
#define SHADER_NAME icon-layer-vertex-shader
in vec2 positions;
in vec3 instancePositions;
in vec3 instancePositions64Low;
in float instanceSizes;
in float instanceAngles;
in vec4 instanceColors;
in vec3 instancePickingColors;
in vec4 instanceIconFrames;
in float instanceColorModes;
in vec2 instanceOffsets;
in vec2 instancePixelOffset;
uniform float sizeScale;
uniform vec2 iconsTextureDim;
uniform float sizeMinPixels;
uniform float sizeMaxPixels;
uniform bool billboard;
uniform int sizeUnits;
out float vColorMode;
out vec4 vColor;
out vec2 vTextureCoords;
out vec2 uv;
vec2 rotate_by_angle(vec2 vertex, float angle) {
float angle_radian = angle * PI / 180.0;
float cos_angle = cos(angle_radian);
float sin_angle = sin(angle_radian);
mat2 rotationMatrix = mat2(cos_angle, -sin_angle, sin_angle, cos_angle);
return rotationMatrix * vertex;
}
void main(void) {
geometry.worldPosition = instancePositions;
geometry.uv = positions;
geometry.pickingColor = instancePickingColors;
uv = positions;
vec2 iconSize = instanceIconFrames.zw;
float sizePixels = clamp(
project_size_to_pixel(instanceSizes * sizeScale, sizeUnits),
sizeMinPixels, sizeMaxPixels
);
float instanceScale = iconSize.y == 0.0 ? 0.0 : sizePixels / iconSize.y;
vec2 pixelOffset = positions / 2.0 * iconSize + instanceOffsets;
pixelOffset = rotate_by_angle(pixelOffset, instanceAngles) * instanceScale;
pixelOffset += instancePixelOffset;
pixelOffset.y *= -1.0;
if (billboard)  {
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
vec3 offset = vec3(pixelOffset, 0.0);
DECKGL_FILTER_SIZE(offset, geometry);
gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);
} else {
vec3 offset_common = vec3(project_pixel_size(pixelOffset), 0.0);
DECKGL_FILTER_SIZE(offset_common, geometry);
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset_common, geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
}
vTextureCoords = mix(
instanceIconFrames.xy,
instanceIconFrames.xy + iconSize,
(positions.xy + 1.0) / 2.0
) / iconsTextureDim;
vColor = instanceColors;
DECKGL_FILTER_COLOR(vColor, geometry);
vColorMode = instanceColorModes;
}
`;
const fs$d = `#version 300 es
#define SHADER_NAME icon-layer-fragment-shader
precision highp float;
uniform float opacity;
uniform sampler2D iconsTexture;
uniform float alphaCutoff;
in float vColorMode;
in vec4 vColor;
in vec2 vTextureCoords;
in vec2 uv;
out vec4 fragColor;
void main(void) {
geometry.uv = uv;
vec4 texColor = texture(iconsTexture, vTextureCoords);
vec3 color = mix(texColor.rgb, vColor.rgb, vColorMode);
float a = texColor.a * opacity * vColor.a;
if (a < alphaCutoff) {
discard;
}
fragColor = vec4(color, a);
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_CANVAS_WIDTH = 1024;
const DEFAULT_BUFFER$1 = 4;
const noop$2 = () => {
};
const DEFAULT_SAMPLER_PARAMETERS$2 = {
  minFilter: "linear",
  mipmapFilter: "linear",
  // LINEAR is the default value but explicitly set it here
  magFilter: "linear",
  // minimize texture boundary artifacts
  addressModeU: "clamp-to-edge",
  addressModeV: "clamp-to-edge"
};
const MISSING_ICON = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};
function nextPowOfTwo$1(number2) {
  return Math.pow(2, Math.ceil(Math.log2(number2)));
}
function resizeImage(ctx2, imageData, maxWidth, maxHeight) {
  const resizeRatio = Math.min(maxWidth / imageData.width, maxHeight / imageData.height);
  const width = Math.floor(imageData.width * resizeRatio);
  const height = Math.floor(imageData.height * resizeRatio);
  if (resizeRatio === 1) {
    return { data: imageData, width, height };
  }
  ctx2.canvas.height = height;
  ctx2.canvas.width = width;
  ctx2.clearRect(0, 0, width, height);
  ctx2.drawImage(imageData, 0, 0, imageData.width, imageData.height, 0, 0, width, height);
  return { data: ctx2.canvas, width, height };
}
function getIconId(icon) {
  return icon && (icon.id || icon.url);
}
function resizeTexture(texture, width, height, sampler) {
  const { width: oldWidth, height: oldHeight, device } = texture;
  const newTexture = device.createTexture({ format: "rgba8unorm", width, height, sampler });
  const commandEncoder = device.createCommandEncoder();
  commandEncoder.copyTextureToTexture({
    source: texture,
    destination: newTexture,
    width: oldWidth,
    height: oldHeight
  });
  commandEncoder.finish();
  texture.destroy();
  return newTexture;
}
function buildRowMapping(mapping, columns, yOffset) {
  for (let i2 = 0; i2 < columns.length; i2++) {
    const { icon, xOffset } = columns[i2];
    const id = getIconId(icon);
    mapping[id] = {
      ...icon,
      x: xOffset,
      y: yOffset
    };
  }
}
function buildMapping$1({ icons, buffer: buffer3, mapping = {}, xOffset = 0, yOffset = 0, rowHeight = 0, canvasWidth }) {
  let columns = [];
  for (let i2 = 0; i2 < icons.length; i2++) {
    const icon = icons[i2];
    const id = getIconId(icon);
    if (!mapping[id]) {
      const { height, width } = icon;
      if (xOffset + width + buffer3 > canvasWidth) {
        buildRowMapping(mapping, columns, yOffset);
        xOffset = 0;
        yOffset = rowHeight + yOffset + buffer3;
        rowHeight = 0;
        columns = [];
      }
      columns.push({
        icon,
        xOffset
      });
      xOffset = xOffset + width + buffer3;
      rowHeight = Math.max(rowHeight, height);
    }
  }
  if (columns.length > 0) {
    buildRowMapping(mapping, columns, yOffset);
  }
  return {
    mapping,
    rowHeight,
    xOffset,
    yOffset,
    canvasWidth,
    canvasHeight: nextPowOfTwo$1(rowHeight + yOffset + buffer3)
  };
}
function getDiffIcons(data2, getIcon, cachedIcons) {
  if (!data2 || !getIcon) {
    return null;
  }
  cachedIcons = cachedIcons || {};
  const icons = {};
  const { iterable, objectInfo } = createIterable(data2);
  for (const object2 of iterable) {
    objectInfo.index++;
    const icon = getIcon(object2, objectInfo);
    const id = getIconId(icon);
    if (!icon) {
      throw new Error("Icon is missing.");
    }
    if (!icon.url) {
      throw new Error("Icon url is missing.");
    }
    if (!icons[id] && (!cachedIcons[id] || icon.url !== cachedIcons[id].url)) {
      icons[id] = { ...icon, source: object2, sourceIndex: objectInfo.index };
    }
  }
  return icons;
}
class IconManager {
  constructor(device, { onUpdate = noop$2, onError = noop$2 }) {
    this._loadOptions = null;
    this._texture = null;
    this._externalTexture = null;
    this._mapping = {};
    this._textureParameters = null;
    this._pendingCount = 0;
    this._autoPacking = false;
    this._xOffset = 0;
    this._yOffset = 0;
    this._rowHeight = 0;
    this._buffer = DEFAULT_BUFFER$1;
    this._canvasWidth = DEFAULT_CANVAS_WIDTH;
    this._canvasHeight = 0;
    this._canvas = null;
    this.device = device;
    this.onUpdate = onUpdate;
    this.onError = onError;
  }
  finalize() {
    var _a3;
    (_a3 = this._texture) == null ? void 0 : _a3.delete();
  }
  getTexture() {
    return this._texture || this._externalTexture;
  }
  getIconMapping(icon) {
    const id = this._autoPacking ? getIconId(icon) : icon;
    return this._mapping[id] || MISSING_ICON;
  }
  setProps({ loadOptions, autoPacking, iconAtlas, iconMapping, textureParameters }) {
    var _a3;
    if (loadOptions) {
      this._loadOptions = loadOptions;
    }
    if (autoPacking !== void 0) {
      this._autoPacking = autoPacking;
    }
    if (iconMapping) {
      this._mapping = iconMapping;
    }
    if (iconAtlas) {
      (_a3 = this._texture) == null ? void 0 : _a3.delete();
      this._texture = null;
      this._externalTexture = iconAtlas;
    }
    if (textureParameters) {
      this._textureParameters = textureParameters;
    }
  }
  get isLoaded() {
    return this._pendingCount === 0;
  }
  packIcons(data2, getIcon) {
    if (!this._autoPacking || typeof document === "undefined") {
      return;
    }
    const icons = Object.values(getDiffIcons(data2, getIcon, this._mapping) || {});
    if (icons.length > 0) {
      const { mapping, xOffset, yOffset, rowHeight, canvasHeight } = buildMapping$1({
        icons,
        buffer: this._buffer,
        canvasWidth: this._canvasWidth,
        mapping: this._mapping,
        rowHeight: this._rowHeight,
        xOffset: this._xOffset,
        yOffset: this._yOffset
      });
      this._rowHeight = rowHeight;
      this._mapping = mapping;
      this._xOffset = xOffset;
      this._yOffset = yOffset;
      this._canvasHeight = canvasHeight;
      if (!this._texture) {
        this._texture = this.device.createTexture({
          format: "rgba8unorm",
          width: this._canvasWidth,
          height: this._canvasHeight,
          sampler: this._textureParameters || DEFAULT_SAMPLER_PARAMETERS$2
        });
      }
      if (this._texture.height !== this._canvasHeight) {
        this._texture = resizeTexture(this._texture, this._canvasWidth, this._canvasHeight, this._textureParameters || DEFAULT_SAMPLER_PARAMETERS$2);
      }
      this.onUpdate();
      this._canvas = this._canvas || document.createElement("canvas");
      this._loadIcons(icons);
    }
  }
  _loadIcons(icons) {
    const ctx2 = this._canvas.getContext("2d", {
      willReadFrequently: true
    });
    for (const icon of icons) {
      this._pendingCount++;
      load(icon.url, this._loadOptions).then((imageData) => {
        const id = getIconId(icon);
        const iconDef = this._mapping[id];
        const { x: x2, y: y2, width: maxWidth, height: maxHeight } = iconDef;
        const { data: data2, width, height } = resizeImage(ctx2, imageData, maxWidth, maxHeight);
        this._texture.setSubImageData({
          data: data2,
          x: x2 + (maxWidth - width) / 2,
          y: y2 + (maxHeight - height) / 2,
          width,
          height
        });
        iconDef.width = width;
        iconDef.height = height;
        this._texture.generateMipmap();
        this.onUpdate();
      }).catch((error2) => {
        this.onError({
          url: icon.url,
          source: icon.source,
          sourceIndex: icon.sourceIndex,
          loadOptions: this._loadOptions,
          error: error2
        });
      }).finally(() => {
        this._pendingCount--;
      });
    }
  }
}
const DEFAULT_COLOR$8 = [0, 0, 0, 255];
const defaultProps$n = {
  iconAtlas: { type: "image", value: null, async: true },
  iconMapping: { type: "object", value: {}, async: true },
  sizeScale: { type: "number", value: 1, min: 0 },
  billboard: true,
  sizeUnits: "pixels",
  sizeMinPixels: { type: "number", min: 0, value: 0 },
  //  min point radius in pixels
  sizeMaxPixels: { type: "number", min: 0, value: Number.MAX_SAFE_INTEGER },
  // max point radius in pixels
  alphaCutoff: { type: "number", value: 0.05, min: 0, max: 1 },
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getIcon: { type: "accessor", value: (x2) => x2.icon },
  getColor: { type: "accessor", value: DEFAULT_COLOR$8 },
  getSize: { type: "accessor", value: 1 },
  getAngle: { type: "accessor", value: 0 },
  getPixelOffset: { type: "accessor", value: [0, 0] },
  onIconError: { type: "function", value: null, optional: true },
  textureParameters: { type: "object", ignore: true, value: null }
};
const _IconLayer = class extends Layer {
  getShaders() {
    return super.getShaders({ vs: vs$b, fs: fs$d, modules: [project32, picking] });
  }
  initializeState() {
    this.state = {
      iconManager: new IconManager(this.context.device, {
        onUpdate: this._onUpdate.bind(this),
        onError: this._onError.bind(this)
      })
    };
    const attributeManager = this.getAttributeManager();
    attributeManager.addInstanced({
      instancePositions: {
        size: 3,
        type: "float64",
        fp64: this.use64bitPositions(),
        transition: true,
        accessor: "getPosition"
      },
      instanceSizes: {
        size: 1,
        transition: true,
        accessor: "getSize",
        defaultValue: 1
      },
      instanceOffsets: {
        size: 2,
        accessor: "getIcon",
        // eslint-disable-next-line @typescript-eslint/unbound-method
        transform: this.getInstanceOffset
      },
      instanceIconFrames: {
        size: 4,
        accessor: "getIcon",
        // eslint-disable-next-line @typescript-eslint/unbound-method
        transform: this.getInstanceIconFrame
      },
      instanceColorModes: {
        size: 1,
        type: "uint8",
        accessor: "getIcon",
        // eslint-disable-next-line @typescript-eslint/unbound-method
        transform: this.getInstanceColorMode
      },
      instanceColors: {
        size: this.props.colorFormat.length,
        type: "unorm8",
        transition: true,
        accessor: "getColor",
        defaultValue: DEFAULT_COLOR$8
      },
      instanceAngles: {
        size: 1,
        transition: true,
        accessor: "getAngle"
      },
      instancePixelOffset: {
        size: 2,
        transition: true,
        accessor: "getPixelOffset"
      }
    });
  }
  /* eslint-disable max-statements, complexity */
  updateState(params2) {
    var _a3;
    super.updateState(params2);
    const { props, oldProps, changeFlags } = params2;
    const attributeManager = this.getAttributeManager();
    const { iconAtlas, iconMapping, data: data2, getIcon, textureParameters } = props;
    const { iconManager } = this.state;
    if (typeof iconAtlas === "string") {
      return;
    }
    const prePacked = iconAtlas || this.internalState.isAsyncPropLoading("iconAtlas");
    iconManager.setProps({
      loadOptions: props.loadOptions,
      autoPacking: !prePacked,
      iconAtlas,
      iconMapping: prePacked ? iconMapping : null,
      textureParameters
    });
    if (prePacked) {
      if (oldProps.iconMapping !== props.iconMapping) {
        attributeManager.invalidate("getIcon");
      }
    } else if (changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getIcon)) {
      iconManager.packIcons(data2, getIcon);
    }
    if (changeFlags.extensionsChanged) {
      (_a3 = this.state.model) == null ? void 0 : _a3.destroy();
      this.state.model = this._getModel();
      attributeManager.invalidateAll();
    }
  }
  /* eslint-enable max-statements, complexity */
  get isLoaded() {
    return super.isLoaded && this.state.iconManager.isLoaded;
  }
  finalizeState(context2) {
    super.finalizeState(context2);
    this.state.iconManager.finalize();
  }
  draw({ uniforms }) {
    const { sizeScale, sizeMinPixels, sizeMaxPixels, sizeUnits, billboard, alphaCutoff } = this.props;
    const { iconManager } = this.state;
    const iconsTexture = iconManager.getTexture();
    if (iconsTexture) {
      const model = this.state.model;
      model.setBindings({ iconsTexture });
      model.setUniforms(uniforms);
      model.setUniforms({
        iconsTextureDim: [iconsTexture.width, iconsTexture.height],
        sizeUnits: UNIT[sizeUnits],
        sizeScale,
        sizeMinPixels,
        sizeMaxPixels,
        billboard,
        alphaCutoff
      });
      model.draw(this.context.renderPass);
    }
  }
  _getModel() {
    const positions = [-1, -1, 1, -1, -1, 1, 1, 1];
    return new Model(this.context.device, {
      ...this.getShaders(),
      id: this.props.id,
      bufferLayout: this.getAttributeManager().getBufferLayouts(),
      geometry: new Geometry({
        topology: "triangle-strip",
        attributes: {
          // The size must be explicitly passed here otherwise luma.gl
          // will default to assuming that positions are 3D (x,y,z)
          positions: {
            size: 2,
            value: new Float32Array(positions)
          }
        }
      }),
      isInstanced: true
    });
  }
  _onUpdate() {
    this.setNeedsRedraw();
  }
  _onError(evt) {
    var _a3;
    const onIconError = (_a3 = this.getCurrentLayer()) == null ? void 0 : _a3.props.onIconError;
    if (onIconError) {
      onIconError(evt);
    } else {
      log$1.error(evt.error.message)();
    }
  }
  getInstanceOffset(icon) {
    const { width, height, anchorX = width / 2, anchorY = height / 2 } = this.state.iconManager.getIconMapping(icon);
    return [width / 2 - anchorX, height / 2 - anchorY];
  }
  getInstanceColorMode(icon) {
    const mapping = this.state.iconManager.getIconMapping(icon);
    return mapping.mask ? 1 : 0;
  }
  getInstanceIconFrame(icon) {
    const { x: x2, y: y2, width, height } = this.state.iconManager.getIconMapping(icon);
    return [x2, y2, width, height];
  }
};
let IconLayer = _IconLayer;
(() => {
  _IconLayer.defaultProps = defaultProps$n;
})();
(() => {
  _IconLayer.layerName = "IconLayer";
})();
const vs$a = `#version 300 es
#define SHADER_NAME point-cloud-layer-vertex-shader
in vec3 positions;
in vec3 instanceNormals;
in vec4 instanceColors;
in vec3 instancePositions;
in vec3 instancePositions64Low;
in vec3 instancePickingColors;
uniform float opacity;
uniform float radiusPixels;
uniform int sizeUnits;
out vec4 vColor;
out vec2 unitPosition;
void main(void) {
geometry.worldPosition = instancePositions;
geometry.normal = project_normal(instanceNormals);
unitPosition = positions.xy;
geometry.uv = unitPosition;
geometry.pickingColor = instancePickingColors;
vec3 offset = vec3(positions.xy * project_size_to_pixel(radiusPixels, sizeUnits), 0.0);
DECKGL_FILTER_SIZE(offset, geometry);
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.), geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);
vec3 lightColor = lighting_getLightColor(instanceColors.rgb, project_uCameraPosition, geometry.position.xyz, geometry.normal);
vColor = vec4(lightColor, instanceColors.a * opacity);
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;
const fs$c = `#version 300 es
#define SHADER_NAME point-cloud-layer-fragment-shader
precision highp float;
in vec4 vColor;
in vec2 unitPosition;
out vec4 fragColor;
void main(void) {
geometry.uv = unitPosition;
float distToCenter = length(unitPosition);
if (distToCenter > 1.0) {
discard;
}
fragColor = vColor;
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_COLOR$7 = [0, 0, 0, 255];
const DEFAULT_NORMAL = [0, 0, 1];
const defaultProps$m = {
  sizeUnits: "pixels",
  pointSize: { type: "number", min: 0, value: 10 },
  //  point radius in pixels
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getNormal: { type: "accessor", value: DEFAULT_NORMAL },
  getColor: { type: "accessor", value: DEFAULT_COLOR$7 },
  material: true,
  // Depreated
  radiusPixels: { deprecatedFor: "pointSize" }
};
function normalizeData(data2) {
  const { header, attributes } = data2;
  if (!header || !attributes) {
    return;
  }
  data2.length = header.vertexCount;
  if (attributes.POSITION) {
    attributes.instancePositions = attributes.POSITION;
  }
  if (attributes.NORMAL) {
    attributes.instanceNormals = attributes.NORMAL;
  }
  if (attributes.COLOR_0) {
    const { size: size12, value } = attributes.COLOR_0;
    attributes.instanceColors = { size: size12, type: "unorm8", value };
  }
}
const _PointCloudLayer = class extends Layer {
  getShaders() {
    return super.getShaders({ vs: vs$a, fs: fs$c, modules: [project32, gouraudLighting, picking] });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: "float64",
        fp64: this.use64bitPositions(),
        transition: true,
        accessor: "getPosition"
      },
      instanceNormals: {
        size: 3,
        transition: true,
        accessor: "getNormal",
        defaultValue: DEFAULT_NORMAL
      },
      instanceColors: {
        size: this.props.colorFormat.length,
        type: "unorm8",
        transition: true,
        accessor: "getColor",
        defaultValue: DEFAULT_COLOR$7
      }
    });
  }
  updateState(params2) {
    var _a3;
    const { changeFlags, props } = params2;
    super.updateState(params2);
    if (changeFlags.extensionsChanged) {
      (_a3 = this.state.model) == null ? void 0 : _a3.destroy();
      this.state.model = this._getModel();
      this.getAttributeManager().invalidateAll();
    }
    if (changeFlags.dataChanged) {
      normalizeData(props.data);
    }
  }
  draw({ uniforms }) {
    const { pointSize, sizeUnits } = this.props;
    const model = this.state.model;
    model.setUniforms(uniforms);
    model.setUniforms({
      sizeUnits: UNIT[sizeUnits],
      radiusPixels: pointSize
    });
    model.draw(this.context.renderPass);
  }
  _getModel() {
    const positions = [];
    for (let i2 = 0; i2 < 3; i2++) {
      const angle4 = i2 / 3 * Math.PI * 2;
      positions.push(Math.cos(angle4) * 2, Math.sin(angle4) * 2, 0);
    }
    return new Model(this.context.device, {
      ...this.getShaders(),
      id: this.props.id,
      bufferLayout: this.getAttributeManager().getBufferLayouts(),
      geometry: new Geometry({
        topology: "triangle-list",
        attributes: {
          positions: new Float32Array(positions)
        }
      }),
      isInstanced: true
    });
  }
};
let PointCloudLayer = _PointCloudLayer;
(() => {
  _PointCloudLayer.layerName = "PointCloudLayer";
})();
(() => {
  _PointCloudLayer.defaultProps = defaultProps$m;
})();
const vs$9 = `#version 300 es
#define SHADER_NAME scatterplot-layer-vertex-shader
in vec3 positions;
in vec3 instancePositions;
in vec3 instancePositions64Low;
in float instanceRadius;
in float instanceLineWidths;
in vec4 instanceFillColors;
in vec4 instanceLineColors;
in vec3 instancePickingColors;
uniform float opacity;
uniform float radiusScale;
uniform float radiusMinPixels;
uniform float radiusMaxPixels;
uniform float lineWidthScale;
uniform float lineWidthMinPixels;
uniform float lineWidthMaxPixels;
uniform float stroked;
uniform bool filled;
uniform bool antialiasing;
uniform bool billboard;
uniform int radiusUnits;
uniform int lineWidthUnits;
out vec4 vFillColor;
out vec4 vLineColor;
out vec2 unitPosition;
out float innerUnitRadius;
out float outerRadiusPixels;
void main(void) {
geometry.worldPosition = instancePositions;
outerRadiusPixels = clamp(
project_size_to_pixel(radiusScale * instanceRadius, radiusUnits),
radiusMinPixels, radiusMaxPixels
);
float lineWidthPixels = clamp(
project_size_to_pixel(lineWidthScale * instanceLineWidths, lineWidthUnits),
lineWidthMinPixels, lineWidthMaxPixels
);
outerRadiusPixels += stroked * lineWidthPixels / 2.0;
float edgePadding = antialiasing ? (outerRadiusPixels + SMOOTH_EDGE_RADIUS) / outerRadiusPixels : 1.0;
unitPosition = edgePadding * positions.xy;
geometry.uv = unitPosition;
geometry.pickingColor = instancePickingColors;
innerUnitRadius = 1.0 - stroked * lineWidthPixels / outerRadiusPixels;
if (billboard) {
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
vec3 offset = edgePadding * positions * outerRadiusPixels;
DECKGL_FILTER_SIZE(offset, geometry);
gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);
} else {
vec3 offset = edgePadding * positions * project_pixel_size(outerRadiusPixels);
DECKGL_FILTER_SIZE(offset, geometry);
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset, geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
}
vFillColor = vec4(instanceFillColors.rgb, instanceFillColors.a * opacity);
DECKGL_FILTER_COLOR(vFillColor, geometry);
vLineColor = vec4(instanceLineColors.rgb, instanceLineColors.a * opacity);
DECKGL_FILTER_COLOR(vLineColor, geometry);
}
`;
const fs$b = `#version 300 es
#define SHADER_NAME scatterplot-layer-fragment-shader
precision highp float;
uniform bool filled;
uniform float stroked;
uniform bool antialiasing;
in vec4 vFillColor;
in vec4 vLineColor;
in vec2 unitPosition;
in float innerUnitRadius;
in float outerRadiusPixels;
out vec4 fragColor;
void main(void) {
geometry.uv = unitPosition;
float distToCenter = length(unitPosition) * outerRadiusPixels;
float inCircle = antialiasing ?
smoothedge(distToCenter, outerRadiusPixels) :
step(distToCenter, outerRadiusPixels);
if (inCircle == 0.0) {
discard;
}
if (stroked > 0.5) {
float isLine = antialiasing ?
smoothedge(innerUnitRadius * outerRadiusPixels, distToCenter) :
step(innerUnitRadius * outerRadiusPixels, distToCenter);
if (filled) {
fragColor = mix(vFillColor, vLineColor, isLine);
} else {
if (isLine == 0.0) {
discard;
}
fragColor = vec4(vLineColor.rgb, vLineColor.a * isLine);
}
} else if (!filled) {
discard;
} else {
fragColor = vFillColor;
}
fragColor.a *= inCircle;
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_COLOR$6 = [0, 0, 0, 255];
const defaultProps$l = {
  radiusUnits: "meters",
  radiusScale: { type: "number", min: 0, value: 1 },
  radiusMinPixels: { type: "number", min: 0, value: 0 },
  //  min point radius in pixels
  radiusMaxPixels: { type: "number", min: 0, value: Number.MAX_SAFE_INTEGER },
  // max point radius in pixels
  lineWidthUnits: "meters",
  lineWidthScale: { type: "number", min: 0, value: 1 },
  lineWidthMinPixels: { type: "number", min: 0, value: 0 },
  lineWidthMaxPixels: { type: "number", min: 0, value: Number.MAX_SAFE_INTEGER },
  stroked: false,
  filled: true,
  billboard: false,
  antialiasing: true,
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getRadius: { type: "accessor", value: 1 },
  getFillColor: { type: "accessor", value: DEFAULT_COLOR$6 },
  getLineColor: { type: "accessor", value: DEFAULT_COLOR$6 },
  getLineWidth: { type: "accessor", value: 1 },
  // deprecated
  strokeWidth: { deprecatedFor: "getLineWidth" },
  outline: { deprecatedFor: "stroked" },
  getColor: { deprecatedFor: ["getFillColor", "getLineColor"] }
};
const _ScatterplotLayer = class extends Layer {
  getShaders() {
    return super.getShaders({ vs: vs$9, fs: fs$b, modules: [project32, picking] });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: "float64",
        fp64: this.use64bitPositions(),
        transition: true,
        accessor: "getPosition"
      },
      instanceRadius: {
        size: 1,
        transition: true,
        accessor: "getRadius",
        defaultValue: 1
      },
      instanceFillColors: {
        size: this.props.colorFormat.length,
        transition: true,
        type: "unorm8",
        accessor: "getFillColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineColors: {
        size: this.props.colorFormat.length,
        transition: true,
        type: "unorm8",
        accessor: "getLineColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineWidths: {
        size: 1,
        transition: true,
        accessor: "getLineWidth",
        defaultValue: 1
      }
    });
  }
  updateState(params2) {
    var _a3;
    super.updateState(params2);
    if (params2.changeFlags.extensionsChanged) {
      (_a3 = this.state.model) == null ? void 0 : _a3.destroy();
      this.state.model = this._getModel();
      this.getAttributeManager().invalidateAll();
    }
  }
  draw({ uniforms }) {
    const { radiusUnits, radiusScale, radiusMinPixels, radiusMaxPixels, stroked, filled, billboard, antialiasing, lineWidthUnits, lineWidthScale, lineWidthMinPixels, lineWidthMaxPixels } = this.props;
    const model = this.state.model;
    model.setUniforms(uniforms);
    model.setUniforms({
      stroked: stroked ? 1 : 0,
      filled,
      billboard,
      antialiasing,
      radiusUnits: UNIT[radiusUnits],
      radiusScale,
      radiusMinPixels,
      radiusMaxPixels,
      lineWidthUnits: UNIT[lineWidthUnits],
      lineWidthScale,
      lineWidthMinPixels,
      lineWidthMaxPixels
    });
    model.draw(this.context.renderPass);
  }
  _getModel() {
    const positions = [-1, -1, 0, 1, -1, 0, -1, 1, 0, 1, 1, 0];
    return new Model(this.context.device, {
      ...this.getShaders(),
      id: this.props.id,
      bufferLayout: this.getAttributeManager().getBufferLayouts(),
      geometry: new Geometry({
        topology: "triangle-strip",
        attributes: {
          positions: { size: 3, value: new Float32Array(positions) }
        }
      }),
      isInstanced: true
    });
  }
};
let ScatterplotLayer = _ScatterplotLayer;
(() => {
  _ScatterplotLayer.defaultProps = defaultProps$l;
})();
(() => {
  _ScatterplotLayer.layerName = "ScatterplotLayer";
})();
const WINDING = {
  CLOCKWISE: 1,
  COUNTER_CLOCKWISE: -1
};
function modifyPolygonWindingDirection(points2, direction, options2 = {}) {
  const windingDirection = getPolygonWindingDirection(points2, options2);
  if (windingDirection !== direction) {
    reversePolygon(points2, options2);
    return true;
  }
  return false;
}
function getPolygonWindingDirection(points2, options2 = {}) {
  return Math.sign(getPolygonSignedArea(points2, options2));
}
const DimIndex = {
  x: 0,
  y: 1,
  z: 2
};
function getPolygonSignedArea(points2, options2 = {}) {
  const { start: start2 = 0, end = points2.length, plane = "xy" } = options2;
  const dim = options2.size || 2;
  let area5 = 0;
  const i0 = DimIndex[plane[0]];
  const i1 = DimIndex[plane[1]];
  for (let i2 = start2, j2 = end - dim; i2 < end; i2 += dim) {
    area5 += (points2[i2 + i0] - points2[j2 + i0]) * (points2[i2 + i1] + points2[j2 + i1]);
    j2 = i2;
  }
  return area5 / 2;
}
function reversePolygon(points2, options2) {
  const { start: start2 = 0, end = points2.length, size: size12 = 2 } = options2;
  const numPoints = (end - start2) / size12;
  const numSwaps = Math.floor(numPoints / 2);
  for (let i2 = 0; i2 < numSwaps; ++i2) {
    const b1 = start2 + i2 * size12;
    const b2 = start2 + (numPoints - 1 - i2) * size12;
    for (let j2 = 0; j2 < size12; ++j2) {
      const tmp2 = points2[b1 + j2];
      points2[b1 + j2] = points2[b2 + j2];
      points2[b2 + j2] = tmp2;
    }
  }
}
function earcut(positions, holeIndices, dim = 2, areas, plane = "xy") {
  const hasHoles = holeIndices && holeIndices.length;
  const outerLen = hasHoles ? holeIndices[0] * dim : positions.length;
  let outerNode = linkedList(positions, 0, outerLen, dim, true, areas && areas[0], plane);
  const triangles = [];
  if (!outerNode || outerNode.next === outerNode.prev)
    return triangles;
  let invSize;
  let maxX2;
  let maxY2;
  let minX2;
  let minY2;
  let x2;
  let y2;
  if (hasHoles)
    outerNode = eliminateHoles(positions, holeIndices, outerNode, dim, areas, plane);
  if (positions.length > 80 * dim) {
    minX2 = maxX2 = positions[0];
    minY2 = maxY2 = positions[1];
    for (let i2 = dim; i2 < outerLen; i2 += dim) {
      x2 = positions[i2];
      y2 = positions[i2 + 1];
      if (x2 < minX2)
        minX2 = x2;
      if (y2 < minY2)
        minY2 = y2;
      if (x2 > maxX2)
        maxX2 = x2;
      if (y2 > maxY2)
        maxY2 = y2;
    }
    invSize = Math.max(maxX2 - minX2, maxY2 - minY2);
    invSize = invSize !== 0 ? 32767 / invSize : 0;
  }
  earcutLinked(outerNode, triangles, dim, minX2, minY2, invSize, 0);
  return triangles;
}
function linkedList(data2, start2, end, dim, clockwise, area5, plane) {
  let i2;
  let last;
  if (area5 === void 0) {
    area5 = getPolygonSignedArea(data2, { start: start2, end, size: dim, plane });
  }
  let i0 = DimIndex[plane[0]];
  let i1 = DimIndex[plane[1]];
  if (clockwise === area5 < 0) {
    for (i2 = start2; i2 < end; i2 += dim)
      last = insertNode(i2, data2[i2 + i0], data2[i2 + i1], last);
  } else {
    for (i2 = end - dim; i2 >= start2; i2 -= dim)
      last = insertNode(i2, data2[i2 + i0], data2[i2 + i1], last);
  }
  if (last && equals(last, last.next)) {
    removeNode(last);
    last = last.next;
  }
  return last;
}
function filterPoints(start2, end) {
  if (!start2)
    return start2;
  if (!end)
    end = start2;
  let p2 = start2;
  let again;
  do {
    again = false;
    if (!p2.steiner && (equals(p2, p2.next) || area$1(p2.prev, p2, p2.next) === 0)) {
      removeNode(p2);
      p2 = end = p2.prev;
      if (p2 === p2.next)
        break;
      again = true;
    } else {
      p2 = p2.next;
    }
  } while (again || p2 !== end);
  return end;
}
function earcutLinked(ear, triangles, dim, minX2, minY2, invSize, pass2) {
  if (!ear)
    return;
  if (!pass2 && invSize)
    indexCurve(ear, minX2, minY2, invSize);
  let stop = ear;
  let prev;
  let next5;
  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next5 = ear.next;
    if (invSize ? isEarHashed(ear, minX2, minY2, invSize) : isEar(ear)) {
      triangles.push(prev.i / dim | 0);
      triangles.push(ear.i / dim | 0);
      triangles.push(next5.i / dim | 0);
      removeNode(ear);
      ear = next5.next;
      stop = next5.next;
      continue;
    }
    ear = next5;
    if (ear === stop) {
      if (!pass2) {
        earcutLinked(filterPoints(ear), triangles, dim, minX2, minY2, invSize, 1);
      } else if (pass2 === 1) {
        ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
        earcutLinked(ear, triangles, dim, minX2, minY2, invSize, 2);
      } else if (pass2 === 2) {
        splitEarcut(ear, triangles, dim, minX2, minY2, invSize);
      }
      break;
    }
  }
}
function isEar(ear) {
  const a2 = ear.prev;
  const b2 = ear;
  const c2 = ear.next;
  if (area$1(a2, b2, c2) >= 0)
    return false;
  const ax2 = a2.x;
  const bx2 = b2.x;
  const cx = c2.x;
  const ay2 = a2.y;
  const by2 = b2.y;
  const cy = c2.y;
  const x02 = ax2 < bx2 ? ax2 < cx ? ax2 : cx : bx2 < cx ? bx2 : cx;
  const y02 = ay2 < by2 ? ay2 < cy ? ay2 : cy : by2 < cy ? by2 : cy;
  const x12 = ax2 > bx2 ? ax2 > cx ? ax2 : cx : bx2 > cx ? bx2 : cx;
  const y12 = ay2 > by2 ? ay2 > cy ? ay2 : cy : by2 > cy ? by2 : cy;
  let p2 = c2.next;
  while (p2 !== a2) {
    if (p2.x >= x02 && p2.x <= x12 && p2.y >= y02 && p2.y <= y12 && pointInTriangle(ax2, ay2, bx2, by2, cx, cy, p2.x, p2.y) && area$1(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.next;
  }
  return true;
}
function isEarHashed(ear, minX2, minY2, invSize) {
  const a2 = ear.prev;
  const b2 = ear;
  const c2 = ear.next;
  if (area$1(a2, b2, c2) >= 0)
    return false;
  const ax2 = a2.x;
  const bx2 = b2.x;
  const cx = c2.x;
  const ay2 = a2.y;
  const by2 = b2.y;
  const cy = c2.y;
  const x02 = ax2 < bx2 ? ax2 < cx ? ax2 : cx : bx2 < cx ? bx2 : cx;
  const y02 = ay2 < by2 ? ay2 < cy ? ay2 : cy : by2 < cy ? by2 : cy;
  const x12 = ax2 > bx2 ? ax2 > cx ? ax2 : cx : bx2 > cx ? bx2 : cx;
  const y12 = ay2 > by2 ? ay2 > cy ? ay2 : cy : by2 > cy ? by2 : cy;
  const minZ = zOrder(x02, y02, minX2, minY2, invSize);
  const maxZ = zOrder(x12, y12, minX2, minY2, invSize);
  let p2 = ear.prevZ;
  let n2 = ear.nextZ;
  while (p2 && p2.z >= minZ && n2 && n2.z <= maxZ) {
    if (p2.x >= x02 && p2.x <= x12 && p2.y >= y02 && p2.y <= y12 && p2 !== a2 && p2 !== c2 && pointInTriangle(ax2, ay2, bx2, by2, cx, cy, p2.x, p2.y) && area$1(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
    if (n2.x >= x02 && n2.x <= x12 && n2.y >= y02 && n2.y <= y12 && n2 !== a2 && n2 !== c2 && pointInTriangle(ax2, ay2, bx2, by2, cx, cy, n2.x, n2.y) && area$1(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  while (p2 && p2.z >= minZ) {
    if (p2.x >= x02 && p2.x <= x12 && p2.y >= y02 && p2.y <= y12 && p2 !== a2 && p2 !== c2 && pointInTriangle(ax2, ay2, bx2, by2, cx, cy, p2.x, p2.y) && area$1(p2.prev, p2, p2.next) >= 0)
      return false;
    p2 = p2.prevZ;
  }
  while (n2 && n2.z <= maxZ) {
    if (n2.x >= x02 && n2.x <= x12 && n2.y >= y02 && n2.y <= y12 && n2 !== a2 && n2 !== c2 && pointInTriangle(ax2, ay2, bx2, by2, cx, cy, n2.x, n2.y) && area$1(n2.prev, n2, n2.next) >= 0)
      return false;
    n2 = n2.nextZ;
  }
  return true;
}
function cureLocalIntersections(start2, triangles, dim) {
  let p2 = start2;
  do {
    const a2 = p2.prev;
    const b2 = p2.next.next;
    if (!equals(a2, b2) && intersects$2(a2, p2, p2.next, b2) && locallyInside(a2, b2) && locallyInside(b2, a2)) {
      triangles.push(a2.i / dim | 0);
      triangles.push(p2.i / dim | 0);
      triangles.push(b2.i / dim | 0);
      removeNode(p2);
      removeNode(p2.next);
      p2 = start2 = b2;
    }
    p2 = p2.next;
  } while (p2 !== start2);
  return filterPoints(p2);
}
function splitEarcut(start2, triangles, dim, minX2, minY2, invSize) {
  let a2 = start2;
  do {
    let b2 = a2.next.next;
    while (b2 !== a2.prev) {
      if (a2.i !== b2.i && isValidDiagonal(a2, b2)) {
        let c2 = splitPolygon(a2, b2);
        a2 = filterPoints(a2, a2.next);
        c2 = filterPoints(c2, c2.next);
        earcutLinked(a2, triangles, dim, minX2, minY2, invSize, 0);
        earcutLinked(c2, triangles, dim, minX2, minY2, invSize, 0);
        return;
      }
      b2 = b2.next;
    }
    a2 = a2.next;
  } while (a2 !== start2);
}
function eliminateHoles(data2, holeIndices, outerNode, dim, areas, plane) {
  const queue = [];
  let i2;
  let len2;
  let start2;
  let end;
  let list2;
  for (i2 = 0, len2 = holeIndices.length; i2 < len2; i2++) {
    start2 = holeIndices[i2] * dim;
    end = i2 < len2 - 1 ? holeIndices[i2 + 1] * dim : data2.length;
    list2 = linkedList(data2, start2, end, dim, false, areas && areas[i2 + 1], plane);
    if (list2 === list2.next)
      list2.steiner = true;
    queue.push(getLeftmost(list2));
  }
  queue.sort(compareX);
  for (i2 = 0; i2 < queue.length; i2++) {
    outerNode = eliminateHole(queue[i2], outerNode);
  }
  return outerNode;
}
function compareX(a2, b2) {
  return a2.x - b2.x;
}
function eliminateHole(hole, outerNode) {
  const bridge = findHoleBridge(hole, outerNode);
  if (!bridge) {
    return outerNode;
  }
  const bridgeReverse = splitPolygon(bridge, hole);
  filterPoints(bridgeReverse, bridgeReverse.next);
  return filterPoints(bridge, bridge.next);
}
function findHoleBridge(hole, outerNode) {
  let p2 = outerNode;
  const hx = hole.x;
  const hy = hole.y;
  let qx = -Infinity;
  let m2;
  do {
    if (hy <= p2.y && hy >= p2.next.y && p2.next.y !== p2.y) {
      const x2 = p2.x + (hy - p2.y) * (p2.next.x - p2.x) / (p2.next.y - p2.y);
      if (x2 <= hx && x2 > qx) {
        qx = x2;
        m2 = p2.x < p2.next.x ? p2 : p2.next;
        if (x2 === hx)
          return m2;
      }
    }
    p2 = p2.next;
  } while (p2 !== outerNode);
  if (!m2)
    return null;
  const stop = m2;
  const mx = m2.x;
  const my = m2.y;
  let tanMin = Infinity;
  let tan;
  p2 = m2;
  do {
    if (hx >= p2.x && p2.x >= mx && hx !== p2.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p2.x, p2.y)) {
      tan = Math.abs(hy - p2.y) / (hx - p2.x);
      if (locallyInside(p2, hole) && (tan < tanMin || tan === tanMin && (p2.x > m2.x || p2.x === m2.x && sectorContainsSector(m2, p2)))) {
        m2 = p2;
        tanMin = tan;
      }
    }
    p2 = p2.next;
  } while (p2 !== stop);
  return m2;
}
function sectorContainsSector(m2, p2) {
  return area$1(m2.prev, m2, p2.prev) < 0 && area$1(p2.next, m2, m2.next) < 0;
}
function indexCurve(start2, minX2, minY2, invSize) {
  let p2 = start2;
  do {
    if (p2.z === 0)
      p2.z = zOrder(p2.x, p2.y, minX2, minY2, invSize);
    p2.prevZ = p2.prev;
    p2.nextZ = p2.next;
    p2 = p2.next;
  } while (p2 !== start2);
  p2.prevZ.nextZ = null;
  p2.prevZ = null;
  sortLinked(p2);
}
function sortLinked(list2) {
  let e3;
  let i2;
  let inSize = 1;
  let numMerges;
  let p2;
  let pSize;
  let q2;
  let qSize;
  let tail;
  do {
    p2 = list2;
    list2 = null;
    tail = null;
    numMerges = 0;
    while (p2) {
      numMerges++;
      q2 = p2;
      pSize = 0;
      for (i2 = 0; i2 < inSize; i2++) {
        pSize++;
        q2 = q2.nextZ;
        if (!q2)
          break;
      }
      qSize = inSize;
      while (pSize > 0 || qSize > 0 && q2) {
        if (pSize !== 0 && (qSize === 0 || !q2 || p2.z <= q2.z)) {
          e3 = p2;
          p2 = p2.nextZ;
          pSize--;
        } else {
          e3 = q2;
          q2 = q2.nextZ;
          qSize--;
        }
        if (tail)
          tail.nextZ = e3;
        else
          list2 = e3;
        e3.prevZ = tail;
        tail = e3;
      }
      p2 = q2;
    }
    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);
  return list2;
}
function zOrder(x2, y2, minX2, minY2, invSize) {
  x2 = (x2 - minX2) * invSize | 0;
  y2 = (y2 - minY2) * invSize | 0;
  x2 = (x2 | x2 << 8) & 16711935;
  x2 = (x2 | x2 << 4) & 252645135;
  x2 = (x2 | x2 << 2) & 858993459;
  x2 = (x2 | x2 << 1) & 1431655765;
  y2 = (y2 | y2 << 8) & 16711935;
  y2 = (y2 | y2 << 4) & 252645135;
  y2 = (y2 | y2 << 2) & 858993459;
  y2 = (y2 | y2 << 1) & 1431655765;
  return x2 | y2 << 1;
}
function getLeftmost(start2) {
  let p2 = start2;
  let leftmost = start2;
  do {
    if (p2.x < leftmost.x || p2.x === leftmost.x && p2.y < leftmost.y)
      leftmost = p2;
    p2 = p2.next;
  } while (p2 !== start2);
  return leftmost;
}
function pointInTriangle(ax2, ay2, bx2, by2, cx, cy, px2, py2) {
  return (cx - px2) * (ay2 - py2) >= (ax2 - px2) * (cy - py2) && (ax2 - px2) * (by2 - py2) >= (bx2 - px2) * (ay2 - py2) && (bx2 - px2) * (cy - py2) >= (cx - px2) * (by2 - py2);
}
function isValidDiagonal(a2, b2) {
  return a2.next.i !== b2.i && a2.prev.i !== b2.i && !intersectsPolygon(a2, b2) && // dones't intersect other edges
  (locallyInside(a2, b2) && locallyInside(b2, a2) && middleInside(a2, b2) && // locally visible
  (area$1(a2.prev, a2, b2.prev) || area$1(a2, b2.prev, b2)) || // does not create opposite-facing sectors
  equals(a2, b2) && area$1(a2.prev, a2, a2.next) > 0 && area$1(b2.prev, b2, b2.next) > 0);
}
function area$1(p2, q2, r2) {
  return (q2.y - p2.y) * (r2.x - q2.x) - (q2.x - p2.x) * (r2.y - q2.y);
}
function equals(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
}
function intersects$2(p1, q1, p2, q2) {
  const o1 = sign(area$1(p1, q1, p2));
  const o2 = sign(area$1(p1, q1, q2));
  const o3 = sign(area$1(p2, q2, p1));
  const o4 = sign(area$1(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4)
    return true;
  if (o1 === 0 && onSegment(p1, p2, q1))
    return true;
  if (o2 === 0 && onSegment(p1, q2, q1))
    return true;
  if (o3 === 0 && onSegment(p2, p1, q2))
    return true;
  if (o4 === 0 && onSegment(p2, q1, q2))
    return true;
  return false;
}
function onSegment(p2, q2, r2) {
  return q2.x <= Math.max(p2.x, r2.x) && q2.x >= Math.min(p2.x, r2.x) && q2.y <= Math.max(p2.y, r2.y) && q2.y >= Math.min(p2.y, r2.y);
}
function sign(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
}
function intersectsPolygon(a2, b2) {
  let p2 = a2;
  do {
    if (p2.i !== a2.i && p2.next.i !== a2.i && p2.i !== b2.i && p2.next.i !== b2.i && intersects$2(p2, p2.next, a2, b2))
      return true;
    p2 = p2.next;
  } while (p2 !== a2);
  return false;
}
function locallyInside(a2, b2) {
  return area$1(a2.prev, a2, a2.next) < 0 ? area$1(a2, b2, a2.next) >= 0 && area$1(a2, a2.prev, b2) >= 0 : area$1(a2, b2, a2.prev) < 0 || area$1(a2, a2.next, b2) < 0;
}
function middleInside(a2, b2) {
  let p2 = a2;
  let inside = false;
  const px2 = (a2.x + b2.x) / 2;
  const py2 = (a2.y + b2.y) / 2;
  do {
    if (p2.y > py2 !== p2.next.y > py2 && p2.next.y !== p2.y && px2 < (p2.next.x - p2.x) * (py2 - p2.y) / (p2.next.y - p2.y) + p2.x)
      inside = !inside;
    p2 = p2.next;
  } while (p2 !== a2);
  return inside;
}
function splitPolygon(a2, b2) {
  const a22 = new Vertex(a2.i, a2.x, a2.y);
  const b22 = new Vertex(b2.i, b2.x, b2.y);
  const an2 = a2.next;
  const bp2 = b2.prev;
  a2.next = b2;
  b2.prev = a2;
  a22.next = an2;
  an2.prev = a22;
  b22.next = a22;
  a22.prev = b22;
  bp2.next = b22;
  b22.prev = bp2;
  return b22;
}
function insertNode(i2, x2, y2, last) {
  const p2 = new Vertex(i2, x2, y2);
  if (!last) {
    p2.prev = p2;
    p2.next = p2;
  } else {
    p2.next = last.next;
    p2.prev = last;
    last.next.prev = p2;
    last.next = p2;
  }
  return p2;
}
function removeNode(p2) {
  p2.next.prev = p2.prev;
  p2.prev.next = p2.next;
  if (p2.prevZ)
    p2.prevZ.nextZ = p2.nextZ;
  if (p2.nextZ)
    p2.nextZ.prevZ = p2.prevZ;
}
class Vertex {
  constructor(i2, x2, y2) {
    this.prev = null;
    this.next = null;
    this.z = 0;
    this.prevZ = null;
    this.nextZ = null;
    this.steiner = false;
    this.i = i2;
    this.x = x2;
    this.y = y2;
  }
}
function push(target, source) {
  const size12 = source.length;
  const startIndex = target.length;
  if (startIndex > 0) {
    let isDuplicate = true;
    for (let i2 = 0; i2 < size12; i2++) {
      if (target[startIndex - size12 + i2] !== source[i2]) {
        isDuplicate = false;
        break;
      }
    }
    if (isDuplicate) {
      return false;
    }
  }
  for (let i2 = 0; i2 < size12; i2++) {
    target[startIndex + i2] = source[i2];
  }
  return true;
}
function copy$1(target, source) {
  const size12 = source.length;
  for (let i2 = 0; i2 < size12; i2++) {
    target[i2] = source[i2];
  }
}
function getPointAtIndex(positions, index2, size12, offset, out = []) {
  const startI = offset + index2 * size12;
  for (let i2 = 0; i2 < size12; i2++) {
    out[i2] = positions[startI + i2];
  }
  return out;
}
function intersect(a2, b2, edge, bbox2, out = []) {
  let t2;
  let snap5;
  if (edge & 8) {
    t2 = (bbox2[3] - a2[1]) / (b2[1] - a2[1]);
    snap5 = 3;
  } else if (edge & 4) {
    t2 = (bbox2[1] - a2[1]) / (b2[1] - a2[1]);
    snap5 = 1;
  } else if (edge & 2) {
    t2 = (bbox2[2] - a2[0]) / (b2[0] - a2[0]);
    snap5 = 2;
  } else if (edge & 1) {
    t2 = (bbox2[0] - a2[0]) / (b2[0] - a2[0]);
    snap5 = 0;
  } else {
    return null;
  }
  for (let i2 = 0; i2 < a2.length; i2++) {
    out[i2] = (snap5 & 1) === i2 ? bbox2[snap5] : t2 * (b2[i2] - a2[i2]) + a2[i2];
  }
  return out;
}
function bitCode(p2, bbox2) {
  let code = 0;
  if (p2[0] < bbox2[0])
    code |= 1;
  else if (p2[0] > bbox2[2])
    code |= 2;
  if (p2[1] < bbox2[1])
    code |= 4;
  else if (p2[1] > bbox2[3])
    code |= 8;
  return code;
}
function cutPolylineByGrid(positions, options2) {
  const { size: size12 = 2, broken = false, gridResolution = 10, gridOffset = [0, 0], startIndex = 0, endIndex = positions.length } = options2 || {};
  const numPoints = (endIndex - startIndex) / size12;
  let part = [];
  const result = [part];
  const a2 = getPointAtIndex(positions, 0, size12, startIndex);
  let b2;
  let codeB;
  const cell = getGridCell(a2, gridResolution, gridOffset, []);
  const scratchPoint2 = [];
  push(part, a2);
  for (let i2 = 1; i2 < numPoints; i2++) {
    b2 = getPointAtIndex(positions, i2, size12, startIndex, b2);
    codeB = bitCode(b2, cell);
    while (codeB) {
      intersect(a2, b2, codeB, cell, scratchPoint2);
      const codeAlt = bitCode(scratchPoint2, cell);
      if (codeAlt) {
        intersect(a2, scratchPoint2, codeAlt, cell, scratchPoint2);
        codeB = codeAlt;
      }
      push(part, scratchPoint2);
      copy$1(a2, scratchPoint2);
      moveToNeighborCell(cell, gridResolution, codeB);
      if (broken && part.length > size12) {
        part = [];
        result.push(part);
        push(part, a2);
      }
      codeB = bitCode(b2, cell);
    }
    push(part, b2);
    copy$1(a2, b2);
  }
  return broken ? result : result[0];
}
const TYPE_INSIDE = 0;
const TYPE_BORDER = 1;
function cutPolygonByGrid(positions, holeIndices = null, options2) {
  if (!positions.length) {
    return [];
  }
  const { size: size12 = 2, gridResolution = 10, gridOffset = [0, 0], edgeTypes = false } = options2 || {};
  const result = [];
  const queue = [
    {
      pos: positions,
      types: edgeTypes ? new Array(positions.length / size12).fill(TYPE_BORDER) : null,
      holes: holeIndices || []
    }
  ];
  const bbox2 = [[], []];
  let cell = [];
  while (queue.length) {
    const { pos, types: types2, holes } = queue.shift();
    getBoundingBox$1(pos, size12, holes[0] || pos.length, bbox2);
    cell = getGridCell(bbox2[0], gridResolution, gridOffset, cell);
    const code = bitCode(bbox2[1], cell);
    if (code) {
      let parts = bisectPolygon(pos, types2, size12, 0, holes[0] || pos.length, cell, code);
      const polygonLow = { pos: parts[0].pos, types: parts[0].types, holes: [] };
      const polygonHigh = { pos: parts[1].pos, types: parts[1].types, holes: [] };
      queue.push(polygonLow, polygonHigh);
      for (let i2 = 0; i2 < holes.length; i2++) {
        parts = bisectPolygon(pos, types2, size12, holes[i2], holes[i2 + 1] || pos.length, cell, code);
        if (parts[0]) {
          polygonLow.holes.push(polygonLow.pos.length);
          polygonLow.pos = concatInPlace(polygonLow.pos, parts[0].pos);
          if (edgeTypes) {
            polygonLow.types = concatInPlace(polygonLow.types, parts[0].types);
          }
        }
        if (parts[1]) {
          polygonHigh.holes.push(polygonHigh.pos.length);
          polygonHigh.pos = concatInPlace(polygonHigh.pos, parts[1].pos);
          if (edgeTypes) {
            polygonHigh.types = concatInPlace(polygonHigh.types, parts[1].types);
          }
        }
      }
    } else {
      const polygon4 = { positions: pos };
      if (edgeTypes) {
        polygon4.edgeTypes = types2;
      }
      if (holes.length) {
        polygon4.holeIndices = holes;
      }
      result.push(polygon4);
    }
  }
  return result;
}
function bisectPolygon(positions, edgeTypes, size12, startIndex, endIndex, bbox2, edge) {
  const numPoints = (endIndex - startIndex) / size12;
  const resultLow = [];
  const resultHigh = [];
  const typesLow = [];
  const typesHigh = [];
  const scratchPoint2 = [];
  let p2;
  let side;
  let type;
  const prev = getPointAtIndex(positions, numPoints - 1, size12, startIndex);
  let prevSide = Math.sign(edge & 8 ? prev[1] - bbox2[3] : prev[0] - bbox2[2]);
  let prevType = edgeTypes && edgeTypes[numPoints - 1];
  let lowPointCount = 0;
  let highPointCount = 0;
  for (let i2 = 0; i2 < numPoints; i2++) {
    p2 = getPointAtIndex(positions, i2, size12, startIndex, p2);
    side = Math.sign(edge & 8 ? p2[1] - bbox2[3] : p2[0] - bbox2[2]);
    type = edgeTypes && edgeTypes[startIndex / size12 + i2];
    if (side && prevSide && prevSide !== side) {
      intersect(prev, p2, edge, bbox2, scratchPoint2);
      push(resultLow, scratchPoint2) && typesLow.push(prevType);
      push(resultHigh, scratchPoint2) && typesHigh.push(prevType);
    }
    if (side <= 0) {
      push(resultLow, p2) && typesLow.push(type);
      lowPointCount -= side;
    } else if (typesLow.length) {
      typesLow[typesLow.length - 1] = TYPE_INSIDE;
    }
    if (side >= 0) {
      push(resultHigh, p2) && typesHigh.push(type);
      highPointCount += side;
    } else if (typesHigh.length) {
      typesHigh[typesHigh.length - 1] = TYPE_INSIDE;
    }
    copy$1(prev, p2);
    prevSide = side;
    prevType = type;
  }
  return [
    lowPointCount ? { pos: resultLow, types: edgeTypes && typesLow } : null,
    highPointCount ? { pos: resultHigh, types: edgeTypes && typesHigh } : null
  ];
}
function getGridCell(p2, gridResolution, gridOffset, out) {
  const left = Math.floor((p2[0] - gridOffset[0]) / gridResolution) * gridResolution + gridOffset[0];
  const bottom = Math.floor((p2[1] - gridOffset[1]) / gridResolution) * gridResolution + gridOffset[1];
  out[0] = left;
  out[1] = bottom;
  out[2] = left + gridResolution;
  out[3] = bottom + gridResolution;
  return out;
}
function moveToNeighborCell(cell, gridResolution, edge) {
  if (edge & 8) {
    cell[1] += gridResolution;
    cell[3] += gridResolution;
  } else if (edge & 4) {
    cell[1] -= gridResolution;
    cell[3] -= gridResolution;
  } else if (edge & 2) {
    cell[0] += gridResolution;
    cell[2] += gridResolution;
  } else if (edge & 1) {
    cell[0] -= gridResolution;
    cell[2] -= gridResolution;
  }
}
function getBoundingBox$1(positions, size12, endIndex, out) {
  let minX2 = Infinity;
  let maxX2 = -Infinity;
  let minY2 = Infinity;
  let maxY2 = -Infinity;
  for (let i2 = 0; i2 < endIndex; i2 += size12) {
    const x2 = positions[i2];
    const y2 = positions[i2 + 1];
    minX2 = x2 < minX2 ? x2 : minX2;
    maxX2 = x2 > maxX2 ? x2 : maxX2;
    minY2 = y2 < minY2 ? y2 : minY2;
    maxY2 = y2 > maxY2 ? y2 : maxY2;
  }
  out[0][0] = minX2;
  out[0][1] = minY2;
  out[1][0] = maxX2;
  out[1][1] = maxY2;
  return out;
}
function concatInPlace(arr1, arr2) {
  for (let i2 = 0; i2 < arr2.length; i2++) {
    arr1.push(arr2[i2]);
  }
  return arr1;
}
const DEFAULT_MAX_LATITUDE = 85.051129;
function cutPolylineByMercatorBounds(positions, options2) {
  const { size: size12 = 2, startIndex = 0, endIndex = positions.length, normalize: normalize5 = true } = options2 || {};
  const newPositions = positions.slice(startIndex, endIndex);
  wrapLongitudesForShortestPath(newPositions, size12, 0, endIndex - startIndex);
  const parts = cutPolylineByGrid(newPositions, {
    size: size12,
    broken: true,
    gridResolution: 360,
    gridOffset: [-180, -180]
  });
  if (normalize5) {
    for (const part of parts) {
      shiftLongitudesIntoRange(part, size12);
    }
  }
  return parts;
}
function cutPolygonByMercatorBounds(positions, holeIndices = null, options2) {
  const { size: size12 = 2, normalize: normalize5 = true, edgeTypes = false } = options2 || {};
  holeIndices = holeIndices || [];
  const newPositions = [];
  const newHoleIndices = [];
  let srcStartIndex = 0;
  let targetIndex = 0;
  for (let ringIndex = 0; ringIndex <= holeIndices.length; ringIndex++) {
    const srcEndIndex = holeIndices[ringIndex] || positions.length;
    const targetStartIndex = targetIndex;
    const splitIndex = findSplitIndex(positions, size12, srcStartIndex, srcEndIndex);
    for (let i2 = splitIndex; i2 < srcEndIndex; i2++) {
      newPositions[targetIndex++] = positions[i2];
    }
    for (let i2 = srcStartIndex; i2 < splitIndex; i2++) {
      newPositions[targetIndex++] = positions[i2];
    }
    wrapLongitudesForShortestPath(newPositions, size12, targetStartIndex, targetIndex);
    insertPoleVertices(newPositions, size12, targetStartIndex, targetIndex, options2 == null ? void 0 : options2.maxLatitude);
    srcStartIndex = srcEndIndex;
    newHoleIndices[ringIndex] = targetIndex;
  }
  newHoleIndices.pop();
  const parts = cutPolygonByGrid(newPositions, newHoleIndices, {
    size: size12,
    gridResolution: 360,
    gridOffset: [-180, -180],
    edgeTypes
  });
  if (normalize5) {
    for (const part of parts) {
      shiftLongitudesIntoRange(part.positions, size12);
    }
  }
  return parts;
}
function findSplitIndex(positions, size12, startIndex, endIndex) {
  let maxLat = -1;
  let pointIndex = -1;
  for (let i2 = startIndex + 1; i2 < endIndex; i2 += size12) {
    const lat = Math.abs(positions[i2]);
    if (lat > maxLat) {
      maxLat = lat;
      pointIndex = i2 - 1;
    }
  }
  return pointIndex;
}
function insertPoleVertices(positions, size12, startIndex, endIndex, maxLatitude = DEFAULT_MAX_LATITUDE) {
  const firstLng = positions[startIndex];
  const lastLng = positions[endIndex - size12];
  if (Math.abs(firstLng - lastLng) > 180) {
    const p2 = getPointAtIndex(positions, 0, size12, startIndex);
    p2[0] += Math.round((lastLng - firstLng) / 360) * 360;
    push(positions, p2);
    p2[1] = Math.sign(p2[1]) * maxLatitude;
    push(positions, p2);
    p2[0] = firstLng;
    push(positions, p2);
  }
}
function wrapLongitudesForShortestPath(positions, size12, startIndex, endIndex) {
  let prevLng = positions[0];
  let lng;
  for (let i2 = startIndex; i2 < endIndex; i2 += size12) {
    lng = positions[i2];
    const delta = lng - prevLng;
    if (delta > 180 || delta < -180) {
      lng -= Math.round(delta / 360) * 360;
    }
    positions[i2] = prevLng = lng;
  }
}
function shiftLongitudesIntoRange(positions, size12) {
  let refLng;
  const pointCount = positions.length / size12;
  for (let i2 = 0; i2 < pointCount; i2++) {
    refLng = positions[i2 * size12];
    if ((refLng + 180) % 360 !== 0) {
      break;
    }
  }
  const delta = -Math.round(refLng / 360) * 360;
  if (delta === 0) {
    return;
  }
  for (let i2 = 0; i2 < pointCount; i2++) {
    positions[i2 * size12] += delta;
  }
}
class ColumnGeometry extends Geometry {
  constructor(props) {
    const { indices, attributes } = tesselateColumn(props);
    super({
      ...props,
      indices,
      // @ts-expect-error
      attributes
    });
  }
}
function tesselateColumn(props) {
  const { radius, height = 1, nradial = 10 } = props;
  let { vertices } = props;
  if (vertices) {
    log$1.assert(vertices.length >= nradial);
    vertices = vertices.flatMap((v5) => [v5[0], v5[1]]);
    modifyPolygonWindingDirection(vertices, WINDING.COUNTER_CLOCKWISE);
  }
  const isExtruded = height > 0;
  const vertsAroundEdge = nradial + 1;
  const numVertices = isExtruded ? vertsAroundEdge * 3 + 1 : nradial;
  const stepAngle = Math.PI * 2 / nradial;
  const indices = new Uint16Array(isExtruded ? nradial * 3 * 2 : 0);
  const positions = new Float32Array(numVertices * 3);
  const normals = new Float32Array(numVertices * 3);
  let i2 = 0;
  if (isExtruded) {
    for (let j2 = 0; j2 < vertsAroundEdge; j2++) {
      const a2 = j2 * stepAngle;
      const vertexIndex = j2 % nradial;
      const sin2 = Math.sin(a2);
      const cos2 = Math.cos(a2);
      for (let k2 = 0; k2 < 2; k2++) {
        positions[i2 + 0] = vertices ? vertices[vertexIndex * 2] : cos2 * radius;
        positions[i2 + 1] = vertices ? vertices[vertexIndex * 2 + 1] : sin2 * radius;
        positions[i2 + 2] = (1 / 2 - k2) * height;
        normals[i2 + 0] = vertices ? vertices[vertexIndex * 2] : cos2;
        normals[i2 + 1] = vertices ? vertices[vertexIndex * 2 + 1] : sin2;
        i2 += 3;
      }
    }
    positions[i2 + 0] = positions[i2 - 3];
    positions[i2 + 1] = positions[i2 - 2];
    positions[i2 + 2] = positions[i2 - 1];
    i2 += 3;
  }
  for (let j2 = isExtruded ? 0 : 1; j2 < vertsAroundEdge; j2++) {
    const v5 = Math.floor(j2 / 2) * Math.sign(0.5 - j2 % 2);
    const a2 = v5 * stepAngle;
    const vertexIndex = (v5 + nradial) % nradial;
    const sin2 = Math.sin(a2);
    const cos2 = Math.cos(a2);
    positions[i2 + 0] = vertices ? vertices[vertexIndex * 2] : cos2 * radius;
    positions[i2 + 1] = vertices ? vertices[vertexIndex * 2 + 1] : sin2 * radius;
    positions[i2 + 2] = height / 2;
    normals[i2 + 2] = 1;
    i2 += 3;
  }
  if (isExtruded) {
    let index2 = 0;
    for (let j2 = 0; j2 < nradial; j2++) {
      indices[index2++] = j2 * 2 + 0;
      indices[index2++] = j2 * 2 + 2;
      indices[index2++] = j2 * 2 + 0;
      indices[index2++] = j2 * 2 + 1;
      indices[index2++] = j2 * 2 + 1;
      indices[index2++] = j2 * 2 + 3;
    }
  }
  return {
    indices,
    attributes: {
      POSITION: { size: 3, value: positions },
      NORMAL: { size: 3, value: normals }
    }
  };
}
const vs$8 = `#version 300 es
#define SHADER_NAME column-layer-vertex-shader
in vec3 positions;
in vec3 normals;
in vec3 instancePositions;
in float instanceElevations;
in vec3 instancePositions64Low;
in vec4 instanceFillColors;
in vec4 instanceLineColors;
in float instanceStrokeWidths;
in vec3 instancePickingColors;
uniform float opacity;
uniform float radius;
uniform float angle;
uniform vec2 offset;
uniform bool extruded;
uniform bool stroked;
uniform bool isStroke;
uniform float coverage;
uniform float elevationScale;
uniform float edgeDistance;
uniform float widthScale;
uniform float widthMinPixels;
uniform float widthMaxPixels;
uniform int radiusUnits;
uniform int widthUnits;
out vec4 vColor;
#ifdef FLAT_SHADING
out vec4 position_commonspace;
#endif
void main(void) {
geometry.worldPosition = instancePositions;
vec4 color = isStroke ? instanceLineColors : instanceFillColors;
mat2 rotationMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));
float elevation = 0.0;
float strokeOffsetRatio = 1.0;
if (extruded) {
elevation = instanceElevations * (positions.z + 1.0) / 2.0 * elevationScale;
} else if (stroked) {
float widthPixels = clamp(
project_size_to_pixel(instanceStrokeWidths * widthScale, widthUnits),
widthMinPixels, widthMaxPixels) / 2.0;
float halfOffset = project_pixel_size(widthPixels) / project_size(edgeDistance * coverage * radius);
if (isStroke) {
strokeOffsetRatio -= sign(positions.z) * halfOffset;
} else {
strokeOffsetRatio -= halfOffset;
}
}
float shouldRender = float(color.a > 0.0 && instanceElevations >= 0.0);
float dotRadius = radius * coverage * shouldRender;
geometry.pickingColor = instancePickingColors;
vec3 centroidPosition = vec3(instancePositions.xy, instancePositions.z + elevation);
vec3 centroidPosition64Low = instancePositions64Low;
vec2 offset = (rotationMatrix * positions.xy * strokeOffsetRatio + offset) * dotRadius;
if (radiusUnits == UNIT_METERS) {
offset = project_size(offset);
}
vec3 pos = vec3(offset, 0.);
DECKGL_FILTER_SIZE(pos, geometry);
gl_Position = project_position_to_clipspace(centroidPosition, centroidPosition64Low, pos, geometry.position);
geometry.normal = project_normal(vec3(rotationMatrix * normals.xy, normals.z));
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
if (extruded && !isStroke) {
#ifdef FLAT_SHADING
position_commonspace = geometry.position;
vColor = vec4(color.rgb, color.a * opacity);
#else
vec3 lightColor = lighting_getLightColor(color.rgb, project_uCameraPosition, geometry.position.xyz, geometry.normal);
vColor = vec4(lightColor, color.a * opacity);
#endif
} else {
vColor = vec4(color.rgb, color.a * opacity);
}
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;
const fs$a = `#version 300 es
#define SHADER_NAME column-layer-fragment-shader
precision highp float;
uniform vec3 project_uCameraPosition;
uniform bool extruded;
uniform bool isStroke;
out vec4 fragColor;
in vec4 vColor;
#ifdef FLAT_SHADING
in vec4 position_commonspace;
#endif
void main(void) {
fragColor = vColor;
geometry.uv = vec2(0.);
#ifdef FLAT_SHADING
if (extruded && !isStroke && !bool(picking.isActive)) {
vec3 normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));
fragColor.rgb = lighting_getLightColor(vColor.rgb, project_uCameraPosition, position_commonspace.xyz, normal);
}
#endif
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_COLOR$5 = [0, 0, 0, 255];
const defaultProps$k = {
  diskResolution: { type: "number", min: 4, value: 20 },
  vertices: null,
  radius: { type: "number", min: 0, value: 1e3 },
  angle: { type: "number", value: 0 },
  offset: { type: "array", value: [0, 0] },
  coverage: { type: "number", min: 0, max: 1, value: 1 },
  elevationScale: { type: "number", min: 0, value: 1 },
  radiusUnits: "meters",
  lineWidthUnits: "meters",
  lineWidthScale: 1,
  lineWidthMinPixels: 0,
  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
  extruded: true,
  wireframe: false,
  filled: true,
  stroked: false,
  flatShading: false,
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getFillColor: { type: "accessor", value: DEFAULT_COLOR$5 },
  getLineColor: { type: "accessor", value: DEFAULT_COLOR$5 },
  getLineWidth: { type: "accessor", value: 1 },
  getElevation: { type: "accessor", value: 1e3 },
  material: true,
  getColor: { deprecatedFor: ["getFillColor", "getLineColor"] }
};
const _ColumnLayer = class extends Layer {
  getShaders() {
    const defines2 = {};
    const { flatShading } = this.props;
    if (flatShading) {
      defines2.FLAT_SHADING = 1;
    }
    return super.getShaders({
      vs: vs$8,
      fs: fs$a,
      defines: defines2,
      modules: [project32, flatShading ? phongLighting : gouraudLighting, picking]
    });
  }
  /**
   * DeckGL calls initializeState when GL context is available
   * Essentially a deferred constructor
   */
  initializeState() {
    const attributeManager = this.getAttributeManager();
    attributeManager.addInstanced({
      instancePositions: {
        size: 3,
        type: "float64",
        fp64: this.use64bitPositions(),
        transition: true,
        accessor: "getPosition"
      },
      instanceElevations: {
        size: 1,
        transition: true,
        accessor: "getElevation"
      },
      instanceFillColors: {
        size: this.props.colorFormat.length,
        type: "unorm8",
        transition: true,
        accessor: "getFillColor",
        defaultValue: DEFAULT_COLOR$5
      },
      instanceLineColors: {
        size: this.props.colorFormat.length,
        type: "unorm8",
        transition: true,
        accessor: "getLineColor",
        defaultValue: DEFAULT_COLOR$5
      },
      instanceStrokeWidths: {
        size: 1,
        accessor: "getLineWidth",
        transition: true
      }
    });
  }
  updateState(params2) {
    var _a3;
    super.updateState(params2);
    const { props, oldProps, changeFlags } = params2;
    const regenerateModels = changeFlags.extensionsChanged || props.flatShading !== oldProps.flatShading;
    if (regenerateModels) {
      (_a3 = this.state.models) == null ? void 0 : _a3.forEach((model) => model.destroy());
      this.setState(this._getModels());
      this.getAttributeManager().invalidateAll();
    }
    const instanceCount = this.getNumInstances();
    this.state.fillModel.setInstanceCount(instanceCount);
    this.state.wireframeModel.setInstanceCount(instanceCount);
    if (regenerateModels || props.diskResolution !== oldProps.diskResolution || props.vertices !== oldProps.vertices || (props.extruded || props.stroked) !== (oldProps.extruded || oldProps.stroked)) {
      this._updateGeometry(props);
    }
  }
  getGeometry(diskResolution, vertices, hasThinkness) {
    const geometry2 = new ColumnGeometry({
      radius: 1,
      height: hasThinkness ? 2 : 0,
      vertices,
      nradial: diskResolution
    });
    let meanVertexDistance = 0;
    if (vertices) {
      for (let i2 = 0; i2 < diskResolution; i2++) {
        const p2 = vertices[i2];
        const d2 = Math.sqrt(p2[0] * p2[0] + p2[1] * p2[1]);
        meanVertexDistance += d2 / diskResolution;
      }
    } else {
      meanVertexDistance = 1;
    }
    this.setState({
      edgeDistance: Math.cos(Math.PI / diskResolution) * meanVertexDistance
    });
    return geometry2;
  }
  _getModels() {
    const shaders = this.getShaders();
    const bufferLayout = this.getAttributeManager().getBufferLayouts();
    const fillModel = new Model(this.context.device, {
      ...shaders,
      id: `${this.props.id}-fill`,
      bufferLayout,
      isInstanced: true
    });
    const wireframeModel = new Model(this.context.device, {
      ...shaders,
      id: `${this.props.id}-wireframe`,
      bufferLayout,
      isInstanced: true
    });
    return {
      fillModel,
      wireframeModel,
      models: [wireframeModel, fillModel]
    };
  }
  _updateGeometry({ diskResolution, vertices, extruded, stroked }) {
    const geometry2 = this.getGeometry(diskResolution, vertices, extruded || stroked);
    this.setState({
      fillVertexCount: geometry2.attributes.POSITION.value.length / 3
    });
    const fillModel = this.state.fillModel;
    const wireframeModel = this.state.wireframeModel;
    fillModel.setGeometry(geometry2);
    fillModel.setTopology("triangle-strip");
    fillModel.setIndexBuffer(null);
    wireframeModel.setGeometry(geometry2);
    wireframeModel.setTopology("line-list");
  }
  draw({ uniforms }) {
    const { lineWidthUnits, lineWidthScale, lineWidthMinPixels, lineWidthMaxPixels, radiusUnits, elevationScale, extruded, filled, stroked, wireframe, offset, coverage, radius, angle: angle4 } = this.props;
    const fillModel = this.state.fillModel;
    const wireframeModel = this.state.wireframeModel;
    const { fillVertexCount, edgeDistance } = this.state;
    const renderUniforms = {
      ...uniforms,
      radius,
      angle: angle4 / 180 * Math.PI,
      offset,
      extruded,
      stroked,
      coverage,
      elevationScale,
      edgeDistance,
      radiusUnits: UNIT[radiusUnits],
      widthUnits: UNIT[lineWidthUnits],
      widthScale: lineWidthScale,
      widthMinPixels: lineWidthMinPixels,
      widthMaxPixels: lineWidthMaxPixels
    };
    if (extruded && wireframe) {
      wireframeModel.setUniforms(renderUniforms);
      wireframeModel.setUniforms({ isStroke: true });
      wireframeModel.draw(this.context.renderPass);
    }
    fillModel.setUniforms(renderUniforms);
    if (filled) {
      fillModel.setVertexCount(fillVertexCount);
      fillModel.setUniforms({ isStroke: false });
      fillModel.draw(this.context.renderPass);
    }
    if (!extruded && stroked) {
      fillModel.setVertexCount(fillVertexCount * 2 / 3);
      fillModel.setUniforms({ isStroke: true });
      fillModel.draw(this.context.renderPass);
    }
  }
};
let ColumnLayer = _ColumnLayer;
(() => {
  _ColumnLayer.layerName = "ColumnLayer";
})();
(() => {
  _ColumnLayer.defaultProps = defaultProps$k;
})();
function normalizePath(path2, size12, gridResolution, wrapLongitude) {
  let flatPath;
  if (Array.isArray(path2[0])) {
    const length2 = path2.length * size12;
    flatPath = new Array(length2);
    for (let i2 = 0; i2 < path2.length; i2++) {
      for (let j2 = 0; j2 < size12; j2++) {
        flatPath[i2 * size12 + j2] = path2[i2][j2] || 0;
      }
    }
  } else {
    flatPath = path2;
  }
  if (gridResolution) {
    return cutPolylineByGrid(flatPath, { size: size12, gridResolution });
  }
  if (wrapLongitude) {
    return cutPolylineByMercatorBounds(flatPath, { size: size12 });
  }
  return flatPath;
}
const START_CAP = 1;
const END_CAP = 2;
const INVALID = 4;
class PathTesselator extends Tesselator {
  constructor(opts) {
    super({
      ...opts,
      attributes: {
        // Padding covers shaderAttributes for last segment in largest case fp64
        // additional vertex + hi & low parts, 3 * 6
        positions: {
          size: 3,
          padding: 18,
          initialize: true,
          type: opts.fp64 ? Float64Array : Float32Array
        },
        segmentTypes: { size: 1, type: Uint8ClampedArray }
      }
    });
  }
  /** Get packed attribute by name */
  get(attributeName) {
    return this.attributes[attributeName];
  }
  /* Implement base Tesselator interface */
  getGeometryFromBuffer(buffer3) {
    if (this.normalize) {
      return super.getGeometryFromBuffer(buffer3);
    }
    return null;
  }
  /* Implement base Tesselator interface */
  normalizeGeometry(path2) {
    if (this.normalize) {
      return normalizePath(path2, this.positionSize, this.opts.resolution, this.opts.wrapLongitude);
    }
    return path2;
  }
  /* Implement base Tesselator interface */
  getGeometrySize(path2) {
    if (isCut$1(path2)) {
      let size12 = 0;
      for (const subPath of path2) {
        size12 += this.getGeometrySize(subPath);
      }
      return size12;
    }
    const numPoints = this.getPathLength(path2);
    if (numPoints < 2) {
      return 0;
    }
    if (this.isClosed(path2)) {
      return numPoints < 3 ? 0 : numPoints + 2;
    }
    return numPoints;
  }
  /* Implement base Tesselator interface */
  updateGeometryAttributes(path2, context2) {
    if (context2.geometrySize === 0) {
      return;
    }
    if (path2 && isCut$1(path2)) {
      for (const subPath of path2) {
        const geometrySize = this.getGeometrySize(subPath);
        context2.geometrySize = geometrySize;
        this.updateGeometryAttributes(subPath, context2);
        context2.vertexStart += geometrySize;
      }
    } else {
      this._updateSegmentTypes(path2, context2);
      this._updatePositions(path2, context2);
    }
  }
  _updateSegmentTypes(path2, context2) {
    const segmentTypes = this.attributes.segmentTypes;
    const isPathClosed = path2 ? this.isClosed(path2) : false;
    const { vertexStart, geometrySize } = context2;
    segmentTypes.fill(0, vertexStart, vertexStart + geometrySize);
    if (isPathClosed) {
      segmentTypes[vertexStart] = INVALID;
      segmentTypes[vertexStart + geometrySize - 2] = INVALID;
    } else {
      segmentTypes[vertexStart] += START_CAP;
      segmentTypes[vertexStart + geometrySize - 2] += END_CAP;
    }
    segmentTypes[vertexStart + geometrySize - 1] = INVALID;
  }
  _updatePositions(path2, context2) {
    const { positions } = this.attributes;
    if (!positions || !path2) {
      return;
    }
    const { vertexStart, geometrySize } = context2;
    const p2 = new Array(3);
    for (let i2 = vertexStart, ptIndex = 0; ptIndex < geometrySize; i2++, ptIndex++) {
      this.getPointOnPath(path2, ptIndex, p2);
      positions[i2 * 3] = p2[0];
      positions[i2 * 3 + 1] = p2[1];
      positions[i2 * 3 + 2] = p2[2];
    }
  }
  // Utilities
  /** Returns the number of points in the path */
  getPathLength(path2) {
    return path2.length / this.positionSize;
  }
  /** Returns a point on the path at the specified index */
  getPointOnPath(path2, index2, target = []) {
    const { positionSize } = this;
    if (index2 * positionSize >= path2.length) {
      index2 += 1 - path2.length / positionSize;
    }
    const i2 = index2 * positionSize;
    target[0] = path2[i2];
    target[1] = path2[i2 + 1];
    target[2] = positionSize === 3 && path2[i2 + 2] || 0;
    return target;
  }
  // Returns true if the first and last points are identical
  isClosed(path2) {
    if (!this.normalize) {
      return Boolean(this.opts.loop);
    }
    const { positionSize } = this;
    const lastPointIndex = path2.length - positionSize;
    return path2[0] === path2[lastPointIndex] && path2[1] === path2[lastPointIndex + 1] && (positionSize === 2 || path2[2] === path2[lastPointIndex + 2]);
  }
}
function isCut$1(path2) {
  return Array.isArray(path2[0]);
}
const vs$7 = `#version 300 es
#define SHADER_NAME path-layer-vertex-shader
in vec2 positions;
in float instanceTypes;
in vec3 instanceStartPositions;
in vec3 instanceEndPositions;
in vec3 instanceLeftPositions;
in vec3 instanceRightPositions;
in vec3 instanceLeftPositions64Low;
in vec3 instanceStartPositions64Low;
in vec3 instanceEndPositions64Low;
in vec3 instanceRightPositions64Low;
in float instanceStrokeWidths;
in vec4 instanceColors;
in vec3 instancePickingColors;
uniform float widthScale;
uniform float widthMinPixels;
uniform float widthMaxPixels;
uniform float jointType;
uniform float capType;
uniform float miterLimit;
uniform bool billboard;
uniform int widthUnits;
uniform float opacity;
out vec4 vColor;
out vec2 vCornerOffset;
out float vMiterLength;
out vec2 vPathPosition;
out float vPathLength;
out float vJointType;
const float EPSILON = 0.001;
const vec3 ZERO_OFFSET = vec3(0.0);
float flipIfTrue(bool flag) {
return -(float(flag) * 2. - 1.);
}
vec3 getLineJoinOffset(
vec3 prevPoint, vec3 currPoint, vec3 nextPoint,
vec2 width
) {
bool isEnd = positions.x > 0.0;
float sideOfPath = positions.y;
float isJoint = float(sideOfPath == 0.0);
vec3 deltaA3 = (currPoint - prevPoint);
vec3 deltaB3 = (nextPoint - currPoint);
mat3 rotationMatrix;
bool needsRotation = !billboard && project_needs_rotation(currPoint, rotationMatrix);
if (needsRotation) {
deltaA3 = deltaA3 * rotationMatrix;
deltaB3 = deltaB3 * rotationMatrix;
}
vec2 deltaA = deltaA3.xy / width;
vec2 deltaB = deltaB3.xy / width;
float lenA = length(deltaA);
float lenB = length(deltaB);
vec2 dirA = lenA > 0. ? normalize(deltaA) : vec2(0.0, 0.0);
vec2 dirB = lenB > 0. ? normalize(deltaB) : vec2(0.0, 0.0);
vec2 perpA = vec2(-dirA.y, dirA.x);
vec2 perpB = vec2(-dirB.y, dirB.x);
vec2 tangent = dirA + dirB;
tangent = length(tangent) > 0. ? normalize(tangent) : perpA;
vec2 miterVec = vec2(-tangent.y, tangent.x);
vec2 dir = isEnd ? dirA : dirB;
vec2 perp = isEnd ? perpA : perpB;
float L = isEnd ? lenA : lenB;
float sinHalfA = abs(dot(miterVec, perp));
float cosHalfA = abs(dot(dirA, miterVec));
float turnDirection = flipIfTrue(dirA.x * dirB.y >= dirA.y * dirB.x);
float cornerPosition = sideOfPath * turnDirection;
float miterSize = 1.0 / max(sinHalfA, EPSILON);
miterSize = mix(
min(miterSize, max(lenA, lenB) / max(cosHalfA, EPSILON)),
miterSize,
step(0.0, cornerPosition)
);
vec2 offsetVec = mix(miterVec * miterSize, perp, step(0.5, cornerPosition))
* (sideOfPath + isJoint * turnDirection);
bool isStartCap = lenA == 0.0 || (!isEnd && (instanceTypes == 1.0 || instanceTypes == 3.0));
bool isEndCap = lenB == 0.0 || (isEnd && (instanceTypes == 2.0 || instanceTypes == 3.0));
bool isCap = isStartCap || isEndCap;
if (isCap) {
offsetVec = mix(perp * sideOfPath, dir * capType * 4.0 * flipIfTrue(isStartCap), isJoint);
vJointType = capType;
} else {
vJointType = jointType;
}
vPathLength = L;
vCornerOffset = offsetVec;
vMiterLength = dot(vCornerOffset, miterVec * turnDirection);
vMiterLength = isCap ? isJoint : vMiterLength;
vec2 offsetFromStartOfPath = vCornerOffset + deltaA * float(isEnd);
vPathPosition = vec2(
dot(offsetFromStartOfPath, perp),
dot(offsetFromStartOfPath, dir)
);
geometry.uv = vPathPosition;
float isValid = step(instanceTypes, 3.5);
vec3 offset = vec3(offsetVec * width * isValid, 0.0);
if (needsRotation) {
offset = rotationMatrix * offset;
}
return offset;
}
void clipLine(inout vec4 position, vec4 refPosition) {
if (position.w < EPSILON) {
float r = (EPSILON - refPosition.w) / (position.w - refPosition.w);
position = refPosition + (position - refPosition) * r;
}
}
void main() {
geometry.pickingColor = instancePickingColors;
vColor = vec4(instanceColors.rgb, instanceColors.a * opacity);
float isEnd = positions.x;
vec3 prevPosition = mix(instanceLeftPositions, instanceStartPositions, isEnd);
vec3 prevPosition64Low = mix(instanceLeftPositions64Low, instanceStartPositions64Low, isEnd);
vec3 currPosition = mix(instanceStartPositions, instanceEndPositions, isEnd);
vec3 currPosition64Low = mix(instanceStartPositions64Low, instanceEndPositions64Low, isEnd);
vec3 nextPosition = mix(instanceEndPositions, instanceRightPositions, isEnd);
vec3 nextPosition64Low = mix(instanceEndPositions64Low, instanceRightPositions64Low, isEnd);
geometry.worldPosition = currPosition;
vec2 widthPixels = vec2(clamp(
project_size_to_pixel(instanceStrokeWidths * widthScale, widthUnits),
widthMinPixels, widthMaxPixels) / 2.0);
vec3 width;
if (billboard) {
vec4 prevPositionScreen = project_position_to_clipspace(prevPosition, prevPosition64Low, ZERO_OFFSET);
vec4 currPositionScreen = project_position_to_clipspace(currPosition, currPosition64Low, ZERO_OFFSET, geometry.position);
vec4 nextPositionScreen = project_position_to_clipspace(nextPosition, nextPosition64Low, ZERO_OFFSET);
clipLine(prevPositionScreen, currPositionScreen);
clipLine(nextPositionScreen, currPositionScreen);
clipLine(currPositionScreen, mix(nextPositionScreen, prevPositionScreen, isEnd));
width = vec3(widthPixels, 0.0);
DECKGL_FILTER_SIZE(width, geometry);
vec3 offset = getLineJoinOffset(
prevPositionScreen.xyz / prevPositionScreen.w,
currPositionScreen.xyz / currPositionScreen.w,
nextPositionScreen.xyz / nextPositionScreen.w,
project_pixel_size_to_clipspace(width.xy)
);
DECKGL_FILTER_GL_POSITION(currPositionScreen, geometry);
gl_Position = vec4(currPositionScreen.xyz + offset * currPositionScreen.w, currPositionScreen.w);
} else {
prevPosition = project_position(prevPosition, prevPosition64Low);
currPosition = project_position(currPosition, currPosition64Low);
nextPosition = project_position(nextPosition, nextPosition64Low);
width = vec3(project_pixel_size(widthPixels), 0.0);
DECKGL_FILTER_SIZE(width, geometry);
vec3 offset = getLineJoinOffset(prevPosition, currPosition, nextPosition, width.xy);
geometry.position = vec4(currPosition + offset, 1.0);
gl_Position = project_common_position_to_clipspace(geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
}
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;
const fs$9 = `#version 300 es
#define SHADER_NAME path-layer-fragment-shader
precision highp float;
uniform float miterLimit;
in vec4 vColor;
in vec2 vCornerOffset;
in float vMiterLength;
in vec2 vPathPosition;
in float vPathLength;
in float vJointType;
out vec4 fragColor;
void main(void) {
geometry.uv = vPathPosition;
if (vPathPosition.y < 0.0 || vPathPosition.y > vPathLength) {
if (vJointType > 0.5 && length(vCornerOffset) > 1.0) {
discard;
}
if (vJointType < 0.5 && vMiterLength > miterLimit + 1.0) {
discard;
}
}
fragColor = vColor;
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_COLOR$4 = [0, 0, 0, 255];
const defaultProps$j = {
  widthUnits: "meters",
  widthScale: { type: "number", min: 0, value: 1 },
  widthMinPixels: { type: "number", min: 0, value: 0 },
  widthMaxPixels: { type: "number", min: 0, value: Number.MAX_SAFE_INTEGER },
  jointRounded: false,
  capRounded: false,
  miterLimit: { type: "number", min: 0, value: 4 },
  billboard: false,
  _pathType: null,
  getPath: { type: "accessor", value: (object2) => object2.path },
  getColor: { type: "accessor", value: DEFAULT_COLOR$4 },
  getWidth: { type: "accessor", value: 1 },
  // deprecated props
  rounded: { deprecatedFor: ["jointRounded", "capRounded"] }
};
const ATTRIBUTE_TRANSITION$1 = {
  enter: (value, chunk) => {
    return chunk.length ? chunk.subarray(chunk.length - value.length) : value;
  }
};
const _PathLayer = class extends Layer {
  getShaders() {
    return super.getShaders({ vs: vs$7, fs: fs$9, modules: [project32, picking] });
  }
  get wrapLongitude() {
    return false;
  }
  getBounds() {
    var _a3;
    return (_a3 = this.getAttributeManager()) == null ? void 0 : _a3.getBounds(["vertexPositions"]);
  }
  initializeState() {
    const noAlloc = true;
    const attributeManager = this.getAttributeManager();
    attributeManager.addInstanced({
      vertexPositions: {
        size: 3,
        // Start filling buffer from 1 vertex in
        vertexOffset: 1,
        type: "float64",
        fp64: this.use64bitPositions(),
        transition: ATTRIBUTE_TRANSITION$1,
        accessor: "getPath",
        // eslint-disable-next-line @typescript-eslint/unbound-method
        update: this.calculatePositions,
        noAlloc,
        shaderAttributes: {
          instanceLeftPositions: {
            vertexOffset: 0
          },
          instanceStartPositions: {
            vertexOffset: 1
          },
          instanceEndPositions: {
            vertexOffset: 2
          },
          instanceRightPositions: {
            vertexOffset: 3
          }
        }
      },
      instanceTypes: {
        size: 1,
        type: "uint8",
        // eslint-disable-next-line @typescript-eslint/unbound-method
        update: this.calculateSegmentTypes,
        noAlloc
      },
      instanceStrokeWidths: {
        size: 1,
        accessor: "getWidth",
        transition: ATTRIBUTE_TRANSITION$1,
        defaultValue: 1
      },
      instanceColors: {
        size: this.props.colorFormat.length,
        type: "unorm8",
        accessor: "getColor",
        transition: ATTRIBUTE_TRANSITION$1,
        defaultValue: DEFAULT_COLOR$4
      },
      instancePickingColors: {
        size: 4,
        type: "uint8",
        accessor: (object2, { index: index2, target: value }) => this.encodePickingColor(object2 && object2.__source ? object2.__source.index : index2, value)
      }
    });
    this.setState({
      pathTesselator: new PathTesselator({
        fp64: this.use64bitPositions()
      })
    });
  }
  updateState(params2) {
    var _a3;
    super.updateState(params2);
    const { props, changeFlags } = params2;
    const attributeManager = this.getAttributeManager();
    const geometryChanged2 = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPath);
    if (geometryChanged2) {
      const { pathTesselator } = this.state;
      const buffers = props.data.attributes || {};
      pathTesselator.updateGeometry({
        data: props.data,
        geometryBuffer: buffers.getPath,
        buffers,
        normalize: !props._pathType,
        loop: props._pathType === "loop",
        getGeometry: props.getPath,
        positionFormat: props.positionFormat,
        wrapLongitude: props.wrapLongitude,
        // TODO - move the flag out of the viewport
        resolution: this.context.viewport.resolution,
        dataChanged: changeFlags.dataChanged
      });
      this.setState({
        numInstances: pathTesselator.instanceCount,
        startIndices: pathTesselator.vertexStarts
      });
      if (!changeFlags.dataChanged) {
        attributeManager.invalidateAll();
      }
    }
    if (changeFlags.extensionsChanged) {
      (_a3 = this.state.model) == null ? void 0 : _a3.destroy();
      this.state.model = this._getModel();
      attributeManager.invalidateAll();
    }
  }
  getPickingInfo(params2) {
    const info = super.getPickingInfo(params2);
    const { index: index2 } = info;
    const data2 = this.props.data;
    if (data2[0] && data2[0].__source) {
      info.object = data2.find((d2) => d2.__source.index === index2);
    }
    return info;
  }
  /** Override base Layer method */
  disablePickingIndex(objectIndex) {
    const data2 = this.props.data;
    if (data2[0] && data2[0].__source) {
      for (let i2 = 0; i2 < data2.length; i2++) {
        if (data2[i2].__source.index === objectIndex) {
          this._disablePickingIndex(i2);
        }
      }
    } else {
      super.disablePickingIndex(objectIndex);
    }
  }
  draw({ uniforms }) {
    const { jointRounded, capRounded, billboard, miterLimit, widthUnits, widthScale, widthMinPixels, widthMaxPixels } = this.props;
    const model = this.state.model;
    model.setUniforms(uniforms);
    model.setUniforms({
      jointType: Number(jointRounded),
      capType: Number(capRounded),
      billboard,
      widthUnits: UNIT[widthUnits],
      widthScale,
      miterLimit,
      widthMinPixels,
      widthMaxPixels
    });
    model.draw(this.context.renderPass);
  }
  _getModel() {
    const SEGMENT_INDICES = [
      // start corner
      0,
      1,
      2,
      // body
      1,
      4,
      2,
      1,
      3,
      4,
      // end corner
      3,
      5,
      4
    ];
    const SEGMENT_POSITIONS = [
      // bevel start corner
      0,
      0,
      // start inner corner
      0,
      -1,
      // start outer corner
      0,
      1,
      // end inner corner
      1,
      -1,
      // end outer corner
      1,
      1,
      // bevel end corner
      1,
      0
    ];
    return new Model(this.context.device, {
      ...this.getShaders(),
      id: this.props.id,
      bufferLayout: this.getAttributeManager().getBufferLayouts(),
      geometry: new Geometry({
        topology: "triangle-list",
        attributes: {
          indices: new Uint16Array(SEGMENT_INDICES),
          positions: { value: new Float32Array(SEGMENT_POSITIONS), size: 2 }
        }
      }),
      isInstanced: true
    });
  }
  calculatePositions(attribute) {
    const { pathTesselator } = this.state;
    attribute.startIndices = pathTesselator.vertexStarts;
    attribute.value = pathTesselator.get("positions");
  }
  calculateSegmentTypes(attribute) {
    const { pathTesselator } = this.state;
    attribute.startIndices = pathTesselator.vertexStarts;
    attribute.value = pathTesselator.get("segmentTypes");
  }
};
let PathLayer = _PathLayer;
(() => {
  _PathLayer.defaultProps = defaultProps$j;
})();
(() => {
  _PathLayer.layerName = "PathLayer";
})();
const OUTER_POLYGON_WINDING = WINDING.CLOCKWISE;
const HOLE_POLYGON_WINDING = WINDING.COUNTER_CLOCKWISE;
const windingOptions = {
  isClosed: true
};
function validate$1(polygon4) {
  polygon4 = polygon4 && polygon4.positions || polygon4;
  if (!Array.isArray(polygon4) && !ArrayBuffer.isView(polygon4)) {
    throw new Error("invalid polygon");
  }
}
function getPositions(polygon4) {
  return "positions" in polygon4 ? polygon4.positions : polygon4;
}
function getHoleIndices(polygon4) {
  return "holeIndices" in polygon4 ? polygon4.holeIndices : null;
}
function isNested(polygon4) {
  return Array.isArray(polygon4[0]);
}
function isSimple(polygon4) {
  return polygon4.length >= 1 && polygon4[0].length >= 2 && Number.isFinite(polygon4[0][0]);
}
function isNestedRingClosed(simplePolygon) {
  const p0 = simplePolygon[0];
  const p1 = simplePolygon[simplePolygon.length - 1];
  return p0[0] === p1[0] && p0[1] === p1[1] && p0[2] === p1[2];
}
function isFlatRingClosed(positions, size12, startIndex, endIndex) {
  for (let i2 = 0; i2 < size12; i2++) {
    if (positions[startIndex + i2] !== positions[endIndex - size12 + i2]) {
      return false;
    }
  }
  return true;
}
function copyNestedRing(target, targetStartIndex, simplePolygon, size12, windingDirection) {
  let targetIndex = targetStartIndex;
  const len2 = simplePolygon.length;
  for (let i2 = 0; i2 < len2; i2++) {
    for (let j2 = 0; j2 < size12; j2++) {
      target[targetIndex++] = simplePolygon[i2][j2] || 0;
    }
  }
  if (!isNestedRingClosed(simplePolygon)) {
    for (let j2 = 0; j2 < size12; j2++) {
      target[targetIndex++] = simplePolygon[0][j2] || 0;
    }
  }
  windingOptions.start = targetStartIndex;
  windingOptions.end = targetIndex;
  windingOptions.size = size12;
  modifyPolygonWindingDirection(target, windingDirection, windingOptions);
  return targetIndex;
}
function copyFlatRing(target, targetStartIndex, positions, size12, srcStartIndex = 0, srcEndIndex, windingDirection) {
  srcEndIndex = srcEndIndex || positions.length;
  const srcLength = srcEndIndex - srcStartIndex;
  if (srcLength <= 0) {
    return targetStartIndex;
  }
  let targetIndex = targetStartIndex;
  for (let i2 = 0; i2 < srcLength; i2++) {
    target[targetIndex++] = positions[srcStartIndex + i2];
  }
  if (!isFlatRingClosed(positions, size12, srcStartIndex, srcEndIndex)) {
    for (let i2 = 0; i2 < size12; i2++) {
      target[targetIndex++] = positions[srcStartIndex + i2];
    }
  }
  windingOptions.start = targetStartIndex;
  windingOptions.end = targetIndex;
  windingOptions.size = size12;
  modifyPolygonWindingDirection(target, windingDirection, windingOptions);
  return targetIndex;
}
function normalize$2(polygon4, positionSize) {
  validate$1(polygon4);
  const positions = [];
  const holeIndices = [];
  if ("positions" in polygon4) {
    const { positions: srcPositions, holeIndices: srcHoleIndices } = polygon4;
    if (srcHoleIndices) {
      let targetIndex = 0;
      for (let i2 = 0; i2 <= srcHoleIndices.length; i2++) {
        targetIndex = copyFlatRing(positions, targetIndex, srcPositions, positionSize, srcHoleIndices[i2 - 1], srcHoleIndices[i2], i2 === 0 ? OUTER_POLYGON_WINDING : HOLE_POLYGON_WINDING);
        holeIndices.push(targetIndex);
      }
      holeIndices.pop();
      return { positions, holeIndices };
    }
    polygon4 = srcPositions;
  }
  if (!isNested(polygon4)) {
    copyFlatRing(positions, 0, polygon4, positionSize, 0, positions.length, OUTER_POLYGON_WINDING);
    return positions;
  }
  if (!isSimple(polygon4)) {
    let targetIndex = 0;
    for (const [polygonIndex, simplePolygon] of polygon4.entries()) {
      targetIndex = copyNestedRing(positions, targetIndex, simplePolygon, positionSize, polygonIndex === 0 ? OUTER_POLYGON_WINDING : HOLE_POLYGON_WINDING);
      holeIndices.push(targetIndex);
    }
    holeIndices.pop();
    return { positions, holeIndices };
  }
  copyNestedRing(positions, 0, polygon4, positionSize, OUTER_POLYGON_WINDING);
  return positions;
}
function getPlaneArea(positions, xIndex, yIndex) {
  const numVerts = positions.length / 3;
  let area5 = 0;
  for (let i2 = 0; i2 < numVerts; i2++) {
    const j2 = (i2 + 1) % numVerts;
    area5 += positions[i2 * 3 + xIndex] * positions[j2 * 3 + yIndex];
    area5 -= positions[j2 * 3 + xIndex] * positions[i2 * 3 + yIndex];
  }
  return Math.abs(area5 / 2);
}
function permutePositions(positions, xIndex, yIndex, zIndex) {
  const numVerts = positions.length / 3;
  for (let i2 = 0; i2 < numVerts; i2++) {
    const o2 = i2 * 3;
    const x2 = positions[o2 + 0];
    const y2 = positions[o2 + 1];
    const z2 = positions[o2 + 2];
    positions[o2 + xIndex] = x2;
    positions[o2 + yIndex] = y2;
    positions[o2 + zIndex] = z2;
  }
}
function getSurfaceIndices(polygon4, positionSize, preproject, full3d) {
  let holeIndices = getHoleIndices(polygon4);
  if (holeIndices) {
    holeIndices = holeIndices.map((positionIndex) => positionIndex / positionSize);
  }
  let positions = getPositions(polygon4);
  const is3d = full3d && positionSize === 3;
  if (preproject) {
    const n2 = positions.length;
    positions = positions.slice();
    const p2 = [];
    for (let i2 = 0; i2 < n2; i2 += positionSize) {
      p2[0] = positions[i2];
      p2[1] = positions[i2 + 1];
      if (is3d) {
        p2[2] = positions[i2 + 2];
      }
      const xy = preproject(p2);
      positions[i2] = xy[0];
      positions[i2 + 1] = xy[1];
      if (is3d) {
        positions[i2 + 2] = xy[2];
      }
    }
  }
  if (is3d) {
    const xyArea = getPlaneArea(positions, 0, 1);
    const xzArea = getPlaneArea(positions, 0, 2);
    const yzArea = getPlaneArea(positions, 1, 2);
    if (!xyArea && !xzArea && !yzArea) {
      return [];
    }
    if (xyArea > xzArea && xyArea > yzArea)
      ;
    else if (xzArea > yzArea) {
      if (!preproject) {
        positions = positions.slice();
      }
      permutePositions(positions, 0, 2, 1);
    } else {
      if (!preproject) {
        positions = positions.slice();
      }
      permutePositions(positions, 2, 0, 1);
    }
  }
  return earcutExports(positions, holeIndices, positionSize);
}
class PolygonTesselator extends Tesselator {
  constructor(opts) {
    const { fp64, IndexType = Uint32Array } = opts;
    super({
      ...opts,
      attributes: {
        positions: { size: 3, type: fp64 ? Float64Array : Float32Array },
        vertexValid: { type: Uint16Array, size: 1 },
        indices: { type: IndexType, size: 1 }
      }
    });
  }
  /** Get attribute by name */
  get(attributeName) {
    const { attributes } = this;
    if (attributeName === "indices") {
      return attributes.indices && attributes.indices.subarray(0, this.vertexCount);
    }
    return attributes[attributeName];
  }
  /** Override base Tesselator method */
  updateGeometry(opts) {
    super.updateGeometry(opts);
    const externalIndices = this.buffers.indices;
    if (externalIndices) {
      this.vertexCount = (externalIndices.value || externalIndices).length;
    } else if (this.data && !this.getGeometry) {
      throw new Error("missing indices buffer");
    }
  }
  /** Implement base Tesselator interface */
  normalizeGeometry(polygon4) {
    if (this.normalize) {
      const normalizedPolygon = normalize$2(polygon4, this.positionSize);
      if (this.opts.resolution) {
        return cutPolygonByGrid(getPositions(normalizedPolygon), getHoleIndices(normalizedPolygon), {
          size: this.positionSize,
          gridResolution: this.opts.resolution,
          edgeTypes: true
        });
      }
      if (this.opts.wrapLongitude) {
        return cutPolygonByMercatorBounds(getPositions(normalizedPolygon), getHoleIndices(normalizedPolygon), {
          size: this.positionSize,
          maxLatitude: 86,
          edgeTypes: true
        });
      }
      return normalizedPolygon;
    }
    return polygon4;
  }
  /** Implement base Tesselator interface */
  getGeometrySize(polygon4) {
    if (isCut(polygon4)) {
      let size12 = 0;
      for (const subPolygon of polygon4) {
        size12 += this.getGeometrySize(subPolygon);
      }
      return size12;
    }
    return getPositions(polygon4).length / this.positionSize;
  }
  /** Override base Tesselator method */
  getGeometryFromBuffer(buffer3) {
    if (this.normalize || !this.buffers.indices) {
      return super.getGeometryFromBuffer(buffer3);
    }
    return null;
  }
  /** Implement base Tesselator interface */
  updateGeometryAttributes(polygon4, context2) {
    if (polygon4 && isCut(polygon4)) {
      for (const subPolygon of polygon4) {
        const geometrySize = this.getGeometrySize(subPolygon);
        context2.geometrySize = geometrySize;
        this.updateGeometryAttributes(subPolygon, context2);
        context2.vertexStart += geometrySize;
        context2.indexStart = this.indexStarts[context2.geometryIndex + 1];
      }
    } else {
      const normalizedPolygon = polygon4;
      this._updateIndices(normalizedPolygon, context2);
      this._updatePositions(normalizedPolygon, context2);
      this._updateVertexValid(normalizedPolygon, context2);
    }
  }
  // Flatten the indices array
  _updateIndices(polygon4, { geometryIndex, vertexStart: offset, indexStart }) {
    const { attributes, indexStarts, typedArrayManager } = this;
    let target = attributes.indices;
    if (!target || !polygon4) {
      return;
    }
    let i2 = indexStart;
    const indices = getSurfaceIndices(polygon4, this.positionSize, this.opts.preproject, this.opts.full3d);
    target = typedArrayManager.allocate(target, indexStart + indices.length, {
      copy: true
    });
    for (let j2 = 0; j2 < indices.length; j2++) {
      target[i2++] = indices[j2] + offset;
    }
    indexStarts[geometryIndex + 1] = indexStart + indices.length;
    attributes.indices = target;
  }
  // Flatten out all the vertices of all the sub subPolygons
  _updatePositions(polygon4, { vertexStart, geometrySize }) {
    const { attributes: { positions }, positionSize } = this;
    if (!positions || !polygon4) {
      return;
    }
    const polygonPositions = getPositions(polygon4);
    for (let i2 = vertexStart, j2 = 0; j2 < geometrySize; i2++, j2++) {
      const x2 = polygonPositions[j2 * positionSize];
      const y2 = polygonPositions[j2 * positionSize + 1];
      const z2 = positionSize > 2 ? polygonPositions[j2 * positionSize + 2] : 0;
      positions[i2 * 3] = x2;
      positions[i2 * 3 + 1] = y2;
      positions[i2 * 3 + 2] = z2;
    }
  }
  _updateVertexValid(polygon4, { vertexStart, geometrySize }) {
    const { positionSize } = this;
    const vertexValid = this.attributes.vertexValid;
    const holeIndices = polygon4 && getHoleIndices(polygon4);
    if (polygon4 && polygon4.edgeTypes) {
      vertexValid.set(polygon4.edgeTypes, vertexStart);
    } else {
      vertexValid.fill(1, vertexStart, vertexStart + geometrySize);
    }
    if (holeIndices) {
      for (let j2 = 0; j2 < holeIndices.length; j2++) {
        vertexValid[vertexStart + holeIndices[j2] / positionSize - 1] = 0;
      }
    }
    vertexValid[vertexStart + geometrySize - 1] = 0;
  }
}
function isCut(polygon4) {
  return Array.isArray(polygon4) && polygon4.length > 0 && !Number.isFinite(polygon4[0]);
}
const main = `uniform bool extruded;
uniform bool isWireframe;
uniform float elevationScale;
uniform float opacity;
in vec4 fillColors;
in vec4 lineColors;
in vec3 pickingColors;
out vec4 vColor;
struct PolygonProps {
vec3 positions;
vec3 positions64Low;
vec3 normal;
float elevations;
};
vec3 project_offset_normal(vec3 vector) {
if (project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT ||
project_uCoordinateSystem == COORDINATE_SYSTEM_LNGLAT_OFFSETS) {
return normalize(vector * project_uCommonUnitsPerWorldUnit);
}
return project_normal(vector);
}
void calculatePosition(PolygonProps props) {
vec3 pos = props.positions;
vec3 pos64Low = props.positions64Low;
vec3 normal = props.normal;
vec4 colors = isWireframe ? lineColors : fillColors;
geometry.worldPosition = props.positions;
geometry.pickingColor = pickingColors;
if (extruded) {
pos.z += props.elevations * elevationScale;
}
gl_Position = project_position_to_clipspace(pos, pos64Low, vec3(0.), geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
if (extruded) {
#ifdef IS_SIDE_VERTEX
normal = project_offset_normal(normal);
#else
normal = project_normal(normal);
#endif
geometry.normal = normal;
vec3 lightColor = lighting_getLightColor(colors.rgb, project_uCameraPosition, geometry.position.xyz, geometry.normal);
vColor = vec4(lightColor, colors.a * opacity);
} else {
vColor = vec4(colors.rgb, colors.a * opacity);
}
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;
const vsTop = `#version 300 es
#define SHADER_NAME solid-polygon-layer-vertex-shader
in vec3 vertexPositions;
in vec3 vertexPositions64Low;
in float elevations;
${main}
void main(void) {
PolygonProps props;
props.positions = vertexPositions;
props.positions64Low = vertexPositions64Low;
props.elevations = elevations;
props.normal = vec3(0.0, 0.0, 1.0);
calculatePosition(props);
}
`;
const vsSide = `#version 300 es
#define SHADER_NAME solid-polygon-layer-vertex-shader-side
#define IS_SIDE_VERTEX
in vec2 positions;
in vec3 vertexPositions;
in vec3 nextVertexPositions;
in vec3 vertexPositions64Low;
in vec3 nextVertexPositions64Low;
in float elevations;
in float instanceVertexValid;
${main}
void main(void) {
if(instanceVertexValid < 0.5){
gl_Position = vec4(0.);
return;
}
PolygonProps props;
vec3 pos;
vec3 pos64Low;
vec3 nextPos;
vec3 nextPos64Low;
#if RING_WINDING_ORDER_CW == 1
pos = vertexPositions;
pos64Low = vertexPositions64Low;
nextPos = nextVertexPositions;
nextPos64Low = nextVertexPositions64Low;
#else
pos = nextVertexPositions;
pos64Low = nextVertexPositions64Low;
nextPos = vertexPositions;
nextPos64Low = vertexPositions64Low;
#endif
props.positions = mix(pos, nextPos, positions.x);
props.positions64Low = mix(pos64Low, nextPos64Low, positions.x);
props.normal = vec3(
pos.y - nextPos.y + (pos64Low.y - nextPos64Low.y),
nextPos.x - pos.x + (nextPos64Low.x - pos64Low.x),
0.0);
props.elevations = elevations * positions.y;
calculatePosition(props);
}
`;
const fs$8 = `#version 300 es
#define SHADER_NAME solid-polygon-layer-fragment-shader
precision highp float;
in vec4 vColor;
out vec4 fragColor;
void main(void) {
fragColor = vColor;
geometry.uv = vec2(0.);
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_COLOR$3 = [0, 0, 0, 255];
const defaultProps$i = {
  filled: true,
  extruded: false,
  wireframe: false,
  _normalize: true,
  _windingOrder: "CW",
  _full3d: false,
  elevationScale: { type: "number", min: 0, value: 1 },
  getPolygon: { type: "accessor", value: (f2) => f2.polygon },
  getElevation: { type: "accessor", value: 1e3 },
  getFillColor: { type: "accessor", value: DEFAULT_COLOR$3 },
  getLineColor: { type: "accessor", value: DEFAULT_COLOR$3 },
  material: true
};
const ATTRIBUTE_TRANSITION = {
  enter: (value, chunk) => {
    return chunk.length ? chunk.subarray(chunk.length - value.length) : value;
  }
};
const _SolidPolygonLayer = class extends Layer {
  getShaders(type) {
    return super.getShaders({
      vs: type === "top" ? vsTop : vsSide,
      fs: fs$8,
      defines: {
        RING_WINDING_ORDER_CW: !this.props._normalize && this.props._windingOrder === "CCW" ? 0 : 1
      },
      modules: [project32, gouraudLighting, picking]
    });
  }
  get wrapLongitude() {
    return false;
  }
  getBounds() {
    var _a3;
    return (_a3 = this.getAttributeManager()) == null ? void 0 : _a3.getBounds(["vertexPositions"]);
  }
  initializeState() {
    const { viewport } = this.context;
    let { coordinateSystem } = this.props;
    const { _full3d } = this.props;
    if (viewport.isGeospatial && coordinateSystem === COORDINATE_SYSTEM.DEFAULT) {
      coordinateSystem = COORDINATE_SYSTEM.LNGLAT;
    }
    let preproject;
    if (coordinateSystem === COORDINATE_SYSTEM.LNGLAT) {
      if (_full3d) {
        preproject = viewport.projectPosition.bind(viewport);
      } else {
        preproject = viewport.projectFlat.bind(viewport);
      }
    }
    this.setState({
      numInstances: 0,
      polygonTesselator: new PolygonTesselator({
        // Lnglat coordinates are usually projected non-linearly, which affects tesselation results
        // Provide a preproject function if the coordinates are in lnglat
        preproject,
        fp64: this.use64bitPositions(),
        IndexType: Uint32Array
      })
    });
    const attributeManager = this.getAttributeManager();
    const noAlloc = true;
    attributeManager.remove(["instancePickingColors"]);
    attributeManager.add({
      indices: {
        size: 1,
        isIndexed: true,
        // eslint-disable-next-line @typescript-eslint/unbound-method
        update: this.calculateIndices,
        noAlloc
      },
      vertexPositions: {
        size: 3,
        type: "float64",
        stepMode: "dynamic",
        fp64: this.use64bitPositions(),
        transition: ATTRIBUTE_TRANSITION,
        accessor: "getPolygon",
        // eslint-disable-next-line @typescript-eslint/unbound-method
        update: this.calculatePositions,
        noAlloc,
        shaderAttributes: {
          nextVertexPositions: {
            vertexOffset: 1
          }
        }
      },
      instanceVertexValid: {
        size: 1,
        type: "uint16",
        stepMode: "instance",
        // eslint-disable-next-line @typescript-eslint/unbound-method
        update: this.calculateVertexValid,
        noAlloc
      },
      elevations: {
        size: 1,
        stepMode: "dynamic",
        transition: ATTRIBUTE_TRANSITION,
        accessor: "getElevation"
      },
      fillColors: {
        size: this.props.colorFormat.length,
        type: "unorm8",
        stepMode: "dynamic",
        transition: ATTRIBUTE_TRANSITION,
        accessor: "getFillColor",
        defaultValue: DEFAULT_COLOR$3
      },
      lineColors: {
        size: this.props.colorFormat.length,
        type: "unorm8",
        stepMode: "dynamic",
        transition: ATTRIBUTE_TRANSITION,
        accessor: "getLineColor",
        defaultValue: DEFAULT_COLOR$3
      },
      pickingColors: {
        size: 4,
        type: "uint8",
        stepMode: "dynamic",
        accessor: (object2, { index: index2, target: value }) => this.encodePickingColor(object2 && object2.__source ? object2.__source.index : index2, value)
      }
    });
  }
  getPickingInfo(params2) {
    const info = super.getPickingInfo(params2);
    const { index: index2 } = info;
    const data2 = this.props.data;
    if (data2[0] && data2[0].__source) {
      info.object = data2.find((d2) => d2.__source.index === index2);
    }
    return info;
  }
  disablePickingIndex(objectIndex) {
    const data2 = this.props.data;
    if (data2[0] && data2[0].__source) {
      for (let i2 = 0; i2 < data2.length; i2++) {
        if (data2[i2].__source.index === objectIndex) {
          this._disablePickingIndex(i2);
        }
      }
    } else {
      super.disablePickingIndex(objectIndex);
    }
  }
  draw({ uniforms }) {
    const { extruded, filled, wireframe, elevationScale } = this.props;
    const { topModel, sideModel, wireframeModel, polygonTesselator } = this.state;
    const renderUniforms = {
      ...uniforms,
      extruded: Boolean(extruded),
      elevationScale
    };
    if (wireframeModel && wireframe) {
      wireframeModel.setInstanceCount(polygonTesselator.instanceCount - 1);
      wireframeModel.setUniforms(renderUniforms);
      wireframeModel.draw(this.context.renderPass);
    }
    if (sideModel && filled) {
      sideModel.setInstanceCount(polygonTesselator.instanceCount - 1);
      sideModel.setUniforms(renderUniforms);
      sideModel.draw(this.context.renderPass);
    }
    if (topModel && filled) {
      topModel.setVertexCount(polygonTesselator.vertexCount);
      topModel.setUniforms(renderUniforms);
      topModel.draw(this.context.renderPass);
    }
  }
  updateState(updateParams) {
    var _a3;
    super.updateState(updateParams);
    this.updateGeometry(updateParams);
    const { props, oldProps, changeFlags } = updateParams;
    const attributeManager = this.getAttributeManager();
    const regenerateModels = changeFlags.extensionsChanged || props.filled !== oldProps.filled || props.extruded !== oldProps.extruded;
    if (regenerateModels) {
      (_a3 = this.state.models) == null ? void 0 : _a3.forEach((model) => model.destroy());
      this.setState(this._getModels());
      attributeManager.invalidateAll();
    }
  }
  updateGeometry({ props, oldProps, changeFlags }) {
    const geometryConfigChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPolygon);
    if (geometryConfigChanged) {
      const { polygonTesselator } = this.state;
      const buffers = props.data.attributes || {};
      polygonTesselator.updateGeometry({
        data: props.data,
        normalize: props._normalize,
        geometryBuffer: buffers.getPolygon,
        buffers,
        getGeometry: props.getPolygon,
        positionFormat: props.positionFormat,
        wrapLongitude: props.wrapLongitude,
        // TODO - move the flag out of the viewport
        resolution: this.context.viewport.resolution,
        fp64: this.use64bitPositions(),
        dataChanged: changeFlags.dataChanged,
        full3d: props._full3d
      });
      this.setState({
        numInstances: polygonTesselator.instanceCount,
        startIndices: polygonTesselator.vertexStarts
      });
      if (!changeFlags.dataChanged) {
        this.getAttributeManager().invalidateAll();
      }
    }
  }
  _getModels() {
    const { id, filled, extruded } = this.props;
    let topModel;
    let sideModel;
    let wireframeModel;
    if (filled) {
      const shaders = this.getShaders("top");
      shaders.defines.NON_INSTANCED_MODEL = 1;
      const bufferLayout = this.getAttributeManager().getBufferLayouts({ isInstanced: false });
      topModel = new Model(this.context.device, {
        ...shaders,
        id: `${id}-top`,
        topology: "triangle-list",
        uniforms: {
          isWireframe: false
        },
        bufferLayout,
        isIndexed: true,
        userData: {
          excludeAttributes: { instanceVertexValid: true }
        }
      });
    }
    if (extruded) {
      const bufferLayout = this.getAttributeManager().getBufferLayouts({ isInstanced: true });
      sideModel = new Model(this.context.device, {
        ...this.getShaders("side"),
        id: `${id}-side`,
        bufferLayout,
        uniforms: {
          isWireframe: false
        },
        geometry: new Geometry({
          topology: "triangle-strip",
          attributes: {
            // top right - top left - bottom right - bottom left
            positions: {
              size: 2,
              value: new Float32Array([1, 0, 0, 0, 1, 1, 0, 1])
            }
          }
        }),
        isInstanced: true,
        userData: {
          excludeAttributes: { indices: true }
        }
      });
      wireframeModel = new Model(this.context.device, {
        ...this.getShaders("side"),
        id: `${id}-wireframe`,
        bufferLayout,
        uniforms: {
          isWireframe: true
        },
        geometry: new Geometry({
          topology: "line-strip",
          attributes: {
            // top right - top left - bottom left - bottom right
            positions: {
              size: 2,
              value: new Float32Array([1, 0, 0, 0, 0, 1, 1, 1])
            }
          }
        }),
        isInstanced: true,
        userData: {
          excludeAttributes: { indices: true }
        }
      });
    }
    return {
      models: [sideModel, wireframeModel, topModel].filter(Boolean),
      topModel,
      sideModel,
      wireframeModel
    };
  }
  calculateIndices(attribute) {
    const { polygonTesselator } = this.state;
    attribute.startIndices = polygonTesselator.indexStarts;
    attribute.value = polygonTesselator.get("indices");
  }
  calculatePositions(attribute) {
    const { polygonTesselator } = this.state;
    attribute.startIndices = polygonTesselator.vertexStarts;
    attribute.value = polygonTesselator.get("positions");
  }
  calculateVertexValid(attribute) {
    attribute.value = this.state.polygonTesselator.get("vertexValid");
  }
};
let SolidPolygonLayer = _SolidPolygonLayer;
(() => {
  _SolidPolygonLayer.defaultProps = defaultProps$i;
})();
(() => {
  _SolidPolygonLayer.layerName = "SolidPolygonLayer";
})();
function replaceInRange({ data: data2, getIndex, dataRange, replace: replace2 }) {
  const { startRow = 0, endRow = Infinity } = dataRange;
  const count3 = data2.length;
  let replaceStart = count3;
  let replaceEnd = count3;
  for (let i2 = 0; i2 < count3; i2++) {
    const row = getIndex(data2[i2]);
    if (replaceStart > i2 && row >= startRow) {
      replaceStart = i2;
    }
    if (row >= endRow) {
      replaceEnd = i2;
      break;
    }
  }
  let index2 = replaceStart;
  const dataLengthChanged = replaceEnd - replaceStart !== replace2.length;
  const endChunk = dataLengthChanged ? data2.slice(replaceEnd) : void 0;
  for (let i2 = 0; i2 < replace2.length; i2++) {
    data2[index2++] = replace2[i2];
  }
  if (endChunk) {
    for (let i2 = 0; i2 < endChunk.length; i2++) {
      data2[index2++] = endChunk[i2];
    }
    data2.length = index2;
  }
  return {
    startRow: replaceStart,
    endRow: replaceStart + replace2.length
  };
}
const defaultLineColor = [0, 0, 0, 255];
const defaultFillColor = [0, 0, 0, 255];
const defaultProps$h = {
  stroked: true,
  filled: true,
  extruded: false,
  elevationScale: 1,
  wireframe: false,
  _normalize: true,
  _windingOrder: "CW",
  lineWidthUnits: "meters",
  lineWidthScale: 1,
  lineWidthMinPixels: 0,
  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
  lineJointRounded: false,
  lineMiterLimit: 4,
  getPolygon: { type: "accessor", value: (f2) => f2.polygon },
  // Polygon fill color
  getFillColor: { type: "accessor", value: defaultFillColor },
  // Point, line and polygon outline color
  getLineColor: { type: "accessor", value: defaultLineColor },
  // Line and polygon outline accessors
  getLineWidth: { type: "accessor", value: 1 },
  // Polygon extrusion accessor
  getElevation: { type: "accessor", value: 1e3 },
  // Optional material for 'lighting' shader module
  material: true
};
const _PolygonLayer = class extends CompositeLayer {
  initializeState() {
    this.state = {
      paths: [],
      pathsDiff: null
    };
    if (this.props.getLineDashArray) {
      log$1.removed("getLineDashArray", "PathStyleExtension")();
    }
  }
  updateState({ changeFlags }) {
    const geometryChanged2 = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPolygon);
    if (geometryChanged2 && Array.isArray(changeFlags.dataChanged)) {
      const paths = this.state.paths.slice();
      const pathsDiff = changeFlags.dataChanged.map((dataRange) => replaceInRange({
        data: paths,
        getIndex: (p2) => p2.__source.index,
        dataRange,
        replace: this._getPaths(dataRange)
      }));
      this.setState({ paths, pathsDiff });
    } else if (geometryChanged2) {
      this.setState({
        paths: this._getPaths(),
        pathsDiff: null
      });
    }
  }
  _getPaths(dataRange = {}) {
    const { data: data2, getPolygon, positionFormat, _normalize } = this.props;
    const paths = [];
    const positionSize = positionFormat === "XY" ? 2 : 3;
    const { startRow, endRow } = dataRange;
    const { iterable, objectInfo } = createIterable(data2, startRow, endRow);
    for (const object2 of iterable) {
      objectInfo.index++;
      let polygon4 = getPolygon(object2, objectInfo);
      if (_normalize) {
        polygon4 = normalize$2(polygon4, positionSize);
      }
      const { holeIndices } = polygon4;
      const positions = polygon4.positions || polygon4;
      if (holeIndices) {
        for (let i2 = 0; i2 <= holeIndices.length; i2++) {
          const path2 = positions.slice(holeIndices[i2 - 1] || 0, holeIndices[i2] || positions.length);
          paths.push(this.getSubLayerRow({ path: path2 }, object2, objectInfo.index));
        }
      } else {
        paths.push(this.getSubLayerRow({ path: positions }, object2, objectInfo.index));
      }
    }
    return paths;
  }
  /* eslint-disable complexity */
  renderLayers() {
    const { data: data2, _dataDiff, stroked, filled, extruded, wireframe, _normalize, _windingOrder, elevationScale, transitions, positionFormat } = this.props;
    const { lineWidthUnits, lineWidthScale, lineWidthMinPixels, lineWidthMaxPixels, lineJointRounded, lineMiterLimit, lineDashJustified } = this.props;
    const { getFillColor, getLineColor, getLineWidth, getLineDashArray, getElevation, getPolygon, updateTriggers, material } = this.props;
    const { paths, pathsDiff } = this.state;
    const FillLayer3 = this.getSubLayerClass("fill", SolidPolygonLayer);
    const StrokeLayer = this.getSubLayerClass("stroke", PathLayer);
    const polygonLayer = this.shouldRenderSubLayer("fill", paths) && new FillLayer3({
      _dataDiff,
      extruded,
      elevationScale,
      filled,
      wireframe,
      _normalize,
      _windingOrder,
      getElevation,
      getFillColor,
      getLineColor: extruded && wireframe ? getLineColor : defaultLineColor,
      material,
      transitions
    }, this.getSubLayerProps({
      id: "fill",
      updateTriggers: updateTriggers && {
        getPolygon: updateTriggers.getPolygon,
        getElevation: updateTriggers.getElevation,
        getFillColor: updateTriggers.getFillColor,
        // using a legacy API to invalid lineColor attributes
        // if (extruded && wireframe) has changed
        lineColors: extruded && wireframe,
        getLineColor: updateTriggers.getLineColor
      }
    }), {
      data: data2,
      positionFormat,
      getPolygon
    });
    const polygonLineLayer = !extruded && stroked && this.shouldRenderSubLayer("stroke", paths) && new StrokeLayer({
      _dataDiff: pathsDiff && (() => pathsDiff),
      widthUnits: lineWidthUnits,
      widthScale: lineWidthScale,
      widthMinPixels: lineWidthMinPixels,
      widthMaxPixels: lineWidthMaxPixels,
      jointRounded: lineJointRounded,
      miterLimit: lineMiterLimit,
      dashJustified: lineDashJustified,
      // Already normalized
      _pathType: "loop",
      transitions: transitions && {
        getWidth: transitions.getLineWidth,
        getColor: transitions.getLineColor,
        getPath: transitions.getPolygon
      },
      getColor: this.getSubLayerAccessor(getLineColor),
      getWidth: this.getSubLayerAccessor(getLineWidth),
      getDashArray: this.getSubLayerAccessor(getLineDashArray)
    }, this.getSubLayerProps({
      id: "stroke",
      updateTriggers: updateTriggers && {
        getWidth: updateTriggers.getLineWidth,
        getColor: updateTriggers.getLineColor,
        getDashArray: updateTriggers.getLineDashArray
      }
    }), {
      data: paths,
      positionFormat,
      getPath: (x2) => x2.path
    });
    return [
      // If not extruded: flat fill layer is drawn below outlines
      !extruded && polygonLayer,
      polygonLineLayer,
      // If extruded: draw fill layer last for correct blending behavior
      extruded && polygonLayer
    ];
  }
};
let PolygonLayer = _PolygonLayer;
(() => {
  _PolygonLayer.layerName = "PolygonLayer";
})();
(() => {
  _PolygonLayer.defaultProps = defaultProps$h;
})();
function binaryToFeatureForAccesor(data2, index2) {
  if (!data2) {
    return null;
  }
  const featureIndex = "startIndices" in data2 ? data2.startIndices[index2] : index2;
  const geometryIndex = data2.featureIds.value[featureIndex];
  if (featureIndex !== -1) {
    return getPropertiesForIndex(data2, geometryIndex, featureIndex);
  }
  return null;
}
function getPropertiesForIndex(data2, propertiesIndex, numericPropsIndex) {
  const feature2 = {
    properties: { ...data2.properties[propertiesIndex] }
  };
  for (const prop in data2.numericProps) {
    feature2.properties[prop] = data2.numericProps[prop].value[numericPropsIndex];
  }
  return feature2;
}
function calculatePickingColors(geojsonBinary, encodePickingColor) {
  const pickingColors = {
    points: null,
    lines: null,
    polygons: null
  };
  for (const key in pickingColors) {
    const featureIds = geojsonBinary[key].globalFeatureIds.value;
    pickingColors[key] = new Uint8ClampedArray(featureIds.length * 3);
    const pickingColor = [];
    for (let i2 = 0; i2 < featureIds.length; i2++) {
      encodePickingColor(featureIds[i2], pickingColor);
      pickingColors[key][i2 * 3 + 0] = pickingColor[0];
      pickingColors[key][i2 * 3 + 1] = pickingColor[1];
      pickingColors[key][i2 * 3 + 2] = pickingColor[2];
    }
  }
  return pickingColors;
}
const fs$7 = `#version 300 es
#define SHADER_NAME multi-icon-layer-fragment-shader
precision highp float;
uniform float opacity;
uniform sampler2D iconsTexture;
uniform float gamma;
uniform bool sdf;
uniform float alphaCutoff;
uniform float sdfBuffer;
uniform float outlineBuffer;
uniform vec4 outlineColor;
in vec4 vColor;
in vec2 vTextureCoords;
in vec2 uv;
out vec4 fragColor;
void main(void) {
geometry.uv = uv;
if (!bool(picking.isActive)) {
float alpha = texture(iconsTexture, vTextureCoords).a;
vec4 color = vColor;
if (sdf) {
float distance = alpha;
alpha = smoothstep(sdfBuffer - gamma, sdfBuffer + gamma, distance);
if (outlineBuffer > 0.0) {
float inFill = alpha;
float inBorder = smoothstep(outlineBuffer - gamma, outlineBuffer + gamma, distance);
color = mix(outlineColor, vColor, inFill);
alpha = inBorder;
}
}
float a = alpha * color.a;
if (a < alphaCutoff) {
discard;
}
fragColor = vec4(color.rgb, a * opacity);
}
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_BUFFER = 192 / 256;
const EMPTY_ARRAY = [];
const defaultProps$g = {
  getIconOffsets: { type: "accessor", value: (x2) => x2.offsets },
  alphaCutoff: 1e-3,
  smoothing: 0.1,
  outlineWidth: 0,
  outlineColor: { type: "color", value: [0, 0, 0, 255] }
};
const _MultiIconLayer = class extends IconLayer {
  getShaders() {
    return { ...super.getShaders(), fs: fs$7 };
  }
  initializeState() {
    super.initializeState();
    const attributeManager = this.getAttributeManager();
    attributeManager.addInstanced({
      instanceOffsets: {
        size: 2,
        accessor: "getIconOffsets"
      },
      instancePickingColors: {
        type: "uint8",
        size: 3,
        accessor: (object2, { index: index2, target: value }) => this.encodePickingColor(index2, value)
      }
    });
  }
  updateState(params2) {
    super.updateState(params2);
    const { props, oldProps } = params2;
    let { outlineColor } = props;
    if (outlineColor !== oldProps.outlineColor) {
      outlineColor = outlineColor.map((x2) => x2 / 255);
      outlineColor[3] = Number.isFinite(outlineColor[3]) ? outlineColor[3] : 1;
      this.setState({
        outlineColor
      });
    }
    if (!props.sdf && props.outlineWidth) {
      log$1.warn(`${this.id}: fontSettings.sdf is required to render outline`)();
    }
  }
  draw(params2) {
    const { sdf, smoothing, outlineWidth } = this.props;
    const { outlineColor } = this.state;
    const outlineBuffer = outlineWidth ? Math.max(smoothing, DEFAULT_BUFFER * (1 - outlineWidth)) : -1;
    params2.uniforms = {
      ...params2.uniforms,
      // Refer the following doc about gamma and buffer
      // https://blog.mapbox.com/drawing-text-with-signed-distance-fields-in-mapbox-gl-b0933af6f817
      sdfBuffer: DEFAULT_BUFFER,
      outlineBuffer,
      gamma: smoothing,
      sdf: Boolean(sdf),
      outlineColor
    };
    super.draw(params2);
    if (sdf && outlineWidth) {
      const { iconManager } = this.state;
      const iconsTexture = iconManager.getTexture();
      const model = this.state.model;
      if (iconsTexture) {
        model.setUniforms({ outlineBuffer: DEFAULT_BUFFER });
        model.draw(this.context.renderPass);
      }
    }
  }
  getInstanceOffset(icons) {
    return icons ? Array.from(icons).flatMap((icon) => super.getInstanceOffset(icon)) : EMPTY_ARRAY;
  }
  getInstanceColorMode(icons) {
    return 1;
  }
  getInstanceIconFrame(icons) {
    return icons ? Array.from(icons).flatMap((icon) => super.getInstanceIconFrame(icon)) : EMPTY_ARRAY;
  }
};
let MultiIconLayer = _MultiIconLayer;
(() => {
  _MultiIconLayer.defaultProps = defaultProps$g;
})();
(() => {
  _MultiIconLayer.layerName = "MultiIconLayer";
})();
const INF = 1e20;
class TinySDF {
  constructor({
    fontSize = 24,
    buffer: buffer3 = 3,
    radius = 8,
    cutoff = 0.25,
    fontFamily = "sans-serif",
    fontWeight = "normal",
    fontStyle = "normal"
  } = {}) {
    this.buffer = buffer3;
    this.cutoff = cutoff;
    this.radius = radius;
    const size12 = this.size = fontSize + buffer3 * 4;
    const canvas2 = this._createCanvas(size12);
    const ctx2 = this.ctx = canvas2.getContext("2d", { willReadFrequently: true });
    ctx2.font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
    ctx2.textBaseline = "alphabetic";
    ctx2.textAlign = "left";
    ctx2.fillStyle = "black";
    this.gridOuter = new Float64Array(size12 * size12);
    this.gridInner = new Float64Array(size12 * size12);
    this.f = new Float64Array(size12);
    this.z = new Float64Array(size12 + 1);
    this.v = new Uint16Array(size12);
  }
  _createCanvas(size12) {
    const canvas2 = document.createElement("canvas");
    canvas2.width = canvas2.height = size12;
    return canvas2;
  }
  draw(char) {
    const {
      width: glyphAdvance,
      actualBoundingBoxAscent,
      actualBoundingBoxDescent,
      actualBoundingBoxLeft,
      actualBoundingBoxRight
    } = this.ctx.measureText(char);
    const glyphTop = Math.ceil(actualBoundingBoxAscent);
    const glyphLeft = 0;
    const glyphWidth = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(actualBoundingBoxRight - actualBoundingBoxLeft)));
    const glyphHeight = Math.min(this.size - this.buffer, glyphTop + Math.ceil(actualBoundingBoxDescent));
    const width = glyphWidth + 2 * this.buffer;
    const height = glyphHeight + 2 * this.buffer;
    const len2 = Math.max(width * height, 0);
    const data2 = new Uint8ClampedArray(len2);
    const glyph = { data: data2, width, height, glyphWidth, glyphHeight, glyphTop, glyphLeft, glyphAdvance };
    if (glyphWidth === 0 || glyphHeight === 0)
      return glyph;
    const { ctx: ctx2, buffer: buffer3, gridInner, gridOuter } = this;
    ctx2.clearRect(buffer3, buffer3, glyphWidth, glyphHeight);
    ctx2.fillText(char, buffer3, buffer3 + glyphTop);
    const imgData = ctx2.getImageData(buffer3, buffer3, glyphWidth, glyphHeight);
    gridOuter.fill(INF, 0, len2);
    gridInner.fill(0, 0, len2);
    for (let y2 = 0; y2 < glyphHeight; y2++) {
      for (let x2 = 0; x2 < glyphWidth; x2++) {
        const a2 = imgData.data[4 * (y2 * glyphWidth + x2) + 3] / 255;
        if (a2 === 0)
          continue;
        const j2 = (y2 + buffer3) * width + x2 + buffer3;
        if (a2 === 1) {
          gridOuter[j2] = 0;
          gridInner[j2] = INF;
        } else {
          const d2 = 0.5 - a2;
          gridOuter[j2] = d2 > 0 ? d2 * d2 : 0;
          gridInner[j2] = d2 < 0 ? d2 * d2 : 0;
        }
      }
    }
    edt(gridOuter, 0, 0, width, height, width, this.f, this.v, this.z);
    edt(gridInner, buffer3, buffer3, glyphWidth, glyphHeight, width, this.f, this.v, this.z);
    for (let i2 = 0; i2 < len2; i2++) {
      const d2 = Math.sqrt(gridOuter[i2]) - Math.sqrt(gridInner[i2]);
      data2[i2] = Math.round(255 - 255 * (d2 / this.radius + this.cutoff));
    }
    return glyph;
  }
}
function edt(data2, x02, y02, width, height, gridSize, f2, v5, z2) {
  for (let x2 = x02; x2 < x02 + width; x2++)
    edt1d(data2, y02 * gridSize + x2, gridSize, height, f2, v5, z2);
  for (let y2 = y02; y2 < y02 + height; y2++)
    edt1d(data2, y2 * gridSize + x02, 1, width, f2, v5, z2);
}
function edt1d(grid, offset, stride, length2, f2, v5, z2) {
  v5[0] = 0;
  z2[0] = -INF;
  z2[1] = INF;
  f2[0] = grid[offset];
  for (let q2 = 1, k2 = 0, s2 = 0; q2 < length2; q2++) {
    f2[q2] = grid[offset + q2 * stride];
    const q22 = q2 * q2;
    do {
      const r2 = v5[k2];
      s2 = (f2[q2] - f2[r2] + q22 - r2 * r2) / (q2 - r2) / 2;
    } while (s2 <= z2[k2] && --k2 > -1);
    k2++;
    v5[k2] = q2;
    z2[k2] = s2;
    z2[k2 + 1] = INF;
  }
  for (let q2 = 0, k2 = 0; q2 < length2; q2++) {
    while (z2[k2 + 1] < q2)
      k2++;
    const r2 = v5[k2];
    const qr = q2 - r2;
    grid[offset + q2 * stride] = f2[r2] + qr * qr;
  }
}
const MISSING_CHAR_WIDTH = 32;
const SINGLE_LINE = [];
function nextPowOfTwo(number2) {
  return Math.pow(2, Math.ceil(Math.log2(number2)));
}
function buildMapping({ characterSet, getFontWidth, fontHeight, buffer: buffer3, maxCanvasWidth, mapping = {}, xOffset = 0, yOffset = 0 }) {
  let row = 0;
  let x2 = xOffset;
  const rowHeight = fontHeight + buffer3 * 2;
  for (const char of characterSet) {
    if (!mapping[char]) {
      const width = getFontWidth(char);
      if (x2 + width + buffer3 * 2 > maxCanvasWidth) {
        x2 = 0;
        row++;
      }
      mapping[char] = {
        x: x2 + buffer3,
        y: yOffset + row * rowHeight + buffer3,
        width,
        height: rowHeight,
        layoutWidth: width,
        layoutHeight: fontHeight
      };
      x2 += width + buffer3 * 2;
    }
  }
  return {
    mapping,
    xOffset: x2,
    yOffset: yOffset + row * rowHeight,
    canvasHeight: nextPowOfTwo(yOffset + (row + 1) * rowHeight)
  };
}
function getTextWidth(text, startIndex, endIndex, mapping) {
  var _a3;
  let width = 0;
  for (let i2 = startIndex; i2 < endIndex; i2++) {
    const character = text[i2];
    width += ((_a3 = mapping[character]) == null ? void 0 : _a3.layoutWidth) || 0;
  }
  return width;
}
function breakAll(text, startIndex, endIndex, maxWidth, iconMapping, target) {
  let rowStartCharIndex = startIndex;
  let rowOffsetLeft = 0;
  for (let i2 = startIndex; i2 < endIndex; i2++) {
    const textWidth = getTextWidth(text, i2, i2 + 1, iconMapping);
    if (rowOffsetLeft + textWidth > maxWidth) {
      if (rowStartCharIndex < i2) {
        target.push(i2);
      }
      rowStartCharIndex = i2;
      rowOffsetLeft = 0;
    }
    rowOffsetLeft += textWidth;
  }
  return rowOffsetLeft;
}
function breakWord(text, startIndex, endIndex, maxWidth, iconMapping, target) {
  let rowStartCharIndex = startIndex;
  let groupStartCharIndex = startIndex;
  let groupEndCharIndex = startIndex;
  let rowOffsetLeft = 0;
  for (let i2 = startIndex; i2 < endIndex; i2++) {
    if (text[i2] === " ") {
      groupEndCharIndex = i2 + 1;
    } else if (text[i2 + 1] === " " || i2 + 1 === endIndex) {
      groupEndCharIndex = i2 + 1;
    }
    if (groupEndCharIndex > groupStartCharIndex) {
      let groupWidth = getTextWidth(text, groupStartCharIndex, groupEndCharIndex, iconMapping);
      if (rowOffsetLeft + groupWidth > maxWidth) {
        if (rowStartCharIndex < groupStartCharIndex) {
          target.push(groupStartCharIndex);
          rowStartCharIndex = groupStartCharIndex;
          rowOffsetLeft = 0;
        }
        if (groupWidth > maxWidth) {
          groupWidth = breakAll(text, groupStartCharIndex, groupEndCharIndex, maxWidth, iconMapping, target);
          rowStartCharIndex = target[target.length - 1];
        }
      }
      groupStartCharIndex = groupEndCharIndex;
      rowOffsetLeft += groupWidth;
    }
  }
  return rowOffsetLeft;
}
function autoWrapping(text, wordBreak, maxWidth, iconMapping, startIndex = 0, endIndex) {
  if (endIndex === void 0) {
    endIndex = text.length;
  }
  const result = [];
  if (wordBreak === "break-all") {
    breakAll(text, startIndex, endIndex, maxWidth, iconMapping, result);
  } else {
    breakWord(text, startIndex, endIndex, maxWidth, iconMapping, result);
  }
  return result;
}
function transformRow(line, startIndex, endIndex, iconMapping, leftOffsets, rowSize) {
  let x2 = 0;
  let rowHeight = 0;
  for (let i2 = startIndex; i2 < endIndex; i2++) {
    const character = line[i2];
    const frame = iconMapping[character];
    if (frame) {
      if (!rowHeight) {
        rowHeight = frame.layoutHeight;
      }
      leftOffsets[i2] = x2 + frame.layoutWidth / 2;
      x2 += frame.layoutWidth;
    } else {
      log$1.warn(`Missing character: ${character} (${character.codePointAt(0)})`)();
      leftOffsets[i2] = x2;
      x2 += MISSING_CHAR_WIDTH;
    }
  }
  rowSize[0] = x2;
  rowSize[1] = rowHeight;
}
function transformParagraph(paragraph, lineHeight, wordBreak, maxWidth, iconMapping) {
  var _a3;
  const characters = Array.from(paragraph);
  const numCharacters = characters.length;
  const x2 = new Array(numCharacters);
  const y2 = new Array(numCharacters);
  const rowWidth = new Array(numCharacters);
  const autoWrappingEnabled = (wordBreak === "break-word" || wordBreak === "break-all") && isFinite(maxWidth) && maxWidth > 0;
  const size12 = [0, 0];
  const rowSize = [0, 0];
  let rowOffsetTop = 0;
  let lineStartIndex = 0;
  let lineEndIndex = 0;
  for (let i2 = 0; i2 <= numCharacters; i2++) {
    const char = characters[i2];
    if (char === "\n" || i2 === numCharacters) {
      lineEndIndex = i2;
    }
    if (lineEndIndex > lineStartIndex) {
      const rows = autoWrappingEnabled ? autoWrapping(characters, wordBreak, maxWidth, iconMapping, lineStartIndex, lineEndIndex) : SINGLE_LINE;
      for (let rowIndex = 0; rowIndex <= rows.length; rowIndex++) {
        const rowStart = rowIndex === 0 ? lineStartIndex : rows[rowIndex - 1];
        const rowEnd = rowIndex < rows.length ? rows[rowIndex] : lineEndIndex;
        transformRow(characters, rowStart, rowEnd, iconMapping, x2, rowSize);
        for (let j2 = rowStart; j2 < rowEnd; j2++) {
          const char2 = characters[j2];
          const layoutOffsetY = ((_a3 = iconMapping[char2]) == null ? void 0 : _a3.layoutOffsetY) || 0;
          y2[j2] = rowOffsetTop + rowSize[1] / 2 + layoutOffsetY;
          rowWidth[j2] = rowSize[0];
        }
        rowOffsetTop = rowOffsetTop + rowSize[1] * lineHeight;
        size12[0] = Math.max(size12[0], rowSize[0]);
      }
      lineStartIndex = lineEndIndex;
    }
    if (char === "\n") {
      x2[lineStartIndex] = 0;
      y2[lineStartIndex] = 0;
      rowWidth[lineStartIndex] = 0;
      lineStartIndex++;
    }
  }
  size12[1] = rowOffsetTop;
  return { x: x2, y: y2, rowWidth, size: size12 };
}
function getTextFromBuffer({ value, length: length2, stride, offset, startIndices, characterSet }) {
  const bytesPerElement = value.BYTES_PER_ELEMENT;
  const elementStride = stride ? stride / bytesPerElement : 1;
  const elementOffset = offset ? offset / bytesPerElement : 0;
  const characterCount = startIndices[length2] || Math.ceil((value.length - elementOffset) / elementStride);
  const autoCharacterSet = characterSet && /* @__PURE__ */ new Set();
  const texts = new Array(length2);
  let codes2 = value;
  if (elementStride > 1 || elementOffset > 0) {
    const ArrayType2 = value.constructor;
    codes2 = new ArrayType2(characterCount);
    for (let i2 = 0; i2 < characterCount; i2++) {
      codes2[i2] = value[i2 * elementStride + elementOffset];
    }
  }
  for (let index2 = 0; index2 < length2; index2++) {
    const startIndex = startIndices[index2];
    const endIndex = startIndices[index2 + 1] || characterCount;
    const codesAtIndex = codes2.subarray(startIndex, endIndex);
    texts[index2] = String.fromCodePoint.apply(null, codesAtIndex);
    if (autoCharacterSet) {
      codesAtIndex.forEach(autoCharacterSet.add, autoCharacterSet);
    }
  }
  if (autoCharacterSet) {
    for (const charCode of autoCharacterSet) {
      characterSet.add(String.fromCodePoint(charCode));
    }
  }
  return { texts, characterCount };
}
class LRUCache {
  constructor(limit = 5) {
    this._cache = {};
    this._order = [];
    this.limit = limit;
  }
  get(key) {
    const value = this._cache[key];
    if (value) {
      this._deleteOrder(key);
      this._appendOrder(key);
    }
    return value;
  }
  set(key, value) {
    if (!this._cache[key]) {
      if (Object.keys(this._cache).length === this.limit) {
        this.delete(this._order[0]);
      }
      this._cache[key] = value;
      this._appendOrder(key);
    } else {
      this.delete(key);
      this._cache[key] = value;
      this._appendOrder(key);
    }
  }
  delete(key) {
    const value = this._cache[key];
    if (value) {
      delete this._cache[key];
      this._deleteOrder(key);
    }
  }
  _deleteOrder(key) {
    const index2 = this._order.indexOf(key);
    if (index2 >= 0) {
      this._order.splice(index2, 1);
    }
  }
  _appendOrder(key) {
    this._order.push(key);
  }
}
function getDefaultCharacterSet() {
  const charSet = [];
  for (let i2 = 32; i2 < 128; i2++) {
    charSet.push(String.fromCharCode(i2));
  }
  return charSet;
}
const DEFAULT_FONT_SETTINGS = {
  fontFamily: "Monaco, monospace",
  fontWeight: "normal",
  characterSet: getDefaultCharacterSet(),
  fontSize: 64,
  buffer: 4,
  sdf: false,
  cutoff: 0.25,
  radius: 12,
  smoothing: 0.1
};
const MAX_CANVAS_WIDTH = 1024;
const BASELINE_SCALE = 0.9;
const HEIGHT_SCALE = 1.2;
const CACHE_LIMIT = 3;
let cache = new LRUCache(CACHE_LIMIT);
function getNewChars(cacheKey, characterSet) {
  let newCharSet;
  if (typeof characterSet === "string") {
    newCharSet = new Set(Array.from(characterSet));
  } else {
    newCharSet = new Set(characterSet);
  }
  const cachedFontAtlas = cache.get(cacheKey);
  if (!cachedFontAtlas) {
    return newCharSet;
  }
  for (const char in cachedFontAtlas.mapping) {
    if (newCharSet.has(char)) {
      newCharSet.delete(char);
    }
  }
  return newCharSet;
}
function populateAlphaChannel(alphaChannel, imageData) {
  for (let i2 = 0; i2 < alphaChannel.length; i2++) {
    imageData.data[4 * i2 + 3] = alphaChannel[i2];
  }
}
function setTextStyle(ctx2, fontFamily, fontSize, fontWeight) {
  ctx2.font = `${fontWeight} ${fontSize}px ${fontFamily}`;
  ctx2.fillStyle = "#000";
  ctx2.textBaseline = "alphabetic";
  ctx2.textAlign = "left";
}
function setFontAtlasCacheLimit(limit) {
  log$1.assert(Number.isFinite(limit) && limit >= CACHE_LIMIT, "Invalid cache limit");
  cache = new LRUCache(limit);
}
class FontAtlasManager {
  constructor() {
    this.props = { ...DEFAULT_FONT_SETTINGS };
  }
  get atlas() {
    return this._atlas;
  }
  // TODO - cut during v9 porting as types reveal this is not correct
  // get texture(): Texture | undefined {
  //   return this._atlas;
  // }
  get mapping() {
    return this._atlas && this._atlas.mapping;
  }
  get scale() {
    const { fontSize, buffer: buffer3 } = this.props;
    return (fontSize * HEIGHT_SCALE + buffer3 * 2) / fontSize;
  }
  setProps(props = {}) {
    Object.assign(this.props, props);
    this._key = this._getKey();
    const charSet = getNewChars(this._key, this.props.characterSet);
    const cachedFontAtlas = cache.get(this._key);
    if (cachedFontAtlas && charSet.size === 0) {
      if (this._atlas !== cachedFontAtlas) {
        this._atlas = cachedFontAtlas;
      }
      return;
    }
    const fontAtlas = this._generateFontAtlas(charSet, cachedFontAtlas);
    this._atlas = fontAtlas;
    cache.set(this._key, fontAtlas);
  }
  // eslint-disable-next-line max-statements
  _generateFontAtlas(characterSet, cachedFontAtlas) {
    const { fontFamily, fontWeight, fontSize, buffer: buffer3, sdf, radius, cutoff } = this.props;
    let canvas2 = cachedFontAtlas && cachedFontAtlas.data;
    if (!canvas2) {
      canvas2 = document.createElement("canvas");
      canvas2.width = MAX_CANVAS_WIDTH;
    }
    const ctx2 = canvas2.getContext("2d", { willReadFrequently: true });
    setTextStyle(ctx2, fontFamily, fontSize, fontWeight);
    const { mapping, canvasHeight, xOffset, yOffset } = buildMapping({
      getFontWidth: (char) => ctx2.measureText(char).width,
      fontHeight: fontSize * HEIGHT_SCALE,
      buffer: buffer3,
      characterSet,
      maxCanvasWidth: MAX_CANVAS_WIDTH,
      ...cachedFontAtlas && {
        mapping: cachedFontAtlas.mapping,
        xOffset: cachedFontAtlas.xOffset,
        yOffset: cachedFontAtlas.yOffset
      }
    });
    if (canvas2.height !== canvasHeight) {
      const imageData = ctx2.getImageData(0, 0, canvas2.width, canvas2.height);
      canvas2.height = canvasHeight;
      ctx2.putImageData(imageData, 0, 0);
    }
    setTextStyle(ctx2, fontFamily, fontSize, fontWeight);
    if (sdf) {
      const tinySDF = new TinySDF({
        fontSize,
        buffer: buffer3,
        radius,
        cutoff,
        fontFamily,
        fontWeight: `${fontWeight}`
      });
      for (const char of characterSet) {
        const { data: data2, width, height, glyphTop } = tinySDF.draw(char);
        mapping[char].width = width;
        mapping[char].layoutOffsetY = fontSize * BASELINE_SCALE - glyphTop;
        const imageData = ctx2.createImageData(width, height);
        populateAlphaChannel(data2, imageData);
        ctx2.putImageData(imageData, mapping[char].x, mapping[char].y);
      }
    } else {
      for (const char of characterSet) {
        ctx2.fillText(char, mapping[char].x, mapping[char].y + buffer3 + fontSize * BASELINE_SCALE);
      }
    }
    return {
      xOffset,
      yOffset,
      mapping,
      data: canvas2,
      width: canvas2.width,
      height: canvas2.height
    };
  }
  _getKey() {
    const { fontFamily, fontWeight, fontSize, buffer: buffer3, sdf, radius, cutoff } = this.props;
    if (sdf) {
      return `${fontFamily} ${fontWeight} ${fontSize} ${buffer3} ${radius} ${cutoff}`;
    }
    return `${fontFamily} ${fontWeight} ${fontSize} ${buffer3}`;
  }
}
const vs$6 = `#version 300 es
#define SHADER_NAME text-background-layer-vertex-shader
in vec2 positions;
in vec3 instancePositions;
in vec3 instancePositions64Low;
in vec4 instanceRects;
in float instanceSizes;
in float instanceAngles;
in vec2 instancePixelOffsets;
in float instanceLineWidths;
in vec4 instanceFillColors;
in vec4 instanceLineColors;
in vec3 instancePickingColors;
uniform bool billboard;
uniform float opacity;
uniform float sizeScale;
uniform float sizeMinPixels;
uniform float sizeMaxPixels;
uniform vec4 padding;
uniform int sizeUnits;
out vec4 vFillColor;
out vec4 vLineColor;
out float vLineWidth;
out vec2 uv;
out vec2 dimensions;
vec2 rotate_by_angle(vec2 vertex, float angle) {
float angle_radian = radians(angle);
float cos_angle = cos(angle_radian);
float sin_angle = sin(angle_radian);
mat2 rotationMatrix = mat2(cos_angle, -sin_angle, sin_angle, cos_angle);
return rotationMatrix * vertex;
}
void main(void) {
geometry.worldPosition = instancePositions;
geometry.uv = positions;
geometry.pickingColor = instancePickingColors;
uv = positions;
vLineWidth = instanceLineWidths;
float sizePixels = clamp(
project_size_to_pixel(instanceSizes * sizeScale, sizeUnits),
sizeMinPixels, sizeMaxPixels
);
dimensions = instanceRects.zw * sizePixels + padding.xy + padding.zw;
vec2 pixelOffset = (positions * instanceRects.zw + instanceRects.xy) * sizePixels + mix(-padding.xy, padding.zw, positions);
pixelOffset = rotate_by_angle(pixelOffset, instanceAngles);
pixelOffset += instancePixelOffsets;
pixelOffset.y *= -1.0;
if (billboard)  {
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
vec3 offset = vec3(pixelOffset, 0.0);
DECKGL_FILTER_SIZE(offset, geometry);
gl_Position.xy += project_pixel_size_to_clipspace(offset.xy);
} else {
vec3 offset_common = vec3(project_pixel_size(pixelOffset), 0.0);
DECKGL_FILTER_SIZE(offset_common, geometry);
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, offset_common, geometry.position);
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
}
vFillColor = vec4(instanceFillColors.rgb, instanceFillColors.a * opacity);
DECKGL_FILTER_COLOR(vFillColor, geometry);
vLineColor = vec4(instanceLineColors.rgb, instanceLineColors.a * opacity);
DECKGL_FILTER_COLOR(vLineColor, geometry);
}
`;
const fs$6 = `#version 300 es
#define SHADER_NAME text-background-layer-fragment-shader
precision highp float;
uniform bool stroked;
in vec4 vFillColor;
in vec4 vLineColor;
in float vLineWidth;
in vec2 uv;
in vec2 dimensions;
out vec4 fragColor;
void main(void) {
geometry.uv = uv;
vec2 pixelPosition = uv * dimensions;
if (stroked) {
float distToEdge = min(
min(pixelPosition.x, dimensions.x - pixelPosition.x),
min(pixelPosition.y, dimensions.y - pixelPosition.y)
);
float isBorder = smoothedge(distToEdge, vLineWidth);
fragColor = mix(vFillColor, vLineColor, isBorder);
} else {
fragColor = vFillColor;
}
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const defaultProps$f = {
  billboard: true,
  sizeScale: 1,
  sizeUnits: "pixels",
  sizeMinPixels: 0,
  sizeMaxPixels: Number.MAX_SAFE_INTEGER,
  padding: { type: "array", value: [0, 0, 0, 0] },
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getSize: { type: "accessor", value: 1 },
  getAngle: { type: "accessor", value: 0 },
  getPixelOffset: { type: "accessor", value: [0, 0] },
  getBoundingRect: { type: "accessor", value: [0, 0, 0, 0] },
  getFillColor: { type: "accessor", value: [0, 0, 0, 255] },
  getLineColor: { type: "accessor", value: [0, 0, 0, 255] },
  getLineWidth: { type: "accessor", value: 1 }
};
const _TextBackgroundLayer = class extends Layer {
  getShaders() {
    return super.getShaders({ vs: vs$6, fs: fs$6, modules: [project32, picking] });
  }
  initializeState() {
    this.getAttributeManager().addInstanced({
      instancePositions: {
        size: 3,
        type: "float64",
        fp64: this.use64bitPositions(),
        transition: true,
        accessor: "getPosition"
      },
      instanceSizes: {
        size: 1,
        transition: true,
        accessor: "getSize",
        defaultValue: 1
      },
      instanceAngles: {
        size: 1,
        transition: true,
        accessor: "getAngle"
      },
      instanceRects: {
        size: 4,
        accessor: "getBoundingRect"
      },
      instancePixelOffsets: {
        size: 2,
        transition: true,
        accessor: "getPixelOffset"
      },
      instanceFillColors: {
        size: 4,
        transition: true,
        type: "unorm8",
        accessor: "getFillColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineColors: {
        size: 4,
        transition: true,
        type: "unorm8",
        accessor: "getLineColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceLineWidths: {
        size: 1,
        transition: true,
        accessor: "getLineWidth",
        defaultValue: 1
      }
    });
  }
  updateState(params2) {
    var _a3;
    super.updateState(params2);
    const { changeFlags } = params2;
    if (changeFlags.extensionsChanged) {
      (_a3 = this.state.model) == null ? void 0 : _a3.destroy();
      this.state.model = this._getModel();
      this.getAttributeManager().invalidateAll();
    }
  }
  draw({ uniforms }) {
    const { billboard, sizeScale, sizeUnits, sizeMinPixels, sizeMaxPixels, getLineWidth } = this.props;
    let { padding } = this.props;
    if (padding.length < 4) {
      padding = [padding[0], padding[1], padding[0], padding[1]];
    }
    const model = this.state.model;
    model.setUniforms(uniforms);
    model.setUniforms({
      billboard,
      stroked: Boolean(getLineWidth),
      padding,
      sizeUnits: UNIT[sizeUnits],
      sizeScale,
      sizeMinPixels,
      sizeMaxPixels
    });
    model.draw(this.context.renderPass);
  }
  _getModel() {
    const positions = [0, 0, 1, 0, 1, 1, 0, 1];
    return new Model(this.context.device, {
      ...this.getShaders(),
      id: this.props.id,
      bufferLayout: this.getAttributeManager().getBufferLayouts(),
      geometry: new Geometry({
        topology: "triangle-fan-webgl",
        vertexCount: 4,
        attributes: {
          positions: { size: 2, value: new Float32Array(positions) }
        }
      }),
      isInstanced: true
    });
  }
};
let TextBackgroundLayer = _TextBackgroundLayer;
(() => {
  _TextBackgroundLayer.defaultProps = defaultProps$f;
})();
(() => {
  _TextBackgroundLayer.layerName = "TextBackgroundLayer";
})();
const TEXT_ANCHOR = {
  start: 1,
  middle: 0,
  end: -1
};
const ALIGNMENT_BASELINE = {
  top: 1,
  center: 0,
  bottom: -1
};
const DEFAULT_COLOR$2 = [0, 0, 0, 255];
const DEFAULT_LINE_HEIGHT = 1;
const defaultProps$e = {
  billboard: true,
  sizeScale: 1,
  sizeUnits: "pixels",
  sizeMinPixels: 0,
  sizeMaxPixels: Number.MAX_SAFE_INTEGER,
  background: false,
  getBackgroundColor: { type: "accessor", value: [255, 255, 255, 255] },
  getBorderColor: { type: "accessor", value: DEFAULT_COLOR$2 },
  getBorderWidth: { type: "accessor", value: 0 },
  backgroundPadding: { type: "array", value: [0, 0, 0, 0] },
  characterSet: { type: "object", value: DEFAULT_FONT_SETTINGS.characterSet },
  fontFamily: DEFAULT_FONT_SETTINGS.fontFamily,
  fontWeight: DEFAULT_FONT_SETTINGS.fontWeight,
  lineHeight: DEFAULT_LINE_HEIGHT,
  outlineWidth: { type: "number", value: 0, min: 0 },
  outlineColor: { type: "color", value: DEFAULT_COLOR$2 },
  fontSettings: { type: "object", value: {}, compare: 1 },
  // auto wrapping options
  wordBreak: "break-word",
  maxWidth: { type: "number", value: -1 },
  getText: { type: "accessor", value: (x2) => x2.text },
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getColor: { type: "accessor", value: DEFAULT_COLOR$2 },
  getSize: { type: "accessor", value: 32 },
  getAngle: { type: "accessor", value: 0 },
  getTextAnchor: { type: "accessor", value: "middle" },
  getAlignmentBaseline: { type: "accessor", value: "center" },
  getPixelOffset: { type: "accessor", value: [0, 0] },
  // deprecated
  backgroundColor: { deprecatedFor: ["background", "getBackgroundColor"] }
};
const _TextLayer = class extends CompositeLayer {
  constructor() {
    super(...arguments);
    this.getBoundingRect = (object2, objectInfo) => {
      let { size: [width, height] } = this.transformParagraph(object2, objectInfo);
      const { fontSize } = this.state.fontAtlasManager.props;
      width /= fontSize;
      height /= fontSize;
      const { getTextAnchor, getAlignmentBaseline } = this.props;
      const anchorX = TEXT_ANCHOR[typeof getTextAnchor === "function" ? getTextAnchor(object2, objectInfo) : getTextAnchor];
      const anchorY = ALIGNMENT_BASELINE[typeof getAlignmentBaseline === "function" ? getAlignmentBaseline(object2, objectInfo) : getAlignmentBaseline];
      return [(anchorX - 1) * width / 2, (anchorY - 1) * height / 2, width, height];
    };
    this.getIconOffsets = (object2, objectInfo) => {
      const { getTextAnchor, getAlignmentBaseline } = this.props;
      const { x: x2, y: y2, rowWidth, size: [width, height] } = this.transformParagraph(object2, objectInfo);
      const anchorX = TEXT_ANCHOR[typeof getTextAnchor === "function" ? getTextAnchor(object2, objectInfo) : getTextAnchor];
      const anchorY = ALIGNMENT_BASELINE[typeof getAlignmentBaseline === "function" ? getAlignmentBaseline(object2, objectInfo) : getAlignmentBaseline];
      const numCharacters = x2.length;
      const offsets = new Array(numCharacters * 2);
      let index2 = 0;
      for (let i2 = 0; i2 < numCharacters; i2++) {
        const rowOffset = (1 - anchorX) * (width - rowWidth[i2]) / 2;
        offsets[index2++] = (anchorX - 1) * width / 2 + rowOffset + x2[i2];
        offsets[index2++] = (anchorY - 1) * height / 2 + y2[i2];
      }
      return offsets;
    };
  }
  initializeState() {
    this.state = {
      styleVersion: 0,
      fontAtlasManager: new FontAtlasManager()
    };
    if (this.props.maxWidth > 0) {
      log$1.warn("v8.9 breaking change: TextLayer maxWidth is now relative to text size")();
    }
  }
  // eslint-disable-next-line complexity
  updateState(params2) {
    const { props, oldProps, changeFlags } = params2;
    const textChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getText);
    if (textChanged) {
      this._updateText();
    }
    const fontChanged = this._updateFontAtlas();
    const styleChanged = fontChanged || props.lineHeight !== oldProps.lineHeight || props.wordBreak !== oldProps.wordBreak || props.maxWidth !== oldProps.maxWidth;
    if (styleChanged) {
      this.setState({
        styleVersion: this.state.styleVersion + 1
      });
    }
  }
  getPickingInfo({ info }) {
    info.object = info.index >= 0 ? this.props.data[info.index] : null;
    return info;
  }
  /** Returns true if font has changed */
  _updateFontAtlas() {
    const { fontSettings, fontFamily, fontWeight } = this.props;
    const { fontAtlasManager, characterSet } = this.state;
    const fontProps = {
      ...fontSettings,
      characterSet,
      fontFamily,
      fontWeight
    };
    if (!fontAtlasManager.mapping) {
      fontAtlasManager.setProps(fontProps);
      return true;
    }
    for (const key in fontProps) {
      if (fontProps[key] !== fontAtlasManager.props[key]) {
        fontAtlasManager.setProps(fontProps);
        return true;
      }
    }
    return false;
  }
  // Text strings are variable width objects
  // Count characters and start offsets
  _updateText() {
    var _a3;
    const { data: data2, characterSet } = this.props;
    const textBuffer = (_a3 = data2.attributes) == null ? void 0 : _a3.getText;
    let { getText } = this.props;
    let startIndices = data2.startIndices;
    let numInstances;
    const autoCharacterSet = characterSet === "auto" && /* @__PURE__ */ new Set();
    if (textBuffer && startIndices) {
      const { texts, characterCount } = getTextFromBuffer({
        ...ArrayBuffer.isView(textBuffer) ? { value: textBuffer } : textBuffer,
        // @ts-ignore if data.attribute is defined then length is expected
        length: data2.length,
        startIndices,
        characterSet: autoCharacterSet
      });
      numInstances = characterCount;
      getText = (_2, { index: index2 }) => texts[index2];
    } else {
      const { iterable, objectInfo } = createIterable(data2);
      startIndices = [0];
      numInstances = 0;
      for (const object2 of iterable) {
        objectInfo.index++;
        const text = Array.from(getText(object2, objectInfo) || "");
        if (autoCharacterSet) {
          text.forEach(autoCharacterSet.add, autoCharacterSet);
        }
        numInstances += text.length;
        startIndices.push(numInstances);
      }
    }
    this.setState({
      getText,
      startIndices,
      numInstances,
      characterSet: autoCharacterSet || characterSet
    });
  }
  /** There are two size systems in this layer:
  
      + Pixel size: user-specified text size, via getSize, sizeScale, sizeUnits etc.
        The layer roughly matches the output of the layer to CSS pixels, e.g. getSize: 12, sizeScale: 2
        in layer props is roughly equivalent to font-size: 24px in CSS.
      + Texture size: internally, character positions in a text blob are calculated using the sizes of iconMapping,
        which depends on how large each character is drawn into the font atlas. This is controlled by
        fontSettings.fontSize (default 64) and most users do not set it manually.
        These numbers are intended to be used in the vertex shader and never to be exposed to the end user.
  
      All surfaces exposed to the user should either use the pixel size or a multiplier relative to the pixel size. */
  /** Calculate the size and position of each character in a text string.
   * Values are in texture size */
  transformParagraph(object2, objectInfo) {
    const { fontAtlasManager } = this.state;
    const iconMapping = fontAtlasManager.mapping;
    const getText = this.state.getText;
    const { wordBreak, lineHeight, maxWidth } = this.props;
    const paragraph = getText(object2, objectInfo) || "";
    return transformParagraph(paragraph, lineHeight, wordBreak, maxWidth * fontAtlasManager.props.fontSize, iconMapping);
  }
  renderLayers() {
    const { startIndices, numInstances, getText, fontAtlasManager: { scale: scale5, atlas, mapping }, styleVersion } = this.state;
    const { data: data2, _dataDiff, getPosition: getPosition2, getColor: getColor2, getSize, getAngle, getPixelOffset, getBackgroundColor, getBorderColor, getBorderWidth, backgroundPadding, background, billboard, fontSettings, outlineWidth, outlineColor, sizeScale, sizeUnits, sizeMinPixels, sizeMaxPixels, transitions, updateTriggers } = this.props;
    const CharactersLayerClass = this.getSubLayerClass("characters", MultiIconLayer);
    const BackgroundLayerClass = this.getSubLayerClass("background", TextBackgroundLayer);
    return [
      background && new BackgroundLayerClass({
        // background props
        getFillColor: getBackgroundColor,
        getLineColor: getBorderColor,
        getLineWidth: getBorderWidth,
        padding: backgroundPadding,
        // props shared with characters layer
        getPosition: getPosition2,
        getSize,
        getAngle,
        getPixelOffset,
        billboard,
        sizeScale,
        sizeUnits,
        sizeMinPixels,
        sizeMaxPixels,
        transitions: transitions && {
          getPosition: transitions.getPosition,
          getAngle: transitions.getAngle,
          getSize: transitions.getSize,
          getFillColor: transitions.getBackgroundColor,
          getLineColor: transitions.getBorderColor,
          getLineWidth: transitions.getBorderWidth,
          getPixelOffset: transitions.getPixelOffset
        }
      }, this.getSubLayerProps({
        id: "background",
        updateTriggers: {
          getPosition: updateTriggers.getPosition,
          getAngle: updateTriggers.getAngle,
          getSize: updateTriggers.getSize,
          getFillColor: updateTriggers.getBackgroundColor,
          getLineColor: updateTriggers.getBorderColor,
          getLineWidth: updateTriggers.getBorderWidth,
          getPixelOffset: updateTriggers.getPixelOffset,
          getBoundingRect: {
            getText: updateTriggers.getText,
            getTextAnchor: updateTriggers.getTextAnchor,
            getAlignmentBaseline: updateTriggers.getAlignmentBaseline,
            styleVersion
          }
        }
      }), {
        data: (
          // @ts-ignore (2339) attribute is not defined on all data types
          data2.attributes && data2.attributes.background ? (
            // @ts-ignore (2339) attribute is not defined on all data types
            { length: data2.length, attributes: data2.attributes.background }
          ) : data2
        ),
        _dataDiff,
        // Maintain the same background behavior as <=8.3. Remove in v9?
        autoHighlight: false,
        getBoundingRect: this.getBoundingRect
      }),
      new CharactersLayerClass({
        sdf: fontSettings.sdf,
        smoothing: Number.isFinite(fontSettings.smoothing) ? fontSettings.smoothing : DEFAULT_FONT_SETTINGS.smoothing,
        outlineWidth: outlineWidth / (fontSettings.radius || DEFAULT_FONT_SETTINGS.radius),
        outlineColor,
        iconAtlas: atlas,
        iconMapping: mapping,
        getPosition: getPosition2,
        getColor: getColor2,
        getSize,
        getAngle,
        getPixelOffset,
        billboard,
        sizeScale: sizeScale * scale5,
        sizeUnits,
        sizeMinPixels: sizeMinPixels * scale5,
        sizeMaxPixels: sizeMaxPixels * scale5,
        transitions: transitions && {
          getPosition: transitions.getPosition,
          getAngle: transitions.getAngle,
          getColor: transitions.getColor,
          getSize: transitions.getSize,
          getPixelOffset: transitions.getPixelOffset
        }
      }, this.getSubLayerProps({
        id: "characters",
        updateTriggers: {
          all: updateTriggers.getText,
          getPosition: updateTriggers.getPosition,
          getAngle: updateTriggers.getAngle,
          getColor: updateTriggers.getColor,
          getSize: updateTriggers.getSize,
          getPixelOffset: updateTriggers.getPixelOffset,
          getIconOffsets: {
            getTextAnchor: updateTriggers.getTextAnchor,
            getAlignmentBaseline: updateTriggers.getAlignmentBaseline,
            styleVersion
          }
        }
      }), {
        data: data2,
        _dataDiff,
        startIndices,
        numInstances,
        getIconOffsets: this.getIconOffsets,
        getIcon: getText
      })
    ];
  }
  static set fontAtlasCacheLimit(limit) {
    setFontAtlasCacheLimit(limit);
  }
};
let TextLayer = _TextLayer;
(() => {
  _TextLayer.defaultProps = defaultProps$e;
})();
(() => {
  _TextLayer.layerName = "TextLayer";
})();
const POINT_LAYER = {
  circle: {
    type: ScatterplotLayer,
    props: {
      filled: "filled",
      stroked: "stroked",
      lineWidthMaxPixels: "lineWidthMaxPixels",
      lineWidthMinPixels: "lineWidthMinPixels",
      lineWidthScale: "lineWidthScale",
      lineWidthUnits: "lineWidthUnits",
      pointRadiusMaxPixels: "radiusMaxPixels",
      pointRadiusMinPixels: "radiusMinPixels",
      pointRadiusScale: "radiusScale",
      pointRadiusUnits: "radiusUnits",
      pointAntialiasing: "antialiasing",
      pointBillboard: "billboard",
      getFillColor: "getFillColor",
      getLineColor: "getLineColor",
      getLineWidth: "getLineWidth",
      getPointRadius: "getRadius"
    }
  },
  icon: {
    type: IconLayer,
    props: {
      iconAtlas: "iconAtlas",
      iconMapping: "iconMapping",
      iconSizeMaxPixels: "sizeMaxPixels",
      iconSizeMinPixels: "sizeMinPixels",
      iconSizeScale: "sizeScale",
      iconSizeUnits: "sizeUnits",
      iconAlphaCutoff: "alphaCutoff",
      iconBillboard: "billboard",
      getIcon: "getIcon",
      getIconAngle: "getAngle",
      getIconColor: "getColor",
      getIconPixelOffset: "getPixelOffset",
      getIconSize: "getSize"
    }
  },
  text: {
    type: TextLayer,
    props: {
      textSizeMaxPixels: "sizeMaxPixels",
      textSizeMinPixels: "sizeMinPixels",
      textSizeScale: "sizeScale",
      textSizeUnits: "sizeUnits",
      textBackground: "background",
      textBackgroundPadding: "backgroundPadding",
      textFontFamily: "fontFamily",
      textFontWeight: "fontWeight",
      textLineHeight: "lineHeight",
      textMaxWidth: "maxWidth",
      textOutlineColor: "outlineColor",
      textOutlineWidth: "outlineWidth",
      textWordBreak: "wordBreak",
      textCharacterSet: "characterSet",
      textBillboard: "billboard",
      textFontSettings: "fontSettings",
      getText: "getText",
      getTextAngle: "getAngle",
      getTextColor: "getColor",
      getTextPixelOffset: "getPixelOffset",
      getTextSize: "getSize",
      getTextAnchor: "getTextAnchor",
      getTextAlignmentBaseline: "getAlignmentBaseline",
      getTextBackgroundColor: "getBackgroundColor",
      getTextBorderColor: "getBorderColor",
      getTextBorderWidth: "getBorderWidth"
    }
  }
};
const LINE_LAYER = {
  type: PathLayer,
  props: {
    lineWidthUnits: "widthUnits",
    lineWidthScale: "widthScale",
    lineWidthMinPixels: "widthMinPixels",
    lineWidthMaxPixels: "widthMaxPixels",
    lineJointRounded: "jointRounded",
    lineCapRounded: "capRounded",
    lineMiterLimit: "miterLimit",
    lineBillboard: "billboard",
    getLineColor: "getColor",
    getLineWidth: "getWidth"
  }
};
const POLYGON_LAYER = {
  type: SolidPolygonLayer,
  props: {
    extruded: "extruded",
    filled: "filled",
    wireframe: "wireframe",
    elevationScale: "elevationScale",
    material: "material",
    _full3d: "_full3d",
    getElevation: "getElevation",
    getFillColor: "getFillColor",
    getLineColor: "getLineColor"
  }
};
function getDefaultProps({ type, props }) {
  const result = {};
  for (const key in props) {
    result[key] = type.defaultProps[props[key]];
  }
  return result;
}
function forwardProps(layer, mapping) {
  const { transitions, updateTriggers } = layer.props;
  const result = {
    updateTriggers: {},
    transitions: transitions && {
      getPosition: transitions.geometry
    }
  };
  for (const sourceKey in mapping) {
    const targetKey = mapping[sourceKey];
    let value = layer.props[sourceKey];
    if (sourceKey.startsWith("get")) {
      value = layer.getSubLayerAccessor(value);
      result.updateTriggers[targetKey] = updateTriggers[sourceKey];
      if (transitions) {
        result.transitions[targetKey] = transitions[sourceKey];
      }
    }
    result[targetKey] = value;
  }
  return result;
}
function getGeojsonFeatures(geojson) {
  if (Array.isArray(geojson)) {
    return geojson;
  }
  log$1.assert(geojson.type, "GeoJSON does not have type");
  switch (geojson.type) {
    case "Feature":
      return [geojson];
    case "FeatureCollection":
      log$1.assert(Array.isArray(geojson.features), "GeoJSON does not have features array");
      return geojson.features;
    default:
      return [{ geometry: geojson }];
  }
}
function separateGeojsonFeatures(features, wrapFeature, dataRange = {}) {
  const separated = {
    pointFeatures: [],
    lineFeatures: [],
    polygonFeatures: [],
    polygonOutlineFeatures: []
  };
  const { startRow = 0, endRow = features.length } = dataRange;
  for (let featureIndex = startRow; featureIndex < endRow; featureIndex++) {
    const feature2 = features[featureIndex];
    const { geometry: geometry2 } = feature2;
    if (!geometry2) {
      continue;
    }
    if (geometry2.type === "GeometryCollection") {
      log$1.assert(Array.isArray(geometry2.geometries), "GeoJSON does not have geometries array");
      const { geometries } = geometry2;
      for (let i2 = 0; i2 < geometries.length; i2++) {
        const subGeometry = geometries[i2];
        separateGeometry(subGeometry, separated, wrapFeature, feature2, featureIndex);
      }
    } else {
      separateGeometry(geometry2, separated, wrapFeature, feature2, featureIndex);
    }
  }
  return separated;
}
function separateGeometry(geometry2, separated, wrapFeature, sourceFeature, sourceFeatureIndex) {
  const { type, coordinates: coordinates2 } = geometry2;
  const { pointFeatures, lineFeatures, polygonFeatures, polygonOutlineFeatures } = separated;
  if (!validateGeometry(type, coordinates2)) {
    log$1.warn(`${type} coordinates are malformed`)();
    return;
  }
  switch (type) {
    case "Point":
      pointFeatures.push(wrapFeature({
        geometry: geometry2
      }, sourceFeature, sourceFeatureIndex));
      break;
    case "MultiPoint":
      coordinates2.forEach((point4) => {
        pointFeatures.push(wrapFeature({
          geometry: { type: "Point", coordinates: point4 }
        }, sourceFeature, sourceFeatureIndex));
      });
      break;
    case "LineString":
      lineFeatures.push(wrapFeature({
        geometry: geometry2
      }, sourceFeature, sourceFeatureIndex));
      break;
    case "MultiLineString":
      coordinates2.forEach((path2) => {
        lineFeatures.push(wrapFeature({
          geometry: { type: "LineString", coordinates: path2 }
        }, sourceFeature, sourceFeatureIndex));
      });
      break;
    case "Polygon":
      polygonFeatures.push(wrapFeature({
        geometry: geometry2
      }, sourceFeature, sourceFeatureIndex));
      coordinates2.forEach((path2) => {
        polygonOutlineFeatures.push(wrapFeature({
          geometry: { type: "LineString", coordinates: path2 }
        }, sourceFeature, sourceFeatureIndex));
      });
      break;
    case "MultiPolygon":
      coordinates2.forEach((polygon4) => {
        polygonFeatures.push(wrapFeature({
          geometry: { type: "Polygon", coordinates: polygon4 }
        }, sourceFeature, sourceFeatureIndex));
        polygon4.forEach((path2) => {
          polygonOutlineFeatures.push(wrapFeature({
            geometry: { type: "LineString", coordinates: path2 }
          }, sourceFeature, sourceFeatureIndex));
        });
      });
      break;
  }
}
const COORDINATE_NEST_LEVEL = {
  Point: 1,
  MultiPoint: 2,
  LineString: 2,
  MultiLineString: 3,
  Polygon: 3,
  MultiPolygon: 4
};
function validateGeometry(type, coordinates2) {
  let nestLevel = COORDINATE_NEST_LEVEL[type];
  log$1.assert(nestLevel, `Unknown GeoJSON type ${type}`);
  while (coordinates2 && --nestLevel > 0) {
    coordinates2 = coordinates2[0];
  }
  return coordinates2 && Number.isFinite(coordinates2[0]);
}
function createEmptyLayerProps() {
  return {
    points: {},
    lines: {},
    polygons: {},
    polygonsOutline: {}
  };
}
function getCoordinates(f2) {
  return f2.geometry.coordinates;
}
function createLayerPropsFromFeatures(features, featuresDiff) {
  const layerProps = createEmptyLayerProps();
  const { pointFeatures, lineFeatures, polygonFeatures, polygonOutlineFeatures } = features;
  layerProps.points.data = pointFeatures;
  layerProps.points._dataDiff = featuresDiff.pointFeatures && (() => featuresDiff.pointFeatures);
  layerProps.points.getPosition = getCoordinates;
  layerProps.lines.data = lineFeatures;
  layerProps.lines._dataDiff = featuresDiff.lineFeatures && (() => featuresDiff.lineFeatures);
  layerProps.lines.getPath = getCoordinates;
  layerProps.polygons.data = polygonFeatures;
  layerProps.polygons._dataDiff = featuresDiff.polygonFeatures && (() => featuresDiff.polygonFeatures);
  layerProps.polygons.getPolygon = getCoordinates;
  layerProps.polygonsOutline.data = polygonOutlineFeatures;
  layerProps.polygonsOutline._dataDiff = featuresDiff.polygonOutlineFeatures && (() => featuresDiff.polygonOutlineFeatures);
  layerProps.polygonsOutline.getPath = getCoordinates;
  return layerProps;
}
function createLayerPropsFromBinary(geojsonBinary, encodePickingColor) {
  const layerProps = createEmptyLayerProps();
  const { points: points2, lines, polygons: polygons2 } = geojsonBinary;
  const customPickingColors = calculatePickingColors(geojsonBinary, encodePickingColor);
  layerProps.points.data = {
    length: points2.positions.value.length / points2.positions.size,
    attributes: {
      ...points2.attributes,
      getPosition: points2.positions,
      instancePickingColors: {
        size: 3,
        value: customPickingColors.points
      }
    },
    properties: points2.properties,
    numericProps: points2.numericProps,
    featureIds: points2.featureIds
  };
  layerProps.lines.data = {
    length: lines.pathIndices.value.length - 1,
    startIndices: lines.pathIndices.value,
    attributes: {
      ...lines.attributes,
      getPath: lines.positions,
      instancePickingColors: {
        size: 3,
        value: customPickingColors.lines
      }
    },
    properties: lines.properties,
    numericProps: lines.numericProps,
    featureIds: lines.featureIds
  };
  layerProps.lines._pathType = "open";
  layerProps.polygons.data = {
    length: polygons2.polygonIndices.value.length - 1,
    startIndices: polygons2.polygonIndices.value,
    attributes: {
      ...polygons2.attributes,
      getPolygon: polygons2.positions,
      pickingColors: {
        size: 3,
        value: customPickingColors.polygons
      }
    },
    properties: polygons2.properties,
    numericProps: polygons2.numericProps,
    featureIds: polygons2.featureIds
  };
  layerProps.polygons._normalize = false;
  if (polygons2.triangles) {
    layerProps.polygons.data.attributes.indices = polygons2.triangles.value;
  }
  layerProps.polygonsOutline.data = {
    length: polygons2.primitivePolygonIndices.value.length - 1,
    startIndices: polygons2.primitivePolygonIndices.value,
    attributes: {
      ...polygons2.attributes,
      getPath: polygons2.positions,
      instancePickingColors: {
        size: 3,
        value: customPickingColors.polygons
      }
    },
    properties: polygons2.properties,
    numericProps: polygons2.numericProps,
    featureIds: polygons2.featureIds
  };
  layerProps.polygonsOutline._pathType = "open";
  return layerProps;
}
const FEATURE_TYPES = ["points", "linestrings", "polygons"];
const defaultProps$d = {
  ...getDefaultProps(POINT_LAYER.circle),
  ...getDefaultProps(POINT_LAYER.icon),
  ...getDefaultProps(POINT_LAYER.text),
  ...getDefaultProps(LINE_LAYER),
  ...getDefaultProps(POLYGON_LAYER),
  // Overwrite sub layer defaults
  stroked: true,
  filled: true,
  extruded: false,
  wireframe: false,
  _full3d: false,
  iconAtlas: { type: "object", value: null },
  iconMapping: { type: "object", value: {} },
  getIcon: { type: "accessor", value: (f2) => f2.properties.icon },
  getText: { type: "accessor", value: (f2) => f2.properties.text },
  // Self props
  pointType: "circle",
  // TODO: deprecated, remove in v9
  getRadius: { deprecatedFor: "getPointRadius" }
};
let GeoJsonLayer$1 = (_d = class extends CompositeLayer {
  initializeState() {
    this.state = {
      layerProps: {},
      features: {},
      featuresDiff: {}
    };
  }
  updateState({ props, changeFlags }) {
    if (!changeFlags.dataChanged) {
      return;
    }
    const { data: data2 } = this.props;
    const binary = data2 && "points" in data2 && "polygons" in data2 && "lines" in data2;
    this.setState({ binary });
    if (binary) {
      this._updateStateBinary({ props, changeFlags });
    } else {
      this._updateStateJSON({ props, changeFlags });
    }
  }
  _updateStateBinary({ props, changeFlags }) {
    const layerProps = createLayerPropsFromBinary(props.data, this.encodePickingColor);
    this.setState({ layerProps });
  }
  _updateStateJSON({ props, changeFlags }) {
    const features = getGeojsonFeatures(props.data);
    const wrapFeature = this.getSubLayerRow.bind(this);
    let newFeatures = {};
    const featuresDiff = {};
    if (Array.isArray(changeFlags.dataChanged)) {
      const oldFeatures = this.state.features;
      for (const key in oldFeatures) {
        newFeatures[key] = oldFeatures[key].slice();
        featuresDiff[key] = [];
      }
      for (const dataRange of changeFlags.dataChanged) {
        const partialFeatures = separateGeojsonFeatures(features, wrapFeature, dataRange);
        for (const key in oldFeatures) {
          featuresDiff[key].push(replaceInRange({
            data: newFeatures[key],
            getIndex: (f2) => f2.__source.index,
            dataRange,
            replace: partialFeatures[key]
          }));
        }
      }
    } else {
      newFeatures = separateGeojsonFeatures(features, wrapFeature);
    }
    const layerProps = createLayerPropsFromFeatures(newFeatures, featuresDiff);
    this.setState({
      features: newFeatures,
      featuresDiff,
      layerProps
    });
  }
  getPickingInfo(params2) {
    const info = super.getPickingInfo(params2);
    const { index: index2, sourceLayer } = info;
    info.featureType = FEATURE_TYPES.find((ft) => sourceLayer.id.startsWith(`${this.id}-${ft}-`));
    if (index2 >= 0 && sourceLayer.id.startsWith(`${this.id}-points-text`) && this.state.binary) {
      info.index = this.props.data.points.globalFeatureIds.value[index2];
    }
    return info;
  }
  _updateAutoHighlight(info) {
    const pointLayerIdPrefix = `${this.id}-points-`;
    const sourceIsPoints = info.featureType === "points";
    for (const layer of this.getSubLayers()) {
      if (layer.id.startsWith(pointLayerIdPrefix) === sourceIsPoints) {
        layer.updateAutoHighlight(info);
      }
    }
  }
  _renderPolygonLayer() {
    var _a3;
    const { extruded, wireframe } = this.props;
    const { layerProps } = this.state;
    const id = "polygons-fill";
    const PolygonFillLayer = this.shouldRenderSubLayer(id, (_a3 = layerProps.polygons) == null ? void 0 : _a3.data) && this.getSubLayerClass(id, POLYGON_LAYER.type);
    if (PolygonFillLayer) {
      const forwardedProps = forwardProps(this, POLYGON_LAYER.props);
      const useLineColor = extruded && wireframe;
      if (!useLineColor) {
        delete forwardedProps.getLineColor;
      }
      forwardedProps.updateTriggers.lineColors = useLineColor;
      return new PolygonFillLayer(forwardedProps, this.getSubLayerProps({
        id,
        updateTriggers: forwardedProps.updateTriggers
      }), layerProps.polygons);
    }
    return null;
  }
  _renderLineLayers() {
    var _a3, _b3;
    const { extruded, stroked } = this.props;
    const { layerProps } = this.state;
    const polygonStrokeLayerId = "polygons-stroke";
    const lineStringsLayerId = "linestrings";
    const PolygonStrokeLayer = !extruded && stroked && this.shouldRenderSubLayer(polygonStrokeLayerId, (_a3 = layerProps.polygonsOutline) == null ? void 0 : _a3.data) && this.getSubLayerClass(polygonStrokeLayerId, LINE_LAYER.type);
    const LineStringsLayer = this.shouldRenderSubLayer(lineStringsLayerId, (_b3 = layerProps.lines) == null ? void 0 : _b3.data) && this.getSubLayerClass(lineStringsLayerId, LINE_LAYER.type);
    if (PolygonStrokeLayer || LineStringsLayer) {
      const forwardedProps = forwardProps(this, LINE_LAYER.props);
      return [
        PolygonStrokeLayer && new PolygonStrokeLayer(forwardedProps, this.getSubLayerProps({
          id: polygonStrokeLayerId,
          updateTriggers: forwardedProps.updateTriggers
        }), layerProps.polygonsOutline),
        LineStringsLayer && new LineStringsLayer(forwardedProps, this.getSubLayerProps({
          id: lineStringsLayerId,
          updateTriggers: forwardedProps.updateTriggers
        }), layerProps.lines)
      ];
    }
    return null;
  }
  _renderPointLayers() {
    var _a3;
    const { pointType } = this.props;
    const { layerProps, binary } = this.state;
    let { highlightedObjectIndex } = this.props;
    if (!binary && Number.isFinite(highlightedObjectIndex)) {
      highlightedObjectIndex = layerProps.points.data.findIndex((d2) => d2.__source.index === highlightedObjectIndex);
    }
    const types2 = new Set(pointType.split("+"));
    const pointLayers = [];
    for (const type of types2) {
      const id = `points-${type}`;
      const PointLayerMapping = POINT_LAYER[type];
      const PointsLayer = PointLayerMapping && this.shouldRenderSubLayer(id, (_a3 = layerProps.points) == null ? void 0 : _a3.data) && this.getSubLayerClass(id, PointLayerMapping.type);
      if (PointsLayer) {
        const forwardedProps = forwardProps(this, PointLayerMapping.props);
        let pointsLayerProps = layerProps.points;
        if (type === "text" && binary) {
          const { instancePickingColors, ...rest } = pointsLayerProps.data.attributes;
          pointsLayerProps = {
            ...pointsLayerProps,
            // @ts-expect-error TODO - type binary data
            data: { ...pointsLayerProps.data, attributes: rest }
          };
        }
        pointLayers.push(new PointsLayer(forwardedProps, this.getSubLayerProps({
          id,
          updateTriggers: forwardedProps.updateTriggers,
          highlightedObjectIndex
        }), pointsLayerProps));
      }
    }
    return pointLayers;
  }
  renderLayers() {
    const { extruded } = this.props;
    const polygonFillLayer = this._renderPolygonLayer();
    const lineLayers = this._renderLineLayers();
    const pointLayers = this._renderPointLayers();
    return [
      // If not extruded: flat fill layer is drawn below outlines
      !extruded && polygonFillLayer,
      lineLayers,
      pointLayers,
      // If extruded: draw fill layer last for correct blending behavior
      extruded && polygonFillLayer
    ];
  }
  getSubLayerAccessor(accessor) {
    const { binary } = this.state;
    if (!binary || typeof accessor !== "function") {
      return super.getSubLayerAccessor(accessor);
    }
    return (object2, info) => {
      const { data: data2, index: index2 } = info;
      const feature2 = binaryToFeatureForAccesor(data2, index2);
      return accessor(feature2, info);
    };
  }
}, (() => {
  _d.layerName = "GeoJsonLayer";
})(), (() => {
  _d.defaultProps = defaultProps$d;
})(), _d);
const defaultProps$c = {
  ...PolygonLayer.defaultProps
};
const _GeoCellLayer = class extends CompositeLayer {
  /** Implement to generate props to create geometry. */
  indexToBounds() {
    return null;
  }
  renderLayers() {
    const { elevationScale, extruded, wireframe, filled, stroked, lineWidthUnits, lineWidthScale, lineWidthMinPixels, lineWidthMaxPixels, lineJointRounded, lineMiterLimit, lineDashJustified, getElevation, getFillColor, getLineColor, getLineWidth } = this.props;
    const { updateTriggers, material, transitions } = this.props;
    const CellLayer = this.getSubLayerClass("cell", PolygonLayer);
    const { updateTriggers: boundsUpdateTriggers, ...boundsProps } = this.indexToBounds() || {};
    return new CellLayer({
      filled,
      wireframe,
      extruded,
      elevationScale,
      stroked,
      lineWidthUnits,
      lineWidthScale,
      lineWidthMinPixels,
      lineWidthMaxPixels,
      lineJointRounded,
      lineMiterLimit,
      lineDashJustified,
      material,
      transitions,
      getElevation,
      getFillColor,
      getLineColor,
      getLineWidth
    }, this.getSubLayerProps({
      id: "cell",
      updateTriggers: updateTriggers && {
        ...boundsUpdateTriggers,
        getElevation: updateTriggers.getElevation,
        getFillColor: updateTriggers.getFillColor,
        getLineColor: updateTriggers.getLineColor,
        getLineWidth: updateTriggers.getLineWidth
      }
    }), boundsProps);
  }
};
let GeoCellLayer = _GeoCellLayer;
(() => {
  _GeoCellLayer.layerName = "GeoCellLayer";
})();
(() => {
  _GeoCellLayer.defaultProps = defaultProps$c;
})();
const TILE_SIZE$2 = 512;
function quadkeyToWorldBounds(quadkey, coverage) {
  let x2 = 0;
  let y2 = 0;
  let mask = 1 << quadkey.length;
  const scale5 = mask / TILE_SIZE$2;
  for (let i2 = 0; i2 < quadkey.length; i2++) {
    mask >>= 1;
    const q2 = parseInt(quadkey[i2]);
    if (q2 % 2)
      x2 |= mask;
    if (q2 > 1)
      y2 |= mask;
  }
  return [
    [x2 / scale5, TILE_SIZE$2 - y2 / scale5],
    [(x2 + coverage) / scale5, TILE_SIZE$2 - (y2 + coverage) / scale5]
  ];
}
function getQuadkeyPolygon(quadkey, coverage = 1) {
  const [topLeft, bottomRight] = quadkeyToWorldBounds(quadkey, coverage);
  const [w2, n2] = worldToLngLat(topLeft);
  const [e3, s2] = worldToLngLat(bottomRight);
  return [e3, n2, e3, s2, w2, s2, w2, n2, e3, n2];
}
const defaultProps$b = {
  getQuadkey: { type: "accessor", value: (d2) => d2.quadkey }
};
const _QuadkeyLayer = class extends GeoCellLayer {
  indexToBounds() {
    const { data: data2, extruded, getQuadkey } = this.props;
    const coverage = extruded ? 0.99 : 1;
    return {
      data: data2,
      _normalize: false,
      positionFormat: "XY",
      getPolygon: (x2, objectInfo) => getQuadkeyPolygon(getQuadkey(x2, objectInfo), coverage),
      updateTriggers: { getPolygon: coverage }
    };
  }
};
let QuadkeyLayer = _QuadkeyLayer;
(() => {
  _QuadkeyLayer.layerName = "QuadkeyLayer";
})();
(() => {
  _QuadkeyLayer.defaultProps = defaultProps$b;
})();
class Tile2DHeader {
  constructor(index2) {
    this.index = index2;
    this.isVisible = false;
    this.isSelected = false;
    this.parent = null;
    this.children = [];
    this.content = null;
    this._loader = void 0;
    this._abortController = null;
    this._loaderId = 0;
    this._isLoaded = false;
    this._isCancelled = false;
    this._needsReload = false;
  }
  /** @deprecated use `boundingBox` instead */
  get bbox() {
    return this._bbox;
  }
  // TODO - remove in v9
  set bbox(value) {
    if (this._bbox)
      return;
    this._bbox = value;
    if ("west" in value) {
      this.boundingBox = [
        [value.west, value.south],
        [value.east, value.north]
      ];
    } else {
      this.boundingBox = [
        [value.left, value.top],
        [value.right, value.bottom]
      ];
    }
  }
  get data() {
    return this.isLoading && this._loader ? this._loader.then(() => this.data) : this.content;
  }
  get isLoaded() {
    return this._isLoaded && !this._needsReload;
  }
  get isLoading() {
    return Boolean(this._loader) && !this._isCancelled;
  }
  get needsReload() {
    return this._needsReload || this._isCancelled;
  }
  get byteLength() {
    const result = this.content ? this.content.byteLength : 0;
    if (!Number.isFinite(result)) {
      console.error("byteLength not defined in tile data");
    }
    return result;
  }
  /* eslint-disable max-statements */
  async _loadData({ getData: getData6, requestScheduler, onLoad, onError }) {
    const { index: index2, id, bbox: bbox2, userData, zoom: zoom2 } = this;
    const loaderId = this._loaderId;
    this._abortController = new AbortController();
    const { signal } = this._abortController;
    const requestToken = await requestScheduler.scheduleRequest(this, (tile) => {
      return tile.isSelected ? 1 : -1;
    });
    if (!requestToken) {
      this._isCancelled = true;
      return;
    }
    if (this._isCancelled) {
      requestToken.done();
      return;
    }
    let tileData = null;
    let error2;
    try {
      tileData = await getData6({ index: index2, id, bbox: bbox2, userData, zoom: zoom2, signal });
    } catch (err) {
      error2 = err || true;
    } finally {
      requestToken.done();
    }
    if (loaderId !== this._loaderId) {
      return;
    }
    this._loader = void 0;
    this.content = tileData;
    if (this._isCancelled && !tileData) {
      this._isLoaded = false;
      return;
    }
    this._isLoaded = true;
    this._isCancelled = false;
    if (error2) {
      onError(error2, this);
    } else {
      onLoad(this);
    }
  }
  loadData(opts) {
    this._isLoaded = false;
    this._isCancelled = false;
    this._needsReload = false;
    this._loaderId++;
    this._loader = this._loadData(opts);
    return this._loader;
  }
  setNeedsReload() {
    if (this.isLoading) {
      this.abort();
      this._loader = void 0;
    }
    this._needsReload = true;
  }
  abort() {
    var _a3;
    if (this.isLoaded) {
      return;
    }
    this._isCancelled = true;
    (_a3 = this._abortController) == null ? void 0 : _a3.abort();
  }
}
const INTERSECTION = {
  OUTSIDE: -1,
  // Represents that an object is not contained within the frustum.
  INTERSECTING: 0,
  // Represents that an object intersects one of the frustum's planes.
  INSIDE: 1
  // Represents that an object is fully within the frustum.
};
const scratchVector$8 = new Vector3();
const scratchNormal$4 = new Vector3();
class AxisAlignedBoundingBox {
  /**
   * Creates an instance of an AxisAlignedBoundingBox from the minimum and maximum points along the x, y, and z axes.
   * @param minimum=[0, 0, 0] The minimum point along the x, y, and z axes.
   * @param maximum=[0, 0, 0] The maximum point along the x, y, and z axes.
   * @param center The center of the box; automatically computed if not supplied.
   */
  constructor(minimum = [0, 0, 0], maximum = [0, 0, 0], center2) {
    center2 = center2 || scratchVector$8.copy(minimum).add(maximum).scale(0.5);
    this.center = new Vector3(center2);
    this.halfDiagonal = new Vector3(maximum).subtract(this.center);
    this.minimum = new Vector3(minimum);
    this.maximum = new Vector3(maximum);
  }
  /**
   * Duplicates a AxisAlignedBoundingBox instance.
   *
   * @returns {AxisAlignedBoundingBox} A new AxisAlignedBoundingBox instance.
   */
  clone() {
    return new AxisAlignedBoundingBox(this.minimum, this.maximum, this.center);
  }
  /**
   * Compares the provided AxisAlignedBoundingBox componentwise and returns
   * <code>true</code> if they are equal, <code>false</code> otherwise.
   *
   * @param {AxisAlignedBoundingBox} [right] The second AxisAlignedBoundingBox to compare with.
   * @returns {Boolean} <code>true</code> if left and right are equal, <code>false</code> otherwise.
   */
  equals(right) {
    return this === right || Boolean(right) && this.minimum.equals(right.minimum) && this.maximum.equals(right.maximum);
  }
  /**
   * Applies a 4x4 affine transformation matrix to a bounding sphere.
   * @param transform The transformation matrix to apply to the bounding sphere.
   * @returns itself, i.e. the modified BoundingVolume.
   */
  transform(transform4) {
    this.center.transformAsPoint(transform4);
    this.halfDiagonal.transform(transform4);
    this.minimum.transform(transform4);
    this.maximum.transform(transform4);
    return this;
  }
  /**
   * Determines which side of a plane a box is located.
   */
  intersectPlane(plane) {
    const { halfDiagonal } = this;
    const normal = scratchNormal$4.from(plane.normal);
    const e3 = halfDiagonal.x * Math.abs(normal.x) + halfDiagonal.y * Math.abs(normal.y) + halfDiagonal.z * Math.abs(normal.z);
    const s2 = this.center.dot(normal) + plane.distance;
    if (s2 - e3 > 0) {
      return INTERSECTION.INSIDE;
    }
    if (s2 + e3 < 0) {
      return INTERSECTION.OUTSIDE;
    }
    return INTERSECTION.INTERSECTING;
  }
  /** Computes the estimated distance from the closest point on a bounding box to a point. */
  distanceTo(point4) {
    return Math.sqrt(this.distanceSquaredTo(point4));
  }
  /** Computes the estimated distance squared from the closest point on a bounding box to a point. */
  distanceSquaredTo(point4) {
    const offset = scratchVector$8.from(point4).subtract(this.center);
    const { halfDiagonal } = this;
    let distanceSquared = 0;
    let d2;
    d2 = Math.abs(offset.x) - halfDiagonal.x;
    if (d2 > 0) {
      distanceSquared += d2 * d2;
    }
    d2 = Math.abs(offset.y) - halfDiagonal.y;
    if (d2 > 0) {
      distanceSquared += d2 * d2;
    }
    d2 = Math.abs(offset.z) - halfDiagonal.z;
    if (d2 > 0) {
      distanceSquared += d2 * d2;
    }
    return distanceSquared;
  }
}
const scratchVector$7 = new Vector3();
const scratchVector2$2 = new Vector3();
class BoundingSphere {
  /** Creates a bounding sphere */
  constructor(center2 = [0, 0, 0], radius = 0) {
    this.radius = -0;
    this.center = new Vector3();
    this.fromCenterRadius(center2, radius);
  }
  /** Sets the bounding sphere from `center` and `radius`. */
  fromCenterRadius(center2, radius) {
    this.center.from(center2);
    this.radius = radius;
    return this;
  }
  /**
   * Computes a bounding sphere from the corner points of an axis-aligned bounding box.  The sphere
   * tightly and fully encompasses the box.
   */
  fromCornerPoints(corner, oppositeCorner) {
    oppositeCorner = scratchVector$7.from(oppositeCorner);
    this.center = new Vector3().from(corner).add(oppositeCorner).scale(0.5);
    this.radius = this.center.distance(oppositeCorner);
    return this;
  }
  /** Compares the provided BoundingSphere component wise */
  equals(right) {
    return this === right || Boolean(right) && this.center.equals(right.center) && this.radius === right.radius;
  }
  /** Duplicates a BoundingSphere instance. */
  clone() {
    return new BoundingSphere(this.center, this.radius);
  }
  /** Computes a bounding sphere that contains both the left and right bounding spheres. */
  union(boundingSphere) {
    const leftCenter = this.center;
    const leftRadius = this.radius;
    const rightCenter = boundingSphere.center;
    const rightRadius = boundingSphere.radius;
    const toRightCenter = scratchVector$7.copy(rightCenter).subtract(leftCenter);
    const centerSeparation = toRightCenter.magnitude();
    if (leftRadius >= centerSeparation + rightRadius) {
      return this.clone();
    }
    if (rightRadius >= centerSeparation + leftRadius) {
      return boundingSphere.clone();
    }
    const halfDistanceBetweenTangentPoints = (leftRadius + centerSeparation + rightRadius) * 0.5;
    scratchVector2$2.copy(toRightCenter).scale((-leftRadius + halfDistanceBetweenTangentPoints) / centerSeparation).add(leftCenter);
    this.center.copy(scratchVector2$2);
    this.radius = halfDistanceBetweenTangentPoints;
    return this;
  }
  /** Computes a bounding sphere by enlarging the provided sphere to contain the provided point. */
  expand(point4) {
    const scratchPoint2 = scratchVector$7.from(point4);
    const radius = scratchPoint2.subtract(this.center).magnitude();
    if (radius > this.radius) {
      this.radius = radius;
    }
    return this;
  }
  // BoundingVolume interface
  /**
   * Applies a 4x4 affine transformation matrix to a bounding sphere.
   * @param sphere The bounding sphere to apply the transformation to.
   * @param transform The transformation matrix to apply to the bounding sphere.
   * @returns self.
   */
  transform(transform4) {
    this.center.transform(transform4);
    const scale5 = getScaling(scratchVector$7, transform4);
    this.radius = Math.max(scale5[0], Math.max(scale5[1], scale5[2])) * this.radius;
    return this;
  }
  /** Computes the estimated distance squared from the closest point on a bounding sphere to a point. */
  distanceSquaredTo(point4) {
    const d2 = this.distanceTo(point4);
    return d2 * d2;
  }
  /** Computes the estimated distance from the closest point on a bounding sphere to a point. */
  distanceTo(point4) {
    const scratchPoint2 = scratchVector$7.from(point4);
    const delta = scratchPoint2.subtract(this.center);
    return Math.max(0, delta.len() - this.radius);
  }
  /** Determines which side of a plane a sphere is located. */
  intersectPlane(plane) {
    const center2 = this.center;
    const radius = this.radius;
    const normal = plane.normal;
    const distanceToPlane = normal.dot(center2) + plane.distance;
    if (distanceToPlane < -radius) {
      return INTERSECTION.OUTSIDE;
    }
    if (distanceToPlane < radius) {
      return INTERSECTION.INTERSECTING;
    }
    return INTERSECTION.INSIDE;
  }
}
const scratchVector3$2 = new Vector3();
const scratchOffset = new Vector3();
const scratchVectorU = new Vector3();
const scratchVectorV = new Vector3();
const scratchVectorW = new Vector3();
const scratchCorner = new Vector3();
const scratchToCenter = new Vector3();
const MATRIX3 = {
  COLUMN0ROW0: 0,
  COLUMN0ROW1: 1,
  COLUMN0ROW2: 2,
  COLUMN1ROW0: 3,
  COLUMN1ROW1: 4,
  COLUMN1ROW2: 5,
  COLUMN2ROW0: 6,
  COLUMN2ROW1: 7,
  COLUMN2ROW2: 8
};
class OrientedBoundingBox {
  constructor(center2 = [0, 0, 0], halfAxes = [0, 0, 0, 0, 0, 0, 0, 0, 0]) {
    this.center = new Vector3().from(center2);
    this.halfAxes = new Matrix3(halfAxes);
  }
  /** Returns an array with three halfSizes for the bounding box */
  get halfSize() {
    const xAxis = this.halfAxes.getColumn(0);
    const yAxis = this.halfAxes.getColumn(1);
    const zAxis = this.halfAxes.getColumn(2);
    return [new Vector3(xAxis).len(), new Vector3(yAxis).len(), new Vector3(zAxis).len()];
  }
  /** Returns a quaternion describing the orientation of the bounding box */
  get quaternion() {
    const xAxis = this.halfAxes.getColumn(0);
    const yAxis = this.halfAxes.getColumn(1);
    const zAxis = this.halfAxes.getColumn(2);
    const normXAxis = new Vector3(xAxis).normalize();
    const normYAxis = new Vector3(yAxis).normalize();
    const normZAxis = new Vector3(zAxis).normalize();
    return new Quaternion().fromMatrix3(new Matrix3([...normXAxis, ...normYAxis, ...normZAxis]));
  }
  /**
   * Create OrientedBoundingBox from quaternion based OBB,
   */
  fromCenterHalfSizeQuaternion(center2, halfSize, quaternion2) {
    const quaternionObject = new Quaternion(quaternion2);
    const directionsMatrix = new Matrix3().fromQuaternion(quaternionObject);
    directionsMatrix[0] = directionsMatrix[0] * halfSize[0];
    directionsMatrix[1] = directionsMatrix[1] * halfSize[0];
    directionsMatrix[2] = directionsMatrix[2] * halfSize[0];
    directionsMatrix[3] = directionsMatrix[3] * halfSize[1];
    directionsMatrix[4] = directionsMatrix[4] * halfSize[1];
    directionsMatrix[5] = directionsMatrix[5] * halfSize[1];
    directionsMatrix[6] = directionsMatrix[6] * halfSize[2];
    directionsMatrix[7] = directionsMatrix[7] * halfSize[2];
    directionsMatrix[8] = directionsMatrix[8] * halfSize[2];
    this.center = new Vector3().from(center2);
    this.halfAxes = directionsMatrix;
    return this;
  }
  /** Duplicates a OrientedBoundingBox instance. */
  clone() {
    return new OrientedBoundingBox(this.center, this.halfAxes);
  }
  /** Compares the provided OrientedBoundingBox component wise and returns */
  equals(right) {
    return this === right || Boolean(right) && this.center.equals(right.center) && this.halfAxes.equals(right.halfAxes);
  }
  /** Computes a tight-fitting bounding sphere enclosing the provided oriented bounding box. */
  getBoundingSphere(result = new BoundingSphere()) {
    const halfAxes = this.halfAxes;
    const u2 = halfAxes.getColumn(0, scratchVectorU);
    const v5 = halfAxes.getColumn(1, scratchVectorV);
    const w2 = halfAxes.getColumn(2, scratchVectorW);
    const cornerVector = scratchVector3$2.copy(u2).add(v5).add(w2);
    result.center.copy(this.center);
    result.radius = cornerVector.magnitude();
    return result;
  }
  /** Determines which side of a plane the oriented bounding box is located. */
  intersectPlane(plane) {
    const center2 = this.center;
    const normal = plane.normal;
    const halfAxes = this.halfAxes;
    const normalX = normal.x;
    const normalY = normal.y;
    const normalZ = normal.z;
    const radEffective = Math.abs(normalX * halfAxes[MATRIX3.COLUMN0ROW0] + normalY * halfAxes[MATRIX3.COLUMN0ROW1] + normalZ * halfAxes[MATRIX3.COLUMN0ROW2]) + Math.abs(normalX * halfAxes[MATRIX3.COLUMN1ROW0] + normalY * halfAxes[MATRIX3.COLUMN1ROW1] + normalZ * halfAxes[MATRIX3.COLUMN1ROW2]) + Math.abs(normalX * halfAxes[MATRIX3.COLUMN2ROW0] + normalY * halfAxes[MATRIX3.COLUMN2ROW1] + normalZ * halfAxes[MATRIX3.COLUMN2ROW2]);
    const distanceToPlane = normal.dot(center2) + plane.distance;
    if (distanceToPlane <= -radEffective) {
      return INTERSECTION.OUTSIDE;
    } else if (distanceToPlane >= radEffective) {
      return INTERSECTION.INSIDE;
    }
    return INTERSECTION.INTERSECTING;
  }
  /** Computes the estimated distance from the closest point on a bounding box to a point. */
  distanceTo(point4) {
    return Math.sqrt(this.distanceSquaredTo(point4));
  }
  /**
   * Computes the estimated distance squared from the closest point
   * on a bounding box to a point.
   * See Geometric Tools for Computer Graphics 10.4.2
   */
  distanceSquaredTo(point4) {
    const offset = scratchOffset.from(point4).subtract(this.center);
    const halfAxes = this.halfAxes;
    const u2 = halfAxes.getColumn(0, scratchVectorU);
    const v5 = halfAxes.getColumn(1, scratchVectorV);
    const w2 = halfAxes.getColumn(2, scratchVectorW);
    const uHalf = u2.magnitude();
    const vHalf = v5.magnitude();
    const wHalf = w2.magnitude();
    u2.normalize();
    v5.normalize();
    w2.normalize();
    let distanceSquared = 0;
    let d2;
    d2 = Math.abs(offset.dot(u2)) - uHalf;
    if (d2 > 0) {
      distanceSquared += d2 * d2;
    }
    d2 = Math.abs(offset.dot(v5)) - vHalf;
    if (d2 > 0) {
      distanceSquared += d2 * d2;
    }
    d2 = Math.abs(offset.dot(w2)) - wHalf;
    if (d2 > 0) {
      distanceSquared += d2 * d2;
    }
    return distanceSquared;
  }
  /**
   * The distances calculated by the vector from the center of the bounding box
   * to position projected onto direction.
   *
   * - If you imagine the infinite number of planes with normal direction,
   *   this computes the smallest distance to the closest and farthest planes
   *   from `position` that intersect the bounding box.
   *
   * @param position The position to calculate the distance from.
   * @param direction The direction from position.
   * @param result An Interval (array of length 2) to store the nearest and farthest distances.
   * @returns Interval (array of length 2) with nearest and farthest distances
   *   on the bounding box from position in direction.
   */
  // eslint-disable-next-line max-statements
  computePlaneDistances(position, direction, result = [-0, -0]) {
    let minDist = Number.POSITIVE_INFINITY;
    let maxDist = Number.NEGATIVE_INFINITY;
    const center2 = this.center;
    const halfAxes = this.halfAxes;
    const u2 = halfAxes.getColumn(0, scratchVectorU);
    const v5 = halfAxes.getColumn(1, scratchVectorV);
    const w2 = halfAxes.getColumn(2, scratchVectorW);
    const corner = scratchCorner.copy(u2).add(v5).add(w2).add(center2);
    const toCenter = scratchToCenter.copy(corner).subtract(position);
    let mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    corner.copy(center2).add(u2).add(v5).subtract(w2);
    toCenter.copy(corner).subtract(position);
    mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    corner.copy(center2).add(u2).subtract(v5).add(w2);
    toCenter.copy(corner).subtract(position);
    mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    corner.copy(center2).add(u2).subtract(v5).subtract(w2);
    toCenter.copy(corner).subtract(position);
    mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    center2.copy(corner).subtract(u2).add(v5).add(w2);
    toCenter.copy(corner).subtract(position);
    mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    center2.copy(corner).subtract(u2).add(v5).subtract(w2);
    toCenter.copy(corner).subtract(position);
    mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    center2.copy(corner).subtract(u2).subtract(v5).add(w2);
    toCenter.copy(corner).subtract(position);
    mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    center2.copy(corner).subtract(u2).subtract(v5).subtract(w2);
    toCenter.copy(corner).subtract(position);
    mag = direction.dot(toCenter);
    minDist = Math.min(mag, minDist);
    maxDist = Math.max(mag, maxDist);
    result[0] = minDist;
    result[1] = maxDist;
    return result;
  }
  /**
   * Applies a 4x4 affine transformation matrix to a bounding sphere.
   * @param transform The transformation matrix to apply to the bounding sphere.
   * @returns itself, i.e. the modified BoundingVolume.
   */
  transform(transformation) {
    this.center.transformAsPoint(transformation);
    const xAxis = this.halfAxes.getColumn(0, scratchVectorU);
    xAxis.transformAsPoint(transformation);
    const yAxis = this.halfAxes.getColumn(1, scratchVectorV);
    yAxis.transformAsPoint(transformation);
    const zAxis = this.halfAxes.getColumn(2, scratchVectorW);
    zAxis.transformAsPoint(transformation);
    this.halfAxes = new Matrix3([...xAxis, ...yAxis, ...zAxis]);
    return this;
  }
  getTransform() {
    throw new Error("not implemented");
  }
}
const scratchPosition$2 = new Vector3();
const scratchNormal$3 = new Vector3();
class Plane {
  constructor(normal = [0, 0, 1], distance11 = 0) {
    this.normal = new Vector3();
    this.distance = -0;
    this.fromNormalDistance(normal, distance11);
  }
  /** Creates a plane from a normal and a distance from the origin. */
  fromNormalDistance(normal, distance11) {
    assert$9(Number.isFinite(distance11));
    this.normal.from(normal).normalize();
    this.distance = distance11;
    return this;
  }
  /** Creates a plane from a normal and a point on the plane. */
  fromPointNormal(point4, normal) {
    point4 = scratchPosition$2.from(point4);
    this.normal.from(normal).normalize();
    const distance11 = -this.normal.dot(point4);
    this.distance = distance11;
    return this;
  }
  /** Creates a plane from the general equation */
  fromCoefficients(a2, b2, c2, d2) {
    this.normal.set(a2, b2, c2);
    assert$9(equals$1(this.normal.len(), 1));
    this.distance = d2;
    return this;
  }
  /** Duplicates a Plane instance. */
  clone() {
    return new Plane(this.normal, this.distance);
  }
  /** Compares the provided Planes by normal and distance */
  equals(right) {
    return equals$1(this.distance, right.distance) && equals$1(this.normal, right.normal);
  }
  /** Computes the signed shortest distance of a point to a plane.
   * The sign of the distance determines which side of the plane the point is on.
   */
  getPointDistance(point4) {
    return this.normal.dot(point4) + this.distance;
  }
  /** Transforms the plane by the given transformation matrix. */
  transform(matrix4) {
    const normal = scratchNormal$3.copy(this.normal).transformAsVector(matrix4).normalize();
    const point4 = this.normal.scale(-this.distance).transform(matrix4);
    return this.fromPointNormal(point4, normal);
  }
  projectPointOntoPlane(point4, result = [0, 0, 0]) {
    const scratchPoint2 = scratchPosition$2.from(point4);
    const pointDistance = this.getPointDistance(scratchPoint2);
    const scaledNormal = scratchNormal$3.copy(this.normal).scale(pointDistance);
    return scratchPoint2.subtract(scaledNormal).to(result);
  }
}
const faces = [new Vector3([1, 0, 0]), new Vector3([0, 1, 0]), new Vector3([0, 0, 1])];
const scratchPlaneCenter = new Vector3();
const scratchPlaneNormal = new Vector3();
class CullingVolume {
  /**
   * Create a new `CullingVolume` bounded by an array of clipping planed
   * @param planes Array of clipping planes.
   * */
  constructor(planes = []) {
    this.planes = planes;
  }
  /**
   * Constructs a culling volume from a bounding sphere. Creates six planes that create a box containing the sphere.
   * The planes are aligned to the x, y, and z axes in world coordinates.
   */
  fromBoundingSphere(boundingSphere) {
    this.planes.length = 2 * faces.length;
    const center2 = boundingSphere.center;
    const radius = boundingSphere.radius;
    let planeIndex = 0;
    for (const faceNormal of faces) {
      let plane0 = this.planes[planeIndex];
      let plane1 = this.planes[planeIndex + 1];
      if (!plane0) {
        plane0 = this.planes[planeIndex] = new Plane();
      }
      if (!plane1) {
        plane1 = this.planes[planeIndex + 1] = new Plane();
      }
      const plane0Center = scratchPlaneCenter.copy(faceNormal).scale(-radius).add(center2);
      plane0.fromPointNormal(plane0Center, faceNormal);
      const plane1Center = scratchPlaneCenter.copy(faceNormal).scale(radius).add(center2);
      const negatedFaceNormal = scratchPlaneNormal.copy(faceNormal).negate();
      plane1.fromPointNormal(plane1Center, negatedFaceNormal);
      planeIndex += 2;
    }
    return this;
  }
  /** Determines whether a bounding volume intersects the culling volume. */
  computeVisibility(boundingVolume) {
    let intersect2 = INTERSECTION.INSIDE;
    for (const plane of this.planes) {
      const result = boundingVolume.intersectPlane(plane);
      switch (result) {
        case INTERSECTION.OUTSIDE:
          return INTERSECTION.OUTSIDE;
        case INTERSECTION.INTERSECTING:
          intersect2 = INTERSECTION.INTERSECTING;
          break;
      }
    }
    return intersect2;
  }
  /**
   * Determines whether a bounding volume intersects the culling volume.
   *
   * @param parentPlaneMask A bit mask from the boundingVolume's parent's check against the same culling
   *   volume, such that if (planeMask & (1 << planeIndex) === 0), for k < 31, then
   *   the parent (and therefore this) volume is completely inside plane[planeIndex]
   *   and that plane check can be skipped.
   */
  computeVisibilityWithPlaneMask(boundingVolume, parentPlaneMask) {
    assert$9(Number.isFinite(parentPlaneMask), "parentPlaneMask is required.");
    if (parentPlaneMask === CullingVolume.MASK_OUTSIDE || parentPlaneMask === CullingVolume.MASK_INSIDE) {
      return parentPlaneMask;
    }
    let mask = CullingVolume.MASK_INSIDE;
    const planes = this.planes;
    for (let k2 = 0; k2 < this.planes.length; ++k2) {
      const flag = k2 < 31 ? 1 << k2 : 0;
      if (k2 < 31 && (parentPlaneMask & flag) === 0) {
        continue;
      }
      const plane = planes[k2];
      const result = boundingVolume.intersectPlane(plane);
      if (result === INTERSECTION.OUTSIDE) {
        return CullingVolume.MASK_OUTSIDE;
      } else if (result === INTERSECTION.INTERSECTING) {
        mask |= flag;
      }
    }
    return mask;
  }
}
CullingVolume.MASK_OUTSIDE = 4294967295;
CullingVolume.MASK_INSIDE = 0;
CullingVolume.MASK_INDETERMINATE = 2147483647;
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
new Vector3();
const scratchMatrix = new Matrix3();
const scratchUnitary = new Matrix3();
const scratchDiagonal = new Matrix3();
const jMatrix = new Matrix3();
const jMatrixTranspose = new Matrix3();
function computeEigenDecomposition(matrix, result = {}) {
  const EIGEN_TOLERANCE = EPSILON20;
  const EIGEN_MAX_SWEEPS = 10;
  let count3 = 0;
  let sweep = 0;
  const unitaryMatrix = scratchUnitary;
  const diagonalMatrix = scratchDiagonal;
  unitaryMatrix.identity();
  diagonalMatrix.copy(matrix);
  const epsilon2 = EIGEN_TOLERANCE * computeFrobeniusNorm(diagonalMatrix);
  while (sweep < EIGEN_MAX_SWEEPS && offDiagonalFrobeniusNorm(diagonalMatrix) > epsilon2) {
    shurDecomposition(diagonalMatrix, jMatrix);
    jMatrixTranspose.copy(jMatrix).transpose();
    diagonalMatrix.multiplyRight(jMatrix);
    diagonalMatrix.multiplyLeft(jMatrixTranspose);
    unitaryMatrix.multiplyRight(jMatrix);
    if (++count3 > 2) {
      ++sweep;
      count3 = 0;
    }
  }
  result.unitary = unitaryMatrix.toTarget(result.unitary);
  result.diagonal = diagonalMatrix.toTarget(result.diagonal);
  return result;
}
function computeFrobeniusNorm(matrix) {
  let norm2 = 0;
  for (let i2 = 0; i2 < 9; ++i2) {
    const temp2 = matrix[i2];
    norm2 += temp2 * temp2;
  }
  return Math.sqrt(norm2);
}
const rowVal = [1, 0, 0];
const colVal = [2, 2, 1];
function offDiagonalFrobeniusNorm(matrix) {
  let norm2 = 0;
  for (let i2 = 0; i2 < 3; ++i2) {
    const temp2 = matrix[scratchMatrix.getElementIndex(colVal[i2], rowVal[i2])];
    norm2 += 2 * temp2 * temp2;
  }
  return Math.sqrt(norm2);
}
function shurDecomposition(matrix, result) {
  const tolerance = EPSILON15;
  let maxDiagonal = 0;
  let rotAxis = 1;
  for (let i2 = 0; i2 < 3; ++i2) {
    const temp2 = Math.abs(matrix[scratchMatrix.getElementIndex(colVal[i2], rowVal[i2])]);
    if (temp2 > maxDiagonal) {
      rotAxis = i2;
      maxDiagonal = temp2;
    }
  }
  const p2 = rowVal[rotAxis];
  const q2 = colVal[rotAxis];
  let c2 = 1;
  let s2 = 0;
  if (Math.abs(matrix[scratchMatrix.getElementIndex(q2, p2)]) > tolerance) {
    const qq = matrix[scratchMatrix.getElementIndex(q2, q2)];
    const pp = matrix[scratchMatrix.getElementIndex(p2, p2)];
    const qp = matrix[scratchMatrix.getElementIndex(q2, p2)];
    const tau2 = (qq - pp) / 2 / qp;
    let t2;
    if (tau2 < 0) {
      t2 = -1 / (-tau2 + Math.sqrt(1 + tau2 * tau2));
    } else {
      t2 = 1 / (tau2 + Math.sqrt(1 + tau2 * tau2));
    }
    c2 = 1 / Math.sqrt(1 + t2 * t2);
    s2 = t2 * c2;
  }
  Matrix3.IDENTITY.to(result);
  result[scratchMatrix.getElementIndex(p2, p2)] = result[scratchMatrix.getElementIndex(q2, q2)] = c2;
  result[scratchMatrix.getElementIndex(q2, p2)] = s2;
  result[scratchMatrix.getElementIndex(p2, q2)] = -s2;
  return result;
}
const scratchVector2$1 = new Vector3();
const scratchVector3$1 = new Vector3();
const scratchVector4 = new Vector3();
const scratchVector5 = new Vector3();
const scratchVector6 = new Vector3();
const scratchCovarianceResult = new Matrix3();
const scratchEigenResult = {
  diagonal: new Matrix3(),
  unitary: new Matrix3()
};
function makeOrientedBoundingBoxFromPoints(positions, result = new OrientedBoundingBox()) {
  if (!positions || positions.length === 0) {
    result.halfAxes = new Matrix3([0, 0, 0, 0, 0, 0, 0, 0, 0]);
    result.center = new Vector3();
    return result;
  }
  const length2 = positions.length;
  const meanPoint = new Vector3(0, 0, 0);
  for (const position of positions) {
    meanPoint.add(position);
  }
  const invLength = 1 / length2;
  meanPoint.multiplyByScalar(invLength);
  let exx = 0;
  let exy = 0;
  let exz = 0;
  let eyy = 0;
  let eyz = 0;
  let ezz = 0;
  for (const position of positions) {
    const p2 = scratchVector2$1.copy(position).subtract(meanPoint);
    exx += p2.x * p2.x;
    exy += p2.x * p2.y;
    exz += p2.x * p2.z;
    eyy += p2.y * p2.y;
    eyz += p2.y * p2.z;
    ezz += p2.z * p2.z;
  }
  exx *= invLength;
  exy *= invLength;
  exz *= invLength;
  eyy *= invLength;
  eyz *= invLength;
  ezz *= invLength;
  const covarianceMatrix = scratchCovarianceResult;
  covarianceMatrix[0] = exx;
  covarianceMatrix[1] = exy;
  covarianceMatrix[2] = exz;
  covarianceMatrix[3] = exy;
  covarianceMatrix[4] = eyy;
  covarianceMatrix[5] = eyz;
  covarianceMatrix[6] = exz;
  covarianceMatrix[7] = eyz;
  covarianceMatrix[8] = ezz;
  const { unitary } = computeEigenDecomposition(covarianceMatrix, scratchEigenResult);
  const rotation = result.halfAxes.copy(unitary);
  let v12 = rotation.getColumn(0, scratchVector4);
  let v22 = rotation.getColumn(1, scratchVector5);
  let v32 = rotation.getColumn(2, scratchVector6);
  let u1 = -Number.MAX_VALUE;
  let u2 = -Number.MAX_VALUE;
  let u3 = -Number.MAX_VALUE;
  let l1 = Number.MAX_VALUE;
  let l2 = Number.MAX_VALUE;
  let l3 = Number.MAX_VALUE;
  for (const position of positions) {
    scratchVector2$1.copy(position);
    u1 = Math.max(scratchVector2$1.dot(v12), u1);
    u2 = Math.max(scratchVector2$1.dot(v22), u2);
    u3 = Math.max(scratchVector2$1.dot(v32), u3);
    l1 = Math.min(scratchVector2$1.dot(v12), l1);
    l2 = Math.min(scratchVector2$1.dot(v22), l2);
    l3 = Math.min(scratchVector2$1.dot(v32), l3);
  }
  v12 = v12.multiplyByScalar(0.5 * (l1 + u1));
  v22 = v22.multiplyByScalar(0.5 * (l2 + u2));
  v32 = v32.multiplyByScalar(0.5 * (l3 + u3));
  result.center.copy(v12).add(v22).add(v32);
  const scale5 = scratchVector3$1.set(u1 - l1, u2 - l2, u3 - l3).multiplyByScalar(0.5);
  const scaleMatrix = new Matrix3([scale5[0], 0, 0, 0, scale5[1], 0, 0, 0, scale5[2]]);
  result.halfAxes.multiplyRight(scaleMatrix);
  return result;
}
const TILE_SIZE$1 = 512;
const MAX_MAPS = 3;
const REF_POINTS_5 = [
  [0.5, 0.5],
  [0, 0],
  [0, 1],
  [1, 0],
  [1, 1]
];
const REF_POINTS_9 = REF_POINTS_5.concat([
  [0, 0.5],
  [0.5, 0],
  [1, 0.5],
  [0.5, 1]
]);
const REF_POINTS_11 = REF_POINTS_9.concat([
  [0.25, 0.5],
  [0.75, 0.5]
]);
class OSMNode {
  constructor(x2, y2, z2) {
    this.x = x2;
    this.y = y2;
    this.z = z2;
  }
  get children() {
    if (!this._children) {
      const x2 = this.x * 2;
      const y2 = this.y * 2;
      const z2 = this.z + 1;
      this._children = [
        new OSMNode(x2, y2, z2),
        new OSMNode(x2, y2 + 1, z2),
        new OSMNode(x2 + 1, y2, z2),
        new OSMNode(x2 + 1, y2 + 1, z2)
      ];
    }
    return this._children;
  }
  // eslint-disable-next-line complexity
  update(params2) {
    const { viewport, cullingVolume: cullingVolume2, elevationBounds, minZ, maxZ, bounds, offset, project: project3 } = params2;
    const boundingVolume = this.getBoundingVolume(elevationBounds, offset, project3);
    if (bounds && !this.insideBounds(bounds)) {
      return false;
    }
    const isInside = cullingVolume2.computeVisibility(boundingVolume);
    if (isInside < 0) {
      return false;
    }
    if (!this.childVisible) {
      let { z: z2 } = this;
      if (z2 < maxZ && z2 >= minZ) {
        const distance11 = boundingVolume.distanceTo(viewport.cameraPosition) * viewport.scale / viewport.height;
        z2 += Math.floor(Math.log2(distance11));
      }
      if (z2 >= maxZ) {
        this.selected = true;
        return true;
      }
    }
    this.selected = false;
    this.childVisible = true;
    for (const child of this.children) {
      child.update(params2);
    }
    return true;
  }
  getSelected(result = []) {
    if (this.selected) {
      result.push(this);
    }
    if (this._children) {
      for (const node of this._children) {
        node.getSelected(result);
      }
    }
    return result;
  }
  insideBounds([minX2, minY2, maxX2, maxY2]) {
    const scale5 = Math.pow(2, this.z);
    const extent2 = TILE_SIZE$1 / scale5;
    return this.x * extent2 < maxX2 && this.y * extent2 < maxY2 && (this.x + 1) * extent2 > minX2 && (this.y + 1) * extent2 > minY2;
  }
  getBoundingVolume(zRange, worldOffset, project3) {
    if (project3) {
      const refPoints = this.z < 1 ? REF_POINTS_11 : this.z < 2 ? REF_POINTS_9 : REF_POINTS_5;
      const refPointPositions = [];
      for (const p2 of refPoints) {
        const lngLat = osmTile2lngLat(this.x + p2[0], this.y + p2[1], this.z);
        lngLat[2] = zRange[0];
        refPointPositions.push(project3(lngLat));
        if (zRange[0] !== zRange[1]) {
          lngLat[2] = zRange[1];
          refPointPositions.push(project3(lngLat));
        }
      }
      return makeOrientedBoundingBoxFromPoints(refPointPositions);
    }
    const scale5 = Math.pow(2, this.z);
    const extent2 = TILE_SIZE$1 / scale5;
    const originX = this.x * extent2 + worldOffset * TILE_SIZE$1;
    const originY = TILE_SIZE$1 - (this.y + 1) * extent2;
    return new AxisAlignedBoundingBox([originX, originY, zRange[0]], [originX + extent2, originY + extent2, zRange[1]]);
  }
}
function getOSMTileIndices(viewport, maxZ, zRange, bounds) {
  const project3 = viewport instanceof GlobeViewport && viewport.resolution ? (
    // eslint-disable-next-line @typescript-eslint/unbound-method
    viewport.projectPosition
  ) : null;
  const planes = Object.values(viewport.getFrustumPlanes()).map(({ normal, distance: distance11 }) => new Plane(normal.clone().negate(), distance11));
  const cullingVolume2 = new CullingVolume(planes);
  const unitsPerMeter2 = viewport.distanceScales.unitsPerMeter[2];
  const elevationMin = zRange && zRange[0] * unitsPerMeter2 || 0;
  const elevationMax = zRange && zRange[1] * unitsPerMeter2 || 0;
  const minZ = viewport instanceof WebMercatorViewport && viewport.pitch <= 60 ? maxZ : 0;
  if (bounds) {
    const [minLng, minLat, maxLng, maxLat] = bounds;
    const topLeft = lngLatToWorld([minLng, maxLat]);
    const bottomRight = lngLatToWorld([maxLng, minLat]);
    bounds = [topLeft[0], TILE_SIZE$1 - topLeft[1], bottomRight[0], TILE_SIZE$1 - bottomRight[1]];
  }
  const root2 = new OSMNode(0, 0, 0);
  const traversalParams = {
    viewport,
    project: project3,
    cullingVolume: cullingVolume2,
    elevationBounds: [elevationMin, elevationMax],
    minZ,
    maxZ,
    bounds,
    // num. of worlds from the center. For repeated maps
    offset: 0
  };
  root2.update(traversalParams);
  if (viewport instanceof WebMercatorViewport && viewport.subViewports && viewport.subViewports.length > 1) {
    traversalParams.offset = -1;
    while (root2.update(traversalParams)) {
      if (--traversalParams.offset < -MAX_MAPS) {
        break;
      }
    }
    traversalParams.offset = 1;
    while (root2.update(traversalParams)) {
      if (++traversalParams.offset > MAX_MAPS) {
        break;
      }
    }
  }
  return root2.getSelected();
}
const TILE_SIZE = 512;
const DEFAULT_EXTENT = [-Infinity, -Infinity, Infinity, Infinity];
const urlType = {
  type: "object",
  value: null,
  validate: (value, propType) => propType.optional && value === null || typeof value === "string" || Array.isArray(value) && value.every((url2) => typeof url2 === "string"),
  equal: (value1, value2) => {
    if (value1 === value2) {
      return true;
    }
    if (!Array.isArray(value1) || !Array.isArray(value2)) {
      return false;
    }
    const len2 = value1.length;
    if (len2 !== value2.length) {
      return false;
    }
    for (let i2 = 0; i2 < len2; i2++) {
      if (value1[i2] !== value2[i2]) {
        return false;
      }
    }
    return true;
  }
};
function transformBox(bbox2, modelMatrix2) {
  const transformedCoords = [
    // top-left
    modelMatrix2.transformAsPoint([bbox2[0], bbox2[1]]),
    // top-right
    modelMatrix2.transformAsPoint([bbox2[2], bbox2[1]]),
    // bottom-left
    modelMatrix2.transformAsPoint([bbox2[0], bbox2[3]]),
    // bottom-right
    modelMatrix2.transformAsPoint([bbox2[2], bbox2[3]])
  ];
  const transformedBox = [
    // Minimum x coord
    Math.min(...transformedCoords.map((i2) => i2[0])),
    // Minimum y coord
    Math.min(...transformedCoords.map((i2) => i2[1])),
    // Max x coord
    Math.max(...transformedCoords.map((i2) => i2[0])),
    // Max y coord
    Math.max(...transformedCoords.map((i2) => i2[1]))
  ];
  return transformedBox;
}
function stringHash(s2) {
  return Math.abs(s2.split("").reduce((a2, b2) => (a2 << 5) - a2 + b2.charCodeAt(0) | 0, 0));
}
function getURLFromTemplate(template, tile) {
  if (!template || !template.length) {
    return null;
  }
  const { index: index2, id } = tile;
  if (Array.isArray(template)) {
    const i2 = stringHash(id) % template.length;
    template = template[i2];
  }
  let url2 = template;
  for (const key of Object.keys(index2)) {
    const regex2 = new RegExp(`{${key}}`, "g");
    url2 = url2.replace(regex2, String(index2[key]));
  }
  if (Number.isInteger(index2.y) && Number.isInteger(index2.z)) {
    url2 = url2.replace(/\{-y\}/g, String(Math.pow(2, index2.z) - index2.y - 1));
  }
  return url2;
}
function getBoundingBox(viewport, zRange, extent2) {
  let bounds;
  if (zRange && zRange.length === 2) {
    const [minZ, maxZ] = zRange;
    const bounds0 = viewport.getBounds({ z: minZ });
    const bounds1 = viewport.getBounds({ z: maxZ });
    bounds = [
      Math.min(bounds0[0], bounds1[0]),
      Math.min(bounds0[1], bounds1[1]),
      Math.max(bounds0[2], bounds1[2]),
      Math.max(bounds0[3], bounds1[3])
    ];
  } else {
    bounds = viewport.getBounds();
  }
  if (!viewport.isGeospatial) {
    return [
      // Top corner should not be more then bottom corner in either direction
      Math.max(Math.min(bounds[0], extent2[2]), extent2[0]),
      Math.max(Math.min(bounds[1], extent2[3]), extent2[1]),
      // Bottom corner should not be less then top corner in either direction
      Math.min(Math.max(bounds[2], extent2[0]), extent2[2]),
      Math.min(Math.max(bounds[3], extent2[1]), extent2[3])
    ];
  }
  return [
    Math.max(bounds[0], extent2[0]),
    Math.max(bounds[1], extent2[1]),
    Math.min(bounds[2], extent2[2]),
    Math.min(bounds[3], extent2[3])
  ];
}
function getCullBounds({ viewport, z: z2, cullRect }) {
  const subViewports = viewport.subViewports || [viewport];
  return subViewports.map((v5) => getCullBoundsInViewport(v5, z2 || 0, cullRect));
}
function getCullBoundsInViewport(viewport, z2, cullRect) {
  if (!Array.isArray(z2)) {
    const x2 = cullRect.x - viewport.x;
    const y2 = cullRect.y - viewport.y;
    const { width, height } = cullRect;
    const unprojectOption = { targetZ: z2 };
    const topLeft = viewport.unproject([x2, y2], unprojectOption);
    const topRight = viewport.unproject([x2 + width, y2], unprojectOption);
    const bottomLeft = viewport.unproject([x2, y2 + height], unprojectOption);
    const bottomRight = viewport.unproject([x2 + width, y2 + height], unprojectOption);
    return [
      Math.min(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
      Math.min(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1]),
      Math.max(topLeft[0], topRight[0], bottomLeft[0], bottomRight[0]),
      Math.max(topLeft[1], topRight[1], bottomLeft[1], bottomRight[1])
    ];
  }
  const bounds0 = getCullBoundsInViewport(viewport, z2[0], cullRect);
  const bounds1 = getCullBoundsInViewport(viewport, z2[1], cullRect);
  return [
    Math.min(bounds0[0], bounds1[0]),
    Math.min(bounds0[1], bounds1[1]),
    Math.max(bounds0[2], bounds1[2]),
    Math.max(bounds0[3], bounds1[3])
  ];
}
function getIndexingCoords(bbox2, scale5, modelMatrixInverse) {
  if (modelMatrixInverse) {
    const transformedTileIndex = transformBox(bbox2, modelMatrixInverse).map((i2) => i2 * scale5 / TILE_SIZE);
    return transformedTileIndex;
  }
  return bbox2.map((i2) => i2 * scale5 / TILE_SIZE);
}
function getScale$1(z2, tileSize) {
  return Math.pow(2, z2) * TILE_SIZE / tileSize;
}
function osmTile2lngLat(x2, y2, z2) {
  const scale5 = getScale$1(z2, TILE_SIZE);
  const lng = x2 / scale5 * 360 - 180;
  const n2 = Math.PI - 2 * Math.PI * y2 / scale5;
  const lat = 180 / Math.PI * Math.atan(0.5 * (Math.exp(n2) - Math.exp(-n2)));
  return [lng, lat];
}
function tile2XY(x2, y2, z2, tileSize) {
  const scale5 = getScale$1(z2, tileSize);
  return [x2 / scale5 * TILE_SIZE, y2 / scale5 * TILE_SIZE];
}
function tileToBoundingBox(viewport, x2, y2, z2, tileSize = TILE_SIZE) {
  if (viewport.isGeospatial) {
    const [west, north] = osmTile2lngLat(x2, y2, z2);
    const [east, south] = osmTile2lngLat(x2 + 1, y2 + 1, z2);
    return { west, north, east, south };
  }
  const [left, top] = tile2XY(x2, y2, z2, tileSize);
  const [right, bottom] = tile2XY(x2 + 1, y2 + 1, z2, tileSize);
  return { left, top, right, bottom };
}
function getIdentityTileIndices(viewport, z2, tileSize, extent2, modelMatrixInverse) {
  const bbox2 = getBoundingBox(viewport, null, extent2);
  const scale5 = getScale$1(z2, tileSize);
  const [minX2, minY2, maxX2, maxY2] = getIndexingCoords(bbox2, scale5, modelMatrixInverse);
  const indices = [];
  for (let x2 = Math.floor(minX2); x2 < maxX2; x2++) {
    for (let y2 = Math.floor(minY2); y2 < maxY2; y2++) {
      indices.push({ x: x2, y: y2, z: z2 });
    }
  }
  return indices;
}
function getTileIndices({ viewport, maxZoom, minZoom, zRange, extent: extent2, tileSize = TILE_SIZE, modelMatrix: modelMatrix2, modelMatrixInverse, zoomOffset = 0 }) {
  let z2 = viewport.isGeospatial ? Math.round(viewport.zoom + Math.log2(TILE_SIZE / tileSize)) + zoomOffset : Math.ceil(viewport.zoom) + zoomOffset;
  if (typeof minZoom === "number" && Number.isFinite(minZoom) && z2 < minZoom) {
    if (!extent2) {
      return [];
    }
    z2 = minZoom;
  }
  if (typeof maxZoom === "number" && Number.isFinite(maxZoom) && z2 > maxZoom) {
    z2 = maxZoom;
  }
  let transformedExtent = extent2;
  if (modelMatrix2 && modelMatrixInverse && extent2 && !viewport.isGeospatial) {
    transformedExtent = transformBox(extent2, modelMatrix2);
  }
  return viewport.isGeospatial ? getOSMTileIndices(viewport, z2, zRange, extent2) : getIdentityTileIndices(viewport, z2, tileSize, transformedExtent || DEFAULT_EXTENT, modelMatrixInverse);
}
function isURLTemplate(s2) {
  return /(?=.*{z})(?=.*{x})(?=.*({y}|{-y}))/.test(s2);
}
function isGeoBoundingBox(v5) {
  return Number.isFinite(v5.west) && Number.isFinite(v5.north) && Number.isFinite(v5.east) && Number.isFinite(v5.south);
}
function memoize(compute2) {
  let cachedArgs = {};
  let cachedResult;
  return (args) => {
    for (const key in args) {
      if (!isEqual$2(args[key], cachedArgs[key])) {
        cachedResult = compute2(args);
        cachedArgs = args;
        break;
      }
    }
    return cachedResult;
  };
}
function isEqual$2(a2, b2) {
  if (a2 === b2) {
    return true;
  }
  if (Array.isArray(a2)) {
    const len2 = a2.length;
    if (!b2 || b2.length !== len2) {
      return false;
    }
    for (let i2 = 0; i2 < len2; i2++) {
      if (a2[i2] !== b2[i2]) {
        return false;
      }
    }
    return true;
  }
  return false;
}
const TILE_STATE_VISITED = 1;
const TILE_STATE_VISIBLE = 2;
const STRATEGY_NEVER = "never";
const STRATEGY_REPLACE = "no-overlap";
const STRATEGY_DEFAULT = "best-available";
const DEFAULT_CACHE_SCALE = 5;
const STRATEGIES = {
  [STRATEGY_DEFAULT]: updateTileStateDefault,
  [STRATEGY_REPLACE]: updateTileStateReplace,
  [STRATEGY_NEVER]: () => {
  }
};
const DEFAULT_TILESET2D_PROPS = {
  extent: null,
  tileSize: 512,
  maxZoom: null,
  minZoom: null,
  maxCacheSize: null,
  maxCacheByteSize: null,
  refinementStrategy: "best-available",
  zRange: null,
  maxRequests: 6,
  debounceTime: 0,
  zoomOffset: 0,
  // onTileLoad: (tile: Tile2DHeader) => void,  // onTileUnload: (tile: Tile2DHeader) => void,  // onTileError: (error: any, tile: Tile2DHeader) => void,  /** Called when all tiles in the current viewport are loaded. */
  // onViewportLoad: ((tiles: Tile2DHeader<DataT>[]) => void) | null,
  onTileLoad: () => {
  },
  onTileUnload: () => {
  },
  onTileError: () => {
  }
};
class Tileset2D {
  /**
   * Takes in a function that returns tile data, a cache size, and a max and a min zoom level.
   * Cache size defaults to 5 * number of tiles in the current viewport
   */
  constructor(opts) {
    this._getCullBounds = memoize(getCullBounds);
    this.opts = { ...DEFAULT_TILESET2D_PROPS, ...opts };
    this.setOptions(this.opts);
    this.onTileLoad = (tile) => {
      var _a3, _b3;
      (_b3 = (_a3 = this.opts).onTileLoad) == null ? void 0 : _b3.call(_a3, tile);
      if (this.opts.maxCacheByteSize) {
        this._cacheByteSize += tile.byteLength;
        this._resizeCache();
      }
    };
    this._requestScheduler = new RequestScheduler({
      throttleRequests: this.opts.maxRequests > 0 || this.opts.debounceTime > 0,
      maxRequests: this.opts.maxRequests,
      debounceTime: this.opts.debounceTime
    });
    this._cache = /* @__PURE__ */ new Map();
    this._tiles = [];
    this._dirty = false;
    this._cacheByteSize = 0;
    this._viewport = null;
    this._zRange = null;
    this._selectedTiles = null;
    this._frameNumber = 0;
    this._modelMatrix = new Matrix4();
    this._modelMatrixInverse = new Matrix4();
  }
  /* Public API */
  get tiles() {
    return this._tiles;
  }
  get selectedTiles() {
    return this._selectedTiles;
  }
  get isLoaded() {
    return this._selectedTiles !== null && this._selectedTiles.every((tile) => tile.isLoaded);
  }
  get needsReload() {
    return this._selectedTiles !== null && this._selectedTiles.some((tile) => tile.needsReload);
  }
  setOptions(opts) {
    Object.assign(this.opts, opts);
    if (Number.isFinite(opts.maxZoom)) {
      this._maxZoom = Math.floor(opts.maxZoom);
    }
    if (Number.isFinite(opts.minZoom)) {
      this._minZoom = Math.ceil(opts.minZoom);
    }
  }
  // Clean up any outstanding tile requests.
  finalize() {
    for (const tile of this._cache.values()) {
      if (tile.isLoading) {
        tile.abort();
      }
    }
    this._cache.clear();
    this._tiles = [];
    this._selectedTiles = null;
  }
  reloadAll() {
    for (const id of this._cache.keys()) {
      const tile = this._cache.get(id);
      if (!this._selectedTiles || !this._selectedTiles.includes(tile)) {
        this._cache.delete(id);
      } else {
        tile.setNeedsReload();
      }
    }
  }
  /**
   * Update the cache with the given viewport and model matrix and triggers callback onUpdate.
   */
  update(viewport, { zRange, modelMatrix: modelMatrix2 } = {
    zRange: null,
    modelMatrix: null
  }) {
    const modelMatrixAsMatrix4 = modelMatrix2 ? new Matrix4(modelMatrix2) : new Matrix4();
    const isModelMatrixNew = !modelMatrixAsMatrix4.equals(this._modelMatrix);
    if (!this._viewport || !viewport.equals(this._viewport) || !equals$1(this._zRange, zRange) || isModelMatrixNew) {
      if (isModelMatrixNew) {
        this._modelMatrixInverse = modelMatrixAsMatrix4.clone().invert();
        this._modelMatrix = modelMatrixAsMatrix4;
      }
      this._viewport = viewport;
      this._zRange = zRange;
      const tileIndices = this.getTileIndices({
        viewport,
        maxZoom: this._maxZoom,
        minZoom: this._minZoom,
        zRange,
        modelMatrix: this._modelMatrix,
        modelMatrixInverse: this._modelMatrixInverse
      });
      this._selectedTiles = tileIndices.map((index2) => this._getTile(index2, true));
      if (this._dirty) {
        this._rebuildTree();
      }
    } else if (this.needsReload) {
      this._selectedTiles = this._selectedTiles.map((tile) => this._getTile(tile.index, true));
    }
    const changed = this.updateTileStates();
    this._pruneRequests();
    if (this._dirty) {
      this._resizeCache();
    }
    if (changed) {
      this._frameNumber++;
    }
    return this._frameNumber;
  }
  // eslint-disable-next-line complexity
  isTileVisible(tile, cullRect) {
    if (!tile.isVisible) {
      return false;
    }
    if (cullRect && this._viewport) {
      const boundsArr = this._getCullBounds({
        viewport: this._viewport,
        z: this._zRange,
        cullRect
      });
      const { bbox: bbox2 } = tile;
      for (const [minX2, minY2, maxX2, maxY2] of boundsArr) {
        let overlaps;
        if ("west" in bbox2) {
          overlaps = bbox2.west < maxX2 && bbox2.east > minX2 && bbox2.south < maxY2 && bbox2.north > minY2;
        } else {
          const y02 = Math.min(bbox2.top, bbox2.bottom);
          const y12 = Math.max(bbox2.top, bbox2.bottom);
          overlaps = bbox2.left < maxX2 && bbox2.right > minX2 && y02 < maxY2 && y12 > minY2;
        }
        if (overlaps) {
          return true;
        }
      }
      return false;
    }
    return true;
  }
  /* Public interface for subclassing */
  /** Returns array of tile indices in the current viewport */
  getTileIndices({ viewport, maxZoom, minZoom, zRange, modelMatrix: modelMatrix2, modelMatrixInverse }) {
    const { tileSize, extent: extent2, zoomOffset } = this.opts;
    return getTileIndices({
      viewport,
      maxZoom,
      minZoom,
      zRange,
      tileSize,
      extent: extent2,
      modelMatrix: modelMatrix2,
      modelMatrixInverse,
      zoomOffset
    });
  }
  /** Returns unique string key for a tile index */
  getTileId(index2) {
    return `${index2.x}-${index2.y}-${index2.z}`;
  }
  /** Returns a zoom level for a tile index */
  getTileZoom(index2) {
    return index2.z;
  }
  /** Returns additional metadata to add to tile, bbox by default */
  getTileMetadata(index2) {
    const { tileSize } = this.opts;
    return { bbox: tileToBoundingBox(this._viewport, index2.x, index2.y, index2.z, tileSize) };
  }
  /** Returns index of the parent tile */
  getParentIndex(index2) {
    const x2 = Math.floor(index2.x / 2);
    const y2 = Math.floor(index2.y / 2);
    const z2 = index2.z - 1;
    return { x: x2, y: y2, z: z2 };
  }
  // Returns true if any tile's visibility changed
  updateTileStates() {
    const refinementStrategy = this.opts.refinementStrategy || STRATEGY_DEFAULT;
    const visibilities = new Array(this._cache.size);
    let i2 = 0;
    for (const tile of this._cache.values()) {
      visibilities[i2++] = tile.isVisible;
      tile.isSelected = false;
      tile.isVisible = false;
    }
    for (const tile of this._selectedTiles) {
      tile.isSelected = true;
      tile.isVisible = true;
    }
    (typeof refinementStrategy === "function" ? refinementStrategy : STRATEGIES[refinementStrategy])(Array.from(this._cache.values()));
    i2 = 0;
    for (const tile of this._cache.values()) {
      if (visibilities[i2++] !== tile.isVisible) {
        return true;
      }
    }
    return false;
  }
  _pruneRequests() {
    const { maxRequests = 0 } = this.opts;
    const abortCandidates = [];
    let ongoingRequestCount = 0;
    for (const tile of this._cache.values()) {
      if (tile.isLoading) {
        ongoingRequestCount++;
        if (!tile.isSelected && !tile.isVisible) {
          abortCandidates.push(tile);
        }
      }
    }
    while (maxRequests > 0 && ongoingRequestCount > maxRequests && abortCandidates.length > 0) {
      const tile = abortCandidates.shift();
      tile.abort();
      ongoingRequestCount--;
    }
  }
  // This needs to be called every time some tiles have been added/removed from cache
  _rebuildTree() {
    const { _cache } = this;
    for (const tile of _cache.values()) {
      tile.parent = null;
      if (tile.children) {
        tile.children.length = 0;
      }
    }
    for (const tile of _cache.values()) {
      const parent = this._getNearestAncestor(tile);
      tile.parent = parent;
      if (parent == null ? void 0 : parent.children) {
        parent.children.push(tile);
      }
    }
  }
  /**
   * Clear tiles that are not visible when the cache is full
   */
  /* eslint-disable complexity */
  _resizeCache() {
    var _a3, _b3;
    const { _cache, opts } = this;
    const maxCacheSize = opts.maxCacheSize || // @ts-expect-error called only when selectedTiles is initialized
    (opts.maxCacheByteSize ? Infinity : DEFAULT_CACHE_SCALE * this.selectedTiles.length);
    const maxCacheByteSize = opts.maxCacheByteSize || Infinity;
    const overflown = _cache.size > maxCacheSize || this._cacheByteSize > maxCacheByteSize;
    if (overflown) {
      for (const [id, tile] of _cache) {
        if (!tile.isVisible && !tile.isSelected) {
          this._cacheByteSize -= opts.maxCacheByteSize ? tile.byteLength : 0;
          _cache.delete(id);
          (_b3 = (_a3 = this.opts).onTileUnload) == null ? void 0 : _b3.call(_a3, tile);
        }
        if (_cache.size <= maxCacheSize && this._cacheByteSize <= maxCacheByteSize) {
          break;
        }
      }
      this._rebuildTree();
      this._dirty = true;
    }
    if (this._dirty) {
      this._tiles = Array.from(this._cache.values()).sort((t1, t2) => t1.zoom - t2.zoom);
      this._dirty = false;
    }
  }
  _getTile(index2, create5) {
    const id = this.getTileId(index2);
    let tile = this._cache.get(id);
    let needsReload = false;
    if (!tile && create5) {
      tile = new Tile2DHeader(index2);
      Object.assign(tile, this.getTileMetadata(tile.index));
      Object.assign(tile, { id, zoom: this.getTileZoom(tile.index) });
      needsReload = true;
      this._cache.set(id, tile);
      this._dirty = true;
    } else if (tile && tile.needsReload) {
      needsReload = true;
    }
    if (tile && needsReload) {
      tile.loadData({
        getData: this.opts.getTileData,
        requestScheduler: this._requestScheduler,
        onLoad: this.onTileLoad,
        onError: this.opts.onTileError
      });
    }
    return tile;
  }
  _getNearestAncestor(tile) {
    const { _minZoom = 0 } = this;
    let index2 = tile.index;
    while (this.getTileZoom(index2) > _minZoom) {
      index2 = this.getParentIndex(index2);
      const parent = this._getTile(index2);
      if (parent) {
        return parent;
      }
    }
    return null;
  }
}
function updateTileStateDefault(allTiles) {
  for (const tile of allTiles) {
    tile.state = 0;
  }
  for (const tile of allTiles) {
    if (tile.isSelected && !getPlaceholderInAncestors(tile)) {
      getPlaceholderInChildren(tile);
    }
  }
  for (const tile of allTiles) {
    tile.isVisible = Boolean(tile.state & TILE_STATE_VISIBLE);
  }
}
function updateTileStateReplace(allTiles) {
  for (const tile of allTiles) {
    tile.state = 0;
  }
  for (const tile of allTiles) {
    if (tile.isSelected) {
      getPlaceholderInAncestors(tile);
    }
  }
  const sortedTiles = Array.from(allTiles).sort((t1, t2) => t1.zoom - t2.zoom);
  for (const tile of sortedTiles) {
    tile.isVisible = Boolean(tile.state & TILE_STATE_VISIBLE);
    if (tile.children && (tile.isVisible || tile.state & TILE_STATE_VISITED)) {
      for (const child of tile.children) {
        child.state = TILE_STATE_VISITED;
      }
    } else if (tile.isSelected) {
      getPlaceholderInChildren(tile);
    }
  }
}
function getPlaceholderInAncestors(startTile) {
  let tile = startTile;
  while (tile) {
    if (tile.isLoaded || tile.content) {
      tile.state |= TILE_STATE_VISIBLE;
      return true;
    }
    tile = tile.parent;
  }
  return false;
}
function getPlaceholderInChildren(tile) {
  for (const child of tile.children) {
    if (child.isLoaded || child.content) {
      child.state |= TILE_STATE_VISIBLE;
    } else {
      getPlaceholderInChildren(child);
    }
  }
}
const defaultProps$a = {
  TilesetClass: Tileset2D,
  data: { type: "data", value: [] },
  dataComparator: urlType.equal,
  renderSubLayers: { type: "function", value: (props) => new GeoJsonLayer$1(props) },
  getTileData: { type: "function", optional: true, value: null },
  // TODO - change to onViewportLoad to align with Tile3DLayer
  onViewportLoad: { type: "function", optional: true, value: null },
  onTileLoad: { type: "function", value: (tile) => {
  } },
  onTileUnload: { type: "function", value: (tile) => {
  } },
  // eslint-disable-next-line
  onTileError: { type: "function", value: (err) => console.error(err) },
  extent: { type: "array", optional: true, value: null, compare: true },
  tileSize: 512,
  maxZoom: null,
  minZoom: 0,
  maxCacheSize: null,
  maxCacheByteSize: null,
  refinementStrategy: STRATEGY_DEFAULT,
  zRange: null,
  maxRequests: 6,
  debounceTime: 0,
  zoomOffset: 0
};
const _TileLayer = class extends CompositeLayer {
  initializeState() {
    this.state = {
      tileset: null,
      isLoaded: false
    };
  }
  finalizeState() {
    var _a3, _b3;
    (_b3 = (_a3 = this.state) == null ? void 0 : _a3.tileset) == null ? void 0 : _b3.finalize();
  }
  get isLoaded() {
    var _a3, _b3, _c2;
    return Boolean((_c2 = (_b3 = (_a3 = this.state) == null ? void 0 : _a3.tileset) == null ? void 0 : _b3.selectedTiles) == null ? void 0 : _c2.every((tile) => tile.isLoaded && tile.layers && tile.layers.every((layer) => layer.isLoaded)));
  }
  shouldUpdateState({ changeFlags }) {
    return changeFlags.somethingChanged;
  }
  updateState({ changeFlags }) {
    let { tileset } = this.state;
    const propsChanged = changeFlags.propsOrDataChanged || changeFlags.updateTriggersChanged;
    const dataChanged = changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getTileData);
    if (!tileset) {
      tileset = new this.props.TilesetClass(this._getTilesetOptions());
      this.setState({ tileset });
    } else if (propsChanged) {
      tileset.setOptions(this._getTilesetOptions());
      if (dataChanged) {
        tileset.reloadAll();
      } else {
        tileset.tiles.forEach((tile) => {
          tile.layers = null;
        });
      }
    }
    this._updateTileset();
  }
  _getTilesetOptions() {
    const { tileSize, maxCacheSize, maxCacheByteSize, refinementStrategy, extent: extent2, maxZoom, minZoom, maxRequests, debounceTime, zoomOffset } = this.props;
    return {
      maxCacheSize,
      maxCacheByteSize,
      maxZoom,
      minZoom,
      tileSize,
      refinementStrategy,
      extent: extent2,
      maxRequests,
      debounceTime,
      zoomOffset,
      getTileData: this.getTileData.bind(this),
      onTileLoad: this._onTileLoad.bind(this),
      onTileError: this._onTileError.bind(this),
      onTileUnload: this._onTileUnload.bind(this)
    };
  }
  _updateTileset() {
    const tileset = this.state.tileset;
    const { zRange, modelMatrix: modelMatrix2 } = this.props;
    const frameNumber = tileset.update(this.context.viewport, { zRange, modelMatrix: modelMatrix2 });
    const { isLoaded } = tileset;
    const loadingStateChanged = this.state.isLoaded !== isLoaded;
    const tilesetChanged = this.state.frameNumber !== frameNumber;
    if (isLoaded && (loadingStateChanged || tilesetChanged)) {
      this._onViewportLoad();
    }
    if (tilesetChanged) {
      this.setState({ frameNumber });
    }
    this.state.isLoaded = isLoaded;
  }
  _onViewportLoad() {
    const { tileset } = this.state;
    const { onViewportLoad } = this.props;
    if (onViewportLoad) {
      onViewportLoad(tileset.selectedTiles);
    }
  }
  _onTileLoad(tile) {
    this.props.onTileLoad(tile);
    tile.layers = null;
    this.setNeedsUpdate();
  }
  _onTileError(error2, tile) {
    this.props.onTileError(error2);
    tile.layers = null;
    this.setNeedsUpdate();
  }
  _onTileUnload(tile) {
    this.props.onTileUnload(tile);
  }
  // Methods for subclass to override
  getTileData(tile) {
    const { data: data2, getTileData, fetch: fetch2 } = this.props;
    const { signal } = tile;
    tile.url = typeof data2 === "string" || Array.isArray(data2) ? getURLFromTemplate(data2, tile) : null;
    if (getTileData) {
      return getTileData(tile);
    }
    if (fetch2 && tile.url) {
      return fetch2(tile.url, { propName: "data", layer: this, signal });
    }
    return null;
  }
  renderSubLayers(props) {
    return this.props.renderSubLayers(props);
  }
  getSubLayerPropsByTile(tile) {
    return null;
  }
  getPickingInfo(params2) {
    const sourceLayer = params2.sourceLayer;
    const sourceTile = sourceLayer.props.tile;
    const info = params2.info;
    if (info.picked) {
      info.tile = sourceTile;
    }
    info.sourceTile = sourceTile;
    info.sourceTileSubLayer = sourceLayer;
    return info;
  }
  _updateAutoHighlight(info) {
    info.sourceTileSubLayer.updateAutoHighlight(info);
  }
  renderLayers() {
    return this.state.tileset.tiles.map((tile) => {
      const subLayerProps = this.getSubLayerPropsByTile(tile);
      if (!tile.isLoaded && !tile.content)
        ;
      else if (!tile.layers) {
        const layers = this.renderSubLayers({
          ...this.props,
          ...this.getSubLayerProps({
            id: tile.id,
            updateTriggers: this.props.updateTriggers
          }),
          data: tile.content,
          _offset: 0,
          tile
        });
        tile.layers = flatten$2(layers, Boolean).map((layer) => layer.clone({
          tile,
          ...subLayerProps
        }));
      } else if (subLayerProps && tile.layers[0] && Object.keys(subLayerProps).some((propName2) => tile.layers[0].props[propName2] !== subLayerProps[propName2])) {
        tile.layers = tile.layers.map((layer) => layer.clone(subLayerProps));
      }
      return tile.layers;
    });
  }
  filterSubLayer({ layer, cullRect }) {
    const { tile } = layer.props;
    return this.state.tileset.isTileVisible(tile, cullRect);
  }
};
let TileLayer = _TileLayer;
(() => {
  _TileLayer.defaultProps = defaultProps$a;
})();
(() => {
  _TileLayer.layerName = "TileLayer";
})();
var libh3 = function(libh32) {
  libh32 = libh32 || {};
  var Module = typeof libh32 !== "undefined" ? libh32 : {};
  var moduleOverrides = {};
  var key;
  for (key in Module) {
    if (Module.hasOwnProperty(key)) {
      moduleOverrides[key] = Module[key];
    }
  }
  var scriptDirectory = "";
  function locateFile(path2) {
    if (Module["locateFile"]) {
      return Module["locateFile"](path2, scriptDirectory);
    }
    return scriptDirectory + path2;
  }
  var readAsync;
  {
    if (typeof document !== "undefined" && document.currentScript) {
      scriptDirectory = document.currentScript.src;
    }
    if (scriptDirectory.indexOf("blob:") !== 0) {
      scriptDirectory = scriptDirectory.substr(0, scriptDirectory.lastIndexOf("/") + 1);
    } else {
      scriptDirectory = "";
    }
    readAsync = function readAsync2(url2, onload, onerror) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url2, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = function xhr_onload() {
        if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
          onload(xhr.response);
          return;
        }
        var data2 = tryParseAsDataURI(url2);
        if (data2) {
          onload(data2.buffer);
          return;
        }
        onerror();
      };
      xhr.onerror = onerror;
      xhr.send(null);
    };
  }
  var out = Module["print"] || console.log.bind(console);
  var err = Module["printErr"] || console.warn.bind(console);
  for (key in moduleOverrides) {
    if (moduleOverrides.hasOwnProperty(key)) {
      Module[key] = moduleOverrides[key];
    }
  }
  moduleOverrides = null;
  if (Module["arguments"]) {
    Module["arguments"];
  }
  var tempRet0 = 0;
  var setTempRet0 = function(value) {
    tempRet0 = value;
  };
  var getTempRet0 = function() {
    return tempRet0;
  };
  var GLOBAL_BASE = 8;
  function setValue2(ptr, value, type, noSafe) {
    type = type || "i8";
    if (type.charAt(type.length - 1) === "*") {
      type = "i32";
    }
    switch (type) {
      case "i1":
        HEAP8[ptr >> 0] = value;
        break;
      case "i8":
        HEAP8[ptr >> 0] = value;
        break;
      case "i16":
        HEAP16[ptr >> 1] = value;
        break;
      case "i32":
        HEAP32[ptr >> 2] = value;
        break;
      case "i64":
        tempI64 = [value >>> 0, (tempDouble = value, +Math_abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math_min(+Math_floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];
        break;
      case "float":
        HEAPF32[ptr >> 2] = value;
        break;
      case "double":
        HEAPF64[ptr >> 3] = value;
        break;
      default:
        abort2("invalid type for setValue: " + type);
    }
  }
  function getValue2(ptr, type, noSafe) {
    type = type || "i8";
    if (type.charAt(type.length - 1) === "*") {
      type = "i32";
    }
    switch (type) {
      case "i1":
        return HEAP8[ptr >> 0];
      case "i8":
        return HEAP8[ptr >> 0];
      case "i16":
        return HEAP16[ptr >> 1];
      case "i32":
        return HEAP32[ptr >> 2];
      case "i64":
        return HEAP32[ptr >> 2];
      case "float":
        return HEAPF32[ptr >> 2];
      case "double":
        return HEAPF64[ptr >> 3];
      default:
        abort2("invalid type for getValue: " + type);
    }
    return null;
  }
  var ABORT = false;
  function assert2(condition, text) {
    if (!condition) {
      abort2("Assertion failed: " + text);
    }
  }
  function getCFunc(ident) {
    var func2 = Module["_" + ident];
    assert2(func2, "Cannot call unknown function " + ident + ", make sure it is exported");
    return func2;
  }
  function ccall(ident, returnType, argTypes, args, opts) {
    var toC = {
      "string": function(str) {
        var ret2 = 0;
        if (str !== null && str !== void 0 && str !== 0) {
          var len2 = (str.length << 2) + 1;
          ret2 = stackAlloc(len2);
          stringToUTF8(str, ret2, len2);
        }
        return ret2;
      },
      "array": function(arr) {
        var ret2 = stackAlloc(arr.length);
        writeArrayToMemory(arr, ret2);
        return ret2;
      }
    };
    function convertReturnValue(ret2) {
      if (returnType === "string") {
        return UTF8ToString(ret2);
      }
      if (returnType === "boolean") {
        return Boolean(ret2);
      }
      return ret2;
    }
    var func2 = getCFunc(ident);
    var cArgs = [];
    var stack2 = 0;
    if (args) {
      for (var i2 = 0; i2 < args.length; i2++) {
        var converter = toC[argTypes[i2]];
        if (converter) {
          if (stack2 === 0) {
            stack2 = stackSave();
          }
          cArgs[i2] = converter(args[i2]);
        } else {
          cArgs[i2] = args[i2];
        }
      }
    }
    var ret = func2.apply(null, cArgs);
    ret = convertReturnValue(ret);
    if (stack2 !== 0) {
      stackRestore(stack2);
    }
    return ret;
  }
  function cwrap(ident, returnType, argTypes, opts) {
    argTypes = argTypes || [];
    var numericArgs = argTypes.every(function(type) {
      return type === "number";
    });
    var numericRet = returnType !== "string";
    if (numericRet && numericArgs && !opts) {
      return getCFunc(ident);
    }
    return function() {
      return ccall(ident, returnType, argTypes, arguments);
    };
  }
  var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : void 0;
  function UTF8ArrayToString(u8Array, idx, maxBytesToRead) {
    var endIdx = idx + maxBytesToRead;
    var endPtr = idx;
    while (u8Array[endPtr] && !(endPtr >= endIdx)) {
      ++endPtr;
    }
    if (endPtr - idx > 16 && u8Array.subarray && UTF8Decoder) {
      return UTF8Decoder.decode(u8Array.subarray(idx, endPtr));
    } else {
      var str = "";
      while (idx < endPtr) {
        var u0 = u8Array[idx++];
        if (!(u0 & 128)) {
          str += String.fromCharCode(u0);
          continue;
        }
        var u1 = u8Array[idx++] & 63;
        if ((u0 & 224) == 192) {
          str += String.fromCharCode((u0 & 31) << 6 | u1);
          continue;
        }
        var u2 = u8Array[idx++] & 63;
        if ((u0 & 240) == 224) {
          u0 = (u0 & 15) << 12 | u1 << 6 | u2;
        } else {
          u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | u8Array[idx++] & 63;
        }
        if (u0 < 65536) {
          str += String.fromCharCode(u0);
        } else {
          var ch2 = u0 - 65536;
          str += String.fromCharCode(55296 | ch2 >> 10, 56320 | ch2 & 1023);
        }
      }
    }
    return str;
  }
  function UTF8ToString(ptr, maxBytesToRead) {
    return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
  }
  function stringToUTF8Array(str, outU8Array, outIdx, maxBytesToWrite) {
    if (!(maxBytesToWrite > 0)) {
      return 0;
    }
    var startIdx = outIdx;
    var endIdx = outIdx + maxBytesToWrite - 1;
    for (var i2 = 0; i2 < str.length; ++i2) {
      var u2 = str.charCodeAt(i2);
      if (u2 >= 55296 && u2 <= 57343) {
        var u1 = str.charCodeAt(++i2);
        u2 = 65536 + ((u2 & 1023) << 10) | u1 & 1023;
      }
      if (u2 <= 127) {
        if (outIdx >= endIdx) {
          break;
        }
        outU8Array[outIdx++] = u2;
      } else if (u2 <= 2047) {
        if (outIdx + 1 >= endIdx) {
          break;
        }
        outU8Array[outIdx++] = 192 | u2 >> 6;
        outU8Array[outIdx++] = 128 | u2 & 63;
      } else if (u2 <= 65535) {
        if (outIdx + 2 >= endIdx) {
          break;
        }
        outU8Array[outIdx++] = 224 | u2 >> 12;
        outU8Array[outIdx++] = 128 | u2 >> 6 & 63;
        outU8Array[outIdx++] = 128 | u2 & 63;
      } else {
        if (outIdx + 3 >= endIdx) {
          break;
        }
        outU8Array[outIdx++] = 240 | u2 >> 18;
        outU8Array[outIdx++] = 128 | u2 >> 12 & 63;
        outU8Array[outIdx++] = 128 | u2 >> 6 & 63;
        outU8Array[outIdx++] = 128 | u2 & 63;
      }
    }
    outU8Array[outIdx] = 0;
    return outIdx - startIdx;
  }
  function stringToUTF8(str, outPtr, maxBytesToWrite) {
    return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
  }
  typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : void 0;
  function writeArrayToMemory(array2, buffer4) {
    HEAP8.set(array2, buffer4);
  }
  function alignUp(x2, multiple) {
    if (x2 % multiple > 0) {
      x2 += multiple - x2 % multiple;
    }
    return x2;
  }
  var buffer3, HEAP8, HEAPU8, HEAP16, HEAP32, HEAPF32, HEAPF64;
  function updateGlobalBufferAndViews(buf) {
    buffer3 = buf;
    Module["HEAP8"] = HEAP8 = new Int8Array(buf);
    Module["HEAP16"] = HEAP16 = new Int16Array(buf);
    Module["HEAP32"] = HEAP32 = new Int32Array(buf);
    Module["HEAPU8"] = HEAPU8 = new Uint8Array(buf);
    Module["HEAPU16"] = new Uint16Array(buf);
    Module["HEAPU32"] = new Uint32Array(buf);
    Module["HEAPF32"] = HEAPF32 = new Float32Array(buf);
    Module["HEAPF64"] = HEAPF64 = new Float64Array(buf);
  }
  var DYNAMIC_BASE = 5267040, DYNAMICTOP_PTR = 24128;
  var INITIAL_TOTAL_MEMORY = Module["TOTAL_MEMORY"] || 33554432;
  if (Module["buffer"]) {
    buffer3 = Module["buffer"];
  } else {
    buffer3 = new ArrayBuffer(INITIAL_TOTAL_MEMORY);
  }
  INITIAL_TOTAL_MEMORY = buffer3.byteLength;
  updateGlobalBufferAndViews(buffer3);
  HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;
  function callRuntimeCallbacks(callbacks2) {
    while (callbacks2.length > 0) {
      var callback = callbacks2.shift();
      if (typeof callback == "function") {
        callback();
        continue;
      }
      var func2 = callback.func;
      if (typeof func2 === "number") {
        if (callback.arg === void 0) {
          Module["dynCall_v"](func2);
        } else {
          Module["dynCall_vi"](func2, callback.arg);
        }
      } else {
        func2(callback.arg === void 0 ? null : callback.arg);
      }
    }
  }
  var __ATPRERUN__ = [];
  var __ATINIT__ = [];
  var __ATMAIN__ = [];
  var __ATPOSTRUN__ = [];
  function preRun() {
    if (Module["preRun"]) {
      if (typeof Module["preRun"] == "function") {
        Module["preRun"] = [Module["preRun"]];
      }
      while (Module["preRun"].length) {
        addOnPreRun(Module["preRun"].shift());
      }
    }
    callRuntimeCallbacks(__ATPRERUN__);
  }
  function initRuntime() {
    callRuntimeCallbacks(__ATINIT__);
  }
  function preMain() {
    callRuntimeCallbacks(__ATMAIN__);
  }
  function postRun() {
    if (Module["postRun"]) {
      if (typeof Module["postRun"] == "function") {
        Module["postRun"] = [Module["postRun"]];
      }
      while (Module["postRun"].length) {
        addOnPostRun(Module["postRun"].shift());
      }
    }
    callRuntimeCallbacks(__ATPOSTRUN__);
  }
  function addOnPreRun(cb2) {
    __ATPRERUN__.unshift(cb2);
  }
  function addOnPostRun(cb2) {
    __ATPOSTRUN__.unshift(cb2);
  }
  var Math_abs = Math.abs;
  var Math_ceil = Math.ceil;
  var Math_floor = Math.floor;
  var Math_min = Math.min;
  var runDependencies = 0;
  var dependenciesFulfilled = null;
  function addRunDependency(id) {
    runDependencies++;
    if (Module["monitorRunDependencies"]) {
      Module["monitorRunDependencies"](runDependencies);
    }
  }
  function removeRunDependency(id) {
    runDependencies--;
    if (Module["monitorRunDependencies"]) {
      Module["monitorRunDependencies"](runDependencies);
    }
    if (runDependencies == 0) {
      if (dependenciesFulfilled) {
        var callback = dependenciesFulfilled;
        dependenciesFulfilled = null;
        callback();
      }
    }
  }
  Module["preloadedImages"] = {};
  Module["preloadedAudios"] = {};
  var memoryInitializer = null;
  var dataURIPrefix = "data:application/octet-stream;base64,";
  function isDataURI(filename2) {
    return String.prototype.startsWith ? filename2.startsWith(dataURIPrefix) : filename2.indexOf(dataURIPrefix) === 0;
  }
  var tempDouble;
  var tempI64;
  memoryInitializer = "data:application/octet-stream;base64,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";
  var tempDoublePtr = 24144;
  function demangle(func2) {
    return func2;
  }
  function demangleAll(text) {
    var regex2 = /\b__Z[\w\d_]+/g;
    return text.replace(regex2, function(x2) {
      var y2 = demangle(x2);
      return x2 === y2 ? x2 : y2 + " [" + x2 + "]";
    });
  }
  function jsStackTrace() {
    var err2 = new Error();
    if (!err2.stack) {
      try {
        throw new Error(0);
      } catch (e3) {
        err2 = e3;
      }
      if (!err2.stack) {
        return "(no stack trace available)";
      }
    }
    return err2.stack.toString();
  }
  function stackTrace() {
    var js2 = jsStackTrace();
    if (Module["extraStackTrace"]) {
      js2 += "\n" + Module["extraStackTrace"]();
    }
    return demangleAll(js2);
  }
  function ___assert_fail(condition, filename2, line, func2) {
    abort2("Assertion failed: " + UTF8ToString(condition) + ", at: " + [filename2 ? UTF8ToString(filename2) : "unknown filename", line, func2 ? UTF8ToString(func2) : "unknown function"]);
  }
  function _emscripten_get_heap_size() {
    return HEAP8.length;
  }
  function _emscripten_memcpy_big(dest, src2, num) {
    HEAPU8.set(HEAPU8.subarray(src2, src2 + num), dest);
  }
  function ___setErrNo(value) {
    if (Module["___errno_location"]) {
      HEAP32[Module["___errno_location"]() >> 2] = value;
    }
    return value;
  }
  function abortOnCannotGrowMemory(requestedSize) {
    abort2("OOM");
  }
  function emscripten_realloc_buffer(size12) {
    try {
      var newBuffer = new ArrayBuffer(size12);
      if (newBuffer.byteLength != size12) {
        return;
      }
      new Int8Array(newBuffer).set(HEAP8);
      _emscripten_replace_memory(newBuffer);
      updateGlobalBufferAndViews(newBuffer);
      return 1;
    } catch (e3) {
    }
  }
  function _emscripten_resize_heap(requestedSize) {
    var oldSize = _emscripten_get_heap_size();
    var PAGE_MULTIPLE = 16777216;
    var LIMIT = 2147483648 - PAGE_MULTIPLE;
    if (requestedSize > LIMIT) {
      return false;
    }
    var MIN_TOTAL_MEMORY = 16777216;
    var newSize = Math.max(oldSize, MIN_TOTAL_MEMORY);
    while (newSize < requestedSize) {
      if (newSize <= 536870912) {
        newSize = alignUp(2 * newSize, PAGE_MULTIPLE);
      } else {
        newSize = Math.min(alignUp((3 * newSize + 2147483648) / 4, PAGE_MULTIPLE), LIMIT);
      }
    }
    var replacement = emscripten_realloc_buffer(newSize);
    if (!replacement) {
      return false;
    }
    return true;
  }
  var decodeBase64 = typeof atob === "function" ? atob : function(input) {
    var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var output2 = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i2 = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
    do {
      enc1 = keyStr.indexOf(input.charAt(i2++));
      enc2 = keyStr.indexOf(input.charAt(i2++));
      enc3 = keyStr.indexOf(input.charAt(i2++));
      enc4 = keyStr.indexOf(input.charAt(i2++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output2 = output2 + String.fromCharCode(chr1);
      if (enc3 !== 64) {
        output2 = output2 + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output2 = output2 + String.fromCharCode(chr3);
      }
    } while (i2 < input.length);
    return output2;
  };
  function intArrayFromBase64(s2) {
    try {
      var decoded = decodeBase64(s2);
      var bytes = new Uint8Array(decoded.length);
      for (var i2 = 0; i2 < decoded.length; ++i2) {
        bytes[i2] = decoded.charCodeAt(i2);
      }
      return bytes;
    } catch (_2) {
      throw new Error("Converting base64 string to bytes failed.");
    }
  }
  function tryParseAsDataURI(filename2) {
    if (!isDataURI(filename2)) {
      return;
    }
    return intArrayFromBase64(filename2.slice(dataURIPrefix.length));
  }
  var asmGlobalArg = {
    "Math": Math,
    "Int8Array": Int8Array,
    "Int32Array": Int32Array,
    "Uint8Array": Uint8Array,
    "Float32Array": Float32Array,
    "Float64Array": Float64Array
  };
  var asmLibraryArg = {
    "a": abort2,
    "b": setTempRet0,
    "c": getTempRet0,
    "d": ___assert_fail,
    "e": ___setErrNo,
    "f": _emscripten_get_heap_size,
    "g": _emscripten_memcpy_big,
    "h": _emscripten_resize_heap,
    "i": abortOnCannotGrowMemory,
    "j": demangle,
    "k": demangleAll,
    "l": emscripten_realloc_buffer,
    "m": jsStackTrace,
    "n": stackTrace,
    "o": tempDoublePtr,
    "p": DYNAMICTOP_PTR
  };
  var asm = (
    /** @suppress {uselessCode} */
    function(global2, env, buffer4) {
      "almost asm";
      var a2 = new global2.Int8Array(buffer4), b2 = new global2.Int32Array(buffer4);
      new global2.Uint8Array(buffer4);
      new global2.Float32Array(buffer4);
      var e3 = new global2.Float64Array(buffer4), f2 = env.o | 0, g2 = env.p | 0, p2 = global2.Math.floor, q2 = global2.Math.abs, r2 = global2.Math.sqrt, s2 = global2.Math.pow, t2 = global2.Math.cos, u2 = global2.Math.sin, v5 = global2.Math.tan, w2 = global2.Math.acos, x2 = global2.Math.asin, y2 = global2.Math.atan, z2 = global2.Math.atan2, A2 = global2.Math.ceil, B2 = global2.Math.imul, C2 = global2.Math.min, D2 = global2.Math.max, E3 = global2.Math.clz32, G2 = env.b, H2 = env.c, I2 = env.d, J2 = env.e, K2 = env.f, L2 = env.g, M2 = env.h, N2 = env.i, T2 = 24160;
      function W2(newBuffer) {
        a2 = new Int8Array(newBuffer);
        b2 = new Int32Array(newBuffer);
        e3 = new Float64Array(newBuffer);
        buffer4 = newBuffer;
        return true;
      }
      function X2(a3) {
        a3 = a3 | 0;
        var b3 = 0;
        b3 = T2;
        T2 = T2 + a3 | 0;
        T2 = T2 + 15 & -16;
        return b3 | 0;
      }
      function Y2() {
        return T2 | 0;
      }
      function Z2(a3) {
        a3 = a3 | 0;
        T2 = a3;
      }
      function _2(a3, b3) {
        a3 = a3 | 0;
        T2 = a3;
      }
      function $(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0;
        if ((a3 | 0) < 0) {
          c2 = 2;
          return c2 | 0;
        }
        if ((a3 | 0) > 13780509) {
          c2 = ic(15, c2) | 0;
          return c2 | 0;
        } else {
          d2 = ((a3 | 0) < 0) << 31 >> 31;
          f3 = rd(a3 | 0, d2 | 0, 3, 0) | 0;
          e4 = H2() | 0;
          d2 = ld(a3 | 0, d2 | 0, 1, 0) | 0;
          d2 = rd(f3 | 0, e4 | 0, d2 | 0, H2() | 0) | 0;
          d2 = ld(d2 | 0, H2() | 0, 1, 0) | 0;
          a3 = H2() | 0;
          b2[c2 >> 2] = d2;
          b2[c2 + 4 >> 2] = a3;
          c2 = 0;
          return c2 | 0;
        }
      }
      function aa2(a3, b3, c2, d2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        return ba2(a3, b3, c2, d2, 0) | 0;
      }
      function ba2(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0;
        j2 = T2;
        T2 = T2 + 16 | 0;
        h2 = j2;
        if (!(ca2(a3, c2, d2, e4, f3) | 0)) {
          e4 = 0;
          T2 = j2;
          return e4 | 0;
        }
        do {
          if ((d2 | 0) >= 0) {
            if ((d2 | 0) > 13780509) {
              g3 = ic(15, h2) | 0;
              if (g3 | 0) {
                break;
              }
              i2 = h2;
              h2 = b2[i2 >> 2] | 0;
              i2 = b2[i2 + 4 >> 2] | 0;
            } else {
              g3 = ((d2 | 0) < 0) << 31 >> 31;
              k2 = rd(d2 | 0, g3 | 0, 3, 0) | 0;
              i2 = H2() | 0;
              g3 = ld(d2 | 0, g3 | 0, 1, 0) | 0;
              g3 = rd(k2 | 0, i2 | 0, g3 | 0, H2() | 0) | 0;
              g3 = ld(g3 | 0, H2() | 0, 1, 0) | 0;
              i2 = H2() | 0;
              b2[h2 >> 2] = g3;
              b2[h2 + 4 >> 2] = i2;
              h2 = g3;
            }
            Bd(e4 | 0, 0, h2 << 3 | 0) | 0;
            if (f3 | 0) {
              Bd(f3 | 0, 0, h2 << 2 | 0) | 0;
              g3 = da(a3, c2, d2, e4, f3, h2, i2, 0) | 0;
              break;
            }
            g3 = kd(h2, 4) | 0;
            if (!g3) {
              g3 = 13;
            } else {
              k2 = da(a3, c2, d2, e4, g3, h2, i2, 0) | 0;
              jd(g3);
              g3 = k2;
            }
          } else {
            g3 = 2;
          }
        } while (0);
        k2 = g3;
        T2 = j2;
        return k2 | 0;
      }
      function ca2(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0;
        q3 = T2;
        T2 = T2 + 16 | 0;
        o2 = q3;
        p3 = q3 + 8 | 0;
        n2 = o2;
        b2[n2 >> 2] = a3;
        b2[n2 + 4 >> 2] = c2;
        if ((d2 | 0) < 0) {
          p3 = 2;
          T2 = q3;
          return p3 | 0;
        }
        g3 = e4;
        b2[g3 >> 2] = a3;
        b2[g3 + 4 >> 2] = c2;
        g3 = (f3 | 0) != 0;
        if (g3) {
          b2[f3 >> 2] = 0;
        }
        if (xb(a3, c2) | 0) {
          p3 = 9;
          T2 = q3;
          return p3 | 0;
        }
        b2[p3 >> 2] = 0;
        a:
          do {
            if ((d2 | 0) >= 1) {
              if (g3) {
                l2 = 1;
                k2 = 0;
                m2 = 0;
                n2 = 1;
                g3 = a3;
                while (1) {
                  if (!(k2 | m2)) {
                    g3 = ea(g3, c2, 4, p3, o2) | 0;
                    if (g3 | 0) {
                      break a;
                    }
                    c2 = o2;
                    g3 = b2[c2 >> 2] | 0;
                    c2 = b2[c2 + 4 >> 2] | 0;
                    if (xb(g3, c2) | 0) {
                      g3 = 9;
                      break a;
                    }
                  }
                  g3 = ea(g3, c2, b2[22384 + (m2 << 2) >> 2] | 0, p3, o2) | 0;
                  if (g3 | 0) {
                    break a;
                  }
                  c2 = o2;
                  g3 = b2[c2 >> 2] | 0;
                  c2 = b2[c2 + 4 >> 2] | 0;
                  a3 = e4 + (l2 << 3) | 0;
                  b2[a3 >> 2] = g3;
                  b2[a3 + 4 >> 2] = c2;
                  b2[f3 + (l2 << 2) >> 2] = n2;
                  a3 = k2 + 1 | 0;
                  h2 = (a3 | 0) == (n2 | 0);
                  i2 = m2 + 1 | 0;
                  j2 = (i2 | 0) == 6;
                  if (xb(g3, c2) | 0) {
                    g3 = 9;
                    break a;
                  }
                  n2 = n2 + (j2 & h2 & 1) | 0;
                  if ((n2 | 0) > (d2 | 0)) {
                    g3 = 0;
                    break;
                  } else {
                    l2 = l2 + 1 | 0;
                    k2 = h2 ? 0 : a3;
                    m2 = h2 ? j2 ? 0 : i2 : m2;
                  }
                }
              } else {
                l2 = 1;
                k2 = 0;
                m2 = 0;
                n2 = 1;
                g3 = a3;
                while (1) {
                  if (!(k2 | m2)) {
                    g3 = ea(g3, c2, 4, p3, o2) | 0;
                    if (g3 | 0) {
                      break a;
                    }
                    c2 = o2;
                    g3 = b2[c2 >> 2] | 0;
                    c2 = b2[c2 + 4 >> 2] | 0;
                    if (xb(g3, c2) | 0) {
                      g3 = 9;
                      break a;
                    }
                  }
                  g3 = ea(g3, c2, b2[22384 + (m2 << 2) >> 2] | 0, p3, o2) | 0;
                  if (g3 | 0) {
                    break a;
                  }
                  c2 = o2;
                  g3 = b2[c2 >> 2] | 0;
                  c2 = b2[c2 + 4 >> 2] | 0;
                  a3 = e4 + (l2 << 3) | 0;
                  b2[a3 >> 2] = g3;
                  b2[a3 + 4 >> 2] = c2;
                  a3 = k2 + 1 | 0;
                  h2 = (a3 | 0) == (n2 | 0);
                  i2 = m2 + 1 | 0;
                  j2 = (i2 | 0) == 6;
                  if (xb(g3, c2) | 0) {
                    g3 = 9;
                    break a;
                  }
                  n2 = n2 + (j2 & h2 & 1) | 0;
                  if ((n2 | 0) > (d2 | 0)) {
                    g3 = 0;
                    break;
                  } else {
                    l2 = l2 + 1 | 0;
                    k2 = h2 ? 0 : a3;
                    m2 = h2 ? j2 ? 0 : i2 : m2;
                  }
                }
              }
            } else {
              g3 = 0;
            }
          } while (0);
        p3 = g3;
        T2 = q3;
        return p3 | 0;
      }
      function da(a3, c2, d2, e4, f3, g3, h2, i2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        h2 = h2 | 0;
        i2 = i2 | 0;
        var j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0;
        q3 = T2;
        T2 = T2 + 16 | 0;
        o2 = q3 + 8 | 0;
        p3 = q3;
        j2 = td(a3 | 0, c2 | 0, g3 | 0, h2 | 0) | 0;
        l2 = H2() | 0;
        m2 = e4 + (j2 << 3) | 0;
        r3 = m2;
        s3 = b2[r3 >> 2] | 0;
        r3 = b2[r3 + 4 >> 2] | 0;
        k2 = (s3 | 0) == (a3 | 0) & (r3 | 0) == (c2 | 0);
        if (!((s3 | 0) == 0 & (r3 | 0) == 0 | k2)) {
          do {
            j2 = ld(j2 | 0, l2 | 0, 1, 0) | 0;
            j2 = sd(j2 | 0, H2() | 0, g3 | 0, h2 | 0) | 0;
            l2 = H2() | 0;
            m2 = e4 + (j2 << 3) | 0;
            s3 = m2;
            r3 = b2[s3 >> 2] | 0;
            s3 = b2[s3 + 4 >> 2] | 0;
            k2 = (r3 | 0) == (a3 | 0) & (s3 | 0) == (c2 | 0);
          } while (!((r3 | 0) == 0 & (s3 | 0) == 0 | k2));
        }
        j2 = f3 + (j2 << 2) | 0;
        if (k2 ? (b2[j2 >> 2] | 0) <= (i2 | 0) : 0) {
          s3 = 0;
          T2 = q3;
          return s3 | 0;
        }
        s3 = m2;
        b2[s3 >> 2] = a3;
        b2[s3 + 4 >> 2] = c2;
        b2[j2 >> 2] = i2;
        if ((i2 | 0) >= (d2 | 0)) {
          s3 = 0;
          T2 = q3;
          return s3 | 0;
        }
        k2 = i2 + 1 | 0;
        b2[o2 >> 2] = 0;
        j2 = ea(a3, c2, 2, o2, p3) | 0;
        switch (j2 | 0) {
          case 9: {
            n2 = 9;
            break;
          }
          case 0: {
            j2 = p3;
            j2 = da(b2[j2 >> 2] | 0, b2[j2 + 4 >> 2] | 0, d2, e4, f3, g3, h2, k2) | 0;
            if (!j2) {
              n2 = 9;
            }
            break;
          }
        }
        a:
          do {
            if ((n2 | 0) == 9) {
              b2[o2 >> 2] = 0;
              j2 = ea(a3, c2, 3, o2, p3) | 0;
              switch (j2 | 0) {
                case 9:
                  break;
                case 0: {
                  j2 = p3;
                  j2 = da(b2[j2 >> 2] | 0, b2[j2 + 4 >> 2] | 0, d2, e4, f3, g3, h2, k2) | 0;
                  if (j2 | 0) {
                    break a;
                  }
                  break;
                }
                default:
                  break a;
              }
              b2[o2 >> 2] = 0;
              j2 = ea(a3, c2, 1, o2, p3) | 0;
              switch (j2 | 0) {
                case 9:
                  break;
                case 0: {
                  j2 = p3;
                  j2 = da(b2[j2 >> 2] | 0, b2[j2 + 4 >> 2] | 0, d2, e4, f3, g3, h2, k2) | 0;
                  if (j2 | 0) {
                    break a;
                  }
                  break;
                }
                default:
                  break a;
              }
              b2[o2 >> 2] = 0;
              j2 = ea(a3, c2, 5, o2, p3) | 0;
              switch (j2 | 0) {
                case 9:
                  break;
                case 0: {
                  j2 = p3;
                  j2 = da(b2[j2 >> 2] | 0, b2[j2 + 4 >> 2] | 0, d2, e4, f3, g3, h2, k2) | 0;
                  if (j2 | 0) {
                    break a;
                  }
                  break;
                }
                default:
                  break a;
              }
              b2[o2 >> 2] = 0;
              j2 = ea(a3, c2, 4, o2, p3) | 0;
              switch (j2 | 0) {
                case 9:
                  break;
                case 0: {
                  j2 = p3;
                  j2 = da(b2[j2 >> 2] | 0, b2[j2 + 4 >> 2] | 0, d2, e4, f3, g3, h2, k2) | 0;
                  if (j2 | 0) {
                    break a;
                  }
                  break;
                }
                default:
                  break a;
              }
              b2[o2 >> 2] = 0;
              j2 = ea(a3, c2, 6, o2, p3) | 0;
              switch (j2 | 0) {
                case 9:
                  break;
                case 0: {
                  j2 = p3;
                  j2 = da(b2[j2 >> 2] | 0, b2[j2 + 4 >> 2] | 0, d2, e4, f3, g3, h2, k2) | 0;
                  if (j2 | 0) {
                    break a;
                  }
                  break;
                }
                default:
                  break a;
              }
              s3 = 0;
              T2 = q3;
              return s3 | 0;
            }
          } while (0);
        s3 = j2;
        T2 = q3;
        return s3 | 0;
      }
      function ea(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0;
        if (d2 >>> 0 > 6) {
          f3 = 1;
          return f3 | 0;
        }
        m2 = (b2[e4 >> 2] | 0) % 6 | 0;
        b2[e4 >> 2] = m2;
        if ((m2 | 0) > 0) {
          g3 = 0;
          do {
            d2 = Sa(d2) | 0;
            g3 = g3 + 1 | 0;
          } while ((g3 | 0) < (b2[e4 >> 2] | 0));
        }
        m2 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        l2 = m2 & 127;
        if (l2 >>> 0 > 121) {
          f3 = 5;
          return f3 | 0;
        }
        j2 = Fb(a3, c2) | 0;
        g3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        g3 = g3 & 15;
        a:
          do {
            if (!g3) {
              k2 = 8;
            } else {
              while (1) {
                h2 = (15 - g3 | 0) * 3 | 0;
                i2 = vd(a3 | 0, c2 | 0, h2 | 0) | 0;
                H2() | 0;
                i2 = i2 & 7;
                if ((i2 | 0) == 7) {
                  c2 = 5;
                  break;
                }
                p3 = (Lb(g3) | 0) == 0;
                g3 = g3 + -1 | 0;
                n2 = wd(7, 0, h2 | 0) | 0;
                c2 = c2 & ~(H2() | 0);
                o2 = wd(b2[(p3 ? 432 : 16) + (i2 * 28 | 0) + (d2 << 2) >> 2] | 0, 0, h2 | 0) | 0;
                h2 = H2() | 0;
                d2 = b2[(p3 ? 640 : 224) + (i2 * 28 | 0) + (d2 << 2) >> 2] | 0;
                a3 = o2 | a3 & ~n2;
                c2 = h2 | c2;
                if (!d2) {
                  d2 = 0;
                  break a;
                }
                if (!g3) {
                  k2 = 8;
                  break a;
                }
              }
              return c2 | 0;
            }
          } while (0);
        if ((k2 | 0) == 8) {
          p3 = b2[848 + (l2 * 28 | 0) + (d2 << 2) >> 2] | 0;
          o2 = wd(p3 | 0, 0, 45) | 0;
          a3 = o2 | a3;
          c2 = H2() | 0 | c2 & -1040385;
          d2 = b2[4272 + (l2 * 28 | 0) + (d2 << 2) >> 2] | 0;
          if ((p3 & 127 | 0) == 127) {
            p3 = wd(b2[848 + (l2 * 28 | 0) + 20 >> 2] | 0, 0, 45) | 0;
            c2 = H2() | 0 | c2 & -1040385;
            d2 = b2[4272 + (l2 * 28 | 0) + 20 >> 2] | 0;
            a3 = Hb(p3 | a3, c2) | 0;
            c2 = H2() | 0;
            b2[e4 >> 2] = (b2[e4 >> 2] | 0) + 1;
          }
        }
        i2 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        i2 = i2 & 127;
        b:
          do {
            if (!(ma(i2) | 0)) {
              if ((d2 | 0) > 0) {
                g3 = 0;
                do {
                  a3 = Hb(a3, c2) | 0;
                  c2 = H2() | 0;
                  g3 = g3 + 1 | 0;
                } while ((g3 | 0) != (d2 | 0));
              }
            } else {
              c:
                do {
                  if ((Fb(a3, c2) | 0) == 1) {
                    if ((l2 | 0) != (i2 | 0)) {
                      if (sa(i2, b2[7696 + (l2 * 28 | 0) >> 2] | 0) | 0) {
                        a3 = Jb(a3, c2) | 0;
                        h2 = 1;
                        c2 = H2() | 0;
                        break;
                      } else {
                        I2(23313, 22416, 436, 22424);
                      }
                    }
                    switch (j2 | 0) {
                      case 3: {
                        a3 = Hb(a3, c2) | 0;
                        c2 = H2() | 0;
                        b2[e4 >> 2] = (b2[e4 >> 2] | 0) + 1;
                        h2 = 0;
                        break c;
                      }
                      case 5: {
                        a3 = Jb(a3, c2) | 0;
                        c2 = H2() | 0;
                        b2[e4 >> 2] = (b2[e4 >> 2] | 0) + 5;
                        h2 = 0;
                        break c;
                      }
                      case 0: {
                        p3 = 9;
                        return p3 | 0;
                      }
                      default: {
                        p3 = 1;
                        return p3 | 0;
                      }
                    }
                  } else {
                    h2 = 0;
                  }
                } while (0);
              if ((d2 | 0) > 0) {
                g3 = 0;
                do {
                  a3 = Gb(a3, c2) | 0;
                  c2 = H2() | 0;
                  g3 = g3 + 1 | 0;
                } while ((g3 | 0) != (d2 | 0));
              }
              if ((l2 | 0) != (i2 | 0)) {
                if (!(na(i2) | 0)) {
                  if ((h2 | 0) != 0 | (Fb(a3, c2) | 0) != 5) {
                    break;
                  }
                  b2[e4 >> 2] = (b2[e4 >> 2] | 0) + 1;
                  break;
                }
                switch (m2 & 127) {
                  case 8:
                  case 118:
                    break b;
                }
                if ((Fb(a3, c2) | 0) != 3) {
                  b2[e4 >> 2] = (b2[e4 >> 2] | 0) + 1;
                }
              }
            }
          } while (0);
        b2[e4 >> 2] = ((b2[e4 >> 2] | 0) + d2 | 0) % 6 | 0;
        p3 = f3;
        b2[p3 >> 2] = a3;
        b2[p3 + 4 >> 2] = c2;
        p3 = 0;
        return p3 | 0;
      }
      function fa(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0;
        i2 = T2;
        T2 = T2 + 16 | 0;
        g3 = i2;
        h2 = i2 + 8 | 0;
        f3 = (xb(a3, c2) | 0) == 0;
        f3 = f3 ? 1 : 2;
        while (1) {
          b2[h2 >> 2] = 0;
          k2 = (ea(a3, c2, f3, h2, g3) | 0) == 0;
          j2 = g3;
          if (k2 & ((b2[j2 >> 2] | 0) == (d2 | 0) ? (b2[j2 + 4 >> 2] | 0) == (e4 | 0) : 0)) {
            a3 = 4;
            break;
          }
          f3 = f3 + 1 | 0;
          if (f3 >>> 0 >= 7) {
            f3 = 7;
            a3 = 4;
            break;
          }
        }
        if ((a3 | 0) == 4) {
          T2 = i2;
          return f3 | 0;
        }
        return 0;
      }
      function ga(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0;
        p3 = T2;
        T2 = T2 + 16 | 0;
        n2 = p3;
        o2 = p3 + 8 | 0;
        m2 = n2;
        b2[m2 >> 2] = a3;
        b2[m2 + 4 >> 2] = c2;
        if (!d2) {
          o2 = e4;
          b2[o2 >> 2] = a3;
          b2[o2 + 4 >> 2] = c2;
          o2 = 0;
          T2 = p3;
          return o2 | 0;
        }
        b2[o2 >> 2] = 0;
        a:
          do {
            if (!(xb(a3, c2) | 0)) {
              g3 = (d2 | 0) > 0;
              if (g3) {
                f3 = 0;
                m2 = a3;
                do {
                  a3 = ea(m2, c2, 4, o2, n2) | 0;
                  if (a3 | 0) {
                    break a;
                  }
                  c2 = n2;
                  m2 = b2[c2 >> 2] | 0;
                  c2 = b2[c2 + 4 >> 2] | 0;
                  f3 = f3 + 1 | 0;
                  if (xb(m2, c2) | 0) {
                    a3 = 9;
                    break a;
                  }
                } while ((f3 | 0) < (d2 | 0));
                l2 = e4;
                b2[l2 >> 2] = m2;
                b2[l2 + 4 >> 2] = c2;
                l2 = d2 + -1 | 0;
                if (g3) {
                  k2 = 0;
                  a3 = 1;
                  do {
                    f3 = 22384 + (k2 << 2) | 0;
                    if ((k2 | 0) == 5) {
                      h2 = b2[f3 >> 2] | 0;
                      g3 = 0;
                      f3 = a3;
                      while (1) {
                        a3 = n2;
                        a3 = ea(b2[a3 >> 2] | 0, b2[a3 + 4 >> 2] | 0, h2, o2, n2) | 0;
                        if (a3 | 0) {
                          break a;
                        }
                        if ((g3 | 0) != (l2 | 0)) {
                          j2 = n2;
                          i2 = b2[j2 >> 2] | 0;
                          j2 = b2[j2 + 4 >> 2] | 0;
                          a3 = e4 + (f3 << 3) | 0;
                          b2[a3 >> 2] = i2;
                          b2[a3 + 4 >> 2] = j2;
                          if (!(xb(i2, j2) | 0)) {
                            a3 = f3 + 1 | 0;
                          } else {
                            a3 = 9;
                            break a;
                          }
                        } else {
                          a3 = f3;
                        }
                        g3 = g3 + 1 | 0;
                        if ((g3 | 0) >= (d2 | 0)) {
                          break;
                        } else {
                          f3 = a3;
                        }
                      }
                    } else {
                      h2 = n2;
                      j2 = b2[f3 >> 2] | 0;
                      i2 = 0;
                      f3 = a3;
                      g3 = b2[h2 >> 2] | 0;
                      h2 = b2[h2 + 4 >> 2] | 0;
                      while (1) {
                        a3 = ea(g3, h2, j2, o2, n2) | 0;
                        if (a3 | 0) {
                          break a;
                        }
                        h2 = n2;
                        g3 = b2[h2 >> 2] | 0;
                        h2 = b2[h2 + 4 >> 2] | 0;
                        a3 = e4 + (f3 << 3) | 0;
                        b2[a3 >> 2] = g3;
                        b2[a3 + 4 >> 2] = h2;
                        a3 = f3 + 1 | 0;
                        if (xb(g3, h2) | 0) {
                          a3 = 9;
                          break a;
                        }
                        i2 = i2 + 1 | 0;
                        if ((i2 | 0) >= (d2 | 0)) {
                          break;
                        } else {
                          f3 = a3;
                        }
                      }
                    }
                    k2 = k2 + 1 | 0;
                  } while (k2 >>> 0 < 6);
                  a3 = n2;
                  h2 = m2;
                  f3 = b2[a3 >> 2] | 0;
                  g3 = c2;
                  a3 = b2[a3 + 4 >> 2] | 0;
                } else {
                  h2 = m2;
                  f3 = m2;
                  g3 = c2;
                  a3 = c2;
                }
              } else {
                h2 = e4;
                b2[h2 >> 2] = a3;
                b2[h2 + 4 >> 2] = c2;
                h2 = a3;
                f3 = a3;
                g3 = c2;
                a3 = c2;
              }
              a3 = (h2 | 0) == (f3 | 0) & (g3 | 0) == (a3 | 0) ? 0 : 9;
            } else {
              a3 = 9;
            }
          } while (0);
        o2 = a3;
        T2 = p3;
        return o2 | 0;
      }
      function ha(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0;
        i2 = T2;
        T2 = T2 + 48 | 0;
        f3 = i2 + 16 | 0;
        g3 = i2 + 8 | 0;
        h2 = i2;
        if (d2 | 0) {
          h2 = 15;
          T2 = i2;
          return h2 | 0;
        }
        k2 = a3;
        j2 = b2[k2 + 4 >> 2] | 0;
        d2 = g3;
        b2[d2 >> 2] = b2[k2 >> 2];
        b2[d2 + 4 >> 2] = j2;
        Ec(g3, f3);
        c2 = za(f3, c2, h2) | 0;
        if (!c2) {
          d2 = b2[g3 >> 2] | 0;
          g3 = b2[a3 + 8 >> 2] | 0;
          if ((g3 | 0) > 0) {
            f3 = b2[a3 + 12 >> 2] | 0;
            c2 = 0;
            do {
              d2 = (b2[f3 + (c2 << 3) >> 2] | 0) + d2 | 0;
              c2 = c2 + 1 | 0;
            } while ((c2 | 0) < (g3 | 0));
          }
          c2 = h2;
          f3 = b2[c2 >> 2] | 0;
          c2 = b2[c2 + 4 >> 2] | 0;
          g3 = ((d2 | 0) < 0) << 31 >> 31;
          if ((c2 | 0) < (g3 | 0) | (c2 | 0) == (g3 | 0) & f3 >>> 0 < d2 >>> 0) {
            c2 = h2;
            b2[c2 >> 2] = d2;
            b2[c2 + 4 >> 2] = g3;
            c2 = g3;
          } else {
            d2 = f3;
          }
          j2 = ld(d2 | 0, c2 | 0, 12, 0) | 0;
          k2 = H2() | 0;
          c2 = h2;
          b2[c2 >> 2] = j2;
          b2[c2 + 4 >> 2] = k2;
          c2 = e4;
          b2[c2 >> 2] = j2;
          b2[c2 + 4 >> 2] = k2;
          c2 = 0;
        }
        k2 = c2;
        T2 = i2;
        return k2 | 0;
      }
      function ia(a3, c2, d2, f3, g3, h2, i2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        h2 = h2 | 0;
        i2 = i2 | 0;
        var j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0, A3 = 0, B3 = 0, C3 = 0, D3 = 0, E4 = 0, F2 = 0, G3 = 0, I3 = 0, J3 = 0, K3 = 0, L3 = 0, M3 = 0;
        I3 = T2;
        T2 = T2 + 64 | 0;
        D3 = I3 + 48 | 0;
        E4 = I3 + 32 | 0;
        F2 = I3 + 24 | 0;
        x3 = I3 + 8 | 0;
        y3 = I3;
        k2 = b2[a3 >> 2] | 0;
        if ((k2 | 0) <= 0) {
          G3 = 0;
          T2 = I3;
          return G3 | 0;
        }
        z3 = a3 + 4 | 0;
        A3 = D3 + 8 | 0;
        B3 = E4 + 8 | 0;
        C3 = x3 + 8 | 0;
        j2 = 0;
        v6 = 0;
        while (1) {
          l2 = b2[z3 >> 2] | 0;
          u3 = l2 + (v6 << 4) | 0;
          b2[D3 >> 2] = b2[u3 >> 2];
          b2[D3 + 4 >> 2] = b2[u3 + 4 >> 2];
          b2[D3 + 8 >> 2] = b2[u3 + 8 >> 2];
          b2[D3 + 12 >> 2] = b2[u3 + 12 >> 2];
          if ((v6 | 0) == (k2 + -1 | 0)) {
            b2[E4 >> 2] = b2[l2 >> 2];
            b2[E4 + 4 >> 2] = b2[l2 + 4 >> 2];
            b2[E4 + 8 >> 2] = b2[l2 + 8 >> 2];
            b2[E4 + 12 >> 2] = b2[l2 + 12 >> 2];
          } else {
            u3 = l2 + (v6 + 1 << 4) | 0;
            b2[E4 >> 2] = b2[u3 >> 2];
            b2[E4 + 4 >> 2] = b2[u3 + 4 >> 2];
            b2[E4 + 8 >> 2] = b2[u3 + 8 >> 2];
            b2[E4 + 12 >> 2] = b2[u3 + 12 >> 2];
          }
          k2 = Aa(D3, E4, f3, F2) | 0;
          a:
            do {
              if (!k2) {
                l2 = F2;
                k2 = b2[l2 >> 2] | 0;
                l2 = b2[l2 + 4 >> 2] | 0;
                if ((l2 | 0) > 0 | (l2 | 0) == 0 & k2 >>> 0 > 0) {
                  t3 = 0;
                  u3 = 0;
                  b:
                    while (1) {
                      M3 = +e3[D3 >> 3];
                      s3 = md(k2 | 0, l2 | 0, t3 | 0, u3 | 0) | 0;
                      L3 = +(s3 >>> 0) + 4294967296 * +(H2() | 0);
                      J3 = +(k2 >>> 0) + 4294967296 * +(l2 | 0);
                      K3 = +(t3 >>> 0) + 4294967296 * +(u3 | 0);
                      e3[x3 >> 3] = M3 * L3 / J3 + +e3[E4 >> 3] * K3 / J3;
                      e3[C3 >> 3] = +e3[A3 >> 3] * L3 / J3 + +e3[B3 >> 3] * K3 / J3;
                      k2 = Mb(x3, f3, y3) | 0;
                      if (k2 | 0) {
                        j2 = k2;
                        break;
                      }
                      s3 = y3;
                      r3 = b2[s3 >> 2] | 0;
                      s3 = b2[s3 + 4 >> 2] | 0;
                      o2 = td(r3 | 0, s3 | 0, c2 | 0, d2 | 0) | 0;
                      m2 = H2() | 0;
                      k2 = i2 + (o2 << 3) | 0;
                      n2 = k2;
                      l2 = b2[n2 >> 2] | 0;
                      n2 = b2[n2 + 4 >> 2] | 0;
                      c:
                        do {
                          if ((l2 | 0) == 0 & (n2 | 0) == 0) {
                            w3 = k2;
                            G3 = 16;
                          } else {
                            p3 = 0;
                            q3 = 0;
                            while (1) {
                              if ((p3 | 0) > (d2 | 0) | (p3 | 0) == (d2 | 0) & q3 >>> 0 > c2 >>> 0) {
                                j2 = 1;
                                break b;
                              }
                              if ((l2 | 0) == (r3 | 0) & (n2 | 0) == (s3 | 0)) {
                                break c;
                              }
                              k2 = ld(o2 | 0, m2 | 0, 1, 0) | 0;
                              o2 = sd(k2 | 0, H2() | 0, c2 | 0, d2 | 0) | 0;
                              m2 = H2() | 0;
                              q3 = ld(q3 | 0, p3 | 0, 1, 0) | 0;
                              p3 = H2() | 0;
                              k2 = i2 + (o2 << 3) | 0;
                              n2 = k2;
                              l2 = b2[n2 >> 2] | 0;
                              n2 = b2[n2 + 4 >> 2] | 0;
                              if ((l2 | 0) == 0 & (n2 | 0) == 0) {
                                w3 = k2;
                                G3 = 16;
                                break;
                              }
                            }
                          }
                        } while (0);
                      if ((G3 | 0) == 16 ? (G3 = 0, !((r3 | 0) == 0 & (s3 | 0) == 0)) : 0) {
                        q3 = w3;
                        b2[q3 >> 2] = r3;
                        b2[q3 + 4 >> 2] = s3;
                        q3 = h2 + (b2[g3 >> 2] << 3) | 0;
                        b2[q3 >> 2] = r3;
                        b2[q3 + 4 >> 2] = s3;
                        q3 = g3;
                        q3 = ld(b2[q3 >> 2] | 0, b2[q3 + 4 >> 2] | 0, 1, 0) | 0;
                        r3 = H2() | 0;
                        s3 = g3;
                        b2[s3 >> 2] = q3;
                        b2[s3 + 4 >> 2] = r3;
                      }
                      t3 = ld(t3 | 0, u3 | 0, 1, 0) | 0;
                      u3 = H2() | 0;
                      l2 = F2;
                      k2 = b2[l2 >> 2] | 0;
                      l2 = b2[l2 + 4 >> 2] | 0;
                      if (!((l2 | 0) > (u3 | 0) | (l2 | 0) == (u3 | 0) & k2 >>> 0 > t3 >>> 0)) {
                        l2 = 1;
                        break a;
                      }
                    }
                  l2 = 0;
                } else {
                  l2 = 1;
                }
              } else {
                l2 = 0;
                j2 = k2;
              }
            } while (0);
          v6 = v6 + 1 | 0;
          if (!l2) {
            G3 = 21;
            break;
          }
          k2 = b2[a3 >> 2] | 0;
          if ((v6 | 0) >= (k2 | 0)) {
            j2 = 0;
            G3 = 21;
            break;
          }
        }
        if ((G3 | 0) == 21) {
          T2 = I3;
          return j2 | 0;
        }
        return 0;
      }
      function ja(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0, A3 = 0, B3 = 0, C3 = 0, D3 = 0, E4 = 0, F2 = 0, G3 = 0, I3 = 0, J3 = 0, K3 = 0;
        K3 = T2;
        T2 = T2 + 112 | 0;
        F2 = K3 + 80 | 0;
        j2 = K3 + 72 | 0;
        G3 = K3;
        I3 = K3 + 56 | 0;
        if (d2 | 0) {
          J3 = 15;
          T2 = K3;
          return J3 | 0;
        }
        k2 = a3 + 8 | 0;
        J3 = id((b2[k2 >> 2] << 5) + 32 | 0) | 0;
        if (!J3) {
          J3 = 13;
          T2 = K3;
          return J3 | 0;
        }
        Fc(a3, J3);
        D3 = a3;
        E4 = b2[D3 + 4 >> 2] | 0;
        d2 = j2;
        b2[d2 >> 2] = b2[D3 >> 2];
        b2[d2 + 4 >> 2] = E4;
        Ec(j2, F2);
        d2 = za(F2, c2, G3) | 0;
        if (!d2) {
          d2 = b2[j2 >> 2] | 0;
          g3 = b2[k2 >> 2] | 0;
          if ((g3 | 0) > 0) {
            h2 = b2[a3 + 12 >> 2] | 0;
            f3 = 0;
            do {
              d2 = (b2[h2 + (f3 << 3) >> 2] | 0) + d2 | 0;
              f3 = f3 + 1 | 0;
            } while ((f3 | 0) != (g3 | 0));
            f3 = d2;
          } else {
            f3 = d2;
          }
          d2 = G3;
          g3 = b2[d2 >> 2] | 0;
          d2 = b2[d2 + 4 >> 2] | 0;
          h2 = ((f3 | 0) < 0) << 31 >> 31;
          if ((d2 | 0) < (h2 | 0) | (d2 | 0) == (h2 | 0) & g3 >>> 0 < f3 >>> 0) {
            d2 = G3;
            b2[d2 >> 2] = f3;
            b2[d2 + 4 >> 2] = h2;
            d2 = h2;
          } else {
            f3 = g3;
          }
          D3 = ld(f3 | 0, d2 | 0, 12, 0) | 0;
          E4 = H2() | 0;
          d2 = G3;
          b2[d2 >> 2] = D3;
          b2[d2 + 4 >> 2] = E4;
          d2 = 0;
        } else {
          D3 = 0;
          E4 = 0;
        }
        if (d2 | 0) {
          jd(J3);
          J3 = d2;
          T2 = K3;
          return J3 | 0;
        }
        f3 = kd(D3, 8) | 0;
        if (!f3) {
          jd(J3);
          J3 = 13;
          T2 = K3;
          return J3 | 0;
        }
        i2 = kd(D3, 8) | 0;
        if (!i2) {
          jd(J3);
          jd(f3);
          J3 = 13;
          T2 = K3;
          return J3 | 0;
        }
        B3 = F2;
        b2[B3 >> 2] = 0;
        b2[B3 + 4 >> 2] = 0;
        B3 = a3;
        C3 = b2[B3 + 4 >> 2] | 0;
        d2 = j2;
        b2[d2 >> 2] = b2[B3 >> 2];
        b2[d2 + 4 >> 2] = C3;
        d2 = ia(j2, D3, E4, c2, F2, f3, i2) | 0;
        a:
          do {
            if (!d2) {
              b:
                do {
                  if ((b2[k2 >> 2] | 0) > 0) {
                    h2 = a3 + 12 | 0;
                    g3 = 0;
                    while (1) {
                      d2 = ia((b2[h2 >> 2] | 0) + (g3 << 3) | 0, D3, E4, c2, F2, f3, i2) | 0;
                      g3 = g3 + 1 | 0;
                      if (d2 | 0) {
                        break;
                      }
                      if ((g3 | 0) >= (b2[k2 >> 2] | 0)) {
                        break b;
                      }
                    }
                    jd(f3);
                    jd(i2);
                    jd(J3);
                    break a;
                  }
                } while (0);
              if ((E4 | 0) > 0 | (E4 | 0) == 0 & D3 >>> 0 > 0) {
                Bd(i2 | 0, 0, D3 << 3 | 0) | 0;
              }
              C3 = F2;
              B3 = b2[C3 + 4 >> 2] | 0;
              c:
                do {
                  if ((B3 | 0) > 0 | (B3 | 0) == 0 & (b2[C3 >> 2] | 0) >>> 0 > 0) {
                    y3 = f3;
                    z3 = i2;
                    A3 = f3;
                    B3 = i2;
                    C3 = f3;
                    d2 = f3;
                    v6 = f3;
                    w3 = i2;
                    x3 = i2;
                    f3 = i2;
                    d:
                      while (1) {
                        r3 = 0;
                        s3 = 0;
                        t3 = 0;
                        u3 = 0;
                        g3 = 0;
                        h2 = 0;
                        while (1) {
                          i2 = G3;
                          j2 = i2 + 56 | 0;
                          do {
                            b2[i2 >> 2] = 0;
                            i2 = i2 + 4 | 0;
                          } while ((i2 | 0) < (j2 | 0));
                          c2 = y3 + (r3 << 3) | 0;
                          k2 = b2[c2 >> 2] | 0;
                          c2 = b2[c2 + 4 >> 2] | 0;
                          if (ca2(k2, c2, 1, G3, 0) | 0) {
                            i2 = G3;
                            j2 = i2 + 56 | 0;
                            do {
                              b2[i2 >> 2] = 0;
                              i2 = i2 + 4 | 0;
                            } while ((i2 | 0) < (j2 | 0));
                            i2 = kd(7, 4) | 0;
                            if (i2 | 0) {
                              da(k2, c2, 1, G3, i2, 7, 0, 0) | 0;
                              jd(i2);
                            }
                          }
                          q3 = 0;
                          while (1) {
                            p3 = G3 + (q3 << 3) | 0;
                            o2 = b2[p3 >> 2] | 0;
                            p3 = b2[p3 + 4 >> 2] | 0;
                            e:
                              do {
                                if (!((o2 | 0) == 0 & (p3 | 0) == 0)) {
                                  l2 = td(o2 | 0, p3 | 0, D3 | 0, E4 | 0) | 0;
                                  k2 = H2() | 0;
                                  i2 = e4 + (l2 << 3) | 0;
                                  c2 = i2;
                                  j2 = b2[c2 >> 2] | 0;
                                  c2 = b2[c2 + 4 >> 2] | 0;
                                  if (!((j2 | 0) == 0 & (c2 | 0) == 0)) {
                                    m2 = 0;
                                    n2 = 0;
                                    do {
                                      if ((m2 | 0) > (E4 | 0) | (m2 | 0) == (E4 | 0) & n2 >>> 0 > D3 >>> 0) {
                                        break d;
                                      }
                                      if ((j2 | 0) == (o2 | 0) & (c2 | 0) == (p3 | 0)) {
                                        i2 = g3;
                                        j2 = h2;
                                        break e;
                                      }
                                      i2 = ld(l2 | 0, k2 | 0, 1, 0) | 0;
                                      l2 = sd(i2 | 0, H2() | 0, D3 | 0, E4 | 0) | 0;
                                      k2 = H2() | 0;
                                      n2 = ld(n2 | 0, m2 | 0, 1, 0) | 0;
                                      m2 = H2() | 0;
                                      i2 = e4 + (l2 << 3) | 0;
                                      c2 = i2;
                                      j2 = b2[c2 >> 2] | 0;
                                      c2 = b2[c2 + 4 >> 2] | 0;
                                    } while (!((j2 | 0) == 0 & (c2 | 0) == 0));
                                  }
                                  if (!((o2 | 0) == 0 & (p3 | 0) == 0)) {
                                    Pb(o2, p3, I3) | 0;
                                    if (Gc(a3, J3, I3) | 0) {
                                      n2 = ld(g3 | 0, h2 | 0, 1, 0) | 0;
                                      h2 = H2() | 0;
                                      m2 = i2;
                                      b2[m2 >> 2] = o2;
                                      b2[m2 + 4 >> 2] = p3;
                                      g3 = z3 + (g3 << 3) | 0;
                                      b2[g3 >> 2] = o2;
                                      b2[g3 + 4 >> 2] = p3;
                                      g3 = n2;
                                    }
                                    i2 = g3;
                                    j2 = h2;
                                  } else {
                                    i2 = g3;
                                    j2 = h2;
                                  }
                                } else {
                                  i2 = g3;
                                  j2 = h2;
                                }
                              } while (0);
                            q3 = q3 + 1 | 0;
                            if (q3 >>> 0 >= 7) {
                              break;
                            } else {
                              g3 = i2;
                              h2 = j2;
                            }
                          }
                          r3 = ld(r3 | 0, s3 | 0, 1, 0) | 0;
                          s3 = H2() | 0;
                          t3 = ld(t3 | 0, u3 | 0, 1, 0) | 0;
                          u3 = H2() | 0;
                          h2 = F2;
                          g3 = b2[h2 >> 2] | 0;
                          h2 = b2[h2 + 4 >> 2] | 0;
                          if (!((u3 | 0) < (h2 | 0) | (u3 | 0) == (h2 | 0) & t3 >>> 0 < g3 >>> 0)) {
                            break;
                          } else {
                            g3 = i2;
                            h2 = j2;
                          }
                        }
                        if ((h2 | 0) > 0 | (h2 | 0) == 0 & g3 >>> 0 > 0) {
                          g3 = 0;
                          h2 = 0;
                          do {
                            u3 = y3 + (g3 << 3) | 0;
                            b2[u3 >> 2] = 0;
                            b2[u3 + 4 >> 2] = 0;
                            g3 = ld(g3 | 0, h2 | 0, 1, 0) | 0;
                            h2 = H2() | 0;
                            u3 = F2;
                            t3 = b2[u3 + 4 >> 2] | 0;
                          } while ((h2 | 0) < (t3 | 0) | ((h2 | 0) == (t3 | 0) ? g3 >>> 0 < (b2[u3 >> 2] | 0) >>> 0 : 0));
                        }
                        u3 = F2;
                        b2[u3 >> 2] = i2;
                        b2[u3 + 4 >> 2] = j2;
                        if ((j2 | 0) > 0 | (j2 | 0) == 0 & i2 >>> 0 > 0) {
                          q3 = f3;
                          r3 = x3;
                          s3 = C3;
                          t3 = w3;
                          u3 = z3;
                          f3 = v6;
                          x3 = d2;
                          w3 = A3;
                          v6 = q3;
                          d2 = r3;
                          C3 = B3;
                          B3 = s3;
                          A3 = t3;
                          z3 = y3;
                          y3 = u3;
                        } else {
                          break c;
                        }
                      }
                    jd(A3);
                    jd(B3);
                    jd(J3);
                    d2 = 1;
                    break a;
                  } else {
                    d2 = i2;
                  }
                } while (0);
              jd(J3);
              jd(f3);
              jd(d2);
              d2 = 0;
            } else {
              jd(f3);
              jd(i2);
              jd(J3);
            }
          } while (0);
        J3 = d2;
        T2 = K3;
        return J3 | 0;
      }
      function ka(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0;
        l2 = T2;
        T2 = T2 + 176 | 0;
        j2 = l2;
        if ((c2 | 0) < 1) {
          _c2(d2, 0, 0);
          k2 = 0;
          T2 = l2;
          return k2 | 0;
        }
        i2 = a3;
        i2 = vd(b2[i2 >> 2] | 0, b2[i2 + 4 >> 2] | 0, 52) | 0;
        H2() | 0;
        _c2(d2, (c2 | 0) > 6 ? c2 : 6, i2 & 15);
        i2 = 0;
        while (1) {
          e4 = a3 + (i2 << 3) | 0;
          e4 = Qb(b2[e4 >> 2] | 0, b2[e4 + 4 >> 2] | 0, j2) | 0;
          if (e4 | 0) {
            break;
          }
          e4 = b2[j2 >> 2] | 0;
          if ((e4 | 0) > 0) {
            h2 = 0;
            do {
              g3 = j2 + 8 + (h2 << 4) | 0;
              h2 = h2 + 1 | 0;
              e4 = j2 + 8 + (((h2 | 0) % (e4 | 0) | 0) << 4) | 0;
              f3 = dd(d2, e4, g3) | 0;
              if (!f3) {
                cd2(d2, g3, e4) | 0;
              } else {
                bd2(d2, f3) | 0;
              }
              e4 = b2[j2 >> 2] | 0;
            } while ((h2 | 0) < (e4 | 0));
          }
          i2 = i2 + 1 | 0;
          if ((i2 | 0) >= (c2 | 0)) {
            e4 = 0;
            k2 = 13;
            break;
          }
        }
        if ((k2 | 0) == 13) {
          T2 = l2;
          return e4 | 0;
        }
        $c(d2);
        k2 = e4;
        T2 = l2;
        return k2 | 0;
      }
      function la(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0;
        g3 = T2;
        T2 = T2 + 32 | 0;
        e4 = g3;
        f3 = g3 + 16 | 0;
        a3 = ka(a3, c2, f3) | 0;
        if (a3 | 0) {
          d2 = a3;
          T2 = g3;
          return d2 | 0;
        }
        b2[d2 >> 2] = 0;
        b2[d2 + 4 >> 2] = 0;
        b2[d2 + 8 >> 2] = 0;
        a3 = ad2(f3) | 0;
        if (a3 | 0) {
          do {
            c2 = qc(d2) | 0;
            do {
              rc(c2, a3) | 0;
              h2 = a3 + 16 | 0;
              b2[e4 >> 2] = b2[h2 >> 2];
              b2[e4 + 4 >> 2] = b2[h2 + 4 >> 2];
              b2[e4 + 8 >> 2] = b2[h2 + 8 >> 2];
              b2[e4 + 12 >> 2] = b2[h2 + 12 >> 2];
              bd2(f3, a3) | 0;
              a3 = ed(f3, e4) | 0;
            } while ((a3 | 0) != 0);
            a3 = ad2(f3) | 0;
          } while ((a3 | 0) != 0);
        }
        $c(f3);
        a3 = tc(d2) | 0;
        if (!a3) {
          h2 = 0;
          T2 = g3;
          return h2 | 0;
        }
        sc(d2);
        h2 = a3;
        T2 = g3;
        return h2 | 0;
      }
      function ma(a3) {
        a3 = a3 | 0;
        if (a3 >>> 0 > 121) {
          a3 = 0;
          return a3 | 0;
        }
        a3 = b2[7696 + (a3 * 28 | 0) + 16 >> 2] | 0;
        return a3 | 0;
      }
      function na(a3) {
        a3 = a3 | 0;
        return (a3 | 0) == 4 | (a3 | 0) == 117 | 0;
      }
      function oa(a3) {
        a3 = a3 | 0;
        return b2[11120 + ((b2[a3 >> 2] | 0) * 216 | 0) + ((b2[a3 + 4 >> 2] | 0) * 72 | 0) + ((b2[a3 + 8 >> 2] | 0) * 24 | 0) + (b2[a3 + 12 >> 2] << 3) >> 2] | 0;
      }
      function pa(a3) {
        a3 = a3 | 0;
        return b2[11120 + ((b2[a3 >> 2] | 0) * 216 | 0) + ((b2[a3 + 4 >> 2] | 0) * 72 | 0) + ((b2[a3 + 8 >> 2] | 0) * 24 | 0) + (b2[a3 + 12 >> 2] << 3) + 4 >> 2] | 0;
      }
      function qa(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        a3 = 7696 + (a3 * 28 | 0) | 0;
        b2[c2 >> 2] = b2[a3 >> 2];
        b2[c2 + 4 >> 2] = b2[a3 + 4 >> 2];
        b2[c2 + 8 >> 2] = b2[a3 + 8 >> 2];
        b2[c2 + 12 >> 2] = b2[a3 + 12 >> 2];
        return;
      }
      function ra(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0;
        if (c2 >>> 0 > 20) {
          c2 = -1;
          return c2 | 0;
        }
        do {
          if ((b2[11120 + (c2 * 216 | 0) >> 2] | 0) != (a3 | 0)) {
            if ((b2[11120 + (c2 * 216 | 0) + 8 >> 2] | 0) != (a3 | 0)) {
              if ((b2[11120 + (c2 * 216 | 0) + 16 >> 2] | 0) != (a3 | 0)) {
                if ((b2[11120 + (c2 * 216 | 0) + 24 >> 2] | 0) != (a3 | 0)) {
                  if ((b2[11120 + (c2 * 216 | 0) + 32 >> 2] | 0) != (a3 | 0)) {
                    if ((b2[11120 + (c2 * 216 | 0) + 40 >> 2] | 0) != (a3 | 0)) {
                      if ((b2[11120 + (c2 * 216 | 0) + 48 >> 2] | 0) != (a3 | 0)) {
                        if ((b2[11120 + (c2 * 216 | 0) + 56 >> 2] | 0) != (a3 | 0)) {
                          if ((b2[11120 + (c2 * 216 | 0) + 64 >> 2] | 0) != (a3 | 0)) {
                            if ((b2[11120 + (c2 * 216 | 0) + 72 >> 2] | 0) != (a3 | 0)) {
                              if ((b2[11120 + (c2 * 216 | 0) + 80 >> 2] | 0) != (a3 | 0)) {
                                if ((b2[11120 + (c2 * 216 | 0) + 88 >> 2] | 0) != (a3 | 0)) {
                                  if ((b2[11120 + (c2 * 216 | 0) + 96 >> 2] | 0) != (a3 | 0)) {
                                    if ((b2[11120 + (c2 * 216 | 0) + 104 >> 2] | 0) != (a3 | 0)) {
                                      if ((b2[11120 + (c2 * 216 | 0) + 112 >> 2] | 0) != (a3 | 0)) {
                                        if ((b2[11120 + (c2 * 216 | 0) + 120 >> 2] | 0) != (a3 | 0)) {
                                          if ((b2[11120 + (c2 * 216 | 0) + 128 >> 2] | 0) != (a3 | 0)) {
                                            if ((b2[11120 + (c2 * 216 | 0) + 136 >> 2] | 0) == (a3 | 0)) {
                                              a3 = 2;
                                              d2 = 1;
                                              e4 = 2;
                                            } else {
                                              if ((b2[11120 + (c2 * 216 | 0) + 144 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 0;
                                                d2 = 2;
                                                e4 = 0;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 152 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 0;
                                                d2 = 2;
                                                e4 = 1;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 160 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 0;
                                                d2 = 2;
                                                e4 = 2;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 168 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 1;
                                                d2 = 2;
                                                e4 = 0;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 176 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 1;
                                                d2 = 2;
                                                e4 = 1;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 184 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 1;
                                                d2 = 2;
                                                e4 = 2;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 192 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 2;
                                                d2 = 2;
                                                e4 = 0;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 200 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 2;
                                                d2 = 2;
                                                e4 = 1;
                                                break;
                                              }
                                              if ((b2[11120 + (c2 * 216 | 0) + 208 >> 2] | 0) == (a3 | 0)) {
                                                a3 = 2;
                                                d2 = 2;
                                                e4 = 2;
                                                break;
                                              } else {
                                                a3 = -1;
                                              }
                                              return a3 | 0;
                                            }
                                          } else {
                                            a3 = 2;
                                            d2 = 1;
                                            e4 = 1;
                                          }
                                        } else {
                                          a3 = 2;
                                          d2 = 1;
                                          e4 = 0;
                                        }
                                      } else {
                                        a3 = 1;
                                        d2 = 1;
                                        e4 = 2;
                                      }
                                    } else {
                                      a3 = 1;
                                      d2 = 1;
                                      e4 = 1;
                                    }
                                  } else {
                                    a3 = 1;
                                    d2 = 1;
                                    e4 = 0;
                                  }
                                } else {
                                  a3 = 0;
                                  d2 = 1;
                                  e4 = 2;
                                }
                              } else {
                                a3 = 0;
                                d2 = 1;
                                e4 = 1;
                              }
                            } else {
                              a3 = 0;
                              d2 = 1;
                              e4 = 0;
                            }
                          } else {
                            a3 = 2;
                            d2 = 0;
                            e4 = 2;
                          }
                        } else {
                          a3 = 2;
                          d2 = 0;
                          e4 = 1;
                        }
                      } else {
                        a3 = 2;
                        d2 = 0;
                        e4 = 0;
                      }
                    } else {
                      a3 = 1;
                      d2 = 0;
                      e4 = 2;
                    }
                  } else {
                    a3 = 1;
                    d2 = 0;
                    e4 = 1;
                  }
                } else {
                  a3 = 1;
                  d2 = 0;
                  e4 = 0;
                }
              } else {
                a3 = 0;
                d2 = 0;
                e4 = 2;
              }
            } else {
              a3 = 0;
              d2 = 0;
              e4 = 1;
            }
          } else {
            a3 = 0;
            d2 = 0;
            e4 = 0;
          }
        } while (0);
        c2 = b2[11120 + (c2 * 216 | 0) + (d2 * 72 | 0) + (a3 * 24 | 0) + (e4 << 3) + 4 >> 2] | 0;
        return c2 | 0;
      }
      function sa(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        if ((b2[7696 + (a3 * 28 | 0) + 20 >> 2] | 0) == (c2 | 0)) {
          c2 = 1;
          return c2 | 0;
        }
        c2 = (b2[7696 + (a3 * 28 | 0) + 24 >> 2] | 0) == (c2 | 0);
        return c2 | 0;
      }
      function ta(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        return b2[848 + (a3 * 28 | 0) + (c2 << 2) >> 2] | 0;
      }
      function ua(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        if ((b2[848 + (a3 * 28 | 0) >> 2] | 0) == (c2 | 0)) {
          c2 = 0;
          return c2 | 0;
        }
        if ((b2[848 + (a3 * 28 | 0) + 4 >> 2] | 0) == (c2 | 0)) {
          c2 = 1;
          return c2 | 0;
        }
        if ((b2[848 + (a3 * 28 | 0) + 8 >> 2] | 0) == (c2 | 0)) {
          c2 = 2;
          return c2 | 0;
        }
        if ((b2[848 + (a3 * 28 | 0) + 12 >> 2] | 0) == (c2 | 0)) {
          c2 = 3;
          return c2 | 0;
        }
        if ((b2[848 + (a3 * 28 | 0) + 16 >> 2] | 0) == (c2 | 0)) {
          c2 = 4;
          return c2 | 0;
        }
        if ((b2[848 + (a3 * 28 | 0) + 20 >> 2] | 0) == (c2 | 0)) {
          c2 = 5;
          return c2 | 0;
        } else {
          return ((b2[848 + (a3 * 28 | 0) + 24 >> 2] | 0) == (c2 | 0) ? 6 : 7) | 0;
        }
      }
      function va() {
        return 122;
      }
      function wa(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0;
        c2 = 0;
        do {
          wd(c2 | 0, 0, 45) | 0;
          e4 = H2() | 0 | 134225919;
          d2 = a3 + (c2 << 3) | 0;
          b2[d2 >> 2] = -1;
          b2[d2 + 4 >> 2] = e4;
          c2 = c2 + 1 | 0;
        } while ((c2 | 0) != 122);
        return 0;
      }
      function xa(a3) {
        a3 = a3 | 0;
        return +e3[a3 + 16 >> 3] < +e3[a3 + 24 >> 3] | 0;
      }
      function ya(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, f3 = 0;
        c2 = +e3[b3 >> 3];
        if (!(c2 >= +e3[a3 + 8 >> 3])) {
          b3 = 0;
          return b3 | 0;
        }
        if (!(c2 <= +e3[a3 >> 3])) {
          b3 = 0;
          return b3 | 0;
        }
        d2 = +e3[a3 + 16 >> 3];
        c2 = +e3[a3 + 24 >> 3];
        f3 = +e3[b3 + 8 >> 3];
        b3 = f3 >= c2;
        a3 = f3 <= d2 & 1;
        if (d2 < c2) {
          if (b3) {
            a3 = 1;
          }
        } else if (!b3) {
          a3 = 0;
        }
        b3 = (a3 | 0) != 0;
        return b3 | 0;
      }
      function za(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0;
        t3 = T2;
        T2 = T2 + 288 | 0;
        n2 = t3 + 264 | 0;
        o2 = t3 + 96 | 0;
        m2 = t3;
        k2 = m2;
        l2 = k2 + 96 | 0;
        do {
          b2[k2 >> 2] = 0;
          k2 = k2 + 4 | 0;
        } while ((k2 | 0) < (l2 | 0));
        c2 = Ub(c2, m2) | 0;
        if (c2 | 0) {
          s3 = c2;
          T2 = t3;
          return s3 | 0;
        }
        l2 = m2;
        m2 = b2[l2 >> 2] | 0;
        l2 = b2[l2 + 4 >> 2] | 0;
        Pb(m2, l2, n2) | 0;
        Qb(m2, l2, o2) | 0;
        j2 = +ac2(n2, o2 + 8 | 0);
        e3[n2 >> 3] = +e3[a3 >> 3];
        l2 = n2 + 8 | 0;
        e3[l2 >> 3] = +e3[a3 + 16 >> 3];
        e3[o2 >> 3] = +e3[a3 + 8 >> 3];
        m2 = o2 + 8 | 0;
        e3[m2 >> 3] = +e3[a3 + 24 >> 3];
        h2 = +ac2(n2, o2);
        v6 = +e3[l2 >> 3] - +e3[m2 >> 3];
        i2 = +q2(+v6);
        u3 = +e3[n2 >> 3] - +e3[o2 >> 3];
        g3 = +q2(+u3);
        if (!(v6 == 0 | u3 == 0) ? (v6 = +xd(+i2, +g3), v6 = +A2(+(h2 * h2 / +yd(+(v6 / +yd(+i2, +g3)), 3) / (j2 * (j2 * 2.59807621135) * 0.8))), e3[f2 >> 3] = v6, r3 = ~~v6 >>> 0, s3 = +q2(v6) >= 1 ? v6 > 0 ? ~~+C2(+p2(v6 / 4294967296), 4294967295) >>> 0 : ~~+A2((v6 - +(~~v6 >>> 0)) / 4294967296) >>> 0 : 0, !((b2[f2 + 4 >> 2] & 2146435072 | 0) == 2146435072)) : 0) {
          o2 = (r3 | 0) == 0 & (s3 | 0) == 0;
          c2 = d2;
          b2[c2 >> 2] = o2 ? 1 : r3;
          b2[c2 + 4 >> 2] = o2 ? 0 : s3;
          c2 = 0;
        } else {
          c2 = 1;
        }
        s3 = c2;
        T2 = t3;
        return s3 | 0;
      }
      function Aa(a3, c2, d2, g3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        g3 = g3 | 0;
        var h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0;
        m2 = T2;
        T2 = T2 + 288 | 0;
        j2 = m2 + 264 | 0;
        k2 = m2 + 96 | 0;
        l2 = m2;
        h2 = l2;
        i2 = h2 + 96 | 0;
        do {
          b2[h2 >> 2] = 0;
          h2 = h2 + 4 | 0;
        } while ((h2 | 0) < (i2 | 0));
        d2 = Ub(d2, l2) | 0;
        if (d2 | 0) {
          g3 = d2;
          T2 = m2;
          return g3 | 0;
        }
        d2 = l2;
        h2 = b2[d2 >> 2] | 0;
        d2 = b2[d2 + 4 >> 2] | 0;
        Pb(h2, d2, j2) | 0;
        Qb(h2, d2, k2) | 0;
        n2 = +ac2(j2, k2 + 8 | 0);
        n2 = +A2(+(+ac2(a3, c2) / (n2 * 2)));
        e3[f2 >> 3] = n2;
        d2 = ~~n2 >>> 0;
        h2 = +q2(n2) >= 1 ? n2 > 0 ? ~~+C2(+p2(n2 / 4294967296), 4294967295) >>> 0 : ~~+A2((n2 - +(~~n2 >>> 0)) / 4294967296) >>> 0 : 0;
        if ((b2[f2 + 4 >> 2] & 2146435072 | 0) == 2146435072) {
          g3 = 1;
          T2 = m2;
          return g3 | 0;
        }
        l2 = (d2 | 0) == 0 & (h2 | 0) == 0;
        b2[g3 >> 2] = l2 ? 1 : d2;
        b2[g3 + 4 >> 2] = l2 ? 0 : h2;
        g3 = 0;
        T2 = m2;
        return g3 | 0;
      }
      function Ba(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        b2[a3 >> 2] = c2;
        b2[a3 + 4 >> 2] = d2;
        b2[a3 + 8 >> 2] = e4;
        return;
      }
      function Ca(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0;
        n2 = c2 + 8 | 0;
        b2[n2 >> 2] = 0;
        k2 = +e3[a3 >> 3];
        i2 = +q2(+k2);
        l2 = +e3[a3 + 8 >> 3];
        j2 = +q2(+l2) / 0.8660254037844386;
        i2 = i2 + j2 * 0.5;
        d2 = ~~i2;
        a3 = ~~j2;
        i2 = i2 - +(d2 | 0);
        j2 = j2 - +(a3 | 0);
        do {
          if (i2 < 0.5) {
            if (i2 < 0.3333333333333333) {
              b2[c2 >> 2] = d2;
              if (j2 < (i2 + 1) * 0.5) {
                b2[c2 + 4 >> 2] = a3;
                break;
              } else {
                a3 = a3 + 1 | 0;
                b2[c2 + 4 >> 2] = a3;
                break;
              }
            } else {
              o2 = 1 - i2;
              a3 = (!(j2 < o2) & 1) + a3 | 0;
              b2[c2 + 4 >> 2] = a3;
              if (o2 <= j2 & j2 < i2 * 2) {
                d2 = d2 + 1 | 0;
                b2[c2 >> 2] = d2;
                break;
              } else {
                b2[c2 >> 2] = d2;
                break;
              }
            }
          } else {
            if (!(i2 < 0.6666666666666666)) {
              d2 = d2 + 1 | 0;
              b2[c2 >> 2] = d2;
              if (j2 < i2 * 0.5) {
                b2[c2 + 4 >> 2] = a3;
                break;
              } else {
                a3 = a3 + 1 | 0;
                b2[c2 + 4 >> 2] = a3;
                break;
              }
            }
            if (j2 < 1 - i2) {
              b2[c2 + 4 >> 2] = a3;
              if (i2 * 2 + -1 < j2) {
                b2[c2 >> 2] = d2;
                break;
              }
            } else {
              a3 = a3 + 1 | 0;
              b2[c2 + 4 >> 2] = a3;
            }
            d2 = d2 + 1 | 0;
            b2[c2 >> 2] = d2;
          }
        } while (0);
        do {
          if (k2 < 0) {
            if (!(a3 & 1)) {
              m2 = (a3 | 0) / 2 | 0;
              m2 = md(d2 | 0, ((d2 | 0) < 0) << 31 >> 31 | 0, m2 | 0, ((m2 | 0) < 0) << 31 >> 31 | 0) | 0;
              d2 = ~~(+(d2 | 0) - (+(m2 >>> 0) + 4294967296 * +(H2() | 0)) * 2);
              b2[c2 >> 2] = d2;
              break;
            } else {
              m2 = (a3 + 1 | 0) / 2 | 0;
              m2 = md(d2 | 0, ((d2 | 0) < 0) << 31 >> 31 | 0, m2 | 0, ((m2 | 0) < 0) << 31 >> 31 | 0) | 0;
              d2 = ~~(+(d2 | 0) - ((+(m2 >>> 0) + 4294967296 * +(H2() | 0)) * 2 + 1));
              b2[c2 >> 2] = d2;
              break;
            }
          }
        } while (0);
        m2 = c2 + 4 | 0;
        if (l2 < 0) {
          d2 = d2 - ((a3 << 1 | 1 | 0) / 2 | 0) | 0;
          b2[c2 >> 2] = d2;
          a3 = 0 - a3 | 0;
          b2[m2 >> 2] = a3;
        }
        f3 = a3 - d2 | 0;
        if ((d2 | 0) < 0) {
          g3 = 0 - d2 | 0;
          b2[m2 >> 2] = f3;
          b2[n2 >> 2] = g3;
          b2[c2 >> 2] = 0;
          a3 = f3;
          d2 = 0;
        } else {
          g3 = 0;
        }
        if ((a3 | 0) < 0) {
          d2 = d2 - a3 | 0;
          b2[c2 >> 2] = d2;
          g3 = g3 - a3 | 0;
          b2[n2 >> 2] = g3;
          b2[m2 >> 2] = 0;
          a3 = 0;
        }
        h2 = d2 - g3 | 0;
        f3 = a3 - g3 | 0;
        if ((g3 | 0) < 0) {
          b2[c2 >> 2] = h2;
          b2[m2 >> 2] = f3;
          b2[n2 >> 2] = 0;
          a3 = f3;
          d2 = h2;
          g3 = 0;
        }
        f3 = (a3 | 0) < (d2 | 0) ? a3 : d2;
        f3 = (g3 | 0) < (f3 | 0) ? g3 : f3;
        if ((f3 | 0) <= 0) {
          return;
        }
        b2[c2 >> 2] = d2 - f3;
        b2[m2 >> 2] = a3 - f3;
        b2[n2 >> 2] = g3 - f3;
        return;
      }
      function Da(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0;
        c2 = b2[a3 >> 2] | 0;
        h2 = a3 + 4 | 0;
        d2 = b2[h2 >> 2] | 0;
        if ((c2 | 0) < 0) {
          d2 = d2 - c2 | 0;
          b2[h2 >> 2] = d2;
          g3 = a3 + 8 | 0;
          b2[g3 >> 2] = (b2[g3 >> 2] | 0) - c2;
          b2[a3 >> 2] = 0;
          c2 = 0;
        }
        if ((d2 | 0) < 0) {
          c2 = c2 - d2 | 0;
          b2[a3 >> 2] = c2;
          g3 = a3 + 8 | 0;
          f3 = (b2[g3 >> 2] | 0) - d2 | 0;
          b2[g3 >> 2] = f3;
          b2[h2 >> 2] = 0;
          d2 = 0;
        } else {
          f3 = a3 + 8 | 0;
          g3 = f3;
          f3 = b2[f3 >> 2] | 0;
        }
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[a3 >> 2] = c2;
          d2 = d2 - f3 | 0;
          b2[h2 >> 2] = d2;
          b2[g3 >> 2] = 0;
          f3 = 0;
        }
        e4 = (d2 | 0) < (c2 | 0) ? d2 : c2;
        e4 = (f3 | 0) < (e4 | 0) ? f3 : e4;
        if ((e4 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = c2 - e4;
        b2[h2 >> 2] = d2 - e4;
        b2[g3 >> 2] = f3 - e4;
        return;
      }
      function Ea(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, f3 = 0;
        f3 = b2[a3 + 8 >> 2] | 0;
        d2 = +((b2[a3 + 4 >> 2] | 0) - f3 | 0);
        e3[c2 >> 3] = +((b2[a3 >> 2] | 0) - f3 | 0) - d2 * 0.5;
        e3[c2 + 8 >> 3] = d2 * 0.8660254037844386;
        return;
      }
      function Fa(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        b2[d2 >> 2] = (b2[c2 >> 2] | 0) + (b2[a3 >> 2] | 0);
        b2[d2 + 4 >> 2] = (b2[c2 + 4 >> 2] | 0) + (b2[a3 + 4 >> 2] | 0);
        b2[d2 + 8 >> 2] = (b2[c2 + 8 >> 2] | 0) + (b2[a3 + 8 >> 2] | 0);
        return;
      }
      function Ga(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        b2[d2 >> 2] = (b2[a3 >> 2] | 0) - (b2[c2 >> 2] | 0);
        b2[d2 + 4 >> 2] = (b2[a3 + 4 >> 2] | 0) - (b2[c2 + 4 >> 2] | 0);
        b2[d2 + 8 >> 2] = (b2[a3 + 8 >> 2] | 0) - (b2[c2 + 8 >> 2] | 0);
        return;
      }
      function Ha(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0;
        d2 = B2(b2[a3 >> 2] | 0, c2) | 0;
        b2[a3 >> 2] = d2;
        d2 = a3 + 4 | 0;
        e4 = B2(b2[d2 >> 2] | 0, c2) | 0;
        b2[d2 >> 2] = e4;
        a3 = a3 + 8 | 0;
        c2 = B2(b2[a3 >> 2] | 0, c2) | 0;
        b2[a3 >> 2] = c2;
        return;
      }
      function Ia(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = b2[a3 >> 2] | 0;
        i2 = (h2 | 0) < 0;
        e4 = (b2[a3 + 4 >> 2] | 0) - (i2 ? h2 : 0) | 0;
        g3 = (e4 | 0) < 0;
        f3 = (g3 ? 0 - e4 | 0 : 0) + ((b2[a3 + 8 >> 2] | 0) - (i2 ? h2 : 0)) | 0;
        d2 = (f3 | 0) < 0;
        a3 = d2 ? 0 : f3;
        c2 = (g3 ? 0 : e4) - (d2 ? f3 : 0) | 0;
        f3 = (i2 ? 0 : h2) - (g3 ? e4 : 0) - (d2 ? f3 : 0) | 0;
        d2 = (c2 | 0) < (f3 | 0) ? c2 : f3;
        d2 = (a3 | 0) < (d2 | 0) ? a3 : d2;
        e4 = (d2 | 0) > 0;
        a3 = a3 - (e4 ? d2 : 0) | 0;
        c2 = c2 - (e4 ? d2 : 0) | 0;
        a:
          do {
            switch (f3 - (e4 ? d2 : 0) | 0) {
              case 0:
                switch (c2 | 0) {
                  case 0: {
                    i2 = (a3 | 0) == 0 ? 0 : (a3 | 0) == 1 ? 1 : 7;
                    return i2 | 0;
                  }
                  case 1: {
                    i2 = (a3 | 0) == 0 ? 2 : (a3 | 0) == 1 ? 3 : 7;
                    return i2 | 0;
                  }
                  default:
                    break a;
                }
              case 1:
                switch (c2 | 0) {
                  case 0: {
                    i2 = (a3 | 0) == 0 ? 4 : (a3 | 0) == 1 ? 5 : 7;
                    return i2 | 0;
                  }
                  case 1: {
                    if (!a3) {
                      a3 = 6;
                    } else {
                      break a;
                    }
                    return a3 | 0;
                  }
                  default:
                    break a;
                }
            }
          } while (0);
        i2 = 7;
        return i2 | 0;
      }
      function Ja(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = a3 + 8 | 0;
        f3 = b2[h2 >> 2] | 0;
        g3 = (b2[a3 >> 2] | 0) - f3 | 0;
        i2 = a3 + 4 | 0;
        f3 = (b2[i2 >> 2] | 0) - f3 | 0;
        do {
          if (g3 >>> 0 > 715827881 | f3 >>> 0 > 715827881) {
            d2 = (g3 | 0) > 0;
            if (d2) {
              if ((2147483647 - g3 | 0) < (g3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
              if ((2147483647 - (g3 << 1) | 0) < (g3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            } else {
              if ((-2147483648 - g3 | 0) > (g3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
              if ((-2147483648 - (g3 << 1) | 0) > (g3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            }
            c2 = g3 * 3 | 0;
            if ((f3 | 0) > 0) {
              if ((2147483647 - f3 | 0) < (f3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            } else if ((-2147483648 - f3 | 0) > (f3 | 0)) {
              i2 = 1;
              return i2 | 0;
            }
            e4 = f3 << 1;
            if ((g3 | 0) > -1) {
              if ((c2 | -2147483648 | 0) >= (f3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            } else if ((c2 ^ -2147483648 | 0) < (f3 | 0)) {
              i2 = 1;
              return i2 | 0;
            }
            if (d2) {
              if ((2147483647 - g3 | 0) < (e4 | 0)) {
                c2 = 1;
              } else {
                d2 = e4;
                break;
              }
              return c2 | 0;
            } else {
              if ((-2147483648 - g3 | 0) > (e4 | 0)) {
                c2 = 1;
              } else {
                d2 = e4;
                break;
              }
              return c2 | 0;
            }
          } else {
            d2 = f3 << 1;
            c2 = g3 * 3 | 0;
          }
        } while (0);
        e4 = hd(+(c2 - f3 | 0) / 7) | 0;
        b2[a3 >> 2] = e4;
        f3 = hd(+(d2 + g3 | 0) / 7) | 0;
        b2[i2 >> 2] = f3;
        b2[h2 >> 2] = 0;
        d2 = (f3 | 0) < (e4 | 0);
        c2 = d2 ? e4 : f3;
        d2 = d2 ? f3 : e4;
        do {
          if ((d2 | 0) < 0) {
            if ((c2 | 0) > 0) {
              if ((c2 | -2147483648 | 0) < (d2 | 0) & ((d2 | 0) != -2147483648 & (2147483647 - c2 | 0) >= (d2 | 0))) {
                break;
              }
              I2(23313, 22444, 355, 22455);
            }
            if ((d2 | 0) == -2147483648 | (-2147483648 - c2 | 0) > (d2 | 0)) {
              I2(23313, 22444, 355, 22455);
            }
            if ((c2 | 0) > -1) {
              if ((c2 | -2147483648 | 0) < (d2 | 0)) {
                break;
              }
              I2(23313, 22444, 355, 22455);
            } else {
              if ((c2 ^ -2147483648 | 0) >= (d2 | 0)) {
                break;
              }
              I2(23313, 22444, 355, 22455);
            }
          }
        } while (0);
        c2 = f3 - e4 | 0;
        if ((e4 | 0) < 0) {
          d2 = 0 - e4 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = d2;
          b2[a3 >> 2] = 0;
          e4 = 0;
        } else {
          c2 = f3;
          d2 = 0;
        }
        if ((c2 | 0) < 0) {
          e4 = e4 - c2 | 0;
          b2[a3 >> 2] = e4;
          d2 = d2 - c2 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = 0;
          c2 = 0;
        }
        g3 = e4 - d2 | 0;
        f3 = c2 - d2 | 0;
        if ((d2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[i2 >> 2] = f3;
          b2[h2 >> 2] = 0;
          c2 = f3;
          f3 = g3;
          d2 = 0;
        } else {
          f3 = e4;
        }
        e4 = (c2 | 0) < (f3 | 0) ? c2 : f3;
        e4 = (d2 | 0) < (e4 | 0) ? d2 : e4;
        if ((e4 | 0) <= 0) {
          i2 = 0;
          return i2 | 0;
        }
        b2[a3 >> 2] = f3 - e4;
        b2[i2 >> 2] = c2 - e4;
        b2[h2 >> 2] = d2 - e4;
        i2 = 0;
        return i2 | 0;
      }
      function Ka(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = a3 + 8 | 0;
        f3 = b2[h2 >> 2] | 0;
        g3 = (b2[a3 >> 2] | 0) - f3 | 0;
        i2 = a3 + 4 | 0;
        f3 = (b2[i2 >> 2] | 0) - f3 | 0;
        do {
          if (g3 >>> 0 > 715827881 | f3 >>> 0 > 715827881) {
            d2 = (g3 | 0) > 0;
            if (d2) {
              if ((2147483647 - g3 | 0) < (g3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            } else if ((-2147483648 - g3 | 0) > (g3 | 0)) {
              i2 = 1;
              return i2 | 0;
            }
            c2 = g3 << 1;
            if ((f3 | 0) > 0) {
              if ((2147483647 - f3 | 0) < (f3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
              if ((2147483647 - (f3 << 1) | 0) < (f3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            } else {
              if ((-2147483648 - f3 | 0) > (f3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
              if ((-2147483648 - (f3 << 1) | 0) > (f3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            }
            e4 = f3 * 3 | 0;
            if (d2) {
              if ((2147483647 - c2 | 0) < (f3 | 0)) {
                i2 = 1;
                return i2 | 0;
              }
            } else if ((-2147483648 - c2 | 0) > (f3 | 0)) {
              i2 = 1;
              return i2 | 0;
            }
            if ((f3 | 0) > -1) {
              if ((e4 | -2147483648 | 0) < (g3 | 0)) {
                d2 = e4;
                break;
              } else {
                c2 = 1;
              }
              return c2 | 0;
            } else {
              if ((e4 ^ -2147483648 | 0) < (g3 | 0)) {
                c2 = 1;
              } else {
                d2 = e4;
                break;
              }
              return c2 | 0;
            }
          } else {
            d2 = f3 * 3 | 0;
            c2 = g3 << 1;
          }
        } while (0);
        e4 = hd(+(c2 + f3 | 0) / 7) | 0;
        b2[a3 >> 2] = e4;
        f3 = hd(+(d2 - g3 | 0) / 7) | 0;
        b2[i2 >> 2] = f3;
        b2[h2 >> 2] = 0;
        d2 = (f3 | 0) < (e4 | 0);
        c2 = d2 ? e4 : f3;
        d2 = d2 ? f3 : e4;
        do {
          if ((d2 | 0) < 0) {
            if ((c2 | 0) > 0) {
              if ((c2 | -2147483648 | 0) < (d2 | 0) & ((d2 | 0) != -2147483648 & (2147483647 - c2 | 0) >= (d2 | 0))) {
                break;
              }
              I2(23313, 22444, 404, 22469);
            }
            if ((d2 | 0) == -2147483648 | (-2147483648 - c2 | 0) > (d2 | 0)) {
              I2(23313, 22444, 404, 22469);
            }
            if ((c2 | 0) > -1) {
              if ((c2 | -2147483648 | 0) < (d2 | 0)) {
                break;
              }
              I2(23313, 22444, 404, 22469);
            } else {
              if ((c2 ^ -2147483648 | 0) >= (d2 | 0)) {
                break;
              }
              I2(23313, 22444, 404, 22469);
            }
          }
        } while (0);
        c2 = f3 - e4 | 0;
        if ((e4 | 0) < 0) {
          d2 = 0 - e4 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = d2;
          b2[a3 >> 2] = 0;
          e4 = 0;
        } else {
          c2 = f3;
          d2 = 0;
        }
        if ((c2 | 0) < 0) {
          e4 = e4 - c2 | 0;
          b2[a3 >> 2] = e4;
          d2 = d2 - c2 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = 0;
          c2 = 0;
        }
        g3 = e4 - d2 | 0;
        f3 = c2 - d2 | 0;
        if ((d2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[i2 >> 2] = f3;
          b2[h2 >> 2] = 0;
          c2 = f3;
          f3 = g3;
          d2 = 0;
        } else {
          f3 = e4;
        }
        e4 = (c2 | 0) < (f3 | 0) ? c2 : f3;
        e4 = (d2 | 0) < (e4 | 0) ? d2 : e4;
        if ((e4 | 0) <= 0) {
          i2 = 0;
          return i2 | 0;
        }
        b2[a3 >> 2] = f3 - e4;
        b2[i2 >> 2] = c2 - e4;
        b2[h2 >> 2] = d2 - e4;
        i2 = 0;
        return i2 | 0;
      }
      function La(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = a3 + 8 | 0;
        d2 = b2[h2 >> 2] | 0;
        c2 = (b2[a3 >> 2] | 0) - d2 | 0;
        i2 = a3 + 4 | 0;
        d2 = (b2[i2 >> 2] | 0) - d2 | 0;
        e4 = hd(+((c2 * 3 | 0) - d2 | 0) / 7) | 0;
        b2[a3 >> 2] = e4;
        c2 = hd(+((d2 << 1) + c2 | 0) / 7) | 0;
        b2[i2 >> 2] = c2;
        b2[h2 >> 2] = 0;
        d2 = c2 - e4 | 0;
        if ((e4 | 0) < 0) {
          g3 = 0 - e4 | 0;
          b2[i2 >> 2] = d2;
          b2[h2 >> 2] = g3;
          b2[a3 >> 2] = 0;
          c2 = d2;
          e4 = 0;
          d2 = g3;
        } else {
          d2 = 0;
        }
        if ((c2 | 0) < 0) {
          e4 = e4 - c2 | 0;
          b2[a3 >> 2] = e4;
          d2 = d2 - c2 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = 0;
          c2 = 0;
        }
        g3 = e4 - d2 | 0;
        f3 = c2 - d2 | 0;
        if ((d2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[i2 >> 2] = f3;
          b2[h2 >> 2] = 0;
          c2 = f3;
          f3 = g3;
          d2 = 0;
        } else {
          f3 = e4;
        }
        e4 = (c2 | 0) < (f3 | 0) ? c2 : f3;
        e4 = (d2 | 0) < (e4 | 0) ? d2 : e4;
        if ((e4 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = f3 - e4;
        b2[i2 >> 2] = c2 - e4;
        b2[h2 >> 2] = d2 - e4;
        return;
      }
      function Ma(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = a3 + 8 | 0;
        d2 = b2[h2 >> 2] | 0;
        c2 = (b2[a3 >> 2] | 0) - d2 | 0;
        i2 = a3 + 4 | 0;
        d2 = (b2[i2 >> 2] | 0) - d2 | 0;
        e4 = hd(+((c2 << 1) + d2 | 0) / 7) | 0;
        b2[a3 >> 2] = e4;
        c2 = hd(+((d2 * 3 | 0) - c2 | 0) / 7) | 0;
        b2[i2 >> 2] = c2;
        b2[h2 >> 2] = 0;
        d2 = c2 - e4 | 0;
        if ((e4 | 0) < 0) {
          g3 = 0 - e4 | 0;
          b2[i2 >> 2] = d2;
          b2[h2 >> 2] = g3;
          b2[a3 >> 2] = 0;
          c2 = d2;
          e4 = 0;
          d2 = g3;
        } else {
          d2 = 0;
        }
        if ((c2 | 0) < 0) {
          e4 = e4 - c2 | 0;
          b2[a3 >> 2] = e4;
          d2 = d2 - c2 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = 0;
          c2 = 0;
        }
        g3 = e4 - d2 | 0;
        f3 = c2 - d2 | 0;
        if ((d2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[i2 >> 2] = f3;
          b2[h2 >> 2] = 0;
          c2 = f3;
          f3 = g3;
          d2 = 0;
        } else {
          f3 = e4;
        }
        e4 = (c2 | 0) < (f3 | 0) ? c2 : f3;
        e4 = (d2 | 0) < (e4 | 0) ? d2 : e4;
        if ((e4 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = f3 - e4;
        b2[i2 >> 2] = c2 - e4;
        b2[h2 >> 2] = d2 - e4;
        return;
      }
      function Na(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        c2 = b2[a3 >> 2] | 0;
        h2 = a3 + 4 | 0;
        d2 = b2[h2 >> 2] | 0;
        i2 = a3 + 8 | 0;
        e4 = b2[i2 >> 2] | 0;
        f3 = d2 + (c2 * 3 | 0) | 0;
        b2[a3 >> 2] = f3;
        d2 = e4 + (d2 * 3 | 0) | 0;
        b2[h2 >> 2] = d2;
        c2 = (e4 * 3 | 0) + c2 | 0;
        b2[i2 >> 2] = c2;
        e4 = d2 - f3 | 0;
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[h2 >> 2] = e4;
          b2[i2 >> 2] = c2;
          b2[a3 >> 2] = 0;
          d2 = e4;
          e4 = 0;
        } else {
          e4 = f3;
        }
        if ((d2 | 0) < 0) {
          e4 = e4 - d2 | 0;
          b2[a3 >> 2] = e4;
          c2 = c2 - d2 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = 0;
          d2 = 0;
        }
        g3 = e4 - c2 | 0;
        f3 = d2 - c2 | 0;
        if ((c2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[h2 >> 2] = f3;
          b2[i2 >> 2] = 0;
          e4 = g3;
          c2 = 0;
        } else {
          f3 = d2;
        }
        d2 = (f3 | 0) < (e4 | 0) ? f3 : e4;
        d2 = (c2 | 0) < (d2 | 0) ? c2 : d2;
        if ((d2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = e4 - d2;
        b2[h2 >> 2] = f3 - d2;
        b2[i2 >> 2] = c2 - d2;
        return;
      }
      function Oa(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        f3 = b2[a3 >> 2] | 0;
        h2 = a3 + 4 | 0;
        c2 = b2[h2 >> 2] | 0;
        i2 = a3 + 8 | 0;
        d2 = b2[i2 >> 2] | 0;
        e4 = (c2 * 3 | 0) + f3 | 0;
        f3 = d2 + (f3 * 3 | 0) | 0;
        b2[a3 >> 2] = f3;
        b2[h2 >> 2] = e4;
        c2 = (d2 * 3 | 0) + c2 | 0;
        b2[i2 >> 2] = c2;
        d2 = e4 - f3 | 0;
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = c2;
          b2[a3 >> 2] = 0;
          f3 = 0;
        } else {
          d2 = e4;
        }
        if ((d2 | 0) < 0) {
          f3 = f3 - d2 | 0;
          b2[a3 >> 2] = f3;
          c2 = c2 - d2 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = 0;
          d2 = 0;
        }
        g3 = f3 - c2 | 0;
        e4 = d2 - c2 | 0;
        if ((c2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[h2 >> 2] = e4;
          b2[i2 >> 2] = 0;
          f3 = g3;
          c2 = 0;
        } else {
          e4 = d2;
        }
        d2 = (e4 | 0) < (f3 | 0) ? e4 : f3;
        d2 = (c2 | 0) < (d2 | 0) ? c2 : d2;
        if ((d2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = f3 - d2;
        b2[h2 >> 2] = e4 - d2;
        b2[i2 >> 2] = c2 - d2;
        return;
      }
      function Pa(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        if ((c2 + -1 | 0) >>> 0 >= 6) {
          return;
        }
        f3 = (b2[15440 + (c2 * 12 | 0) >> 2] | 0) + (b2[a3 >> 2] | 0) | 0;
        b2[a3 >> 2] = f3;
        i2 = a3 + 4 | 0;
        e4 = (b2[15440 + (c2 * 12 | 0) + 4 >> 2] | 0) + (b2[i2 >> 2] | 0) | 0;
        b2[i2 >> 2] = e4;
        h2 = a3 + 8 | 0;
        c2 = (b2[15440 + (c2 * 12 | 0) + 8 >> 2] | 0) + (b2[h2 >> 2] | 0) | 0;
        b2[h2 >> 2] = c2;
        d2 = e4 - f3 | 0;
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[i2 >> 2] = d2;
          b2[h2 >> 2] = c2;
          b2[a3 >> 2] = 0;
          e4 = 0;
        } else {
          d2 = e4;
          e4 = f3;
        }
        if ((d2 | 0) < 0) {
          e4 = e4 - d2 | 0;
          b2[a3 >> 2] = e4;
          c2 = c2 - d2 | 0;
          b2[h2 >> 2] = c2;
          b2[i2 >> 2] = 0;
          d2 = 0;
        }
        g3 = e4 - c2 | 0;
        f3 = d2 - c2 | 0;
        if ((c2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[i2 >> 2] = f3;
          b2[h2 >> 2] = 0;
          e4 = g3;
          c2 = 0;
        } else {
          f3 = d2;
        }
        d2 = (f3 | 0) < (e4 | 0) ? f3 : e4;
        d2 = (c2 | 0) < (d2 | 0) ? c2 : d2;
        if ((d2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = e4 - d2;
        b2[i2 >> 2] = f3 - d2;
        b2[h2 >> 2] = c2 - d2;
        return;
      }
      function Qa(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        f3 = b2[a3 >> 2] | 0;
        h2 = a3 + 4 | 0;
        c2 = b2[h2 >> 2] | 0;
        i2 = a3 + 8 | 0;
        d2 = b2[i2 >> 2] | 0;
        e4 = c2 + f3 | 0;
        f3 = d2 + f3 | 0;
        b2[a3 >> 2] = f3;
        b2[h2 >> 2] = e4;
        c2 = d2 + c2 | 0;
        b2[i2 >> 2] = c2;
        d2 = e4 - f3 | 0;
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = c2;
          b2[a3 >> 2] = 0;
          e4 = 0;
        } else {
          d2 = e4;
          e4 = f3;
        }
        if ((d2 | 0) < 0) {
          e4 = e4 - d2 | 0;
          b2[a3 >> 2] = e4;
          c2 = c2 - d2 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = 0;
          d2 = 0;
        }
        g3 = e4 - c2 | 0;
        f3 = d2 - c2 | 0;
        if ((c2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[h2 >> 2] = f3;
          b2[i2 >> 2] = 0;
          e4 = g3;
          c2 = 0;
        } else {
          f3 = d2;
        }
        d2 = (f3 | 0) < (e4 | 0) ? f3 : e4;
        d2 = (c2 | 0) < (d2 | 0) ? c2 : d2;
        if ((d2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = e4 - d2;
        b2[h2 >> 2] = f3 - d2;
        b2[i2 >> 2] = c2 - d2;
        return;
      }
      function Ra(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        c2 = b2[a3 >> 2] | 0;
        h2 = a3 + 4 | 0;
        e4 = b2[h2 >> 2] | 0;
        i2 = a3 + 8 | 0;
        d2 = b2[i2 >> 2] | 0;
        f3 = e4 + c2 | 0;
        b2[a3 >> 2] = f3;
        e4 = d2 + e4 | 0;
        b2[h2 >> 2] = e4;
        c2 = d2 + c2 | 0;
        b2[i2 >> 2] = c2;
        d2 = e4 - f3 | 0;
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = c2;
          b2[a3 >> 2] = 0;
          e4 = 0;
        } else {
          d2 = e4;
          e4 = f3;
        }
        if ((d2 | 0) < 0) {
          e4 = e4 - d2 | 0;
          b2[a3 >> 2] = e4;
          c2 = c2 - d2 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = 0;
          d2 = 0;
        }
        g3 = e4 - c2 | 0;
        f3 = d2 - c2 | 0;
        if ((c2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[h2 >> 2] = f3;
          b2[i2 >> 2] = 0;
          e4 = g3;
          c2 = 0;
        } else {
          f3 = d2;
        }
        d2 = (f3 | 0) < (e4 | 0) ? f3 : e4;
        d2 = (c2 | 0) < (d2 | 0) ? c2 : d2;
        if ((d2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = e4 - d2;
        b2[h2 >> 2] = f3 - d2;
        b2[i2 >> 2] = c2 - d2;
        return;
      }
      function Sa(a3) {
        a3 = a3 | 0;
        switch (a3 | 0) {
          case 1: {
            a3 = 5;
            break;
          }
          case 5: {
            a3 = 4;
            break;
          }
          case 4: {
            a3 = 6;
            break;
          }
          case 6: {
            a3 = 2;
            break;
          }
          case 2: {
            a3 = 3;
            break;
          }
          case 3: {
            a3 = 1;
            break;
          }
        }
        return a3 | 0;
      }
      function Ta(a3) {
        a3 = a3 | 0;
        switch (a3 | 0) {
          case 1: {
            a3 = 3;
            break;
          }
          case 3: {
            a3 = 2;
            break;
          }
          case 2: {
            a3 = 6;
            break;
          }
          case 6: {
            a3 = 4;
            break;
          }
          case 4: {
            a3 = 5;
            break;
          }
          case 5: {
            a3 = 1;
            break;
          }
        }
        return a3 | 0;
      }
      function Ua(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        c2 = b2[a3 >> 2] | 0;
        h2 = a3 + 4 | 0;
        d2 = b2[h2 >> 2] | 0;
        i2 = a3 + 8 | 0;
        e4 = b2[i2 >> 2] | 0;
        f3 = d2 + (c2 << 1) | 0;
        b2[a3 >> 2] = f3;
        d2 = e4 + (d2 << 1) | 0;
        b2[h2 >> 2] = d2;
        c2 = (e4 << 1) + c2 | 0;
        b2[i2 >> 2] = c2;
        e4 = d2 - f3 | 0;
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[h2 >> 2] = e4;
          b2[i2 >> 2] = c2;
          b2[a3 >> 2] = 0;
          d2 = e4;
          e4 = 0;
        } else {
          e4 = f3;
        }
        if ((d2 | 0) < 0) {
          e4 = e4 - d2 | 0;
          b2[a3 >> 2] = e4;
          c2 = c2 - d2 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = 0;
          d2 = 0;
        }
        g3 = e4 - c2 | 0;
        f3 = d2 - c2 | 0;
        if ((c2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[h2 >> 2] = f3;
          b2[i2 >> 2] = 0;
          e4 = g3;
          c2 = 0;
        } else {
          f3 = d2;
        }
        d2 = (f3 | 0) < (e4 | 0) ? f3 : e4;
        d2 = (c2 | 0) < (d2 | 0) ? c2 : d2;
        if ((d2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = e4 - d2;
        b2[h2 >> 2] = f3 - d2;
        b2[i2 >> 2] = c2 - d2;
        return;
      }
      function Va(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        f3 = b2[a3 >> 2] | 0;
        h2 = a3 + 4 | 0;
        c2 = b2[h2 >> 2] | 0;
        i2 = a3 + 8 | 0;
        d2 = b2[i2 >> 2] | 0;
        e4 = (c2 << 1) + f3 | 0;
        f3 = d2 + (f3 << 1) | 0;
        b2[a3 >> 2] = f3;
        b2[h2 >> 2] = e4;
        c2 = (d2 << 1) + c2 | 0;
        b2[i2 >> 2] = c2;
        d2 = e4 - f3 | 0;
        if ((f3 | 0) < 0) {
          c2 = c2 - f3 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = c2;
          b2[a3 >> 2] = 0;
          f3 = 0;
        } else {
          d2 = e4;
        }
        if ((d2 | 0) < 0) {
          f3 = f3 - d2 | 0;
          b2[a3 >> 2] = f3;
          c2 = c2 - d2 | 0;
          b2[i2 >> 2] = c2;
          b2[h2 >> 2] = 0;
          d2 = 0;
        }
        g3 = f3 - c2 | 0;
        e4 = d2 - c2 | 0;
        if ((c2 | 0) < 0) {
          b2[a3 >> 2] = g3;
          b2[h2 >> 2] = e4;
          b2[i2 >> 2] = 0;
          f3 = g3;
          c2 = 0;
        } else {
          e4 = d2;
        }
        d2 = (e4 | 0) < (f3 | 0) ? e4 : f3;
        d2 = (c2 | 0) < (d2 | 0) ? c2 : d2;
        if ((d2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = f3 - d2;
        b2[h2 >> 2] = e4 - d2;
        b2[i2 >> 2] = c2 - d2;
        return;
      }
      function Wa(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = (b2[a3 >> 2] | 0) - (b2[c2 >> 2] | 0) | 0;
        i2 = (h2 | 0) < 0;
        e4 = (b2[a3 + 4 >> 2] | 0) - (b2[c2 + 4 >> 2] | 0) - (i2 ? h2 : 0) | 0;
        g3 = (e4 | 0) < 0;
        f3 = (i2 ? 0 - h2 | 0 : 0) + (b2[a3 + 8 >> 2] | 0) - (b2[c2 + 8 >> 2] | 0) + (g3 ? 0 - e4 | 0 : 0) | 0;
        a3 = (f3 | 0) < 0;
        c2 = a3 ? 0 : f3;
        d2 = (g3 ? 0 : e4) - (a3 ? f3 : 0) | 0;
        f3 = (i2 ? 0 : h2) - (g3 ? e4 : 0) - (a3 ? f3 : 0) | 0;
        a3 = (d2 | 0) < (f3 | 0) ? d2 : f3;
        a3 = (c2 | 0) < (a3 | 0) ? c2 : a3;
        e4 = (a3 | 0) > 0;
        c2 = c2 - (e4 ? a3 : 0) | 0;
        d2 = d2 - (e4 ? a3 : 0) | 0;
        a3 = f3 - (e4 ? a3 : 0) | 0;
        a3 = (a3 | 0) > -1 ? a3 : 0 - a3 | 0;
        d2 = (d2 | 0) > -1 ? d2 : 0 - d2 | 0;
        c2 = (c2 | 0) > -1 ? c2 : 0 - c2 | 0;
        c2 = (d2 | 0) > (c2 | 0) ? d2 : c2;
        return ((a3 | 0) > (c2 | 0) ? a3 : c2) | 0;
      }
      function Xa(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0;
        d2 = b2[a3 + 8 >> 2] | 0;
        b2[c2 >> 2] = (b2[a3 >> 2] | 0) - d2;
        b2[c2 + 4 >> 2] = (b2[a3 + 4 >> 2] | 0) - d2;
        return;
      }
      function Ya(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        e4 = b2[a3 >> 2] | 0;
        b2[c2 >> 2] = e4;
        f3 = b2[a3 + 4 >> 2] | 0;
        h2 = c2 + 4 | 0;
        b2[h2 >> 2] = f3;
        i2 = c2 + 8 | 0;
        b2[i2 >> 2] = 0;
        d2 = (f3 | 0) < (e4 | 0);
        a3 = d2 ? e4 : f3;
        d2 = d2 ? f3 : e4;
        do {
          if ((d2 | 0) < 0) {
            if ((a3 | 0) > 0) {
              if ((a3 | -2147483648 | 0) < (d2 | 0) & ((d2 | 0) != -2147483648 & (2147483647 - a3 | 0) >= (d2 | 0))) {
                break;
              } else {
                a3 = 1;
              }
              return a3 | 0;
            }
            if ((d2 | 0) == -2147483648 | (-2147483648 - a3 | 0) > (d2 | 0)) {
              c2 = 1;
              return c2 | 0;
            }
            if ((a3 | 0) > -1) {
              if ((a3 | -2147483648 | 0) < (d2 | 0)) {
                break;
              } else {
                a3 = 1;
              }
              return a3 | 0;
            } else {
              if ((a3 ^ -2147483648 | 0) < (d2 | 0)) {
                a3 = 1;
              } else {
                break;
              }
              return a3 | 0;
            }
          }
        } while (0);
        a3 = f3 - e4 | 0;
        if ((e4 | 0) < 0) {
          d2 = 0 - e4 | 0;
          b2[h2 >> 2] = a3;
          b2[i2 >> 2] = d2;
          b2[c2 >> 2] = 0;
          e4 = 0;
        } else {
          a3 = f3;
          d2 = 0;
        }
        if ((a3 | 0) < 0) {
          e4 = e4 - a3 | 0;
          b2[c2 >> 2] = e4;
          d2 = d2 - a3 | 0;
          b2[i2 >> 2] = d2;
          b2[h2 >> 2] = 0;
          a3 = 0;
        }
        g3 = e4 - d2 | 0;
        f3 = a3 - d2 | 0;
        if ((d2 | 0) < 0) {
          b2[c2 >> 2] = g3;
          b2[h2 >> 2] = f3;
          b2[i2 >> 2] = 0;
          a3 = f3;
          f3 = g3;
          d2 = 0;
        } else {
          f3 = e4;
        }
        e4 = (a3 | 0) < (f3 | 0) ? a3 : f3;
        e4 = (d2 | 0) < (e4 | 0) ? d2 : e4;
        if ((e4 | 0) <= 0) {
          c2 = 0;
          return c2 | 0;
        }
        b2[c2 >> 2] = f3 - e4;
        b2[h2 >> 2] = a3 - e4;
        b2[i2 >> 2] = d2 - e4;
        c2 = 0;
        return c2 | 0;
      }
      function Za(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0;
        c2 = a3 + 8 | 0;
        f3 = b2[c2 >> 2] | 0;
        d2 = f3 - (b2[a3 >> 2] | 0) | 0;
        b2[a3 >> 2] = d2;
        e4 = a3 + 4 | 0;
        a3 = (b2[e4 >> 2] | 0) - f3 | 0;
        b2[e4 >> 2] = a3;
        b2[c2 >> 2] = 0 - (a3 + d2);
        return;
      }
      function _a3(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        d2 = b2[a3 >> 2] | 0;
        c2 = 0 - d2 | 0;
        b2[a3 >> 2] = c2;
        h2 = a3 + 8 | 0;
        b2[h2 >> 2] = 0;
        i2 = a3 + 4 | 0;
        e4 = b2[i2 >> 2] | 0;
        f3 = e4 + d2 | 0;
        if ((d2 | 0) > 0) {
          b2[i2 >> 2] = f3;
          b2[h2 >> 2] = d2;
          b2[a3 >> 2] = 0;
          c2 = 0;
          e4 = f3;
        } else {
          d2 = 0;
        }
        if ((e4 | 0) < 0) {
          g3 = c2 - e4 | 0;
          b2[a3 >> 2] = g3;
          d2 = d2 - e4 | 0;
          b2[h2 >> 2] = d2;
          b2[i2 >> 2] = 0;
          f3 = g3 - d2 | 0;
          c2 = 0 - d2 | 0;
          if ((d2 | 0) < 0) {
            b2[a3 >> 2] = f3;
            b2[i2 >> 2] = c2;
            b2[h2 >> 2] = 0;
            e4 = c2;
            d2 = 0;
          } else {
            e4 = 0;
            f3 = g3;
          }
        } else {
          f3 = c2;
        }
        c2 = (e4 | 0) < (f3 | 0) ? e4 : f3;
        c2 = (d2 | 0) < (c2 | 0) ? d2 : c2;
        if ((c2 | 0) <= 0) {
          return;
        }
        b2[a3 >> 2] = f3 - c2;
        b2[i2 >> 2] = e4 - c2;
        b2[h2 >> 2] = d2 - c2;
        return;
      }
      function $a(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0;
        m2 = T2;
        T2 = T2 + 64 | 0;
        l2 = m2;
        i2 = m2 + 56 | 0;
        if (!(true & (c2 & 2013265920 | 0) == 134217728 & (true & (e4 & 2013265920 | 0) == 134217728))) {
          f3 = 5;
          T2 = m2;
          return f3 | 0;
        }
        if ((a3 | 0) == (d2 | 0) & (c2 | 0) == (e4 | 0)) {
          b2[f3 >> 2] = 0;
          f3 = 0;
          T2 = m2;
          return f3 | 0;
        }
        h2 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        h2 = h2 & 15;
        k2 = vd(d2 | 0, e4 | 0, 52) | 0;
        H2() | 0;
        if ((h2 | 0) != (k2 & 15 | 0)) {
          f3 = 12;
          T2 = m2;
          return f3 | 0;
        }
        g3 = h2 + -1 | 0;
        if (h2 >>> 0 > 1) {
          vb(a3, c2, g3, l2) | 0;
          vb(d2, e4, g3, i2) | 0;
          k2 = l2;
          j2 = b2[k2 >> 2] | 0;
          k2 = b2[k2 + 4 >> 2] | 0;
          a:
            do {
              if ((j2 | 0) == (b2[i2 >> 2] | 0) ? (k2 | 0) == (b2[i2 + 4 >> 2] | 0) : 0) {
                h2 = (h2 ^ 15) * 3 | 0;
                g3 = vd(a3 | 0, c2 | 0, h2 | 0) | 0;
                H2() | 0;
                g3 = g3 & 7;
                h2 = vd(d2 | 0, e4 | 0, h2 | 0) | 0;
                H2() | 0;
                h2 = h2 & 7;
                do {
                  if (!((g3 | 0) == 0 | (h2 | 0) == 0)) {
                    if ((g3 | 0) == 7) {
                      g3 = 5;
                    } else {
                      if ((g3 | 0) == 1 | (h2 | 0) == 1 ? xb(j2, k2) | 0 : 0) {
                        g3 = 5;
                        break;
                      }
                      if ((b2[15536 + (g3 << 2) >> 2] | 0) != (h2 | 0) ? (b2[15568 + (g3 << 2) >> 2] | 0) != (h2 | 0) : 0) {
                        break a;
                      }
                      b2[f3 >> 2] = 1;
                      g3 = 0;
                    }
                  } else {
                    b2[f3 >> 2] = 1;
                    g3 = 0;
                  }
                } while (0);
                f3 = g3;
                T2 = m2;
                return f3 | 0;
              }
            } while (0);
        }
        g3 = l2;
        h2 = g3 + 56 | 0;
        do {
          b2[g3 >> 2] = 0;
          g3 = g3 + 4 | 0;
        } while ((g3 | 0) < (h2 | 0));
        aa2(a3, c2, 1, l2) | 0;
        c2 = l2;
        if (((((!((b2[c2 >> 2] | 0) == (d2 | 0) ? (b2[c2 + 4 >> 2] | 0) == (e4 | 0) : 0) ? (c2 = l2 + 8 | 0, !((b2[c2 >> 2] | 0) == (d2 | 0) ? (b2[c2 + 4 >> 2] | 0) == (e4 | 0) : 0)) : 0) ? (c2 = l2 + 16 | 0, !((b2[c2 >> 2] | 0) == (d2 | 0) ? (b2[c2 + 4 >> 2] | 0) == (e4 | 0) : 0)) : 0) ? (c2 = l2 + 24 | 0, !((b2[c2 >> 2] | 0) == (d2 | 0) ? (b2[c2 + 4 >> 2] | 0) == (e4 | 0) : 0)) : 0) ? (c2 = l2 + 32 | 0, !((b2[c2 >> 2] | 0) == (d2 | 0) ? (b2[c2 + 4 >> 2] | 0) == (e4 | 0) : 0)) : 0) ? (c2 = l2 + 40 | 0, !((b2[c2 >> 2] | 0) == (d2 | 0) ? (b2[c2 + 4 >> 2] | 0) == (e4 | 0) : 0)) : 0) {
          g3 = l2 + 48 | 0;
          g3 = ((b2[g3 >> 2] | 0) == (d2 | 0) ? (b2[g3 + 4 >> 2] | 0) == (e4 | 0) : 0) & 1;
        } else {
          g3 = 1;
        }
        b2[f3 >> 2] = g3;
        f3 = 0;
        T2 = m2;
        return f3 | 0;
      }
      function ab2(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        d2 = fa(a3, c2, d2, e4) | 0;
        if ((d2 | 0) == 7) {
          f3 = 11;
          return f3 | 0;
        }
        e4 = wd(d2 | 0, 0, 56) | 0;
        c2 = c2 & -2130706433 | (H2() | 0) | 268435456;
        b2[f3 >> 2] = a3 | e4;
        b2[f3 + 4 >> 2] = c2;
        f3 = 0;
        return f3 | 0;
      }
      function bb2(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        if (!(true & (c2 & 2013265920 | 0) == 268435456)) {
          d2 = 6;
          return d2 | 0;
        }
        b2[d2 >> 2] = a3;
        b2[d2 + 4 >> 2] = c2 & -2130706433 | 134217728;
        d2 = 0;
        return d2 | 0;
      }
      function cb2(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0;
        f3 = T2;
        T2 = T2 + 16 | 0;
        e4 = f3;
        b2[e4 >> 2] = 0;
        if (!(true & (c2 & 2013265920 | 0) == 268435456)) {
          e4 = 6;
          T2 = f3;
          return e4 | 0;
        }
        g3 = vd(a3 | 0, c2 | 0, 56) | 0;
        H2() | 0;
        e4 = ea(a3, c2 & -2130706433 | 134217728, g3 & 7, e4, d2) | 0;
        T2 = f3;
        return e4 | 0;
      }
      function db(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0;
        c2 = vd(a3 | 0, b3 | 0, 56) | 0;
        H2() | 0;
        switch (c2 & 7) {
          case 0:
          case 7: {
            c2 = 0;
            return c2 | 0;
          }
        }
        c2 = b3 & -2130706433 | 134217728;
        if (!(true & (b3 & 2013265920 | 0) == 268435456)) {
          c2 = 0;
          return c2 | 0;
        }
        if (true & (b3 & 117440512 | 0) == 16777216 & (xb(a3, c2) | 0) != 0) {
          c2 = 0;
          return c2 | 0;
        }
        c2 = ub(a3, c2) | 0;
        return c2 | 0;
      }
      function eb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0;
        f3 = T2;
        T2 = T2 + 16 | 0;
        e4 = f3;
        if (!(true & (c2 & 2013265920 | 0) == 268435456)) {
          e4 = 6;
          T2 = f3;
          return e4 | 0;
        }
        g3 = c2 & -2130706433 | 134217728;
        h2 = d2;
        b2[h2 >> 2] = a3;
        b2[h2 + 4 >> 2] = g3;
        b2[e4 >> 2] = 0;
        c2 = vd(a3 | 0, c2 | 0, 56) | 0;
        H2() | 0;
        e4 = ea(a3, g3, c2 & 7, e4, d2 + 8 | 0) | 0;
        T2 = f3;
        return e4 | 0;
      }
      function fb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0;
        f3 = (xb(a3, c2) | 0) == 0;
        c2 = c2 & -2130706433;
        e4 = d2;
        b2[e4 >> 2] = f3 ? a3 : 0;
        b2[e4 + 4 >> 2] = f3 ? c2 | 285212672 : 0;
        e4 = d2 + 8 | 0;
        b2[e4 >> 2] = a3;
        b2[e4 + 4 >> 2] = c2 | 301989888;
        e4 = d2 + 16 | 0;
        b2[e4 >> 2] = a3;
        b2[e4 + 4 >> 2] = c2 | 318767104;
        e4 = d2 + 24 | 0;
        b2[e4 >> 2] = a3;
        b2[e4 + 4 >> 2] = c2 | 335544320;
        e4 = d2 + 32 | 0;
        b2[e4 >> 2] = a3;
        b2[e4 + 4 >> 2] = c2 | 352321536;
        d2 = d2 + 40 | 0;
        b2[d2 >> 2] = a3;
        b2[d2 + 4 >> 2] = c2 | 369098752;
        return 0;
      }
      function gb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0;
        h2 = T2;
        T2 = T2 + 16 | 0;
        f3 = h2;
        g3 = c2 & -2130706433 | 134217728;
        if (!(true & (c2 & 2013265920 | 0) == 268435456)) {
          g3 = 6;
          T2 = h2;
          return g3 | 0;
        }
        e4 = vd(a3 | 0, c2 | 0, 56) | 0;
        H2() | 0;
        e4 = Uc(a3, g3, e4 & 7) | 0;
        if ((e4 | 0) == -1) {
          b2[d2 >> 2] = 0;
          g3 = 6;
          T2 = h2;
          return g3 | 0;
        }
        if (Ob(a3, g3, f3) | 0) {
          I2(23313, 22484, 282, 22499);
        }
        c2 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        c2 = c2 & 15;
        if (!(xb(a3, g3) | 0)) {
          qb(f3, c2, e4, 2, d2);
        } else {
          mb(f3, c2, e4, 2, d2);
        }
        g3 = 0;
        T2 = h2;
        return g3 | 0;
      }
      function hb(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0;
        d2 = T2;
        T2 = T2 + 16 | 0;
        e4 = d2;
        ib(a3, b3, c2, e4);
        Ca(e4, c2 + 4 | 0);
        T2 = d2;
        return;
      }
      function ib(a3, c2, d2, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0;
        j2 = T2;
        T2 = T2 + 16 | 0;
        k2 = j2;
        jb(a3, d2, k2);
        h2 = +w2(+(1 - +e3[k2 >> 3] * 0.5));
        if (h2 < 1e-16) {
          b2[f3 >> 2] = 0;
          b2[f3 + 4 >> 2] = 0;
          b2[f3 + 8 >> 2] = 0;
          b2[f3 + 12 >> 2] = 0;
          T2 = j2;
          return;
        }
        k2 = b2[d2 >> 2] | 0;
        g3 = +e3[15920 + (k2 * 24 | 0) >> 3];
        g3 = +Zb(g3 - +Zb(+cc2(15600 + (k2 << 4) | 0, a3)));
        if (!(Lb(c2) | 0)) {
          i2 = g3;
        } else {
          i2 = +Zb(g3 + -0.3334731722518321);
        }
        g3 = +v5(+h2) / 0.381966011250105;
        if ((c2 | 0) > 0) {
          a3 = 0;
          do {
            g3 = g3 * 2.6457513110645907;
            a3 = a3 + 1 | 0;
          } while ((a3 | 0) != (c2 | 0));
        }
        h2 = +t2(+i2) * g3;
        e3[f3 >> 3] = h2;
        i2 = +u2(+i2) * g3;
        e3[f3 + 8 >> 3] = i2;
        T2 = j2;
        return;
      }
      function jb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0;
        h2 = T2;
        T2 = T2 + 32 | 0;
        g3 = h2;
        Tc(a3, g3);
        b2[c2 >> 2] = 0;
        e3[d2 >> 3] = 5;
        f3 = +Sc(16400, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 0;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16424, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 1;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16448, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 2;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16472, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 3;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16496, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 4;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16520, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 5;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16544, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 6;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16568, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 7;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16592, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 8;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16616, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 9;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16640, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 10;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16664, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 11;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16688, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 12;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16712, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 13;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16736, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 14;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16760, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 15;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16784, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 16;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16808, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 17;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16832, g3);
        if (f3 < +e3[d2 >> 3]) {
          b2[c2 >> 2] = 18;
          e3[d2 >> 3] = f3;
        }
        f3 = +Sc(16856, g3);
        if (!(f3 < +e3[d2 >> 3])) {
          T2 = h2;
          return;
        }
        b2[c2 >> 2] = 19;
        e3[d2 >> 3] = f3;
        T2 = h2;
        return;
      }
      function kb(a3, c2, d2, f3, g3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        var h2 = 0, i2 = 0;
        h2 = +Pc(a3);
        if (h2 < 1e-16) {
          c2 = 15600 + (c2 << 4) | 0;
          b2[g3 >> 2] = b2[c2 >> 2];
          b2[g3 + 4 >> 2] = b2[c2 + 4 >> 2];
          b2[g3 + 8 >> 2] = b2[c2 + 8 >> 2];
          b2[g3 + 12 >> 2] = b2[c2 + 12 >> 2];
          return;
        }
        i2 = +z2(+ +e3[a3 + 8 >> 3], + +e3[a3 >> 3]);
        if ((d2 | 0) > 0) {
          a3 = 0;
          do {
            h2 = h2 / 2.6457513110645907;
            a3 = a3 + 1 | 0;
          } while ((a3 | 0) != (d2 | 0));
        }
        if (!f3) {
          h2 = +y2(+(h2 * 0.381966011250105));
          if (Lb(d2) | 0) {
            i2 = +Zb(i2 + 0.3334731722518321);
          }
        } else {
          h2 = h2 / 3;
          d2 = (Lb(d2) | 0) == 0;
          h2 = +y2(+((d2 ? h2 : h2 / 2.6457513110645907) * 0.381966011250105));
        }
        dc(15600 + (c2 << 4) | 0, +Zb(+e3[15920 + (c2 * 24 | 0) >> 3] - i2), h2, g3);
        return;
      }
      function lb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0;
        e4 = T2;
        T2 = T2 + 16 | 0;
        f3 = e4;
        Ea(a3 + 4 | 0, f3);
        kb(f3, b2[a3 >> 2] | 0, c2, 0, d2);
        T2 = e4;
        return;
      }
      function mb(a3, c2, d2, f3, g3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        var h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0, A3 = 0, B3 = 0, C3 = 0, D3 = 0, E4 = 0, F2 = 0, G3 = 0, H4 = 0, J3 = 0;
        G3 = T2;
        T2 = T2 + 272 | 0;
        h2 = G3 + 256 | 0;
        u3 = G3 + 240 | 0;
        D3 = G3;
        E4 = G3 + 224 | 0;
        F2 = G3 + 208 | 0;
        v6 = G3 + 176 | 0;
        w3 = G3 + 160 | 0;
        x3 = G3 + 192 | 0;
        y3 = G3 + 144 | 0;
        z3 = G3 + 128 | 0;
        A3 = G3 + 112 | 0;
        B3 = G3 + 96 | 0;
        C3 = G3 + 80 | 0;
        b2[h2 >> 2] = c2;
        b2[u3 >> 2] = b2[a3 >> 2];
        b2[u3 + 4 >> 2] = b2[a3 + 4 >> 2];
        b2[u3 + 8 >> 2] = b2[a3 + 8 >> 2];
        b2[u3 + 12 >> 2] = b2[a3 + 12 >> 2];
        nb(u3, h2, D3);
        b2[g3 >> 2] = 0;
        u3 = f3 + d2 + ((f3 | 0) == 5 & 1) | 0;
        if ((u3 | 0) <= (d2 | 0)) {
          T2 = G3;
          return;
        }
        k2 = b2[h2 >> 2] | 0;
        l2 = E4 + 4 | 0;
        m2 = v6 + 4 | 0;
        n2 = d2 + 5 | 0;
        o2 = 16880 + (k2 << 2) | 0;
        p3 = 16960 + (k2 << 2) | 0;
        q3 = z3 + 8 | 0;
        r3 = A3 + 8 | 0;
        s3 = B3 + 8 | 0;
        t3 = F2 + 4 | 0;
        j2 = d2;
        a:
          while (1) {
            i2 = D3 + (((j2 | 0) % 5 | 0) << 4) | 0;
            b2[F2 >> 2] = b2[i2 >> 2];
            b2[F2 + 4 >> 2] = b2[i2 + 4 >> 2];
            b2[F2 + 8 >> 2] = b2[i2 + 8 >> 2];
            b2[F2 + 12 >> 2] = b2[i2 + 12 >> 2];
            do {
            } while ((ob(F2, k2, 0, 1) | 0) == 2);
            if ((j2 | 0) > (d2 | 0) & (Lb(c2) | 0) != 0) {
              b2[v6 >> 2] = b2[F2 >> 2];
              b2[v6 + 4 >> 2] = b2[F2 + 4 >> 2];
              b2[v6 + 8 >> 2] = b2[F2 + 8 >> 2];
              b2[v6 + 12 >> 2] = b2[F2 + 12 >> 2];
              Ea(l2, w3);
              f3 = b2[v6 >> 2] | 0;
              h2 = b2[17040 + (f3 * 80 | 0) + (b2[E4 >> 2] << 2) >> 2] | 0;
              b2[v6 >> 2] = b2[18640 + (f3 * 80 | 0) + (h2 * 20 | 0) >> 2];
              i2 = b2[18640 + (f3 * 80 | 0) + (h2 * 20 | 0) + 16 >> 2] | 0;
              if ((i2 | 0) > 0) {
                a3 = 0;
                do {
                  Qa(m2);
                  a3 = a3 + 1 | 0;
                } while ((a3 | 0) < (i2 | 0));
              }
              i2 = 18640 + (f3 * 80 | 0) + (h2 * 20 | 0) + 4 | 0;
              b2[x3 >> 2] = b2[i2 >> 2];
              b2[x3 + 4 >> 2] = b2[i2 + 4 >> 2];
              b2[x3 + 8 >> 2] = b2[i2 + 8 >> 2];
              Ha(x3, (b2[o2 >> 2] | 0) * 3 | 0);
              Fa(m2, x3, m2);
              Da(m2);
              Ea(m2, y3);
              H4 = +(b2[p3 >> 2] | 0);
              e3[z3 >> 3] = H4 * 3;
              e3[q3 >> 3] = 0;
              J3 = H4 * -1.5;
              e3[A3 >> 3] = J3;
              e3[r3 >> 3] = H4 * 2.598076211353316;
              e3[B3 >> 3] = J3;
              e3[s3 >> 3] = H4 * -2.598076211353316;
              switch (b2[17040 + ((b2[v6 >> 2] | 0) * 80 | 0) + (b2[F2 >> 2] << 2) >> 2] | 0) {
                case 1: {
                  a3 = A3;
                  f3 = z3;
                  break;
                }
                case 3: {
                  a3 = B3;
                  f3 = A3;
                  break;
                }
                case 2: {
                  a3 = z3;
                  f3 = B3;
                  break;
                }
                default: {
                  a3 = 12;
                  break a;
                }
              }
              Qc(w3, y3, f3, a3, C3);
              kb(C3, b2[v6 >> 2] | 0, k2, 1, g3 + 8 + (b2[g3 >> 2] << 4) | 0);
              b2[g3 >> 2] = (b2[g3 >> 2] | 0) + 1;
            }
            if ((j2 | 0) < (n2 | 0)) {
              Ea(t3, v6);
              kb(v6, b2[F2 >> 2] | 0, k2, 1, g3 + 8 + (b2[g3 >> 2] << 4) | 0);
              b2[g3 >> 2] = (b2[g3 >> 2] | 0) + 1;
            }
            b2[E4 >> 2] = b2[F2 >> 2];
            b2[E4 + 4 >> 2] = b2[F2 + 4 >> 2];
            b2[E4 + 8 >> 2] = b2[F2 + 8 >> 2];
            b2[E4 + 12 >> 2] = b2[F2 + 12 >> 2];
            j2 = j2 + 1 | 0;
            if ((j2 | 0) >= (u3 | 0)) {
              a3 = 3;
              break;
            }
          }
        if ((a3 | 0) == 3) {
          T2 = G3;
          return;
        } else if ((a3 | 0) == 12) {
          I2(22522, 22569, 571, 22579);
        }
      }
      function nb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        j2 = T2;
        T2 = T2 + 128 | 0;
        e4 = j2 + 64 | 0;
        f3 = j2;
        g3 = e4;
        h2 = 20240;
        i2 = g3 + 60 | 0;
        do {
          b2[g3 >> 2] = b2[h2 >> 2];
          g3 = g3 + 4 | 0;
          h2 = h2 + 4 | 0;
        } while ((g3 | 0) < (i2 | 0));
        g3 = f3;
        h2 = 20304;
        i2 = g3 + 60 | 0;
        do {
          b2[g3 >> 2] = b2[h2 >> 2];
          g3 = g3 + 4 | 0;
          h2 = h2 + 4 | 0;
        } while ((g3 | 0) < (i2 | 0));
        i2 = (Lb(b2[c2 >> 2] | 0) | 0) == 0;
        e4 = i2 ? e4 : f3;
        f3 = a3 + 4 | 0;
        Ua(f3);
        Va(f3);
        if (Lb(b2[c2 >> 2] | 0) | 0) {
          Oa(f3);
          b2[c2 >> 2] = (b2[c2 >> 2] | 0) + 1;
        }
        b2[d2 >> 2] = b2[a3 >> 2];
        c2 = d2 + 4 | 0;
        Fa(f3, e4, c2);
        Da(c2);
        b2[d2 + 16 >> 2] = b2[a3 >> 2];
        c2 = d2 + 20 | 0;
        Fa(f3, e4 + 12 | 0, c2);
        Da(c2);
        b2[d2 + 32 >> 2] = b2[a3 >> 2];
        c2 = d2 + 36 | 0;
        Fa(f3, e4 + 24 | 0, c2);
        Da(c2);
        b2[d2 + 48 >> 2] = b2[a3 >> 2];
        c2 = d2 + 52 | 0;
        Fa(f3, e4 + 36 | 0, c2);
        Da(c2);
        b2[d2 + 64 >> 2] = b2[a3 >> 2];
        d2 = d2 + 68 | 0;
        Fa(f3, e4 + 48 | 0, d2);
        Da(d2);
        T2 = j2;
        return;
      }
      function ob(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0;
        p3 = T2;
        T2 = T2 + 32 | 0;
        n2 = p3 + 12 | 0;
        i2 = p3;
        o2 = a3 + 4 | 0;
        m2 = b2[16960 + (c2 << 2) >> 2] | 0;
        l2 = (e4 | 0) != 0;
        m2 = l2 ? m2 * 3 | 0 : m2;
        f3 = b2[o2 >> 2] | 0;
        k2 = a3 + 8 | 0;
        h2 = b2[k2 >> 2] | 0;
        if (l2) {
          g3 = a3 + 12 | 0;
          e4 = b2[g3 >> 2] | 0;
          f3 = h2 + f3 + e4 | 0;
          if ((f3 | 0) == (m2 | 0)) {
            o2 = 1;
            T2 = p3;
            return o2 | 0;
          } else {
            j2 = g3;
          }
        } else {
          j2 = a3 + 12 | 0;
          e4 = b2[j2 >> 2] | 0;
          f3 = h2 + f3 + e4 | 0;
        }
        if ((f3 | 0) <= (m2 | 0)) {
          o2 = 0;
          T2 = p3;
          return o2 | 0;
        }
        do {
          if ((e4 | 0) > 0) {
            e4 = b2[a3 >> 2] | 0;
            if ((h2 | 0) > 0) {
              g3 = 18640 + (e4 * 80 | 0) + 60 | 0;
              e4 = a3;
              break;
            }
            e4 = 18640 + (e4 * 80 | 0) + 40 | 0;
            if (!d2) {
              g3 = e4;
              e4 = a3;
            } else {
              Ba(n2, m2, 0, 0);
              Ga(o2, n2, i2);
              Ra(i2);
              Fa(i2, n2, o2);
              g3 = e4;
              e4 = a3;
            }
          } else {
            g3 = 18640 + ((b2[a3 >> 2] | 0) * 80 | 0) + 20 | 0;
            e4 = a3;
          }
        } while (0);
        b2[e4 >> 2] = b2[g3 >> 2];
        f3 = g3 + 16 | 0;
        if ((b2[f3 >> 2] | 0) > 0) {
          e4 = 0;
          do {
            Qa(o2);
            e4 = e4 + 1 | 0;
          } while ((e4 | 0) < (b2[f3 >> 2] | 0));
        }
        a3 = g3 + 4 | 0;
        b2[n2 >> 2] = b2[a3 >> 2];
        b2[n2 + 4 >> 2] = b2[a3 + 4 >> 2];
        b2[n2 + 8 >> 2] = b2[a3 + 8 >> 2];
        c2 = b2[16880 + (c2 << 2) >> 2] | 0;
        Ha(n2, l2 ? c2 * 3 | 0 : c2);
        Fa(o2, n2, o2);
        Da(o2);
        if (l2) {
          e4 = ((b2[k2 >> 2] | 0) + (b2[o2 >> 2] | 0) + (b2[j2 >> 2] | 0) | 0) == (m2 | 0) ? 1 : 2;
        } else {
          e4 = 2;
        }
        o2 = e4;
        T2 = p3;
        return o2 | 0;
      }
      function pb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0;
        do {
          c2 = ob(a3, b3, 0, 1) | 0;
        } while ((c2 | 0) == 2);
        return c2 | 0;
      }
      function qb(a3, c2, d2, f3, g3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        var h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0, A3 = 0, B3 = 0, C3 = 0, D3 = 0;
        B3 = T2;
        T2 = T2 + 240 | 0;
        h2 = B3 + 224 | 0;
        x3 = B3 + 208 | 0;
        y3 = B3;
        z3 = B3 + 192 | 0;
        A3 = B3 + 176 | 0;
        s3 = B3 + 160 | 0;
        t3 = B3 + 144 | 0;
        u3 = B3 + 128 | 0;
        v6 = B3 + 112 | 0;
        w3 = B3 + 96 | 0;
        b2[h2 >> 2] = c2;
        b2[x3 >> 2] = b2[a3 >> 2];
        b2[x3 + 4 >> 2] = b2[a3 + 4 >> 2];
        b2[x3 + 8 >> 2] = b2[a3 + 8 >> 2];
        b2[x3 + 12 >> 2] = b2[a3 + 12 >> 2];
        rb(x3, h2, y3);
        b2[g3 >> 2] = 0;
        r3 = f3 + d2 + ((f3 | 0) == 6 & 1) | 0;
        if ((r3 | 0) <= (d2 | 0)) {
          T2 = B3;
          return;
        }
        k2 = b2[h2 >> 2] | 0;
        l2 = d2 + 6 | 0;
        m2 = 16960 + (k2 << 2) | 0;
        n2 = t3 + 8 | 0;
        o2 = u3 + 8 | 0;
        p3 = v6 + 8 | 0;
        q3 = z3 + 4 | 0;
        i2 = 0;
        j2 = d2;
        f3 = -1;
        a:
          while (1) {
            h2 = (j2 | 0) % 6 | 0;
            a3 = y3 + (h2 << 4) | 0;
            b2[z3 >> 2] = b2[a3 >> 2];
            b2[z3 + 4 >> 2] = b2[a3 + 4 >> 2];
            b2[z3 + 8 >> 2] = b2[a3 + 8 >> 2];
            b2[z3 + 12 >> 2] = b2[a3 + 12 >> 2];
            a3 = i2;
            i2 = ob(z3, k2, 0, 1) | 0;
            if ((j2 | 0) > (d2 | 0) & (Lb(c2) | 0) != 0 ? (a3 | 0) != 1 ? (b2[z3 >> 2] | 0) != (f3 | 0) : 0 : 0) {
              Ea(y3 + (((h2 + 5 | 0) % 6 | 0) << 4) + 4 | 0, A3);
              Ea(y3 + (h2 << 4) + 4 | 0, s3);
              C3 = +(b2[m2 >> 2] | 0);
              e3[t3 >> 3] = C3 * 3;
              e3[n2 >> 3] = 0;
              D3 = C3 * -1.5;
              e3[u3 >> 3] = D3;
              e3[o2 >> 3] = C3 * 2.598076211353316;
              e3[v6 >> 3] = D3;
              e3[p3 >> 3] = C3 * -2.598076211353316;
              h2 = b2[x3 >> 2] | 0;
              switch (b2[17040 + (h2 * 80 | 0) + (((f3 | 0) == (h2 | 0) ? b2[z3 >> 2] | 0 : f3) << 2) >> 2] | 0) {
                case 1: {
                  a3 = u3;
                  f3 = t3;
                  break;
                }
                case 3: {
                  a3 = v6;
                  f3 = u3;
                  break;
                }
                case 2: {
                  a3 = t3;
                  f3 = v6;
                  break;
                }
                default: {
                  a3 = 8;
                  break a;
                }
              }
              Qc(A3, s3, f3, a3, w3);
              if (!(Rc(A3, w3) | 0) ? !(Rc(s3, w3) | 0) : 0) {
                kb(w3, b2[x3 >> 2] | 0, k2, 1, g3 + 8 + (b2[g3 >> 2] << 4) | 0);
                b2[g3 >> 2] = (b2[g3 >> 2] | 0) + 1;
              }
            }
            if ((j2 | 0) < (l2 | 0)) {
              Ea(q3, A3);
              kb(A3, b2[z3 >> 2] | 0, k2, 1, g3 + 8 + (b2[g3 >> 2] << 4) | 0);
              b2[g3 >> 2] = (b2[g3 >> 2] | 0) + 1;
            }
            j2 = j2 + 1 | 0;
            if ((j2 | 0) >= (r3 | 0)) {
              a3 = 3;
              break;
            } else {
              f3 = b2[z3 >> 2] | 0;
            }
          }
        if ((a3 | 0) == 3) {
          T2 = B3;
          return;
        } else if ((a3 | 0) == 8) {
          I2(22606, 22569, 736, 22651);
        }
      }
      function rb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        j2 = T2;
        T2 = T2 + 160 | 0;
        e4 = j2 + 80 | 0;
        f3 = j2;
        g3 = e4;
        h2 = 20368;
        i2 = g3 + 72 | 0;
        do {
          b2[g3 >> 2] = b2[h2 >> 2];
          g3 = g3 + 4 | 0;
          h2 = h2 + 4 | 0;
        } while ((g3 | 0) < (i2 | 0));
        g3 = f3;
        h2 = 20448;
        i2 = g3 + 72 | 0;
        do {
          b2[g3 >> 2] = b2[h2 >> 2];
          g3 = g3 + 4 | 0;
          h2 = h2 + 4 | 0;
        } while ((g3 | 0) < (i2 | 0));
        i2 = (Lb(b2[c2 >> 2] | 0) | 0) == 0;
        e4 = i2 ? e4 : f3;
        f3 = a3 + 4 | 0;
        Ua(f3);
        Va(f3);
        if (Lb(b2[c2 >> 2] | 0) | 0) {
          Oa(f3);
          b2[c2 >> 2] = (b2[c2 >> 2] | 0) + 1;
        }
        b2[d2 >> 2] = b2[a3 >> 2];
        c2 = d2 + 4 | 0;
        Fa(f3, e4, c2);
        Da(c2);
        b2[d2 + 16 >> 2] = b2[a3 >> 2];
        c2 = d2 + 20 | 0;
        Fa(f3, e4 + 12 | 0, c2);
        Da(c2);
        b2[d2 + 32 >> 2] = b2[a3 >> 2];
        c2 = d2 + 36 | 0;
        Fa(f3, e4 + 24 | 0, c2);
        Da(c2);
        b2[d2 + 48 >> 2] = b2[a3 >> 2];
        c2 = d2 + 52 | 0;
        Fa(f3, e4 + 36 | 0, c2);
        Da(c2);
        b2[d2 + 64 >> 2] = b2[a3 >> 2];
        c2 = d2 + 68 | 0;
        Fa(f3, e4 + 48 | 0, c2);
        Da(c2);
        b2[d2 + 80 >> 2] = b2[a3 >> 2];
        d2 = d2 + 84 | 0;
        Fa(f3, e4 + 60 | 0, d2);
        Da(d2);
        T2 = j2;
        return;
      }
      function sb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        b3 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        return b3 & 15 | 0;
      }
      function tb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        b3 = vd(a3 | 0, b3 | 0, 45) | 0;
        H2() | 0;
        return b3 & 127 | 0;
      }
      function ub(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0;
        if (!(true & (b3 & -16777216 | 0) == 134217728)) {
          b3 = 0;
          return b3 | 0;
        }
        g3 = vd(a3 | 0, b3 | 0, 45) | 0;
        H2() | 0;
        g3 = g3 & 127;
        if (g3 >>> 0 > 121) {
          b3 = 0;
          return b3 | 0;
        }
        c2 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        c2 = c2 & 15;
        do {
          if (c2 | 0) {
            e4 = 1;
            d2 = 0;
            while (1) {
              f3 = vd(a3 | 0, b3 | 0, (15 - e4 | 0) * 3 | 0) | 0;
              H2() | 0;
              f3 = f3 & 7;
              if ((f3 | 0) != 0 & (d2 ^ 1)) {
                if ((f3 | 0) == 1 & (ma(g3) | 0) != 0) {
                  h2 = 0;
                  d2 = 13;
                  break;
                } else {
                  d2 = 1;
                }
              }
              if ((f3 | 0) == 7) {
                h2 = 0;
                d2 = 13;
                break;
              }
              if (e4 >>> 0 < c2 >>> 0) {
                e4 = e4 + 1 | 0;
              } else {
                d2 = 9;
                break;
              }
            }
            if ((d2 | 0) == 9) {
              if ((c2 | 0) == 15) {
                h2 = 1;
              } else {
                break;
              }
              return h2 | 0;
            } else if ((d2 | 0) == 13) {
              return h2 | 0;
            }
          }
        } while (0);
        while (1) {
          h2 = vd(a3 | 0, b3 | 0, (14 - c2 | 0) * 3 | 0) | 0;
          H2() | 0;
          if (!((h2 & 7 | 0) == 7 & true)) {
            h2 = 0;
            d2 = 13;
            break;
          }
          if (c2 >>> 0 < 14) {
            c2 = c2 + 1 | 0;
          } else {
            h2 = 1;
            d2 = 13;
            break;
          }
        }
        if ((d2 | 0) == 13) {
          return h2 | 0;
        }
        return 0;
      }
      function vb(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0;
        g3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        g3 = g3 & 15;
        if (d2 >>> 0 > 15) {
          e4 = 4;
          return e4 | 0;
        }
        if ((g3 | 0) < (d2 | 0)) {
          e4 = 12;
          return e4 | 0;
        }
        if ((g3 | 0) == (d2 | 0)) {
          b2[e4 >> 2] = a3;
          b2[e4 + 4 >> 2] = c2;
          e4 = 0;
          return e4 | 0;
        }
        f3 = wd(d2 | 0, 0, 52) | 0;
        f3 = f3 | a3;
        a3 = H2() | 0 | c2 & -15728641;
        if ((g3 | 0) > (d2 | 0)) {
          do {
            c2 = wd(7, 0, (14 - d2 | 0) * 3 | 0) | 0;
            d2 = d2 + 1 | 0;
            f3 = c2 | f3;
            a3 = H2() | 0 | a3;
          } while ((d2 | 0) < (g3 | 0));
        }
        b2[e4 >> 2] = f3;
        b2[e4 + 4 >> 2] = a3;
        e4 = 0;
        return e4 | 0;
      }
      function wb(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0;
        g3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        g3 = g3 & 15;
        if (!((d2 | 0) < 16 & (g3 | 0) <= (d2 | 0))) {
          e4 = 4;
          return e4 | 0;
        }
        f3 = d2 - g3 | 0;
        d2 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        a:
          do {
            if (!(ma(d2 & 127) | 0)) {
              d2 = Cc(7, 0, f3, ((f3 | 0) < 0) << 31 >> 31) | 0;
              f3 = H2() | 0;
            } else {
              b:
                do {
                  if (g3 | 0) {
                    d2 = 1;
                    while (1) {
                      h2 = wd(7, 0, (15 - d2 | 0) * 3 | 0) | 0;
                      if (!((h2 & a3 | 0) == 0 & ((H2() | 0) & c2 | 0) == 0)) {
                        break;
                      }
                      if (d2 >>> 0 < g3 >>> 0) {
                        d2 = d2 + 1 | 0;
                      } else {
                        break b;
                      }
                    }
                    d2 = Cc(7, 0, f3, ((f3 | 0) < 0) << 31 >> 31) | 0;
                    f3 = H2() | 0;
                    break a;
                  }
                } while (0);
              d2 = Cc(7, 0, f3, ((f3 | 0) < 0) << 31 >> 31) | 0;
              d2 = rd(d2 | 0, H2() | 0, 5, 0) | 0;
              d2 = ld(d2 | 0, H2() | 0, -5, -1) | 0;
              d2 = pd(d2 | 0, H2() | 0, 6, 0) | 0;
              d2 = ld(d2 | 0, H2() | 0, 1, 0) | 0;
              f3 = H2() | 0;
            }
          } while (0);
        h2 = e4;
        b2[h2 >> 2] = d2;
        b2[h2 + 4 >> 2] = f3;
        h2 = 0;
        return h2 | 0;
      }
      function xb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0;
        e4 = vd(a3 | 0, b3 | 0, 45) | 0;
        H2() | 0;
        if (!(ma(e4 & 127) | 0)) {
          e4 = 0;
          return e4 | 0;
        }
        e4 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        e4 = e4 & 15;
        a:
          do {
            if (!e4) {
              c2 = 0;
            } else {
              d2 = 1;
              while (1) {
                c2 = vd(a3 | 0, b3 | 0, (15 - d2 | 0) * 3 | 0) | 0;
                H2() | 0;
                c2 = c2 & 7;
                if (c2 | 0) {
                  break a;
                }
                if (d2 >>> 0 < e4 >>> 0) {
                  d2 = d2 + 1 | 0;
                } else {
                  c2 = 0;
                  break;
                }
              }
            }
          } while (0);
        e4 = (c2 | 0) == 0 & 1;
        return e4 | 0;
      }
      function yb(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = T2;
        T2 = T2 + 16 | 0;
        g3 = h2;
        Xb(g3, a3, c2, d2);
        c2 = g3;
        a3 = b2[c2 >> 2] | 0;
        c2 = b2[c2 + 4 >> 2] | 0;
        if ((a3 | 0) == 0 & (c2 | 0) == 0) {
          T2 = h2;
          return 0;
        }
        f3 = 0;
        d2 = 0;
        do {
          i2 = e4 + (f3 << 3) | 0;
          b2[i2 >> 2] = a3;
          b2[i2 + 4 >> 2] = c2;
          f3 = ld(f3 | 0, d2 | 0, 1, 0) | 0;
          d2 = H2() | 0;
          Yb(g3);
          i2 = g3;
          a3 = b2[i2 >> 2] | 0;
          c2 = b2[i2 + 4 >> 2] | 0;
        } while (!((a3 | 0) == 0 & (c2 | 0) == 0));
        T2 = h2;
        return 0;
      }
      function zb(a3, b3, c2, d2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        if ((d2 | 0) < (c2 | 0)) {
          c2 = b3;
          d2 = a3;
          G2(c2 | 0);
          return d2 | 0;
        }
        c2 = wd(-1, -1, ((d2 - c2 | 0) * 3 | 0) + 3 | 0) | 0;
        d2 = wd(~c2 | 0, ~(H2() | 0) | 0, (15 - d2 | 0) * 3 | 0) | 0;
        c2 = ~(H2() | 0) & b3;
        d2 = ~d2 & a3;
        G2(c2 | 0);
        return d2 | 0;
      }
      function Ab(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0;
        f3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        f3 = f3 & 15;
        if (!((d2 | 0) < 16 & (f3 | 0) <= (d2 | 0))) {
          e4 = 4;
          return e4 | 0;
        }
        if ((f3 | 0) < (d2 | 0)) {
          f3 = wd(-1, -1, ((d2 + -1 - f3 | 0) * 3 | 0) + 3 | 0) | 0;
          f3 = wd(~f3 | 0, ~(H2() | 0) | 0, (15 - d2 | 0) * 3 | 0) | 0;
          c2 = ~(H2() | 0) & c2;
          a3 = ~f3 & a3;
        }
        f3 = wd(d2 | 0, 0, 52) | 0;
        d2 = c2 & -15728641 | (H2() | 0);
        b2[e4 >> 2] = a3 | f3;
        b2[e4 + 4 >> 2] = d2;
        e4 = 0;
        return e4 | 0;
      }
      function Bb(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0;
        if ((d2 | 0) == 0 & (e4 | 0) == 0) {
          y3 = 0;
          return y3 | 0;
        }
        f3 = a3;
        g3 = b2[f3 >> 2] | 0;
        f3 = b2[f3 + 4 >> 2] | 0;
        if (true & (f3 & 15728640 | 0) == 0) {
          if (!((e4 | 0) > 0 | (e4 | 0) == 0 & d2 >>> 0 > 0)) {
            y3 = 0;
            return y3 | 0;
          }
          y3 = c2;
          b2[y3 >> 2] = g3;
          b2[y3 + 4 >> 2] = f3;
          if ((d2 | 0) == 1 & (e4 | 0) == 0) {
            y3 = 0;
            return y3 | 0;
          }
          f3 = 1;
          do {
            w3 = a3 + (f3 << 3) | 0;
            x3 = b2[w3 + 4 >> 2] | 0;
            y3 = c2 + (f3 << 3) | 0;
            b2[y3 >> 2] = b2[w3 >> 2];
            b2[y3 + 4 >> 2] = x3;
            f3 = f3 + 1 | 0;
          } while (0 < (e4 | 0) | 0 == (e4 | 0) & f3 >>> 0 < d2 >>> 0);
          f3 = 0;
          return f3 | 0;
        }
        v6 = d2 << 3;
        x3 = id(v6) | 0;
        if (!x3) {
          y3 = 13;
          return y3 | 0;
        }
        Ad(x3 | 0, a3 | 0, v6 | 0) | 0;
        w3 = kd(d2, 8) | 0;
        if (!w3) {
          jd(x3);
          y3 = 13;
          return y3 | 0;
        }
        a:
          do {
            if (d2 | 0) {
              b:
                while (1) {
                  f3 = x3;
                  s3 = b2[f3 >> 2] | 0;
                  f3 = b2[f3 + 4 >> 2] | 0;
                  t3 = vd(s3 | 0, f3 | 0, 52) | 0;
                  H2() | 0;
                  t3 = t3 & 15;
                  u3 = t3 + -1 | 0;
                  r3 = (d2 | 0) > 0;
                  c:
                    do {
                      if ((t3 | 0) != 0 & r3) {
                        o2 = ((d2 | 0) < 0) << 31 >> 31;
                        p3 = wd(u3 | 0, 0, 52) | 0;
                        q3 = H2() | 0;
                        if (u3 >>> 0 > 15) {
                          if (!((s3 | 0) == 0 & (f3 | 0) == 0)) {
                            y3 = 17;
                            break b;
                          }
                          g3 = 0;
                          while (1) {
                            g3 = g3 + 1 | 0;
                            if ((g3 | 0) >= (d2 | 0)) {
                              break c;
                            }
                            e4 = x3 + (g3 << 3) | 0;
                            q3 = b2[e4 >> 2] | 0;
                            e4 = b2[e4 + 4 >> 2] | 0;
                            if (!((q3 | 0) == 0 & (e4 | 0) == 0)) {
                              f3 = e4;
                              y3 = 17;
                              break b;
                            }
                          }
                        }
                        g3 = 0;
                        a3 = s3;
                        e4 = f3;
                        while (1) {
                          if (!((a3 | 0) == 0 & (e4 | 0) == 0)) {
                            if (!(true & (e4 & 117440512 | 0) == 0)) {
                              y3 = 22;
                              break b;
                            }
                            i2 = vd(a3 | 0, e4 | 0, 52) | 0;
                            H2() | 0;
                            i2 = i2 & 15;
                            if ((i2 | 0) < (u3 | 0)) {
                              f3 = 12;
                              y3 = 28;
                              break b;
                            }
                            if ((i2 | 0) != (u3 | 0)) {
                              a3 = a3 | p3;
                              e4 = e4 & -15728641 | q3;
                              if (i2 >>> 0 >= t3 >>> 0) {
                                h2 = u3;
                                do {
                                  n2 = wd(7, 0, (14 - h2 | 0) * 3 | 0) | 0;
                                  h2 = h2 + 1 | 0;
                                  a3 = n2 | a3;
                                  e4 = H2() | 0 | e4;
                                } while (h2 >>> 0 < i2 >>> 0);
                              }
                            }
                            h2 = td(a3 | 0, e4 | 0, d2 | 0, o2 | 0) | 0;
                            H2() | 0;
                            k2 = w3 + (h2 << 3) | 0;
                            i2 = k2;
                            j2 = b2[i2 >> 2] | 0;
                            i2 = b2[i2 + 4 >> 2] | 0;
                            if ((j2 | 0) == 0 & (i2 | 0) == 0) {
                              h2 = k2;
                            } else {
                              n2 = 0;
                              while (1) {
                                if ((n2 | 0) > (d2 | 0)) {
                                  y3 = 32;
                                  break b;
                                }
                                if ((j2 | 0) == (a3 | 0) & (i2 & -117440513 | 0) == (e4 | 0)) {
                                  l2 = vd(j2 | 0, i2 | 0, 56) | 0;
                                  H2() | 0;
                                  l2 = l2 & 7;
                                  m2 = l2 + 1 | 0;
                                  z3 = vd(j2 | 0, i2 | 0, 45) | 0;
                                  H2() | 0;
                                  d:
                                    do {
                                      if (!(ma(z3 & 127) | 0)) {
                                        i2 = 7;
                                      } else {
                                        j2 = vd(j2 | 0, i2 | 0, 52) | 0;
                                        H2() | 0;
                                        j2 = j2 & 15;
                                        if (!j2) {
                                          i2 = 6;
                                          break;
                                        }
                                        i2 = 1;
                                        while (1) {
                                          z3 = wd(7, 0, (15 - i2 | 0) * 3 | 0) | 0;
                                          if (!((z3 & a3 | 0) == 0 & ((H2() | 0) & e4 | 0) == 0)) {
                                            i2 = 7;
                                            break d;
                                          }
                                          if (i2 >>> 0 < j2 >>> 0) {
                                            i2 = i2 + 1 | 0;
                                          } else {
                                            i2 = 6;
                                            break;
                                          }
                                        }
                                      }
                                    } while (0);
                                  if ((l2 + 2 | 0) >>> 0 > i2 >>> 0) {
                                    y3 = 42;
                                    break b;
                                  }
                                  z3 = wd(m2 | 0, 0, 56) | 0;
                                  e4 = H2() | 0 | e4 & -117440513;
                                  m2 = k2;
                                  b2[m2 >> 2] = 0;
                                  b2[m2 + 4 >> 2] = 0;
                                  a3 = z3 | a3;
                                } else {
                                  h2 = (h2 + 1 | 0) % (d2 | 0) | 0;
                                }
                                k2 = w3 + (h2 << 3) | 0;
                                i2 = k2;
                                j2 = b2[i2 >> 2] | 0;
                                i2 = b2[i2 + 4 >> 2] | 0;
                                if ((j2 | 0) == 0 & (i2 | 0) == 0) {
                                  h2 = k2;
                                  break;
                                } else {
                                  n2 = n2 + 1 | 0;
                                }
                              }
                            }
                            z3 = h2;
                            b2[z3 >> 2] = a3;
                            b2[z3 + 4 >> 2] = e4;
                          }
                          g3 = g3 + 1 | 0;
                          if ((g3 | 0) >= (d2 | 0)) {
                            break c;
                          }
                          e4 = x3 + (g3 << 3) | 0;
                          a3 = b2[e4 >> 2] | 0;
                          e4 = b2[e4 + 4 >> 2] | 0;
                        }
                      }
                    } while (0);
                  if ((d2 + 5 | 0) >>> 0 < 11) {
                    y3 = 85;
                    break;
                  }
                  q3 = kd((d2 | 0) / 6 | 0, 8) | 0;
                  if (!q3) {
                    y3 = 49;
                    break;
                  }
                  e:
                    do {
                      if (r3) {
                        n2 = 0;
                        m2 = 0;
                        do {
                          i2 = w3 + (n2 << 3) | 0;
                          e4 = i2;
                          g3 = b2[e4 >> 2] | 0;
                          e4 = b2[e4 + 4 >> 2] | 0;
                          if (!((g3 | 0) == 0 & (e4 | 0) == 0)) {
                            j2 = vd(g3 | 0, e4 | 0, 56) | 0;
                            H2() | 0;
                            j2 = j2 & 7;
                            a3 = j2 + 1 | 0;
                            k2 = e4 & -117440513;
                            z3 = vd(g3 | 0, e4 | 0, 45) | 0;
                            H2() | 0;
                            f:
                              do {
                                if (ma(z3 & 127) | 0) {
                                  l2 = vd(g3 | 0, e4 | 0, 52) | 0;
                                  H2() | 0;
                                  l2 = l2 & 15;
                                  if (l2 | 0) {
                                    h2 = 1;
                                    while (1) {
                                      z3 = wd(7, 0, (15 - h2 | 0) * 3 | 0) | 0;
                                      if (!((g3 & z3 | 0) == 0 & (k2 & (H2() | 0) | 0) == 0)) {
                                        break f;
                                      }
                                      if (h2 >>> 0 < l2 >>> 0) {
                                        h2 = h2 + 1 | 0;
                                      } else {
                                        break;
                                      }
                                    }
                                  }
                                  e4 = wd(a3 | 0, 0, 56) | 0;
                                  g3 = e4 | g3;
                                  e4 = H2() | 0 | k2;
                                  a3 = i2;
                                  b2[a3 >> 2] = g3;
                                  b2[a3 + 4 >> 2] = e4;
                                  a3 = j2 + 2 | 0;
                                }
                              } while (0);
                            if ((a3 | 0) == 7) {
                              z3 = q3 + (m2 << 3) | 0;
                              b2[z3 >> 2] = g3;
                              b2[z3 + 4 >> 2] = e4 & -117440513;
                              m2 = m2 + 1 | 0;
                            }
                          }
                          n2 = n2 + 1 | 0;
                        } while ((n2 | 0) != (d2 | 0));
                        if (r3) {
                          n2 = ((d2 | 0) < 0) << 31 >> 31;
                          o2 = wd(u3 | 0, 0, 52) | 0;
                          p3 = H2() | 0;
                          if (u3 >>> 0 > 15) {
                            if (!((s3 | 0) == 0 & (f3 | 0) == 0)) {
                              f3 = 4;
                              y3 = 84;
                              break b;
                            }
                            f3 = 0;
                            while (1) {
                              f3 = f3 + 1 | 0;
                              if ((f3 | 0) >= (d2 | 0)) {
                                g3 = 0;
                                f3 = m2;
                                break e;
                              }
                              z3 = x3 + (f3 << 3) | 0;
                              if (!((b2[z3 >> 2] | 0) == 0 & (b2[z3 + 4 >> 2] | 0) == 0)) {
                                f3 = 4;
                                y3 = 84;
                                break b;
                              }
                            }
                          }
                          l2 = 0;
                          g3 = 0;
                          k2 = s3;
                          while (1) {
                            do {
                              if (!((k2 | 0) == 0 & (f3 | 0) == 0)) {
                                i2 = vd(k2 | 0, f3 | 0, 52) | 0;
                                H2() | 0;
                                i2 = i2 & 15;
                                if ((i2 | 0) < (u3 | 0)) {
                                  f3 = 12;
                                  y3 = 84;
                                  break b;
                                }
                                do {
                                  if ((i2 | 0) == (u3 | 0)) {
                                    e4 = k2;
                                    i2 = f3;
                                  } else {
                                    e4 = k2 | o2;
                                    a3 = f3 & -15728641 | p3;
                                    if (i2 >>> 0 < t3 >>> 0) {
                                      i2 = a3;
                                      break;
                                    }
                                    h2 = u3;
                                    do {
                                      z3 = wd(7, 0, (14 - h2 | 0) * 3 | 0) | 0;
                                      h2 = h2 + 1 | 0;
                                      e4 = z3 | e4;
                                      a3 = H2() | 0 | a3;
                                    } while (h2 >>> 0 < i2 >>> 0);
                                    i2 = a3;
                                  }
                                } while (0);
                                h2 = td(e4 | 0, i2 | 0, d2 | 0, n2 | 0) | 0;
                                H2() | 0;
                                a3 = 0;
                                while (1) {
                                  if ((a3 | 0) > (d2 | 0)) {
                                    y3 = 77;
                                    break b;
                                  }
                                  z3 = w3 + (h2 << 3) | 0;
                                  j2 = b2[z3 + 4 >> 2] | 0;
                                  if ((j2 & -117440513 | 0) == (i2 | 0) ? (b2[z3 >> 2] | 0) == (e4 | 0) : 0) {
                                    y3 = 79;
                                    break;
                                  }
                                  h2 = (h2 + 1 | 0) % (d2 | 0) | 0;
                                  z3 = w3 + (h2 << 3) | 0;
                                  if ((b2[z3 >> 2] | 0) == (e4 | 0) ? (b2[z3 + 4 >> 2] | 0) == (i2 | 0) : 0) {
                                    break;
                                  } else {
                                    a3 = a3 + 1 | 0;
                                  }
                                }
                                if ((y3 | 0) == 79 ? (y3 = 0, true & (j2 & 117440512 | 0) == 100663296) : 0) {
                                  break;
                                }
                                z3 = c2 + (g3 << 3) | 0;
                                b2[z3 >> 2] = k2;
                                b2[z3 + 4 >> 2] = f3;
                                g3 = g3 + 1 | 0;
                              }
                            } while (0);
                            f3 = l2 + 1 | 0;
                            if ((f3 | 0) >= (d2 | 0)) {
                              f3 = m2;
                              break e;
                            }
                            z3 = x3 + (f3 << 3) | 0;
                            l2 = f3;
                            k2 = b2[z3 >> 2] | 0;
                            f3 = b2[z3 + 4 >> 2] | 0;
                          }
                        } else {
                          g3 = 0;
                          f3 = m2;
                        }
                      } else {
                        g3 = 0;
                        f3 = 0;
                      }
                    } while (0);
                  Bd(w3 | 0, 0, v6 | 0) | 0;
                  Ad(x3 | 0, q3 | 0, f3 << 3 | 0) | 0;
                  jd(q3);
                  if (!f3) {
                    break a;
                  } else {
                    c2 = c2 + (g3 << 3) | 0;
                    d2 = f3;
                  }
                }
              if ((y3 | 0) == 17) {
                if (true & (f3 & 117440512 | 0) == 0) {
                  f3 = 4;
                  y3 = 28;
                } else {
                  y3 = 22;
                }
              } else if ((y3 | 0) == 32) {
                I2(23313, 22674, 362, 22684);
              } else if ((y3 | 0) == 42) {
                jd(x3);
                jd(w3);
                z3 = 10;
                return z3 | 0;
              } else if ((y3 | 0) == 49) {
                jd(x3);
                jd(w3);
                z3 = 13;
                return z3 | 0;
              } else if ((y3 | 0) == 77) {
                I2(23313, 22674, 462, 22684);
              } else if ((y3 | 0) == 84) {
                jd(q3);
                jd(x3);
                jd(w3);
                z3 = f3;
                return z3 | 0;
              } else if ((y3 | 0) == 85) {
                Ad(c2 | 0, x3 | 0, d2 << 3 | 0) | 0;
                break;
              }
              if ((y3 | 0) == 22) {
                jd(x3);
                jd(w3);
                z3 = 5;
                return z3 | 0;
              } else if ((y3 | 0) == 28) {
                jd(x3);
                jd(w3);
                z3 = f3;
                return z3 | 0;
              }
            }
          } while (0);
        jd(x3);
        jd(w3);
        z3 = 0;
        return z3 | 0;
      }
      function Cb(a3, c2, d2, e4, f3, g3, h2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        h2 = h2 | 0;
        var i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0;
        q3 = T2;
        T2 = T2 + 16 | 0;
        p3 = q3;
        if (!((d2 | 0) > 0 | (d2 | 0) == 0 & c2 >>> 0 > 0)) {
          p3 = 0;
          T2 = q3;
          return p3 | 0;
        }
        if ((h2 | 0) >= 16) {
          p3 = 12;
          T2 = q3;
          return p3 | 0;
        }
        n2 = 0;
        o2 = 0;
        m2 = 0;
        i2 = 0;
        a:
          while (1) {
            k2 = a3 + (n2 << 3) | 0;
            j2 = b2[k2 >> 2] | 0;
            k2 = b2[k2 + 4 >> 2] | 0;
            l2 = vd(j2 | 0, k2 | 0, 52) | 0;
            H2() | 0;
            if ((l2 & 15 | 0) > (h2 | 0)) {
              i2 = 12;
              j2 = 11;
              break;
            }
            Xb(p3, j2, k2, h2);
            l2 = p3;
            k2 = b2[l2 >> 2] | 0;
            l2 = b2[l2 + 4 >> 2] | 0;
            if ((k2 | 0) == 0 & (l2 | 0) == 0) {
              j2 = m2;
            } else {
              j2 = m2;
              do {
                if (!((i2 | 0) < (g3 | 0) | (i2 | 0) == (g3 | 0) & j2 >>> 0 < f3 >>> 0)) {
                  j2 = 10;
                  break a;
                }
                m2 = e4 + (j2 << 3) | 0;
                b2[m2 >> 2] = k2;
                b2[m2 + 4 >> 2] = l2;
                j2 = ld(j2 | 0, i2 | 0, 1, 0) | 0;
                i2 = H2() | 0;
                Yb(p3);
                m2 = p3;
                k2 = b2[m2 >> 2] | 0;
                l2 = b2[m2 + 4 >> 2] | 0;
              } while (!((k2 | 0) == 0 & (l2 | 0) == 0));
            }
            n2 = ld(n2 | 0, o2 | 0, 1, 0) | 0;
            o2 = H2() | 0;
            if (!((o2 | 0) < (d2 | 0) | (o2 | 0) == (d2 | 0) & n2 >>> 0 < c2 >>> 0)) {
              i2 = 0;
              j2 = 11;
              break;
            } else {
              m2 = j2;
            }
          }
        if ((j2 | 0) == 10) {
          p3 = 14;
          T2 = q3;
          return p3 | 0;
        } else if ((j2 | 0) == 11) {
          T2 = q3;
          return i2 | 0;
        }
        return 0;
      }
      function Db(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0;
        n2 = T2;
        T2 = T2 + 16 | 0;
        m2 = n2;
        a:
          do {
            if ((d2 | 0) > 0 | (d2 | 0) == 0 & c2 >>> 0 > 0) {
              k2 = 0;
              h2 = 0;
              g3 = 0;
              l2 = 0;
              while (1) {
                j2 = a3 + (k2 << 3) | 0;
                i2 = b2[j2 >> 2] | 0;
                j2 = b2[j2 + 4 >> 2] | 0;
                if (!((i2 | 0) == 0 & (j2 | 0) == 0)) {
                  j2 = (wb(i2, j2, e4, m2) | 0) == 0;
                  i2 = m2;
                  h2 = ld(b2[i2 >> 2] | 0, b2[i2 + 4 >> 2] | 0, h2 | 0, g3 | 0) | 0;
                  g3 = H2() | 0;
                  if (!j2) {
                    g3 = 12;
                    break;
                  }
                }
                k2 = ld(k2 | 0, l2 | 0, 1, 0) | 0;
                l2 = H2() | 0;
                if (!((l2 | 0) < (d2 | 0) | (l2 | 0) == (d2 | 0) & k2 >>> 0 < c2 >>> 0)) {
                  break a;
                }
              }
              T2 = n2;
              return g3 | 0;
            } else {
              h2 = 0;
              g3 = 0;
            }
          } while (0);
        b2[f3 >> 2] = h2;
        b2[f3 + 4 >> 2] = g3;
        f3 = 0;
        T2 = n2;
        return f3 | 0;
      }
      function Eb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        b3 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        return b3 & 1 | 0;
      }
      function Fb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0;
        e4 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        e4 = e4 & 15;
        if (!e4) {
          e4 = 0;
          return e4 | 0;
        }
        d2 = 1;
        while (1) {
          c2 = vd(a3 | 0, b3 | 0, (15 - d2 | 0) * 3 | 0) | 0;
          H2() | 0;
          c2 = c2 & 7;
          if (c2 | 0) {
            d2 = 5;
            break;
          }
          if (d2 >>> 0 < e4 >>> 0) {
            d2 = d2 + 1 | 0;
          } else {
            c2 = 0;
            d2 = 5;
            break;
          }
        }
        if ((d2 | 0) == 5) {
          return c2 | 0;
        }
        return 0;
      }
      function Gb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        i2 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        i2 = i2 & 15;
        if (!i2) {
          h2 = b3;
          i2 = a3;
          G2(h2 | 0);
          return i2 | 0;
        }
        h2 = 1;
        c2 = 0;
        while (1) {
          f3 = (15 - h2 | 0) * 3 | 0;
          d2 = wd(7, 0, f3 | 0) | 0;
          e4 = H2() | 0;
          g3 = vd(a3 | 0, b3 | 0, f3 | 0) | 0;
          H2() | 0;
          f3 = wd(Sa(g3 & 7) | 0, 0, f3 | 0) | 0;
          g3 = H2() | 0;
          a3 = f3 | a3 & ~d2;
          b3 = g3 | b3 & ~e4;
          a:
            do {
              if (!c2) {
                if (!((f3 & d2 | 0) == 0 & (g3 & e4 | 0) == 0)) {
                  d2 = vd(a3 | 0, b3 | 0, 52) | 0;
                  H2() | 0;
                  d2 = d2 & 15;
                  if (!d2) {
                    c2 = 1;
                  } else {
                    c2 = 1;
                    b:
                      while (1) {
                        g3 = vd(a3 | 0, b3 | 0, (15 - c2 | 0) * 3 | 0) | 0;
                        H2() | 0;
                        switch (g3 & 7) {
                          case 1:
                            break b;
                          case 0:
                            break;
                          default: {
                            c2 = 1;
                            break a;
                          }
                        }
                        if (c2 >>> 0 < d2 >>> 0) {
                          c2 = c2 + 1 | 0;
                        } else {
                          c2 = 1;
                          break a;
                        }
                      }
                    c2 = 1;
                    while (1) {
                      g3 = (15 - c2 | 0) * 3 | 0;
                      e4 = vd(a3 | 0, b3 | 0, g3 | 0) | 0;
                      H2() | 0;
                      f3 = wd(7, 0, g3 | 0) | 0;
                      b3 = b3 & ~(H2() | 0);
                      g3 = wd(Sa(e4 & 7) | 0, 0, g3 | 0) | 0;
                      a3 = a3 & ~f3 | g3;
                      b3 = b3 | (H2() | 0);
                      if (c2 >>> 0 < d2 >>> 0) {
                        c2 = c2 + 1 | 0;
                      } else {
                        c2 = 1;
                        break;
                      }
                    }
                  }
                } else {
                  c2 = 0;
                }
              }
            } while (0);
          if (h2 >>> 0 < i2 >>> 0) {
            h2 = h2 + 1 | 0;
          } else {
            break;
          }
        }
        G2(b3 | 0);
        return a3 | 0;
      }
      function Hb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0;
        d2 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        d2 = d2 & 15;
        if (!d2) {
          c2 = b3;
          d2 = a3;
          G2(c2 | 0);
          return d2 | 0;
        }
        c2 = 1;
        while (1) {
          f3 = (15 - c2 | 0) * 3 | 0;
          g3 = vd(a3 | 0, b3 | 0, f3 | 0) | 0;
          H2() | 0;
          e4 = wd(7, 0, f3 | 0) | 0;
          b3 = b3 & ~(H2() | 0);
          f3 = wd(Sa(g3 & 7) | 0, 0, f3 | 0) | 0;
          a3 = f3 | a3 & ~e4;
          b3 = H2() | 0 | b3;
          if (c2 >>> 0 < d2 >>> 0) {
            c2 = c2 + 1 | 0;
          } else {
            break;
          }
        }
        G2(b3 | 0);
        return a3 | 0;
      }
      function Ib(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        i2 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        i2 = i2 & 15;
        if (!i2) {
          h2 = b3;
          i2 = a3;
          G2(h2 | 0);
          return i2 | 0;
        }
        h2 = 1;
        c2 = 0;
        while (1) {
          f3 = (15 - h2 | 0) * 3 | 0;
          d2 = wd(7, 0, f3 | 0) | 0;
          e4 = H2() | 0;
          g3 = vd(a3 | 0, b3 | 0, f3 | 0) | 0;
          H2() | 0;
          f3 = wd(Ta(g3 & 7) | 0, 0, f3 | 0) | 0;
          g3 = H2() | 0;
          a3 = f3 | a3 & ~d2;
          b3 = g3 | b3 & ~e4;
          a:
            do {
              if (!c2) {
                if (!((f3 & d2 | 0) == 0 & (g3 & e4 | 0) == 0)) {
                  d2 = vd(a3 | 0, b3 | 0, 52) | 0;
                  H2() | 0;
                  d2 = d2 & 15;
                  if (!d2) {
                    c2 = 1;
                  } else {
                    c2 = 1;
                    b:
                      while (1) {
                        g3 = vd(a3 | 0, b3 | 0, (15 - c2 | 0) * 3 | 0) | 0;
                        H2() | 0;
                        switch (g3 & 7) {
                          case 1:
                            break b;
                          case 0:
                            break;
                          default: {
                            c2 = 1;
                            break a;
                          }
                        }
                        if (c2 >>> 0 < d2 >>> 0) {
                          c2 = c2 + 1 | 0;
                        } else {
                          c2 = 1;
                          break a;
                        }
                      }
                    c2 = 1;
                    while (1) {
                      e4 = (15 - c2 | 0) * 3 | 0;
                      f3 = wd(7, 0, e4 | 0) | 0;
                      g3 = b3 & ~(H2() | 0);
                      b3 = vd(a3 | 0, b3 | 0, e4 | 0) | 0;
                      H2() | 0;
                      b3 = wd(Ta(b3 & 7) | 0, 0, e4 | 0) | 0;
                      a3 = a3 & ~f3 | b3;
                      b3 = g3 | (H2() | 0);
                      if (c2 >>> 0 < d2 >>> 0) {
                        c2 = c2 + 1 | 0;
                      } else {
                        c2 = 1;
                        break;
                      }
                    }
                  }
                } else {
                  c2 = 0;
                }
              }
            } while (0);
          if (h2 >>> 0 < i2 >>> 0) {
            h2 = h2 + 1 | 0;
          } else {
            break;
          }
        }
        G2(b3 | 0);
        return a3 | 0;
      }
      function Jb(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0;
        d2 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        d2 = d2 & 15;
        if (!d2) {
          c2 = b3;
          d2 = a3;
          G2(c2 | 0);
          return d2 | 0;
        }
        c2 = 1;
        while (1) {
          g3 = (15 - c2 | 0) * 3 | 0;
          f3 = wd(7, 0, g3 | 0) | 0;
          e4 = b3 & ~(H2() | 0);
          b3 = vd(a3 | 0, b3 | 0, g3 | 0) | 0;
          H2() | 0;
          b3 = wd(Ta(b3 & 7) | 0, 0, g3 | 0) | 0;
          a3 = b3 | a3 & ~f3;
          b3 = H2() | 0 | e4;
          if (c2 >>> 0 < d2 >>> 0) {
            c2 = c2 + 1 | 0;
          } else {
            break;
          }
        }
        G2(b3 | 0);
        return a3 | 0;
      }
      function Kb(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0;
        j2 = T2;
        T2 = T2 + 64 | 0;
        i2 = j2 + 40 | 0;
        e4 = j2 + 24 | 0;
        f3 = j2 + 12 | 0;
        g3 = j2;
        wd(c2 | 0, 0, 52) | 0;
        d2 = H2() | 0 | 134225919;
        if (!c2) {
          if ((b2[a3 + 4 >> 2] | 0) > 2) {
            h2 = 0;
            i2 = 0;
            G2(h2 | 0);
            T2 = j2;
            return i2 | 0;
          }
          if ((b2[a3 + 8 >> 2] | 0) > 2) {
            h2 = 0;
            i2 = 0;
            G2(h2 | 0);
            T2 = j2;
            return i2 | 0;
          }
          if ((b2[a3 + 12 >> 2] | 0) > 2) {
            h2 = 0;
            i2 = 0;
            G2(h2 | 0);
            T2 = j2;
            return i2 | 0;
          }
          wd(oa(a3) | 0, 0, 45) | 0;
          h2 = H2() | 0 | d2;
          i2 = -1;
          G2(h2 | 0);
          T2 = j2;
          return i2 | 0;
        }
        b2[i2 >> 2] = b2[a3 >> 2];
        b2[i2 + 4 >> 2] = b2[a3 + 4 >> 2];
        b2[i2 + 8 >> 2] = b2[a3 + 8 >> 2];
        b2[i2 + 12 >> 2] = b2[a3 + 12 >> 2];
        h2 = i2 + 4 | 0;
        if ((c2 | 0) > 0) {
          a3 = -1;
          while (1) {
            b2[e4 >> 2] = b2[h2 >> 2];
            b2[e4 + 4 >> 2] = b2[h2 + 4 >> 2];
            b2[e4 + 8 >> 2] = b2[h2 + 8 >> 2];
            if (!(c2 & 1)) {
              Ma(h2);
              b2[f3 >> 2] = b2[h2 >> 2];
              b2[f3 + 4 >> 2] = b2[h2 + 4 >> 2];
              b2[f3 + 8 >> 2] = b2[h2 + 8 >> 2];
              Oa(f3);
            } else {
              La(h2);
              b2[f3 >> 2] = b2[h2 >> 2];
              b2[f3 + 4 >> 2] = b2[h2 + 4 >> 2];
              b2[f3 + 8 >> 2] = b2[h2 + 8 >> 2];
              Na(f3);
            }
            Ga(e4, f3, g3);
            Da(g3);
            l2 = (15 - c2 | 0) * 3 | 0;
            k2 = wd(7, 0, l2 | 0) | 0;
            d2 = d2 & ~(H2() | 0);
            l2 = wd(Ia(g3) | 0, 0, l2 | 0) | 0;
            a3 = l2 | a3 & ~k2;
            d2 = H2() | 0 | d2;
            if ((c2 | 0) > 1) {
              c2 = c2 + -1 | 0;
            } else {
              break;
            }
          }
        } else {
          a3 = -1;
        }
        a:
          do {
            if (((b2[h2 >> 2] | 0) <= 2 ? (b2[i2 + 8 >> 2] | 0) <= 2 : 0) ? (b2[i2 + 12 >> 2] | 0) <= 2 : 0) {
              e4 = oa(i2) | 0;
              c2 = wd(e4 | 0, 0, 45) | 0;
              c2 = c2 | a3;
              a3 = H2() | 0 | d2 & -1040385;
              g3 = pa(i2) | 0;
              if (!(ma(e4) | 0)) {
                if ((g3 | 0) <= 0) {
                  break;
                }
                f3 = 0;
                while (1) {
                  e4 = vd(c2 | 0, a3 | 0, 52) | 0;
                  H2() | 0;
                  e4 = e4 & 15;
                  if (e4) {
                    d2 = 1;
                    while (1) {
                      l2 = (15 - d2 | 0) * 3 | 0;
                      i2 = vd(c2 | 0, a3 | 0, l2 | 0) | 0;
                      H2() | 0;
                      k2 = wd(7, 0, l2 | 0) | 0;
                      a3 = a3 & ~(H2() | 0);
                      l2 = wd(Sa(i2 & 7) | 0, 0, l2 | 0) | 0;
                      c2 = c2 & ~k2 | l2;
                      a3 = a3 | (H2() | 0);
                      if (d2 >>> 0 < e4 >>> 0) {
                        d2 = d2 + 1 | 0;
                      } else {
                        break;
                      }
                    }
                  }
                  f3 = f3 + 1 | 0;
                  if ((f3 | 0) == (g3 | 0)) {
                    break a;
                  }
                }
              }
              f3 = vd(c2 | 0, a3 | 0, 52) | 0;
              H2() | 0;
              f3 = f3 & 15;
              b:
                do {
                  if (f3) {
                    d2 = 1;
                    c:
                      while (1) {
                        l2 = vd(c2 | 0, a3 | 0, (15 - d2 | 0) * 3 | 0) | 0;
                        H2() | 0;
                        switch (l2 & 7) {
                          case 1:
                            break c;
                          case 0:
                            break;
                          default:
                            break b;
                        }
                        if (d2 >>> 0 < f3 >>> 0) {
                          d2 = d2 + 1 | 0;
                        } else {
                          break b;
                        }
                      }
                    if (sa(e4, b2[i2 >> 2] | 0) | 0) {
                      d2 = 1;
                      while (1) {
                        i2 = (15 - d2 | 0) * 3 | 0;
                        k2 = wd(7, 0, i2 | 0) | 0;
                        l2 = a3 & ~(H2() | 0);
                        a3 = vd(c2 | 0, a3 | 0, i2 | 0) | 0;
                        H2() | 0;
                        a3 = wd(Ta(a3 & 7) | 0, 0, i2 | 0) | 0;
                        c2 = c2 & ~k2 | a3;
                        a3 = l2 | (H2() | 0);
                        if (d2 >>> 0 < f3 >>> 0) {
                          d2 = d2 + 1 | 0;
                        } else {
                          break;
                        }
                      }
                    } else {
                      d2 = 1;
                      while (1) {
                        l2 = (15 - d2 | 0) * 3 | 0;
                        i2 = vd(c2 | 0, a3 | 0, l2 | 0) | 0;
                        H2() | 0;
                        k2 = wd(7, 0, l2 | 0) | 0;
                        a3 = a3 & ~(H2() | 0);
                        l2 = wd(Sa(i2 & 7) | 0, 0, l2 | 0) | 0;
                        c2 = c2 & ~k2 | l2;
                        a3 = a3 | (H2() | 0);
                        if (d2 >>> 0 < f3 >>> 0) {
                          d2 = d2 + 1 | 0;
                        } else {
                          break;
                        }
                      }
                    }
                  }
                } while (0);
              if ((g3 | 0) > 0) {
                d2 = 0;
                do {
                  c2 = Gb(c2, a3) | 0;
                  a3 = H2() | 0;
                  d2 = d2 + 1 | 0;
                } while ((d2 | 0) != (g3 | 0));
              }
            } else {
              c2 = 0;
              a3 = 0;
            }
          } while (0);
        k2 = a3;
        l2 = c2;
        G2(k2 | 0);
        T2 = j2;
        return l2 | 0;
      }
      function Lb(a3) {
        a3 = a3 | 0;
        return (a3 | 0) % 2 | 0 | 0;
      }
      function Mb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0;
        f3 = T2;
        T2 = T2 + 16 | 0;
        e4 = f3;
        if (c2 >>> 0 > 15) {
          e4 = 4;
          T2 = f3;
          return e4 | 0;
        }
        if ((b2[a3 + 4 >> 2] & 2146435072 | 0) == 2146435072) {
          e4 = 3;
          T2 = f3;
          return e4 | 0;
        }
        if ((b2[a3 + 8 + 4 >> 2] & 2146435072 | 0) == 2146435072) {
          e4 = 3;
          T2 = f3;
          return e4 | 0;
        }
        hb(a3, c2, e4);
        c2 = Kb(e4, c2) | 0;
        e4 = H2() | 0;
        b2[d2 >> 2] = c2;
        b2[d2 + 4 >> 2] = e4;
        if ((c2 | 0) == 0 & (e4 | 0) == 0) {
          I2(23313, 22674, 786, 22697);
        }
        e4 = 0;
        T2 = f3;
        return e4 | 0;
      }
      function Nb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0;
        f3 = d2 + 4 | 0;
        g3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        g3 = g3 & 15;
        h2 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        e4 = (g3 | 0) == 0;
        if (!(ma(h2 & 127) | 0)) {
          if (e4) {
            h2 = 0;
            return h2 | 0;
          }
          if ((b2[f3 >> 2] | 0) == 0 ? (b2[d2 + 8 >> 2] | 0) == 0 : 0) {
            e4 = (b2[d2 + 12 >> 2] | 0) != 0 & 1;
          } else {
            e4 = 1;
          }
        } else if (e4) {
          h2 = 1;
          return h2 | 0;
        } else {
          e4 = 1;
        }
        d2 = 1;
        while (1) {
          if (!(d2 & 1)) {
            Oa(f3);
          } else {
            Na(f3);
          }
          h2 = vd(a3 | 0, c2 | 0, (15 - d2 | 0) * 3 | 0) | 0;
          H2() | 0;
          Pa(f3, h2 & 7);
          if (d2 >>> 0 < g3 >>> 0) {
            d2 = d2 + 1 | 0;
          } else {
            break;
          }
        }
        return e4 | 0;
      }
      function Ob(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0;
        l2 = T2;
        T2 = T2 + 16 | 0;
        j2 = l2;
        k2 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        k2 = k2 & 127;
        if (k2 >>> 0 > 121) {
          b2[d2 >> 2] = 0;
          b2[d2 + 4 >> 2] = 0;
          b2[d2 + 8 >> 2] = 0;
          b2[d2 + 12 >> 2] = 0;
          k2 = 5;
          T2 = l2;
          return k2 | 0;
        }
        a:
          do {
            if ((ma(k2) | 0) != 0 ? (g3 = vd(a3 | 0, c2 | 0, 52) | 0, H2() | 0, g3 = g3 & 15, (g3 | 0) != 0) : 0) {
              e4 = 1;
              b:
                while (1) {
                  i2 = vd(a3 | 0, c2 | 0, (15 - e4 | 0) * 3 | 0) | 0;
                  H2() | 0;
                  switch (i2 & 7) {
                    case 5:
                      break b;
                    case 0:
                      break;
                    default: {
                      e4 = c2;
                      break a;
                    }
                  }
                  if (e4 >>> 0 < g3 >>> 0) {
                    e4 = e4 + 1 | 0;
                  } else {
                    e4 = c2;
                    break a;
                  }
                }
              f3 = 1;
              e4 = c2;
              while (1) {
                c2 = (15 - f3 | 0) * 3 | 0;
                h2 = wd(7, 0, c2 | 0) | 0;
                i2 = e4 & ~(H2() | 0);
                e4 = vd(a3 | 0, e4 | 0, c2 | 0) | 0;
                H2() | 0;
                e4 = wd(Ta(e4 & 7) | 0, 0, c2 | 0) | 0;
                a3 = a3 & ~h2 | e4;
                e4 = i2 | (H2() | 0);
                if (f3 >>> 0 < g3 >>> 0) {
                  f3 = f3 + 1 | 0;
                } else {
                  break;
                }
              }
            } else {
              e4 = c2;
            }
          } while (0);
        i2 = 7696 + (k2 * 28 | 0) | 0;
        b2[d2 >> 2] = b2[i2 >> 2];
        b2[d2 + 4 >> 2] = b2[i2 + 4 >> 2];
        b2[d2 + 8 >> 2] = b2[i2 + 8 >> 2];
        b2[d2 + 12 >> 2] = b2[i2 + 12 >> 2];
        if (!(Nb(a3, e4, d2) | 0)) {
          k2 = 0;
          T2 = l2;
          return k2 | 0;
        }
        h2 = d2 + 4 | 0;
        b2[j2 >> 2] = b2[h2 >> 2];
        b2[j2 + 4 >> 2] = b2[h2 + 4 >> 2];
        b2[j2 + 8 >> 2] = b2[h2 + 8 >> 2];
        g3 = vd(a3 | 0, e4 | 0, 52) | 0;
        H2() | 0;
        i2 = g3 & 15;
        if (!(g3 & 1)) {
          g3 = i2;
        } else {
          Oa(h2);
          g3 = i2 + 1 | 0;
        }
        if (!(ma(k2) | 0)) {
          e4 = 0;
        } else {
          c:
            do {
              if (!i2) {
                e4 = 0;
              } else {
                c2 = 1;
                while (1) {
                  f3 = vd(a3 | 0, e4 | 0, (15 - c2 | 0) * 3 | 0) | 0;
                  H2() | 0;
                  f3 = f3 & 7;
                  if (f3 | 0) {
                    e4 = f3;
                    break c;
                  }
                  if (c2 >>> 0 < i2 >>> 0) {
                    c2 = c2 + 1 | 0;
                  } else {
                    e4 = 0;
                    break;
                  }
                }
              }
            } while (0);
          e4 = (e4 | 0) == 4 & 1;
        }
        if (!(ob(d2, g3, e4, 0) | 0)) {
          if ((g3 | 0) != (i2 | 0)) {
            b2[h2 >> 2] = b2[j2 >> 2];
            b2[h2 + 4 >> 2] = b2[j2 + 4 >> 2];
            b2[h2 + 8 >> 2] = b2[j2 + 8 >> 2];
          }
        } else {
          if (ma(k2) | 0) {
            do {
            } while ((ob(d2, g3, 0, 0) | 0) != 0);
          }
          if ((g3 | 0) != (i2 | 0)) {
            Ma(h2);
          }
        }
        k2 = 0;
        T2 = l2;
        return k2 | 0;
      }
      function Pb(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0;
        f3 = T2;
        T2 = T2 + 16 | 0;
        d2 = f3;
        e4 = Ob(a3, b3, d2) | 0;
        if (e4 | 0) {
          T2 = f3;
          return e4 | 0;
        }
        e4 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        lb(d2, e4 & 15, c2);
        e4 = 0;
        T2 = f3;
        return e4 | 0;
      }
      function Qb(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0;
        g3 = T2;
        T2 = T2 + 16 | 0;
        f3 = g3;
        d2 = Ob(a3, b3, f3) | 0;
        if (d2 | 0) {
          f3 = d2;
          T2 = g3;
          return f3 | 0;
        }
        d2 = vd(a3 | 0, b3 | 0, 45) | 0;
        H2() | 0;
        d2 = (ma(d2 & 127) | 0) == 0;
        e4 = vd(a3 | 0, b3 | 0, 52) | 0;
        H2() | 0;
        e4 = e4 & 15;
        a:
          do {
            if (!d2) {
              if (e4 | 0) {
                d2 = 1;
                while (1) {
                  h2 = wd(7, 0, (15 - d2 | 0) * 3 | 0) | 0;
                  if (!((h2 & a3 | 0) == 0 & ((H2() | 0) & b3 | 0) == 0)) {
                    break a;
                  }
                  if (d2 >>> 0 < e4 >>> 0) {
                    d2 = d2 + 1 | 0;
                  } else {
                    break;
                  }
                }
              }
              mb(f3, e4, 0, 5, c2);
              h2 = 0;
              T2 = g3;
              return h2 | 0;
            }
          } while (0);
        qb(f3, e4, 0, 6, c2);
        h2 = 0;
        T2 = g3;
        return h2 | 0;
      }
      function Rb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0;
        f3 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        if (!(ma(f3 & 127) | 0)) {
          f3 = 2;
          b2[d2 >> 2] = f3;
          return 0;
        }
        f3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        f3 = f3 & 15;
        if (!f3) {
          f3 = 5;
          b2[d2 >> 2] = f3;
          return 0;
        }
        e4 = 1;
        while (1) {
          g3 = wd(7, 0, (15 - e4 | 0) * 3 | 0) | 0;
          if (!((g3 & a3 | 0) == 0 & ((H2() | 0) & c2 | 0) == 0)) {
            e4 = 2;
            a3 = 6;
            break;
          }
          if (e4 >>> 0 < f3 >>> 0) {
            e4 = e4 + 1 | 0;
          } else {
            e4 = 5;
            a3 = 6;
            break;
          }
        }
        if ((a3 | 0) == 6) {
          b2[d2 >> 2] = e4;
          return 0;
        }
        return 0;
      }
      function Sb(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0;
        m2 = T2;
        T2 = T2 + 128 | 0;
        k2 = m2 + 112 | 0;
        g3 = m2 + 96 | 0;
        l2 = m2;
        f3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        i2 = f3 & 15;
        b2[k2 >> 2] = i2;
        h2 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        h2 = h2 & 127;
        a:
          do {
            if (ma(h2) | 0) {
              if (i2 | 0) {
                e4 = 1;
                while (1) {
                  j2 = wd(7, 0, (15 - e4 | 0) * 3 | 0) | 0;
                  if (!((j2 & a3 | 0) == 0 & ((H2() | 0) & c2 | 0) == 0)) {
                    f3 = 0;
                    break a;
                  }
                  if (e4 >>> 0 < i2 >>> 0) {
                    e4 = e4 + 1 | 0;
                  } else {
                    break;
                  }
                }
              }
              if (!(f3 & 1)) {
                j2 = wd(i2 + 1 | 0, 0, 52) | 0;
                l2 = H2() | 0 | c2 & -15728641;
                k2 = wd(7, 0, (14 - i2 | 0) * 3 | 0) | 0;
                l2 = Sb((j2 | a3) & ~k2, l2 & ~(H2() | 0), d2) | 0;
                T2 = m2;
                return l2 | 0;
              } else {
                f3 = 1;
              }
            } else {
              f3 = 0;
            }
          } while (0);
        e4 = Ob(a3, c2, g3) | 0;
        if (!e4) {
          if (f3) {
            nb(g3, k2, l2);
            j2 = 5;
          } else {
            rb(g3, k2, l2);
            j2 = 6;
          }
          b:
            do {
              if (ma(h2) | 0) {
                if (!i2) {
                  a3 = 5;
                } else {
                  e4 = 1;
                  while (1) {
                    h2 = wd(7, 0, (15 - e4 | 0) * 3 | 0) | 0;
                    if (!((h2 & a3 | 0) == 0 & ((H2() | 0) & c2 | 0) == 0)) {
                      a3 = 2;
                      break b;
                    }
                    if (e4 >>> 0 < i2 >>> 0) {
                      e4 = e4 + 1 | 0;
                    } else {
                      a3 = 5;
                      break;
                    }
                  }
                }
              } else {
                a3 = 2;
              }
            } while (0);
          Bd(d2 | 0, -1, a3 << 2 | 0) | 0;
          c:
            do {
              if (f3) {
                g3 = 0;
                while (1) {
                  h2 = l2 + (g3 << 4) | 0;
                  pb(h2, b2[k2 >> 2] | 0) | 0;
                  h2 = b2[h2 >> 2] | 0;
                  i2 = b2[d2 >> 2] | 0;
                  if ((i2 | 0) == -1 | (i2 | 0) == (h2 | 0)) {
                    e4 = d2;
                  } else {
                    f3 = 0;
                    do {
                      f3 = f3 + 1 | 0;
                      if (f3 >>> 0 >= a3 >>> 0) {
                        e4 = 1;
                        break c;
                      }
                      e4 = d2 + (f3 << 2) | 0;
                      i2 = b2[e4 >> 2] | 0;
                    } while (!((i2 | 0) == -1 | (i2 | 0) == (h2 | 0)));
                  }
                  b2[e4 >> 2] = h2;
                  g3 = g3 + 1 | 0;
                  if (g3 >>> 0 >= j2 >>> 0) {
                    e4 = 0;
                    break;
                  }
                }
              } else {
                g3 = 0;
                while (1) {
                  h2 = l2 + (g3 << 4) | 0;
                  ob(h2, b2[k2 >> 2] | 0, 0, 1) | 0;
                  h2 = b2[h2 >> 2] | 0;
                  i2 = b2[d2 >> 2] | 0;
                  if ((i2 | 0) == -1 | (i2 | 0) == (h2 | 0)) {
                    e4 = d2;
                  } else {
                    f3 = 0;
                    do {
                      f3 = f3 + 1 | 0;
                      if (f3 >>> 0 >= a3 >>> 0) {
                        e4 = 1;
                        break c;
                      }
                      e4 = d2 + (f3 << 2) | 0;
                      i2 = b2[e4 >> 2] | 0;
                    } while (!((i2 | 0) == -1 | (i2 | 0) == (h2 | 0)));
                  }
                  b2[e4 >> 2] = h2;
                  g3 = g3 + 1 | 0;
                  if (g3 >>> 0 >= j2 >>> 0) {
                    e4 = 0;
                    break;
                  }
                }
              }
            } while (0);
        }
        l2 = e4;
        T2 = m2;
        return l2 | 0;
      }
      function Tb() {
        return 12;
      }
      function Ub(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        if (a3 >>> 0 > 15) {
          i2 = 4;
          return i2 | 0;
        }
        wd(a3 | 0, 0, 52) | 0;
        i2 = H2() | 0 | 134225919;
        if (!a3) {
          d2 = 0;
          e4 = 0;
          do {
            if (ma(e4) | 0) {
              wd(e4 | 0, 0, 45) | 0;
              h2 = i2 | (H2() | 0);
              a3 = c2 + (d2 << 3) | 0;
              b2[a3 >> 2] = -1;
              b2[a3 + 4 >> 2] = h2;
              d2 = d2 + 1 | 0;
            }
            e4 = e4 + 1 | 0;
          } while ((e4 | 0) != 122);
          d2 = 0;
          return d2 | 0;
        }
        d2 = 0;
        h2 = 0;
        do {
          if (ma(h2) | 0) {
            wd(h2 | 0, 0, 45) | 0;
            e4 = 1;
            f3 = -1;
            g3 = i2 | (H2() | 0);
            while (1) {
              j2 = wd(7, 0, (15 - e4 | 0) * 3 | 0) | 0;
              f3 = f3 & ~j2;
              g3 = g3 & ~(H2() | 0);
              if ((e4 | 0) == (a3 | 0)) {
                break;
              } else {
                e4 = e4 + 1 | 0;
              }
            }
            j2 = c2 + (d2 << 3) | 0;
            b2[j2 >> 2] = f3;
            b2[j2 + 4 >> 2] = g3;
            d2 = d2 + 1 | 0;
          }
          h2 = h2 + 1 | 0;
        } while ((h2 | 0) != 122);
        d2 = 0;
        return d2 | 0;
      }
      function Vb(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0;
        t3 = T2;
        T2 = T2 + 16 | 0;
        r3 = t3;
        s3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        s3 = s3 & 15;
        if (d2 >>> 0 > 15) {
          s3 = 4;
          T2 = t3;
          return s3 | 0;
        }
        if ((s3 | 0) < (d2 | 0)) {
          s3 = 12;
          T2 = t3;
          return s3 | 0;
        }
        if ((s3 | 0) != (d2 | 0)) {
          g3 = wd(d2 | 0, 0, 52) | 0;
          g3 = g3 | a3;
          i2 = H2() | 0 | c2 & -15728641;
          if ((s3 | 0) > (d2 | 0)) {
            j2 = d2;
            do {
              q3 = wd(7, 0, (14 - j2 | 0) * 3 | 0) | 0;
              j2 = j2 + 1 | 0;
              g3 = q3 | g3;
              i2 = H2() | 0 | i2;
            } while ((j2 | 0) < (s3 | 0));
            q3 = g3;
          } else {
            q3 = g3;
          }
        } else {
          q3 = a3;
          i2 = c2;
        }
        p3 = vd(q3 | 0, i2 | 0, 45) | 0;
        H2() | 0;
        a:
          do {
            if (ma(p3 & 127) | 0) {
              j2 = vd(q3 | 0, i2 | 0, 52) | 0;
              H2() | 0;
              j2 = j2 & 15;
              if (j2 | 0) {
                g3 = 1;
                while (1) {
                  p3 = wd(7, 0, (15 - g3 | 0) * 3 | 0) | 0;
                  if (!((p3 & q3 | 0) == 0 & ((H2() | 0) & i2 | 0) == 0)) {
                    k2 = 33;
                    break a;
                  }
                  if (g3 >>> 0 < j2 >>> 0) {
                    g3 = g3 + 1 | 0;
                  } else {
                    break;
                  }
                }
              }
              p3 = e4;
              b2[p3 >> 2] = 0;
              b2[p3 + 4 >> 2] = 0;
              if ((s3 | 0) > (d2 | 0)) {
                p3 = c2 & -15728641;
                o2 = s3;
                while (1) {
                  n2 = o2;
                  o2 = o2 + -1 | 0;
                  if (o2 >>> 0 > 15 | (s3 | 0) < (o2 | 0)) {
                    k2 = 19;
                    break;
                  }
                  if ((s3 | 0) != (o2 | 0)) {
                    g3 = wd(o2 | 0, 0, 52) | 0;
                    g3 = g3 | a3;
                    j2 = H2() | 0 | p3;
                    if ((s3 | 0) < (n2 | 0)) {
                      m2 = g3;
                    } else {
                      k2 = o2;
                      do {
                        m2 = wd(7, 0, (14 - k2 | 0) * 3 | 0) | 0;
                        k2 = k2 + 1 | 0;
                        g3 = m2 | g3;
                        j2 = H2() | 0 | j2;
                      } while ((k2 | 0) < (s3 | 0));
                      m2 = g3;
                    }
                  } else {
                    m2 = a3;
                    j2 = c2;
                  }
                  l2 = vd(m2 | 0, j2 | 0, 45) | 0;
                  H2() | 0;
                  if (!(ma(l2 & 127) | 0)) {
                    g3 = 0;
                  } else {
                    l2 = vd(m2 | 0, j2 | 0, 52) | 0;
                    H2() | 0;
                    l2 = l2 & 15;
                    b:
                      do {
                        if (!l2) {
                          g3 = 0;
                        } else {
                          k2 = 1;
                          while (1) {
                            g3 = vd(m2 | 0, j2 | 0, (15 - k2 | 0) * 3 | 0) | 0;
                            H2() | 0;
                            g3 = g3 & 7;
                            if (g3 | 0) {
                              break b;
                            }
                            if (k2 >>> 0 < l2 >>> 0) {
                              k2 = k2 + 1 | 0;
                            } else {
                              g3 = 0;
                              break;
                            }
                          }
                        }
                      } while (0);
                    g3 = (g3 | 0) == 0 & 1;
                  }
                  j2 = vd(a3 | 0, c2 | 0, (15 - n2 | 0) * 3 | 0) | 0;
                  H2() | 0;
                  j2 = j2 & 7;
                  if ((j2 | 0) == 7) {
                    f3 = 5;
                    k2 = 42;
                    break;
                  }
                  g3 = (g3 | 0) != 0;
                  if ((j2 | 0) == 1 & g3) {
                    f3 = 5;
                    k2 = 42;
                    break;
                  }
                  m2 = j2 + (((j2 | 0) != 0 & g3) << 31 >> 31) | 0;
                  if (m2 | 0) {
                    k2 = s3 - n2 | 0;
                    k2 = Cc(7, 0, k2, ((k2 | 0) < 0) << 31 >> 31) | 0;
                    l2 = H2() | 0;
                    if (g3) {
                      g3 = rd(k2 | 0, l2 | 0, 5, 0) | 0;
                      g3 = ld(g3 | 0, H2() | 0, -5, -1) | 0;
                      g3 = pd(g3 | 0, H2() | 0, 6, 0) | 0;
                      g3 = ld(g3 | 0, H2() | 0, 1, 0) | 0;
                      j2 = H2() | 0;
                    } else {
                      g3 = k2;
                      j2 = l2;
                    }
                    n2 = m2 + -1 | 0;
                    n2 = rd(k2 | 0, l2 | 0, n2 | 0, ((n2 | 0) < 0) << 31 >> 31 | 0) | 0;
                    n2 = ld(g3 | 0, j2 | 0, n2 | 0, H2() | 0) | 0;
                    m2 = H2() | 0;
                    l2 = e4;
                    l2 = ld(n2 | 0, m2 | 0, b2[l2 >> 2] | 0, b2[l2 + 4 >> 2] | 0) | 0;
                    m2 = H2() | 0;
                    n2 = e4;
                    b2[n2 >> 2] = l2;
                    b2[n2 + 4 >> 2] = m2;
                  }
                  if ((o2 | 0) <= (d2 | 0)) {
                    k2 = 37;
                    break;
                  }
                }
                if ((k2 | 0) == 19) {
                  I2(23313, 22674, 1099, 22710);
                } else if ((k2 | 0) == 37) {
                  h2 = e4;
                  f3 = b2[h2 + 4 >> 2] | 0;
                  h2 = b2[h2 >> 2] | 0;
                  break;
                } else if ((k2 | 0) == 42) {
                  T2 = t3;
                  return f3 | 0;
                }
              } else {
                f3 = 0;
                h2 = 0;
              }
            } else {
              k2 = 33;
            }
          } while (0);
        c:
          do {
            if ((k2 | 0) == 33) {
              p3 = e4;
              b2[p3 >> 2] = 0;
              b2[p3 + 4 >> 2] = 0;
              if ((s3 | 0) > (d2 | 0)) {
                g3 = s3;
                while (1) {
                  f3 = vd(a3 | 0, c2 | 0, (15 - g3 | 0) * 3 | 0) | 0;
                  H2() | 0;
                  f3 = f3 & 7;
                  if ((f3 | 0) == 7) {
                    f3 = 5;
                    break;
                  }
                  h2 = s3 - g3 | 0;
                  h2 = Cc(7, 0, h2, ((h2 | 0) < 0) << 31 >> 31) | 0;
                  f3 = rd(h2 | 0, H2() | 0, f3 | 0, 0) | 0;
                  h2 = H2() | 0;
                  p3 = e4;
                  h2 = ld(b2[p3 >> 2] | 0, b2[p3 + 4 >> 2] | 0, f3 | 0, h2 | 0) | 0;
                  f3 = H2() | 0;
                  p3 = e4;
                  b2[p3 >> 2] = h2;
                  b2[p3 + 4 >> 2] = f3;
                  g3 = g3 + -1 | 0;
                  if ((g3 | 0) <= (d2 | 0)) {
                    break c;
                  }
                }
                T2 = t3;
                return f3 | 0;
              } else {
                f3 = 0;
                h2 = 0;
              }
            }
          } while (0);
        if (wb(q3, i2, s3, r3) | 0) {
          I2(23313, 22674, 1063, 22725);
        }
        s3 = r3;
        r3 = b2[s3 + 4 >> 2] | 0;
        if (((f3 | 0) > -1 | (f3 | 0) == -1 & h2 >>> 0 > 4294967295) & ((r3 | 0) > (f3 | 0) | ((r3 | 0) == (f3 | 0) ? (b2[s3 >> 2] | 0) >>> 0 > h2 >>> 0 : 0))) {
          s3 = 0;
          T2 = t3;
          return s3 | 0;
        } else {
          I2(23313, 22674, 1139, 22710);
        }
        return 0;
      }
      function Wb(a3, c2, d2, e4, f3, g3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        var h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0;
        m2 = T2;
        T2 = T2 + 16 | 0;
        h2 = m2;
        if (f3 >>> 0 > 15) {
          g3 = 4;
          T2 = m2;
          return g3 | 0;
        }
        i2 = vd(d2 | 0, e4 | 0, 52) | 0;
        H2() | 0;
        i2 = i2 & 15;
        if ((i2 | 0) > (f3 | 0)) {
          g3 = 12;
          T2 = m2;
          return g3 | 0;
        }
        if (wb(d2, e4, f3, h2) | 0) {
          I2(23313, 22674, 1063, 22725);
        }
        l2 = h2;
        k2 = b2[l2 + 4 >> 2] | 0;
        if (!(((c2 | 0) > -1 | (c2 | 0) == -1 & a3 >>> 0 > 4294967295) & ((k2 | 0) > (c2 | 0) | ((k2 | 0) == (c2 | 0) ? (b2[l2 >> 2] | 0) >>> 0 > a3 >>> 0 : 0)))) {
          g3 = 2;
          T2 = m2;
          return g3 | 0;
        }
        l2 = f3 - i2 | 0;
        f3 = wd(f3 | 0, 0, 52) | 0;
        j2 = H2() | 0 | e4 & -15728641;
        k2 = g3;
        b2[k2 >> 2] = f3 | d2;
        b2[k2 + 4 >> 2] = j2;
        k2 = vd(d2 | 0, e4 | 0, 45) | 0;
        H2() | 0;
        a:
          do {
            if (ma(k2 & 127) | 0) {
              if (i2 | 0) {
                h2 = 1;
                while (1) {
                  k2 = wd(7, 0, (15 - h2 | 0) * 3 | 0) | 0;
                  if (!((k2 & d2 | 0) == 0 & ((H2() | 0) & e4 | 0) == 0)) {
                    break a;
                  }
                  if (h2 >>> 0 < i2 >>> 0) {
                    h2 = h2 + 1 | 0;
                  } else {
                    break;
                  }
                }
              }
              if ((l2 | 0) < 1) {
                g3 = 0;
                T2 = m2;
                return g3 | 0;
              }
              k2 = i2 ^ 15;
              e4 = -1;
              j2 = 1;
              h2 = 1;
              while (1) {
                i2 = l2 - j2 | 0;
                i2 = Cc(7, 0, i2, ((i2 | 0) < 0) << 31 >> 31) | 0;
                d2 = H2() | 0;
                do {
                  if (h2) {
                    h2 = rd(i2 | 0, d2 | 0, 5, 0) | 0;
                    h2 = ld(h2 | 0, H2() | 0, -5, -1) | 0;
                    h2 = pd(h2 | 0, H2() | 0, 6, 0) | 0;
                    f3 = H2() | 0;
                    if ((c2 | 0) > (f3 | 0) | (c2 | 0) == (f3 | 0) & a3 >>> 0 > h2 >>> 0) {
                      c2 = ld(a3 | 0, c2 | 0, -1, -1) | 0;
                      c2 = md(c2 | 0, H2() | 0, h2 | 0, f3 | 0) | 0;
                      h2 = H2() | 0;
                      n2 = g3;
                      p3 = b2[n2 >> 2] | 0;
                      n2 = b2[n2 + 4 >> 2] | 0;
                      q3 = (k2 + e4 | 0) * 3 | 0;
                      o2 = wd(7, 0, q3 | 0) | 0;
                      n2 = n2 & ~(H2() | 0);
                      e4 = pd(c2 | 0, h2 | 0, i2 | 0, d2 | 0) | 0;
                      a3 = H2() | 0;
                      f3 = ld(e4 | 0, a3 | 0, 2, 0) | 0;
                      q3 = wd(f3 | 0, H2() | 0, q3 | 0) | 0;
                      n2 = H2() | 0 | n2;
                      f3 = g3;
                      b2[f3 >> 2] = q3 | p3 & ~o2;
                      b2[f3 + 4 >> 2] = n2;
                      a3 = rd(e4 | 0, a3 | 0, i2 | 0, d2 | 0) | 0;
                      a3 = md(c2 | 0, h2 | 0, a3 | 0, H2() | 0) | 0;
                      h2 = 0;
                      c2 = H2() | 0;
                      break;
                    } else {
                      q3 = g3;
                      o2 = b2[q3 >> 2] | 0;
                      q3 = b2[q3 + 4 >> 2] | 0;
                      p3 = wd(7, 0, (k2 + e4 | 0) * 3 | 0) | 0;
                      q3 = q3 & ~(H2() | 0);
                      h2 = g3;
                      b2[h2 >> 2] = o2 & ~p3;
                      b2[h2 + 4 >> 2] = q3;
                      h2 = 1;
                      break;
                    }
                  } else {
                    o2 = g3;
                    f3 = b2[o2 >> 2] | 0;
                    o2 = b2[o2 + 4 >> 2] | 0;
                    e4 = (k2 + e4 | 0) * 3 | 0;
                    n2 = wd(7, 0, e4 | 0) | 0;
                    o2 = o2 & ~(H2() | 0);
                    q3 = pd(a3 | 0, c2 | 0, i2 | 0, d2 | 0) | 0;
                    h2 = H2() | 0;
                    e4 = wd(q3 | 0, h2 | 0, e4 | 0) | 0;
                    o2 = H2() | 0 | o2;
                    p3 = g3;
                    b2[p3 >> 2] = e4 | f3 & ~n2;
                    b2[p3 + 4 >> 2] = o2;
                    h2 = rd(q3 | 0, h2 | 0, i2 | 0, d2 | 0) | 0;
                    a3 = md(a3 | 0, c2 | 0, h2 | 0, H2() | 0) | 0;
                    h2 = 0;
                    c2 = H2() | 0;
                  }
                } while (0);
                if ((l2 | 0) > (j2 | 0)) {
                  e4 = ~j2;
                  j2 = j2 + 1 | 0;
                } else {
                  c2 = 0;
                  break;
                }
              }
              T2 = m2;
              return c2 | 0;
            }
          } while (0);
        if ((l2 | 0) < 1) {
          q3 = 0;
          T2 = m2;
          return q3 | 0;
        }
        f3 = i2 ^ 15;
        h2 = 1;
        while (1) {
          p3 = l2 - h2 | 0;
          p3 = Cc(7, 0, p3, ((p3 | 0) < 0) << 31 >> 31) | 0;
          q3 = H2() | 0;
          j2 = g3;
          d2 = b2[j2 >> 2] | 0;
          j2 = b2[j2 + 4 >> 2] | 0;
          i2 = (f3 - h2 | 0) * 3 | 0;
          e4 = wd(7, 0, i2 | 0) | 0;
          j2 = j2 & ~(H2() | 0);
          n2 = pd(a3 | 0, c2 | 0, p3 | 0, q3 | 0) | 0;
          o2 = H2() | 0;
          i2 = wd(n2 | 0, o2 | 0, i2 | 0) | 0;
          j2 = H2() | 0 | j2;
          k2 = g3;
          b2[k2 >> 2] = i2 | d2 & ~e4;
          b2[k2 + 4 >> 2] = j2;
          q3 = rd(n2 | 0, o2 | 0, p3 | 0, q3 | 0) | 0;
          a3 = md(a3 | 0, c2 | 0, q3 | 0, H2() | 0) | 0;
          c2 = H2() | 0;
          if ((l2 | 0) <= (h2 | 0)) {
            c2 = 0;
            break;
          } else {
            h2 = h2 + 1 | 0;
          }
        }
        T2 = m2;
        return c2 | 0;
      }
      function Xb(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0;
        f3 = vd(c2 | 0, d2 | 0, 52) | 0;
        H2() | 0;
        f3 = f3 & 15;
        if ((c2 | 0) == 0 & (d2 | 0) == 0 | ((e4 | 0) > 15 | (f3 | 0) > (e4 | 0))) {
          e4 = -1;
          f3 = -1;
          c2 = 0;
          d2 = 0;
        } else {
          g3 = zb(c2, d2, f3 + 1 | 0, e4) | 0;
          d2 = (H2() | 0) & -15728641;
          c2 = wd(e4 | 0, 0, 52) | 0;
          c2 = g3 | c2;
          d2 = d2 | (H2() | 0);
          g3 = (xb(c2, d2) | 0) == 0;
          e4 = g3 ? -1 : e4;
        }
        g3 = a3;
        b2[g3 >> 2] = c2;
        b2[g3 + 4 >> 2] = d2;
        b2[a3 + 8 >> 2] = f3;
        b2[a3 + 12 >> 2] = e4;
        return;
      }
      function Yb(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0;
        d2 = a3;
        c2 = b2[d2 >> 2] | 0;
        d2 = b2[d2 + 4 >> 2] | 0;
        if ((c2 | 0) == 0 & (d2 | 0) == 0) {
          return;
        }
        e4 = vd(c2 | 0, d2 | 0, 52) | 0;
        H2() | 0;
        e4 = e4 & 15;
        i2 = wd(1, 0, (e4 ^ 15) * 3 | 0) | 0;
        c2 = ld(i2 | 0, H2() | 0, c2 | 0, d2 | 0) | 0;
        d2 = H2() | 0;
        i2 = a3;
        b2[i2 >> 2] = c2;
        b2[i2 + 4 >> 2] = d2;
        i2 = a3 + 8 | 0;
        h2 = b2[i2 >> 2] | 0;
        if ((e4 | 0) < (h2 | 0)) {
          return;
        }
        j2 = a3 + 12 | 0;
        g3 = e4;
        while (1) {
          if ((g3 | 0) == (h2 | 0)) {
            e4 = 5;
            break;
          }
          k2 = (g3 | 0) == (b2[j2 >> 2] | 0);
          f3 = (15 - g3 | 0) * 3 | 0;
          e4 = vd(c2 | 0, d2 | 0, f3 | 0) | 0;
          H2() | 0;
          e4 = e4 & 7;
          if (k2 & ((e4 | 0) == 1 & true)) {
            e4 = 7;
            break;
          }
          if (!((e4 | 0) == 7 & true)) {
            e4 = 10;
            break;
          }
          k2 = wd(1, 0, f3 | 0) | 0;
          c2 = ld(c2 | 0, d2 | 0, k2 | 0, H2() | 0) | 0;
          d2 = H2() | 0;
          k2 = a3;
          b2[k2 >> 2] = c2;
          b2[k2 + 4 >> 2] = d2;
          if ((g3 | 0) > (h2 | 0)) {
            g3 = g3 + -1 | 0;
          } else {
            e4 = 10;
            break;
          }
        }
        if ((e4 | 0) == 5) {
          k2 = a3;
          b2[k2 >> 2] = 0;
          b2[k2 + 4 >> 2] = 0;
          b2[i2 >> 2] = -1;
          b2[j2 >> 2] = -1;
          return;
        } else if ((e4 | 0) == 7) {
          h2 = wd(1, 0, f3 | 0) | 0;
          h2 = ld(c2 | 0, d2 | 0, h2 | 0, H2() | 0) | 0;
          i2 = H2() | 0;
          k2 = a3;
          b2[k2 >> 2] = h2;
          b2[k2 + 4 >> 2] = i2;
          b2[j2 >> 2] = g3 + -1;
          return;
        } else if ((e4 | 0) == 10) {
          return;
        }
      }
      function Zb(a3) {
        a3 = +a3;
        var b3 = 0;
        b3 = a3 < 0 ? a3 + 6.283185307179586 : a3;
        return +(!(a3 >= 6.283185307179586) ? b3 : b3 + -6.283185307179586);
      }
      function _b3(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        if (!(+q2(+(+e3[a3 >> 3] - +e3[b3 >> 3])) < 17453292519943298e-27)) {
          b3 = 0;
          return b3 | 0;
        }
        b3 = +q2(+(+e3[a3 + 8 >> 3] - +e3[b3 + 8 >> 3])) < 17453292519943298e-27;
        return b3 | 0;
      }
      function $b(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, f3 = 0, g3 = 0;
        f3 = +e3[b3 >> 3];
        d2 = +e3[a3 >> 3];
        g3 = +u2(+((f3 - d2) * 0.5));
        c2 = +u2(+((+e3[b3 + 8 >> 3] - +e3[a3 + 8 >> 3]) * 0.5));
        c2 = g3 * g3 + c2 * (+t2(+f3) * +t2(+d2) * c2);
        return +(+z2(+ +r2(+c2), + +r2(+(1 - c2))) * 2);
      }
      function ac2(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, f3 = 0, g3 = 0;
        f3 = +e3[b3 >> 3];
        d2 = +e3[a3 >> 3];
        g3 = +u2(+((f3 - d2) * 0.5));
        c2 = +u2(+((+e3[b3 + 8 >> 3] - +e3[a3 + 8 >> 3]) * 0.5));
        c2 = g3 * g3 + c2 * (+t2(+f3) * +t2(+d2) * c2);
        return +(+z2(+ +r2(+c2), + +r2(+(1 - c2))) * 2 * 6371.007180918475);
      }
      function bc2(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, f3 = 0, g3 = 0;
        f3 = +e3[b3 >> 3];
        d2 = +e3[a3 >> 3];
        g3 = +u2(+((f3 - d2) * 0.5));
        c2 = +u2(+((+e3[b3 + 8 >> 3] - +e3[a3 + 8 >> 3]) * 0.5));
        c2 = g3 * g3 + c2 * (+t2(+f3) * +t2(+d2) * c2);
        return +(+z2(+ +r2(+c2), + +r2(+(1 - c2))) * 2 * 6371.007180918475 * 1e3);
      }
      function cc2(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, f3 = 0, g3 = 0, h2 = 0;
        g3 = +e3[b3 >> 3];
        d2 = +t2(+g3);
        f3 = +e3[b3 + 8 >> 3] - +e3[a3 + 8 >> 3];
        h2 = d2 * +u2(+f3);
        c2 = +e3[a3 >> 3];
        return + +z2(+h2, +(+u2(+g3) * +t2(+c2) - +t2(+f3) * (d2 * +u2(+c2))));
      }
      function dc(a3, c2, d2, f3) {
        a3 = a3 | 0;
        c2 = +c2;
        d2 = +d2;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        if (d2 < 1e-16) {
          b2[f3 >> 2] = b2[a3 >> 2];
          b2[f3 + 4 >> 2] = b2[a3 + 4 >> 2];
          b2[f3 + 8 >> 2] = b2[a3 + 8 >> 2];
          b2[f3 + 12 >> 2] = b2[a3 + 12 >> 2];
          return;
        }
        h2 = c2 < 0 ? c2 + 6.283185307179586 : c2;
        h2 = !(c2 >= 6.283185307179586) ? h2 : h2 + -6.283185307179586;
        do {
          if (h2 < 1e-16) {
            c2 = +e3[a3 >> 3] + d2;
            e3[f3 >> 3] = c2;
            g3 = f3;
          } else {
            g3 = +q2(+(h2 + -3.141592653589793)) < 1e-16;
            c2 = +e3[a3 >> 3];
            if (g3) {
              c2 = c2 - d2;
              e3[f3 >> 3] = c2;
              g3 = f3;
              break;
            }
            i2 = +t2(+d2);
            d2 = +u2(+d2);
            c2 = i2 * +u2(+c2) + +t2(+h2) * (d2 * +t2(+c2));
            c2 = c2 > 1 ? 1 : c2;
            c2 = +x2(+(c2 < -1 ? -1 : c2));
            e3[f3 >> 3] = c2;
            if (+q2(+(c2 + -1.5707963267948966)) < 1e-16) {
              e3[f3 >> 3] = 1.5707963267948966;
              e3[f3 + 8 >> 3] = 0;
              return;
            }
            if (+q2(+(c2 + 1.5707963267948966)) < 1e-16) {
              e3[f3 >> 3] = -1.5707963267948966;
              e3[f3 + 8 >> 3] = 0;
              return;
            }
            j2 = +t2(+c2);
            h2 = d2 * +u2(+h2) / j2;
            d2 = +e3[a3 >> 3];
            c2 = (i2 - +u2(+c2) * +u2(+d2)) / +t2(+d2) / j2;
            i2 = h2 > 1 ? 1 : h2;
            c2 = c2 > 1 ? 1 : c2;
            c2 = +e3[a3 + 8 >> 3] + +z2(+(i2 < -1 ? -1 : i2), +(c2 < -1 ? -1 : c2));
            if (c2 > 3.141592653589793) {
              do {
                c2 = c2 + -6.283185307179586;
              } while (c2 > 3.141592653589793);
            }
            if (c2 < -3.141592653589793) {
              do {
                c2 = c2 + 6.283185307179586;
              } while (c2 < -3.141592653589793);
            }
            e3[f3 + 8 >> 3] = c2;
            return;
          }
        } while (0);
        if (+q2(+(c2 + -1.5707963267948966)) < 1e-16) {
          e3[g3 >> 3] = 1.5707963267948966;
          e3[f3 + 8 >> 3] = 0;
          return;
        }
        if (+q2(+(c2 + 1.5707963267948966)) < 1e-16) {
          e3[g3 >> 3] = -1.5707963267948966;
          e3[f3 + 8 >> 3] = 0;
          return;
        }
        c2 = +e3[a3 + 8 >> 3];
        if (c2 > 3.141592653589793) {
          do {
            c2 = c2 + -6.283185307179586;
          } while (c2 > 3.141592653589793);
        }
        if (c2 < -3.141592653589793) {
          do {
            c2 = c2 + 6.283185307179586;
          } while (c2 < -3.141592653589793);
        }
        e3[f3 + 8 >> 3] = c2;
        return;
      }
      function ec(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        if (a3 >>> 0 > 15) {
          b3 = 4;
          return b3 | 0;
        }
        e3[b3 >> 3] = +e3[20528 + (a3 << 3) >> 3];
        b3 = 0;
        return b3 | 0;
      }
      function fc(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        if (a3 >>> 0 > 15) {
          b3 = 4;
          return b3 | 0;
        }
        e3[b3 >> 3] = +e3[20656 + (a3 << 3) >> 3];
        b3 = 0;
        return b3 | 0;
      }
      function gc(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        if (a3 >>> 0 > 15) {
          b3 = 4;
          return b3 | 0;
        }
        e3[b3 >> 3] = +e3[20784 + (a3 << 3) >> 3];
        b3 = 0;
        return b3 | 0;
      }
      function hc(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        if (a3 >>> 0 > 15) {
          b3 = 4;
          return b3 | 0;
        }
        e3[b3 >> 3] = +e3[20912 + (a3 << 3) >> 3];
        b3 = 0;
        return b3 | 0;
      }
      function ic(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0;
        if (a3 >>> 0 > 15) {
          c2 = 4;
          return c2 | 0;
        }
        d2 = Cc(7, 0, a3, ((a3 | 0) < 0) << 31 >> 31) | 0;
        d2 = rd(d2 | 0, H2() | 0, 120, 0) | 0;
        a3 = H2() | 0;
        b2[c2 >> 2] = d2 | 2;
        b2[c2 + 4 >> 2] = a3;
        c2 = 0;
        return c2 | 0;
      }
      function jc(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        var d2 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0;
        n2 = +e3[b3 >> 3];
        l2 = +e3[a3 >> 3];
        j2 = +u2(+((n2 - l2) * 0.5));
        g3 = +e3[b3 + 8 >> 3];
        k2 = +e3[a3 + 8 >> 3];
        h2 = +u2(+((g3 - k2) * 0.5));
        i2 = +t2(+l2);
        m2 = +t2(+n2);
        h2 = j2 * j2 + h2 * (m2 * i2 * h2);
        h2 = +z2(+ +r2(+h2), + +r2(+(1 - h2))) * 2;
        j2 = +e3[c2 >> 3];
        n2 = +u2(+((j2 - n2) * 0.5));
        d2 = +e3[c2 + 8 >> 3];
        g3 = +u2(+((d2 - g3) * 0.5));
        f3 = +t2(+j2);
        g3 = n2 * n2 + g3 * (m2 * f3 * g3);
        g3 = +z2(+ +r2(+g3), + +r2(+(1 - g3))) * 2;
        j2 = +u2(+((l2 - j2) * 0.5));
        d2 = +u2(+((k2 - d2) * 0.5));
        d2 = j2 * j2 + d2 * (i2 * f3 * d2);
        d2 = +z2(+ +r2(+d2), + +r2(+(1 - d2))) * 2;
        f3 = (h2 + g3 + d2) * 0.5;
        return +(+y2(+ +r2(+(+v5(+(f3 * 0.5)) * +v5(+((f3 - h2) * 0.5)) * +v5(+((f3 - g3) * 0.5)) * +v5(+((f3 - d2) * 0.5))))) * 4);
      }
      function kc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        j2 = T2;
        T2 = T2 + 192 | 0;
        h2 = j2 + 168 | 0;
        i2 = j2;
        g3 = Pb(a3, c2, h2) | 0;
        if (g3 | 0) {
          d2 = g3;
          T2 = j2;
          return d2 | 0;
        }
        if (Qb(a3, c2, i2) | 0) {
          I2(23313, 22742, 386, 22751);
        }
        c2 = b2[i2 >> 2] | 0;
        if ((c2 | 0) > 0) {
          f3 = +jc(i2 + 8 | 0, i2 + 8 + (((c2 | 0) != 1 & 1) << 4) | 0, h2) + 0;
          if ((c2 | 0) != 1) {
            a3 = 1;
            do {
              g3 = a3;
              a3 = a3 + 1 | 0;
              f3 = f3 + +jc(i2 + 8 + (g3 << 4) | 0, i2 + 8 + (((a3 | 0) % (c2 | 0) | 0) << 4) | 0, h2);
            } while ((a3 | 0) < (c2 | 0));
          }
        } else {
          f3 = 0;
        }
        e3[d2 >> 3] = f3;
        d2 = 0;
        T2 = j2;
        return d2 | 0;
      }
      function lc(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        a3 = kc(a3, b3, c2) | 0;
        if (a3 | 0) {
          return a3 | 0;
        }
        e3[c2 >> 3] = +e3[c2 >> 3] * 6371.007180918475 * 6371.007180918475;
        return a3 | 0;
      }
      function mc(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        a3 = kc(a3, b3, c2) | 0;
        if (a3 | 0) {
          return a3 | 0;
        }
        e3[c2 >> 3] = +e3[c2 >> 3] * 6371.007180918475 * 6371.007180918475 * 1e3 * 1e3;
        return a3 | 0;
      }
      function nc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0;
        j2 = T2;
        T2 = T2 + 176 | 0;
        i2 = j2;
        a3 = gb(a3, c2, i2) | 0;
        if (a3 | 0) {
          i2 = a3;
          T2 = j2;
          return i2 | 0;
        }
        e3[d2 >> 3] = 0;
        a3 = b2[i2 >> 2] | 0;
        if ((a3 | 0) <= 1) {
          i2 = 0;
          T2 = j2;
          return i2 | 0;
        }
        c2 = a3 + -1 | 0;
        a3 = 0;
        f3 = +e3[i2 + 8 >> 3];
        g3 = +e3[i2 + 16 >> 3];
        h2 = 0;
        do {
          a3 = a3 + 1 | 0;
          l2 = f3;
          f3 = +e3[i2 + 8 + (a3 << 4) >> 3];
          m2 = +u2(+((f3 - l2) * 0.5));
          k2 = g3;
          g3 = +e3[i2 + 8 + (a3 << 4) + 8 >> 3];
          k2 = +u2(+((g3 - k2) * 0.5));
          k2 = m2 * m2 + k2 * (+t2(+f3) * +t2(+l2) * k2);
          h2 = h2 + +z2(+ +r2(+k2), + +r2(+(1 - k2))) * 2;
        } while ((a3 | 0) < (c2 | 0));
        e3[d2 >> 3] = h2;
        i2 = 0;
        T2 = j2;
        return i2 | 0;
      }
      function oc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0;
        j2 = T2;
        T2 = T2 + 176 | 0;
        i2 = j2;
        a3 = gb(a3, c2, i2) | 0;
        if (a3 | 0) {
          i2 = a3;
          h2 = +e3[d2 >> 3];
          h2 = h2 * 6371.007180918475;
          e3[d2 >> 3] = h2;
          T2 = j2;
          return i2 | 0;
        }
        e3[d2 >> 3] = 0;
        a3 = b2[i2 >> 2] | 0;
        if ((a3 | 0) <= 1) {
          i2 = 0;
          h2 = 0;
          h2 = h2 * 6371.007180918475;
          e3[d2 >> 3] = h2;
          T2 = j2;
          return i2 | 0;
        }
        c2 = a3 + -1 | 0;
        a3 = 0;
        f3 = +e3[i2 + 8 >> 3];
        g3 = +e3[i2 + 16 >> 3];
        h2 = 0;
        do {
          a3 = a3 + 1 | 0;
          l2 = f3;
          f3 = +e3[i2 + 8 + (a3 << 4) >> 3];
          m2 = +u2(+((f3 - l2) * 0.5));
          k2 = g3;
          g3 = +e3[i2 + 8 + (a3 << 4) + 8 >> 3];
          k2 = +u2(+((g3 - k2) * 0.5));
          k2 = m2 * m2 + k2 * (+t2(+l2) * +t2(+f3) * k2);
          h2 = h2 + +z2(+ +r2(+k2), + +r2(+(1 - k2))) * 2;
        } while ((a3 | 0) != (c2 | 0));
        e3[d2 >> 3] = h2;
        i2 = 0;
        m2 = h2;
        m2 = m2 * 6371.007180918475;
        e3[d2 >> 3] = m2;
        T2 = j2;
        return i2 | 0;
      }
      function pc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0;
        j2 = T2;
        T2 = T2 + 176 | 0;
        i2 = j2;
        a3 = gb(a3, c2, i2) | 0;
        if (a3 | 0) {
          i2 = a3;
          h2 = +e3[d2 >> 3];
          h2 = h2 * 6371.007180918475;
          h2 = h2 * 1e3;
          e3[d2 >> 3] = h2;
          T2 = j2;
          return i2 | 0;
        }
        e3[d2 >> 3] = 0;
        a3 = b2[i2 >> 2] | 0;
        if ((a3 | 0) <= 1) {
          i2 = 0;
          h2 = 0;
          h2 = h2 * 6371.007180918475;
          h2 = h2 * 1e3;
          e3[d2 >> 3] = h2;
          T2 = j2;
          return i2 | 0;
        }
        c2 = a3 + -1 | 0;
        a3 = 0;
        f3 = +e3[i2 + 8 >> 3];
        g3 = +e3[i2 + 16 >> 3];
        h2 = 0;
        do {
          a3 = a3 + 1 | 0;
          l2 = f3;
          f3 = +e3[i2 + 8 + (a3 << 4) >> 3];
          m2 = +u2(+((f3 - l2) * 0.5));
          k2 = g3;
          g3 = +e3[i2 + 8 + (a3 << 4) + 8 >> 3];
          k2 = +u2(+((g3 - k2) * 0.5));
          k2 = m2 * m2 + k2 * (+t2(+l2) * +t2(+f3) * k2);
          h2 = h2 + +z2(+ +r2(+k2), + +r2(+(1 - k2))) * 2;
        } while ((a3 | 0) != (c2 | 0));
        e3[d2 >> 3] = h2;
        i2 = 0;
        m2 = h2;
        m2 = m2 * 6371.007180918475;
        m2 = m2 * 1e3;
        e3[d2 >> 3] = m2;
        T2 = j2;
        return i2 | 0;
      }
      function qc(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0;
        c2 = kd(1, 12) | 0;
        if (!c2) {
          I2(22832, 22787, 49, 22845);
        }
        d2 = a3 + 4 | 0;
        e4 = b2[d2 >> 2] | 0;
        if (e4 | 0) {
          e4 = e4 + 8 | 0;
          b2[e4 >> 2] = c2;
          b2[d2 >> 2] = c2;
          return c2 | 0;
        }
        if (b2[a3 >> 2] | 0) {
          I2(22862, 22787, 61, 22885);
        }
        e4 = a3;
        b2[e4 >> 2] = c2;
        b2[d2 >> 2] = c2;
        return c2 | 0;
      }
      function rc(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0;
        e4 = id(24) | 0;
        if (!e4) {
          I2(22899, 22787, 78, 22913);
        }
        b2[e4 >> 2] = b2[c2 >> 2];
        b2[e4 + 4 >> 2] = b2[c2 + 4 >> 2];
        b2[e4 + 8 >> 2] = b2[c2 + 8 >> 2];
        b2[e4 + 12 >> 2] = b2[c2 + 12 >> 2];
        b2[e4 + 16 >> 2] = 0;
        c2 = a3 + 4 | 0;
        d2 = b2[c2 >> 2] | 0;
        if (d2 | 0) {
          b2[d2 + 16 >> 2] = e4;
          b2[c2 >> 2] = e4;
          return e4 | 0;
        }
        if (b2[a3 >> 2] | 0) {
          I2(22928, 22787, 82, 22913);
        }
        b2[a3 >> 2] = e4;
        b2[c2 >> 2] = e4;
        return e4 | 0;
      }
      function sc(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0;
        if (!a3) {
          return;
        }
        e4 = 1;
        while (1) {
          c2 = b2[a3 >> 2] | 0;
          if (c2 | 0) {
            do {
              d2 = b2[c2 >> 2] | 0;
              if (d2 | 0) {
                do {
                  f3 = d2;
                  d2 = b2[d2 + 16 >> 2] | 0;
                  jd(f3);
                } while ((d2 | 0) != 0);
              }
              f3 = c2;
              c2 = b2[c2 + 8 >> 2] | 0;
              jd(f3);
            } while ((c2 | 0) != 0);
          }
          c2 = a3;
          a3 = b2[a3 + 8 >> 2] | 0;
          if (!e4) {
            jd(c2);
          }
          if (!a3) {
            break;
          } else {
            e4 = 0;
          }
        }
        return;
      }
      function tc(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0, A3 = 0, B3 = 0, C3 = 0, D3 = 0, E4 = 0, F2 = 0, G3 = 0, H4 = 0, J3 = 0, K3 = 0;
        g3 = a3 + 8 | 0;
        if (b2[g3 >> 2] | 0) {
          K3 = 1;
          return K3 | 0;
        }
        f3 = b2[a3 >> 2] | 0;
        if (!f3) {
          K3 = 0;
          return K3 | 0;
        }
        c2 = f3;
        d2 = 0;
        do {
          d2 = d2 + 1 | 0;
          c2 = b2[c2 + 8 >> 2] | 0;
        } while ((c2 | 0) != 0);
        if (d2 >>> 0 < 2) {
          K3 = 0;
          return K3 | 0;
        }
        H4 = id(d2 << 2) | 0;
        if (!H4) {
          I2(22948, 22787, 317, 22967);
        }
        G3 = id(d2 << 5) | 0;
        if (!G3) {
          I2(22989, 22787, 321, 22967);
        }
        b2[a3 >> 2] = 0;
        z3 = a3 + 4 | 0;
        b2[z3 >> 2] = 0;
        b2[g3 >> 2] = 0;
        d2 = 0;
        F2 = 0;
        y3 = 0;
        n2 = 0;
        a:
          while (1) {
            m2 = b2[f3 >> 2] | 0;
            if (m2) {
              h2 = 0;
              i2 = m2;
              do {
                k2 = +e3[i2 + 8 >> 3];
                c2 = i2;
                i2 = b2[i2 + 16 >> 2] | 0;
                l2 = (i2 | 0) == 0;
                g3 = l2 ? m2 : i2;
                j2 = +e3[g3 + 8 >> 3];
                if (+q2(+(k2 - j2)) > 3.141592653589793) {
                  K3 = 14;
                  break;
                }
                h2 = h2 + (j2 - k2) * (+e3[c2 >> 3] + +e3[g3 >> 3]);
              } while (!l2);
              if ((K3 | 0) == 14) {
                K3 = 0;
                h2 = 0;
                c2 = m2;
                do {
                  x3 = +e3[c2 + 8 >> 3];
                  E4 = c2 + 16 | 0;
                  D3 = b2[E4 >> 2] | 0;
                  D3 = (D3 | 0) == 0 ? m2 : D3;
                  w3 = +e3[D3 + 8 >> 3];
                  h2 = h2 + (+e3[c2 >> 3] + +e3[D3 >> 3]) * ((w3 < 0 ? w3 + 6.283185307179586 : w3) - (x3 < 0 ? x3 + 6.283185307179586 : x3));
                  c2 = b2[((c2 | 0) == 0 ? f3 : E4) >> 2] | 0;
                } while ((c2 | 0) != 0);
              }
              if (h2 > 0) {
                b2[H4 + (F2 << 2) >> 2] = f3;
                F2 = F2 + 1 | 0;
                g3 = y3;
                c2 = n2;
              } else {
                K3 = 19;
              }
            } else {
              K3 = 19;
            }
            if ((K3 | 0) == 19) {
              K3 = 0;
              do {
                if (!d2) {
                  if (!n2) {
                    if (!(b2[a3 >> 2] | 0)) {
                      g3 = z3;
                      i2 = a3;
                      c2 = f3;
                      d2 = a3;
                      break;
                    } else {
                      K3 = 27;
                      break a;
                    }
                  } else {
                    g3 = z3;
                    i2 = n2 + 8 | 0;
                    c2 = f3;
                    d2 = a3;
                    break;
                  }
                } else {
                  c2 = d2 + 8 | 0;
                  if (b2[c2 >> 2] | 0) {
                    K3 = 21;
                    break a;
                  }
                  d2 = kd(1, 12) | 0;
                  if (!d2) {
                    K3 = 23;
                    break a;
                  }
                  b2[c2 >> 2] = d2;
                  g3 = d2 + 4 | 0;
                  i2 = d2;
                  c2 = n2;
                }
              } while (0);
              b2[i2 >> 2] = f3;
              b2[g3 >> 2] = f3;
              i2 = G3 + (y3 << 5) | 0;
              l2 = b2[f3 >> 2] | 0;
              if (l2) {
                m2 = G3 + (y3 << 5) + 8 | 0;
                e3[m2 >> 3] = 17976931348623157e292;
                n2 = G3 + (y3 << 5) + 24 | 0;
                e3[n2 >> 3] = 17976931348623157e292;
                e3[i2 >> 3] = -17976931348623157e292;
                o2 = G3 + (y3 << 5) + 16 | 0;
                e3[o2 >> 3] = -17976931348623157e292;
                u3 = 17976931348623157e292;
                v6 = -17976931348623157e292;
                g3 = 0;
                p3 = l2;
                k2 = 17976931348623157e292;
                s3 = 17976931348623157e292;
                t3 = -17976931348623157e292;
                j2 = -17976931348623157e292;
                while (1) {
                  h2 = +e3[p3 >> 3];
                  x3 = +e3[p3 + 8 >> 3];
                  p3 = b2[p3 + 16 >> 2] | 0;
                  r3 = (p3 | 0) == 0;
                  w3 = +e3[(r3 ? l2 : p3) + 8 >> 3];
                  if (h2 < k2) {
                    e3[m2 >> 3] = h2;
                    k2 = h2;
                  }
                  if (x3 < s3) {
                    e3[n2 >> 3] = x3;
                    s3 = x3;
                  }
                  if (h2 > t3) {
                    e3[i2 >> 3] = h2;
                  } else {
                    h2 = t3;
                  }
                  if (x3 > j2) {
                    e3[o2 >> 3] = x3;
                    j2 = x3;
                  }
                  u3 = x3 > 0 & x3 < u3 ? x3 : u3;
                  v6 = x3 < 0 & x3 > v6 ? x3 : v6;
                  g3 = g3 | +q2(+(x3 - w3)) > 3.141592653589793;
                  if (r3) {
                    break;
                  } else {
                    t3 = h2;
                  }
                }
                if (g3) {
                  e3[o2 >> 3] = v6;
                  e3[n2 >> 3] = u3;
                }
              } else {
                b2[i2 >> 2] = 0;
                b2[i2 + 4 >> 2] = 0;
                b2[i2 + 8 >> 2] = 0;
                b2[i2 + 12 >> 2] = 0;
                b2[i2 + 16 >> 2] = 0;
                b2[i2 + 20 >> 2] = 0;
                b2[i2 + 24 >> 2] = 0;
                b2[i2 + 28 >> 2] = 0;
              }
              g3 = y3 + 1 | 0;
            }
            E4 = f3 + 8 | 0;
            f3 = b2[E4 >> 2] | 0;
            b2[E4 >> 2] = 0;
            if (!f3) {
              K3 = 45;
              break;
            } else {
              y3 = g3;
              n2 = c2;
            }
          }
        if ((K3 | 0) == 21) {
          I2(22765, 22787, 35, 22799);
        } else if ((K3 | 0) == 23) {
          I2(22819, 22787, 37, 22799);
        } else if ((K3 | 0) == 27) {
          I2(22862, 22787, 61, 22885);
        } else if ((K3 | 0) == 45) {
          b:
            do {
              if ((F2 | 0) > 0) {
                E4 = (g3 | 0) == 0;
                C3 = g3 << 2;
                D3 = (a3 | 0) == 0;
                B3 = 0;
                c2 = 0;
                while (1) {
                  A3 = b2[H4 + (B3 << 2) >> 2] | 0;
                  if (!E4) {
                    y3 = id(C3) | 0;
                    if (!y3) {
                      K3 = 50;
                      break;
                    }
                    z3 = id(C3) | 0;
                    if (!z3) {
                      K3 = 52;
                      break;
                    }
                    c:
                      do {
                        if (!D3) {
                          g3 = 0;
                          d2 = 0;
                          i2 = a3;
                          while (1) {
                            f3 = G3 + (g3 << 5) | 0;
                            if (uc(b2[i2 >> 2] | 0, f3, b2[A3 >> 2] | 0) | 0) {
                              b2[y3 + (d2 << 2) >> 2] = i2;
                              b2[z3 + (d2 << 2) >> 2] = f3;
                              r3 = d2 + 1 | 0;
                            } else {
                              r3 = d2;
                            }
                            i2 = b2[i2 + 8 >> 2] | 0;
                            if (!i2) {
                              break;
                            } else {
                              g3 = g3 + 1 | 0;
                              d2 = r3;
                            }
                          }
                          if ((r3 | 0) > 0) {
                            f3 = b2[y3 >> 2] | 0;
                            if ((r3 | 0) == 1) {
                              d2 = f3;
                            } else {
                              o2 = 0;
                              p3 = -1;
                              d2 = f3;
                              n2 = f3;
                              while (1) {
                                l2 = b2[n2 >> 2] | 0;
                                f3 = 0;
                                i2 = 0;
                                while (1) {
                                  g3 = b2[b2[y3 + (i2 << 2) >> 2] >> 2] | 0;
                                  if ((g3 | 0) == (l2 | 0)) {
                                    m2 = f3;
                                  } else {
                                    m2 = f3 + ((uc(g3, b2[z3 + (i2 << 2) >> 2] | 0, b2[l2 >> 2] | 0) | 0) & 1) | 0;
                                  }
                                  i2 = i2 + 1 | 0;
                                  if ((i2 | 0) == (r3 | 0)) {
                                    break;
                                  } else {
                                    f3 = m2;
                                  }
                                }
                                g3 = (m2 | 0) > (p3 | 0);
                                d2 = g3 ? n2 : d2;
                                f3 = o2 + 1 | 0;
                                if ((f3 | 0) == (r3 | 0)) {
                                  break c;
                                }
                                o2 = f3;
                                p3 = g3 ? m2 : p3;
                                n2 = b2[y3 + (f3 << 2) >> 2] | 0;
                              }
                            }
                          } else {
                            d2 = 0;
                          }
                        } else {
                          d2 = 0;
                        }
                      } while (0);
                    jd(y3);
                    jd(z3);
                    if (d2) {
                      g3 = d2 + 4 | 0;
                      f3 = b2[g3 >> 2] | 0;
                      if (!f3) {
                        if (b2[d2 >> 2] | 0) {
                          K3 = 70;
                          break;
                        }
                      } else {
                        d2 = f3 + 8 | 0;
                      }
                      b2[d2 >> 2] = A3;
                      b2[g3 >> 2] = A3;
                    } else {
                      K3 = 73;
                    }
                  } else {
                    K3 = 73;
                  }
                  if ((K3 | 0) == 73) {
                    K3 = 0;
                    c2 = b2[A3 >> 2] | 0;
                    if (c2 | 0) {
                      do {
                        z3 = c2;
                        c2 = b2[c2 + 16 >> 2] | 0;
                        jd(z3);
                      } while ((c2 | 0) != 0);
                    }
                    jd(A3);
                    c2 = 1;
                  }
                  B3 = B3 + 1 | 0;
                  if ((B3 | 0) >= (F2 | 0)) {
                    J3 = c2;
                    break b;
                  }
                }
                if ((K3 | 0) == 50) {
                  I2(23004, 22787, 249, 23023);
                } else if ((K3 | 0) == 52) {
                  I2(23042, 22787, 252, 23023);
                } else if ((K3 | 0) == 70) {
                  I2(22862, 22787, 61, 22885);
                }
              } else {
                J3 = 0;
              }
            } while (0);
          jd(H4);
          jd(G3);
          K3 = J3;
          return K3 | 0;
        }
        return 0;
      }
      function uc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0;
        if (!(ya(c2, d2) | 0)) {
          a3 = 0;
          return a3 | 0;
        }
        c2 = xa(c2) | 0;
        f3 = +e3[d2 >> 3];
        g3 = +e3[d2 + 8 >> 3];
        g3 = c2 & g3 < 0 ? g3 + 6.283185307179586 : g3;
        a3 = b2[a3 >> 2] | 0;
        if (!a3) {
          a3 = 0;
          return a3 | 0;
        }
        if (c2) {
          c2 = 0;
          l2 = g3;
          d2 = a3;
          a:
            while (1) {
              while (1) {
                i2 = +e3[d2 >> 3];
                g3 = +e3[d2 + 8 >> 3];
                d2 = d2 + 16 | 0;
                m2 = b2[d2 >> 2] | 0;
                m2 = (m2 | 0) == 0 ? a3 : m2;
                h2 = +e3[m2 >> 3];
                j2 = +e3[m2 + 8 >> 3];
                if (i2 > h2) {
                  k2 = i2;
                  i2 = j2;
                } else {
                  k2 = h2;
                  h2 = i2;
                  i2 = g3;
                  g3 = j2;
                }
                f3 = f3 == h2 | f3 == k2 ? f3 + 2220446049250313e-31 : f3;
                if (!(f3 < h2 | f3 > k2)) {
                  break;
                }
                d2 = b2[d2 >> 2] | 0;
                if (!d2) {
                  d2 = 22;
                  break a;
                }
              }
              j2 = i2 < 0 ? i2 + 6.283185307179586 : i2;
              i2 = g3 < 0 ? g3 + 6.283185307179586 : g3;
              l2 = j2 == l2 | i2 == l2 ? l2 + -2220446049250313e-31 : l2;
              k2 = j2 + (i2 - j2) * ((f3 - h2) / (k2 - h2));
              if ((k2 < 0 ? k2 + 6.283185307179586 : k2) > l2) {
                c2 = c2 ^ 1;
              }
              d2 = b2[d2 >> 2] | 0;
              if (!d2) {
                d2 = 22;
                break;
              }
            }
          if ((d2 | 0) == 22) {
            return c2 | 0;
          }
        } else {
          c2 = 0;
          l2 = g3;
          d2 = a3;
          b:
            while (1) {
              while (1) {
                i2 = +e3[d2 >> 3];
                g3 = +e3[d2 + 8 >> 3];
                d2 = d2 + 16 | 0;
                m2 = b2[d2 >> 2] | 0;
                m2 = (m2 | 0) == 0 ? a3 : m2;
                h2 = +e3[m2 >> 3];
                j2 = +e3[m2 + 8 >> 3];
                if (i2 > h2) {
                  k2 = i2;
                  i2 = j2;
                } else {
                  k2 = h2;
                  h2 = i2;
                  i2 = g3;
                  g3 = j2;
                }
                f3 = f3 == h2 | f3 == k2 ? f3 + 2220446049250313e-31 : f3;
                if (!(f3 < h2 | f3 > k2)) {
                  break;
                }
                d2 = b2[d2 >> 2] | 0;
                if (!d2) {
                  d2 = 22;
                  break b;
                }
              }
              l2 = i2 == l2 | g3 == l2 ? l2 + -2220446049250313e-31 : l2;
              if (i2 + (g3 - i2) * ((f3 - h2) / (k2 - h2)) > l2) {
                c2 = c2 ^ 1;
              }
              d2 = b2[d2 >> 2] | 0;
              if (!d2) {
                d2 = 22;
                break;
              }
            }
          if ((d2 | 0) == 22) {
            return c2 | 0;
          }
        }
        return 0;
      }
      function vc(c2, d2, e4, f3, g3) {
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        g3 = g3 | 0;
        var h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0;
        u3 = T2;
        T2 = T2 + 32 | 0;
        t3 = u3 + 16 | 0;
        s3 = u3;
        h2 = vd(c2 | 0, d2 | 0, 52) | 0;
        H2() | 0;
        h2 = h2 & 15;
        p3 = vd(e4 | 0, f3 | 0, 52) | 0;
        H2() | 0;
        if ((h2 | 0) != (p3 & 15 | 0)) {
          t3 = 12;
          T2 = u3;
          return t3 | 0;
        }
        l2 = vd(c2 | 0, d2 | 0, 45) | 0;
        H2() | 0;
        l2 = l2 & 127;
        m2 = vd(e4 | 0, f3 | 0, 45) | 0;
        H2() | 0;
        m2 = m2 & 127;
        if (l2 >>> 0 > 121 | m2 >>> 0 > 121) {
          t3 = 5;
          T2 = u3;
          return t3 | 0;
        }
        p3 = (l2 | 0) != (m2 | 0);
        if (p3) {
          j2 = ua(l2, m2) | 0;
          if ((j2 | 0) == 7) {
            t3 = 1;
            T2 = u3;
            return t3 | 0;
          }
          k2 = ua(m2, l2) | 0;
          if ((k2 | 0) == 7) {
            I2(23066, 23090, 161, 23100);
          } else {
            q3 = j2;
            i2 = k2;
          }
        } else {
          q3 = 0;
          i2 = 0;
        }
        n2 = ma(l2) | 0;
        o2 = ma(m2) | 0;
        b2[t3 >> 2] = 0;
        b2[t3 + 4 >> 2] = 0;
        b2[t3 + 8 >> 2] = 0;
        b2[t3 + 12 >> 2] = 0;
        do {
          if (!q3) {
            Nb(e4, f3, t3) | 0;
            if ((n2 | 0) != 0 & (o2 | 0) != 0) {
              if ((m2 | 0) != (l2 | 0)) {
                I2(23173, 23090, 261, 23100);
              }
              i2 = Fb(c2, d2) | 0;
              h2 = Fb(e4, f3) | 0;
              if (!((i2 | 0) == 7 | (h2 | 0) == 7)) {
                if (!(a2[21872 + (i2 * 7 | 0) + h2 >> 0] | 0)) {
                  i2 = b2[21040 + (i2 * 28 | 0) + (h2 << 2) >> 2] | 0;
                  if ((i2 | 0) > 0) {
                    j2 = t3 + 4 | 0;
                    h2 = 0;
                    do {
                      Ra(j2);
                      h2 = h2 + 1 | 0;
                    } while ((h2 | 0) != (i2 | 0));
                    r3 = 51;
                  } else {
                    r3 = 51;
                  }
                } else {
                  h2 = 1;
                }
              } else {
                h2 = 5;
              }
            } else {
              r3 = 51;
            }
          } else {
            m2 = b2[4272 + (l2 * 28 | 0) + (q3 << 2) >> 2] | 0;
            j2 = (m2 | 0) > 0;
            if (!o2) {
              if (j2) {
                l2 = 0;
                k2 = e4;
                j2 = f3;
                do {
                  k2 = Jb(k2, j2) | 0;
                  j2 = H2() | 0;
                  i2 = Ta(i2) | 0;
                  l2 = l2 + 1 | 0;
                } while ((l2 | 0) != (m2 | 0));
                m2 = i2;
                l2 = k2;
                k2 = j2;
              } else {
                m2 = i2;
                l2 = e4;
                k2 = f3;
              }
            } else if (j2) {
              l2 = 0;
              k2 = e4;
              j2 = f3;
              do {
                k2 = Ib(k2, j2) | 0;
                j2 = H2() | 0;
                i2 = Ta(i2) | 0;
                if ((i2 | 0) == 1) {
                  i2 = Ta(1) | 0;
                }
                l2 = l2 + 1 | 0;
              } while ((l2 | 0) != (m2 | 0));
              m2 = i2;
              l2 = k2;
              k2 = j2;
            } else {
              m2 = i2;
              l2 = e4;
              k2 = f3;
            }
            Nb(l2, k2, t3) | 0;
            if (!p3) {
              I2(23115, 23090, 191, 23100);
            }
            j2 = (n2 | 0) != 0;
            i2 = (o2 | 0) != 0;
            if (j2 & i2) {
              I2(23142, 23090, 192, 23100);
            }
            if (!j2) {
              if (i2) {
                i2 = Fb(l2, k2) | 0;
                if ((i2 | 0) == 7) {
                  h2 = 5;
                  break;
                }
                if (a2[21872 + (i2 * 7 | 0) + m2 >> 0] | 0) {
                  h2 = 1;
                  break;
                }
                l2 = 0;
                k2 = b2[21040 + (m2 * 28 | 0) + (i2 << 2) >> 2] | 0;
              } else {
                l2 = 0;
                k2 = 0;
              }
            } else {
              i2 = Fb(c2, d2) | 0;
              if ((i2 | 0) == 7) {
                h2 = 5;
                break;
              }
              if (a2[21872 + (i2 * 7 | 0) + q3 >> 0] | 0) {
                h2 = 1;
                break;
              }
              k2 = b2[21040 + (i2 * 28 | 0) + (q3 << 2) >> 2] | 0;
              l2 = k2;
            }
            if ((l2 | k2 | 0) < 0) {
              h2 = 5;
            } else {
              if ((k2 | 0) > 0) {
                j2 = t3 + 4 | 0;
                i2 = 0;
                do {
                  Ra(j2);
                  i2 = i2 + 1 | 0;
                } while ((i2 | 0) != (k2 | 0));
              }
              b2[s3 >> 2] = 0;
              b2[s3 + 4 >> 2] = 0;
              b2[s3 + 8 >> 2] = 0;
              Pa(s3, q3);
              if (h2 | 0) {
                while (1) {
                  if (!(Lb(h2) | 0)) {
                    Oa(s3);
                  } else {
                    Na(s3);
                  }
                  if ((h2 | 0) > 1) {
                    h2 = h2 + -1 | 0;
                  } else {
                    break;
                  }
                }
              }
              if ((l2 | 0) > 0) {
                h2 = 0;
                do {
                  Ra(s3);
                  h2 = h2 + 1 | 0;
                } while ((h2 | 0) != (l2 | 0));
              }
              r3 = t3 + 4 | 0;
              Fa(r3, s3, r3);
              Da(r3);
              r3 = 51;
            }
          }
        } while (0);
        if ((r3 | 0) == 51) {
          h2 = t3 + 4 | 0;
          b2[g3 >> 2] = b2[h2 >> 2];
          b2[g3 + 4 >> 2] = b2[h2 + 4 >> 2];
          b2[g3 + 8 >> 2] = b2[h2 + 8 >> 2];
          h2 = 0;
        }
        t3 = h2;
        T2 = u3;
        return t3 | 0;
      }
      function wc(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0;
        q3 = T2;
        T2 = T2 + 48 | 0;
        k2 = q3 + 36 | 0;
        h2 = q3 + 24 | 0;
        i2 = q3 + 12 | 0;
        j2 = q3;
        f3 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        f3 = f3 & 15;
        n2 = vd(a3 | 0, c2 | 0, 45) | 0;
        H2() | 0;
        n2 = n2 & 127;
        if (n2 >>> 0 > 121) {
          e4 = 5;
          T2 = q3;
          return e4 | 0;
        }
        l2 = ma(n2) | 0;
        wd(f3 | 0, 0, 52) | 0;
        r3 = H2() | 0 | 134225919;
        g3 = e4;
        b2[g3 >> 2] = -1;
        b2[g3 + 4 >> 2] = r3;
        if (!f3) {
          f3 = Ia(d2) | 0;
          if ((f3 | 0) == 7) {
            r3 = 1;
            T2 = q3;
            return r3 | 0;
          }
          f3 = ta(n2, f3) | 0;
          if ((f3 | 0) == 127) {
            r3 = 1;
            T2 = q3;
            return r3 | 0;
          }
          o2 = wd(f3 | 0, 0, 45) | 0;
          p3 = H2() | 0;
          n2 = e4;
          p3 = b2[n2 + 4 >> 2] & -1040385 | p3;
          r3 = e4;
          b2[r3 >> 2] = b2[n2 >> 2] | o2;
          b2[r3 + 4 >> 2] = p3;
          r3 = 0;
          T2 = q3;
          return r3 | 0;
        }
        b2[k2 >> 2] = b2[d2 >> 2];
        b2[k2 + 4 >> 2] = b2[d2 + 4 >> 2];
        b2[k2 + 8 >> 2] = b2[d2 + 8 >> 2];
        d2 = f3;
        while (1) {
          g3 = d2;
          d2 = d2 + -1 | 0;
          b2[h2 >> 2] = b2[k2 >> 2];
          b2[h2 + 4 >> 2] = b2[k2 + 4 >> 2];
          b2[h2 + 8 >> 2] = b2[k2 + 8 >> 2];
          if (!(Lb(g3) | 0)) {
            f3 = Ka(k2) | 0;
            if (f3 | 0) {
              d2 = 13;
              break;
            }
            b2[i2 >> 2] = b2[k2 >> 2];
            b2[i2 + 4 >> 2] = b2[k2 + 4 >> 2];
            b2[i2 + 8 >> 2] = b2[k2 + 8 >> 2];
            Oa(i2);
          } else {
            f3 = Ja(k2) | 0;
            if (f3 | 0) {
              d2 = 13;
              break;
            }
            b2[i2 >> 2] = b2[k2 >> 2];
            b2[i2 + 4 >> 2] = b2[k2 + 4 >> 2];
            b2[i2 + 8 >> 2] = b2[k2 + 8 >> 2];
            Na(i2);
          }
          Ga(h2, i2, j2);
          Da(j2);
          f3 = e4;
          t3 = b2[f3 >> 2] | 0;
          f3 = b2[f3 + 4 >> 2] | 0;
          u3 = (15 - g3 | 0) * 3 | 0;
          s3 = wd(7, 0, u3 | 0) | 0;
          f3 = f3 & ~(H2() | 0);
          u3 = wd(Ia(j2) | 0, 0, u3 | 0) | 0;
          f3 = H2() | 0 | f3;
          r3 = e4;
          b2[r3 >> 2] = u3 | t3 & ~s3;
          b2[r3 + 4 >> 2] = f3;
          if ((g3 | 0) <= 1) {
            d2 = 14;
            break;
          }
        }
        a:
          do {
            if ((d2 | 0) != 13) {
              if ((d2 | 0) == 14) {
                if (((b2[k2 >> 2] | 0) <= 1 ? (b2[k2 + 4 >> 2] | 0) <= 1 : 0) ? (b2[k2 + 8 >> 2] | 0) <= 1 : 0) {
                  d2 = Ia(k2) | 0;
                  f3 = ta(n2, d2) | 0;
                  if ((f3 | 0) == 127) {
                    j2 = 0;
                  } else {
                    j2 = ma(f3) | 0;
                  }
                  b:
                    do {
                      if (!d2) {
                        if ((l2 | 0) != 0 & (j2 | 0) != 0) {
                          d2 = Fb(a3, c2) | 0;
                          g3 = e4;
                          g3 = Fb(b2[g3 >> 2] | 0, b2[g3 + 4 >> 2] | 0) | 0;
                          if ((d2 | 0) == 7 | (g3 | 0) == 7) {
                            f3 = 5;
                            break a;
                          }
                          g3 = b2[21248 + (d2 * 28 | 0) + (g3 << 2) >> 2] | 0;
                          if ((g3 | 0) < 0) {
                            f3 = 5;
                            break a;
                          }
                          if (!g3) {
                            d2 = 59;
                          } else {
                            i2 = e4;
                            d2 = 0;
                            h2 = b2[i2 >> 2] | 0;
                            i2 = b2[i2 + 4 >> 2] | 0;
                            do {
                              h2 = Hb(h2, i2) | 0;
                              i2 = H2() | 0;
                              u3 = e4;
                              b2[u3 >> 2] = h2;
                              b2[u3 + 4 >> 2] = i2;
                              d2 = d2 + 1 | 0;
                            } while ((d2 | 0) < (g3 | 0));
                            d2 = 58;
                          }
                        } else {
                          d2 = 58;
                        }
                      } else {
                        if (l2) {
                          f3 = Fb(a3, c2) | 0;
                          if ((f3 | 0) == 7) {
                            f3 = 5;
                            break a;
                          }
                          g3 = b2[21248 + (f3 * 28 | 0) + (d2 << 2) >> 2] | 0;
                          if ((g3 | 0) > 0) {
                            f3 = d2;
                            d2 = 0;
                            do {
                              f3 = Sa(f3) | 0;
                              d2 = d2 + 1 | 0;
                            } while ((d2 | 0) != (g3 | 0));
                          } else {
                            f3 = d2;
                          }
                          if ((f3 | 0) == 1) {
                            f3 = 9;
                            break a;
                          }
                          d2 = ta(n2, f3) | 0;
                          if ((d2 | 0) == 127) {
                            I2(23200, 23090, 411, 23230);
                          }
                          if (!(ma(d2) | 0)) {
                            p3 = d2;
                            o2 = g3;
                            m2 = f3;
                          } else {
                            I2(23245, 23090, 412, 23230);
                          }
                        } else {
                          p3 = f3;
                          o2 = 0;
                          m2 = d2;
                        }
                        i2 = b2[4272 + (n2 * 28 | 0) + (m2 << 2) >> 2] | 0;
                        if ((i2 | 0) <= -1) {
                          I2(23276, 23090, 419, 23230);
                        }
                        if (!j2) {
                          if ((o2 | 0) < 0) {
                            f3 = 5;
                            break a;
                          }
                          if (o2 | 0) {
                            g3 = e4;
                            f3 = 0;
                            d2 = b2[g3 >> 2] | 0;
                            g3 = b2[g3 + 4 >> 2] | 0;
                            do {
                              d2 = Hb(d2, g3) | 0;
                              g3 = H2() | 0;
                              u3 = e4;
                              b2[u3 >> 2] = d2;
                              b2[u3 + 4 >> 2] = g3;
                              f3 = f3 + 1 | 0;
                            } while ((f3 | 0) < (o2 | 0));
                          }
                          if ((i2 | 0) <= 0) {
                            f3 = p3;
                            d2 = 58;
                            break;
                          }
                          g3 = e4;
                          f3 = 0;
                          d2 = b2[g3 >> 2] | 0;
                          g3 = b2[g3 + 4 >> 2] | 0;
                          while (1) {
                            d2 = Hb(d2, g3) | 0;
                            g3 = H2() | 0;
                            u3 = e4;
                            b2[u3 >> 2] = d2;
                            b2[u3 + 4 >> 2] = g3;
                            f3 = f3 + 1 | 0;
                            if ((f3 | 0) == (i2 | 0)) {
                              f3 = p3;
                              d2 = 58;
                              break b;
                            }
                          }
                        }
                        h2 = ua(p3, n2) | 0;
                        if ((h2 | 0) == 7) {
                          I2(23066, 23090, 428, 23230);
                        }
                        f3 = e4;
                        d2 = b2[f3 >> 2] | 0;
                        f3 = b2[f3 + 4 >> 2] | 0;
                        if ((i2 | 0) > 0) {
                          g3 = 0;
                          do {
                            d2 = Hb(d2, f3) | 0;
                            f3 = H2() | 0;
                            u3 = e4;
                            b2[u3 >> 2] = d2;
                            b2[u3 + 4 >> 2] = f3;
                            g3 = g3 + 1 | 0;
                          } while ((g3 | 0) != (i2 | 0));
                        }
                        f3 = Fb(d2, f3) | 0;
                        if ((f3 | 0) == 7) {
                          I2(23313, 23090, 440, 23230);
                        }
                        d2 = na(p3) | 0;
                        d2 = b2[(d2 ? 21664 : 21456) + (h2 * 28 | 0) + (f3 << 2) >> 2] | 0;
                        if ((d2 | 0) < 0) {
                          I2(23313, 23090, 454, 23230);
                        }
                        if (!d2) {
                          f3 = p3;
                          d2 = 58;
                        } else {
                          h2 = e4;
                          f3 = 0;
                          g3 = b2[h2 >> 2] | 0;
                          h2 = b2[h2 + 4 >> 2] | 0;
                          do {
                            g3 = Gb(g3, h2) | 0;
                            h2 = H2() | 0;
                            u3 = e4;
                            b2[u3 >> 2] = g3;
                            b2[u3 + 4 >> 2] = h2;
                            f3 = f3 + 1 | 0;
                          } while ((f3 | 0) < (d2 | 0));
                          f3 = p3;
                          d2 = 58;
                        }
                      }
                    } while (0);
                  if ((d2 | 0) == 58) {
                    if (j2) {
                      d2 = 59;
                    }
                  }
                  if ((d2 | 0) == 59) {
                    u3 = e4;
                    if ((Fb(b2[u3 >> 2] | 0, b2[u3 + 4 >> 2] | 0) | 0) == 1) {
                      f3 = 9;
                      break;
                    }
                  }
                  u3 = e4;
                  s3 = b2[u3 >> 2] | 0;
                  u3 = b2[u3 + 4 >> 2] & -1040385;
                  t3 = wd(f3 | 0, 0, 45) | 0;
                  u3 = u3 | (H2() | 0);
                  f3 = e4;
                  b2[f3 >> 2] = s3 | t3;
                  b2[f3 + 4 >> 2] = u3;
                  f3 = 0;
                } else {
                  f3 = 1;
                }
              }
            }
          } while (0);
        u3 = f3;
        T2 = q3;
        return u3 | 0;
      }
      function xc(a3, b3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0;
        h2 = T2;
        T2 = T2 + 16 | 0;
        g3 = h2;
        if (!e4) {
          a3 = vc(a3, b3, c2, d2, g3) | 0;
          if (!a3) {
            Xa(g3, f3);
            a3 = 0;
          }
        } else {
          a3 = 15;
        }
        T2 = h2;
        return a3 | 0;
      }
      function yc(a3, b3, c2, d2, e4) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0;
        g3 = T2;
        T2 = T2 + 16 | 0;
        f3 = g3;
        if (!d2) {
          c2 = Ya(c2, f3) | 0;
          if (!c2) {
            c2 = wc(a3, b3, f3, e4) | 0;
          }
        } else {
          c2 = 15;
        }
        T2 = g3;
        return c2 | 0;
      }
      function zc(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        j2 = T2;
        T2 = T2 + 32 | 0;
        h2 = j2 + 12 | 0;
        i2 = j2;
        g3 = vc(a3, c2, a3, c2, h2) | 0;
        if (g3 | 0) {
          i2 = g3;
          T2 = j2;
          return i2 | 0;
        }
        a3 = vc(a3, c2, d2, e4, i2) | 0;
        if (a3 | 0) {
          i2 = a3;
          T2 = j2;
          return i2 | 0;
        }
        h2 = Wa(h2, i2) | 0;
        i2 = f3;
        b2[i2 >> 2] = h2;
        b2[i2 + 4 >> 2] = ((h2 | 0) < 0) << 31 >> 31;
        i2 = 0;
        T2 = j2;
        return i2 | 0;
      }
      function Ac(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        j2 = T2;
        T2 = T2 + 32 | 0;
        h2 = j2 + 12 | 0;
        i2 = j2;
        g3 = vc(a3, c2, a3, c2, h2) | 0;
        if (!g3) {
          g3 = vc(a3, c2, d2, e4, i2) | 0;
          if (!g3) {
            e4 = Wa(h2, i2) | 0;
            e4 = ld(e4 | 0, ((e4 | 0) < 0) << 31 >> 31 | 0, 1, 0) | 0;
            h2 = H2() | 0;
            i2 = f3;
            b2[i2 >> 2] = e4;
            b2[i2 + 4 >> 2] = h2;
            i2 = 0;
            T2 = j2;
            return i2 | 0;
          }
        }
        i2 = g3;
        T2 = j2;
        return i2 | 0;
      }
      function Bc(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0, A3 = 0;
        z3 = T2;
        T2 = T2 + 48 | 0;
        h2 = z3 + 24 | 0;
        i2 = z3 + 12 | 0;
        y3 = z3;
        g3 = vc(a3, c2, a3, c2, h2) | 0;
        if (!g3) {
          g3 = vc(a3, c2, d2, e4, i2) | 0;
          if (!g3) {
            w3 = Wa(h2, i2) | 0;
            x3 = ((w3 | 0) < 0) << 31 >> 31;
            b2[h2 >> 2] = 0;
            b2[h2 + 4 >> 2] = 0;
            b2[h2 + 8 >> 2] = 0;
            b2[i2 >> 2] = 0;
            b2[i2 + 4 >> 2] = 0;
            b2[i2 + 8 >> 2] = 0;
            if (vc(a3, c2, a3, c2, h2) | 0) {
              I2(23313, 23090, 691, 23299);
            }
            if (vc(a3, c2, d2, e4, i2) | 0) {
              I2(23313, 23090, 696, 23299);
            }
            Za(h2);
            Za(i2);
            if (!w3) {
              g3 = h2 + 4 | 0;
              d2 = h2 + 8 | 0;
              t3 = g3;
              u3 = d2;
              v6 = h2;
              e4 = b2[h2 >> 2] | 0;
              g3 = b2[g3 >> 2] | 0;
              d2 = b2[d2 >> 2] | 0;
              r3 = 0;
              s3 = 0;
              p3 = 0;
            } else {
              m2 = b2[h2 >> 2] | 0;
              p3 = +(w3 | 0);
              t3 = h2 + 4 | 0;
              n2 = b2[t3 >> 2] | 0;
              u3 = h2 + 8 | 0;
              o2 = b2[u3 >> 2] | 0;
              v6 = h2;
              e4 = m2;
              g3 = n2;
              d2 = o2;
              r3 = +((b2[i2 >> 2] | 0) - m2 | 0) / p3;
              s3 = +((b2[i2 + 4 >> 2] | 0) - n2 | 0) / p3;
              p3 = +((b2[i2 + 8 >> 2] | 0) - o2 | 0) / p3;
            }
            b2[y3 >> 2] = e4;
            o2 = y3 + 4 | 0;
            b2[o2 >> 2] = g3;
            n2 = y3 + 8 | 0;
            b2[n2 >> 2] = d2;
            a:
              do {
                if ((w3 | 0) < 0) {
                  g3 = 0;
                } else {
                  l2 = 0;
                  m2 = 0;
                  g3 = e4;
                  while (1) {
                    k2 = +(m2 >>> 0) + 4294967296 * +(l2 | 0);
                    A3 = r3 * k2 + +(g3 | 0);
                    j2 = s3 * k2 + +(b2[t3 >> 2] | 0);
                    k2 = p3 * k2 + +(b2[u3 >> 2] | 0);
                    d2 = ~~+zd(+A3);
                    h2 = ~~+zd(+j2);
                    g3 = ~~+zd(+k2);
                    A3 = +q2(+(+(d2 | 0) - A3));
                    j2 = +q2(+(+(h2 | 0) - j2));
                    k2 = +q2(+(+(g3 | 0) - k2));
                    do {
                      if (!(A3 > j2 & A3 > k2)) {
                        i2 = 0 - d2 | 0;
                        if (j2 > k2) {
                          e4 = i2 - g3 | 0;
                          break;
                        } else {
                          e4 = h2;
                          g3 = i2 - h2 | 0;
                          break;
                        }
                      } else {
                        d2 = 0 - (h2 + g3) | 0;
                        e4 = h2;
                      }
                    } while (0);
                    b2[y3 >> 2] = d2;
                    b2[o2 >> 2] = e4;
                    b2[n2 >> 2] = g3;
                    _a3(y3);
                    g3 = wc(a3, c2, y3, f3 + (m2 << 3) | 0) | 0;
                    if (g3 | 0) {
                      break a;
                    }
                    if (!((l2 | 0) < (x3 | 0) | (l2 | 0) == (x3 | 0) & m2 >>> 0 < w3 >>> 0)) {
                      g3 = 0;
                      break a;
                    }
                    g3 = ld(m2 | 0, l2 | 0, 1, 0) | 0;
                    i2 = H2() | 0;
                    l2 = i2;
                    m2 = g3;
                    g3 = b2[v6 >> 2] | 0;
                  }
                }
              } while (0);
            y3 = g3;
            T2 = z3;
            return y3 | 0;
          }
        }
        y3 = g3;
        T2 = z3;
        return y3 | 0;
      }
      function Cc(a3, b3, c2, d2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0;
        if ((c2 | 0) == 0 & (d2 | 0) == 0) {
          e4 = 0;
          f3 = 1;
          G2(e4 | 0);
          return f3 | 0;
        }
        f3 = a3;
        e4 = b3;
        a3 = 1;
        b3 = 0;
        do {
          g3 = (c2 & 1 | 0) == 0 & true;
          a3 = rd((g3 ? 1 : f3) | 0, (g3 ? 0 : e4) | 0, a3 | 0, b3 | 0) | 0;
          b3 = H2() | 0;
          c2 = ud(c2 | 0, d2 | 0, 1) | 0;
          d2 = H2() | 0;
          f3 = rd(f3 | 0, e4 | 0, f3 | 0, e4 | 0) | 0;
          e4 = H2() | 0;
        } while (!((c2 | 0) == 0 & (d2 | 0) == 0));
        G2(b3 | 0);
        return a3 | 0;
      }
      function Dc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0;
        if (!(ya(c2, d2) | 0)) {
          o2 = 0;
          return o2 | 0;
        }
        c2 = xa(c2) | 0;
        f3 = +e3[d2 >> 3];
        g3 = +e3[d2 + 8 >> 3];
        g3 = c2 & g3 < 0 ? g3 + 6.283185307179586 : g3;
        o2 = b2[a3 >> 2] | 0;
        if ((o2 | 0) <= 0) {
          o2 = 0;
          return o2 | 0;
        }
        n2 = b2[a3 + 4 >> 2] | 0;
        if (c2) {
          c2 = 0;
          m2 = g3;
          d2 = -1;
          a3 = 0;
          a:
            while (1) {
              l2 = a3;
              while (1) {
                i2 = +e3[n2 + (l2 << 4) >> 3];
                g3 = +e3[n2 + (l2 << 4) + 8 >> 3];
                a3 = (d2 + 2 | 0) % (o2 | 0) | 0;
                h2 = +e3[n2 + (a3 << 4) >> 3];
                j2 = +e3[n2 + (a3 << 4) + 8 >> 3];
                if (i2 > h2) {
                  k2 = i2;
                  i2 = j2;
                } else {
                  k2 = h2;
                  h2 = i2;
                  i2 = g3;
                  g3 = j2;
                }
                f3 = f3 == h2 | f3 == k2 ? f3 + 2220446049250313e-31 : f3;
                if (!(f3 < h2 | f3 > k2)) {
                  break;
                }
                d2 = l2 + 1 | 0;
                if ((d2 | 0) >= (o2 | 0)) {
                  d2 = 22;
                  break a;
                } else {
                  a3 = l2;
                  l2 = d2;
                  d2 = a3;
                }
              }
              j2 = i2 < 0 ? i2 + 6.283185307179586 : i2;
              i2 = g3 < 0 ? g3 + 6.283185307179586 : g3;
              m2 = j2 == m2 | i2 == m2 ? m2 + -2220446049250313e-31 : m2;
              k2 = j2 + (i2 - j2) * ((f3 - h2) / (k2 - h2));
              if ((k2 < 0 ? k2 + 6.283185307179586 : k2) > m2) {
                c2 = c2 ^ 1;
              }
              a3 = l2 + 1 | 0;
              if ((a3 | 0) >= (o2 | 0)) {
                d2 = 22;
                break;
              } else {
                d2 = l2;
              }
            }
          if ((d2 | 0) == 22) {
            return c2 | 0;
          }
        } else {
          c2 = 0;
          m2 = g3;
          d2 = -1;
          a3 = 0;
          b:
            while (1) {
              l2 = a3;
              while (1) {
                i2 = +e3[n2 + (l2 << 4) >> 3];
                g3 = +e3[n2 + (l2 << 4) + 8 >> 3];
                a3 = (d2 + 2 | 0) % (o2 | 0) | 0;
                h2 = +e3[n2 + (a3 << 4) >> 3];
                j2 = +e3[n2 + (a3 << 4) + 8 >> 3];
                if (i2 > h2) {
                  k2 = i2;
                  i2 = j2;
                } else {
                  k2 = h2;
                  h2 = i2;
                  i2 = g3;
                  g3 = j2;
                }
                f3 = f3 == h2 | f3 == k2 ? f3 + 2220446049250313e-31 : f3;
                if (!(f3 < h2 | f3 > k2)) {
                  break;
                }
                d2 = l2 + 1 | 0;
                if ((d2 | 0) >= (o2 | 0)) {
                  d2 = 22;
                  break b;
                } else {
                  a3 = l2;
                  l2 = d2;
                  d2 = a3;
                }
              }
              m2 = i2 == m2 | g3 == m2 ? m2 + -2220446049250313e-31 : m2;
              if (i2 + (g3 - i2) * ((f3 - h2) / (k2 - h2)) > m2) {
                c2 = c2 ^ 1;
              }
              a3 = l2 + 1 | 0;
              if ((a3 | 0) >= (o2 | 0)) {
                d2 = 22;
                break;
              } else {
                d2 = l2;
              }
            }
          if ((d2 | 0) == 22) {
            return c2 | 0;
          }
        }
        return 0;
      }
      function Ec(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0;
        r3 = b2[a3 >> 2] | 0;
        if (!r3) {
          b2[c2 >> 2] = 0;
          b2[c2 + 4 >> 2] = 0;
          b2[c2 + 8 >> 2] = 0;
          b2[c2 + 12 >> 2] = 0;
          b2[c2 + 16 >> 2] = 0;
          b2[c2 + 20 >> 2] = 0;
          b2[c2 + 24 >> 2] = 0;
          b2[c2 + 28 >> 2] = 0;
          return;
        }
        s3 = c2 + 8 | 0;
        e3[s3 >> 3] = 17976931348623157e292;
        t3 = c2 + 24 | 0;
        e3[t3 >> 3] = 17976931348623157e292;
        e3[c2 >> 3] = -17976931348623157e292;
        u3 = c2 + 16 | 0;
        e3[u3 >> 3] = -17976931348623157e292;
        if ((r3 | 0) <= 0) {
          return;
        }
        o2 = b2[a3 + 4 >> 2] | 0;
        l2 = 17976931348623157e292;
        m2 = -17976931348623157e292;
        n2 = 0;
        a3 = -1;
        h2 = 17976931348623157e292;
        i2 = 17976931348623157e292;
        k2 = -17976931348623157e292;
        f3 = -17976931348623157e292;
        p3 = 0;
        while (1) {
          d2 = +e3[o2 + (p3 << 4) >> 3];
          j2 = +e3[o2 + (p3 << 4) + 8 >> 3];
          a3 = a3 + 2 | 0;
          g3 = +e3[o2 + (((a3 | 0) == (r3 | 0) ? 0 : a3) << 4) + 8 >> 3];
          if (d2 < h2) {
            e3[s3 >> 3] = d2;
            h2 = d2;
          }
          if (j2 < i2) {
            e3[t3 >> 3] = j2;
            i2 = j2;
          }
          if (d2 > k2) {
            e3[c2 >> 3] = d2;
          } else {
            d2 = k2;
          }
          if (j2 > f3) {
            e3[u3 >> 3] = j2;
            f3 = j2;
          }
          l2 = j2 > 0 & j2 < l2 ? j2 : l2;
          m2 = j2 < 0 & j2 > m2 ? j2 : m2;
          n2 = n2 | +q2(+(j2 - g3)) > 3.141592653589793;
          a3 = p3 + 1 | 0;
          if ((a3 | 0) == (r3 | 0)) {
            break;
          } else {
            v6 = p3;
            k2 = d2;
            p3 = a3;
            a3 = v6;
          }
        }
        if (!n2) {
          return;
        }
        e3[u3 >> 3] = m2;
        e3[t3 >> 3] = l2;
        return;
      }
      function Fc(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0, x3 = 0, y3 = 0, z3 = 0, A3 = 0;
        r3 = b2[a3 >> 2] | 0;
        if (r3) {
          s3 = c2 + 8 | 0;
          e3[s3 >> 3] = 17976931348623157e292;
          t3 = c2 + 24 | 0;
          e3[t3 >> 3] = 17976931348623157e292;
          e3[c2 >> 3] = -17976931348623157e292;
          u3 = c2 + 16 | 0;
          e3[u3 >> 3] = -17976931348623157e292;
          if ((r3 | 0) > 0) {
            g3 = b2[a3 + 4 >> 2] | 0;
            o2 = 17976931348623157e292;
            p3 = -17976931348623157e292;
            f3 = 0;
            d2 = -1;
            k2 = 17976931348623157e292;
            l2 = 17976931348623157e292;
            n2 = -17976931348623157e292;
            i2 = -17976931348623157e292;
            v6 = 0;
            while (1) {
              h2 = +e3[g3 + (v6 << 4) >> 3];
              m2 = +e3[g3 + (v6 << 4) + 8 >> 3];
              z3 = d2 + 2 | 0;
              j2 = +e3[g3 + (((z3 | 0) == (r3 | 0) ? 0 : z3) << 4) + 8 >> 3];
              if (h2 < k2) {
                e3[s3 >> 3] = h2;
                k2 = h2;
              }
              if (m2 < l2) {
                e3[t3 >> 3] = m2;
                l2 = m2;
              }
              if (h2 > n2) {
                e3[c2 >> 3] = h2;
              } else {
                h2 = n2;
              }
              if (m2 > i2) {
                e3[u3 >> 3] = m2;
                i2 = m2;
              }
              o2 = m2 > 0 & m2 < o2 ? m2 : o2;
              p3 = m2 < 0 & m2 > p3 ? m2 : p3;
              f3 = f3 | +q2(+(m2 - j2)) > 3.141592653589793;
              d2 = v6 + 1 | 0;
              if ((d2 | 0) == (r3 | 0)) {
                break;
              } else {
                z3 = v6;
                n2 = h2;
                v6 = d2;
                d2 = z3;
              }
            }
            if (f3) {
              e3[u3 >> 3] = p3;
              e3[t3 >> 3] = o2;
            }
          }
        } else {
          b2[c2 >> 2] = 0;
          b2[c2 + 4 >> 2] = 0;
          b2[c2 + 8 >> 2] = 0;
          b2[c2 + 12 >> 2] = 0;
          b2[c2 + 16 >> 2] = 0;
          b2[c2 + 20 >> 2] = 0;
          b2[c2 + 24 >> 2] = 0;
          b2[c2 + 28 >> 2] = 0;
        }
        z3 = a3 + 8 | 0;
        d2 = b2[z3 >> 2] | 0;
        if ((d2 | 0) <= 0) {
          return;
        }
        y3 = a3 + 12 | 0;
        x3 = 0;
        do {
          g3 = b2[y3 >> 2] | 0;
          f3 = x3;
          x3 = x3 + 1 | 0;
          t3 = c2 + (x3 << 5) | 0;
          u3 = b2[g3 + (f3 << 3) >> 2] | 0;
          if (u3) {
            v6 = c2 + (x3 << 5) + 8 | 0;
            e3[v6 >> 3] = 17976931348623157e292;
            a3 = c2 + (x3 << 5) + 24 | 0;
            e3[a3 >> 3] = 17976931348623157e292;
            e3[t3 >> 3] = -17976931348623157e292;
            w3 = c2 + (x3 << 5) + 16 | 0;
            e3[w3 >> 3] = -17976931348623157e292;
            if ((u3 | 0) > 0) {
              r3 = b2[g3 + (f3 << 3) + 4 >> 2] | 0;
              o2 = 17976931348623157e292;
              p3 = -17976931348623157e292;
              g3 = 0;
              f3 = -1;
              s3 = 0;
              k2 = 17976931348623157e292;
              l2 = 17976931348623157e292;
              m2 = -17976931348623157e292;
              i2 = -17976931348623157e292;
              while (1) {
                h2 = +e3[r3 + (s3 << 4) >> 3];
                n2 = +e3[r3 + (s3 << 4) + 8 >> 3];
                f3 = f3 + 2 | 0;
                j2 = +e3[r3 + (((f3 | 0) == (u3 | 0) ? 0 : f3) << 4) + 8 >> 3];
                if (h2 < k2) {
                  e3[v6 >> 3] = h2;
                  k2 = h2;
                }
                if (n2 < l2) {
                  e3[a3 >> 3] = n2;
                  l2 = n2;
                }
                if (h2 > m2) {
                  e3[t3 >> 3] = h2;
                } else {
                  h2 = m2;
                }
                if (n2 > i2) {
                  e3[w3 >> 3] = n2;
                  i2 = n2;
                }
                o2 = n2 > 0 & n2 < o2 ? n2 : o2;
                p3 = n2 < 0 & n2 > p3 ? n2 : p3;
                g3 = g3 | +q2(+(n2 - j2)) > 3.141592653589793;
                f3 = s3 + 1 | 0;
                if ((f3 | 0) == (u3 | 0)) {
                  break;
                } else {
                  A3 = s3;
                  s3 = f3;
                  m2 = h2;
                  f3 = A3;
                }
              }
              if (g3) {
                e3[w3 >> 3] = p3;
                e3[a3 >> 3] = o2;
              }
            }
          } else {
            b2[t3 >> 2] = 0;
            b2[t3 + 4 >> 2] = 0;
            b2[t3 + 8 >> 2] = 0;
            b2[t3 + 12 >> 2] = 0;
            b2[t3 + 16 >> 2] = 0;
            b2[t3 + 20 >> 2] = 0;
            b2[t3 + 24 >> 2] = 0;
            b2[t3 + 28 >> 2] = 0;
            d2 = b2[z3 >> 2] | 0;
          }
        } while ((x3 | 0) < (d2 | 0));
        return;
      }
      function Gc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0;
        if (!(Dc(a3, c2, d2) | 0)) {
          f3 = 0;
          return f3 | 0;
        }
        f3 = a3 + 8 | 0;
        if ((b2[f3 >> 2] | 0) <= 0) {
          f3 = 1;
          return f3 | 0;
        }
        e4 = a3 + 12 | 0;
        a3 = 0;
        while (1) {
          g3 = a3;
          a3 = a3 + 1 | 0;
          if (Dc((b2[e4 >> 2] | 0) + (g3 << 3) | 0, c2 + (a3 << 5) | 0, d2) | 0) {
            a3 = 0;
            e4 = 6;
            break;
          }
          if ((a3 | 0) >= (b2[f3 >> 2] | 0)) {
            a3 = 1;
            e4 = 6;
            break;
          }
        }
        if ((e4 | 0) == 6) {
          return a3 | 0;
        }
        return 0;
      }
      function Hc() {
        return 8;
      }
      function Ic() {
        return 16;
      }
      function Jc() {
        return 168;
      }
      function Kc() {
        return 8;
      }
      function Lc() {
        return 16;
      }
      function Mc() {
        return 12;
      }
      function Nc() {
        return 8;
      }
      function Oc(a3) {
        a3 = a3 | 0;
        return +(+((b2[a3 >> 2] | 0) >>> 0) + 4294967296 * +(b2[a3 + 4 >> 2] | 0));
      }
      function Pc(a3) {
        a3 = a3 | 0;
        var b3 = 0, c2 = 0;
        c2 = +e3[a3 >> 3];
        b3 = +e3[a3 + 8 >> 3];
        return + +r2(+(c2 * c2 + b3 * b3));
      }
      function Qc(a3, b3, c2, d2, f3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0;
        k2 = +e3[a3 >> 3];
        j2 = +e3[b3 >> 3] - k2;
        i2 = +e3[a3 + 8 >> 3];
        h2 = +e3[b3 + 8 >> 3] - i2;
        m2 = +e3[c2 >> 3];
        g3 = +e3[d2 >> 3] - m2;
        n2 = +e3[c2 + 8 >> 3];
        l2 = +e3[d2 + 8 >> 3] - n2;
        g3 = (g3 * (i2 - n2) - (k2 - m2) * l2) / (j2 * l2 - h2 * g3);
        e3[f3 >> 3] = k2 + j2 * g3;
        e3[f3 + 8 >> 3] = i2 + h2 * g3;
        return;
      }
      function Rc(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        if (!(+q2(+(+e3[a3 >> 3] - +e3[b3 >> 3])) < 11920928955078125e-23)) {
          b3 = 0;
          return b3 | 0;
        }
        b3 = +q2(+(+e3[a3 + 8 >> 3] - +e3[b3 + 8 >> 3])) < 11920928955078125e-23;
        return b3 | 0;
      }
      function Sc(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, f3 = 0;
        f3 = +e3[a3 >> 3] - +e3[b3 >> 3];
        d2 = +e3[a3 + 8 >> 3] - +e3[b3 + 8 >> 3];
        c2 = +e3[a3 + 16 >> 3] - +e3[b3 + 16 >> 3];
        return +(f3 * f3 + d2 * d2 + c2 * c2);
      }
      function Tc(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, f3 = 0;
        c2 = +e3[a3 >> 3];
        d2 = +t2(+c2);
        c2 = +u2(+c2);
        e3[b3 + 16 >> 3] = c2;
        c2 = +e3[a3 + 8 >> 3];
        f3 = d2 * +t2(+c2);
        e3[b3 >> 3] = f3;
        c2 = d2 * +u2(+c2);
        e3[b3 + 8 >> 3] = c2;
        return;
      }
      function Uc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0;
        g3 = T2;
        T2 = T2 + 16 | 0;
        f3 = g3;
        e4 = xb(a3, c2) | 0;
        if ((d2 + -1 | 0) >>> 0 > 5) {
          f3 = -1;
          T2 = g3;
          return f3 | 0;
        }
        e4 = (e4 | 0) != 0;
        if ((d2 | 0) == 1 & e4) {
          f3 = -1;
          T2 = g3;
          return f3 | 0;
        }
        do {
          if (!(Vc(a3, c2, f3) | 0)) {
            if (e4) {
              e4 = ((b2[21936 + (d2 << 2) >> 2] | 0) + 5 - (b2[f3 >> 2] | 0) | 0) % 5 | 0;
              break;
            } else {
              e4 = ((b2[21968 + (d2 << 2) >> 2] | 0) + 6 - (b2[f3 >> 2] | 0) | 0) % 6 | 0;
              break;
            }
          } else {
            e4 = -1;
          }
        } while (0);
        f3 = e4;
        T2 = g3;
        return f3 | 0;
      }
      function Vc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0;
        k2 = T2;
        T2 = T2 + 32 | 0;
        h2 = k2 + 16 | 0;
        i2 = k2;
        e4 = Ob(a3, c2, h2) | 0;
        if (e4 | 0) {
          d2 = e4;
          T2 = k2;
          return d2 | 0;
        }
        g3 = tb(a3, c2) | 0;
        j2 = Fb(a3, c2) | 0;
        qa(g3, i2);
        e4 = ra(g3, b2[h2 >> 2] | 0) | 0;
        a:
          do {
            if (ma(g3) | 0) {
              do {
                switch (g3 | 0) {
                  case 4: {
                    a3 = 0;
                    break;
                  }
                  case 14: {
                    a3 = 1;
                    break;
                  }
                  case 24: {
                    a3 = 2;
                    break;
                  }
                  case 38: {
                    a3 = 3;
                    break;
                  }
                  case 49: {
                    a3 = 4;
                    break;
                  }
                  case 58: {
                    a3 = 5;
                    break;
                  }
                  case 63: {
                    a3 = 6;
                    break;
                  }
                  case 72: {
                    a3 = 7;
                    break;
                  }
                  case 83: {
                    a3 = 8;
                    break;
                  }
                  case 97: {
                    a3 = 9;
                    break;
                  }
                  case 107: {
                    a3 = 10;
                    break;
                  }
                  case 117: {
                    a3 = 11;
                    break;
                  }
                  default: {
                    e4 = 1;
                    break a;
                  }
                }
              } while (0);
              f3 = b2[22e3 + (a3 * 24 | 0) + 8 >> 2] | 0;
              c2 = b2[22e3 + (a3 * 24 | 0) + 16 >> 2] | 0;
              a3 = b2[h2 >> 2] | 0;
              if ((a3 | 0) != (b2[i2 >> 2] | 0)) {
                i2 = na(g3) | 0;
                a3 = b2[h2 >> 2] | 0;
                if (i2 | (a3 | 0) == (c2 | 0)) {
                  e4 = (e4 + 1 | 0) % 6 | 0;
                }
              }
              if ((j2 | 0) == 3 & (a3 | 0) == (c2 | 0)) {
                e4 = (e4 + 5 | 0) % 6 | 0;
                f3 = 22;
                break;
              }
              if ((j2 | 0) == 5 & (a3 | 0) == (f3 | 0)) {
                e4 = (e4 + 1 | 0) % 6 | 0;
                f3 = 22;
              } else {
                f3 = 22;
              }
            } else {
              f3 = 22;
            }
          } while (0);
        if ((f3 | 0) == 22) {
          b2[d2 >> 2] = e4;
          e4 = 0;
        }
        d2 = e4;
        T2 = k2;
        return d2 | 0;
      }
      function Wc(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0;
        u3 = T2;
        T2 = T2 + 32 | 0;
        t3 = u3 + 24 | 0;
        r3 = u3 + 20 | 0;
        p3 = u3 + 8 | 0;
        o2 = u3 + 16 | 0;
        n2 = u3;
        j2 = (xb(a3, c2) | 0) == 0;
        j2 = j2 ? 6 : 5;
        l2 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        l2 = l2 & 15;
        if (j2 >>> 0 <= d2 >>> 0) {
          e4 = 2;
          T2 = u3;
          return e4 | 0;
        }
        m2 = (l2 | 0) == 0;
        if (!m2 ? (q3 = wd(7, 0, (l2 ^ 15) * 3 | 0) | 0, (q3 & a3 | 0) == 0 & ((H2() | 0) & c2 | 0) == 0) : 0) {
          f3 = d2;
        } else {
          g3 = 4;
        }
        a:
          do {
            if ((g3 | 0) == 4) {
              f3 = (xb(a3, c2) | 0) != 0;
              if (((f3 ? 4 : 5) | 0) < (d2 | 0)) {
                e4 = 1;
                T2 = u3;
                return e4 | 0;
              }
              if (Vc(a3, c2, t3) | 0) {
                e4 = 1;
                T2 = u3;
                return e4 | 0;
              }
              g3 = (b2[t3 >> 2] | 0) + d2 | 0;
              if (f3) {
                f3 = 22288 + (((g3 | 0) % 5 | 0) << 2) | 0;
              } else {
                f3 = 22320 + (((g3 | 0) % 6 | 0) << 2) | 0;
              }
              q3 = b2[f3 >> 2] | 0;
              if ((q3 | 0) == 7) {
                e4 = 1;
                T2 = u3;
                return e4 | 0;
              }
              b2[r3 >> 2] = 0;
              f3 = ea(a3, c2, q3, r3, p3) | 0;
              do {
                if (!f3) {
                  i2 = p3;
                  k2 = b2[i2 >> 2] | 0;
                  i2 = b2[i2 + 4 >> 2] | 0;
                  h2 = i2 >>> 0 < c2 >>> 0 | (i2 | 0) == (c2 | 0) & k2 >>> 0 < a3 >>> 0;
                  g3 = h2 ? k2 : a3;
                  h2 = h2 ? i2 : c2;
                  if (!m2 ? (m2 = wd(7, 0, (l2 ^ 15) * 3 | 0) | 0, (k2 & m2 | 0) == 0 & (i2 & (H2() | 0) | 0) == 0) : 0) {
                    f3 = d2;
                  } else {
                    i2 = (d2 + -1 + j2 | 0) % (j2 | 0) | 0;
                    f3 = xb(a3, c2) | 0;
                    if ((i2 | 0) < 0) {
                      I2(23313, 23315, 245, 23324);
                    }
                    j2 = (f3 | 0) != 0;
                    if (((j2 ? 4 : 5) | 0) < (i2 | 0)) {
                      I2(23313, 23315, 245, 23324);
                    }
                    if (Vc(a3, c2, t3) | 0) {
                      I2(23313, 23315, 245, 23324);
                    }
                    f3 = (b2[t3 >> 2] | 0) + i2 | 0;
                    if (j2) {
                      f3 = 22288 + (((f3 | 0) % 5 | 0) << 2) | 0;
                    } else {
                      f3 = 22320 + (((f3 | 0) % 6 | 0) << 2) | 0;
                    }
                    i2 = b2[f3 >> 2] | 0;
                    if ((i2 | 0) == 7) {
                      I2(23313, 23315, 245, 23324);
                    }
                    b2[o2 >> 2] = 0;
                    f3 = ea(a3, c2, i2, o2, n2) | 0;
                    if (f3 | 0) {
                      break;
                    }
                    k2 = n2;
                    j2 = b2[k2 >> 2] | 0;
                    k2 = b2[k2 + 4 >> 2] | 0;
                    do {
                      if (k2 >>> 0 < h2 >>> 0 | (k2 | 0) == (h2 | 0) & j2 >>> 0 < g3 >>> 0) {
                        if (!(xb(j2, k2) | 0)) {
                          g3 = b2[22384 + ((((b2[o2 >> 2] | 0) + (b2[22352 + (i2 << 2) >> 2] | 0) | 0) % 6 | 0) << 2) >> 2] | 0;
                        } else {
                          g3 = fa(j2, k2, a3, c2) | 0;
                        }
                        f3 = xb(j2, k2) | 0;
                        if ((g3 + -1 | 0) >>> 0 > 5) {
                          f3 = -1;
                          g3 = j2;
                          h2 = k2;
                          break;
                        }
                        f3 = (f3 | 0) != 0;
                        if ((g3 | 0) == 1 & f3) {
                          f3 = -1;
                          g3 = j2;
                          h2 = k2;
                          break;
                        }
                        do {
                          if (!(Vc(j2, k2, t3) | 0)) {
                            if (f3) {
                              f3 = ((b2[21936 + (g3 << 2) >> 2] | 0) + 5 - (b2[t3 >> 2] | 0) | 0) % 5 | 0;
                              break;
                            } else {
                              f3 = ((b2[21968 + (g3 << 2) >> 2] | 0) + 6 - (b2[t3 >> 2] | 0) | 0) % 6 | 0;
                              break;
                            }
                          } else {
                            f3 = -1;
                          }
                        } while (0);
                        g3 = j2;
                        h2 = k2;
                      } else {
                        f3 = d2;
                      }
                    } while (0);
                    i2 = p3;
                    k2 = b2[i2 >> 2] | 0;
                    i2 = b2[i2 + 4 >> 2] | 0;
                  }
                  if ((g3 | 0) == (k2 | 0) & (h2 | 0) == (i2 | 0)) {
                    j2 = (xb(k2, i2) | 0) != 0;
                    if (j2) {
                      a3 = fa(k2, i2, a3, c2) | 0;
                    } else {
                      a3 = b2[22384 + ((((b2[r3 >> 2] | 0) + (b2[22352 + (q3 << 2) >> 2] | 0) | 0) % 6 | 0) << 2) >> 2] | 0;
                    }
                    f3 = xb(k2, i2) | 0;
                    if ((a3 + -1 | 0) >>> 0 <= 5 ? (s3 = (f3 | 0) != 0, !((a3 | 0) == 1 & s3)) : 0) {
                      do {
                        if (!(Vc(k2, i2, t3) | 0)) {
                          if (s3) {
                            f3 = ((b2[21936 + (a3 << 2) >> 2] | 0) + 5 - (b2[t3 >> 2] | 0) | 0) % 5 | 0;
                            break;
                          } else {
                            f3 = ((b2[21968 + (a3 << 2) >> 2] | 0) + 6 - (b2[t3 >> 2] | 0) | 0) % 6 | 0;
                            break;
                          }
                        } else {
                          f3 = -1;
                        }
                      } while (0);
                    } else {
                      f3 = -1;
                    }
                    f3 = f3 + 1 | 0;
                    f3 = (f3 | 0) == 6 | j2 & (f3 | 0) == 5 ? 0 : f3;
                  }
                  c2 = h2;
                  a3 = g3;
                  break a;
                }
              } while (0);
              e4 = f3;
              T2 = u3;
              return e4 | 0;
            }
          } while (0);
        s3 = wd(f3 | 0, 0, 56) | 0;
        t3 = H2() | 0 | c2 & -2130706433 | 536870912;
        b2[e4 >> 2] = s3 | a3;
        b2[e4 + 4 >> 2] = t3;
        e4 = 0;
        T2 = u3;
        return e4 | 0;
      }
      function Xc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0;
        g3 = (xb(a3, c2) | 0) == 0;
        e4 = Wc(a3, c2, 0, d2) | 0;
        f3 = (e4 | 0) == 0;
        if (g3) {
          if (!f3) {
            g3 = e4;
            return g3 | 0;
          }
          e4 = Wc(a3, c2, 1, d2 + 8 | 0) | 0;
          if (e4 | 0) {
            g3 = e4;
            return g3 | 0;
          }
          e4 = Wc(a3, c2, 2, d2 + 16 | 0) | 0;
          if (e4 | 0) {
            g3 = e4;
            return g3 | 0;
          }
          e4 = Wc(a3, c2, 3, d2 + 24 | 0) | 0;
          if (e4 | 0) {
            g3 = e4;
            return g3 | 0;
          }
          e4 = Wc(a3, c2, 4, d2 + 32 | 0) | 0;
          if (!e4) {
            return Wc(a3, c2, 5, d2 + 40 | 0) | 0;
          } else {
            g3 = e4;
            return g3 | 0;
          }
        }
        if (!f3) {
          g3 = e4;
          return g3 | 0;
        }
        e4 = Wc(a3, c2, 1, d2 + 8 | 0) | 0;
        if (e4 | 0) {
          g3 = e4;
          return g3 | 0;
        }
        e4 = Wc(a3, c2, 2, d2 + 16 | 0) | 0;
        if (e4 | 0) {
          g3 = e4;
          return g3 | 0;
        }
        e4 = Wc(a3, c2, 3, d2 + 24 | 0) | 0;
        if (e4 | 0) {
          g3 = e4;
          return g3 | 0;
        }
        e4 = Wc(a3, c2, 4, d2 + 32 | 0) | 0;
        if (e4 | 0) {
          g3 = e4;
          return g3 | 0;
        }
        g3 = d2 + 40 | 0;
        b2[g3 >> 2] = 0;
        b2[g3 + 4 >> 2] = 0;
        g3 = 0;
        return g3 | 0;
      }
      function Yc(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        j2 = T2;
        T2 = T2 + 192 | 0;
        f3 = j2;
        g3 = j2 + 168 | 0;
        h2 = vd(a3 | 0, c2 | 0, 56) | 0;
        H2() | 0;
        h2 = h2 & 7;
        i2 = c2 & -2130706433 | 134217728;
        e4 = Ob(a3, i2, g3) | 0;
        if (e4 | 0) {
          i2 = e4;
          T2 = j2;
          return i2 | 0;
        }
        c2 = vd(a3 | 0, c2 | 0, 52) | 0;
        H2() | 0;
        c2 = c2 & 15;
        if (!(xb(a3, i2) | 0)) {
          qb(g3, c2, h2, 1, f3);
        } else {
          mb(g3, c2, h2, 1, f3);
        }
        i2 = f3 + 8 | 0;
        b2[d2 >> 2] = b2[i2 >> 2];
        b2[d2 + 4 >> 2] = b2[i2 + 4 >> 2];
        b2[d2 + 8 >> 2] = b2[i2 + 8 >> 2];
        b2[d2 + 12 >> 2] = b2[i2 + 12 >> 2];
        i2 = 0;
        T2 = j2;
        return i2 | 0;
      }
      function Zc(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, e4 = 0, f3 = 0, g3 = 0;
        f3 = T2;
        T2 = T2 + 16 | 0;
        d2 = f3;
        if (!(true & (c2 & 2013265920 | 0) == 536870912)) {
          e4 = 0;
          T2 = f3;
          return e4 | 0;
        }
        e4 = c2 & -2130706433 | 134217728;
        if (!(ub(a3, e4) | 0)) {
          e4 = 0;
          T2 = f3;
          return e4 | 0;
        }
        g3 = vd(a3 | 0, c2 | 0, 56) | 0;
        H2() | 0;
        g3 = (Wc(a3, e4, g3 & 7, d2) | 0) == 0;
        e4 = d2;
        e4 = g3 & ((b2[e4 >> 2] | 0) == (a3 | 0) ? (b2[e4 + 4 >> 2] | 0) == (c2 | 0) : 0) & 1;
        T2 = f3;
        return e4 | 0;
      }
      function _c2(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0;
        if ((c2 | 0) > 0) {
          e4 = kd(c2, 4) | 0;
          b2[a3 >> 2] = e4;
          if (!e4) {
            I2(23337, 23360, 40, 23374);
          }
        } else {
          b2[a3 >> 2] = 0;
        }
        b2[a3 + 4 >> 2] = c2;
        b2[a3 + 8 >> 2] = 0;
        b2[a3 + 12 >> 2] = d2;
        return;
      }
      function $c(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        g3 = a3 + 4 | 0;
        h2 = a3 + 12 | 0;
        i2 = a3 + 8 | 0;
        a:
          while (1) {
            d2 = b2[g3 >> 2] | 0;
            c2 = 0;
            while (1) {
              if ((c2 | 0) >= (d2 | 0)) {
                break a;
              }
              f3 = b2[a3 >> 2] | 0;
              j2 = b2[f3 + (c2 << 2) >> 2] | 0;
              if (!j2) {
                c2 = c2 + 1 | 0;
              } else {
                break;
              }
            }
            c2 = f3 + (~~(+q2(+(+s2(10, + +(15 - (b2[h2 >> 2] | 0) | 0)) * (+e3[j2 >> 3] + +e3[j2 + 8 >> 3]))) % +(d2 | 0)) >>> 0 << 2) | 0;
            d2 = b2[c2 >> 2] | 0;
            b:
              do {
                if (d2 | 0) {
                  f3 = j2 + 32 | 0;
                  if ((d2 | 0) == (j2 | 0)) {
                    b2[c2 >> 2] = b2[f3 >> 2];
                  } else {
                    d2 = d2 + 32 | 0;
                    c2 = b2[d2 >> 2] | 0;
                    if (!c2) {
                      break;
                    }
                    while (1) {
                      if ((c2 | 0) == (j2 | 0)) {
                        break;
                      }
                      d2 = c2 + 32 | 0;
                      c2 = b2[d2 >> 2] | 0;
                      if (!c2) {
                        break b;
                      }
                    }
                    b2[d2 >> 2] = b2[f3 >> 2];
                  }
                  jd(j2);
                  b2[i2 >> 2] = (b2[i2 >> 2] | 0) + -1;
                }
              } while (0);
          }
        jd(b2[a3 >> 2] | 0);
        return;
      }
      function ad2(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0;
        e4 = b2[a3 + 4 >> 2] | 0;
        d2 = 0;
        while (1) {
          if ((d2 | 0) >= (e4 | 0)) {
            c2 = 0;
            d2 = 4;
            break;
          }
          c2 = b2[(b2[a3 >> 2] | 0) + (d2 << 2) >> 2] | 0;
          if (!c2) {
            d2 = d2 + 1 | 0;
          } else {
            d2 = 4;
            break;
          }
        }
        if ((d2 | 0) == 4) {
          return c2 | 0;
        }
        return 0;
      }
      function bd2(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0, f3 = 0, g3 = 0, h2 = 0;
        d2 = ~~(+q2(+(+s2(10, + +(15 - (b2[a3 + 12 >> 2] | 0) | 0)) * (+e3[c2 >> 3] + +e3[c2 + 8 >> 3]))) % +(b2[a3 + 4 >> 2] | 0)) >>> 0;
        d2 = (b2[a3 >> 2] | 0) + (d2 << 2) | 0;
        f3 = b2[d2 >> 2] | 0;
        if (!f3) {
          h2 = 1;
          return h2 | 0;
        }
        h2 = c2 + 32 | 0;
        do {
          if ((f3 | 0) != (c2 | 0)) {
            d2 = b2[f3 + 32 >> 2] | 0;
            if (!d2) {
              h2 = 1;
              return h2 | 0;
            }
            g3 = d2;
            while (1) {
              if ((g3 | 0) == (c2 | 0)) {
                g3 = 8;
                break;
              }
              d2 = b2[g3 + 32 >> 2] | 0;
              if (!d2) {
                d2 = 1;
                g3 = 10;
                break;
              } else {
                f3 = g3;
                g3 = d2;
              }
            }
            if ((g3 | 0) == 8) {
              b2[f3 + 32 >> 2] = b2[h2 >> 2];
              break;
            } else if ((g3 | 0) == 10) {
              return d2 | 0;
            }
          } else {
            b2[d2 >> 2] = b2[h2 >> 2];
          }
        } while (0);
        jd(c2);
        h2 = a3 + 8 | 0;
        b2[h2 >> 2] = (b2[h2 >> 2] | 0) + -1;
        h2 = 0;
        return h2 | 0;
      }
      function cd2(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = id(40) | 0;
        if (!h2) {
          I2(23390, 23360, 98, 23403);
        }
        b2[h2 >> 2] = b2[c2 >> 2];
        b2[h2 + 4 >> 2] = b2[c2 + 4 >> 2];
        b2[h2 + 8 >> 2] = b2[c2 + 8 >> 2];
        b2[h2 + 12 >> 2] = b2[c2 + 12 >> 2];
        g3 = h2 + 16 | 0;
        b2[g3 >> 2] = b2[d2 >> 2];
        b2[g3 + 4 >> 2] = b2[d2 + 4 >> 2];
        b2[g3 + 8 >> 2] = b2[d2 + 8 >> 2];
        b2[g3 + 12 >> 2] = b2[d2 + 12 >> 2];
        b2[h2 + 32 >> 2] = 0;
        g3 = ~~(+q2(+(+s2(10, + +(15 - (b2[a3 + 12 >> 2] | 0) | 0)) * (+e3[c2 >> 3] + +e3[c2 + 8 >> 3]))) % +(b2[a3 + 4 >> 2] | 0)) >>> 0;
        g3 = (b2[a3 >> 2] | 0) + (g3 << 2) | 0;
        f3 = b2[g3 >> 2] | 0;
        do {
          if (!f3) {
            b2[g3 >> 2] = h2;
          } else {
            while (1) {
              if (_b3(f3, c2) | 0 ? _b3(f3 + 16 | 0, d2) | 0 : 0) {
                break;
              }
              g3 = b2[f3 + 32 >> 2] | 0;
              f3 = (g3 | 0) == 0 ? f3 : g3;
              if (!(b2[f3 + 32 >> 2] | 0)) {
                i2 = 10;
                break;
              }
            }
            if ((i2 | 0) == 10) {
              b2[f3 + 32 >> 2] = h2;
              break;
            }
            jd(h2);
            i2 = f3;
            return i2 | 0;
          }
        } while (0);
        i2 = a3 + 8 | 0;
        b2[i2 >> 2] = (b2[i2 >> 2] | 0) + 1;
        i2 = h2;
        return i2 | 0;
      }
      function dd(a3, c2, d2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var f3 = 0, g3 = 0;
        g3 = ~~(+q2(+(+s2(10, + +(15 - (b2[a3 + 12 >> 2] | 0) | 0)) * (+e3[c2 >> 3] + +e3[c2 + 8 >> 3]))) % +(b2[a3 + 4 >> 2] | 0)) >>> 0;
        g3 = b2[(b2[a3 >> 2] | 0) + (g3 << 2) >> 2] | 0;
        if (!g3) {
          d2 = 0;
          return d2 | 0;
        }
        if (!d2) {
          a3 = g3;
          while (1) {
            if (_b3(a3, c2) | 0) {
              f3 = 10;
              break;
            }
            a3 = b2[a3 + 32 >> 2] | 0;
            if (!a3) {
              a3 = 0;
              f3 = 10;
              break;
            }
          }
          if ((f3 | 0) == 10) {
            return a3 | 0;
          }
        }
        a3 = g3;
        while (1) {
          if (_b3(a3, c2) | 0 ? _b3(a3 + 16 | 0, d2) | 0 : 0) {
            f3 = 10;
            break;
          }
          a3 = b2[a3 + 32 >> 2] | 0;
          if (!a3) {
            a3 = 0;
            f3 = 10;
            break;
          }
        }
        if ((f3 | 0) == 10) {
          return a3 | 0;
        }
        return 0;
      }
      function ed(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0;
        d2 = ~~(+q2(+(+s2(10, + +(15 - (b2[a3 + 12 >> 2] | 0) | 0)) * (+e3[c2 >> 3] + +e3[c2 + 8 >> 3]))) % +(b2[a3 + 4 >> 2] | 0)) >>> 0;
        a3 = b2[(b2[a3 >> 2] | 0) + (d2 << 2) >> 2] | 0;
        if (!a3) {
          d2 = 0;
          return d2 | 0;
        }
        while (1) {
          if (_b3(a3, c2) | 0) {
            c2 = 5;
            break;
          }
          a3 = b2[a3 + 32 >> 2] | 0;
          if (!a3) {
            a3 = 0;
            c2 = 5;
            break;
          }
        }
        if ((c2 | 0) == 5) {
          return a3 | 0;
        }
        return 0;
      }
      function fd() {
        return 23424;
      }
      function gd(a3) {
        a3 = +a3;
        return + +Cd(+a3);
      }
      function hd(a3) {
        a3 = +a3;
        return ~~+gd(a3) | 0;
      }
      function id(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0, q3 = 0, r3 = 0, s3 = 0, t3 = 0, u3 = 0, v6 = 0, w3 = 0;
        w3 = T2;
        T2 = T2 + 16 | 0;
        n2 = w3;
        do {
          if (a3 >>> 0 < 245) {
            k2 = a3 >>> 0 < 11 ? 16 : a3 + 11 & -8;
            a3 = k2 >>> 3;
            m2 = b2[5857] | 0;
            d2 = m2 >>> a3;
            if (d2 & 3 | 0) {
              c2 = (d2 & 1 ^ 1) + a3 | 0;
              a3 = 23468 + (c2 << 1 << 2) | 0;
              d2 = a3 + 8 | 0;
              e4 = b2[d2 >> 2] | 0;
              f3 = e4 + 8 | 0;
              g3 = b2[f3 >> 2] | 0;
              if ((g3 | 0) == (a3 | 0)) {
                b2[5857] = m2 & ~(1 << c2);
              } else {
                b2[g3 + 12 >> 2] = a3;
                b2[d2 >> 2] = g3;
              }
              v6 = c2 << 3;
              b2[e4 + 4 >> 2] = v6 | 3;
              v6 = e4 + v6 + 4 | 0;
              b2[v6 >> 2] = b2[v6 >> 2] | 1;
              v6 = f3;
              T2 = w3;
              return v6 | 0;
            }
            l2 = b2[5859] | 0;
            if (k2 >>> 0 > l2 >>> 0) {
              if (d2 | 0) {
                c2 = 2 << a3;
                c2 = d2 << a3 & (c2 | 0 - c2);
                c2 = (c2 & 0 - c2) + -1 | 0;
                i2 = c2 >>> 12 & 16;
                c2 = c2 >>> i2;
                d2 = c2 >>> 5 & 8;
                c2 = c2 >>> d2;
                g3 = c2 >>> 2 & 4;
                c2 = c2 >>> g3;
                a3 = c2 >>> 1 & 2;
                c2 = c2 >>> a3;
                e4 = c2 >>> 1 & 1;
                e4 = (d2 | i2 | g3 | a3 | e4) + (c2 >>> e4) | 0;
                c2 = 23468 + (e4 << 1 << 2) | 0;
                a3 = c2 + 8 | 0;
                g3 = b2[a3 >> 2] | 0;
                i2 = g3 + 8 | 0;
                d2 = b2[i2 >> 2] | 0;
                if ((d2 | 0) == (c2 | 0)) {
                  a3 = m2 & ~(1 << e4);
                  b2[5857] = a3;
                } else {
                  b2[d2 + 12 >> 2] = c2;
                  b2[a3 >> 2] = d2;
                  a3 = m2;
                }
                v6 = e4 << 3;
                h2 = v6 - k2 | 0;
                b2[g3 + 4 >> 2] = k2 | 3;
                f3 = g3 + k2 | 0;
                b2[f3 + 4 >> 2] = h2 | 1;
                b2[g3 + v6 >> 2] = h2;
                if (l2 | 0) {
                  e4 = b2[5862] | 0;
                  c2 = l2 >>> 3;
                  d2 = 23468 + (c2 << 1 << 2) | 0;
                  c2 = 1 << c2;
                  if (!(a3 & c2)) {
                    b2[5857] = a3 | c2;
                    c2 = d2;
                    a3 = d2 + 8 | 0;
                  } else {
                    a3 = d2 + 8 | 0;
                    c2 = b2[a3 >> 2] | 0;
                  }
                  b2[a3 >> 2] = e4;
                  b2[c2 + 12 >> 2] = e4;
                  b2[e4 + 8 >> 2] = c2;
                  b2[e4 + 12 >> 2] = d2;
                }
                b2[5859] = h2;
                b2[5862] = f3;
                v6 = i2;
                T2 = w3;
                return v6 | 0;
              }
              g3 = b2[5858] | 0;
              if (g3) {
                d2 = (g3 & 0 - g3) + -1 | 0;
                f3 = d2 >>> 12 & 16;
                d2 = d2 >>> f3;
                e4 = d2 >>> 5 & 8;
                d2 = d2 >>> e4;
                h2 = d2 >>> 2 & 4;
                d2 = d2 >>> h2;
                i2 = d2 >>> 1 & 2;
                d2 = d2 >>> i2;
                j2 = d2 >>> 1 & 1;
                j2 = b2[23732 + ((e4 | f3 | h2 | i2 | j2) + (d2 >>> j2) << 2) >> 2] | 0;
                d2 = j2;
                i2 = j2;
                j2 = (b2[j2 + 4 >> 2] & -8) - k2 | 0;
                while (1) {
                  a3 = b2[d2 + 16 >> 2] | 0;
                  if (!a3) {
                    a3 = b2[d2 + 20 >> 2] | 0;
                    if (!a3) {
                      break;
                    }
                  }
                  h2 = (b2[a3 + 4 >> 2] & -8) - k2 | 0;
                  f3 = h2 >>> 0 < j2 >>> 0;
                  d2 = a3;
                  i2 = f3 ? a3 : i2;
                  j2 = f3 ? h2 : j2;
                }
                h2 = i2 + k2 | 0;
                if (h2 >>> 0 > i2 >>> 0) {
                  f3 = b2[i2 + 24 >> 2] | 0;
                  c2 = b2[i2 + 12 >> 2] | 0;
                  do {
                    if ((c2 | 0) == (i2 | 0)) {
                      a3 = i2 + 20 | 0;
                      c2 = b2[a3 >> 2] | 0;
                      if (!c2) {
                        a3 = i2 + 16 | 0;
                        c2 = b2[a3 >> 2] | 0;
                        if (!c2) {
                          d2 = 0;
                          break;
                        }
                      }
                      while (1) {
                        e4 = c2 + 20 | 0;
                        d2 = b2[e4 >> 2] | 0;
                        if (!d2) {
                          e4 = c2 + 16 | 0;
                          d2 = b2[e4 >> 2] | 0;
                          if (!d2) {
                            break;
                          } else {
                            c2 = d2;
                            a3 = e4;
                          }
                        } else {
                          c2 = d2;
                          a3 = e4;
                        }
                      }
                      b2[a3 >> 2] = 0;
                      d2 = c2;
                    } else {
                      d2 = b2[i2 + 8 >> 2] | 0;
                      b2[d2 + 12 >> 2] = c2;
                      b2[c2 + 8 >> 2] = d2;
                      d2 = c2;
                    }
                  } while (0);
                  do {
                    if (f3 | 0) {
                      c2 = b2[i2 + 28 >> 2] | 0;
                      a3 = 23732 + (c2 << 2) | 0;
                      if ((i2 | 0) == (b2[a3 >> 2] | 0)) {
                        b2[a3 >> 2] = d2;
                        if (!d2) {
                          b2[5858] = g3 & ~(1 << c2);
                          break;
                        }
                      } else {
                        v6 = f3 + 16 | 0;
                        b2[((b2[v6 >> 2] | 0) == (i2 | 0) ? v6 : f3 + 20 | 0) >> 2] = d2;
                        if (!d2) {
                          break;
                        }
                      }
                      b2[d2 + 24 >> 2] = f3;
                      c2 = b2[i2 + 16 >> 2] | 0;
                      if (c2 | 0) {
                        b2[d2 + 16 >> 2] = c2;
                        b2[c2 + 24 >> 2] = d2;
                      }
                      c2 = b2[i2 + 20 >> 2] | 0;
                      if (c2 | 0) {
                        b2[d2 + 20 >> 2] = c2;
                        b2[c2 + 24 >> 2] = d2;
                      }
                    }
                  } while (0);
                  if (j2 >>> 0 < 16) {
                    v6 = j2 + k2 | 0;
                    b2[i2 + 4 >> 2] = v6 | 3;
                    v6 = i2 + v6 + 4 | 0;
                    b2[v6 >> 2] = b2[v6 >> 2] | 1;
                  } else {
                    b2[i2 + 4 >> 2] = k2 | 3;
                    b2[h2 + 4 >> 2] = j2 | 1;
                    b2[h2 + j2 >> 2] = j2;
                    if (l2 | 0) {
                      e4 = b2[5862] | 0;
                      c2 = l2 >>> 3;
                      d2 = 23468 + (c2 << 1 << 2) | 0;
                      c2 = 1 << c2;
                      if (!(c2 & m2)) {
                        b2[5857] = c2 | m2;
                        c2 = d2;
                        a3 = d2 + 8 | 0;
                      } else {
                        a3 = d2 + 8 | 0;
                        c2 = b2[a3 >> 2] | 0;
                      }
                      b2[a3 >> 2] = e4;
                      b2[c2 + 12 >> 2] = e4;
                      b2[e4 + 8 >> 2] = c2;
                      b2[e4 + 12 >> 2] = d2;
                    }
                    b2[5859] = j2;
                    b2[5862] = h2;
                  }
                  v6 = i2 + 8 | 0;
                  T2 = w3;
                  return v6 | 0;
                } else {
                  m2 = k2;
                }
              } else {
                m2 = k2;
              }
            } else {
              m2 = k2;
            }
          } else if (a3 >>> 0 <= 4294967231) {
            a3 = a3 + 11 | 0;
            k2 = a3 & -8;
            e4 = b2[5858] | 0;
            if (e4) {
              f3 = 0 - k2 | 0;
              a3 = a3 >>> 8;
              if (a3) {
                if (k2 >>> 0 > 16777215) {
                  j2 = 31;
                } else {
                  m2 = (a3 + 1048320 | 0) >>> 16 & 8;
                  q3 = a3 << m2;
                  i2 = (q3 + 520192 | 0) >>> 16 & 4;
                  q3 = q3 << i2;
                  j2 = (q3 + 245760 | 0) >>> 16 & 2;
                  j2 = 14 - (i2 | m2 | j2) + (q3 << j2 >>> 15) | 0;
                  j2 = k2 >>> (j2 + 7 | 0) & 1 | j2 << 1;
                }
              } else {
                j2 = 0;
              }
              d2 = b2[23732 + (j2 << 2) >> 2] | 0;
              a:
                do {
                  if (!d2) {
                    d2 = 0;
                    a3 = 0;
                    q3 = 61;
                  } else {
                    a3 = 0;
                    i2 = k2 << ((j2 | 0) == 31 ? 0 : 25 - (j2 >>> 1) | 0);
                    g3 = 0;
                    while (1) {
                      h2 = (b2[d2 + 4 >> 2] & -8) - k2 | 0;
                      if (h2 >>> 0 < f3 >>> 0) {
                        if (!h2) {
                          a3 = d2;
                          f3 = 0;
                          q3 = 65;
                          break a;
                        } else {
                          a3 = d2;
                          f3 = h2;
                        }
                      }
                      q3 = b2[d2 + 20 >> 2] | 0;
                      d2 = b2[d2 + 16 + (i2 >>> 31 << 2) >> 2] | 0;
                      g3 = (q3 | 0) == 0 | (q3 | 0) == (d2 | 0) ? g3 : q3;
                      if (!d2) {
                        d2 = g3;
                        q3 = 61;
                        break;
                      } else {
                        i2 = i2 << 1;
                      }
                    }
                  }
                } while (0);
              if ((q3 | 0) == 61) {
                if ((d2 | 0) == 0 & (a3 | 0) == 0) {
                  a3 = 2 << j2;
                  a3 = (a3 | 0 - a3) & e4;
                  if (!a3) {
                    m2 = k2;
                    break;
                  }
                  m2 = (a3 & 0 - a3) + -1 | 0;
                  h2 = m2 >>> 12 & 16;
                  m2 = m2 >>> h2;
                  g3 = m2 >>> 5 & 8;
                  m2 = m2 >>> g3;
                  i2 = m2 >>> 2 & 4;
                  m2 = m2 >>> i2;
                  j2 = m2 >>> 1 & 2;
                  m2 = m2 >>> j2;
                  d2 = m2 >>> 1 & 1;
                  a3 = 0;
                  d2 = b2[23732 + ((g3 | h2 | i2 | j2 | d2) + (m2 >>> d2) << 2) >> 2] | 0;
                }
                if (!d2) {
                  i2 = a3;
                  h2 = f3;
                } else {
                  q3 = 65;
                }
              }
              if ((q3 | 0) == 65) {
                g3 = d2;
                while (1) {
                  m2 = (b2[g3 + 4 >> 2] & -8) - k2 | 0;
                  d2 = m2 >>> 0 < f3 >>> 0;
                  f3 = d2 ? m2 : f3;
                  a3 = d2 ? g3 : a3;
                  d2 = b2[g3 + 16 >> 2] | 0;
                  if (!d2) {
                    d2 = b2[g3 + 20 >> 2] | 0;
                  }
                  if (!d2) {
                    i2 = a3;
                    h2 = f3;
                    break;
                  } else {
                    g3 = d2;
                  }
                }
              }
              if (((i2 | 0) != 0 ? h2 >>> 0 < ((b2[5859] | 0) - k2 | 0) >>> 0 : 0) ? (l2 = i2 + k2 | 0, l2 >>> 0 > i2 >>> 0) : 0) {
                g3 = b2[i2 + 24 >> 2] | 0;
                c2 = b2[i2 + 12 >> 2] | 0;
                do {
                  if ((c2 | 0) == (i2 | 0)) {
                    a3 = i2 + 20 | 0;
                    c2 = b2[a3 >> 2] | 0;
                    if (!c2) {
                      a3 = i2 + 16 | 0;
                      c2 = b2[a3 >> 2] | 0;
                      if (!c2) {
                        c2 = 0;
                        break;
                      }
                    }
                    while (1) {
                      f3 = c2 + 20 | 0;
                      d2 = b2[f3 >> 2] | 0;
                      if (!d2) {
                        f3 = c2 + 16 | 0;
                        d2 = b2[f3 >> 2] | 0;
                        if (!d2) {
                          break;
                        } else {
                          c2 = d2;
                          a3 = f3;
                        }
                      } else {
                        c2 = d2;
                        a3 = f3;
                      }
                    }
                    b2[a3 >> 2] = 0;
                  } else {
                    v6 = b2[i2 + 8 >> 2] | 0;
                    b2[v6 + 12 >> 2] = c2;
                    b2[c2 + 8 >> 2] = v6;
                  }
                } while (0);
                do {
                  if (g3) {
                    a3 = b2[i2 + 28 >> 2] | 0;
                    d2 = 23732 + (a3 << 2) | 0;
                    if ((i2 | 0) == (b2[d2 >> 2] | 0)) {
                      b2[d2 >> 2] = c2;
                      if (!c2) {
                        e4 = e4 & ~(1 << a3);
                        b2[5858] = e4;
                        break;
                      }
                    } else {
                      v6 = g3 + 16 | 0;
                      b2[((b2[v6 >> 2] | 0) == (i2 | 0) ? v6 : g3 + 20 | 0) >> 2] = c2;
                      if (!c2) {
                        break;
                      }
                    }
                    b2[c2 + 24 >> 2] = g3;
                    a3 = b2[i2 + 16 >> 2] | 0;
                    if (a3 | 0) {
                      b2[c2 + 16 >> 2] = a3;
                      b2[a3 + 24 >> 2] = c2;
                    }
                    a3 = b2[i2 + 20 >> 2] | 0;
                    if (a3) {
                      b2[c2 + 20 >> 2] = a3;
                      b2[a3 + 24 >> 2] = c2;
                    }
                  }
                } while (0);
                b:
                  do {
                    if (h2 >>> 0 < 16) {
                      v6 = h2 + k2 | 0;
                      b2[i2 + 4 >> 2] = v6 | 3;
                      v6 = i2 + v6 + 4 | 0;
                      b2[v6 >> 2] = b2[v6 >> 2] | 1;
                    } else {
                      b2[i2 + 4 >> 2] = k2 | 3;
                      b2[l2 + 4 >> 2] = h2 | 1;
                      b2[l2 + h2 >> 2] = h2;
                      c2 = h2 >>> 3;
                      if (h2 >>> 0 < 256) {
                        d2 = 23468 + (c2 << 1 << 2) | 0;
                        a3 = b2[5857] | 0;
                        c2 = 1 << c2;
                        if (!(a3 & c2)) {
                          b2[5857] = a3 | c2;
                          c2 = d2;
                          a3 = d2 + 8 | 0;
                        } else {
                          a3 = d2 + 8 | 0;
                          c2 = b2[a3 >> 2] | 0;
                        }
                        b2[a3 >> 2] = l2;
                        b2[c2 + 12 >> 2] = l2;
                        b2[l2 + 8 >> 2] = c2;
                        b2[l2 + 12 >> 2] = d2;
                        break;
                      }
                      c2 = h2 >>> 8;
                      if (c2) {
                        if (h2 >>> 0 > 16777215) {
                          d2 = 31;
                        } else {
                          u3 = (c2 + 1048320 | 0) >>> 16 & 8;
                          v6 = c2 << u3;
                          t3 = (v6 + 520192 | 0) >>> 16 & 4;
                          v6 = v6 << t3;
                          d2 = (v6 + 245760 | 0) >>> 16 & 2;
                          d2 = 14 - (t3 | u3 | d2) + (v6 << d2 >>> 15) | 0;
                          d2 = h2 >>> (d2 + 7 | 0) & 1 | d2 << 1;
                        }
                      } else {
                        d2 = 0;
                      }
                      c2 = 23732 + (d2 << 2) | 0;
                      b2[l2 + 28 >> 2] = d2;
                      a3 = l2 + 16 | 0;
                      b2[a3 + 4 >> 2] = 0;
                      b2[a3 >> 2] = 0;
                      a3 = 1 << d2;
                      if (!(e4 & a3)) {
                        b2[5858] = e4 | a3;
                        b2[c2 >> 2] = l2;
                        b2[l2 + 24 >> 2] = c2;
                        b2[l2 + 12 >> 2] = l2;
                        b2[l2 + 8 >> 2] = l2;
                        break;
                      }
                      c2 = b2[c2 >> 2] | 0;
                      c:
                        do {
                          if ((b2[c2 + 4 >> 2] & -8 | 0) != (h2 | 0)) {
                            e4 = h2 << ((d2 | 0) == 31 ? 0 : 25 - (d2 >>> 1) | 0);
                            while (1) {
                              d2 = c2 + 16 + (e4 >>> 31 << 2) | 0;
                              a3 = b2[d2 >> 2] | 0;
                              if (!a3) {
                                break;
                              }
                              if ((b2[a3 + 4 >> 2] & -8 | 0) == (h2 | 0)) {
                                c2 = a3;
                                break c;
                              } else {
                                e4 = e4 << 1;
                                c2 = a3;
                              }
                            }
                            b2[d2 >> 2] = l2;
                            b2[l2 + 24 >> 2] = c2;
                            b2[l2 + 12 >> 2] = l2;
                            b2[l2 + 8 >> 2] = l2;
                            break b;
                          }
                        } while (0);
                      u3 = c2 + 8 | 0;
                      v6 = b2[u3 >> 2] | 0;
                      b2[v6 + 12 >> 2] = l2;
                      b2[u3 >> 2] = l2;
                      b2[l2 + 8 >> 2] = v6;
                      b2[l2 + 12 >> 2] = c2;
                      b2[l2 + 24 >> 2] = 0;
                    }
                  } while (0);
                v6 = i2 + 8 | 0;
                T2 = w3;
                return v6 | 0;
              } else {
                m2 = k2;
              }
            } else {
              m2 = k2;
            }
          } else {
            m2 = -1;
          }
        } while (0);
        d2 = b2[5859] | 0;
        if (d2 >>> 0 >= m2 >>> 0) {
          c2 = d2 - m2 | 0;
          a3 = b2[5862] | 0;
          if (c2 >>> 0 > 15) {
            v6 = a3 + m2 | 0;
            b2[5862] = v6;
            b2[5859] = c2;
            b2[v6 + 4 >> 2] = c2 | 1;
            b2[a3 + d2 >> 2] = c2;
            b2[a3 + 4 >> 2] = m2 | 3;
          } else {
            b2[5859] = 0;
            b2[5862] = 0;
            b2[a3 + 4 >> 2] = d2 | 3;
            v6 = a3 + d2 + 4 | 0;
            b2[v6 >> 2] = b2[v6 >> 2] | 1;
          }
          v6 = a3 + 8 | 0;
          T2 = w3;
          return v6 | 0;
        }
        h2 = b2[5860] | 0;
        if (h2 >>> 0 > m2 >>> 0) {
          t3 = h2 - m2 | 0;
          b2[5860] = t3;
          v6 = b2[5863] | 0;
          u3 = v6 + m2 | 0;
          b2[5863] = u3;
          b2[u3 + 4 >> 2] = t3 | 1;
          b2[v6 + 4 >> 2] = m2 | 3;
          v6 = v6 + 8 | 0;
          T2 = w3;
          return v6 | 0;
        }
        if (!(b2[5975] | 0)) {
          b2[5977] = 4096;
          b2[5976] = 4096;
          b2[5978] = -1;
          b2[5979] = -1;
          b2[5980] = 0;
          b2[5968] = 0;
          b2[5975] = n2 & -16 ^ 1431655768;
          a3 = 4096;
        } else {
          a3 = b2[5977] | 0;
        }
        i2 = m2 + 48 | 0;
        j2 = m2 + 47 | 0;
        g3 = a3 + j2 | 0;
        f3 = 0 - a3 | 0;
        k2 = g3 & f3;
        if (k2 >>> 0 <= m2 >>> 0) {
          v6 = 0;
          T2 = w3;
          return v6 | 0;
        }
        a3 = b2[5967] | 0;
        if (a3 | 0 ? (l2 = b2[5965] | 0, n2 = l2 + k2 | 0, n2 >>> 0 <= l2 >>> 0 | n2 >>> 0 > a3 >>> 0) : 0) {
          v6 = 0;
          T2 = w3;
          return v6 | 0;
        }
        d:
          do {
            if (!(b2[5968] & 4)) {
              d2 = b2[5863] | 0;
              e:
                do {
                  if (d2) {
                    e4 = 23876;
                    while (1) {
                      n2 = b2[e4 >> 2] | 0;
                      if (n2 >>> 0 <= d2 >>> 0 ? (n2 + (b2[e4 + 4 >> 2] | 0) | 0) >>> 0 > d2 >>> 0 : 0) {
                        break;
                      }
                      a3 = b2[e4 + 8 >> 2] | 0;
                      if (!a3) {
                        q3 = 128;
                        break e;
                      } else {
                        e4 = a3;
                      }
                    }
                    c2 = g3 - h2 & f3;
                    if (c2 >>> 0 < 2147483647) {
                      a3 = Dd(c2 | 0) | 0;
                      if ((a3 | 0) == ((b2[e4 >> 2] | 0) + (b2[e4 + 4 >> 2] | 0) | 0)) {
                        if ((a3 | 0) != (-1 | 0)) {
                          h2 = c2;
                          g3 = a3;
                          q3 = 145;
                          break d;
                        }
                      } else {
                        e4 = a3;
                        q3 = 136;
                      }
                    } else {
                      c2 = 0;
                    }
                  } else {
                    q3 = 128;
                  }
                } while (0);
              do {
                if ((q3 | 0) == 128) {
                  d2 = Dd(0) | 0;
                  if ((d2 | 0) != (-1 | 0) ? (c2 = d2, o2 = b2[5976] | 0, p3 = o2 + -1 | 0, c2 = ((p3 & c2 | 0) == 0 ? 0 : (p3 + c2 & 0 - o2) - c2 | 0) + k2 | 0, o2 = b2[5965] | 0, p3 = c2 + o2 | 0, c2 >>> 0 > m2 >>> 0 & c2 >>> 0 < 2147483647) : 0) {
                    n2 = b2[5967] | 0;
                    if (n2 | 0 ? p3 >>> 0 <= o2 >>> 0 | p3 >>> 0 > n2 >>> 0 : 0) {
                      c2 = 0;
                      break;
                    }
                    a3 = Dd(c2 | 0) | 0;
                    if ((a3 | 0) == (d2 | 0)) {
                      h2 = c2;
                      g3 = d2;
                      q3 = 145;
                      break d;
                    } else {
                      e4 = a3;
                      q3 = 136;
                    }
                  } else {
                    c2 = 0;
                  }
                }
              } while (0);
              do {
                if ((q3 | 0) == 136) {
                  d2 = 0 - c2 | 0;
                  if (!(i2 >>> 0 > c2 >>> 0 & (c2 >>> 0 < 2147483647 & (e4 | 0) != (-1 | 0)))) {
                    if ((e4 | 0) == (-1 | 0)) {
                      c2 = 0;
                      break;
                    } else {
                      h2 = c2;
                      g3 = e4;
                      q3 = 145;
                      break d;
                    }
                  }
                  a3 = b2[5977] | 0;
                  a3 = j2 - c2 + a3 & 0 - a3;
                  if (a3 >>> 0 >= 2147483647) {
                    h2 = c2;
                    g3 = e4;
                    q3 = 145;
                    break d;
                  }
                  if ((Dd(a3 | 0) | 0) == (-1 | 0)) {
                    Dd(d2 | 0) | 0;
                    c2 = 0;
                    break;
                  } else {
                    h2 = a3 + c2 | 0;
                    g3 = e4;
                    q3 = 145;
                    break d;
                  }
                }
              } while (0);
              b2[5968] = b2[5968] | 4;
              q3 = 143;
            } else {
              c2 = 0;
              q3 = 143;
            }
          } while (0);
        if (((q3 | 0) == 143 ? k2 >>> 0 < 2147483647 : 0) ? (t3 = Dd(k2 | 0) | 0, p3 = Dd(0) | 0, r3 = p3 - t3 | 0, s3 = r3 >>> 0 > (m2 + 40 | 0) >>> 0, !((t3 | 0) == (-1 | 0) | s3 ^ 1 | t3 >>> 0 < p3 >>> 0 & ((t3 | 0) != (-1 | 0) & (p3 | 0) != (-1 | 0)) ^ 1)) : 0) {
          h2 = s3 ? r3 : c2;
          g3 = t3;
          q3 = 145;
        }
        if ((q3 | 0) == 145) {
          c2 = (b2[5965] | 0) + h2 | 0;
          b2[5965] = c2;
          if (c2 >>> 0 > (b2[5966] | 0) >>> 0) {
            b2[5966] = c2;
          }
          j2 = b2[5863] | 0;
          f:
            do {
              if (j2) {
                c2 = 23876;
                while (1) {
                  a3 = b2[c2 >> 2] | 0;
                  d2 = b2[c2 + 4 >> 2] | 0;
                  if ((g3 | 0) == (a3 + d2 | 0)) {
                    q3 = 154;
                    break;
                  }
                  e4 = b2[c2 + 8 >> 2] | 0;
                  if (!e4) {
                    break;
                  } else {
                    c2 = e4;
                  }
                }
                if (((q3 | 0) == 154 ? (u3 = c2 + 4 | 0, (b2[c2 + 12 >> 2] & 8 | 0) == 0) : 0) ? g3 >>> 0 > j2 >>> 0 & a3 >>> 0 <= j2 >>> 0 : 0) {
                  b2[u3 >> 2] = d2 + h2;
                  v6 = (b2[5860] | 0) + h2 | 0;
                  t3 = j2 + 8 | 0;
                  t3 = (t3 & 7 | 0) == 0 ? 0 : 0 - t3 & 7;
                  u3 = j2 + t3 | 0;
                  t3 = v6 - t3 | 0;
                  b2[5863] = u3;
                  b2[5860] = t3;
                  b2[u3 + 4 >> 2] = t3 | 1;
                  b2[j2 + v6 + 4 >> 2] = 40;
                  b2[5864] = b2[5979];
                  break;
                }
                if (g3 >>> 0 < (b2[5861] | 0) >>> 0) {
                  b2[5861] = g3;
                }
                d2 = g3 + h2 | 0;
                c2 = 23876;
                while (1) {
                  if ((b2[c2 >> 2] | 0) == (d2 | 0)) {
                    q3 = 162;
                    break;
                  }
                  a3 = b2[c2 + 8 >> 2] | 0;
                  if (!a3) {
                    break;
                  } else {
                    c2 = a3;
                  }
                }
                if ((q3 | 0) == 162 ? (b2[c2 + 12 >> 2] & 8 | 0) == 0 : 0) {
                  b2[c2 >> 2] = g3;
                  l2 = c2 + 4 | 0;
                  b2[l2 >> 2] = (b2[l2 >> 2] | 0) + h2;
                  l2 = g3 + 8 | 0;
                  l2 = g3 + ((l2 & 7 | 0) == 0 ? 0 : 0 - l2 & 7) | 0;
                  c2 = d2 + 8 | 0;
                  c2 = d2 + ((c2 & 7 | 0) == 0 ? 0 : 0 - c2 & 7) | 0;
                  k2 = l2 + m2 | 0;
                  i2 = c2 - l2 - m2 | 0;
                  b2[l2 + 4 >> 2] = m2 | 3;
                  g:
                    do {
                      if ((j2 | 0) == (c2 | 0)) {
                        v6 = (b2[5860] | 0) + i2 | 0;
                        b2[5860] = v6;
                        b2[5863] = k2;
                        b2[k2 + 4 >> 2] = v6 | 1;
                      } else {
                        if ((b2[5862] | 0) == (c2 | 0)) {
                          v6 = (b2[5859] | 0) + i2 | 0;
                          b2[5859] = v6;
                          b2[5862] = k2;
                          b2[k2 + 4 >> 2] = v6 | 1;
                          b2[k2 + v6 >> 2] = v6;
                          break;
                        }
                        a3 = b2[c2 + 4 >> 2] | 0;
                        if ((a3 & 3 | 0) == 1) {
                          h2 = a3 & -8;
                          e4 = a3 >>> 3;
                          h:
                            do {
                              if (a3 >>> 0 < 256) {
                                a3 = b2[c2 + 8 >> 2] | 0;
                                d2 = b2[c2 + 12 >> 2] | 0;
                                if ((d2 | 0) == (a3 | 0)) {
                                  b2[5857] = b2[5857] & ~(1 << e4);
                                  break;
                                } else {
                                  b2[a3 + 12 >> 2] = d2;
                                  b2[d2 + 8 >> 2] = a3;
                                  break;
                                }
                              } else {
                                g3 = b2[c2 + 24 >> 2] | 0;
                                a3 = b2[c2 + 12 >> 2] | 0;
                                do {
                                  if ((a3 | 0) == (c2 | 0)) {
                                    d2 = c2 + 16 | 0;
                                    e4 = d2 + 4 | 0;
                                    a3 = b2[e4 >> 2] | 0;
                                    if (!a3) {
                                      a3 = b2[d2 >> 2] | 0;
                                      if (!a3) {
                                        a3 = 0;
                                        break;
                                      }
                                    } else {
                                      d2 = e4;
                                    }
                                    while (1) {
                                      f3 = a3 + 20 | 0;
                                      e4 = b2[f3 >> 2] | 0;
                                      if (!e4) {
                                        f3 = a3 + 16 | 0;
                                        e4 = b2[f3 >> 2] | 0;
                                        if (!e4) {
                                          break;
                                        } else {
                                          a3 = e4;
                                          d2 = f3;
                                        }
                                      } else {
                                        a3 = e4;
                                        d2 = f3;
                                      }
                                    }
                                    b2[d2 >> 2] = 0;
                                  } else {
                                    v6 = b2[c2 + 8 >> 2] | 0;
                                    b2[v6 + 12 >> 2] = a3;
                                    b2[a3 + 8 >> 2] = v6;
                                  }
                                } while (0);
                                if (!g3) {
                                  break;
                                }
                                d2 = b2[c2 + 28 >> 2] | 0;
                                e4 = 23732 + (d2 << 2) | 0;
                                do {
                                  if ((b2[e4 >> 2] | 0) != (c2 | 0)) {
                                    v6 = g3 + 16 | 0;
                                    b2[((b2[v6 >> 2] | 0) == (c2 | 0) ? v6 : g3 + 20 | 0) >> 2] = a3;
                                    if (!a3) {
                                      break h;
                                    }
                                  } else {
                                    b2[e4 >> 2] = a3;
                                    if (a3 | 0) {
                                      break;
                                    }
                                    b2[5858] = b2[5858] & ~(1 << d2);
                                    break h;
                                  }
                                } while (0);
                                b2[a3 + 24 >> 2] = g3;
                                d2 = c2 + 16 | 0;
                                e4 = b2[d2 >> 2] | 0;
                                if (e4 | 0) {
                                  b2[a3 + 16 >> 2] = e4;
                                  b2[e4 + 24 >> 2] = a3;
                                }
                                d2 = b2[d2 + 4 >> 2] | 0;
                                if (!d2) {
                                  break;
                                }
                                b2[a3 + 20 >> 2] = d2;
                                b2[d2 + 24 >> 2] = a3;
                              }
                            } while (0);
                          c2 = c2 + h2 | 0;
                          f3 = h2 + i2 | 0;
                        } else {
                          f3 = i2;
                        }
                        c2 = c2 + 4 | 0;
                        b2[c2 >> 2] = b2[c2 >> 2] & -2;
                        b2[k2 + 4 >> 2] = f3 | 1;
                        b2[k2 + f3 >> 2] = f3;
                        c2 = f3 >>> 3;
                        if (f3 >>> 0 < 256) {
                          d2 = 23468 + (c2 << 1 << 2) | 0;
                          a3 = b2[5857] | 0;
                          c2 = 1 << c2;
                          if (!(a3 & c2)) {
                            b2[5857] = a3 | c2;
                            c2 = d2;
                            a3 = d2 + 8 | 0;
                          } else {
                            a3 = d2 + 8 | 0;
                            c2 = b2[a3 >> 2] | 0;
                          }
                          b2[a3 >> 2] = k2;
                          b2[c2 + 12 >> 2] = k2;
                          b2[k2 + 8 >> 2] = c2;
                          b2[k2 + 12 >> 2] = d2;
                          break;
                        }
                        c2 = f3 >>> 8;
                        do {
                          if (!c2) {
                            e4 = 0;
                          } else {
                            if (f3 >>> 0 > 16777215) {
                              e4 = 31;
                              break;
                            }
                            u3 = (c2 + 1048320 | 0) >>> 16 & 8;
                            v6 = c2 << u3;
                            t3 = (v6 + 520192 | 0) >>> 16 & 4;
                            v6 = v6 << t3;
                            e4 = (v6 + 245760 | 0) >>> 16 & 2;
                            e4 = 14 - (t3 | u3 | e4) + (v6 << e4 >>> 15) | 0;
                            e4 = f3 >>> (e4 + 7 | 0) & 1 | e4 << 1;
                          }
                        } while (0);
                        c2 = 23732 + (e4 << 2) | 0;
                        b2[k2 + 28 >> 2] = e4;
                        a3 = k2 + 16 | 0;
                        b2[a3 + 4 >> 2] = 0;
                        b2[a3 >> 2] = 0;
                        a3 = b2[5858] | 0;
                        d2 = 1 << e4;
                        if (!(a3 & d2)) {
                          b2[5858] = a3 | d2;
                          b2[c2 >> 2] = k2;
                          b2[k2 + 24 >> 2] = c2;
                          b2[k2 + 12 >> 2] = k2;
                          b2[k2 + 8 >> 2] = k2;
                          break;
                        }
                        c2 = b2[c2 >> 2] | 0;
                        i:
                          do {
                            if ((b2[c2 + 4 >> 2] & -8 | 0) != (f3 | 0)) {
                              e4 = f3 << ((e4 | 0) == 31 ? 0 : 25 - (e4 >>> 1) | 0);
                              while (1) {
                                d2 = c2 + 16 + (e4 >>> 31 << 2) | 0;
                                a3 = b2[d2 >> 2] | 0;
                                if (!a3) {
                                  break;
                                }
                                if ((b2[a3 + 4 >> 2] & -8 | 0) == (f3 | 0)) {
                                  c2 = a3;
                                  break i;
                                } else {
                                  e4 = e4 << 1;
                                  c2 = a3;
                                }
                              }
                              b2[d2 >> 2] = k2;
                              b2[k2 + 24 >> 2] = c2;
                              b2[k2 + 12 >> 2] = k2;
                              b2[k2 + 8 >> 2] = k2;
                              break g;
                            }
                          } while (0);
                        u3 = c2 + 8 | 0;
                        v6 = b2[u3 >> 2] | 0;
                        b2[v6 + 12 >> 2] = k2;
                        b2[u3 >> 2] = k2;
                        b2[k2 + 8 >> 2] = v6;
                        b2[k2 + 12 >> 2] = c2;
                        b2[k2 + 24 >> 2] = 0;
                      }
                    } while (0);
                  v6 = l2 + 8 | 0;
                  T2 = w3;
                  return v6 | 0;
                }
                c2 = 23876;
                while (1) {
                  a3 = b2[c2 >> 2] | 0;
                  if (a3 >>> 0 <= j2 >>> 0 ? (v6 = a3 + (b2[c2 + 4 >> 2] | 0) | 0, v6 >>> 0 > j2 >>> 0) : 0) {
                    break;
                  }
                  c2 = b2[c2 + 8 >> 2] | 0;
                }
                f3 = v6 + -47 | 0;
                a3 = f3 + 8 | 0;
                a3 = f3 + ((a3 & 7 | 0) == 0 ? 0 : 0 - a3 & 7) | 0;
                f3 = j2 + 16 | 0;
                a3 = a3 >>> 0 < f3 >>> 0 ? j2 : a3;
                c2 = a3 + 8 | 0;
                d2 = h2 + -40 | 0;
                t3 = g3 + 8 | 0;
                t3 = (t3 & 7 | 0) == 0 ? 0 : 0 - t3 & 7;
                u3 = g3 + t3 | 0;
                t3 = d2 - t3 | 0;
                b2[5863] = u3;
                b2[5860] = t3;
                b2[u3 + 4 >> 2] = t3 | 1;
                b2[g3 + d2 + 4 >> 2] = 40;
                b2[5864] = b2[5979];
                d2 = a3 + 4 | 0;
                b2[d2 >> 2] = 27;
                b2[c2 >> 2] = b2[5969];
                b2[c2 + 4 >> 2] = b2[5970];
                b2[c2 + 8 >> 2] = b2[5971];
                b2[c2 + 12 >> 2] = b2[5972];
                b2[5969] = g3;
                b2[5970] = h2;
                b2[5972] = 0;
                b2[5971] = c2;
                c2 = a3 + 24 | 0;
                do {
                  u3 = c2;
                  c2 = c2 + 4 | 0;
                  b2[c2 >> 2] = 7;
                } while ((u3 + 8 | 0) >>> 0 < v6 >>> 0);
                if ((a3 | 0) != (j2 | 0)) {
                  g3 = a3 - j2 | 0;
                  b2[d2 >> 2] = b2[d2 >> 2] & -2;
                  b2[j2 + 4 >> 2] = g3 | 1;
                  b2[a3 >> 2] = g3;
                  c2 = g3 >>> 3;
                  if (g3 >>> 0 < 256) {
                    d2 = 23468 + (c2 << 1 << 2) | 0;
                    a3 = b2[5857] | 0;
                    c2 = 1 << c2;
                    if (!(a3 & c2)) {
                      b2[5857] = a3 | c2;
                      c2 = d2;
                      a3 = d2 + 8 | 0;
                    } else {
                      a3 = d2 + 8 | 0;
                      c2 = b2[a3 >> 2] | 0;
                    }
                    b2[a3 >> 2] = j2;
                    b2[c2 + 12 >> 2] = j2;
                    b2[j2 + 8 >> 2] = c2;
                    b2[j2 + 12 >> 2] = d2;
                    break;
                  }
                  c2 = g3 >>> 8;
                  if (c2) {
                    if (g3 >>> 0 > 16777215) {
                      e4 = 31;
                    } else {
                      u3 = (c2 + 1048320 | 0) >>> 16 & 8;
                      v6 = c2 << u3;
                      t3 = (v6 + 520192 | 0) >>> 16 & 4;
                      v6 = v6 << t3;
                      e4 = (v6 + 245760 | 0) >>> 16 & 2;
                      e4 = 14 - (t3 | u3 | e4) + (v6 << e4 >>> 15) | 0;
                      e4 = g3 >>> (e4 + 7 | 0) & 1 | e4 << 1;
                    }
                  } else {
                    e4 = 0;
                  }
                  d2 = 23732 + (e4 << 2) | 0;
                  b2[j2 + 28 >> 2] = e4;
                  b2[j2 + 20 >> 2] = 0;
                  b2[f3 >> 2] = 0;
                  c2 = b2[5858] | 0;
                  a3 = 1 << e4;
                  if (!(c2 & a3)) {
                    b2[5858] = c2 | a3;
                    b2[d2 >> 2] = j2;
                    b2[j2 + 24 >> 2] = d2;
                    b2[j2 + 12 >> 2] = j2;
                    b2[j2 + 8 >> 2] = j2;
                    break;
                  }
                  c2 = b2[d2 >> 2] | 0;
                  j:
                    do {
                      if ((b2[c2 + 4 >> 2] & -8 | 0) != (g3 | 0)) {
                        e4 = g3 << ((e4 | 0) == 31 ? 0 : 25 - (e4 >>> 1) | 0);
                        while (1) {
                          d2 = c2 + 16 + (e4 >>> 31 << 2) | 0;
                          a3 = b2[d2 >> 2] | 0;
                          if (!a3) {
                            break;
                          }
                          if ((b2[a3 + 4 >> 2] & -8 | 0) == (g3 | 0)) {
                            c2 = a3;
                            break j;
                          } else {
                            e4 = e4 << 1;
                            c2 = a3;
                          }
                        }
                        b2[d2 >> 2] = j2;
                        b2[j2 + 24 >> 2] = c2;
                        b2[j2 + 12 >> 2] = j2;
                        b2[j2 + 8 >> 2] = j2;
                        break f;
                      }
                    } while (0);
                  u3 = c2 + 8 | 0;
                  v6 = b2[u3 >> 2] | 0;
                  b2[v6 + 12 >> 2] = j2;
                  b2[u3 >> 2] = j2;
                  b2[j2 + 8 >> 2] = v6;
                  b2[j2 + 12 >> 2] = c2;
                  b2[j2 + 24 >> 2] = 0;
                }
              } else {
                v6 = b2[5861] | 0;
                if ((v6 | 0) == 0 | g3 >>> 0 < v6 >>> 0) {
                  b2[5861] = g3;
                }
                b2[5969] = g3;
                b2[5970] = h2;
                b2[5972] = 0;
                b2[5866] = b2[5975];
                b2[5865] = -1;
                b2[5870] = 23468;
                b2[5869] = 23468;
                b2[5872] = 23476;
                b2[5871] = 23476;
                b2[5874] = 23484;
                b2[5873] = 23484;
                b2[5876] = 23492;
                b2[5875] = 23492;
                b2[5878] = 23500;
                b2[5877] = 23500;
                b2[5880] = 23508;
                b2[5879] = 23508;
                b2[5882] = 23516;
                b2[5881] = 23516;
                b2[5884] = 23524;
                b2[5883] = 23524;
                b2[5886] = 23532;
                b2[5885] = 23532;
                b2[5888] = 23540;
                b2[5887] = 23540;
                b2[5890] = 23548;
                b2[5889] = 23548;
                b2[5892] = 23556;
                b2[5891] = 23556;
                b2[5894] = 23564;
                b2[5893] = 23564;
                b2[5896] = 23572;
                b2[5895] = 23572;
                b2[5898] = 23580;
                b2[5897] = 23580;
                b2[5900] = 23588;
                b2[5899] = 23588;
                b2[5902] = 23596;
                b2[5901] = 23596;
                b2[5904] = 23604;
                b2[5903] = 23604;
                b2[5906] = 23612;
                b2[5905] = 23612;
                b2[5908] = 23620;
                b2[5907] = 23620;
                b2[5910] = 23628;
                b2[5909] = 23628;
                b2[5912] = 23636;
                b2[5911] = 23636;
                b2[5914] = 23644;
                b2[5913] = 23644;
                b2[5916] = 23652;
                b2[5915] = 23652;
                b2[5918] = 23660;
                b2[5917] = 23660;
                b2[5920] = 23668;
                b2[5919] = 23668;
                b2[5922] = 23676;
                b2[5921] = 23676;
                b2[5924] = 23684;
                b2[5923] = 23684;
                b2[5926] = 23692;
                b2[5925] = 23692;
                b2[5928] = 23700;
                b2[5927] = 23700;
                b2[5930] = 23708;
                b2[5929] = 23708;
                b2[5932] = 23716;
                b2[5931] = 23716;
                v6 = h2 + -40 | 0;
                t3 = g3 + 8 | 0;
                t3 = (t3 & 7 | 0) == 0 ? 0 : 0 - t3 & 7;
                u3 = g3 + t3 | 0;
                t3 = v6 - t3 | 0;
                b2[5863] = u3;
                b2[5860] = t3;
                b2[u3 + 4 >> 2] = t3 | 1;
                b2[g3 + v6 + 4 >> 2] = 40;
                b2[5864] = b2[5979];
              }
            } while (0);
          c2 = b2[5860] | 0;
          if (c2 >>> 0 > m2 >>> 0) {
            t3 = c2 - m2 | 0;
            b2[5860] = t3;
            v6 = b2[5863] | 0;
            u3 = v6 + m2 | 0;
            b2[5863] = u3;
            b2[u3 + 4 >> 2] = t3 | 1;
            b2[v6 + 4 >> 2] = m2 | 3;
            v6 = v6 + 8 | 0;
            T2 = w3;
            return v6 | 0;
          }
        }
        v6 = fd() | 0;
        b2[v6 >> 2] = 12;
        v6 = 0;
        T2 = w3;
        return v6 | 0;
      }
      function jd(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        if (!a3) {
          return;
        }
        d2 = a3 + -8 | 0;
        f3 = b2[5861] | 0;
        a3 = b2[a3 + -4 >> 2] | 0;
        c2 = a3 & -8;
        j2 = d2 + c2 | 0;
        do {
          if (!(a3 & 1)) {
            e4 = b2[d2 >> 2] | 0;
            if (!(a3 & 3)) {
              return;
            }
            h2 = d2 + (0 - e4) | 0;
            g3 = e4 + c2 | 0;
            if (h2 >>> 0 < f3 >>> 0) {
              return;
            }
            if ((b2[5862] | 0) == (h2 | 0)) {
              a3 = j2 + 4 | 0;
              c2 = b2[a3 >> 2] | 0;
              if ((c2 & 3 | 0) != 3) {
                i2 = h2;
                c2 = g3;
                break;
              }
              b2[5859] = g3;
              b2[a3 >> 2] = c2 & -2;
              b2[h2 + 4 >> 2] = g3 | 1;
              b2[h2 + g3 >> 2] = g3;
              return;
            }
            d2 = e4 >>> 3;
            if (e4 >>> 0 < 256) {
              a3 = b2[h2 + 8 >> 2] | 0;
              c2 = b2[h2 + 12 >> 2] | 0;
              if ((c2 | 0) == (a3 | 0)) {
                b2[5857] = b2[5857] & ~(1 << d2);
                i2 = h2;
                c2 = g3;
                break;
              } else {
                b2[a3 + 12 >> 2] = c2;
                b2[c2 + 8 >> 2] = a3;
                i2 = h2;
                c2 = g3;
                break;
              }
            }
            f3 = b2[h2 + 24 >> 2] | 0;
            a3 = b2[h2 + 12 >> 2] | 0;
            do {
              if ((a3 | 0) == (h2 | 0)) {
                c2 = h2 + 16 | 0;
                d2 = c2 + 4 | 0;
                a3 = b2[d2 >> 2] | 0;
                if (!a3) {
                  a3 = b2[c2 >> 2] | 0;
                  if (!a3) {
                    a3 = 0;
                    break;
                  }
                } else {
                  c2 = d2;
                }
                while (1) {
                  e4 = a3 + 20 | 0;
                  d2 = b2[e4 >> 2] | 0;
                  if (!d2) {
                    e4 = a3 + 16 | 0;
                    d2 = b2[e4 >> 2] | 0;
                    if (!d2) {
                      break;
                    } else {
                      a3 = d2;
                      c2 = e4;
                    }
                  } else {
                    a3 = d2;
                    c2 = e4;
                  }
                }
                b2[c2 >> 2] = 0;
              } else {
                i2 = b2[h2 + 8 >> 2] | 0;
                b2[i2 + 12 >> 2] = a3;
                b2[a3 + 8 >> 2] = i2;
              }
            } while (0);
            if (f3) {
              c2 = b2[h2 + 28 >> 2] | 0;
              d2 = 23732 + (c2 << 2) | 0;
              if ((b2[d2 >> 2] | 0) == (h2 | 0)) {
                b2[d2 >> 2] = a3;
                if (!a3) {
                  b2[5858] = b2[5858] & ~(1 << c2);
                  i2 = h2;
                  c2 = g3;
                  break;
                }
              } else {
                i2 = f3 + 16 | 0;
                b2[((b2[i2 >> 2] | 0) == (h2 | 0) ? i2 : f3 + 20 | 0) >> 2] = a3;
                if (!a3) {
                  i2 = h2;
                  c2 = g3;
                  break;
                }
              }
              b2[a3 + 24 >> 2] = f3;
              c2 = h2 + 16 | 0;
              d2 = b2[c2 >> 2] | 0;
              if (d2 | 0) {
                b2[a3 + 16 >> 2] = d2;
                b2[d2 + 24 >> 2] = a3;
              }
              c2 = b2[c2 + 4 >> 2] | 0;
              if (c2) {
                b2[a3 + 20 >> 2] = c2;
                b2[c2 + 24 >> 2] = a3;
                i2 = h2;
                c2 = g3;
              } else {
                i2 = h2;
                c2 = g3;
              }
            } else {
              i2 = h2;
              c2 = g3;
            }
          } else {
            i2 = d2;
            h2 = d2;
          }
        } while (0);
        if (h2 >>> 0 >= j2 >>> 0) {
          return;
        }
        a3 = j2 + 4 | 0;
        e4 = b2[a3 >> 2] | 0;
        if (!(e4 & 1)) {
          return;
        }
        if (!(e4 & 2)) {
          if ((b2[5863] | 0) == (j2 | 0)) {
            j2 = (b2[5860] | 0) + c2 | 0;
            b2[5860] = j2;
            b2[5863] = i2;
            b2[i2 + 4 >> 2] = j2 | 1;
            if ((i2 | 0) != (b2[5862] | 0)) {
              return;
            }
            b2[5862] = 0;
            b2[5859] = 0;
            return;
          }
          if ((b2[5862] | 0) == (j2 | 0)) {
            j2 = (b2[5859] | 0) + c2 | 0;
            b2[5859] = j2;
            b2[5862] = h2;
            b2[i2 + 4 >> 2] = j2 | 1;
            b2[h2 + j2 >> 2] = j2;
            return;
          }
          f3 = (e4 & -8) + c2 | 0;
          d2 = e4 >>> 3;
          do {
            if (e4 >>> 0 < 256) {
              c2 = b2[j2 + 8 >> 2] | 0;
              a3 = b2[j2 + 12 >> 2] | 0;
              if ((a3 | 0) == (c2 | 0)) {
                b2[5857] = b2[5857] & ~(1 << d2);
                break;
              } else {
                b2[c2 + 12 >> 2] = a3;
                b2[a3 + 8 >> 2] = c2;
                break;
              }
            } else {
              g3 = b2[j2 + 24 >> 2] | 0;
              a3 = b2[j2 + 12 >> 2] | 0;
              do {
                if ((a3 | 0) == (j2 | 0)) {
                  c2 = j2 + 16 | 0;
                  d2 = c2 + 4 | 0;
                  a3 = b2[d2 >> 2] | 0;
                  if (!a3) {
                    a3 = b2[c2 >> 2] | 0;
                    if (!a3) {
                      d2 = 0;
                      break;
                    }
                  } else {
                    c2 = d2;
                  }
                  while (1) {
                    e4 = a3 + 20 | 0;
                    d2 = b2[e4 >> 2] | 0;
                    if (!d2) {
                      e4 = a3 + 16 | 0;
                      d2 = b2[e4 >> 2] | 0;
                      if (!d2) {
                        break;
                      } else {
                        a3 = d2;
                        c2 = e4;
                      }
                    } else {
                      a3 = d2;
                      c2 = e4;
                    }
                  }
                  b2[c2 >> 2] = 0;
                  d2 = a3;
                } else {
                  d2 = b2[j2 + 8 >> 2] | 0;
                  b2[d2 + 12 >> 2] = a3;
                  b2[a3 + 8 >> 2] = d2;
                  d2 = a3;
                }
              } while (0);
              if (g3 | 0) {
                a3 = b2[j2 + 28 >> 2] | 0;
                c2 = 23732 + (a3 << 2) | 0;
                if ((b2[c2 >> 2] | 0) == (j2 | 0)) {
                  b2[c2 >> 2] = d2;
                  if (!d2) {
                    b2[5858] = b2[5858] & ~(1 << a3);
                    break;
                  }
                } else {
                  e4 = g3 + 16 | 0;
                  b2[((b2[e4 >> 2] | 0) == (j2 | 0) ? e4 : g3 + 20 | 0) >> 2] = d2;
                  if (!d2) {
                    break;
                  }
                }
                b2[d2 + 24 >> 2] = g3;
                a3 = j2 + 16 | 0;
                c2 = b2[a3 >> 2] | 0;
                if (c2 | 0) {
                  b2[d2 + 16 >> 2] = c2;
                  b2[c2 + 24 >> 2] = d2;
                }
                a3 = b2[a3 + 4 >> 2] | 0;
                if (a3 | 0) {
                  b2[d2 + 20 >> 2] = a3;
                  b2[a3 + 24 >> 2] = d2;
                }
              }
            }
          } while (0);
          b2[i2 + 4 >> 2] = f3 | 1;
          b2[h2 + f3 >> 2] = f3;
          if ((i2 | 0) == (b2[5862] | 0)) {
            b2[5859] = f3;
            return;
          }
        } else {
          b2[a3 >> 2] = e4 & -2;
          b2[i2 + 4 >> 2] = c2 | 1;
          b2[h2 + c2 >> 2] = c2;
          f3 = c2;
        }
        a3 = f3 >>> 3;
        if (f3 >>> 0 < 256) {
          d2 = 23468 + (a3 << 1 << 2) | 0;
          c2 = b2[5857] | 0;
          a3 = 1 << a3;
          if (!(c2 & a3)) {
            b2[5857] = c2 | a3;
            a3 = d2;
            c2 = d2 + 8 | 0;
          } else {
            c2 = d2 + 8 | 0;
            a3 = b2[c2 >> 2] | 0;
          }
          b2[c2 >> 2] = i2;
          b2[a3 + 12 >> 2] = i2;
          b2[i2 + 8 >> 2] = a3;
          b2[i2 + 12 >> 2] = d2;
          return;
        }
        a3 = f3 >>> 8;
        if (a3) {
          if (f3 >>> 0 > 16777215) {
            e4 = 31;
          } else {
            h2 = (a3 + 1048320 | 0) >>> 16 & 8;
            j2 = a3 << h2;
            g3 = (j2 + 520192 | 0) >>> 16 & 4;
            j2 = j2 << g3;
            e4 = (j2 + 245760 | 0) >>> 16 & 2;
            e4 = 14 - (g3 | h2 | e4) + (j2 << e4 >>> 15) | 0;
            e4 = f3 >>> (e4 + 7 | 0) & 1 | e4 << 1;
          }
        } else {
          e4 = 0;
        }
        a3 = 23732 + (e4 << 2) | 0;
        b2[i2 + 28 >> 2] = e4;
        b2[i2 + 20 >> 2] = 0;
        b2[i2 + 16 >> 2] = 0;
        c2 = b2[5858] | 0;
        d2 = 1 << e4;
        a:
          do {
            if (!(c2 & d2)) {
              b2[5858] = c2 | d2;
              b2[a3 >> 2] = i2;
              b2[i2 + 24 >> 2] = a3;
              b2[i2 + 12 >> 2] = i2;
              b2[i2 + 8 >> 2] = i2;
            } else {
              a3 = b2[a3 >> 2] | 0;
              b:
                do {
                  if ((b2[a3 + 4 >> 2] & -8 | 0) != (f3 | 0)) {
                    e4 = f3 << ((e4 | 0) == 31 ? 0 : 25 - (e4 >>> 1) | 0);
                    while (1) {
                      d2 = a3 + 16 + (e4 >>> 31 << 2) | 0;
                      c2 = b2[d2 >> 2] | 0;
                      if (!c2) {
                        break;
                      }
                      if ((b2[c2 + 4 >> 2] & -8 | 0) == (f3 | 0)) {
                        a3 = c2;
                        break b;
                      } else {
                        e4 = e4 << 1;
                        a3 = c2;
                      }
                    }
                    b2[d2 >> 2] = i2;
                    b2[i2 + 24 >> 2] = a3;
                    b2[i2 + 12 >> 2] = i2;
                    b2[i2 + 8 >> 2] = i2;
                    break a;
                  }
                } while (0);
              h2 = a3 + 8 | 0;
              j2 = b2[h2 >> 2] | 0;
              b2[j2 + 12 >> 2] = i2;
              b2[h2 >> 2] = i2;
              b2[i2 + 8 >> 2] = j2;
              b2[i2 + 12 >> 2] = a3;
              b2[i2 + 24 >> 2] = 0;
            }
          } while (0);
        j2 = (b2[5865] | 0) + -1 | 0;
        b2[5865] = j2;
        if (j2 | 0) {
          return;
        }
        a3 = 23884;
        while (1) {
          a3 = b2[a3 >> 2] | 0;
          if (!a3) {
            break;
          } else {
            a3 = a3 + 8 | 0;
          }
        }
        b2[5865] = -1;
        return;
      }
      function kd(a3, c2) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        var d2 = 0;
        if (a3) {
          d2 = B2(c2, a3) | 0;
          if ((c2 | a3) >>> 0 > 65535) {
            d2 = ((d2 >>> 0) / (a3 >>> 0) | 0 | 0) == (c2 | 0) ? d2 : -1;
          }
        } else {
          d2 = 0;
        }
        a3 = id(d2) | 0;
        if (!a3) {
          return a3 | 0;
        }
        if (!(b2[a3 + -4 >> 2] & 3)) {
          return a3 | 0;
        }
        Bd(a3 | 0, 0, d2 | 0) | 0;
        return a3 | 0;
      }
      function ld(a3, b3, c2, d2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        c2 = a3 + c2 >>> 0;
        return (G2(b3 + d2 + (c2 >>> 0 < a3 >>> 0 | 0) >>> 0 | 0), c2 | 0) | 0;
      }
      function md(a3, b3, c2, d2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        d2 = b3 - d2 - (c2 >>> 0 > a3 >>> 0 | 0) >>> 0;
        return (G2(d2 | 0), a3 - c2 >>> 0 | 0) | 0;
      }
      function nd(a3) {
        a3 = a3 | 0;
        return (a3 ? 31 - (E3(a3 ^ a3 - 1) | 0) | 0 : 32) | 0;
      }
      function od(a3, c2, d2, e4, f3) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        f3 = f3 | 0;
        var g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0, l2 = 0, m2 = 0, n2 = 0, o2 = 0, p3 = 0;
        l2 = a3;
        j2 = c2;
        k2 = j2;
        h2 = d2;
        n2 = e4;
        i2 = n2;
        if (!k2) {
          g3 = (f3 | 0) != 0;
          if (!i2) {
            if (g3) {
              b2[f3 >> 2] = (l2 >>> 0) % (h2 >>> 0);
              b2[f3 + 4 >> 2] = 0;
            }
            n2 = 0;
            f3 = (l2 >>> 0) / (h2 >>> 0) >>> 0;
            return (G2(n2 | 0), f3) | 0;
          } else {
            if (!g3) {
              n2 = 0;
              f3 = 0;
              return (G2(n2 | 0), f3) | 0;
            }
            b2[f3 >> 2] = a3 | 0;
            b2[f3 + 4 >> 2] = c2 & 0;
            n2 = 0;
            f3 = 0;
            return (G2(n2 | 0), f3) | 0;
          }
        }
        g3 = (i2 | 0) == 0;
        do {
          if (h2) {
            if (!g3) {
              g3 = (E3(i2 | 0) | 0) - (E3(k2 | 0) | 0) | 0;
              if (g3 >>> 0 <= 31) {
                m2 = g3 + 1 | 0;
                i2 = 31 - g3 | 0;
                c2 = g3 - 31 >> 31;
                h2 = m2;
                a3 = l2 >>> (m2 >>> 0) & c2 | k2 << i2;
                c2 = k2 >>> (m2 >>> 0) & c2;
                g3 = 0;
                i2 = l2 << i2;
                break;
              }
              if (!f3) {
                n2 = 0;
                f3 = 0;
                return (G2(n2 | 0), f3) | 0;
              }
              b2[f3 >> 2] = a3 | 0;
              b2[f3 + 4 >> 2] = j2 | c2 & 0;
              n2 = 0;
              f3 = 0;
              return (G2(n2 | 0), f3) | 0;
            }
            g3 = h2 - 1 | 0;
            if (g3 & h2 | 0) {
              i2 = (E3(h2 | 0) | 0) + 33 - (E3(k2 | 0) | 0) | 0;
              p3 = 64 - i2 | 0;
              m2 = 32 - i2 | 0;
              j2 = m2 >> 31;
              o2 = i2 - 32 | 0;
              c2 = o2 >> 31;
              h2 = i2;
              a3 = m2 - 1 >> 31 & k2 >>> (o2 >>> 0) | (k2 << m2 | l2 >>> (i2 >>> 0)) & c2;
              c2 = c2 & k2 >>> (i2 >>> 0);
              g3 = l2 << p3 & j2;
              i2 = (k2 << p3 | l2 >>> (o2 >>> 0)) & j2 | l2 << m2 & i2 - 33 >> 31;
              break;
            }
            if (f3 | 0) {
              b2[f3 >> 2] = g3 & l2;
              b2[f3 + 4 >> 2] = 0;
            }
            if ((h2 | 0) == 1) {
              o2 = j2 | c2 & 0;
              p3 = a3 | 0 | 0;
              return (G2(o2 | 0), p3) | 0;
            } else {
              p3 = nd(h2 | 0) | 0;
              o2 = k2 >>> (p3 >>> 0) | 0;
              p3 = k2 << 32 - p3 | l2 >>> (p3 >>> 0) | 0;
              return (G2(o2 | 0), p3) | 0;
            }
          } else {
            if (g3) {
              if (f3 | 0) {
                b2[f3 >> 2] = (k2 >>> 0) % (h2 >>> 0);
                b2[f3 + 4 >> 2] = 0;
              }
              o2 = 0;
              p3 = (k2 >>> 0) / (h2 >>> 0) >>> 0;
              return (G2(o2 | 0), p3) | 0;
            }
            if (!l2) {
              if (f3 | 0) {
                b2[f3 >> 2] = 0;
                b2[f3 + 4 >> 2] = (k2 >>> 0) % (i2 >>> 0);
              }
              o2 = 0;
              p3 = (k2 >>> 0) / (i2 >>> 0) >>> 0;
              return (G2(o2 | 0), p3) | 0;
            }
            g3 = i2 - 1 | 0;
            if (!(g3 & i2)) {
              if (f3 | 0) {
                b2[f3 >> 2] = a3 | 0;
                b2[f3 + 4 >> 2] = g3 & k2 | c2 & 0;
              }
              o2 = 0;
              p3 = k2 >>> ((nd(i2 | 0) | 0) >>> 0);
              return (G2(o2 | 0), p3) | 0;
            }
            g3 = (E3(i2 | 0) | 0) - (E3(k2 | 0) | 0) | 0;
            if (g3 >>> 0 <= 30) {
              c2 = g3 + 1 | 0;
              i2 = 31 - g3 | 0;
              h2 = c2;
              a3 = k2 << i2 | l2 >>> (c2 >>> 0);
              c2 = k2 >>> (c2 >>> 0);
              g3 = 0;
              i2 = l2 << i2;
              break;
            }
            if (!f3) {
              o2 = 0;
              p3 = 0;
              return (G2(o2 | 0), p3) | 0;
            }
            b2[f3 >> 2] = a3 | 0;
            b2[f3 + 4 >> 2] = j2 | c2 & 0;
            o2 = 0;
            p3 = 0;
            return (G2(o2 | 0), p3) | 0;
          }
        } while (0);
        if (!h2) {
          k2 = i2;
          j2 = 0;
          i2 = 0;
        } else {
          m2 = d2 | 0 | 0;
          l2 = n2 | e4 & 0;
          k2 = ld(m2 | 0, l2 | 0, -1, -1) | 0;
          d2 = H2() | 0;
          j2 = i2;
          i2 = 0;
          do {
            e4 = j2;
            j2 = g3 >>> 31 | j2 << 1;
            g3 = i2 | g3 << 1;
            e4 = a3 << 1 | e4 >>> 31 | 0;
            n2 = a3 >>> 31 | c2 << 1 | 0;
            md(k2 | 0, d2 | 0, e4 | 0, n2 | 0) | 0;
            p3 = H2() | 0;
            o2 = p3 >> 31 | ((p3 | 0) < 0 ? -1 : 0) << 1;
            i2 = o2 & 1;
            a3 = md(e4 | 0, n2 | 0, o2 & m2 | 0, (((p3 | 0) < 0 ? -1 : 0) >> 31 | ((p3 | 0) < 0 ? -1 : 0) << 1) & l2 | 0) | 0;
            c2 = H2() | 0;
            h2 = h2 - 1 | 0;
          } while ((h2 | 0) != 0);
          k2 = j2;
          j2 = 0;
        }
        h2 = 0;
        if (f3 | 0) {
          b2[f3 >> 2] = a3;
          b2[f3 + 4 >> 2] = c2;
        }
        o2 = (g3 | 0) >>> 31 | (k2 | h2) << 1 | (h2 << 1 | g3 >>> 31) & 0 | j2;
        p3 = (g3 << 1 | 0 >>> 31) & -2 | i2;
        return (G2(o2 | 0), p3) | 0;
      }
      function pd(a3, b3, c2, d2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0;
        j2 = b3 >> 31 | ((b3 | 0) < 0 ? -1 : 0) << 1;
        i2 = ((b3 | 0) < 0 ? -1 : 0) >> 31 | ((b3 | 0) < 0 ? -1 : 0) << 1;
        f3 = d2 >> 31 | ((d2 | 0) < 0 ? -1 : 0) << 1;
        e4 = ((d2 | 0) < 0 ? -1 : 0) >> 31 | ((d2 | 0) < 0 ? -1 : 0) << 1;
        h2 = md(j2 ^ a3 | 0, i2 ^ b3 | 0, j2 | 0, i2 | 0) | 0;
        g3 = H2() | 0;
        a3 = f3 ^ j2;
        b3 = e4 ^ i2;
        return md((od(h2, g3, md(f3 ^ c2 | 0, e4 ^ d2 | 0, f3 | 0, e4 | 0) | 0, H2() | 0, 0) | 0) ^ a3 | 0, (H2() | 0) ^ b3 | 0, a3 | 0, b3 | 0) | 0;
      }
      function qd(a3, b3) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        var c2 = 0, d2 = 0, e4 = 0, f3 = 0;
        f3 = a3 & 65535;
        e4 = b3 & 65535;
        c2 = B2(e4, f3) | 0;
        d2 = a3 >>> 16;
        a3 = (c2 >>> 16) + (B2(e4, d2) | 0) | 0;
        e4 = b3 >>> 16;
        b3 = B2(e4, f3) | 0;
        return (G2((a3 >>> 16) + (B2(e4, d2) | 0) + (((a3 & 65535) + b3 | 0) >>> 16) | 0), a3 + b3 << 16 | c2 & 65535 | 0) | 0;
      }
      function rd(a3, b3, c2, d2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        var e4 = 0, f3 = 0;
        e4 = a3;
        f3 = c2;
        c2 = qd(e4, f3) | 0;
        a3 = H2() | 0;
        return (G2((B2(b3, f3) | 0) + (B2(d2, e4) | 0) + a3 | a3 & 0 | 0), c2 | 0 | 0) | 0;
      }
      function sd(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0, j2 = 0, k2 = 0;
        f3 = T2;
        T2 = T2 + 16 | 0;
        i2 = f3 | 0;
        h2 = c2 >> 31 | ((c2 | 0) < 0 ? -1 : 0) << 1;
        g3 = ((c2 | 0) < 0 ? -1 : 0) >> 31 | ((c2 | 0) < 0 ? -1 : 0) << 1;
        k2 = e4 >> 31 | ((e4 | 0) < 0 ? -1 : 0) << 1;
        j2 = ((e4 | 0) < 0 ? -1 : 0) >> 31 | ((e4 | 0) < 0 ? -1 : 0) << 1;
        a3 = md(h2 ^ a3 | 0, g3 ^ c2 | 0, h2 | 0, g3 | 0) | 0;
        c2 = H2() | 0;
        od(a3, c2, md(k2 ^ d2 | 0, j2 ^ e4 | 0, k2 | 0, j2 | 0) | 0, H2() | 0, i2) | 0;
        e4 = md(b2[i2 >> 2] ^ h2 | 0, b2[i2 + 4 >> 2] ^ g3 | 0, h2 | 0, g3 | 0) | 0;
        d2 = H2() | 0;
        T2 = f3;
        return (G2(d2 | 0), e4) | 0;
      }
      function td(a3, c2, d2, e4) {
        a3 = a3 | 0;
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0;
        g3 = T2;
        T2 = T2 + 16 | 0;
        f3 = g3 | 0;
        od(a3, c2, d2, e4, f3) | 0;
        T2 = g3;
        return (G2(b2[f3 + 4 >> 2] | 0), b2[f3 >> 2] | 0) | 0;
      }
      function ud(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        if ((c2 | 0) < 32) {
          G2(b3 >> c2 | 0);
          return a3 >>> c2 | (b3 & (1 << c2) - 1) << 32 - c2;
        }
        G2(((b3 | 0) < 0 ? -1 : 0) | 0);
        return b3 >> c2 - 32 | 0;
      }
      function vd(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        if ((c2 | 0) < 32) {
          G2(b3 >>> c2 | 0);
          return a3 >>> c2 | (b3 & (1 << c2) - 1) << 32 - c2;
        }
        G2(0);
        return b3 >>> c2 - 32 | 0;
      }
      function wd(a3, b3, c2) {
        a3 = a3 | 0;
        b3 = b3 | 0;
        c2 = c2 | 0;
        if ((c2 | 0) < 32) {
          G2(b3 << c2 | (a3 & (1 << c2) - 1 << 32 - c2) >>> 32 - c2 | 0);
          return a3 << c2;
        }
        G2(a3 << c2 - 32 | 0);
        return 0;
      }
      function xd(a3, b3) {
        a3 = +a3;
        b3 = +b3;
        if (a3 != a3) {
          return +b3;
        }
        if (b3 != b3) {
          return +a3;
        }
        return +D2(+a3, +b3);
      }
      function yd(a3, b3) {
        a3 = +a3;
        b3 = +b3;
        if (a3 != a3) {
          return +b3;
        }
        if (b3 != b3) {
          return +a3;
        }
        return +C2(+a3, +b3);
      }
      function zd(a3) {
        a3 = +a3;
        return a3 >= 0 ? +p2(a3 + 0.5) : +A2(a3 - 0.5);
      }
      function Ad(c2, d2, e4) {
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0;
        if ((e4 | 0) >= 8192) {
          L2(c2 | 0, d2 | 0, e4 | 0) | 0;
          return c2 | 0;
        }
        h2 = c2 | 0;
        g3 = c2 + e4 | 0;
        if ((c2 & 3) == (d2 & 3)) {
          while (c2 & 3) {
            if (!e4) {
              return h2 | 0;
            }
            a2[c2 >> 0] = a2[d2 >> 0] | 0;
            c2 = c2 + 1 | 0;
            d2 = d2 + 1 | 0;
            e4 = e4 - 1 | 0;
          }
          e4 = g3 & -4 | 0;
          f3 = e4 - 64 | 0;
          while ((c2 | 0) <= (f3 | 0)) {
            b2[c2 >> 2] = b2[d2 >> 2];
            b2[c2 + 4 >> 2] = b2[d2 + 4 >> 2];
            b2[c2 + 8 >> 2] = b2[d2 + 8 >> 2];
            b2[c2 + 12 >> 2] = b2[d2 + 12 >> 2];
            b2[c2 + 16 >> 2] = b2[d2 + 16 >> 2];
            b2[c2 + 20 >> 2] = b2[d2 + 20 >> 2];
            b2[c2 + 24 >> 2] = b2[d2 + 24 >> 2];
            b2[c2 + 28 >> 2] = b2[d2 + 28 >> 2];
            b2[c2 + 32 >> 2] = b2[d2 + 32 >> 2];
            b2[c2 + 36 >> 2] = b2[d2 + 36 >> 2];
            b2[c2 + 40 >> 2] = b2[d2 + 40 >> 2];
            b2[c2 + 44 >> 2] = b2[d2 + 44 >> 2];
            b2[c2 + 48 >> 2] = b2[d2 + 48 >> 2];
            b2[c2 + 52 >> 2] = b2[d2 + 52 >> 2];
            b2[c2 + 56 >> 2] = b2[d2 + 56 >> 2];
            b2[c2 + 60 >> 2] = b2[d2 + 60 >> 2];
            c2 = c2 + 64 | 0;
            d2 = d2 + 64 | 0;
          }
          while ((c2 | 0) < (e4 | 0)) {
            b2[c2 >> 2] = b2[d2 >> 2];
            c2 = c2 + 4 | 0;
            d2 = d2 + 4 | 0;
          }
        } else {
          e4 = g3 - 4 | 0;
          while ((c2 | 0) < (e4 | 0)) {
            a2[c2 >> 0] = a2[d2 >> 0] | 0;
            a2[c2 + 1 >> 0] = a2[d2 + 1 >> 0] | 0;
            a2[c2 + 2 >> 0] = a2[d2 + 2 >> 0] | 0;
            a2[c2 + 3 >> 0] = a2[d2 + 3 >> 0] | 0;
            c2 = c2 + 4 | 0;
            d2 = d2 + 4 | 0;
          }
        }
        while ((c2 | 0) < (g3 | 0)) {
          a2[c2 >> 0] = a2[d2 >> 0] | 0;
          c2 = c2 + 1 | 0;
          d2 = d2 + 1 | 0;
        }
        return h2 | 0;
      }
      function Bd(c2, d2, e4) {
        c2 = c2 | 0;
        d2 = d2 | 0;
        e4 = e4 | 0;
        var f3 = 0, g3 = 0, h2 = 0, i2 = 0;
        h2 = c2 + e4 | 0;
        d2 = d2 & 255;
        if ((e4 | 0) >= 67) {
          while (c2 & 3) {
            a2[c2 >> 0] = d2;
            c2 = c2 + 1 | 0;
          }
          f3 = h2 & -4 | 0;
          i2 = d2 | d2 << 8 | d2 << 16 | d2 << 24;
          g3 = f3 - 64 | 0;
          while ((c2 | 0) <= (g3 | 0)) {
            b2[c2 >> 2] = i2;
            b2[c2 + 4 >> 2] = i2;
            b2[c2 + 8 >> 2] = i2;
            b2[c2 + 12 >> 2] = i2;
            b2[c2 + 16 >> 2] = i2;
            b2[c2 + 20 >> 2] = i2;
            b2[c2 + 24 >> 2] = i2;
            b2[c2 + 28 >> 2] = i2;
            b2[c2 + 32 >> 2] = i2;
            b2[c2 + 36 >> 2] = i2;
            b2[c2 + 40 >> 2] = i2;
            b2[c2 + 44 >> 2] = i2;
            b2[c2 + 48 >> 2] = i2;
            b2[c2 + 52 >> 2] = i2;
            b2[c2 + 56 >> 2] = i2;
            b2[c2 + 60 >> 2] = i2;
            c2 = c2 + 64 | 0;
          }
          while ((c2 | 0) < (f3 | 0)) {
            b2[c2 >> 2] = i2;
            c2 = c2 + 4 | 0;
          }
        }
        while ((c2 | 0) < (h2 | 0)) {
          a2[c2 >> 0] = d2;
          c2 = c2 + 1 | 0;
        }
        return h2 - e4 | 0;
      }
      function Cd(a3) {
        a3 = +a3;
        return a3 >= 0 ? +p2(a3 + 0.5) : +A2(a3 - 0.5);
      }
      function Dd(a3) {
        a3 = a3 | 0;
        var c2 = 0, d2 = 0, e4 = 0;
        e4 = K2() | 0;
        d2 = b2[g2 >> 2] | 0;
        c2 = d2 + a3 | 0;
        if ((a3 | 0) > 0 & (c2 | 0) < (d2 | 0) | (c2 | 0) < 0) {
          N2(c2 | 0) | 0;
          J2(12);
          return -1;
        }
        if ((c2 | 0) > (e4 | 0)) {
          if (!(M2(c2 | 0) | 0)) {
            J2(12);
            return -1;
          }
        }
        b2[g2 >> 2] = c2;
        return d2 | 0;
      }
      return {
        ___divdi3: pd,
        ___muldi3: rd,
        ___remdi3: sd,
        ___uremdi3: td,
        _areNeighborCells: $a,
        _bitshift64Ashr: ud,
        _bitshift64Lshr: vd,
        _bitshift64Shl: wd,
        _calloc: kd,
        _cellAreaKm2: lc,
        _cellAreaM2: mc,
        _cellAreaRads2: kc,
        _cellToBoundary: Qb,
        _cellToCenterChild: Ab,
        _cellToChildPos: Vb,
        _cellToChildren: yb,
        _cellToChildrenSize: wb,
        _cellToLatLng: Pb,
        _cellToLocalIj: xc,
        _cellToParent: vb,
        _cellToVertex: Wc,
        _cellToVertexes: Xc,
        _cellsToDirectedEdge: ab2,
        _cellsToLinkedMultiPolygon: la,
        _childPosToCell: Wb,
        _compactCells: Bb,
        _destroyLinkedMultiPolygon: sc,
        _directedEdgeToBoundary: gb,
        _directedEdgeToCells: eb,
        _edgeLengthKm: oc,
        _edgeLengthM: pc,
        _edgeLengthRads: nc,
        _emscripten_replace_memory: W2,
        _free: jd,
        _getBaseCellNumber: tb,
        _getDirectedEdgeDestination: cb2,
        _getDirectedEdgeOrigin: bb2,
        _getHexagonAreaAvgKm2: ec,
        _getHexagonAreaAvgM2: fc,
        _getHexagonEdgeLengthAvgKm: gc,
        _getHexagonEdgeLengthAvgM: hc,
        _getIcosahedronFaces: Sb,
        _getNumCells: ic,
        _getPentagons: Ub,
        _getRes0Cells: wa,
        _getResolution: sb,
        _greatCircleDistanceKm: ac2,
        _greatCircleDistanceM: bc2,
        _greatCircleDistanceRads: $b,
        _gridDisk: aa2,
        _gridDiskDistances: ba2,
        _gridDistance: zc,
        _gridPathCells: Bc,
        _gridPathCellsSize: Ac,
        _gridRingUnsafe: ga,
        _i64Add: ld,
        _i64Subtract: md,
        _isPentagon: xb,
        _isResClassIII: Eb,
        _isValidCell: ub,
        _isValidDirectedEdge: db,
        _isValidVertex: Zc,
        _latLngToCell: Mb,
        _llvm_maxnum_f64: xd,
        _llvm_minnum_f64: yd,
        _llvm_round_f64: zd,
        _localIjToCell: yc,
        _malloc: id,
        _maxFaceCount: Rb,
        _maxGridDiskSize: $,
        _maxPolygonToCellsSize: ha,
        _memcpy: Ad,
        _memset: Bd,
        _originToDirectedEdges: fb,
        _pentagonCount: Tb,
        _polygonToCells: ja,
        _readInt64AsDoubleFromPointer: Oc,
        _res0CellCount: va,
        _round: Cd,
        _sbrk: Dd,
        _sizeOfCellBoundary: Jc,
        _sizeOfCoordIJ: Nc,
        _sizeOfGeoLoop: Kc,
        _sizeOfGeoPolygon: Lc,
        _sizeOfH3Index: Hc,
        _sizeOfLatLng: Ic,
        _sizeOfLinkedGeoPolygon: Mc,
        _uncompactCells: Cb,
        _uncompactCellsSize: Db,
        _vertexToLatLng: Yc,
        establishStackSpace: _2,
        stackAlloc: X2,
        stackRestore: Z2,
        stackSave: Y2
      };
    }(
      // EMSCRIPTEN_END_ASM
      asmGlobalArg,
      asmLibraryArg,
      buffer3
    )
  );
  Module["___divdi3"] = asm["___divdi3"];
  Module["___muldi3"] = asm["___muldi3"];
  Module["___remdi3"] = asm["___remdi3"];
  Module["___uremdi3"] = asm["___uremdi3"];
  Module["_areNeighborCells"] = asm["_areNeighborCells"];
  Module["_bitshift64Ashr"] = asm["_bitshift64Ashr"];
  Module["_bitshift64Lshr"] = asm["_bitshift64Lshr"];
  Module["_bitshift64Shl"] = asm["_bitshift64Shl"];
  Module["_calloc"] = asm["_calloc"];
  Module["_cellAreaKm2"] = asm["_cellAreaKm2"];
  Module["_cellAreaM2"] = asm["_cellAreaM2"];
  Module["_cellAreaRads2"] = asm["_cellAreaRads2"];
  Module["_cellToBoundary"] = asm["_cellToBoundary"];
  Module["_cellToCenterChild"] = asm["_cellToCenterChild"];
  Module["_cellToChildPos"] = asm["_cellToChildPos"];
  Module["_cellToChildren"] = asm["_cellToChildren"];
  Module["_cellToChildrenSize"] = asm["_cellToChildrenSize"];
  Module["_cellToLatLng"] = asm["_cellToLatLng"];
  Module["_cellToLocalIj"] = asm["_cellToLocalIj"];
  Module["_cellToParent"] = asm["_cellToParent"];
  Module["_cellToVertex"] = asm["_cellToVertex"];
  Module["_cellToVertexes"] = asm["_cellToVertexes"];
  Module["_cellsToDirectedEdge"] = asm["_cellsToDirectedEdge"];
  Module["_cellsToLinkedMultiPolygon"] = asm["_cellsToLinkedMultiPolygon"];
  Module["_childPosToCell"] = asm["_childPosToCell"];
  Module["_compactCells"] = asm["_compactCells"];
  Module["_destroyLinkedMultiPolygon"] = asm["_destroyLinkedMultiPolygon"];
  Module["_directedEdgeToBoundary"] = asm["_directedEdgeToBoundary"];
  Module["_directedEdgeToCells"] = asm["_directedEdgeToCells"];
  Module["_edgeLengthKm"] = asm["_edgeLengthKm"];
  Module["_edgeLengthM"] = asm["_edgeLengthM"];
  Module["_edgeLengthRads"] = asm["_edgeLengthRads"];
  var _emscripten_replace_memory = Module["_emscripten_replace_memory"] = asm["_emscripten_replace_memory"];
  Module["_free"] = asm["_free"];
  Module["_getBaseCellNumber"] = asm["_getBaseCellNumber"];
  Module["_getDirectedEdgeDestination"] = asm["_getDirectedEdgeDestination"];
  Module["_getDirectedEdgeOrigin"] = asm["_getDirectedEdgeOrigin"];
  Module["_getHexagonAreaAvgKm2"] = asm["_getHexagonAreaAvgKm2"];
  Module["_getHexagonAreaAvgM2"] = asm["_getHexagonAreaAvgM2"];
  Module["_getHexagonEdgeLengthAvgKm"] = asm["_getHexagonEdgeLengthAvgKm"];
  Module["_getHexagonEdgeLengthAvgM"] = asm["_getHexagonEdgeLengthAvgM"];
  Module["_getIcosahedronFaces"] = asm["_getIcosahedronFaces"];
  Module["_getNumCells"] = asm["_getNumCells"];
  Module["_getPentagons"] = asm["_getPentagons"];
  Module["_getRes0Cells"] = asm["_getRes0Cells"];
  Module["_getResolution"] = asm["_getResolution"];
  Module["_greatCircleDistanceKm"] = asm["_greatCircleDistanceKm"];
  Module["_greatCircleDistanceM"] = asm["_greatCircleDistanceM"];
  Module["_greatCircleDistanceRads"] = asm["_greatCircleDistanceRads"];
  Module["_gridDisk"] = asm["_gridDisk"];
  Module["_gridDiskDistances"] = asm["_gridDiskDistances"];
  Module["_gridDistance"] = asm["_gridDistance"];
  Module["_gridPathCells"] = asm["_gridPathCells"];
  Module["_gridPathCellsSize"] = asm["_gridPathCellsSize"];
  Module["_gridRingUnsafe"] = asm["_gridRingUnsafe"];
  Module["_i64Add"] = asm["_i64Add"];
  Module["_i64Subtract"] = asm["_i64Subtract"];
  Module["_isPentagon"] = asm["_isPentagon"];
  Module["_isResClassIII"] = asm["_isResClassIII"];
  Module["_isValidCell"] = asm["_isValidCell"];
  Module["_isValidDirectedEdge"] = asm["_isValidDirectedEdge"];
  Module["_isValidVertex"] = asm["_isValidVertex"];
  Module["_latLngToCell"] = asm["_latLngToCell"];
  Module["_llvm_maxnum_f64"] = asm["_llvm_maxnum_f64"];
  Module["_llvm_minnum_f64"] = asm["_llvm_minnum_f64"];
  Module["_llvm_round_f64"] = asm["_llvm_round_f64"];
  Module["_localIjToCell"] = asm["_localIjToCell"];
  Module["_malloc"] = asm["_malloc"];
  Module["_maxFaceCount"] = asm["_maxFaceCount"];
  Module["_maxGridDiskSize"] = asm["_maxGridDiskSize"];
  Module["_maxPolygonToCellsSize"] = asm["_maxPolygonToCellsSize"];
  Module["_memcpy"] = asm["_memcpy"];
  Module["_memset"] = asm["_memset"];
  Module["_originToDirectedEdges"] = asm["_originToDirectedEdges"];
  Module["_pentagonCount"] = asm["_pentagonCount"];
  Module["_polygonToCells"] = asm["_polygonToCells"];
  Module["_readInt64AsDoubleFromPointer"] = asm["_readInt64AsDoubleFromPointer"];
  Module["_res0CellCount"] = asm["_res0CellCount"];
  Module["_round"] = asm["_round"];
  Module["_sbrk"] = asm["_sbrk"];
  Module["_sizeOfCellBoundary"] = asm["_sizeOfCellBoundary"];
  Module["_sizeOfCoordIJ"] = asm["_sizeOfCoordIJ"];
  Module["_sizeOfGeoLoop"] = asm["_sizeOfGeoLoop"];
  Module["_sizeOfGeoPolygon"] = asm["_sizeOfGeoPolygon"];
  Module["_sizeOfH3Index"] = asm["_sizeOfH3Index"];
  Module["_sizeOfLatLng"] = asm["_sizeOfLatLng"];
  Module["_sizeOfLinkedGeoPolygon"] = asm["_sizeOfLinkedGeoPolygon"];
  Module["_uncompactCells"] = asm["_uncompactCells"];
  Module["_uncompactCellsSize"] = asm["_uncompactCellsSize"];
  Module["_vertexToLatLng"] = asm["_vertexToLatLng"];
  Module["establishStackSpace"] = asm["establishStackSpace"];
  var stackAlloc = Module["stackAlloc"] = asm["stackAlloc"];
  var stackRestore = Module["stackRestore"] = asm["stackRestore"];
  var stackSave = Module["stackSave"] = asm["stackSave"];
  Module["asm"] = asm;
  Module["cwrap"] = cwrap;
  Module["setValue"] = setValue2;
  Module["getValue"] = getValue2;
  if (memoryInitializer) {
    if (!isDataURI(memoryInitializer)) {
      memoryInitializer = locateFile(memoryInitializer);
    }
    {
      addRunDependency();
      var applyMemoryInitializer = function(data2) {
        if (data2.byteLength) {
          data2 = new Uint8Array(data2);
        }
        HEAPU8.set(data2, GLOBAL_BASE);
        if (Module["memoryInitializerRequest"]) {
          delete Module["memoryInitializerRequest"].response;
        }
        removeRunDependency();
      };
      var doBrowserLoad = function() {
        readAsync(memoryInitializer, applyMemoryInitializer, function() {
          throw "could not load memory initializer " + memoryInitializer;
        });
      };
      var memoryInitializerBytes = tryParseAsDataURI(memoryInitializer);
      if (memoryInitializerBytes) {
        applyMemoryInitializer(memoryInitializerBytes.buffer);
      } else if (Module["memoryInitializerRequest"]) {
        var useRequest = function() {
          var request = Module["memoryInitializerRequest"];
          var response = request.response;
          if (request.status !== 200 && request.status !== 0) {
            var data2 = tryParseAsDataURI(Module["memoryInitializerRequestURL"]);
            if (data2) {
              response = data2.buffer;
            } else {
              console.warn("a problem seems to have happened with Module.memoryInitializerRequest, status: " + request.status + ", retrying " + memoryInitializer);
              doBrowserLoad();
              return;
            }
          }
          applyMemoryInitializer(response);
        };
        if (Module["memoryInitializerRequest"].response) {
          setTimeout(useRequest, 0);
        } else {
          Module["memoryInitializerRequest"].addEventListener("load", useRequest);
        }
      } else {
        doBrowserLoad();
      }
    }
  }
  var calledRun;
  dependenciesFulfilled = function runCaller() {
    if (!calledRun) {
      run2();
    }
    if (!calledRun) {
      dependenciesFulfilled = runCaller;
    }
  };
  function run2(args) {
    if (runDependencies > 0) {
      return;
    }
    preRun();
    if (runDependencies > 0) {
      return;
    }
    function doRun() {
      if (calledRun) {
        return;
      }
      calledRun = true;
      if (ABORT) {
        return;
      }
      initRuntime();
      preMain();
      if (Module["onRuntimeInitialized"]) {
        Module["onRuntimeInitialized"]();
      }
      postRun();
    }
    if (Module["setStatus"]) {
      Module["setStatus"]("Running...");
      setTimeout(function() {
        setTimeout(function() {
          Module["setStatus"]("");
        }, 1);
        doRun();
      }, 1);
    } else {
      doRun();
    }
  }
  Module["run"] = run2;
  function abort2(what) {
    if (Module["onAbort"]) {
      Module["onAbort"](what);
    }
    what += "";
    out(what);
    err(what);
    ABORT = true;
    throw "abort(" + what + "). Build with -s ASSERTIONS=1 for more info.";
  }
  Module["abort"] = abort2;
  if (Module["preInit"]) {
    if (typeof Module["preInit"] == "function") {
      Module["preInit"] = [Module["preInit"]];
    }
    while (Module["preInit"].length > 0) {
      Module["preInit"].pop()();
    }
  }
  run2();
  return libh32;
}(typeof libh3 === "object" ? libh3 : {});
var NUMBER = "number";
var H3_ERROR = NUMBER;
var BOOLEAN = NUMBER;
var H3_LOWER = NUMBER;
var H3_UPPER = NUMBER;
var RESOLUTION$1 = NUMBER;
var POINTER = NUMBER;
var BINDINGS = [
  // The size functions are inserted via build/sizes.h
  ["sizeOfH3Index", NUMBER],
  ["sizeOfLatLng", NUMBER],
  ["sizeOfCellBoundary", NUMBER],
  ["sizeOfGeoLoop", NUMBER],
  ["sizeOfGeoPolygon", NUMBER],
  ["sizeOfLinkedGeoPolygon", NUMBER],
  ["sizeOfCoordIJ", NUMBER],
  ["readInt64AsDoubleFromPointer", NUMBER],
  // The remaining functions are defined in the core lib in h3Api.h
  ["isValidCell", BOOLEAN, [H3_LOWER, H3_UPPER]],
  ["latLngToCell", H3_ERROR, [NUMBER, NUMBER, RESOLUTION$1, POINTER]],
  ["cellToLatLng", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["cellToBoundary", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["maxGridDiskSize", H3_ERROR, [NUMBER, POINTER]],
  ["gridDisk", H3_ERROR, [H3_LOWER, H3_UPPER, NUMBER, POINTER]],
  ["gridDiskDistances", H3_ERROR, [H3_LOWER, H3_UPPER, NUMBER, POINTER, POINTER]],
  ["gridRingUnsafe", H3_ERROR, [H3_LOWER, H3_UPPER, NUMBER, POINTER]],
  ["maxPolygonToCellsSize", H3_ERROR, [POINTER, RESOLUTION$1, NUMBER, POINTER]],
  ["polygonToCells", H3_ERROR, [POINTER, RESOLUTION$1, NUMBER, POINTER]],
  ["cellsToLinkedMultiPolygon", H3_ERROR, [POINTER, NUMBER, POINTER]],
  ["destroyLinkedMultiPolygon", null, [POINTER]],
  ["compactCells", H3_ERROR, [POINTER, POINTER, NUMBER, NUMBER]],
  ["uncompactCells", H3_ERROR, [POINTER, NUMBER, NUMBER, POINTER, NUMBER, RESOLUTION$1]],
  ["uncompactCellsSize", H3_ERROR, [POINTER, NUMBER, NUMBER, RESOLUTION$1, POINTER]],
  ["isPentagon", BOOLEAN, [H3_LOWER, H3_UPPER]],
  ["isResClassIII", BOOLEAN, [H3_LOWER, H3_UPPER]],
  ["getBaseCellNumber", NUMBER, [H3_LOWER, H3_UPPER]],
  ["getResolution", NUMBER, [H3_LOWER, H3_UPPER]],
  ["maxFaceCount", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["getIcosahedronFaces", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["cellToParent", H3_ERROR, [H3_LOWER, H3_UPPER, RESOLUTION$1, POINTER]],
  ["cellToChildren", H3_ERROR, [H3_LOWER, H3_UPPER, RESOLUTION$1, POINTER]],
  ["cellToCenterChild", H3_ERROR, [H3_LOWER, H3_UPPER, RESOLUTION$1, POINTER]],
  ["cellToChildrenSize", H3_ERROR, [H3_LOWER, H3_UPPER, RESOLUTION$1, POINTER]],
  ["cellToChildPos", H3_ERROR, [H3_LOWER, H3_UPPER, RESOLUTION$1, POINTER]],
  ["childPosToCell", H3_ERROR, [NUMBER, NUMBER, H3_LOWER, H3_UPPER, RESOLUTION$1, POINTER]],
  ["areNeighborCells", H3_ERROR, [H3_LOWER, H3_UPPER, H3_LOWER, H3_UPPER, POINTER]],
  ["cellsToDirectedEdge", H3_ERROR, [H3_LOWER, H3_UPPER, H3_LOWER, H3_UPPER, POINTER]],
  ["getDirectedEdgeOrigin", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["getDirectedEdgeDestination", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["isValidDirectedEdge", BOOLEAN, [H3_LOWER, H3_UPPER]],
  ["directedEdgeToCells", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["originToDirectedEdges", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["directedEdgeToBoundary", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["gridDistance", H3_ERROR, [H3_LOWER, H3_UPPER, H3_LOWER, H3_UPPER, POINTER]],
  ["gridPathCells", H3_ERROR, [H3_LOWER, H3_UPPER, H3_LOWER, H3_UPPER, POINTER]],
  ["gridPathCellsSize", H3_ERROR, [H3_LOWER, H3_UPPER, H3_LOWER, H3_UPPER, POINTER]],
  ["cellToLocalIj", H3_ERROR, [H3_LOWER, H3_UPPER, H3_LOWER, H3_UPPER, NUMBER, POINTER]],
  ["localIjToCell", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER, NUMBER, POINTER]],
  ["getHexagonAreaAvgM2", H3_ERROR, [RESOLUTION$1, POINTER]],
  ["getHexagonAreaAvgKm2", H3_ERROR, [RESOLUTION$1, POINTER]],
  ["getHexagonEdgeLengthAvgM", H3_ERROR, [RESOLUTION$1, POINTER]],
  ["getHexagonEdgeLengthAvgKm", H3_ERROR, [RESOLUTION$1, POINTER]],
  ["greatCircleDistanceM", NUMBER, [POINTER, POINTER]],
  ["greatCircleDistanceKm", NUMBER, [POINTER, POINTER]],
  ["greatCircleDistanceRads", NUMBER, [POINTER, POINTER]],
  ["cellAreaM2", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["cellAreaKm2", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["cellAreaRads2", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["edgeLengthM", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["edgeLengthKm", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["edgeLengthRads", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["getNumCells", H3_ERROR, [RESOLUTION$1, POINTER]],
  ["getRes0Cells", H3_ERROR, [POINTER]],
  ["res0CellCount", NUMBER],
  ["getPentagons", H3_ERROR, [NUMBER, POINTER]],
  ["pentagonCount", NUMBER],
  ["cellToVertex", H3_ERROR, [H3_LOWER, H3_UPPER, NUMBER, POINTER]],
  ["cellToVertexes", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["vertexToLatLng", H3_ERROR, [H3_LOWER, H3_UPPER, POINTER]],
  ["isValidVertex", BOOLEAN, [H3_LOWER, H3_UPPER]]
];
var E_SUCCESS = 0;
var E_FAILED = 1;
var E_DOMAIN = 2;
var E_LATLNG_DOMAIN = 3;
var E_RES_DOMAIN = 4;
var E_CELL_INVALID = 5;
var E_DIR_EDGE_INVALID = 6;
var E_UNDIR_EDGE_INVALID = 7;
var E_VERTEX_INVALID = 8;
var E_PENTAGON = 9;
var E_DUPLICATE_INPUT = 10;
var E_NOT_NEIGHBORS = 11;
var E_RES_MISMATCH = 12;
var E_MEMORY_ALLOC = 13;
var E_MEMORY_BOUNDS = 14;
var E_OPTION_INVALID = 15;
var H3_ERROR_MSGS = {};
H3_ERROR_MSGS[E_SUCCESS] = "Success";
H3_ERROR_MSGS[E_FAILED] = "The operation failed but a more specific error is not available";
H3_ERROR_MSGS[E_DOMAIN] = "Argument was outside of acceptable range";
H3_ERROR_MSGS[E_LATLNG_DOMAIN] = "Latitude or longitude arguments were outside of acceptable range";
H3_ERROR_MSGS[E_RES_DOMAIN] = "Resolution argument was outside of acceptable range";
H3_ERROR_MSGS[E_CELL_INVALID] = "Cell argument was not valid";
H3_ERROR_MSGS[E_DIR_EDGE_INVALID] = "Directed edge argument was not valid";
H3_ERROR_MSGS[E_UNDIR_EDGE_INVALID] = "Undirected edge argument was not valid";
H3_ERROR_MSGS[E_VERTEX_INVALID] = "Vertex argument was not valid";
H3_ERROR_MSGS[E_PENTAGON] = "Pentagon distortion was encountered";
H3_ERROR_MSGS[E_DUPLICATE_INPUT] = "Duplicate input";
H3_ERROR_MSGS[E_NOT_NEIGHBORS] = "Cell arguments were not neighbors";
H3_ERROR_MSGS[E_RES_MISMATCH] = "Cell arguments had incompatible resolutions";
H3_ERROR_MSGS[E_MEMORY_ALLOC] = "Memory allocation failed";
H3_ERROR_MSGS[E_MEMORY_BOUNDS] = "Bounds of provided memory were insufficient";
H3_ERROR_MSGS[E_OPTION_INVALID] = "Mode or flags argument was not valid";
var E_UNKNOWN_UNIT = 1e3;
var E_ARRAY_LENGTH = 1001;
var E_NULL_INDEX = 1002;
var JS_ERROR_MESSAGES = {};
JS_ERROR_MESSAGES[E_UNKNOWN_UNIT] = "Unknown unit";
JS_ERROR_MESSAGES[E_ARRAY_LENGTH] = "Array length out of bounds";
JS_ERROR_MESSAGES[E_NULL_INDEX] = "Got unexpected null value for H3 index";
var UNKNOWN_ERROR_MSG = "Unknown error";
function createError(messages, errCode, meta2) {
  var hasValue = meta2 && "value" in meta2;
  var err = new Error((messages[errCode] || UNKNOWN_ERROR_MSG) + " (code: " + errCode + (hasValue ? ", value: " + meta2.value : "") + ")");
  err.code = errCode;
  return err;
}
function H3LibraryError(errCode, value) {
  var meta2 = arguments.length === 2 ? {
    value
  } : {};
  return createError(H3_ERROR_MSGS, errCode, meta2);
}
function JSBindingError(errCode, value) {
  var meta2 = arguments.length === 2 ? {
    value
  } : {};
  return createError(JS_ERROR_MESSAGES, errCode, meta2);
}
function throwIfError(errCode) {
  if (errCode !== 0) {
    throw H3LibraryError(errCode);
  }
}
var H3 = {};
BINDINGS.forEach(function bind3(def) {
  H3[def[0]] = libh3.cwrap.apply(libh3, def);
});
var BASE_16 = 16;
var SZ_INT = 4;
var SZ_DBL = 8;
var SZ_INT64 = 8;
var SZ_H3INDEX = H3.sizeOfH3Index();
var SZ_LATLNG = H3.sizeOfLatLng();
var SZ_CELLBOUNDARY = H3.sizeOfCellBoundary();
H3.sizeOfGeoPolygon();
H3.sizeOfGeoLoop();
H3.sizeOfLinkedGeoPolygon();
H3.sizeOfCoordIJ();
var UNITS = {
  m: "m",
  m2: "m2",
  km: "km",
  km2: "km2",
  rads: "rads",
  rads2: "rads2"
};
function validateRes(res) {
  if (typeof res !== "number" || res < 0 || res > 15 || Math.floor(res) !== res) {
    throw H3LibraryError(E_RES_DOMAIN, res);
  }
  return res;
}
function validateH3Index(h3Index) {
  if (!h3Index) {
    throw JSBindingError(E_NULL_INDEX);
  }
  return h3Index;
}
var INVALID_HEXIDECIMAL_CHAR = /[^0-9a-fA-F]/;
function h3IndexToSplitLong(h3Index) {
  if (Array.isArray(h3Index) && h3Index.length === 2 && Number.isInteger(h3Index[0]) && Number.isInteger(h3Index[1])) {
    return h3Index;
  }
  if (typeof h3Index !== "string" || INVALID_HEXIDECIMAL_CHAR.test(h3Index)) {
    return [0, 0];
  }
  var upper = parseInt(h3Index.substring(0, h3Index.length - 8), BASE_16);
  var lower = parseInt(h3Index.substring(h3Index.length - 8), BASE_16);
  return [lower, upper];
}
function hexFrom32Bit(num) {
  if (num >= 0) {
    return num.toString(BASE_16);
  }
  num = num & 2147483647;
  var tempStr = zeroPad(8, num.toString(BASE_16));
  var topNum = (parseInt(tempStr[0], BASE_16) + 8).toString(BASE_16);
  tempStr = topNum + tempStr.substring(1);
  return tempStr;
}
function splitLongToH3Index(lower, upper) {
  return hexFrom32Bit(upper) + zeroPad(8, hexFrom32Bit(lower));
}
function zeroPad(fullLen, numStr) {
  var numZeroes = fullLen - numStr.length;
  var outStr = "";
  for (var i2 = 0; i2 < numZeroes; i2++) {
    outStr += "0";
  }
  outStr = outStr + numStr;
  return outStr;
}
function readH3IndexFromPointer(cAddress, offset) {
  if (offset === void 0)
    offset = 0;
  var lower = libh3.getValue(cAddress + SZ_H3INDEX * offset, "i32");
  var upper = libh3.getValue(cAddress + SZ_H3INDEX * offset + SZ_INT, "i32");
  return upper ? splitLongToH3Index(lower, upper) : null;
}
function readDoubleFromPointer(cAddress, offset) {
  if (offset === void 0)
    offset = 0;
  return libh3.getValue(cAddress + SZ_DBL * offset, "double");
}
function readInt64AsDoubleFromPointer(cAddress) {
  return H3.readInt64AsDoubleFromPointer(cAddress);
}
function readSingleCoord(cAddress) {
  return radsToDegs(libh3.getValue(cAddress, "double"));
}
function readLatLng(cAddress) {
  return [readSingleCoord(cAddress), readSingleCoord(cAddress + SZ_DBL)];
}
function readLatLngGeoJson(cAddress) {
  return [readSingleCoord(cAddress + SZ_DBL), readSingleCoord(cAddress)];
}
function readCellBoundary(cellBoundary, geoJsonCoords, closedLoop) {
  var numVerts = libh3.getValue(cellBoundary, "i32");
  var vertsPos = cellBoundary + SZ_DBL;
  var out = [];
  var readCoord = geoJsonCoords ? readLatLngGeoJson : readLatLng;
  for (var i2 = 0; i2 < numVerts * 2; i2 += 2) {
    out.push(readCoord(vertsPos + SZ_DBL * i2));
  }
  if (closedLoop) {
    out.push(out[0]);
  }
  return out;
}
function isPentagon(h3Index) {
  var ref = h3IndexToSplitLong(h3Index);
  var lower = ref[0];
  var upper = ref[1];
  return Boolean(H3.isPentagon(lower, upper));
}
function getResolution(h3Index) {
  var ref = h3IndexToSplitLong(h3Index);
  var lower = ref[0];
  var upper = ref[1];
  if (!H3.isValidCell(lower, upper)) {
    return -1;
  }
  return H3.getResolution(lower, upper);
}
function latLngToCell(lat, lng, res) {
  var latLng = libh3._malloc(SZ_LATLNG);
  libh3.HEAPF64.set([lat, lng].map(degsToRads), latLng / SZ_DBL);
  var h3Index = libh3._malloc(SZ_H3INDEX);
  try {
    throwIfError(H3.latLngToCell(latLng, res, h3Index));
    return validateH3Index(readH3IndexFromPointer(h3Index));
  } finally {
    libh3._free(h3Index);
    libh3._free(latLng);
  }
}
function cellToLatLng(h3Index) {
  var latLng = libh3._malloc(SZ_LATLNG);
  var ref = h3IndexToSplitLong(h3Index);
  var lower = ref[0];
  var upper = ref[1];
  try {
    throwIfError(H3.cellToLatLng(lower, upper, latLng));
    return readLatLng(latLng);
  } finally {
    libh3._free(latLng);
  }
}
function cellToBoundary(h3Index, formatAsGeoJson) {
  var cellBoundary = libh3._malloc(SZ_CELLBOUNDARY);
  var ref = h3IndexToSplitLong(h3Index);
  var lower = ref[0];
  var upper = ref[1];
  try {
    throwIfError(H3.cellToBoundary(lower, upper, cellBoundary));
    return readCellBoundary(cellBoundary, formatAsGeoJson, formatAsGeoJson);
  } finally {
    libh3._free(cellBoundary);
  }
}
function gridDistance(origin, destination2) {
  var ref = h3IndexToSplitLong(origin);
  var oLower = ref[0];
  var oUpper = ref[1];
  var ref$1 = h3IndexToSplitLong(destination2);
  var dLower = ref$1[0];
  var dUpper = ref$1[1];
  var countPtr = libh3._malloc(SZ_INT64);
  try {
    throwIfError(H3.gridDistance(oLower, oUpper, dLower, dUpper, countPtr));
    return readInt64AsDoubleFromPointer(countPtr);
  } finally {
    libh3._free(countPtr);
  }
}
function getHexagonEdgeLengthAvg(res, unit) {
  validateRes(res);
  var out = libh3._malloc(SZ_DBL);
  try {
    switch (unit) {
      case UNITS.m:
        throwIfError(H3.getHexagonEdgeLengthAvgM(res, out));
        break;
      case UNITS.km:
        throwIfError(H3.getHexagonEdgeLengthAvgKm(res, out));
        break;
      default:
        throw JSBindingError(E_UNKNOWN_UNIT, unit);
    }
    return readDoubleFromPointer(out);
  } finally {
    libh3._free(out);
  }
}
function degsToRads(deg) {
  return deg * Math.PI / 180;
}
function radsToDegs(rad2) {
  return rad2 * 180 / Math.PI;
}
function normalizeLongitudes(vertices, refLng) {
  refLng = refLng === void 0 ? vertices[0][0] : refLng;
  for (const pt of vertices) {
    const deltaLng = pt[0] - refLng;
    if (deltaLng > 180) {
      pt[0] -= 360;
    } else if (deltaLng < -180) {
      pt[0] += 360;
    }
  }
}
function scalePolygon(hexId, vertices, factor) {
  const [lat, lng] = cellToLatLng(hexId);
  const actualCount = vertices.length;
  normalizeLongitudes(vertices, lng);
  const vertexCount = vertices[0] === vertices[actualCount - 1] ? actualCount - 1 : actualCount;
  for (let i2 = 0; i2 < vertexCount; i2++) {
    vertices[i2][0] = lerp$4(lng, vertices[i2][0], factor);
    vertices[i2][1] = lerp$4(lat, vertices[i2][1], factor);
  }
}
function getHexagonCentroid(getHexagon, object2, objectInfo) {
  const hexagonId = getHexagon(object2, objectInfo);
  const [lat, lng] = cellToLatLng(hexagonId);
  return [lng, lat];
}
function h3ToPolygon(hexId, coverage = 1) {
  const vertices = cellToBoundary(hexId, true);
  if (coverage !== 1) {
    scalePolygon(hexId, vertices, coverage);
  } else {
    normalizeLongitudes(vertices);
  }
  return vertices;
}
function flattenPolygon(vertices) {
  const positions = new Float64Array(vertices.length * 2);
  let i2 = 0;
  for (const pt of vertices) {
    positions[i2++] = pt[0];
    positions[i2++] = pt[1];
  }
  return positions;
}
const UPDATE_THRESHOLD_KM = 10;
function mergeTriggers(getHexagon, coverage) {
  let trigger2;
  if (getHexagon === void 0 || getHexagon === null) {
    trigger2 = coverage;
  } else if (typeof getHexagon === "object") {
    trigger2 = { ...getHexagon, coverage };
  } else {
    trigger2 = { getHexagon, coverage };
  }
  return trigger2;
}
const defaultProps$9 = {
  ...PolygonLayer.defaultProps,
  highPrecision: "auto",
  coverage: { type: "number", min: 0, max: 1, value: 1 },
  centerHexagon: null,
  getHexagon: { type: "accessor", value: (x2) => x2.hexagon },
  extruded: true
};
const _H3HexagonLayer = class extends CompositeLayer {
  initializeState() {
    _H3HexagonLayer._checkH3Lib();
    this.state = {
      edgeLengthKM: 0,
      resolution: -1
    };
  }
  shouldUpdateState({ changeFlags }) {
    return this._shouldUseHighPrecision() ? changeFlags.propsOrDataChanged : changeFlags.somethingChanged;
  }
  updateState({ props, changeFlags }) {
    if (props.highPrecision !== true && (changeFlags.dataChanged || changeFlags.updateTriggersChanged && changeFlags.updateTriggersChanged.getHexagon)) {
      const dataProps = this._calculateH3DataProps();
      this.setState(dataProps);
    }
    this._updateVertices(this.context.viewport);
  }
  _calculateH3DataProps() {
    let resolution = -1;
    let hasPentagon = false;
    let hasMultipleRes = false;
    const { iterable, objectInfo } = createIterable(this.props.data);
    for (const object2 of iterable) {
      objectInfo.index++;
      const hexId = this.props.getHexagon(object2, objectInfo);
      const hexResolution = getResolution(hexId);
      if (resolution < 0) {
        resolution = hexResolution;
        if (!this.props.highPrecision)
          break;
      } else if (resolution !== hexResolution) {
        hasMultipleRes = true;
        break;
      }
      if (isPentagon(hexId)) {
        hasPentagon = true;
        break;
      }
    }
    return {
      resolution,
      edgeLengthKM: resolution >= 0 ? getHexagonEdgeLengthAvg(resolution, "km") : 0,
      hasMultipleRes,
      hasPentagon
    };
  }
  _shouldUseHighPrecision() {
    if (this.props.highPrecision === "auto") {
      const { resolution, hasPentagon, hasMultipleRes } = this.state;
      const { viewport } = this.context;
      return Boolean(viewport == null ? void 0 : viewport.resolution) || hasMultipleRes || hasPentagon || resolution >= 0 && resolution <= 5;
    }
    return this.props.highPrecision;
  }
  _updateVertices(viewport) {
    if (this._shouldUseHighPrecision()) {
      return;
    }
    const { resolution, edgeLengthKM, centerHex } = this.state;
    if (resolution < 0) {
      return;
    }
    const hex = this.props.centerHexagon || latLngToCell(viewport.latitude, viewport.longitude, resolution);
    if (centerHex === hex) {
      return;
    }
    if (centerHex) {
      try {
        const distance11 = gridDistance(centerHex, hex);
        if (distance11 * edgeLengthKM < UPDATE_THRESHOLD_KM) {
          return;
        }
      } catch {
      }
    }
    const { unitsPerMeter: unitsPerMeter2 } = viewport.distanceScales;
    let vertices = h3ToPolygon(hex);
    const [centerLat, centerLng] = cellToLatLng(hex);
    const [centerX, centerY] = viewport.projectFlat([centerLng, centerLat]);
    vertices = vertices.map((p2) => {
      const worldPosition = viewport.projectFlat(p2);
      return [
        (worldPosition[0] - centerX) / unitsPerMeter2[0],
        (worldPosition[1] - centerY) / unitsPerMeter2[1]
      ];
    });
    this.setState({ centerHex: hex, vertices });
  }
  renderLayers() {
    return this._shouldUseHighPrecision() ? this._renderPolygonLayer() : this._renderColumnLayer();
  }
  _getForwardProps() {
    const { elevationScale, material, coverage, extruded, wireframe, stroked, filled, lineWidthUnits, lineWidthScale, lineWidthMinPixels, lineWidthMaxPixels, getFillColor, getElevation, getLineColor, getLineWidth, transitions, updateTriggers } = this.props;
    return {
      elevationScale,
      extruded,
      coverage,
      wireframe,
      stroked,
      filled,
      lineWidthUnits,
      lineWidthScale,
      lineWidthMinPixels,
      lineWidthMaxPixels,
      material,
      getElevation,
      getFillColor,
      getLineColor,
      getLineWidth,
      transitions,
      updateTriggers: {
        getFillColor: updateTriggers.getFillColor,
        getElevation: updateTriggers.getElevation,
        getLineColor: updateTriggers.getLineColor,
        getLineWidth: updateTriggers.getLineWidth
      }
    };
  }
  _renderPolygonLayer() {
    const { data: data2, getHexagon, updateTriggers, coverage } = this.props;
    const SubLayerClass = this.getSubLayerClass("hexagon-cell-hifi", PolygonLayer);
    const forwardProps2 = this._getForwardProps();
    forwardProps2.updateTriggers.getPolygon = mergeTriggers(updateTriggers.getHexagon, coverage);
    return new SubLayerClass(forwardProps2, this.getSubLayerProps({
      id: "hexagon-cell-hifi",
      updateTriggers: forwardProps2.updateTriggers
    }), {
      data: data2,
      _normalize: false,
      _windingOrder: "CCW",
      positionFormat: "XY",
      getPolygon: (object2, objectInfo) => {
        const hexagonId = getHexagon(object2, objectInfo);
        return flattenPolygon(h3ToPolygon(hexagonId, coverage));
      }
    });
  }
  _renderColumnLayer() {
    const { data: data2, getHexagon, updateTriggers } = this.props;
    const SubLayerClass = this.getSubLayerClass("hexagon-cell", ColumnLayer);
    const forwardProps2 = this._getForwardProps();
    forwardProps2.updateTriggers.getPosition = updateTriggers.getHexagon;
    return new SubLayerClass(forwardProps2, this.getSubLayerProps({
      id: "hexagon-cell",
      flatShading: true,
      updateTriggers: forwardProps2.updateTriggers
    }), {
      data: data2,
      diskResolution: 6,
      // generate an extruded hexagon as the base geometry
      radius: 1,
      vertices: this.state.vertices,
      getPosition: getHexagonCentroid.bind(null, getHexagon)
    });
  }
};
let H3HexagonLayer = _H3HexagonLayer;
(() => {
  _H3HexagonLayer.defaultProps = defaultProps$9;
})();
(() => {
  _H3HexagonLayer.layerName = "H3HexagonLayer";
})();
// See `main/bundle.ts`
(() => {
  _H3HexagonLayer._checkH3Lib = () => {
  };
})();
const RADIAN_PER_DEGREE = Math.PI / 180;
const modelMatrix = new Float32Array(16);
const valueArray = new Float32Array(12);
function calculateTransformMatrix(targetMatrix, orientation2, scale5) {
  const pitch = orientation2[0] * RADIAN_PER_DEGREE;
  const yaw = orientation2[1] * RADIAN_PER_DEGREE;
  const roll = orientation2[2] * RADIAN_PER_DEGREE;
  const sr = Math.sin(roll);
  const sp = Math.sin(pitch);
  const sw = Math.sin(yaw);
  const cr = Math.cos(roll);
  const cp = Math.cos(pitch);
  const cw = Math.cos(yaw);
  const scx = scale5[0];
  const scy = scale5[1];
  const scz = scale5[2];
  targetMatrix[0] = scx * cw * cp;
  targetMatrix[1] = scx * sw * cp;
  targetMatrix[2] = scx * -sp;
  targetMatrix[3] = scy * (-sw * cr + cw * sp * sr);
  targetMatrix[4] = scy * (cw * cr + sw * sp * sr);
  targetMatrix[5] = scy * cp * sr;
  targetMatrix[6] = scz * (sw * sr + cw * sp * cr);
  targetMatrix[7] = scz * (-cw * sr + sw * sp * cr);
  targetMatrix[8] = scz * cp * cr;
}
function getExtendedMat3FromMat4(mat4) {
  mat4[0] = mat4[0];
  mat4[1] = mat4[1];
  mat4[2] = mat4[2];
  mat4[3] = mat4[4];
  mat4[4] = mat4[5];
  mat4[5] = mat4[6];
  mat4[6] = mat4[8];
  mat4[7] = mat4[9];
  mat4[8] = mat4[10];
  mat4[9] = mat4[12];
  mat4[10] = mat4[13];
  mat4[11] = mat4[14];
  return mat4.subarray(0, 12);
}
const MATRIX_ATTRIBUTES = {
  size: 12,
  accessor: ["getOrientation", "getScale", "getTranslation", "getTransformMatrix"],
  shaderAttributes: {
    instanceModelMatrixCol0: {
      size: 3,
      elementOffset: 0
    },
    instanceModelMatrixCol1: {
      size: 3,
      elementOffset: 3
    },
    instanceModelMatrixCol2: {
      size: 3,
      elementOffset: 6
    },
    instanceTranslation: {
      size: 3,
      elementOffset: 9
    }
  },
  update(attribute, { startRow, endRow }) {
    const { data: data2, getOrientation, getScale: getScale3, getTranslation, getTransformMatrix } = this.props;
    const arrayMatrix = Array.isArray(getTransformMatrix);
    const constantMatrix = arrayMatrix && getTransformMatrix.length === 16;
    const constantScale = Array.isArray(getScale3);
    const constantOrientation = Array.isArray(getOrientation);
    const constantTranslation = Array.isArray(getTranslation);
    const hasMatrix = constantMatrix || !arrayMatrix && Boolean(getTransformMatrix(data2[0]));
    if (hasMatrix) {
      attribute.constant = constantMatrix;
    } else {
      attribute.constant = constantOrientation && constantScale && constantTranslation;
    }
    const instanceModelMatrixData = attribute.value;
    if (attribute.constant) {
      let matrix;
      if (hasMatrix) {
        modelMatrix.set(getTransformMatrix);
        matrix = getExtendedMat3FromMat4(modelMatrix);
      } else {
        matrix = valueArray;
        const orientation2 = getOrientation;
        const scale5 = getScale3;
        calculateTransformMatrix(matrix, orientation2, scale5);
        matrix.set(getTranslation, 9);
      }
      attribute.value = new Float32Array(matrix);
    } else {
      let i2 = startRow * attribute.size;
      const { iterable, objectInfo } = createIterable(data2, startRow, endRow);
      for (const object2 of iterable) {
        objectInfo.index++;
        let matrix;
        if (hasMatrix) {
          modelMatrix.set(constantMatrix ? getTransformMatrix : getTransformMatrix(object2, objectInfo));
          matrix = getExtendedMat3FromMat4(modelMatrix);
        } else {
          matrix = valueArray;
          const orientation2 = constantOrientation ? getOrientation : getOrientation(object2, objectInfo);
          const scale5 = constantScale ? getScale3 : getScale3(object2, objectInfo);
          calculateTransformMatrix(matrix, orientation2, scale5);
          matrix.set(constantTranslation ? getTranslation : getTranslation(object2, objectInfo), 9);
        }
        instanceModelMatrixData[i2++] = matrix[0];
        instanceModelMatrixData[i2++] = matrix[1];
        instanceModelMatrixData[i2++] = matrix[2];
        instanceModelMatrixData[i2++] = matrix[3];
        instanceModelMatrixData[i2++] = matrix[4];
        instanceModelMatrixData[i2++] = matrix[5];
        instanceModelMatrixData[i2++] = matrix[6];
        instanceModelMatrixData[i2++] = matrix[7];
        instanceModelMatrixData[i2++] = matrix[8];
        instanceModelMatrixData[i2++] = matrix[9];
        instanceModelMatrixData[i2++] = matrix[10];
        instanceModelMatrixData[i2++] = matrix[11];
      }
    }
  }
};
function shouldComposeModelMatrix(viewport, coordinateSystem) {
  return coordinateSystem === COORDINATE_SYSTEM.CARTESIAN || coordinateSystem === COORDINATE_SYSTEM.METER_OFFSETS || coordinateSystem === COORDINATE_SYSTEM.DEFAULT && !viewport.isGeospatial;
}
const vs$5 = `#version 300 es
#define SHADER_NAME simple-mesh-layer-vs
uniform float sizeScale;
uniform bool composeModelMatrix;
in vec3 positions;
in vec3 normals;
in vec3 colors;
in vec2 texCoords;
in vec3 instancePositions;
in vec3 instancePositions64Low;
in vec4 instanceColors;
in vec3 instancePickingColors;
in vec3 instanceModelMatrixCol0;
in vec3 instanceModelMatrixCol1;
in vec3 instanceModelMatrixCol2;
in vec3 instanceTranslation;
out vec2 vTexCoord;
out vec3 cameraPosition;
out vec3 normals_commonspace;
out vec4 position_commonspace;
out vec4 vColor;
void main(void) {
geometry.worldPosition = instancePositions;
geometry.uv = texCoords;
geometry.pickingColor = instancePickingColors;
vTexCoord = texCoords;
cameraPosition = project_uCameraPosition;
vColor = vec4(colors * instanceColors.rgb, instanceColors.a);
mat3 instanceModelMatrix = mat3(instanceModelMatrixCol0, instanceModelMatrixCol1, instanceModelMatrixCol2);
vec3 pos = (instanceModelMatrix * positions) * sizeScale + instanceTranslation;
if (composeModelMatrix) {
DECKGL_FILTER_SIZE(pos, geometry);
normals_commonspace = project_normal(instanceModelMatrix * normals);
geometry.worldPosition += pos;
gl_Position = project_position_to_clipspace(pos + instancePositions, instancePositions64Low, vec3(0.0), position_commonspace);
geometry.position = position_commonspace;
}
else {
pos = project_size(pos);
DECKGL_FILTER_SIZE(pos, geometry);
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, pos, position_commonspace);
geometry.position = position_commonspace;
normals_commonspace = project_normal(instanceModelMatrix * normals);
}
geometry.normal = normals_commonspace;
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;
const fs$5 = `#version 300 es
#define SHADER_NAME simple-mesh-layer-fs
precision highp float;
uniform bool hasTexture;
uniform sampler2D sampler;
uniform bool flatShading;
uniform float opacity;
in vec2 vTexCoord;
in vec3 cameraPosition;
in vec3 normals_commonspace;
in vec4 position_commonspace;
in vec4 vColor;
out vec4 fragColor;
void main(void) {
geometry.uv = vTexCoord;
vec3 normal;
if (flatShading) {
normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));
} else {
normal = normals_commonspace;
}
vec4 color = hasTexture ? texture(sampler, vTexCoord) : vColor;
DECKGL_FILTER_COLOR(color, geometry);
vec3 lightColor = lighting_getLightColor(color.rgb, cameraPosition, position_commonspace.xyz, normal);
fragColor = vec4(lightColor, color.a * opacity);
}
`;
function normalizeGeometryAttributes(attributes) {
  const positionAttribute = attributes.positions || attributes.POSITION;
  log$1.assert(positionAttribute, 'no "postions" or "POSITION" attribute in mesh');
  const vertexCount = positionAttribute.value.length / positionAttribute.size;
  let colorAttribute = attributes.COLOR_0 || attributes.colors;
  if (!colorAttribute) {
    colorAttribute = { size: 3, value: new Float32Array(vertexCount * 3).fill(1) };
  }
  let normalAttribute = attributes.NORMAL || attributes.normals;
  if (!normalAttribute) {
    normalAttribute = { size: 3, value: new Float32Array(vertexCount * 3).fill(0) };
  }
  let texCoordAttribute = attributes.TEXCOORD_0 || attributes.texCoords;
  if (!texCoordAttribute) {
    texCoordAttribute = { size: 2, value: new Float32Array(vertexCount * 2).fill(0) };
  }
  return {
    positions: positionAttribute,
    colors: colorAttribute,
    normals: normalAttribute,
    texCoords: texCoordAttribute
  };
}
function getGeometry(data2) {
  if (data2 instanceof Geometry) {
    data2.attributes = normalizeGeometryAttributes(data2.attributes);
    return data2;
  } else if (data2.attributes) {
    return new Geometry({
      ...data2,
      topology: "triangle-list",
      attributes: normalizeGeometryAttributes(data2.attributes)
    });
  } else {
    return new Geometry({
      topology: "triangle-list",
      attributes: normalizeGeometryAttributes(data2)
    });
  }
}
const DEFAULT_COLOR$1 = [0, 0, 0, 255];
const defaultProps$8 = {
  mesh: { type: "object", value: null, async: true },
  texture: { type: "image", value: null, async: true },
  sizeScale: { type: "number", value: 1, min: 0 },
  // _instanced is a hack to use world position instead of meter offsets in mesh
  // TODO - formalize API
  _instanced: true,
  // NOTE(Tarek): Quick and dirty wireframe. Just draws
  // the same mesh with LINE_STRIPS. Won't follow edges
  // of the original mesh.
  wireframe: false,
  // Optional material for 'lighting' shader module
  material: true,
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getColor: { type: "accessor", value: DEFAULT_COLOR$1 },
  // yaw, pitch and roll are in degrees
  // https://en.wikipedia.org/wiki/Euler_angles
  // [pitch, yaw, roll]
  getOrientation: { type: "accessor", value: [0, 0, 0] },
  getScale: { type: "accessor", value: [1, 1, 1] },
  getTranslation: { type: "accessor", value: [0, 0, 0] },
  // 4x4 matrix
  getTransformMatrix: { type: "accessor", value: [] },
  textureParameters: { type: "object", ignore: true, value: null }
};
const _SimpleMeshLayer = class extends Layer {
  getShaders() {
    return super.getShaders({
      vs: vs$5,
      fs: fs$5,
      modules: [project32, phongLighting, picking]
    });
  }
  getBounds() {
    var _a3;
    if (this.props._instanced) {
      return super.getBounds();
    }
    let result = this.state.positionBounds;
    if (result) {
      return result;
    }
    const { mesh } = this.props;
    if (!mesh) {
      return null;
    }
    result = (_a3 = mesh.header) == null ? void 0 : _a3.boundingBox;
    if (!result) {
      const { attributes } = getGeometry(mesh);
      attributes.POSITION = attributes.POSITION || attributes.positions;
      result = getMeshBoundingBox$1(attributes);
    }
    this.state.positionBounds = result;
    return result;
  }
  initializeState() {
    const attributeManager = this.getAttributeManager();
    attributeManager.addInstanced({
      instancePositions: {
        transition: true,
        type: "float64",
        fp64: this.use64bitPositions(),
        size: 3,
        accessor: "getPosition"
      },
      instanceColors: {
        type: "unorm8",
        transition: true,
        size: this.props.colorFormat.length,
        accessor: "getColor",
        defaultValue: [0, 0, 0, 255]
      },
      instanceModelMatrix: MATRIX_ATTRIBUTES
    });
    this.setState({
      // Avoid luma.gl's missing uniform warning
      // TODO - add feature to luma.gl to specify ignored uniforms?
      emptyTexture: this.context.device.createTexture({
        data: new Uint8Array(4),
        width: 1,
        height: 1
      })
    });
  }
  updateState(params2) {
    var _a3;
    super.updateState(params2);
    const { props, oldProps, changeFlags } = params2;
    if (props.mesh !== oldProps.mesh || changeFlags.extensionsChanged) {
      this.state.positionBounds = null;
      (_a3 = this.state.model) == null ? void 0 : _a3.destroy();
      if (props.mesh) {
        this.state.model = this.getModel(props.mesh);
        const attributes = props.mesh.attributes || props.mesh;
        this.setState({
          hasNormals: Boolean(attributes.NORMAL || attributes.normals)
        });
      }
      this.getAttributeManager().invalidateAll();
    }
    if (props.texture !== oldProps.texture && props.texture instanceof Texture) {
      this.setTexture(props.texture);
    }
    if (this.state.model) {
      this.state.model.setTopology(this.props.wireframe ? "line-strip" : "triangle-list");
    }
  }
  finalizeState(context2) {
    super.finalizeState(context2);
    this.state.emptyTexture.delete();
  }
  draw({ uniforms }) {
    const { model } = this.state;
    if (!model) {
      return;
    }
    const { viewport, renderPass } = this.context;
    const { sizeScale, coordinateSystem, _instanced } = this.props;
    model.setUniforms(uniforms);
    model.setUniforms({
      sizeScale,
      composeModelMatrix: !_instanced || shouldComposeModelMatrix(viewport, coordinateSystem),
      flatShading: !this.state.hasNormals
    });
    model.draw(renderPass);
  }
  get isLoaded() {
    var _a3;
    return Boolean(((_a3 = this.state) == null ? void 0 : _a3.model) && super.isLoaded);
  }
  getModel(mesh) {
    const model = new Model(this.context.device, {
      ...this.getShaders(),
      id: this.props.id,
      bufferLayout: this.getAttributeManager().getBufferLayouts(),
      geometry: getGeometry(mesh),
      isInstanced: true
    });
    const { texture } = this.props;
    const { emptyTexture: emptyTexture2 } = this.state;
    model.setBindings({
      sampler: texture || emptyTexture2
    });
    model.setUniforms({
      hasTexture: Boolean(texture)
    });
    return model;
  }
  setTexture(texture) {
    const { emptyTexture: emptyTexture2, model } = this.state;
    if (model) {
      model.setBindings({
        sampler: texture || emptyTexture2
      });
      model.setUniforms({
        hasTexture: Boolean(texture)
      });
    }
  }
};
let SimpleMeshLayer = _SimpleMeshLayer;
(() => {
  _SimpleMeshLayer.defaultProps = defaultProps$8;
})();
(() => {
  _SimpleMeshLayer.layerName = "SimpleMeshLayer";
})();
var GLEnum$2;
(function(GLEnum2) {
  GLEnum2[GLEnum2["FUNC_ADD"] = 32774] = "FUNC_ADD";
  GLEnum2[GLEnum2["ONE"] = 1] = "ONE";
  GLEnum2[GLEnum2["SRC_ALPHA"] = 770] = "SRC_ALPHA";
  GLEnum2[GLEnum2["ONE_MINUS_SRC_ALPHA"] = 771] = "ONE_MINUS_SRC_ALPHA";
  GLEnum2[GLEnum2["TEXTURE_MIN_FILTER"] = 10241] = "TEXTURE_MIN_FILTER";
  GLEnum2[GLEnum2["LINEAR"] = 9729] = "LINEAR";
  GLEnum2[GLEnum2["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
  GLEnum2[GLEnum2["UNPACK_FLIP_Y_WEBGL"] = 37440] = "UNPACK_FLIP_Y_WEBGL";
})(GLEnum$2 || (GLEnum$2 = {}));
function parsePBRMaterial$1(device, material, attributes, options2) {
  const parsedMaterial = {
    defines: {
      // TODO: Use EXT_sRGB if available (Standard in WebGL 2.0)
      MANUAL_SRGB: 1,
      SRGB_FAST_APPROXIMATION: 1
    },
    bindings: {},
    uniforms: {
      // TODO: find better values?
      u_Camera: [0, 0, 0],
      // Model should override
      u_MetallicRoughnessValues: [1, 1]
      // Default is 1 and 1
    },
    parameters: {},
    glParameters: {},
    generatedTextures: []
  };
  parsedMaterial.defines.USE_TEX_LOD = 1;
  const { imageBasedLightingEnvironment } = options2;
  if (imageBasedLightingEnvironment) {
    parsedMaterial.bindings.u_DiffuseEnvSampler = imageBasedLightingEnvironment.diffuseEnvSampler;
    parsedMaterial.bindings.u_SpecularEnvSampler = imageBasedLightingEnvironment.specularEnvSampler;
    parsedMaterial.bindings.u_brdfLUT = imageBasedLightingEnvironment.brdfLutTexture;
    parsedMaterial.uniforms.u_ScaleIBLAmbient = [1, 1];
  }
  if (options2 == null ? void 0 : options2.pbrDebug) {
    parsedMaterial.defines.PBR_DEBUG = 1;
    parsedMaterial.uniforms.u_ScaleDiffBaseMR = [0, 0, 0, 0];
    parsedMaterial.uniforms.u_ScaleFGDSpec = [0, 0, 0, 0];
  }
  if (attributes.NORMAL)
    parsedMaterial.defines.HAS_NORMALS = 1;
  if (attributes.TANGENT && (options2 == null ? void 0 : options2.useTangents))
    parsedMaterial.defines.HAS_TANGENTS = 1;
  if (attributes.TEXCOORD_0)
    parsedMaterial.defines.HAS_UV = 1;
  if (options2 == null ? void 0 : options2.imageBasedLightingEnvironment)
    parsedMaterial.defines.USE_IBL = 1;
  if (options2 == null ? void 0 : options2.lights)
    parsedMaterial.defines.USE_LIGHTS = 1;
  if (material) {
    parseMaterial$1(device, material, parsedMaterial);
  }
  return parsedMaterial;
}
function parseMaterial$1(device, material, parsedMaterial) {
  parsedMaterial.uniforms.pbr_uUnlit = Boolean(material.unlit);
  if (material.pbrMetallicRoughness) {
    parsePbrMetallicRoughness$1(device, material.pbrMetallicRoughness, parsedMaterial);
  }
  if (material.normalTexture) {
    addTexture$1(device, material.normalTexture, "u_NormalSampler", "HAS_NORMALMAP", parsedMaterial);
    const { scale: scale5 = 1 } = material.normalTexture;
    parsedMaterial.uniforms.u_NormalScale = scale5;
  }
  if (material.occlusionTexture) {
    addTexture$1(device, material.occlusionTexture, "u_OcclusionSampler", "HAS_OCCLUSIONMAP", parsedMaterial);
    const { strength = 1 } = material.occlusionTexture;
    parsedMaterial.uniforms.u_OcclusionStrength = strength;
  }
  if (material.emissiveTexture) {
    addTexture$1(device, material.emissiveTexture, "u_EmissiveSampler", "HAS_EMISSIVEMAP", parsedMaterial);
    parsedMaterial.uniforms.u_EmissiveFactor = material.emissiveFactor || [0, 0, 0];
  }
  switch (material.alphaMode) {
    case "MASK":
      const { alphaCutoff = 0.5 } = material;
      parsedMaterial.defines.ALPHA_CUTOFF = 1;
      parsedMaterial.uniforms.u_AlphaCutoff = alphaCutoff;
      break;
    case "BLEND":
      log.warn("glTF BLEND alphaMode might not work well because it requires mesh sorting")();
      parsedMaterial.parameters.blendColorOperation = "add";
      parsedMaterial.parameters.blendColorSrcFactor = "src-alpha";
      parsedMaterial.parameters.blendColorDstFactor = "one-minus-src-alpha";
      parsedMaterial.parameters.blendAlphaOperation = "add";
      parsedMaterial.parameters.blendAlphaSrcFactor = "one";
      parsedMaterial.parameters.blendAlphaDstFactor = "one-minus-src-alpha";
      parsedMaterial.glParameters.blend = true;
      parsedMaterial.glParameters.blendEquation = GLEnum$2.FUNC_ADD;
      parsedMaterial.glParameters.blendFunc = [
        GLEnum$2.SRC_ALPHA,
        GLEnum$2.ONE_MINUS_SRC_ALPHA,
        GLEnum$2.ONE,
        GLEnum$2.ONE_MINUS_SRC_ALPHA
      ];
      break;
  }
}
function parsePbrMetallicRoughness$1(device, pbrMetallicRoughness, parsedMaterial) {
  if (pbrMetallicRoughness.baseColorTexture) {
    addTexture$1(device, pbrMetallicRoughness.baseColorTexture, "u_BaseColorSampler", "HAS_BASECOLORMAP", parsedMaterial);
  }
  parsedMaterial.uniforms.u_BaseColorFactor = pbrMetallicRoughness.baseColorFactor || [1, 1, 1, 1];
  if (pbrMetallicRoughness.metallicRoughnessTexture) {
    addTexture$1(device, pbrMetallicRoughness.metallicRoughnessTexture, "u_MetallicRoughnessSampler", "HAS_METALROUGHNESSMAP", parsedMaterial);
  }
  const { metallicFactor = 1, roughnessFactor = 1 } = pbrMetallicRoughness;
  parsedMaterial.uniforms.u_MetallicRoughnessValues = [metallicFactor, roughnessFactor];
}
function addTexture$1(device, gltfTexture, uniformName, define2 = null, parsedMaterial) {
  var _a3, _b3;
  const parameters = ((_b3 = (_a3 = gltfTexture == null ? void 0 : gltfTexture.texture) == null ? void 0 : _a3.sampler) == null ? void 0 : _b3.parameters) || {};
  const image = gltfTexture.texture.source.image;
  let textureOptions;
  let specialTextureParameters = {};
  if (image.compressed) {
    textureOptions = image;
    specialTextureParameters = {
      [GLEnum$2.TEXTURE_MIN_FILTER]: image.data.length > 1 ? GLEnum$2.LINEAR_MIPMAP_NEAREST : GLEnum$2.LINEAR
    };
  } else {
    textureOptions = { data: image };
  }
  const texture = device.createTexture({
    id: gltfTexture.uniformName || gltfTexture.id,
    parameters: {
      ...parameters,
      ...specialTextureParameters
    },
    pixelStore: {
      [GLEnum$2.UNPACK_FLIP_Y_WEBGL]: false
    },
    ...textureOptions
  });
  parsedMaterial.bindings[uniformName] = texture;
  if (define2)
    parsedMaterial.defines[define2] = 1;
  parsedMaterial.generatedTextures.push(texture);
}
const VERSION$a = "4.2.0";
const BASIS_EXTERNAL_LIBRARIES$1 = {
  /** Basis transcoder, javascript wrapper part */
  TRANSCODER: "basis_transcoder.js",
  /** Basis transcoder, compiled web assembly part */
  TRANSCODER_WASM: "basis_transcoder.wasm",
  /** Basis encoder, javascript wrapper part */
  ENCODER: "basis_encoder.js",
  /** Basis encoder, compiled web assembly part */
  ENCODER_WASM: "basis_encoder.wasm"
};
let loadBasisTranscoderPromise$1;
async function loadBasisTranscoderModule$1(options2) {
  registerJSModules$1(options2.modules);
  const basis = getJSModuleOrNull$1("basis");
  if (basis) {
    return basis;
  }
  loadBasisTranscoderPromise$1 || (loadBasisTranscoderPromise$1 = loadBasisTranscoder$1(options2));
  return await loadBasisTranscoderPromise$1;
}
async function loadBasisTranscoder$1(options2) {
  let BASIS = null;
  let wasmBinary = null;
  [BASIS, wasmBinary] = await Promise.all([
    await loadLibrary$1(BASIS_EXTERNAL_LIBRARIES$1.TRANSCODER, "textures", options2),
    await loadLibrary$1(BASIS_EXTERNAL_LIBRARIES$1.TRANSCODER_WASM, "textures", options2)
  ]);
  BASIS = BASIS || globalThis.BASIS;
  return await initializeBasisTranscoderModule$1(BASIS, wasmBinary);
}
function initializeBasisTranscoderModule$1(BasisModule, wasmBinary) {
  const options2 = {};
  if (wasmBinary) {
    options2.wasmBinary = wasmBinary;
  }
  return new Promise((resolve2) => {
    BasisModule(options2).then((module2) => {
      const { BasisFile, initializeBasis } = module2;
      initializeBasis();
      resolve2({ BasisFile });
    });
  });
}
let loadBasisEncoderPromise$1;
async function loadBasisEncoderModule$1(options2) {
  const modules = options2.modules || {};
  if (modules.basisEncoder) {
    return modules.basisEncoder;
  }
  loadBasisEncoderPromise$1 = loadBasisEncoderPromise$1 || loadBasisEncoder$1(options2);
  return await loadBasisEncoderPromise$1;
}
async function loadBasisEncoder$1(options2) {
  let BASIS_ENCODER = null;
  let wasmBinary = null;
  [BASIS_ENCODER, wasmBinary] = await Promise.all([
    await loadLibrary$1(BASIS_EXTERNAL_LIBRARIES$1.ENCODER, "textures", options2),
    await loadLibrary$1(BASIS_EXTERNAL_LIBRARIES$1.ENCODER_WASM, "textures", options2)
  ]);
  BASIS_ENCODER = BASIS_ENCODER || globalThis.BASIS;
  return await initializeBasisEncoderModule$1(BASIS_ENCODER, wasmBinary);
}
function initializeBasisEncoderModule$1(BasisEncoderModule, wasmBinary) {
  const options2 = {};
  if (wasmBinary) {
    options2.wasmBinary = wasmBinary;
  }
  return new Promise((resolve2) => {
    BasisEncoderModule(options2).then((module2) => {
      const { BasisFile, KTX2File, initializeBasis, BasisEncoder } = module2;
      initializeBasis();
      resolve2({ BasisFile, KTX2File, BasisEncoder });
    });
  });
}
const GL_EXTENSIONS_CONSTANTS$1 = {
  // WEBGL_compressed_texture_s3tc
  COMPRESSED_RGB_S3TC_DXT1_EXT: 33776,
  COMPRESSED_RGBA_S3TC_DXT1_EXT: 33777,
  COMPRESSED_RGBA_S3TC_DXT3_EXT: 33778,
  COMPRESSED_RGBA_S3TC_DXT5_EXT: 33779,
  // WEBGL_compressed_texture_es3
  COMPRESSED_R11_EAC: 37488,
  COMPRESSED_SIGNED_R11_EAC: 37489,
  COMPRESSED_RG11_EAC: 37490,
  COMPRESSED_SIGNED_RG11_EAC: 37491,
  COMPRESSED_RGB8_ETC2: 37492,
  COMPRESSED_RGBA8_ETC2_EAC: 37493,
  COMPRESSED_SRGB8_ETC2: 37494,
  COMPRESSED_SRGB8_ALPHA8_ETC2_EAC: 37495,
  COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37496,
  COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37497,
  // WEBGL_compressed_texture_pvrtc
  COMPRESSED_RGB_PVRTC_4BPPV1_IMG: 35840,
  COMPRESSED_RGBA_PVRTC_4BPPV1_IMG: 35842,
  COMPRESSED_RGB_PVRTC_2BPPV1_IMG: 35841,
  COMPRESSED_RGBA_PVRTC_2BPPV1_IMG: 35843,
  // WEBGL_compressed_texture_etc1
  COMPRESSED_RGB_ETC1_WEBGL: 36196,
  // WEBGL_compressed_texture_atc
  COMPRESSED_RGB_ATC_WEBGL: 35986,
  COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL: 35987,
  COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL: 34798,
  // WEBGL_compressed_texture_astc
  COMPRESSED_RGBA_ASTC_4X4_KHR: 37808,
  COMPRESSED_RGBA_ASTC_5X4_KHR: 37809,
  COMPRESSED_RGBA_ASTC_5X5_KHR: 37810,
  COMPRESSED_RGBA_ASTC_6X5_KHR: 37811,
  COMPRESSED_RGBA_ASTC_6X6_KHR: 37812,
  COMPRESSED_RGBA_ASTC_8X5_KHR: 37813,
  COMPRESSED_RGBA_ASTC_8X6_KHR: 37814,
  COMPRESSED_RGBA_ASTC_8X8_KHR: 37815,
  COMPRESSED_RGBA_ASTC_10X5_KHR: 37816,
  COMPRESSED_RGBA_ASTC_10X6_KHR: 37817,
  COMPRESSED_RGBA_ASTC_10X8_KHR: 37818,
  COMPRESSED_RGBA_ASTC_10X10_KHR: 37819,
  COMPRESSED_RGBA_ASTC_12X10_KHR: 37820,
  COMPRESSED_RGBA_ASTC_12X12_KHR: 37821,
  COMPRESSED_SRGB8_ALPHA8_ASTC_4X4_KHR: 37840,
  COMPRESSED_SRGB8_ALPHA8_ASTC_5X4_KHR: 37841,
  COMPRESSED_SRGB8_ALPHA8_ASTC_5X5_KHR: 37842,
  COMPRESSED_SRGB8_ALPHA8_ASTC_6X5_KHR: 37843,
  COMPRESSED_SRGB8_ALPHA8_ASTC_6X6_KHR: 37844,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X5_KHR: 37845,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X6_KHR: 37846,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X8_KHR: 37847,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X5_KHR: 37848,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X6_KHR: 37849,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X8_KHR: 37850,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X10_KHR: 37851,
  COMPRESSED_SRGB8_ALPHA8_ASTC_12X10_KHR: 37852,
  COMPRESSED_SRGB8_ALPHA8_ASTC_12X12_KHR: 37853,
  // EXT_texture_compression_rgtc
  COMPRESSED_RED_RGTC1_EXT: 36283,
  COMPRESSED_SIGNED_RED_RGTC1_EXT: 36284,
  COMPRESSED_RED_GREEN_RGTC2_EXT: 36285,
  COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT: 36286,
  // WEBGL_compressed_texture_s3tc_srgb
  COMPRESSED_SRGB_S3TC_DXT1_EXT: 35916,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT: 35917,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT: 35918,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT: 35919
};
const BROWSER_PREFIXES$1 = ["", "WEBKIT_", "MOZ_"];
const WEBGL_EXTENSIONS$1 = {
  /* eslint-disable camelcase */
  WEBGL_compressed_texture_s3tc: "dxt",
  WEBGL_compressed_texture_s3tc_srgb: "dxt-srgb",
  WEBGL_compressed_texture_etc1: "etc1",
  WEBGL_compressed_texture_etc: "etc2",
  WEBGL_compressed_texture_pvrtc: "pvrtc",
  WEBGL_compressed_texture_atc: "atc",
  WEBGL_compressed_texture_astc: "astc",
  EXT_texture_compression_rgtc: "rgtc"
  /* eslint-enable camelcase */
};
let formats$1 = null;
function getSupportedGPUTextureFormats$1(gl) {
  if (!formats$1) {
    gl = gl || getWebGLContext$1() || void 0;
    formats$1 = /* @__PURE__ */ new Set();
    for (const prefix of BROWSER_PREFIXES$1) {
      for (const extension in WEBGL_EXTENSIONS$1) {
        if (gl && gl.getExtension(`${prefix}${extension}`)) {
          const gpuTextureFormat = WEBGL_EXTENSIONS$1[extension];
          formats$1.add(gpuTextureFormat);
        }
      }
    }
  }
  return formats$1;
}
function getWebGLContext$1() {
  try {
    const canvas2 = document.createElement("canvas");
    return canvas2.getContext("webgl");
  } catch (error2) {
    return null;
  }
}
var n$1, i$4, s, a$2, r, o, l$1, f$1;
!function(t2) {
  t2[t2.NONE = 0] = "NONE", t2[t2.BASISLZ = 1] = "BASISLZ", t2[t2.ZSTD = 2] = "ZSTD", t2[t2.ZLIB = 3] = "ZLIB";
}(n$1 || (n$1 = {})), function(t2) {
  t2[t2.BASICFORMAT = 0] = "BASICFORMAT";
}(i$4 || (i$4 = {})), function(t2) {
  t2[t2.UNSPECIFIED = 0] = "UNSPECIFIED", t2[t2.ETC1S = 163] = "ETC1S", t2[t2.UASTC = 166] = "UASTC";
}(s || (s = {})), function(t2) {
  t2[t2.UNSPECIFIED = 0] = "UNSPECIFIED", t2[t2.SRGB = 1] = "SRGB";
}(a$2 || (a$2 = {})), function(t2) {
  t2[t2.UNSPECIFIED = 0] = "UNSPECIFIED", t2[t2.LINEAR = 1] = "LINEAR", t2[t2.SRGB = 2] = "SRGB", t2[t2.ITU = 3] = "ITU", t2[t2.NTSC = 4] = "NTSC", t2[t2.SLOG = 5] = "SLOG", t2[t2.SLOG2 = 6] = "SLOG2";
}(r || (r = {})), function(t2) {
  t2[t2.ALPHA_STRAIGHT = 0] = "ALPHA_STRAIGHT", t2[t2.ALPHA_PREMULTIPLIED = 1] = "ALPHA_PREMULTIPLIED";
}(o || (o = {})), function(t2) {
  t2[t2.RGB = 0] = "RGB", t2[t2.RRR = 3] = "RRR", t2[t2.GGG = 4] = "GGG", t2[t2.AAA = 15] = "AAA";
}(l$1 || (l$1 = {})), function(t2) {
  t2[t2.RGB = 0] = "RGB", t2[t2.RGBA = 3] = "RGBA", t2[t2.RRR = 4] = "RRR", t2[t2.RRRG = 5] = "RRRG";
}(f$1 || (f$1 = {}));
const KTX2_ID$1 = [
  // '´', 'K', 'T', 'X', '2', '0', 'ª', '\r', '\n', '\x1A', '\n'
  171,
  75,
  84,
  88,
  32,
  50,
  48,
  187,
  13,
  10,
  26,
  10
];
function isKTX$1(data2) {
  const id = new Uint8Array(data2);
  const notKTX = id.byteLength < KTX2_ID$1.length || id[0] !== KTX2_ID$1[0] || // '´'
  id[1] !== KTX2_ID$1[1] || // 'K'
  id[2] !== KTX2_ID$1[2] || // 'T'
  id[3] !== KTX2_ID$1[3] || // 'X'
  id[4] !== KTX2_ID$1[4] || // ' '
  id[5] !== KTX2_ID$1[5] || // '2'
  id[6] !== KTX2_ID$1[6] || // '0'
  id[7] !== KTX2_ID$1[7] || // 'ª'
  id[8] !== KTX2_ID$1[8] || // '\r'
  id[9] !== KTX2_ID$1[9] || // '\n'
  id[10] !== KTX2_ID$1[10] || // '\x1A'
  id[11] !== KTX2_ID$1[11];
  return !notKTX;
}
const OutputFormat$1 = {
  etc1: {
    basisFormat: 0,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS$1.COMPRESSED_RGB_ETC1_WEBGL
  },
  etc2: { basisFormat: 1, compressed: true },
  bc1: {
    basisFormat: 2,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS$1.COMPRESSED_RGB_S3TC_DXT1_EXT
  },
  bc3: {
    basisFormat: 3,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS$1.COMPRESSED_RGBA_S3TC_DXT5_EXT
  },
  bc4: { basisFormat: 4, compressed: true },
  bc5: { basisFormat: 5, compressed: true },
  "bc7-m6-opaque-only": { basisFormat: 6, compressed: true },
  "bc7-m5": { basisFormat: 7, compressed: true },
  "pvrtc1-4-rgb": {
    basisFormat: 8,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS$1.COMPRESSED_RGB_PVRTC_4BPPV1_IMG
  },
  "pvrtc1-4-rgba": {
    basisFormat: 9,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS$1.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
  },
  "astc-4x4": {
    basisFormat: 10,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS$1.COMPRESSED_RGBA_ASTC_4X4_KHR
  },
  "atc-rgb": { basisFormat: 11, compressed: true },
  "atc-rgba-interpolated-alpha": { basisFormat: 12, compressed: true },
  rgba32: { basisFormat: 13, compressed: false },
  rgb565: { basisFormat: 14, compressed: false },
  bgr565: { basisFormat: 15, compressed: false },
  rgba4444: { basisFormat: 16, compressed: false }
};
async function parseBasis$1(data2, options2) {
  if (options2.basis.containerFormat === "auto") {
    if (isKTX$1(data2)) {
      const fileConstructors = await loadBasisEncoderModule$1(options2);
      return parseKTX2File$1(fileConstructors.KTX2File, data2, options2);
    }
    const { BasisFile } = await loadBasisTranscoderModule$1(options2);
    return parseBasisFile$1(BasisFile, data2, options2);
  }
  switch (options2.basis.module) {
    case "encoder":
      const fileConstructors = await loadBasisEncoderModule$1(options2);
      switch (options2.basis.containerFormat) {
        case "ktx2":
          return parseKTX2File$1(fileConstructors.KTX2File, data2, options2);
        case "basis":
        default:
          return parseBasisFile$1(fileConstructors.BasisFile, data2, options2);
      }
    case "transcoder":
    default:
      const { BasisFile } = await loadBasisTranscoderModule$1(options2);
      return parseBasisFile$1(BasisFile, data2, options2);
  }
}
function parseBasisFile$1(BasisFile, data2, options2) {
  const basisFile = new BasisFile(new Uint8Array(data2));
  try {
    if (!basisFile.startTranscoding()) {
      throw new Error("Failed to start basis transcoding");
    }
    const imageCount = basisFile.getNumImages();
    const images = [];
    for (let imageIndex = 0; imageIndex < imageCount; imageIndex++) {
      const levelsCount = basisFile.getNumLevels(imageIndex);
      const levels = [];
      for (let levelIndex = 0; levelIndex < levelsCount; levelIndex++) {
        levels.push(transcodeImage$1(basisFile, imageIndex, levelIndex, options2));
      }
      images.push(levels);
    }
    return images;
  } finally {
    basisFile.close();
    basisFile.delete();
  }
}
function transcodeImage$1(basisFile, imageIndex, levelIndex, options2) {
  const width = basisFile.getImageWidth(imageIndex, levelIndex);
  const height = basisFile.getImageHeight(imageIndex, levelIndex);
  const hasAlpha = basisFile.getHasAlpha(
    /* imageIndex, levelIndex */
  );
  const { compressed, format, basisFormat } = getBasisOptions$1(options2, hasAlpha);
  const decodedSize = basisFile.getImageTranscodedSizeInBytes(imageIndex, levelIndex, basisFormat);
  const decodedData = new Uint8Array(decodedSize);
  if (!basisFile.transcodeImage(decodedData, imageIndex, levelIndex, basisFormat, 0, 0)) {
    throw new Error("failed to start Basis transcoding");
  }
  return {
    // standard loaders.gl image category payload
    width,
    height,
    data: decodedData,
    compressed,
    format,
    // Additional fields
    // Add levelSize field.
    hasAlpha
  };
}
function parseKTX2File$1(KTX2File, data2, options2) {
  const ktx2File = new KTX2File(new Uint8Array(data2));
  try {
    if (!ktx2File.startTranscoding()) {
      throw new Error("failed to start KTX2 transcoding");
    }
    const levelsCount = ktx2File.getLevels();
    const levels = [];
    for (let levelIndex = 0; levelIndex < levelsCount; levelIndex++) {
      levels.push(transcodeKTX2Image$1(ktx2File, levelIndex, options2));
      break;
    }
    return [levels];
  } finally {
    ktx2File.close();
    ktx2File.delete();
  }
}
function transcodeKTX2Image$1(ktx2File, levelIndex, options2) {
  const { alphaFlag, height, width } = ktx2File.getImageLevelInfo(levelIndex, 0, 0);
  const { compressed, format, basisFormat } = getBasisOptions$1(options2, alphaFlag);
  const decodedSize = ktx2File.getImageTranscodedSizeInBytes(levelIndex, 0, 0, basisFormat);
  const decodedData = new Uint8Array(decodedSize);
  if (!ktx2File.transcodeImage(
    decodedData,
    levelIndex,
    0,
    0,
    basisFormat,
    0,
    -1,
    -1
    /* channel1 */
  )) {
    throw new Error("Failed to transcode KTX2 image");
  }
  return {
    // standard loaders.gl image category payload
    width,
    height,
    data: decodedData,
    compressed,
    // Additional fields
    levelSize: decodedSize,
    hasAlpha: alphaFlag,
    format
  };
}
function getBasisOptions$1(options2, hasAlpha) {
  let format = options2 && options2.basis && options2.basis.format;
  if (format === "auto") {
    format = selectSupportedBasisFormat$1();
  }
  if (typeof format === "object") {
    format = hasAlpha ? format.alpha : format.noAlpha;
  }
  format = format.toLowerCase();
  return OutputFormat$1[format];
}
function selectSupportedBasisFormat$1() {
  const supportedFormats = getSupportedGPUTextureFormats$1();
  if (supportedFormats.has("astc")) {
    return "astc-4x4";
  } else if (supportedFormats.has("dxt")) {
    return {
      alpha: "bc3",
      noAlpha: "bc1"
    };
  } else if (supportedFormats.has("pvrtc")) {
    return {
      alpha: "pvrtc1-4-rgba",
      noAlpha: "pvrtc1-4-rgb"
    };
  } else if (supportedFormats.has("etc1")) {
    return "etc1";
  } else if (supportedFormats.has("etc2")) {
    return "etc2";
  }
  return "rgb565";
}
const BasisWorkerLoader$1 = {
  dataType: null,
  batchType: null,
  name: "Basis",
  id: "basis",
  module: "textures",
  version: VERSION$a,
  worker: true,
  extensions: ["basis", "ktx2"],
  mimeTypes: ["application/octet-stream", "image/ktx2"],
  tests: ["sB"],
  binary: true,
  options: {
    basis: {
      format: "auto",
      libraryPath: "libs/",
      containerFormat: "auto",
      module: "transcoder"
    }
  }
};
const BasisLoader$1 = {
  ...BasisWorkerLoader$1,
  parse: parseBasis$1
};
const ATTRIBUTE_TYPE_TO_COMPONENTS$4 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$4 = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
class GLTFAnimation {
  constructor(props) {
    __publicField2(this, "name");
    __publicField2(this, "startTime", 0);
    __publicField2(this, "playing", true);
    __publicField2(this, "speed", 1);
    __publicField2(this, "channels", []);
    Object.assign(this, props);
  }
  animate(timeMs) {
    if (!this.playing) {
      return;
    }
    const absTime = timeMs / 1e3;
    const time2 = (absTime - this.startTime) * this.speed;
    this.channels.forEach(({ sampler, target, path: path2 }) => {
      interpolate(time2, sampler, target, path2);
      applyTranslationRotationScale(target, target._node);
    });
  }
}
class GLTFAnimator {
  constructor(gltf) {
    __publicField2(this, "animations");
    this.animations = gltf.animations.map((animation, index2) => {
      const name2 = animation.name || `Animation-${index2}`;
      const samplers = animation.samplers.map(({ input, interpolation = "LINEAR", output: output2 }) => ({
        input: accessorToJsArray(gltf.accessors[input]),
        interpolation,
        output: accessorToJsArray(gltf.accessors[output2])
      }));
      const channels = animation.channels.map(({ sampler, target }) => ({
        sampler: samplers[sampler],
        target: gltf.nodes[target.node],
        path: target.path
      }));
      return new GLTFAnimation({ name: name2, channels });
    });
  }
  /** @deprecated Use .setTime(). Will be removed (deck.gl is using this) */
  animate(time2) {
    this.setTime(time2);
  }
  setTime(time2) {
    this.animations.forEach((animation) => animation.animate(time2));
  }
  getAnimations() {
    return this.animations;
  }
}
function accessorToJsArray(accessor) {
  if (!accessor._animation) {
    const ArrayType2 = ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$4[accessor.componentType];
    const components = ATTRIBUTE_TYPE_TO_COMPONENTS$4[accessor.type];
    const length2 = components * accessor.count;
    const { buffer: buffer3, byteOffset } = accessor.bufferView.data;
    const array2 = new ArrayType2(buffer3, byteOffset + (accessor.byteOffset || 0), length2);
    if (components === 1) {
      accessor._animation = Array.from(array2);
    } else {
      const slicedArray = [];
      for (let i2 = 0; i2 < array2.length; i2 += components) {
        slicedArray.push(Array.from(array2.slice(i2, i2 + components)));
      }
      accessor._animation = slicedArray;
    }
  }
  return accessor._animation;
}
const helperMatrix = new Matrix4();
function applyTranslationRotationScale(gltfNode, node) {
  node.matrix.identity();
  if (gltfNode.translation) {
    node.matrix.translate(gltfNode.translation);
  }
  if (gltfNode.rotation) {
    const rotationMatrix = helperMatrix.fromQuaternion(gltfNode.rotation);
    node.matrix.multiplyRight(rotationMatrix);
  }
  if (gltfNode.scale) {
    node.matrix.scale(gltfNode.scale);
  }
}
const quaternion = new Quaternion();
function linearInterpolate(target, path2, start2, stop, ratio) {
  if (path2 === "rotation") {
    quaternion.slerp({ start: start2, target: stop, ratio });
    for (let i2 = 0; i2 < quaternion.length; i2++) {
      target[path2][i2] = quaternion[i2];
    }
  } else {
    for (let i2 = 0; i2 < start2.length; i2++) {
      target[path2][i2] = ratio * stop[i2] + (1 - ratio) * start2[i2];
    }
  }
}
function cubicsplineInterpolate(target, path2, { p0, outTangent0, inTangent1, p1, tDiff, ratio: t2 }) {
  for (let i2 = 0; i2 < target[path2].length; i2++) {
    const m0 = outTangent0[i2] * tDiff;
    const m1 = inTangent1[i2] * tDiff;
    target[path2][i2] = (2 * Math.pow(t2, 3) - 3 * Math.pow(t2, 2) + 1) * p0[i2] + (Math.pow(t2, 3) - 2 * Math.pow(t2, 2) + t2) * m0 + (-2 * Math.pow(t2, 3) + 3 * Math.pow(t2, 2)) * p1[i2] + (Math.pow(t2, 3) - Math.pow(t2, 2)) * m1;
  }
}
function stepInterpolate(target, path2, value) {
  for (let i2 = 0; i2 < value.length; i2++) {
    target[path2][i2] = value[i2];
  }
}
function interpolate(time2, { input, interpolation, output: output2 }, target, path2) {
  const maxTime = input[input.length - 1];
  const animationTime = time2 % maxTime;
  const nextIndex = input.findIndex((t2) => t2 >= animationTime);
  const previousIndex = Math.max(0, nextIndex - 1);
  if (!Array.isArray(target[path2])) {
    switch (path2) {
      case "translation":
        target[path2] = [0, 0, 0];
        break;
      case "rotation":
        target[path2] = [0, 0, 0, 1];
        break;
      case "scale":
        target[path2] = [1, 1, 1];
        break;
      default:
        log.warn(`Bad animation path ${path2}`)();
    }
  }
  assert$a(target[path2].length === output2[previousIndex].length);
  const previousTime = input[previousIndex];
  const nextTime = input[nextIndex];
  switch (interpolation) {
    case "STEP":
      stepInterpolate(target, path2, output2[previousIndex]);
      break;
    case "LINEAR":
      if (nextTime > previousTime) {
        const ratio = (animationTime - previousTime) / (nextTime - previousTime);
        linearInterpolate(target, path2, output2[previousIndex], output2[nextIndex], ratio);
      }
      break;
    case "CUBICSPLINE":
      if (nextTime > previousTime) {
        const ratio = (animationTime - previousTime) / (nextTime - previousTime);
        const tDiff = nextTime - previousTime;
        const p0 = output2[3 * previousIndex + 1];
        const outTangent0 = output2[3 * previousIndex + 2];
        const inTangent1 = output2[3 * nextIndex + 0];
        const p1 = output2[3 * nextIndex + 1];
        cubicsplineInterpolate(target, path2, { p0, outTangent0, inTangent1, p1, tDiff, ratio });
      }
      break;
    default:
      log.warn(`Interpolation ${interpolation} not supported`)();
      break;
  }
}
const vs$4 = `
#pragma vscode_glsllint_stage: vert
#if (__VERSION__ < 300)
  #define _attr attribute
#else
  #define _attr in
#endif

  // _attr vec4 POSITION;
  _attr vec4 positions;

  #ifdef HAS_NORMALS
    // _attr vec4 NORMAL;
    _attr vec4 normals;
  #endif

  #ifdef HAS_TANGENTS
    _attr vec4 TANGENT;
  #endif

  #ifdef HAS_UV
    // _attr vec2 TEXCOORD_0;
    _attr vec2 texCoords;
  #endif

  void main(void) {
    vec4 _NORMAL = vec4(0.);
    vec4 _TANGENT = vec4(0.);
    vec2 _TEXCOORD_0 = vec2(0.);

    #ifdef HAS_NORMALS
      _NORMAL = normals;
    #endif

    #ifdef HAS_TANGENTS
      _TANGENT = TANGENT;
    #endif

    #ifdef HAS_UV
      _TEXCOORD_0 = texCoords;
    #endif

    pbr_setPositionNormalTangentUV(positions, _NORMAL, _TANGENT, _TEXCOORD_0);
    gl_Position = u_MVPMatrix * positions;
  }
`;
const fs$4 = `
#pragma vscode_glsllint_stage: frag
#if (__VERSION__ < 300)
  #define fragmentColor gl_FragColor
#else
  out vec4 fragmentColor;
#endif

  void main(void) {
    vec3 pos = pbr_vPosition;
    fragmentColor = pbr_filterColor(vec4(1.0));
  }
`;
function createGLTFModel(device, options2) {
  const { id, geometry: geometry2, material, vertexCount, materialOptions, modelOptions } = options2;
  const parsedMaterial = parsePBRMaterial$1(device, material, geometry2.attributes, materialOptions);
  log.info(4, "createGLTFModel defines: ", parsedMaterial.defines)();
  const managedResources = [];
  const parameters = {
    depthWriteEnabled: true,
    depthCompare: "less",
    depthFormat: "depth24plus",
    cullMode: "back"
  };
  const modelProps = {
    id,
    geometry: geometry2,
    topology: geometry2.topology,
    vertexCount,
    modules: [pbr$1],
    vs: addVersionToShader(device, vs$4),
    fs: addVersionToShader(device, fs$4),
    ...modelOptions,
    bindings: { ...parsedMaterial.bindings, ...modelOptions.bindings },
    defines: { ...parsedMaterial.defines, ...modelOptions.defines },
    parameters: { ...parameters, ...parsedMaterial.parameters, ...modelOptions.parameters },
    uniforms: { ...parsedMaterial.uniforms, ...modelOptions.uniforms }
  };
  const model = new Model(device, modelProps);
  return new ModelNode({ managedResources, model });
}
function addVersionToShader(device, source) {
  return `#version 300 es
${source}`;
}
const DEFAULT_OPTIONS = {
  modelOptions: {},
  pbrDebug: false,
  imageBasedLightingEnvironment: null,
  lights: true,
  useTangents: false
};
class GLTFInstantiator {
  constructor(device, options2 = {}) {
    __publicField2(this, "device");
    __publicField2(this, "options");
    __publicField2(this, "gltf");
    this.device = device;
    this.options = { ...DEFAULT_OPTIONS, ...options2 };
  }
  instantiate(gltf) {
    this.gltf = gltf;
    const scenes = (gltf.scenes || []).map((scene) => this.createScene(scene));
    return scenes;
  }
  createAnimator() {
    if (Array.isArray(this.gltf.animations)) {
      return new GLTFAnimator(this.gltf);
    }
    return null;
  }
  createScene(gltfScene) {
    const gltfNodes = gltfScene.nodes || [];
    const nodes = gltfNodes.map((node) => this.createNode(node));
    const scene = new GroupNode({
      id: gltfScene.name || gltfScene.id,
      children: nodes
    });
    return scene;
  }
  createNode(gltfNode) {
    if (!gltfNode._node) {
      const gltfChildren = gltfNode.children || [];
      const children = gltfChildren.map((child) => this.createNode(child));
      if (gltfNode.mesh) {
        children.push(this.createMesh(gltfNode.mesh));
      }
      const node = new GroupNode({
        id: gltfNode.name || gltfNode.id,
        children
      });
      if (gltfNode.matrix) {
        node.setMatrix(gltfNode.matrix);
      } else {
        node.matrix.identity();
        if (gltfNode.translation) {
          node.matrix.translate(gltfNode.translation);
        }
        if (gltfNode.rotation) {
          const rotationMatrix = new Matrix4().fromQuaternion(gltfNode.rotation);
          node.matrix.multiplyRight(rotationMatrix);
        }
        if (gltfNode.scale) {
          node.matrix.scale(gltfNode.scale);
        }
      }
      gltfNode._node = node;
    }
    return gltfNode._node;
  }
  createMesh(gltfMesh) {
    if (!gltfMesh._mesh) {
      const gltfPrimitives = gltfMesh.primitives || [];
      const primitives = gltfPrimitives.map((gltfPrimitive, i2) => this.createPrimitive(gltfPrimitive, i2, gltfMesh));
      const mesh = new GroupNode({
        id: gltfMesh.name || gltfMesh.id,
        children: primitives
      });
      gltfMesh._mesh = mesh;
    }
    return gltfMesh._mesh;
  }
  createPrimitive(gltfPrimitive, i2, gltfMesh) {
    const id = gltfPrimitive.name || `${gltfMesh.name || gltfMesh.id}-primitive-${i2}`;
    const topology = convertGLDrawModeToTopology(gltfPrimitive.mode || 4);
    const vertexCount = gltfPrimitive.indices ? gltfPrimitive.indices.count : this.getVertexCount(gltfPrimitive.attributes);
    const modelNode = createGLTFModel(this.device, {
      id,
      geometry: this.createGeometry(id, gltfPrimitive, topology),
      material: gltfPrimitive.material,
      materialOptions: this.options,
      modelOptions: this.options.modelOptions,
      vertexCount
    });
    modelNode.bounds = [
      gltfPrimitive.attributes.POSITION.min,
      gltfPrimitive.attributes.POSITION.max
    ];
    return modelNode;
  }
  getVertexCount(attributes) {
    throw new Error("getVertexCount not implemented");
  }
  createGeometry(id, gltfPrimitive, topology) {
    const attributes = {};
    for (const [attributeName, attribute] of Object.entries(gltfPrimitive.attributes)) {
      const { components, size: size12, value } = attribute;
      attributes[attributeName] = { size: size12 ?? components, value };
    }
    return new Geometry({
      id,
      topology,
      indices: gltfPrimitive.indices.value,
      attributes
    });
  }
  createBuffer(attribute, usage) {
    if (!attribute.bufferView) {
      attribute.bufferView = {};
    }
    const { bufferView } = attribute;
    if (!bufferView.lumaBuffers) {
      bufferView.lumaBuffers = {};
    }
    if (!bufferView.lumaBuffers[usage]) {
      bufferView.lumaBuffers[usage] = this.device.createBuffer({
        id: `from-${bufferView.id}`,
        // Draco decoded files have attribute.value
        data: bufferView.data || attribute.value
      });
    }
    return bufferView.lumaBuffers[usage];
  }
  // TODO - create sampler in WebGL2
  createSampler(gltfSampler) {
    return gltfSampler;
  }
  // Helper methods (move to GLTFLoader.resolve...?)
  needsPOT() {
    return false;
  }
}
var GLEnum$1;
(function(GLEnum2) {
  GLEnum2[GLEnum2["POINTS"] = 0] = "POINTS";
  GLEnum2[GLEnum2["LINES"] = 1] = "LINES";
  GLEnum2[GLEnum2["LINE_LOOP"] = 2] = "LINE_LOOP";
  GLEnum2[GLEnum2["LINE_STRIP"] = 3] = "LINE_STRIP";
  GLEnum2[GLEnum2["TRIANGLES"] = 4] = "TRIANGLES";
  GLEnum2[GLEnum2["TRIANGLE_STRIP"] = 5] = "TRIANGLE_STRIP";
  GLEnum2[GLEnum2["TRIANGLE_FAN"] = 6] = "TRIANGLE_FAN";
})(GLEnum$1 || (GLEnum$1 = {}));
function convertGLDrawModeToTopology(drawMode) {
  switch (drawMode) {
    case GLEnum$1.POINTS:
      return "point-list";
    case GLEnum$1.LINES:
      return "line-list";
    case GLEnum$1.LINE_STRIP:
      return "line-strip";
    case GLEnum$1.LINE_LOOP:
      return "line-loop-webgl";
    case GLEnum$1.TRIANGLES:
      return "triangle-list";
    case GLEnum$1.TRIANGLE_STRIP:
      return "triangle-strip";
    case GLEnum$1.TRIANGLE_FAN:
      return "triangle-fan-webgl";
    default:
      throw new Error(drawMode);
  }
}
function createScenegraphsFromGLTF(device, gltf, options2) {
  const instantiator = new GLTFInstantiator(device, options2);
  const scenes = instantiator.instantiate(gltf);
  const animator = instantiator.createAnimator();
  return { scenes, animator };
}
function assert$6(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "assert failed: gltf");
  }
}
const COMPONENTS$3 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const BYTES$3 = {
  5120: 1,
  // BYTE
  5121: 1,
  // UNSIGNED_BYTE
  5122: 2,
  // SHORT
  5123: 2,
  // UNSIGNED_SHORT
  5125: 4,
  // UNSIGNED_INT
  5126: 4
  // FLOAT
};
const MIPMAP_FACTOR$1 = 1.33;
const TYPES$1 = ["SCALAR", "VEC2", "VEC3", "VEC4"];
const ARRAY_CONSTRUCTOR_TO_WEBGL_CONSTANT$1 = [
  [Int8Array, 5120],
  [Uint8Array, 5121],
  [Int16Array, 5122],
  [Uint16Array, 5123],
  [Uint32Array, 5125],
  [Float32Array, 5126],
  [Float64Array, 5130]
];
const ARRAY_TO_COMPONENT_TYPE$1 = new Map(ARRAY_CONSTRUCTOR_TO_WEBGL_CONSTANT$1);
const ATTRIBUTE_TYPE_TO_COMPONENTS$3 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE$3 = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4
};
const ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$3 = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
function getAccessorTypeFromSize$1(size12) {
  const type = TYPES$1[size12 - 1];
  return type || TYPES$1[0];
}
function getComponentTypeFromArray$1(typedArray) {
  const componentType = ARRAY_TO_COMPONENT_TYPE$1.get(typedArray.constructor);
  if (!componentType) {
    throw new Error("Illegal typed array");
  }
  return componentType;
}
function getAccessorArrayTypeAndLength$1(accessor, bufferView) {
  const ArrayType2 = ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$3[accessor.componentType];
  const components = ATTRIBUTE_TYPE_TO_COMPONENTS$3[accessor.type];
  const bytesPerComponent = ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE$3[accessor.componentType];
  const length2 = accessor.count * components;
  const byteLength = accessor.count * components * bytesPerComponent;
  assert$6(byteLength >= 0 && byteLength <= bufferView.byteLength);
  const componentByteSize = BYTES$3[accessor.componentType];
  const numberOfComponentsInElement = COMPONENTS$3[accessor.type];
  return { ArrayType: ArrayType2, length: length2, byteLength, componentByteSize, numberOfComponentsInElement };
}
function getMemoryUsageGLTF$1(gltf) {
  let { images, bufferViews } = gltf;
  images = images || [];
  bufferViews = bufferViews || [];
  const imageBufferViews = images.map((i2) => i2.bufferView);
  bufferViews = bufferViews.filter((view2) => !imageBufferViews.includes(view2));
  const bufferMemory = bufferViews.reduce((acc, view2) => acc + view2.byteLength, 0);
  const pixelCount = images.reduce((acc, image) => {
    const { width, height } = image.image;
    return acc + width * height;
  }, 0);
  return bufferMemory + Math.ceil(4 * pixelCount * MIPMAP_FACTOR$1);
}
function getTypedArrayForBufferView$1(json, buffers, bufferViewIndex) {
  const bufferView = json.bufferViews[bufferViewIndex];
  assert$6(bufferView);
  const bufferIndex = bufferView.buffer;
  const binChunk = buffers[bufferIndex];
  assert$6(binChunk);
  const byteOffset = (bufferView.byteOffset || 0) + binChunk.byteOffset;
  return new Uint8Array(binChunk.arrayBuffer, byteOffset, bufferView.byteLength);
}
function getTypedArrayForAccessor$1(json, buffers, accessor) {
  var _a3, _b3;
  const gltfAccessor = typeof accessor === "number" ? (_a3 = json.accessors) == null ? void 0 : _a3[accessor] : accessor;
  if (!gltfAccessor) {
    throw new Error(`No gltf accessor ${JSON.stringify(accessor)}`);
  }
  const bufferView = (_b3 = json.bufferViews) == null ? void 0 : _b3[gltfAccessor.bufferView || 0];
  if (!bufferView) {
    throw new Error(`No gltf buffer view for accessor ${bufferView}`);
  }
  const { arrayBuffer: arrayBuffer2, byteOffset: bufferByteOffset } = buffers[bufferView.buffer];
  const byteOffset = (bufferByteOffset || 0) + (gltfAccessor.byteOffset || 0) + (bufferView.byteOffset || 0);
  const { ArrayType: ArrayType2, length: length2, componentByteSize, numberOfComponentsInElement } = getAccessorArrayTypeAndLength$1(gltfAccessor, bufferView);
  const elementByteSize = componentByteSize * numberOfComponentsInElement;
  const elementAddressScale = bufferView.byteStride || elementByteSize;
  if (typeof bufferView.byteStride === "undefined" || bufferView.byteStride === elementByteSize) {
    const result2 = new ArrayType2(arrayBuffer2, byteOffset, length2);
    return result2;
  }
  const result = new ArrayType2(length2);
  for (let i2 = 0; i2 < gltfAccessor.count; i2++) {
    const values4 = new ArrayType2(arrayBuffer2, byteOffset + i2 * elementAddressScale, numberOfComponentsInElement);
    result.set(values4, i2 * numberOfComponentsInElement);
  }
  return result;
}
function makeDefaultGLTFJson$1() {
  return {
    asset: {
      version: "2.0",
      generator: "loaders.gl"
    },
    buffers: [],
    extensions: {},
    extensionsRequired: [],
    extensionsUsed: []
  };
}
let GLTFScenegraph$1 = class GLTFScenegraph2 {
  // TODO - why is this not GLTFWithBuffers - what happens to images?
  constructor(gltf) {
    // internal
    __publicField2(this, "gltf");
    __publicField2(this, "sourceBuffers");
    __publicField2(this, "byteLength");
    this.gltf = {
      json: (gltf == null ? void 0 : gltf.json) || makeDefaultGLTFJson$1(),
      buffers: (gltf == null ? void 0 : gltf.buffers) || [],
      images: (gltf == null ? void 0 : gltf.images) || []
    };
    this.sourceBuffers = [];
    this.byteLength = 0;
    if (this.gltf.buffers && this.gltf.buffers[0]) {
      this.byteLength = this.gltf.buffers[0].byteLength;
      this.sourceBuffers = [this.gltf.buffers[0]];
    }
  }
  // Accessors
  get json() {
    return this.gltf.json;
  }
  getApplicationData(key) {
    const data2 = this.json[key];
    return data2;
  }
  getExtraData(key) {
    const extras = this.json.extras || {};
    return extras[key];
  }
  hasExtension(extensionName) {
    const isUsedExtension = this.getUsedExtensions().find((name2) => name2 === extensionName);
    const isRequiredExtension = this.getRequiredExtensions().find((name2) => name2 === extensionName);
    return typeof isUsedExtension === "string" || typeof isRequiredExtension === "string";
  }
  getExtension(extensionName) {
    const isExtension = this.getUsedExtensions().find((name2) => name2 === extensionName);
    const extensions = this.json.extensions || {};
    return isExtension ? extensions[extensionName] : null;
  }
  getRequiredExtension(extensionName) {
    const isRequired = this.getRequiredExtensions().find((name2) => name2 === extensionName);
    return isRequired ? this.getExtension(extensionName) : null;
  }
  getRequiredExtensions() {
    return this.json.extensionsRequired || [];
  }
  getUsedExtensions() {
    return this.json.extensionsUsed || [];
  }
  getRemovedExtensions() {
    return this.json.extensionsRemoved || [];
  }
  getObjectExtension(object2, extensionName) {
    const extensions = object2.extensions || {};
    return extensions[extensionName];
  }
  getScene(index2) {
    return this.getObject("scenes", index2);
  }
  getNode(index2) {
    return this.getObject("nodes", index2);
  }
  getSkin(index2) {
    return this.getObject("skins", index2);
  }
  getMesh(index2) {
    return this.getObject("meshes", index2);
  }
  getMaterial(index2) {
    return this.getObject("materials", index2);
  }
  getAccessor(index2) {
    return this.getObject("accessors", index2);
  }
  // getCamera(index: number): object | null {
  //   return null; // TODO: fix thi: object  as null;
  // }
  getTexture(index2) {
    return this.getObject("textures", index2);
  }
  getSampler(index2) {
    return this.getObject("samplers", index2);
  }
  getImage(index2) {
    return this.getObject("images", index2);
  }
  getBufferView(index2) {
    return this.getObject("bufferViews", index2);
  }
  getBuffer(index2) {
    return this.getObject("buffers", index2);
  }
  getObject(array2, index2) {
    if (typeof index2 === "object") {
      return index2;
    }
    const object2 = this.json[array2] && this.json[array2][index2];
    if (!object2) {
      throw new Error(`glTF file error: Could not find ${array2}[${index2}]`);
    }
    return object2;
  }
  /**
   * Accepts buffer view index or buffer view object
   * @returns a `Uint8Array`
   */
  getTypedArrayForBufferView(bufferView) {
    bufferView = this.getBufferView(bufferView);
    const bufferIndex = bufferView.buffer;
    const binChunk = this.gltf.buffers[bufferIndex];
    assert$6(binChunk);
    const byteOffset = (bufferView.byteOffset || 0) + binChunk.byteOffset;
    return new Uint8Array(binChunk.arrayBuffer, byteOffset, bufferView.byteLength);
  }
  /** Accepts accessor index or accessor object
   * @returns a typed array with type that matches the types
   */
  getTypedArrayForAccessor(accessor) {
    const gltfAccessor = this.getAccessor(accessor);
    return getTypedArrayForAccessor$1(this.gltf.json, this.gltf.buffers, gltfAccessor);
  }
  /** accepts accessor index or accessor object
   * returns a `Uint8Array`
   */
  getTypedArrayForImageData(image) {
    image = this.getAccessor(image);
    const bufferView = this.getBufferView(image.bufferView);
    const buffer3 = this.getBuffer(bufferView.buffer);
    const arrayBuffer2 = buffer3.data;
    const byteOffset = bufferView.byteOffset || 0;
    return new Uint8Array(arrayBuffer2, byteOffset, bufferView.byteLength);
  }
  // MODIFERS
  /**
   * Add an extra application-defined key to the top-level data structure
   */
  addApplicationData(key, data2) {
    this.json[key] = data2;
    return this;
  }
  /**
   * `extras` - Standard GLTF field for storing application specific data
   */
  addExtraData(key, data2) {
    this.json.extras = this.json.extras || {};
    this.json.extras[key] = data2;
    return this;
  }
  addObjectExtension(object2, extensionName, data2) {
    object2.extensions = object2.extensions || {};
    object2.extensions[extensionName] = data2;
    this.registerUsedExtension(extensionName);
    return this;
  }
  setObjectExtension(object2, extensionName, data2) {
    const extensions = object2.extensions || {};
    extensions[extensionName] = data2;
  }
  removeObjectExtension(object2, extensionName) {
    const extensions = (object2 == null ? void 0 : object2.extensions) || {};
    if (extensions[extensionName]) {
      this.json.extensionsRemoved = this.json.extensionsRemoved || [];
      const extensionsRemoved = this.json.extensionsRemoved;
      if (!extensionsRemoved.includes(extensionName)) {
        extensionsRemoved.push(extensionName);
      }
    }
    delete extensions[extensionName];
  }
  /**
   * Add to standard GLTF top level extension object, mark as used
   */
  addExtension(extensionName, extensionData = {}) {
    assert$6(extensionData);
    this.json.extensions = this.json.extensions || {};
    this.json.extensions[extensionName] = extensionData;
    this.registerUsedExtension(extensionName);
    return extensionData;
  }
  /**
   * Standard GLTF top level extension object, mark as used and required
   */
  addRequiredExtension(extensionName, extensionData = {}) {
    assert$6(extensionData);
    this.addExtension(extensionName, extensionData);
    this.registerRequiredExtension(extensionName);
    return extensionData;
  }
  /**
   * Add extensionName to list of used extensions
   */
  registerUsedExtension(extensionName) {
    this.json.extensionsUsed = this.json.extensionsUsed || [];
    if (!this.json.extensionsUsed.find((ext) => ext === extensionName)) {
      this.json.extensionsUsed.push(extensionName);
    }
  }
  /**
   * Add extensionName to list of required extensions
   */
  registerRequiredExtension(extensionName) {
    this.registerUsedExtension(extensionName);
    this.json.extensionsRequired = this.json.extensionsRequired || [];
    if (!this.json.extensionsRequired.find((ext) => ext === extensionName)) {
      this.json.extensionsRequired.push(extensionName);
    }
  }
  /**
   * Removes an extension from the top-level list
   */
  removeExtension(extensionName) {
    var _a3;
    if ((_a3 = this.json.extensions) == null ? void 0 : _a3[extensionName]) {
      this.json.extensionsRemoved = this.json.extensionsRemoved || [];
      const extensionsRemoved = this.json.extensionsRemoved;
      if (!extensionsRemoved.includes(extensionName)) {
        extensionsRemoved.push(extensionName);
      }
    }
    if (this.json.extensions) {
      delete this.json.extensions[extensionName];
    }
    if (this.json.extensionsRequired) {
      this._removeStringFromArray(this.json.extensionsRequired, extensionName);
    }
    if (this.json.extensionsUsed) {
      this._removeStringFromArray(this.json.extensionsUsed, extensionName);
    }
  }
  /**
   *  Set default scene which is to be displayed at load time
   */
  setDefaultScene(sceneIndex) {
    this.json.scene = sceneIndex;
  }
  /**
   * @todo: add more properties for scene initialization:
   *   name`, `extensions`, `extras`
   *   https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#reference-scene
   */
  addScene(scene) {
    const { nodeIndices } = scene;
    this.json.scenes = this.json.scenes || [];
    this.json.scenes.push({ nodes: nodeIndices });
    return this.json.scenes.length - 1;
  }
  /**
   * @todo: add more properties for node initialization:
   *   `name`, `extensions`, `extras`, `camera`, `children`, `skin`, `rotation`, `scale`, `translation`, `weights`
   *   https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#node
   */
  addNode(node) {
    const { meshIndex, matrix } = node;
    this.json.nodes = this.json.nodes || [];
    const nodeData = { mesh: meshIndex };
    if (matrix) {
      nodeData.matrix = matrix;
    }
    this.json.nodes.push(nodeData);
    return this.json.nodes.length - 1;
  }
  /** Adds a mesh to the json part */
  addMesh(mesh) {
    const { attributes, indices, material, mode: mode2 = 4 } = mesh;
    const accessors = this._addAttributes(attributes);
    const glTFMesh = {
      primitives: [
        {
          attributes: accessors,
          mode: mode2
        }
      ]
    };
    if (indices) {
      const indicesAccessor = this._addIndices(indices);
      glTFMesh.primitives[0].indices = indicesAccessor;
    }
    if (Number.isFinite(material)) {
      glTFMesh.primitives[0].material = material;
    }
    this.json.meshes = this.json.meshes || [];
    this.json.meshes.push(glTFMesh);
    return this.json.meshes.length - 1;
  }
  addPointCloud(attributes) {
    const accessorIndices = this._addAttributes(attributes);
    const glTFMesh = {
      primitives: [
        {
          attributes: accessorIndices,
          mode: 0
          // GL.POINTS
        }
      ]
    };
    this.json.meshes = this.json.meshes || [];
    this.json.meshes.push(glTFMesh);
    return this.json.meshes.length - 1;
  }
  /**
   * Adds a binary image. Builds glTF "JSON metadata" and saves buffer reference
   * Buffer will be copied into BIN chunk during "pack"
   * Currently encodes as glTF image
   * @param imageData
   * @param mimeType
   */
  addImage(imageData, mimeTypeOpt) {
    const metadata = getBinaryImageMetadata$1(imageData);
    const mimeType = mimeTypeOpt || (metadata == null ? void 0 : metadata.mimeType);
    const bufferViewIndex = this.addBufferView(imageData);
    const glTFImage = {
      bufferView: bufferViewIndex,
      mimeType
    };
    this.json.images = this.json.images || [];
    this.json.images.push(glTFImage);
    return this.json.images.length - 1;
  }
  /**
   * Add one untyped source buffer, create a matching glTF `bufferView`, and return its index
   * @param buffer
   */
  addBufferView(buffer3, bufferIndex = 0, byteOffset = this.byteLength) {
    const byteLength = buffer3.byteLength;
    assert$6(Number.isFinite(byteLength));
    this.sourceBuffers = this.sourceBuffers || [];
    this.sourceBuffers.push(buffer3);
    const glTFBufferView = {
      buffer: bufferIndex,
      // Write offset from the start of the binary body
      byteOffset,
      byteLength
    };
    this.byteLength += padToNBytes$1(byteLength, 4);
    this.json.bufferViews = this.json.bufferViews || [];
    this.json.bufferViews.push(glTFBufferView);
    return this.json.bufferViews.length - 1;
  }
  /**
   * Adds an accessor to a bufferView
   * @param bufferViewIndex
   * @param accessor
   */
  addAccessor(bufferViewIndex, accessor) {
    const glTFAccessor = {
      bufferView: bufferViewIndex,
      // @ts-ignore
      type: getAccessorTypeFromSize$1(accessor.size),
      // @ts-ignore
      componentType: accessor.componentType,
      // @ts-ignore
      count: accessor.count,
      // @ts-ignore
      max: accessor.max,
      // @ts-ignore
      min: accessor.min
    };
    this.json.accessors = this.json.accessors || [];
    this.json.accessors.push(glTFAccessor);
    return this.json.accessors.length - 1;
  }
  /**
   * Add a binary buffer. Builds glTF "JSON metadata" and saves buffer reference
   * Buffer will be copied into BIN chunk during "pack"
   * Currently encodes buffers as glTF accessors, but this could be optimized
   * @param sourceBuffer
   * @param accessor
   */
  addBinaryBuffer(sourceBuffer, accessor = { size: 3 }) {
    const bufferViewIndex = this.addBufferView(sourceBuffer);
    let minMax = { min: accessor.min, max: accessor.max };
    if (!minMax.min || !minMax.max) {
      minMax = this._getAccessorMinMax(sourceBuffer, accessor.size);
    }
    const accessorDefaults = {
      // @ts-ignore
      size: accessor.size,
      componentType: getComponentTypeFromArray$1(sourceBuffer),
      // @ts-ignore
      count: Math.round(sourceBuffer.length / accessor.size),
      min: minMax.min,
      max: minMax.max
    };
    return this.addAccessor(bufferViewIndex, Object.assign(accessorDefaults, accessor));
  }
  /**
   * Adds a texture to the json part
   * @todo: add more properties for texture initialization
   * `sampler`, `name`, `extensions`, `extras`
   * https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#texture
   */
  addTexture(texture) {
    const { imageIndex } = texture;
    const glTFTexture = {
      source: imageIndex
    };
    this.json.textures = this.json.textures || [];
    this.json.textures.push(glTFTexture);
    return this.json.textures.length - 1;
  }
  /** Adds a material to the json part */
  addMaterial(pbrMaterialInfo) {
    this.json.materials = this.json.materials || [];
    this.json.materials.push(pbrMaterialInfo);
    return this.json.materials.length - 1;
  }
  /** Pack the binary chunk */
  createBinaryChunk() {
    var _a3, _b3;
    this.gltf.buffers = [];
    const totalByteLength = this.byteLength;
    const arrayBuffer2 = new ArrayBuffer(totalByteLength);
    const targetArray = new Uint8Array(arrayBuffer2);
    let dstByteOffset = 0;
    for (const sourceBuffer of this.sourceBuffers || []) {
      dstByteOffset = copyToArray$1(sourceBuffer, targetArray, dstByteOffset);
    }
    if ((_b3 = (_a3 = this.json) == null ? void 0 : _a3.buffers) == null ? void 0 : _b3[0]) {
      this.json.buffers[0].byteLength = totalByteLength;
    } else {
      this.json.buffers = [{ byteLength: totalByteLength }];
    }
    this.gltf.binary = arrayBuffer2;
    this.sourceBuffers = [arrayBuffer2];
  }
  // PRIVATE
  _removeStringFromArray(array2, string3) {
    let found = true;
    while (found) {
      const index2 = array2.indexOf(string3);
      if (index2 > -1) {
        array2.splice(index2, 1);
      } else {
        found = false;
      }
    }
  }
  /**
   * Add attributes to buffers and create `attributes` object which is part of `mesh`
   */
  _addAttributes(attributes = {}) {
    const result = {};
    for (const attributeKey in attributes) {
      const attributeData = attributes[attributeKey];
      const attrName = this._getGltfAttributeName(attributeKey);
      const accessor = this.addBinaryBuffer(attributeData.value, attributeData);
      result[attrName] = accessor;
    }
    return result;
  }
  /**
   * Add indices to buffers
   */
  _addIndices(indices) {
    return this.addBinaryBuffer(indices, { size: 1 });
  }
  /**
   * Deduce gltf specific attribue name from input attribute name
   */
  _getGltfAttributeName(attributeName) {
    switch (attributeName.toLowerCase()) {
      case "position":
      case "positions":
      case "vertices":
        return "POSITION";
      case "normal":
      case "normals":
        return "NORMAL";
      case "color":
      case "colors":
        return "COLOR_0";
      case "texcoord":
      case "texcoords":
        return "TEXCOORD_0";
      default:
        return attributeName;
    }
  }
  /**
   * Calculate `min` and `max` arrays of accessor according to spec:
   * https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#reference-accessor
   */
  _getAccessorMinMax(buffer3, size12) {
    const result = { min: null, max: null };
    if (buffer3.length < size12) {
      return result;
    }
    result.min = [];
    result.max = [];
    const initValues = buffer3.subarray(0, size12);
    for (const value of initValues) {
      result.min.push(value);
      result.max.push(value);
    }
    for (let index2 = size12; index2 < buffer3.length; index2 += size12) {
      for (let componentIndex = 0; componentIndex < size12; componentIndex++) {
        result.min[0 + componentIndex] = Math.min(
          // @ts-ignore
          result.min[0 + componentIndex],
          buffer3[index2 + componentIndex]
        );
        result.max[0 + componentIndex] = Math.max(
          // @ts-ignore
          result.max[0 + componentIndex],
          buffer3[index2 + componentIndex]
        );
      }
    }
    return result;
  }
};
function emod$1(n2) {
  return (n2 % 1 + 1) % 1;
}
const ATTRIBUTE_TYPE_TO_COMPONENTS$2 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16,
  BOOLEAN: 1,
  STRING: 1,
  ENUM: 1
};
const ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$2 = {
  INT8: Int8Array,
  UINT8: Uint8Array,
  INT16: Int16Array,
  UINT16: Uint16Array,
  INT32: Int32Array,
  UINT32: Uint32Array,
  INT64: BigInt64Array,
  UINT64: BigUint64Array,
  FLOAT32: Float32Array,
  FLOAT64: Float64Array
};
const ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE$2 = {
  INT8: 1,
  UINT8: 1,
  INT16: 2,
  UINT16: 2,
  INT32: 4,
  UINT32: 4,
  INT64: 8,
  UINT64: 8,
  FLOAT32: 4,
  FLOAT64: 8
};
function getArrayElementByteSize$1(attributeType, componentType) {
  return ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE$2[componentType] * ATTRIBUTE_TYPE_TO_COMPONENTS$2[attributeType];
}
function getOffsetsForProperty$1(scenegraph, bufferViewIndex, offsetType, numberOfElements) {
  if (offsetType !== "UINT8" && offsetType !== "UINT16" && offsetType !== "UINT32" && offsetType !== "UINT64") {
    return null;
  }
  const arrayOffsetsBytes = scenegraph.getTypedArrayForBufferView(bufferViewIndex);
  const arrayOffsets = convertRawBufferToMetadataArray$1(
    arrayOffsetsBytes,
    "SCALAR",
    // offsets consist of ONE component
    offsetType,
    numberOfElements + 1
    // The number of offsets is equal to the property table `count` plus one.
  );
  if (arrayOffsets instanceof BigInt64Array || arrayOffsets instanceof BigUint64Array) {
    return null;
  }
  return arrayOffsets;
}
function convertRawBufferToMetadataArray$1(data2, attributeType, componentType, elementCount = 1) {
  const numberOfComponents = ATTRIBUTE_TYPE_TO_COMPONENTS$2[attributeType];
  const ArrayType2 = ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$2[componentType];
  const size12 = ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE$2[componentType];
  const length2 = elementCount * numberOfComponents;
  const byteLength = length2 * size12;
  let buffer3 = data2.buffer;
  let offset = data2.byteOffset;
  if (offset % size12 !== 0) {
    const bufferArray = new Uint8Array(buffer3);
    buffer3 = bufferArray.slice(offset, offset + byteLength).buffer;
    offset = 0;
  }
  return new ArrayType2(buffer3, offset, length2);
}
function getPrimitiveTextureData$1(scenegraph, textureInfo, primitive) {
  var _a3, _b3, _c2, _d2, _e2;
  const texCoordAccessorKey = `TEXCOORD_${textureInfo.texCoord || 0}`;
  const texCoordAccessorIndex = primitive.attributes[texCoordAccessorKey];
  const textureCoordinates = scenegraph.getTypedArrayForAccessor(texCoordAccessorIndex);
  const json = scenegraph.gltf.json;
  const textureIndex = textureInfo.index;
  const imageIndex = (_b3 = (_a3 = json.textures) == null ? void 0 : _a3[textureIndex]) == null ? void 0 : _b3.source;
  if (typeof imageIndex !== "undefined") {
    const mimeType = (_d2 = (_c2 = json.images) == null ? void 0 : _c2[imageIndex]) == null ? void 0 : _d2.mimeType;
    const parsedImage = (_e2 = scenegraph.gltf.images) == null ? void 0 : _e2[imageIndex];
    if (parsedImage && typeof parsedImage.width !== "undefined") {
      const textureData = [];
      for (let index2 = 0; index2 < textureCoordinates.length; index2 += 2) {
        const value = getImageValueByCoordinates$1(parsedImage, mimeType, textureCoordinates, index2, textureInfo.channels);
        textureData.push(value);
      }
      return textureData;
    }
  }
  return [];
}
function primitivePropertyDataToAttributes$1(scenegraph, attributeName, propertyData, featureTable, primitive) {
  if (!(propertyData == null ? void 0 : propertyData.length)) {
    return;
  }
  const featureIndices = [];
  for (const texelData of propertyData) {
    let index2 = featureTable.findIndex((item) => item === texelData);
    if (index2 === -1) {
      index2 = featureTable.push(texelData) - 1;
    }
    featureIndices.push(index2);
  }
  const typedArray = new Uint32Array(featureIndices);
  const bufferIndex = scenegraph.gltf.buffers.push({
    arrayBuffer: typedArray.buffer,
    byteOffset: typedArray.byteOffset,
    byteLength: typedArray.byteLength
  }) - 1;
  const bufferViewIndex = scenegraph.addBufferView(typedArray, bufferIndex, 0);
  const accessorIndex = scenegraph.addAccessor(bufferViewIndex, {
    size: 1,
    componentType: getComponentTypeFromArray$1(typedArray),
    count: typedArray.length
  });
  primitive.attributes[attributeName] = accessorIndex;
}
function getImageValueByCoordinates$1(parsedImage, mimeType, textureCoordinates, index2, channels = [0]) {
  const CHANNELS_MAP = {
    r: { offset: 0, shift: 0 },
    g: { offset: 1, shift: 8 },
    b: { offset: 2, shift: 16 },
    a: { offset: 3, shift: 24 }
  };
  const u2 = textureCoordinates[index2];
  const v5 = textureCoordinates[index2 + 1];
  let components = 1;
  if (mimeType && (mimeType.indexOf("image/jpeg") !== -1 || mimeType.indexOf("image/png") !== -1))
    components = 4;
  const offset = coordinatesToOffset$1(u2, v5, parsedImage, components);
  let value = 0;
  for (const c2 of channels) {
    const map5 = typeof c2 === "number" ? Object.values(CHANNELS_MAP)[c2] : CHANNELS_MAP[c2];
    const imageOffset = offset + map5.offset;
    const imageData = getImageData$1(parsedImage);
    if (imageData.data.length <= imageOffset) {
      throw new Error(`${imageData.data.length} <= ${imageOffset}`);
    }
    const imageValue = imageData.data[imageOffset];
    value |= imageValue << map5.shift;
  }
  return value;
}
function coordinatesToOffset$1(u2, v5, parsedImage, componentsCount = 1) {
  const w2 = parsedImage.width;
  const iX = emod$1(u2) * (w2 - 1);
  const indX = Math.round(iX);
  const h2 = parsedImage.height;
  const iY = emod$1(v5) * (h2 - 1);
  const indY = Math.round(iY);
  const components = parsedImage.components ? parsedImage.components : componentsCount;
  const offset = (indY * w2 + indX) * components;
  return offset;
}
function parseVariableLengthArrayNumeric$1(valuesData, numberOfElements, arrayOffsets, valuesDataBytesLength, valueSize) {
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const arrayOffset = arrayOffsets[index2];
    const arrayByteSize = arrayOffsets[index2 + 1] - arrayOffsets[index2];
    if (arrayByteSize + arrayOffset > valuesDataBytesLength) {
      break;
    }
    const typedArrayOffset = arrayOffset / valueSize;
    const elementCount = arrayByteSize / valueSize;
    attributeValueArray.push(valuesData.slice(typedArrayOffset, typedArrayOffset + elementCount));
  }
  return attributeValueArray;
}
function parseFixedLengthArrayNumeric$1(valuesData, numberOfElements, arrayCount) {
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const elementOffset = index2 * arrayCount;
    attributeValueArray.push(valuesData.slice(elementOffset, elementOffset + arrayCount));
  }
  return attributeValueArray;
}
function getPropertyDataString$1(numberOfElements, valuesDataBytes, arrayOffsets, stringOffsets) {
  if (arrayOffsets) {
    throw new Error("Not implemented - arrayOffsets for strings is specified");
  }
  if (stringOffsets) {
    const stringsArray = [];
    const textDecoder = new TextDecoder("utf8");
    let stringOffset = 0;
    for (let index2 = 0; index2 < numberOfElements; index2++) {
      const stringByteSize = stringOffsets[index2 + 1] - stringOffsets[index2];
      if (stringByteSize + stringOffset <= valuesDataBytes.length) {
        const stringData = valuesDataBytes.subarray(stringOffset, stringByteSize + stringOffset);
        const stringAttribute = textDecoder.decode(stringData);
        stringsArray.push(stringAttribute);
        stringOffset += stringByteSize;
      }
    }
    return stringsArray;
  }
  return [];
}
const EXT_MESH_FEATURES_NAME$1 = "EXT_mesh_features";
const name$m = EXT_MESH_FEATURES_NAME$1;
async function decode$j(gltfData, options2) {
  const scenegraph = new GLTFScenegraph$1(gltfData);
  decodeExtMeshFeatures$1(scenegraph, options2);
}
function decodeExtMeshFeatures$1(scenegraph, options2) {
  const json = scenegraph.gltf.json;
  if (!json.meshes) {
    return;
  }
  for (const mesh of json.meshes) {
    for (const primitive of mesh.primitives) {
      processMeshPrimitiveFeatures$1(scenegraph, primitive, options2);
    }
  }
}
function processMeshPrimitiveFeatures$1(scenegraph, primitive, options2) {
  var _a3, _b3, _c2;
  if (!((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const extension = (_b3 = primitive.extensions) == null ? void 0 : _b3[EXT_MESH_FEATURES_NAME$1];
  const featureIds = extension == null ? void 0 : extension.featureIds;
  if (!featureIds) {
    return;
  }
  for (const featureId of featureIds) {
    let featureIdData;
    if (typeof featureId.attribute !== "undefined") {
      const accessorKey = `_FEATURE_ID_${featureId.attribute}`;
      const accessorIndex = primitive.attributes[accessorKey];
      featureIdData = scenegraph.getTypedArrayForAccessor(accessorIndex);
    } else if (typeof featureId.texture !== "undefined" && ((_c2 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _c2.loadImages)) {
      featureIdData = getPrimitiveTextureData$1(scenegraph, featureId.texture, primitive);
    } else {
      featureIdData = [];
    }
    featureId.data = featureIdData;
  }
}
const EXT_mesh_features$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$j,
  name: name$m
}, Symbol.toStringTag, { value: "Module" }));
const EXT_STRUCTURAL_METADATA_NAME$1 = "EXT_structural_metadata";
const name$l = EXT_STRUCTURAL_METADATA_NAME$1;
async function decode$i(gltfData, options2) {
  const scenegraph = new GLTFScenegraph$1(gltfData);
  decodeExtStructuralMetadata$1(scenegraph, options2);
}
function decodeExtStructuralMetadata$1(scenegraph, options2) {
  var _a3, _b3;
  if (!((_a3 = options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const extension = scenegraph.getExtension(EXT_STRUCTURAL_METADATA_NAME$1);
  if (!extension) {
    return;
  }
  if ((_b3 = options2.gltf) == null ? void 0 : _b3.loadImages) {
    decodePropertyTextures$3(scenegraph, extension);
  }
  decodePropertyTables$3(scenegraph, extension);
}
function decodePropertyTextures$3(scenegraph, extension) {
  const propertyTextures = extension.propertyTextures;
  const json = scenegraph.gltf.json;
  if (propertyTextures && json.meshes) {
    for (const mesh of json.meshes) {
      for (const primitive of mesh.primitives) {
        processPrimitivePropertyTextures$1(scenegraph, propertyTextures, primitive, extension);
      }
    }
  }
}
function decodePropertyTables$3(scenegraph, extension) {
  const schema = extension.schema;
  if (!schema) {
    return;
  }
  const schemaClasses = schema.classes;
  const propertyTables = extension.propertyTables;
  if (schemaClasses && propertyTables) {
    for (const schemaName in schemaClasses) {
      const propertyTable = findPropertyTableByClass$3(propertyTables, schemaName);
      if (propertyTable) {
        processPropertyTable$3(scenegraph, schema, propertyTable);
      }
    }
  }
}
function findPropertyTableByClass$3(propertyTables, schemaClassName) {
  for (const propertyTable of propertyTables) {
    if (propertyTable.class === schemaClassName) {
      return propertyTable;
    }
  }
  return null;
}
function processPrimitivePropertyTextures$1(scenegraph, propertyTextures, primitive, extension) {
  var _a3;
  if (!propertyTextures) {
    return;
  }
  const primitiveExtension = (_a3 = primitive.extensions) == null ? void 0 : _a3[EXT_STRUCTURAL_METADATA_NAME$1];
  const primitivePropertyTextureIndices = primitiveExtension == null ? void 0 : primitiveExtension.propertyTextures;
  if (!primitivePropertyTextureIndices) {
    return;
  }
  for (const primitivePropertyTextureIndex of primitivePropertyTextureIndices) {
    const propertyTexture = propertyTextures[primitivePropertyTextureIndex];
    processPrimitivePropertyTexture$1(scenegraph, propertyTexture, primitive, extension);
  }
}
function processPrimitivePropertyTexture$1(scenegraph, propertyTexture, primitive, extension) {
  var _a3;
  if (!propertyTexture.properties) {
    return;
  }
  if (!extension.dataAttributeNames) {
    extension.dataAttributeNames = [];
  }
  const className = propertyTexture.class;
  for (const propertyName in propertyTexture.properties) {
    const attributeName = `${className}_${propertyName}`;
    const textureInfoTopLevel = (_a3 = propertyTexture.properties) == null ? void 0 : _a3[propertyName];
    if (!textureInfoTopLevel) {
      continue;
    }
    if (!textureInfoTopLevel.data) {
      textureInfoTopLevel.data = [];
    }
    const featureTextureTable = textureInfoTopLevel.data;
    const propertyData = getPrimitiveTextureData$1(scenegraph, textureInfoTopLevel, primitive);
    if (propertyData === null) {
      continue;
    }
    primitivePropertyDataToAttributes$1(scenegraph, attributeName, propertyData, featureTextureTable, primitive);
    textureInfoTopLevel.data = featureTextureTable;
    extension.dataAttributeNames.push(attributeName);
  }
}
function processPropertyTable$3(scenegraph, schema, propertyTable) {
  var _a3, _b3;
  const schemaClass = (_a3 = schema.classes) == null ? void 0 : _a3[propertyTable.class];
  if (!schemaClass) {
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: no schema class with name ${propertyTable.class}`);
  }
  const numberOfElements = propertyTable.count;
  for (const propertyName in schemaClass.properties) {
    const classProperty = schemaClass.properties[propertyName];
    const propertyTableProperty = (_b3 = propertyTable.properties) == null ? void 0 : _b3[propertyName];
    if (propertyTableProperty) {
      const data2 = getPropertyDataFromBinarySource$3(scenegraph, schema, classProperty, numberOfElements, propertyTableProperty);
      propertyTableProperty.data = data2;
    }
  }
}
function getPropertyDataFromBinarySource$3(scenegraph, schema, classProperty, numberOfElements, propertyTableProperty) {
  let data2 = [];
  const valuesBufferView = propertyTableProperty.values;
  const valuesDataBytes = scenegraph.getTypedArrayForBufferView(valuesBufferView);
  const arrayOffsets = getArrayOffsetsForProperty$3(scenegraph, classProperty, propertyTableProperty, numberOfElements);
  const stringOffsets = getStringOffsetsForProperty$3(scenegraph, propertyTableProperty, numberOfElements);
  switch (classProperty.type) {
    case "SCALAR":
    case "VEC2":
    case "VEC3":
    case "VEC4":
    case "MAT2":
    case "MAT3":
    case "MAT4": {
      data2 = getPropertyDataNumeric$3(classProperty, numberOfElements, valuesDataBytes, arrayOffsets);
      break;
    }
    case "BOOLEAN": {
      throw new Error(`Not implemented - classProperty.type=${classProperty.type}`);
    }
    case "STRING": {
      data2 = getPropertyDataString$1(numberOfElements, valuesDataBytes, arrayOffsets, stringOffsets);
      break;
    }
    case "ENUM": {
      data2 = getPropertyDataENUM$1(schema, classProperty, numberOfElements, valuesDataBytes, arrayOffsets);
      break;
    }
    default:
      throw new Error(`Unknown classProperty type ${classProperty.type}`);
  }
  return data2;
}
function getArrayOffsetsForProperty$3(scenegraph, classProperty, propertyTableProperty, numberOfElements) {
  if (classProperty.array && // `count` is a number of array elements. May only be defined when `array` is true.
  // If `count` is NOT defined, it's a VARIABLE-length array
  typeof classProperty.count === "undefined" && // `arrayOffsets` is an index of the buffer view containing offsets for variable-length arrays.
  typeof propertyTableProperty.arrayOffsets !== "undefined") {
    return getOffsetsForProperty$1(scenegraph, propertyTableProperty.arrayOffsets, propertyTableProperty.arrayOffsetType || "UINT32", numberOfElements);
  }
  return null;
}
function getStringOffsetsForProperty$3(scenegraph, propertyTableProperty, numberOfElements) {
  if (typeof propertyTableProperty.stringOffsets !== "undefined") {
    return getOffsetsForProperty$1(scenegraph, propertyTableProperty.stringOffsets, propertyTableProperty.stringOffsetType || "UINT32", numberOfElements);
  }
  return null;
}
function getPropertyDataNumeric$3(classProperty, numberOfElements, valuesDataBytes, arrayOffsets) {
  const isArray3 = classProperty.array;
  const arrayCount = classProperty.count;
  const elementSize = getArrayElementByteSize$1(classProperty.type, classProperty.componentType);
  const elementCount = valuesDataBytes.byteLength / elementSize;
  let valuesData;
  if (classProperty.componentType) {
    valuesData = convertRawBufferToMetadataArray$1(
      valuesDataBytes,
      classProperty.type,
      // The datatype of the element's components. Only applicable to `SCALAR`, `VECN`, and `MATN` types.
      classProperty.componentType,
      elementCount
    );
  } else {
    valuesData = valuesDataBytes;
  }
  if (isArray3) {
    if (arrayOffsets) {
      return parseVariableLengthArrayNumeric$1(valuesData, numberOfElements, arrayOffsets, valuesDataBytes.length, elementSize);
    }
    if (arrayCount) {
      return parseFixedLengthArrayNumeric$1(valuesData, numberOfElements, arrayCount);
    }
    return [];
  }
  return valuesData;
}
function getPropertyDataENUM$1(schema, classProperty, numberOfElements, valuesDataBytes, arrayOffsets) {
  var _a3;
  const enumType = classProperty.enumType;
  if (!enumType) {
    throw new Error("Incorrect data in the EXT_structural_metadata extension: classProperty.enumType is not set for type ENUM");
  }
  const enumEntry = (_a3 = schema.enums) == null ? void 0 : _a3[enumType];
  if (!enumEntry) {
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: schema.enums does't contain ${enumType}`);
  }
  const enumValueType = enumEntry.valueType || "UINT16";
  const elementSize = getArrayElementByteSize$1(classProperty.type, enumValueType);
  const elementCount = valuesDataBytes.byteLength / elementSize;
  let valuesData = convertRawBufferToMetadataArray$1(valuesDataBytes, classProperty.type, enumValueType, elementCount);
  if (!valuesData) {
    valuesData = valuesDataBytes;
  }
  if (classProperty.array) {
    if (arrayOffsets) {
      return parseVariableLengthArrayENUM$1({
        valuesData,
        numberOfElements,
        arrayOffsets,
        valuesDataBytesLength: valuesDataBytes.length,
        elementSize,
        enumEntry
      });
    }
    const arrayCount = classProperty.count;
    if (arrayCount) {
      return parseFixedLengthArrayENUM$1(valuesData, numberOfElements, arrayCount, enumEntry);
    }
    return [];
  }
  return getEnumsArray$1(valuesData, 0, numberOfElements, enumEntry);
}
function parseVariableLengthArrayENUM$1(params2) {
  const { valuesData, numberOfElements, arrayOffsets, valuesDataBytesLength, elementSize, enumEntry } = params2;
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const arrayOffset = arrayOffsets[index2];
    const arrayByteSize = arrayOffsets[index2 + 1] - arrayOffsets[index2];
    if (arrayByteSize + arrayOffset > valuesDataBytesLength) {
      break;
    }
    const typedArrayOffset = arrayOffset / elementSize;
    const elementCount = arrayByteSize / elementSize;
    const array2 = getEnumsArray$1(valuesData, typedArrayOffset, elementCount, enumEntry);
    attributeValueArray.push(array2);
  }
  return attributeValueArray;
}
function parseFixedLengthArrayENUM$1(valuesData, numberOfElements, arrayCount, enumEntry) {
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const elementOffset = arrayCount * index2;
    const array2 = getEnumsArray$1(valuesData, elementOffset, arrayCount, enumEntry);
    attributeValueArray.push(array2);
  }
  return attributeValueArray;
}
function getEnumsArray$1(valuesData, offset, count3, enumEntry) {
  const array2 = [];
  for (let i2 = 0; i2 < count3; i2++) {
    if (valuesData instanceof BigInt64Array || valuesData instanceof BigUint64Array) {
      array2.push("");
    } else {
      const value = valuesData[offset + i2];
      const enumObject = getEnumByValue$1(enumEntry, value);
      if (enumObject) {
        array2.push(enumObject.name);
      } else {
        array2.push("");
      }
    }
  }
  return array2;
}
function getEnumByValue$1(enumEntry, value) {
  for (const enumValue of enumEntry.values) {
    if (enumValue.value === value) {
      return enumValue;
    }
  }
  return null;
}
const EXT_structural_metadata$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$i,
  name: name$l
}, Symbol.toStringTag, { value: "Module" }));
const EXT_FEATURE_METADATA_NAME$1 = "EXT_feature_metadata";
const name$k = EXT_FEATURE_METADATA_NAME$1;
async function decode$h(gltfData, options2) {
  const scenegraph = new GLTFScenegraph$1(gltfData);
  decodeExtFeatureMetadata$1(scenegraph, options2);
}
function decodeExtFeatureMetadata$1(scenegraph, options2) {
  var _a3, _b3;
  if (!((_a3 = options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const extension = scenegraph.getExtension(EXT_FEATURE_METADATA_NAME$1);
  if (!extension) {
    return;
  }
  if ((_b3 = options2.gltf) == null ? void 0 : _b3.loadImages) {
    decodePropertyTextures$2(scenegraph, extension);
  }
  decodePropertyTables$2(scenegraph, extension);
}
function decodePropertyTextures$2(scenegraph, extension) {
  const schema = extension.schema;
  if (!schema) {
    return;
  }
  const schemaClasses = schema.classes;
  const { featureTextures } = extension;
  if (schemaClasses && featureTextures) {
    for (const schemaName in schemaClasses) {
      const schemaClass = schemaClasses[schemaName];
      const featureTexture = findFeatureTextureByClass$1(featureTextures, schemaName);
      if (featureTexture) {
        handleFeatureTextureProperties$1(scenegraph, featureTexture, schemaClass);
      }
    }
  }
}
function decodePropertyTables$2(scenegraph, extension) {
  const schema = extension.schema;
  if (!schema) {
    return;
  }
  const schemaClasses = schema.classes;
  const propertyTables = extension.featureTables;
  if (schemaClasses && propertyTables) {
    for (const schemaName in schemaClasses) {
      const propertyTable = findPropertyTableByClass$2(propertyTables, schemaName);
      if (propertyTable) {
        processPropertyTable$2(scenegraph, schema, propertyTable);
      }
    }
  }
}
function findPropertyTableByClass$2(propertyTables, schemaClassName) {
  for (const propertyTableName in propertyTables) {
    const propertyTable = propertyTables[propertyTableName];
    if (propertyTable.class === schemaClassName) {
      return propertyTable;
    }
  }
  return null;
}
function findFeatureTextureByClass$1(featureTextures, schemaClassName) {
  for (const featureTexturesName in featureTextures) {
    const featureTable = featureTextures[featureTexturesName];
    if (featureTable.class === schemaClassName) {
      return featureTable;
    }
  }
  return null;
}
function processPropertyTable$2(scenegraph, schema, propertyTable) {
  var _a3, _b3;
  if (!propertyTable.class) {
    return;
  }
  const schemaClass = (_a3 = schema.classes) == null ? void 0 : _a3[propertyTable.class];
  if (!schemaClass) {
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: no schema class with name ${propertyTable.class}`);
  }
  const numberOfElements = propertyTable.count;
  for (const propertyName in schemaClass.properties) {
    const classProperty = schemaClass.properties[propertyName];
    const propertyTableProperty = (_b3 = propertyTable.properties) == null ? void 0 : _b3[propertyName];
    if (propertyTableProperty) {
      const data2 = getPropertyDataFromBinarySource$2(scenegraph, schema, classProperty, numberOfElements, propertyTableProperty);
      propertyTableProperty.data = data2;
    }
  }
}
function handleFeatureTextureProperties$1(scenegraph, featureTexture, schemaClass) {
  var _a3;
  const attributeName = featureTexture.class;
  for (const propertyName in schemaClass.properties) {
    const featureTextureProperty = (_a3 = featureTexture == null ? void 0 : featureTexture.properties) == null ? void 0 : _a3[propertyName];
    if (featureTextureProperty) {
      const data2 = getPropertyDataFromTexture$1(scenegraph, featureTextureProperty, attributeName);
      featureTextureProperty.data = data2;
    }
  }
}
function getPropertyDataFromBinarySource$2(scenegraph, schema, classProperty, numberOfFeatures, featureTableProperty) {
  let data2 = [];
  const bufferView = featureTableProperty.bufferView;
  const dataArray = scenegraph.getTypedArrayForBufferView(bufferView);
  const arrayOffsets = getArrayOffsetsForProperty$2(scenegraph, classProperty, featureTableProperty, numberOfFeatures);
  const stringOffsets = getStringOffsetsForProperty$2(scenegraph, classProperty, featureTableProperty, numberOfFeatures);
  if (classProperty.type === "STRING" || classProperty.componentType === "STRING") {
    data2 = getPropertyDataString$1(numberOfFeatures, dataArray, arrayOffsets, stringOffsets);
  } else if (isNumericProperty$1(classProperty)) {
    data2 = getPropertyDataNumeric$2(classProperty, numberOfFeatures, dataArray, arrayOffsets);
  }
  return data2;
}
function getArrayOffsetsForProperty$2(scenegraph, classProperty, propertyTableProperty, numberOfElements) {
  if (classProperty.type === "ARRAY" && // `componentCount` is a number of fixed-length array elements.
  // If `componentCount` is NOT defined, it's a VARIABLE-length array
  typeof classProperty.componentCount === "undefined" && // `arrayOffsetBufferView` is an index of the buffer view containing offsets for variable-length arrays.
  typeof propertyTableProperty.arrayOffsetBufferView !== "undefined") {
    return getOffsetsForProperty$1(
      scenegraph,
      propertyTableProperty.arrayOffsetBufferView,
      propertyTableProperty.offsetType || "UINT32",
      // offsetType is used both for stringOffsetBufferView and arrayOffsetBufferView
      numberOfElements
    );
  }
  return null;
}
function getStringOffsetsForProperty$2(scenegraph, classProperty, propertyTableProperty, numberOfElements) {
  if (typeof propertyTableProperty.stringOffsetBufferView !== "undefined") {
    return getOffsetsForProperty$1(
      scenegraph,
      propertyTableProperty.stringOffsetBufferView,
      propertyTableProperty.offsetType || "UINT32",
      // offsetType is used both for stringOffsetBufferView and arrayOffsetBufferView
      numberOfElements
    );
  }
  return null;
}
function isNumericProperty$1(schemaProperty) {
  const types2 = [
    "UINT8",
    "INT16",
    "UINT16",
    "INT32",
    "UINT32",
    "INT64",
    "UINT64",
    "FLOAT32",
    "FLOAT64"
  ];
  return types2.includes(schemaProperty.type) || typeof schemaProperty.componentType !== "undefined" && types2.includes(schemaProperty.componentType);
}
function getPropertyDataNumeric$2(classProperty, numberOfElements, valuesDataBytes, arrayOffsets) {
  const isArray3 = classProperty.type === "ARRAY";
  const arrayCount = classProperty.componentCount;
  const attributeType = "SCALAR";
  const componentType = classProperty.componentType || classProperty.type;
  const elementSize = getArrayElementByteSize$1(attributeType, componentType);
  const elementCount = valuesDataBytes.byteLength / elementSize;
  const valuesData = convertRawBufferToMetadataArray$1(valuesDataBytes, attributeType, componentType, elementCount);
  if (isArray3) {
    if (arrayOffsets) {
      return parseVariableLengthArrayNumeric$1(valuesData, numberOfElements, arrayOffsets, valuesDataBytes.length, elementSize);
    }
    if (arrayCount) {
      return parseFixedLengthArrayNumeric$1(valuesData, numberOfElements, arrayCount);
    }
    return [];
  }
  return valuesData;
}
function getPropertyDataFromTexture$1(scenegraph, featureTextureProperty, attributeName) {
  const json = scenegraph.gltf.json;
  if (!json.meshes) {
    return [];
  }
  const featureTextureTable = [];
  for (const mesh of json.meshes) {
    for (const primitive of mesh.primitives) {
      processPrimitiveTextures$1(scenegraph, attributeName, featureTextureProperty, featureTextureTable, primitive);
    }
  }
  return featureTextureTable;
}
function processPrimitiveTextures$1(scenegraph, attributeName, featureTextureProperty, featureTextureTable, primitive) {
  const textureInfoTopLevel = {
    channels: featureTextureProperty.channels,
    ...featureTextureProperty.texture
  };
  const propertyData = getPrimitiveTextureData$1(scenegraph, textureInfoTopLevel, primitive);
  if (!propertyData) {
    return;
  }
  primitivePropertyDataToAttributes$1(scenegraph, attributeName, propertyData, featureTextureTable, primitive);
}
const EXT_feature_metadata$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$h,
  name: name$k
}, Symbol.toStringTag, { value: "Module" }));
const VERSION$9 = "4.2.0";
const LITTLE_ENDIAN$2 = true;
const MAGIC_glTF$1 = 1735152710;
const GLB_FILE_HEADER_SIZE$1 = 12;
const GLB_CHUNK_HEADER_SIZE$1 = 8;
const GLB_CHUNK_TYPE_JSON$1 = 1313821514;
const GLB_CHUNK_TYPE_BIN$1 = 5130562;
const GLB_V1_CONTENT_FORMAT_JSON$1 = 0;
const GLB_CHUNK_TYPE_JSON_XVIZ_DEPRECATED$1 = 0;
const GLB_CHUNK_TYPE_BIX_XVIZ_DEPRECATED$1 = 1;
function getMagicString$4(dataView, byteOffset = 0) {
  return `${String.fromCharCode(dataView.getUint8(byteOffset + 0))}${String.fromCharCode(dataView.getUint8(byteOffset + 1))}${String.fromCharCode(dataView.getUint8(byteOffset + 2))}${String.fromCharCode(dataView.getUint8(byteOffset + 3))}`;
}
function isGLB$1(arrayBuffer2, byteOffset = 0, options2 = {}) {
  const dataView = new DataView(arrayBuffer2);
  const { magic = MAGIC_glTF$1 } = options2;
  const magic1 = dataView.getUint32(byteOffset, false);
  return magic1 === magic || magic1 === MAGIC_glTF$1;
}
function parseGLBSync$1(glb, arrayBuffer2, byteOffset = 0, options2 = {}) {
  const dataView = new DataView(arrayBuffer2);
  const type = getMagicString$4(dataView, byteOffset + 0);
  const version2 = dataView.getUint32(byteOffset + 4, LITTLE_ENDIAN$2);
  const byteLength = dataView.getUint32(byteOffset + 8, LITTLE_ENDIAN$2);
  Object.assign(glb, {
    // Put less important stuff in a header, to avoid clutter
    header: {
      byteOffset,
      // Byte offset into the initial arrayBuffer
      byteLength,
      hasBinChunk: false
    },
    type,
    version: version2,
    json: {},
    binChunks: []
  });
  byteOffset += GLB_FILE_HEADER_SIZE$1;
  switch (glb.version) {
    case 1:
      return parseGLBV1$1(glb, dataView, byteOffset);
    case 2:
      return parseGLBV2$1(glb, dataView, byteOffset, options2 = {});
    default:
      throw new Error(`Invalid GLB version ${glb.version}. Only supports version 1 and 2.`);
  }
}
function parseGLBV1$1(glb, dataView, byteOffset) {
  assert$e(glb.header.byteLength > GLB_FILE_HEADER_SIZE$1 + GLB_CHUNK_HEADER_SIZE$1);
  const contentLength = dataView.getUint32(byteOffset + 0, LITTLE_ENDIAN$2);
  const contentFormat = dataView.getUint32(byteOffset + 4, LITTLE_ENDIAN$2);
  byteOffset += GLB_CHUNK_HEADER_SIZE$1;
  assert$e(contentFormat === GLB_V1_CONTENT_FORMAT_JSON$1);
  parseJSONChunk$1(glb, dataView, byteOffset, contentLength);
  byteOffset += contentLength;
  byteOffset += parseBINChunk$1(glb, dataView, byteOffset, glb.header.byteLength);
  return byteOffset;
}
function parseGLBV2$1(glb, dataView, byteOffset, options2) {
  assert$e(glb.header.byteLength > GLB_FILE_HEADER_SIZE$1 + GLB_CHUNK_HEADER_SIZE$1);
  parseGLBChunksSync$1(glb, dataView, byteOffset, options2);
  return byteOffset + glb.header.byteLength;
}
function parseGLBChunksSync$1(glb, dataView, byteOffset, options2) {
  while (byteOffset + 8 <= glb.header.byteLength) {
    const chunkLength = dataView.getUint32(byteOffset + 0, LITTLE_ENDIAN$2);
    const chunkFormat = dataView.getUint32(byteOffset + 4, LITTLE_ENDIAN$2);
    byteOffset += GLB_CHUNK_HEADER_SIZE$1;
    switch (chunkFormat) {
      case GLB_CHUNK_TYPE_JSON$1:
        parseJSONChunk$1(glb, dataView, byteOffset, chunkLength);
        break;
      case GLB_CHUNK_TYPE_BIN$1:
        parseBINChunk$1(glb, dataView, byteOffset, chunkLength);
        break;
      case GLB_CHUNK_TYPE_JSON_XVIZ_DEPRECATED$1:
        if (!options2.strict) {
          parseJSONChunk$1(glb, dataView, byteOffset, chunkLength);
        }
        break;
      case GLB_CHUNK_TYPE_BIX_XVIZ_DEPRECATED$1:
        if (!options2.strict) {
          parseBINChunk$1(glb, dataView, byteOffset, chunkLength);
        }
        break;
    }
    byteOffset += padToNBytes$1(chunkLength, 4);
  }
  return byteOffset;
}
function parseJSONChunk$1(glb, dataView, byteOffset, chunkLength) {
  const jsonChunk = new Uint8Array(dataView.buffer, byteOffset, chunkLength);
  const textDecoder = new TextDecoder("utf8");
  const jsonText = textDecoder.decode(jsonChunk);
  glb.json = JSON.parse(jsonText);
  return padToNBytes$1(chunkLength, 4);
}
function parseBINChunk$1(glb, dataView, byteOffset, chunkLength) {
  glb.header.hasBinChunk = true;
  glb.binChunks.push({
    byteOffset,
    byteLength: chunkLength,
    arrayBuffer: dataView.buffer
    // TODO - copy, or create typed array view?
  });
  return padToNBytes$1(chunkLength, 4);
}
function resolveUrl$1(url2, options2) {
  const absolute2 = url2.startsWith("data:") || url2.startsWith("http:") || url2.startsWith("https:");
  if (absolute2) {
    return url2;
  }
  const baseUrl = options2.baseUri || options2.uri;
  if (!baseUrl) {
    throw new Error(`'baseUri' must be provided to resolve relative url ${url2}`);
  }
  return baseUrl.substr(0, baseUrl.lastIndexOf("/") + 1) + url2;
}
const wasm_base$1 = "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";
const wasm_simd$1 = "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";
const detector$1 = new Uint8Array([
  0,
  97,
  115,
  109,
  1,
  0,
  0,
  0,
  1,
  4,
  1,
  96,
  0,
  0,
  3,
  3,
  2,
  0,
  0,
  5,
  3,
  1,
  0,
  1,
  12,
  1,
  0,
  10,
  22,
  2,
  12,
  0,
  65,
  0,
  65,
  0,
  65,
  0,
  252,
  10,
  0,
  0,
  11,
  7,
  0,
  65,
  0,
  253,
  15,
  26,
  11
]);
const wasmpack$1 = new Uint8Array([
  32,
  0,
  65,
  253,
  3,
  1,
  2,
  34,
  4,
  106,
  6,
  5,
  11,
  8,
  7,
  20,
  13,
  33,
  12,
  16,
  128,
  9,
  116,
  64,
  19,
  113,
  127,
  15,
  10,
  21,
  22,
  14,
  255,
  66,
  24,
  54,
  136,
  107,
  18,
  23,
  192,
  26,
  114,
  118,
  132,
  17,
  77,
  101,
  130,
  144,
  27,
  87,
  131,
  44,
  45,
  74,
  156,
  154,
  70,
  167
]);
const FILTERS$1 = {
  // legacy index-based enums for glTF
  0: "",
  1: "meshopt_decodeFilterOct",
  2: "meshopt_decodeFilterQuat",
  3: "meshopt_decodeFilterExp",
  // string-based enums for glTF
  NONE: "",
  OCTAHEDRAL: "meshopt_decodeFilterOct",
  QUATERNION: "meshopt_decodeFilterQuat",
  EXPONENTIAL: "meshopt_decodeFilterExp"
};
const DECODERS$1 = {
  // legacy index-based enums for glTF
  0: "meshopt_decodeVertexBuffer",
  1: "meshopt_decodeIndexBuffer",
  2: "meshopt_decodeIndexSequence",
  // string-based enums for glTF
  ATTRIBUTES: "meshopt_decodeVertexBuffer",
  TRIANGLES: "meshopt_decodeIndexBuffer",
  INDICES: "meshopt_decodeIndexSequence"
};
async function meshoptDecodeGltfBuffer$1(target, count3, size12, source, mode2, filter17 = "NONE") {
  const instance2 = await loadWasmInstance$1();
  decode$g(instance2, instance2.exports[DECODERS$1[mode2]], target, count3, size12, source, instance2.exports[FILTERS$1[filter17 || "NONE"]]);
}
let wasmPromise$1;
async function loadWasmInstance$1() {
  if (!wasmPromise$1) {
    wasmPromise$1 = loadWasmModule$1();
  }
  return wasmPromise$1;
}
async function loadWasmModule$1() {
  let wasm2 = wasm_base$1;
  if (WebAssembly.validate(detector$1)) {
    wasm2 = wasm_simd$1;
    console.log("Warning: meshopt_decoder is using experimental SIMD support");
  }
  const result = await WebAssembly.instantiate(unpack$1(wasm2), {});
  await result.instance.exports.__wasm_call_ctors();
  return result.instance;
}
function unpack$1(data2) {
  const result = new Uint8Array(data2.length);
  for (let i2 = 0; i2 < data2.length; ++i2) {
    const ch2 = data2.charCodeAt(i2);
    result[i2] = ch2 > 96 ? ch2 - 71 : ch2 > 64 ? ch2 - 65 : ch2 > 47 ? ch2 + 4 : ch2 > 46 ? 63 : 62;
  }
  let write5 = 0;
  for (let i2 = 0; i2 < data2.length; ++i2) {
    result[write5++] = result[i2] < 60 ? wasmpack$1[result[i2]] : (result[i2] - 60) * 64 + result[++i2];
  }
  return result.buffer.slice(0, write5);
}
function decode$g(instance2, fun, target, count3, size12, source, filter17) {
  const sbrk = instance2.exports.sbrk;
  const count4 = count3 + 3 & ~3;
  const tp = sbrk(count4 * size12);
  const sp = sbrk(source.length);
  const heap = new Uint8Array(instance2.exports.memory.buffer);
  heap.set(source, sp);
  const res = fun(tp, count3, size12, sp, source.length);
  if (res === 0 && filter17) {
    filter17(tp, count4, size12);
  }
  target.set(heap.subarray(tp, tp + count3 * size12));
  sbrk(tp - sbrk(0));
  if (res !== 0) {
    throw new Error(`Malformed buffer data: ${res}`);
  }
}
const EXT_MESHOPT_COMPRESSION$1 = "EXT_meshopt_compression";
const name$j = EXT_MESHOPT_COMPRESSION$1;
async function decode$f(gltfData, options2) {
  var _a3, _b3;
  const scenegraph = new GLTFScenegraph$1(gltfData);
  if (!((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.decompressMeshes) || !((_b3 = options2.gltf) == null ? void 0 : _b3.loadBuffers)) {
    return;
  }
  const promises = [];
  for (const bufferViewIndex of gltfData.json.bufferViews || []) {
    promises.push(decodeMeshoptBufferView$1(scenegraph, bufferViewIndex));
  }
  await Promise.all(promises);
  scenegraph.removeExtension(EXT_MESHOPT_COMPRESSION$1);
}
async function decodeMeshoptBufferView$1(scenegraph, bufferView) {
  const meshoptExtension = scenegraph.getObjectExtension(bufferView, EXT_MESHOPT_COMPRESSION$1);
  if (meshoptExtension) {
    const { byteOffset = 0, byteLength = 0, byteStride, count: count3, mode: mode2, filter: filter17 = "NONE", buffer: bufferIndex } = meshoptExtension;
    const buffer3 = scenegraph.gltf.buffers[bufferIndex];
    const source = new Uint8Array(buffer3.arrayBuffer, buffer3.byteOffset + byteOffset, byteLength);
    const result = new Uint8Array(scenegraph.gltf.buffers[bufferView.buffer].arrayBuffer, bufferView.byteOffset, bufferView.byteLength);
    await meshoptDecodeGltfBuffer$1(result, count3, byteStride, source, mode2, filter17);
    scenegraph.removeObjectExtension(bufferView, EXT_MESHOPT_COMPRESSION$1);
  }
}
const EXT_meshopt_compression$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$f,
  name: name$j
}, Symbol.toStringTag, { value: "Module" }));
const EXT_TEXTURE_WEBP$1 = "EXT_texture_webp";
const name$i = EXT_TEXTURE_WEBP$1;
function preprocess$7(gltfData, options2) {
  const scenegraph = new GLTFScenegraph$1(gltfData);
  if (!isImageFormatSupported$1("image/webp")) {
    if (scenegraph.getRequiredExtensions().includes(EXT_TEXTURE_WEBP$1)) {
      throw new Error(`gltf: Required extension ${EXT_TEXTURE_WEBP$1} not supported by browser`);
    }
    return;
  }
  const { json } = scenegraph;
  for (const texture of json.textures || []) {
    const extension = scenegraph.getObjectExtension(texture, EXT_TEXTURE_WEBP$1);
    if (extension) {
      texture.source = extension.source;
    }
    scenegraph.removeObjectExtension(texture, EXT_TEXTURE_WEBP$1);
  }
  scenegraph.removeExtension(EXT_TEXTURE_WEBP$1);
}
const EXT_texture_webp$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$i,
  preprocess: preprocess$7
}, Symbol.toStringTag, { value: "Module" }));
const KHR_TEXTURE_BASISU$1 = "KHR_texture_basisu";
const name$h = KHR_TEXTURE_BASISU$1;
function preprocess$6(gltfData, options2) {
  const scene = new GLTFScenegraph$1(gltfData);
  const { json } = scene;
  for (const texture of json.textures || []) {
    const extension = scene.getObjectExtension(texture, KHR_TEXTURE_BASISU$1);
    if (extension) {
      texture.source = extension.source;
      scene.removeObjectExtension(texture, KHR_TEXTURE_BASISU$1);
    }
  }
  scene.removeExtension(KHR_TEXTURE_BASISU$1);
}
const KHR_texture_basisu$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$h,
  preprocess: preprocess$6
}, Symbol.toStringTag, { value: "Module" }));
const VERSION$8 = "4.2.0";
const DracoLoader$3 = {
  dataType: null,
  batchType: null,
  name: "Draco",
  id: "draco",
  module: "draco",
  // shapes: ['mesh'],
  version: VERSION$8,
  worker: true,
  extensions: ["drc"],
  mimeTypes: ["application/octet-stream"],
  binary: true,
  tests: ["DRACO"],
  options: {
    draco: {
      decoderType: typeof WebAssembly === "object" ? "wasm" : "js",
      // 'js' for IE11
      libraryPath: "libs/",
      extraAttributes: {},
      attributeNameEntry: void 0
    }
  }
};
function getDracoSchema$1(attributes, loaderData, indices) {
  const metadata = makeMetadata$1(loaderData.metadata);
  const fields = [];
  const namedLoaderDataAttributes = transformAttributesLoaderData$1(loaderData.attributes);
  for (const attributeName in attributes) {
    const attribute = attributes[attributeName];
    const field = getArrowFieldFromAttribute$1(attributeName, attribute, namedLoaderDataAttributes[attributeName]);
    fields.push(field);
  }
  if (indices) {
    const indicesField = getArrowFieldFromAttribute$1("indices", indices);
    fields.push(indicesField);
  }
  return { fields, metadata };
}
function transformAttributesLoaderData$1(loaderData) {
  const result = {};
  for (const key in loaderData) {
    const dracoAttribute = loaderData[key];
    result[dracoAttribute.name || "undefined"] = dracoAttribute;
  }
  return result;
}
function getArrowFieldFromAttribute$1(attributeName, attribute, loaderData) {
  const metadataMap = loaderData ? makeMetadata$1(loaderData.metadata) : void 0;
  const field = deduceMeshField$1(attributeName, attribute, metadataMap);
  return field;
}
function makeMetadata$1(metadata) {
  const serializedMetadata = {};
  for (const key in metadata) {
    serializedMetadata[`${key}.string`] = JSON.stringify(metadata[key]);
  }
  return serializedMetadata;
}
const DRACO_TO_GLTF_ATTRIBUTE_NAME_MAP$1 = {
  POSITION: "POSITION",
  NORMAL: "NORMAL",
  COLOR: "COLOR_0",
  TEX_COORD: "TEXCOORD_0"
};
const DRACO_DATA_TYPE_TO_TYPED_ARRAY_MAP$1 = {
  1: Int8Array,
  2: Uint8Array,
  3: Int16Array,
  4: Uint16Array,
  5: Int32Array,
  6: Uint32Array,
  // 7: BigInt64Array,
  // 8: BigUint64Array,
  9: Float32Array
  // 10: Float64Array
  // 11: BOOL - What array type do we use for this?
};
const INDEX_ITEM_SIZE$1 = 4;
let DracoParser$1 = class DracoParser2 {
  // draco - the draco decoder, either import `draco3d` or load dynamically
  constructor(draco) {
    __publicField2(this, "draco");
    __publicField2(this, "decoder");
    __publicField2(this, "metadataQuerier");
    this.draco = draco;
    this.decoder = new this.draco.Decoder();
    this.metadataQuerier = new this.draco.MetadataQuerier();
  }
  /**
   * Destroy draco resources
   */
  destroy() {
    this.draco.destroy(this.decoder);
    this.draco.destroy(this.metadataQuerier);
  }
  /**
   * NOTE: caller must call `destroyGeometry` on the return value after using it
   * @param arrayBuffer
   * @param options
   */
  parseSync(arrayBuffer2, options2 = {}) {
    const buffer3 = new this.draco.DecoderBuffer();
    buffer3.Init(new Int8Array(arrayBuffer2), arrayBuffer2.byteLength);
    this._disableAttributeTransforms(options2);
    const geometry_type = this.decoder.GetEncodedGeometryType(buffer3);
    const dracoGeometry = geometry_type === this.draco.TRIANGULAR_MESH ? new this.draco.Mesh() : new this.draco.PointCloud();
    try {
      let dracoStatus;
      switch (geometry_type) {
        case this.draco.TRIANGULAR_MESH:
          dracoStatus = this.decoder.DecodeBufferToMesh(buffer3, dracoGeometry);
          break;
        case this.draco.POINT_CLOUD:
          dracoStatus = this.decoder.DecodeBufferToPointCloud(buffer3, dracoGeometry);
          break;
        default:
          throw new Error("DRACO: Unknown geometry type.");
      }
      if (!dracoStatus.ok() || !dracoGeometry.ptr) {
        const message2 = `DRACO decompression failed: ${dracoStatus.error_msg()}`;
        throw new Error(message2);
      }
      const loaderData = this._getDracoLoaderData(dracoGeometry, geometry_type, options2);
      const geometry2 = this._getMeshData(dracoGeometry, loaderData, options2);
      const boundingBox = getMeshBoundingBox$1(geometry2.attributes);
      const schema = getDracoSchema$1(geometry2.attributes, loaderData, geometry2.indices);
      const data2 = {
        loader: "draco",
        loaderData,
        header: {
          vertexCount: dracoGeometry.num_points(),
          boundingBox
        },
        ...geometry2,
        schema
      };
      return data2;
    } finally {
      this.draco.destroy(buffer3);
      if (dracoGeometry) {
        this.draco.destroy(dracoGeometry);
      }
    }
  }
  // Draco specific "loader data"
  /**
   * Extract
   * @param dracoGeometry
   * @param geometry_type
   * @param options
   * @returns
   */
  _getDracoLoaderData(dracoGeometry, geometry_type, options2) {
    const metadata = this._getTopLevelMetadata(dracoGeometry);
    const attributes = this._getDracoAttributes(dracoGeometry, options2);
    return {
      geometry_type,
      num_attributes: dracoGeometry.num_attributes(),
      num_points: dracoGeometry.num_points(),
      num_faces: dracoGeometry instanceof this.draco.Mesh ? dracoGeometry.num_faces() : 0,
      metadata,
      attributes
    };
  }
  /**
   * Extract all draco provided information and metadata for each attribute
   * @param dracoGeometry
   * @param options
   * @returns
   */
  _getDracoAttributes(dracoGeometry, options2) {
    const dracoAttributes = {};
    for (let attributeId = 0; attributeId < dracoGeometry.num_attributes(); attributeId++) {
      const dracoAttribute = this.decoder.GetAttribute(dracoGeometry, attributeId);
      const metadata = this._getAttributeMetadata(dracoGeometry, attributeId);
      dracoAttributes[dracoAttribute.unique_id()] = {
        unique_id: dracoAttribute.unique_id(),
        attribute_type: dracoAttribute.attribute_type(),
        data_type: dracoAttribute.data_type(),
        num_components: dracoAttribute.num_components(),
        byte_offset: dracoAttribute.byte_offset(),
        byte_stride: dracoAttribute.byte_stride(),
        normalized: dracoAttribute.normalized(),
        attribute_index: attributeId,
        metadata
      };
      const quantization = this._getQuantizationTransform(dracoAttribute, options2);
      if (quantization) {
        dracoAttributes[dracoAttribute.unique_id()].quantization_transform = quantization;
      }
      const octahedron = this._getOctahedronTransform(dracoAttribute, options2);
      if (octahedron) {
        dracoAttributes[dracoAttribute.unique_id()].octahedron_transform = octahedron;
      }
    }
    return dracoAttributes;
  }
  /**
   * Get standard loaders.gl mesh category data
   * Extracts the geometry from draco
   * @param dracoGeometry
   * @param options
   */
  _getMeshData(dracoGeometry, loaderData, options2) {
    const attributes = this._getMeshAttributes(loaderData, dracoGeometry, options2);
    const positionAttribute = attributes.POSITION;
    if (!positionAttribute) {
      throw new Error("DRACO: No position attribute found.");
    }
    if (dracoGeometry instanceof this.draco.Mesh) {
      switch (options2.topology) {
        case "triangle-strip":
          return {
            topology: "triangle-strip",
            mode: 4,
            // GL.TRIANGLES
            attributes,
            indices: {
              value: this._getTriangleStripIndices(dracoGeometry),
              size: 1
            }
          };
        case "triangle-list":
        default:
          return {
            topology: "triangle-list",
            mode: 5,
            // GL.TRIANGLE_STRIP
            attributes,
            indices: {
              value: this._getTriangleListIndices(dracoGeometry),
              size: 1
            }
          };
      }
    }
    return {
      topology: "point-list",
      mode: 0,
      // GL.POINTS
      attributes
    };
  }
  _getMeshAttributes(loaderData, dracoGeometry, options2) {
    const attributes = {};
    for (const loaderAttribute of Object.values(loaderData.attributes)) {
      const attributeName = this._deduceAttributeName(loaderAttribute, options2);
      loaderAttribute.name = attributeName;
      const values4 = this._getAttributeValues(dracoGeometry, loaderAttribute);
      if (values4) {
        const { value, size: size12 } = values4;
        attributes[attributeName] = {
          value,
          size: size12,
          byteOffset: loaderAttribute.byte_offset,
          byteStride: loaderAttribute.byte_stride,
          normalized: loaderAttribute.normalized
        };
      }
    }
    return attributes;
  }
  // MESH INDICES EXTRACTION
  /**
   * For meshes, we need indices to define the faces.
   * @param dracoGeometry
   */
  _getTriangleListIndices(dracoGeometry) {
    const numFaces = dracoGeometry.num_faces();
    const numIndices = numFaces * 3;
    const byteLength = numIndices * INDEX_ITEM_SIZE$1;
    const ptr = this.draco._malloc(byteLength);
    try {
      this.decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
      return new Uint32Array(this.draco.HEAPF32.buffer, ptr, numIndices).slice();
    } finally {
      this.draco._free(ptr);
    }
  }
  /**
   * For meshes, we need indices to define the faces.
   * @param dracoGeometry
   */
  _getTriangleStripIndices(dracoGeometry) {
    const dracoArray = new this.draco.DracoInt32Array();
    try {
      this.decoder.GetTriangleStripsFromMesh(dracoGeometry, dracoArray);
      return getUint32Array$1(dracoArray);
    } finally {
      this.draco.destroy(dracoArray);
    }
  }
  /**
   *
   * @param dracoGeometry
   * @param dracoAttribute
   * @param attributeName
   */
  _getAttributeValues(dracoGeometry, attribute) {
    const TypedArrayCtor = DRACO_DATA_TYPE_TO_TYPED_ARRAY_MAP$1[attribute.data_type];
    if (!TypedArrayCtor) {
      console.warn(`DRACO: Unsupported attribute type ${attribute.data_type}`);
      return null;
    }
    const numComponents = attribute.num_components;
    const numPoints = dracoGeometry.num_points();
    const numValues = numPoints * numComponents;
    const byteLength = numValues * TypedArrayCtor.BYTES_PER_ELEMENT;
    const dataType = getDracoDataType$1(this.draco, TypedArrayCtor);
    let value;
    const ptr = this.draco._malloc(byteLength);
    try {
      const dracoAttribute = this.decoder.GetAttribute(dracoGeometry, attribute.attribute_index);
      this.decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, dracoAttribute, dataType, byteLength, ptr);
      value = new TypedArrayCtor(this.draco.HEAPF32.buffer, ptr, numValues).slice();
    } finally {
      this.draco._free(ptr);
    }
    return { value, size: numComponents };
  }
  // Attribute names
  /**
   * DRACO does not store attribute names - We need to deduce an attribute name
   * for each attribute
  _getAttributeNames(
    dracoGeometry: Mesh | PointCloud,
    options: DracoParseOptions
  ): {[unique_id: number]: string} {
    const attributeNames: {[unique_id: number]: string} = {};
    for (let attributeId = 0; attributeId < dracoGeometry.num_attributes(); attributeId++) {
      const dracoAttribute = this.decoder.GetAttribute(dracoGeometry, attributeId);
      const attributeName = this._deduceAttributeName(dracoAttribute, options);
      attributeNames[attributeName] = attributeName;
    }
    return attributeNames;
  }
   */
  /**
   * Deduce an attribute name.
   * @note DRACO does not save attribute names, just general type (POSITION, COLOR)
   * to help optimize compression. We generate GLTF compatible names for the Draco-recognized
   * types
   * @param attributeData
   */
  _deduceAttributeName(attribute, options2) {
    const uniqueId = attribute.unique_id;
    for (const [attributeName, attributeUniqueId] of Object.entries(options2.extraAttributes || {})) {
      if (attributeUniqueId === uniqueId) {
        return attributeName;
      }
    }
    const thisAttributeType = attribute.attribute_type;
    for (const dracoAttributeConstant in DRACO_TO_GLTF_ATTRIBUTE_NAME_MAP$1) {
      const attributeType = this.draco[dracoAttributeConstant];
      if (attributeType === thisAttributeType) {
        return DRACO_TO_GLTF_ATTRIBUTE_NAME_MAP$1[dracoAttributeConstant];
      }
    }
    const entryName = options2.attributeNameEntry || "name";
    if (attribute.metadata[entryName]) {
      return attribute.metadata[entryName].string;
    }
    return `CUSTOM_ATTRIBUTE_${uniqueId}`;
  }
  // METADATA EXTRACTION
  /** Get top level metadata */
  _getTopLevelMetadata(dracoGeometry) {
    const dracoMetadata = this.decoder.GetMetadata(dracoGeometry);
    return this._getDracoMetadata(dracoMetadata);
  }
  /** Get per attribute metadata */
  _getAttributeMetadata(dracoGeometry, attributeId) {
    const dracoMetadata = this.decoder.GetAttributeMetadata(dracoGeometry, attributeId);
    return this._getDracoMetadata(dracoMetadata);
  }
  /**
   * Extract metadata field values
   * @param dracoMetadata
   * @returns
   */
  _getDracoMetadata(dracoMetadata) {
    if (!dracoMetadata || !dracoMetadata.ptr) {
      return {};
    }
    const result = {};
    const numEntries = this.metadataQuerier.NumEntries(dracoMetadata);
    for (let entryIndex = 0; entryIndex < numEntries; entryIndex++) {
      const entryName = this.metadataQuerier.GetEntryName(dracoMetadata, entryIndex);
      result[entryName] = this._getDracoMetadataField(dracoMetadata, entryName);
    }
    return result;
  }
  /**
   * Extracts possible values for one metadata entry by name
   * @param dracoMetadata
   * @param entryName
   */
  _getDracoMetadataField(dracoMetadata, entryName) {
    const dracoArray = new this.draco.DracoInt32Array();
    try {
      this.metadataQuerier.GetIntEntryArray(dracoMetadata, entryName, dracoArray);
      const intArray = getInt32Array$1(dracoArray);
      return {
        int: this.metadataQuerier.GetIntEntry(dracoMetadata, entryName),
        string: this.metadataQuerier.GetStringEntry(dracoMetadata, entryName),
        double: this.metadataQuerier.GetDoubleEntry(dracoMetadata, entryName),
        intArray
      };
    } finally {
      this.draco.destroy(dracoArray);
    }
  }
  // QUANTIZED ATTRIBUTE SUPPORT (NO DECOMPRESSION)
  /** Skip transforms for specific attribute types */
  _disableAttributeTransforms(options2) {
    const { quantizedAttributes = [], octahedronAttributes = [] } = options2;
    const skipAttributes = [...quantizedAttributes, ...octahedronAttributes];
    for (const dracoAttributeName of skipAttributes) {
      this.decoder.SkipAttributeTransform(this.draco[dracoAttributeName]);
    }
  }
  /**
   * Extract (and apply?) Position Transform
   * @todo not used
   */
  _getQuantizationTransform(dracoAttribute, options2) {
    const { quantizedAttributes = [] } = options2;
    const attribute_type = dracoAttribute.attribute_type();
    const skip = quantizedAttributes.map((type) => this.decoder[type]).includes(attribute_type);
    if (skip) {
      const transform4 = new this.draco.AttributeQuantizationTransform();
      try {
        if (transform4.InitFromAttribute(dracoAttribute)) {
          return {
            quantization_bits: transform4.quantization_bits(),
            range: transform4.range(),
            min_values: new Float32Array([1, 2, 3]).map((i2) => transform4.min_value(i2))
          };
        }
      } finally {
        this.draco.destroy(transform4);
      }
    }
    return null;
  }
  _getOctahedronTransform(dracoAttribute, options2) {
    const { octahedronAttributes = [] } = options2;
    const attribute_type = dracoAttribute.attribute_type();
    const octahedron = octahedronAttributes.map((type) => this.decoder[type]).includes(attribute_type);
    if (octahedron) {
      const transform4 = new this.draco.AttributeQuantizationTransform();
      try {
        if (transform4.InitFromAttribute(dracoAttribute)) {
          return {
            quantization_bits: transform4.quantization_bits()
          };
        }
      } finally {
        this.draco.destroy(transform4);
      }
    }
    return null;
  }
};
function getDracoDataType$1(draco, attributeType) {
  switch (attributeType) {
    case Float32Array:
      return draco.DT_FLOAT32;
    case Int8Array:
      return draco.DT_INT8;
    case Int16Array:
      return draco.DT_INT16;
    case Int32Array:
      return draco.DT_INT32;
    case Uint8Array:
      return draco.DT_UINT8;
    case Uint16Array:
      return draco.DT_UINT16;
    case Uint32Array:
      return draco.DT_UINT32;
    default:
      return draco.DT_INVALID;
  }
}
function getInt32Array$1(dracoArray) {
  const numValues = dracoArray.size();
  const intArray = new Int32Array(numValues);
  for (let i2 = 0; i2 < numValues; i2++) {
    intArray[i2] = dracoArray.GetValue(i2);
  }
  return intArray;
}
function getUint32Array$1(dracoArray) {
  const numValues = dracoArray.size();
  const intArray = new Int32Array(numValues);
  for (let i2 = 0; i2 < numValues; i2++) {
    intArray[i2] = dracoArray.GetValue(i2);
  }
  return intArray;
}
const DRACO_DECODER_VERSION$1 = "1.5.6";
const DRACO_ENCODER_VERSION$1 = "1.4.1";
const STATIC_DECODER_URL$1 = `https://www.gstatic.com/draco/versioned/decoders/${DRACO_DECODER_VERSION$1}`;
const DRACO_EXTERNAL_LIBRARIES$1 = {
  /** The primary Draco3D encoder, javascript wrapper part */
  DECODER: "draco_wasm_wrapper.js",
  /** The primary draco decoder, compiled web assembly part */
  DECODER_WASM: "draco_decoder.wasm",
  /** Fallback decoder for non-webassebly environments. Very big bundle, lower performance */
  FALLBACK_DECODER: "draco_decoder.js",
  /** Draco encoder */
  ENCODER: "draco_encoder.js"
};
const DRACO_EXTERNAL_LIBRARY_URLS$1 = {
  [DRACO_EXTERNAL_LIBRARIES$1.DECODER]: `${STATIC_DECODER_URL$1}/${DRACO_EXTERNAL_LIBRARIES$1.DECODER}`,
  [DRACO_EXTERNAL_LIBRARIES$1.DECODER_WASM]: `${STATIC_DECODER_URL$1}/${DRACO_EXTERNAL_LIBRARIES$1.DECODER_WASM}`,
  [DRACO_EXTERNAL_LIBRARIES$1.FALLBACK_DECODER]: `${STATIC_DECODER_URL$1}/${DRACO_EXTERNAL_LIBRARIES$1.FALLBACK_DECODER}`,
  [DRACO_EXTERNAL_LIBRARIES$1.ENCODER]: `https://raw.githubusercontent.com/google/draco/${DRACO_ENCODER_VERSION$1}/javascript/${DRACO_EXTERNAL_LIBRARIES$1.ENCODER}`
};
let loadDecoderPromise$1;
async function loadDracoDecoderModule$1(options2) {
  const modules = options2.modules || {};
  if (modules.draco3d) {
    loadDecoderPromise$1 || (loadDecoderPromise$1 = modules.draco3d.createDecoderModule({}).then((draco) => {
      return { draco };
    }));
  } else {
    loadDecoderPromise$1 || (loadDecoderPromise$1 = loadDracoDecoder$1(options2));
  }
  return await loadDecoderPromise$1;
}
async function loadDracoDecoder$1(options2) {
  let DracoDecoderModule2;
  let wasmBinary;
  switch (options2.draco && options2.draco.decoderType) {
    case "js":
      DracoDecoderModule2 = await loadLibrary$1(DRACO_EXTERNAL_LIBRARY_URLS$1[DRACO_EXTERNAL_LIBRARIES$1.FALLBACK_DECODER], "draco", options2, DRACO_EXTERNAL_LIBRARIES$1.FALLBACK_DECODER);
      break;
    case "wasm":
    default:
      [DracoDecoderModule2, wasmBinary] = await Promise.all([
        await loadLibrary$1(DRACO_EXTERNAL_LIBRARY_URLS$1[DRACO_EXTERNAL_LIBRARIES$1.DECODER], "draco", options2, DRACO_EXTERNAL_LIBRARIES$1.DECODER),
        await loadLibrary$1(DRACO_EXTERNAL_LIBRARY_URLS$1[DRACO_EXTERNAL_LIBRARIES$1.DECODER_WASM], "draco", options2, DRACO_EXTERNAL_LIBRARIES$1.DECODER_WASM)
      ]);
  }
  DracoDecoderModule2 = DracoDecoderModule2 || globalThis.DracoDecoderModule;
  return await initializeDracoDecoder$1(DracoDecoderModule2, wasmBinary);
}
function initializeDracoDecoder$1(DracoDecoderModule2, wasmBinary) {
  const options2 = {};
  if (wasmBinary) {
    options2.wasmBinary = wasmBinary;
  }
  return new Promise((resolve2) => {
    DracoDecoderModule2({
      ...options2,
      onModuleLoaded: (draco) => resolve2({ draco })
      // Module is Promise-like. Wrap in object to avoid loop.
    });
  });
}
const DracoLoader$2 = {
  ...DracoLoader$3,
  parse: parse$6
};
async function parse$6(arrayBuffer2, options2) {
  const { draco } = await loadDracoDecoderModule$1(options2);
  const dracoParser = new DracoParser$1(draco);
  try {
    return dracoParser.parseSync(arrayBuffer2, options2 == null ? void 0 : options2.draco);
  } finally {
    dracoParser.destroy();
  }
}
function getGLTFAccessors$1(attributes) {
  const accessors = {};
  for (const name2 in attributes) {
    const attribute = attributes[name2];
    if (name2 !== "indices") {
      const glTFAccessor = getGLTFAccessor$1(attribute);
      accessors[name2] = glTFAccessor;
    }
  }
  return accessors;
}
function getGLTFAccessor$1(attribute) {
  const { buffer: buffer3, size: size12, count: count3 } = getAccessorData$1(attribute);
  const glTFAccessor = {
    // glTF Accessor values
    // TODO: Instead of a bufferView index we could have an actual buffer (typed array)
    // bufferView: null,
    // TODO: Deprecate `value` in favor of bufferView?
    // @ts-ignore
    value: buffer3,
    size: size12,
    // Decoded `type` (e.g. SCALAR)
    byteOffset: 0,
    count: count3,
    type: getAccessorTypeFromSize$1(size12),
    componentType: getComponentTypeFromArray$1(buffer3)
  };
  return glTFAccessor;
}
function getAccessorData$1(attribute) {
  let buffer3 = attribute;
  let size12 = 1;
  let count3 = 0;
  if (attribute && attribute.value) {
    buffer3 = attribute.value;
    size12 = attribute.size || 1;
  }
  if (buffer3) {
    if (!ArrayBuffer.isView(buffer3)) {
      buffer3 = toTypedArray$1(buffer3, Float32Array);
    }
    count3 = buffer3.length / size12;
  }
  return { buffer: buffer3, size: size12, count: count3 };
}
function toTypedArray$1(array2, ArrayType2, convertTypedArrays = false) {
  if (!array2) {
    return null;
  }
  if (Array.isArray(array2)) {
    return new ArrayType2(array2);
  }
  if (convertTypedArrays && !(array2 instanceof ArrayType2)) {
    return new ArrayType2(array2);
  }
  return array2;
}
const KHR_DRACO_MESH_COMPRESSION$1 = "KHR_draco_mesh_compression";
const name$g = KHR_DRACO_MESH_COMPRESSION$1;
function preprocess$5(gltfData, options2, context2) {
  const scenegraph = new GLTFScenegraph$1(gltfData);
  for (const primitive of makeMeshPrimitiveIterator$1(scenegraph)) {
    if (scenegraph.getObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION$1))
      ;
  }
}
async function decode$e(gltfData, options2, context2) {
  var _a3;
  if (!((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.decompressMeshes)) {
    return;
  }
  const scenegraph = new GLTFScenegraph$1(gltfData);
  const promises = [];
  for (const primitive of makeMeshPrimitiveIterator$1(scenegraph)) {
    if (scenegraph.getObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION$1)) {
      promises.push(decompressPrimitive$1(scenegraph, primitive, options2, context2));
    }
  }
  await Promise.all(promises);
  scenegraph.removeExtension(KHR_DRACO_MESH_COMPRESSION$1);
}
function encode$7(gltfData, options2 = {}) {
  const scenegraph = new GLTFScenegraph$1(gltfData);
  for (const mesh of scenegraph.json.meshes || []) {
    compressMesh$1(mesh);
    scenegraph.addRequiredExtension(KHR_DRACO_MESH_COMPRESSION$1);
  }
}
async function decompressPrimitive$1(scenegraph, primitive, options2, context2) {
  const dracoExtension = scenegraph.getObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION$1);
  if (!dracoExtension) {
    return;
  }
  const buffer3 = scenegraph.getTypedArrayForBufferView(dracoExtension.bufferView);
  const bufferCopy = sliceArrayBuffer$1(buffer3.buffer, buffer3.byteOffset);
  const dracoOptions = { ...options2 };
  delete dracoOptions["3d-tiles"];
  const decodedData = await parseFromContext$1(bufferCopy, DracoLoader$2, dracoOptions, context2);
  const decodedAttributes = getGLTFAccessors$1(decodedData.attributes);
  for (const [attributeName, decodedAttribute] of Object.entries(decodedAttributes)) {
    if (attributeName in primitive.attributes) {
      const accessorIndex = primitive.attributes[attributeName];
      const accessor = scenegraph.getAccessor(accessorIndex);
      if ((accessor == null ? void 0 : accessor.min) && (accessor == null ? void 0 : accessor.max)) {
        decodedAttribute.min = accessor.min;
        decodedAttribute.max = accessor.max;
      }
    }
  }
  primitive.attributes = decodedAttributes;
  if (decodedData.indices) {
    primitive.indices = getGLTFAccessor$1(decodedData.indices);
  }
  scenegraph.removeObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION$1);
  checkPrimitive$1(primitive);
}
function compressMesh$1(attributes, indices, mode2 = 4, options2, context2) {
  var _a3;
  if (!options2.DracoWriter) {
    throw new Error("options.gltf.DracoWriter not provided");
  }
  const compressedData = options2.DracoWriter.encodeSync({ attributes });
  const decodedData = (_a3 = context2 == null ? void 0 : context2.parseSync) == null ? void 0 : _a3.call(context2, { attributes });
  const fauxAccessors = options2._addFauxAttributes(decodedData.attributes);
  const bufferViewIndex = options2.addBufferView(compressedData);
  const glTFMesh = {
    primitives: [
      {
        attributes: fauxAccessors,
        // TODO - verify with spec
        mode: mode2,
        // GL.POINTS
        extensions: {
          [KHR_DRACO_MESH_COMPRESSION$1]: {
            bufferView: bufferViewIndex,
            attributes: fauxAccessors
            // TODO - verify with spec
          }
        }
      }
    ]
  };
  return glTFMesh;
}
function checkPrimitive$1(primitive) {
  if (!primitive.attributes && Object.keys(primitive.attributes).length > 0) {
    throw new Error("glTF: Empty primitive detected: Draco decompression failure?");
  }
}
function* makeMeshPrimitiveIterator$1(scenegraph) {
  for (const mesh of scenegraph.json.meshes || []) {
    for (const primitive of mesh.primitives) {
      yield primitive;
    }
  }
}
const KHR_draco_mesh_compression$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$e,
  encode: encode$7,
  name: name$g,
  preprocess: preprocess$5
}, Symbol.toStringTag, { value: "Module" }));
const KHR_TEXTURE_TRANSFORM$1 = "KHR_texture_transform";
const name$f = KHR_TEXTURE_TRANSFORM$1;
const scratchVector$6 = new Vector3();
const scratchRotationMatrix$1 = new Matrix3();
const scratchScaleMatrix$1 = new Matrix3();
async function decode$d(gltfData, options2) {
  var _a3;
  const gltfScenegraph = new GLTFScenegraph$1(gltfData);
  const hasExtension = gltfScenegraph.hasExtension(KHR_TEXTURE_TRANSFORM$1);
  if (!hasExtension || !((_a3 = options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const materials = gltfData.json.materials || [];
  for (let i2 = 0; i2 < materials.length; i2++) {
    transformTexCoords$1(i2, gltfData);
  }
}
function transformTexCoords$1(materialIndex, gltfData) {
  var _a3, _b3, _c2, _d2;
  const material = (_a3 = gltfData.json.materials) == null ? void 0 : _a3[materialIndex];
  const materialTextures = [
    (_b3 = material == null ? void 0 : material.pbrMetallicRoughness) == null ? void 0 : _b3.baseColorTexture,
    material == null ? void 0 : material.emissiveTexture,
    material == null ? void 0 : material.normalTexture,
    material == null ? void 0 : material.occlusionTexture,
    (_c2 = material == null ? void 0 : material.pbrMetallicRoughness) == null ? void 0 : _c2.metallicRoughnessTexture
  ];
  const processedTexCoords = [];
  for (const textureInfo of materialTextures) {
    if (textureInfo && ((_d2 = textureInfo == null ? void 0 : textureInfo.extensions) == null ? void 0 : _d2[KHR_TEXTURE_TRANSFORM$1])) {
      transformPrimitives$1(gltfData, materialIndex, textureInfo, processedTexCoords);
    }
  }
}
function transformPrimitives$1(gltfData, materialIndex, texture, processedTexCoords) {
  const transformParameters = getTransformParameters$1(texture, processedTexCoords);
  if (!transformParameters) {
    return;
  }
  const meshes = gltfData.json.meshes || [];
  for (const mesh of meshes) {
    for (const primitive of mesh.primitives) {
      const material = primitive.material;
      if (Number.isFinite(material) && materialIndex === material) {
        transformPrimitive$1(gltfData, primitive, transformParameters);
      }
    }
  }
}
function getTransformParameters$1(texture, processedTexCoords) {
  var _a3;
  const textureInfo = (_a3 = texture.extensions) == null ? void 0 : _a3[KHR_TEXTURE_TRANSFORM$1];
  const { texCoord: originalTexCoord = 0 } = texture;
  const { texCoord = originalTexCoord } = textureInfo;
  const isProcessed = processedTexCoords.findIndex(([original, newTexCoord]) => original === originalTexCoord && newTexCoord === texCoord) !== -1;
  if (!isProcessed) {
    const matrix = makeTransformationMatrix$1(textureInfo);
    if (originalTexCoord !== texCoord) {
      texture.texCoord = texCoord;
    }
    processedTexCoords.push([originalTexCoord, texCoord]);
    return { originalTexCoord, texCoord, matrix };
  }
  return null;
}
function transformPrimitive$1(gltfData, primitive, transformParameters) {
  var _a3, _b3;
  const { originalTexCoord, texCoord, matrix } = transformParameters;
  const texCoordAccessor = primitive.attributes[`TEXCOORD_${originalTexCoord}`];
  if (Number.isFinite(texCoordAccessor)) {
    const accessor = (_a3 = gltfData.json.accessors) == null ? void 0 : _a3[texCoordAccessor];
    if (accessor && accessor.bufferView) {
      const bufferView = (_b3 = gltfData.json.bufferViews) == null ? void 0 : _b3[accessor.bufferView];
      if (bufferView) {
        const { arrayBuffer: arrayBuffer2, byteOffset: bufferByteOffset } = gltfData.buffers[bufferView.buffer];
        const byteOffset = (bufferByteOffset || 0) + (accessor.byteOffset || 0) + (bufferView.byteOffset || 0);
        const { ArrayType: ArrayType2, length: length2 } = getAccessorArrayTypeAndLength$1(accessor, bufferView);
        const bytes = BYTES$3[accessor.componentType];
        const components = COMPONENTS$3[accessor.type];
        const elementAddressScale = bufferView.byteStride || bytes * components;
        const result = new Float32Array(length2);
        for (let i2 = 0; i2 < accessor.count; i2++) {
          const uv = new ArrayType2(arrayBuffer2, byteOffset + i2 * elementAddressScale, 2);
          scratchVector$6.set(uv[0], uv[1], 1);
          scratchVector$6.transformByMatrix3(matrix);
          result.set([scratchVector$6[0], scratchVector$6[1]], i2 * components);
        }
        if (originalTexCoord === texCoord) {
          updateGltf$1(accessor, bufferView, gltfData.buffers, result);
        } else {
          createAttribute$1(texCoord, accessor, primitive, gltfData, result);
        }
      }
    }
  }
}
function updateGltf$1(accessor, bufferView, buffers, newTexCoordArray) {
  accessor.componentType = 5126;
  buffers.push({
    arrayBuffer: newTexCoordArray.buffer,
    byteOffset: 0,
    byteLength: newTexCoordArray.buffer.byteLength
  });
  bufferView.buffer = buffers.length - 1;
  bufferView.byteLength = newTexCoordArray.buffer.byteLength;
  bufferView.byteOffset = 0;
  delete bufferView.byteStride;
}
function createAttribute$1(newTexCoord, originalAccessor, primitive, gltfData, newTexCoordArray) {
  gltfData.buffers.push({
    arrayBuffer: newTexCoordArray.buffer,
    byteOffset: 0,
    byteLength: newTexCoordArray.buffer.byteLength
  });
  const bufferViews = gltfData.json.bufferViews;
  if (!bufferViews) {
    return;
  }
  bufferViews.push({
    buffer: gltfData.buffers.length - 1,
    byteLength: newTexCoordArray.buffer.byteLength,
    byteOffset: 0
  });
  const accessors = gltfData.json.accessors;
  if (!accessors) {
    return;
  }
  accessors.push({
    bufferView: (bufferViews == null ? void 0 : bufferViews.length) - 1,
    byteOffset: 0,
    componentType: 5126,
    count: originalAccessor.count,
    type: "VEC2"
  });
  primitive.attributes[`TEXCOORD_${newTexCoord}`] = accessors.length - 1;
}
function makeTransformationMatrix$1(extensionData) {
  const { offset = [0, 0], rotation = 0, scale: scale5 = [1, 1] } = extensionData;
  const translationMatrix = new Matrix3().set(1, 0, 0, 0, 1, 0, offset[0], offset[1], 1);
  const rotationMatrix = scratchRotationMatrix$1.set(Math.cos(rotation), Math.sin(rotation), 0, -Math.sin(rotation), Math.cos(rotation), 0, 0, 0, 1);
  const scaleMatrix = scratchScaleMatrix$1.set(scale5[0], 0, 0, 0, scale5[1], 0, 0, 0, 1);
  return translationMatrix.multiplyRight(rotationMatrix).multiplyRight(scaleMatrix);
}
const KHR_texture_transform$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$d,
  name: name$f
}, Symbol.toStringTag, { value: "Module" }));
const KHR_LIGHTS_PUNCTUAL$1 = "KHR_lights_punctual";
const name$e = KHR_LIGHTS_PUNCTUAL$1;
async function decode$c(gltfData) {
  const gltfScenegraph = new GLTFScenegraph$1(gltfData);
  const { json } = gltfScenegraph;
  const extension = gltfScenegraph.getExtension(KHR_LIGHTS_PUNCTUAL$1);
  if (extension) {
    gltfScenegraph.json.lights = extension.lights;
    gltfScenegraph.removeExtension(KHR_LIGHTS_PUNCTUAL$1);
  }
  for (const node of json.nodes || []) {
    const nodeExtension = gltfScenegraph.getObjectExtension(node, KHR_LIGHTS_PUNCTUAL$1);
    if (nodeExtension) {
      node.light = nodeExtension.light;
    }
    gltfScenegraph.removeObjectExtension(node, KHR_LIGHTS_PUNCTUAL$1);
  }
}
async function encode$6(gltfData) {
  const gltfScenegraph = new GLTFScenegraph$1(gltfData);
  const { json } = gltfScenegraph;
  if (json.lights) {
    const extension = gltfScenegraph.addExtension(KHR_LIGHTS_PUNCTUAL$1);
    assert$6(!extension.lights);
    extension.lights = json.lights;
    delete json.lights;
  }
  if (gltfScenegraph.json.lights) {
    for (const light of gltfScenegraph.json.lights) {
      const node = light.node;
      gltfScenegraph.addObjectExtension(node, KHR_LIGHTS_PUNCTUAL$1, light);
    }
    delete gltfScenegraph.json.lights;
  }
}
const KHR_lights_punctual$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$c,
  encode: encode$6,
  name: name$e
}, Symbol.toStringTag, { value: "Module" }));
const KHR_MATERIALS_UNLIT$1 = "KHR_materials_unlit";
const name$d = KHR_MATERIALS_UNLIT$1;
async function decode$b(gltfData) {
  const gltfScenegraph = new GLTFScenegraph$1(gltfData);
  const { json } = gltfScenegraph;
  for (const material of json.materials || []) {
    const extension = material.extensions && material.extensions.KHR_materials_unlit;
    if (extension) {
      material.unlit = true;
    }
    gltfScenegraph.removeObjectExtension(material, KHR_MATERIALS_UNLIT$1);
  }
  gltfScenegraph.removeExtension(KHR_MATERIALS_UNLIT$1);
}
function encode$5(gltfData) {
  const gltfScenegraph = new GLTFScenegraph$1(gltfData);
  const { json } = gltfScenegraph;
  if (gltfScenegraph.materials) {
    for (const material of json.materials || []) {
      if (material.unlit) {
        delete material.unlit;
        gltfScenegraph.addObjectExtension(material, KHR_MATERIALS_UNLIT$1, {});
        gltfScenegraph.addExtension(KHR_MATERIALS_UNLIT$1);
      }
    }
  }
}
const KHR_materials_unlit$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$b,
  encode: encode$5,
  name: name$d
}, Symbol.toStringTag, { value: "Module" }));
const KHR_TECHNIQUES_WEBGL$1 = "KHR_techniques_webgl";
const name$c = KHR_TECHNIQUES_WEBGL$1;
async function decode$a(gltfData) {
  const gltfScenegraph = new GLTFScenegraph$1(gltfData);
  const { json } = gltfScenegraph;
  const extension = gltfScenegraph.getExtension(KHR_TECHNIQUES_WEBGL$1);
  if (extension) {
    const techniques = resolveTechniques$1(extension, gltfScenegraph);
    for (const material of json.materials || []) {
      const materialExtension = gltfScenegraph.getObjectExtension(material, KHR_TECHNIQUES_WEBGL$1);
      if (materialExtension) {
        material.technique = Object.assign(
          {},
          materialExtension,
          // @ts-ignore
          techniques[materialExtension.technique]
        );
        material.technique.values = resolveValues$1(material.technique, gltfScenegraph);
      }
      gltfScenegraph.removeObjectExtension(material, KHR_TECHNIQUES_WEBGL$1);
    }
    gltfScenegraph.removeExtension(KHR_TECHNIQUES_WEBGL$1);
  }
}
async function encode$4(gltfData, options2) {
}
function resolveTechniques$1(techniquesExtension, gltfScenegraph) {
  const { programs = [], shaders = [], techniques = [] } = techniquesExtension;
  const textDecoder = new TextDecoder();
  shaders.forEach((shader) => {
    if (Number.isFinite(shader.bufferView)) {
      shader.code = textDecoder.decode(gltfScenegraph.getTypedArrayForBufferView(shader.bufferView));
    } else {
      throw new Error("KHR_techniques_webgl: no shader code");
    }
  });
  programs.forEach((program) => {
    program.fragmentShader = shaders[program.fragmentShader];
    program.vertexShader = shaders[program.vertexShader];
  });
  techniques.forEach((technique) => {
    technique.program = programs[technique.program];
  });
  return techniques;
}
function resolveValues$1(technique, gltfScenegraph) {
  const values4 = Object.assign({}, technique.values);
  Object.keys(technique.uniforms || {}).forEach((uniform) => {
    if (technique.uniforms[uniform].value && !(uniform in values4)) {
      values4[uniform] = technique.uniforms[uniform].value;
    }
  });
  Object.keys(values4).forEach((uniform) => {
    if (typeof values4[uniform] === "object" && values4[uniform].index !== void 0) {
      values4[uniform].texture = gltfScenegraph.getTexture(values4[uniform].index);
    }
  });
  return values4;
}
const KHR_techniques_webgl$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$a,
  encode: encode$4,
  name: name$c
}, Symbol.toStringTag, { value: "Module" }));
const EXTENSIONS$8 = [
  // 1.0
  // KHR_binary_gltf is handled separately - must be processed before other parsing starts
  // KHR_binary_gltf,
  // 2.0
  EXT_structural_metadata$1,
  EXT_mesh_features$1,
  EXT_meshopt_compression$1,
  EXT_texture_webp$1,
  // Basisu should come after webp, we want basisu to be preferred if both are provided
  KHR_texture_basisu$1,
  KHR_draco_mesh_compression$1,
  KHR_lights_punctual$1,
  KHR_materials_unlit$1,
  KHR_techniques_webgl$1,
  KHR_texture_transform$1,
  EXT_feature_metadata$1
];
function preprocessExtensions$1(gltf, options2 = {}, context2) {
  var _a3;
  const extensions = EXTENSIONS$8.filter((extension) => useExtension$1(extension.name, options2));
  for (const extension of extensions) {
    (_a3 = extension.preprocess) == null ? void 0 : _a3.call(extension, gltf, options2, context2);
  }
}
async function decodeExtensions$1(gltf, options2 = {}, context2) {
  var _a3;
  const extensions = EXTENSIONS$8.filter((extension) => useExtension$1(extension.name, options2));
  for (const extension of extensions) {
    await ((_a3 = extension.decode) == null ? void 0 : _a3.call(extension, gltf, options2, context2));
  }
}
function useExtension$1(extensionName, options2) {
  var _a3;
  const excludes = ((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.excludeExtensions) || {};
  const exclude = extensionName in excludes && !excludes[extensionName];
  return !exclude;
}
const KHR_BINARY_GLTF$1 = "KHR_binary_glTF";
function preprocess$4(gltfData) {
  const gltfScenegraph = new GLTFScenegraph$1(gltfData);
  const { json } = gltfScenegraph;
  for (const image of json.images || []) {
    const extension = gltfScenegraph.getObjectExtension(image, KHR_BINARY_GLTF$1);
    if (extension) {
      Object.assign(image, extension);
    }
    gltfScenegraph.removeObjectExtension(image, KHR_BINARY_GLTF$1);
  }
  if (json.buffers && json.buffers[0]) {
    delete json.buffers[0].uri;
  }
  gltfScenegraph.removeExtension(KHR_BINARY_GLTF$1);
}
const GLTF_ARRAYS$1 = {
  accessors: "accessor",
  animations: "animation",
  buffers: "buffer",
  bufferViews: "bufferView",
  images: "image",
  materials: "material",
  meshes: "mesh",
  nodes: "node",
  samplers: "sampler",
  scenes: "scene",
  skins: "skin",
  textures: "texture"
};
const GLTF_KEYS$1 = {
  accessor: "accessors",
  animations: "animation",
  buffer: "buffers",
  bufferView: "bufferViews",
  image: "images",
  material: "materials",
  mesh: "meshes",
  node: "nodes",
  sampler: "samplers",
  scene: "scenes",
  skin: "skins",
  texture: "textures"
};
let GLTFV1Normalizer$1 = class GLTFV1Normalizer2 {
  constructor() {
    __publicField2(this, "idToIndexMap", {
      animations: {},
      accessors: {},
      buffers: {},
      bufferViews: {},
      images: {},
      materials: {},
      meshes: {},
      nodes: {},
      samplers: {},
      scenes: {},
      skins: {},
      textures: {}
    });
    __publicField2(this, "json");
  }
  // constructor() {}
  /**
   * Convert (normalize) glTF < 2.0 to glTF 2.0
   * @param gltf - object with json and binChunks
   * @param options
   * @param options normalize Whether to actually normalize
   */
  normalize(gltf, options2) {
    this.json = gltf.json;
    const json = gltf.json;
    switch (json.asset && json.asset.version) {
      case "2.0":
        return;
      case void 0:
      case "1.0":
        break;
      default:
        console.warn(`glTF: Unknown version ${json.asset.version}`);
        return;
    }
    if (!options2.normalize) {
      throw new Error("glTF v1 is not supported.");
    }
    console.warn("Converting glTF v1 to glTF v2 format. This is experimental and may fail.");
    this._addAsset(json);
    this._convertTopLevelObjectsToArrays(json);
    preprocess$4(gltf);
    this._convertObjectIdsToArrayIndices(json);
    this._updateObjects(json);
    this._updateMaterial(json);
  }
  // asset is now required, #642 https://github.com/KhronosGroup/glTF/issues/639
  _addAsset(json) {
    json.asset = json.asset || {};
    json.asset.version = "2.0";
    json.asset.generator = json.asset.generator || "Normalized to glTF 2.0 by loaders.gl";
  }
  _convertTopLevelObjectsToArrays(json) {
    for (const arrayName in GLTF_ARRAYS$1) {
      this._convertTopLevelObjectToArray(json, arrayName);
    }
  }
  /** Convert one top level object to array */
  _convertTopLevelObjectToArray(json, mapName) {
    const objectMap2 = json[mapName];
    if (!objectMap2 || Array.isArray(objectMap2)) {
      return;
    }
    json[mapName] = [];
    for (const id in objectMap2) {
      const object2 = objectMap2[id];
      object2.id = object2.id || id;
      const index2 = json[mapName].length;
      json[mapName].push(object2);
      this.idToIndexMap[mapName][id] = index2;
    }
  }
  /** Go through all objects in all top-level arrays and replace ids with indices */
  _convertObjectIdsToArrayIndices(json) {
    for (const arrayName in GLTF_ARRAYS$1) {
      this._convertIdsToIndices(json, arrayName);
    }
    if ("scene" in json) {
      json.scene = this._convertIdToIndex(json.scene, "scene");
    }
    for (const texture of json.textures) {
      this._convertTextureIds(texture);
    }
    for (const mesh of json.meshes) {
      this._convertMeshIds(mesh);
    }
    for (const node of json.nodes) {
      this._convertNodeIds(node);
    }
    for (const node of json.scenes) {
      this._convertSceneIds(node);
    }
  }
  _convertTextureIds(texture) {
    if (texture.source) {
      texture.source = this._convertIdToIndex(texture.source, "image");
    }
  }
  _convertMeshIds(mesh) {
    for (const primitive of mesh.primitives) {
      const { attributes, indices, material } = primitive;
      for (const attributeName in attributes) {
        attributes[attributeName] = this._convertIdToIndex(attributes[attributeName], "accessor");
      }
      if (indices) {
        primitive.indices = this._convertIdToIndex(indices, "accessor");
      }
      if (material) {
        primitive.material = this._convertIdToIndex(material, "material");
      }
    }
  }
  _convertNodeIds(node) {
    if (node.children) {
      node.children = node.children.map((child) => this._convertIdToIndex(child, "node"));
    }
    if (node.meshes) {
      node.meshes = node.meshes.map((mesh) => this._convertIdToIndex(mesh, "mesh"));
    }
  }
  _convertSceneIds(scene) {
    if (scene.nodes) {
      scene.nodes = scene.nodes.map((node) => this._convertIdToIndex(node, "node"));
    }
  }
  /** Go through all objects in a top-level array and replace ids with indices */
  _convertIdsToIndices(json, topLevelArrayName) {
    if (!json[topLevelArrayName]) {
      console.warn(`gltf v1: json doesn't contain attribute ${topLevelArrayName}`);
      json[topLevelArrayName] = [];
    }
    for (const object2 of json[topLevelArrayName]) {
      for (const key in object2) {
        const id = object2[key];
        const index2 = this._convertIdToIndex(id, key);
        object2[key] = index2;
      }
    }
  }
  _convertIdToIndex(id, key) {
    const arrayName = GLTF_KEYS$1[key];
    if (arrayName in this.idToIndexMap) {
      const index2 = this.idToIndexMap[arrayName][id];
      if (!Number.isFinite(index2)) {
        throw new Error(`gltf v1: failed to resolve ${key} with id ${id}`);
      }
      return index2;
    }
    return id;
  }
  /**
   *
   * @param {*} json
   */
  _updateObjects(json) {
    for (const buffer3 of this.json.buffers) {
      delete buffer3.type;
    }
  }
  /**
   * Update material (set pbrMetallicRoughness)
   * @param {*} json
   */
  _updateMaterial(json) {
    var _a3, _b3, _c2;
    for (const material of json.materials) {
      material.pbrMetallicRoughness = {
        baseColorFactor: [1, 1, 1, 1],
        metallicFactor: 1,
        roughnessFactor: 1
      };
      const textureId2 = ((_a3 = material.values) == null ? void 0 : _a3.tex) || ((_b3 = material.values) == null ? void 0 : _b3.texture2d_0) || ((_c2 = material.values) == null ? void 0 : _c2.diffuseTex);
      const textureIndex = json.textures.findIndex((texture) => texture.id === textureId2);
      if (textureIndex !== -1) {
        material.pbrMetallicRoughness.baseColorTexture = { index: textureIndex };
      }
    }
  }
};
function normalizeGLTFV1$1(gltf, options2 = {}) {
  return new GLTFV1Normalizer$1().normalize(gltf, options2);
}
async function parseGLTF$1(gltf, arrayBufferOrString, byteOffset = 0, options2, context2) {
  var _a3, _b3, _c2;
  parseGLTFContainerSync$1(gltf, arrayBufferOrString, byteOffset, options2);
  normalizeGLTFV1$1(gltf, { normalize: (_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.normalize });
  preprocessExtensions$1(gltf, options2, context2);
  if (((_b3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _b3.loadBuffers) && gltf.json.buffers) {
    await loadBuffers$1(gltf, options2, context2);
  }
  if ((_c2 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _c2.loadImages) {
    await loadImages$1(gltf, options2, context2);
  }
  await decodeExtensions$1(gltf, options2, context2);
  return gltf;
}
function parseGLTFContainerSync$1(gltf, data2, byteOffset, options2) {
  if (options2.uri) {
    gltf.baseUri = options2.uri;
  }
  if (data2 instanceof ArrayBuffer && !isGLB$1(data2, byteOffset, options2)) {
    const textDecoder = new TextDecoder();
    data2 = textDecoder.decode(data2);
  }
  if (typeof data2 === "string") {
    gltf.json = parseJSON$1(data2);
  } else if (data2 instanceof ArrayBuffer) {
    const glb = {};
    byteOffset = parseGLBSync$1(glb, data2, byteOffset, options2.glb);
    assert$6(glb.type === "glTF", `Invalid GLB magic string ${glb.type}`);
    gltf._glb = glb;
    gltf.json = glb.json;
  } else {
    assert$6(false, "GLTF: must be ArrayBuffer or string");
  }
  const buffers = gltf.json.buffers || [];
  gltf.buffers = new Array(buffers.length).fill(null);
  if (gltf._glb && gltf._glb.header.hasBinChunk) {
    const { binChunks } = gltf._glb;
    gltf.buffers[0] = {
      arrayBuffer: binChunks[0].arrayBuffer,
      byteOffset: binChunks[0].byteOffset,
      byteLength: binChunks[0].byteLength
    };
  }
  const images = gltf.json.images || [];
  gltf.images = new Array(images.length).fill({});
}
async function loadBuffers$1(gltf, options2, context2) {
  var _a3, _b3;
  const buffers = gltf.json.buffers || [];
  for (let i2 = 0; i2 < buffers.length; ++i2) {
    const buffer3 = buffers[i2];
    if (buffer3.uri) {
      const { fetch: fetch2 } = context2;
      assert$6(fetch2);
      const uri = resolveUrl$1(buffer3.uri, options2);
      const response = await ((_a3 = context2 == null ? void 0 : context2.fetch) == null ? void 0 : _a3.call(context2, uri));
      const arrayBuffer2 = await ((_b3 = response == null ? void 0 : response.arrayBuffer) == null ? void 0 : _b3.call(response));
      gltf.buffers[i2] = {
        arrayBuffer: arrayBuffer2,
        byteOffset: 0,
        byteLength: arrayBuffer2.byteLength
      };
      delete buffer3.uri;
    } else if (gltf.buffers[i2] === null) {
      gltf.buffers[i2] = {
        arrayBuffer: new ArrayBuffer(buffer3.byteLength),
        byteOffset: 0,
        byteLength: buffer3.byteLength
      };
    }
  }
}
async function loadImages$1(gltf, options2, context2) {
  const imageIndices = getReferencesImageIndices$1(gltf);
  const images = gltf.json.images || [];
  const promises = [];
  for (const imageIndex of imageIndices) {
    promises.push(loadImage$1(gltf, images[imageIndex], imageIndex, options2, context2));
  }
  return await Promise.all(promises);
}
function getReferencesImageIndices$1(gltf) {
  const imageIndices = /* @__PURE__ */ new Set();
  const textures = gltf.json.textures || [];
  for (const texture of textures) {
    if (texture.source !== void 0) {
      imageIndices.add(texture.source);
    }
  }
  return Array.from(imageIndices).sort();
}
async function loadImage$1(gltf, image, index2, options2, context2) {
  let arrayBuffer2;
  if (image.uri && !image.hasOwnProperty("bufferView")) {
    const uri = resolveUrl$1(image.uri, options2);
    const { fetch: fetch2 } = context2;
    const response = await fetch2(uri);
    arrayBuffer2 = await response.arrayBuffer();
    image.bufferView = {
      data: arrayBuffer2
    };
  }
  if (Number.isFinite(image.bufferView)) {
    const array2 = getTypedArrayForBufferView$1(gltf.json, gltf.buffers, image.bufferView);
    arrayBuffer2 = sliceArrayBuffer$1(array2.buffer, array2.byteOffset, array2.byteLength);
  }
  assert$6(arrayBuffer2, "glTF image has no data");
  let parsedImage = await parseFromContext$1(arrayBuffer2, [ImageLoader$1, BasisLoader$1], {
    ...options2,
    mimeType: image.mimeType,
    basis: options2.basis || { format: selectSupportedBasisFormat$1() }
  }, context2);
  if (parsedImage && parsedImage[0]) {
    parsedImage = {
      compressed: true,
      // @ts-expect-error
      mipmaps: false,
      width: parsedImage[0].width,
      height: parsedImage[0].height,
      data: parsedImage[0]
    };
  }
  gltf.images = gltf.images || [];
  gltf.images[index2] = parsedImage;
}
const GLTFLoader$2 = {
  dataType: null,
  batchType: null,
  name: "glTF",
  id: "gltf",
  module: "gltf",
  version: VERSION$9,
  extensions: ["gltf", "glb"],
  mimeTypes: ["model/gltf+json", "model/gltf-binary"],
  text: true,
  binary: true,
  tests: ["glTF"],
  parse: parse$5,
  options: {
    gltf: {
      normalize: true,
      // Normalize glTF v1 to glTF v2 format (not yet stable)
      loadBuffers: true,
      // Fetch any linked .BIN buffers, decode base64
      loadImages: true,
      // Create image objects
      decompressMeshes: true
      // Decompress Draco encoded meshes
    },
    // common?
    log: console
    // eslint-disable-line
  }
};
async function parse$5(arrayBuffer2, options2 = {}, context2) {
  options2 = { ...GLTFLoader$2.options, ...options2 };
  options2.gltf = { ...GLTFLoader$2.options.gltf, ...options2.gltf };
  const { byteOffset = 0 } = options2;
  const gltf = {};
  return await parseGLTF$1(gltf, arrayBuffer2, byteOffset, options2, context2);
}
const COMPONENTS$2 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const BYTES$2 = {
  5120: 1,
  // BYTE
  5121: 1,
  // UNSIGNED_BYTE
  5122: 2,
  // SHORT
  5123: 2,
  // UNSIGNED_SHORT
  5125: 4,
  // UNSIGNED_INT
  5126: 4
  // FLOAT
};
const GL_SAMPLER$1 = {
  // Sampler parameters
  TEXTURE_MAG_FILTER: 10240,
  TEXTURE_MIN_FILTER: 10241,
  TEXTURE_WRAP_S: 10242,
  TEXTURE_WRAP_T: 10243,
  // Sampler default values
  REPEAT: 10497,
  LINEAR: 9729,
  NEAREST_MIPMAP_LINEAR: 9986
};
const SAMPLER_PARAMETER_GLTF_TO_GL$1 = {
  magFilter: GL_SAMPLER$1.TEXTURE_MAG_FILTER,
  minFilter: GL_SAMPLER$1.TEXTURE_MIN_FILTER,
  wrapS: GL_SAMPLER$1.TEXTURE_WRAP_S,
  wrapT: GL_SAMPLER$1.TEXTURE_WRAP_T
};
const DEFAULT_SAMPLER_PARAMETERS$1 = {
  [GL_SAMPLER$1.TEXTURE_MAG_FILTER]: GL_SAMPLER$1.LINEAR,
  [GL_SAMPLER$1.TEXTURE_MIN_FILTER]: GL_SAMPLER$1.NEAREST_MIPMAP_LINEAR,
  [GL_SAMPLER$1.TEXTURE_WRAP_S]: GL_SAMPLER$1.REPEAT,
  [GL_SAMPLER$1.TEXTURE_WRAP_T]: GL_SAMPLER$1.REPEAT
};
function makeDefaultSampler$1() {
  return {
    id: "default-sampler",
    parameters: DEFAULT_SAMPLER_PARAMETERS$1
  };
}
function getBytesFromComponentType$1(componentType) {
  return BYTES$2[componentType];
}
function getSizeFromAccessorType$1(type) {
  return COMPONENTS$2[type];
}
let GLTFPostProcessor$1 = class GLTFPostProcessor2 {
  constructor() {
    __publicField2(this, "baseUri", "");
    // @ts-expect-error
    __publicField2(this, "jsonUnprocessed");
    // @ts-expect-error
    __publicField2(this, "json");
    __publicField2(this, "buffers", []);
    __publicField2(this, "images", []);
  }
  postProcess(gltf, options2 = {}) {
    const { json, buffers = [], images = [] } = gltf;
    const { baseUri = "" } = gltf;
    assert$6(json);
    this.baseUri = baseUri;
    this.buffers = buffers;
    this.images = images;
    this.jsonUnprocessed = json;
    this.json = this._resolveTree(gltf.json, options2);
    return this.json;
  }
  // Convert indexed glTF structure into tree structure
  // cross-link index resolution, enum lookup, convenience calculations
  // eslint-disable-next-line complexity, max-statements
  _resolveTree(gltf, options2 = {}) {
    const json = { ...gltf };
    this.json = json;
    if (gltf.bufferViews) {
      json.bufferViews = gltf.bufferViews.map((bufView, i2) => this._resolveBufferView(bufView, i2));
    }
    if (gltf.images) {
      json.images = gltf.images.map((image, i2) => this._resolveImage(image, i2));
    }
    if (gltf.samplers) {
      json.samplers = gltf.samplers.map((sampler, i2) => this._resolveSampler(sampler, i2));
    }
    if (gltf.textures) {
      json.textures = gltf.textures.map((texture, i2) => this._resolveTexture(texture, i2));
    }
    if (gltf.accessors) {
      json.accessors = gltf.accessors.map((accessor, i2) => this._resolveAccessor(accessor, i2));
    }
    if (gltf.materials) {
      json.materials = gltf.materials.map((material, i2) => this._resolveMaterial(material, i2));
    }
    if (gltf.meshes) {
      json.meshes = gltf.meshes.map((mesh, i2) => this._resolveMesh(mesh, i2));
    }
    if (gltf.nodes) {
      json.nodes = gltf.nodes.map((node, i2) => this._resolveNode(node, i2));
      json.nodes = json.nodes.map((node, i2) => this._resolveNodeChildren(node));
    }
    if (gltf.skins) {
      json.skins = gltf.skins.map((skin, i2) => this._resolveSkin(skin, i2));
    }
    if (gltf.scenes) {
      json.scenes = gltf.scenes.map((scene, i2) => this._resolveScene(scene, i2));
    }
    if (typeof this.json.scene === "number" && json.scenes) {
      json.scene = json.scenes[this.json.scene];
    }
    return json;
  }
  getScene(index2) {
    return this._get(this.json.scenes, index2);
  }
  getNode(index2) {
    return this._get(this.json.nodes, index2);
  }
  getSkin(index2) {
    return this._get(this.json.skins, index2);
  }
  getMesh(index2) {
    return this._get(this.json.meshes, index2);
  }
  getMaterial(index2) {
    return this._get(this.json.materials, index2);
  }
  getAccessor(index2) {
    return this._get(this.json.accessors, index2);
  }
  getCamera(index2) {
    return this._get(this.json.cameras, index2);
  }
  getTexture(index2) {
    return this._get(this.json.textures, index2);
  }
  getSampler(index2) {
    return this._get(this.json.samplers, index2);
  }
  getImage(index2) {
    return this._get(this.json.images, index2);
  }
  getBufferView(index2) {
    return this._get(this.json.bufferViews, index2);
  }
  getBuffer(index2) {
    return this._get(this.json.buffers, index2);
  }
  _get(array2, index2) {
    if (typeof index2 === "object") {
      return index2;
    }
    const object2 = array2 && array2[index2];
    if (!object2) {
      console.warn(`glTF file error: Could not find ${array2}[${index2}]`);
    }
    return object2;
  }
  // PARSING HELPERS
  _resolveScene(scene, index2) {
    return {
      ...scene,
      // @ts-ignore
      id: scene.id || `scene-${index2}`,
      nodes: (scene.nodes || []).map((node) => this.getNode(node))
    };
  }
  _resolveNode(gltfNode, index2) {
    const node = {
      ...gltfNode,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: (gltfNode == null ? void 0 : gltfNode.id) || `node-${index2}`
    };
    if (gltfNode.mesh !== void 0) {
      node.mesh = this.getMesh(gltfNode.mesh);
    }
    if (gltfNode.camera !== void 0) {
      node.camera = this.getCamera(gltfNode.camera);
    }
    if (gltfNode.skin !== void 0) {
      node.skin = this.getSkin(gltfNode.skin);
    }
    if (gltfNode.meshes !== void 0 && gltfNode.meshes.length) {
      node.mesh = gltfNode.meshes.reduce((accum, meshIndex) => {
        const mesh = this.getMesh(meshIndex);
        accum.id = mesh.id;
        accum.primitives = accum.primitives.concat(mesh.primitives);
        return accum;
      }, { primitives: [] });
    }
    return node;
  }
  _resolveNodeChildren(node) {
    if (node.children) {
      node.children = node.children.map((child) => this.getNode(child));
    }
    return node;
  }
  _resolveSkin(gltfSkin, index2) {
    const inverseBindMatrices = typeof gltfSkin.inverseBindMatrices === "number" ? this.getAccessor(gltfSkin.inverseBindMatrices) : void 0;
    return {
      ...gltfSkin,
      id: gltfSkin.id || `skin-${index2}`,
      inverseBindMatrices
    };
  }
  _resolveMesh(gltfMesh, index2) {
    const mesh = {
      ...gltfMesh,
      id: gltfMesh.id || `mesh-${index2}`,
      primitives: []
    };
    if (gltfMesh.primitives) {
      mesh.primitives = gltfMesh.primitives.map((gltfPrimitive) => {
        const primitive = {
          ...gltfPrimitive,
          attributes: {},
          indices: void 0,
          material: void 0
        };
        const attributes = gltfPrimitive.attributes;
        for (const attribute in attributes) {
          primitive.attributes[attribute] = this.getAccessor(attributes[attribute]);
        }
        if (gltfPrimitive.indices !== void 0) {
          primitive.indices = this.getAccessor(gltfPrimitive.indices);
        }
        if (gltfPrimitive.material !== void 0) {
          primitive.material = this.getMaterial(gltfPrimitive.material);
        }
        return primitive;
      });
    }
    return mesh;
  }
  _resolveMaterial(gltfMaterial, index2) {
    const material = {
      ...gltfMaterial,
      // @ts-expect-error
      id: gltfMaterial.id || `material-${index2}`
    };
    if (material.normalTexture) {
      material.normalTexture = { ...material.normalTexture };
      material.normalTexture.texture = this.getTexture(material.normalTexture.index);
    }
    if (material.occlusionTexture) {
      material.occlusionTexture = { ...material.occlusionTexture };
      material.occlusionTexture.texture = this.getTexture(material.occlusionTexture.index);
    }
    if (material.emissiveTexture) {
      material.emissiveTexture = { ...material.emissiveTexture };
      material.emissiveTexture.texture = this.getTexture(material.emissiveTexture.index);
    }
    if (!material.emissiveFactor) {
      material.emissiveFactor = material.emissiveTexture ? [1, 1, 1] : [0, 0, 0];
    }
    if (material.pbrMetallicRoughness) {
      material.pbrMetallicRoughness = { ...material.pbrMetallicRoughness };
      const mr = material.pbrMetallicRoughness;
      if (mr.baseColorTexture) {
        mr.baseColorTexture = { ...mr.baseColorTexture };
        mr.baseColorTexture.texture = this.getTexture(mr.baseColorTexture.index);
      }
      if (mr.metallicRoughnessTexture) {
        mr.metallicRoughnessTexture = { ...mr.metallicRoughnessTexture };
        mr.metallicRoughnessTexture.texture = this.getTexture(mr.metallicRoughnessTexture.index);
      }
    }
    return material;
  }
  _resolveAccessor(gltfAccessor, index2) {
    const bytesPerComponent = getBytesFromComponentType$1(gltfAccessor.componentType);
    const components = getSizeFromAccessorType$1(gltfAccessor.type);
    const bytesPerElement = bytesPerComponent * components;
    const accessor = {
      ...gltfAccessor,
      // @ts-expect-error
      id: gltfAccessor.id || `accessor-${index2}`,
      bytesPerComponent,
      components,
      bytesPerElement,
      value: void 0,
      bufferView: void 0,
      sparse: void 0
    };
    if (gltfAccessor.bufferView !== void 0) {
      accessor.bufferView = this.getBufferView(gltfAccessor.bufferView);
    }
    if (accessor.bufferView) {
      const buffer3 = accessor.bufferView.buffer;
      const { ArrayType: ArrayType2, byteLength } = getAccessorArrayTypeAndLength$1(accessor, accessor.bufferView);
      const byteOffset = (accessor.bufferView.byteOffset || 0) + (accessor.byteOffset || 0) + buffer3.byteOffset;
      let cutBuffer = buffer3.arrayBuffer.slice(byteOffset, byteOffset + byteLength);
      if (accessor.bufferView.byteStride) {
        cutBuffer = this._getValueFromInterleavedBuffer(buffer3, byteOffset, accessor.bufferView.byteStride, accessor.bytesPerElement, accessor.count);
      }
      accessor.value = new ArrayType2(cutBuffer);
    }
    return accessor;
  }
  /**
   * Take values of particular accessor from interleaved buffer
   * various parts of the buffer
   * @param buffer
   * @param byteOffset
   * @param byteStride
   * @param bytesPerElement
   * @param count
   * @returns
   */
  _getValueFromInterleavedBuffer(buffer3, byteOffset, byteStride, bytesPerElement, count3) {
    const result = new Uint8Array(count3 * bytesPerElement);
    for (let i2 = 0; i2 < count3; i2++) {
      const elementOffset = byteOffset + i2 * byteStride;
      result.set(new Uint8Array(buffer3.arrayBuffer.slice(elementOffset, elementOffset + bytesPerElement)), i2 * bytesPerElement);
    }
    return result.buffer;
  }
  _resolveTexture(gltfTexture, index2) {
    return {
      ...gltfTexture,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfTexture.id || `texture-${index2}`,
      sampler: typeof gltfTexture.sampler === "number" ? this.getSampler(gltfTexture.sampler) : makeDefaultSampler$1(),
      source: typeof gltfTexture.source === "number" ? this.getImage(gltfTexture.source) : void 0
    };
  }
  _resolveSampler(gltfSampler, index2) {
    const sampler = {
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfSampler.id || `sampler-${index2}`,
      ...gltfSampler,
      parameters: {}
    };
    for (const key in sampler) {
      const glEnum = this._enumSamplerParameter(key);
      if (glEnum !== void 0) {
        sampler.parameters[glEnum] = sampler[key];
      }
    }
    return sampler;
  }
  _enumSamplerParameter(key) {
    return SAMPLER_PARAMETER_GLTF_TO_GL$1[key];
  }
  _resolveImage(gltfImage, index2) {
    const image = {
      ...gltfImage,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfImage.id || `image-${index2}`,
      image: null,
      bufferView: gltfImage.bufferView !== void 0 ? this.getBufferView(gltfImage.bufferView) : void 0
    };
    const preloadedImage = this.images[index2];
    if (preloadedImage) {
      image.image = preloadedImage;
    }
    return image;
  }
  _resolveBufferView(gltfBufferView, index2) {
    const bufferIndex = gltfBufferView.buffer;
    const arrayBuffer2 = this.buffers[bufferIndex].arrayBuffer;
    let byteOffset = this.buffers[bufferIndex].byteOffset || 0;
    if (gltfBufferView.byteOffset) {
      byteOffset += gltfBufferView.byteOffset;
    }
    const bufferView = {
      // // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: `bufferView-${index2}`,
      ...gltfBufferView,
      // ...this.buffers[bufferIndex],
      buffer: this.buffers[bufferIndex],
      data: new Uint8Array(arrayBuffer2, byteOffset, gltfBufferView.byteLength)
    };
    return bufferView;
  }
  _resolveCamera(gltfCamera, index2) {
    const camera = {
      ...gltfCamera,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfCamera.id || `camera-${index2}`
    };
    if (camera.perspective)
      ;
    if (camera.orthographic)
      ;
    return camera;
  }
};
function postProcessGLTF$1(gltf, options2) {
  return new GLTFPostProcessor$1().postProcess(gltf, options2);
}
async function waitForGLTFAssets(gltfObjects) {
  const remaining = [];
  gltfObjects.scenes.forEach((scene) => {
    scene.traverse((modelNode) => {
      Object.values(modelNode.model.uniforms).forEach((uniform) => {
        if (uniform.loaded === false) {
          remaining.push(uniform);
        }
      });
    });
  });
  return await waitWhileCondition(() => remaining.some((uniform) => !uniform.loaded));
}
async function waitWhileCondition(condition) {
  while (condition()) {
    await new Promise((resolve2) => requestAnimationFrame(resolve2));
  }
}
const vs$3 = `#version 300 es
#define SHADER_NAME scenegraph-layer-vertex-shader
in vec3 instancePositions;
in vec3 instancePositions64Low;
in vec4 instanceColors;
in vec3 instancePickingColors;
in vec3 instanceModelMatrixCol0;
in vec3 instanceModelMatrixCol1;
in vec3 instanceModelMatrixCol2;
in vec3 instanceTranslation;
uniform float sizeScale;
uniform float sizeMinPixels;
uniform float sizeMaxPixels;
uniform mat4 sceneModelMatrix;
uniform bool composeModelMatrix;
in vec3 positions;
#ifdef HAS_UV
in vec2 texCoords;
#endif
#ifdef MODULE_PBR
#ifdef HAS_NORMALS
in vec3 normals;
#endif
#endif
out vec4 vColor;
#ifndef MODULE_PBR
#ifdef HAS_UV
out vec2 vTEXCOORD_0;
#endif
#endif
void main(void) {
#if defined(HAS_UV) && !defined(MODULE_PBR)
vTEXCOORD_0 = texCoords;
geometry.uv = texCoords;
#endif
geometry.worldPosition = instancePositions;
geometry.pickingColor = instancePickingColors;
mat3 instanceModelMatrix = mat3(instanceModelMatrixCol0, instanceModelMatrixCol1, instanceModelMatrixCol2);
vec3 normal = vec3(0.0, 0.0, 1.0);
#ifdef MODULE_PBR
#ifdef HAS_NORMALS
normal = instanceModelMatrix * (sceneModelMatrix * vec4(normals, 0.0)).xyz;
#endif
#endif
float originalSize = project_size_to_pixel(sizeScale);
float clampedSize = clamp(originalSize, sizeMinPixels, sizeMaxPixels);
vec3 pos = (instanceModelMatrix * (sceneModelMatrix * vec4(positions, 1.0)).xyz) * sizeScale * (clampedSize / originalSize) + instanceTranslation;
if(composeModelMatrix) {
DECKGL_FILTER_SIZE(pos, geometry);
geometry.normal = project_normal(normal);
geometry.worldPosition += pos;
gl_Position = project_position_to_clipspace(pos + instancePositions, instancePositions64Low, vec3(0.0), geometry.position);
}
else {
pos = project_size(pos);
DECKGL_FILTER_SIZE(pos, geometry);
gl_Position = project_position_to_clipspace(instancePositions, instancePositions64Low, pos, geometry.position);
geometry.normal = project_normal(normal);
}
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
#ifdef MODULE_PBR
pbr_vPosition = geometry.position.xyz;
#ifdef HAS_NORMALS
pbr_vNormal = geometry.normal;
#endif
#ifdef HAS_UV
pbr_vUV = texCoords;
#else
pbr_vUV = vec2(0., 0.);
#endif
geometry.uv = pbr_vUV;
#endif
vColor = instanceColors;
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;
const fs$3 = `#version 300 es
#define SHADER_NAME scenegraph-layer-fragment-shader
uniform float opacity;
in vec4 vColor;
out vec4 fragColor;
#ifndef MODULE_PBR
#if defined(HAS_UV) && defined(HAS_BASECOLORMAP)
in vec2 vTEXCOORD_0;
uniform sampler2D u_BaseColorSampler;
#endif
#endif
void main(void) {
#ifdef MODULE_PBR
fragColor = vColor * pbr_filterColor(vec4(0));
geometry.uv = pbr_vUV;
#else
#if defined(HAS_UV) && defined(HAS_BASECOLORMAP)
fragColor = vColor * texture(u_BaseColorSampler, vTEXCOORD_0);
geometry.uv = vTEXCOORD_0;
#else
fragColor = vColor;
#endif
#endif
fragColor.a *= opacity;
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const DEFAULT_COLOR = [255, 255, 255, 255];
const defaultProps$7 = {
  scenegraph: { type: "object", value: null, async: true },
  getScene: (gltf) => {
    if (gltf && gltf.scenes) {
      return typeof gltf.scene === "object" ? gltf.scene : gltf.scenes[gltf.scene || 0];
    }
    return gltf;
  },
  getAnimator: (scenegraph) => scenegraph && scenegraph.animator,
  _animations: null,
  sizeScale: { type: "number", value: 1, min: 0 },
  sizeMinPixels: { type: "number", min: 0, value: 0 },
  sizeMaxPixels: { type: "number", min: 0, value: Number.MAX_SAFE_INTEGER },
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getColor: { type: "accessor", value: DEFAULT_COLOR },
  // flat or pbr
  _lighting: "flat",
  // _lighting must be pbr for this to work
  _imageBasedLightingEnvironment: void 0,
  // yaw, pitch and roll are in degrees
  // https://en.wikipedia.org/wiki/Euler_angles
  // [pitch, yaw, roll]
  getOrientation: { type: "accessor", value: [0, 0, 0] },
  getScale: { type: "accessor", value: [1, 1, 1] },
  getTranslation: { type: "accessor", value: [0, 0, 0] },
  // 4x4 matrix
  getTransformMatrix: { type: "accessor", value: [] },
  loaders: [GLTFLoader$2]
};
const _ScenegraphLayer = class extends Layer {
  getShaders() {
    const modules = [project32, picking];
    if (this.props._lighting === "pbr") {
      modules.push(pbr$1);
    }
    return super.getShaders({ vs: vs$3, fs: fs$3, modules });
  }
  initializeState() {
    const attributeManager = this.getAttributeManager();
    attributeManager.addInstanced({
      instancePositions: {
        size: 3,
        type: "float64",
        fp64: this.use64bitPositions(),
        accessor: "getPosition",
        transition: true
      },
      instanceColors: {
        type: "unorm8",
        size: this.props.colorFormat.length,
        accessor: "getColor",
        defaultValue: DEFAULT_COLOR,
        transition: true
      },
      instanceModelMatrix: MATRIX_ATTRIBUTES
    });
  }
  updateState(params2) {
    super.updateState(params2);
    const { props, oldProps } = params2;
    if (props.scenegraph !== oldProps.scenegraph) {
      this._updateScenegraph();
    } else if (props._animations !== oldProps._animations) {
      this._applyAnimationsProp(this.state.animator, props._animations);
    }
  }
  finalizeState(context2) {
    var _a3;
    super.finalizeState(context2);
    (_a3 = this.state.scenegraph) == null ? void 0 : _a3.destroy();
  }
  get isLoaded() {
    var _a3;
    return Boolean(((_a3 = this.state) == null ? void 0 : _a3.scenegraph) && super.isLoaded);
  }
  _updateScenegraph() {
    var _a3;
    const props = this.props;
    const { device } = this.context;
    let scenegraphData = null;
    if (props.scenegraph instanceof ScenegraphNode) {
      scenegraphData = { scenes: [props.scenegraph] };
    } else if (props.scenegraph && typeof props.scenegraph === "object") {
      const gltf = props.scenegraph;
      const processedGLTF = gltf.json ? postProcessGLTF$1(gltf) : gltf;
      const gltfObjects = createScenegraphsFromGLTF(device, processedGLTF, this._getModelOptions());
      scenegraphData = { gltf: processedGLTF, ...gltfObjects };
      waitForGLTFAssets(gltfObjects).then(() => {
        this.setNeedsRedraw();
      }).catch((ex) => {
        this.raiseError(ex, "loading glTF");
      });
    }
    const options2 = { layer: this, device: this.context.device };
    const scenegraph = props.getScene(scenegraphData, options2);
    const animator = props.getAnimator(scenegraphData, options2);
    if (scenegraph instanceof GroupNode) {
      (_a3 = this.state.scenegraph) == null ? void 0 : _a3.destroy();
      this._applyAnimationsProp(animator, props._animations);
      const models2 = [];
      scenegraph.traverse((node) => {
        if (node instanceof ModelNode) {
          models2.push(node.model);
        }
      });
      this.setState({ scenegraph, animator, models: models2 });
      this.getAttributeManager().invalidateAll();
    } else if (scenegraph !== null) {
      log$1.warn("invalid scenegraph:", scenegraph)();
    }
  }
  _applyAnimationsProp(animator, animationsProp) {
    if (!animator || !animationsProp) {
      return;
    }
    const animations = animator.getAnimations();
    Object.keys(animationsProp).sort().forEach((key) => {
      const value = animationsProp[key];
      if (key === "*") {
        animations.forEach((animation) => {
          Object.assign(animation, value);
        });
      } else if (Number.isFinite(Number(key))) {
        const number2 = Number(key);
        if (number2 >= 0 && number2 < animations.length) {
          Object.assign(animations[number2], value);
        } else {
          log$1.warn(`animation ${key} not found`)();
        }
      } else {
        const findResult = animations.find(({ name: name2 }) => name2 === key);
        if (findResult) {
          Object.assign(findResult, value);
        } else {
          log$1.warn(`animation ${key} not found`)();
        }
      }
    });
  }
  _getModelOptions() {
    const { _imageBasedLightingEnvironment } = this.props;
    let env;
    if (_imageBasedLightingEnvironment) {
      if (typeof _imageBasedLightingEnvironment === "function") {
        env = _imageBasedLightingEnvironment({ gl: this.context.gl, layer: this });
      } else {
        env = _imageBasedLightingEnvironment;
      }
    }
    return {
      imageBasedLightingEnvironment: env,
      modelOptions: {
        id: this.props.id,
        isInstanced: true,
        bufferLayout: this.getAttributeManager().getBufferLayouts(),
        ...this.getShaders()
      },
      // tangents are not supported
      useTangents: false
    };
  }
  draw({ context: context2 }) {
    if (!this.state.scenegraph)
      return;
    if (this.props._animations && this.state.animator) {
      this.state.animator.animate(context2.timeline.getTime());
      this.setNeedsRedraw();
    }
    const { viewport, renderPass } = this.context;
    const { sizeScale, sizeMinPixels, sizeMaxPixels, opacity, coordinateSystem } = this.props;
    const numInstances = this.getNumInstances();
    this.state.scenegraph.traverse((node, { worldMatrix }) => {
      if (node instanceof ModelNode) {
        const { model } = node;
        model.setInstanceCount(numInstances);
        model.setUniforms({
          sizeScale,
          opacity,
          sizeMinPixels,
          sizeMaxPixels,
          composeModelMatrix: shouldComposeModelMatrix(viewport, coordinateSystem),
          sceneModelMatrix: worldMatrix,
          // Needed for PBR (TODO: find better way to get it)
          // eslint-disable-next-line camelcase
          u_Camera: model.uniforms.project_uCameraPosition
        });
        model.draw(renderPass);
      }
    });
  }
};
let ScenegraphLayer = _ScenegraphLayer;
(() => {
  _ScenegraphLayer.defaultProps = defaultProps$7;
})();
(() => {
  _ScenegraphLayer.layerName = "ScenegraphLayer";
})();
var GLEnum;
(function(GLEnum2) {
  GLEnum2[GLEnum2["FUNC_ADD"] = 32774] = "FUNC_ADD";
  GLEnum2[GLEnum2["ONE"] = 1] = "ONE";
  GLEnum2[GLEnum2["SRC_ALPHA"] = 770] = "SRC_ALPHA";
  GLEnum2[GLEnum2["ONE_MINUS_SRC_ALPHA"] = 771] = "ONE_MINUS_SRC_ALPHA";
  GLEnum2[GLEnum2["TEXTURE_MIN_FILTER"] = 10241] = "TEXTURE_MIN_FILTER";
  GLEnum2[GLEnum2["LINEAR"] = 9729] = "LINEAR";
  GLEnum2[GLEnum2["LINEAR_MIPMAP_NEAREST"] = 9985] = "LINEAR_MIPMAP_NEAREST";
  GLEnum2[GLEnum2["UNPACK_FLIP_Y_WEBGL"] = 37440] = "UNPACK_FLIP_Y_WEBGL";
})(GLEnum || (GLEnum = {}));
function parsePBRMaterial(device, material, attributes, options2) {
  const parsedMaterial = {
    defines: {
      // TODO: Use EXT_sRGB if available (Standard in WebGL 2.0)
      MANUAL_SRGB: 1,
      SRGB_FAST_APPROXIMATION: 1
    },
    bindings: {},
    uniforms: {
      // TODO: find better values?
      camera: [0, 0, 0],
      // Model should override
      metallicRoughnessValues: [1, 1]
      // Default is 1 and 1
    },
    parameters: {},
    glParameters: {},
    generatedTextures: []
  };
  parsedMaterial.defines.USE_TEX_LOD = 1;
  const { imageBasedLightingEnvironment } = options2;
  if (imageBasedLightingEnvironment) {
    parsedMaterial.bindings.pbr_diffuseEnvSampler = imageBasedLightingEnvironment.diffuseEnvSampler;
    parsedMaterial.bindings.pbr_specularEnvSampler = imageBasedLightingEnvironment.specularEnvSampler;
    parsedMaterial.bindings.pbr_BrdfLUT = imageBasedLightingEnvironment.brdfLutTexture;
    parsedMaterial.uniforms.scaleIBLAmbient = [1, 1];
  }
  if (options2 == null ? void 0 : options2.pbrDebug) {
    parsedMaterial.defines.PBR_DEBUG = 1;
    parsedMaterial.uniforms.scaleDiffBaseMR = [0, 0, 0, 0];
    parsedMaterial.uniforms.scaleFGDSpec = [0, 0, 0, 0];
  }
  if (attributes.NORMAL)
    parsedMaterial.defines.HAS_NORMALS = 1;
  if (attributes.TANGENT && (options2 == null ? void 0 : options2.useTangents))
    parsedMaterial.defines.HAS_TANGENTS = 1;
  if (attributes.TEXCOORD_0)
    parsedMaterial.defines.HAS_UV = 1;
  if (options2 == null ? void 0 : options2.imageBasedLightingEnvironment)
    parsedMaterial.defines.USE_IBL = 1;
  if (options2 == null ? void 0 : options2.lights)
    parsedMaterial.defines.USE_LIGHTS = 1;
  if (material) {
    parseMaterial(device, material, parsedMaterial);
  }
  return parsedMaterial;
}
function parseMaterial(device, material, parsedMaterial) {
  parsedMaterial.uniforms.unlit = Boolean(material.unlit);
  if (material.pbrMetallicRoughness) {
    parsePbrMetallicRoughness(device, material.pbrMetallicRoughness, parsedMaterial);
  }
  if (material.normalTexture) {
    addTexture(device, material.normalTexture, "pbr_normalSampler", "HAS_NORMALMAP", parsedMaterial);
    const { scale: scale5 = 1 } = material.normalTexture;
    parsedMaterial.uniforms.normalScale = scale5;
  }
  if (material.occlusionTexture) {
    addTexture(device, material.occlusionTexture, "pbr_occlusionSampler", "HAS_OCCLUSIONMAP", parsedMaterial);
    const { strength = 1 } = material.occlusionTexture;
    parsedMaterial.uniforms.occlusionStrength = strength;
  }
  if (material.emissiveTexture) {
    addTexture(device, material.emissiveTexture, "pbr_emissiveSampler", "HAS_EMISSIVEMAP", parsedMaterial);
    parsedMaterial.uniforms.emissiveFactor = material.emissiveFactor || [0, 0, 0];
  }
  switch (material.alphaMode) {
    case "MASK":
      const { alphaCutoff = 0.5 } = material;
      parsedMaterial.defines.ALPHA_CUTOFF = 1;
      parsedMaterial.uniforms.alphaCutoff = alphaCutoff;
      break;
    case "BLEND":
      log.warn("glTF BLEND alphaMode might not work well because it requires mesh sorting")();
      parsedMaterial.parameters.blendColorOperation = "add";
      parsedMaterial.parameters.blendColorSrcFactor = "src-alpha";
      parsedMaterial.parameters.blendColorDstFactor = "one-minus-src-alpha";
      parsedMaterial.parameters.blendAlphaOperation = "add";
      parsedMaterial.parameters.blendAlphaSrcFactor = "one";
      parsedMaterial.parameters.blendAlphaDstFactor = "one-minus-src-alpha";
      parsedMaterial.glParameters.blend = true;
      parsedMaterial.glParameters.blendEquation = GLEnum.FUNC_ADD;
      parsedMaterial.glParameters.blendFunc = [
        GLEnum.SRC_ALPHA,
        GLEnum.ONE_MINUS_SRC_ALPHA,
        GLEnum.ONE,
        GLEnum.ONE_MINUS_SRC_ALPHA
      ];
      break;
  }
}
function parsePbrMetallicRoughness(device, pbrMetallicRoughness, parsedMaterial) {
  if (pbrMetallicRoughness.baseColorTexture) {
    addTexture(device, pbrMetallicRoughness.baseColorTexture, "pbr_baseColorSampler", "HAS_BASECOLORMAP", parsedMaterial);
  }
  parsedMaterial.uniforms.baseColorFactor = pbrMetallicRoughness.baseColorFactor || [1, 1, 1, 1];
  if (pbrMetallicRoughness.metallicRoughnessTexture) {
    addTexture(device, pbrMetallicRoughness.metallicRoughnessTexture, "pbr_metallicRoughnessSampler", "HAS_METALROUGHNESSMAP", parsedMaterial);
  }
  const { metallicFactor = 1, roughnessFactor = 1 } = pbrMetallicRoughness;
  parsedMaterial.uniforms.metallicRoughnessValues = [metallicFactor, roughnessFactor];
}
function addTexture(device, gltfTexture, uniformName, define2 = null, parsedMaterial) {
  var _a3, _b3;
  const parameters = ((_b3 = (_a3 = gltfTexture == null ? void 0 : gltfTexture.texture) == null ? void 0 : _a3.sampler) == null ? void 0 : _b3.parameters) || {};
  const image = gltfTexture.texture.source.image;
  let textureOptions;
  let specialTextureParameters = {};
  if (image.compressed) {
    textureOptions = image;
    specialTextureParameters = {
      [GLEnum.TEXTURE_MIN_FILTER]: image.data.length > 1 ? GLEnum.LINEAR_MIPMAP_NEAREST : GLEnum.LINEAR
    };
  } else {
    textureOptions = { data: image };
  }
  const texture = device.createTexture({
    id: gltfTexture.uniformName || gltfTexture.id,
    parameters: {
      ...parameters,
      ...specialTextureParameters
    },
    pixelStore: {
      [GLEnum.UNPACK_FLIP_Y_WEBGL]: false
    },
    ...textureOptions
  });
  parsedMaterial.bindings[uniformName] = texture;
  if (define2)
    parsedMaterial.defines[define2] = 1;
  parsedMaterial.generatedTextures.push(texture);
}
const lightingShader = `#if (defined(SHADER_TYPE_FRAGMENT) && defined(LIGHTING_FRAGMENT)) || (defined(SHADER_TYPE_VERTEX) && defined(LIGHTING_VERTEX))
struct AmbientLight {
vec3 color;
};
struct PointLight {
vec3 color;
vec3 position;
vec3 attenuation;
};
struct DirectionalLight {
vec3 color;
vec3 direction;
};
uniform AmbientLight lighting_uAmbientLight;
uniform PointLight lighting_uPointLight[MAX_LIGHTS];
uniform DirectionalLight lighting_uDirectionalLight[MAX_LIGHTS];
uniform int lighting_uPointLightCount;
uniform int lighting_uDirectionalLightCount;
uniform bool lighting_uEnabled;
float getPointLightAttenuation(PointLight pointLight, float distance) {
return pointLight.attenuation.x
+ pointLight.attenuation.y * distance
+ pointLight.attenuation.z * distance * distance;
}
#endif
`;
const INITIAL_MODULE_OPTIONS = {
  lightSources: {}
};
function convertColor(colorDef = {}) {
  const { color = [0, 0, 0], intensity = 1 } = colorDef;
  return color.map((component) => component * intensity / 255);
}
function getLightSourceUniforms({ ambientLight, pointLights = [], directionalLights = [] }) {
  const lightSourceUniforms = {};
  if (ambientLight) {
    lightSourceUniforms["lighting_uAmbientLight.color"] = convertColor(ambientLight);
  } else {
    lightSourceUniforms["lighting_uAmbientLight.color"] = [0, 0, 0];
  }
  pointLights.forEach((pointLight, index2) => {
    lightSourceUniforms[`lighting_uPointLight[${index2}].color`] = convertColor(pointLight);
    lightSourceUniforms[`lighting_uPointLight[${index2}].position`] = pointLight.position;
    lightSourceUniforms[`lighting_uPointLight[${index2}].attenuation`] = pointLight.attenuation || [
      1,
      0,
      0
    ];
  });
  lightSourceUniforms.lighting_uPointLightCount = pointLights.length;
  directionalLights.forEach((directionalLight, index2) => {
    lightSourceUniforms[`lighting_uDirectionalLight[${index2}].color`] = convertColor(directionalLight);
    lightSourceUniforms[`lighting_uDirectionalLight[${index2}].direction`] = directionalLight.direction;
  });
  lightSourceUniforms.lighting_uDirectionalLightCount = directionalLights.length;
  return lightSourceUniforms;
}
function getUniforms(opts = INITIAL_MODULE_OPTIONS) {
  var _a3, _b3;
  if ("lightSources" in opts) {
    const { ambientLight, pointLights, directionalLights } = opts.lightSources || {};
    const hasLights = ambientLight || pointLights && pointLights.length > 0 || directionalLights && directionalLights.length > 0;
    if (!hasLights) {
      return { lighting_uEnabled: false };
    }
    return Object.assign({}, getLightSourceUniforms({ ambientLight, pointLights, directionalLights }), {
      lighting_uEnabled: true
    });
  }
  if ("lights" in opts) {
    const lightSources = { pointLights: [], directionalLights: [] };
    for (const light of opts.lights || []) {
      switch (light.type) {
        case "ambient":
          lightSources.ambientLight = light;
          break;
        case "directional":
          (_a3 = lightSources.directionalLights) == null ? void 0 : _a3.push(light);
          break;
        case "point":
          (_b3 = lightSources.pointLights) == null ? void 0 : _b3.push(light);
          break;
      }
    }
    return getUniforms({ lightSources });
  }
  return {};
}
const lights = {
  name: "lights",
  vs: lightingShader,
  fs: lightingShader,
  getUniforms,
  defines: {
    MAX_LIGHTS: 3
  }
};
const vs$2 = `uniform mat4 u_MVPMatrix;
uniform mat4 u_ModelMatrix;
uniform mat4 u_NormalMatrix;
out vec3 pbr_vPosition;
out vec2 pbr_vUV;
#ifdef HAS_NORMALS
# ifdef HAS_TANGENTS
out mat3 pbr_vTBN;
# else
out vec3 pbr_vNormal;
# endif
#endif
void pbr_setPositionNormalTangentUV(vec4 position, vec4 normal, vec4 tangent, vec2 uv)
{
vec4 pos = u_ModelMatrix * position;
pbr_vPosition = vec3(pos.xyz) / pos.w;
#ifdef HAS_NORMALS
#ifdef HAS_TANGENTS
vec3 normalW = normalize(vec3(u_NormalMatrix * vec4(normal.xyz, 0.0)));
vec3 tangentW = normalize(vec3(u_ModelMatrix * vec4(tangent.xyz, 0.0)));
vec3 bitangentW = cross(normalW, tangentW) * tangent.w;
pbr_vTBN = mat3(tangentW, bitangentW, normalW);
#else
pbr_vNormal = normalize(vec3(u_ModelMatrix * vec4(normal.xyz, 0.0)));
#endif
#endif
#ifdef HAS_UV
pbr_vUV = uv;
#else
pbr_vUV = vec2(0.,0.);
#endif
}
`;
const fs$2 = `precision highp float;
uniform bool pbr_uUnlit;
#ifdef USE_IBL
uniform samplerCube u_DiffuseEnvSampler;
uniform samplerCube u_SpecularEnvSampler;
uniform sampler2D u_brdfLUT;
uniform vec2 u_ScaleIBLAmbient;
#endif
#ifdef HAS_BASECOLORMAP
uniform sampler2D u_BaseColorSampler;
#endif
#ifdef HAS_NORMALMAP
uniform sampler2D u_NormalSampler;
uniform float u_NormalScale;
#endif
#ifdef HAS_EMISSIVEMAP
uniform sampler2D u_EmissiveSampler;
uniform vec3 u_EmissiveFactor;
#endif
#ifdef HAS_METALROUGHNESSMAP
uniform sampler2D u_MetallicRoughnessSampler;
#endif
#ifdef HAS_OCCLUSIONMAP
uniform sampler2D u_OcclusionSampler;
uniform float u_OcclusionStrength;
#endif
#ifdef ALPHA_CUTOFF
uniform float u_AlphaCutoff;
#endif
uniform vec2 u_MetallicRoughnessValues;
uniform vec4 u_BaseColorFactor;
uniform vec3 u_Camera;
#ifdef PBR_DEBUG
uniform vec4 u_ScaleDiffBaseMR;
uniform vec4 u_ScaleFGDSpec;
#endif
in vec3 pbr_vPosition;
in vec2 pbr_vUV;
#ifdef HAS_NORMALS
#ifdef HAS_TANGENTS
in mat3 pbr_vTBN;
#else
in vec3 pbr_vNormal;
#endif
#endif
struct PBRInfo
{
float NdotL;
float NdotV;
float NdotH;
float LdotH;
float VdotH;
float perceptualRoughness;
float metalness;
vec3 reflectance0;
vec3 reflectance90;
float alphaRoughness;
vec3 diffuseColor;
vec3 specularColor;
vec3 n;
vec3 v;
};
const float M_PI = 3.141592653589793;
const float c_MinRoughness = 0.04;
vec4 SRGBtoLINEAR(vec4 srgbIn)
{
#ifdef MANUAL_SRGB
#ifdef SRGB_FAST_APPROXIMATION
vec3 linOut = pow(srgbIn.xyz,vec3(2.2));
#else
vec3 bLess = step(vec3(0.04045),srgbIn.xyz);
vec3 linOut = mix( srgbIn.xyz/vec3(12.92), pow((srgbIn.xyz+vec3(0.055))/vec3(1.055),vec3(2.4)), bLess );
#endif
return vec4(linOut,srgbIn.w);;
#else
return srgbIn;
#endif
}
vec3 getNormal()
{
#ifndef HAS_TANGENTS
vec3 pos_dx = dFdx(pbr_vPosition);
vec3 pos_dy = dFdy(pbr_vPosition);
vec3 tex_dx = dFdx(vec3(pbr_vUV, 0.0));
vec3 tex_dy = dFdy(vec3(pbr_vUV, 0.0));
vec3 t = (tex_dy.t * pos_dx - tex_dx.t * pos_dy) / (tex_dx.s * tex_dy.t - tex_dy.s * tex_dx.t);
#ifdef HAS_NORMALS
vec3 ng = normalize(pbr_vNormal);
#else
vec3 ng = cross(pos_dx, pos_dy);
#endif
t = normalize(t - ng * dot(ng, t));
vec3 b = normalize(cross(ng, t));
mat3 tbn = mat3(t, b, ng);
#else
mat3 tbn = pbr_vTBN;
#endif
#ifdef HAS_NORMALMAP
vec3 n = texture(u_NormalSampler, pbr_vUV).rgb;
n = normalize(tbn * ((2.0 * n - 1.0) * vec3(u_NormalScale, u_NormalScale, 1.0)));
#else
vec3 n = normalize(tbn[2].xyz);
#endif
return n;
}
#ifdef USE_IBL
vec3 getIBLContribution(PBRInfo pbrInputs, vec3 n, vec3 reflection)
{
float mipCount = 9.0;
float lod = (pbrInputs.perceptualRoughness * mipCount);
vec3 brdf = SRGBtoLINEAR(texture(u_brdfLUT,
vec2(pbrInputs.NdotV, 1.0 - pbrInputs.perceptualRoughness))).rgb;
vec3 diffuseLight = SRGBtoLINEAR(textureCube(u_DiffuseEnvSampler, n)).rgb;
#ifdef USE_TEX_LOD
vec3 specularLight = SRGBtoLINEAR(textureCubeLod(u_SpecularEnvSampler, reflection, lod)).rgb;
#else
vec3 specularLight = SRGBtoLINEAR(textureCube(u_SpecularEnvSampler, reflection)).rgb;
#endif
vec3 diffuse = diffuseLight * pbrInputs.diffuseColor;
vec3 specular = specularLight * (pbrInputs.specularColor * brdf.x + brdf.y);
diffuse *= u_ScaleIBLAmbient.x;
specular *= u_ScaleIBLAmbient.y;
return diffuse + specular;
}
#endif
vec3 diffuse(PBRInfo pbrInputs)
{
return pbrInputs.diffuseColor / M_PI;
}
vec3 specularReflection(PBRInfo pbrInputs)
{
return pbrInputs.reflectance0 +
(pbrInputs.reflectance90 - pbrInputs.reflectance0) *
pow(clamp(1.0 - pbrInputs.VdotH, 0.0, 1.0), 5.0);
}
float geometricOcclusion(PBRInfo pbrInputs)
{
float NdotL = pbrInputs.NdotL;
float NdotV = pbrInputs.NdotV;
float r = pbrInputs.alphaRoughness;
float attenuationL = 2.0 * NdotL / (NdotL + sqrt(r * r + (1.0 - r * r) * (NdotL * NdotL)));
float attenuationV = 2.0 * NdotV / (NdotV + sqrt(r * r + (1.0 - r * r) * (NdotV * NdotV)));
return attenuationL * attenuationV;
}
float microfacetDistribution(PBRInfo pbrInputs)
{
float roughnessSq = pbrInputs.alphaRoughness * pbrInputs.alphaRoughness;
float f = (pbrInputs.NdotH * roughnessSq - pbrInputs.NdotH) * pbrInputs.NdotH + 1.0;
return roughnessSq / (M_PI * f * f);
}
void PBRInfo_setAmbientLight(inout PBRInfo pbrInputs) {
pbrInputs.NdotL = 1.0;
pbrInputs.NdotH = 0.0;
pbrInputs.LdotH = 0.0;
pbrInputs.VdotH = 1.0;
}
void PBRInfo_setDirectionalLight(inout PBRInfo pbrInputs, vec3 lightDirection) {
vec3 n = pbrInputs.n;
vec3 v = pbrInputs.v;
vec3 l = normalize(lightDirection);
vec3 h = normalize(l+v);
pbrInputs.NdotL = clamp(dot(n, l), 0.001, 1.0);
pbrInputs.NdotH = clamp(dot(n, h), 0.0, 1.0);
pbrInputs.LdotH = clamp(dot(l, h), 0.0, 1.0);
pbrInputs.VdotH = clamp(dot(v, h), 0.0, 1.0);
}
void PBRInfo_setPointLight(inout PBRInfo pbrInputs, PointLight pointLight) {
vec3 light_direction = normalize(pointLight.position - pbr_vPosition);
PBRInfo_setDirectionalLight(pbrInputs, light_direction);
}
vec3 calculateFinalColor(PBRInfo pbrInputs, vec3 lightColor) {
vec3 F = specularReflection(pbrInputs);
float G = geometricOcclusion(pbrInputs);
float D = microfacetDistribution(pbrInputs);
vec3 diffuseContrib = (1.0 - F) * diffuse(pbrInputs);
vec3 specContrib = F * G * D / (4.0 * pbrInputs.NdotL * pbrInputs.NdotV);
return pbrInputs.NdotL * lightColor * (diffuseContrib + specContrib);
}
vec4 pbr_filterColor(vec4 colorUnused)
{
#ifdef HAS_BASECOLORMAP
vec4 baseColor = SRGBtoLINEAR(texture(u_BaseColorSampler, pbr_vUV)) * u_BaseColorFactor;
#else
vec4 baseColor = u_BaseColorFactor;
#endif
#ifdef ALPHA_CUTOFF
if (baseColor.a < u_AlphaCutoff) {
discard;
}
#endif
vec3 color = vec3(0, 0, 0);
if(pbr_uUnlit){
color.rgb = baseColor.rgb;
}
else{
float perceptualRoughness = u_MetallicRoughnessValues.y;
float metallic = u_MetallicRoughnessValues.x;
#ifdef HAS_METALROUGHNESSMAP
vec4 mrSample = texture(u_MetallicRoughnessSampler, pbr_vUV);
perceptualRoughness = mrSample.g * perceptualRoughness;
metallic = mrSample.b * metallic;
#endif
perceptualRoughness = clamp(perceptualRoughness, c_MinRoughness, 1.0);
metallic = clamp(metallic, 0.0, 1.0);
float alphaRoughness = perceptualRoughness * perceptualRoughness;
vec3 f0 = vec3(0.04);
vec3 diffuseColor = baseColor.rgb * (vec3(1.0) - f0);
diffuseColor *= 1.0 - metallic;
vec3 specularColor = mix(f0, baseColor.rgb, metallic);
float reflectance = max(max(specularColor.r, specularColor.g), specularColor.b);
float reflectance90 = clamp(reflectance * 25.0, 0.0, 1.0);
vec3 specularEnvironmentR0 = specularColor.rgb;
vec3 specularEnvironmentR90 = vec3(1.0, 1.0, 1.0) * reflectance90;
vec3 n = getNormal();
vec3 v = normalize(u_Camera - pbr_vPosition);
float NdotV = clamp(abs(dot(n, v)), 0.001, 1.0);
vec3 reflection = -normalize(reflect(v, n));
PBRInfo pbrInputs = PBRInfo(
0.0,
NdotV,
0.0,
0.0,
0.0,
perceptualRoughness,
metallic,
specularEnvironmentR0,
specularEnvironmentR90,
alphaRoughness,
diffuseColor,
specularColor,
n,
v
);
#ifdef USE_LIGHTS
PBRInfo_setAmbientLight(pbrInputs);
color += calculateFinalColor(pbrInputs, lighting_uAmbientLight.color);
for(int i = 0; i < lighting_uDirectionalLightCount; i++) {
if (i < lighting_uDirectionalLightCount) {
PBRInfo_setDirectionalLight(pbrInputs, lighting_uDirectionalLight[i].direction);
color += calculateFinalColor(pbrInputs, lighting_uDirectionalLight[i].color);
}
}
for(int i = 0; i < lighting_uPointLightCount; i++) {
if (i < lighting_uPointLightCount) {
PBRInfo_setPointLight(pbrInputs, lighting_uPointLight[i]);
float attenuation = getPointLightAttenuation(lighting_uPointLight[i], distance(lighting_uPointLight[i].position, pbr_vPosition));
color += calculateFinalColor(pbrInputs, lighting_uPointLight[i].color / attenuation);
}
}
#endif
#ifdef USE_IBL
color += getIBLContribution(pbrInputs, n, reflection);
#endif
#ifdef HAS_OCCLUSIONMAP
float ao = texture(u_OcclusionSampler, pbr_vUV).r;
color = mix(color, color * ao, u_OcclusionStrength);
#endif
#ifdef HAS_EMISSIVEMAP
vec3 emissive = SRGBtoLINEAR(texture(u_EmissiveSampler, pbr_vUV)).rgb * u_EmissiveFactor;
color += emissive;
#endif
#ifdef PBR_DEBUG
color = mix(color, baseColor.rgb, u_ScaleDiffBaseMR.y);
color = mix(color, vec3(metallic), u_ScaleDiffBaseMR.z);
color = mix(color, vec3(perceptualRoughness), u_ScaleDiffBaseMR.w);
#endif
}
return vec4(pow(color,vec3(1.0/2.2)), baseColor.a);
}
`;
const pbr = {
  name: "pbr",
  vs: vs$2,
  fs: fs$2,
  defines: {
    LIGHTING_FRAGMENT: 1
  },
  dependencies: [lights]
};
const vs$1 = `#version 300 es
#define SHADER_NAME simple-mesh-layer-vs
uniform float sizeScale;
uniform bool composeModelMatrix;
uniform bool pickFeatureIds;
in vec3 positions;
in vec3 normals;
in vec3 colors;
in vec2 texCoords;
in vec4 uvRegions;
in vec3 featureIdsPickingColors;
in vec4 instanceColors;
in vec3 instancePickingColors;
in vec3 instanceModelMatrixCol0;
in vec3 instanceModelMatrixCol1;
in vec3 instanceModelMatrixCol2;
out vec2 vTexCoord;
out vec3 cameraPosition;
out vec3 normals_commonspace;
out vec4 position_commonspace;
out vec4 vColor;
vec2 applyUVRegion(vec2 uv) {
#ifdef HAS_UV_REGIONS
return fract(uv) * (uvRegions.zw - uvRegions.xy) + uvRegions.xy;
#else
return uv;
#endif
}
void main(void) {
vec2 uv = applyUVRegion(texCoords);
geometry.uv = uv;
if (pickFeatureIds) {
geometry.pickingColor = featureIdsPickingColors;
} else {
geometry.pickingColor = instancePickingColors;
}
mat3 instanceModelMatrix = mat3(instanceModelMatrixCol0, instanceModelMatrixCol1, instanceModelMatrixCol2);
vTexCoord = uv;
cameraPosition = project_uCameraPosition;
vColor = vec4(colors * instanceColors.rgb, instanceColors.a);
vec3 pos = (instanceModelMatrix * positions) * sizeScale;
vec3 projectedPosition = project_position(positions);
position_commonspace = vec4(projectedPosition, 1.0);
gl_Position = project_common_position_to_clipspace(position_commonspace);
geometry.position = position_commonspace;
normals_commonspace = project_normal(instanceModelMatrix * normals);
geometry.normal = normals_commonspace;
DECKGL_FILTER_GL_POSITION(gl_Position, geometry);
#ifdef MODULE_PBR
pbr_vPosition = geometry.position.xyz;
#ifdef HAS_NORMALS
pbr_vNormal = geometry.normal;
#endif
#ifdef HAS_UV
pbr_vUV = uv;
#else
pbr_vUV = vec2(0., 0.);
#endif
geometry.uv = pbr_vUV;
#endif
DECKGL_FILTER_COLOR(vColor, geometry);
}
`;
const fs$1 = `#version 300 es
#define SHADER_NAME simple-mesh-layer-fs
precision highp float;
uniform bool hasTexture;
uniform sampler2D sampler;
uniform bool flatShading;
uniform float opacity;
in vec2 vTexCoord;
in vec3 cameraPosition;
in vec3 normals_commonspace;
in vec4 position_commonspace;
in vec4 vColor;
out vec4 fragColor;
void main(void) {
#ifdef MODULE_PBR
fragColor = vColor * pbr_filterColor(vec4(0));
geometry.uv = pbr_vUV;
fragColor.a *= opacity;
#else
geometry.uv = vTexCoord;
vec3 normal;
if (flatShading) {
normal = normalize(cross(dFdx(position_commonspace.xyz), dFdy(position_commonspace.xyz)));
} else {
normal = normals_commonspace;
}
vec4 color = hasTexture ? texture(sampler, vTexCoord) : vColor;
vec3 lightColor = lighting_getLightColor(color.rgb, cameraPosition, position_commonspace.xyz, normal);
fragColor = vec4(lightColor, color.a * opacity);
#endif
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
function validateGeometryAttributes(attributes) {
  const positionAttribute = attributes.positions || attributes.POSITION;
  const vertexCount = positionAttribute.value.length / positionAttribute.size;
  const hasColorAttribute = attributes.COLOR_0 || attributes.colors;
  if (!hasColorAttribute) {
    attributes.colors = {
      size: 4,
      value: new Uint8Array(vertexCount * 4).fill(255),
      normalized: true
    };
  }
}
const defaultProps$6 = {
  pbrMaterial: { type: "object", value: null },
  featureIds: { type: "array", value: null, optional: true }
};
const _MeshLayer = class extends SimpleMeshLayer {
  getShaders() {
    const shaders = super.getShaders();
    const modules = shaders.modules;
    modules.push(pbr);
    return { ...shaders, vs: vs$1, fs: fs$1 };
  }
  initializeState() {
    const { featureIds } = this.props;
    super.initializeState();
    const attributeManager = this.getAttributeManager();
    if (featureIds) {
      attributeManager.add({
        featureIdsPickingColors: {
          type: "uint8",
          size: 3,
          noAlloc: true,
          // eslint-disable-next-line @typescript-eslint/unbound-method
          update: this.calculateFeatureIdsPickingColors
        }
      });
    }
  }
  updateState(params2) {
    super.updateState(params2);
    const { props, oldProps } = params2;
    if (props.pbrMaterial !== oldProps.pbrMaterial) {
      this.updatePbrMaterialUniforms(props.pbrMaterial);
    }
  }
  draw(opts) {
    const { featureIds } = this.props;
    if (!this.state.model) {
      return;
    }
    this.state.model.setUniforms({
      // Needed for PBR (TODO: find better way to get it)
      // eslint-disable-next-line camelcase
      u_Camera: this.state.model.uniforms.project_uCameraPosition,
      pickFeatureIds: Boolean(featureIds)
    });
    super.draw(opts);
  }
  getModel(mesh) {
    const { id, pbrMaterial } = this.props;
    const parsedPBRMaterial = this.parseMaterial(pbrMaterial, mesh);
    this.setState({ parsedPBRMaterial });
    const shaders = this.getShaders();
    validateGeometryAttributes(mesh.attributes);
    const model = new Model(this.context.device, {
      ...this.getShaders(),
      id,
      geometry: mesh,
      bufferLayout: this.getAttributeManager().getBufferLayouts(),
      defines: {
        ...shaders.defines,
        ...parsedPBRMaterial == null ? void 0 : parsedPBRMaterial.defines,
        HAS_UV_REGIONS: mesh.attributes.uvRegions ? 1 : 0
      },
      parameters: parsedPBRMaterial == null ? void 0 : parsedPBRMaterial.parameters,
      isInstanced: true
    });
    return model;
  }
  updatePbrMaterialUniforms(pbrMaterial) {
    const { model } = this.state;
    if (model) {
      const { mesh } = this.props;
      const parsedPBRMaterial = this.parseMaterial(pbrMaterial, mesh);
      this.setState({ parsedPBRMaterial });
      model.setBindings(parsedPBRMaterial.bindings);
      model.setUniforms(parsedPBRMaterial.uniforms);
    }
  }
  parseMaterial(pbrMaterial, mesh) {
    const unlit = Boolean(pbrMaterial.pbrMetallicRoughness && pbrMaterial.pbrMetallicRoughness.baseColorTexture);
    return parsePBRMaterial(this.context.device, { unlit, ...pbrMaterial }, { NORMAL: mesh.attributes.normals, TEXCOORD_0: mesh.attributes.texCoords }, {
      pbrDebug: false,
      lights: true,
      useTangents: false
    });
  }
  calculateFeatureIdsPickingColors(attribute) {
    const featureIds = this.props.featureIds;
    const value = new Uint8ClampedArray(featureIds.length * attribute.size);
    const pickingColor = [];
    for (let index2 = 0; index2 < featureIds.length; index2++) {
      this.encodePickingColor(featureIds[index2], pickingColor);
      value[index2 * 3] = pickingColor[0];
      value[index2 * 3 + 1] = pickingColor[1];
      value[index2 * 3 + 2] = pickingColor[2];
    }
    attribute.value = value;
  }
  finalizeState(context2) {
    var _a3;
    super.finalizeState(context2);
    (_a3 = this.state.parsedPBRMaterial) == null ? void 0 : _a3.generatedTextures.forEach((texture) => texture.destroy());
    this.setState({ parsedPBRMaterial: null });
  }
};
let MeshLayer = _MeshLayer;
(() => {
  _MeshLayer.layerName = "MeshLayer";
})();
(() => {
  _MeshLayer.defaultProps = defaultProps$6;
})();
const WGS84_RADIUS_X$1 = 6378137;
const WGS84_RADIUS_Y$1 = 6378137;
const WGS84_RADIUS_Z$1 = 6356752314245179e-9;
function identity$1(x2) {
  return x2;
}
new Vector3();
function fromCartographic(cartographic, result = [], map5 = identity$1) {
  if ("longitude" in cartographic) {
    result[0] = map5(cartographic.longitude);
    result[1] = map5(cartographic.latitude);
    result[2] = cartographic.height;
  } else if ("x" in cartographic) {
    result[0] = map5(cartographic.x);
    result[1] = map5(cartographic.y);
    result[2] = cartographic.z;
  } else {
    result[0] = map5(cartographic[0]);
    result[1] = map5(cartographic[1]);
    result[2] = cartographic[2];
  }
  return result;
}
function fromCartographicToRadians(cartographic, vector = []) {
  return fromCartographic(cartographic, vector, config._cartographicRadians ? identity$1 : toRadians);
}
function toCartographic(vector, cartographic, map5 = identity$1) {
  if ("longitude" in cartographic) {
    cartographic.longitude = map5(vector[0]);
    cartographic.latitude = map5(vector[1]);
    cartographic.height = vector[2];
  } else if ("x" in cartographic) {
    cartographic.x = map5(vector[0]);
    cartographic.y = map5(vector[1]);
    cartographic.z = vector[2];
  } else {
    cartographic[0] = map5(vector[0]);
    cartographic[1] = map5(vector[1]);
    cartographic[2] = vector[2];
  }
  return cartographic;
}
function toCartographicFromRadians(vector, cartographic) {
  return toCartographic(vector, cartographic, config._cartographicRadians ? identity$1 : toDegrees);
}
const EPSILON14 = 1e-14;
const scratchOrigin = new Vector3();
const VECTOR_PRODUCT_LOCAL_FRAME = {
  up: {
    south: "east",
    north: "west",
    west: "south",
    east: "north"
  },
  down: {
    south: "west",
    north: "east",
    west: "north",
    east: "south"
  },
  south: {
    up: "west",
    down: "east",
    west: "down",
    east: "up"
  },
  north: {
    up: "east",
    down: "west",
    west: "up",
    east: "down"
  },
  west: {
    up: "north",
    down: "south",
    north: "down",
    south: "up"
  },
  east: {
    up: "south",
    down: "north",
    north: "up",
    south: "down"
  }
};
const degeneratePositionLocalFrame = {
  north: [-1, 0, 0],
  east: [0, 1, 0],
  up: [0, 0, 1],
  south: [1, 0, 0],
  west: [0, -1, 0],
  down: [0, 0, -1]
};
const scratchAxisVectors = {
  east: new Vector3(),
  north: new Vector3(),
  up: new Vector3(),
  west: new Vector3(),
  south: new Vector3(),
  down: new Vector3()
};
const scratchVector1 = new Vector3();
const scratchVector2 = new Vector3();
const scratchVector3 = new Vector3();
function localFrameToFixedFrame(ellipsoid, firstAxis, secondAxis, thirdAxis, cartesianOrigin, result) {
  const thirdAxisInferred = VECTOR_PRODUCT_LOCAL_FRAME[firstAxis] && VECTOR_PRODUCT_LOCAL_FRAME[firstAxis][secondAxis];
  assert$9(thirdAxisInferred && (!thirdAxis || thirdAxis === thirdAxisInferred));
  let firstAxisVector;
  let secondAxisVector;
  let thirdAxisVector;
  const origin = scratchOrigin.copy(cartesianOrigin);
  const atPole = equals$1(origin.x, 0, EPSILON14) && equals$1(origin.y, 0, EPSILON14);
  if (atPole) {
    const sign2 = Math.sign(origin.z);
    firstAxisVector = scratchVector1.fromArray(degeneratePositionLocalFrame[firstAxis]);
    if (firstAxis !== "east" && firstAxis !== "west") {
      firstAxisVector.scale(sign2);
    }
    secondAxisVector = scratchVector2.fromArray(degeneratePositionLocalFrame[secondAxis]);
    if (secondAxis !== "east" && secondAxis !== "west") {
      secondAxisVector.scale(sign2);
    }
    thirdAxisVector = scratchVector3.fromArray(degeneratePositionLocalFrame[thirdAxis]);
    if (thirdAxis !== "east" && thirdAxis !== "west") {
      thirdAxisVector.scale(sign2);
    }
  } else {
    const { up, east, north } = scratchAxisVectors;
    east.set(-origin.y, origin.x, 0).normalize();
    ellipsoid.geodeticSurfaceNormal(origin, up);
    north.copy(up).cross(east);
    const { down, west, south } = scratchAxisVectors;
    down.copy(up).scale(-1);
    west.copy(east).scale(-1);
    south.copy(north).scale(-1);
    firstAxisVector = scratchAxisVectors[firstAxis];
    secondAxisVector = scratchAxisVectors[secondAxis];
    thirdAxisVector = scratchAxisVectors[thirdAxis];
  }
  result[0] = firstAxisVector.x;
  result[1] = firstAxisVector.y;
  result[2] = firstAxisVector.z;
  result[3] = 0;
  result[4] = secondAxisVector.x;
  result[5] = secondAxisVector.y;
  result[6] = secondAxisVector.z;
  result[7] = 0;
  result[8] = thirdAxisVector.x;
  result[9] = thirdAxisVector.y;
  result[10] = thirdAxisVector.z;
  result[11] = 0;
  result[12] = origin.x;
  result[13] = origin.y;
  result[14] = origin.z;
  result[15] = 1;
  return result;
}
const scratchVector$5 = new Vector3();
const scaleToGeodeticSurfaceIntersection = new Vector3();
const scaleToGeodeticSurfaceGradient = new Vector3();
function scaleToGeodeticSurface(cartesian2, ellipsoid, result = []) {
  const { oneOverRadii, oneOverRadiiSquared, centerToleranceSquared } = ellipsoid;
  scratchVector$5.from(cartesian2);
  const positionX = scratchVector$5.x;
  const positionY = scratchVector$5.y;
  const positionZ = scratchVector$5.z;
  const oneOverRadiiX = oneOverRadii.x;
  const oneOverRadiiY = oneOverRadii.y;
  const oneOverRadiiZ = oneOverRadii.z;
  const x2 = positionX * positionX * oneOverRadiiX * oneOverRadiiX;
  const y2 = positionY * positionY * oneOverRadiiY * oneOverRadiiY;
  const z2 = positionZ * positionZ * oneOverRadiiZ * oneOverRadiiZ;
  const squaredNorm = x2 + y2 + z2;
  const ratio = Math.sqrt(1 / squaredNorm);
  if (!Number.isFinite(ratio)) {
    return void 0;
  }
  const intersection8 = scaleToGeodeticSurfaceIntersection;
  intersection8.copy(cartesian2).scale(ratio);
  if (squaredNorm < centerToleranceSquared) {
    return intersection8.to(result);
  }
  const oneOverRadiiSquaredX = oneOverRadiiSquared.x;
  const oneOverRadiiSquaredY = oneOverRadiiSquared.y;
  const oneOverRadiiSquaredZ = oneOverRadiiSquared.z;
  const gradient = scaleToGeodeticSurfaceGradient;
  gradient.set(intersection8.x * oneOverRadiiSquaredX * 2, intersection8.y * oneOverRadiiSquaredY * 2, intersection8.z * oneOverRadiiSquaredZ * 2);
  let lambda = (1 - ratio) * scratchVector$5.len() / (0.5 * gradient.len());
  let correction = 0;
  let xMultiplier;
  let yMultiplier;
  let zMultiplier;
  let func2;
  do {
    lambda -= correction;
    xMultiplier = 1 / (1 + lambda * oneOverRadiiSquaredX);
    yMultiplier = 1 / (1 + lambda * oneOverRadiiSquaredY);
    zMultiplier = 1 / (1 + lambda * oneOverRadiiSquaredZ);
    const xMultiplier2 = xMultiplier * xMultiplier;
    const yMultiplier2 = yMultiplier * yMultiplier;
    const zMultiplier2 = zMultiplier * zMultiplier;
    const xMultiplier3 = xMultiplier2 * xMultiplier;
    const yMultiplier3 = yMultiplier2 * yMultiplier;
    const zMultiplier3 = zMultiplier2 * zMultiplier;
    func2 = x2 * xMultiplier2 + y2 * yMultiplier2 + z2 * zMultiplier2 - 1;
    const denominator = x2 * xMultiplier3 * oneOverRadiiSquaredX + y2 * yMultiplier3 * oneOverRadiiSquaredY + z2 * zMultiplier3 * oneOverRadiiSquaredZ;
    const derivative = -2 * denominator;
    correction = func2 / derivative;
  } while (Math.abs(func2) > EPSILON12);
  return scratchVector$5.scale([xMultiplier, yMultiplier, zMultiplier]).to(result);
}
const scratchVector$4 = new Vector3();
const scratchNormal$2 = new Vector3();
const scratchK = new Vector3();
const scratchPosition$1 = new Vector3();
const scratchHeight = new Vector3();
const scratchCartesian = new Vector3();
class Ellipsoid {
  constructor(x2 = 0, y2 = 0, z2 = 0) {
    this.centerToleranceSquared = EPSILON1;
    assert$9(x2 >= 0);
    assert$9(y2 >= 0);
    assert$9(z2 >= 0);
    this.radii = new Vector3(x2, y2, z2);
    this.radiiSquared = new Vector3(x2 * x2, y2 * y2, z2 * z2);
    this.radiiToTheFourth = new Vector3(x2 * x2 * x2 * x2, y2 * y2 * y2 * y2, z2 * z2 * z2 * z2);
    this.oneOverRadii = new Vector3(x2 === 0 ? 0 : 1 / x2, y2 === 0 ? 0 : 1 / y2, z2 === 0 ? 0 : 1 / z2);
    this.oneOverRadiiSquared = new Vector3(x2 === 0 ? 0 : 1 / (x2 * x2), y2 === 0 ? 0 : 1 / (y2 * y2), z2 === 0 ? 0 : 1 / (z2 * z2));
    this.minimumRadius = Math.min(x2, y2, z2);
    this.maximumRadius = Math.max(x2, y2, z2);
    if (this.radiiSquared.z !== 0) {
      this.squaredXOverSquaredZ = this.radiiSquared.x / this.radiiSquared.z;
    }
    Object.freeze(this);
  }
  /** Compares this Ellipsoid against the provided Ellipsoid componentwise */
  equals(right) {
    return this === right || Boolean(right && this.radii.equals(right.radii));
  }
  /** Creates a string representing this Ellipsoid in the format '(radii.x, radii.y, radii.z)'. */
  toString() {
    return this.radii.toString();
  }
  cartographicToCartesian(cartographic, result = [0, 0, 0]) {
    const normal = scratchNormal$2;
    const k2 = scratchK;
    const [, , height] = cartographic;
    this.geodeticSurfaceNormalCartographic(cartographic, normal);
    k2.copy(this.radiiSquared).scale(normal);
    const gamma = Math.sqrt(normal.dot(k2));
    k2.scale(1 / gamma);
    normal.scale(height);
    k2.add(normal);
    return k2.to(result);
  }
  cartesianToCartographic(cartesian2, result = [0, 0, 0]) {
    scratchCartesian.from(cartesian2);
    const point4 = this.scaleToGeodeticSurface(scratchCartesian, scratchPosition$1);
    if (!point4) {
      return void 0;
    }
    const normal = this.geodeticSurfaceNormal(point4, scratchNormal$2);
    const h2 = scratchHeight;
    h2.copy(scratchCartesian).subtract(point4);
    const longitude = Math.atan2(normal.y, normal.x);
    const latitude = Math.asin(normal.z);
    const height = Math.sign(dot$2(h2, scratchCartesian)) * length$4(h2);
    return toCartographicFromRadians([longitude, latitude, height], result);
  }
  eastNorthUpToFixedFrame(origin, result = new Matrix4()) {
    return localFrameToFixedFrame(this, "east", "north", "up", origin, result);
  }
  // Computes a 4x4 transformation matrix from a reference frame centered at
  // the provided origin to the ellipsoid's fixed reference frame.
  localFrameToFixedFrame(firstAxis, secondAxis, thirdAxis, origin, result = new Matrix4()) {
    return localFrameToFixedFrame(this, firstAxis, secondAxis, thirdAxis, origin, result);
  }
  geocentricSurfaceNormal(cartesian2, result = [0, 0, 0]) {
    return scratchVector$4.from(cartesian2).normalize().to(result);
  }
  geodeticSurfaceNormalCartographic(cartographic, result = [0, 0, 0]) {
    const cartographicVectorRadians = fromCartographicToRadians(cartographic);
    const longitude = cartographicVectorRadians[0];
    const latitude = cartographicVectorRadians[1];
    const cosLatitude = Math.cos(latitude);
    scratchVector$4.set(cosLatitude * Math.cos(longitude), cosLatitude * Math.sin(longitude), Math.sin(latitude)).normalize();
    return scratchVector$4.to(result);
  }
  geodeticSurfaceNormal(cartesian2, result = [0, 0, 0]) {
    return scratchVector$4.from(cartesian2).scale(this.oneOverRadiiSquared).normalize().to(result);
  }
  /** Scales the provided Cartesian position along the geodetic surface normal
   * so that it is on the surface of this ellipsoid.  If the position is
   * at the center of the ellipsoid, this function returns undefined. */
  scaleToGeodeticSurface(cartesian2, result) {
    return scaleToGeodeticSurface(cartesian2, this, result);
  }
  /** Scales the provided Cartesian position along the geocentric surface normal
   * so that it is on the surface of this ellipsoid. */
  scaleToGeocentricSurface(cartesian2, result = [0, 0, 0]) {
    scratchPosition$1.from(cartesian2);
    const positionX = scratchPosition$1.x;
    const positionY = scratchPosition$1.y;
    const positionZ = scratchPosition$1.z;
    const oneOverRadiiSquared = this.oneOverRadiiSquared;
    const beta = 1 / Math.sqrt(positionX * positionX * oneOverRadiiSquared.x + positionY * positionY * oneOverRadiiSquared.y + positionZ * positionZ * oneOverRadiiSquared.z);
    return scratchPosition$1.multiplyScalar(beta).to(result);
  }
  /** Transforms a Cartesian X, Y, Z position to the ellipsoid-scaled space by multiplying
   * its components by the result of `Ellipsoid#oneOverRadii` */
  transformPositionToScaledSpace(position, result = [0, 0, 0]) {
    return scratchPosition$1.from(position).scale(this.oneOverRadii).to(result);
  }
  /** Transforms a Cartesian X, Y, Z position from the ellipsoid-scaled space by multiplying
   * its components by the result of `Ellipsoid#radii`. */
  transformPositionFromScaledSpace(position, result = [0, 0, 0]) {
    return scratchPosition$1.from(position).scale(this.radii).to(result);
  }
  /** Computes a point which is the intersection of the surface normal with the z-axis. */
  getSurfaceNormalIntersectionWithZAxis(position, buffer3 = 0, result = [0, 0, 0]) {
    assert$9(equals$1(this.radii.x, this.radii.y, EPSILON15));
    assert$9(this.radii.z > 0);
    scratchPosition$1.from(position);
    const z2 = scratchPosition$1.z * (1 - this.squaredXOverSquaredZ);
    if (Math.abs(z2) >= this.radii.z - buffer3) {
      return void 0;
    }
    return scratchPosition$1.set(0, 0, z2).to(result);
  }
}
Ellipsoid.WGS84 = new Ellipsoid(WGS84_RADIUS_X$1, WGS84_RADIUS_Y$1, WGS84_RADIUS_Z$1);
class DoublyLinkedListNode {
  constructor(item, previous, next5) {
    __publicField2(this, "item");
    __publicField2(this, "previous");
    __publicField2(this, "next");
    this.item = item;
    this.previous = previous;
    this.next = next5;
  }
}
class DoublyLinkedList {
  constructor() {
    __publicField2(this, "head", null);
    __publicField2(this, "tail", null);
    __publicField2(this, "_length", 0);
  }
  get length() {
    return this._length;
  }
  /**
   * Adds the item to the end of the list
   * @param {*} [item]
   * @return {DoublyLinkedListNode}
   */
  add(item) {
    const node = new DoublyLinkedListNode(item, this.tail, null);
    if (this.tail) {
      this.tail.next = node;
      this.tail = node;
    } else {
      this.head = node;
      this.tail = node;
    }
    ++this._length;
    return node;
  }
  /**
   * Removes the given node from the list
   * @param {DoublyLinkedListNode} node
   */
  remove(node) {
    if (!node) {
      return;
    }
    if (node.previous && node.next) {
      node.previous.next = node.next;
      node.next.previous = node.previous;
    } else if (node.previous) {
      node.previous.next = null;
      this.tail = node.previous;
    } else if (node.next) {
      node.next.previous = null;
      this.head = node.next;
    } else {
      this.head = null;
      this.tail = null;
    }
    node.next = null;
    node.previous = null;
    --this._length;
  }
  /**
   * Moves nextNode after node
   * @param {DoublyLinkedListNode} node
   * @param {DoublyLinkedListNode} nextNode
   */
  splice(node, nextNode) {
    if (node === nextNode) {
      return;
    }
    this.remove(nextNode);
    this._insert(node, nextNode);
  }
  _insert(node, nextNode) {
    const oldNodeNext = node.next;
    node.next = nextNode;
    if (this.tail === node) {
      this.tail = nextNode;
    } else {
      oldNodeNext.previous = nextNode;
    }
    nextNode.next = oldNodeNext;
    nextNode.previous = node;
    ++this._length;
  }
}
class TilesetCache {
  constructor() {
    __publicField2(this, "_list");
    __publicField2(this, "_sentinel");
    __publicField2(this, "_trimTiles");
    this._list = new DoublyLinkedList();
    this._sentinel = this._list.add("sentinel");
    this._trimTiles = false;
  }
  reset() {
    this._list.splice(this._list.tail, this._sentinel);
  }
  touch(tile) {
    const node = tile._cacheNode;
    if (node) {
      this._list.splice(this._sentinel, node);
    }
  }
  add(tileset, tile, addCallback) {
    if (!tile._cacheNode) {
      tile._cacheNode = this._list.add(tile);
      if (addCallback) {
        addCallback(tileset, tile);
      }
    }
  }
  unloadTile(tileset, tile, unloadCallback) {
    const node = tile._cacheNode;
    if (!node) {
      return;
    }
    this._list.remove(node);
    tile._cacheNode = null;
    if (unloadCallback) {
      unloadCallback(tileset, tile);
    }
  }
  unloadTiles(tileset, unloadCallback) {
    const trimTiles = this._trimTiles;
    this._trimTiles = false;
    const list2 = this._list;
    const maximumMemoryUsageInBytes = tileset.maximumMemoryUsage * 1024 * 1024;
    const sentinel = this._sentinel;
    let node = list2.head;
    while (node !== sentinel && (tileset.gpuMemoryUsageInBytes > maximumMemoryUsageInBytes || trimTiles)) {
      const tile = node.item;
      node = node.next;
      this.unloadTile(tileset, tile, unloadCallback);
    }
  }
  trim() {
    this._trimTiles = true;
  }
}
function calculateTransformProps(tileHeader, tile) {
  assert$e(tileHeader);
  assert$e(tile);
  const { rtcCenter, gltfUpAxis } = tile;
  const { computedTransform, boundingVolume: { center: center2 } } = tileHeader;
  let modelMatrix2 = new Matrix4(computedTransform);
  if (rtcCenter) {
    modelMatrix2.translate(rtcCenter);
  }
  switch (gltfUpAxis) {
    case "Z":
      break;
    case "Y":
      const rotationY = new Matrix4().rotateX(Math.PI / 2);
      modelMatrix2 = modelMatrix2.multiplyRight(rotationY);
      break;
    case "X":
      const rotationX = new Matrix4().rotateY(-Math.PI / 2);
      modelMatrix2 = modelMatrix2.multiplyRight(rotationX);
      break;
  }
  if (tile.isQuantized) {
    modelMatrix2.translate(tile.quantizedVolumeOffset).scale(tile.quantizedVolumeScale);
  }
  const cartesianOrigin = new Vector3(center2);
  tile.cartesianModelMatrix = modelMatrix2;
  tile.cartesianOrigin = cartesianOrigin;
  const cartographicOrigin = Ellipsoid.WGS84.cartesianToCartographic(cartesianOrigin, new Vector3());
  const fromFixedFrameMatrix = Ellipsoid.WGS84.eastNorthUpToFixedFrame(cartesianOrigin);
  const toFixedFrameMatrix = fromFixedFrameMatrix.invert();
  tile.cartographicModelMatrix = toFixedFrameMatrix.multiplyRight(modelMatrix2);
  tile.cartographicOrigin = cartographicOrigin;
  if (!tile.coordinateSystem) {
    tile.modelMatrix = tile.cartographicModelMatrix;
  }
}
const scratchVector$3 = new Vector3();
const scratchPosition = new Vector3();
const cullingVolume = new CullingVolume([
  new Plane(),
  new Plane(),
  new Plane(),
  new Plane(),
  new Plane(),
  new Plane()
]);
function getFrameState(viewport, frameNumber) {
  const { cameraDirection, cameraUp, height } = viewport;
  const { metersPerUnit } = viewport.distanceScales;
  const viewportCenterCartesian = worldToCartesian(viewport, viewport.center);
  const enuToFixedTransform = Ellipsoid.WGS84.eastNorthUpToFixedFrame(viewportCenterCartesian);
  const cameraPositionCartographic = viewport.unprojectPosition(viewport.cameraPosition);
  const cameraPositionCartesian2 = Ellipsoid.WGS84.cartographicToCartesian(cameraPositionCartographic, new Vector3());
  const cameraDirectionCartesian = new Vector3(
    // @ts-ignore
    enuToFixedTransform.transformAsVector(new Vector3(cameraDirection).scale(metersPerUnit))
  ).normalize();
  const cameraUpCartesian = new Vector3(
    // @ts-ignore
    enuToFixedTransform.transformAsVector(new Vector3(cameraUp).scale(metersPerUnit))
  ).normalize();
  commonSpacePlanesToWGS84(viewport);
  const ViewportClass = viewport.constructor;
  const { longitude, latitude, width, bearing: bearing2, zoom: zoom2 } = viewport;
  const topDownViewport = new ViewportClass({
    longitude,
    latitude,
    height,
    width,
    bearing: bearing2,
    zoom: zoom2,
    pitch: 0
  });
  return {
    camera: {
      position: cameraPositionCartesian2,
      direction: cameraDirectionCartesian,
      up: cameraUpCartesian
    },
    viewport,
    topDownViewport,
    height,
    cullingVolume,
    frameNumber,
    // TODO: This can be the same between updates, what number is unique for between updates?
    sseDenominator: 1.15
    // Assumes fovy = 60 degrees
  };
}
function limitSelectedTiles(tiles, frameState, maximumTilesSelected) {
  if (maximumTilesSelected === 0 || tiles.length <= maximumTilesSelected) {
    return [tiles, []];
  }
  const tuples = [];
  const { longitude: viewportLongitude, latitude: viewportLatitude } = frameState.viewport;
  for (const [index2, tile] of tiles.entries()) {
    const [longitude, latitude] = tile.header.mbs;
    const deltaLon = Math.abs(viewportLongitude - longitude);
    const deltaLat = Math.abs(viewportLatitude - latitude);
    const distance11 = Math.sqrt(deltaLat * deltaLat + deltaLon * deltaLon);
    tuples.push([index2, distance11]);
  }
  const tuplesSorted = tuples.sort((a2, b2) => a2[1] - b2[1]);
  const selectedTiles = [];
  for (let i2 = 0; i2 < maximumTilesSelected; i2++) {
    selectedTiles.push(tiles[tuplesSorted[i2][0]]);
  }
  const unselectedTiles = [];
  for (let i2 = maximumTilesSelected; i2 < tuplesSorted.length; i2++) {
    unselectedTiles.push(tiles[tuplesSorted[i2][0]]);
  }
  return [selectedTiles, unselectedTiles];
}
function commonSpacePlanesToWGS84(viewport) {
  const frustumPlanes = viewport.getFrustumPlanes();
  const nearCenterCommon = closestPointOnPlane(frustumPlanes.near, viewport.cameraPosition);
  const nearCenterCartesian = worldToCartesian(viewport, nearCenterCommon);
  const cameraCartesian = worldToCartesian(viewport, viewport.cameraPosition, scratchPosition);
  let i2 = 0;
  cullingVolume.planes[i2++].fromPointNormal(nearCenterCartesian, scratchVector$3.copy(nearCenterCartesian).subtract(cameraCartesian));
  for (const dir in frustumPlanes) {
    if (dir === "near") {
      continue;
    }
    const plane = frustumPlanes[dir];
    const posCommon = closestPointOnPlane(plane, nearCenterCommon, scratchPosition);
    const cartesianPos = worldToCartesian(viewport, posCommon, scratchPosition);
    cullingVolume.planes[i2++].fromPointNormal(
      cartesianPos,
      // Want the normal to point into the frustum since that's what culling expects
      scratchVector$3.copy(nearCenterCartesian).subtract(cartesianPos)
    );
  }
}
function closestPointOnPlane(plane, refPoint, out = new Vector3()) {
  const distanceToRef = plane.normal.dot(refPoint);
  out.copy(plane.normal).scale(plane.distance - distanceToRef).add(refPoint);
  return out;
}
function worldToCartesian(viewport, point4, out = new Vector3()) {
  const cartographicPos = viewport.unprojectPosition(point4);
  return Ellipsoid.WGS84.cartographicToCartesian(cartographicPos, out);
}
const WGS84_RADIUS_X = 6378137;
const WGS84_RADIUS_Y = 6378137;
const WGS84_RADIUS_Z = 6356752314245179e-9;
const scratchVector$2 = new Vector3();
function getZoomFromBoundingVolume(boundingVolume, cartorgraphicCenter) {
  if (boundingVolume instanceof OrientedBoundingBox) {
    const { halfAxes } = boundingVolume;
    const obbSize = getObbSize(halfAxes);
    return Math.log2(WGS84_RADIUS_Z / (obbSize + cartorgraphicCenter[2]));
  } else if (boundingVolume instanceof BoundingSphere) {
    const { radius } = boundingVolume;
    return Math.log2(WGS84_RADIUS_Z / (radius + cartorgraphicCenter[2]));
  } else if (boundingVolume.width && boundingVolume.height) {
    const { width, height } = boundingVolume;
    const zoomX = Math.log2(WGS84_RADIUS_X / width);
    const zoomY = Math.log2(WGS84_RADIUS_Y / height);
    return (zoomX + zoomY) / 2;
  }
  return 1;
}
function getZoomFromFullExtent(fullExtent, cartorgraphicCenter, cartesianCenter) {
  Ellipsoid.WGS84.cartographicToCartesian([fullExtent.xmax, fullExtent.ymax, fullExtent.zmax], scratchVector$2);
  const extentSize = Math.sqrt(Math.pow(scratchVector$2[0] - cartesianCenter[0], 2) + Math.pow(scratchVector$2[1] - cartesianCenter[1], 2) + Math.pow(scratchVector$2[2] - cartesianCenter[2], 2));
  return Math.log2(WGS84_RADIUS_Z / (extentSize + cartorgraphicCenter[2]));
}
function getZoomFromExtent(extent2, cartorgraphicCenter, cartesianCenter) {
  const [xmin, ymin, xmax, ymax] = extent2;
  return getZoomFromFullExtent({ xmin, xmax, ymin, ymax, zmin: 0, zmax: 0 }, cartorgraphicCenter, cartesianCenter);
}
function getObbSize(halfAxes) {
  halfAxes.getColumn(0, scratchVector$2);
  const axeY = halfAxes.getColumn(1);
  const axeZ = halfAxes.getColumn(2);
  const farthestVertex = scratchVector$2.add(axeY).add(axeZ);
  const size12 = farthestVertex.len();
  return size12;
}
const TILE_CONTENT_STATE = {
  UNLOADED: 0,
  // Has never been requested
  LOADING: 1,
  // Is waiting on a pending request
  PROCESSING: 2,
  // Request received.  Contents are being processed for rendering.  Depending on the content, it might make its own requests for external data.
  READY: 3,
  // Ready to render.
  EXPIRED: 4,
  // Is expired and will be unloaded once new content is loaded.
  FAILED: 5
  // Request failed.
};
var TILE_REFINEMENT$1;
(function(TILE_REFINEMENT2) {
  TILE_REFINEMENT2[TILE_REFINEMENT2["ADD"] = 1] = "ADD";
  TILE_REFINEMENT2[TILE_REFINEMENT2["REPLACE"] = 2] = "REPLACE";
})(TILE_REFINEMENT$1 || (TILE_REFINEMENT$1 = {}));
var TILE_TYPE$1;
(function(TILE_TYPE2) {
  TILE_TYPE2["EMPTY"] = "empty";
  TILE_TYPE2["SCENEGRAPH"] = "scenegraph";
  TILE_TYPE2["POINTCLOUD"] = "pointcloud";
  TILE_TYPE2["MESH"] = "mesh";
})(TILE_TYPE$1 || (TILE_TYPE$1 = {}));
var TILESET_TYPE$1;
(function(TILESET_TYPE2) {
  TILESET_TYPE2["I3S"] = "I3S";
  TILESET_TYPE2["TILES3D"] = "TILES3D";
})(TILESET_TYPE$1 || (TILESET_TYPE$1 = {}));
var LOD_METRIC_TYPE$1;
(function(LOD_METRIC_TYPE2) {
  LOD_METRIC_TYPE2["GEOMETRIC_ERROR"] = "geometricError";
  LOD_METRIC_TYPE2["MAX_SCREEN_THRESHOLD"] = "maxScreenThreshold";
})(LOD_METRIC_TYPE$1 || (LOD_METRIC_TYPE$1 = {}));
const TILE3D_OPTIMIZATION_HINT = {
  NOT_COMPUTED: -1,
  USE_OPTIMIZATION: 1,
  SKIP_OPTIMIZATION: 0
};
function defined$5(x2) {
  return x2 !== void 0 && x2 !== null;
}
const scratchPoint = new Vector3();
const scratchScale = new Vector3();
const scratchNorthWest = new Vector3();
const scratchSouthEast = new Vector3();
const scratchCenter = new Vector3();
const scratchXAxis = new Vector3();
const scratchYAxis = new Vector3();
const scratchZAxis = new Vector3();
function createBoundingVolume(boundingVolumeHeader, transform4, result) {
  assert$e(boundingVolumeHeader, "3D Tile: boundingVolume must be defined");
  if (boundingVolumeHeader.box) {
    return createBox(boundingVolumeHeader.box, transform4, result);
  }
  if (boundingVolumeHeader.region) {
    return createObbFromRegion(boundingVolumeHeader.region);
  }
  if (boundingVolumeHeader.sphere) {
    return createSphere(boundingVolumeHeader.sphere, transform4, result);
  }
  throw new Error("3D Tile: boundingVolume must contain a sphere, region, or box");
}
function getCartographicBounds(boundingVolumeHeader, boundingVolume) {
  if (boundingVolumeHeader.box) {
    return orientedBoundingBoxToCartographicBounds(boundingVolume);
  }
  if (boundingVolumeHeader.region) {
    const [west, south, east, north, minHeight, maxHeight] = boundingVolumeHeader.region;
    return [
      [degrees(west), degrees(south), minHeight],
      [degrees(east), degrees(north), maxHeight]
    ];
  }
  if (boundingVolumeHeader.sphere) {
    return boundingSphereToCartographicBounds(boundingVolume);
  }
  throw new Error("Unkown boundingVolume type");
}
function createBox(box, transform4, result) {
  const center2 = new Vector3(box[0], box[1], box[2]);
  transform4.transform(center2, center2);
  let origin = [];
  if (box.length === 10) {
    const halfSize = box.slice(3, 6);
    const quaternion2 = new Quaternion();
    quaternion2.fromArray(box, 6);
    const x2 = new Vector3([1, 0, 0]);
    const y2 = new Vector3([0, 1, 0]);
    const z2 = new Vector3([0, 0, 1]);
    x2.transformByQuaternion(quaternion2);
    x2.scale(halfSize[0]);
    y2.transformByQuaternion(quaternion2);
    y2.scale(halfSize[1]);
    z2.transformByQuaternion(quaternion2);
    z2.scale(halfSize[2]);
    origin = [...x2.toArray(), ...y2.toArray(), ...z2.toArray()];
  } else {
    origin = [...box.slice(3, 6), ...box.slice(6, 9), ...box.slice(9, 12)];
  }
  const xAxis = transform4.transformAsVector(origin.slice(0, 3));
  const yAxis = transform4.transformAsVector(origin.slice(3, 6));
  const zAxis = transform4.transformAsVector(origin.slice(6, 9));
  const halfAxes = new Matrix3([
    xAxis[0],
    xAxis[1],
    xAxis[2],
    yAxis[0],
    yAxis[1],
    yAxis[2],
    zAxis[0],
    zAxis[1],
    zAxis[2]
  ]);
  if (defined$5(result)) {
    result.center = center2;
    result.halfAxes = halfAxes;
    return result;
  }
  return new OrientedBoundingBox(center2, halfAxes);
}
function createSphere(sphere2, transform4, result) {
  const center2 = new Vector3(sphere2[0], sphere2[1], sphere2[2]);
  transform4.transform(center2, center2);
  const scale5 = transform4.getScale(scratchScale);
  const uniformScale = Math.max(Math.max(scale5[0], scale5[1]), scale5[2]);
  const radius = sphere2[3] * uniformScale;
  if (defined$5(result)) {
    result.center = center2;
    result.radius = radius;
    return result;
  }
  return new BoundingSphere(center2, radius);
}
function createObbFromRegion(region) {
  const [west, south, east, north, minHeight, maxHeight] = region;
  const northWest = Ellipsoid.WGS84.cartographicToCartesian([degrees(west), degrees(north), minHeight], scratchNorthWest);
  const southEast = Ellipsoid.WGS84.cartographicToCartesian([degrees(east), degrees(south), maxHeight], scratchSouthEast);
  const centerInCartesian = new Vector3().addVectors(northWest, southEast).multiplyByScalar(0.5);
  Ellipsoid.WGS84.cartesianToCartographic(centerInCartesian, scratchCenter);
  Ellipsoid.WGS84.cartographicToCartesian([degrees(east), scratchCenter[1], scratchCenter[2]], scratchXAxis);
  Ellipsoid.WGS84.cartographicToCartesian([scratchCenter[0], degrees(north), scratchCenter[2]], scratchYAxis);
  Ellipsoid.WGS84.cartographicToCartesian([scratchCenter[0], scratchCenter[1], maxHeight], scratchZAxis);
  return createBox([
    ...centerInCartesian,
    ...scratchXAxis.subtract(centerInCartesian),
    ...scratchYAxis.subtract(centerInCartesian),
    ...scratchZAxis.subtract(centerInCartesian)
  ], new Matrix4());
}
function orientedBoundingBoxToCartographicBounds(boundingVolume) {
  const result = emptyCartographicBounds();
  const { halfAxes } = boundingVolume;
  const xAxis = new Vector3(halfAxes.getColumn(0));
  const yAxis = new Vector3(halfAxes.getColumn(1));
  const zAxis = new Vector3(halfAxes.getColumn(2));
  for (let x2 = 0; x2 < 2; x2++) {
    for (let y2 = 0; y2 < 2; y2++) {
      for (let z2 = 0; z2 < 2; z2++) {
        scratchPoint.copy(boundingVolume.center);
        scratchPoint.add(xAxis);
        scratchPoint.add(yAxis);
        scratchPoint.add(zAxis);
        addToCartographicBounds(result, scratchPoint);
        zAxis.negate();
      }
      yAxis.negate();
    }
    xAxis.negate();
  }
  return result;
}
function boundingSphereToCartographicBounds(boundingVolume) {
  const result = emptyCartographicBounds();
  const { center: center2, radius } = boundingVolume;
  const point4 = Ellipsoid.WGS84.scaleToGeodeticSurface(center2, scratchPoint);
  let zAxis;
  if (point4) {
    zAxis = Ellipsoid.WGS84.geodeticSurfaceNormal(point4);
  } else {
    zAxis = new Vector3(0, 0, 1);
  }
  let xAxis = new Vector3(zAxis[2], -zAxis[1], 0);
  if (xAxis.len() > 0) {
    xAxis.normalize();
  } else {
    xAxis = new Vector3(0, 1, 0);
  }
  const yAxis = xAxis.clone().cross(zAxis);
  for (const axis of [xAxis, yAxis, zAxis]) {
    scratchScale.copy(axis).scale(radius);
    for (let dir = 0; dir < 2; dir++) {
      scratchPoint.copy(center2);
      scratchPoint.add(scratchScale);
      addToCartographicBounds(result, scratchPoint);
      scratchScale.negate();
    }
  }
  return result;
}
function emptyCartographicBounds() {
  return [
    [Infinity, Infinity, Infinity],
    [-Infinity, -Infinity, -Infinity]
  ];
}
function addToCartographicBounds(target, cartesian2) {
  Ellipsoid.WGS84.cartesianToCartographic(cartesian2, scratchPoint);
  target[0][0] = Math.min(target[0][0], scratchPoint[0]);
  target[0][1] = Math.min(target[0][1], scratchPoint[1]);
  target[0][2] = Math.min(target[0][2], scratchPoint[2]);
  target[1][0] = Math.max(target[1][0], scratchPoint[0]);
  target[1][1] = Math.max(target[1][1], scratchPoint[1]);
  target[1][2] = Math.max(target[1][2], scratchPoint[2]);
}
new Vector3();
new Vector3();
new Matrix4();
new Vector3();
new Vector3();
new Vector3();
function fog(distanceToCamera, density) {
  const scalar = distanceToCamera * density;
  return 1 - Math.exp(-(scalar * scalar));
}
function getDynamicScreenSpaceError(tileset, distanceToCamera) {
  if (tileset.dynamicScreenSpaceError && tileset.dynamicScreenSpaceErrorComputedDensity) {
    const density = tileset.dynamicScreenSpaceErrorComputedDensity;
    const factor = tileset.dynamicScreenSpaceErrorFactor;
    const dynamicError = fog(distanceToCamera, density) * factor;
    return dynamicError;
  }
  return 0;
}
function getTiles3DScreenSpaceError(tile, frameState, useParentLodMetric) {
  const tileset = tile.tileset;
  const parentLodMetricValue = tile.parent && tile.parent.lodMetricValue || tile.lodMetricValue;
  const lodMetricValue = useParentLodMetric ? parentLodMetricValue : tile.lodMetricValue;
  if (lodMetricValue === 0) {
    return 0;
  }
  const distance11 = Math.max(tile._distanceToCamera, 1e-7);
  const { height, sseDenominator } = frameState;
  const { viewDistanceScale } = tileset.options;
  let error2 = lodMetricValue * height * (viewDistanceScale || 1) / (distance11 * sseDenominator);
  error2 -= getDynamicScreenSpaceError(tileset, distance11);
  return error2;
}
const cameraPositionCartesian = new Vector3();
const toEye = new Vector3();
const cameraPositionEnu = new Vector3();
const extraVertexEnu = new Vector3();
const projectedOriginVector = new Vector3();
const enuToCartesianMatrix = new Matrix4();
const cartesianToEnuMatrix = new Matrix4();
function getLodStatus(tile, frameState) {
  if (tile.lodMetricValue === 0 || isNaN(tile.lodMetricValue)) {
    return "DIG";
  }
  const screenSize = 2 * getProjectedRadius(tile, frameState);
  if (screenSize < 2) {
    return "OUT";
  }
  if (!tile.header.children || screenSize <= tile.lodMetricValue) {
    return "DRAW";
  } else if (tile.header.children) {
    return "DIG";
  }
  return "OUT";
}
function getProjectedRadius(tile, frameState) {
  const { topDownViewport: viewport } = frameState;
  const mbsLat = tile.header.mbs[1];
  const mbsLon = tile.header.mbs[0];
  const mbsZ = tile.header.mbs[2];
  const mbsR = tile.header.mbs[3];
  const mbsCenterCartesian = [...tile.boundingVolume.center];
  const cameraPositionCartographic = viewport.unprojectPosition(viewport.cameraPosition);
  Ellipsoid.WGS84.cartographicToCartesian(cameraPositionCartographic, cameraPositionCartesian);
  toEye.copy(cameraPositionCartesian).subtract(mbsCenterCartesian).normalize();
  Ellipsoid.WGS84.eastNorthUpToFixedFrame(mbsCenterCartesian, enuToCartesianMatrix);
  cartesianToEnuMatrix.copy(enuToCartesianMatrix).invert();
  cameraPositionEnu.copy(cameraPositionCartesian).transform(cartesianToEnuMatrix);
  const projection2 = Math.sqrt(cameraPositionEnu[0] * cameraPositionEnu[0] + cameraPositionEnu[1] * cameraPositionEnu[1]);
  const extraZ = projection2 * projection2 / cameraPositionEnu[2];
  extraVertexEnu.copy([cameraPositionEnu[0], cameraPositionEnu[1], extraZ]);
  const extraVertexCartesian = extraVertexEnu.transform(enuToCartesianMatrix);
  const extraVectorCartesian = extraVertexCartesian.subtract(mbsCenterCartesian).normalize();
  const radiusVector = toEye.cross(extraVectorCartesian).normalize().scale(mbsR);
  const sphereMbsBorderVertexCartesian = radiusVector.add(mbsCenterCartesian);
  const sphereMbsBorderVertexCartographic = Ellipsoid.WGS84.cartesianToCartographic(sphereMbsBorderVertexCartesian);
  const projectedOrigin = viewport.project([mbsLon, mbsLat, mbsZ]);
  const projectedMbsBorderVertex = viewport.project(sphereMbsBorderVertexCartographic);
  const projectedRadius = projectedOriginVector.copy(projectedOrigin).subtract(projectedMbsBorderVertex).magnitude();
  return projectedRadius;
}
function get3dTilesOptions(tileset) {
  return {
    assetGltfUpAxis: tileset.asset && tileset.asset.gltfUpAxis || "Y"
  };
}
class ManagedArray {
  constructor(length2 = 0) {
    __publicField2(this, "_map", /* @__PURE__ */ new Map());
    __publicField2(this, "_array");
    __publicField2(this, "_length");
    this._array = new Array(length2);
    this._length = length2;
  }
  /**
   * Gets or sets the length of the array.
   * If the set length is greater than the length of the internal array, the internal array is resized.
   *
   * @memberof ManagedArray.prototype
   * @type Number
   */
  get length() {
    return this._length;
  }
  set length(length2) {
    this._length = length2;
    if (length2 > this._array.length) {
      this._array.length = length2;
    }
  }
  /**
   * Gets the internal array.
   *
   * @memberof ManagedArray.prototype
   * @type Array
   * @readonly
   */
  get values() {
    return this._array;
  }
  /**
   * Gets the element at an index.
   *
   * @param {Number} index The index to get.
   */
  get(index2) {
    assert$e(index2 < this._array.length);
    return this._array[index2];
  }
  /**
   * Sets the element at an index. Resizes the array if index is greater than the length of the array.
   *
   * @param {Number} index The index to set.
   * @param {*} element The element to set at index.
   */
  set(index2, element) {
    assert$e(index2 >= 0);
    if (index2 >= this.length) {
      this.length = index2 + 1;
    }
    if (this._map.has(this._array[index2])) {
      this._map.delete(this._array[index2]);
    }
    this._array[index2] = element;
    this._map.set(element, index2);
  }
  delete(element) {
    const index2 = this._map.get(element);
    if (index2 >= 0) {
      this._array.splice(index2, 1);
      this._map.delete(element);
      this.length--;
    }
  }
  /**
   * Returns the last element in the array without modifying the array.
   *
   * @returns {*} The last element in the array.
   */
  peek() {
    return this._array[this._length - 1];
  }
  /**
   * Push an element into the array.
   *
   * @param {*} element The element to push.
   */
  push(element) {
    if (!this._map.has(element)) {
      const index2 = this.length++;
      this._array[index2] = element;
      this._map.set(element, index2);
    }
  }
  /**
   * Pop an element from the array.
   *
   * @returns {*} The last element in the array.
   */
  pop() {
    const element = this._array[--this.length];
    this._map.delete(element);
    return element;
  }
  /**
   * Resize the internal array if length > _array.length.
   *
   * @param {Number} length The length.
   */
  reserve(length2) {
    assert$e(length2 >= 0);
    if (length2 > this._array.length) {
      this._array.length = length2;
    }
  }
  /**
   * Resize the array.
   *
   * @param {Number} length The length.
   */
  resize(length2) {
    assert$e(length2 >= 0);
    this.length = length2;
  }
  /**
   * Trim the internal array to the specified length. Defaults to the current length.
   *
   * @param {Number} [length] The length.
   */
  trim(length2) {
    if (length2 === null || length2 === void 0) {
      length2 = this.length;
    }
    this._array.length = length2;
  }
  reset() {
    this._array = [];
    this._map = /* @__PURE__ */ new Map();
    this._length = 0;
  }
  find(target) {
    return this._map.has(target);
  }
}
const DEFAULT_PROPS$1 = {
  loadSiblings: false,
  skipLevelOfDetail: false,
  updateTransforms: true,
  onTraversalEnd: () => {
  },
  viewportTraversersMap: {},
  basePath: ""
};
class TilesetTraverser {
  // TODO nested props
  constructor(options2) {
    __publicField2(this, "options");
    // fulfill in traverse call
    __publicField2(this, "root", null);
    // tiles should be rendered
    __publicField2(this, "selectedTiles", {});
    // tiles should be loaded from server
    __publicField2(this, "requestedTiles", {});
    // tiles does not have render content
    __publicField2(this, "emptyTiles", {});
    __publicField2(this, "lastUpdate", (/* @__PURE__ */ new Date()).getTime());
    __publicField2(this, "updateDebounceTime", 1e3);
    /** temporary storage to hold the traversed tiles during a traversal */
    __publicField2(this, "_traversalStack", new ManagedArray());
    __publicField2(this, "_emptyTraversalStack", new ManagedArray());
    /** set in every traverse cycle */
    __publicField2(this, "_frameNumber", null);
    this.options = { ...DEFAULT_PROPS$1, ...options2 };
  }
  // RESULT
  traversalFinished(frameState) {
    return true;
  }
  // tiles should be visible
  traverse(root2, frameState, options2) {
    this.root = root2;
    this.options = { ...this.options, ...options2 };
    this.reset();
    this.updateTile(root2, frameState);
    this._frameNumber = frameState.frameNumber;
    this.executeTraversal(root2, frameState);
  }
  reset() {
    this.requestedTiles = {};
    this.selectedTiles = {};
    this.emptyTiles = {};
    this._traversalStack.reset();
    this._emptyTraversalStack.reset();
  }
  /**
   * Execute traverse
   * Depth-first traversal that traverses all visible tiles and marks tiles for selection.
   * If skipLevelOfDetail is off then a tile does not refine until all children are loaded.
   * This is the traditional replacement refinement approach and is called the base traversal.
   * Tiles that have a greater screen space error than the base screen space error are part of the base traversal,
   * all other tiles are part of the skip traversal. The skip traversal allows for skipping levels of the tree
   * and rendering children and parent tiles simultaneously.
   */
  /* eslint-disable-next-line complexity, max-statements */
  executeTraversal(root2, frameState) {
    const stack2 = this._traversalStack;
    root2._selectionDepth = 1;
    stack2.push(root2);
    while (stack2.length > 0) {
      const tile = stack2.pop();
      let shouldRefine = false;
      if (this.canTraverse(tile, frameState)) {
        this.updateChildTiles(tile, frameState);
        shouldRefine = this.updateAndPushChildren(tile, frameState, stack2, tile.hasRenderContent ? tile._selectionDepth + 1 : tile._selectionDepth);
      }
      const parent = tile.parent;
      const parentRefines = Boolean(!parent || parent._shouldRefine);
      const stoppedRefining = !shouldRefine;
      if (!tile.hasRenderContent) {
        this.emptyTiles[tile.id] = tile;
        this.loadTile(tile, frameState);
        if (stoppedRefining) {
          this.selectTile(tile, frameState);
        }
      } else if (tile.refine === TILE_REFINEMENT$1.ADD) {
        this.loadTile(tile, frameState);
        this.selectTile(tile, frameState);
      } else if (tile.refine === TILE_REFINEMENT$1.REPLACE) {
        this.loadTile(tile, frameState);
        if (stoppedRefining) {
          this.selectTile(tile, frameState);
        }
      }
      this.touchTile(tile, frameState);
      tile._shouldRefine = shouldRefine && parentRefines;
    }
    const newTime = (/* @__PURE__ */ new Date()).getTime();
    if (this.traversalFinished(frameState) || newTime - this.lastUpdate > this.updateDebounceTime) {
      this.lastUpdate = newTime;
      this.options.onTraversalEnd(frameState);
    }
  }
  updateChildTiles(tile, frameState) {
    const children = tile.children;
    for (const child of children) {
      this.updateTile(child, frameState);
    }
  }
  /* eslint-disable complexity, max-statements */
  updateAndPushChildren(tile, frameState, stack2, depth2) {
    const { loadSiblings, skipLevelOfDetail } = this.options;
    const children = tile.children;
    children.sort(this.compareDistanceToCamera.bind(this));
    const checkRefines = tile.refine === TILE_REFINEMENT$1.REPLACE && tile.hasRenderContent && !skipLevelOfDetail;
    let hasVisibleChild = false;
    let refines = true;
    for (const child of children) {
      child._selectionDepth = depth2;
      if (child.isVisibleAndInRequestVolume) {
        if (stack2.find(child)) {
          stack2.delete(child);
        }
        stack2.push(child);
        hasVisibleChild = true;
      } else if (checkRefines || loadSiblings) {
        this.loadTile(child, frameState);
        this.touchTile(child, frameState);
      }
      if (checkRefines) {
        let childRefines;
        if (!child._inRequestVolume) {
          childRefines = false;
        } else if (!child.hasRenderContent) {
          childRefines = this.executeEmptyTraversal(child, frameState);
        } else {
          childRefines = child.contentAvailable;
        }
        refines = refines && childRefines;
        if (!refines) {
          return false;
        }
      }
    }
    if (!hasVisibleChild) {
      refines = false;
    }
    return refines;
  }
  /* eslint-enable complexity, max-statements */
  updateTile(tile, frameState) {
    this.updateTileVisibility(tile, frameState);
  }
  // tile to render in the browser
  selectTile(tile, frameState) {
    if (this.shouldSelectTile(tile)) {
      tile._selectedFrame = frameState.frameNumber;
      this.selectedTiles[tile.id] = tile;
    }
  }
  // tile to load from server
  loadTile(tile, frameState) {
    if (this.shouldLoadTile(tile)) {
      tile._requestedFrame = frameState.frameNumber;
      tile._priority = tile._getPriority();
      this.requestedTiles[tile.id] = tile;
    }
  }
  // cache tile
  touchTile(tile, frameState) {
    tile.tileset._cache.touch(tile);
    tile._touchedFrame = frameState.frameNumber;
  }
  // tile should be visible
  // tile should have children
  // tile LoD (level of detail) is not sufficient under current viewport
  canTraverse(tile, frameState, useParentMetric = false, ignoreVisibility = false) {
    if (!tile.hasChildren) {
      return false;
    }
    if (tile.hasTilesetContent) {
      return !tile.contentExpired;
    }
    if (!ignoreVisibility && !tile.isVisibleAndInRequestVolume) {
      return false;
    }
    return this.shouldRefine(tile, frameState, useParentMetric);
  }
  shouldLoadTile(tile) {
    return tile.hasUnloadedContent || tile.contentExpired;
  }
  shouldSelectTile(tile) {
    return tile.contentAvailable && !this.options.skipLevelOfDetail;
  }
  /** Decide if tile LoD (level of detail) is not sufficient under current viewport */
  shouldRefine(tile, frameState, useParentMetric = false) {
    let screenSpaceError = tile._screenSpaceError;
    if (useParentMetric) {
      screenSpaceError = tile.getScreenSpaceError(frameState, true);
    }
    return screenSpaceError > tile.tileset.memoryAdjustedScreenSpaceError;
  }
  updateTileVisibility(tile, frameState) {
    const viewportIds = [];
    if (this.options.viewportTraversersMap) {
      for (const key in this.options.viewportTraversersMap) {
        const value = this.options.viewportTraversersMap[key];
        if (value === frameState.viewport.id) {
          viewportIds.push(key);
        }
      }
    } else {
      viewportIds.push(frameState.viewport.id);
    }
    tile.updateVisibility(frameState, viewportIds);
  }
  // UTILITIES
  compareDistanceToCamera(b2, a2) {
    return b2._distanceToCamera - a2._distanceToCamera;
  }
  anyChildrenVisible(tile, frameState) {
    let anyVisible = false;
    for (const child of tile.children) {
      child.updateVisibility(frameState);
      anyVisible = anyVisible || child.isVisibleAndInRequestVolume;
    }
    return anyVisible;
  }
  // Depth-first traversal that checks if all nearest descendants with content are loaded.
  // Ignores visibility.
  executeEmptyTraversal(root2, frameState) {
    let allDescendantsLoaded = true;
    const stack2 = this._emptyTraversalStack;
    stack2.push(root2);
    while (stack2.length > 0) {
      const tile = stack2.pop();
      const traverse2 = !tile.hasRenderContent && this.canTraverse(tile, frameState, false, false);
      const emptyLeaf = !tile.hasRenderContent && tile.children.length === 0;
      if (!traverse2 && !tile.contentAvailable && !emptyLeaf) {
        allDescendantsLoaded = false;
      }
      this.updateTile(tile, frameState);
      if (!tile.isVisibleAndInRequestVolume) {
        this.loadTile(tile, frameState);
        this.touchTile(tile, frameState);
      }
      if (traverse2) {
        const children = tile.children;
        for (const child of children) {
          stack2.push(child);
        }
      }
    }
    return allDescendantsLoaded;
  }
}
const scratchVector$1 = new Vector3();
function defined$4(x2) {
  return x2 !== void 0 && x2 !== null;
}
class Tile3D {
  // TODO i3s specific, needs to remove
  /**
   * @constructs
   * Create a Tile3D instance
   * @param tileset - Tileset3D instance
   * @param header - tile header - JSON loaded from a dataset
   * @param parentHeader - parent Tile3D instance
   * @param extendedId - optional ID to separate copies of a tile for different viewports.
   *    const extendedId = `${tile.id}-${frameState.viewport.id}`;
   */
  // eslint-disable-next-line max-statements
  constructor(tileset, header, parentHeader, extendedId = "") {
    __publicField2(this, "tileset");
    __publicField2(this, "header");
    __publicField2(this, "id");
    __publicField2(this, "url");
    __publicField2(this, "parent");
    /* Specifies the type of refine that is used when traversing this tile for rendering. */
    __publicField2(this, "refine");
    __publicField2(this, "type");
    __publicField2(this, "contentUrl");
    /** Different refinement algorithms used by I3S and 3D tiles */
    __publicField2(this, "lodMetricType", "geometricError");
    /** The error, in meters, introduced if this tile is rendered and its children are not. */
    __publicField2(this, "lodMetricValue", 0);
    /** @todo math.gl is not exporting BoundingVolume base type? */
    __publicField2(this, "boundingVolume", null);
    /**
     * The tile's content.  This represents the actual tile's payload,
     * not the content's metadata in the tileset JSON file.
     */
    __publicField2(this, "content", null);
    __publicField2(this, "contentState", TILE_CONTENT_STATE.UNLOADED);
    __publicField2(this, "gpuMemoryUsageInBytes", 0);
    /** The tile's children - an array of Tile3D objects. */
    __publicField2(this, "children", []);
    __publicField2(this, "depth", 0);
    __publicField2(this, "viewportIds", []);
    __publicField2(this, "transform", new Matrix4());
    __publicField2(this, "extensions", null);
    /** TODO Cesium 3d tiles specific */
    __publicField2(this, "implicitTiling", null);
    /** Container to store application specific data */
    __publicField2(this, "userData", {});
    __publicField2(this, "computedTransform");
    __publicField2(this, "hasEmptyContent", false);
    __publicField2(this, "hasTilesetContent", false);
    __publicField2(this, "traverser", new TilesetTraverser({}));
    /** Used by TilesetCache */
    __publicField2(this, "_cacheNode", null);
    __publicField2(this, "_frameNumber", null);
    // TODO Cesium 3d tiles specific
    __publicField2(this, "_expireDate", null);
    __publicField2(this, "_expiredContent", null);
    __publicField2(this, "_boundingBox");
    /** updated every frame for tree traversal and rendering optimizations: */
    __publicField2(this, "_distanceToCamera", 0);
    __publicField2(this, "_screenSpaceError", 0);
    __publicField2(this, "_visibilityPlaneMask");
    __publicField2(this, "_visible");
    __publicField2(this, "_contentBoundingVolume");
    __publicField2(this, "_viewerRequestVolume");
    __publicField2(this, "_initialTransform", new Matrix4());
    // Used by traverser, cannot be marked private
    __publicField2(this, "_priority", 0);
    __publicField2(this, "_selectedFrame", 0);
    __publicField2(this, "_requestedFrame", 0);
    __publicField2(this, "_selectionDepth", 0);
    __publicField2(this, "_touchedFrame", 0);
    __publicField2(this, "_centerZDepth", 0);
    __publicField2(this, "_shouldRefine", false);
    __publicField2(this, "_stackLength", 0);
    __publicField2(this, "_visitedFrame", 0);
    __publicField2(this, "_inRequestVolume", false);
    __publicField2(this, "_lodJudge", null);
    this.header = header;
    this.tileset = tileset;
    this.id = extendedId || header.id;
    this.url = header.url;
    this.parent = parentHeader;
    this.refine = this._getRefine(header.refine);
    this.type = header.type;
    this.contentUrl = header.contentUrl;
    this._initializeLodMetric(header);
    this._initializeTransforms(header);
    this._initializeBoundingVolumes(header);
    this._initializeContent(header);
    this._initializeRenderingState(header);
    Object.seal(this);
  }
  destroy() {
    this.header = null;
  }
  isDestroyed() {
    return this.header === null;
  }
  get selected() {
    return this._selectedFrame === this.tileset._frameNumber;
  }
  get isVisible() {
    return this._visible;
  }
  get isVisibleAndInRequestVolume() {
    return this._visible && this._inRequestVolume;
  }
  /** Returns true if tile is not an empty tile and not an external tileset */
  get hasRenderContent() {
    return !this.hasEmptyContent && !this.hasTilesetContent;
  }
  /** Returns true if tile has children */
  get hasChildren() {
    return this.children.length > 0 || this.header.children && this.header.children.length > 0;
  }
  /**
   * Determines if the tile's content is ready. This is automatically `true` for
   * tiles with empty content.
   */
  get contentReady() {
    return this.contentState === TILE_CONTENT_STATE.READY || this.hasEmptyContent;
  }
  /**
   * Determines if the tile has available content to render.  `true` if the tile's
   * content is ready or if it has expired content this renders while new content loads; otherwise,
   */
  get contentAvailable() {
    return Boolean(this.contentReady && this.hasRenderContent || this._expiredContent && !this.contentFailed);
  }
  /** Returns true if tile has renderable content but it's unloaded */
  get hasUnloadedContent() {
    return this.hasRenderContent && this.contentUnloaded;
  }
  /**
   * Determines if the tile's content has not be requested. `true` if tile's
   * content has not be requested; otherwise, `false`.
   */
  get contentUnloaded() {
    return this.contentState === TILE_CONTENT_STATE.UNLOADED;
  }
  /**
   * Determines if the tile's content is expired. `true` if tile's
   * content is expired; otherwise, `false`.
   */
  get contentExpired() {
    return this.contentState === TILE_CONTENT_STATE.EXPIRED;
  }
  // Determines if the tile's content failed to load.  `true` if the tile's
  // content failed to load; otherwise, `false`.
  get contentFailed() {
    return this.contentState === TILE_CONTENT_STATE.FAILED;
  }
  /**
   * Distance from the tile's bounding volume center to the camera
   */
  get distanceToCamera() {
    return this._distanceToCamera;
  }
  /**
   * Screen space error for LOD selection
   */
  get screenSpaceError() {
    return this._screenSpaceError;
  }
  /**
   * Get bounding box in cartographic coordinates
   * @returns [min, max] each in [longitude, latitude, altitude]
   */
  get boundingBox() {
    if (!this._boundingBox) {
      this._boundingBox = getCartographicBounds(this.header.boundingVolume, this.boundingVolume);
    }
    return this._boundingBox;
  }
  /** Get the tile's screen space error. */
  getScreenSpaceError(frameState, useParentLodMetric) {
    switch (this.tileset.type) {
      case TILESET_TYPE$1.I3S:
        return getProjectedRadius(this, frameState);
      case TILESET_TYPE$1.TILES3D:
        return getTiles3DScreenSpaceError(this, frameState, useParentLodMetric);
      default:
        throw new Error("Unsupported tileset type");
    }
  }
  /**
   * Make tile unselected than means it won't be shown
   * but it can be still loaded in memory
   */
  unselect() {
    this._selectedFrame = 0;
  }
  /**
   * Memory usage of tile on GPU
   */
  _getGpuMemoryUsageInBytes() {
    return this.content.gpuMemoryUsageInBytes || this.content.byteLength || 0;
  }
  /*
   * If skipLevelOfDetail is off try to load child tiles as soon as possible so that their parent can refine sooner.
   * Tiles are prioritized by screen space error.
   */
  // eslint-disable-next-line complexity
  _getPriority() {
    const traverser = this.tileset._traverser;
    const { skipLevelOfDetail } = traverser.options;
    const maySkipTile = this.refine === TILE_REFINEMENT$1.ADD || skipLevelOfDetail;
    if (maySkipTile && !this.isVisible && this._visible !== void 0) {
      return -1;
    }
    if (this.tileset._frameNumber - this._touchedFrame >= 1) {
      return -1;
    }
    if (this.contentState === TILE_CONTENT_STATE.UNLOADED) {
      return -1;
    }
    const parent = this.parent;
    const useParentScreenSpaceError = parent && (!maySkipTile || this._screenSpaceError === 0 || parent.hasTilesetContent);
    const screenSpaceError = useParentScreenSpaceError ? parent._screenSpaceError : this._screenSpaceError;
    const rootScreenSpaceError = traverser.root ? traverser.root._screenSpaceError : 0;
    return Math.max(rootScreenSpaceError - screenSpaceError, 0);
  }
  /**
   *  Requests the tile's content.
   * The request may not be made if the Request Scheduler can't prioritize it.
   */
  // eslint-disable-next-line max-statements, complexity
  async loadContent() {
    if (this.hasEmptyContent) {
      return false;
    }
    if (this.content) {
      return true;
    }
    const expired = this.contentExpired;
    if (expired) {
      this._expireDate = null;
    }
    this.contentState = TILE_CONTENT_STATE.LOADING;
    const requestToken = await this.tileset._requestScheduler.scheduleRequest(this.id, this._getPriority.bind(this));
    if (!requestToken) {
      this.contentState = TILE_CONTENT_STATE.UNLOADED;
      return false;
    }
    try {
      const contentUrl = this.tileset.getTileUrl(this.contentUrl);
      const loader2 = this.tileset.loader;
      const options2 = {
        ...this.tileset.loadOptions,
        [loader2.id]: {
          // @ts-expect-error
          ...this.tileset.loadOptions[loader2.id],
          isTileset: this.type === "json",
          ...this._getLoaderSpecificOptions(loader2.id)
        }
      };
      this.content = await load(contentUrl, loader2, options2);
      if (this.tileset.options.contentLoader) {
        await this.tileset.options.contentLoader(this);
      }
      if (this._isTileset()) {
        this.tileset._initializeTileHeaders(this.content, this);
      }
      this.contentState = TILE_CONTENT_STATE.READY;
      this._onContentLoaded();
      return true;
    } catch (error2) {
      this.contentState = TILE_CONTENT_STATE.FAILED;
      throw error2;
    } finally {
      requestToken.done();
    }
  }
  // Unloads the tile's content.
  unloadContent() {
    if (this.content && this.content.destroy) {
      this.content.destroy();
    }
    this.content = null;
    if (this.header.content && this.header.content.destroy) {
      this.header.content.destroy();
    }
    this.header.content = null;
    this.contentState = TILE_CONTENT_STATE.UNLOADED;
    return true;
  }
  /**
   * Update the tile's visibility
   * @param {Object} frameState - frame state for tile culling
   * @param {string[]} viewportIds - a list of viewport ids that show this tile
   * @return {void}
   */
  updateVisibility(frameState, viewportIds) {
    if (this._frameNumber === frameState.frameNumber) {
      return;
    }
    const parent = this.parent;
    const parentVisibilityPlaneMask = parent ? parent._visibilityPlaneMask : CullingVolume.MASK_INDETERMINATE;
    if (this.tileset._traverser.options.updateTransforms) {
      const parentTransform = parent ? parent.computedTransform : this.tileset.modelMatrix;
      this._updateTransform(parentTransform);
    }
    this._distanceToCamera = this.distanceToTile(frameState);
    this._screenSpaceError = this.getScreenSpaceError(frameState, false);
    this._visibilityPlaneMask = this.visibility(frameState, parentVisibilityPlaneMask);
    this._visible = this._visibilityPlaneMask !== CullingVolume.MASK_OUTSIDE;
    this._inRequestVolume = this.insideViewerRequestVolume(frameState);
    this._frameNumber = frameState.frameNumber;
    this.viewportIds = viewportIds;
  }
  // Determines whether the tile's bounding volume intersects the culling volume.
  // @param {FrameState} frameState The frame state.
  // @param {Number} parentVisibilityPlaneMask The parent's plane mask to speed up the visibility check.
  // @returns {Number} A plane mask as described above in {@link CullingVolume#computeVisibilityWithPlaneMask}.
  visibility(frameState, parentVisibilityPlaneMask) {
    const { cullingVolume: cullingVolume2 } = frameState;
    const { boundingVolume } = this;
    return cullingVolume2.computeVisibilityWithPlaneMask(boundingVolume, parentVisibilityPlaneMask);
  }
  // Assuming the tile's bounding volume intersects the culling volume, determines
  // whether the tile's content's bounding volume intersects the culling volume.
  // @param {FrameState} frameState The frame state.
  // @returns {Intersect} The result of the intersection: the tile's content is completely outside, completely inside, or intersecting the culling volume.
  contentVisibility() {
    return true;
  }
  /**
   * Computes the (potentially approximate) distance from the closest point of the tile's bounding volume to the camera.
   * @param frameState The frame state.
   * @returns {Number} The distance, in meters, or zero if the camera is inside the bounding volume.
   */
  distanceToTile(frameState) {
    const boundingVolume = this.boundingVolume;
    return Math.sqrt(Math.max(boundingVolume.distanceSquaredTo(frameState.camera.position), 0));
  }
  /**
   * Computes the tile's camera-space z-depth.
   * @param frameState The frame state.
   * @returns The distance, in meters.
   */
  cameraSpaceZDepth({ camera }) {
    const boundingVolume = this.boundingVolume;
    scratchVector$1.subVectors(boundingVolume.center, camera.position);
    return camera.direction.dot(scratchVector$1);
  }
  /**
   * Checks if the camera is inside the viewer request volume.
   * @param {FrameState} frameState The frame state.
   * @returns {Boolean} Whether the camera is inside the volume.
   */
  insideViewerRequestVolume(frameState) {
    const viewerRequestVolume = this._viewerRequestVolume;
    return !viewerRequestVolume || viewerRequestVolume.distanceSquaredTo(frameState.camera.position) <= 0;
  }
  // TODO Cesium specific
  // Update whether the tile has expired.
  updateExpiration() {
    if (defined$4(this._expireDate) && this.contentReady && !this.hasEmptyContent) {
      const now2 = Date.now();
      if (Date.lessThan(this._expireDate, now2)) {
        this.contentState = TILE_CONTENT_STATE.EXPIRED;
        this._expiredContent = this.content;
      }
    }
  }
  get extras() {
    return this.header.extras;
  }
  // INTERNAL METHODS
  _initializeLodMetric(header) {
    if ("lodMetricType" in header) {
      this.lodMetricType = header.lodMetricType;
    } else {
      this.lodMetricType = this.parent && this.parent.lodMetricType || this.tileset.lodMetricType;
      console.warn(`3D Tile: Required prop lodMetricType is undefined. Using parent lodMetricType`);
    }
    if ("lodMetricValue" in header) {
      this.lodMetricValue = header.lodMetricValue;
    } else {
      this.lodMetricValue = this.parent && this.parent.lodMetricValue || this.tileset.lodMetricValue;
      console.warn("3D Tile: Required prop lodMetricValue is undefined. Using parent lodMetricValue");
    }
  }
  _initializeTransforms(tileHeader) {
    this.transform = tileHeader.transform ? new Matrix4(tileHeader.transform) : new Matrix4();
    const parent = this.parent;
    const tileset = this.tileset;
    const parentTransform = parent && parent.computedTransform ? parent.computedTransform.clone() : tileset.modelMatrix.clone();
    this.computedTransform = new Matrix4(parentTransform).multiplyRight(this.transform);
    const parentInitialTransform = parent && parent._initialTransform ? parent._initialTransform.clone() : new Matrix4();
    this._initialTransform = new Matrix4(parentInitialTransform).multiplyRight(this.transform);
  }
  _initializeBoundingVolumes(tileHeader) {
    this._contentBoundingVolume = null;
    this._viewerRequestVolume = null;
    this._updateBoundingVolume(tileHeader);
  }
  _initializeContent(tileHeader) {
    this.content = { _tileset: this.tileset, _tile: this };
    this.hasEmptyContent = true;
    this.contentState = TILE_CONTENT_STATE.UNLOADED;
    this.hasTilesetContent = false;
    if (tileHeader.contentUrl) {
      this.content = null;
      this.hasEmptyContent = false;
    }
  }
  // TODO - remove anything not related to basic visibility detection
  _initializeRenderingState(header) {
    this.depth = header.level || (this.parent ? this.parent.depth + 1 : 0);
    this._shouldRefine = false;
    this._distanceToCamera = 0;
    this._centerZDepth = 0;
    this._screenSpaceError = 0;
    this._visibilityPlaneMask = CullingVolume.MASK_INDETERMINATE;
    this._visible = void 0;
    this._inRequestVolume = false;
    this._stackLength = 0;
    this._selectionDepth = 0;
    this._frameNumber = 0;
    this._touchedFrame = 0;
    this._visitedFrame = 0;
    this._selectedFrame = 0;
    this._requestedFrame = 0;
    this._priority = 0;
  }
  _getRefine(refine) {
    return refine || this.parent && this.parent.refine || TILE_REFINEMENT$1.REPLACE;
  }
  _isTileset() {
    return this.contentUrl.indexOf(".json") !== -1;
  }
  _onContentLoaded() {
    switch (this.content && this.content.type) {
      case "vctr":
      case "geom":
        this.tileset._traverser.disableSkipLevelOfDetail = true;
        break;
    }
    if (this._isTileset()) {
      this.hasTilesetContent = true;
    } else {
      this.gpuMemoryUsageInBytes = this._getGpuMemoryUsageInBytes();
    }
  }
  _updateBoundingVolume(header) {
    this.boundingVolume = createBoundingVolume(header.boundingVolume, this.computedTransform, this.boundingVolume);
    const content = header.content;
    if (!content) {
      return;
    }
    if (content.boundingVolume) {
      this._contentBoundingVolume = createBoundingVolume(content.boundingVolume, this.computedTransform, this._contentBoundingVolume);
    }
    if (header.viewerRequestVolume) {
      this._viewerRequestVolume = createBoundingVolume(header.viewerRequestVolume, this.computedTransform, this._viewerRequestVolume);
    }
  }
  // Update the tile's transform. The transform is applied to the tile's bounding volumes.
  _updateTransform(parentTransform = new Matrix4()) {
    const computedTransform = parentTransform.clone().multiplyRight(this.transform);
    const didTransformChange = !computedTransform.equals(this.computedTransform);
    if (!didTransformChange) {
      return;
    }
    this.computedTransform = computedTransform;
    this._updateBoundingVolume(this.header);
  }
  // Get options which are applicable only for the particular loader
  _getLoaderSpecificOptions(loaderId) {
    switch (loaderId) {
      case "i3s":
        return {
          ...this.tileset.options.i3s,
          _tileOptions: {
            attributeUrls: this.header.attributeUrls,
            textureUrl: this.header.textureUrl,
            textureFormat: this.header.textureFormat,
            textureLoaderOptions: this.header.textureLoaderOptions,
            materialDefinition: this.header.materialDefinition,
            isDracoGeometry: this.header.isDracoGeometry,
            mbs: this.header.mbs
          },
          _tilesetOptions: {
            store: this.tileset.tileset.store,
            attributeStorageInfo: this.tileset.tileset.attributeStorageInfo,
            fields: this.tileset.tileset.fields
          },
          isTileHeader: false
        };
      case "3d-tiles":
      case "cesium-ion":
      default:
        return get3dTilesOptions(this.tileset.tileset);
    }
  }
}
class Tileset3DTraverser extends TilesetTraverser {
  compareDistanceToCamera(a2, b2) {
    return b2._distanceToCamera === 0 && a2._distanceToCamera === 0 ? b2._centerZDepth - a2._centerZDepth : b2._distanceToCamera - a2._distanceToCamera;
  }
  updateTileVisibility(tile, frameState) {
    super.updateTileVisibility(tile, frameState);
    if (!tile.isVisibleAndInRequestVolume) {
      return;
    }
    const hasChildren = tile.children.length > 0;
    if (tile.hasTilesetContent && hasChildren) {
      const firstChild = tile.children[0];
      this.updateTileVisibility(firstChild, frameState);
      tile._visible = firstChild._visible;
      return;
    }
    if (this.meetsScreenSpaceErrorEarly(tile, frameState)) {
      tile._visible = false;
      return;
    }
    const replace2 = tile.refine === TILE_REFINEMENT$1.REPLACE;
    const useOptimization = tile._optimChildrenWithinParent === TILE3D_OPTIMIZATION_HINT.USE_OPTIMIZATION;
    if (replace2 && useOptimization && hasChildren) {
      if (!this.anyChildrenVisible(tile, frameState)) {
        tile._visible = false;
        return;
      }
    }
  }
  meetsScreenSpaceErrorEarly(tile, frameState) {
    const { parent } = tile;
    if (!parent || parent.hasTilesetContent || parent.refine !== TILE_REFINEMENT$1.ADD) {
      return false;
    }
    return !this.shouldRefine(tile, frameState, true);
  }
}
class I3SPendingTilesRegister {
  constructor() {
    __publicField2(this, "frameNumberMap", /* @__PURE__ */ new Map());
  }
  /**
   * Register a new pending tile header for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   */
  register(viewportId, frameNumber) {
    const viewportMap = this.frameNumberMap.get(viewportId) || /* @__PURE__ */ new Map();
    const oldCount = viewportMap.get(frameNumber) || 0;
    viewportMap.set(frameNumber, oldCount + 1);
    this.frameNumberMap.set(viewportId, viewportMap);
  }
  /**
   * Deregister a pending tile header for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   */
  deregister(viewportId, frameNumber) {
    const viewportMap = this.frameNumberMap.get(viewportId);
    if (!viewportMap) {
      return;
    }
    const oldCount = viewportMap.get(frameNumber) || 1;
    viewportMap.set(frameNumber, oldCount - 1);
  }
  /**
   * Check is there are no pending tile headers registered for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   * @returns
   */
  isZero(viewportId, frameNumber) {
    var _a3;
    const count3 = ((_a3 = this.frameNumberMap.get(viewportId)) == null ? void 0 : _a3.get(frameNumber)) || 0;
    return count3 === 0;
  }
}
const STATUS = {
  REQUESTED: "REQUESTED",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR"
};
class I3STileManager {
  constructor() {
    __publicField2(this, "_statusMap");
    __publicField2(this, "pendingTilesRegister", new I3SPendingTilesRegister());
    this._statusMap = {};
  }
  /**
   * Add request to map
   * @param request - node metadata request
   * @param key - unique key
   * @param callback - callback after request completed
   * @param frameState - frameState data
   */
  add(request, key, callback, frameState) {
    if (!this._statusMap[key]) {
      const { frameNumber, viewport: { id } } = frameState;
      this._statusMap[key] = { request, callback, key, frameState, status: STATUS.REQUESTED };
      this.pendingTilesRegister.register(id, frameNumber);
      request().then((data2) => {
        this._statusMap[key].status = STATUS.COMPLETED;
        const { frameNumber: actualFrameNumber, viewport: { id: id2 } } = this._statusMap[key].frameState;
        this.pendingTilesRegister.deregister(id2, actualFrameNumber);
        this._statusMap[key].callback(data2, frameState);
      }).catch((error2) => {
        this._statusMap[key].status = STATUS.ERROR;
        const { frameNumber: actualFrameNumber, viewport: { id: id2 } } = this._statusMap[key].frameState;
        this.pendingTilesRegister.deregister(id2, actualFrameNumber);
        callback(error2);
      });
    }
  }
  /**
   * Update request if it is still actual for the new frameState
   * @param key - unique key
   * @param frameState - frameState data
   */
  update(key, frameState) {
    if (this._statusMap[key]) {
      const { frameNumber, viewport: { id } } = this._statusMap[key].frameState;
      this.pendingTilesRegister.deregister(id, frameNumber);
      const { frameNumber: newFrameNumber, viewport: { id: newViewportId } } = frameState;
      this.pendingTilesRegister.register(newViewportId, newFrameNumber);
      this._statusMap[key].frameState = frameState;
    }
  }
  /**
   * Find request in the map
   * @param key - unique key
   * @returns
   */
  find(key) {
    return this._statusMap[key];
  }
  /**
   * Check it there are pending tile headers for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   * @returns
   */
  hasPendingTiles(viewportId, frameNumber) {
    return !this.pendingTilesRegister.isZero(viewportId, frameNumber);
  }
}
class I3STilesetTraverser extends TilesetTraverser {
  constructor(options2) {
    super(options2);
    __publicField2(this, "_tileManager");
    this._tileManager = new I3STileManager();
  }
  /**
   * Check if there are no penging tile header requests,
   * that means the traversal is finished and we can call
   * following-up callbacks.
   */
  traversalFinished(frameState) {
    return !this._tileManager.hasPendingTiles(frameState.viewport.id, this._frameNumber || 0);
  }
  shouldRefine(tile, frameState) {
    tile._lodJudge = getLodStatus(tile, frameState);
    return tile._lodJudge === "DIG";
  }
  updateChildTiles(tile, frameState) {
    const children = tile.header.children || [];
    const childTiles = tile.children;
    const tileset = tile.tileset;
    for (const child of children) {
      const extendedId = `${child.id}-${frameState.viewport.id}`;
      const childTile = childTiles && childTiles.find((t2) => t2.id === extendedId);
      if (!childTile) {
        let request = () => this._loadTile(child.id, tileset);
        const cachedRequest = this._tileManager.find(extendedId);
        if (!cachedRequest) {
          if (tileset.tileset.nodePages) {
            request = () => tileset.tileset.nodePagesTile.formTileFromNodePages(child.id);
          }
          this._tileManager.add(request, extendedId, (header) => this._onTileLoad(header, tile, extendedId), frameState);
        } else {
          this._tileManager.update(extendedId, frameState);
        }
      } else if (childTile) {
        this.updateTile(childTile, frameState);
      }
    }
    return false;
  }
  async _loadTile(nodeId, tileset) {
    const { loader: loader2 } = tileset;
    const nodeUrl = tileset.getTileUrl(`${tileset.url}/nodes/${nodeId}`);
    const options2 = {
      ...tileset.loadOptions,
      i3s: {
        ...tileset.loadOptions.i3s,
        isTileHeader: true
      }
    };
    return await load(nodeUrl, loader2, options2);
  }
  /**
   * The callback to init Tile3D instance after loading the tile JSON
   * @param {Object} header - the tile JSON from a dataset
   * @param {Tile3D} tile - the parent Tile3D instance
   * @param {string} extendedId - optional ID to separate copies of a tile for different viewports.
   *                              const extendedId = `${tile.id}-${frameState.viewport.id}`;
   * @return {void}
   */
  _onTileLoad(header, tile, extendedId) {
    const childTile = new Tile3D(tile.tileset, header, tile, extendedId);
    tile.children.push(childTile);
    const frameState = this._tileManager.find(childTile.id).frameState;
    this.updateTile(childTile, frameState);
    if (this._frameNumber === frameState.frameNumber && (this.traversalFinished(frameState) || (/* @__PURE__ */ new Date()).getTime() - this.lastUpdate > this.updateDebounceTime)) {
      this.executeTraversal(childTile, frameState);
    }
  }
}
const DEFAULT_PROPS = {
  description: "",
  ellipsoid: Ellipsoid.WGS84,
  modelMatrix: new Matrix4(),
  throttleRequests: true,
  maxRequests: 64,
  /** Default memory values optimized for viewing mesh-based 3D Tiles on both mobile and desktop devices */
  maximumMemoryUsage: 32,
  memoryCacheOverflow: 1,
  maximumTilesSelected: 0,
  debounceTime: 0,
  onTileLoad: () => {
  },
  onTileUnload: () => {
  },
  onTileError: () => {
  },
  onTraversalComplete: (selectedTiles) => selectedTiles,
  contentLoader: void 0,
  viewDistanceScale: 1,
  maximumScreenSpaceError: 8,
  memoryAdjustedScreenSpaceError: false,
  loadTiles: true,
  updateTransforms: true,
  viewportTraversersMap: null,
  loadOptions: { fetch: {} },
  attributions: [],
  basePath: "",
  i3s: {}
};
const TILES_TOTAL = "Tiles In Tileset(s)";
const TILES_IN_MEMORY = "Tiles In Memory";
const TILES_IN_VIEW = "Tiles In View";
const TILES_RENDERABLE = "Tiles To Render";
const TILES_LOADED = "Tiles Loaded";
const TILES_LOADING = "Tiles Loading";
const TILES_UNLOADED = "Tiles Unloaded";
const TILES_LOAD_FAILED = "Failed Tile Loads";
const POINTS_COUNT = "Points/Vertices";
const TILES_GPU_MEMORY = "Tile Memory Use";
const MAXIMUM_SSE = "Maximum Screen Space Error";
class Tileset3D {
  /**
   * Create a new Tileset3D
   * @param json
   * @param props
   */
  // eslint-disable-next-line max-statements
  constructor(tileset, options2) {
    // props: Tileset3DProps;
    __publicField2(this, "options");
    __publicField2(this, "loadOptions");
    __publicField2(this, "type");
    __publicField2(this, "tileset");
    __publicField2(this, "loader");
    __publicField2(this, "url");
    __publicField2(this, "basePath");
    __publicField2(this, "modelMatrix");
    __publicField2(this, "ellipsoid");
    __publicField2(this, "lodMetricType");
    __publicField2(this, "lodMetricValue");
    __publicField2(this, "refine");
    __publicField2(this, "root", null);
    __publicField2(this, "roots", {});
    /** @todo any->unknown */
    __publicField2(this, "asset", {});
    // Metadata for the entire tileset
    __publicField2(this, "description", "");
    __publicField2(this, "properties");
    __publicField2(this, "extras", null);
    __publicField2(this, "attributions", {});
    __publicField2(this, "credits", {});
    __publicField2(this, "stats");
    /** flags that contain information about data types in nested tiles */
    __publicField2(this, "contentFormats", { draco: false, meshopt: false, dds: false, ktx2: false });
    // view props
    __publicField2(this, "cartographicCenter", null);
    __publicField2(this, "cartesianCenter", null);
    __publicField2(this, "zoom", 1);
    __publicField2(this, "boundingVolume", null);
    /** Updated based on the camera position and direction */
    __publicField2(this, "dynamicScreenSpaceErrorComputedDensity", 0);
    // METRICS
    /**
     * The maximum amount of GPU memory (in MB) that may be used to cache tiles
     * Tiles not in view are unloaded to enforce private
     */
    __publicField2(this, "maximumMemoryUsage", 32);
    /** The total amount of GPU memory in bytes used by the tileset. */
    __publicField2(this, "gpuMemoryUsageInBytes", 0);
    /**
     * If loading the level of detail required by maximumScreenSpaceError
     * results in the memory usage exceeding maximumMemoryUsage (GPU), level of detail refinement
     * will instead use this (larger) adjusted screen space error to achieve the
     * best possible visual quality within the available memory.
     */
    __publicField2(this, "memoryAdjustedScreenSpaceError", 0);
    __publicField2(this, "_cacheBytes", 0);
    __publicField2(this, "_cacheOverflowBytes", 0);
    /** Update tracker. increase in each update cycle. */
    __publicField2(this, "_frameNumber", 0);
    __publicField2(this, "_queryParams", {});
    __publicField2(this, "_extensionsUsed", []);
    __publicField2(this, "_tiles", {});
    /** counter for tracking tiles requests */
    __publicField2(this, "_pendingCount", 0);
    /** Hold traversal results */
    __publicField2(this, "selectedTiles", []);
    // TRAVERSAL
    __publicField2(this, "traverseCounter", 0);
    __publicField2(this, "geometricError", 0);
    __publicField2(this, "lastUpdatedVieports", null);
    __publicField2(this, "_requestedTiles", []);
    __publicField2(this, "_emptyTiles", []);
    __publicField2(this, "frameStateData", {});
    __publicField2(this, "_traverser");
    __publicField2(this, "_cache", new TilesetCache());
    __publicField2(this, "_requestScheduler");
    // Promise tracking
    __publicField2(this, "updatePromise", null);
    __publicField2(this, "tilesetInitializationPromise");
    this.options = { ...DEFAULT_PROPS, ...options2 };
    this.tileset = tileset;
    this.loader = tileset.loader;
    this.type = tileset.type;
    this.url = tileset.url;
    this.basePath = tileset.basePath || dirname$1(this.url);
    this.modelMatrix = this.options.modelMatrix;
    this.ellipsoid = this.options.ellipsoid;
    this.lodMetricType = tileset.lodMetricType;
    this.lodMetricValue = tileset.lodMetricValue;
    this.refine = tileset.root.refine;
    this.loadOptions = this.options.loadOptions || {};
    this._traverser = this._initializeTraverser();
    this._requestScheduler = new RequestScheduler({
      throttleRequests: this.options.throttleRequests,
      maxRequests: this.options.maxRequests
    });
    this.memoryAdjustedScreenSpaceError = this.options.maximumScreenSpaceError;
    this._cacheBytes = this.options.maximumMemoryUsage * 1024 * 1024;
    this._cacheOverflowBytes = this.options.memoryCacheOverflow * 1024 * 1024;
    this.stats = new Stats({ id: this.url });
    this._initializeStats();
    this.tilesetInitializationPromise = this._initializeTileSet(tileset);
  }
  /** Release resources */
  destroy() {
    this._destroy();
  }
  /** Is the tileset loaded (update needs to have been called at least once) */
  isLoaded() {
    return this._pendingCount === 0 && this._frameNumber !== 0 && this._requestedTiles.length === 0;
  }
  get tiles() {
    return Object.values(this._tiles);
  }
  get frameNumber() {
    return this._frameNumber;
  }
  get queryParams() {
    return new URLSearchParams(this._queryParams).toString();
  }
  setProps(props) {
    this.options = { ...this.options, ...props };
  }
  /** @deprecated */
  // setOptions(options: Tileset3DProps): void {
  //   this.options = {...this.options, ...options};
  // }
  /**
   * Return a loadable tile url for a specific tile subpath
   * @param tilePath a tile subpath
   */
  getTileUrl(tilePath) {
    const isDataUrl = tilePath.startsWith("data:");
    if (isDataUrl) {
      return tilePath;
    }
    let tileUrl = tilePath;
    if (this.queryParams.length) {
      tileUrl = `${tilePath}${tilePath.includes("?") ? "&" : "?"}${this.queryParams}`;
    }
    return tileUrl;
  }
  // TODO CESIUM specific
  hasExtension(extensionName) {
    return Boolean(this._extensionsUsed.indexOf(extensionName) > -1);
  }
  /**
   * Update visible tiles relying on a list of viewports
   * @param viewports - list of viewports
   * @deprecated
   */
  update(viewports = null) {
    this.tilesetInitializationPromise.then(() => {
      if (!viewports && this.lastUpdatedVieports) {
        viewports = this.lastUpdatedVieports;
      } else {
        this.lastUpdatedVieports = viewports;
      }
      if (viewports) {
        this.doUpdate(viewports);
      }
    });
  }
  /**
   * Update visible tiles relying on a list of viewports.
   * Do it with debounce delay to prevent update spam
   * @param viewports viewports
   * @returns Promise of new frameNumber
   */
  async selectTiles(viewports = null) {
    await this.tilesetInitializationPromise;
    if (viewports) {
      this.lastUpdatedVieports = viewports;
    }
    if (!this.updatePromise) {
      this.updatePromise = new Promise((resolve2) => {
        setTimeout(() => {
          if (this.lastUpdatedVieports) {
            this.doUpdate(this.lastUpdatedVieports);
          }
          resolve2(this._frameNumber);
          this.updatePromise = null;
        }, this.options.debounceTime);
      });
    }
    return this.updatePromise;
  }
  adjustScreenSpaceError() {
    if (this.gpuMemoryUsageInBytes < this._cacheBytes) {
      this.memoryAdjustedScreenSpaceError = Math.max(this.memoryAdjustedScreenSpaceError / 1.02, this.options.maximumScreenSpaceError);
    } else if (this.gpuMemoryUsageInBytes > this._cacheBytes + this._cacheOverflowBytes) {
      this.memoryAdjustedScreenSpaceError *= 1.02;
    }
  }
  /**
   * Update visible tiles relying on a list of viewports
   * @param viewports viewports
   */
  // eslint-disable-next-line max-statements, complexity
  doUpdate(viewports) {
    if ("loadTiles" in this.options && !this.options.loadTiles) {
      return;
    }
    if (this.traverseCounter > 0) {
      return;
    }
    const preparedViewports = viewports instanceof Array ? viewports : [viewports];
    this._cache.reset();
    this._frameNumber++;
    this.traverseCounter = preparedViewports.length;
    const viewportsToTraverse = [];
    for (const viewport of preparedViewports) {
      const id = viewport.id;
      if (this._needTraverse(id)) {
        viewportsToTraverse.push(id);
      } else {
        this.traverseCounter--;
      }
    }
    for (const viewport of preparedViewports) {
      const id = viewport.id;
      if (!this.roots[id]) {
        this.roots[id] = this._initializeTileHeaders(this.tileset, null);
      }
      if (!viewportsToTraverse.includes(id)) {
        continue;
      }
      const frameState = getFrameState(viewport, this._frameNumber);
      this._traverser.traverse(this.roots[id], frameState, this.options);
    }
  }
  /**
   * Check if traversal is needed for particular viewport
   * @param {string} viewportId - id of a viewport
   * @return {boolean}
   */
  _needTraverse(viewportId) {
    let traverserId = viewportId;
    if (this.options.viewportTraversersMap) {
      traverserId = this.options.viewportTraversersMap[viewportId];
    }
    if (traverserId !== viewportId) {
      return false;
    }
    return true;
  }
  /**
   * The callback to post-process tiles after traversal procedure
   * @param frameState - frame state for tile culling
   */
  _onTraversalEnd(frameState) {
    const id = frameState.viewport.id;
    if (!this.frameStateData[id]) {
      this.frameStateData[id] = { selectedTiles: [], _requestedTiles: [], _emptyTiles: [] };
    }
    const currentFrameStateData = this.frameStateData[id];
    const selectedTiles = Object.values(this._traverser.selectedTiles);
    const [filteredSelectedTiles, unselectedTiles] = limitSelectedTiles(selectedTiles, frameState, this.options.maximumTilesSelected);
    currentFrameStateData.selectedTiles = filteredSelectedTiles;
    for (const tile of unselectedTiles) {
      tile.unselect();
    }
    currentFrameStateData._requestedTiles = Object.values(this._traverser.requestedTiles);
    currentFrameStateData._emptyTiles = Object.values(this._traverser.emptyTiles);
    this.traverseCounter--;
    if (this.traverseCounter > 0) {
      return;
    }
    this._updateTiles();
  }
  /**
   * Update tiles relying on data from all traversers
   */
  _updateTiles() {
    this.selectedTiles = [];
    this._requestedTiles = [];
    this._emptyTiles = [];
    for (const frameStateKey in this.frameStateData) {
      const frameStateDataValue = this.frameStateData[frameStateKey];
      this.selectedTiles = this.selectedTiles.concat(frameStateDataValue.selectedTiles);
      this._requestedTiles = this._requestedTiles.concat(frameStateDataValue._requestedTiles);
      this._emptyTiles = this._emptyTiles.concat(frameStateDataValue._emptyTiles);
    }
    this.selectedTiles = this.options.onTraversalComplete(this.selectedTiles);
    for (const tile of this.selectedTiles) {
      this._tiles[tile.id] = tile;
    }
    this._loadTiles();
    this._unloadTiles();
    this._updateStats();
  }
  _tilesChanged(oldSelectedTiles, selectedTiles) {
    if (oldSelectedTiles.length !== selectedTiles.length) {
      return true;
    }
    const set1 = new Set(oldSelectedTiles.map((t2) => t2.id));
    const set2 = new Set(selectedTiles.map((t2) => t2.id));
    let changed = oldSelectedTiles.filter((x2) => !set2.has(x2.id)).length > 0;
    changed = changed || selectedTiles.filter((x2) => !set1.has(x2.id)).length > 0;
    return changed;
  }
  _loadTiles() {
    for (const tile of this._requestedTiles) {
      if (tile.contentUnloaded) {
        this._loadTile(tile);
      }
    }
  }
  _unloadTiles() {
    this._cache.unloadTiles(this, (tileset, tile) => tileset._unloadTile(tile));
  }
  _updateStats() {
    let tilesRenderable = 0;
    let pointsRenderable = 0;
    for (const tile of this.selectedTiles) {
      if (tile.contentAvailable && tile.content) {
        tilesRenderable++;
        if (tile.content.pointCount) {
          pointsRenderable += tile.content.pointCount;
        } else {
          pointsRenderable += tile.content.vertexCount;
        }
      }
    }
    this.stats.get(TILES_IN_VIEW).count = this.selectedTiles.length;
    this.stats.get(TILES_RENDERABLE).count = tilesRenderable;
    this.stats.get(POINTS_COUNT).count = pointsRenderable;
    this.stats.get(MAXIMUM_SSE).count = this.memoryAdjustedScreenSpaceError;
  }
  async _initializeTileSet(tilesetJson) {
    if (this.type === TILESET_TYPE$1.I3S) {
      this.calculateViewPropsI3S();
      tilesetJson.root = await tilesetJson.root;
    }
    this.root = this._initializeTileHeaders(tilesetJson, null);
    if (this.type === TILESET_TYPE$1.TILES3D) {
      this._initializeTiles3DTileset(tilesetJson);
      this.calculateViewPropsTiles3D();
    }
    if (this.type === TILESET_TYPE$1.I3S) {
      this._initializeI3STileset();
    }
  }
  /**
   * Called during initialize Tileset to initialize the tileset's cartographic center (longitude, latitude) and zoom.
   * These metrics help apps center view on tileset
   * For I3S there is extent (<1.8 version) or fullExtent (>=1.8 version) to calculate view props
   * @returns
   */
  calculateViewPropsI3S() {
    var _a3;
    const fullExtent = this.tileset.fullExtent;
    if (fullExtent) {
      const { xmin, xmax, ymin, ymax, zmin, zmax } = fullExtent;
      this.cartographicCenter = new Vector3(xmin + (xmax - xmin) / 2, ymin + (ymax - ymin) / 2, zmin + (zmax - zmin) / 2);
      this.cartesianCenter = new Vector3();
      Ellipsoid.WGS84.cartographicToCartesian(this.cartographicCenter, this.cartesianCenter);
      this.zoom = getZoomFromFullExtent(fullExtent, this.cartographicCenter, this.cartesianCenter);
      return;
    }
    const extent2 = (_a3 = this.tileset.store) == null ? void 0 : _a3.extent;
    if (extent2) {
      const [xmin, ymin, xmax, ymax] = extent2;
      this.cartographicCenter = new Vector3(xmin + (xmax - xmin) / 2, ymin + (ymax - ymin) / 2, 0);
      this.cartesianCenter = new Vector3();
      Ellipsoid.WGS84.cartographicToCartesian(this.cartographicCenter, this.cartesianCenter);
      this.zoom = getZoomFromExtent(extent2, this.cartographicCenter, this.cartesianCenter);
      return;
    }
    console.warn("Extent is not defined in the tileset header");
    this.cartographicCenter = new Vector3();
    this.zoom = 1;
    return;
  }
  /**
   * Called during initialize Tileset to initialize the tileset's cartographic center (longitude, latitude) and zoom.
   * These metrics help apps center view on tileset.
   * For 3DTiles the root tile data is used to calculate view props.
   * @returns
   */
  calculateViewPropsTiles3D() {
    const root2 = this.root;
    const { center: center2 } = root2.boundingVolume;
    if (!center2) {
      console.warn("center was not pre-calculated for the root tile");
      this.cartographicCenter = new Vector3();
      this.zoom = 1;
      return;
    }
    if (center2[0] !== 0 || center2[1] !== 0 || center2[2] !== 0) {
      this.cartographicCenter = new Vector3();
      Ellipsoid.WGS84.cartesianToCartographic(center2, this.cartographicCenter);
    } else {
      this.cartographicCenter = new Vector3(0, 0, -Ellipsoid.WGS84.radii[0]);
    }
    this.cartesianCenter = center2;
    this.zoom = getZoomFromBoundingVolume(root2.boundingVolume, this.cartographicCenter);
  }
  _initializeStats() {
    this.stats.get(TILES_TOTAL);
    this.stats.get(TILES_LOADING);
    this.stats.get(TILES_IN_MEMORY);
    this.stats.get(TILES_IN_VIEW);
    this.stats.get(TILES_RENDERABLE);
    this.stats.get(TILES_LOADED);
    this.stats.get(TILES_UNLOADED);
    this.stats.get(TILES_LOAD_FAILED);
    this.stats.get(POINTS_COUNT);
    this.stats.get(TILES_GPU_MEMORY, "memory");
    this.stats.get(MAXIMUM_SSE);
  }
  // Installs the main tileset JSON file or a tileset JSON file referenced from a tile.
  // eslint-disable-next-line max-statements
  _initializeTileHeaders(tilesetJson, parentTileHeader) {
    var _a3;
    const rootTile = new Tile3D(this, tilesetJson.root, parentTileHeader);
    if (parentTileHeader) {
      parentTileHeader.children.push(rootTile);
      rootTile.depth = parentTileHeader.depth + 1;
    }
    if (this.type === TILESET_TYPE$1.TILES3D) {
      const stack2 = [];
      stack2.push(rootTile);
      while (stack2.length > 0) {
        const tile = stack2.pop();
        this.stats.get(TILES_TOTAL).incrementCount();
        const children = tile.header.children || [];
        for (const childHeader of children) {
          const childTile = new Tile3D(this, childHeader, tile);
          if ((_a3 = childTile.contentUrl) == null ? void 0 : _a3.includes("?session=")) {
            const url2 = new URL(childTile.contentUrl);
            const session = url2.searchParams.get("session");
            if (session) {
              this._queryParams.session = session;
            }
          }
          tile.children.push(childTile);
          childTile.depth = tile.depth + 1;
          stack2.push(childTile);
        }
      }
    }
    return rootTile;
  }
  _initializeTraverser() {
    let TraverserClass;
    const type = this.type;
    switch (type) {
      case TILESET_TYPE$1.TILES3D:
        TraverserClass = Tileset3DTraverser;
        break;
      case TILESET_TYPE$1.I3S:
        TraverserClass = I3STilesetTraverser;
        break;
      default:
        TraverserClass = TilesetTraverser;
    }
    return new TraverserClass({
      basePath: this.basePath,
      onTraversalEnd: this._onTraversalEnd.bind(this)
    });
  }
  _destroyTileHeaders(parentTile) {
    this._destroySubtree(parentTile);
  }
  async _loadTile(tile) {
    let loaded;
    try {
      this._onStartTileLoading();
      loaded = await tile.loadContent();
    } catch (error2) {
      this._onTileLoadError(tile, error2 instanceof Error ? error2 : new Error("load failed"));
    } finally {
      this._onEndTileLoading();
      this._onTileLoad(tile, loaded);
    }
  }
  _onTileLoadError(tile, error2) {
    this.stats.get(TILES_LOAD_FAILED).incrementCount();
    const message2 = error2.message || error2.toString();
    const url2 = tile.url;
    console.error(`A 3D tile failed to load: ${tile.url} ${message2}`);
    this.options.onTileError(tile, message2, url2);
  }
  _onTileLoad(tile, loaded) {
    var _a3, _b3;
    if (!loaded) {
      return;
    }
    if (this.type === TILESET_TYPE$1.I3S) {
      const nodesInNodePages = ((_b3 = (_a3 = this.tileset) == null ? void 0 : _a3.nodePagesTile) == null ? void 0 : _b3.nodesInNodePages) || 0;
      this.stats.get(TILES_TOTAL).reset();
      this.stats.get(TILES_TOTAL).addCount(nodesInNodePages);
    }
    if (tile && tile.content) {
      calculateTransformProps(tile, tile.content);
    }
    this.updateContentTypes(tile);
    this._addTileToCache(tile);
    this.options.onTileLoad(tile);
  }
  /**
   * Update information about data types in nested tiles
   * @param tile instance of a nested Tile3D
   */
  updateContentTypes(tile) {
    var _a3;
    if (this.type === TILESET_TYPE$1.I3S) {
      if (tile.header.isDracoGeometry) {
        this.contentFormats.draco = true;
      }
      switch (tile.header.textureFormat) {
        case "dds":
          this.contentFormats.dds = true;
          break;
        case "ktx2":
          this.contentFormats.ktx2 = true;
          break;
      }
    } else if (this.type === TILESET_TYPE$1.TILES3D) {
      const { extensionsRemoved = [] } = ((_a3 = tile.content) == null ? void 0 : _a3.gltf) || {};
      if (extensionsRemoved.includes("KHR_draco_mesh_compression")) {
        this.contentFormats.draco = true;
      }
      if (extensionsRemoved.includes("EXT_meshopt_compression")) {
        this.contentFormats.meshopt = true;
      }
      if (extensionsRemoved.includes("KHR_texture_basisu")) {
        this.contentFormats.ktx2 = true;
      }
    }
  }
  _onStartTileLoading() {
    this._pendingCount++;
    this.stats.get(TILES_LOADING).incrementCount();
  }
  _onEndTileLoading() {
    this._pendingCount--;
    this.stats.get(TILES_LOADING).decrementCount();
  }
  _addTileToCache(tile) {
    this._cache.add(this, tile, (tileset) => tileset._updateCacheStats(tile));
  }
  _updateCacheStats(tile) {
    this.stats.get(TILES_LOADED).incrementCount();
    this.stats.get(TILES_IN_MEMORY).incrementCount();
    this.gpuMemoryUsageInBytes += tile.gpuMemoryUsageInBytes || 0;
    this.stats.get(TILES_GPU_MEMORY).count = this.gpuMemoryUsageInBytes;
    if (this.options.memoryAdjustedScreenSpaceError) {
      this.adjustScreenSpaceError();
    }
  }
  _unloadTile(tile) {
    this.gpuMemoryUsageInBytes -= tile.gpuMemoryUsageInBytes || 0;
    this.stats.get(TILES_IN_MEMORY).decrementCount();
    this.stats.get(TILES_UNLOADED).incrementCount();
    this.stats.get(TILES_GPU_MEMORY).count = this.gpuMemoryUsageInBytes;
    this.options.onTileUnload(tile);
    tile.unloadContent();
  }
  // Traverse the tree and destroy all tiles
  _destroy() {
    const stack2 = [];
    if (this.root) {
      stack2.push(this.root);
    }
    while (stack2.length > 0) {
      const tile = stack2.pop();
      for (const child of tile.children) {
        stack2.push(child);
      }
      this._destroyTile(tile);
    }
    this.root = null;
  }
  // Traverse the tree and destroy all sub tiles
  _destroySubtree(tile) {
    const root2 = tile;
    const stack2 = [];
    stack2.push(root2);
    while (stack2.length > 0) {
      tile = stack2.pop();
      for (const child of tile.children) {
        stack2.push(child);
      }
      if (tile !== root2) {
        this._destroyTile(tile);
      }
    }
    root2.children = [];
  }
  _destroyTile(tile) {
    this._cache.unloadTile(this, tile);
    this._unloadTile(tile);
    tile.destroy();
  }
  _initializeTiles3DTileset(tilesetJson) {
    if (tilesetJson.queryString) {
      const searchParams = new URLSearchParams(tilesetJson.queryString);
      const queryParams = Object.fromEntries(searchParams.entries());
      this._queryParams = { ...this._queryParams, ...queryParams };
    }
    this.asset = tilesetJson.asset;
    if (!this.asset) {
      throw new Error("Tileset must have an asset property.");
    }
    if (this.asset.version !== "0.0" && this.asset.version !== "1.0" && this.asset.version !== "1.1") {
      throw new Error("The tileset must be 3D Tiles version either 0.0 or 1.0 or 1.1.");
    }
    if ("tilesetVersion" in this.asset) {
      this._queryParams.v = this.asset.tilesetVersion;
    }
    this.credits = {
      attributions: this.options.attributions || []
    };
    this.description = this.options.description || "";
    this.properties = tilesetJson.properties;
    this.geometricError = tilesetJson.geometricError;
    this._extensionsUsed = tilesetJson.extensionsUsed || [];
    this.extras = tilesetJson.extras;
  }
  _initializeI3STileset() {
    if (this.loadOptions.i3s && "token" in this.loadOptions.i3s) {
      this._queryParams.token = this.loadOptions.i3s.token;
    }
  }
}
const VERSION$7 = "4.2.0";
const TILE3D_TYPE$1 = {
  COMPOSITE: "cmpt",
  POINT_CLOUD: "pnts",
  BATCHED_3D_MODEL: "b3dm",
  INSTANCED_3D_MODEL: "i3dm",
  GEOMETRY: "geom",
  VECTOR: "vect",
  GLTF: "glTF"
};
function getStringFromArrayBuffer$1(arrayBuffer2, byteOffset, byteLength) {
  assert$e(arrayBuffer2 instanceof ArrayBuffer);
  const textDecoder = new TextDecoder("utf8");
  const typedArray = new Uint8Array(arrayBuffer2, byteOffset, byteLength);
  const string3 = textDecoder.decode(typedArray);
  return string3;
}
function getMagicString$3(arrayBuffer2, byteOffset = 0) {
  const dataView = new DataView(arrayBuffer2);
  return `${String.fromCharCode(dataView.getUint8(byteOffset + 0))}${String.fromCharCode(dataView.getUint8(byteOffset + 1))}${String.fromCharCode(dataView.getUint8(byteOffset + 2))}${String.fromCharCode(dataView.getUint8(byteOffset + 3))}`;
}
const GL_PRIMITIVE_MODE$1 = {
  POINTS: 0,
  // Points. single points.
  LINES: 1,
  // Lines. Each vertex connects to the one after it.
  LINE_LOOP: 2,
  // Lines. Each set of two vertices is treated as a separate line segment.
  LINE_STRIP: 3,
  // Lines/ a connected group of line segments from the first vertex to the last
  TRIANGLES: 4,
  // Triangles. Each set of three vertices creates a separate triangle.
  TRIANGLE_STRIP: 5,
  // Triangles. A connected group of triangles.
  TRIANGLE_FAN: 6
  // Triangles. A connected group of triangles.
  // Each vertex connects to the previous and the first vertex in the fan.
};
const GL_TYPE$1 = {
  BYTE: 5120,
  UNSIGNED_BYTE: 5121,
  SHORT: 5122,
  UNSIGNED_SHORT: 5123,
  INT: 5124,
  UNSIGNED_INT: 5125,
  FLOAT: 5126,
  DOUBLE: 5130
};
const GL$2 = {
  ...GL_PRIMITIVE_MODE$1,
  ...GL_TYPE$1
};
const GL_TYPE_TO_ARRAY_TYPE$1 = {
  [GL_TYPE$1.DOUBLE]: Float64Array,
  [GL_TYPE$1.FLOAT]: Float32Array,
  [GL_TYPE$1.UNSIGNED_SHORT]: Uint16Array,
  [GL_TYPE$1.UNSIGNED_INT]: Uint32Array,
  [GL_TYPE$1.UNSIGNED_BYTE]: Uint8Array,
  [GL_TYPE$1.BYTE]: Int8Array,
  [GL_TYPE$1.SHORT]: Int16Array,
  [GL_TYPE$1.INT]: Int32Array
};
const NAME_TO_GL_TYPE$1 = {
  DOUBLE: GL_TYPE$1.DOUBLE,
  FLOAT: GL_TYPE$1.FLOAT,
  UNSIGNED_SHORT: GL_TYPE$1.UNSIGNED_SHORT,
  UNSIGNED_INT: GL_TYPE$1.UNSIGNED_INT,
  UNSIGNED_BYTE: GL_TYPE$1.UNSIGNED_BYTE,
  BYTE: GL_TYPE$1.BYTE,
  SHORT: GL_TYPE$1.SHORT,
  INT: GL_TYPE$1.INT
};
const ERR_TYPE_CONVERSION$1 = "Failed to convert GL type";
let GLType$1 = class GLType2 {
  // Signature: fromTypedArray(new Uint8Array())
  // Signature: fromTypedArray(Uint8Array)
  /**
   * Returns the size, in bytes, of the corresponding datatype
   * @param arrayOrType
   * @returns glType a a string
   */
  static fromTypedArray(arrayOrType) {
    arrayOrType = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
    for (const glType in GL_TYPE_TO_ARRAY_TYPE$1) {
      const ArrayType2 = GL_TYPE_TO_ARRAY_TYPE$1[glType];
      if (ArrayType2 === arrayOrType) {
        return glType;
      }
    }
    throw new Error(ERR_TYPE_CONVERSION$1);
  }
  /**
   * Extracts name for glType from array NAME_TO_GL_TYPE
   * @param name
   * @returns glType as a number
   */
  static fromName(name2) {
    const glType = NAME_TO_GL_TYPE$1[name2];
    if (!glType) {
      throw new Error(ERR_TYPE_CONVERSION$1);
    }
    return glType;
  }
  // Converts GL constant to corresponding typed array type
  // eslint-disable-next-line complexity
  static getArrayType(glType) {
    switch (glType) {
      case GL_TYPE$1.UNSIGNED_SHORT_5_6_5:
      case GL_TYPE$1.UNSIGNED_SHORT_4_4_4_4:
      case GL_TYPE$1.UNSIGNED_SHORT_5_5_5_1:
        return Uint16Array;
      default:
        const ArrayType2 = GL_TYPE_TO_ARRAY_TYPE$1[glType];
        if (!ArrayType2) {
          throw new Error(ERR_TYPE_CONVERSION$1);
        }
        return ArrayType2;
    }
  }
  /**
   * Returns the size in bytes of one element of the provided WebGL type
   * @param glType
   * @returns size of glType
   */
  static getByteSize(glType) {
    const ArrayType2 = GLType2.getArrayType(glType);
    return ArrayType2.BYTES_PER_ELEMENT;
  }
  /**
   * Returns `true` if `glType` is a valid WebGL data type.
   * @param glType
   * @returns boolean
   */
  static validate(glType) {
    return Boolean(GLType2.getArrayType(glType));
  }
  /**
   * Creates a typed view of an array of bytes
   * @param glType The type of typed array (ArrayBuffer view) to create
   * @param buffer The buffer storage to use for the view.
   * @param byteOffset The offset, in bytes, to the first element in the view
   * @param length The number of elements in the view. Defaults to buffer length
   * @returns A typed array view of the buffer
   */
  static createTypedArray(glType, buffer3, byteOffset = 0, length2) {
    if (length2 === void 0) {
      length2 = (buffer3.byteLength - byteOffset) / GLType2.getByteSize(glType);
    }
    const ArrayType2 = GLType2.getArrayType(glType);
    return new ArrayType2(buffer3, byteOffset, length2);
  }
};
function assert$5(condition, message2) {
  if (!condition) {
    throw new Error(`math.gl assertion failed. ${message2}`);
  }
}
function decodeRGB565$1(rgb565, target = [0, 0, 0]) {
  const r5 = rgb565 >> 11 & 31;
  const g6 = rgb565 >> 5 & 63;
  const b5 = rgb565 & 31;
  target[0] = r5 << 3;
  target[1] = g6 << 2;
  target[2] = b5 << 3;
  return target;
}
new Vector2();
new Vector3();
new Vector2();
new Vector2();
function fromSNorm$1(value, rangeMaximum = 255) {
  return clamp$3(value, 0, rangeMaximum) / rangeMaximum * 2 - 1;
}
function signNotZero$1(value) {
  return value < 0 ? -1 : 1;
}
function octDecodeInRange$1(x2, y2, rangeMax, result) {
  assert$5(result);
  if (x2 < 0 || x2 > rangeMax || y2 < 0 || y2 > rangeMax) {
    throw new Error(`x and y must be unsigned normalized integers between 0 and ${rangeMax}`);
  }
  result.x = fromSNorm$1(x2, rangeMax);
  result.y = fromSNorm$1(y2, rangeMax);
  result.z = 1 - (Math.abs(result.x) + Math.abs(result.y));
  if (result.z < 0) {
    const oldVX = result.x;
    result.x = (1 - Math.abs(result.y)) * signNotZero$1(oldVX);
    result.y = (1 - Math.abs(oldVX)) * signNotZero$1(result.y);
  }
  return result.normalize();
}
function octDecode$1(x2, y2, result) {
  return octDecodeInRange$1(x2, y2, 255, result);
}
let Tile3DFeatureTable$1 = class Tile3DFeatureTable2 {
  constructor(featureTableJson, featureTableBinary) {
    __publicField2(this, "json");
    __publicField2(this, "buffer");
    __publicField2(this, "featuresLength", 0);
    __publicField2(this, "_cachedTypedArrays", {});
    this.json = featureTableJson;
    this.buffer = featureTableBinary;
  }
  getExtension(extensionName) {
    return this.json.extensions && this.json.extensions[extensionName];
  }
  hasProperty(propertyName) {
    return Boolean(this.json[propertyName]);
  }
  getGlobalProperty(propertyName, componentType = GL$2.UNSIGNED_INT, componentLength = 1) {
    const jsonValue = this.json[propertyName];
    if (jsonValue && Number.isFinite(jsonValue.byteOffset)) {
      return this._getTypedArrayFromBinary(propertyName, componentType, componentLength, 1, jsonValue.byteOffset);
    }
    return jsonValue;
  }
  getPropertyArray(propertyName, componentType, componentLength) {
    const jsonValue = this.json[propertyName];
    if (jsonValue && Number.isFinite(jsonValue.byteOffset)) {
      if ("componentType" in jsonValue) {
        componentType = GLType$1.fromName(jsonValue.componentType);
      }
      return this._getTypedArrayFromBinary(propertyName, componentType, componentLength, this.featuresLength, jsonValue.byteOffset);
    }
    return this._getTypedArrayFromArray(propertyName, componentType, jsonValue);
  }
  getProperty(propertyName, componentType, componentLength, featureId, result) {
    const jsonValue = this.json[propertyName];
    if (!jsonValue) {
      return jsonValue;
    }
    const typedArray = this.getPropertyArray(propertyName, componentType, componentLength);
    if (componentLength === 1) {
      return typedArray[featureId];
    }
    for (let i2 = 0; i2 < componentLength; ++i2) {
      result[i2] = typedArray[componentLength * featureId + i2];
    }
    return result;
  }
  // HELPERS
  _getTypedArrayFromBinary(propertyName, componentType, componentLength, count3, byteOffset) {
    const cachedTypedArrays = this._cachedTypedArrays;
    let typedArray = cachedTypedArrays[propertyName];
    if (!typedArray) {
      typedArray = GLType$1.createTypedArray(componentType, this.buffer.buffer, this.buffer.byteOffset + byteOffset, count3 * componentLength);
      cachedTypedArrays[propertyName] = typedArray;
    }
    return typedArray;
  }
  _getTypedArrayFromArray(propertyName, componentType, array2) {
    const cachedTypedArrays = this._cachedTypedArrays;
    let typedArray = cachedTypedArrays[propertyName];
    if (!typedArray) {
      typedArray = GLType$1.createTypedArray(componentType, array2);
      cachedTypedArrays[propertyName] = typedArray;
    }
    return typedArray;
  }
};
const COMPONENTS_PER_ATTRIBUTE$1 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const UNPACKER$1 = {
  SCALAR: (values4, i2) => values4[i2],
  VEC2: (values4, i2) => [values4[2 * i2 + 0], values4[2 * i2 + 1]],
  VEC3: (values4, i2) => [values4[3 * i2 + 0], values4[3 * i2 + 1], values4[3 * i2 + 2]],
  VEC4: (values4, i2) => [values4[4 * i2 + 0], values4[4 * i2 + 1], values4[4 * i2 + 2], values4[4 * i2 + 3]],
  // TODO: check column major
  MAT2: (values4, i2) => [
    values4[4 * i2 + 0],
    values4[4 * i2 + 1],
    values4[4 * i2 + 2],
    values4[4 * i2 + 3]
  ],
  MAT3: (values4, i2) => [
    values4[9 * i2 + 0],
    values4[9 * i2 + 1],
    values4[9 * i2 + 2],
    values4[9 * i2 + 3],
    values4[9 * i2 + 4],
    values4[9 * i2 + 5],
    values4[9 * i2 + 6],
    values4[9 * i2 + 7],
    values4[9 * i2 + 8]
  ],
  MAT4: (values4, i2) => [
    values4[16 * i2 + 0],
    values4[16 * i2 + 1],
    values4[16 * i2 + 2],
    values4[16 * i2 + 3],
    values4[16 * i2 + 4],
    values4[16 * i2 + 5],
    values4[16 * i2 + 6],
    values4[16 * i2 + 7],
    values4[16 * i2 + 8],
    values4[16 * i2 + 9],
    values4[16 * i2 + 10],
    values4[16 * i2 + 11],
    values4[16 * i2 + 12],
    values4[16 * i2 + 13],
    values4[16 * i2 + 14],
    values4[16 * i2 + 15]
  ]
};
const PACKER$1 = {
  SCALAR: (x2, values4, i2) => {
    values4[i2] = x2;
  },
  VEC2: (x2, values4, i2) => {
    values4[2 * i2 + 0] = x2[0];
    values4[2 * i2 + 1] = x2[1];
  },
  VEC3: (x2, values4, i2) => {
    values4[3 * i2 + 0] = x2[0];
    values4[3 * i2 + 1] = x2[1];
    values4[3 * i2 + 2] = x2[2];
  },
  VEC4: (x2, values4, i2) => {
    values4[4 * i2 + 0] = x2[0];
    values4[4 * i2 + 1] = x2[1];
    values4[4 * i2 + 2] = x2[2];
    values4[4 * i2 + 3] = x2[3];
  },
  // TODO: check column major correctness
  MAT2: (x2, values4, i2) => {
    values4[4 * i2 + 0] = x2[0];
    values4[4 * i2 + 1] = x2[1];
    values4[4 * i2 + 2] = x2[2];
    values4[4 * i2 + 3] = x2[3];
  },
  MAT3: (x2, values4, i2) => {
    values4[9 * i2 + 0] = x2[0];
    values4[9 * i2 + 1] = x2[1];
    values4[9 * i2 + 2] = x2[2];
    values4[9 * i2 + 3] = x2[3];
    values4[9 * i2 + 4] = x2[4];
    values4[9 * i2 + 5] = x2[5];
    values4[9 * i2 + 6] = x2[6];
    values4[9 * i2 + 7] = x2[7];
    values4[9 * i2 + 8] = x2[8];
    values4[9 * i2 + 9] = x2[9];
  },
  MAT4: (x2, values4, i2) => {
    values4[16 * i2 + 0] = x2[0];
    values4[16 * i2 + 1] = x2[1];
    values4[16 * i2 + 2] = x2[2];
    values4[16 * i2 + 3] = x2[3];
    values4[16 * i2 + 4] = x2[4];
    values4[16 * i2 + 5] = x2[5];
    values4[16 * i2 + 6] = x2[6];
    values4[16 * i2 + 7] = x2[7];
    values4[16 * i2 + 8] = x2[8];
    values4[16 * i2 + 9] = x2[9];
    values4[16 * i2 + 10] = x2[10];
    values4[16 * i2 + 11] = x2[11];
    values4[16 * i2 + 12] = x2[12];
    values4[16 * i2 + 13] = x2[13];
    values4[16 * i2 + 14] = x2[14];
    values4[16 * i2 + 15] = x2[15];
  }
};
function createTypedArrayFromAccessor$1(tile3DAccessor, buffer3, byteOffset, length2) {
  const { componentType } = tile3DAccessor;
  assert$e(tile3DAccessor.componentType);
  const type = typeof componentType === "string" ? GLType$1.fromName(componentType) : componentType;
  const size12 = COMPONENTS_PER_ATTRIBUTE$1[tile3DAccessor.type];
  const unpacker = UNPACKER$1[tile3DAccessor.type];
  const packer = PACKER$1[tile3DAccessor.type];
  byteOffset += tile3DAccessor.byteOffset;
  const values4 = GLType$1.createTypedArray(type, buffer3, byteOffset, size12 * length2);
  return {
    values: values4,
    type,
    size: size12,
    unpacker,
    packer
  };
}
const defined$3 = (x2) => x2 !== void 0;
function initializeHierarchy$1(batchTable, jsonHeader, binaryBody) {
  if (!jsonHeader) {
    return null;
  }
  let hierarchy = batchTable.getExtension("3DTILES_batch_table_hierarchy");
  const legacyHierarchy = jsonHeader.HIERARCHY;
  if (legacyHierarchy) {
    console.warn("3D Tile Parser: HIERARCHY is deprecated. Use 3DTILES_batch_table_hierarchy.");
    jsonHeader.extensions = jsonHeader.extensions || {};
    jsonHeader.extensions["3DTILES_batch_table_hierarchy"] = legacyHierarchy;
    hierarchy = legacyHierarchy;
  }
  if (!hierarchy) {
    return null;
  }
  return initializeHierarchyValues$1(hierarchy, binaryBody);
}
function initializeHierarchyValues$1(hierarchyJson, binaryBody) {
  let i2;
  let classId;
  let binaryAccessor;
  const instancesLength = hierarchyJson.instancesLength;
  const classes2 = hierarchyJson.classes;
  let classIds = hierarchyJson.classIds;
  let parentCounts = hierarchyJson.parentCounts;
  let parentIds = hierarchyJson.parentIds;
  let parentIdsLength = instancesLength;
  if (defined$3(classIds.byteOffset)) {
    classIds.componentType = defaultValue(classIds.componentType, GL.UNSIGNED_SHORT);
    classIds.type = AttributeType.SCALAR;
    binaryAccessor = getBinaryAccessor(classIds);
    classIds = binaryAccessor.createArrayBufferView(binaryBody.buffer, binaryBody.byteOffset + classIds.byteOffset, instancesLength);
  }
  let parentIndexes;
  if (defined$3(parentCounts)) {
    if (defined$3(parentCounts.byteOffset)) {
      parentCounts.componentType = defaultValue(parentCounts.componentType, GL.UNSIGNED_SHORT);
      parentCounts.type = AttributeType.SCALAR;
      binaryAccessor = getBinaryAccessor(parentCounts);
      parentCounts = binaryAccessor.createArrayBufferView(binaryBody.buffer, binaryBody.byteOffset + parentCounts.byteOffset, instancesLength);
    }
    parentIndexes = new Uint16Array(instancesLength);
    parentIdsLength = 0;
    for (i2 = 0; i2 < instancesLength; ++i2) {
      parentIndexes[i2] = parentIdsLength;
      parentIdsLength += parentCounts[i2];
    }
  }
  if (defined$3(parentIds) && defined$3(parentIds.byteOffset)) {
    parentIds.componentType = defaultValue(parentIds.componentType, GL.UNSIGNED_SHORT);
    parentIds.type = AttributeType.SCALAR;
    binaryAccessor = getBinaryAccessor(parentIds);
    parentIds = binaryAccessor.createArrayBufferView(binaryBody.buffer, binaryBody.byteOffset + parentIds.byteOffset, parentIdsLength);
  }
  const classesLength = classes2.length;
  for (i2 = 0; i2 < classesLength; ++i2) {
    const classInstancesLength = classes2[i2].length;
    const properties = classes2[i2].instances;
    const binaryProperties = getBinaryProperties(classInstancesLength, properties, binaryBody);
    classes2[i2].instances = combine(binaryProperties, properties);
  }
  const classCounts = new Array(classesLength).fill(0);
  const classIndexes = new Uint16Array(instancesLength);
  for (i2 = 0; i2 < instancesLength; ++i2) {
    classId = classIds[i2];
    classIndexes[i2] = classCounts[classId];
    ++classCounts[classId];
  }
  const hierarchy = {
    classes: classes2,
    classIds,
    classIndexes,
    parentCounts,
    parentIndexes,
    parentIds
  };
  validateHierarchy$1(hierarchy);
  return hierarchy;
}
function traverseHierarchy$1(hierarchy, instanceIndex, endConditionCallback) {
  if (!hierarchy) {
    return;
  }
  const parentCounts = hierarchy.parentCounts;
  const parentIds = hierarchy.parentIds;
  if (parentIds) {
    return endConditionCallback(hierarchy, instanceIndex);
  }
  if (parentCounts > 0) {
    return traverseHierarchyMultipleParents$1(hierarchy, instanceIndex, endConditionCallback);
  }
  return traverseHierarchySingleParent$1(hierarchy, instanceIndex, endConditionCallback);
}
function traverseHierarchyMultipleParents$1(hierarchy, instanceIndex, endConditionCallback) {
  const classIds = hierarchy.classIds;
  const parentCounts = hierarchy.parentCounts;
  const parentIds = hierarchy.parentIds;
  const parentIndexes = hierarchy.parentIndexes;
  const instancesLength = classIds.length;
  const visited = scratchVisited;
  visited.length = Math.max(visited.length, instancesLength);
  const visitedMarker = ++marker;
  const stack2 = scratchStack;
  stack2.length = 0;
  stack2.push(instanceIndex);
  while (stack2.length > 0) {
    instanceIndex = stack2.pop();
    if (visited[instanceIndex] === visitedMarker) {
      continue;
    }
    visited[instanceIndex] = visitedMarker;
    const result = endConditionCallback(hierarchy, instanceIndex);
    if (defined$3(result)) {
      return result;
    }
    const parentCount = parentCounts[instanceIndex];
    const parentIndex = parentIndexes[instanceIndex];
    for (let i2 = 0; i2 < parentCount; ++i2) {
      const parentId = parentIds[parentIndex + i2];
      if (parentId !== instanceIndex) {
        stack2.push(parentId);
      }
    }
  }
  return null;
}
function traverseHierarchySingleParent$1(hierarchy, instanceIndex, endConditionCallback) {
  let hasParent = true;
  while (hasParent) {
    const result = endConditionCallback(hierarchy, instanceIndex);
    if (defined$3(result)) {
      return result;
    }
    const parentId = hierarchy.parentIds[instanceIndex];
    hasParent = parentId !== instanceIndex;
    instanceIndex = parentId;
  }
  throw new Error("traverseHierarchySingleParent");
}
function validateHierarchy$1(hierarchy) {
  const classIds = hierarchy.classIds;
  const instancesLength = classIds.length;
  for (let i2 = 0; i2 < instancesLength; ++i2) {
    validateInstance$1(hierarchy, i2, stack);
  }
}
function validateInstance$1(hierarchy, instanceIndex, stack2) {
  const parentCounts = hierarchy.parentCounts;
  const parentIds = hierarchy.parentIds;
  const parentIndexes = hierarchy.parentIndexes;
  const classIds = hierarchy.classIds;
  const instancesLength = classIds.length;
  if (!defined$3(parentIds)) {
    return;
  }
  assert(instanceIndex < instancesLength, `Parent index ${instanceIndex} exceeds the total number of instances: ${instancesLength}`);
  assert(stack2.indexOf(instanceIndex) === -1, "Circular dependency detected in the batch table hierarchy.");
  stack2.push(instanceIndex);
  const parentCount = defined$3(parentCounts) ? parentCounts[instanceIndex] : 1;
  const parentIndex = defined$3(parentCounts) ? parentIndexes[instanceIndex] : instanceIndex;
  for (let i2 = 0; i2 < parentCount; ++i2) {
    const parentId = parentIds[parentIndex + i2];
    if (parentId !== instanceIndex) {
      validateInstance$1(hierarchy, parentId, stack2);
    }
  }
  stack2.pop(instanceIndex);
}
function defined$2(x2) {
  return x2 !== void 0 && x2 !== null;
}
const clone$1 = (x2, y2) => x2;
const IGNORED_PROPERTY_FIELDS$1 = {
  HIERARCHY: true,
  // Deprecated HIERARCHY property
  extensions: true,
  extras: true
};
let Tile3DBatchTableParser$1 = class Tile3DBatchTableParser2 {
  constructor(json, binary, featureCount, options2 = {}) {
    __publicField2(this, "json");
    __publicField2(this, "binary");
    __publicField2(this, "featureCount");
    __publicField2(this, "_extensions");
    // Copy all top-level property fields from the json object, ignoring special fields
    __publicField2(this, "_properties");
    __publicField2(this, "_binaryProperties");
    // TODO: hierarchy support is only partially implemented and not tested
    __publicField2(this, "_hierarchy");
    var _a3;
    assert$e(featureCount >= 0);
    this.json = json || {};
    this.binary = binary;
    this.featureCount = featureCount;
    this._extensions = ((_a3 = this.json) == null ? void 0 : _a3.extensions) || {};
    this._properties = {};
    for (const propertyName in this.json) {
      if (!IGNORED_PROPERTY_FIELDS$1[propertyName]) {
        this._properties[propertyName] = this.json[propertyName];
      }
    }
    this._binaryProperties = this._initializeBinaryProperties();
    if (options2["3DTILES_batch_table_hierarchy"]) {
      this._hierarchy = initializeHierarchy$1(this, this.json, this.binary);
    }
  }
  getExtension(extensionName) {
    return this.json && this.json.extensions && this.json.extensions[extensionName];
  }
  memorySizeInBytes() {
    return 0;
  }
  isClass(batchId, className) {
    this._checkBatchId(batchId);
    assert$e(typeof className === "string", className);
    if (this._hierarchy) {
      const result = traverseHierarchy$1(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
        const classId = hierarchy.classIds[instanceIndex];
        const instanceClass = hierarchy.classes[classId];
        return instanceClass.name === className;
      });
      return defined$2(result);
    }
    return false;
  }
  isExactClass(batchId, className) {
    assert$e(typeof className === "string", className);
    return this.getExactClassName(batchId) === className;
  }
  getExactClassName(batchId) {
    this._checkBatchId(batchId);
    if (this._hierarchy) {
      const classId = this._hierarchy.classIds[batchId];
      const instanceClass = this._hierarchy.classes[classId];
      return instanceClass.name;
    }
    return void 0;
  }
  hasProperty(batchId, name2) {
    this._checkBatchId(batchId);
    assert$e(typeof name2 === "string", name2);
    return defined$2(this._properties[name2]) || this._hasPropertyInHierarchy(batchId, name2);
  }
  getPropertyNames(batchId, results) {
    this._checkBatchId(batchId);
    results = defined$2(results) ? results : [];
    results.length = 0;
    const propertyNames = Object.keys(this._properties);
    results.push(...propertyNames);
    if (this._hierarchy) {
      this._getPropertyNamesInHierarchy(batchId, results);
    }
    return results;
  }
  getProperty(batchId, name2) {
    this._checkBatchId(batchId);
    assert$e(typeof name2 === "string", name2);
    if (this._binaryProperties) {
      const binaryProperty = this._binaryProperties[name2];
      if (defined$2(binaryProperty)) {
        return this._getBinaryProperty(binaryProperty, batchId);
      }
    }
    const propertyValues = this._properties[name2];
    if (defined$2(propertyValues)) {
      return clone$1(propertyValues[batchId]);
    }
    if (this._hierarchy) {
      const hierarchyProperty = this._getHierarchyProperty(batchId, name2);
      if (defined$2(hierarchyProperty)) {
        return hierarchyProperty;
      }
    }
    return void 0;
  }
  setProperty(batchId, name2, value) {
    const featureCount = this.featureCount;
    this._checkBatchId(batchId);
    assert$e(typeof name2 === "string", name2);
    if (this._binaryProperties) {
      const binaryProperty = this._binaryProperties[name2];
      if (binaryProperty) {
        this._setBinaryProperty(binaryProperty, batchId, value);
        return;
      }
    }
    if (this._hierarchy) {
      if (this._setHierarchyProperty(this, batchId, name2, value)) {
        return;
      }
    }
    let propertyValues = this._properties[name2];
    if (!defined$2(propertyValues)) {
      this._properties[name2] = new Array(featureCount);
      propertyValues = this._properties[name2];
    }
    propertyValues[batchId] = clone$1(value);
  }
  // PRIVATE METHODS
  _checkBatchId(batchId) {
    const valid = batchId >= 0 && batchId < this.featureCount;
    if (!valid) {
      throw new Error("batchId not in range [0, featureCount - 1].");
    }
  }
  _getBinaryProperty(binaryProperty, index2) {
    return binaryProperty.unpack(binaryProperty.typedArray, index2);
  }
  _setBinaryProperty(binaryProperty, index2, value) {
    binaryProperty.pack(value, binaryProperty.typedArray, index2);
  }
  _initializeBinaryProperties() {
    let binaryProperties = null;
    for (const name2 in this._properties) {
      const property2 = this._properties[name2];
      const binaryProperty = this._initializeBinaryProperty(name2, property2);
      if (binaryProperty) {
        binaryProperties = binaryProperties || {};
        binaryProperties[name2] = binaryProperty;
      }
    }
    return binaryProperties;
  }
  _initializeBinaryProperty(name2, property2) {
    if ("byteOffset" in property2) {
      const tile3DAccessor = property2;
      assert$e(this.binary, `Property ${name2} requires a batch table binary.`);
      assert$e(tile3DAccessor.type, `Property ${name2} requires a type.`);
      const accessor = createTypedArrayFromAccessor$1(tile3DAccessor, this.binary.buffer, this.binary.byteOffset | 0, this.featureCount);
      return {
        typedArray: accessor.values,
        componentCount: accessor.size,
        unpack: accessor.unpacker,
        pack: accessor.packer
      };
    }
    return null;
  }
  //  EXTENSION SUPPORT: 3DTILES_batch_table_hierarchy
  _hasPropertyInHierarchy(batchId, name2) {
    if (!this._hierarchy) {
      return false;
    }
    const result = traverseHierarchy$1(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instances = hierarchy.classes[classId].instances;
      return defined$2(instances[name2]);
    });
    return defined$2(result);
  }
  _getPropertyNamesInHierarchy(batchId, results) {
    traverseHierarchy$1(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instances = hierarchy.classes[classId].instances;
      for (const name2 in instances) {
        if (instances.hasOwnProperty(name2)) {
          if (results.indexOf(name2) === -1) {
            results.push(name2);
          }
        }
      }
    });
  }
  _getHierarchyProperty(batchId, name2) {
    return traverseHierarchy$1(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instanceClass = hierarchy.classes[classId];
      const indexInClass = hierarchy.classIndexes[instanceIndex];
      const propertyValues = instanceClass.instances[name2];
      if (defined$2(propertyValues)) {
        if (defined$2(propertyValues.typedArray)) {
          return this._getBinaryProperty(propertyValues, indexInClass);
        }
        return clone$1(propertyValues[indexInClass]);
      }
      return null;
    });
  }
  _setHierarchyProperty(batchTable, batchId, name2, value) {
    const result = traverseHierarchy$1(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instanceClass = hierarchy.classes[classId];
      const indexInClass = hierarchy.classIndexes[instanceIndex];
      const propertyValues = instanceClass.instances[name2];
      if (defined$2(propertyValues)) {
        assert$e(instanceIndex === batchId, `Inherited property "${name2}" is read-only.`);
        if (defined$2(propertyValues.typedArray)) {
          this._setBinaryProperty(propertyValues, indexInClass, value);
        } else {
          propertyValues[indexInClass] = clone$1(value);
        }
        return true;
      }
      return false;
    });
    return defined$2(result);
  }
};
const SIZEOF_UINT32$3 = 4;
function parse3DTileHeaderSync$1(tile, arrayBuffer2, byteOffset = 0) {
  const view2 = new DataView(arrayBuffer2);
  tile.magic = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$3;
  tile.version = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$3;
  tile.byteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$3;
  if (tile.version !== 1) {
    throw new Error(`3D Tile Version ${tile.version} not supported`);
  }
  return byteOffset;
}
const SIZEOF_UINT32$2 = 4;
const DEPRECATION_WARNING$1 = "b3dm tile in legacy format.";
function parse3DTileTablesHeaderSync$1(tile, arrayBuffer2, byteOffset) {
  const view2 = new DataView(arrayBuffer2);
  let batchLength;
  tile.header = tile.header || {};
  let featureTableJsonByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$2;
  let featureTableBinaryByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$2;
  let batchTableJsonByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$2;
  let batchTableBinaryByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$2;
  if (batchTableJsonByteLength >= 570425344) {
    byteOffset -= SIZEOF_UINT32$2 * 2;
    batchLength = featureTableJsonByteLength;
    batchTableJsonByteLength = featureTableBinaryByteLength;
    batchTableBinaryByteLength = 0;
    featureTableJsonByteLength = 0;
    featureTableBinaryByteLength = 0;
    console.warn(DEPRECATION_WARNING$1);
  } else if (batchTableBinaryByteLength >= 570425344) {
    byteOffset -= SIZEOF_UINT32$2;
    batchLength = batchTableJsonByteLength;
    batchTableJsonByteLength = featureTableJsonByteLength;
    batchTableBinaryByteLength = featureTableBinaryByteLength;
    featureTableJsonByteLength = 0;
    featureTableBinaryByteLength = 0;
    console.warn(DEPRECATION_WARNING$1);
  }
  tile.header.featureTableJsonByteLength = featureTableJsonByteLength;
  tile.header.featureTableBinaryByteLength = featureTableBinaryByteLength;
  tile.header.batchTableJsonByteLength = batchTableJsonByteLength;
  tile.header.batchTableBinaryByteLength = batchTableBinaryByteLength;
  tile.header.batchLength = batchLength;
  return byteOffset;
}
function parse3DTileTablesSync$1(tile, arrayBuffer2, byteOffset, options2) {
  byteOffset = parse3DTileFeatureTable$1(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileBatchTable$1(tile, arrayBuffer2, byteOffset);
  return byteOffset;
}
function parse3DTileFeatureTable$1(tile, arrayBuffer2, byteOffset, options2) {
  const { featureTableJsonByteLength, featureTableBinaryByteLength, batchLength } = tile.header || {};
  tile.featureTableJson = {
    BATCH_LENGTH: batchLength || 0
  };
  if (featureTableJsonByteLength && featureTableJsonByteLength > 0) {
    const featureTableString = getStringFromArrayBuffer$1(arrayBuffer2, byteOffset, featureTableJsonByteLength);
    tile.featureTableJson = JSON.parse(featureTableString);
  }
  byteOffset += featureTableJsonByteLength || 0;
  tile.featureTableBinary = new Uint8Array(arrayBuffer2, byteOffset, featureTableBinaryByteLength);
  byteOffset += featureTableBinaryByteLength || 0;
  return byteOffset;
}
function parse3DTileBatchTable$1(tile, arrayBuffer2, byteOffset, options2) {
  const { batchTableJsonByteLength, batchTableBinaryByteLength } = tile.header || {};
  if (batchTableJsonByteLength && batchTableJsonByteLength > 0) {
    const batchTableString = getStringFromArrayBuffer$1(arrayBuffer2, byteOffset, batchTableJsonByteLength);
    tile.batchTableJson = JSON.parse(batchTableString);
    byteOffset += batchTableJsonByteLength;
    if (batchTableBinaryByteLength && batchTableBinaryByteLength > 0) {
      tile.batchTableBinary = new Uint8Array(arrayBuffer2, byteOffset, batchTableBinaryByteLength);
      tile.batchTableBinary = new Uint8Array(tile.batchTableBinary);
      byteOffset += batchTableBinaryByteLength;
    }
  }
  return byteOffset;
}
function normalize3DTileColorAttribute$1(tile, colors, batchTable) {
  if (!colors && (!tile || !tile.batchIds || !batchTable)) {
    return null;
  }
  const { batchIds, isRGB565, pointCount = 0 } = tile;
  if (batchIds && batchTable) {
    const colorArray = new Uint8ClampedArray(pointCount * 3);
    for (let i2 = 0; i2 < pointCount; i2++) {
      const batchId = batchIds[i2];
      const dimensions = batchTable.getProperty(batchId, "dimensions");
      const color = dimensions.map((d2) => d2 * 255);
      colorArray[i2 * 3] = color[0];
      colorArray[i2 * 3 + 1] = color[1];
      colorArray[i2 * 3 + 2] = color[2];
    }
    return {
      type: GL$2.UNSIGNED_BYTE,
      value: colorArray,
      size: 3,
      normalized: true
    };
  }
  if (colors && isRGB565) {
    const colorArray = new Uint8ClampedArray(pointCount * 3);
    for (let i2 = 0; i2 < pointCount; i2++) {
      const color = decodeRGB565$1(colors[i2]);
      colorArray[i2 * 3] = color[0];
      colorArray[i2 * 3 + 1] = color[1];
      colorArray[i2 * 3 + 2] = color[2];
    }
    return {
      type: GL$2.UNSIGNED_BYTE,
      value: colorArray,
      size: 3,
      normalized: true
    };
  }
  if (colors && colors.length === pointCount * 3) {
    return {
      type: GL$2.UNSIGNED_BYTE,
      value: colors,
      size: 3,
      normalized: true
    };
  }
  return {
    type: GL$2.UNSIGNED_BYTE,
    value: colors || new Uint8ClampedArray(),
    size: 4,
    normalized: true
  };
}
const scratchNormal$1 = new Vector3();
function normalize3DTileNormalAttribute$1(tile, normals) {
  if (!normals) {
    return null;
  }
  if (tile.isOctEncoded16P) {
    const decodedArray = new Float32Array((tile.pointsLength || 0) * 3);
    for (let i2 = 0; i2 < (tile.pointsLength || 0); i2++) {
      octDecode$1(normals[i2 * 2], normals[i2 * 2 + 1], scratchNormal$1);
      scratchNormal$1.toArray(decodedArray, i2 * 3);
    }
    return {
      type: GL$2.FLOAT,
      size: 2,
      value: decodedArray
    };
  }
  return {
    type: GL$2.FLOAT,
    size: 2,
    value: normals
  };
}
function normalize3DTilePositionAttribute$1(tile, positions, options2) {
  if (!tile.isQuantized) {
    return positions;
  }
  if (options2["3d-tiles"] && options2["3d-tiles"].decodeQuantizedPositions) {
    tile.isQuantized = false;
    return decodeQuantizedPositions$1(tile, positions);
  }
  return {
    type: GL$2.UNSIGNED_SHORT,
    value: positions,
    size: 3,
    normalized: true
  };
}
function decodeQuantizedPositions$1(tile, positions) {
  const scratchPosition2 = new Vector3();
  const decodedArray = new Float32Array(tile.pointCount * 3);
  for (let i2 = 0; i2 < tile.pointCount; i2++) {
    scratchPosition2.set(positions[i2 * 3], positions[i2 * 3 + 1], positions[i2 * 3 + 2]).scale(1 / tile.quantizedRange).multiply(tile.quantizedVolumeScale).add(tile.quantizedVolumeOffset).toArray(decodedArray, i2 * 3);
  }
  return decodedArray;
}
async function parsePointCloud3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2) {
  byteOffset = parse3DTileHeaderSync$1(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesHeaderSync$1(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesSync$1(tile, arrayBuffer2, byteOffset);
  initializeTile$1(tile);
  const { featureTable, batchTable } = parsePointCloudTables$1(tile);
  await parseDraco$1(tile, featureTable, batchTable, options2, context2);
  parsePositions$1(tile, featureTable, options2);
  parseColors$1(tile, featureTable, batchTable);
  parseNormals$1(tile, featureTable);
  return byteOffset;
}
function initializeTile$1(tile) {
  tile.attributes = {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  tile.isQuantized = false;
  tile.isTranslucent = false;
  tile.isRGB565 = false;
  tile.isOctEncoded16P = false;
}
function parsePointCloudTables$1(tile) {
  const featureTable = new Tile3DFeatureTable$1(tile.featureTableJson, tile.featureTableBinary);
  const pointsLength = featureTable.getGlobalProperty("POINTS_LENGTH");
  if (!Number.isFinite(pointsLength)) {
    throw new Error("POINTS_LENGTH must be defined");
  }
  featureTable.featuresLength = pointsLength;
  tile.featuresLength = pointsLength;
  tile.pointsLength = pointsLength;
  tile.pointCount = pointsLength;
  tile.rtcCenter = featureTable.getGlobalProperty("RTC_CENTER", GL$2.FLOAT, 3);
  const batchTable = parseBatchIds$1(tile, featureTable);
  return { featureTable, batchTable };
}
function parsePositions$1(tile, featureTable, options2) {
  tile.attributes = tile.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  if (!tile.attributes.positions) {
    if (featureTable.hasProperty("POSITION")) {
      tile.attributes.positions = featureTable.getPropertyArray("POSITION", GL$2.FLOAT, 3);
    } else if (featureTable.hasProperty("POSITION_QUANTIZED")) {
      const positions = featureTable.getPropertyArray("POSITION_QUANTIZED", GL$2.UNSIGNED_SHORT, 3);
      tile.isQuantized = true;
      tile.quantizedRange = (1 << 16) - 1;
      tile.quantizedVolumeScale = featureTable.getGlobalProperty("QUANTIZED_VOLUME_SCALE", GL$2.FLOAT, 3);
      if (!tile.quantizedVolumeScale) {
        throw new Error("QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      }
      tile.quantizedVolumeOffset = featureTable.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", GL$2.FLOAT, 3);
      if (!tile.quantizedVolumeOffset) {
        throw new Error("QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      }
      tile.attributes.positions = normalize3DTilePositionAttribute$1(tile, positions, options2);
    }
  }
  if (!tile.attributes.positions) {
    throw new Error("Either POSITION or POSITION_QUANTIZED must be defined.");
  }
}
function parseColors$1(tile, featureTable, batchTable) {
  tile.attributes = tile.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  if (!tile.attributes.colors) {
    let colors = null;
    if (featureTable.hasProperty("RGBA")) {
      colors = featureTable.getPropertyArray("RGBA", GL$2.UNSIGNED_BYTE, 4);
      tile.isTranslucent = true;
    } else if (featureTable.hasProperty("RGB")) {
      colors = featureTable.getPropertyArray("RGB", GL$2.UNSIGNED_BYTE, 3);
    } else if (featureTable.hasProperty("RGB565")) {
      colors = featureTable.getPropertyArray("RGB565", GL$2.UNSIGNED_SHORT, 1);
      tile.isRGB565 = true;
    }
    tile.attributes.colors = normalize3DTileColorAttribute$1(tile, colors, batchTable);
  }
  if (featureTable.hasProperty("CONSTANT_RGBA")) {
    tile.constantRGBA = featureTable.getGlobalProperty("CONSTANT_RGBA", GL$2.UNSIGNED_BYTE, 4);
  }
}
function parseNormals$1(tile, featureTable) {
  tile.attributes = tile.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  if (!tile.attributes.normals) {
    let normals = null;
    if (featureTable.hasProperty("NORMAL")) {
      normals = featureTable.getPropertyArray("NORMAL", GL$2.FLOAT, 3);
    } else if (featureTable.hasProperty("NORMAL_OCT16P")) {
      normals = featureTable.getPropertyArray("NORMAL_OCT16P", GL$2.UNSIGNED_BYTE, 2);
      tile.isOctEncoded16P = true;
    }
    tile.attributes.normals = normalize3DTileNormalAttribute$1(tile, normals);
  }
}
function parseBatchIds$1(tile, featureTable) {
  let batchTable = null;
  if (!tile.batchIds && featureTable.hasProperty("BATCH_ID")) {
    tile.batchIds = featureTable.getPropertyArray("BATCH_ID", GL$2.UNSIGNED_SHORT, 1);
    if (tile.batchIds) {
      const batchFeatureLength = featureTable.getGlobalProperty("BATCH_LENGTH");
      if (!batchFeatureLength) {
        throw new Error("Global property: BATCH_LENGTH must be defined when BATCH_ID is defined.");
      }
      const { batchTableJson, batchTableBinary } = tile;
      batchTable = new Tile3DBatchTableParser$1(batchTableJson, batchTableBinary, batchFeatureLength);
    }
  }
  return batchTable;
}
async function parseDraco$1(tile, featureTable, batchTable, options2, context2) {
  let dracoBuffer;
  let dracoFeatureTableProperties;
  let dracoBatchTableProperties;
  const batchTableDraco = tile.batchTableJson && tile.batchTableJson.extensions && tile.batchTableJson.extensions["3DTILES_draco_point_compression"];
  if (batchTableDraco) {
    dracoBatchTableProperties = batchTableDraco.properties;
  }
  const featureTableDraco = featureTable.getExtension("3DTILES_draco_point_compression");
  if (featureTableDraco) {
    dracoFeatureTableProperties = featureTableDraco.properties;
    const dracoByteOffset = featureTableDraco.byteOffset;
    const dracoByteLength = featureTableDraco.byteLength;
    if (!dracoFeatureTableProperties || !Number.isFinite(dracoByteOffset) || !dracoByteLength) {
      throw new Error("Draco properties, byteOffset, and byteLength must be defined");
    }
    dracoBuffer = (tile.featureTableBinary || []).slice(dracoByteOffset, dracoByteOffset + dracoByteLength);
    tile.hasPositions = Number.isFinite(dracoFeatureTableProperties.POSITION);
    tile.hasColors = Number.isFinite(dracoFeatureTableProperties.RGB) || Number.isFinite(dracoFeatureTableProperties.RGBA);
    tile.hasNormals = Number.isFinite(dracoFeatureTableProperties.NORMAL);
    tile.hasBatchIds = Number.isFinite(dracoFeatureTableProperties.BATCH_ID);
    tile.isTranslucent = Number.isFinite(dracoFeatureTableProperties.RGBA);
  }
  if (!dracoBuffer) {
    return true;
  }
  const dracoData = {
    buffer: dracoBuffer,
    properties: { ...dracoFeatureTableProperties, ...dracoBatchTableProperties },
    featureTableProperties: dracoFeatureTableProperties,
    batchTableProperties: dracoBatchTableProperties,
    dequantizeInShader: false
  };
  return await loadDraco$1(tile, dracoData, options2, context2);
}
async function loadDraco$1(tile, dracoData, options2, context2) {
  if (!context2) {
    return;
  }
  const dracoOptions = {
    ...options2,
    draco: {
      ...options2 == null ? void 0 : options2.draco,
      extraAttributes: dracoData.batchTableProperties || {}
    }
  };
  delete dracoOptions["3d-tiles"];
  const data2 = await parseFromContext$1(dracoData.buffer, DracoLoader$2, dracoOptions, context2);
  const decodedPositions = data2.attributes.POSITION && data2.attributes.POSITION.value;
  const decodedColors = data2.attributes.COLOR_0 && data2.attributes.COLOR_0.value;
  const decodedNormals = data2.attributes.NORMAL && data2.attributes.NORMAL.value;
  const decodedBatchIds = data2.attributes.BATCH_ID && data2.attributes.BATCH_ID.value;
  const isQuantizedDraco = decodedPositions && data2.attributes.POSITION.value.quantization;
  const isOctEncodedDraco = decodedNormals && data2.attributes.NORMAL.value.quantization;
  if (isQuantizedDraco) {
    const quantization = data2.POSITION.data.quantization;
    const range2 = quantization.range;
    tile.quantizedVolumeScale = new Vector3(range2, range2, range2);
    tile.quantizedVolumeOffset = new Vector3(quantization.minValues);
    tile.quantizedRange = (1 << quantization.quantizationBits) - 1;
    tile.isQuantizedDraco = true;
  }
  if (isOctEncodedDraco) {
    tile.octEncodedRange = (1 << data2.NORMAL.data.quantization.quantizationBits) - 1;
    tile.isOctEncodedDraco = true;
  }
  const batchTableAttributes = {};
  if (dracoData.batchTableProperties) {
    for (const attributeName of Object.keys(dracoData.batchTableProperties)) {
      if (data2.attributes[attributeName] && data2.attributes[attributeName].value) {
        batchTableAttributes[attributeName.toLowerCase()] = data2.attributes[attributeName].value;
      }
    }
  }
  tile.attributes = {
    // @ts-expect-error
    positions: decodedPositions,
    // @ts-expect-error
    colors: normalize3DTileColorAttribute$1(tile, decodedColors, void 0),
    // @ts-expect-error
    normals: decodedNormals,
    // @ts-expect-error
    batchIds: decodedBatchIds,
    ...batchTableAttributes
  };
}
const GLTF_FORMAT$1 = {
  URI: 0,
  EMBEDDED: 1
};
function parse3DTileGLTFViewSync$1(tile, arrayBuffer2, byteOffset, options2) {
  tile.rotateYtoZ = true;
  const gltfByteLength = (tile.byteOffset || 0) + (tile.byteLength || 0) - byteOffset;
  if (gltfByteLength === 0) {
    throw new Error("glTF byte length must be greater than 0.");
  }
  tile.gltfUpAxis = (options2 == null ? void 0 : options2["3d-tiles"]) && options2["3d-tiles"].assetGltfUpAxis ? options2["3d-tiles"].assetGltfUpAxis : "Y";
  tile.gltfArrayBuffer = sliceArrayBuffer$1(arrayBuffer2, byteOffset, gltfByteLength);
  tile.gltfByteOffset = 0;
  tile.gltfByteLength = gltfByteLength;
  if (byteOffset % 4 === 0)
    ;
  else {
    console.warn(`${tile.type}: embedded glb is not aligned to a 4-byte boundary.`);
  }
  return (tile.byteOffset || 0) + (tile.byteLength || 0);
}
async function extractGLTF$1(tile, gltfFormat, options2, context2) {
  const tile3DOptions = (options2 == null ? void 0 : options2["3d-tiles"]) || {};
  extractGLTFBufferOrURL$1(tile, gltfFormat);
  if (tile3DOptions.loadGLTF) {
    if (!context2) {
      return;
    }
    if (tile.gltfUrl) {
      const { fetch: fetch2 } = context2;
      const response = await fetch2(tile.gltfUrl, options2);
      tile.gltfArrayBuffer = await response.arrayBuffer();
      tile.gltfByteOffset = 0;
    }
    if (tile.gltfArrayBuffer) {
      const gltfWithBuffers = await parseFromContext$1(tile.gltfArrayBuffer, GLTFLoader$2, options2, context2);
      tile.gltf = postProcessGLTF$1(gltfWithBuffers);
      tile.gpuMemoryUsageInBytes = getMemoryUsageGLTF$1(tile.gltf);
      delete tile.gltfArrayBuffer;
      delete tile.gltfByteOffset;
      delete tile.gltfByteLength;
    }
  }
}
function extractGLTFBufferOrURL$1(tile, gltfFormat, options2) {
  switch (gltfFormat) {
    case GLTF_FORMAT$1.URI:
      if (tile.gltfArrayBuffer) {
        const gltfUrlBytes = new Uint8Array(tile.gltfArrayBuffer, tile.gltfByteOffset);
        const textDecoder = new TextDecoder();
        const gltfUrl = textDecoder.decode(gltfUrlBytes);
        tile.gltfUrl = gltfUrl.replace(/[\s\0]+$/, "");
      }
      delete tile.gltfArrayBuffer;
      delete tile.gltfByteOffset;
      delete tile.gltfByteLength;
      break;
    case GLTF_FORMAT$1.EMBEDDED:
      break;
    default:
      throw new Error("b3dm: Illegal glTF format field");
  }
}
async function parseBatchedModel3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2) {
  var _a3;
  byteOffset = parseBatchedModel$1(tile, arrayBuffer2, byteOffset, options2);
  await extractGLTF$1(tile, GLTF_FORMAT$1.EMBEDDED, options2, context2);
  const extensions = (_a3 = tile == null ? void 0 : tile.gltf) == null ? void 0 : _a3.extensions;
  if (extensions && extensions.CESIUM_RTC) {
    tile.rtcCenter = extensions.CESIUM_RTC.center;
  }
  return byteOffset;
}
function parseBatchedModel$1(tile, arrayBuffer2, byteOffset, options2, context2) {
  byteOffset = parse3DTileHeaderSync$1(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesHeaderSync$1(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesSync$1(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileGLTFViewSync$1(tile, arrayBuffer2, byteOffset, options2);
  const featureTable = new Tile3DFeatureTable$1(tile.featureTableJson, tile.featureTableBinary);
  tile.rtcCenter = featureTable.getGlobalProperty("RTC_CENTER", GL$2.FLOAT, 3);
  return byteOffset;
}
async function parseInstancedModel3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2) {
  byteOffset = parseInstancedModel$1(tile, arrayBuffer2, byteOffset, options2);
  await extractGLTF$1(tile, tile.gltfFormat || 0, options2, context2);
  return byteOffset;
}
function parseInstancedModel$1(tile, arrayBuffer2, byteOffset, options2, context2) {
  var _a3;
  byteOffset = parse3DTileHeaderSync$1(tile, arrayBuffer2, byteOffset);
  if (tile.version !== 1) {
    throw new Error(`Instanced 3D Model version ${tile.version} is not supported`);
  }
  byteOffset = parse3DTileTablesHeaderSync$1(tile, arrayBuffer2, byteOffset);
  const view2 = new DataView(arrayBuffer2);
  tile.gltfFormat = view2.getUint32(byteOffset, true);
  byteOffset += 4;
  byteOffset = parse3DTileTablesSync$1(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileGLTFViewSync$1(tile, arrayBuffer2, byteOffset, options2);
  if (!((_a3 = tile == null ? void 0 : tile.header) == null ? void 0 : _a3.featureTableJsonByteLength) || tile.header.featureTableJsonByteLength === 0) {
    throw new Error("i3dm parser: featureTableJsonByteLength is zero.");
  }
  const featureTable = new Tile3DFeatureTable$1(tile.featureTableJson, tile.featureTableBinary);
  const instancesLength = featureTable.getGlobalProperty("INSTANCES_LENGTH");
  featureTable.featuresLength = instancesLength;
  if (!Number.isFinite(instancesLength)) {
    throw new Error("i3dm parser: INSTANCES_LENGTH must be defined");
  }
  tile.eastNorthUp = featureTable.getGlobalProperty("EAST_NORTH_UP");
  tile.rtcCenter = featureTable.getGlobalProperty("RTC_CENTER", GL$2.FLOAT, 3);
  const batchTable = new Tile3DBatchTableParser$1(tile.batchTableJson, tile.batchTableBinary, instancesLength);
  extractInstancedAttributes$1(tile, featureTable, batchTable, instancesLength);
  return byteOffset;
}
function extractInstancedAttributes$1(tile, featureTable, batchTable, instancesLength) {
  const instances = new Array(instancesLength);
  const instancePosition = new Vector3();
  new Vector3();
  new Vector3();
  new Vector3();
  const instanceRotation = new Matrix3();
  const instanceQuaternion = new Quaternion();
  const instanceScale = new Vector3();
  const instanceTranslationRotationScale = {};
  const instanceTransform = new Matrix4();
  const scratch1 = [];
  const scratch2 = [];
  const scratch3 = [];
  const scratch4 = [];
  for (let i2 = 0; i2 < instancesLength; i2++) {
    let position;
    if (featureTable.hasProperty("POSITION")) {
      position = featureTable.getProperty("POSITION", GL$2.FLOAT, 3, i2, instancePosition);
    } else if (featureTable.hasProperty("POSITION_QUANTIZED")) {
      position = featureTable.getProperty("POSITION_QUANTIZED", GL$2.UNSIGNED_SHORT, 3, i2, instancePosition);
      const quantizedVolumeOffset = featureTable.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", GL$2.FLOAT, 3);
      if (!quantizedVolumeOffset) {
        throw new Error("i3dm parser: QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      }
      const quantizedVolumeScale = featureTable.getGlobalProperty("QUANTIZED_VOLUME_SCALE", GL$2.FLOAT, 3);
      if (!quantizedVolumeScale) {
        throw new Error("i3dm parser: QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      }
      const MAX_UNSIGNED_SHORT = 65535;
      for (let j2 = 0; j2 < 3; j2++) {
        position[j2] = position[j2] / MAX_UNSIGNED_SHORT * quantizedVolumeScale[j2] + quantizedVolumeOffset[j2];
      }
    }
    if (!position) {
      throw new Error("i3dm: POSITION or POSITION_QUANTIZED must be defined for each instance.");
    }
    instancePosition.copy(position);
    instanceTranslationRotationScale.translation = instancePosition;
    tile.normalUp = featureTable.getProperty("NORMAL_UP", GL$2.FLOAT, 3, i2, scratch1);
    tile.normalRight = featureTable.getProperty("NORMAL_RIGHT", GL$2.FLOAT, 3, i2, scratch2);
    if (tile.normalUp) {
      if (!tile.normalRight) {
        throw new Error("i3dm: Custom orientation requires both NORMAL_UP and NORMAL_RIGHT.");
      }
      tile.hasCustomOrientation = true;
    } else {
      tile.octNormalUp = featureTable.getProperty("NORMAL_UP_OCT32P", GL$2.UNSIGNED_SHORT, 2, i2, scratch1);
      tile.octNormalRight = featureTable.getProperty("NORMAL_RIGHT_OCT32P", GL$2.UNSIGNED_SHORT, 2, i2, scratch2);
      if (tile.octNormalUp) {
        if (!tile.octNormalRight) {
          throw new Error("i3dm: oct-encoded orientation requires NORMAL_UP_OCT32P and NORMAL_RIGHT_OCT32P");
        }
        throw new Error("i3dm: oct-encoded orientation not implemented");
      } else if (tile.eastNorthUp) {
        Ellipsoid.WGS84.eastNorthUpToFixedFrame(instancePosition, instanceTransform);
        instanceTransform.getRotationMatrix3(instanceRotation);
      } else {
        instanceRotation.identity();
      }
    }
    instanceQuaternion.fromMatrix3(instanceRotation);
    instanceTranslationRotationScale.rotation = instanceQuaternion;
    instanceScale.set(1, 1, 1);
    const scale5 = featureTable.getProperty("SCALE", GL$2.FLOAT, 1, i2, scratch3);
    if (Number.isFinite(scale5)) {
      instanceScale.multiplyByScalar(scale5);
    }
    const nonUniformScale = featureTable.getProperty("SCALE_NON_UNIFORM", GL$2.FLOAT, 3, i2, scratch1);
    if (nonUniformScale) {
      instanceScale.scale(nonUniformScale);
    }
    instanceTranslationRotationScale.scale = instanceScale;
    let batchId = featureTable.getProperty("BATCH_ID", GL$2.UNSIGNED_SHORT, 1, i2, scratch4);
    if (batchId === void 0) {
      batchId = i2;
    }
    const rotationMatrix = new Matrix4().fromQuaternion(instanceTranslationRotationScale.rotation);
    instanceTransform.identity();
    instanceTransform.translate(instanceTranslationRotationScale.translation);
    instanceTransform.multiplyRight(rotationMatrix);
    instanceTransform.scale(instanceTranslationRotationScale.scale);
    const modelMatrix2 = instanceTransform.clone();
    instances[i2] = {
      modelMatrix: modelMatrix2,
      batchId
    };
  }
  tile.instances = instances;
}
async function parseComposite3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2, parse3DTile2) {
  byteOffset = parse3DTileHeaderSync$1(tile, arrayBuffer2, byteOffset);
  const view2 = new DataView(arrayBuffer2);
  tile.tilesLength = view2.getUint32(byteOffset, true);
  byteOffset += 4;
  tile.tiles = [];
  while (tile.tiles.length < tile.tilesLength && (tile.byteLength || 0) - byteOffset > 12) {
    const subtile = { shape: "tile3d" };
    tile.tiles.push(subtile);
    byteOffset = await parse3DTile2(arrayBuffer2, byteOffset, options2, context2, subtile);
  }
  return byteOffset;
}
async function parseGltf3DTile$1(tile, arrayBuffer2, options2, context2) {
  var _a3, _b3;
  tile.rotateYtoZ = true;
  tile.gltfUpAxis = ((_a3 = options2 == null ? void 0 : options2["3d-tiles"]) == null ? void 0 : _a3.assetGltfUpAxis) ? options2["3d-tiles"].assetGltfUpAxis : "Y";
  if ((_b3 = options2 == null ? void 0 : options2["3d-tiles"]) == null ? void 0 : _b3.loadGLTF) {
    if (!context2) {
      return arrayBuffer2.byteLength;
    }
    const gltfWithBuffers = await parseFromContext$1(arrayBuffer2, GLTFLoader$2, options2, context2);
    tile.gltf = postProcessGLTF$1(gltfWithBuffers);
    tile.gpuMemoryUsageInBytes = getMemoryUsageGLTF$1(tile.gltf);
  } else {
    tile.gltfArrayBuffer = arrayBuffer2;
  }
  return arrayBuffer2.byteLength;
}
async function parse3DTile$1(arrayBuffer2, byteOffset = 0, options2, context2, tile = { shape: "tile3d" }) {
  tile.byteOffset = byteOffset;
  tile.type = getMagicString$3(arrayBuffer2, byteOffset);
  switch (tile.type) {
    case TILE3D_TYPE$1.COMPOSITE:
      return await parseComposite3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2, parse3DTile$1);
    case TILE3D_TYPE$1.BATCHED_3D_MODEL:
      return await parseBatchedModel3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2);
    case TILE3D_TYPE$1.GLTF:
      return await parseGltf3DTile$1(tile, arrayBuffer2, options2, context2);
    case TILE3D_TYPE$1.INSTANCED_3D_MODEL:
      return await parseInstancedModel3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2);
    case TILE3D_TYPE$1.POINT_CLOUD:
      return await parsePointCloud3DTile$1(tile, arrayBuffer2, byteOffset, options2, context2);
    default:
      throw new Error(`3DTileLoader: unknown type ${tile.type}`);
  }
}
const SUBTREE_FILE_MAGIC$1 = 1952609651;
const SUBTREE_FILE_VERSION$1 = 1;
async function parse3DTilesSubtree$1(data2, options2, context2) {
  const magic = new Uint32Array(data2.slice(0, 4));
  if (magic[0] !== SUBTREE_FILE_MAGIC$1) {
    throw new Error("Wrong subtree file magic number");
  }
  const version2 = new Uint32Array(data2.slice(4, 8));
  if (version2[0] !== SUBTREE_FILE_VERSION$1) {
    throw new Error("Wrong subtree file verson, must be 1");
  }
  const jsonByteLength = parseUint64Value$1(data2.slice(8, 16));
  const stringAttribute = new Uint8Array(data2, 24, jsonByteLength);
  const textDecoder = new TextDecoder("utf8");
  const string3 = textDecoder.decode(stringAttribute);
  const subtree = JSON.parse(string3);
  const binaryByteLength = parseUint64Value$1(data2.slice(16, 24));
  let internalBinaryBuffer = new ArrayBuffer(0);
  if (binaryByteLength) {
    internalBinaryBuffer = data2.slice(24 + jsonByteLength);
  }
  await loadExplicitBitstream$1(subtree, subtree.tileAvailability, internalBinaryBuffer, context2);
  if (Array.isArray(subtree.contentAvailability)) {
    for (const contentAvailability of subtree.contentAvailability) {
      await loadExplicitBitstream$1(subtree, contentAvailability, internalBinaryBuffer, context2);
    }
  } else {
    await loadExplicitBitstream$1(subtree, subtree.contentAvailability, internalBinaryBuffer, context2);
  }
  await loadExplicitBitstream$1(subtree, subtree.childSubtreeAvailability, internalBinaryBuffer, context2);
  return subtree;
}
async function loadExplicitBitstream$1(subtree, availabilityObject, internalBinaryBuffer, context2) {
  const bufferViewIndex = Number.isFinite(availabilityObject.bitstream) ? availabilityObject.bitstream : availabilityObject.bufferView;
  if (typeof bufferViewIndex !== "number") {
    return;
  }
  const bufferView = subtree.bufferViews[bufferViewIndex];
  const buffer3 = subtree.buffers[bufferView.buffer];
  if (!(context2 == null ? void 0 : context2.baseUrl)) {
    throw new Error("Url is not provided");
  }
  if (!context2.fetch) {
    throw new Error("fetch is not provided");
  }
  if (buffer3.uri) {
    const bufferUri = `${(context2 == null ? void 0 : context2.baseUrl) || ""}/${buffer3.uri}`;
    const response = await context2.fetch(bufferUri);
    const data2 = await response.arrayBuffer();
    availabilityObject.explicitBitstream = new Uint8Array(data2, bufferView.byteOffset, bufferView.byteLength);
    return;
  }
  const bufferStart = subtree.buffers.slice(0, bufferView.buffer).reduce((offset, buf) => offset + buf.byteLength, 0);
  availabilityObject.explicitBitstream = new Uint8Array(internalBinaryBuffer.slice(bufferStart, bufferStart + buffer3.byteLength), bufferView.byteOffset, bufferView.byteLength);
}
function parseUint64Value$1(buffer3) {
  const dataView = new DataView(buffer3);
  const left = dataView.getUint32(0, true);
  const right = dataView.getUint32(4, true);
  return left + 2 ** 32 * right;
}
const Tile3DSubtreeLoader$1 = {
  dataType: null,
  batchType: null,
  id: "3d-tiles-subtree",
  name: "3D Tiles Subtree",
  module: "3d-tiles",
  version: VERSION$7,
  extensions: ["subtree"],
  mimeTypes: ["application/octet-stream"],
  tests: ["subtree"],
  parse: parse3DTilesSubtree$1,
  options: {}
};
/**
 * @license
 * Copyright 2009 The Closure Library Authors
 * Copyright 2020 Daniel Wirtz / The long.js Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var wasm$1 = null;
try {
  wasm$1 = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch (e3) {
}
function Long$1(low, high, unsigned) {
  this.low = low | 0;
  this.high = high | 0;
  this.unsigned = !!unsigned;
}
Long$1.prototype.__isLong__;
Object.defineProperty(Long$1.prototype, "__isLong__", { value: true });
function isLong$1(obj) {
  return (obj && obj["__isLong__"]) === true;
}
function ctz32$1(value) {
  var c2 = Math.clz32(value & -value);
  return value ? 31 - c2 : c2;
}
Long$1.isLong = isLong$1;
var INT_CACHE$1 = {};
var UINT_CACHE$1 = {};
function fromInt$1(value, unsigned) {
  var obj, cachedObj, cache2;
  if (unsigned) {
    value >>>= 0;
    if (cache2 = 0 <= value && value < 256) {
      cachedObj = UINT_CACHE$1[value];
      if (cachedObj)
        return cachedObj;
    }
    obj = fromBits$1(value, 0, true);
    if (cache2)
      UINT_CACHE$1[value] = obj;
    return obj;
  } else {
    value |= 0;
    if (cache2 = -128 <= value && value < 128) {
      cachedObj = INT_CACHE$1[value];
      if (cachedObj)
        return cachedObj;
    }
    obj = fromBits$1(value, value < 0 ? -1 : 0, false);
    if (cache2)
      INT_CACHE$1[value] = obj;
    return obj;
  }
}
Long$1.fromInt = fromInt$1;
function fromNumber$1(value, unsigned) {
  if (isNaN(value))
    return unsigned ? UZERO$1 : ZERO$1;
  if (unsigned) {
    if (value < 0)
      return UZERO$1;
    if (value >= TWO_PWR_64_DBL$1)
      return MAX_UNSIGNED_VALUE$1;
  } else {
    if (value <= -TWO_PWR_63_DBL$1)
      return MIN_VALUE$1;
    if (value + 1 >= TWO_PWR_63_DBL$1)
      return MAX_VALUE$1;
  }
  if (value < 0)
    return fromNumber$1(-value, unsigned).neg();
  return fromBits$1(value % TWO_PWR_32_DBL$1 | 0, value / TWO_PWR_32_DBL$1 | 0, unsigned);
}
Long$1.fromNumber = fromNumber$1;
function fromBits$1(lowBits, highBits, unsigned) {
  return new Long$1(lowBits, highBits, unsigned);
}
Long$1.fromBits = fromBits$1;
var pow_dbl$1 = Math.pow;
function fromString$1(str, unsigned, radix) {
  if (str.length === 0)
    throw Error("empty string");
  if (typeof unsigned === "number") {
    radix = unsigned;
    unsigned = false;
  } else {
    unsigned = !!unsigned;
  }
  if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
    return unsigned ? UZERO$1 : ZERO$1;
  radix = radix || 10;
  if (radix < 2 || 36 < radix)
    throw RangeError("radix");
  var p2;
  if ((p2 = str.indexOf("-")) > 0)
    throw Error("interior hyphen");
  else if (p2 === 0) {
    return fromString$1(str.substring(1), unsigned, radix).neg();
  }
  var radixToPower = fromNumber$1(pow_dbl$1(radix, 8));
  var result = ZERO$1;
  for (var i2 = 0; i2 < str.length; i2 += 8) {
    var size12 = Math.min(8, str.length - i2), value = parseInt(str.substring(i2, i2 + size12), radix);
    if (size12 < 8) {
      var power = fromNumber$1(pow_dbl$1(radix, size12));
      result = result.mul(power).add(fromNumber$1(value));
    } else {
      result = result.mul(radixToPower);
      result = result.add(fromNumber$1(value));
    }
  }
  result.unsigned = unsigned;
  return result;
}
Long$1.fromString = fromString$1;
function fromValue$1(val, unsigned) {
  if (typeof val === "number")
    return fromNumber$1(val, unsigned);
  if (typeof val === "string")
    return fromString$1(val, unsigned);
  return fromBits$1(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
Long$1.fromValue = fromValue$1;
var TWO_PWR_16_DBL$1 = 1 << 16;
var TWO_PWR_24_DBL$1 = 1 << 24;
var TWO_PWR_32_DBL$1 = TWO_PWR_16_DBL$1 * TWO_PWR_16_DBL$1;
var TWO_PWR_64_DBL$1 = TWO_PWR_32_DBL$1 * TWO_PWR_32_DBL$1;
var TWO_PWR_63_DBL$1 = TWO_PWR_64_DBL$1 / 2;
var TWO_PWR_24$1 = fromInt$1(TWO_PWR_24_DBL$1);
var ZERO$1 = fromInt$1(0);
Long$1.ZERO = ZERO$1;
var UZERO$1 = fromInt$1(0, true);
Long$1.UZERO = UZERO$1;
var ONE$1 = fromInt$1(1);
Long$1.ONE = ONE$1;
var UONE$1 = fromInt$1(1, true);
Long$1.UONE = UONE$1;
var NEG_ONE$1 = fromInt$1(-1);
Long$1.NEG_ONE = NEG_ONE$1;
var MAX_VALUE$1 = fromBits$1(4294967295 | 0, 2147483647 | 0, false);
Long$1.MAX_VALUE = MAX_VALUE$1;
var MAX_UNSIGNED_VALUE$1 = fromBits$1(4294967295 | 0, 4294967295 | 0, true);
Long$1.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE$1;
var MIN_VALUE$1 = fromBits$1(0, 2147483648 | 0, false);
Long$1.MIN_VALUE = MIN_VALUE$1;
var LongPrototype$1 = Long$1.prototype;
LongPrototype$1.toInt = function toInt() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype$1.toNumber = function toNumber2() {
  if (this.unsigned)
    return (this.high >>> 0) * TWO_PWR_32_DBL$1 + (this.low >>> 0);
  return this.high * TWO_PWR_32_DBL$1 + (this.low >>> 0);
};
LongPrototype$1.toString = function toString27(radix) {
  radix = radix || 10;
  if (radix < 2 || 36 < radix)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative()) {
    if (this.eq(MIN_VALUE$1)) {
      var radixLong = fromNumber$1(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
      return div.toString(radix) + rem1.toInt().toString(radix);
    } else
      return "-" + this.neg().toString(radix);
  }
  var radixToPower = fromNumber$1(pow_dbl$1(radix, 6), this.unsigned), rem = this;
  var result = "";
  while (true) {
    var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
    rem = remDiv;
    if (rem.isZero())
      return digits + result;
    else {
      while (digits.length < 6)
        digits = "0" + digits;
      result = "" + digits + result;
    }
  }
};
LongPrototype$1.getHighBits = function getHighBits() {
  return this.high;
};
LongPrototype$1.getHighBitsUnsigned = function getHighBitsUnsigned() {
  return this.high >>> 0;
};
LongPrototype$1.getLowBits = function getLowBits() {
  return this.low;
};
LongPrototype$1.getLowBitsUnsigned = function getLowBitsUnsigned() {
  return this.low >>> 0;
};
LongPrototype$1.getNumBitsAbs = function getNumBitsAbs() {
  if (this.isNegative())
    return this.eq(MIN_VALUE$1) ? 64 : this.neg().getNumBitsAbs();
  var val = this.high != 0 ? this.high : this.low;
  for (var bit = 31; bit > 0; bit--)
    if ((val & 1 << bit) != 0)
      break;
  return this.high != 0 ? bit + 33 : bit + 1;
};
LongPrototype$1.isZero = function isZero2() {
  return this.high === 0 && this.low === 0;
};
LongPrototype$1.eqz = LongPrototype$1.isZero;
LongPrototype$1.isNegative = function isNegative2() {
  return !this.unsigned && this.high < 0;
};
LongPrototype$1.isPositive = function isPositive2() {
  return this.unsigned || this.high >= 0;
};
LongPrototype$1.isOdd = function isOdd() {
  return (this.low & 1) === 1;
};
LongPrototype$1.isEven = function isEven() {
  return (this.low & 1) === 0;
};
LongPrototype$1.equals = function equals10(other) {
  if (!isLong$1(other))
    other = fromValue$1(other);
  if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1)
    return false;
  return this.high === other.high && this.low === other.low;
};
LongPrototype$1.eq = LongPrototype$1.equals;
LongPrototype$1.notEquals = function notEquals(other) {
  return !this.eq(
    /* validates */
    other
  );
};
LongPrototype$1.neq = LongPrototype$1.notEquals;
LongPrototype$1.ne = LongPrototype$1.notEquals;
LongPrototype$1.lessThan = function lessThan(other) {
  return this.comp(
    /* validates */
    other
  ) < 0;
};
LongPrototype$1.lt = LongPrototype$1.lessThan;
LongPrototype$1.lessThanOrEqual = function lessThanOrEqual(other) {
  return this.comp(
    /* validates */
    other
  ) <= 0;
};
LongPrototype$1.lte = LongPrototype$1.lessThanOrEqual;
LongPrototype$1.le = LongPrototype$1.lessThanOrEqual;
LongPrototype$1.greaterThan = function greaterThan(other) {
  return this.comp(
    /* validates */
    other
  ) > 0;
};
LongPrototype$1.gt = LongPrototype$1.greaterThan;
LongPrototype$1.greaterThanOrEqual = function greaterThanOrEqual(other) {
  return this.comp(
    /* validates */
    other
  ) >= 0;
};
LongPrototype$1.gte = LongPrototype$1.greaterThanOrEqual;
LongPrototype$1.ge = LongPrototype$1.greaterThanOrEqual;
LongPrototype$1.compare = function compare10(other) {
  if (!isLong$1(other))
    other = fromValue$1(other);
  if (this.eq(other))
    return 0;
  var thisNeg = this.isNegative(), otherNeg = other.isNegative();
  if (thisNeg && !otherNeg)
    return -1;
  if (!thisNeg && otherNeg)
    return 1;
  if (!this.unsigned)
    return this.sub(other).isNegative() ? -1 : 1;
  return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
LongPrototype$1.comp = LongPrototype$1.compare;
LongPrototype$1.negate = function negate3() {
  if (!this.unsigned && this.eq(MIN_VALUE$1))
    return MIN_VALUE$1;
  return this.not().add(ONE$1);
};
LongPrototype$1.neg = LongPrototype$1.negate;
LongPrototype$1.add = function add16(addend) {
  if (!isLong$1(addend))
    addend = fromValue$1(addend);
  var a48 = this.high >>> 16;
  var a32 = this.high & 65535;
  var a16 = this.low >>> 16;
  var a00 = this.low & 65535;
  var b48 = addend.high >>> 16;
  var b32 = addend.high & 65535;
  var b16 = addend.low >>> 16;
  var b00 = addend.low & 65535;
  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 + b00;
  c16 += c00 >>> 16;
  c00 &= 65535;
  c16 += a16 + b16;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c32 += a32 + b32;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c48 += a48 + b48;
  c48 &= 65535;
  return fromBits$1(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
LongPrototype$1.subtract = function subtract3(subtrahend) {
  if (!isLong$1(subtrahend))
    subtrahend = fromValue$1(subtrahend);
  return this.add(subtrahend.neg());
};
LongPrototype$1.sub = LongPrototype$1.subtract;
LongPrototype$1.multiply = function multiply3(multiplier) {
  if (this.isZero())
    return this;
  if (!isLong$1(multiplier))
    multiplier = fromValue$1(multiplier);
  if (wasm$1) {
    var low = wasm$1["mul"](
      this.low,
      this.high,
      multiplier.low,
      multiplier.high
    );
    return fromBits$1(low, wasm$1["get_high"](), this.unsigned);
  }
  if (multiplier.isZero())
    return this.unsigned ? UZERO$1 : ZERO$1;
  if (this.eq(MIN_VALUE$1))
    return multiplier.isOdd() ? MIN_VALUE$1 : ZERO$1;
  if (multiplier.eq(MIN_VALUE$1))
    return this.isOdd() ? MIN_VALUE$1 : ZERO$1;
  if (this.isNegative()) {
    if (multiplier.isNegative())
      return this.neg().mul(multiplier.neg());
    else
      return this.neg().mul(multiplier).neg();
  } else if (multiplier.isNegative())
    return this.mul(multiplier.neg()).neg();
  if (this.lt(TWO_PWR_24$1) && multiplier.lt(TWO_PWR_24$1))
    return fromNumber$1(this.toNumber() * multiplier.toNumber(), this.unsigned);
  var a48 = this.high >>> 16;
  var a32 = this.high & 65535;
  var a16 = this.low >>> 16;
  var a00 = this.low & 65535;
  var b48 = multiplier.high >>> 16;
  var b32 = multiplier.high & 65535;
  var b16 = multiplier.low >>> 16;
  var b00 = multiplier.low & 65535;
  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 * b00;
  c16 += c00 >>> 16;
  c00 &= 65535;
  c16 += a16 * b00;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c16 += a00 * b16;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c32 += a32 * b00;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c32 += a16 * b16;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c32 += a00 * b32;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
  c48 &= 65535;
  return fromBits$1(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
LongPrototype$1.mul = LongPrototype$1.multiply;
LongPrototype$1.divide = function divide2(divisor) {
  if (!isLong$1(divisor))
    divisor = fromValue$1(divisor);
  if (divisor.isZero())
    throw Error("division by zero");
  if (wasm$1) {
    if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) {
      return this;
    }
    var low = (this.unsigned ? wasm$1["div_u"] : wasm$1["div_s"])(
      this.low,
      this.high,
      divisor.low,
      divisor.high
    );
    return fromBits$1(low, wasm$1["get_high"](), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO$1 : ZERO$1;
  var approx, rem, res;
  if (!this.unsigned) {
    if (this.eq(MIN_VALUE$1)) {
      if (divisor.eq(ONE$1) || divisor.eq(NEG_ONE$1))
        return MIN_VALUE$1;
      else if (divisor.eq(MIN_VALUE$1))
        return ONE$1;
      else {
        var halfThis = this.shr(1);
        approx = halfThis.div(divisor).shl(1);
        if (approx.eq(ZERO$1)) {
          return divisor.isNegative() ? ONE$1 : NEG_ONE$1;
        } else {
          rem = this.sub(divisor.mul(approx));
          res = approx.add(rem.div(divisor));
          return res;
        }
      }
    } else if (divisor.eq(MIN_VALUE$1))
      return this.unsigned ? UZERO$1 : ZERO$1;
    if (this.isNegative()) {
      if (divisor.isNegative())
        return this.neg().div(divisor.neg());
      return this.neg().div(divisor).neg();
    } else if (divisor.isNegative())
      return this.div(divisor.neg()).neg();
    res = ZERO$1;
  } else {
    if (!divisor.unsigned)
      divisor = divisor.toUnsigned();
    if (divisor.gt(this))
      return UZERO$1;
    if (divisor.gt(this.shru(1)))
      return UONE$1;
    res = UZERO$1;
  }
  rem = this;
  while (rem.gte(divisor)) {
    approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
    var log22 = Math.ceil(Math.log(approx) / Math.LN2), delta = log22 <= 48 ? 1 : pow_dbl$1(2, log22 - 48), approxRes = fromNumber$1(approx), approxRem = approxRes.mul(divisor);
    while (approxRem.isNegative() || approxRem.gt(rem)) {
      approx -= delta;
      approxRes = fromNumber$1(approx, this.unsigned);
      approxRem = approxRes.mul(divisor);
    }
    if (approxRes.isZero())
      approxRes = ONE$1;
    res = res.add(approxRes);
    rem = rem.sub(approxRem);
  }
  return res;
};
LongPrototype$1.div = LongPrototype$1.divide;
LongPrototype$1.modulo = function modulo(divisor) {
  if (!isLong$1(divisor))
    divisor = fromValue$1(divisor);
  if (wasm$1) {
    var low = (this.unsigned ? wasm$1["rem_u"] : wasm$1["rem_s"])(
      this.low,
      this.high,
      divisor.low,
      divisor.high
    );
    return fromBits$1(low, wasm$1["get_high"](), this.unsigned);
  }
  return this.sub(this.div(divisor).mul(divisor));
};
LongPrototype$1.mod = LongPrototype$1.modulo;
LongPrototype$1.rem = LongPrototype$1.modulo;
LongPrototype$1.not = function not2() {
  return fromBits$1(~this.low, ~this.high, this.unsigned);
};
LongPrototype$1.countLeadingZeros = function countLeadingZeros() {
  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
LongPrototype$1.clz = LongPrototype$1.countLeadingZeros;
LongPrototype$1.countTrailingZeros = function countTrailingZeros() {
  return this.low ? ctz32$1(this.low) : ctz32$1(this.high) + 32;
};
LongPrototype$1.ctz = LongPrototype$1.countTrailingZeros;
LongPrototype$1.and = function and(other) {
  if (!isLong$1(other))
    other = fromValue$1(other);
  return fromBits$1(this.low & other.low, this.high & other.high, this.unsigned);
};
LongPrototype$1.or = function or(other) {
  if (!isLong$1(other))
    other = fromValue$1(other);
  return fromBits$1(this.low | other.low, this.high | other.high, this.unsigned);
};
LongPrototype$1.xor = function xor(other) {
  if (!isLong$1(other))
    other = fromValue$1(other);
  return fromBits$1(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
LongPrototype$1.shiftLeft = function shiftLeft(numBits) {
  if (isLong$1(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  else if (numBits < 32)
    return fromBits$1(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
  else
    return fromBits$1(0, this.low << numBits - 32, this.unsigned);
};
LongPrototype$1.shl = LongPrototype$1.shiftLeft;
LongPrototype$1.shiftRight = function shiftRight(numBits) {
  if (isLong$1(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  else if (numBits < 32)
    return fromBits$1(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
  else
    return fromBits$1(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype$1.shr = LongPrototype$1.shiftRight;
LongPrototype$1.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
  if (isLong$1(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  if (numBits < 32)
    return fromBits$1(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
  if (numBits === 32)
    return fromBits$1(this.high, 0, this.unsigned);
  return fromBits$1(this.high >>> numBits - 32, 0, this.unsigned);
};
LongPrototype$1.shru = LongPrototype$1.shiftRightUnsigned;
LongPrototype$1.shr_u = LongPrototype$1.shiftRightUnsigned;
LongPrototype$1.rotateLeft = function rotateLeft(numBits) {
  var b2;
  if (isLong$1(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  if (numBits === 32)
    return fromBits$1(this.high, this.low, this.unsigned);
  if (numBits < 32) {
    b2 = 32 - numBits;
    return fromBits$1(this.low << numBits | this.high >>> b2, this.high << numBits | this.low >>> b2, this.unsigned);
  }
  numBits -= 32;
  b2 = 32 - numBits;
  return fromBits$1(this.high << numBits | this.low >>> b2, this.low << numBits | this.high >>> b2, this.unsigned);
};
LongPrototype$1.rotl = LongPrototype$1.rotateLeft;
LongPrototype$1.rotateRight = function rotateRight(numBits) {
  var b2;
  if (isLong$1(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  if (numBits === 32)
    return fromBits$1(this.high, this.low, this.unsigned);
  if (numBits < 32) {
    b2 = 32 - numBits;
    return fromBits$1(this.high << b2 | this.low >>> numBits, this.low << b2 | this.high >>> numBits, this.unsigned);
  }
  numBits -= 32;
  b2 = 32 - numBits;
  return fromBits$1(this.low << b2 | this.high >>> numBits, this.high << b2 | this.low >>> numBits, this.unsigned);
};
LongPrototype$1.rotr = LongPrototype$1.rotateRight;
LongPrototype$1.toSigned = function toSigned() {
  if (!this.unsigned)
    return this;
  return fromBits$1(this.low, this.high, false);
};
LongPrototype$1.toUnsigned = function toUnsigned() {
  if (this.unsigned)
    return this;
  return fromBits$1(this.low, this.high, true);
};
LongPrototype$1.toBytes = function toBytes(le2) {
  return le2 ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype$1.toBytesLE = function toBytesLE() {
  var hi = this.high, lo = this.low;
  return [
    lo & 255,
    lo >>> 8 & 255,
    lo >>> 16 & 255,
    lo >>> 24,
    hi & 255,
    hi >>> 8 & 255,
    hi >>> 16 & 255,
    hi >>> 24
  ];
};
LongPrototype$1.toBytesBE = function toBytesBE() {
  var hi = this.high, lo = this.low;
  return [
    hi >>> 24,
    hi >>> 16 & 255,
    hi >>> 8 & 255,
    hi & 255,
    lo >>> 24,
    lo >>> 16 & 255,
    lo >>> 8 & 255,
    lo & 255
  ];
};
Long$1.fromBytes = function fromBytes(bytes, unsigned, le2) {
  return le2 ? Long$1.fromBytesLE(bytes, unsigned) : Long$1.fromBytesBE(bytes, unsigned);
};
Long$1.fromBytesLE = function fromBytesLE(bytes, unsigned) {
  return new Long$1(
    bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24,
    bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24,
    unsigned
  );
};
Long$1.fromBytesBE = function fromBytesBE(bytes, unsigned) {
  return new Long$1(
    bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7],
    bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3],
    unsigned
  );
};
const MAXIMUM_TOKEN_LENGTH$1 = 16;
function getS2CellIdFromToken$1(token) {
  if (token === "X") {
    token = "";
  }
  const paddedToken = token.padEnd(MAXIMUM_TOKEN_LENGTH$1, "0");
  return Long$1.fromString(paddedToken, true, 16);
}
function getS2TokenFromCellId$1(cellId) {
  if (cellId.isZero()) {
    return "X";
  }
  let numZeroDigits = cellId.countTrailingZeros();
  const remainder = numZeroDigits % 4;
  numZeroDigits = (numZeroDigits - remainder) / 4;
  const trailingZeroHexChars = numZeroDigits;
  numZeroDigits *= 4;
  const x2 = cellId.shiftRightUnsigned(numZeroDigits);
  const hexString = x2.toString(16).replace(/0+$/, "");
  const zeroString = Array(17 - trailingZeroHexChars - hexString.length).join("0");
  return zeroString + hexString;
}
function getS2ChildCellId$1(cellId, index2) {
  const newLsb = lsb$1(cellId).shiftRightUnsigned(2);
  const childCellId = cellId.add(Long$1.fromNumber(2 * index2 + 1 - 4).multiply(newLsb));
  return childCellId;
}
function lsb$1(cellId) {
  return cellId.and(cellId.not().add(1));
}
const FACE_BITS$1 = 3;
const MAX_LEVEL$1 = 30;
const POS_BITS$1 = 2 * MAX_LEVEL$1 + 1;
const RADIAN_TO_DEGREE$1 = 180 / Math.PI;
function getS2CellFromQuadKey$1(hilbertQuadkey) {
  if (hilbertQuadkey.length === 0) {
    throw new Error(`Invalid Hilbert quad key ${hilbertQuadkey}`);
  }
  const parts = hilbertQuadkey.split("/");
  const face = parseInt(parts[0], 10);
  const position = parts[1];
  const maxLevel = position.length;
  let level = 0;
  const point4 = [0, 0];
  for (let i2 = maxLevel - 1; i2 >= 0; i2--) {
    level = maxLevel - i2;
    const bit = position[i2];
    let rx = 0;
    let ry = 0;
    if (bit === "1") {
      ry = 1;
    } else if (bit === "2") {
      rx = 1;
      ry = 1;
    } else if (bit === "3") {
      rx = 1;
    }
    const val = Math.pow(2, level - 1);
    rotateAndFlipQuadrant$1(val, point4, rx, ry);
    point4[0] += val * rx;
    point4[1] += val * ry;
  }
  if (face % 2 === 1) {
    const t2 = point4[0];
    point4[0] = point4[1];
    point4[1] = t2;
  }
  return { face, ij: point4, level };
}
function getS2QuadkeyFromCellId$1(cellId) {
  if (cellId.isZero()) {
    return "";
  }
  let bin = cellId.toString(2);
  while (bin.length < FACE_BITS$1 + POS_BITS$1) {
    bin = "0" + bin;
  }
  const lsbIndex = bin.lastIndexOf("1");
  const faceB = bin.substring(0, 3);
  const posB = bin.substring(3, lsbIndex);
  const levelN = posB.length / 2;
  const faceS = Long$1.fromString(faceB, true, 2).toString(10);
  let posS = "";
  if (levelN !== 0) {
    posS = Long$1.fromString(posB, true, 2).toString(4);
    while (posS.length < levelN) {
      posS = "0" + posS;
    }
  }
  return `${faceS}/${posS}`;
}
function IJToST$1(ij, level, offsets) {
  const maxSize = 1 << level;
  return [(ij[0] + offsets[0]) / maxSize, (ij[1] + offsets[1]) / maxSize];
}
function singleSTtoUV$1(st) {
  if (st >= 0.5) {
    return 1 / 3 * (4 * st * st - 1);
  }
  return 1 / 3 * (1 - 4 * (1 - st) * (1 - st));
}
function STToUV$1(st) {
  return [singleSTtoUV$1(st[0]), singleSTtoUV$1(st[1])];
}
function FaceUVToXYZ$1(face, [u2, v5]) {
  switch (face) {
    case 0:
      return [1, u2, v5];
    case 1:
      return [-u2, 1, v5];
    case 2:
      return [-u2, -v5, 1];
    case 3:
      return [-1, -v5, -u2];
    case 4:
      return [v5, -1, -u2];
    case 5:
      return [v5, u2, -1];
    default:
      throw new Error("Invalid face");
  }
}
function XYZToLngLat$1([x2, y2, z2]) {
  const lat = Math.atan2(z2, Math.sqrt(x2 * x2 + y2 * y2));
  const lng = Math.atan2(y2, x2);
  return [lng * RADIAN_TO_DEGREE$1, lat * RADIAN_TO_DEGREE$1];
}
function rotateAndFlipQuadrant$1(n2, point4, rx, ry) {
  if (ry === 0) {
    if (rx === 1) {
      point4[0] = n2 - 1 - point4[0];
      point4[1] = n2 - 1 - point4[1];
    }
    const x2 = point4[0];
    point4[0] = point4[1];
    point4[1] = x2;
  }
}
function getS2LngLatFromS2Cell$1(s2Cell) {
  const st = IJToST$1(s2Cell.ij, s2Cell.level, [0.5, 0.5]);
  const uv = STToUV$1(st);
  const xyz = FaceUVToXYZ$1(s2Cell.face, uv);
  return XYZToLngLat$1(xyz);
}
const MAX_RESOLUTION$1 = 100;
function getS2BoundaryFlatFromS2Cell$1(s2cell) {
  const { face, ij, level } = s2cell;
  const offsets = [
    [0, 0],
    [0, 1],
    [1, 1],
    [1, 0],
    [0, 0]
  ];
  const resolution = Math.max(1, Math.ceil(MAX_RESOLUTION$1 * Math.pow(2, -level)));
  const result = new Float64Array(4 * resolution * 2 + 2);
  let ptIndex = 0;
  let prevLng = 0;
  for (let i2 = 0; i2 < 4; i2++) {
    const offset = offsets[i2].slice(0);
    const nextOffset = offsets[i2 + 1];
    const stepI = (nextOffset[0] - offset[0]) / resolution;
    const stepJ = (nextOffset[1] - offset[1]) / resolution;
    for (let j2 = 0; j2 < resolution; j2++) {
      offset[0] += stepI;
      offset[1] += stepJ;
      const st = IJToST$1(ij, level, offset);
      const uv = STToUV$1(st);
      const xyz = FaceUVToXYZ$1(face, uv);
      const lngLat = XYZToLngLat$1(xyz);
      if (Math.abs(lngLat[1]) > 89.999) {
        lngLat[0] = prevLng;
      }
      const deltaLng = lngLat[0] - prevLng;
      lngLat[0] += deltaLng > 180 ? -360 : deltaLng < -180 ? 360 : 0;
      result[ptIndex++] = lngLat[0];
      result[ptIndex++] = lngLat[1];
      prevLng = lngLat[0];
    }
  }
  result[ptIndex++] = result[0];
  result[ptIndex++] = result[1];
  return result;
}
function getS2Cell$1(tokenOrKey) {
  const key = getS2QuadKey$1(tokenOrKey);
  const s2cell = getS2CellFromQuadKey$1(key);
  return s2cell;
}
function getS2QuadKey$1(tokenOrKey) {
  if (tokenOrKey.indexOf("/") > 0) {
    return tokenOrKey;
  }
  const id = getS2CellIdFromToken$1(tokenOrKey);
  return getS2QuadkeyFromCellId$1(id);
}
function getS2LngLat$1(s2Token) {
  const s2cell = getS2Cell$1(s2Token);
  return getS2LngLatFromS2Cell$1(s2cell);
}
function getS2Region$1(s2cell) {
  let region;
  if (s2cell.face === 2 || s2cell.face === 5) {
    let corners = null;
    let len2 = 0;
    for (let i2 = 0; i2 < 4; i2++) {
      const key = `${s2cell.face}/${i2}`;
      const cell = getS2Cell$1(key);
      const corns = getS2BoundaryFlatFromS2Cell$1(cell);
      if (typeof corners === "undefined" || corners === null)
        corners = new Float64Array(4 * corns.length);
      corners.set(corns, len2);
      len2 += corns.length;
    }
    region = get2DRegionFromS2Corners$1(corners);
  } else {
    const corners = getS2BoundaryFlatFromS2Cell$1(s2cell);
    region = get2DRegionFromS2Corners$1(corners);
  }
  return region;
}
function get2DRegionFromS2Corners$1(corners) {
  if (corners.length % 2 !== 0) {
    throw new Error("Invalid corners");
  }
  const longitudes = [];
  const latitudes = [];
  for (let i2 = 0; i2 < corners.length; i2 += 2) {
    longitudes.push(corners[i2]);
    latitudes.push(corners[i2 + 1]);
  }
  longitudes.sort((a2, b2) => a2 - b2);
  latitudes.sort((a2, b2) => a2 - b2);
  return {
    west: longitudes[0],
    east: longitudes[longitudes.length - 1],
    north: latitudes[latitudes.length - 1],
    south: latitudes[0]
  };
}
function getS2OrientedBoundingBoxCornerPoints$1(tokenOrKey, heightInfo) {
  const min4 = (heightInfo == null ? void 0 : heightInfo.minimumHeight) || 0;
  const max3 = (heightInfo == null ? void 0 : heightInfo.maximumHeight) || 0;
  const s2cell = getS2Cell$1(tokenOrKey);
  const region = getS2Region$1(s2cell);
  const W2 = region.west;
  const S2 = region.south;
  const E3 = region.east;
  const N2 = region.north;
  const points2 = [];
  points2.push(new Vector3(W2, N2, min4));
  points2.push(new Vector3(E3, N2, min4));
  points2.push(new Vector3(E3, S2, min4));
  points2.push(new Vector3(W2, S2, min4));
  points2.push(new Vector3(W2, N2, max3));
  points2.push(new Vector3(E3, N2, max3));
  points2.push(new Vector3(E3, S2, max3));
  points2.push(new Vector3(W2, S2, max3));
  return points2;
}
function convertS2BoundingVolumetoOBB$1(s2VolumeInfo) {
  const token = s2VolumeInfo.token;
  const heightInfo = {
    minimumHeight: s2VolumeInfo.minimumHeight,
    maximumHeight: s2VolumeInfo.maximumHeight
  };
  const corners = getS2OrientedBoundingBoxCornerPoints$1(token, heightInfo);
  const center2 = getS2LngLat$1(token);
  const centerLng = center2[0];
  const centerLat = center2[1];
  const point4 = Ellipsoid.WGS84.cartographicToCartesian([
    centerLng,
    centerLat,
    heightInfo.maximumHeight
  ]);
  const centerPointAdditional = new Vector3(point4[0], point4[1], point4[2]);
  corners.push(centerPointAdditional);
  const obb = makeOrientedBoundingBoxFromPoints(corners);
  const box = [...obb.center, ...obb.halfAxes];
  return box;
}
const QUADTREE_DIVISION_COUNT$1 = 4;
const OCTREE_DIVISION_COUNT$1 = 8;
const SUBDIVISION_COUNT_MAP$1 = {
  QUADTREE: QUADTREE_DIVISION_COUNT$1,
  OCTREE: OCTREE_DIVISION_COUNT$1
};
function getChildS2VolumeBox$1(s2VolumeBox, index2, subdivisionScheme) {
  if (s2VolumeBox == null ? void 0 : s2VolumeBox.box) {
    const cellId = getS2CellIdFromToken$1(s2VolumeBox.s2VolumeInfo.token);
    const childCellId = getS2ChildCellId$1(cellId, index2);
    const childToken = getS2TokenFromCellId$1(childCellId);
    const s2ChildVolumeInfo = { ...s2VolumeBox.s2VolumeInfo };
    s2ChildVolumeInfo.token = childToken;
    switch (subdivisionScheme) {
      case "OCTREE":
        const s2VolumeInfo = s2VolumeBox.s2VolumeInfo;
        const delta = s2VolumeInfo.maximumHeight - s2VolumeInfo.minimumHeight;
        const sizeZ = delta / 2;
        const midZ = s2VolumeInfo.minimumHeight + delta / 2;
        s2VolumeInfo.minimumHeight = midZ - sizeZ;
        s2VolumeInfo.maximumHeight = midZ + sizeZ;
        break;
    }
    const box = convertS2BoundingVolumetoOBB$1(s2ChildVolumeInfo);
    const childS2VolumeBox = {
      box,
      s2VolumeInfo: s2ChildVolumeInfo
    };
    return childS2VolumeBox;
  }
  return void 0;
}
async function parseImplicitTiles$1(params2) {
  const { implicitOptions, parentData = {
    mortonIndex: 0,
    x: 0,
    y: 0,
    z: 0
  }, childIndex = 0, s2VolumeBox, loaderOptions } = params2;
  let { subtree, level = 0, globalData = {
    level: 0,
    mortonIndex: 0,
    x: 0,
    y: 0,
    z: 0
  } } = params2;
  const { subdivisionScheme, subtreeLevels, maximumLevel, contentUrlTemplate, subtreesUriTemplate, basePath } = implicitOptions;
  const tile = { children: [], lodMetricValue: 0, contentUrl: "" };
  if (!maximumLevel) {
    log$3.once(`Missing 'maximumLevel' or 'availableLevels' property. The subtree ${contentUrlTemplate} won't be loaded...`);
    return tile;
  }
  const lev = level + globalData.level;
  if (lev > maximumLevel) {
    return tile;
  }
  const childrenPerTile = SUBDIVISION_COUNT_MAP$1[subdivisionScheme];
  const bitsPerTile = Math.log2(childrenPerTile);
  const childX = childIndex & 1;
  const childY = childIndex >> 1 & 1;
  const childZ = childIndex >> 2 & 1;
  const levelOffset = (childrenPerTile ** level - 1) / (childrenPerTile - 1);
  let childTileMortonIndex = concatBits$1(parentData.mortonIndex, childIndex, bitsPerTile);
  let tileAvailabilityIndex = levelOffset + childTileMortonIndex;
  let childTileX = concatBits$1(parentData.x, childX, 1);
  let childTileY = concatBits$1(parentData.y, childY, 1);
  let childTileZ = concatBits$1(parentData.z, childZ, 1);
  let isChildSubtreeAvailable = false;
  if (level >= subtreeLevels) {
    isChildSubtreeAvailable = getAvailabilityResult$1(subtree.childSubtreeAvailability, childTileMortonIndex);
  }
  const x2 = concatBits$1(globalData.x, childTileX, level);
  const y2 = concatBits$1(globalData.y, childTileY, level);
  const z2 = concatBits$1(globalData.z, childTileZ, level);
  if (isChildSubtreeAvailable) {
    const subtreePath = `${basePath}/${subtreesUriTemplate}`;
    const childSubtreeUrl = replaceContentUrlTemplate$1(subtreePath, lev, x2, y2, z2);
    const childSubtree = await load(childSubtreeUrl, Tile3DSubtreeLoader$1, loaderOptions);
    subtree = childSubtree;
    globalData = {
      mortonIndex: childTileMortonIndex,
      x: childTileX,
      y: childTileY,
      z: childTileZ,
      level
    };
    childTileMortonIndex = 0;
    tileAvailabilityIndex = 0;
    childTileX = 0;
    childTileY = 0;
    childTileZ = 0;
    level = 0;
  }
  const isTileAvailable = getAvailabilityResult$1(subtree.tileAvailability, tileAvailabilityIndex);
  if (!isTileAvailable) {
    return tile;
  }
  const isContentAvailable = getAvailabilityResult$1(subtree.contentAvailability, tileAvailabilityIndex);
  if (isContentAvailable) {
    tile.contentUrl = replaceContentUrlTemplate$1(contentUrlTemplate, lev, x2, y2, z2);
  }
  const childTileLevel = level + 1;
  const pData = { mortonIndex: childTileMortonIndex, x: childTileX, y: childTileY, z: childTileZ };
  for (let index2 = 0; index2 < childrenPerTile; index2++) {
    const childS2VolumeBox = getChildS2VolumeBox$1(s2VolumeBox, index2, subdivisionScheme);
    const childTileParsed = await parseImplicitTiles$1({
      subtree,
      implicitOptions,
      loaderOptions,
      parentData: pData,
      childIndex: index2,
      level: childTileLevel,
      globalData: { ...globalData },
      s2VolumeBox: childS2VolumeBox
    });
    if (childTileParsed.contentUrl || childTileParsed.children.length) {
      const globalLevel = lev + 1;
      const childCoordinates = { childTileX, childTileY, childTileZ };
      const formattedTile = formatTileData$1(childTileParsed, globalLevel, childCoordinates, implicitOptions, s2VolumeBox);
      tile.children.push(formattedTile);
    }
  }
  return tile;
}
function getAvailabilityResult$1(availabilityData, index2) {
  let availabilityObject;
  if (Array.isArray(availabilityData)) {
    availabilityObject = availabilityData[0];
    if (availabilityData.length > 1) {
      log$3.once('Not supported extension "3DTILES_multiple_contents" has been detected');
    }
  } else {
    availabilityObject = availabilityData;
  }
  if ("constant" in availabilityObject) {
    return Boolean(availabilityObject.constant);
  }
  if (availabilityObject.explicitBitstream) {
    return getBooleanValueFromBitstream$1(index2, availabilityObject.explicitBitstream);
  }
  return false;
}
function formatTileData$1(tile, level, childCoordinates, options2, s2VolumeBox) {
  const { basePath, refine, getRefine: getRefine2, lodMetricType, getTileType: getTileType2, rootLodMetricValue, rootBoundingVolume } = options2;
  const uri = tile.contentUrl && tile.contentUrl.replace(`${basePath}/`, "");
  const lodMetricValue = rootLodMetricValue / 2 ** level;
  const boundingVolume = (s2VolumeBox == null ? void 0 : s2VolumeBox.box) ? { box: s2VolumeBox.box } : rootBoundingVolume;
  const boundingVolumeForChildTile = calculateBoundingVolumeForChildTile$1(level, boundingVolume, childCoordinates);
  return {
    children: tile.children,
    contentUrl: tile.contentUrl,
    content: { uri },
    id: tile.contentUrl,
    refine: getRefine2(refine),
    type: getTileType2(tile),
    lodMetricType,
    lodMetricValue,
    geometricError: lodMetricValue,
    transform: tile.transform,
    boundingVolume: boundingVolumeForChildTile
  };
}
function calculateBoundingVolumeForChildTile$1(level, rootBoundingVolume, childCoordinates) {
  if (rootBoundingVolume.region) {
    const { childTileX, childTileY, childTileZ } = childCoordinates;
    const [west, south, east, north, minimumHeight, maximumHeight] = rootBoundingVolume.region;
    const boundingVolumesCount = 2 ** level;
    const sizeX = (east - west) / boundingVolumesCount;
    const sizeY = (north - south) / boundingVolumesCount;
    const sizeZ = (maximumHeight - minimumHeight) / boundingVolumesCount;
    const [childWest, childEast] = [west + sizeX * childTileX, west + sizeX * (childTileX + 1)];
    const [childSouth, childNorth] = [south + sizeY * childTileY, south + sizeY * (childTileY + 1)];
    const [childMinimumHeight, childMaximumHeight] = [
      minimumHeight + sizeZ * childTileZ,
      minimumHeight + sizeZ * (childTileZ + 1)
    ];
    return {
      region: [childWest, childSouth, childEast, childNorth, childMinimumHeight, childMaximumHeight]
    };
  }
  if (rootBoundingVolume.box) {
    return rootBoundingVolume;
  }
  throw new Error(`Unsupported bounding volume type ${JSON.stringify(rootBoundingVolume)}`);
}
function concatBits$1(higher, lower, shift) {
  return (higher << shift) + lower;
}
function replaceContentUrlTemplate$1(templateUrl, level, x2, y2, z2) {
  const mapUrl = generateMapUrl$1({ level, x: x2, y: y2, z: z2 });
  return templateUrl.replace(/{level}|{x}|{y}|{z}/gi, (matched) => mapUrl[matched]);
}
function generateMapUrl$1(items) {
  const mapUrl = {};
  for (const key in items) {
    mapUrl[`{${key}}`] = items[key];
  }
  return mapUrl;
}
function getBooleanValueFromBitstream$1(availabilityIndex, availabilityBuffer) {
  const byteIndex = Math.floor(availabilityIndex / 8);
  const bitIndex = availabilityIndex % 8;
  const bitValue = availabilityBuffer[byteIndex] >> bitIndex & 1;
  return bitValue === 1;
}
function getTileType$1(tile, tileContentUrl = "") {
  if (!tileContentUrl) {
    return TILE_TYPE$1.EMPTY;
  }
  const contentUrl = tileContentUrl.split("?")[0];
  const fileExtension = contentUrl.split(".").pop();
  switch (fileExtension) {
    case "pnts":
      return TILE_TYPE$1.POINTCLOUD;
    case "i3dm":
    case "b3dm":
    case "glb":
    case "gltf":
      return TILE_TYPE$1.SCENEGRAPH;
    default:
      return fileExtension || TILE_TYPE$1.EMPTY;
  }
}
function getRefine$1(refine) {
  switch (refine) {
    case "REPLACE":
    case "replace":
      return TILE_REFINEMENT$1.REPLACE;
    case "ADD":
    case "add":
      return TILE_REFINEMENT$1.ADD;
    default:
      return refine;
  }
}
function resolveUri$1(uri, basePath) {
  const urlSchemeRegex = /^[a-z][0-9a-z+.-]*:/i;
  if (urlSchemeRegex.test(basePath)) {
    const url2 = new URL(uri, `${basePath}/`);
    return decodeURI(url2.toString());
  } else if (uri.startsWith("/")) {
    return uri;
  }
  return resolve$2(basePath, uri);
}
function normalizeTileData$1(tile, basePath) {
  var _a3;
  if (!tile) {
    return null;
  }
  let tileContentUrl;
  if (tile.content) {
    const contentUri = tile.content.uri || ((_a3 = tile.content) == null ? void 0 : _a3.url);
    if (typeof contentUri !== "undefined") {
      tileContentUrl = resolveUri$1(contentUri, basePath);
    }
  }
  const tilePostprocessed = {
    ...tile,
    id: tileContentUrl,
    contentUrl: tileContentUrl,
    lodMetricType: LOD_METRIC_TYPE$1.GEOMETRIC_ERROR,
    lodMetricValue: tile.geometricError,
    transformMatrix: tile.transform,
    type: getTileType$1(tile, tileContentUrl),
    refine: getRefine$1(tile.refine)
  };
  return tilePostprocessed;
}
async function normalizeTileHeaders$1(tileset, basePath, options2) {
  let root2 = null;
  const rootImplicitTilingExtension = getImplicitTilingExtensionData$1(tileset.root);
  if (rootImplicitTilingExtension && tileset.root) {
    root2 = await normalizeImplicitTileHeaders$1(tileset.root, tileset, basePath, rootImplicitTilingExtension, options2);
  } else {
    root2 = normalizeTileData$1(tileset.root, basePath);
  }
  const stack2 = [];
  stack2.push(root2);
  while (stack2.length > 0) {
    const tile = stack2.pop() || {};
    const children = tile.children || [];
    const childrenPostprocessed = [];
    for (const childHeader of children) {
      const childImplicitTilingExtension = getImplicitTilingExtensionData$1(childHeader);
      let childHeaderPostprocessed;
      if (childImplicitTilingExtension) {
        childHeaderPostprocessed = await normalizeImplicitTileHeaders$1(childHeader, tileset, basePath, childImplicitTilingExtension, options2);
      } else {
        childHeaderPostprocessed = normalizeTileData$1(childHeader, basePath);
      }
      if (childHeaderPostprocessed) {
        childrenPostprocessed.push(childHeaderPostprocessed);
        stack2.push(childHeaderPostprocessed);
      }
    }
    tile.children = childrenPostprocessed;
  }
  return root2;
}
async function normalizeImplicitTileHeaders$1(tile, tileset, basePath, implicitTilingExtension, options2) {
  var _a3, _b3, _c2;
  const { subdivisionScheme, maximumLevel, availableLevels, subtreeLevels, subtrees: { uri: subtreesUriTemplate } } = implicitTilingExtension;
  const replacedUrlTemplate = replaceContentUrlTemplate$1(subtreesUriTemplate, 0, 0, 0, 0);
  const subtreeUrl = resolveUri$1(replacedUrlTemplate, basePath);
  const subtree = await load(subtreeUrl, Tile3DSubtreeLoader$1, options2);
  const tileContentUri = (_a3 = tile.content) == null ? void 0 : _a3.uri;
  const contentUrlTemplate = tileContentUri ? resolveUri$1(tileContentUri, basePath) : "";
  const refine = (_b3 = tileset == null ? void 0 : tileset.root) == null ? void 0 : _b3.refine;
  const rootLodMetricValue = tile.geometricError;
  const s2VolumeInfo = (_c2 = tile.boundingVolume.extensions) == null ? void 0 : _c2["3DTILES_bounding_volume_S2"];
  if (s2VolumeInfo) {
    const box = convertS2BoundingVolumetoOBB$1(s2VolumeInfo);
    const s2VolumeBox = { box, s2VolumeInfo };
    tile.boundingVolume = s2VolumeBox;
  }
  const rootBoundingVolume = tile.boundingVolume;
  const implicitOptions = {
    contentUrlTemplate,
    subtreesUriTemplate,
    subdivisionScheme,
    subtreeLevels,
    maximumLevel: Number.isFinite(availableLevels) ? availableLevels - 1 : maximumLevel,
    refine,
    basePath,
    lodMetricType: LOD_METRIC_TYPE$1.GEOMETRIC_ERROR,
    rootLodMetricValue,
    rootBoundingVolume,
    getTileType: getTileType$1,
    getRefine: getRefine$1
  };
  return await normalizeImplicitTileData$1(tile, basePath, subtree, implicitOptions, options2);
}
async function normalizeImplicitTileData$1(tile, basePath, rootSubtree, implicitOptions, loaderOptions) {
  if (!tile) {
    return null;
  }
  const { children, contentUrl } = await parseImplicitTiles$1({
    subtree: rootSubtree,
    implicitOptions,
    loaderOptions
  });
  let tileContentUrl;
  let tileContent = null;
  if (contentUrl) {
    tileContentUrl = contentUrl;
    tileContent = { uri: contentUrl.replace(`${basePath}/`, "") };
  }
  const tilePostprocessed = {
    ...tile,
    id: tileContentUrl,
    contentUrl: tileContentUrl,
    lodMetricType: LOD_METRIC_TYPE$1.GEOMETRIC_ERROR,
    lodMetricValue: tile.geometricError,
    transformMatrix: tile.transform,
    type: getTileType$1(tile, tileContentUrl),
    refine: getRefine$1(tile.refine),
    content: tileContent || tile.content,
    children
  };
  return tilePostprocessed;
}
function getImplicitTilingExtensionData$1(tile) {
  var _a3;
  return ((_a3 = tile == null ? void 0 : tile.extensions) == null ? void 0 : _a3["3DTILES_implicit_tiling"]) || (tile == null ? void 0 : tile.implicitTiling);
}
const Tiles3DLoader$1 = {
  dataType: null,
  batchType: null,
  id: "3d-tiles",
  name: "3D Tiles",
  module: "3d-tiles",
  version: VERSION$7,
  extensions: ["cmpt", "pnts", "b3dm", "i3dm"],
  mimeTypes: ["application/octet-stream"],
  tests: ["cmpt", "pnts", "b3dm", "i3dm"],
  parse: parse$4,
  options: {
    "3d-tiles": {
      loadGLTF: true,
      decodeQuantizedPositions: false,
      isTileset: "auto",
      assetGltfUpAxis: null
    }
  }
};
async function parse$4(data2, options2 = {}, context2) {
  const loaderOptions = options2["3d-tiles"] || {};
  let isTileset;
  if (loaderOptions.isTileset === "auto") {
    isTileset = (context2 == null ? void 0 : context2.url) && context2.url.indexOf(".json") !== -1;
  } else {
    isTileset = loaderOptions.isTileset;
  }
  return isTileset ? parseTileset$1(data2, options2, context2) : parseTile$1(data2, options2, context2);
}
async function parseTileset$1(data2, options2, context2) {
  var _a3;
  const tilesetJson = JSON.parse(new TextDecoder().decode(data2));
  const tilesetUrl = (context2 == null ? void 0 : context2.url) || "";
  const basePath = getBaseUri$1(tilesetUrl);
  const normalizedRoot = await normalizeTileHeaders$1(tilesetJson, basePath, options2 || {});
  const tilesetJsonPostprocessed = {
    ...tilesetJson,
    shape: "tileset3d",
    loader: Tiles3DLoader$1,
    url: tilesetUrl,
    queryString: (context2 == null ? void 0 : context2.queryString) || "",
    basePath,
    root: normalizedRoot || tilesetJson.root,
    type: TILESET_TYPE$1.TILES3D,
    lodMetricType: LOD_METRIC_TYPE$1.GEOMETRIC_ERROR,
    lodMetricValue: ((_a3 = tilesetJson.root) == null ? void 0 : _a3.geometricError) || 0
  };
  return tilesetJsonPostprocessed;
}
async function parseTile$1(arrayBuffer2, options2, context2) {
  const tile = {
    content: {
      shape: "tile3d",
      featureIds: null
    }
  };
  const byteOffset = 0;
  await parse3DTile$1(arrayBuffer2, byteOffset, options2, context2, tile.content);
  return tile.content;
}
function getBaseUri$1(tilesetUrl) {
  return dirname$1(tilesetUrl);
}
const SINGLE_DATA = [0];
const defaultProps$5 = {
  getPointColor: { type: "accessor", value: [0, 0, 0, 255] },
  pointSize: 1,
  // Disable async data loading (handling it in _loadTileSet)
  data: "",
  loader: Tiles3DLoader$1,
  onTilesetLoad: { type: "function", value: (tileset3d) => {
  } },
  onTileLoad: { type: "function", value: (tileHeader) => {
  } },
  onTileUnload: { type: "function", value: (tileHeader) => {
  } },
  onTileError: { type: "function", value: (tile, message2, url2) => {
  } },
  _getMeshColor: { type: "function", value: (tileHeader) => [255, 255, 255] }
};
const _Tile3DLayer = class extends CompositeLayer {
  initializeState() {
    if ("onTileLoadFail" in this.props) {
      log$1.removed("onTileLoadFail", "onTileError")();
    }
    this.state = {
      layerMap: {},
      tileset3d: null,
      activeViewports: {},
      lastUpdatedViewports: null
    };
  }
  get isLoaded() {
    var _a3, _b3;
    return Boolean(((_b3 = (_a3 = this.state) == null ? void 0 : _a3.tileset3d) == null ? void 0 : _b3.isLoaded()) && super.isLoaded);
  }
  shouldUpdateState({ changeFlags }) {
    return changeFlags.somethingChanged;
  }
  updateState({ props, oldProps, changeFlags }) {
    if (props.data && props.data !== oldProps.data) {
      this._loadTileset(props.data);
    }
    if (changeFlags.viewportChanged) {
      const { activeViewports } = this.state;
      const viewportsNumber = Object.keys(activeViewports).length;
      if (viewportsNumber) {
        this._updateTileset(activeViewports);
        this.state.lastUpdatedViewports = activeViewports;
        this.state.activeViewports = {};
      }
    }
    if (changeFlags.propsChanged) {
      const { layerMap } = this.state;
      for (const key in layerMap) {
        layerMap[key].needsUpdate = true;
      }
    }
  }
  activateViewport(viewport) {
    const { activeViewports, lastUpdatedViewports } = this.state;
    this.internalState.viewport = viewport;
    activeViewports[viewport.id] = viewport;
    const lastViewport = lastUpdatedViewports == null ? void 0 : lastUpdatedViewports[viewport.id];
    if (!lastViewport || !viewport.equals(lastViewport)) {
      this.setChangeFlags({ viewportChanged: true });
      this.setNeedsUpdate();
    }
  }
  getPickingInfo({ info, sourceLayer }) {
    const sourceTile = sourceLayer && sourceLayer.props.tile;
    if (info.picked) {
      info.object = sourceTile;
    }
    info.sourceTile = sourceTile;
    return info;
  }
  filterSubLayer({ layer, viewport }) {
    const { tile } = layer.props;
    const { id: viewportId } = viewport;
    return tile.selected && tile.viewportIds.includes(viewportId);
  }
  _updateAutoHighlight(info) {
    const sourceTile = info.sourceTile;
    const layerCache = this.state.layerMap[sourceTile == null ? void 0 : sourceTile.id];
    if (layerCache && layerCache.layer) {
      layerCache.layer.updateAutoHighlight(info);
    }
  }
  async _loadTileset(tilesetUrl) {
    const { loadOptions = {} } = this.props;
    const loaders = this.props.loader || this.props.loaders;
    const loader2 = Array.isArray(loaders) ? loaders[0] : loaders;
    const options2 = { loadOptions: { ...loadOptions } };
    let actualTilesetUrl = tilesetUrl;
    if (loader2.preload) {
      const preloadOptions = await loader2.preload(tilesetUrl, loadOptions);
      if (preloadOptions.url) {
        actualTilesetUrl = preloadOptions.url;
      }
      if (preloadOptions.headers) {
        options2.loadOptions.fetch = {
          ...options2.loadOptions.fetch,
          headers: preloadOptions.headers
        };
      }
      Object.assign(options2, preloadOptions);
    }
    const tilesetJson = await load(actualTilesetUrl, loader2, options2.loadOptions);
    const tileset3d = new Tileset3D(tilesetJson, {
      onTileLoad: this._onTileLoad.bind(this),
      onTileUnload: this._onTileUnload.bind(this),
      onTileError: this.props.onTileError,
      ...options2
    });
    this.setState({
      tileset3d,
      layerMap: {}
    });
    this._updateTileset(this.state.activeViewports);
    this.props.onTilesetLoad(tileset3d);
  }
  _onTileLoad(tileHeader) {
    const { lastUpdatedViewports } = this.state;
    this.props.onTileLoad(tileHeader);
    this._updateTileset(lastUpdatedViewports);
    this.setNeedsUpdate();
  }
  _onTileUnload(tileHeader) {
    delete this.state.layerMap[tileHeader.id];
    this.props.onTileUnload(tileHeader);
  }
  _updateTileset(viewports) {
    if (!viewports) {
      return;
    }
    const { tileset3d } = this.state;
    const { timeline } = this.context;
    const viewportsNumber = Object.keys(viewports).length;
    if (!timeline || !viewportsNumber || !tileset3d) {
      return;
    }
    tileset3d.selectTiles(Object.values(viewports)).then((frameNumber) => {
      const tilesetChanged = this.state.frameNumber !== frameNumber;
      if (tilesetChanged) {
        this.setState({ frameNumber });
      }
    });
  }
  _getSubLayer(tileHeader, oldLayer) {
    if (!tileHeader.content) {
      return null;
    }
    switch (tileHeader.type) {
      case TILE_TYPE$1.POINTCLOUD:
        return this._makePointCloudLayer(tileHeader, oldLayer);
      case TILE_TYPE$1.SCENEGRAPH:
        return this._make3DModelLayer(tileHeader);
      case TILE_TYPE$1.MESH:
        return this._makeSimpleMeshLayer(tileHeader, oldLayer);
      default:
        throw new Error(`Tile3DLayer: Failed to render layer of type ${tileHeader.content.type}`);
    }
  }
  _makePointCloudLayer(tileHeader, oldLayer) {
    const { attributes, pointCount, constantRGBA, cartographicOrigin, modelMatrix: modelMatrix2 } = tileHeader.content;
    const { positions, normals, colors } = attributes;
    if (!positions) {
      return null;
    }
    const data2 = oldLayer && oldLayer.props.data || {
      header: {
        vertexCount: pointCount
      },
      attributes: {
        POSITION: positions,
        NORMAL: normals,
        COLOR_0: colors
      }
    };
    const { pointSize, getPointColor } = this.props;
    const SubLayerClass = this.getSubLayerClass("pointcloud", PointCloudLayer);
    return new SubLayerClass({
      pointSize
    }, this.getSubLayerProps({
      id: "pointcloud"
    }), {
      id: `${this.id}-pointcloud-${tileHeader.id}`,
      tile: tileHeader,
      data: data2,
      coordinateSystem: COORDINATE_SYSTEM.METER_OFFSETS,
      coordinateOrigin: cartographicOrigin,
      modelMatrix: modelMatrix2,
      getColor: constantRGBA || getPointColor,
      _offset: 0
    });
  }
  _make3DModelLayer(tileHeader) {
    const { gltf, instances, cartographicOrigin, modelMatrix: modelMatrix2 } = tileHeader.content;
    const SubLayerClass = this.getSubLayerClass("scenegraph", ScenegraphLayer);
    return new SubLayerClass({
      _lighting: "pbr"
    }, this.getSubLayerProps({
      id: "scenegraph"
    }), {
      id: `${this.id}-scenegraph-${tileHeader.id}`,
      tile: tileHeader,
      data: instances || SINGLE_DATA,
      scenegraph: gltf,
      coordinateSystem: COORDINATE_SYSTEM.METER_OFFSETS,
      coordinateOrigin: cartographicOrigin,
      modelMatrix: modelMatrix2,
      getTransformMatrix: (instance2) => instance2.modelMatrix,
      getPosition: [0, 0, 0],
      _offset: 0
    });
  }
  _makeSimpleMeshLayer(tileHeader, oldLayer) {
    const content = tileHeader.content;
    const { attributes, indices, modelMatrix: modelMatrix2, cartographicOrigin, coordinateSystem = COORDINATE_SYSTEM.METER_OFFSETS, material, featureIds } = content;
    const { _getMeshColor } = this.props;
    const geometry2 = oldLayer && oldLayer.props.mesh || new Geometry({
      topology: "triangle-list",
      attributes: getMeshGeometry(attributes),
      indices
    });
    const SubLayerClass = this.getSubLayerClass("mesh", MeshLayer);
    return new SubLayerClass(this.getSubLayerProps({
      id: "mesh"
    }), {
      id: `${this.id}-mesh-${tileHeader.id}`,
      tile: tileHeader,
      mesh: geometry2,
      data: SINGLE_DATA,
      getColor: _getMeshColor(tileHeader),
      pbrMaterial: material,
      modelMatrix: modelMatrix2,
      coordinateOrigin: cartographicOrigin,
      coordinateSystem,
      featureIds,
      _offset: 0
    });
  }
  renderLayers() {
    const { tileset3d, layerMap } = this.state;
    if (!tileset3d) {
      return null;
    }
    return tileset3d.tiles.map((tile) => {
      const layerCache = layerMap[tile.id] = layerMap[tile.id] || { tile };
      let { layer } = layerCache;
      if (tile.selected) {
        if (!layer) {
          layer = this._getSubLayer(tile);
        } else if (layerCache.needsUpdate) {
          layer = this._getSubLayer(tile, layer);
          layerCache.needsUpdate = false;
        }
      }
      layerCache.layer = layer;
      return layer;
    }).filter(Boolean);
  }
};
let Tile3DLayer = _Tile3DLayer;
(() => {
  _Tile3DLayer.defaultProps = defaultProps$5;
})();
(() => {
  _Tile3DLayer.layerName = "Tile3DLayer";
})();
function getMeshGeometry(contentAttributes) {
  const attributes = {};
  attributes.positions = {
    ...contentAttributes.positions,
    value: new Float32Array(contentAttributes.positions.value)
  };
  if (contentAttributes.normals) {
    attributes.normals = contentAttributes.normals;
  }
  if (contentAttributes.texCoords) {
    attributes.texCoords = contentAttributes.texCoords;
  }
  if (contentAttributes.colors) {
    attributes.colors = contentAttributes.colors;
  }
  if (contentAttributes.uvRegions) {
    attributes.uvRegions = contentAttributes.uvRegions;
  }
  return attributes;
}
const defaultProps$4 = {
  clipBounds: [0, 0, 1, 1],
  clipByInstance: void 0
};
const shaderFunction = (
  /* glsl */
  `
uniform clipUniforms {
  vec4 bounds;
} clip;

bool clip_isInBounds(vec2 position) {
  return position.x >= clip.bounds[0] && position.y >= clip.bounds[1] && position.x < clip.bounds[2] && position.y < clip.bounds[3];
}
`
);
const shaderModuleVs = {
  name: "clip",
  vs: shaderFunction,
  uniformTypes: {
    bounds: "vec4<f32>"
  }
};
const injectionVs = {
  "vs:#decl": (
    /* glsl */
    `
out float clip_isVisible;
`
  ),
  "vs:DECKGL_FILTER_GL_POSITION": (
    /* glsl */
    `
  clip_isVisible = float(clip_isInBounds(geometry.worldPosition.xy));
`
  ),
  "fs:#decl": (
    /* glsl */
    `
in float clip_isVisible;
`
  ),
  "fs:DECKGL_FILTER_COLOR": (
    /* glsl */
    `
  if (clip_isVisible < 0.5) discard;
`
  )
};
const shaderModuleFs = {
  name: "clip",
  fs: shaderFunction,
  uniformTypes: {
    bounds: "vec4<f32>"
  }
};
const injectionFs = {
  "vs:#decl": (
    /* glsl */
    `
out vec2 clip_commonPosition;
`
  ),
  "vs:DECKGL_FILTER_GL_POSITION": (
    /* glsl */
    `
  clip_commonPosition = geometry.position.xy;
`
  ),
  "fs:#decl": (
    /* glsl */
    `
in vec2 clip_commonPosition;
`
  ),
  "fs:DECKGL_FILTER_COLOR": (
    /* glsl */
    `
  if (!clip_isInBounds(clip_commonPosition)) discard;
`
  )
};
class ClipExtension extends LayerExtension {
  getShaders() {
    let clipByInstance = "instancePositions" in this.getAttributeManager().attributes;
    if (this.props.clipByInstance !== void 0) {
      clipByInstance = Boolean(this.props.clipByInstance);
    }
    this.state.clipByInstance = clipByInstance;
    return clipByInstance ? {
      modules: [shaderModuleVs],
      inject: injectionVs
    } : {
      modules: [shaderModuleFs],
      inject: injectionFs
    };
  }
  /* eslint-disable camelcase */
  draw() {
    const { clipBounds } = this.props;
    const clipProps = {};
    if (this.state.clipByInstance) {
      clipProps.bounds = clipBounds;
    } else {
      const corner0 = this.projectPosition([clipBounds[0], clipBounds[1], 0]);
      const corner1 = this.projectPosition([clipBounds[2], clipBounds[3], 0]);
      clipProps.bounds = [
        Math.min(corner0[0], corner1[0]),
        Math.min(corner0[1], corner1[1]),
        Math.max(corner0[0], corner1[0]),
        Math.max(corner0[1], corner1[1])
      ];
    }
    this.setShaderModuleProps({ clip: clipProps });
  }
}
ClipExtension.defaultProps = defaultProps$4;
ClipExtension.extensionName = "ClipExtension";
const ClipExtension$1 = ClipExtension;
function flatGeojsonToBinary(features, geometryInfo, options2) {
  const propArrayTypes = extractNumericPropTypes(features);
  const numericPropKeys = Object.keys(propArrayTypes).filter((k2) => propArrayTypes[k2] !== Array);
  return fillArrays(features, {
    propArrayTypes,
    ...geometryInfo
  }, {
    numericPropKeys: options2 && options2.numericPropKeys || numericPropKeys,
    PositionDataType: options2 ? options2.PositionDataType : Float32Array,
    triangulate: options2 ? options2.triangulate : true
  });
}
function extractNumericPropTypes(features) {
  const propArrayTypes = {};
  for (const feature2 of features) {
    if (feature2.properties) {
      for (const key in feature2.properties) {
        const val = feature2.properties[key];
        propArrayTypes[key] = deduceArrayType(val, propArrayTypes[key]);
      }
    }
  }
  return propArrayTypes;
}
function fillArrays(features, geometryInfo, options2) {
  const { pointPositionsCount, pointFeaturesCount, linePositionsCount, linePathsCount, lineFeaturesCount, polygonPositionsCount, polygonObjectsCount, polygonRingsCount, polygonFeaturesCount, propArrayTypes, coordLength } = geometryInfo;
  const { numericPropKeys = [], PositionDataType = Float32Array, triangulate = true } = options2;
  const hasGlobalId = features[0] && "id" in features[0];
  const GlobalFeatureIdsDataType = features.length > 65535 ? Uint32Array : Uint16Array;
  const points2 = {
    type: "Point",
    positions: new PositionDataType(pointPositionsCount * coordLength),
    globalFeatureIds: new GlobalFeatureIdsDataType(pointPositionsCount),
    featureIds: pointFeaturesCount > 65535 ? new Uint32Array(pointPositionsCount) : new Uint16Array(pointPositionsCount),
    numericProps: {},
    properties: [],
    fields: []
  };
  const lines = {
    type: "LineString",
    pathIndices: linePositionsCount > 65535 ? new Uint32Array(linePathsCount + 1) : new Uint16Array(linePathsCount + 1),
    positions: new PositionDataType(linePositionsCount * coordLength),
    globalFeatureIds: new GlobalFeatureIdsDataType(linePositionsCount),
    featureIds: lineFeaturesCount > 65535 ? new Uint32Array(linePositionsCount) : new Uint16Array(linePositionsCount),
    numericProps: {},
    properties: [],
    fields: []
  };
  const polygons2 = {
    type: "Polygon",
    polygonIndices: polygonPositionsCount > 65535 ? new Uint32Array(polygonObjectsCount + 1) : new Uint16Array(polygonObjectsCount + 1),
    primitivePolygonIndices: polygonPositionsCount > 65535 ? new Uint32Array(polygonRingsCount + 1) : new Uint16Array(polygonRingsCount + 1),
    positions: new PositionDataType(polygonPositionsCount * coordLength),
    globalFeatureIds: new GlobalFeatureIdsDataType(polygonPositionsCount),
    featureIds: polygonFeaturesCount > 65535 ? new Uint32Array(polygonPositionsCount) : new Uint16Array(polygonPositionsCount),
    numericProps: {},
    properties: [],
    fields: []
  };
  if (triangulate) {
    polygons2.triangles = [];
  }
  for (const object2 of [points2, lines, polygons2]) {
    for (const propName2 of numericPropKeys) {
      const T2 = propArrayTypes[propName2];
      object2.numericProps[propName2] = new T2(object2.positions.length / coordLength);
    }
  }
  lines.pathIndices[linePathsCount] = linePositionsCount;
  polygons2.polygonIndices[polygonObjectsCount] = polygonPositionsCount;
  polygons2.primitivePolygonIndices[polygonRingsCount] = polygonPositionsCount;
  const indexMap = {
    pointPosition: 0,
    pointFeature: 0,
    linePosition: 0,
    linePath: 0,
    lineFeature: 0,
    polygonPosition: 0,
    polygonObject: 0,
    polygonRing: 0,
    polygonFeature: 0,
    feature: 0
  };
  for (const feature2 of features) {
    const geometry2 = feature2.geometry;
    const properties = feature2.properties || {};
    switch (geometry2.type) {
      case "Point":
        handlePoint(geometry2, points2, indexMap, coordLength, properties);
        points2.properties.push(keepStringProperties(properties, numericPropKeys));
        if (hasGlobalId) {
          points2.fields.push({ id: feature2.id });
        }
        indexMap.pointFeature++;
        break;
      case "LineString":
        handleLineString(geometry2, lines, indexMap, coordLength, properties);
        lines.properties.push(keepStringProperties(properties, numericPropKeys));
        if (hasGlobalId) {
          lines.fields.push({ id: feature2.id });
        }
        indexMap.lineFeature++;
        break;
      case "Polygon":
        handlePolygon(geometry2, polygons2, indexMap, coordLength, properties);
        polygons2.properties.push(keepStringProperties(properties, numericPropKeys));
        if (hasGlobalId) {
          polygons2.fields.push({ id: feature2.id });
        }
        indexMap.polygonFeature++;
        break;
      default:
        throw new Error("Invalid geometry type");
    }
    indexMap.feature++;
  }
  return makeAccessorObjects(points2, lines, polygons2, coordLength);
}
function handlePoint(geometry2, points2, indexMap, coordLength, properties) {
  points2.positions.set(geometry2.data, indexMap.pointPosition * coordLength);
  const nPositions = geometry2.data.length / coordLength;
  fillNumericProperties(points2, properties, indexMap.pointPosition, nPositions);
  points2.globalFeatureIds.fill(indexMap.feature, indexMap.pointPosition, indexMap.pointPosition + nPositions);
  points2.featureIds.fill(indexMap.pointFeature, indexMap.pointPosition, indexMap.pointPosition + nPositions);
  indexMap.pointPosition += nPositions;
}
function handleLineString(geometry2, lines, indexMap, coordLength, properties) {
  lines.positions.set(geometry2.data, indexMap.linePosition * coordLength);
  const nPositions = geometry2.data.length / coordLength;
  fillNumericProperties(lines, properties, indexMap.linePosition, nPositions);
  lines.globalFeatureIds.fill(indexMap.feature, indexMap.linePosition, indexMap.linePosition + nPositions);
  lines.featureIds.fill(indexMap.lineFeature, indexMap.linePosition, indexMap.linePosition + nPositions);
  for (let i2 = 0, il = geometry2.indices.length; i2 < il; ++i2) {
    const start2 = geometry2.indices[i2];
    const end = i2 === il - 1 ? geometry2.data.length : geometry2.indices[i2 + 1];
    lines.pathIndices[indexMap.linePath++] = indexMap.linePosition;
    indexMap.linePosition += (end - start2) / coordLength;
  }
}
function handlePolygon(geometry2, polygons2, indexMap, coordLength, properties) {
  polygons2.positions.set(geometry2.data, indexMap.polygonPosition * coordLength);
  const nPositions = geometry2.data.length / coordLength;
  fillNumericProperties(polygons2, properties, indexMap.polygonPosition, nPositions);
  polygons2.globalFeatureIds.fill(indexMap.feature, indexMap.polygonPosition, indexMap.polygonPosition + nPositions);
  polygons2.featureIds.fill(indexMap.polygonFeature, indexMap.polygonPosition, indexMap.polygonPosition + nPositions);
  for (let l2 = 0, ll = geometry2.indices.length; l2 < ll; ++l2) {
    const startPosition = indexMap.polygonPosition;
    polygons2.polygonIndices[indexMap.polygonObject++] = startPosition;
    const areas = geometry2.areas[l2];
    const indices = geometry2.indices[l2];
    const nextIndices = geometry2.indices[l2 + 1];
    for (let i2 = 0, il = indices.length; i2 < il; ++i2) {
      const start2 = indices[i2];
      const end = i2 === il - 1 ? (
        // last line, so either read to:
        nextIndices === void 0 ? geometry2.data.length : nextIndices[0]
      ) : indices[i2 + 1];
      polygons2.primitivePolygonIndices[indexMap.polygonRing++] = indexMap.polygonPosition;
      indexMap.polygonPosition += (end - start2) / coordLength;
    }
    const endPosition = indexMap.polygonPosition;
    triangulatePolygon(polygons2, areas, indices, { startPosition, endPosition, coordLength });
  }
}
function triangulatePolygon(polygons2, areas, indices, { startPosition, endPosition, coordLength }) {
  if (!polygons2.triangles) {
    return;
  }
  const start2 = startPosition * coordLength;
  const end = endPosition * coordLength;
  const polygonPositions = polygons2.positions.subarray(start2, end);
  const offset = indices[0];
  const holes = indices.slice(1).map((n2) => (n2 - offset) / coordLength);
  const triangles = earcut(polygonPositions, holes, coordLength, areas);
  for (let t2 = 0, tl = triangles.length; t2 < tl; ++t2) {
    polygons2.triangles.push(startPosition + triangles[t2]);
  }
}
function wrapProps(obj, size12) {
  const returnObj = {};
  for (const key in obj) {
    returnObj[key] = { value: obj[key], size: size12 };
  }
  return returnObj;
}
function makeAccessorObjects(points2, lines, polygons2, coordLength) {
  const binaryFeatures = {
    shape: "binary-feature-collection",
    points: {
      ...points2,
      positions: { value: points2.positions, size: coordLength },
      globalFeatureIds: { value: points2.globalFeatureIds, size: 1 },
      featureIds: { value: points2.featureIds, size: 1 },
      numericProps: wrapProps(points2.numericProps, 1)
    },
    lines: {
      ...lines,
      positions: { value: lines.positions, size: coordLength },
      pathIndices: { value: lines.pathIndices, size: 1 },
      globalFeatureIds: { value: lines.globalFeatureIds, size: 1 },
      featureIds: { value: lines.featureIds, size: 1 },
      numericProps: wrapProps(lines.numericProps, 1)
    },
    polygons: {
      ...polygons2,
      positions: { value: polygons2.positions, size: coordLength },
      polygonIndices: { value: polygons2.polygonIndices, size: 1 },
      primitivePolygonIndices: { value: polygons2.primitivePolygonIndices, size: 1 },
      globalFeatureIds: { value: polygons2.globalFeatureIds, size: 1 },
      featureIds: { value: polygons2.featureIds, size: 1 },
      numericProps: wrapProps(polygons2.numericProps, 1)
    }
    // triangles not expected
  };
  if (binaryFeatures.polygons && polygons2.triangles) {
    binaryFeatures.polygons.triangles = { value: new Uint32Array(polygons2.triangles), size: 1 };
  }
  return binaryFeatures;
}
function fillNumericProperties(object2, properties, index2, length2) {
  for (const numericPropName in object2.numericProps) {
    if (numericPropName in properties) {
      const value = properties[numericPropName];
      object2.numericProps[numericPropName].fill(value, index2, index2 + length2);
    }
  }
}
function keepStringProperties(properties, numericKeys) {
  const props = {};
  for (const key in properties) {
    if (!numericKeys.includes(key)) {
      props[key] = properties[key];
    }
  }
  return props;
}
function deduceArrayType(x2, constructor) {
  if (constructor === Array || !Number.isFinite(x2)) {
    return Array;
  }
  return constructor === Float64Array || Math.fround(x2) !== x2 ? Float64Array : Float32Array;
}
function binaryToGeojson(data2, options2) {
  const globalFeatureId = options2 == null ? void 0 : options2.globalFeatureId;
  if (globalFeatureId !== void 0) {
    return getSingleFeature(data2, globalFeatureId);
  }
  return parseFeatures(data2, options2 == null ? void 0 : options2.type);
}
function getSingleFeature(data2, globalFeatureId) {
  const dataArray = normalizeInput(data2);
  for (const data3 of dataArray) {
    let lastIndex = 0;
    let lastValue = data3.featureIds.value[0];
    for (let i2 = 0; i2 < data3.featureIds.value.length; i2++) {
      const currValue = data3.featureIds.value[i2];
      if (currValue === lastValue) {
        continue;
      }
      if (globalFeatureId === data3.globalFeatureIds.value[lastIndex]) {
        return parseFeature(data3, lastIndex, i2);
      }
      lastIndex = i2;
      lastValue = currValue;
    }
    if (globalFeatureId === data3.globalFeatureIds.value[lastIndex]) {
      return parseFeature(data3, lastIndex, data3.featureIds.value.length);
    }
  }
  throw new Error(`featureId:${globalFeatureId} not found`);
}
function parseFeatures(data2, type) {
  const dataArray = normalizeInput(data2);
  return parseFeatureCollection(dataArray);
}
function binaryToGeometry(data2, startIndex, endIndex) {
  switch (data2.type) {
    case "Point":
      return pointToGeoJson(data2, startIndex, endIndex);
    case "LineString":
      return lineStringToGeoJson(data2, startIndex, endIndex);
    case "Polygon":
      return polygonToGeoJson(data2, startIndex, endIndex);
    default:
      const unexpectedInput = data2;
      throw new Error(`Unsupported geometry type: ${unexpectedInput == null ? void 0 : unexpectedInput.type}`);
  }
}
function normalizeInput(data2, type) {
  const features = [];
  if (data2.points) {
    data2.points.type = "Point";
    features.push(data2.points);
  }
  if (data2.lines) {
    data2.lines.type = "LineString";
    features.push(data2.lines);
  }
  if (data2.polygons) {
    data2.polygons.type = "Polygon";
    features.push(data2.polygons);
  }
  return features;
}
function parseFeatureCollection(dataArray) {
  const features = [];
  for (const data2 of dataArray) {
    if (data2.featureIds.value.length === 0) {
      continue;
    }
    let lastIndex = 0;
    let lastValue = data2.featureIds.value[0];
    for (let i2 = 0; i2 < data2.featureIds.value.length; i2++) {
      const currValue = data2.featureIds.value[i2];
      if (currValue === lastValue) {
        continue;
      }
      features.push(parseFeature(data2, lastIndex, i2));
      lastIndex = i2;
      lastValue = currValue;
    }
    features.push(parseFeature(data2, lastIndex, data2.featureIds.value.length));
  }
  return features;
}
function parseFeature(data2, startIndex, endIndex) {
  const geometry2 = binaryToGeometry(data2, startIndex, endIndex);
  const properties = parseProperties(data2, startIndex);
  const fields = parseFields(data2, startIndex);
  return { type: "Feature", geometry: geometry2, properties, ...fields };
}
function parseFields(data2, startIndex = 0, endIndex) {
  return data2.fields && data2.fields[data2.featureIds.value[startIndex]];
}
function parseProperties(data2, startIndex = 0, endIndex) {
  const properties = Object.assign({}, data2.properties[data2.featureIds.value[startIndex]]);
  for (const key in data2.numericProps) {
    properties[key] = data2.numericProps[key].value[startIndex];
  }
  return properties;
}
function polygonToGeoJson(data2, startIndex = -Infinity, endIndex = Infinity) {
  const { positions } = data2;
  const polygonIndices = data2.polygonIndices.value.filter((x2) => x2 >= startIndex && x2 <= endIndex);
  const primitivePolygonIndices = data2.primitivePolygonIndices.value.filter((x2) => x2 >= startIndex && x2 <= endIndex);
  const multi = polygonIndices.length > 2;
  if (!multi) {
    const coordinates3 = [];
    for (let i2 = 0; i2 < primitivePolygonIndices.length - 1; i2++) {
      const startRingIndex = primitivePolygonIndices[i2];
      const endRingIndex = primitivePolygonIndices[i2 + 1];
      const ringCoordinates = ringToGeoJson(positions, startRingIndex, endRingIndex);
      coordinates3.push(ringCoordinates);
    }
    return { type: "Polygon", coordinates: coordinates3 };
  }
  const coordinates2 = [];
  for (let i2 = 0; i2 < polygonIndices.length - 1; i2++) {
    const startPolygonIndex = polygonIndices[i2];
    const endPolygonIndex = polygonIndices[i2 + 1];
    const polygonCoordinates = polygonToGeoJson(data2, startPolygonIndex, endPolygonIndex).coordinates;
    coordinates2.push(polygonCoordinates);
  }
  return { type: "MultiPolygon", coordinates: coordinates2 };
}
function lineStringToGeoJson(data2, startIndex = -Infinity, endIndex = Infinity) {
  const { positions } = data2;
  const pathIndices = data2.pathIndices.value.filter((x2) => x2 >= startIndex && x2 <= endIndex);
  const multi = pathIndices.length > 2;
  if (!multi) {
    const coordinates3 = ringToGeoJson(positions, pathIndices[0], pathIndices[1]);
    return { type: "LineString", coordinates: coordinates3 };
  }
  const coordinates2 = [];
  for (let i2 = 0; i2 < pathIndices.length - 1; i2++) {
    const ringCoordinates = ringToGeoJson(positions, pathIndices[i2], pathIndices[i2 + 1]);
    coordinates2.push(ringCoordinates);
  }
  return { type: "MultiLineString", coordinates: coordinates2 };
}
function pointToGeoJson(data2, startIndex, endIndex) {
  const { positions } = data2;
  const coordinates2 = ringToGeoJson(positions, startIndex, endIndex);
  const multi = coordinates2.length > 1;
  if (multi) {
    return { type: "MultiPoint", coordinates: coordinates2 };
  }
  return { type: "Point", coordinates: coordinates2[0] };
}
function ringToGeoJson(positions, startIndex, endIndex) {
  startIndex = startIndex || 0;
  endIndex = endIndex || positions.value.length / positions.size;
  const ringCoordinates = [];
  for (let j2 = startIndex; j2 < endIndex; j2++) {
    const coord = Array();
    for (let k2 = j2 * positions.size; k2 < (j2 + 1) * positions.size; k2++) {
      coord.push(Number(positions.value[k2]));
    }
    ringCoordinates.push(coord);
  }
  return ringCoordinates;
}
var ieee754$1 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754$1.read = function(buffer3, offset, isLE, mLen, nBytes) {
  var e3, m2;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i2 = isLE ? nBytes - 1 : 0;
  var d2 = isLE ? -1 : 1;
  var s2 = buffer3[offset + i2];
  i2 += d2;
  e3 = s2 & (1 << -nBits) - 1;
  s2 >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e3 = e3 * 256 + buffer3[offset + i2], i2 += d2, nBits -= 8) {
  }
  m2 = e3 & (1 << -nBits) - 1;
  e3 >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m2 = m2 * 256 + buffer3[offset + i2], i2 += d2, nBits -= 8) {
  }
  if (e3 === 0) {
    e3 = 1 - eBias;
  } else if (e3 === eMax) {
    return m2 ? NaN : (s2 ? -1 : 1) * Infinity;
  } else {
    m2 = m2 + Math.pow(2, mLen);
    e3 = e3 - eBias;
  }
  return (s2 ? -1 : 1) * m2 * Math.pow(2, e3 - mLen);
};
ieee754$1.write = function(buffer3, value, offset, isLE, mLen, nBytes) {
  var e3, m2, c2;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i2 = isLE ? 0 : nBytes - 1;
  var d2 = isLE ? 1 : -1;
  var s2 = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m2 = isNaN(value) ? 1 : 0;
    e3 = eMax;
  } else {
    e3 = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c2 = Math.pow(2, -e3)) < 1) {
      e3--;
      c2 *= 2;
    }
    if (e3 + eBias >= 1) {
      value += rt / c2;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c2 >= 2) {
      e3++;
      c2 /= 2;
    }
    if (e3 + eBias >= eMax) {
      m2 = 0;
      e3 = eMax;
    } else if (e3 + eBias >= 1) {
      m2 = (value * c2 - 1) * Math.pow(2, mLen);
      e3 = e3 + eBias;
    } else {
      m2 = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e3 = 0;
    }
  }
  for (; mLen >= 8; buffer3[offset + i2] = m2 & 255, i2 += d2, m2 /= 256, mLen -= 8) {
  }
  e3 = e3 << mLen | m2;
  eLen += mLen;
  for (; eLen > 0; buffer3[offset + i2] = e3 & 255, i2 += d2, e3 /= 256, eLen -= 8) {
  }
  buffer3[offset + i2 - d2] |= s2 * 128;
};
var pbf = Pbf;
var ieee754 = ieee754$1;
function Pbf(buf) {
  this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
  this.pos = 0;
  this.type = 0;
  this.length = this.buf.length;
}
Pbf.Varint = 0;
Pbf.Fixed64 = 1;
Pbf.Bytes = 2;
Pbf.Fixed32 = 5;
var SHIFT_LEFT_32 = (1 << 16) * (1 << 16), SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;
var TEXT_DECODER_MIN_LENGTH = 12;
var utf8TextDecoder = typeof TextDecoder === "undefined" ? null : new TextDecoder("utf8");
Pbf.prototype = {
  destroy: function() {
    this.buf = null;
  },
  // === READING =================================================================
  readFields: function(readField, result, end) {
    end = end || this.length;
    while (this.pos < end) {
      var val = this.readVarint(), tag2 = val >> 3, startPos = this.pos;
      this.type = val & 7;
      readField(tag2, result, this);
      if (this.pos === startPos)
        this.skip(val);
    }
    return result;
  },
  readMessage: function(readField, result) {
    return this.readFields(readField, result, this.readVarint() + this.pos);
  },
  readFixed32: function() {
    var val = readUInt32(this.buf, this.pos);
    this.pos += 4;
    return val;
  },
  readSFixed32: function() {
    var val = readInt32(this.buf, this.pos);
    this.pos += 4;
    return val;
  },
  // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)
  readFixed64: function() {
    var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
    this.pos += 8;
    return val;
  },
  readSFixed64: function() {
    var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
    this.pos += 8;
    return val;
  },
  readFloat: function() {
    var val = ieee754.read(this.buf, this.pos, true, 23, 4);
    this.pos += 4;
    return val;
  },
  readDouble: function() {
    var val = ieee754.read(this.buf, this.pos, true, 52, 8);
    this.pos += 8;
    return val;
  },
  readVarint: function(isSigned) {
    var buf = this.buf, val, b2;
    b2 = buf[this.pos++];
    val = b2 & 127;
    if (b2 < 128)
      return val;
    b2 = buf[this.pos++];
    val |= (b2 & 127) << 7;
    if (b2 < 128)
      return val;
    b2 = buf[this.pos++];
    val |= (b2 & 127) << 14;
    if (b2 < 128)
      return val;
    b2 = buf[this.pos++];
    val |= (b2 & 127) << 21;
    if (b2 < 128)
      return val;
    b2 = buf[this.pos];
    val |= (b2 & 15) << 28;
    return readVarintRemainder(val, isSigned, this);
  },
  readVarint64: function() {
    return this.readVarint(true);
  },
  readSVarint: function() {
    var num = this.readVarint();
    return num % 2 === 1 ? (num + 1) / -2 : num / 2;
  },
  readBoolean: function() {
    return Boolean(this.readVarint());
  },
  readString: function() {
    var end = this.readVarint() + this.pos;
    var pos = this.pos;
    this.pos = end;
    if (end - pos >= TEXT_DECODER_MIN_LENGTH && utf8TextDecoder) {
      return readUtf8TextDecoder(this.buf, pos, end);
    }
    return readUtf8(this.buf, pos, end);
  },
  readBytes: function() {
    var end = this.readVarint() + this.pos, buffer3 = this.buf.subarray(this.pos, end);
    this.pos = end;
    return buffer3;
  },
  // verbose for performance reasons; doesn't affect gzipped size
  readPackedVarint: function(arr, isSigned) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readVarint(isSigned));
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readVarint(isSigned));
    return arr;
  },
  readPackedSVarint: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readSVarint());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readSVarint());
    return arr;
  },
  readPackedBoolean: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readBoolean());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readBoolean());
    return arr;
  },
  readPackedFloat: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readFloat());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readFloat());
    return arr;
  },
  readPackedDouble: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readDouble());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readDouble());
    return arr;
  },
  readPackedFixed32: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readFixed32());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readFixed32());
    return arr;
  },
  readPackedSFixed32: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readSFixed32());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readSFixed32());
    return arr;
  },
  readPackedFixed64: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readFixed64());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readFixed64());
    return arr;
  },
  readPackedSFixed64: function(arr) {
    if (this.type !== Pbf.Bytes)
      return arr.push(this.readSFixed64());
    var end = readPackedEnd(this);
    arr = arr || [];
    while (this.pos < end)
      arr.push(this.readSFixed64());
    return arr;
  },
  skip: function(val) {
    var type = val & 7;
    if (type === Pbf.Varint)
      while (this.buf[this.pos++] > 127) {
      }
    else if (type === Pbf.Bytes)
      this.pos = this.readVarint() + this.pos;
    else if (type === Pbf.Fixed32)
      this.pos += 4;
    else if (type === Pbf.Fixed64)
      this.pos += 8;
    else
      throw new Error("Unimplemented type: " + type);
  },
  // === WRITING =================================================================
  writeTag: function(tag2, type) {
    this.writeVarint(tag2 << 3 | type);
  },
  realloc: function(min4) {
    var length2 = this.length || 16;
    while (length2 < this.pos + min4)
      length2 *= 2;
    if (length2 !== this.length) {
      var buf = new Uint8Array(length2);
      buf.set(this.buf);
      this.buf = buf;
      this.length = length2;
    }
  },
  finish: function() {
    this.length = this.pos;
    this.pos = 0;
    return this.buf.subarray(0, this.length);
  },
  writeFixed32: function(val) {
    this.realloc(4);
    writeInt32(this.buf, val, this.pos);
    this.pos += 4;
  },
  writeSFixed32: function(val) {
    this.realloc(4);
    writeInt32(this.buf, val, this.pos);
    this.pos += 4;
  },
  writeFixed64: function(val) {
    this.realloc(8);
    writeInt32(this.buf, val & -1, this.pos);
    writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
    this.pos += 8;
  },
  writeSFixed64: function(val) {
    this.realloc(8);
    writeInt32(this.buf, val & -1, this.pos);
    writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
    this.pos += 8;
  },
  writeVarint: function(val) {
    val = +val || 0;
    if (val > 268435455 || val < 0) {
      writeBigVarint(val, this);
      return;
    }
    this.realloc(4);
    this.buf[this.pos++] = val & 127 | (val > 127 ? 128 : 0);
    if (val <= 127)
      return;
    this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
    if (val <= 127)
      return;
    this.buf[this.pos++] = (val >>>= 7) & 127 | (val > 127 ? 128 : 0);
    if (val <= 127)
      return;
    this.buf[this.pos++] = val >>> 7 & 127;
  },
  writeSVarint: function(val) {
    this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
  },
  writeBoolean: function(val) {
    this.writeVarint(Boolean(val));
  },
  writeString: function(str) {
    str = String(str);
    this.realloc(str.length * 4);
    this.pos++;
    var startPos = this.pos;
    this.pos = writeUtf8(this.buf, str, this.pos);
    var len2 = this.pos - startPos;
    if (len2 >= 128)
      makeRoomForExtraLength(startPos, len2, this);
    this.pos = startPos - 1;
    this.writeVarint(len2);
    this.pos += len2;
  },
  writeFloat: function(val) {
    this.realloc(4);
    ieee754.write(this.buf, val, this.pos, true, 23, 4);
    this.pos += 4;
  },
  writeDouble: function(val) {
    this.realloc(8);
    ieee754.write(this.buf, val, this.pos, true, 52, 8);
    this.pos += 8;
  },
  writeBytes: function(buffer3) {
    var len2 = buffer3.length;
    this.writeVarint(len2);
    this.realloc(len2);
    for (var i2 = 0; i2 < len2; i2++)
      this.buf[this.pos++] = buffer3[i2];
  },
  writeRawMessage: function(fn2, obj) {
    this.pos++;
    var startPos = this.pos;
    fn2(obj, this);
    var len2 = this.pos - startPos;
    if (len2 >= 128)
      makeRoomForExtraLength(startPos, len2, this);
    this.pos = startPos - 1;
    this.writeVarint(len2);
    this.pos += len2;
  },
  writeMessage: function(tag2, fn2, obj) {
    this.writeTag(tag2, Pbf.Bytes);
    this.writeRawMessage(fn2, obj);
  },
  writePackedVarint: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedVarint, arr);
  },
  writePackedSVarint: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedSVarint, arr);
  },
  writePackedBoolean: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedBoolean, arr);
  },
  writePackedFloat: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedFloat, arr);
  },
  writePackedDouble: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedDouble, arr);
  },
  writePackedFixed32: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedFixed32, arr);
  },
  writePackedSFixed32: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedSFixed32, arr);
  },
  writePackedFixed64: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedFixed64, arr);
  },
  writePackedSFixed64: function(tag2, arr) {
    if (arr.length)
      this.writeMessage(tag2, writePackedSFixed64, arr);
  },
  writeBytesField: function(tag2, buffer3) {
    this.writeTag(tag2, Pbf.Bytes);
    this.writeBytes(buffer3);
  },
  writeFixed32Field: function(tag2, val) {
    this.writeTag(tag2, Pbf.Fixed32);
    this.writeFixed32(val);
  },
  writeSFixed32Field: function(tag2, val) {
    this.writeTag(tag2, Pbf.Fixed32);
    this.writeSFixed32(val);
  },
  writeFixed64Field: function(tag2, val) {
    this.writeTag(tag2, Pbf.Fixed64);
    this.writeFixed64(val);
  },
  writeSFixed64Field: function(tag2, val) {
    this.writeTag(tag2, Pbf.Fixed64);
    this.writeSFixed64(val);
  },
  writeVarintField: function(tag2, val) {
    this.writeTag(tag2, Pbf.Varint);
    this.writeVarint(val);
  },
  writeSVarintField: function(tag2, val) {
    this.writeTag(tag2, Pbf.Varint);
    this.writeSVarint(val);
  },
  writeStringField: function(tag2, str) {
    this.writeTag(tag2, Pbf.Bytes);
    this.writeString(str);
  },
  writeFloatField: function(tag2, val) {
    this.writeTag(tag2, Pbf.Fixed32);
    this.writeFloat(val);
  },
  writeDoubleField: function(tag2, val) {
    this.writeTag(tag2, Pbf.Fixed64);
    this.writeDouble(val);
  },
  writeBooleanField: function(tag2, val) {
    this.writeVarintField(tag2, Boolean(val));
  }
};
function readVarintRemainder(l2, s2, p2) {
  var buf = p2.buf, h2, b2;
  b2 = buf[p2.pos++];
  h2 = (b2 & 112) >> 4;
  if (b2 < 128)
    return toNum(l2, h2, s2);
  b2 = buf[p2.pos++];
  h2 |= (b2 & 127) << 3;
  if (b2 < 128)
    return toNum(l2, h2, s2);
  b2 = buf[p2.pos++];
  h2 |= (b2 & 127) << 10;
  if (b2 < 128)
    return toNum(l2, h2, s2);
  b2 = buf[p2.pos++];
  h2 |= (b2 & 127) << 17;
  if (b2 < 128)
    return toNum(l2, h2, s2);
  b2 = buf[p2.pos++];
  h2 |= (b2 & 127) << 24;
  if (b2 < 128)
    return toNum(l2, h2, s2);
  b2 = buf[p2.pos++];
  h2 |= (b2 & 1) << 31;
  if (b2 < 128)
    return toNum(l2, h2, s2);
  throw new Error("Expected varint not more than 10 bytes");
}
function readPackedEnd(pbf2) {
  return pbf2.type === Pbf.Bytes ? pbf2.readVarint() + pbf2.pos : pbf2.pos + 1;
}
function toNum(low, high, isSigned) {
  if (isSigned) {
    return high * 4294967296 + (low >>> 0);
  }
  return (high >>> 0) * 4294967296 + (low >>> 0);
}
function writeBigVarint(val, pbf2) {
  var low, high;
  if (val >= 0) {
    low = val % 4294967296 | 0;
    high = val / 4294967296 | 0;
  } else {
    low = ~(-val % 4294967296);
    high = ~(-val / 4294967296);
    if (low ^ 4294967295) {
      low = low + 1 | 0;
    } else {
      low = 0;
      high = high + 1 | 0;
    }
  }
  if (val >= 18446744073709552e3 || val < -18446744073709552e3) {
    throw new Error("Given varint doesn't fit into 10 bytes");
  }
  pbf2.realloc(10);
  writeBigVarintLow(low, high, pbf2);
  writeBigVarintHigh(high, pbf2);
}
function writeBigVarintLow(low, high, pbf2) {
  pbf2.buf[pbf2.pos++] = low & 127 | 128;
  low >>>= 7;
  pbf2.buf[pbf2.pos++] = low & 127 | 128;
  low >>>= 7;
  pbf2.buf[pbf2.pos++] = low & 127 | 128;
  low >>>= 7;
  pbf2.buf[pbf2.pos++] = low & 127 | 128;
  low >>>= 7;
  pbf2.buf[pbf2.pos] = low & 127;
}
function writeBigVarintHigh(high, pbf2) {
  var lsb2 = (high & 7) << 4;
  pbf2.buf[pbf2.pos++] |= lsb2 | ((high >>>= 3) ? 128 : 0);
  if (!high)
    return;
  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
  if (!high)
    return;
  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
  if (!high)
    return;
  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
  if (!high)
    return;
  pbf2.buf[pbf2.pos++] = high & 127 | ((high >>>= 7) ? 128 : 0);
  if (!high)
    return;
  pbf2.buf[pbf2.pos++] = high & 127;
}
function makeRoomForExtraLength(startPos, len2, pbf2) {
  var extraLen = len2 <= 16383 ? 1 : len2 <= 2097151 ? 2 : len2 <= 268435455 ? 3 : Math.floor(Math.log(len2) / (Math.LN2 * 7));
  pbf2.realloc(extraLen);
  for (var i2 = pbf2.pos - 1; i2 >= startPos; i2--)
    pbf2.buf[i2 + extraLen] = pbf2.buf[i2];
}
function writePackedVarint(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeVarint(arr[i2]);
}
function writePackedSVarint(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeSVarint(arr[i2]);
}
function writePackedFloat(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeFloat(arr[i2]);
}
function writePackedDouble(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeDouble(arr[i2]);
}
function writePackedBoolean(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeBoolean(arr[i2]);
}
function writePackedFixed32(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeFixed32(arr[i2]);
}
function writePackedSFixed32(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeSFixed32(arr[i2]);
}
function writePackedFixed64(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeFixed64(arr[i2]);
}
function writePackedSFixed64(arr, pbf2) {
  for (var i2 = 0; i2 < arr.length; i2++)
    pbf2.writeSFixed64(arr[i2]);
}
function readUInt32(buf, pos) {
  return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + buf[pos + 3] * 16777216;
}
function writeInt32(buf, val, pos) {
  buf[pos] = val;
  buf[pos + 1] = val >>> 8;
  buf[pos + 2] = val >>> 16;
  buf[pos + 3] = val >>> 24;
}
function readInt32(buf, pos) {
  return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16) + (buf[pos + 3] << 24);
}
function readUtf8(buf, pos, end) {
  var str = "";
  var i2 = pos;
  while (i2 < end) {
    var b0 = buf[i2];
    var c2 = null;
    var bytesPerSequence = b0 > 239 ? 4 : b0 > 223 ? 3 : b0 > 191 ? 2 : 1;
    if (i2 + bytesPerSequence > end)
      break;
    var b1, b2, b3;
    if (bytesPerSequence === 1) {
      if (b0 < 128) {
        c2 = b0;
      }
    } else if (bytesPerSequence === 2) {
      b1 = buf[i2 + 1];
      if ((b1 & 192) === 128) {
        c2 = (b0 & 31) << 6 | b1 & 63;
        if (c2 <= 127) {
          c2 = null;
        }
      }
    } else if (bytesPerSequence === 3) {
      b1 = buf[i2 + 1];
      b2 = buf[i2 + 2];
      if ((b1 & 192) === 128 && (b2 & 192) === 128) {
        c2 = (b0 & 15) << 12 | (b1 & 63) << 6 | b2 & 63;
        if (c2 <= 2047 || c2 >= 55296 && c2 <= 57343) {
          c2 = null;
        }
      }
    } else if (bytesPerSequence === 4) {
      b1 = buf[i2 + 1];
      b2 = buf[i2 + 2];
      b3 = buf[i2 + 3];
      if ((b1 & 192) === 128 && (b2 & 192) === 128 && (b3 & 192) === 128) {
        c2 = (b0 & 15) << 18 | (b1 & 63) << 12 | (b2 & 63) << 6 | b3 & 63;
        if (c2 <= 65535 || c2 >= 1114112) {
          c2 = null;
        }
      }
    }
    if (c2 === null) {
      c2 = 65533;
      bytesPerSequence = 1;
    } else if (c2 > 65535) {
      c2 -= 65536;
      str += String.fromCharCode(c2 >>> 10 & 1023 | 55296);
      c2 = 56320 | c2 & 1023;
    }
    str += String.fromCharCode(c2);
    i2 += bytesPerSequence;
  }
  return str;
}
function readUtf8TextDecoder(buf, pos, end) {
  return utf8TextDecoder.decode(buf.subarray(pos, end));
}
function writeUtf8(buf, str, pos) {
  for (var i2 = 0, c2, lead; i2 < str.length; i2++) {
    c2 = str.charCodeAt(i2);
    if (c2 > 55295 && c2 < 57344) {
      if (lead) {
        if (c2 < 56320) {
          buf[pos++] = 239;
          buf[pos++] = 191;
          buf[pos++] = 189;
          lead = c2;
          continue;
        } else {
          c2 = lead - 55296 << 10 | c2 - 56320 | 65536;
          lead = null;
        }
      } else {
        if (c2 > 56319 || i2 + 1 === str.length) {
          buf[pos++] = 239;
          buf[pos++] = 191;
          buf[pos++] = 189;
        } else {
          lead = c2;
        }
        continue;
      }
    } else if (lead) {
      buf[pos++] = 239;
      buf[pos++] = 191;
      buf[pos++] = 189;
      lead = null;
    }
    if (c2 < 128) {
      buf[pos++] = c2;
    } else {
      if (c2 < 2048) {
        buf[pos++] = c2 >> 6 | 192;
      } else {
        if (c2 < 65536) {
          buf[pos++] = c2 >> 12 | 224;
        } else {
          buf[pos++] = c2 >> 18 | 240;
          buf[pos++] = c2 >> 12 & 63 | 128;
        }
        buf[pos++] = c2 >> 6 & 63 | 128;
      }
      buf[pos++] = c2 & 63 | 128;
    }
  }
  return pos;
}
function classifyRings$1(rings) {
  const len2 = rings.length;
  if (len2 <= 1)
    return [rings];
  const polygons2 = [];
  let polygon4;
  let ccw;
  for (let i2 = 0; i2 < len2; i2++) {
    const area5 = signedArea(rings[i2]);
    if (area5 === 0)
      continue;
    if (ccw === void 0)
      ccw = area5 < 0;
    if (ccw === area5 < 0) {
      if (polygon4)
        polygons2.push(polygon4);
      polygon4 = [rings[i2]];
    } else if (polygon4)
      polygon4.push(rings[i2]);
  }
  if (polygon4)
    polygons2.push(polygon4);
  return polygons2;
}
function signedArea(ring) {
  let sum2 = 0;
  for (let i2 = 0, j2 = ring.length - 1, p1, p2; i2 < ring.length; j2 = i2++) {
    p1 = ring[i2];
    p2 = ring[j2];
    sum2 += (p2[0] - p1[0]) * (p1[1] + p2[1]);
  }
  return sum2;
}
function readFeature$1(tag2, feature2, pbf2) {
  if (feature2 && pbf2) {
    if (tag2 === 1)
      feature2.id = pbf2.readVarint();
    else if (tag2 === 2)
      readTag$1(pbf2, feature2);
    else if (tag2 === 3)
      feature2.type = pbf2.readVarint();
    else if (tag2 === 4)
      feature2._geometry = pbf2.pos;
  }
}
function readTag$1(pbf2, feature2) {
  const end = pbf2.readVarint() + pbf2.pos;
  while (pbf2.pos < end) {
    const key = feature2._keys[pbf2.readVarint()];
    const value = feature2._values[pbf2.readVarint()];
    feature2.properties[key] = value;
  }
}
class VectorTileFeature {
  constructor(pbf2, end, extent2, keys4, values4) {
    __publicField2(this, "properties");
    __publicField2(this, "extent");
    __publicField2(this, "type");
    __publicField2(this, "id");
    __publicField2(this, "_pbf");
    __publicField2(this, "_geometry");
    __publicField2(this, "_keys");
    __publicField2(this, "_values");
    this.properties = {};
    this.extent = extent2;
    this.type = 0;
    this.id = null;
    this._pbf = pbf2;
    this._geometry = -1;
    this._keys = keys4;
    this._values = values4;
    pbf2.readFields(readFeature$1, this, end);
  }
  static get types() {
    return ["Unknown", "Point", "LineString", "Polygon"];
  }
  // eslint-disable-next-line complexity, max-statements
  loadGeometry() {
    const pbf2 = this._pbf;
    pbf2.pos = this._geometry;
    const end = pbf2.readVarint() + pbf2.pos;
    let cmd2 = 1;
    let length2 = 0;
    let x2 = 0;
    let y2 = 0;
    const lines = [];
    let line;
    while (pbf2.pos < end) {
      if (length2 <= 0) {
        const cmdLen2 = pbf2.readVarint();
        cmd2 = cmdLen2 & 7;
        length2 = cmdLen2 >> 3;
      }
      length2--;
      if (cmd2 === 1 || cmd2 === 2) {
        x2 += pbf2.readSVarint();
        y2 += pbf2.readSVarint();
        if (cmd2 === 1) {
          if (line)
            lines.push(line);
          line = [];
        }
        if (line)
          line.push([x2, y2]);
      } else if (cmd2 === 7) {
        if (line) {
          line.push(line[0].slice());
        }
      } else {
        throw new Error(`unknown command ${cmd2}`);
      }
    }
    if (line)
      lines.push(line);
    return lines;
  }
  // eslint-disable-next-line max-statements
  bbox() {
    const pbf2 = this._pbf;
    pbf2.pos = this._geometry;
    const end = pbf2.readVarint() + pbf2.pos;
    let cmd2 = 1;
    let length2 = 0;
    let x2 = 0;
    let y2 = 0;
    let x12 = Infinity;
    let x22 = -Infinity;
    let y12 = Infinity;
    let y22 = -Infinity;
    while (pbf2.pos < end) {
      if (length2 <= 0) {
        const cmdLen2 = pbf2.readVarint();
        cmd2 = cmdLen2 & 7;
        length2 = cmdLen2 >> 3;
      }
      length2--;
      if (cmd2 === 1 || cmd2 === 2) {
        x2 += pbf2.readSVarint();
        y2 += pbf2.readSVarint();
        if (x2 < x12)
          x12 = x2;
        if (x2 > x22)
          x22 = x2;
        if (y2 < y12)
          y12 = y2;
        if (y2 > y22)
          y22 = y2;
      } else if (cmd2 !== 7) {
        throw new Error(`unknown command ${cmd2}`);
      }
    }
    return [x12, y12, x22, y22];
  }
  _toGeoJSON(transform4) {
    let coords = this.loadGeometry();
    let type = VectorTileFeature.types[this.type];
    let i2;
    let j2;
    switch (this.type) {
      case 1:
        const points2 = [];
        for (i2 = 0; i2 < coords.length; i2++) {
          points2[i2] = coords[i2][0];
        }
        coords = points2;
        transform4(coords, this);
        break;
      case 2:
        for (i2 = 0; i2 < coords.length; i2++) {
          transform4(coords[i2], this);
        }
        break;
      case 3:
        coords = classifyRings$1(coords);
        for (i2 = 0; i2 < coords.length; i2++) {
          for (j2 = 0; j2 < coords[i2].length; j2++) {
            transform4(coords[i2][j2], this);
          }
        }
        break;
    }
    if (coords.length === 1) {
      coords = coords[0];
    } else {
      type = `Multi${type}`;
    }
    const result = {
      type: "Feature",
      geometry: {
        type,
        coordinates: coords
      },
      properties: this.properties
    };
    if (this.id !== null) {
      result.id = this.id;
    }
    return result;
  }
  toGeoJSON(options2) {
    if (typeof options2 === "function") {
      return this._toGeoJSON(options2);
    }
    const { x: x2, y: y2, z: z2 } = options2;
    const size12 = this.extent * Math.pow(2, z2);
    const x02 = this.extent * x2;
    const y02 = this.extent * y2;
    function project3(line) {
      for (let j2 = 0; j2 < line.length; j2++) {
        const p2 = line[j2];
        p2[0] = (p2[0] + x02) * 360 / size12 - 180;
        const y22 = 180 - (p2[1] + y02) * 360 / size12;
        p2[1] = 360 / Math.PI * Math.atan(Math.exp(y22 * Math.PI / 180)) - 90;
      }
    }
    return this._toGeoJSON(project3);
  }
}
class VectorTileLayer {
  constructor(pbf2, end) {
    __publicField2(this, "version");
    __publicField2(this, "name");
    __publicField2(this, "extent");
    __publicField2(this, "length");
    __publicField2(this, "_pbf");
    __publicField2(this, "_keys");
    __publicField2(this, "_values");
    __publicField2(this, "_features");
    this.version = 1;
    this.name = "";
    this.extent = 4096;
    this.length = 0;
    this._pbf = pbf2;
    this._keys = [];
    this._values = [];
    this._features = [];
    pbf2.readFields(readLayer$1, this, end);
    this.length = this._features.length;
  }
  /**
   * return feature `i` from this layer as a `VectorTileFeature`
   * @param index
   * @returns feature
   */
  feature(i2) {
    if (i2 < 0 || i2 >= this._features.length) {
      throw new Error("feature index out of bounds");
    }
    this._pbf.pos = this._features[i2];
    const end = this._pbf.readVarint() + this._pbf.pos;
    return new VectorTileFeature(this._pbf, end, this.extent, this._keys, this._values);
  }
}
function readLayer$1(tag2, layer, pbf2) {
  if (layer && pbf2) {
    if (tag2 === 15)
      layer.version = pbf2.readVarint();
    else if (tag2 === 1)
      layer.name = pbf2.readString();
    else if (tag2 === 5)
      layer.extent = pbf2.readVarint();
    else if (tag2 === 2)
      layer._features.push(pbf2.pos);
    else if (tag2 === 3)
      layer._keys.push(pbf2.readString());
    else if (tag2 === 4)
      layer._values.push(readValueMessage$1(pbf2));
  }
}
function readValueMessage$1(pbf2) {
  let value = null;
  const end = pbf2.readVarint() + pbf2.pos;
  while (pbf2.pos < end) {
    const tag2 = pbf2.readVarint() >> 3;
    value = tag2 === 1 ? pbf2.readString() : tag2 === 2 ? pbf2.readFloat() : tag2 === 3 ? pbf2.readDouble() : tag2 === 4 ? pbf2.readVarint64() : tag2 === 5 ? pbf2.readVarint() : tag2 === 6 ? pbf2.readSVarint() : tag2 === 7 ? pbf2.readBoolean() : null;
  }
  return value;
}
class VectorTile {
  constructor(pbf2, end) {
    __publicField2(this, "layers");
    this.layers = pbf2.readFields(readTile$1, {}, end);
  }
}
function readTile$1(tag2, layers, pbf2) {
  if (tag2 === 3) {
    if (pbf2) {
      const layer = new VectorTileLayer(pbf2, pbf2.readVarint() + pbf2.pos);
      if (layer.length && layers) {
        layers[layer.name] = layer;
      }
    }
  }
}
function classifyRings(geom) {
  const len2 = geom.indices.length;
  const type = "Polygon";
  if (len2 <= 1) {
    return {
      type,
      data: geom.data,
      areas: [[getPolygonSignedArea(geom.data)]],
      indices: [geom.indices]
    };
  }
  const areas = [];
  const polygons2 = [];
  let ringAreas = [];
  let polygon4 = [];
  let ccw;
  let offset = 0;
  for (let endIndex, i2 = 0, startIndex; i2 < len2; i2++) {
    startIndex = geom.indices[i2] - offset;
    endIndex = geom.indices[i2 + 1] - offset || geom.data.length;
    const shape2 = geom.data.slice(startIndex, endIndex);
    const area5 = getPolygonSignedArea(shape2);
    if (area5 === 0) {
      const before = geom.data.slice(0, startIndex);
      const after = geom.data.slice(endIndex);
      geom.data = before.concat(after);
      offset += endIndex - startIndex;
      continue;
    }
    if (ccw === void 0)
      ccw = area5 < 0;
    if (ccw === area5 < 0) {
      if (polygon4.length) {
        areas.push(ringAreas);
        polygons2.push(polygon4);
      }
      polygon4 = [startIndex];
      ringAreas = [area5];
    } else {
      ringAreas.push(area5);
      polygon4.push(startIndex);
    }
  }
  if (ringAreas)
    areas.push(ringAreas);
  if (polygon4.length)
    polygons2.push(polygon4);
  return { type, areas, indices: polygons2, data: geom.data };
}
function project(data2, x02, y02, size12) {
  for (let j2 = 0, jl = data2.length; j2 < jl; j2 += 2) {
    data2[j2] = (data2[j2] + x02) * 360 / size12 - 180;
    const y2 = 180 - (data2[j2 + 1] + y02) * 360 / size12;
    data2[j2 + 1] = 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
  }
}
function readFeature(tag2, feature2, pbf2) {
  if (feature2 && pbf2) {
    if (tag2 === 1)
      feature2.id = pbf2.readVarint();
    else if (tag2 === 2)
      readTag(pbf2, feature2);
    else if (tag2 === 3)
      feature2.type = pbf2.readVarint();
    else if (tag2 === 4)
      feature2._geometry = pbf2.pos;
  }
}
function readTag(pbf2, feature2) {
  const end = pbf2.readVarint() + pbf2.pos;
  while (pbf2.pos < end) {
    const key = feature2._keys[pbf2.readVarint()];
    const value = feature2._values[pbf2.readVarint()];
    feature2.properties[key] = value;
  }
}
let endPos;
let cmd;
let cmdLen;
let length$1;
let x;
let y;
let i$3;
class BinaryVectorTileFeature {
  // eslint-disable-next-line max-params
  constructor(pbf2, end, extent2, keys4, values4, geometryInfo) {
    __publicField2(this, "properties");
    __publicField2(this, "extent");
    __publicField2(this, "type");
    __publicField2(this, "id");
    __publicField2(this, "_pbf");
    __publicField2(this, "_geometry");
    __publicField2(this, "_keys");
    __publicField2(this, "_values");
    __publicField2(this, "_geometryInfo");
    this.properties = {};
    this.extent = extent2;
    this.type = 0;
    this.id = null;
    this._pbf = pbf2;
    this._geometry = -1;
    this._keys = keys4;
    this._values = values4;
    this._geometryInfo = geometryInfo;
    pbf2.readFields(readFeature, this, end);
  }
  // eslint-disable-next-line complexity, max-statements
  loadGeometry() {
    const pbf2 = this._pbf;
    pbf2.pos = this._geometry;
    endPos = pbf2.readVarint() + pbf2.pos;
    cmd = 1;
    length$1 = 0;
    x = 0;
    y = 0;
    i$3 = 0;
    const indices = [];
    const data2 = [];
    while (pbf2.pos < endPos) {
      if (length$1 <= 0) {
        cmdLen = pbf2.readVarint();
        cmd = cmdLen & 7;
        length$1 = cmdLen >> 3;
      }
      length$1--;
      if (cmd === 1 || cmd === 2) {
        x += pbf2.readSVarint();
        y += pbf2.readSVarint();
        if (cmd === 1) {
          indices.push(i$3);
        }
        data2.push(x, y);
        i$3 += 2;
      } else if (cmd === 7) {
        if (i$3 > 0) {
          const start2 = indices[indices.length - 1];
          data2.push(data2[start2], data2[start2 + 1]);
          i$3 += 2;
        }
      } else {
        throw new Error(`unknown command ${cmd}`);
      }
    }
    return { data: data2, indices };
  }
  /**
   *
   * @param transform
   * @returns result
   */
  _toBinaryCoordinates(transform4) {
    const geom = this.loadGeometry();
    let geometry2;
    transform4(geom.data, this);
    const coordLength = 2;
    switch (this.type) {
      case 1:
        this._geometryInfo.pointFeaturesCount++;
        this._geometryInfo.pointPositionsCount += geom.indices.length;
        geometry2 = { type: "Point", ...geom };
        break;
      case 2:
        this._geometryInfo.lineFeaturesCount++;
        this._geometryInfo.linePathsCount += geom.indices.length;
        this._geometryInfo.linePositionsCount += geom.data.length / coordLength;
        geometry2 = { type: "LineString", ...geom };
        break;
      case 3:
        geometry2 = classifyRings(geom);
        this._geometryInfo.polygonFeaturesCount++;
        this._geometryInfo.polygonObjectsCount += geometry2.indices.length;
        for (const indices of geometry2.indices) {
          this._geometryInfo.polygonRingsCount += indices.length;
        }
        this._geometryInfo.polygonPositionsCount += geometry2.data.length / coordLength;
        break;
      default:
        throw new Error(`Invalid geometry type: ${this.type}`);
    }
    const result = { type: "Feature", geometry: geometry2, properties: this.properties };
    if (this.id !== null) {
      result.id = this.id;
    }
    return result;
  }
  toBinaryCoordinates(options2) {
    if (typeof options2 === "function") {
      return this._toBinaryCoordinates(options2);
    }
    const { x: x2, y: y2, z: z2 } = options2;
    const size12 = this.extent * Math.pow(2, z2);
    const x02 = this.extent * x2;
    const y02 = this.extent * y2;
    return this._toBinaryCoordinates((data2) => project(data2, x02, y02, size12));
  }
}
class BinaryVectorTileLayer {
  constructor(pbf2, end) {
    __publicField2(this, "version");
    __publicField2(this, "name");
    __publicField2(this, "extent");
    __publicField2(this, "length");
    __publicField2(this, "_pbf");
    __publicField2(this, "_keys");
    __publicField2(this, "_values");
    __publicField2(this, "_features");
    this.version = 1;
    this.name = "";
    this.extent = 4096;
    this.length = 0;
    this._pbf = pbf2;
    this._keys = [];
    this._values = [];
    this._features = [];
    pbf2.readFields(readLayer, this, end);
    this.length = this._features.length;
  }
  /**
   * return feature `i` from this layer as a `BinaryVectorTileFeature`
   *
   * @param index
   * @param geometryInfo
   * @returns {BinaryVectorTileFeature}
   */
  feature(i2, geometryInfo) {
    if (i2 < 0 || i2 >= this._features.length) {
      throw new Error("feature index out of bounds");
    }
    this._pbf.pos = this._features[i2];
    const end = this._pbf.readVarint() + this._pbf.pos;
    return new BinaryVectorTileFeature(this._pbf, end, this.extent, this._keys, this._values, geometryInfo);
  }
}
function readLayer(tag2, layer, pbf2) {
  if (layer && pbf2) {
    if (tag2 === 15)
      layer.version = pbf2.readVarint();
    else if (tag2 === 1)
      layer.name = pbf2.readString();
    else if (tag2 === 5)
      layer.extent = pbf2.readVarint();
    else if (tag2 === 2)
      layer._features.push(pbf2.pos);
    else if (tag2 === 3)
      layer._keys.push(pbf2.readString());
    else if (tag2 === 4)
      layer._values.push(readValueMessage(pbf2));
  }
}
function readValueMessage(pbf2) {
  let value = null;
  const end = pbf2.readVarint() + pbf2.pos;
  while (pbf2.pos < end) {
    const tag2 = pbf2.readVarint() >> 3;
    value = tag2 === 1 ? pbf2.readString() : tag2 === 2 ? pbf2.readFloat() : tag2 === 3 ? pbf2.readDouble() : tag2 === 4 ? pbf2.readVarint64() : tag2 === 5 ? pbf2.readVarint() : tag2 === 6 ? pbf2.readSVarint() : tag2 === 7 ? pbf2.readBoolean() : null;
  }
  return value;
}
class BinaryVectorTile {
  constructor(pbf2, end) {
    __publicField2(this, "layers");
    this.layers = pbf2.readFields(readTile, {}, end);
  }
}
function readTile(tag2, layers, pbf2) {
  if (tag2 === 3) {
    if (pbf2) {
      const layer = new BinaryVectorTileLayer(pbf2, pbf2.readVarint() + pbf2.pos);
      if (layer.length && layers) {
        layers[layer.name] = layer;
      }
    }
  }
}
function parseMVT(arrayBuffer2, options2) {
  var _a3, _b3;
  const mvtOptions = normalizeOptions(options2);
  const shape2 = ((_a3 = options2 == null ? void 0 : options2.gis) == null ? void 0 : _a3.format) || ((_b3 = options2 == null ? void 0 : options2.mvt) == null ? void 0 : _b3.shape) || (options2 == null ? void 0 : options2.shape);
  switch (shape2) {
    case "columnar-table":
      return { shape: "columnar-table", data: parseToBinary(arrayBuffer2, mvtOptions) };
    case "geojson-table": {
      const table = {
        shape: "geojson-table",
        type: "FeatureCollection",
        features: parseToGeojsonFeatures(arrayBuffer2, mvtOptions)
      };
      return table;
    }
    case "geojson":
      return parseToGeojsonFeatures(arrayBuffer2, mvtOptions);
    case "binary-geometry":
      return parseToBinary(arrayBuffer2, mvtOptions);
    case "binary":
      return parseToBinary(arrayBuffer2, mvtOptions);
    default:
      throw new Error(shape2 || "undefined shape");
  }
}
function parseToBinary(arrayBuffer2, options2) {
  const [flatGeoJsonFeatures, geometryInfo] = parseToFlatGeoJson(arrayBuffer2, options2);
  const binaryData = flatGeojsonToBinary(flatGeoJsonFeatures, geometryInfo);
  binaryData.byteLength = arrayBuffer2.byteLength;
  return binaryData;
}
function parseToFlatGeoJson(arrayBuffer2, options2) {
  const features = [];
  const geometryInfo = {
    coordLength: 2,
    pointPositionsCount: 0,
    pointFeaturesCount: 0,
    linePositionsCount: 0,
    linePathsCount: 0,
    lineFeaturesCount: 0,
    polygonPositionsCount: 0,
    polygonObjectsCount: 0,
    polygonRingsCount: 0,
    polygonFeaturesCount: 0
  };
  if (arrayBuffer2.byteLength <= 0) {
    return [features, geometryInfo];
  }
  const tile = new BinaryVectorTile(new pbf(arrayBuffer2));
  const selectedLayers = options2 && Array.isArray(options2.layers) ? options2.layers : Object.keys(tile.layers);
  selectedLayers.forEach((layerName) => {
    const vectorTileLayer = tile.layers[layerName];
    if (!vectorTileLayer) {
      return;
    }
    for (let i2 = 0; i2 < vectorTileLayer.length; i2++) {
      const vectorTileFeature = vectorTileLayer.feature(i2, geometryInfo);
      const decodedFeature = getDecodedFeatureBinary(vectorTileFeature, options2, layerName);
      features.push(decodedFeature);
    }
  });
  return [features, geometryInfo];
}
function parseToGeojsonFeatures(arrayBuffer2, options2) {
  if (arrayBuffer2.byteLength <= 0) {
    return [];
  }
  const features = [];
  const tile = new VectorTile(new pbf(arrayBuffer2));
  const selectedLayers = Array.isArray(options2.layers) ? options2.layers : Object.keys(tile.layers);
  selectedLayers.forEach((layerName) => {
    const vectorTileLayer = tile.layers[layerName];
    if (!vectorTileLayer) {
      return;
    }
    for (let i2 = 0; i2 < vectorTileLayer.length; i2++) {
      const vectorTileFeature = vectorTileLayer.feature(i2);
      const decodedFeature = getDecodedFeature(vectorTileFeature, options2, layerName);
      features.push(decodedFeature);
    }
  });
  return features;
}
function normalizeOptions(options2) {
  var _a3;
  if (!(options2 == null ? void 0 : options2.mvt)) {
    throw new Error("mvt options required");
  }
  const wgs84Coordinates = ((_a3 = options2.mvt) == null ? void 0 : _a3.coordinates) === "wgs84";
  const { tileIndex } = options2.mvt;
  const hasTileIndex = tileIndex && Number.isFinite(tileIndex.x) && Number.isFinite(tileIndex.y) && Number.isFinite(tileIndex.z);
  if (wgs84Coordinates && !hasTileIndex) {
    throw new Error("MVT Loader: WGS84 coordinates need tileIndex property");
  }
  return options2.mvt;
}
function getDecodedFeature(feature2, options2, layerName) {
  const decodedFeature = feature2.toGeoJSON(
    // @ts-expect-error What is going on here?
    options2.coordinates === "wgs84" ? options2.tileIndex : transformToLocalCoordinates
  );
  if (options2.layerProperty) {
    decodedFeature.properties[options2.layerProperty] = layerName;
  }
  return decodedFeature;
}
function getDecodedFeatureBinary(feature2, options2, layerName) {
  const decodedFeature = feature2.toBinaryCoordinates(
    // @ts-expect-error
    options2.coordinates === "wgs84" ? options2.tileIndex : transformToLocalCoordinatesBinary
  );
  if (options2.layerProperty && decodedFeature.properties) {
    decodedFeature.properties[options2.layerProperty] = layerName;
  }
  return decodedFeature;
}
function transformToLocalCoordinates(line, feature2) {
  const { extent: extent2 } = feature2;
  for (let i2 = 0; i2 < line.length; i2++) {
    const p2 = line[i2];
    p2[0] /= extent2;
    p2[1] /= extent2;
  }
}
function transformToLocalCoordinatesBinary(data2, feature2) {
  const { extent: extent2 } = feature2;
  for (let i2 = 0, il = data2.length; i2 < il; ++i2) {
    data2[i2] /= extent2;
  }
}
const VERSION$6 = "4.2.0";
const MVTWorkerLoader = {
  dataType: null,
  batchType: null,
  name: "Mapbox Vector Tile",
  id: "mvt",
  module: "mvt",
  version: VERSION$6,
  // Note: ArcGIS uses '.pbf' extension and 'application/octet-stream'
  extensions: ["mvt", "pbf"],
  mimeTypes: [
    // https://www.iana.org/assignments/media-types/application/vnd.mapbox-vector-tile
    "application/vnd.mapbox-vector-tile",
    "application/x-protobuf"
    // 'application/octet-stream'
  ],
  worker: true,
  category: "geometry",
  options: {
    mvt: {
      shape: "geojson",
      coordinates: "local",
      layerProperty: "layerName",
      layers: void 0,
      tileIndex: null
    }
  }
};
({
  ...MVTWorkerLoader,
  parse: async (arrayBuffer2, options2) => parseMVT(arrayBuffer2, options2),
  parseSync: parseMVT,
  binary: true
});
const availableTransformations = {
  Point: Point$5,
  MultiPoint,
  LineString: LineString$3,
  MultiLineString,
  Polygon: Polygon$3,
  MultiPolygon
};
function Point$5([pointX2, pointY2], [nw, se], viewport) {
  const x2 = lerp$4(nw[0], se[0], pointX2);
  const y2 = lerp$4(nw[1], se[1], pointY2);
  return viewport.unprojectFlat([x2, y2]);
}
function getPoints(geometry2, bbox2, viewport) {
  return geometry2.map((g2) => Point$5(g2, bbox2, viewport));
}
function MultiPoint(multiPoint2, bbox2, viewport) {
  return getPoints(multiPoint2, bbox2, viewport);
}
function LineString$3(line, bbox2, viewport) {
  return getPoints(line, bbox2, viewport);
}
function MultiLineString(multiLineString2, bbox2, viewport) {
  return multiLineString2.map((lineString2) => LineString$3(lineString2, bbox2, viewport));
}
function Polygon$3(polygon4, bbox2, viewport) {
  return polygon4.map((polygonRing) => getPoints(polygonRing, bbox2, viewport));
}
function MultiPolygon(multiPolygon2, bbox2, viewport) {
  return multiPolygon2.map((polygon4) => Polygon$3(polygon4, bbox2, viewport));
}
function transform(geometry2, bbox2, viewport) {
  const nw = viewport.projectFlat([bbox2.west, bbox2.north]);
  const se = viewport.projectFlat([bbox2.east, bbox2.south]);
  const projectedBbox = [nw, se];
  return {
    ...geometry2,
    coordinates: availableTransformations[geometry2.type](geometry2.coordinates, projectedBbox, viewport)
  };
}
const GEOM_TYPES = ["points", "lines", "polygons"];
function findIndexBinary(data2, uniqueIdProperty, featureId, layerName) {
  for (const gt2 of GEOM_TYPES) {
    const index2 = data2[gt2] && findIndexByType(data2[gt2], uniqueIdProperty, featureId, layerName);
    if (index2 >= 0) {
      return index2;
    }
  }
  return -1;
}
function findIndexByType(geomData, uniqueIdProperty, featureId, layerName) {
  const featureIds = geomData.featureIds.value;
  if (!featureIds.length) {
    return -1;
  }
  let startFeatureIndex = 0;
  let endFeatureIndex = featureIds[featureIds.length - 1] + 1;
  if (layerName) {
    const layerRange = getLayerRange(geomData, layerName);
    if (layerRange) {
      startFeatureIndex = layerRange[0];
      endFeatureIndex = layerRange[1] + 1;
    } else {
      return -1;
    }
  }
  let featureIndex = -1;
  if (uniqueIdProperty in geomData.numericProps) {
    const vertexIndex = geomData.numericProps[uniqueIdProperty].value.findIndex((x2, i2) => x2 === featureId && featureIds[i2] >= startFeatureIndex && featureIds[i2] < endFeatureIndex);
    return vertexIndex >= 0 ? geomData.globalFeatureIds.value[vertexIndex] : -1;
  } else if (uniqueIdProperty) {
    featureIndex = findIndex(geomData.properties, (elem) => elem[uniqueIdProperty] === featureId, startFeatureIndex, endFeatureIndex);
  } else if (geomData.fields) {
    featureIndex = findIndex(geomData.fields, (elem) => elem.id === featureId, startFeatureIndex, endFeatureIndex);
  }
  return featureIndex >= 0 ? getGlobalFeatureId(geomData, featureIndex) : -1;
}
function getLayerRange(geomData, layerName) {
  if (!geomData.__layers) {
    const layerNames = {};
    const { properties } = geomData;
    for (let i2 = 0; i2 < properties.length; i2++) {
      const { layerName: key } = properties[i2];
      if (!key)
        ;
      else if (layerNames[key]) {
        layerNames[key][1] = i2;
      } else {
        layerNames[key] = [i2, i2];
      }
    }
    geomData.__layers = layerNames;
  }
  return geomData.__layers[layerName];
}
function getGlobalFeatureId(geomData, featureIndex) {
  if (!geomData.__ids) {
    const result = [];
    const featureIds = geomData.featureIds.value;
    const globalFeatureIds = geomData.globalFeatureIds.value;
    for (let i2 = 0; i2 < featureIds.length; i2++) {
      result[featureIds[i2]] = globalFeatureIds[i2];
    }
    geomData.__ids = result;
  }
  return geomData.__ids[featureIndex];
}
function findIndex(array2, predicate, startIndex, endIndex) {
  for (let i2 = startIndex; i2 < endIndex; i2++) {
    if (predicate(array2[i2], i2)) {
      return i2;
    }
  }
  return -1;
}
const WORLD_SIZE$1 = 512;
const defaultProps$3 = {
  ...GeoJsonLayer$1.defaultProps,
  data: urlType,
  onDataLoad: { type: "function", value: null, optional: true, compare: false },
  uniqueIdProperty: "",
  highlightedFeatureId: null,
  loaders: [MVTWorkerLoader],
  binary: true
};
const _MVTLayer = class extends TileLayer {
  initializeState() {
    super.initializeState();
    const binary = this.context.viewport.resolution !== void 0 ? false : this.props.binary;
    this.setState({
      binary,
      data: null,
      tileJSON: null,
      hoveredFeatureId: null,
      hoveredFeatureLayerName: null
    });
  }
  get isLoaded() {
    var _a3;
    return Boolean(((_a3 = this.state) == null ? void 0 : _a3.data) && super.isLoaded);
  }
  updateState({ props, oldProps, context: context2, changeFlags }) {
    var _a3;
    if (changeFlags.dataChanged) {
      this._updateTileData();
    }
    if ((_a3 = this.state) == null ? void 0 : _a3.data) {
      super.updateState({ props, oldProps, context: context2, changeFlags });
      this._setWGS84PropertyForTiles();
    }
    const { highlightColor } = props;
    if (highlightColor !== oldProps.highlightColor && Array.isArray(highlightColor)) {
      this.setState({ highlightColor });
    }
  }
  /* eslint-disable complexity */
  async _updateTileData() {
    let data2 = this.props.data;
    let tileJSON = null;
    if (typeof data2 === "string" && !isURLTemplate(data2)) {
      const { onDataLoad, fetch: fetch2 } = this.props;
      this.setState({ data: null, tileJSON: null });
      try {
        tileJSON = await fetch2(data2, { propName: "data", layer: this, loaders: [] });
      } catch (error2) {
        this.raiseError(error2, "loading TileJSON");
        data2 = null;
      }
      if (onDataLoad) {
        onDataLoad(tileJSON, { propName: "data", layer: this });
      }
    } else if (data2 && typeof data2 === "object" && "tilejson" in data2) {
      tileJSON = data2;
    }
    if (tileJSON) {
      data2 = tileJSON.tiles;
    }
    this.setState({ data: data2, tileJSON });
  }
  _getTilesetOptions() {
    const opts = super._getTilesetOptions();
    const tileJSON = this.state.tileJSON;
    const { minZoom, maxZoom } = this.props;
    if (tileJSON) {
      if (Number.isFinite(tileJSON.minzoom) && tileJSON.minzoom > minZoom) {
        opts.minZoom = tileJSON.minzoom;
      }
      if (Number.isFinite(tileJSON.maxzoom) && (!Number.isFinite(maxZoom) || tileJSON.maxzoom < maxZoom)) {
        opts.maxZoom = tileJSON.maxzoom;
      }
    }
    return opts;
  }
  /* eslint-disable complexity */
  renderLayers() {
    var _a3;
    if (!((_a3 = this.state) == null ? void 0 : _a3.data))
      return null;
    return super.renderLayers();
  }
  getTileData(loadProps) {
    const { data: data2, binary } = this.state;
    const { index: index2, signal } = loadProps;
    const url2 = getURLFromTemplate(data2, loadProps);
    if (!url2) {
      return Promise.reject("Invalid URL");
    }
    let loadOptions = this.getLoadOptions();
    const { fetch: fetch2 } = this.props;
    loadOptions = {
      ...loadOptions,
      mimeType: "application/x-protobuf",
      mvt: {
        ...loadOptions == null ? void 0 : loadOptions.mvt,
        coordinates: this.context.viewport.resolution ? "wgs84" : "local",
        tileIndex: index2
        // Local worker debug
        // workerUrl: `modules/mvt/dist/mvt-loader.worker.js`
        // Set worker to null to skip web workers
        // workerUrl: null
      },
      gis: binary ? { format: "binary" } : {}
    };
    return fetch2(url2, { propName: "data", layer: this, loadOptions, signal });
  }
  renderSubLayers(props) {
    const { x: x2, y: y2, z: z2 } = props.tile.index;
    const worldScale = Math.pow(2, z2);
    const xScale = WORLD_SIZE$1 / worldScale;
    const yScale = -xScale;
    const xOffset = WORLD_SIZE$1 * x2 / worldScale;
    const yOffset = WORLD_SIZE$1 * (1 - y2 / worldScale);
    const modelMatrix2 = new Matrix4().scale([xScale, yScale, 1]);
    props.autoHighlight = false;
    if (!this.context.viewport.resolution) {
      props.modelMatrix = modelMatrix2;
      props.coordinateOrigin = [xOffset, yOffset, 0];
      props.coordinateSystem = COORDINATE_SYSTEM.CARTESIAN;
      props.extensions = [...props.extensions || [], new ClipExtension$1()];
    }
    const subLayers = super.renderSubLayers(props);
    if (this.state.binary && !(subLayers instanceof GeoJsonLayer$1)) {
      log$1.warn("renderSubLayers() must return GeoJsonLayer when using binary:true")();
    }
    return subLayers;
  }
  _updateAutoHighlight(info) {
    const { uniqueIdProperty } = this.props;
    const { hoveredFeatureId, hoveredFeatureLayerName } = this.state;
    const hoveredFeature = info.object;
    let newHoveredFeatureId = null;
    let newHoveredFeatureLayerName = null;
    if (hoveredFeature) {
      newHoveredFeatureId = getFeatureUniqueId(hoveredFeature, uniqueIdProperty);
      newHoveredFeatureLayerName = getFeatureLayerName(hoveredFeature);
    }
    let { highlightColor } = this.props;
    if (typeof highlightColor === "function") {
      highlightColor = highlightColor(info);
    }
    if (hoveredFeatureId !== newHoveredFeatureId || hoveredFeatureLayerName !== newHoveredFeatureLayerName) {
      this.setState({
        highlightColor,
        hoveredFeatureId: newHoveredFeatureId,
        hoveredFeatureLayerName: newHoveredFeatureLayerName
      });
    }
  }
  _isWGS84() {
    return Boolean(this.context.viewport.resolution);
  }
  getPickingInfo(params2) {
    const info = super.getPickingInfo(params2);
    if (this.state.binary && info.index !== -1) {
      const { data: data2 } = params2.sourceLayer.props;
      info.object = binaryToGeojson(data2, {
        globalFeatureId: info.index
      });
    }
    if (info.object && !this._isWGS84()) {
      info.object = transformTileCoordsToWGS84(
        info.object,
        info.tile.bbox,
        // eslint-disable-line
        this.context.viewport
      );
    }
    return info;
  }
  getSubLayerPropsByTile(tile) {
    return {
      highlightedObjectIndex: this.getHighlightedObjectIndex(tile),
      highlightColor: this.state.highlightColor
    };
  }
  getHighlightedObjectIndex(tile) {
    const { hoveredFeatureId, hoveredFeatureLayerName, binary } = this.state;
    const { uniqueIdProperty, highlightedFeatureId } = this.props;
    const data2 = tile.content;
    const isHighlighted = isFeatureIdDefined(highlightedFeatureId);
    const isFeatureIdPresent = isFeatureIdDefined(hoveredFeatureId) || isHighlighted;
    if (!isFeatureIdPresent) {
      return -1;
    }
    const featureIdToHighlight = isHighlighted ? highlightedFeatureId : hoveredFeatureId;
    if (Array.isArray(data2)) {
      return data2.findIndex((feature2) => {
        const isMatchingId = getFeatureUniqueId(feature2, uniqueIdProperty) === featureIdToHighlight;
        const isMatchingLayer = isHighlighted || getFeatureLayerName(feature2) === hoveredFeatureLayerName;
        return isMatchingId && isMatchingLayer;
      });
    } else if (data2 && binary) {
      return findIndexBinary(data2, uniqueIdProperty, featureIdToHighlight, isHighlighted ? "" : hoveredFeatureLayerName);
    }
    return -1;
  }
  _pickObjects(maxObjects) {
    const { deck, viewport } = this.context;
    const width = viewport.width;
    const height = viewport.height;
    const x2 = viewport.x;
    const y2 = viewport.y;
    const layerIds = [this.id];
    return deck.pickObjects({ x: x2, y: y2, width, height, layerIds, maxObjects });
  }
  /** Get the rendered features in the current viewport. */
  getRenderedFeatures(maxFeatures = null) {
    const features = this._pickObjects(maxFeatures);
    const featureCache = /* @__PURE__ */ new Set();
    const renderedFeatures = [];
    for (const f2 of features) {
      const featureId = getFeatureUniqueId(f2.object, this.props.uniqueIdProperty);
      if (featureId === void 0) {
        renderedFeatures.push(f2.object);
      } else if (!featureCache.has(featureId)) {
        featureCache.add(featureId);
        renderedFeatures.push(f2.object);
      }
    }
    return renderedFeatures;
  }
  _setWGS84PropertyForTiles() {
    const propName2 = "dataInWGS84";
    const tileset = this.state.tileset;
    tileset.selectedTiles.forEach((tile) => {
      if (!tile.hasOwnProperty(propName2)) {
        Object.defineProperty(tile, propName2, {
          get: () => {
            if (!tile.content) {
              return null;
            }
            if (this.state.binary && Array.isArray(tile.content) && !tile.content.length) {
              return [];
            }
            const { bbox: bbox2 } = tile;
            if (tile._contentWGS84 === void 0 && isGeoBoundingBox(bbox2)) {
              const content = this.state.binary ? binaryToGeojson(tile.content) : tile.content;
              tile._contentWGS84 = content.map((feature2) => transformTileCoordsToWGS84(feature2, bbox2, this.context.viewport));
            }
            return tile._contentWGS84;
          }
        });
      }
    });
  }
};
let MVTLayer = _MVTLayer;
(() => {
  _MVTLayer.layerName = "MVTLayer";
})();
(() => {
  _MVTLayer.defaultProps = defaultProps$3;
})();
function getFeatureUniqueId(feature2, uniqueIdProperty) {
  if (feature2.properties && uniqueIdProperty) {
    return feature2.properties[uniqueIdProperty];
  }
  if ("id" in feature2) {
    return feature2.id;
  }
  return void 0;
}
function getFeatureLayerName(feature2) {
  var _a3;
  return ((_a3 = feature2.properties) == null ? void 0 : _a3.layerName) || null;
}
function isFeatureIdDefined(value) {
  return value !== void 0 && value !== null && value !== "";
}
function transformTileCoordsToWGS84(object2, bbox2, viewport) {
  const feature2 = {
    ...object2,
    geometry: {
      type: object2.geometry.type
    }
  };
  Object.defineProperty(feature2.geometry, "coordinates", {
    get: () => {
      const wgs84Geom = transform(object2.geometry, bbox2, viewport);
      return wgs84Geom.coordinates;
    }
  });
  return feature2;
}
const AGGREGATION_OPERATION = {
  SUM: 1,
  MEAN: 2,
  MIN: 3,
  MAX: 4
};
function sumReducer(accu, cur) {
  return accu + cur;
}
function maxReducer(accu, cur) {
  return cur > accu ? cur : accu;
}
function minReducer(accu, cur) {
  return cur < accu ? cur : accu;
}
function getMean(pts, accessor) {
  if (Number.isFinite(accessor)) {
    return pts.length ? accessor : null;
  }
  const filtered = pts.map(accessor).filter(Number.isFinite);
  return filtered.length ? filtered.reduce(sumReducer, 0) / filtered.length : null;
}
function getSum(pts, accessor) {
  if (Number.isFinite(accessor)) {
    return pts.length ? pts.length * accessor : null;
  }
  const filtered = pts.map(accessor).filter(Number.isFinite);
  return filtered.length ? filtered.reduce(sumReducer, 0) : null;
}
function getMax(pts, accessor) {
  if (Number.isFinite(accessor)) {
    return pts.length ? accessor : null;
  }
  const filtered = pts.map(accessor).filter(Number.isFinite);
  return filtered.length ? filtered.reduce(maxReducer, -Infinity) : null;
}
function getMin(pts, accessor) {
  if (Number.isFinite(accessor)) {
    return pts.length ? accessor : null;
  }
  const filtered = pts.map(accessor).filter(Number.isFinite);
  return filtered.length ? filtered.reduce(minReducer, Infinity) : null;
}
function getValueFunc(aggregation, accessor, context2) {
  const op = AGGREGATION_OPERATION[aggregation] || AGGREGATION_OPERATION.SUM;
  accessor = wrapAccessor(accessor, context2);
  switch (op) {
    case AGGREGATION_OPERATION.MIN:
      return (pts) => getMin(pts, accessor);
    case AGGREGATION_OPERATION.SUM:
      return (pts) => getSum(pts, accessor);
    case AGGREGATION_OPERATION.MEAN:
      return (pts) => getMean(pts, accessor);
    case AGGREGATION_OPERATION.MAX:
      return (pts) => getMax(pts, accessor);
    default:
      return null;
  }
}
function wrapAccessor(accessor, context2 = {}) {
  if (Number.isFinite(accessor)) {
    return accessor;
  }
  return (pt) => {
    context2.index = pt.index;
    return accessor(pt.source, context2);
  };
}
function wrapGetValueFunc(getValue2, context2 = {}) {
  return (pts) => {
    context2.indices = pts.map((pt) => pt.index);
    return getValue2(pts.map((pt) => pt.source), context2);
  };
}
const defaultColorRange = [
  [255, 255, 178],
  [254, 217, 118],
  [254, 178, 76],
  [253, 141, 60],
  [240, 59, 32],
  [189, 0, 38]
];
function colorRangeToFlatArray(colorRange, normalize5 = false, ArrayType2 = Float32Array) {
  let flatArray;
  if (Number.isFinite(colorRange[0])) {
    flatArray = new ArrayType2(colorRange);
  } else {
    flatArray = new ArrayType2(colorRange.length * 4);
    let index2 = 0;
    for (let i2 = 0; i2 < colorRange.length; i2++) {
      const color = colorRange[i2];
      flatArray[index2++] = color[0];
      flatArray[index2++] = color[1];
      flatArray[index2++] = color[2];
      flatArray[index2++] = Number.isFinite(color[3]) ? color[3] : 255;
    }
  }
  if (normalize5) {
    for (let i2 = 0; i2 < flatArray.length; i2++) {
      flatArray[i2] /= 255;
    }
  }
  return flatArray;
}
function filterProps(props, filterKeys) {
  const filteredProps = {};
  for (const key in props) {
    if (!filterKeys.includes(key)) {
      filteredProps[key] = props[key];
    }
  }
  return filteredProps;
}
const _AggregationLayer = class extends CompositeLayer {
  initializeAggregationLayer(dimensions) {
    super.initializeState(this.context);
    this.setState({
      // Layer props , when changed doesn't require updating aggregation
      ignoreProps: filterProps(this.constructor._propTypes, dimensions.data.props),
      dimensions
    });
  }
  updateState(opts) {
    super.updateState(opts);
    const { changeFlags } = opts;
    if (changeFlags.extensionsChanged) {
      const shaders = this.getShaders({});
      if (shaders && shaders.defines) {
        shaders.defines.NON_INSTANCED_MODEL = 1;
      }
      this.updateShaders(shaders);
    }
    this._updateAttributes();
  }
  updateAttributes(changedAttributes) {
    this.setState({ changedAttributes });
  }
  getAttributes() {
    return this.getAttributeManager().getAttributes();
  }
  getModuleSettings() {
    const { viewport, mousePosition, device } = this.context;
    const moduleSettings = Object.assign(Object.create(this.props), {
      viewport,
      mousePosition,
      picking: {
        isActive: 0
      },
      // @ts-expect-error TODO - assuming WebGL context
      devicePixelRatio: device.canvasContext.cssToDeviceRatio()
    });
    return moduleSettings;
  }
  updateShaders(shaders) {
  }
  /**
   * Checks if aggregation is dirty
   * @param {Object} updateOpts - object {props, oldProps, changeFlags}
   * @param {Object} params - object {dimension, compareAll}
   * @param {Object} params.dimension - {props, accessors} array of props and/or accessors
   * @param {Boolean} params.compareAll - when `true` it will include non layer props for comparision
   * @returns {Boolean} - returns true if dimensions' prop or accessor is changed
   **/
  isAggregationDirty(updateOpts, params2 = {}) {
    const { props, oldProps, changeFlags } = updateOpts;
    const { compareAll = false, dimension } = params2;
    const { ignoreProps } = this.state;
    const { props: dataProps, accessors = [] } = dimension;
    const { updateTriggersChanged } = changeFlags;
    if (changeFlags.dataChanged) {
      return true;
    }
    if (updateTriggersChanged) {
      if (updateTriggersChanged.all) {
        return true;
      }
      for (const accessor of accessors) {
        if (updateTriggersChanged[accessor]) {
          return true;
        }
      }
    }
    if (compareAll) {
      if (changeFlags.extensionsChanged) {
        return true;
      }
      return compareProps({
        oldProps,
        newProps: props,
        ignoreProps,
        propTypes: this.constructor._propTypes
      });
    }
    for (const name2 of dataProps) {
      if (props[name2] !== oldProps[name2]) {
        return true;
      }
    }
    return false;
  }
  /**
   * Checks if an attribute is changed
   * @param {String} name - name of the attribute
   * @returns {Boolean} - `true` if attribute `name` is changed, `false` otherwise,
   *                       If `name` is not passed or `undefiend`, `true` if any attribute is changed, `false` otherwise
   **/
  isAttributeChanged(name2) {
    const { changedAttributes } = this.state;
    if (!name2) {
      return !isObjectEmpty(changedAttributes);
    }
    return changedAttributes && changedAttributes[name2] !== void 0;
  }
  // Private
  // override Composite layer private method to create AttributeManager instance
  _getAttributeManager() {
    return new AttributeManager(this.context.device, {
      id: this.props.id,
      stats: this.context.stats
    });
  }
};
let AggregationLayer = _AggregationLayer;
(() => {
  _AggregationLayer.layerName = "AggregationLayer";
})();
function isObjectEmpty(obj) {
  let isEmpty6 = true;
  for (const key in obj) {
    isEmpty6 = false;
    break;
  }
  return isEmpty6;
}
function getScale(domain, range2, scaleFunction) {
  const scale5 = scaleFunction;
  scale5.domain = () => domain;
  scale5.range = () => range2;
  return scale5;
}
function getQuantizeScale(domain, range2) {
  const scaleFunction = (value) => quantizeScale(domain, range2, value);
  return getScale(domain, range2, scaleFunction);
}
function getLinearScale(domain, range2) {
  const scaleFunction = (value) => linearScale(domain, range2, value);
  return getScale(domain, range2, scaleFunction);
}
function getQuantileScale(domain, range2) {
  const sortedDomain = domain.sort(ascending$1);
  let i2 = 0;
  const n2 = Math.max(1, range2.length);
  const thresholds = new Array(n2 - 1);
  while (++i2 < n2) {
    thresholds[i2 - 1] = threshold(sortedDomain, i2 / n2);
  }
  const scaleFunction = (value) => thresholdsScale(thresholds, range2, value);
  scaleFunction.thresholds = () => thresholds;
  return getScale(domain, range2, scaleFunction);
}
function ascending$1(a2, b2) {
  return a2 - b2;
}
function threshold(domain, fraction) {
  const domainLength = domain.length;
  if (fraction <= 0 || domainLength < 2) {
    return domain[0];
  }
  if (fraction >= 1) {
    return domain[domainLength - 1];
  }
  const domainFraction = (domainLength - 1) * fraction;
  const lowIndex = Math.floor(domainFraction);
  const low = domain[lowIndex];
  const high = domain[lowIndex + 1];
  return low + (high - low) * (domainFraction - lowIndex);
}
function bisectRight(a2, x2) {
  let lo = 0;
  let hi = a2.length;
  while (lo < hi) {
    const mid = lo + hi >>> 1;
    if (ascending$1(a2[mid], x2) > 0) {
      hi = mid;
    } else {
      lo = mid + 1;
    }
  }
  return lo;
}
function thresholdsScale(thresholds, range2, value) {
  return range2[bisectRight(thresholds, value)];
}
function ordinalScale(domain, domainMap, range2, value) {
  const key = `${value}`;
  let d2 = domainMap.get(key);
  if (d2 === void 0) {
    d2 = domain.push(value);
    domainMap.set(key, d2);
  }
  return range2[(d2 - 1) % range2.length];
}
function getOrdinalScale(domain, range2) {
  const domainMap = /* @__PURE__ */ new Map();
  const uniqueDomain = [];
  for (const d2 of domain) {
    const key = `${d2}`;
    if (!domainMap.has(key)) {
      domainMap.set(key, uniqueDomain.push(d2));
    }
  }
  const scaleFunction = (value) => ordinalScale(uniqueDomain, domainMap, range2, value);
  return getScale(domain, range2, scaleFunction);
}
function quantizeScale(domain, range2, value) {
  const domainRange = domain[1] - domain[0];
  if (domainRange <= 0) {
    log$1.warn("quantizeScale: invalid domain, returning range[0]")();
    return range2[0];
  }
  const step = domainRange / range2.length;
  const idx = Math.floor((value - domain[0]) / step);
  const clampIdx = Math.max(Math.min(idx, range2.length - 1), 0);
  return range2[clampIdx];
}
function linearScale(domain, range2, value) {
  return (value - domain[0]) / (domain[1] - domain[0]) * (range2[1] - range2[0]) + range2[0];
}
function notNullOrUndefined(d2) {
  return d2 !== void 0 && d2 !== null;
}
function unique(values4) {
  const results = [];
  values4.forEach((v5) => {
    if (!results.includes(v5) && notNullOrUndefined(v5)) {
      results.push(v5);
    }
  });
  return results;
}
function getTruthyValues(data2, valueAccessor) {
  const values4 = typeof valueAccessor === "function" ? data2.map(valueAccessor) : data2;
  return values4.filter(notNullOrUndefined);
}
function getQuantileDomain(data2, valueAccessor) {
  return getTruthyValues(data2, valueAccessor);
}
function getOrdinalDomain(data2, valueAccessor) {
  return unique(getTruthyValues(data2, valueAccessor));
}
function clamp$1(value, min4, max3) {
  return Math.max(min4, Math.min(max3, value));
}
function getScaleFunctionByScaleType(scaleType) {
  switch (scaleType) {
    case "quantize":
      return getQuantizeScale;
    case "linear":
      return getLinearScale;
    case "quantile":
      return getQuantileScale;
    case "ordinal":
      return getOrdinalScale;
    default:
      return getQuantizeScale;
  }
}
const defaultGetValue = (points2) => points2.length;
const MAX_32_BIT_FLOAT = 3402823466e29;
const defaultGetPoints = (bin) => bin.points;
const defaultGetIndex = (bin) => bin.index;
const ascending = (a2, b2) => a2 < b2 ? -1 : a2 > b2 ? 1 : a2 >= b2 ? 0 : NaN;
const defaultProps$2 = {
  getValue: defaultGetValue,
  getPoints: defaultGetPoints,
  getIndex: defaultGetIndex,
  filterData: null
};
class BinSorter {
  constructor(bins = [], props = defaultProps$2) {
    this.aggregatedBins = this.getAggregatedBins(bins, props);
    this._updateMinMaxValues();
    this.binMap = this.getBinMap();
  }
  /**
   * Get an array of object with aggregated values and index of bins
   * Array object will be sorted by value optionally.
   * @param {Array} bins
   * @param {Function} getValue
   * @return {Array} array of values and index lookup
   */
  getAggregatedBins(bins, props) {
    const { getValue: getValue2 = defaultGetValue, getPoints: getPoints4 = defaultGetPoints, getIndex = defaultGetIndex, filterData } = props;
    const hasFilter = typeof filterData === "function";
    const binCount = bins.length;
    const aggregatedBins = [];
    let index2 = 0;
    for (let binIndex = 0; binIndex < binCount; binIndex++) {
      const bin = bins[binIndex];
      const points2 = getPoints4(bin);
      const i2 = getIndex(bin);
      const filteredPoints = hasFilter ? points2.filter(filterData) : points2;
      bin.filteredPoints = hasFilter ? filteredPoints : null;
      const value = filteredPoints.length ? getValue2(filteredPoints) : null;
      if (value !== null && value !== void 0) {
        aggregatedBins[index2] = {
          i: Number.isFinite(i2) ? i2 : binIndex,
          value,
          counts: filteredPoints.length
        };
        index2++;
      }
    }
    return aggregatedBins;
  }
  _percentileToIndex(percentileRange) {
    const len2 = this.sortedBins.length;
    if (len2 < 2) {
      return [0, 0];
    }
    const [lower, upper] = percentileRange.map((n2) => clamp$1(n2, 0, 100));
    const lowerIdx = Math.ceil(lower / 100 * (len2 - 1));
    const upperIdx = Math.floor(upper / 100 * (len2 - 1));
    return [lowerIdx, upperIdx];
  }
  /**
   * Get a mapping from cell/hexagon index to sorted bin
   * This is used to retrieve bin value for color calculation
   * @return {Object} bin index to aggregatedBins
   */
  getBinMap() {
    const binMap = {};
    for (const bin of this.aggregatedBins) {
      binMap[bin.i] = bin;
    }
    return binMap;
  }
  // Private
  /**
   * Get ths max count of all bins
   */
  _updateMinMaxValues() {
    let maxCount = 0;
    let maxValue = 0;
    let minValue = MAX_32_BIT_FLOAT;
    let totalCount = 0;
    for (const x2 of this.aggregatedBins) {
      maxCount = maxCount > x2.counts ? maxCount : x2.counts;
      maxValue = maxValue > x2.value ? maxValue : x2.value;
      minValue = minValue < x2.value ? minValue : x2.value;
      totalCount += x2.counts;
    }
    this.maxCount = maxCount;
    this.maxValue = maxValue;
    this.minValue = minValue;
    this.totalCount = totalCount;
  }
  /**
   * Get range of values of all bins
   * @param {Number[]} range
   * @param {Number} range[0] - lower bound
   * @param {Number} range[1] - upper bound
   * @return {Array} array of new value range
   */
  getValueRange(percentileRange) {
    if (!this.sortedBins) {
      this.sortedBins = this.aggregatedBins.sort((a2, b2) => ascending(a2.value, b2.value));
    }
    if (!this.sortedBins.length) {
      return [];
    }
    let lowerIdx = 0;
    let upperIdx = this.sortedBins.length - 1;
    if (Array.isArray(percentileRange)) {
      const idxRange = this._percentileToIndex(percentileRange);
      lowerIdx = idxRange[0];
      upperIdx = idxRange[1];
    }
    return [this.sortedBins[lowerIdx].value, this.sortedBins[upperIdx].value];
  }
  getValueDomainByScale(scale5, [lower = 0, upper = 100] = []) {
    if (!this.sortedBins) {
      this.sortedBins = this.aggregatedBins.sort((a2, b2) => ascending(a2.value, b2.value));
    }
    if (!this.sortedBins.length) {
      return [];
    }
    const indexEdge = this._percentileToIndex([lower, upper]);
    return this._getScaleDomain(scale5, indexEdge);
  }
  _getScaleDomain(scaleType, [lowerIdx, upperIdx]) {
    const bins = this.sortedBins;
    switch (scaleType) {
      case "quantize":
      case "linear":
        return [bins[lowerIdx].value, bins[upperIdx].value];
      case "quantile":
        return getQuantileDomain(bins.slice(lowerIdx, upperIdx + 1), (d2) => d2.value);
      case "ordinal":
        return getOrdinalDomain(bins, (d2) => d2.value);
      default:
        return [bins[lowerIdx].value, bins[upperIdx].value];
    }
  }
}
function noop$1() {
}
const dimensionSteps = ["getBins", "getDomain", "getScaleFunc"];
const defaultDimensions = [
  {
    key: "fillColor",
    accessor: "getFillColor",
    pickingInfo: "colorValue",
    getBins: {
      triggers: {
        value: {
          prop: "getColorValue",
          updateTrigger: "getColorValue"
        },
        weight: {
          prop: "getColorWeight",
          updateTrigger: "getColorWeight"
        },
        aggregation: {
          prop: "colorAggregation"
        },
        filterData: {
          prop: "_filterData",
          updateTrigger: "_filterData"
        }
      }
    },
    getDomain: {
      triggers: {
        lowerPercentile: {
          prop: "lowerPercentile"
        },
        upperPercentile: {
          prop: "upperPercentile"
        },
        scaleType: {
          prop: "colorScaleType"
        }
      }
    },
    getScaleFunc: {
      triggers: {
        domain: { prop: "colorDomain" },
        range: { prop: "colorRange" }
      },
      onSet: {
        props: "onSetColorDomain"
      }
    },
    nullValue: [0, 0, 0, 0]
  },
  {
    key: "elevation",
    accessor: "getElevation",
    pickingInfo: "elevationValue",
    getBins: {
      triggers: {
        value: {
          prop: "getElevationValue",
          updateTrigger: "getElevationValue"
        },
        weight: {
          prop: "getElevationWeight",
          updateTrigger: "getElevationWeight"
        },
        aggregation: {
          prop: "elevationAggregation"
        },
        filterData: {
          prop: "_filterData",
          updateTrigger: "_filterData"
        }
      }
    },
    getDomain: {
      triggers: {
        lowerPercentile: {
          prop: "elevationLowerPercentile"
        },
        upperPercentile: {
          prop: "elevationUpperPercentile"
        },
        scaleType: {
          prop: "elevationScaleType"
        }
      }
    },
    getScaleFunc: {
      triggers: {
        domain: { prop: "elevationDomain" },
        range: { prop: "elevationRange" }
      },
      onSet: {
        props: "onSetElevationDomain"
      }
    },
    nullValue: -1
  }
];
const defaultGetCellSize = (props) => props.cellSize;
class CPUAggregator {
  constructor(opts) {
    this.state = {
      layerData: {
        data: void 0
      },
      dimensions: {
        // color: {
        //   getValue: null,
        //   domain: null,
        //   sortedBins: null,
        //   scaleFunc: noop
        // },
        // elevation: {
        //   getValue: null,
        //   domain: null,
        //   sortedBins: null,
        //   scaleFunc: noop
        // }
      }
    };
    this.changeFlags = {};
    this.dimensionUpdaters = {};
    this._getCellSize = opts.getCellSize || defaultGetCellSize;
    this._getAggregator = opts.getAggregator;
    this._addDimension(opts.dimensions || defaultDimensions);
  }
  static defaultDimensions() {
    return defaultDimensions;
  }
  updateState(opts, aggregationParams) {
    const { oldProps, props, changeFlags } = opts;
    this.updateGetValueFuncs(oldProps, props, changeFlags);
    const reprojectNeeded = this.needsReProjectPoints(oldProps, props, changeFlags);
    let aggregationDirty = false;
    if (changeFlags.dataChanged || reprojectNeeded) {
      this.getAggregatedData(props, aggregationParams);
      aggregationDirty = true;
    } else {
      const dimensionChanges = this.getDimensionChanges(oldProps, props, changeFlags) || [];
      dimensionChanges.forEach((f2) => typeof f2 === "function" && f2());
      aggregationDirty = true;
    }
    this.setState({ aggregationDirty });
    return this.state;
  }
  // Update private state
  setState(updateObject) {
    this.state = { ...this.state, ...updateObject };
  }
  // Update private state.dimensions
  setDimensionState(key, updateObject) {
    this.setState({
      dimensions: {
        ...this.state.dimensions,
        [key]: { ...this.state.dimensions[key], ...updateObject }
      }
    });
  }
  normalizeResult(result = {}) {
    if (result.hexagons) {
      return { data: result.hexagons, ...result };
    } else if (result.layerData) {
      return { data: result.layerData, ...result };
    }
    return result;
  }
  getAggregatedData(props, aggregationParams) {
    const aggregator = this._getAggregator(props);
    const result = aggregator(props, aggregationParams);
    this.setState({
      layerData: this.normalizeResult(result)
    });
    this.changeFlags = {
      layerData: true
    };
    this.getSortedBins(props);
  }
  updateGetValueFuncs(oldProps, props, changeFlags) {
    for (const key in this.dimensionUpdaters) {
      const { value, weight, aggregation } = this.dimensionUpdaters[key].getBins.triggers;
      let getValue2 = props[value.prop];
      const getValueChanged = this.needUpdateDimensionStep(this.dimensionUpdaters[key].getBins, oldProps, props, changeFlags);
      if (getValueChanged) {
        if (getValue2) {
          getValue2 = wrapGetValueFunc(getValue2, { data: props.data });
        } else {
          getValue2 = getValueFunc(props[aggregation.prop], props[weight.prop], { data: props.data });
        }
      }
      if (getValue2) {
        this.setDimensionState(key, { getValue: getValue2 });
      }
    }
  }
  needsReProjectPoints(oldProps, props, changeFlags) {
    return this._getCellSize(oldProps) !== this._getCellSize(props) || this._getAggregator(oldProps) !== this._getAggregator(props) || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged.getPosition);
  }
  // Adds dimensions
  addDimension(dimensions) {
    this._addDimension(dimensions);
  }
  _addDimension(dimensions = []) {
    dimensions.forEach((dimension) => {
      const { key } = dimension;
      this.dimensionUpdaters[key] = this.getDimensionUpdaters(dimension);
      this.state.dimensions[key] = {
        getValue: null,
        domain: null,
        sortedBins: null,
        scaleFunc: noop$1
      };
    });
  }
  getDimensionUpdaters({ key, accessor, pickingInfo, getBins, getDomain, getScaleFunc, nullValue }) {
    return {
      key,
      accessor,
      pickingInfo,
      getBins: { updater: this.getDimensionSortedBins.bind(this), ...getBins },
      getDomain: { updater: this.getDimensionValueDomain.bind(this), ...getDomain },
      getScaleFunc: { updater: this.getDimensionScale.bind(this), ...getScaleFunc },
      attributeAccessor: this.getSubLayerDimensionAttribute(key, nullValue)
    };
  }
  needUpdateDimensionStep(dimensionStep, oldProps, props, changeFlags) {
    return Object.values(dimensionStep.triggers).some((item) => {
      if (item.updateTrigger) {
        return changeFlags.dataChanged || changeFlags.updateTriggersChanged && (changeFlags.updateTriggersChanged.all || changeFlags.updateTriggersChanged[item.updateTrigger]);
      }
      return oldProps[item.prop] !== props[item.prop];
    });
  }
  getDimensionChanges(oldProps, props, changeFlags) {
    const updaters = [];
    for (const key in this.dimensionUpdaters) {
      const needUpdate = dimensionSteps.find((step) => this.needUpdateDimensionStep(this.dimensionUpdaters[key][step], oldProps, props, changeFlags));
      if (needUpdate) {
        updaters.push(this.dimensionUpdaters[key][needUpdate].updater.bind(this, props, this.dimensionUpdaters[key]));
      }
    }
    return updaters.length ? updaters : null;
  }
  getUpdateTriggers(props) {
    const _updateTriggers = props.updateTriggers || {};
    const updateTriggers = {};
    for (const key in this.dimensionUpdaters) {
      const { accessor } = this.dimensionUpdaters[key];
      updateTriggers[accessor] = {};
      dimensionSteps.forEach((step) => {
        Object.values(this.dimensionUpdaters[key][step].triggers).forEach(({ prop, updateTrigger }) => {
          if (updateTrigger) {
            const fromProp = _updateTriggers[updateTrigger];
            if (typeof fromProp === "object" && !Array.isArray(fromProp)) {
              Object.assign(updateTriggers[accessor], fromProp);
            } else if (fromProp !== void 0) {
              updateTriggers[accessor][prop] = fromProp;
            }
          } else {
            updateTriggers[accessor][prop] = props[prop];
          }
        });
      });
    }
    return updateTriggers;
  }
  getSortedBins(props) {
    for (const key in this.dimensionUpdaters) {
      this.getDimensionSortedBins(props, this.dimensionUpdaters[key]);
    }
  }
  getDimensionSortedBins(props, dimensionUpdater) {
    const { key } = dimensionUpdater;
    const { getValue: getValue2 } = this.state.dimensions[key];
    const sortedBins = new BinSorter(this.state.layerData.data || [], {
      getValue: getValue2,
      filterData: props._filterData
    });
    this.setDimensionState(key, { sortedBins });
    this.getDimensionValueDomain(props, dimensionUpdater);
  }
  getDimensionValueDomain(props, dimensionUpdater) {
    const { getDomain, key } = dimensionUpdater;
    const { triggers: { lowerPercentile, upperPercentile, scaleType } } = getDomain;
    const valueDomain = this.state.dimensions[key].sortedBins.getValueDomainByScale(props[scaleType.prop], [props[lowerPercentile.prop], props[upperPercentile.prop]]);
    this.setDimensionState(key, { valueDomain });
    this.getDimensionScale(props, dimensionUpdater);
  }
  getDimensionScale(props, dimensionUpdater) {
    const { key, getScaleFunc, getDomain } = dimensionUpdater;
    const { domain, range: range2 } = getScaleFunc.triggers;
    const { scaleType } = getDomain.triggers;
    const { onSet } = getScaleFunc;
    const dimensionRange = props[range2.prop];
    const dimensionDomain = props[domain.prop] || this.state.dimensions[key].valueDomain;
    const getScaleFunction = getScaleFunctionByScaleType(scaleType && props[scaleType.prop]);
    const scaleFunc = getScaleFunction(dimensionDomain, dimensionRange);
    if (typeof onSet === "object" && typeof props[onSet.props] === "function") {
      props[onSet.props](scaleFunc.domain());
    }
    this.setDimensionState(key, { scaleFunc });
  }
  getSubLayerDimensionAttribute(key, nullValue) {
    return (cell) => {
      const { sortedBins, scaleFunc } = this.state.dimensions[key];
      const bin = sortedBins.binMap[cell.index];
      if (bin && bin.counts === 0) {
        return nullValue;
      }
      const cv = bin && bin.value;
      const domain = scaleFunc.domain();
      const isValueInDomain = cv >= domain[0] && cv <= domain[domain.length - 1];
      return isValueInDomain ? scaleFunc(cv) : nullValue;
    };
  }
  getSubLayerAccessors(props) {
    const accessors = {};
    for (const key in this.dimensionUpdaters) {
      const { accessor } = this.dimensionUpdaters[key];
      accessors[accessor] = this.getSubLayerDimensionAttribute(props, key);
    }
    return accessors;
  }
  getPickingInfo({ info }) {
    const isPicked = info.picked && info.index > -1;
    let object2 = null;
    if (isPicked) {
      const cell = this.state.layerData.data[info.index];
      const binInfo = {};
      for (const key in this.dimensionUpdaters) {
        const { pickingInfo } = this.dimensionUpdaters[key];
        const { sortedBins } = this.state.dimensions[key];
        const value = sortedBins.binMap[cell.index] && sortedBins.binMap[cell.index].value;
        binInfo[pickingInfo] = value;
      }
      object2 = Object.assign(binInfo, cell, {
        points: cell.filteredPoints || cell.points
      });
    }
    info.picked = Boolean(object2);
    info.object = object2;
    return info;
  }
  getAccessor(dimensionKey) {
    if (!this.dimensionUpdaters.hasOwnProperty(dimensionKey)) {
      return noop$1;
    }
    return this.dimensionUpdaters[dimensionKey].attributeAccessor;
  }
}
var thirdPi = Math.PI / 3, angles = [0, thirdPi, 2 * thirdPi, 3 * thirdPi, 4 * thirdPi, 5 * thirdPi];
function pointX(d2) {
  return d2[0];
}
function pointY(d2) {
  return d2[1];
}
function hexbin() {
  var x02 = 0, y02 = 0, x12 = 1, y12 = 1, x2 = pointX, y2 = pointY, r2, dx, dy;
  function hexbin2(points2) {
    var binsById = {}, bins = [], i2, n2 = points2.length;
    for (i2 = 0; i2 < n2; ++i2) {
      if (isNaN(px2 = +x2.call(null, point4 = points2[i2], i2, points2)) || isNaN(py2 = +y2.call(null, point4, i2, points2)))
        continue;
      var point4, px2, py2, pj = Math.round(py2 = py2 / dy), pi2 = Math.round(px2 = px2 / dx - (pj & 1) / 2), py1 = py2 - pj;
      if (Math.abs(py1) * 3 > 1) {
        var px1 = px2 - pi2, pi22 = pi2 + (px2 < pi2 ? -1 : 1) / 2, pj2 = pj + (py2 < pj ? -1 : 1), px22 = px2 - pi22, py22 = py2 - pj2;
        if (px1 * px1 + py1 * py1 > px22 * px22 + py22 * py22)
          pi2 = pi22 + (pj & 1 ? 1 : -1) / 2, pj = pj2;
      }
      var id = pi2 + "-" + pj, bin = binsById[id];
      if (bin)
        bin.push(point4);
      else {
        bins.push(bin = binsById[id] = [point4]);
        bin.x = (pi2 + (pj & 1) / 2) * dx;
        bin.y = pj * dy;
      }
    }
    return bins;
  }
  function hexagon(radius) {
    var x03 = 0, y03 = 0;
    return angles.map(function(angle4) {
      var x13 = Math.sin(angle4) * radius, y13 = -Math.cos(angle4) * radius, dx2 = x13 - x03, dy2 = y13 - y03;
      x03 = x13, y03 = y13;
      return [dx2, dy2];
    });
  }
  hexbin2.hexagon = function(radius) {
    return "m" + hexagon(radius == null ? r2 : +radius).join("l") + "z";
  };
  hexbin2.centers = function() {
    var centers = [], j2 = Math.round(y02 / dy), i2 = Math.round(x02 / dx);
    for (var y3 = j2 * dy; y3 < y12 + r2; y3 += dy, ++j2) {
      for (var x3 = i2 * dx + (j2 & 1) * dx / 2; x3 < x12 + dx / 2; x3 += dx) {
        centers.push([x3, y3]);
      }
    }
    return centers;
  };
  hexbin2.mesh = function() {
    var fragment2 = hexagon(r2).slice(0, 4).join("l");
    return hexbin2.centers().map(function(p2) {
      return "M" + p2 + "m" + fragment2;
    }).join("");
  };
  hexbin2.x = function(_2) {
    return arguments.length ? (x2 = _2, hexbin2) : x2;
  };
  hexbin2.y = function(_2) {
    return arguments.length ? (y2 = _2, hexbin2) : y2;
  };
  hexbin2.radius = function(_2) {
    return arguments.length ? (r2 = +_2, dx = r2 * 2 * Math.sin(thirdPi), dy = r2 * 1.5, hexbin2) : r2;
  };
  hexbin2.size = function(_2) {
    return arguments.length ? (x02 = y02 = 0, x12 = +_2[0], y12 = +_2[1], hexbin2) : [x12 - x02, y12 - y02];
  };
  hexbin2.extent = function(_2) {
    return arguments.length ? (x02 = +_2[0][0], y02 = +_2[0][1], x12 = +_2[1][0], y12 = +_2[1][1], hexbin2) : [[x02, y02], [x12, y12]];
  };
  return hexbin2.radius(1);
}
function pointToHexbin(props, aggregationParams) {
  const { data: data2, radius } = props;
  const { viewport, attributes } = aggregationParams;
  const centerLngLat = data2.length ? getPointsCenter(data2, aggregationParams) : null;
  const radiusCommon = getRadiusInCommon(radius, viewport, centerLngLat);
  const screenPoints = [];
  const { iterable, objectInfo } = createIterable(data2);
  const positions = attributes.positions.value;
  const { size: size12 } = attributes.positions.getAccessor();
  for (const object2 of iterable) {
    objectInfo.index++;
    const posIndex = objectInfo.index * size12;
    const position = [positions[posIndex], positions[posIndex + 1]];
    const arrayIsFinite = Number.isFinite(position[0]) && Number.isFinite(position[1]);
    if (arrayIsFinite) {
      screenPoints.push({
        screenCoord: viewport.projectFlat(position),
        source: object2,
        index: objectInfo.index
      });
    } else {
      log$1.warn("HexagonLayer: invalid position")();
    }
  }
  const newHexbin = hexbin().radius(radiusCommon).x((d2) => d2.screenCoord[0]).y((d2) => d2.screenCoord[1]);
  const hexagonBins = newHexbin(screenPoints);
  return {
    hexagons: hexagonBins.map((hex, index2) => ({
      position: viewport.unprojectFlat([hex.x, hex.y]),
      points: hex,
      index: index2
    })),
    radiusCommon
  };
}
function getPointsCenter(data2, aggregationParams) {
  const { attributes } = aggregationParams;
  const positions = attributes.positions.value;
  const { size: size12 } = attributes.positions.getAccessor();
  let minX2 = Infinity;
  let minY2 = Infinity;
  let maxX2 = -Infinity;
  let maxY2 = -Infinity;
  let i2;
  for (i2 = 0; i2 < size12 * data2.length; i2 += size12) {
    const x2 = positions[i2];
    const y2 = positions[i2 + 1];
    const arrayIsFinite = Number.isFinite(x2) && Number.isFinite(y2);
    if (arrayIsFinite) {
      minX2 = Math.min(x2, minX2);
      maxX2 = Math.max(x2, maxX2);
      minY2 = Math.min(y2, minY2);
      maxY2 = Math.max(y2, maxY2);
    }
  }
  return [minX2, minY2, maxX2, maxY2].every(Number.isFinite) ? [(minX2 + maxX2) / 2, (minY2 + maxY2) / 2] : null;
}
function getRadiusInCommon(radius, viewport, center2) {
  const { unitsPerMeter: unitsPerMeter2 } = viewport.getDistanceScales(center2);
  return radius * unitsPerMeter2[0];
}
function nop() {
}
const defaultProps$1 = {
  // color
  colorDomain: null,
  colorRange: defaultColorRange,
  getColorValue: { type: "accessor", value: null },
  // default value is calcuated from `getColorWeight` and `colorAggregation`
  getColorWeight: { type: "accessor", value: 1 },
  colorAggregation: "SUM",
  lowerPercentile: { type: "number", value: 0, min: 0, max: 100 },
  upperPercentile: { type: "number", value: 100, min: 0, max: 100 },
  colorScaleType: "quantize",
  onSetColorDomain: nop,
  // elevation
  elevationDomain: null,
  elevationRange: [0, 1e3],
  getElevationValue: { type: "accessor", value: null },
  // default value is calcuated from `getElevationWeight` and `elevationAggregation`
  getElevationWeight: { type: "accessor", value: 1 },
  elevationAggregation: "SUM",
  elevationLowerPercentile: { type: "number", value: 0, min: 0, max: 100 },
  elevationUpperPercentile: { type: "number", value: 100, min: 0, max: 100 },
  elevationScale: { type: "number", min: 0, value: 1 },
  elevationScaleType: "linear",
  onSetElevationDomain: nop,
  radius: { type: "number", value: 1e3, min: 1 },
  coverage: { type: "number", min: 0, max: 1, value: 1 },
  extruded: false,
  hexagonAggregator: pointToHexbin,
  getPosition: { type: "accessor", value: (x2) => x2.position },
  // Optional material for 'lighting' shader module
  material: true,
  // data filter
  _filterData: { type: "function", value: null, optional: true }
};
const _HexagonLayer = class extends AggregationLayer {
  initializeState() {
    const cpuAggregator = new CPUAggregator({
      getAggregator: (props) => props.hexagonAggregator,
      getCellSize: (props) => props.radius
    });
    this.state = {
      cpuAggregator,
      aggregatorState: cpuAggregator.state,
      vertices: null
    };
    const attributeManager = this.getAttributeManager();
    attributeManager.add({
      positions: { size: 3, type: "float64", accessor: "getPosition" }
    });
  }
  updateState(opts) {
    super.updateState(opts);
    if (opts.changeFlags.propsOrDataChanged) {
      const aggregatorState = this.state.cpuAggregator.updateState(opts, {
        viewport: this.context.viewport,
        attributes: this.getAttributes()
      });
      if (this.state.aggregatorState.layerData !== aggregatorState.layerData) {
        const { hexagonVertices } = aggregatorState.layerData || {};
        this.setState({
          vertices: hexagonVertices && this.convertLatLngToMeterOffset(hexagonVertices)
        });
      }
      this.setState({
        // make a copy of the internal state of cpuAggregator for testing
        aggregatorState
      });
    }
  }
  convertLatLngToMeterOffset(hexagonVertices) {
    const { viewport } = this.context;
    if (Array.isArray(hexagonVertices) && hexagonVertices.length === 6) {
      const vertex0 = hexagonVertices[0];
      const vertex3 = hexagonVertices[3];
      const centroid4 = [(vertex0[0] + vertex3[0]) / 2, (vertex0[1] + vertex3[1]) / 2];
      const centroidFlat = viewport.projectFlat(centroid4);
      const { metersPerUnit } = viewport.getDistanceScales(centroid4);
      const vertices = hexagonVertices.map((vt) => {
        const vtFlat = viewport.projectFlat(vt);
        return [
          (vtFlat[0] - centroidFlat[0]) * metersPerUnit[0],
          (vtFlat[1] - centroidFlat[1]) * metersPerUnit[1]
        ];
      });
      return vertices;
    }
    log$1.error("HexagonLayer: hexagonVertices needs to be an array of 6 points")();
    return null;
  }
  getPickingInfo({ info }) {
    return this.state.cpuAggregator.getPickingInfo({ info });
  }
  // create a method for testing
  _onGetSublayerColor(cell) {
    return this.state.cpuAggregator.getAccessor("fillColor")(cell);
  }
  // create a method for testing
  _onGetSublayerElevation(cell) {
    return this.state.cpuAggregator.getAccessor("elevation")(cell);
  }
  _getSublayerUpdateTriggers() {
    return this.state.cpuAggregator.getUpdateTriggers(this.props);
  }
  renderLayers() {
    const { elevationScale, extruded, coverage, material, transitions } = this.props;
    const { aggregatorState, vertices } = this.state;
    const SubLayerClass = this.getSubLayerClass("hexagon-cell", ColumnLayer);
    const updateTriggers = this._getSublayerUpdateTriggers();
    const geometry2 = vertices ? { vertices, radius: 1 } : {
      // default geometry
      // @ts-expect-error TODO - undefined property?
      radius: aggregatorState.layerData.radiusCommon || 1,
      radiusUnits: "common",
      angle: 90
    };
    return new SubLayerClass({
      ...geometry2,
      diskResolution: 6,
      elevationScale,
      extruded,
      coverage,
      material,
      getFillColor: this._onGetSublayerColor.bind(this),
      getElevation: this._onGetSublayerElevation.bind(this),
      transitions: transitions && {
        getFillColor: transitions.getColorValue || transitions.getColorWeight,
        getElevation: transitions.getElevationValue || transitions.getElevationWeight
      }
    }, this.getSubLayerProps({
      id: "hexagon-cell",
      updateTriggers
    }), {
      data: aggregatorState.layerData.data
    });
  }
};
let HexagonLayer = _HexagonLayer;
(() => {
  _HexagonLayer.layerName = "HexagonLayer";
})();
(() => {
  _HexagonLayer.defaultProps = defaultProps$1;
})();
function getBounds(points2) {
  const x2 = points2.map((p2) => p2[0]);
  const y2 = points2.map((p2) => p2[1]);
  const xMin = Math.min.apply(null, x2);
  const xMax = Math.max.apply(null, x2);
  const yMin = Math.min.apply(null, y2);
  const yMax = Math.max.apply(null, y2);
  return [xMin, yMin, xMax, yMax];
}
function boundsContain(currentBounds, targetBounds) {
  if (targetBounds[0] >= currentBounds[0] && targetBounds[2] <= currentBounds[2] && targetBounds[1] >= currentBounds[1] && targetBounds[3] <= currentBounds[3]) {
    return true;
  }
  return false;
}
const scratchArray = new Float32Array(12);
function packVertices(points2, dimensions = 2) {
  let index2 = 0;
  for (const point4 of points2) {
    for (let i2 = 0; i2 < dimensions; i2++) {
      scratchArray[index2++] = point4[i2] || 0;
    }
  }
  return scratchArray;
}
function scaleToAspectRatio(boundingBox, width, height) {
  const [xMin, yMin, xMax, yMax] = boundingBox;
  const currentWidth = xMax - xMin;
  const currentHeight = yMax - yMin;
  let newWidth = currentWidth;
  let newHeight = currentHeight;
  if (currentWidth / currentHeight < width / height) {
    newWidth = width / height * currentHeight;
  } else {
    newHeight = height / width * currentWidth;
  }
  if (newWidth < width) {
    newWidth = width;
    newHeight = height;
  }
  const xCenter = (xMax + xMin) / 2;
  const yCenter = (yMax + yMin) / 2;
  return [
    xCenter - newWidth / 2,
    yCenter - newHeight / 2,
    xCenter + newWidth / 2,
    yCenter + newHeight / 2
  ];
}
function getTextureCoordinates(point4, bounds) {
  const [xMin, yMin, xMax, yMax] = bounds;
  return [(point4[0] - xMin) / (xMax - xMin), (point4[1] - yMin) / (yMax - yMin)];
}
const vs = `#version 300 es
#define SHADER_NAME heatp-map-layer-vertex-shader
uniform sampler2D maxTexture;
uniform float intensity;
uniform vec2 colorDomain;
uniform float threshold;
uniform float aggregationMode;
in vec3 positions;
in vec2 texCoords;
out vec2 vTexCoords;
out float vIntensityMin;
out float vIntensityMax;
void main(void) {
gl_Position = project_position_to_clipspace(positions, vec3(0.0), vec3(0.0));
vTexCoords = texCoords;
vec4 maxTexture = texture(maxTexture, vec2(0.5));
float maxValue = aggregationMode < 0.5 ? maxTexture.r : maxTexture.g;
float minValue = maxValue * threshold;
if (colorDomain[1] > 0.) {
maxValue = colorDomain[1];
minValue = colorDomain[0];
}
vIntensityMax = intensity / maxValue;
vIntensityMin = intensity / minValue;
}
`;
const fs = `#version 300 es
#define SHADER_NAME triangle-layer-fragment-shader
precision highp float;
uniform float opacity;
uniform sampler2D weightsTexture;
uniform sampler2D colorTexture;
uniform float aggregationMode;
in vec2 vTexCoords;
in float vIntensityMin;
in float vIntensityMax;
out vec4 fragColor;
vec4 getLinearColor(float value) {
float factor = clamp(value * vIntensityMax, 0., 1.);
vec4 color = texture(colorTexture, vec2(factor, 0.5));
color.a *= min(value * vIntensityMin, 1.0);
return color;
}
void main(void) {
vec4 weights = texture(weightsTexture, vTexCoords);
float weight = weights.r;
if (aggregationMode > 0.5) {
weight /= max(1.0, weights.a);
}
if (weight <= 0.) {
discard;
}
vec4 linearColor = getLinearColor(weight);
linearColor.a *= opacity;
fragColor = linearColor;
}
`;
const _TriangleLayer = class extends Layer {
  getShaders() {
    return { vs, fs, modules: [project32] };
  }
  initializeState({ device }) {
    this.setState({ model: this._getModel(device) });
  }
  _getModel(device) {
    const { vertexCount, data: data2, weightsTexture, maxTexture, colorTexture } = this.props;
    return new Model(device, {
      ...this.getShaders(),
      id: this.props.id,
      bindings: { weightsTexture, maxTexture, colorTexture },
      attributes: data2.attributes,
      bufferLayout: [
        { name: "positions", format: "float32x3" },
        { name: "texCoords", format: "float32x2" }
      ],
      topology: "triangle-fan-webgl",
      vertexCount
    });
  }
  draw({ uniforms }) {
    const { model } = this.state;
    const { intensity, threshold: threshold2, aggregationMode, colorDomain } = this.props;
    model.setUniforms({
      ...uniforms,
      intensity,
      threshold: threshold2,
      aggregationMode,
      colorDomain
    });
    model.draw(this.context.renderPass);
  }
};
let TriangleLayer = _TriangleLayer;
(() => {
  _TriangleLayer.layerName = "TriangleLayer";
})();
const weightsVs = `#version 300 es
in vec3 positions;
in vec3 positions64Low;
in float weights;
out vec4 weightsTexture;
uniform float radiusPixels;
uniform float textureWidth;
uniform vec4 commonBounds;
uniform float weightsScale;
void main()
{
weightsTexture = vec4(weights * weightsScale, 0., 0., 1.);
float radiusTexels = project_pixel_size(radiusPixels) * textureWidth / (commonBounds.z - commonBounds.x);
gl_PointSize = radiusTexels * 2.;
vec3 commonPosition = project_position(positions, positions64Low);
gl_Position.xy = (commonPosition.xy - commonBounds.xy) / (commonBounds.zw - commonBounds.xy) ;
gl_Position.xy = (gl_Position.xy * 2.) - (1.);
gl_Position.w = 1.0;
}
`;
const weightsFs = `#version 300 es
in vec4 weightsTexture;
out vec4 fragColor;
float gaussianKDE(float u){
return pow(2.71828, -u*u/0.05555)/(1.77245385*0.166666);
}
void main()
{
float dist = length(gl_PointCoord - vec2(0.5, 0.5));
if (dist > 0.5) {
discard;
}
fragColor = weightsTexture * gaussianKDE(2. * dist);
DECKGL_FILTER_COLOR(fragColor, geometry);
}
`;
const maxVs = `#version 300 es
uniform sampler2D inTexture;
uniform float textureSize;
out vec4 outTexture;
void main()
{
int yIndex = gl_VertexID / int(textureSize);
int xIndex = gl_VertexID - (yIndex * int(textureSize));
vec2 uv = (0.5 + vec2(float(xIndex), float(yIndex))) / textureSize;
outTexture = texture(inTexture, uv);
gl_Position = vec4(0.0, 0.0, 0.0, 1.0);
gl_PointSize = 1.0;
}
`;
const maxFs = `#version 300 es
in vec4 outTexture;
out vec4 fragColor;
void main() {
fragColor = outTexture;
fragColor.g = outTexture.r / max(1.0, outTexture.a);
}
`;
const RESOLUTION = 2;
const TEXTURE_PROPS = {
  format: "rgba8unorm",
  mipmaps: false,
  sampler: {
    minFilter: "linear",
    magFilter: "linear",
    addressModeU: "clamp-to-edge",
    addressModeV: "clamp-to-edge"
  }
};
const DEFAULT_COLOR_DOMAIN = [0, 0];
const AGGREGATION_MODE = {
  SUM: 0,
  MEAN: 1
};
const defaultProps = {
  getPosition: { type: "accessor", value: (x2) => x2.position },
  getWeight: { type: "accessor", value: 1 },
  intensity: { type: "number", min: 0, value: 1 },
  radiusPixels: { type: "number", min: 1, max: 100, value: 50 },
  colorRange: defaultColorRange,
  threshold: { type: "number", min: 0, max: 1, value: 0.05 },
  colorDomain: { type: "array", value: null, optional: true },
  // 'SUM' or 'MEAN'
  aggregation: "SUM",
  weightsTextureSize: { type: "number", min: 128, max: 2048, value: 2048 },
  debounceTimeout: { type: "number", min: 0, max: 1e3, value: 500 }
};
const FLOAT_TARGET_FEATURES = [
  "float32-renderable-webgl",
  // ability to render to float texture
  "texture-blend-float-webgl"
  // ability to blend when rendering to float texture
];
const DIMENSIONS = {
  data: {
    props: ["radiusPixels"]
  }
};
let HeatmapLayer$1 = (_e = class extends AggregationLayer {
  initializeState() {
    super.initializeAggregationLayer(DIMENSIONS);
    this.setState({ colorDomain: DEFAULT_COLOR_DOMAIN });
    this._setupTextureParams();
    this._setupAttributes();
    this._setupResources();
  }
  shouldUpdateState({ changeFlags }) {
    return changeFlags.somethingChanged;
  }
  /* eslint-disable max-statements,complexity */
  updateState(opts) {
    super.updateState(opts);
    this._updateHeatmapState(opts);
  }
  _updateHeatmapState(opts) {
    const { props, oldProps } = opts;
    const changeFlags = this._getChangeFlags(opts);
    if (changeFlags.dataChanged || changeFlags.viewportChanged) {
      changeFlags.boundsChanged = this._updateBounds(changeFlags.dataChanged);
      this._updateTextureRenderingBounds();
    }
    if (changeFlags.dataChanged || changeFlags.boundsChanged) {
      clearTimeout(this.state.updateTimer);
      this.setState({ isWeightMapDirty: true });
    } else if (changeFlags.viewportZoomChanged) {
      this._debouncedUpdateWeightmap();
    }
    if (props.colorRange !== oldProps.colorRange) {
      this._updateColorTexture(opts);
    }
    if (this.state.isWeightMapDirty) {
      this._updateWeightmap();
    }
    this.setState({ zoom: opts.context.viewport.zoom });
  }
  renderLayers() {
    const { weightsTexture, triPositionBuffer, triTexCoordBuffer, maxWeightsTexture, colorTexture, colorDomain } = this.state;
    const { updateTriggers, intensity, threshold: threshold2, aggregation } = this.props;
    const TriangleLayerClass = this.getSubLayerClass("triangle", TriangleLayer);
    return new TriangleLayerClass(this.getSubLayerProps({
      id: "triangle-layer",
      updateTriggers
    }), {
      // position buffer is filled with world coordinates generated from viewport.unproject
      // i.e. LNGLAT if geospatial, CARTESIAN otherwise
      coordinateSystem: COORDINATE_SYSTEM.DEFAULT,
      data: {
        attributes: {
          positions: triPositionBuffer,
          texCoords: triTexCoordBuffer
        }
      },
      vertexCount: 4,
      maxTexture: maxWeightsTexture,
      colorTexture,
      aggregationMode: AGGREGATION_MODE[aggregation] || 0,
      weightsTexture,
      intensity,
      threshold: threshold2,
      colorDomain
    });
  }
  finalizeState(context2) {
    super.finalizeState(context2);
    const { weightsTransform, weightsTexture, maxWeightTransform, maxWeightsTexture, triPositionBuffer, triTexCoordBuffer, colorTexture, updateTimer } = this.state;
    weightsTransform == null ? void 0 : weightsTransform.destroy();
    weightsTexture == null ? void 0 : weightsTexture.destroy();
    maxWeightTransform == null ? void 0 : maxWeightTransform.destroy();
    maxWeightsTexture == null ? void 0 : maxWeightsTexture.destroy();
    triPositionBuffer == null ? void 0 : triPositionBuffer.destroy();
    triTexCoordBuffer == null ? void 0 : triTexCoordBuffer.destroy();
    colorTexture == null ? void 0 : colorTexture.destroy();
    if (updateTimer) {
      clearTimeout(updateTimer);
    }
  }
  // PRIVATE
  // override Composite layer private method to create AttributeManager instance
  _getAttributeManager() {
    return new AttributeManager(this.context.device, {
      id: this.props.id,
      stats: this.context.stats
    });
  }
  _getChangeFlags(opts) {
    const changeFlags = {};
    const { dimensions } = this.state;
    changeFlags.dataChanged = this.isAttributeChanged() && "attribute changed" || // if any attribute is changed
    this.isAggregationDirty(opts, {
      compareAll: true,
      dimension: dimensions.data
    }) && "aggregation is dirty";
    changeFlags.viewportChanged = opts.changeFlags.viewportChanged;
    const { zoom: zoom2 } = this.state;
    if (!opts.context.viewport || opts.context.viewport.zoom !== zoom2) {
      changeFlags.viewportZoomChanged = true;
    }
    return changeFlags;
  }
  _createTextures() {
    const { textureSize, format } = this.state;
    this.setState({
      weightsTexture: this.context.device.createTexture({
        ...TEXTURE_PROPS,
        width: textureSize,
        height: textureSize,
        format
      }),
      maxWeightsTexture: this.context.device.createTexture({
        ...TEXTURE_PROPS,
        width: 1,
        height: 1,
        format
      })
    });
  }
  _setupAttributes() {
    const attributeManager = this.getAttributeManager();
    attributeManager.add({
      positions: { size: 3, type: "float64", accessor: "getPosition" },
      weights: { size: 1, accessor: "getWeight" }
    });
    this.setState({ positionAttributeName: "positions" });
  }
  _setupTextureParams() {
    const { device } = this.context;
    const { weightsTextureSize } = this.props;
    const textureSize = Math.min(weightsTextureSize, device.limits.maxTextureDimension2D);
    const floatTargetSupport = FLOAT_TARGET_FEATURES.every((feature2) => device.features.has(feature2));
    const format = floatTargetSupport ? "rgba32float" : "rgba8unorm";
    const weightsScale = floatTargetSupport ? 1 : 1 / 255;
    this.setState({ textureSize, format, weightsScale });
    if (!floatTargetSupport) {
      log$1.warn(`HeatmapLayer: ${this.id} rendering to float texture not supported, falling back to low precision format`)();
    }
  }
  _createWeightsTransform(shaders) {
    let { weightsTransform } = this.state;
    const { weightsTexture } = this.state;
    const attributeManager = this.getAttributeManager();
    weightsTransform == null ? void 0 : weightsTransform.destroy();
    weightsTransform = new TextureTransform(this.context.device, {
      id: `${this.id}-weights-transform`,
      bufferLayout: attributeManager.getBufferLayouts(),
      vertexCount: 1,
      targetTexture: weightsTexture,
      parameters: {
        depthWriteEnabled: false,
        blendColorOperation: "add",
        blendColorSrcFactor: "one",
        blendColorDstFactor: "one",
        blendAlphaSrcFactor: "one",
        blendAlphaDstFactor: "one"
      },
      topology: "point-list",
      ...shaders
    });
    this.setState({ weightsTransform });
  }
  _setupResources() {
    this._createTextures();
    const { device } = this.context;
    const { textureSize, weightsTexture, maxWeightsTexture } = this.state;
    const weightsTransformShaders = this.getShaders({
      vs: weightsVs,
      fs: weightsFs
    });
    this._createWeightsTransform(weightsTransformShaders);
    const maxWeightsTransformShaders = this.getShaders({ vs: maxVs, fs: maxFs });
    const maxWeightTransform = new TextureTransform(device, {
      id: `${this.id}-max-weights-transform`,
      bindings: { inTexture: weightsTexture },
      uniforms: { textureSize },
      targetTexture: maxWeightsTexture,
      ...maxWeightsTransformShaders,
      vertexCount: textureSize * textureSize,
      topology: "point-list",
      parameters: {
        depthWriteEnabled: false,
        blendColorOperation: "max",
        blendAlphaOperation: "max",
        blendColorSrcFactor: "one",
        blendColorDstFactor: "one",
        blendAlphaSrcFactor: "one",
        blendAlphaDstFactor: "one"
      }
    });
    this.setState({
      weightsTexture,
      maxWeightsTexture,
      maxWeightTransform,
      zoom: null,
      triPositionBuffer: device.createBuffer({ byteLength: 48 }),
      triTexCoordBuffer: device.createBuffer({ byteLength: 48 })
    });
  }
  // overwrite super class method to update transform model
  updateShaders(shaderOptions) {
    this._createWeightsTransform({
      vs: weightsVs,
      fs: weightsFs,
      ...shaderOptions
    });
  }
  _updateMaxWeightValue() {
    const { maxWeightTransform } = this.state;
    maxWeightTransform.run({
      parameters: { viewport: [0, 0, 1, 1] },
      clearColor: [0, 0, 0, 0]
    });
  }
  // Computes world bounds area that needs to be processed for generate heatmap
  _updateBounds(forceUpdate = false) {
    const { viewport } = this.context;
    const viewportCorners = [
      viewport.unproject([0, 0]),
      viewport.unproject([viewport.width, 0]),
      viewport.unproject([viewport.width, viewport.height]),
      viewport.unproject([0, viewport.height])
    ].map((p2) => p2.map(Math.fround));
    const visibleWorldBounds = getBounds(viewportCorners);
    const newState = { visibleWorldBounds, viewportCorners };
    let boundsChanged = false;
    if (forceUpdate || !this.state.worldBounds || !boundsContain(this.state.worldBounds, visibleWorldBounds)) {
      const scaledCommonBounds = this._worldToCommonBounds(visibleWorldBounds);
      const worldBounds = this._commonToWorldBounds(scaledCommonBounds);
      if (this.props.coordinateSystem === COORDINATE_SYSTEM.LNGLAT) {
        worldBounds[1] = Math.max(worldBounds[1], -85.051129);
        worldBounds[3] = Math.min(worldBounds[3], 85.051129);
        worldBounds[0] = Math.max(worldBounds[0], -360);
        worldBounds[2] = Math.min(worldBounds[2], 360);
      }
      const normalizedCommonBounds = this._worldToCommonBounds(worldBounds);
      newState.worldBounds = worldBounds;
      newState.normalizedCommonBounds = normalizedCommonBounds;
      boundsChanged = true;
    }
    this.setState(newState);
    return boundsChanged;
  }
  _updateTextureRenderingBounds() {
    const { triPositionBuffer, triTexCoordBuffer, normalizedCommonBounds, viewportCorners } = this.state;
    const { viewport } = this.context;
    triPositionBuffer.write(packVertices(viewportCorners, 3));
    const textureBounds = viewportCorners.map((p2) => getTextureCoordinates(viewport.projectPosition(p2), normalizedCommonBounds));
    triTexCoordBuffer.write(packVertices(textureBounds, 2));
  }
  _updateColorTexture(opts) {
    const { colorRange } = opts.props;
    let { colorTexture } = this.state;
    const colors = colorRangeToFlatArray(colorRange, false, Uint8Array);
    if (colorTexture && (colorTexture == null ? void 0 : colorTexture.width) === colorRange.length) {
      colorTexture.setSubImageData({ data: colors });
    } else {
      colorTexture == null ? void 0 : colorTexture.destroy();
      colorTexture = this.context.device.createTexture({
        ...TEXTURE_PROPS,
        data: colors,
        width: colorRange.length,
        height: 1
      });
    }
    this.setState({ colorTexture });
  }
  _updateWeightmap() {
    const { radiusPixels, colorDomain, aggregation } = this.props;
    const { worldBounds, textureSize, weightsScale } = this.state;
    const weightsTransform = this.state.weightsTransform;
    this.state.isWeightMapDirty = false;
    const commonBounds = this._worldToCommonBounds(worldBounds, {
      useLayerCoordinateSystem: true
    });
    if (colorDomain && aggregation === "SUM") {
      const { viewport } = this.context;
      const metersPerPixel2 = viewport.distanceScales.metersPerUnit[2] * (commonBounds[2] - commonBounds[0]) / textureSize;
      this.state.colorDomain = colorDomain.map((x2) => x2 * metersPerPixel2 * weightsScale);
    } else {
      this.state.colorDomain = colorDomain || DEFAULT_COLOR_DOMAIN;
    }
    const attributeManager = this.getAttributeManager();
    const attributes = attributeManager.getAttributes();
    const moduleSettings = this.getModuleSettings();
    const positions = attributes.positions.buffer;
    const uniforms = { radiusPixels, commonBounds, textureWidth: textureSize, weightsScale };
    const weights = attributes.weights.buffer;
    weightsTransform.model.setAttributes({ positions, weights });
    weightsTransform.model.setVertexCount(this.getNumInstances());
    weightsTransform.model.setUniforms(uniforms);
    weightsTransform.model.updateModuleSettings(moduleSettings);
    weightsTransform.run({
      parameters: { viewport: [0, 0, textureSize, textureSize] },
      clearColor: [0, 0, 0, 0]
    });
    this._updateMaxWeightValue();
  }
  _debouncedUpdateWeightmap(fromTimer = false) {
    let { updateTimer } = this.state;
    const { debounceTimeout } = this.props;
    if (fromTimer) {
      updateTimer = null;
      this._updateBounds(true);
      this._updateTextureRenderingBounds();
      this.setState({ isWeightMapDirty: true });
    } else {
      this.setState({ isWeightMapDirty: false });
      clearTimeout(updateTimer);
      updateTimer = setTimeout(this._debouncedUpdateWeightmap.bind(this, true), debounceTimeout);
    }
    this.setState({ updateTimer });
  }
  // input: worldBounds: [minLong, minLat, maxLong, maxLat]
  // input: opts.useLayerCoordinateSystem : layers coordiante system is used
  // optput: commonBounds: [minX, minY, maxX, maxY] scaled to fit the current texture
  _worldToCommonBounds(worldBounds, opts = {}) {
    const { useLayerCoordinateSystem = false } = opts;
    const [minLong, minLat, maxLong, maxLat] = worldBounds;
    const { viewport } = this.context;
    const { textureSize } = this.state;
    const { coordinateSystem } = this.props;
    const offsetMode = useLayerCoordinateSystem && (coordinateSystem === COORDINATE_SYSTEM.LNGLAT_OFFSETS || coordinateSystem === COORDINATE_SYSTEM.METER_OFFSETS);
    const offsetOriginCommon = offsetMode ? viewport.projectPosition(this.props.coordinateOrigin) : [0, 0];
    const size12 = textureSize * RESOLUTION / viewport.scale;
    let bottomLeftCommon;
    let topRightCommon;
    if (useLayerCoordinateSystem && !offsetMode) {
      bottomLeftCommon = this.projectPosition([minLong, minLat, 0]);
      topRightCommon = this.projectPosition([maxLong, maxLat, 0]);
    } else {
      bottomLeftCommon = viewport.projectPosition([minLong, minLat, 0]);
      topRightCommon = viewport.projectPosition([maxLong, maxLat, 0]);
    }
    return scaleToAspectRatio([
      bottomLeftCommon[0] - offsetOriginCommon[0],
      bottomLeftCommon[1] - offsetOriginCommon[1],
      topRightCommon[0] - offsetOriginCommon[0],
      topRightCommon[1] - offsetOriginCommon[1]
    ], size12, size12);
  }
  // input commonBounds: [xMin, yMin, xMax, yMax]
  // output worldBounds: [minLong, minLat, maxLong, maxLat]
  _commonToWorldBounds(commonBounds) {
    const [xMin, yMin, xMax, yMax] = commonBounds;
    const { viewport } = this.context;
    const bottomLeftWorld = viewport.unprojectPosition([xMin, yMin]);
    const topRightWorld = viewport.unprojectPosition([xMax, yMax]);
    return bottomLeftWorld.slice(0, 2).concat(topRightWorld.slice(0, 2));
  }
}, (() => {
  _e.layerName = "HeatmapLayer";
})(), (() => {
  _e.defaultProps = defaultProps;
})(), _e);
const ColorMaps = {
  rainbow: {
    0: "rgba(0,0,255,0)",
    0.2: "#00FFFF",
    0.5: "#00FF00",
    0.8: "#FFFF00",
    1: "#FF0000"
  },
  cooltowarm: {
    0: "#3C4EC2",
    0.2: "#9BBCFF",
    0.5: "#DCDCDC",
    0.8: "#F6A385",
    1: "#B40426"
  },
  blackbody: {
    0: "#000000",
    0.2: "#780000",
    0.5: "#E63200",
    0.8: "#FFFF00",
    1: "#FFFFFF"
  },
  grayscale: {
    0: "#000000",
    0.2: "#404040",
    0.5: "#7F7F80",
    0.8: "#BFBFBF",
    1: "#FFFFFF"
  },
  redblue: {
    0: "rgba(33,102,172,0)",
    0.2: "rgb(103,169,207)",
    0.4: "rgb(209,229,240)",
    0.6: "rgb(253,219,199)",
    0.8: "rgb(239,138,98)",
    1: "rgb(178,24,43)"
  },
  yellowtored: {
    0: "#FFEDA0",
    0.01: "#FED976",
    0.02: "#FEB24C",
    0.05: "#FD8D3C",
    0.1: "#FC4E2A",
    0.2: "#E31A1C",
    0.5: "#BD0026",
    1: "#800026"
  }
};
function convertToColorRange(colorMap) {
  var _a3;
  if (!colorMap)
    return null;
  const sortedKeys = (_a3 = Object.keys(colorMap)) == null ? void 0 : _a3.map(Number).sort((a2, b2) => a2 - b2);
  if (!(sortedKeys == null ? void 0 : sortedKeys.length))
    return null;
  const colorMapArray = sortedKeys.map((key) => ColorUtil.convertToArray(colorMap[key]));
  const colorRange = [];
  const delta = 0.2;
  let val = 0;
  while (val <= 1) {
    const color = ColorUtil.getInterpolatedColor(val, sortedKeys, colorMapArray);
    colorRange.push(color);
    val += delta;
  }
  return colorRange;
}
function getAsColorRange(colorMapKey) {
  return convertToColorRange(ColorMaps[colorMapKey]);
}
ColorMaps.getAsColorRange = (key) => getAsColorRange(key);
class DeckGlUtil {
  static createMvtLayer(params2) {
    const {
      id,
      url: url2,
      minZoom,
      maxZoom,
      getTileData,
      onDataLoad,
      colorPropName,
      lineWidth = 1,
      color: colorIn,
      onFeatures,
      valuePropName,
      indexPropName,
      colorRange,
      colorDomain,
      colorMap,
      transformRequest,
      ...rest
    } = params2;
    const {
      headers
    } = (transformRequest == null ? void 0 : transformRequest(url2, "Tile")) || {};
    const {
      getFillColor
    } = valuePropName && indexPropName && (colorRange || colorMap) ? DeckGlUtil.getPropertyMethods({
      valuePropName,
      indexPropName,
      colorDomain,
      colorRange,
      colorMap
    }) : {};
    const getColor2 = (feature2) => {
      var _a3;
      let color = colorIn;
      if (colorPropName) {
        const featureColor = (_a3 = feature2.properties) == null ? void 0 : _a3[colorPropName];
        color = typeof featureColor !== "undefined" ? featureColor : colorIn;
      }
      if (color) {
        return ColorUtil.convertToArray(color);
      }
      if (typeof getFillColor === "function") {
        return getFillColor(feature2);
      }
      return void 0;
    };
    const getLineWidth = () => lineWidth;
    const onTiles = (tiles) => {
      if (onFeatures) {
        onFeatures(tiles.flatMap((tile) => tile.dataInWGS84));
      }
    };
    const onViewportLoad = debounce$3(onTiles, 300);
    if (!id)
      return null;
    return new MVTLayer({
      id: `${id}-mvt`,
      data: [url2],
      minZoom,
      maxZoom,
      getTileData,
      onDataLoad,
      getFillColor: getColor2,
      getLineWidth,
      getLineColor: getColor2,
      getPointRadius: 2,
      pointRadiusUnits: "pixels",
      onViewportLoad,
      loadOptions: {
        fetch: {
          headers
        }
      },
      ...rest
    });
  }
  static createHeatmapLayer(params2) {
    const {
      id,
      data: data2,
      valuePropName,
      aggregation,
      radiusPixels,
      intensity,
      weightsTextureSize,
      colorRange,
      colorDomain
    } = params2;
    if (!id || !valuePropName)
      return null;
    return new HeatmapLayer$1({
      id,
      data: data2,
      aggregation,
      getPosition: (f2) => f2.geometry.coordinates,
      getWeight: (f2) => f2.properties[valuePropName],
      radiusPixels,
      intensity,
      weightsTextureSize,
      colorDomain,
      colorRange
    });
  }
  static createH3HexagonLayer(params2) {
    const {
      id,
      data: data2,
      indexPropName,
      valuePropName,
      extruded,
      elevationScale,
      pickable,
      opacity,
      colorRange,
      colorDomain,
      colorMap
    } = params2;
    const {
      getIndex,
      getValue: getValue2,
      getFillColor
    } = DeckGlUtil.getPropertyMethods({
      valuePropName,
      indexPropName,
      colorDomain,
      colorRange,
      colorMap
    });
    if (!id || !valuePropName || !indexPropName || !colorDomain || !colorRange && !colorMap)
      return null;
    return new H3HexagonLayer({
      id,
      data: data2,
      getHexagon: getIndex,
      opacity,
      getElevation: getValue2,
      elevationScale,
      getFillColor,
      extruded,
      pickable
    });
  }
  static createHexagonLayer(params2) {
    const {
      id,
      data: data2,
      valuePropName,
      aggregation,
      radius,
      colorRange,
      colorDomain,
      extruded,
      elevationScale
    } = params2;
    if (!id || !valuePropName)
      return null;
    const layer = new HexagonLayer({
      id,
      data: data2,
      colorAggregation: aggregation,
      elevationAggregation: aggregation,
      getPosition: (f2) => f2.geometry.coordinates,
      getColorWeight: (f2) => f2.properties[valuePropName],
      getElevationWeight: (f2) => f2.properties[valuePropName],
      radius,
      colorDomain,
      colorRange,
      elevationScale,
      extruded
    });
    return layer;
  }
  static createQuadLayer(params2) {
    const {
      id,
      data: data2,
      indexPropName = "quadkey",
      valuePropName,
      colorRange,
      colorDomain,
      elevationScale,
      extruded,
      opacity,
      colorMap
    } = params2;
    const {
      getIndex,
      getValue: getValue2,
      getFillColor
    } = DeckGlUtil.getPropertyMethods({
      valuePropName,
      indexPropName,
      colorDomain,
      colorRange,
      colorMap
    });
    if (!id || !valuePropName || !indexPropName || !colorDomain || !colorRange && !colorMap)
      return null;
    const layer = new QuadkeyLayer({
      id,
      data: data2,
      getQuadkey: getIndex,
      getFillColor,
      opacity,
      getElevation: getValue2,
      elevationScale,
      extruded
    });
    return layer;
  }
  static createScatterPlotLayer(params2) {
    const {
      id,
      data: data2,
      colorPropName,
      color,
      valuePropName,
      beforeId,
      radiusScale,
      radiusMinPixels,
      radiusMaxPixels,
      lineWidthScale,
      stroked,
      filled,
      lineWidthMinPixels,
      lineWidthMaxPixels
    } = params2;
    if (!id || !valuePropName)
      return null;
    return new ScatterplotLayer({
      id,
      data: data2,
      getPosition: (f2) => f2.geometry.coordinates,
      getFillColor: (f2) => f2.properties[colorPropName] || color,
      getRadius: (f2) => f2.properties[valuePropName],
      radiusScale,
      radiusMinPixels,
      radiusMaxPixels,
      lineWidthScale,
      stroked,
      filled,
      lineWidthMinPixels,
      lineWidthMaxPixels,
      beforeId
    });
  }
  static getPropertyMethods({
    valuePropName,
    indexPropName,
    colorDomain,
    colorRange: colorRangeIn,
    colorMap
  }) {
    const getValue2 = (f2) => {
      var _a3;
      const value = (f2 == null ? void 0 : f2[valuePropName]) || ((_a3 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a3[valuePropName]);
      return value;
    };
    const getIndex = (f2) => {
      var _a3;
      const index2 = (f2 == null ? void 0 : f2[indexPropName]) || ((_a3 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a3[indexPropName]);
      return index2;
    };
    const colorRange = colorRangeIn || ColorMaps.getAsColorRange(colorMap);
    const [min4, max3] = colorDomain || [];
    const delta = 1 / (colorRange.length - 1);
    const sortedKeys = [];
    let val = 0;
    while (val <= 1) {
      sortedKeys.push(val);
      val += delta;
    }
    const getFillColor = (f2) => {
      const value = getValue2(f2);
      const normalizedValue = value / (max3 - min4);
      const finalColor = ColorUtil.getInterpolatedColor(normalizedValue, sortedKeys, colorRange);
      return finalColor;
    };
    return {
      getIndex,
      getValue: getValue2,
      getFillColor
    };
  }
}
function useDeckGlMvtLayer(props) {
  const {
    id
  } = props;
  const [mvtLayer, setMvtLayer] = React__default.useState();
  const [forceUpdate, setForceUpdate] = React__default.useState(true);
  const transformRequest = useEnvStore((state) => {
    var _a3;
    return (_a3 = state == null ? void 0 : state.env) == null ? void 0 : _a3.transformRequest;
  });
  React__default.useEffect(() => {
    const DELAY = 1 * 60 * 1e3;
    const handle = setInterval(() => {
      setForceUpdate(true);
    }, DELAY);
    return () => clearInterval(handle);
  }, []);
  React__default.useLayoutEffect(() => {
    if (!id || !forceUpdate)
      return;
    const mvt = DeckGlUtil.createMvtLayer({
      ...props,
      transformRequest
    });
    setMvtLayer(mvt);
    setForceUpdate(false);
  }, [forceUpdate, id, props, transformRequest]);
  return mvtLayer;
}
function HeatmapInternal$3(props) {
  const {
    id,
    data: url2,
    valuePropName,
    beforeId,
    aggregation,
    radiusPixels,
    intensity,
    weightsTextureSize,
    colorRange,
    colorDomain,
    colorPropName,
    color,
    ...restProps
  } = props;
  const mvtLayerRef = React__default.useRef();
  const [heatmapData, setHeatmapData] = React__default.useState([]);
  const [layer, setLayer] = React__default.useState(null);
  const mvtLayer = useDeckGlMvtLayer({
    id: `${id}-mvt`,
    ref: mvtLayerRef,
    url: url2,
    colorPropName,
    color,
    onFeatures: (f2) => setHeatmapData(f2)
  });
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName || !mvtLayer)
      return;
    const heatmap = DeckGlUtil.createHeatmapLayer({
      id: `${id}-heatmap`,
      data: heatmapData,
      aggregation,
      valuePropName,
      radiusPixels,
      intensity,
      weightsTextureSize,
      colorDomain,
      colorRange
    });
    const layers = [mvtLayer, heatmap];
    setLayer(layers);
  }, [aggregation, colorDomain, colorRange, heatmapData, id, intensity, mvtLayer, radiusPixels, valuePropName, weightsTextureSize]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
HeatmapInternal$3.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  beforeId: propTypesExports$1.string,
  radiusPixels: propTypesExports$1.number,
  intensity: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorDomain: propTypesExports$1.array,
  aggregation: propTypesExports$1.oneOf(["MEAN", "SUM"]),
  weightsTextureSize: propTypesExports$1.oneOf([256, 512, 1024, 2048]),
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any
};
HeatmapInternal$3.defaultProps = {
  id: "",
  data: null,
  valuePropName: null,
  beforeId: "",
  radiusPixels: 100,
  intensity: 1,
  colorRange: [[22, 119, 255, 25], [22, 119, 255, 50], [22, 119, 255, 90], [22, 119, 255, 128], [22, 119, 255, 216]],
  colorDomain: null,
  aggregation: "MEAN",
  weightsTextureSize: 512,
  minZoom: 0,
  maxZoom: 24,
  colorPropName: null,
  color: "#FF0000"
};
function HeatmapTiles(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(HeatmapInternal$3, { ...props }) });
}
function HeatmapInternal$2(props) {
  const {
    id,
    data: data2,
    valuePropName,
    beforeId,
    aggregation,
    radiusPixels,
    intensity,
    weightsTextureSize,
    colorRange,
    colorDomain,
    ...restProps
  } = props;
  const json = useEditGeojson({
    data: data2
  });
  const features = React__default.useMemo(() => {
    var _a3;
    return (_a3 = json == null ? void 0 : json.features) == null ? void 0 : _a3.filter((f2) => f2.geometry.type === "Point");
  }, [json == null ? void 0 : json.features]);
  const [layer, setLayer] = React__default.useState();
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName)
      return;
    const layer2 = DeckGlUtil.createHeatmapLayer({
      id,
      data: features,
      aggregation,
      valuePropName,
      radiusPixels,
      intensity,
      weightsTextureSize,
      colorDomain,
      colorRange
    });
    setLayer(layer2);
  }, [beforeId, features, id, valuePropName, aggregation, radiusPixels, intensity, weightsTextureSize, colorDomain, colorRange]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
HeatmapInternal$2.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  beforeId: propTypesExports$1.string,
  radiusPixels: propTypesExports$1.number,
  intensity: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorDomain: propTypesExports$1.array,
  aggregation: propTypesExports$1.oneOf(["MEAN", "SUM"]),
  weightsTextureSize: propTypesExports$1.oneOf([256, 512, 1024, 2048])
};
HeatmapInternal$2.defaultProps = {
  id: "",
  data: null,
  valuePropName: null,
  beforeId: "",
  radiusPixels: 100,
  intensity: 1,
  colorRange: [[22, 119, 255, 25], [22, 119, 255, 50], [22, 119, 255, 90], [22, 119, 255, 128], [22, 119, 255, 216]],
  colorDomain: null,
  aggregation: "MEAN",
  weightsTextureSize: 512
};
function HeatmapGeojson(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(HeatmapInternal$2, { ...props }) });
}
function Heatmap(props) {
  const {
    type,
    ...restProps
  } = props;
  if (type === "vector")
    return /* @__PURE__ */ jsx(HeatmapTiles, { ...restProps });
  return /* @__PURE__ */ jsx(HeatmapGeojson, { ...restProps });
}
Heatmap.propTypes = {
  type: propTypesExports$1.oneOf(["vector", "geojson"])
};
Heatmap.defaultProps = {
  type: "geojson"
};
function ScatterPlotInternal(props) {
  const {
    id,
    data: data2,
    colorPropName,
    color,
    valuePropName,
    beforeId,
    radiusScale,
    radiusMinPixels,
    radiusMaxPixels,
    lineWidthScale,
    stroked,
    filled,
    lineWidthMinPixels,
    lineWidthMaxPixels,
    ...restProps
  } = props;
  const json = useEditGeojson({
    data: data2
  });
  const features = React__default.useMemo(() => {
    var _a3;
    return (_a3 = json == null ? void 0 : json.features) == null ? void 0 : _a3.filter((f2) => f2.geometry.type === "Point");
  }, [json == null ? void 0 : json.features]);
  const [layer, setLayer] = React__default.useState();
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName)
      return;
    const layer2 = DeckGlUtil.createScatterPlotLayer({
      id,
      data: features,
      valuePropName,
      colorPropName,
      color,
      radiusScale,
      radiusMinPixels,
      radiusMaxPixels,
      lineWidthScale,
      stroked,
      filled,
      lineWidthMinPixels,
      lineWidthMaxPixels,
      beforeId
    });
    setLayer(layer2);
  }, [beforeId, colorPropName, features, id, valuePropName, color, radiusScale, radiusMinPixels, radiusMaxPixels, lineWidthScale, stroked, filled, lineWidthMinPixels, lineWidthMaxPixels]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
ScatterPlotInternal.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  colorPropName: propTypesExports$1.string,
  valuePropName: propTypesExports$1.string,
  radiusScale: propTypesExports$1.number,
  color: propTypesExports$1.arrayOf(propTypesExports$1.number),
  beforeId: propTypesExports$1.string,
  radiusMinPixels: propTypesExports$1.number,
  radiusMaxPixels: propTypesExports$1.number,
  lineWidthScale: propTypesExports$1.number,
  lineWidthMinPixels: propTypesExports$1.number,
  lineWidthMaxPixels: propTypesExports$1.number,
  stroked: propTypesExports$1.bool,
  filled: propTypesExports$1.bool
};
ScatterPlotInternal.defaultProps = {
  id: "",
  data: null,
  colorPropName: "fill",
  valuePropName: null,
  radiusScale: 1,
  color: [22, 119, 255, 100],
  beforeId: "",
  radiusMinPixels: 2,
  radiusMaxPixels: Number.MAX_SAFE_INTEGER,
  lineWidthScale: 1,
  lineWidthMinPixels: 0,
  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
  stroked: false,
  filled: true
};
function ScatterPlot(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(ScatterPlotInternal, { ...props }) });
}
async function parseFromContext(data2, loaders, options2, context2) {
  return context2._parse(data2, loaders, options2, context2);
}
function assert$4(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "loader assertion failed.");
  }
}
const isBrowser$2 = (
  // @ts-ignore process does not exist on browser
  Boolean(typeof process !== "object" || String(process) !== "[object process]" || process.browser)
);
const matches$1 = typeof process !== "undefined" && process.version && /v([0-9]*)/.exec(process.version);
matches$1 && parseFloat(matches$1[1]) || 0;
function registerJSModules(modules) {
  var _a3;
  globalThis.loaders || (globalThis.loaders = {});
  (_a3 = globalThis.loaders).modules || (_a3.modules = {});
  Object.assign(globalThis.loaders.modules, modules);
}
function getJSModuleOrNull(name2) {
  var _a3, _b3;
  const module2 = (_b3 = (_a3 = globalThis.loaders) == null ? void 0 : _a3.modules) == null ? void 0 : _b3[name2];
  return module2 || null;
}
function getVersion() {
  var _a3;
  if (!((_a3 = globalThis._loadersgl_) == null ? void 0 : _a3.version)) {
    globalThis._loadersgl_ = globalThis._loadersgl_ || {};
    {
      globalThis._loadersgl_.version = "4.2.1";
    }
  }
  return globalThis._loadersgl_.version;
}
const VERSION$5 = getVersion();
function assert$3(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "loaders.gl assertion failed.");
  }
}
const isBrowser$1 = (
  // @ts-ignore process.browser
  typeof process !== "object" || String(process) !== "[object process]" || process.browser
);
const isWorker = typeof importScripts === "function";
const matches = typeof process !== "undefined" && process.version && /v([0-9]*)/.exec(process.version);
matches && parseFloat(matches[1]) || 0;
const loadLibraryPromises = {};
async function loadLibrary(libraryUrl, moduleName = null, options2 = {}, libraryName = null) {
  if (moduleName) {
    libraryUrl = getLibraryUrl(libraryUrl, moduleName, options2, libraryName);
  }
  loadLibraryPromises[libraryUrl] = // eslint-disable-next-line @typescript-eslint/no-misused-promises
  loadLibraryPromises[libraryUrl] || loadLibraryFromFile(libraryUrl);
  return await loadLibraryPromises[libraryUrl];
}
function getLibraryUrl(library, moduleName, options2 = {}, libraryName = null) {
  if (!options2.useLocalLibraries && library.startsWith("http")) {
    return library;
  }
  libraryName = libraryName || library;
  const modules = options2.modules || {};
  if (modules[libraryName]) {
    return modules[libraryName];
  }
  if (!isBrowser$1) {
    return `modules/${moduleName}/dist/libs/${libraryName}`;
  }
  if (options2.CDN) {
    assert$3(options2.CDN.startsWith("http"));
    return `${options2.CDN}/${moduleName}@${VERSION$5}/dist/libs/${libraryName}`;
  }
  if (isWorker) {
    return `../src/libs/${libraryName}`;
  }
  return `modules/${moduleName}/src/libs/${libraryName}`;
}
async function loadLibraryFromFile(libraryUrl) {
  if (libraryUrl.endsWith("wasm")) {
    return await loadAsArrayBuffer(libraryUrl);
  }
  if (!isBrowser$1) {
    try {
      const { requireFromFile } = globalThis.loaders || {};
      return await (requireFromFile == null ? void 0 : requireFromFile(libraryUrl));
    } catch (error2) {
      console.error(error2);
      return null;
    }
  }
  if (isWorker) {
    return importScripts(libraryUrl);
  }
  const scriptSource = await loadAsText(libraryUrl);
  return loadLibraryFromString(scriptSource, libraryUrl);
}
function loadLibraryFromString(scriptSource, id) {
  if (!isBrowser$1) {
    const { requireFromString } = globalThis.loaders || {};
    return requireFromString == null ? void 0 : requireFromString(scriptSource, id);
  }
  if (isWorker) {
    eval.call(globalThis, scriptSource);
    return null;
  }
  const script = document.createElement("script");
  script.id = id;
  try {
    script.appendChild(document.createTextNode(scriptSource));
  } catch (e3) {
    script.text = scriptSource;
  }
  document.body.appendChild(script);
  return null;
}
async function loadAsArrayBuffer(url2) {
  const { readFileAsArrayBuffer } = globalThis.loaders || {};
  if (isBrowser$1 || !readFileAsArrayBuffer || url2.startsWith("http")) {
    const response = await fetch(url2);
    return await response.arrayBuffer();
  }
  return await readFileAsArrayBuffer(url2);
}
async function loadAsText(url2) {
  const { readFileAsText } = globalThis.loaders || {};
  if (isBrowser$1 || !readFileAsText || url2.startsWith("http")) {
    const response = await fetch(url2);
    return await response.text();
  }
  return await readFileAsText(url2);
}
function getFirstCharacters(data2, length2 = 5) {
  if (typeof data2 === "string") {
    return data2.slice(0, length2);
  } else if (ArrayBuffer.isView(data2)) {
    return getMagicString$2(data2.buffer, data2.byteOffset, length2);
  } else if (data2 instanceof ArrayBuffer) {
    const byteOffset = 0;
    return getMagicString$2(data2, byteOffset, length2);
  }
  return "";
}
function getMagicString$2(arrayBuffer2, byteOffset, length2) {
  if (arrayBuffer2.byteLength <= byteOffset + length2) {
    return "";
  }
  const dataView = new DataView(arrayBuffer2);
  let magic = "";
  for (let i2 = 0; i2 < length2; i2++) {
    magic += String.fromCharCode(dataView.getUint8(byteOffset + i2));
  }
  return magic;
}
function parseJSON(string3) {
  try {
    return JSON.parse(string3);
  } catch (_2) {
    throw new Error(`Failed to parse JSON from data starting with "${getFirstCharacters(string3)}"`);
  }
}
function sliceArrayBuffer(arrayBuffer2, byteOffset, byteLength) {
  const subArray = byteLength !== void 0 ? new Uint8Array(arrayBuffer2).subarray(byteOffset, byteOffset + byteLength) : new Uint8Array(arrayBuffer2).subarray(byteOffset);
  const arrayCopy2 = new Uint8Array(subArray);
  return arrayCopy2.buffer;
}
function padToNBytes(byteLength, padding) {
  assert$4(byteLength >= 0);
  assert$4(padding > 0);
  return byteLength + (padding - 1) & ~(padding - 1);
}
function copyToArray(source, target, targetOffset) {
  let sourceArray;
  if (source instanceof ArrayBuffer) {
    sourceArray = new Uint8Array(source);
  } else {
    const srcByteOffset = source.byteOffset;
    const srcByteLength = source.byteLength;
    sourceArray = new Uint8Array(source.buffer || source.arrayBuffer, srcByteOffset, srcByteLength);
  }
  target.set(sourceArray, targetOffset);
  return targetOffset + padToNBytes(sourceArray.byteLength, 4);
}
function getCWD() {
  var _a3;
  if (typeof process !== "undefined" && typeof process.cwd !== "undefined") {
    return process.cwd();
  }
  const pathname = (_a3 = window.location) == null ? void 0 : _a3.pathname;
  return (pathname == null ? void 0 : pathname.slice(0, pathname.lastIndexOf("/") + 1)) || "";
}
function dirname(url2) {
  const slashIndex = url2 ? url2.lastIndexOf("/") : -1;
  return slashIndex >= 0 ? url2.substr(0, slashIndex) : "";
}
function resolve$1(...components) {
  const paths = [];
  for (let _i = 0; _i < components.length; _i++) {
    paths[_i] = components[_i];
  }
  let resolvedPath2 = "";
  let resolvedAbsolute = false;
  let cwd;
  for (let i2 = paths.length - 1; i2 >= -1 && !resolvedAbsolute; i2--) {
    let path2;
    if (i2 >= 0) {
      path2 = paths[i2];
    } else {
      if (cwd === void 0) {
        cwd = getCWD();
      }
      path2 = cwd;
    }
    if (path2.length === 0) {
      continue;
    }
    resolvedPath2 = `${path2}/${resolvedPath2}`;
    resolvedAbsolute = path2.charCodeAt(0) === SLASH;
  }
  resolvedPath2 = normalizeStringPosix(resolvedPath2, !resolvedAbsolute);
  if (resolvedAbsolute) {
    return `/${resolvedPath2}`;
  } else if (resolvedPath2.length > 0) {
    return resolvedPath2;
  }
  return ".";
}
const SLASH = 47;
const DOT = 46;
function normalizeStringPosix(path2, allowAboveRoot) {
  let res = "";
  let lastSlash = -1;
  let dots = 0;
  let code;
  let isAboveRoot = false;
  for (let i2 = 0; i2 <= path2.length; ++i2) {
    if (i2 < path2.length) {
      code = path2.charCodeAt(i2);
    } else if (code === SLASH) {
      break;
    } else {
      code = SLASH;
    }
    if (code === SLASH) {
      if (lastSlash === i2 - 1 || dots === 1)
        ;
      else if (lastSlash !== i2 - 1 && dots === 2) {
        if (res.length < 2 || !isAboveRoot || res.charCodeAt(res.length - 1) !== DOT || res.charCodeAt(res.length - 2) !== DOT) {
          if (res.length > 2) {
            const start2 = res.length - 1;
            let j2 = start2;
            for (; j2 >= 0; --j2) {
              if (res.charCodeAt(j2) === SLASH) {
                break;
              }
            }
            if (j2 !== start2) {
              res = j2 === -1 ? "" : res.slice(0, j2);
              lastSlash = i2;
              dots = 0;
              isAboveRoot = false;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = "";
            lastSlash = i2;
            dots = 0;
            isAboveRoot = false;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0) {
            res += "/..";
          } else {
            res = "..";
          }
          isAboveRoot = true;
        }
      } else {
        const slice2 = path2.slice(lastSlash + 1, i2);
        if (res.length > 0) {
          res += `/${slice2}`;
        } else {
          res = slice2;
        }
        isAboveRoot = false;
      }
      lastSlash = i2;
      dots = 0;
    } else if (code === DOT && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}
var TILE_REFINEMENT;
(function(TILE_REFINEMENT2) {
  TILE_REFINEMENT2[TILE_REFINEMENT2["ADD"] = 1] = "ADD";
  TILE_REFINEMENT2[TILE_REFINEMENT2["REPLACE"] = 2] = "REPLACE";
})(TILE_REFINEMENT || (TILE_REFINEMENT = {}));
var TILE_TYPE;
(function(TILE_TYPE2) {
  TILE_TYPE2["EMPTY"] = "empty";
  TILE_TYPE2["SCENEGRAPH"] = "scenegraph";
  TILE_TYPE2["POINTCLOUD"] = "pointcloud";
  TILE_TYPE2["MESH"] = "mesh";
})(TILE_TYPE || (TILE_TYPE = {}));
var TILESET_TYPE;
(function(TILESET_TYPE2) {
  TILESET_TYPE2["I3S"] = "I3S";
  TILESET_TYPE2["TILES3D"] = "TILES3D";
})(TILESET_TYPE || (TILESET_TYPE = {}));
var LOD_METRIC_TYPE;
(function(LOD_METRIC_TYPE2) {
  LOD_METRIC_TYPE2["GEOMETRIC_ERROR"] = "geometricError";
  LOD_METRIC_TYPE2["MAX_SCREEN_THRESHOLD"] = "maxScreenThreshold";
})(LOD_METRIC_TYPE || (LOD_METRIC_TYPE = {}));
const VERSION$4 = "4.2.1";
const TILE3D_TYPE = {
  COMPOSITE: "cmpt",
  POINT_CLOUD: "pnts",
  BATCHED_3D_MODEL: "b3dm",
  INSTANCED_3D_MODEL: "i3dm",
  GEOMETRY: "geom",
  VECTOR: "vect",
  GLTF: "glTF"
};
function getStringFromArrayBuffer(arrayBuffer2, byteOffset, byteLength) {
  assert$4(arrayBuffer2 instanceof ArrayBuffer);
  const textDecoder = new TextDecoder("utf8");
  const typedArray = new Uint8Array(arrayBuffer2, byteOffset, byteLength);
  const string3 = textDecoder.decode(typedArray);
  return string3;
}
function getMagicString$1(arrayBuffer2, byteOffset = 0) {
  const dataView = new DataView(arrayBuffer2);
  return `${String.fromCharCode(dataView.getUint8(byteOffset + 0))}${String.fromCharCode(dataView.getUint8(byteOffset + 1))}${String.fromCharCode(dataView.getUint8(byteOffset + 2))}${String.fromCharCode(dataView.getUint8(byteOffset + 3))}`;
}
const VERSION$3 = "4.2.1";
const DracoLoader$1 = {
  dataType: null,
  batchType: null,
  name: "Draco",
  id: "draco",
  module: "draco",
  // shapes: ['mesh'],
  version: VERSION$3,
  worker: true,
  extensions: ["drc"],
  mimeTypes: ["application/octet-stream"],
  binary: true,
  tests: ["DRACO"],
  options: {
    draco: {
      decoderType: typeof WebAssembly === "object" ? "wasm" : "js",
      // 'js' for IE11
      libraryPath: "libs/",
      extraAttributes: {},
      attributeNameEntry: void 0
    }
  }
};
function getDataTypeFromTypedArray(array2) {
  switch (array2.constructor) {
    case Int8Array:
      return "int8";
    case Uint8Array:
    case Uint8ClampedArray:
      return "uint8";
    case Int16Array:
      return "int16";
    case Uint16Array:
      return "uint16";
    case Int32Array:
      return "int32";
    case Uint32Array:
      return "uint32";
    case Float32Array:
      return "float32";
    case Float64Array:
      return "float64";
    default:
      return "null";
  }
}
function getMeshBoundingBox(attributes) {
  let minX2 = Infinity;
  let minY2 = Infinity;
  let minZ = Infinity;
  let maxX2 = -Infinity;
  let maxY2 = -Infinity;
  let maxZ = -Infinity;
  const positions = attributes.POSITION ? attributes.POSITION.value : [];
  const len2 = positions && positions.length;
  for (let i2 = 0; i2 < len2; i2 += 3) {
    const x2 = positions[i2];
    const y2 = positions[i2 + 1];
    const z2 = positions[i2 + 2];
    minX2 = x2 < minX2 ? x2 : minX2;
    minY2 = y2 < minY2 ? y2 : minY2;
    minZ = z2 < minZ ? z2 : minZ;
    maxX2 = x2 > maxX2 ? x2 : maxX2;
    maxY2 = y2 > maxY2 ? y2 : maxY2;
    maxZ = z2 > maxZ ? z2 : maxZ;
  }
  return [
    [minX2, minY2, minZ],
    [maxX2, maxY2, maxZ]
  ];
}
function deduceMeshField(name2, attribute, optionalMetadata) {
  const type = getDataTypeFromTypedArray(attribute.value);
  const metadata = optionalMetadata ? optionalMetadata : makeMeshAttributeMetadata(attribute);
  return {
    name: name2,
    type: { type: "fixed-size-list", listSize: attribute.size, children: [{ name: "value", type }] },
    nullable: false,
    metadata
  };
}
function makeMeshAttributeMetadata(attribute) {
  const result = {};
  if ("byteOffset" in attribute) {
    result.byteOffset = attribute.byteOffset.toString(10);
  }
  if ("byteStride" in attribute) {
    result.byteStride = attribute.byteStride.toString(10);
  }
  if ("normalized" in attribute) {
    result.normalized = attribute.normalized.toString();
  }
  return result;
}
function getDracoSchema(attributes, loaderData, indices) {
  const metadata = makeMetadata(loaderData.metadata);
  const fields = [];
  const namedLoaderDataAttributes = transformAttributesLoaderData(loaderData.attributes);
  for (const attributeName in attributes) {
    const attribute = attributes[attributeName];
    const field = getArrowFieldFromAttribute(attributeName, attribute, namedLoaderDataAttributes[attributeName]);
    fields.push(field);
  }
  if (indices) {
    const indicesField = getArrowFieldFromAttribute("indices", indices);
    fields.push(indicesField);
  }
  return { fields, metadata };
}
function transformAttributesLoaderData(loaderData) {
  const result = {};
  for (const key in loaderData) {
    const dracoAttribute = loaderData[key];
    result[dracoAttribute.name || "undefined"] = dracoAttribute;
  }
  return result;
}
function getArrowFieldFromAttribute(attributeName, attribute, loaderData) {
  const metadataMap = loaderData ? makeMetadata(loaderData.metadata) : void 0;
  const field = deduceMeshField(attributeName, attribute, metadataMap);
  return field;
}
function makeMetadata(metadata) {
  const serializedMetadata = {};
  for (const key in metadata) {
    serializedMetadata[`${key}.string`] = JSON.stringify(metadata[key]);
  }
  return serializedMetadata;
}
const DRACO_TO_GLTF_ATTRIBUTE_NAME_MAP = {
  POSITION: "POSITION",
  NORMAL: "NORMAL",
  COLOR: "COLOR_0",
  TEX_COORD: "TEXCOORD_0"
};
const DRACO_DATA_TYPE_TO_TYPED_ARRAY_MAP = {
  1: Int8Array,
  2: Uint8Array,
  3: Int16Array,
  4: Uint16Array,
  5: Int32Array,
  6: Uint32Array,
  // 7: BigInt64Array,
  // 8: BigUint64Array,
  9: Float32Array
  // 10: Float64Array
  // 11: BOOL - What array type do we use for this?
};
const INDEX_ITEM_SIZE = 4;
class DracoParser {
  // draco - the draco decoder, either import `draco3d` or load dynamically
  constructor(draco) {
    __publicField2(this, "draco");
    __publicField2(this, "decoder");
    __publicField2(this, "metadataQuerier");
    this.draco = draco;
    this.decoder = new this.draco.Decoder();
    this.metadataQuerier = new this.draco.MetadataQuerier();
  }
  /**
   * Destroy draco resources
   */
  destroy() {
    this.draco.destroy(this.decoder);
    this.draco.destroy(this.metadataQuerier);
  }
  /**
   * NOTE: caller must call `destroyGeometry` on the return value after using it
   * @param arrayBuffer
   * @param options
   */
  parseSync(arrayBuffer2, options2 = {}) {
    const buffer3 = new this.draco.DecoderBuffer();
    buffer3.Init(new Int8Array(arrayBuffer2), arrayBuffer2.byteLength);
    this._disableAttributeTransforms(options2);
    const geometry_type = this.decoder.GetEncodedGeometryType(buffer3);
    const dracoGeometry = geometry_type === this.draco.TRIANGULAR_MESH ? new this.draco.Mesh() : new this.draco.PointCloud();
    try {
      let dracoStatus;
      switch (geometry_type) {
        case this.draco.TRIANGULAR_MESH:
          dracoStatus = this.decoder.DecodeBufferToMesh(buffer3, dracoGeometry);
          break;
        case this.draco.POINT_CLOUD:
          dracoStatus = this.decoder.DecodeBufferToPointCloud(buffer3, dracoGeometry);
          break;
        default:
          throw new Error("DRACO: Unknown geometry type.");
      }
      if (!dracoStatus.ok() || !dracoGeometry.ptr) {
        const message2 = `DRACO decompression failed: ${dracoStatus.error_msg()}`;
        throw new Error(message2);
      }
      const loaderData = this._getDracoLoaderData(dracoGeometry, geometry_type, options2);
      const geometry2 = this._getMeshData(dracoGeometry, loaderData, options2);
      const boundingBox = getMeshBoundingBox(geometry2.attributes);
      const schema = getDracoSchema(geometry2.attributes, loaderData, geometry2.indices);
      const data2 = {
        loader: "draco",
        loaderData,
        header: {
          vertexCount: dracoGeometry.num_points(),
          boundingBox
        },
        ...geometry2,
        schema
      };
      return data2;
    } finally {
      this.draco.destroy(buffer3);
      if (dracoGeometry) {
        this.draco.destroy(dracoGeometry);
      }
    }
  }
  // Draco specific "loader data"
  /**
   * Extract
   * @param dracoGeometry
   * @param geometry_type
   * @param options
   * @returns
   */
  _getDracoLoaderData(dracoGeometry, geometry_type, options2) {
    const metadata = this._getTopLevelMetadata(dracoGeometry);
    const attributes = this._getDracoAttributes(dracoGeometry, options2);
    return {
      geometry_type,
      num_attributes: dracoGeometry.num_attributes(),
      num_points: dracoGeometry.num_points(),
      num_faces: dracoGeometry instanceof this.draco.Mesh ? dracoGeometry.num_faces() : 0,
      metadata,
      attributes
    };
  }
  /**
   * Extract all draco provided information and metadata for each attribute
   * @param dracoGeometry
   * @param options
   * @returns
   */
  _getDracoAttributes(dracoGeometry, options2) {
    const dracoAttributes = {};
    for (let attributeId = 0; attributeId < dracoGeometry.num_attributes(); attributeId++) {
      const dracoAttribute = this.decoder.GetAttribute(dracoGeometry, attributeId);
      const metadata = this._getAttributeMetadata(dracoGeometry, attributeId);
      dracoAttributes[dracoAttribute.unique_id()] = {
        unique_id: dracoAttribute.unique_id(),
        attribute_type: dracoAttribute.attribute_type(),
        data_type: dracoAttribute.data_type(),
        num_components: dracoAttribute.num_components(),
        byte_offset: dracoAttribute.byte_offset(),
        byte_stride: dracoAttribute.byte_stride(),
        normalized: dracoAttribute.normalized(),
        attribute_index: attributeId,
        metadata
      };
      const quantization = this._getQuantizationTransform(dracoAttribute, options2);
      if (quantization) {
        dracoAttributes[dracoAttribute.unique_id()].quantization_transform = quantization;
      }
      const octahedron = this._getOctahedronTransform(dracoAttribute, options2);
      if (octahedron) {
        dracoAttributes[dracoAttribute.unique_id()].octahedron_transform = octahedron;
      }
    }
    return dracoAttributes;
  }
  /**
   * Get standard loaders.gl mesh category data
   * Extracts the geometry from draco
   * @param dracoGeometry
   * @param options
   */
  _getMeshData(dracoGeometry, loaderData, options2) {
    const attributes = this._getMeshAttributes(loaderData, dracoGeometry, options2);
    const positionAttribute = attributes.POSITION;
    if (!positionAttribute) {
      throw new Error("DRACO: No position attribute found.");
    }
    if (dracoGeometry instanceof this.draco.Mesh) {
      switch (options2.topology) {
        case "triangle-strip":
          return {
            topology: "triangle-strip",
            mode: 4,
            // GL.TRIANGLES
            attributes,
            indices: {
              value: this._getTriangleStripIndices(dracoGeometry),
              size: 1
            }
          };
        case "triangle-list":
        default:
          return {
            topology: "triangle-list",
            mode: 5,
            // GL.TRIANGLE_STRIP
            attributes,
            indices: {
              value: this._getTriangleListIndices(dracoGeometry),
              size: 1
            }
          };
      }
    }
    return {
      topology: "point-list",
      mode: 0,
      // GL.POINTS
      attributes
    };
  }
  _getMeshAttributes(loaderData, dracoGeometry, options2) {
    const attributes = {};
    for (const loaderAttribute of Object.values(loaderData.attributes)) {
      const attributeName = this._deduceAttributeName(loaderAttribute, options2);
      loaderAttribute.name = attributeName;
      const values4 = this._getAttributeValues(dracoGeometry, loaderAttribute);
      if (values4) {
        const { value, size: size12 } = values4;
        attributes[attributeName] = {
          value,
          size: size12,
          byteOffset: loaderAttribute.byte_offset,
          byteStride: loaderAttribute.byte_stride,
          normalized: loaderAttribute.normalized
        };
      }
    }
    return attributes;
  }
  // MESH INDICES EXTRACTION
  /**
   * For meshes, we need indices to define the faces.
   * @param dracoGeometry
   */
  _getTriangleListIndices(dracoGeometry) {
    const numFaces = dracoGeometry.num_faces();
    const numIndices = numFaces * 3;
    const byteLength = numIndices * INDEX_ITEM_SIZE;
    const ptr = this.draco._malloc(byteLength);
    try {
      this.decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
      return new Uint32Array(this.draco.HEAPF32.buffer, ptr, numIndices).slice();
    } finally {
      this.draco._free(ptr);
    }
  }
  /**
   * For meshes, we need indices to define the faces.
   * @param dracoGeometry
   */
  _getTriangleStripIndices(dracoGeometry) {
    const dracoArray = new this.draco.DracoInt32Array();
    try {
      this.decoder.GetTriangleStripsFromMesh(dracoGeometry, dracoArray);
      return getUint32Array(dracoArray);
    } finally {
      this.draco.destroy(dracoArray);
    }
  }
  /**
   *
   * @param dracoGeometry
   * @param dracoAttribute
   * @param attributeName
   */
  _getAttributeValues(dracoGeometry, attribute) {
    const TypedArrayCtor = DRACO_DATA_TYPE_TO_TYPED_ARRAY_MAP[attribute.data_type];
    if (!TypedArrayCtor) {
      console.warn(`DRACO: Unsupported attribute type ${attribute.data_type}`);
      return null;
    }
    const numComponents = attribute.num_components;
    const numPoints = dracoGeometry.num_points();
    const numValues = numPoints * numComponents;
    const byteLength = numValues * TypedArrayCtor.BYTES_PER_ELEMENT;
    const dataType = getDracoDataType(this.draco, TypedArrayCtor);
    let value;
    const ptr = this.draco._malloc(byteLength);
    try {
      const dracoAttribute = this.decoder.GetAttribute(dracoGeometry, attribute.attribute_index);
      this.decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, dracoAttribute, dataType, byteLength, ptr);
      value = new TypedArrayCtor(this.draco.HEAPF32.buffer, ptr, numValues).slice();
    } finally {
      this.draco._free(ptr);
    }
    return { value, size: numComponents };
  }
  // Attribute names
  /**
   * DRACO does not store attribute names - We need to deduce an attribute name
   * for each attribute
  _getAttributeNames(
    dracoGeometry: Mesh | PointCloud,
    options: DracoParseOptions
  ): {[unique_id: number]: string} {
    const attributeNames: {[unique_id: number]: string} = {};
    for (let attributeId = 0; attributeId < dracoGeometry.num_attributes(); attributeId++) {
      const dracoAttribute = this.decoder.GetAttribute(dracoGeometry, attributeId);
      const attributeName = this._deduceAttributeName(dracoAttribute, options);
      attributeNames[attributeName] = attributeName;
    }
    return attributeNames;
  }
   */
  /**
   * Deduce an attribute name.
   * @note DRACO does not save attribute names, just general type (POSITION, COLOR)
   * to help optimize compression. We generate GLTF compatible names for the Draco-recognized
   * types
   * @param attributeData
   */
  _deduceAttributeName(attribute, options2) {
    const uniqueId = attribute.unique_id;
    for (const [attributeName, attributeUniqueId] of Object.entries(options2.extraAttributes || {})) {
      if (attributeUniqueId === uniqueId) {
        return attributeName;
      }
    }
    const thisAttributeType = attribute.attribute_type;
    for (const dracoAttributeConstant in DRACO_TO_GLTF_ATTRIBUTE_NAME_MAP) {
      const attributeType = this.draco[dracoAttributeConstant];
      if (attributeType === thisAttributeType) {
        return DRACO_TO_GLTF_ATTRIBUTE_NAME_MAP[dracoAttributeConstant];
      }
    }
    const entryName = options2.attributeNameEntry || "name";
    if (attribute.metadata[entryName]) {
      return attribute.metadata[entryName].string;
    }
    return `CUSTOM_ATTRIBUTE_${uniqueId}`;
  }
  // METADATA EXTRACTION
  /** Get top level metadata */
  _getTopLevelMetadata(dracoGeometry) {
    const dracoMetadata = this.decoder.GetMetadata(dracoGeometry);
    return this._getDracoMetadata(dracoMetadata);
  }
  /** Get per attribute metadata */
  _getAttributeMetadata(dracoGeometry, attributeId) {
    const dracoMetadata = this.decoder.GetAttributeMetadata(dracoGeometry, attributeId);
    return this._getDracoMetadata(dracoMetadata);
  }
  /**
   * Extract metadata field values
   * @param dracoMetadata
   * @returns
   */
  _getDracoMetadata(dracoMetadata) {
    if (!dracoMetadata || !dracoMetadata.ptr) {
      return {};
    }
    const result = {};
    const numEntries = this.metadataQuerier.NumEntries(dracoMetadata);
    for (let entryIndex = 0; entryIndex < numEntries; entryIndex++) {
      const entryName = this.metadataQuerier.GetEntryName(dracoMetadata, entryIndex);
      result[entryName] = this._getDracoMetadataField(dracoMetadata, entryName);
    }
    return result;
  }
  /**
   * Extracts possible values for one metadata entry by name
   * @param dracoMetadata
   * @param entryName
   */
  _getDracoMetadataField(dracoMetadata, entryName) {
    const dracoArray = new this.draco.DracoInt32Array();
    try {
      this.metadataQuerier.GetIntEntryArray(dracoMetadata, entryName, dracoArray);
      const intArray = getInt32Array(dracoArray);
      return {
        int: this.metadataQuerier.GetIntEntry(dracoMetadata, entryName),
        string: this.metadataQuerier.GetStringEntry(dracoMetadata, entryName),
        double: this.metadataQuerier.GetDoubleEntry(dracoMetadata, entryName),
        intArray
      };
    } finally {
      this.draco.destroy(dracoArray);
    }
  }
  // QUANTIZED ATTRIBUTE SUPPORT (NO DECOMPRESSION)
  /** Skip transforms for specific attribute types */
  _disableAttributeTransforms(options2) {
    const { quantizedAttributes = [], octahedronAttributes = [] } = options2;
    const skipAttributes = [...quantizedAttributes, ...octahedronAttributes];
    for (const dracoAttributeName of skipAttributes) {
      this.decoder.SkipAttributeTransform(this.draco[dracoAttributeName]);
    }
  }
  /**
   * Extract (and apply?) Position Transform
   * @todo not used
   */
  _getQuantizationTransform(dracoAttribute, options2) {
    const { quantizedAttributes = [] } = options2;
    const attribute_type = dracoAttribute.attribute_type();
    const skip = quantizedAttributes.map((type) => this.decoder[type]).includes(attribute_type);
    if (skip) {
      const transform4 = new this.draco.AttributeQuantizationTransform();
      try {
        if (transform4.InitFromAttribute(dracoAttribute)) {
          return {
            quantization_bits: transform4.quantization_bits(),
            range: transform4.range(),
            min_values: new Float32Array([1, 2, 3]).map((i2) => transform4.min_value(i2))
          };
        }
      } finally {
        this.draco.destroy(transform4);
      }
    }
    return null;
  }
  _getOctahedronTransform(dracoAttribute, options2) {
    const { octahedronAttributes = [] } = options2;
    const attribute_type = dracoAttribute.attribute_type();
    const octahedron = octahedronAttributes.map((type) => this.decoder[type]).includes(attribute_type);
    if (octahedron) {
      const transform4 = new this.draco.AttributeQuantizationTransform();
      try {
        if (transform4.InitFromAttribute(dracoAttribute)) {
          return {
            quantization_bits: transform4.quantization_bits()
          };
        }
      } finally {
        this.draco.destroy(transform4);
      }
    }
    return null;
  }
}
function getDracoDataType(draco, attributeType) {
  switch (attributeType) {
    case Float32Array:
      return draco.DT_FLOAT32;
    case Int8Array:
      return draco.DT_INT8;
    case Int16Array:
      return draco.DT_INT16;
    case Int32Array:
      return draco.DT_INT32;
    case Uint8Array:
      return draco.DT_UINT8;
    case Uint16Array:
      return draco.DT_UINT16;
    case Uint32Array:
      return draco.DT_UINT32;
    default:
      return draco.DT_INVALID;
  }
}
function getInt32Array(dracoArray) {
  const numValues = dracoArray.size();
  const intArray = new Int32Array(numValues);
  for (let i2 = 0; i2 < numValues; i2++) {
    intArray[i2] = dracoArray.GetValue(i2);
  }
  return intArray;
}
function getUint32Array(dracoArray) {
  const numValues = dracoArray.size();
  const intArray = new Int32Array(numValues);
  for (let i2 = 0; i2 < numValues; i2++) {
    intArray[i2] = dracoArray.GetValue(i2);
  }
  return intArray;
}
const DRACO_DECODER_VERSION = "1.5.6";
const DRACO_ENCODER_VERSION = "1.4.1";
const STATIC_DECODER_URL = `https://www.gstatic.com/draco/versioned/decoders/${DRACO_DECODER_VERSION}`;
const DRACO_EXTERNAL_LIBRARIES = {
  /** The primary Draco3D encoder, javascript wrapper part */
  DECODER: "draco_wasm_wrapper.js",
  /** The primary draco decoder, compiled web assembly part */
  DECODER_WASM: "draco_decoder.wasm",
  /** Fallback decoder for non-webassebly environments. Very big bundle, lower performance */
  FALLBACK_DECODER: "draco_decoder.js",
  /** Draco encoder */
  ENCODER: "draco_encoder.js"
};
const DRACO_EXTERNAL_LIBRARY_URLS = {
  [DRACO_EXTERNAL_LIBRARIES.DECODER]: `${STATIC_DECODER_URL}/${DRACO_EXTERNAL_LIBRARIES.DECODER}`,
  [DRACO_EXTERNAL_LIBRARIES.DECODER_WASM]: `${STATIC_DECODER_URL}/${DRACO_EXTERNAL_LIBRARIES.DECODER_WASM}`,
  [DRACO_EXTERNAL_LIBRARIES.FALLBACK_DECODER]: `${STATIC_DECODER_URL}/${DRACO_EXTERNAL_LIBRARIES.FALLBACK_DECODER}`,
  [DRACO_EXTERNAL_LIBRARIES.ENCODER]: `https://raw.githubusercontent.com/google/draco/${DRACO_ENCODER_VERSION}/javascript/${DRACO_EXTERNAL_LIBRARIES.ENCODER}`
};
let loadDecoderPromise;
async function loadDracoDecoderModule(options2) {
  const modules = options2.modules || {};
  if (modules.draco3d) {
    loadDecoderPromise || (loadDecoderPromise = modules.draco3d.createDecoderModule({}).then((draco) => {
      return { draco };
    }));
  } else {
    loadDecoderPromise || (loadDecoderPromise = loadDracoDecoder(options2));
  }
  return await loadDecoderPromise;
}
async function loadDracoDecoder(options2) {
  let DracoDecoderModule2;
  let wasmBinary;
  switch (options2.draco && options2.draco.decoderType) {
    case "js":
      DracoDecoderModule2 = await loadLibrary(DRACO_EXTERNAL_LIBRARY_URLS[DRACO_EXTERNAL_LIBRARIES.FALLBACK_DECODER], "draco", options2, DRACO_EXTERNAL_LIBRARIES.FALLBACK_DECODER);
      break;
    case "wasm":
    default:
      [DracoDecoderModule2, wasmBinary] = await Promise.all([
        await loadLibrary(DRACO_EXTERNAL_LIBRARY_URLS[DRACO_EXTERNAL_LIBRARIES.DECODER], "draco", options2, DRACO_EXTERNAL_LIBRARIES.DECODER),
        await loadLibrary(DRACO_EXTERNAL_LIBRARY_URLS[DRACO_EXTERNAL_LIBRARIES.DECODER_WASM], "draco", options2, DRACO_EXTERNAL_LIBRARIES.DECODER_WASM)
      ]);
  }
  DracoDecoderModule2 = DracoDecoderModule2 || globalThis.DracoDecoderModule;
  return await initializeDracoDecoder(DracoDecoderModule2, wasmBinary);
}
function initializeDracoDecoder(DracoDecoderModule2, wasmBinary) {
  const options2 = {};
  if (wasmBinary) {
    options2.wasmBinary = wasmBinary;
  }
  return new Promise((resolve2) => {
    DracoDecoderModule2({
      ...options2,
      onModuleLoaded: (draco) => resolve2({ draco })
      // Module is Promise-like. Wrap in object to avoid loop.
    });
  });
}
const DracoLoader = {
  ...DracoLoader$1,
  parse: parse$3
};
async function parse$3(arrayBuffer2, options2) {
  const { draco } = await loadDracoDecoderModule(options2);
  const dracoParser = new DracoParser(draco);
  try {
    return dracoParser.parseSync(arrayBuffer2, options2 == null ? void 0 : options2.draco);
  } finally {
    dracoParser.destroy();
  }
}
const GL_PRIMITIVE_MODE = {
  POINTS: 0,
  // Points. single points.
  LINES: 1,
  // Lines. Each vertex connects to the one after it.
  LINE_LOOP: 2,
  // Lines. Each set of two vertices is treated as a separate line segment.
  LINE_STRIP: 3,
  // Lines/ a connected group of line segments from the first vertex to the last
  TRIANGLES: 4,
  // Triangles. Each set of three vertices creates a separate triangle.
  TRIANGLE_STRIP: 5,
  // Triangles. A connected group of triangles.
  TRIANGLE_FAN: 6
  // Triangles. A connected group of triangles.
  // Each vertex connects to the previous and the first vertex in the fan.
};
const GL_TYPE = {
  BYTE: 5120,
  UNSIGNED_BYTE: 5121,
  SHORT: 5122,
  UNSIGNED_SHORT: 5123,
  INT: 5124,
  UNSIGNED_INT: 5125,
  FLOAT: 5126,
  DOUBLE: 5130
};
const GL$1 = {
  ...GL_PRIMITIVE_MODE,
  ...GL_TYPE
};
const GL_TYPE_TO_ARRAY_TYPE = {
  [GL_TYPE.DOUBLE]: Float64Array,
  [GL_TYPE.FLOAT]: Float32Array,
  [GL_TYPE.UNSIGNED_SHORT]: Uint16Array,
  [GL_TYPE.UNSIGNED_INT]: Uint32Array,
  [GL_TYPE.UNSIGNED_BYTE]: Uint8Array,
  [GL_TYPE.BYTE]: Int8Array,
  [GL_TYPE.SHORT]: Int16Array,
  [GL_TYPE.INT]: Int32Array
};
const NAME_TO_GL_TYPE = {
  DOUBLE: GL_TYPE.DOUBLE,
  FLOAT: GL_TYPE.FLOAT,
  UNSIGNED_SHORT: GL_TYPE.UNSIGNED_SHORT,
  UNSIGNED_INT: GL_TYPE.UNSIGNED_INT,
  UNSIGNED_BYTE: GL_TYPE.UNSIGNED_BYTE,
  BYTE: GL_TYPE.BYTE,
  SHORT: GL_TYPE.SHORT,
  INT: GL_TYPE.INT
};
const ERR_TYPE_CONVERSION = "Failed to convert GL type";
class GLType {
  // Signature: fromTypedArray(new Uint8Array())
  // Signature: fromTypedArray(Uint8Array)
  /**
   * Returns the size, in bytes, of the corresponding datatype
   * @param arrayOrType
   * @returns glType a a string
   */
  static fromTypedArray(arrayOrType) {
    arrayOrType = ArrayBuffer.isView(arrayOrType) ? arrayOrType.constructor : arrayOrType;
    for (const glType in GL_TYPE_TO_ARRAY_TYPE) {
      const ArrayType2 = GL_TYPE_TO_ARRAY_TYPE[glType];
      if (ArrayType2 === arrayOrType) {
        return glType;
      }
    }
    throw new Error(ERR_TYPE_CONVERSION);
  }
  /**
   * Extracts name for glType from array NAME_TO_GL_TYPE
   * @param name
   * @returns glType as a number
   */
  static fromName(name2) {
    const glType = NAME_TO_GL_TYPE[name2];
    if (!glType) {
      throw new Error(ERR_TYPE_CONVERSION);
    }
    return glType;
  }
  // Converts GL constant to corresponding typed array type
  // eslint-disable-next-line complexity
  static getArrayType(glType) {
    switch (glType) {
      case GL_TYPE.UNSIGNED_SHORT_5_6_5:
      case GL_TYPE.UNSIGNED_SHORT_4_4_4_4:
      case GL_TYPE.UNSIGNED_SHORT_5_5_5_1:
        return Uint16Array;
      default:
        const ArrayType2 = GL_TYPE_TO_ARRAY_TYPE[glType];
        if (!ArrayType2) {
          throw new Error(ERR_TYPE_CONVERSION);
        }
        return ArrayType2;
    }
  }
  /**
   * Returns the size in bytes of one element of the provided WebGL type
   * @param glType
   * @returns size of glType
   */
  static getByteSize(glType) {
    const ArrayType2 = GLType.getArrayType(glType);
    return ArrayType2.BYTES_PER_ELEMENT;
  }
  /**
   * Returns `true` if `glType` is a valid WebGL data type.
   * @param glType
   * @returns boolean
   */
  static validate(glType) {
    return Boolean(GLType.getArrayType(glType));
  }
  /**
   * Creates a typed view of an array of bytes
   * @param glType The type of typed array (ArrayBuffer view) to create
   * @param buffer The buffer storage to use for the view.
   * @param byteOffset The offset, in bytes, to the first element in the view
   * @param length The number of elements in the view. Defaults to buffer length
   * @returns A typed array view of the buffer
   */
  static createTypedArray(glType, buffer3, byteOffset = 0, length2) {
    if (length2 === void 0) {
      length2 = (buffer3.byteLength - byteOffset) / GLType.getByteSize(glType);
    }
    const ArrayType2 = GLType.getArrayType(glType);
    return new ArrayType2(buffer3, byteOffset, length2);
  }
}
function assert$2(condition, message2) {
  if (!condition) {
    throw new Error(`math.gl assertion failed. ${message2}`);
  }
}
function decodeRGB565(rgb565, target = [0, 0, 0]) {
  const r5 = rgb565 >> 11 & 31;
  const g6 = rgb565 >> 5 & 63;
  const b5 = rgb565 & 31;
  target[0] = r5 << 3;
  target[1] = g6 << 2;
  target[2] = b5 << 3;
  return target;
}
new Vector2();
new Vector3();
new Vector2();
new Vector2();
function fromSNorm(value, rangeMaximum = 255) {
  return clamp$3(value, 0, rangeMaximum) / rangeMaximum * 2 - 1;
}
function signNotZero(value) {
  return value < 0 ? -1 : 1;
}
function octDecodeInRange(x2, y2, rangeMax, result) {
  assert$2(result);
  if (x2 < 0 || x2 > rangeMax || y2 < 0 || y2 > rangeMax) {
    throw new Error(`x and y must be unsigned normalized integers between 0 and ${rangeMax}`);
  }
  result.x = fromSNorm(x2, rangeMax);
  result.y = fromSNorm(y2, rangeMax);
  result.z = 1 - (Math.abs(result.x) + Math.abs(result.y));
  if (result.z < 0) {
    const oldVX = result.x;
    result.x = (1 - Math.abs(result.y)) * signNotZero(oldVX);
    result.y = (1 - Math.abs(oldVX)) * signNotZero(result.y);
  }
  return result.normalize();
}
function octDecode(x2, y2, result) {
  return octDecodeInRange(x2, y2, 255, result);
}
class Tile3DFeatureTable {
  constructor(featureTableJson, featureTableBinary) {
    __publicField2(this, "json");
    __publicField2(this, "buffer");
    __publicField2(this, "featuresLength", 0);
    __publicField2(this, "_cachedTypedArrays", {});
    this.json = featureTableJson;
    this.buffer = featureTableBinary;
  }
  getExtension(extensionName) {
    return this.json.extensions && this.json.extensions[extensionName];
  }
  hasProperty(propertyName) {
    return Boolean(this.json[propertyName]);
  }
  getGlobalProperty(propertyName, componentType = GL$1.UNSIGNED_INT, componentLength = 1) {
    const jsonValue = this.json[propertyName];
    if (jsonValue && Number.isFinite(jsonValue.byteOffset)) {
      return this._getTypedArrayFromBinary(propertyName, componentType, componentLength, 1, jsonValue.byteOffset);
    }
    return jsonValue;
  }
  getPropertyArray(propertyName, componentType, componentLength) {
    const jsonValue = this.json[propertyName];
    if (jsonValue && Number.isFinite(jsonValue.byteOffset)) {
      if ("componentType" in jsonValue) {
        componentType = GLType.fromName(jsonValue.componentType);
      }
      return this._getTypedArrayFromBinary(propertyName, componentType, componentLength, this.featuresLength, jsonValue.byteOffset);
    }
    return this._getTypedArrayFromArray(propertyName, componentType, jsonValue);
  }
  getProperty(propertyName, componentType, componentLength, featureId, result) {
    const jsonValue = this.json[propertyName];
    if (!jsonValue) {
      return jsonValue;
    }
    const typedArray = this.getPropertyArray(propertyName, componentType, componentLength);
    if (componentLength === 1) {
      return typedArray[featureId];
    }
    for (let i2 = 0; i2 < componentLength; ++i2) {
      result[i2] = typedArray[componentLength * featureId + i2];
    }
    return result;
  }
  // HELPERS
  _getTypedArrayFromBinary(propertyName, componentType, componentLength, count3, byteOffset) {
    const cachedTypedArrays = this._cachedTypedArrays;
    let typedArray = cachedTypedArrays[propertyName];
    if (!typedArray) {
      typedArray = GLType.createTypedArray(componentType, this.buffer.buffer, this.buffer.byteOffset + byteOffset, count3 * componentLength);
      cachedTypedArrays[propertyName] = typedArray;
    }
    return typedArray;
  }
  _getTypedArrayFromArray(propertyName, componentType, array2) {
    const cachedTypedArrays = this._cachedTypedArrays;
    let typedArray = cachedTypedArrays[propertyName];
    if (!typedArray) {
      typedArray = GLType.createTypedArray(componentType, array2);
      cachedTypedArrays[propertyName] = typedArray;
    }
    return typedArray;
  }
}
const COMPONENTS_PER_ATTRIBUTE = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const UNPACKER = {
  SCALAR: (values4, i2) => values4[i2],
  VEC2: (values4, i2) => [values4[2 * i2 + 0], values4[2 * i2 + 1]],
  VEC3: (values4, i2) => [values4[3 * i2 + 0], values4[3 * i2 + 1], values4[3 * i2 + 2]],
  VEC4: (values4, i2) => [values4[4 * i2 + 0], values4[4 * i2 + 1], values4[4 * i2 + 2], values4[4 * i2 + 3]],
  // TODO: check column major
  MAT2: (values4, i2) => [
    values4[4 * i2 + 0],
    values4[4 * i2 + 1],
    values4[4 * i2 + 2],
    values4[4 * i2 + 3]
  ],
  MAT3: (values4, i2) => [
    values4[9 * i2 + 0],
    values4[9 * i2 + 1],
    values4[9 * i2 + 2],
    values4[9 * i2 + 3],
    values4[9 * i2 + 4],
    values4[9 * i2 + 5],
    values4[9 * i2 + 6],
    values4[9 * i2 + 7],
    values4[9 * i2 + 8]
  ],
  MAT4: (values4, i2) => [
    values4[16 * i2 + 0],
    values4[16 * i2 + 1],
    values4[16 * i2 + 2],
    values4[16 * i2 + 3],
    values4[16 * i2 + 4],
    values4[16 * i2 + 5],
    values4[16 * i2 + 6],
    values4[16 * i2 + 7],
    values4[16 * i2 + 8],
    values4[16 * i2 + 9],
    values4[16 * i2 + 10],
    values4[16 * i2 + 11],
    values4[16 * i2 + 12],
    values4[16 * i2 + 13],
    values4[16 * i2 + 14],
    values4[16 * i2 + 15]
  ]
};
const PACKER = {
  SCALAR: (x2, values4, i2) => {
    values4[i2] = x2;
  },
  VEC2: (x2, values4, i2) => {
    values4[2 * i2 + 0] = x2[0];
    values4[2 * i2 + 1] = x2[1];
  },
  VEC3: (x2, values4, i2) => {
    values4[3 * i2 + 0] = x2[0];
    values4[3 * i2 + 1] = x2[1];
    values4[3 * i2 + 2] = x2[2];
  },
  VEC4: (x2, values4, i2) => {
    values4[4 * i2 + 0] = x2[0];
    values4[4 * i2 + 1] = x2[1];
    values4[4 * i2 + 2] = x2[2];
    values4[4 * i2 + 3] = x2[3];
  },
  // TODO: check column major correctness
  MAT2: (x2, values4, i2) => {
    values4[4 * i2 + 0] = x2[0];
    values4[4 * i2 + 1] = x2[1];
    values4[4 * i2 + 2] = x2[2];
    values4[4 * i2 + 3] = x2[3];
  },
  MAT3: (x2, values4, i2) => {
    values4[9 * i2 + 0] = x2[0];
    values4[9 * i2 + 1] = x2[1];
    values4[9 * i2 + 2] = x2[2];
    values4[9 * i2 + 3] = x2[3];
    values4[9 * i2 + 4] = x2[4];
    values4[9 * i2 + 5] = x2[5];
    values4[9 * i2 + 6] = x2[6];
    values4[9 * i2 + 7] = x2[7];
    values4[9 * i2 + 8] = x2[8];
    values4[9 * i2 + 9] = x2[9];
  },
  MAT4: (x2, values4, i2) => {
    values4[16 * i2 + 0] = x2[0];
    values4[16 * i2 + 1] = x2[1];
    values4[16 * i2 + 2] = x2[2];
    values4[16 * i2 + 3] = x2[3];
    values4[16 * i2 + 4] = x2[4];
    values4[16 * i2 + 5] = x2[5];
    values4[16 * i2 + 6] = x2[6];
    values4[16 * i2 + 7] = x2[7];
    values4[16 * i2 + 8] = x2[8];
    values4[16 * i2 + 9] = x2[9];
    values4[16 * i2 + 10] = x2[10];
    values4[16 * i2 + 11] = x2[11];
    values4[16 * i2 + 12] = x2[12];
    values4[16 * i2 + 13] = x2[13];
    values4[16 * i2 + 14] = x2[14];
    values4[16 * i2 + 15] = x2[15];
  }
};
function createTypedArrayFromAccessor(tile3DAccessor, buffer3, byteOffset, length2) {
  const { componentType } = tile3DAccessor;
  assert$4(tile3DAccessor.componentType);
  const type = typeof componentType === "string" ? GLType.fromName(componentType) : componentType;
  const size12 = COMPONENTS_PER_ATTRIBUTE[tile3DAccessor.type];
  const unpacker = UNPACKER[tile3DAccessor.type];
  const packer = PACKER[tile3DAccessor.type];
  byteOffset += tile3DAccessor.byteOffset;
  const values4 = GLType.createTypedArray(type, buffer3, byteOffset, size12 * length2);
  return {
    values: values4,
    type,
    size: size12,
    unpacker,
    packer
  };
}
const defined$1 = (x2) => x2 !== void 0;
function initializeHierarchy(batchTable, jsonHeader, binaryBody) {
  if (!jsonHeader) {
    return null;
  }
  let hierarchy = batchTable.getExtension("3DTILES_batch_table_hierarchy");
  const legacyHierarchy = jsonHeader.HIERARCHY;
  if (legacyHierarchy) {
    console.warn("3D Tile Parser: HIERARCHY is deprecated. Use 3DTILES_batch_table_hierarchy.");
    jsonHeader.extensions = jsonHeader.extensions || {};
    jsonHeader.extensions["3DTILES_batch_table_hierarchy"] = legacyHierarchy;
    hierarchy = legacyHierarchy;
  }
  if (!hierarchy) {
    return null;
  }
  return initializeHierarchyValues(hierarchy, binaryBody);
}
function initializeHierarchyValues(hierarchyJson, binaryBody) {
  let i2;
  let classId;
  let binaryAccessor;
  const instancesLength = hierarchyJson.instancesLength;
  const classes2 = hierarchyJson.classes;
  let classIds = hierarchyJson.classIds;
  let parentCounts = hierarchyJson.parentCounts;
  let parentIds = hierarchyJson.parentIds;
  let parentIdsLength = instancesLength;
  if (defined$1(classIds.byteOffset)) {
    classIds.componentType = defaultValue(classIds.componentType, GL.UNSIGNED_SHORT);
    classIds.type = AttributeType.SCALAR;
    binaryAccessor = getBinaryAccessor(classIds);
    classIds = binaryAccessor.createArrayBufferView(binaryBody.buffer, binaryBody.byteOffset + classIds.byteOffset, instancesLength);
  }
  let parentIndexes;
  if (defined$1(parentCounts)) {
    if (defined$1(parentCounts.byteOffset)) {
      parentCounts.componentType = defaultValue(parentCounts.componentType, GL.UNSIGNED_SHORT);
      parentCounts.type = AttributeType.SCALAR;
      binaryAccessor = getBinaryAccessor(parentCounts);
      parentCounts = binaryAccessor.createArrayBufferView(binaryBody.buffer, binaryBody.byteOffset + parentCounts.byteOffset, instancesLength);
    }
    parentIndexes = new Uint16Array(instancesLength);
    parentIdsLength = 0;
    for (i2 = 0; i2 < instancesLength; ++i2) {
      parentIndexes[i2] = parentIdsLength;
      parentIdsLength += parentCounts[i2];
    }
  }
  if (defined$1(parentIds) && defined$1(parentIds.byteOffset)) {
    parentIds.componentType = defaultValue(parentIds.componentType, GL.UNSIGNED_SHORT);
    parentIds.type = AttributeType.SCALAR;
    binaryAccessor = getBinaryAccessor(parentIds);
    parentIds = binaryAccessor.createArrayBufferView(binaryBody.buffer, binaryBody.byteOffset + parentIds.byteOffset, parentIdsLength);
  }
  const classesLength = classes2.length;
  for (i2 = 0; i2 < classesLength; ++i2) {
    const classInstancesLength = classes2[i2].length;
    const properties = classes2[i2].instances;
    const binaryProperties = getBinaryProperties(classInstancesLength, properties, binaryBody);
    classes2[i2].instances = combine(binaryProperties, properties);
  }
  const classCounts = new Array(classesLength).fill(0);
  const classIndexes = new Uint16Array(instancesLength);
  for (i2 = 0; i2 < instancesLength; ++i2) {
    classId = classIds[i2];
    classIndexes[i2] = classCounts[classId];
    ++classCounts[classId];
  }
  const hierarchy = {
    classes: classes2,
    classIds,
    classIndexes,
    parentCounts,
    parentIndexes,
    parentIds
  };
  validateHierarchy(hierarchy);
  return hierarchy;
}
function traverseHierarchy(hierarchy, instanceIndex, endConditionCallback) {
  if (!hierarchy) {
    return;
  }
  const parentCounts = hierarchy.parentCounts;
  const parentIds = hierarchy.parentIds;
  if (parentIds) {
    return endConditionCallback(hierarchy, instanceIndex);
  }
  if (parentCounts > 0) {
    return traverseHierarchyMultipleParents(hierarchy, instanceIndex, endConditionCallback);
  }
  return traverseHierarchySingleParent(hierarchy, instanceIndex, endConditionCallback);
}
function traverseHierarchyMultipleParents(hierarchy, instanceIndex, endConditionCallback) {
  const classIds = hierarchy.classIds;
  const parentCounts = hierarchy.parentCounts;
  const parentIds = hierarchy.parentIds;
  const parentIndexes = hierarchy.parentIndexes;
  const instancesLength = classIds.length;
  const visited = scratchVisited;
  visited.length = Math.max(visited.length, instancesLength);
  const visitedMarker = ++marker;
  const stack2 = scratchStack;
  stack2.length = 0;
  stack2.push(instanceIndex);
  while (stack2.length > 0) {
    instanceIndex = stack2.pop();
    if (visited[instanceIndex] === visitedMarker) {
      continue;
    }
    visited[instanceIndex] = visitedMarker;
    const result = endConditionCallback(hierarchy, instanceIndex);
    if (defined$1(result)) {
      return result;
    }
    const parentCount = parentCounts[instanceIndex];
    const parentIndex = parentIndexes[instanceIndex];
    for (let i2 = 0; i2 < parentCount; ++i2) {
      const parentId = parentIds[parentIndex + i2];
      if (parentId !== instanceIndex) {
        stack2.push(parentId);
      }
    }
  }
  return null;
}
function traverseHierarchySingleParent(hierarchy, instanceIndex, endConditionCallback) {
  let hasParent = true;
  while (hasParent) {
    const result = endConditionCallback(hierarchy, instanceIndex);
    if (defined$1(result)) {
      return result;
    }
    const parentId = hierarchy.parentIds[instanceIndex];
    hasParent = parentId !== instanceIndex;
    instanceIndex = parentId;
  }
  throw new Error("traverseHierarchySingleParent");
}
function validateHierarchy(hierarchy) {
  const classIds = hierarchy.classIds;
  const instancesLength = classIds.length;
  for (let i2 = 0; i2 < instancesLength; ++i2) {
    validateInstance(hierarchy, i2, stack);
  }
}
function validateInstance(hierarchy, instanceIndex, stack2) {
  const parentCounts = hierarchy.parentCounts;
  const parentIds = hierarchy.parentIds;
  const parentIndexes = hierarchy.parentIndexes;
  const classIds = hierarchy.classIds;
  const instancesLength = classIds.length;
  if (!defined$1(parentIds)) {
    return;
  }
  assert(instanceIndex < instancesLength, `Parent index ${instanceIndex} exceeds the total number of instances: ${instancesLength}`);
  assert(stack2.indexOf(instanceIndex) === -1, "Circular dependency detected in the batch table hierarchy.");
  stack2.push(instanceIndex);
  const parentCount = defined$1(parentCounts) ? parentCounts[instanceIndex] : 1;
  const parentIndex = defined$1(parentCounts) ? parentIndexes[instanceIndex] : instanceIndex;
  for (let i2 = 0; i2 < parentCount; ++i2) {
    const parentId = parentIds[parentIndex + i2];
    if (parentId !== instanceIndex) {
      validateInstance(hierarchy, parentId, stack2);
    }
  }
  stack2.pop(instanceIndex);
}
function defined(x2) {
  return x2 !== void 0 && x2 !== null;
}
const clone = (x2, y2) => x2;
const IGNORED_PROPERTY_FIELDS = {
  HIERARCHY: true,
  // Deprecated HIERARCHY property
  extensions: true,
  extras: true
};
class Tile3DBatchTableParser {
  constructor(json, binary, featureCount, options2 = {}) {
    __publicField2(this, "json");
    __publicField2(this, "binary");
    __publicField2(this, "featureCount");
    __publicField2(this, "_extensions");
    // Copy all top-level property fields from the json object, ignoring special fields
    __publicField2(this, "_properties");
    __publicField2(this, "_binaryProperties");
    // TODO: hierarchy support is only partially implemented and not tested
    __publicField2(this, "_hierarchy");
    var _a3;
    assert$4(featureCount >= 0);
    this.json = json || {};
    this.binary = binary;
    this.featureCount = featureCount;
    this._extensions = ((_a3 = this.json) == null ? void 0 : _a3.extensions) || {};
    this._properties = {};
    for (const propertyName in this.json) {
      if (!IGNORED_PROPERTY_FIELDS[propertyName]) {
        this._properties[propertyName] = this.json[propertyName];
      }
    }
    this._binaryProperties = this._initializeBinaryProperties();
    if (options2["3DTILES_batch_table_hierarchy"]) {
      this._hierarchy = initializeHierarchy(this, this.json, this.binary);
    }
  }
  getExtension(extensionName) {
    return this.json && this.json.extensions && this.json.extensions[extensionName];
  }
  memorySizeInBytes() {
    return 0;
  }
  isClass(batchId, className) {
    this._checkBatchId(batchId);
    assert$4(typeof className === "string", className);
    if (this._hierarchy) {
      const result = traverseHierarchy(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
        const classId = hierarchy.classIds[instanceIndex];
        const instanceClass = hierarchy.classes[classId];
        return instanceClass.name === className;
      });
      return defined(result);
    }
    return false;
  }
  isExactClass(batchId, className) {
    assert$4(typeof className === "string", className);
    return this.getExactClassName(batchId) === className;
  }
  getExactClassName(batchId) {
    this._checkBatchId(batchId);
    if (this._hierarchy) {
      const classId = this._hierarchy.classIds[batchId];
      const instanceClass = this._hierarchy.classes[classId];
      return instanceClass.name;
    }
    return void 0;
  }
  hasProperty(batchId, name2) {
    this._checkBatchId(batchId);
    assert$4(typeof name2 === "string", name2);
    return defined(this._properties[name2]) || this._hasPropertyInHierarchy(batchId, name2);
  }
  getPropertyNames(batchId, results) {
    this._checkBatchId(batchId);
    results = defined(results) ? results : [];
    results.length = 0;
    const propertyNames = Object.keys(this._properties);
    results.push(...propertyNames);
    if (this._hierarchy) {
      this._getPropertyNamesInHierarchy(batchId, results);
    }
    return results;
  }
  getProperty(batchId, name2) {
    this._checkBatchId(batchId);
    assert$4(typeof name2 === "string", name2);
    if (this._binaryProperties) {
      const binaryProperty = this._binaryProperties[name2];
      if (defined(binaryProperty)) {
        return this._getBinaryProperty(binaryProperty, batchId);
      }
    }
    const propertyValues = this._properties[name2];
    if (defined(propertyValues)) {
      return clone(propertyValues[batchId]);
    }
    if (this._hierarchy) {
      const hierarchyProperty = this._getHierarchyProperty(batchId, name2);
      if (defined(hierarchyProperty)) {
        return hierarchyProperty;
      }
    }
    return void 0;
  }
  setProperty(batchId, name2, value) {
    const featureCount = this.featureCount;
    this._checkBatchId(batchId);
    assert$4(typeof name2 === "string", name2);
    if (this._binaryProperties) {
      const binaryProperty = this._binaryProperties[name2];
      if (binaryProperty) {
        this._setBinaryProperty(binaryProperty, batchId, value);
        return;
      }
    }
    if (this._hierarchy) {
      if (this._setHierarchyProperty(this, batchId, name2, value)) {
        return;
      }
    }
    let propertyValues = this._properties[name2];
    if (!defined(propertyValues)) {
      this._properties[name2] = new Array(featureCount);
      propertyValues = this._properties[name2];
    }
    propertyValues[batchId] = clone(value);
  }
  // PRIVATE METHODS
  _checkBatchId(batchId) {
    const valid = batchId >= 0 && batchId < this.featureCount;
    if (!valid) {
      throw new Error("batchId not in range [0, featureCount - 1].");
    }
  }
  _getBinaryProperty(binaryProperty, index2) {
    return binaryProperty.unpack(binaryProperty.typedArray, index2);
  }
  _setBinaryProperty(binaryProperty, index2, value) {
    binaryProperty.pack(value, binaryProperty.typedArray, index2);
  }
  _initializeBinaryProperties() {
    let binaryProperties = null;
    for (const name2 in this._properties) {
      const property2 = this._properties[name2];
      const binaryProperty = this._initializeBinaryProperty(name2, property2);
      if (binaryProperty) {
        binaryProperties = binaryProperties || {};
        binaryProperties[name2] = binaryProperty;
      }
    }
    return binaryProperties;
  }
  _initializeBinaryProperty(name2, property2) {
    if ("byteOffset" in property2) {
      const tile3DAccessor = property2;
      assert$4(this.binary, `Property ${name2} requires a batch table binary.`);
      assert$4(tile3DAccessor.type, `Property ${name2} requires a type.`);
      const accessor = createTypedArrayFromAccessor(tile3DAccessor, this.binary.buffer, this.binary.byteOffset | 0, this.featureCount);
      return {
        typedArray: accessor.values,
        componentCount: accessor.size,
        unpack: accessor.unpacker,
        pack: accessor.packer
      };
    }
    return null;
  }
  //  EXTENSION SUPPORT: 3DTILES_batch_table_hierarchy
  _hasPropertyInHierarchy(batchId, name2) {
    if (!this._hierarchy) {
      return false;
    }
    const result = traverseHierarchy(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instances = hierarchy.classes[classId].instances;
      return defined(instances[name2]);
    });
    return defined(result);
  }
  _getPropertyNamesInHierarchy(batchId, results) {
    traverseHierarchy(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instances = hierarchy.classes[classId].instances;
      for (const name2 in instances) {
        if (instances.hasOwnProperty(name2)) {
          if (results.indexOf(name2) === -1) {
            results.push(name2);
          }
        }
      }
    });
  }
  _getHierarchyProperty(batchId, name2) {
    return traverseHierarchy(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instanceClass = hierarchy.classes[classId];
      const indexInClass = hierarchy.classIndexes[instanceIndex];
      const propertyValues = instanceClass.instances[name2];
      if (defined(propertyValues)) {
        if (defined(propertyValues.typedArray)) {
          return this._getBinaryProperty(propertyValues, indexInClass);
        }
        return clone(propertyValues[indexInClass]);
      }
      return null;
    });
  }
  _setHierarchyProperty(batchTable, batchId, name2, value) {
    const result = traverseHierarchy(this._hierarchy, batchId, (hierarchy, instanceIndex) => {
      const classId = hierarchy.classIds[instanceIndex];
      const instanceClass = hierarchy.classes[classId];
      const indexInClass = hierarchy.classIndexes[instanceIndex];
      const propertyValues = instanceClass.instances[name2];
      if (defined(propertyValues)) {
        assert$4(instanceIndex === batchId, `Inherited property "${name2}" is read-only.`);
        if (defined(propertyValues.typedArray)) {
          this._setBinaryProperty(propertyValues, indexInClass, value);
        } else {
          propertyValues[indexInClass] = clone(value);
        }
        return true;
      }
      return false;
    });
    return defined(result);
  }
}
const SIZEOF_UINT32$1 = 4;
function parse3DTileHeaderSync(tile, arrayBuffer2, byteOffset = 0) {
  const view2 = new DataView(arrayBuffer2);
  tile.magic = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$1;
  tile.version = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$1;
  tile.byteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32$1;
  if (tile.version !== 1) {
    throw new Error(`3D Tile Version ${tile.version} not supported`);
  }
  return byteOffset;
}
const SIZEOF_UINT32 = 4;
const DEPRECATION_WARNING = "b3dm tile in legacy format.";
function parse3DTileTablesHeaderSync(tile, arrayBuffer2, byteOffset) {
  const view2 = new DataView(arrayBuffer2);
  let batchLength;
  tile.header = tile.header || {};
  let featureTableJsonByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32;
  let featureTableBinaryByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32;
  let batchTableJsonByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32;
  let batchTableBinaryByteLength = view2.getUint32(byteOffset, true);
  byteOffset += SIZEOF_UINT32;
  if (batchTableJsonByteLength >= 570425344) {
    byteOffset -= SIZEOF_UINT32 * 2;
    batchLength = featureTableJsonByteLength;
    batchTableJsonByteLength = featureTableBinaryByteLength;
    batchTableBinaryByteLength = 0;
    featureTableJsonByteLength = 0;
    featureTableBinaryByteLength = 0;
    console.warn(DEPRECATION_WARNING);
  } else if (batchTableBinaryByteLength >= 570425344) {
    byteOffset -= SIZEOF_UINT32;
    batchLength = batchTableJsonByteLength;
    batchTableJsonByteLength = featureTableJsonByteLength;
    batchTableBinaryByteLength = featureTableBinaryByteLength;
    featureTableJsonByteLength = 0;
    featureTableBinaryByteLength = 0;
    console.warn(DEPRECATION_WARNING);
  }
  tile.header.featureTableJsonByteLength = featureTableJsonByteLength;
  tile.header.featureTableBinaryByteLength = featureTableBinaryByteLength;
  tile.header.batchTableJsonByteLength = batchTableJsonByteLength;
  tile.header.batchTableBinaryByteLength = batchTableBinaryByteLength;
  tile.header.batchLength = batchLength;
  return byteOffset;
}
function parse3DTileTablesSync(tile, arrayBuffer2, byteOffset, options2) {
  byteOffset = parse3DTileFeatureTable(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileBatchTable(tile, arrayBuffer2, byteOffset);
  return byteOffset;
}
function parse3DTileFeatureTable(tile, arrayBuffer2, byteOffset, options2) {
  const { featureTableJsonByteLength, featureTableBinaryByteLength, batchLength } = tile.header || {};
  tile.featureTableJson = {
    BATCH_LENGTH: batchLength || 0
  };
  if (featureTableJsonByteLength && featureTableJsonByteLength > 0) {
    const featureTableString = getStringFromArrayBuffer(arrayBuffer2, byteOffset, featureTableJsonByteLength);
    tile.featureTableJson = JSON.parse(featureTableString);
  }
  byteOffset += featureTableJsonByteLength || 0;
  tile.featureTableBinary = new Uint8Array(arrayBuffer2, byteOffset, featureTableBinaryByteLength);
  byteOffset += featureTableBinaryByteLength || 0;
  return byteOffset;
}
function parse3DTileBatchTable(tile, arrayBuffer2, byteOffset, options2) {
  const { batchTableJsonByteLength, batchTableBinaryByteLength } = tile.header || {};
  if (batchTableJsonByteLength && batchTableJsonByteLength > 0) {
    const batchTableString = getStringFromArrayBuffer(arrayBuffer2, byteOffset, batchTableJsonByteLength);
    tile.batchTableJson = JSON.parse(batchTableString);
    byteOffset += batchTableJsonByteLength;
    if (batchTableBinaryByteLength && batchTableBinaryByteLength > 0) {
      tile.batchTableBinary = new Uint8Array(arrayBuffer2, byteOffset, batchTableBinaryByteLength);
      tile.batchTableBinary = new Uint8Array(tile.batchTableBinary);
      byteOffset += batchTableBinaryByteLength;
    }
  }
  return byteOffset;
}
function normalize3DTileColorAttribute(tile, colors, batchTable) {
  if (!colors && (!tile || !tile.batchIds || !batchTable)) {
    return null;
  }
  const { batchIds, isRGB565, pointCount = 0 } = tile;
  if (batchIds && batchTable) {
    const colorArray = new Uint8ClampedArray(pointCount * 3);
    for (let i2 = 0; i2 < pointCount; i2++) {
      const batchId = batchIds[i2];
      const dimensions = batchTable.getProperty(batchId, "dimensions");
      const color = dimensions.map((d2) => d2 * 255);
      colorArray[i2 * 3] = color[0];
      colorArray[i2 * 3 + 1] = color[1];
      colorArray[i2 * 3 + 2] = color[2];
    }
    return {
      type: GL$1.UNSIGNED_BYTE,
      value: colorArray,
      size: 3,
      normalized: true
    };
  }
  if (colors && isRGB565) {
    const colorArray = new Uint8ClampedArray(pointCount * 3);
    for (let i2 = 0; i2 < pointCount; i2++) {
      const color = decodeRGB565(colors[i2]);
      colorArray[i2 * 3] = color[0];
      colorArray[i2 * 3 + 1] = color[1];
      colorArray[i2 * 3 + 2] = color[2];
    }
    return {
      type: GL$1.UNSIGNED_BYTE,
      value: colorArray,
      size: 3,
      normalized: true
    };
  }
  if (colors && colors.length === pointCount * 3) {
    return {
      type: GL$1.UNSIGNED_BYTE,
      value: colors,
      size: 3,
      normalized: true
    };
  }
  return {
    type: GL$1.UNSIGNED_BYTE,
    value: colors || new Uint8ClampedArray(),
    size: 4,
    normalized: true
  };
}
const scratchNormal = new Vector3();
function normalize3DTileNormalAttribute(tile, normals) {
  if (!normals) {
    return null;
  }
  if (tile.isOctEncoded16P) {
    const decodedArray = new Float32Array((tile.pointsLength || 0) * 3);
    for (let i2 = 0; i2 < (tile.pointsLength || 0); i2++) {
      octDecode(normals[i2 * 2], normals[i2 * 2 + 1], scratchNormal);
      scratchNormal.toArray(decodedArray, i2 * 3);
    }
    return {
      type: GL$1.FLOAT,
      size: 2,
      value: decodedArray
    };
  }
  return {
    type: GL$1.FLOAT,
    size: 2,
    value: normals
  };
}
function normalize3DTilePositionAttribute(tile, positions, options2) {
  if (!tile.isQuantized) {
    return positions;
  }
  if (options2["3d-tiles"] && options2["3d-tiles"].decodeQuantizedPositions) {
    tile.isQuantized = false;
    return decodeQuantizedPositions(tile, positions);
  }
  return {
    type: GL$1.UNSIGNED_SHORT,
    value: positions,
    size: 3,
    normalized: true
  };
}
function decodeQuantizedPositions(tile, positions) {
  const scratchPosition2 = new Vector3();
  const decodedArray = new Float32Array(tile.pointCount * 3);
  for (let i2 = 0; i2 < tile.pointCount; i2++) {
    scratchPosition2.set(positions[i2 * 3], positions[i2 * 3 + 1], positions[i2 * 3 + 2]).scale(1 / tile.quantizedRange).multiply(tile.quantizedVolumeScale).add(tile.quantizedVolumeOffset).toArray(decodedArray, i2 * 3);
  }
  return decodedArray;
}
async function parsePointCloud3DTile(tile, arrayBuffer2, byteOffset, options2, context2) {
  byteOffset = parse3DTileHeaderSync(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesHeaderSync(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesSync(tile, arrayBuffer2, byteOffset);
  initializeTile(tile);
  const { featureTable, batchTable } = parsePointCloudTables(tile);
  await parseDraco(tile, featureTable, batchTable, options2, context2);
  parsePositions(tile, featureTable, options2);
  parseColors(tile, featureTable, batchTable);
  parseNormals(tile, featureTable);
  return byteOffset;
}
function initializeTile(tile) {
  tile.attributes = {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  tile.isQuantized = false;
  tile.isTranslucent = false;
  tile.isRGB565 = false;
  tile.isOctEncoded16P = false;
}
function parsePointCloudTables(tile) {
  const featureTable = new Tile3DFeatureTable(tile.featureTableJson, tile.featureTableBinary);
  const pointsLength = featureTable.getGlobalProperty("POINTS_LENGTH");
  if (!Number.isFinite(pointsLength)) {
    throw new Error("POINTS_LENGTH must be defined");
  }
  featureTable.featuresLength = pointsLength;
  tile.featuresLength = pointsLength;
  tile.pointsLength = pointsLength;
  tile.pointCount = pointsLength;
  tile.rtcCenter = featureTable.getGlobalProperty("RTC_CENTER", GL$1.FLOAT, 3);
  const batchTable = parseBatchIds(tile, featureTable);
  return { featureTable, batchTable };
}
function parsePositions(tile, featureTable, options2) {
  tile.attributes = tile.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  if (!tile.attributes.positions) {
    if (featureTable.hasProperty("POSITION")) {
      tile.attributes.positions = featureTable.getPropertyArray("POSITION", GL$1.FLOAT, 3);
    } else if (featureTable.hasProperty("POSITION_QUANTIZED")) {
      const positions = featureTable.getPropertyArray("POSITION_QUANTIZED", GL$1.UNSIGNED_SHORT, 3);
      tile.isQuantized = true;
      tile.quantizedRange = (1 << 16) - 1;
      tile.quantizedVolumeScale = featureTable.getGlobalProperty("QUANTIZED_VOLUME_SCALE", GL$1.FLOAT, 3);
      if (!tile.quantizedVolumeScale) {
        throw new Error("QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      }
      tile.quantizedVolumeOffset = featureTable.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", GL$1.FLOAT, 3);
      if (!tile.quantizedVolumeOffset) {
        throw new Error("QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      }
      tile.attributes.positions = normalize3DTilePositionAttribute(tile, positions, options2);
    }
  }
  if (!tile.attributes.positions) {
    throw new Error("Either POSITION or POSITION_QUANTIZED must be defined.");
  }
}
function parseColors(tile, featureTable, batchTable) {
  tile.attributes = tile.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  if (!tile.attributes.colors) {
    let colors = null;
    if (featureTable.hasProperty("RGBA")) {
      colors = featureTable.getPropertyArray("RGBA", GL$1.UNSIGNED_BYTE, 4);
      tile.isTranslucent = true;
    } else if (featureTable.hasProperty("RGB")) {
      colors = featureTable.getPropertyArray("RGB", GL$1.UNSIGNED_BYTE, 3);
    } else if (featureTable.hasProperty("RGB565")) {
      colors = featureTable.getPropertyArray("RGB565", GL$1.UNSIGNED_SHORT, 1);
      tile.isRGB565 = true;
    }
    tile.attributes.colors = normalize3DTileColorAttribute(tile, colors, batchTable);
  }
  if (featureTable.hasProperty("CONSTANT_RGBA")) {
    tile.constantRGBA = featureTable.getGlobalProperty("CONSTANT_RGBA", GL$1.UNSIGNED_BYTE, 4);
  }
}
function parseNormals(tile, featureTable) {
  tile.attributes = tile.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  };
  if (!tile.attributes.normals) {
    let normals = null;
    if (featureTable.hasProperty("NORMAL")) {
      normals = featureTable.getPropertyArray("NORMAL", GL$1.FLOAT, 3);
    } else if (featureTable.hasProperty("NORMAL_OCT16P")) {
      normals = featureTable.getPropertyArray("NORMAL_OCT16P", GL$1.UNSIGNED_BYTE, 2);
      tile.isOctEncoded16P = true;
    }
    tile.attributes.normals = normalize3DTileNormalAttribute(tile, normals);
  }
}
function parseBatchIds(tile, featureTable) {
  let batchTable = null;
  if (!tile.batchIds && featureTable.hasProperty("BATCH_ID")) {
    tile.batchIds = featureTable.getPropertyArray("BATCH_ID", GL$1.UNSIGNED_SHORT, 1);
    if (tile.batchIds) {
      const batchFeatureLength = featureTable.getGlobalProperty("BATCH_LENGTH");
      if (!batchFeatureLength) {
        throw new Error("Global property: BATCH_LENGTH must be defined when BATCH_ID is defined.");
      }
      const { batchTableJson, batchTableBinary } = tile;
      batchTable = new Tile3DBatchTableParser(batchTableJson, batchTableBinary, batchFeatureLength);
    }
  }
  return batchTable;
}
async function parseDraco(tile, featureTable, batchTable, options2, context2) {
  let dracoBuffer;
  let dracoFeatureTableProperties;
  let dracoBatchTableProperties;
  const batchTableDraco = tile.batchTableJson && tile.batchTableJson.extensions && tile.batchTableJson.extensions["3DTILES_draco_point_compression"];
  if (batchTableDraco) {
    dracoBatchTableProperties = batchTableDraco.properties;
  }
  const featureTableDraco = featureTable.getExtension("3DTILES_draco_point_compression");
  if (featureTableDraco) {
    dracoFeatureTableProperties = featureTableDraco.properties;
    const dracoByteOffset = featureTableDraco.byteOffset;
    const dracoByteLength = featureTableDraco.byteLength;
    if (!dracoFeatureTableProperties || !Number.isFinite(dracoByteOffset) || !dracoByteLength) {
      throw new Error("Draco properties, byteOffset, and byteLength must be defined");
    }
    dracoBuffer = (tile.featureTableBinary || []).slice(dracoByteOffset, dracoByteOffset + dracoByteLength);
    tile.hasPositions = Number.isFinite(dracoFeatureTableProperties.POSITION);
    tile.hasColors = Number.isFinite(dracoFeatureTableProperties.RGB) || Number.isFinite(dracoFeatureTableProperties.RGBA);
    tile.hasNormals = Number.isFinite(dracoFeatureTableProperties.NORMAL);
    tile.hasBatchIds = Number.isFinite(dracoFeatureTableProperties.BATCH_ID);
    tile.isTranslucent = Number.isFinite(dracoFeatureTableProperties.RGBA);
  }
  if (!dracoBuffer) {
    return true;
  }
  const dracoData = {
    buffer: dracoBuffer,
    properties: { ...dracoFeatureTableProperties, ...dracoBatchTableProperties },
    featureTableProperties: dracoFeatureTableProperties,
    batchTableProperties: dracoBatchTableProperties,
    dequantizeInShader: false
  };
  return await loadDraco(tile, dracoData, options2, context2);
}
async function loadDraco(tile, dracoData, options2, context2) {
  if (!context2) {
    return;
  }
  const dracoOptions = {
    ...options2,
    draco: {
      ...options2 == null ? void 0 : options2.draco,
      extraAttributes: dracoData.batchTableProperties || {}
    }
  };
  delete dracoOptions["3d-tiles"];
  const data2 = await parseFromContext(dracoData.buffer, DracoLoader, dracoOptions, context2);
  const decodedPositions = data2.attributes.POSITION && data2.attributes.POSITION.value;
  const decodedColors = data2.attributes.COLOR_0 && data2.attributes.COLOR_0.value;
  const decodedNormals = data2.attributes.NORMAL && data2.attributes.NORMAL.value;
  const decodedBatchIds = data2.attributes.BATCH_ID && data2.attributes.BATCH_ID.value;
  const isQuantizedDraco = decodedPositions && data2.attributes.POSITION.value.quantization;
  const isOctEncodedDraco = decodedNormals && data2.attributes.NORMAL.value.quantization;
  if (isQuantizedDraco) {
    const quantization = data2.POSITION.data.quantization;
    const range2 = quantization.range;
    tile.quantizedVolumeScale = new Vector3(range2, range2, range2);
    tile.quantizedVolumeOffset = new Vector3(quantization.minValues);
    tile.quantizedRange = (1 << quantization.quantizationBits) - 1;
    tile.isQuantizedDraco = true;
  }
  if (isOctEncodedDraco) {
    tile.octEncodedRange = (1 << data2.NORMAL.data.quantization.quantizationBits) - 1;
    tile.isOctEncodedDraco = true;
  }
  const batchTableAttributes = {};
  if (dracoData.batchTableProperties) {
    for (const attributeName of Object.keys(dracoData.batchTableProperties)) {
      if (data2.attributes[attributeName] && data2.attributes[attributeName].value) {
        batchTableAttributes[attributeName.toLowerCase()] = data2.attributes[attributeName].value;
      }
    }
  }
  tile.attributes = {
    // @ts-expect-error
    positions: decodedPositions,
    // @ts-expect-error
    colors: normalize3DTileColorAttribute(tile, decodedColors, void 0),
    // @ts-expect-error
    normals: decodedNormals,
    // @ts-expect-error
    batchIds: decodedBatchIds,
    ...batchTableAttributes
  };
}
const VERSION$2 = "4.2.1";
const parseImageNode = (_f = globalThis.loaders) == null ? void 0 : _f.parseImageNode;
const IMAGE_SUPPORTED = typeof Image !== "undefined";
const IMAGE_BITMAP_SUPPORTED = typeof ImageBitmap !== "undefined";
const NODE_IMAGE_SUPPORTED = Boolean(parseImageNode);
const DATA_SUPPORTED = isBrowser$2 ? true : NODE_IMAGE_SUPPORTED;
function isImageTypeSupported(type) {
  switch (type) {
    case "auto":
      return IMAGE_BITMAP_SUPPORTED || IMAGE_SUPPORTED || DATA_SUPPORTED;
    case "imagebitmap":
      return IMAGE_BITMAP_SUPPORTED;
    case "image":
      return IMAGE_SUPPORTED;
    case "data":
      return DATA_SUPPORTED;
    default:
      throw new Error(`@loaders.gl/images: image ${type} not supported in this environment`);
  }
}
function getDefaultImageType() {
  if (IMAGE_BITMAP_SUPPORTED) {
    return "imagebitmap";
  }
  if (IMAGE_SUPPORTED) {
    return "image";
  }
  if (DATA_SUPPORTED) {
    return "data";
  }
  throw new Error("Install '@loaders.gl/polyfills' to parse images under Node.js");
}
function getImageType(image) {
  const format = getImageTypeOrNull(image);
  if (!format) {
    throw new Error("Not an image");
  }
  return format;
}
function getImageData(image) {
  switch (getImageType(image)) {
    case "data":
      return image;
    case "image":
    case "imagebitmap":
      const canvas2 = document.createElement("canvas");
      const context2 = canvas2.getContext("2d");
      if (!context2) {
        throw new Error("getImageData");
      }
      canvas2.width = image.width;
      canvas2.height = image.height;
      context2.drawImage(image, 0, 0);
      return context2.getImageData(0, 0, image.width, image.height);
    default:
      throw new Error("getImageData");
  }
}
function getImageTypeOrNull(image) {
  if (typeof ImageBitmap !== "undefined" && image instanceof ImageBitmap) {
    return "imagebitmap";
  }
  if (typeof Image !== "undefined" && image instanceof Image) {
    return "image";
  }
  if (image && typeof image === "object" && image.data && image.width && image.height) {
    return "data";
  }
  return null;
}
const SVG_DATA_URL_PATTERN = /^data:image\/svg\+xml/;
const SVG_URL_PATTERN = /\.svg((\?|#).*)?$/;
function isSVG(url2) {
  return url2 && (SVG_DATA_URL_PATTERN.test(url2) || SVG_URL_PATTERN.test(url2));
}
function getBlobOrSVGDataUrl(arrayBuffer2, url2) {
  if (isSVG(url2)) {
    const textDecoder = new TextDecoder();
    let xmlText = textDecoder.decode(arrayBuffer2);
    try {
      if (typeof unescape === "function" && typeof encodeURIComponent === "function") {
        xmlText = unescape(encodeURIComponent(xmlText));
      }
    } catch (error2) {
      throw new Error(error2.message);
    }
    const src2 = `data:image/svg+xml;base64,${btoa(xmlText)}`;
    return src2;
  }
  return getBlob(arrayBuffer2, url2);
}
function getBlob(arrayBuffer2, url2) {
  if (isSVG(url2)) {
    throw new Error("SVG cannot be parsed directly to imagebitmap");
  }
  return new Blob([new Uint8Array(arrayBuffer2)]);
}
async function parseToImage(arrayBuffer2, options2, url2) {
  const blobOrDataUrl = getBlobOrSVGDataUrl(arrayBuffer2, url2);
  const URL2 = self.URL || self.webkitURL;
  const objectUrl = typeof blobOrDataUrl !== "string" && URL2.createObjectURL(blobOrDataUrl);
  try {
    return await loadToImage(objectUrl || blobOrDataUrl, options2);
  } finally {
    if (objectUrl) {
      URL2.revokeObjectURL(objectUrl);
    }
  }
}
async function loadToImage(url2, options2) {
  const image = new Image();
  image.src = url2;
  if (options2.image && options2.image.decode && image.decode) {
    await image.decode();
    return image;
  }
  return await new Promise((resolve2, reject) => {
    try {
      image.onload = () => resolve2(image);
      image.onerror = (error2) => {
        const message2 = error2 instanceof Error ? error2.message : "error";
        reject(new Error(message2));
      };
    } catch (error2) {
      reject(error2);
    }
  });
}
const EMPTY_OBJECT = {};
let imagebitmapOptionsSupported = true;
async function parseToImageBitmap(arrayBuffer2, options2, url2) {
  let blob;
  if (isSVG(url2)) {
    const image = await parseToImage(arrayBuffer2, options2, url2);
    blob = image;
  } else {
    blob = getBlob(arrayBuffer2, url2);
  }
  const imagebitmapOptions = options2 && options2.imagebitmap;
  return await safeCreateImageBitmap(blob, imagebitmapOptions);
}
async function safeCreateImageBitmap(blob, imagebitmapOptions = null) {
  if (isEmptyObject(imagebitmapOptions) || !imagebitmapOptionsSupported) {
    imagebitmapOptions = null;
  }
  if (imagebitmapOptions) {
    try {
      return await createImageBitmap(blob, imagebitmapOptions);
    } catch (error2) {
      console.warn(error2);
      imagebitmapOptionsSupported = false;
    }
  }
  return await createImageBitmap(blob);
}
function isEmptyObject(object2) {
  for (const key in object2 || EMPTY_OBJECT) {
    return false;
  }
  return true;
}
function getISOBMFFMediaType(buffer3) {
  if (!checkString(buffer3, "ftyp", 4)) {
    return null;
  }
  if ((buffer3[8] & 96) === 0) {
    return null;
  }
  return decodeMajorBrand(buffer3);
}
function decodeMajorBrand(buffer3) {
  const brandMajor = getUTF8String(buffer3, 8, 12).replace("\0", " ").trim();
  switch (brandMajor) {
    case "avif":
    case "avis":
      return { extension: "avif", mimeType: "image/avif" };
    default:
      return null;
  }
}
function getUTF8String(array2, start2, end) {
  return String.fromCharCode(...array2.slice(start2, end));
}
function stringToBytes(string3) {
  return [...string3].map((character) => character.charCodeAt(0));
}
function checkString(buffer3, header, offset = 0) {
  const headerBytes = stringToBytes(header);
  for (let i2 = 0; i2 < headerBytes.length; ++i2) {
    if (headerBytes[i2] !== buffer3[i2 + offset]) {
      return false;
    }
  }
  return true;
}
const BIG_ENDIAN = false;
const LITTLE_ENDIAN$1 = true;
function getBinaryImageMetadata(binaryData) {
  const dataView = toDataView(binaryData);
  return getPngMetadata(dataView) || getJpegMetadata(dataView) || getGifMetadata(dataView) || getBmpMetadata(dataView) || getISOBMFFMetadata(dataView);
}
function getISOBMFFMetadata(binaryData) {
  const buffer3 = new Uint8Array(binaryData instanceof DataView ? binaryData.buffer : binaryData);
  const mediaType = getISOBMFFMediaType(buffer3);
  if (!mediaType) {
    return null;
  }
  return {
    mimeType: mediaType.mimeType,
    // TODO - decode width and height
    width: 0,
    height: 0
  };
}
function getPngMetadata(binaryData) {
  const dataView = toDataView(binaryData);
  const isPng = dataView.byteLength >= 24 && dataView.getUint32(0, BIG_ENDIAN) === 2303741511;
  if (!isPng) {
    return null;
  }
  return {
    mimeType: "image/png",
    width: dataView.getUint32(16, BIG_ENDIAN),
    height: dataView.getUint32(20, BIG_ENDIAN)
  };
}
function getGifMetadata(binaryData) {
  const dataView = toDataView(binaryData);
  const isGif = dataView.byteLength >= 10 && dataView.getUint32(0, BIG_ENDIAN) === 1195984440;
  if (!isGif) {
    return null;
  }
  return {
    mimeType: "image/gif",
    width: dataView.getUint16(6, LITTLE_ENDIAN$1),
    height: dataView.getUint16(8, LITTLE_ENDIAN$1)
  };
}
function getBmpMetadata(binaryData) {
  const dataView = toDataView(binaryData);
  const isBmp = dataView.byteLength >= 14 && dataView.getUint16(0, BIG_ENDIAN) === 16973 && dataView.getUint32(2, LITTLE_ENDIAN$1) === dataView.byteLength;
  if (!isBmp) {
    return null;
  }
  return {
    mimeType: "image/bmp",
    width: dataView.getUint32(18, LITTLE_ENDIAN$1),
    height: dataView.getUint32(22, LITTLE_ENDIAN$1)
  };
}
function getJpegMetadata(binaryData) {
  const dataView = toDataView(binaryData);
  const isJpeg = dataView.byteLength >= 3 && dataView.getUint16(0, BIG_ENDIAN) === 65496 && dataView.getUint8(2) === 255;
  if (!isJpeg) {
    return null;
  }
  const { tableMarkers, sofMarkers } = getJpegMarkers();
  let i2 = 2;
  while (i2 + 9 < dataView.byteLength) {
    const marker2 = dataView.getUint16(i2, BIG_ENDIAN);
    if (sofMarkers.has(marker2)) {
      return {
        mimeType: "image/jpeg",
        height: dataView.getUint16(i2 + 5, BIG_ENDIAN),
        // Number of lines
        width: dataView.getUint16(i2 + 7, BIG_ENDIAN)
        // Number of pixels per line
      };
    }
    if (!tableMarkers.has(marker2)) {
      return null;
    }
    i2 += 2;
    i2 += dataView.getUint16(i2, BIG_ENDIAN);
  }
  return null;
}
function getJpegMarkers() {
  const tableMarkers = /* @__PURE__ */ new Set([65499, 65476, 65484, 65501, 65534]);
  for (let i2 = 65504; i2 < 65520; ++i2) {
    tableMarkers.add(i2);
  }
  const sofMarkers = /* @__PURE__ */ new Set([
    65472,
    65473,
    65474,
    65475,
    65477,
    65478,
    65479,
    65481,
    65482,
    65483,
    65485,
    65486,
    65487,
    65502
  ]);
  return { tableMarkers, sofMarkers };
}
function toDataView(data2) {
  if (data2 instanceof DataView) {
    return data2;
  }
  if (ArrayBuffer.isView(data2)) {
    return new DataView(data2.buffer);
  }
  if (data2 instanceof ArrayBuffer) {
    return new DataView(data2);
  }
  throw new Error("toDataView");
}
async function parseToNodeImage(arrayBuffer2, options2) {
  var _a3;
  const { mimeType } = getBinaryImageMetadata(arrayBuffer2) || {};
  const parseImageNode2 = (_a3 = globalThis.loaders) == null ? void 0 : _a3.parseImageNode;
  assert$4(parseImageNode2);
  return await parseImageNode2(arrayBuffer2, mimeType);
}
async function parseImage(arrayBuffer2, options2, context2) {
  options2 = options2 || {};
  const imageOptions = options2.image || {};
  const imageType = imageOptions.type || "auto";
  const { url: url2 } = context2 || {};
  const loadType = getLoadableImageType(imageType);
  let image;
  switch (loadType) {
    case "imagebitmap":
      image = await parseToImageBitmap(arrayBuffer2, options2, url2);
      break;
    case "image":
      image = await parseToImage(arrayBuffer2, options2, url2);
      break;
    case "data":
      image = await parseToNodeImage(arrayBuffer2);
      break;
    default:
      assert$4(false);
  }
  if (imageType === "data") {
    image = getImageData(image);
  }
  return image;
}
function getLoadableImageType(type) {
  switch (type) {
    case "auto":
    case "data":
      return getDefaultImageType();
    default:
      isImageTypeSupported(type);
      return type;
  }
}
const EXTENSIONS$7 = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "ico", "svg", "avif"];
const MIME_TYPES = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/avif",
  "image/bmp",
  "image/vnd.microsoft.icon",
  "image/svg+xml"
];
const DEFAULT_IMAGE_LOADER_OPTIONS = {
  image: {
    type: "auto",
    decode: true
    // if format is HTML
  }
  // imagebitmap: {} - passes (platform dependent) parameters to ImageBitmap constructor
};
const ImageLoader = {
  dataType: null,
  batchType: null,
  id: "image",
  module: "images",
  name: "Images",
  version: VERSION$2,
  mimeTypes: MIME_TYPES,
  extensions: EXTENSIONS$7,
  parse: parseImage,
  // TODO: byteOffset, byteLength;
  tests: [(arrayBuffer2) => Boolean(getBinaryImageMetadata(new DataView(arrayBuffer2)))],
  options: DEFAULT_IMAGE_LOADER_OPTIONS
};
const mimeTypeSupportedSync = {};
function isImageFormatSupported(mimeType) {
  if (mimeTypeSupportedSync[mimeType] === void 0) {
    const supported = isBrowser$2 ? checkBrowserImageFormatSupport(mimeType) : checkNodeImageFormatSupport(mimeType);
    mimeTypeSupportedSync[mimeType] = supported;
  }
  return mimeTypeSupportedSync[mimeType];
}
function checkNodeImageFormatSupport(mimeType) {
  var _a3, _b3;
  const NODE_FORMAT_SUPPORT = ["image/png", "image/jpeg", "image/gif"];
  const imageFormatsNode = ((_a3 = globalThis.loaders) == null ? void 0 : _a3.imageFormatsNode) || NODE_FORMAT_SUPPORT;
  const parseImageNode2 = (_b3 = globalThis.loaders) == null ? void 0 : _b3.parseImageNode;
  return Boolean(parseImageNode2) && imageFormatsNode.includes(mimeType);
}
function checkBrowserImageFormatSupport(mimeType) {
  switch (mimeType) {
    case "image/avif":
    case "image/webp":
      return testBrowserImageFormatSupport(mimeType);
    default:
      return true;
  }
}
function testBrowserImageFormatSupport(mimeType) {
  try {
    const element = document.createElement("canvas");
    const dataURL = element.toDataURL(mimeType);
    return dataURL.indexOf(`data:${mimeType}`) === 0;
  } catch {
    return false;
  }
}
function assert$1(condition, message2) {
  if (!condition) {
    throw new Error(message2 || "assert failed: gltf");
  }
}
const COMPONENTS$1 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const BYTES$1 = {
  5120: 1,
  // BYTE
  5121: 1,
  // UNSIGNED_BYTE
  5122: 2,
  // SHORT
  5123: 2,
  // UNSIGNED_SHORT
  5125: 4,
  // UNSIGNED_INT
  5126: 4
  // FLOAT
};
const MIPMAP_FACTOR = 1.33;
const TYPES = ["SCALAR", "VEC2", "VEC3", "VEC4"];
const ARRAY_CONSTRUCTOR_TO_WEBGL_CONSTANT = [
  [Int8Array, 5120],
  [Uint8Array, 5121],
  [Int16Array, 5122],
  [Uint16Array, 5123],
  [Uint32Array, 5125],
  [Float32Array, 5126],
  [Float64Array, 5130]
];
const ARRAY_TO_COMPONENT_TYPE = new Map(ARRAY_CONSTRUCTOR_TO_WEBGL_CONSTANT);
const ATTRIBUTE_TYPE_TO_COMPONENTS$1 = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE$1 = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4
};
const ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$1 = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
function getAccessorTypeFromSize(size12) {
  const type = TYPES[size12 - 1];
  return type || TYPES[0];
}
function getComponentTypeFromArray(typedArray) {
  const componentType = ARRAY_TO_COMPONENT_TYPE.get(typedArray.constructor);
  if (!componentType) {
    throw new Error("Illegal typed array");
  }
  return componentType;
}
function getAccessorArrayTypeAndLength(accessor, bufferView) {
  const ArrayType2 = ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY$1[accessor.componentType];
  const components = ATTRIBUTE_TYPE_TO_COMPONENTS$1[accessor.type];
  const bytesPerComponent = ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE$1[accessor.componentType];
  const length2 = accessor.count * components;
  const byteLength = accessor.count * components * bytesPerComponent;
  assert$1(byteLength >= 0 && byteLength <= bufferView.byteLength);
  const componentByteSize = BYTES$1[accessor.componentType];
  const numberOfComponentsInElement = COMPONENTS$1[accessor.type];
  return { ArrayType: ArrayType2, length: length2, byteLength, componentByteSize, numberOfComponentsInElement };
}
function getMemoryUsageGLTF(gltf) {
  let { images, bufferViews } = gltf;
  images = images || [];
  bufferViews = bufferViews || [];
  const imageBufferViews = images.map((i2) => i2.bufferView);
  bufferViews = bufferViews.filter((view2) => !imageBufferViews.includes(view2));
  const bufferMemory = bufferViews.reduce((acc, view2) => acc + view2.byteLength, 0);
  const pixelCount = images.reduce((acc, image) => {
    const { width, height } = image.image;
    return acc + width * height;
  }, 0);
  return bufferMemory + Math.ceil(4 * pixelCount * MIPMAP_FACTOR);
}
function getTypedArrayForBufferView(json, buffers, bufferViewIndex) {
  const bufferView = json.bufferViews[bufferViewIndex];
  assert$1(bufferView);
  const bufferIndex = bufferView.buffer;
  const binChunk = buffers[bufferIndex];
  assert$1(binChunk);
  const byteOffset = (bufferView.byteOffset || 0) + binChunk.byteOffset;
  return new Uint8Array(binChunk.arrayBuffer, byteOffset, bufferView.byteLength);
}
function getTypedArrayForAccessor(json, buffers, accessor) {
  var _a3, _b3;
  const gltfAccessor = typeof accessor === "number" ? (_a3 = json.accessors) == null ? void 0 : _a3[accessor] : accessor;
  if (!gltfAccessor) {
    throw new Error(`No gltf accessor ${JSON.stringify(accessor)}`);
  }
  const bufferView = (_b3 = json.bufferViews) == null ? void 0 : _b3[gltfAccessor.bufferView || 0];
  if (!bufferView) {
    throw new Error(`No gltf buffer view for accessor ${bufferView}`);
  }
  const { arrayBuffer: arrayBuffer2, byteOffset: bufferByteOffset } = buffers[bufferView.buffer];
  const byteOffset = (bufferByteOffset || 0) + (gltfAccessor.byteOffset || 0) + (bufferView.byteOffset || 0);
  const { ArrayType: ArrayType2, length: length2, componentByteSize, numberOfComponentsInElement } = getAccessorArrayTypeAndLength(gltfAccessor, bufferView);
  const elementByteSize = componentByteSize * numberOfComponentsInElement;
  const elementAddressScale = bufferView.byteStride || elementByteSize;
  if (typeof bufferView.byteStride === "undefined" || bufferView.byteStride === elementByteSize) {
    const result2 = new ArrayType2(arrayBuffer2, byteOffset, length2);
    return result2;
  }
  const result = new ArrayType2(length2);
  for (let i2 = 0; i2 < gltfAccessor.count; i2++) {
    const values4 = new ArrayType2(arrayBuffer2, byteOffset + i2 * elementAddressScale, numberOfComponentsInElement);
    result.set(values4, i2 * numberOfComponentsInElement);
  }
  return result;
}
function makeDefaultGLTFJson() {
  return {
    asset: {
      version: "2.0",
      generator: "loaders.gl"
    },
    buffers: [],
    extensions: {},
    extensionsRequired: [],
    extensionsUsed: []
  };
}
class GLTFScenegraph {
  // TODO - why is this not GLTFWithBuffers - what happens to images?
  constructor(gltf) {
    // internal
    __publicField2(this, "gltf");
    __publicField2(this, "sourceBuffers");
    __publicField2(this, "byteLength");
    this.gltf = {
      json: (gltf == null ? void 0 : gltf.json) || makeDefaultGLTFJson(),
      buffers: (gltf == null ? void 0 : gltf.buffers) || [],
      images: (gltf == null ? void 0 : gltf.images) || []
    };
    this.sourceBuffers = [];
    this.byteLength = 0;
    if (this.gltf.buffers && this.gltf.buffers[0]) {
      this.byteLength = this.gltf.buffers[0].byteLength;
      this.sourceBuffers = [this.gltf.buffers[0]];
    }
  }
  // Accessors
  get json() {
    return this.gltf.json;
  }
  getApplicationData(key) {
    const data2 = this.json[key];
    return data2;
  }
  getExtraData(key) {
    const extras = this.json.extras || {};
    return extras[key];
  }
  hasExtension(extensionName) {
    const isUsedExtension = this.getUsedExtensions().find((name2) => name2 === extensionName);
    const isRequiredExtension = this.getRequiredExtensions().find((name2) => name2 === extensionName);
    return typeof isUsedExtension === "string" || typeof isRequiredExtension === "string";
  }
  getExtension(extensionName) {
    const isExtension = this.getUsedExtensions().find((name2) => name2 === extensionName);
    const extensions = this.json.extensions || {};
    return isExtension ? extensions[extensionName] : null;
  }
  getRequiredExtension(extensionName) {
    const isRequired = this.getRequiredExtensions().find((name2) => name2 === extensionName);
    return isRequired ? this.getExtension(extensionName) : null;
  }
  getRequiredExtensions() {
    return this.json.extensionsRequired || [];
  }
  getUsedExtensions() {
    return this.json.extensionsUsed || [];
  }
  getRemovedExtensions() {
    return this.json.extensionsRemoved || [];
  }
  getObjectExtension(object2, extensionName) {
    const extensions = object2.extensions || {};
    return extensions[extensionName];
  }
  getScene(index2) {
    return this.getObject("scenes", index2);
  }
  getNode(index2) {
    return this.getObject("nodes", index2);
  }
  getSkin(index2) {
    return this.getObject("skins", index2);
  }
  getMesh(index2) {
    return this.getObject("meshes", index2);
  }
  getMaterial(index2) {
    return this.getObject("materials", index2);
  }
  getAccessor(index2) {
    return this.getObject("accessors", index2);
  }
  // getCamera(index: number): object | null {
  //   return null; // TODO: fix thi: object  as null;
  // }
  getTexture(index2) {
    return this.getObject("textures", index2);
  }
  getSampler(index2) {
    return this.getObject("samplers", index2);
  }
  getImage(index2) {
    return this.getObject("images", index2);
  }
  getBufferView(index2) {
    return this.getObject("bufferViews", index2);
  }
  getBuffer(index2) {
    return this.getObject("buffers", index2);
  }
  getObject(array2, index2) {
    if (typeof index2 === "object") {
      return index2;
    }
    const object2 = this.json[array2] && this.json[array2][index2];
    if (!object2) {
      throw new Error(`glTF file error: Could not find ${array2}[${index2}]`);
    }
    return object2;
  }
  /**
   * Accepts buffer view index or buffer view object
   * @returns a `Uint8Array`
   */
  getTypedArrayForBufferView(bufferView) {
    bufferView = this.getBufferView(bufferView);
    const bufferIndex = bufferView.buffer;
    const binChunk = this.gltf.buffers[bufferIndex];
    assert$1(binChunk);
    const byteOffset = (bufferView.byteOffset || 0) + binChunk.byteOffset;
    return new Uint8Array(binChunk.arrayBuffer, byteOffset, bufferView.byteLength);
  }
  /** Accepts accessor index or accessor object
   * @returns a typed array with type that matches the types
   */
  getTypedArrayForAccessor(accessor) {
    const gltfAccessor = this.getAccessor(accessor);
    return getTypedArrayForAccessor(this.gltf.json, this.gltf.buffers, gltfAccessor);
  }
  /** accepts accessor index or accessor object
   * returns a `Uint8Array`
   */
  getTypedArrayForImageData(image) {
    image = this.getAccessor(image);
    const bufferView = this.getBufferView(image.bufferView);
    const buffer3 = this.getBuffer(bufferView.buffer);
    const arrayBuffer2 = buffer3.data;
    const byteOffset = bufferView.byteOffset || 0;
    return new Uint8Array(arrayBuffer2, byteOffset, bufferView.byteLength);
  }
  // MODIFERS
  /**
   * Add an extra application-defined key to the top-level data structure
   */
  addApplicationData(key, data2) {
    this.json[key] = data2;
    return this;
  }
  /**
   * `extras` - Standard GLTF field for storing application specific data
   */
  addExtraData(key, data2) {
    this.json.extras = this.json.extras || {};
    this.json.extras[key] = data2;
    return this;
  }
  addObjectExtension(object2, extensionName, data2) {
    object2.extensions = object2.extensions || {};
    object2.extensions[extensionName] = data2;
    this.registerUsedExtension(extensionName);
    return this;
  }
  setObjectExtension(object2, extensionName, data2) {
    const extensions = object2.extensions || {};
    extensions[extensionName] = data2;
  }
  removeObjectExtension(object2, extensionName) {
    const extensions = (object2 == null ? void 0 : object2.extensions) || {};
    if (extensions[extensionName]) {
      this.json.extensionsRemoved = this.json.extensionsRemoved || [];
      const extensionsRemoved = this.json.extensionsRemoved;
      if (!extensionsRemoved.includes(extensionName)) {
        extensionsRemoved.push(extensionName);
      }
    }
    delete extensions[extensionName];
  }
  /**
   * Add to standard GLTF top level extension object, mark as used
   */
  addExtension(extensionName, extensionData = {}) {
    assert$1(extensionData);
    this.json.extensions = this.json.extensions || {};
    this.json.extensions[extensionName] = extensionData;
    this.registerUsedExtension(extensionName);
    return extensionData;
  }
  /**
   * Standard GLTF top level extension object, mark as used and required
   */
  addRequiredExtension(extensionName, extensionData = {}) {
    assert$1(extensionData);
    this.addExtension(extensionName, extensionData);
    this.registerRequiredExtension(extensionName);
    return extensionData;
  }
  /**
   * Add extensionName to list of used extensions
   */
  registerUsedExtension(extensionName) {
    this.json.extensionsUsed = this.json.extensionsUsed || [];
    if (!this.json.extensionsUsed.find((ext) => ext === extensionName)) {
      this.json.extensionsUsed.push(extensionName);
    }
  }
  /**
   * Add extensionName to list of required extensions
   */
  registerRequiredExtension(extensionName) {
    this.registerUsedExtension(extensionName);
    this.json.extensionsRequired = this.json.extensionsRequired || [];
    if (!this.json.extensionsRequired.find((ext) => ext === extensionName)) {
      this.json.extensionsRequired.push(extensionName);
    }
  }
  /**
   * Removes an extension from the top-level list
   */
  removeExtension(extensionName) {
    var _a3;
    if ((_a3 = this.json.extensions) == null ? void 0 : _a3[extensionName]) {
      this.json.extensionsRemoved = this.json.extensionsRemoved || [];
      const extensionsRemoved = this.json.extensionsRemoved;
      if (!extensionsRemoved.includes(extensionName)) {
        extensionsRemoved.push(extensionName);
      }
    }
    if (this.json.extensions) {
      delete this.json.extensions[extensionName];
    }
    if (this.json.extensionsRequired) {
      this._removeStringFromArray(this.json.extensionsRequired, extensionName);
    }
    if (this.json.extensionsUsed) {
      this._removeStringFromArray(this.json.extensionsUsed, extensionName);
    }
  }
  /**
   *  Set default scene which is to be displayed at load time
   */
  setDefaultScene(sceneIndex) {
    this.json.scene = sceneIndex;
  }
  /**
   * @todo: add more properties for scene initialization:
   *   name`, `extensions`, `extras`
   *   https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#reference-scene
   */
  addScene(scene) {
    const { nodeIndices } = scene;
    this.json.scenes = this.json.scenes || [];
    this.json.scenes.push({ nodes: nodeIndices });
    return this.json.scenes.length - 1;
  }
  /**
   * @todo: add more properties for node initialization:
   *   `name`, `extensions`, `extras`, `camera`, `children`, `skin`, `rotation`, `scale`, `translation`, `weights`
   *   https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#node
   */
  addNode(node) {
    const { meshIndex, matrix } = node;
    this.json.nodes = this.json.nodes || [];
    const nodeData = { mesh: meshIndex };
    if (matrix) {
      nodeData.matrix = matrix;
    }
    this.json.nodes.push(nodeData);
    return this.json.nodes.length - 1;
  }
  /** Adds a mesh to the json part */
  addMesh(mesh) {
    const { attributes, indices, material, mode: mode2 = 4 } = mesh;
    const accessors = this._addAttributes(attributes);
    const glTFMesh = {
      primitives: [
        {
          attributes: accessors,
          mode: mode2
        }
      ]
    };
    if (indices) {
      const indicesAccessor = this._addIndices(indices);
      glTFMesh.primitives[0].indices = indicesAccessor;
    }
    if (Number.isFinite(material)) {
      glTFMesh.primitives[0].material = material;
    }
    this.json.meshes = this.json.meshes || [];
    this.json.meshes.push(glTFMesh);
    return this.json.meshes.length - 1;
  }
  addPointCloud(attributes) {
    const accessorIndices = this._addAttributes(attributes);
    const glTFMesh = {
      primitives: [
        {
          attributes: accessorIndices,
          mode: 0
          // GL.POINTS
        }
      ]
    };
    this.json.meshes = this.json.meshes || [];
    this.json.meshes.push(glTFMesh);
    return this.json.meshes.length - 1;
  }
  /**
   * Adds a binary image. Builds glTF "JSON metadata" and saves buffer reference
   * Buffer will be copied into BIN chunk during "pack"
   * Currently encodes as glTF image
   * @param imageData
   * @param mimeType
   */
  addImage(imageData, mimeTypeOpt) {
    const metadata = getBinaryImageMetadata(imageData);
    const mimeType = mimeTypeOpt || (metadata == null ? void 0 : metadata.mimeType);
    const bufferViewIndex = this.addBufferView(imageData);
    const glTFImage = {
      bufferView: bufferViewIndex,
      mimeType
    };
    this.json.images = this.json.images || [];
    this.json.images.push(glTFImage);
    return this.json.images.length - 1;
  }
  /**
   * Add one untyped source buffer, create a matching glTF `bufferView`, and return its index
   * @param buffer
   */
  addBufferView(buffer3, bufferIndex = 0, byteOffset = this.byteLength) {
    const byteLength = buffer3.byteLength;
    assert$1(Number.isFinite(byteLength));
    this.sourceBuffers = this.sourceBuffers || [];
    this.sourceBuffers.push(buffer3);
    const glTFBufferView = {
      buffer: bufferIndex,
      // Write offset from the start of the binary body
      byteOffset,
      byteLength
    };
    this.byteLength += padToNBytes(byteLength, 4);
    this.json.bufferViews = this.json.bufferViews || [];
    this.json.bufferViews.push(glTFBufferView);
    return this.json.bufferViews.length - 1;
  }
  /**
   * Adds an accessor to a bufferView
   * @param bufferViewIndex
   * @param accessor
   */
  addAccessor(bufferViewIndex, accessor) {
    const glTFAccessor = {
      bufferView: bufferViewIndex,
      // @ts-ignore
      type: getAccessorTypeFromSize(accessor.size),
      // @ts-ignore
      componentType: accessor.componentType,
      // @ts-ignore
      count: accessor.count,
      // @ts-ignore
      max: accessor.max,
      // @ts-ignore
      min: accessor.min
    };
    this.json.accessors = this.json.accessors || [];
    this.json.accessors.push(glTFAccessor);
    return this.json.accessors.length - 1;
  }
  /**
   * Add a binary buffer. Builds glTF "JSON metadata" and saves buffer reference
   * Buffer will be copied into BIN chunk during "pack"
   * Currently encodes buffers as glTF accessors, but this could be optimized
   * @param sourceBuffer
   * @param accessor
   */
  addBinaryBuffer(sourceBuffer, accessor = { size: 3 }) {
    const bufferViewIndex = this.addBufferView(sourceBuffer);
    let minMax = { min: accessor.min, max: accessor.max };
    if (!minMax.min || !minMax.max) {
      minMax = this._getAccessorMinMax(sourceBuffer, accessor.size);
    }
    const accessorDefaults = {
      // @ts-ignore
      size: accessor.size,
      componentType: getComponentTypeFromArray(sourceBuffer),
      // @ts-ignore
      count: Math.round(sourceBuffer.length / accessor.size),
      min: minMax.min,
      max: minMax.max
    };
    return this.addAccessor(bufferViewIndex, Object.assign(accessorDefaults, accessor));
  }
  /**
   * Adds a texture to the json part
   * @todo: add more properties for texture initialization
   * `sampler`, `name`, `extensions`, `extras`
   * https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#texture
   */
  addTexture(texture) {
    const { imageIndex } = texture;
    const glTFTexture = {
      source: imageIndex
    };
    this.json.textures = this.json.textures || [];
    this.json.textures.push(glTFTexture);
    return this.json.textures.length - 1;
  }
  /** Adds a material to the json part */
  addMaterial(pbrMaterialInfo) {
    this.json.materials = this.json.materials || [];
    this.json.materials.push(pbrMaterialInfo);
    return this.json.materials.length - 1;
  }
  /** Pack the binary chunk */
  createBinaryChunk() {
    var _a3, _b3;
    this.gltf.buffers = [];
    const totalByteLength = this.byteLength;
    const arrayBuffer2 = new ArrayBuffer(totalByteLength);
    const targetArray = new Uint8Array(arrayBuffer2);
    let dstByteOffset = 0;
    for (const sourceBuffer of this.sourceBuffers || []) {
      dstByteOffset = copyToArray(sourceBuffer, targetArray, dstByteOffset);
    }
    if ((_b3 = (_a3 = this.json) == null ? void 0 : _a3.buffers) == null ? void 0 : _b3[0]) {
      this.json.buffers[0].byteLength = totalByteLength;
    } else {
      this.json.buffers = [{ byteLength: totalByteLength }];
    }
    this.gltf.binary = arrayBuffer2;
    this.sourceBuffers = [arrayBuffer2];
  }
  // PRIVATE
  _removeStringFromArray(array2, string3) {
    let found = true;
    while (found) {
      const index2 = array2.indexOf(string3);
      if (index2 > -1) {
        array2.splice(index2, 1);
      } else {
        found = false;
      }
    }
  }
  /**
   * Add attributes to buffers and create `attributes` object which is part of `mesh`
   */
  _addAttributes(attributes = {}) {
    const result = {};
    for (const attributeKey in attributes) {
      const attributeData = attributes[attributeKey];
      const attrName = this._getGltfAttributeName(attributeKey);
      const accessor = this.addBinaryBuffer(attributeData.value, attributeData);
      result[attrName] = accessor;
    }
    return result;
  }
  /**
   * Add indices to buffers
   */
  _addIndices(indices) {
    return this.addBinaryBuffer(indices, { size: 1 });
  }
  /**
   * Deduce gltf specific attribue name from input attribute name
   */
  _getGltfAttributeName(attributeName) {
    switch (attributeName.toLowerCase()) {
      case "position":
      case "positions":
      case "vertices":
        return "POSITION";
      case "normal":
      case "normals":
        return "NORMAL";
      case "color":
      case "colors":
        return "COLOR_0";
      case "texcoord":
      case "texcoords":
        return "TEXCOORD_0";
      default:
        return attributeName;
    }
  }
  /**
   * Calculate `min` and `max` arrays of accessor according to spec:
   * https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#reference-accessor
   */
  _getAccessorMinMax(buffer3, size12) {
    const result = { min: null, max: null };
    if (buffer3.length < size12) {
      return result;
    }
    result.min = [];
    result.max = [];
    const initValues = buffer3.subarray(0, size12);
    for (const value of initValues) {
      result.min.push(value);
      result.max.push(value);
    }
    for (let index2 = size12; index2 < buffer3.length; index2 += size12) {
      for (let componentIndex = 0; componentIndex < size12; componentIndex++) {
        result.min[0 + componentIndex] = Math.min(
          // @ts-ignore
          result.min[0 + componentIndex],
          buffer3[index2 + componentIndex]
        );
        result.max[0 + componentIndex] = Math.max(
          // @ts-ignore
          result.max[0 + componentIndex],
          buffer3[index2 + componentIndex]
        );
      }
    }
    return result;
  }
}
function emod(n2) {
  return (n2 % 1 + 1) % 1;
}
const ATTRIBUTE_TYPE_TO_COMPONENTS = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16,
  BOOLEAN: 1,
  STRING: 1,
  ENUM: 1
};
const ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY = {
  INT8: Int8Array,
  UINT8: Uint8Array,
  INT16: Int16Array,
  UINT16: Uint16Array,
  INT32: Int32Array,
  UINT32: Uint32Array,
  INT64: BigInt64Array,
  UINT64: BigUint64Array,
  FLOAT32: Float32Array,
  FLOAT64: Float64Array
};
const ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE = {
  INT8: 1,
  UINT8: 1,
  INT16: 2,
  UINT16: 2,
  INT32: 4,
  UINT32: 4,
  INT64: 8,
  UINT64: 8,
  FLOAT32: 4,
  FLOAT64: 8
};
function getArrayElementByteSize(attributeType, componentType) {
  return ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE[componentType] * ATTRIBUTE_TYPE_TO_COMPONENTS[attributeType];
}
function getOffsetsForProperty(scenegraph, bufferViewIndex, offsetType, numberOfElements) {
  if (offsetType !== "UINT8" && offsetType !== "UINT16" && offsetType !== "UINT32" && offsetType !== "UINT64") {
    return null;
  }
  const arrayOffsetsBytes = scenegraph.getTypedArrayForBufferView(bufferViewIndex);
  const arrayOffsets = convertRawBufferToMetadataArray(
    arrayOffsetsBytes,
    "SCALAR",
    // offsets consist of ONE component
    offsetType,
    numberOfElements + 1
    // The number of offsets is equal to the property table `count` plus one.
  );
  if (arrayOffsets instanceof BigInt64Array || arrayOffsets instanceof BigUint64Array) {
    return null;
  }
  return arrayOffsets;
}
function convertRawBufferToMetadataArray(data2, attributeType, componentType, elementCount = 1) {
  const numberOfComponents = ATTRIBUTE_TYPE_TO_COMPONENTS[attributeType];
  const ArrayType2 = ATTRIBUTE_COMPONENT_TYPE_TO_ARRAY[componentType];
  const size12 = ATTRIBUTE_COMPONENT_TYPE_TO_BYTE_SIZE[componentType];
  const length2 = elementCount * numberOfComponents;
  const byteLength = length2 * size12;
  let buffer3 = data2.buffer;
  let offset = data2.byteOffset;
  if (offset % size12 !== 0) {
    const bufferArray = new Uint8Array(buffer3);
    buffer3 = bufferArray.slice(offset, offset + byteLength).buffer;
    offset = 0;
  }
  return new ArrayType2(buffer3, offset, length2);
}
function getPrimitiveTextureData(scenegraph, textureInfo, primitive) {
  var _a3, _b3, _c2, _d2, _e2;
  const texCoordAccessorKey = `TEXCOORD_${textureInfo.texCoord || 0}`;
  const texCoordAccessorIndex = primitive.attributes[texCoordAccessorKey];
  const textureCoordinates = scenegraph.getTypedArrayForAccessor(texCoordAccessorIndex);
  const json = scenegraph.gltf.json;
  const textureIndex = textureInfo.index;
  const imageIndex = (_b3 = (_a3 = json.textures) == null ? void 0 : _a3[textureIndex]) == null ? void 0 : _b3.source;
  if (typeof imageIndex !== "undefined") {
    const mimeType = (_d2 = (_c2 = json.images) == null ? void 0 : _c2[imageIndex]) == null ? void 0 : _d2.mimeType;
    const parsedImage = (_e2 = scenegraph.gltf.images) == null ? void 0 : _e2[imageIndex];
    if (parsedImage && typeof parsedImage.width !== "undefined") {
      const textureData = [];
      for (let index2 = 0; index2 < textureCoordinates.length; index2 += 2) {
        const value = getImageValueByCoordinates(parsedImage, mimeType, textureCoordinates, index2, textureInfo.channels);
        textureData.push(value);
      }
      return textureData;
    }
  }
  return [];
}
function primitivePropertyDataToAttributes(scenegraph, attributeName, propertyData, featureTable, primitive) {
  if (!(propertyData == null ? void 0 : propertyData.length)) {
    return;
  }
  const featureIndices = [];
  for (const texelData of propertyData) {
    let index2 = featureTable.findIndex((item) => item === texelData);
    if (index2 === -1) {
      index2 = featureTable.push(texelData) - 1;
    }
    featureIndices.push(index2);
  }
  const typedArray = new Uint32Array(featureIndices);
  const bufferIndex = scenegraph.gltf.buffers.push({
    arrayBuffer: typedArray.buffer,
    byteOffset: typedArray.byteOffset,
    byteLength: typedArray.byteLength
  }) - 1;
  const bufferViewIndex = scenegraph.addBufferView(typedArray, bufferIndex, 0);
  const accessorIndex = scenegraph.addAccessor(bufferViewIndex, {
    size: 1,
    componentType: getComponentTypeFromArray(typedArray),
    count: typedArray.length
  });
  primitive.attributes[attributeName] = accessorIndex;
}
function getImageValueByCoordinates(parsedImage, mimeType, textureCoordinates, index2, channels = [0]) {
  const CHANNELS_MAP = {
    r: { offset: 0, shift: 0 },
    g: { offset: 1, shift: 8 },
    b: { offset: 2, shift: 16 },
    a: { offset: 3, shift: 24 }
  };
  const u2 = textureCoordinates[index2];
  const v5 = textureCoordinates[index2 + 1];
  let components = 1;
  if (mimeType && (mimeType.indexOf("image/jpeg") !== -1 || mimeType.indexOf("image/png") !== -1))
    components = 4;
  const offset = coordinatesToOffset(u2, v5, parsedImage, components);
  let value = 0;
  for (const c2 of channels) {
    const map5 = typeof c2 === "number" ? Object.values(CHANNELS_MAP)[c2] : CHANNELS_MAP[c2];
    const imageOffset = offset + map5.offset;
    const imageData = getImageData(parsedImage);
    if (imageData.data.length <= imageOffset) {
      throw new Error(`${imageData.data.length} <= ${imageOffset}`);
    }
    const imageValue = imageData.data[imageOffset];
    value |= imageValue << map5.shift;
  }
  return value;
}
function coordinatesToOffset(u2, v5, parsedImage, componentsCount = 1) {
  const w2 = parsedImage.width;
  const iX = emod(u2) * (w2 - 1);
  const indX = Math.round(iX);
  const h2 = parsedImage.height;
  const iY = emod(v5) * (h2 - 1);
  const indY = Math.round(iY);
  const components = parsedImage.components ? parsedImage.components : componentsCount;
  const offset = (indY * w2 + indX) * components;
  return offset;
}
function parseVariableLengthArrayNumeric(valuesData, numberOfElements, arrayOffsets, valuesDataBytesLength, valueSize) {
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const arrayOffset = arrayOffsets[index2];
    const arrayByteSize = arrayOffsets[index2 + 1] - arrayOffsets[index2];
    if (arrayByteSize + arrayOffset > valuesDataBytesLength) {
      break;
    }
    const typedArrayOffset = arrayOffset / valueSize;
    const elementCount = arrayByteSize / valueSize;
    attributeValueArray.push(valuesData.slice(typedArrayOffset, typedArrayOffset + elementCount));
  }
  return attributeValueArray;
}
function parseFixedLengthArrayNumeric(valuesData, numberOfElements, arrayCount) {
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const elementOffset = index2 * arrayCount;
    attributeValueArray.push(valuesData.slice(elementOffset, elementOffset + arrayCount));
  }
  return attributeValueArray;
}
function getPropertyDataString(numberOfElements, valuesDataBytes, arrayOffsets, stringOffsets) {
  if (arrayOffsets) {
    throw new Error("Not implemented - arrayOffsets for strings is specified");
  }
  if (stringOffsets) {
    const stringsArray = [];
    const textDecoder = new TextDecoder("utf8");
    let stringOffset = 0;
    for (let index2 = 0; index2 < numberOfElements; index2++) {
      const stringByteSize = stringOffsets[index2 + 1] - stringOffsets[index2];
      if (stringByteSize + stringOffset <= valuesDataBytes.length) {
        const stringData = valuesDataBytes.subarray(stringOffset, stringByteSize + stringOffset);
        const stringAttribute = textDecoder.decode(stringData);
        stringsArray.push(stringAttribute);
        stringOffset += stringByteSize;
      }
    }
    return stringsArray;
  }
  return [];
}
const EXT_MESH_FEATURES_NAME = "EXT_mesh_features";
const name$b = EXT_MESH_FEATURES_NAME;
async function decode$9(gltfData, options2) {
  const scenegraph = new GLTFScenegraph(gltfData);
  decodeExtMeshFeatures(scenegraph, options2);
}
function decodeExtMeshFeatures(scenegraph, options2) {
  const json = scenegraph.gltf.json;
  if (!json.meshes) {
    return;
  }
  for (const mesh of json.meshes) {
    for (const primitive of mesh.primitives) {
      processMeshPrimitiveFeatures(scenegraph, primitive, options2);
    }
  }
}
function processMeshPrimitiveFeatures(scenegraph, primitive, options2) {
  var _a3, _b3, _c2;
  if (!((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const extension = (_b3 = primitive.extensions) == null ? void 0 : _b3[EXT_MESH_FEATURES_NAME];
  const featureIds = extension == null ? void 0 : extension.featureIds;
  if (!featureIds) {
    return;
  }
  for (const featureId of featureIds) {
    let featureIdData;
    if (typeof featureId.attribute !== "undefined") {
      const accessorKey = `_FEATURE_ID_${featureId.attribute}`;
      const accessorIndex = primitive.attributes[accessorKey];
      featureIdData = scenegraph.getTypedArrayForAccessor(accessorIndex);
    } else if (typeof featureId.texture !== "undefined" && ((_c2 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _c2.loadImages)) {
      featureIdData = getPrimitiveTextureData(scenegraph, featureId.texture, primitive);
    } else {
      featureIdData = [];
    }
    featureId.data = featureIdData;
  }
}
const EXT_mesh_features = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$9,
  name: name$b
}, Symbol.toStringTag, { value: "Module" }));
const EXT_STRUCTURAL_METADATA_NAME = "EXT_structural_metadata";
const name$a = EXT_STRUCTURAL_METADATA_NAME;
async function decode$8(gltfData, options2) {
  const scenegraph = new GLTFScenegraph(gltfData);
  decodeExtStructuralMetadata(scenegraph, options2);
}
function decodeExtStructuralMetadata(scenegraph, options2) {
  var _a3, _b3;
  if (!((_a3 = options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const extension = scenegraph.getExtension(EXT_STRUCTURAL_METADATA_NAME);
  if (!extension) {
    return;
  }
  if ((_b3 = options2.gltf) == null ? void 0 : _b3.loadImages) {
    decodePropertyTextures$1(scenegraph, extension);
  }
  decodePropertyTables$1(scenegraph, extension);
}
function decodePropertyTextures$1(scenegraph, extension) {
  const propertyTextures = extension.propertyTextures;
  const json = scenegraph.gltf.json;
  if (propertyTextures && json.meshes) {
    for (const mesh of json.meshes) {
      for (const primitive of mesh.primitives) {
        processPrimitivePropertyTextures(scenegraph, propertyTextures, primitive, extension);
      }
    }
  }
}
function decodePropertyTables$1(scenegraph, extension) {
  const schema = extension.schema;
  if (!schema) {
    return;
  }
  const schemaClasses = schema.classes;
  const propertyTables = extension.propertyTables;
  if (schemaClasses && propertyTables) {
    for (const schemaName in schemaClasses) {
      const propertyTable = findPropertyTableByClass$1(propertyTables, schemaName);
      if (propertyTable) {
        processPropertyTable$1(scenegraph, schema, propertyTable);
      }
    }
  }
}
function findPropertyTableByClass$1(propertyTables, schemaClassName) {
  for (const propertyTable of propertyTables) {
    if (propertyTable.class === schemaClassName) {
      return propertyTable;
    }
  }
  return null;
}
function processPrimitivePropertyTextures(scenegraph, propertyTextures, primitive, extension) {
  var _a3;
  if (!propertyTextures) {
    return;
  }
  const primitiveExtension = (_a3 = primitive.extensions) == null ? void 0 : _a3[EXT_STRUCTURAL_METADATA_NAME];
  const primitivePropertyTextureIndices = primitiveExtension == null ? void 0 : primitiveExtension.propertyTextures;
  if (!primitivePropertyTextureIndices) {
    return;
  }
  for (const primitivePropertyTextureIndex of primitivePropertyTextureIndices) {
    const propertyTexture = propertyTextures[primitivePropertyTextureIndex];
    processPrimitivePropertyTexture(scenegraph, propertyTexture, primitive, extension);
  }
}
function processPrimitivePropertyTexture(scenegraph, propertyTexture, primitive, extension) {
  var _a3;
  if (!propertyTexture.properties) {
    return;
  }
  if (!extension.dataAttributeNames) {
    extension.dataAttributeNames = [];
  }
  const className = propertyTexture.class;
  for (const propertyName in propertyTexture.properties) {
    const attributeName = `${className}_${propertyName}`;
    const textureInfoTopLevel = (_a3 = propertyTexture.properties) == null ? void 0 : _a3[propertyName];
    if (!textureInfoTopLevel) {
      continue;
    }
    if (!textureInfoTopLevel.data) {
      textureInfoTopLevel.data = [];
    }
    const featureTextureTable = textureInfoTopLevel.data;
    const propertyData = getPrimitiveTextureData(scenegraph, textureInfoTopLevel, primitive);
    if (propertyData === null) {
      continue;
    }
    primitivePropertyDataToAttributes(scenegraph, attributeName, propertyData, featureTextureTable, primitive);
    textureInfoTopLevel.data = featureTextureTable;
    extension.dataAttributeNames.push(attributeName);
  }
}
function processPropertyTable$1(scenegraph, schema, propertyTable) {
  var _a3, _b3;
  const schemaClass = (_a3 = schema.classes) == null ? void 0 : _a3[propertyTable.class];
  if (!schemaClass) {
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: no schema class with name ${propertyTable.class}`);
  }
  const numberOfElements = propertyTable.count;
  for (const propertyName in schemaClass.properties) {
    const classProperty = schemaClass.properties[propertyName];
    const propertyTableProperty = (_b3 = propertyTable.properties) == null ? void 0 : _b3[propertyName];
    if (propertyTableProperty) {
      const data2 = getPropertyDataFromBinarySource$1(scenegraph, schema, classProperty, numberOfElements, propertyTableProperty);
      propertyTableProperty.data = data2;
    }
  }
}
function getPropertyDataFromBinarySource$1(scenegraph, schema, classProperty, numberOfElements, propertyTableProperty) {
  let data2 = [];
  const valuesBufferView = propertyTableProperty.values;
  const valuesDataBytes = scenegraph.getTypedArrayForBufferView(valuesBufferView);
  const arrayOffsets = getArrayOffsetsForProperty$1(scenegraph, classProperty, propertyTableProperty, numberOfElements);
  const stringOffsets = getStringOffsetsForProperty$1(scenegraph, propertyTableProperty, numberOfElements);
  switch (classProperty.type) {
    case "SCALAR":
    case "VEC2":
    case "VEC3":
    case "VEC4":
    case "MAT2":
    case "MAT3":
    case "MAT4": {
      data2 = getPropertyDataNumeric$1(classProperty, numberOfElements, valuesDataBytes, arrayOffsets);
      break;
    }
    case "BOOLEAN": {
      throw new Error(`Not implemented - classProperty.type=${classProperty.type}`);
    }
    case "STRING": {
      data2 = getPropertyDataString(numberOfElements, valuesDataBytes, arrayOffsets, stringOffsets);
      break;
    }
    case "ENUM": {
      data2 = getPropertyDataENUM(schema, classProperty, numberOfElements, valuesDataBytes, arrayOffsets);
      break;
    }
    default:
      throw new Error(`Unknown classProperty type ${classProperty.type}`);
  }
  return data2;
}
function getArrayOffsetsForProperty$1(scenegraph, classProperty, propertyTableProperty, numberOfElements) {
  if (classProperty.array && // `count` is a number of array elements. May only be defined when `array` is true.
  // If `count` is NOT defined, it's a VARIABLE-length array
  typeof classProperty.count === "undefined" && // `arrayOffsets` is an index of the buffer view containing offsets for variable-length arrays.
  typeof propertyTableProperty.arrayOffsets !== "undefined") {
    return getOffsetsForProperty(scenegraph, propertyTableProperty.arrayOffsets, propertyTableProperty.arrayOffsetType || "UINT32", numberOfElements);
  }
  return null;
}
function getStringOffsetsForProperty$1(scenegraph, propertyTableProperty, numberOfElements) {
  if (typeof propertyTableProperty.stringOffsets !== "undefined") {
    return getOffsetsForProperty(scenegraph, propertyTableProperty.stringOffsets, propertyTableProperty.stringOffsetType || "UINT32", numberOfElements);
  }
  return null;
}
function getPropertyDataNumeric$1(classProperty, numberOfElements, valuesDataBytes, arrayOffsets) {
  const isArray3 = classProperty.array;
  const arrayCount = classProperty.count;
  const elementSize = getArrayElementByteSize(classProperty.type, classProperty.componentType);
  const elementCount = valuesDataBytes.byteLength / elementSize;
  let valuesData;
  if (classProperty.componentType) {
    valuesData = convertRawBufferToMetadataArray(
      valuesDataBytes,
      classProperty.type,
      // The datatype of the element's components. Only applicable to `SCALAR`, `VECN`, and `MATN` types.
      classProperty.componentType,
      elementCount
    );
  } else {
    valuesData = valuesDataBytes;
  }
  if (isArray3) {
    if (arrayOffsets) {
      return parseVariableLengthArrayNumeric(valuesData, numberOfElements, arrayOffsets, valuesDataBytes.length, elementSize);
    }
    if (arrayCount) {
      return parseFixedLengthArrayNumeric(valuesData, numberOfElements, arrayCount);
    }
    return [];
  }
  return valuesData;
}
function getPropertyDataENUM(schema, classProperty, numberOfElements, valuesDataBytes, arrayOffsets) {
  var _a3;
  const enumType = classProperty.enumType;
  if (!enumType) {
    throw new Error("Incorrect data in the EXT_structural_metadata extension: classProperty.enumType is not set for type ENUM");
  }
  const enumEntry = (_a3 = schema.enums) == null ? void 0 : _a3[enumType];
  if (!enumEntry) {
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: schema.enums does't contain ${enumType}`);
  }
  const enumValueType = enumEntry.valueType || "UINT16";
  const elementSize = getArrayElementByteSize(classProperty.type, enumValueType);
  const elementCount = valuesDataBytes.byteLength / elementSize;
  let valuesData = convertRawBufferToMetadataArray(valuesDataBytes, classProperty.type, enumValueType, elementCount);
  if (!valuesData) {
    valuesData = valuesDataBytes;
  }
  if (classProperty.array) {
    if (arrayOffsets) {
      return parseVariableLengthArrayENUM({
        valuesData,
        numberOfElements,
        arrayOffsets,
        valuesDataBytesLength: valuesDataBytes.length,
        elementSize,
        enumEntry
      });
    }
    const arrayCount = classProperty.count;
    if (arrayCount) {
      return parseFixedLengthArrayENUM(valuesData, numberOfElements, arrayCount, enumEntry);
    }
    return [];
  }
  return getEnumsArray(valuesData, 0, numberOfElements, enumEntry);
}
function parseVariableLengthArrayENUM(params2) {
  const { valuesData, numberOfElements, arrayOffsets, valuesDataBytesLength, elementSize, enumEntry } = params2;
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const arrayOffset = arrayOffsets[index2];
    const arrayByteSize = arrayOffsets[index2 + 1] - arrayOffsets[index2];
    if (arrayByteSize + arrayOffset > valuesDataBytesLength) {
      break;
    }
    const typedArrayOffset = arrayOffset / elementSize;
    const elementCount = arrayByteSize / elementSize;
    const array2 = getEnumsArray(valuesData, typedArrayOffset, elementCount, enumEntry);
    attributeValueArray.push(array2);
  }
  return attributeValueArray;
}
function parseFixedLengthArrayENUM(valuesData, numberOfElements, arrayCount, enumEntry) {
  const attributeValueArray = [];
  for (let index2 = 0; index2 < numberOfElements; index2++) {
    const elementOffset = arrayCount * index2;
    const array2 = getEnumsArray(valuesData, elementOffset, arrayCount, enumEntry);
    attributeValueArray.push(array2);
  }
  return attributeValueArray;
}
function getEnumsArray(valuesData, offset, count3, enumEntry) {
  const array2 = [];
  for (let i2 = 0; i2 < count3; i2++) {
    if (valuesData instanceof BigInt64Array || valuesData instanceof BigUint64Array) {
      array2.push("");
    } else {
      const value = valuesData[offset + i2];
      const enumObject = getEnumByValue(enumEntry, value);
      if (enumObject) {
        array2.push(enumObject.name);
      } else {
        array2.push("");
      }
    }
  }
  return array2;
}
function getEnumByValue(enumEntry, value) {
  for (const enumValue of enumEntry.values) {
    if (enumValue.value === value) {
      return enumValue;
    }
  }
  return null;
}
const EXT_structural_metadata = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$8,
  name: name$a
}, Symbol.toStringTag, { value: "Module" }));
const EXT_FEATURE_METADATA_NAME = "EXT_feature_metadata";
const name$9 = EXT_FEATURE_METADATA_NAME;
async function decode$7(gltfData, options2) {
  const scenegraph = new GLTFScenegraph(gltfData);
  decodeExtFeatureMetadata(scenegraph, options2);
}
function decodeExtFeatureMetadata(scenegraph, options2) {
  var _a3, _b3;
  if (!((_a3 = options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const extension = scenegraph.getExtension(EXT_FEATURE_METADATA_NAME);
  if (!extension) {
    return;
  }
  if ((_b3 = options2.gltf) == null ? void 0 : _b3.loadImages) {
    decodePropertyTextures(scenegraph, extension);
  }
  decodePropertyTables(scenegraph, extension);
}
function decodePropertyTextures(scenegraph, extension) {
  const schema = extension.schema;
  if (!schema) {
    return;
  }
  const schemaClasses = schema.classes;
  const { featureTextures } = extension;
  if (schemaClasses && featureTextures) {
    for (const schemaName in schemaClasses) {
      const schemaClass = schemaClasses[schemaName];
      const featureTexture = findFeatureTextureByClass(featureTextures, schemaName);
      if (featureTexture) {
        handleFeatureTextureProperties(scenegraph, featureTexture, schemaClass);
      }
    }
  }
}
function decodePropertyTables(scenegraph, extension) {
  const schema = extension.schema;
  if (!schema) {
    return;
  }
  const schemaClasses = schema.classes;
  const propertyTables = extension.featureTables;
  if (schemaClasses && propertyTables) {
    for (const schemaName in schemaClasses) {
      const propertyTable = findPropertyTableByClass(propertyTables, schemaName);
      if (propertyTable) {
        processPropertyTable(scenegraph, schema, propertyTable);
      }
    }
  }
}
function findPropertyTableByClass(propertyTables, schemaClassName) {
  for (const propertyTableName in propertyTables) {
    const propertyTable = propertyTables[propertyTableName];
    if (propertyTable.class === schemaClassName) {
      return propertyTable;
    }
  }
  return null;
}
function findFeatureTextureByClass(featureTextures, schemaClassName) {
  for (const featureTexturesName in featureTextures) {
    const featureTable = featureTextures[featureTexturesName];
    if (featureTable.class === schemaClassName) {
      return featureTable;
    }
  }
  return null;
}
function processPropertyTable(scenegraph, schema, propertyTable) {
  var _a3, _b3;
  if (!propertyTable.class) {
    return;
  }
  const schemaClass = (_a3 = schema.classes) == null ? void 0 : _a3[propertyTable.class];
  if (!schemaClass) {
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: no schema class with name ${propertyTable.class}`);
  }
  const numberOfElements = propertyTable.count;
  for (const propertyName in schemaClass.properties) {
    const classProperty = schemaClass.properties[propertyName];
    const propertyTableProperty = (_b3 = propertyTable.properties) == null ? void 0 : _b3[propertyName];
    if (propertyTableProperty) {
      const data2 = getPropertyDataFromBinarySource(scenegraph, schema, classProperty, numberOfElements, propertyTableProperty);
      propertyTableProperty.data = data2;
    }
  }
}
function handleFeatureTextureProperties(scenegraph, featureTexture, schemaClass) {
  var _a3;
  const attributeName = featureTexture.class;
  for (const propertyName in schemaClass.properties) {
    const featureTextureProperty = (_a3 = featureTexture == null ? void 0 : featureTexture.properties) == null ? void 0 : _a3[propertyName];
    if (featureTextureProperty) {
      const data2 = getPropertyDataFromTexture(scenegraph, featureTextureProperty, attributeName);
      featureTextureProperty.data = data2;
    }
  }
}
function getPropertyDataFromBinarySource(scenegraph, schema, classProperty, numberOfFeatures, featureTableProperty) {
  let data2 = [];
  const bufferView = featureTableProperty.bufferView;
  const dataArray = scenegraph.getTypedArrayForBufferView(bufferView);
  const arrayOffsets = getArrayOffsetsForProperty(scenegraph, classProperty, featureTableProperty, numberOfFeatures);
  const stringOffsets = getStringOffsetsForProperty(scenegraph, classProperty, featureTableProperty, numberOfFeatures);
  if (classProperty.type === "STRING" || classProperty.componentType === "STRING") {
    data2 = getPropertyDataString(numberOfFeatures, dataArray, arrayOffsets, stringOffsets);
  } else if (isNumericProperty(classProperty)) {
    data2 = getPropertyDataNumeric(classProperty, numberOfFeatures, dataArray, arrayOffsets);
  }
  return data2;
}
function getArrayOffsetsForProperty(scenegraph, classProperty, propertyTableProperty, numberOfElements) {
  if (classProperty.type === "ARRAY" && // `componentCount` is a number of fixed-length array elements.
  // If `componentCount` is NOT defined, it's a VARIABLE-length array
  typeof classProperty.componentCount === "undefined" && // `arrayOffsetBufferView` is an index of the buffer view containing offsets for variable-length arrays.
  typeof propertyTableProperty.arrayOffsetBufferView !== "undefined") {
    return getOffsetsForProperty(
      scenegraph,
      propertyTableProperty.arrayOffsetBufferView,
      propertyTableProperty.offsetType || "UINT32",
      // offsetType is used both for stringOffsetBufferView and arrayOffsetBufferView
      numberOfElements
    );
  }
  return null;
}
function getStringOffsetsForProperty(scenegraph, classProperty, propertyTableProperty, numberOfElements) {
  if (typeof propertyTableProperty.stringOffsetBufferView !== "undefined") {
    return getOffsetsForProperty(
      scenegraph,
      propertyTableProperty.stringOffsetBufferView,
      propertyTableProperty.offsetType || "UINT32",
      // offsetType is used both for stringOffsetBufferView and arrayOffsetBufferView
      numberOfElements
    );
  }
  return null;
}
function isNumericProperty(schemaProperty) {
  const types2 = [
    "UINT8",
    "INT16",
    "UINT16",
    "INT32",
    "UINT32",
    "INT64",
    "UINT64",
    "FLOAT32",
    "FLOAT64"
  ];
  return types2.includes(schemaProperty.type) || typeof schemaProperty.componentType !== "undefined" && types2.includes(schemaProperty.componentType);
}
function getPropertyDataNumeric(classProperty, numberOfElements, valuesDataBytes, arrayOffsets) {
  const isArray3 = classProperty.type === "ARRAY";
  const arrayCount = classProperty.componentCount;
  const attributeType = "SCALAR";
  const componentType = classProperty.componentType || classProperty.type;
  const elementSize = getArrayElementByteSize(attributeType, componentType);
  const elementCount = valuesDataBytes.byteLength / elementSize;
  const valuesData = convertRawBufferToMetadataArray(valuesDataBytes, attributeType, componentType, elementCount);
  if (isArray3) {
    if (arrayOffsets) {
      return parseVariableLengthArrayNumeric(valuesData, numberOfElements, arrayOffsets, valuesDataBytes.length, elementSize);
    }
    if (arrayCount) {
      return parseFixedLengthArrayNumeric(valuesData, numberOfElements, arrayCount);
    }
    return [];
  }
  return valuesData;
}
function getPropertyDataFromTexture(scenegraph, featureTextureProperty, attributeName) {
  const json = scenegraph.gltf.json;
  if (!json.meshes) {
    return [];
  }
  const featureTextureTable = [];
  for (const mesh of json.meshes) {
    for (const primitive of mesh.primitives) {
      processPrimitiveTextures(scenegraph, attributeName, featureTextureProperty, featureTextureTable, primitive);
    }
  }
  return featureTextureTable;
}
function processPrimitiveTextures(scenegraph, attributeName, featureTextureProperty, featureTextureTable, primitive) {
  const textureInfoTopLevel = {
    channels: featureTextureProperty.channels,
    ...featureTextureProperty.texture
  };
  const propertyData = getPrimitiveTextureData(scenegraph, textureInfoTopLevel, primitive);
  if (!propertyData) {
    return;
  }
  primitivePropertyDataToAttributes(scenegraph, attributeName, propertyData, featureTextureTable, primitive);
}
const EXT_feature_metadata = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$7,
  name: name$9
}, Symbol.toStringTag, { value: "Module" }));
const VERSION$1 = "4.2.1";
const VERSION = "4.2.1";
const BASIS_EXTERNAL_LIBRARIES = {
  /** Basis transcoder, javascript wrapper part */
  TRANSCODER: "basis_transcoder.js",
  /** Basis transcoder, compiled web assembly part */
  TRANSCODER_WASM: "basis_transcoder.wasm",
  /** Basis encoder, javascript wrapper part */
  ENCODER: "basis_encoder.js",
  /** Basis encoder, compiled web assembly part */
  ENCODER_WASM: "basis_encoder.wasm"
};
let loadBasisTranscoderPromise;
async function loadBasisTranscoderModule(options2) {
  registerJSModules(options2.modules);
  const basis = getJSModuleOrNull("basis");
  if (basis) {
    return basis;
  }
  loadBasisTranscoderPromise || (loadBasisTranscoderPromise = loadBasisTranscoder(options2));
  return await loadBasisTranscoderPromise;
}
async function loadBasisTranscoder(options2) {
  let BASIS = null;
  let wasmBinary = null;
  [BASIS, wasmBinary] = await Promise.all([
    await loadLibrary(BASIS_EXTERNAL_LIBRARIES.TRANSCODER, "textures", options2),
    await loadLibrary(BASIS_EXTERNAL_LIBRARIES.TRANSCODER_WASM, "textures", options2)
  ]);
  BASIS = BASIS || globalThis.BASIS;
  return await initializeBasisTranscoderModule(BASIS, wasmBinary);
}
function initializeBasisTranscoderModule(BasisModule, wasmBinary) {
  const options2 = {};
  if (wasmBinary) {
    options2.wasmBinary = wasmBinary;
  }
  return new Promise((resolve2) => {
    BasisModule(options2).then((module2) => {
      const { BasisFile, initializeBasis } = module2;
      initializeBasis();
      resolve2({ BasisFile });
    });
  });
}
let loadBasisEncoderPromise;
async function loadBasisEncoderModule(options2) {
  const modules = options2.modules || {};
  if (modules.basisEncoder) {
    return modules.basisEncoder;
  }
  loadBasisEncoderPromise = loadBasisEncoderPromise || loadBasisEncoder(options2);
  return await loadBasisEncoderPromise;
}
async function loadBasisEncoder(options2) {
  let BASIS_ENCODER = null;
  let wasmBinary = null;
  [BASIS_ENCODER, wasmBinary] = await Promise.all([
    await loadLibrary(BASIS_EXTERNAL_LIBRARIES.ENCODER, "textures", options2),
    await loadLibrary(BASIS_EXTERNAL_LIBRARIES.ENCODER_WASM, "textures", options2)
  ]);
  BASIS_ENCODER = BASIS_ENCODER || globalThis.BASIS;
  return await initializeBasisEncoderModule(BASIS_ENCODER, wasmBinary);
}
function initializeBasisEncoderModule(BasisEncoderModule, wasmBinary) {
  const options2 = {};
  if (wasmBinary) {
    options2.wasmBinary = wasmBinary;
  }
  return new Promise((resolve2) => {
    BasisEncoderModule(options2).then((module2) => {
      const { BasisFile, KTX2File, initializeBasis, BasisEncoder } = module2;
      initializeBasis();
      resolve2({ BasisFile, KTX2File, BasisEncoder });
    });
  });
}
const GL_EXTENSIONS_CONSTANTS = {
  // WEBGL_compressed_texture_s3tc
  COMPRESSED_RGB_S3TC_DXT1_EXT: 33776,
  COMPRESSED_RGBA_S3TC_DXT1_EXT: 33777,
  COMPRESSED_RGBA_S3TC_DXT3_EXT: 33778,
  COMPRESSED_RGBA_S3TC_DXT5_EXT: 33779,
  // WEBGL_compressed_texture_es3
  COMPRESSED_R11_EAC: 37488,
  COMPRESSED_SIGNED_R11_EAC: 37489,
  COMPRESSED_RG11_EAC: 37490,
  COMPRESSED_SIGNED_RG11_EAC: 37491,
  COMPRESSED_RGB8_ETC2: 37492,
  COMPRESSED_RGBA8_ETC2_EAC: 37493,
  COMPRESSED_SRGB8_ETC2: 37494,
  COMPRESSED_SRGB8_ALPHA8_ETC2_EAC: 37495,
  COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37496,
  COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2: 37497,
  // WEBGL_compressed_texture_pvrtc
  COMPRESSED_RGB_PVRTC_4BPPV1_IMG: 35840,
  COMPRESSED_RGBA_PVRTC_4BPPV1_IMG: 35842,
  COMPRESSED_RGB_PVRTC_2BPPV1_IMG: 35841,
  COMPRESSED_RGBA_PVRTC_2BPPV1_IMG: 35843,
  // WEBGL_compressed_texture_etc1
  COMPRESSED_RGB_ETC1_WEBGL: 36196,
  // WEBGL_compressed_texture_atc
  COMPRESSED_RGB_ATC_WEBGL: 35986,
  COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL: 35987,
  COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL: 34798,
  // WEBGL_compressed_texture_astc
  COMPRESSED_RGBA_ASTC_4X4_KHR: 37808,
  COMPRESSED_RGBA_ASTC_5X4_KHR: 37809,
  COMPRESSED_RGBA_ASTC_5X5_KHR: 37810,
  COMPRESSED_RGBA_ASTC_6X5_KHR: 37811,
  COMPRESSED_RGBA_ASTC_6X6_KHR: 37812,
  COMPRESSED_RGBA_ASTC_8X5_KHR: 37813,
  COMPRESSED_RGBA_ASTC_8X6_KHR: 37814,
  COMPRESSED_RGBA_ASTC_8X8_KHR: 37815,
  COMPRESSED_RGBA_ASTC_10X5_KHR: 37816,
  COMPRESSED_RGBA_ASTC_10X6_KHR: 37817,
  COMPRESSED_RGBA_ASTC_10X8_KHR: 37818,
  COMPRESSED_RGBA_ASTC_10X10_KHR: 37819,
  COMPRESSED_RGBA_ASTC_12X10_KHR: 37820,
  COMPRESSED_RGBA_ASTC_12X12_KHR: 37821,
  COMPRESSED_SRGB8_ALPHA8_ASTC_4X4_KHR: 37840,
  COMPRESSED_SRGB8_ALPHA8_ASTC_5X4_KHR: 37841,
  COMPRESSED_SRGB8_ALPHA8_ASTC_5X5_KHR: 37842,
  COMPRESSED_SRGB8_ALPHA8_ASTC_6X5_KHR: 37843,
  COMPRESSED_SRGB8_ALPHA8_ASTC_6X6_KHR: 37844,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X5_KHR: 37845,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X6_KHR: 37846,
  COMPRESSED_SRGB8_ALPHA8_ASTC_8X8_KHR: 37847,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X5_KHR: 37848,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X6_KHR: 37849,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X8_KHR: 37850,
  COMPRESSED_SRGB8_ALPHA8_ASTC_10X10_KHR: 37851,
  COMPRESSED_SRGB8_ALPHA8_ASTC_12X10_KHR: 37852,
  COMPRESSED_SRGB8_ALPHA8_ASTC_12X12_KHR: 37853,
  // EXT_texture_compression_rgtc
  COMPRESSED_RED_RGTC1_EXT: 36283,
  COMPRESSED_SIGNED_RED_RGTC1_EXT: 36284,
  COMPRESSED_RED_GREEN_RGTC2_EXT: 36285,
  COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT: 36286,
  // WEBGL_compressed_texture_s3tc_srgb
  COMPRESSED_SRGB_S3TC_DXT1_EXT: 35916,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT: 35917,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT: 35918,
  COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT: 35919
};
const BROWSER_PREFIXES = ["", "WEBKIT_", "MOZ_"];
const WEBGL_EXTENSIONS = {
  /* eslint-disable camelcase */
  WEBGL_compressed_texture_s3tc: "dxt",
  WEBGL_compressed_texture_s3tc_srgb: "dxt-srgb",
  WEBGL_compressed_texture_etc1: "etc1",
  WEBGL_compressed_texture_etc: "etc2",
  WEBGL_compressed_texture_pvrtc: "pvrtc",
  WEBGL_compressed_texture_atc: "atc",
  WEBGL_compressed_texture_astc: "astc",
  EXT_texture_compression_rgtc: "rgtc"
  /* eslint-enable camelcase */
};
let formats = null;
function getSupportedGPUTextureFormats(gl) {
  if (!formats) {
    gl = gl || getWebGLContext() || void 0;
    formats = /* @__PURE__ */ new Set();
    for (const prefix of BROWSER_PREFIXES) {
      for (const extension in WEBGL_EXTENSIONS) {
        if (gl && gl.getExtension(`${prefix}${extension}`)) {
          const gpuTextureFormat = WEBGL_EXTENSIONS[extension];
          formats.add(gpuTextureFormat);
        }
      }
    }
  }
  return formats;
}
function getWebGLContext() {
  try {
    const canvas2 = document.createElement("canvas");
    return canvas2.getContext("webgl");
  } catch (error2) {
    return null;
  }
}
const KTX2_ID = [
  // '´', 'K', 'T', 'X', '2', '0', 'ª', '\r', '\n', '\x1A', '\n'
  171,
  75,
  84,
  88,
  32,
  50,
  48,
  187,
  13,
  10,
  26,
  10
];
function isKTX(data2) {
  const id = new Uint8Array(data2);
  const notKTX = id.byteLength < KTX2_ID.length || id[0] !== KTX2_ID[0] || // '´'
  id[1] !== KTX2_ID[1] || // 'K'
  id[2] !== KTX2_ID[2] || // 'T'
  id[3] !== KTX2_ID[3] || // 'X'
  id[4] !== KTX2_ID[4] || // ' '
  id[5] !== KTX2_ID[5] || // '2'
  id[6] !== KTX2_ID[6] || // '0'
  id[7] !== KTX2_ID[7] || // 'ª'
  id[8] !== KTX2_ID[8] || // '\r'
  id[9] !== KTX2_ID[9] || // '\n'
  id[10] !== KTX2_ID[10] || // '\x1A'
  id[11] !== KTX2_ID[11];
  return !notKTX;
}
const OutputFormat = {
  etc1: {
    basisFormat: 0,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS.COMPRESSED_RGB_ETC1_WEBGL
  },
  etc2: { basisFormat: 1, compressed: true },
  bc1: {
    basisFormat: 2,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS.COMPRESSED_RGB_S3TC_DXT1_EXT
  },
  bc3: {
    basisFormat: 3,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS.COMPRESSED_RGBA_S3TC_DXT5_EXT
  },
  bc4: { basisFormat: 4, compressed: true },
  bc5: { basisFormat: 5, compressed: true },
  "bc7-m6-opaque-only": { basisFormat: 6, compressed: true },
  "bc7-m5": { basisFormat: 7, compressed: true },
  "pvrtc1-4-rgb": {
    basisFormat: 8,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS.COMPRESSED_RGB_PVRTC_4BPPV1_IMG
  },
  "pvrtc1-4-rgba": {
    basisFormat: 9,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
  },
  "astc-4x4": {
    basisFormat: 10,
    compressed: true,
    format: GL_EXTENSIONS_CONSTANTS.COMPRESSED_RGBA_ASTC_4X4_KHR
  },
  "atc-rgb": { basisFormat: 11, compressed: true },
  "atc-rgba-interpolated-alpha": { basisFormat: 12, compressed: true },
  rgba32: { basisFormat: 13, compressed: false },
  rgb565: { basisFormat: 14, compressed: false },
  bgr565: { basisFormat: 15, compressed: false },
  rgba4444: { basisFormat: 16, compressed: false }
};
async function parseBasis(data2, options2) {
  if (options2.basis.containerFormat === "auto") {
    if (isKTX(data2)) {
      const fileConstructors = await loadBasisEncoderModule(options2);
      return parseKTX2File(fileConstructors.KTX2File, data2, options2);
    }
    const { BasisFile } = await loadBasisTranscoderModule(options2);
    return parseBasisFile(BasisFile, data2, options2);
  }
  switch (options2.basis.module) {
    case "encoder":
      const fileConstructors = await loadBasisEncoderModule(options2);
      switch (options2.basis.containerFormat) {
        case "ktx2":
          return parseKTX2File(fileConstructors.KTX2File, data2, options2);
        case "basis":
        default:
          return parseBasisFile(fileConstructors.BasisFile, data2, options2);
      }
    case "transcoder":
    default:
      const { BasisFile } = await loadBasisTranscoderModule(options2);
      return parseBasisFile(BasisFile, data2, options2);
  }
}
function parseBasisFile(BasisFile, data2, options2) {
  const basisFile = new BasisFile(new Uint8Array(data2));
  try {
    if (!basisFile.startTranscoding()) {
      throw new Error("Failed to start basis transcoding");
    }
    const imageCount = basisFile.getNumImages();
    const images = [];
    for (let imageIndex = 0; imageIndex < imageCount; imageIndex++) {
      const levelsCount = basisFile.getNumLevels(imageIndex);
      const levels = [];
      for (let levelIndex = 0; levelIndex < levelsCount; levelIndex++) {
        levels.push(transcodeImage(basisFile, imageIndex, levelIndex, options2));
      }
      images.push(levels);
    }
    return images;
  } finally {
    basisFile.close();
    basisFile.delete();
  }
}
function transcodeImage(basisFile, imageIndex, levelIndex, options2) {
  const width = basisFile.getImageWidth(imageIndex, levelIndex);
  const height = basisFile.getImageHeight(imageIndex, levelIndex);
  const hasAlpha = basisFile.getHasAlpha(
    /* imageIndex, levelIndex */
  );
  const { compressed, format, basisFormat } = getBasisOptions(options2, hasAlpha);
  const decodedSize = basisFile.getImageTranscodedSizeInBytes(imageIndex, levelIndex, basisFormat);
  const decodedData = new Uint8Array(decodedSize);
  if (!basisFile.transcodeImage(decodedData, imageIndex, levelIndex, basisFormat, 0, 0)) {
    throw new Error("failed to start Basis transcoding");
  }
  return {
    // standard loaders.gl image category payload
    width,
    height,
    data: decodedData,
    compressed,
    format,
    // Additional fields
    // Add levelSize field.
    hasAlpha
  };
}
function parseKTX2File(KTX2File, data2, options2) {
  const ktx2File = new KTX2File(new Uint8Array(data2));
  try {
    if (!ktx2File.startTranscoding()) {
      throw new Error("failed to start KTX2 transcoding");
    }
    const levelsCount = ktx2File.getLevels();
    const levels = [];
    for (let levelIndex = 0; levelIndex < levelsCount; levelIndex++) {
      levels.push(transcodeKTX2Image(ktx2File, levelIndex, options2));
      break;
    }
    return [levels];
  } finally {
    ktx2File.close();
    ktx2File.delete();
  }
}
function transcodeKTX2Image(ktx2File, levelIndex, options2) {
  const { alphaFlag, height, width } = ktx2File.getImageLevelInfo(levelIndex, 0, 0);
  const { compressed, format, basisFormat } = getBasisOptions(options2, alphaFlag);
  const decodedSize = ktx2File.getImageTranscodedSizeInBytes(levelIndex, 0, 0, basisFormat);
  const decodedData = new Uint8Array(decodedSize);
  if (!ktx2File.transcodeImage(
    decodedData,
    levelIndex,
    0,
    0,
    basisFormat,
    0,
    -1,
    -1
    /* channel1 */
  )) {
    throw new Error("Failed to transcode KTX2 image");
  }
  return {
    // standard loaders.gl image category payload
    width,
    height,
    data: decodedData,
    compressed,
    // Additional fields
    levelSize: decodedSize,
    hasAlpha: alphaFlag,
    format
  };
}
function getBasisOptions(options2, hasAlpha) {
  let format = options2 && options2.basis && options2.basis.format;
  if (format === "auto") {
    format = selectSupportedBasisFormat();
  }
  if (typeof format === "object") {
    format = hasAlpha ? format.alpha : format.noAlpha;
  }
  format = format.toLowerCase();
  return OutputFormat[format];
}
function selectSupportedBasisFormat() {
  const supportedFormats = getSupportedGPUTextureFormats();
  if (supportedFormats.has("astc")) {
    return "astc-4x4";
  } else if (supportedFormats.has("dxt")) {
    return {
      alpha: "bc3",
      noAlpha: "bc1"
    };
  } else if (supportedFormats.has("pvrtc")) {
    return {
      alpha: "pvrtc1-4-rgba",
      noAlpha: "pvrtc1-4-rgb"
    };
  } else if (supportedFormats.has("etc1")) {
    return "etc1";
  } else if (supportedFormats.has("etc2")) {
    return "etc2";
  }
  return "rgb565";
}
const BasisWorkerLoader = {
  dataType: null,
  batchType: null,
  name: "Basis",
  id: "basis",
  module: "textures",
  version: VERSION,
  worker: true,
  extensions: ["basis", "ktx2"],
  mimeTypes: ["application/octet-stream", "image/ktx2"],
  tests: ["sB"],
  binary: true,
  options: {
    basis: {
      format: "auto",
      libraryPath: "libs/",
      containerFormat: "auto",
      module: "transcoder"
    }
  }
};
const BasisLoader = {
  ...BasisWorkerLoader,
  parse: parseBasis
};
const LITTLE_ENDIAN = true;
const MAGIC_glTF = 1735152710;
const GLB_FILE_HEADER_SIZE = 12;
const GLB_CHUNK_HEADER_SIZE = 8;
const GLB_CHUNK_TYPE_JSON = 1313821514;
const GLB_CHUNK_TYPE_BIN = 5130562;
const GLB_V1_CONTENT_FORMAT_JSON = 0;
const GLB_CHUNK_TYPE_JSON_XVIZ_DEPRECATED = 0;
const GLB_CHUNK_TYPE_BIX_XVIZ_DEPRECATED = 1;
function getMagicString(dataView, byteOffset = 0) {
  return `${String.fromCharCode(dataView.getUint8(byteOffset + 0))}${String.fromCharCode(dataView.getUint8(byteOffset + 1))}${String.fromCharCode(dataView.getUint8(byteOffset + 2))}${String.fromCharCode(dataView.getUint8(byteOffset + 3))}`;
}
function isGLB(arrayBuffer2, byteOffset = 0, options2 = {}) {
  const dataView = new DataView(arrayBuffer2);
  const { magic = MAGIC_glTF } = options2;
  const magic1 = dataView.getUint32(byteOffset, false);
  return magic1 === magic || magic1 === MAGIC_glTF;
}
function parseGLBSync(glb, arrayBuffer2, byteOffset = 0, options2 = {}) {
  const dataView = new DataView(arrayBuffer2);
  const type = getMagicString(dataView, byteOffset + 0);
  const version2 = dataView.getUint32(byteOffset + 4, LITTLE_ENDIAN);
  const byteLength = dataView.getUint32(byteOffset + 8, LITTLE_ENDIAN);
  Object.assign(glb, {
    // Put less important stuff in a header, to avoid clutter
    header: {
      byteOffset,
      // Byte offset into the initial arrayBuffer
      byteLength,
      hasBinChunk: false
    },
    type,
    version: version2,
    json: {},
    binChunks: []
  });
  byteOffset += GLB_FILE_HEADER_SIZE;
  switch (glb.version) {
    case 1:
      return parseGLBV1(glb, dataView, byteOffset);
    case 2:
      return parseGLBV2(glb, dataView, byteOffset, options2 = {});
    default:
      throw new Error(`Invalid GLB version ${glb.version}. Only supports version 1 and 2.`);
  }
}
function parseGLBV1(glb, dataView, byteOffset) {
  assert$4(glb.header.byteLength > GLB_FILE_HEADER_SIZE + GLB_CHUNK_HEADER_SIZE);
  const contentLength = dataView.getUint32(byteOffset + 0, LITTLE_ENDIAN);
  const contentFormat = dataView.getUint32(byteOffset + 4, LITTLE_ENDIAN);
  byteOffset += GLB_CHUNK_HEADER_SIZE;
  assert$4(contentFormat === GLB_V1_CONTENT_FORMAT_JSON);
  parseJSONChunk(glb, dataView, byteOffset, contentLength);
  byteOffset += contentLength;
  byteOffset += parseBINChunk(glb, dataView, byteOffset, glb.header.byteLength);
  return byteOffset;
}
function parseGLBV2(glb, dataView, byteOffset, options2) {
  assert$4(glb.header.byteLength > GLB_FILE_HEADER_SIZE + GLB_CHUNK_HEADER_SIZE);
  parseGLBChunksSync(glb, dataView, byteOffset, options2);
  return byteOffset + glb.header.byteLength;
}
function parseGLBChunksSync(glb, dataView, byteOffset, options2) {
  while (byteOffset + 8 <= glb.header.byteLength) {
    const chunkLength = dataView.getUint32(byteOffset + 0, LITTLE_ENDIAN);
    const chunkFormat = dataView.getUint32(byteOffset + 4, LITTLE_ENDIAN);
    byteOffset += GLB_CHUNK_HEADER_SIZE;
    switch (chunkFormat) {
      case GLB_CHUNK_TYPE_JSON:
        parseJSONChunk(glb, dataView, byteOffset, chunkLength);
        break;
      case GLB_CHUNK_TYPE_BIN:
        parseBINChunk(glb, dataView, byteOffset, chunkLength);
        break;
      case GLB_CHUNK_TYPE_JSON_XVIZ_DEPRECATED:
        if (!options2.strict) {
          parseJSONChunk(glb, dataView, byteOffset, chunkLength);
        }
        break;
      case GLB_CHUNK_TYPE_BIX_XVIZ_DEPRECATED:
        if (!options2.strict) {
          parseBINChunk(glb, dataView, byteOffset, chunkLength);
        }
        break;
    }
    byteOffset += padToNBytes(chunkLength, 4);
  }
  return byteOffset;
}
function parseJSONChunk(glb, dataView, byteOffset, chunkLength) {
  const jsonChunk = new Uint8Array(dataView.buffer, byteOffset, chunkLength);
  const textDecoder = new TextDecoder("utf8");
  const jsonText = textDecoder.decode(jsonChunk);
  glb.json = JSON.parse(jsonText);
  return padToNBytes(chunkLength, 4);
}
function parseBINChunk(glb, dataView, byteOffset, chunkLength) {
  glb.header.hasBinChunk = true;
  glb.binChunks.push({
    byteOffset,
    byteLength: chunkLength,
    arrayBuffer: dataView.buffer
    // TODO - copy, or create typed array view?
  });
  return padToNBytes(chunkLength, 4);
}
function resolveUrl(url2, options2) {
  const absolute2 = url2.startsWith("data:") || url2.startsWith("http:") || url2.startsWith("https:");
  if (absolute2) {
    return url2;
  }
  const baseUrl = options2.baseUri || options2.uri;
  if (!baseUrl) {
    throw new Error(`'baseUri' must be provided to resolve relative url ${url2}`);
  }
  return baseUrl.substr(0, baseUrl.lastIndexOf("/") + 1) + url2;
}
const wasm_base = "B9h9z9tFBBBF8fL9gBB9gLaaaaaFa9gEaaaB9gFaFa9gEaaaFaEMcBFFFGGGEIIILF9wFFFLEFBFKNFaFCx/IFMO/LFVK9tv9t9vq95GBt9f9f939h9z9t9f9j9h9s9s9f9jW9vq9zBBp9tv9z9o9v9wW9f9kv9j9v9kv9WvqWv94h919m9mvqBF8Z9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv94h919m9mvqBGy9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv949TvZ91v9u9jvBEn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9P9jWBIi9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9R919hWBLn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9F949wBKI9z9iqlBOc+x8ycGBM/qQFTa8jUUUUBCU/EBlHL8kUUUUBC9+RKGXAGCFJAI9LQBCaRKAE2BBC+gF9HQBALAEAIJHOAGlAGTkUUUBRNCUoBAG9uC/wgBZHKCUGAKCUG9JyRVAECFJRICBRcGXEXAcAF9PQFAVAFAclAcAVJAF9JyRMGXGXAG9FQBAMCbJHKC9wZRSAKCIrCEJCGrRQANCUGJRfCBRbAIRTEXGXAOATlAQ9PQBCBRISEMATAQJRIGXAS9FQBCBRtCBREEXGXAOAIlCi9PQBCBRISLMANCU/CBJAEJRKGXGXGXGXGXATAECKrJ2BBAtCKZrCEZfIBFGEBMAKhB83EBAKCNJhB83EBSEMAKAI2BIAI2BBHmCKrHYAYCE6HYy86BBAKCFJAICIJAYJHY2BBAmCIrCEZHPAPCE6HPy86BBAKCGJAYAPJHY2BBAmCGrCEZHPAPCE6HPy86BBAKCEJAYAPJHY2BBAmCEZHmAmCE6Hmy86BBAKCIJAYAmJHY2BBAI2BFHmCKrHPAPCE6HPy86BBAKCLJAYAPJHY2BBAmCIrCEZHPAPCE6HPy86BBAKCKJAYAPJHY2BBAmCGrCEZHPAPCE6HPy86BBAKCOJAYAPJHY2BBAmCEZHmAmCE6Hmy86BBAKCNJAYAmJHY2BBAI2BGHmCKrHPAPCE6HPy86BBAKCVJAYAPJHY2BBAmCIrCEZHPAPCE6HPy86BBAKCcJAYAPJHY2BBAmCGrCEZHPAPCE6HPy86BBAKCMJAYAPJHY2BBAmCEZHmAmCE6Hmy86BBAKCSJAYAmJHm2BBAI2BEHICKrHYAYCE6HYy86BBAKCQJAmAYJHm2BBAICIrCEZHYAYCE6HYy86BBAKCfJAmAYJHm2BBAICGrCEZHYAYCE6HYy86BBAKCbJAmAYJHK2BBAICEZHIAICE6HIy86BBAKAIJRISGMAKAI2BNAI2BBHmCIrHYAYCb6HYy86BBAKCFJAICNJAYJHY2BBAmCbZHmAmCb6Hmy86BBAKCGJAYAmJHm2BBAI2BFHYCIrHPAPCb6HPy86BBAKCEJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCIJAmAYJHm2BBAI2BGHYCIrHPAPCb6HPy86BBAKCLJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCKJAmAYJHm2BBAI2BEHYCIrHPAPCb6HPy86BBAKCOJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCNJAmAYJHm2BBAI2BIHYCIrHPAPCb6HPy86BBAKCVJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCcJAmAYJHm2BBAI2BLHYCIrHPAPCb6HPy86BBAKCMJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCSJAmAYJHm2BBAI2BKHYCIrHPAPCb6HPy86BBAKCQJAmAPJHm2BBAYCbZHYAYCb6HYy86BBAKCfJAmAYJHm2BBAI2BOHICIrHYAYCb6HYy86BBAKCbJAmAYJHK2BBAICbZHIAICb6HIy86BBAKAIJRISFMAKAI8pBB83BBAKCNJAICNJ8pBB83BBAICTJRIMAtCGJRtAECTJHEAS9JQBMMGXAIQBCBRISEMGXAM9FQBANAbJ2BBRtCBRKAfREEXAEANCU/CBJAKJ2BBHTCFrCBATCFZl9zAtJHt86BBAEAGJREAKCFJHKAM9HQBMMAfCFJRfAIRTAbCFJHbAG9HQBMMABAcAG9sJANCUGJAMAG9sTkUUUBpANANCUGJAMCaJAG9sJAGTkUUUBpMAMCBAIyAcJRcAIQBMC9+RKSFMCBC99AOAIlAGCAAGCA9Ly6yRKMALCU/EBJ8kUUUUBAKM+OmFTa8jUUUUBCoFlHL8kUUUUBC9+RKGXAFCE9uHOCtJAI9LQBCaRKAE2BBHNC/wFZC/gF9HQBANCbZHVCF9LQBALCoBJCgFCUFT+JUUUBpALC84Jha83EBALC8wJha83EBALC8oJha83EBALCAJha83EBALCiJha83EBALCTJha83EBALha83ENALha83EBAEAIJC9wJRcAECFJHNAOJRMGXAF9FQBCQCbAVCF6yRSABRECBRVCBRQCBRfCBRICBRKEXGXAMAcuQBC9+RKSEMGXGXAN2BBHOC/vF9LQBALCoBJAOCIrCa9zAKJCbZCEWJHb8oGIRTAb8oGBRtGXAOCbZHbAS9PQBALAOCa9zAIJCbZCGWJ8oGBAVAbyROAb9FRbGXGXAGCG9HQBABAt87FBABCIJAO87FBABCGJAT87FBSFMAEAtjGBAECNJAOjGBAECIJATjGBMAVAbJRVALCoBJAKCEWJHmAOjGBAmATjGIALAICGWJAOjGBALCoBJAKCFJCbZHKCEWJHTAtjGBATAOjGIAIAbJRIAKCFJRKSGMGXGXAbCb6QBAQAbJAbC989zJCFJRQSFMAM1BBHbCgFZROGXGXAbCa9MQBAMCFJRMSFMAM1BFHbCgBZCOWAOCgBZqROGXAbCa9MQBAMCGJRMSFMAM1BGHbCgBZCfWAOqROGXAbCa9MQBAMCEJRMSFMAM1BEHbCgBZCdWAOqROGXAbCa9MQBAMCIJRMSFMAM2BIC8cWAOqROAMCLJRMMAOCFrCBAOCFZl9zAQJRQMGXGXAGCG9HQBABAt87FBABCIJAQ87FBABCGJAT87FBSFMAEAtjGBAECNJAQjGBAECIJATjGBMALCoBJAKCEWJHOAQjGBAOATjGIALAICGWJAQjGBALCoBJAKCFJCbZHKCEWJHOAtjGBAOAQjGIAICFJRIAKCFJRKSFMGXAOCDF9LQBALAIAcAOCbZJ2BBHbCIrHTlCbZCGWJ8oGBAVCFJHtATyROALAIAblCbZCGWJ8oGBAtAT9FHmJHtAbCbZHTyRbAT9FRTGXGXAGCG9HQBABAV87FBABCIJAb87FBABCGJAO87FBSFMAEAVjGBAECNJAbjGBAECIJAOjGBMALAICGWJAVjGBALCoBJAKCEWJHYAOjGBAYAVjGIALAICFJHICbZCGWJAOjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAIAmJCbZHICGWJAbjGBALCoBJAKCGJCbZHKCEWJHOAVjGBAOAbjGIAKCFJRKAIATJRIAtATJRVSFMAVCBAM2BBHYyHTAOC/+F6HPJROAYCbZRtGXGXAYCIrHmQBAOCFJRbSFMAORbALAIAmlCbZCGWJ8oGBROMGXGXAtQBAbCFJRVSFMAbRVALAIAYlCbZCGWJ8oGBRbMGXGXAP9FQBAMCFJRYSFMAM1BFHYCgFZRTGXGXAYCa9MQBAMCGJRYSFMAM1BGHYCgBZCOWATCgBZqRTGXAYCa9MQBAMCEJRYSFMAM1BEHYCgBZCfWATqRTGXAYCa9MQBAMCIJRYSFMAM1BIHYCgBZCdWATqRTGXAYCa9MQBAMCLJRYSFMAMCKJRYAM2BLC8cWATqRTMATCFrCBATCFZl9zAQJHQRTMGXGXAmCb6QBAYRPSFMAY1BBHMCgFZROGXGXAMCa9MQBAYCFJRPSFMAY1BFHMCgBZCOWAOCgBZqROGXAMCa9MQBAYCGJRPSFMAY1BGHMCgBZCfWAOqROGXAMCa9MQBAYCEJRPSFMAY1BEHMCgBZCdWAOqROGXAMCa9MQBAYCIJRPSFMAYCLJRPAY2BIC8cWAOqROMAOCFrCBAOCFZl9zAQJHQROMGXGXAtCb6QBAPRMSFMAP1BBHMCgFZRbGXGXAMCa9MQBAPCFJRMSFMAP1BFHMCgBZCOWAbCgBZqRbGXAMCa9MQBAPCGJRMSFMAP1BGHMCgBZCfWAbqRbGXAMCa9MQBAPCEJRMSFMAP1BEHMCgBZCdWAbqRbGXAMCa9MQBAPCIJRMSFMAPCLJRMAP2BIC8cWAbqRbMAbCFrCBAbCFZl9zAQJHQRbMGXGXAGCG9HQBABAT87FBABCIJAb87FBABCGJAO87FBSFMAEATjGBAECNJAbjGBAECIJAOjGBMALCoBJAKCEWJHYAOjGBAYATjGIALAICGWJATjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAICFJHICbZCGWJAOjGBALCoBJAKCGJCbZCEWJHOATjGBAOAbjGIALAIAm9FAmCb6qJHICbZCGWJAbjGBAIAt9FAtCb6qJRIAKCEJRKMANCFJRNABCKJRBAECSJREAKCbZRKAICbZRIAfCEJHfAF9JQBMMCBC99AMAc6yRKMALCoFJ8kUUUUBAKM/tIFGa8jUUUUBCTlRLC9+RKGXAFCLJAI9LQBCaRKAE2BBC/+FZC/QF9HQBALhB83ENAECFJRKAEAIJC98JREGXAF9FQBGXAGCG6QBEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMALCNJAICFZCGWqHGAICGrCBAICFrCFZl9zAG8oGBJHIjGBABAIjGBABCIJRBAFCaJHFQBSGMMEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMABAICGrCBAICFrCFZl9zALCNJAICFZCGWqHI8oGBJHG87FBAIAGjGBABCGJRBAFCaJHFQBMMCBC99AKAE6yRKMAKM+lLKFaF99GaG99FaG99GXGXAGCI9HQBAF9FQFEXGXGX9DBBB8/9DBBB+/ABCGJHG1BB+yAB1BBHE+yHI+L+TABCFJHL1BBHK+yHO+L+THN9DBBBB9gHVyAN9DBB/+hANAN+U9DBBBBANAVyHcAc+MHMAECa3yAI+SHIAI+UAcAMAKCa3yAO+SHcAc+U+S+S+R+VHO+U+SHN+L9DBBB9P9d9FQBAN+oRESFMCUUUU94REMAGAE86BBGXGX9DBBB8/9DBBB+/Ac9DBBBB9gyAcAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMALAG86BBGXGX9DBBB8/9DBBB+/AI9DBBBB9gyAIAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMABAG86BBABCIJRBAFCaJHFQBSGMMAF9FQBEXGXGX9DBBB8/9DBBB+/ABCIJHG8uFB+yAB8uFBHE+yHI+L+TABCGJHL8uFBHK+yHO+L+THN9DBBBB9gHVyAN9DB/+g6ANAN+U9DBBBBANAVyHcAc+MHMAECa3yAI+SHIAI+UAcAMAKCa3yAO+SHcAc+U+S+S+R+VHO+U+SHN+L9DBBB9P9d9FQBAN+oRESFMCUUUU94REMAGAE87FBGXGX9DBBB8/9DBBB+/Ac9DBBBB9gyAcAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMALAG87FBGXGX9DBBB8/9DBBB+/AI9DBBBB9gyAIAO+U+SHN+L9DBBB9P9d9FQBAN+oRGSFMCUUUU94RGMABAG87FBABCNJRBAFCaJHFQBMMM/SEIEaE99EaF99GXAF9FQBCBREABRIEXGXGX9D/zI818/AICKJ8uFBHLCEq+y+VHKAI8uFB+y+UHO9DB/+g6+U9DBBB8/9DBBB+/AO9DBBBB9gy+SHN+L9DBBB9P9d9FQBAN+oRVSFMCUUUU94RVMAICIJ8uFBRcAICGJ8uFBRMABALCFJCEZAEqCFWJAV87FBGXGXAKAM+y+UHN9DB/+g6+U9DBBB8/9DBBB+/AN9DBBBB9gy+SHS+L9DBBB9P9d9FQBAS+oRMSFMCUUUU94RMMABALCGJCEZAEqCFWJAM87FBGXGXAKAc+y+UHK9DB/+g6+U9DBBB8/9DBBB+/AK9DBBBB9gy+SHS+L9DBBB9P9d9FQBAS+oRcSFMCUUUU94RcMABALCaJCEZAEqCFWJAc87FBGXGX9DBBU8/AOAO+U+TANAN+U+TAKAK+U+THO9DBBBBAO9DBBBB9gy+R9DB/+g6+U9DBBB8/+SHO+L9DBBB9P9d9FQBAO+oRcSFMCUUUU94RcMABALCEZAEqCFWJAc87FBAICNJRIAECIJREAFCaJHFQBMMM9JBGXAGCGrAF9sHF9FQBEXABAB8oGBHGCNWCN91+yAGCi91CnWCUUU/8EJ+++U84GBABCIJRBAFCaJHFQBMMM9TFEaCBCB8oGUkUUBHFABCEJC98ZJHBjGUkUUBGXGXAB8/BCTWHGuQBCaREABAGlCggEJCTrXBCa6QFMAFREMAEM/lFFFaGXGXAFABqCEZ9FQBABRESFMGXGXAGCT9PQBABRESFMABREEXAEAF8oGBjGBAECIJAFCIJ8oGBjGBAECNJAFCNJ8oGBjGBAECSJAFCSJ8oGBjGBAECTJREAFCTJRFAGC9wJHGCb9LQBMMAGCI9JQBEXAEAF8oGBjGBAFCIJRFAECIJREAGC98JHGCE9LQBMMGXAG9FQBEXAEAF2BB86BBAECFJREAFCFJRFAGCaJHGQBMMABMoFFGaGXGXABCEZ9FQBABRESFMAFCgFZC+BwsN9sRIGXGXAGCT9PQBABRESFMABREEXAEAIjGBAECSJAIjGBAECNJAIjGBAECIJAIjGBAECTJREAGC9wJHGCb9LQBMMAGCI9JQBEXAEAIjGBAECIJREAGC98JHGCE9LQBMMGXAG9FQBEXAEAF86BBAECFJREAGCaJHGQBMMABMMMFBCUNMIT9kBB";
const wasm_simd = "B9h9z9tFBBBF8dL9gBB9gLaaaaaFa9gEaaaB9gGaaB9gFaFaEQSBBFBFFGEGEGIILF9wFFFLEFBFKNFaFCx/aFMO/LFVK9tv9t9vq95GBt9f9f939h9z9t9f9j9h9s9s9f9jW9vq9zBBp9tv9z9o9v9wW9f9kv9j9v9kv9WvqWv94h919m9mvqBG8Z9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv94h919m9mvqBIy9tv9z9o9v9wW9f9kv9j9v9kv9J9u9kv949TvZ91v9u9jvBLn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9P9jWBKi9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9R919hWBNn9tv9z9o9v9wW9f9kv9j9v9kv69p9sWvq9F949wBcI9z9iqlBMc/j9JSIBTEM9+FLa8jUUUUBCTlRBCBRFEXCBRGCBREEXABCNJAGJAECUaAFAGrCFZHIy86BBAEAIJREAGCFJHGCN9HQBMAFCx+YUUBJAE86BBAFCEWCxkUUBJAB8pEN83EBAFCFJHFCUG9HQBMMkRIbaG97FaK978jUUUUBCU/KBlHL8kUUUUBC9+RKGXAGCFJAI9LQBCaRKAE2BBC+gF9HQBALAEAIJHOAGlAG/8cBBCUoBAG9uC/wgBZHKCUGAKCUG9JyRNAECFJRKCBRVGXEXAVAF9PQFANAFAVlAVANJAF9JyRcGXGXAG9FQBAcCbJHIC9wZHMCE9sRSAMCFWRQAICIrCEJCGrRfCBRbEXAKRTCBRtGXEXGXAOATlAf9PQBCBRKSLMALCU/CBJAtAM9sJRmATAfJRKCBREGXAMCoB9JQBAOAKlC/gB9JQBCBRIEXAmAIJREGXGXGXGXGXATAICKrJ2BBHYCEZfIBFGEBMAECBDtDMIBSEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCIJAnDeBJAeCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCNJAnDeBJAeCx+YUUBJ2BBJRKSFMAEAKDBBBDMIBAKCTJRKMGXGXGXGXGXAYCGrCEZfIBFGEBMAECBDtDMITSEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMITAKCIJAnDeBJAeCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMITAKCNJAnDeBJAeCx+YUUBJ2BBJRKSFMAEAKDBBBDMITAKCTJRKMGXGXGXGXGXAYCIrCEZfIBFGEBMAECBDtDMIASEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIAAKCIJAnDeBJAeCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIAAKCNJAnDeBJAeCx+YUUBJ2BBJRKSFMAEAKDBBBDMIAAKCTJRKMGXGXGXGXGXAYCKrfIBFGEBMAECBDtDMI8wSEMAEAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HYCEWCxkUUBJDBEBAYCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HYCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMI8wAKCIJAnDeBJAYCx+YUUBJ2BBJRKSGMAEAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HYCEWCxkUUBJDBEBAYCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HYCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMI8wAKCNJAnDeBJAYCx+YUUBJ2BBJRKSFMAEAKDBBBDMI8wAKCTJRKMAICoBJREAICUFJAM9LQFAERIAOAKlC/fB9LQBMMGXAEAM9PQBAECErRIEXGXAOAKlCi9PQBCBRKSOMAmAEJRYGXGXGXGXGXATAECKrJ2BBAICKZrCEZfIBFGEBMAYCBDtDMIBSEMAYAKDBBIAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnHPCGD+MFAPDQBTFtGmEYIPLdKeOnC0+G+MiDtD9OHdCEDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCIJAnDeBJAeCx+YUUBJ2BBJRKSGMAYAKDBBNAKDBBBHPCID+MFAPDQBTFtGmEYIPLdKeOnC+P+e+8/4BDtD9OHdCbDbD8jHPD8dBhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBAeCx+YUUBJDBBBHnAnDQBBBBBBBBBBBBBBBBAPD8dFhUg/8/4/w/goB9+h84k7HeCEWCxkUUBJDBEBD9uDQBFGEILKOTtmYPdenDfAdAPD9SDMIBAKCNJAnDeBJAeCx+YUUBJ2BBJRKSFMAYAKDBBBDMIBAKCTJRKMAICGJRIAECTJHEAM9JQBMMGXAK9FQBAKRTAtCFJHtCI6QGSFMMCBRKSEMGXAM9FQBALCUGJAbJREALAbJDBGBRnCBRYEXAEALCU/CBJAYJHIDBIBHdCFD9tAdCFDbHPD9OD9hD9RHdAIAMJDBIBHiCFD9tAiAPD9OD9hD9RHiDQBTFtGmEYIPLdKeOnH8ZAIAQJDBIBHpCFD9tApAPD9OD9hD9RHpAIASJDBIBHyCFD9tAyAPD9OD9hD9RHyDQBTFtGmEYIPLdKeOnH8cDQBFTtGEmYILPdKOenHPAPDQBFGEBFGEBFGEBFGEAnD9uHnDyBjGBAEAGJHIAnAPAPDQILKOILKOILKOILKOD9uHnDyBjGBAIAGJHIAnAPAPDQNVcMNVcMNVcMNVcMD9uHnDyBjGBAIAGJHIAnAPAPDQSQfbSQfbSQfbSQfbD9uHnDyBjGBAIAGJHIAnA8ZA8cDQNVi8ZcMpySQ8c8dfb8e8fHPAPDQBFGEBFGEBFGEBFGED9uHnDyBjGBAIAGJHIAnAPAPDQILKOILKOILKOILKOD9uHnDyBjGBAIAGJHIAnAPAPDQNVcMNVcMNVcMNVcMD9uHnDyBjGBAIAGJHIAnAPAPDQSQfbSQfbSQfbSQfbD9uHnDyBjGBAIAGJHIAnAdAiDQNiV8ZcpMyS8cQ8df8eb8fHdApAyDQNiV8ZcpMyS8cQ8df8eb8fHiDQBFTtGEmYILPdKOenHPAPDQBFGEBFGEBFGEBFGED9uHnDyBjGBAIAGJHIAnAPAPDQILKOILKOILKOILKOD9uHnDyBjGBAIAGJHIAnAPAPDQNVcMNVcMNVcMNVcMD9uHnDyBjGBAIAGJHIAnAPAPDQSQfbSQfbSQfbSQfbD9uHnDyBjGBAIAGJHIAnAdAiDQNVi8ZcMpySQ8c8dfb8e8fHPAPDQBFGEBFGEBFGEBFGED9uHnDyBjGBAIAGJHIAnAPAPDQILKOILKOILKOILKOD9uHnDyBjGBAIAGJHIAnAPAPDQNVcMNVcMNVcMNVcMD9uHnDyBjGBAIAGJHIAnAPAPDQSQfbSQfbSQfbSQfbD9uHnDyBjGBAIAGJREAYCTJHYAM9JQBMMAbCIJHbAG9JQBMMABAVAG9sJALCUGJAcAG9s/8cBBALALCUGJAcCaJAG9sJAG/8cBBMAcCBAKyAVJRVAKQBMC9+RKSFMCBC99AOAKlAGCAAGCA9Ly6yRKMALCU/KBJ8kUUUUBAKMNBT+BUUUBM+KmFTa8jUUUUBCoFlHL8kUUUUBC9+RKGXAFCE9uHOCtJAI9LQBCaRKAE2BBHNC/wFZC/gF9HQBANCbZHVCF9LQBALCoBJCgFCUF/8MBALC84Jha83EBALC8wJha83EBALC8oJha83EBALCAJha83EBALCiJha83EBALCTJha83EBALha83ENALha83EBAEAIJC9wJRcAECFJHNAOJRMGXAF9FQBCQCbAVCF6yRSABRECBRVCBRQCBRfCBRICBRKEXGXAMAcuQBC9+RKSEMGXGXAN2BBHOC/vF9LQBALCoBJAOCIrCa9zAKJCbZCEWJHb8oGIRTAb8oGBRtGXAOCbZHbAS9PQBALAOCa9zAIJCbZCGWJ8oGBAVAbyROAb9FRbGXGXAGCG9HQBABAt87FBABCIJAO87FBABCGJAT87FBSFMAEAtjGBAECNJAOjGBAECIJATjGBMAVAbJRVALCoBJAKCEWJHmAOjGBAmATjGIALAICGWJAOjGBALCoBJAKCFJCbZHKCEWJHTAtjGBATAOjGIAIAbJRIAKCFJRKSGMGXGXAbCb6QBAQAbJAbC989zJCFJRQSFMAM1BBHbCgFZROGXGXAbCa9MQBAMCFJRMSFMAM1BFHbCgBZCOWAOCgBZqROGXAbCa9MQBAMCGJRMSFMAM1BGHbCgBZCfWAOqROGXAbCa9MQBAMCEJRMSFMAM1BEHbCgBZCdWAOqROGXAbCa9MQBAMCIJRMSFMAM2BIC8cWAOqROAMCLJRMMAOCFrCBAOCFZl9zAQJRQMGXGXAGCG9HQBABAt87FBABCIJAQ87FBABCGJAT87FBSFMAEAtjGBAECNJAQjGBAECIJATjGBMALCoBJAKCEWJHOAQjGBAOATjGIALAICGWJAQjGBALCoBJAKCFJCbZHKCEWJHOAtjGBAOAQjGIAICFJRIAKCFJRKSFMGXAOCDF9LQBALAIAcAOCbZJ2BBHbCIrHTlCbZCGWJ8oGBAVCFJHtATyROALAIAblCbZCGWJ8oGBAtAT9FHmJHtAbCbZHTyRbAT9FRTGXGXAGCG9HQBABAV87FBABCIJAb87FBABCGJAO87FBSFMAEAVjGBAECNJAbjGBAECIJAOjGBMALAICGWJAVjGBALCoBJAKCEWJHYAOjGBAYAVjGIALAICFJHICbZCGWJAOjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAIAmJCbZHICGWJAbjGBALCoBJAKCGJCbZHKCEWJHOAVjGBAOAbjGIAKCFJRKAIATJRIAtATJRVSFMAVCBAM2BBHYyHTAOC/+F6HPJROAYCbZRtGXGXAYCIrHmQBAOCFJRbSFMAORbALAIAmlCbZCGWJ8oGBROMGXGXAtQBAbCFJRVSFMAbRVALAIAYlCbZCGWJ8oGBRbMGXGXAP9FQBAMCFJRYSFMAM1BFHYCgFZRTGXGXAYCa9MQBAMCGJRYSFMAM1BGHYCgBZCOWATCgBZqRTGXAYCa9MQBAMCEJRYSFMAM1BEHYCgBZCfWATqRTGXAYCa9MQBAMCIJRYSFMAM1BIHYCgBZCdWATqRTGXAYCa9MQBAMCLJRYSFMAMCKJRYAM2BLC8cWATqRTMATCFrCBATCFZl9zAQJHQRTMGXGXAmCb6QBAYRPSFMAY1BBHMCgFZROGXGXAMCa9MQBAYCFJRPSFMAY1BFHMCgBZCOWAOCgBZqROGXAMCa9MQBAYCGJRPSFMAY1BGHMCgBZCfWAOqROGXAMCa9MQBAYCEJRPSFMAY1BEHMCgBZCdWAOqROGXAMCa9MQBAYCIJRPSFMAYCLJRPAY2BIC8cWAOqROMAOCFrCBAOCFZl9zAQJHQROMGXGXAtCb6QBAPRMSFMAP1BBHMCgFZRbGXGXAMCa9MQBAPCFJRMSFMAP1BFHMCgBZCOWAbCgBZqRbGXAMCa9MQBAPCGJRMSFMAP1BGHMCgBZCfWAbqRbGXAMCa9MQBAPCEJRMSFMAP1BEHMCgBZCdWAbqRbGXAMCa9MQBAPCIJRMSFMAPCLJRMAP2BIC8cWAbqRbMAbCFrCBAbCFZl9zAQJHQRbMGXGXAGCG9HQBABAT87FBABCIJAb87FBABCGJAO87FBSFMAEATjGBAECNJAbjGBAECIJAOjGBMALCoBJAKCEWJHYAOjGBAYATjGIALAICGWJATjGBALCoBJAKCFJCbZCEWJHYAbjGBAYAOjGIALAICFJHICbZCGWJAOjGBALCoBJAKCGJCbZCEWJHOATjGBAOAbjGIALAIAm9FAmCb6qJHICbZCGWJAbjGBAIAt9FAtCb6qJRIAKCEJRKMANCFJRNABCKJRBAECSJREAKCbZRKAICbZRIAfCEJHfAF9JQBMMCBC99AMAc6yRKMALCoFJ8kUUUUBAKM/tIFGa8jUUUUBCTlRLC9+RKGXAFCLJAI9LQBCaRKAE2BBC/+FZC/QF9HQBALhB83ENAECFJRKAEAIJC98JREGXAF9FQBGXAGCG6QBEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMALCNJAICFZCGWqHGAICGrCBAICFrCFZl9zAG8oGBJHIjGBABAIjGBABCIJRBAFCaJHFQBSGMMEXGXAKAE9JQBC9+bMAK1BBHGCgFZRIGXGXAGCa9MQBAKCFJRKSFMAK1BFHGCgBZCOWAICgBZqRIGXAGCa9MQBAKCGJRKSFMAK1BGHGCgBZCfWAIqRIGXAGCa9MQBAKCEJRKSFMAK1BEHGCgBZCdWAIqRIGXAGCa9MQBAKCIJRKSFMAK2BIC8cWAIqRIAKCLJRKMABAICGrCBAICFrCFZl9zALCNJAICFZCGWqHI8oGBJHG87FBAIAGjGBABCGJRBAFCaJHFQBMMCBC99AKAE6yRKMAKM/xLGEaK978jUUUUBCAlHE8kUUUUBGXGXAGCI9HQBGXAFC98ZHI9FQBABRGCBRLEXAGAGDBBBHKCiD+rFCiD+sFD/6FHOAKCND+rFCiD+sFD/6FAOD/gFAKCTD+rFCiD+sFD/6FHND/gFD/kFD/lFHVCBDtD+2FHcAOCUUUU94DtHMD9OD9RD/kFHO9DBB/+hDYAOAOD/mFAVAVD/mFANAcANAMD9OD9RD/kFHOAOD/mFD/kFD/kFD/jFD/nFHND/mF9DBBX9LDYHcD/kFCgFDtD9OAKCUUU94DtD9OD9QAOAND/mFAcD/kFCND+rFCU/+EDtD9OD9QAVAND/mFAcD/kFCTD+rFCUU/8ODtD9OD9QDMBBAGCTJRGALCIJHLAI9JQBMMAIAF9PQFAEAFCEZHLCGWHGqCBCTAGl/8MBAEABAICGWJHIAG/8cBBGXAL9FQBAEAEDBIBHKCiD+rFCiD+sFD/6FHOAKCND+rFCiD+sFD/6FAOD/gFAKCTD+rFCiD+sFD/6FHND/gFD/kFD/lFHVCBDtD+2FHcAOCUUUU94DtHMD9OD9RD/kFHO9DBB/+hDYAOAOD/mFAVAVD/mFANAcANAMD9OD9RD/kFHOAOD/mFD/kFD/kFD/jFD/nFHND/mF9DBBX9LDYHcD/kFCgFDtD9OAKCUUU94DtD9OD9QAOAND/mFAcD/kFCND+rFCU/+EDtD9OD9QAVAND/mFAcD/kFCTD+rFCUU/8ODtD9OD9QDMIBMAIAEAG/8cBBSFMABAFC98ZHGT+HUUUBAGAF9PQBAEAFCEZHICEWHLJCBCAALl/8MBAEABAGCEWJHGAL/8cBBAEAIT+HUUUBAGAEAL/8cBBMAECAJ8kUUUUBM+yEGGaO97GXAF9FQBCBRGEXABCTJHEAEDBBBHICBDtHLCUU98D8cFCUU98D8cEHKD9OABDBBBHOAIDQILKOSQfbPden8c8d8e8fCggFDtD9OD/6FAOAIDQBFGENVcMTtmYi8ZpyHICTD+sFD/6FHND/gFAICTD+rFCTD+sFD/6FHVD/gFD/kFD/lFHI9DB/+g6DYAVAIALD+2FHLAVCUUUU94DtHcD9OD9RD/kFHVAVD/mFAIAID/mFANALANAcD9OD9RD/kFHIAID/mFD/kFD/kFD/jFD/nFHND/mF9DBBX9LDYHLD/kFCTD+rFAVAND/mFALD/kFCggEDtD9OD9QHVAIAND/mFALD/kFCaDbCBDnGCBDnECBDnKCBDnOCBDncCBDnMCBDnfCBDnbD9OHIDQNVi8ZcMpySQ8c8dfb8e8fD9QDMBBABAOAKD9OAVAIDQBFTtGEmYILPdKOenD9QDMBBABCAJRBAGCIJHGAF9JQBMMM94FEa8jUUUUBCAlHE8kUUUUBABAFC98ZHIT+JUUUBGXAIAF9PQBAEAFCEZHLCEWHFJCBCAAFl/8MBAEABAICEWJHBAF/8cBBAEALT+JUUUBABAEAF/8cBBMAECAJ8kUUUUBM/hEIGaF97FaL978jUUUUBCTlRGGXAF9FQBCBREEXAGABDBBBHIABCTJHLDBBBHKDQILKOSQfbPden8c8d8e8fHOCTD+sFHNCID+rFDMIBAB9DBBU8/DY9D/zI818/DYANCEDtD9QD/6FD/nFHNAIAKDQBFGENVcMTtmYi8ZpyHICTD+rFCTD+sFD/6FD/mFHKAKD/mFANAICTD+sFD/6FD/mFHVAVD/mFANAOCTD+rFCTD+sFD/6FD/mFHOAOD/mFD/kFD/kFD/lFCBDtD+4FD/jF9DB/+g6DYHND/mF9DBBX9LDYHID/kFCggEDtHcD9OAVAND/mFAID/kFCTD+rFD9QHVAOAND/mFAID/kFCTD+rFAKAND/mFAID/kFAcD9OD9QHNDQBFTtGEmYILPdKOenHID8dBAGDBIBDyB+t+J83EBABCNJAID8dFAGDBIBDyF+t+J83EBALAVANDQNVi8ZcMpySQ8c8dfb8e8fHND8dBAGDBIBDyG+t+J83EBABCiJAND8dFAGDBIBDyE+t+J83EBABCAJRBAECIJHEAF9JQBMMM/3FGEaF978jUUUUBCoBlREGXAGCGrAF9sHIC98ZHL9FQBCBRGABRFEXAFAFDBBBHKCND+rFCND+sFD/6FAKCiD+sFCnD+rFCUUU/8EDtD+uFD/mFDMBBAFCTJRFAGCIJHGAL9JQBMMGXALAI9PQBAEAICEZHGCGWHFqCBCoBAFl/8MBAEABALCGWJHLAF/8cBBGXAG9FQBAEAEDBIBHKCND+rFCND+sFD/6FAKCiD+sFCnD+rFCUUU/8EDtD+uFD/mFDMIBMALAEAF/8cBBMM9TFEaCBCB8oGUkUUBHFABCEJC98ZJHBjGUkUUBGXGXAB8/BCTWHGuQBCaREABAGlCggEJCTrXBCa6QFMAFREMAEMMMFBCUNMIT9tBB";
const detector = new Uint8Array([
  0,
  97,
  115,
  109,
  1,
  0,
  0,
  0,
  1,
  4,
  1,
  96,
  0,
  0,
  3,
  3,
  2,
  0,
  0,
  5,
  3,
  1,
  0,
  1,
  12,
  1,
  0,
  10,
  22,
  2,
  12,
  0,
  65,
  0,
  65,
  0,
  65,
  0,
  252,
  10,
  0,
  0,
  11,
  7,
  0,
  65,
  0,
  253,
  15,
  26,
  11
]);
const wasmpack = new Uint8Array([
  32,
  0,
  65,
  253,
  3,
  1,
  2,
  34,
  4,
  106,
  6,
  5,
  11,
  8,
  7,
  20,
  13,
  33,
  12,
  16,
  128,
  9,
  116,
  64,
  19,
  113,
  127,
  15,
  10,
  21,
  22,
  14,
  255,
  66,
  24,
  54,
  136,
  107,
  18,
  23,
  192,
  26,
  114,
  118,
  132,
  17,
  77,
  101,
  130,
  144,
  27,
  87,
  131,
  44,
  45,
  74,
  156,
  154,
  70,
  167
]);
const FILTERS = {
  // legacy index-based enums for glTF
  0: "",
  1: "meshopt_decodeFilterOct",
  2: "meshopt_decodeFilterQuat",
  3: "meshopt_decodeFilterExp",
  // string-based enums for glTF
  NONE: "",
  OCTAHEDRAL: "meshopt_decodeFilterOct",
  QUATERNION: "meshopt_decodeFilterQuat",
  EXPONENTIAL: "meshopt_decodeFilterExp"
};
const DECODERS = {
  // legacy index-based enums for glTF
  0: "meshopt_decodeVertexBuffer",
  1: "meshopt_decodeIndexBuffer",
  2: "meshopt_decodeIndexSequence",
  // string-based enums for glTF
  ATTRIBUTES: "meshopt_decodeVertexBuffer",
  TRIANGLES: "meshopt_decodeIndexBuffer",
  INDICES: "meshopt_decodeIndexSequence"
};
async function meshoptDecodeGltfBuffer(target, count3, size12, source, mode2, filter17 = "NONE") {
  const instance2 = await loadWasmInstance();
  decode$6(instance2, instance2.exports[DECODERS[mode2]], target, count3, size12, source, instance2.exports[FILTERS[filter17 || "NONE"]]);
}
let wasmPromise;
async function loadWasmInstance() {
  if (!wasmPromise) {
    wasmPromise = loadWasmModule();
  }
  return wasmPromise;
}
async function loadWasmModule() {
  let wasm2 = wasm_base;
  if (WebAssembly.validate(detector)) {
    wasm2 = wasm_simd;
    console.log("Warning: meshopt_decoder is using experimental SIMD support");
  }
  const result = await WebAssembly.instantiate(unpack(wasm2), {});
  await result.instance.exports.__wasm_call_ctors();
  return result.instance;
}
function unpack(data2) {
  const result = new Uint8Array(data2.length);
  for (let i2 = 0; i2 < data2.length; ++i2) {
    const ch2 = data2.charCodeAt(i2);
    result[i2] = ch2 > 96 ? ch2 - 71 : ch2 > 64 ? ch2 - 65 : ch2 > 47 ? ch2 + 4 : ch2 > 46 ? 63 : 62;
  }
  let write5 = 0;
  for (let i2 = 0; i2 < data2.length; ++i2) {
    result[write5++] = result[i2] < 60 ? wasmpack[result[i2]] : (result[i2] - 60) * 64 + result[++i2];
  }
  return result.buffer.slice(0, write5);
}
function decode$6(instance2, fun, target, count3, size12, source, filter17) {
  const sbrk = instance2.exports.sbrk;
  const count4 = count3 + 3 & ~3;
  const tp = sbrk(count4 * size12);
  const sp = sbrk(source.length);
  const heap = new Uint8Array(instance2.exports.memory.buffer);
  heap.set(source, sp);
  const res = fun(tp, count3, size12, sp, source.length);
  if (res === 0 && filter17) {
    filter17(tp, count4, size12);
  }
  target.set(heap.subarray(tp, tp + count3 * size12));
  sbrk(tp - sbrk(0));
  if (res !== 0) {
    throw new Error(`Malformed buffer data: ${res}`);
  }
}
const EXT_MESHOPT_COMPRESSION = "EXT_meshopt_compression";
const name$8 = EXT_MESHOPT_COMPRESSION;
async function decode$5(gltfData, options2) {
  var _a3, _b3;
  const scenegraph = new GLTFScenegraph(gltfData);
  if (!((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.decompressMeshes) || !((_b3 = options2.gltf) == null ? void 0 : _b3.loadBuffers)) {
    return;
  }
  const promises = [];
  for (const bufferViewIndex of gltfData.json.bufferViews || []) {
    promises.push(decodeMeshoptBufferView(scenegraph, bufferViewIndex));
  }
  await Promise.all(promises);
  scenegraph.removeExtension(EXT_MESHOPT_COMPRESSION);
}
async function decodeMeshoptBufferView(scenegraph, bufferView) {
  const meshoptExtension = scenegraph.getObjectExtension(bufferView, EXT_MESHOPT_COMPRESSION);
  if (meshoptExtension) {
    const { byteOffset = 0, byteLength = 0, byteStride, count: count3, mode: mode2, filter: filter17 = "NONE", buffer: bufferIndex } = meshoptExtension;
    const buffer3 = scenegraph.gltf.buffers[bufferIndex];
    const source = new Uint8Array(buffer3.arrayBuffer, buffer3.byteOffset + byteOffset, byteLength);
    const result = new Uint8Array(scenegraph.gltf.buffers[bufferView.buffer].arrayBuffer, bufferView.byteOffset, bufferView.byteLength);
    await meshoptDecodeGltfBuffer(result, count3, byteStride, source, mode2, filter17);
    scenegraph.removeObjectExtension(bufferView, EXT_MESHOPT_COMPRESSION);
  }
}
const EXT_meshopt_compression = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$5,
  name: name$8
}, Symbol.toStringTag, { value: "Module" }));
const EXT_TEXTURE_WEBP = "EXT_texture_webp";
const name$7 = EXT_TEXTURE_WEBP;
function preprocess$3(gltfData, options2) {
  const scenegraph = new GLTFScenegraph(gltfData);
  if (!isImageFormatSupported("image/webp")) {
    if (scenegraph.getRequiredExtensions().includes(EXT_TEXTURE_WEBP)) {
      throw new Error(`gltf: Required extension ${EXT_TEXTURE_WEBP} not supported by browser`);
    }
    return;
  }
  const { json } = scenegraph;
  for (const texture of json.textures || []) {
    const extension = scenegraph.getObjectExtension(texture, EXT_TEXTURE_WEBP);
    if (extension) {
      texture.source = extension.source;
    }
    scenegraph.removeObjectExtension(texture, EXT_TEXTURE_WEBP);
  }
  scenegraph.removeExtension(EXT_TEXTURE_WEBP);
}
const EXT_texture_webp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$7,
  preprocess: preprocess$3
}, Symbol.toStringTag, { value: "Module" }));
const KHR_TEXTURE_BASISU = "KHR_texture_basisu";
const name$6 = KHR_TEXTURE_BASISU;
function preprocess$2(gltfData, options2) {
  const scene = new GLTFScenegraph(gltfData);
  const { json } = scene;
  for (const texture of json.textures || []) {
    const extension = scene.getObjectExtension(texture, KHR_TEXTURE_BASISU);
    if (extension) {
      texture.source = extension.source;
      scene.removeObjectExtension(texture, KHR_TEXTURE_BASISU);
    }
  }
  scene.removeExtension(KHR_TEXTURE_BASISU);
}
const KHR_texture_basisu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: name$6,
  preprocess: preprocess$2
}, Symbol.toStringTag, { value: "Module" }));
function getGLTFAccessors(attributes) {
  const accessors = {};
  for (const name2 in attributes) {
    const attribute = attributes[name2];
    if (name2 !== "indices") {
      const glTFAccessor = getGLTFAccessor(attribute);
      accessors[name2] = glTFAccessor;
    }
  }
  return accessors;
}
function getGLTFAccessor(attribute) {
  const { buffer: buffer3, size: size12, count: count3 } = getAccessorData(attribute);
  const glTFAccessor = {
    // glTF Accessor values
    // TODO: Instead of a bufferView index we could have an actual buffer (typed array)
    // bufferView: null,
    // TODO: Deprecate `value` in favor of bufferView?
    // @ts-ignore
    value: buffer3,
    size: size12,
    // Decoded `type` (e.g. SCALAR)
    byteOffset: 0,
    count: count3,
    type: getAccessorTypeFromSize(size12),
    componentType: getComponentTypeFromArray(buffer3)
  };
  return glTFAccessor;
}
function getAccessorData(attribute) {
  let buffer3 = attribute;
  let size12 = 1;
  let count3 = 0;
  if (attribute && attribute.value) {
    buffer3 = attribute.value;
    size12 = attribute.size || 1;
  }
  if (buffer3) {
    if (!ArrayBuffer.isView(buffer3)) {
      buffer3 = toTypedArray(buffer3, Float32Array);
    }
    count3 = buffer3.length / size12;
  }
  return { buffer: buffer3, size: size12, count: count3 };
}
function toTypedArray(array2, ArrayType2, convertTypedArrays = false) {
  if (!array2) {
    return null;
  }
  if (Array.isArray(array2)) {
    return new ArrayType2(array2);
  }
  if (convertTypedArrays && !(array2 instanceof ArrayType2)) {
    return new ArrayType2(array2);
  }
  return array2;
}
const KHR_DRACO_MESH_COMPRESSION = "KHR_draco_mesh_compression";
const name$5 = KHR_DRACO_MESH_COMPRESSION;
function preprocess$1(gltfData, options2, context2) {
  const scenegraph = new GLTFScenegraph(gltfData);
  for (const primitive of makeMeshPrimitiveIterator(scenegraph)) {
    if (scenegraph.getObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION))
      ;
  }
}
async function decode$4(gltfData, options2, context2) {
  var _a3;
  if (!((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.decompressMeshes)) {
    return;
  }
  const scenegraph = new GLTFScenegraph(gltfData);
  const promises = [];
  for (const primitive of makeMeshPrimitiveIterator(scenegraph)) {
    if (scenegraph.getObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION)) {
      promises.push(decompressPrimitive(scenegraph, primitive, options2, context2));
    }
  }
  await Promise.all(promises);
  scenegraph.removeExtension(KHR_DRACO_MESH_COMPRESSION);
}
function encode$3(gltfData, options2 = {}) {
  const scenegraph = new GLTFScenegraph(gltfData);
  for (const mesh of scenegraph.json.meshes || []) {
    compressMesh(mesh);
    scenegraph.addRequiredExtension(KHR_DRACO_MESH_COMPRESSION);
  }
}
async function decompressPrimitive(scenegraph, primitive, options2, context2) {
  const dracoExtension = scenegraph.getObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION);
  if (!dracoExtension) {
    return;
  }
  const buffer3 = scenegraph.getTypedArrayForBufferView(dracoExtension.bufferView);
  const bufferCopy = sliceArrayBuffer(buffer3.buffer, buffer3.byteOffset);
  const dracoOptions = { ...options2 };
  delete dracoOptions["3d-tiles"];
  const decodedData = await parseFromContext(bufferCopy, DracoLoader, dracoOptions, context2);
  const decodedAttributes = getGLTFAccessors(decodedData.attributes);
  for (const [attributeName, decodedAttribute] of Object.entries(decodedAttributes)) {
    if (attributeName in primitive.attributes) {
      const accessorIndex = primitive.attributes[attributeName];
      const accessor = scenegraph.getAccessor(accessorIndex);
      if ((accessor == null ? void 0 : accessor.min) && (accessor == null ? void 0 : accessor.max)) {
        decodedAttribute.min = accessor.min;
        decodedAttribute.max = accessor.max;
      }
    }
  }
  primitive.attributes = decodedAttributes;
  if (decodedData.indices) {
    primitive.indices = getGLTFAccessor(decodedData.indices);
  }
  scenegraph.removeObjectExtension(primitive, KHR_DRACO_MESH_COMPRESSION);
  checkPrimitive(primitive);
}
function compressMesh(attributes, indices, mode2 = 4, options2, context2) {
  var _a3;
  if (!options2.DracoWriter) {
    throw new Error("options.gltf.DracoWriter not provided");
  }
  const compressedData = options2.DracoWriter.encodeSync({ attributes });
  const decodedData = (_a3 = context2 == null ? void 0 : context2.parseSync) == null ? void 0 : _a3.call(context2, { attributes });
  const fauxAccessors = options2._addFauxAttributes(decodedData.attributes);
  const bufferViewIndex = options2.addBufferView(compressedData);
  const glTFMesh = {
    primitives: [
      {
        attributes: fauxAccessors,
        // TODO - verify with spec
        mode: mode2,
        // GL.POINTS
        extensions: {
          [KHR_DRACO_MESH_COMPRESSION]: {
            bufferView: bufferViewIndex,
            attributes: fauxAccessors
            // TODO - verify with spec
          }
        }
      }
    ]
  };
  return glTFMesh;
}
function checkPrimitive(primitive) {
  if (!primitive.attributes && Object.keys(primitive.attributes).length > 0) {
    throw new Error("glTF: Empty primitive detected: Draco decompression failure?");
  }
}
function* makeMeshPrimitiveIterator(scenegraph) {
  for (const mesh of scenegraph.json.meshes || []) {
    for (const primitive of mesh.primitives) {
      yield primitive;
    }
  }
}
const KHR_draco_mesh_compression = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$4,
  encode: encode$3,
  name: name$5,
  preprocess: preprocess$1
}, Symbol.toStringTag, { value: "Module" }));
const KHR_TEXTURE_TRANSFORM = "KHR_texture_transform";
const name$4 = KHR_TEXTURE_TRANSFORM;
const scratchVector = new Vector3();
const scratchRotationMatrix = new Matrix3();
const scratchScaleMatrix = new Matrix3();
async function decode$3(gltfData, options2) {
  var _a3;
  const gltfScenegraph = new GLTFScenegraph(gltfData);
  const hasExtension = gltfScenegraph.hasExtension(KHR_TEXTURE_TRANSFORM);
  if (!hasExtension || !((_a3 = options2.gltf) == null ? void 0 : _a3.loadBuffers)) {
    return;
  }
  const materials = gltfData.json.materials || [];
  for (let i2 = 0; i2 < materials.length; i2++) {
    transformTexCoords(i2, gltfData);
  }
}
function transformTexCoords(materialIndex, gltfData) {
  var _a3, _b3, _c2, _d2;
  const material = (_a3 = gltfData.json.materials) == null ? void 0 : _a3[materialIndex];
  const materialTextures = [
    (_b3 = material == null ? void 0 : material.pbrMetallicRoughness) == null ? void 0 : _b3.baseColorTexture,
    material == null ? void 0 : material.emissiveTexture,
    material == null ? void 0 : material.normalTexture,
    material == null ? void 0 : material.occlusionTexture,
    (_c2 = material == null ? void 0 : material.pbrMetallicRoughness) == null ? void 0 : _c2.metallicRoughnessTexture
  ];
  const processedTexCoords = [];
  for (const textureInfo of materialTextures) {
    if (textureInfo && ((_d2 = textureInfo == null ? void 0 : textureInfo.extensions) == null ? void 0 : _d2[KHR_TEXTURE_TRANSFORM])) {
      transformPrimitives(gltfData, materialIndex, textureInfo, processedTexCoords);
    }
  }
}
function transformPrimitives(gltfData, materialIndex, texture, processedTexCoords) {
  const transformParameters = getTransformParameters(texture, processedTexCoords);
  if (!transformParameters) {
    return;
  }
  const meshes = gltfData.json.meshes || [];
  for (const mesh of meshes) {
    for (const primitive of mesh.primitives) {
      const material = primitive.material;
      if (Number.isFinite(material) && materialIndex === material) {
        transformPrimitive(gltfData, primitive, transformParameters);
      }
    }
  }
}
function getTransformParameters(texture, processedTexCoords) {
  var _a3;
  const textureInfo = (_a3 = texture.extensions) == null ? void 0 : _a3[KHR_TEXTURE_TRANSFORM];
  const { texCoord: originalTexCoord = 0 } = texture;
  const { texCoord = originalTexCoord } = textureInfo;
  const isProcessed = processedTexCoords.findIndex(([original, newTexCoord]) => original === originalTexCoord && newTexCoord === texCoord) !== -1;
  if (!isProcessed) {
    const matrix = makeTransformationMatrix(textureInfo);
    if (originalTexCoord !== texCoord) {
      texture.texCoord = texCoord;
    }
    processedTexCoords.push([originalTexCoord, texCoord]);
    return { originalTexCoord, texCoord, matrix };
  }
  return null;
}
function transformPrimitive(gltfData, primitive, transformParameters) {
  var _a3, _b3;
  const { originalTexCoord, texCoord, matrix } = transformParameters;
  const texCoordAccessor = primitive.attributes[`TEXCOORD_${originalTexCoord}`];
  if (Number.isFinite(texCoordAccessor)) {
    const accessor = (_a3 = gltfData.json.accessors) == null ? void 0 : _a3[texCoordAccessor];
    if (accessor && accessor.bufferView) {
      const bufferView = (_b3 = gltfData.json.bufferViews) == null ? void 0 : _b3[accessor.bufferView];
      if (bufferView) {
        const { arrayBuffer: arrayBuffer2, byteOffset: bufferByteOffset } = gltfData.buffers[bufferView.buffer];
        const byteOffset = (bufferByteOffset || 0) + (accessor.byteOffset || 0) + (bufferView.byteOffset || 0);
        const { ArrayType: ArrayType2, length: length2 } = getAccessorArrayTypeAndLength(accessor, bufferView);
        const bytes = BYTES$1[accessor.componentType];
        const components = COMPONENTS$1[accessor.type];
        const elementAddressScale = bufferView.byteStride || bytes * components;
        const result = new Float32Array(length2);
        for (let i2 = 0; i2 < accessor.count; i2++) {
          const uv = new ArrayType2(arrayBuffer2, byteOffset + i2 * elementAddressScale, 2);
          scratchVector.set(uv[0], uv[1], 1);
          scratchVector.transformByMatrix3(matrix);
          result.set([scratchVector[0], scratchVector[1]], i2 * components);
        }
        if (originalTexCoord === texCoord) {
          updateGltf(accessor, bufferView, gltfData.buffers, result);
        } else {
          createAttribute(texCoord, accessor, primitive, gltfData, result);
        }
      }
    }
  }
}
function updateGltf(accessor, bufferView, buffers, newTexCoordArray) {
  accessor.componentType = 5126;
  buffers.push({
    arrayBuffer: newTexCoordArray.buffer,
    byteOffset: 0,
    byteLength: newTexCoordArray.buffer.byteLength
  });
  bufferView.buffer = buffers.length - 1;
  bufferView.byteLength = newTexCoordArray.buffer.byteLength;
  bufferView.byteOffset = 0;
  delete bufferView.byteStride;
}
function createAttribute(newTexCoord, originalAccessor, primitive, gltfData, newTexCoordArray) {
  gltfData.buffers.push({
    arrayBuffer: newTexCoordArray.buffer,
    byteOffset: 0,
    byteLength: newTexCoordArray.buffer.byteLength
  });
  const bufferViews = gltfData.json.bufferViews;
  if (!bufferViews) {
    return;
  }
  bufferViews.push({
    buffer: gltfData.buffers.length - 1,
    byteLength: newTexCoordArray.buffer.byteLength,
    byteOffset: 0
  });
  const accessors = gltfData.json.accessors;
  if (!accessors) {
    return;
  }
  accessors.push({
    bufferView: (bufferViews == null ? void 0 : bufferViews.length) - 1,
    byteOffset: 0,
    componentType: 5126,
    count: originalAccessor.count,
    type: "VEC2"
  });
  primitive.attributes[`TEXCOORD_${newTexCoord}`] = accessors.length - 1;
}
function makeTransformationMatrix(extensionData) {
  const { offset = [0, 0], rotation = 0, scale: scale5 = [1, 1] } = extensionData;
  const translationMatrix = new Matrix3().set(1, 0, 0, 0, 1, 0, offset[0], offset[1], 1);
  const rotationMatrix = scratchRotationMatrix.set(Math.cos(rotation), Math.sin(rotation), 0, -Math.sin(rotation), Math.cos(rotation), 0, 0, 0, 1);
  const scaleMatrix = scratchScaleMatrix.set(scale5[0], 0, 0, 0, scale5[1], 0, 0, 0, 1);
  return translationMatrix.multiplyRight(rotationMatrix).multiplyRight(scaleMatrix);
}
const KHR_texture_transform = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$3,
  name: name$4
}, Symbol.toStringTag, { value: "Module" }));
const KHR_LIGHTS_PUNCTUAL = "KHR_lights_punctual";
const name$3 = KHR_LIGHTS_PUNCTUAL;
async function decode$2(gltfData) {
  const gltfScenegraph = new GLTFScenegraph(gltfData);
  const { json } = gltfScenegraph;
  const extension = gltfScenegraph.getExtension(KHR_LIGHTS_PUNCTUAL);
  if (extension) {
    gltfScenegraph.json.lights = extension.lights;
    gltfScenegraph.removeExtension(KHR_LIGHTS_PUNCTUAL);
  }
  for (const node of json.nodes || []) {
    const nodeExtension = gltfScenegraph.getObjectExtension(node, KHR_LIGHTS_PUNCTUAL);
    if (nodeExtension) {
      node.light = nodeExtension.light;
    }
    gltfScenegraph.removeObjectExtension(node, KHR_LIGHTS_PUNCTUAL);
  }
}
async function encode$2(gltfData) {
  const gltfScenegraph = new GLTFScenegraph(gltfData);
  const { json } = gltfScenegraph;
  if (json.lights) {
    const extension = gltfScenegraph.addExtension(KHR_LIGHTS_PUNCTUAL);
    assert$1(!extension.lights);
    extension.lights = json.lights;
    delete json.lights;
  }
  if (gltfScenegraph.json.lights) {
    for (const light of gltfScenegraph.json.lights) {
      const node = light.node;
      gltfScenegraph.addObjectExtension(node, KHR_LIGHTS_PUNCTUAL, light);
    }
    delete gltfScenegraph.json.lights;
  }
}
const KHR_lights_punctual = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$2,
  encode: encode$2,
  name: name$3
}, Symbol.toStringTag, { value: "Module" }));
const KHR_MATERIALS_UNLIT = "KHR_materials_unlit";
const name$2 = KHR_MATERIALS_UNLIT;
async function decode$1(gltfData) {
  const gltfScenegraph = new GLTFScenegraph(gltfData);
  const { json } = gltfScenegraph;
  for (const material of json.materials || []) {
    const extension = material.extensions && material.extensions.KHR_materials_unlit;
    if (extension) {
      material.unlit = true;
    }
    gltfScenegraph.removeObjectExtension(material, KHR_MATERIALS_UNLIT);
  }
  gltfScenegraph.removeExtension(KHR_MATERIALS_UNLIT);
}
function encode$1(gltfData) {
  const gltfScenegraph = new GLTFScenegraph(gltfData);
  const { json } = gltfScenegraph;
  if (gltfScenegraph.materials) {
    for (const material of json.materials || []) {
      if (material.unlit) {
        delete material.unlit;
        gltfScenegraph.addObjectExtension(material, KHR_MATERIALS_UNLIT, {});
        gltfScenegraph.addExtension(KHR_MATERIALS_UNLIT);
      }
    }
  }
}
const KHR_materials_unlit = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: decode$1,
  encode: encode$1,
  name: name$2
}, Symbol.toStringTag, { value: "Module" }));
const KHR_TECHNIQUES_WEBGL = "KHR_techniques_webgl";
const name$1 = KHR_TECHNIQUES_WEBGL;
async function decode(gltfData) {
  const gltfScenegraph = new GLTFScenegraph(gltfData);
  const { json } = gltfScenegraph;
  const extension = gltfScenegraph.getExtension(KHR_TECHNIQUES_WEBGL);
  if (extension) {
    const techniques = resolveTechniques(extension, gltfScenegraph);
    for (const material of json.materials || []) {
      const materialExtension = gltfScenegraph.getObjectExtension(material, KHR_TECHNIQUES_WEBGL);
      if (materialExtension) {
        material.technique = Object.assign(
          {},
          materialExtension,
          // @ts-ignore
          techniques[materialExtension.technique]
        );
        material.technique.values = resolveValues(material.technique, gltfScenegraph);
      }
      gltfScenegraph.removeObjectExtension(material, KHR_TECHNIQUES_WEBGL);
    }
    gltfScenegraph.removeExtension(KHR_TECHNIQUES_WEBGL);
  }
}
async function encode(gltfData, options2) {
}
function resolveTechniques(techniquesExtension, gltfScenegraph) {
  const { programs = [], shaders = [], techniques = [] } = techniquesExtension;
  const textDecoder = new TextDecoder();
  shaders.forEach((shader) => {
    if (Number.isFinite(shader.bufferView)) {
      shader.code = textDecoder.decode(gltfScenegraph.getTypedArrayForBufferView(shader.bufferView));
    } else {
      throw new Error("KHR_techniques_webgl: no shader code");
    }
  });
  programs.forEach((program) => {
    program.fragmentShader = shaders[program.fragmentShader];
    program.vertexShader = shaders[program.vertexShader];
  });
  techniques.forEach((technique) => {
    technique.program = programs[technique.program];
  });
  return techniques;
}
function resolveValues(technique, gltfScenegraph) {
  const values4 = Object.assign({}, technique.values);
  Object.keys(technique.uniforms || {}).forEach((uniform) => {
    if (technique.uniforms[uniform].value && !(uniform in values4)) {
      values4[uniform] = technique.uniforms[uniform].value;
    }
  });
  Object.keys(values4).forEach((uniform) => {
    if (typeof values4[uniform] === "object" && values4[uniform].index !== void 0) {
      values4[uniform].texture = gltfScenegraph.getTexture(values4[uniform].index);
    }
  });
  return values4;
}
const KHR_techniques_webgl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode,
  encode,
  name: name$1
}, Symbol.toStringTag, { value: "Module" }));
const EXTENSIONS$6 = [
  // 1.0
  // KHR_binary_gltf is handled separately - must be processed before other parsing starts
  // KHR_binary_gltf,
  // 2.0
  EXT_structural_metadata,
  EXT_mesh_features,
  EXT_meshopt_compression,
  EXT_texture_webp,
  // Basisu should come after webp, we want basisu to be preferred if both are provided
  KHR_texture_basisu,
  KHR_draco_mesh_compression,
  KHR_lights_punctual,
  KHR_materials_unlit,
  KHR_techniques_webgl,
  KHR_texture_transform,
  EXT_feature_metadata
];
function preprocessExtensions(gltf, options2 = {}, context2) {
  var _a3;
  const extensions = EXTENSIONS$6.filter((extension) => useExtension(extension.name, options2));
  for (const extension of extensions) {
    (_a3 = extension.preprocess) == null ? void 0 : _a3.call(extension, gltf, options2, context2);
  }
}
async function decodeExtensions(gltf, options2 = {}, context2) {
  var _a3;
  const extensions = EXTENSIONS$6.filter((extension) => useExtension(extension.name, options2));
  for (const extension of extensions) {
    await ((_a3 = extension.decode) == null ? void 0 : _a3.call(extension, gltf, options2, context2));
  }
}
function useExtension(extensionName, options2) {
  var _a3;
  const excludes = ((_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.excludeExtensions) || {};
  const exclude = extensionName in excludes && !excludes[extensionName];
  return !exclude;
}
const KHR_BINARY_GLTF = "KHR_binary_glTF";
function preprocess(gltfData) {
  const gltfScenegraph = new GLTFScenegraph(gltfData);
  const { json } = gltfScenegraph;
  for (const image of json.images || []) {
    const extension = gltfScenegraph.getObjectExtension(image, KHR_BINARY_GLTF);
    if (extension) {
      Object.assign(image, extension);
    }
    gltfScenegraph.removeObjectExtension(image, KHR_BINARY_GLTF);
  }
  if (json.buffers && json.buffers[0]) {
    delete json.buffers[0].uri;
  }
  gltfScenegraph.removeExtension(KHR_BINARY_GLTF);
}
const GLTF_ARRAYS = {
  accessors: "accessor",
  animations: "animation",
  buffers: "buffer",
  bufferViews: "bufferView",
  images: "image",
  materials: "material",
  meshes: "mesh",
  nodes: "node",
  samplers: "sampler",
  scenes: "scene",
  skins: "skin",
  textures: "texture"
};
const GLTF_KEYS = {
  accessor: "accessors",
  animations: "animation",
  buffer: "buffers",
  bufferView: "bufferViews",
  image: "images",
  material: "materials",
  mesh: "meshes",
  node: "nodes",
  sampler: "samplers",
  scene: "scenes",
  skin: "skins",
  texture: "textures"
};
class GLTFV1Normalizer {
  constructor() {
    __publicField2(this, "idToIndexMap", {
      animations: {},
      accessors: {},
      buffers: {},
      bufferViews: {},
      images: {},
      materials: {},
      meshes: {},
      nodes: {},
      samplers: {},
      scenes: {},
      skins: {},
      textures: {}
    });
    __publicField2(this, "json");
  }
  // constructor() {}
  /**
   * Convert (normalize) glTF < 2.0 to glTF 2.0
   * @param gltf - object with json and binChunks
   * @param options
   * @param options normalize Whether to actually normalize
   */
  normalize(gltf, options2) {
    this.json = gltf.json;
    const json = gltf.json;
    switch (json.asset && json.asset.version) {
      case "2.0":
        return;
      case void 0:
      case "1.0":
        break;
      default:
        console.warn(`glTF: Unknown version ${json.asset.version}`);
        return;
    }
    if (!options2.normalize) {
      throw new Error("glTF v1 is not supported.");
    }
    console.warn("Converting glTF v1 to glTF v2 format. This is experimental and may fail.");
    this._addAsset(json);
    this._convertTopLevelObjectsToArrays(json);
    preprocess(gltf);
    this._convertObjectIdsToArrayIndices(json);
    this._updateObjects(json);
    this._updateMaterial(json);
  }
  // asset is now required, #642 https://github.com/KhronosGroup/glTF/issues/639
  _addAsset(json) {
    json.asset = json.asset || {};
    json.asset.version = "2.0";
    json.asset.generator = json.asset.generator || "Normalized to glTF 2.0 by loaders.gl";
  }
  _convertTopLevelObjectsToArrays(json) {
    for (const arrayName in GLTF_ARRAYS) {
      this._convertTopLevelObjectToArray(json, arrayName);
    }
  }
  /** Convert one top level object to array */
  _convertTopLevelObjectToArray(json, mapName) {
    const objectMap2 = json[mapName];
    if (!objectMap2 || Array.isArray(objectMap2)) {
      return;
    }
    json[mapName] = [];
    for (const id in objectMap2) {
      const object2 = objectMap2[id];
      object2.id = object2.id || id;
      const index2 = json[mapName].length;
      json[mapName].push(object2);
      this.idToIndexMap[mapName][id] = index2;
    }
  }
  /** Go through all objects in all top-level arrays and replace ids with indices */
  _convertObjectIdsToArrayIndices(json) {
    for (const arrayName in GLTF_ARRAYS) {
      this._convertIdsToIndices(json, arrayName);
    }
    if ("scene" in json) {
      json.scene = this._convertIdToIndex(json.scene, "scene");
    }
    for (const texture of json.textures) {
      this._convertTextureIds(texture);
    }
    for (const mesh of json.meshes) {
      this._convertMeshIds(mesh);
    }
    for (const node of json.nodes) {
      this._convertNodeIds(node);
    }
    for (const node of json.scenes) {
      this._convertSceneIds(node);
    }
  }
  _convertTextureIds(texture) {
    if (texture.source) {
      texture.source = this._convertIdToIndex(texture.source, "image");
    }
  }
  _convertMeshIds(mesh) {
    for (const primitive of mesh.primitives) {
      const { attributes, indices, material } = primitive;
      for (const attributeName in attributes) {
        attributes[attributeName] = this._convertIdToIndex(attributes[attributeName], "accessor");
      }
      if (indices) {
        primitive.indices = this._convertIdToIndex(indices, "accessor");
      }
      if (material) {
        primitive.material = this._convertIdToIndex(material, "material");
      }
    }
  }
  _convertNodeIds(node) {
    if (node.children) {
      node.children = node.children.map((child) => this._convertIdToIndex(child, "node"));
    }
    if (node.meshes) {
      node.meshes = node.meshes.map((mesh) => this._convertIdToIndex(mesh, "mesh"));
    }
  }
  _convertSceneIds(scene) {
    if (scene.nodes) {
      scene.nodes = scene.nodes.map((node) => this._convertIdToIndex(node, "node"));
    }
  }
  /** Go through all objects in a top-level array and replace ids with indices */
  _convertIdsToIndices(json, topLevelArrayName) {
    if (!json[topLevelArrayName]) {
      console.warn(`gltf v1: json doesn't contain attribute ${topLevelArrayName}`);
      json[topLevelArrayName] = [];
    }
    for (const object2 of json[topLevelArrayName]) {
      for (const key in object2) {
        const id = object2[key];
        const index2 = this._convertIdToIndex(id, key);
        object2[key] = index2;
      }
    }
  }
  _convertIdToIndex(id, key) {
    const arrayName = GLTF_KEYS[key];
    if (arrayName in this.idToIndexMap) {
      const index2 = this.idToIndexMap[arrayName][id];
      if (!Number.isFinite(index2)) {
        throw new Error(`gltf v1: failed to resolve ${key} with id ${id}`);
      }
      return index2;
    }
    return id;
  }
  /**
   *
   * @param {*} json
   */
  _updateObjects(json) {
    for (const buffer3 of this.json.buffers) {
      delete buffer3.type;
    }
  }
  /**
   * Update material (set pbrMetallicRoughness)
   * @param {*} json
   */
  _updateMaterial(json) {
    var _a3, _b3, _c2;
    for (const material of json.materials) {
      material.pbrMetallicRoughness = {
        baseColorFactor: [1, 1, 1, 1],
        metallicFactor: 1,
        roughnessFactor: 1
      };
      const textureId2 = ((_a3 = material.values) == null ? void 0 : _a3.tex) || ((_b3 = material.values) == null ? void 0 : _b3.texture2d_0) || ((_c2 = material.values) == null ? void 0 : _c2.diffuseTex);
      const textureIndex = json.textures.findIndex((texture) => texture.id === textureId2);
      if (textureIndex !== -1) {
        material.pbrMetallicRoughness.baseColorTexture = { index: textureIndex };
      }
    }
  }
}
function normalizeGLTFV1(gltf, options2 = {}) {
  return new GLTFV1Normalizer().normalize(gltf, options2);
}
async function parseGLTF(gltf, arrayBufferOrString, byteOffset = 0, options2, context2) {
  var _a3, _b3, _c2;
  parseGLTFContainerSync(gltf, arrayBufferOrString, byteOffset, options2);
  normalizeGLTFV1(gltf, { normalize: (_a3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _a3.normalize });
  preprocessExtensions(gltf, options2, context2);
  if (((_b3 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _b3.loadBuffers) && gltf.json.buffers) {
    await loadBuffers(gltf, options2, context2);
  }
  if ((_c2 = options2 == null ? void 0 : options2.gltf) == null ? void 0 : _c2.loadImages) {
    await loadImages(gltf, options2, context2);
  }
  await decodeExtensions(gltf, options2, context2);
  return gltf;
}
function parseGLTFContainerSync(gltf, data2, byteOffset, options2) {
  if (options2.uri) {
    gltf.baseUri = options2.uri;
  }
  if (data2 instanceof ArrayBuffer && !isGLB(data2, byteOffset, options2)) {
    const textDecoder = new TextDecoder();
    data2 = textDecoder.decode(data2);
  }
  if (typeof data2 === "string") {
    gltf.json = parseJSON(data2);
  } else if (data2 instanceof ArrayBuffer) {
    const glb = {};
    byteOffset = parseGLBSync(glb, data2, byteOffset, options2.glb);
    assert$1(glb.type === "glTF", `Invalid GLB magic string ${glb.type}`);
    gltf._glb = glb;
    gltf.json = glb.json;
  } else {
    assert$1(false, "GLTF: must be ArrayBuffer or string");
  }
  const buffers = gltf.json.buffers || [];
  gltf.buffers = new Array(buffers.length).fill(null);
  if (gltf._glb && gltf._glb.header.hasBinChunk) {
    const { binChunks } = gltf._glb;
    gltf.buffers[0] = {
      arrayBuffer: binChunks[0].arrayBuffer,
      byteOffset: binChunks[0].byteOffset,
      byteLength: binChunks[0].byteLength
    };
  }
  const images = gltf.json.images || [];
  gltf.images = new Array(images.length).fill({});
}
async function loadBuffers(gltf, options2, context2) {
  var _a3, _b3;
  const buffers = gltf.json.buffers || [];
  for (let i2 = 0; i2 < buffers.length; ++i2) {
    const buffer3 = buffers[i2];
    if (buffer3.uri) {
      const { fetch: fetch2 } = context2;
      assert$1(fetch2);
      const uri = resolveUrl(buffer3.uri, options2);
      const response = await ((_a3 = context2 == null ? void 0 : context2.fetch) == null ? void 0 : _a3.call(context2, uri));
      const arrayBuffer2 = await ((_b3 = response == null ? void 0 : response.arrayBuffer) == null ? void 0 : _b3.call(response));
      gltf.buffers[i2] = {
        arrayBuffer: arrayBuffer2,
        byteOffset: 0,
        byteLength: arrayBuffer2.byteLength
      };
      delete buffer3.uri;
    } else if (gltf.buffers[i2] === null) {
      gltf.buffers[i2] = {
        arrayBuffer: new ArrayBuffer(buffer3.byteLength),
        byteOffset: 0,
        byteLength: buffer3.byteLength
      };
    }
  }
}
async function loadImages(gltf, options2, context2) {
  const imageIndices = getReferencesImageIndices(gltf);
  const images = gltf.json.images || [];
  const promises = [];
  for (const imageIndex of imageIndices) {
    promises.push(loadImage(gltf, images[imageIndex], imageIndex, options2, context2));
  }
  return await Promise.all(promises);
}
function getReferencesImageIndices(gltf) {
  const imageIndices = /* @__PURE__ */ new Set();
  const textures = gltf.json.textures || [];
  for (const texture of textures) {
    if (texture.source !== void 0) {
      imageIndices.add(texture.source);
    }
  }
  return Array.from(imageIndices).sort();
}
async function loadImage(gltf, image, index2, options2, context2) {
  let arrayBuffer2;
  if (image.uri && !image.hasOwnProperty("bufferView")) {
    const uri = resolveUrl(image.uri, options2);
    const { fetch: fetch2 } = context2;
    const response = await fetch2(uri);
    arrayBuffer2 = await response.arrayBuffer();
    image.bufferView = {
      data: arrayBuffer2
    };
  }
  if (Number.isFinite(image.bufferView)) {
    const array2 = getTypedArrayForBufferView(gltf.json, gltf.buffers, image.bufferView);
    arrayBuffer2 = sliceArrayBuffer(array2.buffer, array2.byteOffset, array2.byteLength);
  }
  assert$1(arrayBuffer2, "glTF image has no data");
  let parsedImage = await parseFromContext(arrayBuffer2, [ImageLoader, BasisLoader], {
    ...options2,
    mimeType: image.mimeType,
    basis: options2.basis || { format: selectSupportedBasisFormat() }
  }, context2);
  if (parsedImage && parsedImage[0]) {
    parsedImage = {
      compressed: true,
      // @ts-expect-error
      mipmaps: false,
      width: parsedImage[0].width,
      height: parsedImage[0].height,
      data: parsedImage[0]
    };
  }
  gltf.images = gltf.images || [];
  gltf.images[index2] = parsedImage;
}
const GLTFLoader$1 = {
  dataType: null,
  batchType: null,
  name: "glTF",
  id: "gltf",
  module: "gltf",
  version: VERSION$1,
  extensions: ["gltf", "glb"],
  mimeTypes: ["model/gltf+json", "model/gltf-binary"],
  text: true,
  binary: true,
  tests: ["glTF"],
  parse: parse$2,
  options: {
    gltf: {
      normalize: true,
      // Normalize glTF v1 to glTF v2 format (not yet stable)
      loadBuffers: true,
      // Fetch any linked .BIN buffers, decode base64
      loadImages: true,
      // Create image objects
      decompressMeshes: true
      // Decompress Draco encoded meshes
    },
    // common?
    log: console
    // eslint-disable-line
  }
};
async function parse$2(arrayBuffer2, options2 = {}, context2) {
  options2 = { ...GLTFLoader$1.options, ...options2 };
  options2.gltf = { ...GLTFLoader$1.options.gltf, ...options2.gltf };
  const { byteOffset = 0 } = options2;
  const gltf = {};
  return await parseGLTF(gltf, arrayBuffer2, byteOffset, options2, context2);
}
const COMPONENTS = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
};
const BYTES = {
  5120: 1,
  // BYTE
  5121: 1,
  // UNSIGNED_BYTE
  5122: 2,
  // SHORT
  5123: 2,
  // UNSIGNED_SHORT
  5125: 4,
  // UNSIGNED_INT
  5126: 4
  // FLOAT
};
const GL_SAMPLER = {
  // Sampler parameters
  TEXTURE_MAG_FILTER: 10240,
  TEXTURE_MIN_FILTER: 10241,
  TEXTURE_WRAP_S: 10242,
  TEXTURE_WRAP_T: 10243,
  // Sampler default values
  REPEAT: 10497,
  LINEAR: 9729,
  NEAREST_MIPMAP_LINEAR: 9986
};
const SAMPLER_PARAMETER_GLTF_TO_GL = {
  magFilter: GL_SAMPLER.TEXTURE_MAG_FILTER,
  minFilter: GL_SAMPLER.TEXTURE_MIN_FILTER,
  wrapS: GL_SAMPLER.TEXTURE_WRAP_S,
  wrapT: GL_SAMPLER.TEXTURE_WRAP_T
};
const DEFAULT_SAMPLER_PARAMETERS = {
  [GL_SAMPLER.TEXTURE_MAG_FILTER]: GL_SAMPLER.LINEAR,
  [GL_SAMPLER.TEXTURE_MIN_FILTER]: GL_SAMPLER.NEAREST_MIPMAP_LINEAR,
  [GL_SAMPLER.TEXTURE_WRAP_S]: GL_SAMPLER.REPEAT,
  [GL_SAMPLER.TEXTURE_WRAP_T]: GL_SAMPLER.REPEAT
};
function makeDefaultSampler() {
  return {
    id: "default-sampler",
    parameters: DEFAULT_SAMPLER_PARAMETERS
  };
}
function getBytesFromComponentType(componentType) {
  return BYTES[componentType];
}
function getSizeFromAccessorType(type) {
  return COMPONENTS[type];
}
class GLTFPostProcessor {
  constructor() {
    __publicField2(this, "baseUri", "");
    // @ts-expect-error
    __publicField2(this, "jsonUnprocessed");
    // @ts-expect-error
    __publicField2(this, "json");
    __publicField2(this, "buffers", []);
    __publicField2(this, "images", []);
  }
  postProcess(gltf, options2 = {}) {
    const { json, buffers = [], images = [] } = gltf;
    const { baseUri = "" } = gltf;
    assert$1(json);
    this.baseUri = baseUri;
    this.buffers = buffers;
    this.images = images;
    this.jsonUnprocessed = json;
    this.json = this._resolveTree(gltf.json, options2);
    return this.json;
  }
  // Convert indexed glTF structure into tree structure
  // cross-link index resolution, enum lookup, convenience calculations
  // eslint-disable-next-line complexity, max-statements
  _resolveTree(gltf, options2 = {}) {
    const json = { ...gltf };
    this.json = json;
    if (gltf.bufferViews) {
      json.bufferViews = gltf.bufferViews.map((bufView, i2) => this._resolveBufferView(bufView, i2));
    }
    if (gltf.images) {
      json.images = gltf.images.map((image, i2) => this._resolveImage(image, i2));
    }
    if (gltf.samplers) {
      json.samplers = gltf.samplers.map((sampler, i2) => this._resolveSampler(sampler, i2));
    }
    if (gltf.textures) {
      json.textures = gltf.textures.map((texture, i2) => this._resolveTexture(texture, i2));
    }
    if (gltf.accessors) {
      json.accessors = gltf.accessors.map((accessor, i2) => this._resolveAccessor(accessor, i2));
    }
    if (gltf.materials) {
      json.materials = gltf.materials.map((material, i2) => this._resolveMaterial(material, i2));
    }
    if (gltf.meshes) {
      json.meshes = gltf.meshes.map((mesh, i2) => this._resolveMesh(mesh, i2));
    }
    if (gltf.nodes) {
      json.nodes = gltf.nodes.map((node, i2) => this._resolveNode(node, i2));
      json.nodes = json.nodes.map((node, i2) => this._resolveNodeChildren(node));
    }
    if (gltf.skins) {
      json.skins = gltf.skins.map((skin, i2) => this._resolveSkin(skin, i2));
    }
    if (gltf.scenes) {
      json.scenes = gltf.scenes.map((scene, i2) => this._resolveScene(scene, i2));
    }
    if (typeof this.json.scene === "number" && json.scenes) {
      json.scene = json.scenes[this.json.scene];
    }
    return json;
  }
  getScene(index2) {
    return this._get(this.json.scenes, index2);
  }
  getNode(index2) {
    return this._get(this.json.nodes, index2);
  }
  getSkin(index2) {
    return this._get(this.json.skins, index2);
  }
  getMesh(index2) {
    return this._get(this.json.meshes, index2);
  }
  getMaterial(index2) {
    return this._get(this.json.materials, index2);
  }
  getAccessor(index2) {
    return this._get(this.json.accessors, index2);
  }
  getCamera(index2) {
    return this._get(this.json.cameras, index2);
  }
  getTexture(index2) {
    return this._get(this.json.textures, index2);
  }
  getSampler(index2) {
    return this._get(this.json.samplers, index2);
  }
  getImage(index2) {
    return this._get(this.json.images, index2);
  }
  getBufferView(index2) {
    return this._get(this.json.bufferViews, index2);
  }
  getBuffer(index2) {
    return this._get(this.json.buffers, index2);
  }
  _get(array2, index2) {
    if (typeof index2 === "object") {
      return index2;
    }
    const object2 = array2 && array2[index2];
    if (!object2) {
      console.warn(`glTF file error: Could not find ${array2}[${index2}]`);
    }
    return object2;
  }
  // PARSING HELPERS
  _resolveScene(scene, index2) {
    return {
      ...scene,
      // @ts-ignore
      id: scene.id || `scene-${index2}`,
      nodes: (scene.nodes || []).map((node) => this.getNode(node))
    };
  }
  _resolveNode(gltfNode, index2) {
    const node = {
      ...gltfNode,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: (gltfNode == null ? void 0 : gltfNode.id) || `node-${index2}`
    };
    if (gltfNode.mesh !== void 0) {
      node.mesh = this.getMesh(gltfNode.mesh);
    }
    if (gltfNode.camera !== void 0) {
      node.camera = this.getCamera(gltfNode.camera);
    }
    if (gltfNode.skin !== void 0) {
      node.skin = this.getSkin(gltfNode.skin);
    }
    if (gltfNode.meshes !== void 0 && gltfNode.meshes.length) {
      node.mesh = gltfNode.meshes.reduce((accum, meshIndex) => {
        const mesh = this.getMesh(meshIndex);
        accum.id = mesh.id;
        accum.primitives = accum.primitives.concat(mesh.primitives);
        return accum;
      }, { primitives: [] });
    }
    return node;
  }
  _resolveNodeChildren(node) {
    if (node.children) {
      node.children = node.children.map((child) => this.getNode(child));
    }
    return node;
  }
  _resolveSkin(gltfSkin, index2) {
    const inverseBindMatrices = typeof gltfSkin.inverseBindMatrices === "number" ? this.getAccessor(gltfSkin.inverseBindMatrices) : void 0;
    return {
      ...gltfSkin,
      id: gltfSkin.id || `skin-${index2}`,
      inverseBindMatrices
    };
  }
  _resolveMesh(gltfMesh, index2) {
    const mesh = {
      ...gltfMesh,
      id: gltfMesh.id || `mesh-${index2}`,
      primitives: []
    };
    if (gltfMesh.primitives) {
      mesh.primitives = gltfMesh.primitives.map((gltfPrimitive) => {
        const primitive = {
          ...gltfPrimitive,
          attributes: {},
          indices: void 0,
          material: void 0
        };
        const attributes = gltfPrimitive.attributes;
        for (const attribute in attributes) {
          primitive.attributes[attribute] = this.getAccessor(attributes[attribute]);
        }
        if (gltfPrimitive.indices !== void 0) {
          primitive.indices = this.getAccessor(gltfPrimitive.indices);
        }
        if (gltfPrimitive.material !== void 0) {
          primitive.material = this.getMaterial(gltfPrimitive.material);
        }
        return primitive;
      });
    }
    return mesh;
  }
  _resolveMaterial(gltfMaterial, index2) {
    const material = {
      ...gltfMaterial,
      // @ts-expect-error
      id: gltfMaterial.id || `material-${index2}`
    };
    if (material.normalTexture) {
      material.normalTexture = { ...material.normalTexture };
      material.normalTexture.texture = this.getTexture(material.normalTexture.index);
    }
    if (material.occlusionTexture) {
      material.occlusionTexture = { ...material.occlusionTexture };
      material.occlusionTexture.texture = this.getTexture(material.occlusionTexture.index);
    }
    if (material.emissiveTexture) {
      material.emissiveTexture = { ...material.emissiveTexture };
      material.emissiveTexture.texture = this.getTexture(material.emissiveTexture.index);
    }
    if (!material.emissiveFactor) {
      material.emissiveFactor = material.emissiveTexture ? [1, 1, 1] : [0, 0, 0];
    }
    if (material.pbrMetallicRoughness) {
      material.pbrMetallicRoughness = { ...material.pbrMetallicRoughness };
      const mr = material.pbrMetallicRoughness;
      if (mr.baseColorTexture) {
        mr.baseColorTexture = { ...mr.baseColorTexture };
        mr.baseColorTexture.texture = this.getTexture(mr.baseColorTexture.index);
      }
      if (mr.metallicRoughnessTexture) {
        mr.metallicRoughnessTexture = { ...mr.metallicRoughnessTexture };
        mr.metallicRoughnessTexture.texture = this.getTexture(mr.metallicRoughnessTexture.index);
      }
    }
    return material;
  }
  _resolveAccessor(gltfAccessor, index2) {
    const bytesPerComponent = getBytesFromComponentType(gltfAccessor.componentType);
    const components = getSizeFromAccessorType(gltfAccessor.type);
    const bytesPerElement = bytesPerComponent * components;
    const accessor = {
      ...gltfAccessor,
      // @ts-expect-error
      id: gltfAccessor.id || `accessor-${index2}`,
      bytesPerComponent,
      components,
      bytesPerElement,
      value: void 0,
      bufferView: void 0,
      sparse: void 0
    };
    if (gltfAccessor.bufferView !== void 0) {
      accessor.bufferView = this.getBufferView(gltfAccessor.bufferView);
    }
    if (accessor.bufferView) {
      const buffer3 = accessor.bufferView.buffer;
      const { ArrayType: ArrayType2, byteLength } = getAccessorArrayTypeAndLength(accessor, accessor.bufferView);
      const byteOffset = (accessor.bufferView.byteOffset || 0) + (accessor.byteOffset || 0) + buffer3.byteOffset;
      let cutBuffer = buffer3.arrayBuffer.slice(byteOffset, byteOffset + byteLength);
      if (accessor.bufferView.byteStride) {
        cutBuffer = this._getValueFromInterleavedBuffer(buffer3, byteOffset, accessor.bufferView.byteStride, accessor.bytesPerElement, accessor.count);
      }
      accessor.value = new ArrayType2(cutBuffer);
    }
    return accessor;
  }
  /**
   * Take values of particular accessor from interleaved buffer
   * various parts of the buffer
   * @param buffer
   * @param byteOffset
   * @param byteStride
   * @param bytesPerElement
   * @param count
   * @returns
   */
  _getValueFromInterleavedBuffer(buffer3, byteOffset, byteStride, bytesPerElement, count3) {
    const result = new Uint8Array(count3 * bytesPerElement);
    for (let i2 = 0; i2 < count3; i2++) {
      const elementOffset = byteOffset + i2 * byteStride;
      result.set(new Uint8Array(buffer3.arrayBuffer.slice(elementOffset, elementOffset + bytesPerElement)), i2 * bytesPerElement);
    }
    return result.buffer;
  }
  _resolveTexture(gltfTexture, index2) {
    return {
      ...gltfTexture,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfTexture.id || `texture-${index2}`,
      sampler: typeof gltfTexture.sampler === "number" ? this.getSampler(gltfTexture.sampler) : makeDefaultSampler(),
      source: typeof gltfTexture.source === "number" ? this.getImage(gltfTexture.source) : void 0
    };
  }
  _resolveSampler(gltfSampler, index2) {
    const sampler = {
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfSampler.id || `sampler-${index2}`,
      ...gltfSampler,
      parameters: {}
    };
    for (const key in sampler) {
      const glEnum = this._enumSamplerParameter(key);
      if (glEnum !== void 0) {
        sampler.parameters[glEnum] = sampler[key];
      }
    }
    return sampler;
  }
  _enumSamplerParameter(key) {
    return SAMPLER_PARAMETER_GLTF_TO_GL[key];
  }
  _resolveImage(gltfImage, index2) {
    const image = {
      ...gltfImage,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfImage.id || `image-${index2}`,
      image: null,
      bufferView: gltfImage.bufferView !== void 0 ? this.getBufferView(gltfImage.bufferView) : void 0
    };
    const preloadedImage = this.images[index2];
    if (preloadedImage) {
      image.image = preloadedImage;
    }
    return image;
  }
  _resolveBufferView(gltfBufferView, index2) {
    const bufferIndex = gltfBufferView.buffer;
    const arrayBuffer2 = this.buffers[bufferIndex].arrayBuffer;
    let byteOffset = this.buffers[bufferIndex].byteOffset || 0;
    if (gltfBufferView.byteOffset) {
      byteOffset += gltfBufferView.byteOffset;
    }
    const bufferView = {
      // // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: `bufferView-${index2}`,
      ...gltfBufferView,
      // ...this.buffers[bufferIndex],
      buffer: this.buffers[bufferIndex],
      data: new Uint8Array(arrayBuffer2, byteOffset, gltfBufferView.byteLength)
    };
    return bufferView;
  }
  _resolveCamera(gltfCamera, index2) {
    const camera = {
      ...gltfCamera,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: gltfCamera.id || `camera-${index2}`
    };
    if (camera.perspective)
      ;
    if (camera.orthographic)
      ;
    return camera;
  }
}
function postProcessGLTF(gltf, options2) {
  return new GLTFPostProcessor().postProcess(gltf, options2);
}
const GLTF_FORMAT = {
  URI: 0,
  EMBEDDED: 1
};
function parse3DTileGLTFViewSync(tile, arrayBuffer2, byteOffset, options2) {
  tile.rotateYtoZ = true;
  const gltfByteLength = (tile.byteOffset || 0) + (tile.byteLength || 0) - byteOffset;
  if (gltfByteLength === 0) {
    throw new Error("glTF byte length must be greater than 0.");
  }
  tile.gltfUpAxis = (options2 == null ? void 0 : options2["3d-tiles"]) && options2["3d-tiles"].assetGltfUpAxis ? options2["3d-tiles"].assetGltfUpAxis : "Y";
  tile.gltfArrayBuffer = sliceArrayBuffer(arrayBuffer2, byteOffset, gltfByteLength);
  tile.gltfByteOffset = 0;
  tile.gltfByteLength = gltfByteLength;
  if (byteOffset % 4 === 0)
    ;
  else {
    console.warn(`${tile.type}: embedded glb is not aligned to a 4-byte boundary.`);
  }
  return (tile.byteOffset || 0) + (tile.byteLength || 0);
}
async function extractGLTF(tile, gltfFormat, options2, context2) {
  const tile3DOptions = (options2 == null ? void 0 : options2["3d-tiles"]) || {};
  extractGLTFBufferOrURL(tile, gltfFormat);
  if (tile3DOptions.loadGLTF) {
    if (!context2) {
      return;
    }
    if (tile.gltfUrl) {
      const { fetch: fetch2 } = context2;
      const response = await fetch2(tile.gltfUrl, options2);
      tile.gltfArrayBuffer = await response.arrayBuffer();
      tile.gltfByteOffset = 0;
    }
    if (tile.gltfArrayBuffer) {
      const gltfWithBuffers = await parseFromContext(tile.gltfArrayBuffer, GLTFLoader$1, options2, context2);
      tile.gltf = postProcessGLTF(gltfWithBuffers);
      tile.gpuMemoryUsageInBytes = getMemoryUsageGLTF(tile.gltf);
      delete tile.gltfArrayBuffer;
      delete tile.gltfByteOffset;
      delete tile.gltfByteLength;
    }
  }
}
function extractGLTFBufferOrURL(tile, gltfFormat, options2) {
  switch (gltfFormat) {
    case GLTF_FORMAT.URI:
      if (tile.gltfArrayBuffer) {
        const gltfUrlBytes = new Uint8Array(tile.gltfArrayBuffer, tile.gltfByteOffset);
        const textDecoder = new TextDecoder();
        const gltfUrl = textDecoder.decode(gltfUrlBytes);
        tile.gltfUrl = gltfUrl.replace(/[\s\0]+$/, "");
      }
      delete tile.gltfArrayBuffer;
      delete tile.gltfByteOffset;
      delete tile.gltfByteLength;
      break;
    case GLTF_FORMAT.EMBEDDED:
      break;
    default:
      throw new Error("b3dm: Illegal glTF format field");
  }
}
async function parseBatchedModel3DTile(tile, arrayBuffer2, byteOffset, options2, context2) {
  var _a3;
  byteOffset = parseBatchedModel(tile, arrayBuffer2, byteOffset, options2);
  await extractGLTF(tile, GLTF_FORMAT.EMBEDDED, options2, context2);
  const extensions = (_a3 = tile == null ? void 0 : tile.gltf) == null ? void 0 : _a3.extensions;
  if (extensions && extensions.CESIUM_RTC) {
    tile.rtcCenter = extensions.CESIUM_RTC.center;
  }
  return byteOffset;
}
function parseBatchedModel(tile, arrayBuffer2, byteOffset, options2, context2) {
  byteOffset = parse3DTileHeaderSync(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesHeaderSync(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileTablesSync(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileGLTFViewSync(tile, arrayBuffer2, byteOffset, options2);
  const featureTable = new Tile3DFeatureTable(tile.featureTableJson, tile.featureTableBinary);
  tile.rtcCenter = featureTable.getGlobalProperty("RTC_CENTER", GL$1.FLOAT, 3);
  return byteOffset;
}
async function parseInstancedModel3DTile(tile, arrayBuffer2, byteOffset, options2, context2) {
  byteOffset = parseInstancedModel(tile, arrayBuffer2, byteOffset, options2);
  await extractGLTF(tile, tile.gltfFormat || 0, options2, context2);
  return byteOffset;
}
function parseInstancedModel(tile, arrayBuffer2, byteOffset, options2, context2) {
  var _a3;
  byteOffset = parse3DTileHeaderSync(tile, arrayBuffer2, byteOffset);
  if (tile.version !== 1) {
    throw new Error(`Instanced 3D Model version ${tile.version} is not supported`);
  }
  byteOffset = parse3DTileTablesHeaderSync(tile, arrayBuffer2, byteOffset);
  const view2 = new DataView(arrayBuffer2);
  tile.gltfFormat = view2.getUint32(byteOffset, true);
  byteOffset += 4;
  byteOffset = parse3DTileTablesSync(tile, arrayBuffer2, byteOffset);
  byteOffset = parse3DTileGLTFViewSync(tile, arrayBuffer2, byteOffset, options2);
  if (!((_a3 = tile == null ? void 0 : tile.header) == null ? void 0 : _a3.featureTableJsonByteLength) || tile.header.featureTableJsonByteLength === 0) {
    throw new Error("i3dm parser: featureTableJsonByteLength is zero.");
  }
  const featureTable = new Tile3DFeatureTable(tile.featureTableJson, tile.featureTableBinary);
  const instancesLength = featureTable.getGlobalProperty("INSTANCES_LENGTH");
  featureTable.featuresLength = instancesLength;
  if (!Number.isFinite(instancesLength)) {
    throw new Error("i3dm parser: INSTANCES_LENGTH must be defined");
  }
  tile.eastNorthUp = featureTable.getGlobalProperty("EAST_NORTH_UP");
  tile.rtcCenter = featureTable.getGlobalProperty("RTC_CENTER", GL$1.FLOAT, 3);
  const batchTable = new Tile3DBatchTableParser(tile.batchTableJson, tile.batchTableBinary, instancesLength);
  extractInstancedAttributes(tile, featureTable, batchTable, instancesLength);
  return byteOffset;
}
function extractInstancedAttributes(tile, featureTable, batchTable, instancesLength) {
  const instances = new Array(instancesLength);
  const instancePosition = new Vector3();
  new Vector3();
  new Vector3();
  new Vector3();
  const instanceRotation = new Matrix3();
  const instanceQuaternion = new Quaternion();
  const instanceScale = new Vector3();
  const instanceTranslationRotationScale = {};
  const instanceTransform = new Matrix4();
  const scratch1 = [];
  const scratch2 = [];
  const scratch3 = [];
  const scratch4 = [];
  for (let i2 = 0; i2 < instancesLength; i2++) {
    let position;
    if (featureTable.hasProperty("POSITION")) {
      position = featureTable.getProperty("POSITION", GL$1.FLOAT, 3, i2, instancePosition);
    } else if (featureTable.hasProperty("POSITION_QUANTIZED")) {
      position = featureTable.getProperty("POSITION_QUANTIZED", GL$1.UNSIGNED_SHORT, 3, i2, instancePosition);
      const quantizedVolumeOffset = featureTable.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", GL$1.FLOAT, 3);
      if (!quantizedVolumeOffset) {
        throw new Error("i3dm parser: QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      }
      const quantizedVolumeScale = featureTable.getGlobalProperty("QUANTIZED_VOLUME_SCALE", GL$1.FLOAT, 3);
      if (!quantizedVolumeScale) {
        throw new Error("i3dm parser: QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      }
      const MAX_UNSIGNED_SHORT = 65535;
      for (let j2 = 0; j2 < 3; j2++) {
        position[j2] = position[j2] / MAX_UNSIGNED_SHORT * quantizedVolumeScale[j2] + quantizedVolumeOffset[j2];
      }
    }
    if (!position) {
      throw new Error("i3dm: POSITION or POSITION_QUANTIZED must be defined for each instance.");
    }
    instancePosition.copy(position);
    instanceTranslationRotationScale.translation = instancePosition;
    tile.normalUp = featureTable.getProperty("NORMAL_UP", GL$1.FLOAT, 3, i2, scratch1);
    tile.normalRight = featureTable.getProperty("NORMAL_RIGHT", GL$1.FLOAT, 3, i2, scratch2);
    if (tile.normalUp) {
      if (!tile.normalRight) {
        throw new Error("i3dm: Custom orientation requires both NORMAL_UP and NORMAL_RIGHT.");
      }
      tile.hasCustomOrientation = true;
    } else {
      tile.octNormalUp = featureTable.getProperty("NORMAL_UP_OCT32P", GL$1.UNSIGNED_SHORT, 2, i2, scratch1);
      tile.octNormalRight = featureTable.getProperty("NORMAL_RIGHT_OCT32P", GL$1.UNSIGNED_SHORT, 2, i2, scratch2);
      if (tile.octNormalUp) {
        if (!tile.octNormalRight) {
          throw new Error("i3dm: oct-encoded orientation requires NORMAL_UP_OCT32P and NORMAL_RIGHT_OCT32P");
        }
        throw new Error("i3dm: oct-encoded orientation not implemented");
      } else if (tile.eastNorthUp) {
        Ellipsoid.WGS84.eastNorthUpToFixedFrame(instancePosition, instanceTransform);
        instanceTransform.getRotationMatrix3(instanceRotation);
      } else {
        instanceRotation.identity();
      }
    }
    instanceQuaternion.fromMatrix3(instanceRotation);
    instanceTranslationRotationScale.rotation = instanceQuaternion;
    instanceScale.set(1, 1, 1);
    const scale5 = featureTable.getProperty("SCALE", GL$1.FLOAT, 1, i2, scratch3);
    if (Number.isFinite(scale5)) {
      instanceScale.multiplyByScalar(scale5);
    }
    const nonUniformScale = featureTable.getProperty("SCALE_NON_UNIFORM", GL$1.FLOAT, 3, i2, scratch1);
    if (nonUniformScale) {
      instanceScale.scale(nonUniformScale);
    }
    instanceTranslationRotationScale.scale = instanceScale;
    let batchId = featureTable.getProperty("BATCH_ID", GL$1.UNSIGNED_SHORT, 1, i2, scratch4);
    if (batchId === void 0) {
      batchId = i2;
    }
    const rotationMatrix = new Matrix4().fromQuaternion(instanceTranslationRotationScale.rotation);
    instanceTransform.identity();
    instanceTransform.translate(instanceTranslationRotationScale.translation);
    instanceTransform.multiplyRight(rotationMatrix);
    instanceTransform.scale(instanceTranslationRotationScale.scale);
    const modelMatrix2 = instanceTransform.clone();
    instances[i2] = {
      modelMatrix: modelMatrix2,
      batchId
    };
  }
  tile.instances = instances;
}
async function parseComposite3DTile(tile, arrayBuffer2, byteOffset, options2, context2, parse3DTile2) {
  byteOffset = parse3DTileHeaderSync(tile, arrayBuffer2, byteOffset);
  const view2 = new DataView(arrayBuffer2);
  tile.tilesLength = view2.getUint32(byteOffset, true);
  byteOffset += 4;
  tile.tiles = [];
  while (tile.tiles.length < tile.tilesLength && (tile.byteLength || 0) - byteOffset > 12) {
    const subtile = { shape: "tile3d" };
    tile.tiles.push(subtile);
    byteOffset = await parse3DTile2(arrayBuffer2, byteOffset, options2, context2, subtile);
  }
  return byteOffset;
}
async function parseGltf3DTile(tile, arrayBuffer2, options2, context2) {
  var _a3, _b3;
  tile.rotateYtoZ = true;
  tile.gltfUpAxis = ((_a3 = options2 == null ? void 0 : options2["3d-tiles"]) == null ? void 0 : _a3.assetGltfUpAxis) ? options2["3d-tiles"].assetGltfUpAxis : "Y";
  if ((_b3 = options2 == null ? void 0 : options2["3d-tiles"]) == null ? void 0 : _b3.loadGLTF) {
    if (!context2) {
      return arrayBuffer2.byteLength;
    }
    const gltfWithBuffers = await parseFromContext(arrayBuffer2, GLTFLoader$1, options2, context2);
    tile.gltf = postProcessGLTF(gltfWithBuffers);
    tile.gpuMemoryUsageInBytes = getMemoryUsageGLTF(tile.gltf);
  } else {
    tile.gltfArrayBuffer = arrayBuffer2;
  }
  return arrayBuffer2.byteLength;
}
async function parse3DTile(arrayBuffer2, byteOffset = 0, options2, context2, tile = { shape: "tile3d" }) {
  tile.byteOffset = byteOffset;
  tile.type = getMagicString$1(arrayBuffer2, byteOffset);
  switch (tile.type) {
    case TILE3D_TYPE.COMPOSITE:
      return await parseComposite3DTile(tile, arrayBuffer2, byteOffset, options2, context2, parse3DTile);
    case TILE3D_TYPE.BATCHED_3D_MODEL:
      return await parseBatchedModel3DTile(tile, arrayBuffer2, byteOffset, options2, context2);
    case TILE3D_TYPE.GLTF:
      return await parseGltf3DTile(tile, arrayBuffer2, options2, context2);
    case TILE3D_TYPE.INSTANCED_3D_MODEL:
      return await parseInstancedModel3DTile(tile, arrayBuffer2, byteOffset, options2, context2);
    case TILE3D_TYPE.POINT_CLOUD:
      return await parsePointCloud3DTile(tile, arrayBuffer2, byteOffset, options2, context2);
    default:
      throw new Error(`3DTileLoader: unknown type ${tile.type}`);
  }
}
const SUBTREE_FILE_MAGIC = 1952609651;
const SUBTREE_FILE_VERSION = 1;
async function parse3DTilesSubtree(data2, options2, context2) {
  const magic = new Uint32Array(data2.slice(0, 4));
  if (magic[0] !== SUBTREE_FILE_MAGIC) {
    throw new Error("Wrong subtree file magic number");
  }
  const version2 = new Uint32Array(data2.slice(4, 8));
  if (version2[0] !== SUBTREE_FILE_VERSION) {
    throw new Error("Wrong subtree file verson, must be 1");
  }
  const jsonByteLength = parseUint64Value(data2.slice(8, 16));
  const stringAttribute = new Uint8Array(data2, 24, jsonByteLength);
  const textDecoder = new TextDecoder("utf8");
  const string3 = textDecoder.decode(stringAttribute);
  const subtree = JSON.parse(string3);
  const binaryByteLength = parseUint64Value(data2.slice(16, 24));
  let internalBinaryBuffer = new ArrayBuffer(0);
  if (binaryByteLength) {
    internalBinaryBuffer = data2.slice(24 + jsonByteLength);
  }
  await loadExplicitBitstream(subtree, subtree.tileAvailability, internalBinaryBuffer, context2);
  if (Array.isArray(subtree.contentAvailability)) {
    for (const contentAvailability of subtree.contentAvailability) {
      await loadExplicitBitstream(subtree, contentAvailability, internalBinaryBuffer, context2);
    }
  } else {
    await loadExplicitBitstream(subtree, subtree.contentAvailability, internalBinaryBuffer, context2);
  }
  await loadExplicitBitstream(subtree, subtree.childSubtreeAvailability, internalBinaryBuffer, context2);
  return subtree;
}
async function loadExplicitBitstream(subtree, availabilityObject, internalBinaryBuffer, context2) {
  const bufferViewIndex = Number.isFinite(availabilityObject.bitstream) ? availabilityObject.bitstream : availabilityObject.bufferView;
  if (typeof bufferViewIndex !== "number") {
    return;
  }
  const bufferView = subtree.bufferViews[bufferViewIndex];
  const buffer3 = subtree.buffers[bufferView.buffer];
  if (!(context2 == null ? void 0 : context2.baseUrl)) {
    throw new Error("Url is not provided");
  }
  if (!context2.fetch) {
    throw new Error("fetch is not provided");
  }
  if (buffer3.uri) {
    const bufferUri = `${(context2 == null ? void 0 : context2.baseUrl) || ""}/${buffer3.uri}`;
    const response = await context2.fetch(bufferUri);
    const data2 = await response.arrayBuffer();
    availabilityObject.explicitBitstream = new Uint8Array(data2, bufferView.byteOffset, bufferView.byteLength);
    return;
  }
  const bufferStart = subtree.buffers.slice(0, bufferView.buffer).reduce((offset, buf) => offset + buf.byteLength, 0);
  availabilityObject.explicitBitstream = new Uint8Array(internalBinaryBuffer.slice(bufferStart, bufferStart + buffer3.byteLength), bufferView.byteOffset, bufferView.byteLength);
}
function parseUint64Value(buffer3) {
  const dataView = new DataView(buffer3);
  const left = dataView.getUint32(0, true);
  const right = dataView.getUint32(4, true);
  return left + 2 ** 32 * right;
}
const Tile3DSubtreeLoader = {
  dataType: null,
  batchType: null,
  id: "3d-tiles-subtree",
  name: "3D Tiles Subtree",
  module: "3d-tiles",
  version: VERSION$4,
  extensions: ["subtree"],
  mimeTypes: ["application/octet-stream"],
  tests: ["subtree"],
  parse: parse3DTilesSubtree,
  options: {}
};
/**
 * @license
 * Copyright 2009 The Closure Library Authors
 * Copyright 2020 Daniel Wirtz / The long.js Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var wasm = null;
try {
  wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    13,
    2,
    96,
    0,
    1,
    127,
    96,
    4,
    127,
    127,
    127,
    127,
    1,
    127,
    3,
    7,
    6,
    0,
    1,
    1,
    1,
    1,
    1,
    6,
    6,
    1,
    127,
    1,
    65,
    0,
    11,
    7,
    50,
    6,
    3,
    109,
    117,
    108,
    0,
    1,
    5,
    100,
    105,
    118,
    95,
    115,
    0,
    2,
    5,
    100,
    105,
    118,
    95,
    117,
    0,
    3,
    5,
    114,
    101,
    109,
    95,
    115,
    0,
    4,
    5,
    114,
    101,
    109,
    95,
    117,
    0,
    5,
    8,
    103,
    101,
    116,
    95,
    104,
    105,
    103,
    104,
    0,
    0,
    10,
    191,
    1,
    6,
    4,
    0,
    35,
    0,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    126,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    127,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    128,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    129,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11,
    36,
    1,
    1,
    126,
    32,
    0,
    173,
    32,
    1,
    173,
    66,
    32,
    134,
    132,
    32,
    2,
    173,
    32,
    3,
    173,
    66,
    32,
    134,
    132,
    130,
    34,
    4,
    66,
    32,
    135,
    167,
    36,
    0,
    32,
    4,
    167,
    11
  ])), {}).exports;
} catch (e3) {
}
function Long(low, high, unsigned) {
  this.low = low | 0;
  this.high = high | 0;
  this.unsigned = !!unsigned;
}
Long.prototype.__isLong__;
Object.defineProperty(Long.prototype, "__isLong__", { value: true });
function isLong(obj) {
  return (obj && obj["__isLong__"]) === true;
}
function ctz32(value) {
  var c2 = Math.clz32(value & -value);
  return value ? 31 - c2 : c2;
}
Long.isLong = isLong;
var INT_CACHE = {};
var UINT_CACHE = {};
function fromInt(value, unsigned) {
  var obj, cachedObj, cache2;
  if (unsigned) {
    value >>>= 0;
    if (cache2 = 0 <= value && value < 256) {
      cachedObj = UINT_CACHE[value];
      if (cachedObj)
        return cachedObj;
    }
    obj = fromBits(value, 0, true);
    if (cache2)
      UINT_CACHE[value] = obj;
    return obj;
  } else {
    value |= 0;
    if (cache2 = -128 <= value && value < 128) {
      cachedObj = INT_CACHE[value];
      if (cachedObj)
        return cachedObj;
    }
    obj = fromBits(value, value < 0 ? -1 : 0, false);
    if (cache2)
      INT_CACHE[value] = obj;
    return obj;
  }
}
Long.fromInt = fromInt;
function fromNumber(value, unsigned) {
  if (isNaN(value))
    return unsigned ? UZERO : ZERO;
  if (unsigned) {
    if (value < 0)
      return UZERO;
    if (value >= TWO_PWR_64_DBL)
      return MAX_UNSIGNED_VALUE;
  } else {
    if (value <= -TWO_PWR_63_DBL)
      return MIN_VALUE;
    if (value + 1 >= TWO_PWR_63_DBL)
      return MAX_VALUE;
  }
  if (value < 0)
    return fromNumber(-value, unsigned).neg();
  return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
}
Long.fromNumber = fromNumber;
function fromBits(lowBits, highBits, unsigned) {
  return new Long(lowBits, highBits, unsigned);
}
Long.fromBits = fromBits;
var pow_dbl = Math.pow;
function fromString(str, unsigned, radix) {
  if (str.length === 0)
    throw Error("empty string");
  if (typeof unsigned === "number") {
    radix = unsigned;
    unsigned = false;
  } else {
    unsigned = !!unsigned;
  }
  if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
    return unsigned ? UZERO : ZERO;
  radix = radix || 10;
  if (radix < 2 || 36 < radix)
    throw RangeError("radix");
  var p2;
  if ((p2 = str.indexOf("-")) > 0)
    throw Error("interior hyphen");
  else if (p2 === 0) {
    return fromString(str.substring(1), unsigned, radix).neg();
  }
  var radixToPower = fromNumber(pow_dbl(radix, 8));
  var result = ZERO;
  for (var i2 = 0; i2 < str.length; i2 += 8) {
    var size12 = Math.min(8, str.length - i2), value = parseInt(str.substring(i2, i2 + size12), radix);
    if (size12 < 8) {
      var power = fromNumber(pow_dbl(radix, size12));
      result = result.mul(power).add(fromNumber(value));
    } else {
      result = result.mul(radixToPower);
      result = result.add(fromNumber(value));
    }
  }
  result.unsigned = unsigned;
  return result;
}
Long.fromString = fromString;
function fromValue(val, unsigned) {
  if (typeof val === "number")
    return fromNumber(val, unsigned);
  if (typeof val === "string")
    return fromString(val, unsigned);
  return fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
Long.fromValue = fromValue;
var TWO_PWR_16_DBL = 1 << 16;
var TWO_PWR_24_DBL = 1 << 24;
var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
var ZERO = fromInt(0);
Long.ZERO = ZERO;
var UZERO = fromInt(0, true);
Long.UZERO = UZERO;
var ONE = fromInt(1);
Long.ONE = ONE;
var UONE = fromInt(1, true);
Long.UONE = UONE;
var NEG_ONE = fromInt(-1);
Long.NEG_ONE = NEG_ONE;
var MAX_VALUE = fromBits(4294967295 | 0, 2147483647 | 0, false);
Long.MAX_VALUE = MAX_VALUE;
var MAX_UNSIGNED_VALUE = fromBits(4294967295 | 0, 4294967295 | 0, true);
Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
var MIN_VALUE = fromBits(0, 2147483648 | 0, false);
Long.MIN_VALUE = MIN_VALUE;
var LongPrototype = Long.prototype;
LongPrototype.toInt = function toInt2() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
LongPrototype.toNumber = function toNumber3() {
  if (this.unsigned)
    return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
  return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
};
LongPrototype.toString = function toString28(radix) {
  radix = radix || 10;
  if (radix < 2 || 36 < radix)
    throw RangeError("radix");
  if (this.isZero())
    return "0";
  if (this.isNegative()) {
    if (this.eq(MIN_VALUE)) {
      var radixLong = fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
      return div.toString(radix) + rem1.toInt().toString(radix);
    } else
      return "-" + this.neg().toString(radix);
  }
  var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned), rem = this;
  var result = "";
  while (true) {
    var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
    rem = remDiv;
    if (rem.isZero())
      return digits + result;
    else {
      while (digits.length < 6)
        digits = "0" + digits;
      result = "" + digits + result;
    }
  }
};
LongPrototype.getHighBits = function getHighBits2() {
  return this.high;
};
LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned2() {
  return this.high >>> 0;
};
LongPrototype.getLowBits = function getLowBits2() {
  return this.low;
};
LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned2() {
  return this.low >>> 0;
};
LongPrototype.getNumBitsAbs = function getNumBitsAbs2() {
  if (this.isNegative())
    return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
  var val = this.high != 0 ? this.high : this.low;
  for (var bit = 31; bit > 0; bit--)
    if ((val & 1 << bit) != 0)
      break;
  return this.high != 0 ? bit + 33 : bit + 1;
};
LongPrototype.isZero = function isZero3() {
  return this.high === 0 && this.low === 0;
};
LongPrototype.eqz = LongPrototype.isZero;
LongPrototype.isNegative = function isNegative3() {
  return !this.unsigned && this.high < 0;
};
LongPrototype.isPositive = function isPositive3() {
  return this.unsigned || this.high >= 0;
};
LongPrototype.isOdd = function isOdd2() {
  return (this.low & 1) === 1;
};
LongPrototype.isEven = function isEven2() {
  return (this.low & 1) === 0;
};
LongPrototype.equals = function equals11(other) {
  if (!isLong(other))
    other = fromValue(other);
  if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1)
    return false;
  return this.high === other.high && this.low === other.low;
};
LongPrototype.eq = LongPrototype.equals;
LongPrototype.notEquals = function notEquals2(other) {
  return !this.eq(
    /* validates */
    other
  );
};
LongPrototype.neq = LongPrototype.notEquals;
LongPrototype.ne = LongPrototype.notEquals;
LongPrototype.lessThan = function lessThan2(other) {
  return this.comp(
    /* validates */
    other
  ) < 0;
};
LongPrototype.lt = LongPrototype.lessThan;
LongPrototype.lessThanOrEqual = function lessThanOrEqual2(other) {
  return this.comp(
    /* validates */
    other
  ) <= 0;
};
LongPrototype.lte = LongPrototype.lessThanOrEqual;
LongPrototype.le = LongPrototype.lessThanOrEqual;
LongPrototype.greaterThan = function greaterThan2(other) {
  return this.comp(
    /* validates */
    other
  ) > 0;
};
LongPrototype.gt = LongPrototype.greaterThan;
LongPrototype.greaterThanOrEqual = function greaterThanOrEqual2(other) {
  return this.comp(
    /* validates */
    other
  ) >= 0;
};
LongPrototype.gte = LongPrototype.greaterThanOrEqual;
LongPrototype.ge = LongPrototype.greaterThanOrEqual;
LongPrototype.compare = function compare11(other) {
  if (!isLong(other))
    other = fromValue(other);
  if (this.eq(other))
    return 0;
  var thisNeg = this.isNegative(), otherNeg = other.isNegative();
  if (thisNeg && !otherNeg)
    return -1;
  if (!thisNeg && otherNeg)
    return 1;
  if (!this.unsigned)
    return this.sub(other).isNegative() ? -1 : 1;
  return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
LongPrototype.comp = LongPrototype.compare;
LongPrototype.negate = function negate4() {
  if (!this.unsigned && this.eq(MIN_VALUE))
    return MIN_VALUE;
  return this.not().add(ONE);
};
LongPrototype.neg = LongPrototype.negate;
LongPrototype.add = function add17(addend) {
  if (!isLong(addend))
    addend = fromValue(addend);
  var a48 = this.high >>> 16;
  var a32 = this.high & 65535;
  var a16 = this.low >>> 16;
  var a00 = this.low & 65535;
  var b48 = addend.high >>> 16;
  var b32 = addend.high & 65535;
  var b16 = addend.low >>> 16;
  var b00 = addend.low & 65535;
  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 + b00;
  c16 += c00 >>> 16;
  c00 &= 65535;
  c16 += a16 + b16;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c32 += a32 + b32;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c48 += a48 + b48;
  c48 &= 65535;
  return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
LongPrototype.subtract = function subtract4(subtrahend) {
  if (!isLong(subtrahend))
    subtrahend = fromValue(subtrahend);
  return this.add(subtrahend.neg());
};
LongPrototype.sub = LongPrototype.subtract;
LongPrototype.multiply = function multiply4(multiplier) {
  if (this.isZero())
    return this;
  if (!isLong(multiplier))
    multiplier = fromValue(multiplier);
  if (wasm) {
    var low = wasm["mul"](
      this.low,
      this.high,
      multiplier.low,
      multiplier.high
    );
    return fromBits(low, wasm["get_high"](), this.unsigned);
  }
  if (multiplier.isZero())
    return this.unsigned ? UZERO : ZERO;
  if (this.eq(MIN_VALUE))
    return multiplier.isOdd() ? MIN_VALUE : ZERO;
  if (multiplier.eq(MIN_VALUE))
    return this.isOdd() ? MIN_VALUE : ZERO;
  if (this.isNegative()) {
    if (multiplier.isNegative())
      return this.neg().mul(multiplier.neg());
    else
      return this.neg().mul(multiplier).neg();
  } else if (multiplier.isNegative())
    return this.mul(multiplier.neg()).neg();
  if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
    return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
  var a48 = this.high >>> 16;
  var a32 = this.high & 65535;
  var a16 = this.low >>> 16;
  var a00 = this.low & 65535;
  var b48 = multiplier.high >>> 16;
  var b32 = multiplier.high & 65535;
  var b16 = multiplier.low >>> 16;
  var b00 = multiplier.low & 65535;
  var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
  c00 += a00 * b00;
  c16 += c00 >>> 16;
  c00 &= 65535;
  c16 += a16 * b00;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c16 += a00 * b16;
  c32 += c16 >>> 16;
  c16 &= 65535;
  c32 += a32 * b00;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c32 += a16 * b16;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c32 += a00 * b32;
  c48 += c32 >>> 16;
  c32 &= 65535;
  c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
  c48 &= 65535;
  return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
LongPrototype.mul = LongPrototype.multiply;
LongPrototype.divide = function divide3(divisor) {
  if (!isLong(divisor))
    divisor = fromValue(divisor);
  if (divisor.isZero())
    throw Error("division by zero");
  if (wasm) {
    if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) {
      return this;
    }
    var low = (this.unsigned ? wasm["div_u"] : wasm["div_s"])(
      this.low,
      this.high,
      divisor.low,
      divisor.high
    );
    return fromBits(low, wasm["get_high"](), this.unsigned);
  }
  if (this.isZero())
    return this.unsigned ? UZERO : ZERO;
  var approx, rem, res;
  if (!this.unsigned) {
    if (this.eq(MIN_VALUE)) {
      if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
        return MIN_VALUE;
      else if (divisor.eq(MIN_VALUE))
        return ONE;
      else {
        var halfThis = this.shr(1);
        approx = halfThis.div(divisor).shl(1);
        if (approx.eq(ZERO)) {
          return divisor.isNegative() ? ONE : NEG_ONE;
        } else {
          rem = this.sub(divisor.mul(approx));
          res = approx.add(rem.div(divisor));
          return res;
        }
      }
    } else if (divisor.eq(MIN_VALUE))
      return this.unsigned ? UZERO : ZERO;
    if (this.isNegative()) {
      if (divisor.isNegative())
        return this.neg().div(divisor.neg());
      return this.neg().div(divisor).neg();
    } else if (divisor.isNegative())
      return this.div(divisor.neg()).neg();
    res = ZERO;
  } else {
    if (!divisor.unsigned)
      divisor = divisor.toUnsigned();
    if (divisor.gt(this))
      return UZERO;
    if (divisor.gt(this.shru(1)))
      return UONE;
    res = UZERO;
  }
  rem = this;
  while (rem.gte(divisor)) {
    approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
    var log22 = Math.ceil(Math.log(approx) / Math.LN2), delta = log22 <= 48 ? 1 : pow_dbl(2, log22 - 48), approxRes = fromNumber(approx), approxRem = approxRes.mul(divisor);
    while (approxRem.isNegative() || approxRem.gt(rem)) {
      approx -= delta;
      approxRes = fromNumber(approx, this.unsigned);
      approxRem = approxRes.mul(divisor);
    }
    if (approxRes.isZero())
      approxRes = ONE;
    res = res.add(approxRes);
    rem = rem.sub(approxRem);
  }
  return res;
};
LongPrototype.div = LongPrototype.divide;
LongPrototype.modulo = function modulo2(divisor) {
  if (!isLong(divisor))
    divisor = fromValue(divisor);
  if (wasm) {
    var low = (this.unsigned ? wasm["rem_u"] : wasm["rem_s"])(
      this.low,
      this.high,
      divisor.low,
      divisor.high
    );
    return fromBits(low, wasm["get_high"](), this.unsigned);
  }
  return this.sub(this.div(divisor).mul(divisor));
};
LongPrototype.mod = LongPrototype.modulo;
LongPrototype.rem = LongPrototype.modulo;
LongPrototype.not = function not3() {
  return fromBits(~this.low, ~this.high, this.unsigned);
};
LongPrototype.countLeadingZeros = function countLeadingZeros2() {
  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
LongPrototype.clz = LongPrototype.countLeadingZeros;
LongPrototype.countTrailingZeros = function countTrailingZeros2() {
  return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
};
LongPrototype.ctz = LongPrototype.countTrailingZeros;
LongPrototype.and = function and2(other) {
  if (!isLong(other))
    other = fromValue(other);
  return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
LongPrototype.or = function or2(other) {
  if (!isLong(other))
    other = fromValue(other);
  return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
LongPrototype.xor = function xor2(other) {
  if (!isLong(other))
    other = fromValue(other);
  return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
LongPrototype.shiftLeft = function shiftLeft2(numBits) {
  if (isLong(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  else if (numBits < 32)
    return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
  else
    return fromBits(0, this.low << numBits - 32, this.unsigned);
};
LongPrototype.shl = LongPrototype.shiftLeft;
LongPrototype.shiftRight = function shiftRight2(numBits) {
  if (isLong(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  else if (numBits < 32)
    return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
  else
    return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
LongPrototype.shr = LongPrototype.shiftRight;
LongPrototype.shiftRightUnsigned = function shiftRightUnsigned2(numBits) {
  if (isLong(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  if (numBits < 32)
    return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
  if (numBits === 32)
    return fromBits(this.high, 0, this.unsigned);
  return fromBits(this.high >>> numBits - 32, 0, this.unsigned);
};
LongPrototype.shru = LongPrototype.shiftRightUnsigned;
LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
LongPrototype.rotateLeft = function rotateLeft2(numBits) {
  var b2;
  if (isLong(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  if (numBits === 32)
    return fromBits(this.high, this.low, this.unsigned);
  if (numBits < 32) {
    b2 = 32 - numBits;
    return fromBits(this.low << numBits | this.high >>> b2, this.high << numBits | this.low >>> b2, this.unsigned);
  }
  numBits -= 32;
  b2 = 32 - numBits;
  return fromBits(this.high << numBits | this.low >>> b2, this.low << numBits | this.high >>> b2, this.unsigned);
};
LongPrototype.rotl = LongPrototype.rotateLeft;
LongPrototype.rotateRight = function rotateRight2(numBits) {
  var b2;
  if (isLong(numBits))
    numBits = numBits.toInt();
  if ((numBits &= 63) === 0)
    return this;
  if (numBits === 32)
    return fromBits(this.high, this.low, this.unsigned);
  if (numBits < 32) {
    b2 = 32 - numBits;
    return fromBits(this.high << b2 | this.low >>> numBits, this.low << b2 | this.high >>> numBits, this.unsigned);
  }
  numBits -= 32;
  b2 = 32 - numBits;
  return fromBits(this.low << b2 | this.high >>> numBits, this.high << b2 | this.low >>> numBits, this.unsigned);
};
LongPrototype.rotr = LongPrototype.rotateRight;
LongPrototype.toSigned = function toSigned2() {
  if (!this.unsigned)
    return this;
  return fromBits(this.low, this.high, false);
};
LongPrototype.toUnsigned = function toUnsigned2() {
  if (this.unsigned)
    return this;
  return fromBits(this.low, this.high, true);
};
LongPrototype.toBytes = function toBytes2(le2) {
  return le2 ? this.toBytesLE() : this.toBytesBE();
};
LongPrototype.toBytesLE = function toBytesLE2() {
  var hi = this.high, lo = this.low;
  return [
    lo & 255,
    lo >>> 8 & 255,
    lo >>> 16 & 255,
    lo >>> 24,
    hi & 255,
    hi >>> 8 & 255,
    hi >>> 16 & 255,
    hi >>> 24
  ];
};
LongPrototype.toBytesBE = function toBytesBE2() {
  var hi = this.high, lo = this.low;
  return [
    hi >>> 24,
    hi >>> 16 & 255,
    hi >>> 8 & 255,
    hi & 255,
    lo >>> 24,
    lo >>> 16 & 255,
    lo >>> 8 & 255,
    lo & 255
  ];
};
Long.fromBytes = function fromBytes2(bytes, unsigned, le2) {
  return le2 ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
};
Long.fromBytesLE = function fromBytesLE2(bytes, unsigned) {
  return new Long(
    bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24,
    bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24,
    unsigned
  );
};
Long.fromBytesBE = function fromBytesBE2(bytes, unsigned) {
  return new Long(
    bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7],
    bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3],
    unsigned
  );
};
const MAXIMUM_TOKEN_LENGTH = 16;
function getS2CellIdFromToken(token) {
  if (token === "X") {
    token = "";
  }
  const paddedToken = token.padEnd(MAXIMUM_TOKEN_LENGTH, "0");
  return Long.fromString(paddedToken, true, 16);
}
function getS2TokenFromCellId(cellId) {
  if (cellId.isZero()) {
    return "X";
  }
  let numZeroDigits = cellId.countTrailingZeros();
  const remainder = numZeroDigits % 4;
  numZeroDigits = (numZeroDigits - remainder) / 4;
  const trailingZeroHexChars = numZeroDigits;
  numZeroDigits *= 4;
  const x2 = cellId.shiftRightUnsigned(numZeroDigits);
  const hexString = x2.toString(16).replace(/0+$/, "");
  const zeroString = Array(17 - trailingZeroHexChars - hexString.length).join("0");
  return zeroString + hexString;
}
function getS2ChildCellId(cellId, index2) {
  const newLsb = lsb(cellId).shiftRightUnsigned(2);
  const childCellId = cellId.add(Long.fromNumber(2 * index2 + 1 - 4).multiply(newLsb));
  return childCellId;
}
function lsb(cellId) {
  return cellId.and(cellId.not().add(1));
}
const FACE_BITS = 3;
const MAX_LEVEL = 30;
const POS_BITS = 2 * MAX_LEVEL + 1;
const RADIAN_TO_DEGREE = 180 / Math.PI;
function getS2CellFromQuadKey(hilbertQuadkey) {
  if (hilbertQuadkey.length === 0) {
    throw new Error(`Invalid Hilbert quad key ${hilbertQuadkey}`);
  }
  const parts = hilbertQuadkey.split("/");
  const face = parseInt(parts[0], 10);
  const position = parts[1];
  const maxLevel = position.length;
  let level = 0;
  const point4 = [0, 0];
  for (let i2 = maxLevel - 1; i2 >= 0; i2--) {
    level = maxLevel - i2;
    const bit = position[i2];
    let rx = 0;
    let ry = 0;
    if (bit === "1") {
      ry = 1;
    } else if (bit === "2") {
      rx = 1;
      ry = 1;
    } else if (bit === "3") {
      rx = 1;
    }
    const val = Math.pow(2, level - 1);
    rotateAndFlipQuadrant(val, point4, rx, ry);
    point4[0] += val * rx;
    point4[1] += val * ry;
  }
  if (face % 2 === 1) {
    const t2 = point4[0];
    point4[0] = point4[1];
    point4[1] = t2;
  }
  return { face, ij: point4, level };
}
function getS2QuadkeyFromCellId(cellId) {
  if (cellId.isZero()) {
    return "";
  }
  let bin = cellId.toString(2);
  while (bin.length < FACE_BITS + POS_BITS) {
    bin = "0" + bin;
  }
  const lsbIndex = bin.lastIndexOf("1");
  const faceB = bin.substring(0, 3);
  const posB = bin.substring(3, lsbIndex);
  const levelN = posB.length / 2;
  const faceS = Long.fromString(faceB, true, 2).toString(10);
  let posS = "";
  if (levelN !== 0) {
    posS = Long.fromString(posB, true, 2).toString(4);
    while (posS.length < levelN) {
      posS = "0" + posS;
    }
  }
  return `${faceS}/${posS}`;
}
function IJToST(ij, level, offsets) {
  const maxSize = 1 << level;
  return [(ij[0] + offsets[0]) / maxSize, (ij[1] + offsets[1]) / maxSize];
}
function singleSTtoUV(st) {
  if (st >= 0.5) {
    return 1 / 3 * (4 * st * st - 1);
  }
  return 1 / 3 * (1 - 4 * (1 - st) * (1 - st));
}
function STToUV(st) {
  return [singleSTtoUV(st[0]), singleSTtoUV(st[1])];
}
function FaceUVToXYZ(face, [u2, v5]) {
  switch (face) {
    case 0:
      return [1, u2, v5];
    case 1:
      return [-u2, 1, v5];
    case 2:
      return [-u2, -v5, 1];
    case 3:
      return [-1, -v5, -u2];
    case 4:
      return [v5, -1, -u2];
    case 5:
      return [v5, u2, -1];
    default:
      throw new Error("Invalid face");
  }
}
function XYZToLngLat([x2, y2, z2]) {
  const lat = Math.atan2(z2, Math.sqrt(x2 * x2 + y2 * y2));
  const lng = Math.atan2(y2, x2);
  return [lng * RADIAN_TO_DEGREE, lat * RADIAN_TO_DEGREE];
}
function rotateAndFlipQuadrant(n2, point4, rx, ry) {
  if (ry === 0) {
    if (rx === 1) {
      point4[0] = n2 - 1 - point4[0];
      point4[1] = n2 - 1 - point4[1];
    }
    const x2 = point4[0];
    point4[0] = point4[1];
    point4[1] = x2;
  }
}
function getS2LngLatFromS2Cell(s2Cell) {
  const st = IJToST(s2Cell.ij, s2Cell.level, [0.5, 0.5]);
  const uv = STToUV(st);
  const xyz = FaceUVToXYZ(s2Cell.face, uv);
  return XYZToLngLat(xyz);
}
const MAX_RESOLUTION = 100;
function getS2BoundaryFlatFromS2Cell(s2cell) {
  const { face, ij, level } = s2cell;
  const offsets = [
    [0, 0],
    [0, 1],
    [1, 1],
    [1, 0],
    [0, 0]
  ];
  const resolution = Math.max(1, Math.ceil(MAX_RESOLUTION * Math.pow(2, -level)));
  const result = new Float64Array(4 * resolution * 2 + 2);
  let ptIndex = 0;
  let prevLng = 0;
  for (let i2 = 0; i2 < 4; i2++) {
    const offset = offsets[i2].slice(0);
    const nextOffset = offsets[i2 + 1];
    const stepI = (nextOffset[0] - offset[0]) / resolution;
    const stepJ = (nextOffset[1] - offset[1]) / resolution;
    for (let j2 = 0; j2 < resolution; j2++) {
      offset[0] += stepI;
      offset[1] += stepJ;
      const st = IJToST(ij, level, offset);
      const uv = STToUV(st);
      const xyz = FaceUVToXYZ(face, uv);
      const lngLat = XYZToLngLat(xyz);
      if (Math.abs(lngLat[1]) > 89.999) {
        lngLat[0] = prevLng;
      }
      const deltaLng = lngLat[0] - prevLng;
      lngLat[0] += deltaLng > 180 ? -360 : deltaLng < -180 ? 360 : 0;
      result[ptIndex++] = lngLat[0];
      result[ptIndex++] = lngLat[1];
      prevLng = lngLat[0];
    }
  }
  result[ptIndex++] = result[0];
  result[ptIndex++] = result[1];
  return result;
}
function getS2Cell(tokenOrKey) {
  const key = getS2QuadKey(tokenOrKey);
  const s2cell = getS2CellFromQuadKey(key);
  return s2cell;
}
function getS2QuadKey(tokenOrKey) {
  if (tokenOrKey.indexOf("/") > 0) {
    return tokenOrKey;
  }
  const id = getS2CellIdFromToken(tokenOrKey);
  return getS2QuadkeyFromCellId(id);
}
function getS2LngLat(s2Token) {
  const s2cell = getS2Cell(s2Token);
  return getS2LngLatFromS2Cell(s2cell);
}
function getS2Region(s2cell) {
  let region;
  if (s2cell.face === 2 || s2cell.face === 5) {
    let corners = null;
    let len2 = 0;
    for (let i2 = 0; i2 < 4; i2++) {
      const key = `${s2cell.face}/${i2}`;
      const cell = getS2Cell(key);
      const corns = getS2BoundaryFlatFromS2Cell(cell);
      if (typeof corners === "undefined" || corners === null)
        corners = new Float64Array(4 * corns.length);
      corners.set(corns, len2);
      len2 += corns.length;
    }
    region = get2DRegionFromS2Corners(corners);
  } else {
    const corners = getS2BoundaryFlatFromS2Cell(s2cell);
    region = get2DRegionFromS2Corners(corners);
  }
  return region;
}
function get2DRegionFromS2Corners(corners) {
  if (corners.length % 2 !== 0) {
    throw new Error("Invalid corners");
  }
  const longitudes = [];
  const latitudes = [];
  for (let i2 = 0; i2 < corners.length; i2 += 2) {
    longitudes.push(corners[i2]);
    latitudes.push(corners[i2 + 1]);
  }
  longitudes.sort((a2, b2) => a2 - b2);
  latitudes.sort((a2, b2) => a2 - b2);
  return {
    west: longitudes[0],
    east: longitudes[longitudes.length - 1],
    north: latitudes[latitudes.length - 1],
    south: latitudes[0]
  };
}
function getS2OrientedBoundingBoxCornerPoints(tokenOrKey, heightInfo) {
  const min4 = (heightInfo == null ? void 0 : heightInfo.minimumHeight) || 0;
  const max3 = (heightInfo == null ? void 0 : heightInfo.maximumHeight) || 0;
  const s2cell = getS2Cell(tokenOrKey);
  const region = getS2Region(s2cell);
  const W2 = region.west;
  const S2 = region.south;
  const E3 = region.east;
  const N2 = region.north;
  const points2 = [];
  points2.push(new Vector3(W2, N2, min4));
  points2.push(new Vector3(E3, N2, min4));
  points2.push(new Vector3(E3, S2, min4));
  points2.push(new Vector3(W2, S2, min4));
  points2.push(new Vector3(W2, N2, max3));
  points2.push(new Vector3(E3, N2, max3));
  points2.push(new Vector3(E3, S2, max3));
  points2.push(new Vector3(W2, S2, max3));
  return points2;
}
function convertS2BoundingVolumetoOBB(s2VolumeInfo) {
  const token = s2VolumeInfo.token;
  const heightInfo = {
    minimumHeight: s2VolumeInfo.minimumHeight,
    maximumHeight: s2VolumeInfo.maximumHeight
  };
  const corners = getS2OrientedBoundingBoxCornerPoints(token, heightInfo);
  const center2 = getS2LngLat(token);
  const centerLng = center2[0];
  const centerLat = center2[1];
  const point4 = Ellipsoid.WGS84.cartographicToCartesian([
    centerLng,
    centerLat,
    heightInfo.maximumHeight
  ]);
  const centerPointAdditional = new Vector3(point4[0], point4[1], point4[2]);
  corners.push(centerPointAdditional);
  const obb = makeOrientedBoundingBoxFromPoints(corners);
  const box = [...obb.center, ...obb.halfAxes];
  return box;
}
const QUADTREE_DIVISION_COUNT = 4;
const OCTREE_DIVISION_COUNT = 8;
const SUBDIVISION_COUNT_MAP = {
  QUADTREE: QUADTREE_DIVISION_COUNT,
  OCTREE: OCTREE_DIVISION_COUNT
};
function getChildS2VolumeBox(s2VolumeBox, index2, subdivisionScheme) {
  if (s2VolumeBox == null ? void 0 : s2VolumeBox.box) {
    const cellId = getS2CellIdFromToken(s2VolumeBox.s2VolumeInfo.token);
    const childCellId = getS2ChildCellId(cellId, index2);
    const childToken = getS2TokenFromCellId(childCellId);
    const s2ChildVolumeInfo = { ...s2VolumeBox.s2VolumeInfo };
    s2ChildVolumeInfo.token = childToken;
    switch (subdivisionScheme) {
      case "OCTREE":
        const s2VolumeInfo = s2VolumeBox.s2VolumeInfo;
        const delta = s2VolumeInfo.maximumHeight - s2VolumeInfo.minimumHeight;
        const sizeZ = delta / 2;
        const midZ = s2VolumeInfo.minimumHeight + delta / 2;
        s2VolumeInfo.minimumHeight = midZ - sizeZ;
        s2VolumeInfo.maximumHeight = midZ + sizeZ;
        break;
    }
    const box = convertS2BoundingVolumetoOBB(s2ChildVolumeInfo);
    const childS2VolumeBox = {
      box,
      s2VolumeInfo: s2ChildVolumeInfo
    };
    return childS2VolumeBox;
  }
  return void 0;
}
async function parseImplicitTiles(params2) {
  const { implicitOptions, parentData = {
    mortonIndex: 0,
    x: 0,
    y: 0,
    z: 0
  }, childIndex = 0, s2VolumeBox, loaderOptions } = params2;
  let { subtree, level = 0, globalData = {
    level: 0,
    mortonIndex: 0,
    x: 0,
    y: 0,
    z: 0
  } } = params2;
  const { subdivisionScheme, subtreeLevels, maximumLevel, contentUrlTemplate, subtreesUriTemplate, basePath } = implicitOptions;
  const tile = { children: [], lodMetricValue: 0, contentUrl: "" };
  if (!maximumLevel) {
    log$3.once(`Missing 'maximumLevel' or 'availableLevels' property. The subtree ${contentUrlTemplate} won't be loaded...`);
    return tile;
  }
  const lev = level + globalData.level;
  if (lev > maximumLevel) {
    return tile;
  }
  const childrenPerTile = SUBDIVISION_COUNT_MAP[subdivisionScheme];
  const bitsPerTile = Math.log2(childrenPerTile);
  const childX = childIndex & 1;
  const childY = childIndex >> 1 & 1;
  const childZ = childIndex >> 2 & 1;
  const levelOffset = (childrenPerTile ** level - 1) / (childrenPerTile - 1);
  let childTileMortonIndex = concatBits(parentData.mortonIndex, childIndex, bitsPerTile);
  let tileAvailabilityIndex = levelOffset + childTileMortonIndex;
  let childTileX = concatBits(parentData.x, childX, 1);
  let childTileY = concatBits(parentData.y, childY, 1);
  let childTileZ = concatBits(parentData.z, childZ, 1);
  let isChildSubtreeAvailable = false;
  if (level >= subtreeLevels) {
    isChildSubtreeAvailable = getAvailabilityResult(subtree.childSubtreeAvailability, childTileMortonIndex);
  }
  const x2 = concatBits(globalData.x, childTileX, level);
  const y2 = concatBits(globalData.y, childTileY, level);
  const z2 = concatBits(globalData.z, childTileZ, level);
  if (isChildSubtreeAvailable) {
    const subtreePath = `${basePath}/${subtreesUriTemplate}`;
    const childSubtreeUrl = replaceContentUrlTemplate(subtreePath, lev, x2, y2, z2);
    const childSubtree = await load(childSubtreeUrl, Tile3DSubtreeLoader, loaderOptions);
    subtree = childSubtree;
    globalData = {
      mortonIndex: childTileMortonIndex,
      x: childTileX,
      y: childTileY,
      z: childTileZ,
      level
    };
    childTileMortonIndex = 0;
    tileAvailabilityIndex = 0;
    childTileX = 0;
    childTileY = 0;
    childTileZ = 0;
    level = 0;
  }
  const isTileAvailable = getAvailabilityResult(subtree.tileAvailability, tileAvailabilityIndex);
  if (!isTileAvailable) {
    return tile;
  }
  const isContentAvailable = getAvailabilityResult(subtree.contentAvailability, tileAvailabilityIndex);
  if (isContentAvailable) {
    tile.contentUrl = replaceContentUrlTemplate(contentUrlTemplate, lev, x2, y2, z2);
  }
  const childTileLevel = level + 1;
  const pData = { mortonIndex: childTileMortonIndex, x: childTileX, y: childTileY, z: childTileZ };
  for (let index2 = 0; index2 < childrenPerTile; index2++) {
    const childS2VolumeBox = getChildS2VolumeBox(s2VolumeBox, index2, subdivisionScheme);
    const childTileParsed = await parseImplicitTiles({
      subtree,
      implicitOptions,
      loaderOptions,
      parentData: pData,
      childIndex: index2,
      level: childTileLevel,
      globalData: { ...globalData },
      s2VolumeBox: childS2VolumeBox
    });
    if (childTileParsed.contentUrl || childTileParsed.children.length) {
      const globalLevel = lev + 1;
      const childCoordinates = { childTileX, childTileY, childTileZ };
      const formattedTile = formatTileData(childTileParsed, globalLevel, childCoordinates, implicitOptions, s2VolumeBox);
      tile.children.push(formattedTile);
    }
  }
  return tile;
}
function getAvailabilityResult(availabilityData, index2) {
  let availabilityObject;
  if (Array.isArray(availabilityData)) {
    availabilityObject = availabilityData[0];
    if (availabilityData.length > 1) {
      log$3.once('Not supported extension "3DTILES_multiple_contents" has been detected');
    }
  } else {
    availabilityObject = availabilityData;
  }
  if ("constant" in availabilityObject) {
    return Boolean(availabilityObject.constant);
  }
  if (availabilityObject.explicitBitstream) {
    return getBooleanValueFromBitstream(index2, availabilityObject.explicitBitstream);
  }
  return false;
}
function formatTileData(tile, level, childCoordinates, options2, s2VolumeBox) {
  const { basePath, refine, getRefine: getRefine2, lodMetricType, getTileType: getTileType2, rootLodMetricValue, rootBoundingVolume } = options2;
  const uri = tile.contentUrl && tile.contentUrl.replace(`${basePath}/`, "");
  const lodMetricValue = rootLodMetricValue / 2 ** level;
  const boundingVolume = (s2VolumeBox == null ? void 0 : s2VolumeBox.box) ? { box: s2VolumeBox.box } : rootBoundingVolume;
  const boundingVolumeForChildTile = calculateBoundingVolumeForChildTile(level, boundingVolume, childCoordinates);
  return {
    children: tile.children,
    contentUrl: tile.contentUrl,
    content: { uri },
    id: tile.contentUrl,
    refine: getRefine2(refine),
    type: getTileType2(tile),
    lodMetricType,
    lodMetricValue,
    geometricError: lodMetricValue,
    transform: tile.transform,
    boundingVolume: boundingVolumeForChildTile
  };
}
function calculateBoundingVolumeForChildTile(level, rootBoundingVolume, childCoordinates) {
  if (rootBoundingVolume.region) {
    const { childTileX, childTileY, childTileZ } = childCoordinates;
    const [west, south, east, north, minimumHeight, maximumHeight] = rootBoundingVolume.region;
    const boundingVolumesCount = 2 ** level;
    const sizeX = (east - west) / boundingVolumesCount;
    const sizeY = (north - south) / boundingVolumesCount;
    const sizeZ = (maximumHeight - minimumHeight) / boundingVolumesCount;
    const [childWest, childEast] = [west + sizeX * childTileX, west + sizeX * (childTileX + 1)];
    const [childSouth, childNorth] = [south + sizeY * childTileY, south + sizeY * (childTileY + 1)];
    const [childMinimumHeight, childMaximumHeight] = [
      minimumHeight + sizeZ * childTileZ,
      minimumHeight + sizeZ * (childTileZ + 1)
    ];
    return {
      region: [childWest, childSouth, childEast, childNorth, childMinimumHeight, childMaximumHeight]
    };
  }
  if (rootBoundingVolume.box) {
    return rootBoundingVolume;
  }
  throw new Error(`Unsupported bounding volume type ${JSON.stringify(rootBoundingVolume)}`);
}
function concatBits(higher, lower, shift) {
  return (higher << shift) + lower;
}
function replaceContentUrlTemplate(templateUrl, level, x2, y2, z2) {
  const mapUrl = generateMapUrl({ level, x: x2, y: y2, z: z2 });
  return templateUrl.replace(/{level}|{x}|{y}|{z}/gi, (matched) => mapUrl[matched]);
}
function generateMapUrl(items) {
  const mapUrl = {};
  for (const key in items) {
    mapUrl[`{${key}}`] = items[key];
  }
  return mapUrl;
}
function getBooleanValueFromBitstream(availabilityIndex, availabilityBuffer) {
  const byteIndex = Math.floor(availabilityIndex / 8);
  const bitIndex = availabilityIndex % 8;
  const bitValue = availabilityBuffer[byteIndex] >> bitIndex & 1;
  return bitValue === 1;
}
function getTileType(tile, tileContentUrl = "") {
  if (!tileContentUrl) {
    return TILE_TYPE.EMPTY;
  }
  const contentUrl = tileContentUrl.split("?")[0];
  const fileExtension = contentUrl.split(".").pop();
  switch (fileExtension) {
    case "pnts":
      return TILE_TYPE.POINTCLOUD;
    case "i3dm":
    case "b3dm":
    case "glb":
    case "gltf":
      return TILE_TYPE.SCENEGRAPH;
    default:
      return fileExtension || TILE_TYPE.EMPTY;
  }
}
function getRefine(refine) {
  switch (refine) {
    case "REPLACE":
    case "replace":
      return TILE_REFINEMENT.REPLACE;
    case "ADD":
    case "add":
      return TILE_REFINEMENT.ADD;
    default:
      return refine;
  }
}
function resolveUri(uri, basePath) {
  const urlSchemeRegex = /^[a-z][0-9a-z+.-]*:/i;
  if (urlSchemeRegex.test(basePath)) {
    const url2 = new URL(uri, `${basePath}/`);
    return decodeURI(url2.toString());
  } else if (uri.startsWith("/")) {
    return uri;
  }
  return resolve$1(basePath, uri);
}
function normalizeTileData(tile, basePath) {
  var _a3;
  if (!tile) {
    return null;
  }
  let tileContentUrl;
  if (tile.content) {
    const contentUri = tile.content.uri || ((_a3 = tile.content) == null ? void 0 : _a3.url);
    if (typeof contentUri !== "undefined") {
      tileContentUrl = resolveUri(contentUri, basePath);
    }
  }
  const tilePostprocessed = {
    ...tile,
    id: tileContentUrl,
    contentUrl: tileContentUrl,
    lodMetricType: LOD_METRIC_TYPE.GEOMETRIC_ERROR,
    lodMetricValue: tile.geometricError,
    transformMatrix: tile.transform,
    type: getTileType(tile, tileContentUrl),
    refine: getRefine(tile.refine)
  };
  return tilePostprocessed;
}
async function normalizeTileHeaders(tileset, basePath, options2) {
  let root2 = null;
  const rootImplicitTilingExtension = getImplicitTilingExtensionData(tileset.root);
  if (rootImplicitTilingExtension && tileset.root) {
    root2 = await normalizeImplicitTileHeaders(tileset.root, tileset, basePath, rootImplicitTilingExtension, options2);
  } else {
    root2 = normalizeTileData(tileset.root, basePath);
  }
  const stack2 = [];
  stack2.push(root2);
  while (stack2.length > 0) {
    const tile = stack2.pop() || {};
    const children = tile.children || [];
    const childrenPostprocessed = [];
    for (const childHeader of children) {
      const childImplicitTilingExtension = getImplicitTilingExtensionData(childHeader);
      let childHeaderPostprocessed;
      if (childImplicitTilingExtension) {
        childHeaderPostprocessed = await normalizeImplicitTileHeaders(childHeader, tileset, basePath, childImplicitTilingExtension, options2);
      } else {
        childHeaderPostprocessed = normalizeTileData(childHeader, basePath);
      }
      if (childHeaderPostprocessed) {
        childrenPostprocessed.push(childHeaderPostprocessed);
        stack2.push(childHeaderPostprocessed);
      }
    }
    tile.children = childrenPostprocessed;
  }
  return root2;
}
async function normalizeImplicitTileHeaders(tile, tileset, basePath, implicitTilingExtension, options2) {
  var _a3, _b3, _c2;
  const { subdivisionScheme, maximumLevel, availableLevels, subtreeLevels, subtrees: { uri: subtreesUriTemplate } } = implicitTilingExtension;
  const replacedUrlTemplate = replaceContentUrlTemplate(subtreesUriTemplate, 0, 0, 0, 0);
  const subtreeUrl = resolveUri(replacedUrlTemplate, basePath);
  const subtree = await load(subtreeUrl, Tile3DSubtreeLoader, options2);
  const tileContentUri = (_a3 = tile.content) == null ? void 0 : _a3.uri;
  const contentUrlTemplate = tileContentUri ? resolveUri(tileContentUri, basePath) : "";
  const refine = (_b3 = tileset == null ? void 0 : tileset.root) == null ? void 0 : _b3.refine;
  const rootLodMetricValue = tile.geometricError;
  const s2VolumeInfo = (_c2 = tile.boundingVolume.extensions) == null ? void 0 : _c2["3DTILES_bounding_volume_S2"];
  if (s2VolumeInfo) {
    const box = convertS2BoundingVolumetoOBB(s2VolumeInfo);
    const s2VolumeBox = { box, s2VolumeInfo };
    tile.boundingVolume = s2VolumeBox;
  }
  const rootBoundingVolume = tile.boundingVolume;
  const implicitOptions = {
    contentUrlTemplate,
    subtreesUriTemplate,
    subdivisionScheme,
    subtreeLevels,
    maximumLevel: Number.isFinite(availableLevels) ? availableLevels - 1 : maximumLevel,
    refine,
    basePath,
    lodMetricType: LOD_METRIC_TYPE.GEOMETRIC_ERROR,
    rootLodMetricValue,
    rootBoundingVolume,
    getTileType,
    getRefine
  };
  return await normalizeImplicitTileData(tile, basePath, subtree, implicitOptions, options2);
}
async function normalizeImplicitTileData(tile, basePath, rootSubtree, implicitOptions, loaderOptions) {
  if (!tile) {
    return null;
  }
  const { children, contentUrl } = await parseImplicitTiles({
    subtree: rootSubtree,
    implicitOptions,
    loaderOptions
  });
  let tileContentUrl;
  let tileContent = null;
  if (contentUrl) {
    tileContentUrl = contentUrl;
    tileContent = { uri: contentUrl.replace(`${basePath}/`, "") };
  }
  const tilePostprocessed = {
    ...tile,
    id: tileContentUrl,
    contentUrl: tileContentUrl,
    lodMetricType: LOD_METRIC_TYPE.GEOMETRIC_ERROR,
    lodMetricValue: tile.geometricError,
    transformMatrix: tile.transform,
    type: getTileType(tile, tileContentUrl),
    refine: getRefine(tile.refine),
    content: tileContent || tile.content,
    children
  };
  return tilePostprocessed;
}
function getImplicitTilingExtensionData(tile) {
  var _a3;
  return ((_a3 = tile == null ? void 0 : tile.extensions) == null ? void 0 : _a3["3DTILES_implicit_tiling"]) || (tile == null ? void 0 : tile.implicitTiling);
}
const Tiles3DLoader = {
  dataType: null,
  batchType: null,
  id: "3d-tiles",
  name: "3D Tiles",
  module: "3d-tiles",
  version: VERSION$4,
  extensions: ["cmpt", "pnts", "b3dm", "i3dm"],
  mimeTypes: ["application/octet-stream"],
  tests: ["cmpt", "pnts", "b3dm", "i3dm"],
  parse: parse$1,
  options: {
    "3d-tiles": {
      loadGLTF: true,
      decodeQuantizedPositions: false,
      isTileset: "auto",
      assetGltfUpAxis: null
    }
  }
};
async function parse$1(data2, options2 = {}, context2) {
  const loaderOptions = options2["3d-tiles"] || {};
  let isTileset;
  if (loaderOptions.isTileset === "auto") {
    isTileset = (context2 == null ? void 0 : context2.url) && context2.url.indexOf(".json") !== -1;
  } else {
    isTileset = loaderOptions.isTileset;
  }
  return isTileset ? parseTileset(data2, options2, context2) : parseTile(data2, options2, context2);
}
async function parseTileset(data2, options2, context2) {
  var _a3;
  const tilesetJson = JSON.parse(new TextDecoder().decode(data2));
  const tilesetUrl = (context2 == null ? void 0 : context2.url) || "";
  const basePath = getBaseUri(tilesetUrl);
  const normalizedRoot = await normalizeTileHeaders(tilesetJson, basePath, options2 || {});
  const tilesetJsonPostprocessed = {
    ...tilesetJson,
    shape: "tileset3d",
    loader: Tiles3DLoader,
    url: tilesetUrl,
    queryString: (context2 == null ? void 0 : context2.queryString) || "",
    basePath,
    root: normalizedRoot || tilesetJson.root,
    type: TILESET_TYPE.TILES3D,
    lodMetricType: LOD_METRIC_TYPE.GEOMETRIC_ERROR,
    lodMetricValue: ((_a3 = tilesetJson.root) == null ? void 0 : _a3.geometricError) || 0
  };
  return tilesetJsonPostprocessed;
}
async function parseTile(arrayBuffer2, options2, context2) {
  const tile = {
    content: {
      shape: "tile3d",
      featureIds: null
    }
  };
  const byteOffset = 0;
  await parse3DTile(arrayBuffer2, byteOffset, options2, context2, tile.content);
  return tile.content;
}
function getBaseUri(tilesetUrl) {
  return dirname(tilesetUrl);
}
function Tiles3dLayerInternal(props) {
  const {
    id,
    data: url2,
    token,
    opacity,
    color,
    onLoad,
    minZoom,
    maxZoom,
    ...restProps
  } = props;
  const [layer, setLayer] = React__default.useState();
  const layerRef = useValueRef(layer);
  React__default.useLayoutEffect(() => {
    if (!url2 || !id || layerRef.current)
      return;
    const headers = token ? {
      Authorization: `Bearer ${token}`
    } : {};
    const layer2 = new Tile3DLayer({
      id,
      data: url2,
      loader: Tiles3DLoader,
      loadOptions: {
        fetch: {
          headers
        }
      },
      onTilesetLoad: (tileset) => {
        onLoad(tileset);
      },
      pointSize: 2,
      opacity,
      color,
      ...restProps
    });
    setLayer(layer2);
  }, [color, id, layer, layerRef, onLoad, opacity, restProps, token, url2]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, minZoom, maxZoom });
}
Tiles3dLayerInternal.propTypes = {
  id: propTypesExports$1.string.isRequired,
  data: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.string]).isRequired,
  opacity: propTypesExports$1.number,
  color: propTypesExports$1.oneOfType([propTypesExports$1.number, propTypesExports$1.string]),
  onLoad: propTypesExports$1.func,
  token: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number
};
Tiles3dLayerInternal.defaultProps = {
  opacity: 1,
  color: "#f5fefd",
  onLoad: () => {
  },
  token: "",
  minZoom: 0,
  maxZoom: 24
};
function Tiles3dLayer$2(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(Tiles3dLayerInternal, { ...props }) });
}
function HeatmapInternal$1(props) {
  const {
    id,
    data: url2,
    valuePropName,
    beforeId,
    aggregation,
    radius,
    colorRange,
    colorDomain,
    minZoom,
    maxZoom,
    colorPropName,
    color,
    extruded,
    elevationScale,
    ...restProps
  } = props;
  const mvtLayerRef = React__default.useRef();
  const [heatmapData, setHeatmapData] = React__default.useState([]);
  const [layer, setLayer] = React__default.useState(null);
  const mvtLayer = useDeckGlMvtLayer({
    id: `${id}-mvt`,
    ref: mvtLayerRef,
    url: url2,
    minZoom,
    maxZoom,
    colorPropName,
    color,
    onFeatures: (f2) => setHeatmapData(f2)
  });
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName || !mvtLayer)
      return;
    const heatmap = DeckGlUtil.createHexagonLayer({
      id: `${id}-heatmap`,
      data: heatmapData,
      aggregation,
      valuePropName,
      radius,
      colorDomain,
      colorRange,
      extruded,
      elevationScale
    });
    const layers = [mvtLayer, heatmap];
    setLayer(layers);
  }, [beforeId, id, valuePropName, aggregation, radius, colorDomain, colorRange, url2, minZoom, maxZoom, colorPropName, color, extruded, elevationScale, heatmapData, mvtLayer]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
HeatmapInternal$1.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  beforeId: propTypesExports$1.string,
  radius: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorDomain: propTypesExports$1.array,
  aggregation: propTypesExports$1.oneOf(["MEAN", "SUM"]),
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any,
  extruded: propTypesExports$1.bool,
  elevationScale: propTypesExports$1.number
};
HeatmapInternal$1.defaultProps = {
  id: "",
  data: null,
  valuePropName: null,
  beforeId: "",
  radius: 100,
  // in meter
  colorRange: [[22, 119, 255, 25], [22, 119, 255, 50], [22, 119, 255, 90], [22, 119, 255, 128], [22, 119, 255, 216]],
  colorDomain: null,
  aggregation: "MEAN",
  minZoom: 0,
  maxZoom: 24,
  colorPropName: null,
  color: "#FF0000",
  extruded: true,
  elevationScale: 1
};
function HexmapTiles(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(HeatmapInternal$1, { ...props }) });
}
function HeatmapInternal(props) {
  const {
    id,
    data: data2,
    valuePropName,
    beforeId,
    aggregation,
    radius,
    colorRange,
    colorDomain,
    extruded,
    elevationScale,
    ...restProps
  } = props;
  const json = useEditGeojson({
    data: data2
  });
  const features = React__default.useMemo(() => {
    var _a3;
    return (_a3 = json == null ? void 0 : json.features) == null ? void 0 : _a3.filter((f2) => f2.geometry.type === "Point");
  }, [json == null ? void 0 : json.features]);
  const [layer, setLayer] = React__default.useState();
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName)
      return;
    const layer2 = DeckGlUtil.createHexagonLayer({
      id,
      data: features,
      aggregation,
      valuePropName,
      radius,
      colorDomain,
      colorRange,
      extruded,
      elevationScale
    });
    setLayer(layer2);
  }, [beforeId, features, id, valuePropName, aggregation, radius, colorDomain, colorRange, extruded, elevationScale]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
HeatmapInternal.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  beforeId: propTypesExports$1.string,
  radius: propTypesExports$1.number,
  intensity: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorDomain: propTypesExports$1.array,
  aggregation: propTypesExports$1.oneOf(["MEAN", "SUM"]),
  extruded: propTypesExports$1.bool,
  elevationScale: propTypesExports$1.number
};
HeatmapInternal.defaultProps = {
  id: "",
  data: null,
  valuePropName: null,
  beforeId: "",
  radius: 100,
  // in meter
  intensity: 1,
  colorRange: [[22, 119, 255, 25], [22, 119, 255, 50], [22, 119, 255, 90], [22, 119, 255, 128], [22, 119, 255, 216]],
  colorDomain: null,
  aggregation: "MEAN",
  extruded: true,
  elevationScale: 1
};
function HexmapGeojson(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(HeatmapInternal, { ...props }) });
}
function Hexmap(props) {
  const {
    type,
    ...restProps
  } = props;
  if (type === "vector")
    return /* @__PURE__ */ jsx(HexmapTiles, { ...restProps });
  return /* @__PURE__ */ jsx(HexmapGeojson, { ...restProps });
}
Hexmap.propTypes = {
  type: propTypesExports$1.oneOf(["vector", "geojson"])
};
Hexmap.defaultProps = {
  type: "geojson"
};
function QuadmapInternal$1(props) {
  const {
    id,
    data: url2,
    valuePropName,
    indexPropName,
    colorRange,
    colorDomain,
    elevationScale,
    extruded,
    opacity,
    minZoom,
    maxZoom,
    colorPropName,
    color,
    colorMap,
    ...restProps
  } = props;
  const mvtLayerRef = React__default.useRef();
  const [heatmapData, setHeatmapData] = React__default.useState([]);
  const [layer, setLayer] = React__default.useState(null);
  const mvtLayer = useDeckGlMvtLayer({
    id: `${id}-mvt`,
    ref: mvtLayerRef,
    url: url2,
    minZoom,
    maxZoom,
    colorPropName,
    color,
    valuePropName,
    indexPropName,
    colorRange,
    colorDomain,
    colorMap,
    onFeatures: (f2) => setHeatmapData(f2),
    getPointRadius: 1,
    pointRadiusUnits: "pixels",
    lineWidth: 0
  });
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName || !mvtLayer)
      return;
    const quadmap = DeckGlUtil.createQuadLayer({
      id: `${id}-quadmap`,
      data: heatmapData,
      indexPropName,
      valuePropName,
      opacity,
      colorDomain,
      colorRange,
      colorMap,
      elevationScale,
      extruded
    });
    const layers = [mvtLayer, quadmap];
    setLayer(layers);
  }, [id, valuePropName, indexPropName, opacity, colorDomain, colorRange, elevationScale, extruded, mvtLayer, heatmapData, colorMap]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
QuadmapInternal$1.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  indexPropName: propTypesExports$1.string,
  opacity: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorMap: propTypesExports$1.string,
  colorDomain: propTypesExports$1.array,
  extruded: propTypesExports$1.bool,
  elevationScale: propTypesExports$1.number,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any
};
QuadmapInternal$1.defaultProps = {
  id: "",
  data: null,
  valuePropName: null,
  indexPropName: "quadkey",
  opacity: 0.8,
  colorRange: null,
  colorMap: "cooltowarm",
  colorDomain: null,
  extruded: true,
  elevationScale: 1,
  minZoom: 0,
  maxZoom: 24,
  colorPropName: null,
  // this will override the value based colors
  color: null
  // this will override the value based colors
};
function QuadmapTiles(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(QuadmapInternal$1, { ...props }) });
}
function QuadmapInternal(props) {
  const {
    id,
    data: data2,
    valuePropName,
    indexPropName,
    colorRange,
    colorDomain,
    colorMap,
    elevationScale,
    extruded,
    opacity,
    ...restProps
  } = props;
  const [layer, setLayer] = React__default.useState();
  const features = React__default.useMemo(() => {
    if (Array.isArray(data2))
      return data2;
    return data2 == null ? void 0 : data2.features;
  }, [data2]);
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName)
      return;
    const layer2 = DeckGlUtil.createQuadLayer({
      id,
      data: features,
      indexPropName,
      valuePropName,
      opacity,
      colorDomain,
      colorRange,
      colorMap,
      elevationScale,
      extruded
    });
    setLayer(layer2);
  }, [id, valuePropName, features, indexPropName, opacity, colorDomain, colorRange, elevationScale, extruded, colorMap]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
QuadmapInternal.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  indexPropName: propTypesExports$1.string,
  opacity: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorMap: propTypesExports$1.string,
  colorDomain: propTypesExports$1.array,
  extruded: propTypesExports$1.bool,
  elevationScale: propTypesExports$1.number
};
QuadmapInternal.defaultProps = {
  id: "",
  data: null,
  valuePropName: null,
  indexPropName: "quadkey",
  opacity: 0.8,
  colorRange: null,
  colorMap: "cooltowarm",
  colorDomain: null,
  extruded: true,
  elevationScale: 1
};
function QuadmapGeojson(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(QuadmapInternal, { ...props }) });
}
function Quadmap(props) {
  const {
    type,
    ...restProps
  } = props;
  if (type === "vector")
    return /* @__PURE__ */ jsx(QuadmapTiles, { ...restProps });
  return /* @__PURE__ */ jsx(QuadmapGeojson, { ...restProps });
}
Quadmap.propTypes = {
  type: propTypesExports$1.oneOf(["vector", "geojson"])
};
Quadmap.defaultProps = {
  type: "geojson"
};
function H3MapInternal$1(props) {
  const {
    id,
    data: url2,
    valuePropName,
    indexPropName,
    colorRange,
    colorDomain,
    elevationScale,
    extruded,
    opacity,
    minZoom,
    maxZoom,
    colorPropName,
    color,
    colorMap,
    ...restProps
  } = props;
  const mvtLayerRef = React__default.useRef();
  const [heatmapData, setHeatmapData] = React__default.useState([]);
  const [layer, setLayer] = React__default.useState(null);
  const mvtLayer = useDeckGlMvtLayer({
    id: `${id}-mvt`,
    ref: mvtLayerRef,
    url: url2,
    minZoom,
    maxZoom,
    colorPropName,
    color,
    valuePropName,
    indexPropName,
    colorRange,
    colorDomain,
    colorMap,
    onFeatures: (f2) => setHeatmapData(f2),
    getPointRadius: 1,
    pointRadiusUnits: "pixels",
    lineWidth: 0,
    opacity
  });
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName || !mvtLayer)
      return;
    const quadmap = DeckGlUtil.createH3HexagonLayer({
      id: `${id}-h3map`,
      data: heatmapData,
      indexPropName,
      valuePropName,
      opacity,
      colorRange,
      colorDomain,
      colorMap,
      elevationScale,
      extruded
    });
    const layers = [mvtLayer, quadmap];
    setLayer(layers);
  }, [id, valuePropName, opacity, colorDomain, colorRange, elevationScale, extruded, mvtLayer, heatmapData, indexPropName, colorMap]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
H3MapInternal$1.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.array, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  indexPropName: propTypesExports$1.string,
  opacity: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorMap: propTypesExports$1.string,
  colorDomain: propTypesExports$1.array,
  extruded: propTypesExports$1.bool,
  elevationScale: propTypesExports$1.number,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any
};
H3MapInternal$1.defaultProps = {
  id: "",
  data: null,
  indexPropName: "hex",
  valuePropName: null,
  opacity: 0.8,
  colorRange: null,
  colorMap: "cooltowarm",
  colorDomain: null,
  extruded: true,
  elevationScale: 1,
  minZoom: 0,
  maxZoom: 24,
  colorPropName: null,
  color: null
};
function H3Tiles(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(H3MapInternal$1, { ...props }) });
}
function H3MapInternal(props) {
  const {
    id,
    data: data2,
    valuePropName,
    indexPropName,
    colorRange,
    colorDomain,
    elevationScale,
    extruded,
    opacity,
    colorMap,
    ...restProps
  } = props;
  const [layer, setLayer] = React__default.useState();
  const features = React__default.useMemo(() => {
    if (Array.isArray(data2))
      return data2;
    return data2 == null ? void 0 : data2.features;
  }, [data2]);
  React__default.useLayoutEffect(() => {
    if (!id || !valuePropName)
      return;
    const layer2 = DeckGlUtil.createH3HexagonLayer({
      id,
      data: features,
      indexPropName,
      valuePropName,
      opacity,
      colorRange,
      colorDomain,
      colorMap,
      elevationScale,
      extruded
    });
    setLayer(layer2);
  }, [id, valuePropName, indexPropName, opacity, colorRange, colorDomain, elevationScale, extruded, features, colorMap]);
  if (!layer)
    return null;
  return /* @__PURE__ */ jsx(DeckGlOverlay, { layer, ...restProps });
}
H3MapInternal.propTypes = {
  id: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.array, propTypesExports$1.object]),
  valuePropName: propTypesExports$1.string,
  indexPropName: propTypesExports$1.string,
  opacity: propTypesExports$1.number,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  colorMap: propTypesExports$1.string,
  colorDomain: propTypesExports$1.array,
  extruded: propTypesExports$1.bool,
  elevationScale: propTypesExports$1.number
};
H3MapInternal.defaultProps = {
  id: "",
  data: null,
  indexPropName: "hex",
  valuePropName: null,
  opacity: 0.8,
  colorRange: null,
  colorMap: "cooltowarm",
  colorDomain: null,
  extruded: true,
  elevationScale: 1e4
};
function H3MapGeojson(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(H3MapInternal, { ...props }) });
}
function H3Map(props) {
  const {
    type,
    ...restProps
  } = props;
  if (type === "vector")
    return /* @__PURE__ */ jsx(H3Tiles, { ...restProps });
  return /* @__PURE__ */ jsx(H3MapGeojson, { ...restProps });
}
H3Map.propTypes = {
  type: propTypesExports$1.oneOf(["vector", "geojson"])
};
H3Map.defaultProps = {
  type: "geojson"
};
function TheMap(props) {
  const {
    children,
    style: style2,
    tilesetUrl,
    center: center2,
    enableDoubleClickZoom,
    onLoad: onLoadIn,
    reuseMaps,
    camera,
    id,
    deckgl,
    transformRequest: transformRequestIn,
    ...restProps
  } = props;
  const [theMap, setTheMap] = React__default.useState(null);
  const [initialCenter] = React__default.useState(center2);
  const accessToken = useEnvStore((state) => state.env.mapboxToken);
  const transformRequest = useEnvStore((state) => transformRequestIn || state.env.transformRequest);
  const onLoad = React__default.useCallback((event) => {
    if (event == null ? void 0 : event.target) {
      const map5 = event.target;
      setTheMap(map5);
      onLoadIn(map5);
    }
  }, [onLoadIn]);
  React__default.useLayoutEffect(() => {
    if (theMap) {
      if (enableDoubleClickZoom) {
        theMap.doubleClickZoom.enable();
      } else {
        theMap.doubleClickZoom.disable();
      }
    }
  }, [enableDoubleClickZoom, theMap]);
  React__default.useLayoutEffect(() => {
    const onError = (data2) => {
      console.error("Mapbox error:", data2);
    };
    theMap == null ? void 0 : theMap.on("error", onError);
    return () => {
      theMap == null ? void 0 : theMap.off("error", onError);
    };
  }, [theMap]);
  const {
    bearing: bearing2,
    pitch,
    zoom: zoom2
  } = camera;
  if (!accessToken)
    return null;
  return /* @__PURE__ */ jsxs(
    Map$7,
    {
      id,
      mapStyle: tilesetUrl,
      style: {
        height: "100%",
        width: "100%",
        ...style2
      },
      mapboxAccessToken: accessToken,
      initialViewState: {
        longitude: initialCenter[0],
        latitude: initialCenter[1],
        bearing: [bearing2],
        pitch: [pitch],
        zoom: [zoom2]
        // projection: 'globe' // TODO: testing
      },
      onLoad,
      antialias: true,
      reuseMaps,
      RTLTextPlugin: false,
      transformRequest,
      ...restProps,
      pitchWithRotate: true,
      attributionControl: false,
      children: [
        !!theMap && /* @__PURE__ */ jsx(CameraFocus, { ...camera, center: center2 }),
        !!theMap && /* @__PURE__ */ jsx(MapboxDeckGlOverlayProvider, { ...deckgl, children })
      ]
    }
  );
}
TheMap.propTypes = {
  /**
   * children
   */
  children: propTypesExports$1.node,
  style: propTypesExports$1.object,
  tilesetUrl: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  enableDoubleClickZoom: propTypesExports$1.bool,
  onLoad: propTypesExports$1.func,
  reuseMaps: propTypesExports$1.bool,
  id: propTypesExports$1.string,
  camera: propTypesExports$1.shape({
    bearing: propTypesExports$1.number,
    pitch: propTypesExports$1.number,
    zoom: propTypesExports$1.number,
    pitchWithRotate: propTypesExports$1.bool,
    enableRotate: propTypesExports$1.bool
  }),
  deckgl: propTypesExports$1.object,
  transformRequest: propTypesExports$1.func
};
TheMap.defaultProps = {
  children: null,
  style: {},
  tilesetUrl: MapTilesConstants.Streets.tilesetUrl,
  center: [],
  enableDoubleClickZoom: false,
  onLoad: () => {
  },
  reuseMaps: false,
  id: "defaultMap",
  camera: {},
  deckgl: {},
  transformRequest: void 0
};
TheMap.Provider = MapProvider;
function StaticMap(props) {
  const {
    center: center2,
    zoom: zoom2,
    bearing: bearing2,
    pitch,
    tilesetUrl
  } = props;
  const [image, setImage] = React__default.useState();
  const [size12, setSize] = React__default.useState(null);
  const containerRef = React__default.useRef(null);
  const isLoadingRef = React__default.useRef(false);
  React__default.useLayoutEffect(() => {
    var _a3, _b3;
    const rect = (_b3 = (_a3 = containerRef.current) == null ? void 0 : _a3.getBoundingClientRect) == null ? void 0 : _b3.call(_a3);
    if (rect) {
      const {
        width,
        height
      } = rect;
      const MAX = 1280;
      if (width > height) {
        setSize({
          width: MAX,
          height: Math.floor(MAX / width * height)
        });
      } else {
        setSize({
          height: MAX,
          width: Math.floor(MAX / height * width)
        });
      }
    }
  }, []);
  const accessToken = useEnvStore((state) => state.env.mapboxToken);
  const loadImage2 = React__default.useCallback(async () => {
    if (!center2 || typeof tilesetUrl !== "string")
      return;
    if (isLoadingRef.current)
      return;
    const {
      width,
      height
    } = size12 || {};
    if (!width || !height)
      return;
    isLoadingRef.current = true;
    try {
      const [longitude, latitude] = center2;
      const styleId = tilesetUrl.replace("mapbox://styles/", "");
      const mapboxUrl = `https://api.mapbox.com/styles/v1/${styleId}/static/${longitude},${latitude},${zoom2},${bearing2},${pitch}/${width}x${height}@2x?access_token=${accessToken}`;
      const response = await fetch(mapboxUrl);
      if (response.ok) {
        const blob = await response.blob();
        const img = URL.createObjectURL(blob);
        setImage(img);
      }
    } catch (error2) {
      console.error(error2);
    }
    isLoadingRef.current = false;
  }, [accessToken, bearing2, center2, size12, pitch, tilesetUrl, zoom2]);
  React__default.useLayoutEffect(() => {
    loadImage2();
  }, [loadImage2]);
  return /* @__PURE__ */ jsx("div", { ref: containerRef, style: {
    width: "100%",
    height: "100%"
  }, children: image && /* @__PURE__ */ jsx(Image$1, { src: image, preview: false, alt: "map", width: "100%", height: "100%" }) });
}
StaticMap.propTypes = {
  center: propTypesExports$1.array,
  zoom: propTypesExports$1.number,
  bearing: propTypesExports$1.number,
  pitch: propTypesExports$1.number,
  tilesetUrl: propTypesExports$1.string
};
StaticMap.defaultProps = {
  center: null,
  zoom: 0,
  bearing: 0,
  pitch: 0,
  tilesetUrl: MapTilesConstants.Streets.tilesetUrl
};
function Overlay(props) {
  const {
    children,
    backgroundColor,
    containerStyle: containerStyle2,
    style: style2
  } = props;
  return /* @__PURE__ */ jsx("div", { style: {
    position: "absolute",
    zIndex: 1e3,
    backgroundColor,
    width: "100%",
    height: "100%",
    display: "initial",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    ...containerStyle2
  }, children: /* @__PURE__ */ jsx("div", { style: {
    height: "100%",
    padding: "0",
    overflow: "hidden",
    position: "relative",
    marginTop: "0px",
    ...style2
  }, children }) });
}
Overlay.propTypes = {
  children: propTypesExports$1.node,
  backgroundColor: propTypesExports$1.string,
  containerStyle: propTypesExports$1.object,
  style: propTypesExports$1.object
};
Overlay.defaultProps = {
  children: "",
  backgroundColor: "transparent",
  containerStyle: {},
  style: {}
};
function LazyMap(props) {
  const {
    loading: loading2,
    trigger: trigger2,
    camera,
    tilesetUrl: tilesetUrlIn,
    onLoad: onLoadIn,
    overlay,
    ...restProps
  } = props;
  const [map5, setMap] = React__default.useState(null);
  const [isRendered, setIsRendered] = React__default.useState(false);
  const onLoad = React__default.useCallback((map22) => {
    setMap(map22);
    onLoadIn(map22);
  }, [onLoadIn]);
  React__default.useEffect(() => {
    if (map5) {
      const isRegistered = {
        current: false
      };
      const onLoad2 = () => {
        setIsRendered(true);
        if (isRegistered.current) {
          isRegistered.current = false;
          map5.off(trigger2, onLoad2);
        }
      };
      map5.on(trigger2, onLoad2);
      isRegistered.current = true;
      return () => {
        if (isRegistered.current) {
          isRegistered.current = false;
          map5.off(trigger2, onLoad2);
        }
      };
    }
    return () => {
    };
  }, [map5, trigger2]);
  const isTilesetObject = typeof tilesetUrlIn !== "string";
  return /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    height: "100%"
  }, children: [
    /* @__PURE__ */ jsx(TheMap, { onLoad, camera, tilesetUrl: tilesetUrlIn, ...restProps }),
    (loading2 || !isRendered) && overlay && !isTilesetObject && /* @__PURE__ */ jsx(Overlay, { children: /* @__PURE__ */ jsx(StaticMap, { ...camera, tilesetUrl: tilesetUrlIn, ...restProps }) })
  ] });
}
LazyMap.propTypes = {
  overlay: propTypesExports$1.bool,
  loading: propTypesExports$1.bool,
  // effective when overlay is true
  trigger: propTypesExports$1.oneOf(["load", "render", "data", "styledata", "styledata"]),
  // overaly will phase out on this trigger
  camera: propTypesExports$1.object,
  tilesetUrl: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  onLoad: propTypesExports$1.func
};
LazyMap.defaultProps = {
  loading: false,
  overlay: false,
  trigger: "render",
  camera: {},
  tilesetUrl: MapTilesConstants.Streets.tilesetUrl,
  onLoad: () => {
  }
};
LazyMap.Provider = TheMap.Provider;
const useMapListener = (props) => {
  const {
    layerIds,
    sourceId,
    sourceLayer,
    isRaster,
    stateKey
  } = props || {};
  const {
    map: map5
  } = useMapbox();
  const onClearRef = React__default.useRef(null);
  const lastFeatureRef = React__default.useRef(null);
  const updateFeatureState = React__default.useCallback((feature2, stateValue) => {
    if (sourceId && feature2.id && stateKey) {
      if (stateValue)
        lastFeatureRef.current = feature2;
      else
        lastFeatureRef.current = null;
      try {
        const hasSource = !!map5.getSource(sourceId);
        if (hasSource) {
          map5.setFeatureState({
            source: sourceId,
            sourceLayer,
            id: feature2.id
          }, {
            [stateKey]: stateValue
          });
        }
      } catch (error2) {
        console.error(error2);
      }
      map5.triggerRepaint();
    }
  }, [map5, sourceId, sourceLayer, stateKey]);
  const onClear = React__default.useCallback(() => {
    if (lastFeatureRef.current) {
      updateFeatureState(lastFeatureRef.current, false);
    }
  }, [updateFeatureState]);
  React__default.useLayoutEffect(() => {
    onClearRef.current = onClear;
  }, [onClear]);
  const onListener = React__default.useCallback((event, clearAllowed) => {
    var _a3, _b3, _c2;
    if (!event)
      return null;
    if (clearAllowed)
      onClearRef.current();
    const {
      features,
      point: mousePoint,
      lngLat
    } = event;
    if (!mousePoint && !(features == null ? void 0 : features.length))
      return null;
    const clickPoint = lngLat ? CoordinateUtil.toArray(lngLat) : null;
    let selectedFeature = features == null ? void 0 : features[0];
    if (selectedFeature) {
      updateFeatureState(selectedFeature, true);
      selectedFeature.clickPoint = clickPoint;
      return selectedFeature;
    }
    if (isRaster && sourceId) {
      const {
        sources: sources2
      } = map5.getStyle();
      if (((_a3 = sources2 == null ? void 0 : sources2[sourceId]) == null ? void 0 : _a3.type) === "image" || ((_b3 = sources2 == null ? void 0 : sources2[sourceId]) == null ? void 0 : _b3.coordinates)) {
        const loop2 = sources2[sourceId].coordinates.map((coord) => [...coord]);
        loop2.push([...sources2[sourceId].coordinates[0]]);
        const feature2 = {
          id: void 0,
          // dummy feature (cannot be selected)
          type: "Feature",
          properties: {
            sourceId
          },
          geometry: {
            type: "Polygon",
            coordinates: [loop2]
          }
        };
        const isInside = GeoUtil.isPointInsidePolygon(clickPoint, feature2);
        if (isInside) {
          selectedFeature = feature2;
        }
      }
    }
    if (!selectedFeature) {
      let features2 = null;
      let layers = [];
      if (layerIds) {
        const allLayers = ((_c2 = map5.getStyle()) == null ? void 0 : _c2.layers) || [];
        layers = (Array.isArray(layerIds) ? layerIds : [layerIds]).filter((id) => allLayers.find((item) => item.id === id));
      }
      if (layers.length) {
        features2 = map5.queryRenderedFeatures(mousePoint, {
          layers
        });
      } else {
        features2 = map5.queryRenderedFeatures(mousePoint);
      }
      if (features2.length) {
        [selectedFeature] = features2;
      }
    }
    if (selectedFeature) {
      updateFeatureState(selectedFeature, true);
      selectedFeature.clickPoint = clickPoint;
    }
    return selectedFeature;
  }, [layerIds, map5, sourceId, isRaster, updateFeatureState]);
  return {
    onListener,
    onClear
  };
};
const useSelection = (props) => {
  const {
    enable: enable4,
    ...restProps
  } = props || {};
  const {
    onListener,
    onClear
  } = useMapListener({
    ...restProps,
    stateKey: "select"
  });
  const {
    map: map5
  } = useMapbox();
  const [selection, setSelection] = React__default.useState(null);
  const clearSelection = React__default.useCallback(() => {
    if (selection) {
      onClear();
      setSelection(null);
    }
  }, [onClear, selection]);
  const onClickListener = React__default.useCallback((event) => {
    const feature2 = onListener(event, true);
    setSelection(feature2);
  }, [onListener]);
  React__default.useEffect(() => {
    if (enable4 && map5)
      map5 == null ? void 0 : map5.on("click", onClickListener);
  }, [enable4, map5, onClickListener]);
  React__default.useEffect(() => () => map5 == null ? void 0 : map5.off("click", onClickListener), [map5, onClickListener]);
  return {
    selection,
    clearSelection
  };
};
const useDoubleSelection = (props) => {
  const {
    enable: enable4,
    ...restProps
  } = props || {};
  const {
    map: map5
  } = useMapbox();
  const {
    onListener,
    onClear
  } = useMapListener({
    ...restProps,
    stateKey: "doubleSelect"
  });
  const [doubleSelection, setDoubleSelection] = React__default.useState(null);
  React__default.useLayoutEffect(() => {
    var _a3;
    (_a3 = map5 == null ? void 0 : map5.doubleClickZoom) == null ? void 0 : _a3.disable();
  }, [map5]);
  const clearSelection = React__default.useCallback(() => {
    if (doubleSelection) {
      onClear();
      setDoubleSelection(null);
    }
  }, [doubleSelection, onClear]);
  const onDoubleClickListener = React__default.useCallback((event) => {
    const feature2 = onListener(event, true);
    setDoubleSelection(feature2);
  }, [onListener]);
  React__default.useEffect(() => {
    if (enable4)
      map5 == null ? void 0 : map5.on("dblclick", onDoubleClickListener);
  }, [map5, enable4, onDoubleClickListener]);
  React__default.useEffect(() => () => map5 == null ? void 0 : map5.off("dblclick", onDoubleClickListener), [map5, onDoubleClickListener]);
  return {
    selection: doubleSelection,
    clearSelection
  };
};
function useHover(props) {
  const {
    layerIds,
    enable: enable4,
    ...restProps
  } = props || {};
  const {
    onListener,
    onClear
  } = useMapListener({
    ...restProps,
    layerIds,
    stateKey: "hover"
  });
  const {
    map: map5
  } = useMapbox();
  const [hoverData, setHoverData] = React__default.useState(null);
  const onMouseMove2 = React__default.useCallback((event) => {
    const feature2 = onListener(event, true);
    setHoverData({
      feature: feature2,
      position: [event.lngLat.lng, event.lngLat.lat]
    });
  }, [onListener]);
  const clearHoverData = React__default.useCallback(() => {
    setHoverData((previous) => {
      if (previous) {
        onClear();
      }
      return null;
    });
  }, [onClear]);
  const onMouseLeave = React__default.useCallback((event) => {
    const feature2 = onListener(event, false);
    setHoverData((previous) => {
      if (!feature2 || (previous == null ? void 0 : previous.feature) === feature2) {
        onClear();
        return null;
      }
      return previous;
    });
  }, [onListener, onClear]);
  React__default.useEffect(() => {
    if (enable4) {
      if (layerIds) {
        map5 == null ? void 0 : map5.on("mousemove", layerIds, onMouseMove2);
        map5 == null ? void 0 : map5.on("mouseleave", layerIds, onMouseLeave);
      } else {
        map5 == null ? void 0 : map5.on("mousemove", onMouseMove2);
        map5 == null ? void 0 : map5.on("mouseleave", onMouseLeave);
      }
    }
  }, [enable4, layerIds, map5, onMouseMove2, onMouseLeave]);
  React__default.useEffect(() => () => {
    if (layerIds) {
      map5 == null ? void 0 : map5.off("mousemove", layerIds, onMouseMove2);
      map5 == null ? void 0 : map5.off("mouseleave", layerIds, onMouseLeave);
    } else {
      map5 == null ? void 0 : map5.off("mousemove", onMouseMove2);
      map5 == null ? void 0 : map5.off("mouseleave", onMouseLeave);
    }
  }, [layerIds, map5, onMouseMove2, onMouseLeave]);
  return {
    selection: hoverData,
    clearSelection: clearHoverData
  };
}
const usePointPicker = (props) => {
  const {
    enable: enable4
  } = props || {};
  const {
    map: map5
  } = useMapbox();
  const [clickPosition, setClickPosition] = React__default.useState(null);
  const clearClickPosition = React__default.useCallback(() => {
    if (clickPosition) {
      setClickPosition(null);
    }
  }, [clickPosition]);
  const onClickListener = React__default.useCallback((event) => {
    if (enable4)
      setClickPosition([event.lngLat.lng, event.lngLat.lat]);
  }, [enable4]);
  React__default.useEffect(() => {
    if (enable4 && map5)
      map5 == null ? void 0 : map5.on("click", onClickListener);
  }, [enable4, map5, onClickListener]);
  React__default.useEffect(() => {
    if (enable4 && (map5 == null ? void 0 : map5.getCanvas())) {
      map5.getCanvas().style.cursor = "crosshair";
    }
    return () => {
      if (map5 == null ? void 0 : map5.getCanvas()) {
        map5.getCanvas().style.cursor = "";
      }
    };
  }, [enable4, map5]);
  React__default.useEffect(() => () => map5 == null ? void 0 : map5.off("click", onClickListener), [map5, onClickListener]);
  return {
    position: clickPosition,
    clearPosition: clearClickPosition
  };
};
function Interactions(props) {
  const {
    layerIds,
    sourceId,
    sourceLayer,
    onSelect,
    onDoubleSelect,
    onClickPosition,
    onHover,
    enableSelection,
    enableHover,
    enableDoubleSelection,
    enablePointPicking,
    clearSelections,
    onClearSelections,
    isRaster
  } = props;
  const {
    map: map5
  } = useMapbox();
  const {
    selection: hoverSelection,
    clearSelection: clearHoverSelection
  } = useHover({
    enable: enableHover,
    sourceId,
    sourceLayer,
    layerIds,
    isRaster
  });
  const {
    selection: tempSelection,
    clearSelection
  } = useSelection({
    enable: enableSelection,
    sourceId,
    sourceLayer,
    layerIds,
    isRaster
  });
  const {
    doubleSelection,
    clearSelection: clearDoubleSelection
  } = useDoubleSelection({
    enable: enableDoubleSelection,
    sourceId,
    sourceLayer,
    layerIds,
    isRaster
  });
  const {
    position,
    clearPosition: clearClickPosition
  } = usePointPicker({
    enable: enablePointPicking
  });
  const selection = doubleSelection === tempSelection ? null : tempSelection;
  React__default.useEffect(() => {
    if (clearSelections) {
      if (enableSelection)
        clearSelection();
      if (enableDoubleSelection)
        clearDoubleSelection();
      if (enablePointPicking)
        clearClickPosition();
      if (enableHover)
        clearHoverSelection();
      onClearSelections();
    }
  }, [clearClickPosition, clearDoubleSelection, clearSelection, clearHoverSelection, clearSelections, enablePointPicking, enableDoubleSelection, enableSelection, onClearSelections, enableHover]);
  React__default.useEffect(() => {
    if (selection && enableSelection && !clearSelections) {
      onSelect(selection, map5);
    }
  }, [clearSelections, enableSelection, map5, onSelect, selection]);
  React__default.useEffect(() => {
    if (doubleSelection && enableDoubleSelection && !clearSelections) {
      onDoubleSelect(doubleSelection, map5);
    }
  }, [clearSelections, doubleSelection, enableDoubleSelection, map5, onDoubleSelect]);
  React__default.useEffect(() => {
    if (enablePointPicking && position) {
      onClickPosition(position);
    }
  }, [enablePointPicking, onClickPosition, position]);
  React__default.useEffect(() => {
    if (enableHover) {
      onHover(hoverSelection, map5);
    }
  }, [enableHover, onHover, hoverSelection, map5]);
  return null;
}
Interactions.propTypes = {
  layerIds: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.arrayOf(propTypesExports$1.string)]),
  sourceId: propTypesExports$1.string,
  sourceLayer: propTypesExports$1.string,
  onSelect: propTypesExports$1.func,
  onDoubleSelect: propTypesExports$1.func,
  onClickPosition: propTypesExports$1.func,
  onHover: propTypesExports$1.func,
  enableHover: propTypesExports$1.bool,
  enableSelection: propTypesExports$1.bool,
  enableDoubleSelection: propTypesExports$1.bool,
  enablePointPicking: propTypesExports$1.bool,
  clearSelections: propTypesExports$1.bool,
  onClearSelections: propTypesExports$1.func,
  isRaster: propTypesExports$1.bool
};
Interactions.defaultProps = {
  layerIds: null,
  sourceId: null,
  sourceLayer: null,
  onSelect: () => {
  },
  onDoubleSelect: () => {
  },
  onClickPosition: () => {
  },
  onHover: () => {
  },
  enableHover: false,
  enableSelection: false,
  enableDoubleSelection: false,
  enablePointPicking: false,
  clearSelections: false,
  onClearSelections: () => {
  },
  isRaster: false
};
function useCursor(props) {
  const {
    getCursor: getCustomCursor,
    ...restProps
  } = props || {};
  const {
    map: map5
  } = useMapbox();
  const cursorRef = React__default.useRef();
  const {
    enable: deckGlEnabled,
    addCursorCallback,
    removeCursorCallback
  } = useMapboxDeckGlOverlay();
  const {
    selection
  } = useHover(restProps);
  const getCursorDeckGl = React__default.useCallback(() => {
    if (map5) {
      map5.getCanvas().style.cursor = cursorRef.current;
    }
    return cursorRef.current;
  }, [map5]);
  React__default.useEffect(() => {
    if (!map5 || !deckGlEnabled)
      return () => {
      };
    addCursorCallback(getCursorDeckGl);
    return () => {
      removeCursorCallback(getCursorDeckGl);
    };
  }, [addCursorCallback, deckGlEnabled, getCursorDeckGl, map5, removeCursorCallback]);
  React__default.useLayoutEffect(() => {
    const cursor = getCustomCursor == null ? void 0 : getCustomCursor(selection);
    cursorRef.current = cursor || "";
    if (!deckGlEnabled && map5) {
      map5.getCanvas().style.cursor = cursorRef.current;
    }
  }, [deckGlEnabled, map5, getCustomCursor, selection]);
  return null;
}
const ModeHandler$1 = function(mode2, DrawContext) {
  const handlers2 = {
    drag: [],
    click: [],
    mousemove: [],
    mousedown: [],
    mouseup: [],
    mouseout: [],
    keydown: [],
    keyup: [],
    touchstart: [],
    touchmove: [],
    touchend: [],
    tap: []
  };
  const ctx2 = {
    on(event, selector, fn2) {
      if (handlers2[event] === void 0) {
        throw new Error(`Invalid event type: ${event}`);
      }
      handlers2[event].push({
        selector,
        fn: fn2
      });
    },
    render(id) {
      DrawContext.store.featureChanged(id);
    }
  };
  const delegate = function(eventName, event) {
    const handles = handlers2[eventName];
    let iHandle = handles.length;
    while (iHandle--) {
      const handle = handles[iHandle];
      if (handle.selector(event)) {
        handle.fn.call(ctx2, event);
        DrawContext.store.render();
        DrawContext.ui.updateMapClasses();
        break;
      }
    }
  };
  mode2.start.call(ctx2);
  return {
    render: mode2.render,
    stop() {
      if (mode2.stop)
        mode2.stop();
    },
    trash() {
      if (mode2.trash) {
        mode2.trash();
        DrawContext.store.render();
      }
    },
    combineFeatures() {
      if (mode2.combineFeatures) {
        mode2.combineFeatures();
      }
    },
    uncombineFeatures() {
      if (mode2.uncombineFeatures) {
        mode2.uncombineFeatures();
      }
    },
    drag(event) {
      delegate("drag", event);
    },
    click(event) {
      delegate("click", event);
    },
    mousemove(event) {
      delegate("mousemove", event);
    },
    mousedown(event) {
      delegate("mousedown", event);
    },
    mouseup(event) {
      delegate("mouseup", event);
    },
    mouseout(event) {
      delegate("mouseout", event);
    },
    keydown(event) {
      delegate("keydown", event);
    },
    keyup(event) {
      delegate("keyup", event);
    },
    touchstart(event) {
      delegate("touchstart", event);
    },
    touchmove(event) {
      delegate("touchmove", event);
    },
    touchend(event) {
      delegate("touchend", event);
    },
    tap(event) {
      delegate("tap", event);
    }
  };
};
var geojsonArea = {};
var wgs84$1 = {};
wgs84$1.RADIUS = 6378137;
wgs84$1.FLATTENING = 1 / 298.257223563;
wgs84$1.POLAR_RADIUS = 63567523142e-4;
var wgs84 = wgs84$1;
geojsonArea.geometry = geometry$1;
geojsonArea.ring = ringArea;
function geometry$1(_2) {
  var area5 = 0, i2;
  switch (_2.type) {
    case "Polygon":
      return polygonArea(_2.coordinates);
    case "MultiPolygon":
      for (i2 = 0; i2 < _2.coordinates.length; i2++) {
        area5 += polygonArea(_2.coordinates[i2]);
      }
      return area5;
    case "Point":
    case "MultiPoint":
    case "LineString":
    case "MultiLineString":
      return 0;
    case "GeometryCollection":
      for (i2 = 0; i2 < _2.geometries.length; i2++) {
        area5 += geometry$1(_2.geometries[i2]);
      }
      return area5;
  }
}
function polygonArea(coords) {
  var area5 = 0;
  if (coords && coords.length > 0) {
    area5 += Math.abs(ringArea(coords[0]));
    for (var i2 = 1; i2 < coords.length; i2++) {
      area5 -= Math.abs(ringArea(coords[i2]));
    }
  }
  return area5;
}
function ringArea(coords) {
  var p1, p2, p3, lowerIndex, middleIndex, upperIndex, i2, area5 = 0, coordsLength = coords.length;
  if (coordsLength > 2) {
    for (i2 = 0; i2 < coordsLength; i2++) {
      if (i2 === coordsLength - 2) {
        lowerIndex = coordsLength - 2;
        middleIndex = coordsLength - 1;
        upperIndex = 0;
      } else if (i2 === coordsLength - 1) {
        lowerIndex = coordsLength - 1;
        middleIndex = 0;
        upperIndex = 1;
      } else {
        lowerIndex = i2;
        middleIndex = i2 + 1;
        upperIndex = i2 + 2;
      }
      p1 = coords[lowerIndex];
      p2 = coords[middleIndex];
      p3 = coords[upperIndex];
      area5 += (rad$2(p3[0]) - rad$2(p1[0])) * Math.sin(rad$2(p2[1]));
    }
    area5 = area5 * wgs84.RADIUS * wgs84.RADIUS / 2;
  }
  return area5;
}
function rad$2(_2) {
  return _2 * Math.PI / 180;
}
const classes = {
  CONTROL_BASE: "mapboxgl-ctrl",
  CONTROL_PREFIX: "mapboxgl-ctrl-",
  CONTROL_BUTTON: "mapbox-gl-draw_ctrl-draw-btn",
  CONTROL_BUTTON_LINE: "mapbox-gl-draw_line",
  CONTROL_BUTTON_POLYGON: "mapbox-gl-draw_polygon",
  CONTROL_BUTTON_POINT: "mapbox-gl-draw_point",
  CONTROL_BUTTON_TRASH: "mapbox-gl-draw_trash",
  CONTROL_BUTTON_COMBINE_FEATURES: "mapbox-gl-draw_combine",
  CONTROL_BUTTON_UNCOMBINE_FEATURES: "mapbox-gl-draw_uncombine",
  CONTROL_GROUP: "mapboxgl-ctrl-group",
  ATTRIBUTION: "mapboxgl-ctrl-attrib",
  ACTIVE_BUTTON: "active",
  BOX_SELECT: "mapbox-gl-draw_boxselect"
};
const sources = {
  HOT: "mapbox-gl-draw-hot",
  COLD: "mapbox-gl-draw-cold"
};
const cursors = {
  ADD: "add",
  MOVE: "move",
  DRAG: "drag",
  POINTER: "pointer",
  NONE: "none"
};
const types$1 = {
  POLYGON: "polygon",
  LINE: "line_string",
  POINT: "point"
};
const geojsonTypes = {
  FEATURE: "Feature",
  POLYGON: "Polygon",
  LINE_STRING: "LineString",
  POINT: "Point",
  FEATURE_COLLECTION: "FeatureCollection",
  MULTI_PREFIX: "Multi",
  MULTI_POINT: "MultiPoint",
  MULTI_LINE_STRING: "MultiLineString",
  MULTI_POLYGON: "MultiPolygon"
};
const modes$2 = {
  DRAW_LINE_STRING: "draw_line_string",
  DRAW_POLYGON: "draw_polygon",
  DRAW_POINT: "draw_point",
  SIMPLE_SELECT: "simple_select",
  DIRECT_SELECT: "direct_select",
  STATIC: "static"
};
const events$6 = {
  CREATE: "draw.create",
  DELETE: "draw.delete",
  UPDATE: "draw.update",
  SELECTION_CHANGE: "draw.selectionchange",
  MODE_CHANGE: "draw.modechange",
  ACTIONABLE: "draw.actionable",
  RENDER: "draw.render",
  COMBINE_FEATURES: "draw.combine",
  UNCOMBINE_FEATURES: "draw.uncombine"
};
const updateActions = {
  MOVE: "move",
  CHANGE_COORDINATES: "change_coordinates"
};
const meta = {
  FEATURE: "feature",
  MIDPOINT: "midpoint",
  VERTEX: "vertex"
};
const activeStates = {
  ACTIVE: "true",
  INACTIVE: "false"
};
const interactions$1 = [
  "scrollZoom",
  "boxZoom",
  "dragRotate",
  "dragPan",
  "keyboard",
  "doubleClickZoom",
  "touchZoomRotate"
];
const LAT_MIN$2 = -90;
const LAT_RENDERED_MIN$2 = -85;
const LAT_MAX$2 = 90;
const LAT_RENDERED_MAX$2 = 85;
const LNG_MIN$2 = -270;
const LNG_MAX$2 = 270;
const Constants$s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  LAT_MAX: LAT_MAX$2,
  LAT_MIN: LAT_MIN$2,
  LAT_RENDERED_MAX: LAT_RENDERED_MAX$2,
  LAT_RENDERED_MIN: LAT_RENDERED_MIN$2,
  LNG_MAX: LNG_MAX$2,
  LNG_MIN: LNG_MIN$2,
  activeStates,
  classes,
  cursors,
  events: events$6,
  geojsonTypes,
  interactions: interactions$1,
  meta,
  modes: modes$2,
  sources,
  types: types$1,
  updateActions
}, Symbol.toStringTag, { value: "Module" }));
const FEATURE_SORT_RANKS$1 = {
  Point: 0,
  LineString: 1,
  Polygon: 2
};
function comparator$1(a2, b2) {
  const score = FEATURE_SORT_RANKS$1[a2.geometry.type] - FEATURE_SORT_RANKS$1[b2.geometry.type];
  if (score === 0 && a2.geometry.type === geojsonTypes.POLYGON) {
    return a2.area - b2.area;
  }
  return score;
}
function sortFeatures$2(features) {
  return features.map((feature2) => {
    if (feature2.geometry.type === geojsonTypes.POLYGON) {
      feature2.area = geojsonArea.geometry({
        type: geojsonTypes.FEATURE,
        property: {},
        geometry: feature2.geometry
      });
    }
    return feature2;
  }).sort(comparator$1).map((feature2) => {
    delete feature2.area;
    return feature2;
  });
}
function mapEventToBoundingBox$2(mapEvent, buffer3 = 0) {
  return [
    [mapEvent.point.x - buffer3, mapEvent.point.y - buffer3],
    [mapEvent.point.x + buffer3, mapEvent.point.y + buffer3]
  ];
}
function StringSet$5(items) {
  this._items = {};
  this._nums = {};
  this._length = items ? items.length : 0;
  if (!items)
    return;
  for (let i2 = 0, l2 = items.length; i2 < l2; i2++) {
    this.add(items[i2]);
    if (items[i2] === void 0)
      continue;
    if (typeof items[i2] === "string")
      this._items[items[i2]] = i2;
    else
      this._nums[items[i2]] = i2;
  }
}
StringSet$5.prototype.add = function(x2) {
  if (this.has(x2))
    return this;
  this._length++;
  if (typeof x2 === "string")
    this._items[x2] = this._length;
  else
    this._nums[x2] = this._length;
  return this;
};
StringSet$5.prototype.delete = function(x2) {
  if (this.has(x2) === false)
    return this;
  this._length--;
  delete this._items[x2];
  delete this._nums[x2];
  return this;
};
StringSet$5.prototype.has = function(x2) {
  if (typeof x2 !== "string" && typeof x2 !== "number")
    return false;
  return this._items[x2] !== void 0 || this._nums[x2] !== void 0;
};
StringSet$5.prototype.values = function() {
  const values4 = [];
  Object.keys(this._items).forEach((k2) => {
    values4.push({ k: k2, v: this._items[k2] });
  });
  Object.keys(this._nums).forEach((k2) => {
    values4.push({ k: JSON.parse(k2), v: this._nums[k2] });
  });
  return values4.sort((a2, b2) => a2.v - b2.v).map((a2) => a2.k);
};
StringSet$5.prototype.clear = function() {
  this._length = 0;
  this._items = {};
  this._nums = {};
  return this;
};
const META_TYPES$1 = [
  meta.FEATURE,
  meta.MIDPOINT,
  meta.VERTEX
];
const featuresAt$5 = {
  click: featuresAtClick$1,
  touch: featuresAtTouch$1
};
function featuresAtClick$1(event, bbox2, ctx2) {
  return featuresAt$6(event, bbox2, ctx2, ctx2.options.clickBuffer);
}
function featuresAtTouch$1(event, bbox2, ctx2) {
  return featuresAt$6(event, bbox2, ctx2, ctx2.options.touchBuffer);
}
function featuresAt$6(event, bbox2, ctx2, buffer3) {
  if (ctx2.map === null)
    return [];
  const box = event ? mapEventToBoundingBox$2(event, buffer3) : bbox2;
  const queryParams = {};
  if (ctx2.options.styles)
    queryParams.layers = ctx2.options.styles.map((s2) => s2.id);
  const features = ctx2.map.queryRenderedFeatures(box, queryParams).filter((feature2) => META_TYPES$1.indexOf(feature2.properties.meta) !== -1);
  const featureIds = new StringSet$5();
  const uniqueFeatures = [];
  features.forEach((feature2) => {
    const featureId = feature2.properties.id;
    if (featureIds.has(featureId))
      return;
    featureIds.add(featureId);
    uniqueFeatures.push(feature2);
  });
  return sortFeatures$2(uniqueFeatures);
}
function getFeatureAtAndSetCursors(event, ctx2) {
  const features = featuresAt$5.click(event, null, ctx2);
  const classes2 = { mouse: cursors.NONE };
  if (features[0]) {
    classes2.mouse = features[0].properties.active === activeStates.ACTIVE ? cursors.MOVE : cursors.POINTER;
    classes2.feature = features[0].properties.meta;
  }
  if (ctx2.events.currentModeName().indexOf("draw") !== -1) {
    classes2.mouse = cursors.ADD;
  }
  ctx2.ui.queueMapClasses(classes2);
  ctx2.ui.updateMapClasses();
  return features[0];
}
function euclideanDistance$2(a2, b2) {
  const x2 = a2.x - b2.x;
  const y2 = a2.y - b2.y;
  return Math.sqrt(x2 * x2 + y2 * y2);
}
const FINE_TOLERANCE$1 = 4;
const GROSS_TOLERANCE$1 = 12;
const INTERVAL$3 = 500;
function isClick$1(start2, end, options2 = {}) {
  const fineTolerance = options2.fineTolerance != null ? options2.fineTolerance : FINE_TOLERANCE$1;
  const grossTolerance = options2.grossTolerance != null ? options2.grossTolerance : GROSS_TOLERANCE$1;
  const interval = options2.interval != null ? options2.interval : INTERVAL$3;
  start2.point = start2.point || end.point;
  start2.time = start2.time || end.time;
  const moveDistance = euclideanDistance$2(start2.point, end.point);
  return moveDistance < fineTolerance || moveDistance < grossTolerance && end.time - start2.time < interval;
}
const TOLERANCE$1 = 25;
const INTERVAL$2 = 250;
function isTap$1(start2, end, options2 = {}) {
  const tolerance = options2.tolerance != null ? options2.tolerance : TOLERANCE$1;
  const interval = options2.interval != null ? options2.interval : INTERVAL$2;
  start2.point = start2.point || end.point;
  start2.time = start2.time || end.time;
  const moveDistance = euclideanDistance$2(start2.point, end.point);
  return moveDistance < tolerance && end.time - start2.time < interval;
}
var hatExports = {};
var hat$4 = {
  get exports() {
    return hatExports;
  },
  set exports(v5) {
    hatExports = v5;
  }
};
var hat$3 = hat$4.exports = function(bits, base) {
  if (!base)
    base = 16;
  if (bits === void 0)
    bits = 128;
  if (bits <= 0)
    return "0";
  var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
  for (var i2 = 2; digits === Infinity; i2 *= 2) {
    digits = Math.log(Math.pow(2, bits / i2)) / Math.log(base) * i2;
  }
  var rem = digits - Math.floor(digits);
  var res = "";
  for (var i2 = 0; i2 < Math.floor(digits); i2++) {
    var x2 = Math.floor(Math.random() * base).toString(base);
    res = x2 + res;
  }
  if (rem) {
    var b2 = Math.pow(base, rem);
    var x2 = Math.floor(Math.random() * b2).toString(base);
    res = x2 + res;
  }
  var parsed = parseInt(res, base);
  if (parsed !== Infinity && parsed >= Math.pow(2, bits)) {
    return hat$3(bits, base);
  } else
    return res;
};
hat$3.rack = function(bits, base, expandBy2) {
  var fn2 = function(data2) {
    var iters = 0;
    do {
      if (iters++ > 10) {
        if (expandBy2)
          bits += expandBy2;
        else
          throw new Error("too many ID collisions, use more bits");
      }
      var id = hat$3(bits, base);
    } while (Object.hasOwnProperty.call(hats, id));
    hats[id] = data2;
    return id;
  };
  var hats = fn2.hats = {};
  fn2.get = function(id) {
    return fn2.hats[id];
  };
  fn2.set = function(id, value) {
    fn2.hats[id] = value;
    return fn2;
  };
  fn2.bits = bits || 128;
  fn2.base = base || 16;
  return fn2;
};
const Feature$5 = function(ctx2, geojson) {
  this.ctx = ctx2;
  this.properties = geojson.properties || {};
  this.coordinates = geojson.geometry.coordinates;
  this.id = geojson.id || hatExports();
  this.type = geojson.geometry.type;
};
Feature$5.prototype.changed = function() {
  this.ctx.store.featureChanged(this.id);
};
Feature$5.prototype.incomingCoords = function(coords) {
  this.setCoordinates(coords);
};
Feature$5.prototype.setCoordinates = function(coords) {
  this.coordinates = coords;
  this.changed();
};
Feature$5.prototype.getCoordinates = function() {
  return JSON.parse(JSON.stringify(this.coordinates));
};
Feature$5.prototype.setProperty = function(property2, value) {
  this.properties[property2] = value;
};
Feature$5.prototype.toGeoJSON = function() {
  return JSON.parse(JSON.stringify({
    id: this.id,
    type: geojsonTypes.FEATURE,
    properties: this.properties,
    geometry: {
      coordinates: this.getCoordinates(),
      type: this.type
    }
  }));
};
Feature$5.prototype.internal = function(mode2) {
  const properties = {
    id: this.id,
    meta: meta.FEATURE,
    "meta:type": this.type,
    active: activeStates.INACTIVE,
    mode: mode2
  };
  if (this.ctx.options.userProperties) {
    for (const name2 in this.properties) {
      properties[`user_${name2}`] = this.properties[name2];
    }
  }
  return {
    type: geojsonTypes.FEATURE,
    properties,
    geometry: {
      coordinates: this.getCoordinates(),
      type: this.type
    }
  };
};
const Point$4 = function(ctx2, geojson) {
  Feature$5.call(this, ctx2, geojson);
};
Point$4.prototype = Object.create(Feature$5.prototype);
Point$4.prototype.isValid = function() {
  return typeof this.coordinates[0] === "number" && typeof this.coordinates[1] === "number";
};
Point$4.prototype.updateCoordinate = function(pathOrLng, lngOrLat, lat) {
  if (arguments.length === 3) {
    this.coordinates = [lngOrLat, lat];
  } else {
    this.coordinates = [pathOrLng, lngOrLat];
  }
  this.changed();
};
Point$4.prototype.getCoordinate = function() {
  return this.getCoordinates();
};
const LineString$2 = function(ctx2, geojson) {
  Feature$5.call(this, ctx2, geojson);
};
LineString$2.prototype = Object.create(Feature$5.prototype);
LineString$2.prototype.isValid = function() {
  return this.coordinates.length > 1;
};
LineString$2.prototype.addCoordinate = function(path2, lng, lat) {
  this.changed();
  const id = parseInt(path2, 10);
  this.coordinates.splice(id, 0, [lng, lat]);
};
LineString$2.prototype.getCoordinate = function(path2) {
  const id = parseInt(path2, 10);
  return JSON.parse(JSON.stringify(this.coordinates[id]));
};
LineString$2.prototype.removeCoordinate = function(path2) {
  this.changed();
  this.coordinates.splice(parseInt(path2, 10), 1);
};
LineString$2.prototype.updateCoordinate = function(path2, lng, lat) {
  const id = parseInt(path2, 10);
  this.coordinates[id] = [lng, lat];
  this.changed();
};
const Polygon$2 = function(ctx2, geojson) {
  Feature$5.call(this, ctx2, geojson);
  this.coordinates = this.coordinates.map((ring) => ring.slice(0, -1));
};
Polygon$2.prototype = Object.create(Feature$5.prototype);
Polygon$2.prototype.isValid = function() {
  if (this.coordinates.length === 0)
    return false;
  return this.coordinates.every((ring) => ring.length > 2);
};
Polygon$2.prototype.incomingCoords = function(coords) {
  this.coordinates = coords.map((ring) => ring.slice(0, -1));
  this.changed();
};
Polygon$2.prototype.setCoordinates = function(coords) {
  this.coordinates = coords;
  this.changed();
};
Polygon$2.prototype.addCoordinate = function(path2, lng, lat) {
  this.changed();
  const ids = path2.split(".").map((x2) => parseInt(x2, 10));
  const ring = this.coordinates[ids[0]];
  ring.splice(ids[1], 0, [lng, lat]);
};
Polygon$2.prototype.removeCoordinate = function(path2) {
  this.changed();
  const ids = path2.split(".").map((x2) => parseInt(x2, 10));
  const ring = this.coordinates[ids[0]];
  if (ring) {
    ring.splice(ids[1], 1);
    if (ring.length < 3) {
      this.coordinates.splice(ids[0], 1);
    }
  }
};
Polygon$2.prototype.getCoordinate = function(path2) {
  const ids = path2.split(".").map((x2) => parseInt(x2, 10));
  const ring = this.coordinates[ids[0]];
  return JSON.parse(JSON.stringify(ring[ids[1]]));
};
Polygon$2.prototype.getCoordinates = function() {
  return this.coordinates.map((coords) => coords.concat([coords[0]]));
};
Polygon$2.prototype.updateCoordinate = function(path2, lng, lat) {
  this.changed();
  const parts = path2.split(".");
  const ringId = parseInt(parts[0], 10);
  const coordId = parseInt(parts[1], 10);
  if (this.coordinates[ringId] === void 0) {
    this.coordinates[ringId] = [];
  }
  this.coordinates[ringId][coordId] = [lng, lat];
};
const models$1 = {
  MultiPoint: Point$4,
  MultiLineString: LineString$2,
  MultiPolygon: Polygon$2
};
const takeAction$1 = (features, action, path2, lng, lat) => {
  const parts = path2.split(".");
  const idx = parseInt(parts[0], 10);
  const tail = !parts[1] ? null : parts.slice(1).join(".");
  return features[idx][action](tail, lng, lat);
};
const MultiFeature$2 = function(ctx2, geojson) {
  Feature$5.call(this, ctx2, geojson);
  delete this.coordinates;
  this.model = models$1[geojson.geometry.type];
  if (this.model === void 0)
    throw new TypeError(`${geojson.geometry.type} is not a valid type`);
  this.features = this._coordinatesToFeatures(geojson.geometry.coordinates);
};
MultiFeature$2.prototype = Object.create(Feature$5.prototype);
MultiFeature$2.prototype._coordinatesToFeatures = function(coordinates2) {
  const Model2 = this.model.bind(this);
  return coordinates2.map((coords) => new Model2(this.ctx, {
    id: hatExports(),
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      coordinates: coords,
      type: this.type.replace("Multi", "")
    }
  }));
};
MultiFeature$2.prototype.isValid = function() {
  return this.features.every((f2) => f2.isValid());
};
MultiFeature$2.prototype.setCoordinates = function(coords) {
  this.features = this._coordinatesToFeatures(coords);
  this.changed();
};
MultiFeature$2.prototype.getCoordinate = function(path2) {
  return takeAction$1(this.features, "getCoordinate", path2);
};
MultiFeature$2.prototype.getCoordinates = function() {
  return JSON.parse(JSON.stringify(this.features.map((f2) => {
    if (f2.type === geojsonTypes.POLYGON)
      return f2.getCoordinates();
    return f2.coordinates;
  })));
};
MultiFeature$2.prototype.updateCoordinate = function(path2, lng, lat) {
  takeAction$1(this.features, "updateCoordinate", path2, lng, lat);
  this.changed();
};
MultiFeature$2.prototype.addCoordinate = function(path2, lng, lat) {
  takeAction$1(this.features, "addCoordinate", path2, lng, lat);
  this.changed();
};
MultiFeature$2.prototype.removeCoordinate = function(path2) {
  takeAction$1(this.features, "removeCoordinate", path2);
  this.changed();
};
MultiFeature$2.prototype.getFeatures = function() {
  return this.features;
};
function ModeInterface$2(ctx2) {
  this.map = ctx2.map;
  this.drawConfig = JSON.parse(JSON.stringify(ctx2.options || {}));
  this._ctx = ctx2;
}
ModeInterface$2.prototype.setSelected = function(features) {
  return this._ctx.store.setSelected(features);
};
ModeInterface$2.prototype.setSelectedCoordinates = function(coords) {
  this._ctx.store.setSelectedCoordinates(coords);
  coords.reduce((m2, c2) => {
    if (m2[c2.feature_id] === void 0) {
      m2[c2.feature_id] = true;
      this._ctx.store.get(c2.feature_id).changed();
    }
    return m2;
  }, {});
};
ModeInterface$2.prototype.getSelected = function() {
  return this._ctx.store.getSelected();
};
ModeInterface$2.prototype.getSelectedIds = function() {
  return this._ctx.store.getSelectedIds();
};
ModeInterface$2.prototype.isSelected = function(id) {
  return this._ctx.store.isSelected(id);
};
ModeInterface$2.prototype.getFeature = function(id) {
  return this._ctx.store.get(id);
};
ModeInterface$2.prototype.select = function(id) {
  return this._ctx.store.select(id);
};
ModeInterface$2.prototype.deselect = function(id) {
  return this._ctx.store.deselect(id);
};
ModeInterface$2.prototype.deleteFeature = function(id, opts = {}) {
  return this._ctx.store.delete(id, opts);
};
ModeInterface$2.prototype.addFeature = function(feature2) {
  return this._ctx.store.add(feature2);
};
ModeInterface$2.prototype.clearSelectedFeatures = function() {
  return this._ctx.store.clearSelected();
};
ModeInterface$2.prototype.clearSelectedCoordinates = function() {
  return this._ctx.store.clearSelectedCoordinates();
};
ModeInterface$2.prototype.setActionableState = function(actions = {}) {
  const newSet = {
    trash: actions.trash || false,
    combineFeatures: actions.combineFeatures || false,
    uncombineFeatures: actions.uncombineFeatures || false
  };
  return this._ctx.events.actionable(newSet);
};
ModeInterface$2.prototype.changeMode = function(mode2, opts = {}, eventOpts = {}) {
  return this._ctx.events.changeMode(mode2, opts, eventOpts);
};
ModeInterface$2.prototype.updateUIClasses = function(opts) {
  return this._ctx.ui.queueMapClasses(opts);
};
ModeInterface$2.prototype.activateUIButton = function(name2) {
  return this._ctx.ui.setActiveButton(name2);
};
ModeInterface$2.prototype.featuresAt = function(event, bbox2, bufferType = "click") {
  if (bufferType !== "click" && bufferType !== "touch")
    throw new Error("invalid buffer type");
  return featuresAt$5[bufferType](event, bbox2, this._ctx);
};
ModeInterface$2.prototype.newFeature = function(geojson) {
  const type = geojson.geometry.type;
  if (type === geojsonTypes.POINT)
    return new Point$4(this._ctx, geojson);
  if (type === geojsonTypes.LINE_STRING)
    return new LineString$2(this._ctx, geojson);
  if (type === geojsonTypes.POLYGON)
    return new Polygon$2(this._ctx, geojson);
  return new MultiFeature$2(this._ctx, geojson);
};
ModeInterface$2.prototype.isInstanceOf = function(type, feature2) {
  if (type === geojsonTypes.POINT)
    return feature2 instanceof Point$4;
  if (type === geojsonTypes.LINE_STRING)
    return feature2 instanceof LineString$2;
  if (type === geojsonTypes.POLYGON)
    return feature2 instanceof Polygon$2;
  if (type === "MultiFeature")
    return feature2 instanceof MultiFeature$2;
  throw new Error(`Unknown feature class: ${type}`);
};
ModeInterface$2.prototype.doRender = function(id) {
  return this._ctx.store.featureChanged(id);
};
ModeInterface$2.prototype.onSetup = function() {
};
ModeInterface$2.prototype.onDrag = function() {
};
ModeInterface$2.prototype.onClick = function() {
};
ModeInterface$2.prototype.onMouseMove = function() {
};
ModeInterface$2.prototype.onMouseDown = function() {
};
ModeInterface$2.prototype.onMouseUp = function() {
};
ModeInterface$2.prototype.onMouseOut = function() {
};
ModeInterface$2.prototype.onKeyUp = function() {
};
ModeInterface$2.prototype.onKeyDown = function() {
};
ModeInterface$2.prototype.onTouchStart = function() {
};
ModeInterface$2.prototype.onTouchMove = function() {
};
ModeInterface$2.prototype.onTouchEnd = function() {
};
ModeInterface$2.prototype.onTap = function() {
};
ModeInterface$2.prototype.onStop = function() {
};
ModeInterface$2.prototype.onTrash = function() {
};
ModeInterface$2.prototype.onCombineFeature = function() {
};
ModeInterface$2.prototype.onUncombineFeature = function() {
};
ModeInterface$2.prototype.toDisplayFeatures = function() {
  throw new Error("You must overwrite toDisplayFeatures");
};
const eventMapper$1 = {
  drag: "onDrag",
  click: "onClick",
  mousemove: "onMouseMove",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseout: "onMouseOut",
  keyup: "onKeyUp",
  keydown: "onKeyDown",
  touchstart: "onTouchStart",
  touchmove: "onTouchMove",
  touchend: "onTouchEnd",
  tap: "onTap"
};
const eventKeys$1 = Object.keys(eventMapper$1);
function objectToMode$1(modeObject) {
  const modeObjectKeys = Object.keys(modeObject);
  return function(ctx2, startOpts = {}) {
    let state = {};
    const mode2 = modeObjectKeys.reduce((m2, k2) => {
      m2[k2] = modeObject[k2];
      return m2;
    }, new ModeInterface$2(ctx2));
    function wrapper(eh) {
      return function(e3) {
        mode2[eh](state, e3);
      };
    }
    return {
      start() {
        state = mode2.onSetup(startOpts);
        eventKeys$1.forEach((key) => {
          const modeHandler = eventMapper$1[key];
          let selector = () => false;
          if (modeObject[modeHandler]) {
            selector = () => true;
          }
          this.on(key, selector, wrapper(modeHandler));
        });
      },
      stop() {
        mode2.onStop(state);
      },
      trash() {
        mode2.onTrash(state);
      },
      combineFeatures() {
        mode2.onCombineFeatures(state);
      },
      uncombineFeatures() {
        mode2.onUncombineFeatures(state);
      },
      render(geojson, push2) {
        mode2.toDisplayFeatures(state, geojson, push2);
      }
    };
  };
}
function events$5(ctx2) {
  const modes2 = Object.keys(ctx2.options.modes).reduce((m2, k2) => {
    m2[k2] = objectToMode$1(ctx2.options.modes[k2]);
    return m2;
  }, {});
  let mouseDownInfo = {};
  let touchStartInfo = {};
  const events2 = {};
  let currentModeName = null;
  let currentMode = null;
  events2.drag = function(event, isDrag) {
    if (isDrag({
      point: event.point,
      time: (/* @__PURE__ */ new Date()).getTime()
    })) {
      ctx2.ui.queueMapClasses({ mouse: cursors.DRAG });
      currentMode.drag(event);
    } else {
      event.originalEvent.stopPropagation();
    }
  };
  events2.mousedrag = function(event) {
    events2.drag(event, (endInfo) => !isClick$1(mouseDownInfo, endInfo));
  };
  events2.touchdrag = function(event) {
    events2.drag(event, (endInfo) => !isTap$1(touchStartInfo, endInfo));
  };
  events2.mousemove = function(event) {
    const button = event.originalEvent.buttons !== void 0 ? event.originalEvent.buttons : event.originalEvent.which;
    if (button === 1) {
      return events2.mousedrag(event);
    }
    const target = getFeatureAtAndSetCursors(event, ctx2);
    event.featureTarget = target;
    currentMode.mousemove(event);
  };
  events2.mousedown = function(event) {
    mouseDownInfo = {
      time: (/* @__PURE__ */ new Date()).getTime(),
      point: event.point
    };
    const target = getFeatureAtAndSetCursors(event, ctx2);
    event.featureTarget = target;
    currentMode.mousedown(event);
  };
  events2.mouseup = function(event) {
    const target = getFeatureAtAndSetCursors(event, ctx2);
    event.featureTarget = target;
    if (isClick$1(mouseDownInfo, {
      point: event.point,
      time: (/* @__PURE__ */ new Date()).getTime()
    })) {
      currentMode.click(event);
    } else {
      currentMode.mouseup(event);
    }
  };
  events2.mouseout = function(event) {
    currentMode.mouseout(event);
  };
  events2.touchstart = function(event) {
    event.originalEvent.preventDefault();
    if (!ctx2.options.touchEnabled) {
      return;
    }
    touchStartInfo = {
      time: (/* @__PURE__ */ new Date()).getTime(),
      point: event.point
    };
    const target = featuresAt$5.touch(event, null, ctx2)[0];
    event.featureTarget = target;
    currentMode.touchstart(event);
  };
  events2.touchmove = function(event) {
    event.originalEvent.preventDefault();
    if (!ctx2.options.touchEnabled) {
      return;
    }
    currentMode.touchmove(event);
    return events2.touchdrag(event);
  };
  events2.touchend = function(event) {
    event.originalEvent.preventDefault();
    if (!ctx2.options.touchEnabled) {
      return;
    }
    const target = featuresAt$5.touch(event, null, ctx2)[0];
    event.featureTarget = target;
    if (isTap$1(touchStartInfo, {
      time: (/* @__PURE__ */ new Date()).getTime(),
      point: event.point
    })) {
      currentMode.tap(event);
    } else {
      currentMode.touchend(event);
    }
  };
  const isKeyModeValid = (code) => !(code === 8 || code === 46 || code >= 48 && code <= 57);
  events2.keydown = function(event) {
    if ((event.srcElement || event.target).classList[0] !== "mapboxgl-canvas")
      return;
    if ((event.keyCode === 8 || event.keyCode === 46) && ctx2.options.controls.trash) {
      event.preventDefault();
      currentMode.trash();
    } else if (isKeyModeValid(event.keyCode)) {
      currentMode.keydown(event);
    } else if (event.keyCode === 49 && ctx2.options.controls.point) {
      changeMode(modes$2.DRAW_POINT);
    } else if (event.keyCode === 50 && ctx2.options.controls.line_string) {
      changeMode(modes$2.DRAW_LINE_STRING);
    } else if (event.keyCode === 51 && ctx2.options.controls.polygon) {
      changeMode(modes$2.DRAW_POLYGON);
    }
  };
  events2.keyup = function(event) {
    if (isKeyModeValid(event.keyCode)) {
      currentMode.keyup(event);
    }
  };
  events2.zoomend = function() {
    ctx2.store.changeZoom();
  };
  events2.data = function(event) {
    if (event.dataType === "style") {
      const { setup: setup2, map: map5, options: options2, store: store2 } = ctx2;
      const hasLayers = options2.styles.some((style2) => map5.getLayer(style2.id));
      if (!hasLayers) {
        setup2.addLayers();
        store2.setDirty();
        store2.render();
      }
    }
  };
  function changeMode(modename, nextModeOptions, eventOptions = {}) {
    currentMode.stop();
    const modebuilder = modes2[modename];
    if (modebuilder === void 0) {
      throw new Error(`${modename} is not valid`);
    }
    currentModeName = modename;
    const mode2 = modebuilder(ctx2, nextModeOptions);
    currentMode = ModeHandler$1(mode2, ctx2);
    if (!eventOptions.silent) {
      ctx2.map.fire(events$6.MODE_CHANGE, { mode: modename });
    }
    ctx2.store.setDirty();
    ctx2.store.render();
  }
  const actionState = {
    trash: false,
    combineFeatures: false,
    uncombineFeatures: false
  };
  function actionable(actions) {
    let changed = false;
    Object.keys(actions).forEach((action) => {
      if (actionState[action] === void 0)
        throw new Error("Invalid action type");
      if (actionState[action] !== actions[action])
        changed = true;
      actionState[action] = actions[action];
    });
    if (changed)
      ctx2.map.fire(events$6.ACTIONABLE, { actions: actionState });
  }
  const api2 = {
    start() {
      currentModeName = ctx2.options.defaultMode;
      currentMode = ModeHandler$1(modes2[currentModeName](ctx2), ctx2);
    },
    changeMode,
    actionable,
    currentModeName() {
      return currentModeName;
    },
    currentModeRender(geojson, push2) {
      return currentMode.render(geojson, push2);
    },
    fire(name2, event) {
      if (events2[name2]) {
        events2[name2](event);
      }
    },
    addEventListeners() {
      ctx2.map.on("mousemove", events2.mousemove);
      ctx2.map.on("mousedown", events2.mousedown);
      ctx2.map.on("mouseup", events2.mouseup);
      ctx2.map.on("data", events2.data);
      ctx2.map.on("touchmove", events2.touchmove);
      ctx2.map.on("touchstart", events2.touchstart);
      ctx2.map.on("touchend", events2.touchend);
      ctx2.container.addEventListener("mouseout", events2.mouseout);
      if (ctx2.options.keybindings) {
        ctx2.container.addEventListener("keydown", events2.keydown);
        ctx2.container.addEventListener("keyup", events2.keyup);
      }
    },
    removeEventListeners() {
      ctx2.map.off("mousemove", events2.mousemove);
      ctx2.map.off("mousedown", events2.mousedown);
      ctx2.map.off("mouseup", events2.mouseup);
      ctx2.map.off("data", events2.data);
      ctx2.map.off("touchmove", events2.touchmove);
      ctx2.map.off("touchstart", events2.touchstart);
      ctx2.map.off("touchend", events2.touchend);
      ctx2.container.removeEventListener("mouseout", events2.mouseout);
      if (ctx2.options.keybindings) {
        ctx2.container.removeEventListener("keydown", events2.keydown);
        ctx2.container.removeEventListener("keyup", events2.keyup);
      }
    },
    trash(options2) {
      currentMode.trash(options2);
    },
    combineFeatures() {
      currentMode.combineFeatures();
    },
    uncombineFeatures() {
      currentMode.uncombineFeatures();
    },
    getMode() {
      return currentModeName;
    }
  };
  return api2;
}
function toDenseArray$2(x2) {
  return [].concat(x2).filter((y2) => y2 !== void 0);
}
function render$4() {
  const store2 = this;
  const mapExists = store2.ctx.map && store2.ctx.map.getSource(sources.HOT) !== void 0;
  if (!mapExists)
    return cleanup();
  const mode2 = store2.ctx.events.currentModeName();
  store2.ctx.ui.queueMapClasses({ mode: mode2 });
  let newHotIds = [];
  let newColdIds = [];
  if (store2.isDirty) {
    newColdIds = store2.getAllIds();
  } else {
    newHotIds = store2.getChangedIds().filter((id) => store2.get(id) !== void 0);
    newColdIds = store2.sources.hot.filter((geojson) => geojson.properties.id && newHotIds.indexOf(geojson.properties.id) === -1 && store2.get(geojson.properties.id) !== void 0).map((geojson) => geojson.properties.id);
  }
  store2.sources.hot = [];
  const lastColdCount = store2.sources.cold.length;
  store2.sources.cold = store2.isDirty ? [] : store2.sources.cold.filter((geojson) => {
    const id = geojson.properties.id || geojson.properties.parent;
    return newHotIds.indexOf(id) === -1;
  });
  const coldChanged = lastColdCount !== store2.sources.cold.length || newColdIds.length > 0;
  newHotIds.forEach((id) => renderFeature(id, "hot"));
  newColdIds.forEach((id) => renderFeature(id, "cold"));
  function renderFeature(id, source) {
    const feature2 = store2.get(id);
    const featureInternal = feature2.internal(mode2);
    store2.ctx.events.currentModeRender(featureInternal, (geojson) => {
      store2.sources[source].push(geojson);
    });
  }
  if (coldChanged) {
    store2.ctx.map.getSource(sources.COLD).setData({
      type: geojsonTypes.FEATURE_COLLECTION,
      features: store2.sources.cold
    });
  }
  store2.ctx.map.getSource(sources.HOT).setData({
    type: geojsonTypes.FEATURE_COLLECTION,
    features: store2.sources.hot
  });
  if (store2._emitSelectionChange) {
    store2.ctx.map.fire(events$6.SELECTION_CHANGE, {
      features: store2.getSelected().map((feature2) => feature2.toGeoJSON()),
      points: store2.getSelectedCoordinates().map((coordinate2) => ({
        type: geojsonTypes.FEATURE,
        properties: {},
        geometry: {
          type: geojsonTypes.POINT,
          coordinates: coordinate2.coordinates
        }
      }))
    });
    store2._emitSelectionChange = false;
  }
  if (store2._deletedFeaturesToEmit.length) {
    const geojsonToEmit = store2._deletedFeaturesToEmit.map((feature2) => feature2.toGeoJSON());
    store2._deletedFeaturesToEmit = [];
    store2.ctx.map.fire(events$6.DELETE, {
      features: geojsonToEmit
    });
  }
  cleanup();
  store2.ctx.map.fire(events$6.RENDER, {});
  function cleanup() {
    store2.isDirty = false;
    store2.clearChangedIds();
  }
}
function Store$2(ctx2) {
  this._features = {};
  this._featureIds = new StringSet$5();
  this._selectedFeatureIds = new StringSet$5();
  this._selectedCoordinates = [];
  this._changedFeatureIds = new StringSet$5();
  this._deletedFeaturesToEmit = [];
  this._emitSelectionChange = false;
  this._mapInitialConfig = {};
  this.ctx = ctx2;
  this.sources = {
    hot: [],
    cold: []
  };
  let renderRequest;
  this.render = () => {
    if (!renderRequest) {
      renderRequest = requestAnimationFrame(() => {
        renderRequest = null;
        render$4.call(this);
      });
    }
  };
  this.isDirty = false;
}
Store$2.prototype.createRenderBatch = function() {
  const holdRender = this.render;
  let numRenders = 0;
  this.render = function() {
    numRenders++;
  };
  return () => {
    this.render = holdRender;
    if (numRenders > 0) {
      this.render();
    }
  };
};
Store$2.prototype.setDirty = function() {
  this.isDirty = true;
  return this;
};
Store$2.prototype.featureChanged = function(featureId) {
  this._changedFeatureIds.add(featureId);
  return this;
};
Store$2.prototype.getChangedIds = function() {
  return this._changedFeatureIds.values();
};
Store$2.prototype.clearChangedIds = function() {
  this._changedFeatureIds.clear();
  return this;
};
Store$2.prototype.getAllIds = function() {
  return this._featureIds.values();
};
Store$2.prototype.add = function(feature2) {
  this.featureChanged(feature2.id);
  this._features[feature2.id] = feature2;
  this._featureIds.add(feature2.id);
  return this;
};
Store$2.prototype.delete = function(featureIds, options2 = {}) {
  toDenseArray$2(featureIds).forEach((id) => {
    if (!this._featureIds.has(id))
      return;
    this._featureIds.delete(id);
    this._selectedFeatureIds.delete(id);
    if (!options2.silent) {
      if (this._deletedFeaturesToEmit.indexOf(this._features[id]) === -1) {
        this._deletedFeaturesToEmit.push(this._features[id]);
      }
    }
    delete this._features[id];
    this.isDirty = true;
  });
  refreshSelectedCoordinates$1(this, options2);
  return this;
};
Store$2.prototype.get = function(id) {
  return this._features[id];
};
Store$2.prototype.getAll = function() {
  return Object.keys(this._features).map((id) => this._features[id]);
};
Store$2.prototype.select = function(featureIds, options2 = {}) {
  toDenseArray$2(featureIds).forEach((id) => {
    if (this._selectedFeatureIds.has(id))
      return;
    this._selectedFeatureIds.add(id);
    this._changedFeatureIds.add(id);
    if (!options2.silent) {
      this._emitSelectionChange = true;
    }
  });
  return this;
};
Store$2.prototype.deselect = function(featureIds, options2 = {}) {
  toDenseArray$2(featureIds).forEach((id) => {
    if (!this._selectedFeatureIds.has(id))
      return;
    this._selectedFeatureIds.delete(id);
    this._changedFeatureIds.add(id);
    if (!options2.silent) {
      this._emitSelectionChange = true;
    }
  });
  refreshSelectedCoordinates$1(this, options2);
  return this;
};
Store$2.prototype.clearSelected = function(options2 = {}) {
  this.deselect(this._selectedFeatureIds.values(), { silent: options2.silent });
  return this;
};
Store$2.prototype.setSelected = function(featureIds, options2 = {}) {
  featureIds = toDenseArray$2(featureIds);
  this.deselect(this._selectedFeatureIds.values().filter((id) => featureIds.indexOf(id) === -1), { silent: options2.silent });
  this.select(featureIds.filter((id) => !this._selectedFeatureIds.has(id)), { silent: options2.silent });
  return this;
};
Store$2.prototype.setSelectedCoordinates = function(coordinates2) {
  this._selectedCoordinates = coordinates2;
  this._emitSelectionChange = true;
  return this;
};
Store$2.prototype.clearSelectedCoordinates = function() {
  this._selectedCoordinates = [];
  this._emitSelectionChange = true;
  return this;
};
Store$2.prototype.getSelectedIds = function() {
  return this._selectedFeatureIds.values();
};
Store$2.prototype.getSelected = function() {
  return this._selectedFeatureIds.values().map((id) => this.get(id));
};
Store$2.prototype.getSelectedCoordinates = function() {
  const selected = this._selectedCoordinates.map((coordinate2) => {
    const feature2 = this.get(coordinate2.feature_id);
    return {
      coordinates: feature2.getCoordinate(coordinate2.coord_path)
    };
  });
  return selected;
};
Store$2.prototype.isSelected = function(featureId) {
  return this._selectedFeatureIds.has(featureId);
};
Store$2.prototype.setFeatureProperty = function(featureId, property2, value) {
  this.get(featureId).setProperty(property2, value);
  this.featureChanged(featureId);
};
function refreshSelectedCoordinates$1(store2, options2) {
  const newSelectedCoordinates = store2._selectedCoordinates.filter((point4) => store2._selectedFeatureIds.has(point4.feature_id));
  if (store2._selectedCoordinates.length !== newSelectedCoordinates.length && !options2.silent) {
    store2._emitSelectionChange = true;
  }
  store2._selectedCoordinates = newSelectedCoordinates;
}
Store$2.prototype.storeMapConfig = function() {
  interactions$1.forEach((interaction) => {
    const interactionSet = this.ctx.map[interaction];
    if (interactionSet) {
      this._mapInitialConfig[interaction] = this.ctx.map[interaction].isEnabled();
    }
  });
};
Store$2.prototype.restoreMapConfig = function() {
  Object.keys(this._mapInitialConfig).forEach((key) => {
    const value = this._mapInitialConfig[key];
    if (value) {
      this.ctx.map[key].enable();
    } else {
      this.ctx.map[key].disable();
    }
  });
};
Store$2.prototype.getInitialConfigValue = function(interaction) {
  if (this._mapInitialConfig[interaction] !== void 0) {
    return this._mapInitialConfig[interaction];
  } else {
    return true;
  }
};
var immutable = extend$4;
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
function extend$4() {
  var target = {};
  for (var i2 = 0; i2 < arguments.length; i2++) {
    var source = arguments[i2];
    for (var key in source) {
      if (hasOwnProperty$2.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
}
const classTypes$1 = ["mode", "feature", "mouse"];
function ui$2(ctx2) {
  const buttonElements = {};
  let activeButton = null;
  let currentMapClasses = {
    mode: null,
    // e.g. mode-direct_select
    feature: null,
    // e.g. feature-vertex
    mouse: null
    // e.g. mouse-move
  };
  let nextMapClasses = {
    mode: null,
    feature: null,
    mouse: null
  };
  function clearMapClasses() {
    queueMapClasses({ mode: null, feature: null, mouse: null });
    updateMapClasses();
  }
  function queueMapClasses(options2) {
    nextMapClasses = immutable(nextMapClasses, options2);
  }
  function updateMapClasses() {
    if (!ctx2.container)
      return;
    const classesToRemove = [];
    const classesToAdd = [];
    classTypes$1.forEach((type) => {
      if (nextMapClasses[type] === currentMapClasses[type])
        return;
      classesToRemove.push(`${type}-${currentMapClasses[type]}`);
      if (nextMapClasses[type] !== null) {
        classesToAdd.push(`${type}-${nextMapClasses[type]}`);
      }
    });
    if (classesToRemove.length > 0) {
      ctx2.container.classList.remove(...classesToRemove);
    }
    if (classesToAdd.length > 0) {
      ctx2.container.classList.add(...classesToAdd);
    }
    currentMapClasses = immutable(currentMapClasses, nextMapClasses);
  }
  function createControlButton(id, options2 = {}) {
    const button = document.createElement("button");
    button.className = `${classes.CONTROL_BUTTON} ${options2.className}`;
    button.setAttribute("title", options2.title);
    options2.container.appendChild(button);
    button.addEventListener("click", (e3) => {
      e3.preventDefault();
      e3.stopPropagation();
      const clickedButton = e3.target;
      if (clickedButton === activeButton) {
        deactivateButtons();
        options2.onDeactivate();
        return;
      }
      setActiveButton(id);
      options2.onActivate();
    }, true);
    return button;
  }
  function deactivateButtons() {
    if (!activeButton)
      return;
    activeButton.classList.remove(classes.ACTIVE_BUTTON);
    activeButton = null;
  }
  function setActiveButton(id) {
    deactivateButtons();
    const button = buttonElements[id];
    if (!button)
      return;
    if (button && id !== "trash") {
      button.classList.add(classes.ACTIVE_BUTTON);
      activeButton = button;
    }
  }
  function addButtons() {
    const controls = ctx2.options.controls;
    const controlGroup = document.createElement("div");
    controlGroup.className = `${classes.CONTROL_GROUP} ${classes.CONTROL_BASE}`;
    if (!controls)
      return controlGroup;
    if (controls[types$1.LINE]) {
      buttonElements[types$1.LINE] = createControlButton(types$1.LINE, {
        container: controlGroup,
        className: classes.CONTROL_BUTTON_LINE,
        title: `LineString tool ${ctx2.options.keybindings ? "(l)" : ""}`,
        onActivate: () => ctx2.events.changeMode(modes$2.DRAW_LINE_STRING),
        onDeactivate: () => ctx2.events.trash()
      });
    }
    if (controls[types$1.POLYGON]) {
      buttonElements[types$1.POLYGON] = createControlButton(types$1.POLYGON, {
        container: controlGroup,
        className: classes.CONTROL_BUTTON_POLYGON,
        title: `Polygon tool ${ctx2.options.keybindings ? "(p)" : ""}`,
        onActivate: () => ctx2.events.changeMode(modes$2.DRAW_POLYGON),
        onDeactivate: () => ctx2.events.trash()
      });
    }
    if (controls[types$1.POINT]) {
      buttonElements[types$1.POINT] = createControlButton(types$1.POINT, {
        container: controlGroup,
        className: classes.CONTROL_BUTTON_POINT,
        title: `Marker tool ${ctx2.options.keybindings ? "(m)" : ""}`,
        onActivate: () => ctx2.events.changeMode(modes$2.DRAW_POINT),
        onDeactivate: () => ctx2.events.trash()
      });
    }
    if (controls.trash) {
      buttonElements.trash = createControlButton("trash", {
        container: controlGroup,
        className: classes.CONTROL_BUTTON_TRASH,
        title: "Delete",
        onActivate: () => {
          ctx2.events.trash();
        }
      });
    }
    if (controls.combine_features) {
      buttonElements.combine_features = createControlButton("combineFeatures", {
        container: controlGroup,
        className: classes.CONTROL_BUTTON_COMBINE_FEATURES,
        title: "Combine",
        onActivate: () => {
          ctx2.events.combineFeatures();
        }
      });
    }
    if (controls.uncombine_features) {
      buttonElements.uncombine_features = createControlButton("uncombineFeatures", {
        container: controlGroup,
        className: classes.CONTROL_BUTTON_UNCOMBINE_FEATURES,
        title: "Uncombine",
        onActivate: () => {
          ctx2.events.uncombineFeatures();
        }
      });
    }
    return controlGroup;
  }
  function removeButtons() {
    Object.keys(buttonElements).forEach((buttonId) => {
      const button = buttonElements[buttonId];
      if (button.parentNode) {
        button.parentNode.removeChild(button);
      }
      delete buttonElements[buttonId];
    });
  }
  return {
    setActiveButton,
    queueMapClasses,
    updateMapClasses,
    clearMapClasses,
    addButtons,
    removeButtons
  };
}
function runSetup$1(ctx2) {
  let controlContainer = null;
  let mapLoadedInterval = null;
  const setup2 = {
    onRemove() {
      ctx2.map.off("load", setup2.connect);
      clearInterval(mapLoadedInterval);
      setup2.removeLayers();
      ctx2.store.restoreMapConfig();
      ctx2.ui.removeButtons();
      ctx2.events.removeEventListeners();
      ctx2.ui.clearMapClasses();
      ctx2.map = null;
      ctx2.container = null;
      ctx2.store = null;
      if (controlContainer && controlContainer.parentNode)
        controlContainer.parentNode.removeChild(controlContainer);
      controlContainer = null;
      return this;
    },
    connect() {
      ctx2.map.off("load", setup2.connect);
      clearInterval(mapLoadedInterval);
      setup2.addLayers();
      ctx2.store.storeMapConfig();
      ctx2.events.addEventListeners();
    },
    onAdd(map5) {
      if (process.env.NODE_ENV !== "test") {
        const _fire = map5.fire;
        map5.fire = function(type, event) {
          let args = arguments;
          if (_fire.length === 1 && arguments.length !== 1) {
            args = [immutable({}, { type }, event)];
          }
          return _fire.apply(map5, args);
        };
      }
      ctx2.map = map5;
      ctx2.events = events$5(ctx2);
      ctx2.ui = ui$2(ctx2);
      ctx2.container = map5.getContainer();
      ctx2.store = new Store$2(ctx2);
      controlContainer = ctx2.ui.addButtons();
      if (ctx2.options.boxSelect) {
        map5.boxZoom.disable();
        map5.dragPan.disable();
        map5.dragPan.enable();
      }
      if (map5.loaded()) {
        setup2.connect();
      } else {
        map5.on("load", setup2.connect);
        mapLoadedInterval = setInterval(() => {
          if (map5.loaded())
            setup2.connect();
        }, 16);
      }
      ctx2.events.start();
      return controlContainer;
    },
    addLayers() {
      ctx2.map.addSource(sources.COLD, {
        data: {
          type: geojsonTypes.FEATURE_COLLECTION,
          features: []
        },
        type: "geojson"
      });
      ctx2.map.addSource(sources.HOT, {
        data: {
          type: geojsonTypes.FEATURE_COLLECTION,
          features: []
        },
        type: "geojson"
      });
      ctx2.options.styles.forEach((style2) => {
        ctx2.map.addLayer(style2);
      });
      ctx2.store.setDirty(true);
      ctx2.store.render();
    },
    // Check for layers and sources before attempting to remove
    // If user adds draw control and removes it before the map is loaded, layers and sources will be missing
    removeLayers() {
      ctx2.options.styles.forEach((style2) => {
        if (ctx2.map.getLayer(style2.id)) {
          ctx2.map.removeLayer(style2.id);
        }
      });
      if (ctx2.map.getSource(sources.COLD)) {
        ctx2.map.removeSource(sources.COLD);
      }
      if (ctx2.map.getSource(sources.HOT)) {
        ctx2.map.removeSource(sources.HOT);
      }
    }
  };
  ctx2.setup = setup2;
  return setup2;
}
const theme$1 = [
  {
    "id": "gl-draw-polygon-fill-inactive",
    "type": "fill",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Polygon"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "fill-color": "#3bb2d0",
      "fill-outline-color": "#3bb2d0",
      "fill-opacity": 0.1
    }
  },
  {
    "id": "gl-draw-polygon-fill-active",
    "type": "fill",
    "filter": ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
    "paint": {
      "fill-color": "#fbb03b",
      "fill-outline-color": "#fbb03b",
      "fill-opacity": 0.1
    }
  },
  {
    "id": "gl-draw-polygon-midpoint",
    "type": "circle",
    "filter": [
      "all",
      ["==", "$type", "Point"],
      ["==", "meta", "midpoint"]
    ],
    "paint": {
      "circle-radius": 3,
      "circle-color": "#fbb03b"
    }
  },
  {
    "id": "gl-draw-polygon-stroke-inactive",
    "type": "line",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Polygon"],
      ["!=", "mode", "static"]
    ],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#3bb2d0",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-polygon-stroke-active",
    "type": "line",
    "filter": ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#fbb03b",
      "line-dasharray": [0.2, 2],
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-line-inactive",
    "type": "line",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "LineString"],
      ["!=", "mode", "static"]
    ],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#3bb2d0",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-line-active",
    "type": "line",
    "filter": [
      "all",
      ["==", "$type", "LineString"],
      ["==", "active", "true"]
    ],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#fbb03b",
      "line-dasharray": [0.2, 2],
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-polygon-and-line-vertex-stroke-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "meta", "vertex"],
      ["==", "$type", "Point"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 5,
      "circle-color": "#fff"
    }
  },
  {
    "id": "gl-draw-polygon-and-line-vertex-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "meta", "vertex"],
      ["==", "$type", "Point"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 3,
      "circle-color": "#fbb03b"
    }
  },
  {
    "id": "gl-draw-point-point-stroke-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Point"],
      ["==", "meta", "feature"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 5,
      "circle-opacity": 1,
      "circle-color": "#fff"
    }
  },
  {
    "id": "gl-draw-point-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Point"],
      ["==", "meta", "feature"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 3,
      "circle-color": "#3bb2d0"
    }
  },
  {
    "id": "gl-draw-point-stroke-active",
    "type": "circle",
    "filter": [
      "all",
      ["==", "$type", "Point"],
      ["==", "active", "true"],
      ["!=", "meta", "midpoint"]
    ],
    "paint": {
      "circle-radius": 7,
      "circle-color": "#fff"
    }
  },
  {
    "id": "gl-draw-point-active",
    "type": "circle",
    "filter": [
      "all",
      ["==", "$type", "Point"],
      ["!=", "meta", "midpoint"],
      ["==", "active", "true"]
    ],
    "paint": {
      "circle-radius": 5,
      "circle-color": "#fbb03b"
    }
  },
  {
    "id": "gl-draw-polygon-fill-static",
    "type": "fill",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
    "paint": {
      "fill-color": "#404040",
      "fill-outline-color": "#404040",
      "fill-opacity": 0.1
    }
  },
  {
    "id": "gl-draw-polygon-stroke-static",
    "type": "line",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#404040",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-line-static",
    "type": "line",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "LineString"]],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#404040",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-point-static",
    "type": "circle",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
    "paint": {
      "circle-radius": 5,
      "circle-color": "#404040"
    }
  }
];
function isOfMetaType$1(type) {
  return function(e3) {
    const featureTarget = e3.featureTarget;
    if (!featureTarget)
      return false;
    if (!featureTarget.properties)
      return false;
    return featureTarget.properties.meta === type;
  };
}
function isShiftMousedown(e3) {
  if (!e3.originalEvent)
    return false;
  if (!e3.originalEvent.shiftKey)
    return false;
  return e3.originalEvent.button === 0;
}
function isActiveFeature(e3) {
  if (!e3.featureTarget)
    return false;
  if (!e3.featureTarget.properties)
    return false;
  return e3.featureTarget.properties.active === activeStates.ACTIVE && e3.featureTarget.properties.meta === meta.FEATURE;
}
function isInactiveFeature$1(e3) {
  if (!e3.featureTarget)
    return false;
  if (!e3.featureTarget.properties)
    return false;
  return e3.featureTarget.properties.active === activeStates.INACTIVE && e3.featureTarget.properties.meta === meta.FEATURE;
}
function noTarget$1(e3) {
  return e3.featureTarget === void 0;
}
function isFeature(e3) {
  if (!e3.featureTarget)
    return false;
  if (!e3.featureTarget.properties)
    return false;
  return e3.featureTarget.properties.meta === meta.FEATURE;
}
function isVertex$2(e3) {
  const featureTarget = e3.featureTarget;
  if (!featureTarget)
    return false;
  if (!featureTarget.properties)
    return false;
  return featureTarget.properties.meta === meta.VERTEX;
}
function isShiftDown$1(e3) {
  if (!e3.originalEvent)
    return false;
  return e3.originalEvent.shiftKey === true;
}
function isEscapeKey(e3) {
  return e3.keyCode === 27;
}
function isEnterKey(e3) {
  return e3.keyCode === 13;
}
var pointGeometry = Point$3;
function Point$3(x2, y2) {
  this.x = x2;
  this.y = y2;
}
Point$3.prototype = {
  /**
   * Clone this point, returning a new point that can be modified
   * without affecting the old one.
   * @return {Point} the clone
   */
  clone: function() {
    return new Point$3(this.x, this.y);
  },
  /**
   * Add this point's x & y coordinates to another point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */
  add: function(p2) {
    return this.clone()._add(p2);
  },
  /**
   * Subtract this point's x & y coordinates to from point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */
  sub: function(p2) {
    return this.clone()._sub(p2);
  },
  /**
   * Multiply this point's x & y coordinates by point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */
  multByPoint: function(p2) {
    return this.clone()._multByPoint(p2);
  },
  /**
   * Divide this point's x & y coordinates by point,
   * yielding a new point.
   * @param {Point} p the other point
   * @return {Point} output point
   */
  divByPoint: function(p2) {
    return this.clone()._divByPoint(p2);
  },
  /**
   * Multiply this point's x & y coordinates by a factor,
   * yielding a new point.
   * @param {Point} k factor
   * @return {Point} output point
   */
  mult: function(k2) {
    return this.clone()._mult(k2);
  },
  /**
   * Divide this point's x & y coordinates by a factor,
   * yielding a new point.
   * @param {Point} k factor
   * @return {Point} output point
   */
  div: function(k2) {
    return this.clone()._div(k2);
  },
  /**
   * Rotate this point around the 0, 0 origin by an angle a,
   * given in radians
   * @param {Number} a angle to rotate around, in radians
   * @return {Point} output point
   */
  rotate: function(a2) {
    return this.clone()._rotate(a2);
  },
  /**
   * Rotate this point around p point by an angle a,
   * given in radians
   * @param {Number} a angle to rotate around, in radians
   * @param {Point} p Point to rotate around
   * @return {Point} output point
   */
  rotateAround: function(a2, p2) {
    return this.clone()._rotateAround(a2, p2);
  },
  /**
   * Multiply this point by a 4x1 transformation matrix
   * @param {Array<Number>} m transformation matrix
   * @return {Point} output point
   */
  matMult: function(m2) {
    return this.clone()._matMult(m2);
  },
  /**
   * Calculate this point but as a unit vector from 0, 0, meaning
   * that the distance from the resulting point to the 0, 0
   * coordinate will be equal to 1 and the angle from the resulting
   * point to the 0, 0 coordinate will be the same as before.
   * @return {Point} unit vector point
   */
  unit: function() {
    return this.clone()._unit();
  },
  /**
   * Compute a perpendicular point, where the new y coordinate
   * is the old x coordinate and the new x coordinate is the old y
   * coordinate multiplied by -1
   * @return {Point} perpendicular point
   */
  perp: function() {
    return this.clone()._perp();
  },
  /**
   * Return a version of this point with the x & y coordinates
   * rounded to integers.
   * @return {Point} rounded point
   */
  round: function() {
    return this.clone()._round();
  },
  /**
   * Return the magitude of this point: this is the Euclidean
   * distance from the 0, 0 coordinate to this point's x and y
   * coordinates.
   * @return {Number} magnitude
   */
  mag: function() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  },
  /**
   * Judge whether this point is equal to another point, returning
   * true or false.
   * @param {Point} other the other point
   * @return {boolean} whether the points are equal
   */
  equals: function(other) {
    return this.x === other.x && this.y === other.y;
  },
  /**
   * Calculate the distance from this point to another point
   * @param {Point} p the other point
   * @return {Number} distance
   */
  dist: function(p2) {
    return Math.sqrt(this.distSqr(p2));
  },
  /**
   * Calculate the distance from this point to another point,
   * without the square root step. Useful if you're comparing
   * relative distances.
   * @param {Point} p the other point
   * @return {Number} distance
   */
  distSqr: function(p2) {
    var dx = p2.x - this.x, dy = p2.y - this.y;
    return dx * dx + dy * dy;
  },
  /**
   * Get the angle from the 0, 0 coordinate to this point, in radians
   * coordinates.
   * @return {Number} angle
   */
  angle: function() {
    return Math.atan2(this.y, this.x);
  },
  /**
   * Get the angle from this point to another point, in radians
   * @param {Point} b the other point
   * @return {Number} angle
   */
  angleTo: function(b2) {
    return Math.atan2(this.y - b2.y, this.x - b2.x);
  },
  /**
   * Get the angle between this point and another point, in radians
   * @param {Point} b the other point
   * @return {Number} angle
   */
  angleWith: function(b2) {
    return this.angleWithSep(b2.x, b2.y);
  },
  /*
   * Find the angle of the two vectors, solving the formula for
   * the cross product a x b = |a||b|sin(θ) for θ.
   * @param {Number} x the x-coordinate
   * @param {Number} y the y-coordinate
   * @return {Number} the angle in radians
   */
  angleWithSep: function(x2, y2) {
    return Math.atan2(
      this.x * y2 - this.y * x2,
      this.x * x2 + this.y * y2
    );
  },
  _matMult: function(m2) {
    var x2 = m2[0] * this.x + m2[1] * this.y, y2 = m2[2] * this.x + m2[3] * this.y;
    this.x = x2;
    this.y = y2;
    return this;
  },
  _add: function(p2) {
    this.x += p2.x;
    this.y += p2.y;
    return this;
  },
  _sub: function(p2) {
    this.x -= p2.x;
    this.y -= p2.y;
    return this;
  },
  _mult: function(k2) {
    this.x *= k2;
    this.y *= k2;
    return this;
  },
  _div: function(k2) {
    this.x /= k2;
    this.y /= k2;
    return this;
  },
  _multByPoint: function(p2) {
    this.x *= p2.x;
    this.y *= p2.y;
    return this;
  },
  _divByPoint: function(p2) {
    this.x /= p2.x;
    this.y /= p2.y;
    return this;
  },
  _unit: function() {
    this._div(this.mag());
    return this;
  },
  _perp: function() {
    var y2 = this.y;
    this.y = this.x;
    this.x = -y2;
    return this;
  },
  _rotate: function(angle4) {
    var cos2 = Math.cos(angle4), sin2 = Math.sin(angle4), x2 = cos2 * this.x - sin2 * this.y, y2 = sin2 * this.x + cos2 * this.y;
    this.x = x2;
    this.y = y2;
    return this;
  },
  _rotateAround: function(angle4, p2) {
    var cos2 = Math.cos(angle4), sin2 = Math.sin(angle4), x2 = p2.x + cos2 * (this.x - p2.x) - sin2 * (this.y - p2.y), y2 = p2.y + sin2 * (this.x - p2.x) + cos2 * (this.y - p2.y);
    this.x = x2;
    this.y = y2;
    return this;
  },
  _round: function() {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this;
  }
};
Point$3.convert = function(a2) {
  if (a2 instanceof Point$3) {
    return a2;
  }
  if (Array.isArray(a2)) {
    return new Point$3(a2[0], a2[1]);
  }
  return a2;
};
function mouseEventPoint$2(mouseEvent, container) {
  const rect = container.getBoundingClientRect();
  return new pointGeometry(
    mouseEvent.clientX - rect.left - (container.clientLeft || 0),
    mouseEvent.clientY - rect.top - (container.clientTop || 0)
  );
}
function createVertex$5(parentId, coordinates2, path2, selected) {
  return {
    type: geojsonTypes.FEATURE,
    properties: {
      meta: meta.VERTEX,
      parent: parentId,
      coord_path: path2,
      active: selected ? activeStates.ACTIVE : activeStates.INACTIVE
    },
    geometry: {
      type: geojsonTypes.POINT,
      coordinates: coordinates2
    }
  };
}
function createMidpoint$1(parent, startVertex, endVertex, map5) {
  const startCoord = startVertex.geometry.coordinates;
  const endCoord = endVertex.geometry.coordinates;
  if (startCoord[1] > LAT_RENDERED_MAX$2 || startCoord[1] < LAT_RENDERED_MIN$2 || endCoord[1] > LAT_RENDERED_MAX$2 || endCoord[1] < LAT_RENDERED_MIN$2) {
    return null;
  }
  const ptA = map5.project([startCoord[0], startCoord[1]]);
  const ptB = map5.project([endCoord[0], endCoord[1]]);
  const mid = map5.unproject([(ptA.x + ptB.x) / 2, (ptA.y + ptB.y) / 2]);
  return {
    type: geojsonTypes.FEATURE,
    properties: {
      meta: meta.MIDPOINT,
      parent,
      lng: mid.lng,
      lat: mid.lat,
      coord_path: endVertex.properties.coord_path
    },
    geometry: {
      type: geojsonTypes.POINT,
      coordinates: [mid.lng, mid.lat]
    }
  };
}
function createSupplementaryPoints$5(geojson, options2 = {}, basePath = null) {
  const { type, coordinates: coordinates2 } = geojson.geometry;
  const featureId = geojson.properties && geojson.properties.id;
  let supplementaryPoints = [];
  if (type === geojsonTypes.POINT) {
    supplementaryPoints.push(createVertex$5(featureId, coordinates2, basePath, isSelectedPath(basePath)));
  } else if (type === geojsonTypes.POLYGON) {
    coordinates2.forEach((line, lineIndex) => {
      processLine(line, basePath !== null ? `${basePath}.${lineIndex}` : String(lineIndex));
    });
  } else if (type === geojsonTypes.LINE_STRING) {
    processLine(coordinates2, basePath);
  } else if (type.indexOf(geojsonTypes.MULTI_PREFIX) === 0) {
    processMultiGeometry();
  }
  function processLine(line, lineBasePath) {
    let firstPointString = "";
    let lastVertex = null;
    line.forEach((point4, pointIndex) => {
      const pointPath = lineBasePath !== void 0 && lineBasePath !== null ? `${lineBasePath}.${pointIndex}` : String(pointIndex);
      const vertex2 = createVertex$5(featureId, point4, pointPath, isSelectedPath(pointPath));
      if (options2.midpoints && lastVertex) {
        const midpoint2 = createMidpoint$1(featureId, lastVertex, vertex2, options2.map);
        if (midpoint2) {
          supplementaryPoints.push(midpoint2);
        }
      }
      lastVertex = vertex2;
      const stringifiedPoint = JSON.stringify(point4);
      if (firstPointString !== stringifiedPoint) {
        supplementaryPoints.push(vertex2);
      }
      if (pointIndex === 0) {
        firstPointString = stringifiedPoint;
      }
    });
  }
  function isSelectedPath(path2) {
    if (!options2.selectedPaths)
      return false;
    return options2.selectedPaths.indexOf(path2) !== -1;
  }
  function processMultiGeometry() {
    const subType = type.replace(geojsonTypes.MULTI_PREFIX, "");
    coordinates2.forEach((subCoordinates, index2) => {
      const subFeature = {
        type: geojsonTypes.FEATURE,
        properties: geojson.properties,
        geometry: {
          type: subType,
          coordinates: subCoordinates
        }
      };
      supplementaryPoints = supplementaryPoints.concat(createSupplementaryPoints$5(subFeature, options2, index2));
    });
  }
  return supplementaryPoints;
}
const doubleClickZoom$8 = {
  enable(ctx2) {
    setTimeout(() => {
      if (!ctx2.map || !ctx2.map.doubleClickZoom || !ctx2._ctx || !ctx2._ctx.store || !ctx2._ctx.store.getInitialConfigValue)
        return;
      if (!ctx2._ctx.store.getInitialConfigValue("doubleClickZoom"))
        return;
      ctx2.map.doubleClickZoom.enable();
    }, 0);
  },
  disable(ctx2) {
    setTimeout(() => {
      if (!ctx2.map || !ctx2.map.doubleClickZoom)
        return;
      ctx2.map.doubleClickZoom.disable();
    }, 0);
  }
};
var geojsonExtentExports = {};
var geojsonExtent = {
  get exports() {
    return geojsonExtentExports;
  },
  set exports(v5) {
    geojsonExtentExports = v5;
  }
};
var geojsonNormalize$1 = normalize$1;
var types = {
  Point: "geometry",
  MultiPoint: "geometry",
  LineString: "geometry",
  MultiLineString: "geometry",
  Polygon: "geometry",
  MultiPolygon: "geometry",
  GeometryCollection: "geometry",
  Feature: "feature",
  FeatureCollection: "featurecollection"
};
function normalize$1(gj) {
  if (!gj || !gj.type)
    return null;
  var type = types[gj.type];
  if (!type)
    return null;
  if (type === "geometry") {
    return {
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        properties: {},
        geometry: gj
      }]
    };
  } else if (type === "feature") {
    return {
      type: "FeatureCollection",
      features: [gj]
    };
  } else if (type === "featurecollection") {
    return gj;
  }
}
var dist$1 = function e2(t2) {
  switch (t2 && t2.type || null) {
    case "FeatureCollection":
      return t2.features = t2.features.reduce(function(t3, r2) {
        return t3.concat(e2(r2));
      }, []), t2;
    case "Feature":
      return t2.geometry ? e2(t2.geometry).map(function(e3) {
        var r2 = { type: "Feature", properties: JSON.parse(JSON.stringify(t2.properties)), geometry: e3 };
        return void 0 !== t2.id && (r2.id = t2.id), r2;
      }) : t2;
    case "MultiPoint":
      return t2.coordinates.map(function(e3) {
        return { type: "Point", coordinates: e3 };
      });
    case "MultiPolygon":
      return t2.coordinates.map(function(e3) {
        return { type: "Polygon", coordinates: e3 };
      });
    case "MultiLineString":
      return t2.coordinates.map(function(e3) {
        return { type: "LineString", coordinates: e3 };
      });
    case "GeometryCollection":
      return t2.geometries.map(e2).reduce(function(e3, t3) {
        return e3.concat(t3);
      }, []);
    case "Point":
    case "Polygon":
    case "LineString":
      return [t2];
  }
};
var flatten$1 = function flatten2(list2) {
  return _flatten(list2);
  function _flatten(list3) {
    if (Array.isArray(list3) && list3.length && typeof list3[0] === "number") {
      return [list3];
    }
    return list3.reduce(function(acc, item) {
      if (Array.isArray(item) && Array.isArray(item[0])) {
        return acc.concat(_flatten(item));
      } else {
        acc.push(item);
        return acc;
      }
    }, []);
  }
};
var geojsonNormalize = geojsonNormalize$1, geojsonFlatten = dist$1, flatten = flatten$1;
var geojsonCoords$1 = function(_2) {
  if (!_2)
    return [];
  var normalized = geojsonFlatten(geojsonNormalize(_2)), coordinates2 = [];
  normalized.features.forEach(function(feature2) {
    if (!feature2.geometry)
      return;
    coordinates2 = coordinates2.concat(flatten(feature2.geometry.coordinates));
  });
  return coordinates2;
};
function toS(obj) {
  return Object.prototype.toString.call(obj);
}
function isDate(obj) {
  return toS(obj) === "[object Date]";
}
function isRegExp(obj) {
  return toS(obj) === "[object RegExp]";
}
function isError(obj) {
  return toS(obj) === "[object Error]";
}
function isBoolean(obj) {
  return toS(obj) === "[object Boolean]";
}
function isNumber$9(obj) {
  return toS(obj) === "[object Number]";
}
function isString(obj) {
  return toS(obj) === "[object String]";
}
var isArray = Array.isArray || function isArray2(xs) {
  return Object.prototype.toString.call(xs) === "[object Array]";
};
function forEach$1(xs, fn2) {
  if (xs.forEach) {
    return xs.forEach(fn2);
  }
  for (var i2 = 0; i2 < xs.length; i2++) {
    fn2(xs[i2], i2, xs);
  }
  return void 0;
}
var objectKeys = Object.keys || function keys3(obj) {
  var res = [];
  for (var key in obj) {
    res.push(key);
  }
  return res;
};
var hasOwnProperty$1 = Object.prototype.hasOwnProperty || function(obj, key) {
  return key in obj;
};
function copy(src2) {
  if (typeof src2 === "object" && src2 !== null) {
    var dst;
    if (isArray(src2)) {
      dst = [];
    } else if (isDate(src2)) {
      dst = new Date(src2.getTime ? src2.getTime() : src2);
    } else if (isRegExp(src2)) {
      dst = new RegExp(src2);
    } else if (isError(src2)) {
      dst = { message: src2.message };
    } else if (isBoolean(src2) || isNumber$9(src2) || isString(src2)) {
      dst = Object(src2);
    } else if (Object.create && Object.getPrototypeOf) {
      dst = Object.create(Object.getPrototypeOf(src2));
    } else if (src2.constructor === Object) {
      dst = {};
    } else {
      var proto = src2.constructor && src2.constructor.prototype || src2.__proto__ || {};
      var T2 = function T3() {
      };
      T2.prototype = proto;
      dst = new T2();
    }
    forEach$1(objectKeys(src2), function(key) {
      dst[key] = src2[key];
    });
    return dst;
  }
  return src2;
}
function walk(root2, cb2, immutable2) {
  var path2 = [];
  var parents = [];
  var alive = true;
  return function walker(node_) {
    var node = immutable2 ? copy(node_) : node_;
    var modifiers = {};
    var keepGoing = true;
    var state = {
      node,
      node_,
      path: [].concat(path2),
      parent: parents[parents.length - 1],
      parents,
      key: path2[path2.length - 1],
      isRoot: path2.length === 0,
      level: path2.length,
      circular: null,
      update: function(x2, stopHere) {
        if (!state.isRoot) {
          state.parent.node[state.key] = x2;
        }
        state.node = x2;
        if (stopHere) {
          keepGoing = false;
        }
      },
      delete: function(stopHere) {
        delete state.parent.node[state.key];
        if (stopHere) {
          keepGoing = false;
        }
      },
      remove: function(stopHere) {
        if (isArray(state.parent.node)) {
          state.parent.node.splice(state.key, 1);
        } else {
          delete state.parent.node[state.key];
        }
        if (stopHere) {
          keepGoing = false;
        }
      },
      keys: null,
      before: function(f2) {
        modifiers.before = f2;
      },
      after: function(f2) {
        modifiers.after = f2;
      },
      pre: function(f2) {
        modifiers.pre = f2;
      },
      post: function(f2) {
        modifiers.post = f2;
      },
      stop: function() {
        alive = false;
      },
      block: function() {
        keepGoing = false;
      }
    };
    if (!alive) {
      return state;
    }
    function updateState() {
      if (typeof state.node === "object" && state.node !== null) {
        if (!state.keys || state.node_ !== state.node) {
          state.keys = objectKeys(state.node);
        }
        state.isLeaf = state.keys.length === 0;
        for (var i2 = 0; i2 < parents.length; i2++) {
          if (parents[i2].node_ === node_) {
            state.circular = parents[i2];
            break;
          }
        }
      } else {
        state.isLeaf = true;
        state.keys = null;
      }
      state.notLeaf = !state.isLeaf;
      state.notRoot = !state.isRoot;
    }
    updateState();
    var ret = cb2.call(state, state.node);
    if (ret !== void 0 && state.update) {
      state.update(ret);
    }
    if (modifiers.before) {
      modifiers.before.call(state, state.node);
    }
    if (!keepGoing) {
      return state;
    }
    if (typeof state.node === "object" && state.node !== null && !state.circular) {
      parents.push(state);
      updateState();
      forEach$1(state.keys, function(key, i2) {
        path2.push(key);
        if (modifiers.pre) {
          modifiers.pre.call(state, state.node[key], key);
        }
        var child = walker(state.node[key]);
        if (immutable2 && hasOwnProperty$1.call(state.node, key)) {
          state.node[key] = child.node;
        }
        child.isLast = i2 === state.keys.length - 1;
        child.isFirst = i2 === 0;
        if (modifiers.post) {
          modifiers.post.call(state, child);
        }
        path2.pop();
      });
      parents.pop();
    }
    if (modifiers.after) {
      modifiers.after.call(state, state.node);
    }
    return state;
  }(root2).node;
}
function Traverse(obj) {
  this.value = obj;
}
Traverse.prototype.get = function(ps) {
  var node = this.value;
  for (var i2 = 0; i2 < ps.length; i2++) {
    var key = ps[i2];
    if (!node || !hasOwnProperty$1.call(node, key)) {
      return void 0;
    }
    node = node[key];
  }
  return node;
};
Traverse.prototype.has = function(ps) {
  var node = this.value;
  for (var i2 = 0; i2 < ps.length; i2++) {
    var key = ps[i2];
    if (!node || !hasOwnProperty$1.call(node, key)) {
      return false;
    }
    node = node[key];
  }
  return true;
};
Traverse.prototype.set = function(ps, value) {
  var node = this.value;
  for (var i2 = 0; i2 < ps.length - 1; i2++) {
    var key = ps[i2];
    if (!hasOwnProperty$1.call(node, key)) {
      node[key] = {};
    }
    node = node[key];
  }
  node[ps[i2]] = value;
  return value;
};
Traverse.prototype.map = function(cb2) {
  return walk(this.value, cb2, true);
};
Traverse.prototype.forEach = function(cb2) {
  this.value = walk(this.value, cb2, false);
  return this.value;
};
Traverse.prototype.reduce = function(cb2, init9) {
  var skip = arguments.length === 1;
  var acc = skip ? this.value : init9;
  this.forEach(function(x2) {
    if (!this.isRoot || !skip) {
      acc = cb2.call(this, acc, x2);
    }
  });
  return acc;
};
Traverse.prototype.paths = function() {
  var acc = [];
  this.forEach(function() {
    acc.push(this.path);
  });
  return acc;
};
Traverse.prototype.nodes = function() {
  var acc = [];
  this.forEach(function() {
    acc.push(this.node);
  });
  return acc;
};
Traverse.prototype.clone = function() {
  var parents = [];
  var nodes = [];
  return function clone8(src2) {
    for (var i2 = 0; i2 < parents.length; i2++) {
      if (parents[i2] === src2) {
        return nodes[i2];
      }
    }
    if (typeof src2 === "object" && src2 !== null) {
      var dst = copy(src2);
      parents.push(src2);
      nodes.push(dst);
      forEach$1(objectKeys(src2), function(key) {
        dst[key] = clone8(src2[key]);
      });
      parents.pop();
      nodes.pop();
      return dst;
    }
    return src2;
  }(this.value);
};
function traverse$1(obj) {
  return new Traverse(obj);
}
forEach$1(objectKeys(Traverse.prototype), function(key) {
  traverse$1[key] = function(obj) {
    var args = [].slice.call(arguments, 1);
    var t2 = new Traverse(obj);
    return t2[key].apply(t2, args);
  };
});
var traverse_1 = traverse$1;
var extent$2 = Extent;
function Extent(bbox2) {
  if (!(this instanceof Extent)) {
    return new Extent(bbox2);
  }
  this._bbox = bbox2 || [Infinity, Infinity, -Infinity, -Infinity];
  this._valid = !!bbox2;
}
Extent.prototype.include = function(ll) {
  this._valid = true;
  this._bbox[0] = Math.min(this._bbox[0], ll[0]);
  this._bbox[1] = Math.min(this._bbox[1], ll[1]);
  this._bbox[2] = Math.max(this._bbox[2], ll[0]);
  this._bbox[3] = Math.max(this._bbox[3], ll[1]);
  return this;
};
Extent.prototype.equals = function(_2) {
  var other;
  if (_2 instanceof Extent) {
    other = _2.bbox();
  } else {
    other = _2;
  }
  return this._bbox[0] == other[0] && this._bbox[1] == other[1] && this._bbox[2] == other[2] && this._bbox[3] == other[3];
};
Extent.prototype.center = function(_2) {
  if (!this._valid)
    return null;
  return [
    (this._bbox[0] + this._bbox[2]) / 2,
    (this._bbox[1] + this._bbox[3]) / 2
  ];
};
Extent.prototype.union = function(_2) {
  this._valid = true;
  var other;
  if (_2 instanceof Extent) {
    other = _2.bbox();
  } else {
    other = _2;
  }
  this._bbox[0] = Math.min(this._bbox[0], other[0]);
  this._bbox[1] = Math.min(this._bbox[1], other[1]);
  this._bbox[2] = Math.max(this._bbox[2], other[2]);
  this._bbox[3] = Math.max(this._bbox[3], other[3]);
  return this;
};
Extent.prototype.bbox = function() {
  if (!this._valid)
    return null;
  return this._bbox;
};
Extent.prototype.contains = function(ll) {
  if (!ll)
    return this._fastContains();
  if (!this._valid)
    return null;
  var lon = ll[0], lat = ll[1];
  return this._bbox[0] <= lon && this._bbox[1] <= lat && this._bbox[2] >= lon && this._bbox[3] >= lat;
};
Extent.prototype.intersect = function(_2) {
  if (!this._valid)
    return null;
  var other;
  if (_2 instanceof Extent) {
    other = _2.bbox();
  } else {
    other = _2;
  }
  return !(this._bbox[0] > other[2] || this._bbox[2] < other[0] || this._bbox[3] < other[1] || this._bbox[1] > other[3]);
};
Extent.prototype._fastContains = function() {
  if (!this._valid)
    return new Function("return null;");
  var body = "return " + this._bbox[0] + "<= ll[0] &&" + this._bbox[1] + "<= ll[1] &&" + this._bbox[2] + ">= ll[0] &&" + this._bbox[3] + ">= ll[1]";
  return new Function("ll", body);
};
Extent.prototype.polygon = function() {
  if (!this._valid)
    return null;
  return {
    type: "Polygon",
    coordinates: [
      [
        // W, S
        [this._bbox[0], this._bbox[1]],
        // E, S
        [this._bbox[2], this._bbox[1]],
        // E, N
        [this._bbox[2], this._bbox[3]],
        // W, N
        [this._bbox[0], this._bbox[3]],
        // W, S
        [this._bbox[0], this._bbox[1]]
      ]
    ]
  };
};
var geojsonCoords = geojsonCoords$1, traverse = traverse_1, extent$1 = extent$2;
var geojsonTypesByDataAttributes = {
  features: ["FeatureCollection"],
  coordinates: ["Point", "MultiPoint", "LineString", "MultiLineString", "Polygon", "MultiPolygon"],
  geometry: ["Feature"],
  geometries: ["GeometryCollection"]
};
var dataAttributes = Object.keys(geojsonTypesByDataAttributes);
geojsonExtent.exports = function(_2) {
  return getExtent(_2).bbox();
};
geojsonExtentExports.polygon = function(_2) {
  return getExtent(_2).polygon();
};
geojsonExtentExports.bboxify = function(_2) {
  return traverse(_2).map(function(value) {
    if (!value)
      return;
    var isValid8 = dataAttributes.some(function(attribute) {
      if (value[attribute]) {
        return geojsonTypesByDataAttributes[attribute].indexOf(value.type) !== -1;
      }
      return false;
    });
    if (isValid8) {
      value.bbox = getExtent(value).bbox();
      this.update(value);
    }
  });
};
function getExtent(_2) {
  var ext = extent$1(), coords = geojsonCoords(_2);
  for (var i2 = 0; i2 < coords.length; i2++)
    ext.include(coords[i2]);
  return ext;
}
const {
  LAT_MIN: LAT_MIN$1,
  LAT_MAX: LAT_MAX$1,
  LAT_RENDERED_MIN: LAT_RENDERED_MIN$1,
  LAT_RENDERED_MAX: LAT_RENDERED_MAX$1,
  LNG_MIN: LNG_MIN$1,
  LNG_MAX: LNG_MAX$1
} = Constants$s;
function constrainFeatureMovement$3(geojsonFeatures, delta) {
  let northInnerEdge = LAT_MIN$1;
  let southInnerEdge = LAT_MAX$1;
  let northOuterEdge = LAT_MIN$1;
  let southOuterEdge = LAT_MAX$1;
  let westEdge = LNG_MAX$1;
  let eastEdge = LNG_MIN$1;
  geojsonFeatures.forEach((feature2) => {
    const bounds = geojsonExtentExports(feature2);
    const featureSouthEdge = bounds[1];
    const featureNorthEdge = bounds[3];
    const featureWestEdge = bounds[0];
    const featureEastEdge = bounds[2];
    if (featureSouthEdge > northInnerEdge)
      northInnerEdge = featureSouthEdge;
    if (featureNorthEdge < southInnerEdge)
      southInnerEdge = featureNorthEdge;
    if (featureNorthEdge > northOuterEdge)
      northOuterEdge = featureNorthEdge;
    if (featureSouthEdge < southOuterEdge)
      southOuterEdge = featureSouthEdge;
    if (featureWestEdge < westEdge)
      westEdge = featureWestEdge;
    if (featureEastEdge > eastEdge)
      eastEdge = featureEastEdge;
  });
  const constrainedDelta = delta;
  if (northInnerEdge + constrainedDelta.lat > LAT_RENDERED_MAX$1) {
    constrainedDelta.lat = LAT_RENDERED_MAX$1 - northInnerEdge;
  }
  if (northOuterEdge + constrainedDelta.lat > LAT_MAX$1) {
    constrainedDelta.lat = LAT_MAX$1 - northOuterEdge;
  }
  if (southInnerEdge + constrainedDelta.lat < LAT_RENDERED_MIN$1) {
    constrainedDelta.lat = LAT_RENDERED_MIN$1 - southInnerEdge;
  }
  if (southOuterEdge + constrainedDelta.lat < LAT_MIN$1) {
    constrainedDelta.lat = LAT_MIN$1 - southOuterEdge;
  }
  if (westEdge + constrainedDelta.lng <= LNG_MIN$1) {
    constrainedDelta.lng += Math.ceil(Math.abs(constrainedDelta.lng) / 360) * 360;
  }
  if (eastEdge + constrainedDelta.lng >= LNG_MAX$1) {
    constrainedDelta.lng -= Math.ceil(Math.abs(constrainedDelta.lng) / 360) * 360;
  }
  return constrainedDelta;
}
function moveFeatures$4(features, delta) {
  const constrainedDelta = constrainFeatureMovement$3(features.map((feature2) => feature2.toGeoJSON()), delta);
  features.forEach((feature2) => {
    const currentCoordinates = feature2.getCoordinates();
    const moveCoordinate = (coord) => {
      const point4 = {
        lng: coord[0] + constrainedDelta.lng,
        lat: coord[1] + constrainedDelta.lat
      };
      return [point4.lng, point4.lat];
    };
    const moveRing = (ring) => ring.map((coord) => moveCoordinate(coord));
    const moveMultiPolygon = (multi) => multi.map((ring) => moveRing(ring));
    let nextCoordinates;
    if (feature2.type === geojsonTypes.POINT) {
      nextCoordinates = moveCoordinate(currentCoordinates);
    } else if (feature2.type === geojsonTypes.LINE_STRING || feature2.type === geojsonTypes.MULTI_POINT) {
      nextCoordinates = currentCoordinates.map(moveCoordinate);
    } else if (feature2.type === geojsonTypes.POLYGON || feature2.type === geojsonTypes.MULTI_LINE_STRING) {
      nextCoordinates = currentCoordinates.map(moveRing);
    } else if (feature2.type === geojsonTypes.MULTI_POLYGON) {
      nextCoordinates = currentCoordinates.map(moveMultiPolygon);
    }
    feature2.incomingCoords(nextCoordinates);
  });
}
const SimpleSelect$1 = {};
SimpleSelect$1.onSetup = function(opts) {
  const state = {
    dragMoveLocation: null,
    boxSelectStartLocation: null,
    boxSelectElement: void 0,
    boxSelecting: false,
    canBoxSelect: false,
    dragMoving: false,
    canDragMove: false,
    initiallySelectedFeatureIds: opts.featureIds || []
  };
  this.setSelected(state.initiallySelectedFeatureIds.filter((id) => this.getFeature(id) !== void 0));
  this.fireActionable();
  this.setActionableState({
    combineFeatures: true,
    uncombineFeatures: true,
    trash: true
  });
  return state;
};
SimpleSelect$1.fireUpdate = function() {
  this.map.fire(events$6.UPDATE, {
    action: updateActions.MOVE,
    features: this.getSelected().map((f2) => f2.toGeoJSON())
  });
};
SimpleSelect$1.fireActionable = function() {
  const selectedFeatures = this.getSelected();
  const multiFeatures = selectedFeatures.filter(
    (feature2) => this.isInstanceOf("MultiFeature", feature2)
  );
  let combineFeatures = false;
  if (selectedFeatures.length > 1) {
    combineFeatures = true;
    const featureType = selectedFeatures[0].type.replace("Multi", "");
    selectedFeatures.forEach((feature2) => {
      if (feature2.type.replace("Multi", "") !== featureType) {
        combineFeatures = false;
      }
    });
  }
  const uncombineFeatures = multiFeatures.length > 0;
  const trash = selectedFeatures.length > 0;
  this.setActionableState({
    combineFeatures,
    uncombineFeatures,
    trash
  });
};
SimpleSelect$1.getUniqueIds = function(allFeatures) {
  if (!allFeatures.length)
    return [];
  const ids = allFeatures.map((s2) => s2.properties.id).filter((id) => id !== void 0).reduce((memo, id) => {
    memo.add(id);
    return memo;
  }, new StringSet$5());
  return ids.values();
};
SimpleSelect$1.stopExtendedInteractions = function(state) {
  if (state.boxSelectElement) {
    if (state.boxSelectElement.parentNode)
      state.boxSelectElement.parentNode.removeChild(state.boxSelectElement);
    state.boxSelectElement = null;
  }
  this.map.dragPan.enable();
  state.boxSelecting = false;
  state.canBoxSelect = false;
  state.dragMoving = false;
  state.canDragMove = false;
};
SimpleSelect$1.onStop = function() {
  doubleClickZoom$8.enable(this);
};
SimpleSelect$1.onMouseMove = function(state) {
  return this.stopExtendedInteractions(state);
};
SimpleSelect$1.onMouseOut = function(state) {
  if (state.dragMoving)
    return this.fireUpdate();
};
SimpleSelect$1.onTap = SimpleSelect$1.onClick = function(state, e3) {
  if (noTarget$1(e3))
    return this.clickAnywhere(state, e3);
  if (isOfMetaType$1(meta.VERTEX)(e3))
    return this.clickOnVertex(state, e3);
  if (isFeature(e3))
    return this.clickOnFeature(state, e3);
};
SimpleSelect$1.clickAnywhere = function(state) {
  const wasSelected = this.getSelectedIds();
  if (wasSelected.length) {
    this.clearSelectedFeatures();
    wasSelected.forEach((id) => this.doRender(id));
  }
  doubleClickZoom$8.enable(this);
  this.stopExtendedInteractions(state);
};
SimpleSelect$1.clickOnVertex = function(state, e3) {
  this.changeMode(modes$2.DIRECT_SELECT, {
    featureId: e3.featureTarget.properties.parent,
    coordPath: e3.featureTarget.properties.coord_path,
    startPos: e3.lngLat
  });
  this.updateUIClasses({ mouse: cursors.MOVE });
};
SimpleSelect$1.startOnActiveFeature = function(state, e3) {
  this.stopExtendedInteractions(state);
  this.map.dragPan.disable();
  this.doRender(e3.featureTarget.properties.id);
  state.canDragMove = true;
  state.dragMoveLocation = e3.lngLat;
};
SimpleSelect$1.clickOnFeature = function(state, e3) {
  doubleClickZoom$8.disable(this);
  this.stopExtendedInteractions(state);
  const isShiftClick = isShiftDown$1(e3);
  const selectedFeatureIds = this.getSelectedIds();
  const featureId = e3.featureTarget.properties.id;
  const isFeatureSelected = this.isSelected(featureId);
  if (!isShiftClick && isFeatureSelected && this.getFeature(featureId).type !== geojsonTypes.POINT) {
    return this.changeMode(modes$2.DIRECT_SELECT, {
      featureId
    });
  }
  if (isFeatureSelected && isShiftClick) {
    this.deselect(featureId);
    this.updateUIClasses({ mouse: cursors.POINTER });
    if (selectedFeatureIds.length === 1) {
      doubleClickZoom$8.enable(this);
    }
  } else if (!isFeatureSelected && isShiftClick) {
    this.select(featureId);
    this.updateUIClasses({ mouse: cursors.MOVE });
  } else if (!isFeatureSelected && !isShiftClick) {
    selectedFeatureIds.forEach((id) => this.doRender(id));
    this.setSelected(featureId);
    this.updateUIClasses({ mouse: cursors.MOVE });
  }
  this.doRender(featureId);
};
SimpleSelect$1.onMouseDown = function(state, e3) {
  if (isActiveFeature(e3))
    return this.startOnActiveFeature(state, e3);
  if (this.drawConfig.boxSelect && isShiftMousedown(e3))
    return this.startBoxSelect(state, e3);
};
SimpleSelect$1.startBoxSelect = function(state, e3) {
  this.stopExtendedInteractions(state);
  this.map.dragPan.disable();
  state.boxSelectStartLocation = mouseEventPoint$2(e3.originalEvent, this.map.getContainer());
  state.canBoxSelect = true;
};
SimpleSelect$1.onTouchStart = function(state, e3) {
  if (isActiveFeature(e3))
    return this.startOnActiveFeature(state, e3);
};
SimpleSelect$1.onDrag = function(state, e3) {
  if (state.canDragMove)
    return this.dragMove(state, e3);
  if (this.drawConfig.boxSelect && state.canBoxSelect)
    return this.whileBoxSelect(state, e3);
};
SimpleSelect$1.whileBoxSelect = function(state, e3) {
  state.boxSelecting = true;
  this.updateUIClasses({ mouse: cursors.ADD });
  if (!state.boxSelectElement) {
    state.boxSelectElement = document.createElement("div");
    state.boxSelectElement.classList.add(classes.BOX_SELECT);
    this.map.getContainer().appendChild(state.boxSelectElement);
  }
  const current = mouseEventPoint$2(e3.originalEvent, this.map.getContainer());
  const minX2 = Math.min(state.boxSelectStartLocation.x, current.x);
  const maxX2 = Math.max(state.boxSelectStartLocation.x, current.x);
  const minY2 = Math.min(state.boxSelectStartLocation.y, current.y);
  const maxY2 = Math.max(state.boxSelectStartLocation.y, current.y);
  const translateValue = `translate(${minX2}px, ${minY2}px)`;
  state.boxSelectElement.style.transform = translateValue;
  state.boxSelectElement.style.WebkitTransform = translateValue;
  state.boxSelectElement.style.width = `${maxX2 - minX2}px`;
  state.boxSelectElement.style.height = `${maxY2 - minY2}px`;
};
SimpleSelect$1.dragMove = function(state, e3) {
  state.dragMoving = true;
  e3.originalEvent.stopPropagation();
  const delta = {
    lng: e3.lngLat.lng - state.dragMoveLocation.lng,
    lat: e3.lngLat.lat - state.dragMoveLocation.lat
  };
  moveFeatures$4(this.getSelected(), delta);
  state.dragMoveLocation = e3.lngLat;
};
SimpleSelect$1.onMouseUp = function(state, e3) {
  if (state.dragMoving) {
    this.fireUpdate();
  } else if (state.boxSelecting) {
    const bbox2 = [
      state.boxSelectStartLocation,
      mouseEventPoint$2(e3.originalEvent, this.map.getContainer())
    ];
    const featuresInBox = this.featuresAt(null, bbox2, "click");
    const idsToSelect = this.getUniqueIds(featuresInBox).filter((id) => !this.isSelected(id));
    if (idsToSelect.length) {
      this.select(idsToSelect);
      idsToSelect.forEach((id) => this.doRender(id));
      this.updateUIClasses({ mouse: cursors.MOVE });
    }
  }
  this.stopExtendedInteractions(state);
};
SimpleSelect$1.toDisplayFeatures = function(state, geojson, display) {
  geojson.properties.active = this.isSelected(geojson.properties.id) ? activeStates.ACTIVE : activeStates.INACTIVE;
  display(geojson);
  this.fireActionable();
  if (geojson.properties.active !== activeStates.ACTIVE || geojson.geometry.type === geojsonTypes.POINT)
    return;
  createSupplementaryPoints$5(geojson).forEach(display);
};
SimpleSelect$1.onTrash = function() {
  this.deleteFeature(this.getSelectedIds());
  this.fireActionable();
};
SimpleSelect$1.onCombineFeatures = function() {
  const selectedFeatures = this.getSelected();
  if (selectedFeatures.length === 0 || selectedFeatures.length < 2)
    return;
  const coordinates2 = [], featuresCombined = [];
  const featureType = selectedFeatures[0].type.replace("Multi", "");
  for (let i2 = 0; i2 < selectedFeatures.length; i2++) {
    const feature2 = selectedFeatures[i2];
    if (feature2.type.replace("Multi", "") !== featureType) {
      return;
    }
    if (feature2.type.includes("Multi")) {
      feature2.getCoordinates().forEach((subcoords) => {
        coordinates2.push(subcoords);
      });
    } else {
      coordinates2.push(feature2.getCoordinates());
    }
    featuresCombined.push(feature2.toGeoJSON());
  }
  if (featuresCombined.length > 1) {
    const multiFeature = this.newFeature({
      type: geojsonTypes.FEATURE,
      properties: featuresCombined[0].properties,
      geometry: {
        type: `Multi${featureType}`,
        coordinates: coordinates2
      }
    });
    this.addFeature(multiFeature);
    this.deleteFeature(this.getSelectedIds(), { silent: true });
    this.setSelected([multiFeature.id]);
    this.map.fire(events$6.COMBINE_FEATURES, {
      createdFeatures: [multiFeature.toGeoJSON()],
      deletedFeatures: featuresCombined
    });
  }
  this.fireActionable();
};
SimpleSelect$1.onUncombineFeatures = function() {
  const selectedFeatures = this.getSelected();
  if (selectedFeatures.length === 0)
    return;
  const createdFeatures = [];
  const featuresUncombined = [];
  for (let i2 = 0; i2 < selectedFeatures.length; i2++) {
    const feature2 = selectedFeatures[i2];
    if (this.isInstanceOf("MultiFeature", feature2)) {
      feature2.getFeatures().forEach((subFeature) => {
        this.addFeature(subFeature);
        subFeature.properties = feature2.properties;
        createdFeatures.push(subFeature.toGeoJSON());
        this.select([subFeature.id]);
      });
      this.deleteFeature(feature2.id, { silent: true });
      featuresUncombined.push(feature2.toGeoJSON());
    }
  }
  if (createdFeatures.length > 1) {
    this.map.fire(events$6.UNCOMBINE_FEATURES, {
      createdFeatures,
      deletedFeatures: featuresUncombined
    });
  }
  this.fireActionable();
};
const isVertex$1 = isOfMetaType$1(meta.VERTEX);
const isMidpoint$1 = isOfMetaType$1(meta.MIDPOINT);
const DirectSelect$1 = {};
DirectSelect$1.fireUpdate = function() {
  this.map.fire(events$6.UPDATE, {
    action: updateActions.CHANGE_COORDINATES,
    features: this.getSelected().map((f2) => f2.toGeoJSON())
  });
};
DirectSelect$1.fireActionable = function(state) {
  this.setActionableState({
    combineFeatures: false,
    uncombineFeatures: false,
    trash: state.selectedCoordPaths.length > 0
  });
};
DirectSelect$1.startDragging = function(state, e3) {
  this.map.dragPan.disable();
  state.canDragMove = true;
  state.dragMoveLocation = e3.lngLat;
};
DirectSelect$1.stopDragging = function(state) {
  this.map.dragPan.enable();
  state.dragMoving = false;
  state.canDragMove = false;
  state.dragMoveLocation = null;
};
DirectSelect$1.onVertex = function(state, e3) {
  this.startDragging(state, e3);
  const about = e3.featureTarget.properties;
  const selectedIndex = state.selectedCoordPaths.indexOf(about.coord_path);
  if (!isShiftDown$1(e3) && selectedIndex === -1) {
    state.selectedCoordPaths = [about.coord_path];
  } else if (isShiftDown$1(e3) && selectedIndex === -1) {
    state.selectedCoordPaths.push(about.coord_path);
  }
  const selectedCoordinates = this.pathsToCoordinates(state.featureId, state.selectedCoordPaths);
  this.setSelectedCoordinates(selectedCoordinates);
};
DirectSelect$1.onMidpoint = function(state, e3) {
  this.startDragging(state, e3);
  const about = e3.featureTarget.properties;
  state.feature.addCoordinate(about.coord_path, about.lng, about.lat);
  this.fireUpdate();
  state.selectedCoordPaths = [about.coord_path];
};
DirectSelect$1.pathsToCoordinates = function(featureId, paths) {
  return paths.map((coord_path) => ({ feature_id: featureId, coord_path }));
};
DirectSelect$1.onFeature = function(state, e3) {
  if (state.selectedCoordPaths.length === 0)
    this.startDragging(state, e3);
  else
    this.stopDragging(state);
};
DirectSelect$1.dragFeature = function(state, e3, delta) {
  moveFeatures$4(this.getSelected(), delta);
  state.dragMoveLocation = e3.lngLat;
};
DirectSelect$1.dragVertex = function(state, e3, delta) {
  const selectedCoords = state.selectedCoordPaths.map((coord_path) => state.feature.getCoordinate(coord_path));
  const selectedCoordPoints = selectedCoords.map((coords) => ({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.POINT,
      coordinates: coords
    }
  }));
  const constrainedDelta = constrainFeatureMovement$3(selectedCoordPoints, delta);
  for (let i2 = 0; i2 < selectedCoords.length; i2++) {
    const coord = selectedCoords[i2];
    state.feature.updateCoordinate(state.selectedCoordPaths[i2], coord[0] + constrainedDelta.lng, coord[1] + constrainedDelta.lat);
  }
};
DirectSelect$1.clickNoTarget = function() {
  this.changeMode(modes$2.SIMPLE_SELECT);
};
DirectSelect$1.clickInactive = function() {
  this.changeMode(modes$2.SIMPLE_SELECT);
};
DirectSelect$1.clickActiveFeature = function(state) {
  state.selectedCoordPaths = [];
  this.clearSelectedCoordinates();
  state.feature.changed();
};
DirectSelect$1.onSetup = function(opts) {
  const featureId = opts.featureId;
  const feature2 = this.getFeature(featureId);
  if (!feature2) {
    throw new Error("You must provide a featureId to enter direct_select mode");
  }
  if (feature2.type === geojsonTypes.POINT) {
    throw new TypeError("direct_select mode doesn't handle point features");
  }
  const state = {
    featureId,
    feature: feature2,
    dragMoveLocation: opts.startPos || null,
    dragMoving: false,
    canDragMove: false,
    selectedCoordPaths: opts.coordPath ? [opts.coordPath] : []
  };
  this.setSelectedCoordinates(this.pathsToCoordinates(featureId, state.selectedCoordPaths));
  this.setSelected(featureId);
  doubleClickZoom$8.disable(this);
  this.setActionableState({
    trash: true
  });
  return state;
};
DirectSelect$1.onStop = function() {
  doubleClickZoom$8.enable(this);
  this.clearSelectedCoordinates();
};
DirectSelect$1.toDisplayFeatures = function(state, geojson, push2) {
  if (state.featureId === geojson.properties.id) {
    geojson.properties.active = activeStates.ACTIVE;
    push2(geojson);
    createSupplementaryPoints$5(geojson, {
      map: this.map,
      midpoints: true,
      selectedPaths: state.selectedCoordPaths
    }).forEach(push2);
  } else {
    geojson.properties.active = activeStates.INACTIVE;
    push2(geojson);
  }
  this.fireActionable(state);
};
DirectSelect$1.onTrash = function(state) {
  state.selectedCoordPaths.sort((a2, b2) => b2.localeCompare(a2, "en", { numeric: true })).forEach((id) => state.feature.removeCoordinate(id));
  this.fireUpdate();
  state.selectedCoordPaths = [];
  this.clearSelectedCoordinates();
  this.fireActionable(state);
  if (state.feature.isValid() === false) {
    this.deleteFeature([state.featureId]);
    this.changeMode(modes$2.SIMPLE_SELECT, {});
  }
};
DirectSelect$1.onMouseMove = function(state, e3) {
  const isFeature2 = isActiveFeature(e3);
  const onVertex = isVertex$1(e3);
  const noCoords = state.selectedCoordPaths.length === 0;
  if (isFeature2 && noCoords)
    this.updateUIClasses({ mouse: cursors.MOVE });
  else if (onVertex && !noCoords)
    this.updateUIClasses({ mouse: cursors.MOVE });
  else
    this.updateUIClasses({ mouse: cursors.NONE });
  this.stopDragging(state);
};
DirectSelect$1.onMouseOut = function(state) {
  if (state.dragMoving)
    this.fireUpdate();
};
DirectSelect$1.onTouchStart = DirectSelect$1.onMouseDown = function(state, e3) {
  if (isVertex$1(e3))
    return this.onVertex(state, e3);
  if (isActiveFeature(e3))
    return this.onFeature(state, e3);
  if (isMidpoint$1(e3))
    return this.onMidpoint(state, e3);
};
DirectSelect$1.onDrag = function(state, e3) {
  if (state.canDragMove !== true)
    return;
  state.dragMoving = true;
  e3.originalEvent.stopPropagation();
  const delta = {
    lng: e3.lngLat.lng - state.dragMoveLocation.lng,
    lat: e3.lngLat.lat - state.dragMoveLocation.lat
  };
  if (state.selectedCoordPaths.length > 0)
    this.dragVertex(state, e3, delta);
  else
    this.dragFeature(state, e3, delta);
  state.dragMoveLocation = e3.lngLat;
};
DirectSelect$1.onClick = function(state, e3) {
  if (noTarget$1(e3))
    return this.clickNoTarget(state, e3);
  if (isActiveFeature(e3))
    return this.clickActiveFeature(state, e3);
  if (isInactiveFeature$1(e3))
    return this.clickInactive(state, e3);
  this.stopDragging(state);
};
DirectSelect$1.onTap = function(state, e3) {
  if (noTarget$1(e3))
    return this.clickNoTarget(state, e3);
  if (isActiveFeature(e3))
    return this.clickActiveFeature(state, e3);
  if (isInactiveFeature$1(e3))
    return this.clickInactive(state, e3);
};
DirectSelect$1.onTouchEnd = DirectSelect$1.onMouseUp = function(state) {
  if (state.dragMoving) {
    this.fireUpdate();
  }
  this.stopDragging(state);
};
const DrawPoint$1 = {};
DrawPoint$1.onSetup = function() {
  const point4 = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.POINT,
      coordinates: []
    }
  });
  this.addFeature(point4);
  this.clearSelectedFeatures();
  this.updateUIClasses({ mouse: cursors.ADD });
  this.activateUIButton(types$1.POINT);
  this.setActionableState({
    trash: true
  });
  return { point: point4 };
};
DrawPoint$1.stopDrawingAndRemove = function(state) {
  this.deleteFeature([state.point.id], { silent: true });
  this.changeMode(modes$2.SIMPLE_SELECT);
};
DrawPoint$1.onTap = DrawPoint$1.onClick = function(state, e3) {
  this.updateUIClasses({ mouse: cursors.MOVE });
  state.point.updateCoordinate("", e3.lngLat.lng, e3.lngLat.lat);
  this.map.fire(events$6.CREATE, {
    features: [state.point.toGeoJSON()]
  });
  this.changeMode(modes$2.SIMPLE_SELECT, { featureIds: [state.point.id] });
};
DrawPoint$1.onStop = function(state) {
  this.activateUIButton();
  if (!state.point.getCoordinate().length) {
    this.deleteFeature([state.point.id], { silent: true });
  }
};
DrawPoint$1.toDisplayFeatures = function(state, geojson, display) {
  const isActivePoint = geojson.properties.id === state.point.id;
  geojson.properties.active = isActivePoint ? activeStates.ACTIVE : activeStates.INACTIVE;
  if (!isActivePoint)
    return display(geojson);
};
DrawPoint$1.onTrash = DrawPoint$1.stopDrawingAndRemove;
DrawPoint$1.onKeyUp = function(state, e3) {
  if (isEscapeKey(e3) || isEnterKey(e3)) {
    return this.stopDrawingAndRemove(state, e3);
  }
};
function isEventAtCoordinates$3(event, coordinates2) {
  if (!event.lngLat)
    return false;
  return event.lngLat.lng === coordinates2[0] && event.lngLat.lat === coordinates2[1];
}
const DrawPolygon$1 = {};
DrawPolygon$1.onSetup = function() {
  const polygon4 = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.POLYGON,
      coordinates: [[]]
    }
  });
  this.addFeature(polygon4);
  this.clearSelectedFeatures();
  doubleClickZoom$8.disable(this);
  this.updateUIClasses({ mouse: cursors.ADD });
  this.activateUIButton(types$1.POLYGON);
  this.setActionableState({
    trash: true
  });
  return {
    polygon: polygon4,
    currentVertexPosition: 0
  };
};
DrawPolygon$1.clickAnywhere = function(state, e3) {
  if (state.currentVertexPosition > 0 && isEventAtCoordinates$3(e3, state.polygon.coordinates[0][state.currentVertexPosition - 1])) {
    return this.changeMode(modes$2.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
  }
  this.updateUIClasses({ mouse: cursors.ADD });
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e3.lngLat.lng, e3.lngLat.lat);
  state.currentVertexPosition++;
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e3.lngLat.lng, e3.lngLat.lat);
};
DrawPolygon$1.clickOnVertex = function(state) {
  return this.changeMode(modes$2.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
};
DrawPolygon$1.onMouseMove = function(state, e3) {
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e3.lngLat.lng, e3.lngLat.lat);
  if (isVertex$2(e3)) {
    this.updateUIClasses({ mouse: cursors.POINTER });
  }
};
DrawPolygon$1.onTap = DrawPolygon$1.onClick = function(state, e3) {
  if (isVertex$2(e3))
    return this.clickOnVertex(state, e3);
  return this.clickAnywhere(state, e3);
};
DrawPolygon$1.onKeyUp = function(state, e3) {
  if (isEscapeKey(e3)) {
    this.deleteFeature([state.polygon.id], { silent: true });
    this.changeMode(modes$2.SIMPLE_SELECT);
  } else if (isEnterKey(e3)) {
    this.changeMode(modes$2.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
  }
};
DrawPolygon$1.onStop = function(state) {
  this.updateUIClasses({ mouse: cursors.NONE });
  doubleClickZoom$8.enable(this);
  this.activateUIButton();
  if (this.getFeature(state.polygon.id) === void 0)
    return;
  state.polygon.removeCoordinate(`0.${state.currentVertexPosition}`);
  if (state.polygon.isValid()) {
    this.map.fire(events$6.CREATE, {
      features: [state.polygon.toGeoJSON()]
    });
  } else {
    this.deleteFeature([state.polygon.id], { silent: true });
    this.changeMode(modes$2.SIMPLE_SELECT, {}, { silent: true });
  }
};
DrawPolygon$1.toDisplayFeatures = function(state, geojson, display) {
  const isActivePolygon = geojson.properties.id === state.polygon.id;
  geojson.properties.active = isActivePolygon ? activeStates.ACTIVE : activeStates.INACTIVE;
  if (!isActivePolygon)
    return display(geojson);
  if (geojson.geometry.coordinates.length === 0)
    return;
  const coordinateCount = geojson.geometry.coordinates[0].length;
  if (coordinateCount < 3) {
    return;
  }
  geojson.properties.meta = meta.FEATURE;
  display(createVertex$5(state.polygon.id, geojson.geometry.coordinates[0][0], "0.0", false));
  if (coordinateCount > 3) {
    const endPos2 = geojson.geometry.coordinates[0].length - 3;
    display(createVertex$5(state.polygon.id, geojson.geometry.coordinates[0][endPos2], `0.${endPos2}`, false));
  }
  if (coordinateCount <= 4) {
    const lineCoordinates = [
      [geojson.geometry.coordinates[0][0][0], geojson.geometry.coordinates[0][0][1]],
      [geojson.geometry.coordinates[0][1][0], geojson.geometry.coordinates[0][1][1]]
    ];
    display({
      type: geojsonTypes.FEATURE,
      properties: geojson.properties,
      geometry: {
        coordinates: lineCoordinates,
        type: geojsonTypes.LINE_STRING
      }
    });
    if (coordinateCount === 3) {
      return;
    }
  }
  return display(geojson);
};
DrawPolygon$1.onTrash = function(state) {
  this.deleteFeature([state.polygon.id], { silent: true });
  this.changeMode(modes$2.SIMPLE_SELECT);
};
const DrawLineString$1 = {};
DrawLineString$1.onSetup = function(opts) {
  opts = opts || {};
  const featureId = opts.featureId;
  let line, currentVertexPosition;
  let direction = "forward";
  if (featureId) {
    line = this.getFeature(featureId);
    if (!line) {
      throw new Error("Could not find a feature with the provided featureId");
    }
    let from = opts.from;
    if (from && from.type === "Feature" && from.geometry && from.geometry.type === "Point") {
      from = from.geometry;
    }
    if (from && from.type === "Point" && from.coordinates && from.coordinates.length === 2) {
      from = from.coordinates;
    }
    if (!from || !Array.isArray(from)) {
      throw new Error("Please use the `from` property to indicate which point to continue the line from");
    }
    const lastCoord = line.coordinates.length - 1;
    if (line.coordinates[lastCoord][0] === from[0] && line.coordinates[lastCoord][1] === from[1]) {
      currentVertexPosition = lastCoord + 1;
      line.addCoordinate(currentVertexPosition, ...line.coordinates[lastCoord]);
    } else if (line.coordinates[0][0] === from[0] && line.coordinates[0][1] === from[1]) {
      direction = "backwards";
      currentVertexPosition = 0;
      line.addCoordinate(currentVertexPosition, ...line.coordinates[0]);
    } else {
      throw new Error("`from` should match the point at either the start or the end of the provided LineString");
    }
  } else {
    line = this.newFeature({
      type: geojsonTypes.FEATURE,
      properties: {},
      geometry: {
        type: geojsonTypes.LINE_STRING,
        coordinates: []
      }
    });
    currentVertexPosition = 0;
    this.addFeature(line);
  }
  this.clearSelectedFeatures();
  doubleClickZoom$8.disable(this);
  this.updateUIClasses({ mouse: cursors.ADD });
  this.activateUIButton(types$1.LINE);
  this.setActionableState({
    trash: true
  });
  return {
    line,
    currentVertexPosition,
    direction
  };
};
DrawLineString$1.clickAnywhere = function(state, e3) {
  if (state.currentVertexPosition > 0 && isEventAtCoordinates$3(e3, state.line.coordinates[state.currentVertexPosition - 1]) || state.direction === "backwards" && isEventAtCoordinates$3(e3, state.line.coordinates[state.currentVertexPosition + 1])) {
    return this.changeMode(modes$2.SIMPLE_SELECT, { featureIds: [state.line.id] });
  }
  this.updateUIClasses({ mouse: cursors.ADD });
  state.line.updateCoordinate(state.currentVertexPosition, e3.lngLat.lng, e3.lngLat.lat);
  if (state.direction === "forward") {
    state.currentVertexPosition++;
    state.line.updateCoordinate(state.currentVertexPosition, e3.lngLat.lng, e3.lngLat.lat);
  } else {
    state.line.addCoordinate(0, e3.lngLat.lng, e3.lngLat.lat);
  }
};
DrawLineString$1.clickOnVertex = function(state) {
  return this.changeMode(modes$2.SIMPLE_SELECT, { featureIds: [state.line.id] });
};
DrawLineString$1.onMouseMove = function(state, e3) {
  state.line.updateCoordinate(state.currentVertexPosition, e3.lngLat.lng, e3.lngLat.lat);
  if (isVertex$2(e3)) {
    this.updateUIClasses({ mouse: cursors.POINTER });
  }
};
DrawLineString$1.onTap = DrawLineString$1.onClick = function(state, e3) {
  if (isVertex$2(e3))
    return this.clickOnVertex(state, e3);
  this.clickAnywhere(state, e3);
};
DrawLineString$1.onKeyUp = function(state, e3) {
  if (isEnterKey(e3)) {
    this.changeMode(modes$2.SIMPLE_SELECT, { featureIds: [state.line.id] });
  } else if (isEscapeKey(e3)) {
    this.deleteFeature([state.line.id], { silent: true });
    this.changeMode(modes$2.SIMPLE_SELECT);
  }
};
DrawLineString$1.onStop = function(state) {
  doubleClickZoom$8.enable(this);
  this.activateUIButton();
  if (this.getFeature(state.line.id) === void 0)
    return;
  state.line.removeCoordinate(`${state.currentVertexPosition}`);
  if (state.line.isValid()) {
    this.map.fire(events$6.CREATE, {
      features: [state.line.toGeoJSON()]
    });
  } else {
    this.deleteFeature([state.line.id], { silent: true });
    this.changeMode(modes$2.SIMPLE_SELECT, {}, { silent: true });
  }
};
DrawLineString$1.onTrash = function(state) {
  this.deleteFeature([state.line.id], { silent: true });
  this.changeMode(modes$2.SIMPLE_SELECT);
};
DrawLineString$1.toDisplayFeatures = function(state, geojson, display) {
  const isActiveLine = geojson.properties.id === state.line.id;
  geojson.properties.active = isActiveLine ? activeStates.ACTIVE : activeStates.INACTIVE;
  if (!isActiveLine)
    return display(geojson);
  if (geojson.geometry.coordinates.length < 2)
    return;
  geojson.properties.meta = meta.FEATURE;
  display(createVertex$5(
    state.line.id,
    geojson.geometry.coordinates[state.direction === "forward" ? geojson.geometry.coordinates.length - 2 : 1],
    `${state.direction === "forward" ? geojson.geometry.coordinates.length - 2 : 1}`,
    false
  ));
  display(geojson);
};
const modes$1 = {
  simple_select: SimpleSelect$1,
  direct_select: DirectSelect$1,
  draw_point: DrawPoint$1,
  draw_polygon: DrawPolygon$1,
  draw_line_string: DrawLineString$1
};
const defaultOptions$1 = {
  defaultMode: modes$2.SIMPLE_SELECT,
  keybindings: true,
  touchEnabled: true,
  clickBuffer: 2,
  touchBuffer: 25,
  boxSelect: true,
  displayControlsDefault: true,
  styles: theme$1,
  modes: modes$1,
  controls: {},
  userProperties: false
};
const showControls$1 = {
  point: true,
  line_string: true,
  polygon: true,
  trash: true,
  combine_features: true,
  uncombine_features: true
};
const hideControls$1 = {
  point: false,
  line_string: false,
  polygon: false,
  trash: false,
  combine_features: false,
  uncombine_features: false
};
function addSources$1(styles2, sourceBucket) {
  return styles2.map((style2) => {
    if (style2.source)
      return style2;
    return immutable(style2, {
      id: `${style2.id}.${sourceBucket}`,
      source: sourceBucket === "hot" ? sources.HOT : sources.COLD
    });
  });
}
function setupOptions$1(options2 = {}) {
  let withDefaults = immutable(options2);
  if (!options2.controls) {
    withDefaults.controls = {};
  }
  if (options2.displayControlsDefault === false) {
    withDefaults.controls = immutable(hideControls$1, options2.controls);
  } else {
    withDefaults.controls = immutable(showControls$1, options2.controls);
  }
  withDefaults = immutable(defaultOptions$1, withDefaults);
  withDefaults.styles = addSources$1(withDefaults.styles, "cold").concat(addSources$1(withDefaults.styles, "hot"));
  return withDefaults;
}
var lodash_isequalExports = {};
var lodash_isequal = {
  get exports() {
    return lodash_isequalExports;
  },
  set exports(v5) {
    lodash_isequalExports = v5;
  }
};
(function(module2, exports2) {
  var LARGE_ARRAY_SIZE2 = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
  var MAX_SAFE_INTEGER2 = 9007199254740991;
  var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]";
  var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint2 = /^(?:0|[1-9]\d*)$/;
  var typedArrayTags2 = {};
  typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
  typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
  var freeGlobal2 = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports2 = exports2 && !exports2.nodeType && exports2;
  var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess2 = moduleExports2 && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
    } catch (e3) {
    }
  }();
  var nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
  function arrayFilter2(array2, predicate) {
    var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
    while (++index2 < length2) {
      var value = array2[index2];
      if (predicate(value, index2, array2)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }
  function arrayPush2(array2, values4) {
    var index2 = -1, length2 = values4.length, offset = array2.length;
    while (++index2 < length2) {
      array2[offset + index2] = values4[index2];
    }
    return array2;
  }
  function arraySome2(array2, predicate) {
    var index2 = -1, length2 = array2 == null ? 0 : array2.length;
    while (++index2 < length2) {
      if (predicate(array2[index2], index2, array2)) {
        return true;
      }
    }
    return false;
  }
  function baseTimes2(n2, iteratee) {
    var index2 = -1, result = Array(n2);
    while (++index2 < n2) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function baseUnary2(func2) {
    return function(value) {
      return func2(value);
    };
  }
  function cacheHas2(cache2, key) {
    return cache2.has(key);
  }
  function getValue2(object2, key) {
    return object2 == null ? void 0 : object2[key];
  }
  function mapToArray2(map5) {
    var index2 = -1, result = Array(map5.size);
    map5.forEach(function(value, key) {
      result[++index2] = [key, value];
    });
    return result;
  }
  function overArg2(func2, transform4) {
    return function(arg) {
      return func2(transform4(arg));
    };
  }
  function setToArray2(set) {
    var index2 = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index2] = value;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var maskSrcKey2 = function() {
    var uid2 = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid2 ? "Symbol(src)_1." + uid2 : "";
  }();
  var nativeObjectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp(
    "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  var Buffer2 = moduleExports2 ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : void 0;
  var nativeGetSymbols2 = Object.getOwnPropertySymbols, nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys2 = overArg2(Object.keys, Object);
  var DataView2 = getNative2(root2, "DataView"), Map3 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set2 = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map3), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : void 0;
  function Hash2(entries) {
    var index2 = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
    this.size = 0;
  }
  function hashDelete2(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }
  function hashGet2(key) {
    var data2 = this.__data__;
    if (nativeCreate2) {
      var result = data2[key];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data2, key) ? data2[key] : void 0;
  }
  function hashHas2(key) {
    var data2 = this.__data__;
    return nativeCreate2 ? data2[key] !== void 0 : hasOwnProperty2.call(data2, key);
  }
  function hashSet2(key, value) {
    var data2 = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data2[key] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index2 = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
    this.size = 0;
  }
  function listCacheDelete2(key) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data2.length - 1;
    if (index2 == lastIndex) {
      data2.pop();
    } else {
      splice2.call(data2, index2, 1);
    }
    --this.size;
    return true;
  }
  function listCacheGet2(key) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    return index2 < 0 ? void 0 : data2[index2][1];
  }
  function listCacheHas2(key) {
    return assocIndexOf2(this.__data__, key) > -1;
  }
  function listCacheSet2(key, value) {
    var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
    if (index2 < 0) {
      ++this.size;
      data2.push([key, value]);
    } else {
      data2[index2][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index2 = -1, length2 = entries == null ? 0 : entries.length;
    this.clear();
    while (++index2 < length2) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.size = 0;
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map3 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key) {
    var result = getMapData2(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
  }
  function mapCacheGet2(key) {
    return getMapData2(this, key).get(key);
  }
  function mapCacheHas2(key) {
    return getMapData2(this, key).has(key);
  }
  function mapCacheSet2(key, value) {
    var data2 = getMapData2(this, key), size12 = data2.size;
    data2.set(key, value);
    this.size += data2.size == size12 ? 0 : 1;
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function SetCache2(values4) {
    var index2 = -1, length2 = values4 == null ? 0 : values4.length;
    this.__data__ = new MapCache2();
    while (++index2 < length2) {
      this.add(values4[index2]);
    }
  }
  function setCacheAdd2(value) {
    this.__data__.set(value, HASH_UNDEFINED2);
    return this;
  }
  function setCacheHas2(value) {
    return this.__data__.has(value);
  }
  SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
  SetCache2.prototype.has = setCacheHas2;
  function Stack2(entries) {
    var data2 = this.__data__ = new ListCache2(entries);
    this.size = data2.size;
  }
  function stackClear2() {
    this.__data__ = new ListCache2();
    this.size = 0;
  }
  function stackDelete2(key) {
    var data2 = this.__data__, result = data2["delete"](key);
    this.size = data2.size;
    return result;
  }
  function stackGet2(key) {
    return this.__data__.get(key);
  }
  function stackHas2(key) {
    return this.__data__.has(key);
  }
  function stackSet2(key, value) {
    var data2 = this.__data__;
    if (data2 instanceof ListCache2) {
      var pairs2 = data2.__data__;
      if (!Map3 || pairs2.length < LARGE_ARRAY_SIZE2 - 1) {
        pairs2.push([key, value]);
        this.size = ++data2.size;
        return this;
      }
      data2 = this.__data__ = new MapCache2(pairs2);
    }
    data2.set(key, value);
    this.size = data2.size;
    return this;
  }
  Stack2.prototype.clear = stackClear2;
  Stack2.prototype["delete"] = stackDelete2;
  Stack2.prototype.get = stackGet2;
  Stack2.prototype.has = stackHas2;
  Stack2.prototype.set = stackSet2;
  function arrayLikeKeys2(value, inherited) {
    var isArr = isArray3(value), isArg = !isArr && isArguments5(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes2(value.length, String) : [], length2 = result.length;
    for (var key in value) {
      if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
      (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
      isIndex2(key, length2)))) {
        result.push(key);
      }
    }
    return result;
  }
  function assocIndexOf2(array2, key) {
    var length2 = array2.length;
    while (length2--) {
      if (eq2(array2[length2][0], key)) {
        return length2;
      }
    }
    return -1;
  }
  function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
    var result = keysFunc(object2);
    return isArray3(object2) ? result : arrayPush2(result, symbolsFunc(object2));
  }
  function baseGetTag2(value) {
    if (value == null) {
      return value === void 0 ? undefinedTag2 : nullTag2;
    }
    return symToStringTag2 && symToStringTag2 in Object(value) ? getRawTag2(value) : objectToString2(value);
  }
  function baseIsArguments2(value) {
    return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
  }
  function baseIsEqual2(value, other, bitmask, customizer, stack2) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep2(value, other, bitmask, customizer, baseIsEqual2, stack2);
  }
  function baseIsEqualDeep2(object2, other, bitmask, customizer, equalFunc, stack2) {
    var objIsArr = isArray3(object2), othIsArr = isArray3(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
    objTag = objTag == argsTag2 ? objectTag2 : objTag;
    othTag = othTag == argsTag2 ? objectTag2 : othTag;
    var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer2(object2)) {
      if (!isBuffer2(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack2 || (stack2 = new Stack2());
      return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer, equalFunc, stack2) : equalByTag2(object2, other, objTag, bitmask, customizer, equalFunc, stack2);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
      var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
        stack2 || (stack2 = new Stack2());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack2 || (stack2 = new Stack2());
    return equalObjects2(object2, other, bitmask, customizer, equalFunc, stack2);
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseIsTypedArray2(value) {
    return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
  }
  function baseKeys2(object2) {
    if (!isPrototype2(object2)) {
      return nativeKeys2(object2);
    }
    var result = [];
    for (var key in Object(object2)) {
      if (hasOwnProperty2.call(object2, key) && key != "constructor") {
        result.push(key);
      }
    }
    return result;
  }
  function equalArrays2(array2, other, bitmask, customizer, equalFunc, stack2) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array2.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    var stacked = stack2.get(array2);
    if (stacked && stack2.get(other)) {
      return stacked == other;
    }
    var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : void 0;
    stack2.set(array2, other);
    stack2.set(other, array2);
    while (++index2 < arrLength) {
      var arrValue = array2[index2], othValue = other[index2];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack2) : customizer(arrValue, othValue, index2, array2, other, stack2);
      }
      if (compared !== void 0) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      if (seen) {
        if (!arraySome2(other, function(othValue2, othIndex) {
          if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
        result = false;
        break;
      }
    }
    stack2["delete"](array2);
    stack2["delete"](other);
    return result;
  }
  function equalByTag2(object2, other, tag2, bitmask, customizer, equalFunc, stack2) {
    switch (tag2) {
      case dataViewTag2:
        if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
          return false;
        }
        object2 = object2.buffer;
        other = other.buffer;
      case arrayBufferTag2:
        if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
          return false;
        }
        return true;
      case boolTag2:
      case dateTag2:
      case numberTag2:
        return eq2(+object2, +other);
      case errorTag2:
        return object2.name == other.name && object2.message == other.message;
      case regexpTag2:
      case stringTag2:
        return object2 == other + "";
      case mapTag2:
        var convert = mapToArray2;
      case setTag2:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
        convert || (convert = setToArray2);
        if (object2.size != other.size && !isPartial) {
          return false;
        }
        var stacked = stack2.get(object2);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG2;
        stack2.set(object2, other);
        var result = equalArrays2(convert(object2), convert(other), bitmask, customizer, equalFunc, stack2);
        stack2["delete"](object2);
        return result;
      case symbolTag2:
        if (symbolValueOf2) {
          return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
        }
    }
    return false;
  }
  function equalObjects2(object2, other, bitmask, customizer, equalFunc, stack2) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index2 = objLength;
    while (index2--) {
      var key = objProps[index2];
      if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
        return false;
      }
    }
    var stacked = stack2.get(object2);
    if (stacked && stack2.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack2.set(object2, other);
    stack2.set(other, object2);
    var skipCtor = isPartial;
    while (++index2 < objLength) {
      key = objProps[index2];
      var objValue = object2[key], othValue = other[key];
      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack2) : customizer(objValue, othValue, key, object2, other, stack2);
      }
      if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
      var objCtor = object2.constructor, othCtor = other.constructor;
      if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack2["delete"](object2);
    stack2["delete"](other);
    return result;
  }
  function getAllKeys2(object2) {
    return baseGetAllKeys2(object2, keys4, getSymbols2);
  }
  function getMapData2(map5, key) {
    var data2 = map5.__data__;
    return isKeyable2(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
  }
  function getNative2(object2, key) {
    var value = getValue2(object2, key);
    return baseIsNative2(value) ? value : void 0;
  }
  function getRawTag2(value) {
    var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag2 = value[symToStringTag2];
    try {
      value[symToStringTag2] = void 0;
      var unmasked = true;
    } catch (e3) {
    }
    var result = nativeObjectToString2.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag2] = tag2;
      } else {
        delete value[symToStringTag2];
      }
    }
    return result;
  }
  var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
    if (object2 == null) {
      return [];
    }
    object2 = Object(object2);
    return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
      return propertyIsEnumerable2.call(object2, symbol);
    });
  };
  var getTag2 = baseGetTag2;
  if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map3 && getTag2(new Map3()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
    getTag2 = function(value) {
      var result = baseGetTag2(value), Ctor = result == objectTag2 ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : "";
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString2:
            return dataViewTag2;
          case mapCtorString2:
            return mapTag2;
          case promiseCtorString2:
            return promiseTag2;
          case setCtorString2:
            return setTag2;
          case weakMapCtorString2:
            return weakMapTag2;
        }
      }
      return result;
    };
  }
  function isIndex2(value, length2) {
    length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
    return !!length2 && (typeof value == "number" || reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func2) {
    return !!maskSrcKey2 && maskSrcKey2 in func2;
  }
  function isPrototype2(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function objectToString2(value) {
    return nativeObjectToString2.call(value);
  }
  function toSource2(func2) {
    if (func2 != null) {
      try {
        return funcToString2.call(func2);
      } catch (e3) {
      }
      try {
        return func2 + "";
      } catch (e3) {
      }
    }
    return "";
  }
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  var isArguments5 = baseIsArguments2(function() {
    return arguments;
  }()) ? baseIsArguments2 : function(value) {
    return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
  };
  var isArray3 = Array.isArray;
  function isArrayLike2(value) {
    return value != null && isLength2(value.length) && !isFunction2(value);
  }
  var isBuffer2 = nativeIsBuffer2 || stubFalse2;
  function isEqual3(value, other) {
    return baseIsEqual2(value, other);
  }
  function isFunction2(value) {
    if (!isObject2(value)) {
      return false;
    }
    var tag2 = baseGetTag2(value);
    return tag2 == funcTag2 || tag2 == genTag2 || tag2 == asyncTag2 || tag2 == proxyTag2;
  }
  function isLength2(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
  }
  function isObject2(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return value != null && typeof value == "object";
  }
  var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
  function keys4(object2) {
    return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
  }
  function stubArray2() {
    return [];
  }
  function stubFalse2() {
    return false;
  }
  module2.exports = isEqual3;
})(lodash_isequal, lodash_isequalExports);
const isEqual$1 = lodash_isequalExports;
function stringSetsAreEqual$1(a2, b2) {
  if (a2.length !== b2.length)
    return false;
  return JSON.stringify(a2.map((id) => id).sort()) === JSON.stringify(b2.map((id) => id).sort());
}
var lib$3 = {};
var jsonlintExports = {};
var jsonlint$2 = {
  get exports() {
    return jsonlintExports;
  },
  set exports(v5) {
    jsonlintExports = v5;
  }
};
(function(module2, exports2) {
  var jsonlint2 = function() {
    var o2 = function(k2, v5, o3, l2) {
      for (o3 = o3 || {}, l2 = k2.length; l2--; o3[k2[l2]] = v5)
        ;
      return o3;
    }, $V0 = [1, 12], $V1 = [1, 13], $V2 = [1, 9], $V3 = [1, 10], $V4 = [1, 11], $V5 = [1, 14], $V6 = [1, 15], $V7 = [14, 18, 22, 24], $V8 = [18, 22], $V9 = [22, 24];
    var parser = {
      trace: function trace() {
      },
      yy: {},
      symbols_: { "error": 2, "JSONString": 3, "STRING": 4, "JSONNumber": 5, "NUMBER": 6, "JSONNullLiteral": 7, "NULL": 8, "JSONBooleanLiteral": 9, "TRUE": 10, "FALSE": 11, "JSONText": 12, "JSONValue": 13, "EOF": 14, "JSONObject": 15, "JSONArray": 16, "{": 17, "}": 18, "JSONMemberList": 19, "JSONMember": 20, ":": 21, ",": 22, "[": 23, "]": 24, "JSONElementList": 25, "$accept": 0, "$end": 1 },
      terminals_: { 2: "error", 4: "STRING", 6: "NUMBER", 8: "NULL", 10: "TRUE", 11: "FALSE", 14: "EOF", 17: "{", 18: "}", 21: ":", 22: ",", 23: "[", 24: "]" },
      productions_: [0, [3, 1], [5, 1], [7, 1], [9, 1], [9, 1], [12, 2], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [13, 1], [15, 2], [15, 3], [20, 3], [19, 1], [19, 3], [16, 2], [16, 3], [25, 1], [25, 3]],
      performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
        var $0 = $$.length - 1;
        switch (yystate) {
          case 1:
            this.$ = yytext.replace(/\\(\\|")/g, "$1").replace(/\\n/g, "\n").replace(/\\r/g, "\r").replace(/\\t/g, "	").replace(/\\v/g, "\v").replace(/\\f/g, "\f").replace(/\\b/g, "\b");
            break;
          case 2:
            this.$ = Number(yytext);
            break;
          case 3:
            this.$ = null;
            break;
          case 4:
            this.$ = true;
            break;
          case 5:
            this.$ = false;
            break;
          case 6:
            return this.$ = $$[$0 - 1];
          case 13:
            this.$ = {};
            Object.defineProperty(this.$, "__line__", {
              value: this._$.first_line,
              enumerable: false
            });
            break;
          case 14:
          case 19:
            this.$ = $$[$0 - 1];
            Object.defineProperty(this.$, "__line__", {
              value: this._$.first_line,
              enumerable: false
            });
            break;
          case 15:
            this.$ = [$$[$0 - 2], $$[$0]];
            break;
          case 16:
            this.$ = {};
            this.$[$$[$0][0]] = $$[$0][1];
            break;
          case 17:
            this.$ = $$[$0 - 2];
            if ($$[$0 - 2][$$[$0][0]] !== void 0) {
              if (!this.$.__duplicateProperties__) {
                Object.defineProperty(this.$, "__duplicateProperties__", {
                  value: [],
                  enumerable: false
                });
              }
              this.$.__duplicateProperties__.push($$[$0][0]);
            }
            $$[$0 - 2][$$[$0][0]] = $$[$0][1];
            break;
          case 18:
            this.$ = [];
            Object.defineProperty(this.$, "__line__", {
              value: this._$.first_line,
              enumerable: false
            });
            break;
          case 20:
            this.$ = [$$[$0]];
            break;
          case 21:
            this.$ = $$[$0 - 2];
            $$[$0 - 2].push($$[$0]);
            break;
        }
      },
      table: [{ 3: 5, 4: $V0, 5: 6, 6: $V1, 7: 3, 8: $V2, 9: 4, 10: $V3, 11: $V4, 12: 1, 13: 2, 15: 7, 16: 8, 17: $V5, 23: $V6 }, { 1: [3] }, { 14: [1, 16] }, o2($V7, [2, 7]), o2($V7, [2, 8]), o2($V7, [2, 9]), o2($V7, [2, 10]), o2($V7, [2, 11]), o2($V7, [2, 12]), o2($V7, [2, 3]), o2($V7, [2, 4]), o2($V7, [2, 5]), o2([14, 18, 21, 22, 24], [2, 1]), o2($V7, [2, 2]), { 3: 20, 4: $V0, 18: [1, 17], 19: 18, 20: 19 }, { 3: 5, 4: $V0, 5: 6, 6: $V1, 7: 3, 8: $V2, 9: 4, 10: $V3, 11: $V4, 13: 23, 15: 7, 16: 8, 17: $V5, 23: $V6, 24: [1, 21], 25: 22 }, { 1: [2, 6] }, o2($V7, [2, 13]), { 18: [1, 24], 22: [1, 25] }, o2($V8, [2, 16]), { 21: [1, 26] }, o2($V7, [2, 18]), { 22: [1, 28], 24: [1, 27] }, o2($V9, [2, 20]), o2($V7, [2, 14]), { 3: 20, 4: $V0, 20: 29 }, { 3: 5, 4: $V0, 5: 6, 6: $V1, 7: 3, 8: $V2, 9: 4, 10: $V3, 11: $V4, 13: 30, 15: 7, 16: 8, 17: $V5, 23: $V6 }, o2($V7, [2, 19]), { 3: 5, 4: $V0, 5: 6, 6: $V1, 7: 3, 8: $V2, 9: 4, 10: $V3, 11: $V4, 13: 31, 15: 7, 16: 8, 17: $V5, 23: $V6 }, o2($V8, [2, 17]), o2($V8, [2, 15]), o2($V9, [2, 21])],
      defaultActions: { 16: [2, 6] },
      parseError: function parseError(str, hash) {
        if (hash.recoverable) {
          this.trace(str);
        } else {
          let _parseError = function(msg2, hash2) {
            this.message = msg2;
            this.hash = hash2;
          };
          _parseError.prototype = Error;
          throw new _parseError(str, hash);
        }
      },
      parse: function parse3(input) {
        var self2 = this, stack2 = [0], vstack = [null], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, TERROR = 2, EOF = 1;
        var args = lstack.slice.call(arguments, 1);
        var lexer2 = Object.create(this.lexer);
        var sharedState = { yy: {} };
        for (var k2 in this.yy) {
          if (Object.prototype.hasOwnProperty.call(this.yy, k2)) {
            sharedState.yy[k2] = this.yy[k2];
          }
        }
        lexer2.setInput(input, sharedState.yy);
        sharedState.yy.lexer = lexer2;
        sharedState.yy.parser = this;
        if (typeof lexer2.yylloc == "undefined") {
          lexer2.yylloc = {};
        }
        var yyloc = lexer2.yylloc;
        lstack.push(yyloc);
        var ranges = lexer2.options && lexer2.options.ranges;
        if (typeof sharedState.yy.parseError === "function") {
          this.parseError = sharedState.yy.parseError;
        } else {
          this.parseError = Object.getPrototypeOf(this).parseError;
        }
        var lex = function() {
          var token;
          token = lexer2.lex() || EOF;
          if (typeof token !== "number") {
            token = self2.symbols_[token] || token;
          }
          return token;
        };
        var symbol, state, action, r2, yyval = {}, p2, len2, newState, expected;
        while (true) {
          state = stack2[stack2.length - 1];
          if (this.defaultActions[state]) {
            action = this.defaultActions[state];
          } else {
            if (symbol === null || typeof symbol == "undefined") {
              symbol = lex();
            }
            action = table[state] && table[state][symbol];
          }
          if (typeof action === "undefined" || !action.length || !action[0]) {
            var errStr = "";
            expected = [];
            for (p2 in table[state]) {
              if (this.terminals_[p2] && p2 > TERROR) {
                expected.push("'" + this.terminals_[p2] + "'");
              }
            }
            if (lexer2.showPosition) {
              errStr = "Parse error on line " + (yylineno + 1) + ":\n" + lexer2.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
            } else {
              errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == EOF ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
            }
            this.parseError(errStr, {
              text: lexer2.match,
              token: this.terminals_[symbol] || symbol,
              line: lexer2.yylineno,
              loc: yyloc,
              expected
            });
          }
          if (action[0] instanceof Array && action.length > 1) {
            throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
          }
          switch (action[0]) {
            case 1:
              stack2.push(symbol);
              vstack.push(lexer2.yytext);
              lstack.push(lexer2.yylloc);
              stack2.push(action[1]);
              symbol = null;
              {
                yyleng = lexer2.yyleng;
                yytext = lexer2.yytext;
                yylineno = lexer2.yylineno;
                yyloc = lexer2.yylloc;
              }
              break;
            case 2:
              len2 = this.productions_[action[1]][1];
              yyval.$ = vstack[vstack.length - len2];
              yyval._$ = {
                first_line: lstack[lstack.length - (len2 || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len2 || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
              };
              if (ranges) {
                yyval._$.range = [
                  lstack[lstack.length - (len2 || 1)].range[0],
                  lstack[lstack.length - 1].range[1]
                ];
              }
              r2 = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
              ].concat(args));
              if (typeof r2 !== "undefined") {
                return r2;
              }
              if (len2) {
                stack2 = stack2.slice(0, -1 * len2 * 2);
                vstack = vstack.slice(0, -1 * len2);
                lstack = lstack.slice(0, -1 * len2);
              }
              stack2.push(this.productions_[action[1]][0]);
              vstack.push(yyval.$);
              lstack.push(yyval._$);
              newState = table[stack2[stack2.length - 2]][stack2[stack2.length - 1]];
              stack2.push(newState);
              break;
            case 3:
              return true;
          }
        }
        return true;
      }
    };
    var lexer = function() {
      var lexer2 = {
        EOF: 1,
        parseError: function parseError(str, hash) {
          if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
          } else {
            throw new Error(str);
          }
        },
        // resets the lexer, sets new input
        setInput: function(input, yy) {
          this.yy = yy || this.yy || {};
          this._input = input;
          this._more = this._backtrack = this.done = false;
          this.yylineno = this.yyleng = 0;
          this.yytext = this.matched = this.match = "";
          this.conditionStack = ["INITIAL"];
          this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
          };
          if (this.options.ranges) {
            this.yylloc.range = [0, 0];
          }
          this.offset = 0;
          return this;
        },
        // consumes and returns one char from the input
        input: function() {
          var ch2 = this._input[0];
          this.yytext += ch2;
          this.yyleng++;
          this.offset++;
          this.match += ch2;
          this.matched += ch2;
          var lines = ch2.match(/(?:\r\n?|\n).*/g);
          if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
          } else {
            this.yylloc.last_column++;
          }
          if (this.options.ranges) {
            this.yylloc.range[1]++;
          }
          this._input = this._input.slice(1);
          return ch2;
        },
        // unshifts one char (or a string) into the input
        unput: function(ch2) {
          var len2 = ch2.length;
          var lines = ch2.split(/(?:\r\n?|\n)/g);
          this._input = ch2 + this._input;
          this.yytext = this.yytext.substr(0, this.yytext.length - len2);
          this.offset -= len2;
          var oldLines = this.match.split(/(?:\r\n?|\n)/g);
          this.match = this.match.substr(0, this.match.length - 1);
          this.matched = this.matched.substr(0, this.matched.length - 1);
          if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
          }
          var r2 = this.yylloc.range;
          this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len2
          };
          if (this.options.ranges) {
            this.yylloc.range = [r2[0], r2[0] + this.yyleng - len2];
          }
          this.yyleng = this.yytext.length;
          return this;
        },
        // When called from action, caches matched text and appends it on next action
        more: function() {
          this._more = true;
          return this;
        },
        // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
        reject: function() {
          if (this.options.backtrack_lexer) {
            this._backtrack = true;
          } else {
            return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
              text: "",
              token: null,
              line: this.yylineno
            });
          }
          return this;
        },
        // retain first n characters of the match
        less: function(n2) {
          this.unput(this.match.slice(n2));
        },
        // displays already matched input, i.e. for error messages
        pastInput: function() {
          var past = this.matched.substr(0, this.matched.length - this.match.length);
          return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
        },
        // displays upcoming input, i.e. for error messages
        upcomingInput: function() {
          var next5 = this.match;
          if (next5.length < 20) {
            next5 += this._input.substr(0, 20 - next5.length);
          }
          return (next5.substr(0, 20) + (next5.length > 20 ? "..." : "")).replace(/\n/g, "");
        },
        // displays the character position where the lexing error occurred, i.e. for error messages
        showPosition: function() {
          var pre = this.pastInput();
          var c2 = new Array(pre.length + 1).join("-");
          return pre + this.upcomingInput() + "\n" + c2 + "^";
        },
        // test the lexed token: return FALSE when not a match, otherwise return token
        test_match: function(match2, indexed_rule) {
          var token, lines, backup;
          if (this.options.backtrack_lexer) {
            backup = {
              yylineno: this.yylineno,
              yylloc: {
                first_line: this.yylloc.first_line,
                last_line: this.last_line,
                first_column: this.yylloc.first_column,
                last_column: this.yylloc.last_column
              },
              yytext: this.yytext,
              match: this.match,
              matches: this.matches,
              matched: this.matched,
              yyleng: this.yyleng,
              offset: this.offset,
              _more: this._more,
              _input: this._input,
              yy: this.yy,
              conditionStack: this.conditionStack.slice(0),
              done: this.done
            };
            if (this.options.ranges) {
              backup.yylloc.range = this.yylloc.range.slice(0);
            }
          }
          lines = match2[0].match(/(?:\r\n?|\n).*/g);
          if (lines) {
            this.yylineno += lines.length;
          }
          this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match2[0].length
          };
          this.yytext += match2[0];
          this.match += match2[0];
          this.matches = match2;
          this.yyleng = this.yytext.length;
          if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
          }
          this._more = false;
          this._backtrack = false;
          this._input = this._input.slice(match2[0].length);
          this.matched += match2[0];
          token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
          if (this.done && this._input) {
            this.done = false;
          }
          if (token) {
            return token;
          } else if (this._backtrack) {
            for (var k2 in backup) {
              this[k2] = backup[k2];
            }
            return false;
          }
          return false;
        },
        // return next match in input
        next: function() {
          if (this.done) {
            return this.EOF;
          }
          if (!this._input) {
            this.done = true;
          }
          var token, match2, tempMatch, index2;
          if (!this._more) {
            this.yytext = "";
            this.match = "";
          }
          var rules = this._currentRules();
          for (var i2 = 0; i2 < rules.length; i2++) {
            tempMatch = this._input.match(this.rules[rules[i2]]);
            if (tempMatch && (!match2 || tempMatch[0].length > match2[0].length)) {
              match2 = tempMatch;
              index2 = i2;
              if (this.options.backtrack_lexer) {
                token = this.test_match(tempMatch, rules[i2]);
                if (token !== false) {
                  return token;
                } else if (this._backtrack) {
                  match2 = false;
                  continue;
                } else {
                  return false;
                }
              } else if (!this.options.flex) {
                break;
              }
            }
          }
          if (match2) {
            token = this.test_match(match2, rules[index2]);
            if (token !== false) {
              return token;
            }
            return false;
          }
          if (this._input === "") {
            return this.EOF;
          } else {
            return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
              text: "",
              token: null,
              line: this.yylineno
            });
          }
        },
        // return next match that has a token
        lex: function lex() {
          var r2 = this.next();
          if (r2) {
            return r2;
          } else {
            return this.lex();
          }
        },
        // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
        begin: function begin(condition) {
          this.conditionStack.push(condition);
        },
        // pop the previously active lexer condition state off the condition stack
        popState: function popState() {
          var n2 = this.conditionStack.length - 1;
          if (n2 > 0) {
            return this.conditionStack.pop();
          } else {
            return this.conditionStack[0];
          }
        },
        // produce the lexer rule set which is active for the currently active lexer condition state
        _currentRules: function _currentRules() {
          if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
          } else {
            return this.conditions["INITIAL"].rules;
          }
        },
        // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
        topState: function topState(n2) {
          n2 = this.conditionStack.length - 1 - Math.abs(n2 || 0);
          if (n2 >= 0) {
            return this.conditionStack[n2];
          } else {
            return "INITIAL";
          }
        },
        // alias for begin(condition)
        pushState: function pushState(condition) {
          this.begin(condition);
        },
        // return the number of states currently on the stack
        stateStackSize: function stateStackSize() {
          return this.conditionStack.length;
        },
        options: {},
        performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
          switch ($avoiding_name_collisions) {
            case 0:
              break;
            case 1:
              return 6;
            case 2:
              yy_.yytext = yy_.yytext.substr(1, yy_.yyleng - 2);
              return 4;
            case 3:
              return 17;
            case 4:
              return 18;
            case 5:
              return 23;
            case 6:
              return 24;
            case 7:
              return 22;
            case 8:
              return 21;
            case 9:
              return 10;
            case 10:
              return 11;
            case 11:
              return 8;
            case 12:
              return 14;
            case 13:
              return "INVALID";
          }
        },
        rules: [/^(?:\s+)/, /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/, /^(?:"(?:\\[\\"bfnrt\/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/, /^(?:\{)/, /^(?:\})/, /^(?:\[)/, /^(?:\])/, /^(?:,)/, /^(?::)/, /^(?:true\b)/, /^(?:false\b)/, /^(?:null\b)/, /^(?:$)/, /^(?:.)/],
        conditions: { "INITIAL": { "rules": [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], "inclusive": true } }
      };
      return lexer2;
    }();
    parser.lexer = lexer;
    function Parser3() {
      this.yy = {};
    }
    Parser3.prototype = parser;
    parser.Parser = Parser3;
    return new Parser3();
  }();
  if (typeof commonjsRequire !== "undefined" && true) {
    exports2.parser = jsonlint2;
    exports2.Parser = jsonlint2.Parser;
    exports2.parse = function() {
      return jsonlint2.parse.apply(jsonlint2, arguments);
    };
    exports2.main = function commonjsMain(args) {
      if (!args[1]) {
        console.log("Usage: " + args[0] + " FILE");
        process.exit(1);
      }
      var source = require$$1$2.readFileSync(require$$1$2.normalize(args[1]), "utf8");
      return exports2.parser.parse(source);
    };
    if (typeof require !== 'undefined' && require.main === module2) {
      exports2.main(process.argv.slice(1));
    }
  }
})(jsonlint$2, jsonlintExports);
var object$1 = {};
function rad$1(x2) {
  return x2 * Math.PI / 180;
}
function isRingClockwise$1(coords) {
  var area5 = 0;
  if (coords.length > 2) {
    var p1, p2;
    for (var i2 = 0; i2 < coords.length - 1; i2++) {
      p1 = coords[i2];
      p2 = coords[i2 + 1];
      area5 += rad$1(p2[0] - p1[0]) * (2 + Math.sin(rad$1(p1[1])) + Math.sin(rad$1(p2[1])));
    }
  }
  return area5 >= 0;
}
function isPolyRHR$1(coords) {
  if (coords && coords.length > 0) {
    if (isRingClockwise$1(coords[0]))
      return false;
    var interiorCoords = coords.slice(1, coords.length);
    if (!interiorCoords.every(isRingClockwise$1))
      return false;
  }
  return true;
}
function rightHandRule$3(geometry2) {
  if (geometry2.type === "Polygon") {
    return isPolyRHR$1(geometry2.coordinates);
  } else if (geometry2.type === "MultiPolygon") {
    return geometry2.coordinates.every(isPolyRHR$1);
  }
}
var rhr$1 = function validateRightHandRule(geometry2, errors) {
  if (!rightHandRule$3(geometry2)) {
    errors.push({
      message: "Polygons and MultiPolygons should follow the right-hand rule",
      level: "message",
      line: geometry2.__line__
    });
  }
};
var rightHandRule$2 = rhr$1;
function hint$3(gj, options2) {
  var errors = [];
  var precisionWarningCount = 0;
  var maxPrecisionWarnings = 10;
  var maxPrecision = 6;
  function root2(_2) {
    if ((!options2 || options2.noDuplicateMembers !== false) && _2.__duplicateProperties__) {
      errors.push({
        message: "An object contained duplicate members, making parsing ambigous: " + _2.__duplicateProperties__.join(", "),
        line: _2.__line__
      });
    }
    if (requiredProperty(_2, "type", "string")) {
      return;
    }
    if (!types2[_2.type]) {
      var expectedType = typesLower[_2.type.toLowerCase()];
      if (expectedType !== void 0) {
        errors.push({
          message: "Expected " + expectedType + " but got " + _2.type + " (case sensitive)",
          line: _2.__line__
        });
      } else {
        errors.push({
          message: "The type " + _2.type + " is unknown",
          line: _2.__line__
        });
      }
    } else if (_2) {
      types2[_2.type](_2);
    }
  }
  function everyIs(_2, type) {
    return _2.every(function(x2) {
      return x2 !== null && typeof x2 === type;
    });
  }
  function requiredProperty(_2, name2, type) {
    if (typeof _2[name2] === "undefined") {
      return errors.push({
        message: '"' + name2 + '" member required',
        line: _2.__line__
      });
    } else if (type === "array") {
      if (!Array.isArray(_2[name2])) {
        return errors.push({
          message: '"' + name2 + '" member should be an array, but is an ' + typeof _2[name2] + " instead",
          line: _2.__line__
        });
      }
    } else if (type === "object" && _2[name2] && _2[name2].constructor !== Object) {
      return errors.push({
        message: '"' + name2 + '" member should be ' + type + ", but is an " + _2[name2].constructor.name + " instead",
        line: _2.__line__
      });
    } else if (type && typeof _2[name2] !== type) {
      return errors.push({
        message: '"' + name2 + '" member should be ' + type + ", but is an " + typeof _2[name2] + " instead",
        line: _2.__line__
      });
    }
  }
  function FeatureCollection(featureCollection2) {
    crs(featureCollection2);
    bbox2(featureCollection2);
    if (featureCollection2.properties !== void 0) {
      errors.push({
        message: 'FeatureCollection object cannot contain a "properties" member',
        line: featureCollection2.__line__
      });
    }
    if (featureCollection2.coordinates !== void 0) {
      errors.push({
        message: 'FeatureCollection object cannot contain a "coordinates" member',
        line: featureCollection2.__line__
      });
    }
    if (!requiredProperty(featureCollection2, "features", "array")) {
      if (!everyIs(featureCollection2.features, "object")) {
        return errors.push({
          message: "Every feature must be an object",
          line: featureCollection2.__line__
        });
      }
      featureCollection2.features.forEach(Feature2);
    }
  }
  function position(_2, line) {
    if (!Array.isArray(_2)) {
      return errors.push({
        message: "position should be an array, is a " + typeof _2 + " instead",
        line: _2.__line__ || line
      });
    }
    if (_2.length < 2) {
      return errors.push({
        message: "position must have 2 or more elements",
        line: _2.__line__ || line
      });
    }
    if (_2.length > 3) {
      return errors.push({
        message: "position should not have more than 3 elements",
        level: "message",
        line: _2.__line__ || line
      });
    }
    if (!everyIs(_2, "number")) {
      return errors.push({
        message: "each element in a position must be a number",
        line: _2.__line__ || line
      });
    }
    if (options2 && options2.precisionWarning) {
      if (precisionWarningCount === maxPrecisionWarnings) {
        precisionWarningCount += 1;
        return errors.push({
          message: "truncated warnings: we've encountered coordinate precision warning " + maxPrecisionWarnings + " times, no more warnings will be reported",
          level: "message",
          line: _2.__line__ || line
        });
      } else if (precisionWarningCount < maxPrecisionWarnings) {
        _2.forEach(function(num) {
          var precision = 0;
          var decimalStr = String(num).split(".")[1];
          if (decimalStr !== void 0)
            precision = decimalStr.length;
          if (precision > maxPrecision) {
            precisionWarningCount += 1;
            return errors.push({
              message: "precision of coordinates should be reduced",
              level: "message",
              line: _2.__line__ || line
            });
          }
        });
      }
    }
  }
  function positionArray(coords, type, depth2, line) {
    if (line === void 0 && coords.__line__ !== void 0) {
      line = coords.__line__;
    }
    if (depth2 === 0) {
      return position(coords, line);
    }
    if (depth2 === 1 && type) {
      if (type === "LinearRing") {
        if (!Array.isArray(coords[coords.length - 1])) {
          errors.push({
            message: "a number was found where a coordinate array should have been found: this needs to be nested more deeply",
            line
          });
          return true;
        }
        if (coords.length < 4) {
          errors.push({
            message: "a LinearRing of coordinates needs to have four or more positions",
            line
          });
        }
        if (coords.length && (coords[coords.length - 1].length !== coords[0].length || !coords[coords.length - 1].every(function(pos, index2) {
          return coords[0][index2] === pos;
        }))) {
          errors.push({
            message: "the first and last positions in a LinearRing of coordinates must be the same",
            line
          });
          return true;
        }
      } else if (type === "Line" && coords.length < 2) {
        return errors.push({
          message: "a line needs to have two or more coordinates to be valid",
          line
        });
      }
    }
    if (!Array.isArray(coords)) {
      errors.push({
        message: "a number was found where a coordinate array should have been found: this needs to be nested more deeply",
        line
      });
    } else {
      var results = coords.map(function(c2) {
        return positionArray(c2, type, depth2 - 1, c2.__line__ || line);
      });
      return results.some(function(r2) {
        return r2;
      });
    }
  }
  function crs(_2) {
    if (!_2.crs)
      return;
    var defaultCRSName = "urn:ogc:def:crs:OGC:1.3:CRS84";
    if (typeof _2.crs === "object" && _2.crs.properties && _2.crs.properties.name === defaultCRSName) {
      errors.push({
        message: "old-style crs member is not recommended, this object is equivalent to the default and should be removed",
        line: _2.__line__
      });
    } else {
      errors.push({
        message: "old-style crs member is not recommended",
        line: _2.__line__
      });
    }
  }
  function bbox2(_2) {
    if (!_2.bbox) {
      return;
    }
    if (Array.isArray(_2.bbox)) {
      if (!everyIs(_2.bbox, "number")) {
        errors.push({
          message: "each element in a bbox member must be a number",
          line: _2.bbox.__line__
        });
      }
      if (!(_2.bbox.length === 4 || _2.bbox.length === 6)) {
        errors.push({
          message: "bbox must contain 4 elements (for 2D) or 6 elements (for 3D)",
          line: _2.bbox.__line__
        });
      }
      return errors.length;
    }
    errors.push({
      message: "bbox member must be an array of numbers, but is a " + typeof _2.bbox,
      line: _2.__line__
    });
  }
  function geometrySemantics(geom) {
    if (geom.properties !== void 0) {
      errors.push({
        message: 'geometry object cannot contain a "properties" member',
        line: geom.__line__
      });
    }
    if (geom.geometry !== void 0) {
      errors.push({
        message: 'geometry object cannot contain a "geometry" member',
        line: geom.__line__
      });
    }
    if (geom.features !== void 0) {
      errors.push({
        message: 'geometry object cannot contain a "features" member',
        line: geom.__line__
      });
    }
  }
  function Point2(point4) {
    crs(point4);
    bbox2(point4);
    geometrySemantics(point4);
    if (!requiredProperty(point4, "coordinates", "array")) {
      position(point4.coordinates);
    }
  }
  function Polygon2(polygon4) {
    crs(polygon4);
    bbox2(polygon4);
    if (!requiredProperty(polygon4, "coordinates", "array")) {
      if (!positionArray(polygon4.coordinates, "LinearRing", 2)) {
        rightHandRule$2(polygon4, errors);
      }
    }
  }
  function MultiPolygon2(multiPolygon2) {
    crs(multiPolygon2);
    bbox2(multiPolygon2);
    if (!requiredProperty(multiPolygon2, "coordinates", "array")) {
      if (!positionArray(multiPolygon2.coordinates, "LinearRing", 3)) {
        rightHandRule$2(multiPolygon2, errors);
      }
    }
  }
  function LineString2(lineString2) {
    crs(lineString2);
    bbox2(lineString2);
    if (!requiredProperty(lineString2, "coordinates", "array")) {
      positionArray(lineString2.coordinates, "Line", 1);
    }
  }
  function MultiLineString2(multiLineString2) {
    crs(multiLineString2);
    bbox2(multiLineString2);
    if (!requiredProperty(multiLineString2, "coordinates", "array")) {
      positionArray(multiLineString2.coordinates, "Line", 2);
    }
  }
  function MultiPoint2(multiPoint2) {
    crs(multiPoint2);
    bbox2(multiPoint2);
    if (!requiredProperty(multiPoint2, "coordinates", "array")) {
      positionArray(multiPoint2.coordinates, "", 1);
    }
  }
  function GeometryCollection2(geometryCollection2) {
    crs(geometryCollection2);
    bbox2(geometryCollection2);
    if (!requiredProperty(geometryCollection2, "geometries", "array")) {
      if (!everyIs(geometryCollection2.geometries, "object")) {
        errors.push({
          message: "The geometries array in a GeometryCollection must contain only geometry objects",
          line: geometryCollection2.__line__
        });
      }
      if (geometryCollection2.geometries.length === 1) {
        errors.push({
          message: "GeometryCollection with a single geometry should be avoided in favor of single part or a single object of multi-part type",
          line: geometryCollection2.geometries.__line__
        });
      }
      geometryCollection2.geometries.forEach(function(geometry2) {
        if (geometry2) {
          if (geometry2.type === "GeometryCollection") {
            errors.push({
              message: "GeometryCollection should avoid nested geometry collections",
              line: geometryCollection2.geometries.__line__
            });
          }
          root2(geometry2);
        }
      });
    }
  }
  function Feature2(feature2) {
    crs(feature2);
    bbox2(feature2);
    if (feature2.id !== void 0 && typeof feature2.id !== "string" && typeof feature2.id !== "number") {
      errors.push({
        message: 'Feature "id" member must have a string or number value',
        line: feature2.__line__
      });
    }
    if (feature2.features !== void 0) {
      errors.push({
        message: 'Feature object cannot contain a "features" member',
        line: feature2.__line__
      });
    }
    if (feature2.coordinates !== void 0) {
      errors.push({
        message: 'Feature object cannot contain a "coordinates" member',
        line: feature2.__line__
      });
    }
    if (feature2.type !== "Feature") {
      errors.push({
        message: "GeoJSON features must have a type=feature member",
        line: feature2.__line__
      });
    }
    requiredProperty(feature2, "properties", "object");
    if (!requiredProperty(feature2, "geometry", "object")) {
      if (feature2.geometry)
        root2(feature2.geometry);
    }
  }
  var types2 = {
    Point: Point2,
    Feature: Feature2,
    MultiPoint: MultiPoint2,
    LineString: LineString2,
    MultiLineString: MultiLineString2,
    FeatureCollection,
    GeometryCollection: GeometryCollection2,
    Polygon: Polygon2,
    MultiPolygon: MultiPolygon2
  };
  var typesLower = Object.keys(types2).reduce(function(prev, curr) {
    prev[curr.toLowerCase()] = curr;
    return prev;
  }, {});
  if (typeof gj !== "object" || gj === null || gj === void 0) {
    errors.push({
      message: "The root of a GeoJSON object must be an object.",
      line: 0
    });
    return errors;
  }
  root2(gj);
  errors.forEach(function(err) {
    if ({}.hasOwnProperty.call(err, "line") && err.line === void 0) {
      delete err.line;
    }
  });
  return errors;
}
object$1.hint = hint$3;
var jsonlint$1 = jsonlintExports, geojsonHintObject$1 = object$1;
function hint$2(str, options2) {
  var gj, errors = [];
  if (typeof str === "object") {
    gj = str;
  } else if (typeof str === "string") {
    try {
      gj = jsonlint$1.parse(str);
    } catch (e3) {
      var match2 = e3.message.match(/line (\d+)/);
      var lineNumber = parseInt(match2[1], 10);
      return [{
        line: lineNumber - 1,
        message: e3.message,
        error: e3
      }];
    }
  } else {
    return [{
      message: "Expected string or object as input",
      line: 0
    }];
  }
  errors = errors.concat(geojsonHintObject$1.hint(gj, options2));
  return errors;
}
lib$3.hint = hint$2;
const featureTypes$2 = {
  Polygon: Polygon$2,
  LineString: LineString$2,
  Point: Point$4,
  MultiPolygon: MultiFeature$2,
  MultiLineString: MultiFeature$2,
  MultiPoint: MultiFeature$2
};
function setupAPI$1(ctx2, api2) {
  api2.modes = modes$2;
  api2.getFeatureIdsAt = function(point4) {
    const features = featuresAt$5.click({ point: point4 }, null, ctx2);
    return features.map((feature2) => feature2.properties.id);
  };
  api2.getSelectedIds = function() {
    return ctx2.store.getSelectedIds();
  };
  api2.getSelected = function() {
    return {
      type: geojsonTypes.FEATURE_COLLECTION,
      features: ctx2.store.getSelectedIds().map((id) => ctx2.store.get(id)).map((feature2) => feature2.toGeoJSON())
    };
  };
  api2.getSelectedPoints = function() {
    return {
      type: geojsonTypes.FEATURE_COLLECTION,
      features: ctx2.store.getSelectedCoordinates().map((coordinate2) => ({
        type: geojsonTypes.FEATURE,
        properties: {},
        geometry: {
          type: geojsonTypes.POINT,
          coordinates: coordinate2.coordinates
        }
      }))
    };
  };
  api2.set = function(featureCollection2) {
    if (featureCollection2.type === void 0 || featureCollection2.type !== geojsonTypes.FEATURE_COLLECTION || !Array.isArray(featureCollection2.features)) {
      throw new Error("Invalid FeatureCollection");
    }
    const renderBatch = ctx2.store.createRenderBatch();
    let toDelete = ctx2.store.getAllIds().slice();
    const newIds = api2.add(featureCollection2);
    const newIdsLookup = new StringSet$5(newIds);
    toDelete = toDelete.filter((id) => !newIdsLookup.has(id));
    if (toDelete.length) {
      api2.delete(toDelete);
    }
    renderBatch();
    return newIds;
  };
  api2.add = function(geojson) {
    const errors = lib$3.hint(geojson, { precisionWarning: false }).filter((e3) => e3.level !== "message");
    if (errors.length) {
      throw new Error(errors[0].message);
    }
    const featureCollection2 = JSON.parse(JSON.stringify(geojsonNormalize$1(geojson)));
    const ids = featureCollection2.features.map((feature2) => {
      feature2.id = feature2.id || hatExports();
      if (feature2.geometry === null) {
        throw new Error("Invalid geometry: null");
      }
      if (ctx2.store.get(feature2.id) === void 0 || ctx2.store.get(feature2.id).type !== feature2.geometry.type) {
        const Model2 = featureTypes$2[feature2.geometry.type];
        if (Model2 === void 0) {
          throw new Error(`Invalid geometry type: ${feature2.geometry.type}.`);
        }
        const internalFeature = new Model2(ctx2, feature2);
        ctx2.store.add(internalFeature);
      } else {
        const internalFeature = ctx2.store.get(feature2.id);
        internalFeature.properties = feature2.properties;
        if (!isEqual$1(internalFeature.getCoordinates(), feature2.geometry.coordinates)) {
          internalFeature.incomingCoords(feature2.geometry.coordinates);
        }
      }
      return feature2.id;
    });
    ctx2.store.render();
    return ids;
  };
  api2.get = function(id) {
    const feature2 = ctx2.store.get(id);
    if (feature2) {
      return feature2.toGeoJSON();
    }
  };
  api2.getAll = function() {
    return {
      type: geojsonTypes.FEATURE_COLLECTION,
      features: ctx2.store.getAll().map((feature2) => feature2.toGeoJSON())
    };
  };
  api2.delete = function(featureIds) {
    ctx2.store.delete(featureIds, { silent: true });
    if (api2.getMode() === modes$2.DIRECT_SELECT && !ctx2.store.getSelectedIds().length) {
      ctx2.events.changeMode(modes$2.SIMPLE_SELECT, void 0, { silent: true });
    } else {
      ctx2.store.render();
    }
    return api2;
  };
  api2.deleteAll = function() {
    ctx2.store.delete(ctx2.store.getAllIds(), { silent: true });
    if (api2.getMode() === modes$2.DIRECT_SELECT) {
      ctx2.events.changeMode(modes$2.SIMPLE_SELECT, void 0, { silent: true });
    } else {
      ctx2.store.render();
    }
    return api2;
  };
  api2.changeMode = function(mode2, modeOptions = {}) {
    if (mode2 === modes$2.SIMPLE_SELECT && api2.getMode() === modes$2.SIMPLE_SELECT) {
      if (stringSetsAreEqual$1(modeOptions.featureIds || [], ctx2.store.getSelectedIds()))
        return api2;
      ctx2.store.setSelected(modeOptions.featureIds, { silent: true });
      ctx2.store.render();
      return api2;
    }
    if (mode2 === modes$2.DIRECT_SELECT && api2.getMode() === modes$2.DIRECT_SELECT && modeOptions.featureId === ctx2.store.getSelectedIds()[0]) {
      return api2;
    }
    ctx2.events.changeMode(mode2, modeOptions, { silent: true });
    return api2;
  };
  api2.getMode = function() {
    return ctx2.events.getMode();
  };
  api2.trash = function() {
    ctx2.events.trash({ silent: true });
    return api2;
  };
  api2.combineFeatures = function() {
    ctx2.events.combineFeatures({ silent: true });
    return api2;
  };
  api2.uncombineFeatures = function() {
    ctx2.events.uncombineFeatures({ silent: true });
    return api2;
  };
  api2.setFeatureProperty = function(featureId, property2, value) {
    ctx2.store.setFeatureProperty(featureId, property2, value);
    return api2;
  };
  return api2;
}
const setupDraw$1 = function(options2, api2) {
  options2 = setupOptions$1(options2);
  const ctx2 = {
    options: options2
  };
  api2 = setupAPI$1(ctx2, api2);
  ctx2.api = api2;
  const setup2 = runSetup$1(ctx2);
  api2.onAdd = setup2.onAdd;
  api2.onRemove = setup2.onRemove;
  api2.types = types$1;
  api2.options = options2;
  return api2;
};
function MapboxDraw$5(options2) {
  setupDraw$1(options2, this);
}
MapboxDraw$5.modes = modes$1;
const mapboxGlDraw$1 = "";
function feature$8(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$9(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox$7(bbox2);
  if (id)
    validateId$7(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function polygon$2(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  for (var i2 = 0; i2 < coordinates2.length; i2++) {
    var ring = coordinates2[i2];
    if (ring.length < 4) {
      throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
    }
    for (var j2 = 0; j2 < ring[ring.length - 1].length; j2++) {
      if (i2 === 0 && j2 === 0 && !isNumber$8(ring[0][0]) || !isNumber$8(ring[0][1]))
        throw new Error("coordinates must contain numbers");
      if (ring[ring.length - 1][j2] !== ring[0][j2]) {
        throw new Error("First and last Position are not equivalent.");
      }
    }
  }
  return feature$8({
    type: "Polygon",
    coordinates: coordinates2
  }, properties, options2);
}
function isNumber$8(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$9(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$7(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$8(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId$7(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function bboxPolygon$1(bbox2) {
  validateBBox$7(bbox2);
  var west = Number(bbox2[0]);
  var south = Number(bbox2[1]);
  var east = Number(bbox2[2]);
  var north = Number(bbox2[3]);
  if (bbox2.length === 6)
    throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
  var lowLeft = [west, south];
  var topLeft = [west, north];
  var topRight = [east, north];
  var lowRight = [east, south];
  return polygon$2([[
    lowLeft,
    lowRight,
    topRight,
    topLeft,
    lowLeft
  ]]);
}
function getCoord$4(coord) {
  if (!coord)
    throw new Error("coord is required");
  if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point")
    return coord.geometry.coordinates;
  if (coord.type === "Point")
    return coord.coordinates;
  if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === void 0 && coord[1].length === void 0)
    return coord;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords$5(coords) {
  if (!coords)
    throw new Error("coords is required");
  if (coords.type === "Feature" && coords.geometry !== null)
    return coords.geometry.coordinates;
  if (coords.coordinates)
    return coords.coordinates;
  if (Array.isArray(coords))
    return coords;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function booleanPointInPolygon(point4, polygon4, options2) {
  options2 = options2 || {};
  if (typeof options2 !== "object")
    throw new Error("options is invalid");
  var ignoreBoundary = options2.ignoreBoundary;
  if (!point4)
    throw new Error("point is required");
  if (!polygon4)
    throw new Error("polygon is required");
  var pt = getCoord$4(point4);
  var polys = getCoords$5(polygon4);
  var type = polygon4.geometry ? polygon4.geometry.type : polygon4.type;
  var bbox2 = polygon4.bbox;
  if (bbox2 && inBBox(pt, bbox2) === false)
    return false;
  if (type === "Polygon")
    polys = [polys];
  for (var i2 = 0, insidePoly = false; i2 < polys.length && !insidePoly; i2++) {
    if (inRing(pt, polys[i2][0], ignoreBoundary)) {
      var inHole = false;
      var k2 = 1;
      while (k2 < polys[i2].length && !inHole) {
        if (inRing(pt, polys[i2][k2], !ignoreBoundary)) {
          inHole = true;
        }
        k2++;
      }
      if (!inHole)
        insidePoly = true;
    }
  }
  return insidePoly;
}
function inRing(pt, ring, ignoreBoundary) {
  var isInside = false;
  if (ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1])
    ring = ring.slice(0, ring.length - 1);
  for (var i2 = 0, j2 = ring.length - 1; i2 < ring.length; j2 = i2++) {
    var xi = ring[i2][0], yi = ring[i2][1];
    var xj = ring[j2][0], yj = ring[j2][1];
    var onBoundary = pt[1] * (xi - xj) + yi * (xj - pt[0]) + yj * (pt[0] - xi) === 0 && (xi - pt[0]) * (xj - pt[0]) <= 0 && (yi - pt[1]) * (yj - pt[1]) <= 0;
    if (onBoundary)
      return !ignoreBoundary;
    var intersect2 = yi > pt[1] !== yj > pt[1] && pt[0] < (xj - xi) * (pt[1] - yi) / (yj - yi) + xi;
    if (intersect2)
      isInside = !isInside;
  }
  return isInside;
}
function inBBox(pt, bbox2) {
  return bbox2[0] <= pt[0] && bbox2[1] <= pt[1] && bbox2[2] >= pt[0] && bbox2[3] >= pt[1];
}
var earthRadius$3 = 63710088e-1;
var factors$3 = {
  meters: earthRadius$3,
  metres: earthRadius$3,
  millimeters: earthRadius$3 * 1e3,
  millimetres: earthRadius$3 * 1e3,
  centimeters: earthRadius$3 * 100,
  centimetres: earthRadius$3 * 100,
  kilometers: earthRadius$3 / 1e3,
  kilometres: earthRadius$3 / 1e3,
  miles: earthRadius$3 / 1609.344,
  nauticalmiles: earthRadius$3 / 1852,
  inches: earthRadius$3 * 39.37,
  yards: earthRadius$3 / 1.0936,
  feet: earthRadius$3 * 3.28084,
  radians: 1,
  degrees: earthRadius$3 / 111325
};
function feature$7(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$8(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox$6(bbox2);
  if (id)
    validateId$6(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function lineString$4(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be an array of two or more positions");
  if (!isNumber$7(coordinates2[0][1]) || !isNumber$7(coordinates2[0][1]))
    throw new Error("coordinates must contain numbers");
  return feature$7({
    type: "LineString",
    coordinates: coordinates2
  }, properties, options2);
}
function radiansToLength$2(radians2, units2) {
  if (radians2 === void 0 || radians2 === null)
    throw new Error("radians is required");
  if (units2 && typeof units2 !== "string")
    throw new Error("units must be a string");
  var factor = factors$3[units2 || "kilometers"];
  if (!factor)
    throw new Error(units2 + " units is invalid");
  return radians2 * factor;
}
function radiansToDegrees$3(radians2) {
  if (radians2 === null || radians2 === void 0)
    throw new Error("radians is required");
  var degrees2 = radians2 % (2 * Math.PI);
  return degrees2 * 180 / Math.PI;
}
function degreesToRadians$3(degrees2) {
  if (degrees2 === null || degrees2 === void 0)
    throw new Error("degrees is required");
  var radians2 = degrees2 % 360;
  return radians2 * Math.PI / 180;
}
function isNumber$7(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$8(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$6(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$7(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId$6(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function geomEach$2(geojson, callback) {
  var i2, j2, g2, geometry2, stopG, geometryMaybeCollection, isGeometryCollection2, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature2 = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i2 = 0; i2 < stop; i2++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[i2].geometry : isFeature2 ? geojson.geometry : geojson;
    featureProperties = isFeatureCollection ? geojson.features[i2].properties : isFeature2 ? geojson.properties : {};
    featureBBox = isFeatureCollection ? geojson.features[i2].bbox : isFeature2 ? geojson.bbox : void 0;
    featureId = isFeatureCollection ? geojson.features[i2].id : isFeature2 ? geojson.id : void 0;
    isGeometryCollection2 = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection2 ? geometryMaybeCollection.geometries.length : 1;
    for (g2 = 0; g2 < stopG; g2++) {
      geometry2 = isGeometryCollection2 ? geometryMaybeCollection.geometries[g2] : geometryMaybeCollection;
      if (geometry2 === null) {
        if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false)
          return false;
        continue;
      }
      switch (geometry2.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (callback(geometry2, featureIndex, featureProperties, featureBBox, featureId) === false)
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j2 = 0; j2 < geometry2.geometries.length; j2++) {
            if (callback(geometry2.geometries[j2], featureIndex, featureProperties, featureBBox, featureId) === false)
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function flattenEach$2(geojson, callback) {
  geomEach$2(geojson, function(geometry2, featureIndex, properties, bbox2, id) {
    var type = geometry2 === null ? null : geometry2.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (callback(feature$7(geometry2, properties, { bbox: bbox2, id }), featureIndex, 0) === false)
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (var multiFeatureIndex = 0; multiFeatureIndex < geometry2.coordinates.length; multiFeatureIndex++) {
      var coordinate2 = geometry2.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate2
      };
      if (callback(feature$7(geom, properties), featureIndex, multiFeatureIndex) === false)
        return false;
    }
  });
}
function quickselect(arr, k2, left, right, compare12) {
  quickselectStep(arr, k2, left || 0, right || arr.length - 1, compare12 || defaultCompare);
}
function quickselectStep(arr, k2, left, right, compare12) {
  while (right > left) {
    if (right - left > 600) {
      var n2 = right - left + 1;
      var m2 = k2 - left + 1;
      var z2 = Math.log(n2);
      var s2 = 0.5 * Math.exp(2 * z2 / 3);
      var sd = 0.5 * Math.sqrt(z2 * s2 * (n2 - s2) / n2) * (m2 - n2 / 2 < 0 ? -1 : 1);
      var newLeft = Math.max(left, Math.floor(k2 - m2 * s2 / n2 + sd));
      var newRight = Math.min(right, Math.floor(k2 + (n2 - m2) * s2 / n2 + sd));
      quickselectStep(arr, k2, newLeft, newRight, compare12);
    }
    var t2 = arr[k2];
    var i2 = left;
    var j2 = right;
    swap(arr, left, k2);
    if (compare12(arr[right], t2) > 0)
      swap(arr, left, right);
    while (i2 < j2) {
      swap(arr, i2, j2);
      i2++;
      j2--;
      while (compare12(arr[i2], t2) < 0)
        i2++;
      while (compare12(arr[j2], t2) > 0)
        j2--;
    }
    if (compare12(arr[left], t2) === 0)
      swap(arr, left, j2);
    else {
      j2++;
      swap(arr, j2, right);
    }
    if (j2 <= k2)
      left = j2 + 1;
    if (k2 <= j2)
      right = j2 - 1;
  }
}
function swap(arr, i2, j2) {
  var tmp2 = arr[i2];
  arr[i2] = arr[j2];
  arr[j2] = tmp2;
}
function defaultCompare(a2, b2) {
  return a2 < b2 ? -1 : a2 > b2 ? 1 : 0;
}
function rbush(maxEntries, format) {
  if (!(this instanceof rbush))
    return new rbush(maxEntries, format);
  this._maxEntries = Math.max(4, maxEntries || 9);
  this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
  if (format) {
    this._initFormat(format);
  }
  this.clear();
}
rbush.prototype = {
  all: function() {
    return this._all(this.data, []);
  },
  search: function(bbox2) {
    var node = this.data, result = [], toBBox = this.toBBox;
    if (!intersects$1(bbox2, node))
      return result;
    var nodesToSearch = [], i2, len2, child, childBBox;
    while (node) {
      for (i2 = 0, len2 = node.children.length; i2 < len2; i2++) {
        child = node.children[i2];
        childBBox = node.leaf ? toBBox(child) : child;
        if (intersects$1(bbox2, childBBox)) {
          if (node.leaf)
            result.push(child);
          else if (contains(bbox2, childBBox))
            this._all(child, result);
          else
            nodesToSearch.push(child);
        }
      }
      node = nodesToSearch.pop();
    }
    return result;
  },
  collides: function(bbox2) {
    var node = this.data, toBBox = this.toBBox;
    if (!intersects$1(bbox2, node))
      return false;
    var nodesToSearch = [], i2, len2, child, childBBox;
    while (node) {
      for (i2 = 0, len2 = node.children.length; i2 < len2; i2++) {
        child = node.children[i2];
        childBBox = node.leaf ? toBBox(child) : child;
        if (intersects$1(bbox2, childBBox)) {
          if (node.leaf || contains(bbox2, childBBox))
            return true;
          nodesToSearch.push(child);
        }
      }
      node = nodesToSearch.pop();
    }
    return false;
  },
  load: function(data2) {
    if (!(data2 && data2.length))
      return this;
    if (data2.length < this._minEntries) {
      for (var i2 = 0, len2 = data2.length; i2 < len2; i2++) {
        this.insert(data2[i2]);
      }
      return this;
    }
    var node = this._build(data2.slice(), 0, data2.length - 1, 0);
    if (!this.data.children.length) {
      this.data = node;
    } else if (this.data.height === node.height) {
      this._splitRoot(this.data, node);
    } else {
      if (this.data.height < node.height) {
        var tmpNode = this.data;
        this.data = node;
        node = tmpNode;
      }
      this._insert(node, this.data.height - node.height - 1, true);
    }
    return this;
  },
  insert: function(item) {
    if (item)
      this._insert(item, this.data.height - 1);
    return this;
  },
  clear: function() {
    this.data = createNode([]);
    return this;
  },
  remove: function(item, equalsFn) {
    if (!item)
      return this;
    var node = this.data, bbox2 = this.toBBox(item), path2 = [], indexes = [], i2, parent, index2, goingUp;
    while (node || path2.length) {
      if (!node) {
        node = path2.pop();
        parent = path2[path2.length - 1];
        i2 = indexes.pop();
        goingUp = true;
      }
      if (node.leaf) {
        index2 = findItem(item, node.children, equalsFn);
        if (index2 !== -1) {
          node.children.splice(index2, 1);
          path2.push(node);
          this._condense(path2);
          return this;
        }
      }
      if (!goingUp && !node.leaf && contains(node, bbox2)) {
        path2.push(node);
        indexes.push(i2);
        i2 = 0;
        parent = node;
        node = node.children[0];
      } else if (parent) {
        i2++;
        node = parent.children[i2];
        goingUp = false;
      } else
        node = null;
    }
    return this;
  },
  toBBox: function(item) {
    return item;
  },
  compareMinX: compareNodeMinX,
  compareMinY: compareNodeMinY,
  toJSON: function() {
    return this.data;
  },
  fromJSON: function(data2) {
    this.data = data2;
    return this;
  },
  _all: function(node, result) {
    var nodesToSearch = [];
    while (node) {
      if (node.leaf)
        result.push.apply(result, node.children);
      else
        nodesToSearch.push.apply(nodesToSearch, node.children);
      node = nodesToSearch.pop();
    }
    return result;
  },
  _build: function(items, left, right, height) {
    var N2 = right - left + 1, M2 = this._maxEntries, node;
    if (N2 <= M2) {
      node = createNode(items.slice(left, right + 1));
      calcBBox(node, this.toBBox);
      return node;
    }
    if (!height) {
      height = Math.ceil(Math.log(N2) / Math.log(M2));
      M2 = Math.ceil(N2 / Math.pow(M2, height - 1));
    }
    node = createNode([]);
    node.leaf = false;
    node.height = height;
    var N22 = Math.ceil(N2 / M2), N1 = N22 * Math.ceil(Math.sqrt(M2)), i2, j2, right2, right3;
    multiSelect(items, left, right, N1, this.compareMinX);
    for (i2 = left; i2 <= right; i2 += N1) {
      right2 = Math.min(i2 + N1 - 1, right);
      multiSelect(items, i2, right2, N22, this.compareMinY);
      for (j2 = i2; j2 <= right2; j2 += N22) {
        right3 = Math.min(j2 + N22 - 1, right2);
        node.children.push(this._build(items, j2, right3, height - 1));
      }
    }
    calcBBox(node, this.toBBox);
    return node;
  },
  _chooseSubtree: function(bbox2, node, level, path2) {
    var i2, len2, child, targetNode, area5, enlargement, minArea, minEnlargement;
    while (true) {
      path2.push(node);
      if (node.leaf || path2.length - 1 === level)
        break;
      minArea = minEnlargement = Infinity;
      for (i2 = 0, len2 = node.children.length; i2 < len2; i2++) {
        child = node.children[i2];
        area5 = bboxArea(child);
        enlargement = enlargedArea(bbox2, child) - area5;
        if (enlargement < minEnlargement) {
          minEnlargement = enlargement;
          minArea = area5 < minArea ? area5 : minArea;
          targetNode = child;
        } else if (enlargement === minEnlargement) {
          if (area5 < minArea) {
            minArea = area5;
            targetNode = child;
          }
        }
      }
      node = targetNode || node.children[0];
    }
    return node;
  },
  _insert: function(item, level, isNode) {
    var toBBox = this.toBBox, bbox2 = isNode ? item : toBBox(item), insertPath = [];
    var node = this._chooseSubtree(bbox2, this.data, level, insertPath);
    node.children.push(item);
    extend$3(node, bbox2);
    while (level >= 0) {
      if (insertPath[level].children.length > this._maxEntries) {
        this._split(insertPath, level);
        level--;
      } else
        break;
    }
    this._adjustParentBBoxes(bbox2, insertPath, level);
  },
  // split overflowed node into two
  _split: function(insertPath, level) {
    var node = insertPath[level], M2 = node.children.length, m2 = this._minEntries;
    this._chooseSplitAxis(node, m2, M2);
    var splitIndex = this._chooseSplitIndex(node, m2, M2);
    var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
    newNode.height = node.height;
    newNode.leaf = node.leaf;
    calcBBox(node, this.toBBox);
    calcBBox(newNode, this.toBBox);
    if (level)
      insertPath[level - 1].children.push(newNode);
    else
      this._splitRoot(node, newNode);
  },
  _splitRoot: function(node, newNode) {
    this.data = createNode([node, newNode]);
    this.data.height = node.height + 1;
    this.data.leaf = false;
    calcBBox(this.data, this.toBBox);
  },
  _chooseSplitIndex: function(node, m2, M2) {
    var i2, bbox1, bbox2, overlap2, area5, minOverlap, minArea, index2;
    minOverlap = minArea = Infinity;
    for (i2 = m2; i2 <= M2 - m2; i2++) {
      bbox1 = distBBox(node, 0, i2, this.toBBox);
      bbox2 = distBBox(node, i2, M2, this.toBBox);
      overlap2 = intersectionArea(bbox1, bbox2);
      area5 = bboxArea(bbox1) + bboxArea(bbox2);
      if (overlap2 < minOverlap) {
        minOverlap = overlap2;
        index2 = i2;
        minArea = area5 < minArea ? area5 : minArea;
      } else if (overlap2 === minOverlap) {
        if (area5 < minArea) {
          minArea = area5;
          index2 = i2;
        }
      }
    }
    return index2;
  },
  // sorts node children by the best axis for split
  _chooseSplitAxis: function(node, m2, M2) {
    var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX, compareMinY = node.leaf ? this.compareMinY : compareNodeMinY, xMargin = this._allDistMargin(node, m2, M2, compareMinX), yMargin = this._allDistMargin(node, m2, M2, compareMinY);
    if (xMargin < yMargin)
      node.children.sort(compareMinX);
  },
  // total margin of all possible split distributions where each node is at least m full
  _allDistMargin: function(node, m2, M2, compare12) {
    node.children.sort(compare12);
    var toBBox = this.toBBox, leftBBox = distBBox(node, 0, m2, toBBox), rightBBox = distBBox(node, M2 - m2, M2, toBBox), margin = bboxMargin(leftBBox) + bboxMargin(rightBBox), i2, child;
    for (i2 = m2; i2 < M2 - m2; i2++) {
      child = node.children[i2];
      extend$3(leftBBox, node.leaf ? toBBox(child) : child);
      margin += bboxMargin(leftBBox);
    }
    for (i2 = M2 - m2 - 1; i2 >= m2; i2--) {
      child = node.children[i2];
      extend$3(rightBBox, node.leaf ? toBBox(child) : child);
      margin += bboxMargin(rightBBox);
    }
    return margin;
  },
  _adjustParentBBoxes: function(bbox2, path2, level) {
    for (var i2 = level; i2 >= 0; i2--) {
      extend$3(path2[i2], bbox2);
    }
  },
  _condense: function(path2) {
    for (var i2 = path2.length - 1, siblings; i2 >= 0; i2--) {
      if (path2[i2].children.length === 0) {
        if (i2 > 0) {
          siblings = path2[i2 - 1].children;
          siblings.splice(siblings.indexOf(path2[i2]), 1);
        } else
          this.clear();
      } else
        calcBBox(path2[i2], this.toBBox);
    }
  },
  _initFormat: function(format) {
    var compareArr = ["return a", " - b", ";"];
    this.compareMinX = new Function("a", "b", compareArr.join(format[0]));
    this.compareMinY = new Function("a", "b", compareArr.join(format[1]));
    this.toBBox = new Function(
      "a",
      "return {minX: a" + format[0] + ", minY: a" + format[1] + ", maxX: a" + format[2] + ", maxY: a" + format[3] + "};"
    );
  }
};
function findItem(item, items, equalsFn) {
  if (!equalsFn)
    return items.indexOf(item);
  for (var i2 = 0; i2 < items.length; i2++) {
    if (equalsFn(item, items[i2]))
      return i2;
  }
  return -1;
}
function calcBBox(node, toBBox) {
  distBBox(node, 0, node.children.length, toBBox, node);
}
function distBBox(node, k2, p2, toBBox, destNode) {
  if (!destNode)
    destNode = createNode(null);
  destNode.minX = Infinity;
  destNode.minY = Infinity;
  destNode.maxX = -Infinity;
  destNode.maxY = -Infinity;
  for (var i2 = k2, child; i2 < p2; i2++) {
    child = node.children[i2];
    extend$3(destNode, node.leaf ? toBBox(child) : child);
  }
  return destNode;
}
function extend$3(a2, b2) {
  a2.minX = Math.min(a2.minX, b2.minX);
  a2.minY = Math.min(a2.minY, b2.minY);
  a2.maxX = Math.max(a2.maxX, b2.maxX);
  a2.maxY = Math.max(a2.maxY, b2.maxY);
  return a2;
}
function compareNodeMinX(a2, b2) {
  return a2.minX - b2.minX;
}
function compareNodeMinY(a2, b2) {
  return a2.minY - b2.minY;
}
function bboxArea(a2) {
  return (a2.maxX - a2.minX) * (a2.maxY - a2.minY);
}
function bboxMargin(a2) {
  return a2.maxX - a2.minX + (a2.maxY - a2.minY);
}
function enlargedArea(a2, b2) {
  return (Math.max(b2.maxX, a2.maxX) - Math.min(b2.minX, a2.minX)) * (Math.max(b2.maxY, a2.maxY) - Math.min(b2.minY, a2.minY));
}
function intersectionArea(a2, b2) {
  var minX2 = Math.max(a2.minX, b2.minX), minY2 = Math.max(a2.minY, b2.minY), maxX2 = Math.min(a2.maxX, b2.maxX), maxY2 = Math.min(a2.maxY, b2.maxY);
  return Math.max(0, maxX2 - minX2) * Math.max(0, maxY2 - minY2);
}
function contains(a2, b2) {
  return a2.minX <= b2.minX && a2.minY <= b2.minY && b2.maxX <= a2.maxX && b2.maxY <= a2.maxY;
}
function intersects$1(a2, b2) {
  return b2.minX <= a2.maxX && b2.minY <= a2.maxY && b2.maxX >= a2.minX && b2.maxY >= a2.minY;
}
function createNode(children) {
  return {
    children,
    height: 1,
    leaf: true,
    minX: Infinity,
    minY: Infinity,
    maxX: -Infinity,
    maxY: -Infinity
  };
}
function multiSelect(arr, left, right, n2, compare12) {
  var stack2 = [left, right], mid;
  while (stack2.length) {
    right = stack2.pop();
    left = stack2.pop();
    if (right - left <= n2)
      continue;
    mid = left + Math.ceil((right - left) / n2 / 2) * n2;
    quickselect(arr, mid, left, right, compare12);
    stack2.push(left, mid, mid, right);
  }
}
function geojsonRbush(maxEntries) {
  var tree = rbush(maxEntries);
  tree.insert = function(feature2) {
    if (Array.isArray(feature2)) {
      var bbox2 = feature2;
      feature2 = bboxPolygon(bbox2);
      feature2.bbox = bbox2;
    } else {
      feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox(feature2);
    }
    return rbush.prototype.insert.call(this, feature2);
  };
  tree.load = function(features) {
    var load2 = [];
    if (Array.isArray(features)) {
      features.forEach(function(bbox2) {
        var feature2 = bboxPolygon(bbox2);
        feature2.bbox = bbox2;
        load2.push(feature2);
      });
    } else {
      featureEach$3(features, function(feature2) {
        feature2.bbox = feature2.bbox ? feature2.bbox : turfBBox(feature2);
        load2.push(feature2);
      });
    }
    return rbush.prototype.load.call(this, load2);
  };
  tree.remove = function(feature2) {
    if (Array.isArray(feature2)) {
      var bbox2 = feature2;
      feature2 = bboxPolygon(bbox2);
      feature2.bbox = bbox2;
    }
    return rbush.prototype.remove.call(this, feature2);
  };
  tree.clear = function() {
    return rbush.prototype.clear.call(this);
  };
  tree.search = function(geojson) {
    var features = rbush.prototype.search.call(this, this.toBBox(geojson));
    return {
      type: "FeatureCollection",
      features
    };
  };
  tree.collides = function(geojson) {
    return rbush.prototype.collides.call(this, this.toBBox(geojson));
  };
  tree.all = function() {
    var features = rbush.prototype.all.call(this);
    return {
      type: "FeatureCollection",
      features
    };
  };
  tree.toJSON = function() {
    return rbush.prototype.toJSON.call(this);
  };
  tree.fromJSON = function(json) {
    return rbush.prototype.fromJSON.call(this, json);
  };
  tree.toBBox = function(geojson) {
    var bbox2;
    if (geojson.bbox)
      bbox2 = geojson.bbox;
    else if (Array.isArray(geojson) && geojson.length === 4)
      bbox2 = geojson;
    else
      bbox2 = turfBBox(geojson);
    return {
      minX: bbox2[0],
      minY: bbox2[1],
      maxX: bbox2[2],
      maxY: bbox2[3]
    };
  };
  return tree;
}
function bboxPolygon(bbox2) {
  var lowLeft = [bbox2[0], bbox2[1]];
  var topLeft = [bbox2[0], bbox2[3]];
  var topRight = [bbox2[2], bbox2[3]];
  var lowRight = [bbox2[2], bbox2[1]];
  var coordinates2 = [[lowLeft, lowRight, topRight, topLeft, lowLeft]];
  return {
    type: "Feature",
    bbox: bbox2,
    properties: {},
    geometry: {
      type: "Polygon",
      coordinates: coordinates2
    }
  };
}
function turfBBox(geojson) {
  var bbox2 = [Infinity, Infinity, -Infinity, -Infinity];
  coordEach(geojson, function(coord) {
    if (bbox2[0] > coord[0])
      bbox2[0] = coord[0];
    if (bbox2[1] > coord[1])
      bbox2[1] = coord[1];
    if (bbox2[2] < coord[0])
      bbox2[2] = coord[0];
    if (bbox2[3] < coord[1])
      bbox2[3] = coord[1];
  });
  return bbox2;
}
function feature$6(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$7(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox$5(bbox2);
  if (id)
    validateId$5(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function lineString$3(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be an array of two or more positions");
  if (!isNumber$6(coordinates2[0][1]) || !isNumber$6(coordinates2[0][1]))
    throw new Error("coordinates must contain numbers");
  return feature$6({
    type: "LineString",
    coordinates: coordinates2
  }, properties, options2);
}
function featureCollection$3(features, options2) {
  options2 = options2 || {};
  if (!isObject$7(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (!features)
    throw new Error("No features passed");
  if (!Array.isArray(features))
    throw new Error("features must be an Array");
  if (bbox2)
    validateBBox$5(bbox2);
  if (id)
    validateId$5(id);
  var fc = { type: "FeatureCollection" };
  if (id)
    fc.id = id;
  if (bbox2)
    fc.bbox = bbox2;
  fc.features = features;
  return fc;
}
function isNumber$6(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$7(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$5(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$6(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId$5(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function getCoords$4(coords) {
  if (!coords)
    throw new Error("coords is required");
  if (coords.type === "Feature" && coords.geometry !== null)
    return coords.geometry.coordinates;
  if (coords.coordinates)
    return coords.coordinates;
  if (Array.isArray(coords))
    return coords;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function geomEach$1(geojson, callback) {
  var i2, j2, g2, geometry2, stopG, geometryMaybeCollection, isGeometryCollection2, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature2 = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i2 = 0; i2 < stop; i2++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[i2].geometry : isFeature2 ? geojson.geometry : geojson;
    featureProperties = isFeatureCollection ? geojson.features[i2].properties : isFeature2 ? geojson.properties : {};
    featureBBox = isFeatureCollection ? geojson.features[i2].bbox : isFeature2 ? geojson.bbox : void 0;
    featureId = isFeatureCollection ? geojson.features[i2].id : isFeature2 ? geojson.id : void 0;
    isGeometryCollection2 = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection2 ? geometryMaybeCollection.geometries.length : 1;
    for (g2 = 0; g2 < stopG; g2++) {
      geometry2 = isGeometryCollection2 ? geometryMaybeCollection.geometries[g2] : geometryMaybeCollection;
      if (geometry2 === null) {
        if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false)
          return false;
        continue;
      }
      switch (geometry2.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (callback(geometry2, featureIndex, featureProperties, featureBBox, featureId) === false)
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j2 = 0; j2 < geometry2.geometries.length; j2++) {
            if (callback(geometry2.geometries[j2], featureIndex, featureProperties, featureBBox, featureId) === false)
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function flattenEach$1(geojson, callback) {
  geomEach$1(geojson, function(geometry2, featureIndex, properties, bbox2, id) {
    var type = geometry2 === null ? null : geometry2.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (callback(feature$6(geometry2, properties, { bbox: bbox2, id }), featureIndex, 0) === false)
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (var multiFeatureIndex = 0; multiFeatureIndex < geometry2.coordinates.length; multiFeatureIndex++) {
      var coordinate2 = geometry2.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate2
      };
      if (callback(feature$6(geom, properties), featureIndex, multiFeatureIndex) === false)
        return false;
    }
  });
}
function lineSegment(geojson) {
  if (!geojson)
    throw new Error("geojson is required");
  var results = [];
  flattenEach$1(geojson, function(feature2) {
    lineSegmentFeature(feature2, results);
  });
  return featureCollection$3(results);
}
function lineSegmentFeature(geojson, results) {
  var coords = [];
  var geometry2 = geojson.geometry;
  switch (geometry2.type) {
    case "Polygon":
      coords = getCoords$4(geometry2);
      break;
    case "LineString":
      coords = [getCoords$4(geometry2)];
  }
  coords.forEach(function(coord) {
    var segments = createSegments(coord, geojson.properties);
    segments.forEach(function(segment) {
      segment.id = results.length;
      results.push(segment);
    });
  });
}
function createSegments(coords, properties) {
  var segments = [];
  coords.reduce(function(previousCoords, currentCoords) {
    var segment = lineString$3([previousCoords, currentCoords], properties);
    segment.bbox = bbox(previousCoords, currentCoords);
    segments.push(segment);
    return currentCoords;
  });
  return segments;
}
function bbox(coords1, coords2) {
  var x12 = coords1[0];
  var y12 = coords1[1];
  var x2 = coords2[0];
  var y2 = coords2[1];
  var west = x12 < x2 ? x12 : x2;
  var south = y12 < y2 ? y12 : y2;
  var east = x12 > x2 ? x12 : x2;
  var north = y12 > y2 ? y12 : y2;
  return [west, south, east, north];
}
function feature$5(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$6(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox$4(bbox2);
  if (id)
    validateId$4(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function point$4(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be at least 2 numbers long");
  if (!isNumber$5(coordinates2[0]) || !isNumber$5(coordinates2[1]))
    throw new Error("coordinates must contain numbers");
  return feature$5({
    type: "Point",
    coordinates: coordinates2
  }, properties, options2);
}
function featureCollection$2(features, options2) {
  options2 = options2 || {};
  if (!isObject$6(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (!features)
    throw new Error("No features passed");
  if (!Array.isArray(features))
    throw new Error("features must be an Array");
  if (bbox2)
    validateBBox$4(bbox2);
  if (id)
    validateId$4(id);
  var fc = { type: "FeatureCollection" };
  if (id)
    fc.id = id;
  if (bbox2)
    fc.bbox = bbox2;
  fc.features = features;
  return fc;
}
function isNumber$5(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$6(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$4(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$5(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId$4(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function getCoords$3(coords) {
  if (!coords)
    throw new Error("coords is required");
  if (coords.type === "Feature" && coords.geometry !== null)
    return coords.geometry.coordinates;
  if (coords.coordinates)
    return coords.coordinates;
  if (Array.isArray(coords))
    return coords;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function featureEach(geojson, callback) {
  if (geojson.type === "Feature") {
    callback(geojson, 0);
  } else if (geojson.type === "FeatureCollection") {
    for (var i2 = 0; i2 < geojson.features.length; i2++) {
      if (callback(geojson.features[i2], i2) === false)
        break;
    }
  }
}
function lineIntersect(line1, line2) {
  var unique2 = {};
  var results = [];
  if (line1.type === "LineString")
    line1 = feature$5(line1);
  if (line2.type === "LineString")
    line2 = feature$5(line2);
  if (line1.type === "Feature" && line2.type === "Feature" && line1.geometry.type === "LineString" && line2.geometry.type === "LineString" && line1.geometry.coordinates.length === 2 && line2.geometry.coordinates.length === 2) {
    var intersect2 = intersects(line1, line2);
    if (intersect2)
      results.push(intersect2);
    return featureCollection$2(results);
  }
  var tree = geojsonRbush();
  tree.load(lineSegment(line2));
  featureEach(lineSegment(line1), function(segment) {
    featureEach(tree.search(segment), function(match2) {
      var intersect3 = intersects(segment, match2);
      if (intersect3) {
        var key = getCoords$3(intersect3).join(",");
        if (!unique2[key]) {
          unique2[key] = true;
          results.push(intersect3);
        }
      }
    });
  });
  return featureCollection$2(results);
}
function intersects(line1, line2) {
  var coords1 = getCoords$3(line1);
  var coords2 = getCoords$3(line2);
  if (coords1.length !== 2) {
    throw new Error("<intersects> line1 must only contain 2 coordinates");
  }
  if (coords2.length !== 2) {
    throw new Error("<intersects> line2 must only contain 2 coordinates");
  }
  var x12 = coords1[0][0];
  var y12 = coords1[0][1];
  var x2 = coords1[1][0];
  var y2 = coords1[1][1];
  var x3 = coords2[0][0];
  var y3 = coords2[0][1];
  var x4 = coords2[1][0];
  var y4 = coords2[1][1];
  var denom = (y4 - y3) * (x2 - x12) - (x4 - x3) * (y2 - y12);
  var numeA = (x4 - x3) * (y12 - y3) - (y4 - y3) * (x12 - x3);
  var numeB = (x2 - x12) * (y12 - y3) - (y2 - y12) * (x12 - x3);
  if (denom === 0) {
    if (numeA === 0 && numeB === 0) {
      return null;
    }
    return null;
  }
  var uA = numeA / denom;
  var uB = numeB / denom;
  if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1) {
    var x5 = x12 + uA * (x2 - x12);
    var y5 = y12 + uA * (y2 - y12);
    return point$4([x5, y5]);
  }
  return null;
}
function feature$4(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$5(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox$3(bbox2);
  if (id)
    validateId$3(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function lineString$2(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be an array of two or more positions");
  if (!isNumber$4(coordinates2[0][1]) || !isNumber$4(coordinates2[0][1]))
    throw new Error("coordinates must contain numbers");
  return feature$4({
    type: "LineString",
    coordinates: coordinates2
  }, properties, options2);
}
function featureCollection$1(features, options2) {
  options2 = options2 || {};
  if (!isObject$5(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (!features)
    throw new Error("No features passed");
  if (!Array.isArray(features))
    throw new Error("features must be an Array");
  if (bbox2)
    validateBBox$3(bbox2);
  if (id)
    validateId$3(id);
  var fc = { type: "FeatureCollection" };
  if (id)
    fc.id = id;
  if (bbox2)
    fc.bbox = bbox2;
  fc.features = features;
  return fc;
}
function multiLineString$1(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  return feature$4({
    type: "MultiLineString",
    coordinates: coordinates2
  }, properties, options2);
}
function isNumber$4(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$5(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$3(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$4(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId$3(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function getCoords$2(coords) {
  if (!coords)
    throw new Error("coords is required");
  if (coords.type === "Feature" && coords.geometry !== null)
    return coords.geometry.coordinates;
  if (coords.coordinates)
    return coords.coordinates;
  if (Array.isArray(coords))
    return coords;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function getType(geojson, name2) {
  if (!geojson)
    throw new Error((name2 || "geojson") + " is required");
  if (geojson.geometry && geojson.geometry.type)
    return geojson.geometry.type;
  if (geojson.type)
    return geojson.type;
  throw new Error((name2 || "geojson") + " is invalid");
}
function polygonToLine(polygon4, options2) {
  options2 = options2 || {};
  if (!isObject$5(options2))
    throw new Error("options is invalid");
  var properties = options2.properties;
  var geom = getType(polygon4);
  var coords = getCoords$2(polygon4);
  properties = properties || polygon4.properties || {};
  if (!coords.length)
    throw new Error("polygon must contain coordinates");
  switch (geom) {
    case "Polygon":
      return coordsToLine(coords, properties);
    case "MultiPolygon":
      var lines = [];
      coords.forEach(function(coord) {
        lines.push(coordsToLine(coord, properties));
      });
      return featureCollection$1(lines);
    default:
      throw new Error("geom " + geom + " not supported");
  }
}
function coordsToLine(coords, properties) {
  if (coords.length > 1)
    return multiLineString$1(coords, properties);
  return lineString$2(coords[0], properties);
}
function booleanDisjoint(feature1, feature2) {
  var boolean2;
  flattenEach$2(feature1, function(flatten1) {
    flattenEach$2(feature2, function(flatten22) {
      if (boolean2 === false)
        return false;
      boolean2 = disjoint(flatten1.geometry, flatten22.geometry);
    });
  });
  return boolean2;
}
function disjoint(geom1, geom2) {
  switch (geom1.type) {
    case "Point":
      switch (geom2.type) {
        case "Point":
          return !compareCoords(geom1.coordinates, geom2.coordinates);
        case "LineString":
          return !isPointOnLine(geom2, geom1);
        case "Polygon":
          return !booleanPointInPolygon(geom1, geom2);
      }
      break;
    case "LineString":
      switch (geom2.type) {
        case "Point":
          return !isPointOnLine(geom1, geom2);
        case "LineString":
          return !isLineOnLine(geom1, geom2);
        case "Polygon":
          return !isLineInPoly(geom2, geom1);
      }
      break;
    case "Polygon":
      switch (geom2.type) {
        case "Point":
          return !booleanPointInPolygon(geom2, geom1);
        case "LineString":
          return !isLineInPoly(geom1, geom2);
        case "Polygon":
          return !isPolyInPoly(geom2, geom1);
      }
  }
}
function isPointOnLine(lineString2, point4) {
  for (var i2 = 0; i2 < lineString2.coordinates.length - 1; i2++) {
    if (isPointOnLineSegment(lineString2.coordinates[i2], lineString2.coordinates[i2 + 1], point4.coordinates)) {
      return true;
    }
  }
  return false;
}
function isLineOnLine(lineString1, lineString2) {
  var doLinesIntersect = lineIntersect(lineString1, lineString2);
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isLineInPoly(polygon4, lineString2) {
  for (var i2 = 0; i2 < lineString2.coordinates.length; i2++) {
    if (booleanPointInPolygon(lineString2.coordinates[i2], polygon4)) {
      return true;
    }
  }
  var doLinesIntersect = lineIntersect(lineString2, polygonToLine(polygon4));
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isPolyInPoly(feature1, feature2) {
  for (var i2 = 0; i2 < feature1.coordinates[0].length; i2++) {
    if (booleanPointInPolygon(feature1.coordinates[0][i2], feature2)) {
      return true;
    }
  }
  for (var i22 = 0; i22 < feature2.coordinates[0].length; i22++) {
    if (booleanPointInPolygon(feature2.coordinates[0][i22], feature1)) {
      return true;
    }
  }
  var doLinesIntersect = lineIntersect(polygonToLine(feature1), polygonToLine(feature2));
  if (doLinesIntersect.features.length > 0) {
    return true;
  }
  return false;
}
function isPointOnLineSegment(LineSegmentStart, LineSegmentEnd, Point2) {
  var dxc = Point2[0] - LineSegmentStart[0];
  var dyc = Point2[1] - LineSegmentStart[1];
  var dxl = LineSegmentEnd[0] - LineSegmentStart[0];
  var dyl = LineSegmentEnd[1] - LineSegmentStart[1];
  var cross2 = dxc * dyl - dyc * dxl;
  if (cross2 !== 0) {
    return false;
  }
  if (Math.abs(dxl) >= Math.abs(dyl)) {
    if (dxl > 0) {
      return LineSegmentStart[0] <= Point2[0] && Point2[0] <= LineSegmentEnd[0];
    } else {
      return LineSegmentEnd[0] <= Point2[0] && Point2[0] <= LineSegmentStart[0];
    }
  } else if (dyl > 0) {
    return LineSegmentStart[1] <= Point2[1] && Point2[1] <= LineSegmentEnd[1];
  } else {
    return LineSegmentEnd[1] <= Point2[1] && Point2[1] <= LineSegmentStart[1];
  }
}
function compareCoords(pair1, pair2) {
  return pair1[0] === pair2[0] && pair1[1] === pair2[1];
}
function getCoords$1(obj) {
  if (!obj)
    throw new Error("obj is required");
  var coordinates2;
  if (obj.length) {
    coordinates2 = obj;
  } else if (obj.coordinates) {
    coordinates2 = obj.coordinates;
  } else if (obj.geometry && obj.geometry.coordinates) {
    coordinates2 = obj.geometry.coordinates;
  }
  if (coordinates2) {
    containsNumber(coordinates2);
    return coordinates2;
  }
  throw new Error("No valid coordinates");
}
function containsNumber(coordinates2) {
  if (coordinates2.length > 1 && isNumber$7(coordinates2[0]) && isNumber$7(coordinates2[1])) {
    return true;
  }
  if (Array.isArray(coordinates2[0]) && coordinates2[0].length) {
    return containsNumber(coordinates2[0]);
  }
  throw new Error("coordinates must only contain numbers");
}
function getCoord$3(coord) {
  if (!coord)
    throw new Error("coord is required");
  if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point")
    return coord.geometry.coordinates;
  if (coord.type === "Point")
    return coord.coordinates;
  if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === void 0 && coord[1].length === void 0)
    return coord;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function distance$3(from, to, options2) {
  options2 = options2 || {};
  if (!isObject$8(options2))
    throw new Error("options is invalid");
  var units2 = options2.units;
  var coordinates1 = getCoord$3(from);
  var coordinates2 = getCoord$3(to);
  var dLat = degreesToRadians$3(coordinates2[1] - coordinates1[1]);
  var dLon = degreesToRadians$3(coordinates2[0] - coordinates1[0]);
  var lat1 = degreesToRadians$3(coordinates1[1]);
  var lat2 = degreesToRadians$3(coordinates2[1]);
  var a2 = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
  return radiansToLength$2(2 * Math.atan2(Math.sqrt(a2), Math.sqrt(1 - a2)), units2);
}
var earthRadius$2 = 63710088e-1;
var factors$2 = {
  meters: earthRadius$2,
  metres: earthRadius$2,
  millimeters: earthRadius$2 * 1e3,
  millimetres: earthRadius$2 * 1e3,
  centimeters: earthRadius$2 * 100,
  centimetres: earthRadius$2 * 100,
  kilometers: earthRadius$2 / 1e3,
  kilometres: earthRadius$2 / 1e3,
  miles: earthRadius$2 / 1609.344,
  nauticalmiles: earthRadius$2 / 1852,
  inches: earthRadius$2 * 39.37,
  yards: earthRadius$2 / 1.0936,
  feet: earthRadius$2 * 3.28084,
  radians: 1,
  degrees: earthRadius$2 / 111325
};
function feature$3(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$4(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox$2(bbox2);
  if (id)
    validateId$2(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function point$3(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be at least 2 numbers long");
  if (!isNumber$3(coordinates2[0]) || !isNumber$3(coordinates2[1]))
    throw new Error("coordinates must contain numbers");
  return feature$3({
    type: "Point",
    coordinates: coordinates2
  }, properties, options2);
}
function lineString$1(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be an array of two or more positions");
  if (!isNumber$3(coordinates2[0][1]) || !isNumber$3(coordinates2[0][1]))
    throw new Error("coordinates must contain numbers");
  return feature$3({
    type: "LineString",
    coordinates: coordinates2
  }, properties, options2);
}
function radiansToLength$1(radians2, units2) {
  if (radians2 === void 0 || radians2 === null)
    throw new Error("radians is required");
  if (units2 && typeof units2 !== "string")
    throw new Error("units must be a string");
  var factor = factors$2[units2 || "kilometers"];
  if (!factor)
    throw new Error(units2 + " units is invalid");
  return radians2 * factor;
}
function radiansToDegrees$2(radians2) {
  if (radians2 === null || radians2 === void 0)
    throw new Error("radians is required");
  var degrees2 = radians2 % (2 * Math.PI);
  return degrees2 * 180 / Math.PI;
}
function degreesToRadians$2(degrees2) {
  if (degrees2 === null || degrees2 === void 0)
    throw new Error("degrees is required");
  var radians2 = degrees2 % 360;
  return radians2 * Math.PI / 180;
}
function isNumber$3(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$4(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$2(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$3(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId$2(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function getCoord$2(coord) {
  if (!coord)
    throw new Error("coord is required");
  if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point")
    return coord.geometry.coordinates;
  if (coord.type === "Point")
    return coord.coordinates;
  if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === void 0 && coord[1].length === void 0)
    return coord;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function getCoords(coords) {
  if (!coords)
    throw new Error("coords is required");
  if (coords.type === "Feature" && coords.geometry !== null)
    return coords.geometry.coordinates;
  if (coords.coordinates)
    return coords.coordinates;
  if (Array.isArray(coords))
    return coords;
  throw new Error("coords must be GeoJSON Feature, Geometry Object or an Array");
}
function bearing$1(start2, end, options2) {
  options2 = options2 || {};
  if (!isObject$4(options2))
    throw new Error("options is invalid");
  var final = options2.final;
  if (final === true)
    return calculateFinalBearing$1(start2, end);
  var coordinates1 = getCoord$2(start2);
  var coordinates2 = getCoord$2(end);
  var lon1 = degreesToRadians$2(coordinates1[0]);
  var lon2 = degreesToRadians$2(coordinates2[0]);
  var lat1 = degreesToRadians$2(coordinates1[1]);
  var lat2 = degreesToRadians$2(coordinates2[1]);
  var a2 = Math.sin(lon2 - lon1) * Math.cos(lat2);
  var b2 = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
  return radiansToDegrees$2(Math.atan2(a2, b2));
}
function calculateFinalBearing$1(start2, end) {
  var bear = bearing$1(end, start2);
  bear = (bear + 180) % 360;
  return bear;
}
function distance$2(from, to, options2) {
  options2 = options2 || {};
  if (!isObject$4(options2))
    throw new Error("options is invalid");
  var units2 = options2.units;
  var coordinates1 = getCoord$2(from);
  var coordinates2 = getCoord$2(to);
  var dLat = degreesToRadians$2(coordinates2[1] - coordinates1[1]);
  var dLon = degreesToRadians$2(coordinates2[0] - coordinates1[0]);
  var lat1 = degreesToRadians$2(coordinates1[1]);
  var lat2 = degreesToRadians$2(coordinates2[1]);
  var a2 = Math.pow(Math.sin(dLat / 2), 2) + Math.pow(Math.sin(dLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
  return radiansToLength$1(2 * Math.atan2(Math.sqrt(a2), Math.sqrt(1 - a2)), units2);
}
var earthRadius$1 = 63710088e-1;
var factors$1 = {
  meters: earthRadius$1,
  metres: earthRadius$1,
  millimeters: earthRadius$1 * 1e3,
  millimetres: earthRadius$1 * 1e3,
  centimeters: earthRadius$1 * 100,
  centimetres: earthRadius$1 * 100,
  kilometers: earthRadius$1 / 1e3,
  kilometres: earthRadius$1 / 1e3,
  miles: earthRadius$1 / 1609.344,
  nauticalmiles: earthRadius$1 / 1852,
  inches: earthRadius$1 * 39.37,
  yards: earthRadius$1 / 1.0936,
  feet: earthRadius$1 * 3.28084,
  radians: 1,
  degrees: earthRadius$1 / 111325
};
function feature$2(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$3(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox$1(bbox2);
  if (id)
    validateId$1(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function point$2(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be at least 2 numbers long");
  if (!isNumber$2(coordinates2[0]) || !isNumber$2(coordinates2[1]))
    throw new Error("coordinates must contain numbers");
  return feature$2({
    type: "Point",
    coordinates: coordinates2
  }, properties, options2);
}
function lengthToRadians$1(distance11, units2) {
  if (distance11 === void 0 || distance11 === null)
    throw new Error("distance is required");
  if (units2 && typeof units2 !== "string")
    throw new Error("units must be a string");
  var factor = factors$1[units2 || "kilometers"];
  if (!factor)
    throw new Error(units2 + " units is invalid");
  return distance11 / factor;
}
function radiansToDegrees$1(radians2) {
  if (radians2 === null || radians2 === void 0)
    throw new Error("radians is required");
  var degrees2 = radians2 % (2 * Math.PI);
  return degrees2 * 180 / Math.PI;
}
function degreesToRadians$1(degrees2) {
  if (degrees2 === null || degrees2 === void 0)
    throw new Error("degrees is required");
  var radians2 = degrees2 % 360;
  return radians2 * Math.PI / 180;
}
function isNumber$2(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$3(input) {
  return !!input && input.constructor === Object;
}
function validateBBox$1(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$2(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId$1(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function getCoord$1(coord) {
  if (!coord)
    throw new Error("coord is required");
  if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point")
    return coord.geometry.coordinates;
  if (coord.type === "Point")
    return coord.coordinates;
  if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === void 0 && coord[1].length === void 0)
    return coord;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function destination$1(origin, distance11, bearing2, options2) {
  options2 = options2 || {};
  if (!isObject$3(options2))
    throw new Error("options is invalid");
  var units2 = options2.units;
  var properties = options2.properties;
  var coordinates1 = getCoord$1(origin);
  var longitude1 = degreesToRadians$1(coordinates1[0]);
  var latitude1 = degreesToRadians$1(coordinates1[1]);
  var bearing_rad = degreesToRadians$1(bearing2);
  var radians2 = lengthToRadians$1(distance11, units2);
  var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians2) + Math.cos(latitude1) * Math.sin(radians2) * Math.cos(bearing_rad));
  var longitude2 = longitude1 + Math.atan2(
    Math.sin(bearing_rad) * Math.sin(radians2) * Math.cos(latitude1),
    Math.cos(radians2) - Math.sin(latitude1) * Math.sin(latitude2)
  );
  var lng = radiansToDegrees$1(longitude2);
  var lat = radiansToDegrees$1(latitude2);
  return point$2([lng, lat], properties);
}
function geomEach(geojson, callback) {
  var i2, j2, g2, geometry2, stopG, geometryMaybeCollection, isGeometryCollection2, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature2 = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
  for (i2 = 0; i2 < stop; i2++) {
    geometryMaybeCollection = isFeatureCollection ? geojson.features[i2].geometry : isFeature2 ? geojson.geometry : geojson;
    featureProperties = isFeatureCollection ? geojson.features[i2].properties : isFeature2 ? geojson.properties : {};
    featureBBox = isFeatureCollection ? geojson.features[i2].bbox : isFeature2 ? geojson.bbox : void 0;
    featureId = isFeatureCollection ? geojson.features[i2].id : isFeature2 ? geojson.id : void 0;
    isGeometryCollection2 = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
    stopG = isGeometryCollection2 ? geometryMaybeCollection.geometries.length : 1;
    for (g2 = 0; g2 < stopG; g2++) {
      geometry2 = isGeometryCollection2 ? geometryMaybeCollection.geometries[g2] : geometryMaybeCollection;
      if (geometry2 === null) {
        if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false)
          return false;
        continue;
      }
      switch (geometry2.type) {
        case "Point":
        case "LineString":
        case "MultiPoint":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon": {
          if (callback(geometry2, featureIndex, featureProperties, featureBBox, featureId) === false)
            return false;
          break;
        }
        case "GeometryCollection": {
          for (j2 = 0; j2 < geometry2.geometries.length; j2++) {
            if (callback(geometry2.geometries[j2], featureIndex, featureProperties, featureBBox, featureId) === false)
              return false;
          }
          break;
        }
        default:
          throw new Error("Unknown Geometry Type");
      }
    }
    featureIndex++;
  }
}
function flattenEach(geojson, callback) {
  geomEach(geojson, function(geometry2, featureIndex, properties, bbox2, id) {
    var type = geometry2 === null ? null : geometry2.type;
    switch (type) {
      case null:
      case "Point":
      case "LineString":
      case "Polygon":
        if (callback(feature$3(geometry2, properties, { bbox: bbox2, id }), featureIndex, 0) === false)
          return false;
        return;
    }
    var geomType;
    switch (type) {
      case "MultiPoint":
        geomType = "Point";
        break;
      case "MultiLineString":
        geomType = "LineString";
        break;
      case "MultiPolygon":
        geomType = "Polygon";
        break;
    }
    for (var multiFeatureIndex = 0; multiFeatureIndex < geometry2.coordinates.length; multiFeatureIndex++) {
      var coordinate2 = geometry2.coordinates[multiFeatureIndex];
      var geom = {
        type: geomType,
        coordinates: coordinate2
      };
      if (callback(feature$3(geom, properties), featureIndex, multiFeatureIndex) === false)
        return false;
    }
  });
}
function nearestPointOnLine(lines, pt, options2) {
  options2 = options2 || {};
  if (!isObject$4(options2))
    throw new Error("options is invalid");
  var type = lines.geometry ? lines.geometry.type : lines.type;
  if (type !== "LineString" && type !== "MultiLineString") {
    throw new Error("lines must be LineString or MultiLineString");
  }
  var closestPt = point$3([Infinity, Infinity], {
    dist: Infinity
  });
  var length2 = 0;
  flattenEach(lines, function(line) {
    var coords = getCoords(line);
    for (var i2 = 0; i2 < coords.length - 1; i2++) {
      var start2 = point$3(coords[i2]);
      start2.properties.dist = distance$2(pt, start2, options2);
      var stop = point$3(coords[i2 + 1]);
      stop.properties.dist = distance$2(pt, stop, options2);
      var sectionLength = distance$2(start2, stop, options2);
      var heightDistance = Math.max(start2.properties.dist, stop.properties.dist);
      var direction = bearing$1(start2, stop);
      var perpendicularPt1 = destination$1(pt, heightDistance, direction + 90, options2);
      var perpendicularPt2 = destination$1(pt, heightDistance, direction - 90, options2);
      var intersect2 = lineIntersect(
        lineString$1([perpendicularPt1.geometry.coordinates, perpendicularPt2.geometry.coordinates]),
        lineString$1([start2.geometry.coordinates, stop.geometry.coordinates])
      );
      var intersectPt = null;
      if (intersect2.features.length > 0) {
        intersectPt = intersect2.features[0];
        intersectPt.properties.dist = distance$2(pt, intersectPt, options2);
        intersectPt.properties.location = length2 + distance$2(start2, intersectPt, options2);
      }
      if (start2.properties.dist < closestPt.properties.dist) {
        closestPt = start2;
        closestPt.properties.index = i2;
        closestPt.properties.location = length2;
      }
      if (stop.properties.dist < closestPt.properties.dist) {
        closestPt = stop;
        closestPt.properties.index = i2 + 1;
        closestPt.properties.location = length2 + sectionLength;
      }
      if (intersectPt && intersectPt.properties.dist < closestPt.properties.dist) {
        closestPt = intersectPt;
        closestPt.properties.index = i2;
      }
      length2 += sectionLength;
    }
  });
  return closestPt;
}
function getCoord(coord) {
  if (!coord)
    throw new Error("coord is required");
  if (coord.type === "Feature" && coord.geometry !== null && coord.geometry.type === "Point")
    return coord.geometry.coordinates;
  if (coord.type === "Point")
    return coord.coordinates;
  if (Array.isArray(coord) && coord.length >= 2 && coord[0].length === void 0 && coord[1].length === void 0)
    return coord;
  throw new Error("coord must be GeoJSON Point or an Array of numbers");
}
function bearing(start2, end, options2) {
  options2 = options2 || {};
  if (!isObject$8(options2))
    throw new Error("options is invalid");
  var final = options2.final;
  if (final === true)
    return calculateFinalBearing(start2, end);
  var coordinates1 = getCoord(start2);
  var coordinates2 = getCoord(end);
  var lon1 = degreesToRadians$3(coordinates1[0]);
  var lon2 = degreesToRadians$3(coordinates2[0]);
  var lat1 = degreesToRadians$3(coordinates1[1]);
  var lat2 = degreesToRadians$3(coordinates2[1]);
  var a2 = Math.sin(lon2 - lon1) * Math.cos(lat2);
  var b2 = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
  return radiansToDegrees$3(Math.atan2(a2, b2));
}
function calculateFinalBearing(start2, end) {
  var bear = bearing(end, start2);
  bear = (bear + 180) % 360;
  return bear;
}
function midpoint(point1, point22) {
  var dist2 = distance$3(point1, point22);
  var heading = bearing(point1, point22);
  var midpoint2 = destination$1(point1, dist2 / 2, heading);
  return midpoint2;
}
const IDS$2 = {
  VERTICAL_GUIDE: "VERTICAL_GUIDE",
  HORIZONTAL_GUIDE: "HORIZONTAL_GUIDE"
};
const addPointTovertices = (map5, vertices, coordinates2, forceInclusion) => {
  const { width: w2, height: h2 } = map5.getCanvas();
  const { x: x2, y: y2 } = map5.project(coordinates2);
  const pointIsOnTheScreen = x2 > 0 && x2 < w2 && y2 > 0 && y2 < h2;
  if (pointIsOnTheScreen || forceInclusion) {
    vertices.push(coordinates2);
  }
};
const createSnapList = (map5, draw, currentFeature) => {
  const features = draw.getAll().features;
  const snapList = [];
  const bboxAsPolygon = (() => {
    const canvas2 = map5.getCanvas(), w2 = canvas2.width, h2 = canvas2.height;
    map5.unproject([0, 0]).toArray();
    const cUR = map5.unproject([w2, 0]).toArray();
    map5.unproject([w2, h2]).toArray();
    const cLL = map5.unproject([0, h2]).toArray();
    return bboxPolygon$1([cLL, cUR].flat());
  })();
  const vertices = [];
  const addVerticesTovertices = (coordinates2, isCurrentFeature = false) => {
    if (!Array.isArray(coordinates2))
      throw Error("Your array is not an array");
    if (Array.isArray(coordinates2[0])) {
      coordinates2.forEach((coord) => {
        addVerticesTovertices(coord);
      });
    } else {
      if (coordinates2.length === 2) {
        addPointTovertices(map5, vertices, coordinates2, isCurrentFeature);
      }
    }
  };
  features.forEach((feature2) => {
    if (feature2.id === currentFeature.id) {
      if (currentFeature.type === geojsonTypes.POLYGON) {
        addVerticesTovertices(
          feature2.geometry.coordinates[0].slice(0, -2),
          true
        );
      }
      return;
    }
    if (feature2.id === IDS$2.HORIZONTAL_GUIDE || feature2.id === IDS$2.VERTICAL_GUIDE)
      return;
    addVerticesTovertices(feature2.geometry.coordinates);
    if (!booleanDisjoint(bboxAsPolygon, feature2)) {
      snapList.push(feature2);
    }
  });
  return [snapList, vertices];
};
const getNearbyvertices = (vertices, coords) => {
  const verticals = [];
  const horizontals = [];
  vertices.forEach((vertex2) => {
    verticals.push(vertex2[0]);
    horizontals.push(vertex2[1]);
  });
  const nearbyVerticalGuide = verticals.find(
    (px2) => Math.abs(px2 - coords.lng) < 9e-3
  );
  const nearbyHorizontalGuide = horizontals.find(
    (py2) => Math.abs(py2 - coords.lat) < 9e-3
  );
  return {
    verticalPx: nearbyVerticalGuide,
    horizontalPx: nearbyHorizontalGuide
  };
};
const calcLayerDistances = (lngLat, layer) => {
  const P2 = [lngLat.lng, lngLat.lat];
  const isMarker = layer.geometry.type === "Point";
  const isPolygon = layer.geometry.type === "Polygon";
  const isMultiPolygon = layer.geometry.type === "MultiPolygon";
  let lines = void 0;
  const latlngs = getCoords$1(layer);
  if (isMarker) {
    const [lng2, lat2] = latlngs;
    return {
      latlng: { lng: lng2, lat: lat2 },
      distance: distance$3(latlngs, P2)
    };
  }
  if (isPolygon || isMultiPolygon) {
    lines = polygonToLine(layer);
  } else {
    lines = layer;
  }
  let nearestPoint;
  if (isPolygon) {
    let lineStrings2;
    if (lines.geometry.type === "LineString") {
      lineStrings2 = [lineString$4(lines.geometry.coordinates)];
    } else {
      lineStrings2 = lines.geometry.coordinates.map(
        (coords) => lineString$4(coords)
      );
    }
    const closestFeature = getFeatureWithNearestPoint(lineStrings2, P2);
    lines = closestFeature.feature;
    nearestPoint = closestFeature.point;
  } else if (isMultiPolygon) {
    const lineStrings2 = lines.features.map((feat) => {
      if (feat.geometry.type === "LineString") {
        return [feat.geometry.coordinates];
      } else {
        return feat.geometry.coordinates;
      }
    }).flatMap((coords) => coords).map((coords) => lineString$4(coords));
    const closestFeature = getFeatureWithNearestPoint(lineStrings2, P2);
    lines = closestFeature.feature;
    nearestPoint = closestFeature.point;
  } else {
    nearestPoint = nearestPointOnLine(lines, P2);
  }
  const [lng, lat] = nearestPoint.geometry.coordinates;
  let segmentIndex = nearestPoint.properties.index;
  if (segmentIndex + 1 === lines.geometry.coordinates.length)
    segmentIndex--;
  return {
    latlng: { lng, lat },
    segment: lines.geometry.coordinates.slice(segmentIndex, segmentIndex + 2),
    distance: nearestPoint.properties.dist,
    isMarker
  };
};
function getFeatureWithNearestPoint(lineStrings2, P2) {
  const nearestPointsOfEachFeature = lineStrings2.map((feat) => ({
    feature: feat,
    point: nearestPointOnLine(feat, P2)
  }));
  nearestPointsOfEachFeature.sort(
    (a2, b2) => a2.point.properties.dist - b2.point.properties.dist
  );
  return {
    feature: nearestPointsOfEachFeature[0].feature,
    point: nearestPointsOfEachFeature[0].point
  };
}
const calcClosestLayer = (lngLat, layers) => {
  let closestLayer = {};
  layers.forEach((layer, index2) => {
    const results = calcLayerDistances(lngLat, layer);
    if (closestLayer.distance === void 0 || results.distance < closestLayer.distance) {
      closestLayer = results;
      closestLayer.layer = layer;
    }
  });
  return closestLayer;
};
const metersPerPixel = function(latitude, zoomLevel) {
  const earthCircumference = 40075017;
  const latitudeRadians = latitude * (Math.PI / 180);
  return earthCircumference * Math.cos(latitudeRadians) / Math.pow(2, zoomLevel + 8);
};
function snapToLineOrPolygon(closestLayer, snapOptions, snapVertexPriorityDistance) {
  const A2 = closestLayer.segment[0];
  const B2 = closestLayer.segment[1];
  const C2 = [closestLayer.latlng.lng, closestLayer.latlng.lat];
  const distanceAC = distance$3(A2, C2);
  const distanceBC = distance$3(B2, C2);
  let closestVertexLatLng = distanceAC < distanceBC ? A2 : B2;
  let shortestDistance = distanceAC < distanceBC ? distanceAC : distanceBC;
  if (snapOptions && snapOptions.snapToMidPoints) {
    const M2 = midpoint(A2, B2).geometry.coordinates;
    const distanceMC = distance$3(M2, C2);
    if (distanceMC < distanceAC && distanceMC < distanceBC) {
      closestVertexLatLng = M2;
      shortestDistance = distanceMC;
    }
  }
  const priorityDistance = snapVertexPriorityDistance;
  let snapLatlng;
  if (shortestDistance < priorityDistance) {
    snapLatlng = closestVertexLatLng;
  } else {
    snapLatlng = C2;
  }
  const [lng, lat] = snapLatlng;
  return { lng, lat };
}
function snapToPoint(closestLayer) {
  return closestLayer.latlng;
}
const checkPrioritiySnapping = (closestLayer, snapOptions, snapVertexPriorityDistance = 1.25) => {
  let snappingToPoint = !Array.isArray(closestLayer.segment);
  if (snappingToPoint) {
    return snapToPoint(closestLayer);
  } else {
    return snapToLineOrPolygon(closestLayer, snapOptions, snapVertexPriorityDistance);
  }
};
const snap = (state, e3) => {
  let lng = e3.lngLat.lng;
  let lat = e3.lngLat.lat;
  if (e3.originalEvent.altKey) {
    state.showVerticalSnapLine = false;
    state.showHorizontalSnapLine = false;
    return { lng, lat };
  }
  if (state.snapList.length <= 0) {
    return { lng, lat };
  }
  let closestLayer, minDistance, snapLatLng;
  if (state.options.snap) {
    closestLayer = calcClosestLayer({ lng, lat }, state.snapList);
    if (Object.keys(closestLayer).length === 0) {
      return false;
    }
    const isMarker = closestLayer.isMarker;
    const snapVertexPriorityDistance = state.options.snapOptions ? state.options.snapOptions.snapVertexPriorityDistance : void 0;
    if (!isMarker) {
      snapLatLng = checkPrioritiySnapping(
        closestLayer,
        state.options.snapOptions,
        snapVertexPriorityDistance
      );
    } else {
      snapLatLng = closestLayer.latlng;
    }
    minDistance = (state.options.snapOptions && state.options.snapOptions.snapPx || 15) * metersPerPixel(snapLatLng.lat, state.map.getZoom());
  }
  let verticalPx, horizontalPx;
  if (state.options.guides) {
    const nearestGuidline = getNearbyvertices(state.vertices, e3.lngLat);
    verticalPx = nearestGuidline.verticalPx;
    horizontalPx = nearestGuidline.horizontalPx;
    if (verticalPx) {
      const lngLatTop = { lng: verticalPx, lat: e3.lngLat.lat + 10 };
      const lngLatBottom = { lng: verticalPx, lat: e3.lngLat.lat - 10 };
      state.verticalGuide.updateCoordinate(0, lngLatTop.lng, lngLatTop.lat);
      state.verticalGuide.updateCoordinate(
        1,
        lngLatBottom.lng,
        lngLatBottom.lat
      );
    }
    if (horizontalPx) {
      const lngLatTop = { lng: e3.lngLat.lng + 10, lat: horizontalPx };
      const lngLatBottom = { lng: e3.lngLat.lng - 10, lat: horizontalPx };
      state.horizontalGuide.updateCoordinate(0, lngLatTop.lng, lngLatTop.lat);
      state.horizontalGuide.updateCoordinate(
        1,
        lngLatBottom.lng,
        lngLatBottom.lat
      );
    }
    state.showVerticalSnapLine = !!verticalPx;
    state.showHorizontalSnapLine = !!horizontalPx;
  }
  if (closestLayer && closestLayer.distance * 1e3 < minDistance) {
    return snapLatLng;
  } else if (verticalPx || horizontalPx) {
    if (verticalPx) {
      lng = verticalPx;
    }
    if (horizontalPx) {
      lat = horizontalPx;
    }
    return { lng, lat };
  } else {
    return { lng, lat };
  }
};
const getGuideFeature = (id) => ({
  id,
  type: geojsonTypes.FEATURE,
  properties: {
    isSnapGuide: "true"
    // for styling
  },
  geometry: {
    type: geojsonTypes.LINE_STRING,
    coordinates: []
  }
});
const shouldHideGuide = (state, geojson) => {
  if (geojson.properties.id === IDS$2.VERTICAL_GUIDE && (!state.options.guides || !state.showVerticalSnapLine)) {
    return true;
  }
  if (geojson.properties.id === IDS$2.HORIZONTAL_GUIDE && (!state.options.guides || !state.showHorizontalSnapLine)) {
    return true;
  }
  return false;
};
const SnapPointMode = { ...DrawPoint$1 };
SnapPointMode.onSetup = function(options2) {
  const point4 = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.POINT,
      coordinates: [[]]
    }
  });
  const verticalGuide = this.newFeature(getGuideFeature(IDS$2.VERTICAL_GUIDE));
  const horizontalGuide = this.newFeature(
    getGuideFeature(IDS$2.HORIZONTAL_GUIDE)
  );
  this.addFeature(point4);
  this.addFeature(verticalGuide);
  this.addFeature(horizontalGuide);
  const selectedFeatures = this.getSelected();
  this.clearSelectedFeatures();
  doubleClickZoom$8.disable(this);
  const [snapList, vertices] = createSnapList(this.map, this._ctx.api, point4);
  const state = {
    map: this.map,
    point: point4,
    vertices,
    snapList,
    selectedFeatures,
    verticalGuide,
    horizontalGuide
  };
  state.options = this._ctx.options;
  const moveendCallback = () => {
    const [snapList2, vertices2] = createSnapList(this.map, this._ctx.api, point4);
    state.vertices = vertices2;
    state.snapList = snapList2;
  };
  state["moveendCallback"] = moveendCallback;
  const optionsChangedCallBAck = (options3) => {
    state.options = options3;
  };
  state["optionsChangedCallBAck"] = optionsChangedCallBAck;
  this.map.on("moveend", moveendCallback);
  this.map.on("draw.snap.options_changed", optionsChangedCallBAck);
  return state;
};
SnapPointMode.onClick = function(state) {
  DrawPoint$1.onClick.call(this, state, {
    lngLat: {
      lng: state.snappedLng,
      lat: state.snappedLat
    }
  });
};
SnapPointMode.onMouseMove = function(state, e3) {
  const { lng, lat } = snap(state, e3);
  state.snappedLng = lng;
  state.snappedLat = lat;
  if (state.lastVertex && state.lastVertex[0] === lng && state.lastVertex[1] === lat) {
    this.updateUIClasses({ mouse: cursors.POINTER });
  } else {
    this.updateUIClasses({ mouse: cursors.ADD });
  }
};
SnapPointMode.toDisplayFeatures = function(state, geojson, display) {
  if (shouldHideGuide(state, geojson))
    return;
  DrawPoint$1.toDisplayFeatures(state, geojson, display);
};
SnapPointMode.onStop = function(state) {
  this.deleteFeature(IDS$2.VERTICAL_GUIDE, { silent: true });
  this.deleteFeature(IDS$2.HORIZONTAL_GUIDE, { silent: true });
  this.map.off("moveend", state.moveendCallback);
  DrawPoint$1.onStop.call(this, state);
};
const SnapLineMode = { ...DrawLineString$1 };
SnapLineMode.onSetup = function(options2) {
  const line = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.LINE_STRING,
      coordinates: [[]]
    }
  });
  const verticalGuide = this.newFeature(getGuideFeature(IDS$2.VERTICAL_GUIDE));
  const horizontalGuide = this.newFeature(
    getGuideFeature(IDS$2.HORIZONTAL_GUIDE)
  );
  this.addFeature(line);
  this.addFeature(verticalGuide);
  this.addFeature(horizontalGuide);
  const selectedFeatures = this.getSelected();
  this.clearSelectedFeatures();
  doubleClickZoom$8.disable(this);
  const [snapList, vertices] = createSnapList(this.map, this._ctx.api, line);
  const state = {
    map: this.map,
    line,
    currentVertexPosition: 0,
    vertices,
    snapList,
    selectedFeatures,
    verticalGuide,
    horizontalGuide,
    direction: "forward"
    // expected by DrawLineString
  };
  state.options = this._ctx.options;
  const moveendCallback = () => {
    const [snapList2, vertices2] = createSnapList(this.map, this._ctx.api, line);
    state.vertices = vertices2;
    state.snapList = snapList2;
  };
  state["moveendCallback"] = moveendCallback;
  const optionsChangedCallBAck = (options3) => {
    state.options = options3;
  };
  state["optionsChangedCallBAck"] = optionsChangedCallBAck;
  this.map.on("moveend", moveendCallback);
  this.map.on("draw.snap.options_changed", optionsChangedCallBAck);
  return state;
};
SnapLineMode.onClick = function(state) {
  const lng = state.snappedLng;
  const lat = state.snappedLat;
  if (state.currentVertexPosition > 0) {
    const lastVertex = state.line.coordinates[state.currentVertexPosition - 1];
    state.lastVertex = lastVertex;
    if (lastVertex[0] === lng && lastVertex[1] === lat) {
      return this.changeMode(modes$2.SIMPLE_SELECT, {
        featureIds: [state.line.id]
      });
    }
  }
  addPointTovertices(state.map, state.vertices, { lng, lat });
  state.line.updateCoordinate(state.currentVertexPosition, lng, lat);
  state.currentVertexPosition++;
  state.line.updateCoordinate(state.currentVertexPosition, lng, lat);
};
SnapLineMode.onMouseMove = function(state, e3) {
  const { lng, lat } = snap(state, e3);
  state.line.updateCoordinate(state.currentVertexPosition, lng, lat);
  state.snappedLng = lng;
  state.snappedLat = lat;
  if (state.lastVertex && state.lastVertex[0] === lng && state.lastVertex[1] === lat) {
    this.updateUIClasses({ mouse: cursors.POINTER });
  } else {
    this.updateUIClasses({ mouse: cursors.ADD });
  }
};
SnapLineMode.toDisplayFeatures = function(state, geojson, display) {
  if (shouldHideGuide(state, geojson))
    return;
  DrawLineString$1.toDisplayFeatures(state, geojson, display);
};
SnapLineMode.onStop = function(state) {
  this.deleteFeature(IDS$2.VERTICAL_GUIDE, { silent: true });
  this.deleteFeature(IDS$2.HORIZONTAL_GUIDE, { silent: true });
  this.map.off("moveend", state.moveendCallback);
  DrawLineString$1.onStop.call(this, state);
};
const SnapPolygonMode = { ...DrawPolygon$1 };
SnapPolygonMode.onSetup = function(options2) {
  const polygon4 = this.newFeature({
    type: geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: geojsonTypes.POLYGON,
      coordinates: [[]]
    }
  });
  const verticalGuide = this.newFeature(getGuideFeature(IDS$2.VERTICAL_GUIDE));
  const horizontalGuide = this.newFeature(
    getGuideFeature(IDS$2.HORIZONTAL_GUIDE)
  );
  this.addFeature(polygon4);
  this.addFeature(verticalGuide);
  this.addFeature(horizontalGuide);
  const selectedFeatures = this.getSelected();
  this.clearSelectedFeatures();
  doubleClickZoom$8.disable(this);
  const [snapList, vertices] = createSnapList(this.map, this._ctx.api, polygon4);
  const state = {
    map: this.map,
    polygon: polygon4,
    currentVertexPosition: 0,
    vertices,
    snapList,
    selectedFeatures,
    verticalGuide,
    horizontalGuide
  };
  state.options = this._ctx.options;
  const moveendCallback = () => {
    const [snapList2, vertices2] = createSnapList(
      this.map,
      this._ctx.api,
      polygon4
    );
    state.vertices = vertices2;
    state.snapList = snapList2;
  };
  state["moveendCallback"] = moveendCallback;
  const optionsChangedCallBAck = (options3) => {
    state.options = options3;
  };
  state["optionsChangedCallBAck"] = optionsChangedCallBAck;
  this.map.on("moveend", moveendCallback);
  this.map.on("draw.snap.options_changed", optionsChangedCallBAck);
  return state;
};
SnapPolygonMode.onClick = function(state) {
  const lng = state.snappedLng;
  const lat = state.snappedLat;
  if (state.currentVertexPosition > 0) {
    const lastVertex = state.polygon.coordinates[0][state.currentVertexPosition - 1];
    state.lastVertex = lastVertex;
    if (lastVertex[0] === lng && lastVertex[1] === lat) {
      return this.changeMode(modes$2.SIMPLE_SELECT, {
        featureIds: [state.polygon.id]
      });
    }
  }
  addPointTovertices(state.map, state.vertices, { lng, lat });
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, lng, lat);
  state.currentVertexPosition++;
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, lng, lat);
};
SnapPolygonMode.onMouseMove = function(state, e3) {
  const { lng, lat } = snap(state, e3);
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, lng, lat);
  state.snappedLng = lng;
  state.snappedLat = lat;
  if (state.lastVertex && state.lastVertex[0] === lng && state.lastVertex[1] === lat) {
    this.updateUIClasses({ mouse: cursors.POINTER });
  } else {
    this.updateUIClasses({ mouse: cursors.ADD });
  }
};
SnapPolygonMode.toDisplayFeatures = function(state, geojson, display) {
  if (shouldHideGuide(state, geojson))
    return;
  DrawPolygon$1.toDisplayFeatures(state, geojson, display);
};
SnapPolygonMode.onStop = function(state) {
  this.deleteFeature(IDS$2.VERTICAL_GUIDE, { silent: true });
  this.deleteFeature(IDS$2.HORIZONTAL_GUIDE, { silent: true });
  this.map.off("moveend", state.moveendCallback);
  this.map.off("draw.snap.options_changed", state.optionsChangedCallBAck);
  DrawPolygon$1.onStop.call(this, state);
};
({ ...DirectSelect$1 });
const modifiedDefaultStyles = theme$1.map((defaultStyle2) => {
  if (defaultStyle2.id === "gl-draw-line-inactive") {
    return {
      ...defaultStyle2,
      filter: [
        ...defaultStyle2.filter,
        ["!=", "user_isSnapGuide", "true"]
      ]
    };
  }
  return defaultStyle2;
});
const customDrawStyles = [
  ...modifiedDefaultStyles,
  {
    id: "guide",
    type: "line",
    filter: [
      "all",
      ["==", "$type", "LineString"],
      ["==", "user_isSnapGuide", "true"]
    ],
    layout: {
      "line-cap": "round",
      "line-join": "round"
    },
    paint: {
      "line-color": "#c00c00",
      "line-width": 1,
      "line-dasharray": [5, 5]
    }
  }
];
var mapboxGlDrawExports = {};
var mapboxGlDraw = {
  get exports() {
    return mapboxGlDrawExports;
  },
  set exports(v5) {
    mapboxGlDrawExports = v5;
  }
};
const ModeHandler = function(mode2, DrawContext) {
  const handlers2 = {
    drag: [],
    click: [],
    mousemove: [],
    mousedown: [],
    mouseup: [],
    mouseout: [],
    keydown: [],
    keyup: [],
    touchstart: [],
    touchmove: [],
    touchend: [],
    tap: []
  };
  const ctx2 = {
    on: function(event, selector, fn2) {
      if (handlers2[event] === void 0) {
        throw new Error(`Invalid event type: ${event}`);
      }
      handlers2[event].push({
        selector,
        fn: fn2
      });
    },
    render: function(id) {
      DrawContext.store.featureChanged(id);
    }
  };
  const delegate = function(eventName, event) {
    const handles = handlers2[eventName];
    let iHandle = handles.length;
    while (iHandle--) {
      const handle = handles[iHandle];
      if (handle.selector(event)) {
        handle.fn.call(ctx2, event);
        DrawContext.store.render();
        DrawContext.ui.updateMapClasses();
        break;
      }
    }
  };
  mode2.start.call(ctx2);
  return {
    render: mode2.render,
    stop: function() {
      if (mode2.stop)
        mode2.stop();
    },
    trash: function() {
      if (mode2.trash) {
        mode2.trash();
        DrawContext.store.render();
      }
    },
    combineFeatures: function() {
      if (mode2.combineFeatures) {
        mode2.combineFeatures();
      }
    },
    uncombineFeatures: function() {
      if (mode2.uncombineFeatures) {
        mode2.uncombineFeatures();
      }
    },
    drag: function(event) {
      delegate("drag", event);
    },
    click: function(event) {
      delegate("click", event);
    },
    mousemove: function(event) {
      delegate("mousemove", event);
    },
    mousedown: function(event) {
      delegate("mousedown", event);
    },
    mouseup: function(event) {
      delegate("mouseup", event);
    },
    mouseout: function(event) {
      delegate("mouseout", event);
    },
    keydown: function(event) {
      delegate("keydown", event);
    },
    keyup: function(event) {
      delegate("keyup", event);
    },
    touchstart: function(event) {
      delegate("touchstart", event);
    },
    touchmove: function(event) {
      delegate("touchmove", event);
    },
    touchend: function(event) {
      delegate("touchend", event);
    },
    tap: function(event) {
      delegate("tap", event);
    }
  };
};
var mode_handler = ModeHandler;
var constants$6 = {
  classes: {
    CONTROL_BASE: "mapboxgl-ctrl",
    CONTROL_PREFIX: "mapboxgl-ctrl-",
    CONTROL_BUTTON: "mapbox-gl-draw_ctrl-draw-btn",
    CONTROL_BUTTON_LINE: "mapbox-gl-draw_line",
    CONTROL_BUTTON_POLYGON: "mapbox-gl-draw_polygon",
    CONTROL_BUTTON_POINT: "mapbox-gl-draw_point",
    CONTROL_BUTTON_TRASH: "mapbox-gl-draw_trash",
    CONTROL_BUTTON_COMBINE_FEATURES: "mapbox-gl-draw_combine",
    CONTROL_BUTTON_UNCOMBINE_FEATURES: "mapbox-gl-draw_uncombine",
    CONTROL_GROUP: "mapboxgl-ctrl-group",
    ATTRIBUTION: "mapboxgl-ctrl-attrib",
    ACTIVE_BUTTON: "active",
    BOX_SELECT: "mapbox-gl-draw_boxselect"
  },
  sources: {
    HOT: "mapbox-gl-draw-hot",
    COLD: "mapbox-gl-draw-cold"
  },
  cursors: {
    ADD: "add",
    MOVE: "move",
    DRAG: "drag",
    POINTER: "pointer",
    NONE: "none"
  },
  types: {
    POLYGON: "polygon",
    LINE: "line_string",
    POINT: "point"
  },
  geojsonTypes: {
    FEATURE: "Feature",
    POLYGON: "Polygon",
    LINE_STRING: "LineString",
    POINT: "Point",
    FEATURE_COLLECTION: "FeatureCollection",
    MULTI_PREFIX: "Multi",
    MULTI_POINT: "MultiPoint",
    MULTI_LINE_STRING: "MultiLineString",
    MULTI_POLYGON: "MultiPolygon"
  },
  modes: {
    DRAW_LINE_STRING: "draw_line_string",
    DRAW_POLYGON: "draw_polygon",
    DRAW_POINT: "draw_point",
    SIMPLE_SELECT: "simple_select",
    DIRECT_SELECT: "direct_select",
    STATIC: "static"
  },
  events: {
    CREATE: "draw.create",
    DELETE: "draw.delete",
    UPDATE: "draw.update",
    SELECTION_CHANGE: "draw.selectionchange",
    MODE_CHANGE: "draw.modechange",
    ACTIONABLE: "draw.actionable",
    RENDER: "draw.render",
    COMBINE_FEATURES: "draw.combine",
    UNCOMBINE_FEATURES: "draw.uncombine"
  },
  updateActions: {
    MOVE: "move",
    CHANGE_COORDINATES: "change_coordinates"
  },
  meta: {
    FEATURE: "feature",
    MIDPOINT: "midpoint",
    VERTEX: "vertex"
  },
  activeStates: {
    ACTIVE: "true",
    INACTIVE: "false"
  },
  interactions: [
    "scrollZoom",
    "boxZoom",
    "dragRotate",
    "dragPan",
    "keyboard",
    "doubleClickZoom",
    "touchZoomRotate"
  ],
  LAT_MIN: -90,
  LAT_RENDERED_MIN: -85,
  LAT_MAX: 90,
  LAT_RENDERED_MAX: 85,
  LNG_MIN: -270,
  LNG_MAX: 270
};
const area = geojsonArea;
const Constants$r = constants$6;
const FEATURE_SORT_RANKS = {
  Point: 0,
  LineString: 1,
  Polygon: 2
};
function comparator(a2, b2) {
  const score = FEATURE_SORT_RANKS[a2.geometry.type] - FEATURE_SORT_RANKS[b2.geometry.type];
  if (score === 0 && a2.geometry.type === Constants$r.geojsonTypes.POLYGON) {
    return a2.area - b2.area;
  }
  return score;
}
function sortFeatures$1(features) {
  return features.map((feature2) => {
    if (feature2.geometry.type === Constants$r.geojsonTypes.POLYGON) {
      feature2.area = area.geometry({
        type: Constants$r.geojsonTypes.FEATURE,
        property: {},
        geometry: feature2.geometry
      });
    }
    return feature2;
  }).sort(comparator).map((feature2) => {
    delete feature2.area;
    return feature2;
  });
}
var sort_features = sortFeatures$1;
function mapEventToBoundingBox$1(mapEvent, buffer3 = 0) {
  return [
    [mapEvent.point.x - buffer3, mapEvent.point.y - buffer3],
    [mapEvent.point.x + buffer3, mapEvent.point.y + buffer3]
  ];
}
var map_event_to_bounding_box = mapEventToBoundingBox$1;
function StringSet$4(items) {
  this._items = {};
  this._nums = {};
  this._length = items ? items.length : 0;
  if (!items)
    return;
  for (let i2 = 0, l2 = items.length; i2 < l2; i2++) {
    this.add(items[i2]);
    if (items[i2] === void 0)
      continue;
    if (typeof items[i2] === "string")
      this._items[items[i2]] = i2;
    else
      this._nums[items[i2]] = i2;
  }
}
StringSet$4.prototype.add = function(x2) {
  if (this.has(x2))
    return this;
  this._length++;
  if (typeof x2 === "string")
    this._items[x2] = this._length;
  else
    this._nums[x2] = this._length;
  return this;
};
StringSet$4.prototype.delete = function(x2) {
  if (this.has(x2) === false)
    return this;
  this._length--;
  delete this._items[x2];
  delete this._nums[x2];
  return this;
};
StringSet$4.prototype.has = function(x2) {
  if (typeof x2 !== "string" && typeof x2 !== "number")
    return false;
  return this._items[x2] !== void 0 || this._nums[x2] !== void 0;
};
StringSet$4.prototype.values = function() {
  const values4 = [];
  Object.keys(this._items).forEach((k2) => {
    values4.push({ k: k2, v: this._items[k2] });
  });
  Object.keys(this._nums).forEach((k2) => {
    values4.push({ k: JSON.parse(k2), v: this._nums[k2] });
  });
  return values4.sort((a2, b2) => a2.v - b2.v).map((a2) => a2.k);
};
StringSet$4.prototype.clear = function() {
  this._length = 0;
  this._items = {};
  this._nums = {};
  return this;
};
var string_set = StringSet$4;
const sortFeatures = sort_features;
const mapEventToBoundingBox = map_event_to_bounding_box;
const Constants$q = constants$6;
const StringSet$3 = string_set;
const META_TYPES = [
  Constants$q.meta.FEATURE,
  Constants$q.meta.MIDPOINT,
  Constants$q.meta.VERTEX
];
var features_at = {
  click: featuresAtClick,
  touch: featuresAtTouch
};
function featuresAtClick(event, bbox2, ctx2) {
  return featuresAt$4(event, bbox2, ctx2, ctx2.options.clickBuffer);
}
function featuresAtTouch(event, bbox2, ctx2) {
  return featuresAt$4(event, bbox2, ctx2, ctx2.options.touchBuffer);
}
function featuresAt$4(event, bbox2, ctx2, buffer3) {
  if (ctx2.map === null)
    return [];
  const box = event ? mapEventToBoundingBox(event, buffer3) : bbox2;
  const queryParams = {};
  if (ctx2.options.styles)
    queryParams.layers = ctx2.options.styles.map((s2) => s2.id);
  const features = ctx2.map.queryRenderedFeatures(box, queryParams).filter((feature2) => {
    return META_TYPES.indexOf(feature2.properties.meta) !== -1;
  });
  const featureIds = new StringSet$3();
  const uniqueFeatures = [];
  features.forEach((feature2) => {
    const featureId = feature2.properties.id;
    if (featureIds.has(featureId))
      return;
    featureIds.add(featureId);
    uniqueFeatures.push(feature2);
  });
  return sortFeatures(uniqueFeatures);
}
const featuresAt$3 = features_at;
const Constants$p = constants$6;
var get_features_and_set_cursor = function getFeatureAtAndSetCursors2(event, ctx2) {
  const features = featuresAt$3.click(event, null, ctx2);
  const classes2 = { mouse: Constants$p.cursors.NONE };
  if (features[0]) {
    classes2.mouse = features[0].properties.active === Constants$p.activeStates.ACTIVE ? Constants$p.cursors.MOVE : Constants$p.cursors.POINTER;
    classes2.feature = features[0].properties.meta;
  }
  if (ctx2.events.currentModeName().indexOf("draw") !== -1) {
    classes2.mouse = Constants$p.cursors.ADD;
  }
  ctx2.ui.queueMapClasses(classes2);
  ctx2.ui.updateMapClasses();
  return features[0];
};
var euclidean_distance = function(a2, b2) {
  const x2 = a2.x - b2.x;
  const y2 = a2.y - b2.y;
  return Math.sqrt(x2 * x2 + y2 * y2);
};
const euclideanDistance$1 = euclidean_distance;
const FINE_TOLERANCE = 4;
const GROSS_TOLERANCE = 12;
const INTERVAL$1 = 500;
var is_click = function isClick2(start2, end, options2 = {}) {
  const fineTolerance = options2.fineTolerance != null ? options2.fineTolerance : FINE_TOLERANCE;
  const grossTolerance = options2.grossTolerance != null ? options2.grossTolerance : GROSS_TOLERANCE;
  const interval = options2.interval != null ? options2.interval : INTERVAL$1;
  start2.point = start2.point || end.point;
  start2.time = start2.time || end.time;
  const moveDistance = euclideanDistance$1(start2.point, end.point);
  return moveDistance < fineTolerance || moveDistance < grossTolerance && end.time - start2.time < interval;
};
const euclideanDistance = euclidean_distance;
const TOLERANCE = 25;
const INTERVAL = 250;
var is_tap = function isTap2(start2, end, options2 = {}) {
  const tolerance = options2.tolerance != null ? options2.tolerance : TOLERANCE;
  const interval = options2.interval != null ? options2.interval : INTERVAL;
  start2.point = start2.point || end.point;
  start2.time = start2.time || end.time;
  const moveDistance = euclideanDistance(start2.point, end.point);
  return moveDistance < tolerance && end.time - start2.time < interval;
};
var mode_interfaceExports = {};
var mode_interface = {
  get exports() {
    return mode_interfaceExports;
  },
  set exports(v5) {
    mode_interfaceExports = v5;
  }
};
var mode_interface_accessorsExports = {};
var mode_interface_accessors = {
  get exports() {
    return mode_interface_accessorsExports;
  },
  set exports(v5) {
    mode_interface_accessorsExports = v5;
  }
};
const hat$2 = hatExports;
const Constants$o = constants$6;
const Feature$4 = function(ctx2, geojson) {
  this.ctx = ctx2;
  this.properties = geojson.properties || {};
  this.coordinates = geojson.geometry.coordinates;
  this.id = geojson.id || hat$2();
  this.type = geojson.geometry.type;
};
Feature$4.prototype.changed = function() {
  this.ctx.store.featureChanged(this.id);
};
Feature$4.prototype.incomingCoords = function(coords) {
  this.setCoordinates(coords);
};
Feature$4.prototype.setCoordinates = function(coords) {
  this.coordinates = coords;
  this.changed();
};
Feature$4.prototype.getCoordinates = function() {
  return JSON.parse(JSON.stringify(this.coordinates));
};
Feature$4.prototype.setProperty = function(property2, value) {
  this.properties[property2] = value;
};
Feature$4.prototype.toGeoJSON = function() {
  return JSON.parse(JSON.stringify({
    id: this.id,
    type: Constants$o.geojsonTypes.FEATURE,
    properties: this.properties,
    geometry: {
      coordinates: this.getCoordinates(),
      type: this.type
    }
  }));
};
Feature$4.prototype.internal = function(mode2) {
  const properties = {
    id: this.id,
    meta: Constants$o.meta.FEATURE,
    "meta:type": this.type,
    active: Constants$o.activeStates.INACTIVE,
    mode: mode2
  };
  if (this.ctx.options.userProperties) {
    for (const name2 in this.properties) {
      properties[`user_${name2}`] = this.properties[name2];
    }
  }
  return {
    type: Constants$o.geojsonTypes.FEATURE,
    properties,
    geometry: {
      coordinates: this.getCoordinates(),
      type: this.type
    }
  };
};
var feature$1 = Feature$4;
const Feature$3 = feature$1;
const Point$2 = function(ctx2, geojson) {
  Feature$3.call(this, ctx2, geojson);
};
Point$2.prototype = Object.create(Feature$3.prototype);
Point$2.prototype.isValid = function() {
  return typeof this.coordinates[0] === "number" && typeof this.coordinates[1] === "number";
};
Point$2.prototype.updateCoordinate = function(pathOrLng, lngOrLat, lat) {
  if (arguments.length === 3) {
    this.coordinates = [lngOrLat, lat];
  } else {
    this.coordinates = [pathOrLng, lngOrLat];
  }
  this.changed();
};
Point$2.prototype.getCoordinate = function() {
  return this.getCoordinates();
};
var point$1 = Point$2;
const Feature$2 = feature$1;
const LineString$1 = function(ctx2, geojson) {
  Feature$2.call(this, ctx2, geojson);
};
LineString$1.prototype = Object.create(Feature$2.prototype);
LineString$1.prototype.isValid = function() {
  return this.coordinates.length > 1;
};
LineString$1.prototype.addCoordinate = function(path2, lng, lat) {
  this.changed();
  const id = parseInt(path2, 10);
  this.coordinates.splice(id, 0, [lng, lat]);
};
LineString$1.prototype.getCoordinate = function(path2) {
  const id = parseInt(path2, 10);
  return JSON.parse(JSON.stringify(this.coordinates[id]));
};
LineString$1.prototype.removeCoordinate = function(path2) {
  this.changed();
  this.coordinates.splice(parseInt(path2, 10), 1);
};
LineString$1.prototype.updateCoordinate = function(path2, lng, lat) {
  const id = parseInt(path2, 10);
  this.coordinates[id] = [lng, lat];
  this.changed();
};
var line_string = LineString$1;
const Feature$1 = feature$1;
const Polygon$1 = function(ctx2, geojson) {
  Feature$1.call(this, ctx2, geojson);
  this.coordinates = this.coordinates.map((ring) => ring.slice(0, -1));
};
Polygon$1.prototype = Object.create(Feature$1.prototype);
Polygon$1.prototype.isValid = function() {
  if (this.coordinates.length === 0)
    return false;
  return this.coordinates.every((ring) => ring.length > 2);
};
Polygon$1.prototype.incomingCoords = function(coords) {
  this.coordinates = coords.map((ring) => ring.slice(0, -1));
  this.changed();
};
Polygon$1.prototype.setCoordinates = function(coords) {
  this.coordinates = coords;
  this.changed();
};
Polygon$1.prototype.addCoordinate = function(path2, lng, lat) {
  this.changed();
  const ids = path2.split(".").map((x2) => parseInt(x2, 10));
  const ring = this.coordinates[ids[0]];
  ring.splice(ids[1], 0, [lng, lat]);
};
Polygon$1.prototype.removeCoordinate = function(path2) {
  this.changed();
  const ids = path2.split(".").map((x2) => parseInt(x2, 10));
  const ring = this.coordinates[ids[0]];
  if (ring) {
    ring.splice(ids[1], 1);
    if (ring.length < 3) {
      this.coordinates.splice(ids[0], 1);
    }
  }
};
Polygon$1.prototype.getCoordinate = function(path2) {
  const ids = path2.split(".").map((x2) => parseInt(x2, 10));
  const ring = this.coordinates[ids[0]];
  return JSON.parse(JSON.stringify(ring[ids[1]]));
};
Polygon$1.prototype.getCoordinates = function() {
  return this.coordinates.map((coords) => coords.concat([coords[0]]));
};
Polygon$1.prototype.updateCoordinate = function(path2, lng, lat) {
  this.changed();
  const parts = path2.split(".");
  const ringId = parseInt(parts[0], 10);
  const coordId = parseInt(parts[1], 10);
  if (this.coordinates[ringId] === void 0) {
    this.coordinates[ringId] = [];
  }
  this.coordinates[ringId][coordId] = [lng, lat];
};
var polygon$1 = Polygon$1;
const Feature = feature$1;
const Constants$n = constants$6;
const hat$1 = hatExports;
const models = {
  MultiPoint: point$1,
  MultiLineString: line_string,
  MultiPolygon: polygon$1
};
const takeAction = (features, action, path2, lng, lat) => {
  const parts = path2.split(".");
  const idx = parseInt(parts[0], 10);
  const tail = !parts[1] ? null : parts.slice(1).join(".");
  return features[idx][action](tail, lng, lat);
};
const MultiFeature$1 = function(ctx2, geojson) {
  Feature.call(this, ctx2, geojson);
  delete this.coordinates;
  this.model = models[geojson.geometry.type];
  if (this.model === void 0)
    throw new TypeError(`${geojson.geometry.type} is not a valid type`);
  this.features = this._coordinatesToFeatures(geojson.geometry.coordinates);
};
MultiFeature$1.prototype = Object.create(Feature.prototype);
MultiFeature$1.prototype._coordinatesToFeatures = function(coordinates2) {
  const Model2 = this.model.bind(this);
  return coordinates2.map((coords) => new Model2(this.ctx, {
    id: hat$1(),
    type: Constants$n.geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      coordinates: coords,
      type: this.type.replace("Multi", "")
    }
  }));
};
MultiFeature$1.prototype.isValid = function() {
  return this.features.every((f2) => f2.isValid());
};
MultiFeature$1.prototype.setCoordinates = function(coords) {
  this.features = this._coordinatesToFeatures(coords);
  this.changed();
};
MultiFeature$1.prototype.getCoordinate = function(path2) {
  return takeAction(this.features, "getCoordinate", path2);
};
MultiFeature$1.prototype.getCoordinates = function() {
  return JSON.parse(JSON.stringify(this.features.map((f2) => {
    if (f2.type === Constants$n.geojsonTypes.POLYGON)
      return f2.getCoordinates();
    return f2.coordinates;
  })));
};
MultiFeature$1.prototype.updateCoordinate = function(path2, lng, lat) {
  takeAction(this.features, "updateCoordinate", path2, lng, lat);
  this.changed();
};
MultiFeature$1.prototype.addCoordinate = function(path2, lng, lat) {
  takeAction(this.features, "addCoordinate", path2, lng, lat);
  this.changed();
};
MultiFeature$1.prototype.removeCoordinate = function(path2) {
  takeAction(this.features, "removeCoordinate", path2);
  this.changed();
};
MultiFeature$1.prototype.getFeatures = function() {
  return this.features;
};
var multi_feature = MultiFeature$1;
const Constants$m = constants$6;
const featuresAt$2 = features_at;
const Point$1 = point$1;
const LineString = line_string;
const Polygon = polygon$1;
const MultiFeature = multi_feature;
const ModeInterface$1 = mode_interface_accessors.exports = function(ctx2) {
  this.map = ctx2.map;
  this.drawConfig = JSON.parse(JSON.stringify(ctx2.options || {}));
  this._ctx = ctx2;
};
ModeInterface$1.prototype.setSelected = function(features) {
  return this._ctx.store.setSelected(features);
};
ModeInterface$1.prototype.setSelectedCoordinates = function(coords) {
  this._ctx.store.setSelectedCoordinates(coords);
  coords.reduce((m2, c2) => {
    if (m2[c2.feature_id] === void 0) {
      m2[c2.feature_id] = true;
      this._ctx.store.get(c2.feature_id).changed();
    }
    return m2;
  }, {});
};
ModeInterface$1.prototype.getSelected = function() {
  return this._ctx.store.getSelected();
};
ModeInterface$1.prototype.getSelectedIds = function() {
  return this._ctx.store.getSelectedIds();
};
ModeInterface$1.prototype.isSelected = function(id) {
  return this._ctx.store.isSelected(id);
};
ModeInterface$1.prototype.getFeature = function(id) {
  return this._ctx.store.get(id);
};
ModeInterface$1.prototype.select = function(id) {
  return this._ctx.store.select(id);
};
ModeInterface$1.prototype.deselect = function(id) {
  return this._ctx.store.deselect(id);
};
ModeInterface$1.prototype.deleteFeature = function(id, opts = {}) {
  return this._ctx.store.delete(id, opts);
};
ModeInterface$1.prototype.addFeature = function(feature2) {
  return this._ctx.store.add(feature2);
};
ModeInterface$1.prototype.clearSelectedFeatures = function() {
  return this._ctx.store.clearSelected();
};
ModeInterface$1.prototype.clearSelectedCoordinates = function() {
  return this._ctx.store.clearSelectedCoordinates();
};
ModeInterface$1.prototype.setActionableState = function(actions = {}) {
  const newSet = {
    trash: actions.trash || false,
    combineFeatures: actions.combineFeatures || false,
    uncombineFeatures: actions.uncombineFeatures || false
  };
  return this._ctx.events.actionable(newSet);
};
ModeInterface$1.prototype.changeMode = function(mode2, opts = {}, eventOpts = {}) {
  return this._ctx.events.changeMode(mode2, opts, eventOpts);
};
ModeInterface$1.prototype.updateUIClasses = function(opts) {
  return this._ctx.ui.queueMapClasses(opts);
};
ModeInterface$1.prototype.activateUIButton = function(name2) {
  return this._ctx.ui.setActiveButton(name2);
};
ModeInterface$1.prototype.featuresAt = function(event, bbox2, bufferType = "click") {
  if (bufferType !== "click" && bufferType !== "touch")
    throw new Error("invalid buffer type");
  return featuresAt$2[bufferType](event, bbox2, this._ctx);
};
ModeInterface$1.prototype.newFeature = function(geojson) {
  const type = geojson.geometry.type;
  if (type === Constants$m.geojsonTypes.POINT)
    return new Point$1(this._ctx, geojson);
  if (type === Constants$m.geojsonTypes.LINE_STRING)
    return new LineString(this._ctx, geojson);
  if (type === Constants$m.geojsonTypes.POLYGON)
    return new Polygon(this._ctx, geojson);
  return new MultiFeature(this._ctx, geojson);
};
ModeInterface$1.prototype.isInstanceOf = function(type, feature2) {
  if (type === Constants$m.geojsonTypes.POINT)
    return feature2 instanceof Point$1;
  if (type === Constants$m.geojsonTypes.LINE_STRING)
    return feature2 instanceof LineString;
  if (type === Constants$m.geojsonTypes.POLYGON)
    return feature2 instanceof Polygon;
  if (type === "MultiFeature")
    return feature2 instanceof MultiFeature;
  throw new Error(`Unknown feature class: ${type}`);
};
ModeInterface$1.prototype.doRender = function(id) {
  return this._ctx.store.featureChanged(id);
};
(function(module2) {
  const ModeInterface2 = module2.exports = mode_interface_accessorsExports;
  ModeInterface2.prototype.onSetup = function() {
  };
  ModeInterface2.prototype.onDrag = function() {
  };
  ModeInterface2.prototype.onClick = function() {
  };
  ModeInterface2.prototype.onMouseMove = function() {
  };
  ModeInterface2.prototype.onMouseDown = function() {
  };
  ModeInterface2.prototype.onMouseUp = function() {
  };
  ModeInterface2.prototype.onMouseOut = function() {
  };
  ModeInterface2.prototype.onKeyUp = function() {
  };
  ModeInterface2.prototype.onKeyDown = function() {
  };
  ModeInterface2.prototype.onTouchStart = function() {
  };
  ModeInterface2.prototype.onTouchMove = function() {
  };
  ModeInterface2.prototype.onTouchEnd = function() {
  };
  ModeInterface2.prototype.onTap = function() {
  };
  ModeInterface2.prototype.onStop = function() {
  };
  ModeInterface2.prototype.onTrash = function() {
  };
  ModeInterface2.prototype.onCombineFeature = function() {
  };
  ModeInterface2.prototype.onUncombineFeature = function() {
  };
  ModeInterface2.prototype.toDisplayFeatures = function() {
    throw new Error("You must overwrite toDisplayFeatures");
  };
})(mode_interface);
const ModeInterface = mode_interfaceExports;
const eventMapper = {
  drag: "onDrag",
  click: "onClick",
  mousemove: "onMouseMove",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseout: "onMouseOut",
  keyup: "onKeyUp",
  keydown: "onKeyDown",
  touchstart: "onTouchStart",
  touchmove: "onTouchMove",
  touchend: "onTouchEnd",
  tap: "onTap"
};
const eventKeys = Object.keys(eventMapper);
var object_to_mode = function(modeObject) {
  const modeObjectKeys = Object.keys(modeObject);
  return function(ctx2, startOpts = {}) {
    let state = {};
    const mode2 = modeObjectKeys.reduce((m2, k2) => {
      m2[k2] = modeObject[k2];
      return m2;
    }, new ModeInterface(ctx2));
    function wrapper(eh) {
      return function(e3) {
        mode2[eh](state, e3);
      };
    }
    return {
      start: function() {
        state = mode2.onSetup(startOpts);
        eventKeys.forEach((key) => {
          const modeHandler = eventMapper[key];
          let selector = () => false;
          if (modeObject[modeHandler]) {
            selector = () => true;
          }
          this.on(key, selector, wrapper(modeHandler));
        });
      },
      stop: function() {
        mode2.onStop(state);
      },
      trash: function() {
        mode2.onTrash(state);
      },
      combineFeatures: function() {
        mode2.onCombineFeatures(state);
      },
      uncombineFeatures: function() {
        mode2.onUncombineFeatures(state);
      },
      render: function(geojson, push2) {
        mode2.toDisplayFeatures(state, geojson, push2);
      }
    };
  };
};
const setupModeHandler = mode_handler;
const getFeaturesAndSetCursor = get_features_and_set_cursor;
const featuresAt$1 = features_at;
const isClick = is_click;
const isTap = is_tap;
const Constants$l = constants$6;
const objectToMode = object_to_mode;
var events$4 = function(ctx2) {
  const modes2 = Object.keys(ctx2.options.modes).reduce((m2, k2) => {
    m2[k2] = objectToMode(ctx2.options.modes[k2]);
    return m2;
  }, {});
  let mouseDownInfo = {};
  let touchStartInfo = {};
  const events2 = {};
  let currentModeName = null;
  let currentMode = null;
  events2.drag = function(event, isDrag) {
    if (isDrag({
      point: event.point,
      time: (/* @__PURE__ */ new Date()).getTime()
    })) {
      ctx2.ui.queueMapClasses({ mouse: Constants$l.cursors.DRAG });
      currentMode.drag(event);
    } else {
      event.originalEvent.stopPropagation();
    }
  };
  events2.mousedrag = function(event) {
    events2.drag(event, (endInfo) => !isClick(mouseDownInfo, endInfo));
  };
  events2.touchdrag = function(event) {
    events2.drag(event, (endInfo) => !isTap(touchStartInfo, endInfo));
  };
  events2.mousemove = function(event) {
    const button = event.originalEvent.buttons !== void 0 ? event.originalEvent.buttons : event.originalEvent.which;
    if (button === 1) {
      return events2.mousedrag(event);
    }
    const target = getFeaturesAndSetCursor(event, ctx2);
    event.featureTarget = target;
    currentMode.mousemove(event);
  };
  events2.mousedown = function(event) {
    mouseDownInfo = {
      time: (/* @__PURE__ */ new Date()).getTime(),
      point: event.point
    };
    const target = getFeaturesAndSetCursor(event, ctx2);
    event.featureTarget = target;
    currentMode.mousedown(event);
  };
  events2.mouseup = function(event) {
    const target = getFeaturesAndSetCursor(event, ctx2);
    event.featureTarget = target;
    if (isClick(mouseDownInfo, {
      point: event.point,
      time: (/* @__PURE__ */ new Date()).getTime()
    })) {
      currentMode.click(event);
    } else {
      currentMode.mouseup(event);
    }
  };
  events2.mouseout = function(event) {
    currentMode.mouseout(event);
  };
  events2.touchstart = function(event) {
    event.originalEvent.preventDefault();
    if (!ctx2.options.touchEnabled) {
      return;
    }
    touchStartInfo = {
      time: (/* @__PURE__ */ new Date()).getTime(),
      point: event.point
    };
    const target = featuresAt$1.touch(event, null, ctx2)[0];
    event.featureTarget = target;
    currentMode.touchstart(event);
  };
  events2.touchmove = function(event) {
    event.originalEvent.preventDefault();
    if (!ctx2.options.touchEnabled) {
      return;
    }
    currentMode.touchmove(event);
    return events2.touchdrag(event);
  };
  events2.touchend = function(event) {
    event.originalEvent.preventDefault();
    if (!ctx2.options.touchEnabled) {
      return;
    }
    const target = featuresAt$1.touch(event, null, ctx2)[0];
    event.featureTarget = target;
    if (isTap(touchStartInfo, {
      time: (/* @__PURE__ */ new Date()).getTime(),
      point: event.point
    })) {
      currentMode.tap(event);
    } else {
      currentMode.touchend(event);
    }
  };
  const isKeyModeValid = (code) => !(code === 8 || code === 46 || code >= 48 && code <= 57);
  events2.keydown = function(event) {
    if ((event.srcElement || event.target).classList[0] !== "mapboxgl-canvas")
      return;
    if ((event.keyCode === 8 || event.keyCode === 46) && ctx2.options.controls.trash) {
      event.preventDefault();
      currentMode.trash();
    } else if (isKeyModeValid(event.keyCode)) {
      currentMode.keydown(event);
    } else if (event.keyCode === 49 && ctx2.options.controls.point) {
      changeMode(Constants$l.modes.DRAW_POINT);
    } else if (event.keyCode === 50 && ctx2.options.controls.line_string) {
      changeMode(Constants$l.modes.DRAW_LINE_STRING);
    } else if (event.keyCode === 51 && ctx2.options.controls.polygon) {
      changeMode(Constants$l.modes.DRAW_POLYGON);
    }
  };
  events2.keyup = function(event) {
    if (isKeyModeValid(event.keyCode)) {
      currentMode.keyup(event);
    }
  };
  events2.zoomend = function() {
    ctx2.store.changeZoom();
  };
  events2.data = function(event) {
    if (event.dataType === "style") {
      const { setup: setup2, map: map5, options: options2, store: store2 } = ctx2;
      const hasLayers = options2.styles.some((style2) => map5.getLayer(style2.id));
      if (!hasLayers) {
        setup2.addLayers();
        store2.setDirty();
        store2.render();
      }
    }
  };
  function changeMode(modename, nextModeOptions, eventOptions = {}) {
    currentMode.stop();
    const modebuilder = modes2[modename];
    if (modebuilder === void 0) {
      throw new Error(`${modename} is not valid`);
    }
    currentModeName = modename;
    const mode2 = modebuilder(ctx2, nextModeOptions);
    currentMode = setupModeHandler(mode2, ctx2);
    if (!eventOptions.silent) {
      ctx2.map.fire(Constants$l.events.MODE_CHANGE, { mode: modename });
    }
    ctx2.store.setDirty();
    ctx2.store.render();
  }
  const actionState = {
    trash: false,
    combineFeatures: false,
    uncombineFeatures: false
  };
  function actionable(actions) {
    let changed = false;
    Object.keys(actions).forEach((action) => {
      if (actionState[action] === void 0)
        throw new Error("Invalid action type");
      if (actionState[action] !== actions[action])
        changed = true;
      actionState[action] = actions[action];
    });
    if (changed)
      ctx2.map.fire(Constants$l.events.ACTIONABLE, { actions: actionState });
  }
  const api2 = {
    start: function() {
      currentModeName = ctx2.options.defaultMode;
      currentMode = setupModeHandler(modes2[currentModeName](ctx2), ctx2);
    },
    changeMode,
    actionable,
    currentModeName: function() {
      return currentModeName;
    },
    currentModeRender: function(geojson, push2) {
      return currentMode.render(geojson, push2);
    },
    fire: function(name2, event) {
      if (events2[name2]) {
        events2[name2](event);
      }
    },
    addEventListeners: function() {
      ctx2.map.on("mousemove", events2.mousemove);
      ctx2.map.on("mousedown", events2.mousedown);
      ctx2.map.on("mouseup", events2.mouseup);
      ctx2.map.on("data", events2.data);
      ctx2.map.on("touchmove", events2.touchmove);
      ctx2.map.on("touchstart", events2.touchstart);
      ctx2.map.on("touchend", events2.touchend);
      ctx2.container.addEventListener("mouseout", events2.mouseout);
      if (ctx2.options.keybindings) {
        ctx2.container.addEventListener("keydown", events2.keydown);
        ctx2.container.addEventListener("keyup", events2.keyup);
      }
    },
    removeEventListeners: function() {
      ctx2.map.off("mousemove", events2.mousemove);
      ctx2.map.off("mousedown", events2.mousedown);
      ctx2.map.off("mouseup", events2.mouseup);
      ctx2.map.off("data", events2.data);
      ctx2.map.off("touchmove", events2.touchmove);
      ctx2.map.off("touchstart", events2.touchstart);
      ctx2.map.off("touchend", events2.touchend);
      ctx2.container.removeEventListener("mouseout", events2.mouseout);
      if (ctx2.options.keybindings) {
        ctx2.container.removeEventListener("keydown", events2.keydown);
        ctx2.container.removeEventListener("keyup", events2.keyup);
      }
    },
    trash: function(options2) {
      currentMode.trash(options2);
    },
    combineFeatures: function() {
      currentMode.combineFeatures();
    },
    uncombineFeatures: function() {
      currentMode.uncombineFeatures();
    },
    getMode: function() {
      return currentModeName;
    }
  };
  return api2;
};
var storeExports = {};
var store = {
  get exports() {
    return storeExports;
  },
  set exports(v5) {
    storeExports = v5;
  }
};
function throttle$1(fn2, time2, context2) {
  let lock, args;
  function later() {
    lock = false;
    if (args) {
      wrapperFn.apply(context2, args);
      args = false;
    }
  }
  function wrapperFn() {
    if (lock) {
      args = arguments;
    } else {
      lock = true;
      fn2.apply(context2, arguments);
      setTimeout(later, time2);
    }
  }
  return wrapperFn;
}
var throttle_1 = throttle$1;
function toDenseArray$1(x2) {
  return [].concat(x2).filter((y2) => y2 !== void 0);
}
var to_dense_array = toDenseArray$1;
const Constants$k = constants$6;
var render$3 = function render3() {
  const store2 = this;
  const mapExists = store2.ctx.map && store2.ctx.map.getSource(Constants$k.sources.HOT) !== void 0;
  if (!mapExists)
    return cleanup();
  const mode2 = store2.ctx.events.currentModeName();
  store2.ctx.ui.queueMapClasses({ mode: mode2 });
  let newHotIds = [];
  let newColdIds = [];
  if (store2.isDirty) {
    newColdIds = store2.getAllIds();
  } else {
    newHotIds = store2.getChangedIds().filter((id) => store2.get(id) !== void 0);
    newColdIds = store2.sources.hot.filter((geojson) => {
      return geojson.properties.id && newHotIds.indexOf(geojson.properties.id) === -1 && store2.get(geojson.properties.id) !== void 0;
    }).map((geojson) => geojson.properties.id);
  }
  store2.sources.hot = [];
  const lastColdCount = store2.sources.cold.length;
  store2.sources.cold = store2.isDirty ? [] : store2.sources.cold.filter((geojson) => {
    const id = geojson.properties.id || geojson.properties.parent;
    return newHotIds.indexOf(id) === -1;
  });
  const coldChanged = lastColdCount !== store2.sources.cold.length || newColdIds.length > 0;
  newHotIds.forEach((id) => renderFeature(id, "hot"));
  newColdIds.forEach((id) => renderFeature(id, "cold"));
  function renderFeature(id, source) {
    const feature2 = store2.get(id);
    const featureInternal = feature2.internal(mode2);
    store2.ctx.events.currentModeRender(featureInternal, (geojson) => {
      store2.sources[source].push(geojson);
    });
  }
  if (coldChanged) {
    store2.ctx.map.getSource(Constants$k.sources.COLD).setData({
      type: Constants$k.geojsonTypes.FEATURE_COLLECTION,
      features: store2.sources.cold
    });
  }
  store2.ctx.map.getSource(Constants$k.sources.HOT).setData({
    type: Constants$k.geojsonTypes.FEATURE_COLLECTION,
    features: store2.sources.hot
  });
  if (store2._emitSelectionChange) {
    store2.ctx.map.fire(Constants$k.events.SELECTION_CHANGE, {
      features: store2.getSelected().map((feature2) => feature2.toGeoJSON()),
      points: store2.getSelectedCoordinates().map((coordinate2) => {
        return {
          type: Constants$k.geojsonTypes.FEATURE,
          properties: {},
          geometry: {
            type: Constants$k.geojsonTypes.POINT,
            coordinates: coordinate2.coordinates
          }
        };
      })
    });
    store2._emitSelectionChange = false;
  }
  if (store2._deletedFeaturesToEmit.length) {
    const geojsonToEmit = store2._deletedFeaturesToEmit.map((feature2) => feature2.toGeoJSON());
    store2._deletedFeaturesToEmit = [];
    store2.ctx.map.fire(Constants$k.events.DELETE, {
      features: geojsonToEmit
    });
  }
  cleanup();
  store2.ctx.map.fire(Constants$k.events.RENDER, {});
  function cleanup() {
    store2.isDirty = false;
    store2.clearChangedIds();
  }
};
const throttle = throttle_1;
const toDenseArray = to_dense_array;
const StringSet$2 = string_set;
const render$2 = render$3;
const interactions = constants$6.interactions;
const Store$1 = store.exports = function(ctx2) {
  this._features = {};
  this._featureIds = new StringSet$2();
  this._selectedFeatureIds = new StringSet$2();
  this._selectedCoordinates = [];
  this._changedFeatureIds = new StringSet$2();
  this._deletedFeaturesToEmit = [];
  this._emitSelectionChange = false;
  this._mapInitialConfig = {};
  this.ctx = ctx2;
  this.sources = {
    hot: [],
    cold: []
  };
  this.render = throttle(render$2, 16, this);
  this.isDirty = false;
};
Store$1.prototype.createRenderBatch = function() {
  const holdRender = this.render;
  let numRenders = 0;
  this.render = function() {
    numRenders++;
  };
  return () => {
    this.render = holdRender;
    if (numRenders > 0) {
      this.render();
    }
  };
};
Store$1.prototype.setDirty = function() {
  this.isDirty = true;
  return this;
};
Store$1.prototype.featureChanged = function(featureId) {
  this._changedFeatureIds.add(featureId);
  return this;
};
Store$1.prototype.getChangedIds = function() {
  return this._changedFeatureIds.values();
};
Store$1.prototype.clearChangedIds = function() {
  this._changedFeatureIds.clear();
  return this;
};
Store$1.prototype.getAllIds = function() {
  return this._featureIds.values();
};
Store$1.prototype.add = function(feature2) {
  this.featureChanged(feature2.id);
  this._features[feature2.id] = feature2;
  this._featureIds.add(feature2.id);
  return this;
};
Store$1.prototype.delete = function(featureIds, options2 = {}) {
  toDenseArray(featureIds).forEach((id) => {
    if (!this._featureIds.has(id))
      return;
    this._featureIds.delete(id);
    this._selectedFeatureIds.delete(id);
    if (!options2.silent) {
      if (this._deletedFeaturesToEmit.indexOf(this._features[id]) === -1) {
        this._deletedFeaturesToEmit.push(this._features[id]);
      }
    }
    delete this._features[id];
    this.isDirty = true;
  });
  refreshSelectedCoordinates.call(this, options2);
  return this;
};
Store$1.prototype.get = function(id) {
  return this._features[id];
};
Store$1.prototype.getAll = function() {
  return Object.keys(this._features).map((id) => this._features[id]);
};
Store$1.prototype.select = function(featureIds, options2 = {}) {
  toDenseArray(featureIds).forEach((id) => {
    if (this._selectedFeatureIds.has(id))
      return;
    this._selectedFeatureIds.add(id);
    this._changedFeatureIds.add(id);
    if (!options2.silent) {
      this._emitSelectionChange = true;
    }
  });
  return this;
};
Store$1.prototype.deselect = function(featureIds, options2 = {}) {
  toDenseArray(featureIds).forEach((id) => {
    if (!this._selectedFeatureIds.has(id))
      return;
    this._selectedFeatureIds.delete(id);
    this._changedFeatureIds.add(id);
    if (!options2.silent) {
      this._emitSelectionChange = true;
    }
  });
  refreshSelectedCoordinates.call(this, options2);
  return this;
};
Store$1.prototype.clearSelected = function(options2 = {}) {
  this.deselect(this._selectedFeatureIds.values(), { silent: options2.silent });
  return this;
};
Store$1.prototype.setSelected = function(featureIds, options2 = {}) {
  featureIds = toDenseArray(featureIds);
  this.deselect(this._selectedFeatureIds.values().filter((id) => {
    return featureIds.indexOf(id) === -1;
  }), { silent: options2.silent });
  this.select(featureIds.filter((id) => {
    return !this._selectedFeatureIds.has(id);
  }), { silent: options2.silent });
  return this;
};
Store$1.prototype.setSelectedCoordinates = function(coordinates2) {
  this._selectedCoordinates = coordinates2;
  this._emitSelectionChange = true;
  return this;
};
Store$1.prototype.clearSelectedCoordinates = function() {
  this._selectedCoordinates = [];
  this._emitSelectionChange = true;
  return this;
};
Store$1.prototype.getSelectedIds = function() {
  return this._selectedFeatureIds.values();
};
Store$1.prototype.getSelected = function() {
  return this._selectedFeatureIds.values().map((id) => this.get(id));
};
Store$1.prototype.getSelectedCoordinates = function() {
  const selected = this._selectedCoordinates.map((coordinate2) => {
    const feature2 = this.get(coordinate2.feature_id);
    return {
      coordinates: feature2.getCoordinate(coordinate2.coord_path)
    };
  });
  return selected;
};
Store$1.prototype.isSelected = function(featureId) {
  return this._selectedFeatureIds.has(featureId);
};
Store$1.prototype.setFeatureProperty = function(featureId, property2, value) {
  this.get(featureId).setProperty(property2, value);
  this.featureChanged(featureId);
};
function refreshSelectedCoordinates(options2) {
  const newSelectedCoordinates = this._selectedCoordinates.filter((point4) => this._selectedFeatureIds.has(point4.feature_id));
  if (this._selectedCoordinates.length !== newSelectedCoordinates.length && !options2.silent) {
    this._emitSelectionChange = true;
  }
  this._selectedCoordinates = newSelectedCoordinates;
}
Store$1.prototype.storeMapConfig = function() {
  interactions.forEach((interaction) => {
    const interactionSet = this.ctx.map[interaction];
    if (interactionSet) {
      this._mapInitialConfig[interaction] = this.ctx.map[interaction].isEnabled();
    }
  });
};
Store$1.prototype.restoreMapConfig = function() {
  Object.keys(this._mapInitialConfig).forEach((key) => {
    const value = this._mapInitialConfig[key];
    if (value) {
      this.ctx.map[key].enable();
    } else {
      this.ctx.map[key].disable();
    }
  });
};
Store$1.prototype.getInitialConfigValue = function(interaction) {
  if (this._mapInitialConfig[interaction] !== void 0) {
    return this._mapInitialConfig[interaction];
  } else {
    return true;
  }
};
const xtend$6 = immutable;
const Constants$j = constants$6;
const classTypes = ["mode", "feature", "mouse"];
var ui$1 = function(ctx2) {
  const buttonElements = {};
  let activeButton = null;
  let currentMapClasses = {
    mode: null,
    // e.g. mode-direct_select
    feature: null,
    // e.g. feature-vertex
    mouse: null
    // e.g. mouse-move
  };
  let nextMapClasses = {
    mode: null,
    feature: null,
    mouse: null
  };
  function clearMapClasses() {
    queueMapClasses({ mode: null, feature: null, mouse: null });
    updateMapClasses();
  }
  function queueMapClasses(options2) {
    nextMapClasses = xtend$6(nextMapClasses, options2);
  }
  function updateMapClasses() {
    if (!ctx2.container)
      return;
    const classesToRemove = [];
    const classesToAdd = [];
    classTypes.forEach((type) => {
      if (nextMapClasses[type] === currentMapClasses[type])
        return;
      classesToRemove.push(`${type}-${currentMapClasses[type]}`);
      if (nextMapClasses[type] !== null) {
        classesToAdd.push(`${type}-${nextMapClasses[type]}`);
      }
    });
    if (classesToRemove.length > 0) {
      ctx2.container.classList.remove.apply(ctx2.container.classList, classesToRemove);
    }
    if (classesToAdd.length > 0) {
      ctx2.container.classList.add.apply(ctx2.container.classList, classesToAdd);
    }
    currentMapClasses = xtend$6(currentMapClasses, nextMapClasses);
  }
  function createControlButton(id, options2 = {}) {
    const button = document.createElement("button");
    button.className = `${Constants$j.classes.CONTROL_BUTTON} ${options2.className}`;
    button.setAttribute("title", options2.title);
    options2.container.appendChild(button);
    button.addEventListener("click", (e3) => {
      e3.preventDefault();
      e3.stopPropagation();
      const clickedButton = e3.target;
      if (clickedButton === activeButton) {
        deactivateButtons();
        return;
      }
      setActiveButton(id);
      options2.onActivate();
    }, true);
    return button;
  }
  function deactivateButtons() {
    if (!activeButton)
      return;
    activeButton.classList.remove(Constants$j.classes.ACTIVE_BUTTON);
    activeButton = null;
  }
  function setActiveButton(id) {
    deactivateButtons();
    const button = buttonElements[id];
    if (!button)
      return;
    if (button && id !== "trash") {
      button.classList.add(Constants$j.classes.ACTIVE_BUTTON);
      activeButton = button;
    }
  }
  function addButtons() {
    const controls = ctx2.options.controls;
    const controlGroup = document.createElement("div");
    controlGroup.className = `${Constants$j.classes.CONTROL_GROUP} ${Constants$j.classes.CONTROL_BASE}`;
    if (!controls)
      return controlGroup;
    if (controls[Constants$j.types.LINE]) {
      buttonElements[Constants$j.types.LINE] = createControlButton(Constants$j.types.LINE, {
        container: controlGroup,
        className: Constants$j.classes.CONTROL_BUTTON_LINE,
        title: `LineString tool ${ctx2.options.keybindings ? "(l)" : ""}`,
        onActivate: () => ctx2.events.changeMode(Constants$j.modes.DRAW_LINE_STRING)
      });
    }
    if (controls[Constants$j.types.POLYGON]) {
      buttonElements[Constants$j.types.POLYGON] = createControlButton(Constants$j.types.POLYGON, {
        container: controlGroup,
        className: Constants$j.classes.CONTROL_BUTTON_POLYGON,
        title: `Polygon tool ${ctx2.options.keybindings ? "(p)" : ""}`,
        onActivate: () => ctx2.events.changeMode(Constants$j.modes.DRAW_POLYGON)
      });
    }
    if (controls[Constants$j.types.POINT]) {
      buttonElements[Constants$j.types.POINT] = createControlButton(Constants$j.types.POINT, {
        container: controlGroup,
        className: Constants$j.classes.CONTROL_BUTTON_POINT,
        title: `Marker tool ${ctx2.options.keybindings ? "(m)" : ""}`,
        onActivate: () => ctx2.events.changeMode(Constants$j.modes.DRAW_POINT)
      });
    }
    if (controls.trash) {
      buttonElements.trash = createControlButton("trash", {
        container: controlGroup,
        className: Constants$j.classes.CONTROL_BUTTON_TRASH,
        title: "Delete",
        onActivate: () => {
          ctx2.events.trash();
        }
      });
    }
    if (controls.combine_features) {
      buttonElements.combine_features = createControlButton("combineFeatures", {
        container: controlGroup,
        className: Constants$j.classes.CONTROL_BUTTON_COMBINE_FEATURES,
        title: "Combine",
        onActivate: () => {
          ctx2.events.combineFeatures();
        }
      });
    }
    if (controls.uncombine_features) {
      buttonElements.uncombine_features = createControlButton("uncombineFeatures", {
        container: controlGroup,
        className: Constants$j.classes.CONTROL_BUTTON_UNCOMBINE_FEATURES,
        title: "Uncombine",
        onActivate: () => {
          ctx2.events.uncombineFeatures();
        }
      });
    }
    return controlGroup;
  }
  function removeButtons() {
    Object.keys(buttonElements).forEach((buttonId) => {
      const button = buttonElements[buttonId];
      if (button.parentNode) {
        button.parentNode.removeChild(button);
      }
      delete buttonElements[buttonId];
    });
  }
  return {
    setActiveButton,
    queueMapClasses,
    updateMapClasses,
    clearMapClasses,
    addButtons,
    removeButtons
  };
};
const events$3 = events$4;
const Store = storeExports;
const ui = ui$1;
const Constants$i = constants$6;
const xtend$5 = immutable;
var setup = function(ctx2) {
  let controlContainer = null;
  let mapLoadedInterval = null;
  const setup2 = {
    onRemove: function() {
      ctx2.map.off("load", setup2.connect);
      clearInterval(mapLoadedInterval);
      setup2.removeLayers();
      ctx2.store.restoreMapConfig();
      ctx2.ui.removeButtons();
      ctx2.events.removeEventListeners();
      ctx2.ui.clearMapClasses();
      ctx2.map = null;
      ctx2.container = null;
      ctx2.store = null;
      if (controlContainer && controlContainer.parentNode)
        controlContainer.parentNode.removeChild(controlContainer);
      controlContainer = null;
      return this;
    },
    connect: function() {
      ctx2.map.off("load", setup2.connect);
      clearInterval(mapLoadedInterval);
      setup2.addLayers();
      ctx2.store.storeMapConfig();
      ctx2.events.addEventListeners();
    },
    onAdd: function(map5) {
      if (process.env.NODE_ENV !== "test") {
        const _fire = map5.fire;
        map5.fire = function(type, event) {
          let args = arguments;
          if (_fire.length === 1 && arguments.length !== 1) {
            args = [xtend$5({}, { type }, event)];
          }
          return _fire.apply(map5, args);
        };
      }
      ctx2.map = map5;
      ctx2.events = events$3(ctx2);
      ctx2.ui = ui(ctx2);
      ctx2.container = map5.getContainer();
      ctx2.store = new Store(ctx2);
      controlContainer = ctx2.ui.addButtons();
      if (ctx2.options.boxSelect) {
        map5.boxZoom.disable();
        map5.dragPan.disable();
        map5.dragPan.enable();
      }
      if (map5.loaded()) {
        setup2.connect();
      } else {
        map5.on("load", setup2.connect);
        mapLoadedInterval = setInterval(() => {
          if (map5.loaded())
            setup2.connect();
        }, 16);
      }
      ctx2.events.start();
      return controlContainer;
    },
    addLayers: function() {
      ctx2.map.addSource(Constants$i.sources.COLD, {
        data: {
          type: Constants$i.geojsonTypes.FEATURE_COLLECTION,
          features: []
        },
        type: "geojson"
      });
      ctx2.map.addSource(Constants$i.sources.HOT, {
        data: {
          type: Constants$i.geojsonTypes.FEATURE_COLLECTION,
          features: []
        },
        type: "geojson"
      });
      ctx2.options.styles.forEach((style2) => {
        ctx2.map.addLayer(style2);
      });
      ctx2.store.setDirty(true);
      ctx2.store.render();
    },
    // Check for layers and sources before attempting to remove
    // If user adds draw control and removes it before the map is loaded, layers and sources will be missing
    removeLayers: function() {
      ctx2.options.styles.forEach((style2) => {
        if (ctx2.map.getLayer(style2.id)) {
          ctx2.map.removeLayer(style2.id);
        }
      });
      if (ctx2.map.getSource(Constants$i.sources.COLD)) {
        ctx2.map.removeSource(Constants$i.sources.COLD);
      }
      if (ctx2.map.getSource(Constants$i.sources.HOT)) {
        ctx2.map.removeSource(Constants$i.sources.HOT);
      }
    }
  };
  ctx2.setup = setup2;
  return setup2;
};
var theme = [
  {
    "id": "gl-draw-polygon-fill-inactive",
    "type": "fill",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Polygon"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "fill-color": "#3bb2d0",
      "fill-outline-color": "#3bb2d0",
      "fill-opacity": 0.1
    }
  },
  {
    "id": "gl-draw-polygon-fill-active",
    "type": "fill",
    "filter": ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
    "paint": {
      "fill-color": "#fbb03b",
      "fill-outline-color": "#fbb03b",
      "fill-opacity": 0.1
    }
  },
  {
    "id": "gl-draw-polygon-midpoint",
    "type": "circle",
    "filter": [
      "all",
      ["==", "$type", "Point"],
      ["==", "meta", "midpoint"]
    ],
    "paint": {
      "circle-radius": 3,
      "circle-color": "#fbb03b"
    }
  },
  {
    "id": "gl-draw-polygon-stroke-inactive",
    "type": "line",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Polygon"],
      ["!=", "mode", "static"]
    ],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#3bb2d0",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-polygon-stroke-active",
    "type": "line",
    "filter": ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#fbb03b",
      "line-dasharray": [0.2, 2],
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-line-inactive",
    "type": "line",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "LineString"],
      ["!=", "mode", "static"]
    ],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#3bb2d0",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-line-active",
    "type": "line",
    "filter": [
      "all",
      ["==", "$type", "LineString"],
      ["==", "active", "true"]
    ],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#fbb03b",
      "line-dasharray": [0.2, 2],
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-polygon-and-line-vertex-stroke-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "meta", "vertex"],
      ["==", "$type", "Point"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 5,
      "circle-color": "#fff"
    }
  },
  {
    "id": "gl-draw-polygon-and-line-vertex-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "meta", "vertex"],
      ["==", "$type", "Point"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 3,
      "circle-color": "#fbb03b"
    }
  },
  {
    "id": "gl-draw-point-point-stroke-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Point"],
      ["==", "meta", "feature"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 5,
      "circle-opacity": 1,
      "circle-color": "#fff"
    }
  },
  {
    "id": "gl-draw-point-inactive",
    "type": "circle",
    "filter": [
      "all",
      ["==", "active", "false"],
      ["==", "$type", "Point"],
      ["==", "meta", "feature"],
      ["!=", "mode", "static"]
    ],
    "paint": {
      "circle-radius": 3,
      "circle-color": "#3bb2d0"
    }
  },
  {
    "id": "gl-draw-point-stroke-active",
    "type": "circle",
    "filter": [
      "all",
      ["==", "$type", "Point"],
      ["==", "active", "true"],
      ["!=", "meta", "midpoint"]
    ],
    "paint": {
      "circle-radius": 7,
      "circle-color": "#fff"
    }
  },
  {
    "id": "gl-draw-point-active",
    "type": "circle",
    "filter": [
      "all",
      ["==", "$type", "Point"],
      ["!=", "meta", "midpoint"],
      ["==", "active", "true"]
    ],
    "paint": {
      "circle-radius": 5,
      "circle-color": "#fbb03b"
    }
  },
  {
    "id": "gl-draw-polygon-fill-static",
    "type": "fill",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
    "paint": {
      "fill-color": "#404040",
      "fill-outline-color": "#404040",
      "fill-opacity": 0.1
    }
  },
  {
    "id": "gl-draw-polygon-stroke-static",
    "type": "line",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#404040",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-line-static",
    "type": "line",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "LineString"]],
    "layout": {
      "line-cap": "round",
      "line-join": "round"
    },
    "paint": {
      "line-color": "#404040",
      "line-width": 2
    }
  },
  {
    "id": "gl-draw-point-static",
    "type": "circle",
    "filter": ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
    "paint": {
      "circle-radius": 5,
      "circle-color": "#404040"
    }
  }
];
const Constants$h = constants$6;
var common_selectors = {
  isOfMetaType: function(type) {
    return function(e3) {
      const featureTarget = e3.featureTarget;
      if (!featureTarget)
        return false;
      if (!featureTarget.properties)
        return false;
      return featureTarget.properties.meta === type;
    };
  },
  isShiftMousedown: function(e3) {
    if (!e3.originalEvent)
      return false;
    if (!e3.originalEvent.shiftKey)
      return false;
    return e3.originalEvent.button === 0;
  },
  isActiveFeature: function(e3) {
    if (!e3.featureTarget)
      return false;
    if (!e3.featureTarget.properties)
      return false;
    return e3.featureTarget.properties.active === Constants$h.activeStates.ACTIVE && e3.featureTarget.properties.meta === Constants$h.meta.FEATURE;
  },
  isInactiveFeature: function(e3) {
    if (!e3.featureTarget)
      return false;
    if (!e3.featureTarget.properties)
      return false;
    return e3.featureTarget.properties.active === Constants$h.activeStates.INACTIVE && e3.featureTarget.properties.meta === Constants$h.meta.FEATURE;
  },
  noTarget: function(e3) {
    return e3.featureTarget === void 0;
  },
  isFeature: function(e3) {
    if (!e3.featureTarget)
      return false;
    if (!e3.featureTarget.properties)
      return false;
    return e3.featureTarget.properties.meta === Constants$h.meta.FEATURE;
  },
  isVertex: function(e3) {
    const featureTarget = e3.featureTarget;
    if (!featureTarget)
      return false;
    if (!featureTarget.properties)
      return false;
    return featureTarget.properties.meta === Constants$h.meta.VERTEX;
  },
  isShiftDown: function(e3) {
    if (!e3.originalEvent)
      return false;
    return e3.originalEvent.shiftKey === true;
  },
  isEscapeKey: function(e3) {
    return e3.keyCode === 27;
  },
  isEnterKey: function(e3) {
    return e3.keyCode === 13;
  },
  true: function() {
    return true;
  }
};
const Point = pointGeometry;
function mouseEventPoint$1(mouseEvent, container) {
  const rect = container.getBoundingClientRect();
  return new Point(
    mouseEvent.clientX - rect.left - (container.clientLeft || 0),
    mouseEvent.clientY - rect.top - (container.clientTop || 0)
  );
}
var mouse_event_point = mouseEventPoint$1;
const Constants$g = constants$6;
var create_vertex = function(parentId, coordinates2, path2, selected) {
  return {
    type: Constants$g.geojsonTypes.FEATURE,
    properties: {
      meta: Constants$g.meta.VERTEX,
      parent: parentId,
      coord_path: path2,
      active: selected ? Constants$g.activeStates.ACTIVE : Constants$g.activeStates.INACTIVE
    },
    geometry: {
      type: Constants$g.geojsonTypes.POINT,
      coordinates: coordinates2
    }
  };
};
const Constants$f = constants$6;
var create_midpoint = function(parent, startVertex, endVertex, map5) {
  const startCoord = startVertex.geometry.coordinates;
  const endCoord = endVertex.geometry.coordinates;
  if (startCoord[1] > Constants$f.LAT_RENDERED_MAX || startCoord[1] < Constants$f.LAT_RENDERED_MIN || endCoord[1] > Constants$f.LAT_RENDERED_MAX || endCoord[1] < Constants$f.LAT_RENDERED_MIN) {
    return null;
  }
  const ptA = map5.project([startCoord[0], startCoord[1]]);
  const ptB = map5.project([endCoord[0], endCoord[1]]);
  const mid = map5.unproject([(ptA.x + ptB.x) / 2, (ptA.y + ptB.y) / 2]);
  return {
    type: Constants$f.geojsonTypes.FEATURE,
    properties: {
      meta: Constants$f.meta.MIDPOINT,
      parent,
      lng: mid.lng,
      lat: mid.lat,
      coord_path: endVertex.properties.coord_path
    },
    geometry: {
      type: Constants$f.geojsonTypes.POINT,
      coordinates: [mid.lng, mid.lat]
    }
  };
};
const createVertex$4 = create_vertex;
const createMidpoint = create_midpoint;
const Constants$e = constants$6;
function createSupplementaryPoints$4(geojson, options2 = {}, basePath = null) {
  const { type, coordinates: coordinates2 } = geojson.geometry;
  const featureId = geojson.properties && geojson.properties.id;
  let supplementaryPoints = [];
  if (type === Constants$e.geojsonTypes.POINT) {
    supplementaryPoints.push(createVertex$4(featureId, coordinates2, basePath, isSelectedPath(basePath)));
  } else if (type === Constants$e.geojsonTypes.POLYGON) {
    coordinates2.forEach((line, lineIndex) => {
      processLine(line, basePath !== null ? `${basePath}.${lineIndex}` : String(lineIndex));
    });
  } else if (type === Constants$e.geojsonTypes.LINE_STRING) {
    processLine(coordinates2, basePath);
  } else if (type.indexOf(Constants$e.geojsonTypes.MULTI_PREFIX) === 0) {
    processMultiGeometry();
  }
  function processLine(line, lineBasePath) {
    let firstPointString = "";
    let lastVertex = null;
    line.forEach((point4, pointIndex) => {
      const pointPath = lineBasePath !== void 0 && lineBasePath !== null ? `${lineBasePath}.${pointIndex}` : String(pointIndex);
      const vertex2 = createVertex$4(featureId, point4, pointPath, isSelectedPath(pointPath));
      if (options2.midpoints && lastVertex) {
        const midpoint2 = createMidpoint(featureId, lastVertex, vertex2, options2.map);
        if (midpoint2) {
          supplementaryPoints.push(midpoint2);
        }
      }
      lastVertex = vertex2;
      const stringifiedPoint = JSON.stringify(point4);
      if (firstPointString !== stringifiedPoint) {
        supplementaryPoints.push(vertex2);
      }
      if (pointIndex === 0) {
        firstPointString = stringifiedPoint;
      }
    });
  }
  function isSelectedPath(path2) {
    if (!options2.selectedPaths)
      return false;
    return options2.selectedPaths.indexOf(path2) !== -1;
  }
  function processMultiGeometry() {
    const subType = type.replace(Constants$e.geojsonTypes.MULTI_PREFIX, "");
    coordinates2.forEach((subCoordinates, index2) => {
      const subFeature = {
        type: Constants$e.geojsonTypes.FEATURE,
        properties: geojson.properties,
        geometry: {
          type: subType,
          coordinates: subCoordinates
        }
      };
      supplementaryPoints = supplementaryPoints.concat(createSupplementaryPoints$4(subFeature, options2, index2));
    });
  }
  return supplementaryPoints;
}
var create_supplementary_points = createSupplementaryPoints$4;
var double_click_zoom = {
  enable(ctx2) {
    setTimeout(() => {
      if (!ctx2.map || !ctx2.map.doubleClickZoom || !ctx2._ctx || !ctx2._ctx.store || !ctx2._ctx.store.getInitialConfigValue)
        return;
      if (!ctx2._ctx.store.getInitialConfigValue("doubleClickZoom"))
        return;
      ctx2.map.doubleClickZoom.enable();
    }, 0);
  },
  disable(ctx2) {
    setTimeout(() => {
      if (!ctx2.map || !ctx2.map.doubleClickZoom)
        return;
      ctx2.map.doubleClickZoom.disable();
    }, 0);
  }
};
const extent = geojsonExtentExports;
const Constants$d = constants$6;
const {
  LAT_MIN,
  LAT_MAX,
  LAT_RENDERED_MIN,
  LAT_RENDERED_MAX,
  LNG_MIN,
  LNG_MAX
} = Constants$d;
var constrain_feature_movement = function(geojsonFeatures, delta) {
  let northInnerEdge = LAT_MIN;
  let southInnerEdge = LAT_MAX;
  let northOuterEdge = LAT_MIN;
  let southOuterEdge = LAT_MAX;
  let westEdge = LNG_MAX;
  let eastEdge = LNG_MIN;
  geojsonFeatures.forEach((feature2) => {
    const bounds = extent(feature2);
    const featureSouthEdge = bounds[1];
    const featureNorthEdge = bounds[3];
    const featureWestEdge = bounds[0];
    const featureEastEdge = bounds[2];
    if (featureSouthEdge > northInnerEdge)
      northInnerEdge = featureSouthEdge;
    if (featureNorthEdge < southInnerEdge)
      southInnerEdge = featureNorthEdge;
    if (featureNorthEdge > northOuterEdge)
      northOuterEdge = featureNorthEdge;
    if (featureSouthEdge < southOuterEdge)
      southOuterEdge = featureSouthEdge;
    if (featureWestEdge < westEdge)
      westEdge = featureWestEdge;
    if (featureEastEdge > eastEdge)
      eastEdge = featureEastEdge;
  });
  const constrainedDelta = delta;
  if (northInnerEdge + constrainedDelta.lat > LAT_RENDERED_MAX) {
    constrainedDelta.lat = LAT_RENDERED_MAX - northInnerEdge;
  }
  if (northOuterEdge + constrainedDelta.lat > LAT_MAX) {
    constrainedDelta.lat = LAT_MAX - northOuterEdge;
  }
  if (southInnerEdge + constrainedDelta.lat < LAT_RENDERED_MIN) {
    constrainedDelta.lat = LAT_RENDERED_MIN - southInnerEdge;
  }
  if (southOuterEdge + constrainedDelta.lat < LAT_MIN) {
    constrainedDelta.lat = LAT_MIN - southOuterEdge;
  }
  if (westEdge + constrainedDelta.lng <= LNG_MIN) {
    constrainedDelta.lng += Math.ceil(Math.abs(constrainedDelta.lng) / 360) * 360;
  }
  if (eastEdge + constrainedDelta.lng >= LNG_MAX) {
    constrainedDelta.lng -= Math.ceil(Math.abs(constrainedDelta.lng) / 360) * 360;
  }
  return constrainedDelta;
};
const constrainFeatureMovement$2 = constrain_feature_movement;
const Constants$c = constants$6;
var move_features = function(features, delta) {
  const constrainedDelta = constrainFeatureMovement$2(features.map((feature2) => feature2.toGeoJSON()), delta);
  features.forEach((feature2) => {
    const currentCoordinates = feature2.getCoordinates();
    const moveCoordinate = (coord) => {
      const point4 = {
        lng: coord[0] + constrainedDelta.lng,
        lat: coord[1] + constrainedDelta.lat
      };
      return [point4.lng, point4.lat];
    };
    const moveRing = (ring) => ring.map((coord) => moveCoordinate(coord));
    const moveMultiPolygon = (multi) => multi.map((ring) => moveRing(ring));
    let nextCoordinates;
    if (feature2.type === Constants$c.geojsonTypes.POINT) {
      nextCoordinates = moveCoordinate(currentCoordinates);
    } else if (feature2.type === Constants$c.geojsonTypes.LINE_STRING || feature2.type === Constants$c.geojsonTypes.MULTI_POINT) {
      nextCoordinates = currentCoordinates.map(moveCoordinate);
    } else if (feature2.type === Constants$c.geojsonTypes.POLYGON || feature2.type === Constants$c.geojsonTypes.MULTI_LINE_STRING) {
      nextCoordinates = currentCoordinates.map(moveRing);
    } else if (feature2.type === Constants$c.geojsonTypes.MULTI_POLYGON) {
      nextCoordinates = currentCoordinates.map(moveMultiPolygon);
    }
    feature2.incomingCoords(nextCoordinates);
  });
};
const CommonSelectors$4 = common_selectors;
const mouseEventPoint = mouse_event_point;
const createSupplementaryPoints$3 = create_supplementary_points;
const StringSet$1 = string_set;
const doubleClickZoom$7 = double_click_zoom;
const moveFeatures$3 = move_features;
const Constants$b = constants$6;
const SimpleSelect = {};
SimpleSelect.onSetup = function(opts) {
  const state = {
    dragMoveLocation: null,
    boxSelectStartLocation: null,
    boxSelectElement: void 0,
    boxSelecting: false,
    canBoxSelect: false,
    dragMoveing: false,
    canDragMove: false,
    initiallySelectedFeatureIds: opts.featureIds || []
  };
  this.setSelected(state.initiallySelectedFeatureIds.filter((id) => {
    return this.getFeature(id) !== void 0;
  }));
  this.fireActionable();
  this.setActionableState({
    combineFeatures: true,
    uncombineFeatures: true,
    trash: true
  });
  return state;
};
SimpleSelect.fireUpdate = function() {
  this.map.fire(Constants$b.events.UPDATE, {
    action: Constants$b.updateActions.MOVE,
    features: this.getSelected().map((f2) => f2.toGeoJSON())
  });
};
SimpleSelect.fireActionable = function() {
  const selectedFeatures = this.getSelected();
  const multiFeatures = selectedFeatures.filter(
    (feature2) => this.isInstanceOf("MultiFeature", feature2)
  );
  let combineFeatures = false;
  if (selectedFeatures.length > 1) {
    combineFeatures = true;
    const featureType = selectedFeatures[0].type.replace("Multi", "");
    selectedFeatures.forEach((feature2) => {
      if (feature2.type.replace("Multi", "") !== featureType) {
        combineFeatures = false;
      }
    });
  }
  const uncombineFeatures = multiFeatures.length > 0;
  const trash = selectedFeatures.length > 0;
  this.setActionableState({
    combineFeatures,
    uncombineFeatures,
    trash
  });
};
SimpleSelect.getUniqueIds = function(allFeatures) {
  if (!allFeatures.length)
    return [];
  const ids = allFeatures.map((s2) => s2.properties.id).filter((id) => id !== void 0).reduce((memo, id) => {
    memo.add(id);
    return memo;
  }, new StringSet$1());
  return ids.values();
};
SimpleSelect.stopExtendedInteractions = function(state) {
  if (state.boxSelectElement) {
    if (state.boxSelectElement.parentNode)
      state.boxSelectElement.parentNode.removeChild(state.boxSelectElement);
    state.boxSelectElement = null;
  }
  this.map.dragPan.enable();
  state.boxSelecting = false;
  state.canBoxSelect = false;
  state.dragMoving = false;
  state.canDragMove = false;
};
SimpleSelect.onStop = function() {
  doubleClickZoom$7.enable(this);
};
SimpleSelect.onMouseMove = function(state) {
  return this.stopExtendedInteractions(state);
};
SimpleSelect.onMouseOut = function(state) {
  if (state.dragMoving)
    return this.fireUpdate();
};
SimpleSelect.onTap = SimpleSelect.onClick = function(state, e3) {
  if (CommonSelectors$4.noTarget(e3))
    return this.clickAnywhere(state, e3);
  if (CommonSelectors$4.isOfMetaType(Constants$b.meta.VERTEX)(e3))
    return this.clickOnVertex(state, e3);
  if (CommonSelectors$4.isFeature(e3))
    return this.clickOnFeature(state, e3);
};
SimpleSelect.clickAnywhere = function(state) {
  const wasSelected = this.getSelectedIds();
  if (wasSelected.length) {
    this.clearSelectedFeatures();
    wasSelected.forEach((id) => this.doRender(id));
  }
  doubleClickZoom$7.enable(this);
  this.stopExtendedInteractions(state);
};
SimpleSelect.clickOnVertex = function(state, e3) {
  this.changeMode(Constants$b.modes.DIRECT_SELECT, {
    featureId: e3.featureTarget.properties.parent,
    coordPath: e3.featureTarget.properties.coord_path,
    startPos: e3.lngLat
  });
  this.updateUIClasses({ mouse: Constants$b.cursors.MOVE });
};
SimpleSelect.startOnActiveFeature = function(state, e3) {
  this.stopExtendedInteractions(state);
  this.map.dragPan.disable();
  this.doRender(e3.featureTarget.properties.id);
  state.canDragMove = true;
  state.dragMoveLocation = e3.lngLat;
};
SimpleSelect.clickOnFeature = function(state, e3) {
  doubleClickZoom$7.disable(this);
  this.stopExtendedInteractions(state);
  const isShiftClick = CommonSelectors$4.isShiftDown(e3);
  const selectedFeatureIds = this.getSelectedIds();
  const featureId = e3.featureTarget.properties.id;
  const isFeatureSelected = this.isSelected(featureId);
  if (!isShiftClick && isFeatureSelected && this.getFeature(featureId).type !== Constants$b.geojsonTypes.POINT) {
    return this.changeMode(Constants$b.modes.DIRECT_SELECT, {
      featureId
    });
  }
  if (isFeatureSelected && isShiftClick) {
    this.deselect(featureId);
    this.updateUIClasses({ mouse: Constants$b.cursors.POINTER });
    if (selectedFeatureIds.length === 1) {
      doubleClickZoom$7.enable(this);
    }
  } else if (!isFeatureSelected && isShiftClick) {
    this.select(featureId);
    this.updateUIClasses({ mouse: Constants$b.cursors.MOVE });
  } else if (!isFeatureSelected && !isShiftClick) {
    selectedFeatureIds.forEach((id) => this.doRender(id));
    this.setSelected(featureId);
    this.updateUIClasses({ mouse: Constants$b.cursors.MOVE });
  }
  this.doRender(featureId);
};
SimpleSelect.onMouseDown = function(state, e3) {
  if (CommonSelectors$4.isActiveFeature(e3))
    return this.startOnActiveFeature(state, e3);
  if (this.drawConfig.boxSelect && CommonSelectors$4.isShiftMousedown(e3))
    return this.startBoxSelect(state, e3);
};
SimpleSelect.startBoxSelect = function(state, e3) {
  this.stopExtendedInteractions(state);
  this.map.dragPan.disable();
  state.boxSelectStartLocation = mouseEventPoint(e3.originalEvent, this.map.getContainer());
  state.canBoxSelect = true;
};
SimpleSelect.onTouchStart = function(state, e3) {
  if (CommonSelectors$4.isActiveFeature(e3))
    return this.startOnActiveFeature(state, e3);
};
SimpleSelect.onDrag = function(state, e3) {
  if (state.canDragMove)
    return this.dragMove(state, e3);
  if (this.drawConfig.boxSelect && state.canBoxSelect)
    return this.whileBoxSelect(state, e3);
};
SimpleSelect.whileBoxSelect = function(state, e3) {
  state.boxSelecting = true;
  this.updateUIClasses({ mouse: Constants$b.cursors.ADD });
  if (!state.boxSelectElement) {
    state.boxSelectElement = document.createElement("div");
    state.boxSelectElement.classList.add(Constants$b.classes.BOX_SELECT);
    this.map.getContainer().appendChild(state.boxSelectElement);
  }
  const current = mouseEventPoint(e3.originalEvent, this.map.getContainer());
  const minX2 = Math.min(state.boxSelectStartLocation.x, current.x);
  const maxX2 = Math.max(state.boxSelectStartLocation.x, current.x);
  const minY2 = Math.min(state.boxSelectStartLocation.y, current.y);
  const maxY2 = Math.max(state.boxSelectStartLocation.y, current.y);
  const translateValue = `translate(${minX2}px, ${minY2}px)`;
  state.boxSelectElement.style.transform = translateValue;
  state.boxSelectElement.style.WebkitTransform = translateValue;
  state.boxSelectElement.style.width = `${maxX2 - minX2}px`;
  state.boxSelectElement.style.height = `${maxY2 - minY2}px`;
};
SimpleSelect.dragMove = function(state, e3) {
  state.dragMoving = true;
  e3.originalEvent.stopPropagation();
  const delta = {
    lng: e3.lngLat.lng - state.dragMoveLocation.lng,
    lat: e3.lngLat.lat - state.dragMoveLocation.lat
  };
  moveFeatures$3(this.getSelected(), delta);
  state.dragMoveLocation = e3.lngLat;
};
SimpleSelect.onMouseUp = function(state, e3) {
  if (state.dragMoving) {
    this.fireUpdate();
  } else if (state.boxSelecting) {
    const bbox2 = [
      state.boxSelectStartLocation,
      mouseEventPoint(e3.originalEvent, this.map.getContainer())
    ];
    const featuresInBox = this.featuresAt(null, bbox2, "click");
    const idsToSelect = this.getUniqueIds(featuresInBox).filter((id) => !this.isSelected(id));
    if (idsToSelect.length) {
      this.select(idsToSelect);
      idsToSelect.forEach((id) => this.doRender(id));
      this.updateUIClasses({ mouse: Constants$b.cursors.MOVE });
    }
  }
  this.stopExtendedInteractions(state);
};
SimpleSelect.toDisplayFeatures = function(state, geojson, display) {
  geojson.properties.active = this.isSelected(geojson.properties.id) ? Constants$b.activeStates.ACTIVE : Constants$b.activeStates.INACTIVE;
  display(geojson);
  this.fireActionable();
  if (geojson.properties.active !== Constants$b.activeStates.ACTIVE || geojson.geometry.type === Constants$b.geojsonTypes.POINT)
    return;
  createSupplementaryPoints$3(geojson).forEach(display);
};
SimpleSelect.onTrash = function() {
  this.deleteFeature(this.getSelectedIds());
  this.fireActionable();
};
SimpleSelect.onCombineFeatures = function() {
  const selectedFeatures = this.getSelected();
  if (selectedFeatures.length === 0 || selectedFeatures.length < 2)
    return;
  const coordinates2 = [], featuresCombined = [];
  const featureType = selectedFeatures[0].type.replace("Multi", "");
  for (let i2 = 0; i2 < selectedFeatures.length; i2++) {
    const feature2 = selectedFeatures[i2];
    if (feature2.type.replace("Multi", "") !== featureType) {
      return;
    }
    if (feature2.type.includes("Multi")) {
      feature2.getCoordinates().forEach((subcoords) => {
        coordinates2.push(subcoords);
      });
    } else {
      coordinates2.push(feature2.getCoordinates());
    }
    featuresCombined.push(feature2.toGeoJSON());
  }
  if (featuresCombined.length > 1) {
    const multiFeature = this.newFeature({
      type: Constants$b.geojsonTypes.FEATURE,
      properties: featuresCombined[0].properties,
      geometry: {
        type: `Multi${featureType}`,
        coordinates: coordinates2
      }
    });
    this.addFeature(multiFeature);
    this.deleteFeature(this.getSelectedIds(), { silent: true });
    this.setSelected([multiFeature.id]);
    this.map.fire(Constants$b.events.COMBINE_FEATURES, {
      createdFeatures: [multiFeature.toGeoJSON()],
      deletedFeatures: featuresCombined
    });
  }
  this.fireActionable();
};
SimpleSelect.onUncombineFeatures = function() {
  const selectedFeatures = this.getSelected();
  if (selectedFeatures.length === 0)
    return;
  const createdFeatures = [];
  const featuresUncombined = [];
  for (let i2 = 0; i2 < selectedFeatures.length; i2++) {
    const feature2 = selectedFeatures[i2];
    if (this.isInstanceOf("MultiFeature", feature2)) {
      feature2.getFeatures().forEach((subFeature) => {
        this.addFeature(subFeature);
        subFeature.properties = feature2.properties;
        createdFeatures.push(subFeature.toGeoJSON());
        this.select([subFeature.id]);
      });
      this.deleteFeature(feature2.id, { silent: true });
      featuresUncombined.push(feature2.toGeoJSON());
    }
  }
  if (createdFeatures.length > 1) {
    this.map.fire(Constants$b.events.UNCOMBINE_FEATURES, {
      createdFeatures,
      deletedFeatures: featuresUncombined
    });
  }
  this.fireActionable();
};
var simple_select = SimpleSelect;
const { noTarget, isOfMetaType, isInactiveFeature, isShiftDown } = common_selectors;
const createSupplementaryPoints$2 = create_supplementary_points;
const constrainFeatureMovement$1 = constrain_feature_movement;
const doubleClickZoom$6 = double_click_zoom;
const Constants$a = constants$6;
const CommonSelectors$3 = common_selectors;
const moveFeatures$2 = move_features;
const isVertex = isOfMetaType(Constants$a.meta.VERTEX);
const isMidpoint = isOfMetaType(Constants$a.meta.MIDPOINT);
const DirectSelect = {};
DirectSelect.fireUpdate = function() {
  this.map.fire(Constants$a.events.UPDATE, {
    action: Constants$a.updateActions.CHANGE_COORDINATES,
    features: this.getSelected().map((f2) => f2.toGeoJSON())
  });
};
DirectSelect.fireActionable = function(state) {
  this.setActionableState({
    combineFeatures: false,
    uncombineFeatures: false,
    trash: state.selectedCoordPaths.length > 0
  });
};
DirectSelect.startDragging = function(state, e3) {
  this.map.dragPan.disable();
  state.canDragMove = true;
  state.dragMoveLocation = e3.lngLat;
};
DirectSelect.stopDragging = function(state) {
  this.map.dragPan.enable();
  state.dragMoving = false;
  state.canDragMove = false;
  state.dragMoveLocation = null;
};
DirectSelect.onVertex = function(state, e3) {
  this.startDragging(state, e3);
  const about = e3.featureTarget.properties;
  const selectedIndex = state.selectedCoordPaths.indexOf(about.coord_path);
  if (!isShiftDown(e3) && selectedIndex === -1) {
    state.selectedCoordPaths = [about.coord_path];
  } else if (isShiftDown(e3) && selectedIndex === -1) {
    state.selectedCoordPaths.push(about.coord_path);
  }
  const selectedCoordinates = this.pathsToCoordinates(state.featureId, state.selectedCoordPaths);
  this.setSelectedCoordinates(selectedCoordinates);
};
DirectSelect.onMidpoint = function(state, e3) {
  this.startDragging(state, e3);
  const about = e3.featureTarget.properties;
  state.feature.addCoordinate(about.coord_path, about.lng, about.lat);
  this.fireUpdate();
  state.selectedCoordPaths = [about.coord_path];
};
DirectSelect.pathsToCoordinates = function(featureId, paths) {
  return paths.map((coord_path) => {
    return { feature_id: featureId, coord_path };
  });
};
DirectSelect.onFeature = function(state, e3) {
  if (state.selectedCoordPaths.length === 0)
    this.startDragging(state, e3);
  else
    this.stopDragging(state);
};
DirectSelect.dragFeature = function(state, e3, delta) {
  moveFeatures$2(this.getSelected(), delta);
  state.dragMoveLocation = e3.lngLat;
};
DirectSelect.dragVertex = function(state, e3, delta) {
  const selectedCoords = state.selectedCoordPaths.map((coord_path) => state.feature.getCoordinate(coord_path));
  const selectedCoordPoints = selectedCoords.map((coords) => ({
    type: Constants$a.geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: Constants$a.geojsonTypes.POINT,
      coordinates: coords
    }
  }));
  const constrainedDelta = constrainFeatureMovement$1(selectedCoordPoints, delta);
  for (let i2 = 0; i2 < selectedCoords.length; i2++) {
    const coord = selectedCoords[i2];
    state.feature.updateCoordinate(state.selectedCoordPaths[i2], coord[0] + constrainedDelta.lng, coord[1] + constrainedDelta.lat);
  }
};
DirectSelect.clickNoTarget = function() {
  this.changeMode(Constants$a.modes.SIMPLE_SELECT);
};
DirectSelect.clickInactive = function() {
  this.changeMode(Constants$a.modes.SIMPLE_SELECT);
};
DirectSelect.clickActiveFeature = function(state) {
  state.selectedCoordPaths = [];
  this.clearSelectedCoordinates();
  state.feature.changed();
};
DirectSelect.onSetup = function(opts) {
  const featureId = opts.featureId;
  const feature2 = this.getFeature(featureId);
  if (!feature2) {
    throw new Error("You must provide a featureId to enter direct_select mode");
  }
  if (feature2.type === Constants$a.geojsonTypes.POINT) {
    throw new TypeError("direct_select mode doesn't handle point features");
  }
  const state = {
    featureId,
    feature: feature2,
    dragMoveLocation: opts.startPos || null,
    dragMoving: false,
    canDragMove: false,
    selectedCoordPaths: opts.coordPath ? [opts.coordPath] : []
  };
  this.setSelectedCoordinates(this.pathsToCoordinates(featureId, state.selectedCoordPaths));
  this.setSelected(featureId);
  doubleClickZoom$6.disable(this);
  this.setActionableState({
    trash: true
  });
  return state;
};
DirectSelect.onStop = function() {
  doubleClickZoom$6.enable(this);
  this.clearSelectedCoordinates();
};
DirectSelect.toDisplayFeatures = function(state, geojson, push2) {
  if (state.featureId === geojson.properties.id) {
    geojson.properties.active = Constants$a.activeStates.ACTIVE;
    push2(geojson);
    createSupplementaryPoints$2(geojson, {
      map: this.map,
      midpoints: true,
      selectedPaths: state.selectedCoordPaths
    }).forEach(push2);
  } else {
    geojson.properties.active = Constants$a.activeStates.INACTIVE;
    push2(geojson);
  }
  this.fireActionable(state);
};
DirectSelect.onTrash = function(state) {
  state.selectedCoordPaths.sort().reverse().forEach((id) => state.feature.removeCoordinate(id));
  this.fireUpdate();
  state.selectedCoordPaths = [];
  this.clearSelectedCoordinates();
  this.fireActionable(state);
  if (state.feature.isValid() === false) {
    this.deleteFeature([state.featureId]);
    this.changeMode(Constants$a.modes.SIMPLE_SELECT, {});
  }
};
DirectSelect.onMouseMove = function(state, e3) {
  const isFeature2 = CommonSelectors$3.isActiveFeature(e3);
  const onVertex = isVertex(e3);
  const noCoords = state.selectedCoordPaths.length === 0;
  if (isFeature2 && noCoords)
    this.updateUIClasses({ mouse: Constants$a.cursors.MOVE });
  else if (onVertex && !noCoords)
    this.updateUIClasses({ mouse: Constants$a.cursors.MOVE });
  else
    this.updateUIClasses({ mouse: Constants$a.cursors.NONE });
  this.stopDragging(state);
};
DirectSelect.onMouseOut = function(state) {
  if (state.dragMoving)
    this.fireUpdate();
};
DirectSelect.onTouchStart = DirectSelect.onMouseDown = function(state, e3) {
  if (isVertex(e3))
    return this.onVertex(state, e3);
  if (CommonSelectors$3.isActiveFeature(e3))
    return this.onFeature(state, e3);
  if (isMidpoint(e3))
    return this.onMidpoint(state, e3);
};
DirectSelect.onDrag = function(state, e3) {
  if (state.canDragMove !== true)
    return;
  state.dragMoving = true;
  e3.originalEvent.stopPropagation();
  const delta = {
    lng: e3.lngLat.lng - state.dragMoveLocation.lng,
    lat: e3.lngLat.lat - state.dragMoveLocation.lat
  };
  if (state.selectedCoordPaths.length > 0)
    this.dragVertex(state, e3, delta);
  else
    this.dragFeature(state, e3, delta);
  state.dragMoveLocation = e3.lngLat;
};
DirectSelect.onClick = function(state, e3) {
  if (noTarget(e3))
    return this.clickNoTarget(state, e3);
  if (CommonSelectors$3.isActiveFeature(e3))
    return this.clickActiveFeature(state, e3);
  if (isInactiveFeature(e3))
    return this.clickInactive(state, e3);
  this.stopDragging(state);
};
DirectSelect.onTap = function(state, e3) {
  if (noTarget(e3))
    return this.clickNoTarget(state, e3);
  if (CommonSelectors$3.isActiveFeature(e3))
    return this.clickActiveFeature(state, e3);
  if (isInactiveFeature(e3))
    return this.clickInactive(state, e3);
};
DirectSelect.onTouchEnd = DirectSelect.onMouseUp = function(state) {
  if (state.dragMoving) {
    this.fireUpdate();
  }
  this.stopDragging(state);
};
var direct_select = DirectSelect;
const CommonSelectors$2 = common_selectors;
const Constants$9 = constants$6;
const DrawPoint = {};
DrawPoint.onSetup = function() {
  const point4 = this.newFeature({
    type: Constants$9.geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: Constants$9.geojsonTypes.POINT,
      coordinates: []
    }
  });
  this.addFeature(point4);
  this.clearSelectedFeatures();
  this.updateUIClasses({ mouse: Constants$9.cursors.ADD });
  this.activateUIButton(Constants$9.types.POINT);
  this.setActionableState({
    trash: true
  });
  return { point: point4 };
};
DrawPoint.stopDrawingAndRemove = function(state) {
  this.deleteFeature([state.point.id], { silent: true });
  this.changeMode(Constants$9.modes.SIMPLE_SELECT);
};
DrawPoint.onTap = DrawPoint.onClick = function(state, e3) {
  this.updateUIClasses({ mouse: Constants$9.cursors.MOVE });
  state.point.updateCoordinate("", e3.lngLat.lng, e3.lngLat.lat);
  this.map.fire(Constants$9.events.CREATE, {
    features: [state.point.toGeoJSON()]
  });
  this.changeMode(Constants$9.modes.SIMPLE_SELECT, { featureIds: [state.point.id] });
};
DrawPoint.onStop = function(state) {
  this.activateUIButton();
  if (!state.point.getCoordinate().length) {
    this.deleteFeature([state.point.id], { silent: true });
  }
};
DrawPoint.toDisplayFeatures = function(state, geojson, display) {
  const isActivePoint = geojson.properties.id === state.point.id;
  geojson.properties.active = isActivePoint ? Constants$9.activeStates.ACTIVE : Constants$9.activeStates.INACTIVE;
  if (!isActivePoint)
    return display(geojson);
};
DrawPoint.onTrash = DrawPoint.stopDrawingAndRemove;
DrawPoint.onKeyUp = function(state, e3) {
  if (CommonSelectors$2.isEscapeKey(e3) || CommonSelectors$2.isEnterKey(e3)) {
    return this.stopDrawingAndRemove(state, e3);
  }
};
var draw_point = DrawPoint;
function isEventAtCoordinates$2(event, coordinates2) {
  if (!event.lngLat)
    return false;
  return event.lngLat.lng === coordinates2[0] && event.lngLat.lat === coordinates2[1];
}
var is_event_at_coordinates = isEventAtCoordinates$2;
const CommonSelectors$1 = common_selectors;
const doubleClickZoom$5 = double_click_zoom;
const Constants$8 = constants$6;
const isEventAtCoordinates$1 = is_event_at_coordinates;
const createVertex$3 = create_vertex;
const DrawPolygon = {};
DrawPolygon.onSetup = function() {
  const polygon4 = this.newFeature({
    type: Constants$8.geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: Constants$8.geojsonTypes.POLYGON,
      coordinates: [[]]
    }
  });
  this.addFeature(polygon4);
  this.clearSelectedFeatures();
  doubleClickZoom$5.disable(this);
  this.updateUIClasses({ mouse: Constants$8.cursors.ADD });
  this.activateUIButton(Constants$8.types.POLYGON);
  this.setActionableState({
    trash: true
  });
  return {
    polygon: polygon4,
    currentVertexPosition: 0
  };
};
DrawPolygon.clickAnywhere = function(state, e3) {
  if (state.currentVertexPosition > 0 && isEventAtCoordinates$1(e3, state.polygon.coordinates[0][state.currentVertexPosition - 1])) {
    return this.changeMode(Constants$8.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
  }
  this.updateUIClasses({ mouse: Constants$8.cursors.ADD });
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e3.lngLat.lng, e3.lngLat.lat);
  state.currentVertexPosition++;
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e3.lngLat.lng, e3.lngLat.lat);
};
DrawPolygon.clickOnVertex = function(state) {
  return this.changeMode(Constants$8.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
};
DrawPolygon.onMouseMove = function(state, e3) {
  state.polygon.updateCoordinate(`0.${state.currentVertexPosition}`, e3.lngLat.lng, e3.lngLat.lat);
  if (CommonSelectors$1.isVertex(e3)) {
    this.updateUIClasses({ mouse: Constants$8.cursors.POINTER });
  }
};
DrawPolygon.onTap = DrawPolygon.onClick = function(state, e3) {
  if (CommonSelectors$1.isVertex(e3))
    return this.clickOnVertex(state, e3);
  return this.clickAnywhere(state, e3);
};
DrawPolygon.onKeyUp = function(state, e3) {
  if (CommonSelectors$1.isEscapeKey(e3)) {
    this.deleteFeature([state.polygon.id], { silent: true });
    this.changeMode(Constants$8.modes.SIMPLE_SELECT);
  } else if (CommonSelectors$1.isEnterKey(e3)) {
    this.changeMode(Constants$8.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
  }
};
DrawPolygon.onStop = function(state) {
  this.updateUIClasses({ mouse: Constants$8.cursors.NONE });
  doubleClickZoom$5.enable(this);
  this.activateUIButton();
  if (this.getFeature(state.polygon.id) === void 0)
    return;
  state.polygon.removeCoordinate(`0.${state.currentVertexPosition}`);
  if (state.polygon.isValid()) {
    this.map.fire(Constants$8.events.CREATE, {
      features: [state.polygon.toGeoJSON()]
    });
  } else {
    this.deleteFeature([state.polygon.id], { silent: true });
    this.changeMode(Constants$8.modes.SIMPLE_SELECT, {}, { silent: true });
  }
};
DrawPolygon.toDisplayFeatures = function(state, geojson, display) {
  const isActivePolygon = geojson.properties.id === state.polygon.id;
  geojson.properties.active = isActivePolygon ? Constants$8.activeStates.ACTIVE : Constants$8.activeStates.INACTIVE;
  if (!isActivePolygon)
    return display(geojson);
  if (geojson.geometry.coordinates.length === 0)
    return;
  const coordinateCount = geojson.geometry.coordinates[0].length;
  if (coordinateCount < 3) {
    return;
  }
  geojson.properties.meta = Constants$8.meta.FEATURE;
  display(createVertex$3(state.polygon.id, geojson.geometry.coordinates[0][0], "0.0", false));
  if (coordinateCount > 3) {
    const endPos2 = geojson.geometry.coordinates[0].length - 3;
    display(createVertex$3(state.polygon.id, geojson.geometry.coordinates[0][endPos2], `0.${endPos2}`, false));
  }
  if (coordinateCount <= 4) {
    const lineCoordinates = [
      [geojson.geometry.coordinates[0][0][0], geojson.geometry.coordinates[0][0][1]],
      [geojson.geometry.coordinates[0][1][0], geojson.geometry.coordinates[0][1][1]]
    ];
    display({
      type: Constants$8.geojsonTypes.FEATURE,
      properties: geojson.properties,
      geometry: {
        coordinates: lineCoordinates,
        type: Constants$8.geojsonTypes.LINE_STRING
      }
    });
    if (coordinateCount === 3) {
      return;
    }
  }
  return display(geojson);
};
DrawPolygon.onTrash = function(state) {
  this.deleteFeature([state.polygon.id], { silent: true });
  this.changeMode(Constants$8.modes.SIMPLE_SELECT);
};
var draw_polygon = DrawPolygon;
const CommonSelectors = common_selectors;
const isEventAtCoordinates = is_event_at_coordinates;
const doubleClickZoom$4 = double_click_zoom;
const Constants$7 = constants$6;
const createVertex$2 = create_vertex;
const DrawLineString = {};
DrawLineString.onSetup = function(opts) {
  opts = opts || {};
  const featureId = opts.featureId;
  let line, currentVertexPosition;
  let direction = "forward";
  if (featureId) {
    line = this.getFeature(featureId);
    if (!line) {
      throw new Error("Could not find a feature with the provided featureId");
    }
    let from = opts.from;
    if (from && from.type === "Feature" && from.geometry && from.geometry.type === "Point") {
      from = from.geometry;
    }
    if (from && from.type === "Point" && from.coordinates && from.coordinates.length === 2) {
      from = from.coordinates;
    }
    if (!from || !Array.isArray(from)) {
      throw new Error("Please use the `from` property to indicate which point to continue the line from");
    }
    const lastCoord = line.coordinates.length - 1;
    if (line.coordinates[lastCoord][0] === from[0] && line.coordinates[lastCoord][1] === from[1]) {
      currentVertexPosition = lastCoord + 1;
      line.addCoordinate(currentVertexPosition, ...line.coordinates[lastCoord]);
    } else if (line.coordinates[0][0] === from[0] && line.coordinates[0][1] === from[1]) {
      direction = "backwards";
      currentVertexPosition = 0;
      line.addCoordinate(currentVertexPosition, ...line.coordinates[0]);
    } else {
      throw new Error("`from` should match the point at either the start or the end of the provided LineString");
    }
  } else {
    line = this.newFeature({
      type: Constants$7.geojsonTypes.FEATURE,
      properties: {},
      geometry: {
        type: Constants$7.geojsonTypes.LINE_STRING,
        coordinates: []
      }
    });
    currentVertexPosition = 0;
    this.addFeature(line);
  }
  this.clearSelectedFeatures();
  doubleClickZoom$4.disable(this);
  this.updateUIClasses({ mouse: Constants$7.cursors.ADD });
  this.activateUIButton(Constants$7.types.LINE);
  this.setActionableState({
    trash: true
  });
  return {
    line,
    currentVertexPosition,
    direction
  };
};
DrawLineString.clickAnywhere = function(state, e3) {
  if (state.currentVertexPosition > 0 && isEventAtCoordinates(e3, state.line.coordinates[state.currentVertexPosition - 1]) || state.direction === "backwards" && isEventAtCoordinates(e3, state.line.coordinates[state.currentVertexPosition + 1])) {
    return this.changeMode(Constants$7.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
  }
  this.updateUIClasses({ mouse: Constants$7.cursors.ADD });
  state.line.updateCoordinate(state.currentVertexPosition, e3.lngLat.lng, e3.lngLat.lat);
  if (state.direction === "forward") {
    state.currentVertexPosition++;
    state.line.updateCoordinate(state.currentVertexPosition, e3.lngLat.lng, e3.lngLat.lat);
  } else {
    state.line.addCoordinate(0, e3.lngLat.lng, e3.lngLat.lat);
  }
};
DrawLineString.clickOnVertex = function(state) {
  return this.changeMode(Constants$7.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
};
DrawLineString.onMouseMove = function(state, e3) {
  state.line.updateCoordinate(state.currentVertexPosition, e3.lngLat.lng, e3.lngLat.lat);
  if (CommonSelectors.isVertex(e3)) {
    this.updateUIClasses({ mouse: Constants$7.cursors.POINTER });
  }
};
DrawLineString.onTap = DrawLineString.onClick = function(state, e3) {
  if (CommonSelectors.isVertex(e3))
    return this.clickOnVertex(state, e3);
  this.clickAnywhere(state, e3);
};
DrawLineString.onKeyUp = function(state, e3) {
  if (CommonSelectors.isEnterKey(e3)) {
    this.changeMode(Constants$7.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
  } else if (CommonSelectors.isEscapeKey(e3)) {
    this.deleteFeature([state.line.id], { silent: true });
    this.changeMode(Constants$7.modes.SIMPLE_SELECT);
  }
};
DrawLineString.onStop = function(state) {
  doubleClickZoom$4.enable(this);
  this.activateUIButton();
  if (this.getFeature(state.line.id) === void 0)
    return;
  state.line.removeCoordinate(`${state.currentVertexPosition}`);
  if (state.line.isValid()) {
    this.map.fire(Constants$7.events.CREATE, {
      features: [state.line.toGeoJSON()]
    });
  } else {
    this.deleteFeature([state.line.id], { silent: true });
    this.changeMode(Constants$7.modes.SIMPLE_SELECT, {}, { silent: true });
  }
};
DrawLineString.onTrash = function(state) {
  this.deleteFeature([state.line.id], { silent: true });
  this.changeMode(Constants$7.modes.SIMPLE_SELECT);
};
DrawLineString.toDisplayFeatures = function(state, geojson, display) {
  const isActiveLine = geojson.properties.id === state.line.id;
  geojson.properties.active = isActiveLine ? Constants$7.activeStates.ACTIVE : Constants$7.activeStates.INACTIVE;
  if (!isActiveLine)
    return display(geojson);
  if (geojson.geometry.coordinates.length < 2)
    return;
  geojson.properties.meta = Constants$7.meta.FEATURE;
  display(createVertex$2(
    state.line.id,
    geojson.geometry.coordinates[state.direction === "forward" ? geojson.geometry.coordinates.length - 2 : 1],
    `${state.direction === "forward" ? geojson.geometry.coordinates.length - 2 : 1}`,
    false
  ));
  display(geojson);
};
var draw_line_string = DrawLineString;
var modes = {
  simple_select,
  direct_select,
  draw_point,
  draw_polygon,
  draw_line_string
};
const xtend$4 = immutable;
const Constants$6 = constants$6;
const defaultOptions = {
  defaultMode: Constants$6.modes.SIMPLE_SELECT,
  keybindings: true,
  touchEnabled: true,
  clickBuffer: 2,
  touchBuffer: 25,
  boxSelect: true,
  displayControlsDefault: true,
  styles: theme,
  modes,
  controls: {},
  userProperties: false
};
const showControls = {
  point: true,
  line_string: true,
  polygon: true,
  trash: true,
  combine_features: true,
  uncombine_features: true
};
const hideControls = {
  point: false,
  line_string: false,
  polygon: false,
  trash: false,
  combine_features: false,
  uncombine_features: false
};
function addSources(styles2, sourceBucket) {
  return styles2.map((style2) => {
    if (style2.source)
      return style2;
    return xtend$4(style2, {
      id: `${style2.id}.${sourceBucket}`,
      source: sourceBucket === "hot" ? Constants$6.sources.HOT : Constants$6.sources.COLD
    });
  });
}
var options = function(options2 = {}) {
  let withDefaults = xtend$4(options2);
  if (!options2.controls) {
    withDefaults.controls = {};
  }
  if (options2.displayControlsDefault === false) {
    withDefaults.controls = xtend$4(hideControls, options2.controls);
  } else {
    withDefaults.controls = xtend$4(showControls, options2.controls);
  }
  withDefaults = xtend$4(defaultOptions, withDefaults);
  withDefaults.styles = addSources(withDefaults.styles, "cold").concat(addSources(withDefaults.styles, "hot"));
  return withDefaults;
};
var string_sets_are_equal = function(a2, b2) {
  if (a2.length !== b2.length)
    return false;
  return JSON.stringify(a2.map((id) => id).sort()) === JSON.stringify(b2.map((id) => id).sort());
};
var lib$2 = {};
var object = {};
function rad(x2) {
  return x2 * Math.PI / 180;
}
function isRingClockwise(coords) {
  var area5 = 0;
  if (coords.length > 2) {
    var p1, p2;
    for (var i2 = 0; i2 < coords.length - 1; i2++) {
      p1 = coords[i2];
      p2 = coords[i2 + 1];
      area5 += rad(p2[0] - p1[0]) * (2 + Math.sin(rad(p1[1])) + Math.sin(rad(p2[1])));
    }
  }
  return area5 >= 0;
}
function isPolyRHR(coords) {
  if (coords && coords.length > 0) {
    if (isRingClockwise(coords[0]))
      return false;
    var interiorCoords = coords.slice(1, coords.length);
    if (!interiorCoords.every(isRingClockwise))
      return false;
  }
  return true;
}
function rightHandRule$1(geometry2) {
  if (geometry2.type === "Polygon") {
    return isPolyRHR(geometry2.coordinates);
  } else if (geometry2.type === "MultiPolygon") {
    return geometry2.coordinates.every(isPolyRHR);
  }
}
var rhr = function validateRightHandRule2(geometry2, errors) {
  if (!rightHandRule$1(geometry2)) {
    errors.push({
      message: "Polygons and MultiPolygons should follow the right-hand rule",
      level: "message",
      line: geometry2.__line__
    });
  }
};
var rightHandRule = rhr;
function hint$1(gj, options2) {
  var errors = [];
  var precisionWarningCount = 0;
  var maxPrecisionWarnings = 10;
  var maxPrecision = 6;
  function root2(_2) {
    if ((!options2 || options2.noDuplicateMembers !== false) && _2.__duplicateProperties__) {
      errors.push({
        message: "An object contained duplicate members, making parsing ambigous: " + _2.__duplicateProperties__.join(", "),
        line: _2.__line__
      });
    }
    if (requiredProperty(_2, "type", "string")) {
      return;
    }
    if (!types2[_2.type]) {
      var expectedType = typesLower[_2.type.toLowerCase()];
      if (expectedType !== void 0) {
        errors.push({
          message: "Expected " + expectedType + " but got " + _2.type + " (case sensitive)",
          line: _2.__line__
        });
      } else {
        errors.push({
          message: "The type " + _2.type + " is unknown",
          line: _2.__line__
        });
      }
    } else if (_2) {
      types2[_2.type](_2);
    }
  }
  function everyIs(_2, type) {
    return _2.every(function(x2) {
      return x2 !== null && typeof x2 === type;
    });
  }
  function requiredProperty(_2, name2, type) {
    if (typeof _2[name2] === "undefined") {
      return errors.push({
        message: '"' + name2 + '" member required',
        line: _2.__line__
      });
    } else if (type === "array") {
      if (!Array.isArray(_2[name2])) {
        return errors.push({
          message: '"' + name2 + '" member should be an array, but is an ' + typeof _2[name2] + " instead",
          line: _2.__line__
        });
      }
    } else if (type === "object" && _2[name2] && _2[name2].constructor !== Object) {
      return errors.push({
        message: '"' + name2 + '" member should be ' + type + ", but is an " + _2[name2].constructor.name + " instead",
        line: _2.__line__
      });
    } else if (type && typeof _2[name2] !== type) {
      return errors.push({
        message: '"' + name2 + '" member should be ' + type + ", but is an " + typeof _2[name2] + " instead",
        line: _2.__line__
      });
    }
  }
  function FeatureCollection(featureCollection2) {
    crs(featureCollection2);
    bbox2(featureCollection2);
    if (featureCollection2.properties !== void 0) {
      errors.push({
        message: 'FeatureCollection object cannot contain a "properties" member',
        line: featureCollection2.__line__
      });
    }
    if (featureCollection2.coordinates !== void 0) {
      errors.push({
        message: 'FeatureCollection object cannot contain a "coordinates" member',
        line: featureCollection2.__line__
      });
    }
    if (!requiredProperty(featureCollection2, "features", "array")) {
      if (!everyIs(featureCollection2.features, "object")) {
        return errors.push({
          message: "Every feature must be an object",
          line: featureCollection2.__line__
        });
      }
      featureCollection2.features.forEach(Feature2);
    }
  }
  function position(_2, line) {
    if (!Array.isArray(_2)) {
      return errors.push({
        message: "position should be an array, is a " + typeof _2 + " instead",
        line: _2.__line__ || line
      });
    }
    if (_2.length < 2) {
      return errors.push({
        message: "position must have 2 or more elements",
        line: _2.__line__ || line
      });
    }
    if (_2.length > 3) {
      return errors.push({
        message: "position should not have more than 3 elements",
        level: "message",
        line: _2.__line__ || line
      });
    }
    if (!everyIs(_2, "number")) {
      return errors.push({
        message: "each element in a position must be a number",
        line: _2.__line__ || line
      });
    }
    if (options2 && options2.precisionWarning) {
      if (precisionWarningCount === maxPrecisionWarnings) {
        precisionWarningCount += 1;
        return errors.push({
          message: "truncated warnings: we've encountered coordinate precision warning " + maxPrecisionWarnings + " times, no more warnings will be reported",
          level: "message",
          line: _2.__line__ || line
        });
      } else if (precisionWarningCount < maxPrecisionWarnings) {
        _2.forEach(function(num) {
          var precision = 0;
          var decimalStr = String(num).split(".")[1];
          if (decimalStr !== void 0)
            precision = decimalStr.length;
          if (precision > maxPrecision) {
            precisionWarningCount += 1;
            return errors.push({
              message: "precision of coordinates should be reduced",
              level: "message",
              line: _2.__line__ || line
            });
          }
        });
      }
    }
  }
  function positionArray(coords, type, depth2, line) {
    if (line === void 0 && coords.__line__ !== void 0) {
      line = coords.__line__;
    }
    if (depth2 === 0) {
      return position(coords, line);
    }
    if (depth2 === 1 && type) {
      if (type === "LinearRing") {
        if (!Array.isArray(coords[coords.length - 1])) {
          errors.push({
            message: "a number was found where a coordinate array should have been found: this needs to be nested more deeply",
            line
          });
          return true;
        }
        if (coords.length < 4) {
          errors.push({
            message: "a LinearRing of coordinates needs to have four or more positions",
            line
          });
        }
        if (coords.length && (coords[coords.length - 1].length !== coords[0].length || !coords[coords.length - 1].every(function(pos, index2) {
          return coords[0][index2] === pos;
        }))) {
          errors.push({
            message: "the first and last positions in a LinearRing of coordinates must be the same",
            line
          });
          return true;
        }
      } else if (type === "Line" && coords.length < 2) {
        return errors.push({
          message: "a line needs to have two or more coordinates to be valid",
          line
        });
      }
    }
    if (!Array.isArray(coords)) {
      errors.push({
        message: "a number was found where a coordinate array should have been found: this needs to be nested more deeply",
        line
      });
    } else {
      var results = coords.map(function(c2) {
        return positionArray(c2, type, depth2 - 1, c2.__line__ || line);
      });
      return results.some(function(r2) {
        return r2;
      });
    }
  }
  function crs(_2) {
    if (!_2.crs)
      return;
    var defaultCRSName = "urn:ogc:def:crs:OGC:1.3:CRS84";
    if (typeof _2.crs === "object" && _2.crs.properties && _2.crs.properties.name === defaultCRSName) {
      errors.push({
        message: "old-style crs member is not recommended, this object is equivalent to the default and should be removed",
        line: _2.__line__
      });
    } else {
      errors.push({
        message: "old-style crs member is not recommended",
        line: _2.__line__
      });
    }
  }
  function bbox2(_2) {
    if (!_2.bbox) {
      return;
    }
    if (Array.isArray(_2.bbox)) {
      if (!everyIs(_2.bbox, "number")) {
        errors.push({
          message: "each element in a bbox member must be a number",
          line: _2.bbox.__line__
        });
      }
      if (!(_2.bbox.length === 4 || _2.bbox.length === 6)) {
        errors.push({
          message: "bbox must contain 4 elements (for 2D) or 6 elements (for 3D)",
          line: _2.bbox.__line__
        });
      }
      return errors.length;
    }
    errors.push({
      message: "bbox member must be an array of numbers, but is a " + typeof _2.bbox,
      line: _2.__line__
    });
  }
  function geometrySemantics(geom) {
    if (geom.properties !== void 0) {
      errors.push({
        message: 'geometry object cannot contain a "properties" member',
        line: geom.__line__
      });
    }
    if (geom.geometry !== void 0) {
      errors.push({
        message: 'geometry object cannot contain a "geometry" member',
        line: geom.__line__
      });
    }
    if (geom.features !== void 0) {
      errors.push({
        message: 'geometry object cannot contain a "features" member',
        line: geom.__line__
      });
    }
  }
  function Point2(point4) {
    crs(point4);
    bbox2(point4);
    geometrySemantics(point4);
    if (!requiredProperty(point4, "coordinates", "array")) {
      position(point4.coordinates);
    }
  }
  function Polygon2(polygon4) {
    crs(polygon4);
    bbox2(polygon4);
    if (!requiredProperty(polygon4, "coordinates", "array")) {
      if (!positionArray(polygon4.coordinates, "LinearRing", 2)) {
        rightHandRule(polygon4, errors);
      }
    }
  }
  function MultiPolygon2(multiPolygon2) {
    crs(multiPolygon2);
    bbox2(multiPolygon2);
    if (!requiredProperty(multiPolygon2, "coordinates", "array")) {
      if (!positionArray(multiPolygon2.coordinates, "LinearRing", 3)) {
        rightHandRule(multiPolygon2, errors);
      }
    }
  }
  function LineString2(lineString2) {
    crs(lineString2);
    bbox2(lineString2);
    if (!requiredProperty(lineString2, "coordinates", "array")) {
      positionArray(lineString2.coordinates, "Line", 1);
    }
  }
  function MultiLineString2(multiLineString2) {
    crs(multiLineString2);
    bbox2(multiLineString2);
    if (!requiredProperty(multiLineString2, "coordinates", "array")) {
      positionArray(multiLineString2.coordinates, "Line", 2);
    }
  }
  function MultiPoint2(multiPoint2) {
    crs(multiPoint2);
    bbox2(multiPoint2);
    if (!requiredProperty(multiPoint2, "coordinates", "array")) {
      positionArray(multiPoint2.coordinates, "", 1);
    }
  }
  function GeometryCollection2(geometryCollection2) {
    crs(geometryCollection2);
    bbox2(geometryCollection2);
    if (!requiredProperty(geometryCollection2, "geometries", "array")) {
      if (!everyIs(geometryCollection2.geometries, "object")) {
        errors.push({
          message: "The geometries array in a GeometryCollection must contain only geometry objects",
          line: geometryCollection2.__line__
        });
      }
      if (geometryCollection2.geometries.length === 1) {
        errors.push({
          message: "GeometryCollection with a single geometry should be avoided in favor of single part or a single object of multi-part type",
          line: geometryCollection2.geometries.__line__
        });
      }
      geometryCollection2.geometries.forEach(function(geometry2) {
        if (geometry2) {
          if (geometry2.type === "GeometryCollection") {
            errors.push({
              message: "GeometryCollection should avoid nested geometry collections",
              line: geometryCollection2.geometries.__line__
            });
          }
          root2(geometry2);
        }
      });
    }
  }
  function Feature2(feature2) {
    crs(feature2);
    bbox2(feature2);
    if (feature2.id !== void 0 && typeof feature2.id !== "string" && typeof feature2.id !== "number") {
      errors.push({
        message: 'Feature "id" member must have a string or number value',
        line: feature2.__line__
      });
    }
    if (feature2.features !== void 0) {
      errors.push({
        message: 'Feature object cannot contain a "features" member',
        line: feature2.__line__
      });
    }
    if (feature2.coordinates !== void 0) {
      errors.push({
        message: 'Feature object cannot contain a "coordinates" member',
        line: feature2.__line__
      });
    }
    if (feature2.type !== "Feature") {
      errors.push({
        message: "GeoJSON features must have a type=feature member",
        line: feature2.__line__
      });
    }
    requiredProperty(feature2, "properties", "object");
    if (!requiredProperty(feature2, "geometry", "object")) {
      if (feature2.geometry)
        root2(feature2.geometry);
    }
  }
  var types2 = {
    Point: Point2,
    Feature: Feature2,
    MultiPoint: MultiPoint2,
    LineString: LineString2,
    MultiLineString: MultiLineString2,
    FeatureCollection,
    GeometryCollection: GeometryCollection2,
    Polygon: Polygon2,
    MultiPolygon: MultiPolygon2
  };
  var typesLower = Object.keys(types2).reduce(function(prev, curr) {
    prev[curr.toLowerCase()] = curr;
    return prev;
  }, {});
  if (typeof gj !== "object" || gj === null || gj === void 0) {
    errors.push({
      message: "The root of a GeoJSON object must be an object.",
      line: 0
    });
    return errors;
  }
  root2(gj);
  errors.forEach(function(err) {
    if ({}.hasOwnProperty.call(err, "line") && err.line === void 0) {
      delete err.line;
    }
  });
  return errors;
}
object.hint = hint$1;
var jsonlint = jsonlintExports, geojsonHintObject = object;
function hint(str, options2) {
  var gj, errors = [];
  if (typeof str === "object") {
    gj = str;
  } else if (typeof str === "string") {
    try {
      gj = jsonlint.parse(str);
    } catch (e3) {
      var match2 = e3.message.match(/line (\d+)/);
      var lineNumber = parseInt(match2[1], 10);
      return [{
        line: lineNumber - 1,
        message: e3.message,
        error: e3
      }];
    }
  } else {
    return [{
      message: "Expected string or object as input",
      line: 0
    }];
  }
  errors = errors.concat(geojsonHintObject.hint(gj, options2));
  return errors;
}
lib$2.hint = hint;
const isEqual = lodash_isequalExports;
const normalize = geojsonNormalize$1;
const hat = hatExports;
const featuresAt = features_at;
const stringSetsAreEqual = string_sets_are_equal;
const geojsonhint = lib$2;
const Constants$5 = constants$6;
const StringSet = string_set;
const featureTypes$1 = {
  Polygon: polygon$1,
  LineString: line_string,
  Point: point$1,
  MultiPolygon: multi_feature,
  MultiLineString: multi_feature,
  MultiPoint: multi_feature
};
var api = function(ctx2, api2) {
  api2.modes = Constants$5.modes;
  api2.getFeatureIdsAt = function(point4) {
    const features = featuresAt.click({ point: point4 }, null, ctx2);
    return features.map((feature2) => feature2.properties.id);
  };
  api2.getSelectedIds = function() {
    return ctx2.store.getSelectedIds();
  };
  api2.getSelected = function() {
    return {
      type: Constants$5.geojsonTypes.FEATURE_COLLECTION,
      features: ctx2.store.getSelectedIds().map((id) => ctx2.store.get(id)).map((feature2) => feature2.toGeoJSON())
    };
  };
  api2.getSelectedPoints = function() {
    return {
      type: Constants$5.geojsonTypes.FEATURE_COLLECTION,
      features: ctx2.store.getSelectedCoordinates().map((coordinate2) => {
        return {
          type: Constants$5.geojsonTypes.FEATURE,
          properties: {},
          geometry: {
            type: Constants$5.geojsonTypes.POINT,
            coordinates: coordinate2.coordinates
          }
        };
      })
    };
  };
  api2.set = function(featureCollection2) {
    if (featureCollection2.type === void 0 || featureCollection2.type !== Constants$5.geojsonTypes.FEATURE_COLLECTION || !Array.isArray(featureCollection2.features)) {
      throw new Error("Invalid FeatureCollection");
    }
    const renderBatch = ctx2.store.createRenderBatch();
    let toDelete = ctx2.store.getAllIds().slice();
    const newIds = api2.add(featureCollection2);
    const newIdsLookup = new StringSet(newIds);
    toDelete = toDelete.filter((id) => !newIdsLookup.has(id));
    if (toDelete.length) {
      api2.delete(toDelete);
    }
    renderBatch();
    return newIds;
  };
  api2.add = function(geojson) {
    const errors = geojsonhint.hint(geojson, { precisionWarning: false }).filter((e3) => e3.level !== "message");
    if (errors.length) {
      throw new Error(errors[0].message);
    }
    const featureCollection2 = JSON.parse(JSON.stringify(normalize(geojson)));
    const ids = featureCollection2.features.map((feature2) => {
      feature2.id = feature2.id || hat();
      if (feature2.geometry === null) {
        throw new Error("Invalid geometry: null");
      }
      if (ctx2.store.get(feature2.id) === void 0 || ctx2.store.get(feature2.id).type !== feature2.geometry.type) {
        const Model2 = featureTypes$1[feature2.geometry.type];
        if (Model2 === void 0) {
          throw new Error(`Invalid geometry type: ${feature2.geometry.type}.`);
        }
        const internalFeature = new Model2(ctx2, feature2);
        ctx2.store.add(internalFeature);
      } else {
        const internalFeature = ctx2.store.get(feature2.id);
        internalFeature.properties = feature2.properties;
        if (!isEqual(internalFeature.getCoordinates(), feature2.geometry.coordinates)) {
          internalFeature.incomingCoords(feature2.geometry.coordinates);
        }
      }
      return feature2.id;
    });
    ctx2.store.render();
    return ids;
  };
  api2.get = function(id) {
    const feature2 = ctx2.store.get(id);
    if (feature2) {
      return feature2.toGeoJSON();
    }
  };
  api2.getAll = function() {
    return {
      type: Constants$5.geojsonTypes.FEATURE_COLLECTION,
      features: ctx2.store.getAll().map((feature2) => feature2.toGeoJSON())
    };
  };
  api2.delete = function(featureIds) {
    ctx2.store.delete(featureIds, { silent: true });
    if (api2.getMode() === Constants$5.modes.DIRECT_SELECT && !ctx2.store.getSelectedIds().length) {
      ctx2.events.changeMode(Constants$5.modes.SIMPLE_SELECT, void 0, { silent: true });
    } else {
      ctx2.store.render();
    }
    return api2;
  };
  api2.deleteAll = function() {
    ctx2.store.delete(ctx2.store.getAllIds(), { silent: true });
    if (api2.getMode() === Constants$5.modes.DIRECT_SELECT) {
      ctx2.events.changeMode(Constants$5.modes.SIMPLE_SELECT, void 0, { silent: true });
    } else {
      ctx2.store.render();
    }
    return api2;
  };
  api2.changeMode = function(mode2, modeOptions = {}) {
    if (mode2 === Constants$5.modes.SIMPLE_SELECT && api2.getMode() === Constants$5.modes.SIMPLE_SELECT) {
      if (stringSetsAreEqual(modeOptions.featureIds || [], ctx2.store.getSelectedIds()))
        return api2;
      ctx2.store.setSelected(modeOptions.featureIds, { silent: true });
      ctx2.store.render();
      return api2;
    }
    if (mode2 === Constants$5.modes.DIRECT_SELECT && api2.getMode() === Constants$5.modes.DIRECT_SELECT && modeOptions.featureId === ctx2.store.getSelectedIds()[0]) {
      return api2;
    }
    ctx2.events.changeMode(mode2, modeOptions, { silent: true });
    return api2;
  };
  api2.getMode = function() {
    return ctx2.events.getMode();
  };
  api2.trash = function() {
    ctx2.events.trash({ silent: true });
    return api2;
  };
  api2.combineFeatures = function() {
    ctx2.events.combineFeatures({ silent: true });
    return api2;
  };
  api2.uncombineFeatures = function() {
    ctx2.events.uncombineFeatures({ silent: true });
    return api2;
  };
  api2.setFeatureProperty = function(featureId, property2, value) {
    ctx2.store.setFeatureProperty(featureId, property2, value);
    return api2;
  };
  return api2;
};
const runSetup = setup;
const setupOptions = options;
const setupAPI = api;
const Constants$4 = constants$6;
const setupDraw = function(options2, api2) {
  options2 = setupOptions(options2);
  const ctx2 = {
    options: options2
  };
  api2 = setupAPI(ctx2, api2);
  ctx2.api = api2;
  const setup2 = runSetup(ctx2);
  api2.onAdd = setup2.onAdd;
  api2.onRemove = setup2.onRemove;
  api2.types = Constants$4.types;
  api2.options = options2;
  return api2;
};
mapboxGlDraw.exports = function(options2) {
  setupDraw(options2, this);
};
mapboxGlDrawExports.modes = modes;
var js$2 = {};
var js$1 = {};
var earthRadius = 63710088e-1;
var factors = {
  meters: earthRadius,
  metres: earthRadius,
  millimeters: earthRadius * 1e3,
  millimetres: earthRadius * 1e3,
  centimeters: earthRadius * 100,
  centimetres: earthRadius * 100,
  kilometers: earthRadius / 1e3,
  kilometres: earthRadius / 1e3,
  miles: earthRadius / 1609.344,
  nauticalmiles: earthRadius / 1852,
  inches: earthRadius * 39.37,
  yards: earthRadius / 1.0936,
  feet: earthRadius * 3.28084,
  radians: 1,
  degrees: earthRadius / 111325
};
var unitsFactors = {
  meters: 1,
  metres: 1,
  millimeters: 1e3,
  millimetres: 1e3,
  centimeters: 100,
  centimetres: 100,
  kilometers: 1 / 1e3,
  kilometres: 1 / 1e3,
  miles: 1 / 1609.344,
  nauticalmiles: 1 / 1852,
  inches: 39.37,
  yards: 1 / 1.0936,
  feet: 3.28084,
  radians: 1 / earthRadius,
  degrees: 1 / 111325
};
var areaFactors = {
  meters: 1,
  metres: 1,
  millimeters: 1e6,
  millimetres: 1e6,
  centimeters: 1e4,
  centimetres: 1e4,
  kilometers: 1e-6,
  kilometres: 1e-6,
  acres: 247105e-9,
  miles: 386e-9,
  yards: 1.195990046,
  feet: 10.763910417,
  inches: 1550.003100006
};
function feature(geometry2, properties, options2) {
  options2 = options2 || {};
  if (!isObject$2(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (geometry2 === void 0)
    throw new Error("geometry is required");
  if (properties && properties.constructor !== Object)
    throw new Error("properties must be an Object");
  if (bbox2)
    validateBBox(bbox2);
  if (id)
    validateId(id);
  var feat = { type: "Feature" };
  if (id)
    feat.id = id;
  if (bbox2)
    feat.bbox = bbox2;
  feat.properties = properties || {};
  feat.geometry = geometry2;
  return feat;
}
function geometry(type, coordinates2, options2) {
  options2 = options2 || {};
  if (!isObject$2(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  if (!type)
    throw new Error("type is required");
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  if (bbox2)
    validateBBox(bbox2);
  var geom;
  switch (type) {
    case "Point":
      geom = point(coordinates2).geometry;
      break;
    case "LineString":
      geom = lineString(coordinates2).geometry;
      break;
    case "Polygon":
      geom = polygon(coordinates2).geometry;
      break;
    case "MultiPoint":
      geom = multiPoint(coordinates2).geometry;
      break;
    case "MultiLineString":
      geom = multiLineString(coordinates2).geometry;
      break;
    case "MultiPolygon":
      geom = multiPolygon(coordinates2).geometry;
      break;
    default:
      throw new Error(type + " is invalid");
  }
  if (bbox2)
    geom.bbox = bbox2;
  return geom;
}
function point(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be at least 2 numbers long");
  if (!isNumber$1(coordinates2[0]) || !isNumber$1(coordinates2[1]))
    throw new Error("coordinates must contain numbers");
  return feature({
    type: "Point",
    coordinates: coordinates2
  }, properties, options2);
}
function points(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  return featureCollection(coordinates2.map(function(coords) {
    return point(coords, properties);
  }), options2);
}
function polygon(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  for (var i2 = 0; i2 < coordinates2.length; i2++) {
    var ring = coordinates2[i2];
    if (ring.length < 4) {
      throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
    }
    for (var j2 = 0; j2 < ring[ring.length - 1].length; j2++) {
      if (i2 === 0 && j2 === 0 && !isNumber$1(ring[0][0]) || !isNumber$1(ring[0][1]))
        throw new Error("coordinates must contain numbers");
      if (ring[ring.length - 1][j2] !== ring[0][j2]) {
        throw new Error("First and last Position are not equivalent.");
      }
    }
  }
  return feature({
    type: "Polygon",
    coordinates: coordinates2
  }, properties, options2);
}
function polygons(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  return featureCollection(coordinates2.map(function(coords) {
    return polygon(coords, properties);
  }), options2);
}
function lineString(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (coordinates2.length < 2)
    throw new Error("coordinates must be an array of two or more positions");
  if (!isNumber$1(coordinates2[0][1]) || !isNumber$1(coordinates2[0][1]))
    throw new Error("coordinates must contain numbers");
  return feature({
    type: "LineString",
    coordinates: coordinates2
  }, properties, options2);
}
function lineStrings(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  if (!Array.isArray(coordinates2))
    throw new Error("coordinates must be an Array");
  return featureCollection(coordinates2.map(function(coords) {
    return lineString(coords, properties);
  }), options2);
}
function featureCollection(features, options2) {
  options2 = options2 || {};
  if (!isObject$2(options2))
    throw new Error("options is invalid");
  var bbox2 = options2.bbox;
  var id = options2.id;
  if (!features)
    throw new Error("No features passed");
  if (!Array.isArray(features))
    throw new Error("features must be an Array");
  if (bbox2)
    validateBBox(bbox2);
  if (id)
    validateId(id);
  var fc = { type: "FeatureCollection" };
  if (id)
    fc.id = id;
  if (bbox2)
    fc.bbox = bbox2;
  fc.features = features;
  return fc;
}
function multiLineString(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  return feature({
    type: "MultiLineString",
    coordinates: coordinates2
  }, properties, options2);
}
function multiPoint(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  return feature({
    type: "MultiPoint",
    coordinates: coordinates2
  }, properties, options2);
}
function multiPolygon(coordinates2, properties, options2) {
  if (!coordinates2)
    throw new Error("coordinates is required");
  return feature({
    type: "MultiPolygon",
    coordinates: coordinates2
  }, properties, options2);
}
function geometryCollection(geometries, properties, options2) {
  if (!geometries)
    throw new Error("geometries is required");
  if (!Array.isArray(geometries))
    throw new Error("geometries must be an Array");
  return feature({
    type: "GeometryCollection",
    geometries
  }, properties, options2);
}
function round(num, precision) {
  if (num === void 0 || num === null || isNaN(num))
    throw new Error("num is required");
  if (precision && !(precision >= 0))
    throw new Error("precision must be a positive number");
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(num * multiplier) / multiplier;
}
function radiansToLength(radians2, units2) {
  if (radians2 === void 0 || radians2 === null)
    throw new Error("radians is required");
  if (units2 && typeof units2 !== "string")
    throw new Error("units must be a string");
  var factor = factors[units2 || "kilometers"];
  if (!factor)
    throw new Error(units2 + " units is invalid");
  return radians2 * factor;
}
function lengthToRadians(distance11, units2) {
  if (distance11 === void 0 || distance11 === null)
    throw new Error("distance is required");
  if (units2 && typeof units2 !== "string")
    throw new Error("units must be a string");
  var factor = factors[units2 || "kilometers"];
  if (!factor)
    throw new Error(units2 + " units is invalid");
  return distance11 / factor;
}
function lengthToDegrees(distance11, units2) {
  return radiansToDegrees(lengthToRadians(distance11, units2));
}
function bearingToAzimuth(bearing2) {
  if (bearing2 === null || bearing2 === void 0)
    throw new Error("bearing is required");
  var angle4 = bearing2 % 360;
  if (angle4 < 0)
    angle4 += 360;
  return angle4;
}
function radiansToDegrees(radians2) {
  if (radians2 === null || radians2 === void 0)
    throw new Error("radians is required");
  var degrees2 = radians2 % (2 * Math.PI);
  return degrees2 * 180 / Math.PI;
}
function degreesToRadians(degrees2) {
  if (degrees2 === null || degrees2 === void 0)
    throw new Error("degrees is required");
  var radians2 = degrees2 % 360;
  return radians2 * Math.PI / 180;
}
function convertLength(length2, originalUnit, finalUnit) {
  if (length2 === null || length2 === void 0)
    throw new Error("length is required");
  if (!(length2 >= 0))
    throw new Error("length must be a positive number");
  return radiansToLength(lengthToRadians(length2, originalUnit), finalUnit || "kilometers");
}
function convertArea(area5, originalUnit, finalUnit) {
  if (area5 === null || area5 === void 0)
    throw new Error("area is required");
  if (!(area5 >= 0))
    throw new Error("area must be a positive number");
  var startFactor = areaFactors[originalUnit || "meters"];
  if (!startFactor)
    throw new Error("invalid original units");
  var finalFactor = areaFactors[finalUnit || "kilometers"];
  if (!finalFactor)
    throw new Error("invalid final units");
  return area5 / startFactor * finalFactor;
}
function isNumber$1(num) {
  return !isNaN(num) && num !== null && !Array.isArray(num);
}
function isObject$2(input) {
  return !!input && input.constructor === Object;
}
function validateBBox(bbox2) {
  if (!bbox2)
    throw new Error("bbox is required");
  if (!Array.isArray(bbox2))
    throw new Error("bbox must be an Array");
  if (bbox2.length !== 4 && bbox2.length !== 6)
    throw new Error("bbox must be an Array of 4 or 6 numbers");
  bbox2.forEach(function(num) {
    if (!isNumber$1(num))
      throw new Error("bbox must only contain numbers");
  });
}
function validateId(id) {
  if (!id)
    throw new Error("id is required");
  if (["string", "number"].indexOf(typeof id) === -1)
    throw new Error("id must be a number or a string");
}
function radians2degrees$1() {
  throw new Error("method has been renamed to `radiansToDegrees`");
}
function degrees2radians() {
  throw new Error("method has been renamed to `degreesToRadians`");
}
function distanceToDegrees() {
  throw new Error("method has been renamed to `lengthToDegrees`");
}
function distanceToRadians() {
  throw new Error("method has been renamed to `lengthToRadians`");
}
function radiansToDistance() {
  throw new Error("method has been renamed to `radiansToLength`");
}
function bearingToAngle() {
  throw new Error("method has been renamed to `bearingToAzimuth`");
}
function convertDistance() {
  throw new Error("method has been renamed to `convertLength`");
}
const main_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  areaFactors,
  bearingToAngle,
  bearingToAzimuth,
  convertArea,
  convertDistance,
  convertLength,
  degrees2radians,
  degreesToRadians,
  distanceToDegrees,
  distanceToRadians,
  earthRadius,
  factors,
  feature,
  featureCollection,
  geometry,
  geometryCollection,
  isNumber: isNumber$1,
  isObject: isObject$2,
  lengthToDegrees,
  lengthToRadians,
  lineString,
  lineStrings,
  multiLineString,
  multiPoint,
  multiPolygon,
  point,
  points,
  polygon,
  polygons,
  radians2degrees: radians2degrees$1,
  radiansToDegrees,
  radiansToDistance,
  radiansToLength,
  round,
  unitsFactors,
  validateBBox,
  validateId
}, Symbol.toStringTag, { value: "Module" }));
const require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(main_es);
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(es$1);
Object.defineProperty(js$1, "__esModule", { value: true });
var helpers_1$1 = require$$1$1;
var invariant_1 = require$$1;
function destination(origin, distance11, bearing2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var coordinates1 = invariant_1.getCoord(origin);
  var longitude1 = helpers_1$1.degreesToRadians(coordinates1[0]);
  var latitude1 = helpers_1$1.degreesToRadians(coordinates1[1]);
  var bearingRad = helpers_1$1.degreesToRadians(bearing2);
  var radians2 = helpers_1$1.lengthToRadians(distance11, options2.units);
  var latitude2 = Math.asin(Math.sin(latitude1) * Math.cos(radians2) + Math.cos(latitude1) * Math.sin(radians2) * Math.cos(bearingRad));
  var longitude2 = longitude1 + Math.atan2(Math.sin(bearingRad) * Math.sin(radians2) * Math.cos(latitude1), Math.cos(radians2) - Math.sin(latitude1) * Math.sin(latitude2));
  var lng = helpers_1$1.radiansToDegrees(longitude2);
  var lat = helpers_1$1.radiansToDegrees(latitude2);
  return helpers_1$1.point([lng, lat], options2.properties);
}
js$1.default = destination;
var __importDefault$1 = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(mod2) {
  return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
};
Object.defineProperty(js$2, "__esModule", { value: true });
var destination_1 = __importDefault$1(js$1);
var helpers_1 = require$$1$1;
function circle$3(center2, radius, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var steps = options2.steps || 64;
  var properties = options2.properties ? options2.properties : !Array.isArray(center2) && center2.type === "Feature" && center2.properties ? center2.properties : {};
  var coordinates2 = [];
  for (var i2 = 0; i2 < steps; i2++) {
    coordinates2.push(destination_1.default(center2, radius, i2 * -360 / steps, options2).geometry.coordinates);
  }
  coordinates2.push(coordinates2[0]);
  return helpers_1.polygon([coordinates2], properties);
}
js$2.default = circle$3;
const MapboxDraw$4 = mapboxGlDrawExports;
const Constants$3 = constants$6;
const doubleClickZoom$3 = double_click_zoom;
const circle$2 = js$2.default;
const CircleMode$1 = { ...MapboxDraw$4.modes.draw_polygon };
const DEFAULT_RADIUS_IN_KM = 2;
CircleMode$1.onSetup = function(opts) {
  const polygon4 = this.newFeature({
    type: Constants$3.geojsonTypes.FEATURE,
    properties: {
      isCircle: true,
      center: []
    },
    geometry: {
      type: Constants$3.geojsonTypes.POLYGON,
      coordinates: [[]]
    }
  });
  this.addFeature(polygon4);
  this.clearSelectedFeatures();
  doubleClickZoom$3.disable(this);
  this.updateUIClasses({ mouse: Constants$3.cursors.ADD });
  this.activateUIButton(Constants$3.types.POLYGON);
  this.setActionableState({
    trash: true
  });
  return {
    initialRadiusInKm: opts.initialRadiusInKm || DEFAULT_RADIUS_IN_KM,
    polygon: polygon4,
    currentVertexPosition: 0
  };
};
CircleMode$1.clickAnywhere = function(state, e3) {
  if (state.currentVertexPosition === 0) {
    state.currentVertexPosition++;
    const center2 = [e3.lngLat.lng, e3.lngLat.lat];
    const circleFeature = circle$2(center2, state.initialRadiusInKm);
    state.polygon.incomingCoords(circleFeature.geometry.coordinates);
    state.polygon.properties.center = center2;
    state.polygon.properties.radiusInKm = state.initialRadiusInKm;
  }
  return this.changeMode(Constants$3.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
};
var CircleMode_1 = CircleMode$1;
var drag_pan = {
  enable(ctx2) {
    setTimeout(() => {
      if (!ctx2.map || !ctx2.map.dragPan || !ctx2._ctx || !ctx2._ctx.store || !ctx2._ctx.store.getInitialConfigValue)
        return;
      if (!ctx2._ctx.store.getInitialConfigValue("dragPan"))
        return;
      ctx2.map.dragPan.enable();
    }, 0);
  },
  disable(ctx2) {
    setTimeout(() => {
      if (!ctx2.map || !ctx2.map.doubleClickZoom)
        return;
      ctx2.map.dragPan.disable();
    }, 0);
  }
};
const require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(es);
const MapboxDraw$3 = mapboxGlDrawExports;
const Constants$2 = constants$6;
const doubleClickZoom$2 = double_click_zoom;
const dragPan = drag_pan;
const circle$1 = js$2.default;
const distance$1 = require$$0$1.default;
const turfHelpers$1 = require$$6;
const DragCircleMode$1 = { ...MapboxDraw$3.modes.draw_polygon };
DragCircleMode$1.onSetup = function(opts) {
  const polygon4 = this.newFeature({
    type: Constants$2.geojsonTypes.FEATURE,
    properties: {
      isCircle: true,
      center: []
    },
    geometry: {
      type: Constants$2.geojsonTypes.POLYGON,
      coordinates: [[]]
    }
  });
  this.addFeature(polygon4);
  this.clearSelectedFeatures();
  doubleClickZoom$2.disable(this);
  dragPan.disable(this);
  this.updateUIClasses({ mouse: Constants$2.cursors.ADD });
  this.activateUIButton(Constants$2.types.POLYGON);
  this.setActionableState({
    trash: true
  });
  return {
    polygon: polygon4,
    currentVertexPosition: 0
  };
};
DragCircleMode$1.onMouseDown = DragCircleMode$1.onTouchStart = function(state, e3) {
  const currentCenter = state.polygon.properties.center;
  if (currentCenter.length === 0) {
    state.polygon.properties.center = [e3.lngLat.lng, e3.lngLat.lat];
  }
};
DragCircleMode$1.onDrag = DragCircleMode$1.onMouseMove = function(state, e3) {
  const center2 = state.polygon.properties.center;
  if (center2.length > 0) {
    const distanceInKm = distance$1(
      turfHelpers$1.point(center2),
      turfHelpers$1.point([e3.lngLat.lng, e3.lngLat.lat]),
      { units: "kilometers" }
    );
    const circleFeature = circle$1(center2, distanceInKm);
    state.polygon.incomingCoords(circleFeature.geometry.coordinates);
    state.polygon.properties.radiusInKm = distanceInKm;
  }
};
DragCircleMode$1.onMouseUp = DragCircleMode$1.onTouchEnd = function(state, e3) {
  dragPan.enable(this);
  return this.changeMode(Constants$2.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
};
DragCircleMode$1.onClick = DragCircleMode$1.onTap = function(state, e3) {
  state.polygon.properties.center = [];
};
DragCircleMode$1.toDisplayFeatures = function(state, geojson, display) {
  const isActivePolygon = geojson.properties.id === state.polygon.id;
  geojson.properties.active = isActivePolygon ? Constants$2.activeStates.ACTIVE : Constants$2.activeStates.INACTIVE;
  return display(geojson);
};
var DragCircleMode_1 = DragCircleMode$1;
const createVertex$1 = create_vertex;
function createSupplementaryPointsForCircle$2(geojson) {
  const { properties, geometry: geometry2 } = geojson;
  if (!properties.user_isCircle)
    return null;
  const supplementaryPoints = [];
  const vertices = geometry2.coordinates[0].slice(0, -1);
  for (let index2 = 0; index2 < vertices.length; index2 += Math.round(vertices.length / 4)) {
    supplementaryPoints.push(createVertex$1(properties.id, vertices[index2], `0.${index2}`, false));
  }
  return supplementaryPoints;
}
var create_supplementary_points_circle = createSupplementaryPointsForCircle$2;
const MapboxDraw$2 = mapboxGlDrawExports;
const createSupplementaryPoints$1 = create_supplementary_points;
const moveFeatures$1 = move_features;
const Constants$1 = constants$6;
const constrainFeatureMovement = constrain_feature_movement;
const distance = require$$0$1.default;
const turfHelpers = require$$6;
const circle = js$2.default;
const createSupplementaryPointsForCircle$1 = create_supplementary_points_circle;
const DirectModeOverride = MapboxDraw$2.modes.direct_select;
DirectModeOverride.dragFeature = function(state, e3, delta) {
  moveFeatures$1(this.getSelected(), delta);
  this.getSelected().filter((feature2) => feature2.properties.isCircle).map((circle2) => circle2.properties.center).forEach((center2) => {
    center2[0] += delta.lng;
    center2[1] += delta.lat;
  });
  state.dragMoveLocation = e3.lngLat;
};
DirectModeOverride.dragVertex = function(state, e3, delta) {
  if (state.feature.properties.isCircle) {
    const center2 = state.feature.properties.center;
    const movedVertex = [e3.lngLat.lng, e3.lngLat.lat];
    const radius = distance(turfHelpers.point(center2), turfHelpers.point(movedVertex), { units: "kilometers" });
    const circleFeature = circle(center2, radius);
    state.feature.incomingCoords(circleFeature.geometry.coordinates);
    state.feature.properties.radiusInKm = radius;
  } else {
    const selectedCoords = state.selectedCoordPaths.map((coord_path) => state.feature.getCoordinate(coord_path));
    const selectedCoordPoints = selectedCoords.map((coords) => ({
      type: Constants$1.geojsonTypes.FEATURE,
      properties: {},
      geometry: {
        type: Constants$1.geojsonTypes.POINT,
        coordinates: coords
      }
    }));
    const constrainedDelta = constrainFeatureMovement(selectedCoordPoints, delta);
    for (let i2 = 0; i2 < selectedCoords.length; i2++) {
      const coord = selectedCoords[i2];
      state.feature.updateCoordinate(state.selectedCoordPaths[i2], coord[0] + constrainedDelta.lng, coord[1] + constrainedDelta.lat);
    }
  }
};
DirectModeOverride.toDisplayFeatures = function(state, geojson, push2) {
  if (state.featureId === geojson.properties.id) {
    geojson.properties.active = Constants$1.activeStates.ACTIVE;
    push2(geojson);
    const supplementaryPoints = geojson.properties.user_isCircle ? createSupplementaryPointsForCircle$1(geojson) : createSupplementaryPoints$1(geojson, {
      map: this.map,
      midpoints: true,
      selectedPaths: state.selectedCoordPaths
    });
    supplementaryPoints.forEach(push2);
  } else {
    geojson.properties.active = Constants$1.activeStates.INACTIVE;
    push2(geojson);
  }
  this.fireActionable(state);
};
var DirectModeOverride_1 = DirectModeOverride;
const MapboxDraw$1 = mapboxGlDrawExports;
const createSupplementaryPoints = create_supplementary_points;
const moveFeatures = move_features;
const Constants = constants$6;
const createSupplementaryPointsForCircle = create_supplementary_points_circle;
const SimpleSelectModeOverride = MapboxDraw$1.modes.simple_select;
SimpleSelectModeOverride.dragMove = function(state, e3) {
  state.dragMoving = true;
  e3.originalEvent.stopPropagation();
  const delta = {
    lng: e3.lngLat.lng - state.dragMoveLocation.lng,
    lat: e3.lngLat.lat - state.dragMoveLocation.lat
  };
  moveFeatures(this.getSelected(), delta);
  this.getSelected().filter((feature2) => feature2.properties.isCircle).map((circle2) => circle2.properties.center).forEach((center2) => {
    center2[0] += delta.lng;
    center2[1] += delta.lat;
  });
  state.dragMoveLocation = e3.lngLat;
};
SimpleSelectModeOverride.toDisplayFeatures = function(state, geojson, display) {
  geojson.properties.active = this.isSelected(geojson.properties.id) ? Constants.activeStates.ACTIVE : Constants.activeStates.INACTIVE;
  display(geojson);
  this.fireActionable();
  if (geojson.properties.active !== Constants.activeStates.ACTIVE || geojson.geometry.type === Constants.geojsonTypes.POINT)
    return;
  const supplementaryPoints = geojson.properties.user_isCircle ? createSupplementaryPointsForCircle(geojson) : createSupplementaryPoints(geojson);
  supplementaryPoints.forEach(display);
};
var SimpleSelectModeOverride_1 = SimpleSelectModeOverride;
var numeralExports = {};
var numeral$1 = {
  get exports() {
    return numeralExports;
  },
  set exports(v5) {
    numeralExports = v5;
  }
};
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(module2) {
  (function(global2, factory) {
    if (module2.exports) {
      module2.exports = factory();
    } else {
      global2.numeral = factory();
    }
  })(commonjsGlobal$1, function() {
    var numeral2, _2, VERSION2 = "2.0.6", formats2 = {}, locales = {}, defaults = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: true
    }, options2 = {
      currentLocale: defaults.currentLocale,
      zeroFormat: defaults.zeroFormat,
      nullFormat: defaults.nullFormat,
      defaultFormat: defaults.defaultFormat,
      scalePercentBy100: defaults.scalePercentBy100
    };
    function Numeral(input, number2) {
      this._input = input;
      this._value = number2;
    }
    numeral2 = function(input) {
      var value, kind, unformatFunction, regexp;
      if (numeral2.isNumeral(input)) {
        value = input.value();
      } else if (input === 0 || typeof input === "undefined") {
        value = 0;
      } else if (input === null || _2.isNaN(input)) {
        value = null;
      } else if (typeof input === "string") {
        if (options2.zeroFormat && input === options2.zeroFormat) {
          value = 0;
        } else if (options2.nullFormat && input === options2.nullFormat || !input.replace(/[^0-9]+/g, "").length) {
          value = null;
        } else {
          for (kind in formats2) {
            regexp = typeof formats2[kind].regexps.unformat === "function" ? formats2[kind].regexps.unformat() : formats2[kind].regexps.unformat;
            if (regexp && input.match(regexp)) {
              unformatFunction = formats2[kind].unformat;
              break;
            }
          }
          unformatFunction = unformatFunction || numeral2._.stringToNumber;
          value = unformatFunction(input);
        }
      } else {
        value = Number(input) || null;
      }
      return new Numeral(input, value);
    };
    numeral2.version = VERSION2;
    numeral2.isNumeral = function(obj) {
      return obj instanceof Numeral;
    };
    numeral2._ = _2 = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(value, format, roundingFunction) {
        var locale = locales[numeral2.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1e12, billion = 1e9, million = 1e6, thousand = 1e3, decimal = "", neg = false, abbrForce, abs3, int, precision, signed, thousands, output2;
        value = value || 0;
        abs3 = Math.abs(value);
        if (numeral2._.includes(format, "(")) {
          negP = true;
          format = format.replace(/[\(|\)]/g, "");
        } else if (numeral2._.includes(format, "+") || numeral2._.includes(format, "-")) {
          signed = numeral2._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
          format = format.replace(/[\+|\-]/g, "");
        }
        if (numeral2._.includes(format, "a")) {
          abbrForce = format.match(/a(k|m|b|t)?/);
          abbrForce = abbrForce ? abbrForce[1] : false;
          if (numeral2._.includes(format, " a")) {
            abbr = " ";
          }
          format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
          if (abs3 >= trillion && !abbrForce || abbrForce === "t") {
            abbr += locale.abbreviations.trillion;
            value = value / trillion;
          } else if (abs3 < trillion && abs3 >= billion && !abbrForce || abbrForce === "b") {
            abbr += locale.abbreviations.billion;
            value = value / billion;
          } else if (abs3 < billion && abs3 >= million && !abbrForce || abbrForce === "m") {
            abbr += locale.abbreviations.million;
            value = value / million;
          } else if (abs3 < million && abs3 >= thousand && !abbrForce || abbrForce === "k") {
            abbr += locale.abbreviations.thousand;
            value = value / thousand;
          }
        }
        if (numeral2._.includes(format, "[.]")) {
          optDec = true;
          format = format.replace("[.]", ".");
        }
        int = value.toString().split(".")[0];
        precision = format.split(".")[1];
        thousands = format.indexOf(",");
        leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
        if (precision) {
          if (numeral2._.includes(precision, "[")) {
            precision = precision.replace("]", "");
            precision = precision.split("[");
            decimal = numeral2._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
          } else {
            decimal = numeral2._.toFixed(value, precision.length, roundingFunction);
          }
          int = decimal.split(".")[0];
          if (numeral2._.includes(decimal, ".")) {
            decimal = locale.delimiters.decimal + decimal.split(".")[1];
          } else {
            decimal = "";
          }
          if (optDec && Number(decimal.slice(1)) === 0) {
            decimal = "";
          }
        } else {
          int = numeral2._.toFixed(value, 0, roundingFunction);
        }
        if (abbr && !abbrForce && Number(int) >= 1e3 && abbr !== locale.abbreviations.trillion) {
          int = String(Number(int) / 1e3);
          switch (abbr) {
            case locale.abbreviations.thousand:
              abbr = locale.abbreviations.million;
              break;
            case locale.abbreviations.million:
              abbr = locale.abbreviations.billion;
              break;
            case locale.abbreviations.billion:
              abbr = locale.abbreviations.trillion;
              break;
          }
        }
        if (numeral2._.includes(int, "-")) {
          int = int.slice(1);
          neg = true;
        }
        if (int.length < leadingCount) {
          for (var i2 = leadingCount - int.length; i2 > 0; i2--) {
            int = "0" + int;
          }
        }
        if (thousands > -1) {
          int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
        }
        if (format.indexOf(".") === 0) {
          int = "";
        }
        output2 = int + decimal + (abbr ? abbr : "");
        if (negP) {
          output2 = (negP && neg ? "(" : "") + output2 + (negP && neg ? ")" : "");
        } else {
          if (signed >= 0) {
            output2 = signed === 0 ? (neg ? "-" : "+") + output2 : output2 + (neg ? "-" : "+");
          } else if (neg) {
            output2 = "-" + output2;
          }
        }
        return output2;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(string3) {
        var locale = locales[options2.currentLocale], stringOriginal = string3, abbreviations = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, abbreviation, value, regexp;
        if (options2.zeroFormat && string3 === options2.zeroFormat) {
          value = 0;
        } else if (options2.nullFormat && string3 === options2.nullFormat || !string3.replace(/[^0-9]+/g, "").length) {
          value = null;
        } else {
          value = 1;
          if (locale.delimiters.decimal !== ".") {
            string3 = string3.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
          }
          for (abbreviation in abbreviations) {
            regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
            if (stringOriginal.match(regexp)) {
              value *= Math.pow(10, abbreviations[abbreviation]);
              break;
            }
          }
          value *= (string3.split("-").length + Math.min(string3.split("(").length - 1, string3.split(")").length - 1)) % 2 ? 1 : -1;
          string3 = string3.replace(/[^0-9\.]+/g, "");
          value *= Number(string3);
        }
        return value;
      },
      isNaN: function(value) {
        return typeof value === "number" && isNaN(value);
      },
      includes: function(string3, search) {
        return string3.indexOf(search) !== -1;
      },
      insert: function(string3, subString, start2) {
        return string3.slice(0, start2) + subString + string3.slice(start2);
      },
      reduce: function(array2, callback) {
        if (this === null) {
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        }
        if (typeof callback !== "function") {
          throw new TypeError(callback + " is not a function");
        }
        var t2 = Object(array2), len2 = t2.length >>> 0, k2 = 0, value;
        if (arguments.length === 3) {
          value = arguments[2];
        } else {
          while (k2 < len2 && !(k2 in t2)) {
            k2++;
          }
          if (k2 >= len2) {
            throw new TypeError("Reduce of empty array with no initial value");
          }
          value = t2[k2++];
        }
        for (; k2 < len2; k2++) {
          if (k2 in t2) {
            value = callback(value, t2[k2], k2, t2);
          }
        }
        return value;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(x2) {
        var parts = x2.toString().split(".");
        return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function(accum, next5) {
          var mn = _2.multiplier(next5);
          return accum > mn ? accum : mn;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(value, maxDecimals, roundingFunction, optionals) {
        var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output2;
        if (splitValue.length === 2) {
          boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
        } else {
          boundedPrecision = minDecimals;
        }
        power = Math.pow(10, boundedPrecision);
        output2 = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
        if (optionals > maxDecimals - boundedPrecision) {
          optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
          output2 = output2.replace(optionalsRegExp, "");
        }
        return output2;
      }
    };
    numeral2.options = options2;
    numeral2.formats = formats2;
    numeral2.locales = locales;
    numeral2.locale = function(key) {
      if (key) {
        options2.currentLocale = key.toLowerCase();
      }
      return options2.currentLocale;
    };
    numeral2.localeData = function(key) {
      if (!key) {
        return locales[options2.currentLocale];
      }
      key = key.toLowerCase();
      if (!locales[key]) {
        throw new Error("Unknown locale : " + key);
      }
      return locales[key];
    };
    numeral2.reset = function() {
      for (var property2 in defaults) {
        options2[property2] = defaults[property2];
      }
    };
    numeral2.zeroFormat = function(format) {
      options2.zeroFormat = typeof format === "string" ? format : null;
    };
    numeral2.nullFormat = function(format) {
      options2.nullFormat = typeof format === "string" ? format : null;
    };
    numeral2.defaultFormat = function(format) {
      options2.defaultFormat = typeof format === "string" ? format : "0.0";
    };
    numeral2.register = function(type, name2, format) {
      name2 = name2.toLowerCase();
      if (this[type + "s"][name2]) {
        throw new TypeError(name2 + " " + type + " already registered.");
      }
      this[type + "s"][name2] = format;
      return format;
    };
    numeral2.validate = function(val, culture) {
      var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData2, temp2;
      if (typeof val !== "string") {
        val += "";
        if (console.warn) {
          console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
      }
      val = val.trim();
      if (!!val.match(/^\d+$/)) {
        return true;
      }
      if (val === "") {
        return false;
      }
      try {
        localeData2 = numeral2.localeData(culture);
      } catch (e3) {
        localeData2 = numeral2.localeData(numeral2.locale());
      }
      _currSymbol = localeData2.currency.symbol;
      _abbrObj = localeData2.abbreviations;
      _decimalSep = localeData2.delimiters.decimal;
      if (localeData2.delimiters.thousands === ".") {
        _thousandSep = "\\.";
      } else {
        _thousandSep = localeData2.delimiters.thousands;
      }
      temp2 = val.match(/^[^\d]+/);
      if (temp2 !== null) {
        val = val.substr(1);
        if (temp2[0] !== _currSymbol) {
          return false;
        }
      }
      temp2 = val.match(/[^\d]+$/);
      if (temp2 !== null) {
        val = val.slice(0, -1);
        if (temp2[0] !== _abbrObj.thousand && temp2[0] !== _abbrObj.million && temp2[0] !== _abbrObj.billion && temp2[0] !== _abbrObj.trillion) {
          return false;
        }
      }
      _thousandRegEx = new RegExp(_thousandSep + "{2}");
      if (!val.match(/[^\d.,]/g)) {
        _valArray = val.split(_decimalSep);
        if (_valArray.length > 2) {
          return false;
        } else {
          if (_valArray.length < 2) {
            return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
          } else {
            if (_valArray[0].length === 1) {
              return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
            } else {
              return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
            }
          }
        }
      }
      return false;
    };
    numeral2.fn = Numeral.prototype = {
      clone: function() {
        return numeral2(this);
      },
      format: function(inputString, roundingFunction) {
        var value = this._value, format = inputString || options2.defaultFormat, kind, output2, formatFunction;
        roundingFunction = roundingFunction || Math.round;
        if (value === 0 && options2.zeroFormat !== null) {
          output2 = options2.zeroFormat;
        } else if (value === null && options2.nullFormat !== null) {
          output2 = options2.nullFormat;
        } else {
          for (kind in formats2) {
            if (format.match(formats2[kind].regexps.format)) {
              formatFunction = formats2[kind].format;
              break;
            }
          }
          formatFunction = formatFunction || numeral2._.numberToFormat;
          output2 = formatFunction(value, format, roundingFunction);
        }
        return output2;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(value) {
        this._value = Number(value);
        return this;
      },
      add: function(value) {
        var corrFactor = _2.correctionFactor.call(null, this._value, value);
        function cback(accum, curr, currI, O2) {
          return accum + Math.round(corrFactor * curr);
        }
        this._value = _2.reduce([this._value, value], cback, 0) / corrFactor;
        return this;
      },
      subtract: function(value) {
        var corrFactor = _2.correctionFactor.call(null, this._value, value);
        function cback(accum, curr, currI, O2) {
          return accum - Math.round(corrFactor * curr);
        }
        this._value = _2.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
        return this;
      },
      multiply: function(value) {
        function cback(accum, curr, currI, O2) {
          var corrFactor = _2.correctionFactor(accum, curr);
          return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
        }
        this._value = _2.reduce([this._value, value], cback, 1);
        return this;
      },
      divide: function(value) {
        function cback(accum, curr, currI, O2) {
          var corrFactor = _2.correctionFactor(accum, curr);
          return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
        }
        this._value = _2.reduce([this._value, value], cback);
        return this;
      },
      difference: function(value) {
        return Math.abs(numeral2(this._value).subtract(value).value());
      }
    };
    numeral2.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(number2) {
        var b2 = number2 % 10;
        return ~~(number2 % 100 / 10) === 1 ? "th" : b2 === 1 ? "st" : b2 === 2 ? "nd" : b2 === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    });
    (function() {
      numeral2.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(value, format, roundingFunction) {
          var space = numeral2._.includes(format, " BPS") ? " " : "", output2;
          value = value * 1e4;
          format = format.replace(/\s?BPS/, "");
          output2 = numeral2._.numberToFormat(value, format, roundingFunction);
          if (numeral2._.includes(output2, ")")) {
            output2 = output2.split("");
            output2.splice(-1, 0, space + "BPS");
            output2 = output2.join("");
          } else {
            output2 = output2 + space + "BPS";
          }
          return output2;
        },
        unformat: function(string3) {
          return +(numeral2._.stringToNumber(string3) * 1e-4).toFixed(15);
        }
      });
    })();
    (function() {
      var decimal = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, binary = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      };
      var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
        return decimal.suffixes.indexOf(item) < 0;
      }));
      var unformatRegex = allSuffixes.join("|");
      unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
      numeral2.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
          var output2, bytes = numeral2._.includes(format, "ib") ? binary : decimal, suffix = numeral2._.includes(format, " b") || numeral2._.includes(format, " ib") ? " " : "", power, min4, max3;
          format = format.replace(/\s?i?b/, "");
          for (power = 0; power <= bytes.suffixes.length; power++) {
            min4 = Math.pow(bytes.base, power);
            max3 = Math.pow(bytes.base, power + 1);
            if (value === null || value === 0 || value >= min4 && value < max3) {
              suffix += bytes.suffixes[power];
              if (min4 > 0) {
                value = value / min4;
              }
              break;
            }
          }
          output2 = numeral2._.numberToFormat(value, format, roundingFunction);
          return output2 + suffix;
        },
        unformat: function(string3) {
          var value = numeral2._.stringToNumber(string3), power, bytesMultiplier;
          if (value) {
            for (power = decimal.suffixes.length - 1; power >= 0; power--) {
              if (numeral2._.includes(string3, decimal.suffixes[power])) {
                bytesMultiplier = Math.pow(decimal.base, power);
                break;
              }
              if (numeral2._.includes(string3, binary.suffixes[power])) {
                bytesMultiplier = Math.pow(binary.base, power);
                break;
              }
            }
            value *= bytesMultiplier || 1;
          }
          return value;
        }
      });
    })();
    (function() {
      numeral2.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
          var locale = numeral2.locales[numeral2.options.currentLocale], symbols = {
            before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, output2, symbol, i2;
          format = format.replace(/\s?\$\s?/, "");
          output2 = numeral2._.numberToFormat(value, format, roundingFunction);
          if (value >= 0) {
            symbols.before = symbols.before.replace(/[\-\(]/, "");
            symbols.after = symbols.after.replace(/[\-\)]/, "");
          } else if (value < 0 && (!numeral2._.includes(symbols.before, "-") && !numeral2._.includes(symbols.before, "("))) {
            symbols.before = "-" + symbols.before;
          }
          for (i2 = 0; i2 < symbols.before.length; i2++) {
            symbol = symbols.before[i2];
            switch (symbol) {
              case "$":
                output2 = numeral2._.insert(output2, locale.currency.symbol, i2);
                break;
              case " ":
                output2 = numeral2._.insert(output2, " ", i2 + locale.currency.symbol.length - 1);
                break;
            }
          }
          for (i2 = symbols.after.length - 1; i2 >= 0; i2--) {
            symbol = symbols.after[i2];
            switch (symbol) {
              case "$":
                output2 = i2 === symbols.after.length - 1 ? output2 + locale.currency.symbol : numeral2._.insert(output2, locale.currency.symbol, -(symbols.after.length - (1 + i2)));
                break;
              case " ":
                output2 = i2 === symbols.after.length - 1 ? output2 + " " : numeral2._.insert(output2, " ", -(symbols.after.length - (1 + i2) + locale.currency.symbol.length - 1));
                break;
            }
          }
          return output2;
        }
      });
    })();
    (function() {
      numeral2.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
          var output2, exponential = typeof value === "number" && !numeral2._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
          format = format.replace(/e[\+|\-]{1}0/, "");
          output2 = numeral2._.numberToFormat(Number(parts[0]), format, roundingFunction);
          return output2 + "e" + parts[1];
        },
        unformat: function(string3) {
          var parts = numeral2._.includes(string3, "e+") ? string3.split("e+") : string3.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
          power = numeral2._.includes(string3, "e-") ? power *= -1 : power;
          function cback(accum, curr, currI, O2) {
            var corrFactor = numeral2._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
            return num;
          }
          return numeral2._.reduce([value, Math.pow(10, power)], cback, 1);
        }
      });
    })();
    (function() {
      numeral2.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(value, format, roundingFunction) {
          var locale = numeral2.locales[numeral2.options.currentLocale], output2, ordinal = numeral2._.includes(format, " o") ? " " : "";
          format = format.replace(/\s?o/, "");
          ordinal += locale.ordinal(value);
          output2 = numeral2._.numberToFormat(value, format, roundingFunction);
          return output2 + ordinal;
        }
      });
    })();
    (function() {
      numeral2.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
          var space = numeral2._.includes(format, " %") ? " " : "", output2;
          if (numeral2.options.scalePercentBy100) {
            value = value * 100;
          }
          format = format.replace(/\s?\%/, "");
          output2 = numeral2._.numberToFormat(value, format, roundingFunction);
          if (numeral2._.includes(output2, ")")) {
            output2 = output2.split("");
            output2.splice(-1, 0, space + "%");
            output2 = output2.join("");
          } else {
            output2 = output2 + space + "%";
          }
          return output2;
        },
        unformat: function(string3) {
          var number2 = numeral2._.stringToNumber(string3);
          if (numeral2.options.scalePercentBy100) {
            return number2 * 0.01;
          }
          return number2;
        }
      });
    })();
    (function() {
      numeral2.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
          var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 60 * 60) / 60), seconds = Math.round(value - hours * 60 * 60 - minutes * 60);
          return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
        },
        unformat: function(string3) {
          var timeArray = string3.split(":"), seconds = 0;
          if (timeArray.length === 3) {
            seconds = seconds + Number(timeArray[0]) * 60 * 60;
            seconds = seconds + Number(timeArray[1]) * 60;
            seconds = seconds + Number(timeArray[2]);
          } else if (timeArray.length === 2) {
            seconds = seconds + Number(timeArray[0]) * 60;
            seconds = seconds + Number(timeArray[1]);
          }
          return Number(seconds);
        }
      });
    })();
    return numeral2;
  });
})(numeral$1);
var lodashExports = {};
var lodash = {
  get exports() {
    return lodashExports;
  },
  set exports(v5) {
    lodashExports = v5;
  }
};
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module2, exports2) {
  (function() {
    var undefined$12;
    var VERSION2 = "4.17.21";
    var LARGE_ARRAY_SIZE2 = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT2 = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE2 = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG2 = 1, CLONE_FLAT_FLAG2 = 2, CLONE_SYMBOLS_FLAG2 = 4;
    var COMPARE_PARTIAL_FLAG2 = 1, COMPARE_UNORDERED_FLAG2 = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT2 = 800, HOT_SPAN2 = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY2 = 1 / 0, MAX_SAFE_INTEGER2 = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN2 = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag2 = "[object Arguments]", arrayTag2 = "[object Array]", asyncTag2 = "[object AsyncFunction]", boolTag2 = "[object Boolean]", dateTag2 = "[object Date]", domExcTag = "[object DOMException]", errorTag2 = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag2 = "[object Map]", numberTag2 = "[object Number]", nullTag2 = "[object Null]", objectTag2 = "[object Object]", promiseTag2 = "[object Promise]", proxyTag2 = "[object Proxy]", regexpTag2 = "[object RegExp]", setTag2 = "[object Set]", stringTag2 = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag2 = "[object Undefined]", weakMapTag2 = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag2 = "[object ArrayBuffer]", dataViewTag2 = "[object DataView]", float32Tag2 = "[object Float32Array]", float64Tag2 = "[object Float64Array]", int8Tag2 = "[object Int8Array]", int16Tag2 = "[object Int16Array]", int32Tag2 = "[object Int32Array]", uint8Tag2 = "[object Uint8Array]", uint8ClampedTag2 = "[object Uint8ClampedArray]", uint16Tag2 = "[object Uint16Array]", uint32Tag2 = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp2 = /^\w*$/, rePropName2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar2.source);
    var reTrimStart2 = /^\s+/;
    var reWhitespace2 = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar2 = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags2 = /\w*$/;
    var reIsBadHex2 = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary2 = /^0b[01]+$/i;
    var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
    var reIsOctal2 = /^0o[0-7]+$/i;
    var reIsUint2 = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags2 = {};
    typedArrayTags2[float32Tag2] = typedArrayTags2[float64Tag2] = typedArrayTags2[int8Tag2] = typedArrayTags2[int16Tag2] = typedArrayTags2[int32Tag2] = typedArrayTags2[uint8Tag2] = typedArrayTags2[uint8ClampedTag2] = typedArrayTags2[uint16Tag2] = typedArrayTags2[uint32Tag2] = true;
    typedArrayTags2[argsTag2] = typedArrayTags2[arrayTag2] = typedArrayTags2[arrayBufferTag2] = typedArrayTags2[boolTag2] = typedArrayTags2[dataViewTag2] = typedArrayTags2[dateTag2] = typedArrayTags2[errorTag2] = typedArrayTags2[funcTag2] = typedArrayTags2[mapTag2] = typedArrayTags2[numberTag2] = typedArrayTags2[objectTag2] = typedArrayTags2[regexpTag2] = typedArrayTags2[setTag2] = typedArrayTags2[stringTag2] = typedArrayTags2[weakMapTag2] = false;
    var cloneableTags2 = {};
    cloneableTags2[argsTag2] = cloneableTags2[arrayTag2] = cloneableTags2[arrayBufferTag2] = cloneableTags2[dataViewTag2] = cloneableTags2[boolTag2] = cloneableTags2[dateTag2] = cloneableTags2[float32Tag2] = cloneableTags2[float64Tag2] = cloneableTags2[int8Tag2] = cloneableTags2[int16Tag2] = cloneableTags2[int32Tag2] = cloneableTags2[mapTag2] = cloneableTags2[numberTag2] = cloneableTags2[objectTag2] = cloneableTags2[regexpTag2] = cloneableTags2[setTag2] = cloneableTags2[stringTag2] = cloneableTags2[symbolTag2] = cloneableTags2[uint8Tag2] = cloneableTags2[uint8ClampedTag2] = cloneableTags2[uint16Tag2] = cloneableTags2[uint32Tag2] = true;
    cloneableTags2[errorTag2] = cloneableTags2[funcTag2] = cloneableTags2[weakMapTag2] = false;
    var deburredLetters = {
      // Latin-1 Supplement block.
      "À": "A",
      "Á": "A",
      "Â": "A",
      "Ã": "A",
      "Ä": "A",
      "Å": "A",
      "à": "a",
      "á": "a",
      "â": "a",
      "ã": "a",
      "ä": "a",
      "å": "a",
      "Ç": "C",
      "ç": "c",
      "Ð": "D",
      "ð": "d",
      "È": "E",
      "É": "E",
      "Ê": "E",
      "Ë": "E",
      "è": "e",
      "é": "e",
      "ê": "e",
      "ë": "e",
      "Ì": "I",
      "Í": "I",
      "Î": "I",
      "Ï": "I",
      "ì": "i",
      "í": "i",
      "î": "i",
      "ï": "i",
      "Ñ": "N",
      "ñ": "n",
      "Ò": "O",
      "Ó": "O",
      "Ô": "O",
      "Õ": "O",
      "Ö": "O",
      "Ø": "O",
      "ò": "o",
      "ó": "o",
      "ô": "o",
      "õ": "o",
      "ö": "o",
      "ø": "o",
      "Ù": "U",
      "Ú": "U",
      "Û": "U",
      "Ü": "U",
      "ù": "u",
      "ú": "u",
      "û": "u",
      "ü": "u",
      "Ý": "Y",
      "ý": "y",
      "ÿ": "y",
      "Æ": "Ae",
      "æ": "ae",
      "Þ": "Th",
      "þ": "th",
      "ß": "ss",
      // Latin Extended-A block.
      "Ā": "A",
      "Ă": "A",
      "Ą": "A",
      "ā": "a",
      "ă": "a",
      "ą": "a",
      "Ć": "C",
      "Ĉ": "C",
      "Ċ": "C",
      "Č": "C",
      "ć": "c",
      "ĉ": "c",
      "ċ": "c",
      "č": "c",
      "Ď": "D",
      "Đ": "D",
      "ď": "d",
      "đ": "d",
      "Ē": "E",
      "Ĕ": "E",
      "Ė": "E",
      "Ę": "E",
      "Ě": "E",
      "ē": "e",
      "ĕ": "e",
      "ė": "e",
      "ę": "e",
      "ě": "e",
      "Ĝ": "G",
      "Ğ": "G",
      "Ġ": "G",
      "Ģ": "G",
      "ĝ": "g",
      "ğ": "g",
      "ġ": "g",
      "ģ": "g",
      "Ĥ": "H",
      "Ħ": "H",
      "ĥ": "h",
      "ħ": "h",
      "Ĩ": "I",
      "Ī": "I",
      "Ĭ": "I",
      "Į": "I",
      "İ": "I",
      "ĩ": "i",
      "ī": "i",
      "ĭ": "i",
      "į": "i",
      "ı": "i",
      "Ĵ": "J",
      "ĵ": "j",
      "Ķ": "K",
      "ķ": "k",
      "ĸ": "k",
      "Ĺ": "L",
      "Ļ": "L",
      "Ľ": "L",
      "Ŀ": "L",
      "Ł": "L",
      "ĺ": "l",
      "ļ": "l",
      "ľ": "l",
      "ŀ": "l",
      "ł": "l",
      "Ń": "N",
      "Ņ": "N",
      "Ň": "N",
      "Ŋ": "N",
      "ń": "n",
      "ņ": "n",
      "ň": "n",
      "ŋ": "n",
      "Ō": "O",
      "Ŏ": "O",
      "Ő": "O",
      "ō": "o",
      "ŏ": "o",
      "ő": "o",
      "Ŕ": "R",
      "Ŗ": "R",
      "Ř": "R",
      "ŕ": "r",
      "ŗ": "r",
      "ř": "r",
      "Ś": "S",
      "Ŝ": "S",
      "Ş": "S",
      "Š": "S",
      "ś": "s",
      "ŝ": "s",
      "ş": "s",
      "š": "s",
      "Ţ": "T",
      "Ť": "T",
      "Ŧ": "T",
      "ţ": "t",
      "ť": "t",
      "ŧ": "t",
      "Ũ": "U",
      "Ū": "U",
      "Ŭ": "U",
      "Ů": "U",
      "Ű": "U",
      "Ų": "U",
      "ũ": "u",
      "ū": "u",
      "ŭ": "u",
      "ů": "u",
      "ű": "u",
      "ų": "u",
      "Ŵ": "W",
      "ŵ": "w",
      "Ŷ": "Y",
      "ŷ": "y",
      "Ÿ": "Y",
      "Ź": "Z",
      "Ż": "Z",
      "Ž": "Z",
      "ź": "z",
      "ż": "z",
      "ž": "z",
      "Ĳ": "IJ",
      "ĳ": "ij",
      "Œ": "Oe",
      "œ": "oe",
      "ŉ": "'n",
      "ſ": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt2 = parseInt;
    var freeGlobal2 = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports2 = exports2 && !exports2.nodeType && exports2;
    var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
    var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
    var freeProcess2 = moduleExports2 && freeGlobal2.process;
    var nodeUtil2 = function() {
      try {
        var types2 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
        if (types2) {
          return types2;
        }
        return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
      } catch (e3) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil2 && nodeUtil2.isArrayBuffer, nodeIsDate = nodeUtil2 && nodeUtil2.isDate, nodeIsMap2 = nodeUtil2 && nodeUtil2.isMap, nodeIsRegExp = nodeUtil2 && nodeUtil2.isRegExp, nodeIsSet2 = nodeUtil2 && nodeUtil2.isSet, nodeIsTypedArray2 = nodeUtil2 && nodeUtil2.isTypedArray;
    function apply2(func2, thisArg, args) {
      switch (args.length) {
        case 0:
          return func2.call(thisArg);
        case 1:
          return func2.call(thisArg, args[0]);
        case 2:
          return func2.call(thisArg, args[0], args[1]);
        case 3:
          return func2.call(thisArg, args[0], args[1], args[2]);
      }
      return func2.apply(thisArg, args);
    }
    function arrayAggregator(array2, setter, iteratee, accumulator) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        var value = array2[index2];
        setter(accumulator, value, iteratee(value), array2);
      }
      return accumulator;
    }
    function arrayEach2(array2, iteratee) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (iteratee(array2[index2], index2, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEachRight(array2, iteratee) {
      var length2 = array2 == null ? 0 : array2.length;
      while (length2--) {
        if (iteratee(array2[length2], length2, array2) === false) {
          break;
        }
      }
      return array2;
    }
    function arrayEvery(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (!predicate(array2[index2], index2, array2)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter2(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array2[index2];
        if (predicate(value, index2, array2)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array2, value) {
      var length2 = array2 == null ? 0 : array2.length;
      return !!length2 && baseIndexOf(array2, value, 0) > -1;
    }
    function arrayIncludesWith(array2, value, comparator2) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (comparator2(value, array2[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap2(array2, iteratee) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
      while (++index2 < length2) {
        result[index2] = iteratee(array2[index2], index2, array2);
      }
      return result;
    }
    function arrayPush2(array2, values4) {
      var index2 = -1, length2 = values4.length, offset = array2.length;
      while (++index2 < length2) {
        array2[offset + index2] = values4[index2];
      }
      return array2;
    }
    function arrayReduce(array2, iteratee, accumulator, initAccum) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      if (initAccum && length2) {
        accumulator = array2[++index2];
      }
      while (++index2 < length2) {
        accumulator = iteratee(accumulator, array2[index2], index2, array2);
      }
      return accumulator;
    }
    function arrayReduceRight(array2, iteratee, accumulator, initAccum) {
      var length2 = array2 == null ? 0 : array2.length;
      if (initAccum && length2) {
        accumulator = array2[--length2];
      }
      while (length2--) {
        accumulator = iteratee(accumulator, array2[length2], length2, array2);
      }
      return accumulator;
    }
    function arraySome2(array2, predicate) {
      var index2 = -1, length2 = array2 == null ? 0 : array2.length;
      while (++index2 < length2) {
        if (predicate(array2[index2], index2, array2)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty2("length");
    function asciiToArray(string3) {
      return string3.split("");
    }
    function asciiWords(string3) {
      return string3.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array2, predicate, fromIndex, fromRight) {
      var length2 = array2.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length2) {
        if (predicate(array2[index2], index2, array2)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array2, value, fromIndex) {
      return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array2, value, fromIndex, comparator2) {
      var index2 = fromIndex - 1, length2 = array2.length;
      while (++index2 < length2) {
        if (comparator2(array2[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array2, iteratee) {
      var length2 = array2 == null ? 0 : array2.length;
      return length2 ? baseSum(array2, iteratee) / length2 : NAN2;
    }
    function baseProperty2(key) {
      return function(object2) {
        return object2 == null ? undefined$12 : object2[key];
      };
    }
    function basePropertyOf(object2) {
      return function(key) {
        return object2 == null ? undefined$12 : object2[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array2, comparer) {
      var length2 = array2.length;
      array2.sort(comparer);
      while (length2--) {
        array2[length2] = array2[length2].value;
      }
      return array2;
    }
    function baseSum(array2, iteratee) {
      var result, index2 = -1, length2 = array2.length;
      while (++index2 < length2) {
        var current = iteratee(array2[index2]);
        if (current !== undefined$12) {
          result = result === undefined$12 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes2(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object2, props) {
      return arrayMap2(props, function(key) {
        return [key, object2[key]];
      });
    }
    function baseTrim2(string3) {
      return string3 ? string3.slice(0, trimmedEndIndex2(string3) + 1).replace(reTrimStart2, "") : string3;
    }
    function baseUnary2(func2) {
      return function(value) {
        return func2(value);
      };
    }
    function baseValues(object2, props) {
      return arrayMap2(props, function(key) {
        return object2[key];
      });
    }
    function cacheHas2(cache2, key) {
      return cache2.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length2 = strSymbols.length;
      while (++index2 < length2 && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array2, placeholder2) {
      var length2 = array2.length, result = 0;
      while (length2--) {
        if (array2[length2] === placeholder2) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue2(object2, key) {
      return object2 == null ? undefined$12 : object2[key];
    }
    function hasUnicode(string3) {
      return reHasUnicode.test(string3);
    }
    function hasUnicodeWord(string3) {
      return reHasUnicodeWord.test(string3);
    }
    function iteratorToArray(iterator7) {
      var data2, result = [];
      while (!(data2 = iterator7.next()).done) {
        result.push(data2.value);
      }
      return result;
    }
    function mapToArray2(map5) {
      var index2 = -1, result = Array(map5.size);
      map5.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg2(func2, transform4) {
      return function(arg) {
        return func2(transform4(arg));
      };
    }
    function replaceHolders(array2, placeholder2) {
      var index2 = -1, length2 = array2.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array2[index2];
        if (value === placeholder2 || value === PLACEHOLDER) {
          array2[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray2(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array2, value, fromIndex) {
      var index2 = fromIndex - 1, length2 = array2.length;
      while (++index2 < length2) {
        if (array2[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array2, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array2[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string3) {
      return hasUnicode(string3) ? unicodeSize(string3) : asciiSize(string3);
    }
    function stringToArray(string3) {
      return hasUnicode(string3) ? unicodeToArray(string3) : asciiToArray(string3);
    }
    function trimmedEndIndex2(string3) {
      var index2 = string3.length;
      while (index2-- && reWhitespace2.test(string3.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string3) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string3)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string3) {
      return string3.match(reUnicode) || [];
    }
    function unicodeWords(string3) {
      return string3.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context2) {
      context2 = context2 == null ? root2 : _2.defaults(root2.Object(), context2, _2.pick(root2, contextProps));
      var Array2 = context2.Array, Date2 = context2.Date, Error2 = context2.Error, Function3 = context2.Function, Math2 = context2.Math, Object2 = context2.Object, RegExp2 = context2.RegExp, String2 = context2.String, TypeError2 = context2.TypeError;
      var arrayProto2 = Array2.prototype, funcProto2 = Function3.prototype, objectProto2 = Object2.prototype;
      var coreJsData2 = context2["__core-js_shared__"];
      var funcToString2 = funcProto2.toString;
      var hasOwnProperty2 = objectProto2.hasOwnProperty;
      var idCounter2 = 0;
      var maskSrcKey2 = function() {
        var uid2 = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
        return uid2 ? "Symbol(src)_1." + uid2 : "";
      }();
      var nativeObjectToString2 = objectProto2.toString;
      var objectCtorString2 = funcToString2.call(Object2);
      var oldDash = root2._;
      var reIsNative2 = RegExp2(
        "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer2 = moduleExports2 ? context2.Buffer : undefined$12, Symbol2 = context2.Symbol, Uint8Array2 = context2.Uint8Array, allocUnsafe2 = Buffer2 ? Buffer2.allocUnsafe : undefined$12, getPrototype2 = overArg2(Object2.getPrototypeOf, Object2), objectCreate2 = Object2.create, propertyIsEnumerable2 = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$12, symIterator = Symbol2 ? Symbol2.iterator : undefined$12, symToStringTag2 = Symbol2 ? Symbol2.toStringTag : undefined$12;
      var defineProperty2 = function() {
        try {
          var func2 = getNative2(Object2, "defineProperty");
          func2({}, "", {});
          return func2;
        } catch (e3) {
        }
      }();
      var ctxClearTimeout = context2.clearTimeout !== root2.clearTimeout && context2.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context2.setTimeout !== root2.setTimeout && context2.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols2 = Object2.getOwnPropertySymbols, nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : undefined$12, nativeIsFinite = context2.isFinite, nativeJoin = arrayProto2.join, nativeKeys2 = overArg2(Object2.keys, Object2), nativeMax2 = Math2.max, nativeMin2 = Math2.min, nativeNow2 = Date2.now, nativeParseInt = context2.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto2.reverse;
      var DataView2 = getNative2(context2, "DataView"), Map3 = getNative2(context2, "Map"), Promise2 = getNative2(context2, "Promise"), Set2 = getNative2(context2, "Set"), WeakMap2 = getNative2(context2, "WeakMap"), nativeCreate2 = getNative2(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString2 = toSource2(DataView2), mapCtorString2 = toSource2(Map3), promiseCtorString2 = toSource2(Promise2), setCtorString2 = toSource2(Set2), weakMapCtorString2 = toSource2(WeakMap2);
      var symbolProto2 = Symbol2 ? Symbol2.prototype : undefined$12, symbolValueOf2 = symbolProto2 ? symbolProto2.valueOf : undefined$12, symbolToString2 = symbolProto2 ? symbolProto2.toString : undefined$12;
      function lodash2(value) {
        if (isObjectLike2(value) && !isArray3(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate2 = function() {
        function object2() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate2) {
            return objectCreate2(proto);
          }
          object2.prototype = proto;
          var result2 = new object2();
          object2.prototype = undefined$12;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$12;
      }
      lodash2.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "escape": reEscape,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "evaluate": reEvaluate,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        "interpolate": reInterpolate,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        "variable": "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        "imports": {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate2(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray2(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray2(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray2(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array2 = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray3(array2), isRight = dir < 0, arrLength = isArr ? array2.length : 0, view2 = getView(0, arrLength, this.__views__), start2 = view2.start, end = view2.end, length2 = end - start2, index2 = isRight ? end : start2 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin2(length2, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
          return baseWrapperValue(array2, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length2-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array2[index2];
            while (++iterIndex < iterLength) {
              var data2 = iteratees[iterIndex], iteratee2 = data2.iteratee, type = data2.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate2(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear2() {
        this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
        this.size = 0;
      }
      function hashDelete2(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet2(key) {
        var data2 = this.__data__;
        if (nativeCreate2) {
          var result2 = data2[key];
          return result2 === HASH_UNDEFINED2 ? undefined$12 : result2;
        }
        return hasOwnProperty2.call(data2, key) ? data2[key] : undefined$12;
      }
      function hashHas2(key) {
        var data2 = this.__data__;
        return nativeCreate2 ? data2[key] !== undefined$12 : hasOwnProperty2.call(data2, key);
      }
      function hashSet2(key, value) {
        var data2 = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data2[key] = nativeCreate2 && value === undefined$12 ? HASH_UNDEFINED2 : value;
        return this;
      }
      Hash2.prototype.clear = hashClear2;
      Hash2.prototype["delete"] = hashDelete2;
      Hash2.prototype.get = hashGet2;
      Hash2.prototype.has = hashHas2;
      Hash2.prototype.set = hashSet2;
      function ListCache2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear2() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete2(key) {
        var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data2.length - 1;
        if (index2 == lastIndex) {
          data2.pop();
        } else {
          splice2.call(data2, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet2(key) {
        var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
        return index2 < 0 ? undefined$12 : data2[index2][1];
      }
      function listCacheHas2(key) {
        return assocIndexOf2(this.__data__, key) > -1;
      }
      function listCacheSet2(key, value) {
        var data2 = this.__data__, index2 = assocIndexOf2(data2, key);
        if (index2 < 0) {
          ++this.size;
          data2.push([key, value]);
        } else {
          data2[index2][1] = value;
        }
        return this;
      }
      ListCache2.prototype.clear = listCacheClear2;
      ListCache2.prototype["delete"] = listCacheDelete2;
      ListCache2.prototype.get = listCacheGet2;
      ListCache2.prototype.has = listCacheHas2;
      ListCache2.prototype.set = listCacheSet2;
      function MapCache2(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear2() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash2(),
          "map": new (Map3 || ListCache2)(),
          "string": new Hash2()
        };
      }
      function mapCacheDelete2(key) {
        var result2 = getMapData2(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet2(key) {
        return getMapData2(this, key).get(key);
      }
      function mapCacheHas2(key) {
        return getMapData2(this, key).has(key);
      }
      function mapCacheSet2(key, value) {
        var data2 = getMapData2(this, key), size13 = data2.size;
        data2.set(key, value);
        this.size += data2.size == size13 ? 0 : 1;
        return this;
      }
      MapCache2.prototype.clear = mapCacheClear2;
      MapCache2.prototype["delete"] = mapCacheDelete2;
      MapCache2.prototype.get = mapCacheGet2;
      MapCache2.prototype.has = mapCacheHas2;
      MapCache2.prototype.set = mapCacheSet2;
      function SetCache2(values5) {
        var index2 = -1, length2 = values5 == null ? 0 : values5.length;
        this.__data__ = new MapCache2();
        while (++index2 < length2) {
          this.add(values5[index2]);
        }
      }
      function setCacheAdd2(value) {
        this.__data__.set(value, HASH_UNDEFINED2);
        return this;
      }
      function setCacheHas2(value) {
        return this.__data__.has(value);
      }
      SetCache2.prototype.add = SetCache2.prototype.push = setCacheAdd2;
      SetCache2.prototype.has = setCacheHas2;
      function Stack2(entries) {
        var data2 = this.__data__ = new ListCache2(entries);
        this.size = data2.size;
      }
      function stackClear2() {
        this.__data__ = new ListCache2();
        this.size = 0;
      }
      function stackDelete2(key) {
        var data2 = this.__data__, result2 = data2["delete"](key);
        this.size = data2.size;
        return result2;
      }
      function stackGet2(key) {
        return this.__data__.get(key);
      }
      function stackHas2(key) {
        return this.__data__.has(key);
      }
      function stackSet2(key, value) {
        var data2 = this.__data__;
        if (data2 instanceof ListCache2) {
          var pairs2 = data2.__data__;
          if (!Map3 || pairs2.length < LARGE_ARRAY_SIZE2 - 1) {
            pairs2.push([key, value]);
            this.size = ++data2.size;
            return this;
          }
          data2 = this.__data__ = new MapCache2(pairs2);
        }
        data2.set(key, value);
        this.size = data2.size;
        return this;
      }
      Stack2.prototype.clear = stackClear2;
      Stack2.prototype["delete"] = stackDelete2;
      Stack2.prototype.get = stackGet2;
      Stack2.prototype.has = stackHas2;
      Stack2.prototype.set = stackSet2;
      function arrayLikeKeys2(value, inherited) {
        var isArr = isArray3(value), isArg = !isArr && isArguments5(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray2(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes2(value.length, String2) : [], length2 = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex2(key, length2)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array2) {
        var length2 = array2.length;
        return length2 ? array2[baseRandom(0, length2 - 1)] : undefined$12;
      }
      function arraySampleSize(array2, n2) {
        return shuffleSelf(copyArray2(array2), baseClamp(n2, 0, array2.length));
      }
      function arrayShuffle(array2) {
        return shuffleSelf(copyArray2(array2));
      }
      function assignMergeValue2(object2, key, value) {
        if (value !== undefined$12 && !eq2(object2[key], value) || value === undefined$12 && !(key in object2)) {
          baseAssignValue2(object2, key, value);
        }
      }
      function assignValue2(object2, key, value) {
        var objValue = object2[key];
        if (!(hasOwnProperty2.call(object2, key) && eq2(objValue, value)) || value === undefined$12 && !(key in object2)) {
          baseAssignValue2(object2, key, value);
        }
      }
      function assocIndexOf2(array2, key) {
        var length2 = array2.length;
        while (length2--) {
          if (eq2(array2[length2][0], key)) {
            return length2;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach2(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign2(object2, source) {
        return object2 && copyObject2(source, keys4(source), object2);
      }
      function baseAssignIn2(object2, source) {
        return object2 && copyObject2(source, keysIn2(source), object2);
      }
      function baseAssignValue2(object2, key, value) {
        if (key == "__proto__" && defineProperty2) {
          defineProperty2(object2, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object2[key] = value;
        }
      }
      function baseAt(object2, paths) {
        var index2 = -1, length2 = paths.length, result2 = Array2(length2), skip = object2 == null;
        while (++index2 < length2) {
          result2[index2] = skip ? undefined$12 : get6(object2, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number2, lower, upper) {
        if (number2 === number2) {
          if (upper !== undefined$12) {
            number2 = number2 <= upper ? number2 : upper;
          }
          if (lower !== undefined$12) {
            number2 = number2 >= lower ? number2 : lower;
          }
        }
        return number2;
      }
      function baseClone2(value, bitmask, customizer, key, object2, stack2) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG2, isFlat = bitmask & CLONE_FLAT_FLAG2, isFull = bitmask & CLONE_SYMBOLS_FLAG2;
        if (customizer) {
          result2 = object2 ? customizer(value, key, object2, stack2) : customizer(value);
        }
        if (result2 !== undefined$12) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray3(value);
        if (isArr) {
          result2 = initCloneArray2(value);
          if (!isDeep) {
            return copyArray2(value, result2);
          }
        } else {
          var tag2 = getTag2(value), isFunc = tag2 == funcTag2 || tag2 == genTag2;
          if (isBuffer2(value)) {
            return cloneBuffer2(value, isDeep);
          }
          if (tag2 == objectTag2 || tag2 == argsTag2 || isFunc && !object2) {
            result2 = isFlat || isFunc ? {} : initCloneObject2(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn2(value, baseAssignIn2(result2, value)) : copySymbols2(value, baseAssign2(result2, value));
            }
          } else {
            if (!cloneableTags2[tag2]) {
              return object2 ? value : {};
            }
            result2 = initCloneByTag2(value, tag2, isDeep);
          }
        }
        stack2 || (stack2 = new Stack2());
        var stacked = stack2.get(value);
        if (stacked) {
          return stacked;
        }
        stack2.set(value, result2);
        if (isSet2(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone2(subValue, bitmask, customizer, subValue, value, stack2));
          });
        } else if (isMap2(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone2(subValue, bitmask, customizer, key2, value, stack2));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn2 : getAllKeys2 : isFlat ? keysIn2 : keys4;
        var props = isArr ? undefined$12 : keysFunc(value);
        arrayEach2(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue2(result2, key2, baseClone2(subValue, bitmask, customizer, key2, value, stack2));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys4(source);
        return function(object2) {
          return baseConformsTo(object2, source, props);
        };
      }
      function baseConformsTo(object2, source, props) {
        var length2 = props.length;
        if (object2 == null) {
          return !length2;
        }
        object2 = Object2(object2);
        while (length2--) {
          var key = props[length2], predicate = source[key], value = object2[key];
          if (value === undefined$12 && !(key in object2) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func2, wait, args) {
        if (typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return setTimeout2(function() {
          func2.apply(undefined$12, args);
        }, wait);
      }
      function baseDifference(array2, values5, iteratee2, comparator2) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length2 = array2.length, result2 = [], valuesLength = values5.length;
        if (!length2) {
          return result2;
        }
        if (iteratee2) {
          values5 = arrayMap2(values5, baseUnary2(iteratee2));
        }
        if (comparator2) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values5.length >= LARGE_ARRAY_SIZE2) {
          includes2 = cacheHas2;
          isCommon = false;
          values5 = new SetCache2(values5);
        }
        outer:
          while (++index2 < length2) {
            var value = array2[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator2 || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values5[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values5, computed, comparator2)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach2 = createBaseEach2(baseForOwn2);
      var baseEachRight = createBaseEach2(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach2(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array2, iteratee2, comparator2) {
        var index2 = -1, length2 = array2.length;
        while (++index2 < length2) {
          var value = array2[index2], current = iteratee2(value);
          if (current != null && (computed === undefined$12 ? current === current && !isSymbol2(current) : comparator2(current, computed))) {
            var computed = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array2, value, start2, end) {
        var length2 = array2.length;
        start2 = toInteger(start2);
        if (start2 < 0) {
          start2 = -start2 > length2 ? 0 : length2 + start2;
        }
        end = end === undefined$12 || end > length2 ? length2 : toInteger(end);
        if (end < 0) {
          end += length2;
        }
        end = start2 > end ? 0 : toLength(end);
        while (start2 < end) {
          array2[start2++] = value;
        }
        return array2;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach2(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array2, depth2, predicate, isStrict, result2) {
        var index2 = -1, length2 = array2.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length2) {
          var value = array2[index2];
          if (depth2 > 0 && predicate(value)) {
            if (depth2 > 1) {
              baseFlatten(value, depth2 - 1, predicate, isStrict, result2);
            } else {
              arrayPush2(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor2 = createBaseFor2();
      var baseForRight = createBaseFor2(true);
      function baseForOwn2(object2, iteratee2) {
        return object2 && baseFor2(object2, iteratee2, keys4);
      }
      function baseForOwnRight(object2, iteratee2) {
        return object2 && baseForRight(object2, iteratee2, keys4);
      }
      function baseFunctions(object2, props) {
        return arrayFilter2(props, function(key) {
          return isFunction2(object2[key]);
        });
      }
      function baseGet2(object2, path2) {
        path2 = castPath2(path2, object2);
        var index2 = 0, length2 = path2.length;
        while (object2 != null && index2 < length2) {
          object2 = object2[toKey2(path2[index2++])];
        }
        return index2 && index2 == length2 ? object2 : undefined$12;
      }
      function baseGetAllKeys2(object2, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object2);
        return isArray3(object2) ? result2 : arrayPush2(result2, symbolsFunc(object2));
      }
      function baseGetTag2(value) {
        if (value == null) {
          return value === undefined$12 ? undefinedTag2 : nullTag2;
        }
        return symToStringTag2 && symToStringTag2 in Object2(value) ? getRawTag2(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object2, key) {
        return object2 != null && hasOwnProperty2.call(object2, key);
      }
      function baseHasIn2(object2, key) {
        return object2 != null && key in Object2(object2);
      }
      function baseInRange(number2, start2, end) {
        return number2 >= nativeMin2(start2, end) && number2 < nativeMax2(start2, end);
      }
      function baseIntersection(arrays, iteratee2, comparator2) {
        var includes2 = comparator2 ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array2 = arrays[othIndex];
          if (othIndex && iteratee2) {
            array2 = arrayMap2(array2, baseUnary2(iteratee2));
          }
          maxLength = nativeMin2(array2.length, maxLength);
          caches[othIndex] = !comparator2 && (iteratee2 || length2 >= 120 && array2.length >= 120) ? new SetCache2(othIndex && array2) : undefined$12;
        }
        array2 = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length2 && result2.length < maxLength) {
            var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator2 || value !== 0 ? value : 0;
            if (!(seen ? cacheHas2(seen, computed) : includes2(result2, computed, comparator2))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache2 = caches[othIndex];
                if (!(cache2 ? cacheHas2(cache2, computed) : includes2(arrays[othIndex], computed, comparator2))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object2, setter, iteratee2, accumulator) {
        baseForOwn2(object2, function(value, key, object3) {
          setter(accumulator, iteratee2(value), key, object3);
        });
        return accumulator;
      }
      function baseInvoke(object2, path2, args) {
        path2 = castPath2(path2, object2);
        object2 = parent(object2, path2);
        var func2 = object2 == null ? object2 : object2[toKey2(last(path2))];
        return func2 == null ? undefined$12 : apply2(func2, object2, args);
      }
      function baseIsArguments2(value) {
        return isObjectLike2(value) && baseGetTag2(value) == argsTag2;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike2(value) && baseGetTag2(value) == arrayBufferTag2;
      }
      function baseIsDate(value) {
        return isObjectLike2(value) && baseGetTag2(value) == dateTag2;
      }
      function baseIsEqual2(value, other, bitmask, customizer, stack2) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep2(value, other, bitmask, customizer, baseIsEqual2, stack2);
      }
      function baseIsEqualDeep2(object2, other, bitmask, customizer, equalFunc, stack2) {
        var objIsArr = isArray3(object2), othIsArr = isArray3(other), objTag = objIsArr ? arrayTag2 : getTag2(object2), othTag = othIsArr ? arrayTag2 : getTag2(other);
        objTag = objTag == argsTag2 ? objectTag2 : objTag;
        othTag = othTag == argsTag2 ? objectTag2 : othTag;
        var objIsObj = objTag == objectTag2, othIsObj = othTag == objectTag2, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object2)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack2 || (stack2 = new Stack2());
          return objIsArr || isTypedArray2(object2) ? equalArrays2(object2, other, bitmask, customizer, equalFunc, stack2) : equalByTag2(object2, other, objTag, bitmask, customizer, equalFunc, stack2);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG2)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
            stack2 || (stack2 = new Stack2());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack2 || (stack2 = new Stack2());
        return equalObjects2(object2, other, bitmask, customizer, equalFunc, stack2);
      }
      function baseIsMap2(value) {
        return isObjectLike2(value) && getTag2(value) == mapTag2;
      }
      function baseIsMatch2(object2, source, matchData, customizer) {
        var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
        if (object2 == null) {
          return !length2;
        }
        object2 = Object2(object2);
        while (index2--) {
          var data2 = matchData[index2];
          if (noCustomizer && data2[2] ? data2[1] !== object2[data2[0]] : !(data2[0] in object2)) {
            return false;
          }
        }
        while (++index2 < length2) {
          data2 = matchData[index2];
          var key = data2[0], objValue = object2[key], srcValue = data2[1];
          if (noCustomizer && data2[2]) {
            if (objValue === undefined$12 && !(key in object2)) {
              return false;
            }
          } else {
            var stack2 = new Stack2();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object2, source, stack2);
            }
            if (!(result2 === undefined$12 ? baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2, customizer, stack2) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative2(value) {
        if (!isObject2(value) || isMasked2(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative2 : reIsHostCtor2;
        return pattern.test(toSource2(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike2(value) && baseGetTag2(value) == regexpTag2;
      }
      function baseIsSet2(value) {
        return isObjectLike2(value) && getTag2(value) == setTag2;
      }
      function baseIsTypedArray2(value) {
        return isObjectLike2(value) && isLength2(value.length) && !!typedArrayTags2[baseGetTag2(value)];
      }
      function baseIteratee2(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity2;
        }
        if (typeof value == "object") {
          return isArray3(value) ? baseMatchesProperty2(value[0], value[1]) : baseMatches2(value);
        }
        return property2(value);
      }
      function baseKeys2(object2) {
        if (!isPrototype2(object2)) {
          return nativeKeys2(object2);
        }
        var result2 = [];
        for (var key in Object2(object2)) {
          if (hasOwnProperty2.call(object2, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn2(object2) {
        if (!isObject2(object2)) {
          return nativeKeysIn2(object2);
        }
        var isProto = isPrototype2(object2), result2 = [];
        for (var key in object2) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object2, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap2(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach2(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches2(source) {
        var matchData = getMatchData2(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable2(matchData[0][0], matchData[0][1]);
        }
        return function(object2) {
          return object2 === source || baseIsMatch2(object2, source, matchData);
        };
      }
      function baseMatchesProperty2(path2, srcValue) {
        if (isKey2(path2) && isStrictComparable2(srcValue)) {
          return matchesStrictComparable2(toKey2(path2), srcValue);
        }
        return function(object2) {
          var objValue = get6(object2, path2);
          return objValue === undefined$12 && objValue === srcValue ? hasIn2(object2, path2) : baseIsEqual2(srcValue, objValue, COMPARE_PARTIAL_FLAG2 | COMPARE_UNORDERED_FLAG2);
        };
      }
      function baseMerge2(object2, source, srcIndex, customizer, stack2) {
        if (object2 === source) {
          return;
        }
        baseFor2(source, function(srcValue, key) {
          stack2 || (stack2 = new Stack2());
          if (isObject2(srcValue)) {
            baseMergeDeep2(object2, source, key, srcIndex, baseMerge2, customizer, stack2);
          } else {
            var newValue = customizer ? customizer(safeGet2(object2, key), srcValue, key + "", object2, source, stack2) : undefined$12;
            if (newValue === undefined$12) {
              newValue = srcValue;
            }
            assignMergeValue2(object2, key, newValue);
          }
        }, keysIn2);
      }
      function baseMergeDeep2(object2, source, key, srcIndex, mergeFunc, customizer, stack2) {
        var objValue = safeGet2(object2, key), srcValue = safeGet2(source, key), stacked = stack2.get(srcValue);
        if (stacked) {
          assignMergeValue2(object2, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack2) : undefined$12;
        var isCommon = newValue === undefined$12;
        if (isCommon) {
          var isArr = isArray3(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray2(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray3(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject2(objValue)) {
              newValue = copyArray2(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer2(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray2(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments5(srcValue)) {
            newValue = objValue;
            if (isArguments5(objValue)) {
              newValue = toPlainObject2(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject2(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack2.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack2);
          stack2["delete"](srcValue);
        }
        assignMergeValue2(object2, key, newValue);
      }
      function baseNth(array2, n2) {
        var length2 = array2.length;
        if (!length2) {
          return;
        }
        n2 += n2 < 0 ? length2 : 0;
        return isIndex2(n2, length2) ? array2[n2] : undefined$12;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap2(iteratees, function(iteratee2) {
            if (isArray3(iteratee2)) {
              return function(value) {
                return baseGet2(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity2];
        }
        var index2 = -1;
        iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
        var result2 = baseMap2(collection, function(value, key, collection2) {
          var criteria = arrayMap2(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object2, other) {
          return compareMultiple(object2, other, orders);
        });
      }
      function basePick(object2, paths) {
        return basePickBy(object2, paths, function(value, path2) {
          return hasIn2(object2, path2);
        });
      }
      function basePickBy(object2, paths, predicate) {
        var index2 = -1, length2 = paths.length, result2 = {};
        while (++index2 < length2) {
          var path2 = paths[index2], value = baseGet2(object2, path2);
          if (predicate(value, path2)) {
            baseSet(result2, castPath2(path2, object2), value);
          }
        }
        return result2;
      }
      function basePropertyDeep2(path2) {
        return function(object2) {
          return baseGet2(object2, path2);
        };
      }
      function basePullAll(array2, values5, iteratee2, comparator2) {
        var indexOf3 = comparator2 ? baseIndexOfWith : baseIndexOf, index2 = -1, length2 = values5.length, seen = array2;
        if (array2 === values5) {
          values5 = copyArray2(values5);
        }
        if (iteratee2) {
          seen = arrayMap2(array2, baseUnary2(iteratee2));
        }
        while (++index2 < length2) {
          var fromIndex = 0, value = values5[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf3(seen, computed, fromIndex, comparator2)) > -1) {
            if (seen !== array2) {
              splice2.call(seen, fromIndex, 1);
            }
            splice2.call(array2, fromIndex, 1);
          }
        }
        return array2;
      }
      function basePullAt(array2, indexes) {
        var length2 = array2 ? indexes.length : 0, lastIndex = length2 - 1;
        while (length2--) {
          var index2 = indexes[length2];
          if (length2 == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex2(index2)) {
              splice2.call(array2, index2, 1);
            } else {
              baseUnset(array2, index2);
            }
          }
        }
        return array2;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start2, end, step, fromRight) {
        var index2 = -1, length2 = nativeMax2(nativeCeil((end - start2) / (step || 1)), 0), result2 = Array2(length2);
        while (length2--) {
          result2[fromRight ? length2 : ++index2] = start2;
          start2 += step;
        }
        return result2;
      }
      function baseRepeat(string3, n2) {
        var result2 = "";
        if (!string3 || n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return result2;
        }
        do {
          if (n2 % 2) {
            result2 += string3;
          }
          n2 = nativeFloor(n2 / 2);
          if (n2) {
            string3 += string3;
          }
        } while (n2);
        return result2;
      }
      function baseRest2(func2, start2) {
        return setToString2(overRest2(func2, start2, identity2), func2 + "");
      }
      function baseSample(collection) {
        return arraySample(values4(collection));
      }
      function baseSampleSize(collection, n2) {
        var array2 = values4(collection);
        return shuffleSelf(array2, baseClamp(n2, 0, array2.length));
      }
      function baseSet(object2, path2, value, customizer) {
        if (!isObject2(object2)) {
          return object2;
        }
        path2 = castPath2(path2, object2);
        var index2 = -1, length2 = path2.length, lastIndex = length2 - 1, nested = object2;
        while (nested != null && ++index2 < length2) {
          var key = toKey2(path2[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object2;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$12;
            if (newValue === undefined$12) {
              newValue = isObject2(objValue) ? objValue : isIndex2(path2[index2 + 1]) ? [] : {};
            }
          }
          assignValue2(nested, key, newValue);
          nested = nested[key];
        }
        return object2;
      }
      var baseSetData = !metaMap ? identity2 : function(func2, data2) {
        metaMap.set(func2, data2);
        return func2;
      };
      var baseSetToString2 = !defineProperty2 ? identity2 : function(func2, string3) {
        return defineProperty2(func2, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant2(string3),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values4(collection));
      }
      function baseSlice(array2, start2, end) {
        var index2 = -1, length2 = array2.length;
        if (start2 < 0) {
          start2 = -start2 > length2 ? 0 : length2 + start2;
        }
        end = end > length2 ? length2 : end;
        if (end < 0) {
          end += length2;
        }
        length2 = start2 > end ? 0 : end - start2 >>> 0;
        start2 >>>= 0;
        var result2 = Array2(length2);
        while (++index2 < length2) {
          result2[index2] = array2[index2 + start2];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach2(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array2, value, retHighest) {
        var low = 0, high = array2 == null ? low : array2.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array2[mid];
            if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array2, value, identity2, retHighest);
      }
      function baseSortedIndexBy(array2, value, iteratee2, retHighest) {
        var low = 0, high = array2 == null ? 0 : array2.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined$12;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array2[mid]), othIsDefined = computed !== undefined$12, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin2(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array2, iteratee2) {
        var index2 = -1, length2 = array2.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq2(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        return +value;
      }
      function baseToString2(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray3(value)) {
          return arrayMap2(value, baseToString2) + "";
        }
        if (isSymbol2(value)) {
          return symbolToString2 ? symbolToString2.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY2 ? "-0" : result2;
      }
      function baseUniq(array2, iteratee2, comparator2) {
        var index2 = -1, includes2 = arrayIncludes, length2 = array2.length, isCommon = true, result2 = [], seen = result2;
        if (comparator2) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length2 >= LARGE_ARRAY_SIZE2) {
          var set2 = iteratee2 ? null : createSet(array2);
          if (set2) {
            return setToArray2(set2);
          }
          isCommon = false;
          includes2 = cacheHas2;
          seen = new SetCache2();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length2) {
            var value = array2[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator2 || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator2)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object2, path2) {
        path2 = castPath2(path2, object2);
        object2 = parent(object2, path2);
        return object2 == null || delete object2[toKey2(last(path2))];
      }
      function baseUpdate(object2, path2, updater, customizer) {
        return baseSet(object2, path2, updater(baseGet2(object2, path2)), customizer);
      }
      function baseWhile(array2, predicate, isDrop, fromRight) {
        var length2 = array2.length, index2 = fromRight ? length2 : -1;
        while ((fromRight ? index2-- : ++index2 < length2) && predicate(array2[index2], index2, array2)) {
        }
        return isDrop ? baseSlice(array2, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice(array2, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush2([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator2) {
        var length2 = arrays.length;
        if (length2 < 2) {
          return length2 ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length2);
        while (++index2 < length2) {
          var array2 = arrays[index2], othIndex = -1;
          while (++othIndex < length2) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array2, arrays[othIndex], iteratee2, comparator2);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator2);
      }
      function baseZipObject(props, values5, assignFunc) {
        var index2 = -1, length2 = props.length, valsLength = values5.length, result2 = {};
        while (++index2 < length2) {
          var value = index2 < valsLength ? values5[index2] : undefined$12;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject2(value) ? value : [];
      }
      function castFunction2(value) {
        return typeof value == "function" ? value : identity2;
      }
      function castPath2(value, object2) {
        if (isArray3(value)) {
          return value;
        }
        return isKey2(value, object2) ? [value] : stringToPath3(toString29(value));
      }
      var castRest = baseRest2;
      function castSlice(array2, start2, end) {
        var length2 = array2.length;
        end = end === undefined$12 ? length2 : end;
        return !start2 && end >= length2 ? array2 : baseSlice(array2, start2, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root2.clearTimeout(id);
      };
      function cloneBuffer2(buffer3, isDeep) {
        if (isDeep) {
          return buffer3.slice();
        }
        var length2 = buffer3.length, result2 = allocUnsafe2 ? allocUnsafe2(length2) : new buffer3.constructor(length2);
        buffer3.copy(result2);
        return result2;
      }
      function cloneArrayBuffer2(arrayBuffer2) {
        var result2 = new arrayBuffer2.constructor(arrayBuffer2.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer2));
        return result2;
      }
      function cloneDataView2(dataView, isDeep) {
        var buffer3 = isDeep ? cloneArrayBuffer2(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer3, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp2(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags2.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol2(symbol) {
        return symbolValueOf2 ? Object2(symbolValueOf2.call(symbol)) : {};
      }
      function cloneTypedArray2(typedArray, isDeep) {
        var buffer3 = isDeep ? cloneArrayBuffer2(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer3, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$12, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
          var othIsDefined = other !== undefined$12, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object2, other, orders) {
        var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length2) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order = orders[index2];
            return result2 * (order == "desc" ? -1 : 1);
          }
        }
        return object2.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray2(source, array2) {
        var index2 = -1, length2 = source.length;
        array2 || (array2 = Array2(length2));
        while (++index2 < length2) {
          array2[index2] = source[index2];
        }
        return array2;
      }
      function copyObject2(source, props, object2, customizer) {
        var isNew = !object2;
        object2 || (object2 = {});
        var index2 = -1, length2 = props.length;
        while (++index2 < length2) {
          var key = props[index2];
          var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : undefined$12;
          if (newValue === undefined$12) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue2(object2, key, newValue);
          } else {
            assignValue2(object2, key, newValue);
          }
        }
        return object2;
      }
      function copySymbols2(source, object2) {
        return copyObject2(source, getSymbols2(source), object2);
      }
      function copySymbolsIn2(source, object2) {
        return copyObject2(source, getSymbolsIn2(source), object2);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func2 = isArray3(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func2(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner2(assigner) {
        return baseRest2(function(object2, sources2) {
          var index2 = -1, length2 = sources2.length, customizer = length2 > 1 ? sources2[length2 - 1] : undefined$12, guard = length2 > 2 ? sources2[2] : undefined$12;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined$12;
          if (guard && isIterateeCall2(sources2[0], sources2[1], guard)) {
            customizer = length2 < 3 ? undefined$12 : customizer;
            length2 = 1;
          }
          object2 = Object2(object2);
          while (++index2 < length2) {
            var source = sources2[index2];
            if (source) {
              assigner(object2, source, index2, customizer);
            }
          }
          return object2;
        });
      }
      function createBaseEach2(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike2(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length2) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor2(fromRight) {
        return function(object2, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object2), props = keysFunc(object2), length2 = props.length;
          while (length2--) {
            var key = props[fromRight ? length2 : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object2;
        };
      }
      function createBind(func2, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func2);
        function wrapper() {
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func2;
          return fn2.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string3) {
          string3 = toString29(string3);
          var strSymbols = hasUnicode(string3) ? stringToArray(string3) : undefined$12;
          var chr = strSymbols ? strSymbols[0] : string3.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string3.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string3) {
          return arrayReduce(words(deburr(string3).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate2(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func2, bitmask, arity) {
        var Ctor = createCtor(func2);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder2 = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length2 < 3 && args[0] !== placeholder2 && args[length2 - 1] !== placeholder2 ? [] : replaceHolders(args, placeholder2);
          length2 -= holders.length;
          if (length2 < arity) {
            return createRecurry(
              func2,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$12,
              args,
              holders,
              undefined$12,
              undefined$12,
              arity - length2
            );
          }
          var fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func2;
          return apply2(fn2, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike2(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys4(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$12;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func2 = funcs[index2];
            if (typeof func2 != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT2);
            }
            if (prereq && !wrapper && getFuncName(func2) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length2;
          while (++index2 < length2) {
            func2 = funcs[index2];
            var funcName = getFuncName(func2), data2 = funcName == "wrapper" ? getData6(func2) : undefined$12;
            if (data2 && isLaziable(data2[0]) && data2[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data2[4].length && data2[9] == 1) {
              wrapper = wrapper[getFuncName(data2[0])].apply(wrapper, data2[3]);
            } else {
              wrapper = func2.length == 1 && isLaziable(func2) ? wrapper[funcName]() : wrapper.thru(func2);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray3(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length2 ? funcs[index3].apply(this, args) : value;
            while (++index3 < length2) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func2, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$12 : createCtor(func2);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder2 = getHolder(wrapper), holdersCount = countHolders(args, placeholder2);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length2 -= holdersCount;
          if (isCurried && length2 < arity) {
            var newHolders = replaceHolders(args, placeholder2);
            return createRecurry(
              func2,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length2
            );
          }
          var thisBinding = isBind ? thisArg : this, fn2 = isBindKey ? thisBinding[func2] : func2;
          length2 = args.length;
          if (argPos) {
            args = reorder2(args, argPos);
          } else if (isFlip && length2 > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length2) {
            args.length = ary2;
          }
          if (this && this !== root2 && this instanceof wrapper) {
            fn2 = Ctor || createCtor(fn2);
          }
          return fn2.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object2, iteratee2) {
          return baseInverter(object2, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue2) {
        return function(value, other) {
          var result2;
          if (value === undefined$12 && other === undefined$12) {
            return defaultValue2;
          }
          if (value !== undefined$12) {
            result2 = value;
          }
          if (other !== undefined$12) {
            if (result2 === undefined$12) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString2(value);
              other = baseToString2(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap2(iteratees, baseUnary2(getIteratee()));
          return baseRest2(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply2(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length2, chars2) {
        chars2 = chars2 === undefined$12 ? " " : baseToString2(chars2);
        var charsLength = chars2.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars2, length2) : chars2;
        }
        var result2 = baseRepeat(chars2, nativeCeil(length2 / stringSize(chars2)));
        return hasUnicode(chars2) ? castSlice(stringToArray(result2), 0, length2).join("") : result2.slice(0, length2);
      }
      function createPartial(func2, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func2);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn2 = this && this !== root2 && this instanceof wrapper ? Ctor : func2;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply2(fn2, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start2, end, step) {
          if (step && typeof step != "number" && isIterateeCall2(start2, end, step)) {
            end = step = undefined$12;
          }
          start2 = toFinite(start2);
          if (end === undefined$12) {
            end = start2;
            start2 = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$12 ? start2 < end ? 1 : -1 : toFinite(step);
          return baseRange(start2, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber4(value);
            other = toNumber4(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func2, bitmask, wrapFunc, placeholder2, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$12, newHoldersRight = isCurry ? undefined$12 : holders, newPartials = isCurry ? partials : undefined$12, newPartialsRight = isCurry ? undefined$12 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func2,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$12, newData);
        if (isLaziable(func2)) {
          setData6(result2, newData);
        }
        result2.placeholder = placeholder2;
        return setWrapToString(result2, func2, bitmask);
      }
      function createRound(methodName) {
        var func2 = Math2[methodName];
        return function(number2, precision) {
          number2 = toNumber4(number2);
          precision = precision == null ? 0 : nativeMin2(toInteger(precision), 292);
          if (precision && nativeIsFinite(number2)) {
            var pair = (toString29(number2) + "e").split("e"), value = func2(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString29(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func2(number2);
        };
      }
      var createSet = !(Set2 && 1 / setToArray2(new Set2([, -0]))[1] == INFINITY2) ? noop2 : function(values5) {
        return new Set2(values5);
      };
      function createToPairs(keysFunc) {
        return function(object2) {
          var tag2 = getTag2(object2);
          if (tag2 == mapTag2) {
            return mapToArray2(object2);
          }
          if (tag2 == setTag2) {
            return setToPairs(object2);
          }
          return baseToPairs(object2, keysFunc(object2));
        };
      }
      function createWrap(func2, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var length2 = partials ? partials.length : 0;
        if (!length2) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$12;
        }
        ary2 = ary2 === undefined$12 ? ary2 : nativeMax2(toInteger(ary2), 0);
        arity = arity === undefined$12 ? arity : toInteger(arity);
        length2 -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$12;
        }
        var data2 = isBindKey ? undefined$12 : getData6(func2);
        var newData = [
          func2,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data2) {
          mergeData(newData, data2);
        }
        func2 = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$12 ? isBindKey ? 0 : func2.length : nativeMax2(newData[9] - length2, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func2, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func2, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func2, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$12, newData);
        }
        var setter = data2 ? baseSetData : setData6;
        return setWrapToString(setter(result2, newData), func2, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object2) {
        if (objValue === undefined$12 || eq2(objValue, objectProto2[key]) && !hasOwnProperty2.call(object2, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object2, source, stack2) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack2.set(srcValue, objValue);
          baseMerge2(objValue, srcValue, undefined$12, customDefaultsMerge, stack2);
          stack2["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject2(value) ? undefined$12 : value;
      }
      function equalArrays2(array2, other, bitmask, customizer, equalFunc, stack2) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, arrLength = array2.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack2.get(array2);
        var othStacked = stack2.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array2;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG2 ? new SetCache2() : undefined$12;
        stack2.set(array2, other);
        stack2.set(other, array2);
        while (++index2 < arrLength) {
          var arrValue = array2[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack2) : customizer(arrValue, othValue, index2, array2, other, stack2);
          }
          if (compared !== undefined$12) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome2(other, function(othValue2, othIndex) {
              if (!cacheHas2(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
            result2 = false;
            break;
          }
        }
        stack2["delete"](array2);
        stack2["delete"](other);
        return result2;
      }
      function equalByTag2(object2, other, tag2, bitmask, customizer, equalFunc, stack2) {
        switch (tag2) {
          case dataViewTag2:
            if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
              return false;
            }
            object2 = object2.buffer;
            other = other.buffer;
          case arrayBufferTag2:
            if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object2), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag2:
          case dateTag2:
          case numberTag2:
            return eq2(+object2, +other);
          case errorTag2:
            return object2.name == other.name && object2.message == other.message;
          case regexpTag2:
          case stringTag2:
            return object2 == other + "";
          case mapTag2:
            var convert = mapToArray2;
          case setTag2:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG2;
            convert || (convert = setToArray2);
            if (object2.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack2.get(object2);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG2;
            stack2.set(object2, other);
            var result2 = equalArrays2(convert(object2), convert(other), bitmask, customizer, equalFunc, stack2);
            stack2["delete"](object2);
            return result2;
          case symbolTag2:
            if (symbolValueOf2) {
              return symbolValueOf2.call(object2) == symbolValueOf2.call(other);
            }
        }
        return false;
      }
      function equalObjects2(object2, other, bitmask, customizer, equalFunc, stack2) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG2, objProps = getAllKeys2(object2), objLength = objProps.length, othProps = getAllKeys2(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack2.get(object2);
        var othStacked = stack2.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object2;
        }
        var result2 = true;
        stack2.set(object2, other);
        stack2.set(other, object2);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object2[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack2) : customizer(objValue, othValue, key, object2, other, stack2);
          }
          if (!(compared === undefined$12 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object2.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack2["delete"](object2);
        stack2["delete"](other);
        return result2;
      }
      function flatRest(func2) {
        return setToString2(overRest2(func2, undefined$12, flatten3), func2 + "");
      }
      function getAllKeys2(object2) {
        return baseGetAllKeys2(object2, keys4, getSymbols2);
      }
      function getAllKeysIn2(object2) {
        return baseGetAllKeys2(object2, keysIn2, getSymbolsIn2);
      }
      var getData6 = !metaMap ? noop2 : function(func2) {
        return metaMap.get(func2);
      };
      function getFuncName(func2) {
        var result2 = func2.name + "", array2 = realNames[result2], length2 = hasOwnProperty2.call(realNames, result2) ? array2.length : 0;
        while (length2--) {
          var data2 = array2[length2], otherFunc = data2.func;
          if (otherFunc == null || otherFunc == func2) {
            return data2.name;
          }
        }
        return result2;
      }
      function getHolder(func2) {
        var object2 = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func2;
        return object2.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee2 : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData2(map6, key) {
        var data2 = map6.__data__;
        return isKeyable2(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
      }
      function getMatchData2(object2) {
        var result2 = keys4(object2), length2 = result2.length;
        while (length2--) {
          var key = result2[length2], value = object2[key];
          result2[length2] = [key, value, isStrictComparable2(value)];
        }
        return result2;
      }
      function getNative2(object2, key) {
        var value = getValue2(object2, key);
        return baseIsNative2(value) ? value : undefined$12;
      }
      function getRawTag2(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag2), tag2 = value[symToStringTag2];
        try {
          value[symToStringTag2] = undefined$12;
          var unmasked = true;
        } catch (e3) {
        }
        var result2 = nativeObjectToString2.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag2] = tag2;
          } else {
            delete value[symToStringTag2];
          }
        }
        return result2;
      }
      var getSymbols2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
        if (object2 == null) {
          return [];
        }
        object2 = Object2(object2);
        return arrayFilter2(nativeGetSymbols2(object2), function(symbol) {
          return propertyIsEnumerable2.call(object2, symbol);
        });
      };
      var getSymbolsIn2 = !nativeGetSymbols2 ? stubArray2 : function(object2) {
        var result2 = [];
        while (object2) {
          arrayPush2(result2, getSymbols2(object2));
          object2 = getPrototype2(object2);
        }
        return result2;
      };
      var getTag2 = baseGetTag2;
      if (DataView2 && getTag2(new DataView2(new ArrayBuffer(1))) != dataViewTag2 || Map3 && getTag2(new Map3()) != mapTag2 || Promise2 && getTag2(Promise2.resolve()) != promiseTag2 || Set2 && getTag2(new Set2()) != setTag2 || WeakMap2 && getTag2(new WeakMap2()) != weakMapTag2) {
        getTag2 = function(value) {
          var result2 = baseGetTag2(value), Ctor = result2 == objectTag2 ? value.constructor : undefined$12, ctorString = Ctor ? toSource2(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString2:
                return dataViewTag2;
              case mapCtorString2:
                return mapTag2;
              case promiseCtorString2:
                return promiseTag2;
              case setCtorString2:
                return setTag2;
              case weakMapCtorString2:
                return weakMapTag2;
            }
          }
          return result2;
        };
      }
      function getView(start2, end, transforms2) {
        var index2 = -1, length2 = transforms2.length;
        while (++index2 < length2) {
          var data2 = transforms2[index2], size13 = data2.size;
          switch (data2.type) {
            case "drop":
              start2 += size13;
              break;
            case "dropRight":
              end -= size13;
              break;
            case "take":
              end = nativeMin2(end, start2 + size13);
              break;
            case "takeRight":
              start2 = nativeMax2(start2, end - size13);
              break;
          }
        }
        return { "start": start2, "end": end };
      }
      function getWrapDetails(source) {
        var match2 = source.match(reWrapDetails);
        return match2 ? match2[1].split(reSplitDetails) : [];
      }
      function hasPath2(object2, path2, hasFunc) {
        path2 = castPath2(path2, object2);
        var index2 = -1, length2 = path2.length, result2 = false;
        while (++index2 < length2) {
          var key = toKey2(path2[index2]);
          if (!(result2 = object2 != null && hasFunc(object2, key))) {
            break;
          }
          object2 = object2[key];
        }
        if (result2 || ++index2 != length2) {
          return result2;
        }
        length2 = object2 == null ? 0 : object2.length;
        return !!length2 && isLength2(length2) && isIndex2(key, length2) && (isArray3(object2) || isArguments5(object2));
      }
      function initCloneArray2(array2) {
        var length2 = array2.length, result2 = new array2.constructor(length2);
        if (length2 && typeof array2[0] == "string" && hasOwnProperty2.call(array2, "index")) {
          result2.index = array2.index;
          result2.input = array2.input;
        }
        return result2;
      }
      function initCloneObject2(object2) {
        return typeof object2.constructor == "function" && !isPrototype2(object2) ? baseCreate2(getPrototype2(object2)) : {};
      }
      function initCloneByTag2(object2, tag2, isDeep) {
        var Ctor = object2.constructor;
        switch (tag2) {
          case arrayBufferTag2:
            return cloneArrayBuffer2(object2);
          case boolTag2:
          case dateTag2:
            return new Ctor(+object2);
          case dataViewTag2:
            return cloneDataView2(object2, isDeep);
          case float32Tag2:
          case float64Tag2:
          case int8Tag2:
          case int16Tag2:
          case int32Tag2:
          case uint8Tag2:
          case uint8ClampedTag2:
          case uint16Tag2:
          case uint32Tag2:
            return cloneTypedArray2(object2, isDeep);
          case mapTag2:
            return new Ctor();
          case numberTag2:
          case stringTag2:
            return new Ctor(object2);
          case regexpTag2:
            return cloneRegExp2(object2);
          case setTag2:
            return new Ctor();
          case symbolTag2:
            return cloneSymbol2(object2);
        }
      }
      function insertWrapDetails(source, details) {
        var length2 = details.length;
        if (!length2) {
          return source;
        }
        var lastIndex = length2 - 1;
        details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length2 > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray3(value) || isArguments5(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex2(value, length2) {
        var type = typeof value;
        length2 = length2 == null ? MAX_SAFE_INTEGER2 : length2;
        return !!length2 && (type == "number" || type != "symbol" && reIsUint2.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
      }
      function isIterateeCall2(value, index2, object2) {
        if (!isObject2(object2)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike2(object2) && isIndex2(index2, object2.length) : type == "string" && index2 in object2) {
          return eq2(object2[index2], value);
        }
        return false;
      }
      function isKey2(value, object2) {
        if (isArray3(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
          return true;
        }
        return reIsPlainProp2.test(value) || !reIsDeepProp2.test(value) || object2 != null && value in Object2(object2);
      }
      function isKeyable2(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func2) {
        var funcName = getFuncName(func2), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func2 === other) {
          return true;
        }
        var data2 = getData6(other);
        return !!data2 && func2 === data2[0];
      }
      function isMasked2(func2) {
        return !!maskSrcKey2 && maskSrcKey2 in func2;
      }
      var isMaskable = coreJsData2 ? isFunction2 : stubFalse2;
      function isPrototype2(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value === proto;
      }
      function isStrictComparable2(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable2(key, srcValue) {
        return function(object2) {
          if (object2 == null) {
            return false;
          }
          return object2[key] === srcValue && (srcValue !== undefined$12 || key in Object2(object2));
        };
      }
      function memoizeCapped2(func2) {
        var result2 = memoize2(func2, function(key) {
          if (cache2.size === MAX_MEMOIZE_SIZE2) {
            cache2.clear();
          }
          return key;
        });
        var cache2 = result2.cache;
        return result2;
      }
      function mergeData(data2, source) {
        var bitmask = data2[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data2[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data2;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data2[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data2[3];
          data2[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data2[4] = partials ? replaceHolders(data2[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data2[5];
          data2[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data2[6] = partials ? replaceHolders(data2[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data2[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data2[8] = data2[8] == null ? source[8] : nativeMin2(data2[8], source[8]);
        }
        if (data2[9] == null) {
          data2[9] = source[9];
        }
        data2[0] = source[0];
        data2[1] = newBitmask;
        return data2;
      }
      function nativeKeysIn2(object2) {
        var result2 = [];
        if (object2 != null) {
          for (var key in Object2(object2)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString2.call(value);
      }
      function overRest2(func2, start2, transform5) {
        start2 = nativeMax2(start2 === undefined$12 ? func2.length - 1 : start2, 0);
        return function() {
          var args = arguments, index2 = -1, length2 = nativeMax2(args.length - start2, 0), array2 = Array2(length2);
          while (++index2 < length2) {
            array2[index2] = args[start2 + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start2 + 1);
          while (++index2 < start2) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start2] = transform5(array2);
          return apply2(func2, this, otherArgs);
        };
      }
      function parent(object2, path2) {
        return path2.length < 2 ? object2 : baseGet2(object2, baseSlice(path2, 0, -1));
      }
      function reorder2(array2, indexes) {
        var arrLength = array2.length, length2 = nativeMin2(indexes.length, arrLength), oldArray = copyArray2(array2);
        while (length2--) {
          var index2 = indexes[length2];
          array2[length2] = isIndex2(index2, arrLength) ? oldArray[index2] : undefined$12;
        }
        return array2;
      }
      function safeGet2(object2, key) {
        if (key === "constructor" && typeof object2[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object2[key];
      }
      var setData6 = shortOut2(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func2, wait) {
        return root2.setTimeout(func2, wait);
      };
      var setToString2 = shortOut2(baseSetToString2);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString2(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut2(func2) {
        var count3 = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow2(), remaining = HOT_SPAN2 - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count3 >= HOT_COUNT2) {
              return arguments[0];
            }
          } else {
            count3 = 0;
          }
          return func2.apply(undefined$12, arguments);
        };
      }
      function shuffleSelf(array2, size13) {
        var index2 = -1, length2 = array2.length, lastIndex = length2 - 1;
        size13 = size13 === undefined$12 ? length2 : size13;
        while (++index2 < size13) {
          var rand = baseRandom(index2, lastIndex), value = array2[rand];
          array2[rand] = array2[index2];
          array2[index2] = value;
        }
        array2.length = size13;
        return array2;
      }
      var stringToPath3 = memoizeCapped2(function(string3) {
        var result2 = [];
        if (string3.charCodeAt(0) === 46) {
          result2.push("");
        }
        string3.replace(rePropName2, function(match2, number2, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar2, "$1") : number2 || match2);
        });
        return result2;
      });
      function toKey2(value) {
        if (typeof value == "string" || isSymbol2(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY2 ? "-0" : result2;
      }
      function toSource2(func2) {
        if (func2 != null) {
          try {
            return funcToString2.call(func2);
          } catch (e3) {
          }
          try {
            return func2 + "";
          } catch (e3) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach2(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray2(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array2, size13, guard) {
        if (guard ? isIterateeCall2(array2, size13, guard) : size13 === undefined$12) {
          size13 = 1;
        } else {
          size13 = nativeMax2(toInteger(size13), 0);
        }
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2 || size13 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length2 / size13));
        while (index2 < length2) {
          result2[resIndex++] = baseSlice(array2, index2, index2 += size13);
        }
        return result2;
      }
      function compact(array2) {
        var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array2[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat2() {
        var length2 = arguments.length;
        if (!length2) {
          return [];
        }
        var args = Array2(length2 - 1), array2 = arguments[0], index2 = length2;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush2(isArray3(array2) ? copyArray2(array2) : [array2], baseFlatten(args, 1));
      }
      var difference3 = baseRest2(function(array2, values5) {
        return isArrayLikeObject2(array2) ? baseDifference(array2, baseFlatten(values5, 1, isArrayLikeObject2, true)) : [];
      });
      var differenceBy = baseRest2(function(array2, values5) {
        var iteratee2 = last(values5);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$12;
        }
        return isArrayLikeObject2(array2) ? baseDifference(array2, baseFlatten(values5, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest2(function(array2, values5) {
        var comparator2 = last(values5);
        if (isArrayLikeObject2(comparator2)) {
          comparator2 = undefined$12;
        }
        return isArrayLikeObject2(array2) ? baseDifference(array2, baseFlatten(values5, 1, isArrayLikeObject2, true), undefined$12, comparator2) : [];
      });
      function drop(array2, n2, guard) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        return baseSlice(array2, n2 < 0 ? 0 : n2, length2);
      }
      function dropRight(array2, n2, guard) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        n2 = length2 - n2;
        return baseSlice(array2, 0, n2 < 0 ? 0 : n2);
      }
      function dropRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), true) : [];
      }
      function fill(array2, value, start2, end) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        if (start2 && typeof start2 != "number" && isIterateeCall2(array2, value, start2)) {
          start2 = 0;
          end = length2;
        }
        return baseFill(array2, value, start2, end);
      }
      function findIndex3(array2, predicate, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseFindIndex(array2, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array2, predicate, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2 - 1;
        if (fromIndex !== undefined$12) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return baseFindIndex(array2, getIteratee(predicate, 3), index2, true);
      }
      function flatten3(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseFlatten(array2, 1) : [];
      }
      function flattenDeep(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseFlatten(array2, INFINITY2) : [];
      }
      function flattenDepth(array2, depth2) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        depth2 = depth2 === undefined$12 ? 1 : toInteger(depth2);
        return baseFlatten(array2, depth2);
      }
      function fromPairs(pairs2) {
        var index2 = -1, length2 = pairs2 == null ? 0 : pairs2.length, result2 = {};
        while (++index2 < length2) {
          var pair = pairs2[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array2) {
        return array2 && array2.length ? array2[0] : undefined$12;
      }
      function indexOf2(array2, value, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseIndexOf(array2, value, index2);
      }
      function initial(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseSlice(array2, 0, -1) : [];
      }
      var intersection8 = baseRest2(function(arrays) {
        var mapped = arrayMap2(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$12;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest2(function(arrays) {
        var comparator2 = last(arrays), mapped = arrayMap2(arrays, castArrayLikeObject);
        comparator2 = typeof comparator2 == "function" ? comparator2 : undefined$12;
        if (comparator2) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$12, comparator2) : [];
      });
      function join(array2, separator) {
        return array2 == null ? "" : nativeJoin.call(array2, separator);
      }
      function last(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? array2[length2 - 1] : undefined$12;
      }
      function lastIndexOf(array2, value, fromIndex) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2;
        if (fromIndex !== undefined$12) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return value === value ? strictLastIndexOf(array2, value, index2) : baseFindIndex(array2, baseIsNaN, index2, true);
      }
      function nth(array2, n2) {
        return array2 && array2.length ? baseNth(array2, toInteger(n2)) : undefined$12;
      }
      var pull = baseRest2(pullAll);
      function pullAll(array2, values5) {
        return array2 && array2.length && values5 && values5.length ? basePullAll(array2, values5) : array2;
      }
      function pullAllBy(array2, values5, iteratee2) {
        return array2 && array2.length && values5 && values5.length ? basePullAll(array2, values5, getIteratee(iteratee2, 2)) : array2;
      }
      function pullAllWith(array2, values5, comparator2) {
        return array2 && array2.length && values5 && values5.length ? basePullAll(array2, values5, undefined$12, comparator2) : array2;
      }
      var pullAt = flatRest(function(array2, indexes) {
        var length2 = array2 == null ? 0 : array2.length, result2 = baseAt(array2, indexes);
        basePullAt(array2, arrayMap2(indexes, function(index2) {
          return isIndex2(index2, length2) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove6(array2, predicate) {
        var result2 = [];
        if (!(array2 && array2.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length2 = array2.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length2) {
          var value = array2[index2];
          if (predicate(value, index2, array2)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array2, indexes);
        return result2;
      }
      function reverse4(array2) {
        return array2 == null ? array2 : nativeReverse.call(array2);
      }
      function slice2(array2, start2, end) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall2(array2, start2, end)) {
          start2 = 0;
          end = length2;
        } else {
          start2 = start2 == null ? 0 : toInteger(start2);
          end = end === undefined$12 ? length2 : toInteger(end);
        }
        return baseSlice(array2, start2, end);
      }
      function sortedIndex(array2, value) {
        return baseSortedIndex(array2, value);
      }
      function sortedIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array2, value) {
        var length2 = array2 == null ? 0 : array2.length;
        if (length2) {
          var index2 = baseSortedIndex(array2, value);
          if (index2 < length2 && eq2(array2[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array2, value) {
        return baseSortedIndex(array2, value, true);
      }
      function sortedLastIndexBy(array2, value, iteratee2) {
        return baseSortedIndexBy(array2, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array2, value) {
        var length2 = array2 == null ? 0 : array2.length;
        if (length2) {
          var index2 = baseSortedIndex(array2, value, true) - 1;
          if (eq2(array2[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array2) {
        return array2 && array2.length ? baseSortedUniq(array2) : [];
      }
      function sortedUniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseSortedUniq(array2, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array2) {
        var length2 = array2 == null ? 0 : array2.length;
        return length2 ? baseSlice(array2, 1, length2) : [];
      }
      function take(array2, n2, guard) {
        if (!(array2 && array2.length)) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        return baseSlice(array2, 0, n2 < 0 ? 0 : n2);
      }
      function takeRight(array2, n2, guard) {
        var length2 = array2 == null ? 0 : array2.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$12 ? 1 : toInteger(n2);
        n2 = length2 - n2;
        return baseSlice(array2, n2 < 0 ? 0 : n2, length2);
      }
      function takeRightWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array2, predicate) {
        return array2 && array2.length ? baseWhile(array2, getIteratee(predicate, 3)) : [];
      }
      var union6 = baseRest2(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true));
      });
      var unionBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$12;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest2(function(arrays) {
        var comparator2 = last(arrays);
        comparator2 = typeof comparator2 == "function" ? comparator2 : undefined$12;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject2, true), undefined$12, comparator2);
      });
      function uniq(array2) {
        return array2 && array2.length ? baseUniq(array2) : [];
      }
      function uniqBy(array2, iteratee2) {
        return array2 && array2.length ? baseUniq(array2, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array2, comparator2) {
        comparator2 = typeof comparator2 == "function" ? comparator2 : undefined$12;
        return array2 && array2.length ? baseUniq(array2, undefined$12, comparator2) : [];
      }
      function unzip(array2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var length2 = 0;
        array2 = arrayFilter2(array2, function(group) {
          if (isArrayLikeObject2(group)) {
            length2 = nativeMax2(group.length, length2);
            return true;
          }
        });
        return baseTimes2(length2, function(index2) {
          return arrayMap2(array2, baseProperty2(index2));
        });
      }
      function unzipWith(array2, iteratee2) {
        if (!(array2 && array2.length)) {
          return [];
        }
        var result2 = unzip(array2);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap2(result2, function(group) {
          return apply2(iteratee2, undefined$12, group);
        });
      }
      var without = baseRest2(function(array2, values5) {
        return isArrayLikeObject2(array2) ? baseDifference(array2, values5) : [];
      });
      var xor3 = baseRest2(function(arrays) {
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2));
      });
      var xorBy = baseRest2(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject2(iteratee2)) {
          iteratee2 = undefined$12;
        }
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest2(function(arrays) {
        var comparator2 = last(arrays);
        comparator2 = typeof comparator2 == "function" ? comparator2 : undefined$12;
        return baseXor(arrayFilter2(arrays, isArrayLikeObject2), undefined$12, comparator2);
      });
      var zip = baseRest2(unzip);
      function zipObject(props, values5) {
        return baseZipObject(props || [], values5 || [], assignValue2);
      }
      function zipObjectDeep(props, values5) {
        return baseZipObject(props || [], values5 || [], baseSet);
      }
      var zipWith = baseRest2(function(arrays) {
        var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined$12;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$12;
        return unzipWith(arrays, iteratee2);
      });
      function chain2(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length2 = paths.length, start2 = length2 ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object2) {
          return baseAt(object2, paths);
        };
        if (length2 > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex2(start2)) {
          return this.thru(interceptor);
        }
        value = value.slice(start2, +start2 + (length2 ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$12
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array2) {
          if (length2 && !array2.length) {
            array2.push(undefined$12);
          }
          return array2;
        });
      });
      function wrapperChain() {
        return chain2(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$12) {
          this.__values__ = toArray3(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$12 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone9 = wrapperClone(parent2);
          clone9.__index__ = 0;
          clone9.__values__ = undefined$12;
          if (result2) {
            previous.__wrapped__ = clone9;
          } else {
            result2 = clone9;
          }
          var previous = clone9;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse4],
            "thisArg": undefined$12
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse4);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue2(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func2 = isArray3(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$12;
        }
        return func2(collection, getIteratee(predicate, 3));
      }
      function filter17(collection, predicate) {
        var func2 = isArray3(collection) ? arrayFilter2 : baseFilter;
        return func2(collection, getIteratee(predicate, 3));
      }
      var find3 = createFind(findIndex3);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map5(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map5(collection, iteratee2), INFINITY2);
      }
      function flatMapDepth(collection, iteratee2, depth2) {
        depth2 = depth2 === undefined$12 ? 1 : toInteger(depth2);
        return baseFlatten(map5(collection, iteratee2), depth2);
      }
      function forEach2(collection, iteratee2) {
        var func2 = isArray3(collection) ? arrayEach2 : baseEach2;
        return func2(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func2 = isArray3(collection) ? arrayEachRight : baseEachRight;
        return func2(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue2(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike2(collection) ? collection : values4(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length2 = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax2(length2 + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length2 && collection.indexOf(value, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest2(function(collection, path2, args) {
        var index2 = -1, isFunc = typeof path2 == "function", result2 = isArrayLike2(collection) ? Array2(collection.length) : [];
        baseEach2(collection, function(value) {
          result2[++index2] = isFunc ? apply2(path2, value, args) : baseInvoke(value, path2, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue2(result2, key, value);
      });
      function map5(collection, iteratee2) {
        var func2 = isArray3(collection) ? arrayMap2 : baseMap2;
        return func2(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray3(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$12 : orders;
        if (!isArray3(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition2 = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func2 = isArray3(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func2(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach2);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func2 = isArray3(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func2(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func2 = isArray3(collection) ? arrayFilter2 : baseFilter;
        return func2(collection, negate5(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func2 = isArray3(collection) ? arraySample : baseSample;
        return func2(collection);
      }
      function sampleSize(collection, n2, guard) {
        if (guard ? isIterateeCall2(collection, n2, guard) : n2 === undefined$12) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        var func2 = isArray3(collection) ? arraySampleSize : baseSampleSize;
        return func2(collection, n2);
      }
      function shuffle(collection) {
        var func2 = isArray3(collection) ? arrayShuffle : baseShuffle;
        return func2(collection);
      }
      function size12(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike2(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag2 = getTag2(collection);
        if (tag2 == mapTag2 || tag2 == setTag2) {
          return collection.size;
        }
        return baseKeys2(collection).length;
      }
      function some2(collection, predicate, guard) {
        var func2 = isArray3(collection) ? arraySome2 : baseSome;
        if (guard && isIterateeCall2(collection, predicate, guard)) {
          predicate = undefined$12;
        }
        return func2(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest2(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length2 = iteratees.length;
        if (length2 > 1 && isIterateeCall2(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length2 > 2 && isIterateeCall2(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root2.Date.now();
      };
      function after(n2, func2) {
        if (typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 < 1) {
            return func2.apply(this, arguments);
          }
        };
      }
      function ary(func2, n2, guard) {
        n2 = guard ? undefined$12 : n2;
        n2 = func2 && n2 == null ? func2.length : n2;
        return createWrap(func2, WRAP_ARY_FLAG, undefined$12, undefined$12, undefined$12, undefined$12, n2);
      }
      function before(n2, func2) {
        var result2;
        if (typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 > 0) {
            result2 = func2.apply(this, arguments);
          }
          if (n2 <= 1) {
            func2 = undefined$12;
          }
          return result2;
        };
      }
      var bind5 = baseRest2(function(func2, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind5));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func2, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest2(function(object2, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object2, partials, holders);
      });
      function curry(func2, arity, guard) {
        arity = guard ? undefined$12 : arity;
        var result2 = createWrap(func2, WRAP_CURRY_FLAG, undefined$12, undefined$12, undefined$12, undefined$12, undefined$12, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func2, arity, guard) {
        arity = guard ? undefined$12 : arity;
        var result2 = createWrap(func2, WRAP_CURRY_RIGHT_FLAG, undefined$12, undefined$12, undefined$12, undefined$12, undefined$12, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce2(func2, wait, options2) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        wait = toNumber4(wait) || 0;
        if (isObject2(options2)) {
          leading = !!options2.leading;
          maxing = "maxWait" in options2;
          maxWait = maxing ? nativeMax2(toNumber4(options2.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options2 ? !!options2.trailing : trailing;
        }
        function invokeFunc(time2) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$12;
          lastInvokeTime = time2;
          result2 = func2.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time2) {
          lastInvokeTime = time2;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time2) : result2;
        }
        function remainingWait(time2) {
          var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time2) {
          var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
          return lastCallTime === undefined$12 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time2 = now2();
          if (shouldInvoke(time2)) {
            return trailingEdge(time2);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time2));
        }
        function trailingEdge(time2) {
          timerId = undefined$12;
          if (trailing && lastArgs) {
            return invokeFunc(time2);
          }
          lastArgs = lastThis = undefined$12;
          return result2;
        }
        function cancel2() {
          if (timerId !== undefined$12) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$12;
        }
        function flush() {
          return timerId === undefined$12 ? result2 : trailingEdge(now2());
        }
        function debounced() {
          var time2 = now2(), isInvoking = shouldInvoke(time2);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time2;
          if (isInvoking) {
            if (timerId === undefined$12) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$12) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel2;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest2(function(func2, args) {
        return baseDelay(func2, 1, args);
      });
      var delay = baseRest2(function(func2, wait, args) {
        return baseDelay(func2, toNumber4(wait) || 0, args);
      });
      function flip4(func2) {
        return createWrap(func2, WRAP_FLIP_FLAG);
      }
      function memoize2(func2, resolver) {
        if (typeof func2 != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
          if (cache2.has(key)) {
            return cache2.get(key);
          }
          var result2 = func2.apply(this, args);
          memoized.cache = cache2.set(key, result2) || cache2;
          return result2;
        };
        memoized.cache = new (memoize2.Cache || MapCache2)();
        return memoized;
      }
      memoize2.Cache = MapCache2;
      function negate5(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once3(func2) {
        return before(2, func2);
      }
      var overArgs = castRest(function(func2, transforms2) {
        transforms2 = transforms2.length == 1 && isArray3(transforms2[0]) ? arrayMap2(transforms2[0], baseUnary2(getIteratee())) : arrayMap2(baseFlatten(transforms2, 1), baseUnary2(getIteratee()));
        var funcsLength = transforms2.length;
        return baseRest2(function(args) {
          var index2 = -1, length2 = nativeMin2(args.length, funcsLength);
          while (++index2 < length2) {
            args[index2] = transforms2[index2].call(this, args[index2]);
          }
          return apply2(func2, this, args);
        });
      });
      var partial = baseRest2(function(func2, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func2, WRAP_PARTIAL_FLAG, undefined$12, partials, holders);
      });
      var partialRight = baseRest2(function(func2, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func2, WRAP_PARTIAL_RIGHT_FLAG, undefined$12, partials, holders);
      });
      var rearg = flatRest(function(func2, indexes) {
        return createWrap(func2, WRAP_REARG_FLAG, undefined$12, undefined$12, undefined$12, indexes);
      });
      function rest(func2, start2) {
        if (typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start2 = start2 === undefined$12 ? start2 : toInteger(start2);
        return baseRest2(func2, start2);
      }
      function spread(func2, start2) {
        if (typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start2 = start2 == null ? 0 : nativeMax2(toInteger(start2), 0);
        return baseRest2(function(args) {
          var array2 = args[start2], otherArgs = castSlice(args, 0, start2);
          if (array2) {
            arrayPush2(otherArgs, array2);
          }
          return apply2(func2, this, otherArgs);
        });
      }
      function throttle2(func2, wait, options2) {
        var leading = true, trailing = true;
        if (typeof func2 != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        if (isObject2(options2)) {
          leading = "leading" in options2 ? !!options2.leading : leading;
          trailing = "trailing" in options2 ? !!options2.trailing : trailing;
        }
        return debounce2(func2, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func2) {
        return ary(func2, 1);
      }
      function wrap2(value, wrapper) {
        return partial(castFunction2(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray3(value) ? value : [value];
      }
      function clone8(value) {
        return baseClone2(value, CLONE_SYMBOLS_FLAG2);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return baseClone2(value, CLONE_SYMBOLS_FLAG2, customizer);
      }
      function cloneDeep2(value) {
        return baseClone2(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return baseClone2(value, CLONE_DEEP_FLAG2 | CLONE_SYMBOLS_FLAG2, customizer);
      }
      function conformsTo(object2, source) {
        return source == null || baseConformsTo(object2, source, keys4(source));
      }
      function eq2(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt2 = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments5 = baseIsArguments2(function() {
        return arguments;
      }()) ? baseIsArguments2 : function(value) {
        return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable2.call(value, "callee");
      };
      var isArray3 = Array2.isArray;
      var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary2(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike2(value) {
        return value != null && isLength2(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject2(value) {
        return isObjectLike2(value) && isArrayLike2(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike2(value) && baseGetTag2(value) == boolTag2;
      }
      var isBuffer2 = nativeIsBuffer2 || stubFalse2;
      var isDate2 = nodeIsDate ? baseUnary2(nodeIsDate) : baseIsDate;
      function isElement2(value) {
        return isObjectLike2(value) && value.nodeType === 1 && !isPlainObject2(value);
      }
      function isEmpty6(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike2(value) && (isArray3(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray2(value) || isArguments5(value))) {
          return !value.length;
        }
        var tag2 = getTag2(value);
        if (tag2 == mapTag2 || tag2 == setTag2) {
          return !value.size;
        }
        if (isPrototype2(value)) {
          return !baseKeys2(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual3(value, other) {
        return baseIsEqual2(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        var result2 = customizer ? customizer(value, other) : undefined$12;
        return result2 === undefined$12 ? baseIsEqual2(value, other, undefined$12, customizer) : !!result2;
      }
      function isError2(value) {
        if (!isObjectLike2(value)) {
          return false;
        }
        var tag2 = baseGetTag2(value);
        return tag2 == errorTag2 || tag2 == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag2 = baseGetTag2(value);
        return tag2 == funcTag2 || tag2 == genTag2 || tag2 == asyncTag2 || tag2 == proxyTag2;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength2(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER2;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike2(value) {
        return value != null && typeof value == "object";
      }
      var isMap2 = nodeIsMap2 ? baseUnary2(nodeIsMap2) : baseIsMap2;
      function isMatch(object2, source) {
        return object2 === source || baseIsMatch2(object2, source, getMatchData2(source));
      }
      function isMatchWith(object2, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return baseIsMatch2(object2, source, getMatchData2(source), customizer);
      }
      function isNaN5(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative2(value);
      }
      function isNull5(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike2(value) && baseGetTag2(value) == numberTag2;
      }
      function isPlainObject2(value) {
        if (!isObjectLike2(value) || baseGetTag2(value) != objectTag2) {
          return false;
        }
        var proto = getPrototype2(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString2.call(Ctor) == objectCtorString2;
      }
      var isRegExp2 = nodeIsRegExp ? baseUnary2(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER2 && value <= MAX_SAFE_INTEGER2;
      }
      var isSet2 = nodeIsSet2 ? baseUnary2(nodeIsSet2) : baseIsSet2;
      function isString2(value) {
        return typeof value == "string" || !isArray3(value) && isObjectLike2(value) && baseGetTag2(value) == stringTag2;
      }
      function isSymbol2(value) {
        return typeof value == "symbol" || isObjectLike2(value) && baseGetTag2(value) == symbolTag2;
      }
      var isTypedArray2 = nodeIsTypedArray2 ? baseUnary2(nodeIsTypedArray2) : baseIsTypedArray2;
      function isUndefined2(value) {
        return value === undefined$12;
      }
      function isWeakMap(value) {
        return isObjectLike2(value) && getTag2(value) == weakMapTag2;
      }
      function isWeakSet(value) {
        return isObjectLike2(value) && baseGetTag2(value) == weakSetTag;
      }
      var lt2 = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray3(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike2(value)) {
          return isString2(value) ? stringToArray(value) : copyArray2(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag2 = getTag2(value), func2 = tag2 == mapTag2 ? mapToArray2 : tag2 == setTag2 ? setToArray2 : values4;
        return func2(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber4(value);
        if (value === INFINITY2 || value === -INFINITY2) {
          var sign2 = value < 0 ? -1 : 1;
          return sign2 * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber4(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim2(value);
        var isBinary = reIsBinary2.test(value);
        return isBinary || reIsOctal2.test(value) ? freeParseInt2(value.slice(2), isBinary ? 2 : 8) : reIsBadHex2.test(value) ? NAN2 : +value;
      }
      function toPlainObject2(value) {
        return copyObject2(value, keysIn2(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER2, MAX_SAFE_INTEGER2) : value === 0 ? value : 0;
      }
      function toString29(value) {
        return value == null ? "" : baseToString2(value);
      }
      var assign3 = createAssigner2(function(object2, source) {
        if (isPrototype2(source) || isArrayLike2(source)) {
          copyObject2(source, keys4(source), object2);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue2(object2, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner2(function(object2, source) {
        copyObject2(source, keysIn2(source), object2);
      });
      var assignInWith = createAssigner2(function(object2, source, srcIndex, customizer) {
        copyObject2(source, keysIn2(source), object2, customizer);
      });
      var assignWith = createAssigner2(function(object2, source, srcIndex, customizer) {
        copyObject2(source, keys4(source), object2, customizer);
      });
      var at2 = flatRest(baseAt);
      function create5(prototype2, properties) {
        var result2 = baseCreate2(prototype2);
        return properties == null ? result2 : baseAssign2(result2, properties);
      }
      var defaults = baseRest2(function(object2, sources2) {
        object2 = Object2(object2);
        var index2 = -1;
        var length2 = sources2.length;
        var guard = length2 > 2 ? sources2[2] : undefined$12;
        if (guard && isIterateeCall2(sources2[0], sources2[1], guard)) {
          length2 = 1;
        }
        while (++index2 < length2) {
          var source = sources2[index2];
          var props = keysIn2(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object2[key];
            if (value === undefined$12 || eq2(value, objectProto2[key]) && !hasOwnProperty2.call(object2, key)) {
              object2[key] = source[key];
            }
          }
        }
        return object2;
      });
      var defaultsDeep = baseRest2(function(args) {
        args.push(undefined$12, customDefaultsMerge);
        return apply2(mergeWith, undefined$12, args);
      });
      function findKey(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwn2);
      }
      function findLastKey(object2, predicate) {
        return baseFindKey(object2, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object2, iteratee2) {
        return object2 == null ? object2 : baseFor2(object2, getIteratee(iteratee2, 3), keysIn2);
      }
      function forInRight(object2, iteratee2) {
        return object2 == null ? object2 : baseForRight(object2, getIteratee(iteratee2, 3), keysIn2);
      }
      function forOwn2(object2, iteratee2) {
        return object2 && baseForOwn2(object2, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object2, iteratee2) {
        return object2 && baseForOwnRight(object2, getIteratee(iteratee2, 3));
      }
      function functions(object2) {
        return object2 == null ? [] : baseFunctions(object2, keys4(object2));
      }
      function functionsIn(object2) {
        return object2 == null ? [] : baseFunctions(object2, keysIn2(object2));
      }
      function get6(object2, path2, defaultValue2) {
        var result2 = object2 == null ? undefined$12 : baseGet2(object2, path2);
        return result2 === undefined$12 ? defaultValue2 : result2;
      }
      function has2(object2, path2) {
        return object2 != null && hasPath2(object2, path2, baseHas);
      }
      function hasIn2(object2, path2) {
        return object2 != null && hasPath2(object2, path2, baseHasIn2);
      }
      var invert2 = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        result2[value] = key;
      }, constant2(identity2));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString2.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest2(baseInvoke);
      function keys4(object2) {
        return isArrayLike2(object2) ? arrayLikeKeys2(object2) : baseKeys2(object2);
      }
      function keysIn2(object2) {
        return isArrayLike2(object2) ? arrayLikeKeys2(object2, true) : baseKeysIn2(object2);
      }
      function mapKeys(object2, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object2, function(value, key, object3) {
          baseAssignValue2(result2, iteratee2(value, key, object3), value);
        });
        return result2;
      }
      function mapValues(object2, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn2(object2, function(value, key, object3) {
          baseAssignValue2(result2, key, iteratee2(value, key, object3));
        });
        return result2;
      }
      var merge4 = createAssigner2(function(object2, source, srcIndex) {
        baseMerge2(object2, source, srcIndex);
      });
      var mergeWith = createAssigner2(function(object2, source, srcIndex, customizer) {
        baseMerge2(object2, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object2, paths) {
        var result2 = {};
        if (object2 == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap2(paths, function(path2) {
          path2 = castPath2(path2, object2);
          isDeep || (isDeep = path2.length > 1);
          return path2;
        });
        copyObject2(object2, getAllKeysIn2(object2), result2);
        if (isDeep) {
          result2 = baseClone2(result2, CLONE_DEEP_FLAG2 | CLONE_FLAT_FLAG2 | CLONE_SYMBOLS_FLAG2, customOmitClone);
        }
        var length2 = paths.length;
        while (length2--) {
          baseUnset(result2, paths[length2]);
        }
        return result2;
      });
      function omitBy(object2, predicate) {
        return pickBy(object2, negate5(getIteratee(predicate)));
      }
      var pick2 = flatRest(function(object2, paths) {
        return object2 == null ? {} : basePick(object2, paths);
      });
      function pickBy(object2, predicate) {
        if (object2 == null) {
          return {};
        }
        var props = arrayMap2(getAllKeysIn2(object2), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object2, props, function(value, path2) {
          return predicate(value, path2[0]);
        });
      }
      function result(object2, path2, defaultValue2) {
        path2 = castPath2(path2, object2);
        var index2 = -1, length2 = path2.length;
        if (!length2) {
          length2 = 1;
          object2 = undefined$12;
        }
        while (++index2 < length2) {
          var value = object2 == null ? undefined$12 : object2[toKey2(path2[index2])];
          if (value === undefined$12) {
            index2 = length2;
            value = defaultValue2;
          }
          object2 = isFunction2(value) ? value.call(object2) : value;
        }
        return object2;
      }
      function set(object2, path2, value) {
        return object2 == null ? object2 : baseSet(object2, path2, value);
      }
      function setWith(object2, path2, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return object2 == null ? object2 : baseSet(object2, path2, value, customizer);
      }
      var toPairs = createToPairs(keys4);
      var toPairsIn = createToPairs(keysIn2);
      function transform4(object2, iteratee2, accumulator) {
        var isArr = isArray3(object2), isArrLike = isArr || isBuffer2(object2) || isTypedArray2(object2);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object2 && object2.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object2)) {
            accumulator = isFunction2(Ctor) ? baseCreate2(getPrototype2(object2)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach2 : baseForOwn2)(object2, function(value, index2, object3) {
          return iteratee2(accumulator, value, index2, object3);
        });
        return accumulator;
      }
      function unset(object2, path2) {
        return object2 == null ? true : baseUnset(object2, path2);
      }
      function update(object2, path2, updater) {
        return object2 == null ? object2 : baseUpdate(object2, path2, castFunction2(updater));
      }
      function updateWith(object2, path2, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$12;
        return object2 == null ? object2 : baseUpdate(object2, path2, castFunction2(updater), customizer);
      }
      function values4(object2) {
        return object2 == null ? [] : baseValues(object2, keys4(object2));
      }
      function valuesIn(object2) {
        return object2 == null ? [] : baseValues(object2, keysIn2(object2));
      }
      function clamp4(number2, lower, upper) {
        if (upper === undefined$12) {
          upper = lower;
          lower = undefined$12;
        }
        if (upper !== undefined$12) {
          upper = toNumber4(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$12) {
          lower = toNumber4(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber4(number2), lower, upper);
      }
      function inRange(number2, start2, end) {
        start2 = toFinite(start2);
        if (end === undefined$12) {
          end = start2;
          start2 = 0;
        } else {
          end = toFinite(end);
        }
        number2 = toNumber4(number2);
        return baseInRange(number2, start2, end);
      }
      function random2(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall2(lower, upper, floating)) {
          upper = floating = undefined$12;
        }
        if (floating === undefined$12) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$12;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$12;
          }
        }
        if (lower === undefined$12 && upper === undefined$12) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$12) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp2 = lower;
          lower = upper;
          upper = temp2;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin2(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize2(word) : word);
      });
      function capitalize2(string3) {
        return upperFirst(toString29(string3).toLowerCase());
      }
      function deburr(string3) {
        string3 = toString29(string3);
        return string3 && string3.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string3, target, position) {
        string3 = toString29(string3);
        target = baseToString2(target);
        var length2 = string3.length;
        position = position === undefined$12 ? length2 : baseClamp(toInteger(position), 0, length2);
        var end = position;
        position -= target.length;
        return position >= 0 && string3.slice(position, end) == target;
      }
      function escape2(string3) {
        string3 = toString29(string3);
        return string3 && reHasUnescapedHtml.test(string3) ? string3.replace(reUnescapedHtml, escapeHtmlChar) : string3;
      }
      function escapeRegExp(string3) {
        string3 = toString29(string3);
        return string3 && reHasRegExpChar.test(string3) ? string3.replace(reRegExpChar2, "\\$&") : string3;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string3, length2, chars2) {
        string3 = toString29(string3);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string3) : 0;
        if (!length2 || strLength >= length2) {
          return string3;
        }
        var mid = (length2 - strLength) / 2;
        return createPadding(nativeFloor(mid), chars2) + string3 + createPadding(nativeCeil(mid), chars2);
      }
      function padEnd(string3, length2, chars2) {
        string3 = toString29(string3);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string3) : 0;
        return length2 && strLength < length2 ? string3 + createPadding(length2 - strLength, chars2) : string3;
      }
      function padStart(string3, length2, chars2) {
        string3 = toString29(string3);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string3) : 0;
        return length2 && strLength < length2 ? createPadding(length2 - strLength, chars2) + string3 : string3;
      }
      function parseInt2(string3, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString29(string3).replace(reTrimStart2, ""), radix || 0);
      }
      function repeat(string3, n2, guard) {
        if (guard ? isIterateeCall2(string3, n2, guard) : n2 === undefined$12) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        return baseRepeat(toString29(string3), n2);
      }
      function replace2() {
        var args = arguments, string3 = toString29(args[0]);
        return args.length < 3 ? string3 : string3.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split2(string3, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall2(string3, separator, limit)) {
          separator = limit = undefined$12;
        }
        limit = limit === undefined$12 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string3 = toString29(string3);
        if (string3 && (typeof separator == "string" || separator != null && !isRegExp2(separator))) {
          separator = baseToString2(separator);
          if (!separator && hasUnicode(string3)) {
            return castSlice(stringToArray(string3), 0, limit);
          }
        }
        return string3.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string3, target, position) {
        string3 = toString29(string3);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string3.length);
        target = baseToString2(target);
        return string3.slice(position, position + target.length) == target;
      }
      function template(string3, options2, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall2(string3, options2, guard)) {
          options2 = undefined$12;
        }
        string3 = toString29(string3);
        options2 = assignInWith({}, options2, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options2.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys4(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate2 = options2.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2(
          (options2.escape || reNoMatch).source + "|" + interpolate2.source + "|" + (interpolate2 === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options2.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options2, "sourceURL") ? (options2.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string3.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string3.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset + match2.length;
          return match2;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options2, "variable") && options2.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function3(importsKeys, sourceURL + "return " + source).apply(undefined$12, importsValues);
        });
        result2.source = source;
        if (isError2(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString29(value).toLowerCase();
      }
      function toUpper(value) {
        return toString29(value).toUpperCase();
      }
      function trim(string3, chars2, guard) {
        string3 = toString29(string3);
        if (string3 && (guard || chars2 === undefined$12)) {
          return baseTrim2(string3);
        }
        if (!string3 || !(chars2 = baseToString2(chars2))) {
          return string3;
        }
        var strSymbols = stringToArray(string3), chrSymbols = stringToArray(chars2), start2 = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start2, end).join("");
      }
      function trimEnd(string3, chars2, guard) {
        string3 = toString29(string3);
        if (string3 && (guard || chars2 === undefined$12)) {
          return string3.slice(0, trimmedEndIndex2(string3) + 1);
        }
        if (!string3 || !(chars2 = baseToString2(chars2))) {
          return string3;
        }
        var strSymbols = stringToArray(string3), end = charsEndIndex(strSymbols, stringToArray(chars2)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string3, chars2, guard) {
        string3 = toString29(string3);
        if (string3 && (guard || chars2 === undefined$12)) {
          return string3.replace(reTrimStart2, "");
        }
        if (!string3 || !(chars2 = baseToString2(chars2))) {
          return string3;
        }
        var strSymbols = stringToArray(string3), start2 = charsStartIndex(strSymbols, stringToArray(chars2));
        return castSlice(strSymbols, start2).join("");
      }
      function truncate(string3, options2) {
        var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options2)) {
          var separator = "separator" in options2 ? options2.separator : separator;
          length2 = "length" in options2 ? toInteger(options2.length) : length2;
          omission = "omission" in options2 ? baseToString2(options2.omission) : omission;
        }
        string3 = toString29(string3);
        var strLength = string3.length;
        if (hasUnicode(string3)) {
          var strSymbols = stringToArray(string3);
          strLength = strSymbols.length;
        }
        if (length2 >= strLength) {
          return string3;
        }
        var end = length2 - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string3.slice(0, end);
        if (separator === undefined$12) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp2(separator)) {
          if (string3.slice(end).search(separator)) {
            var match2, substring2 = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString29(reFlags2.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match2 = separator.exec(substring2)) {
              var newEnd = match2.index;
            }
            result2 = result2.slice(0, newEnd === undefined$12 ? end : newEnd);
          }
        } else if (string3.indexOf(baseToString2(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape2(string3) {
        string3 = toString29(string3);
        return string3 && reHasEscapedHtml.test(string3) ? string3.replace(reEscapedHtml, unescapeHtmlChar) : string3;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string3, pattern, guard) {
        string3 = toString29(string3);
        pattern = guard ? undefined$12 : pattern;
        if (pattern === undefined$12) {
          return hasUnicodeWord(string3) ? unicodeWords(string3) : asciiWords(string3);
        }
        return string3.match(pattern) || [];
      }
      var attempt = baseRest2(function(func2, args) {
        try {
          return apply2(func2, undefined$12, args);
        } catch (e3) {
          return isError2(e3) ? e3 : new Error2(e3);
        }
      });
      var bindAll = flatRest(function(object2, methodNames) {
        arrayEach2(methodNames, function(key) {
          key = toKey2(key);
          baseAssignValue2(object2, key, bind5(object2[key], object2));
        });
        return object2;
      });
      function cond(pairs2) {
        var length2 = pairs2 == null ? 0 : pairs2.length, toIteratee = getIteratee();
        pairs2 = !length2 ? [] : arrayMap2(pairs2, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest2(function(args) {
          var index2 = -1;
          while (++index2 < length2) {
            var pair = pairs2[index2];
            if (apply2(pair[0], this, args)) {
              return apply2(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone2(source, CLONE_DEEP_FLAG2));
      }
      function constant2(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue2) {
        return value == null || value !== value ? defaultValue2 : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity2(value) {
        return value;
      }
      function iteratee(func2) {
        return baseIteratee2(typeof func2 == "function" ? func2 : baseClone2(func2, CLONE_DEEP_FLAG2));
      }
      function matches2(source) {
        return baseMatches2(baseClone2(source, CLONE_DEEP_FLAG2));
      }
      function matchesProperty(path2, srcValue) {
        return baseMatchesProperty2(path2, baseClone2(srcValue, CLONE_DEEP_FLAG2));
      }
      var method = baseRest2(function(path2, args) {
        return function(object2) {
          return baseInvoke(object2, path2, args);
        };
      });
      var methodOf = baseRest2(function(object2, args) {
        return function(path2) {
          return baseInvoke(object2, path2, args);
        };
      });
      function mixin(object2, source, options2) {
        var props = keys4(source), methodNames = baseFunctions(source, props);
        if (options2 == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options2 = source;
          source = object2;
          object2 = this;
          methodNames = baseFunctions(source, keys4(source));
        }
        var chain3 = !(isObject2(options2) && "chain" in options2) || !!options2.chain, isFunc = isFunction2(object2);
        arrayEach2(methodNames, function(methodName) {
          var func2 = source[methodName];
          object2[methodName] = func2;
          if (isFunc) {
            object2.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain3 || chainAll) {
                var result2 = object2(this.__wrapped__), actions = result2.__actions__ = copyArray2(this.__actions__);
                actions.push({ "func": func2, "args": arguments, "thisArg": object2 });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func2.apply(object2, arrayPush2([this.value()], arguments));
            };
          }
        });
        return object2;
      }
      function noConflict() {
        if (root2._ === this) {
          root2._ = oldDash;
        }
        return this;
      }
      function noop2() {
      }
      function nthArg(n2) {
        n2 = toInteger(n2);
        return baseRest2(function(args) {
          return baseNth(args, n2);
        });
      }
      var over = createOver(arrayMap2);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome2);
      function property2(path2) {
        return isKey2(path2) ? baseProperty2(toKey2(path2)) : basePropertyDeep2(path2);
      }
      function propertyOf(object2) {
        return function(path2) {
          return object2 == null ? undefined$12 : baseGet2(object2, path2);
        };
      }
      var range2 = createRange();
      var rangeRight = createRange(true);
      function stubArray2() {
        return [];
      }
      function stubFalse2() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n2, iteratee2) {
        n2 = toInteger(n2);
        if (n2 < 1 || n2 > MAX_SAFE_INTEGER2) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin2(n2, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n2 -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes2(length2, iteratee2);
        while (++index2 < n2) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray3(value)) {
          return arrayMap2(value, toKey2);
        }
        return isSymbol2(value) ? [value] : copyArray2(stringToPath3(toString29(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter2;
        return toString29(prefix) + id;
      }
      var add18 = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil2 = createRound("ceil");
      var divide4 = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor3 = createRound("floor");
      function max3(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity2, baseGt) : undefined$12;
      }
      function maxBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseGt) : undefined$12;
      }
      function mean(array2) {
        return baseMean(array2, identity2);
      }
      function meanBy(array2, iteratee2) {
        return baseMean(array2, getIteratee(iteratee2, 2));
      }
      function min4(array2) {
        return array2 && array2.length ? baseExtremum(array2, identity2, baseLt) : undefined$12;
      }
      function minBy(array2, iteratee2) {
        return array2 && array2.length ? baseExtremum(array2, getIteratee(iteratee2, 2), baseLt) : undefined$12;
      }
      var multiply5 = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract5 = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum2(array2) {
        return array2 && array2.length ? baseSum(array2, identity2) : 0;
      }
      function sumBy(array2, iteratee2) {
        return array2 && array2.length ? baseSum(array2, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign3;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at2;
      lodash2.before = before;
      lodash2.bind = bind5;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain2;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat2;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant2;
      lodash2.countBy = countBy;
      lodash2.create = create5;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce2;
      lodash2.defaults = defaults;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference3;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter17;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten3;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip4;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection8;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert2;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys4;
      lodash2.keysIn = keysIn2;
      lodash2.map = map5;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches2;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize2;
      lodash2.merge = merge4;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate5;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once3;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition2;
      lodash2.pick = pick2;
      lodash2.pickBy = pickBy;
      lodash2.property = property2;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range2;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove6;
      lodash2.rest = rest;
      lodash2.reverse = reverse4;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice2;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split2;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle2;
      lodash2.thru = thru;
      lodash2.toArray = toArray3;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject2;
      lodash2.transform = transform4;
      lodash2.unary = unary;
      lodash2.union = union6;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values4;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap2;
      lodash2.xor = xor3;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add18;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize2;
      lodash2.ceil = ceil2;
      lodash2.clamp = clamp4;
      lodash2.clone = clone8;
      lodash2.cloneDeep = cloneDeep2;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide4;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq2;
      lodash2.escape = escape2;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find3;
      lodash2.findIndex = findIndex3;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor3;
      lodash2.forEach = forEach2;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn2;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get6;
      lodash2.gt = gt2;
      lodash2.gte = gte;
      lodash2.has = has2;
      lodash2.hasIn = hasIn2;
      lodash2.head = head;
      lodash2.identity = identity2;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf2;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments5;
      lodash2.isArray = isArray3;
      lodash2.isArrayBuffer = isArrayBuffer2;
      lodash2.isArrayLike = isArrayLike2;
      lodash2.isArrayLikeObject = isArrayLikeObject2;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement2;
      lodash2.isEmpty = isEmpty6;
      lodash2.isEqual = isEqual3;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError2;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength2;
      lodash2.isMap = isMap2;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN5;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull5;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike2;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp2;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet2;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray2;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt2;
      lodash2.lte = lte;
      lodash2.max = max3;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min4;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray2;
      lodash2.stubFalse = stubFalse2;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply5;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop2;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random2;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace2;
      lodash2.result = result;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size12;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some2;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract5;
      lodash2.sum = sum2;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber4;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString29;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach2;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn2(lodash2, function(func2, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func2;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION2;
      arrayEach2(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach2(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n2) {
          n2 = n2 === undefined$12 ? 1 : nativeMax2(toInteger(n2), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin2(n2, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin2(n2, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n2) {
          return this.reverse()[methodName](n2).reverse();
        };
      });
      arrayEach2(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach2(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach2(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity2);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest2(function(path2, args) {
        if (typeof path2 == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path2, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate5(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start2, end) {
        start2 = toInteger(start2);
        var result2 = this;
        if (result2.__filtered__ && (start2 > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start2 < 0) {
          result2 = result2.takeRight(-start2);
        } else if (start2) {
          result2 = result2.drop(start2);
        }
        if (end !== undefined$12) {
          end = toInteger(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start2);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn2(LazyWrapper.prototype, function(func2, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray3(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush2([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func2.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$12 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func2.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach2(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func2 = arrayProto2[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func2.apply(isArray3(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func2.apply(isArray3(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn2(LazyWrapper.prototype, function(func2, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$12, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$12
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule2) {
      (freeModule2.exports = _2)._ = _2;
      freeExports2._ = _2;
    } else {
      root2._ = _2;
    }
  }).call(commonjsGlobal$1);
})(lodash, lodashExports);
var js = {};
var __importDefault = commonjsGlobal$1 && commonjsGlobal$1.__importDefault || function(mod2) {
  return mod2 && mod2.__esModule ? mod2 : { "default": mod2 };
};
Object.defineProperty(js, "__esModule", { value: true });
var distance_1 = __importDefault(require$$0$1);
var meta_1 = require$$1$3;
function length(geojson, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return meta_1.segmentReduce(geojson, function(previousValue, segment) {
    var coords = segment.geometry.coordinates;
    return previousValue + distance_1.default(coords[0], coords[1], options2);
  }, 0);
}
js.default = length;
const MapboxDraw = mapboxGlDrawExports;
const numeral = numeralExports;
const _ = lodashExports;
const lineDistance = js.default;
const RadiusCircleMode$1 = _.extend({}, MapboxDraw.modes.draw_line_string);
function createVertex(parentId, coordinates2, path2, selected) {
  return {
    type: "Feature",
    properties: {
      meta: "vertex",
      parent: parentId,
      coord_path: path2,
      active: selected ? "true" : "false"
    },
    geometry: {
      type: "Point",
      coordinates: coordinates2
    }
  };
}
function createGeoJSONCircle(center2, radiusInKm, parentId, points2 = 64) {
  const coords = {
    latitude: center2[1],
    longitude: center2[0]
  };
  const km = radiusInKm;
  const ret = [];
  const distanceX = km / (111.32 * Math.cos(coords.latitude * Math.PI / 180));
  const distanceY = km / 110.574;
  let theta;
  let x2;
  let y2;
  for (let i2 = 0; i2 < points2; i2 += 1) {
    theta = i2 / points2 * (2 * Math.PI);
    x2 = distanceX * Math.cos(theta);
    y2 = distanceY * Math.sin(theta);
    ret.push([coords.longitude + x2, coords.latitude + y2]);
  }
  ret.push(ret[0]);
  return {
    type: "Feature",
    geometry: {
      type: "Polygon",
      coordinates: [ret]
    },
    properties: {
      parent: parentId
    }
  };
}
function getDisplayMeasurements(feature2) {
  const drawnLength = lineDistance(feature2) * 1e3;
  let metricUnits = "m";
  let metricFormat = "0,0";
  let metricMeasurement;
  let standardUnits = "feet";
  let standardFormat = "0,0";
  let standardMeasurement;
  metricMeasurement = drawnLength;
  if (drawnLength >= 1e3) {
    metricMeasurement = drawnLength / 1e3;
    metricUnits = "km";
    metricFormat = "0.00";
  }
  standardMeasurement = drawnLength * 3.28084;
  if (standardMeasurement >= 5280) {
    standardMeasurement /= 5280;
    standardUnits = "mi";
    standardFormat = "0.00";
  }
  const displayMeasurements = {
    metric: `${numeral(metricMeasurement).format(metricFormat)} ${metricUnits}`,
    standard: `${numeral(standardMeasurement).format(
      standardFormat
    )} ${standardUnits}`
  };
  return displayMeasurements;
}
const doubleClickZoom$1 = {
  enable: (ctx2) => {
    setTimeout(() => {
      if (!ctx2.map || !ctx2.map.doubleClickZoom || !ctx2._ctx || !ctx2._ctx.store || !ctx2._ctx.store.getInitialConfigValue)
        return;
      if (!ctx2._ctx.store.getInitialConfigValue("doubleClickZoom"))
        return;
      ctx2.map.doubleClickZoom.enable();
    }, 0);
  }
};
RadiusCircleMode$1.onSetup = function(opts) {
  const props = MapboxDraw.modes.draw_line_string.onSetup.call(this, opts);
  const circle2 = this.newFeature({
    type: "Feature",
    properties: {
      meta: "radius"
    },
    geometry: {
      type: "Polygon",
      coordinates: [[]]
    }
  });
  this.addFeature(circle2);
  return {
    ...props,
    circle: circle2
  };
};
RadiusCircleMode$1.clickAnywhere = function(state, e3) {
  if (state.currentVertexPosition === 1) {
    state.line.addCoordinate(0, e3.lngLat.lng, e3.lngLat.lat);
    return this.changeMode("simple_select", { featureIds: [state.line.id] });
  }
  this.updateUIClasses({ mouse: "add" });
  state.line.updateCoordinate(
    state.currentVertexPosition,
    e3.lngLat.lng,
    e3.lngLat.lat
  );
  if (state.direction === "forward") {
    state.currentVertexPosition += 1;
    state.line.updateCoordinate(
      state.currentVertexPosition,
      e3.lngLat.lng,
      e3.lngLat.lat
    );
  } else {
    state.line.addCoordinate(0, e3.lngLat.lng, e3.lngLat.lat);
  }
  return null;
};
RadiusCircleMode$1.onMouseMove = function(state, e3) {
  MapboxDraw.modes.draw_line_string.onMouseMove.call(this, state, e3);
  const geojson = state.line.toGeoJSON();
  const center2 = geojson.geometry.coordinates[0];
  const radiusInKm = lineDistance(geojson, "kilometers");
  const circleFeature = createGeoJSONCircle(center2, radiusInKm, state.line.id);
  circleFeature.properties.meta = "radius";
  state.circle.setCoordinates(circleFeature.geometry.coordinates);
};
RadiusCircleMode$1.onStop = function(state) {
  doubleClickZoom$1.enable(this);
  this.activateUIButton();
  if (this.getFeature(state.line.id) === void 0)
    return;
  state.line.removeCoordinate("0");
  if (state.line.isValid()) {
    state.line.toGeoJSON();
    this.deleteFeature([state.line.id], { silent: true });
    this.map.fire("draw.create", {
      features: [state.circle.toGeoJSON()]
    });
  } else {
    this.deleteFeature([state.line.id], { silent: true });
    this.changeMode("simple_select", {}, { silent: true });
  }
};
RadiusCircleMode$1.toDisplayFeatures = function(state, geojson, display) {
  const isActiveLine = geojson.properties.id === state.line.id;
  geojson.properties.active = isActiveLine ? "true" : "false";
  if (!isActiveLine)
    return display(geojson);
  if (geojson.geometry.coordinates.length < 2)
    return null;
  geojson.properties.meta = "feature";
  display(
    createVertex(
      state.line.id,
      geojson.geometry.coordinates[state.direction === "forward" ? geojson.geometry.coordinates.length - 2 : 1],
      `${state.direction === "forward" ? geojson.geometry.coordinates.length - 2 : 1}`,
      false
    )
  );
  display(geojson);
  const displayMeasurements = getDisplayMeasurements(geojson);
  const currentVertex = {
    type: "Feature",
    properties: {
      meta: "currentPosition",
      radiusMetric: displayMeasurements.metric,
      radiusStandard: displayMeasurements.standard,
      parent: state.line.id
    },
    geometry: {
      type: "Point",
      coordinates: geojson.geometry.coordinates[1]
    }
  };
  display(currentVertex);
  return null;
};
var RadiusCircleMode_1 = RadiusCircleMode$1;
const CircleMode = CircleMode_1;
const DragCircleMode = DragCircleMode_1;
const DirectMode = DirectModeOverride_1;
const SimpleSelectMode = SimpleSelectModeOverride_1;
const RadiusCircleMode = RadiusCircleMode_1;
var mapboxGlDrawCircleModes = { CircleMode, DragCircleMode, DirectMode, SimpleSelectMode, RadiusCircleMode };
var dist = {};
Object.defineProperty(dist, "__esModule", {
  value: true
});
var doubleClickZoom = {
  enable: function enable2(ctx2) {
    setTimeout(function() {
      if (!ctx2.map || !ctx2.map.doubleClickZoom || !ctx2._ctx || !ctx2._ctx.store || !ctx2._ctx.store.getInitialConfigValue)
        return;
      if (!ctx2._ctx.store.getInitialConfigValue("doubleClickZoom"))
        return;
      ctx2.map.doubleClickZoom.enable();
    }, 0);
  },
  disable: function disable(ctx2) {
    setTimeout(function() {
      if (!ctx2.map || !ctx2.map.doubleClickZoom)
        return;
      ctx2.map.doubleClickZoom.disable();
    }, 0);
  }
};
var DrawRectangle = {
  // When the mode starts this function will be called.
  onSetup: function onSetup(opts) {
    var rectangle = this.newFeature({
      type: "Feature",
      properties: {},
      geometry: {
        type: "Polygon",
        coordinates: [[]]
      }
    });
    this.addFeature(rectangle);
    this.clearSelectedFeatures();
    doubleClickZoom.disable(this);
    this.updateUIClasses({ mouse: "add" });
    this.setActionableState({
      trash: true
    });
    return {
      rectangle
    };
  },
  // support mobile taps
  onTap: function onTap(state, e3) {
    if (state.startPoint)
      this.onMouseMove(state, e3);
    this.onClick(state, e3);
  },
  // Whenever a user clicks on the map, Draw will call `onClick`
  onClick: function onClick(state, e3) {
    if (state.startPoint && state.startPoint[0] !== e3.lngLat.lng && state.startPoint[1] !== e3.lngLat.lat) {
      this.updateUIClasses({ mouse: "pointer" });
      state.endPoint = [e3.lngLat.lng, e3.lngLat.lat];
      this.changeMode("simple_select", { featuresId: state.rectangle.id });
    }
    var startPoint = [e3.lngLat.lng, e3.lngLat.lat];
    state.startPoint = startPoint;
  },
  onMouseMove: function onMouseMove(state, e3) {
    if (state.startPoint) {
      state.rectangle.updateCoordinate("0.0", state.startPoint[0], state.startPoint[1]);
      state.rectangle.updateCoordinate("0.1", e3.lngLat.lng, state.startPoint[1]);
      state.rectangle.updateCoordinate("0.2", e3.lngLat.lng, e3.lngLat.lat);
      state.rectangle.updateCoordinate("0.3", state.startPoint[0], e3.lngLat.lat);
      state.rectangle.updateCoordinate("0.4", state.startPoint[0], state.startPoint[1]);
    }
  },
  // Whenever a user clicks on a key while focused on the map, it will be sent here
  onKeyUp: function onKeyUp(state, e3) {
    if (e3.keyCode === 27)
      return this.changeMode("simple_select");
  },
  onStop: function onStop(state) {
    doubleClickZoom.enable(this);
    this.updateUIClasses({ mouse: "none" });
    this.activateUIButton();
    if (this.getFeature(state.rectangle.id) === void 0)
      return;
    state.rectangle.removeCoordinate("0.4");
    if (state.rectangle.isValid()) {
      this.map.fire("draw.create", {
        features: [state.rectangle.toGeoJSON()]
      });
    } else {
      this.deleteFeature([state.rectangle.id], { silent: true });
      this.changeMode("simple_select", {}, { silent: true });
    }
  },
  toDisplayFeatures: function toDisplayFeatures(state, geojson, display) {
    var isActivePolygon = geojson.properties.id === state.rectangle.id;
    geojson.properties.active = isActivePolygon ? "true" : "false";
    if (!isActivePolygon)
      return display(geojson);
    if (!state.startPoint)
      return;
    return display(geojson);
  },
  onTrash: function onTrash(state) {
    this.deleteFeature([state.rectangle.id], { silent: true });
    this.changeMode("simple_select");
  }
};
var _default = dist.default = DrawRectangle;
class MapButtonControlClass {
  constructor(params2) {
    if (Array.isArray(params2)) {
      this.params = params2;
    } else {
      this.params = [params2];
    }
    this.className = params2.className;
    this.tooltip = params2.tooltip;
    this.onClick = params2.onClick;
  }
  onAdd() {
    this.container = document.createElement("div");
    this.container.className = "mapboxgl-ctrl-group mapboxgl-ctrl-group-horizontal mapboxgl-ctrl";
    this.params.forEach((param) => {
      const {
        className = "",
        tooltip = "",
        onClick: onClick2 = () => {
        },
        disabled = false
      } = param || {};
      const btn = document.createElement("button");
      btn.className = `mapboxgl-ctrl-icon ${className}`;
      btn.type = "button";
      btn.title = tooltip;
      btn.onclick = onClick2;
      if (disabled)
        btn.disabled = true;
      this.container.appendChild(btn);
    });
    return this.container;
  }
  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = void 0;
  }
}
function MapButtonControl(props) {
  const {
    map: map5,
    anchor,
    buttons
  } = props;
  React__default.useLayoutEffect(() => {
    if (map5) {
      const control = new MapButtonControlClass(buttons);
      map5.addControl(control, anchor);
      return () => {
        map5.removeControl(control);
      };
    }
    return null;
  }, [anchor, buttons, map5]);
  return null;
}
MapButtonControl.propTypes = {
  map: propTypesExports$1.object,
  buttons: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    className: propTypesExports$1.string,
    tooltip: propTypesExports$1.string,
    onClick: propTypesExports$1.func
  })),
  anchor: propTypesExports$1.oneOf(["top-right", "bottom-right", "bottom-left", "top-left"])
};
MapButtonControl.defaultProps = {
  map: null,
  buttons: [],
  anchor: "top-right"
};
const cssstyles = {
  "mapboxgl-ctrl-download": "_mapboxgl-ctrl-download_1frwx_1",
  "mapboxgl-ctrl-image-scale": "_mapboxgl-ctrl-image-scale_1frwx_8",
  "mapboxgl-ctrl-image-drag": "_mapboxgl-ctrl-image-drag_1frwx_15",
  "mapboxgl-ctrl-image-skew": "_mapboxgl-ctrl-image-skew_1frwx_22",
  "mapboxgl-ctrl-image-rotate": "_mapboxgl-ctrl-image-rotate_1frwx_29",
  "mapboxgl-ctrl-property-setter": "_mapboxgl-ctrl-property-setter_1frwx_36",
  "mapboxgl-ctrl-upload-image": "_mapboxgl-ctrl-upload-image_1frwx_43",
  "mapboxgl-ctrl-image-snap": "_mapboxgl-ctrl-image-snap_1frwx_50"
};
function DownloadControls(props) {
  const {
    data: dataIn,
    outputFilename
  } = props;
  const {
    map: map5
  } = useMapbox();
  const getData6 = React__default.useCallback(() => {
    if (typeof dataIn === "function")
      return dataIn();
    return dataIn;
  }, [dataIn]);
  const onClick2 = React__default.useCallback(() => {
    const data2 = getData6();
    if (!data2)
      return;
    const content = JSON.stringify(data2);
    const a2 = document.createElement("a");
    const file2 = new Blob([content], {
      type: "text/plain"
    });
    a2.href = URL.createObjectURL(file2);
    a2.download = outputFilename;
    a2.click();
  }, [getData6, outputFilename]);
  const buttonData = React__default.useMemo(() => [{
    className: cssstyles["mapboxgl-ctrl-download"],
    tooltip: "Download",
    onClick: onClick2
  }], [onClick2]);
  return /* @__PURE__ */ jsx(MapButtonControl, { map: map5, buttons: buttonData, anchor: "top-right" }, "downloadControls");
}
DownloadControls.propTypes = {
  data: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.func]),
  outputFilename: propTypesExports$1.string
};
DownloadControls.defaultProps = {
  data: null,
  outputFilename: "output.json"
};
const useEffect17 = (callback) => {
  const callbackRef = React__default.useRef(callback);
  const destroyRef = React__default.useRef();
  const callbackCalledRef = React__default.useRef(false);
  const renderedRef = React__default.useRef(false);
  const [, setVal] = React__default.useState(0);
  if (callbackCalledRef.current) {
    renderedRef.current = true;
  }
  React__default.useEffect(() => {
    if (!callbackCalledRef.current) {
      destroyRef.current = callbackRef.current();
      callbackCalledRef.current = true;
    }
    setVal((val) => val + 1);
    return () => {
      if (!renderedRef.current) {
        return;
      }
      if (destroyRef.current) {
        destroyRef.current();
      }
    };
  }, []);
};
const drawControls_module = {};
const ConstrainedDrawLine = {
  ...MapboxDraw$5.modes.draw_line_string,
  onSetup(opts = {}) {
    const state = MapboxDraw$5.modes.draw_line_string.onSetup.call(this, {});
    state.maxPoints = opts.maxPoints || 3;
    return state;
  },
  clickAnywhere(state, e3) {
    MapboxDraw$5.modes.draw_line_string.clickAnywhere.call(this, state, e3);
    if (state.line.coordinates.length > state.maxPoints) {
      this.changeMode("simple_select", {
        featureIds: [state.line.id]
      });
    }
  }
};
const ConstrainedDrawPolygon = {
  ...MapboxDraw$5.modes.draw_polygon,
  onSetup(opts) {
    const state = MapboxDraw$5.modes.draw_polygon.onSetup.call(this, {});
    state.maxPoints = opts.maxPoints || 5;
    return state;
  },
  clickAnywhere(state, e3) {
    MapboxDraw$5.modes.draw_polygon.clickAnywhere.call(this, state, e3);
    const numPoints = state.polygon.coordinates[0].length;
    if (numPoints - 1 >= state.maxPoints) {
      this.changeMode("simple_select", {
        featureIds: [state.polygon.id]
      });
    }
  }
};
const SnapConstrainedDrawLine = {
  ...SnapLineMode,
  onSetup(opts = {}) {
    const state = SnapLineMode.onSetup.call(this, {});
    state.maxPoints = opts.maxPoints || 3;
    return state;
  },
  onClick(state, e3) {
    SnapLineMode.onClick.call(this, state, e3);
    if (state.line.coordinates.length > state.maxPoints) {
      this.changeMode("simple_select", {
        featureIds: [state.line.id]
      });
    }
  }
};
const SnapConstrainedDrawPolygon = {
  ...SnapPolygonMode,
  onSetup(opts) {
    const state = SnapPolygonMode.onSetup.call(this, {});
    state.maxPoints = opts.maxPoints || 5;
    return state;
  },
  onClick(state, e3) {
    SnapPolygonMode.onClick.call(this, state, e3);
    const numPoints = state.polygon.coordinates[0].length;
    if (numPoints - 1 >= state.maxPoints) {
      this.changeMode("simple_select", {
        featureIds: [state.polygon.id]
      });
    }
  }
};
function DrawControls(props) {
  const {
    mode: modeIn,
    onChange,
    onSelect,
    onDelete,
    features,
    editableFeatures,
    enableDownload,
    enableDelete,
    enableButtons,
    enableSnap,
    enableConstraint,
    constraintPointCount,
    customModes
  } = props;
  const [isLoaded, setIsLoaded] = React__default.useState(null);
  const drawRef = React__default.useRef(null);
  const {
    map: map5
  } = useMapbox();
  const style2 = React__default.useMemo(() => {
    let style22 = getFeatureStyle(editableFeatures == null ? void 0 : editableFeatures[0]);
    if (!style22 || !Object.keys(style22).length)
      style22 = {
        ...DRAW_POLYGON_STYLE
      };
    return style22;
  }, [editableFeatures]);
  const enforceStyle = React__default.useCallback(() => {
    if (map5 && isLoaded) {
      applyPaintProperty(map5, style2, (layerName) => layerName == null ? void 0 : layerName.includes("gl-draw-"));
      map5.triggerRepaint();
    }
  }, [isLoaded, map5, style2]);
  const styles2 = React__default.useMemo(() => {
    const styles22 = [...customDrawStyles];
    applyPaintProperty(styles22, style2, (layerName) => layerName == null ? void 0 : layerName.includes("gl-draw-"));
    return styles22;
  }, [style2]);
  const onCreateImpl = React__default.useCallback((event) => {
    var _a3, _b3, _c2;
    const feature2 = (_a3 = event.features) == null ? void 0 : _a3[0];
    if (feature2) {
      (_b3 = drawRef.current) == null ? void 0 : _b3.add(feature2);
      onChange(feature2, (_c2 = drawRef.current) == null ? void 0 : _c2.getAll());
    }
  }, [onChange]);
  const onCreate = useMutableFunc(onCreateImpl);
  const onSelectionChangeImpl = React__default.useCallback((event) => {
    var _a3, _b3, _c2;
    if (!drawRef.current)
      return;
    if (!((_a3 = event == null ? void 0 : event.features) == null ? void 0 : _a3.length))
      return;
    const validSelections = [];
    const invalidSelections = [];
    event.features.forEach((feature2) => {
      const edit5 = editableFeatures.find((f2) => f2.id === feature2.id);
      const all = features.find((f2) => f2.id === feature2.id);
      const validSelection = !!edit5 || !all;
      if (validSelection) {
        validSelections.push(feature2);
      } else {
        invalidSelections.push(feature2);
      }
    });
    if (!invalidSelections.length && validSelections.length)
      ;
    else if (validSelections.length) {
      const featureIds = validSelections.map((f2) => f2.id);
      if (featureIds.length > 1 || ((_c2 = (_b3 = validSelections[0]) == null ? void 0 : _b3.geometry) == null ? void 0 : _c2.type) === "Point") {
        drawRef.current.changeMode("simple_select", {
          featureIds
        });
      } else {
        drawRef.current.changeMode("direct_select", {
          featureId: featureIds[0]
        });
      }
    } else if (invalidSelections.length) {
      drawRef.current.changeMode("simple_select");
    }
    const isMultiSelect = event.features.length > 1;
    if (!isMultiSelect && validSelections.length) {
      onSelect(validSelections[0], drawRef.current.getAll());
    }
  }, [editableFeatures, features, onSelect]);
  const onSelectionChange = useMutableFunc(onSelectionChangeImpl);
  const onDeleteDoneImpl = React__default.useCallback((event) => {
    const features2 = event == null ? void 0 : event.features;
    onDelete(features2);
  }, [onDelete]);
  const onDeleteDone = useMutableFunc(onDeleteDoneImpl);
  const availableModes = React__default.useMemo(() => {
    const modes2 = {
      ...MapboxDraw$5.modes
    };
    if (enableSnap) {
      modes2.draw_point = SnapPointMode;
      modes2.draw_circle = mapboxGlDrawCircleModes.RadiusCircleMode;
      modes2.draw_rectangle = _default;
      if (enableConstraint) {
        modes2.draw_line_string = SnapConstrainedDrawLine;
        modes2.draw_polygon = SnapConstrainedDrawPolygon;
      } else {
        modes2.draw_polygon = SnapPolygonMode;
        modes2.draw_line_string = SnapLineMode;
      }
    } else if (enableConstraint) {
      modes2.draw_line_string = ConstrainedDrawLine;
      modes2.draw_polygon = ConstrainedDrawPolygon;
    }
    const keys4 = Object.keys(customModes);
    if (keys4 == null ? void 0 : keys4.length) {
      keys4.forEach((key) => {
        modes2[key] = customModes[key];
      });
    }
    return modes2;
  }, [customModes, enableConstraint, enableSnap]);
  const initialize3 = React__default.useCallback(() => {
    if (!map5) {
      return null;
    }
    const mode2 = modeIn === "any" ? "select" : modeIn;
    const mapBoxMode = `${mode2}${mode2 === "line" ? "_string" : ""}`;
    const controls = {};
    if (enableButtons === "auto") {
      if (mode2 !== "select") {
        controls.trash = true;
        controls[mapBoxMode] = true;
      } else if (modeIn === "any") {
        controls.trash = true;
        controls.polygon = true;
        controls.line_string = true;
        controls.point = true;
        controls.circle = true;
        controls.rectangle = true;
      }
    } else if (Array.isArray(enableButtons)) {
      enableButtons.forEach((button) => {
        const buttonName = `${button}${button === "line" ? "_string" : ""}`;
        controls[buttonName] = true;
      });
    }
    if (enableDelete) {
      controls.trash = true;
    }
    let mapboxDrawObject = {
      displayControlsDefault: false,
      controls,
      modes: availableModes,
      defaultMode: "simple_select"
    };
    if (enableSnap) {
      mapboxDrawObject = {
        ...mapboxDrawObject,
        modes: availableModes,
        // Styling guides
        styles: styles2,
        userProperties: true,
        // Config snapping features
        snap: true,
        snapOptions: {
          snapPx: 15,
          // defaults to 15
          snapToMidPoints: true,
          // defaults to false
          snapVertexPriorityDistance: 1e-4
          // in km
        },
        guides: false
      };
    }
    const draw = new MapboxDraw$5(mapboxDrawObject);
    map5.addControl(draw);
    drawRef.current = draw;
    try {
      drawRef.current.set({
        type: "FeatureCollection",
        features
      });
    } catch (error2) {
      console.error(error2);
    }
    if (mode2 !== "select" && mode2 !== "simple_select") {
      const defaultMode = `draw_${mapBoxMode}`;
      if (enableConstraint && constraintPointCount && ["draw_line_string", "draw_polygon"].includes(defaultMode)) {
        drawRef.current.changeMode(defaultMode, {
          maxPoints: constraintPointCount
        });
      } else {
        drawRef.current.changeMode(defaultMode);
      }
    }
    drawRef.current.options.snap = !!enableSnap;
    map5.on("draw.create", onCreate);
    map5.on("draw.update", onCreate);
    map5.on("draw.selectionchange", onSelectionChange);
    map5.on("draw.delete", onDeleteDone);
    setIsLoaded(true);
    return () => {
      if (draw && map5) {
        try {
          draw.changeMode("simple_select");
          draw.options.snap = false;
          map5.off("draw.create", onCreate);
          map5.off("draw.selectionchange", onSelectionChange);
          map5.off("draw.update", onCreate);
          map5.off("draw.delete", onDeleteDone);
          map5.removeControl(draw);
        } catch (error2) {
        }
        drawRef.current = null;
      }
    };
  }, [map5, modeIn, enableButtons, enableDelete, availableModes, enableSnap, onCreate, onSelectionChange, onDeleteDone, styles2, features, enableConstraint, constraintPointCount]);
  React__default.useEffect(() => {
    if (enableDelete && Array.isArray(enableButtons) && !enableButtons.includes("trash")) {
      const TRASH_BUTTON_CLASS_NAME = "mapbox-gl-draw_trash";
      const elements = document.getElementsByClassName(TRASH_BUTTON_CLASS_NAME);
      if (elements == null ? void 0 : elements[0])
        elements[0].style.display = "none";
    }
  }, [enableButtons, enableDelete]);
  React__default.useEffect(() => {
    enforceStyle();
  }, [enforceStyle]);
  useEffect17(() => {
    const terminate = initialize3();
    return terminate;
  });
  const onDownload = React__default.useCallback(() => {
    var _a3;
    return (_a3 = drawRef.current) == null ? void 0 : _a3.getAll();
  }, []);
  if (!isLoaded || !enableDownload)
    return null;
  return /* @__PURE__ */ jsx(DownloadControls, { data: onDownload, outputFilename: `drawn-${modeIn}.json` });
}
DrawControls.propTypes = {
  mode: propTypesExports$1.oneOf(["noselect", "select", "polygon", "point", "line", "circle", "rectangle", "any"]),
  customModes: propTypesExports$1.object,
  onChange: propTypesExports$1.func,
  onSelect: propTypesExports$1.func,
  onDelete: propTypesExports$1.func,
  features: propTypesExports$1.array,
  editableFeatures: propTypesExports$1.array,
  enableDelete: propTypesExports$1.bool,
  enableDownload: propTypesExports$1.bool,
  enableButtons: propTypesExports$1.oneOfType([propTypesExports$1.oneOf(["auto"]), propTypesExports$1.arrayOf(propTypesExports$1.string)]),
  enableSnap: propTypesExports$1.bool,
  enableConstraint: propTypesExports$1.bool,
  constraintPointCount: propTypesExports$1.number
};
DrawControls.defaultProps = {
  mode: "select",
  customModes: {},
  onChange: () => {
  },
  onSelect: () => {
  },
  onDelete: () => {
  },
  features: [],
  editableFeatures: [],
  enableDelete: true,
  enableDownload: false,
  enableButtons: "auto",
  enableSnap: true,
  enableConstraint: false,
  constraintPointCount: 2
};
function LineLayer(props) {
  const {
    id,
    sourceId,
    sourceLayer,
    minZoom,
    maxZoom,
    opacity,
    width,
    dashArray,
    color: colorIn,
    selectColor,
    hoverColor,
    lineJoin,
    lineCap,
    paintProps,
    layoutProps,
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    const color2 = [colorIn];
    let needCase = false;
    if (hoverColor) {
      color2.unshift(hoverColor);
      color2.unshift(["boolean", ["feature-state", "hover"], false]);
      needCase = true;
    }
    if (selectColor) {
      color2.unshift(selectColor);
      color2.unshift(["boolean", ["feature-state", "select"], false]);
      needCase = true;
    }
    if (needCase)
      color2.unshift("case");
    return color2;
  }, [colorIn, hoverColor, selectColor]);
  const paintOptions = React__default.useMemo(() => ({
    "line-color": color,
    "line-width": width,
    "line-opacity": opacity,
    "line-dasharray": dashArray,
    ...paintProps
  }), [color, width, opacity, dashArray, paintProps]);
  const layoutOptions = React__default.useMemo(() => ({
    "line-join": lineJoin,
    "line-cap": lineCap,
    ...layoutProps
  }), [layoutProps, lineCap, lineJoin]);
  const sources2 = React__default.useMemo(() => {
    const sources22 = {};
    if (sourceId) {
      sources22.source = sourceId;
    }
    if (sourceLayer) {
      sources22["source-layer"] = sourceLayer;
    }
    return sources22;
  }, [sourceId, sourceLayer]);
  return /* @__PURE__ */ jsx(Layer$1, { id, type: "line", paint: paintOptions, layout: layoutOptions, minzoom: minZoom, maxzoom: maxZoom, ...sources2, ...restProps });
}
LineLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  opacity: propTypesExports$1.any,
  width: propTypesExports$1.any,
  dashArray: propTypesExports$1.any,
  selectColor: propTypesExports$1.string,
  hoverColor: propTypesExports$1.string,
  color: propTypesExports$1.any,
  lineJoin: propTypesExports$1.string,
  lineCap: propTypesExports$1.string,
  paintProps: propTypesExports$1.object,
  layoutProps: propTypesExports$1.object
};
LineLayer.defaultProps = {
  sourceLayer: void 0,
  minZoom: 0,
  maxZoom: 24,
  width: 2,
  dashArray: [],
  opacity: 1,
  color: "#000000",
  lineJoin: "round",
  lineCap: "round",
  selectColor: "lightgreen",
  hoverColor: "lightblue",
  paintProps: {},
  layoutProps: {}
};
function LineLayer2(props) {
  const {
    id: layerId,
    sourceId,
    color: fillColor,
    // not used - only use outline color
    colorPropName: fillColorPropName,
    // not used - only use outline color
    opacity: fillOpacity,
    // not used - only use outline
    opacityPropName: fillOpacityPropName,
    // not used - only use outline
    outlineColor: colorIn,
    outlinePropName: colorPropName,
    outlineOpacity: opacityIn,
    outlineOpacityPropName: opacityPropName,
    outlineWidth,
    outlineWidthPropName,
    outlineDashArray: outlineDashArrayIn,
    outlineDashArrayPropName,
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    if (colorPropName) {
      return ["coalesce", ["get", colorPropName], colorIn];
    }
    return colorIn;
  }, [colorIn, colorPropName]);
  const opacity = React__default.useMemo(() => {
    if (opacityPropName) {
      return ["to-number", ["coalesce", ["get", opacityPropName], opacityIn], opacityIn];
    }
    return opacityIn;
  }, [opacityIn, opacityPropName]);
  const width = React__default.useMemo(() => {
    if (outlineWidthPropName) {
      return ["to-number", ["coalesce", ["get", outlineWidthPropName], outlineWidth], outlineWidth];
    }
    return outlineWidth;
  }, [outlineWidth, outlineWidthPropName]);
  const dashArray = React__default.useMemo(() => {
    if (outlineDashArrayPropName) {
      return ["coalesce", ["get", outlineDashArrayPropName], ["literal", outlineDashArrayIn]];
    }
    return outlineDashArrayIn;
  }, [outlineDashArrayIn, outlineDashArrayPropName]);
  return /* @__PURE__ */ jsx(LineLayer, { id: layerId, sourceId, color, opacity, width, dashArray, ...restProps });
}
LineLayer2.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  outlineWidth: propTypesExports$1.number,
  outlineWidthPropName: propTypesExports$1.string,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string,
  outlineColor: propTypesExports$1.any,
  outlinePropName: propTypesExports$1.string,
  outlineOpacity: propTypesExports$1.any,
  outlineOpacityPropName: propTypesExports$1.string,
  outlineDashArray: propTypesExports$1.arrayOf(propTypesExports$1.number),
  outlineDashArrayPropName: propTypesExports$1.string
};
LineLayer2.defaultProps = {
  outlineWidth: 1,
  outlineWidthPropName: null,
  colorPropName: null,
  color: null,
  opacity: 1,
  opacityPropName: null,
  outlineColor: null,
  outlinePropName: null,
  outlineOpacity: 1,
  outlineOpacityPropName: null,
  outlineDashArray: null,
  outlineDashArrayPropName: null
};
function GeoJsonLineLayer(props) {
  const {
    id: layerId,
    sourceId: sourceIdIn,
    data: data2,
    sourceProps,
    ...restProps
  } = props;
  const sourceId = sourceIdIn || `${layerId}-source`;
  return /* @__PURE__ */ jsx(Source$1, { id: sourceId, type: "geojson", data: data2, ...sourceProps, children: /* @__PURE__ */ jsx(LineLayer2, { id: layerId, sourceId, ...restProps }) });
}
GeoJsonLineLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]).isRequired,
  sourceProps: propTypesExports$1.object
};
GeoJsonLineLayer.defaultProps = {
  sourceId: null,
  sourceProps: {}
};
function ExtrusionLayer(props) {
  const {
    id,
    sourceId,
    sourceLayer,
    minZoom,
    maxZoom,
    opacity,
    color: colorIn,
    selectColor,
    hoverColor,
    height,
    elevation,
    paintProps,
    layoutProps,
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    const color2 = [colorIn];
    let needCase = false;
    if (hoverColor) {
      color2.unshift(hoverColor);
      color2.unshift(["boolean", ["feature-state", "hover"], false]);
      needCase = true;
    }
    if (selectColor) {
      color2.unshift(selectColor);
      color2.unshift(["boolean", ["feature-state", "select"], false]);
      needCase = true;
    }
    if (needCase)
      color2.unshift("case");
    return color2;
  }, [colorIn, hoverColor, selectColor]);
  const paintOptions = React__default.useMemo(() => ({
    "fill-extrusion-color": color,
    "fill-extrusion-height": height,
    "fill-extrusion-base": elevation,
    "fill-extrusion-opacity": opacity,
    // per layer basis (not per feature)
    ...paintProps
  }), [color, elevation, paintProps, height, opacity]);
  const layoutOptions = React__default.useMemo(() => {
    const layouts = {
      ...layoutProps
    };
    return layouts;
  }, [layoutProps]);
  const sources2 = React__default.useMemo(() => {
    const sources22 = {};
    if (sourceId) {
      sources22.source = sourceId;
    }
    if (sourceLayer) {
      sources22["source-layer"] = sourceLayer;
    }
    return sources22;
  }, [sourceId, sourceLayer]);
  return /* @__PURE__ */ jsx(Layer$1, { id, type: "fill-extrusion", paint: paintOptions, layout: layoutOptions, minzoom: minZoom, maxzoom: maxZoom, ...sources2, ...restProps });
}
ExtrusionLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  opacity: propTypesExports$1.any,
  selectColor: propTypesExports$1.any,
  hoverColor: propTypesExports$1.any,
  color: propTypesExports$1.any,
  height: propTypesExports$1.any,
  elevation: propTypesExports$1.any,
  paintProps: propTypesExports$1.object,
  layoutProps: propTypesExports$1.object
};
ExtrusionLayer.defaultProps = {
  sourceLayer: void 0,
  minZoom: 0,
  maxZoom: 24,
  opacity: 1,
  color: "#f5fefd",
  selectColor: "lightgreen",
  hoverColor: "lightblue",
  height: 1e-4,
  elevation: 0,
  paintProps: {},
  layoutProps: {}
};
function ExtrusionLayer2(props) {
  const {
    id: layerId,
    sourceId,
    height: heightIn,
    elevation: elevationIn,
    color: colorIn,
    colorPropName,
    opacity,
    // not supported on per feature basis
    opacityPropName,
    outlineColor,
    // not supported by extrusions
    outlinePropName,
    // not supported by extrusions
    outlineOpacity,
    outlineOpacityPropName,
    heightPropName,
    elevationPropName,
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    if (colorPropName) {
      return ["get", colorPropName];
    }
    return colorIn;
  }, [colorIn, colorPropName]);
  const height = React__default.useMemo(() => {
    if (heightPropName) {
      return ["to-number", ["coalesce", ["get", heightPropName], heightIn], heightIn];
    }
    return heightIn;
  }, [heightIn, heightPropName]);
  const elevation = React__default.useMemo(() => {
    if (elevationPropName) {
      return ["to-number", ["coalesce", ["get", elevationPropName], elevationIn], elevationIn];
    }
    return elevationIn;
  }, [elevationIn, elevationPropName]);
  return /* @__PURE__ */ jsx(ExtrusionLayer, { id: layerId, sourceId, color, opacity, height, elevation, ...restProps });
}
ExtrusionLayer2.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string,
  outlineColor: propTypesExports$1.any,
  outlinePropName: propTypesExports$1.string,
  outlineOpacity: propTypesExports$1.any,
  outlineOpacityPropName: propTypesExports$1.string,
  height: propTypesExports$1.any,
  heightPropName: propTypesExports$1.string,
  elevation: propTypesExports$1.number,
  elevationPropName: propTypesExports$1.string
};
ExtrusionLayer2.defaultProps = {
  colorPropName: null,
  color: null,
  opacity: 1,
  opacityPropName: null,
  outlineColor: null,
  outlinePropName: null,
  outlineOpacity: 1,
  outlineOpacityPropName: null,
  height: 0,
  heightPropName: null,
  elevation: 0,
  elevationPropName: null
};
function GeoJsonExtrusionLayer(props) {
  const {
    id: layerId,
    sourceId: sourceIdIn,
    data: data2,
    opacity: opacityIn,
    // not supported on per feature basis
    opacityPropName,
    sourceProps,
    ...restProps
  } = props;
  const sourceId = sourceIdIn || `${layerId}-source`;
  const opacity = React__default.useMemo(() => {
    var _a3, _b3, _c2;
    if (typeof data2 !== "object")
      return opacityIn;
    if (!opacityPropName)
      return opacityIn;
    return ((_c2 = (_b3 = (_a3 = data2 == null ? void 0 : data2.features) == null ? void 0 : _a3[0]) == null ? void 0 : _b3.properties) == null ? void 0 : _c2[opacityPropName]) || opacityIn;
  }, [data2, opacityIn, opacityPropName]);
  return /* @__PURE__ */ jsx(Source$1, { id: sourceId, type: "geojson", data: data2, ...sourceProps, children: /* @__PURE__ */ jsx(ExtrusionLayer2, { id: layerId, sourceId, opacity, ...restProps }) });
}
GeoJsonExtrusionLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]).isRequired,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string,
  sourceProps: propTypesExports$1.object
};
GeoJsonExtrusionLayer.defaultProps = {
  sourceId: null,
  opacity: 1,
  opacityPropName: null,
  sourceProps: {}
};
function FillLayer(props) {
  const {
    id,
    sourceId,
    sourceLayer,
    minZoom,
    maxZoom,
    opacity: opacityIn,
    color: colorIn,
    outlineColor,
    selectColor,
    hoverColor,
    hoverOpacity,
    selectOpacity,
    paintProps,
    layoutProps,
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    const needCase = hoverColor || selectColor;
    const color2 = needCase ? [colorIn] : colorIn;
    if (needCase) {
      if (hoverColor) {
        color2.unshift(hoverColor);
        color2.unshift(["boolean", ["feature-state", "hover"], false]);
      }
      if (selectColor) {
        color2.unshift(selectColor);
        color2.unshift(["boolean", ["feature-state", "select"], false]);
      }
      color2.unshift("case");
    }
    return color2;
  }, [colorIn, hoverColor, selectColor]);
  const opacity = React__default.useMemo(() => {
    const needCase = typeof hoverOpacity !== "undefined" || typeof selectOpacity !== "undefined";
    const opacity2 = needCase ? [opacityIn] : opacityIn;
    if (needCase) {
      if (typeof hoverOpacity !== "undefined") {
        opacity2.unshift(hoverOpacity);
        opacity2.unshift(["boolean", ["feature-state", "hover"], false]);
      }
      if (typeof selectOpacity !== "undefined") {
        opacity2.unshift(selectOpacity);
        opacity2.unshift(["boolean", ["feature-state", "select"], false]);
      }
      opacity2.unshift("case");
    }
    return opacity2;
  }, [hoverOpacity, opacityIn, selectOpacity]);
  const paintOptions = React__default.useMemo(() => ({
    "fill-color": color,
    "fill-opacity": opacity,
    "fill-outline-color": outlineColor,
    ...paintProps
  }), [color, paintProps, opacity, outlineColor]);
  const layoutOptions = React__default.useMemo(() => {
    const layouts = {
      ...layoutProps
    };
    return layouts;
  }, [layoutProps]);
  const sources2 = React__default.useMemo(() => {
    const sources22 = {};
    if (sourceId) {
      sources22.source = sourceId;
    }
    if (sourceLayer) {
      sources22["source-layer"] = sourceLayer;
    }
    return sources22;
  }, [sourceId, sourceLayer]);
  return /* @__PURE__ */ jsx(Layer$1, { id, type: "fill", paint: paintOptions, layout: layoutOptions, minzoom: minZoom, maxzoom: maxZoom, ...sources2, ...restProps });
}
FillLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  opacity: propTypesExports$1.any,
  selectColor: propTypesExports$1.any,
  hoverColor: propTypesExports$1.any,
  hoverOpacity: propTypesExports$1.any,
  selectOpacity: propTypesExports$1.any,
  color: propTypesExports$1.any,
  outlineColor: propTypesExports$1.any,
  paintProps: propTypesExports$1.object,
  layoutProps: propTypesExports$1.object
};
FillLayer.defaultProps = {
  sourceLayer: void 0,
  minZoom: 0,
  maxZoom: 24,
  opacity: 0.5,
  color: "#0080ff",
  // blue color fill
  outlineColor: void 0,
  selectColor: "lightgreen",
  hoverColor: "lightblue",
  hoverOpacity: 0.1,
  selectOpacity: 0.1,
  paintProps: {},
  layoutProps: {}
};
function FillLayer2(props) {
  const {
    id: layerId,
    sourceId,
    color: colorIn,
    colorPropName,
    opacity: opacityIn,
    opacityPropName,
    outlineColor: outlineColorIn,
    outlinePropName,
    outlineOpacity: outlineOpacityIn,
    // fill-outline-opacity is not supported in mapbox
    outlineOpacityPropName,
    // fill-outline-opacity is not supported in mapbox
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    if (colorPropName) {
      return ["coalesce", ["get", colorPropName], colorIn];
    }
    return colorIn;
  }, [colorIn, colorPropName]);
  const outlineColor = React__default.useMemo(() => {
    if (outlinePropName) {
      return ["coalesce", ["get", outlinePropName], outlineColorIn];
    }
    return outlineColorIn;
  }, [outlineColorIn, outlinePropName]);
  const opacity = React__default.useMemo(() => {
    if (opacityPropName) {
      return ["to-number", ["coalesce", ["get", opacityPropName], opacityIn], opacityIn];
    }
    return opacityIn;
  }, [opacityIn, opacityPropName]);
  return /* @__PURE__ */ jsx(FillLayer, { id: layerId, sourceId, color, opacity, outlineColor, ...restProps });
}
FillLayer2.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string,
  outlineColor: propTypesExports$1.any,
  outlinePropName: propTypesExports$1.string,
  outlineOpacity: propTypesExports$1.any,
  outlineOpacityPropName: propTypesExports$1.string
};
FillLayer2.defaultProps = {
  colorPropName: null,
  color: null,
  opacity: 1,
  opacityPropName: null,
  outlineColor: null,
  outlinePropName: null,
  outlineOpacity: 1,
  outlineOpacityPropName: null
};
function GeoJsonFillLayer(props) {
  const {
    id: layerId,
    data: data2,
    sourceId: sourceIdIn,
    sourceProps,
    ...restProps
  } = props;
  const sourceId = sourceIdIn || `${layerId}-source`;
  return /* @__PURE__ */ jsx(Source$1, { id: sourceId, type: "geojson", data: data2, ...sourceProps, children: /* @__PURE__ */ jsx(FillLayer2, { id: layerId, sourceId, ...restProps }) });
}
GeoJsonFillLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]).isRequired,
  sourceProps: propTypesExports$1.object
};
GeoJsonFillLayer.defaultProps = {
  sourceId: null,
  sourceProps: {}
};
function ClusterSource(props) {
  const {
    id: sourceId,
    children,
    clusterLayerId,
    cluster,
    clusterExpansion,
    clusterMaxZoom,
    clusterRadius,
    ...restProps
  } = props;
  const {
    map: map5
  } = useMapbox();
  const clusterProps = React__default.useMemo(() => {
    const sourceProps = {};
    if (cluster) {
      sourceProps.cluster = true;
      sourceProps.clusterMaxZoom = clusterMaxZoom;
      sourceProps.clusterRadius = clusterRadius;
    }
    return sourceProps;
  }, [cluster, clusterMaxZoom, clusterRadius]);
  const onClickCluster = React__default.useCallback((e3) => {
    var _a3, _b3;
    if (!e3 || !clusterExpansion || !cluster || !clusterLayerId)
      return;
    const features = map5.queryRenderedFeatures(e3.point, {
      layers: [clusterLayerId]
    });
    const clusterId = (_b3 = (_a3 = features[0]) == null ? void 0 : _a3.properties) == null ? void 0 : _b3.cluster_id;
    if (!clusterId)
      return;
    map5.getSource(sourceId).getClusterExpansionZoom(clusterId, (err, zoom2) => {
      if (!err) {
        map5.easeTo({
          center: features[0].geometry.coordinates,
          zoom: zoom2
        });
      }
    });
  }, [cluster, clusterExpansion, clusterLayerId, map5, sourceId]);
  React__default.useEffect(() => {
    if (!clusterExpansion || !cluster || !clusterLayerId)
      return () => {
      };
    map5 == null ? void 0 : map5.on("click", clusterLayerId, onClickCluster);
    return () => {
      map5 == null ? void 0 : map5.off("click", clusterLayerId, onClickCluster);
    };
  }, [cluster, clusterExpansion, clusterLayerId, map5, onClickCluster]);
  return /* @__PURE__ */ jsx(Source$1, { id: sourceId, ...clusterProps, ...restProps, children });
}
ClusterSource.propTypes = {
  id: propTypesExports$1.string.isRequired,
  // sourceId
  children: propTypesExports$1.node,
  clusterLayerId: propTypesExports$1.string,
  cluster: propTypesExports$1.bool,
  clusterExpansion: propTypesExports$1.bool,
  // zoom effect on click of cluster
  clusterMaxZoom: propTypesExports$1.number,
  clusterRadius: propTypesExports$1.number
};
ClusterSource.defaultProps = {
  children: null,
  clusterLayerId: null,
  cluster: false,
  clusterExpansion: true,
  clusterMaxZoom: 15,
  clusterRadius: 50
};
function SymbolLayer(props) {
  const {
    id,
    sourceId,
    iconId: iconIdIn,
    // either iconId or iconUrl should be provided for icon to display
    iconUrl: iconUrl2,
    sourceLayer,
    minZoom,
    maxZoom,
    opacity,
    color: colorIn,
    textValue,
    textColor: textColor2,
    textOpacity,
    textAnchor,
    textOffset,
    textMinZoom,
    textMaxZoom,
    selectColor,
    hoverColor,
    iconSize: scale5,
    showIcon,
    showText,
    textBackground,
    paintProps,
    layoutProps,
    pixelRatio,
    ...restProps
  } = props;
  const [iconId, setIconId] = React__default.useState();
  const isLoadingRef = React__default.useRef(false);
  const {
    map: map5
  } = useMapbox();
  React__default.useLayoutEffect(() => {
    if (isLoadingRef.current)
      return;
    if (map5 && iconUrl2) {
      if (!iconId) {
        const iconIdNew = `${id}-icon`;
        if (map5.hasImage(iconIdNew)) {
          isLoadingRef.current = false;
        } else {
          isLoadingRef.current = true;
          map5.loadImage(iconUrl2, (error2, image) => {
            isLoadingRef.current = false;
            if (!error2) {
              map5.addImage(iconIdNew, image, {
                pixelRatio
              });
              setIconId(iconIdNew);
            }
          });
        }
      }
    } else if (!iconUrl2 && iconIdIn && !iconId) {
      setIconId(iconIdIn);
    }
  }, [iconId, iconIdIn, iconUrl2, id, map5, pixelRatio]);
  const color = React__default.useMemo(() => {
    const color2 = [colorIn];
    let needCase = false;
    if (hoverColor) {
      color2.unshift(hoverColor);
      color2.unshift(["boolean", ["feature-state", "hover"], false]);
      needCase = true;
    }
    if (selectColor) {
      color2.unshift(selectColor);
      color2.unshift(["boolean", ["feature-state", "select"], false]);
      needCase = true;
    }
    if (needCase)
      color2.unshift("case");
    return color2;
  }, [colorIn, hoverColor, selectColor]);
  const paintOptions = React__default.useMemo(() => {
    const background = textBackground ? {
      "text-halo-blur": 2,
      "text-halo-color": "rgba(0, 0, 0, 0.2)",
      "text-halo-width": 10
    } : {};
    return {
      "icon-color": color,
      "icon-opacity": opacity,
      "text-color": textColor2,
      "text-opacity": textOpacity,
      ...background,
      ...paintProps
    };
  }, [color, paintProps, opacity, textBackground, textColor2, textOpacity]);
  const layoutOptions = React__default.useMemo(() => {
    const textAnchorFinal = textAnchor ? {
      "text-anchor": textAnchor,
      "text-offset": [0, textOffset]
    } : {
      "text-variable-anchor": ["top", "bottom", "left", "right"],
      "text-radial-offset": textOffset
    };
    const layout = {
      visibility: "visible",
      "icon-size": scale5,
      "text-rotation-alignment": "auto",
      "text-allow-overlap": true,
      "text-justify": "auto",
      ...textAnchorFinal
    };
    if (showIcon && iconId)
      layout["icon-image"] = iconId;
    return {
      ...layout,
      ...layoutProps
    };
  }, [textAnchor, textOffset, scale5, showIcon, iconId, layoutProps]);
  const sources2 = React__default.useMemo(() => {
    const sources22 = {};
    if (sourceId) {
      sources22.source = sourceId;
    }
    if (sourceLayer) {
      sources22["source-layer"] = sourceLayer;
    }
    return sources22;
  }, [sourceId, sourceLayer]);
  React__default.useLayoutEffect(() => {
    if (!map5 || !showText || !textValue)
      return () => {
      };
    const listener = () => {
      if (!map5.getLayer(id))
        return;
      const currentZoom = map5.getZoom();
      if (currentZoom < textMinZoom || currentZoom > textMaxZoom) {
        map5.setLayoutProperty(id, "text-field", "");
      } else {
        map5.setLayoutProperty(id, "text-field", textValue);
      }
    };
    map5.on("move", listener);
    return () => map5.off("move", listener);
  }, [id, map5, showText, textMaxZoom, textMinZoom, textValue]);
  if (!showIcon && !showText)
    return null;
  if (showIcon && !iconId)
    return null;
  return /* @__PURE__ */ jsx(Layer$1, { id, type: "symbol", paint: paintOptions, layout: layoutOptions, minzoom: minZoom, maxzoom: maxZoom, ...sources2, ...restProps });
}
SymbolLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  textMinZoom: propTypesExports$1.number,
  textMaxZoom: propTypesExports$1.number,
  opacity: propTypesExports$1.any,
  selectColor: propTypesExports$1.string,
  hoverColor: propTypesExports$1.string,
  color: propTypesExports$1.any,
  textValue: propTypesExports$1.any,
  textColor: propTypesExports$1.any,
  textOpacity: propTypesExports$1.number,
  textAnchor: propTypesExports$1.any,
  textOffset: propTypesExports$1.number,
  textBackground: propTypesExports$1.bool,
  iconSize: propTypesExports$1.any,
  // scale
  iconId: propTypesExports$1.any,
  iconUrl: propTypesExports$1.string,
  showIcon: propTypesExports$1.bool,
  showText: propTypesExports$1.bool,
  paintProps: propTypesExports$1.object,
  layoutProps: propTypesExports$1.object,
  pixelRatio: propTypesExports$1.number
};
SymbolLayer.defaultProps = {
  sourceLayer: void 0,
  minZoom: 0,
  maxZoom: 24,
  textMinZoom: 0,
  textMaxZoom: 24,
  opacity: 0.5,
  color: "#0080ff",
  // blue color fill
  textValue: "",
  textColor: "#000000",
  textOpacity: 1,
  textAnchor: "center",
  textOffset: 0,
  textBackground: false,
  selectColor: "lightgreen",
  hoverColor: "lightblue",
  iconSize: 1,
  iconId: "",
  iconUrl: "",
  showIcon: true,
  showText: false,
  paintProps: {},
  layoutProps: {},
  pixelRatio: 1
};
function CircleLayer(props) {
  const {
    id,
    sourceId,
    sourceLayer,
    minZoom,
    maxZoom,
    opacity,
    color: colorIn,
    selectColor,
    hoverColor,
    circleRadius: circleRadius2,
    outlineColor,
    outlineWidth,
    outlineOpacity,
    paintProps,
    layoutProps,
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    const color2 = [colorIn];
    let needCase = false;
    if (hoverColor) {
      color2.unshift(hoverColor);
      color2.unshift(["boolean", ["feature-state", "hover"], false]);
      needCase = true;
    }
    if (selectColor) {
      color2.unshift(selectColor);
      color2.unshift(["boolean", ["feature-state", "select"], false]);
      needCase = true;
    }
    if (needCase)
      color2.unshift("case");
    return color2;
  }, [colorIn, hoverColor, selectColor]);
  const paintOptions = React__default.useMemo(() => ({
    "circle-radius": circleRadius2,
    "circle-color": color,
    "circle-opacity": opacity,
    "circle-stroke-color": outlineColor,
    "circle-stroke-width": outlineWidth,
    "circle-stroke-opacity": outlineOpacity,
    ...paintProps
  }), [circleRadius2, color, opacity, outlineColor, outlineWidth, outlineOpacity, paintProps]);
  const layoutOptions = React__default.useMemo(() => {
    const layout = {
      visibility: "visible",
      ...layoutProps
    };
    return layout;
  }, [layoutProps]);
  const sources2 = React__default.useMemo(() => {
    const sources22 = {};
    if (sourceId) {
      sources22.source = sourceId;
    }
    if (sourceLayer) {
      sources22["source-layer"] = sourceLayer;
    }
    return sources22;
  }, [sourceId, sourceLayer]);
  return /* @__PURE__ */ jsx(Layer$1, { id, type: "circle", paint: paintOptions, layout: layoutOptions, minzoom: minZoom, maxzoom: maxZoom, ...sources2, ...restProps });
}
CircleLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  opacity: propTypesExports$1.any,
  selectColor: propTypesExports$1.string,
  hoverColor: propTypesExports$1.string,
  color: propTypesExports$1.any,
  outlineColor: propTypesExports$1.any,
  outlineWidth: propTypesExports$1.any,
  outlineOpacity: propTypesExports$1.any,
  circleRadius: propTypesExports$1.number,
  paintProps: propTypesExports$1.object,
  layoutProps: propTypesExports$1.object
};
CircleLayer.defaultProps = {
  sourceLayer: void 0,
  minZoom: 0,
  maxZoom: 24,
  opacity: 1,
  color: "#0080ff",
  // blue color fill
  selectColor: "lightgreen",
  hoverColor: "lightblue",
  outlineColor: "#FFFFFF",
  outlineWidth: 2,
  outlineOpacity: 1,
  circleRadius: 5,
  paintProps: {},
  layoutProps: {}
};
function PointLayer2(props) {
  const {
    id: layerId,
    sourceId,
    color: colorIn,
    colorPropName,
    opacity: opacityIn,
    opacityPropName,
    outlineColor: outlineColorIn,
    outlinePropName,
    outlineOpacity: outlinePpacityIn,
    outlineOpacityPropName,
    textValue: textValueIn,
    textValuePropName,
    textColor: textColorIn,
    textColorPropName,
    textOpacity: textOpacityIn,
    textOpacityPropName,
    textAnchor: textAnchorIn,
    textAnchorPropName,
    showIcon,
    showText,
    iconIdPropName,
    iconId: iconIdIn,
    iconUrl: iconUrl2,
    iconSize: iconSizeIn,
    iconSizePropName,
    circleRadius: circleRadius2,
    ...restProps
  } = props;
  const shouldFallback = !showIcon && !showText || showIcon && !iconUrl2 && !iconIdIn && !iconIdPropName;
  const color = React__default.useMemo(() => {
    if (colorPropName) {
      return ["coalesce", ["get", colorPropName], colorIn];
    }
    return colorIn;
  }, [colorIn, colorPropName]);
  const opacity = React__default.useMemo(() => {
    if (opacityPropName) {
      return ["to-number", ["coalesce", ["get", opacityPropName], opacityIn], opacityIn];
    }
    return opacityIn;
  }, [opacityIn, opacityPropName]);
  const textValue = React__default.useMemo(() => {
    if (textValuePropName) {
      return ["coalesce", ["get", textValuePropName], textValueIn];
    }
    return textValueIn;
  }, [textValueIn, textValuePropName]);
  const textColor2 = React__default.useMemo(() => {
    if (textColorPropName) {
      return ["coalesce", ["get", textColorPropName], textColorIn];
    }
    return textColorIn;
  }, [textColorIn, textColorPropName]);
  const textOpacity = React__default.useMemo(() => {
    if (textOpacityPropName) {
      return ["to-number", ["coalesce", ["get", textOpacityPropName], textOpacityIn], textOpacityIn];
    }
    return textOpacityIn;
  }, [textOpacityIn, textOpacityPropName]);
  const textAnchor = React__default.useMemo(() => {
    if (textAnchorPropName) {
      return ["coalesce", ["get", textAnchorPropName], textAnchorIn];
    }
    return textAnchorIn;
  }, [textAnchorIn, textAnchorPropName]);
  const iconId = React__default.useMemo(() => {
    if (iconIdPropName) {
      return ["coalesce", ["get", iconIdPropName], iconIdIn];
    }
    return iconIdIn;
  }, [iconIdIn, iconIdPropName]);
  const iconSize2 = React__default.useMemo(() => {
    let size22 = iconSizeIn || 1;
    if (Array.isArray(size22))
      return size22;
    if (iconSizePropName) {
      size22 = ["coalesce", ["get", iconSizePropName], iconSizeIn || 1];
    }
    return size22;
  }, [iconSizeIn, iconSizePropName]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !shouldFallback && /* @__PURE__ */ jsx(SymbolLayer, { id: layerId, sourceId, color, opacity, textValue, textColor: textColor2, textOpacity, textAnchor, showIcon, showText, iconId, iconUrl: iconUrl2, iconSize: iconSize2, ...restProps }),
    shouldFallback && /* @__PURE__ */ jsx(
      CircleLayer,
      {
        id: layerId,
        sourceId,
        color,
        opacity: 1,
        circleRadius: circleRadius2,
        ...restProps
      }
    ),
    shouldFallback && showText && /* @__PURE__ */ jsx(
      SymbolLayer,
      {
        id: `${layerId}-text`,
        sourceId,
        color,
        opacity,
        textValue,
        textColor: textColor2,
        textOpacity,
        textAnchor,
        showIcon: false,
        showText,
        ...restProps
      }
    )
  ] });
}
PointLayer2.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string,
  outlineColor: propTypesExports$1.any,
  outlinePropName: propTypesExports$1.string,
  outlineOpacity: propTypesExports$1.any,
  outlineOpacityPropName: propTypesExports$1.string,
  iconIdPropName: propTypesExports$1.string,
  iconId: propTypesExports$1.string,
  iconUrl: propTypesExports$1.string,
  iconSize: propTypesExports$1.any,
  iconSizePropName: propTypesExports$1.string,
  textValue: propTypesExports$1.any,
  textValuePropName: propTypesExports$1.string,
  textColor: propTypesExports$1.any,
  textColorPropName: propTypesExports$1.string,
  textOpacity: propTypesExports$1.any,
  textOpacityPropName: propTypesExports$1.any,
  textAnchor: propTypesExports$1.any,
  textAnchorPropName: propTypesExports$1.string,
  showIcon: propTypesExports$1.bool,
  showText: propTypesExports$1.bool,
  circleRadius: propTypesExports$1.any
};
PointLayer2.defaultProps = {
  colorPropName: null,
  color: void 0,
  opacity: 1,
  opacityPropName: null,
  outlineColor: null,
  outlinePropName: null,
  outlineOpacity: 1,
  outlineOpacityPropName: null,
  iconIdPropName: null,
  iconId: "",
  iconUrl: "",
  iconSize: [
    "interpolate",
    ["exponential", 0.5],
    ["zoom"],
    15,
    typeof size === "number" ? 0.4 : ["*", 0.4, ["number", 1]],
    18,
    1
    // When zoom is 18 or higher,
  ],
  iconSizePropName: void 0,
  textValue: "",
  textValuePropName: null,
  textColor: "",
  textColorPropName: null,
  textOpacity: 1,
  textOpacityPropName: void 0,
  textAnchor: "",
  textAnchorPropName: null,
  showIcon: true,
  showText: false,
  circleRadius: void 0
};
function GeojsonPointLayer(props) {
  const {
    id: layerId,
    data: data2,
    sourceId: sourceIdIn,
    sourceProps,
    ...restProps
  } = props;
  const sourceId = sourceIdIn || `${layerId}-source`;
  if (!data2)
    return null;
  return /* @__PURE__ */ jsx(ClusterSource, { id: sourceId, type: "geojson", data: data2, clusterLayerId: layerId, ...sourceProps, children: /* @__PURE__ */ jsx(PointLayer2, { id: layerId, sourceId, ...restProps }) });
}
GeojsonPointLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]).isRequired,
  sourceProps: propTypesExports$1.object
};
GeojsonPointLayer.defaultProps = {
  sourceId: null,
  sourceProps: {}
};
const getRandomHex$1 = () => {
  const n2 = (Math.random() * 1048575 * 1e6).toString(16);
  return `#${n2.slice(0, 6)}`;
};
function GeoJsonLayerInternals(props) {
  var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h;
  const {
    id: layerIdPrefix,
    beforeId,
    data: dataIn,
    floorHeight,
    heightPropName,
    colorPropName,
    color,
    outlinePropName,
    outlineColor,
    textColorPropName,
    textOpacityPropName,
    extrusionEnabled,
    thicknessEnabled,
    fillEnabled,
    outlineEnabled: extractOutlines,
    lineEnabled,
    pointEnabled,
    thickness,
    iconIdPropName,
    iconUrlPropName,
    iconUrl: iconUrlIn,
    iconSize: iconSize2,
    iconSizePropName,
    textColor: textColor2,
    textOpacity,
    textAnchor,
    textAnchorPropName,
    textValue,
    textValuePropName,
    textOffset,
    textBackground,
    customIcon,
    ...restProps
  } = props;
  const {
    map: map5
  } = useMapbox();
  const [symbols, setSymbols] = React__default.useState(null);
  const onFeature = React__default.useCallback((feature2) => {
    if (feature2) {
      if (typeof feature2.properties[heightPropName] === "undefined") {
        feature2.properties[heightPropName] = floorHeight;
      }
      if (typeof feature2.properties[colorPropName] === "undefined") {
        feature2.properties[colorPropName] = color === "random" ? getRandomHex$1() : color;
      }
      if (typeof feature2.properties[outlinePropName] === "undefined") {
        feature2.properties[outlinePropName] = outlineColor === "random" ? getRandomHex$1() : outlineColor;
      }
    }
  }, [color, colorPropName, floorHeight, heightPropName, outlineColor, outlinePropName]);
  const getCollections = React__default.useCallback((features) => ({
    type: "FeatureCollection",
    features
  }), []);
  const json = useEditGeojson({
    data: dataIn,
    onFeature
  });
  const {
    extrusions,
    polygons: polygons2,
    lines,
    points: points2
  } = React__default.useMemo(() => {
    const features = (json == null ? void 0 : json.features) || (json.type === "Feature" ? [json] : []);
    const polygons22 = [];
    const lines2 = [];
    const points22 = [];
    features == null ? void 0 : features.forEach((feature2) => {
      var _a4, _b4;
      switch ((_a4 = feature2.geometry) == null ? void 0 : _a4.type) {
        case "Polygon": {
          polygons22.push(feature2);
          if (extractOutlines) {
            (_b4 = GeoUtil.getLineStrings(feature2)) == null ? void 0 : _b4.forEach((line, index2) => {
              lines2.push({
                id: `${feature2.id}-${index2}-line`,
                type: "Feature",
                geometry: line,
                properties: {
                  ...feature2.properties || {}
                }
              });
            });
          }
          break;
        }
        case "LineString": {
          lines2.push(feature2);
          break;
        }
        case "Point": {
          points22.push(feature2);
          break;
        }
      }
    });
    if (thicknessEnabled) {
      if (extrusionEnabled) {
        polygons22.forEach((f2, index2, arr) => {
          const finalThickness = f2.properties.thickness ? Number(f2.properties.thickness) : thickness;
          if (finalThickness) {
            const polygon4 = GeoUtil.thicken(f2, finalThickness);
            if (polygon4)
              arr[index2] = polygon4;
          }
        });
      }
      lines2.forEach((f2) => {
        const finalThickness = f2.properties.thickness ? Number(f2.properties.thickness) : thickness;
        if (finalThickness) {
          const polygon4 = GeoUtil.thicken(f2, finalThickness);
          if (polygon4)
            polygons22.push(polygon4);
        }
      });
      lines2.splice(0, lines2.length);
    }
    return {
      extrusions: (lines2 == null ? void 0 : lines2.length) || (polygons22 == null ? void 0 : polygons22.length) ? getCollections(mergeArray(lines2, polygons22)) : null,
      polygons: (polygons22 == null ? void 0 : polygons22.length) ? getCollections(polygons22) : null,
      lines: (lines2 == null ? void 0 : lines2.length) ? getCollections(lines2) : null,
      points: (points22 == null ? void 0 : points22.length) ? getCollections(points22) : null
    };
  }, [json, thicknessEnabled, getCollections, extractOutlines, extrusionEnabled, thickness]);
  React__default.useEffect(() => {
    var _a4;
    let isMounted = true;
    const options2 = {
      colorPropName,
      iconIdPropName,
      iconUrlPropName,
      textValuePropName,
      defaultIconUrl: iconUrlIn,
      defaultIconColor: color,
      prefix: layerIdPrefix,
      getCustomIcon: customIcon
    };
    const features = [...(points2 == null ? void 0 : points2.features) || [], ...((_a4 = lines == null ? void 0 : lines.features) == null ? void 0 : _a4.filter((l2) => !!l2.properties[iconIdPropName])) || []];
    IconUtil.loadSymbolsOnMap(map5, features, options2).then((symbols2) => {
      if (isMounted) {
        setSymbols(symbols2);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [iconUrlIn, map5, layerIdPrefix, iconUrlPropName, iconIdPropName, color, colorPropName, textValuePropName, points2 == null ? void 0 : points2.features, lines == null ? void 0 : lines.features, customIcon]);
  const {
    beforeIdExtrusion,
    beforeIdFill,
    beforeIdLine,
    beforeIdPoint,
    extrusionLayerId,
    fillLayerId,
    lineLayerId,
    pointLayerId
  } = React__default.useMemo(() => {
    var _a4, _b4, _c3, _d3;
    let extrusionLayerId2 = null;
    let fillLayerId2 = null;
    let lineLayerId2 = null;
    let pointLayerId2 = null;
    let beforeIdExtrusion2;
    let beforeIdFill2;
    let beforeIdLine2;
    let beforeIdPoint2;
    if (extrusionEnabled && ((_a4 = extrusions == null ? void 0 : extrusions.features) == null ? void 0 : _a4.length)) {
      beforeIdExtrusion2 = beforeId;
      extrusionLayerId2 = `${layerIdPrefix}-extrusion`;
    }
    if (fillEnabled && ((_b4 = polygons2 == null ? void 0 : polygons2.features) == null ? void 0 : _b4.length)) {
      beforeIdFill2 = extrusionLayerId2 || beforeId;
      fillLayerId2 = `${layerIdPrefix}-fill`;
    }
    if (lineEnabled && ((_c3 = lines == null ? void 0 : lines.features) == null ? void 0 : _c3.length)) {
      beforeIdLine2 = fillLayerId2 || extrusionLayerId2 || beforeId;
      lineLayerId2 = `${layerIdPrefix}-line`;
    }
    if (pointEnabled && ((_d3 = symbols == null ? void 0 : symbols.features) == null ? void 0 : _d3.length)) {
      beforeIdPoint2 = lineLayerId2 || fillLayerId2 || extrusionLayerId2 || beforeId;
      pointLayerId2 = `${layerIdPrefix}-point`;
    }
    return {
      beforeIdExtrusion: beforeIdExtrusion2,
      beforeIdFill: beforeIdFill2,
      beforeIdLine: beforeIdLine2,
      beforeIdPoint: beforeIdPoint2,
      extrusionLayerId: extrusionLayerId2,
      fillLayerId: fillLayerId2,
      lineLayerId: lineLayerId2,
      pointLayerId: pointLayerId2
    };
  }, [beforeId, extrusionEnabled, (_a3 = extrusions == null ? void 0 : extrusions.features) == null ? void 0 : _a3.length, fillEnabled, layerIdPrefix, lineEnabled, (_b3 = lines == null ? void 0 : lines.features) == null ? void 0 : _b3.length, pointEnabled, (_c2 = polygons2 == null ? void 0 : polygons2.features) == null ? void 0 : _c2.length, (_d2 = symbols == null ? void 0 : symbols.features) == null ? void 0 : _d2.length]);
  if (!layerIdPrefix)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    extrusionEnabled && !!((_e2 = extrusions == null ? void 0 : extrusions.features) == null ? void 0 : _e2.length) && /* @__PURE__ */ jsx(GeoJsonExtrusionLayer, { id: extrusionLayerId, beforeId: beforeIdExtrusion, data: extrusions, heightPropName, color, outlineColor, colorPropName, outlinePropName, ...restProps }),
    fillEnabled && !!((_f3 = polygons2 == null ? void 0 : polygons2.features) == null ? void 0 : _f3.length) && /* @__PURE__ */ jsx(
      GeoJsonFillLayer,
      {
        id: fillLayerId,
        beforeId: beforeIdFill,
        data: polygons2,
        color,
        colorPropName,
        outlineColor: extractOutlines ? color : outlineColor,
        ...restProps
      }
    ),
    lineEnabled && !!((_g = lines == null ? void 0 : lines.features) == null ? void 0 : _g.length) && /* @__PURE__ */ jsx(GeoJsonLineLayer, { id: lineLayerId, beforeId: beforeIdLine, data: lines, heightPropName, color, outlineColor, colorPropName, outlinePropName, ...restProps }),
    pointEnabled && !!((_h = symbols == null ? void 0 : symbols.features) == null ? void 0 : _h.length) && /* @__PURE__ */ jsx(GeojsonPointLayer, { beforeId: beforeIdPoint, id: pointLayerId, data: symbols, colorPropName, outlinePropName, textColorPropName, textValuePropName, textAnchorPropName, color, outlineColor, showIcon: !!iconUrlPropName || !!iconIdPropName || !!iconUrlIn, iconSize: iconSize2, iconSizePropName, textColor: textColor2, textOpacity, textValue, textAnchor, textOffset, textBackground, showText: !!textValuePropName || !!textValue, iconIdPropName, ...restProps }, pointLayerId)
  ] });
}
GeoJsonLayerInternals.propTypes = {
  id: propTypesExports$1.string,
  sourceProps: propTypesExports$1.object,
  beforeId: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]).isRequired,
  heightPropName: propTypesExports$1.string,
  floorHeight: propTypesExports$1.number,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string,
  outlineColor: propTypesExports$1.any,
  outlinePropName: propTypesExports$1.string,
  outlineOpacity: propTypesExports$1.any,
  outlineOpacityPropName: propTypesExports$1.string,
  outlineDashArray: propTypesExports$1.arrayOf(propTypesExports$1.number),
  outlineWidthPropName: propTypesExports$1.string,
  outlineWidth: propTypesExports$1.number,
  outlineDashArrayPropName: propTypesExports$1.string,
  textColor: propTypesExports$1.any,
  textOpacity: propTypesExports$1.any,
  textValue: propTypesExports$1.any,
  textAnchor: propTypesExports$1.any,
  textOffset: propTypesExports$1.number,
  textBackground: propTypesExports$1.bool,
  textColorPropName: propTypesExports$1.string,
  textOpacityPropName: propTypesExports$1.string,
  textAnchorPropName: propTypesExports$1.string,
  textValuePropName: propTypesExports$1.string,
  extrusionEnabled: propTypesExports$1.bool,
  fillEnabled: propTypesExports$1.bool,
  outlineEnabled: propTypesExports$1.bool,
  // extract fill outline automatically
  lineEnabled: propTypesExports$1.bool,
  pointEnabled: propTypesExports$1.bool,
  thicknessEnabled: propTypesExports$1.bool,
  thickness: propTypesExports$1.number,
  customIcon: propTypesExports$1.func,
  // refer IconUtil.generateSampleCanvas
  iconIdPropName: propTypesExports$1.string,
  iconUrlPropName: propTypesExports$1.string,
  iconUrl: propTypesExports$1.string,
  iconSize: propTypesExports$1.any,
  iconSizePropName: propTypesExports$1.string
};
GeoJsonLayerInternals.defaultProps = {
  id: "",
  sourceProps: {},
  beforeId: "",
  heightPropName: "height",
  floorHeight: 3.5,
  colorPropName: "fill",
  color: "#0080ff",
  // blue color fill
  opacity: 1,
  opacityPropName: "fill-opacity",
  outlineColor: "#0080ff",
  // blue color fill
  outlinePropName: "stroke",
  outlineWidthPropName: "stroke-width",
  outlineWidth: 1,
  outlineOpacity: 1,
  outlineOpacityPropName: "stroke-opacity",
  outlineDashArray: [1, 0],
  outlineDashArrayPropName: "stroke-dasharray",
  textColor: "#000000",
  // black
  textOpacity: 1,
  textValue: "",
  textAnchor: "center",
  textOffset: 0,
  textBackground: false,
  textAnchorPropName: "",
  textValuePropName: "text-value",
  textColorPropName: "text-color",
  textOpacityPropName: "text-opacity",
  extrusionEnabled: false,
  fillEnabled: false,
  outlineEnabled: false,
  lineEnabled: false,
  pointEnabled: false,
  thicknessEnabled: false,
  thickness: 0.4,
  // in meters
  customIcon: null,
  iconIdPropName: "marker-symbol-id",
  // one of two (marker-symbol-id or marker-symbol) can be provided to render the custom marker
  iconUrlPropName: "marker-symbol",
  iconUrl: "",
  iconSize: void 0,
  iconSizePropName: "marker-size"
};
function GeoJsonLayer(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { children: /* @__PURE__ */ jsx(GeoJsonLayerInternals, { ...props }) });
}
const getRandomHex = (level) => {
  const even = level % 2;
  const palette = ["#cfecf7", "#a0d9ef"];
  return palette[even];
};
function FlooredBuildingInternals(props) {
  var _a3;
  const {
    data: dataIn,
    buildingHeight,
    floorHeight,
    floorElevation,
    heightPropName,
    elevationPropName,
    opacityPropName,
    colorPropName,
    color,
    getLevel: getLevel2,
    missingFloorColor,
    singleFloorActive,
    ...restProps
  } = props;
  const counterRef = React__default.useRef(0);
  const missingFloorElevationRef = React__default.useRef(0);
  const missingFloorHeightRef = React__default.useRef(0);
  const createNewMissingFeature = React__default.useCallback((feature2, height, elevation) => {
    if (!feature2 || singleFloorActive)
      return null;
    const newFeature = JSON.parse(JSON.stringify(feature2));
    counterRef.current += 1;
    newFeature.id = counterRef.current;
    newFeature.properties[elevationPropName] = elevation;
    newFeature.properties[heightPropName] = height;
    newFeature.properties[colorPropName] = missingFloorColor;
    newFeature.properties.isMissingFloor = true;
    return newFeature;
  }, [colorPropName, elevationPropName, heightPropName, singleFloorActive, missingFloorColor]);
  const onMissingTopFloor = React__default.useCallback((feature2, missingFeatures) => {
    if (!feature2 || singleFloorActive)
      return;
    missingFloorElevationRef.current = feature2.properties[heightPropName];
    missingFloorHeightRef.current = buildingHeight;
    if (missingFloorHeightRef.current - missingFloorElevationRef.current > 0.5 * floorHeight) {
      const newFeature = createNewMissingFeature(feature2, missingFloorHeightRef.current, missingFloorElevationRef.current);
      if (newFeature)
        missingFeatures.push(newFeature);
    }
  }, [singleFloorActive, heightPropName, buildingHeight, floorHeight, createNewMissingFeature]);
  const onMissingFeature = React__default.useCallback((feature2, missingFeatures) => {
    if (!feature2 || singleFloorActive)
      return;
    missingFloorHeightRef.current = feature2.properties[elevationPropName];
    if (Math.abs(missingFloorHeightRef.current - missingFloorElevationRef.current) > floorHeight * 0.5) {
      const newFeature = createNewMissingFeature(feature2, missingFloorHeightRef.current, missingFloorElevationRef.current);
      if (newFeature)
        missingFeatures.push(newFeature);
    }
    missingFloorElevationRef.current = feature2.properties[heightPropName];
  }, [createNewMissingFeature, elevationPropName, floorHeight, heightPropName, singleFloorActive]);
  const onLastFeature = React__default.useCallback((features) => {
    if (singleFloorActive)
      return;
    missingFloorElevationRef.current = 0;
    missingFloorHeightRef.current = 0;
    features.sort((a2, b2) => a2.properties[elevationPropName] - b2.properties[elevationPropName]);
    const missingFeatures = [];
    features.forEach((feature2) => {
      onMissingFeature(feature2, missingFeatures);
    });
    const lastFeatureIndex = features.length - 1;
    if (lastFeatureIndex > -1)
      onMissingTopFloor(features[lastFeatureIndex], missingFeatures);
    if (missingFeatures.length)
      features.push(...missingFeatures);
  }, [elevationPropName, singleFloorActive, onMissingFeature, onMissingTopFloor]);
  const onFeature = React__default.useCallback((feature2) => {
    if (feature2) {
      let level = 0;
      if (getLevel2) {
        level = getLevel2(feature2);
      }
      if (typeof feature2.id === "undefined") {
        counterRef.current += 1;
        feature2.id = counterRef.current;
      }
      if (singleFloorActive) {
        feature2.properties[elevationPropName] = 0;
      }
      if (typeof feature2.properties[elevationPropName] === "undefined") {
        feature2.properties[elevationPropName] = level * floorHeight;
      }
      if (typeof feature2.properties[heightPropName] === "undefined") {
        feature2.properties[heightPropName] = (level + 1) * floorHeight;
      }
      if (typeof feature2.properties[colorPropName] === "undefined") {
        feature2.properties[colorPropName] = color === "random" ? getRandomHex(level) : color;
      }
      if (typeof feature2.properties[opacityPropName] === "undefined") {
        feature2.properties[opacityPropName] = 0.3;
      }
    }
  }, [color, colorPropName, elevationPropName, floorHeight, getLevel2, heightPropName, singleFloorActive, opacityPropName]);
  const data2 = useEditGeojson({
    data: dataIn,
    onFeature,
    onAllFeatures: onLastFeature
  });
  return /* @__PURE__ */ jsx(Fragment, { children: singleFloorActive ? (_a3 = data2 == null ? void 0 : data2.features) == null ? void 0 : _a3.map((feature2) => /* @__PURE__ */ jsx(GeoJsonLayer, { id: `${feature2.id}-3d`, data: data2, extrusionEnabled: true, thicknessEnabled: true, pointEnabled: true, color, colorPropName, opacityPropName }, `levels-view-3d-${feature2.id}`)) : /* @__PURE__ */ jsx(GeoJsonExtrusionLayer, { data: data2, ...restProps, height: floorHeight, elevation: floorElevation, heightPropName, elevationPropName, colorPropName, opacityPropName }) });
}
FlooredBuildingInternals.propTypes = {
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]).isRequired,
  buildingHeight: propTypesExports$1.number,
  floorHeight: propTypesExports$1.number,
  floorElevation: propTypesExports$1.number,
  getLevel: propTypesExports$1.func,
  heightPropName: propTypesExports$1.string,
  // cumulative i.e. above ground
  elevationPropName: propTypesExports$1.string,
  // cumulative i.e. above ground
  colorPropName: propTypesExports$1.string,
  opacityPropName: propTypesExports$1.string,
  color: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  missingFloorColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  singleFloorActive: propTypesExports$1.bool
};
FlooredBuildingInternals.defaultProps = {
  buildingHeight: 4,
  floorHeight: 4,
  floorElevation: 0,
  getLevel: null,
  heightPropName: "height",
  elevationPropName: "base_height",
  colorPropName: "color",
  opacityPropName: "opacity",
  color: null,
  missingFloorColor: "#f5fefd",
  singleFloorActive: false
};
function FlooredBuilding(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { children: /* @__PURE__ */ jsx(FlooredBuildingInternals, { ...props }) });
}
const Countries$1 = [
  {
    id: 1,
    name: "Afghanistan",
    iso3: "AFG",
    iso2: "AF",
    latitude: "33.00000000",
    longitude: "65.00000000",
    bounding_box: [
      60.5176034,
      29.3772,
      74.889862,
      38.4910682
    ]
  },
  {
    id: 2,
    name: "Aland Islands",
    iso3: "ALA",
    iso2: "AX",
    latitude: "60.11666700",
    longitude: "19.90000000",
    bounding_box: [
      19.0832098,
      59.4541578,
      21.3456556,
      60.87665
    ]
  },
  {
    id: 3,
    name: "Albania",
    iso3: "ALB",
    iso2: "AL",
    latitude: "41.00000000",
    longitude: "20.00000000",
    bounding_box: [
      19.1246095,
      39.6448625,
      21.0574335,
      42.6610848
    ]
  },
  {
    id: 4,
    name: "Algeria",
    iso3: "DZA",
    iso2: "DZ",
    latitude: "28.00000000",
    longitude: "3.00000000",
    bounding_box: [
      -8.668908,
      18.968147,
      11.997337,
      37.2962055
    ]
  },
  {
    id: 5,
    name: "American Samoa",
    iso3: "ASM",
    iso2: "AS",
    latitude: "-14.33333333",
    longitude: "-170.00000000",
    bounding_box: [
      -171.2951296,
      -14.7608358,
      -167.9322899,
      -10.8449746
    ]
  },
  {
    id: 6,
    name: "Andorra",
    iso3: "AND",
    iso2: "AD",
    latitude: "42.50000000",
    longitude: "1.50000000",
    bounding_box: [
      1.4135781,
      42.4288238,
      1.7863837,
      42.6559357
    ]
  },
  {
    id: 7,
    name: "Angola",
    iso3: "AGO",
    iso2: "AO",
    latitude: "-12.50000000",
    longitude: "18.50000000",
    bounding_box: [
      11.4609793,
      -18.038945,
      24.0878856,
      -4.3880634
    ]
  },
  {
    id: 8,
    name: "Anguilla",
    iso3: "AIA",
    iso2: "AI",
    latitude: "18.25000000",
    longitude: "-63.16666666",
    bounding_box: [
      -63.6391992,
      18.0615454,
      -62.7125449,
      18.7951194
    ]
  },
  {
    id: 9,
    name: "Antarctica",
    iso3: "ATA",
    iso2: "AQ",
    latitude: "-74.65000000",
    longitude: "4.48000000",
    bounding_box: [
      -180,
      -85.0511287,
      180,
      -60
    ]
  },
  {
    id: 10,
    name: "Antigua And Barbuda",
    iso3: "ATG",
    iso2: "AG",
    latitude: "17.05000000",
    longitude: "-61.80000000",
    bounding_box: [
      -62.5536517,
      16.7573901,
      -61.447857,
      17.929
    ]
  },
  {
    id: 11,
    name: "Argentina",
    iso3: "ARG",
    iso2: "AR",
    latitude: "-34.00000000",
    longitude: "-64.00000000",
    bounding_box: [
      -73.5600329,
      -55.1850761,
      -53.6374515,
      -21.781168
    ]
  },
  {
    id: 12,
    name: "Armenia",
    iso3: "ARM",
    iso2: "AM",
    latitude: "40.00000000",
    longitude: "45.00000000",
    bounding_box: [
      43.4471395,
      38.8404775,
      46.6333087,
      41.300712
    ]
  },
  {
    id: 13,
    name: "Aruba",
    iso3: "ABW",
    iso2: "AW",
    latitude: "12.50000000",
    longitude: "-69.96666666",
    bounding_box: [
      -70.2809842,
      12.1702998,
      -69.6409842,
      12.8102998
    ]
  },
  {
    id: 14,
    name: "Australia",
    iso3: "AUS",
    iso2: "AU",
    latitude: "-27.00000000",
    longitude: "133.00000000",
    bounding_box: [
      72.2460938,
      -55.3228175,
      168.2249543,
      -9.0882278
    ]
  },
  {
    id: 15,
    name: "Austria",
    iso3: "AUT",
    iso2: "AT",
    latitude: "47.33333333",
    longitude: "13.33333333",
    bounding_box: [
      9.5307487,
      46.3722761,
      17.160776,
      49.0205305
    ]
  },
  {
    id: 16,
    name: "Azerbaijan",
    iso3: "AZE",
    iso2: "AZ",
    latitude: "40.50000000",
    longitude: "47.50000000",
    bounding_box: [
      44.7633701,
      38.3929551,
      51.0090302,
      41.9502947
    ]
  },
  {
    id: 18,
    name: "Bahrain",
    iso3: "BHR",
    iso2: "BH",
    latitude: "26.00000000",
    longitude: "50.55000000",
    bounding_box: [
      50.2697989,
      25.535,
      50.9233693,
      26.6872444
    ]
  },
  {
    id: 19,
    name: "Bangladesh",
    iso3: "BGD",
    iso2: "BD",
    latitude: "24.00000000",
    longitude: "90.00000000",
    bounding_box: [
      88.0075306,
      20.3756582,
      92.6804979,
      26.6382534
    ]
  },
  {
    id: 20,
    name: "Barbados",
    iso3: "BRB",
    iso2: "BB",
    latitude: "13.16666666",
    longitude: "-59.53333333",
    bounding_box: [
      -59.8562115,
      12.845,
      -59.2147175,
      13.535
    ]
  },
  {
    id: 21,
    name: "Belarus",
    iso3: "BLR",
    iso2: "BY",
    latitude: "53.00000000",
    longitude: "28.00000000",
    bounding_box: [
      23.1783344,
      51.2575982,
      32.7627809,
      56.17218
    ]
  },
  {
    id: 22,
    name: "Belgium",
    iso3: "BEL",
    iso2: "BE",
    latitude: "50.83333333",
    longitude: "4.00000000",
    bounding_box: [
      2.3889137,
      49.4969821,
      6.408097,
      51.5516667
    ]
  },
  {
    id: 23,
    name: "Belize",
    iso3: "BLZ",
    iso2: "BZ",
    latitude: "17.25000000",
    longitude: "-88.75000000",
    bounding_box: [
      -89.2262083,
      15.8857286,
      -87.3098494,
      18.496001
    ]
  },
  {
    id: 24,
    name: "Benin",
    iso3: "BEN",
    iso2: "BJ",
    latitude: "9.50000000",
    longitude: "2.25000000",
    bounding_box: [
      0.776667,
      6.0398696,
      3.843343,
      12.4092447
    ]
  },
  {
    id: 25,
    name: "Bermuda",
    iso3: "BMU",
    iso2: "BM",
    latitude: "32.33333333",
    longitude: "-64.75000000",
    bounding_box: [
      -65.1232222,
      32.0469651,
      -64.4109842,
      32.5913693
    ]
  },
  {
    id: 26,
    name: "Bhutan",
    iso3: "BTN",
    iso2: "BT",
    latitude: "27.50000000",
    longitude: "90.50000000",
    bounding_box: [
      88.7464724,
      26.702016,
      92.1252321,
      28.246987
    ]
  },
  {
    id: 27,
    name: "Bolivia",
    iso3: "BOL",
    iso2: "BO",
    latitude: "-17.00000000",
    longitude: "-65.00000000",
    bounding_box: [
      -69.6450073,
      -22.8982742,
      -57.453,
      -9.6689438
    ]
  },
  {
    id: 155,
    name: "Bonaire, Sint Eustatius and Saba",
    iso3: "BES",
    iso2: "BQ",
    latitude: "12.15000000",
    longitude: "-68.26666700"
  },
  {
    id: 28,
    name: "Bosnia and Herzegovina",
    iso3: "BIH",
    iso2: "BA",
    latitude: "44.00000000",
    longitude: "18.00000000",
    bounding_box: [
      15.7287433,
      42.5553114,
      19.6237311,
      45.2764135
    ]
  },
  {
    id: 29,
    name: "Botswana",
    iso3: "BWA",
    iso2: "BW",
    latitude: "-22.00000000",
    longitude: "24.00000000",
    bounding_box: [
      19.9986474,
      -26.9059669,
      29.375304,
      -17.778137
    ]
  },
  {
    id: 30,
    name: "Bouvet Island",
    iso3: "BVT",
    iso2: "BV",
    latitude: "-54.43333333",
    longitude: "3.40000000",
    bounding_box: [
      2.9345531,
      -54.654,
      3.7791099,
      -54.187
    ]
  },
  {
    id: 31,
    name: "Brazil",
    iso3: "BRA",
    iso2: "BR",
    latitude: "-10.00000000",
    longitude: "-55.00000000",
    bounding_box: [
      -73.9830625,
      -33.8689056,
      -28.6341164,
      5.2842873
    ]
  },
  {
    id: 32,
    name: "British Indian Ocean Territory",
    iso3: "IOT",
    iso2: "IO",
    latitude: "-6.00000000",
    longitude: "71.50000000",
    bounding_box: [
      71.036504,
      -7.6454079,
      72.7020157,
      -5.037066
    ]
  },
  {
    id: 33,
    name: "Brunei",
    iso3: "BRN",
    iso2: "BN",
    latitude: "4.50000000",
    longitude: "114.66666666",
    bounding_box: [
      114.0758734,
      4.002508,
      115.3635623,
      5.1011857
    ]
  },
  {
    id: 34,
    name: "Bulgaria",
    iso3: "BGR",
    iso2: "BG",
    latitude: "43.00000000",
    longitude: "25.00000000",
    bounding_box: [
      22.3571459,
      41.2353929,
      28.8875409,
      44.2167064
    ]
  },
  {
    id: 35,
    name: "Burkina Faso",
    iso3: "BFA",
    iso2: "BF",
    latitude: "13.00000000",
    longitude: "-2.00000000",
    bounding_box: [
      -5.5132416,
      9.4104718,
      2.4089717,
      15.084
    ]
  },
  {
    id: 36,
    name: "Burundi",
    iso3: "BDI",
    iso2: "BI",
    latitude: "-3.50000000",
    longitude: "30.00000000",
    bounding_box: [
      29.0007401,
      -4.4693155,
      30.8498462,
      -2.3096796
    ]
  },
  {
    id: 37,
    name: "Cambodia",
    iso3: "KHM",
    iso2: "KH",
    latitude: "13.00000000",
    longitude: "105.00000000",
    bounding_box: [
      102.3338282,
      9.4752639,
      107.6276788,
      14.6904224
    ]
  },
  {
    id: 38,
    name: "Cameroon",
    iso3: "CMR",
    iso2: "CM",
    latitude: "6.00000000",
    longitude: "12.00000000",
    bounding_box: [
      8.3822176,
      1.6546659,
      16.1921476,
      13.083333
    ]
  },
  {
    id: 39,
    name: "Canada",
    iso3: "CAN",
    iso2: "CA",
    latitude: "60.00000000",
    longitude: "-95.00000000",
    bounding_box: [
      -141.00275,
      41.6765556,
      -52.3231981,
      83.3362128
    ]
  },
  {
    id: 40,
    name: "Cape Verde",
    iso3: "CPV",
    iso2: "CV",
    latitude: "16.00000000",
    longitude: "-24.00000000",
    bounding_box: [
      -25.3609478,
      14.8031546,
      -22.6673416,
      17.2053108
    ]
  },
  {
    id: 41,
    name: "Cayman Islands",
    iso3: "CYM",
    iso2: "KY",
    latitude: "19.50000000",
    longitude: "-80.50000000",
    bounding_box: [
      -81.6313748,
      19.0620619,
      -79.5110954,
      19.9573759
    ]
  },
  {
    id: 42,
    name: "Central African Republic",
    iso3: "CAF",
    iso2: "CF",
    latitude: "7.00000000",
    longitude: "21.00000000",
    bounding_box: [
      14.4155426,
      2.2156553,
      27.4540764,
      11.001389
    ]
  },
  {
    id: 43,
    name: "Chad",
    iso3: "TCD",
    iso2: "TD",
    latitude: "15.00000000",
    longitude: "19.00000000",
    bounding_box: [
      13.47348,
      7.44107,
      24,
      23.4975
    ]
  },
  {
    id: 44,
    name: "Chile",
    iso3: "CHL",
    iso2: "CL",
    latitude: "-30.00000000",
    longitude: "-71.00000000",
    bounding_box: [
      -109.6795789,
      -56.725,
      -66.0753474,
      -17.4983998
    ]
  },
  {
    id: 45,
    name: "China",
    iso3: "CHN",
    iso2: "CN",
    latitude: "35.00000000",
    longitude: "105.00000000",
    bounding_box: [
      73.4997347,
      8.8383436,
      134.7754563,
      53.5608154
    ]
  },
  {
    id: 46,
    name: "Christmas Island",
    iso3: "CXR",
    iso2: "CX",
    latitude: "-10.50000000",
    longitude: "105.66666666",
    bounding_box: [
      105.5336422,
      -10.5698515,
      105.7130159,
      -10.4123553
    ]
  },
  {
    id: 47,
    name: "Cocos (Keeling) Islands",
    iso3: "CCK",
    iso2: "CC",
    latitude: "-12.50000000",
    longitude: "96.83333333",
    bounding_box: [
      96.612524,
      -12.4055983,
      97.1357343,
      -11.6213132
    ]
  },
  {
    id: 48,
    name: "Colombia",
    iso3: "COL",
    iso2: "CO",
    latitude: "4.00000000",
    longitude: "-72.00000000",
    bounding_box: [
      -82.1243666,
      -4.2316872,
      -66.8511907,
      16.0571269
    ]
  },
  {
    id: 49,
    name: "Comoros",
    iso3: "COM",
    iso2: "KM",
    latitude: "-12.16666666",
    longitude: "44.25000000",
    bounding_box: [
      43.025305,
      -12.621,
      44.7451922,
      -11.165
    ]
  },
  {
    id: 50,
    name: "Congo",
    iso3: "COG",
    iso2: "CG",
    latitude: "-1.00000000",
    longitude: "15.00000000",
    bounding_box: [
      11.0048205,
      -5.149089,
      18.643611,
      3.713056
    ]
  },
  {
    id: 52,
    name: "Cook Islands",
    iso3: "COK",
    iso2: "CK",
    latitude: "-21.23333333",
    longitude: "-159.76666666",
    bounding_box: [
      -166.0856468,
      -22.15807,
      -157.1089329,
      -8.7168792
    ]
  },
  {
    id: 53,
    name: "Costa Rica",
    iso3: "CRI",
    iso2: "CR",
    latitude: "10.00000000",
    longitude: "-84.00000000",
    bounding_box: [
      -87.2722647,
      5.3329698,
      -82.5060208,
      11.2195684
    ]
  },
  {
    id: 54,
    name: "Cote D'Ivoire (Ivory Coast)",
    iso3: "CIV",
    iso2: "CI",
    latitude: "8.00000000",
    longitude: "-5.00000000",
    bounding_box: [
      -8.601725,
      4.1621205,
      -2.493031,
      10.740197
    ]
  },
  {
    id: 55,
    name: "Croatia",
    iso3: "HRV",
    iso2: "HR",
    latitude: "45.16666666",
    longitude: "15.50000000",
    bounding_box: [
      13.2104814,
      42.1765993,
      19.4470842,
      46.555029
    ]
  },
  {
    id: 56,
    name: "Cuba",
    iso3: "CUB",
    iso2: "CU",
    latitude: "21.50000000",
    longitude: "-80.00000000",
    bounding_box: [
      -85.1679702,
      19.6275294,
      -73.9190004,
      23.4816972
    ]
  },
  {
    id: 249,
    name: "Curaçao",
    iso3: "CUW",
    iso2: "CW",
    latitude: "12.11666700",
    longitude: "-68.93333300"
  },
  {
    id: 57,
    name: "Cyprus",
    iso3: "CYP",
    iso2: "CY",
    latitude: "35.00000000",
    longitude: "33.00000000",
    bounding_box: [
      32.0227581,
      34.4383706,
      34.8553182,
      35.913252
    ]
  },
  {
    id: 58,
    name: "Czech Republic",
    iso3: "CZE",
    iso2: "CZ",
    latitude: "49.75000000",
    longitude: "15.50000000",
    bounding_box: [
      12.0905901,
      48.5518083,
      18.859216,
      51.0557036
    ]
  },
  {
    id: 51,
    name: "Democratic Republic of the Congo",
    iso3: "COD",
    iso2: "CD",
    latitude: "0.00000000",
    longitude: "25.00000000",
    bounding_box: [
      12.039074,
      -13.459035,
      31.3056758,
      5.3920026
    ]
  },
  {
    id: 59,
    name: "Denmark",
    iso3: "DNK",
    iso2: "DK",
    latitude: "56.00000000",
    longitude: "10.00000000",
    bounding_box: [
      7.7153255,
      54.4516667,
      15.5530641,
      57.9524297
    ]
  },
  {
    id: 60,
    name: "Djibouti",
    iso3: "DJI",
    iso2: "DJ",
    latitude: "11.50000000",
    longitude: "43.00000000",
    bounding_box: [
      41.7713139,
      10.9149547,
      43.6579046,
      12.7923081
    ]
  },
  {
    id: 61,
    name: "Dominica",
    iso3: "DMA",
    iso2: "DM",
    latitude: "15.41666666",
    longitude: "-61.33333333",
    bounding_box: [
      -61.6869184,
      15.0074207,
      -61.0329895,
      15.7872222
    ]
  },
  {
    id: 62,
    name: "Dominican Republic",
    iso3: "DOM",
    iso2: "DO",
    latitude: "19.00000000",
    longitude: "-70.66666666",
    bounding_box: [
      -72.0574706,
      17.2701708,
      -68.1101463,
      21.303433
    ]
  },
  {
    id: 63,
    name: "East Timor",
    iso3: "TLS",
    iso2: "TL",
    latitude: "-8.83333333",
    longitude: "125.91666666",
    bounding_box: [
      124.0415703,
      -9.5642775,
      127.5335392,
      -8.0895459
    ]
  },
  {
    id: 64,
    name: "Ecuador",
    iso3: "ECU",
    iso2: "EC",
    latitude: "-2.00000000",
    longitude: "-77.50000000",
    bounding_box: [
      -92.2072392,
      -5.0159314,
      -75.192504,
      1.8835964
    ]
  },
  {
    id: 65,
    name: "Egypt",
    iso3: "EGY",
    iso2: "EG",
    latitude: "27.00000000",
    longitude: "30.00000000",
    bounding_box: [
      24.6499112,
      22,
      37.1153517,
      31.8330854
    ]
  },
  {
    id: 66,
    name: "El Salvador",
    iso3: "SLV",
    iso2: "SV",
    latitude: "13.83333333",
    longitude: "-88.91666666",
    bounding_box: [
      -90.1790975,
      12.976046,
      -87.6351394,
      14.4510488
    ]
  },
  {
    id: 67,
    name: "Equatorial Guinea",
    iso3: "GNQ",
    iso2: "GQ",
    latitude: "2.00000000",
    longitude: "10.00000000",
    bounding_box: [
      5.4172943,
      -1.6732196,
      11.3598628,
      3.989
    ]
  },
  {
    id: 68,
    name: "Eritrea",
    iso3: "ERI",
    iso2: "ER",
    latitude: "15.00000000",
    longitude: "39.00000000",
    bounding_box: [
      36.4333653,
      12.3548219,
      43.3001714,
      18.0709917
    ]
  },
  {
    id: 69,
    name: "Estonia",
    iso3: "EST",
    iso2: "EE",
    latitude: "59.00000000",
    longitude: "26.00000000",
    bounding_box: [
      21.3826069,
      57.5092997,
      28.2100175,
      59.9383754
    ]
  },
  {
    id: 70,
    name: "Ethiopia",
    iso3: "ETH",
    iso2: "ET",
    latitude: "8.00000000",
    longitude: "38.00000000",
    bounding_box: [
      32.9975838,
      3.397448,
      47.9823797,
      14.8940537
    ]
  },
  {
    id: 71,
    name: "Falkland Islands",
    iso3: "FLK",
    iso2: "FK",
    latitude: "-51.75000000",
    longitude: "-59.00000000",
    bounding_box: [
      -61.7726772,
      -53.1186766,
      -57.3662367,
      -50.7973007
    ]
  },
  {
    id: 72,
    name: "Faroe Islands",
    iso3: "FRO",
    iso2: "FO",
    latitude: "62.00000000",
    longitude: "-7.00000000",
    bounding_box: [
      -7.6882939,
      61.3915553,
      -6.2565525,
      62.3942991
    ]
  },
  {
    id: 73,
    name: "Fiji Islands",
    iso3: "FJI",
    iso2: "FJ",
    latitude: "-18.00000000",
    longitude: "175.00000000",
    bounding_box: [
      172,
      -21.9434274,
      -178.5,
      -12.2613866
    ]
  },
  {
    id: 74,
    name: "Finland",
    iso3: "FIN",
    iso2: "FI",
    latitude: "64.00000000",
    longitude: "26.00000000",
    bounding_box: [
      19.0832098,
      59.4541578,
      31.5867071,
      70.0922939
    ]
  },
  {
    id: 75,
    name: "France",
    iso3: "FRA",
    iso2: "FR",
    latitude: "46.00000000",
    longitude: "2.00000000",
    bounding_box: [
      -5.4534286,
      41.2632185,
      9.8678344,
      51.268318
    ]
  },
  {
    id: 76,
    name: "French Guiana",
    iso3: "GUF",
    iso2: "GF",
    latitude: "4.00000000",
    longitude: "-53.00000000",
    bounding_box: [
      -54.60278,
      2.112222,
      -51.6346139,
      5.7507111
    ]
  },
  {
    id: 77,
    name: "French Polynesia",
    iso3: "PYF",
    iso2: "PF",
    latitude: "-15.00000000",
    longitude: "-140.00000000",
    bounding_box: [
      -154.9360599,
      -28.0990232,
      -134.244799,
      -7.6592173
    ]
  },
  {
    id: 78,
    name: "French Southern Territories",
    iso3: "ATF",
    iso2: "TF",
    latitude: "-49.25000000",
    longitude: "69.16700000",
    bounding_box: [
      39.4138676,
      -50.2187169,
      77.8494974,
      -11.3139928
    ]
  },
  {
    id: 79,
    name: "Gabon",
    iso3: "GAB",
    iso2: "GA",
    latitude: "-1.00000000",
    longitude: "11.75000000",
    bounding_box: [
      8.5002246,
      -4.1012261,
      14.539444,
      2.3182171
    ]
  },
  {
    id: 80,
    name: "Gambia The",
    iso3: "GMB",
    iso2: "GM",
    latitude: "13.46666666",
    longitude: "-16.56666666",
    bounding_box: [
      -17.0288254,
      13.061,
      -13.797778,
      13.8253137
    ]
  },
  {
    id: 81,
    name: "Georgia",
    iso3: "GEO",
    iso2: "GE",
    latitude: "42.00000000",
    longitude: "43.50000000",
    bounding_box: [
      39.8844803,
      41.0552922,
      46.7365373,
      43.5864294
    ]
  },
  {
    id: 82,
    name: "Germany",
    iso3: "DEU",
    iso2: "DE",
    latitude: "51.00000000",
    longitude: "9.00000000",
    bounding_box: [
      5.8663153,
      47.2701114,
      15.0419319,
      55.099161
    ]
  },
  {
    id: 83,
    name: "Ghana",
    iso3: "GHA",
    iso2: "GH",
    latitude: "8.00000000",
    longitude: "-2.00000000",
    bounding_box: [
      -3.260786,
      4.5392525,
      1.2732942,
      11.1748562
    ]
  },
  {
    id: 84,
    name: "Gibraltar",
    iso3: "GIB",
    iso2: "GI",
    latitude: "36.13333333",
    longitude: "-5.35000000",
    bounding_box: [
      -5.3941295,
      36.100807,
      -5.3141295,
      36.180807
    ]
  },
  {
    id: 85,
    name: "Greece",
    iso3: "GRC",
    iso2: "GR",
    latitude: "39.00000000",
    longitude: "22.00000000",
    bounding_box: [
      19.2477876,
      34.7006096,
      29.7296986,
      41.7488862
    ]
  },
  {
    id: 86,
    name: "Greenland",
    iso3: "GRL",
    iso2: "GL",
    latitude: "72.00000000",
    longitude: "-40.00000000",
    bounding_box: [
      -74.1250416,
      59.515387,
      -10.0288759,
      83.875172
    ]
  },
  {
    id: 87,
    name: "Grenada",
    iso3: "GRD",
    iso2: "GD",
    latitude: "12.11666666",
    longitude: "-61.66666666",
    bounding_box: [
      -62.0065868,
      11.786,
      -61.1732143,
      12.5966532
    ]
  },
  {
    id: 88,
    name: "Guadeloupe",
    iso3: "GLP",
    iso2: "GP",
    latitude: "16.25000000",
    longitude: "-61.58333300",
    bounding_box: [
      -61.809764,
      15.8320085,
      -61.0003663,
      16.5144664
    ]
  },
  {
    id: 89,
    name: "Guam",
    iso3: "GUM",
    iso2: "GU",
    latitude: "13.46666666",
    longitude: "144.78333333",
    bounding_box: [
      144.563426,
      13.182335,
      145.009167,
      13.706179
    ]
  },
  {
    id: 90,
    name: "Guatemala",
    iso3: "GTM",
    iso2: "GT",
    latitude: "15.50000000",
    longitude: "-90.25000000",
    bounding_box: [
      -92.3105242,
      13.6345804,
      -88.1755849,
      17.8165947
    ]
  },
  {
    id: 91,
    name: "Guernsey and Alderney",
    iso3: "GGY",
    iso2: "GG",
    latitude: "49.46666666",
    longitude: "-2.58333333",
    bounding_box: [
      -2.6751703,
      49.4155331,
      -2.501814,
      49.5090776
    ]
  },
  {
    id: 92,
    name: "Guinea",
    iso3: "GIN",
    iso2: "GN",
    latitude: "11.00000000",
    longitude: "-10.00000000",
    bounding_box: [
      -15.5680508,
      7.1906045,
      -7.6381993,
      12.67563
    ]
  },
  {
    id: 93,
    name: "Guinea-Bissau",
    iso3: "GNB",
    iso2: "GW",
    latitude: "12.00000000",
    longitude: "-15.00000000",
    bounding_box: [
      -16.894523,
      10.6514215,
      -13.6348777,
      12.6862384
    ]
  },
  {
    id: 94,
    name: "Guyana",
    iso3: "GUY",
    iso2: "GY",
    latitude: "5.00000000",
    longitude: "-59.00000000",
    bounding_box: [
      -61.414905,
      1.1710017,
      -56.4689543,
      8.6038842
    ]
  },
  {
    id: 95,
    name: "Haiti",
    iso3: "HTI",
    iso2: "HT",
    latitude: "19.00000000",
    longitude: "-72.41666666",
    bounding_box: [
      -75.2384618,
      17.9099291,
      -71.6217461,
      20.2181368
    ]
  },
  {
    id: 96,
    name: "Heard Island and McDonald Islands",
    iso3: "HMD",
    iso2: "HM",
    latitude: "-53.10000000",
    longitude: "72.51666666",
    bounding_box: [
      72.2460938,
      -53.394741,
      74.1988754,
      -52.7030677
    ]
  },
  {
    id: 97,
    name: "Honduras",
    iso3: "HND",
    iso2: "HN",
    latitude: "15.00000000",
    longitude: "-86.50000000",
    bounding_box: [
      -89.3568207,
      12.9808485,
      -82.1729621,
      17.619526
    ]
  },
  {
    id: 98,
    name: "Hong Kong S.A.R.",
    iso3: "HKG",
    iso2: "HK",
    latitude: "22.25000000",
    longitude: "114.16666666",
    bounding_box: [
      114.0028131,
      22.1193278,
      114.3228131,
      22.4393278
    ]
  },
  {
    id: 99,
    name: "Hungary",
    iso3: "HUN",
    iso2: "HU",
    latitude: "47.00000000",
    longitude: "20.00000000",
    bounding_box: [
      16.1138867,
      45.737128,
      22.8977094,
      48.585257
    ]
  },
  {
    id: 100,
    name: "Iceland",
    iso3: "ISL",
    iso2: "IS",
    latitude: "65.00000000",
    longitude: "-18.00000000",
    bounding_box: [
      -25.0135069,
      63.0859177,
      -12.8046162,
      67.353
    ]
  },
  {
    id: 101,
    name: "India",
    iso3: "IND",
    iso2: "IN",
    latitude: "20.00000000",
    longitude: "77.00000000",
    bounding_box: [
      68.1113787,
      6.5546079,
      97.395561,
      35.6745457
    ]
  },
  {
    id: 102,
    name: "Indonesia",
    iso3: "IDN",
    iso2: "ID",
    latitude: "-5.00000000",
    longitude: "120.00000000",
    bounding_box: [
      94.7717124,
      -11.2085669,
      141.0194444,
      6.2744496
    ]
  },
  {
    id: 103,
    name: "Iran",
    iso3: "IRN",
    iso2: "IR",
    latitude: "32.00000000",
    longitude: "53.00000000",
    bounding_box: [
      44.0318908,
      24.8465103,
      63.3332704,
      39.7816502
    ]
  },
  {
    id: 104,
    name: "Iraq",
    iso3: "IRQ",
    iso2: "IQ",
    latitude: "33.00000000",
    longitude: "44.00000000",
    bounding_box: [
      38.7936719,
      29.0585661,
      48.8412702,
      37.380932
    ]
  },
  {
    id: 105,
    name: "Ireland",
    iso3: "IRL",
    iso2: "IE",
    latitude: "53.00000000",
    longitude: "-8.00000000",
    bounding_box: [
      -11.0133788,
      51.222,
      -5.6582363,
      55.636
    ]
  },
  {
    id: 106,
    name: "Israel",
    iso3: "ISR",
    iso2: "IL",
    latitude: "31.50000000",
    longitude: "34.75000000",
    bounding_box: [
      34.2674994,
      29.4533796,
      35.8950234,
      33.3356317
    ]
  },
  {
    id: 107,
    name: "Italy",
    iso3: "ITA",
    iso2: "IT",
    latitude: "42.83333333",
    longitude: "12.83333333",
    bounding_box: [
      6.6272658,
      35.2889616,
      18.7844746,
      47.0921462
    ]
  },
  {
    id: 108,
    name: "Jamaica",
    iso3: "JAM",
    iso2: "JM",
    latitude: "18.25000000",
    longitude: "-77.50000000",
    bounding_box: [
      -78.5782366,
      16.5899443,
      -75.7541143,
      18.7256394
    ]
  },
  {
    id: 109,
    name: "Japan",
    iso3: "JPN",
    iso2: "JP",
    latitude: "36.00000000",
    longitude: "138.00000000",
    bounding_box: [
      122.7141754,
      20.2145811,
      154.205541,
      45.7112046
    ]
  },
  {
    id: 110,
    name: "Jersey",
    iso3: "JEY",
    iso2: "JE",
    latitude: "49.25000000",
    longitude: "-2.16666666",
    bounding_box: [
      -2.254512,
      49.1625179,
      -2.0104193,
      49.2621288
    ]
  },
  {
    id: 111,
    name: "Jordan",
    iso3: "JOR",
    iso2: "JO",
    latitude: "31.00000000",
    longitude: "36.00000000",
    bounding_box: [
      34.8844372,
      29.183401,
      39.3012981,
      33.3750617
    ]
  },
  {
    id: 112,
    name: "Kazakhstan",
    iso3: "KAZ",
    iso2: "KZ",
    latitude: "48.00000000",
    longitude: "68.00000000",
    bounding_box: [
      46.4932179,
      40.5686476,
      87.3156316,
      55.4421701
    ]
  },
  {
    id: 113,
    name: "Kenya",
    iso3: "KEN",
    iso2: "KE",
    latitude: "1.00000000",
    longitude: "38.00000000",
    bounding_box: [
      33.9098987,
      -4.8995204,
      41.899578,
      4.62
    ]
  },
  {
    id: 114,
    name: "Kiribati",
    iso3: "KIR",
    iso2: "KI",
    latitude: "1.41666666",
    longitude: "173.00000000",
    bounding_box: [
      -179.1645388,
      -7.0516717,
      -164.1645388,
      7.9483283
    ]
  },
  {
    id: 248,
    name: "Kosovo",
    iso3: "XKX",
    iso2: "XK",
    latitude: "42.56129090",
    longitude: "20.34030350"
  },
  {
    id: 117,
    name: "Kuwait",
    iso3: "KWT",
    iso2: "KW",
    latitude: "29.50000000",
    longitude: "45.75000000",
    bounding_box: [
      46.5526837,
      28.5243622,
      49.0046809,
      30.1038082
    ]
  },
  {
    id: 118,
    name: "Kyrgyzstan",
    iso3: "KGZ",
    iso2: "KG",
    latitude: "41.00000000",
    longitude: "75.00000000",
    bounding_box: [
      69.2649523,
      39.1728437,
      80.2295793,
      43.2667971
    ]
  },
  {
    id: 119,
    name: "Laos",
    iso3: "LAO",
    iso2: "LA",
    latitude: "18.00000000",
    longitude: "105.00000000",
    bounding_box: [
      100.0843247,
      13.9096752,
      107.6349989,
      22.5086717
    ]
  },
  {
    id: 120,
    name: "Latvia",
    iso3: "LVA",
    iso2: "LV",
    latitude: "57.00000000",
    longitude: "25.00000000",
    bounding_box: [
      20.6715407,
      55.6746505,
      28.2414904,
      58.0855688
    ]
  },
  {
    id: 121,
    name: "Lebanon",
    iso3: "LBN",
    iso2: "LB",
    latitude: "33.83333333",
    longitude: "35.83333333",
    bounding_box: [
      34.8825667,
      33.0479858,
      36.625,
      34.6923543
    ]
  },
  {
    id: 122,
    name: "Lesotho",
    iso3: "LSO",
    iso2: "LS",
    latitude: "-29.50000000",
    longitude: "28.50000000",
    bounding_box: [
      27.0114632,
      -30.6772773,
      29.4557099,
      -28.570615
    ]
  },
  {
    id: 123,
    name: "Liberia",
    iso3: "LBR",
    iso2: "LR",
    latitude: "6.50000000",
    longitude: "-9.50000000",
    bounding_box: [
      -11.6080764,
      4.1555907,
      -7.367323,
      8.5519861
    ]
  },
  {
    id: 124,
    name: "Libya",
    iso3: "LBY",
    iso2: "LY",
    latitude: "25.00000000",
    longitude: "17.00000000",
    bounding_box: [
      9.391081,
      19.5008138,
      25.3770629,
      33.3545898
    ]
  },
  {
    id: 125,
    name: "Liechtenstein",
    iso3: "LIE",
    iso2: "LI",
    latitude: "47.26666666",
    longitude: "9.53333333",
    bounding_box: [
      9.4716736,
      47.0484291,
      9.6357143,
      47.270581
    ]
  },
  {
    id: 126,
    name: "Lithuania",
    iso3: "LTU",
    iso2: "LT",
    latitude: "56.00000000",
    longitude: "24.00000000",
    bounding_box: [
      20.653783,
      53.8967893,
      26.8355198,
      56.4504213
    ]
  },
  {
    id: 127,
    name: "Luxembourg",
    iso3: "LUX",
    iso2: "LU",
    latitude: "49.75000000",
    longitude: "6.16666666",
    bounding_box: [
      4.9684415,
      49.4969821,
      6.0344254,
      50.430377
    ]
  },
  {
    id: 128,
    name: "Macau S.A.R.",
    iso3: "MAC",
    iso2: "MO",
    latitude: "22.16666666",
    longitude: "113.55000000",
    bounding_box: [
      113.5281666,
      22.0766667,
      113.6301389,
      22.2170361
    ]
  },
  {
    id: 130,
    name: "Madagascar",
    iso3: "MDG",
    iso2: "MG",
    latitude: "-20.00000000",
    longitude: "47.00000000",
    bounding_box: [
      43.2202072,
      -25.6071002,
      50.4862553,
      -11.9519693
    ]
  },
  {
    id: 131,
    name: "Malawi",
    iso3: "MWI",
    iso2: "MW",
    latitude: "-13.50000000",
    longitude: "34.00000000",
    bounding_box: [
      32.6703616,
      -17.1296031,
      35.9185731,
      -9.3683261
    ]
  },
  {
    id: 132,
    name: "Malaysia",
    iso3: "MYS",
    iso2: "MY",
    latitude: "2.50000000",
    longitude: "112.50000000",
    bounding_box: [
      105.3471939,
      -5.1076241,
      120.3471939,
      9.8923759
    ]
  },
  {
    id: 133,
    name: "Maldives",
    iso3: "MDV",
    iso2: "MV",
    latitude: "3.25000000",
    longitude: "73.00000000",
    bounding_box: [
      72.3554187,
      -0.9074935,
      73.9700962,
      7.3106246
    ]
  },
  {
    id: 134,
    name: "Mali",
    iso3: "MLI",
    iso2: "ML",
    latitude: "17.00000000",
    longitude: "-4.00000000",
    bounding_box: [
      -12.2402835,
      10.147811,
      4.2673828,
      25.001084
    ]
  },
  {
    id: 135,
    name: "Malta",
    iso3: "MLT",
    iso2: "MT",
    latitude: "35.83333333",
    longitude: "14.58333333",
    bounding_box: [
      13.9324226,
      35.6029696,
      14.8267966,
      36.2852706
    ]
  },
  {
    id: 136,
    name: "Man (Isle of)",
    iso3: "IMN",
    iso2: "IM",
    latitude: "54.25000000",
    longitude: "-4.50000000",
    bounding_box: [
      -4.7946845,
      54.0539576,
      -4.3076853,
      54.4178705
    ]
  },
  {
    id: 137,
    name: "Marshall Islands",
    iso3: "MHL",
    iso2: "MH",
    latitude: "9.00000000",
    longitude: "168.00000000",
    bounding_box: [
      163.4985095,
      -0.5481258,
      178.4985095,
      14.4518742
    ]
  },
  {
    id: 138,
    name: "Martinique",
    iso3: "MTQ",
    iso2: "MQ",
    latitude: "14.66666700",
    longitude: "-61.00000000",
    bounding_box: [
      -61.2290815,
      14.3948596,
      -60.8095833,
      14.8787029
    ]
  },
  {
    id: 139,
    name: "Mauritania",
    iso3: "MRT",
    iso2: "MR",
    latitude: "20.00000000",
    longitude: "-12.00000000",
    bounding_box: [
      -17.068081,
      14.7209909,
      -4.8333344,
      27.314942
    ]
  },
  {
    id: 140,
    name: "Mauritius",
    iso3: "MUS",
    iso2: "MU",
    latitude: "-20.28333333",
    longitude: "57.55000000",
    bounding_box: [
      56.3825151,
      -20.725,
      63.7151319,
      -10.138
    ]
  },
  {
    id: 141,
    name: "Mayotte",
    iso3: "MYT",
    iso2: "YT",
    latitude: "-12.83333333",
    longitude: "45.16666666",
    bounding_box: [
      45.0183298,
      -13.0210119,
      45.2999917,
      -12.6365902
    ]
  },
  {
    id: 142,
    name: "Mexico",
    iso3: "MEX",
    iso2: "MX",
    latitude: "23.00000000",
    longitude: "-102.00000000",
    bounding_box: [
      -118.59919,
      14.3886243,
      -86.493266,
      32.7186553
    ]
  },
  {
    id: 143,
    name: "Micronesia",
    iso3: "FSM",
    iso2: "FM",
    latitude: "6.91666666",
    longitude: "158.25000000",
    bounding_box: [
      137.2234512,
      0.827,
      163.2364054,
      10.291
    ]
  },
  {
    id: 144,
    name: "Moldova",
    iso3: "MDA",
    iso2: "MD",
    latitude: "47.00000000",
    longitude: "29.00000000",
    bounding_box: [
      26.6162189,
      45.4674139,
      30.1636756,
      48.4918695
    ]
  },
  {
    id: 145,
    name: "Monaco",
    iso3: "MCO",
    iso2: "MC",
    latitude: "43.73333333",
    longitude: "7.40000000",
    bounding_box: [
      7.4090279,
      43.7247599,
      7.4398704,
      43.7519311
    ]
  },
  {
    id: 146,
    name: "Mongolia",
    iso3: "MNG",
    iso2: "MN",
    latitude: "46.00000000",
    longitude: "105.00000000",
    bounding_box: [
      87.73762,
      41.5800276,
      119.931949,
      52.1496
    ]
  },
  {
    id: 147,
    name: "Montenegro",
    iso3: "MNE",
    iso2: "ME",
    latitude: "42.50000000",
    longitude: "19.30000000",
    bounding_box: [
      18.4195781,
      41.7495999,
      20.3561641,
      43.5585061
    ]
  },
  {
    id: 148,
    name: "Montserrat",
    iso3: "MSR",
    iso2: "MS",
    latitude: "16.75000000",
    longitude: "-62.20000000",
    bounding_box: [
      -62.450667,
      16.475,
      -61.9353818,
      17.0152978
    ]
  },
  {
    id: 149,
    name: "Morocco",
    iso3: "MAR",
    iso2: "MA",
    latitude: "32.00000000",
    longitude: "-5.00000000",
    bounding_box: [
      -17.2551456,
      21.3365321,
      -0.998429,
      36.0505269
    ]
  },
  {
    id: 150,
    name: "Mozambique",
    iso3: "MOZ",
    iso2: "MZ",
    latitude: "-18.25000000",
    longitude: "35.00000000",
    bounding_box: [
      30.2138197,
      -26.9209427,
      41.0545908,
      -10.3252149
    ]
  },
  {
    id: 151,
    name: "Myanmar",
    iso3: "MMR",
    iso2: "MM",
    latitude: "22.00000000",
    longitude: "98.00000000",
    bounding_box: [
      92.1719423,
      9.4399432,
      101.1700796,
      28.547835
    ]
  },
  {
    id: 152,
    name: "Namibia",
    iso3: "NAM",
    iso2: "NA",
    latitude: "-22.00000000",
    longitude: "17.00000000",
    bounding_box: [
      11.5280384,
      -28.96945,
      25.2617671,
      -16.9634855
    ]
  },
  {
    id: 153,
    name: "Nauru",
    iso3: "NRU",
    iso2: "NR",
    latitude: "-0.53333333",
    longitude: "166.91666666",
    bounding_box: [
      166.9091794,
      -0.5541334,
      166.9589235,
      -0.5025906
    ]
  },
  {
    id: 154,
    name: "Nepal",
    iso3: "NPL",
    iso2: "NP",
    latitude: "28.00000000",
    longitude: "84.00000000",
    bounding_box: [
      80.0586226,
      26.3477581,
      88.2015257,
      30.446945
    ]
  },
  {
    id: 156,
    name: "Netherlands",
    iso3: "NLD",
    iso2: "NL",
    latitude: "52.50000000",
    longitude: "5.75000000",
    bounding_box: [
      1.9193492,
      50.7295671,
      7.2274985,
      53.7253321
    ]
  },
  {
    id: 157,
    name: "New Caledonia",
    iso3: "NCL",
    iso2: "NC",
    latitude: "-21.50000000",
    longitude: "165.50000000",
    bounding_box: [
      162.6034343,
      -23.2217509,
      167.8109827,
      -17.6868616
    ]
  },
  {
    id: 158,
    name: "New Zealand",
    iso3: "NZL",
    iso2: "NZ",
    latitude: "-41.00000000",
    longitude: "174.00000000",
    bounding_box: [
      -179.059153,
      -52.8213687,
      179.3643594,
      -29.0303303
    ]
  },
  {
    id: 159,
    name: "Nicaragua",
    iso3: "NIC",
    iso2: "NI",
    latitude: "13.00000000",
    longitude: "-85.00000000",
    bounding_box: [
      -87.901532,
      10.7076565,
      -82.6227023,
      15.0331183
    ]
  },
  {
    id: 160,
    name: "Niger",
    iso3: "NER",
    iso2: "NE",
    latitude: "16.00000000",
    longitude: "8.00000000",
    bounding_box: [
      0.1689653,
      11.693756,
      15.996667,
      23.517178
    ]
  },
  {
    id: 161,
    name: "Nigeria",
    iso3: "NGA",
    iso2: "NG",
    latitude: "10.00000000",
    longitude: "8.00000000",
    bounding_box: [
      2.676932,
      4.0690959,
      14.678014,
      13.885645
    ]
  },
  {
    id: 162,
    name: "Niue",
    iso3: "NIU",
    iso2: "NU",
    latitude: "-19.03333333",
    longitude: "-169.86666666",
    bounding_box: [
      -170.1595029,
      -19.3548665,
      -169.5647229,
      -18.7534559
    ]
  },
  {
    id: 163,
    name: "Norfolk Island",
    iso3: "NFK",
    iso2: "NF",
    latitude: "-29.03333333",
    longitude: "167.95000000",
    bounding_box: [
      167.6873878,
      -29.333,
      168.2249543,
      -28.796
    ]
  },
  {
    id: 115,
    name: "North Korea",
    iso3: "PRK",
    iso2: "KP",
    latitude: "40.00000000",
    longitude: "127.00000000",
    bounding_box: [
      124.0913902,
      37.5867855,
      130.924647,
      43.0089642
    ]
  },
  {
    id: 129,
    name: "North Macedonia",
    iso3: "MKD",
    iso2: "MK",
    latitude: "41.83333333",
    longitude: "22.00000000",
    bounding_box: [
      20.4529023,
      40.8536596,
      23.034051,
      42.3735359
    ]
  },
  {
    id: 164,
    name: "Northern Mariana Islands",
    iso3: "MNP",
    iso2: "MP",
    latitude: "15.20000000",
    longitude: "145.75000000",
    bounding_box: [
      144.813338,
      14.036565,
      146.154418,
      20.616556
    ]
  },
  {
    id: 165,
    name: "Norway",
    iso3: "NOR",
    iso2: "NO",
    latitude: "62.00000000",
    longitude: "10.00000000",
    bounding_box: [
      4.0875274,
      57.7590052,
      31.7614911,
      71.3848787
    ]
  },
  {
    id: 166,
    name: "Oman",
    iso3: "OMN",
    iso2: "OM",
    latitude: "21.00000000",
    longitude: "57.00000000",
    bounding_box: [
      52,
      16.4649608,
      60.054577,
      26.7026737
    ]
  },
  {
    id: 167,
    name: "Pakistan",
    iso3: "PAK",
    iso2: "PK",
    latitude: "30.00000000",
    longitude: "70.00000000",
    bounding_box: [
      60.872855,
      23.5393916,
      77.1203914,
      37.084107
    ]
  },
  {
    id: 168,
    name: "Palau",
    iso3: "PLW",
    iso2: "PW",
    latitude: "7.50000000",
    longitude: "134.50000000",
    bounding_box: [
      131.0685462,
      2.748,
      134.7714735,
      8.222
    ]
  },
  {
    id: 169,
    name: "Palestinian Territory Occupied",
    iso3: "PSE",
    iso2: "PS",
    latitude: "31.90000000",
    longitude: "35.20000000",
    bounding_box: [
      34.0689732,
      31.2201289,
      35.5739235,
      32.5521479
    ]
  },
  {
    id: 170,
    name: "Panama",
    iso3: "PAN",
    iso2: "PA",
    latitude: "9.00000000",
    longitude: "-80.00000000",
    bounding_box: [
      -83.0517245,
      7.0338679,
      -77.1393779,
      9.8701757
    ]
  },
  {
    id: 171,
    name: "Papua new Guinea",
    iso3: "PNG",
    iso2: "PG",
    latitude: "-6.00000000",
    longitude: "147.00000000",
    bounding_box: [
      136.7489081,
      -13.1816069,
      151.7489081,
      1.8183931
    ]
  },
  {
    id: 172,
    name: "Paraguay",
    iso3: "PRY",
    iso2: "PY",
    latitude: "-23.00000000",
    longitude: "-58.00000000",
    bounding_box: [
      -62.6442036,
      -27.6063935,
      -54.258,
      -19.2876472
    ]
  },
  {
    id: 173,
    name: "Peru",
    iso3: "PER",
    iso2: "PE",
    latitude: "-10.00000000",
    longitude: "-76.00000000",
    bounding_box: [
      -84.6356535,
      -20.1984472,
      -68.6519906,
      -0.0392818
    ]
  },
  {
    id: 174,
    name: "Philippines",
    iso3: "PHL",
    iso2: "PH",
    latitude: "13.00000000",
    longitude: "122.00000000",
    bounding_box: [
      114.0952145,
      4.2158064,
      126.8072562,
      21.3217806
    ]
  },
  {
    id: 175,
    name: "Pitcairn Island",
    iso3: "PCN",
    iso2: "PN",
    latitude: "-25.06666666",
    longitude: "-130.10000000",
    bounding_box: [
      -130.8049862,
      -25.1306736,
      -124.717534,
      -23.8655769
    ]
  },
  {
    id: 176,
    name: "Poland",
    iso3: "POL",
    iso2: "PL",
    latitude: "52.00000000",
    longitude: "20.00000000",
    bounding_box: [
      14.1229707,
      49.0020468,
      24.145783,
      55.0336963
    ]
  },
  {
    id: 177,
    name: "Portugal",
    iso3: "PRT",
    iso2: "PT",
    latitude: "39.50000000",
    longitude: "-8.00000000",
    bounding_box: [
      -31.5575303,
      29.8288021,
      -6.1891593,
      42.1543112
    ]
  },
  {
    id: 178,
    name: "Puerto Rico",
    iso3: "PRI",
    iso2: "PR",
    latitude: "18.25000000",
    longitude: "-66.50000000",
    bounding_box: [
      -67.271492,
      17.9268695,
      -65.5897525,
      18.5159789
    ]
  },
  {
    id: 179,
    name: "Qatar",
    iso3: "QAT",
    iso2: "QA",
    latitude: "25.50000000",
    longitude: "51.25000000",
    bounding_box: [
      50.5675,
      24.4707534,
      52.638011,
      26.3830212
    ]
  },
  {
    id: 180,
    name: "Reunion",
    iso3: "REU",
    iso2: "RE",
    latitude: "-21.15000000",
    longitude: "55.50000000",
    bounding_box: [
      55.2164268,
      -21.3897308,
      55.8366924,
      -20.8717136
    ]
  },
  {
    id: 181,
    name: "Romania",
    iso3: "ROU",
    iso2: "RO",
    latitude: "46.00000000",
    longitude: "25.00000000",
    bounding_box: [
      20.2619773,
      43.618682,
      30.0454257,
      48.2653964
    ]
  },
  {
    id: 182,
    name: "Russia",
    iso3: "RUS",
    iso2: "RU",
    latitude: "60.00000000",
    longitude: "100.00000000",
    bounding_box: [
      19.6389,
      41.1850968,
      180,
      82.0586232
    ]
  },
  {
    id: 183,
    name: "Rwanda",
    iso3: "RWA",
    iso2: "RW",
    latitude: "-2.00000000",
    longitude: "30.00000000",
    bounding_box: [
      28.8617546,
      -2.8389804,
      30.8990738,
      -1.0474083
    ]
  },
  {
    id: 184,
    name: "Saint Helena",
    iso3: "SHN",
    iso2: "SH",
    latitude: "-15.95000000",
    longitude: "-5.70000000",
    bounding_box: [
      -5.9973424,
      -16.23,
      -5.4234153,
      -15.704
    ]
  },
  {
    id: 185,
    name: "Saint Kitts And Nevis",
    iso3: "KNA",
    iso2: "KN",
    latitude: "17.33333333",
    longitude: "-62.75000000",
    bounding_box: [
      -63.051129,
      16.895,
      -62.3303519,
      17.6158146
    ]
  },
  {
    id: 186,
    name: "Saint Lucia",
    iso3: "LCA",
    iso2: "LC",
    latitude: "13.88333333",
    longitude: "-60.96666666",
    bounding_box: [
      -61.2853867,
      13.508,
      -60.6669363,
      14.2725
    ]
  },
  {
    id: 187,
    name: "Saint Pierre and Miquelon",
    iso3: "SPM",
    iso2: "PM",
    latitude: "46.83333333",
    longitude: "-56.33333333",
    bounding_box: [
      -56.6972961,
      46.5507173,
      -55.9033333,
      47.365
    ]
  },
  {
    id: 188,
    name: "Saint Vincent And The Grenadines",
    iso3: "VCT",
    iso2: "VC",
    latitude: "13.25000000",
    longitude: "-61.20000000",
    bounding_box: [
      -61.6657471,
      12.5166548,
      -60.9094146,
      13.583
    ]
  },
  {
    id: 189,
    name: "Saint-Barthelemy",
    iso3: "BLM",
    iso2: "BL",
    latitude: "18.50000000",
    longitude: "-63.41666666",
    bounding_box: [
      -63.06639,
      17.670931,
      -62.5844019,
      18.1375569
    ]
  },
  {
    id: 190,
    name: "Saint-Martin (French part)",
    iso3: "MAF",
    iso2: "MF",
    latitude: "18.08333333",
    longitude: "-63.95000000",
    bounding_box: [
      -63.3605643,
      17.8963535,
      -62.7644063,
      18.1902778
    ]
  },
  {
    id: 191,
    name: "Samoa",
    iso3: "WSM",
    iso2: "WS",
    latitude: "-13.58333333",
    longitude: "-172.33333333",
    bounding_box: [
      -173.0091864,
      -14.2770916,
      -171.1929229,
      -13.2381892
    ]
  },
  {
    id: 192,
    name: "San Marino",
    iso3: "SMR",
    iso2: "SM",
    latitude: "43.76666666",
    longitude: "12.41666666",
    bounding_box: [
      12.4033246,
      43.8937002,
      12.5160665,
      43.992093
    ]
  },
  {
    id: 193,
    name: "Sao Tome and Principe",
    iso3: "STP",
    iso2: "ST",
    latitude: "1.00000000",
    longitude: "7.00000000",
    bounding_box: [
      6.260642,
      -0.2135137,
      7.6704783,
      1.9257601
    ]
  },
  {
    id: 194,
    name: "Saudi Arabia",
    iso3: "SAU",
    iso2: "SA",
    latitude: "25.00000000",
    longitude: "45.00000000",
    bounding_box: [
      34.4571718,
      16.29,
      55.6666851,
      32.1543377
    ]
  },
  {
    id: 195,
    name: "Senegal",
    iso3: "SEN",
    iso2: "SN",
    latitude: "14.00000000",
    longitude: "-14.00000000",
    bounding_box: [
      -17.7862419,
      12.2372838,
      -11.3458996,
      16.6919712
    ]
  },
  {
    id: 196,
    name: "Serbia",
    iso3: "SRB",
    iso2: "RS",
    latitude: "44.00000000",
    longitude: "21.00000000",
    bounding_box: [
      18.8142875,
      42.2322435,
      23.006309,
      46.1900524
    ]
  },
  {
    id: 197,
    name: "Seychelles",
    iso3: "SYC",
    iso2: "SC",
    latitude: "-4.58333333",
    longitude: "55.66666666",
    bounding_box: [
      45.9988759,
      -10.4649258,
      56.4979396,
      -3.512
    ]
  },
  {
    id: 198,
    name: "Sierra Leone",
    iso3: "SLE",
    iso2: "SL",
    latitude: "8.50000000",
    longitude: "-11.50000000",
    bounding_box: [
      -13.5003389,
      6.755,
      -10.271683,
      9.999973
    ]
  },
  {
    id: 199,
    name: "Singapore",
    iso3: "SGP",
    iso2: "SG",
    latitude: "1.36666666",
    longitude: "103.80000000",
    bounding_box: [
      103.6920359,
      1.1304753,
      104.0120359,
      1.4504753
    ]
  },
  {
    id: 250,
    name: "Sint Maarten (Dutch part)",
    iso3: "SXM",
    iso2: "SX",
    latitude: "18.03333300",
    longitude: "-63.05000000"
  },
  {
    id: 200,
    name: "Slovakia",
    iso3: "SVK",
    iso2: "SK",
    latitude: "48.66666666",
    longitude: "19.50000000",
    bounding_box: [
      16.8331891,
      47.7314286,
      22.56571,
      49.6138162
    ]
  },
  {
    id: 201,
    name: "Slovenia",
    iso3: "SVN",
    iso2: "SI",
    latitude: "46.11666666",
    longitude: "14.81666666",
    bounding_box: [
      13.3754696,
      45.4214242,
      16.5967702,
      46.8766816
    ]
  },
  {
    id: 202,
    name: "Solomon Islands",
    iso3: "SLB",
    iso2: "SB",
    latitude: "-8.00000000",
    longitude: "159.00000000",
    bounding_box: [
      155.3190556,
      -13.2424298,
      170.3964667,
      -4.81085
    ]
  },
  {
    id: 203,
    name: "Somalia",
    iso3: "SOM",
    iso2: "SO",
    latitude: "10.00000000",
    longitude: "49.00000000",
    bounding_box: [
      40.98918,
      -1.8031969,
      51.6177696,
      12.1889121
    ]
  },
  {
    id: 204,
    name: "South Africa",
    iso3: "ZAF",
    iso2: "ZA",
    latitude: "-29.00000000",
    longitude: "24.00000000",
    bounding_box: [
      16.3335213,
      -47.1788335,
      38.2898954,
      -22.1250301
    ]
  },
  {
    id: 205,
    name: "South Georgia",
    iso3: "SGS",
    iso2: "GS",
    latitude: "-54.50000000",
    longitude: "-37.00000000",
    bounding_box: [
      -42.354739,
      -59.684,
      -25.8468303,
      -53.3500755
    ]
  },
  {
    id: 116,
    name: "South Korea",
    iso3: "KOR",
    iso2: "KR",
    latitude: "37.00000000",
    longitude: "127.50000000",
    bounding_box: [
      124.354847,
      32.9104556,
      132.1467806,
      38.623477
    ]
  },
  {
    id: 206,
    name: "South Sudan",
    iso3: "SSD",
    iso2: "SS",
    latitude: "7.00000000",
    longitude: "30.00000000"
  },
  {
    id: 207,
    name: "Spain",
    iso3: "ESP",
    iso2: "ES",
    latitude: "40.00000000",
    longitude: "-4.00000000",
    bounding_box: [
      -18.3936845,
      27.4335426,
      4.5918885,
      43.9933088
    ]
  },
  {
    id: 208,
    name: "Sri Lanka",
    iso3: "LKA",
    iso2: "LK",
    latitude: "7.00000000",
    longitude: "81.00000000",
    bounding_box: [
      79.3959205,
      5.719,
      82.0810141,
      10.035
    ]
  },
  {
    id: 209,
    name: "Sudan",
    iso3: "SDN",
    iso2: "SD",
    latitude: "15.00000000",
    longitude: "30.00000000",
    bounding_box: [
      21.8145046,
      8.685278,
      39.0576252,
      22.224918
    ]
  },
  {
    id: 210,
    name: "Suriname",
    iso3: "SUR",
    iso2: "SR",
    latitude: "4.00000000",
    longitude: "-56.00000000",
    bounding_box: [
      -58.070833,
      1.8312802,
      -53.8433358,
      6.225
    ]
  },
  {
    id: 211,
    name: "Svalbard And Jan Mayen Islands",
    iso3: "SJM",
    iso2: "SJ",
    latitude: "78.00000000",
    longitude: "20.00000000",
    bounding_box: [
      -9.6848146,
      70.6260825,
      34.6891253,
      81.028076
    ]
  },
  {
    id: 212,
    name: "Swaziland",
    iso3: "SWZ",
    iso2: "SZ",
    latitude: "-26.50000000",
    longitude: "31.50000000",
    bounding_box: [
      30.7908,
      -27.3175201,
      32.1349923,
      -25.71876
    ]
  },
  {
    id: 213,
    name: "Sweden",
    iso3: "SWE",
    iso2: "SE",
    latitude: "62.00000000",
    longitude: "15.00000000",
    bounding_box: [
      10.5930952,
      55.1331192,
      24.1776819,
      69.0599699
    ]
  },
  {
    id: 214,
    name: "Switzerland",
    iso3: "CHE",
    iso2: "CH",
    latitude: "47.00000000",
    longitude: "8.00000000",
    bounding_box: [
      5.9559113,
      45.817995,
      10.4922941,
      47.8084648
    ]
  },
  {
    id: 215,
    name: "Syria",
    iso3: "SYR",
    iso2: "SY",
    latitude: "35.00000000",
    longitude: "38.00000000",
    bounding_box: [
      35.4714427,
      32.311354,
      42.3745687,
      37.3184589
    ]
  },
  {
    id: 216,
    name: "Taiwan",
    iso3: "TWN",
    iso2: "TW",
    latitude: "23.50000000",
    longitude: "121.00000000",
    bounding_box: [
      114.3599058,
      10.374269,
      122.297,
      26.4372222
    ]
  },
  {
    id: 217,
    name: "Tajikistan",
    iso3: "TJK",
    iso2: "TJ",
    latitude: "39.00000000",
    longitude: "71.00000000",
    bounding_box: [
      67.3332775,
      36.6711153,
      75.1539563,
      41.0450935
    ]
  },
  {
    id: 218,
    name: "Tanzania",
    iso3: "TZA",
    iso2: "TZ",
    latitude: "-6.00000000",
    longitude: "35.00000000",
    bounding_box: [
      29.3269773,
      -11.761254,
      40.6584071,
      -0.9854812
    ]
  },
  {
    id: 219,
    name: "Thailand",
    iso3: "THA",
    iso2: "TH",
    latitude: "15.00000000",
    longitude: "100.00000000",
    bounding_box: [
      97.3438072,
      5.612851,
      105.636812,
      20.4648337
    ]
  },
  {
    id: 17,
    name: "The Bahamas",
    iso3: "BHS",
    iso2: "BS",
    latitude: "24.25000000",
    longitude: "-76.00000000",
    bounding_box: [
      -80.7001941,
      20.7059846,
      -72.4477521,
      27.4734551
    ]
  },
  {
    id: 220,
    name: "Togo",
    iso3: "TGO",
    iso2: "TG",
    latitude: "8.00000000",
    longitude: "1.16666666",
    bounding_box: [
      -0.1439746,
      5.926547,
      1.8087605,
      11.1395102
    ]
  },
  {
    id: 221,
    name: "Tokelau",
    iso3: "TKL",
    iso2: "TK",
    latitude: "-9.00000000",
    longitude: "-172.00000000",
    bounding_box: [
      -172.7213673,
      -9.6442499,
      -170.9797586,
      -8.3328631
    ]
  },
  {
    id: 222,
    name: "Tonga",
    iso3: "TON",
    iso2: "TO",
    latitude: "-20.00000000",
    longitude: "-175.00000000",
    bounding_box: [
      -179.3866055,
      -24.1034499,
      -173.5295458,
      -15.3655722
    ]
  },
  {
    id: 223,
    name: "Trinidad And Tobago",
    iso3: "TTO",
    iso2: "TT",
    latitude: "11.00000000",
    longitude: "-61.00000000",
    bounding_box: [
      -62.083056,
      9.8732106,
      -60.2895848,
      11.5628372
    ]
  },
  {
    id: 224,
    name: "Tunisia",
    iso3: "TUN",
    iso2: "TN",
    latitude: "34.00000000",
    longitude: "9.00000000",
    bounding_box: [
      7.5219807,
      30.230236,
      11.8801133,
      37.7612052
    ]
  },
  {
    id: 225,
    name: "Turkey",
    iso3: "TUR",
    iso2: "TR",
    latitude: "39.00000000",
    longitude: "35.00000000",
    bounding_box: [
      25.6212891,
      35.8076804,
      44.8176638,
      42.297
    ]
  },
  {
    id: 226,
    name: "Turkmenistan",
    iso3: "TKM",
    iso2: "TM",
    latitude: "40.00000000",
    longitude: "60.00000000",
    bounding_box: [
      52.335076,
      35.129093,
      66.6895177,
      42.7975571
    ]
  },
  {
    id: 227,
    name: "Turks And Caicos Islands",
    iso3: "TCA",
    iso2: "TC",
    latitude: "21.75000000",
    longitude: "-71.58333333",
    bounding_box: [
      -72.6799046,
      20.9553418,
      -70.8643591,
      22.1630989
    ]
  },
  {
    id: 228,
    name: "Tuvalu",
    iso3: "TUV",
    iso2: "TV",
    latitude: "-8.00000000",
    longitude: "178.00000000",
    bounding_box: [
      175.1590468,
      -9.9939389,
      178.7344938,
      -5.4369611
    ]
  },
  {
    id: 229,
    name: "Uganda",
    iso3: "UGA",
    iso2: "UG",
    latitude: "1.00000000",
    longitude: "32.00000000",
    bounding_box: [
      29.573433,
      -1.4823179,
      35.000308,
      4.2340766
    ]
  },
  {
    id: 230,
    name: "Ukraine",
    iso3: "UKR",
    iso2: "UA",
    latitude: "49.00000000",
    longitude: "32.00000000",
    bounding_box: [
      22.137059,
      44.184598,
      40.2275801,
      52.3791473
    ]
  },
  {
    id: 231,
    name: "United Arab Emirates",
    iso3: "ARE",
    iso2: "AE",
    latitude: "24.00000000",
    longitude: "54.00000000",
    bounding_box: [
      51.498,
      22.6444,
      56.3834,
      26.2822
    ]
  },
  {
    id: 232,
    name: "United Kingdom",
    iso3: "GBR",
    iso2: "GB",
    latitude: "54.00000000",
    longitude: "-2.00000000",
    bounding_box: [
      -14.015517,
      49.674,
      2.0919117,
      61.061
    ]
  },
  {
    id: 233,
    name: "United States",
    iso3: "USA",
    iso2: "US",
    latitude: "38.00000000",
    longitude: "-97.00000000",
    bounding_box: [
      -125.0011,
      24.9493,
      -66.9326,
      49.5904
    ]
  },
  {
    id: 234,
    name: "United States Minor Outlying Islands",
    iso3: "UMI",
    iso2: "UM",
    latitude: "0.00000000",
    longitude: "0.00000000",
    bounding_box: [
      -162.6816297,
      6.1779744,
      -162.1339885,
      6.6514388
    ]
  },
  {
    id: 235,
    name: "Uruguay",
    iso3: "URY",
    iso2: "UY",
    latitude: "-33.00000000",
    longitude: "-56.00000000",
    bounding_box: [
      -58.4948438,
      -35.7824481,
      -53.0755833,
      -30.0853962
    ]
  },
  {
    id: 236,
    name: "Uzbekistan",
    iso3: "UZB",
    iso2: "UZ",
    latitude: "41.00000000",
    longitude: "64.00000000",
    bounding_box: [
      55.9977865,
      37.1821164,
      73.1397362,
      45.590118
    ]
  },
  {
    id: 237,
    name: "Vanuatu",
    iso3: "VUT",
    iso2: "VU",
    latitude: "-16.00000000",
    longitude: "167.00000000",
    bounding_box: [
      166.3355255,
      -20.4627425,
      170.449982,
      -12.8713777
    ]
  },
  {
    id: 238,
    name: "Vatican City State (Holy See)",
    iso3: "VAT",
    iso2: "VA",
    latitude: "41.90000000",
    longitude: "12.45000000",
    bounding_box: [
      12.4457442,
      41.9002044,
      12.4583653,
      41.9073912
    ]
  },
  {
    id: 239,
    name: "Venezuela",
    iso3: "VEN",
    iso2: "VE",
    latitude: "8.00000000",
    longitude: "-66.00000000",
    bounding_box: [
      -73.3529632,
      0.647529,
      -59.5427079,
      15.9158431
    ]
  },
  {
    id: 240,
    name: "Vietnam",
    iso3: "VNM",
    iso2: "VN",
    latitude: "16.16666666",
    longitude: "107.83333333",
    bounding_box: [
      102.14441,
      8.1790665,
      114.3337595,
      23.393395
    ]
  },
  {
    id: 241,
    name: "Virgin Islands (British)",
    iso3: "VGB",
    iso2: "VG",
    latitude: "18.43138300",
    longitude: "-64.62305000",
    bounding_box: [
      -65.159094,
      17.623468,
      -64.512674,
      18.464984
    ]
  },
  {
    id: 242,
    name: "Virgin Islands (US)",
    iso3: "VIR",
    iso2: "VI",
    latitude: "18.34000000",
    longitude: "-64.93000000",
    bounding_box: [
      -65.159094,
      17.623468,
      -64.512674,
      18.464984
    ]
  },
  {
    id: 243,
    name: "Wallis And Futuna Islands",
    iso3: "WLF",
    iso2: "WF",
    latitude: "-13.30000000",
    longitude: "-176.20000000",
    bounding_box: [
      -178.3873749,
      -14.5630748,
      -175.9190391,
      -12.9827961
    ]
  },
  {
    id: 244,
    name: "Western Sahara",
    iso3: "ESH",
    iso2: "EH",
    latitude: "24.50000000",
    longitude: "-13.00000000",
    bounding_box: [
      -17.3494721,
      20.556883,
      -8.666389,
      27.6666834
    ]
  },
  {
    id: 245,
    name: "Yemen",
    iso3: "YEM",
    iso2: "YE",
    latitude: "15.00000000",
    longitude: "48.00000000",
    bounding_box: [
      41.60825,
      11.9084802,
      54.7389375,
      19
    ]
  },
  {
    id: 246,
    name: "Zambia",
    iso3: "ZMB",
    iso2: "ZM",
    latitude: "-15.00000000",
    longitude: "30.00000000",
    bounding_box: [
      21.9993509,
      -18.0765945,
      33.701111,
      -8.2712822
    ]
  },
  {
    id: 247,
    name: "Zimbabwe",
    iso3: "ZWE",
    iso2: "ZW",
    latitude: "-20.00000000",
    longitude: "30.00000000",
    bounding_box: [
      25.2373,
      -22.4241096,
      33.0683413,
      -15.6097033
    ]
  }
];
class GLTFLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.dracoLoader = null;
    this.ktx2Loader = null;
    this.meshoptDecoder = null;
    this.pluginCallbacks = [];
    this.register(function(parser) {
      return new GLTFMaterialsClearcoatExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureBasisUExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFTextureWebPExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsSheenExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsTransmissionExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsVolumeExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsIorExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMaterialsSpecularExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFLightsExtension(parser);
    });
    this.register(function(parser) {
      return new GLTFMeshoptCompression(parser);
    });
  }
  load(url2, onLoad, onProgress, onError) {
    const scope = this;
    let resourcePath;
    if (this.resourcePath !== "") {
      resourcePath = this.resourcePath;
    } else if (this.path !== "") {
      resourcePath = this.path;
    } else {
      resourcePath = LoaderUtils.extractUrlBase(url2);
    }
    this.manager.itemStart(url2);
    const _onError = function(e3) {
      if (onError) {
        onError(e3);
      } else {
        console.error(e3);
      }
      scope.manager.itemError(url2);
      scope.manager.itemEnd(url2);
    };
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setResponseType("arraybuffer");
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(url2, function(data2) {
      try {
        scope.parse(data2, resourcePath, function(gltf) {
          onLoad(gltf);
          scope.manager.itemEnd(url2);
        }, _onError);
      } catch (e3) {
        _onError(e3);
      }
    }, onProgress, _onError);
  }
  setDRACOLoader(dracoLoader) {
    this.dracoLoader = dracoLoader;
    return this;
  }
  setDDSLoader() {
    throw new Error(
      'THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".'
    );
  }
  setKTX2Loader(ktx2Loader) {
    this.ktx2Loader = ktx2Loader;
    return this;
  }
  setMeshoptDecoder(meshoptDecoder) {
    this.meshoptDecoder = meshoptDecoder;
    return this;
  }
  register(callback) {
    if (this.pluginCallbacks.indexOf(callback) === -1) {
      this.pluginCallbacks.push(callback);
    }
    return this;
  }
  unregister(callback) {
    if (this.pluginCallbacks.indexOf(callback) !== -1) {
      this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
    }
    return this;
  }
  parse(data2, path2, onLoad, onError) {
    let content;
    const extensions = {};
    const plugins = {};
    if (typeof data2 === "string") {
      content = data2;
    } else {
      const magic = LoaderUtils.decodeText(new Uint8Array(data2, 0, 4));
      if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
        try {
          extensions[EXTENSIONS$5.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data2);
        } catch (error2) {
          if (onError)
            onError(error2);
          return;
        }
        content = extensions[EXTENSIONS$5.KHR_BINARY_GLTF].content;
      } else {
        content = LoaderUtils.decodeText(new Uint8Array(data2));
      }
    }
    const json = JSON.parse(content);
    if (json.asset === void 0 || json.asset.version[0] < 2) {
      if (onError)
        onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const parser = new GLTFParser(json, {
      path: path2 || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    parser.fileLoader.setRequestHeader(this.requestHeader);
    for (let i2 = 0; i2 < this.pluginCallbacks.length; i2++) {
      const plugin = this.pluginCallbacks[i2](parser);
      plugins[plugin.name] = plugin;
      extensions[plugin.name] = true;
    }
    if (json.extensionsUsed) {
      for (let i2 = 0; i2 < json.extensionsUsed.length; ++i2) {
        const extensionName = json.extensionsUsed[i2];
        const extensionsRequired = json.extensionsRequired || [];
        switch (extensionName) {
          case EXTENSIONS$5.KHR_MATERIALS_UNLIT:
            extensions[extensionName] = new GLTFMaterialsUnlitExtension();
            break;
          case EXTENSIONS$5.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
            extensions[extensionName] = new GLTFMaterialsPbrSpecularGlossinessExtension();
            break;
          case EXTENSIONS$5.KHR_DRACO_MESH_COMPRESSION:
            extensions[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
            break;
          case EXTENSIONS$5.KHR_TEXTURE_TRANSFORM:
            extensions[extensionName] = new GLTFTextureTransformExtension();
            break;
          case EXTENSIONS$5.KHR_MESH_QUANTIZATION:
            extensions[extensionName] = new GLTFMeshQuantizationExtension();
            break;
          default:
            if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) {
              console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
      }
    }
    parser.setExtensions(extensions);
    parser.setPlugins(plugins);
    parser.parse(onLoad, onError);
  }
  parseAsync(data2, path2) {
    const scope = this;
    return new Promise(function(resolve2, reject) {
      scope.parse(data2, path2, resolve2, reject);
    });
  }
}
function GLTFRegistry() {
  let objects = {};
  return {
    get: function(key) {
      return objects[key];
    },
    add: function(key, object2) {
      objects[key] = object2;
    },
    remove: function(key) {
      delete objects[key];
    },
    removeAll: function() {
      objects = {};
    }
  };
}
const EXTENSIONS$5 = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS: "KHR_materials_pbrSpecularGlossiness",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression"
};
class GLTFLightsExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_LIGHTS_PUNCTUAL;
    this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const parser = this.parser;
    const nodeDefs = this.parser.json.nodes || [];
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) {
        parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
      }
    }
  }
  _loadLight(lightIndex) {
    const parser = this.parser;
    const cacheKey = "light:" + lightIndex;
    let dependency = parser.cache.get(cacheKey);
    if (dependency)
      return dependency;
    const json = parser.json;
    const extensions = json.extensions && json.extensions[this.name] || {};
    const lightDefs = extensions.lights || [];
    const lightDef = lightDefs[lightIndex];
    let lightNode;
    const color = new Color(16777215);
    if (lightDef.color !== void 0)
      color.fromArray(lightDef.color);
    const range2 = lightDef.range !== void 0 ? lightDef.range : 0;
    switch (lightDef.type) {
      case "directional":
        lightNode = new DirectionalLight$1(color);
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      case "point":
        lightNode = new PointLight(color);
        lightNode.distance = range2;
        break;
      case "spot":
        lightNode = new SpotLight(color);
        lightNode.distance = range2;
        lightDef.spot = lightDef.spot || {};
        lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
        lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
        lightNode.angle = lightDef.spot.outerConeAngle;
        lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
        lightNode.target.position.set(0, 0, -1);
        lightNode.add(lightNode.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
    }
    lightNode.position.set(0, 0, 0);
    lightNode.decay = 2;
    if (lightDef.intensity !== void 0)
      lightNode.intensity = lightDef.intensity;
    lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
    dependency = Promise.resolve(lightNode);
    parser.cache.add(cacheKey, dependency);
    return dependency;
  }
  createNodeAttachment(nodeIndex) {
    const self2 = this;
    const parser = this.parser;
    const json = parser.json;
    const nodeDef = json.nodes[nodeIndex];
    const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
    const lightIndex = lightDef.light;
    if (lightIndex === void 0)
      return null;
    return this._loadLight(lightIndex).then(function(light) {
      return parser._getNodeRef(self2.cache, lightIndex, light);
    });
  }
}
class GLTFMaterialsUnlitExtension {
  constructor() {
    this.name = EXTENSIONS$5.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return MeshBasicMaterial;
  }
  extendParams(materialParams, materialDef, parser) {
    const pending = [];
    materialParams.color = new Color(1, 1, 1);
    materialParams.opacity = 1;
    const metallicRoughness = materialDef.pbrMetallicRoughness;
    if (metallicRoughness) {
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array2 = metallicRoughness.baseColorFactor;
        materialParams.color.fromArray(array2);
        materialParams.opacity = array2[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, sRGBEncoding));
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsClearcoatExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.clearcoatFactor !== void 0) {
      materialParams.clearcoat = extension.clearcoatFactor;
    }
    if (extension.clearcoatTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
    }
    if (extension.clearcoatRoughnessFactor !== void 0) {
      materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
    }
    if (extension.clearcoatRoughnessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
    }
    if (extension.clearcoatNormalTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
      if (extension.clearcoatNormalTexture.scale !== void 0) {
        const scale5 = extension.clearcoatNormalTexture.scale;
        materialParams.clearcoatNormalScale = new Vector2$1(scale5, scale5);
      }
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsSheenExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    materialParams.sheenColor = new Color(0, 0, 0);
    materialParams.sheenRoughness = 0;
    materialParams.sheen = 1;
    const extension = materialDef.extensions[this.name];
    if (extension.sheenColorFactor !== void 0) {
      materialParams.sheenColor.fromArray(extension.sheenColorFactor);
    }
    if (extension.sheenRoughnessFactor !== void 0) {
      materialParams.sheenRoughness = extension.sheenRoughnessFactor;
    }
    if (extension.sheenColorTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, sRGBEncoding));
    }
    if (extension.sheenRoughnessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsTransmissionExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    if (extension.transmissionFactor !== void 0) {
      materialParams.transmission = extension.transmissionFactor;
    }
    if (extension.transmissionTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
    }
    return Promise.all(pending);
  }
}
class GLTFMaterialsVolumeExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.thickness = extension.thicknessFactor !== void 0 ? extension.thicknessFactor : 0;
    if (extension.thicknessTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
    }
    materialParams.attenuationDistance = extension.attenuationDistance || 0;
    const colorArray = extension.attenuationColor || [1, 1, 1];
    materialParams.attenuationColor = new Color(colorArray[0], colorArray[1], colorArray[2]);
    return Promise.all(pending);
  }
}
class GLTFMaterialsIorExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_MATERIALS_IOR;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const extension = materialDef.extensions[this.name];
    materialParams.ior = extension.ior !== void 0 ? extension.ior : 1.5;
    return Promise.resolve();
  }
}
class GLTFMaterialsSpecularExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(materialIndex) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name])
      return null;
    return MeshPhysicalMaterial;
  }
  extendMaterialParams(materialIndex, materialParams) {
    const parser = this.parser;
    const materialDef = parser.json.materials[materialIndex];
    if (!materialDef.extensions || !materialDef.extensions[this.name]) {
      return Promise.resolve();
    }
    const pending = [];
    const extension = materialDef.extensions[this.name];
    materialParams.specularIntensity = extension.specularFactor !== void 0 ? extension.specularFactor : 1;
    if (extension.specularTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
    }
    const colorArray = extension.specularColorFactor || [1, 1, 1];
    materialParams.specularColor = new Color(colorArray[0], colorArray[1], colorArray[2]);
    if (extension.specularColorTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, sRGBEncoding));
    }
    return Promise.all(pending);
  }
}
class GLTFTextureBasisUExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.KHR_TEXTURE_BASISU;
  }
  loadTexture(textureIndex) {
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[this.name]) {
      return null;
    }
    const extension = textureDef.extensions[this.name];
    const loader2 = parser.options.ktx2Loader;
    if (!loader2) {
      if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      } else {
        return null;
      }
    }
    return parser.loadTextureImage(textureIndex, extension.source, loader2);
  }
}
class GLTFTextureWebPExtension {
  constructor(parser) {
    this.parser = parser;
    this.name = EXTENSIONS$5.EXT_TEXTURE_WEBP;
    this.isSupported = null;
  }
  loadTexture(textureIndex) {
    const name2 = this.name;
    const parser = this.parser;
    const json = parser.json;
    const textureDef = json.textures[textureIndex];
    if (!textureDef.extensions || !textureDef.extensions[name2]) {
      return null;
    }
    const extension = textureDef.extensions[name2];
    const source = json.images[extension.source];
    let loader2 = parser.textureLoader;
    if (source.uri) {
      const handler = parser.options.manager.getHandler(source.uri);
      if (handler !== null)
        loader2 = handler;
    }
    return this.detectSupport().then(function(isSupported) {
      if (isSupported)
        return parser.loadTextureImage(textureIndex, extension.source, loader2);
      if (json.extensionsRequired && json.extensionsRequired.indexOf(name2) >= 0) {
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      }
      return parser.loadTexture(textureIndex);
    });
  }
  detectSupport() {
    if (!this.isSupported) {
      this.isSupported = new Promise(function(resolve2) {
        const image = new Image();
        image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        image.onload = image.onerror = function() {
          resolve2(image.height === 1);
        };
      });
    }
    return this.isSupported;
  }
}
class GLTFMeshoptCompression {
  constructor(parser) {
    this.name = EXTENSIONS$5.EXT_MESHOPT_COMPRESSION;
    this.parser = parser;
  }
  loadBufferView(index2) {
    const json = this.parser.json;
    const bufferView = json.bufferViews[index2];
    if (bufferView.extensions && bufferView.extensions[this.name]) {
      const extensionDef = bufferView.extensions[this.name];
      const buffer3 = this.parser.getDependency("buffer", extensionDef.buffer);
      const decoder = this.parser.options.meshoptDecoder;
      if (!decoder || !decoder.supported) {
        if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) {
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        } else {
          return null;
        }
      }
      return Promise.all([buffer3, decoder.ready]).then(function(res) {
        const byteOffset = extensionDef.byteOffset || 0;
        const byteLength = extensionDef.byteLength || 0;
        const count3 = extensionDef.count;
        const stride = extensionDef.byteStride;
        const result = new ArrayBuffer(count3 * stride);
        const source = new Uint8Array(res[0], byteOffset, byteLength);
        decoder.decodeGltfBuffer(new Uint8Array(result), count3, stride, source, extensionDef.mode, extensionDef.filter);
        return result;
      });
    } else {
      return null;
    }
  }
}
const BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const BINARY_EXTENSION_HEADER_LENGTH = 12;
const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 1313821514, BIN: 5130562 };
class GLTFBinaryExtension {
  constructor(data2) {
    this.name = EXTENSIONS$5.KHR_BINARY_GLTF;
    this.content = null;
    this.body = null;
    const headerView = new DataView(data2, 0, BINARY_EXTENSION_HEADER_LENGTH);
    this.header = {
      magic: LoaderUtils.decodeText(new Uint8Array(data2.slice(0, 4))),
      version: headerView.getUint32(4, true),
      length: headerView.getUint32(8, true)
    };
    if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    } else if (this.header.version < 2) {
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    }
    const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
    const chunkView = new DataView(data2, BINARY_EXTENSION_HEADER_LENGTH);
    let chunkIndex = 0;
    while (chunkIndex < chunkContentsLength) {
      const chunkLength = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      const chunkType = chunkView.getUint32(chunkIndex, true);
      chunkIndex += 4;
      if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
        const contentArray = new Uint8Array(data2, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
        this.content = LoaderUtils.decodeText(contentArray);
      } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
        const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
        this.body = data2.slice(byteOffset, byteOffset + chunkLength);
      }
      chunkIndex += chunkLength;
    }
    if (this.content === null) {
      throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
  }
}
class GLTFDracoMeshCompressionExtension {
  constructor(json, dracoLoader) {
    if (!dracoLoader) {
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    }
    this.name = EXTENSIONS$5.KHR_DRACO_MESH_COMPRESSION;
    this.json = json;
    this.dracoLoader = dracoLoader;
    this.dracoLoader.preload();
  }
  decodePrimitive(primitive, parser) {
    const json = this.json;
    const dracoLoader = this.dracoLoader;
    const bufferViewIndex = primitive.extensions[this.name].bufferView;
    const gltfAttributeMap = primitive.extensions[this.name].attributes;
    const threeAttributeMap = {};
    const attributeNormalizedMap = {};
    const attributeTypeMap = {};
    for (const attributeName in gltfAttributeMap) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
    }
    for (const attributeName in primitive.attributes) {
      const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
      if (gltfAttributeMap[attributeName] !== void 0) {
        const accessorDef = json.accessors[primitive.attributes[attributeName]];
        const componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
        attributeTypeMap[threeAttributeName] = componentType;
        attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
      }
    }
    return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
      return new Promise(function(resolve2) {
        dracoLoader.decodeDracoFile(bufferView, function(geometry2) {
          for (const attributeName in geometry2.attributes) {
            const attribute = geometry2.attributes[attributeName];
            const normalized = attributeNormalizedMap[attributeName];
            if (normalized !== void 0)
              attribute.normalized = normalized;
          }
          resolve2(geometry2);
        }, threeAttributeMap, attributeTypeMap);
      });
    });
  }
}
class GLTFTextureTransformExtension {
  constructor() {
    this.name = EXTENSIONS$5.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(texture, transform4) {
    if (transform4.texCoord !== void 0) {
      console.warn('THREE.GLTFLoader: Custom UV sets in "' + this.name + '" extension not yet supported.');
    }
    if (transform4.offset === void 0 && transform4.rotation === void 0 && transform4.scale === void 0) {
      return texture;
    }
    texture = texture.clone();
    if (transform4.offset !== void 0) {
      texture.offset.fromArray(transform4.offset);
    }
    if (transform4.rotation !== void 0) {
      texture.rotation = transform4.rotation;
    }
    if (transform4.scale !== void 0) {
      texture.repeat.fromArray(transform4.scale);
    }
    texture.needsUpdate = true;
    return texture;
  }
}
class GLTFMeshStandardSGMaterial extends MeshStandardMaterial {
  constructor(params2) {
    super();
    this.isGLTFSpecularGlossinessMaterial = true;
    const specularMapParsFragmentChunk = [
      "#ifdef USE_SPECULARMAP",
      "	uniform sampler2D specularMap;",
      "#endif"
    ].join("\n");
    const glossinessMapParsFragmentChunk = [
      "#ifdef USE_GLOSSINESSMAP",
      "	uniform sampler2D glossinessMap;",
      "#endif"
    ].join("\n");
    const specularMapFragmentChunk = [
      "vec3 specularFactor = specular;",
      "#ifdef USE_SPECULARMAP",
      "	vec4 texelSpecular = texture2D( specularMap, vUv );",
      "	// reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture",
      "	specularFactor *= texelSpecular.rgb;",
      "#endif"
    ].join("\n");
    const glossinessMapFragmentChunk = [
      "float glossinessFactor = glossiness;",
      "#ifdef USE_GLOSSINESSMAP",
      "	vec4 texelGlossiness = texture2D( glossinessMap, vUv );",
      "	// reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture",
      "	glossinessFactor *= texelGlossiness.a;",
      "#endif"
    ].join("\n");
    const lightPhysicalFragmentChunk = [
      "PhysicalMaterial material;",
      "material.diffuseColor = diffuseColor.rgb * ( 1. - max( specularFactor.r, max( specularFactor.g, specularFactor.b ) ) );",
      "vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );",
      "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );",
      "material.roughness = max( 1.0 - glossinessFactor, 0.0525 ); // 0.0525 corresponds to the base mip of a 256 cubemap.",
      "material.roughness += geometryRoughness;",
      "material.roughness = min( material.roughness, 1.0 );",
      "material.specularColor = specularFactor;"
    ].join("\n");
    const uniforms = {
      specular: { value: new Color().setHex(16777215) },
      glossiness: { value: 1 },
      specularMap: { value: null },
      glossinessMap: { value: null }
    };
    this._extraUniforms = uniforms;
    this.onBeforeCompile = function(shader) {
      for (const uniformName in uniforms) {
        shader.uniforms[uniformName] = uniforms[uniformName];
      }
      shader.fragmentShader = shader.fragmentShader.replace("uniform float roughness;", "uniform vec3 specular;").replace("uniform float metalness;", "uniform float glossiness;").replace("#include <roughnessmap_pars_fragment>", specularMapParsFragmentChunk).replace("#include <metalnessmap_pars_fragment>", glossinessMapParsFragmentChunk).replace("#include <roughnessmap_fragment>", specularMapFragmentChunk).replace("#include <metalnessmap_fragment>", glossinessMapFragmentChunk).replace("#include <lights_physical_fragment>", lightPhysicalFragmentChunk);
    };
    Object.defineProperties(this, {
      specular: {
        get: function() {
          return uniforms.specular.value;
        },
        set: function(v5) {
          uniforms.specular.value = v5;
        }
      },
      specularMap: {
        get: function() {
          return uniforms.specularMap.value;
        },
        set: function(v5) {
          uniforms.specularMap.value = v5;
          if (v5) {
            this.defines.USE_SPECULARMAP = "";
          } else {
            delete this.defines.USE_SPECULARMAP;
          }
        }
      },
      glossiness: {
        get: function() {
          return uniforms.glossiness.value;
        },
        set: function(v5) {
          uniforms.glossiness.value = v5;
        }
      },
      glossinessMap: {
        get: function() {
          return uniforms.glossinessMap.value;
        },
        set: function(v5) {
          uniforms.glossinessMap.value = v5;
          if (v5) {
            this.defines.USE_GLOSSINESSMAP = "";
            this.defines.USE_UV = "";
          } else {
            delete this.defines.USE_GLOSSINESSMAP;
            delete this.defines.USE_UV;
          }
        }
      }
    });
    delete this.metalness;
    delete this.roughness;
    delete this.metalnessMap;
    delete this.roughnessMap;
    this.setValues(params2);
  }
  copy(source) {
    super.copy(source);
    this.specularMap = source.specularMap;
    this.specular.copy(source.specular);
    this.glossinessMap = source.glossinessMap;
    this.glossiness = source.glossiness;
    delete this.metalness;
    delete this.roughness;
    delete this.metalnessMap;
    delete this.roughnessMap;
    return this;
  }
}
class GLTFMaterialsPbrSpecularGlossinessExtension {
  constructor() {
    this.name = EXTENSIONS$5.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS;
    this.specularGlossinessParams = [
      "color",
      "map",
      "lightMap",
      "lightMapIntensity",
      "aoMap",
      "aoMapIntensity",
      "emissive",
      "emissiveIntensity",
      "emissiveMap",
      "bumpMap",
      "bumpScale",
      "normalMap",
      "normalMapType",
      "displacementMap",
      "displacementScale",
      "displacementBias",
      "specularMap",
      "specular",
      "glossinessMap",
      "glossiness",
      "alphaMap",
      "envMap",
      "envMapIntensity"
    ];
  }
  getMaterialType() {
    return GLTFMeshStandardSGMaterial;
  }
  extendParams(materialParams, materialDef, parser) {
    const pbrSpecularGlossiness = materialDef.extensions[this.name];
    materialParams.color = new Color(1, 1, 1);
    materialParams.opacity = 1;
    const pending = [];
    if (Array.isArray(pbrSpecularGlossiness.diffuseFactor)) {
      const array2 = pbrSpecularGlossiness.diffuseFactor;
      materialParams.color.fromArray(array2);
      materialParams.opacity = array2[3];
    }
    if (pbrSpecularGlossiness.diffuseTexture !== void 0) {
      pending.push(parser.assignTexture(materialParams, "map", pbrSpecularGlossiness.diffuseTexture, sRGBEncoding));
    }
    materialParams.emissive = new Color(0, 0, 0);
    materialParams.glossiness = pbrSpecularGlossiness.glossinessFactor !== void 0 ? pbrSpecularGlossiness.glossinessFactor : 1;
    materialParams.specular = new Color(1, 1, 1);
    if (Array.isArray(pbrSpecularGlossiness.specularFactor)) {
      materialParams.specular.fromArray(pbrSpecularGlossiness.specularFactor);
    }
    if (pbrSpecularGlossiness.specularGlossinessTexture !== void 0) {
      const specGlossMapDef = pbrSpecularGlossiness.specularGlossinessTexture;
      pending.push(parser.assignTexture(materialParams, "glossinessMap", specGlossMapDef));
      pending.push(parser.assignTexture(materialParams, "specularMap", specGlossMapDef, sRGBEncoding));
    }
    return Promise.all(pending);
  }
  createMaterial(materialParams) {
    const material = new GLTFMeshStandardSGMaterial(materialParams);
    material.fog = true;
    material.color = materialParams.color;
    material.map = materialParams.map === void 0 ? null : materialParams.map;
    material.lightMap = null;
    material.lightMapIntensity = 1;
    material.aoMap = materialParams.aoMap === void 0 ? null : materialParams.aoMap;
    material.aoMapIntensity = 1;
    material.emissive = materialParams.emissive;
    material.emissiveIntensity = 1;
    material.emissiveMap = materialParams.emissiveMap === void 0 ? null : materialParams.emissiveMap;
    material.bumpMap = materialParams.bumpMap === void 0 ? null : materialParams.bumpMap;
    material.bumpScale = 1;
    material.normalMap = materialParams.normalMap === void 0 ? null : materialParams.normalMap;
    material.normalMapType = TangentSpaceNormalMap;
    if (materialParams.normalScale)
      material.normalScale = materialParams.normalScale;
    material.displacementMap = null;
    material.displacementScale = 1;
    material.displacementBias = 0;
    material.specularMap = materialParams.specularMap === void 0 ? null : materialParams.specularMap;
    material.specular = materialParams.specular;
    material.glossinessMap = materialParams.glossinessMap === void 0 ? null : materialParams.glossinessMap;
    material.glossiness = materialParams.glossiness;
    material.alphaMap = null;
    material.envMap = materialParams.envMap === void 0 ? null : materialParams.envMap;
    material.envMapIntensity = 1;
    return material;
  }
}
class GLTFMeshQuantizationExtension {
  constructor() {
    this.name = EXTENSIONS$5.KHR_MESH_QUANTIZATION;
  }
}
class GLTFCubicSplineInterpolant extends Interpolant {
  constructor(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    super(parameterPositions, sampleValues, sampleSize, resultBuffer);
  }
  copySampleValue_(index2) {
    const result = this.resultBuffer, values4 = this.sampleValues, valueSize = this.valueSize, offset = index2 * valueSize * 3 + valueSize;
    for (let i2 = 0; i2 !== valueSize; i2++) {
      result[i2] = values4[offset + i2];
    }
    return result;
  }
}
GLTFCubicSplineInterpolant.prototype.beforeStart_ = GLTFCubicSplineInterpolant.prototype.copySampleValue_;
GLTFCubicSplineInterpolant.prototype.afterEnd_ = GLTFCubicSplineInterpolant.prototype.copySampleValue_;
GLTFCubicSplineInterpolant.prototype.interpolate_ = function(i1, t0, t2, t1) {
  const result = this.resultBuffer;
  const values4 = this.sampleValues;
  const stride = this.valueSize;
  const stride2 = stride * 2;
  const stride3 = stride * 3;
  const td = t1 - t0;
  const p2 = (t2 - t0) / td;
  const pp = p2 * p2;
  const ppp = pp * p2;
  const offset1 = i1 * stride3;
  const offset0 = offset1 - stride3;
  const s2 = -2 * ppp + 3 * pp;
  const s3 = ppp - pp;
  const s0 = 1 - s2;
  const s1 = s3 - pp + p2;
  for (let i2 = 0; i2 !== stride; i2++) {
    const p0 = values4[offset0 + i2 + stride];
    const m0 = values4[offset0 + i2 + stride2] * td;
    const p1 = values4[offset1 + i2 + stride];
    const m1 = values4[offset1 + i2] * td;
    result[i2] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
  }
  return result;
};
const _q = new Quaternion$1();
class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {
  interpolate_(i1, t0, t2, t1) {
    const result = super.interpolate_(i1, t0, t2, t1);
    _q.fromArray(result).normalize().toArray(result);
    return result;
  }
}
const WEBGL_CONSTANTS = {
  FLOAT: 5126,
  //FLOAT_MAT2: 35674,
  FLOAT_MAT3: 35675,
  FLOAT_MAT4: 35676,
  FLOAT_VEC2: 35664,
  FLOAT_VEC3: 35665,
  FLOAT_VEC4: 35666,
  LINEAR: 9729,
  REPEAT: 10497,
  SAMPLER_2D: 35678,
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6,
  UNSIGNED_BYTE: 5121,
  UNSIGNED_SHORT: 5123
};
const WEBGL_COMPONENT_TYPES = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
const WEBGL_FILTERS = {
  9728: NearestFilter,
  9729: LinearFilter,
  9984: NearestMipmapNearestFilter,
  9985: LinearMipmapNearestFilter,
  9986: NearestMipmapLinearFilter,
  9987: LinearMipmapLinearFilter
};
const WEBGL_WRAPPINGS = {
  33071: ClampToEdgeWrapping,
  33648: MirroredRepeatWrapping,
  10497: RepeatWrapping
};
const WEBGL_TYPE_SIZES = {
  "SCALAR": 1,
  "VEC2": 2,
  "VEC3": 3,
  "VEC4": 4,
  "MAT2": 4,
  "MAT3": 9,
  "MAT4": 16
};
const ATTRIBUTES = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv2",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
};
const PATH_PROPERTIES = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
};
const INTERPOLATION = {
  CUBICSPLINE: void 0,
  // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: InterpolateLinear,
  STEP: InterpolateDiscrete
};
const ALPHA_MODES = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function createDefaultMaterial(cache2) {
  if (cache2["DefaultMaterial"] === void 0) {
    cache2["DefaultMaterial"] = new MeshStandardMaterial({
      color: 16777215,
      emissive: 0,
      metalness: 1,
      roughness: 1,
      transparent: false,
      depthTest: true,
      side: FrontSide
    });
  }
  return cache2["DefaultMaterial"];
}
function addUnknownExtensionsToUserData(knownExtensions, object2, objectDef) {
  for (const name2 in objectDef.extensions) {
    if (knownExtensions[name2] === void 0) {
      object2.userData.gltfExtensions = object2.userData.gltfExtensions || {};
      object2.userData.gltfExtensions[name2] = objectDef.extensions[name2];
    }
  }
}
function assignExtrasToUserData(object2, gltfDef) {
  if (gltfDef.extras !== void 0) {
    if (typeof gltfDef.extras === "object") {
      Object.assign(object2.userData, gltfDef.extras);
    } else {
      console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
  }
}
function addMorphTargets(geometry2, targets, parser) {
  let hasMorphPosition = false;
  let hasMorphNormal = false;
  let hasMorphColor = false;
  for (let i2 = 0, il = targets.length; i2 < il; i2++) {
    const target = targets[i2];
    if (target.POSITION !== void 0)
      hasMorphPosition = true;
    if (target.NORMAL !== void 0)
      hasMorphNormal = true;
    if (target.COLOR_0 !== void 0)
      hasMorphColor = true;
    if (hasMorphPosition && hasMorphNormal && hasMorphColor)
      break;
  }
  if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor)
    return Promise.resolve(geometry2);
  const pendingPositionAccessors = [];
  const pendingNormalAccessors = [];
  const pendingColorAccessors = [];
  for (let i2 = 0, il = targets.length; i2 < il; i2++) {
    const target = targets[i2];
    if (hasMorphPosition) {
      const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry2.attributes.position;
      pendingPositionAccessors.push(pendingAccessor);
    }
    if (hasMorphNormal) {
      const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry2.attributes.normal;
      pendingNormalAccessors.push(pendingAccessor);
    }
    if (hasMorphColor) {
      const pendingAccessor = target.COLOR_0 !== void 0 ? parser.getDependency("accessor", target.COLOR_0) : geometry2.attributes.color;
      pendingColorAccessors.push(pendingAccessor);
    }
  }
  return Promise.all([
    Promise.all(pendingPositionAccessors),
    Promise.all(pendingNormalAccessors),
    Promise.all(pendingColorAccessors)
  ]).then(function(accessors) {
    const morphPositions = accessors[0];
    const morphNormals = accessors[1];
    const morphColors = accessors[2];
    if (hasMorphPosition)
      geometry2.morphAttributes.position = morphPositions;
    if (hasMorphNormal)
      geometry2.morphAttributes.normal = morphNormals;
    if (hasMorphColor)
      geometry2.morphAttributes.color = morphColors;
    geometry2.morphTargetsRelative = true;
    return geometry2;
  });
}
function updateMorphTargets(mesh, meshDef) {
  mesh.updateMorphTargets();
  if (meshDef.weights !== void 0) {
    for (let i2 = 0, il = meshDef.weights.length; i2 < il; i2++) {
      mesh.morphTargetInfluences[i2] = meshDef.weights[i2];
    }
  }
  if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
    const targetNames = meshDef.extras.targetNames;
    if (mesh.morphTargetInfluences.length === targetNames.length) {
      mesh.morphTargetDictionary = {};
      for (let i2 = 0, il = targetNames.length; i2 < il; i2++) {
        mesh.morphTargetDictionary[targetNames[i2]] = i2;
      }
    } else {
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
  }
}
function createPrimitiveKey(primitiveDef) {
  const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS$5.KHR_DRACO_MESH_COMPRESSION];
  let geometryKey;
  if (dracoExtension) {
    geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + createAttributesKey(dracoExtension.attributes);
  } else {
    geometryKey = primitiveDef.indices + ":" + createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
  }
  return geometryKey;
}
function createAttributesKey(attributes) {
  let attributesKey = "";
  const keys4 = Object.keys(attributes).sort();
  for (let i2 = 0, il = keys4.length; i2 < il; i2++) {
    attributesKey += keys4[i2] + ":" + attributes[keys4[i2]] + ";";
  }
  return attributesKey;
}
function getNormalizedComponentScale(constructor) {
  switch (constructor) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function getImageURIMimeType(uri) {
  if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0)
    return "image/jpeg";
  if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0)
    return "image/webp";
  return "image/png";
}
class GLTFParser {
  constructor(json = {}, options2 = {}) {
    this.json = json;
    this.extensions = {};
    this.plugins = {};
    this.options = options2;
    this.cache = new GLTFRegistry();
    this.associations = /* @__PURE__ */ new Map();
    this.primitiveCache = {};
    this.meshCache = { refs: {}, uses: {} };
    this.cameraCache = { refs: {}, uses: {} };
    this.lightCache = { refs: {}, uses: {} };
    this.sourceCache = {};
    this.textureCache = {};
    this.nodeNamesUsed = {};
    if (typeof createImageBitmap !== "undefined" && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === false) {
      this.textureLoader = new ImageBitmapLoader(this.options.manager);
    } else {
      this.textureLoader = new TextureLoader(this.options.manager);
    }
    this.textureLoader.setCrossOrigin(this.options.crossOrigin);
    this.textureLoader.setRequestHeader(this.options.requestHeader);
    this.fileLoader = new FileLoader(this.options.manager);
    this.fileLoader.setResponseType("arraybuffer");
    if (this.options.crossOrigin === "use-credentials") {
      this.fileLoader.setWithCredentials(true);
    }
  }
  setExtensions(extensions) {
    this.extensions = extensions;
  }
  setPlugins(plugins) {
    this.plugins = plugins;
  }
  parse(onLoad, onError) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    this.cache.removeAll();
    this._invokeAll(function(ext) {
      return ext._markDefs && ext._markDefs();
    });
    Promise.all(this._invokeAll(function(ext) {
      return ext.beforeRoot && ext.beforeRoot();
    })).then(function() {
      return Promise.all([
        parser.getDependencies("scene"),
        parser.getDependencies("animation"),
        parser.getDependencies("camera")
      ]);
    }).then(function(dependencies2) {
      const result = {
        scene: dependencies2[0][json.scene || 0],
        scenes: dependencies2[0],
        animations: dependencies2[1],
        cameras: dependencies2[2],
        asset: json.asset,
        parser,
        userData: {}
      };
      addUnknownExtensionsToUserData(extensions, result, json);
      assignExtrasToUserData(result, json);
      Promise.all(parser._invokeAll(function(ext) {
        return ext.afterRoot && ext.afterRoot(result);
      })).then(function() {
        onLoad(result);
      });
    }).catch(onError);
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   */
  _markDefs() {
    const nodeDefs = this.json.nodes || [];
    const skinDefs = this.json.skins || [];
    const meshDefs = this.json.meshes || [];
    for (let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++) {
      const joints = skinDefs[skinIndex].joints;
      for (let i2 = 0, il = joints.length; i2 < il; i2++) {
        nodeDefs[joints[i2]].isBone = true;
      }
    }
    for (let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++) {
      const nodeDef = nodeDefs[nodeIndex];
      if (nodeDef.mesh !== void 0) {
        this._addNodeRef(this.meshCache, nodeDef.mesh);
        if (nodeDef.skin !== void 0) {
          meshDefs[nodeDef.mesh].isSkinnedMesh = true;
        }
      }
      if (nodeDef.camera !== void 0) {
        this._addNodeRef(this.cameraCache, nodeDef.camera);
      }
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */
  _addNodeRef(cache2, index2) {
    if (index2 === void 0)
      return;
    if (cache2.refs[index2] === void 0) {
      cache2.refs[index2] = cache2.uses[index2] = 0;
    }
    cache2.refs[index2]++;
  }
  /** Returns a reference to a shared resource, cloning it if necessary. */
  _getNodeRef(cache2, index2, object2) {
    if (cache2.refs[index2] <= 1)
      return object2;
    const ref = object2.clone();
    const updateMappings = (original, clone8) => {
      const mappings = this.associations.get(original);
      if (mappings != null) {
        this.associations.set(clone8, mappings);
      }
      for (const [i2, child] of original.children.entries()) {
        updateMappings(child, clone8.children[i2]);
      }
    };
    updateMappings(object2, ref);
    ref.name += "_instance_" + cache2.uses[index2]++;
    return ref;
  }
  _invokeOne(func2) {
    const extensions = Object.values(this.plugins);
    extensions.push(this);
    for (let i2 = 0; i2 < extensions.length; i2++) {
      const result = func2(extensions[i2]);
      if (result)
        return result;
    }
    return null;
  }
  _invokeAll(func2) {
    const extensions = Object.values(this.plugins);
    extensions.unshift(this);
    const pending = [];
    for (let i2 = 0; i2 < extensions.length; i2++) {
      const result = func2(extensions[i2]);
      if (result)
        pending.push(result);
    }
    return pending;
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(type, index2) {
    const cacheKey = type + ":" + index2;
    let dependency = this.cache.get(cacheKey);
    if (!dependency) {
      switch (type) {
        case "scene":
          dependency = this.loadScene(index2);
          break;
        case "node":
          dependency = this.loadNode(index2);
          break;
        case "mesh":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMesh && ext.loadMesh(index2);
          });
          break;
        case "accessor":
          dependency = this.loadAccessor(index2);
          break;
        case "bufferView":
          dependency = this._invokeOne(function(ext) {
            return ext.loadBufferView && ext.loadBufferView(index2);
          });
          break;
        case "buffer":
          dependency = this.loadBuffer(index2);
          break;
        case "material":
          dependency = this._invokeOne(function(ext) {
            return ext.loadMaterial && ext.loadMaterial(index2);
          });
          break;
        case "texture":
          dependency = this._invokeOne(function(ext) {
            return ext.loadTexture && ext.loadTexture(index2);
          });
          break;
        case "skin":
          dependency = this.loadSkin(index2);
          break;
        case "animation":
          dependency = this.loadAnimation(index2);
          break;
        case "camera":
          dependency = this.loadCamera(index2);
          break;
        default:
          throw new Error("Unknown type: " + type);
      }
      this.cache.add(cacheKey, dependency);
    }
    return dependency;
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(type) {
    let dependencies2 = this.cache.get(type);
    if (!dependencies2) {
      const parser = this;
      const defs2 = this.json[type + (type === "mesh" ? "es" : "s")] || [];
      dependencies2 = Promise.all(defs2.map(function(def, index2) {
        return parser.getDependency(type, index2);
      }));
      this.cache.add(type, dependencies2);
    }
    return dependencies2;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(bufferIndex) {
    const bufferDef = this.json.buffers[bufferIndex];
    const loader2 = this.fileLoader;
    if (bufferDef.type && bufferDef.type !== "arraybuffer") {
      throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
    }
    if (bufferDef.uri === void 0 && bufferIndex === 0) {
      return Promise.resolve(this.extensions[EXTENSIONS$5.KHR_BINARY_GLTF].body);
    }
    const options2 = this.options;
    return new Promise(function(resolve2, reject) {
      loader2.load(LoaderUtils.resolveURL(bufferDef.uri, options2.path), resolve2, void 0, function() {
        reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
      });
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(bufferViewIndex) {
    const bufferViewDef = this.json.bufferViews[bufferViewIndex];
    return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer3) {
      const byteLength = bufferViewDef.byteLength || 0;
      const byteOffset = bufferViewDef.byteOffset || 0;
      return buffer3.slice(byteOffset, byteOffset + byteLength);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(accessorIndex) {
    const parser = this;
    const json = this.json;
    const accessorDef = this.json.accessors[accessorIndex];
    if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
      return Promise.resolve(null);
    }
    const pendingBufferViews = [];
    if (accessorDef.bufferView !== void 0) {
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
    } else {
      pendingBufferViews.push(null);
    }
    if (accessorDef.sparse !== void 0) {
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
      pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
    }
    return Promise.all(pendingBufferViews).then(function(bufferViews) {
      const bufferView = bufferViews[0];
      const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
      const TypedArray2 = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
      const elementBytes = TypedArray2.BYTES_PER_ELEMENT;
      const itemBytes = elementBytes * itemSize;
      const byteOffset = accessorDef.byteOffset || 0;
      const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
      const normalized = accessorDef.normalized === true;
      let array2, bufferAttribute;
      if (byteStride && byteStride !== itemBytes) {
        const ibSlice = Math.floor(byteOffset / byteStride);
        const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
        let ib = parser.cache.get(ibCacheKey);
        if (!ib) {
          array2 = new TypedArray2(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
          ib = new InterleavedBuffer(array2, byteStride / elementBytes);
          parser.cache.add(ibCacheKey, ib);
        }
        bufferAttribute = new InterleavedBufferAttribute(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
      } else {
        if (bufferView === null) {
          array2 = new TypedArray2(accessorDef.count * itemSize);
        } else {
          array2 = new TypedArray2(bufferView, byteOffset, accessorDef.count * itemSize);
        }
        bufferAttribute = new BufferAttribute(array2, itemSize, normalized);
      }
      if (accessorDef.sparse !== void 0) {
        const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
        const TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
        const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
        const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
        const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
        const sparseValues = new TypedArray2(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
        if (bufferView !== null) {
          bufferAttribute = new BufferAttribute(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
        }
        for (let i2 = 0, il = sparseIndices.length; i2 < il; i2++) {
          const index2 = sparseIndices[i2];
          bufferAttribute.setX(index2, sparseValues[i2 * itemSize]);
          if (itemSize >= 2)
            bufferAttribute.setY(index2, sparseValues[i2 * itemSize + 1]);
          if (itemSize >= 3)
            bufferAttribute.setZ(index2, sparseValues[i2 * itemSize + 2]);
          if (itemSize >= 4)
            bufferAttribute.setW(index2, sparseValues[i2 * itemSize + 3]);
          if (itemSize >= 5)
            throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
      }
      return bufferAttribute;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture>}
   */
  loadTexture(textureIndex) {
    const json = this.json;
    const options2 = this.options;
    const textureDef = json.textures[textureIndex];
    const sourceIndex = textureDef.source;
    const sourceDef = json.images[sourceIndex];
    let loader2 = this.textureLoader;
    if (sourceDef.uri) {
      const handler = options2.manager.getHandler(sourceDef.uri);
      if (handler !== null)
        loader2 = handler;
    }
    return this.loadTextureImage(textureIndex, sourceIndex, loader2);
  }
  loadTextureImage(textureIndex, sourceIndex, loader2) {
    const parser = this;
    const json = this.json;
    const textureDef = json.textures[textureIndex];
    const sourceDef = json.images[sourceIndex];
    const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
    if (this.textureCache[cacheKey]) {
      return this.textureCache[cacheKey];
    }
    const promise = this.loadImageSource(sourceIndex, loader2).then(function(texture) {
      texture.flipY = false;
      if (textureDef.name)
        texture.name = textureDef.name;
      const samplers = json.samplers || {};
      const sampler = samplers[textureDef.sampler] || {};
      texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || LinearFilter;
      texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || LinearMipmapLinearFilter;
      texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || RepeatWrapping;
      texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || RepeatWrapping;
      parser.associations.set(texture, { textures: textureIndex });
      return texture;
    }).catch(function() {
      return null;
    });
    this.textureCache[cacheKey] = promise;
    return promise;
  }
  loadImageSource(sourceIndex, loader2) {
    const parser = this;
    const json = this.json;
    const options2 = this.options;
    if (this.sourceCache[sourceIndex] !== void 0) {
      return this.sourceCache[sourceIndex].then((texture) => texture.clone());
    }
    const sourceDef = json.images[sourceIndex];
    const URL2 = self.URL || self.webkitURL;
    let sourceURI = sourceDef.uri || "";
    let isObjectURL = false;
    if (sourceDef.bufferView !== void 0) {
      sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
        isObjectURL = true;
        const blob = new Blob([bufferView], { type: sourceDef.mimeType });
        sourceURI = URL2.createObjectURL(blob);
        return sourceURI;
      });
    } else if (sourceDef.uri === void 0) {
      throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
    }
    const promise = Promise.resolve(sourceURI).then(function(sourceURI2) {
      return new Promise(function(resolve2, reject) {
        let onLoad = resolve2;
        if (loader2.isImageBitmapLoader === true) {
          onLoad = function(imageBitmap) {
            const texture = new Texture$1(imageBitmap);
            texture.needsUpdate = true;
            resolve2(texture);
          };
        }
        loader2.load(LoaderUtils.resolveURL(sourceURI2, options2.path), onLoad, void 0, reject);
      });
    }).then(function(texture) {
      if (isObjectURL === true) {
        URL2.revokeObjectURL(sourceURI);
      }
      texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);
      return texture;
    }).catch(function(error2) {
      console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
      throw error2;
    });
    this.sourceCache[sourceIndex] = promise;
    return promise;
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */
  assignTexture(materialParams, mapName, mapDef, encoding) {
    const parser = this;
    return this.getDependency("texture", mapDef.index).then(function(texture) {
      if (mapDef.texCoord !== void 0 && mapDef.texCoord != 0 && !(mapName === "aoMap" && mapDef.texCoord == 1)) {
        console.warn("THREE.GLTFLoader: Custom UV set " + mapDef.texCoord + " for texture " + mapName + " not yet supported.");
      }
      if (parser.extensions[EXTENSIONS$5.KHR_TEXTURE_TRANSFORM]) {
        const transform4 = mapDef.extensions !== void 0 ? mapDef.extensions[EXTENSIONS$5.KHR_TEXTURE_TRANSFORM] : void 0;
        if (transform4) {
          const gltfReference = parser.associations.get(texture);
          texture = parser.extensions[EXTENSIONS$5.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform4);
          parser.associations.set(texture, gltfReference);
        }
      }
      if (encoding !== void 0) {
        texture.encoding = encoding;
      }
      materialParams[mapName] = texture;
      return texture;
    });
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(mesh) {
    const geometry2 = mesh.geometry;
    let material = mesh.material;
    const useDerivativeTangents = geometry2.attributes.tangent === void 0;
    const useVertexColors = geometry2.attributes.color !== void 0;
    const useFlatShading = geometry2.attributes.normal === void 0;
    if (mesh.isPoints) {
      const cacheKey = "PointsMaterial:" + material.uuid;
      let pointsMaterial = this.cache.get(cacheKey);
      if (!pointsMaterial) {
        pointsMaterial = new PointsMaterial();
        Material$1.prototype.copy.call(pointsMaterial, material);
        pointsMaterial.color.copy(material.color);
        pointsMaterial.map = material.map;
        pointsMaterial.sizeAttenuation = false;
        this.cache.add(cacheKey, pointsMaterial);
      }
      material = pointsMaterial;
    } else if (mesh.isLine) {
      const cacheKey = "LineBasicMaterial:" + material.uuid;
      let lineMaterial = this.cache.get(cacheKey);
      if (!lineMaterial) {
        lineMaterial = new LineBasicMaterial();
        Material$1.prototype.copy.call(lineMaterial, material);
        lineMaterial.color.copy(material.color);
        this.cache.add(cacheKey, lineMaterial);
      }
      material = lineMaterial;
    }
    if (useDerivativeTangents || useVertexColors || useFlatShading) {
      let cacheKey = "ClonedMaterial:" + material.uuid + ":";
      if (material.isGLTFSpecularGlossinessMaterial)
        cacheKey += "specular-glossiness:";
      if (useDerivativeTangents)
        cacheKey += "derivative-tangents:";
      if (useVertexColors)
        cacheKey += "vertex-colors:";
      if (useFlatShading)
        cacheKey += "flat-shading:";
      let cachedMaterial = this.cache.get(cacheKey);
      if (!cachedMaterial) {
        cachedMaterial = material.clone();
        if (useVertexColors)
          cachedMaterial.vertexColors = true;
        if (useFlatShading)
          cachedMaterial.flatShading = true;
        if (useDerivativeTangents) {
          if (cachedMaterial.normalScale)
            cachedMaterial.normalScale.y *= -1;
          if (cachedMaterial.clearcoatNormalScale)
            cachedMaterial.clearcoatNormalScale.y *= -1;
        }
        this.cache.add(cacheKey, cachedMaterial);
        this.associations.set(cachedMaterial, this.associations.get(material));
      }
      material = cachedMaterial;
    }
    if (material.aoMap && geometry2.attributes.uv2 === void 0 && geometry2.attributes.uv !== void 0) {
      geometry2.setAttribute("uv2", geometry2.attributes.uv);
    }
    mesh.material = material;
  }
  getMaterialType() {
    return MeshStandardMaterial;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(materialIndex) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    const materialDef = json.materials[materialIndex];
    let materialType;
    const materialParams = {};
    const materialExtensions = materialDef.extensions || {};
    const pending = [];
    if (materialExtensions[EXTENSIONS$5.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {
      const sgExtension = extensions[EXTENSIONS$5.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
      materialType = sgExtension.getMaterialType();
      pending.push(sgExtension.extendParams(materialParams, materialDef, parser));
    } else if (materialExtensions[EXTENSIONS$5.KHR_MATERIALS_UNLIT]) {
      const kmuExtension = extensions[EXTENSIONS$5.KHR_MATERIALS_UNLIT];
      materialType = kmuExtension.getMaterialType();
      pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
    } else {
      const metallicRoughness = materialDef.pbrMetallicRoughness || {};
      materialParams.color = new Color(1, 1, 1);
      materialParams.opacity = 1;
      if (Array.isArray(metallicRoughness.baseColorFactor)) {
        const array2 = metallicRoughness.baseColorFactor;
        materialParams.color.fromArray(array2);
        materialParams.opacity = array2[3];
      }
      if (metallicRoughness.baseColorTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, sRGBEncoding));
      }
      materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
      materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
      if (metallicRoughness.metallicRoughnessTexture !== void 0) {
        pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
        pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
      }
      materialType = this._invokeOne(function(ext) {
        return ext.getMaterialType && ext.getMaterialType(materialIndex);
      });
      pending.push(Promise.all(this._invokeAll(function(ext) {
        return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
      })));
    }
    if (materialDef.doubleSided === true) {
      materialParams.side = DoubleSide;
    }
    const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
    if (alphaMode === ALPHA_MODES.BLEND) {
      materialParams.transparent = true;
      materialParams.depthWrite = false;
    } else {
      materialParams.transparent = false;
      if (alphaMode === ALPHA_MODES.MASK) {
        materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
      }
    }
    if (materialDef.normalTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
      materialParams.normalScale = new Vector2$1(1, 1);
      if (materialDef.normalTexture.scale !== void 0) {
        const scale5 = materialDef.normalTexture.scale;
        materialParams.normalScale.set(scale5, scale5);
      }
    }
    if (materialDef.occlusionTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
      if (materialDef.occlusionTexture.strength !== void 0) {
        materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
      }
    }
    if (materialDef.emissiveFactor !== void 0 && materialType !== MeshBasicMaterial) {
      materialParams.emissive = new Color().fromArray(materialDef.emissiveFactor);
    }
    if (materialDef.emissiveTexture !== void 0 && materialType !== MeshBasicMaterial) {
      pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, sRGBEncoding));
    }
    return Promise.all(pending).then(function() {
      let material;
      if (materialType === GLTFMeshStandardSGMaterial) {
        material = extensions[EXTENSIONS$5.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS].createMaterial(materialParams);
      } else {
        material = new materialType(materialParams);
      }
      if (materialDef.name)
        material.name = materialDef.name;
      assignExtrasToUserData(material, materialDef);
      parser.associations.set(material, { materials: materialIndex });
      if (materialDef.extensions)
        addUnknownExtensionsToUserData(extensions, material, materialDef);
      return material;
    });
  }
  /** When Object3D instances are targeted by animation, they need unique names. */
  createUniqueName(originalName) {
    const sanitizedName = PropertyBinding.sanitizeNodeName(originalName || "");
    let name2 = sanitizedName;
    for (let i2 = 1; this.nodeNamesUsed[name2]; ++i2) {
      name2 = sanitizedName + "_" + i2;
    }
    this.nodeNamesUsed[name2] = true;
    return name2;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(primitives) {
    const parser = this;
    const extensions = this.extensions;
    const cache2 = this.primitiveCache;
    function createDracoPrimitive(primitive) {
      return extensions[EXTENSIONS$5.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry2) {
        return addPrimitiveAttributes(geometry2, primitive, parser);
      });
    }
    const pending = [];
    for (let i2 = 0, il = primitives.length; i2 < il; i2++) {
      const primitive = primitives[i2];
      const cacheKey = createPrimitiveKey(primitive);
      const cached = cache2[cacheKey];
      if (cached) {
        pending.push(cached.promise);
      } else {
        let geometryPromise;
        if (primitive.extensions && primitive.extensions[EXTENSIONS$5.KHR_DRACO_MESH_COMPRESSION]) {
          geometryPromise = createDracoPrimitive(primitive);
        } else {
          geometryPromise = addPrimitiveAttributes(new BufferGeometry(), primitive, parser);
        }
        cache2[cacheKey] = { primitive, promise: geometryPromise };
        pending.push(geometryPromise);
      }
    }
    return Promise.all(pending);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */
  loadMesh(meshIndex) {
    const parser = this;
    const json = this.json;
    const extensions = this.extensions;
    const meshDef = json.meshes[meshIndex];
    const primitives = meshDef.primitives;
    const pending = [];
    for (let i2 = 0, il = primitives.length; i2 < il; i2++) {
      const material = primitives[i2].material === void 0 ? createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i2].material);
      pending.push(material);
    }
    pending.push(parser.loadGeometries(primitives));
    return Promise.all(pending).then(function(results) {
      const materials = results.slice(0, results.length - 1);
      const geometries = results[results.length - 1];
      const meshes = [];
      for (let i2 = 0, il = geometries.length; i2 < il; i2++) {
        const geometry2 = geometries[i2];
        const primitive = primitives[i2];
        let mesh;
        const material = materials[i2];
        if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
          mesh = meshDef.isSkinnedMesh === true ? new SkinnedMesh(geometry2, material) : new Mesh(geometry2, material);
          if (mesh.isSkinnedMesh === true && !mesh.geometry.attributes.skinWeight.normalized) {
            mesh.normalizeSkinWeights();
          }
          if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleStripDrawMode);
          } else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) {
            mesh.geometry = toTrianglesDrawMode(mesh.geometry, TriangleFanDrawMode);
          }
        } else if (primitive.mode === WEBGL_CONSTANTS.LINES) {
          mesh = new LineSegments(geometry2, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) {
          mesh = new Line(geometry2, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) {
          mesh = new LineLoop(geometry2, material);
        } else if (primitive.mode === WEBGL_CONSTANTS.POINTS) {
          mesh = new Points(geometry2, material);
        } else {
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
        }
        if (Object.keys(mesh.geometry.morphAttributes).length > 0) {
          updateMorphTargets(mesh, meshDef);
        }
        mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
        assignExtrasToUserData(mesh, meshDef);
        if (primitive.extensions)
          addUnknownExtensionsToUserData(extensions, mesh, primitive);
        parser.assignFinalMaterial(mesh);
        meshes.push(mesh);
      }
      for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
        parser.associations.set(meshes[i2], {
          meshes: meshIndex,
          primitives: i2
        });
      }
      if (meshes.length === 1) {
        return meshes[0];
      }
      const group = new Group();
      parser.associations.set(group, { meshes: meshIndex });
      for (let i2 = 0, il = meshes.length; i2 < il; i2++) {
        group.add(meshes[i2]);
      }
      return group;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */
  loadCamera(cameraIndex) {
    let camera;
    const cameraDef = this.json.cameras[cameraIndex];
    const params2 = cameraDef[cameraDef.type];
    if (!params2) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    if (cameraDef.type === "perspective") {
      camera = new PerspectiveCamera(MathUtils.radToDeg(params2.yfov), params2.aspectRatio || 1, params2.znear || 1, params2.zfar || 2e6);
    } else if (cameraDef.type === "orthographic") {
      camera = new OrthographicCamera(-params2.xmag, params2.xmag, params2.ymag, -params2.ymag, params2.znear, params2.zfar);
    }
    if (cameraDef.name)
      camera.name = this.createUniqueName(cameraDef.name);
    assignExtrasToUserData(camera, cameraDef);
    return Promise.resolve(camera);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Object>}
   */
  loadSkin(skinIndex) {
    const skinDef = this.json.skins[skinIndex];
    const skinEntry = { joints: skinDef.joints };
    if (skinDef.inverseBindMatrices === void 0) {
      return Promise.resolve(skinEntry);
    }
    return this.getDependency("accessor", skinDef.inverseBindMatrices).then(function(accessor) {
      skinEntry.inverseBindMatrices = accessor;
      return skinEntry;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(animationIndex) {
    const json = this.json;
    const animationDef = json.animations[animationIndex];
    const pendingNodes = [];
    const pendingInputAccessors = [];
    const pendingOutputAccessors = [];
    const pendingSamplers = [];
    const pendingTargets = [];
    for (let i2 = 0, il = animationDef.channels.length; i2 < il; i2++) {
      const channel = animationDef.channels[i2];
      const sampler = animationDef.samplers[channel.sampler];
      const target = channel.target;
      const name2 = target.node !== void 0 ? target.node : target.id;
      const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
      const output2 = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
      pendingNodes.push(this.getDependency("node", name2));
      pendingInputAccessors.push(this.getDependency("accessor", input));
      pendingOutputAccessors.push(this.getDependency("accessor", output2));
      pendingSamplers.push(sampler);
      pendingTargets.push(target);
    }
    return Promise.all([
      Promise.all(pendingNodes),
      Promise.all(pendingInputAccessors),
      Promise.all(pendingOutputAccessors),
      Promise.all(pendingSamplers),
      Promise.all(pendingTargets)
    ]).then(function(dependencies2) {
      const nodes = dependencies2[0];
      const inputAccessors = dependencies2[1];
      const outputAccessors = dependencies2[2];
      const samplers = dependencies2[3];
      const targets = dependencies2[4];
      const tracks = [];
      for (let i2 = 0, il = nodes.length; i2 < il; i2++) {
        const node = nodes[i2];
        const inputAccessor = inputAccessors[i2];
        const outputAccessor = outputAccessors[i2];
        const sampler = samplers[i2];
        const target = targets[i2];
        if (node === void 0)
          continue;
        node.updateMatrix();
        node.matrixAutoUpdate = true;
        let TypedKeyframeTrack;
        switch (PATH_PROPERTIES[target.path]) {
          case PATH_PROPERTIES.weights:
            TypedKeyframeTrack = NumberKeyframeTrack;
            break;
          case PATH_PROPERTIES.rotation:
            TypedKeyframeTrack = QuaternionKeyframeTrack;
            break;
          case PATH_PROPERTIES.position:
          case PATH_PROPERTIES.scale:
          default:
            TypedKeyframeTrack = VectorKeyframeTrack;
            break;
        }
        const targetName = node.name ? node.name : node.uuid;
        const interpolation = sampler.interpolation !== void 0 ? INTERPOLATION[sampler.interpolation] : InterpolateLinear;
        const targetNames = [];
        if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) {
          node.traverse(function(object2) {
            if (object2.morphTargetInfluences) {
              targetNames.push(object2.name ? object2.name : object2.uuid);
            }
          });
        } else {
          targetNames.push(targetName);
        }
        let outputArray = outputAccessor.array;
        if (outputAccessor.normalized) {
          const scale5 = getNormalizedComponentScale(outputArray.constructor);
          const scaled = new Float32Array(outputArray.length);
          for (let j2 = 0, jl = outputArray.length; j2 < jl; j2++) {
            scaled[j2] = outputArray[j2] * scale5;
          }
          outputArray = scaled;
        }
        for (let j2 = 0, jl = targetNames.length; j2 < jl; j2++) {
          const track = new TypedKeyframeTrack(
            targetNames[j2] + "." + PATH_PROPERTIES[target.path],
            inputAccessor.array,
            outputArray,
            interpolation
          );
          if (sampler.interpolation === "CUBICSPLINE") {
            track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
              const interpolantType = this instanceof QuaternionKeyframeTrack ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
              return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
            };
            track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
          }
          tracks.push(track);
        }
      }
      const name2 = animationDef.name ? animationDef.name : "animation_" + animationIndex;
      return new AnimationClip(name2, void 0, tracks);
    });
  }
  createNodeMesh(nodeIndex) {
    const json = this.json;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    if (nodeDef.mesh === void 0)
      return null;
    return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
      const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
      if (nodeDef.weights !== void 0) {
        node.traverse(function(o2) {
          if (!o2.isMesh)
            return;
          for (let i2 = 0, il = nodeDef.weights.length; i2 < il; i2++) {
            o2.morphTargetInfluences[i2] = nodeDef.weights[i2];
          }
        });
      }
      return node;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(nodeIndex) {
    const json = this.json;
    const extensions = this.extensions;
    const parser = this;
    const nodeDef = json.nodes[nodeIndex];
    const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
    return function() {
      const pending = [];
      const meshPromise = parser._invokeOne(function(ext) {
        return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
      });
      if (meshPromise) {
        pending.push(meshPromise);
      }
      if (nodeDef.camera !== void 0) {
        pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
          return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
      }
      parser._invokeAll(function(ext) {
        return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
      }).forEach(function(promise) {
        pending.push(promise);
      });
      return Promise.all(pending);
    }().then(function(objects) {
      let node;
      if (nodeDef.isBone === true) {
        node = new Bone();
      } else if (objects.length > 1) {
        node = new Group();
      } else if (objects.length === 1) {
        node = objects[0];
      } else {
        node = new Object3D();
      }
      if (node !== objects[0]) {
        for (let i2 = 0, il = objects.length; i2 < il; i2++) {
          node.add(objects[i2]);
        }
      }
      if (nodeDef.name) {
        node.userData.name = nodeDef.name;
        node.name = nodeName;
      }
      assignExtrasToUserData(node, nodeDef);
      if (nodeDef.extensions)
        addUnknownExtensionsToUserData(extensions, node, nodeDef);
      if (nodeDef.matrix !== void 0) {
        const matrix = new Matrix4$1();
        matrix.fromArray(nodeDef.matrix);
        node.applyMatrix4(matrix);
      } else {
        if (nodeDef.translation !== void 0) {
          node.position.fromArray(nodeDef.translation);
        }
        if (nodeDef.rotation !== void 0) {
          node.quaternion.fromArray(nodeDef.rotation);
        }
        if (nodeDef.scale !== void 0) {
          node.scale.fromArray(nodeDef.scale);
        }
      }
      if (!parser.associations.has(node)) {
        parser.associations.set(node, {});
      }
      parser.associations.get(node).nodes = nodeIndex;
      return node;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(sceneIndex) {
    const json = this.json;
    const extensions = this.extensions;
    const sceneDef = this.json.scenes[sceneIndex];
    const parser = this;
    const scene = new Group();
    if (sceneDef.name)
      scene.name = parser.createUniqueName(sceneDef.name);
    assignExtrasToUserData(scene, sceneDef);
    if (sceneDef.extensions)
      addUnknownExtensionsToUserData(extensions, scene, sceneDef);
    const nodeIds = sceneDef.nodes || [];
    const pending = [];
    for (let i2 = 0, il = nodeIds.length; i2 < il; i2++) {
      pending.push(buildNodeHierarchy(nodeIds[i2], scene, json, parser));
    }
    return Promise.all(pending).then(function() {
      const reduceAssociations = (node) => {
        const reducedAssociations = /* @__PURE__ */ new Map();
        for (const [key, value] of parser.associations) {
          if (key instanceof Material$1 || key instanceof Texture$1) {
            reducedAssociations.set(key, value);
          }
        }
        node.traverse((node2) => {
          const mappings = parser.associations.get(node2);
          if (mappings != null) {
            reducedAssociations.set(node2, mappings);
          }
        });
        return reducedAssociations;
      };
      parser.associations = reduceAssociations(scene);
      return scene;
    });
  }
}
function buildNodeHierarchy(nodeId, parentObject, json, parser) {
  const nodeDef = json.nodes[nodeId];
  return parser.getDependency("node", nodeId).then(function(node) {
    if (nodeDef.skin === void 0)
      return node;
    let skinEntry;
    return parser.getDependency("skin", nodeDef.skin).then(function(skin) {
      skinEntry = skin;
      const pendingJoints = [];
      for (let i2 = 0, il = skinEntry.joints.length; i2 < il; i2++) {
        pendingJoints.push(parser.getDependency("node", skinEntry.joints[i2]));
      }
      return Promise.all(pendingJoints);
    }).then(function(jointNodes) {
      node.traverse(function(mesh) {
        if (!mesh.isMesh)
          return;
        const bones = [];
        const boneInverses = [];
        for (let j2 = 0, jl = jointNodes.length; j2 < jl; j2++) {
          const jointNode = jointNodes[j2];
          if (jointNode) {
            bones.push(jointNode);
            const mat = new Matrix4$1();
            if (skinEntry.inverseBindMatrices !== void 0) {
              mat.fromArray(skinEntry.inverseBindMatrices.array, j2 * 16);
            }
            boneInverses.push(mat);
          } else {
            console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinEntry.joints[j2]);
          }
        }
        mesh.bind(new Skeleton(bones, boneInverses), mesh.matrixWorld);
      });
      return node;
    });
  }).then(function(node) {
    parentObject.add(node);
    const pending = [];
    if (nodeDef.children) {
      const children = nodeDef.children;
      for (let i2 = 0, il = children.length; i2 < il; i2++) {
        const child = children[i2];
        pending.push(buildNodeHierarchy(child, node, json, parser));
      }
    }
    return Promise.all(pending);
  });
}
function computeBounds(geometry2, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const box = new Box3();
  if (attributes.POSITION !== void 0) {
    const accessor = parser.json.accessors[attributes.POSITION];
    const min4 = accessor.min;
    const max3 = accessor.max;
    if (min4 !== void 0 && max3 !== void 0) {
      box.set(
        new Vector3$1(min4[0], min4[1], min4[2]),
        new Vector3$1(max3[0], max3[1], max3[2])
      );
      if (accessor.normalized) {
        const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
        box.min.multiplyScalar(boxScale);
        box.max.multiplyScalar(boxScale);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else {
    return;
  }
  const targets = primitiveDef.targets;
  if (targets !== void 0) {
    const maxDisplacement = new Vector3$1();
    const vector = new Vector3$1();
    for (let i2 = 0, il = targets.length; i2 < il; i2++) {
      const target = targets[i2];
      if (target.POSITION !== void 0) {
        const accessor = parser.json.accessors[target.POSITION];
        const min4 = accessor.min;
        const max3 = accessor.max;
        if (min4 !== void 0 && max3 !== void 0) {
          vector.setX(Math.max(Math.abs(min4[0]), Math.abs(max3[0])));
          vector.setY(Math.max(Math.abs(min4[1]), Math.abs(max3[1])));
          vector.setZ(Math.max(Math.abs(min4[2]), Math.abs(max3[2])));
          if (accessor.normalized) {
            const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
            vector.multiplyScalar(boxScale);
          }
          maxDisplacement.max(vector);
        } else {
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
        }
      }
    }
    box.expandByVector(maxDisplacement);
  }
  geometry2.boundingBox = box;
  const sphere2 = new Sphere();
  box.getCenter(sphere2.center);
  sphere2.radius = box.min.distanceTo(box.max) / 2;
  geometry2.boundingSphere = sphere2;
}
function addPrimitiveAttributes(geometry2, primitiveDef, parser) {
  const attributes = primitiveDef.attributes;
  const pending = [];
  function assignAttributeAccessor(accessorIndex, attributeName) {
    return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
      geometry2.setAttribute(attributeName, accessor);
    });
  }
  for (const gltfAttributeName in attributes) {
    const threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
    if (threeAttributeName in geometry2.attributes)
      continue;
    pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
  }
  if (primitiveDef.indices !== void 0 && !geometry2.index) {
    const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
      geometry2.setIndex(accessor2);
    });
    pending.push(accessor);
  }
  assignExtrasToUserData(geometry2, primitiveDef);
  computeBounds(geometry2, primitiveDef, parser);
  return Promise.all(pending).then(function() {
    return primitiveDef.targets !== void 0 ? addMorphTargets(geometry2, primitiveDef.targets, parser) : geometry2;
  });
}
function toTrianglesDrawMode(geometry2, drawMode) {
  let index2 = geometry2.getIndex();
  if (index2 === null) {
    const indices = [];
    const position = geometry2.getAttribute("position");
    if (position !== void 0) {
      for (let i2 = 0; i2 < position.count; i2++) {
        indices.push(i2);
      }
      geometry2.setIndex(indices);
      index2 = geometry2.getIndex();
    } else {
      console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
      return geometry2;
    }
  }
  const numberOfTriangles = index2.count - 2;
  const newIndices = [];
  if (drawMode === TriangleFanDrawMode) {
    for (let i2 = 1; i2 <= numberOfTriangles; i2++) {
      newIndices.push(index2.getX(0));
      newIndices.push(index2.getX(i2));
      newIndices.push(index2.getX(i2 + 1));
    }
  } else {
    for (let i2 = 0; i2 < numberOfTriangles; i2++) {
      if (i2 % 2 === 0) {
        newIndices.push(index2.getX(i2));
        newIndices.push(index2.getX(i2 + 1));
        newIndices.push(index2.getX(i2 + 2));
      } else {
        newIndices.push(index2.getX(i2 + 2));
        newIndices.push(index2.getX(i2 + 1));
        newIndices.push(index2.getX(i2));
      }
    }
  }
  if (newIndices.length / 3 !== numberOfTriangles) {
    console.error("THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
  }
  const newGeometry = geometry2.clone();
  newGeometry.setIndex(newIndices);
  return newGeometry;
}
const _taskCache = /* @__PURE__ */ new WeakMap();
class DRACOLoader extends Loader {
  constructor(manager) {
    super(manager);
    this.decoderPath = "";
    this.decoderConfig = {};
    this.decoderBinary = null;
    this.decoderPending = null;
    this.workerLimit = 4;
    this.workerPool = [];
    this.workerNextTaskID = 1;
    this.workerSourceURL = "";
    this.defaultAttributeIDs = {
      position: "POSITION",
      normal: "NORMAL",
      color: "COLOR",
      uv: "TEX_COORD"
    };
    this.defaultAttributeTypes = {
      position: "Float32Array",
      normal: "Float32Array",
      color: "Float32Array",
      uv: "Float32Array"
    };
  }
  setDecoderPath(path2) {
    this.decoderPath = path2;
    return this;
  }
  setDecoderConfig(config2) {
    this.decoderConfig = config2;
    return this;
  }
  setWorkerLimit(workerLimit) {
    this.workerLimit = workerLimit;
    return this;
  }
  load(url2, onLoad, onProgress, onError) {
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.path);
    loader2.setResponseType("arraybuffer");
    loader2.setRequestHeader(this.requestHeader);
    loader2.setWithCredentials(this.withCredentials);
    loader2.load(url2, (buffer3) => {
      const taskConfig = {
        attributeIDs: this.defaultAttributeIDs,
        attributeTypes: this.defaultAttributeTypes,
        useUniqueIDs: false
      };
      this.decodeGeometry(buffer3, taskConfig).then(onLoad).catch(onError);
    }, onProgress, onError);
  }
  /** @deprecated Kept for backward-compatibility with previous DRACOLoader versions. */
  decodeDracoFile(buffer3, callback, attributeIDs, attributeTypes) {
    const taskConfig = {
      attributeIDs: attributeIDs || this.defaultAttributeIDs,
      attributeTypes: attributeTypes || this.defaultAttributeTypes,
      useUniqueIDs: !!attributeIDs
    };
    this.decodeGeometry(buffer3, taskConfig).then(callback);
  }
  decodeGeometry(buffer3, taskConfig) {
    for (const attribute in taskConfig.attributeTypes) {
      const type = taskConfig.attributeTypes[attribute];
      if (type.BYTES_PER_ELEMENT !== void 0) {
        taskConfig.attributeTypes[attribute] = type.name;
      }
    }
    const taskKey = JSON.stringify(taskConfig);
    if (_taskCache.has(buffer3)) {
      const cachedTask = _taskCache.get(buffer3);
      if (cachedTask.key === taskKey) {
        return cachedTask.promise;
      } else if (buffer3.byteLength === 0) {
        throw new Error(
          "THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred."
        );
      }
    }
    let worker2;
    const taskID = this.workerNextTaskID++;
    const taskCost = buffer3.byteLength;
    const geometryPending = this._getWorker(taskID, taskCost).then((_worker) => {
      worker2 = _worker;
      return new Promise((resolve2, reject) => {
        worker2._callbacks[taskID] = { resolve: resolve2, reject };
        worker2.postMessage({ type: "decode", id: taskID, taskConfig, buffer: buffer3 }, [buffer3]);
      });
    }).then((message2) => this._createGeometry(message2.geometry));
    geometryPending.catch(() => true).then(() => {
      if (worker2 && taskID) {
        this._releaseTask(worker2, taskID);
      }
    });
    _taskCache.set(buffer3, {
      key: taskKey,
      promise: geometryPending
    });
    return geometryPending;
  }
  _createGeometry(geometryData) {
    const geometry2 = new BufferGeometry();
    if (geometryData.index) {
      geometry2.setIndex(new BufferAttribute(geometryData.index.array, 1));
    }
    for (let i2 = 0; i2 < geometryData.attributes.length; i2++) {
      const attribute = geometryData.attributes[i2];
      const name2 = attribute.name;
      const array2 = attribute.array;
      const itemSize = attribute.itemSize;
      geometry2.setAttribute(name2, new BufferAttribute(array2, itemSize));
    }
    return geometry2;
  }
  _loadLibrary(url2, responseType) {
    const loader2 = new FileLoader(this.manager);
    loader2.setPath(this.decoderPath);
    loader2.setResponseType(responseType);
    loader2.setWithCredentials(this.withCredentials);
    return new Promise((resolve2, reject) => {
      loader2.load(url2, resolve2, void 0, reject);
    });
  }
  preload() {
    this._initDecoder();
    return this;
  }
  _initDecoder() {
    if (this.decoderPending)
      return this.decoderPending;
    const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
    const librariesPending = [];
    if (useJS) {
      librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
    } else {
      librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
      librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
    }
    this.decoderPending = Promise.all(librariesPending).then((libraries) => {
      const jsContent = libraries[0];
      if (!useJS) {
        this.decoderConfig.wasmBinary = libraries[1];
      }
      const fn2 = DRACOWorker.toString();
      const body = [
        "/* draco decoder */",
        jsContent,
        "",
        "/* worker */",
        fn2.substring(fn2.indexOf("{") + 1, fn2.lastIndexOf("}"))
      ].join("\n");
      this.workerSourceURL = URL.createObjectURL(new Blob([body]));
    });
    return this.decoderPending;
  }
  _getWorker(taskID, taskCost) {
    return this._initDecoder().then(() => {
      if (this.workerPool.length < this.workerLimit) {
        const worker3 = new Worker(this.workerSourceURL);
        worker3._callbacks = {};
        worker3._taskCosts = {};
        worker3._taskLoad = 0;
        worker3.postMessage({ type: "init", decoderConfig: this.decoderConfig });
        worker3.onmessage = function(e3) {
          const message2 = e3.data;
          switch (message2.type) {
            case "decode":
              worker3._callbacks[message2.id].resolve(message2);
              break;
            case "error":
              worker3._callbacks[message2.id].reject(message2);
              break;
            default:
              console.error('THREE.DRACOLoader: Unexpected message, "' + message2.type + '"');
          }
        };
        this.workerPool.push(worker3);
      } else {
        this.workerPool.sort(function(a2, b2) {
          return a2._taskLoad > b2._taskLoad ? -1 : 1;
        });
      }
      const worker2 = this.workerPool[this.workerPool.length - 1];
      worker2._taskCosts[taskID] = taskCost;
      worker2._taskLoad += taskCost;
      return worker2;
    });
  }
  _releaseTask(worker2, taskID) {
    worker2._taskLoad -= worker2._taskCosts[taskID];
    delete worker2._callbacks[taskID];
    delete worker2._taskCosts[taskID];
  }
  debug() {
    console.log("Task load: ", this.workerPool.map((worker2) => worker2._taskLoad));
  }
  dispose() {
    for (let i2 = 0; i2 < this.workerPool.length; ++i2) {
      this.workerPool[i2].terminate();
    }
    this.workerPool.length = 0;
    return this;
  }
}
function DRACOWorker() {
  let decoderConfig;
  let decoderPending;
  onmessage = function(e3) {
    const message2 = e3.data;
    switch (message2.type) {
      case "init":
        decoderConfig = message2.decoderConfig;
        decoderPending = new Promise(function(resolve2) {
          decoderConfig.onModuleLoaded = function(draco) {
            resolve2({ draco });
          };
          DracoDecoderModule(decoderConfig);
        });
        break;
      case "decode":
        const buffer3 = message2.buffer;
        const taskConfig = message2.taskConfig;
        decoderPending.then((module2) => {
          const draco = module2.draco;
          const decoder = new draco.Decoder();
          const decoderBuffer = new draco.DecoderBuffer();
          decoderBuffer.Init(new Int8Array(buffer3), buffer3.byteLength);
          try {
            const geometry2 = decodeGeometry(draco, decoder, decoderBuffer, taskConfig);
            const buffers = geometry2.attributes.map((attr2) => attr2.array.buffer);
            if (geometry2.index)
              buffers.push(geometry2.index.array.buffer);
            self.postMessage({ type: "decode", id: message2.id, geometry: geometry2 }, buffers);
          } catch (error2) {
            console.error(error2);
            self.postMessage({ type: "error", id: message2.id, error: error2.message });
          } finally {
            draco.destroy(decoderBuffer);
            draco.destroy(decoder);
          }
        });
        break;
    }
  };
  function decodeGeometry(draco, decoder, decoderBuffer, taskConfig) {
    const attributeIDs = taskConfig.attributeIDs;
    const attributeTypes = taskConfig.attributeTypes;
    let dracoGeometry;
    let decodingStatus;
    const geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
    if (geometryType === draco.TRIANGULAR_MESH) {
      dracoGeometry = new draco.Mesh();
      decodingStatus = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
    } else if (geometryType === draco.POINT_CLOUD) {
      dracoGeometry = new draco.PointCloud();
      decodingStatus = decoder.DecodeBufferToPointCloud(decoderBuffer, dracoGeometry);
    } else {
      throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
    }
    if (!decodingStatus.ok() || dracoGeometry.ptr === 0) {
      throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
    }
    const geometry2 = { index: null, attributes: [] };
    for (const attributeName in attributeIDs) {
      const attributeType = self[attributeTypes[attributeName]];
      let attribute;
      let attributeID;
      if (taskConfig.useUniqueIDs) {
        attributeID = attributeIDs[attributeName];
        attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
      } else {
        attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
        if (attributeID === -1)
          continue;
        attribute = decoder.GetAttribute(dracoGeometry, attributeID);
      }
      geometry2.attributes.push(decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute));
    }
    if (geometryType === draco.TRIANGULAR_MESH) {
      geometry2.index = decodeIndex(draco, decoder, dracoGeometry);
    }
    draco.destroy(dracoGeometry);
    return geometry2;
  }
  function decodeIndex(draco, decoder, dracoGeometry) {
    const numFaces = dracoGeometry.num_faces();
    const numIndices = numFaces * 3;
    const byteLength = numIndices * 4;
    const ptr = draco._malloc(byteLength);
    decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
    const index2 = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
    draco._free(ptr);
    return { array: index2, itemSize: 1 };
  }
  function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
    const numComponents = attribute.num_components();
    const numPoints = dracoGeometry.num_points();
    const numValues = numPoints * numComponents;
    const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
    const dataType = getDracoDataType2(draco, attributeType);
    const ptr = draco._malloc(byteLength);
    decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
    const array2 = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
    draco._free(ptr);
    return {
      name: attributeName,
      array: array2,
      itemSize: numComponents
    };
  }
  function getDracoDataType2(draco, attributeType) {
    switch (attributeType) {
      case Float32Array:
        return draco.DT_FLOAT32;
      case Int8Array:
        return draco.DT_INT8;
      case Int16Array:
        return draco.DT_INT16;
      case Int32Array:
        return draco.DT_INT32;
      case Uint8Array:
        return draco.DT_UINT8;
      case Uint16Array:
        return draco.DT_UINT16;
      case Uint32Array:
        return draco.DT_UINT32;
    }
  }
}
class CameraSync {
  constructor(map5, camera, world) {
    this.map = map5;
    this.camera = camera;
    this.active = true;
    this.updateCallback = () => {
    };
    this.Constants = Constants$u;
    this.camera.matrixAutoUpdate = false;
    this.world = world || new Group();
    this.world.position.x = Constants$u.WORLD_SIZE / 2;
    this.world.position.y = Constants$u.WORLD_SIZE / 2;
    this.world.matrixAutoUpdate = false;
    this.state = {
      fov: 0.6435011087932844,
      // Math.atan(0.75);
      translateCenter: new Matrix4$1(),
      worldSizeRatio: 512 / Constants$u.WORLD_SIZE
    };
    this.state.translateCenter.makeTranslation(Constants$u.WORLD_SIZE / 2, -Constants$u.WORLD_SIZE / 2, 0);
    this.updateCameraBound = () => this.updateCamera();
    this.map.on("move", this.updateCameraBound);
    this.setupCameraBound = () => this.setupCamera();
    this.map.on("resize", this.setupCameraBound);
    this.setupCamera();
  }
  detachCamera() {
    this.map.off("move", this.updateCameraBound);
    this.map.off("resize", this.setupCameraBound);
    this.updateCallback = null;
    this.map = null;
    this.camera = null;
  }
  setupCamera() {
    const t2 = this.map.transform;
    const halfFov = this.state.fov / 2;
    const cameraToCenterDistance = 0.5 / Math.tan(halfFov) * t2.height;
    this.state.cameraToCenterDistance = cameraToCenterDistance;
    this.state.cameraTranslateZ = new Matrix4$1().makeTranslation(0, 0, cameraToCenterDistance);
    this.updateCamera();
  }
  updateCamera() {
    if (!this.camera) {
      console.warn("nocamera");
      return;
    }
    const t2 = this.map.transform;
    const halfFov = this.state.fov / 2;
    const groundAngle = Math.PI / 2 + t2._pitch;
    this.state.topHalfSurfaceDistance = Math.sin(halfFov) * this.state.cameraToCenterDistance / Math.sin(Math.PI - groundAngle - halfFov);
    const furthestDistance = Math.cos(Math.PI / 2 - t2._pitch) * this.state.topHalfSurfaceDistance + this.state.cameraToCenterDistance;
    const farZ = furthestDistance * 1.01;
    this.camera.projectionMatrix = this.makePerspectiveMatrix(this.state.fov, t2.width / t2.height, 1, farZ);
    const cameraWorldMatrix = new Matrix4$1();
    const rotatePitch = new Matrix4$1().makeRotationX(t2._pitch);
    const rotateBearing = new Matrix4$1().makeRotationZ(t2.angle);
    cameraWorldMatrix.premultiply(this.state.cameraTranslateZ).premultiply(rotatePitch).premultiply(rotateBearing);
    this.camera.matrixWorld.copy(cameraWorldMatrix);
    const zoomPow = t2.scale * this.state.worldSizeRatio;
    const scale5 = new Matrix4$1();
    scale5.makeScale(zoomPow, zoomPow, zoomPow);
    const translateMap = new Matrix4$1();
    const x2 = -this.map.transform.x || -this.map.transform.point.x;
    const y2 = this.map.transform.y || this.map.transform.point.y;
    translateMap.makeTranslation(x2, y2, 0);
    this.world.matrix = new Matrix4$1();
    this.world.matrix.premultiply(this.state.translateCenter).premultiply(scale5).premultiply(translateMap);
    const matrixWorldInverse = new Matrix4$1();
    matrixWorldInverse.copy(this.world.matrix).invert();
    this.camera.projectionMatrixInverse.copy(this.camera.projectionMatrix).invert();
    this.camera.matrixWorldInverse.copy(this.camera.matrixWorld).invert();
    this.frustum = new Frustum();
    this.frustum.setFromProjectionMatrix(new Matrix4$1().multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse));
    this.cameraPosition = new Vector3$1(0, 0, 0).unproject(this.camera).applyMatrix4(matrixWorldInverse);
    this.updateCallback();
  }
  // eslint-disable-next-line class-methods-use-this
  makePerspectiveMatrix(fovy, aspect2, near, far) {
    const out = new Matrix4$1();
    const f2 = 1 / Math.tan(fovy / 2);
    const nf = 1 / (near - far);
    const newMatrix = [f2 / aspect2, 0, 0, 0, 0, f2, 0, 0, 0, 0, (far + near) * nf, -1, 0, 0, 2 * far * near * nf, 0];
    out.elements = newMatrix;
    return out;
  }
}
class ThreeLayer {
  constructor(params2) {
    if (!params2)
      throw new Error("parameters missing for mapbox 3D layer");
    if (!params2.id)
      throw new Error("id parameter missing for mapbox 3D layer");
    this.id = params2.id;
    this.viewProjectionMatrix = null;
    this.type = "custom";
    this.renderingMode = "3d";
  }
  onAdd(map5, gl) {
    this.map = map5;
    const fov2 = 36.8;
    const aspect2 = map5.getCanvas().width / map5.getCanvas().height;
    const near = 1e-12;
    const far = Infinity;
    this.camera = new PerspectiveCamera(fov2, aspect2, near, far);
    this.mapQueryRenderedFeatures = map5.queryRenderedFeatures.bind(this.map);
    this.map.queryRenderedFeatures = this.queryRenderedFeatures.bind(this);
    this.scene = new Scene();
    this.rootTransform = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
    const lightsarray = this.getLights();
    lightsarray.forEach((light) => {
      this.scene.add(light);
    });
    this.world = new Group();
    this.world.name = "flatMercatorWorld";
    this.scene.add(this.world);
    this.cameraSync = new CameraSync(this.map, this.camera, this.world);
    this.cameraSync.updateCallback = () => this.updateCallback();
    this.raycaster = new Raycaster();
    this.renderer = new WebGLRenderer({
      alpha: true,
      antialias: true,
      canvas: map5.getCanvas(),
      context: gl
    });
    this.renderer.shadowMap.enabled = true;
    this.renderer.autoClear = false;
    this._addPromise = this.addCallback();
    const scope = this;
    this._addPromise.then(() => scope.render());
  }
  loadPromise() {
    const scope = this;
    return new Promise((resolve2) => {
      var _a3;
      (_a3 = scope._addPromise) == null ? void 0 : _a3.then(() => resolve2()).catch(() => resolve2());
    });
  }
  // eslint-disable-next-line no-unused-vars
  onRemove(map5, gl) {
    this.map.queryRenderedFeatures = this.mapQueryRenderedFeatures;
    this.destroy();
  }
  destroy() {
    var _a3, _b3;
    const detachObject = (object2) => {
      var _a4;
      if (!object2)
        return;
      (_a4 = object2.parent) == null ? void 0 : _a4.remove(object2);
      object2.removeFromParent();
    };
    const deleteMesh = (object2) => {
      var _a4, _b4;
      if (!object2)
        return;
      (_b4 = (_a4 = object2.geometry) == null ? void 0 : _a4.dispose) == null ? void 0 : _b4.call(_a4);
      if (object2.material) {
        if (object2.material instanceof Array) {
          object2.material.forEach((material) => material.dispose());
        } else {
          object2.material.dispose();
        }
      }
      detachObject(object2);
    };
    const deleteObject3d = (object2) => {
      var _a4, _b4;
      if (!object2)
        return;
      if (object2.isMesh) {
        deleteMesh(object2);
        return;
      }
      while ((_a4 = object2.children) == null ? void 0 : _a4.length) {
        deleteObject3d(object2.children[0]);
      }
      (_b4 = object2.dispose) == null ? void 0 : _b4.call(object2);
      detachObject(object2);
    };
    this.cameraSync.detachCamera();
    this.cameraSync = null;
    detachObject(this.camera);
    this.camera = null;
    (_a3 = this.scene) == null ? void 0 : _a3.traverse(deleteObject3d);
    this.scene = null;
    (_b3 = this.renderer) == null ? void 0 : _b3.dispose();
    this.renderer = null;
    this.raycaster = null;
    this.world = null;
  }
  queryRenderedFeatures(geometry2, options2) {
    const result = this.mapQueryRenderedFeatures(geometry2, options2);
    if (!this.map || !this.map.transform) {
      return result;
    }
    if (!(options2 && options2.layers && !options2.layers.includes(this.id))) {
      if (geometry2 && geometry2.x && geometry2.y) {
        const mouse = new Vector2$1();
        mouse.x = geometry2.x / this.map.transform.width * 2 - 1;
        mouse.y = 1 - geometry2.y / this.map.transform.height * 2;
        this.raycaster.setFromCamera(mouse, this.camera);
        const intersects7 = this.raycaster.intersectObjects(this.world.children, true);
        if (intersects7.length) {
          const feature2 = {
            type: "Feature",
            properties: {},
            geometry: {},
            layer: {
              id: this.id,
              type: "custom 3d"
            },
            source: this.getSource(),
            "source-layer": null,
            state: {}
          };
          let propertyIndex;
          const intersect2 = intersects7[0];
          if (intersect2.object && intersect2.object.geometry && intersect2.object.geometry.attributes && intersect2.object.geometry.attributes._batchid) {
            const {
              geometry: geometry3
            } = intersect2.object;
            let vertexIdx = intersect2.faceIndex;
            if (geometry3.index) {
              vertexIdx = geometry3.index.array[intersect2.faceIndex * 3];
              propertyIndex = geometry3.attributes._batchid.data.array[vertexIdx * 7 + 6];
            } else {
              propertyIndex = geometry3.attributes._batchid.array[vertexIdx * 3];
            }
            const keys4 = Object.keys(intersect2.object.userData);
            if (keys4.length) {
              for (const propertyName of keys4) {
                feature2.properties[propertyName] = intersect2.object.userData[propertyName][propertyIndex];
              }
            } else {
              feature2.properties.batchId = propertyIndex;
            }
          } else if (intersect2.index != null) {
            feature2.properties.index = intersect2.index;
          } else {
            feature2.properties.name = this.id;
          }
          if (options2.outline !== false && (intersect2.object !== this.outlinedObject || propertyIndex != null && propertyIndex !== this.outlinePropertyIndex || propertyIndex == null && intersect2.index !== this.outlineIndex)) {
            if (this.outlineMesh) {
              const {
                parent
              } = this.outlineMesh;
              parent.remove(this.outlineMesh);
              this.outlineMesh = null;
            }
            this.outlinePropertyIndex = propertyIndex;
            this.outlineIndex = intersect2.index;
            if (intersect2.object instanceof Mesh) {
              this.outlinedObject = intersect2.object;
              const outlineMaterial = new MeshBasicMaterial({
                color: options2.outlineColor ? options2.outlineColor : 16711680,
                wireframe: true
              });
              let outlineMesh;
              if (intersect2.object && intersect2.object.geometry && intersect2.object.geometry.attributes && intersect2.object.geometry.attributes._batchid) {
                const {
                  geometry: geometry3
                } = intersect2.object;
                if (geometry3.index) {
                  const ip1 = geometry3.index.array[intersect2.faceIndex * 3];
                  const idx = geometry3.attributes._batchid.data.array[ip1 * 7 + 6];
                  const blockFaces = [];
                  for (let faceIndex = 0; faceIndex < geometry3.index.array.length; faceIndex += 3) {
                    const p1 = geometry3.index.array[faceIndex];
                    if (geometry3.attributes._batchid.data.array[p1 * 7 + 6] === idx) {
                      const p2 = geometry3.index.array[faceIndex + 1];
                      if (geometry3.attributes._batchid.data.array[p2 * 7 + 6] === idx) {
                        const p3 = geometry3.index.array[faceIndex + 2];
                        if (geometry3.attributes._batchid.data.array[p3 * 7 + 6] === idx) {
                          blockFaces.push(faceIndex);
                        }
                      }
                    }
                  }
                  const highLightGeometry = new (void 0)();
                  for (let vertexCount = 0, face = 0; face < blockFaces.length; face += 1) {
                    const faceIndex = blockFaces[face];
                    const p1 = geometry3.index.array[faceIndex];
                    const p2 = geometry3.index.array[faceIndex + 1];
                    const p3 = geometry3.index.array[faceIndex + 2];
                    const positions = geometry3.attributes.position.data.array;
                    highLightGeometry.vertices.push(new Vector3$1(positions[p1 * 7], positions[p1 * 7 + 1], positions[p1 * 7 + 2]), new Vector3$1(positions[p2 * 7], positions[p2 * 7 + 1], positions[p2 * 7 + 2]), new Vector3$1(positions[p3 * 7], positions[p3 * 7 + 1], positions[p3 * 7 + 2]));
                    highLightGeometry.faces.push(new (void 0)(vertexCount, vertexCount + 1, vertexCount + 2));
                    vertexCount += 3;
                  }
                  highLightGeometry.computeBoundingSphere();
                  outlineMesh = new Mesh(highLightGeometry, outlineMaterial);
                } else {
                  const ip1 = intersect2.faceIndex * 3;
                  const idx = geometry3.attributes._batchid.array[ip1];
                  const blockFaces = [];
                  for (let faceIndex = 0; faceIndex < geometry3.attributes._batchid.array.length; faceIndex += 3) {
                    const p1 = faceIndex;
                    if (geometry3.attributes._batchid.array[p1] === idx) {
                      const p2 = faceIndex + 1;
                      if (geometry3.attributes._batchid.array[p2] === idx) {
                        const p3 = faceIndex + 2;
                        if (geometry3.attributes._batchid.array[p3] === idx) {
                          blockFaces.push(faceIndex);
                        }
                      }
                    }
                  }
                  const highLightGeometry = new (void 0)();
                  for (let vertexCount = 0, face = 0; face < blockFaces.length; face += 1) {
                    const faceIndex = blockFaces[face] * 3;
                    const positions = geometry3.attributes.position.array;
                    highLightGeometry.vertices.push(new Vector3$1(positions[faceIndex], positions[faceIndex + 1], positions[faceIndex + 2]), new Vector3$1(positions[faceIndex + 3], positions[faceIndex + 4], positions[faceIndex + 5]), new Vector3$1(positions[faceIndex + 6], positions[faceIndex + 7], positions[faceIndex + 8]));
                    highLightGeometry.faces.push(new (void 0)(vertexCount, vertexCount + 1, vertexCount + 2));
                    vertexCount += 3;
                  }
                  highLightGeometry.computeBoundingSphere();
                  outlineMesh = new Mesh(highLightGeometry, outlineMaterial);
                }
              } else {
                outlineMesh = new Mesh(this.outlinedObject.geometry, outlineMaterial);
              }
              outlineMesh.position.x = this.outlinedObject.position.x + 0.1;
              outlineMesh.position.y = this.outlinedObject.position.y + 0.1;
              outlineMesh.position.z = this.outlinedObject.position.z + 0.1;
              outlineMesh.quaternion.copy(this.outlinedObject.quaternion);
              outlineMesh.scale.copy(this.outlinedObject.scale);
              outlineMesh.matrix.copy(this.outlinedObject.matrix);
              outlineMesh.raycast = () => {
              };
              outlineMesh.name = "outline";
              outlineMesh.wireframe = true;
              this.outlinedObject.parent.add(outlineMesh);
              this.outlineMesh = outlineMesh;
            }
          }
          result.unshift(feature2);
          this.map.triggerRepaint();
        } else {
          this.outlinedObject = null;
          if (this.outlineMesh) {
            const {
              parent
            } = this.outlineMesh;
            parent.remove(this.outlineMesh);
            this.outlineMesh = null;
            this.map.triggerRepaint();
          }
        }
      }
    }
    return result;
  }
  // eslint-disable-next-line class-methods-use-this
  getLights() {
    const arr = [];
    const directionalLight1 = new DirectionalLight$1(16777215, 0.5);
    directionalLight1.position.set(0.5, 1, 0.5).normalize();
    directionalLight1.target.position.set(1e8, 1e9, 0).normalize();
    arr.push(directionalLight1);
    const directionalLight2 = new DirectionalLight$1(16777215, 0.5);
    directionalLight2.position.set(0.3, 0.3, 1).normalize();
    arr.push(directionalLight2);
    return arr;
  }
  // eslint-disable-next-line no-unused-vars
  render(gl, viewProjectionMatrix) {
    if (this.renderer) {
      this.renderer.state.reset();
      this.renderer.render(this.scene, this.camera);
    }
    this.map.triggerRepaint();
  }
  // eslint-disable-next-line class-methods-use-this
  getSource() {
    return null;
  }
  // eslint-disable-next-line class-methods-use-this
  updateCallback() {
  }
  // eslint-disable-next-line class-methods-use-this
  async addCallback() {
    return null;
  }
  toThreePoint(geoPoint) {
    if (!this.cameraSync || !this.map)
      return null;
    return GeoreferenceUtil.toThreePoint(geoPoint);
  }
  toGeoPoint(position) {
    if (!this.cameraSync || !this.map)
      return null;
    return GeoreferenceUtil.toGeoPoint(position);
  }
}
let ThreeLoaderLayer$1 = class ThreeLoaderLayer2 extends ThreeLayer {
  constructor(loaderAsync2, params2) {
    super(params2);
    this.loaderAsync = loaderAsync2;
    this.url = params2.url;
    this.flipY2Z = params2.flipY2Z;
    this.recenterOnMass = params2.recenterOnMass;
    this.debugBoxHelper = params2.debugBoxHelper;
    this.resourcePath = params2.resourcePath || (typeof this.url === "string" ? LoaderUtils.extractUrlBase(this.url) : "/");
    this.headers = params2.token ? {
      Authorization: `Bearer ${params2.token}`
    } : void 0;
    this.center = params2.center;
    this.styleParams = {};
    if ("color" in params2)
      this.styleParams.color = params2.color;
    if ("opacity" in params2)
      this.styleParams.opacity = params2.opacity;
    this.dip = params2.dip || 0;
    this.head = params2.head || 0;
    this.azimuth = params2.azimuth || 0;
    this.scale = params2.scale || [1, 1, 1];
  }
  async addCallback() {
    const scope = this;
    if (!scope.cameraSync)
      return;
    try {
      if (scope.url) {
        const scene = await scope.load();
        if (!scope.cameraSync)
          return;
        if (scene) {
          const result = GeoreferenceUtil.doGeoreferencing(scene, scope.center, scope.scale, {
            dip: scope.dip,
            head: scope.head,
            azimuth: scope.azimuth
          }, scope.flipY2Z, scope.recenterOnMass, scope.debugBoxHelper, {
            world: scope.world,
            content: scope.content,
            anchor: scope.anchor
          });
          if (result) {
            const {
              world,
              content,
              anchor
            } = result;
            if (!scope.world)
              scope.world = world;
            if (!scope.content)
              scope.content = content;
            if (!scope.anchor)
              scope.anchor = anchor;
          }
        }
      }
    } catch (error2) {
      console.error(error2);
    }
  }
  updateCallback() {
    this.map.triggerRepaint();
  }
  getSource() {
    return this.url;
  }
  async load() {
    try {
      const scene = await this.loaderAsync(this.url, this.headers);
      if (!scene)
        return null;
      scene.traverse((child) => {
        if (child instanceof Mesh) {
          child.geometry.computeBoundingBox();
          child.geometry.computeBoundingSphere();
          child.material.depthWrite = true;
        }
      });
      if (this.styleParams.color != null || this.styleParams.opacity != null) {
        const color = new Color(this.styleParams.color);
        scene.traverse((child) => {
          if (child instanceof Mesh) {
            if (this.styleParams.color !== null)
              child.material.color = color;
            if (this.styleParams.opacity !== null) {
              child.material.opacity = this.styleParams.opacity;
              child.material.transparent = this.styleParams.opacity < 1;
            }
            child.material.needsUpdate = true;
          }
        });
      }
      return scene;
    } catch (error2) {
      throw new Error(`error loading gltf: ${error2}`);
    }
  }
};
const loaderAsync$1 = async (url2, headers) => {
  const loader2 = new GLTFLoader();
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.4.0/");
  loader2.setDRACOLoader(dracoLoader);
  if (headers) {
    loader2.setCrossOrigin("*");
    loader2.setRequestHeader(headers);
  }
  const result = await new Promise((resolve2, reject) => {
    loader2.load(url2, (gltf) => {
      const object2 = gltf == null ? void 0 : gltf.scene;
      if (object2) {
        object2.name = "gltf";
      }
      resolve2(object2);
    }, null, (error2) => {
      reject(new Error(`error loading gltf: ${error2}`));
    });
  });
  return result;
};
class GltfLayer extends ThreeLoaderLayer$1 {
  constructor(params2 = {}) {
    super(loaderAsync$1, {
      flipY2Z: true,
      ...params2
    });
  }
}
const loaderAsync = async (url2, headers) => {
  const enableLayers = true;
  const result = await DxfUtil.loadDxfUrl(url2, {
    headers,
    enableLayers
  });
  return result;
};
class DxfLayer extends ThreeLoaderLayer$1 {
  constructor(params2) {
    super(loaderAsync, params2);
  }
}
const _raycaster = new Raycaster();
const _tempVector = new Vector3$1();
const _tempVector2 = new Vector3$1();
const _tempQuaternion = new Quaternion$1();
const _unit = {
  X: new Vector3$1(1, 0, 0),
  Y: new Vector3$1(0, 1, 0),
  Z: new Vector3$1(0, 0, 1)
};
const _changeEvent = { type: "change" };
const _mouseDownEvent = { type: "mouseDown" };
const _mouseUpEvent = { type: "mouseUp", mode: null };
const _objectChangeEvent = { type: "objectChange" };
let TransformControls$1 = class TransformControls2 extends Object3D {
  constructor(camera, domElement) {
    super();
    if (domElement === void 0) {
      console.warn('THREE.TransformControls: The second parameter "domElement" is now mandatory.');
      domElement = document;
    }
    this.visible = false;
    this.domElement = domElement;
    this.domElement.style.touchAction = "none";
    const _gizmo = new TransformControlsGizmo();
    this._gizmo = _gizmo;
    this.add(_gizmo);
    const _plane2 = new TransformControlsPlane();
    this._plane = _plane2;
    this.add(_plane2);
    const scope = this;
    function defineProperty2(propName2, defaultValue2) {
      let propValue = defaultValue2;
      Object.defineProperty(scope, propName2, {
        get: function() {
          return propValue !== void 0 ? propValue : defaultValue2;
        },
        set: function(value) {
          if (propValue !== value) {
            propValue = value;
            _plane2[propName2] = value;
            _gizmo[propName2] = value;
            scope.dispatchEvent({ type: propName2 + "-changed", value });
            scope.dispatchEvent(_changeEvent);
          }
        }
      });
      scope[propName2] = defaultValue2;
      _plane2[propName2] = defaultValue2;
      _gizmo[propName2] = defaultValue2;
    }
    defineProperty2("camera", camera);
    defineProperty2("object", void 0);
    defineProperty2("enabled", true);
    defineProperty2("axis", null);
    defineProperty2("mode", "translate");
    defineProperty2("translationSnap", null);
    defineProperty2("rotationSnap", null);
    defineProperty2("scaleSnap", null);
    defineProperty2("space", "world");
    defineProperty2("size", 1);
    defineProperty2("dragging", false);
    defineProperty2("showX", true);
    defineProperty2("showY", true);
    defineProperty2("showZ", true);
    const worldPosition = new Vector3$1();
    const worldPositionStart = new Vector3$1();
    const worldQuaternion = new Quaternion$1();
    const worldQuaternionStart = new Quaternion$1();
    const cameraPosition = new Vector3$1();
    const cameraQuaternion = new Quaternion$1();
    const pointStart = new Vector3$1();
    const pointEnd = new Vector3$1();
    const rotationAxis = new Vector3$1();
    const rotationAngle = 0;
    const eye = new Vector3$1();
    defineProperty2("worldPosition", worldPosition);
    defineProperty2("worldPositionStart", worldPositionStart);
    defineProperty2("worldQuaternion", worldQuaternion);
    defineProperty2("worldQuaternionStart", worldQuaternionStart);
    defineProperty2("cameraPosition", cameraPosition);
    defineProperty2("cameraQuaternion", cameraQuaternion);
    defineProperty2("pointStart", pointStart);
    defineProperty2("pointEnd", pointEnd);
    defineProperty2("rotationAxis", rotationAxis);
    defineProperty2("rotationAngle", rotationAngle);
    defineProperty2("eye", eye);
    this._offset = new Vector3$1();
    this._startNorm = new Vector3$1();
    this._endNorm = new Vector3$1();
    this._cameraScale = new Vector3$1();
    this._parentPosition = new Vector3$1();
    this._parentQuaternion = new Quaternion$1();
    this._parentQuaternionInv = new Quaternion$1();
    this._parentScale = new Vector3$1();
    this._worldScaleStart = new Vector3$1();
    this._worldQuaternionInv = new Quaternion$1();
    this._worldScale = new Vector3$1();
    this._positionStart = new Vector3$1();
    this._quaternionStart = new Quaternion$1();
    this._scaleStart = new Vector3$1();
    this._getPointer = getPointer$1.bind(this);
    this._onPointerDown = onPointerDown.bind(this);
    this._onPointerHover = onPointerHover.bind(this);
    this._onPointerMove = onPointerMove.bind(this);
    this._onPointerUp = onPointerUp.bind(this);
    this.domElement.addEventListener("pointerdown", this._onPointerDown);
    this.domElement.addEventListener("pointermove", this._onPointerHover);
    this.domElement.addEventListener("pointerup", this._onPointerUp);
  }
  // updateMatrixWorld  updates key transformation variables
  updateMatrixWorld() {
    if (this.object !== void 0) {
      this.object.updateMatrixWorld();
      if (this.object.parent === null) {
        console.error("TransformControls: The attached 3D object must be a part of the scene graph.");
      } else {
        this.object.parent.matrixWorld.decompose(this._parentPosition, this._parentQuaternion, this._parentScale);
      }
      this.object.matrixWorld.decompose(this.worldPosition, this.worldQuaternion, this._worldScale);
      this._parentQuaternionInv.copy(this._parentQuaternion).invert();
      this._worldQuaternionInv.copy(this.worldQuaternion).invert();
    }
    this.camera.updateMatrixWorld();
    this.camera.matrixWorld.decompose(this.cameraPosition, this.cameraQuaternion, this._cameraScale);
    this.eye.copy(this.cameraPosition).sub(this.worldPosition).normalize();
    super.updateMatrixWorld(this);
  }
  pointerHover(pointer) {
    if (this.object === void 0 || this.dragging === true)
      return;
    _raycaster.setFromCamera(pointer, this.camera);
    const intersect2 = intersectObjectWithRay(this._gizmo.picker[this.mode], _raycaster);
    if (intersect2) {
      this.axis = intersect2.object.name;
    } else {
      this.axis = null;
    }
  }
  pointerDown(pointer) {
    if (this.object === void 0 || this.dragging === true || pointer.button !== 0)
      return;
    if (this.axis !== null) {
      _raycaster.setFromCamera(pointer, this.camera);
      const planeIntersect = intersectObjectWithRay(this._plane, _raycaster, true);
      if (planeIntersect) {
        this.object.updateMatrixWorld();
        this.object.parent.updateMatrixWorld();
        this._positionStart.copy(this.object.position);
        this._quaternionStart.copy(this.object.quaternion);
        this._scaleStart.copy(this.object.scale);
        this.object.matrixWorld.decompose(this.worldPositionStart, this.worldQuaternionStart, this._worldScaleStart);
        this.pointStart.copy(planeIntersect.point).sub(this.worldPositionStart);
      }
      this.dragging = true;
      _mouseDownEvent.mode = this.mode;
      this.dispatchEvent(_mouseDownEvent);
    }
  }
  pointerMove(pointer) {
    const axis = this.axis;
    const mode2 = this.mode;
    const object2 = this.object;
    let space = this.space;
    if (mode2 === "scale") {
      space = "local";
    } else if (axis === "E" || axis === "XYZE" || axis === "XYZ") {
      space = "world";
    }
    if (object2 === void 0 || axis === null || this.dragging === false || pointer.button !== -1)
      return;
    _raycaster.setFromCamera(pointer, this.camera);
    const planeIntersect = intersectObjectWithRay(this._plane, _raycaster, true);
    if (!planeIntersect)
      return;
    this.pointEnd.copy(planeIntersect.point).sub(this.worldPositionStart);
    if (mode2 === "translate") {
      this._offset.copy(this.pointEnd).sub(this.pointStart);
      if (space === "local" && axis !== "XYZ") {
        this._offset.applyQuaternion(this._worldQuaternionInv);
      }
      if (axis.indexOf("X") === -1)
        this._offset.x = 0;
      if (axis.indexOf("Y") === -1)
        this._offset.y = 0;
      if (axis.indexOf("Z") === -1)
        this._offset.z = 0;
      if (space === "local" && axis !== "XYZ") {
        this._offset.applyQuaternion(this._quaternionStart).divide(this._parentScale);
      } else {
        this._offset.applyQuaternion(this._parentQuaternionInv).divide(this._parentScale);
      }
      object2.position.copy(this._offset).add(this._positionStart);
      if (this.translationSnap) {
        if (space === "local") {
          object2.position.applyQuaternion(_tempQuaternion.copy(this._quaternionStart).invert());
          if (axis.search("X") !== -1) {
            object2.position.x = Math.round(object2.position.x / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Y") !== -1) {
            object2.position.y = Math.round(object2.position.y / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Z") !== -1) {
            object2.position.z = Math.round(object2.position.z / this.translationSnap) * this.translationSnap;
          }
          object2.position.applyQuaternion(this._quaternionStart);
        }
        if (space === "world") {
          if (object2.parent) {
            object2.position.add(_tempVector.setFromMatrixPosition(object2.parent.matrixWorld));
          }
          if (axis.search("X") !== -1) {
            object2.position.x = Math.round(object2.position.x / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Y") !== -1) {
            object2.position.y = Math.round(object2.position.y / this.translationSnap) * this.translationSnap;
          }
          if (axis.search("Z") !== -1) {
            object2.position.z = Math.round(object2.position.z / this.translationSnap) * this.translationSnap;
          }
          if (object2.parent) {
            object2.position.sub(_tempVector.setFromMatrixPosition(object2.parent.matrixWorld));
          }
        }
      }
    } else if (mode2 === "scale") {
      if (axis.search("XYZ") !== -1) {
        let d2 = this.pointEnd.length() / this.pointStart.length();
        if (this.pointEnd.dot(this.pointStart) < 0)
          d2 *= -1;
        _tempVector2.set(d2, d2, d2);
      } else {
        _tempVector.copy(this.pointStart);
        _tempVector2.copy(this.pointEnd);
        _tempVector.applyQuaternion(this._worldQuaternionInv);
        _tempVector2.applyQuaternion(this._worldQuaternionInv);
        _tempVector2.divide(_tempVector);
        if (axis.search("X") === -1) {
          _tempVector2.x = 1;
        }
        if (axis.search("Y") === -1) {
          _tempVector2.y = 1;
        }
        if (axis.search("Z") === -1) {
          _tempVector2.z = 1;
        }
      }
      object2.scale.copy(this._scaleStart).multiply(_tempVector2);
      if (this.scaleSnap) {
        if (axis.search("X") !== -1) {
          object2.scale.x = Math.round(object2.scale.x / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
        }
        if (axis.search("Y") !== -1) {
          object2.scale.y = Math.round(object2.scale.y / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
        }
        if (axis.search("Z") !== -1) {
          object2.scale.z = Math.round(object2.scale.z / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
        }
      }
    } else if (mode2 === "rotate") {
      this._offset.copy(this.pointEnd).sub(this.pointStart);
      const ROTATION_SPEED = 20 / this.worldPosition.distanceTo(_tempVector.setFromMatrixPosition(this.camera.matrixWorld));
      if (axis === "E") {
        this.rotationAxis.copy(this.eye);
        this.rotationAngle = this.pointEnd.angleTo(this.pointStart);
        this._startNorm.copy(this.pointStart).normalize();
        this._endNorm.copy(this.pointEnd).normalize();
        this.rotationAngle *= this._endNorm.cross(this._startNorm).dot(this.eye) < 0 ? 1 : -1;
      } else if (axis === "XYZE") {
        this.rotationAxis.copy(this._offset).cross(this.eye).normalize();
        this.rotationAngle = this._offset.dot(_tempVector.copy(this.rotationAxis).cross(this.eye)) * ROTATION_SPEED;
      } else if (axis === "X" || axis === "Y" || axis === "Z") {
        this.rotationAxis.copy(_unit[axis]);
        _tempVector.copy(_unit[axis]);
        if (space === "local") {
          _tempVector.applyQuaternion(this.worldQuaternion);
        }
        this.rotationAngle = this._offset.dot(_tempVector.cross(this.eye).normalize()) * ROTATION_SPEED;
      }
      if (this.rotationSnap)
        this.rotationAngle = Math.round(this.rotationAngle / this.rotationSnap) * this.rotationSnap;
      if (space === "local" && axis !== "E" && axis !== "XYZE") {
        object2.quaternion.copy(this._quaternionStart);
        object2.quaternion.multiply(_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle)).normalize();
      } else {
        this.rotationAxis.applyQuaternion(this._parentQuaternionInv);
        object2.quaternion.copy(_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle));
        object2.quaternion.multiply(this._quaternionStart).normalize();
      }
    }
    this.dispatchEvent(_changeEvent);
    this.dispatchEvent(_objectChangeEvent);
  }
  pointerUp(pointer) {
    if (pointer.button !== 0)
      return;
    if (this.dragging && this.axis !== null) {
      _mouseUpEvent.mode = this.mode;
      this.dispatchEvent(_mouseUpEvent);
    }
    this.dragging = false;
    this.axis = null;
  }
  dispose() {
    this.domElement.removeEventListener("pointerdown", this._onPointerDown);
    this.domElement.removeEventListener("pointermove", this._onPointerHover);
    this.domElement.removeEventListener("pointermove", this._onPointerMove);
    this.domElement.removeEventListener("pointerup", this._onPointerUp);
    this.traverse(function(child) {
      if (child.geometry)
        child.geometry.dispose();
      if (child.material)
        child.material.dispose();
    });
  }
  // Set current object
  attach(object2) {
    this.object = object2;
    this.visible = true;
    return this;
  }
  // Detatch from object
  detach() {
    this.object = void 0;
    this.visible = false;
    this.axis = null;
    return this;
  }
  reset() {
    if (!this.enabled)
      return;
    if (this.dragging) {
      this.object.position.copy(this._positionStart);
      this.object.quaternion.copy(this._quaternionStart);
      this.object.scale.copy(this._scaleStart);
      this.dispatchEvent(_changeEvent);
      this.dispatchEvent(_objectChangeEvent);
      this.pointStart.copy(this.pointEnd);
    }
  }
  getRaycaster() {
    return _raycaster;
  }
  // TODO: deprecate
  getMode() {
    return this.mode;
  }
  setMode(mode2) {
    this.mode = mode2;
  }
  setTranslationSnap(translationSnap) {
    this.translationSnap = translationSnap;
  }
  setRotationSnap(rotationSnap) {
    this.rotationSnap = rotationSnap;
  }
  setScaleSnap(scaleSnap) {
    this.scaleSnap = scaleSnap;
  }
  setSize(size12) {
    this.size = size12;
  }
  setSpace(space) {
    this.space = space;
  }
  update() {
    console.warn("THREE.TransformControls: update function has no more functionality and therefore has been deprecated.");
  }
};
TransformControls$1.prototype.isTransformControls = true;
function getPointer$1(event) {
  if (this.domElement.ownerDocument.pointerLockElement) {
    return {
      x: 0,
      y: 0,
      button: event.button
    };
  } else {
    const rect = this.domElement.getBoundingClientRect();
    return {
      x: (event.clientX - rect.left) / rect.width * 2 - 1,
      y: -(event.clientY - rect.top) / rect.height * 2 + 1,
      button: event.button
    };
  }
}
function onPointerHover(event) {
  if (!this.enabled)
    return;
  switch (event.pointerType) {
    case "mouse":
    case "pen":
      this.pointerHover(this._getPointer(event));
      break;
  }
}
function onPointerDown(event) {
  if (!this.enabled)
    return;
  if (!document.pointerLockElement) {
    this.domElement.setPointerCapture(event.pointerId);
  }
  this.domElement.addEventListener("pointermove", this._onPointerMove);
  this.pointerHover(this._getPointer(event));
  this.pointerDown(this._getPointer(event));
}
function onPointerMove(event) {
  if (!this.enabled)
    return;
  this.pointerMove(this._getPointer(event));
}
function onPointerUp(event) {
  if (!this.enabled)
    return;
  this.domElement.releasePointerCapture(event.pointerId);
  this.domElement.removeEventListener("pointermove", this._onPointerMove);
  this.pointerUp(this._getPointer(event));
}
function intersectObjectWithRay(object2, raycaster, includeInvisible) {
  const allIntersections = raycaster.intersectObject(object2, true);
  for (let i2 = 0; i2 < allIntersections.length; i2++) {
    if (allIntersections[i2].object.visible || includeInvisible) {
      return allIntersections[i2];
    }
  }
  return false;
}
const _tempEuler = new Euler();
const _alignVector = new Vector3$1(0, 1, 0);
const _zeroVector = new Vector3$1(0, 0, 0);
const _lookAtMatrix = new Matrix4$1();
const _tempQuaternion2 = new Quaternion$1();
const _identityQuaternion = new Quaternion$1();
const _dirVector = new Vector3$1();
const _tempMatrix = new Matrix4$1();
const _unitX = new Vector3$1(1, 0, 0);
const _unitY = new Vector3$1(0, 1, 0);
const _unitZ = new Vector3$1(0, 0, 1);
const _v1 = new Vector3$1();
const _v2 = new Vector3$1();
const _v3 = new Vector3$1();
class TransformControlsGizmo extends Object3D {
  constructor() {
    super();
    this.type = "TransformControlsGizmo";
    const gizmoMaterial = new MeshBasicMaterial({
      depthTest: false,
      depthWrite: false,
      fog: false,
      toneMapped: false,
      transparent: true
    });
    const gizmoLineMaterial = new LineBasicMaterial({
      depthTest: false,
      depthWrite: false,
      fog: false,
      toneMapped: false,
      transparent: true
    });
    const matInvisible = gizmoMaterial.clone();
    matInvisible.opacity = 0.15;
    const matHelper = gizmoLineMaterial.clone();
    matHelper.opacity = 0.5;
    const matRed = gizmoMaterial.clone();
    matRed.color.setHex(16711680);
    const matGreen = gizmoMaterial.clone();
    matGreen.color.setHex(65280);
    const matBlue = gizmoMaterial.clone();
    matBlue.color.setHex(255);
    const matRedTransparent = gizmoMaterial.clone();
    matRedTransparent.color.setHex(16711680);
    matRedTransparent.opacity = 0.5;
    const matGreenTransparent = gizmoMaterial.clone();
    matGreenTransparent.color.setHex(65280);
    matGreenTransparent.opacity = 0.5;
    const matBlueTransparent = gizmoMaterial.clone();
    matBlueTransparent.color.setHex(255);
    matBlueTransparent.opacity = 0.5;
    const matWhiteTransparent = gizmoMaterial.clone();
    matWhiteTransparent.opacity = 0.25;
    const matYellowTransparent = gizmoMaterial.clone();
    matYellowTransparent.color.setHex(16776960);
    matYellowTransparent.opacity = 0.25;
    const matYellow = gizmoMaterial.clone();
    matYellow.color.setHex(16776960);
    const matGray = gizmoMaterial.clone();
    matGray.color.setHex(7895160);
    const arrowGeometry = new CylinderGeometry(0, 0.04, 0.1, 12);
    arrowGeometry.translate(0, 0.05, 0);
    const scaleHandleGeometry = new BoxGeometry(0.08, 0.08, 0.08);
    scaleHandleGeometry.translate(0, 0.04, 0);
    const lineGeometry = new BufferGeometry();
    lineGeometry.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 1, 0, 0], 3));
    const lineGeometry2 = new CylinderGeometry(75e-4, 75e-4, 0.5, 3);
    lineGeometry2.translate(0, 0.25, 0);
    function CircleGeometry2(radius, arc) {
      const geometry2 = new TorusGeometry(radius, 75e-4, 3, 64, arc * Math.PI * 2);
      geometry2.rotateY(Math.PI / 2);
      geometry2.rotateX(Math.PI / 2);
      return geometry2;
    }
    function TranslateHelperGeometry() {
      const geometry2 = new BufferGeometry();
      geometry2.setAttribute("position", new Float32BufferAttribute([0, 0, 0, 1, 1, 1], 3));
      return geometry2;
    }
    const gizmoTranslate = {
      X: [
        [new Mesh(arrowGeometry, matRed), [0.5, 0, 0], [0, 0, -Math.PI / 2]],
        [new Mesh(arrowGeometry, matRed), [-0.5, 0, 0], [0, 0, Math.PI / 2]],
        [new Mesh(lineGeometry2, matRed), [0, 0, 0], [0, 0, -Math.PI / 2]]
      ],
      Y: [
        [new Mesh(arrowGeometry, matGreen), [0, 0.5, 0]],
        [new Mesh(arrowGeometry, matGreen), [0, -0.5, 0], [Math.PI, 0, 0]],
        [new Mesh(lineGeometry2, matGreen)]
      ],
      Z: [
        [new Mesh(arrowGeometry, matBlue), [0, 0, 0.5], [Math.PI / 2, 0, 0]],
        [new Mesh(arrowGeometry, matBlue), [0, 0, -0.5], [-Math.PI / 2, 0, 0]],
        [new Mesh(lineGeometry2, matBlue), null, [Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new Mesh(new OctahedronGeometry(0.1, 0), matWhiteTransparent.clone()), [0, 0, 0]]
      ],
      XY: [
        [new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matBlueTransparent.clone()), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matRedTransparent.clone()), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matGreenTransparent.clone()), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ]
    };
    const pickerTranslate = {
      X: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0.3, 0, 0], [0, 0, -Math.PI / 2]],
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [-0.3, 0, 0], [0, 0, Math.PI / 2]]
      ],
      Y: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0.3, 0]],
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, -0.3, 0], [0, 0, Math.PI]]
      ],
      Z: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, 0.3], [Math.PI / 2, 0, 0]],
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, -0.3], [-Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new Mesh(new OctahedronGeometry(0.2, 0), matInvisible)]
      ],
      XY: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ]
    };
    const helperTranslate = {
      START: [
        [new Mesh(new OctahedronGeometry(0.01, 2), matHelper), null, null, null, "helper"]
      ],
      END: [
        [new Mesh(new OctahedronGeometry(0.01, 2), matHelper), null, null, null, "helper"]
      ],
      DELTA: [
        [new Line(TranslateHelperGeometry(), matHelper), null, null, null, "helper"]
      ],
      X: [
        [new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ],
      Y: [
        [new Line(lineGeometry, matHelper.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], "helper"]
      ],
      Z: [
        [new Line(lineGeometry, matHelper.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], "helper"]
      ]
    };
    const gizmoRotate = {
      XYZE: [
        [new Mesh(CircleGeometry2(0.5, 1), matGray), null, [0, Math.PI / 2, 0]]
      ],
      X: [
        [new Mesh(CircleGeometry2(0.5, 0.5), matRed)]
      ],
      Y: [
        [new Mesh(CircleGeometry2(0.5, 0.5), matGreen), null, [0, 0, -Math.PI / 2]]
      ],
      Z: [
        [new Mesh(CircleGeometry2(0.5, 0.5), matBlue), null, [0, Math.PI / 2, 0]]
      ],
      E: [
        [new Mesh(CircleGeometry2(0.75, 1), matYellowTransparent), null, [0, Math.PI / 2, 0]]
      ]
    };
    const helperRotate = {
      AXIS: [
        [new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ]
    };
    const pickerRotate = {
      XYZE: [
        [new Mesh(new SphereGeometry(0.25, 10, 8), matInvisible)]
      ],
      X: [
        [new Mesh(new TorusGeometry(0.5, 0.1, 4, 24), matInvisible), [0, 0, 0], [0, -Math.PI / 2, -Math.PI / 2]]
      ],
      Y: [
        [new Mesh(new TorusGeometry(0.5, 0.1, 4, 24), matInvisible), [0, 0, 0], [Math.PI / 2, 0, 0]]
      ],
      Z: [
        [new Mesh(new TorusGeometry(0.5, 0.1, 4, 24), matInvisible), [0, 0, 0], [0, 0, -Math.PI / 2]]
      ],
      E: [
        [new Mesh(new TorusGeometry(0.75, 0.1, 2, 24), matInvisible)]
      ]
    };
    const gizmoScale = {
      X: [
        [new Mesh(scaleHandleGeometry, matRed), [0.5, 0, 0], [0, 0, -Math.PI / 2]],
        [new Mesh(lineGeometry2, matRed), [0, 0, 0], [0, 0, -Math.PI / 2]],
        [new Mesh(scaleHandleGeometry, matRed), [-0.5, 0, 0], [0, 0, Math.PI / 2]]
      ],
      Y: [
        [new Mesh(scaleHandleGeometry, matGreen), [0, 0.5, 0]],
        [new Mesh(lineGeometry2, matGreen)],
        [new Mesh(scaleHandleGeometry, matGreen), [0, -0.5, 0], [0, 0, Math.PI]]
      ],
      Z: [
        [new Mesh(scaleHandleGeometry, matBlue), [0, 0, 0.5], [Math.PI / 2, 0, 0]],
        [new Mesh(lineGeometry2, matBlue), [0, 0, 0], [Math.PI / 2, 0, 0]],
        [new Mesh(scaleHandleGeometry, matBlue), [0, 0, -0.5], [-Math.PI / 2, 0, 0]]
      ],
      XY: [
        [new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matBlueTransparent), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matRedTransparent), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matGreenTransparent), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new Mesh(new BoxGeometry(0.1, 0.1, 0.1), matWhiteTransparent.clone())]
      ]
    };
    const pickerScale = {
      X: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0.3, 0, 0], [0, 0, -Math.PI / 2]],
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [-0.3, 0, 0], [0, 0, Math.PI / 2]]
      ],
      Y: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0.3, 0]],
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, -0.3, 0], [0, 0, Math.PI]]
      ],
      Z: [
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, 0.3], [Math.PI / 2, 0, 0]],
        [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, -0.3], [-Math.PI / 2, 0, 0]]
      ],
      XY: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0.15, 0]]
      ],
      YZ: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]
      ],
      XZ: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]
      ],
      XYZ: [
        [new Mesh(new BoxGeometry(0.2, 0.2, 0.2), matInvisible), [0, 0, 0]]
      ]
    };
    const helperScale = {
      X: [
        [new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], "helper"]
      ],
      Y: [
        [new Line(lineGeometry, matHelper.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], "helper"]
      ],
      Z: [
        [new Line(lineGeometry, matHelper.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], "helper"]
      ]
    };
    function setupGizmo(gizmoMap) {
      const gizmo = new Object3D();
      for (const name2 in gizmoMap) {
        for (let i2 = gizmoMap[name2].length; i2--; ) {
          const object2 = gizmoMap[name2][i2][0].clone();
          const position = gizmoMap[name2][i2][1];
          const rotation = gizmoMap[name2][i2][2];
          const scale5 = gizmoMap[name2][i2][3];
          const tag2 = gizmoMap[name2][i2][4];
          object2.name = name2;
          object2.tag = tag2;
          if (position) {
            object2.position.set(position[0], position[1], position[2]);
          }
          if (rotation) {
            object2.rotation.set(rotation[0], rotation[1], rotation[2]);
          }
          if (scale5) {
            object2.scale.set(scale5[0], scale5[1], scale5[2]);
          }
          object2.updateMatrix();
          const tempGeometry = object2.geometry.clone();
          tempGeometry.applyMatrix4(object2.matrix);
          object2.geometry = tempGeometry;
          object2.renderOrder = Infinity;
          object2.position.set(0, 0, 0);
          object2.rotation.set(0, 0, 0);
          object2.scale.set(1, 1, 1);
          gizmo.add(object2);
        }
      }
      return gizmo;
    }
    this.gizmo = {};
    this.picker = {};
    this.helper = {};
    this.add(this.gizmo["translate"] = setupGizmo(gizmoTranslate));
    this.add(this.gizmo["rotate"] = setupGizmo(gizmoRotate));
    this.add(this.gizmo["scale"] = setupGizmo(gizmoScale));
    this.add(this.picker["translate"] = setupGizmo(pickerTranslate));
    this.add(this.picker["rotate"] = setupGizmo(pickerRotate));
    this.add(this.picker["scale"] = setupGizmo(pickerScale));
    this.add(this.helper["translate"] = setupGizmo(helperTranslate));
    this.add(this.helper["rotate"] = setupGizmo(helperRotate));
    this.add(this.helper["scale"] = setupGizmo(helperScale));
    this.picker["translate"].visible = false;
    this.picker["rotate"].visible = false;
    this.picker["scale"].visible = false;
  }
  // updateMatrixWorld will update transformations and appearance of individual handles
  updateMatrixWorld(force) {
    const space = this.mode === "scale" ? "local" : this.space;
    const quaternion2 = space === "local" ? this.worldQuaternion : _identityQuaternion;
    this.gizmo["translate"].visible = this.mode === "translate";
    this.gizmo["rotate"].visible = this.mode === "rotate";
    this.gizmo["scale"].visible = this.mode === "scale";
    this.helper["translate"].visible = this.mode === "translate";
    this.helper["rotate"].visible = this.mode === "rotate";
    this.helper["scale"].visible = this.mode === "scale";
    let handles = [];
    handles = handles.concat(this.picker[this.mode].children);
    handles = handles.concat(this.gizmo[this.mode].children);
    handles = handles.concat(this.helper[this.mode].children);
    for (let i2 = 0; i2 < handles.length; i2++) {
      const handle = handles[i2];
      handle.visible = true;
      handle.rotation.set(0, 0, 0);
      handle.position.copy(this.worldPosition);
      let factor;
      if (this.camera.isOrthographicCamera) {
        factor = (this.camera.top - this.camera.bottom) / this.camera.zoom;
      } else {
        factor = this.worldPosition.distanceTo(this.cameraPosition) * Math.min(1.9 * Math.tan(Math.PI * this.camera.fov / 360) / this.camera.zoom, 7);
      }
      handle.scale.set(1, 1, 1).multiplyScalar(factor * this.size / 4);
      if (handle.tag === "helper") {
        handle.visible = false;
        if (handle.name === "AXIS") {
          handle.position.copy(this.worldPositionStart);
          handle.visible = !!this.axis;
          if (this.axis === "X") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, 0, 0));
            handle.quaternion.copy(quaternion2).multiply(_tempQuaternion);
            if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion2).dot(this.eye)) > 0.9) {
              handle.visible = false;
            }
          }
          if (this.axis === "Y") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, 0, Math.PI / 2));
            handle.quaternion.copy(quaternion2).multiply(_tempQuaternion);
            if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion2).dot(this.eye)) > 0.9) {
              handle.visible = false;
            }
          }
          if (this.axis === "Z") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, Math.PI / 2, 0));
            handle.quaternion.copy(quaternion2).multiply(_tempQuaternion);
            if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion2).dot(this.eye)) > 0.9) {
              handle.visible = false;
            }
          }
          if (this.axis === "XYZE") {
            _tempQuaternion.setFromEuler(_tempEuler.set(0, Math.PI / 2, 0));
            _alignVector.copy(this.rotationAxis);
            handle.quaternion.setFromRotationMatrix(_lookAtMatrix.lookAt(_zeroVector, _alignVector, _unitY));
            handle.quaternion.multiply(_tempQuaternion);
            handle.visible = this.dragging;
          }
          if (this.axis === "E") {
            handle.visible = false;
          }
        } else if (handle.name === "START") {
          handle.position.copy(this.worldPositionStart);
          handle.visible = this.dragging;
        } else if (handle.name === "END") {
          handle.position.copy(this.worldPosition);
          handle.visible = this.dragging;
        } else if (handle.name === "DELTA") {
          handle.position.copy(this.worldPositionStart);
          handle.quaternion.copy(this.worldQuaternionStart);
          _tempVector.set(1e-10, 1e-10, 1e-10).add(this.worldPositionStart).sub(this.worldPosition).multiplyScalar(-1);
          _tempVector.applyQuaternion(this.worldQuaternionStart.clone().invert());
          handle.scale.copy(_tempVector);
          handle.visible = this.dragging;
        } else {
          handle.quaternion.copy(quaternion2);
          if (this.dragging) {
            handle.position.copy(this.worldPositionStart);
          } else {
            handle.position.copy(this.worldPosition);
          }
          if (this.axis) {
            handle.visible = this.axis.search(handle.name) !== -1;
          }
        }
        continue;
      }
      handle.quaternion.copy(quaternion2);
      if (this.mode === "translate" || this.mode === "scale") {
        const AXIS_HIDE_TRESHOLD = 0.99;
        const PLANE_HIDE_TRESHOLD = 0.2;
        if (handle.name === "X") {
          if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion2).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "Y") {
          if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion2).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "Z") {
          if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion2).dot(this.eye)) > AXIS_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "XY") {
          if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion2).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "YZ") {
          if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion2).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
        if (handle.name === "XZ") {
          if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion2).dot(this.eye)) < PLANE_HIDE_TRESHOLD) {
            handle.scale.set(1e-10, 1e-10, 1e-10);
            handle.visible = false;
          }
        }
      } else if (this.mode === "rotate") {
        _tempQuaternion2.copy(quaternion2);
        _alignVector.copy(this.eye).applyQuaternion(_tempQuaternion.copy(quaternion2).invert());
        if (handle.name.search("E") !== -1) {
          handle.quaternion.setFromRotationMatrix(_lookAtMatrix.lookAt(this.eye, _zeroVector, _unitY));
        }
        if (handle.name === "X") {
          _tempQuaternion.setFromAxisAngle(_unitX, Math.atan2(-_alignVector.y, _alignVector.z));
          _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);
          handle.quaternion.copy(_tempQuaternion);
        }
        if (handle.name === "Y") {
          _tempQuaternion.setFromAxisAngle(_unitY, Math.atan2(_alignVector.x, _alignVector.z));
          _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);
          handle.quaternion.copy(_tempQuaternion);
        }
        if (handle.name === "Z") {
          _tempQuaternion.setFromAxisAngle(_unitZ, Math.atan2(_alignVector.y, _alignVector.x));
          _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);
          handle.quaternion.copy(_tempQuaternion);
        }
      }
      handle.visible = handle.visible && (handle.name.indexOf("X") === -1 || this.showX);
      handle.visible = handle.visible && (handle.name.indexOf("Y") === -1 || this.showY);
      handle.visible = handle.visible && (handle.name.indexOf("Z") === -1 || this.showZ);
      handle.visible = handle.visible && (handle.name.indexOf("E") === -1 || this.showX && this.showY && this.showZ);
      handle.material._color = handle.material._color || handle.material.color.clone();
      handle.material._opacity = handle.material._opacity || handle.material.opacity;
      handle.material.color.copy(handle.material._color);
      handle.material.opacity = handle.material._opacity;
      if (this.enabled && this.axis) {
        if (handle.name === this.axis) {
          handle.material.color.setHex(16776960);
          handle.material.opacity = 1;
        } else if (this.axis.split("").some(function(a2) {
          return handle.name === a2;
        })) {
          handle.material.color.setHex(16776960);
          handle.material.opacity = 1;
        }
      }
    }
    super.updateMatrixWorld(force);
  }
}
TransformControlsGizmo.prototype.isTransformControlsGizmo = true;
class TransformControlsPlane extends Mesh {
  constructor() {
    super(
      new PlaneGeometry(1e5, 1e5, 2, 2),
      new MeshBasicMaterial({ visible: false, wireframe: true, side: DoubleSide, transparent: true, opacity: 0.1, toneMapped: false })
    );
    this.type = "TransformControlsPlane";
  }
  updateMatrixWorld(force) {
    let space = this.space;
    this.position.copy(this.worldPosition);
    if (this.mode === "scale")
      space = "local";
    _v1.copy(_unitX).applyQuaternion(space === "local" ? this.worldQuaternion : _identityQuaternion);
    _v2.copy(_unitY).applyQuaternion(space === "local" ? this.worldQuaternion : _identityQuaternion);
    _v3.copy(_unitZ).applyQuaternion(space === "local" ? this.worldQuaternion : _identityQuaternion);
    _alignVector.copy(_v2);
    switch (this.mode) {
      case "translate":
      case "scale":
        switch (this.axis) {
          case "X":
            _alignVector.copy(this.eye).cross(_v1);
            _dirVector.copy(_v1).cross(_alignVector);
            break;
          case "Y":
            _alignVector.copy(this.eye).cross(_v2);
            _dirVector.copy(_v2).cross(_alignVector);
            break;
          case "Z":
            _alignVector.copy(this.eye).cross(_v3);
            _dirVector.copy(_v3).cross(_alignVector);
            break;
          case "XY":
            _dirVector.copy(_v3);
            break;
          case "YZ":
            _dirVector.copy(_v1);
            break;
          case "XZ":
            _alignVector.copy(_v3);
            _dirVector.copy(_v2);
            break;
          case "XYZ":
          case "E":
            _dirVector.set(0, 0, 0);
            break;
        }
        break;
      case "rotate":
      default:
        _dirVector.set(0, 0, 0);
    }
    if (_dirVector.length() === 0) {
      this.quaternion.copy(this.cameraQuaternion);
    } else {
      _tempMatrix.lookAt(_tempVector.set(0, 0, 0), _dirVector, _alignVector);
      this.quaternion.setFromRotationMatrix(_tempMatrix);
    }
    super.updateMatrixWorld(force);
  }
}
TransformControlsPlane.prototype.isTransformControlsPlane = true;
function TransformControls(props) {
  const {
    object: object2,
    scene,
    camera,
    gl,
    mode: mode2,
    onTransform: onTransformIn,
    showX,
    showY,
    showZ
  } = props;
  const transformRef = React__default.useRef(null);
  const previousMapControlsRef = React__default.useRef({});
  const {
    map: map5
  } = useMapbox();
  const lockMapControls = React__default.useCallback((lock) => {
    if (!map5)
      return;
    if (lock) {
      previousMapControlsRef.current = {
        dragPan: map5.dragPan.isEnabled(),
        dragRotate: map5.dragRotate.isEnabled(),
        touchZoomRotate: map5.touchZoomRotate.isEnabled()
      };
      map5.dragPan.disable();
      map5.dragRotate.disable();
      map5.touchZoomRotate.disableRotation();
    } else {
      if (previousMapControlsRef.current.dragPan)
        map5.dragPan.enable();
      if (previousMapControlsRef.current.dragRotate)
        map5.dragRotate.enable();
      if (previousMapControlsRef.current.touchZoomRotate)
        map5.touchZoomRotate.enableRotation();
    }
  }, [map5]);
  const onTransform = React__default.useCallback((drag) => {
    const {
      value
    } = drag || {};
    const started = !!value;
    if (started) {
      lockMapControls(true);
    }
    if (!started) {
      lockMapControls(false);
    }
    onTransformIn(started, object2 == null ? void 0 : object2.matrix);
  }, [lockMapControls, object2 == null ? void 0 : object2.matrix, onTransformIn]);
  const createControls = React__default.useCallback(() => {
    if (!gl || !camera || !scene || !object2)
      return;
    if (transformRef.current)
      return;
    const controls = new TransformControls$1(camera, gl.domElement);
    scene.add(controls);
    transformRef.current = controls;
  }, [camera, gl, object2, scene]);
  const removeControls = React__default.useCallback(() => () => {
    const controls = transformRef.current;
    if (scene && controls) {
      controls.removeFromParent();
      scene.remove(controls);
    }
  }, [scene]);
  const updateMode = React__default.useCallback(() => {
    const controls = transformRef.current;
    if (controls) {
      controls.mode = mode2;
      controls.showX = showX;
      controls.showY = showY;
      controls.showZ = showZ;
    }
  }, [mode2, showX, showY, showZ]);
  const attachDetachControls = React__default.useCallback(() => {
    if (object2 && transformRef.current) {
      const controls = transformRef.current;
      controls.attach(object2);
      return () => {
        controls.detach();
      };
    }
    return () => {
    };
  }, [object2]);
  const attachDetachDrag = React__default.useCallback(() => {
    if (object2 && transformRef.current) {
      const controls = transformRef.current;
      controls.addEventListener("dragging-changed", onTransform);
      return () => {
        controls.removeEventListener("dragging-changed", onTransform);
      };
    }
    return () => {
    };
  }, [object2, onTransform]);
  useEffect17(() => {
    createControls();
    updateMode();
    const detachControls = attachDetachControls();
    const detachDrag = attachDetachDrag();
    return () => {
      detachDrag();
      detachControls();
      removeControls();
    };
  });
  return null;
}
TransformControls.propTypes = {
  mode: propTypesExports$1.oneOf(["translate", "rotate", "scale"]),
  object: propTypesExports$1.object,
  scene: propTypesExports$1.object,
  camera: propTypesExports$1.object,
  gl: propTypesExports$1.object,
  onTransform: propTypesExports$1.func,
  showX: propTypesExports$1.bool,
  showY: propTypesExports$1.bool,
  showZ: propTypesExports$1.bool
};
TransformControls.defaultProps = {
  mode: "translate",
  object: null,
  scene: null,
  camera: null,
  gl: null,
  onTransform: () => {
  },
  showX: true,
  showY: true,
  showZ: true
};
function Object3dExportToGlbCesium(props) {
  const {
    onDone,
    assetName,
    object: object2,
    center: center2,
    isBinary,
    exportAs: exportAsIn,
    onProgress,
    flipY2Z,
    threshold: threshold2
  } = props;
  const isExportingRef = React__default.useRef(false);
  const hasExportedRef = React__default.useRef(false);
  const exportGltf = React__default.useCallback(async (file2) => {
    if (file2.dataType === "buffer") {
      const url2 = await FileUtil.readFile(file2.data, "dataUrl");
      file2 = {
        ...file2,
        dataType: "dataUrl",
        data: url2
      };
    }
    return {
      id: generateUid(),
      type: "GLTF",
      success: true,
      sourceFile: file2,
      center: center2,
      azimuth: 0,
      // absorbed in export
      head: 0,
      // absorbed in export
      dip: 0
      // absorbed in export
    };
  }, [center2]);
  const exportIon = React__default.useCallback(async (file2) => {
    try {
      const options2 = {
        longitude: center2[0],
        latitude: center2[1]
      };
      const result = await CesiumIonUtil.createAssetTiles(file2, options2, onProgress);
      const [cesiumAssetId, success] = result || [];
      if (cesiumAssetId && success) {
        return {
          id: cesiumAssetId,
          type: "ION",
          success: true
        };
      }
    } catch (error2) {
      console.error(error2);
    }
    return {
      id: void 0,
      type: "ION",
      success: false
    };
  }, [center2, onProgress]);
  const exportFunc = React__default.useCallback(async () => {
    if (!center2 || !object2 || !["GLTF", "3DTILES", "AUTO"].includes(exportAsIn))
      return null;
    const file2 = await GltfUtil.exportToGlb(object2, {
      assetName,
      flipY2Z,
      isBinary
    });
    if (!(file2 == null ? void 0 : file2.data))
      return null;
    let exportAs = exportAsIn;
    if (exportAs === "AUTO") {
      const size12 = file2.data.size / 1024 / 1024;
      if (size12 > threshold2) {
        exportAs = "3DTILES";
      } else {
        exportAs = "GLTF";
      }
    }
    let result;
    if (exportAs === "GLTF") {
      result = await exportGltf(file2);
      return result;
    }
    result = await exportIon(file2);
    if (!result.success && exportAsIn === "AUTO") {
      result = await exportGltf(file2);
    }
    return result;
  }, [assetName, center2, exportAsIn, exportGltf, exportIon, flipY2Z, isBinary, object2, threshold2]);
  React__default.useLayoutEffect(() => {
    if (isExportingRef.current)
      return;
    if (hasExportedRef.current)
      return;
    isExportingRef.current = true;
    exportFunc().then((result) => {
      isExportingRef.current = false;
      hasExportedRef.current = true;
      onDone(result);
    });
  }, [exportFunc, onDone]);
  return null;
}
Object3dExportToGlbCesium.propTypes = {
  onProgress: propTypesExports$1.func,
  onDone: propTypesExports$1.func,
  object: propTypesExports$1.instanceOf(Object3D),
  isBinary: propTypesExports$1.bool,
  assetName: propTypesExports$1.string,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  flipY2Z: propTypesExports$1.bool,
  exportAs: propTypesExports$1.oneOf(["GLTF", "3DTILES", "AUTO"]),
  threshold: propTypesExports$1.number
  // used only with AUTO
};
Object3dExportToGlbCesium.defaultProps = {
  onProgress: () => {
  },
  onDone: () => {
  },
  isBinary: false,
  object: null,
  assetName: "model3d",
  center: null,
  flipY2Z: true,
  exportAs: null,
  threshold: 10
  // in MB
};
const rounding = (num) => Number((num == null ? void 0 : num.toFixed(8)) || 0);
function TransformationForm(props) {
  const {
    center: center2,
    scale: scale5,
    dip,
    head,
    azimuth,
    onChange,
    onDone,
    disabled,
    ...restProps
  } = props;
  const [nonUniformScale, setNonUniformScale] = React__default.useState(false);
  const formValues = React__default.useMemo(() => {
    const position = [rounding(center2 == null ? void 0 : center2[0]), rounding(center2 == null ? void 0 : center2[1])];
    const height = rounding(center2 == null ? void 0 : center2[2]);
    return {
      position,
      height,
      azimuth: rounding(azimuth),
      head: rounding(head),
      dip: rounding(dip),
      nonUniformScale: !!nonUniformScale,
      scaleUniform: rounding(scale5[0]),
      scale: [rounding(scale5[0]), rounding(scale5[1]), rounding(scale5[2])]
    };
  }, [azimuth, center2, dip, head, scale5, nonUniformScale]);
  const onFormValuesChange = React__default.useCallback((values4, form) => {
    if (!values4)
      return;
    const {
      position,
      height,
      nonUniformScale: nonUniformScale2,
      scaleUniform,
      scale: scale22,
      ...rest
    } = values4 || {};
    const data2 = {
      center: [...position, height],
      ...rest
    };
    if (typeof scaleUniform === "number") {
      data2.scale = [scaleUniform, scaleUniform, scaleUniform];
      form == null ? void 0 : form.setFieldsValue({
        scale: data2.scale
      });
    } else if (Array.isArray(scale22)) {
      data2.scale = scale22;
    }
    if (typeof nonUniformScale2 === "boolean")
      setNonUniformScale(nonUniformScale2);
    onChange(data2, form);
  }, [onChange, setNonUniformScale]);
  const onCancel = React__default.useCallback((values4) => {
    onFormValuesChange(values4);
    onDone(false);
  }, [onDone, onFormValuesChange]);
  const onSubmit = React__default.useCallback((values4) => {
    onFormValuesChange(values4);
    onDone(true);
  }, [onDone, onFormValuesChange]);
  return /* @__PURE__ */ jsxs(ModalForm, { active: true, component: RightPanel, title: "Transform", style: {
    margin: "30px 120px auto auto"
  }, width: "400px", formValues, onChange: onFormValuesChange, validateOnCancel: true, closable: false, onSubmit, onCancel, ...restProps, children: [
    /* @__PURE__ */ jsx(Form.Item, { label: "Coordinates", name: "position", initialValue: formValues.position, disabled: disabled.includes("position"), children: /* @__PURE__ */ jsx(ArrayInput, { size: 2, component: [InputNumber$1, InputNumber$1], disabled: disabled.includes("position") }) }),
    /* @__PURE__ */ jsx(Form.Item, { label: "Height", name: "height", initialValue: formValues.height, disabled: disabled.includes("height"), children: /* @__PURE__ */ jsx(InputNumber$1, { placeholder: "Height", disabled: disabled.includes("height") }) }),
    /* @__PURE__ */ jsx(Form.Item, { label: "Azimuth", name: "azimuth", initialValue: formValues.azimuth || 0, disabled: disabled.includes("azimuth"), children: /* @__PURE__ */ jsx(InputNumber$1, { placeholder: "Azimuth", disabled: disabled.includes("azimuth") }) }),
    /* @__PURE__ */ jsx(Form.Item, { label: "Heading", name: "head", initialValue: formValues.head, disabled: disabled.includes("head"), children: /* @__PURE__ */ jsx(InputNumber$1, { placeholder: "Heading", disabled: disabled.includes("head") }) }),
    /* @__PURE__ */ jsx(Form.Item, { label: "Dip", name: "dip", initialValue: formValues.dip, disabled: disabled.includes("dip"), children: /* @__PURE__ */ jsx(InputNumber$1, { placeholder: "Dip", disabled: disabled.includes("dip") }) }),
    /* @__PURE__ */ jsx(Form.Item, { label: "Non-Uniform Scale", name: "nonUniformScale", initialValue: formValues.nonUniformScale, disabled: disabled.includes("nonUniformScale"), valuePropName: "checked", children: /* @__PURE__ */ jsx(Checkbox, { disabled: disabled.includes("nonUniformScale") }) }),
    formValues.nonUniformScale && /* @__PURE__ */ jsx(Form.Item, { label: "Scale", name: "scale", initialValue: formValues.scale, disabled: disabled.includes("scale"), children: /* @__PURE__ */ jsx(ArrayInput, { size: 3, disabled: disabled.includes("scale"), component: [InputNumber$1, InputNumber$1, InputNumber$1] }) }),
    !formValues.nonUniformScale && /* @__PURE__ */ jsx(Form.Item, { label: "Scale", name: "scaleUniform", initialValue: formValues.scale[0], disabled: disabled.includes("scale"), children: /* @__PURE__ */ jsx(InputNumber$1, { disabled: disabled.includes("scale") }) })
  ] });
}
TransformationForm.propTypes = {
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  nonUniformScale: propTypesExports$1.bool,
  scale: propTypesExports$1.arrayOf(propTypesExports$1.number),
  dip: propTypesExports$1.number,
  head: propTypesExports$1.number,
  azimuth: propTypesExports$1.number,
  onDone: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  disabled: propTypesExports$1.arrayOf(propTypesExports$1.string)
};
TransformationForm.defaultProps = {
  center: null,
  nonUniformScale: true,
  scale: [1, 1, 1],
  dip: 0,
  head: 0,
  azimuth: 0,
  onDone: () => {
  },
  onChange: () => {
  },
  disabled: []
};
function DxfToGeoJson(props) {
  const {
    onDone,
    object: object2,
    toGeoPoint,
    enableLayers,
    onProgress
  } = props;
  const createGeoJson = React__default.useCallback(() => DxfUtil.createGeoJson(object2, toGeoPoint, enableLayers), [enableLayers, object2, toGeoPoint]);
  const exportFunc = React__default.useCallback(() => {
    onProgress({
      percentComplete: 0.1
    });
    return new Promise((resolve2) => {
      setTimeout(() => {
        var _a3;
        const result = createGeoJson();
        onProgress({
          percentComplete: 0.9
        });
        if (result) {
          const hasFeatures = !!((_a3 = result.features) == null ? void 0 : _a3.length);
          resolve2({
            id: hasFeatures ? generateUid() : void 0,
            geojson: result,
            type: "GEOJSON",
            success: hasFeatures
          });
        }
      }, 20);
    });
  }, [createGeoJson, onProgress]);
  const onceRef = React__default.useRef(false);
  React__default.useLayoutEffect(() => {
    if (onceRef.current || !object2)
      return;
    onceRef.current = true;
    exportFunc().then((result) => onDone(result));
  }, [exportFunc, object2, onDone]);
  return null;
}
DxfToGeoJson.propTypes = {
  onDone: propTypesExports$1.func,
  onProgress: propTypesExports$1.func,
  object: propTypesExports$1.instanceOf(Object3D),
  toGeoPoint: propTypesExports$1.func,
  enableLayers: propTypesExports$1.bool
};
DxfToGeoJson.defaultProps = {
  onDone: () => {
  },
  onProgress: () => {
  },
  object: null,
  toGeoPoint: void 0,
  enableLayers: true
};
const radians2degrees = (radians2) => {
  const pi2 = Math.PI;
  return radians2 * (180 / pi2);
};
const degrees2Radians = (deg) => {
  const pi2 = Math.PI;
  return deg / (180 / pi2);
};
function ThreeLoaderLayer(props) {
  const {
    id,
    center: center2,
    data: data2,
    isBinary,
    opacity,
    color,
    enableTransform,
    transformMode,
    onTransform: onTransformIn,
    onLoad,
    exportProps,
    containerId,
    containerClassName,
    enableForm,
    type,
    enableAuto3dTiles,
    threshold3dTiles,
    recenterOnMass,
    ...restProps
  } = props;
  const {
    map: map5
  } = useMapbox();
  const layerRef = React__default.useRef(null);
  const [info, setInfo] = React__default.useState(null);
  const [geoReference, setGeoReference] = React__default.useState({
    center: center2,
    dip: restProps.dip,
    head: restProps.head,
    azimuth: restProps.azimuth,
    scale: restProps.scale
  });
  const [conversionNeeded, setConversionNeeded] = React__default.useState(false);
  const {
    object: object2,
    scene,
    camera,
    gl
  } = info || {};
  const [inverseMatrix, setInverseMatrix] = React__default.useState(null);
  const {
    onExportStart,
    onExportDone,
    onExportProgress
  } = React__default.useMemo(() => {
    const NullFunc = () => {
    };
    const {
      onExportStart: onExportStart2 = NullFunc,
      onExportDone: onExportDone2 = NullFunc,
      onExportProgress: onExportProgress2 = NullFunc
    } = exportProps || {};
    return {
      onExportDone: onExportDone2,
      onExportProgress: onExportProgress2,
      onExportStart: onExportStart2
    };
  }, [exportProps]);
  const {
    LayerImplementation,
    formProps,
    transformProps
  } = React__default.useMemo(() => {
    if (type === "DXF") {
      return {
        LayerImplementation: DxfLayer,
        formProps: {
          okText: "Ok",
          // 'GeoJson',
          cancelText: "Cancel",
          cancelButtonProps: {
            style: {
              display: "none"
            }
          },
          // Donot show cancel
          disabled: ["head", "dip"]
        },
        transformProps: {
          showX: transformMode !== "rotate",
          showY: transformMode !== "rotate",
          showZ: transformMode === "rotate"
        }
      };
    }
    if (type === "GLTF") {
      return {
        LayerImplementation: GltfLayer,
        formProps: {
          okText: "Ok",
          // '3D Tiles',
          cancelText: "Cancel",
          // 'GLTF',
          cancelButtonProps: {
            style: {
              display: "none"
            }
          },
          // Donot show cancel
          disabled: ["head", "dip"]
        },
        transformProps: {}
      };
    }
    return {
      formProps: {}
    };
  }, [type, transformMode]);
  const createLayer2 = React__default.useCallback(() => {
    if (!center2 || !map5 || !LayerImplementation)
      return;
    if (layerRef.current)
      return;
    const layer = new LayerImplementation({
      id,
      url: data2,
      color,
      opacity,
      center: center2,
      recenterOnMass,
      ...restProps
    });
    map5.addLayer(layer);
    const isLoadingCompleted = (layer2) => {
      if (layer2.cameraSync) {
        const {
          content: object22,
          scene: scene2,
          camera: camera2,
          renderer: gl2
        } = layer2;
        setInfo({
          object: object22,
          scene: scene2,
          camera: camera2,
          gl: gl2
        });
        onLoad(layer2);
      }
    };
    layer.loadPromise().then(() => isLoadingCompleted(layer));
    layerRef.current = layer;
  }, [center2, map5, LayerImplementation, id, data2, color, opacity, restProps, recenterOnMass, onLoad]);
  const removeLayer2 = React__default.useCallback(() => {
    try {
      if (layerRef.current) {
        const layer = layerRef.current;
        layerRef.current = null;
        map5 == null ? void 0 : map5.removeLayer(layer.id);
      }
    } catch (error2) {
      console.error(error2);
    }
  }, [map5]);
  const createLayerRef = useValueRef(createLayer2);
  const removeLayerRef = useValueRef(removeLayer2);
  useEffect17(() => {
    var _a3;
    (_a3 = createLayerRef.current) == null ? void 0 : _a3.call(createLayerRef);
    const removeLayer22 = removeLayerRef.current;
    return removeLayer22;
  });
  const onTransform = React__default.useCallback((started, matrix) => {
    if (!started && matrix) {
      const position = new Vector3$1();
      const quaternion2 = new Quaternion$1();
      const scale5 = new Vector3$1();
      matrix.decompose(position, quaternion2, scale5);
      const euler = new Euler().setFromQuaternion(quaternion2);
      const geoRef = {
        center: layerRef.current.toGeoPoint(position),
        dip: radians2degrees(euler.x),
        head: radians2degrees(euler.y),
        azimuth: radians2degrees(euler.z),
        scale: [scale5.x, scale5.y, scale5.z]
      };
      onTransformIn({
        id,
        ...geoRef,
        needsGeoReferencing: false
      });
      setGeoReference(geoRef);
    }
  }, [id, onTransformIn]);
  const onTransformInput = React__default.useCallback((values4) => {
    if (object2 && layerRef.current && values4) {
      const {
        center: center22,
        dip,
        head,
        azimuth,
        scale: scale5
      } = values4;
      if (center22) {
        const euler = new Euler(degrees2Radians(dip), degrees2Radians(head), degrees2Radians(azimuth), "XYZ");
        const quaternion2 = new Quaternion$1().setFromEuler(euler);
        const position = layerRef.current.toThreePoint(center22);
        object2.position.copy(position);
        object2.quaternion.copy(quaternion2);
        object2.scale.set(scale5[0], scale5[1], scale5[2]);
        object2.updateMatrix();
        onTransformIn({
          id,
          center: center22,
          dip,
          head,
          azimuth,
          scale: scale5
        });
        const geoRef = {
          center: center22,
          dip,
          head,
          azimuth,
          scale: scale5
        };
        setGeoReference(geoRef);
      }
    }
  }, [id, object2, onTransformIn]);
  const onTransformFormDone = React__default.useCallback((okPressed) => {
    if (okPressed && object2) {
      const matrix = new Matrix4$1().copy(object2.parent.matrixWorld).invert();
      setInverseMatrix(matrix);
    }
    let needToConvert = false;
    if (type === "DXF") {
      needToConvert = okPressed ? "GEOJSON" : false;
    } else if (type === "GLTF") {
      if (okPressed) {
        needToConvert = enableAuto3dTiles ? "AUTO" : "GLTF";
      } else {
        needToConvert = "GLTF";
      }
    }
    setConversionNeeded(needToConvert);
    if (needToConvert)
      onExportStart();
    else
      onExportDone();
  }, [enableAuto3dTiles, object2, onExportDone, onExportStart, type]);
  const toGeoPoint = React__default.useCallback((worldPosition) => {
    if (!layerRef.current || !object2)
      return null;
    const point4 = layerRef.current.toGeoPoint(worldPosition.clone().applyMatrix4(inverseMatrix));
    return [point4[0], point4[1]];
  }, [inverseMatrix, object2]);
  const element = React__default.useMemo(() => {
    var _a3;
    return document.getElementById(containerId) || ((_a3 = document.getElementsByClassName(containerClassName)) == null ? void 0 : _a3[0]) || document.body;
  }, [containerClassName, containerId]);
  const renderForm = React__default.useCallback(() => {
    if (!enableForm || !enableTransform || !transformMode)
      return null;
    return /* @__PURE__ */ jsx(TransformationForm, { ...geoReference, onDone: onTransformFormDone, onChange: onTransformInput, getContainer: element, ...formProps });
  }, [element, enableForm, enableTransform, formProps, geoReference, onTransformFormDone, onTransformInput, transformMode]);
  const renderDebugCenter = React__default.useCallback(() => {
    const debug2 = false;
    if (!center2 || !debug2)
      return null;
    return /* @__PURE__ */ jsx(GeojsonPointLayer, { id: `test${id}`, data: {
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: center2
        }
      }]
    }, iconUrl: "https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png", iconSize: 0.1 });
  }, [center2, id]);
  if (conversionNeeded && !enableTransform && type === "GLTF")
    return /* @__PURE__ */ jsx(Object3dExportToGlbCesium, { id, object: object2, isBinary, exportAs: conversionNeeded, ...geoReference, onProgress: onExportProgress, onDone: onExportDone, threshold: threshold3dTiles });
  if (conversionNeeded && !enableTransform && type === "DXF")
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(DxfToGeoJson, { object: object2, onDone: onExportDone, toGeoPoint }, id),
      renderDebugCenter()
    ] });
  if (!enableTransform || !object2 || !transformMode || !scene || !camera || !gl)
    return renderDebugCenter();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(TransformControls, { object: object2, scene, camera, gl, mode: transformMode, onTransform, ...transformProps }, transformMode),
    createPortal(renderForm(), element),
    renderDebugCenter()
  ] });
}
ThreeLoaderLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  data: propTypesExports$1.string.isRequired,
  type: propTypesExports$1.oneOf(["DXF", "GLTF"]),
  isBinary: propTypesExports$1.bool,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number).isRequired,
  opacity: propTypesExports$1.number,
  color: propTypesExports$1.oneOfType([propTypesExports$1.number, propTypesExports$1.string]),
  enableTransform: propTypesExports$1.bool,
  onLoad: propTypesExports$1.func,
  onTransform: propTypesExports$1.func,
  transformMode: propTypesExports$1.oneOf(["", "translate", "rotate", "scale"]),
  exportProps: propTypesExports$1.object,
  containerId: propTypesExports$1.string,
  containerClassName: propTypesExports$1.string,
  enableForm: propTypesExports$1.bool,
  enableAuto3dTiles: propTypesExports$1.bool,
  // whether to decide automatically 3DTILES creation (applicable to GLTF)
  threshold3dTiles: propTypesExports$1.number,
  // size above this which 3DTILES will be created (applicable to GLTF)
  recenterOnMass: propTypesExports$1.bool
};
ThreeLoaderLayer.defaultProps = {
  type: null,
  isBinary: false,
  opacity: 1,
  color: null,
  // '#f5fefd',
  enableTransform: false,
  onLoad: () => {
  },
  onTransform: () => {
  },
  transformMode: "",
  exportProps: {},
  containerId: "",
  containerClassName: "",
  enableForm: true,
  enableAuto3dTiles: true,
  threshold3dTiles: void 0,
  recenterOnMass: true
};
function ImageSkewControls(props) {
  const {
    sourceId,
    onClick: onClick2,
    onChange,
    active: activate,
    onStart
  } = props;
  const {
    map: map5
  } = useMapbox();
  const hasValidSource = React__default.useMemo(() => {
    if (!map5)
      return false;
    return !!map5.getSource(sourceId);
  }, [map5, sourceId]);
  const imageSkewEnabledRef = React__default.useRef(activate);
  React__default.useLayoutEffect(() => {
    imageSkewEnabledRef.current = !!activate;
  }, [activate]);
  const cartesianDistance = React__default.useCallback((array1, array2) => {
    const delta = [array1[0] - array2[0], array1[1] - array2[1]];
    return Math.sqrt(delta[0] * delta[0] + delta[1] * delta[1]);
  }, []);
  const mouseDown = React__default.useCallback((downEvent) => {
    var _a3;
    onStart();
    const source = map5 == null ? void 0 : map5.getSource(sourceId);
    if (!source || !imageSkewEnabledRef.current)
      return;
    const downCoords = CoordinateUtil.toArray(CoordinateUtil.toMercator(downEvent.lngLat));
    let minDistance = Number.MAX_SAFE_INTEGER;
    let downIndex = 0;
    let initialCoordsAtIndex = null;
    (_a3 = source.coordinates) == null ? void 0 : _a3.forEach((xyz, index2) => {
      const cur = CoordinateUtil.toArray(CoordinateUtil.toMercator(xyz));
      const dist2 = cartesianDistance(downCoords, cur);
      if (dist2 < minDistance) {
        minDistance = dist2;
        downIndex = index2;
        initialCoordsAtIndex = cur;
      }
    });
    function onMove(moveEvent) {
      const initialCoords = source.coordinates;
      const len2 = (initialCoords == null ? void 0 : initialCoords.length) || 0;
      if (!len2 || !initialCoordsAtIndex)
        return;
      const finalCoords = initialCoords.map((coord, index2) => {
        if (index2 !== downIndex)
          return coord;
        const movedCoords = CoordinateUtil.toArray(CoordinateUtil.toMercator(moveEvent.lngLat));
        const delta = [movedCoords[0] - downCoords[0], movedCoords[1] - downCoords[1]];
        const offsettedCoord = [...initialCoordsAtIndex];
        offsettedCoord[0] += delta[0];
        offsettedCoord[1] += delta[1];
        const v5 = CoordinateUtil.toArray(CoordinateUtil.toLngLat(offsettedCoord));
        return [v5[0], v5[1]];
      });
      source.setCoordinates(finalCoords);
    }
    function onUp() {
      map5.off("mousemove", onMove);
      onChange(source.coordinates);
    }
    downEvent.preventDefault();
    map5.on("mousemove", onMove);
    map5.once("mouseup", onUp);
  }, [map5, sourceId, cartesianDistance, onStart, onClick2, onChange]);
  React__default.useEffect(() => {
    if (!hasValidSource) {
      return null;
    }
    map5.on("mousedown", mouseDown);
    return () => {
      if (map5) {
        map5.off("mousedown", mouseDown);
      }
    };
  }, [hasValidSource, map5, mouseDown]);
  React__default.useEffect(() => {
    if (activate) {
      return () => onClick2 == null ? void 0 : onClick2();
    }
    return () => {
    };
  }, [activate, onClick2]);
  const buttonData = React__default.useMemo(() => [{
    className: cssstyles["mapboxgl-ctrl-image-skew"],
    tooltip: "Skew image",
    onClick: onClick2
  }], [onClick2]);
  if (!hasValidSource || !onClick2)
    return null;
  return /* @__PURE__ */ jsx(MapButtonControl, { map: map5, buttons: buttonData, anchor: "top-right" }, "imageSkewControls");
}
ImageSkewControls.propTypes = {
  sourceId: propTypesExports$1.string.isRequired,
  onClick: propTypesExports$1.func,
  active: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  onStart: propTypesExports$1.func
};
ImageSkewControls.defaultProps = {
  onClick: null,
  // means no button control required
  active: false,
  onChange: () => {
  },
  onStart: () => {
  }
};
class CoordinateIterator {
  constructor(data2, type) {
    this.type = type;
    this.data = data2;
  }
  getData() {
    return this.data;
  }
  transformCoordinates(callback) {
    const result = CoordinateIterator.transformData(this.data, callback);
    return new CoordinateIterator(result, this.type);
  }
  forEachCoordinates(callback, selector) {
    CoordinateIterator.transformData(this.data, callback, selector);
  }
  filterFeatures(selector) {
    const result = CoordinateIterator.transformData(this.data, (p2) => p2, selector);
    return new CoordinateIterator(result, this.type);
  }
  static transformData(data2, callback = (p2) => p2, selector = () => true) {
    if (!data2)
      return null;
    if (data2 == null ? void 0 : data2.geometry) {
      const selected = selector(data2);
      if (selected) {
        const coordinates2 = CoordinateIterator.transformData(data2.geometry.coordinates, callback, selector);
        return {
          ...data2,
          geometry: {
            ...data2.geometry,
            coordinates: coordinates2
          }
        };
      }
      return null;
    }
    if (!Array.isArray(data2))
      return null;
    if (data2.every((subItem) => typeof subItem === "number")) {
      return callback(data2);
    }
    return data2.map((item) => CoordinateIterator.transformData(item, callback, selector)).filter((item) => !!item);
  }
}
const useSourceCoordinates = (sourceIdIn) => {
  const [hasValidSource, setHasValidSource] = React__default.useState(false);
  const {
    map: map5
  } = useMapbox();
  const isSingleSource = typeof sourceIdIn === "string";
  const sourceIds = React__default.useMemo(() => {
    if (!sourceIdIn)
      return [];
    if (Array.isArray(sourceIdIn))
      return sourceIdIn;
    if (typeof sourceIdIn === "string")
      return [sourceIdIn];
    return [];
  }, [sourceIdIn]);
  React__default.useEffect(() => {
    const handle = setTimeout(() => {
      if (!map5) {
        setHasValidSource(false);
        return;
      }
      const isValid8 = sourceIds.some((sourceId) => {
        try {
          return !!map5.getSource(sourceId);
        } catch (error2) {
        }
        return false;
      });
      setHasValidSource(isValid8);
    }, 500);
    return () => {
      if (handle)
        clearTimeout(handle);
    };
  }, [map5, sourceIds]);
  const getCoordinates12 = React__default.useCallback((sourceId) => {
    var _a3;
    if (!hasValidSource || !sourceIds.includes(sourceId))
      return null;
    const source = map5 == null ? void 0 : map5.getSource(sourceId);
    let coordinates2 = null;
    let featureCollection2 = null;
    switch (source == null ? void 0 : source.type) {
      case "image":
        coordinates2 = source.coordinates;
        break;
      case "geojson":
        featureCollection2 = source._data;
        break;
    }
    const len2 = (coordinates2 == null ? void 0 : coordinates2.length) || ((_a3 = featureCollection2 == null ? void 0 : featureCollection2.features) == null ? void 0 : _a3.length) || 0;
    if (!len2)
      return null;
    const data2 = (coordinates2 == null ? void 0 : coordinates2.length) ? coordinates2 : featureCollection2 == null ? void 0 : featureCollection2.features;
    return new CoordinateIterator(data2, source.type);
  }, [hasValidSource, map5, sourceIds]);
  const setCoordinates2 = React__default.useCallback((sourceId, data2) => {
    if (!hasValidSource || !sourceIds.includes(sourceId))
      return;
    const source = map5 == null ? void 0 : map5.getSource(sourceId);
    const coordinates2 = data2.getData();
    switch (source == null ? void 0 : source.type) {
      case "image":
        source.setCoordinates(coordinates2);
        break;
      case "geojson":
        source.setData({
          // eslint-disable-next-line no-underscore-dangle
          ...source._data || {},
          features: coordinates2
        });
        break;
    }
  }, [hasValidSource, map5, sourceIds]);
  return {
    hasValidSource,
    isSingleSource,
    sourceIds,
    getCoordinates: getCoordinates12,
    setCoordinates: setCoordinates2
  };
};
function BoxDragControls(props) {
  const {
    sourceId: sourceIdIn,
    onChange,
    active: activate,
    onStart,
    anchorLayerId: anchorLayerIds
  } = props;
  const {
    map: map5
  } = useMapbox();
  const {
    hasValidSource,
    isSingleSource,
    sourceIds,
    getCoordinates: getCoordinates12,
    setCoordinates: setCoordinates2
  } = useSourceCoordinates(sourceIdIn);
  const rasterAnchorSourceId = React__default.useMemo(() => {
    if (!(sourceIds == null ? void 0 : sourceIds.length) || !map5)
      return "";
    const {
      sources: sources2
    } = map5.getStyle();
    let rasterSourceId = "";
    sourceIds.some((sourceId) => {
      var _a3;
      if (((_a3 = sources2 == null ? void 0 : sources2[sourceId]) == null ? void 0 : _a3.type) === "image") {
        rasterSourceId = sourceId;
      }
      return !!rasterSourceId;
    });
    return rasterSourceId;
  }, [map5, sourceIds]);
  const dragEnabledRef = React__default.useRef(activate);
  React__default.useLayoutEffect(() => {
    dragEnabledRef.current = !!activate;
  }, [activate]);
  const onDone = React__default.useCallback((sources2) => {
    var _a3, _b3;
    if (!sources2)
      return;
    let result = {};
    (_a3 = Object.keys(sources2)) == null ? void 0 : _a3.forEach((key) => {
      var _a4;
      const item = sources2[key];
      result[key] = (_a4 = item == null ? void 0 : item.getData) == null ? void 0 : _a4.call(item);
    });
    if (isSingleSource) {
      result = (_b3 = Object.values(result)) == null ? void 0 : _b3[0];
    }
    onChange({
      sources: result
    });
  }, [isSingleSource, onChange]);
  const {
    onListener: getFeature
  } = useMapListener({
    layerIds: anchorLayerIds,
    sourceId: rasterAnchorSourceId,
    isRaster: !!rasterAnchorSourceId
  });
  const mouseDown = React__default.useCallback((downEvent) => {
    const feature2 = getFeature(downEvent);
    if (!feature2)
      return;
    if (!downEvent.lngLat)
      return;
    const sources2 = {};
    const lastUpdatedSources = {};
    let hasCoordinates = false;
    sourceIds.forEach((sourceId) => {
      const data2 = getCoordinates12(sourceId);
      if (!data2 || !dragEnabledRef.current)
        return;
      sources2[sourceId] = data2;
      hasCoordinates = true;
    });
    if (!hasCoordinates)
      return;
    const initialMouseCoords = downEvent.lngLat;
    if (!initialMouseCoords)
      return;
    onStart({
      key: "drag"
    });
    function onMove(moveEvent) {
      var _a3;
      if (!sources2)
        return;
      const coords = moveEvent.lngLat;
      const delta = [coords.lng - initialMouseCoords.lng, coords.lat - initialMouseCoords.lat];
      (_a3 = Object.keys(sources2)) == null ? void 0 : _a3.forEach((sourceId) => {
        const data2 = sources2[sourceId].transformCoordinates((v5) => {
          const newCoords = [v5[0] + delta[0], v5[1] + delta[1]];
          return newCoords;
        });
        setCoordinates2(sourceId, data2);
        lastUpdatedSources[sourceId] = data2;
      });
    }
    function onUp() {
      map5.off("mousemove", onMove);
      onDone(lastUpdatedSources);
    }
    downEvent.preventDefault();
    map5.on("mousemove", onMove);
    map5.once("mouseup", onUp);
  }, [getFeature, sourceIds, onStart, map5, getCoordinates12, setCoordinates2, onDone]);
  React__default.useEffect(() => {
    if (!hasValidSource)
      return () => {
      };
    map5.on("mousedown", mouseDown);
    return () => {
      if (map5) {
        map5.off("mousedown", mouseDown);
      }
    };
  }, [hasValidSource, map5, mouseDown]);
  return null;
}
BoxDragControls.propTypes = {
  sourceId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  anchorLayerId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  active: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  onStart: propTypesExports$1.func
};
BoxDragControls.defaultProps = {
  sourceId: [],
  anchorLayerId: "",
  active: false,
  onChange: () => {
  },
  onStart: () => {
  }
};
function useScalingRotation(props) {
  const {
    anchorLayerId: anchorLayerIds,
    sourceId: sourceIdIn,
    enabledScale,
    enabledRotate,
    onChange,
    center: center2
  } = props;
  const {
    map: map5
  } = useMapbox();
  const {
    hasValidSource,
    sourceIds,
    getCoordinates: getCoordinates12,
    setCoordinates: setCoordinates2
  } = useSourceCoordinates(sourceIdIn);
  const scaleEnabledRef = React__default.useRef(!!enabledScale);
  React__default.useLayoutEffect(() => {
    scaleEnabledRef.current = !!enabledScale;
  }, [enabledScale]);
  const rotateEnabledRef = React__default.useRef(enabledRotate);
  React__default.useLayoutEffect(() => {
    rotateEnabledRef.current = !!enabledRotate;
  }, [enabledRotate]);
  const onDone = React__default.useCallback((sources2, output2 = {}) => {
    var _a3;
    if (!sources2)
      return;
    const result = {};
    (_a3 = Object.keys(sources2)) == null ? void 0 : _a3.forEach((key) => {
      var _a4;
      const item = sources2[key];
      result[key] = (_a4 = item == null ? void 0 : item.getData) == null ? void 0 : _a4.call(item);
    });
    onChange({
      sources: result,
      ...output2
    });
  }, [onChange]);
  const getSources = React__default.useCallback((sourceIds2) => {
    const sources2 = {};
    let hasCoordinates = false;
    sourceIds2.forEach((sourceId) => {
      const data2 = getCoordinates12(sourceId);
      if (!data2 || !scaleEnabledRef.current && !rotateEnabledRef.current)
        return;
      sources2[sourceId] = data2;
      hasCoordinates = true;
    });
    if (!hasCoordinates)
      return null;
    return sources2;
  }, [getCoordinates12]);
  const getAnchorSources = React__default.useCallback((anchorLayerIds2) => {
    var _a3, _b3;
    if (!map5 || !anchorLayerIds2)
      return null;
    const layerIds = Array.isArray(anchorLayerIds2) ? anchorLayerIds2 : [anchorLayerIds2];
    if (!layerIds.length)
      return null;
    const layers = (_b3 = (_a3 = map5.getStyle()) == null ? void 0 : _a3.layers) == null ? void 0 : _b3.filter((layer) => layerIds.includes(layer.id));
    if (!(layers == null ? void 0 : layers.length))
      return null;
    const sourceIds2 = layers.map((layer) => layer.source).filter((s2) => !!s2);
    if (!(sourceIds2 == null ? void 0 : sourceIds2.length))
      return null;
    return getSources(sourceIds2);
  }, [getSources, map5]);
  const getAzimuth = React__default.useCallback((sources2) => {
    var _a3;
    if (!sources2)
      return 0;
    let south2NorthLineString = null;
    (_a3 = Object.keys(sources2)) == null ? void 0 : _a3.forEach((sourceId) => {
      sources2[sourceId].forEachCoordinates(() => {
      }, (f2) => {
        var _a4, _b3;
        if (!south2NorthLineString && ((_a4 = f2 == null ? void 0 : f2.geometry) == null ? void 0 : _a4.type) === "LineString" && ((_b3 = f2.properties) == null ? void 0 : _b3.orientation) === "sn") {
          south2NorthLineString = f2;
        }
      });
    });
    if (!south2NorthLineString)
      return 0;
    const [coord1, coord2] = south2NorthLineString.geometry.coordinates;
    return GeoUtil.getAzimuth(coord1, coord2);
  }, []);
  const getCenter = React__default.useCallback((sources2) => {
    var _a3;
    if (center2)
      return CoordinateUtil.toArray(CoordinateUtil.toMercator(center2));
    if (!sources2)
      return null;
    const initialCenter = [0, 0];
    let counter2 = 0;
    (_a3 = Object.keys(sources2)) == null ? void 0 : _a3.forEach((sourceId) => {
      sources2[sourceId].forEachCoordinates((v5) => {
        const mercV = CoordinateUtil.toArray(CoordinateUtil.toMercator(v5));
        initialCenter[0] += mercV[0];
        initialCenter[1] += mercV[1];
        counter2 += 1;
      });
    });
    if (!counter2)
      return null;
    initialCenter[0] /= counter2;
    initialCenter[1] /= counter2;
    return initialCenter;
  }, [center2]);
  const rotatePoint = React__default.useCallback((coord, center22, angleR) => {
    const cosAngleR = Math.cos(angleR);
    const sinAngleR = Math.sin(angleR);
    const localCoord = [coord[0] - center22[0], coord[1] - center22[1]];
    const localRotatedCoord = [localCoord[0] * cosAngleR - localCoord[1] * sinAngleR, localCoord[0] * sinAngleR + localCoord[1] * cosAngleR];
    const rotatedCoord = [localRotatedCoord[0] + center22[0], localRotatedCoord[1] + center22[1]];
    return rotatedCoord;
  }, []);
  const scalePoint = React__default.useCallback((coord, center22, scale5) => {
    const scaledCoord = [center22[0] + (coord[0] - center22[0]) * scale5[0], center22[1] + (coord[1] - center22[1]) * scale5[1]];
    return scaledCoord;
  }, []);
  const applyScaling = React__default.useCallback((sources2, center22, scale5, azimuth) => {
    var _a3;
    const angleR = azimuth * Math.PI / 180;
    const lastUpdatedSources = {};
    (_a3 = Object.keys(sources2)) == null ? void 0 : _a3.forEach((sourceId) => {
      const data2 = sources2[sourceId].transformCoordinates((pt) => {
        const v5 = CoordinateUtil.toArray(CoordinateUtil.toMercator(pt));
        const unrotatedCoord = rotatePoint(v5, center22, -angleR);
        const unrotatedScaledCoord = scalePoint(unrotatedCoord, center22, scale5);
        const scaledCoord = rotatePoint(unrotatedScaledCoord, center22, angleR);
        const finalCoord = CoordinateUtil.toArray(CoordinateUtil.toLngLat(scaledCoord));
        return [finalCoord[0], finalCoord[1]];
      });
      setCoordinates2(sourceId, data2);
      lastUpdatedSources[sourceId] = data2;
    });
    return lastUpdatedSources;
  }, [rotatePoint, scalePoint, setCoordinates2]);
  const applyRotation = React__default.useCallback((sources2, angleR, initialCenter) => {
    var _a3;
    const cosAngleR = Math.cos(angleR);
    const sinAngleR = Math.sin(angleR);
    const lastUpdatedSources = {};
    (_a3 = Object.keys(sources2)) == null ? void 0 : _a3.forEach((sourceId) => {
      const data2 = sources2[sourceId].transformCoordinates((xyz) => {
        const initialCoord = CoordinateUtil.toArray(CoordinateUtil.toMercator(xyz));
        const localCoord = [initialCoord[0] - initialCenter[0], initialCoord[1] - initialCenter[1]];
        const localRotatedCoord = [localCoord[0] * cosAngleR - localCoord[1] * sinAngleR, localCoord[0] * sinAngleR + localCoord[1] * cosAngleR];
        const originalRotatedCoord = [localRotatedCoord[0] + initialCenter[0], localRotatedCoord[1] + initialCenter[1]];
        const finalCoord = CoordinateUtil.toArray(CoordinateUtil.toLngLat(originalRotatedCoord));
        return [finalCoord[0], finalCoord[1]];
      });
      setCoordinates2(sourceId, data2);
      lastUpdatedSources[sourceId] = data2;
    });
    return lastUpdatedSources;
  }, [setCoordinates2]);
  const getInitialData = React__default.useCallback(() => {
    const sources2 = getSources(sourceIds);
    if (!sources2)
      return null;
    const anchorSources = getAnchorSources(anchorLayerIds);
    if (!anchorSources)
      return null;
    const initialCenter = getCenter(anchorSources);
    if (!initialCenter)
      return null;
    const azimuth = getAzimuth(anchorSources);
    return {
      sources: sources2,
      anchorSources,
      initialCenter,
      azimuth
    };
  }, [anchorLayerIds, getAnchorSources, getAzimuth, getCenter, getSources, sourceIds]);
  return {
    hasValidSource,
    applyScaling,
    applyRotation,
    getInitialData,
    onDone
  };
}
function RotateForm(props) {
  const {
    value: formValues,
    onChange,
    readOnly
  } = props;
  const [form] = Form.useForm();
  React__default.useEffect(() => {
    if (formValues) {
      form.setFieldsValue(formValues);
    }
  }, [form, formValues]);
  const onFinish = React__default.useCallback((values4) => {
    if (values4) {
      onChange({
        ...values4
      });
    }
  }, [onChange]);
  return /* @__PURE__ */ jsxs(Card, { styles: {
    body: {
      padding: "8px",
      width: "120px"
    }
  }, children: [
    /* @__PURE__ */ jsx(Space, { direction: "vertical", style: {
      gap: "10px"
    }, children: /* @__PURE__ */ jsx(Typography.Text, { strong: true, style: {
      margin: 0,
      padding: 0
    }, children: "Rotate" }) }),
    /* @__PURE__ */ jsxs(Form, { form, layout: "vertical", initialValues: formValues, onFinish, children: [
      /* @__PURE__ */ jsx(Form.Item, { name: "angle", style: {
        marginBottom: "10px"
      }, children: /* @__PURE__ */ jsx(InputNumber$1, { formatter: (value) => `${value}°`, parser: (value) => value == null ? void 0 : value.replace("°", ""), style: {
        width: "100%",
        height: "32px",
        alignContent: "center"
      } }) }),
      /* @__PURE__ */ jsx(Form.Item, { style: {
        marginBottom: 0
      }, children: /* @__PURE__ */ jsx(Button, { style: {
        width: "100%"
      }, type: "primary", htmlType: "submit", disabled: readOnly, children: "Submit" }) })
    ] })
  ] });
}
RotateForm.propTypes = {
  value: propTypesExports$1.object,
  onChange: propTypesExports$1.func,
  readOnly: propTypesExports$1.bool
};
RotateForm.defaultProps = {
  value: {
    angle: 0
  },
  onChange: () => {
  },
  readOnly: false
};
var createRoot$1;
var m$1 = require$$0$2;
if (process.env.NODE_ENV === "production") {
  createRoot$1 = m$1.createRoot;
  m$1.hydrateRoot;
} else {
  var i$2 = m$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  createRoot$1 = function(c2, o2) {
    i$2.usingClientEntryPoint = true;
    try {
      return m$1.createRoot(c2, o2);
    } finally {
      i$2.usingClientEntryPoint = false;
    }
  };
}
function PopupHandler(props) {
  const {
    enabled,
    containerId,
    feature: getFeatureIn,
    position: positionIn,
    render: renderTooltip,
    config: config2,
    offset
  } = props;
  const containerRef = React__default.useRef(null);
  const reactRootRef = React__default.useRef(null);
  const {
    map: map5
  } = useMapbox();
  const getFeature = React__default.useCallback(() => {
    if (!getFeatureIn)
      return null;
    if (typeof getFeatureIn === "function")
      return getFeatureIn();
    return getFeatureIn;
  }, [getFeatureIn]);
  const getElement = React__default.useCallback(() => {
    let element = null;
    if (containerId) {
      element = document.getElementById(containerId);
    }
    if (!element) {
      element = map5 == null ? void 0 : map5.getContainer();
    }
    if (!element)
      return document.body;
    return element;
  }, [containerId, map5]);
  const getCoordinates12 = React__default.useCallback((array2) => {
    if (!array2)
      return null;
    if (!Array.isArray(array2))
      return null;
    if (Array.isArray(array2[0]))
      return getCoordinates12(array2[0]);
    return [array2[0], array2[1]];
  }, []);
  const hideTooltip = React__default.useCallback(() => {
    if (containerRef.current) {
      containerRef.current.style.display = "none";
    }
  }, []);
  const showTooltip = React__default.useCallback(() => {
    var _a3;
    if (!enabled)
      return;
    if (!containerRef.current) {
      containerRef.current = document.createElement("div");
      containerRef.current.style.display = "none";
      containerRef.current.style.position = "absolute";
      containerRef.current.style.backgroundColor = "transparent";
      getElement().appendChild(containerRef.current);
      reactRootRef.current = createRoot$1(containerRef.current);
    }
    let position = positionIn;
    let feature2;
    if (!position) {
      feature2 = getFeature();
      if (!feature2)
        return;
      position = getCoordinates12((_a3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a3.coordinates);
      if (!position)
        return;
    }
    const {
      x: x2,
      y: y2
    } = map5.project(position);
    if (containerRef.current) {
      containerRef.current.style.left = `${x2 + offset[0]}px`;
      containerRef.current.style.top = `${y2 + offset[1]}px`;
    }
    containerRef.current.style.display = "block";
    reactRootRef.current.render(/* @__PURE__ */ jsx(ConfigProvider, { ...config2 || {}, children: renderTooltip({
      feature: feature2,
      onDone: hideTooltip,
      map: map5,
      position
    }) }));
  }, [enabled, config2, getCoordinates12, getElement, getFeature, hideTooltip, map5, positionIn, renderTooltip, offset]);
  const showTooltipMut = useMutableFunc(showTooltip);
  const delayedRender = React__default.useCallback(() => {
    setTimeout(showTooltipMut, 100);
  }, [showTooltipMut]);
  const onUp = React__default.useCallback(() => {
    map5.off("mousemove", delayedRender);
    map5.off("mouseup", onUp);
  }, [delayedRender, map5]);
  const onDown = React__default.useCallback(() => {
    map5.on("mouseup", onUp);
    map5.on("mousemove", delayedRender);
  }, [delayedRender, map5, onUp]);
  React__default.useLayoutEffect(() => {
    if (!enabled) {
      hideTooltip();
    }
  }, [enabled, hideTooltip]);
  React__default.useLayoutEffect(() => {
    showTooltip();
  }, [getFeature, showTooltip]);
  React__default.useLayoutEffect(() => () => {
    if (containerRef.current) {
      try {
        hideTooltip();
        getElement().removeChild(containerRef.current);
      } catch (error2) {
        console.error(error2);
      }
      containerRef.current = null;
    }
  }, [getElement, hideTooltip]);
  React__default.useEffect(() => {
    if (!map5)
      return () => {
      };
    map5.on("move", showTooltipMut);
    map5.on("mousedown", onDown);
    return () => {
      map5.off("move", showTooltipMut);
      map5.off("mousedown", onDown);
    };
  }, [map5, onDown, showTooltipMut]);
  return null;
}
PopupHandler.propTypes = {
  enabled: propTypesExports$1.bool,
  containerId: propTypesExports$1.string,
  render: propTypesExports$1.func,
  config: propTypesExports$1.object,
  feature: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.func]),
  position: propTypesExports$1.arrayOf(propTypesExports$1.number),
  offset: propTypesExports$1.arrayOf(propTypesExports$1.number)
  // in pixels
};
PopupHandler.defaultProps = {
  enabled: false,
  containerId: "",
  render: () => {
  },
  config: {},
  feature: null,
  position: null,
  offset: [0, 0]
};
function PopupSourceHandler(props) {
  const {
    enabled,
    containerId,
    sourceId,
    render: renderTooltip,
    config: config2,
    offset
  } = props;
  const {
    map: map5
  } = useMapbox();
  const getFeature = React__default.useCallback(() => {
    const features = map5.querySourceFeatures(sourceId);
    const firstValidFeature = features.find((f2) => f2.geometry && f2.geometry.coordinates);
    return firstValidFeature;
  }, [map5, sourceId]);
  const feature2 = React__default.useMemo(() => getFeature(), [getFeature]);
  if (!feature2)
    return null;
  return /* @__PURE__ */ jsx(PopupHandler, { enabled, containerId, render: renderTooltip, config: config2, feature: getFeature, offset });
}
PopupSourceHandler.propTypes = {
  enabled: propTypesExports$1.bool,
  containerId: propTypesExports$1.string,
  sourceId: propTypesExports$1.string,
  render: propTypesExports$1.func,
  config: propTypesExports$1.object,
  offset: propTypesExports$1.arrayOf(propTypesExports$1.number)
  // in pixels
};
PopupSourceHandler.defaultProps = {
  enabled: false,
  containerId: "",
  sourceId: [],
  render: () => {
  },
  config: {},
  offset: [0, 0]
};
const OFFSET$1 = [10, 5];
function BoxRotateManual(props) {
  const {
    anchorLayerId: anchorLayerIds,
    containerId,
    rotateLayerId,
    config: config2,
    sourceId: sourceIdIn,
    active: activate,
    onChange,
    center: center2,
    isRotating
  } = props;
  const [isEnabled2, setIsEnabled] = React__default.useState(false);
  const {
    hasValidSource,
    applyRotation,
    getInitialData,
    onDone
  } = useScalingRotation({
    sourceId: sourceIdIn,
    anchorLayerId: anchorLayerIds,
    enabledRotate: !!activate,
    onChange,
    center: center2
  });
  const performRotation = React__default.useCallback((angleInDegree) => {
    const initial = getInitialData();
    if (!initial)
      return;
    const {
      sources: sources2,
      initialCenter,
      azimuth = 0
    } = initial;
    let lastUpdatedSources = sources2;
    const finalRotationInDegree = angleInDegree - azimuth;
    const angleInRad = finalRotationInDegree * Constants$u.DEG2RAD;
    lastUpdatedSources = applyRotation(sources2, angleInRad, initialCenter);
    onDone(lastUpdatedSources, {
      azimuth: angleInDegree
    });
  }, [applyRotation, getInitialData, onDone]);
  const onPopupSubmit = React__default.useCallback((options2) => {
    if (!options2)
      return;
    const {
      angle: angle4,
      closeForm
    } = options2;
    performRotation(angle4);
    closeForm == null ? void 0 : closeForm();
    setIsEnabled(false);
  }, [performRotation]);
  const renderPopup = React__default.useCallback((params2) => {
    var _a3, _b3;
    const {
      onDone: closeForm,
      feature: feature2
    } = params2 || {};
    if (((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.rotation) && !((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.rotationLine)) {
      const initial = getInitialData();
      if (!initial)
        return null;
      const {
        azimuth = 0
      } = initial;
      const initialValue = {
        angle: Math.round(azimuth * 100) / 100
      };
      const onChange2 = (values4) => {
        if (!values4)
          return;
        onPopupSubmit({
          ...values4,
          closeForm
        });
      };
      const readOnly = isRotating();
      return /* @__PURE__ */ jsx(RotateForm, { onChange: onChange2, value: initialValue, readOnly });
    }
    return null;
  }, [getInitialData, isRotating, onPopupSubmit]);
  React__default.useEffect(() => {
    if (!isEnabled2) {
      const handle = setInterval(() => {
        const rotating = isRotating();
        if (rotating)
          setIsEnabled(true);
      }, 100);
      return () => {
        if (handle)
          clearInterval(handle);
      };
    }
    return () => {
    };
  }, [isEnabled2, isRotating]);
  if (!hasValidSource)
    return null;
  return /* @__PURE__ */ jsx(PopupSourceHandler, { enabled: isEnabled2, containerId, sourceId: `${rotateLayerId}-point-source`, render: renderPopup, config: config2, offset: OFFSET$1 });
}
BoxRotateManual.propTypes = {
  containerId: propTypesExports$1.string,
  anchorLayerId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  config: propTypesExports$1.object,
  sourceId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  active: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  isRotating: propTypesExports$1.func,
  rotateLayerId: propTypesExports$1.string
};
BoxRotateManual.defaultProps = {
  containerId: "",
  anchorLayerId: [],
  config: {},
  sourceId: [],
  center: null,
  active: false,
  onChange: () => {
  },
  isRotating: () => false,
  rotateLayerId: ""
};
function BoxRotateControls(props) {
  const {
    sourceId: sourceIdIn,
    rotateLayerId,
    active: activate,
    onChange,
    onStart,
    center: center2,
    anchorLayerId: anchorLayerIds,
    containerId,
    config: config2
  } = props;
  const {
    map: map5
  } = useMapbox();
  const isRotatingRef = React__default.useRef(false);
  const {
    hasValidSource,
    applyRotation,
    getInitialData,
    onDone
  } = useScalingRotation({
    sourceId: sourceIdIn,
    anchorLayerId: anchorLayerIds,
    enabledRotate: !!activate,
    onChange,
    center: center2
  });
  const {
    onListener: getFeature
  } = useMapListener({
    layerIds: anchorLayerIds
  });
  const mouseDown = React__default.useCallback((downEvent) => {
    var _a3;
    const feature2 = getFeature(downEvent);
    if (!feature2)
      return;
    const rotatable = (_a3 = feature2.properties) == null ? void 0 : _a3.rotation;
    if (!rotatable)
      return;
    const initial = getInitialData();
    if (!initial)
      return;
    const {
      sources: sources2,
      initialCenter
    } = initial;
    if (!downEvent.lngLat)
      return;
    const initialMouseCoords = CoordinateUtil.toArray(CoordinateUtil.toMercator(downEvent.lngLat));
    const initialRadialVector = [initialMouseCoords[0] - initialCenter[0], initialMouseCoords[1] - initialCenter[1]];
    const initialRadius = Math.sqrt(initialRadialVector[0] * initialRadialVector[0] + initialRadialVector[1] * initialRadialVector[1]);
    if (!initialRadius)
      return;
    if (initialRadius <= 1 - 6)
      return;
    onStart({
      key: "rotate"
    });
    let lastUpdatedSources = sources2;
    function onMove(moveEvent) {
      if (!sources2)
        return;
      const coords = CoordinateUtil.toArray(CoordinateUtil.toMercator(moveEvent.lngLat));
      const radialVector = [coords[0] - initialCenter[0], coords[1] - initialCenter[1]];
      const radius = Math.sqrt(radialVector[0] * radialVector[0] + radialVector[1] * radialVector[1]);
      if (radius <= 1 - 6)
        return;
      let angleR = Math.acos((radialVector[0] * initialRadialVector[0] + radialVector[1] * initialRadialVector[1]) / radius / initialRadius);
      if (radialVector[0] * initialRadialVector[1] - radialVector[1] * initialRadialVector[0] > 0) {
        angleR *= -1;
      }
      lastUpdatedSources = applyRotation(sources2, angleR, initialCenter);
      isRotatingRef.current = true;
    }
    function onUp() {
      map5.off("mousemove", onMove);
      onDone(lastUpdatedSources);
      isRotatingRef.current = false;
    }
    downEvent.preventDefault();
    map5.on("mousemove", onMove);
    map5.once("mouseup", onUp);
  }, [applyRotation, getFeature, getInitialData, map5, onDone, onStart]);
  const isRotating = React__default.useCallback(() => isRotatingRef.current, []);
  React__default.useEffect(() => {
    if (!hasValidSource)
      return () => {
      };
    map5.on("mousedown", mouseDown);
    return () => {
      if (map5) {
        map5.off("mousedown", mouseDown);
      }
    };
  }, [hasValidSource, map5, mouseDown]);
  return /* @__PURE__ */ jsx(BoxRotateManual, { containerId, anchorLayerId: anchorLayerIds, rotateLayerId, config: config2, sourceId: sourceIdIn, active: true, center: center2, onChange, isRotating });
}
BoxRotateControls.propTypes = {
  sourceId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  anchorLayerId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  active: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  onStart: propTypesExports$1.func,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  containerId: propTypesExports$1.string,
  config: propTypesExports$1.object,
  rotateLayerId: propTypesExports$1.string
};
BoxRotateControls.defaultProps = {
  sourceId: [],
  anchorLayerId: "",
  active: false,
  onChange: () => {
  },
  onStart: () => {
  },
  center: null,
  containerId: "",
  config: {},
  rotateLayerId: ""
};
function BoxScaleControls(props) {
  const {
    sourceId: sourceIdIn,
    anchorLayerId: anchorLayerIds,
    scaleFactor,
    active: activate,
    onChange,
    onStart,
    mouseWheelIdle,
    center: center2,
    enableMouseWheel
  } = props;
  const startTime = React__default.useRef(0);
  const endTime = React__default.useRef(0);
  const resultRef = React__default.useRef(null);
  const {
    map: map5
  } = useMapbox();
  const {
    hasValidSource,
    applyScaling,
    getInitialData,
    onDone
  } = useScalingRotation({
    sourceId: sourceIdIn,
    anchorLayerId: anchorLayerIds,
    enabledScale: !!activate,
    onChange,
    center: center2
  });
  const mouseIdle = React__default.useCallback(() => {
    endTime.current = window.performance.now();
    if (startTime.current && endTime.current && endTime.current - startTime.current > mouseWheelIdle) {
      onDone(resultRef.current);
    }
  }, [mouseWheelIdle, onDone]);
  const mouseWheel = React__default.useCallback((e3) => {
    const initial = getInitialData();
    if (!initial)
      return;
    const {
      sources: sources2,
      initialCenter,
      azimuth
    } = initial;
    if (!sources2)
      return;
    onStart({
      key: "scale"
    });
    e3.preventDefault();
    const scale5 = e3.originalEvent.deltaY > 0 ? scaleFactor : 1 / scaleFactor;
    const lastUpdatedSources = applyScaling(sources2, initialCenter, [scale5, scale5], azimuth);
    resultRef.current = lastUpdatedSources;
    startTime.current = window.performance.now();
    setTimeout(mouseIdle, mouseWheelIdle);
  }, [getInitialData, onStart, scaleFactor, applyScaling, mouseIdle, mouseWheelIdle]);
  const {
    onListener: getFeature
  } = useMapListener({
    layerIds: anchorLayerIds
  });
  const mouseDown = React__default.useCallback((downEvent) => {
    var _a3;
    const feature2 = getFeature(downEvent);
    if (!feature2)
      return;
    if (!downEvent.lngLat)
      return;
    const scalingMode = (_a3 = feature2.properties) == null ? void 0 : _a3.scaling;
    if (!scalingMode)
      return;
    const initial = getInitialData();
    if (!initial)
      return;
    const {
      sources: sources2,
      initialCenter,
      azimuth
    } = initial;
    const initialMouseCoords = CoordinateUtil.toArray(CoordinateUtil.toMercator(downEvent.lngLat));
    const base = [initialMouseCoords[0] - initialCenter[0], initialMouseCoords[1] - initialCenter[1]];
    let lastUpdatedSources = sources2;
    onStart({
      key: "scale"
    });
    function onMove(moveEvent) {
      if (!sources2)
        return;
      const coords = CoordinateUtil.toArray(CoordinateUtil.toMercator(moveEvent.lngLat));
      const delta = [coords[0] - initialCenter[0], coords[1] - initialCenter[1]];
      const scale5 = [delta[0] / base[0], delta[1] / base[1]];
      if (scalingMode === "aspect") {
        const value = Math.min(scale5[0], scale5[1]);
        scale5[0] = value;
        scale5[1] = value;
      } else if (scalingMode === "lng") {
        scale5[1] = 1;
      } else if (scalingMode === "lat") {
        scale5[0] = 1;
      }
      lastUpdatedSources = applyScaling(sources2, initialCenter, scale5, azimuth);
    }
    function onUp() {
      map5.off("mousemove", onMove);
      onDone(lastUpdatedSources);
    }
    downEvent.preventDefault();
    map5.on("mousemove", onMove);
    map5.once("mouseup", onUp);
  }, [applyScaling, getFeature, getInitialData, map5, onDone, onStart]);
  React__default.useEffect(() => {
    if (!hasValidSource)
      return () => {
      };
    if (enableMouseWheel) {
      map5.on("wheel", mouseWheel);
      return () => {
        if (map5) {
          map5.off("wheel", mouseWheel);
        }
      };
    }
    map5.on("mousedown", mouseDown);
    return () => {
      if (map5) {
        map5.off("mousedown", mouseDown);
      }
    };
  }, [enableMouseWheel, hasValidSource, map5, mouseDown, mouseWheel]);
  return null;
}
BoxScaleControls.propTypes = {
  sourceId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  anchorLayerId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  scaleFactor: propTypesExports$1.number,
  active: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  onStart: propTypesExports$1.func,
  mouseWheelIdle: propTypesExports$1.number,
  enableMouseWheel: propTypesExports$1.bool
};
BoxScaleControls.defaultProps = {
  sourceId: [],
  anchorLayerId: "",
  center: null,
  scaleFactor: 1.2 / 10,
  active: false,
  onChange: () => {
  },
  onStart: () => {
  },
  mouseWheelIdle: 300,
  // milliseconds
  enableMouseWheel: false
};
function BoxLayer(props) {
  const {
    id,
    box: boxIn,
    onLoad,
    enablePointIcon,
    enableMidPoints,
    enableLines
  } = props;
  const {
    map: map5
  } = useMapbox();
  const enableLinesRef = useValueRef(enableLines);
  const rectangle = React__default.useMemo(() => GeoUtil.computeRectangle(boxIn), [boxIn]);
  const customIcon = React__default.useCallback(async () => {
    const size12 = 10;
    const url2 = IconUrls.boxPointAnchor;
    return IconUtil.createSvgSymbol({
      url: url2,
      size: size12
    });
  }, []);
  const data2 = React__default.useMemo(() => {
    if (!map5 || !id || !rectangle)
      return null;
    const [west, south, east, north] = rectangle;
    const box = [[west, north, "wn", "nwse-resize"], [east, north, "en", "nesw-resize"], [east, south, "es", "nwse-resize"], [west, south, "ws", "nesw-resize"]];
    const pointFeatures = box.map((coord) => ({
      id: `feature-point-${id}-${coord[2]}`,
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [coord[0], coord[1]]
      },
      properties: {
        color: "#0080FF",
        scaling: "aspect",
        orientation: coord[2],
        cursor: coord[3],
        isBoxPoint: true,
        visibility: "none"
        // keep it hidden initially
      }
    }));
    const lineFeatures = box.map((coord, index2) => {
      const nextCoord = box[(index2 + 1) % box.length];
      const EPSILON2 = 1e-6;
      let orientation2;
      let scaling;
      let cursor;
      if (Math.abs(coord[1] - nextCoord[1]) < EPSILON2) {
        cursor = "ns-resize";
        if (index2 === 0) {
          orientation2 = "we";
        } else if (index2 === 2) {
          orientation2 = "ew";
        }
        scaling = "lat";
      } else if (Math.abs(coord[0] - nextCoord[0]) < EPSILON2) {
        cursor = "ew-resize";
        if (index2 === 1) {
          orientation2 = "ns";
        } else if (index2 === 3) {
          orientation2 = "sn";
        }
        scaling = "lng";
      } else {
        console.error("Unhandled scenario");
        return null;
      }
      const midPoint3 = [(coord[0] + nextCoord[0]) / 2, (coord[1] + nextCoord[1]) / 2];
      pointFeatures.push({
        id: `feature-point-${id}-mid-${orientation2}`,
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: midPoint3
        },
        properties: {
          color: "#0080FF",
          scaling,
          orientation: orientation2,
          midPoint: true,
          cursor,
          visibility: "none"
          // keep it hidden initially
        }
      });
      return {
        id: `feature-line-${id}-${orientation2}`,
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: [[coord[0], coord[1]], [nextCoord[0], nextCoord[1]]]
        },
        properties: {
          color: "#0080FF",
          scaling,
          orientation: orientation2,
          visibility: enableLinesRef.current ? "visible" : "none"
          // keep the box visible, if asked for
        }
      };
    });
    return {
      id: `feature-collection-${id}`,
      type: "FeatureCollection",
      features: [...lineFeatures, ...pointFeatures]
    };
  }, [enableLinesRef, id, map5, rectangle]);
  const sourceId = `${id}-point-source`;
  const lineSourceId = `${id}-line-source`;
  const {
    getCoordinates: getCoordinates12,
    setCoordinates: setCoordinates2
  } = useSourceCoordinates([sourceId, lineSourceId]);
  React__default.useLayoutEffect(() => {
    if (!map5)
      return;
    const iterator7 = getCoordinates12(sourceId);
    if (!iterator7)
      return;
    const data22 = iterator7.filterFeatures((feature2) => {
      var _a3;
      let visibility = enablePointIcon;
      if (enablePointIcon) {
        if (!enableMidPoints)
          visibility = !((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.midPoint);
      }
      feature2.properties.visibility = visibility ? "visible" : "none";
      return true;
    });
    setCoordinates2(sourceId, data22);
  }, [enableMidPoints, enablePointIcon, getCoordinates12, id, map5, setCoordinates2, sourceId]);
  React__default.useLayoutEffect(() => {
    if (!map5)
      return;
    const iterator7 = getCoordinates12(lineSourceId);
    if (!iterator7)
      return;
    const data22 = iterator7.filterFeatures((feature2) => {
      feature2.properties.visibility = enableLines ? "visible" : "none";
      return true;
    });
    setCoordinates2(lineSourceId, data22);
  }, [enableLines, getCoordinates12, lineSourceId, map5, setCoordinates2]);
  const firstRef = React__default.useRef(false);
  React__default.useLayoutEffect(() => {
    if (data2) {
      if (!firstRef.current) {
        firstRef.current = true;
        setTimeout(onLoad, 300);
      } else {
        onLoad();
      }
    }
  }, [data2, onLoad]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsx(GeoJsonLayer, { id, data: data2, lineEnabled: true, outlineWidth: 2, pointEnabled: true, colorPropName: "color", outlinePropName: "color", customIcon, iconSize: 1, filter: ["==", ["get", "visibility"], "visible"] });
}
BoxLayer.propTypes = {
  id: propTypesExports$1.string,
  box: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  // 4 corners of rectangle
  onLoad: propTypesExports$1.func,
  enablePointIcon: propTypesExports$1.bool,
  enableMidPoints: propTypesExports$1.bool,
  enableLines: propTypesExports$1.bool
};
BoxLayer.defaultProps = {
  id: "",
  box: null,
  onLoad: () => {
  },
  enablePointIcon: false,
  enableMidPoints: false,
  enableLines: true
};
const {
  useToken: useToken$u
} = theme$2;
const MODES$2 = [{
  mode: "noedit",
  title: "Select",
  icon: Icons.ArrowCursor
}, {
  mode: "drag",
  title: "Drag",
  icon: Icons.AllDirection
}, {
  mode: "rotate",
  title: "Rotate",
  icon: Icons.PenDraw
}, {
  mode: "rotate-manual",
  title: "Rotate Manual",
  icon: Icons.PenDraw
}, {
  mode: "scale",
  title: "Scale",
  icon: Icons.MeasureDraw
}, {
  mode: "scale-manual",
  title: "Scale Manual",
  icon: Icons.MeasureDraw
}];
function BoxEditMenu(props) {
  const {
    placement,
    marginHorizontal,
    marginVertical,
    setEditType,
    editType,
    hidden,
    disabled,
    options: options2
  } = props;
  const {
    token
  } = useToken$u();
  const {
    iconStyle,
    selectedStyle,
    toolButtonStyle
  } = React__default.useMemo(() => {
    const toolItemCommon = {
      backgroundColor: token.colorBgContainer,
      width: "32px",
      height: "32px",
      borderRadius: "6px",
      border: `1px solid ${token.colorBorderSecondary}`
    };
    const selectedStyle2 = {
      ...toolItemCommon,
      textOverflow: "clip",
      backgroundColor: token.colorPrimary,
      border: `1px solid ${token.colorPrimary}`
    };
    const toolButtonStyle2 = {
      ...toolItemCommon,
      textOverflow: "clip"
    };
    const iconStyle2 = {
      fontSize: "16px",
      color: token == null ? void 0 : token.colorText,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%"
    };
    return {
      iconStyle: iconStyle2,
      toolButtonStyle: toolButtonStyle2,
      selectedStyle: selectedStyle2
    };
  }, [token == null ? void 0 : token.colorBgContainer, token == null ? void 0 : token.colorBorderSecondary, token == null ? void 0 : token.colorPrimary, token == null ? void 0 : token.colorText]);
  const menuItems = React__default.useMemo(() => options2 == null ? void 0 : options2.map((item) => {
    if (hidden[item.mode]) {
      return null;
    }
    return {
      key: item.mode,
      icon: /* @__PURE__ */ jsx(Tooltip$1, { placement: "left", trigger: "hover", title: item.title, arrow: false, align: {
        offset: [-18, 0]
      }, children: /* @__PURE__ */ jsx(item.icon, { style: {
        ...iconStyle
      } }) }),
      style: editType === item.mode ? {
        ...selectedStyle
      } : {
        ...toolButtonStyle
      },
      disabled: disabled[item.mode]
    };
  }), [disabled, editType, hidden, iconStyle, options2, selectedStyle, toolButtonStyle]);
  return /* @__PURE__ */ jsx(OverlayPanel, { placement, width: 50, height: "243px", marginHorizontal, marginVertical, children: /* @__PURE__ */ jsx(Menu, { onClick: (e3) => {
    if (editType === e3.key) {
      setEditType("");
    } else {
      setEditType(e3.key);
    }
  }, selectedKeys: [editType], mode: "vertical", style: {
    width: "48px",
    backgroundColor: "transparent"
  }, items: menuItems }) });
}
BoxEditMenu.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  setEditType: propTypesExports$1.func,
  editType: propTypesExports$1.string,
  hidden: propTypesExports$1.object,
  disabled: propTypesExports$1.object,
  options: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    mode: propTypesExports$1.string,
    title: propTypesExports$1.string,
    icon: propTypesExports$1.any
  }))
};
BoxEditMenu.defaultProps = {
  editType: "noselect",
  placement: "top-right",
  marginHorizontal: 0,
  marginVertical: 0,
  setEditType: () => {
  },
  hidden: {},
  disabled: {},
  options: MODES$2
};
function BoxRotateIcon(props) {
  const {
    id,
    box: boxIn,
    onLoad,
    enable: enable4
  } = props;
  const {
    map: map5
  } = useMapbox();
  const [data2, setData6] = React__default.useState(null);
  const rectangle = React__default.useMemo(() => GeoUtil.computeRectangle(boxIn), [boxIn]);
  const customIcon = React__default.useCallback(async () => {
    const size12 = 30;
    const url2 = IconUrls.boxRotateAnchor;
    return IconUtil.createSvgSymbol({
      url: url2,
      size: size12
    });
  }, []);
  React__default.useLayoutEffect(() => {
    if (!map5 || !id || !rectangle)
      return;
    const [west, south, east, north] = rectangle;
    const ws = (west + east) / 2;
    const length2 = 0.1;
    const ns = (north - south) * length2;
    const boxCenter = [(west + east) / 2, (north + south) / 2];
    const lineFeature = {
      id: `feature-rotation-line-${id}`,
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: [[ws, north + ns / 2], [ws, north]]
      },
      properties: {
        color: "#0080FF",
        rotationLine: true,
        rotation: true,
        cursor: "pointer",
        visibility: "none",
        // keep it hidden initially
        "line-thickness": 4
      }
    };
    const symbolFeature = {
      id: `feature-rotation-symbol-${id}`,
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: [[ws, north + ns], [ws, north]]
      },
      properties: {
        color: "#0080FF",
        "stroke-opacity": 0,
        rotation: true,
        visibility: "none"
        // keep it hidden initially
      }
    };
    const options2 = {
      colorPropNam: "color",
      iconIdPropName: "marker-symbol-id",
      iconUrlPropName: "marker-symbol",
      textValuePropName: "text-value",
      prefix: id,
      getCustomIcon: customIcon
    };
    IconUtil.loadSymbolsOnMap(map5, [symbolFeature], options2).then((geojson) => {
      geojson.features.push(lineFeature);
      setData6(geojson);
      onLoad(boxCenter);
    });
  }, [customIcon, id, map5, onLoad, rectangle]);
  const layerIds = React__default.useMemo(() => [`${id}-line`, `${id}-point`], [id]);
  const sourceIds = React__default.useMemo(() => [`${id}-line-source`, `${id}-point-source`], [id]);
  const {
    getCoordinates: getCoordinates12,
    setCoordinates: setCoordinates2,
    hasValidSource
  } = useSourceCoordinates(sourceIds);
  React__default.useLayoutEffect(() => {
    if (!map5 || !hasValidSource)
      return;
    sourceIds == null ? void 0 : sourceIds.forEach((sourceId) => {
      const iterator7 = getCoordinates12(sourceId);
      if (!iterator7)
        return;
      const data22 = iterator7.filterFeatures((feature2) => {
        feature2.properties.visibility = enable4 ? "visible" : "none";
        return true;
      });
      setCoordinates2(sourceId, data22);
    });
  }, [enable4, getCoordinates12, hasValidSource, id, layerIds, map5, setCoordinates2, sourceIds]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsx(
    GeoJsonLayer,
    {
      id,
      data: data2,
      pointEnabled: true,
      lineEnabled: true,
      outlineWidth: 2,
      colorPropName: "color",
      outlinePropName: "color",
      customIcon,
      paintProps: {
        "icon-rotation-alignment": "map"
      },
      layoutProps: {
        "icon-rotate": -90,
        "icon-size": 1,
        "icon-image": ["get", "marker-symbol-id"],
        "icon-keep-upright": false,
        "symbol-placement": "line-center"
      },
      filter: ["==", ["get", "visibility"], "visible"],
      outlineWidthPropName: "line-thickness"
    }
  );
}
BoxRotateIcon.propTypes = {
  id: propTypesExports$1.string,
  box: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  // 4 corners of rectangle
  onLoad: propTypesExports$1.func,
  enable: propTypesExports$1.bool
};
BoxRotateIcon.defaultProps = {
  id: "",
  box: null,
  onLoad: () => {
  },
  enable: false
};
const {
  Option: Option$5
} = Select$1;
const unitOptions = [{
  key: "m",
  label: "Meters",
  value: "m"
}, {
  key: "in",
  label: "Inches",
  value: "in"
}];
function ScaleForm(props) {
  const {
    value: formValues,
    onChange,
    onValuesChange
  } = props;
  const [form] = Form.useForm();
  React__default.useEffect(() => {
    if (formValues) {
      form.setFieldsValue(formValues);
    }
  }, [form, formValues]);
  const onFinish = React__default.useCallback((values4) => {
    if (values4) {
      onChange({
        ...values4
      });
    }
  }, [onChange]);
  return /* @__PURE__ */ jsxs(Card, { style: {
    width: 232,
    borderRadius: 8
  }, styles: {
    body: {
      padding: "10px"
    }
  }, children: [
    /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
      gap: 0,
      marginBottom: "10px"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { strong: true, style: {
        fontSize: "14px"
      }, children: "Scale" }),
      /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: "Indicate length and units to rescale" })
    ] }),
    /* @__PURE__ */ jsxs(Form, { form, layout: "vertical", initialValues: formValues, onFinish, onValuesChange, children: [
      /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        gap: 8
      }, children: [
        /* @__PURE__ */ jsx(Form.Item, { name: "length", label: "Length", style: {
          flex: 1
        }, children: /* @__PURE__ */ jsx(InputNumber$1, { style: {
          width: "100%"
        }, min: 0 }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "unit", label: "Unit", style: {
          flex: 1
        }, children: /* @__PURE__ */ jsx(Select$1, { children: unitOptions.map(({
          key,
          label,
          value
        }) => /* @__PURE__ */ jsx(Option$5, { value, children: label }, key)) }) })
      ] }),
      /* @__PURE__ */ jsx(Form.Item, { style: {
        marginBottom: 0
      }, children: /* @__PURE__ */ jsx(Button, { type: "primary", size: "large", style: {
        width: "100%",
        margin: 0,
        padding: 0
      }, htmlType: "submit", children: "Submit" }) })
    ] })
  ] });
}
ScaleForm.propTypes = {
  value: propTypesExports$1.object,
  onChange: propTypesExports$1.func,
  onValuesChange: propTypesExports$1.func
};
ScaleForm.defaultProps = {
  value: {
    length: 0,
    unit: "m"
    // ['m', 'ft']
  },
  onChange: () => {
  },
  onValuesChange: () => {
  }
};
const REFERENCE_LINE_ID = "reference-line-manual-scaling";
function BoxScaleManual(props) {
  var _a3, _b3;
  const {
    anchorLayerId: anchorLayerIdsIn,
    containerId,
    config: config2,
    sourceId: sourceIdIn,
    active: activate,
    onChange,
    onStart,
    center: center2
  } = props;
  const userInputRef = React__default.useRef({});
  const anchorLayerIds = React__default.useMemo(() => {
    const anchors = [];
    const extra = `${REFERENCE_LINE_ID}-line`;
    if (Array.isArray(anchorLayerIdsIn)) {
      anchors.push(...anchorLayerIdsIn, extra);
    } else {
      if (anchorLayerIdsIn) {
        anchors.push(anchorLayerIdsIn);
      }
      anchors.push(extra);
    }
    return anchors;
  }, [anchorLayerIdsIn]);
  const {
    hasValidSource,
    applyScaling,
    getInitialData,
    onDone
  } = useScalingRotation({
    sourceId: [...sourceIdIn, `${REFERENCE_LINE_ID}-line-source`],
    anchorLayerId: anchorLayerIds,
    enabledScale: !!activate,
    onChange,
    center: center2
  });
  const [referenceLine, setReferenceLine] = React__default.useState(null);
  const performScaling = React__default.useCallback((scaleIn) => {
    const initial = getInitialData();
    if (!initial)
      return;
    const {
      sources: sources2,
      initialCenter,
      azimuth
    } = initial;
    let lastUpdatedSources = sources2;
    const scale5 = [scaleIn, scaleIn];
    lastUpdatedSources = applyScaling(sources2, initialCenter, scale5, azimuth);
    onDone(lastUpdatedSources);
  }, [applyScaling, getInitialData, onDone]);
  const getUnitConversionFactor = React__default.useCallback((unit) => {
    let factor = 1;
    switch (unit) {
      case "m":
      case "Metres":
        factor = 1;
        break;
      case "in":
      case "Inches":
        factor = 0.0254;
        break;
      default:
        factor = 1;
    }
    return factor;
  }, []);
  const onPopupSubmit = React__default.useCallback((options2) => {
    if (!options2)
      return;
    const {
      length: length2,
      unit,
      unscaledLength,
      closeForm
    } = options2;
    if (!unscaledLength)
      return;
    const proposedLengthInM = length2 * getUnitConversionFactor(unit);
    if (!proposedLengthInM)
      return;
    const scale5 = proposedLengthInM / unscaledLength;
    performScaling(scale5);
    closeForm == null ? void 0 : closeForm();
    setReferenceLine(null);
  }, [getUnitConversionFactor, performScaling]);
  const renderPopup = React__default.useCallback((input) => {
    var _a4;
    const {
      onDone: onDoneIn
    } = input || {};
    const closeForm = () => {
      userInputRef.current = {};
      onDoneIn();
    };
    if (((_a4 = referenceLine == null ? void 0 : referenceLine.geometry) == null ? void 0 : _a4.type) !== "LineString")
      return null;
    let length2 = 0;
    try {
      const featureLength = GeoUtil.distance(referenceLine.geometry.coordinates[0], referenceLine.geometry.coordinates[1]);
      length2 = Math.round(featureLength * 100) / 100;
    } catch (err) {
      console.error(err);
    }
    const initialValue = {
      length: length2,
      unit: "m"
    };
    const onChange2 = (values4) => {
      if (!values4)
        return;
      onPopupSubmit({
        ...values4,
        unscaledLength: initialValue.length,
        closeForm
      });
    };
    const value = {
      ...initialValue,
      ...userInputRef.current || {}
    };
    const onValuesChange = (values4) => {
      userInputRef.current = values4 || {};
    };
    return /* @__PURE__ */ jsx(ScaleForm, { onChange: onChange2, value, onValuesChange });
  }, [onPopupSubmit, referenceLine]);
  React__default.useEffect(() => {
    if (activate && hasValidSource) {
      onStart({
        key: "scale"
      });
    }
  }, [activate, hasValidSource, onStart]);
  const lastPoint = (_b3 = (_a3 = referenceLine == null ? void 0 : referenceLine.geometry) == null ? void 0 : _a3.coordinates) == null ? void 0 : _b3[1];
  if (!hasValidSource)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    referenceLine && lastPoint && /* @__PURE__ */ jsx(PopupHandler, { enabled: true, containerId, render: renderPopup, config: config2, position: lastPoint }),
    referenceLine && /* @__PURE__ */ jsx(GeoJsonLayer, { id: REFERENCE_LINE_ID, data: referenceLine, lineEnabled: true }),
    !referenceLine && /* @__PURE__ */ jsx(DrawControls, { mode: "line", onChange: setReferenceLine, enableConstraint: true, enableSnap: true, enableButtons: [] }, "draw-control-manual-scale-line")
  ] });
}
BoxScaleManual.propTypes = {
  containerId: propTypesExports$1.string,
  anchorLayerId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  config: propTypesExports$1.object,
  sourceId: propTypesExports$1.oneOfType([propTypesExports$1.arrayOf(propTypesExports$1.string), propTypesExports$1.string]),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  active: propTypesExports$1.bool,
  onStart: propTypesExports$1.func,
  onChange: propTypesExports$1.func
};
BoxScaleManual.defaultProps = {
  containerId: "",
  anchorLayerId: [],
  config: {},
  sourceId: [],
  center: null,
  active: false,
  onStart: () => {
  },
  onChange: () => {
  }
};
const MENU_ITEMS$1 = [{
  mode: "rotate-scale",
  title: "Edit",
  icon: Icons.ArrowCursor
}, {
  mode: "drag",
  title: "Drag",
  icon: Icons.AllDirection
}, {
  mode: "scale-manual",
  title: "Scale",
  icon: Icons.MeasureDraw
}];
function BoxEditableLayer(props) {
  const {
    id,
    editableSourceId: editableSourceIdIn,
    box,
    editType: editTypeIn,
    onEditTypeChange: onEditTypeChangeIn,
    onStart,
    onChange,
    menuProps,
    containerId,
    config: config2,
    enableMenu,
    enableBox,
    options: options2,
    ...restProps
  } = props;
  const [boxCenter, setBoxCenter] = React__default.useState(null);
  const [activeControl, setActiveControl] = React__default.useState(editTypeIn);
  const [isLoaded, setIsLoaded] = React__default.useState(false);
  const rotateLayerId = `${id}-rotate`;
  const editableSourceId = React__default.useMemo(() => {
    if (!editableSourceIdIn)
      return [];
    if (Array.isArray(editableSourceIdIn))
      return editableSourceIdIn;
    return [editableSourceIdIn];
  }, [editableSourceIdIn]);
  React__default.useLayoutEffect(() => {
    setActiveControl(editTypeIn);
  }, [editTypeIn]);
  const onEditTypeChange = React__default.useCallback((editType) => {
    setActiveControl(editType);
    onEditTypeChangeIn(editType);
  }, [onEditTypeChangeIn]);
  const onEditDone = React__default.useCallback((output2) => {
    if (!output2)
      return;
    const {
      sources: sources2,
      azimuth
    } = output2;
    const sourceIds2 = Object.keys(sources2);
    const editableSources = {};
    const box2 = [];
    sourceIds2.forEach((key) => {
      if (editableSourceId.includes(key)) {
        editableSources[key] = sources2[key];
      } else if (key === `${id}-point-source`) {
        const pointFeatures = sources2[key];
        pointFeatures.forEach((feature2) => {
          var _a3, _b3;
          const coordinates2 = (_a3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a3.coordinates;
          if ((coordinates2 == null ? void 0 : coordinates2.length) && ((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.isBoxPoint)) {
            box2.push([...coordinates2]);
          }
        });
      }
    });
    const result = {
      sources: editableSources
    };
    if (box2.length === 4) {
      const center2 = box2.reduce((result2, val, ind, arr) => [result2[0] + val[0] / arr.length, result2[1] + val[1] / arr.length], [0, 0]);
      setBoxCenter(center2);
      result.box = box2;
    }
    if (typeof azimuth === "number") {
      result.azimuth = azimuth;
    }
    onChange(result);
  }, [editableSourceId, id, onChange]);
  const {
    enableDrag,
    enableScale,
    enableRotate,
    enableScaleManual
  } = React__default.useMemo(() => {
    const enableDrag2 = activeControl === "drag";
    const enableScale2 = activeControl === "rotate-scale";
    const enableRotate2 = activeControl === "rotate-scale";
    const enableScaleManual2 = activeControl === "scale-manual";
    return {
      enableDrag: enableDrag2,
      enableScale: enableScale2,
      enableRotate: enableRotate2,
      enableScaleManual: enableScaleManual2
    };
  }, [activeControl]);
  const anchors = React__default.useMemo(() => {
    if (!id)
      return [];
    return [`${id}-point`, `${id}-line`, `${rotateLayerId}-point`, `${rotateLayerId}-line`];
  }, [id, rotateLayerId]);
  const dragAnchors = React__default.useMemo(() => {
    if (!(editableSourceId == null ? void 0 : editableSourceId.length))
      return anchors;
    const result = [...anchors];
    editableSourceId.forEach((sourceId) => {
      const anchor = sourceId.replace("-source", "");
      if (!result.includes(anchor))
        result.push(anchor);
    });
    return result;
  }, [anchors, editableSourceId]);
  const sourceIds = React__default.useMemo(() => {
    const sourceIds2 = anchors.map((id2) => `${id2}-source`);
    if (editableSourceId == null ? void 0 : editableSourceId.length)
      sourceIds2.push(...editableSourceId);
    return sourceIds2;
  }, [anchors, editableSourceId]);
  const getCursor2 = React__default.useCallback((selection) => {
    var _a3, _b3, _c2;
    const {
      feature: feature2
    } = selection || {};
    if (!feature2)
      return null;
    if (enableDrag && dragAnchors.includes((_a3 = feature2 == null ? void 0 : feature2.layer) == null ? void 0 : _a3.id)) {
      return "move";
    }
    if (anchors.includes((_b3 = feature2 == null ? void 0 : feature2.layer) == null ? void 0 : _b3.id)) {
      return (_c2 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _c2.cursor;
    }
    return null;
  }, [anchors, dragAnchors, enableDrag]);
  useCursor({
    getCursor: getCursor2,
    enable: !!activeControl
  });
  if (!box)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(BoxLayer, { id, box, onLoad: () => setIsLoaded(true), enablePointIcon: enableScale, enableMidPoints: enableScale, enableLines: enableDrag || enableScale || enableScaleManual || enableRotate || enableBox }),
    /* @__PURE__ */ jsx(BoxRotateIcon, { id: rotateLayerId, box, onLoad: setBoxCenter, enable: enableRotate }),
    isLoaded && enableDrag && /* @__PURE__ */ jsx(BoxDragControls, { sourceId: sourceIds, active: true, onStart, onChange: onEditDone, anchorLayerId: dragAnchors, ...restProps }),
    isLoaded && enableScale && /* @__PURE__ */ jsx(BoxScaleControls, { sourceId: sourceIds, active: true, onStart, onChange: onEditDone, anchorLayerId: anchors, center: boxCenter, ...restProps }),
    isLoaded && enableRotate && /* @__PURE__ */ jsx(BoxRotateControls, { sourceId: sourceIds, rotateLayerId, active: true, onStart, onChange: onEditDone, anchorLayerId: anchors, center: boxCenter, containerId, config: config2, ...restProps }),
    isLoaded && enableScaleManual && /* @__PURE__ */ jsx(BoxScaleManual, { containerId, config: config2, sourceId: sourceIds, active: enableScaleManual, onStart, onChange: onEditDone, center: boxCenter }),
    enableMenu && /* @__PURE__ */ jsx(BoxEditMenu, { placement: "top-right", marginVertical: 32, marginHorizontal: 0, options: options2, ...menuProps, setEditType: onEditTypeChange, editType: activeControl })
  ] });
}
BoxEditableLayer.propTypes = {
  id: propTypesExports$1.string,
  editableSourceId: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.arrayOf(propTypesExports$1.string)]),
  box: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  enableMenu: propTypesExports$1.bool,
  // whether to display menu or not
  enableBox: propTypesExports$1.bool,
  // whether to display box or not
  editType: propTypesExports$1.string,
  onEditTypeChange: propTypesExports$1.func,
  onStart: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  menuProps: propTypesExports$1.object,
  containerId: propTypesExports$1.string,
  config: propTypesExports$1.object,
  options: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    mode: propTypesExports$1.string,
    title: propTypesExports$1.string,
    icon: propTypesExports$1.any
  }))
};
BoxEditableLayer.defaultProps = {
  id: "",
  box: null,
  enableMenu: true,
  enableBox: false,
  editableSourceId: [],
  editType: "",
  onEditTypeChange: () => {
  },
  onStart: () => {
  },
  onChange: () => {
  },
  // i.e. onDone
  menuProps: {},
  containerId: "",
  config: {},
  options: MENU_ITEMS$1
};
function OpacitySlider(props) {
  const {
    value: opacityIn,
    onChange: setOpacity
  } = props;
  const opacity = opacityIn * 100;
  const onChange = React__default.useCallback((value) => {
    setOpacity(value / 100);
  }, [setOpacity]);
  return /* @__PURE__ */ jsx(Card, { style: {
    transform: "translateX(-50%)"
  }, styles: {
    body: {
      padding: "5px"
    }
  }, children: /* @__PURE__ */ jsxs(Space, { style: {
    gap: "5px"
  }, children: [
    /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: "Opacity" }),
    /* @__PURE__ */ jsx(Slider$1, { min: 0, max: 100, value: opacity, onChange, style: {
      width: 100,
      margin: 0,
      height: 0
    }, styles: {
      rail: {
        backgroundColor: "white",
        height: 1
      },
      track: {
        backgroundColor: "white",
        height: 1
      },
      handle: {
        height: 7,
        width: 7,
        insetBlockStart: 0
      }
    } }),
    /* @__PURE__ */ jsxs(Typography.Text, { type: "secondary", children: [
      /* @__PURE__ */ jsx(Divider, { type: "vertical", style: {
        display: "inline"
      } }),
      Math.floor(opacity),
      "%"
    ] })
  ] }) });
}
OpacitySlider.propTypes = {
  value: propTypesExports$1.number,
  // 0 - 1.0
  onChange: propTypesExports$1.func
};
OpacitySlider.defaultProps = {
  value: 1,
  onChange: () => {
  }
};
function PopupBoxHandler(props) {
  const {
    box,
    placement,
    ...restProps
  } = props;
  const position = React__default.useMemo(() => {
    if (box && box.length > 0) {
      let left = box[0][0];
      let right = box[0][0];
      let top = box[0][1];
      let bottom = box[0][1];
      box.forEach(([x2, y2]) => {
        if (x2 < left)
          left = x2;
        if (x2 > right)
          right = x2;
        if (y2 > top)
          top = y2;
        if (y2 < bottom)
          bottom = y2;
      });
      let position2 = box[0][0];
      switch (placement) {
        case "top":
          position2 = [(left + right) * 0.5, top];
          break;
        case "bottom":
          position2 = [(left + right) * 0.5, bottom];
          break;
        case "left":
          position2 = [left, (top + bottom) * 0.5];
          break;
        case "right":
          position2 = [right, (top + bottom) * 0.5];
          break;
        case "center":
          position2 = [(left + right) * 0.5, (top + bottom) * 0.5];
          break;
        case "top-left":
          position2 = [left, top];
          break;
        case "top-right":
          position2 = [right, top];
          break;
        case "bottom-left":
          position2 = [left, bottom];
          break;
        case "bottom-right":
          position2 = [right, bottom];
          break;
        default:
          position2 = [(left + right) * 0.5, bottom];
          break;
      }
      return position2;
    }
    return null;
  }, [box, placement]);
  if (!position)
    return null;
  return /* @__PURE__ */ jsx(PopupHandler, { ...restProps, position });
}
PopupBoxHandler.propTypes = {
  box: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  placement: propTypesExports$1.oneOf(["top", "bottom", "left", "right", "center", "top-left", "top-right", "bottom-left", "bottom-right"])
};
PopupBoxHandler.defaultProps = {
  box: null,
  placement: "bottom"
};
function BoxOpacityControls(props) {
  const {
    containerId,
    sourceId,
    value: opacity,
    onChange: setOpacity,
    map: map5,
    enablePopup,
    ...restProps
  } = props;
  const renderPopup = React__default.useCallback(() => /* @__PURE__ */ jsx(OpacitySlider, { sourceId, value: opacity, onChange: (opacity2) => setOpacity(opacity2), map: map5 }), [sourceId, opacity, map5, setOpacity]);
  return /* @__PURE__ */ jsx(PopupBoxHandler, { id: "opacity-control-popup", enabled: enablePopup, containerId, render: renderPopup, placement: "bottom", ...restProps });
}
BoxOpacityControls.propTypes = {
  sourceId: propTypesExports$1.string,
  containerId: propTypesExports$1.string,
  value: propTypesExports$1.number,
  // 0 - 1.0
  onChange: propTypesExports$1.func,
  map: propTypesExports$1.object,
  enablePopup: propTypesExports$1.bool
};
BoxOpacityControls.defaultProps = {
  sourceId: "",
  containerId: "",
  value: 1,
  onChange: () => {
  },
  map: null,
  enablePopup: false
};
var V$1 = Object.defineProperty;
var I = (i2, o2, t2) => o2 in i2 ? V$1(i2, o2, {
  enumerable: true,
  configurable: true,
  writable: true,
  value: t2
}) : i2[o2] = t2;
var a$1 = (i2, o2, t2) => I(i2, typeof o2 != "symbol" ? o2 + "" : o2, t2);
const B = (i2) => Object.keys(i2).filter((o2) => i2[o2]).join(" "), f = (i2, o2) => i2.x === o2.x && i2.y === o2.y, m = (i2, o2) => !i2 && o2 || i2 && !o2 || i2.length !== o2.length ? false : i2.every((t2, e3) => f(t2, o2[e3])), u = ({
  x: i2,
  y: o2
}, t2 = 1) => ({
  x: Math.round((i2 + Number.EPSILON) * t2) / t2,
  y: Math.round((o2 + Number.EPSILON) * t2) / t2
}), k$1 = (i2, o2, t2 = 0) => {
  const e3 = i2.findIndex((s2) => Math.max(Math.abs(s2.x - o2.x), Math.abs(s2.y - o2.y)) <= t2);
  return {
    point: {
      ...i2[e3] || {
        x: NaN,
        y: NaN
      }
    },
    index: e3
  };
}, S = (i2, o2) => Math.hypot(o2.x - i2.x, o2.y - i2.y), D$1 = (i2, o2) => Math.atan2(o2.y - i2.y, o2.x - i2.x), N = (i2, o2, t2) => {
  const e3 = S(i2, o2), s2 = D$1(i2, o2), n2 = Math.round(s2 / t2) * t2;
  return {
    x: i2.x + e3 * Math.cos(n2),
    y: i2.y + e3 * Math.sin(n2)
  };
}, F = (i2, o2, t2) => {
  const e3 = S(i2, o2), s2 = D$1(i2, o2), n2 = t2.reduce((r2, h2) => Math.abs(h2 - s2) < Math.abs(r2 - s2) ? h2 : r2, 1 / 0);
  return n2 !== 1 / 0 && (o2.x = i2.x + e3 * Math.cos(n2), o2.y = i2.y + e3 * Math.sin(n2)), o2;
}, G = (i2) => {
  const o2 = [];
  for (let t2 = 1; t2 < i2.length; t2++) {
    const e3 = Math.atan2(i2[t2].y - i2[t2 - 1].y, i2[t2].x - i2[t2 - 1].x), s2 = e3 + Math.PI;
    o2.push(e3, s2 > Math.PI ? s2 - 2 * Math.PI : s2);
  }
  return o2.filter((t2, e3, s2) => s2.indexOf(t2) === e3);
};
function X$1(i2, o2, t2, e3 = true) {
  const s2 = new Image();
  s2.crossOrigin = "Anonymous";
  const n2 = document.createElement("canvas"), r2 = n2.getContext("2d");
  if (!r2)
    return t2(new Error("CTX is null"), n2);
  s2.onerror = () => {
    t2(new Error("Failed to load image"), n2);
  }, s2.onload = () => {
    try {
      if (n2.width = s2.naturalWidth + 2, n2.height = s2.naturalHeight + 2, r2.drawImage(s2, 0, 0), o2.length < 3) {
        t2(null, n2);
        return;
      }
      if (r2.beginPath(), r2.moveTo(0, 0), r2.lineTo(n2.width, 0), r2.lineTo(n2.width, n2.height), r2.lineTo(0, n2.height), r2.lineTo(0, 0), r2.lineTo(o2[0].x + 1, o2[0].y + 1), o2.slice(1).forEach(({
        x: h2,
        y: c2
      }) => r2.lineTo(h2 + 1, c2 + 1)), r2.lineTo(o2[0].x + 1, o2[0].y + 1), r2.lineTo(0, 0), r2.closePath(), r2.clip("evenodd"), r2.globalCompositeOperation = "destination-out", r2.fill(), e3) {
        const h2 = o2.map(({
          x: v5
        }) => v5 + 1), c2 = o2.map(({
          y: v5
        }) => v5 + 1), [d2, P2] = [Math.min.apply(null, h2), Math.min.apply(null, c2)], [R2, O2] = [Math.max.apply(null, h2), Math.max.apply(null, c2)], [x2, M2] = [R2 - d2, O2 - P2], A2 = r2.getImageData(d2, P2, x2, M2);
        n2.width = x2, n2.height = M2, r2.putImageData(A2, 0, 0);
      }
      t2(null, n2);
    } catch (h2) {
      t2(h2 instanceof Error ? h2 : new Error(String(h2)), n2);
    }
  }, s2.src = i2;
}
class C {
  constructor(o2) {
    a$1(this, "getSvgElement");
    this.getSvgElement = o2;
  }
  getSvg() {
    const o2 = this.getSvgElement();
    if (!o2)
      throw new Error("SVG is null");
    return o2;
  }
  getCTM() {
    const o2 = this.getSvg();
    let t2 = o2.getCTM();
    if (t2 === null && (t2 = o2.querySelector('rect[visibility="hidden"]').getCTM()), !t2)
      throw new Error("CTM is null");
    return t2;
  }
  getViewboxSize() {
    return this.getSvg().viewBox.baseVal;
  }
  getRealSize() {
    const o2 = this.getSvg();
    return {
      width: o2.clientWidth,
      height: o2.clientHeight
    };
  }
  getViewboxOffset() {
    const o2 = this.getSvg(), {
      width: t2,
      height: e3
    } = this.getRealSize(), {
      width: s2,
      height: n2
    } = this.getViewboxSize(), r2 = Object.assign(o2.createSVGPoint(), {
      x: t2,
      y: e3
    }), h2 = this.getCTM(), {
      x: c2,
      y: d2
    } = r2.matrixTransform(h2.inverse());
    return {
      x: c2 - s2,
      y: d2 - n2
    };
  }
  convertViewboxPointsToReal(o2) {
    const t2 = this.getSvg(), e3 = this.getCTM();
    return o2.map(({
      x: s2,
      y: n2
    }) => {
      const r2 = Object.assign(t2.createSVGPoint(), {
        x: s2,
        y: n2
      }).matrixTransform(e3);
      return u(r2);
    });
  }
  convertRealPointsToViewbox(o2) {
    const t2 = this.getSvg(), e3 = this.getCTM().inverse();
    return o2.map(({
      x: s2,
      y: n2
    }) => {
      const r2 = Object.assign(t2.createSVGPoint(), {
        x: s2,
        y: n2
      }).matrixTransform(e3);
      return u(r2, 1e3);
    });
  }
  getBorderPoints(o2 = true) {
    const {
      width: t2,
      height: e3
    } = this.getViewboxSize(), {
      x: s2,
      y: n2
    } = this.getViewboxOffset(), r2 = [{
      x: -s2,
      y: -n2
    }, {
      x: t2 + s2,
      y: -n2
    }, {
      x: t2 + s2,
      y: e3 + n2
    }, {
      x: -s2,
      y: e3 + n2
    }];
    return o2 && r2.push({
      x: -s2,
      y: -n2
    }), r2;
  }
  isAboveTheBorder({
    x: o2,
    y: t2
  }) {
    const {
      width: e3,
      height: s2
    } = this.getViewboxSize(), {
      x: n2,
      y: r2
    } = this.getViewboxOffset();
    return o2 < -n2 || o2 > e3 + n2 || t2 < -r2 || t2 > s2 + r2;
  }
  getMouseCoordinates(o2) {
    const t2 = o2, {
      clientX: e3,
      clientY: s2
    } = t2.changedTouches && t2.touches ? t2.changedTouches[0] || t2.touches[0] : t2, n2 = this.getSvg(), r2 = n2.getScreenCTM();
    if (!r2)
      throw new Error("ScreenCTM is null");
    const h2 = n2.createSVGPoint();
    h2.x = e3, h2.y = s2;
    const {
      x: c2,
      y: d2
    } = h2.matrixTransform(r2.inverse());
    return {
      x: c2,
      y: d2
    };
  }
}
const L = (i2) => class extends Component$1 {
  constructor() {
    super(...arguments);
    a$1(this, "ref", createRef$1());
    a$1(this, "svg", new C(() => {
      var e3, s2;
      return (s2 = (e3 = this.ref) == null ? void 0 : e3.current) == null ? void 0 : s2.ownerSVGElement;
    }));
    a$1(this, "dragLastPosition", null);
    a$1(this, "wasMoved", false);
    a$1(this, "onMouseTouchDown", (e3) => {
      if (e3.target === this.ref.current && this.props.draggable) {
        e3.stopImmediatePropagation(), e3.preventDefault();
        const s2 = e3.target;
        this.dragLastPosition = this.getMousePosition(e3), s2.ownerSVGElement && s2.ownerSVGElement.focus({
          preventScroll: true
        });
      }
    });
    a$1(this, "onMouseTouchMove", (e3) => {
      if (this.dragLastPosition) {
        e3.stopImmediatePropagation(), e3.preventDefault();
        const {
          x: s2,
          y: n2
        } = this.getMousePosition(e3), r2 = s2 - this.dragLastPosition.x, h2 = n2 - this.dragLastPosition.y;
        !this.wasMoved && this.props.onDragStart && this.props.onDragStart({
          x: this.dragLastPosition.x,
          y: this.dragLastPosition.y,
          dx: r2,
          dy: h2
        }), this.props.onDrag && this.props.onDrag({
          dx: r2,
          dy: h2
        }), this.dragLastPosition = {
          x: s2,
          y: n2
        }, this.wasMoved = true;
      }
    });
    a$1(this, "onMouseTouchUp", (e3) => {
      this.dragLastPosition && this.wasMoved && (e3.stopImmediatePropagation(), e3.preventDefault(), (e3 instanceof MouseEvent || !e3.touches) && window.addEventListener("click", (s2) => s2.stopPropagation(), {
        capture: true,
        once: true
      }), this.props.onDragEnd && this.props.onDragEnd({
        x: this.dragLastPosition.x,
        y: this.dragLastPosition.y
      })), this.dragLastPosition = null, this.wasMoved = false;
    });
  }
  render() {
    const {
      draggable: e3,
      onDrag: s2,
      onDragStart: n2,
      onDragEnd: r2,
      ...h2
    } = this.props;
    return /* @__PURE__ */ jsx(i2, {
      ref: this.ref,
      ...h2,
      draggable: e3
    });
  }
  componentDidUpdate(e3) {
    e3.draggable && !this.props.draggable && this.dragLastPosition && this.wasMoved && (this.props.onDragEnd && this.props.onDragEnd({
      x: this.dragLastPosition.x,
      y: this.dragLastPosition.y
    }), this.dragLastPosition = null, this.wasMoved = false);
  }
  componentDidMount() {
    window.addEventListener("mousedown", this.onMouseTouchDown, true), window.addEventListener("mousemove", this.onMouseTouchMove, true), window.addEventListener("mouseup", this.onMouseTouchUp, true), window.addEventListener("touchstart", this.onMouseTouchDown, true), window.addEventListener("touchmove", this.onMouseTouchMove, true), window.addEventListener("touchend", this.onMouseTouchUp, true);
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.onMouseTouchDown), window.removeEventListener("mousemove", this.onMouseTouchMove), window.removeEventListener("mouseup", this.onMouseTouchUp), window.removeEventListener("touchstart", this.onMouseTouchDown), window.removeEventListener("touchmove", this.onMouseTouchMove), window.removeEventListener("touchend", this.onMouseTouchUp);
  }
  getMousePosition(e3) {
    const s2 = e3;
    return this.svg.getMouseCoordinates(s2);
  }
}, U = L(forwardRef(function({
  path: o2,
  animate: t2,
  draggable: e3
}, s2) {
  return /* @__PURE__ */ jsx("polyline", {
    ref: s2,
    style: {
      cursor: e3 ? "move" : ""
    },
    points: o2.map(({
      x: n2,
      y: r2
    }) => `${n2},${r2}`).join(" "),
    fill: "rgba(0,0,0,0)",
    stroke: "#39f",
    strokeWidth: "1.0",
    shapeRendering: "geometricPrecision",
    vectorEffect: "non-scaling-stroke",
    children: t2 && /* @__PURE__ */ jsx("animate", {
      attributeName: "stroke-dashoffset",
      values: "0;1000;0",
      dur: "100s",
      repeatCount: "indefinite"
    })
  });
}));
function H({
  path: i2
}) {
  return /* @__PURE__ */ jsx("polygon", {
    style: {
      pointerEvents: "none",
      transform: "translate(-1px, -1px)"
    },
    points: i2.map(({
      x: o2,
      y: t2
    }) => `${o2},${t2}`).join(" "),
    fill: "rgba(0, 0, 0, 0.5)",
    fillRule: "evenodd",
    stroke: "null",
    shapeRendering: "geometricPrecision"
  });
}
const Y = L(forwardRef(function({
  x: o2,
  y: t2,
  onClickTouchEvent: e3,
  draggable: s2,
  style: n2
}, r2) {
  const {
    cursor: h2 = s2 ? "move" : "default",
    ...c2
  } = n2;
  return /* @__PURE__ */ jsx("rect", {
    style: {
      cursor: h2,
      ...c2
    },
    ref: r2,
    x: o2 - 2.5,
    y: t2 - 2.5,
    onClick: (d2) => {
      d2.stopPropagation(), d2.preventDefault(), e3(d2);
    },
    onTouchEnd: (d2) => {
      d2.stopPropagation(), d2.preventDefault(), e3(d2);
    },
    width: "5px",
    height: "5",
    fill: "#39f",
    stroke: "#39f",
    strokeWidth: "1.0",
    vectorEffect: "non-scaling-stroke"
  });
}));
var p = /* @__PURE__ */ ((i2) => (i2.ADD = "ADD", i2.DELETE = "DELETE", i2.MODIFY = "MODIFY", i2.MOVE = "MOVE", i2.RESET = "RESET", i2.CHANGE = "CHANGE", i2))(p || {});
function j$1(i2, o2) {
  const t2 = i2.points.length;
  switch (o2.type) {
    case "ADD":
      return i2.closed ? [i2, false] : t2 > 0 && f(i2.points[t2 - 1], o2.payload) || t2 > 1 && f(i2.points[t2 - 2], o2.payload) ? [i2, false] : t2 > 2 && f(i2.points[0], o2.payload) ? [{
        points: [...i2.points],
        closed: true
      }, true] : [{
        points: [...i2.points, o2.payload],
        closed: false
      }, true];
    case "DELETE":
      return [{
        points: [...i2.points.filter((e3, s2) => o2.payload !== s2)],
        closed: t2 > 4 && i2.closed
      }, true];
    case "MODIFY": {
      const {
        x: e3,
        y: s2
      } = i2.points[o2.payload.index];
      return [{
        points: i2.points.map(({
          x: r2,
          y: h2
        }) => r2 === e3 && h2 === s2 ? {
          x: o2.payload.x,
          y: o2.payload.y
        } : {
          x: r2,
          y: h2
        }),
        closed: i2.closed
      }, !!(o2.payload.x || o2.payload.y)];
    }
    case "MOVE":
      return [{
        points: i2.points.map(({
          x: e3,
          y: s2
        }) => ({
          x: e3 + o2.payload.x,
          y: s2 + o2.payload.y
        })),
        closed: i2.closed
      }, !!(o2.payload.x || o2.payload.y)];
    case "CHANGE": {
      const e3 = !m(o2.payload, i2.points);
      return [{
        points: o2.payload,
        closed: e3 ? o2.payload.length > 2 : i2.closed
      }, e3];
    }
    case "RESET":
      return [{
        points: [],
        closed: false
      }, !!i2.points.length];
    default:
      return [i2, false];
  }
}
let E$1 = class E2 extends Component$1 {
  constructor(t2) {
    super(t2);
    a$1(this, "state");
    a$1(this, "imageRef", createRef$1());
    a$1(this, "svgRef", createRef$1());
    a$1(this, "svg", new C(() => {
      var t3;
      return (t3 = this.svgRef) == null ? void 0 : t3.current;
    }));
    a$1(this, "angles", []);
    a$1(this, "path", {
      points: [],
      closed: false
    });
    a$1(this, "lastEmittedPoints", []);
    a$1(this, "lastUpdatedPoints", []);
    a$1(this, "imgError", false);
    a$1(this, "setPathFromPropsOnMediaLoad", true);
    a$1(this, "hidePointer", () => {
      const t3 = this.path.points[this.path.points.length - 1] || {
        x: 0,
        y: 0
      };
      this.setPointer({
        ...t3
      }, true);
    });
    a$1(this, "onShapeDrag", ({
      dx: t3,
      dy: e3
    }) => {
      this.path.points.map(({
        x: n2,
        y: r2
      }) => ({
        x: n2 + t3,
        y: r2 + e3
      })).some((n2) => this.svg.isAboveTheBorder(n2)) || this.dispatchPathAction({
        type: p.MOVE,
        payload: {
          x: t3,
          y: e3
        }
      });
    });
    a$1(this, "onPointDrag", (t3, {
      dx: e3,
      dy: s2
    }) => {
      const n2 = {
        ...this.path.points[t3]
      };
      n2.x += e3, n2.y += s2, this.svg.isAboveTheBorder(n2) || this.dispatchPathAction({
        type: p.MODIFY,
        payload: {
          ...n2,
          index: t3
        }
      });
    });
    a$1(this, "onPointClick", (t3) => {
      this.isLoaded() && !this.props.disabled && !this.path.closed && this.dispatchPathAction({
        type: p.ADD,
        payload: this.path.points[t3]
      });
    });
    a$1(this, "onDragEnd", () => {
      this.checkIfPathUpdated(false);
    });
    a$1(this, "onMediaLoaded", (t3) => {
      this.setPathFromPropsOnMediaLoad && (this.setPathStateFromProps(), this.setPathFromPropsOnMediaLoad = false), this.imgError = false, this.props.onImageLoad(t3);
    });
    a$1(this, "onMediaError", (t3) => {
      this.dispatchPathAction({
        type: p.RESET
      }), this.imgError = true, this.props.onImageError(t3);
    });
    a$1(this, "onClickTouchEvent", (t3) => {
      if (this.isLoaded() && !this.props.disabled) {
        if (this.path.closed) {
          t3.target === this.svgRef.current && this.dispatchPathAction({
            type: p.RESET
          });
          return;
        }
        const [e3] = this.getMousePosition(t3);
        this.svg.isAboveTheBorder(e3) ? this.hidePointer() : this.dispatchPathAction({
          type: p.ADD,
          payload: u(e3, 1e3),
          pointer: e3
        });
      }
    });
    a$1(this, "onClick", (t3) => {
      this.onClickTouchEvent(t3);
    });
    a$1(this, "onTouchEnd", (t3) => {
      t3.cancelable && (t3.preventDefault(), this.onClickTouchEvent(t3)), this.hidePointer();
    });
    a$1(this, "onMouseTouchMove", (t3) => {
      if (this.isLoaded()) {
        const [e3] = this.getMousePosition(t3);
        this.setPointer(e3);
      }
    });
    a$1(this, "onContextMenu", (t3) => {
      if (this.isLoaded() && (t3.preventDefault(), !this.props.disabled && !this.path.closed)) {
        const [e3, {
          index: s2
        }] = this.getMousePosition(t3);
        s2 > -1 ? this.dispatchPathAction({
          type: p.DELETE,
          payload: s2,
          pointer: e3
        }) : this.setPointer(e3);
      }
    });
    this.state = {
      path: {
        points: [],
        closed: false
      },
      pointer: {
        x: t2.viewBox.width / 2,
        y: t2.viewBox.width / 2
      }
    };
  }
  render() {
    return /* @__PURE__ */ jsxs("div", {
      className: B({
        ReactFreeSelect__Component: true,
        ReactFreeSelect__Closed: this.state.path.closed,
        ReactFreeSelect__Disabled: this.props.disabled
      }),
      style: {
        display: "inline-block",
        position: "relative",
        margin: "0",
        padding: "0",
        fontSize: "0",
        cursor: this.props.disabled ? "not-allowed" : "default",
        ...this.props.style
      },
      children: [/* @__PURE__ */ jsx("img", {
        ref: this.imageRef,
        src: this.props.src,
        alt: this.props.imageAlt,
        crossOrigin: this.props.crossOrigin,
        style: this.props.imageStyle,
        onLoad: this.onMediaLoaded,
        onError: this.onMediaError
      }), /* @__PURE__ */ jsxs("svg", {
        ref: this.svgRef,
        style: {
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          userSelect: "none",
          touchAction: "none"
        },
        viewBox: `0 0 ${this.props.viewBox.width} ${this.props.viewBox.height}`,
        onMouseMove: this.onMouseTouchMove,
        onTouchMove: this.onMouseTouchMove,
        onClick: this.onClick,
        onTouchEnd: this.onTouchEnd,
        onContextMenu: this.onContextMenu,
        onMouseLeave: this.hidePointer,
        children: [/* @__PURE__ */ jsx("rect", {
          visibility: "hidden"
        }), !!this.state.path.points.length && /* @__PURE__ */ jsx(H, {
          path: this.getPolygonPoints()
        }), /* @__PURE__ */ jsx(U, {
          draggable: this.state.path.closed && !this.props.disabled,
          onDrag: this.onShapeDrag,
          onDragEnd: this.onDragEnd,
          animate: !this.props.disabled,
          path: this.getPolylinePoints()
        }), this.getRoundedPoints().map(({
          x: t2,
          y: e3
        }, s2) => /* @__PURE__ */ jsx(Y, {
          x: t2,
          y: e3,
          draggable: !this.props.disabled && !this.props.disabledShapeChange,
          style: {
            cursor: !s2 && this.state.path.points.length > 2 && !this.state.path.closed ? "pointer" : void 0
          },
          onDrag: ({
            dx: n2,
            dy: r2
          }) => this.onPointDrag(s2, {
            dx: n2,
            dy: r2
          }),
          onDragEnd: this.onDragEnd,
          onClickTouchEvent: () => this.onPointClick(s2)
        }, s2))]
      })]
    });
  }
  componentDidUpdate(t2) {
    !t2.disabled && this.props.disabled && !this.path.closed && this.hidePointer(), t2.src && t2.src !== this.props.src ? this.dispatchPathAction({
      type: p.RESET
    }) : m(t2.value, this.props.value) || (this.isLoaded() ? this.setPathStateFromProps() : this.setPathFromPropsOnMediaLoad = true);
  }
  convertPoints(t2) {
    const e3 = this.getAspectRatio();
    return this.svg.convertViewboxPointsToReal(t2).map(({
      x: s2,
      y: n2
    }) => ({
      x: Math.round(s2 / e3.x),
      y: Math.round(n2 / e3.y)
    }));
  }
  checkIfPathUpdated(t2) {
    if (this.path.closed || t2) {
      const e3 = this.convertPoints(this.path.points);
      m(e3, this.lastUpdatedPoints) || (this.emitOnComplete(e3), this.lastUpdatedPoints = e3.map(({
        x: s2,
        y: n2
      }) => ({
        x: s2,
        y: n2
      })));
    }
  }
  emitOnChange({
    points: t2
  }) {
    if (this.props.onChange) {
      const e3 = this.convertPoints(t2);
      this.lastEmittedPoints = e3, this.props.onChange(e3);
    }
  }
  emitOnComplete(t2) {
    this.props.onComplete && this.props.onComplete(t2);
  }
  setPointer({
    x: t2,
    y: e3
  }, s2 = false) {
    (s2 || !this.props.disabled) && this.setState({
      path: this.path,
      pointer: {
        x: t2,
        y: e3
      }
    });
  }
  dispatchPathAction(t2) {
    const e3 = this.path.closed, [s2, n2] = j$1(this.path, t2);
    s2.points = s2.points.map((r2) => u(r2, 1e3)), n2 && (this.path = s2, this.setState({
      pointer: t2.pointer || this.path.points[this.path.points.length - 1] || {
        x: 0,
        y: 0
      },
      path: s2
    }), this.angles = G(s2.points), this.emitOnChange(s2), [p.MODIFY, p.MOVE].includes(t2.type) || this.checkIfPathUpdated(e3));
  }
  isLoaded() {
    if (this.imgError || !this.svgRef.current)
      return false;
    const t2 = this.svgRef.current;
    return !!(t2.width.baseVal.value && t2.height.baseVal.value);
  }
  getAspectRatio() {
    return this.imageRef.current ? {
      x: this.imageRef.current.clientWidth / this.imageRef.current.naturalWidth,
      y: this.imageRef.current.clientHeight / this.imageRef.current.naturalHeight
    } : {
      x: NaN,
      y: NaN
    };
  }
  setPathStateFromProps() {
    if (m(this.lastEmittedPoints, this.props.value))
      return;
    const t2 = this.getAspectRatio(), e3 = this.svg.convertRealPointsToViewbox(this.props.value.map(({
      x: s2,
      y: n2
    }) => ({
      x: s2 * t2.x,
      y: n2 * t2.y
    })));
    this.dispatchPathAction({
      type: p.CHANGE,
      payload: e3
    });
  }
  getRoundedPoints() {
    return this.state.path.points.map((t2) => u(t2));
  }
  getBorder() {
    return this.svg.getBorderPoints().map((t2) => u(t2)).map(({
      x: t2,
      y: e3
    }) => ({
      x: t2 - 1,
      y: e3 + 1
    }));
  }
  getPolygonPoints() {
    const t2 = this.getRoundedPoints(), e3 = this.getBorder();
    return this.state.path.closed ? [...e3, ...t2, t2[0], e3[0]] : e3;
  }
  getPolylinePoints() {
    const t2 = this.getRoundedPoints();
    return t2.concat(this.state.path.closed ? t2[0] : u(this.state.pointer));
  }
  getMousePosition(t2, e3 = true, s2 = true) {
    let n2 = this.svg.getMouseCoordinates(t2);
    if (s2) {
      const c2 = navigator.platform.includes("Mac") ? t2.metaKey : t2.ctrlKey, d2 = this.path.points[this.path.points.length - 1];
      c2 && d2 && (t2.shiftKey ? n2 = F(d2, n2, this.angles) : n2 = N(d2, n2, Math.PI / 12));
    }
    const {
      point: r2,
      index: h2
    } = k$1(this.path.points, n2, 10);
    return e3 && h2 > -1 && (n2 = {
      ...r2
    }), [n2, {
      point: r2,
      index: h2
    }];
  }
};
a$1(E$1, "propTypes", {
  value: propTypesExports$1.arrayOf(propTypesExports$1.exact({
    x: propTypesExports$1.number.isRequired,
    y: propTypesExports$1.number.isRequired
  })),
  style: propTypesExports$1.shape({}),
  viewBox: propTypesExports$1.exact({
    width: propTypesExports$1.number.isRequired,
    height: propTypesExports$1.number.isRequired
  }),
  disabled: propTypesExports$1.bool,
  disabledShapeChange: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  onComplete: propTypesExports$1.func,
  src: propTypesExports$1.string.isRequired,
  imageAlt: propTypesExports$1.string,
  crossOrigin: propTypesExports$1.string,
  imageStyle: propTypesExports$1.shape({}),
  onImageLoad: propTypesExports$1.func,
  onImageError: propTypesExports$1.func
}), a$1(E$1, "defaultProps", {
  value: [],
  style: {},
  imageStyle: {},
  viewBox: {
    width: 1e3,
    height: 1e3
  },
  disabled: false,
  disabledShapeChange: false,
  onImageError: Function.prototype,
  onImageLoad: Function.prototype
});
function PolygonalCropper(props) {
  const {
    src: src2,
    onCrop: onChange,
    style: style2
  } = props;
  const lassoRef = React__default.useRef(null);
  const {
    ref: imageRef,
    ...imageSize
  } = useLayoutDimensions();
  const {
    ref: divRef,
    ...divSize
  } = useLayoutDimensions();
  const [points2, setPoints] = React__default.useState([]);
  const [transform4, setTransform] = React__default.useState({});
  const getCuratedPoints = React__default.useCallback(() => {
    var _a3, _b3, _c2, _d2, _e2, _f3;
    let offsetX = (_a3 = transform4.offset) == null ? void 0 : _a3.x;
    let offsetY = (_b3 = transform4.offset) == null ? void 0 : _b3.y;
    let scaleX3 = ((_c2 = transform4.imageSize) == null ? void 0 : _c2.width) / ((_d2 = transform4.imageSizeNatural) == null ? void 0 : _d2.width);
    let scaleY3 = ((_e2 = transform4.imageSize) == null ? void 0 : _e2.height) / ((_f3 = transform4.imageSizeNatural) == null ? void 0 : _f3.height);
    if (Number.isNaN(offsetX))
      offsetX = 0;
    if (Number.isNaN(offsetY))
      offsetY = 0;
    if (Number.isNaN(scaleX3))
      scaleX3 = 1;
    if (Number.isNaN(scaleY3))
      scaleY3 = 1;
    return (points2 == null ? void 0 : points2.map((pt) => [pt.x * scaleX3 + offsetX, pt.y * scaleY3 + offsetY])) || [];
  }, [points2, transform4]);
  const onImageLoad = React__default.useCallback((event) => {
    const image = event == null ? void 0 : event.target;
    if (!image)
      return;
    setTransform((previous) => ({
      ...previous,
      imageSizeNatural: {
        width: image.naturalWidth || 0,
        height: image.naturalHeight || 0
      }
    }));
  }, []);
  const handleLassoComplete = React__default.useCallback((selectedPoints) => {
    if (!selectedPoints.length)
      return;
    X$1(src2, selectedPoints, (err, canvas2) => {
      if (!err) {
        const croppedImage = canvas2.toDataURL("image/png");
        onChange({
          image: croppedImage,
          points: getCuratedPoints()
        });
      }
    });
  }, [getCuratedPoints, onChange, src2]);
  React__default.useLayoutEffect(() => {
    var _a3;
    if (lassoRef.current) {
      imageRef.current = (_a3 = lassoRef.current.imageRef) == null ? void 0 : _a3.current;
    }
  }, [imageRef]);
  React__default.useLayoutEffect(() => {
    const offsetX = (divSize.width - imageSize.width) * 0.5;
    const offsetY = (divSize.height - imageSize.height) * 0.5;
    setTransform((previous) => ({
      ...previous,
      offset: {
        x: offsetX,
        y: offsetY
      },
      imageSize: {
        width: imageSize.width || 0,
        height: imageSize.height || 0
      }
    }));
  }, [divSize.height, divSize.width, imageSize.height, imageSize.width]);
  if (!src2)
    return null;
  return /* @__PURE__ */ jsxs("div", { ref: divRef, style: {
    position: "relative",
    width: "100%",
    height: "100%"
  }, children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "black",
          opacity: 0.5
        }
      }
    ),
    /* @__PURE__ */ jsx("div", { style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    }, children: /* @__PURE__ */ jsx("div", { style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      ...style2
    }, children: /* @__PURE__ */ jsx(E$1, { ref: lassoRef, value: points2, src: src2, onChange: setPoints, onComplete: handleLassoComplete, style: {
      width: "100%"
    }, imageStyle: {
      width: "100%",
      maxWidth: "100%",
      objectFit: "contain"
    }, onImageLoad }) }) })
  ] });
}
PolygonalCropper.propTypes = {
  src: propTypesExports$1.string,
  onCrop: propTypesExports$1.func,
  style: propTypesExports$1.object
};
PolygonalCropper.defaultProps = {
  src: "",
  onCrop: () => {
  },
  style: {}
};
/*!
 * Cropper.js v1.6.0
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-08-26T08:14:27.943Z
 */
function ownKeys$2(e3, r2) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread2$2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$2(Object(t2), true).forEach(function(r3) {
      _defineProperty$2(e3, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys$2(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e3;
}
function _typeof(o2) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o3) {
    return typeof o3;
  } : function(o3) {
    return o3 && "function" == typeof Symbol && o3.constructor === Symbol && o3 !== Symbol.prototype ? "symbol" : typeof o3;
  }, _typeof(o2);
}
function _classCallCheck$1(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len2) {
  if (len2 == null || len2 > arr.length)
    len2 = arr.length;
  for (var i2 = 0, arr2 = new Array(len2); i2 < len2; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive$1(input, hint2) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint2 || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint2 === "string" ? String : Number)(input);
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var IS_BROWSER = typeof window !== "undefined" && typeof window.document !== "undefined";
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? "ontouchstart" in WINDOW.document.documentElement : false;
var HAS_POINTER_EVENT = IS_BROWSER ? "PointerEvent" in WINDOW : false;
var NAMESPACE = "cropper";
var ACTION_ALL = "all";
var ACTION_CROP = "crop";
var ACTION_MOVE = "move";
var ACTION_ZOOM = "zoom";
var ACTION_EAST = "e";
var ACTION_WEST = "w";
var ACTION_SOUTH = "s";
var ACTION_NORTH = "n";
var ACTION_NORTH_EAST = "ne";
var ACTION_NORTH_WEST = "nw";
var ACTION_SOUTH_EAST = "se";
var ACTION_SOUTH_WEST = "sw";
var CLASS_CROP = "".concat(NAMESPACE, "-crop");
var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
var CLASS_MOVE = "".concat(NAMESPACE, "-move");
var DATA_ACTION = "".concat(NAMESPACE, "Action");
var DATA_PREVIEW = "".concat(NAMESPACE, "Preview");
var DRAG_MODE_CROP = "crop";
var DRAG_MODE_MOVE = "move";
var DRAG_MODE_NONE = "none";
var EVENT_CROP = "crop";
var EVENT_CROP_END = "cropend";
var EVENT_CROP_MOVE = "cropmove";
var EVENT_CROP_START = "cropstart";
var EVENT_DBLCLICK = "dblclick";
var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? "touchstart" : "mousedown";
var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? "touchmove" : "mousemove";
var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? "touchend touchcancel" : "mouseup";
var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? "pointerdown" : EVENT_TOUCH_START;
var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? "pointermove" : EVENT_TOUCH_MOVE;
var EVENT_POINTER_UP = HAS_POINTER_EVENT ? "pointerup pointercancel" : EVENT_TOUCH_END;
var EVENT_READY = "ready";
var EVENT_RESIZE = "resize";
var EVENT_WHEEL = "wheel";
var EVENT_ZOOM = "zoom";
var MIME_TYPE_JPEG = "image/jpeg";
var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
var REGEXP_DATA_URL = /^data:/;
var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
var REGEXP_TAG_NAME = /^img|canvas$/i;
var MIN_CONTAINER_WIDTH = 200;
var MIN_CONTAINER_HEIGHT = 100;
var DEFAULTS$1 = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: DRAG_MODE_CROP,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: true,
  // Restore the cropped area after resize the window
  restore: true,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: true,
  // Check the current image's Exif Orientation information
  checkOrientation: true,
  // Show the black modal
  modal: true,
  // Show the dashed lines for guiding
  guides: true,
  // Show the center indicator for guiding
  center: true,
  // Show the white modal to highlight the crop box
  highlight: true,
  // Show the grid background
  background: true,
  // Enable to crop the image automatically when initialize
  autoCrop: true,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: true,
  // Enable to rotate the image
  rotatable: true,
  // Enable to scale the image
  scalable: true,
  // Enable to zoom the image
  zoomable: true,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: true,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: true,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: true,
  // Enable to resize the crop box
  cropBoxResizable: true,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: true,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: MIN_CONTAINER_WIDTH,
  minContainerHeight: MIN_CONTAINER_HEIGHT,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
};
var TEMPLATE = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
var isNaN$1 = Number.isNaN || WINDOW.isNaN;
function isNumber(value) {
  return typeof value === "number" && !isNaN$1(value);
}
var isPositiveNumber = function isPositiveNumber2(value) {
  return value > 0 && value < Infinity;
};
function isUndefined(value) {
  return typeof value === "undefined";
}
function isObject$1(value) {
  return _typeof(value) === "object" && value !== null;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isPlainObject$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  try {
    var _constructor = value.constructor;
    var prototype2 = _constructor.prototype;
    return _constructor && prototype2 && hasOwnProperty.call(prototype2, "isPrototypeOf");
  } catch (error2) {
    return false;
  }
}
function isFunction(value) {
  return typeof value === "function";
}
var slice = Array.prototype.slice;
function toArray(value) {
  return Array.from ? Array.from(value) : slice.call(value);
}
function forEach(data2, callback) {
  if (data2 && isFunction(callback)) {
    if (Array.isArray(data2) || isNumber(data2.length)) {
      toArray(data2).forEach(function(value, key) {
        callback.call(data2, value, key, data2);
      });
    } else if (isObject$1(data2)) {
      Object.keys(data2).forEach(function(key) {
        callback.call(data2, data2[key], key, data2);
      });
    }
  }
  return data2;
}
var assign = Object.assign || function assign2(target) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (isObject$1(target) && args.length > 0) {
    args.forEach(function(arg) {
      if (isObject$1(arg)) {
        Object.keys(arg).forEach(function(key) {
          target[key] = arg[key];
        });
      }
    });
  }
  return target;
};
var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
function normalizeDecimalNumber(value) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
}
var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
function setStyle(element, styles2) {
  var style2 = element.style;
  forEach(styles2, function(value, property2) {
    if (REGEXP_SUFFIX.test(property2) && isNumber(value)) {
      value = "".concat(value, "px");
    }
    style2[property2] = value;
  });
}
function hasClass(element, value) {
  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
}
function addClass(element, value) {
  if (!value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      addClass(elem, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.add(value);
    return;
  }
  var className = element.className.trim();
  if (!className) {
    element.className = value;
  } else if (className.indexOf(value) < 0) {
    element.className = "".concat(className, " ").concat(value);
  }
}
function removeClass(element, value) {
  if (!value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      removeClass(elem, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.remove(value);
    return;
  }
  if (element.className.indexOf(value) >= 0) {
    element.className = element.className.replace(value, "");
  }
}
function toggleClass(element, value, added) {
  if (!value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      toggleClass(elem, value, added);
    });
    return;
  }
  if (added) {
    addClass(element, value);
  } else {
    removeClass(element, value);
  }
}
var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
function toParamCase(value) {
  return value.replace(REGEXP_CAMEL_CASE, "$1-$2").toLowerCase();
}
function getData(element, name2) {
  if (isObject$1(element[name2])) {
    return element[name2];
  }
  if (element.dataset) {
    return element.dataset[name2];
  }
  return element.getAttribute("data-".concat(toParamCase(name2)));
}
function setData(element, name2, data2) {
  if (isObject$1(data2)) {
    element[name2] = data2;
  } else if (element.dataset) {
    element.dataset[name2] = data2;
  } else {
    element.setAttribute("data-".concat(toParamCase(name2)), data2);
  }
}
function removeData(element, name2) {
  if (isObject$1(element[name2])) {
    try {
      delete element[name2];
    } catch (error2) {
      element[name2] = void 0;
    }
  } else if (element.dataset) {
    try {
      delete element.dataset[name2];
    } catch (error2) {
      element.dataset[name2] = void 0;
    }
  } else {
    element.removeAttribute("data-".concat(toParamCase(name2)));
  }
}
var REGEXP_SPACES = /\s\s*/;
var onceSupported = function() {
  var supported = false;
  if (IS_BROWSER) {
    var once3 = false;
    var listener = function listener2() {
    };
    var options2 = Object.defineProperty({}, "once", {
      get: function get6() {
        supported = true;
        return once3;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function set(value) {
        once3 = value;
      }
    });
    WINDOW.addEventListener("test", listener, options2);
    WINDOW.removeEventListener("test", listener, options2);
  }
  return supported;
}();
function removeListener(element, type, listener) {
  var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (!onceSupported) {
      var listeners2 = element.listeners;
      if (listeners2 && listeners2[event] && listeners2[event][listener]) {
        handler = listeners2[event][listener];
        delete listeners2[event][listener];
        if (Object.keys(listeners2[event]).length === 0) {
          delete listeners2[event];
        }
        if (Object.keys(listeners2).length === 0) {
          delete element.listeners;
        }
      }
    }
    element.removeEventListener(event, handler, options2);
  });
}
function addListener(element, type, listener) {
  var options2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var _handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (options2.once && !onceSupported) {
      var _element$listeners = element.listeners, listeners2 = _element$listeners === void 0 ? {} : _element$listeners;
      _handler = function handler() {
        delete listeners2[event][listener];
        element.removeEventListener(event, _handler, options2);
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        listener.apply(element, args);
      };
      if (!listeners2[event]) {
        listeners2[event] = {};
      }
      if (listeners2[event][listener]) {
        element.removeEventListener(event, listeners2[event][listener], options2);
      }
      listeners2[event][listener] = _handler;
      element.listeners = listeners2;
    }
    element.addEventListener(event, _handler, options2);
  });
}
function dispatchEvent(element, type, data2) {
  var event;
  if (isFunction(Event) && isFunction(CustomEvent)) {
    event = new CustomEvent(type, {
      detail: data2,
      bubbles: true,
      cancelable: true
    });
  } else {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(type, true, true, data2);
  }
  return element.dispatchEvent(event);
}
function getOffset(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var location$1 = WINDOW.location;
var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function isCrossOriginURL(url2) {
  var parts = url2.match(REGEXP_ORIGINS);
  return parts !== null && (parts[1] !== location$1.protocol || parts[2] !== location$1.hostname || parts[3] !== location$1.port);
}
function addTimestamp(url2) {
  var timestamp2 = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return url2 + (url2.indexOf("?") === -1 ? "?" : "&") + timestamp2;
}
function getTransforms(_ref2) {
  var rotate3 = _ref2.rotate, scaleX3 = _ref2.scaleX, scaleY3 = _ref2.scaleY, translateX = _ref2.translateX, translateY = _ref2.translateY;
  var values4 = [];
  if (isNumber(translateX) && translateX !== 0) {
    values4.push("translateX(".concat(translateX, "px)"));
  }
  if (isNumber(translateY) && translateY !== 0) {
    values4.push("translateY(".concat(translateY, "px)"));
  }
  if (isNumber(rotate3) && rotate3 !== 0) {
    values4.push("rotate(".concat(rotate3, "deg)"));
  }
  if (isNumber(scaleX3) && scaleX3 !== 1) {
    values4.push("scaleX(".concat(scaleX3, ")"));
  }
  if (isNumber(scaleY3) && scaleY3 !== 1) {
    values4.push("scaleY(".concat(scaleY3, ")"));
  }
  var transform4 = values4.length ? values4.join(" ") : "none";
  return {
    WebkitTransform: transform4,
    msTransform: transform4,
    transform: transform4
  };
}
function getMaxZoomRatio(pointers) {
  var pointers2 = _objectSpread2$2({}, pointers);
  var maxRatio = 0;
  forEach(pointers, function(pointer, pointerId2) {
    delete pointers2[pointerId2];
    forEach(pointers2, function(pointer2) {
      var x12 = Math.abs(pointer.startX - pointer2.startX);
      var y12 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x12 * x12 + y12 * y12);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;
      if (Math.abs(ratio) > Math.abs(maxRatio)) {
        maxRatio = ratio;
      }
    });
  });
  return maxRatio;
}
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX, pageY = _ref2.pageY;
  var end = {
    endX: pageX,
    endY: pageY
  };
  return endOnly ? end : _objectSpread2$2({
    startX: pageX,
    startY: pageY
  }, end);
}
function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count3 = 0;
  forEach(pointers, function(_ref3) {
    var startX = _ref3.startX, startY = _ref3.startY;
    pageX += startX;
    pageY += startY;
    count3 += 1;
  });
  pageX /= count3;
  pageY /= count3;
  return {
    pageX,
    pageY
  };
}
function getAdjustedSizes(_ref4) {
  var aspectRatio = _ref4.aspectRatio, height = _ref4.height, width = _ref4.width;
  var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain";
  var isValidWidth = isPositiveNumber(width);
  var isValidHeight = isPositiveNumber(height);
  if (isValidWidth && isValidHeight) {
    var adjustedWidth = height * aspectRatio;
    if (type === "contain" && adjustedWidth > width || type === "cover" && adjustedWidth < width) {
      height = width / aspectRatio;
    } else {
      width = height * aspectRatio;
    }
  } else if (isValidWidth) {
    height = width / aspectRatio;
  } else if (isValidHeight) {
    width = height * aspectRatio;
  }
  return {
    width,
    height
  };
}
function getRotatedSizes(_ref5) {
  var width = _ref5.width, height = _ref5.height, degree = _ref5.degree;
  degree = Math.abs(degree) % 180;
  if (degree === 90) {
    return {
      width: height,
      height: width
    };
  }
  var arc = degree % 90 * Math.PI / 180;
  var sinArc = Math.sin(arc);
  var cosArc = Math.cos(arc);
  var newWidth = width * cosArc + height * sinArc;
  var newHeight = width * sinArc + height * cosArc;
  return degree > 90 ? {
    width: newHeight,
    height: newWidth
  } : {
    width: newWidth,
    height: newHeight
  };
}
function getSourceCanvas(image, _ref6, _ref7, _ref8) {
  var imageAspectRatio = _ref6.aspectRatio, imageNaturalWidth = _ref6.naturalWidth, imageNaturalHeight = _ref6.naturalHeight, _ref6$rotate = _ref6.rotate, rotate3 = _ref6$rotate === void 0 ? 0 : _ref6$rotate, _ref6$scaleX = _ref6.scaleX, scaleX3 = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX, _ref6$scaleY = _ref6.scaleY, scaleY3 = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
  var aspectRatio = _ref7.aspectRatio, naturalWidth = _ref7.naturalWidth, naturalHeight = _ref7.naturalHeight;
  var _ref8$fillColor = _ref8.fillColor, fillColor = _ref8$fillColor === void 0 ? "transparent" : _ref8$fillColor, _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled, imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE, _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality, imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? "low" : _ref8$imageSmoothingQ, _ref8$maxWidth = _ref8.maxWidth, maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth, _ref8$maxHeight = _ref8.maxHeight, maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight, _ref8$minWidth = _ref8.minWidth, minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth, _ref8$minHeight = _ref8.minHeight, minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
  var canvas2 = document.createElement("canvas");
  var context2 = canvas2.getContext("2d");
  var maxSizes = getAdjustedSizes({
    aspectRatio,
    width: maxWidth,
    height: maxHeight
  });
  var minSizes = getAdjustedSizes({
    aspectRatio,
    width: minWidth,
    height: minHeight
  }, "cover");
  var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
  var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight));
  var destMaxSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: maxWidth,
    height: maxHeight
  });
  var destMinSizes = getAdjustedSizes({
    aspectRatio: imageAspectRatio,
    width: minWidth,
    height: minHeight
  }, "cover");
  var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
  var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
  var params2 = [-destWidth / 2, -destHeight / 2, destWidth, destHeight];
  canvas2.width = normalizeDecimalNumber(width);
  canvas2.height = normalizeDecimalNumber(height);
  context2.fillStyle = fillColor;
  context2.fillRect(0, 0, width, height);
  context2.save();
  context2.translate(width / 2, height / 2);
  context2.rotate(rotate3 * Math.PI / 180);
  context2.scale(scaleX3, scaleY3);
  context2.imageSmoothingEnabled = imageSmoothingEnabled;
  context2.imageSmoothingQuality = imageSmoothingQuality;
  context2.drawImage.apply(context2, [image].concat(_toConsumableArray(params2.map(function(param) {
    return Math.floor(normalizeDecimalNumber(param));
  }))));
  context2.restore();
  return canvas2;
}
var fromCharCode = String.fromCharCode;
function getStringFromCharCode(dataView, start2, length2) {
  var str = "";
  length2 += start2;
  for (var i2 = start2; i2 < length2; i2 += 1) {
    str += fromCharCode(dataView.getUint8(i2));
  }
  return str;
}
var REGEXP_DATA_URL_HEAD = /^data:.*,/;
function dataURLToArrayBuffer(dataURL) {
  var base642 = dataURL.replace(REGEXP_DATA_URL_HEAD, "");
  var binary = atob(base642);
  var arrayBuffer2 = new ArrayBuffer(binary.length);
  var uint8 = new Uint8Array(arrayBuffer2);
  forEach(uint8, function(value, i2) {
    uint8[i2] = binary.charCodeAt(i2);
  });
  return arrayBuffer2;
}
function arrayBufferToDataURL(arrayBuffer2, mimeType) {
  var chunks = [];
  var chunkSize = 8192;
  var uint8 = new Uint8Array(arrayBuffer2);
  while (uint8.length > 0) {
    chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
    uint8 = uint8.subarray(chunkSize);
  }
  return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join("")));
}
function resetAndGetOrientation(arrayBuffer2) {
  var dataView = new DataView(arrayBuffer2);
  var orientation2;
  try {
    var littleEndian;
    var app1Start;
    var ifdStart;
    if (dataView.getUint8(0) === 255 && dataView.getUint8(1) === 216) {
      var length2 = dataView.byteLength;
      var offset = 2;
      while (offset + 1 < length2) {
        if (dataView.getUint8(offset) === 255 && dataView.getUint8(offset + 1) === 225) {
          app1Start = offset;
          break;
        }
        offset += 1;
      }
    }
    if (app1Start) {
      var exifIDCode = app1Start + 4;
      var tiffOffset = app1Start + 10;
      if (getStringFromCharCode(dataView, exifIDCode, 4) === "Exif") {
        var endianness = dataView.getUint16(tiffOffset);
        littleEndian = endianness === 18761;
        if (littleEndian || endianness === 19789) {
          if (dataView.getUint16(tiffOffset + 2, littleEndian) === 42) {
            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
            if (firstIFDOffset >= 8) {
              ifdStart = tiffOffset + firstIFDOffset;
            }
          }
        }
      }
    }
    if (ifdStart) {
      var _length = dataView.getUint16(ifdStart, littleEndian);
      var _offset2;
      var i2;
      for (i2 = 0; i2 < _length; i2 += 1) {
        _offset2 = ifdStart + i2 * 12 + 2;
        if (dataView.getUint16(_offset2, littleEndian) === 274) {
          _offset2 += 8;
          orientation2 = dataView.getUint16(_offset2, littleEndian);
          dataView.setUint16(_offset2, 1, littleEndian);
          break;
        }
      }
    }
  } catch (error2) {
    orientation2 = 1;
  }
  return orientation2;
}
function parseOrientation(orientation2) {
  var rotate3 = 0;
  var scaleX3 = 1;
  var scaleY3 = 1;
  switch (orientation2) {
    case 2:
      scaleX3 = -1;
      break;
    case 3:
      rotate3 = -180;
      break;
    case 4:
      scaleY3 = -1;
      break;
    case 5:
      rotate3 = 90;
      scaleY3 = -1;
      break;
    case 6:
      rotate3 = 90;
      break;
    case 7:
      rotate3 = 90;
      scaleX3 = -1;
      break;
    case 8:
      rotate3 = -90;
      break;
  }
  return {
    rotate: rotate3,
    scaleX: scaleX3,
    scaleY: scaleY3
  };
}
var render = {
  render: function render4() {
    this.initContainer();
    this.initCanvas();
    this.initCropBox();
    this.renderCanvas();
    if (this.cropped) {
      this.renderCropBox();
    }
  },
  initContainer: function initContainer() {
    var element = this.element, options2 = this.options, container = this.container, cropper2 = this.cropper;
    var minWidth = Number(options2.minContainerWidth);
    var minHeight = Number(options2.minContainerHeight);
    addClass(cropper2, CLASS_HIDDEN);
    removeClass(element, CLASS_HIDDEN);
    var containerData = {
      width: Math.max(container.offsetWidth, minWidth >= 0 ? minWidth : MIN_CONTAINER_WIDTH),
      height: Math.max(container.offsetHeight, minHeight >= 0 ? minHeight : MIN_CONTAINER_HEIGHT)
    };
    this.containerData = containerData;
    setStyle(cropper2, {
      width: containerData.width,
      height: containerData.height
    });
    addClass(element, CLASS_HIDDEN);
    removeClass(cropper2, CLASS_HIDDEN);
  },
  // Canvas (image wrapper)
  initCanvas: function initCanvas() {
    var containerData = this.containerData, imageData = this.imageData;
    var viewMode = this.options.viewMode;
    var rotated = Math.abs(imageData.rotate) % 180 === 90;
    var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
    var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
    var aspectRatio = naturalWidth / naturalHeight;
    var canvasWidth = containerData.width;
    var canvasHeight = containerData.height;
    if (containerData.height * aspectRatio > containerData.width) {
      if (viewMode === 3) {
        canvasWidth = containerData.height * aspectRatio;
      } else {
        canvasHeight = containerData.width / aspectRatio;
      }
    } else if (viewMode === 3) {
      canvasHeight = containerData.width / aspectRatio;
    } else {
      canvasWidth = containerData.height * aspectRatio;
    }
    var canvasData = {
      aspectRatio,
      naturalWidth,
      naturalHeight,
      width: canvasWidth,
      height: canvasHeight
    };
    this.canvasData = canvasData;
    this.limited = viewMode === 1 || viewMode === 2;
    this.limitCanvas(true, true);
    canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
    canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
    canvasData.left = (containerData.width - canvasData.width) / 2;
    canvasData.top = (containerData.height - canvasData.height) / 2;
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;
    this.initialCanvasData = assign({}, canvasData);
  },
  limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
    var options2 = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
    var viewMode = options2.viewMode;
    var aspectRatio = canvasData.aspectRatio;
    var cropped = this.cropped && cropBoxData;
    if (sizeLimited) {
      var minCanvasWidth = Number(options2.minCanvasWidth) || 0;
      var minCanvasHeight = Number(options2.minCanvasHeight) || 0;
      if (viewMode > 1) {
        minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
        minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
        if (viewMode === 3) {
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      } else if (viewMode > 0) {
        if (minCanvasWidth) {
          minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
        } else if (minCanvasHeight) {
          minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
        } else if (cropped) {
          minCanvasWidth = cropBoxData.width;
          minCanvasHeight = cropBoxData.height;
          if (minCanvasHeight * aspectRatio > minCanvasWidth) {
            minCanvasWidth = minCanvasHeight * aspectRatio;
          } else {
            minCanvasHeight = minCanvasWidth / aspectRatio;
          }
        }
      }
      var _getAdjustedSizes = getAdjustedSizes({
        aspectRatio,
        width: minCanvasWidth,
        height: minCanvasHeight
      });
      minCanvasWidth = _getAdjustedSizes.width;
      minCanvasHeight = _getAdjustedSizes.height;
      canvasData.minWidth = minCanvasWidth;
      canvasData.minHeight = minCanvasHeight;
      canvasData.maxWidth = Infinity;
      canvasData.maxHeight = Infinity;
    }
    if (positionLimited) {
      if (viewMode > (cropped ? 0 : 1)) {
        var newCanvasLeft = containerData.width - canvasData.width;
        var newCanvasTop = containerData.height - canvasData.height;
        canvasData.minLeft = Math.min(0, newCanvasLeft);
        canvasData.minTop = Math.min(0, newCanvasTop);
        canvasData.maxLeft = Math.max(0, newCanvasLeft);
        canvasData.maxTop = Math.max(0, newCanvasTop);
        if (cropped && this.limited) {
          canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
          canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
          canvasData.maxLeft = cropBoxData.left;
          canvasData.maxTop = cropBoxData.top;
          if (viewMode === 2) {
            if (canvasData.width >= containerData.width) {
              canvasData.minLeft = Math.min(0, newCanvasLeft);
              canvasData.maxLeft = Math.max(0, newCanvasLeft);
            }
            if (canvasData.height >= containerData.height) {
              canvasData.minTop = Math.min(0, newCanvasTop);
              canvasData.maxTop = Math.max(0, newCanvasTop);
            }
          }
        }
      } else {
        canvasData.minLeft = -canvasData.width;
        canvasData.minTop = -canvasData.height;
        canvasData.maxLeft = containerData.width;
        canvasData.maxTop = containerData.height;
      }
    }
  },
  renderCanvas: function renderCanvas(changed, transformed) {
    var canvasData = this.canvasData, imageData = this.imageData;
    if (transformed) {
      var _getRotatedSizes = getRotatedSizes({
        width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
        height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
        degree: imageData.rotate || 0
      }), naturalWidth = _getRotatedSizes.width, naturalHeight = _getRotatedSizes.height;
      var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
      var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
      canvasData.left -= (width - canvasData.width) / 2;
      canvasData.top -= (height - canvasData.height) / 2;
      canvasData.width = width;
      canvasData.height = height;
      canvasData.aspectRatio = naturalWidth / naturalHeight;
      canvasData.naturalWidth = naturalWidth;
      canvasData.naturalHeight = naturalHeight;
      this.limitCanvas(true, false);
    }
    if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) {
      canvasData.left = canvasData.oldLeft;
    }
    if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) {
      canvasData.top = canvasData.oldTop;
    }
    canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
    canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
    this.limitCanvas(false, true);
    canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
    canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
    canvasData.oldLeft = canvasData.left;
    canvasData.oldTop = canvasData.top;
    setStyle(this.canvas, assign({
      width: canvasData.width,
      height: canvasData.height
    }, getTransforms({
      translateX: canvasData.left,
      translateY: canvasData.top
    })));
    this.renderImage(changed);
    if (this.cropped && this.limited) {
      this.limitCropBox(true, true);
    }
  },
  renderImage: function renderImage(changed) {
    var canvasData = this.canvasData, imageData = this.imageData;
    var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
    var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
    assign(imageData, {
      width,
      height,
      left: (canvasData.width - width) / 2,
      top: (canvasData.height - height) / 2
    });
    setStyle(this.image, assign({
      width: imageData.width,
      height: imageData.height
    }, getTransforms(assign({
      translateX: imageData.left,
      translateY: imageData.top
    }, imageData))));
    if (changed) {
      this.output();
    }
  },
  initCropBox: function initCropBox() {
    var options2 = this.options, canvasData = this.canvasData;
    var aspectRatio = options2.aspectRatio || options2.initialAspectRatio;
    var autoCropArea = Number(options2.autoCropArea) || 0.8;
    var cropBoxData = {
      width: canvasData.width,
      height: canvasData.height
    };
    if (aspectRatio) {
      if (canvasData.height * aspectRatio > canvasData.width) {
        cropBoxData.height = cropBoxData.width / aspectRatio;
      } else {
        cropBoxData.width = cropBoxData.height * aspectRatio;
      }
    }
    this.cropBoxData = cropBoxData;
    this.limitCropBox(true, true);
    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
    cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
    cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
    cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
    cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;
    this.initialCropBoxData = assign({}, cropBoxData);
  },
  limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
    var options2 = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, limited = this.limited;
    var aspectRatio = options2.aspectRatio;
    if (sizeLimited) {
      var minCropBoxWidth = Number(options2.minCropBoxWidth) || 0;
      var minCropBoxHeight = Number(options2.minCropBoxHeight) || 0;
      var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
      var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height;
      minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
      minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
      if (aspectRatio) {
        if (minCropBoxWidth && minCropBoxHeight) {
          if (minCropBoxHeight * aspectRatio > minCropBoxWidth) {
            minCropBoxHeight = minCropBoxWidth / aspectRatio;
          } else {
            minCropBoxWidth = minCropBoxHeight * aspectRatio;
          }
        } else if (minCropBoxWidth) {
          minCropBoxHeight = minCropBoxWidth / aspectRatio;
        } else if (minCropBoxHeight) {
          minCropBoxWidth = minCropBoxHeight * aspectRatio;
        }
        if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) {
          maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
        } else {
          maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
        }
      }
      cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
      cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
      cropBoxData.maxWidth = maxCropBoxWidth;
      cropBoxData.maxHeight = maxCropBoxHeight;
    }
    if (positionLimited) {
      if (limited) {
        cropBoxData.minLeft = Math.max(0, canvasData.left);
        cropBoxData.minTop = Math.max(0, canvasData.top);
        cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
        cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
      } else {
        cropBoxData.minLeft = 0;
        cropBoxData.minTop = 0;
        cropBoxData.maxLeft = containerData.width - cropBoxData.width;
        cropBoxData.maxTop = containerData.height - cropBoxData.height;
      }
    }
  },
  renderCropBox: function renderCropBox() {
    var options2 = this.options, containerData = this.containerData, cropBoxData = this.cropBoxData;
    if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) {
      cropBoxData.left = cropBoxData.oldLeft;
    }
    if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) {
      cropBoxData.top = cropBoxData.oldTop;
    }
    cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
    cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
    this.limitCropBox(false, true);
    cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
    cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
    cropBoxData.oldLeft = cropBoxData.left;
    cropBoxData.oldTop = cropBoxData.top;
    if (options2.movable && options2.cropBoxMovable) {
      setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
    }
    setStyle(this.cropBox, assign({
      width: cropBoxData.width,
      height: cropBoxData.height
    }, getTransforms({
      translateX: cropBoxData.left,
      translateY: cropBoxData.top
    })));
    if (this.cropped && this.limited) {
      this.limitCanvas(true, true);
    }
    if (!this.disabled) {
      this.output();
    }
  },
  output: function output() {
    this.preview();
    dispatchEvent(this.element, EVENT_CROP, this.getData());
  }
};
var preview = {
  initPreview: function initPreview() {
    var element = this.element, crossOrigin = this.crossOrigin;
    var preview3 = this.options.preview;
    var url2 = crossOrigin ? this.crossOriginUrl : this.url;
    var alt = element.alt || "The image to preview";
    var image = document.createElement("img");
    if (crossOrigin) {
      image.crossOrigin = crossOrigin;
    }
    image.src = url2;
    image.alt = alt;
    this.viewBox.appendChild(image);
    this.viewBoxImage = image;
    if (!preview3) {
      return;
    }
    var previews = preview3;
    if (typeof preview3 === "string") {
      previews = element.ownerDocument.querySelectorAll(preview3);
    } else if (preview3.querySelector) {
      previews = [preview3];
    }
    this.previews = previews;
    forEach(previews, function(el) {
      var img = document.createElement("img");
      setData(el, DATA_PREVIEW, {
        width: el.offsetWidth,
        height: el.offsetHeight,
        html: el.innerHTML
      });
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.src = url2;
      img.alt = alt;
      img.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"';
      el.innerHTML = "";
      el.appendChild(img);
    });
  },
  resetPreview: function resetPreview() {
    forEach(this.previews, function(element) {
      var data2 = getData(element, DATA_PREVIEW);
      setStyle(element, {
        width: data2.width,
        height: data2.height
      });
      element.innerHTML = data2.html;
      removeData(element, DATA_PREVIEW);
    });
  },
  preview: function preview2() {
    var imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
    var cropBoxWidth = cropBoxData.width, cropBoxHeight = cropBoxData.height;
    var width = imageData.width, height = imageData.height;
    var left = cropBoxData.left - canvasData.left - imageData.left;
    var top = cropBoxData.top - canvasData.top - imageData.top;
    if (!this.cropped || this.disabled) {
      return;
    }
    setStyle(this.viewBoxImage, assign({
      width,
      height
    }, getTransforms(assign({
      translateX: -left,
      translateY: -top
    }, imageData))));
    forEach(this.previews, function(element) {
      var data2 = getData(element, DATA_PREVIEW);
      var originalWidth = data2.width;
      var originalHeight = data2.height;
      var newWidth = originalWidth;
      var newHeight = originalHeight;
      var ratio = 1;
      if (cropBoxWidth) {
        ratio = originalWidth / cropBoxWidth;
        newHeight = cropBoxHeight * ratio;
      }
      if (cropBoxHeight && newHeight > originalHeight) {
        ratio = originalHeight / cropBoxHeight;
        newWidth = cropBoxWidth * ratio;
        newHeight = originalHeight;
      }
      setStyle(element, {
        width: newWidth,
        height: newHeight
      });
      setStyle(element.getElementsByTagName("img")[0], assign({
        width: width * ratio,
        height: height * ratio
      }, getTransforms(assign({
        translateX: -left * ratio,
        translateY: -top * ratio
      }, imageData))));
    });
  }
};
var events$2 = {
  bind: function bind4() {
    var element = this.element, options2 = this.options, cropper2 = this.cropper;
    if (isFunction(options2.cropstart)) {
      addListener(element, EVENT_CROP_START, options2.cropstart);
    }
    if (isFunction(options2.cropmove)) {
      addListener(element, EVENT_CROP_MOVE, options2.cropmove);
    }
    if (isFunction(options2.cropend)) {
      addListener(element, EVENT_CROP_END, options2.cropend);
    }
    if (isFunction(options2.crop)) {
      addListener(element, EVENT_CROP, options2.crop);
    }
    if (isFunction(options2.zoom)) {
      addListener(element, EVENT_ZOOM, options2.zoom);
    }
    addListener(cropper2, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
    if (options2.zoomable && options2.zoomOnWheel) {
      addListener(cropper2, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
        passive: false,
        capture: true
      });
    }
    if (options2.toggleDragModeOnDblclick) {
      addListener(cropper2, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
    }
    addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
    addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
    if (options2.responsive) {
      addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
    }
  },
  unbind: function unbind() {
    var element = this.element, options2 = this.options, cropper2 = this.cropper;
    if (isFunction(options2.cropstart)) {
      removeListener(element, EVENT_CROP_START, options2.cropstart);
    }
    if (isFunction(options2.cropmove)) {
      removeListener(element, EVENT_CROP_MOVE, options2.cropmove);
    }
    if (isFunction(options2.cropend)) {
      removeListener(element, EVENT_CROP_END, options2.cropend);
    }
    if (isFunction(options2.crop)) {
      removeListener(element, EVENT_CROP, options2.crop);
    }
    if (isFunction(options2.zoom)) {
      removeListener(element, EVENT_ZOOM, options2.zoom);
    }
    removeListener(cropper2, EVENT_POINTER_DOWN, this.onCropStart);
    if (options2.zoomable && options2.zoomOnWheel) {
      removeListener(cropper2, EVENT_WHEEL, this.onWheel, {
        passive: false,
        capture: true
      });
    }
    if (options2.toggleDragModeOnDblclick) {
      removeListener(cropper2, EVENT_DBLCLICK, this.onDblclick);
    }
    removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
    removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
    if (options2.responsive) {
      removeListener(window, EVENT_RESIZE, this.onResize);
    }
  }
};
var handlers = {
  resize: function resize() {
    if (this.disabled) {
      return;
    }
    var options2 = this.options, container = this.container, containerData = this.containerData;
    var ratioX = container.offsetWidth / containerData.width;
    var ratioY = container.offsetHeight / containerData.height;
    var ratio = Math.abs(ratioX - 1) > Math.abs(ratioY - 1) ? ratioX : ratioY;
    if (ratio !== 1) {
      var canvasData;
      var cropBoxData;
      if (options2.restore) {
        canvasData = this.getCanvasData();
        cropBoxData = this.getCropBoxData();
      }
      this.render();
      if (options2.restore) {
        this.setCanvasData(forEach(canvasData, function(n2, i2) {
          canvasData[i2] = n2 * ratio;
        }));
        this.setCropBoxData(forEach(cropBoxData, function(n2, i2) {
          cropBoxData[i2] = n2 * ratio;
        }));
      }
    }
  },
  dblclick: function dblclick() {
    if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) {
      return;
    }
    this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
  },
  wheel: function wheel(event) {
    var _this = this;
    var ratio = Number(this.options.wheelZoomRatio) || 0.1;
    var delta = 1;
    if (this.disabled) {
      return;
    }
    event.preventDefault();
    if (this.wheeling) {
      return;
    }
    this.wheeling = true;
    setTimeout(function() {
      _this.wheeling = false;
    }, 50);
    if (event.deltaY) {
      delta = event.deltaY > 0 ? 1 : -1;
    } else if (event.wheelDelta) {
      delta = -event.wheelDelta / 120;
    } else if (event.detail) {
      delta = event.detail > 0 ? 1 : -1;
    }
    this.zoom(-delta * ratio, event);
  },
  cropStart: function cropStart(event) {
    var buttons = event.buttons, button = event.button;
    if (this.disabled || (event.type === "mousedown" || event.type === "pointerdown" && event.pointerType === "mouse") && // No primary button (Usually the left button)
    (isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 || event.ctrlKey)) {
      return;
    }
    var options2 = this.options, pointers = this.pointers;
    var action;
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      pointers[event.pointerId || 0] = getPointer(event);
    }
    if (Object.keys(pointers).length > 1 && options2.zoomable && options2.zoomOnTouch) {
      action = ACTION_ZOOM;
    } else {
      action = getData(event.target, DATA_ACTION);
    }
    if (!REGEXP_ACTIONS.test(action)) {
      return;
    }
    if (dispatchEvent(this.element, EVENT_CROP_START, {
      originalEvent: event,
      action
    }) === false) {
      return;
    }
    event.preventDefault();
    this.action = action;
    this.cropping = false;
    if (action === ACTION_CROP) {
      this.cropping = true;
      addClass(this.dragBox, CLASS_MODAL);
    }
  },
  cropMove: function cropMove(event) {
    var action = this.action;
    if (this.disabled || !action) {
      return;
    }
    var pointers = this.pointers;
    event.preventDefault();
    if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
      originalEvent: event,
      action
    }) === false) {
      return;
    }
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        assign(pointers[touch.identifier] || {}, getPointer(touch, true));
      });
    } else {
      assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
    }
    this.change(event);
  },
  cropEnd: function cropEnd(event) {
    if (this.disabled) {
      return;
    }
    var action = this.action, pointers = this.pointers;
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        delete pointers[touch.identifier];
      });
    } else {
      delete pointers[event.pointerId || 0];
    }
    if (!action) {
      return;
    }
    event.preventDefault();
    if (!Object.keys(pointers).length) {
      this.action = "";
    }
    if (this.cropping) {
      this.cropping = false;
      toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
    }
    dispatchEvent(this.element, EVENT_CROP_END, {
      originalEvent: event,
      action
    });
  }
};
var change = {
  change: function change2(event) {
    var options2 = this.options, canvasData = this.canvasData, containerData = this.containerData, cropBoxData = this.cropBoxData, pointers = this.pointers;
    var action = this.action;
    var aspectRatio = options2.aspectRatio;
    var left = cropBoxData.left, top = cropBoxData.top, width = cropBoxData.width, height = cropBoxData.height;
    var right = left + width;
    var bottom = top + height;
    var minLeft = 0;
    var minTop = 0;
    var maxWidth = containerData.width;
    var maxHeight = containerData.height;
    var renderable = true;
    var offset;
    if (!aspectRatio && event.shiftKey) {
      aspectRatio = width && height ? width / height : 1;
    }
    if (this.limited) {
      minLeft = cropBoxData.minLeft;
      minTop = cropBoxData.minTop;
      maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
      maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
    }
    var pointer = pointers[Object.keys(pointers)[0]];
    var range2 = {
      x: pointer.endX - pointer.startX,
      y: pointer.endY - pointer.startY
    };
    var check = function check2(side) {
      switch (side) {
        case ACTION_EAST:
          if (right + range2.x > maxWidth) {
            range2.x = maxWidth - right;
          }
          break;
        case ACTION_WEST:
          if (left + range2.x < minLeft) {
            range2.x = minLeft - left;
          }
          break;
        case ACTION_NORTH:
          if (top + range2.y < minTop) {
            range2.y = minTop - top;
          }
          break;
        case ACTION_SOUTH:
          if (bottom + range2.y > maxHeight) {
            range2.y = maxHeight - bottom;
          }
          break;
      }
    };
    switch (action) {
      case ACTION_ALL:
        left += range2.x;
        top += range2.y;
        break;
      case ACTION_EAST:
        if (range2.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }
        check(ACTION_EAST);
        width += range2.x;
        if (width < 0) {
          action = ACTION_WEST;
          width = -width;
          left -= width;
        }
        if (aspectRatio) {
          height = width / aspectRatio;
          top += (cropBoxData.height - height) / 2;
        }
        break;
      case ACTION_NORTH:
        if (range2.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }
        check(ACTION_NORTH);
        height -= range2.y;
        top += range2.y;
        if (height < 0) {
          action = ACTION_SOUTH;
          height = -height;
          top -= height;
        }
        if (aspectRatio) {
          width = height * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }
        break;
      case ACTION_WEST:
        if (range2.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
          renderable = false;
          break;
        }
        check(ACTION_WEST);
        width -= range2.x;
        left += range2.x;
        if (width < 0) {
          action = ACTION_EAST;
          width = -width;
          left -= width;
        }
        if (aspectRatio) {
          height = width / aspectRatio;
          top += (cropBoxData.height - height) / 2;
        }
        break;
      case ACTION_SOUTH:
        if (range2.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
          renderable = false;
          break;
        }
        check(ACTION_SOUTH);
        height += range2.y;
        if (height < 0) {
          action = ACTION_NORTH;
          height = -height;
          top -= height;
        }
        if (aspectRatio) {
          width = height * aspectRatio;
          left += (cropBoxData.width - width) / 2;
        }
        break;
      case ACTION_NORTH_EAST:
        if (aspectRatio) {
          if (range2.y <= 0 && (top <= minTop || right >= maxWidth)) {
            renderable = false;
            break;
          }
          check(ACTION_NORTH);
          height -= range2.y;
          top += range2.y;
          width = height * aspectRatio;
        } else {
          check(ACTION_NORTH);
          check(ACTION_EAST);
          if (range2.x >= 0) {
            if (right < maxWidth) {
              width += range2.x;
            } else if (range2.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width += range2.x;
          }
          if (range2.y <= 0) {
            if (top > minTop) {
              height -= range2.y;
              top += range2.y;
            }
          } else {
            height -= range2.y;
            top += range2.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_SOUTH_WEST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_WEST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_SOUTH_EAST;
          height = -height;
          top -= height;
        }
        break;
      case ACTION_NORTH_WEST:
        if (aspectRatio) {
          if (range2.y <= 0 && (top <= minTop || left <= minLeft)) {
            renderable = false;
            break;
          }
          check(ACTION_NORTH);
          height -= range2.y;
          top += range2.y;
          width = height * aspectRatio;
          left += cropBoxData.width - width;
        } else {
          check(ACTION_NORTH);
          check(ACTION_WEST);
          if (range2.x <= 0) {
            if (left > minLeft) {
              width -= range2.x;
              left += range2.x;
            } else if (range2.y <= 0 && top <= minTop) {
              renderable = false;
            }
          } else {
            width -= range2.x;
            left += range2.x;
          }
          if (range2.y <= 0) {
            if (top > minTop) {
              height -= range2.y;
              top += range2.y;
            }
          } else {
            height -= range2.y;
            top += range2.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_SOUTH_EAST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_NORTH_EAST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_SOUTH_WEST;
          height = -height;
          top -= height;
        }
        break;
      case ACTION_SOUTH_WEST:
        if (aspectRatio) {
          if (range2.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
            renderable = false;
            break;
          }
          check(ACTION_WEST);
          width -= range2.x;
          left += range2.x;
          height = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_WEST);
          if (range2.x <= 0) {
            if (left > minLeft) {
              width -= range2.x;
              left += range2.x;
            } else if (range2.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width -= range2.x;
            left += range2.x;
          }
          if (range2.y >= 0) {
            if (bottom < maxHeight) {
              height += range2.y;
            }
          } else {
            height += range2.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_NORTH_EAST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_EAST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_NORTH_WEST;
          height = -height;
          top -= height;
        }
        break;
      case ACTION_SOUTH_EAST:
        if (aspectRatio) {
          if (range2.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
            renderable = false;
            break;
          }
          check(ACTION_EAST);
          width += range2.x;
          height = width / aspectRatio;
        } else {
          check(ACTION_SOUTH);
          check(ACTION_EAST);
          if (range2.x >= 0) {
            if (right < maxWidth) {
              width += range2.x;
            } else if (range2.y >= 0 && bottom >= maxHeight) {
              renderable = false;
            }
          } else {
            width += range2.x;
          }
          if (range2.y >= 0) {
            if (bottom < maxHeight) {
              height += range2.y;
            }
          } else {
            height += range2.y;
          }
        }
        if (width < 0 && height < 0) {
          action = ACTION_NORTH_WEST;
          height = -height;
          width = -width;
          top -= height;
          left -= width;
        } else if (width < 0) {
          action = ACTION_SOUTH_WEST;
          width = -width;
          left -= width;
        } else if (height < 0) {
          action = ACTION_NORTH_EAST;
          height = -height;
          top -= height;
        }
        break;
      case ACTION_MOVE:
        this.move(range2.x, range2.y);
        renderable = false;
        break;
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), event);
        renderable = false;
        break;
      case ACTION_CROP:
        if (!range2.x || !range2.y) {
          renderable = false;
          break;
        }
        offset = getOffset(this.cropper);
        left = pointer.startX - offset.left;
        top = pointer.startY - offset.top;
        width = cropBoxData.minWidth;
        height = cropBoxData.minHeight;
        if (range2.x > 0) {
          action = range2.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
        } else if (range2.x < 0) {
          left -= width;
          action = range2.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
        }
        if (range2.y < 0) {
          top -= height;
        }
        if (!this.cropped) {
          removeClass(this.cropBox, CLASS_HIDDEN);
          this.cropped = true;
          if (this.limited) {
            this.limitCropBox(true, true);
          }
        }
        break;
    }
    if (renderable) {
      cropBoxData.width = width;
      cropBoxData.height = height;
      cropBoxData.left = left;
      cropBoxData.top = top;
      this.action = action;
      this.renderCropBox();
    }
    forEach(pointers, function(p2) {
      p2.startX = p2.endX;
      p2.startY = p2.endY;
    });
  }
};
var methods = {
  // Show the crop box manually
  crop: function crop() {
    if (this.ready && !this.cropped && !this.disabled) {
      this.cropped = true;
      this.limitCropBox(true, true);
      if (this.options.modal) {
        addClass(this.dragBox, CLASS_MODAL);
      }
      removeClass(this.cropBox, CLASS_HIDDEN);
      this.setCropBoxData(this.initialCropBoxData);
    }
    return this;
  },
  // Reset the image and crop box to their initial states
  reset: function reset() {
    if (this.ready && !this.disabled) {
      this.imageData = assign({}, this.initialImageData);
      this.canvasData = assign({}, this.initialCanvasData);
      this.cropBoxData = assign({}, this.initialCropBoxData);
      this.renderCanvas();
      if (this.cropped) {
        this.renderCropBox();
      }
    }
    return this;
  },
  // Clear the crop box
  clear: function clear3() {
    if (this.cropped && !this.disabled) {
      assign(this.cropBoxData, {
        left: 0,
        top: 0,
        width: 0,
        height: 0
      });
      this.cropped = false;
      this.renderCropBox();
      this.limitCanvas(true, true);
      this.renderCanvas();
      removeClass(this.dragBox, CLASS_MODAL);
      addClass(this.cropBox, CLASS_HIDDEN);
    }
    return this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function replace(url2) {
    var hasSameSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!this.disabled && url2) {
      if (this.isImg) {
        this.element.src = url2;
      }
      if (hasSameSize) {
        this.url = url2;
        this.image.src = url2;
        if (this.ready) {
          this.viewBoxImage.src = url2;
          forEach(this.previews, function(element) {
            element.getElementsByTagName("img")[0].src = url2;
          });
        }
      } else {
        if (this.isImg) {
          this.replaced = true;
        }
        this.options.data = null;
        this.uncreate();
        this.load(url2);
      }
    }
    return this;
  },
  // Enable (unfreeze) the cropper
  enable: function enable3() {
    if (this.ready && this.disabled) {
      this.disabled = false;
      removeClass(this.cropper, CLASS_DISABLED);
    }
    return this;
  },
  // Disable (freeze) the cropper
  disable: function disable2() {
    if (this.ready && !this.disabled) {
      this.disabled = true;
      addClass(this.cropper, CLASS_DISABLED);
    }
    return this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function destroy() {
    var element = this.element;
    if (!element[NAMESPACE]) {
      return this;
    }
    element[NAMESPACE] = void 0;
    if (this.isImg && this.replaced) {
      element.src = this.originalUrl;
    }
    this.uncreate();
    return this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function move(offsetX) {
    var offsetY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : offsetX;
    var _this$canvasData = this.canvasData, left = _this$canvasData.left, top = _this$canvasData.top;
    return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function moveTo(x2) {
    var y2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x2;
    var canvasData = this.canvasData;
    var changed = false;
    x2 = Number(x2);
    y2 = Number(y2);
    if (this.ready && !this.disabled && this.options.movable) {
      if (isNumber(x2)) {
        canvasData.left = x2;
        changed = true;
      }
      if (isNumber(y2)) {
        canvasData.top = y2;
        changed = true;
      }
      if (changed) {
        this.renderCanvas(true);
      }
    }
    return this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function zoom(ratio, _originalEvent) {
    var canvasData = this.canvasData;
    ratio = Number(ratio);
    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }
    return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
    var options2 = this.options, canvasData = this.canvasData;
    var width = canvasData.width, height = canvasData.height, naturalWidth = canvasData.naturalWidth, naturalHeight = canvasData.naturalHeight;
    ratio = Number(ratio);
    if (ratio >= 0 && this.ready && !this.disabled && options2.zoomable) {
      var newWidth = naturalWidth * ratio;
      var newHeight = naturalHeight * ratio;
      if (dispatchEvent(this.element, EVENT_ZOOM, {
        ratio,
        oldRatio: width / naturalWidth,
        originalEvent: _originalEvent
      }) === false) {
        return this;
      }
      if (_originalEvent) {
        var pointers = this.pointers;
        var offset = getOffset(this.cropper);
        var center2 = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };
        canvasData.left -= (newWidth - width) * ((center2.pageX - offset.left - canvasData.left) / width);
        canvasData.top -= (newHeight - height) * ((center2.pageY - offset.top - canvasData.top) / height);
      } else if (isPlainObject$1(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
        canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
        canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
      } else {
        canvasData.left -= (newWidth - width) / 2;
        canvasData.top -= (newHeight - height) / 2;
      }
      canvasData.width = newWidth;
      canvasData.height = newHeight;
      this.renderCanvas(true);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function rotate2(degree) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function rotateTo(degree) {
    degree = Number(degree);
    if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
      this.imageData.rotate = degree % 360;
      this.renderCanvas(true, true);
    }
    return this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function scaleX2(_scaleX) {
    var scaleY3 = this.imageData.scaleY;
    return this.scale(_scaleX, isNumber(scaleY3) ? scaleY3 : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function scaleY2(_scaleY) {
    var scaleX3 = this.imageData.scaleX;
    return this.scale(isNumber(scaleX3) ? scaleX3 : 1, _scaleY);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function scale4(scaleX3) {
    var scaleY3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scaleX3;
    var imageData = this.imageData;
    var transformed = false;
    scaleX3 = Number(scaleX3);
    scaleY3 = Number(scaleY3);
    if (this.ready && !this.disabled && this.options.scalable) {
      if (isNumber(scaleX3)) {
        imageData.scaleX = scaleX3;
        transformed = true;
      }
      if (isNumber(scaleY3)) {
        imageData.scaleY = scaleY3;
        transformed = true;
      }
      if (transformed) {
        this.renderCanvas(true, true);
      }
    }
    return this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function getData5() {
    var rounded = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var options2 = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
    var data2;
    if (this.ready && this.cropped) {
      data2 = {
        x: cropBoxData.left - canvasData.left,
        y: cropBoxData.top - canvasData.top,
        width: cropBoxData.width,
        height: cropBoxData.height
      };
      var ratio = imageData.width / imageData.naturalWidth;
      forEach(data2, function(n2, i2) {
        data2[i2] = n2 / ratio;
      });
      if (rounded) {
        var bottom = Math.round(data2.y + data2.height);
        var right = Math.round(data2.x + data2.width);
        data2.x = Math.round(data2.x);
        data2.y = Math.round(data2.y);
        data2.width = right - data2.x;
        data2.height = bottom - data2.y;
      }
    } else {
      data2 = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    }
    if (options2.rotatable) {
      data2.rotate = imageData.rotate || 0;
    }
    if (options2.scalable) {
      data2.scaleX = imageData.scaleX || 1;
      data2.scaleY = imageData.scaleY || 1;
    }
    return data2;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function setData5(data2) {
    var options2 = this.options, imageData = this.imageData, canvasData = this.canvasData;
    var cropBoxData = {};
    if (this.ready && !this.disabled && isPlainObject$1(data2)) {
      var transformed = false;
      if (options2.rotatable) {
        if (isNumber(data2.rotate) && data2.rotate !== imageData.rotate) {
          imageData.rotate = data2.rotate;
          transformed = true;
        }
      }
      if (options2.scalable) {
        if (isNumber(data2.scaleX) && data2.scaleX !== imageData.scaleX) {
          imageData.scaleX = data2.scaleX;
          transformed = true;
        }
        if (isNumber(data2.scaleY) && data2.scaleY !== imageData.scaleY) {
          imageData.scaleY = data2.scaleY;
          transformed = true;
        }
      }
      if (transformed) {
        this.renderCanvas(true, true);
      }
      var ratio = imageData.width / imageData.naturalWidth;
      if (isNumber(data2.x)) {
        cropBoxData.left = data2.x * ratio + canvasData.left;
      }
      if (isNumber(data2.y)) {
        cropBoxData.top = data2.y * ratio + canvasData.top;
      }
      if (isNumber(data2.width)) {
        cropBoxData.width = data2.width * ratio;
      }
      if (isNumber(data2.height)) {
        cropBoxData.height = data2.height * ratio;
      }
      this.setCropBoxData(cropBoxData);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function getContainerData() {
    return this.ready ? assign({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function getImageData2() {
    return this.sized ? assign({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function getCanvasData() {
    var canvasData = this.canvasData;
    var data2 = {};
    if (this.ready) {
      forEach(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(n2) {
        data2[n2] = canvasData[n2];
      });
    }
    return data2;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function setCanvasData(data2) {
    var canvasData = this.canvasData;
    var aspectRatio = canvasData.aspectRatio;
    if (this.ready && !this.disabled && isPlainObject$1(data2)) {
      if (isNumber(data2.left)) {
        canvasData.left = data2.left;
      }
      if (isNumber(data2.top)) {
        canvasData.top = data2.top;
      }
      if (isNumber(data2.width)) {
        canvasData.width = data2.width;
        canvasData.height = data2.width / aspectRatio;
      } else if (isNumber(data2.height)) {
        canvasData.height = data2.height;
        canvasData.width = data2.height * aspectRatio;
      }
      this.renderCanvas(true);
    }
    return this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function getCropBoxData() {
    var cropBoxData = this.cropBoxData;
    var data2;
    if (this.ready && this.cropped) {
      data2 = {
        left: cropBoxData.left,
        top: cropBoxData.top,
        width: cropBoxData.width,
        height: cropBoxData.height
      };
    }
    return data2 || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function setCropBoxData(data2) {
    var cropBoxData = this.cropBoxData;
    var aspectRatio = this.options.aspectRatio;
    var widthChanged;
    var heightChanged;
    if (this.ready && this.cropped && !this.disabled && isPlainObject$1(data2)) {
      if (isNumber(data2.left)) {
        cropBoxData.left = data2.left;
      }
      if (isNumber(data2.top)) {
        cropBoxData.top = data2.top;
      }
      if (isNumber(data2.width) && data2.width !== cropBoxData.width) {
        widthChanged = true;
        cropBoxData.width = data2.width;
      }
      if (isNumber(data2.height) && data2.height !== cropBoxData.height) {
        heightChanged = true;
        cropBoxData.height = data2.height;
      }
      if (aspectRatio) {
        if (widthChanged) {
          cropBoxData.height = cropBoxData.width / aspectRatio;
        } else if (heightChanged) {
          cropBoxData.width = cropBoxData.height * aspectRatio;
        }
      }
      this.renderCropBox();
    }
    return this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function getCroppedCanvas() {
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement) {
      return null;
    }
    var canvasData = this.canvasData;
    var source = getSourceCanvas(this.image, this.imageData, canvasData, options2);
    if (!this.cropped) {
      return source;
    }
    var _this$getData = this.getData(options2.rounded), initialX = _this$getData.x, initialY = _this$getData.y, initialWidth = _this$getData.width, initialHeight = _this$getData.height;
    var ratio = source.width / Math.floor(canvasData.naturalWidth);
    if (ratio !== 1) {
      initialX *= ratio;
      initialY *= ratio;
      initialWidth *= ratio;
      initialHeight *= ratio;
    }
    var aspectRatio = initialWidth / initialHeight;
    var maxSizes = getAdjustedSizes({
      aspectRatio,
      width: options2.maxWidth || Infinity,
      height: options2.maxHeight || Infinity
    });
    var minSizes = getAdjustedSizes({
      aspectRatio,
      width: options2.minWidth || 0,
      height: options2.minHeight || 0
    }, "cover");
    var _getAdjustedSizes = getAdjustedSizes({
      aspectRatio,
      width: options2.width || (ratio !== 1 ? source.width : initialWidth),
      height: options2.height || (ratio !== 1 ? source.height : initialHeight)
    }), width = _getAdjustedSizes.width, height = _getAdjustedSizes.height;
    width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
    height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
    var canvas2 = document.createElement("canvas");
    var context2 = canvas2.getContext("2d");
    canvas2.width = normalizeDecimalNumber(width);
    canvas2.height = normalizeDecimalNumber(height);
    context2.fillStyle = options2.fillColor || "transparent";
    context2.fillRect(0, 0, width, height);
    var _options$imageSmoothi = options2.imageSmoothingEnabled, imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi, imageSmoothingQuality = options2.imageSmoothingQuality;
    context2.imageSmoothingEnabled = imageSmoothingEnabled;
    if (imageSmoothingQuality) {
      context2.imageSmoothingQuality = imageSmoothingQuality;
    }
    var sourceWidth = source.width;
    var sourceHeight = source.height;
    var srcX = initialX;
    var srcY = initialY;
    var srcWidth;
    var srcHeight;
    var dstX;
    var dstY;
    var dstWidth;
    var dstHeight;
    if (srcX <= -initialWidth || srcX > sourceWidth) {
      srcX = 0;
      srcWidth = 0;
      dstX = 0;
      dstWidth = 0;
    } else if (srcX <= 0) {
      dstX = -srcX;
      srcX = 0;
      srcWidth = Math.min(sourceWidth, initialWidth + srcX);
      dstWidth = srcWidth;
    } else if (srcX <= sourceWidth) {
      dstX = 0;
      srcWidth = Math.min(initialWidth, sourceWidth - srcX);
      dstWidth = srcWidth;
    }
    if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
      srcY = 0;
      srcHeight = 0;
      dstY = 0;
      dstHeight = 0;
    } else if (srcY <= 0) {
      dstY = -srcY;
      srcY = 0;
      srcHeight = Math.min(sourceHeight, initialHeight + srcY);
      dstHeight = srcHeight;
    } else if (srcY <= sourceHeight) {
      dstY = 0;
      srcHeight = Math.min(initialHeight, sourceHeight - srcY);
      dstHeight = srcHeight;
    }
    var params2 = [srcX, srcY, srcWidth, srcHeight];
    if (dstWidth > 0 && dstHeight > 0) {
      var scale5 = width / initialWidth;
      params2.push(dstX * scale5, dstY * scale5, dstWidth * scale5, dstHeight * scale5);
    }
    context2.drawImage.apply(context2, [source].concat(_toConsumableArray(params2.map(function(param) {
      return Math.floor(normalizeDecimalNumber(param));
    }))));
    return canvas2;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function setAspectRatio(aspectRatio) {
    var options2 = this.options;
    if (!this.disabled && !isUndefined(aspectRatio)) {
      options2.aspectRatio = Math.max(0, aspectRatio) || NaN;
      if (this.ready) {
        this.initCropBox();
        if (this.cropped) {
          this.renderCropBox();
        }
      }
    }
    return this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function setDragMode(mode2) {
    var options2 = this.options, dragBox = this.dragBox, face = this.face;
    if (this.ready && !this.disabled) {
      var croppable = mode2 === DRAG_MODE_CROP;
      var movable = options2.movable && mode2 === DRAG_MODE_MOVE;
      mode2 = croppable || movable ? mode2 : DRAG_MODE_NONE;
      options2.dragMode = mode2;
      setData(dragBox, DATA_ACTION, mode2);
      toggleClass(dragBox, CLASS_CROP, croppable);
      toggleClass(dragBox, CLASS_MOVE, movable);
      if (!options2.cropBoxMovable) {
        setData(face, DATA_ACTION, mode2);
        toggleClass(face, CLASS_CROP, croppable);
        toggleClass(face, CLASS_MOVE, movable);
      }
    }
    return this;
  }
};
var AnotherCropper = WINDOW.Cropper;
var Cropper$1 = /* @__PURE__ */ function() {
  function Cropper2(element) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck$1(this, Cropper2);
    if (!element || !REGEXP_TAG_NAME.test(element.tagName)) {
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    }
    this.element = element;
    this.options = assign({}, DEFAULTS$1, isPlainObject$1(options2) && options2);
    this.cropped = false;
    this.disabled = false;
    this.pointers = {};
    this.ready = false;
    this.reloading = false;
    this.replaced = false;
    this.sized = false;
    this.sizing = false;
    this.init();
  }
  _createClass$1(Cropper2, [{
    key: "init",
    value: function init9() {
      var element = this.element;
      var tagName = element.tagName.toLowerCase();
      var url2;
      if (element[NAMESPACE]) {
        return;
      }
      element[NAMESPACE] = this;
      if (tagName === "img") {
        this.isImg = true;
        url2 = element.getAttribute("src") || "";
        this.originalUrl = url2;
        if (!url2) {
          return;
        }
        url2 = element.src;
      } else if (tagName === "canvas" && window.HTMLCanvasElement) {
        url2 = element.toDataURL();
      }
      this.load(url2);
    }
  }, {
    key: "load",
    value: function load2(url2) {
      var _this = this;
      if (!url2) {
        return;
      }
      this.url = url2;
      this.imageData = {};
      var element = this.element, options2 = this.options;
      if (!options2.rotatable && !options2.scalable) {
        options2.checkOrientation = false;
      }
      if (!options2.checkOrientation || !window.ArrayBuffer) {
        this.clone();
        return;
      }
      if (REGEXP_DATA_URL.test(url2)) {
        if (REGEXP_DATA_URL_JPEG.test(url2)) {
          this.read(dataURLToArrayBuffer(url2));
        } else {
          this.clone();
        }
        return;
      }
      var xhr = new XMLHttpRequest();
      var clone8 = this.clone.bind(this);
      this.reloading = true;
      this.xhr = xhr;
      xhr.onabort = clone8;
      xhr.onerror = clone8;
      xhr.ontimeout = clone8;
      xhr.onprogress = function() {
        if (xhr.getResponseHeader("content-type") !== MIME_TYPE_JPEG) {
          xhr.abort();
        }
      };
      xhr.onload = function() {
        _this.read(xhr.response);
      };
      xhr.onloadend = function() {
        _this.reloading = false;
        _this.xhr = null;
      };
      if (options2.checkCrossOrigin && isCrossOriginURL(url2) && element.crossOrigin) {
        url2 = addTimestamp(url2);
      }
      xhr.open("GET", url2, true);
      xhr.responseType = "arraybuffer";
      xhr.withCredentials = element.crossOrigin === "use-credentials";
      xhr.send();
    }
  }, {
    key: "read",
    value: function read4(arrayBuffer2) {
      var options2 = this.options, imageData = this.imageData;
      var orientation2 = resetAndGetOrientation(arrayBuffer2);
      var rotate3 = 0;
      var scaleX3 = 1;
      var scaleY3 = 1;
      if (orientation2 > 1) {
        this.url = arrayBufferToDataURL(arrayBuffer2, MIME_TYPE_JPEG);
        var _parseOrientation = parseOrientation(orientation2);
        rotate3 = _parseOrientation.rotate;
        scaleX3 = _parseOrientation.scaleX;
        scaleY3 = _parseOrientation.scaleY;
      }
      if (options2.rotatable) {
        imageData.rotate = rotate3;
      }
      if (options2.scalable) {
        imageData.scaleX = scaleX3;
        imageData.scaleY = scaleY3;
      }
      this.clone();
    }
  }, {
    key: "clone",
    value: function clone8() {
      var element = this.element, url2 = this.url;
      var crossOrigin = element.crossOrigin;
      var crossOriginUrl = url2;
      if (this.options.checkCrossOrigin && isCrossOriginURL(url2)) {
        if (!crossOrigin) {
          crossOrigin = "anonymous";
        }
        crossOriginUrl = addTimestamp(url2);
      }
      this.crossOrigin = crossOrigin;
      this.crossOriginUrl = crossOriginUrl;
      var image = document.createElement("img");
      if (crossOrigin) {
        image.crossOrigin = crossOrigin;
      }
      image.src = crossOriginUrl || url2;
      image.alt = element.alt || "The image to crop";
      this.image = image;
      image.onload = this.start.bind(this);
      image.onerror = this.stop.bind(this);
      addClass(image, CLASS_HIDE);
      element.parentNode.insertBefore(image, element.nextSibling);
    }
  }, {
    key: "start",
    value: function start2() {
      var _this2 = this;
      var image = this.image;
      image.onload = null;
      image.onerror = null;
      this.sizing = true;
      var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
      var done = function done2(naturalWidth, naturalHeight) {
        assign(_this2.imageData, {
          naturalWidth,
          naturalHeight,
          aspectRatio: naturalWidth / naturalHeight
        });
        _this2.initialImageData = assign({}, _this2.imageData);
        _this2.sizing = false;
        _this2.sized = true;
        _this2.build();
      };
      if (image.naturalWidth && !isIOSWebKit) {
        done(image.naturalWidth, image.naturalHeight);
        return;
      }
      var sizingImage = document.createElement("img");
      var body = document.body || document.documentElement;
      this.sizingImage = sizingImage;
      sizingImage.onload = function() {
        done(sizingImage.width, sizingImage.height);
        if (!isIOSWebKit) {
          body.removeChild(sizingImage);
        }
      };
      sizingImage.src = image.src;
      if (!isIOSWebKit) {
        sizingImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
        body.appendChild(sizingImage);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var image = this.image;
      image.onload = null;
      image.onerror = null;
      image.parentNode.removeChild(image);
      this.image = null;
    }
  }, {
    key: "build",
    value: function build5() {
      if (!this.sized || this.ready) {
        return;
      }
      var element = this.element, options2 = this.options, image = this.image;
      var container = element.parentNode;
      var template = document.createElement("div");
      template.innerHTML = TEMPLATE;
      var cropper2 = template.querySelector(".".concat(NAMESPACE, "-container"));
      var canvas2 = cropper2.querySelector(".".concat(NAMESPACE, "-canvas"));
      var dragBox = cropper2.querySelector(".".concat(NAMESPACE, "-drag-box"));
      var cropBox = cropper2.querySelector(".".concat(NAMESPACE, "-crop-box"));
      var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
      this.container = container;
      this.cropper = cropper2;
      this.canvas = canvas2;
      this.dragBox = dragBox;
      this.cropBox = cropBox;
      this.viewBox = cropper2.querySelector(".".concat(NAMESPACE, "-view-box"));
      this.face = face;
      canvas2.appendChild(image);
      addClass(element, CLASS_HIDDEN);
      container.insertBefore(cropper2, element.nextSibling);
      removeClass(image, CLASS_HIDE);
      this.initPreview();
      this.bind();
      options2.initialAspectRatio = Math.max(0, options2.initialAspectRatio) || NaN;
      options2.aspectRatio = Math.max(0, options2.aspectRatio) || NaN;
      options2.viewMode = Math.max(0, Math.min(3, Math.round(options2.viewMode))) || 0;
      addClass(cropBox, CLASS_HIDDEN);
      if (!options2.guides) {
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
      }
      if (!options2.center) {
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
      }
      if (options2.background) {
        addClass(cropper2, "".concat(NAMESPACE, "-bg"));
      }
      if (!options2.highlight) {
        addClass(face, CLASS_INVISIBLE);
      }
      if (options2.cropBoxMovable) {
        addClass(face, CLASS_MOVE);
        setData(face, DATA_ACTION, ACTION_ALL);
      }
      if (!options2.cropBoxResizable) {
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
      }
      this.render();
      this.ready = true;
      this.setDragMode(options2.dragMode);
      if (options2.autoCrop) {
        this.crop();
      }
      this.setData(options2.data);
      if (isFunction(options2.ready)) {
        addListener(element, EVENT_READY, options2.ready, {
          once: true
        });
      }
      dispatchEvent(element, EVENT_READY);
    }
  }, {
    key: "unbuild",
    value: function unbuild() {
      if (!this.ready) {
        return;
      }
      this.ready = false;
      this.unbind();
      this.resetPreview();
      var parentNode = this.cropper.parentNode;
      if (parentNode) {
        parentNode.removeChild(this.cropper);
      }
      removeClass(this.element, CLASS_HIDDEN);
    }
  }, {
    key: "uncreate",
    value: function uncreate() {
      if (this.ready) {
        this.unbuild();
        this.ready = false;
        this.cropped = false;
      } else if (this.sizing) {
        this.sizingImage.onload = null;
        this.sizing = false;
        this.sized = false;
      } else if (this.reloading) {
        this.xhr.onabort = null;
        this.xhr.abort();
      } else if (this.image) {
        this.stop();
      }
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function noConflict() {
      window.Cropper = AnotherCropper;
      return Cropper2;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function setDefaults(options2) {
      assign(DEFAULTS$1, isPlainObject$1(options2) && options2);
    }
  }]);
  return Cropper2;
}();
assign(Cropper$1.prototype, render, preview, events$2, handlers, change, methods);
var n = function() {
  return n = Object.assign || function(e3) {
    for (var r2, o2 = 1, t2 = arguments.length; o2 < t2; o2++)
      for (var n2 in r2 = arguments[o2])
        Object.prototype.hasOwnProperty.call(r2, n2) && (e3[n2] = r2[n2]);
    return e3;
  }, n.apply(this, arguments);
};
function a(e3, r2) {
  var o2 = {};
  for (var t2 in e3)
    Object.prototype.hasOwnProperty.call(e3, t2) && r2.indexOf(t2) < 0 && (o2[t2] = e3[t2]);
  if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
    var n2 = 0;
    for (t2 = Object.getOwnPropertySymbols(e3); n2 < t2.length; n2++)
      r2.indexOf(t2[n2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, t2[n2]) && (o2[t2[n2]] = e3[t2[n2]]);
  }
  return o2;
}
var c = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], i$1 = { opacity: 0, maxWidth: "100%" }, l = React__default.forwardRef(function(l2, s2) {
  var u2 = a(l2, []), p2 = u2.dragMode, d2 = void 0 === p2 ? "crop" : p2, v5 = u2.src, f2 = u2.style, m2 = u2.className, g2 = u2.crossOrigin, y2 = u2.scaleX, b2 = u2.scaleY, h2 = u2.enable, O2 = u2.zoomTo, T2 = u2.rotateTo, z2 = u2.alt, C2 = void 0 === z2 ? "picture" : z2, w2 = u2.ready, x2 = u2.onInitialized, j2 = a(u2, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), M2 = { scaleY: b2, scaleX: y2, enable: h2, zoomTo: O2, rotateTo: T2 }, E3 = function() {
    for (var o2 = [], t2 = 0; t2 < arguments.length; t2++)
      o2[t2] = arguments[t2];
    var n2 = useRef(null);
    return React__default.useEffect(function() {
      o2.forEach(function(e3) {
        e3 && ("function" == typeof e3 ? e3(n2.current) : e3.current = n2.current);
      });
    }, [o2]), n2;
  }(s2, useRef(null));
  useEffect(function() {
    var e3;
    (null === (e3 = E3.current) || void 0 === e3 ? void 0 : e3.cropper) && "number" == typeof O2 && E3.current.cropper.zoomTo(O2);
  }, [u2.zoomTo]), useEffect(function() {
    var e3;
    (null === (e3 = E3.current) || void 0 === e3 ? void 0 : e3.cropper) && void 0 !== v5 && E3.current.cropper.reset().clear().replace(v5);
  }, [v5]), useEffect(function() {
    if (null !== E3.current) {
      var e3 = new Cropper$1(E3.current, n(n({ dragMode: d2 }, j2), { ready: function(e4) {
        null !== e4.currentTarget && function(e5, r2) {
          void 0 === r2 && (r2 = {});
          var o2 = r2.enable, t2 = void 0 === o2 || o2, n2 = r2.scaleX, a2 = void 0 === n2 ? 1 : n2, c2 = r2.scaleY, i2 = void 0 === c2 ? 1 : c2, l3 = r2.zoomTo, s3 = void 0 === l3 ? 0 : l3, u3 = r2.rotateTo;
          t2 ? e5.enable() : e5.disable(), e5.scaleX(a2), e5.scaleY(i2), void 0 !== u3 && e5.rotateTo(u3), s3 > 0 && e5.zoomTo(s3);
        }(e4.currentTarget.cropper, M2), w2 && w2(e4);
      } }));
      x2 && x2(e3);
    }
    return function() {
      var e4, r2;
      null === (r2 = null === (e4 = E3.current) || void 0 === e4 ? void 0 : e4.cropper) || void 0 === r2 || r2.destroy();
    };
  }, [E3]);
  var R2 = function(e3) {
    return c.reduce(function(e4, r2) {
      var o2 = e4, t2 = r2;
      return o2[t2], a(o2, ["symbol" == typeof t2 ? t2 : t2 + ""]);
    }, e3);
  }(n(n({}, j2), { crossOrigin: g2, src: v5, alt: C2 }));
  return React__default.createElement("div", { style: f2, className: m2 }, React__default.createElement("img", n({}, R2, { style: i$1, ref: E3 })));
});
const cropper = "";
function RectangularCropper(props) {
  const {
    src: src2,
    onCrop: onChange,
    style: style2
  } = props;
  const cropperRef = React__default.useRef(null);
  const getCuratedPoints = React__default.useCallback(() => {
    var _a3;
    const cropper2 = (_a3 = cropperRef.current) == null ? void 0 : _a3.cropper;
    if (!(cropper2 == null ? void 0 : cropper2.cropBoxData))
      return [];
    const {
      width,
      height,
      top,
      left
    } = cropper2.cropBoxData;
    return [[left, top], [left + width, top], [left + width, top + height], [left, top + height]];
  }, []);
  const onCrop = React__default.useCallback(() => {
    var _a3;
    const cropper2 = (_a3 = cropperRef.current) == null ? void 0 : _a3.cropper;
    if (!cropper2)
      return;
    const croppedImage = cropper2.getCroppedCanvas().toDataURL();
    onChange({
      image: croppedImage,
      points: getCuratedPoints()
    });
  }, [getCuratedPoints, onChange]);
  if (!src2)
    return null;
  return /* @__PURE__ */ jsx(l, { src: src2, style: style2, crop: onCrop, ref: cropperRef });
}
RectangularCropper.propTypes = {
  src: propTypesExports$1.string,
  onCrop: propTypesExports$1.func,
  style: propTypesExports$1.object
};
RectangularCropper.defaultProps = {
  src: "",
  onCrop: () => {
  },
  style: {}
};
const {
  useToken: useToken$t
} = theme$2;
const MODES$1 = [{
  mode: "polygon",
  title: "Polygon",
  icon: Icons.PolygonData
}, {
  mode: "rectangle",
  title: "Rectangle",
  icon: Icons.RectangleDraw
}];
function CropperMenu(props) {
  const {
    placement,
    marginHorizontal,
    marginVertical,
    setCropperType,
    cropperType,
    hidden,
    disabled
  } = props;
  const {
    token
  } = useToken$t();
  const {
    iconStyle,
    selectedStyle,
    toolButtonStyle
  } = React__default.useMemo(() => {
    const toolItemCommon = {
      backgroundColor: token.colorBgContainer,
      width: "32px",
      height: "32px",
      borderRadius: "6px",
      border: `1px solid ${token.colorBorderSecondary}`
    };
    const selectedStyle2 = {
      ...toolItemCommon,
      textOverflow: "clip",
      backgroundColor: token.colorPrimary,
      border: `1px solid ${token.colorPrimary}`
    };
    const toolButtonStyle2 = {
      ...toolItemCommon,
      textOverflow: "clip"
    };
    const iconStyle2 = {
      fontSize: "16px",
      color: token == null ? void 0 : token.colorText,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%"
    };
    return {
      iconStyle: iconStyle2,
      toolButtonStyle: toolButtonStyle2,
      selectedStyle: selectedStyle2
    };
  }, [token == null ? void 0 : token.colorBgContainer, token == null ? void 0 : token.colorBorderSecondary, token == null ? void 0 : token.colorPrimary, token == null ? void 0 : token.colorText]);
  const menuItems = React__default.useMemo(() => MODES$1.map((item) => {
    if (hidden[item.mode]) {
      return null;
    }
    return {
      key: item.mode,
      icon: /* @__PURE__ */ jsx(Tooltip$1, { placement: "left", trigger: "hover", title: item.title, arrow: false, align: {
        offset: [-18, 0]
      }, children: /* @__PURE__ */ jsx(item.icon, { style: {
        ...iconStyle
      } }) }),
      style: cropperType === item.mode ? {
        ...selectedStyle
      } : {
        ...toolButtonStyle
      },
      disabled: disabled[item.mode]
    };
  }), [disabled, cropperType, hidden, iconStyle, selectedStyle, toolButtonStyle]);
  return /* @__PURE__ */ jsx(OverlayPanel, { placement, width: 50, height: "243px", marginHorizontal, marginVertical, children: /* @__PURE__ */ jsx(Menu, { onClick: (e3) => {
    setCropperType(e3.key);
  }, selectedKeys: [cropperType], mode: "vertical", style: {
    width: "48px",
    backgroundColor: "transparent"
  }, items: menuItems }) });
}
CropperMenu.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  setCropperType: propTypesExports$1.func,
  cropperType: propTypesExports$1.string,
  hidden: propTypesExports$1.object,
  disabled: propTypesExports$1.object
};
CropperMenu.defaultProps = {
  cropperType: "noselect",
  placement: "top-right",
  marginHorizontal: 0,
  marginVertical: 0,
  setCropperType: () => {
  },
  hidden: {},
  disabled: {}
};
function CropperSubmit(props) {
  const {
    onDone,
    marginHorizontal,
    marginVertical
  } = props;
  return /* @__PURE__ */ jsx(OverlayPanel, { placement: "top-left", width: 232, height: 150, marginHorizontal, marginVertical, children: /* @__PURE__ */ jsx(Card, { title: "Crop Image", bordered: 0, styles: {
    header: {
      border: "none"
    },
    body: {
      padding: "0px 16px 16px 16px"
    }
  }, children: /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    width: "100%"
  }, children: [
    /* @__PURE__ */ jsx(Typography.Text, { children: "Are you done with cropping?" }),
    /* @__PURE__ */ jsx(Button, { block: true, type: "primary", onClick: () => onDone(true), children: "Submit" }),
    /* @__PURE__ */ jsx(Button, { block: true, onClick: () => onDone(false), children: "Cancel" })
  ] }) }) });
}
CropperSubmit.propTypes = {
  onDone: propTypesExports$1.func,
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
};
CropperSubmit.defaultProps = {
  onDone: () => {
  },
  marginHorizontal: 0,
  marginVertical: 0
};
function Cropper(props) {
  const {
    menuProps = {},
    enableMenu,
    enableSubmit,
    onCrop: onCropIn,
    cropperType: cropperTypeIn,
    ...restProps
  } = props;
  const [cropperType, setCropperType] = React__default.useState(cropperTypeIn);
  const [showPopup, setShowPopup] = React__default.useState(false);
  const [cropped, setCropped] = React__default.useState(null);
  const [popupPoint, setPopupPoint] = React__default.useState(null);
  const onChange = React__default.useCallback((data2) => {
    const {
      image,
      points: points2
    } = data2 || {};
    setCropped(image);
    if (enableSubmit) {
      setShowPopup(true);
      const point4 = [0, 0];
      let counter2 = 0;
      points2 == null ? void 0 : points2.forEach((cur) => {
        point4[0] += cur[0];
        if (point4[1] < cur[1]) {
          point4[1] = cur[1];
        }
        counter2 += 1;
      });
      if (counter2) {
        point4[0] /= counter2;
      }
      setPopupPoint(point4);
    } else {
      onCropIn(image);
    }
  }, [enableSubmit, onCropIn]);
  const onDone = React__default.useCallback((ok) => {
    if (ok) {
      onCropIn(cropped);
    } else {
      setCropped(null);
    }
    setShowPopup(false);
  }, [cropped, onCropIn]);
  if (!cropperType)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    cropperType === "rectangle" && /* @__PURE__ */ jsx(RectangularCropper, { onCrop: onChange, ...restProps }),
    cropperType === "polygon" && /* @__PURE__ */ jsx(PolygonalCropper, { onCrop: onChange, ...restProps }),
    enableMenu && /* @__PURE__ */ jsx(CropperMenu, { placement: "top-right", marginVertical: 140, marginHorizontal: 0, ...menuProps, setCropperType, cropperType }),
    enableSubmit && showPopup && /* @__PURE__ */ jsx(CropperSubmit, { onDone, marginHorizontal: (popupPoint == null ? void 0 : popupPoint[0]) || 0, marginVertical: (popupPoint == null ? void 0 : popupPoint[1]) || 0 })
  ] });
}
Cropper.propTypes = {
  menuProps: propTypesExports$1.object,
  onCrop: propTypesExports$1.func,
  cropperType: propTypesExports$1.oneOf(["polygon", "rectangle"]),
  enableMenu: propTypesExports$1.bool,
  enableSubmit: propTypesExports$1.bool
};
Cropper.defaultProps = {
  menuProps: {},
  onCrop: () => {
  },
  cropperType: "polygon",
  enableMenu: true,
  enableSubmit: true
};
const MENU_ITEMS = [
  {
    mode: "rotate-scale",
    title: "Edit",
    icon: Icons.ArrowCursor
  },
  {
    mode: "drag",
    title: "Drag",
    icon: Icons.AllDirection
  },
  {
    mode: "scale-manual",
    title: "Scale",
    icon: Icons.MeasureDraw
  },
  // {
  //   mode: 'skew',
  //   title: 'Skew',
  //   icon: Icons.Country,
  // },
  {
    mode: "cropper-polygon",
    title: "Crop Polygon",
    icon: Icons.PolygonData
  },
  {
    mode: "cropper-rectangle",
    title: "Crop Rectangle",
    icon: Icons.RectangleDraw
  }
];
function ImageLayer2(props) {
  const {
    id: layerId,
    sourceId: sourceIdIn,
    url: originalImageUrl,
    box: boxIn,
    editType: editTypeIn,
    onEditTypeChange: onEditTypeChangeIn,
    onChange: onChangeIn,
    opacity: opacityIn,
    azimuth: azimuthIn,
    options: options2,
    containerId,
    offset,
    config: config2,
    enableBox,
    enableMenu,
    ...restProps
  } = props;
  const sourceId = sourceIdIn || `${layerId}-source`;
  const boxId = `${layerId}-box`;
  const [activeControl, setActiveControl] = React__default.useState(editTypeIn);
  const [editInProgress, setEditInProgress] = React__default.useState({});
  const {
    map: map5
  } = useMapbox();
  const [data2, setData6] = React__default.useState({});
  const url2 = (data2 == null ? void 0 : data2.imageUrl) || originalImageUrl;
  const onEditTypeChange = React__default.useCallback((editType) => {
    setActiveControl(editType);
    onEditTypeChangeIn(editType);
  }, [onEditTypeChangeIn]);
  const onEditStart = React__default.useCallback((input) => {
    setEditInProgress(input);
  }, [setEditInProgress]);
  const onEditDone = React__default.useCallback((data22) => {
    setData6((previous) => ({
      ...previous || {},
      ...data22 || {}
    }));
    setEditInProgress({});
  }, [setEditInProgress]);
  const updateVisibility = React__default.useCallback((layerId2, visible) => {
    if (map5.getLayer(layerId2)) {
      if (visible) {
        map5.setLayoutProperty(layerId2, "visibility", "visible");
      } else {
        map5.setLayoutProperty(layerId2, "visibility", "none");
      }
    }
  }, [map5]);
  const onCrop = React__default.useCallback((cropped) => {
    onEditDone({
      imageUrl: cropped
    });
    setActiveControl("");
  }, [onEditDone]);
  const onChangeMut = useMutableFunc(onChangeIn);
  React__default.useLayoutEffect(() => {
    onChangeMut(data2);
  }, [data2, onChangeMut]);
  React__default.useLayoutEffect(() => {
    setData6((previous) => {
      const updated = {
        opacity: opacityIn || 1,
        box: boxIn,
        azimuth: azimuthIn || 0,
        imageUrl: previous.imageUrl || originalImageUrl
        // cropped image
      };
      if (updated.opacity !== previous.opacity || updated.box !== previous.box || updated.azimuth !== previous.azimuth || updated.imageUrl !== previous.imageUrl) {
        return updated;
      }
      return previous;
    });
  }, [azimuthIn, boxIn, opacityIn, originalImageUrl]);
  const {
    enableSkew,
    enableOpacity,
    enableCropper,
    cropperType
  } = React__default.useMemo(() => {
    const enableSkew2 = activeControl === "skew";
    const enableCropper2 = activeControl == null ? void 0 : activeControl.startsWith("cropper-");
    const cropperType2 = enableCropper2 ? activeControl.replace("cropper-", "") : null;
    const enableOpacity2 = activeControl === "rotate-scale";
    return {
      enableSkew: enableSkew2,
      enableCropper: enableCropper2,
      cropperType: cropperType2,
      enableOpacity: enableOpacity2
    };
  }, [activeControl]);
  React__default.useLayoutEffect(() => {
    if (enableCropper) {
      updateVisibility(layerId, false);
    } else {
      updateVisibility(layerId, true);
    }
  }, [enableCropper, layerId, updateVisibility]);
  const paint = React__default.useMemo(() => ({
    "raster-opacity": (data2 == null ? void 0 : data2.opacity) ?? 1
  }), [data2 == null ? void 0 : data2.opacity]);
  if (!(data2 == null ? void 0 : data2.box) || !layerId || !url2 || !data2)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Source$1, { id: sourceId, type: "image", url: url2, coordinates: data2.box, children: /* @__PURE__ */ jsx(Layer$1, { id: layerId, type: "raster", source: sourceId, paint }) }, sourceId),
    /* @__PURE__ */ jsx(BoxEditableLayer, { ...restProps, config: config2, containerId, id: boxId, box: boxIn, editableSourceId: sourceId, options: options2, editType: activeControl, onEditTypeChange, onStart: onEditStart, onChange: onEditDone, enableBox: !enableCropper && enableBox, enableMenu }),
    enableSkew && /* @__PURE__ */ jsx(ImageSkewControls, { sourceId, active: true, onChange: (box) => onEditDone({
      box
    }) }),
    enableOpacity && /* @__PURE__ */ jsx(BoxOpacityControls, { sourceId, containerId, config: config2, box: data2.box, offset, map: map5, value: data2 == null ? void 0 : data2.opacity, onChange: (opacity) => onEditDone({
      opacity
    }), enablePopup: !(editInProgress == null ? void 0 : editInProgress.key) || (editInProgress == null ? void 0 : editInProgress.key) === "opacity" }),
    enableCropper && createPortal(/* @__PURE__ */ jsx("div", { style: {
      width: "100%",
      height: "100%"
    }, children: /* @__PURE__ */ jsx(Cropper, { src: originalImageUrl, style: {
      width: "100%",
      height: "100%"
    }, onCrop, cropperType, enableMenu: false, enableSubmit: true }, cropperType) }), document.getElementById(containerId) || document.body, `cropper-image-edit${containerId}`)
  ] });
}
ImageLayer2.propTypes = {
  id: propTypesExports$1.string,
  // mandatory
  url: propTypesExports$1.string,
  // mandatory
  sourceId: propTypesExports$1.string,
  /**
   * Clockwise order: top left, top right, bottom right, bottom left.
   */
  box: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  editType: propTypesExports$1.string,
  onEditTypeChange: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  containerId: propTypesExports$1.string,
  opacity: propTypesExports$1.number,
  azimuth: propTypesExports$1.number,
  options: propTypesExports$1.arrayOf(propTypesExports$1.object),
  config: propTypesExports$1.object,
  // theme related config
  offset: propTypesExports$1.arrayOf(propTypesExports$1.number),
  // in pixels
  enableBox: propTypesExports$1.bool,
  enableMenu: propTypesExports$1.bool
};
ImageLayer2.defaultProps = {
  id: "",
  url: null,
  sourceId: "",
  box: null,
  editType: "",
  onEditTypeChange: () => {
  },
  onChange: () => {
  },
  containerId: "",
  opacity: 1,
  azimuth: 0,
  options: MENU_ITEMS,
  config: {},
  offset: [0, 20],
  enableBox: false,
  enableMenu: false
};
function ImageLayer(props) {
  const {
    url: originalImageUrl,
    center: center2,
    onChange: onChangeIn,
    ...restProps
  } = props;
  const [data2, setData6] = React__default.useState({
    box: null,
    imageUrl: originalImageUrl
  });
  const computeImageBox = React__default.useCallback(async (imageUrl) => {
    if (!imageUrl || !center2)
      return null;
    const box = await ImageUtil$1.computeImageBox(imageUrl, center2);
    return box;
  }, [center2]);
  const onImageBoxChange = React__default.useCallback(async (imageUrl, rest = {}) => {
    setData6((previous) => {
      if (!previous.box || previous.imageUrl !== imageUrl) {
        computeImageBox(imageUrl).then((box) => {
          if (box == null ? void 0 : box[0]) {
            const updated = {
              box,
              imageUrl
            };
            setTimeout(() => {
              onChangeIn({
                ...rest,
                ...updated
              });
              setData6(updated);
            }, 20);
          }
        });
      } else {
        onChangeIn({
          ...rest,
          imageUrl
        });
      }
      return previous;
    });
  }, [computeImageBox, onChangeIn]);
  const onChange = React__default.useCallback((data22) => {
    const {
      imageUrl,
      ...rest
    } = data22 || {};
    onImageBoxChange(imageUrl, rest);
  }, [onImageBoxChange]);
  if (!(data2 == null ? void 0 : data2.imageUrl))
    return null;
  return /* @__PURE__ */ jsx(
    ImageLayer2,
    {
      box: data2 == null ? void 0 : data2.box,
      url: originalImageUrl,
      onChange,
      ...restProps
    }
  );
}
ImageLayer.propTypes = {
  url: propTypesExports$1.string,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  onChange: propTypesExports$1.func
};
ImageLayer.defaultProps = {
  url: "",
  center: null,
  onChange: () => {
  }
};
function HeatmapLayer(props) {
  const {
    id,
    minZoom,
    maxZoom,
    valuePropName,
    colorDomain,
    colorMap,
    colorRange,
    sourceId,
    sourceLayer,
    radiusPropName,
    radius: radiusIn,
    intensity: intensityIn,
    opacity: opacityIn,
    ...restProps
  } = props;
  const [minValue = 0, maxValue = 0] = colorDomain || [];
  const weight = React__default.useMemo(() => ["interpolate", ["linear"], ["get", valuePropName], minValue, 0, maxValue, 1], [valuePropName, minValue, maxValue]);
  const size12 = React__default.useMemo(() => {
    if (radiusPropName) {
      return ["to-number", ["coalesce", ["get", radiusPropName], radiusIn], radiusIn];
    }
    return radiusIn;
  }, [radiusIn, radiusPropName]);
  const radius = React__default.useMemo(() => ["interpolate", ["linear"], ["zoom"], 0, 2, maxZoom, size12], [maxZoom, size12]);
  const intensity = React__default.useMemo(() => ["interpolate", ["linear"], ["zoom"], 0, 0, maxZoom, intensityIn], [intensityIn, maxZoom]);
  const opacity = React__default.useMemo(() => ["interpolate", ["linear"], ["zoom"], minZoom, Math.min(1, 2 * opacityIn), maxZoom, opacityIn], [minZoom, opacityIn, maxZoom]);
  const color = React__default.useMemo(() => {
    const color2 = ["interpolate", ["linear"], ["heatmap-density"]];
    if ((colorRange == null ? void 0 : colorRange.length) > 1) {
      const delta = 1 / (colorRange.length - 1);
      colorRange.forEach((c2, index2) => {
        color2.push(Number(index2 * delta));
        color2.push(ColorUtil.convertToRGBAString(c2));
      });
    } else {
      const colorInterpolationStops = ColorMaps[colorMap] || {};
      Object.keys(colorInterpolationStops).sort((a2, b2) => a2 - b2).forEach((key) => {
        color2.push(Number(key));
        color2.push(colorInterpolationStops[key]);
      });
    }
    return color2;
  }, [colorMap, colorRange]);
  const paintOptions = React__default.useMemo(() => ({
    "heatmap-weight": weight,
    "heatmap-intensity": intensity,
    "heatmap-color": color,
    "heatmap-radius": radius,
    "heatmap-opacity": opacity
  }), [weight, intensity, color, radius, opacity]);
  const sources2 = React__default.useMemo(() => {
    const sources22 = {};
    if (sourceId) {
      sources22.source = sourceId;
    }
    if (sourceLayer) {
      sources22["source-layer"] = sourceLayer;
    }
    return sources22;
  }, [sourceId, sourceLayer]);
  return /* @__PURE__ */ jsx(Layer$1, { id, type: "heatmap", paint: paintOptions, minZoom, maxZoom, ...sources2, ...restProps });
}
HeatmapLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  valuePropName: propTypesExports$1.string,
  radiusPropName: propTypesExports$1.string,
  colorDomain: propTypesExports$1.array,
  colorMap: propTypesExports$1.string,
  // used when colorRange is not provided
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  sourceId: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string,
  intensity: propTypesExports$1.number,
  radius: propTypesExports$1.number,
  opacity: propTypesExports$1.number
};
HeatmapLayer.defaultProps = {
  minZoom: 0,
  maxZoom: 24,
  valuePropName: "mag",
  radiusPropName: "",
  colorDomain: null,
  // context based value to be provided by caller
  colorMap: "rainbow",
  colorRange: null,
  sourceLayer: null,
  intensity: 3,
  radius: 20,
  // in pixel
  opacity: 0.2
};
function HeatmapFillLayer({
  colorMap,
  colorRange,
  valuePropName,
  colorDomain,
  opacity: opacityIn,
  opacityPropName,
  ...restProps
}) {
  const [minValue = 0, maxValue = 0] = colorDomain || [];
  const fillColor = React__default.useMemo(() => {
    const range2 = maxValue - minValue || 1;
    const normalizedValue = ["/", ["-", ["get", valuePropName], minValue], range2];
    const expression = ["interpolate", ["linear"], normalizedValue];
    if ((colorRange == null ? void 0 : colorRange.length) > 1) {
      const delta = 1 / (colorRange.length - 1);
      colorRange.forEach((c2, index2) => {
        expression.push(index2 * delta);
        expression.push(ColorUtil.convertToRGBAString(c2));
      });
    } else {
      const colorInterpolationStops = ColorMaps[colorMap] || {};
      Object.keys(colorInterpolationStops).map(Number).sort((a2, b2) => a2 - b2).forEach((key) => {
        expression.push(key);
        expression.push(ColorUtil.convertToRGBAString(colorInterpolationStops[key]));
      });
    }
    return expression;
  }, [colorMap, colorRange, valuePropName, minValue, maxValue]);
  const opacity = React__default.useMemo(() => {
    if (opacityPropName) {
      return ["to-number", ["coalesce", ["get", opacityPropName], opacityIn], opacityIn];
    }
    return opacityIn;
  }, [opacityIn, opacityPropName]);
  if (!valuePropName)
    return null;
  return /* @__PURE__ */ jsx(FillLayer, { ...restProps, hoverColor: null, selectColor: null, opacity, color: fillColor, outlineColor: fillColor });
}
HeatmapFillLayer.propTypes = {
  colorMap: propTypesExports$1.string,
  colorRange: propTypesExports$1.arrayOf(propTypesExports$1.string),
  colorDomain: propTypesExports$1.array,
  valuePropName: propTypesExports$1.string,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string
};
HeatmapFillLayer.defaultProps = {
  colorMap: "rainbow",
  colorRange: null,
  colorDomain: null,
  valuePropName: "density",
  opacity: 0.2,
  opacityPropName: null
};
function Tiles2dLayer(props) {
  const {
    id: layerId,
    type,
    sourceId: sourceIdIn,
    sourceLayer,
    url: url2,
    isTiles,
    accessToken,
    sourceProps,
    opacity,
    heightPropName,
    floorHeight,
    colorPropName,
    color,
    opacityPropName,
    outlineColor,
    outlinePropName,
    outlineWidthPropName,
    outlineWidth,
    outlineOpacity,
    outlineOpacityPropName,
    outlineDashArray,
    outlineDashArrayPropName,
    textColor: textColor2,
    textOpacity,
    textValue,
    textAnchor,
    textOffset,
    textBackground,
    textAnchorPropName,
    textValuePropName,
    textColorPropName,
    textOpacityPropName,
    extrusionEnabled,
    fillEnabled,
    outlineEnabled,
    lineEnabled,
    pointEnabled,
    thicknessEnabled,
    thickness,
    customIcon,
    iconIdPropName,
    iconUrlPropName,
    iconUrl: iconUrl2,
    iconSize: iconSize2,
    iconSizePropName,
    ...restProps
  } = props;
  const sourceId = sourceIdIn || `${layerId}-source`;
  const urlProps = React__default.useMemo(() => {
    if (!isTiles) {
      return {
        url: url2
      };
    }
    let tiles = [];
    if (url2) {
      if (accessToken)
        tiles = [`${url2}?access_token=${accessToken}`];
      else
        tiles = [url2];
    }
    return {
      tiles
    };
  }, [accessToken, isTiles, url2]);
  const clusterProps = React__default.useMemo(() => {
    if (type === "point" || type === "symbol") {
      return {
        clusterLayerId: layerId
      };
    }
    return {};
  }, [layerId, type]);
  const featureProps = React__default.useMemo(() => ({
    heightPropName,
    floorHeight,
    colorPropName,
    color,
    opacityPropName,
    outlineColor,
    outlinePropName,
    outlineWidthPropName,
    outlineWidth,
    outlineOpacity,
    outlineOpacityPropName,
    outlineDashArray,
    outlineDashArrayPropName,
    textColor: textColor2,
    textOpacity,
    textValue,
    textAnchor,
    textOffset,
    textBackground,
    textAnchorPropName,
    textValuePropName,
    textColorPropName,
    textOpacityPropName,
    extrusionEnabled,
    fillEnabled,
    outlineEnabled,
    lineEnabled,
    pointEnabled,
    thicknessEnabled,
    thickness,
    customIcon,
    iconIdPropName,
    iconUrlPropName,
    iconUrl: iconUrl2,
    iconSize: iconSize2,
    iconSizePropName
  }), [color, colorPropName, customIcon, extrusionEnabled, fillEnabled, floorHeight, heightPropName, iconIdPropName, iconSize2, iconSizePropName, iconUrl2, iconUrlPropName, lineEnabled, opacityPropName, outlineColor, outlineDashArray, outlineDashArrayPropName, outlineEnabled, outlineOpacity, outlineOpacityPropName, outlinePropName, outlineWidth, outlineWidthPropName, pointEnabled, textAnchor, textAnchorPropName, textBackground, textColor2, textColorPropName, textOffset, textOpacity, textOpacityPropName, textValue, textValuePropName, thickness, thicknessEnabled]);
  if (type === "h3map") {
    return /* @__PURE__ */ jsx(H3Map, { id: `${layerId}-h3map`, data: url2, sourceId, sourceLayer, indexPropName: "h3_index", type: "vector", colorMap: "cooltowarm", extruded: false, opacity, ...restProps });
  }
  return /* @__PURE__ */ jsxs(ClusterSource, { id: sourceId, type: "vector", ...urlProps, ...clusterProps, ...sourceProps, children: [
    type === "line" && /* @__PURE__ */ jsx(LineLayer2, { id: `${layerId}-line`, sourceId, sourceLayer, opacity, ...featureProps, ...restProps }),
    type === "fill" && /* @__PURE__ */ jsx(FillLayer2, { id: `${layerId}-fill`, sourceId, sourceLayer, opacity, ...featureProps, ...restProps }),
    type === "extrusion" && /* @__PURE__ */ jsx(ExtrusionLayer2, { id: `${layerId}-extrusion`, sourceId, sourceLayer, opacity, ...featureProps, ...restProps }),
    type === "circle" && /* @__PURE__ */ jsx(CircleLayer, { id: `${layerId}-circle`, sourceId, sourceLayer, opacity, ...featureProps, ...restProps }),
    type === "symbol" && /* @__PURE__ */ jsx(SymbolLayer, { id: `${layerId}-symbol`, sourceId, sourceLayer, opacity, ...featureProps, ...restProps }),
    type === "point" && /* @__PURE__ */ jsx(PointLayer2, { id: `${layerId}-point`, sourceId, sourceLayer, opacity, ...featureProps, ...restProps }),
    type === "heatmap" && /* @__PURE__ */ jsx(HeatmapLayer, { id: `${layerId}-heatmap`, sourceId, sourceLayer, opacity, ...restProps }),
    type === "heatmapfill" && /* @__PURE__ */ jsx(HeatmapFillLayer, { id: `${layerId}-heatmapfill`, sourceId, sourceLayer, opacity, ...restProps })
  ] });
}
Tiles2dLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  url: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string,
  type: propTypesExports$1.oneOf(["line", "fill", "extrusion", "circle", "symbol", "point", "heatmap", "heatmapfill", "h3map"]),
  accessToken: propTypesExports$1.string,
  sourceProps: propTypesExports$1.object,
  isTiles: propTypesExports$1.bool,
  beforeId: propTypesExports$1.string,
  heightPropName: propTypesExports$1.string,
  floorHeight: propTypesExports$1.number,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.any,
  opacity: propTypesExports$1.any,
  opacityPropName: propTypesExports$1.string,
  outlineColor: propTypesExports$1.any,
  outlinePropName: propTypesExports$1.string,
  outlineOpacity: propTypesExports$1.any,
  outlineOpacityPropName: propTypesExports$1.string,
  outlineDashArray: propTypesExports$1.arrayOf(propTypesExports$1.number),
  outlineWidthPropName: propTypesExports$1.string,
  outlineWidth: propTypesExports$1.number,
  outlineDashArrayPropName: propTypesExports$1.string,
  textColor: propTypesExports$1.any,
  textOpacity: propTypesExports$1.any,
  textValue: propTypesExports$1.any,
  textAnchor: propTypesExports$1.any,
  textOffset: propTypesExports$1.number,
  textBackground: propTypesExports$1.bool,
  textColorPropName: propTypesExports$1.string,
  textOpacityPropName: propTypesExports$1.string,
  textAnchorPropName: propTypesExports$1.string,
  textValuePropName: propTypesExports$1.string,
  extrusionEnabled: propTypesExports$1.bool,
  fillEnabled: propTypesExports$1.bool,
  outlineEnabled: propTypesExports$1.bool,
  // extract fill outline automatically
  lineEnabled: propTypesExports$1.bool,
  pointEnabled: propTypesExports$1.bool,
  thicknessEnabled: propTypesExports$1.bool,
  thickness: propTypesExports$1.number,
  customIcon: propTypesExports$1.func,
  // refer IconUtil.generateSampleCanvas
  iconIdPropName: propTypesExports$1.string,
  iconUrlPropName: propTypesExports$1.string,
  iconUrl: propTypesExports$1.string,
  iconSize: propTypesExports$1.number,
  iconSizePropName: propTypesExports$1.string
};
Tiles2dLayer.defaultProps = {
  type: "line",
  sourceId: null,
  accessToken: "",
  sourceProps: {},
  isTiles: true,
  beforeId: "",
  heightPropName: "",
  floorHeight: 3.5,
  colorPropName: "",
  color: "#0080ff",
  // blue color fill
  opacity: 1,
  opacityPropName: "",
  outlineColor: "#0080ff",
  // blue color fill
  outlinePropName: "",
  outlineWidthPropName: "",
  outlineWidth: 1,
  outlineOpacity: 1,
  outlineOpacityPropName: "",
  outlineDashArray: [1, 0],
  outlineDashArrayPropName: "",
  textColor: "#000000",
  // black
  textOpacity: 1,
  textValue: "",
  textAnchor: "center",
  textOffset: 0,
  textBackground: false,
  textAnchorPropName: "",
  textValuePropName: "",
  textColorPropName: "",
  textOpacityPropName: "",
  extrusionEnabled: false,
  fillEnabled: false,
  outlineEnabled: false,
  lineEnabled: false,
  pointEnabled: false,
  thicknessEnabled: false,
  thickness: 0.4,
  // in meters
  customIcon: null,
  iconIdPropName: "",
  // one of two (marker-symbol-id or marker-symbol) can be provided to render the custom marker
  iconUrlPropName: "",
  iconUrl: "",
  iconSize: void 0,
  iconSizePropName: ""
};
class Tile3dLoader {
  // This class contains the common code to load tile content, such as b3dm and pnts files.
  // It is not to be used directly. Instead, subclasses are used to implement specific
  // content loaders for different tile types.
  constructor(url2) {
    this.url = url2;
    this.type = url2.slice(-4);
    this.version = null;
    this.byteLength = null;
    this.featureTableJSON = null;
    this.featureTableBinary = null;
    this.batchTableJson = null;
    this.batchTableBinary = null;
    this.binaryData = null;
  }
  // Tile3dLoader.load
  async load() {
    const response = await fetch(this.url);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status} - ${response.statusText}`);
    }
    const buffer3 = await response.arrayBuffer();
    const res = this.parseResponse(buffer3);
    return res;
  }
  parseResponse(buffer3) {
    const header = new Uint32Array(buffer3.slice(0, 28));
    const decoder = new TextDecoder();
    const magic = decoder.decode(new Uint8Array(buffer3.slice(0, 4)));
    if (magic !== this.type) {
      throw new Error(`Invalid magic string, expected '${this.type}', got '${this.magic}'`);
    }
    this.version = header[1];
    this.byteLength = header[2];
    const featureTableJSONByteLength = header[3];
    const featureTableBinaryByteLength = header[4];
    const batchTableJsonByteLength = header[5];
    const batchTableBinaryByteLength = header[6];
    let pos = 28;
    if (featureTableJSONByteLength > 0) {
      this.featureTableJSON = JSON.parse(decoder.decode(new Uint8Array(buffer3.slice(pos, pos + featureTableJSONByteLength))));
      pos += featureTableJSONByteLength;
    } else {
      this.featureTableJSON = {};
    }
    this.featureTableBinary = buffer3.slice(pos, pos + featureTableBinaryByteLength);
    pos += featureTableBinaryByteLength;
    if (batchTableJsonByteLength > 0) {
      this.batchTableJson = JSON.parse(decoder.decode(new Uint8Array(buffer3.slice(pos, pos + batchTableJsonByteLength))));
      pos += batchTableJsonByteLength;
    } else {
      this.batchTableJson = {};
    }
    this.batchTableBinary = buffer3.slice(pos, pos + batchTableBinaryByteLength);
    pos += batchTableBinaryByteLength;
    this.binaryData = buffer3.slice(pos);
    return this;
  }
}
class PntsLoader extends Tile3dLoader {
  constructor(url2) {
    super(url2);
    this.points = new Float32Array();
    this.rgba = null;
    this.rgb = null;
  }
  parseResponse(buffer3) {
    super.parseResponse(buffer3);
    if (this.featureTableJSON.POINTS_LENGTH && this.featureTableJSON.POSITION) {
      const len2 = this.featureTableJSON.POINTS_LENGTH;
      let pos = this.featureTableJSON.POSITION.byteOffset;
      this.points = new Float32Array(this.featureTableBinary.slice(pos, pos + len2 * Float32Array.BYTES_PER_ELEMENT * 3));
      this.rtc_center = this.featureTableJSON.RTC_CENTER;
      if (this.featureTableJSON.RGBA) {
        pos = this.featureTableJSON.RGBA.byteOffset;
        const colorInts = new Uint8Array(this.featureTableBinary.slice(pos, pos + len2 * Uint8Array.BYTES_PER_ELEMENT * 4));
        const rgba = new Float32Array(colorInts.length);
        for (let i2 = 0; i2 < colorInts.length; i2 += 1) {
          rgba[i2] = colorInts[i2] / 255;
        }
        this.rgba = rgba;
      } else if (this.featureTableJSON.RGB) {
        pos = this.featureTableJSON.RGB.byteOffset;
        const colorInts = new Uint8Array(this.featureTableBinary.slice(pos, pos + len2 * Uint8Array.BYTES_PER_ELEMENT * 3));
        const rgb = new Float32Array(colorInts.length);
        for (let i2 = 0; i2 < colorInts.length; i2 += 1) {
          rgb[i2] = colorInts[i2] / 255;
        }
        this.rgb = rgb;
      } else if (this.featureTableJSON.RGB565) {
        console.error("RGB565 is currently not supported in pointcloud tiles.");
      }
    }
    return this;
  }
}
class B3dmLoader extends Tile3dLoader {
  constructor(url2) {
    super(url2);
    this.glbData = null;
  }
  parseResponse(buffer3) {
    super.parseResponse(buffer3);
    this.glbData = this.binaryData;
    return this;
  }
}
class Tile3d {
  constructor(json, resourcePath, styleParams, updateCallback, parentRefine, parentTransform, DEBUG) {
    this.loaded = false;
    this.styleParams = styleParams;
    this.updateCallback = updateCallback;
    this.resourcePath = resourcePath;
    this.totalContent = new Group();
    this.tileContent = new Group();
    this.childContent = new Group();
    this.totalContent.add(this.tileContent);
    this.totalContent.add(this.childContent);
    this.boundingVolume = json.boundingVolume;
    if (this.boundingVolume && this.boundingVolume.box) {
      const b2 = this.boundingVolume.box;
      const extent2 = [b2[0] - b2[3], b2[1] - b2[7], b2[0] + b2[3], b2[1] + b2[7]];
      const sw = new Vector3$1(extent2[0], extent2[1], b2[2] - b2[11]);
      const ne = new Vector3$1(extent2[2], extent2[3], b2[2] + b2[11]);
      this.box = new Box3(sw, ne);
      if (DEBUG) {
        const geom = new BoxGeometry(b2[3] * 2, b2[7] * 2, b2[11] * 2);
        const edges = new EdgesGeometry(geom);
        this.debugColor = new Color(16777215);
        this.debugColor.setHex(Math.random() * 16777215);
        const line = new LineSegments(edges, new LineBasicMaterial({
          color: this.debugColor
        }));
        const trans = new Matrix4$1().makeTranslation(b2[0], b2[1], b2[2]);
        line.applyMatrix4(trans);
        this.debugLine = line;
      }
    } else {
      this.extent = null;
      this.sw = null;
      this.ne = null;
      this.box = null;
      this.center = null;
    }
    this.refine = json.refine ? json.refine.toUpperCase() : parentRefine;
    this.geometricError = json.geometricError;
    this.worldTransform = parentTransform ? parentTransform.clone() : new Matrix4$1();
    this.transform = json.transform;
    if (this.transform) {
      const tileMatrix = new Matrix4$1().fromArray(this.transform);
      this.totalContent.applyMatrix4(tileMatrix);
      this.worldTransform.multiply(tileMatrix);
    }
    this.content = json.content;
    this.children = [];
    if (json.children) {
      for (let i2 = 0; i2 < json.children.length; i2 += 1) {
        const child = new Tile3d(json.children[i2], resourcePath, styleParams, updateCallback, this.refine, this.worldTransform);
        this.childContent.add(child.totalContent);
        this.children.push(child);
      }
    }
  }
  async load() {
    if (this.unloadedTileContent) {
      this.totalContent.add(this.tileContent);
      this.unloadedTileContent = false;
    }
    if (this.unloadedChildContent) {
      this.totalContent.add(this.childContent);
      this.unloadedChildContent = false;
    }
    if (this.unloadedDebugContent) {
      this.totalContent.add(this.debugLine);
      this.unloadedDebugContent = false;
    }
    if (this.loaded) {
      this.updateCallback();
      return;
    }
    this.loaded = true;
    if (this.debugLine) {
      this.totalContent.add(this.debugLine);
    }
    if (this.content) {
      let url2 = this.content.uri ? this.content.uri : this.content.url;
      if (!url2)
        return;
      if (url2.substr(0, 4) !== "http")
        url2 = this.resourcePath + url2;
      const type = url2.slice(-4);
      switch (type) {
        case "json":
          try {
            const subTileset = new Tile3dSet(() => this.updateCallback());
            await subTileset.load(url2, this.styleParams);
            if (subTileset.root) {
              this.box.applyMatrix4(this.worldTransform);
              const inverseMatrix = new Matrix4$1().copy(this.worldTransform).invert();
              this.totalContent.applyMatrix4(inverseMatrix);
              this.totalContent.updateMatrixWorld();
              this.worldTransform = new Matrix4$1();
              this.children.push(subTileset.root);
              this.childContent.add(subTileset.root.totalContent);
              subTileset.root.totalContent.updateMatrixWorld();
              subTileset.root.checkLoad(this.frustum, this.cameraPosition);
            }
          } catch (error2) {
            console.error(error2);
          }
          break;
        case "b3dm":
          try {
            const loader2 = new GLTFLoader();
            const b3dm = new B3dmLoader(url2);
            const rotateX2 = new Matrix4$1().makeRotationAxis(new Vector3$1(1, 0, 0), Math.PI / 2);
            this.tileContent.applyMatrix4(rotateX2);
            const b3dmData = await b3dm.load();
            loader2.parse(b3dmData.glbData, this.resourcePath, (gltf) => {
              gltf.scene.traverse((child) => {
                if (child instanceof Mesh) {
                  child.geometry.computeBoundingBox();
                  child.geometry.computeBoundingSphere();
                  child.material.depthWrite = true;
                  child.userData = b3dmData.batchTableJson;
                }
              });
              if (this.styleParams.color != null || this.styleParams.opacity != null) {
                const color = new Color(this.styleParams.color);
                gltf.scene.traverse((child) => {
                  if (child instanceof Mesh) {
                    if (this.styleParams.color != null)
                      child.material.color = color;
                    if (this.styleParams.opacity != null) {
                      child.material.opacity = this.styleParams.opacity;
                      child.material.transparent = this.styleParams.opacity < 1;
                    }
                  }
                });
              }
              if (this.debugColor) {
                gltf.scene.traverse((child) => {
                  if (child instanceof Mesh) {
                    child.material.color = this.debugColor;
                  }
                });
              }
              this.tileContent.add(gltf.scene);
            }, (error2) => {
              throw new Error(`error parsing gltf: ${error2}`);
            });
          } catch (error2) {
            console.error(error2);
          }
          break;
        case "pnts":
          try {
            const pnts = new PntsLoader(url2);
            const pointData = await pnts.load();
            const geometry2 = new BufferGeometry();
            geometry2.setAttribute("position", new Float32BufferAttribute(pointData.points, 3));
            const material = new PointsMaterial();
            material.size = this.styleParams.pointsize != null ? this.styleParams.pointsize : 1;
            if (this.styleParams.color) {
              material.vertexColors = NoColors;
              material.color = new Color(this.styleParams.color);
              material.opacity = this.styleParams.opacity != null ? this.styleParams.opacity : 1;
            } else if (pointData.rgba) {
              geometry2.setAttribute("color", new Float32BufferAttribute(pointData.rgba, 4));
              material.vertexColors = VertexColors;
            } else if (pointData.rgb) {
              geometry2.setAttribute("color", new Float32BufferAttribute(pointData.rgb, 3));
              material.vertexColors = VertexColors;
            }
            this.tileContent.add(new Points(geometry2, material));
            if (pointData.rtc_center) {
              const c2 = pointData.rtc_center;
              this.tileContent.applyMatrix4(new Matrix4$1().makeTranslation(c2[0], c2[1], c2[2]));
            }
            this.tileContent.add(new Points(geometry2, material));
          } catch (error2) {
            console.error(error2);
          }
          break;
        case "i3dm":
          throw new Error("i3dm tiles not yet implemented");
        case "cmpt":
          throw new Error("cmpt tiles not yet implemented");
        default:
          throw new Error(`invalid tile type: ${type}`);
      }
    }
    this.updateCallback();
  }
  unload(includeChildren) {
    this.unloadedTileContent = true;
    this.totalContent.remove(this.tileContent);
    if (includeChildren) {
      this.unloadedChildContent = true;
      this.totalContent.remove(this.childContent);
    } else if (this.unloadedChildContent) {
      this.unloadedChildContent = false;
      this.totalContent.add(this.childContent);
    }
    if (this.debugLine) {
      this.totalContent.remove(this.debugLine);
      this.unloadedDebugContent = true;
    }
    this.updateCallback();
  }
  checkLoad(frustum2, cameraPosition) {
    this.frustum = frustum2;
    this.cameraPosition = cameraPosition;
    const transformedBox = this.box.clone();
    transformedBox.applyMatrix4(this.totalContent.matrixWorld);
    if (!frustum2.intersectsBox(transformedBox)) {
      this.unload(true);
      return;
    }
    const worldBox = this.box.clone().applyMatrix4(this.worldTransform);
    const dist2 = worldBox.distanceToPoint(cameraPosition);
    if (this.geometricError > 0 && dist2 > this.geometricError * 50) {
      this.unload(true);
      return;
    }
    if (this.refine === "REPLACE" && dist2 < this.geometricError * 20) {
      this.unload(false);
    } else {
      this.load();
    }
    for (let i2 = 0; i2 < this.children.length; i2 += 1) {
      if (dist2 < this.geometricError * 20) {
        this.children[i2].checkLoad(frustum2, cameraPosition);
      } else {
        this.children[i2].unload(true);
      }
    }
  }
}
class Tile3dSet {
  constructor(updateCallback) {
    this.updateCallback = updateCallback;
    this.url = null;
    this.version = null;
    this.gltfUpAxis = "Z";
    this.geometricError = null;
    this.root = null;
    this.debug = false;
  }
  async load(url2, resourcePath, styleParams, headers) {
    this.url = url2 || this.url;
    this.headers = headers || this.headers;
    const json = await this.fetchContent(this.url, this.headers);
    this.version = json.asset.version;
    this.geometricError = json.geometricError;
    this.refine = json.root.refine ? json.root.refine.toUpperCase() : "ADD";
    this.root = new Tile3d(json.root, resourcePath, styleParams, this.updateCallback, this.refine, this.debug);
  }
  // eslint-disable-next-line class-methods-use-this
  async fetchContent(data2, headers) {
    if (typeof data2 === "object")
      return data2;
    if (typeof data2 !== "string")
      return {};
    const response = await fetch(data2, {
      method: "GET",
      mode: "cors",
      headers
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status} - ${response.statusText}`);
    }
    return await response.json();
  }
}
class Tile3dLayer extends ThreeLayer {
  constructor(params2) {
    super(params2);
    this.url = params2.url;
    this.headers = params2.token ? {
      Authorization: `Bearer ${params2.token}`
    } : void 0;
    this.resourcePath = params2.resourcePath || (typeof this.url === "string" ? LoaderUtils.extractUrlBase(this.url) : "/");
    this.loadStatus = 0;
    this.styleParams = {};
    if ("color" in params2)
      this.styleParams.color = params2.color;
    if ("opacity" in params2)
      this.styleParams.opacity = params2.opacity;
    if ("pointsize" in params2)
      this.styleParams.pointsize = params2.pointsize;
  }
  isSupportedVersion() {
    var _a3;
    const scope = this;
    if (((_a3 = scope == null ? void 0 : scope.tileset) == null ? void 0 : _a3.version) && scope.tileset.version !== "1.0") {
      return false;
    }
    return true;
  }
  async addCallback() {
    const scope = this;
    try {
      if (scope.url) {
        scope.tileset = new Tile3dSet(() => scope.map.triggerRepaint());
        await scope.tileset.load(scope.url, scope.resourcePath, scope.styleParams, scope.headers);
        if (scope.tileset.root) {
          scope.world.add(scope.tileset.root.totalContent);
          scope.world.updateMatrixWorld();
          scope.loadStatus = 1;
          scope.updateCallback();
        }
      }
    } catch (error2) {
      console.error(error2);
    }
  }
  updateCallback() {
    if (this.tileset && this.tileset.root && this.cameraSync) {
      this.tileset.root.checkLoad(this.cameraSync.frustum, this.cameraSync.cameraPosition);
    }
  }
  getSource() {
    return this.url;
  }
}
function Tiles3dLayer$1(props) {
  const {
    id,
    data: data2,
    opacity,
    color,
    onLoad,
    ...restProps
  } = props;
  const {
    map: map5
  } = useMapbox();
  const hasLayerRef = React__default.useRef(false);
  const createLayer2 = React__default.useCallback(() => {
    if (hasLayerRef.current)
      return;
    if (!map5)
      return;
    const layer = new Tile3dLayer({
      id,
      url: data2,
      color,
      opacity,
      ...restProps
    });
    map5.addLayer(layer);
    const listener = () => {
      map5.off("idle", listener);
      onLoad(layer);
    };
    map5.on("idle", listener);
    hasLayerRef.current = true;
  }, [map5, id, data2, color, opacity, restProps, onLoad]);
  const removeLayer2 = React__default.useCallback(() => () => {
    try {
      if (id && hasLayerRef.current) {
        hasLayerRef.current = false;
        map5 == null ? void 0 : map5.removeLayer(id);
      }
    } catch (error2) {
      console.error(error2);
    }
  }, [id, map5]);
  const createLayerRef = useValueRef(createLayer2);
  const removeLayerRef = useValueRef(removeLayer2);
  useEffect17(() => {
    var _a3;
    (_a3 = createLayerRef.current) == null ? void 0 : _a3.call(createLayerRef);
    const removeLayer22 = removeLayerRef.current;
    return removeLayer22;
  });
  return null;
}
Tiles3dLayer$1.propTypes = {
  id: propTypesExports$1.string.isRequired,
  data: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.string]).isRequired,
  opacity: propTypesExports$1.number,
  color: propTypesExports$1.oneOfType([propTypesExports$1.number, propTypesExports$1.string]),
  onLoad: propTypesExports$1.func
};
Tiles3dLayer$1.defaultProps = {
  opacity: 1,
  color: "#f5fefd",
  onLoad: () => {
  }
};
function Tiles3dLayer(props) {
  const {
    version: version2,
    ...restProps
  } = props;
  const isNewVersion = version2 === "1.1";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !isNewVersion && /* @__PURE__ */ jsx(Tiles3dLayer$1, { ...restProps }),
    isNewVersion && /* @__PURE__ */ jsx(Tiles3dLayer$2, { ...restProps })
  ] });
}
Tiles3dLayer.propTypes = {
  version: propTypesExports$1.oneOf(["1.0", "1", "1.1"])
};
Tiles3dLayer.defaultProps = {
  version: "1.1"
};
function CesiumIonAssetLayer(props) {
  const {
    id,
    center: center2,
    scale: scale5,
    dip,
    head,
    azimuth,
    ...restProps
  } = props;
  const [asset, setAsset] = React__default.useState(null);
  const fetchAsset = React__default.useCallback(() => {
    CesiumIonUtil.getAsset(id).then((data2) => {
      const {
        type,
        url: url2,
        accessToken
      } = data2 || {};
      if (type && url2 && accessToken) {
        setAsset(data2);
      }
    }).catch(console.error);
  }, [id]);
  useEffect17(fetchAsset);
  if (!asset)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    (asset == null ? void 0 : asset.type) === "GLTF" && center2 && /* @__PURE__ */ jsx(ThreeLoaderLayer, { id, type: asset.type, data: asset.url, center: center2, scale: scale5, dip, head, azimuth, token: asset.accessToken, ...restProps }),
    (asset == null ? void 0 : asset.type) === "3DTILES" && /* @__PURE__ */ jsx(Tiles3dLayer, { id, data: asset.url, token: asset.accessToken, ...restProps })
  ] });
}
CesiumIonAssetLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  scale: propTypesExports$1.arrayOf(propTypesExports$1.number),
  dip: propTypesExports$1.number,
  head: propTypesExports$1.number,
  azimuth: propTypesExports$1.number
};
CesiumIonAssetLayer.defaultProps = {
  center: null,
  scale: void 0,
  dip: 0,
  head: 0,
  azimuth: 0
};
function ModelLayer(props) {
  const {
    id,
    sourceId,
    modelId,
    sourceLayer,
    minZoom,
    maxZoom,
    opacity,
    color: colorIn,
    colorMixIntensity,
    selectColor,
    hoverColor,
    modelScale,
    modelRotation,
    modelTranslation,
    paintProps,
    layoutProps,
    ...restProps
  } = props;
  const color = React__default.useMemo(() => {
    const color2 = [colorIn];
    let needCase = false;
    if (hoverColor) {
      color2.unshift(hoverColor);
      color2.unshift(["boolean", ["feature-state", "hover"], false]);
      needCase = true;
    }
    if (selectColor) {
      color2.unshift(selectColor);
      color2.unshift(["boolean", ["feature-state", "select"], false]);
      needCase = true;
    }
    if (needCase)
      color2.unshift("case");
    return color2;
  }, [colorIn, hoverColor, selectColor]);
  const paintOptions = React__default.useMemo(() => {
    const paint = {
      ...paintProps
    };
    if (colorMixIntensity)
      paint["model-color-mix-intensity"] = colorMixIntensity;
    if (color)
      paint["model-color"] = color;
    if (opacity)
      paint["model-opacity"] = opacity;
    if (modelScale)
      paint["model-scale"] = modelScale;
    if (modelRotation)
      paint["model-rotation"] = modelRotation;
    if (modelTranslation)
      paint["model-translation"] = modelTranslation;
    return paint;
  }, [color, paintProps, modelRotation, modelScale, modelTranslation, opacity, colorMixIntensity]);
  const layoutOptions = React__default.useMemo(() => {
    const layout = {
      visibility: "visible"
    };
    if (modelId)
      layout["model-id"] = modelId;
    return {
      ...layout,
      ...layoutProps
    };
  }, [modelId, layoutProps]);
  const sources2 = React__default.useMemo(() => {
    const sources22 = {};
    if (sourceId) {
      sources22.source = sourceId;
    }
    if (sourceLayer) {
      sources22["source-layer"] = sourceLayer;
    }
    return sources22;
  }, [sourceId, sourceLayer]);
  if (!modelId)
    return null;
  return /* @__PURE__ */ jsx(Layer$1, { id, type: "model", paint: paintOptions, layout: layoutOptions, minzoom: minZoom, maxzoom: maxZoom, ...sources2, ...restProps });
}
ModelLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string.isRequired,
  sourceLayer: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  opacity: propTypesExports$1.any,
  selectColor: propTypesExports$1.string,
  hoverColor: propTypesExports$1.string,
  color: propTypesExports$1.any,
  modelScale: propTypesExports$1.any,
  // scale
  modelRotation: propTypesExports$1.any,
  // scale
  modelTranslation: propTypesExports$1.any,
  // scale
  modelId: propTypesExports$1.string,
  paintProps: propTypesExports$1.object,
  layoutProps: propTypesExports$1.object,
  colorMixIntensity: propTypesExports$1.any
};
ModelLayer.defaultProps = {
  sourceLayer: void 0,
  minZoom: 0,
  maxZoom: 24,
  opacity: 1,
  color: "#0080ff",
  // blue color fill
  selectColor: "lightgreen",
  hoverColor: "lightblue",
  modelScale: void 0,
  modelRotation: void 0,
  modelTranslation: void 0,
  modelId: "",
  paintProps: {},
  layoutProps: {},
  colorMixIntensity: 0
};
function GeojsonModelLayer(props) {
  const {
    id: layerId,
    data: data2,
    sourceId: sourceIdIn,
    sourceProps,
    modelId,
    ...restProps
  } = props;
  const sourceId = sourceIdIn || `${layerId}-source`;
  if (!data2 || !modelId)
    return null;
  return /* @__PURE__ */ jsx(Source$1, { id: sourceId, type: "geojson", data: data2, ...sourceProps, children: /* @__PURE__ */ jsx(ModelLayer, { id: layerId, sourceId, modelId, ...restProps }) });
}
GeojsonModelLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  sourceId: propTypesExports$1.string,
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]).isRequired,
  modelId: propTypesExports$1.string.isRequired,
  sourceProps: propTypesExports$1.object
};
GeojsonModelLayer.defaultProps = {
  sourceId: null,
  sourceProps: {}
};
function ThreeModelLayer(props) {
  const {
    type,
    enableTransform,
    data: data2,
    center: center2,
    dip,
    head,
    azimuth,
    scale: scale5,
    forceThreeLoader,
    isBinary,
    ...restProps
  } = props;
  const threeLoader = type === "DXF" || enableTransform || forceThreeLoader;
  const geojsonProps = React__default.useMemo(() => {
    const geojson = {
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [center2[0], center2[1]]
        },
        properties: {}
      }]
    };
    return {
      data: geojson,
      modelScale: scale5,
      modelRotation: [dip, head, azimuth],
      modelTranslation: [0, 0, center2[2] || 0]
    };
  }, [azimuth, center2, dip, head, scale5]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    threeLoader && /* @__PURE__ */ jsx(ThreeLoaderLayer, { ...props }),
    !threeLoader && /* @__PURE__ */ jsx(GeojsonModelLayer, { modelId: data2, ...restProps, ...geojsonProps })
  ] });
}
ThreeModelLayer.propTypes = {
  id: propTypesExports$1.string.isRequired,
  data: propTypesExports$1.string.isRequired,
  type: propTypesExports$1.oneOf(["DXF", "GLTF"]),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number).isRequired,
  enableTransform: propTypesExports$1.bool,
  dip: propTypesExports$1.number,
  head: propTypesExports$1.number,
  azimuth: propTypesExports$1.number,
  scale: propTypesExports$1.array,
  isBinary: propTypesExports$1.bool,
  forceThreeLoader: propTypesExports$1.bool
};
ThreeModelLayer.defaultProps = {
  type: null,
  enableTransform: false,
  dip: 0,
  head: 0,
  azimuth: 0,
  scale: [1, 1, 1],
  isBinary: true,
  forceThreeLoader: false
};
const supportedCadFileFormats = FileUtil.SUPPORTED_CAD_FORMATS;
function CadLayer(props) {
  const {
    data: data2,
    enabled,
    token,
    ...restProps
  } = props;
  const {
    url: url2,
    assetId,
    type,
    center: center2,
    ...geoRef
  } = React__default.useMemo(() => {
    if (!data2)
      return {};
    const {
      id,
      type: type2,
      sourceFile,
      center: center22,
      scale: scale5,
      dip,
      head,
      azimuth
    } = data2;
    if (type2 === "GLTF" || type2 === "DXF") {
      const {
        data: url22,
        dataType,
        extension
      } = sourceFile || {};
      if (dataType === "dataUrl" && supportedCadFileFormats.includes(extension)) {
        return {
          assetId: id,
          url: url22,
          type: type2,
          center: center22,
          scale: scale5,
          dip,
          head,
          azimuth,
          isBinary: extension === "glb"
        };
      }
    } else if (type2 === "ION") {
      return {
        assetId: id,
        type: type2,
        center: center22,
        scale: scale5,
        dip,
        head,
        azimuth
      };
    } else if (type2 === "3DTILES") {
      return {
        url: data2.url,
        assetId: id,
        type: type2
      };
    }
    return {};
  }, [data2]);
  if (!enabled || !data2)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    (type === "GLTF" || type === "DXF") && center2 && url2 && /* @__PURE__ */ jsx(ThreeModelLayer, { id: assetId, data: url2, center: center2, type, ...geoRef, ...restProps }, assetId),
    type === "ION" && /* @__PURE__ */ jsx(CesiumIonAssetLayer, { id: assetId, center: center2, ...geoRef, ...restProps }),
    type === "3DTILES" && /* @__PURE__ */ jsx(Tiles3dLayer, { id: assetId, data: url2, token, ...restProps })
  ] });
}
CadLayer.propTypes = {
  data: propTypesExports$1.object,
  enabled: propTypesExports$1.bool,
  token: propTypesExports$1.string
};
CadLayer.defaultProps = {
  data: null,
  enabled: true,
  token: null
};
const SUPPORTED_TYPES = {
  country: {
    url: "mapbox://mapbox.country-boundaries-v1",
    sourceId: "countries-source",
    sourceLayer: "country_boundaries",
    filter: ["get", "name_en"],
    getFilterKey: (feature2) => {
      var _a3;
      return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.name_en;
    }
  }
};
function Territory(props) {
  const {
    id,
    filterKey,
    territoryType,
    enableOutline,
    ...restProps
  } = props;
  const {
    filter: filterIn,
    getFilterKey,
    ...extraProps
  } = React__default.useMemo(() => {
    const config2 = SUPPORTED_TYPES[territoryType];
    return config2 || {};
  }, [territoryType]);
  const filter17 = React__default.useMemo(() => ["==", filterIn, `${filterKey}`], [filterKey, filterIn]);
  if (!filterKey)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Tiles2dLayer, { id, type: "fill", isTiles: false, filter: filter17, ...extraProps, ...restProps }),
    enableOutline && /* @__PURE__ */ jsx(Tiles2dLayer, { id, type: "line", isTiles: false, filter: filter17, ...extraProps, ...restProps })
  ] });
}
Territory.propTypes = {
  id: propTypesExports$1.string,
  filterKey: propTypesExports$1.string,
  territoryType: propTypesExports$1.oneOf(["country"]),
  enableOutline: propTypesExports$1.bool,
  minZoom: propTypesExports$1.any,
  maxZoom: propTypesExports$1.any
};
Territory.defaultProps = {
  id: "",
  filterKey: "",
  territoryType: "country",
  enableOutline: false,
  minZoom: 0,
  maxZoom: 24
};
Territory.SUPPORTED_TYPES = SUPPORTED_TYPES;
function Territories(props) {
  const {
    features,
    territoryPropName,
    ...restProps
  } = props;
  const data2 = React__default.useMemo(() => {
    const result = [];
    features == null ? void 0 : features.forEach((f2) => {
      if (f2.properties[territoryPropName] && f2.properties.filterKey) {
        const node = {
          ...restProps,
          territoryType: f2.properties[territoryPropName],
          filterKey: f2.properties.filterKey
        };
        if (!node.id) {
          node.id = `territory-${node[territoryPropName]}-${node.filterKey}`;
        }
        if (typeof f2.properties.fill !== "undefined") {
          node.color = f2.properties.fill;
        }
        if (typeof f2.properties.fill !== "undefined") {
          node.outlineColor = f2.properties.fill;
        }
        if (typeof f2.properties["fill-opacity"] !== "undefined") {
          node.opacity = f2.properties["fill-opacity"];
        }
        if (typeof f2.properties["stroke-dasharray"] !== "undefined") {
          node.outlineDashArray = f2.properties["stroke-dasharray"];
        }
        if (typeof f2.properties["stroke-width"] !== "undefined") {
          node.outlineWidth = f2.properties["stroke-width"];
        }
        result.push(node);
      }
    });
    return result;
  }, [features, restProps, territoryPropName]);
  if (!data2 || !data2.length)
    return null;
  return data2.map((node) => /* @__PURE__ */ jsx(Territory, { ...node, outlineDashArrayPropName: "stroke-dasharray", outlineWidthPropName: "stroke-width" }, node.id));
}
Territories.propTypes = {
  features: propTypesExports$1.array,
  territoryPropName: propTypesExports$1.string
};
Territories.defaultProps = {
  features: [],
  territoryPropName: "territoryType"
};
function MapFitBounds(props) {
  const {
    north: northIn,
    south: southIn,
    east: eastIn,
    west: westIn,
    once: once3,
    fitOption,
    ...options2
  } = props;
  const {
    map: map5
  } = useMapbox();
  const onceRef = React__default.useRef(false);
  React__default.useLayoutEffect(() => {
    onceRef.current = false;
  }, [fitOption]);
  const {
    north,
    south,
    east,
    west
  } = React__default.useMemo(() => {
    if (fitOption === "fitBounds")
      return {
        north: northIn,
        south: southIn,
        east: eastIn,
        west: westIn
      };
    const [mWest, mNorth] = CoordinateUtil.toArray(CoordinateUtil.toMercator([westIn, northIn]));
    const [mEast, mSouth] = CoordinateUtil.toArray(CoordinateUtil.toMercator([eastIn, southIn]));
    let width = mWest - mEast;
    let height = mNorth - mSouth;
    let center2 = [0, 0];
    const mapAspectRatio = map5._containerWidth / map5._containerHeight;
    if (fitOption === "fitHeight") {
      width = mapAspectRatio * height;
    } else if (fitOption === "fitWidth") {
      height = width / mapAspectRatio;
    }
    center2 = [(mEast + mWest) * 0.5, (mNorth + mSouth) * 0.5];
    const newEast = center2[0] - width * 0.5;
    const newWest = center2[0] + width * 0.5;
    const newNorth = center2[1] + height * 0.5;
    const newSouth = center2[1] - height * 0.5;
    const [westOut, northOut] = CoordinateUtil.toArray(CoordinateUtil.toLngLat([newWest, newNorth]));
    const [eastOut, southOut] = CoordinateUtil.toArray(CoordinateUtil.toLngLat([newEast, newSouth]));
    return {
      north: northOut,
      south: southOut,
      east: eastOut,
      west: westOut
    };
  }, [eastIn, fitOption, map5, northIn, southIn, westIn]);
  React__default.useLayoutEffect(() => {
    if (!north || !south || !east || !west || !map5)
      return;
    if (once3 && onceRef.current)
      return;
    onceRef.current = true;
    setTimeout(() => map5 == null ? void 0 : map5.fitBounds([
      [west, south],
      // southwestern
      [east, north]
      // northeastern
    ], {
      padding: {
        top: 20,
        bottom: 20,
        left: 20,
        right: 20
      },
      easing: (t2) => t2,
      duration: 20,
      ...options2
    }), 30);
  }, [east, map5, north, south, west, options2, once3]);
  return null;
}
MapFitBounds.propTypes = {
  north: propTypesExports$1.number,
  // in degree
  south: propTypesExports$1.number,
  // in degree
  east: propTypesExports$1.number,
  // in degree
  west: propTypesExports$1.number,
  // in degree
  once: propTypesExports$1.bool,
  // invoke only once
  fitOption: propTypesExports$1.oneOf(["fitBounds", "fitHeight", "fitWidth"])
};
MapFitBounds.defaultProps = {
  north: 0,
  south: 0,
  east: 0,
  west: 0,
  once: true,
  fitOption: "fitBounds"
};
function TerritorySelector(props) {
  const {
    value,
    onChange,
    enableSelector,
    territoryType,
    territoryPropName,
    hoverColor,
    hoverOpacity,
    selectColor,
    selectOpacity,
    opacity,
    enableAutoFocus,
    minZoom,
    ...restProps
  } = props;
  const {
    map: map5
  } = useMapbox();
  const {
    filter: filterIn,
    getFilterKey,
    ...extraProps
  } = React__default.useMemo(() => {
    const config2 = Territory.SUPPORTED_TYPES[territoryType];
    return config2 || {};
  }, [territoryType]);
  const onSelectImpl = React__default.useCallback((selection, map22) => {
    if (!map22 || !selection || !(extraProps == null ? void 0 : extraProps.url))
      return;
    const {
      sourceId,
      sourceLayer
    } = extraProps || {};
    if (!sourceId || !sourceLayer)
      return;
    if (selection.source !== sourceId || selection.sourceLayer !== sourceLayer)
      return;
    const filterKey = getFilterKey(selection);
    const extra = {
      selection,
      name: filterKey,
      territoryType
    };
    if (selection.clickPoint) {
      extra.pointFeature = {
        type: "Feature",
        properties: {
          name: filterKey,
          filterKey,
          [territoryPropName]: territoryType
        },
        geometry: {
          type: "Point",
          coordinates: [selection.clickPoint[0], selection.clickPoint[1]]
        }
      };
    }
    onChange(filterKey, extra);
  }, [extraProps, getFilterKey, territoryType, onChange, territoryPropName]);
  const onSelect = useMutableFunc(onSelectImpl);
  const interactions2 = React__default.useMemo(() => {
    if (!(extraProps == null ? void 0 : extraProps.url))
      return null;
    const {
      sourceId,
      sourceLayer
    } = extraProps;
    return {
      sourceId,
      sourceLayer,
      enableHover: enableSelector,
      enableSelection: enableSelector,
      onSelect
    };
  }, [enableSelector, extraProps, onSelect]);
  const bounds = React__default.useMemo(() => {
    const country = Countries$1.find((c2) => c2.name === value);
    if (country == null ? void 0 : country.bounding_box) {
      const [west, south, east, north] = country.bounding_box;
      return {
        west,
        south,
        east,
        north,
        key: value
      };
    }
    return null;
  }, [value]);
  if (!map5 || !(extraProps == null ? void 0 : extraProps.url))
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    enableSelector && interactions2 && /* @__PURE__ */ jsx(Interactions, { ...interactions2 }),
    enableSelector && /* @__PURE__ */ jsx(Tiles2dLayer, { id: `${territoryType}-hover`, isTiles: false, type: "fill", hoverColor, selectColor, hoverOpacity, selectOpacity, minZoom, ...extraProps, ...restProps, opacity: 0 }),
    value && /* @__PURE__ */ jsx(Territory, { id: `${territoryType}-select`, filterKey: value, territoryType, type: "fill", opacity, minZoom, ...restProps }),
    enableAutoFocus && bounds && /* @__PURE__ */ jsx(MapFitBounds, { ...bounds })
  ] });
}
TerritorySelector.propTypes = {
  value: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  enableSelector: propTypesExports$1.bool,
  territoryType: propTypesExports$1.oneOf(["country"]),
  minZoom: propTypesExports$1.number,
  opacity: propTypesExports$1.any,
  hoverColor: propTypesExports$1.any,
  selectColor: propTypesExports$1.any,
  hoverOpacity: propTypesExports$1.any,
  selectOpacity: propTypesExports$1.any,
  enableAutoFocus: propTypesExports$1.bool,
  territoryPropName: propTypesExports$1.string
};
TerritorySelector.defaultProps = {
  value: "",
  onChange: () => {
  },
  enableSelector: true,
  territoryType: "country",
  minZoom: 0,
  opacity: 1,
  hoverColor: "#0000FF",
  selectColor: "#0000FF",
  hoverOpacity: 0.3,
  selectOpacity: 0.2,
  enableAutoFocus: true,
  territoryPropName: "territoryType"
};
const LAYOUT = {
  // 'text-font': ["Outfit", "Open Sans Regular","Arial Unicode MS Regular"],
  "text-size": 12
  // 'icon-allow-overlap': true,
};
function ClusteredSymbols(props) {
  const {
    id,
    customIcon,
    cluster,
    clusterZoom: clusterMaxZoom,
    minZoom,
    maxZoom,
    ...restProps
  } = props;
  const unclusteredMinZoom = cluster ? clusterMaxZoom : minZoom;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(GeoJsonLayer, { id, filter: ["!", ["has", "point_count"]], pointEnabled: true, customIcon, minZoom: unclusteredMinZoom, maxZoom, iconSize: ["interpolate", ["exponential", 0.5], ["zoom"], unclusteredMinZoom, 0.5, (maxZoom + unclusteredMinZoom) * 0.5, 1], iconSizePropName: "", layoutProps: LAYOUT, ...restProps }),
    cluster && /* @__PURE__ */ jsx(GeoJsonLayer, { id: `${id}-clustered-no`, filter: ["!", ["has", "point_count"]], pointEnabled: true, customIcon, maxZoom: clusterMaxZoom, minZoom, iconSizePropName: "", layoutProps: LAYOUT, ...restProps }),
    cluster && /* @__PURE__ */ jsx(
      GeoJsonLayer,
      {
        id: `${id}-clustered`,
        filter: ["has", "point_count"],
        ...restProps,
        pointEnabled: true,
        textValuePropName: "point_count_abbreviated",
        circleRadius: 20,
        color: "rgba(245, 245, 245, 0.8)",
        colorPropName: "",
        textColor: "#000000",
        textColorPropName: "",
        maxZoom: clusterMaxZoom,
        minZoom,
        iconSizePropName: "",
        iconIdPropName: "",
        sourceProps: {
          cluster,
          clusterMaxZoom,
          clusterRadius: 50
        }
      }
    )
  ] });
}
ClusteredSymbols.propTypes = {
  id: propTypesExports$1.string,
  customIcon: propTypesExports$1.func,
  cluster: propTypesExports$1.bool,
  clusterZoom: propTypesExports$1.number,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number
};
ClusteredSymbols.defaultProps = {
  id: null,
  customIcon: null,
  cluster: false,
  clusterZoom: 16,
  minZoom: 5,
  maxZoom: 24
};
const PIXEL_RATIO$1 = 3;
function AccessPoints(props) {
  var _a3;
  const {
    id: layerId,
    features: data2,
    color,
    textColor: textColor2,
    textOpacity,
    textMinZoom,
    showText,
    cluster,
    clusterZoom,
    textColorPropName,
    textOpacityPropName,
    iconUrl: iconUrl2,
    sectorIconUrl,
    customIcon,
    minZoom,
    maxZoom,
    deviceTypes,
    ...restProps
  } = props;
  const activeTheme = useEnvStore((state) => state.env.activeTheme);
  const [collection, setCollection] = React__default.useState(null);
  const needSquaredIcon = React__default.useCallback((assetType) => {
    if (!assetType)
      return false;
    const found = deviceTypes == null ? void 0 : deviceTypes.find((d2) => d2.key === assetType);
    if (!(found == null ? void 0 : found.deviceCategory))
      return false;
    return found.deviceCategory.toLowerCase() === "wired";
  }, [deviceTypes]);
  const getDeviceIconUrl = React__default.useCallback((type) => {
    const item = deviceTypes == null ? void 0 : deviceTypes.find((d2) => d2.key === type);
    return item == null ? void 0 : item.url;
  }, [deviceTypes]);
  const getSectors = React__default.useCallback((feature2) => {
    var _a4, _b3, _c2;
    if (((_a4 = feature2.properties) == null ? void 0 : _a4.omni) === "yes") {
      return [{
        azimuth: 0,
        beamWidth: Math.PI * 2
      }];
    }
    const params2 = (_c2 = (_b3 = feature2.properties) == null ? void 0 : _b3.sectors) == null ? void 0 : _c2.map((sector) => ({
      azimuth: sector.azimuth,
      beamWidth: sector.beamWidth
    }));
    return params2 || [];
  }, []);
  React__default.useLayoutEffect(() => {
    if (!data2)
      return;
    const apFeatures = Array.isArray(data2) ? data2 : data2 == null ? void 0 : data2.features;
    setCollection({
      type: "FeatureCollection",
      features: apFeatures || []
    });
  }, [data2]);
  const labelProps = React__default.useMemo(() => {
    if (showText) {
      const textProps = {};
      if (activeTheme === "dark") {
        textProps.textColor = textColor2 || "#FFF";
        textProps.textOpacity = textOpacity;
        textProps.textBackground = true;
        textProps.paintProps = {
          "text-halo-width": 3,
          "text-halo-color": "rgba(0, 0, 0, 0.4)"
        };
      } else {
        textProps.textColor = textColor2 || "#000";
        textProps.textBackground = false;
        textProps.textOpacity = textOpacity;
      }
      return {
        textMinZoom,
        textValuePropName: "name",
        textColorPropName,
        textOpacityPropName,
        textOffset: 2.5,
        ...textProps
      };
    }
    return {};
  }, [activeTheme, showText, textColor2, textColorPropName, textMinZoom, textOpacity, textOpacityPropName]);
  const getCustomIcon = React__default.useCallback((feature2) => {
    var _a4, _b3;
    return IconUtil.createDeviceSymbol({
      sectors: getSectors(feature2),
      activityStatus: feature2.properties.activityStatus,
      deploymentStatus: feature2.properties.deploymentStatus,
      isSquare: needSquaredIcon((_a4 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a4.assetType),
      coreColor: color,
      coreIconUrl: iconUrl2 || getDeviceIconUrl((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.assetType),
      sectorIconUrl: sectorIconUrl || IconUrls.directionLeaf,
      pixelRatio: PIXEL_RATIO$1
    });
  }, [color, getDeviceIconUrl, getSectors, iconUrl2, needSquaredIcon, sectorIconUrl]);
  const numFeatures = ((_a3 = collection == null ? void 0 : collection.features) == null ? void 0 : _a3.length) || 0;
  if (!numFeatures)
    return null;
  return /* @__PURE__ */ jsx(ClusteredSymbols, { id: layerId, data: collection, customIcon: customIcon || getCustomIcon, minZoom, maxZoom, clusterZoom, cluster, iconSize: 1 / PIXEL_RATIO$1, ...restProps, ...labelProps });
}
AccessPoints.propTypes = {
  id: propTypesExports$1.string,
  // layerId
  features: propTypesExports$1.array,
  color: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  textColor: propTypesExports$1.string,
  textOpacity: propTypesExports$1.number,
  textMinZoom: propTypesExports$1.number,
  showText: propTypesExports$1.bool,
  cluster: propTypesExports$1.bool,
  clusterZoom: propTypesExports$1.number,
  textColorPropName: propTypesExports$1.string,
  textOpacityPropName: propTypesExports$1.number,
  iconIdPropName: propTypesExports$1.string,
  iconUrlPropName: propTypesExports$1.string,
  iconUrl: propTypesExports$1.string,
  sectorIconUrl: propTypesExports$1.string,
  customIcon: propTypesExports$1.func,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  deviceTypes: propTypesExports$1.array
};
AccessPoints.defaultProps = {
  id: "sai-features-view",
  features: [],
  color: "#ffffff",
  textColor: void 0,
  textOpacity: void 0,
  textColorPropName: void 0,
  textOpacityPropName: void 0,
  showText: false,
  cluster: false,
  iconIdPropName: "marker-symbol-id",
  iconUrlPropName: "marker-symbol",
  iconUrl: void 0,
  sectorIconUrl: void 0,
  customIcon: null,
  minZoom: 0,
  maxZoom: 24,
  textMinZoom: 20,
  clusterZoom: 16,
  deviceTypes: []
};
function FeaturesView(props) {
  const {
    id: layerId,
    singleFloorActive,
    onSelect,
    onChange,
    onDelete,
    drawMode,
    displayMode: displayMode2,
    editableFeatures,
    features: featuresIn,
    flooredBuildings,
    territories,
    color,
    colorPropName,
    opacity,
    opacityPropName,
    outlineColor,
    outlinePropName,
    outlineOpacity,
    outlineOpacityPropName,
    outlineDashArrayPropName,
    textColor: textColor2,
    textOpacity,
    textColorPropName,
    textOpacityPropName,
    showText,
    iconUrl: iconUrl2,
    iconUrlPropName,
    children,
    customIcon,
    minZoom,
    maxZoom,
    beforeId,
    deviceTypes
  } = props;
  const {
    map: theMap
  } = useMapbox();
  const enable3d = displayMode2 === "3d" && (drawMode === "noselect" || !drawMode);
  const numFeatures = (featuresIn == null ? void 0 : featuresIn.length) || 0;
  const enable25d = displayMode2 === "2.5d" && (drawMode === "noselect" || !drawMode);
  const enableFlooredBuilding = enable25d || enable3d;
  const drawAllowed = drawMode && drawMode !== "noselect";
  const allViewOnlyFeatures = React__default.useMemo(() => {
    if (!numFeatures)
      return null;
    if (!drawAllowed) {
      return featuresIn;
    }
    const viewOnlyFeatures = removeArray(featuresIn, editableFeatures, (a2, b2) => a2.id === b2.id);
    if (!(viewOnlyFeatures == null ? void 0 : viewOnlyFeatures.length))
      return null;
    return viewOnlyFeatures;
  }, [drawAllowed, editableFeatures, featuresIn, numFeatures]);
  const {
    collection,
    apFeatures
  } = React__default.useMemo(() => {
    if (!(allViewOnlyFeatures == null ? void 0 : allViewOnlyFeatures.length))
      return {
        collection: null,
        apFeatures: null
      };
    const apFeatures2 = [];
    const nonApFeatures = [];
    allViewOnlyFeatures.forEach((feature2) => {
      var _a3, _b3;
      if (((_a3 = feature2.properties) == null ? void 0 : _a3.category) === "accessPoint") {
        let clonedFeature = feature2;
        if (feature2.name && !((_b3 = feature2.properties) == null ? void 0 : _b3.name)) {
          clonedFeature = {
            ...feature2,
            properties: {
              ...feature2.properties,
              name: feature2.name
            }
          };
        }
        apFeatures2.push(clonedFeature);
      } else {
        nonApFeatures.push(feature2);
      }
    });
    let collection2 = null;
    if (nonApFeatures.length) {
      collection2 = {
        type: "FeatureCollection",
        features: nonApFeatures
      };
    }
    return {
      collection: collection2,
      apFeatures: apFeatures2.length ? apFeatures2 : null
    };
  }, [allViewOnlyFeatures]);
  const {
    strongHash,
    weakHash
  } = React__default.useMemo(() => {
    var _a3, _b3, _c2, _d2, _e2, _f3, _g;
    const nameHash = (_b3 = (_a3 = editableFeatures == null ? void 0 : editableFeatures[0]) == null ? void 0 : _a3.properties) == null ? void 0 : _b3.name;
    const editHash = (_d2 = (_c2 = editableFeatures == null ? void 0 : editableFeatures[0]) == null ? void 0 : _c2.properties) == null ? void 0 : _d2.drawMode;
    const viewHash = (_g = (_f3 = (_e2 = collection == null ? void 0 : collection.features) == null ? void 0 : _e2[0]) == null ? void 0 : _f3.properties) == null ? void 0 : _g.drawMode;
    const strongHash2 = `${drawMode}-${nameHash}-${editHash}-${viewHash}`;
    const weakHash2 = `${drawMode}-${nameHash}-${editHash || drawMode}`;
    return {
      strongHash: strongHash2,
      weakHash: weakHash2
    };
  }, [collection == null ? void 0 : collection.features, drawMode, editableFeatures]);
  React__default.useLayoutEffect(() => {
    if (theMap) {
      if (enable3d) {
        theMap.setMinPitch(0);
        theMap.setMaxPitch(85);
        theMap.setPitch(60);
      } else {
        theMap.setMinPitch(0);
        theMap.setMaxPitch(0);
        theMap.setPitch(0);
      }
    }
  }, [enable3d, theMap]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    children,
    enable3d && collection && !singleFloorActive && /* @__PURE__ */ jsx(GeoJsonLayer, { id: `${layerId}-3d`, data: collection, extrusionEnabled: true, thicknessEnabled: true, pointEnabled: true, color, colorPropName, opacity, opacityPropName, outlineColor, outlinePropName, outlineOpacity, outlineOpacityPropName, textColor: textColor2, textOpacity, textColorPropName, textOpacityPropName, iconUrl: iconUrl2, iconUrlPropName, customIcon, minZoom, maxZoom, beforeId }, `features-view-3d-${strongHash}`),
    collection && /* @__PURE__ */ jsx(
      GeoJsonLayer,
      {
        id: `${layerId}-2d`,
        data: collection,
        thicknessEnabled: false,
        fillEnabled: true,
        outlineEnabled: true,
        lineEnabled: true,
        pointEnabled: true,
        color,
        colorPropName,
        opacity,
        opacityPropName,
        outlineColor,
        outlinePropName,
        outlineOpacity,
        outlineOpacityPropName,
        outlineDashArrayPropName,
        textColor: textColor2,
        textOpacity,
        textColorPropName,
        textOpacityPropName,
        iconUrl: iconUrl2,
        iconUrlPropName,
        customIcon,
        minZoom,
        maxZoom,
        beforeId
      },
      `features-view-2d-${strongHash}`
    ),
    apFeatures && /* @__PURE__ */ jsx(AccessPoints, { id: `${layerId}-ap-2d`, features: apFeatures, deviceTypes, textColor: textColor2, textOpacity, textColorPropName, textOpacityPropName, showText, iconUrl: iconUrl2, iconUrlPropName, customIcon, minZoom, maxZoom, onlyAcessPoint: true }, `features-view-ap-2d-${strongHash}`),
    drawAllowed && /* @__PURE__ */ jsx(DrawControls, { mode: drawMode, onChange, onSelect, onDelete, features: editableFeatures, editableFeatures, enableDownload: false, enableButtons: [] }, `draw-control-${weakHash}`),
    enableFlooredBuilding && (flooredBuildings == null ? void 0 : flooredBuildings.map((flooredBuilding) => {
      var _a3, _b3;
      return ((_b3 = (_a3 = flooredBuilding == null ? void 0 : flooredBuilding.data) == null ? void 0 : _a3.features) == null ? void 0 : _b3.length) && /* @__PURE__ */ jsx(FlooredBuilding, { id: `${layerId}-floored-building-${flooredBuilding.buildingId}`, singleFloorActive, sourceId: `${layerId}-floored-building-source-${flooredBuilding.buildingId}`, data: flooredBuilding.data, getLevel: (f2) => f2.properties.levelNumber, color: "random", buildingHeight: flooredBuilding.buildingHeight }, flooredBuilding.buildingId);
    })),
    /* @__PURE__ */ jsx(Territories, { features: territories, enableOutline: true })
  ] });
}
FeaturesView.propTypes = {
  id: propTypesExports$1.string,
  // layerId
  singleFloorActive: propTypesExports$1.bool,
  onSelect: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  onDelete: propTypesExports$1.func,
  drawMode: propTypesExports$1.oneOf(["noselect", "select", "polygon", "point", "line", "circle", "rectangle", "any"]),
  displayMode: propTypesExports$1.oneOf(["3d", "2d"]),
  editableFeatures: propTypesExports$1.array,
  features: propTypesExports$1.array,
  deviceTypes: propTypesExports$1.array,
  flooredBuildings: propTypesExports$1.array,
  territories: propTypesExports$1.array,
  colorPropName: propTypesExports$1.string,
  color: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  opacity: propTypesExports$1.number,
  opacityPropName: propTypesExports$1.string,
  outlineColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  outlinePropName: propTypesExports$1.string,
  outlineOpacity: propTypesExports$1.number,
  outlineOpacityPropName: propTypesExports$1.string,
  outlineDashArrayPropName: propTypesExports$1.string,
  textColor: propTypesExports$1.string,
  textOpacity: propTypesExports$1.number,
  textColorPropName: propTypesExports$1.string,
  textOpacityPropName: propTypesExports$1.number,
  showText: propTypesExports$1.bool,
  iconUrlPropName: propTypesExports$1.string,
  iconUrl: propTypesExports$1.string,
  children: propTypesExports$1.node,
  customIcon: propTypesExports$1.func,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  beforeId: propTypesExports$1.string
};
FeaturesView.defaultProps = {
  id: "sai-features-view",
  singleFloorActive: false,
  onSelect: () => {
  },
  onChange: () => {
  },
  onDelete: () => {
  },
  drawMode: "select",
  displayMode: "2d",
  editableFeatures: [],
  features: [],
  deviceTypes: [],
  flooredBuildings: [],
  territories: [],
  colorPropName: void 0,
  color: void 0,
  opacity: 1,
  opacityPropName: void 0,
  outlineColor: void 0,
  outlinePropName: void 0,
  outlineOpacity: 1,
  outlineOpacityPropName: void 0,
  outlineDashArrayPropName: void 0,
  textColor: void 0,
  textOpacity: void 0,
  textColorPropName: void 0,
  textOpacityPropName: void 0,
  showText: false,
  iconUrlPropName: void 0,
  iconUrl: void 0,
  children: null,
  customIcon: null,
  minZoom: 0,
  maxZoom: 24,
  beforeId: ""
};
const snapSvgUrl$1 = IconUtil.getDotSvgUrl();
function MapClickPointsReceiver(props) {
  const {
    active: active3,
    updateClickPoints,
    maxClickPoints
  } = props;
  const {
    map: map5
  } = useMapbox();
  const clickPoints = React__default.useRef([]);
  const clickPointMarkers = React__default.useRef([]);
  const removeClickPoints = React__default.useCallback(() => {
    var _a3;
    if (((_a3 = clickPoints.current) == null ? void 0 : _a3.length) > 0) {
      const count3 = clickPoints.current.length;
      for (let i2 = 0; i2 < count3; i2 += 1) {
        clickPoints.current.pop();
        clickPointMarkers.current.pop().remove();
      }
      updateClickPoints([...clickPoints.current]);
    }
  }, [updateClickPoints]);
  const addClickPoints = React__default.useCallback((downEvent) => {
    var _a3;
    if (((_a3 = clickPoints.current) == null ? void 0 : _a3.length) < maxClickPoints) {
      clickPoints.current.push(downEvent.lngLat);
      const el = document.createElement("div");
      el.className = "marker";
      el.style.backgroundImage = `url('${snapSvgUrl$1}')`;
      el.style.width = "10px";
      el.style.height = "10px";
      el.style.backgroundSize = "100%";
      clickPointMarkers.current.push(new mapboxgl__default.Marker(el).setLngLat(downEvent.lngLat).addTo(map5));
      updateClickPoints([...clickPoints.current]);
    }
  }, [map5, maxClickPoints, updateClickPoints]);
  React__default.useEffect(() => {
    if (active3) {
      map5.on("click", addClickPoints);
      map5.on("contextmenu", removeClickPoints);
      if (map5.getCanvas())
        map5.getCanvas().style.cursor = "crosshair";
    }
    return () => {
      if (map5 && active3) {
        map5.off("click", addClickPoints);
        map5.off("contextmenu", removeClickPoints);
        if (map5.getCanvas())
          map5.getCanvas().style.cursor = "";
      }
    };
  }, [active3, addClickPoints, map5, removeClickPoints]);
  return null;
}
MapClickPointsReceiver.propTypes = {
  active: propTypesExports$1.bool,
  updateClickPoints: propTypesExports$1.func.isRequired,
  maxClickPoints: propTypesExports$1.number
};
MapClickPointsReceiver.defaultProps = {
  active: false,
  maxClickPoints: 2
};
function GeoreferencedImage(props) {
  const {
    url: url2,
    box,
    sourceId,
    layerId,
    enableEdit,
    onChange,
    opacity,
    azimuth,
    highlight
  } = props;
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const activateTool = React__default.useMemo(() => {
    if (!enableEdit)
      return "";
    switch (activeSubTool) {
      case "geoReferencingSnap":
        return "snap";
      case "geoReferencingDrag":
        return "drag";
      case "geoReferencingRotate":
        return "rotate";
      case "geoReferencingScale":
        return "scale";
      case "geoReferencingSkew":
        return "skew";
      default:
        return "";
    }
  }, [activeSubTool, enableEdit]);
  const onImageChange = React__default.useCallback((data2) => {
    if (!enableEdit)
      return;
    setActiveSubTool("");
    onChange(data2);
  }, [enableEdit, onChange, setActiveSubTool]);
  const hasImageData = url2 && box;
  if (!hasImageData)
    return null;
  return /* @__PURE__ */ jsx(ImageLayer2, { url: url2, box, sourceId, id: layerId, editType: activateTool, onChange: onImageChange, opacity, azimuth, enableBox: highlight });
}
GeoreferencedImage.propTypes = {
  url: propTypesExports$1.string,
  box: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  sourceId: propTypesExports$1.string,
  layerId: propTypesExports$1.string,
  enableEdit: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  opacity: propTypesExports$1.number,
  azimuth: propTypesExports$1.number,
  highlight: propTypesExports$1.bool
};
GeoreferencedImage.defaultProps = {
  url: null,
  box: null,
  sourceId: "",
  layerId: "",
  enableEdit: false,
  onChange: () => {
  },
  opacity: 1,
  azimuth: 0,
  highlight: false
};
function GeoreferencedAsset(props) {
  const {
    data: data2,
    enableEdit,
    displayMode: displayMode2,
    drawMode,
    onChange,
    onLoad: onLoadIn,
    onOpacityDone,
    ...restProps
  } = props;
  const activeTool = useViewStore((state) => state.activeTool);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const setEditAssetId = useAssetStore((state) => state.setEditAssetId);
  const editAssetId = useAssetStore((state) => state.editAssetId);
  const removeAsset = useAssetStore((state) => state.removeAsset);
  const [isLoaded, setIsLoaded] = React__default.useState(false);
  const enableTransform = enableEdit && isLoaded;
  const sourceId = `image${data2 == null ? void 0 : data2.id}`;
  const layerId = `image${data2 == null ? void 0 : data2.id}-layer`;
  const transformMode = React__default.useMemo(() => {
    if (!enableTransform)
      return "";
    switch (activeSubTool) {
      case "geoReferencingDrag":
        return "translate";
      case "geoReferencingRotate":
        return "rotate";
      case "geoReferencingScale":
        return "scale";
      default:
        return "";
    }
  }, [activeSubTool, enableTransform]);
  const onTransform = React__default.useCallback((data22) => {
    onChange(data22);
  }, [onChange, setActiveSubTool]);
  const onLoad = React__default.useCallback((data22) => {
    onLoadIn(data22);
    setIsLoaded(!!data22);
  }, [onLoadIn]);
  const onSelect = React__default.useCallback((feature2) => {
    var _a3;
    if (((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.sourceId) === sourceId) {
      setEditAssetId(null);
      setEditAssetId(data2 == null ? void 0 : data2.id);
    }
  }, [data2 == null ? void 0 : data2.id, setEditAssetId, sourceId]);
  const onGeoreferencedImageChange = React__default.useCallback((data22) => {
    onChange({
      ...data22,
      id: editAssetId
    });
  }, [editAssetId, onChange]);
  const onRemoveAssetDone = React__default.useCallback((remove6) => {
    setActiveSubTool("");
    if (remove6 && editAssetId)
      removeAsset(editAssetId);
  }, [editAssetId, removeAsset, setActiveSubTool]);
  const isImage = (data2 == null ? void 0 : data2.type) === "IMAGE";
  const enableCad = displayMode2 === data2.displayMode && (drawMode === "noselect" || !drawMode);
  if (!(data2 == null ? void 0 : data2.visible))
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !isImage && /* @__PURE__ */ jsx(CadLayer, { data: data2, enableTransform, onTransform, transformMode, enabled: enableCad, onLoad, opacity: data2.opacity, ...restProps }),
    isImage && /* @__PURE__ */ jsx(GeoreferencedImage, { url: data2.sourceFile.data, box: data2.box, sourceId, layerId, enableEdit: enableEdit && data2.id === editAssetId && activeSubTool, onChange: onGeoreferencedImageChange, opacity: data2.opacity, azimuth: data2.azimuth, highlight: data2.id === editAssetId }),
    isImage && activeTool === "geoReferencing" && /* @__PURE__ */ jsx(Interactions, { sourceId, layerIds: [layerId], onSelect, enableSelection: true, isRaster: true }),
    activeSubTool === "removeAsset" && /* @__PURE__ */ jsx(ModalForm, { title: "Do you want to proceed with removing selected object?", onCancel: () => {
      onRemoveAssetDone(false);
    }, onSubmit: () => {
      onRemoveAssetDone(true);
    }, active: editAssetId && activeSubTool === "removeAsset", component: RightPanel })
  ] });
}
GeoreferencedAsset.propTypes = {
  data: propTypesExports$1.object,
  displayMode: propTypesExports$1.oneOf(["3d", "2d"]),
  enableEdit: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  drawMode: propTypesExports$1.oneOf(["noselect", "select", "any", "polygon", "line", "point"]),
  onLoad: propTypesExports$1.func,
  onOpacityDone: propTypesExports$1.func
};
GeoreferencedAsset.defaultProps = {
  data: null,
  displayMode: "2d",
  enableEdit: false,
  onChange: () => {
  },
  drawMode: "select",
  onLoad: () => {
  },
  onOpacityDone: () => {
  }
};
const upload_class = "_upload_class_1ewu3_1";
const styles$a = {
  upload_class
};
const {
  useToken: useToken$s
} = theme$2;
const getBase64 = (file2) => new Promise((resolve2, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file2);
  reader.onload = () => resolve2(reader.result);
  reader.onerror = (error2) => reject(error2);
});
const FILE_SIZE_LIMIT = 4 * 1024 * 1024;
function UploadThumbnail(props) {
  const {
    value,
    onChange: onChangeIn
  } = props;
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [imageUrl, setImageUrl] = useState(value);
  const [file2, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const {
    token
  } = useToken$s();
  React__default.useLayoutEffect(() => {
    setImageUrl(value);
  }, [value]);
  const beforeUpload = React__default.useCallback((file22) => {
    const isJpgOrPng = file22.type === "image/jpeg" || file22.type === "image/png";
    if (!isJpgOrPng) {
      showMessageBox({
        content: "You can only upload JPG/PNG file!",
        type: "error"
      });
      return false;
    }
    if (file22.size > FILE_SIZE_LIMIT) {
      showMessageBox({
        content: "Image must be smaller than 4MB!",
        type: "error"
      });
      return false;
    }
    return true;
  }, []);
  const handleChange = React__default.useCallback(async ({
    file: file22
  }) => {
    if (!file22)
      return;
    setIsLoading(true);
    setFile(file22);
    if (!file22.url) {
      file22.url = await getBase64(file22.originFileObj);
    }
    setPreviewTitle(file22.name || file22.url.substring(file22.url.lastIndexOf("/") + 1));
    setImageUrl(file22.url);
    onChangeIn(file22.url);
    setIsLoading(false);
  }, [onChangeIn]);
  const handleCancel = React__default.useCallback(() => setPreviewOpen(false), []);
  const handlePreview = React__default.useCallback(async () => {
    setPreviewOpen(true);
  }, []);
  const uploadAction = React__default.useCallback(async () => {
    setIsLoading(false);
    return true;
  }, []);
  const uploadButton = React__default.useMemo(() => /* @__PURE__ */ jsxs(Flex, { justify: "space-evenly", align: "center", vertical: true, style: {
    height: "100%",
    width: "100%",
    padding: "16px"
  }, children: [
    /* @__PURE__ */ jsx(FileImageOutlined, { style: {
      color: token.colorPrimary,
      width: "33px",
      fontSize: "42px"
    } }),
    /* @__PURE__ */ jsx(Typography.Text, { style: {
      fontSize: token.fontSizeLG,
      fontWeight: 400
    }, children: "Click or drag file to this area to upload" }),
    /* @__PURE__ */ jsx(Typography.Text, { style: {
      fontSize: token.fontSize,
      fontColor: token.colorTextDescription
    }, children: "Pick a photo up to 4MB." })
  ] }), [token.colorPrimary, token.colorTextDescription, token.fontSize, token.fontSizeLG]);
  const hasImageLoaded = !isLoading && imageUrl;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Upload, { className: styles$a.upload_class, name: "thumbnail", showUploadList: false, action: uploadAction, beforeUpload, listType: "picture-card", fileList: file2 ? [file2] : [], onPreview: handlePreview, onChange: handleChange, children: [
      !hasImageLoaded && uploadButton,
      hasImageLoaded && /* @__PURE__ */ jsx("img", { src: imageUrl, alt: "thumbnail", style: {
        width: "100%",
        borderRadius: "8px",
        height: "170px"
      } })
    ] }),
    /* @__PURE__ */ jsx(Modal$1, { open: previewOpen, title: previewTitle, footer: null, onCancel: handleCancel, children: /* @__PURE__ */ jsx("img", { alt: "thumbnail", style: {
      width: "100%"
    }, src: imageUrl }) })
  ] });
}
UploadThumbnail.propTypes = {
  value: propTypesExports$1.string,
  // url
  onChange: propTypesExports$1.func
};
UploadThumbnail.defaultProps = {
  value: null,
  onChange: () => {
  }
};
function useDataApi(apiCallback, dep) {
  if (!dep)
    return null;
  return suspend$1(apiCallback, [dep]);
}
function useDataApiPreload(apiCallback, dep) {
  if (!dep)
    return null;
  return preload$1(apiCallback, [dep]);
}
function useDataApiClear(dep) {
  if (!dep)
    return null;
  return clear$2([dep]);
}
useDataApi.preload = useDataApiPreload;
useDataApi.clear = useDataApiClear;
const API_VERSION = "v1";
const PATH = "gis/common";
const BINGMAP_URL = "https://dev.virtualearth.net/REST/v1/Locations";
class AddressUtil {
  static getDataEndPoint() {
    const ep = useEnvStore.getState().env.saiPostgresEndpoint;
    if (!ep)
      throw new Error("Endpoint not defined");
    return `${ep}/${API_VERSION}/${PATH}`;
  }
  static async getApiHeaders() {
    const token = await SpectraTokenUtil.getToken();
    const headers = {
      "Content-Type": "application/json"
    };
    if (token)
      headers.Authorization = `Bearer ${token}`;
    return headers;
  }
  static async getCountries() {
    try {
      const countriesList = Countries$1;
      return (countriesList == null ? void 0 : countriesList.map((country) => ({
        key: country.id,
        label: country.name,
        value: country.name,
        countryCode: country.iso2,
        id: country.id,
        longitude: Number(country.longitude),
        latitude: Number(country.latitude)
      }))) || [];
    } catch (error2) {
      console.error(error2);
    }
    return [];
  }
  static async getStates(countryOrId) {
    try {
      if (!countryOrId)
        return [];
      const countryId = typeof countryOrId === "object" ? countryOrId.id : countryOrId;
      const headers = await AddressUtil.getApiHeaders();
      const res = await fetch(`${AddressUtil.getDataEndPoint()}/states/country/${countryId}`, {
        method: "GET",
        headers
      });
      if (!res.ok)
        return [];
      const stateList = await res.json();
      return (stateList == null ? void 0 : stateList.map((state) => ({
        key: state.id,
        label: state.name,
        value: state.name,
        id: state.id,
        countryId: state.country_id,
        stateCode: state.state_code,
        longitude: Number(state.longitude),
        latitude: Number(state.latitude)
      }))) || [];
    } catch (error2) {
      console.error(error2);
    }
    return [];
  }
  static async getCities(stateOrId) {
    try {
      if (!stateOrId)
        return [];
      const stateId = typeof stateOrId === "object" ? stateOrId.id : stateOrId;
      const headers = await AddressUtil.getApiHeaders();
      const res = await fetch(`${AddressUtil.getDataEndPoint()}/states/${stateId}/cities`, {
        method: "GET",
        headers
      });
      if (!res.ok)
        return [];
      const cityList = await res.json();
      return (cityList == null ? void 0 : cityList.map((city) => ({
        key: city.id,
        label: city.name,
        value: city.name,
        id: city.id,
        longitude: Number(city.longitude),
        latitude: Number(city.latitude)
      }))) || [];
    } catch (error2) {
      console.error(error2);
    }
    return [];
  }
  static async getAddress(position) {
    try {
      const BINGMAP_API_KEY = useEnvStore.getState().env.bingApiKey;
      if (!BINGMAP_API_KEY)
        throw new Error("Bing api key not found");
      const {
        latitude,
        longitude
      } = position || {};
      if (!latitude || !longitude)
        throw new Error("Invalid position");
      const url2 = `${BINGMAP_URL}/${latitude},${longitude}`;
      const response = await fetch(`${url2}?o=json&key=${BINGMAP_API_KEY}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      });
      const data2 = await response.json();
      const {
        resources
      } = data2.resourceSets[0];
      if (resources == null ? void 0 : resources.length) {
        let locationAddress = resources[0].name;
        if (locationAddress.length > 15) {
          locationAddress = locationAddress.replace(/, /g, "\n");
        }
        return locationAddress;
      }
    } catch (error2) {
      console.error(error2);
    }
    return "";
  }
}
function SuspendedFuncInternal(props) {
  const {
    func: func2,
    onLoad,
    args,
    onProgress
  } = props;
  const onLoad2 = useMutableFunc(onLoad);
  const onProgress2 = useMutableFunc(onProgress);
  React__default.useEffect(() => {
    onProgress2({
      loading: true
    });
  }, [onProgress2]);
  const data2 = func2(...args);
  React__default.useEffect(() => {
    onProgress2({
      loading: !!data2
    });
    onLoad2(data2);
  }, [data2, onLoad2, onProgress2]);
  return null;
}
SuspendedFuncInternal.propTypes = {
  func: propTypesExports$1.func,
  onLoad: propTypesExports$1.func,
  onProgress: propTypesExports$1.func,
  args: propTypesExports$1.array
};
SuspendedFuncInternal.defaultProps = {
  func: () => {
  },
  onLoad: () => {
  },
  onProgress: () => {
  },
  args: []
};
function SuspendedFunc(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(SuspendedFuncInternal, { ...props }) });
}
const COUNTRIES_KEY = "address-util-countries";
const STATES_KEY = "address-util-states";
const CITIES_KEY = "address-util-cities";
function useCountries() {
  useDataApi.preload(() => AddressUtil.getCountries(), COUNTRIES_KEY);
  return useDataApi(() => AddressUtil.getCountries(), COUNTRIES_KEY);
}
const USA_ID = 233;
function useStates(countryOrId) {
  const countryId = typeof countryOrId === "object" ? countryOrId == null ? void 0 : countryOrId.id : countryOrId;
  useDataApi.preload(() => AddressUtil.getStates(USA_ID), `${STATES_KEY}-${USA_ID}`);
  return useDataApi(() => AddressUtil.getStates(countryId), `${STATES_KEY}-${countryId}`);
}
const NY_ID = 1452;
function useCities(stateOrId) {
  const stateId = typeof stateOrId === "object" ? stateOrId == null ? void 0 : stateOrId.id : stateOrId;
  useDataApi.preload(() => AddressUtil.getCities(NY_ID), `${CITIES_KEY}-${NY_ID}`);
  return useDataApi(() => AddressUtil.getCities(stateId), `${CITIES_KEY}-${stateId}`);
}
function Countries(props) {
  return /* @__PURE__ */ jsx(SuspendedFunc, { func: useCountries, ...props });
}
Countries.propTypes = {
  onLoad: propTypesExports$1.func
};
Countries.defaultProps = {
  onLoad: () => {
  }
};
function States(props) {
  const {
    country,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsx(SuspendedFunc, { func: useStates, args: [country], ...restProps });
}
States.propTypes = {
  onLoad: propTypesExports$1.func,
  country: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number, propTypesExports$1.object])
};
States.defaultProps = {
  onLoad: () => {
  },
  country: null
};
function Cities(props) {
  const {
    state,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsx(SuspendedFunc, { func: useCities, ...restProps, args: [state] });
}
Cities.propTypes = {
  onLoad: propTypesExports$1.func,
  state: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number, propTypesExports$1.object])
};
Cities.defaultProps = {
  onLoad: () => {
  },
  state: null
};
function AddressSelector(props) {
  const {
    onChange,
    country,
    state
  } = props;
  const updateValues = React__default.useCallback((input) => {
    onChange((prev) => ({
      ...prev || {},
      ...input || {},
      loading: {
        ...(prev == null ? void 0 : prev.loading) || {},
        ...(input == null ? void 0 : input.loading) || {}
      }
    }));
  }, [onChange]);
  const updateProgress = React__default.useCallback((input) => {
    updateValues({
      loading: input
    });
  }, [updateValues]);
  const setCountries = React__default.useCallback((countries) => {
    updateValues({
      countries
    });
  }, [updateValues]);
  const setStates = React__default.useCallback((states) => {
    updateValues({
      states
    });
  }, [updateValues]);
  const setCities = React__default.useCallback((cities) => {
    updateValues({
      cities
    });
  }, [updateValues]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Countries, { onLoad: setCountries, onProgress: ({
      loading: loading2
    }) => updateProgress({
      countries: loading2
    }) }),
    /* @__PURE__ */ jsx(States, { onLoad: setStates, country, onProgress: ({
      loading: loading2
    }) => updateProgress({
      states: loading2
    }) }),
    /* @__PURE__ */ jsx(Cities, { onLoad: setCities, state, onProgress: ({
      loading: loading2
    }) => updateProgress({
      cities: loading2
    }) })
  ] });
}
AddressSelector.propTypes = {
  onChange: propTypesExports$1.func,
  // value: PropTypes.shape({
  //   countries: PropTypes.arrayOf(PropTypes.object),
  //   states: PropTypes.arrayOf(PropTypes.object),
  //   cities: PropTypes.arrayOf(PropTypes.object),
  // }),
  country: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.string]),
  state: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.string])
};
AddressSelector.defaultProps = {
  onChange: () => {
  },
  // value: {},
  country: null,
  state: null
};
function MapMoveTo(props) {
  const {
    center: center2,
    type,
    ...otherProps
  } = props;
  const {
    map: map5
  } = useMapbox();
  const otherPropsRef = useValueRef(otherProps);
  React__default.useLayoutEffect(() => {
    if (map5 && center2 && Array.isArray(center2)) {
      if (type === "jumpTo")
        map5.jumpTo({
          center: center2,
          ...otherPropsRef.current
        });
      else if (type === "easeTo")
        map5.easeTo({
          center: center2,
          ...otherPropsRef.current
        });
      else if (type === "flyTo")
        map5.flyTo({
          center: center2,
          ...otherPropsRef.current
        });
    }
  }, [center2, map5, type, otherPropsRef]);
  return null;
}
MapMoveTo.propTypes = {
  center: propTypesExports$1.array,
  type: propTypesExports$1.oneOf(["jumpTo", "easeTo", "flyTo"])
};
MapMoveTo.defaultProps = {
  center: null,
  type: "easeTo"
};
function AddressPicker(props) {
  var _a3, _b3;
  const {
    onDraw,
    value: data2,
    onChange: onFormValuesChange,
    disableAddressLine1,
    disableAddressLine2,
    disableCountry,
    disableCity,
    disableState,
    disablePostalCode
  } = props;
  const dataRef = useValueRef(data2);
  const [helperData, setHelperData] = React__default.useState({});
  const [enableAutoFocus, setEnableAutoFocus] = React__default.useState(false);
  const disallowAddressChangeRef = React__default.useRef(false);
  const curateAddress = React__default.useCallback(({
    addressObject: addressObjectIn,
    filterField
  }) => {
    const addressObject = {
      ...addressObjectIn
    };
    switch (filterField) {
      case "country":
        addressObject.addressLine1 = null;
        addressObject.addressLine2 = null;
        addressObject.state = null;
        addressObject.city = null;
        addressObject.postalCode = null;
        break;
      case "state":
        addressObject.addressLine1 = null;
        addressObject.addressLine2 = null;
        addressObject.city = null;
        addressObject.postalCode = null;
        break;
      case "city":
        addressObject.addressLine1 = null;
        addressObject.addressLine2 = null;
        addressObject.postalCode = null;
        break;
      case "postalCode":
        addressObject.addressLine1 = null;
        addressObject.addressLine2 = null;
        addressObject.country = null;
        addressObject.state = null;
        addressObject.city = null;
        break;
    }
    return addressObject;
  }, []);
  const updateAddressFields = React__default.useCallback(async (changedData, oldData) => {
    var _a4;
    let newData = {
      ...oldData || {},
      ...changedData || {}
    };
    try {
      if (!changedData)
        return newData;
      const changedField = (_a4 = Object.keys(changedData)) == null ? void 0 : _a4[0];
      if (!changedField)
        return newData;
      if (["addressLine1"].includes(changedField) && newData.latitude)
        return newData;
      newData = curateAddress({
        addressObject: newData,
        filterField: changedField
      });
      const needsLngLat = !["latitude", "longitude"].includes(changedField);
      let geoData;
      if (needsLngLat) {
        geoData = await GeocoderUtil.geocode(newData);
      }
      if (!needsLngLat) {
        const coord = {
          latitude: newData.latitude,
          longitude: newData.longitude
        };
        geoData = await GeocoderUtil.reverseGeocode(coord);
      }
      geoData = curateAddress({
        addressObject: geoData,
        filterField: changedField
      });
      return geoData;
    } catch (error2) {
      console.error(error2);
    }
    return newData;
  }, [curateAddress]);
  const onFieldChange = React__default.useCallback((changed) => {
    if (disallowAddressChangeRef.current)
      return;
    disallowAddressChangeRef.current = true;
    updateAddressFields(changed, dataRef.current).then((data22) => {
      var _a4;
      onFormValuesChange(data22);
      if ((data22 == null ? void 0 : data22.latitude) && data22.latitude !== ((_a4 = dataRef.current) == null ? void 0 : _a4.latitude)) {
        lastCenterRef.current = [data22.longitude, data22.latitude];
        setEnableAutoFocus(true);
      }
      setTimeout(() => {
        disallowAddressChangeRef.current = false;
      }, 100);
    });
  }, [dataRef, onFormValuesChange, updateAddressFields]);
  const lastCenterRef = React__default.useRef([0, 0]);
  React__default.useLayoutEffect(() => {
    if (disallowAddressChangeRef.current)
      return;
    const lastLongitude = lastCenterRef.current[0];
    const lastLatitude = lastCenterRef.current[1];
    const EPSILON2 = 1e-6;
    if ((data2 == null ? void 0 : data2.latitude) && (data2 == null ? void 0 : data2.longitude) && Math.abs(lastLatitude - data2.latitude) > EPSILON2 && Math.abs(lastLongitude - data2.longitude) > EPSILON2) {
      onFieldChange({
        latitude: data2.latitude,
        longitude: data2.longitude
      });
    }
  }, [data2 == null ? void 0 : data2.latitude, data2 == null ? void 0 : data2.longitude, onFieldChange]);
  React__default.useLayoutEffect(() => {
    if (enableAutoFocus) {
      setTimeout(() => setEnableAutoFocus(false), 10);
    }
  }, [enableAutoFocus]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Form.Item, { style: {
      width: "100%"
    }, children: [
      /* @__PURE__ */ jsx(AddressSelector, { onChange: setHelperData, value: helperData, country: (_a3 = helperData == null ? void 0 : helperData.countries) == null ? void 0 : _a3.find((item) => item.label === (data2 == null ? void 0 : data2.country)), state: (_b3 = helperData == null ? void 0 : helperData.states) == null ? void 0 : _b3.find((item) => item.label === (data2 == null ? void 0 : data2.state)) }),
      /* @__PURE__ */ jsx(FormItemLatLon, { onPickerClick: () => onDraw("point"), compact: true }),
      !disableAddressLine1 && /* @__PURE__ */ jsx(Form.Item, { name: "addressLine1", label: "Address 1", getValueFromEvent: (e3) => {
        var _a4;
        return (_a4 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a4.value;
      }, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Address 1", filled: true, onPressEnter: (event) => {
        var _a4;
        return onFieldChange({
          addressLine1: (_a4 = event == null ? void 0 : event.target) == null ? void 0 : _a4.value
        });
      }, allowClear: true }) }),
      !disableAddressLine2 && /* @__PURE__ */ jsx(Form.Item, { name: "addressLine2", label: "Address 2", getValueFromEvent: (e3) => {
        var _a4;
        return (_a4 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a4.value;
      }, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Address 2", filled: true, onPressEnter: (event) => {
        var _a4;
        return onFieldChange({
          addressLine2: (_a4 = event == null ? void 0 : event.target) == null ? void 0 : _a4.value
        });
      }, allowClear: true }) }),
      !disableCountry && /* @__PURE__ */ jsx(Form.Item, { name: "country", label: "Country", children: /* @__PURE__ */ jsx(Select, { placeholder: "Choose Country", showSearch: true, data: helperData == null ? void 0 : helperData.countries, value: data2 == null ? void 0 : data2.country, onChange: (value) => onFieldChange({
        country: value
      }) }) }),
      /* @__PURE__ */ jsxs(Flex, { gap: 12, children: [
        !disableState && /* @__PURE__ */ jsx(Form.Item, { name: "state", label: "State", style: {
          flex: 1
        }, children: /* @__PURE__ */ jsx(Select, { placeholder: "Enter State", showSearch: true, data: helperData == null ? void 0 : helperData.states, value: data2 == null ? void 0 : data2.state, onChange: (value) => onFieldChange({
          state: value
        }) }) }),
        !disableCity && /* @__PURE__ */ jsx(Form.Item, { name: "city", label: "City", style: {
          flex: 1
        }, children: /* @__PURE__ */ jsx(Select, { placeholder: "Enter City", showSearch: true, data: helperData == null ? void 0 : helperData.cities, value: data2 == null ? void 0 : data2.city, onChange: (value) => onFieldChange({
          city: value
        }) }) })
      ] }),
      /* @__PURE__ */ jsx(Flex, { gap: 12, children: !disablePostalCode && /* @__PURE__ */ jsx(Form.Item, { name: "postalCode", label: "Zip Code", getValueFromEvent: (e3) => {
        var _a4;
        return (_a4 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a4.value;
      }, style: {
        flex: 1
      }, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Zip Code", filled: true, onPressEnter: (event) => {
        var _a4;
        return onFieldChange({
          postalCode: (_a4 = event == null ? void 0 : event.target) == null ? void 0 : _a4.value
        });
      }, allowClear: true }) }) })
    ] }),
    enableAutoFocus && lastCenterRef.current[0] && /* @__PURE__ */ jsx(MapMoveTo, { center: lastCenterRef.current, type: "flyTo" })
  ] });
}
AddressPicker.propTypes = {
  onDraw: propTypesExports$1.func,
  value: propTypesExports$1.object,
  onChange: propTypesExports$1.func,
  disableAddressLine1: propTypesExports$1.bool,
  disableAddressLine2: propTypesExports$1.bool,
  disableCountry: propTypesExports$1.bool,
  disableCity: propTypesExports$1.bool,
  disableState: propTypesExports$1.bool,
  disablePostalCode: propTypesExports$1.bool
};
AddressPicker.defaultProps = {
  onDraw: () => {
  },
  value: {},
  onChange: () => {
  },
  disableAddressLine1: false,
  disableAddressLine2: false,
  disableCountry: false,
  disableCity: false,
  disableState: false,
  disablePostalCode: false
};
const {
  Title: Title$e
} = Typography;
const PremisesType = [{
  key: "StadiumPremises",
  value: "Stadium",
  label: "Stadium"
}, {
  key: "EducationalPremises",
  value: "Educational",
  label: "Educational"
}, {
  key: "OfficePremises",
  value: "Office",
  label: "Office"
}, {
  key: "ResidentialPremises",
  value: "Residential",
  label: "Residential"
}, {
  key: "HotelPremises",
  value: "Hotel",
  label: "Hotel"
}, {
  key: "LaboratoryPremises",
  value: "Laboratory",
  label: "Laboratory"
}, {
  key: "HospitalPremises",
  value: "Hospital",
  label: "Hospital"
}, {
  key: "RestaurantPremises",
  value: "Restaurant",
  label: "Restaurant"
}, {
  key: "RetailPremises",
  value: "Retail",
  label: "Retail"
}, {
  key: "GaragePremises",
  value: "Garage",
  label: "Garage"
}, {
  key: "LightIndustryPremises",
  value: "Light Industry",
  label: "Light Industry"
}, {
  key: "StoragePremises",
  value: "Storage",
  label: "Storage"
}, {
  key: "CoffeePremises",
  value: "Coffee",
  label: "Coffee"
}];
const EXTENSIONS$4 = ["png", "jpg", "pdf"];
function VenueForm(props) {
  const {
    onDone,
    onDraw,
    value: data2,
    onChange,
    onUpload,
    onExport,
    mode: mode2,
    subForm: SubForm,
    subFormProps,
    disabled,
    hidden,
    objectTypes,
    onAddBuilding: onAddBuildingIn
  } = props;
  const {
    token
  } = theme$2.useToken();
  const formRef = React__default.useRef();
  const formTitle = React__default.useMemo(() => {
    if (!mode2)
      return null;
    return mode2 === "Add" ? "New" : mode2;
  }, [mode2]);
  const isCreate = mode2 === "Add";
  const onFormValuesChange = React__default.useCallback((data22) => {
    onChange(data22);
  }, [onChange]);
  const onSubmit = React__default.useCallback((values4) => {
    onDone(values4, mode2 === "Add");
  }, [mode2, onDone]);
  const validateHasFeatures = React__default.useCallback(async () => {
    if (data2 == null ? void 0 : data2.hasFeatures)
      return;
    throw new Error("Draw or Import new features to the layer");
  }, [data2 == null ? void 0 : data2.hasFeatures]);
  const onAddBuilding = React__default.useCallback(() => {
    const form = formRef.current;
    if (!form)
      return;
    form.validateFields().then(() => {
      form.submit();
      onAddBuildingIn();
    }).catch(() => {
      var _a3;
      const data22 = form.getFieldsError().find(({
        errors
      }) => !!(errors == null ? void 0 : errors.length));
      if ((_a3 = data22 == null ? void 0 : data22.errors) == null ? void 0 : _a3[0]) {
        message$1.error(data22.errors[0]);
      }
    });
  }, [onAddBuildingIn]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title$e, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: formTitle }), [formTitle]);
  const component = React__default.useCallback((params2) => {
    const newParams = {
      ...params2,
      exportDetails: !isCreate ? {
        onClick: onExport,
        hidden: hidden.download,
        disabled: disabled.download,
        rules: [{
          validator: validateHasFeatures
        }]
      } : null,
      importDetails: isCreate ? {
        onClick: () => onUpload(EXTENSIONS$4),
        hidden: hidden.upload,
        disabled: disabled.upload,
        rules: [{
          validator: validateHasFeatures
        }]
      } : null,
      customButtonDetails: {
        // type: 'primary',
        onClick: onAddBuilding,
        text: "Add Buildings",
        buttonProps: {
          block: true,
          size: "large"
        }
      }
    };
    return /* @__PURE__ */ jsx(RightPanel, { ...newParams, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, { style: {
      color: token.colorIcon
    } }) });
  }, [isCreate, onExport, hidden.download, hidden.upload, disabled.download, disabled.upload, validateHasFeatures, onAddBuilding, token.colorIcon, onUpload]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { ref: formRef, component, title, onCancel: () => onDone(), onSubmit, active: true, formValues: data2, onChange: onFormValuesChange, marginVertical: 0, marginHorizontal: 0, bodyStyle: {
    padding: "8px 24px 0px 24px"
  }, footerStyle: {
    width: "100%",
    padding: 0
  }, showErrors: true, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", initialValue: "venue", hidden: hidden.objectType, children: /* @__PURE__ */ jsx(Select, { placeholder: "Layer Type", data: objectTypes, value: data2.objectType, disabled: disabled.objectType }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "thumbnail", children: /* @__PURE__ */ jsx(UploadThumbnail, {}) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Venue Name", rules: [{
      required: true
    }], hidden: hidden.name, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter venue name", disabled: disabled.name, filled: true }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "venueType", label: "Premises Type", rules: [{
      required: true
    }], children: /* @__PURE__ */ jsx(Select, { placeholder: "Choose premises type", showSearch: true, data: PremisesType, value: data2.venueType, onChange: (value) => onFormValuesChange({
      ...data2,
      venueType: value
    }) }) }),
    /* @__PURE__ */ jsxs("div", { style: {
      borderTop: `1px solid ${token.colorSplit}`,
      borderBottom: `1px solid ${token.colorSplit}`,
      marginLeft: "-24px",
      padding: "8px 0px 8px 24px",
      marginBottom: "8px"
    }, children: [
      /* @__PURE__ */ jsx(Form.Item, { name: "draw", label: /* @__PURE__ */ jsx(Typography.Text, { strong: true, style: {
        paddingBottom: "8px"
      }, children: "Venue Boundaries" }), hidden: !!SubForm && !!(subFormProps == null ? void 0 : subFormProps.open), children: /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, style: {
        padding: "5px"
      }, icon: /* @__PURE__ */ jsx(Icons.PenIconDark, { style: {
        fontSize: "15px",
        color: "transparent"
      } }), onClick: () => {
        var _a3;
        return (_a3 = subFormProps == null ? void 0 : subFormProps.setOpen) == null ? void 0 : _a3.call(subFormProps, true);
      }, children: "Draw boundaries" }) }),
      SubForm && /* @__PURE__ */ jsx(SubForm, { ...subFormProps })
    ] }),
    /* @__PURE__ */ jsx(AddressPicker, { onDraw, value: data2, onChange: onFormValuesChange }),
    /* @__PURE__ */ jsx(Form.Item, { name: "temporaryEvent", label: "Temporary Event", style: {
      flex: 1
    }, children: /* @__PURE__ */ jsx(Switch$1, {}) })
  ] });
}
VenueForm.propTypes = {
  onDone: propTypesExports$1.func,
  onDraw: propTypesExports$1.func,
  onUpload: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  onAddBuilding: propTypesExports$1.func,
  value: propTypesExports$1.object,
  mode: propTypesExports$1.string,
  subForm: propTypesExports$1.any,
  subFormProps: propTypesExports$1.object,
  disabled: propTypesExports$1.object,
  hidden: propTypesExports$1.object,
  objectTypes: propTypesExports$1.array,
  onExport: propTypesExports$1.func
};
VenueForm.defaultProps = {
  onDone: () => {
  },
  onDraw: () => {
  },
  onUpload: () => {
  },
  onChange: () => {
  },
  onAddBuilding: () => {
  },
  value: {},
  mode: null,
  subForm: null,
  subFormProps: {},
  disabled: {},
  hidden: {},
  objectTypes: [],
  onExport: () => {
  }
};
const select_options = "_select_options_vptq9_1";
const styles$9 = {
  select_options
};
const {
  useToken: useToken$r
} = theme$2;
const strokeStyleOptions = [{
  key: "stroke",
  value: "1, 0",
  label: /* @__PURE__ */ jsx("div", { style: {
    borderTop: "2px solid"
  } })
}, {
  key: "dasharray-1-1",
  value: "1, 1",
  label: /* @__PURE__ */ jsx("div", { style: {
    borderTop: "2px dotted"
  } })
}, {
  key: "dasharray-2-2",
  value: "2, 2",
  label: /* @__PURE__ */ jsx("div", { style: {
    borderTop: "2px dashed",
    borderStyle: "dashed",
    borderWidth: "2px"
  } })
}, {
  key: "dasharray-3-3",
  value: "3, 3",
  label: /* @__PURE__ */ jsx("div", { style: {
    borderTop: "4px dashed"
  } })
}, {
  key: "dasharray-1-2",
  value: "1, 2",
  label: /* @__PURE__ */ jsx("div", { style: {
    borderTop: "2px dashed",
    borderStyle: "dashed",
    borderWidth: "2px"
  } })
}, {
  key: "dasharray-1-3",
  value: "1, 3",
  label: /* @__PURE__ */ jsx("div", { style: {
    borderTop: "2px dashed",
    borderStyle: "dashed",
    borderWidth: "2px"
  } })
}];
function StyleForm(props) {
  const {
    value,
    onChange,
    open: open2,
    setOpen,
    toogleIsDrawToolOn,
    isDrawToolOn,
    hidden: hiddenIn,
    showCloseIcon,
    showDivider
  } = props;
  const [form] = Form.useForm();
  const {
    token
  } = useToken$r();
  const [data2, setData6] = React__default.useState({});
  const hidden = React__default.useMemo(() => ({
    ...hiddenIn,
    stroke: true,
    // Not in figma
    "stroke-opacity": true
    // Not in figma
  }), [hiddenIn]);
  React__default.useLayoutEffect(() => {
    if (value) {
      const dasharray = value["stroke-dasharray"];
      let strokeStyle;
      if (Array.isArray(dasharray)) {
        strokeStyle = dasharray.join(", ");
      } else {
        strokeStyle = "1, 0";
      }
      const formValue = {
        ...value,
        "fill-opacity": typeof value["fill-opacity"] === "number" ? value["fill-opacity"] : 1,
        "stroke-opacity": typeof value["stroke-opacity"] === "number" ? value["stroke-opacity"] : 1,
        strokeStyle
      };
      setData6(formValue);
      if (Object.keys(formValue).length) {
        form.setFieldsValue({
          ...formValue
        });
      }
    } else {
      setData6({});
    }
  }, [form, value]);
  const outgoingValues = React__default.useCallback((values4) => {
    if (!values4)
      return values4;
    const dashArray = values4.strokeStyle ? values4.strokeStyle.split(",").map((n2) => Number(n2)) : [1, 0];
    const newValues = {
      ...values4,
      "fill-opacity": typeof values4["fill-opacity"] === "number" ? values4["fill-opacity"] : 1,
      "stroke-opacity": typeof values4["stroke-opacity"] === "number" ? values4["stroke-opacity"] : 1,
      "stroke-dasharray": dashArray,
      "hide-when-zoomed-in": values4["hide-when-zoomed-in"] ? 1 : 0
    };
    delete newValues.strokeStyle;
    newValues.stroke = newValues.fill;
    return newValues;
  }, []);
  const onColorChange = React__default.useCallback((color) => {
    const hexColor = typeof color === "string" ? color : color == null ? void 0 : color.toHexString();
    return hexColor;
  }, []);
  const onValuesChange = React__default.useCallback((values4, allValues) => {
    const modified = outgoingValues(allValues);
    onChange(modified);
  }, [outgoingValues, onChange]);
  if (!data2 || !open2)
    return null;
  return /* @__PURE__ */ jsx(Form, { form, layout: "vertical", autoComplete: "off", onValuesChange, colon: false, initialValues: data2, children: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Flex, { justify: "space-between", style: {
      paddingBottom: "5px"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: (token == null ? void 0 : token.labelFontSize) ?? "14px",
        fontWeight: "450"
      }, children: "Style" }),
      showCloseIcon && /* @__PURE__ */ jsx(CloseOutlined, { onClick: () => setOpen(false) })
    ] }),
    open2 && /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", style: {
      marginBottom: "5px"
    }, children: [
      /* @__PURE__ */ jsx(Form.Item, { name: "fill", rules: [{
        required: false
      }], getValueFromEvent: onColorChange, hidden: !open2 || hidden.fill, style: {
        margin: 0
      }, children: /* @__PURE__ */ jsx(ColorPicker, { size: "small", disabledAlpha: true, style: {
        height: "24px",
        width: "24px"
      } }) }),
      /* @__PURE__ */ jsx(Input$2, { value: value.fill, style: {
        height: "24px",
        alignContent: "center",
        width: "90%"
      } })
    ] }),
    /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", style: {
      marginBottom: "5px"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: "14px",
        fontWeight: "400",
        width: "15%"
      }, children: "Fill" }),
      /* @__PURE__ */ jsx(Form.Item, { layout: "horizontal", label: "", name: "fill-opacity", hidden: !open2 || hidden["fill-opacity"], style: {
        width: "85%",
        height: "100%",
        margin: 0
      }, children: /* @__PURE__ */ jsx(AlphaPicker, { width: 200, color: value.fill, radius: 8, height: 10 }) })
    ] }),
    /* @__PURE__ */ jsxs(Row, { justify: "space-between", align: "middle", children: [
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: "14px",
        fontWeight: "400",
        width: "15%"
      }, children: "Border" }),
      /* @__PURE__ */ jsx(Form.Item, { name: "strokeStyle", hidden: !open2 || hidden.strokeStyle, style: {
        width: "65%",
        height: "100%",
        margin: 0
      }, children: /* @__PURE__ */ jsx(Select$1, { placeholder: "Choose Stroke Style", className: styles$9.select_options, style: {
        height: "24px",
        width: "200px"
      }, children: strokeStyleOptions.map((option) => /* @__PURE__ */ jsx(Select$1.Option, { value: option.value, children: option.label }, option.key)) }) }),
      /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        justifyContent: "space-between",
        width: "20%",
        backgroundColor: token.colorBgContainer,
        border: `1px solid ${token.colorBorder}`,
        padding: "0px 6px 0px 6px",
        borderRadius: "4px",
        height: "24px",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx(Icons.StrokeWidth, { style: {
          fontSize: "14px",
          color: "transparent",
          margin: 0
        } }),
        /* @__PURE__ */ jsx(Form.Item, { name: "stroke-width", style: {
          margin: 0
        }, hidden: !open2 || hidden["stroke-width"], children: /* @__PURE__ */ jsx(InputNumber$1, { min: 1, max: 10, step: 1, style: {
          border: "none",
          width: "100%"
        } }) })
      ] })
    ] }),
    open2 && /* @__PURE__ */ jsxs(Row, { style: {
      width: "100%",
      margin: "2px 0px",
      height: hidden.stroke ? "0px" : "24px",
      marginBottom: "6px"
    }, justify: "space-between", children: [
      /* @__PURE__ */ jsx(Form.Item, { name: "stroke", rules: [{
        required: false
      }], getValueFromEvent: onColorChange, hidden: !open2 || hidden.stroke, style: {
        display: "flex !important",
        flexDirection: "row"
      }, children: /* @__PURE__ */ jsx(ColorPicker, { size: "small", style: {
        marginBottom: "2px"
      }, disabledAlpha: true }) }),
      !hidden.stroke && /* @__PURE__ */ jsx("span", { style: {
        border: `1px solid ${token.colorBorder}`,
        borderRadius: "4px",
        backgroundColor: token.colorBgContainer,
        padding: "3px 8px 0px 8px",
        width: "88%",
        height: "24px"
      }, children: /* @__PURE__ */ jsx(Typography.Text, { children: value.stroke }) })
    ] }),
    /* @__PURE__ */ jsxs(Row, { align: "middle", style: {
      marginBottom: "5px"
    }, children: [
      /* @__PURE__ */ jsx(Form.Item, { layout: "horizontal", name: "hide-when-zoomed-in", hidden: !open2 || hidden["hide-when-zoomed-in"], style: {
        margin: 0
      }, children: /* @__PURE__ */ jsx(Switch$1, { defaultChecked: false, style: {
        marginRight: "10px"
      }, size: "small" }) }),
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: "14px",
        fontWeight: "400"
      }, children: "Hide when zoomed in" })
    ] }),
    /* @__PURE__ */ jsx(Form.Item, { name: "stroke-opacity", label: "Opacity", style: {
      marginTop: 16
    }, hidden: !open2 || hidden["stroke-opacity"], children: /* @__PURE__ */ jsx(NumberSlider, { min: 0, max: 1, step: 0.01 }) }),
    /* @__PURE__ */ jsxs(Row, { align: "middle", style: {
      marginBottom: "10px"
    }, children: [
      /* @__PURE__ */ jsx(Form.Item, { hidden: !open2 || hidden.hide, style: {
        margin: "0 10px 0 0"
      }, children: /* @__PURE__ */ jsx(Button, { type: "default", icon: /* @__PURE__ */ jsx(EyeInvisibleOutlined, { style: {
        paddingRight: "6px"
      } }), onClick: () => setOpen(false), block: true, style: {
        boxShadow: "none"
      }, children: "Hide" }) }),
      /* @__PURE__ */ jsx(Form.Item, { hidden: !open2 || hidden.edit, style: {
        margin: 0
      }, children: /* @__PURE__ */ jsx(Button, { type: isDrawToolOn ? "primary" : "default", ghost: isDrawToolOn, style: {
        boxShadow: "none",
        color: isDrawToolOn ? token.colorPrimary : "white"
      }, icon: isDrawToolOn ? /* @__PURE__ */ jsx(Icons.PenIconDark, { style: {
        paddingRight: "6px",
        color: "transparent"
      } }) : /* @__PURE__ */ jsx(Icons.PenToolDisable, { style: {
        paddingRight: "6px",
        color: "transparent"
      } }), onClick: () => toogleIsDrawToolOn(!isDrawToolOn), block: true, children: "Edit" }) })
    ] }),
    showDivider && /* @__PURE__ */ jsx(Divider, { style: {
      margin: "10px 0"
    } })
  ] }) });
}
StyleForm.propTypes = {
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object,
  open: propTypesExports$1.bool,
  setOpen: propTypesExports$1.func,
  toogleIsDrawToolOn: propTypesExports$1.func,
  isDrawToolOn: propTypesExports$1.bool,
  hidden: propTypesExports$1.object,
  showCloseIcon: propTypesExports$1.bool,
  showDivider: propTypesExports$1.bool
};
StyleForm.defaultProps = {
  onChange: () => {
  },
  value: {},
  open: true,
  setOpen: () => {
  },
  toogleIsDrawToolOn: () => {
  },
  isDrawToolOn: false,
  hidden: {},
  showCloseIcon: false,
  showDivider: false
};
function MapToolInfo(props) {
  const {
    title,
    onDone,
    children
  } = props;
  const component = React__default.useCallback((params2) => /* @__PURE__ */ jsx(RightPanel, { ...params2, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}) }), []);
  return /* @__PURE__ */ jsx(ModalForm, { component, title, onCancel: () => onDone(), active: true, formValues: {}, marginVertical: 0, marginHorizontal: 0, nofooter: true, children });
}
MapToolInfo.propTypes = {
  title: propTypesExports$1.string,
  children: propTypesExports$1.node,
  onDone: propTypesExports$1.func
};
MapToolInfo.defaultProps = {
  title: "",
  children: null,
  onDone: () => {
  }
};
const FALLBACK_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==";
const {
  Text: Text$e
} = Typography;
const textColor$4 = {
  border: "none",
  paddingLeft: "12px"
};
function getFormValues$4(object2) {
  var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h;
  if (!object2)
    return {};
  return {
    id: object2.id,
    objectType: (object2 == null ? void 0 : object2.objectType) || (object2 == null ? void 0 : object2.type),
    name: object2.name,
    venueType: object2.venueType,
    longitude: (_a3 = object2.center) == null ? void 0 : _a3[0],
    latitude: (_b3 = object2.center) == null ? void 0 : _b3[1],
    addressLine1: (_c2 = object2.address) == null ? void 0 : _c2.addressLine1,
    addressLine2: (_d2 = object2.address) == null ? void 0 : _d2.addressLine2,
    city: (_e2 = object2.address) == null ? void 0 : _e2.city,
    country: (_f3 = object2.address) == null ? void 0 : _f3.country,
    postalCode: (_g = object2.address) == null ? void 0 : _g.postalCode,
    state: (_h = object2.address) == null ? void 0 : _h.state,
    temporaryEvent: object2.temporaryEvent,
    thumbnail: object2.thumbnail,
    numBuildings: object2.numBuildings,
    numLevels: object2.numLevels,
    zoneType: object2.zoneType
  };
}
function VenueInfo(props) {
  const {
    onDone,
    object: object2
  } = props;
  const {
    formValue,
    id
  } = React__default.useMemo(() => {
    if (!object2)
      return {};
    const formValue2 = getFormValues$4(object2);
    return {
      id: object2.id,
      formValue: formValue2
    };
  }, [object2]);
  if (!formValue) {
    return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Venue Information", onDone, children: [
      /* @__PURE__ */ jsx(Empty, {}),
      " "
    ] }, "null");
  }
  return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Venue Information", onDone, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", children: /* @__PURE__ */ jsx(Text$e, { style: {
      ...textColor$4
    }, children: formValue.objectType }) }),
    /* @__PURE__ */ jsx("div", { style: {
      display: "flex",
      gap: 8
    }, children: /* @__PURE__ */ jsx(Form.Item, { name: "thumbnail", children: /* @__PURE__ */ jsx(Image$1, { width: 100, height: 100, src: formValue.thumbnail, fallback: FALLBACK_IMAGE }) }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Venue Name", children: /* @__PURE__ */ jsx(Text$e, { style: {
      ...textColor$4
    }, children: formValue.name }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "venueType", label: "Premises Type", children: /* @__PURE__ */ jsx(Text$e, { style: {
      ...textColor$4
    }, children: formValue.venueType }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "addressLine1", label: "Address 1", children: /* @__PURE__ */ jsx(Text$e, { style: {
      ...textColor$4
    }, children: formValue.addressLine1 }) }),
    /* @__PURE__ */ jsxs(Row, { gutter: [16, 16], children: [
      /* @__PURE__ */ jsxs(Col, { span: 12, children: [
        /* @__PURE__ */ jsx(Form.Item, { name: "latitude", label: "Latitude", children: /* @__PURE__ */ jsx(Text$e, { style: {
          ...textColor$4
        }, children: formValue.latitude }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "numBuildings", label: "Total Buildings", children: /* @__PURE__ */ jsx(Text$e, { style: {
          ...textColor$4
        }, children: formValue.numBuildings }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "temporaryEvents", label: "Temporary Event", children: /* @__PURE__ */ jsx(Text$e, { style: {
          ...textColor$4
        }, children: formValue.temporaryEvent ? "Yes" : "No" }) })
      ] }),
      /* @__PURE__ */ jsxs(Col, { span: 12, children: [
        /* @__PURE__ */ jsx(Form.Item, { name: "longitude", label: "Longitude", children: /* @__PURE__ */ jsx(Text$e, { style: {
          ...textColor$4
        }, children: formValue.longitude }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "numLevels", label: "Total Floors", children: /* @__PURE__ */ jsx(Text$e, { style: {
          ...textColor$4
        }, children: formValue.numLevels }) })
      ] })
    ] })
  ] }, id);
}
VenueInfo.propTypes = {
  onDone: propTypesExports$1.func,
  object: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    name: propTypesExports$1.string,
    venueType: propTypesExports$1.string,
    center: propTypesExports$1.array,
    address: propTypesExports$1.object,
    temporaryEvent: propTypesExports$1.bool,
    thumbnail: propTypesExports$1.string,
    numBuildings: propTypesExports$1.number,
    numDevices: propTypesExports$1.number,
    numLevels: propTypesExports$1.number
  })
};
VenueInfo.defaultProps = {
  onDone: () => {
  },
  object: {}
};
VenueInfo.getFormValues = getFormValues$4;
const ImportDataContextInst = React__default.createContext();
function ImportDataContext(props) {
  const {
    children,
    ...value
  } = props;
  return /* @__PURE__ */ jsx(ImportDataContextInst.Provider, { value, children });
}
ImportDataContext.propTypes = {
  children: propTypesExports$1.node
};
ImportDataContext.defaultProps = {
  children: null
};
const useImportDataContext = () => React__default.useContext(ImportDataContextInst) || {};
function IoMdClose(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z" } }] })(props);
}
function FaArrowLeft(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 448 512" }, "child": [{ "tag": "path", "attr": { "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" } }] })(props);
}
function BsMap(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "d": "M15.817.113A.5.5 0 0 1 16 .5v14a.5.5 0 0 1-.402.49l-5 1a.502.502 0 0 1-.196 0L5.5 15.01l-4.902.98A.5.5 0 0 1 0 15.5v-14a.5.5 0 0 1 .402-.49l5-1a.5.5 0 0 1 .196 0L10.5.99l4.902-.98a.5.5 0 0 1 .415.103zM10 1.91l-4-.8v12.98l4 .8V1.91zm1 12.98 4-.8V1.11l-4 .8v12.98zm-6-.8V1.11l-4 .8v12.98l4-.8z" } }] })(props);
}
function BsQuestionSquare(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" } }, { "tag": "path", "attr": { "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" } }] })(props);
}
const {
  Option: Option$4
} = Select$1;
const {
  useToken: useToken$q
} = theme$2;
function HeaderContent(props) {
  const {
    title,
    subTitle,
    showDropdown,
    showSearch,
    showSave,
    showCancel,
    showHelp,
    showBack,
    onClickHelp,
    onDone,
    apps,
    logo: logo2,
    style: style2
  } = props;
  const {
    token
  } = useToken$q();
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const setActiveVenueId = useViewStore((state) => state.setActiveVenueId);
  const setActiveBuildingId = useViewStore((state) => state.setActiveBuildingId);
  const setActiveLevelId = useViewStore((state) => state.setActiveLevelId);
  const setActiveLayerId = useViewStore((state) => state.setActiveLayerId);
  const setActiveFeatureId = useViewStore((state) => state.setActiveFeatureId);
  const setActiveApFeatureId = useViewStore((state) => state.setActiveApFeatureId);
  const setEnableVenueSubTree = useViewStore((state) => state.setEnableVenueSubTree);
  const saving = useViewStore((state) => state.saving);
  const closing = useViewStore((state) => state.closing);
  const venues = useSiteStore((state) => state.venues || []);
  const onVenueSelect = React__default.useCallback((id) => {
    setActiveVenueId(id);
    setEnableVenueSubTree(true);
    setActiveBuildingId(null);
    setActiveLevelId(null);
    setActiveLayerId(null);
    setActiveFeatureId(null);
    setActiveApFeatureId(null);
  }, [setActiveVenueId, setEnableVenueSubTree, setActiveBuildingId, setActiveLevelId, setActiveLayerId, setActiveFeatureId, setActiveApFeatureId]);
  const [helpButtonActive, setHelpButtonActive] = React__default.useState(false);
  const handleHelp = React__default.useCallback(() => {
    setHelpButtonActive((prevActive) => {
      const newValue = !prevActive;
      onClickHelp(newValue);
      return newValue;
    });
  }, [onClickHelp]);
  return /* @__PURE__ */ jsxs("div", { style: {
    padding: "16px 16px 16px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "64px",
    borderBottom: `1px solid ${token.colorSplit}`,
    ...style2
  }, children: [
    /* @__PURE__ */ jsxs(Space, { style: {
      gap: "20px"
    }, children: [
      showBack && /* @__PURE__ */ jsx(Button, { onClick: () => onDone(false), icon: /* @__PURE__ */ jsx(FaArrowLeft, {}), loading: closing }),
      logo2 && /* @__PURE__ */ jsx("div", { style: {
        width: "20px",
        height: "100%",
        overflow: "hidden"
      }, children: logo2 }),
      /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
        lineHeight: 0
      }, children: [
        /* @__PURE__ */ jsx(Tooltip$1, { title, children: /* @__PURE__ */ jsx(Typography.Title, { level: 3, style: {
          margin: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          maxWidth: "250px"
        }, children: title }) }),
        /* @__PURE__ */ jsx(Typography.Text, { children: subTitle })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Space, { children: [
      showDropdown && /* @__PURE__ */ jsx(Select$1, { style: {
        width: "150px",
        borderRadius: 0,
        borderColor: token.colorBorder
      }, defaultValue: activeVenueId, value: activeVenueId, onChange: onVenueSelect, allowClear: true, showSearch: true, children: venues.map((venue) => /* @__PURE__ */ jsx(Option$4, { value: venue.id, children: venue.name }, venue.id)) }),
      showSearch && /* @__PURE__ */ jsx("div", { style: {
        marginLeft: "8px"
      }, id: "geocoder" }),
      apps,
      showSave && /* @__PURE__ */ jsx(Tooltip$1, { title: "Save", children: /* @__PURE__ */ jsx(Button, { type: "primary", style: {
        marginLeft: "8px",
        borderRadius: 0
        // backgroundColor: token.colorBgContainer,
      }, onClick: () => onDone(true), icon: /* @__PURE__ */ jsx(SaveOutlined, {}), loading: saving }) }),
      showHelp && /* @__PURE__ */ jsx(Button, { type: helpButtonActive ? "primary" : "text", onClick: handleHelp, style: {
        borderRadius: 0,
        marginTop: "19px"
      }, icon: /* @__PURE__ */ jsx(BsQuestionSquare, { style: {
        width: "20px",
        height: "20px"
      } }) }),
      showCancel && /* @__PURE__ */ jsx(Button, { type: "text", style: {
        marginLeft: "8px",
        borderRadius: 0,
        backgroundColor: token.colorBgContainer
      }, onClick: () => onDone(false), icon: /* @__PURE__ */ jsx(IoMdClose, {}), loading: closing })
    ] })
  ] });
}
HeaderContent.propTypes = {
  title: propTypesExports$1.string,
  subTitle: propTypesExports$1.string,
  showDropdown: propTypesExports$1.bool,
  showSearch: propTypesExports$1.bool,
  showSave: propTypesExports$1.bool,
  showCancel: propTypesExports$1.bool,
  showHelp: propTypesExports$1.bool,
  showBack: propTypesExports$1.bool,
  onClickHelp: propTypesExports$1.func,
  onDone: propTypesExports$1.func,
  apps: propTypesExports$1.node,
  logo: propTypesExports$1.node,
  style: propTypesExports$1.object
};
HeaderContent.defaultProps = {
  title: "Design Studio",
  subTitle: "",
  showDropdown: false,
  showSearch: false,
  showSave: false,
  showCancel: false,
  showHelp: false,
  showBack: false,
  onClickHelp: () => {
  },
  onDone: () => {
  },
  apps: null,
  logo: null,
  style: {}
};
const panelStyle = {
  textAlign: "center",
  padding: "16px 24px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};
const {
  useToken: useToken$p
} = theme$2;
function FooterPanel(props) {
  const {
    children,
    onNext,
    onBack,
    nextDisabled,
    backDisabled,
    backText,
    nextText
  } = props;
  const {
    token
  } = useToken$p();
  const {
    nextStyle,
    backStyle
  } = React__default.useMemo(() => {
    if (onNext && onBack) {
      return {
        nextStyle: {
          marginLeft: "24px",
          marginBottom: "1%",
          width: "150px",
          backgroundColor: token.colorBgBase
        },
        backStyle: {
          marginRight: "24px",
          marginBottom: "1%",
          width: "150px"
        }
      };
    }
    if (onNext) {
      return {
        backStyle: {},
        nextStyle: {
          marginBottom: "1%",
          width: "300px"
          // backgroundColor: token.colorBgBase,
        }
      };
    }
    if (onBack) {
      return {
        nextStyle: {},
        backStyle: {
          marginLeft: "24px",
          marginRight: "24px",
          marginBottom: "1%",
          width: "300px"
        }
      };
    }
    return {
      nextStyle: {},
      backStyle: {}
    };
  }, [onBack, onNext, token.colorBgBase]);
  return /* @__PURE__ */ jsxs("div", { style: {
    ...panelStyle,
    borderTop: `1px solid ${token.colorBorderSecondary}`
  }, children: [
    onBack && /* @__PURE__ */ jsx(Button, { onClick: onBack, disabled: backDisabled, style: backStyle, children: backText }),
    children,
    onNext && /* @__PURE__ */ jsx(
      Button,
      {
        type: "primary",
        block: true,
        onClick: onNext,
        disabled: nextDisabled,
        style: nextStyle,
        children: nextText
      }
    )
  ] });
}
FooterPanel.propTypes = {
  children: propTypesExports$1.node,
  onNext: propTypesExports$1.func,
  onBack: propTypesExports$1.func,
  nextDisabled: propTypesExports$1.bool,
  backDisabled: propTypesExports$1.bool,
  backText: propTypesExports$1.string,
  nextText: propTypesExports$1.string
};
FooterPanel.defaultProps = {
  children: null,
  onNext: null,
  onBack: null,
  nextDisabled: true,
  backDisabled: true,
  backText: "Back",
  nextText: "Next"
};
function MapResizer(props) {
  const {
    containerId,
    containerClassName
  } = props;
  const {
    map: map5
  } = useMapbox();
  const {
    width,
    height,
    ref
  } = useLayoutDimensions();
  const getElements = React__default.useCallback(() => {
    var _a3, _b3;
    let element = null;
    if (containerId) {
      element = document.getElementById(containerId);
    }
    if (!element && containerClassName) {
      element = (_a3 = document.getElementsByClassName(containerClassName)) == null ? void 0 : _a3[0];
    }
    if (!element) {
      element = map5 == null ? void 0 : map5.getContainer();
    }
    const mapCanvas2 = (_b3 = element == null ? void 0 : element.getElementsByClassName("mapboxgl-canvas")) == null ? void 0 : _b3[0];
    return {
      element,
      mapCanvas: mapCanvas2
    };
  }, [containerClassName, containerId, map5]);
  const mapCanvas = React__default.useMemo(() => {
    const {
      element,
      mapCanvas: mapCanvas2
    } = getElements();
    ref.current = element;
    return mapCanvas2;
  }, [getElements, ref]);
  const previousSizeRef = React__default.useRef({
    width: 0,
    height: 0
  });
  React__default.useEffect(() => {
    if (mapCanvas && map5 && width && height && (width !== previousSizeRef.current.width || height !== previousSizeRef.current.height)) {
      map5.resize();
      previousSizeRef.current.width = width;
      previousSizeRef.current.height = height;
    }
  }, [height, map5, mapCanvas, width]);
  return null;
}
MapResizer.propTypes = {
  containerId: propTypesExports$1.string,
  containerClassName: propTypesExports$1.string
};
MapResizer.defaultProps = {
  containerId: null,
  containerClassName: null
};
const {
  useToken: useToken$o
} = theme$2;
const {
  Title: Title$d,
  Text: Text$d
} = Typography;
function StepScaleHelp(props) {
  const {
    helpData
  } = props;
  const {
    token
  } = useToken$o();
  return /* @__PURE__ */ jsx("div", { style: {
    float: "right"
  }, children: /* @__PURE__ */ jsxs(Card, { style: {
    width: "320px",
    maxHeight: "100%",
    borderRadius: 0
  }, styles: {
    header: {
      fontSize: "18px",
      borderBottom: "none",
      position: "relative",
      top: "2px"
    }
  }, bordered: 0, title: "Scaling Your Floor Plan", children: [
    helpData.map((item, index2) => /* @__PURE__ */ jsxs("div", { style: {
      position: "relative",
      bottom: "46px"
    }, children: [
      /* @__PURE__ */ jsx(Title$d, { style: {
        fontSize: "14px",
        position: "relative",
        right: "8px",
        fontWeight: "normal"
      }, level: 4, children: `${index2 + 1}. ${item.title}` }),
      Array.isArray(item.text) ? item.text.map((line) => /* @__PURE__ */ jsx(Text$d, { style: {
        color: token.colorTextSecondary,
        marginRight: "5px"
      }, children: line })) : /* @__PURE__ */ jsx(Text$d, { style: {
        color: token.colorTextSecondary,
        position: "relative",
        left: "18px",
        fontSize: "14px"
      }, children: item.text })
    ] })),
    /* @__PURE__ */ jsxs("div", { style: {
      marginTop: "-48px"
    }, children: [
      /* @__PURE__ */ jsx(Title$d, { style: {
        fontSize: "18px",
        textAlign: "left"
      }, children: "Navigation" }),
      /* @__PURE__ */ jsx(Text$d, { style: {
        fontSize: "14px",
        position: "relative",
        top: "0px"
      }, children: "Left click for dragging." }),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx(Text$d, { style: {
        fontSize: "14px",
        position: "relative",
        top: "2px"
      }, children: "Mouse wheel for zooming." })
    ] })
  ] }) });
}
StepScaleHelp.propTypes = {
  helpData: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    title: propTypesExports$1.string,
    text: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.arrayOf(propTypesExports$1.string)])
  }))
};
StepScaleHelp.defaultProps = {
  helpData: [{
    title: "Type in Length",
    text: "Enter the actual length of a known dimension into the Ruler`s length field."
  }, {
    title: "Use the Ruler Tool",
    text: "Move the ruler to the corresponding location on the floor plan, aligning it with the measured feature."
  }, {
    title: "Place and Confirm",
    text: "Confirm to set the scale."
  }]
};
function useDraggableLine() {
  const getFeatures = React__default.useCallback((line) => {
    const {
      id,
      startPoint,
      endPoint,
      midPoint: midPoint3
    } = line || {};
    if (!id || !startPoint || !endPoint)
      return {
        pointsFeatures: [],
        allFeatures: []
      };
    const pointsFeatures = [];
    pointsFeatures.push({
      id: `${id}-editable-start-point`,
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [...startPoint]
      },
      properties: {
        index: 0,
        sourceId: id
      }
    });
    pointsFeatures.push({
      id: `${id}-editable-end-point`,
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [...endPoint]
      },
      properties: {
        index: 1,
        sourceId: id
      }
    });
    if (midPoint3) {
      pointsFeatures.push({
        id: `${id}-editable-mid-point`,
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [...midPoint3]
        },
        properties: {
          index: 2,
          sourceId: id
        }
      });
    }
    const allFeatures = pushArray([], pointsFeatures);
    allFeatures.push({
      id: `${id}-non-editable-line`,
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: [startPoint, endPoint]
      },
      properties: {
        sourceId: id
      }
    });
    return {
      pointsFeatures,
      allFeatures
    };
  }, []);
  const getPoints4 = React__default.useCallback((id, featureCollection2) => {
    var _a3;
    let newStartPoint = null;
    let newEndPoint = null;
    let newMidPoint = null;
    (_a3 = featureCollection2 == null ? void 0 : featureCollection2.features) == null ? void 0 : _a3.forEach((f2) => {
      if (f2.properties.sourceId !== id)
        return;
      switch (f2.id) {
        case `${id}-editable-start-point`:
          newStartPoint = [...f2.geometry.coordinates];
          break;
        case `${id}-editable-end-point`:
          newEndPoint = [...f2.geometry.coordinates];
          break;
        case `${id}-editable-mid-point`:
          newMidPoint = [...f2.geometry.coordinates];
          break;
      }
    });
    return {
      startPoint: newStartPoint,
      endPoint: newEndPoint,
      midPoint: newMidPoint
    };
  }, []);
  const areDoubleEquals = React__default.useCallback((one, two, tolerance = 1e-6) => Math.abs(one - two) <= tolerance, []);
  const updateOtherLine = React__default.useCallback((otherLine, changes) => {
    const {
      line,
      newLine,
      isEndPoint: isEndPoint4,
      isStartPoint
    } = changes || {};
    if (!otherLine || !line || !newLine)
      return null;
    if (!isStartPoint && !isEndPoint4)
      return null;
    const isHorizontalLine = areDoubleEquals(line.startPoint[0], line.endPoint[0]);
    const isVerticalLine = areDoubleEquals(line.startPoint[1], line.endPoint[1]);
    if (!isHorizontalLine && !isVerticalLine)
      return null;
    const newOtherLine = {
      ...otherLine
    };
    const distance11 = GeoUtil.distance(newLine.startPoint, newLine.endPoint);
    if (isStartPoint) {
      if (isHorizontalLine) {
        newOtherLine.startPoint = GeoUtil.destination(newOtherLine.endPoint, distance11, -90);
      } else if (isVerticalLine) {
        newOtherLine.startPoint = GeoUtil.destination(newOtherLine.endPoint, distance11, 0);
      }
    } else if (isEndPoint4) {
      if (isHorizontalLine) {
        newOtherLine.endPoint = GeoUtil.destination(newOtherLine.startPoint, distance11, 90);
      } else if (isVerticalLine) {
        newOtherLine.endPoint = GeoUtil.destination(newOtherLine.startPoint, distance11, 180);
      }
    }
    newOtherLine.midPoint[0] = (newOtherLine.startPoint[0] + newOtherLine.endPoint[0]) * 0.5;
    newOtherLine.midPoint[1] = (newOtherLine.startPoint[1] + newOtherLine.endPoint[1]) * 0.5;
    return newOtherLine;
  }, [areDoubleEquals]);
  const updateFeatureCollection = React__default.useCallback((featureCollection2, newFeatures) => {
    featureCollection2.features = featureCollection2.features.map((curFeature) => {
      const index2 = newFeatures.findIndex((newFeature) => newFeature.id === curFeature.id);
      if (index2 > -1) {
        return newFeatures[index2];
      }
      return curFeature;
    });
  }, []);
  const onDragHandler = React__default.useCallback((drawControl, newLocation, line, otherLine, onChange) => {
    var _a3;
    const {
      id: sourceId,
      constraint
    } = line;
    const selectedFeatureId = (_a3 = drawControl.getSelectedIds()) == null ? void 0 : _a3[0];
    const isStartPoint = selectedFeatureId === `${sourceId}-editable-start-point`;
    const isEndPoint4 = selectedFeatureId === `${sourceId}-editable-end-point`;
    const isMidPoint = selectedFeatureId === `${sourceId}-editable-mid-point`;
    if (!isStartPoint && !isEndPoint4 && !isMidPoint)
      return;
    const featureCollection2 = {
      ...drawControl.getAll()
    };
    const {
      startPoint,
      endPoint,
      midPoint: midPoint3
    } = getPoints4(sourceId, featureCollection2);
    const newStartPoint = isStartPoint ? newLocation : startPoint;
    const newEndPoint = isEndPoint4 ? newLocation : endPoint;
    const newMidPoint = isMidPoint ? newLocation : midPoint3;
    if (isMidPoint) {
      const diff2 = [newMidPoint[0] - midPoint3[0], newMidPoint[1] - midPoint3[1]];
      newStartPoint[0] += diff2[0];
      newEndPoint[0] += diff2[0];
      newStartPoint[1] += diff2[1];
      newEndPoint[1] += diff2[1];
    } else if (isStartPoint || isEndPoint4) {
      if (constraint === "lng") {
        newStartPoint[0] = startPoint[0];
        newEndPoint[0] = startPoint[0];
      } else if (constraint === "lat") {
        newStartPoint[1] = startPoint[1];
        newEndPoint[1] = startPoint[1];
      }
    }
    if (newMidPoint) {
      newMidPoint[0] = (newStartPoint[0] + newEndPoint[0]) * 0.5;
      newMidPoint[1] = (newStartPoint[1] + newEndPoint[1]) * 0.5;
    }
    const newLine = {
      id: sourceId,
      startPoint: newStartPoint,
      endPoint: newEndPoint,
      midPoint: newMidPoint,
      constraint
    };
    const newLines = [newLine];
    if (otherLine && !isMidPoint) {
      const newOtherLine = updateOtherLine(otherLine, {
        line,
        newLine,
        isEndPoint: isEndPoint4,
        isStartPoint
      });
      if (newOtherLine)
        newLines.push(newOtherLine);
    }
    newLines.forEach((newLine2) => updateFeatureCollection(featureCollection2, getFeatures(newLine2).allFeatures));
    drawControl.set(featureCollection2);
    onChange(newLines);
  }, [getFeatures, getPoints4, updateFeatureCollection, updateOtherLine]);
  return {
    getFeatures,
    onDragHandler
  };
}
function DraggableLines(props) {
  const {
    onChange: onChangeIn,
    value,
    same
  } = props;
  const [customModes, setCustomModes] = React__default.useState(null);
  const {
    lines
  } = value || {};
  const {
    getFeatures: getLineFeatures,
    onDragHandler: onLineDragHandler
  } = useDraggableLine();
  const onChangeMut = useMutableFunc(onChangeIn);
  const onChange = React__default.useCallback((...args) => {
    debounce$3(() => {
      onChangeMut(...args);
    }, 200)();
  }, [onChangeMut]);
  const getInitialFeatures = React__default.useCallback(() => {
    const pointsFeatures2 = [];
    const allFeatures2 = [];
    lines == null ? void 0 : lines.forEach((line) => {
      var _a3, _b3;
      if (!line)
        return;
      const result = getLineFeatures(line);
      if ((_a3 = result == null ? void 0 : result.pointsFeatures) == null ? void 0 : _a3.length)
        pointsFeatures2.push(...result.pointsFeatures);
      if ((_b3 = result == null ? void 0 : result.allFeatures) == null ? void 0 : _b3.length)
        allFeatures2.push(...result.allFeatures);
    });
    return {
      pointsFeatures: pointsFeatures2,
      allFeatures: allFeatures2
    };
  }, [getLineFeatures, lines]);
  const {
    pointsFeatures,
    allFeatures
  } = React__default.useMemo(() => getInitialFeatures(), [getInitialFeatures]);
  const onDragHandler = React__default.useCallback((state, event) => {
    var _a3, _b3, _c2, _d2, _e2, _f3;
    const map5 = event == null ? void 0 : event.target;
    if (!map5)
      return;
    if (!event.lngLat)
      return;
    const drawControl = (_a3 = map5._controls) == null ? void 0 : _a3.find((control) => control instanceof MapboxDraw$5);
    if (!drawControl)
      return;
    const selectedFeatureId = (_b3 = drawControl.getSelectedIds()) == null ? void 0 : _b3[0];
    const selectedFeature = (_d2 = (_c2 = drawControl.getAll()) == null ? void 0 : _c2.features) == null ? void 0 : _d2.find((f2) => f2.id === selectedFeatureId);
    if (!selectedFeature)
      return;
    const selectedFeatureSourceId = selectedFeature.properties.sourceId;
    const line = (_e2 = lines == null ? void 0 : lines.filter((l2) => l2.id === selectedFeatureSourceId)) == null ? void 0 : _e2[0];
    if (!line)
      return;
    const otherLine = same ? (_f3 = lines == null ? void 0 : lines.filter((l2) => l2.id !== line.id)) == null ? void 0 : _f3[0] : null;
    const newLocation = [event.lngLat.lng, event.lngLat.lat];
    onLineDragHandler(drawControl, newLocation, line, otherLine, onChange);
  }, [lines, onChange, onLineDragHandler, same]);
  const mutableDragHandler = useMutableFunc(onDragHandler);
  React__default.useLayoutEffect(() => {
    const simpleSelectMdoe = MapboxDraw$5.modes.simple_select;
    const customMode = Object.assign(Object.create(Object.getPrototypeOf(simpleSelectMdoe)), simpleSelectMdoe);
    customMode.onDrag = mutableDragHandler;
    setCustomModes({
      simple_select: customMode
    });
  }, [mutableDragHandler]);
  if (!customModes || (allFeatures == null ? void 0 : allFeatures.length) < 3)
    return null;
  return /* @__PURE__ */ jsx(DrawControls, { mode: "simple_select", customModes, features: allFeatures, editableFeatures: pointsFeatures, enableDownload: false, enableButtons: [], enableDelete: false });
}
DraggableLines.propTypes = {
  value: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    startPoint: propTypesExports$1.arrayOf(propTypesExports$1.number),
    endPoint: propTypesExports$1.arrayOf(propTypesExports$1.number),
    midPoint: propTypesExports$1.arrayOf(propTypesExports$1.number)
  }),
  onChange: propTypesExports$1.func,
  same: propTypesExports$1.bool
};
DraggableLines.defaultProps = {
  value: null,
  onChange: () => {
  },
  same: false
};
function OsmBuildings(props) {
  const {
    id,
    sourceId,
    sourceLayer,
    ...restProps
  } = props;
  const height = React__default.useMemo(
    () => ["get", "height"],
    // return ['interpolate', ['linear'], ['zoom'], minZoom, 0, minZoom + 0.05, ['get', 'height']]
    []
  );
  const elevation = React__default.useMemo(
    () => ["get", "min_height"],
    // return ['interpolate', ['linear'], ['zoom'], minZoom, 0, minZoom + 0.05, ['get', 'min_height']]
    []
  );
  return /* @__PURE__ */ jsx(ExtrusionLayer, { id, sourceId, sourceLayer, height, elevation, ...restProps });
}
OsmBuildings.propTypes = {
  id: propTypesExports$1.string.isRequired,
  minZoom: propTypesExports$1.number,
  sourceId: propTypesExports$1.string,
  sourceLayer: propTypesExports$1.string
};
OsmBuildings.defaultProps = {
  minZoom: 0,
  sourceId: "composite",
  sourceLayer: "building"
};
function OsmBuildingsPoi(props) {
  const {
    id: layerId,
    pointOfInterestPropName,
    center: center2,
    color: colorIn,
    hide,
    sourceId,
    sourceLayer,
    ...restProps
  } = props;
  const poiFilter = React__default.useMemo(() => ["boolean", ["feature-state", pointOfInterestPropName], false], [pointOfInterestPropName]);
  const {
    map: map5
  } = useMapbox();
  const getColor2 = React__default.useCallback((fallback) => {
    if (Array.isArray(fallback) && fallback[0] === "case") {
      const len2 = fallback.length;
      const copy8 = [...fallback];
      copy8.splice(len2 - 1, 0, poiFilter, colorIn);
      return copy8;
    }
    return ["case", poiFilter, colorIn, fallback];
  }, [colorIn, poiFilter]);
  const getHeight2 = React__default.useCallback((fallback) => {
    const zeroHeight = 0;
    if (Array.isArray(fallback) && fallback[0] === "case") {
      const len2 = fallback.length;
      const copy8 = [...fallback];
      copy8.splice(len2 - 1, 0, poiFilter, zeroHeight);
      return copy8;
    }
    return ["case", poiFilter, zeroHeight, fallback];
  }, [poiFilter]);
  const originalColorStyleRef = React__default.useRef(null);
  const updateColorStyle = React__default.useCallback(() => {
    let existing = originalColorStyleRef.current;
    if (!existing) {
      existing = map5.getPaintProperty(layerId, "fill-extrusion-color");
      originalColorStyleRef.current = existing;
    }
    const modified = getColor2(existing);
    map5.setPaintProperty(layerId, "fill-extrusion-color", modified);
  }, [getColor2, layerId, map5]);
  const originalExtrusionHeightStyleRef = React__default.useRef(null);
  const updateExtrusionHeightStyle = React__default.useCallback(() => {
    let existing = originalExtrusionHeightStyleRef.current;
    if (hide) {
      if (!existing) {
        existing = map5.getPaintProperty(layerId, "fill-extrusion-height");
        originalExtrusionHeightStyleRef.current = existing;
      }
      const modified = getHeight2(existing);
      map5.setPaintProperty(layerId, "fill-extrusion-height", modified);
    } else if (existing) {
      map5.setPaintProperty(layerId, "fill-extrusion-height", existing);
    }
  }, [getHeight2, hide, layerId, map5]);
  const needsUpdateStylesRef = React__default.useRef(true);
  const handleStyles = React__default.useCallback(() => {
    if (!map5)
      return null;
    needsUpdateStylesRef.current = true;
    const listener = () => {
      if (!needsUpdateStylesRef.current)
        return;
      needsUpdateStylesRef.current = false;
      updateColorStyle();
      updateExtrusionHeightStyle();
      map5.triggerRepaint();
    };
    listener();
    map5.on("sourcedata", listener);
    return () => map5.off("sourcedata", listener);
  }, [map5, updateColorStyle, updateExtrusionHeightStyle]);
  const poiFeatureArrayRef = React__default.useRef([]);
  const modifiedFeaturesRef = React__default.useRef([]);
  const updateFeatureState = React__default.useCallback((feature2) => {
    if (modifiedFeaturesRef.current.includes(feature2.id))
      return;
    modifiedFeaturesRef.current.push(feature2.id);
    try {
      const isWithin = GeoUtil.isPointInsidePolygon(center2, feature2);
      const isIntersecting = GeoUtil.isPolygonIntersectingAnyPolygons(feature2, poiFeatureArrayRef.current);
      const isInside = !!(isWithin || isIntersecting);
      if (isInside) {
        poiFeatureArrayRef.current.push(feature2);
        map5.setFeatureState({
          source: sourceId,
          sourceLayer,
          id: feature2.id
        }, {
          [pointOfInterestPropName]: true
        });
      }
    } catch (error2) {
    }
  }, [center2, map5, poiFeatureArrayRef, pointOfInterestPropName, sourceId, sourceLayer]);
  const handleSource2 = React__default.useCallback(() => {
    const listener = () => {
      var _a3;
      if (center2) {
        poiFeatureArrayRef.current = [];
        (_a3 = map5.querySourceFeatures(sourceId, {
          sourceLayer
        })) == null ? void 0 : _a3.forEach(updateFeatureState);
      }
    };
    map5.on("sourcedata", listener);
    return () => map5.off("sourcedata", listener);
  }, [center2, map5, sourceId, sourceLayer, updateFeatureState]);
  useEffect17(() => {
    const detachSource = handleSource2();
    const detachLayer = handleStyles();
    return () => {
      detachLayer();
      detachSource();
    };
  });
  return /* @__PURE__ */ jsx(OsmBuildings, { id: layerId, sourceId, sourceLayer, ...restProps });
}
OsmBuildingsPoi.propTypes = {
  id: propTypesExports$1.string.isRequired,
  minZoom: propTypesExports$1.number,
  sourceId: propTypesExports$1.string,
  sourceLayer: propTypesExports$1.string,
  pointOfInterestPropName: propTypesExports$1.string,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number).isRequired,
  color: propTypesExports$1.string,
  hide: propTypesExports$1.bool
};
OsmBuildingsPoi.defaultProps = {
  minZoom: 0,
  sourceId: "composite",
  sourceLayer: "building",
  pointOfInterestPropName: "POI",
  color: "#FF0000",
  hide: false
};
const tiles_select_options = "_tiles_select_options_uyytn_1";
const tiles_select_dropdown = "_tiles_select_dropdown_uyytn_19";
const styles$8 = {
  tiles_select_options,
  tiles_select_dropdown
};
const ALL_TILESET = {};
Object.keys(MapTilesConstants).forEach((key) => {
  if (key === "None")
    return;
  ALL_TILESET[key] = {
    ...MapTilesConstants[key]
  };
});
function TilesControls(props) {
  const {
    tile,
    onChange,
    tiles: tilesIn,
    containerId,
    placement,
    width,
    height,
    marginHorizontal,
    marginVertical,
    disabled
  } = props;
  const {
    map: map5
  } = useMapbox();
  const selectedRef = React__default.useRef(tile);
  const elementRef = React__default.useRef(null);
  const onChangeValue = React__default.useCallback((tilesetUrl) => {
    const key = Object.keys(ALL_TILESET).find((key2) => ALL_TILESET[key2].tilesetUrl === tilesetUrl);
    if (!key)
      return;
    if (selectedRef.current !== tilesetUrl) {
      selectedRef.current = tilesetUrl;
      map5.setStyle(tilesetUrl);
      onChange(tilesetUrl);
    }
  }, [map5, onChange]);
  React__default.useMemo(() => {
    var _a3;
    if (!elementRef.current) {
      if (containerId)
        elementRef.current = document.getElementById(containerId);
      if (!elementRef.current)
        elementRef.current = (_a3 = document.getElementsByClassName("mapboxgl-map")) == null ? void 0 : _a3[0];
    }
  }, [containerId]);
  const tiles = React__default.useMemo(() => {
    const tiles2 = {
      ...ALL_TILESET
    };
    Object.keys(tilesIn).forEach((key) => {
      const value = tilesIn[key];
      if (!Object.values(tiles2).find((v5) => v5 === value)) {
        tiles2[key] = {
          imageUrl: value.imageUrl,
          tilesetUrl: value.tilesetUrl
        };
      }
    });
    return tiles2;
  }, [tilesIn]);
  const renderButtons = React__default.useCallback(() => /* @__PURE__ */ jsx(OverlayPanel, { placement, width, height, marginHorizontal, marginVertical, children: /* @__PURE__ */ jsx(Select$1, { defaultValue: tile, value: tile, onChange: onChangeValue, suffixIcon: null, dropdownStyle: {
    borderRadius: 0,
    padding: 0
  }, className: styles$8.tiles_select_options, popupClassName: styles$8.tiles_select_dropdown, disabled, children: Object.keys(tiles).map((key) => ALL_TILESET[key] && /* @__PURE__ */ jsx(Select$1.Option, { value: ALL_TILESET[key].tilesetUrl, children: /* @__PURE__ */ jsx(Image$1, { src: ALL_TILESET[key].imageUrl, preview: false, width: 40 }) }, key)) }) }), [height, marginHorizontal, marginVertical, onChangeValue, placement, tile, tiles, width, disabled]);
  if (!map5 || !elementRef.current)
    return null;
  return require$$0$2.createPortal(renderButtons(), elementRef.current);
}
TilesControls.propTypes = {
  tile: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  tiles: propTypesExports$1.object,
  containerId: propTypesExports$1.string,
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  disabled: propTypesExports$1.bool
};
TilesControls.defaultProps = {
  tile: "",
  onChange: () => {
  },
  tiles: {},
  containerId: "",
  placement: "top-right",
  width: "40px",
  height: "40px",
  marginHorizontal: 0,
  marginVertical: 0,
  disabled: false
};
function TilesSelector(props) {
  const {
    tile,
    onChange,
    enableControls,
    ...restProps
  } = props;
  const initialTileStyleRef = React__default.useRef(null);
  const onceRef = React__default.useRef(false);
  const hasChangedRef = React__default.useRef(false);
  const {
    map: map5
  } = useMapbox();
  const safeSetStyle = React__default.useCallback((map22, style2) => {
    try {
      map22 == null ? void 0 : map22.setStyle(style2);
    } catch (error2) {
      console.error(error2);
    }
  }, []);
  React__default.useLayoutEffect(() => {
    if (!onceRef.current && map5) {
      onceRef.current = true;
      initialTileStyleRef.current = map5.getStyle();
    }
  }, [map5]);
  React__default.useLayoutEffect(() => {
    if (map5 && onceRef.current) {
      if (tile) {
        safeSetStyle(map5, tile);
        hasChangedRef.current = true;
      } else {
        safeSetStyle(map5, initialTileStyleRef.current);
      }
    }
  }, [map5, safeSetStyle, tile]);
  const mapRef = useValueRef(map5);
  React__default.useLayoutEffect(() => {
    const map22 = mapRef.current;
    if (!map22 || !onceRef.current || !hasChangedRef.current)
      return () => {
      };
    const original = initialTileStyleRef.current;
    return () => {
      safeSetStyle(map22, original);
    };
  }, [mapRef, safeSetStyle]);
  if (!enableControls)
    return null;
  return /* @__PURE__ */ jsx(TilesControls, { tile, onChange, disabled: !tile, ...restProps });
}
TilesSelector.propTypes = {
  tile: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  enableControls: propTypesExports$1.bool
};
TilesSelector.defaultProps = {
  tile: "",
  onChange: () => {
  },
  enableControls: true
};
function MapFitFeature(props) {
  const {
    feature: feature2,
    bearing: bearing2,
    refreshCounter,
    pointRadius,
    pointFocus,
    ...restProps
  } = props;
  const [bounds, setBounds] = React__default.useState(null);
  const [key, setKey] = React__default.useState("");
  React__default.useEffect(() => {
    var _a3, _b3, _c2, _d2, _e2, _f3;
    if (!feature2)
      return;
    let featureBoundsData;
    let featureId;
    if (Array.isArray(feature2) && ((_a3 = feature2[0]) == null ? void 0 : _a3.type) === "Feature") {
      featureBoundsData = GeoUtil.getBoundingBox({
        type: "FeatureCollection",
        features: feature2
      });
      featureId = `numFeatures-${feature2.length}-${((_b3 = feature2[0]) == null ? void 0 : _b3.id) || ((_d2 = (_c2 = feature2[0]) == null ? void 0 : _c2.properties) == null ? void 0 : _d2.id) || "default-id"}`;
    } else if (typeof feature2 === "object" && feature2.type === "Feature") {
      featureBoundsData = GeoUtil.getBoundingBox(feature2);
      featureId = `feature-${(feature2 == null ? void 0 : feature2.id) || ((_e2 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _e2.id) || "default-id"}`;
    } else if (feature2 == null ? void 0 : feature2.box) {
      featureBoundsData = GeoUtil.computeRectangle(feature2.box);
      featureId = `asset-${(feature2 == null ? void 0 : feature2.id) || ((_f3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _f3.id) || "default-id"}`;
    } else {
      setBounds(null);
      return;
    }
    setKey(`${featureId}-${refreshCounter}`);
    let [west, south, east, north] = featureBoundsData || [];
    if (west && south && east && north) {
      const EPSILON2 = 1e-7;
      if (Math.abs(west - east) < EPSILON2 && Math.abs(north - south) < EPSILON2) {
        if (pointFocus === "zoomToPoint" && pointRadius) {
          const circle2 = GeoUtil.getTurfCircle(GeoUtil.getTurfPoint([west, north]), pointRadius);
          featureBoundsData = GeoUtil.getBoundingBox(circle2);
          if (featureBoundsData) {
            [west, south, east, north] = featureBoundsData;
          }
        } else {
          setBounds([west, north]);
          return;
        }
      }
      setBounds({
        west,
        south,
        east,
        north
      });
    } else
      setBounds(null);
  }, [feature2, refreshCounter]);
  const moveOrFit = bounds && Array.isArray(bounds) && bounds.length === 2;
  if (!bounds || !feature2)
    return null;
  if (moveOrFit)
    return /* @__PURE__ */ jsx(MapMoveTo, { center: bounds, bearing: bearing2, type: "easeTo", ...restProps });
  return /* @__PURE__ */ jsx(MapFitBounds, { ...bounds, bearing: bearing2, ...restProps }, key);
}
MapFitFeature.propTypes = {
  feature: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.array]),
  bearing: propTypesExports$1.number,
  refreshCounter: propTypesExports$1.number,
  pointRadius: propTypesExports$1.number,
  pointFocus: propTypesExports$1.oneOf(["zoomToPoint", "easeToPoint"])
};
MapFitFeature.defaultProps = {
  feature: null,
  bearing: 0,
  refreshCounter: 0,
  pointRadius: 50,
  // in meters
  pointFocus: "easeToPoint"
};
function MapFitSourceLayer(props) {
  const {
    enable: enable4,
    sourceId,
    sourceLayer,
    seedFeature,
    filter: filter17,
    maxDuration,
    duration,
    ...restProps
  } = props;
  const pendingRef = React__default.useRef(true);
  const {
    map: map5
  } = useMapbox();
  const [features, setFeatures] = React__default.useState(seedFeature ? [seedFeature] : seedFeature);
  const updateFeatures = React__default.useCallback(() => {
    let features2 = [];
    if (pendingRef.current) {
      features2 = map5.querySourceFeatures(sourceId, {
        sourceLayer
      }) || [];
      if (filter17) {
        features2 = features2.filter(filter17);
      }
      features2 = features2.map((f2) => ({
        type: f2.type,
        geometry: f2.geometry,
        properties: f2.properties
      }));
      if (seedFeature) {
        features2.push(seedFeature);
      }
      setFeatures(features2);
      if (features2.length) {
        setTimeout(() => {
          pendingRef.current = false;
        }, maxDuration);
      }
    }
  }, [filter17, map5, seedFeature, sourceId, sourceLayer, maxDuration]);
  const updateFeaturesMut = useMutableFunc(updateFeatures);
  React__default.useLayoutEffect(() => {
    if (sourceId && enable4) {
      pendingRef.current = true;
      updateFeaturesMut();
    } else {
      pendingRef.current = false;
    }
  }, [sourceId, enable4, updateFeaturesMut]);
  React__default.useLayoutEffect(() => {
    if (!map5)
      return () => {
      };
    map5.on("sourcedata", updateFeaturesMut);
    return () => {
      map5.off("sourcedata", updateFeaturesMut);
    };
  }, [map5, updateFeaturesMut]);
  const animation = React__default.useMemo(() => ({
    linear: false,
    duration,
    essential: true
  }), [duration]);
  if (!enable4 && (features == null ? void 0 : features.length))
    return null;
  return /* @__PURE__ */ jsx(MapFitFeature, { feature: features, ...animation, ...restProps }, `${sourceId}-${sourceLayer}`);
}
MapFitSourceLayer.propTypes = {
  enable: propTypesExports$1.bool,
  sourceId: propTypesExports$1.string,
  sourceLayer: propTypesExports$1.string,
  filter: propTypesExports$1.func,
  seedFeature: propTypesExports$1.object,
  maxDuration: propTypesExports$1.number,
  duration: propTypesExports$1.number
};
MapFitSourceLayer.defaultProps = {
  enable: false,
  sourceId: "",
  sourceLayer: void 0,
  filter: null,
  seedFeature: null,
  maxDuration: 5e3,
  // ms
  duration: 1e3
};
var fuzzyExports = {};
var fuzzy$1 = {
  get exports() {
    return fuzzyExports;
  },
  set exports(v5) {
    fuzzyExports = v5;
  }
};
(function(module2, exports2) {
  (function() {
    var fuzzy2 = {};
    {
      module2.exports = fuzzy2;
    }
    fuzzy2.simpleFilter = function(pattern, array2) {
      return array2.filter(function(str) {
        return fuzzy2.test(pattern, str);
      });
    };
    fuzzy2.test = function(pattern, str) {
      return fuzzy2.match(pattern, str) !== null;
    };
    fuzzy2.match = function(pattern, str, opts) {
      opts = opts || {};
      var patternIdx = 0, result = [], len2 = str.length, totalScore = 0, currScore = 0, pre = opts.pre || "", post = opts.post || "", compareString = opts.caseSensitive && str || str.toLowerCase(), ch2;
      pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
      for (var idx = 0; idx < len2; idx++) {
        ch2 = str[idx];
        if (compareString[idx] === pattern[patternIdx]) {
          ch2 = pre + ch2 + post;
          patternIdx += 1;
          currScore += 1 + currScore;
        } else {
          currScore = 0;
        }
        totalScore += currScore;
        result[result.length] = ch2;
      }
      if (patternIdx === pattern.length) {
        totalScore = compareString === pattern ? Infinity : totalScore;
        return { rendered: result.join(""), score: totalScore };
      }
      return null;
    };
    fuzzy2.filter = function(pattern, arr, opts) {
      if (!arr || arr.length === 0) {
        return [];
      }
      if (typeof pattern !== "string") {
        return arr;
      }
      opts = opts || {};
      return arr.reduce(function(prev, element, idx, arr2) {
        var str = element;
        if (opts.extract) {
          str = opts.extract(element);
        }
        var rendered = fuzzy2.match(pattern, str, opts);
        if (rendered != null) {
          prev[prev.length] = {
            string: rendered.rendered,
            score: rendered.score,
            index: idx,
            original: element
          };
        }
        return prev;
      }, []).sort(function(a2, b2) {
        var compare12 = b2.score - a2.score;
        if (compare12)
          return compare12;
        return a2.index - b2.index;
      });
    };
  })();
})(fuzzy$1);
var List$1 = function(component) {
  this.component = component;
  this.items = [];
  this.active = 0;
  this.wrapper = document.createElement("div");
  this.wrapper.className = "suggestions-wrapper";
  this.element = document.createElement("ul");
  this.element.className = "suggestions";
  this.wrapper.appendChild(this.element);
  this.selectingListItem = false;
  component.el.parentNode.insertBefore(this.wrapper, component.el.nextSibling);
  return this;
};
List$1.prototype.show = function() {
  this.element.style.display = "block";
};
List$1.prototype.hide = function() {
  this.element.style.display = "none";
};
List$1.prototype.add = function(item) {
  this.items.push(item);
};
List$1.prototype.clear = function() {
  this.items = [];
  this.active = 0;
};
List$1.prototype.isEmpty = function() {
  return !this.items.length;
};
List$1.prototype.isVisible = function() {
  return this.element.style.display === "block";
};
List$1.prototype.draw = function() {
  this.element.innerHTML = "";
  if (this.items.length === 0) {
    this.hide();
    return;
  }
  for (var i2 = 0; i2 < this.items.length; i2++) {
    this.drawItem(this.items[i2], this.active === i2);
  }
  this.show();
};
List$1.prototype.drawItem = function(item, active3) {
  var li = document.createElement("li"), a2 = document.createElement("a");
  if (active3)
    li.className += " active";
  a2.innerHTML = item.string;
  li.appendChild(a2);
  this.element.appendChild(li);
  li.addEventListener("mousedown", function() {
    this.selectingListItem = true;
  }.bind(this));
  li.addEventListener("mouseup", function() {
    this.handleMouseUp.call(this, item);
  }.bind(this));
};
List$1.prototype.handleMouseUp = function(item) {
  this.selectingListItem = false;
  this.component.value(item.original);
  this.clear();
  this.draw();
};
List$1.prototype.move = function(index2) {
  this.active = index2;
  this.draw();
};
List$1.prototype.previous = function() {
  this.move(this.active === 0 ? this.items.length - 1 : this.active - 1);
};
List$1.prototype.next = function() {
  this.move(this.active === this.items.length - 1 ? 0 : this.active + 1);
};
List$1.prototype.drawError = function(msg2) {
  var li = document.createElement("li");
  li.innerHTML = msg2;
  this.element.appendChild(li);
  this.show();
};
var list = List$1;
var extend$2 = immutable;
var fuzzy = fuzzyExports;
var List = list;
var Suggestions$1 = function(el, data2, options2) {
  options2 = options2 || {};
  this.options = extend$2({
    minLength: 2,
    limit: 5,
    filter: true,
    hideOnBlur: true
  }, options2);
  this.el = el;
  this.data = data2 || [];
  this.list = new List(this);
  this.query = "";
  this.selected = null;
  this.list.draw();
  this.el.addEventListener("keyup", function(e3) {
    this.handleKeyUp(e3.keyCode);
  }.bind(this), false);
  this.el.addEventListener("keydown", function(e3) {
    this.handleKeyDown(e3);
  }.bind(this));
  this.el.addEventListener("focus", function() {
    this.handleFocus();
  }.bind(this));
  this.el.addEventListener("blur", function() {
    this.handleBlur();
  }.bind(this));
  this.el.addEventListener("paste", function(e3) {
    this.handlePaste(e3);
  }.bind(this));
  this.render = this.options.render ? this.options.render.bind(this) : this.render.bind(this);
  this.getItemValue = this.options.getItemValue ? this.options.getItemValue.bind(this) : this.getItemValue.bind(this);
  return this;
};
Suggestions$1.prototype.handleKeyUp = function(keyCode) {
  if (keyCode === 40 || keyCode === 38 || keyCode === 27 || keyCode === 13 || keyCode === 9)
    return;
  this.handleInputChange(this.el.value);
};
Suggestions$1.prototype.handleKeyDown = function(e3) {
  switch (e3.keyCode) {
    case 13:
    case 9:
      if (!this.list.isEmpty()) {
        if (this.list.isVisible()) {
          e3.preventDefault();
        }
        this.value(this.list.items[this.list.active].original);
        this.list.hide();
      }
      break;
    case 27:
      if (!this.list.isEmpty())
        this.list.hide();
      break;
    case 38:
      this.list.previous();
      break;
    case 40:
      this.list.next();
      break;
  }
};
Suggestions$1.prototype.handleBlur = function() {
  if (!this.list.selectingListItem && this.options.hideOnBlur) {
    this.list.hide();
  }
};
Suggestions$1.prototype.handlePaste = function(e3) {
  if (e3.clipboardData) {
    this.handleInputChange(e3.clipboardData.getData("Text"));
  } else {
    var self2 = this;
    setTimeout(function() {
      self2.handleInputChange(e3.target.value);
    }, 100);
  }
};
Suggestions$1.prototype.handleInputChange = function(query6) {
  this.query = this.normalize(query6);
  this.list.clear();
  if (this.query.length < this.options.minLength) {
    this.list.draw();
    return;
  }
  this.getCandidates(function(data2) {
    for (var i2 = 0; i2 < data2.length; i2++) {
      this.list.add(data2[i2]);
      if (i2 === this.options.limit - 1)
        break;
    }
    this.list.draw();
  }.bind(this));
};
Suggestions$1.prototype.handleFocus = function() {
  if (!this.list.isEmpty())
    this.list.show();
  this.list.selectingListItem = false;
};
Suggestions$1.prototype.update = function(revisedData) {
  this.data = revisedData;
  this.handleKeyUp();
};
Suggestions$1.prototype.clear = function() {
  this.data = [];
  this.list.clear();
};
Suggestions$1.prototype.normalize = function(value) {
  value = value.toLowerCase();
  return value;
};
Suggestions$1.prototype.match = function(candidate, query6) {
  return candidate.indexOf(query6) > -1;
};
Suggestions$1.prototype.value = function(value) {
  this.selected = value;
  this.el.value = this.getItemValue(value);
  if (document.createEvent) {
    var e3 = document.createEvent("HTMLEvents");
    e3.initEvent("change", true, false);
    this.el.dispatchEvent(e3);
  } else {
    this.el.fireEvent("onchange");
  }
};
Suggestions$1.prototype.getCandidates = function(callback) {
  var options2 = {
    pre: "<strong>",
    post: "</strong>",
    extract: function(d2) {
      return this.getItemValue(d2);
    }.bind(this)
  };
  var results;
  if (this.options.filter) {
    results = fuzzy.filter(this.query, this.data, options2);
    results = results.map(function(item) {
      return {
        original: item.original,
        string: this.render(item.original, item.string)
      };
    }.bind(this));
  } else {
    results = this.data.map(function(d2) {
      var renderedString = this.render(d2);
      return {
        original: d2,
        string: renderedString
      };
    }.bind(this));
  }
  callback(results);
};
Suggestions$1.prototype.getItemValue = function(item) {
  return item;
};
Suggestions$1.prototype.render = function(item, sourceFormatting) {
  if (sourceFormatting) {
    return sourceFormatting;
  }
  var boldString = item.original ? this.getItemValue(item.original) : this.getItemValue(item);
  var indexString = this.normalize(boldString);
  var indexOfQuery = indexString.lastIndexOf(this.query);
  while (indexOfQuery > -1) {
    var endIndexOfQuery = indexOfQuery + this.query.length;
    boldString = boldString.slice(0, indexOfQuery) + "<strong>" + boldString.slice(indexOfQuery, endIndexOfQuery) + "</strong>" + boldString.slice(endIndexOfQuery);
    indexOfQuery = indexString.slice(0, indexOfQuery).lastIndexOf(this.query);
  }
  return boldString;
};
Suggestions$1.prototype.renderError = function(msg2) {
  this.list.drawError(msg2);
};
var suggestions$1 = Suggestions$1;
var Suggestions = suggestions$1;
var suggestions = Suggestions;
if (typeof window !== "undefined") {
  window.Suggestions = Suggestions;
}
var FUNC_ERROR_TEXT = "Expected a function";
var NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax = Math.max, nativeMin = Math.min;
var now = function() {
  return root.Date.now();
};
function debounce$1(func2, wait, options2) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func2 != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax(toNumber(options2.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func2.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, result2 = wait - timeSinceLastCall;
    return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel2() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time2 = now(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel2;
  debounced.flush = flush;
  return debounced;
}
function isObject(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_debounce = debounce$1;
var eventsExports = {};
var events$1 = {
  get exports() {
    return eventsExports;
  },
  set exports(v5) {
    eventsExports = v5;
  }
};
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply = R && typeof R.apply === "function" ? R.apply : function ReflectApply2(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning(warning2) {
  if (console && console.warn)
    console.warn(warning2);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN2(value) {
  return value !== value;
};
function EventEmitter$2() {
  EventEmitter$2.init.call(this);
}
events$1.exports = EventEmitter$2;
eventsExports.once = once;
EventEmitter$2.EventEmitter = EventEmitter$2;
EventEmitter$2.prototype._events = void 0;
EventEmitter$2.prototype._eventsCount = 0;
EventEmitter$2.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(listener) {
  if (typeof listener !== "function") {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}
Object.defineProperty(EventEmitter$2, "defaultMaxListeners", {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== "number" || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
    }
    defaultMaxListeners = arg;
  }
});
EventEmitter$2.init = function() {
  if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$2.prototype.setMaxListeners = function setMaxListeners(n2) {
  if (typeof n2 !== "number" || n2 < 0 || NumberIsNaN(n2)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n2 + ".");
  }
  this._maxListeners = n2;
  return this;
};
function _getMaxListeners(that) {
  if (that._maxListeners === void 0)
    return EventEmitter$2.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter$2.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};
EventEmitter$2.prototype.emit = function emit(type) {
  var args = [];
  for (var i2 = 1; i2 < arguments.length; i2++)
    args.push(arguments[i2]);
  var doError = type === "error";
  var events2 = this._events;
  if (events2 !== void 0)
    doError = doError && events2.error === void 0;
  else if (!doError)
    return false;
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      throw er;
    }
    var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
    err.context = er;
    throw err;
  }
  var handler = events2[type];
  if (handler === void 0)
    return false;
  if (typeof handler === "function") {
    ReflectApply(handler, this, args);
  } else {
    var len2 = handler.length;
    var listeners2 = arrayClone(handler, len2);
    for (var i2 = 0; i2 < len2; ++i2)
      ReflectApply(listeners2[i2], this, args);
  }
  return true;
};
function _addListener(target, type, listener, prepend) {
  var m2;
  var events2;
  var existing;
  checkListener(listener);
  events2 = target._events;
  if (events2 === void 0) {
    events2 = target._events = /* @__PURE__ */ Object.create(null);
    target._eventsCount = 0;
  } else {
    if (events2.newListener !== void 0) {
      target.emit(
        "newListener",
        type,
        listener.listener ? listener.listener : listener
      );
      events2 = target._events;
    }
    existing = events2[type];
  }
  if (existing === void 0) {
    existing = events2[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events2[type] = prepend ? [listener, existing] : [existing, listener];
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }
    m2 = _getMaxListeners(target);
    if (m2 > 0 && existing.length > m2 && !existing.warned) {
      existing.warned = true;
      var w2 = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      w2.name = "MaxListenersExceededWarning";
      w2.emitter = target;
      w2.type = type;
      w2.count = existing.length;
      ProcessEmitWarning(w2);
    }
  }
  return target;
}
EventEmitter$2.prototype.addListener = function addListener2(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter$2.prototype.on = EventEmitter$2.prototype.addListener;
EventEmitter$2.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: void 0, target, type, listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter$2.prototype.once = function once2(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter$2.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter$2.prototype.removeListener = function removeListener2(type, listener) {
  var list2, events2, position, i2, originalListener;
  checkListener(listener);
  events2 = this._events;
  if (events2 === void 0)
    return this;
  list2 = events2[type];
  if (list2 === void 0)
    return this;
  if (list2 === listener || list2.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = /* @__PURE__ */ Object.create(null);
    else {
      delete events2[type];
      if (events2.removeListener)
        this.emit("removeListener", type, list2.listener || listener);
    }
  } else if (typeof list2 !== "function") {
    position = -1;
    for (i2 = list2.length - 1; i2 >= 0; i2--) {
      if (list2[i2] === listener || list2[i2].listener === listener) {
        originalListener = list2[i2].listener;
        position = i2;
        break;
      }
    }
    if (position < 0)
      return this;
    if (position === 0)
      list2.shift();
    else {
      spliceOne(list2, position);
    }
    if (list2.length === 1)
      events2[type] = list2[0];
    if (events2.removeListener !== void 0)
      this.emit("removeListener", type, originalListener || listener);
  }
  return this;
};
EventEmitter$2.prototype.off = EventEmitter$2.prototype.removeListener;
EventEmitter$2.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners2, events2, i2;
  events2 = this._events;
  if (events2 === void 0)
    return this;
  if (events2.removeListener === void 0) {
    if (arguments.length === 0) {
      this._events = /* @__PURE__ */ Object.create(null);
      this._eventsCount = 0;
    } else if (events2[type] !== void 0) {
      if (--this._eventsCount === 0)
        this._events = /* @__PURE__ */ Object.create(null);
      else
        delete events2[type];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys4 = Object.keys(events2);
    var key;
    for (i2 = 0; i2 < keys4.length; ++i2) {
      key = keys4[i2];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners2 = events2[type];
  if (typeof listeners2 === "function") {
    this.removeListener(type, listeners2);
  } else if (listeners2 !== void 0) {
    for (i2 = listeners2.length - 1; i2 >= 0; i2--) {
      this.removeListener(type, listeners2[i2]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events2 = target._events;
  if (events2 === void 0)
    return [];
  var evlistener = events2[type];
  if (evlistener === void 0)
    return [];
  if (typeof evlistener === "function")
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter$2.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};
EventEmitter$2.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};
EventEmitter$2.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter$2.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events2 = this._events;
  if (events2 !== void 0) {
    var evlistener = events2[type];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener !== void 0) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter$2.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n2) {
  var copy8 = new Array(n2);
  for (var i2 = 0; i2 < n2; ++i2)
    copy8[i2] = arr[i2];
  return copy8;
}
function spliceOne(list2, index2) {
  for (; index2 + 1 < list2.length; index2++)
    list2[index2] = list2[index2 + 1];
  list2.pop();
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i2 = 0; i2 < ret.length; ++i2) {
    ret[i2] = arr[i2].listener || arr[i2];
  }
  return ret;
}
function once(emitter, name2) {
  return new Promise(function(resolve2, reject) {
    function errorListener(err) {
      emitter.removeListener(name2, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === "function") {
        emitter.removeListener("error", errorListener);
      }
      resolve2([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name2, resolver, { once: true });
    if (name2 !== "error") {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags2) {
  if (typeof emitter.on === "function") {
    eventTargetAgnosticAddListener(emitter, "error", handler, flags2);
  }
}
function eventTargetAgnosticAddListener(emitter, name2, listener, flags2) {
  if (typeof emitter.on === "function") {
    if (flags2.once) {
      emitter.once(name2, listener);
    } else {
      emitter.on(name2, listener);
    }
  } else if (typeof emitter.addEventListener === "function") {
    emitter.addEventListener(name2, function wrapListener(arg) {
      if (flags2.once) {
        emitter.removeEventListener(name2, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
var exceptions$1 = {
  "fr": {
    "name": "France",
    "bbox": [[-4.59235, 41.380007], [9.560016, 51.148506]]
  },
  "us": {
    "name": "United States",
    "bbox": [[-171.791111, 18.91619], [-66.96466, 71.357764]]
  },
  "ru": {
    "name": "Russia",
    "bbox": [[19.66064, 41.151416], [190.10042, 81.2504]]
  },
  "ca": {
    "name": "Canada",
    "bbox": [[-140.99778, 41.675105], [-52.648099, 83.23324]]
  }
};
function parseParam(param) {
  var parts = param.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
  if (!parts)
    return null;
  return {
    key: parts[1],
    value: parts[2]
  };
}
function parseLink(link2) {
  var parts = link2.match(/<?([^>]*)>(.*)/);
  if (!parts)
    return null;
  var linkUrl = parts[1];
  var linkParams = parts[2].split(";");
  var rel = null;
  var parsedLinkParams = linkParams.reduce(function(result, param) {
    var parsed = parseParam(param);
    if (!parsed)
      return result;
    if (parsed.key === "rel") {
      if (!rel) {
        rel = parsed.value;
      }
      return result;
    }
    result[parsed.key] = parsed.value;
    return result;
  }, {});
  if (!rel)
    return null;
  return {
    url: linkUrl,
    rel,
    params: parsedLinkParams
  };
}
function parseLinkHeader$1(linkHeader) {
  if (!linkHeader)
    return {};
  return linkHeader.split(/,\s*</).reduce(function(result, link2) {
    var parsed = parseLink(link2);
    if (!parsed)
      return result;
    var splitRel = parsed.rel.split(/\s+/);
    splitRel.forEach(function(rel) {
      if (!result[rel]) {
        result[rel] = {
          url: parsed.url,
          params: parsed.params
        };
      }
    });
    return result;
  }, {});
}
var parseLinkHeader_1 = parseLinkHeader$1;
var parseLinkHeader = parseLinkHeader_1;
function MapiResponse$1(request, responseData) {
  this.request = request;
  this.headers = responseData.headers;
  this.rawBody = responseData.body;
  this.statusCode = responseData.statusCode;
  try {
    this.body = JSON.parse(responseData.body || "{}");
  } catch (parseError) {
    this.body = responseData.body;
  }
  this.links = parseLinkHeader(this.headers.link);
}
MapiResponse$1.prototype.hasNextPage = function hasNextPage() {
  return !!this.links.next;
};
MapiResponse$1.prototype.nextPage = function nextPage() {
  if (!this.hasNextPage())
    return null;
  return this.request._extend({
    path: this.links.next.url
  });
};
var mapiResponse = MapiResponse$1;
var constants$5 = {
  API_ORIGIN: "https://api.mapbox.com",
  EVENT_PROGRESS_DOWNLOAD: "downloadProgress",
  EVENT_PROGRESS_UPLOAD: "uploadProgress",
  EVENT_ERROR: "error",
  EVENT_RESPONSE: "response",
  ERROR_HTTP: "HttpError",
  ERROR_REQUEST_ABORTED: "RequestAbortedError"
};
var constants$4 = constants$5;
function MapiError$1(options2) {
  var errorType = options2.type || constants$4.ERROR_HTTP;
  var body;
  if (options2.body) {
    try {
      body = JSON.parse(options2.body);
    } catch (e3) {
      body = options2.body;
    }
  } else {
    body = null;
  }
  var message2 = options2.message || null;
  if (!message2) {
    if (typeof body === "string") {
      message2 = body;
    } else if (body && typeof body.message === "string") {
      message2 = body.message;
    } else if (errorType === constants$4.ERROR_REQUEST_ABORTED) {
      message2 = "Request aborted";
    }
  }
  this.message = message2;
  this.type = errorType;
  this.statusCode = options2.statusCode || null;
  this.request = options2.request;
  this.body = body;
}
var mapiError = MapiError$1;
function parseSingleHeader(raw) {
  var boundary = raw.indexOf(":");
  var name2 = raw.substring(0, boundary).trim().toLowerCase();
  var value = raw.substring(boundary + 1).trim();
  return {
    name: name2,
    value
  };
}
function parseHeaders$1(raw) {
  var headers = {};
  if (!raw) {
    return headers;
  }
  raw.trim().split(/[\r|\n]+/).forEach(function(rawHeader) {
    var parsed = parseSingleHeader(rawHeader);
    headers[parsed.name] = parsed.value;
  });
  return headers;
}
var parseHeaders_1 = parseHeaders$1;
var MapiResponse = mapiResponse;
var MapiError = mapiError;
var constants$3 = constants$5;
var parseHeaders = parseHeaders_1;
var requestsUnderway = {};
function browserAbort(request) {
  var xhr = requestsUnderway[request.id];
  if (!xhr)
    return;
  xhr.abort();
  delete requestsUnderway[request.id];
}
function createResponse(request, xhr) {
  return new MapiResponse(request, {
    body: xhr.response,
    headers: parseHeaders(xhr.getAllResponseHeaders()),
    statusCode: xhr.status
  });
}
function normalizeBrowserProgressEvent(event) {
  var total = event.total;
  var transferred = event.loaded;
  var percent = 100 * transferred / total;
  return {
    total,
    transferred,
    percent
  };
}
function sendRequestXhr(request, xhr) {
  return new Promise(function(resolve2, reject) {
    xhr.onprogress = function(event) {
      request.emitter.emit(
        constants$3.EVENT_PROGRESS_DOWNLOAD,
        normalizeBrowserProgressEvent(event)
      );
    };
    var file2 = request.file;
    if (file2) {
      xhr.upload.onprogress = function(event) {
        request.emitter.emit(
          constants$3.EVENT_PROGRESS_UPLOAD,
          normalizeBrowserProgressEvent(event)
        );
      };
    }
    xhr.onerror = function(error2) {
      reject(error2);
    };
    xhr.onabort = function() {
      var mapiError2 = new MapiError({
        request,
        type: constants$3.ERROR_REQUEST_ABORTED
      });
      reject(mapiError2);
    };
    xhr.onload = function() {
      delete requestsUnderway[request.id];
      if (xhr.status < 200 || xhr.status >= 400) {
        var mapiError2 = new MapiError({
          request,
          body: xhr.response,
          statusCode: xhr.status
        });
        reject(mapiError2);
        return;
      }
      resolve2(xhr);
    };
    var body = request.body;
    if (typeof body === "string") {
      xhr.send(body);
    } else if (body) {
      xhr.send(JSON.stringify(body));
    } else if (file2) {
      xhr.send(file2);
    } else {
      xhr.send();
    }
    requestsUnderway[request.id] = xhr;
  }).then(function(xhr2) {
    return createResponse(request, xhr2);
  });
}
function createRequestXhr(request, accessToken) {
  var url2 = request.url(accessToken);
  var xhr = new window.XMLHttpRequest();
  xhr.open(request.method, url2);
  Object.keys(request.headers).forEach(function(key) {
    xhr.setRequestHeader(key, request.headers[key]);
  });
  return xhr;
}
function browserSend(request) {
  return Promise.resolve().then(function() {
    var xhr = createRequestXhr(request, request.client.accessToken);
    return sendRequestXhr(request, xhr);
  });
}
var browserLayer = {
  browserAbort,
  sendRequestXhr,
  browserSend,
  createRequestXhr
};
var base64Exports = {};
var base64$1 = {
  get exports() {
    return base64Exports;
  },
  set exports(v5) {
    base64Exports = v5;
  }
};
/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
(function(module2, exports2) {
  (function(root2) {
    var freeExports2 = exports2;
    var freeModule2 = module2 && module2.exports == freeExports2 && module2;
    var freeGlobal2 = typeof commonjsGlobal$1 == "object" && commonjsGlobal$1;
    if (freeGlobal2.global === freeGlobal2 || freeGlobal2.window === freeGlobal2) {
      root2 = freeGlobal2;
    }
    var InvalidCharacterError = function(message2) {
      this.message = message2;
    };
    InvalidCharacterError.prototype = new Error();
    InvalidCharacterError.prototype.name = "InvalidCharacterError";
    var error2 = function(message2) {
      throw new InvalidCharacterError(message2);
    };
    var TABLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
    var decode2 = function(input) {
      input = String(input).replace(REGEX_SPACE_CHARACTERS, "");
      var length2 = input.length;
      if (length2 % 4 == 0) {
        input = input.replace(/==?$/, "");
        length2 = input.length;
      }
      if (length2 % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
      /[^+a-zA-Z0-9/]/.test(input)) {
        error2(
          "Invalid character: the string to be decoded is not correctly encoded."
        );
      }
      var bitCounter = 0;
      var bitStorage;
      var buffer3;
      var output2 = "";
      var position = -1;
      while (++position < length2) {
        buffer3 = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer3 : buffer3;
        if (bitCounter++ % 4) {
          output2 += String.fromCharCode(
            255 & bitStorage >> (-2 * bitCounter & 6)
          );
        }
      }
      return output2;
    };
    var encode2 = function(input) {
      input = String(input);
      if (/[^\0-\xFF]/.test(input)) {
        error2(
          "The string to be encoded contains characters outside of the Latin1 range."
        );
      }
      var padding = input.length % 3;
      var output2 = "";
      var position = -1;
      var a2;
      var b2;
      var c2;
      var buffer3;
      var length2 = input.length - padding;
      while (++position < length2) {
        a2 = input.charCodeAt(position) << 16;
        b2 = input.charCodeAt(++position) << 8;
        c2 = input.charCodeAt(++position);
        buffer3 = a2 + b2 + c2;
        output2 += TABLE.charAt(buffer3 >> 18 & 63) + TABLE.charAt(buffer3 >> 12 & 63) + TABLE.charAt(buffer3 >> 6 & 63) + TABLE.charAt(buffer3 & 63);
      }
      if (padding == 2) {
        a2 = input.charCodeAt(position) << 8;
        b2 = input.charCodeAt(++position);
        buffer3 = a2 + b2;
        output2 += TABLE.charAt(buffer3 >> 10) + TABLE.charAt(buffer3 >> 4 & 63) + TABLE.charAt(buffer3 << 2 & 63) + "=";
      } else if (padding == 1) {
        buffer3 = input.charCodeAt(position);
        output2 += TABLE.charAt(buffer3 >> 2) + TABLE.charAt(buffer3 << 4 & 63) + "==";
      }
      return output2;
    };
    var base642 = {
      "encode": encode2,
      "decode": decode2,
      "version": "0.1.0"
    };
    if (freeExports2 && !freeExports2.nodeType) {
      if (freeModule2) {
        freeModule2.exports = base642;
      } else {
        for (var key in base642) {
          base642.hasOwnProperty(key) && (freeExports2[key] = base642[key]);
        }
      }
    } else {
      root2.base64 = base642;
    }
  })(commonjsGlobal$1);
})(base64$1, base64Exports);
var base64 = base64Exports;
var tokenCache = {};
function parseToken$2(token) {
  if (tokenCache[token]) {
    return tokenCache[token];
  }
  var parts = token.split(".");
  var usage = parts[0];
  var rawPayload = parts[1];
  if (!rawPayload) {
    throw new Error("Invalid token");
  }
  var parsedPayload = parsePaylod(rawPayload);
  var result = {
    usage,
    user: parsedPayload.u
  };
  if (has(parsedPayload, "a"))
    result.authorization = parsedPayload.a;
  if (has(parsedPayload, "exp"))
    result.expires = parsedPayload.exp * 1e3;
  if (has(parsedPayload, "iat"))
    result.created = parsedPayload.iat * 1e3;
  if (has(parsedPayload, "scopes"))
    result.scopes = parsedPayload.scopes;
  if (has(parsedPayload, "client"))
    result.client = parsedPayload.client;
  if (has(parsedPayload, "ll"))
    result.lastLogin = parsedPayload.ll;
  if (has(parsedPayload, "iu"))
    result.impersonator = parsedPayload.iu;
  tokenCache[token] = result;
  return result;
}
function parsePaylod(rawPayload) {
  try {
    return JSON.parse(base64.decode(rawPayload));
  } catch (parseError) {
    throw new Error("Invalid token");
  }
}
function has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}
var parseMapboxToken = parseToken$2;
var eventemitter3Exports = {};
var eventemitter3 = {
  get exports() {
    return eventemitter3Exports;
  },
  set exports(v5) {
    eventemitter3Exports = v5;
  }
};
(function(module2) {
  var has2 = Object.prototype.hasOwnProperty, prefix = "~";
  function Events() {
  }
  if (Object.create) {
    Events.prototype = /* @__PURE__ */ Object.create(null);
    if (!new Events().__proto__)
      prefix = false;
  }
  function EE(fn2, context2, once3) {
    this.fn = fn2;
    this.context = context2;
    this.once = once3 || false;
  }
  function addListener3(emitter, event, fn2, context2, once3) {
    if (typeof fn2 !== "function") {
      throw new TypeError("The listener must be a function");
    }
    var listener = new EE(fn2, context2 || emitter, once3), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt])
      emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn)
      emitter._events[evt].push(listener);
    else
      emitter._events[evt] = [emitter._events[evt], listener];
    return emitter;
  }
  function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0)
      emitter._events = new Events();
    else
      delete emitter._events[evt];
  }
  function EventEmitter2() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  EventEmitter2.prototype.eventNames = function eventNames2() {
    var names2 = [], events2, name2;
    if (this._eventsCount === 0)
      return names2;
    for (name2 in events2 = this._events) {
      if (has2.call(events2, name2))
        names2.push(prefix ? name2.slice(1) : name2);
    }
    if (Object.getOwnPropertySymbols) {
      return names2.concat(Object.getOwnPropertySymbols(events2));
    }
    return names2;
  };
  EventEmitter2.prototype.listeners = function listeners2(event) {
    var evt = prefix ? prefix + event : event, handlers2 = this._events[evt];
    if (!handlers2)
      return [];
    if (handlers2.fn)
      return [handlers2.fn];
    for (var i2 = 0, l2 = handlers2.length, ee = new Array(l2); i2 < l2; i2++) {
      ee[i2] = handlers2[i2].fn;
    }
    return ee;
  };
  EventEmitter2.prototype.listenerCount = function listenerCount2(event) {
    var evt = prefix ? prefix + event : event, listeners2 = this._events[evt];
    if (!listeners2)
      return 0;
    if (listeners2.fn)
      return 1;
    return listeners2.length;
  };
  EventEmitter2.prototype.emit = function emit2(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return false;
    var listeners2 = this._events[evt], len2 = arguments.length, args, i2;
    if (listeners2.fn) {
      if (listeners2.once)
        this.removeListener(event, listeners2.fn, void 0, true);
      switch (len2) {
        case 1:
          return listeners2.fn.call(listeners2.context), true;
        case 2:
          return listeners2.fn.call(listeners2.context, a1), true;
        case 3:
          return listeners2.fn.call(listeners2.context, a1, a2), true;
        case 4:
          return listeners2.fn.call(listeners2.context, a1, a2, a3), true;
        case 5:
          return listeners2.fn.call(listeners2.context, a1, a2, a3, a4), true;
        case 6:
          return listeners2.fn.call(listeners2.context, a1, a2, a3, a4, a5), true;
      }
      for (i2 = 1, args = new Array(len2 - 1); i2 < len2; i2++) {
        args[i2 - 1] = arguments[i2];
      }
      listeners2.fn.apply(listeners2.context, args);
    } else {
      var length2 = listeners2.length, j2;
      for (i2 = 0; i2 < length2; i2++) {
        if (listeners2[i2].once)
          this.removeListener(event, listeners2[i2].fn, void 0, true);
        switch (len2) {
          case 1:
            listeners2[i2].fn.call(listeners2[i2].context);
            break;
          case 2:
            listeners2[i2].fn.call(listeners2[i2].context, a1);
            break;
          case 3:
            listeners2[i2].fn.call(listeners2[i2].context, a1, a2);
            break;
          case 4:
            listeners2[i2].fn.call(listeners2[i2].context, a1, a2, a3);
            break;
          default:
            if (!args)
              for (j2 = 1, args = new Array(len2 - 1); j2 < len2; j2++) {
                args[j2 - 1] = arguments[j2];
              }
            listeners2[i2].fn.apply(listeners2[i2].context, args);
        }
      }
    }
    return true;
  };
  EventEmitter2.prototype.on = function on2(event, fn2, context2) {
    return addListener3(this, event, fn2, context2, false);
  };
  EventEmitter2.prototype.once = function once3(event, fn2, context2) {
    return addListener3(this, event, fn2, context2, true);
  };
  EventEmitter2.prototype.removeListener = function removeListener3(event, fn2, context2, once3) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt])
      return this;
    if (!fn2) {
      clearEvent(this, evt);
      return this;
    }
    var listeners2 = this._events[evt];
    if (listeners2.fn) {
      if (listeners2.fn === fn2 && (!once3 || listeners2.once) && (!context2 || listeners2.context === context2)) {
        clearEvent(this, evt);
      }
    } else {
      for (var i2 = 0, events2 = [], length2 = listeners2.length; i2 < length2; i2++) {
        if (listeners2[i2].fn !== fn2 || once3 && !listeners2[i2].once || context2 && listeners2[i2].context !== context2) {
          events2.push(listeners2[i2]);
        }
      }
      if (events2.length)
        this._events[evt] = events2.length === 1 ? events2[0] : events2;
      else
        clearEvent(this, evt);
    }
    return this;
  };
  EventEmitter2.prototype.removeAllListeners = function removeAllListeners2(event) {
    var evt;
    if (event) {
      evt = prefix ? prefix + event : event;
      if (this._events[evt])
        clearEvent(this, evt);
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }
    return this;
  };
  EventEmitter2.prototype.off = EventEmitter2.prototype.removeListener;
  EventEmitter2.prototype.addListener = EventEmitter2.prototype.on;
  EventEmitter2.prefixed = prefix;
  EventEmitter2.EventEmitter = EventEmitter2;
  {
    module2.exports = EventEmitter2;
  }
})(eventemitter3);
function encodeArray(arrayValue) {
  return arrayValue.map(encodeURIComponent).join(",");
}
function encodeValue(value) {
  if (Array.isArray(value)) {
    return encodeArray(value);
  }
  return encodeURIComponent(String(value));
}
function appendQueryParam(url2, key, value) {
  if (value === false || value === null) {
    return url2;
  }
  var punctuation = /\?/.test(url2) ? "&" : "?";
  var query6 = encodeURIComponent(key);
  if (value !== void 0 && value !== "" && value !== true) {
    query6 += "=" + encodeValue(value);
  }
  return "" + url2 + punctuation + query6;
}
function appendQueryObject(url2, queryObject) {
  if (!queryObject) {
    return url2;
  }
  var result = url2;
  Object.keys(queryObject).forEach(function(key) {
    var value = queryObject[key];
    if (value === void 0) {
      return;
    }
    if (Array.isArray(value)) {
      value = value.filter(function(v5) {
        return v5 !== null && v5 !== void 0;
      }).join(",");
    }
    result = appendQueryParam(result, key, value);
  });
  return result;
}
function prependOrigin(url2, origin) {
  if (!origin) {
    return url2;
  }
  if (url2.slice(0, 4) === "http") {
    return url2;
  }
  var delimiter = url2[0] === "/" ? "" : "/";
  return "" + origin.replace(/\/$/, "") + delimiter + url2;
}
function interpolateRouteParams(route, params2) {
  if (!params2) {
    return route;
  }
  return route.replace(/\/:([a-zA-Z0-9]+)/g, function(_2, paramId) {
    var value = params2[paramId];
    if (value === void 0) {
      throw new Error("Unspecified route parameter " + paramId);
    }
    var preppedValue = encodeValue(value);
    return "/" + preppedValue;
  });
}
var urlUtils$1 = {
  appendQueryObject,
  appendQueryParam,
  prependOrigin,
  interpolateRouteParams
};
var parseToken$1 = parseMapboxToken;
var xtend$3 = immutable;
var EventEmitter$1 = eventemitter3Exports;
var urlUtils = urlUtils$1;
var constants$2 = constants$5;
var requestId = 1;
function MapiRequest$1(client2, options2) {
  if (!client2) {
    throw new Error("MapiRequest requires a client");
  }
  if (!options2 || !options2.path || !options2.method) {
    throw new Error(
      "MapiRequest requires an options object with path and method properties"
    );
  }
  var defaultHeaders = {};
  if (options2.body) {
    defaultHeaders["content-type"] = "application/json";
  }
  var headersWithDefaults = xtend$3(defaultHeaders, options2.headers);
  var headers = Object.keys(headersWithDefaults).reduce(function(memo, name2) {
    memo[name2.toLowerCase()] = headersWithDefaults[name2];
    return memo;
  }, {});
  this.id = requestId++;
  this._options = options2;
  this.emitter = new EventEmitter$1();
  this.client = client2;
  this.response = null;
  this.error = null;
  this.sent = false;
  this.aborted = false;
  this.path = options2.path;
  this.method = options2.method;
  this.origin = options2.origin || client2.origin;
  this.query = options2.query || {};
  this.params = options2.params || {};
  this.body = options2.body || null;
  this.file = options2.file || null;
  this.encoding = options2.encoding || "utf8";
  this.sendFileAs = options2.sendFileAs || null;
  this.headers = headers;
}
MapiRequest$1.prototype.url = function url(accessToken) {
  var url2 = urlUtils.prependOrigin(this.path, this.origin);
  url2 = urlUtils.appendQueryObject(url2, this.query);
  var routeParams = this.params;
  var actualAccessToken = accessToken == null ? this.client.accessToken : accessToken;
  if (actualAccessToken) {
    url2 = urlUtils.appendQueryParam(url2, "access_token", actualAccessToken);
    var accessTokenOwnerId = parseToken$1(actualAccessToken).user;
    routeParams = xtend$3({ ownerId: accessTokenOwnerId }, routeParams);
  }
  url2 = urlUtils.interpolateRouteParams(url2, routeParams);
  return url2;
};
MapiRequest$1.prototype.send = function send() {
  var self2 = this;
  if (self2.sent) {
    throw new Error(
      "This request has already been sent. Check the response and error properties. Create a new request with clone()."
    );
  }
  self2.sent = true;
  return self2.client.sendRequest(self2).then(
    function(response) {
      self2.response = response;
      self2.emitter.emit(constants$2.EVENT_RESPONSE, response);
      return response;
    },
    function(error2) {
      self2.error = error2;
      self2.emitter.emit(constants$2.EVENT_ERROR, error2);
      throw error2;
    }
  );
};
MapiRequest$1.prototype.abort = function abort() {
  if (this._nextPageRequest) {
    this._nextPageRequest.abort();
    delete this._nextPageRequest;
  }
  if (this.response || this.error || this.aborted)
    return;
  this.aborted = true;
  this.client.abortRequest(this);
};
MapiRequest$1.prototype.eachPage = function eachPage(callback) {
  var self2 = this;
  function handleResponse(response) {
    function getNextPage() {
      delete self2._nextPageRequest;
      var nextPageRequest = response.nextPage();
      if (nextPageRequest) {
        self2._nextPageRequest = nextPageRequest;
        getPage(nextPageRequest);
      }
    }
    callback(null, response, getNextPage);
  }
  function handleError(error2) {
    callback(error2, null, function() {
    });
  }
  function getPage(request) {
    request.send().then(handleResponse, handleError);
  }
  getPage(this);
};
MapiRequest$1.prototype.clone = function clone7() {
  return this._extend();
};
MapiRequest$1.prototype._extend = function _extend(options2) {
  var extendedOptions = xtend$3(this._options, options2);
  return new MapiRequest$1(this.client, extendedOptions);
};
var mapiRequest = MapiRequest$1;
var parseToken = parseMapboxToken;
var MapiRequest = mapiRequest;
var constants$1 = constants$5;
function MapiClient$2(options2) {
  if (!options2 || !options2.accessToken) {
    throw new Error("Cannot create a client without an access token");
  }
  parseToken(options2.accessToken);
  this.accessToken = options2.accessToken;
  this.origin = options2.origin || constants$1.API_ORIGIN;
}
MapiClient$2.prototype.createRequest = function createRequest(requestOptions) {
  return new MapiRequest(this, requestOptions);
};
var mapiClient = MapiClient$2;
var browser = browserLayer;
var MapiClient$1 = mapiClient;
function BrowserClient(options2) {
  MapiClient$1.call(this, options2);
}
BrowserClient.prototype = Object.create(MapiClient$1.prototype);
BrowserClient.prototype.constructor = BrowserClient;
BrowserClient.prototype.sendRequest = browser.browserSend;
BrowserClient.prototype.abortRequest = browser.browserAbort;
function createBrowserClient(options2) {
  return new BrowserClient(options2);
}
var browserClient = createBrowserClient;
var client = browserClient;
var mapboxSdk = client;
var toString = Object.prototype.toString;
var isPlainObj = function(x2) {
  var prototype2;
  return toString.call(x2) === "[object Object]" && (prototype2 = Object.getPrototypeOf(x2), prototype2 === null || prototype2 === Object.getPrototypeOf({}));
};
var isPlainObject = isPlainObj;
var xtend$2 = immutable;
var DEFAULT_ERROR_PATH = "value";
var NEWLINE_INDENT = "\n  ";
var v$2 = {};
v$2.assert = function(rootValidator, options2) {
  options2 = options2 || {};
  return function(value) {
    var message2 = validate(rootValidator, value);
    if (!message2) {
      return;
    }
    var errorMessage = processMessage(message2, options2);
    if (options2.apiName) {
      errorMessage = options2.apiName + ": " + errorMessage;
    }
    throw new Error(errorMessage);
  };
};
v$2.shape = function shape(validatorObj) {
  var validators = objectEntries(validatorObj);
  return function shapeValidator(value) {
    var validationResult = validate(v$2.plainObject, value);
    if (validationResult) {
      return validationResult;
    }
    var key, validator2;
    var errorMessages = [];
    for (var i2 = 0; i2 < validators.length; i2++) {
      key = validators[i2].key;
      validator2 = validators[i2].value;
      validationResult = validate(validator2, value[key]);
      if (validationResult) {
        errorMessages.push([key].concat(validationResult));
      }
    }
    if (errorMessages.length < 2) {
      return errorMessages[0];
    }
    return function(options2) {
      errorMessages = errorMessages.map(function(message2) {
        var key2 = message2[0];
        var renderedMessage = processMessage(message2, options2).split("\n").join(NEWLINE_INDENT);
        return "- " + key2 + ": " + renderedMessage;
      });
      var objectId = options2.path.join(".");
      var ofPhrase = objectId === DEFAULT_ERROR_PATH ? "" : " of " + objectId;
      return "The following properties" + ofPhrase + " have invalid values:" + NEWLINE_INDENT + errorMessages.join(NEWLINE_INDENT);
    };
  };
};
v$2.strictShape = function strictShape(validatorObj) {
  var shapeValidator = v$2.shape(validatorObj);
  return function strictShapeValidator(value) {
    var shapeResult = shapeValidator(value);
    if (shapeResult) {
      return shapeResult;
    }
    var invalidKeys = Object.keys(value).reduce(function(memo, valueKey) {
      if (validatorObj[valueKey] === void 0) {
        memo.push(valueKey);
      }
      return memo;
    }, []);
    if (invalidKeys.length !== 0) {
      return function() {
        return "The following keys are invalid: " + invalidKeys.join(", ");
      };
    }
  };
};
v$2.arrayOf = function arrayOf(validator2) {
  return createArrayValidator(validator2);
};
v$2.tuple = function tuple() {
  var validators = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  return createArrayValidator(validators);
};
function createArrayValidator(validators) {
  var validatingTuple = Array.isArray(validators);
  var getValidator = function(index2) {
    if (validatingTuple) {
      return validators[index2];
    }
    return validators;
  };
  return function arrayValidator(value) {
    var validationResult = validate(v$2.plainArray, value);
    if (validationResult) {
      return validationResult;
    }
    if (validatingTuple && value.length !== validators.length) {
      return "an array with " + validators.length + " items";
    }
    for (var i2 = 0; i2 < value.length; i2++) {
      validationResult = validate(getValidator(i2), value[i2]);
      if (validationResult) {
        return [i2].concat(validationResult);
      }
    }
  };
}
v$2.required = function required(validator2) {
  function requiredValidator(value) {
    if (value == null) {
      return function(options2) {
        return formatErrorMessage(
          options2,
          isArrayCulprit(options2.path) ? "cannot be undefined/null." : "is required."
        );
      };
    }
    return validator2.apply(this, arguments);
  }
  requiredValidator.__required = true;
  return requiredValidator;
};
v$2.oneOfType = function oneOfType() {
  var validators = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  return function oneOfTypeValidator(value) {
    var messages = validators.map(function(validator2) {
      return validate(validator2, value);
    }).filter(Boolean);
    if (messages.length !== validators.length) {
      return;
    }
    if (messages.every(function(message2) {
      return message2.length === 1 && typeof message2[0] === "string";
    })) {
      return orList(
        messages.map(function(m2) {
          return m2[0];
        })
      );
    }
    return messages.reduce(function(max3, arr) {
      return arr.length > max3.length ? arr : max3;
    });
  };
};
v$2.equal = function equal2(compareWith) {
  return function equalValidator(value) {
    if (value !== compareWith) {
      return JSON.stringify(compareWith);
    }
  };
};
v$2.oneOf = function oneOf() {
  var options2 = Array.isArray(arguments[0]) ? arguments[0] : Array.prototype.slice.call(arguments);
  var validators = options2.map(function(value) {
    return v$2.equal(value);
  });
  return v$2.oneOfType.apply(this, validators);
};
v$2.range = function range(compareWith) {
  var min4 = compareWith[0];
  var max3 = compareWith[1];
  return function rangeValidator(value) {
    var validationResult = validate(v$2.number, value);
    if (validationResult || value < min4 || value > max3) {
      return "number between " + min4 + " & " + max3 + " (inclusive)";
    }
  };
};
v$2.any = function any() {
  return;
};
v$2.boolean = function boolean(value) {
  if (typeof value !== "boolean") {
    return "boolean";
  }
};
v$2.number = function number(value) {
  if (typeof value !== "number") {
    return "number";
  }
};
v$2.plainArray = function plainArray(value) {
  if (!Array.isArray(value)) {
    return "array";
  }
};
v$2.plainObject = function plainObject(value) {
  if (!isPlainObject(value)) {
    return "object";
  }
};
v$2.string = function string2(value) {
  if (typeof value !== "string") {
    return "string";
  }
};
v$2.func = function func(value) {
  if (typeof value !== "function") {
    return "function";
  }
};
function validate(validator2, value) {
  if (value == null && !validator2.hasOwnProperty("__required")) {
    return;
  }
  var result = validator2(value);
  if (result) {
    return Array.isArray(result) ? result : [result];
  }
}
function processMessage(message2, options2) {
  var len2 = message2.length;
  var result = message2[len2 - 1];
  var path2 = message2.slice(0, len2 - 1);
  if (path2.length === 0) {
    path2 = [DEFAULT_ERROR_PATH];
  }
  options2 = xtend$2(options2, { path: path2 });
  return typeof result === "function" ? result(options2) : formatErrorMessage(options2, prettifyResult(result));
}
function orList(list2) {
  if (list2.length < 2) {
    return list2[0];
  }
  if (list2.length === 2) {
    return list2.join(" or ");
  }
  return list2.slice(0, -1).join(", ") + ", or " + list2.slice(-1);
}
function prettifyResult(result) {
  return "must be " + addArticle(result) + ".";
}
function addArticle(nounPhrase) {
  if (/^an? /.test(nounPhrase)) {
    return nounPhrase;
  }
  if (/^[aeiou]/i.test(nounPhrase)) {
    return "an " + nounPhrase;
  }
  if (/^[a-z]/i.test(nounPhrase)) {
    return "a " + nounPhrase;
  }
  return nounPhrase;
}
function formatErrorMessage(options2, prettyResult) {
  var arrayCulprit = isArrayCulprit(options2.path);
  var output2 = options2.path.join(".") + " " + prettyResult;
  var prepend = arrayCulprit ? "Item at position " : "";
  return prepend + output2;
}
function isArrayCulprit(path2) {
  return typeof path2[path2.length - 1] == "number" || typeof path2[0] == "number";
}
function objectEntries(obj) {
  return Object.keys(obj || {}).map(function(key) {
    return { key, value: obj[key] };
  });
}
v$2.validate = validate;
v$2.processMessage = processMessage;
var lib$1 = v$2;
var xtend$1 = immutable;
var v$1 = lib$1;
function file(value) {
  if (typeof window !== "undefined") {
    if (value instanceof commonjsGlobal$1.Blob || value instanceof commonjsGlobal$1.ArrayBuffer) {
      return;
    }
    return "Blob or ArrayBuffer";
  }
  if (typeof value === "string" || value.pipe !== void 0) {
    return;
  }
  return "Filename or Readable stream";
}
function assertShape(validatorObj, apiName) {
  return v$1.assert(v$1.strictShape(validatorObj), apiName);
}
function date(value) {
  var msg2 = "date";
  if (typeof value === "boolean") {
    return msg2;
  }
  try {
    var date2 = new Date(value);
    if (date2.getTime && isNaN(date2.getTime())) {
      return msg2;
    }
  } catch (e3) {
    return msg2;
  }
}
function coordinates(value) {
  return v$1.tuple(v$1.number, v$1.number)(value);
}
var validator = xtend$1(v$1, {
  file,
  date,
  coordinates,
  assertShape
});
function pick$1(source, keys4) {
  var filter17 = function(key, val) {
    return keys4.indexOf(key) !== -1 && val !== void 0;
  };
  if (typeof keys4 === "function") {
    filter17 = keys4;
  }
  return Object.keys(source).filter(function(key) {
    return filter17(key, source[key]);
  }).reduce(function(result, key) {
    result[key] = source[key];
    return result;
  }, {});
}
var pick_1 = pick$1;
function objectMap$1(obj, cb2) {
  return Object.keys(obj).reduce(function(result, key) {
    result[key] = cb2(key, obj[key]);
    return result;
  }, {});
}
var objectMap_1 = objectMap$1;
var objectMap = objectMap_1;
function stringifyBoolean(obj) {
  return objectMap(obj, function(_2, value) {
    return typeof value === "boolean" ? JSON.stringify(value) : value;
  });
}
var stringifyBooleans$1 = stringifyBoolean;
var MapiClient = mapiClient;
var createClient = browserClient;
function createServiceFactory$1(ServicePrototype) {
  return function(clientOrConfig) {
    var client2;
    if (MapiClient.prototype.isPrototypeOf(clientOrConfig)) {
      client2 = clientOrConfig;
    } else {
      client2 = createClient(clientOrConfig);
    }
    var service = Object.create(ServicePrototype);
    service.client = client2;
    return service;
  };
}
var createServiceFactory_1 = createServiceFactory$1;
var xtend = immutable;
var v = validator;
var pick = pick_1;
var stringifyBooleans = stringifyBooleans$1;
var createServiceFactory = createServiceFactory_1;
var Geocoding = {};
var featureTypes = [
  "country",
  "region",
  "postcode",
  "district",
  "place",
  "locality",
  "neighborhood",
  "address",
  "poi",
  "poi.landmark"
];
Geocoding.forwardGeocode = function(config2) {
  v.assertShape({
    query: v.required(v.string),
    mode: v.oneOf("mapbox.places", "mapbox.places-permanent"),
    countries: v.arrayOf(v.string),
    proximity: v.oneOf(v.coordinates, "ip"),
    types: v.arrayOf(v.oneOf(featureTypes)),
    autocomplete: v.boolean,
    bbox: v.arrayOf(v.number),
    limit: v.number,
    language: v.arrayOf(v.string),
    routing: v.boolean,
    fuzzyMatch: v.boolean,
    worldview: v.string
  })(config2);
  config2.mode = config2.mode || "mapbox.places";
  var query6 = stringifyBooleans(
    xtend(
      { country: config2.countries },
      pick(config2, [
        "proximity",
        "types",
        "autocomplete",
        "bbox",
        "limit",
        "language",
        "routing",
        "fuzzyMatch",
        "worldview"
      ])
    )
  );
  return this.client.createRequest({
    method: "GET",
    path: "/geocoding/v5/:mode/:query.json",
    params: pick(config2, ["mode", "query"]),
    query: query6
  });
};
Geocoding.reverseGeocode = function(config2) {
  v.assertShape({
    query: v.required(v.coordinates),
    mode: v.oneOf("mapbox.places", "mapbox.places-permanent"),
    countries: v.arrayOf(v.string),
    types: v.arrayOf(v.oneOf(featureTypes)),
    bbox: v.arrayOf(v.number),
    limit: v.number,
    language: v.arrayOf(v.string),
    reverseMode: v.oneOf("distance", "score"),
    routing: v.boolean,
    worldview: v.string
  })(config2);
  config2.mode = config2.mode || "mapbox.places";
  var query6 = stringifyBooleans(
    xtend(
      { country: config2.countries },
      pick(config2, [
        "country",
        "types",
        "bbox",
        "limit",
        "language",
        "reverseMode",
        "routing",
        "worldview"
      ])
    )
  );
  return this.client.createRequest({
    method: "GET",
    path: "/geocoding/v5/:mode/:query.json",
    params: pick(config2, ["mode", "query"]),
    query: query6
  });
};
var geocoding = createServiceFactory(Geocoding);
let urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let random = (bytes) => crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, defaultSize, getRandom) => {
  let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
  let step = -~(1.6 * mask * defaultSize / alphabet.length);
  return (size12 = defaultSize) => {
    let id = "";
    while (true) {
      let bytes = getRandom(step);
      let j2 = step;
      while (j2--) {
        id += alphabet[bytes[j2] & mask] || "";
        if (id.length === size12)
          return id;
      }
    }
  };
};
let customAlphabet = (alphabet, size12 = 21) => customRandom(alphabet, size12, random);
let nanoid$1 = (size12 = 21) => crypto.getRandomValues(new Uint8Array(size12)).reduce((id, byte) => {
  byte &= 63;
  if (byte < 36) {
    id += byte.toString(36);
  } else if (byte < 62) {
    id += (byte - 26).toString(36).toUpperCase();
  } else if (byte > 62) {
    id += "-";
  } else {
    id += "_";
  }
  return id;
}, "");
const index_browser = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  customAlphabet,
  customRandom,
  nanoid: nanoid$1,
  random,
  urlAlphabet
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(index_browser);
var nanoid = require$$0.nanoid;
function MapboxEventManager$1(options2) {
  this.origin = options2.origin || "https://api.mapbox.com";
  this.endpoint = "events/v2";
  this.access_token = options2.accessToken;
  this.version = "0.2.0";
  this.sessionID = this.generateSessionID();
  this.userAgent = this.getUserAgent();
  this.options = options2;
  this.send = this.send.bind(this);
  this.countries = options2.countries ? options2.countries.split(",") : null;
  this.types = options2.types ? options2.types.split(",") : null;
  this.bbox = options2.bbox ? options2.bbox : null;
  this.language = options2.language ? options2.language.split(",") : null;
  this.limit = options2.limit ? +options2.limit : null;
  this.locale = navigator.language || null;
  this.enableEventLogging = this.shouldEnableLogging(options2);
  this.eventQueue = new Array();
  this.flushInterval = options2.flushInterval || 1e3;
  this.maxQueueSize = options2.maxQueueSize || 100;
  this.timer = this.flushInterval ? setTimeout(this.flush.bind(this), this.flushInterval) : null;
  this.lastSentInput = "";
  this.lastSentIndex = 0;
}
MapboxEventManager$1.prototype = {
  /**
     * Send a search.select event to the mapbox events service
     * This event marks the array index of the item selected by the user out of the array of possible options
     * @private
     * @param {Object} selected the geojson feature selected by the user
     * @param {Object} geocoder a mapbox-gl-geocoder instance
     * @returns {Promise}
     */
  select: function(selected, geocoder) {
    var resultIndex = this.getSelectedIndex(selected, geocoder);
    var payload = this.getEventPayload("search.select", geocoder);
    payload.resultIndex = resultIndex;
    payload.resultPlaceName = selected.place_name;
    payload.resultId = selected.id;
    if (resultIndex === this.lastSentIndex && payload.queryString === this.lastSentInput || resultIndex == -1) {
      return;
    }
    this.lastSentIndex = resultIndex;
    this.lastSentInput = payload.queryString;
    if (!payload.queryString)
      return;
    return this.push(payload);
  },
  /**
     * Send a search-start event to the mapbox events service
     * This turnstile event marks when a user starts a new search
     * @private
     * @param {Object} geocoder a mapbox-gl-geocoder instance
     * @returns {Promise}
     */
  start: function(geocoder) {
    var payload = this.getEventPayload("search.start", geocoder);
    if (!payload.queryString)
      return;
    return this.push(payload);
  },
  /**
   * Send a search-keyevent event to the mapbox events service
   * This event records each keypress in sequence
   * @private
   * @param {Object} keyEvent the keydown event to log
   * @param {Object} geocoder a mapbox-gl-geocoder instance
   * 
   */
  keyevent: function(keyEvent, geocoder) {
    if (!keyEvent.key)
      return;
    if (keyEvent.metaKey || [9, 27, 37, 39, 13, 38, 40].indexOf(keyEvent.keyCode) !== -1)
      return;
    var payload = this.getEventPayload("search.keystroke", geocoder);
    payload.lastAction = keyEvent.key;
    if (!payload.queryString)
      return;
    return this.push(payload);
  },
  /**
   * Send an event to the events service
   *
   * The event is skipped if the instance is not enabled to send logging events
   *
   * @private
   * @param {Object} payload the http POST body of the event
   * @param {Function} [callback] a callback function to invoke when the send has completed
   * @returns {Promise}
   */
  send: function(payload, callback) {
    if (!this.enableEventLogging) {
      if (callback)
        return callback();
      return;
    }
    var options2 = this.getRequestOptions(payload);
    this.request(options2, function(err) {
      if (err)
        return this.handleError(err, callback);
      if (callback) {
        return callback();
      }
    }.bind(this));
  },
  /**
   * Get http request options
   * @private
   * @param {*} payload
   */
  getRequestOptions: function(payload) {
    if (!Array.isArray(payload))
      payload = [payload];
    var options2 = {
      // events must be sent with POST
      method: "POST",
      host: this.origin,
      path: this.endpoint + "?access_token=" + this.access_token,
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
      //events are arrays
    };
    return options2;
  },
  /**
   * Get the event payload to send to the events service
   * Most payload properties are shared across all events
   * @private
   * @param {String} event the name of the event to send to the events service. Valid options are 'search.start', 'search.select', 'search.feedback'.
   * @param {Object} geocoder a mapbox-gl-geocoder instance
   * @returns {Object} an event payload
   */
  getEventPayload: function(event, geocoder) {
    var proximity;
    if (!geocoder.options.proximity) {
      proximity = null;
    } else if (typeof geocoder.options.proximity === "object") {
      proximity = [geocoder.options.proximity.longitude, geocoder.options.proximity.latitude];
    } else if (geocoder.options.proximity === "ip") {
      proximity = [999, 999];
    } else {
      proximity = geocoder.options.proximity;
    }
    var zoom2 = geocoder._map ? geocoder._map.getZoom() : void 0;
    var payload = {
      event,
      created: +/* @__PURE__ */ new Date(),
      sessionIdentifier: this.sessionID,
      country: this.countries,
      userAgent: this.userAgent,
      language: this.language,
      bbox: this.bbox,
      types: this.types,
      endpoint: "mapbox.places",
      autocomplete: geocoder.options.autocomplete,
      fuzzyMatch: geocoder.options.fuzzyMatch,
      proximity,
      limit: geocoder.options.limit,
      routing: geocoder.options.routing,
      worldview: geocoder.options.worldview,
      mapZoom: zoom2,
      keyboardLocale: this.locale
    };
    if (event === "search.select") {
      payload.queryString = geocoder.inputString;
    } else if (event != "search.select" && geocoder._inputEl) {
      payload.queryString = geocoder._inputEl.value;
    } else {
      payload.queryString = geocoder.inputString;
    }
    return payload;
  },
  /**
   * Wraps the request function for easier testing
   * Make an http request and invoke a callback
   * @private
   * @param {Object} opts options describing the http request to be made
   * @param {Function} callback the callback to invoke when the http request is completed
   */
  request: function(opts, callback) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4) {
        if (this.status == 204) {
          return callback(null);
        } else {
          return callback(this.statusText);
        }
      }
    };
    xhttp.open(opts.method, opts.host + "/" + opts.path, true);
    for (var header in opts.headers) {
      var headerValue = opts.headers[header];
      xhttp.setRequestHeader(header, headerValue);
    }
    xhttp.send(opts.body);
  },
  /**
   * Handle an error that occurred while making a request
   * @param {Object} err an error instance to log
   * @private
   */
  handleError: function(err, callback) {
    if (callback)
      return callback(err);
  },
  /**
   * Generate a session ID to be returned with all of the searches made by this geocoder instance
   * ID is random and cannot be tracked across sessions
   * @private
   */
  generateSessionID: function() {
    return nanoid();
  },
  /**
   * Get a user agent string to send with the request to the events service
   * @private
   */
  getUserAgent: function() {
    return "mapbox-gl-geocoder." + this.version + "." + navigator.userAgent;
  },
  /**
     * Get the 0-based numeric index of the item that the user selected out of the list of options
     * @private
     * @param {Object} selected the geojson feature selected by the user
     * @param {Object} geocoder a Mapbox-GL-Geocoder instance
     * @returns {Number} the index of the selected result
     */
  getSelectedIndex: function(selected, geocoder) {
    if (!geocoder._typeahead)
      return;
    var results = geocoder._typeahead.data;
    var selectedID = selected.id;
    var resultIDs = results.map(function(feature2) {
      return feature2.id;
    });
    var selectedIdx = resultIDs.indexOf(selectedID);
    return selectedIdx;
  },
  /**
     * Check whether events should be logged
     * Clients using a localGeocoder or an origin other than mapbox should not have events logged
     * @private
     */
  shouldEnableLogging: function(options2) {
    if (options2.enableEventLogging === false)
      return false;
    if (options2.origin && options2.origin !== "https://api.mapbox.com")
      return false;
    if (options2.localGeocoder)
      return false;
    if (options2.filter)
      return false;
    return true;
  },
  /**
   * Flush out the event queue by sending events to the events service
   * @private
   */
  flush: function() {
    if (this.eventQueue.length > 0) {
      this.send(this.eventQueue);
      this.eventQueue = new Array();
    }
    if (this.timer)
      clearTimeout(this.timer);
    if (this.flushInterval)
      this.timer = setTimeout(this.flush.bind(this), this.flushInterval);
  },
  /**
   * Push event into the pending queue
   * @param {Object} evt the event to send to the events service
   * @param {Boolean} forceFlush indicates that the event queue should be flushed after adding this event regardless of size of the queue
   * @private
   */
  push: function(evt, forceFlush) {
    this.eventQueue.push(evt);
    if (this.eventQueue.length >= this.maxQueueSize || forceFlush) {
      this.flush();
    }
  },
  /**
   * Flush any remaining events from the queue before it is removed
   * @private
   */
  remove: function() {
    this.flush();
  }
};
var events = MapboxEventManager$1;
var placeholder = {
  // list drawn from https://docs.mapbox.com/api/search/#language-coverage
  "de": "Suche",
  // german
  "it": "Ricerca",
  //italian
  "en": "Search",
  // english
  "nl": "Zoeken",
  //dutch
  "fr": "Chercher",
  //french
  "ca": "Cerca",
  //catalan
  "he": "לחפש",
  //hebrew
  "ja": "サーチ",
  //japanese
  "lv": "Meklēt",
  //latvian
  "pt": "Procurar",
  //portuguese 
  "sr": "Претрага",
  //serbian
  "zh": "搜索",
  //chinese-simplified
  "cs": "Vyhledávání",
  //czech
  "hu": "Keresés",
  //hungarian
  "ka": "ძიება",
  // georgian
  "nb": "Søke",
  //norwegian
  "sk": "Vyhľadávanie",
  //slovak
  "th": "ค้นหา",
  //thai
  "fi": "Hae",
  //finnish
  "is": "Leita",
  //icelandic
  "ko": "수색",
  //korean
  "pl": "Szukaj",
  //polish
  "sl": "Iskanje",
  //slovenian
  "fa": "جستجو",
  //persian(aka farsi)
  "ru": "Поиск"
  //russian
};
var localization$1 = { placeholder };
var subtagExports = {};
var subtag$1 = {
  get exports() {
    return subtagExports;
  },
  set exports(v5) {
    subtagExports = v5;
  }
};
(function(module2) {
  !function(root2, name2, make) {
    if (module2.exports)
      module2.exports = make();
    else
      root2[name2] = make();
  }(commonjsGlobal$1, "subtag", function() {
    var empty2 = "";
    var pattern = /^([a-zA-Z]{2,3})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?/;
    function match2(tag2) {
      return tag2.match(pattern) || [];
    }
    function split2(tag2) {
      return match2(tag2).filter(function(v5, i2) {
        return v5 && i2;
      });
    }
    function api2(tag2) {
      tag2 = match2(tag2);
      return {
        language: tag2[1] || empty2,
        extlang: tag2[2] || empty2,
        script: tag2[3] || empty2,
        region: tag2[4] || empty2
      };
    }
    function expose(target, key, value) {
      Object.defineProperty(target, key, {
        value,
        enumerable: true
      });
    }
    function part(position, pattern2, type) {
      function method(tag2) {
        return match2(tag2)[position] || empty2;
      }
      expose(method, "pattern", pattern2);
      expose(api2, type, method);
    }
    part(1, /^[a-zA-Z]{2,3}$/, "language");
    part(2, /^[a-zA-Z]{3}$/, "extlang");
    part(3, /^[a-zA-Z]{4}$/, "script");
    part(4, /^[a-zA-Z]{2}$|^[0-9]{3}$/, "region");
    expose(api2, "split", split2);
    return api2;
  });
})(subtag$1);
function Geolocation$1() {
}
Geolocation$1.prototype = {
  isSupport: function() {
    return Boolean(window.navigator.geolocation);
  },
  getCurrentPosition: function() {
    const positionOptions = {
      enableHighAccuracy: true
    };
    return new Promise(function(resolve2, reject) {
      window.navigator.geolocation.getCurrentPosition(resolve2, reject, positionOptions);
    });
  }
};
var geolocation = Geolocation$1;
function transformFeatureToGeolocationText(feature2, accuracy) {
  const addrInfo = getAddressInfo(feature2);
  const addressAccuracy = ["address", "street", "place", "country"];
  var currentAccuracy;
  if (typeof accuracy === "function") {
    return accuracy(addrInfo);
  }
  const accuracyIndex = addressAccuracy.indexOf(accuracy);
  if (accuracyIndex === -1) {
    currentAccuracy = addressAccuracy;
  } else {
    currentAccuracy = addressAccuracy.slice(accuracyIndex);
  }
  return currentAccuracy.reduce(function(acc, name2) {
    if (!addrInfo[name2]) {
      return acc;
    }
    if (acc !== "") {
      acc = acc + ", ";
    }
    return acc + addrInfo[name2];
  }, "");
}
function getAddressInfo(feature2) {
  const houseNumber = feature2.address || "";
  const street = feature2.text || "";
  const placeName = feature2.place_name || "";
  const address = placeName.split(",")[0];
  const addrInfo = {
    address,
    houseNumber,
    street,
    placeName
  };
  feature2.context.forEach(function(context2) {
    const layer = context2.id.split(".")[0];
    addrInfo[layer] = context2.text;
  });
  return addrInfo;
}
const REVERSE_GEOCODE_COORD_RGX = /^[ ]*(-?\d{1,3}(\.\d{0,256})?)[, ]+(-?\d{1,3}(\.\d{0,256})?)[ ]*$/;
var utils$1 = {
  transformFeatureToGeolocationText,
  getAddressInfo,
  REVERSE_GEOCODE_COORD_RGX
};
var Typeahead = suggestions;
var debounce = lodash_debounce;
var extend$1 = immutable;
var EventEmitter = eventsExports.EventEmitter;
var exceptions = exceptions$1;
var MapboxClient = mapboxSdk;
var mbxGeocoder = geocoding;
var MapboxEventManager = events;
var localization = localization$1;
var subtag = subtagExports;
var Geolocation = geolocation;
var utils = utils$1;
const GEOCODE_REQUEST_TYPE = {
  FORWARD: 0,
  LOCAL: 1,
  REVERSE: 2
};
function getFooterNode() {
  var div = document.createElement("div");
  div.className = "mapboxgl-ctrl-geocoder--powered-by";
  div.innerHTML = '<a href="https://www.mapbox.com/search-service" target="_blank">Powered by Mapbox</a>';
  return div;
}
function MapboxGeocoder(options2) {
  this._eventEmitter = new EventEmitter();
  this.options = extend$1({}, this.options, options2);
  this.inputString = "";
  this.fresh = true;
  this.lastSelected = null;
  this.geolocation = new Geolocation();
}
MapboxGeocoder.prototype = {
  options: {
    zoom: 16,
    flyTo: true,
    trackProximity: true,
    minLength: 2,
    reverseGeocode: false,
    flipCoordinates: false,
    limit: 5,
    origin: "https://api.mapbox.com",
    enableEventLogging: true,
    marker: true,
    mapboxgl: null,
    collapsed: false,
    clearAndBlurOnEsc: false,
    clearOnBlur: false,
    enableGeolocation: false,
    addressAccuracy: "street",
    getItemValue: function(item) {
      return item.place_name;
    },
    render: function(item) {
      var placeName = item.place_name.split(",");
      return '<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title">' + placeName[0] + '</div><div class="mapboxgl-ctrl-geocoder--suggestion-address">' + placeName.splice(1, placeName.length).join(",") + "</div></div>";
    }
  },
  /**
   * Add the geocoder to a container. The container can be either a `mapboxgl.Map`, an `HTMLElement` or a CSS selector string.
   *
   * If the container is a [`mapboxgl.Map`](https://docs.mapbox.com/mapbox-gl-js/api/map/), this function will behave identically to [`Map.addControl(geocoder)`](https://docs.mapbox.com/mapbox-gl-js/api/map/#map#addcontrol).
   * If the container is an instance of [`HTMLElement`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement), then the geocoder will be appended as a child of that [`HTMLElement`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement).
   * If the container is a [CSS selector string](https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Selectors), the geocoder will be appended to the element returned from the query.
   *
   * This function will throw an error if the container is none of the above.
   * It will also throw an error if the referenced HTML element cannot be found in the `document.body`.
   *
   * For example, if the HTML body contains the element `<div id='geocoder-container'></div>`, the following script will append the geocoder to `#geocoder-container`:
   *
   * ```javascript
   * var geocoder = new MapboxGeocoder({ accessToken: mapboxgl.accessToken });
   * geocoder.addTo('#geocoder-container');
   * ```
   * @param {String|HTMLElement|mapboxgl.Map} container A reference to the container to which to add the geocoder
   */
  addTo: function(container) {
    function addToExistingContainer(geocoder, container2) {
      if (!document.body.contains(container2)) {
        throw new Error("Element provided to #addTo() exists, but is not in the DOM");
      }
      const el = geocoder.onAdd();
      container2.appendChild(el);
    }
    if (container._controlContainer) {
      container.addControl(this);
    } else if (container instanceof HTMLElement) {
      addToExistingContainer(this, container);
    } else if (typeof container == "string") {
      const parent = document.querySelectorAll(container);
      if (parent.length === 0) {
        throw new Error("Element ", container, "not found.");
      }
      if (parent.length > 1) {
        throw new Error("Geocoder can only be added to a single html element");
      }
      addToExistingContainer(this, parent[0]);
    } else {
      throw new Error("Error: addTo must be a mapbox-gl-js map, an html element, or a CSS selector query for a single html element");
    }
  },
  onAdd: function(map5) {
    if (map5 && typeof map5 != "string") {
      this._map = map5;
    }
    this.setLanguage();
    if (!this.options.localGeocoderOnly) {
      this.geocoderService = mbxGeocoder(
        MapboxClient({
          accessToken: this.options.accessToken,
          origin: this.options.origin
        })
      );
    }
    if (this.options.localGeocoderOnly && !this.options.localGeocoder) {
      throw new Error("A localGeocoder function must be specified to use localGeocoderOnly mode");
    }
    this.eventManager = new MapboxEventManager(this.options);
    this._onChange = this._onChange.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);
    this._onPaste = this._onPaste.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this._showButton = this._showButton.bind(this);
    this._hideButton = this._hideButton.bind(this);
    this._onQueryResult = this._onQueryResult.bind(this);
    this.clear = this.clear.bind(this);
    this._updateProximity = this._updateProximity.bind(this);
    this._collapse = this._collapse.bind(this);
    this._unCollapse = this._unCollapse.bind(this);
    this._clear = this._clear.bind(this);
    this._clearOnBlur = this._clearOnBlur.bind(this);
    this._geolocateUser = this._geolocateUser.bind(this);
    var el = this.container = document.createElement("div");
    el.className = "mapboxgl-ctrl-geocoder mapboxgl-ctrl";
    var searchIcon = this.createIcon("search", '<path d="M7.4 2.5c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c1 0 1.8-.2 2.5-.8l3.7 3.7c.2.2.4.3.8.3.7 0 1.1-.4 1.1-1.1 0-.3-.1-.5-.3-.8L11.4 10c.4-.8.8-1.6.8-2.5.1-2.8-2.1-5-4.8-5zm0 1.6c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.3-1.3-3.3-3.1 1.4-3.3 3.3-3.3z"/>');
    this._inputEl = document.createElement("input");
    this._inputEl.type = "text";
    this._inputEl.className = "mapboxgl-ctrl-geocoder--input";
    this.setPlaceholder();
    if (this.options.collapsed) {
      this._collapse();
      this.container.addEventListener("mouseenter", this._unCollapse);
      this.container.addEventListener("mouseleave", this._collapse);
      this._inputEl.addEventListener("focus", this._unCollapse);
    }
    if (this.options.collapsed || this.options.clearOnBlur) {
      this._inputEl.addEventListener("blur", this._onBlur);
    }
    this._inputEl.addEventListener("keydown", debounce(this._onKeyDown, 200));
    this._inputEl.addEventListener("paste", this._onPaste);
    this._inputEl.addEventListener("change", this._onChange);
    this.container.addEventListener("mouseenter", this._showButton);
    this.container.addEventListener("mouseleave", this._hideButton);
    this._inputEl.addEventListener("keyup", function(e3) {
      this.eventManager.keyevent(e3, this);
    }.bind(this));
    var actions = document.createElement("div");
    actions.classList.add("mapboxgl-ctrl-geocoder--pin-right");
    this._clearEl = document.createElement("button");
    this._clearEl.setAttribute("aria-label", "Clear");
    this._clearEl.addEventListener("click", this.clear);
    this._clearEl.className = "mapboxgl-ctrl-geocoder--button";
    var buttonIcon = this.createIcon("close", '<path d="M3.8 2.5c-.6 0-1.3.7-1.3 1.3 0 .3.2.7.5.8L7.2 9 3 13.2c-.3.3-.5.7-.5 1 0 .6.7 1.3 1.3 1.3.3 0 .7-.2 1-.5L9 10.8l4.2 4.2c.2.3.7.3 1 .3.6 0 1.3-.7 1.3-1.3 0-.3-.2-.7-.3-1l-4.4-4L15 4.6c.3-.2.5-.5.5-.8 0-.7-.7-1.3-1.3-1.3-.3 0-.7.2-1 .3L9 7.1 4.8 2.8c-.3-.1-.7-.3-1-.3z"/>');
    this._clearEl.appendChild(buttonIcon);
    this._loadingEl = this.createIcon("loading", '<path fill="#333" d="M4.4 4.4l.8.8c2.1-2.1 5.5-2.1 7.6 0l.8-.8c-2.5-2.5-6.7-2.5-9.2 0z"/><path opacity=".1" d="M12.8 12.9c-2.1 2.1-5.5 2.1-7.6 0-2.1-2.1-2.1-5.5 0-7.7l-.8-.8c-2.5 2.5-2.5 6.7 0 9.2s6.6 2.5 9.2 0 2.5-6.6 0-9.2l-.8.8c2.2 2.1 2.2 5.6 0 7.7z"/>');
    actions.appendChild(this._clearEl);
    actions.appendChild(this._loadingEl);
    el.appendChild(searchIcon);
    el.appendChild(this._inputEl);
    el.appendChild(actions);
    if (this.options.enableGeolocation && this.geolocation.isSupport()) {
      this._geolocateEl = document.createElement("button");
      this._geolocateEl.setAttribute("aria-label", "Geolocate");
      this._geolocateEl.addEventListener("click", this._geolocateUser);
      this._geolocateEl.className = "mapboxgl-ctrl-geocoder--button";
      var geolocateIcon = this.createIcon("geolocate", '<path d="M12.999 3.677L2.042 8.269c-.962.403-.747 1.823.29 1.912l5.032.431.431 5.033c.089 1.037 1.509 1.252 1.912.29l4.592-10.957c.345-.822-.477-1.644-1.299-1.299z" fill="#4264fb"/>');
      this._geolocateEl.appendChild(geolocateIcon);
      actions.appendChild(this._geolocateEl);
      this._showGeolocateButton();
    }
    var typeahead = this._typeahead = new Typeahead(this._inputEl, [], {
      filter: false,
      minLength: this.options.minLength,
      limit: this.options.limit
    });
    this.setRenderFunction(this.options.render);
    typeahead.getItemValue = this.options.getItemValue;
    var parentDraw = typeahead.list.draw;
    var footerNode = this._footerNode = getFooterNode();
    typeahead.list.draw = function() {
      parentDraw.call(this);
      footerNode.addEventListener("mousedown", function() {
        this.selectingListItem = true;
      }.bind(this));
      footerNode.addEventListener("mouseup", function() {
        this.selectingListItem = false;
      }.bind(this));
      this.element.appendChild(footerNode);
    };
    this.mapMarker = null;
    this._handleMarker = this._handleMarker.bind(this);
    if (this._map) {
      if (this.options.trackProximity) {
        this._updateProximity();
        this._map.on("moveend", this._updateProximity);
      }
      this._mapboxgl = this.options.mapboxgl;
      if (!this._mapboxgl && this.options.marker) {
        console.error("No mapboxgl detected in options. Map markers are disabled. Please set options.mapboxgl.");
        this.options.marker = false;
      }
    }
    return el;
  },
  _geolocateUser: function() {
    this._hideGeolocateButton();
    this._showLoadingIcon();
    this.geolocation.getCurrentPosition().then(function(geolocationPosition) {
      this._hideLoadingIcon();
      const geojson = {
        geometry: {
          type: "Point",
          coordinates: [geolocationPosition.coords.longitude, geolocationPosition.coords.latitude]
        }
      };
      this._handleMarker(geojson);
      this._fly(geojson);
      this._typeahead.clear();
      this._typeahead.selected = true;
      this.lastSelected = JSON.stringify(geojson);
      this._showClearButton();
      this.fresh = false;
      const config2 = {
        limit: 1,
        language: [this.options.language],
        query: geojson.geometry.coordinates,
        types: ["address"]
      };
      if (this.options.localGeocoderOnly) {
        const text = geojson.geometry.coordinates[0] + "," + geojson.geometry.coordinates[1];
        this._setInputValue(text);
        this._eventEmitter.emit("result", { result: geojson });
      } else {
        this.geocoderService.reverseGeocode(config2).send().then(function(resp) {
          const feature2 = resp.body.features[0];
          if (feature2) {
            const locationText = utils.transformFeatureToGeolocationText(feature2, this.options.addressAccuracy);
            this._setInputValue(locationText);
            feature2.user_coordinates = geojson.geometry.coordinates;
            this._eventEmitter.emit("result", { result: feature2 });
          } else {
            this._eventEmitter.emit("result", { result: { user_coordinates: geojson.geometry.coordinates } });
          }
        }.bind(this));
      }
    }.bind(this)).catch(function(error2) {
      if (error2.code === 1) {
        this._renderUserDeniedGeolocationError();
      } else {
        this._renderLocationError();
      }
      this._hideLoadingIcon();
      this._showGeolocateButton();
      this._hideAttribution();
    }.bind(this));
  },
  createIcon: function(name2, path2) {
    var icon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    icon.setAttribute("class", "mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-" + name2);
    icon.setAttribute("viewBox", "0 0 18 18");
    icon.setAttribute("xml:space", "preserve");
    icon.setAttribute("width", 18);
    icon.setAttribute("height", 18);
    icon.innerHTML = path2;
    return icon;
  },
  onRemove: function() {
    this.container.parentNode.removeChild(this.container);
    if (this.options.trackProximity && this._map) {
      this._map.off("moveend", this._updateProximity);
    }
    this._removeMarker();
    this._map = null;
    return this;
  },
  _setInputValue: function(value) {
    this._inputEl.value = value;
    setTimeout(function() {
      this._inputEl.focus();
      this._inputEl.scrollLeft = 0;
      this._inputEl.setSelectionRange(0, 0);
    }.bind(this), 1);
  },
  _onPaste: function(e3) {
    var value = (e3.clipboardData || window.clipboardData).getData("text");
    if (value.length >= this.options.minLength) {
      this._geocode(value);
    }
  },
  _onKeyDown: function(e3) {
    var ESC_KEY_CODE = 27, TAB_KEY_CODE = 9;
    if (e3.keyCode === ESC_KEY_CODE && this.options.clearAndBlurOnEsc) {
      this._clear(e3);
      return this._inputEl.blur();
    }
    var target = e3.target && e3.target.shadowRoot ? e3.target.shadowRoot.activeElement : e3.target;
    var value = target ? target.value : "";
    if (!value) {
      this.fresh = true;
      if (e3.keyCode !== TAB_KEY_CODE)
        this.clear(e3);
      this._showGeolocateButton();
      return this._hideClearButton();
    }
    this._hideGeolocateButton();
    if (e3.metaKey || [TAB_KEY_CODE, ESC_KEY_CODE, 37, 39, 13, 38, 40].indexOf(e3.keyCode) !== -1)
      return;
    if (target.value.length >= this.options.minLength) {
      this._geocode(target.value);
    }
  },
  _showButton: function() {
    if (this._typeahead.selected)
      this._showClearButton();
  },
  _hideButton: function() {
    if (this._typeahead.selected)
      this._hideClearButton();
  },
  _showClearButton: function() {
    this._clearEl.style.display = "block";
  },
  _hideClearButton: function() {
    this._clearEl.style.display = "none";
  },
  _showGeolocateButton: function() {
    if (this._geolocateEl && this.geolocation.isSupport()) {
      this._geolocateEl.style.display = "block";
    }
  },
  _hideGeolocateButton: function() {
    if (this._geolocateEl) {
      this._geolocateEl.style.display = "none";
    }
  },
  _showLoadingIcon: function() {
    this._loadingEl.style.display = "block";
  },
  _hideLoadingIcon: function() {
    this._loadingEl.style.display = "none";
  },
  _showAttribution: function() {
    this._footerNode.style.display = "block";
  },
  _hideAttribution: function() {
    this._footerNode.style.display = "none";
  },
  _onBlur: function(e3) {
    if (this.options.clearOnBlur) {
      this._clearOnBlur(e3);
    }
    if (this.options.collapsed) {
      this._collapse();
    }
  },
  _onChange: function() {
    var selected = this._typeahead.selected;
    if (selected && JSON.stringify(selected) !== this.lastSelected) {
      this._hideClearButton();
      if (this.options.flyTo) {
        this._fly(selected);
      }
      if (this.options.marker && this._mapboxgl) {
        this._handleMarker(selected);
      }
      this._inputEl.focus();
      this._inputEl.scrollLeft = 0;
      this._inputEl.setSelectionRange(0, 0);
      this.lastSelected = JSON.stringify(selected);
      this._eventEmitter.emit("result", { result: selected });
      this.eventManager.select(selected, this);
    }
  },
  _fly: function(selected) {
    var flyOptions;
    if (selected.properties && exceptions[selected.properties.short_code]) {
      flyOptions = extend$1({}, this.options.flyTo);
      if (this._map) {
        this._map.fitBounds(exceptions[selected.properties.short_code].bbox, flyOptions);
      }
    } else if (selected.bbox) {
      var bbox2 = selected.bbox;
      flyOptions = extend$1({}, this.options.flyTo);
      if (this._map) {
        this._map.fitBounds([[bbox2[0], bbox2[1]], [bbox2[2], bbox2[3]]], flyOptions);
      }
    } else {
      var defaultFlyOptions = {
        zoom: this.options.zoom
      };
      flyOptions = extend$1({}, defaultFlyOptions, this.options.flyTo);
      if (selected.center) {
        flyOptions.center = selected.center;
      } else if (selected.geometry && selected.geometry.type && selected.geometry.type === "Point" && selected.geometry.coordinates) {
        flyOptions.center = selected.geometry.coordinates;
      }
      if (this._map) {
        this._map.flyTo(flyOptions);
      }
    }
  },
  _requestType: function(options2, search) {
    var type;
    if (options2.localGeocoderOnly) {
      type = GEOCODE_REQUEST_TYPE.LOCAL;
    } else if (options2.reverseGeocode && utils.REVERSE_GEOCODE_COORD_RGX.test(search)) {
      type = GEOCODE_REQUEST_TYPE.REVERSE;
    } else {
      type = GEOCODE_REQUEST_TYPE.FORWARD;
    }
    return type;
  },
  _setupConfig: function(requestType, search) {
    const keys4 = [
      "bbox",
      "limit",
      "proximity",
      "countries",
      "types",
      "language",
      "reverseMode",
      "mode",
      "autocomplete",
      "fuzzyMatch",
      "routing",
      "worldview"
    ];
    const spacesOrCommaRgx = /[\s,]+/;
    var self2 = this;
    var config2 = keys4.reduce(function(config3, key) {
      if (self2.options[key] === void 0 || self2.options[key] === null) {
        return config3;
      }
      ["countries", "types", "language"].indexOf(key) > -1 ? config3[key] = self2.options[key].split(spacesOrCommaRgx) : config3[key] = self2.options[key];
      const isCoordKey = typeof self2.options[key].longitude === "number" && typeof self2.options[key].latitude === "number";
      if (key === "proximity" && isCoordKey) {
        const lng = self2.options[key].longitude;
        const lat = self2.options[key].latitude;
        config3[key] = [lng, lat];
      }
      return config3;
    }, {});
    switch (requestType) {
      case GEOCODE_REQUEST_TYPE.REVERSE:
        {
          var coords = search.split(spacesOrCommaRgx).map(function(c2) {
            return parseFloat(c2, 10);
          });
          if (!self2.options.flipCoordinates) {
            coords.reverse();
          }
          config2.types ? [config2.types[0]] : ["poi"];
          config2 = extend$1(config2, { query: coords, limit: 1 });
          ["proximity", "autocomplete", "fuzzyMatch", "bbox"].forEach(function(key) {
            if (key in config2) {
              delete config2[key];
            }
          });
        }
        break;
      case GEOCODE_REQUEST_TYPE.FORWARD:
        {
          const trimmedSearch = search.trim();
          const reverseGeocodeCoordRgx = /^(-?\d{1,3}(\.\d{0,256})?)[, ]+(-?\d{1,3}(\.\d{0,256})?)?$/;
          if (reverseGeocodeCoordRgx.test(trimmedSearch)) {
            search = search.replace(/,/g, " ");
          }
          config2 = extend$1(config2, { query: search });
        }
        break;
    }
    return config2;
  },
  _geocode: function(searchInput) {
    this.inputString = searchInput;
    this._showLoadingIcon();
    this._eventEmitter.emit("loading", { query: searchInput });
    const requestType = this._requestType(this.options, searchInput);
    const config2 = this._setupConfig(requestType, searchInput);
    var request;
    switch (requestType) {
      case GEOCODE_REQUEST_TYPE.LOCAL:
        request = Promise.resolve();
        break;
      case GEOCODE_REQUEST_TYPE.FORWARD:
        request = this.geocoderService.forwardGeocode(config2).send();
        break;
      case GEOCODE_REQUEST_TYPE.REVERSE:
        request = this.geocoderService.reverseGeocode(config2).send();
        break;
    }
    var localGeocoderRes = this.options.localGeocoder ? this.options.localGeocoder(searchInput) || [] : [];
    var externalGeocoderRes = [];
    var geocoderError = null;
    request.catch(function(error2) {
      geocoderError = error2;
    }.bind(this)).then(
      function(response) {
        this._hideLoadingIcon();
        var res = {};
        if (!response) {
          res = {
            type: "FeatureCollection",
            features: []
          };
        } else if (response.statusCode == "200") {
          res = response.body;
          res.request = response.request;
          res.headers = response.headers;
        }
        res.config = config2;
        if (this.fresh) {
          this.eventManager.start(this);
          this.fresh = false;
        }
        res.features = res.features ? localGeocoderRes.concat(res.features) : localGeocoderRes;
        if (this.options.externalGeocoder) {
          externalGeocoderRes = this.options.externalGeocoder(searchInput, res.features) || Promise.resolve([]);
          return externalGeocoderRes.then(function(features) {
            res.features = res.features ? features.concat(res.features) : features;
            return res;
          }, function() {
            return res;
          });
        }
        return res;
      }.bind(this)
    ).then(
      function(res) {
        if (geocoderError) {
          throw geocoderError;
        }
        if (this.options.filter && res.features.length) {
          res.features = res.features.filter(this.options.filter);
        }
        if (res.features.length) {
          this._showClearButton();
          this._hideGeolocateButton();
          this._showAttribution();
          this._eventEmitter.emit("results", res);
          this._typeahead.update(res.features);
        } else {
          this._hideClearButton();
          this._hideAttribution();
          this._typeahead.selected = null;
          this._renderNoResults();
          this._eventEmitter.emit("results", res);
        }
      }.bind(this)
    ).catch(
      function(err) {
        this._hideLoadingIcon();
        this._hideAttribution();
        if (localGeocoderRes.length && this.options.localGeocoder || externalGeocoderRes.length && this.options.externalGeocoder) {
          this._showClearButton();
          this._hideGeolocateButton();
          this._typeahead.update(localGeocoderRes);
        } else {
          this._hideClearButton();
          this._typeahead.selected = null;
          this._renderError();
        }
        this._eventEmitter.emit("results", { features: localGeocoderRes });
        this._eventEmitter.emit("error", { error: err });
      }.bind(this)
    );
    return request;
  },
  /**
   * Shared logic for clearing input
   * @param {Event} [ev] the event that triggered the clear, if available
   * @private
   *
   */
  _clear: function(ev) {
    if (ev)
      ev.preventDefault();
    this._inputEl.value = "";
    this._typeahead.selected = null;
    this._typeahead.clear();
    this._onChange();
    this._hideClearButton();
    this._showGeolocateButton();
    this._removeMarker();
    this.lastSelected = null;
    this._eventEmitter.emit("clear");
    this.fresh = true;
  },
  /**
   * Clear and then focus the input.
   * @param {Event} [ev] the event that triggered the clear, if available
   *
   */
  clear: function(ev) {
    this._clear(ev);
    this._inputEl.focus();
  },
  /**
   * Clear the input, without refocusing it. Used to implement clearOnBlur
   * constructor option.
   * @param {Event} [ev] the blur event
   * @private
   */
  _clearOnBlur: function(ev) {
    var ctx2 = this;
    if (ev.relatedTarget) {
      ctx2._clear(ev);
    }
  },
  _onQueryResult: function(response) {
    var results = response.body;
    if (!results.features.length)
      return;
    var result = results.features[0];
    this._typeahead.selected = result;
    this._inputEl.value = result.place_name;
    this._onChange();
  },
  _updateProximity: function() {
    if (!this._map || !this.options.trackProximity) {
      return;
    }
    if (this._map.getZoom() > 9) {
      var center2 = this._map.getCenter().wrap();
      this.setProximity({ longitude: center2.lng, latitude: center2.lat }, false);
    } else {
      this.setProximity(null, false);
    }
  },
  _collapse: function() {
    if (!this._inputEl.value && this._inputEl !== document.activeElement)
      this.container.classList.add("mapboxgl-ctrl-geocoder--collapsed");
  },
  _unCollapse: function() {
    this.container.classList.remove("mapboxgl-ctrl-geocoder--collapsed");
  },
  /**
   * Set & query the input
   * @param {string} searchInput location name or other search input
   * @returns {MapboxGeocoder} this
   */
  query: function(searchInput) {
    this._geocode(searchInput).then(this._onQueryResult);
    return this;
  },
  _renderError: function() {
    var errorMessage = "<div class='mapbox-gl-geocoder--error'>There was an error reaching the server</div>";
    this._renderMessage(errorMessage);
  },
  _renderLocationError: function() {
    var errorMessage = "<div class='mapbox-gl-geocoder--error'>A location error has occurred</div>";
    this._renderMessage(errorMessage);
  },
  _renderNoResults: function() {
    var errorMessage = "<div class='mapbox-gl-geocoder--error mapbox-gl-geocoder--no-results'>No results found</div>";
    this._renderMessage(errorMessage);
  },
  _renderUserDeniedGeolocationError: function() {
    var errorMessage = "<div class='mapbox-gl-geocoder--error'>Geolocation permission denied</div>";
    this._renderMessage(errorMessage);
  },
  _renderMessage: function(msg2) {
    this._typeahead.update([]);
    this._typeahead.selected = null;
    this._typeahead.clear();
    this._typeahead.renderError(msg2);
  },
  /**
   * Get the text to use as the search bar placeholder
   *
   * If placeholder is provided in options, then use options.placeholder
   * Otherwise, if language is provided in options, then use the localized string of the first language if available
   * Otherwise use the default
   *
   * @returns {String} the value to use as the search bar placeholder
   * @private
   */
  _getPlaceholderText: function() {
    if (this.options.placeholder)
      return this.options.placeholder;
    if (this.options.language) {
      var firstLanguage = this.options.language.split(",")[0];
      var language = subtag.language(firstLanguage);
      var localizedValue = localization.placeholder[language];
      if (localizedValue)
        return localizedValue;
    }
    return "Search";
  },
  /**
   * Set input
   * @param {string} searchInput location name or other search input
   * @returns {MapboxGeocoder} this
   */
  setInput: function(searchInput) {
    this._inputEl.value = searchInput;
    this._typeahead.selected = null;
    this._typeahead.clear();
    if (searchInput.length >= this.options.minLength) {
      this._geocode(searchInput);
    }
    return this;
  },
  /**
   * Set proximity
   * @param {Object|'ip'} proximity The new `options.proximity` value. This is a geographical point given as an object with `latitude` and `longitude` properties or the string 'ip'.
   * @param {Boolean} disableTrackProximity If true, sets `trackProximity` to false. True by default to prevent `trackProximity` from unintentionally overriding an explicitly set proximity value.
   * @returns {MapboxGeocoder} this
   */
  setProximity: function(proximity, disableTrackProximity = true) {
    this.options.proximity = proximity;
    if (disableTrackProximity) {
      this.options.trackProximity = false;
    }
    return this;
  },
  /**
   * Get proximity
   * @returns {Object} The geocoder proximity
   */
  getProximity: function() {
    return this.options.proximity;
  },
  /**
   * Set the render function used in the results dropdown
   * @param {Function} fn The function to use as a render function. This function accepts a single [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) object as input and returns a string.
   * @returns {MapboxGeocoder} this
   */
  setRenderFunction: function(fn2) {
    if (fn2 && typeof fn2 == "function") {
      this._typeahead.render = fn2;
    }
    return this;
  },
  /**
   * Get the function used to render the results dropdown
   *
   * @returns {Function} the render function
   */
  getRenderFunction: function() {
    return this._typeahead.render;
  },
  /**
   * Get the language to use in UI elements and when making search requests
   *
   * Look first at the explicitly set options otherwise use the browser's language settings
   * @param {String} language Specify the language to use for response text and query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas.
   * @returns {MapboxGeocoder} this
   */
  setLanguage: function(language) {
    var browserLocale = navigator.language || navigator.userLanguage || navigator.browserLanguage;
    this.options.language = language || this.options.language || browserLocale;
    return this;
  },
  /**
   * Get the language to use in UI elements and when making search requests
   * @returns {String} The language(s) used by the plugin, if any
   */
  getLanguage: function() {
    return this.options.language;
  },
  /**
   * Get the zoom level the map will move to when there is no bounding box on the selected result
   * @returns {Number} the map zoom
   */
  getZoom: function() {
    return this.options.zoom;
  },
  /**
   * Set the zoom level
   * @param {Number} zoom The zoom level that the map should animate to when a `bbox` isn't found in the response. If a `bbox` is found the map will fit to the `bbox`.
   * @returns {MapboxGeocoder} this
   */
  setZoom: function(zoom2) {
    this.options.zoom = zoom2;
    return this;
  },
  /**
   * Get the parameters used to fly to the selected response, if any
   * @returns {Boolean|Object} The `flyTo` option
   */
  getFlyTo: function() {
    return this.options.flyTo;
  },
  /**
   * Set the flyTo options
   * @param {Boolean|Object} flyTo If false, animating the map to a selected result is disabled. If true, animating the map will use the default animation parameters. If an object, it will be passed as `options` to the map [`flyTo`](https://docs.mapbox.com/mapbox-gl-js/api/#map#flyto) or [`fitBounds`](https://docs.mapbox.com/mapbox-gl-js/api/#map#fitbounds) method providing control over the animation of the transition.
   */
  setFlyTo: function(flyTo) {
    this.options.flyTo = flyTo;
    return this;
  },
  /**
   * Get the value of the placeholder string
   * @returns {String} The input element's placeholder value
   */
  getPlaceholder: function() {
    return this.options.placeholder;
  },
  /**
   * Set the value of the input element's placeholder
   * @param {String} placeholder the text to use as the input element's placeholder
   * @returns {MapboxGeocoder} this
   */
  setPlaceholder: function(placeholder2) {
    this.placeholder = placeholder2 ? placeholder2 : this._getPlaceholderText();
    this._inputEl.placeholder = this.placeholder;
    this._inputEl.setAttribute("aria-label", this.placeholder);
    return this;
  },
  /**
   * Get the bounding box used by the plugin
   * @returns {Array<Number>} the bounding box, if any
   */
  getBbox: function() {
    return this.options.bbox;
  },
  /**
   * Set the bounding box to limit search results to
   * @param {Array<Number>} bbox a bounding box given as an array in the format [minX, minY, maxX, maxY].
   * @returns {MapboxGeocoder} this
   */
  setBbox: function(bbox2) {
    this.options.bbox = bbox2;
    return this;
  },
  /**
   * Get a list of the countries to limit search results to
   * @returns {String} a comma separated list of countries to limit to, if any
   */
  getCountries: function() {
    return this.options.countries;
  },
  /**
   * Set the countries to limit search results to
   * @param {String} countries a comma separated list of countries to limit to
   * @returns {MapboxGeocoder} this
   */
  setCountries: function(countries) {
    this.options.countries = countries;
    return this;
  },
  /**
   * Get a list of the types to limit search results to
   * @returns {String} a comma separated list of types to limit to
   */
  getTypes: function() {
    return this.options.types;
  },
  /**
   * Set the types to limit search results to
   * @param {String} countries a comma separated list of types to limit to
   * @returns {MapboxGeocoder} this
   */
  setTypes: function(types2) {
    this.options.types = types2;
    return this;
  },
  /**
   * Get the minimum number of characters typed to trigger results used in the plugin
   * @returns {Number} The minimum length in characters before a search is triggered
   */
  getMinLength: function() {
    return this.options.minLength;
  },
  /**
   * Set the minimum number of characters typed to trigger results used by the plugin
   * @param {Number} minLength the minimum length in characters
   * @returns {MapboxGeocoder} this
   */
  setMinLength: function(minLength) {
    this.options.minLength = minLength;
    if (this._typeahead)
      this._typeahead.options.minLength = minLength;
    return this;
  },
  /**
   * Get the limit value for the number of results to display used by the plugin
   * @returns {Number} The limit value for the number of results to display used by the plugin
   */
  getLimit: function() {
    return this.options.limit;
  },
  /**
   * Set the limit value for the number of results to display used by the plugin
   * @param {Number} limit the number of search results to return
   * @returns {MapboxGeocoder}
   */
  setLimit: function(limit) {
    this.options.limit = limit;
    if (this._typeahead)
      this._typeahead.options.limit = limit;
    return this;
  },
  /**
   * Get the filter function used by the plugin
   * @returns {Function} the filter function
   */
  getFilter: function() {
    return this.options.filter;
  },
  /**
   * Set the filter function used by the plugin.
   * @param {Function} filter A function which accepts a Feature in the [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) format to filter out results from the Geocoding API response before they are included in the suggestions list. Return `true` to keep the item, `false` otherwise.
   * @returns {MapboxGeocoder} this
   */
  setFilter: function(filter17) {
    this.options.filter = filter17;
    return this;
  },
  /**
   * Set the geocoding endpoint used by the plugin.
   * @param {Function} origin A function which accepts an HTTPS URL to specify the endpoint to query results from.
   * @returns {MapboxGeocoder} this
   */
  setOrigin: function(origin) {
    this.options.origin = origin;
    this.geocoderService = mbxGeocoder(
      MapboxClient({
        accessToken: this.options.accessToken,
        origin: this.options.origin
      })
    );
    return this;
  },
  /**
   * Get the geocoding endpoint the plugin is currently set to
   * @returns {Function} the endpoint URL
   */
  getOrigin: function() {
    return this.options.origin;
  },
  /**
   * Set the accessToken option used for the geocoding request endpoint.
   * @param {String} accessToken value
   * @returns {MapboxGeocoder} this
   */
  setAccessToken: function(accessToken) {
    this.options.accessToken = accessToken;
    this.geocoderService = mbxGeocoder(
      MapboxClient({
        accessToken: this.options.accessToken,
        origin: this.options.origin
      })
    );
    return this;
  },
  /**
   * Set the autocomplete option used for geocoding requests
   * @param {Boolean} value The boolean value to set autocomplete to
   * @returns
   */
  setAutocomplete: function(value) {
    this.options.autocomplete = value;
    return this;
  },
  /**
   * Get the current autocomplete parameter value used for requests
   * @returns {Boolean} The autocomplete parameter value
   */
  getAutocomplete: function() {
    return this.options.autocomplete;
  },
  /**
   * Set the fuzzyMatch option used for approximate matching in geocoding requests
   * @param {Boolean} value The boolean value to set fuzzyMatch to
   * @returns
   */
  setFuzzyMatch: function(value) {
    this.options.fuzzyMatch = value;
    return this;
  },
  /**
   * Get the current fuzzyMatch parameter value used for requests
   * @returns {Boolean} The fuzzyMatch parameter value
   */
  getFuzzyMatch: function() {
    return this.options.fuzzyMatch;
  },
  /**
   * Set the routing parameter used to ask for routable point metadata in geocoding requests
   * @param {Boolean} value The boolean value to set routing to
   * @returns
   */
  setRouting: function(value) {
    this.options.routing = value;
    return this;
  },
  /**
   * Get the current routing parameter value used for requests
   * @returns {Boolean} The routing parameter value
   */
  getRouting: function() {
    return this.options.routing;
  },
  /**
   * Set the worldview parameter
   * @param {String} code The country code representing the worldview (e.g. "us" | "cn" | "jp", "in")
   * @returns
   */
  setWorldview: function(code) {
    this.options.worldview = code;
    return this;
  },
  /**
   * Get the current worldview parameter value used for requests
   * @returns {String} The worldview parameter value
   */
  getWorldview: function() {
    return this.options.worldview;
  },
  /**
   * Handle the placement of a result marking the selected result
   * @private
   * @param {Object} selected the selected geojson feature
   * @returns {MapboxGeocoder} this
   */
  _handleMarker: function(selected) {
    if (!this._map) {
      return;
    }
    this._removeMarker();
    var defaultMarkerOptions = {
      color: "#4668F2"
    };
    var markerOptions = extend$1({}, defaultMarkerOptions, this.options.marker);
    this.mapMarker = new this._mapboxgl.Marker(markerOptions);
    if (selected.center) {
      this.mapMarker.setLngLat(selected.center).addTo(this._map);
    } else if (selected.geometry && selected.geometry.type && selected.geometry.type === "Point" && selected.geometry.coordinates) {
      this.mapMarker.setLngLat(selected.geometry.coordinates).addTo(this._map);
    }
    return this;
  },
  /**
   * Handle the removal of a result marker
   * @private
   */
  _removeMarker: function() {
    if (this.mapMarker) {
      this.mapMarker.remove();
      this.mapMarker = null;
    }
  },
  /**
   * Subscribe to events that happen within the plugin.
   * @param {String} type name of event. Available events and the data passed into their respective event objects are:
   *
   * - __clear__ `Emitted when the input is cleared`
   * - __loading__ `{ query } Emitted when the geocoder is looking up a query`
   * - __results__ `{ results } Fired when the geocoder returns a response`
   * - __result__ `{ result } Fired when input is set`
   * - __error__ `{ error } Error as string`
   * @param {Function} fn function that's called when the event is emitted.
   * @returns {MapboxGeocoder} this;
   */
  on: function(type, fn2) {
    this._eventEmitter.on(type, fn2);
    return this;
  },
  /**
   * Remove an event
   * @returns {MapboxGeocoder} this
   * @param {String} type Event name.
   * @param {Function} fn Function that should unsubscribe to the event emitted.
   */
  off: function(type, fn2) {
    this._eventEmitter.removeListener(type, fn2);
    this.eventManager.remove();
    return this;
  }
};
var lib = MapboxGeocoder;
const mapboxGlGeocoder = "";
const geocoderControl_module = {};
const zoomLevels = {
  venue: {
    zoom: 16
  },
  building: {
    zoom: 18
  },
  level: {
    zoom: 18
  }
};
function GeocoderControl(props) {
  const {
    enableMarker,
    position,
    id,
    onChange,
    onSelect,
    ...restProps
  } = props;
  const [marker2, setMarker] = React__default.useState(null);
  const {
    map: map5
  } = useMapbox();
  const accessToken = useEnvStore((state) => state.env.mapboxToken);
  const geocoderRef = React__default.useRef(null);
  const element = React__default.useMemo(() => position === "header" ? document.getElementById(id) : null, [id, position]);
  const onLoading = React__default.useCallback(() => {
  }, []);
  const onResults = React__default.useCallback(() => {
  }, []);
  const onResult = React__default.useCallback((event) => {
    var _a3, _b3;
    const {
      result
    } = event || {};
    const {
      center: center2,
      geometry: geometry2
    } = result || {};
    if ((geometry2 == null ? void 0 : geometry2.type) === "Polygon") {
      const bounds = bbox$3(result);
      map5.fitBounds(bounds, {
        duration: 0
      });
    } else {
      const zoom2 = (_b3 = zoomLevels[(_a3 = result == null ? void 0 : result.properties) == null ? void 0 : _a3.category]) == null ? void 0 : _b3.zoom;
      if (zoom2 && map5) {
        map5.flyTo({
          zoom: zoom2,
          duration: 0
        });
      }
    }
    const location2 = center2 || (geometry2 == null ? void 0 : geometry2.type) === "Point" && (geometry2 == null ? void 0 : geometry2.coordinates);
    if (location2 && enableMarker) {
      setMarker(/* @__PURE__ */ jsx(Marker$1, { longitude: location2[0], latitude: location2[1] }));
      onChange(location2);
    } else {
      setMarker(null);
    }
    if (result) {
      onSelect(result);
    }
  }, [enableMarker, map5, onChange, onSelect]);
  const onError = React__default.useCallback(() => {
  }, []);
  const onClear = React__default.useCallback(() => {
    setMarker(null);
  }, []);
  const geocoder = React__default.useMemo(() => new lib({
    ...restProps,
    marker: false,
    // we have custom marker
    accessToken,
    flyTo: {
      duration: 0
    }
  }), [restProps, accessToken]);
  React__default.useLayoutEffect(() => {
    if (map5 && geocoder && position !== "header") {
      if (!map5.hasControl(geocoder)) {
        map5.addControl(geocoder, position);
      }
      return () => {
        if (map5 == null ? void 0 : map5.hasControl(geocoder)) {
          map5.removeControl(geocoder);
        }
      };
    }
    return () => {
    };
  }, [geocoder, map5, position]);
  const addGeocoder = React__default.useCallback(() => {
    if (geocoderRef.current || !element || !geocoder)
      return;
    geocoderRef.current = geocoder.onAdd(map5);
    element.appendChild(geocoderRef.current);
  }, [element, geocoder, map5]);
  React__default.useLayoutEffect(() => {
    if (position !== "header" || !element)
      return () => {
      };
    if (map5)
      addGeocoder();
    return () => {
      if (!map5 || !geocoderRef.current || !element)
        return;
      element.removeChild(geocoderRef.current);
      geocoderRef.current = null;
    };
  }, [addGeocoder, element, map5, position]);
  React__default.useEffect(() => {
    if (geocoder) {
      geocoder.on("loading", onLoading);
      geocoder.on("results", onResults);
      geocoder.on("result", onResult);
      geocoder.on("error", onError);
      geocoder.on("clear", onClear);
      return () => {
        try {
          geocoder.off("loading", onLoading);
          geocoder.off("results", onResults);
          geocoder.off("result", onResult);
          geocoder.off("error", onError);
          geocoder.off("clear", onClear);
        } catch (error2) {
          console.error(error2);
        }
      };
    }
    return () => {
    };
  }, [geocoder, onClear, onError, onLoading, onResult, onResults]);
  return marker2;
}
GeocoderControl.propTypes = {
  enableMarker: propTypesExports$1.bool,
  position: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right", "header"]),
  id: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  onSelect: propTypesExports$1.func
};
GeocoderControl.defaultProps = {
  enableMarker: true,
  position: "top-left",
  id: "",
  onChange: () => {
  },
  onSelect: () => {
  }
};
const snapSvgUrl = IconUtil.getDotSvgUrl();
function ImageSnapControls(props) {
  const {
    sourceId,
    onClick: onClick2,
    onChange,
    active: activate,
    onStart
  } = props;
  const {
    map: map5
  } = useMapbox();
  const hasValidSource = React__default.useMemo(() => {
    if (!map5)
      return false;
    return !!map5.getSource(sourceId);
  }, [map5, sourceId]);
  const imageSnapEnabledRef = React__default.useRef(activate);
  const snapPoints = React__default.useRef([]);
  const snapPointMarkers = React__default.useRef([]);
  React__default.useLayoutEffect(() => {
    imageSnapEnabledRef.current = !!activate;
  }, [activate]);
  const removeSnapPoints = React__default.useCallback(() => {
    var _a3;
    if (((_a3 = snapPoints.current) == null ? void 0 : _a3.length) > 0) {
      const count3 = snapPoints.current.length;
      for (let i2 = 0; i2 < count3; i2 += 1) {
        snapPoints.current.pop();
        snapPointMarkers.current.pop().remove();
      }
    }
  }, []);
  const onDone = React__default.useCallback((coords) => {
    removeSnapPoints();
    onChange(coords);
  }, [onChange, onClick2, removeSnapPoints]);
  const addSnapPoints = React__default.useCallback((downEvent) => {
    var _a3, _b3, _c2, _d2;
    if (((_a3 = snapPoints.current) == null ? void 0 : _a3.length) < 4) {
      onStart();
      snapPoints.current.push(downEvent.lngLat);
      const el = document.createElement("div");
      el.className = "marker";
      el.style.backgroundImage = `url('${snapSvgUrl}')`;
      el.style.width = "10px";
      el.style.height = "10px";
      el.style.backgroundSize = "100%";
      snapPointMarkers.current.push(new mapboxgl__default.Marker(el).setLngLat(downEvent.lngLat).addTo(map5));
      if (((_b3 = snapPoints.current) == null ? void 0 : _b3.length) === 4) {
        const source = map5 == null ? void 0 : map5.getSource(sourceId);
        if (!source)
          return;
        const initialCoords = (_c2 = source.coordinates) == null ? void 0 : _c2.map((xyz) => CoordinateUtil.toArray(CoordinateUtil.toMercator(xyz)));
        const p2 = (_d2 = snapPoints.current) == null ? void 0 : _d2.map((xyz) => CoordinateUtil.toArray(CoordinateUtil.toMercator(xyz)));
        const fromVec = [p2[1][0] - p2[0][0], p2[1][1] - p2[0][1]];
        const toVec = [p2[3][0] - p2[2][0], p2[3][1] - p2[2][1]];
        const magFromVec = (fromVec[0] ** 2 + fromVec[1] ** 2) ** 0.5;
        const magToVec = (toVec[0] ** 2 + toVec[1] ** 2) ** 0.5;
        const scaleFactor = magToVec / magFromVec;
        const scaledCoords = initialCoords.map((v5) => [v5[0] * scaleFactor, v5[1] * scaleFactor]);
        let angleR = Math.acos((fromVec[0] * toVec[0] + fromVec[1] * toVec[1]) / (magFromVec * magToVec));
        const cross2 = fromVec[0] * toVec[1] - fromVec[1] * toVec[0];
        angleR = cross2 >= 0 ? angleR : 2 * Math.PI - angleR;
        const scaledP0 = [p2[0][0] * scaleFactor, p2[0][1] * scaleFactor];
        const localCoords = scaledCoords.map((v5) => [v5[0] - scaledP0[0], v5[1] - scaledP0[1]]);
        const localRotatedCoords = localCoords.map((v5) => [v5[0] * Math.cos(angleR) - v5[1] * Math.sin(angleR), v5[0] * Math.sin(angleR) + v5[1] * Math.cos(angleR)]);
        const translatedCoords = localRotatedCoords.map((v5) => [v5[0] + p2[2][0], v5[1] + p2[2][1]]);
        const finalCoords = translatedCoords.map((xyz) => {
          const v5 = CoordinateUtil.toArray(CoordinateUtil.toLngLat(xyz));
          return [v5[0], v5[1]];
        });
        source.setCoordinates(finalCoords);
        onDone(finalCoords);
      }
    }
  }, [map5, onDone, onStart, sourceId]);
  React__default.useEffect(() => {
    if (!hasValidSource) {
      return null;
    }
    map5.on("click", addSnapPoints);
    map5.on("contextmenu", removeSnapPoints);
    map5.getCanvas().style.cursor = "crosshair";
    return () => {
      if (map5) {
        map5.off("click", addSnapPoints);
        map5.off("contextmenu", removeSnapPoints);
        map5.getCanvas().style.cursor = "";
      }
    };
  }, [addSnapPoints, hasValidSource, map5, removeSnapPoints]);
  React__default.useEffect(() => {
    if (activate) {
      return () => onClick2 == null ? void 0 : onClick2();
    }
    return () => {
      removeSnapPoints();
    };
  }, [activate, onClick2, removeSnapPoints]);
  const buttonData = React__default.useMemo(() => [{
    className: cssstyles["mapboxgl-ctrl-image-snap"],
    tooltip: "Snap image",
    onClick: onClick2
  }], [onClick2]);
  if (!hasValidSource || !onClick2)
    return null;
  return /* @__PURE__ */ jsx(MapButtonControl, { map: map5, buttons: buttonData, anchor: "top-right" }, "imageSnapControls");
}
ImageSnapControls.propTypes = {
  sourceId: propTypesExports$1.string.isRequired,
  onClick: propTypesExports$1.func,
  active: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  onStart: propTypesExports$1.func
};
ImageSnapControls.defaultProps = {
  onClick: null,
  // means no button control required
  active: false,
  onChange: () => {
  },
  onStart: () => {
  }
};
function OpenFileControls(props) {
  const {
    handler
  } = props;
  const {
    map: map5
  } = useMapbox();
  const inputFile = useRef(null);
  const handleFileUpload = (e3) => {
    const {
      files: files2
    } = e3.target;
    if (files2 && files2.length) {
      const url2 = URL.createObjectURL(files2[0]);
      handler(url2);
    }
  };
  const onClick2 = React__default.useCallback(() => {
    inputFile.current.click();
  }, []);
  const buttonData = React__default.useMemo(() => [{
    className: cssstyles["mapboxgl-ctrl-upload-image"],
    tooltip: "Open File",
    onClick: onClick2
  }], [onClick2]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("input", { style: {
      display: "none"
    }, ref: inputFile, onChange: handleFileUpload, type: "file" }),
    /* @__PURE__ */ jsx(MapButtonControl, { map: map5, buttons: buttonData, anchor: "top-right" }, "openFileControls")
  ] });
}
OpenFileControls.propTypes = {
  handler: propTypesExports$1.func.isRequired
};
OpenFileControls.defaultProps = {};
const styles$7 = {
  modalContainer: {
    width: 200,
    height: 200
  },
  textInput: {
    borderWidth: 2
  }
};
const {
  useToken: useToken$n
} = theme$2;
function PropertySetterControls(props) {
  const {
    onSubmit,
    enabled
  } = props;
  const {
    map: map5
  } = useMapbox();
  const [showForm, setShowForm] = React__default.useState(false);
  const [propertyName, setPropertyName] = React__default.useState("");
  const [propertyValue, setPropertyValue] = React__default.useState("");
  const [error2, setError] = React__default.useState("");
  const {
    Text: Text2
  } = Typography;
  const {
    token
  } = useToken$n();
  const onCloseModal = React__default.useCallback(() => {
    setPropertyName("");
    setPropertyValue("");
    setError("");
    setShowForm(false);
  }, []);
  const onClick2 = React__default.useCallback(() => {
    if (!showForm)
      setShowForm(true);
    else
      onCloseModal();
  }, [onCloseModal, showForm]);
  const buttonData = React__default.useMemo(() => [{
    className: cssstyles["mapboxgl-ctrl-property-setter"],
    tooltip: "Set Property",
    onClick: onClick2,
    disabled: !enabled
  }], [enabled, onClick2]);
  const handleSubmit = React__default.useCallback(() => {
    if (propertyName && propertyValue) {
      const status = onSubmit([{
        [propertyName]: propertyValue
      }]);
      if (status) {
        onCloseModal();
      } else {
        setError("Ensure to select a valid feature.");
      }
    } else {
      setError("Enter valid value.z");
    }
  }, [onCloseModal, onSubmit, propertyName, propertyValue]);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(MapButtonControl, { map: map5, buttons: buttonData, anchor: "top-right" }, "propertySetterControls"),
    /* @__PURE__ */ jsx(Modal$1, { open: showForm, onOk: () => {
      onCloseModal();
    }, onCancel: () => {
      onCloseModal();
    }, children: /* @__PURE__ */ jsxs("div", { style: styles$7.modalContainer, children: [
      /* @__PURE__ */ jsx(Text2, { children: "Property Name" }),
      /* @__PURE__ */ jsx(Input$2, { style: styles$7.textInput, onChange: (text) => setPropertyName(text), value: propertyName }),
      /* @__PURE__ */ jsx(Text2, { children: "Value" }),
      /* @__PURE__ */ jsx(Input$2, { style: styles$7.textInput, onChange: (text) => setPropertyValue(text), value: propertyValue }),
      /* @__PURE__ */ jsx(Text2, { style: {
        color: token.colorErrorTextActive
      }, children: error2 }),
      /* @__PURE__ */ jsx(Button, { onClick: handleSubmit, children: "Add Property" }),
      /* @__PURE__ */ jsx(Button, { onClick: onClick2, children: "Close" })
    ] }) })
  ] });
}
PropertySetterControls.propTypes = {
  onSubmit: propTypesExports$1.func,
  enabled: propTypesExports$1.bool
};
PropertySetterControls.defaultProps = {
  onSubmit: () => {
  },
  enabled: false
};
var srcExports = {};
var src = {
  get exports() {
    return srcExports;
  },
  set exports(v5) {
    srcExports = v5;
  }
};
var cssProperties = [
  "alignContent",
  "MozAlignContent",
  "WebkitAlignContent",
  "MSAlignContent",
  "OAlignContent",
  "alignItems",
  "MozAlignItems",
  "WebkitAlignItems",
  "MSAlignItems",
  "OAlignItems",
  "alignSelf",
  "MozAlignSelf",
  "WebkitAlignSelf",
  "MSAlignSelf",
  "OAlignSelf",
  "all",
  "MozAll",
  "WebkitAll",
  "MSAll",
  "OAll",
  "animation",
  "MozAnimation",
  "WebkitAnimation",
  "MSAnimation",
  "OAnimation",
  "animationDelay",
  "MozAnimationDelay",
  "WebkitAnimationDelay",
  "MSAnimationDelay",
  "OAnimationDelay",
  "animationDirection",
  "MozAnimationDirection",
  "WebkitAnimationDirection",
  "MSAnimationDirection",
  "OAnimationDirection",
  "animationDuration",
  "MozAnimationDuration",
  "WebkitAnimationDuration",
  "MSAnimationDuration",
  "OAnimationDuration",
  "animationFillMode",
  "MozAnimationFillMode",
  "WebkitAnimationFillMode",
  "MSAnimationFillMode",
  "OAnimationFillMode",
  "animationIterationCount",
  "MozAnimationIterationCount",
  "WebkitAnimationIterationCount",
  "MSAnimationIterationCount",
  "OAnimationIterationCount",
  "animationName",
  "MozAnimationName",
  "WebkitAnimationName",
  "MSAnimationName",
  "OAnimationName",
  "animationPlayState",
  "MozAnimationPlayState",
  "WebkitAnimationPlayState",
  "MSAnimationPlayState",
  "OAnimationPlayState",
  "animationTimingFunction",
  "MozAnimationTimingFunction",
  "WebkitAnimationTimingFunction",
  "MSAnimationTimingFunction",
  "OAnimationTimingFunction",
  "backfaceVisibility",
  "MozBackfaceVisibility",
  "WebkitBackfaceVisibility",
  "MSBackfaceVisibility",
  "OBackfaceVisibility",
  "background",
  "MozBackground",
  "WebkitBackground",
  "MSBackground",
  "OBackground",
  "backgroundAttachment",
  "MozBackgroundAttachment",
  "WebkitBackgroundAttachment",
  "MSBackgroundAttachment",
  "OBackgroundAttachment",
  "backgroundBlendMode",
  "MozBackgroundBlendMode",
  "WebkitBackgroundBlendMode",
  "MSBackgroundBlendMode",
  "OBackgroundBlendMode",
  "backgroundClip",
  "MozBackgroundClip",
  "WebkitBackgroundClip",
  "MSBackgroundClip",
  "OBackgroundClip",
  "backgroundColor",
  "MozBackgroundColor",
  "WebkitBackgroundColor",
  "MSBackgroundColor",
  "OBackgroundColor",
  "backgroundImage",
  "MozBackgroundImage",
  "WebkitBackgroundImage",
  "MSBackgroundImage",
  "OBackgroundImage",
  "backgroundOrigin",
  "MozBackgroundOrigin",
  "WebkitBackgroundOrigin",
  "MSBackgroundOrigin",
  "OBackgroundOrigin",
  "backgroundPosition",
  "MozBackgroundPosition",
  "WebkitBackgroundPosition",
  "MSBackgroundPosition",
  "OBackgroundPosition",
  "backgroundRepeat",
  "MozBackgroundRepeat",
  "WebkitBackgroundRepeat",
  "MSBackgroundRepeat",
  "OBackgroundRepeat",
  "backgroundSize",
  "MozBackgroundSize",
  "WebkitBackgroundSize",
  "MSBackgroundSize",
  "OBackgroundSize",
  "blockSize",
  "MozBlockSize",
  "WebkitBlockSize",
  "MSBlockSize",
  "OBlockSize",
  "border",
  "MozBorder",
  "WebkitBorder",
  "MSBorder",
  "OBorder",
  "borderBlockEnd",
  "MozBorderBlockEnd",
  "WebkitBorderBlockEnd",
  "MSBorderBlockEnd",
  "OBorderBlockEnd",
  "borderBlockEndColor",
  "MozBorderBlockEndColor",
  "WebkitBorderBlockEndColor",
  "MSBorderBlockEndColor",
  "OBorderBlockEndColor",
  "borderBlockEndStyle",
  "MozBorderBlockEndStyle",
  "WebkitBorderBlockEndStyle",
  "MSBorderBlockEndStyle",
  "OBorderBlockEndStyle",
  "borderBlockEndWidth",
  "MozBorderBlockEndWidth",
  "WebkitBorderBlockEndWidth",
  "MSBorderBlockEndWidth",
  "OBorderBlockEndWidth",
  "borderBlockStart",
  "MozBorderBlockStart",
  "WebkitBorderBlockStart",
  "MSBorderBlockStart",
  "OBorderBlockStart",
  "borderBlockStartColor",
  "MozBorderBlockStartColor",
  "WebkitBorderBlockStartColor",
  "MSBorderBlockStartColor",
  "OBorderBlockStartColor",
  "borderBlockStartStyle",
  "MozBorderBlockStartStyle",
  "WebkitBorderBlockStartStyle",
  "MSBorderBlockStartStyle",
  "OBorderBlockStartStyle",
  "borderBlockStartWidth",
  "MozBorderBlockStartWidth",
  "WebkitBorderBlockStartWidth",
  "MSBorderBlockStartWidth",
  "OBorderBlockStartWidth",
  "borderBottom",
  "MozBorderBottom",
  "WebkitBorderBottom",
  "MSBorderBottom",
  "OBorderBottom",
  "borderBottomColor",
  "MozBorderBottomColor",
  "WebkitBorderBottomColor",
  "MSBorderBottomColor",
  "OBorderBottomColor",
  "borderBottomLeftRadius",
  "MozBorderBottomLeftRadius",
  "WebkitBorderBottomLeftRadius",
  "MSBorderBottomLeftRadius",
  "OBorderBottomLeftRadius",
  "borderBottomRightRadius",
  "MozBorderBottomRightRadius",
  "WebkitBorderBottomRightRadius",
  "MSBorderBottomRightRadius",
  "OBorderBottomRightRadius",
  "borderBottomStyle",
  "MozBorderBottomStyle",
  "WebkitBorderBottomStyle",
  "MSBorderBottomStyle",
  "OBorderBottomStyle",
  "borderBottomWidth",
  "MozBorderBottomWidth",
  "WebkitBorderBottomWidth",
  "MSBorderBottomWidth",
  "OBorderBottomWidth",
  "borderCollapse",
  "MozBorderCollapse",
  "WebkitBorderCollapse",
  "MSBorderCollapse",
  "OBorderCollapse",
  "borderColor",
  "MozBorderColor",
  "WebkitBorderColor",
  "MSBorderColor",
  "OBorderColor",
  "borderImage",
  "MozBorderImage",
  "WebkitBorderImage",
  "MSBorderImage",
  "OBorderImage",
  "borderImageOutset",
  "MozBorderImageOutset",
  "WebkitBorderImageOutset",
  "MSBorderImageOutset",
  "OBorderImageOutset",
  "borderImageRepeat",
  "MozBorderImageRepeat",
  "WebkitBorderImageRepeat",
  "MSBorderImageRepeat",
  "OBorderImageRepeat",
  "borderImageSlice",
  "MozBorderImageSlice",
  "WebkitBorderImageSlice",
  "MSBorderImageSlice",
  "OBorderImageSlice",
  "borderImageSource",
  "MozBorderImageSource",
  "WebkitBorderImageSource",
  "MSBorderImageSource",
  "OBorderImageSource",
  "borderImageWidth",
  "MozBorderImageWidth",
  "WebkitBorderImageWidth",
  "MSBorderImageWidth",
  "OBorderImageWidth",
  "borderInlineEnd",
  "MozBorderInlineEnd",
  "WebkitBorderInlineEnd",
  "MSBorderInlineEnd",
  "OBorderInlineEnd",
  "borderInlineEndColor",
  "MozBorderInlineEndColor",
  "WebkitBorderInlineEndColor",
  "MSBorderInlineEndColor",
  "OBorderInlineEndColor",
  "borderInlineEndStyle",
  "MozBorderInlineEndStyle",
  "WebkitBorderInlineEndStyle",
  "MSBorderInlineEndStyle",
  "OBorderInlineEndStyle",
  "borderInlineEndWidth",
  "MozBorderInlineEndWidth",
  "WebkitBorderInlineEndWidth",
  "MSBorderInlineEndWidth",
  "OBorderInlineEndWidth",
  "borderInlineStart",
  "MozBorderInlineStart",
  "WebkitBorderInlineStart",
  "MSBorderInlineStart",
  "OBorderInlineStart",
  "borderInlineStartColor",
  "MozBorderInlineStartColor",
  "WebkitBorderInlineStartColor",
  "MSBorderInlineStartColor",
  "OBorderInlineStartColor",
  "borderInlineStartStyle",
  "MozBorderInlineStartStyle",
  "WebkitBorderInlineStartStyle",
  "MSBorderInlineStartStyle",
  "OBorderInlineStartStyle",
  "borderInlineStartWidth",
  "MozBorderInlineStartWidth",
  "WebkitBorderInlineStartWidth",
  "MSBorderInlineStartWidth",
  "OBorderInlineStartWidth",
  "borderLeft",
  "MozBorderLeft",
  "WebkitBorderLeft",
  "MSBorderLeft",
  "OBorderLeft",
  "borderLeftColor",
  "MozBorderLeftColor",
  "WebkitBorderLeftColor",
  "MSBorderLeftColor",
  "OBorderLeftColor",
  "borderLeftStyle",
  "MozBorderLeftStyle",
  "WebkitBorderLeftStyle",
  "MSBorderLeftStyle",
  "OBorderLeftStyle",
  "borderLeftWidth",
  "MozBorderLeftWidth",
  "WebkitBorderLeftWidth",
  "MSBorderLeftWidth",
  "OBorderLeftWidth",
  "borderRadius",
  "MozBorderRadius",
  "WebkitBorderRadius",
  "MSBorderRadius",
  "OBorderRadius",
  "borderRight",
  "MozBorderRight",
  "WebkitBorderRight",
  "MSBorderRight",
  "OBorderRight",
  "borderRightColor",
  "MozBorderRightColor",
  "WebkitBorderRightColor",
  "MSBorderRightColor",
  "OBorderRightColor",
  "borderRightStyle",
  "MozBorderRightStyle",
  "WebkitBorderRightStyle",
  "MSBorderRightStyle",
  "OBorderRightStyle",
  "borderRightWidth",
  "MozBorderRightWidth",
  "WebkitBorderRightWidth",
  "MSBorderRightWidth",
  "OBorderRightWidth",
  "borderSpacing",
  "MozBorderSpacing",
  "WebkitBorderSpacing",
  "MSBorderSpacing",
  "OBorderSpacing",
  "borderStyle",
  "MozBorderStyle",
  "WebkitBorderStyle",
  "MSBorderStyle",
  "OBorderStyle",
  "borderTop",
  "MozBorderTop",
  "WebkitBorderTop",
  "MSBorderTop",
  "OBorderTop",
  "borderTopColor",
  "MozBorderTopColor",
  "WebkitBorderTopColor",
  "MSBorderTopColor",
  "OBorderTopColor",
  "borderTopLeftRadius",
  "MozBorderTopLeftRadius",
  "WebkitBorderTopLeftRadius",
  "MSBorderTopLeftRadius",
  "OBorderTopLeftRadius",
  "borderTopRightRadius",
  "MozBorderTopRightRadius",
  "WebkitBorderTopRightRadius",
  "MSBorderTopRightRadius",
  "OBorderTopRightRadius",
  "borderTopStyle",
  "MozBorderTopStyle",
  "WebkitBorderTopStyle",
  "MSBorderTopStyle",
  "OBorderTopStyle",
  "borderTopWidth",
  "MozBorderTopWidth",
  "WebkitBorderTopWidth",
  "MSBorderTopWidth",
  "OBorderTopWidth",
  "borderWidth",
  "MozBorderWidth",
  "WebkitBorderWidth",
  "MSBorderWidth",
  "OBorderWidth",
  "bottom",
  "MozBottom",
  "WebkitBottom",
  "MSBottom",
  "OBottom",
  "boxDecorationBreak",
  "MozBoxDecorationBreak",
  "WebkitBoxDecorationBreak",
  "MSBoxDecorationBreak",
  "OBoxDecorationBreak",
  "boxShadow",
  "MozBoxShadow",
  "WebkitBoxShadow",
  "MSBoxShadow",
  "OBoxShadow",
  "boxSizing",
  "MozBoxSizing",
  "WebkitBoxSizing",
  "MSBoxSizing",
  "OBoxSizing",
  "breakAfter",
  "MozBreakAfter",
  "WebkitBreakAfter",
  "MSBreakAfter",
  "OBreakAfter",
  "breakBefore",
  "MozBreakBefore",
  "WebkitBreakBefore",
  "MSBreakBefore",
  "OBreakBefore",
  "breakInside",
  "MozBreakInside",
  "WebkitBreakInside",
  "MSBreakInside",
  "OBreakInside",
  "captionSide",
  "MozCaptionSide",
  "WebkitCaptionSide",
  "MSCaptionSide",
  "OCaptionSide",
  "caretColor",
  "MozCaretColor",
  "WebkitCaretColor",
  "MSCaretColor",
  "OCaretColor",
  "ch",
  "MozCh",
  "WebkitCh",
  "MSCh",
  "OCh",
  "clear",
  "MozClear",
  "WebkitClear",
  "MSClear",
  "OClear",
  "clip",
  "MozClip",
  "WebkitClip",
  "MSClip",
  "OClip",
  "clipPath",
  "MozClipPath",
  "WebkitClipPath",
  "MSClipPath",
  "OClipPath",
  "cm",
  "MozCm",
  "WebkitCm",
  "MSCm",
  "OCm",
  "color",
  "MozColor",
  "WebkitColor",
  "MSColor",
  "OColor",
  "columnCount",
  "MozColumnCount",
  "WebkitColumnCount",
  "MSColumnCount",
  "OColumnCount",
  "columnFill",
  "MozColumnFill",
  "WebkitColumnFill",
  "MSColumnFill",
  "OColumnFill",
  "columnGap",
  "MozColumnGap",
  "WebkitColumnGap",
  "MSColumnGap",
  "OColumnGap",
  "columnRule",
  "MozColumnRule",
  "WebkitColumnRule",
  "MSColumnRule",
  "OColumnRule",
  "columnRuleColor",
  "MozColumnRuleColor",
  "WebkitColumnRuleColor",
  "MSColumnRuleColor",
  "OColumnRuleColor",
  "columnRuleStyle",
  "MozColumnRuleStyle",
  "WebkitColumnRuleStyle",
  "MSColumnRuleStyle",
  "OColumnRuleStyle",
  "columnRuleWidth",
  "MozColumnRuleWidth",
  "WebkitColumnRuleWidth",
  "MSColumnRuleWidth",
  "OColumnRuleWidth",
  "columnSpan",
  "MozColumnSpan",
  "WebkitColumnSpan",
  "MSColumnSpan",
  "OColumnSpan",
  "columnWidth",
  "MozColumnWidth",
  "WebkitColumnWidth",
  "MSColumnWidth",
  "OColumnWidth",
  "columns",
  "MozColumns",
  "WebkitColumns",
  "MSColumns",
  "OColumns",
  "content",
  "MozContent",
  "WebkitContent",
  "MSContent",
  "OContent",
  "counterIncrement",
  "MozCounterIncrement",
  "WebkitCounterIncrement",
  "MSCounterIncrement",
  "OCounterIncrement",
  "counterReset",
  "MozCounterReset",
  "WebkitCounterReset",
  "MSCounterReset",
  "OCounterReset",
  "cursor",
  "MozCursor",
  "WebkitCursor",
  "MSCursor",
  "OCursor",
  "deg",
  "MozDeg",
  "WebkitDeg",
  "MSDeg",
  "ODeg",
  "direction",
  "MozDirection",
  "WebkitDirection",
  "MSDirection",
  "ODirection",
  "display",
  "MozDisplay",
  "WebkitDisplay",
  "MSDisplay",
  "ODisplay",
  "dpcm",
  "MozDpcm",
  "WebkitDpcm",
  "MSDpcm",
  "ODpcm",
  "dpi",
  "MozDpi",
  "WebkitDpi",
  "MSDpi",
  "ODpi",
  "dppx",
  "MozDppx",
  "WebkitDppx",
  "MSDppx",
  "ODppx",
  "em",
  "MozEm",
  "WebkitEm",
  "MSEm",
  "OEm",
  "emptyCells",
  "MozEmptyCells",
  "WebkitEmptyCells",
  "MSEmptyCells",
  "OEmptyCells",
  "ex",
  "MozEx",
  "WebkitEx",
  "MSEx",
  "OEx",
  "filter",
  "MozFilter",
  "WebkitFilter",
  "MSFilter",
  "OFilter",
  "flexBasis",
  "MozFlexBasis",
  "WebkitFlexBasis",
  "MSFlexBasis",
  "OFlexBasis",
  "flexDirection",
  "MozFlexDirection",
  "WebkitFlexDirection",
  "MSFlexDirection",
  "OFlexDirection",
  "flexFlow",
  "MozFlexFlow",
  "WebkitFlexFlow",
  "MSFlexFlow",
  "OFlexFlow",
  "flexGrow",
  "MozFlexGrow",
  "WebkitFlexGrow",
  "MSFlexGrow",
  "OFlexGrow",
  "flexShrink",
  "MozFlexShrink",
  "WebkitFlexShrink",
  "MSFlexShrink",
  "OFlexShrink",
  "flexWrap",
  "MozFlexWrap",
  "WebkitFlexWrap",
  "MSFlexWrap",
  "OFlexWrap",
  "float",
  "MozFloat",
  "WebkitFloat",
  "MSFloat",
  "OFloat",
  "font",
  "MozFont",
  "WebkitFont",
  "MSFont",
  "OFont",
  "fontFamily",
  "MozFontFamily",
  "WebkitFontFamily",
  "MSFontFamily",
  "OFontFamily",
  "fontFeatureSettings",
  "MozFontFeatureSettings",
  "WebkitFontFeatureSettings",
  "MSFontFeatureSettings",
  "OFontFeatureSettings",
  "fontKerning",
  "MozFontKerning",
  "WebkitFontKerning",
  "MSFontKerning",
  "OFontKerning",
  "fontLanguageOverride",
  "MozFontLanguageOverride",
  "WebkitFontLanguageOverride",
  "MSFontLanguageOverride",
  "OFontLanguageOverride",
  "fontSize",
  "MozFontSize",
  "WebkitFontSize",
  "MSFontSize",
  "OFontSize",
  "fontSizeAdjust",
  "MozFontSizeAdjust",
  "WebkitFontSizeAdjust",
  "MSFontSizeAdjust",
  "OFontSizeAdjust",
  "fontStretch",
  "MozFontStretch",
  "WebkitFontStretch",
  "MSFontStretch",
  "OFontStretch",
  "fontStyle",
  "MozFontStyle",
  "WebkitFontStyle",
  "MSFontStyle",
  "OFontStyle",
  "fontSynthesis",
  "MozFontSynthesis",
  "WebkitFontSynthesis",
  "MSFontSynthesis",
  "OFontSynthesis",
  "fontVariant",
  "MozFontVariant",
  "WebkitFontVariant",
  "MSFontVariant",
  "OFontVariant",
  "fontVariantAlternates",
  "MozFontVariantAlternates",
  "WebkitFontVariantAlternates",
  "MSFontVariantAlternates",
  "OFontVariantAlternates",
  "fontVariantCaps",
  "MozFontVariantCaps",
  "WebkitFontVariantCaps",
  "MSFontVariantCaps",
  "OFontVariantCaps",
  "fontVariantEastAsian",
  "MozFontVariantEastAsian",
  "WebkitFontVariantEastAsian",
  "MSFontVariantEastAsian",
  "OFontVariantEastAsian",
  "fontVariantLigatures",
  "MozFontVariantLigatures",
  "WebkitFontVariantLigatures",
  "MSFontVariantLigatures",
  "OFontVariantLigatures",
  "fontVariantNumeric",
  "MozFontVariantNumeric",
  "WebkitFontVariantNumeric",
  "MSFontVariantNumeric",
  "OFontVariantNumeric",
  "fontVariantPosition",
  "MozFontVariantPosition",
  "WebkitFontVariantPosition",
  "MSFontVariantPosition",
  "OFontVariantPosition",
  "fontWeight",
  "MozFontWeight",
  "WebkitFontWeight",
  "MSFontWeight",
  "OFontWeight",
  "fr",
  "MozFr",
  "WebkitFr",
  "MSFr",
  "OFr",
  "grad",
  "MozGrad",
  "WebkitGrad",
  "MSGrad",
  "OGrad",
  "grid",
  "MozGrid",
  "WebkitGrid",
  "MSGrid",
  "OGrid",
  "gridArea",
  "MozGridArea",
  "WebkitGridArea",
  "MSGridArea",
  "OGridArea",
  "gridAutoColumns",
  "MozGridAutoColumns",
  "WebkitGridAutoColumns",
  "MSGridAutoColumns",
  "OGridAutoColumns",
  "gridAutoFlow",
  "MozGridAutoFlow",
  "WebkitGridAutoFlow",
  "MSGridAutoFlow",
  "OGridAutoFlow",
  "gridAutoRows",
  "MozGridAutoRows",
  "WebkitGridAutoRows",
  "MSGridAutoRows",
  "OGridAutoRows",
  "gridColumn",
  "MozGridColumn",
  "WebkitGridColumn",
  "MSGridColumn",
  "OGridColumn",
  "gridColumnEnd",
  "MozGridColumnEnd",
  "WebkitGridColumnEnd",
  "MSGridColumnEnd",
  "OGridColumnEnd",
  "gridColumnGap",
  "MozGridColumnGap",
  "WebkitGridColumnGap",
  "MSGridColumnGap",
  "OGridColumnGap",
  "gridColumnStart",
  "MozGridColumnStart",
  "WebkitGridColumnStart",
  "MSGridColumnStart",
  "OGridColumnStart",
  "gridGap",
  "MozGridGap",
  "WebkitGridGap",
  "MSGridGap",
  "OGridGap",
  "gridRow",
  "MozGridRow",
  "WebkitGridRow",
  "MSGridRow",
  "OGridRow",
  "gridRowEnd",
  "MozGridRowEnd",
  "WebkitGridRowEnd",
  "MSGridRowEnd",
  "OGridRowEnd",
  "gridRowGap",
  "MozGridRowGap",
  "WebkitGridRowGap",
  "MSGridRowGap",
  "OGridRowGap",
  "gridRowStart",
  "MozGridRowStart",
  "WebkitGridRowStart",
  "MSGridRowStart",
  "OGridRowStart",
  "gridTemplate",
  "MozGridTemplate",
  "WebkitGridTemplate",
  "MSGridTemplate",
  "OGridTemplate",
  "gridTemplateAreas",
  "MozGridTemplateAreas",
  "WebkitGridTemplateAreas",
  "MSGridTemplateAreas",
  "OGridTemplateAreas",
  "gridTemplateColumns",
  "MozGridTemplateColumns",
  "WebkitGridTemplateColumns",
  "MSGridTemplateColumns",
  "OGridTemplateColumns",
  "gridTemplateRows",
  "MozGridTemplateRows",
  "WebkitGridTemplateRows",
  "MSGridTemplateRows",
  "OGridTemplateRows",
  "height",
  "MozHeight",
  "WebkitHeight",
  "MSHeight",
  "OHeight",
  "hyphens",
  "MozHyphens",
  "WebkitHyphens",
  "MSHyphens",
  "OHyphens",
  "hz",
  "MozHz",
  "WebkitHz",
  "MSHz",
  "OHz",
  "imageOrientation",
  "MozImageOrientation",
  "WebkitImageOrientation",
  "MSImageOrientation",
  "OImageOrientation",
  "imageRendering",
  "MozImageRendering",
  "WebkitImageRendering",
  "MSImageRendering",
  "OImageRendering",
  "imageResolution",
  "MozImageResolution",
  "WebkitImageResolution",
  "MSImageResolution",
  "OImageResolution",
  "imeMode",
  "MozImeMode",
  "WebkitImeMode",
  "MSImeMode",
  "OImeMode",
  "in",
  "MozIn",
  "WebkitIn",
  "MSIn",
  "OIn",
  "inherit",
  "MozInherit",
  "WebkitInherit",
  "MSInherit",
  "OInherit",
  "initial",
  "MozInitial",
  "WebkitInitial",
  "MSInitial",
  "OInitial",
  "inlineSize",
  "MozInlineSize",
  "WebkitInlineSize",
  "MSInlineSize",
  "OInlineSize",
  "isolation",
  "MozIsolation",
  "WebkitIsolation",
  "MSIsolation",
  "OIsolation",
  "justifyContent",
  "MozJustifyContent",
  "WebkitJustifyContent",
  "MSJustifyContent",
  "OJustifyContent",
  "khz",
  "MozKhz",
  "WebkitKhz",
  "MSKhz",
  "OKhz",
  "left",
  "MozLeft",
  "WebkitLeft",
  "MSLeft",
  "OLeft",
  "letterSpacing",
  "MozLetterSpacing",
  "WebkitLetterSpacing",
  "MSLetterSpacing",
  "OLetterSpacing",
  "lineBreak",
  "MozLineBreak",
  "WebkitLineBreak",
  "MSLineBreak",
  "OLineBreak",
  "lineHeight",
  "MozLineHeight",
  "WebkitLineHeight",
  "MSLineHeight",
  "OLineHeight",
  "listStyle",
  "MozListStyle",
  "WebkitListStyle",
  "MSListStyle",
  "OListStyle",
  "listStyleImage",
  "MozListStyleImage",
  "WebkitListStyleImage",
  "MSListStyleImage",
  "OListStyleImage",
  "listStylePosition",
  "MozListStylePosition",
  "WebkitListStylePosition",
  "MSListStylePosition",
  "OListStylePosition",
  "listStyleType",
  "MozListStyleType",
  "WebkitListStyleType",
  "MSListStyleType",
  "OListStyleType",
  "margin",
  "MozMargin",
  "WebkitMargin",
  "MSMargin",
  "OMargin",
  "marginBlockEnd",
  "MozMarginBlockEnd",
  "WebkitMarginBlockEnd",
  "MSMarginBlockEnd",
  "OMarginBlockEnd",
  "marginBlockStart",
  "MozMarginBlockStart",
  "WebkitMarginBlockStart",
  "MSMarginBlockStart",
  "OMarginBlockStart",
  "marginBottom",
  "MozMarginBottom",
  "WebkitMarginBottom",
  "MSMarginBottom",
  "OMarginBottom",
  "marginInlineEnd",
  "MozMarginInlineEnd",
  "WebkitMarginInlineEnd",
  "MSMarginInlineEnd",
  "OMarginInlineEnd",
  "marginInlineStart",
  "MozMarginInlineStart",
  "WebkitMarginInlineStart",
  "MSMarginInlineStart",
  "OMarginInlineStart",
  "marginLeft",
  "MozMarginLeft",
  "WebkitMarginLeft",
  "MSMarginLeft",
  "OMarginLeft",
  "marginRight",
  "MozMarginRight",
  "WebkitMarginRight",
  "MSMarginRight",
  "OMarginRight",
  "marginTop",
  "MozMarginTop",
  "WebkitMarginTop",
  "MSMarginTop",
  "OMarginTop",
  "mask",
  "MozMask",
  "WebkitMask",
  "MSMask",
  "OMask",
  "maskClip",
  "MozMaskClip",
  "WebkitMaskClip",
  "MSMaskClip",
  "OMaskClip",
  "maskComposite",
  "MozMaskComposite",
  "WebkitMaskComposite",
  "MSMaskComposite",
  "OMaskComposite",
  "maskImage",
  "MozMaskImage",
  "WebkitMaskImage",
  "MSMaskImage",
  "OMaskImage",
  "maskMode",
  "MozMaskMode",
  "WebkitMaskMode",
  "MSMaskMode",
  "OMaskMode",
  "maskOrigin",
  "MozMaskOrigin",
  "WebkitMaskOrigin",
  "MSMaskOrigin",
  "OMaskOrigin",
  "maskPosition",
  "MozMaskPosition",
  "WebkitMaskPosition",
  "MSMaskPosition",
  "OMaskPosition",
  "maskRepeat",
  "MozMaskRepeat",
  "WebkitMaskRepeat",
  "MSMaskRepeat",
  "OMaskRepeat",
  "maskSize",
  "MozMaskSize",
  "WebkitMaskSize",
  "MSMaskSize",
  "OMaskSize",
  "maskType",
  "MozMaskType",
  "WebkitMaskType",
  "MSMaskType",
  "OMaskType",
  "maxHeight",
  "MozMaxHeight",
  "WebkitMaxHeight",
  "MSMaxHeight",
  "OMaxHeight",
  "maxWidth",
  "MozMaxWidth",
  "WebkitMaxWidth",
  "MSMaxWidth",
  "OMaxWidth",
  "minBlockSize",
  "MozMinBlockSize",
  "WebkitMinBlockSize",
  "MSMinBlockSize",
  "OMinBlockSize",
  "minHeight",
  "MozMinHeight",
  "WebkitMinHeight",
  "MSMinHeight",
  "OMinHeight",
  "minInlineSize",
  "MozMinInlineSize",
  "WebkitMinInlineSize",
  "MSMinInlineSize",
  "OMinInlineSize",
  "minWidth",
  "MozMinWidth",
  "WebkitMinWidth",
  "MSMinWidth",
  "OMinWidth",
  "mixBlendMode",
  "MozMixBlendMode",
  "WebkitMixBlendMode",
  "MSMixBlendMode",
  "OMixBlendMode",
  "mm",
  "MozMm",
  "WebkitMm",
  "MSMm",
  "OMm",
  "ms",
  "MozMs",
  "WebkitMs",
  "MSMs",
  "OMs",
  "objectFit",
  "MozObjectFit",
  "WebkitObjectFit",
  "MSObjectFit",
  "OObjectFit",
  "objectPosition",
  "MozObjectPosition",
  "WebkitObjectPosition",
  "MSObjectPosition",
  "OObjectPosition",
  "offsetBlockEnd",
  "MozOffsetBlockEnd",
  "WebkitOffsetBlockEnd",
  "MSOffsetBlockEnd",
  "OOffsetBlockEnd",
  "offsetBlockStart",
  "MozOffsetBlockStart",
  "WebkitOffsetBlockStart",
  "MSOffsetBlockStart",
  "OOffsetBlockStart",
  "offsetInlineEnd",
  "MozOffsetInlineEnd",
  "WebkitOffsetInlineEnd",
  "MSOffsetInlineEnd",
  "OOffsetInlineEnd",
  "offsetInlineStart",
  "MozOffsetInlineStart",
  "WebkitOffsetInlineStart",
  "MSOffsetInlineStart",
  "OOffsetInlineStart",
  "opacity",
  "MozOpacity",
  "WebkitOpacity",
  "MSOpacity",
  "OOpacity",
  "order",
  "MozOrder",
  "WebkitOrder",
  "MSOrder",
  "OOrder",
  "orphans",
  "MozOrphans",
  "WebkitOrphans",
  "MSOrphans",
  "OOrphans",
  "outline",
  "MozOutline",
  "WebkitOutline",
  "MSOutline",
  "OOutline",
  "outlineColor",
  "MozOutlineColor",
  "WebkitOutlineColor",
  "MSOutlineColor",
  "OOutlineColor",
  "outlineOffset",
  "MozOutlineOffset",
  "WebkitOutlineOffset",
  "MSOutlineOffset",
  "OOutlineOffset",
  "outlineStyle",
  "MozOutlineStyle",
  "WebkitOutlineStyle",
  "MSOutlineStyle",
  "OOutlineStyle",
  "outlineWidth",
  "MozOutlineWidth",
  "WebkitOutlineWidth",
  "MSOutlineWidth",
  "OOutlineWidth",
  "overflow",
  "MozOverflow",
  "WebkitOverflow",
  "MSOverflow",
  "OOverflow",
  "overflowWrap",
  "MozOverflowWrap",
  "WebkitOverflowWrap",
  "MSOverflowWrap",
  "OOverflowWrap",
  "overflowX",
  "MozOverflowX",
  "WebkitOverflowX",
  "MSOverflowX",
  "OOverflowX",
  "overflowY",
  "MozOverflowY",
  "WebkitOverflowY",
  "MSOverflowY",
  "OOverflowY",
  "padding",
  "MozPadding",
  "WebkitPadding",
  "MSPadding",
  "OPadding",
  "paddingBlockEnd",
  "MozPaddingBlockEnd",
  "WebkitPaddingBlockEnd",
  "MSPaddingBlockEnd",
  "OPaddingBlockEnd",
  "paddingBlockStart",
  "MozPaddingBlockStart",
  "WebkitPaddingBlockStart",
  "MSPaddingBlockStart",
  "OPaddingBlockStart",
  "paddingBottom",
  "MozPaddingBottom",
  "WebkitPaddingBottom",
  "MSPaddingBottom",
  "OPaddingBottom",
  "paddingInlineEnd",
  "MozPaddingInlineEnd",
  "WebkitPaddingInlineEnd",
  "MSPaddingInlineEnd",
  "OPaddingInlineEnd",
  "paddingInlineStart",
  "MozPaddingInlineStart",
  "WebkitPaddingInlineStart",
  "MSPaddingInlineStart",
  "OPaddingInlineStart",
  "paddingLeft",
  "MozPaddingLeft",
  "WebkitPaddingLeft",
  "MSPaddingLeft",
  "OPaddingLeft",
  "paddingRight",
  "MozPaddingRight",
  "WebkitPaddingRight",
  "MSPaddingRight",
  "OPaddingRight",
  "paddingTop",
  "MozPaddingTop",
  "WebkitPaddingTop",
  "MSPaddingTop",
  "OPaddingTop",
  "pageBreakAfter",
  "MozPageBreakAfter",
  "WebkitPageBreakAfter",
  "MSPageBreakAfter",
  "OPageBreakAfter",
  "pageBreakBefore",
  "MozPageBreakBefore",
  "WebkitPageBreakBefore",
  "MSPageBreakBefore",
  "OPageBreakBefore",
  "pageBreakInside",
  "MozPageBreakInside",
  "WebkitPageBreakInside",
  "MSPageBreakInside",
  "OPageBreakInside",
  "pc",
  "MozPc",
  "WebkitPc",
  "MSPc",
  "OPc",
  "perspective",
  "MozPerspective",
  "WebkitPerspective",
  "MSPerspective",
  "OPerspective",
  "perspectiveOrigin",
  "MozPerspectiveOrigin",
  "WebkitPerspectiveOrigin",
  "MSPerspectiveOrigin",
  "OPerspectiveOrigin",
  "pointerEvents",
  "MozPointerEvents",
  "WebkitPointerEvents",
  "MSPointerEvents",
  "OPointerEvents",
  "position",
  "MozPosition",
  "WebkitPosition",
  "MSPosition",
  "OPosition",
  "pt",
  "MozPt",
  "WebkitPt",
  "MSPt",
  "OPt",
  "px",
  "MozPx",
  "WebkitPx",
  "MSPx",
  "OPx",
  "q",
  "MozQ",
  "WebkitQ",
  "MSQ",
  "OQ",
  "quotes",
  "MozQuotes",
  "WebkitQuotes",
  "MSQuotes",
  "OQuotes",
  "rad",
  "MozRad",
  "WebkitRad",
  "MSRad",
  "ORad",
  "rem",
  "MozRem",
  "WebkitRem",
  "MSRem",
  "ORem",
  "resize",
  "MozResize",
  "WebkitResize",
  "MSResize",
  "OResize",
  "revert",
  "MozRevert",
  "WebkitRevert",
  "MSRevert",
  "ORevert",
  "right",
  "MozRight",
  "WebkitRight",
  "MSRight",
  "ORight",
  "rubyAlign",
  "MozRubyAlign",
  "WebkitRubyAlign",
  "MSRubyAlign",
  "ORubyAlign",
  "rubyMerge",
  "MozRubyMerge",
  "WebkitRubyMerge",
  "MSRubyMerge",
  "ORubyMerge",
  "rubyPosition",
  "MozRubyPosition",
  "WebkitRubyPosition",
  "MSRubyPosition",
  "ORubyPosition",
  "s",
  "MozS",
  "WebkitS",
  "MSS",
  "OS",
  "scrollBehavior",
  "MozScrollBehavior",
  "WebkitScrollBehavior",
  "MSScrollBehavior",
  "OScrollBehavior",
  "scrollSnapCoordinate",
  "MozScrollSnapCoordinate",
  "WebkitScrollSnapCoordinate",
  "MSScrollSnapCoordinate",
  "OScrollSnapCoordinate",
  "scrollSnapDestination",
  "MozScrollSnapDestination",
  "WebkitScrollSnapDestination",
  "MSScrollSnapDestination",
  "OScrollSnapDestination",
  "scrollSnapType",
  "MozScrollSnapType",
  "WebkitScrollSnapType",
  "MSScrollSnapType",
  "OScrollSnapType",
  "shapeImageThreshold",
  "MozShapeImageThreshold",
  "WebkitShapeImageThreshold",
  "MSShapeImageThreshold",
  "OShapeImageThreshold",
  "shapeMargin",
  "MozShapeMargin",
  "WebkitShapeMargin",
  "MSShapeMargin",
  "OShapeMargin",
  "shapeOutside",
  "MozShapeOutside",
  "WebkitShapeOutside",
  "MSShapeOutside",
  "OShapeOutside",
  "tabSize",
  "MozTabSize",
  "WebkitTabSize",
  "MSTabSize",
  "OTabSize",
  "tableLayout",
  "MozTableLayout",
  "WebkitTableLayout",
  "MSTableLayout",
  "OTableLayout",
  "textAlign",
  "MozTextAlign",
  "WebkitTextAlign",
  "MSTextAlign",
  "OTextAlign",
  "textAlignLast",
  "MozTextAlignLast",
  "WebkitTextAlignLast",
  "MSTextAlignLast",
  "OTextAlignLast",
  "textCombineUpright",
  "MozTextCombineUpright",
  "WebkitTextCombineUpright",
  "MSTextCombineUpright",
  "OTextCombineUpright",
  "textDecoration",
  "MozTextDecoration",
  "WebkitTextDecoration",
  "MSTextDecoration",
  "OTextDecoration",
  "textDecorationColor",
  "MozTextDecorationColor",
  "WebkitTextDecorationColor",
  "MSTextDecorationColor",
  "OTextDecorationColor",
  "textDecorationLine",
  "MozTextDecorationLine",
  "WebkitTextDecorationLine",
  "MSTextDecorationLine",
  "OTextDecorationLine",
  "textDecorationStyle",
  "MozTextDecorationStyle",
  "WebkitTextDecorationStyle",
  "MSTextDecorationStyle",
  "OTextDecorationStyle",
  "textEmphasis",
  "MozTextEmphasis",
  "WebkitTextEmphasis",
  "MSTextEmphasis",
  "OTextEmphasis",
  "textEmphasisColor",
  "MozTextEmphasisColor",
  "WebkitTextEmphasisColor",
  "MSTextEmphasisColor",
  "OTextEmphasisColor",
  "textEmphasisPosition",
  "MozTextEmphasisPosition",
  "WebkitTextEmphasisPosition",
  "MSTextEmphasisPosition",
  "OTextEmphasisPosition",
  "textEmphasisStyle",
  "MozTextEmphasisStyle",
  "WebkitTextEmphasisStyle",
  "MSTextEmphasisStyle",
  "OTextEmphasisStyle",
  "textIndent",
  "MozTextIndent",
  "WebkitTextIndent",
  "MSTextIndent",
  "OTextIndent",
  "textOrientation",
  "MozTextOrientation",
  "WebkitTextOrientation",
  "MSTextOrientation",
  "OTextOrientation",
  "textOverflow",
  "MozTextOverflow",
  "WebkitTextOverflow",
  "MSTextOverflow",
  "OTextOverflow",
  "textRendering",
  "MozTextRendering",
  "WebkitTextRendering",
  "MSTextRendering",
  "OTextRendering",
  "textShadow",
  "MozTextShadow",
  "WebkitTextShadow",
  "MSTextShadow",
  "OTextShadow",
  "textTransform",
  "MozTextTransform",
  "WebkitTextTransform",
  "MSTextTransform",
  "OTextTransform",
  "textUnderlinePosition",
  "MozTextUnderlinePosition",
  "WebkitTextUnderlinePosition",
  "MSTextUnderlinePosition",
  "OTextUnderlinePosition",
  "top",
  "MozTop",
  "WebkitTop",
  "MSTop",
  "OTop",
  "touchAction",
  "MozTouchAction",
  "WebkitTouchAction",
  "MSTouchAction",
  "OTouchAction",
  "transform",
  "MozTransform",
  "WebkitTransform",
  "msTransform",
  "OTransform",
  "transformBox",
  "MozTransformBox",
  "WebkitTransformBox",
  "MSTransformBox",
  "OTransformBox",
  "transformOrigin",
  "MozTransformOrigin",
  "WebkitTransformOrigin",
  "MSTransformOrigin",
  "OTransformOrigin",
  "transformStyle",
  "MozTransformStyle",
  "WebkitTransformStyle",
  "MSTransformStyle",
  "OTransformStyle",
  "transition",
  "MozTransition",
  "WebkitTransition",
  "MSTransition",
  "OTransition",
  "transitionDelay",
  "MozTransitionDelay",
  "WebkitTransitionDelay",
  "MSTransitionDelay",
  "OTransitionDelay",
  "transitionDuration",
  "MozTransitionDuration",
  "WebkitTransitionDuration",
  "MSTransitionDuration",
  "OTransitionDuration",
  "transitionProperty",
  "MozTransitionProperty",
  "WebkitTransitionProperty",
  "MSTransitionProperty",
  "OTransitionProperty",
  "transitionTimingFunction",
  "MozTransitionTimingFunction",
  "WebkitTransitionTimingFunction",
  "MSTransitionTimingFunction",
  "OTransitionTimingFunction",
  "turn",
  "MozTurn",
  "WebkitTurn",
  "MSTurn",
  "OTurn",
  "unicodeBidi",
  "MozUnicodeBidi",
  "WebkitUnicodeBidi",
  "MSUnicodeBidi",
  "OUnicodeBidi",
  "unset",
  "MozUnset",
  "WebkitUnset",
  "MSUnset",
  "OUnset",
  "verticalAlign",
  "MozVerticalAlign",
  "WebkitVerticalAlign",
  "MSVerticalAlign",
  "OVerticalAlign",
  "vh",
  "MozVh",
  "WebkitVh",
  "MSVh",
  "OVh",
  "visibility",
  "MozVisibility",
  "WebkitVisibility",
  "MSVisibility",
  "OVisibility",
  "vmax",
  "MozVmax",
  "WebkitVmax",
  "MSVmax",
  "OVmax",
  "vmin",
  "MozVmin",
  "WebkitVmin",
  "MSVmin",
  "OVmin",
  "vw",
  "MozVw",
  "WebkitVw",
  "MSVw",
  "OVw",
  "whiteSpace",
  "MozWhiteSpace",
  "WebkitWhiteSpace",
  "MSWhiteSpace",
  "OWhiteSpace",
  "widows",
  "MozWidows",
  "WebkitWidows",
  "MSWidows",
  "OWidows",
  "width",
  "MozWidth",
  "WebkitWidth",
  "MSWidth",
  "OWidth",
  "willChange",
  "MozWillChange",
  "WebkitWillChange",
  "MSWillChange",
  "OWillChange",
  "wordBreak",
  "MozWordBreak",
  "WebkitWordBreak",
  "MSWordBreak",
  "OWordBreak",
  "wordSpacing",
  "MozWordSpacing",
  "WebkitWordSpacing",
  "MSWordSpacing",
  "OWordSpacing",
  "wordWrap",
  "MozWordWrap",
  "WebkitWordWrap",
  "MSWordWrap",
  "OWordWrap",
  "writingMode",
  "MozWritingMode",
  "WebkitWritingMode",
  "MSWritingMode",
  "OWritingMode",
  "zIndex",
  "MozZIndex",
  "WebkitZIndex",
  "MSZIndex",
  "OZIndex",
  "fontSize",
  "MozFontSize",
  "WebkitFontSize",
  "MSFontSize",
  "OFontSize",
  "flex",
  "MozFlex",
  "WebkitFlex",
  "MSFlex",
  "OFlex",
  "fr",
  "MozFr",
  "WebkitFr",
  "MSFr",
  "OFr",
  "overflowScrolling",
  "MozOverflowScrolling",
  "WebkitOverflowScrolling",
  "MSOverflowScrolling",
  "OOverflowScrolling",
  "userSelect",
  "MozUserSelect",
  "WebkitUserSelect",
  "MSUserSelect",
  "OUserSelect"
];
(function(module2) {
  var properties = cssProperties;
  var PropTypes2 = propTypesExports$1;
  module2.exports = function(props, propName2, componentName) {
    var styles2 = props[propName2];
    if (!styles2) {
      return;
    }
    var failures = [];
    Object.keys(styles2).forEach(function(styleKey) {
      if (properties.indexOf(styleKey) === -1) {
        failures.push(styleKey);
      }
    });
    if (failures.length) {
      throw new Error("Prop " + propName2 + " passed to " + componentName + ". Has invalid keys " + failures.join(", "));
    }
  };
  module2.exports.isRequired = function(props, propName2, componentName) {
    if (!props[propName2]) {
      throw new Error("Prop " + propName2 + " passed to " + componentName + " is required");
    }
    return module2.exports(props, propName2, componentName);
  };
  module2.exports.supportingArrays = PropTypes2.oneOfType([
    PropTypes2.arrayOf(module2.exports),
    module2.exports
  ]);
})(src);
const stylePropType = srcExports;
function componentWillMount() {
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== void 0) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== void 0 ? state : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component2) {
  var prototype2 = Component2.prototype;
  if (!prototype2 || !prototype2.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component2.getDerivedStateFromProps !== "function" && typeof prototype2.getSnapshotBeforeUpdate !== "function") {
    return Component2;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype2.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype2.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype2.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype2.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype2.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype2.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component2.displayName || Component2.name;
    var newApiName = typeof Component2.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks"
    );
  }
  if (typeof Component2.getDerivedStateFromProps === "function") {
    prototype2.componentWillMount = componentWillMount;
    prototype2.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype2.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype2.componentDidUpdate !== "function") {
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    }
    prototype2.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype2.componentDidUpdate;
    prototype2.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component2;
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$1(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o2) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o3) {
    return o3.__proto__ || Object.getPrototypeOf(o3);
  };
  return _getPrototypeOf(o2);
}
function _setPrototypeOf(o2, p2) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o3, p3) {
    o3.__proto__ = p3;
    return o3;
  };
  return _setPrototypeOf(o2, p2);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e3) {
    return false;
  }
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call2) {
  if (call2 && (typeof call2 === "object" || typeof call2 === "function")) {
    return call2;
  }
  return _assertThisInitialized(self2);
}
function _createSuper(Derived) {
  return function() {
    var Super = _getPrototypeOf(Derived), result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var Pane = /* @__PURE__ */ function(_React$PureComponent) {
  _inherits(Pane2, _React$PureComponent);
  var _super = _createSuper(Pane2);
  function Pane2() {
    _classCallCheck(this, Pane2);
    return _super.apply(this, arguments);
  }
  _createClass(Pane2, [{
    key: "render",
    value: function render5() {
      var _this$props = this.props, children = _this$props.children, className = _this$props.className, split2 = _this$props.split, styleProps = _this$props.style, size12 = _this$props.size, eleRef = _this$props.eleRef;
      var classes2 = ["Pane", split2, className];
      var style2 = {
        flex: 1,
        position: "relative",
        outline: "none"
      };
      if (size12 !== void 0) {
        if (split2 === "vertical") {
          style2.width = size12;
        } else {
          style2.height = size12;
          style2.display = "flex";
        }
        style2.flex = "none";
      }
      style2 = Object.assign({}, style2, styleProps || {});
      return /* @__PURE__ */ React__default.createElement("div", {
        ref: eleRef,
        className: classes2.join(" "),
        style: style2
      }, children);
    }
  }]);
  return Pane2;
}(React__default.PureComponent);
Pane.propTypes = {
  className: propTypesExports$1.string.isRequired,
  children: propTypesExports$1.node.isRequired,
  size: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  split: propTypesExports$1.oneOf(["vertical", "horizontal"]),
  style: stylePropType,
  eleRef: propTypesExports$1.func
};
Pane.defaultProps = {};
var RESIZER_DEFAULT_CLASSNAME = "Resizer";
var Resizer = /* @__PURE__ */ function(_React$Component) {
  _inherits(Resizer2, _React$Component);
  var _super = _createSuper(Resizer2);
  function Resizer2() {
    _classCallCheck(this, Resizer2);
    return _super.apply(this, arguments);
  }
  _createClass(Resizer2, [{
    key: "render",
    value: function render5() {
      var _this$props = this.props, className = _this$props.className, _onClick = _this$props.onClick, _onDoubleClick = _this$props.onDoubleClick, _onMouseDown = _this$props.onMouseDown, _onTouchEnd = _this$props.onTouchEnd, _onTouchStart = _this$props.onTouchStart, resizerClassName = _this$props.resizerClassName, split2 = _this$props.split, style2 = _this$props.style;
      var classes2 = [resizerClassName, split2, className];
      return /* @__PURE__ */ React__default.createElement("span", {
        role: "presentation",
        className: classes2.join(" "),
        style: style2,
        onMouseDown: function onMouseDown(event) {
          return _onMouseDown(event);
        },
        onTouchStart: function onTouchStart(event) {
          event.preventDefault();
          _onTouchStart(event);
        },
        onTouchEnd: function onTouchEnd(event) {
          event.preventDefault();
          _onTouchEnd(event);
        },
        onClick: function onClick2(event) {
          if (_onClick) {
            event.preventDefault();
            _onClick(event);
          }
        },
        onDoubleClick: function onDoubleClick(event) {
          if (_onDoubleClick) {
            event.preventDefault();
            _onDoubleClick(event);
          }
        }
      });
    }
  }]);
  return Resizer2;
}(React__default.Component);
Resizer.propTypes = {
  className: propTypesExports$1.string.isRequired,
  onClick: propTypesExports$1.func,
  onDoubleClick: propTypesExports$1.func,
  onMouseDown: propTypesExports$1.func.isRequired,
  onTouchStart: propTypesExports$1.func.isRequired,
  onTouchEnd: propTypesExports$1.func.isRequired,
  split: propTypesExports$1.oneOf(["vertical", "horizontal"]),
  style: stylePropType,
  resizerClassName: propTypesExports$1.string.isRequired
};
Resizer.defaultProps = {
  resizerClassName: RESIZER_DEFAULT_CLASSNAME
};
function unFocus(document2, window2) {
  if (document2.selection) {
    document2.selection.empty();
  } else {
    try {
      window2.getSelection().removeAllRanges();
    } catch (e3) {
    }
  }
}
function getDefaultSize(defaultSize, minSize, maxSize, draggedSize) {
  if (typeof draggedSize === "number") {
    var min4 = typeof minSize === "number" ? minSize : 0;
    var max3 = typeof maxSize === "number" && maxSize >= 0 ? maxSize : Infinity;
    return Math.max(min4, Math.min(max3, draggedSize));
  }
  if (defaultSize !== void 0) {
    return defaultSize;
  }
  return minSize;
}
function removeNullChildren(children) {
  return React__default.Children.toArray(children).filter(function(c2) {
    return c2;
  });
}
var SplitPane$1 = /* @__PURE__ */ function(_React$Component) {
  _inherits(SplitPane2, _React$Component);
  var _super = _createSuper(SplitPane2);
  function SplitPane2(props) {
    var _this;
    _classCallCheck(this, SplitPane2);
    _this = _super.call(this, props);
    _this.onMouseDown = _this.onMouseDown.bind(_assertThisInitialized(_this));
    _this.onTouchStart = _this.onTouchStart.bind(_assertThisInitialized(_this));
    _this.onMouseMove = _this.onMouseMove.bind(_assertThisInitialized(_this));
    _this.onTouchMove = _this.onTouchMove.bind(_assertThisInitialized(_this));
    _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_this));
    var size12 = props.size, defaultSize = props.defaultSize, minSize = props.minSize, maxSize = props.maxSize, primary = props.primary;
    var initialSize = size12 !== void 0 ? size12 : getDefaultSize(defaultSize, minSize, maxSize, null);
    _this.state = {
      active: false,
      resized: false,
      pane1Size: primary === "first" ? initialSize : void 0,
      pane2Size: primary === "second" ? initialSize : void 0,
      // these are props that are needed in static functions. ie: gDSFP
      instanceProps: {
        size: size12
      }
    };
    return _this;
  }
  _createClass(SplitPane2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mouseup", this.onMouseUp);
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("touchmove", this.onTouchMove);
      this.setState(SplitPane2.getSizeUpdate(this.props, this.state));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mouseup", this.onMouseUp);
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("touchmove", this.onTouchMove);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event) {
      var eventWithTouches = Object.assign({}, event, {
        touches: [{
          clientX: event.clientX,
          clientY: event.clientY
        }]
      });
      this.onTouchStart(eventWithTouches);
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(event) {
      var _this$props = this.props, allowResize = _this$props.allowResize, onDragStarted = _this$props.onDragStarted, split2 = _this$props.split;
      if (allowResize) {
        unFocus(document, window);
        var position = split2 === "vertical" ? event.touches[0].clientX : event.touches[0].clientY;
        if (typeof onDragStarted === "function") {
          onDragStarted();
        }
        this.setState({
          active: true,
          position
        });
      }
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove2(event) {
      var eventWithTouches = Object.assign({}, event, {
        touches: [{
          clientX: event.clientX,
          clientY: event.clientY
        }]
      });
      this.onTouchMove(eventWithTouches);
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(event) {
      var _this$props2 = this.props, allowResize = _this$props2.allowResize, maxSize = _this$props2.maxSize, minSize = _this$props2.minSize, onChange = _this$props2.onChange, split2 = _this$props2.split, step = _this$props2.step;
      var _this$state = this.state, active3 = _this$state.active, position = _this$state.position;
      if (allowResize && active3) {
        unFocus(document, window);
        var isPrimaryFirst = this.props.primary === "first";
        var ref = isPrimaryFirst ? this.pane1 : this.pane2;
        var ref2 = isPrimaryFirst ? this.pane2 : this.pane1;
        if (ref) {
          var node = ref;
          var node2 = ref2;
          if (node.getBoundingClientRect) {
            var width = node.getBoundingClientRect().width;
            var height = node.getBoundingClientRect().height;
            var current = split2 === "vertical" ? event.touches[0].clientX : event.touches[0].clientY;
            var size12 = split2 === "vertical" ? width : height;
            var positionDelta = position - current;
            if (step) {
              if (Math.abs(positionDelta) < step) {
                return;
              }
              positionDelta = ~~(positionDelta / step) * step;
            }
            var sizeDelta = isPrimaryFirst ? positionDelta : -positionDelta;
            var pane1Order = parseInt(window.getComputedStyle(node).order);
            var pane2Order = parseInt(window.getComputedStyle(node2).order);
            if (pane1Order > pane2Order) {
              sizeDelta = -sizeDelta;
            }
            var newMaxSize = maxSize;
            if (maxSize !== void 0 && maxSize <= 0) {
              var splitPane = this.splitPane;
              if (split2 === "vertical") {
                newMaxSize = splitPane.getBoundingClientRect().width + maxSize;
              } else {
                newMaxSize = splitPane.getBoundingClientRect().height + maxSize;
              }
            }
            var newSize = size12 - sizeDelta;
            var newPosition = position - positionDelta;
            if (newSize < minSize) {
              newSize = minSize;
            } else if (maxSize !== void 0 && newSize > newMaxSize) {
              newSize = newMaxSize;
            } else {
              this.setState({
                position: newPosition,
                resized: true
              });
            }
            if (onChange)
              onChange(newSize);
            this.setState(_defineProperty$1({
              draggedSize: newSize
            }, isPrimaryFirst ? "pane1Size" : "pane2Size", newSize));
          }
        }
      }
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp() {
      var _this$props3 = this.props, allowResize = _this$props3.allowResize, onDragFinished = _this$props3.onDragFinished;
      var _this$state2 = this.state, active3 = _this$state2.active, draggedSize = _this$state2.draggedSize;
      if (allowResize && active3) {
        if (typeof onDragFinished === "function") {
          onDragFinished(draggedSize);
        }
        this.setState({
          active: false
        });
      }
    }
    // we have to check values since gDSFP is called on every render and more in StrictMode
  }, {
    key: "render",
    value: function render5() {
      var _this2 = this;
      var _this$props4 = this.props, allowResize = _this$props4.allowResize, children = _this$props4.children, className = _this$props4.className, onResizerClick = _this$props4.onResizerClick, onResizerDoubleClick = _this$props4.onResizerDoubleClick, paneClassName = _this$props4.paneClassName, pane1ClassName = _this$props4.pane1ClassName, pane2ClassName = _this$props4.pane2ClassName, paneStyle = _this$props4.paneStyle, pane1StyleProps = _this$props4.pane1Style, pane2StyleProps = _this$props4.pane2Style, resizerClassName = _this$props4.resizerClassName, resizerStyle = _this$props4.resizerStyle, split2 = _this$props4.split, styleProps = _this$props4.style;
      var _this$state3 = this.state, pane1Size = _this$state3.pane1Size, pane2Size = _this$state3.pane2Size;
      var disabledClass = allowResize ? "" : "disabled";
      var resizerClassNamesIncludingDefault = resizerClassName ? "".concat(resizerClassName, " ").concat(RESIZER_DEFAULT_CLASSNAME) : resizerClassName;
      var notNullChildren = removeNullChildren(children);
      var style2 = _objectSpread2$1({
        display: "flex",
        flex: 1,
        height: "100%",
        position: "absolute",
        outline: "none",
        overflow: "hidden",
        MozUserSelect: "text",
        WebkitUserSelect: "text",
        msUserSelect: "text",
        userSelect: "text"
      }, styleProps);
      if (split2 === "vertical") {
        Object.assign(style2, {
          flexDirection: "row",
          left: 0,
          right: 0
        });
      } else {
        Object.assign(style2, {
          bottom: 0,
          flexDirection: "column",
          minHeight: "100%",
          top: 0,
          width: "100%"
        });
      }
      var classes2 = ["SplitPane", className, split2, disabledClass];
      var pane1Style = _objectSpread2$1({}, paneStyle, {}, pane1StyleProps);
      var pane2Style = _objectSpread2$1({}, paneStyle, {}, pane2StyleProps);
      var pane1Classes = ["Pane1", paneClassName, pane1ClassName].join(" ");
      var pane2Classes = ["Pane2", paneClassName, pane2ClassName].join(" ");
      return /* @__PURE__ */ React__default.createElement("div", {
        className: classes2.join(" "),
        ref: function ref(node) {
          _this2.splitPane = node;
        },
        style: style2
      }, /* @__PURE__ */ React__default.createElement(Pane, {
        className: pane1Classes,
        key: "pane1",
        eleRef: function eleRef(node) {
          _this2.pane1 = node;
        },
        size: pane1Size,
        split: split2,
        style: pane1Style
      }, notNullChildren[0]), /* @__PURE__ */ React__default.createElement(Resizer, {
        className: disabledClass,
        onClick: onResizerClick,
        onDoubleClick: onResizerDoubleClick,
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onTouchEnd: this.onMouseUp,
        key: "resizer",
        resizerClassName: resizerClassNamesIncludingDefault,
        split: split2,
        style: resizerStyle || {}
      }), /* @__PURE__ */ React__default.createElement(Pane, {
        className: pane2Classes,
        key: "pane2",
        eleRef: function eleRef(node) {
          _this2.pane2 = node;
        },
        size: pane2Size,
        split: split2,
        style: pane2Style
      }, notNullChildren[1]));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      return SplitPane2.getSizeUpdate(nextProps, prevState);
    }
  }, {
    key: "getSizeUpdate",
    value: function getSizeUpdate(props, state) {
      var newState = {};
      var instanceProps = state.instanceProps;
      if (instanceProps.size === props.size && props.size !== void 0) {
        return {};
      }
      var newSize = props.size !== void 0 ? props.size : getDefaultSize(props.defaultSize, props.minSize, props.maxSize, state.draggedSize);
      if (props.size !== void 0) {
        newState.draggedSize = newSize;
      }
      var isPanel1Primary = props.primary === "first";
      newState[isPanel1Primary ? "pane1Size" : "pane2Size"] = newSize;
      newState[isPanel1Primary ? "pane2Size" : "pane1Size"] = void 0;
      newState.instanceProps = {
        size: props.size
      };
      return newState;
    }
  }]);
  return SplitPane2;
}(React__default.Component);
SplitPane$1.propTypes = {
  allowResize: propTypesExports$1.bool,
  children: propTypesExports$1.arrayOf(propTypesExports$1.node).isRequired,
  className: propTypesExports$1.string,
  primary: propTypesExports$1.oneOf(["first", "second"]),
  minSize: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  maxSize: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  // eslint-disable-next-line react/no-unused-prop-types
  defaultSize: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  size: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  split: propTypesExports$1.oneOf(["vertical", "horizontal"]),
  onDragStarted: propTypesExports$1.func,
  onDragFinished: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  onResizerClick: propTypesExports$1.func,
  onResizerDoubleClick: propTypesExports$1.func,
  style: stylePropType,
  resizerStyle: stylePropType,
  paneClassName: propTypesExports$1.string,
  pane1ClassName: propTypesExports$1.string,
  pane2ClassName: propTypesExports$1.string,
  paneStyle: stylePropType,
  pane1Style: stylePropType,
  pane2Style: stylePropType,
  resizerClassName: propTypesExports$1.string,
  step: propTypesExports$1.number
};
SplitPane$1.defaultProps = {
  allowResize: true,
  minSize: 50,
  primary: "first",
  split: "vertical",
  paneClassName: "",
  pane1ClassName: "",
  pane2ClassName: ""
};
polyfill(SplitPane$1);
function SplitPane(props) {
  const {
    children: childrenIn,
    disabled,
    ...restProps
  } = props;
  const children = React__default.useMemo(() => React__default.Children.map(childrenIn, (child, index2) => {
    if (disabled.includes(index2))
      return null;
    return child;
  }), [childrenIn, disabled]);
  const numChildren = (children == null ? void 0 : children.length) || 1;
  if (numChildren < 2)
    return children;
  return /* @__PURE__ */ jsx(SplitPane$1, { size: `${100 / numChildren}%`, split: "vertical", ...restProps, children });
}
SplitPane.propTypes = {
  children: propTypesExports$1.arrayOf(propTypesExports$1.node),
  disabled: propTypesExports$1.arrayOf(propTypesExports$1.number)
};
SplitPane.defaultProps = {
  children: [],
  disabled: []
};
function SymbolDragControls(props) {
  var _a3;
  const {
    feature: feature2,
    sourceId,
    layerId,
    onChange,
    enable: enable4
  } = props;
  const {
    map: map5
  } = useMapbox();
  const isDragging = React__default.useRef(false);
  const featureId = (feature2 == null ? void 0 : feature2.id) || ((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.id);
  const updateSource2 = React__default.useCallback((lng, lat) => {
    const source = map5.getSource(sourceId);
    if (!(source == null ? void 0 : source._data))
      return;
    const updatedGeojson = {
      ...source._data
    };
    updatedGeojson.features = updatedGeojson.features.map((f2) => {
      if (f2.id === featureId || f2.properties.id === featureId) {
        return {
          ...f2,
          geometry: {
            ...f2.geometry,
            coordinates: [lng, lat]
          }
        };
      }
      return f2;
    });
    source.setData(updatedGeojson);
    map5.triggerRepaint();
    onChange(updatedGeojson);
  }, [featureId, map5, onChange, sourceId]);
  const handleMove = React__default.useCallback((e3) => {
    if (!isDragging.current)
      return;
    const {
      lng,
      lat
    } = e3.lngLat;
    updateSource2(lng, lat);
  }, [updateSource2]);
  const handleUp = React__default.useCallback((e3) => {
    const {
      lng,
      lat
    } = e3.lngLat;
    updateSource2(lng, lat);
    isDragging.current = false;
    map5.off("mousemove", handleMove);
    map5.off("mouseup", handleUp);
  }, [handleMove, map5, updateSource2]);
  const handleMouseDown = React__default.useCallback((e3) => {
    const features = map5.queryRenderedFeatures(e3.point, {
      layers: [layerId]
    });
    if (!features.length)
      return;
    if (!features.find((f2) => f2.id === featureId || f2.properties.id === featureId))
      return;
    e3.preventDefault();
    isDragging.current = true;
    map5.on("mousemove", handleMove);
    map5.on("mouseup", handleUp);
  }, [featureId, handleMove, handleUp, layerId, map5]);
  React__default.useEffect(() => {
    if (!map5 || !feature2 || !sourceId || !enable4) {
      return () => {
      };
    }
    map5.on("mousedown", layerId, handleMouseDown);
    return () => {
      map5.off("mousedown", layerId, handleMouseDown);
    };
  }, [enable4, feature2, handleMouseDown, layerId, map5, sourceId]);
  return null;
}
SymbolDragControls.propTypes = {
  feature: propTypesExports$1.object,
  sourceId: propTypesExports$1.string,
  layerId: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  enable: propTypesExports$1.bool
};
SymbolDragControls.defaultProps = {
  feature: null,
  sourceId: "",
  layerId: "",
  onChange: () => {
  },
  enable: false
};
const select_class = "_select_class_ncefs_1";
const select_dropdown = "_select_dropdown_ncefs_27";
const checkbox_group = "_checkbox_group_ncefs_35";
const checkbox_wrapper = "_checkbox_wrapper_ncefs_45";
const checkbox_value = "_checkbox_value_ncefs_59";
const styles$6 = {
  select_class,
  select_dropdown,
  checkbox_group,
  checkbox_wrapper,
  checkbox_value
};
function TextFileExporter(props) {
  const {
    formats: formats2,
    active: active3,
    onDone,
    data: data2,
    outputFilename: intialFilename
  } = props;
  const initialFormat = formats2 == null ? void 0 : formats2[0];
  const getFinalData = React__default.useCallback(async (formValues) => {
    let result = null;
    if (typeof data2 === "function") {
      result = await data2(formValues);
    } else {
      result = {
        data: data2,
        type: FileUtil.EXTENSION_MIME_TYPES.txt
      };
    }
    return result || {};
  }, [data2]);
  const handleSubmit = React__default.useCallback(async (values4) => {
    const {
      format,
      outputFilename
    } = values4 || {};
    const {
      data: finalData,
      type
    } = await getFinalData(format);
    if (outputFilename && finalData) {
      let content = finalData;
      if (type === FileUtil.EXTENSION_MIME_TYPES.txt && typeof finalData !== "string") {
        content = JSON.stringify(finalData);
      }
      let extension = format;
      if (type === FileUtil.EXTENSION_MIME_TYPES.kmz) {
        extension = "kmz";
      } else if (type === FileUtil.EXTENSION_MIME_TYPES.kml) {
        extension = "kml";
      }
      FileUtil.writeTextFile(content, `${outputFilename}.${extension}`, type).then(onDone).catch(onDone);
    }
  }, [getFinalData, onDone]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { component: RightPanel, title: "Export", onCancel: onDone, onSubmit: handleSubmit, active: active3, formValues: {
    outputFilename: intialFilename,
    format: initialFormat
  }, marginVertical: 0, marginHorizontal: 0, placement: "top-right", okText: "Export", showCancel: false, bodyStyle: {
    padding: "8px 24px 0px 24px"
  }, footerStyle: {
    width: "100%",
    padding: 0
  }, children: [
    /* @__PURE__ */ jsx(Form.Item, { label: "File Name:", name: "outputFilename", rules: [{
      message: "Enter output file name"
    }], children: /* @__PURE__ */ jsx(Input$2, {}) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "format", label: "File Format:", initialValue: initialFormat, className: styles$6.select_class, children: /* @__PURE__ */ jsx(Select$1, { popupClassName: styles$6.select_dropdown, children: formats2.map((option) => /* @__PURE__ */ jsx(Select$1.Option, { value: option, children: option }, option)) }) })
  ] });
}
TextFileExporter.propTypes = {
  formats: propTypesExports$1.arrayOf(propTypesExports$1.string),
  active: propTypesExports$1.bool,
  onDone: propTypesExports$1.func,
  data: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.func]),
  outputFilename: propTypesExports$1.string
};
TextFileExporter.defaultProps = {
  formats: ["txt"],
  active: false,
  onDone: () => {
  },
  data: null,
  outputFilename: "output"
};
const zoomControls_module = {};
function ZoomControls(props) {
  const {
    placement,
    style: styleIn,
    marginVertical,
    marginHorizontal,
    ...restProps
  } = props;
  const style2 = React__default.useMemo(() => {
    var _a3, _b3;
    const vertical = ((_a3 = placement == null ? void 0 : placement.split("-")) == null ? void 0 : _a3[0]) || "bottom";
    const horizontal = ((_b3 = placement == null ? void 0 : placement.split("-")) == null ? void 0 : _b3[1]) || "right";
    const parentPlacement = {};
    if (vertical === "top") {
      parentPlacement.marginTop = marginVertical;
    } else {
      parentPlacement.marginBottom = marginVertical;
    }
    if (horizontal === "left") {
      parentPlacement.marginLeft = marginHorizontal;
    } else {
      parentPlacement.marginRight = marginHorizontal;
    }
    return {
      ...parentPlacement,
      ...styleIn
    };
  }, [placement, styleIn, marginVertical, marginHorizontal]);
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(NavigationControl$1, { ...restProps, position: placement, style: style2 }) });
}
ZoomControls.propTypes = {
  placement: propTypesExports$1.oneOf(["top-right", "top-left", "bottom-left", "bottom-right"]),
  showCompass: propTypesExports$1.bool,
  showZoom: propTypesExports$1.bool,
  visualizePitch: propTypesExports$1.bool,
  style: propTypesExports$1.object,
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
};
ZoomControls.defaultProps = {
  placement: "bottom-right",
  showCompass: false,
  showZoom: true,
  visualizePitch: false,
  style: {},
  marginHorizontal: 10,
  marginVertical: 0
};
const ORDER = ["extrusion", "fill", "line", "heatmap", "point"];
function LayerSorter(props) {
  const {
    filter: filter17,
    sortingOrder,
    comparator: comparator2
  } = props;
  const {
    map: map5
  } = useMapbox();
  const getLayers = React__default.useCallback(() => {
    var _a3, _b3, _c2;
    return (_c2 = (_b3 = (_a3 = map5 == null ? void 0 : map5.getStyle()) == null ? void 0 : _a3.layers) == null ? void 0 : _b3.map((l2) => l2.id)) == null ? void 0 : _c2.filter(filter17);
  }, [filter17, map5]);
  const sortLayers = React__default.useCallback((layers) => {
    if (!(layers == null ? void 0 : layers.length))
      return [];
    const sorted = [];
    sortingOrder == null ? void 0 : sortingOrder.forEach((type) => {
      layers.forEach((layer) => {
        if (comparator2(type, layer)) {
          sorted.push(layer);
        }
      });
    });
    return sorted;
  }, [comparator2, sortingOrder]);
  const moveLayer = React__default.useCallback((layerId, beforeId) => {
    try {
      if (map5.getLayer(layerId)) {
        map5.moveLayer(layerId, beforeId);
      }
    } catch (error2) {
      console.error(error2);
    }
  }, [map5]);
  const performSorting = React__default.useCallback((layers) => {
    if (!(layers == null ? void 0 : layers.length))
      return;
    layers.forEach((back, index2, array2) => {
      const front = array2.length - 1 > index2 ? array2[index2 + 1] : void 0;
      moveLayer(back, front);
    });
  }, [moveLayer]);
  const lastSortingTimeRef = React__default.useRef(Date.now());
  const performSortingIfNeeded = React__default.useCallback(() => {
    const now2 = Date.now();
    if (now2 - lastSortingTimeRef.current < 100)
      return;
    lastSortingTimeRef.current = now2;
    const currentLayers = getLayers();
    const sortedLayers = sortLayers(currentLayers);
    if (currentLayers.join() === sortedLayers.join()) {
      return;
    }
    performSorting(sortedLayers);
  }, [getLayers, performSorting, sortLayers]);
  React__default.useEffect(() => {
    if (!map5) {
      return () => {
      };
    }
    map5.on("styledata", performSortingIfNeeded);
    return () => {
      map5.off("styledata", performSortingIfNeeded);
    };
  }, [map5, performSorting, performSortingIfNeeded, sortLayers]);
  return null;
}
LayerSorter.propTypes = {
  filter: propTypesExports$1.func,
  comparator: propTypesExports$1.func,
  sortingOrder: propTypesExports$1.array
};
LayerSorter.defaultProps = {
  filter: () => false,
  comparator: (sortingType, layer) => layer.endsWith(sortingType),
  sortingOrder: ORDER
};
var constantsExports = {};
var constants = {
  get exports() {
    return constantsExports;
  },
  set exports(v5) {
    constantsExports = v5;
  }
};
var reactReconcilerConstants_production_min = {};
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactReconcilerConstants_production_min;
function requireReactReconcilerConstants_production_min() {
  if (hasRequiredReactReconcilerConstants_production_min)
    return reactReconcilerConstants_production_min;
  hasRequiredReactReconcilerConstants_production_min = 1;
  reactReconcilerConstants_production_min.ConcurrentRoot = 1;
  reactReconcilerConstants_production_min.ContinuousEventPriority = 4;
  reactReconcilerConstants_production_min.DefaultEventPriority = 16;
  reactReconcilerConstants_production_min.DiscreteEventPriority = 1;
  reactReconcilerConstants_production_min.IdleEventPriority = 536870912;
  reactReconcilerConstants_production_min.LegacyRoot = 0;
  return reactReconcilerConstants_production_min;
}
var reactReconcilerConstants_development = {};
/**
 * @license React
 * react-reconciler-constants.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactReconcilerConstants_development;
function requireReactReconcilerConstants_development() {
  if (hasRequiredReactReconcilerConstants_development)
    return reactReconcilerConstants_development;
  hasRequiredReactReconcilerConstants_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var SyncLane = (
        /*                        */
        1
      );
      var InputContinuousLane = (
        /*            */
        4
      );
      var DefaultLane = (
        /*                    */
        16
      );
      var IdleLane = (
        /*                       */
        536870912
      );
      var DiscreteEventPriority = SyncLane;
      var ContinuousEventPriority = InputContinuousLane;
      var DefaultEventPriority = DefaultLane;
      var IdleEventPriority = IdleLane;
      var LegacyRoot = 0;
      var ConcurrentRoot = 1;
      reactReconcilerConstants_development.ConcurrentRoot = ConcurrentRoot;
      reactReconcilerConstants_development.ContinuousEventPriority = ContinuousEventPriority;
      reactReconcilerConstants_development.DefaultEventPriority = DefaultEventPriority;
      reactReconcilerConstants_development.DiscreteEventPriority = DiscreteEventPriority;
      reactReconcilerConstants_development.IdleEventPriority = IdleEventPriority;
      reactReconcilerConstants_development.LegacyRoot = LegacyRoot;
    })();
  }
  return reactReconcilerConstants_development;
}
(function(module2) {
  if (process.env.NODE_ENV === "production") {
    module2.exports = requireReactReconcilerConstants_production_min();
  } else {
    module2.exports = requireReactReconcilerConstants_development();
  }
})(constants);
function createStore$1(createState) {
  let state;
  const listeners2 = /* @__PURE__ */ new Set();
  const setState = (partial, replace2) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace2 ? nextState : Object.assign({}, state, nextState);
      listeners2.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribeWithSelector = (listener, selector = getState, equalityFn = Object.is) => {
    console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
    let currentSlice = selector(state);
    function listenerToAdd() {
      const nextSlice = selector(state);
      if (!equalityFn(currentSlice, nextSlice)) {
        const previousSlice = currentSlice;
        listener(currentSlice = nextSlice, previousSlice);
      }
    }
    listeners2.add(listenerToAdd);
    return () => listeners2.delete(listenerToAdd);
  };
  const subscribe = (listener, selector, equalityFn) => {
    if (selector || equalityFn) {
      return subscribeWithSelector(listener, selector, equalityFn);
    }
    listeners2.add(listener);
    return () => listeners2.delete(listener);
  };
  const destroy2 = () => listeners2.clear();
  const api2 = { setState, getState, subscribe, destroy: destroy2 };
  state = createState(setState, getState, api2);
  return api2;
}
const isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
const useIsomorphicLayoutEffect$1 = isSSR ? useEffect : useLayoutEffect$1;
function create(createState) {
  const api2 = typeof createState === "function" ? createStore$1(createState) : createState;
  const useStore2 = (selector = api2.getState, equalityFn = Object.is) => {
    const [, forceUpdate] = useReducer((c2) => c2 + 1, 0);
    const state = api2.getState();
    const stateRef = useRef(state);
    const selectorRef = useRef(selector);
    const equalityFnRef = useRef(equalityFn);
    const erroredRef = useRef(false);
    const currentSliceRef = useRef();
    if (currentSliceRef.current === void 0) {
      currentSliceRef.current = selector(state);
    }
    let newStateSlice;
    let hasNewStateSlice = false;
    if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
      newStateSlice = selector(state);
      hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
    }
    useIsomorphicLayoutEffect$1(() => {
      if (hasNewStateSlice) {
        currentSliceRef.current = newStateSlice;
      }
      stateRef.current = state;
      selectorRef.current = selector;
      equalityFnRef.current = equalityFn;
      erroredRef.current = false;
    });
    const stateBeforeSubscriptionRef = useRef(state);
    useIsomorphicLayoutEffect$1(() => {
      const listener = () => {
        try {
          const nextState = api2.getState();
          const nextStateSlice = selectorRef.current(nextState);
          if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
            stateRef.current = nextState;
            currentSliceRef.current = nextStateSlice;
            forceUpdate();
          }
        } catch (error2) {
          erroredRef.current = true;
          forceUpdate();
        }
      };
      const unsubscribe = api2.subscribe(listener);
      if (api2.getState() !== stateBeforeSubscriptionRef.current) {
        listener();
      }
      return unsubscribe;
    }, []);
    const sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
    useDebugValue(sliceToReturn);
    return sliceToReturn;
  };
  Object.assign(useStore2, api2);
  useStore2[Symbol.iterator] = function() {
    console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
    const items = [useStore2, api2];
    return {
      next() {
        const done = items.length <= 0;
        return { value: items.shift(), done };
      }
    };
  };
  return useStore2;
}
const isPromise = (promise) => typeof promise === "object" && typeof promise.then === "function";
const globalCache = [];
function shallowEqualArrays(arrA, arrB, equal3 = (a2, b2) => a2 === b2) {
  if (arrA === arrB)
    return true;
  if (!arrA || !arrB)
    return false;
  const len2 = arrA.length;
  if (arrB.length !== len2)
    return false;
  for (let i2 = 0; i2 < len2; i2++)
    if (!equal3(arrA[i2], arrB[i2]))
      return false;
  return true;
}
function query(fn2, keys4 = null, preload2 = false, config2 = {}) {
  if (keys4 === null)
    keys4 = [fn2];
  for (const entry2 of globalCache) {
    if (shallowEqualArrays(keys4, entry2.keys, entry2.equal)) {
      if (preload2)
        return void 0;
      if (Object.prototype.hasOwnProperty.call(entry2, "error"))
        throw entry2.error;
      if (Object.prototype.hasOwnProperty.call(entry2, "response")) {
        if (config2.lifespan && config2.lifespan > 0) {
          if (entry2.timeout)
            clearTimeout(entry2.timeout);
          entry2.timeout = setTimeout(entry2.remove, config2.lifespan);
        }
        return entry2.response;
      }
      if (!preload2)
        throw entry2.promise;
    }
  }
  const entry = {
    keys: keys4,
    equal: config2.equal,
    remove: () => {
      const index2 = globalCache.indexOf(entry);
      if (index2 !== -1)
        globalCache.splice(index2, 1);
    },
    promise: (
      // Execute the promise
      (isPromise(fn2) ? fn2 : fn2(...keys4)).then((response) => {
        entry.response = response;
        if (config2.lifespan && config2.lifespan > 0) {
          entry.timeout = setTimeout(entry.remove, config2.lifespan);
        }
      }).catch((error2) => entry.error = error2)
    )
  };
  globalCache.push(entry);
  if (!preload2)
    throw entry.promise;
  return void 0;
}
const suspend = (fn2, keys4, config2) => query(fn2, keys4, false, config2);
const preload = (fn2, keys4, config2) => void query(fn2, keys4, true, config2);
const clear = (keys4) => {
  if (keys4 === void 0 || keys4.length === 0)
    globalCache.splice(0, globalCache.length);
  else {
    const entry = globalCache.find((entry2) => shallowEqualArrays(keys4, entry2.keys, entry2.equal));
    if (entry)
      entry.remove();
  }
};
var reactReconcilerExports = {};
var reactReconciler = {
  get exports() {
    return reactReconcilerExports;
  },
  set exports(v5) {
    reactReconcilerExports = v5;
  }
};
var schedulerExports = {};
var scheduler = {
  get exports() {
    return schedulerExports;
  },
  set exports(v5) {
    schedulerExports = v5;
  }
};
var scheduler_production_min = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_production_min;
function requireScheduler_production_min() {
  if (hasRequiredScheduler_production_min)
    return scheduler_production_min;
  hasRequiredScheduler_production_min = 1;
  (function(exports2) {
    function f2(a2, b2) {
      var c2 = a2.length;
      a2.push(b2);
      a:
        for (; 0 < c2; ) {
          var d2 = c2 - 1 >>> 1, e3 = a2[d2];
          if (0 < g2(e3, b2))
            a2[d2] = b2, a2[c2] = e3, c2 = d2;
          else
            break a;
        }
    }
    function h2(a2) {
      return 0 === a2.length ? null : a2[0];
    }
    function k2(a2) {
      if (0 === a2.length)
        return null;
      var b2 = a2[0], c2 = a2.pop();
      if (c2 !== b2) {
        a2[0] = c2;
        a:
          for (var d2 = 0, e3 = a2.length, w2 = e3 >>> 1; d2 < w2; ) {
            var m2 = 2 * (d2 + 1) - 1, C2 = a2[m2], n2 = m2 + 1, x2 = a2[n2];
            if (0 > g2(C2, c2))
              n2 < e3 && 0 > g2(x2, C2) ? (a2[d2] = x2, a2[n2] = c2, d2 = n2) : (a2[d2] = C2, a2[m2] = c2, d2 = m2);
            else if (n2 < e3 && 0 > g2(x2, c2))
              a2[d2] = x2, a2[n2] = c2, d2 = n2;
            else
              break a;
          }
      }
      return b2;
    }
    function g2(a2, b2) {
      var c2 = a2.sortIndex - b2.sortIndex;
      return 0 !== c2 ? c2 : a2.id - b2.id;
    }
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var l2 = performance;
      exports2.unstable_now = function() {
        return l2.now();
      };
    } else {
      var p2 = Date, q2 = p2.now();
      exports2.unstable_now = function() {
        return p2.now() - q2;
      };
    }
    var r2 = [], t2 = [], u2 = 1, v5 = null, y2 = 3, z2 = false, A2 = false, B2 = false, D2 = "function" === typeof setTimeout ? setTimeout : null, E3 = "function" === typeof clearTimeout ? clearTimeout : null, F2 = "undefined" !== typeof setImmediate ? setImmediate : null;
    "undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function G2(a2) {
      for (var b2 = h2(t2); null !== b2; ) {
        if (null === b2.callback)
          k2(t2);
        else if (b2.startTime <= a2)
          k2(t2), b2.sortIndex = b2.expirationTime, f2(r2, b2);
        else
          break;
        b2 = h2(t2);
      }
    }
    function H2(a2) {
      B2 = false;
      G2(a2);
      if (!A2)
        if (null !== h2(r2))
          A2 = true, I2(J2);
        else {
          var b2 = h2(t2);
          null !== b2 && K2(H2, b2.startTime - a2);
        }
    }
    function J2(a2, b2) {
      A2 = false;
      B2 && (B2 = false, E3(L2), L2 = -1);
      z2 = true;
      var c2 = y2;
      try {
        G2(b2);
        for (v5 = h2(r2); null !== v5 && (!(v5.expirationTime > b2) || a2 && !M2()); ) {
          var d2 = v5.callback;
          if ("function" === typeof d2) {
            v5.callback = null;
            y2 = v5.priorityLevel;
            var e3 = d2(v5.expirationTime <= b2);
            b2 = exports2.unstable_now();
            "function" === typeof e3 ? v5.callback = e3 : v5 === h2(r2) && k2(r2);
            G2(b2);
          } else
            k2(r2);
          v5 = h2(r2);
        }
        if (null !== v5)
          var w2 = true;
        else {
          var m2 = h2(t2);
          null !== m2 && K2(H2, m2.startTime - b2);
          w2 = false;
        }
        return w2;
      } finally {
        v5 = null, y2 = c2, z2 = false;
      }
    }
    var N2 = false, O2 = null, L2 = -1, P2 = 5, Q2 = -1;
    function M2() {
      return exports2.unstable_now() - Q2 < P2 ? false : true;
    }
    function R2() {
      if (null !== O2) {
        var a2 = exports2.unstable_now();
        Q2 = a2;
        var b2 = true;
        try {
          b2 = O2(true, a2);
        } finally {
          b2 ? S2() : (N2 = false, O2 = null);
        }
      } else
        N2 = false;
    }
    var S2;
    if ("function" === typeof F2)
      S2 = function() {
        F2(R2);
      };
    else if ("undefined" !== typeof MessageChannel) {
      var T2 = new MessageChannel(), U2 = T2.port2;
      T2.port1.onmessage = R2;
      S2 = function() {
        U2.postMessage(null);
      };
    } else
      S2 = function() {
        D2(R2, 0);
      };
    function I2(a2) {
      O2 = a2;
      N2 || (N2 = true, S2());
    }
    function K2(a2, b2) {
      L2 = D2(function() {
        a2(exports2.unstable_now());
      }, b2);
    }
    exports2.unstable_IdlePriority = 5;
    exports2.unstable_ImmediatePriority = 1;
    exports2.unstable_LowPriority = 4;
    exports2.unstable_NormalPriority = 3;
    exports2.unstable_Profiling = null;
    exports2.unstable_UserBlockingPriority = 2;
    exports2.unstable_cancelCallback = function(a2) {
      a2.callback = null;
    };
    exports2.unstable_continueExecution = function() {
      A2 || z2 || (A2 = true, I2(J2));
    };
    exports2.unstable_forceFrameRate = function(a2) {
      0 > a2 || 125 < a2 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P2 = 0 < a2 ? Math.floor(1e3 / a2) : 5;
    };
    exports2.unstable_getCurrentPriorityLevel = function() {
      return y2;
    };
    exports2.unstable_getFirstCallbackNode = function() {
      return h2(r2);
    };
    exports2.unstable_next = function(a2) {
      switch (y2) {
        case 1:
        case 2:
        case 3:
          var b2 = 3;
          break;
        default:
          b2 = y2;
      }
      var c2 = y2;
      y2 = b2;
      try {
        return a2();
      } finally {
        y2 = c2;
      }
    };
    exports2.unstable_pauseExecution = function() {
    };
    exports2.unstable_requestPaint = function() {
    };
    exports2.unstable_runWithPriority = function(a2, b2) {
      switch (a2) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          a2 = 3;
      }
      var c2 = y2;
      y2 = a2;
      try {
        return b2();
      } finally {
        y2 = c2;
      }
    };
    exports2.unstable_scheduleCallback = function(a2, b2, c2) {
      var d2 = exports2.unstable_now();
      "object" === typeof c2 && null !== c2 ? (c2 = c2.delay, c2 = "number" === typeof c2 && 0 < c2 ? d2 + c2 : d2) : c2 = d2;
      switch (a2) {
        case 1:
          var e3 = -1;
          break;
        case 2:
          e3 = 250;
          break;
        case 5:
          e3 = 1073741823;
          break;
        case 4:
          e3 = 1e4;
          break;
        default:
          e3 = 5e3;
      }
      e3 = c2 + e3;
      a2 = { id: u2++, callback: b2, priorityLevel: a2, startTime: c2, expirationTime: e3, sortIndex: -1 };
      c2 > d2 ? (a2.sortIndex = c2, f2(t2, a2), null === h2(r2) && a2 === h2(t2) && (B2 ? (E3(L2), L2 = -1) : B2 = true, K2(H2, c2 - d2))) : (a2.sortIndex = e3, f2(r2, a2), A2 || z2 || (A2 = true, I2(J2)));
      return a2;
    };
    exports2.unstable_shouldYield = M2;
    exports2.unstable_wrapCallback = function(a2) {
      var b2 = y2;
      return function() {
        var c2 = y2;
        y2 = b2;
        try {
          return a2.apply(this, arguments);
        } finally {
          y2 = c2;
        }
      };
    };
  })(scheduler_production_min);
  return scheduler_production_min;
}
var scheduler_development = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_development;
function requireScheduler_development() {
  if (hasRequiredScheduler_development)
    return scheduler_development;
  hasRequiredScheduler_development = 1;
  (function(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
        }
        var enableSchedulerDebugging = false;
        var enableProfiling = false;
        var frameYieldMs = 5;
        function push2(heap, node) {
          var index2 = heap.length;
          heap.push(node);
          siftUp(heap, node, index2);
        }
        function peek(heap) {
          return heap.length === 0 ? null : heap[0];
        }
        function pop(heap) {
          if (heap.length === 0) {
            return null;
          }
          var first = heap[0];
          var last = heap.pop();
          if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
          }
          return first;
        }
        function siftUp(heap, node, i2) {
          var index2 = i2;
          while (index2 > 0) {
            var parentIndex = index2 - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare12(parent, node) > 0) {
              heap[parentIndex] = node;
              heap[index2] = parent;
              index2 = parentIndex;
            } else {
              return;
            }
          }
        }
        function siftDown(heap, node, i2) {
          var index2 = i2;
          var length2 = heap.length;
          var halfLength = length2 >>> 1;
          while (index2 < halfLength) {
            var leftIndex = (index2 + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex];
            if (compare12(left, node) < 0) {
              if (rightIndex < length2 && compare12(right, left) < 0) {
                heap[index2] = right;
                heap[rightIndex] = node;
                index2 = rightIndex;
              } else {
                heap[index2] = left;
                heap[leftIndex] = node;
                index2 = leftIndex;
              }
            } else if (rightIndex < length2 && compare12(right, node) < 0) {
              heap[index2] = right;
              heap[rightIndex] = node;
              index2 = rightIndex;
            } else {
              return;
            }
          }
        }
        function compare12(a2, b2) {
          var diff2 = a2.sortIndex - b2.sortIndex;
          return diff2 !== 0 ? diff2 : a2.id - b2.id;
        }
        var ImmediatePriority = 1;
        var UserBlockingPriority = 2;
        var NormalPriority = 3;
        var LowPriority = 4;
        var IdlePriority = 5;
        function markTaskErrored(task, ms) {
        }
        var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
        if (hasPerformanceNow) {
          var localPerformance = performance;
          exports2.unstable_now = function() {
            return localPerformance.now();
          };
        } else {
          var localDate = Date;
          var initialTime = localDate.now();
          exports2.unstable_now = function() {
            return localDate.now() - initialTime;
          };
        }
        var maxSigned31BitInt = 1073741823;
        var IMMEDIATE_PRIORITY_TIMEOUT = -1;
        var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
        var NORMAL_PRIORITY_TIMEOUT = 5e3;
        var LOW_PRIORITY_TIMEOUT = 1e4;
        var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt;
        var taskQueue = [];
        var timerQueue = [];
        var taskIdCounter = 1;
        var currentTask = null;
        var currentPriorityLevel = NormalPriority;
        var isPerformingWork = false;
        var isHostCallbackScheduled = false;
        var isHostTimeoutScheduled = false;
        var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
        var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
        var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null;
        typeof navigator !== "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
        function advanceTimers(currentTime) {
          var timer = peek(timerQueue);
          while (timer !== null) {
            if (timer.callback === null) {
              pop(timerQueue);
            } else if (timer.startTime <= currentTime) {
              pop(timerQueue);
              timer.sortIndex = timer.expirationTime;
              push2(taskQueue, timer);
            } else {
              return;
            }
            timer = peek(timerQueue);
          }
        }
        function handleTimeout(currentTime) {
          isHostTimeoutScheduled = false;
          advanceTimers(currentTime);
          if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            } else {
              var firstTimer = peek(timerQueue);
              if (firstTimer !== null) {
                requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
              }
            }
          }
        }
        function flushWork(hasTimeRemaining, initialTime2) {
          isHostCallbackScheduled = false;
          if (isHostTimeoutScheduled) {
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
          }
          isPerformingWork = true;
          var previousPriorityLevel = currentPriorityLevel;
          try {
            var currentTime;
            if (enableProfiling)
              ;
            else {
              return workLoop(hasTimeRemaining, initialTime2);
            }
          } finally {
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
          }
        }
        function workLoop(hasTimeRemaining, initialTime2) {
          var currentTime = initialTime2;
          advanceTimers(currentTime);
          currentTask = peek(taskQueue);
          while (currentTask !== null && !enableSchedulerDebugging) {
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) {
              break;
            }
            var callback = currentTask.callback;
            if (typeof callback === "function") {
              currentTask.callback = null;
              currentPriorityLevel = currentTask.priorityLevel;
              var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
              var continuationCallback = callback(didUserCallbackTimeout);
              currentTime = exports2.unstable_now();
              if (typeof continuationCallback === "function") {
                currentTask.callback = continuationCallback;
              } else {
                if (currentTask === peek(taskQueue)) {
                  pop(taskQueue);
                }
              }
              advanceTimers(currentTime);
            } else {
              pop(taskQueue);
            }
            currentTask = peek(taskQueue);
          }
          if (currentTask !== null) {
            return true;
          } else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
            return false;
          }
        }
        function unstable_runWithPriority(priorityLevel, eventHandler) {
          switch (priorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
              break;
            default:
              priorityLevel = NormalPriority;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_next(eventHandler) {
          var priorityLevel;
          switch (currentPriorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
              priorityLevel = NormalPriority;
              break;
            default:
              priorityLevel = currentPriorityLevel;
              break;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_wrapCallback(callback) {
          var parentPriorityLevel = currentPriorityLevel;
          return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
              return callback.apply(this, arguments);
            } finally {
              currentPriorityLevel = previousPriorityLevel;
            }
          };
        }
        function unstable_scheduleCallback(priorityLevel, callback, options2) {
          var currentTime = exports2.unstable_now();
          var startTime2;
          if (typeof options2 === "object" && options2 !== null) {
            var delay = options2.delay;
            if (typeof delay === "number" && delay > 0) {
              startTime2 = currentTime + delay;
            } else {
              startTime2 = currentTime;
            }
          } else {
            startTime2 = currentTime;
          }
          var timeout;
          switch (priorityLevel) {
            case ImmediatePriority:
              timeout = IMMEDIATE_PRIORITY_TIMEOUT;
              break;
            case UserBlockingPriority:
              timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
              break;
            case IdlePriority:
              timeout = IDLE_PRIORITY_TIMEOUT;
              break;
            case LowPriority:
              timeout = LOW_PRIORITY_TIMEOUT;
              break;
            case NormalPriority:
            default:
              timeout = NORMAL_PRIORITY_TIMEOUT;
              break;
          }
          var expirationTime = startTime2 + timeout;
          var newTask = {
            id: taskIdCounter++,
            callback,
            priorityLevel,
            startTime: startTime2,
            expirationTime,
            sortIndex: -1
          };
          if (startTime2 > currentTime) {
            newTask.sortIndex = startTime2;
            push2(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
              if (isHostTimeoutScheduled) {
                cancelHostTimeout();
              } else {
                isHostTimeoutScheduled = true;
              }
              requestHostTimeout(handleTimeout, startTime2 - currentTime);
            }
          } else {
            newTask.sortIndex = expirationTime;
            push2(taskQueue, newTask);
            if (!isHostCallbackScheduled && !isPerformingWork) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            }
          }
          return newTask;
        }
        function unstable_pauseExecution() {
        }
        function unstable_continueExecution() {
          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }
        function unstable_getFirstCallbackNode() {
          return peek(taskQueue);
        }
        function unstable_cancelCallback(task) {
          task.callback = null;
        }
        function unstable_getCurrentPriorityLevel() {
          return currentPriorityLevel;
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1;
        var frameInterval = frameYieldMs;
        var startTime = -1;
        function shouldYieldToHost() {
          var timeElapsed = exports2.unstable_now() - startTime;
          if (timeElapsed < frameInterval) {
            return false;
          }
          return true;
        }
        function requestPaint() {
        }
        function forceFrameRate(fps) {
          if (fps < 0 || fps > 125) {
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
          }
          if (fps > 0) {
            frameInterval = Math.floor(1e3 / fps);
          } else {
            frameInterval = frameYieldMs;
          }
        }
        var performWorkUntilDeadline = function() {
          if (scheduledHostCallback !== null) {
            var currentTime = exports2.unstable_now();
            startTime = currentTime;
            var hasTimeRemaining = true;
            var hasMoreWork = true;
            try {
              hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally {
              if (hasMoreWork) {
                schedulePerformWorkUntilDeadline();
              } else {
                isMessageLoopRunning = false;
                scheduledHostCallback = null;
              }
            }
          } else {
            isMessageLoopRunning = false;
          }
        };
        var schedulePerformWorkUntilDeadline;
        if (typeof localSetImmediate === "function") {
          schedulePerformWorkUntilDeadline = function() {
            localSetImmediate(performWorkUntilDeadline);
          };
        } else if (typeof MessageChannel !== "undefined") {
          var channel = new MessageChannel();
          var port = channel.port2;
          channel.port1.onmessage = performWorkUntilDeadline;
          schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
          };
        } else {
          schedulePerformWorkUntilDeadline = function() {
            localSetTimeout(performWorkUntilDeadline, 0);
          };
        }
        function requestHostCallback(callback) {
          scheduledHostCallback = callback;
          if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
          }
        }
        function requestHostTimeout(callback, ms) {
          taskTimeoutID = localSetTimeout(function() {
            callback(exports2.unstable_now());
          }, ms);
        }
        function cancelHostTimeout() {
          localClearTimeout(taskTimeoutID);
          taskTimeoutID = -1;
        }
        var unstable_requestPaint = requestPaint;
        var unstable_Profiling = null;
        exports2.unstable_IdlePriority = IdlePriority;
        exports2.unstable_ImmediatePriority = ImmediatePriority;
        exports2.unstable_LowPriority = LowPriority;
        exports2.unstable_NormalPriority = NormalPriority;
        exports2.unstable_Profiling = unstable_Profiling;
        exports2.unstable_UserBlockingPriority = UserBlockingPriority;
        exports2.unstable_cancelCallback = unstable_cancelCallback;
        exports2.unstable_continueExecution = unstable_continueExecution;
        exports2.unstable_forceFrameRate = forceFrameRate;
        exports2.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
        exports2.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
        exports2.unstable_next = unstable_next;
        exports2.unstable_pauseExecution = unstable_pauseExecution;
        exports2.unstable_requestPaint = unstable_requestPaint;
        exports2.unstable_runWithPriority = unstable_runWithPriority;
        exports2.unstable_scheduleCallback = unstable_scheduleCallback;
        exports2.unstable_shouldYield = shouldYieldToHost;
        exports2.unstable_wrapCallback = unstable_wrapCallback;
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
        }
      })();
    }
  })(scheduler_development);
  return scheduler_development;
}
(function(module2) {
  if (process.env.NODE_ENV === "production") {
    module2.exports = requireScheduler_production_min();
  } else {
    module2.exports = requireScheduler_development();
  }
})(scheduler);
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var reactReconciler_production_min;
var hasRequiredReactReconciler_production_min;
function requireReactReconciler_production_min() {
  if (hasRequiredReactReconciler_production_min)
    return reactReconciler_production_min;
  hasRequiredReactReconciler_production_min = 1;
  reactReconciler_production_min = function $$$reconciler($$$hostConfig) {
    var exports2 = {};
    var aa2 = React__default, ba2 = schedulerExports, ca2 = Object.assign;
    function n2(a2) {
      for (var b2 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a2, c2 = 1; c2 < arguments.length; c2++)
        b2 += "&args[]=" + encodeURIComponent(arguments[c2]);
      return "Minified React error #" + a2 + "; visit " + b2 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var ea = aa2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, fa = Symbol.for("react.element"), ha = Symbol.for("react.portal"), ia = Symbol.for("react.fragment"), ja = Symbol.for("react.strict_mode"), ka = Symbol.for("react.profiler"), la = Symbol.for("react.provider"), ma = Symbol.for("react.context"), na = Symbol.for("react.forward_ref"), oa = Symbol.for("react.suspense"), pa = Symbol.for("react.suspense_list"), qa = Symbol.for("react.memo"), ra = Symbol.for("react.lazy");
    var sa = Symbol.for("react.offscreen");
    var ta = Symbol.iterator;
    function ua(a2) {
      if (null === a2 || "object" !== typeof a2)
        return null;
      a2 = ta && a2[ta] || a2["@@iterator"];
      return "function" === typeof a2 ? a2 : null;
    }
    function va(a2) {
      if (null == a2)
        return null;
      if ("function" === typeof a2)
        return a2.displayName || a2.name || null;
      if ("string" === typeof a2)
        return a2;
      switch (a2) {
        case ia:
          return "Fragment";
        case ha:
          return "Portal";
        case ka:
          return "Profiler";
        case ja:
          return "StrictMode";
        case oa:
          return "Suspense";
        case pa:
          return "SuspenseList";
      }
      if ("object" === typeof a2)
        switch (a2.$$typeof) {
          case ma:
            return (a2.displayName || "Context") + ".Consumer";
          case la:
            return (a2._context.displayName || "Context") + ".Provider";
          case na:
            var b2 = a2.render;
            a2 = a2.displayName;
            a2 || (a2 = b2.displayName || b2.name || "", a2 = "" !== a2 ? "ForwardRef(" + a2 + ")" : "ForwardRef");
            return a2;
          case qa:
            return b2 = a2.displayName || null, null !== b2 ? b2 : va(a2.type) || "Memo";
          case ra:
            b2 = a2._payload;
            a2 = a2._init;
            try {
              return va(a2(b2));
            } catch (c2) {
            }
        }
      return null;
    }
    function xa(a2) {
      var b2 = a2.type;
      switch (a2.tag) {
        case 24:
          return "Cache";
        case 9:
          return (b2.displayName || "Context") + ".Consumer";
        case 10:
          return (b2._context.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return a2 = b2.render, a2 = a2.displayName || a2.name || "", b2.displayName || ("" !== a2 ? "ForwardRef(" + a2 + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 5:
          return b2;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return va(b2);
        case 8:
          return b2 === ja ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
          if ("function" === typeof b2)
            return b2.displayName || b2.name || null;
          if ("string" === typeof b2)
            return b2;
      }
      return null;
    }
    function ya(a2) {
      var b2 = a2, c2 = a2;
      if (a2.alternate)
        for (; b2.return; )
          b2 = b2.return;
      else {
        a2 = b2;
        do
          b2 = a2, 0 !== (b2.flags & 4098) && (c2 = b2.return), a2 = b2.return;
        while (a2);
      }
      return 3 === b2.tag ? c2 : null;
    }
    function za(a2) {
      if (ya(a2) !== a2)
        throw Error(n2(188));
    }
    function Aa(a2) {
      var b2 = a2.alternate;
      if (!b2) {
        b2 = ya(a2);
        if (null === b2)
          throw Error(n2(188));
        return b2 !== a2 ? null : a2;
      }
      for (var c2 = a2, d2 = b2; ; ) {
        var e3 = c2.return;
        if (null === e3)
          break;
        var f2 = e3.alternate;
        if (null === f2) {
          d2 = e3.return;
          if (null !== d2) {
            c2 = d2;
            continue;
          }
          break;
        }
        if (e3.child === f2.child) {
          for (f2 = e3.child; f2; ) {
            if (f2 === c2)
              return za(e3), a2;
            if (f2 === d2)
              return za(e3), b2;
            f2 = f2.sibling;
          }
          throw Error(n2(188));
        }
        if (c2.return !== d2.return)
          c2 = e3, d2 = f2;
        else {
          for (var g2 = false, h2 = e3.child; h2; ) {
            if (h2 === c2) {
              g2 = true;
              c2 = e3;
              d2 = f2;
              break;
            }
            if (h2 === d2) {
              g2 = true;
              d2 = e3;
              c2 = f2;
              break;
            }
            h2 = h2.sibling;
          }
          if (!g2) {
            for (h2 = f2.child; h2; ) {
              if (h2 === c2) {
                g2 = true;
                c2 = f2;
                d2 = e3;
                break;
              }
              if (h2 === d2) {
                g2 = true;
                d2 = f2;
                c2 = e3;
                break;
              }
              h2 = h2.sibling;
            }
            if (!g2)
              throw Error(n2(189));
          }
        }
        if (c2.alternate !== d2)
          throw Error(n2(190));
      }
      if (3 !== c2.tag)
        throw Error(n2(188));
      return c2.stateNode.current === c2 ? a2 : b2;
    }
    function Ba(a2) {
      a2 = Aa(a2);
      return null !== a2 ? Ca(a2) : null;
    }
    function Ca(a2) {
      if (5 === a2.tag || 6 === a2.tag)
        return a2;
      for (a2 = a2.child; null !== a2; ) {
        var b2 = Ca(a2);
        if (null !== b2)
          return b2;
        a2 = a2.sibling;
      }
      return null;
    }
    function Da(a2) {
      if (5 === a2.tag || 6 === a2.tag)
        return a2;
      for (a2 = a2.child; null !== a2; ) {
        if (4 !== a2.tag) {
          var b2 = Da(a2);
          if (null !== b2)
            return b2;
        }
        a2 = a2.sibling;
      }
      return null;
    }
    var Ea = Array.isArray, Fa = $$$hostConfig.getPublicInstance, Ga = $$$hostConfig.getRootHostContext, Ha = $$$hostConfig.getChildHostContext, Ia = $$$hostConfig.prepareForCommit, Ja = $$$hostConfig.resetAfterCommit, Ka = $$$hostConfig.createInstance, La = $$$hostConfig.appendInitialChild, Ma = $$$hostConfig.finalizeInitialChildren, Na = $$$hostConfig.prepareUpdate, Oa = $$$hostConfig.shouldSetTextContent, Pa = $$$hostConfig.createTextInstance, Qa = $$$hostConfig.scheduleTimeout, Ra = $$$hostConfig.cancelTimeout, Sa = $$$hostConfig.noTimeout, Ta = $$$hostConfig.isPrimaryRenderer, Ua = $$$hostConfig.supportsMutation, Va = $$$hostConfig.supportsPersistence, p2 = $$$hostConfig.supportsHydration, Wa = $$$hostConfig.getInstanceFromNode, Xa = $$$hostConfig.preparePortalMount, Ya = $$$hostConfig.getCurrentEventPriority, Za = $$$hostConfig.detachDeletedInstance, $a = $$$hostConfig.supportsMicrotasks, ab2 = $$$hostConfig.scheduleMicrotask, bb2 = $$$hostConfig.supportsTestSelectors, cb2 = $$$hostConfig.findFiberRoot, db = $$$hostConfig.getBoundingRect, eb = $$$hostConfig.getTextContent, fb = $$$hostConfig.isHiddenSubtree, gb = $$$hostConfig.matchAccessibilityRole, hb = $$$hostConfig.setFocusIfFocusable, ib = $$$hostConfig.setupIntersectionObserver, jb = $$$hostConfig.appendChild, kb = $$$hostConfig.appendChildToContainer, lb = $$$hostConfig.commitTextUpdate, mb = $$$hostConfig.commitMount, nb = $$$hostConfig.commitUpdate, ob = $$$hostConfig.insertBefore, pb = $$$hostConfig.insertInContainerBefore, qb = $$$hostConfig.removeChild, rb = $$$hostConfig.removeChildFromContainer, sb = $$$hostConfig.resetTextContent, tb = $$$hostConfig.hideInstance, ub = $$$hostConfig.hideTextInstance, vb = $$$hostConfig.unhideInstance, wb = $$$hostConfig.unhideTextInstance, xb = $$$hostConfig.clearContainer, yb = $$$hostConfig.cloneInstance, zb = $$$hostConfig.createContainerChildSet, Ab = $$$hostConfig.appendChildToContainerChildSet, Bb = $$$hostConfig.finalizeContainerChildren, Cb = $$$hostConfig.replaceContainerChildren, Db = $$$hostConfig.cloneHiddenInstance, Eb = $$$hostConfig.cloneHiddenTextInstance, Fb = $$$hostConfig.canHydrateInstance, Gb = $$$hostConfig.canHydrateTextInstance, Hb = $$$hostConfig.canHydrateSuspenseInstance, Ib = $$$hostConfig.isSuspenseInstancePending, Jb = $$$hostConfig.isSuspenseInstanceFallback, Kb = $$$hostConfig.registerSuspenseInstanceRetry, Lb = $$$hostConfig.getNextHydratableSibling, Mb = $$$hostConfig.getFirstHydratableChild, Nb = $$$hostConfig.getFirstHydratableChildWithinContainer, Ob = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance, Pb = $$$hostConfig.hydrateInstance, Qb = $$$hostConfig.hydrateTextInstance, Rb = $$$hostConfig.hydrateSuspenseInstance, Sb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, Tb = $$$hostConfig.commitHydratedContainer, Ub = $$$hostConfig.commitHydratedSuspenseInstance, Vb = $$$hostConfig.clearSuspenseBoundary, Wb = $$$hostConfig.clearSuspenseBoundaryFromContainer, Xb = $$$hostConfig.shouldDeleteUnhydratedTailInstances, Yb = $$$hostConfig.didNotMatchHydratedContainerTextInstance, Zb = $$$hostConfig.didNotMatchHydratedTextInstance, $b;
    function ac2(a2) {
      if (void 0 === $b)
        try {
          throw Error();
        } catch (c2) {
          var b2 = c2.stack.trim().match(/\n( *(at )?)/);
          $b = b2 && b2[1] || "";
        }
      return "\n" + $b + a2;
    }
    var bc2 = false;
    function cc2(a2, b2) {
      if (!a2 || bc2)
        return "";
      bc2 = true;
      var c2 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (b2)
          if (b2 = function() {
            throw Error();
          }, Object.defineProperty(b2.prototype, "props", { set: function() {
            throw Error();
          } }), "object" === typeof Reflect && Reflect.construct) {
            try {
              Reflect.construct(b2, []);
            } catch (l2) {
              var d2 = l2;
            }
            Reflect.construct(a2, [], b2);
          } else {
            try {
              b2.call();
            } catch (l2) {
              d2 = l2;
            }
            a2.call(b2.prototype);
          }
        else {
          try {
            throw Error();
          } catch (l2) {
            d2 = l2;
          }
          a2();
        }
      } catch (l2) {
        if (l2 && d2 && "string" === typeof l2.stack) {
          for (var e3 = l2.stack.split("\n"), f2 = d2.stack.split("\n"), g2 = e3.length - 1, h2 = f2.length - 1; 1 <= g2 && 0 <= h2 && e3[g2] !== f2[h2]; )
            h2--;
          for (; 1 <= g2 && 0 <= h2; g2--, h2--)
            if (e3[g2] !== f2[h2]) {
              if (1 !== g2 || 1 !== h2) {
                do
                  if (g2--, h2--, 0 > h2 || e3[g2] !== f2[h2]) {
                    var k2 = "\n" + e3[g2].replace(" at new ", " at ");
                    a2.displayName && k2.includes("<anonymous>") && (k2 = k2.replace("<anonymous>", a2.displayName));
                    return k2;
                  }
                while (1 <= g2 && 0 <= h2);
              }
              break;
            }
        }
      } finally {
        bc2 = false, Error.prepareStackTrace = c2;
      }
      return (a2 = a2 ? a2.displayName || a2.name : "") ? ac2(a2) : "";
    }
    var dc = Object.prototype.hasOwnProperty, ec = [], fc = -1;
    function gc(a2) {
      return { current: a2 };
    }
    function x2(a2) {
      0 > fc || (a2.current = ec[fc], ec[fc] = null, fc--);
    }
    function y2(a2, b2) {
      fc++;
      ec[fc] = a2.current;
      a2.current = b2;
    }
    var hc = {}, A2 = gc(hc), B2 = gc(false), ic = hc;
    function jc(a2, b2) {
      var c2 = a2.type.contextTypes;
      if (!c2)
        return hc;
      var d2 = a2.stateNode;
      if (d2 && d2.__reactInternalMemoizedUnmaskedChildContext === b2)
        return d2.__reactInternalMemoizedMaskedChildContext;
      var e3 = {}, f2;
      for (f2 in c2)
        e3[f2] = b2[f2];
      d2 && (a2 = a2.stateNode, a2.__reactInternalMemoizedUnmaskedChildContext = b2, a2.__reactInternalMemoizedMaskedChildContext = e3);
      return e3;
    }
    function C2(a2) {
      a2 = a2.childContextTypes;
      return null !== a2 && void 0 !== a2;
    }
    function kc() {
      x2(B2);
      x2(A2);
    }
    function lc(a2, b2, c2) {
      if (A2.current !== hc)
        throw Error(n2(168));
      y2(A2, b2);
      y2(B2, c2);
    }
    function mc(a2, b2, c2) {
      var d2 = a2.stateNode;
      b2 = b2.childContextTypes;
      if ("function" !== typeof d2.getChildContext)
        return c2;
      d2 = d2.getChildContext();
      for (var e3 in d2)
        if (!(e3 in b2))
          throw Error(n2(108, xa(a2) || "Unknown", e3));
      return ca2({}, c2, d2);
    }
    function nc(a2) {
      a2 = (a2 = a2.stateNode) && a2.__reactInternalMemoizedMergedChildContext || hc;
      ic = A2.current;
      y2(A2, a2);
      y2(B2, B2.current);
      return true;
    }
    function oc(a2, b2, c2) {
      var d2 = a2.stateNode;
      if (!d2)
        throw Error(n2(169));
      c2 ? (a2 = mc(a2, b2, ic), d2.__reactInternalMemoizedMergedChildContext = a2, x2(B2), x2(A2), y2(A2, a2)) : x2(B2);
      y2(B2, c2);
    }
    var qc = Math.clz32 ? Math.clz32 : pc, rc = Math.log, sc = Math.LN2;
    function pc(a2) {
      a2 >>>= 0;
      return 0 === a2 ? 32 : 31 - (rc(a2) / sc | 0) | 0;
    }
    var tc = 64, uc = 4194304;
    function vc(a2) {
      switch (a2 & -a2) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return a2 & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return a2 & 130023424;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 1073741824;
        default:
          return a2;
      }
    }
    function wc(a2, b2) {
      var c2 = a2.pendingLanes;
      if (0 === c2)
        return 0;
      var d2 = 0, e3 = a2.suspendedLanes, f2 = a2.pingedLanes, g2 = c2 & 268435455;
      if (0 !== g2) {
        var h2 = g2 & ~e3;
        0 !== h2 ? d2 = vc(h2) : (f2 &= g2, 0 !== f2 && (d2 = vc(f2)));
      } else
        g2 = c2 & ~e3, 0 !== g2 ? d2 = vc(g2) : 0 !== f2 && (d2 = vc(f2));
      if (0 === d2)
        return 0;
      if (0 !== b2 && b2 !== d2 && 0 === (b2 & e3) && (e3 = d2 & -d2, f2 = b2 & -b2, e3 >= f2 || 16 === e3 && 0 !== (f2 & 4194240)))
        return b2;
      0 !== (d2 & 4) && (d2 |= c2 & 16);
      b2 = a2.entangledLanes;
      if (0 !== b2)
        for (a2 = a2.entanglements, b2 &= d2; 0 < b2; )
          c2 = 31 - qc(b2), e3 = 1 << c2, d2 |= a2[c2], b2 &= ~e3;
      return d2;
    }
    function xc(a2, b2) {
      switch (a2) {
        case 1:
        case 2:
        case 4:
          return b2 + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return b2 + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function yc(a2, b2) {
      for (var c2 = a2.suspendedLanes, d2 = a2.pingedLanes, e3 = a2.expirationTimes, f2 = a2.pendingLanes; 0 < f2; ) {
        var g2 = 31 - qc(f2), h2 = 1 << g2, k2 = e3[g2];
        if (-1 === k2) {
          if (0 === (h2 & c2) || 0 !== (h2 & d2))
            e3[g2] = xc(h2, b2);
        } else
          k2 <= b2 && (a2.expiredLanes |= h2);
        f2 &= ~h2;
      }
    }
    function zc(a2) {
      a2 = a2.pendingLanes & -1073741825;
      return 0 !== a2 ? a2 : a2 & 1073741824 ? 1073741824 : 0;
    }
    function Ac(a2) {
      for (var b2 = [], c2 = 0; 31 > c2; c2++)
        b2.push(a2);
      return b2;
    }
    function Bc(a2, b2, c2) {
      a2.pendingLanes |= b2;
      536870912 !== b2 && (a2.suspendedLanes = 0, a2.pingedLanes = 0);
      a2 = a2.eventTimes;
      b2 = 31 - qc(b2);
      a2[b2] = c2;
    }
    function Cc(a2, b2) {
      var c2 = a2.pendingLanes & ~b2;
      a2.pendingLanes = b2;
      a2.suspendedLanes = 0;
      a2.pingedLanes = 0;
      a2.expiredLanes &= b2;
      a2.mutableReadLanes &= b2;
      a2.entangledLanes &= b2;
      b2 = a2.entanglements;
      var d2 = a2.eventTimes;
      for (a2 = a2.expirationTimes; 0 < c2; ) {
        var e3 = 31 - qc(c2), f2 = 1 << e3;
        b2[e3] = 0;
        d2[e3] = -1;
        a2[e3] = -1;
        c2 &= ~f2;
      }
    }
    function Dc(a2, b2) {
      var c2 = a2.entangledLanes |= b2;
      for (a2 = a2.entanglements; c2; ) {
        var d2 = 31 - qc(c2), e3 = 1 << d2;
        e3 & b2 | a2[d2] & b2 && (a2[d2] |= b2);
        c2 &= ~e3;
      }
    }
    var D2 = 0;
    function Ec(a2) {
      a2 &= -a2;
      return 1 < a2 ? 4 < a2 ? 0 !== (a2 & 268435455) ? 16 : 536870912 : 4 : 1;
    }
    var Fc = ba2.unstable_scheduleCallback, Gc = ba2.unstable_cancelCallback, Hc = ba2.unstable_shouldYield, Ic = ba2.unstable_requestPaint, E3 = ba2.unstable_now, Jc = ba2.unstable_ImmediatePriority, Kc = ba2.unstable_UserBlockingPriority, Lc = ba2.unstable_NormalPriority, Mc = ba2.unstable_IdlePriority, Nc = null, Oc = null;
    function Pc(a2) {
      if (Oc && "function" === typeof Oc.onCommitFiberRoot)
        try {
          Oc.onCommitFiberRoot(Nc, a2, void 0, 128 === (a2.current.flags & 128));
        } catch (b2) {
        }
    }
    function Qc(a2, b2) {
      return a2 === b2 && (0 !== a2 || 1 / a2 === 1 / b2) || a2 !== a2 && b2 !== b2;
    }
    var Rc = "function" === typeof Object.is ? Object.is : Qc, Sc = null, Tc = false, Uc = false;
    function Vc(a2) {
      null === Sc ? Sc = [a2] : Sc.push(a2);
    }
    function Wc(a2) {
      Tc = true;
      Vc(a2);
    }
    function Xc() {
      if (!Uc && null !== Sc) {
        Uc = true;
        var a2 = 0, b2 = D2;
        try {
          var c2 = Sc;
          for (D2 = 1; a2 < c2.length; a2++) {
            var d2 = c2[a2];
            do
              d2 = d2(true);
            while (null !== d2);
          }
          Sc = null;
          Tc = false;
        } catch (e3) {
          throw null !== Sc && (Sc = Sc.slice(a2 + 1)), Fc(Jc, Xc), e3;
        } finally {
          D2 = b2, Uc = false;
        }
      }
      return null;
    }
    var Yc = ea.ReactCurrentBatchConfig;
    function Zc(a2, b2) {
      if (Rc(a2, b2))
        return true;
      if ("object" !== typeof a2 || null === a2 || "object" !== typeof b2 || null === b2)
        return false;
      var c2 = Object.keys(a2), d2 = Object.keys(b2);
      if (c2.length !== d2.length)
        return false;
      for (d2 = 0; d2 < c2.length; d2++) {
        var e3 = c2[d2];
        if (!dc.call(b2, e3) || !Rc(a2[e3], b2[e3]))
          return false;
      }
      return true;
    }
    function $c(a2) {
      switch (a2.tag) {
        case 5:
          return ac2(a2.type);
        case 16:
          return ac2("Lazy");
        case 13:
          return ac2("Suspense");
        case 19:
          return ac2("SuspenseList");
        case 0:
        case 2:
        case 15:
          return a2 = cc2(a2.type, false), a2;
        case 11:
          return a2 = cc2(a2.type.render, false), a2;
        case 1:
          return a2 = cc2(a2.type, true), a2;
        default:
          return "";
      }
    }
    function ad2(a2, b2) {
      if (a2 && a2.defaultProps) {
        b2 = ca2({}, b2);
        a2 = a2.defaultProps;
        for (var c2 in a2)
          void 0 === b2[c2] && (b2[c2] = a2[c2]);
        return b2;
      }
      return b2;
    }
    var bd2 = gc(null), cd2 = null, dd = null, ed = null;
    function fd() {
      ed = dd = cd2 = null;
    }
    function gd(a2, b2, c2) {
      Ta ? (y2(bd2, b2._currentValue), b2._currentValue = c2) : (y2(bd2, b2._currentValue2), b2._currentValue2 = c2);
    }
    function hd(a2) {
      var b2 = bd2.current;
      x2(bd2);
      Ta ? a2._currentValue = b2 : a2._currentValue2 = b2;
    }
    function id(a2, b2, c2) {
      for (; null !== a2; ) {
        var d2 = a2.alternate;
        (a2.childLanes & b2) !== b2 ? (a2.childLanes |= b2, null !== d2 && (d2.childLanes |= b2)) : null !== d2 && (d2.childLanes & b2) !== b2 && (d2.childLanes |= b2);
        if (a2 === c2)
          break;
        a2 = a2.return;
      }
    }
    function jd(a2, b2) {
      cd2 = a2;
      ed = dd = null;
      a2 = a2.dependencies;
      null !== a2 && null !== a2.firstContext && (0 !== (a2.lanes & b2) && (kd = true), a2.firstContext = null);
    }
    function ld(a2) {
      var b2 = Ta ? a2._currentValue : a2._currentValue2;
      if (ed !== a2)
        if (a2 = { context: a2, memoizedValue: b2, next: null }, null === dd) {
          if (null === cd2)
            throw Error(n2(308));
          dd = a2;
          cd2.dependencies = { lanes: 0, firstContext: a2 };
        } else
          dd = dd.next = a2;
      return b2;
    }
    var md = null, nd = false;
    function od(a2) {
      a2.updateQueue = { baseState: a2.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
    }
    function pd(a2, b2) {
      a2 = a2.updateQueue;
      b2.updateQueue === a2 && (b2.updateQueue = { baseState: a2.baseState, firstBaseUpdate: a2.firstBaseUpdate, lastBaseUpdate: a2.lastBaseUpdate, shared: a2.shared, effects: a2.effects });
    }
    function qd(a2, b2) {
      return { eventTime: a2, lane: b2, tag: 0, payload: null, callback: null, next: null };
    }
    function rd(a2, b2) {
      var c2 = a2.updateQueue;
      null !== c2 && (c2 = c2.shared, null !== F2 && 0 !== (a2.mode & 1) && 0 === (G2 & 2) ? (a2 = c2.interleaved, null === a2 ? (b2.next = b2, null === md ? md = [c2] : md.push(c2)) : (b2.next = a2.next, a2.next = b2), c2.interleaved = b2) : (a2 = c2.pending, null === a2 ? b2.next = b2 : (b2.next = a2.next, a2.next = b2), c2.pending = b2));
    }
    function sd(a2, b2, c2) {
      b2 = b2.updateQueue;
      if (null !== b2 && (b2 = b2.shared, 0 !== (c2 & 4194240))) {
        var d2 = b2.lanes;
        d2 &= a2.pendingLanes;
        c2 |= d2;
        b2.lanes = c2;
        Dc(a2, c2);
      }
    }
    function td(a2, b2) {
      var c2 = a2.updateQueue, d2 = a2.alternate;
      if (null !== d2 && (d2 = d2.updateQueue, c2 === d2)) {
        var e3 = null, f2 = null;
        c2 = c2.firstBaseUpdate;
        if (null !== c2) {
          do {
            var g2 = { eventTime: c2.eventTime, lane: c2.lane, tag: c2.tag, payload: c2.payload, callback: c2.callback, next: null };
            null === f2 ? e3 = f2 = g2 : f2 = f2.next = g2;
            c2 = c2.next;
          } while (null !== c2);
          null === f2 ? e3 = f2 = b2 : f2 = f2.next = b2;
        } else
          e3 = f2 = b2;
        c2 = { baseState: d2.baseState, firstBaseUpdate: e3, lastBaseUpdate: f2, shared: d2.shared, effects: d2.effects };
        a2.updateQueue = c2;
        return;
      }
      a2 = c2.lastBaseUpdate;
      null === a2 ? c2.firstBaseUpdate = b2 : a2.next = b2;
      c2.lastBaseUpdate = b2;
    }
    function ud(a2, b2, c2, d2) {
      var e3 = a2.updateQueue;
      nd = false;
      var f2 = e3.firstBaseUpdate, g2 = e3.lastBaseUpdate, h2 = e3.shared.pending;
      if (null !== h2) {
        e3.shared.pending = null;
        var k2 = h2, l2 = k2.next;
        k2.next = null;
        null === g2 ? f2 = l2 : g2.next = l2;
        g2 = k2;
        var m2 = a2.alternate;
        null !== m2 && (m2 = m2.updateQueue, h2 = m2.lastBaseUpdate, h2 !== g2 && (null === h2 ? m2.firstBaseUpdate = l2 : h2.next = l2, m2.lastBaseUpdate = k2));
      }
      if (null !== f2) {
        var v5 = e3.baseState;
        g2 = 0;
        m2 = l2 = k2 = null;
        h2 = f2;
        do {
          var r2 = h2.lane, z2 = h2.eventTime;
          if ((d2 & r2) === r2) {
            null !== m2 && (m2 = m2.next = {
              eventTime: z2,
              lane: 0,
              tag: h2.tag,
              payload: h2.payload,
              callback: h2.callback,
              next: null
            });
            a: {
              var q2 = a2, N2 = h2;
              r2 = b2;
              z2 = c2;
              switch (N2.tag) {
                case 1:
                  q2 = N2.payload;
                  if ("function" === typeof q2) {
                    v5 = q2.call(z2, v5, r2);
                    break a;
                  }
                  v5 = q2;
                  break a;
                case 3:
                  q2.flags = q2.flags & -65537 | 128;
                case 0:
                  q2 = N2.payload;
                  r2 = "function" === typeof q2 ? q2.call(z2, v5, r2) : q2;
                  if (null === r2 || void 0 === r2)
                    break a;
                  v5 = ca2({}, v5, r2);
                  break a;
                case 2:
                  nd = true;
              }
            }
            null !== h2.callback && 0 !== h2.lane && (a2.flags |= 64, r2 = e3.effects, null === r2 ? e3.effects = [h2] : r2.push(h2));
          } else
            z2 = { eventTime: z2, lane: r2, tag: h2.tag, payload: h2.payload, callback: h2.callback, next: null }, null === m2 ? (l2 = m2 = z2, k2 = v5) : m2 = m2.next = z2, g2 |= r2;
          h2 = h2.next;
          if (null === h2)
            if (h2 = e3.shared.pending, null === h2)
              break;
            else
              r2 = h2, h2 = r2.next, r2.next = null, e3.lastBaseUpdate = r2, e3.shared.pending = null;
        } while (1);
        null === m2 && (k2 = v5);
        e3.baseState = k2;
        e3.firstBaseUpdate = l2;
        e3.lastBaseUpdate = m2;
        b2 = e3.shared.interleaved;
        if (null !== b2) {
          e3 = b2;
          do
            g2 |= e3.lane, e3 = e3.next;
          while (e3 !== b2);
        } else
          null === f2 && (e3.shared.lanes = 0);
        vd |= g2;
        a2.lanes = g2;
        a2.memoizedState = v5;
      }
    }
    function wd(a2, b2, c2) {
      a2 = b2.effects;
      b2.effects = null;
      if (null !== a2)
        for (b2 = 0; b2 < a2.length; b2++) {
          var d2 = a2[b2], e3 = d2.callback;
          if (null !== e3) {
            d2.callback = null;
            d2 = c2;
            if ("function" !== typeof e3)
              throw Error(n2(191, e3));
            e3.call(d2);
          }
        }
    }
    var xd = new aa2.Component().refs;
    function yd(a2, b2, c2, d2) {
      b2 = a2.memoizedState;
      c2 = c2(d2, b2);
      c2 = null === c2 || void 0 === c2 ? b2 : ca2({}, b2, c2);
      a2.memoizedState = c2;
      0 === a2.lanes && (a2.updateQueue.baseState = c2);
    }
    var Bd = { isMounted: function(a2) {
      return (a2 = a2._reactInternals) ? ya(a2) === a2 : false;
    }, enqueueSetState: function(a2, b2, c2) {
      a2 = a2._reactInternals;
      var d2 = H2(), e3 = zd(a2), f2 = qd(d2, e3);
      f2.payload = b2;
      void 0 !== c2 && null !== c2 && (f2.callback = c2);
      rd(a2, f2);
      b2 = Ad(a2, e3, d2);
      null !== b2 && sd(b2, a2, e3);
    }, enqueueReplaceState: function(a2, b2, c2) {
      a2 = a2._reactInternals;
      var d2 = H2(), e3 = zd(a2), f2 = qd(d2, e3);
      f2.tag = 1;
      f2.payload = b2;
      void 0 !== c2 && null !== c2 && (f2.callback = c2);
      rd(a2, f2);
      b2 = Ad(a2, e3, d2);
      null !== b2 && sd(b2, a2, e3);
    }, enqueueForceUpdate: function(a2, b2) {
      a2 = a2._reactInternals;
      var c2 = H2(), d2 = zd(a2), e3 = qd(
        c2,
        d2
      );
      e3.tag = 2;
      void 0 !== b2 && null !== b2 && (e3.callback = b2);
      rd(a2, e3);
      b2 = Ad(a2, d2, c2);
      null !== b2 && sd(b2, a2, d2);
    } };
    function Cd(a2, b2, c2, d2, e3, f2, g2) {
      a2 = a2.stateNode;
      return "function" === typeof a2.shouldComponentUpdate ? a2.shouldComponentUpdate(d2, f2, g2) : b2.prototype && b2.prototype.isPureReactComponent ? !Zc(c2, d2) || !Zc(e3, f2) : true;
    }
    function Dd(a2, b2, c2) {
      var d2 = false, e3 = hc;
      var f2 = b2.contextType;
      "object" === typeof f2 && null !== f2 ? f2 = ld(f2) : (e3 = C2(b2) ? ic : A2.current, d2 = b2.contextTypes, f2 = (d2 = null !== d2 && void 0 !== d2) ? jc(a2, e3) : hc);
      b2 = new b2(c2, f2);
      a2.memoizedState = null !== b2.state && void 0 !== b2.state ? b2.state : null;
      b2.updater = Bd;
      a2.stateNode = b2;
      b2._reactInternals = a2;
      d2 && (a2 = a2.stateNode, a2.__reactInternalMemoizedUnmaskedChildContext = e3, a2.__reactInternalMemoizedMaskedChildContext = f2);
      return b2;
    }
    function Ed(a2, b2, c2, d2) {
      a2 = b2.state;
      "function" === typeof b2.componentWillReceiveProps && b2.componentWillReceiveProps(c2, d2);
      "function" === typeof b2.UNSAFE_componentWillReceiveProps && b2.UNSAFE_componentWillReceiveProps(c2, d2);
      b2.state !== a2 && Bd.enqueueReplaceState(b2, b2.state, null);
    }
    function Fd(a2, b2, c2, d2) {
      var e3 = a2.stateNode;
      e3.props = c2;
      e3.state = a2.memoizedState;
      e3.refs = xd;
      od(a2);
      var f2 = b2.contextType;
      "object" === typeof f2 && null !== f2 ? e3.context = ld(f2) : (f2 = C2(b2) ? ic : A2.current, e3.context = jc(a2, f2));
      e3.state = a2.memoizedState;
      f2 = b2.getDerivedStateFromProps;
      "function" === typeof f2 && (yd(a2, b2, f2, c2), e3.state = a2.memoizedState);
      "function" === typeof b2.getDerivedStateFromProps || "function" === typeof e3.getSnapshotBeforeUpdate || "function" !== typeof e3.UNSAFE_componentWillMount && "function" !== typeof e3.componentWillMount || (b2 = e3.state, "function" === typeof e3.componentWillMount && e3.componentWillMount(), "function" === typeof e3.UNSAFE_componentWillMount && e3.UNSAFE_componentWillMount(), b2 !== e3.state && Bd.enqueueReplaceState(e3, e3.state, null), ud(a2, c2, e3, d2), e3.state = a2.memoizedState);
      "function" === typeof e3.componentDidMount && (a2.flags |= 4194308);
    }
    var Gd = [], Hd = 0, Id = null, Jd = 0, Kd = [], Ld = 0, Md = null, Nd = 1, Od = "";
    function Pd(a2, b2) {
      Gd[Hd++] = Jd;
      Gd[Hd++] = Id;
      Id = a2;
      Jd = b2;
    }
    function Qd(a2, b2, c2) {
      Kd[Ld++] = Nd;
      Kd[Ld++] = Od;
      Kd[Ld++] = Md;
      Md = a2;
      var d2 = Nd;
      a2 = Od;
      var e3 = 32 - qc(d2) - 1;
      d2 &= ~(1 << e3);
      c2 += 1;
      var f2 = 32 - qc(b2) + e3;
      if (30 < f2) {
        var g2 = e3 - e3 % 5;
        f2 = (d2 & (1 << g2) - 1).toString(32);
        d2 >>= g2;
        e3 -= g2;
        Nd = 1 << 32 - qc(b2) + e3 | c2 << e3 | d2;
        Od = f2 + a2;
      } else
        Nd = 1 << f2 | c2 << e3 | d2, Od = a2;
    }
    function Rd(a2) {
      null !== a2.return && (Pd(a2, 1), Qd(a2, 1, 0));
    }
    function Sd(a2) {
      for (; a2 === Id; )
        Id = Gd[--Hd], Gd[Hd] = null, Jd = Gd[--Hd], Gd[Hd] = null;
      for (; a2 === Md; )
        Md = Kd[--Ld], Kd[Ld] = null, Od = Kd[--Ld], Kd[Ld] = null, Nd = Kd[--Ld], Kd[Ld] = null;
    }
    var Td = null, Ud = null, I2 = false, Vd = false, Wd = null;
    function Xd(a2, b2) {
      var c2 = Yd(5, null, null, 0);
      c2.elementType = "DELETED";
      c2.stateNode = b2;
      c2.return = a2;
      b2 = a2.deletions;
      null === b2 ? (a2.deletions = [c2], a2.flags |= 16) : b2.push(c2);
    }
    function Zd(a2, b2) {
      switch (a2.tag) {
        case 5:
          return b2 = Fb(b2, a2.type, a2.pendingProps), null !== b2 ? (a2.stateNode = b2, Td = a2, Ud = Mb(b2), true) : false;
        case 6:
          return b2 = Gb(b2, a2.pendingProps), null !== b2 ? (a2.stateNode = b2, Td = a2, Ud = null, true) : false;
        case 13:
          b2 = Hb(b2);
          if (null !== b2) {
            var c2 = null !== Md ? { id: Nd, overflow: Od } : null;
            a2.memoizedState = { dehydrated: b2, treeContext: c2, retryLane: 1073741824 };
            c2 = Yd(18, null, null, 0);
            c2.stateNode = b2;
            c2.return = a2;
            a2.child = c2;
            Td = a2;
            Ud = null;
            return true;
          }
          return false;
        default:
          return false;
      }
    }
    function $d(a2) {
      return 0 !== (a2.mode & 1) && 0 === (a2.flags & 128);
    }
    function ae2(a2) {
      if (I2) {
        var b2 = Ud;
        if (b2) {
          var c2 = b2;
          if (!Zd(a2, b2)) {
            if ($d(a2))
              throw Error(n2(418));
            b2 = Lb(c2);
            var d2 = Td;
            b2 && Zd(a2, b2) ? Xd(d2, c2) : (a2.flags = a2.flags & -4097 | 2, I2 = false, Td = a2);
          }
        } else {
          if ($d(a2))
            throw Error(n2(418));
          a2.flags = a2.flags & -4097 | 2;
          I2 = false;
          Td = a2;
        }
      }
    }
    function be2(a2) {
      for (a2 = a2.return; null !== a2 && 5 !== a2.tag && 3 !== a2.tag && 13 !== a2.tag; )
        a2 = a2.return;
      Td = a2;
    }
    function ce2(a2) {
      if (!p2 || a2 !== Td)
        return false;
      if (!I2)
        return be2(a2), I2 = true, false;
      if (3 !== a2.tag && (5 !== a2.tag || Xb(a2.type) && !Oa(a2.type, a2.memoizedProps))) {
        var b2 = Ud;
        if (b2) {
          if ($d(a2)) {
            for (a2 = Ud; a2; )
              a2 = Lb(a2);
            throw Error(n2(418));
          }
          for (; b2; )
            Xd(a2, b2), b2 = Lb(b2);
        }
      }
      be2(a2);
      if (13 === a2.tag) {
        if (!p2)
          throw Error(n2(316));
        a2 = a2.memoizedState;
        a2 = null !== a2 ? a2.dehydrated : null;
        if (!a2)
          throw Error(n2(317));
        Ud = Sb(a2);
      } else
        Ud = Td ? Lb(a2.stateNode) : null;
      return true;
    }
    function de() {
      p2 && (Ud = Td = null, Vd = I2 = false);
    }
    function ee(a2) {
      null === Wd ? Wd = [a2] : Wd.push(a2);
    }
    function fe(a2, b2, c2) {
      a2 = c2.ref;
      if (null !== a2 && "function" !== typeof a2 && "object" !== typeof a2) {
        if (c2._owner) {
          c2 = c2._owner;
          if (c2) {
            if (1 !== c2.tag)
              throw Error(n2(309));
            var d2 = c2.stateNode;
          }
          if (!d2)
            throw Error(n2(147, a2));
          var e3 = d2, f2 = "" + a2;
          if (null !== b2 && null !== b2.ref && "function" === typeof b2.ref && b2.ref._stringRef === f2)
            return b2.ref;
          b2 = function(a3) {
            var b3 = e3.refs;
            b3 === xd && (b3 = e3.refs = {});
            null === a3 ? delete b3[f2] : b3[f2] = a3;
          };
          b2._stringRef = f2;
          return b2;
        }
        if ("string" !== typeof a2)
          throw Error(n2(284));
        if (!c2._owner)
          throw Error(n2(290, a2));
      }
      return a2;
    }
    function ge2(a2, b2) {
      a2 = Object.prototype.toString.call(b2);
      throw Error(n2(31, "[object Object]" === a2 ? "object with keys {" + Object.keys(b2).join(", ") + "}" : a2));
    }
    function he(a2) {
      var b2 = a2._init;
      return b2(a2._payload);
    }
    function ie(a2) {
      function b2(b3, c3) {
        if (a2) {
          var d3 = b3.deletions;
          null === d3 ? (b3.deletions = [c3], b3.flags |= 16) : d3.push(c3);
        }
      }
      function c2(c3, d3) {
        if (!a2)
          return null;
        for (; null !== d3; )
          b2(c3, d3), d3 = d3.sibling;
        return null;
      }
      function d2(a3, b3) {
        for (a3 = /* @__PURE__ */ new Map(); null !== b3; )
          null !== b3.key ? a3.set(b3.key, b3) : a3.set(b3.index, b3), b3 = b3.sibling;
        return a3;
      }
      function e3(a3, b3) {
        a3 = je(a3, b3);
        a3.index = 0;
        a3.sibling = null;
        return a3;
      }
      function f2(b3, c3, d3) {
        b3.index = d3;
        if (!a2)
          return b3.flags |= 1048576, c3;
        d3 = b3.alternate;
        if (null !== d3)
          return d3 = d3.index, d3 < c3 ? (b3.flags |= 2, c3) : d3;
        b3.flags |= 2;
        return c3;
      }
      function g2(b3) {
        a2 && null === b3.alternate && (b3.flags |= 2);
        return b3;
      }
      function h2(a3, b3, c3, d3) {
        if (null === b3 || 6 !== b3.tag)
          return b3 = ke(c3, a3.mode, d3), b3.return = a3, b3;
        b3 = e3(b3, c3);
        b3.return = a3;
        return b3;
      }
      function k2(a3, b3, c3, d3) {
        var f3 = c3.type;
        if (f3 === ia)
          return m2(a3, b3, c3.props.children, d3, c3.key);
        if (null !== b3 && (b3.elementType === f3 || "object" === typeof f3 && null !== f3 && f3.$$typeof === ra && he(f3) === b3.type))
          return d3 = e3(b3, c3.props), d3.ref = fe(a3, b3, c3), d3.return = a3, d3;
        d3 = le2(c3.type, c3.key, c3.props, null, a3.mode, d3);
        d3.ref = fe(a3, b3, c3);
        d3.return = a3;
        return d3;
      }
      function l2(a3, b3, c3, d3) {
        if (null === b3 || 4 !== b3.tag || b3.stateNode.containerInfo !== c3.containerInfo || b3.stateNode.implementation !== c3.implementation)
          return b3 = me(c3, a3.mode, d3), b3.return = a3, b3;
        b3 = e3(b3, c3.children || []);
        b3.return = a3;
        return b3;
      }
      function m2(a3, b3, c3, d3, f3) {
        if (null === b3 || 7 !== b3.tag)
          return b3 = ne(c3, a3.mode, d3, f3), b3.return = a3, b3;
        b3 = e3(b3, c3);
        b3.return = a3;
        return b3;
      }
      function v5(a3, b3, c3) {
        if ("string" === typeof b3 && "" !== b3 || "number" === typeof b3)
          return b3 = ke("" + b3, a3.mode, c3), b3.return = a3, b3;
        if ("object" === typeof b3 && null !== b3) {
          switch (b3.$$typeof) {
            case fa:
              return c3 = le2(b3.type, b3.key, b3.props, null, a3.mode, c3), c3.ref = fe(a3, null, b3), c3.return = a3, c3;
            case ha:
              return b3 = me(b3, a3.mode, c3), b3.return = a3, b3;
            case ra:
              var d3 = b3._init;
              return v5(a3, d3(b3._payload), c3);
          }
          if (Ea(b3) || ua(b3))
            return b3 = ne(b3, a3.mode, c3, null), b3.return = a3, b3;
          ge2(a3, b3);
        }
        return null;
      }
      function r2(a3, b3, c3, d3) {
        var e4 = null !== b3 ? b3.key : null;
        if ("string" === typeof c3 && "" !== c3 || "number" === typeof c3)
          return null !== e4 ? null : h2(a3, b3, "" + c3, d3);
        if ("object" === typeof c3 && null !== c3) {
          switch (c3.$$typeof) {
            case fa:
              return c3.key === e4 ? k2(a3, b3, c3, d3) : null;
            case ha:
              return c3.key === e4 ? l2(a3, b3, c3, d3) : null;
            case ra:
              return e4 = c3._init, r2(
                a3,
                b3,
                e4(c3._payload),
                d3
              );
          }
          if (Ea(c3) || ua(c3))
            return null !== e4 ? null : m2(a3, b3, c3, d3, null);
          ge2(a3, c3);
        }
        return null;
      }
      function z2(a3, b3, c3, d3, e4) {
        if ("string" === typeof d3 && "" !== d3 || "number" === typeof d3)
          return a3 = a3.get(c3) || null, h2(b3, a3, "" + d3, e4);
        if ("object" === typeof d3 && null !== d3) {
          switch (d3.$$typeof) {
            case fa:
              return a3 = a3.get(null === d3.key ? c3 : d3.key) || null, k2(b3, a3, d3, e4);
            case ha:
              return a3 = a3.get(null === d3.key ? c3 : d3.key) || null, l2(b3, a3, d3, e4);
            case ra:
              var f3 = d3._init;
              return z2(a3, b3, c3, f3(d3._payload), e4);
          }
          if (Ea(d3) || ua(d3))
            return a3 = a3.get(c3) || null, m2(b3, a3, d3, e4, null);
          ge2(b3, d3);
        }
        return null;
      }
      function q2(e4, g3, h3, k3) {
        for (var l3 = null, m3 = null, w2 = g3, u2 = g3 = 0, t2 = null; null !== w2 && u2 < h3.length; u2++) {
          w2.index > u2 ? (t2 = w2, w2 = null) : t2 = w2.sibling;
          var q3 = r2(e4, w2, h3[u2], k3);
          if (null === q3) {
            null === w2 && (w2 = t2);
            break;
          }
          a2 && w2 && null === q3.alternate && b2(e4, w2);
          g3 = f2(q3, g3, u2);
          null === m3 ? l3 = q3 : m3.sibling = q3;
          m3 = q3;
          w2 = t2;
        }
        if (u2 === h3.length)
          return c2(e4, w2), I2 && Pd(e4, u2), l3;
        if (null === w2) {
          for (; u2 < h3.length; u2++)
            w2 = v5(e4, h3[u2], k3), null !== w2 && (g3 = f2(w2, g3, u2), null === m3 ? l3 = w2 : m3.sibling = w2, m3 = w2);
          I2 && Pd(e4, u2);
          return l3;
        }
        for (w2 = d2(e4, w2); u2 < h3.length; u2++)
          t2 = z2(w2, e4, u2, h3[u2], k3), null !== t2 && (a2 && null !== t2.alternate && w2.delete(null === t2.key ? u2 : t2.key), g3 = f2(t2, g3, u2), null === m3 ? l3 = t2 : m3.sibling = t2, m3 = t2);
        a2 && w2.forEach(function(a3) {
          return b2(e4, a3);
        });
        I2 && Pd(e4, u2);
        return l3;
      }
      function N2(e4, g3, h3, k3) {
        var l3 = ua(h3);
        if ("function" !== typeof l3)
          throw Error(n2(150));
        h3 = l3.call(h3);
        if (null == h3)
          throw Error(n2(151));
        for (var w2 = l3 = null, m3 = g3, u2 = g3 = 0, q3 = null, t2 = h3.next(); null !== m3 && !t2.done; u2++, t2 = h3.next()) {
          m3.index > u2 ? (q3 = m3, m3 = null) : q3 = m3.sibling;
          var V2 = r2(e4, m3, t2.value, k3);
          if (null === V2) {
            null === m3 && (m3 = q3);
            break;
          }
          a2 && m3 && null === V2.alternate && b2(e4, m3);
          g3 = f2(V2, g3, u2);
          null === w2 ? l3 = V2 : w2.sibling = V2;
          w2 = V2;
          m3 = q3;
        }
        if (t2.done)
          return c2(
            e4,
            m3
          ), I2 && Pd(e4, u2), l3;
        if (null === m3) {
          for (; !t2.done; u2++, t2 = h3.next())
            t2 = v5(e4, t2.value, k3), null !== t2 && (g3 = f2(t2, g3, u2), null === w2 ? l3 = t2 : w2.sibling = t2, w2 = t2);
          I2 && Pd(e4, u2);
          return l3;
        }
        for (m3 = d2(e4, m3); !t2.done; u2++, t2 = h3.next())
          t2 = z2(m3, e4, u2, t2.value, k3), null !== t2 && (a2 && null !== t2.alternate && m3.delete(null === t2.key ? u2 : t2.key), g3 = f2(t2, g3, u2), null === w2 ? l3 = t2 : w2.sibling = t2, w2 = t2);
        a2 && m3.forEach(function(a3) {
          return b2(e4, a3);
        });
        I2 && Pd(e4, u2);
        return l3;
      }
      function da(a3, d3, f3, h3) {
        "object" === typeof f3 && null !== f3 && f3.type === ia && null === f3.key && (f3 = f3.props.children);
        if ("object" === typeof f3 && null !== f3) {
          switch (f3.$$typeof) {
            case fa:
              a: {
                for (var k3 = f3.key, l3 = d3; null !== l3; ) {
                  if (l3.key === k3) {
                    k3 = f3.type;
                    if (k3 === ia) {
                      if (7 === l3.tag) {
                        c2(a3, l3.sibling);
                        d3 = e3(l3, f3.props.children);
                        d3.return = a3;
                        a3 = d3;
                        break a;
                      }
                    } else if (l3.elementType === k3 || "object" === typeof k3 && null !== k3 && k3.$$typeof === ra && he(k3) === l3.type) {
                      c2(a3, l3.sibling);
                      d3 = e3(l3, f3.props);
                      d3.ref = fe(a3, l3, f3);
                      d3.return = a3;
                      a3 = d3;
                      break a;
                    }
                    c2(a3, l3);
                    break;
                  } else
                    b2(a3, l3);
                  l3 = l3.sibling;
                }
                f3.type === ia ? (d3 = ne(f3.props.children, a3.mode, h3, f3.key), d3.return = a3, a3 = d3) : (h3 = le2(f3.type, f3.key, f3.props, null, a3.mode, h3), h3.ref = fe(a3, d3, f3), h3.return = a3, a3 = h3);
              }
              return g2(a3);
            case ha:
              a: {
                for (l3 = f3.key; null !== d3; ) {
                  if (d3.key === l3)
                    if (4 === d3.tag && d3.stateNode.containerInfo === f3.containerInfo && d3.stateNode.implementation === f3.implementation) {
                      c2(a3, d3.sibling);
                      d3 = e3(d3, f3.children || []);
                      d3.return = a3;
                      a3 = d3;
                      break a;
                    } else {
                      c2(a3, d3);
                      break;
                    }
                  else
                    b2(a3, d3);
                  d3 = d3.sibling;
                }
                d3 = me(f3, a3.mode, h3);
                d3.return = a3;
                a3 = d3;
              }
              return g2(a3);
            case ra:
              return l3 = f3._init, da(a3, d3, l3(f3._payload), h3);
          }
          if (Ea(f3))
            return q2(a3, d3, f3, h3);
          if (ua(f3))
            return N2(a3, d3, f3, h3);
          ge2(a3, f3);
        }
        return "string" === typeof f3 && "" !== f3 || "number" === typeof f3 ? (f3 = "" + f3, null !== d3 && 6 === d3.tag ? (c2(a3, d3.sibling), d3 = e3(d3, f3), d3.return = a3, a3 = d3) : (c2(a3, d3), d3 = ke(f3, a3.mode, h3), d3.return = a3, a3 = d3), g2(a3)) : c2(a3, d3);
      }
      return da;
    }
    var oe = ie(true), pe = ie(false), qe = {}, re = gc(qe), se = gc(qe), te = gc(qe);
    function ue(a2) {
      if (a2 === qe)
        throw Error(n2(174));
      return a2;
    }
    function ve(a2, b2) {
      y2(te, b2);
      y2(se, a2);
      y2(re, qe);
      a2 = Ga(b2);
      x2(re);
      y2(re, a2);
    }
    function we() {
      x2(re);
      x2(se);
      x2(te);
    }
    function xe(a2) {
      var b2 = ue(te.current), c2 = ue(re.current);
      b2 = Ha(c2, a2.type, b2);
      c2 !== b2 && (y2(se, a2), y2(re, b2));
    }
    function ye(a2) {
      se.current === a2 && (x2(re), x2(se));
    }
    var J2 = gc(0);
    function ze(a2) {
      for (var b2 = a2; null !== b2; ) {
        if (13 === b2.tag) {
          var c2 = b2.memoizedState;
          if (null !== c2 && (c2 = c2.dehydrated, null === c2 || Ib(c2) || Jb(c2)))
            return b2;
        } else if (19 === b2.tag && void 0 !== b2.memoizedProps.revealOrder) {
          if (0 !== (b2.flags & 128))
            return b2;
        } else if (null !== b2.child) {
          b2.child.return = b2;
          b2 = b2.child;
          continue;
        }
        if (b2 === a2)
          break;
        for (; null === b2.sibling; ) {
          if (null === b2.return || b2.return === a2)
            return null;
          b2 = b2.return;
        }
        b2.sibling.return = b2.return;
        b2 = b2.sibling;
      }
      return null;
    }
    var Ae = [];
    function Be() {
      for (var a2 = 0; a2 < Ae.length; a2++) {
        var b2 = Ae[a2];
        Ta ? b2._workInProgressVersionPrimary = null : b2._workInProgressVersionSecondary = null;
      }
      Ae.length = 0;
    }
    var Ce = ea.ReactCurrentDispatcher, De = ea.ReactCurrentBatchConfig, Ee = 0, K2 = null, L2 = null, M2 = null, Fe = false, Ge = false, He = 0, Ie = 0;
    function O2() {
      throw Error(n2(321));
    }
    function Je(a2, b2) {
      if (null === b2)
        return false;
      for (var c2 = 0; c2 < b2.length && c2 < a2.length; c2++)
        if (!Rc(a2[c2], b2[c2]))
          return false;
      return true;
    }
    function Ke(a2, b2, c2, d2, e3, f2) {
      Ee = f2;
      K2 = b2;
      b2.memoizedState = null;
      b2.updateQueue = null;
      b2.lanes = 0;
      Ce.current = null === a2 || null === a2.memoizedState ? Le : Me;
      a2 = c2(d2, e3);
      if (Ge) {
        f2 = 0;
        do {
          Ge = false;
          He = 0;
          if (25 <= f2)
            throw Error(n2(301));
          f2 += 1;
          M2 = L2 = null;
          b2.updateQueue = null;
          Ce.current = Ne;
          a2 = c2(d2, e3);
        } while (Ge);
      }
      Ce.current = Oe;
      b2 = null !== L2 && null !== L2.next;
      Ee = 0;
      M2 = L2 = K2 = null;
      Fe = false;
      if (b2)
        throw Error(n2(300));
      return a2;
    }
    function Pe() {
      var a2 = 0 !== He;
      He = 0;
      return a2;
    }
    function Qe() {
      var a2 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      null === M2 ? K2.memoizedState = M2 = a2 : M2 = M2.next = a2;
      return M2;
    }
    function Re() {
      if (null === L2) {
        var a2 = K2.alternate;
        a2 = null !== a2 ? a2.memoizedState : null;
      } else
        a2 = L2.next;
      var b2 = null === M2 ? K2.memoizedState : M2.next;
      if (null !== b2)
        M2 = b2, L2 = a2;
      else {
        if (null === a2)
          throw Error(n2(310));
        L2 = a2;
        a2 = { memoizedState: L2.memoizedState, baseState: L2.baseState, baseQueue: L2.baseQueue, queue: L2.queue, next: null };
        null === M2 ? K2.memoizedState = M2 = a2 : M2 = M2.next = a2;
      }
      return M2;
    }
    function Se(a2, b2) {
      return "function" === typeof b2 ? b2(a2) : b2;
    }
    function Te(a2) {
      var b2 = Re(), c2 = b2.queue;
      if (null === c2)
        throw Error(n2(311));
      c2.lastRenderedReducer = a2;
      var d2 = L2, e3 = d2.baseQueue, f2 = c2.pending;
      if (null !== f2) {
        if (null !== e3) {
          var g2 = e3.next;
          e3.next = f2.next;
          f2.next = g2;
        }
        d2.baseQueue = e3 = f2;
        c2.pending = null;
      }
      if (null !== e3) {
        f2 = e3.next;
        d2 = d2.baseState;
        var h2 = g2 = null, k2 = null, l2 = f2;
        do {
          var m2 = l2.lane;
          if ((Ee & m2) === m2)
            null !== k2 && (k2 = k2.next = { lane: 0, action: l2.action, hasEagerState: l2.hasEagerState, eagerState: l2.eagerState, next: null }), d2 = l2.hasEagerState ? l2.eagerState : a2(d2, l2.action);
          else {
            var v5 = {
              lane: m2,
              action: l2.action,
              hasEagerState: l2.hasEagerState,
              eagerState: l2.eagerState,
              next: null
            };
            null === k2 ? (h2 = k2 = v5, g2 = d2) : k2 = k2.next = v5;
            K2.lanes |= m2;
            vd |= m2;
          }
          l2 = l2.next;
        } while (null !== l2 && l2 !== f2);
        null === k2 ? g2 = d2 : k2.next = h2;
        Rc(d2, b2.memoizedState) || (kd = true);
        b2.memoizedState = d2;
        b2.baseState = g2;
        b2.baseQueue = k2;
        c2.lastRenderedState = d2;
      }
      a2 = c2.interleaved;
      if (null !== a2) {
        e3 = a2;
        do
          f2 = e3.lane, K2.lanes |= f2, vd |= f2, e3 = e3.next;
        while (e3 !== a2);
      } else
        null === e3 && (c2.lanes = 0);
      return [b2.memoizedState, c2.dispatch];
    }
    function Ue(a2) {
      var b2 = Re(), c2 = b2.queue;
      if (null === c2)
        throw Error(n2(311));
      c2.lastRenderedReducer = a2;
      var d2 = c2.dispatch, e3 = c2.pending, f2 = b2.memoizedState;
      if (null !== e3) {
        c2.pending = null;
        var g2 = e3 = e3.next;
        do
          f2 = a2(f2, g2.action), g2 = g2.next;
        while (g2 !== e3);
        Rc(f2, b2.memoizedState) || (kd = true);
        b2.memoizedState = f2;
        null === b2.baseQueue && (b2.baseState = f2);
        c2.lastRenderedState = f2;
      }
      return [f2, d2];
    }
    function Ve() {
    }
    function We(a2, b2) {
      var c2 = K2, d2 = Re(), e3 = b2(), f2 = !Rc(d2.memoizedState, e3);
      f2 && (d2.memoizedState = e3, kd = true);
      d2 = d2.queue;
      Xe(Ye.bind(null, c2, d2, a2), [a2]);
      if (d2.getSnapshot !== b2 || f2 || null !== M2 && M2.memoizedState.tag & 1) {
        c2.flags |= 2048;
        Ze(9, $e.bind(null, c2, d2, e3, b2), void 0, null);
        if (null === F2)
          throw Error(n2(349));
        0 !== (Ee & 30) || af2(c2, b2, e3);
      }
      return e3;
    }
    function af2(a2, b2, c2) {
      a2.flags |= 16384;
      a2 = { getSnapshot: b2, value: c2 };
      b2 = K2.updateQueue;
      null === b2 ? (b2 = { lastEffect: null, stores: null }, K2.updateQueue = b2, b2.stores = [a2]) : (c2 = b2.stores, null === c2 ? b2.stores = [a2] : c2.push(a2));
    }
    function $e(a2, b2, c2, d2) {
      b2.value = c2;
      b2.getSnapshot = d2;
      bf2(b2) && Ad(a2, 1, -1);
    }
    function Ye(a2, b2, c2) {
      return c2(function() {
        bf2(b2) && Ad(a2, 1, -1);
      });
    }
    function bf2(a2) {
      var b2 = a2.getSnapshot;
      a2 = a2.value;
      try {
        var c2 = b2();
        return !Rc(a2, c2);
      } catch (d2) {
        return true;
      }
    }
    function cf2(a2) {
      var b2 = Qe();
      "function" === typeof a2 && (a2 = a2());
      b2.memoizedState = b2.baseState = a2;
      a2 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Se, lastRenderedState: a2 };
      b2.queue = a2;
      a2 = a2.dispatch = df.bind(null, K2, a2);
      return [b2.memoizedState, a2];
    }
    function Ze(a2, b2, c2, d2) {
      a2 = { tag: a2, create: b2, destroy: c2, deps: d2, next: null };
      b2 = K2.updateQueue;
      null === b2 ? (b2 = { lastEffect: null, stores: null }, K2.updateQueue = b2, b2.lastEffect = a2.next = a2) : (c2 = b2.lastEffect, null === c2 ? b2.lastEffect = a2.next = a2 : (d2 = c2.next, c2.next = a2, a2.next = d2, b2.lastEffect = a2));
      return a2;
    }
    function ef() {
      return Re().memoizedState;
    }
    function ff2(a2, b2, c2, d2) {
      var e3 = Qe();
      K2.flags |= a2;
      e3.memoizedState = Ze(1 | b2, c2, void 0, void 0 === d2 ? null : d2);
    }
    function gf(a2, b2, c2, d2) {
      var e3 = Re();
      d2 = void 0 === d2 ? null : d2;
      var f2 = void 0;
      if (null !== L2) {
        var g2 = L2.memoizedState;
        f2 = g2.destroy;
        if (null !== d2 && Je(d2, g2.deps)) {
          e3.memoizedState = Ze(b2, c2, f2, d2);
          return;
        }
      }
      K2.flags |= a2;
      e3.memoizedState = Ze(1 | b2, c2, f2, d2);
    }
    function hf(a2, b2) {
      return ff2(8390656, 8, a2, b2);
    }
    function Xe(a2, b2) {
      return gf(2048, 8, a2, b2);
    }
    function jf(a2, b2) {
      return gf(4, 2, a2, b2);
    }
    function kf(a2, b2) {
      return gf(4, 4, a2, b2);
    }
    function lf(a2, b2) {
      if ("function" === typeof b2)
        return a2 = a2(), b2(a2), function() {
          b2(null);
        };
      if (null !== b2 && void 0 !== b2)
        return a2 = a2(), b2.current = a2, function() {
          b2.current = null;
        };
    }
    function mf(a2, b2, c2) {
      c2 = null !== c2 && void 0 !== c2 ? c2.concat([a2]) : null;
      return gf(4, 4, lf.bind(null, b2, a2), c2);
    }
    function nf() {
    }
    function of(a2, b2) {
      var c2 = Re();
      b2 = void 0 === b2 ? null : b2;
      var d2 = c2.memoizedState;
      if (null !== d2 && null !== b2 && Je(b2, d2[1]))
        return d2[0];
      c2.memoizedState = [a2, b2];
      return a2;
    }
    function pf(a2, b2) {
      var c2 = Re();
      b2 = void 0 === b2 ? null : b2;
      var d2 = c2.memoizedState;
      if (null !== d2 && null !== b2 && Je(b2, d2[1]))
        return d2[0];
      a2 = a2();
      c2.memoizedState = [a2, b2];
      return a2;
    }
    function qf(a2, b2) {
      var c2 = D2;
      D2 = 0 !== c2 && 4 > c2 ? c2 : 4;
      a2(true);
      var d2 = De.transition;
      De.transition = {};
      try {
        a2(false), b2();
      } finally {
        D2 = c2, De.transition = d2;
      }
    }
    function rf() {
      return Re().memoizedState;
    }
    function sf(a2, b2, c2) {
      var d2 = zd(a2);
      c2 = { lane: d2, action: c2, hasEagerState: false, eagerState: null, next: null };
      tf(a2) ? uf(b2, c2) : (vf(a2, b2, c2), c2 = H2(), a2 = Ad(a2, d2, c2), null !== a2 && wf(a2, b2, d2));
    }
    function df(a2, b2, c2) {
      var d2 = zd(a2), e3 = { lane: d2, action: c2, hasEagerState: false, eagerState: null, next: null };
      if (tf(a2))
        uf(b2, e3);
      else {
        vf(a2, b2, e3);
        var f2 = a2.alternate;
        if (0 === a2.lanes && (null === f2 || 0 === f2.lanes) && (f2 = b2.lastRenderedReducer, null !== f2))
          try {
            var g2 = b2.lastRenderedState, h2 = f2(g2, c2);
            e3.hasEagerState = true;
            e3.eagerState = h2;
            if (Rc(h2, g2))
              return;
          } catch (k2) {
          } finally {
          }
        c2 = H2();
        a2 = Ad(a2, d2, c2);
        null !== a2 && wf(a2, b2, d2);
      }
    }
    function tf(a2) {
      var b2 = a2.alternate;
      return a2 === K2 || null !== b2 && b2 === K2;
    }
    function uf(a2, b2) {
      Ge = Fe = true;
      var c2 = a2.pending;
      null === c2 ? b2.next = b2 : (b2.next = c2.next, c2.next = b2);
      a2.pending = b2;
    }
    function vf(a2, b2, c2) {
      null !== F2 && 0 !== (a2.mode & 1) && 0 === (G2 & 2) ? (a2 = b2.interleaved, null === a2 ? (c2.next = c2, null === md ? md = [b2] : md.push(b2)) : (c2.next = a2.next, a2.next = c2), b2.interleaved = c2) : (a2 = b2.pending, null === a2 ? c2.next = c2 : (c2.next = a2.next, a2.next = c2), b2.pending = c2);
    }
    function wf(a2, b2, c2) {
      if (0 !== (c2 & 4194240)) {
        var d2 = b2.lanes;
        d2 &= a2.pendingLanes;
        c2 |= d2;
        b2.lanes = c2;
        Dc(a2, c2);
      }
    }
    var Oe = { readContext: ld, useCallback: O2, useContext: O2, useEffect: O2, useImperativeHandle: O2, useInsertionEffect: O2, useLayoutEffect: O2, useMemo: O2, useReducer: O2, useRef: O2, useState: O2, useDebugValue: O2, useDeferredValue: O2, useTransition: O2, useMutableSource: O2, useSyncExternalStore: O2, useId: O2, unstable_isNewReconciler: false }, Le = { readContext: ld, useCallback: function(a2, b2) {
      Qe().memoizedState = [a2, void 0 === b2 ? null : b2];
      return a2;
    }, useContext: ld, useEffect: hf, useImperativeHandle: function(a2, b2, c2) {
      c2 = null !== c2 && void 0 !== c2 ? c2.concat([a2]) : null;
      return ff2(
        4194308,
        4,
        lf.bind(null, b2, a2),
        c2
      );
    }, useLayoutEffect: function(a2, b2) {
      return ff2(4194308, 4, a2, b2);
    }, useInsertionEffect: function(a2, b2) {
      return ff2(4, 2, a2, b2);
    }, useMemo: function(a2, b2) {
      var c2 = Qe();
      b2 = void 0 === b2 ? null : b2;
      a2 = a2();
      c2.memoizedState = [a2, b2];
      return a2;
    }, useReducer: function(a2, b2, c2) {
      var d2 = Qe();
      b2 = void 0 !== c2 ? c2(b2) : b2;
      d2.memoizedState = d2.baseState = b2;
      a2 = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: a2, lastRenderedState: b2 };
      d2.queue = a2;
      a2 = a2.dispatch = sf.bind(null, K2, a2);
      return [d2.memoizedState, a2];
    }, useRef: function(a2) {
      var b2 = Qe();
      a2 = { current: a2 };
      return b2.memoizedState = a2;
    }, useState: cf2, useDebugValue: nf, useDeferredValue: function(a2) {
      var b2 = cf2(a2), c2 = b2[0], d2 = b2[1];
      hf(function() {
        var b3 = De.transition;
        De.transition = {};
        try {
          d2(a2);
        } finally {
          De.transition = b3;
        }
      }, [a2]);
      return c2;
    }, useTransition: function() {
      var a2 = cf2(false), b2 = a2[0];
      a2 = qf.bind(null, a2[1]);
      Qe().memoizedState = a2;
      return [b2, a2];
    }, useMutableSource: function() {
    }, useSyncExternalStore: function(a2, b2, c2) {
      var d2 = K2, e3 = Qe();
      if (I2) {
        if (void 0 === c2)
          throw Error(n2(407));
        c2 = c2();
      } else {
        c2 = b2();
        if (null === F2)
          throw Error(n2(349));
        0 !== (Ee & 30) || af2(d2, b2, c2);
      }
      e3.memoizedState = c2;
      var f2 = { value: c2, getSnapshot: b2 };
      e3.queue = f2;
      hf(Ye.bind(null, d2, f2, a2), [a2]);
      d2.flags |= 2048;
      Ze(9, $e.bind(null, d2, f2, c2, b2), void 0, null);
      return c2;
    }, useId: function() {
      var a2 = Qe(), b2 = F2.identifierPrefix;
      if (I2) {
        var c2 = Od;
        var d2 = Nd;
        c2 = (d2 & ~(1 << 32 - qc(d2) - 1)).toString(32) + c2;
        b2 = ":" + b2 + "R" + c2;
        c2 = He++;
        0 < c2 && (b2 += "H" + c2.toString(32));
        b2 += ":";
      } else
        c2 = Ie++, b2 = ":" + b2 + "r" + c2.toString(32) + ":";
      return a2.memoizedState = b2;
    }, unstable_isNewReconciler: false }, Me = {
      readContext: ld,
      useCallback: of,
      useContext: ld,
      useEffect: Xe,
      useImperativeHandle: mf,
      useInsertionEffect: jf,
      useLayoutEffect: kf,
      useMemo: pf,
      useReducer: Te,
      useRef: ef,
      useState: function() {
        return Te(Se);
      },
      useDebugValue: nf,
      useDeferredValue: function(a2) {
        var b2 = Te(Se), c2 = b2[0], d2 = b2[1];
        Xe(function() {
          var b3 = De.transition;
          De.transition = {};
          try {
            d2(a2);
          } finally {
            De.transition = b3;
          }
        }, [a2]);
        return c2;
      },
      useTransition: function() {
        var a2 = Te(Se)[0], b2 = Re().memoizedState;
        return [a2, b2];
      },
      useMutableSource: Ve,
      useSyncExternalStore: We,
      useId: rf,
      unstable_isNewReconciler: false
    }, Ne = {
      readContext: ld,
      useCallback: of,
      useContext: ld,
      useEffect: Xe,
      useImperativeHandle: mf,
      useInsertionEffect: jf,
      useLayoutEffect: kf,
      useMemo: pf,
      useReducer: Ue,
      useRef: ef,
      useState: function() {
        return Ue(Se);
      },
      useDebugValue: nf,
      useDeferredValue: function(a2) {
        var b2 = Ue(Se), c2 = b2[0], d2 = b2[1];
        Xe(function() {
          var b3 = De.transition;
          De.transition = {};
          try {
            d2(a2);
          } finally {
            De.transition = b3;
          }
        }, [a2]);
        return c2;
      },
      useTransition: function() {
        var a2 = Ue(Se)[0], b2 = Re().memoizedState;
        return [a2, b2];
      },
      useMutableSource: Ve,
      useSyncExternalStore: We,
      useId: rf,
      unstable_isNewReconciler: false
    };
    function xf(a2, b2) {
      try {
        var c2 = "", d2 = b2;
        do
          c2 += $c(d2), d2 = d2.return;
        while (d2);
        var e3 = c2;
      } catch (f2) {
        e3 = "\nError generating stack: " + f2.message + "\n" + f2.stack;
      }
      return { value: a2, source: b2, stack: e3 };
    }
    function yf(a2, b2) {
      try {
        console.error(b2.value);
      } catch (c2) {
        setTimeout(function() {
          throw c2;
        });
      }
    }
    var zf = "function" === typeof WeakMap ? WeakMap : Map;
    function Af(a2, b2, c2) {
      c2 = qd(-1, c2);
      c2.tag = 3;
      c2.payload = { element: null };
      var d2 = b2.value;
      c2.callback = function() {
        Bf || (Bf = true, Cf = d2);
        yf(a2, b2);
      };
      return c2;
    }
    function Df(a2, b2, c2) {
      c2 = qd(-1, c2);
      c2.tag = 3;
      var d2 = a2.type.getDerivedStateFromError;
      if ("function" === typeof d2) {
        var e3 = b2.value;
        c2.payload = function() {
          return d2(e3);
        };
        c2.callback = function() {
          yf(a2, b2);
        };
      }
      var f2 = a2.stateNode;
      null !== f2 && "function" === typeof f2.componentDidCatch && (c2.callback = function() {
        yf(a2, b2);
        "function" !== typeof d2 && (null === Ef ? Ef = /* @__PURE__ */ new Set([this]) : Ef.add(this));
        var c3 = b2.stack;
        this.componentDidCatch(b2.value, { componentStack: null !== c3 ? c3 : "" });
      });
      return c2;
    }
    function Ff(a2, b2, c2) {
      var d2 = a2.pingCache;
      if (null === d2) {
        d2 = a2.pingCache = new zf();
        var e3 = /* @__PURE__ */ new Set();
        d2.set(b2, e3);
      } else
        e3 = d2.get(b2), void 0 === e3 && (e3 = /* @__PURE__ */ new Set(), d2.set(b2, e3));
      e3.has(c2) || (e3.add(c2), a2 = Gf.bind(null, a2, b2, c2), b2.then(a2, a2));
    }
    function Hf(a2) {
      do {
        var b2;
        if (b2 = 13 === a2.tag)
          b2 = a2.memoizedState, b2 = null !== b2 ? null !== b2.dehydrated ? true : false : true;
        if (b2)
          return a2;
        a2 = a2.return;
      } while (null !== a2);
      return null;
    }
    function If2(a2, b2, c2, d2, e3) {
      if (0 === (a2.mode & 1))
        return a2 === b2 ? a2.flags |= 65536 : (a2.flags |= 128, c2.flags |= 131072, c2.flags &= -52805, 1 === c2.tag && (null === c2.alternate ? c2.tag = 17 : (b2 = qd(-1, 1), b2.tag = 2, rd(c2, b2))), c2.lanes |= 1), a2;
      a2.flags |= 65536;
      a2.lanes = e3;
      return a2;
    }
    function Jf(a2) {
      a2.flags |= 4;
    }
    function Kf(a2, b2) {
      if (null !== a2 && a2.child === b2.child)
        return true;
      if (0 !== (b2.flags & 16))
        return false;
      for (a2 = b2.child; null !== a2; ) {
        if (0 !== (a2.flags & 12854) || 0 !== (a2.subtreeFlags & 12854))
          return false;
        a2 = a2.sibling;
      }
      return true;
    }
    var Lf, Mf, Nf, Of;
    if (Ua)
      Lf = function(a2, b2) {
        for (var c2 = b2.child; null !== c2; ) {
          if (5 === c2.tag || 6 === c2.tag)
            La(a2, c2.stateNode);
          else if (4 !== c2.tag && null !== c2.child) {
            c2.child.return = c2;
            c2 = c2.child;
            continue;
          }
          if (c2 === b2)
            break;
          for (; null === c2.sibling; ) {
            if (null === c2.return || c2.return === b2)
              return;
            c2 = c2.return;
          }
          c2.sibling.return = c2.return;
          c2 = c2.sibling;
        }
      }, Mf = function() {
      }, Nf = function(a2, b2, c2, d2, e3) {
        a2 = a2.memoizedProps;
        if (a2 !== d2) {
          var f2 = b2.stateNode, g2 = ue(re.current);
          c2 = Na(f2, c2, a2, d2, e3, g2);
          (b2.updateQueue = c2) && Jf(b2);
        }
      }, Of = function(a2, b2, c2, d2) {
        c2 !== d2 && Jf(b2);
      };
    else if (Va) {
      Lf = function(a2, b2, c2, d2) {
        for (var e3 = b2.child; null !== e3; ) {
          if (5 === e3.tag) {
            var f2 = e3.stateNode;
            c2 && d2 && (f2 = Db(f2, e3.type, e3.memoizedProps, e3));
            La(a2, f2);
          } else if (6 === e3.tag)
            f2 = e3.stateNode, c2 && d2 && (f2 = Eb(f2, e3.memoizedProps, e3)), La(a2, f2);
          else if (4 !== e3.tag) {
            if (22 === e3.tag && null !== e3.memoizedState)
              f2 = e3.child, null !== f2 && (f2.return = e3), Lf(a2, e3, true, true);
            else if (null !== e3.child) {
              e3.child.return = e3;
              e3 = e3.child;
              continue;
            }
          }
          if (e3 === b2)
            break;
          for (; null === e3.sibling; ) {
            if (null === e3.return || e3.return === b2)
              return;
            e3 = e3.return;
          }
          e3.sibling.return = e3.return;
          e3 = e3.sibling;
        }
      };
      var Pf = function(a2, b2, c2, d2) {
        for (var e3 = b2.child; null !== e3; ) {
          if (5 === e3.tag) {
            var f2 = e3.stateNode;
            c2 && d2 && (f2 = Db(f2, e3.type, e3.memoizedProps, e3));
            Ab(a2, f2);
          } else if (6 === e3.tag)
            f2 = e3.stateNode, c2 && d2 && (f2 = Eb(f2, e3.memoizedProps, e3)), Ab(a2, f2);
          else if (4 !== e3.tag) {
            if (22 === e3.tag && null !== e3.memoizedState)
              f2 = e3.child, null !== f2 && (f2.return = e3), Pf(a2, e3, true, true);
            else if (null !== e3.child) {
              e3.child.return = e3;
              e3 = e3.child;
              continue;
            }
          }
          if (e3 === b2)
            break;
          for (; null === e3.sibling; ) {
            if (null === e3.return || e3.return === b2)
              return;
            e3 = e3.return;
          }
          e3.sibling.return = e3.return;
          e3 = e3.sibling;
        }
      };
      Mf = function(a2, b2) {
        var c2 = b2.stateNode;
        if (!Kf(a2, b2)) {
          a2 = c2.containerInfo;
          var d2 = zb(a2);
          Pf(d2, b2, false, false);
          c2.pendingChildren = d2;
          Jf(b2);
          Bb(a2, d2);
        }
      };
      Nf = function(a2, b2, c2, d2, e3) {
        var f2 = a2.stateNode, g2 = a2.memoizedProps;
        if ((a2 = Kf(a2, b2)) && g2 === d2)
          b2.stateNode = f2;
        else {
          var h2 = b2.stateNode, k2 = ue(re.current), l2 = null;
          g2 !== d2 && (l2 = Na(h2, c2, g2, d2, e3, k2));
          a2 && null === l2 ? b2.stateNode = f2 : (f2 = yb(f2, l2, c2, g2, d2, b2, a2, h2), Ma(f2, c2, d2, e3, k2) && Jf(b2), b2.stateNode = f2, a2 ? Jf(b2) : Lf(f2, b2, false, false));
        }
      };
      Of = function(a2, b2, c2, d2) {
        c2 !== d2 ? (a2 = ue(te.current), c2 = ue(re.current), b2.stateNode = Pa(d2, a2, c2, b2), Jf(b2)) : b2.stateNode = a2.stateNode;
      };
    } else
      Mf = function() {
      }, Nf = function() {
      }, Of = function() {
      };
    function Qf(a2, b2) {
      if (!I2)
        switch (a2.tailMode) {
          case "hidden":
            b2 = a2.tail;
            for (var c2 = null; null !== b2; )
              null !== b2.alternate && (c2 = b2), b2 = b2.sibling;
            null === c2 ? a2.tail = null : c2.sibling = null;
            break;
          case "collapsed":
            c2 = a2.tail;
            for (var d2 = null; null !== c2; )
              null !== c2.alternate && (d2 = c2), c2 = c2.sibling;
            null === d2 ? b2 || null === a2.tail ? a2.tail = null : a2.tail.sibling = null : d2.sibling = null;
        }
    }
    function P2(a2) {
      var b2 = null !== a2.alternate && a2.alternate.child === a2.child, c2 = 0, d2 = 0;
      if (b2)
        for (var e3 = a2.child; null !== e3; )
          c2 |= e3.lanes | e3.childLanes, d2 |= e3.subtreeFlags & 14680064, d2 |= e3.flags & 14680064, e3.return = a2, e3 = e3.sibling;
      else
        for (e3 = a2.child; null !== e3; )
          c2 |= e3.lanes | e3.childLanes, d2 |= e3.subtreeFlags, d2 |= e3.flags, e3.return = a2, e3 = e3.sibling;
      a2.subtreeFlags |= d2;
      a2.childLanes = c2;
      return b2;
    }
    function Rf(a2, b2, c2) {
      var d2 = b2.pendingProps;
      Sd(b2);
      switch (b2.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return P2(b2), null;
        case 1:
          return C2(b2.type) && kc(), P2(b2), null;
        case 3:
          d2 = b2.stateNode;
          we();
          x2(B2);
          x2(A2);
          Be();
          d2.pendingContext && (d2.context = d2.pendingContext, d2.pendingContext = null);
          if (null === a2 || null === a2.child)
            ce2(b2) ? Jf(b2) : null === a2 || a2.memoizedState.isDehydrated && 0 === (b2.flags & 256) || (b2.flags |= 1024, null !== Wd && (Sf(Wd), Wd = null));
          Mf(a2, b2);
          P2(b2);
          return null;
        case 5:
          ye(b2);
          c2 = ue(te.current);
          var e3 = b2.type;
          if (null !== a2 && null != b2.stateNode)
            Nf(a2, b2, e3, d2, c2), a2.ref !== b2.ref && (b2.flags |= 512, b2.flags |= 2097152);
          else {
            if (!d2) {
              if (null === b2.stateNode)
                throw Error(n2(166));
              P2(b2);
              return null;
            }
            a2 = ue(re.current);
            if (ce2(b2)) {
              if (!p2)
                throw Error(n2(175));
              a2 = Pb(b2.stateNode, b2.type, b2.memoizedProps, c2, a2, b2, !Vd);
              b2.updateQueue = a2;
              null !== a2 && Jf(b2);
            } else {
              var f2 = Ka(e3, d2, c2, a2, b2);
              Lf(f2, b2, false, false);
              b2.stateNode = f2;
              Ma(f2, e3, d2, c2, a2) && Jf(b2);
            }
            null !== b2.ref && (b2.flags |= 512, b2.flags |= 2097152);
          }
          P2(b2);
          return null;
        case 6:
          if (a2 && null != b2.stateNode)
            Of(a2, b2, a2.memoizedProps, d2);
          else {
            if ("string" !== typeof d2 && null === b2.stateNode)
              throw Error(n2(166));
            a2 = ue(te.current);
            c2 = ue(re.current);
            if (ce2(b2)) {
              if (!p2)
                throw Error(n2(176));
              a2 = b2.stateNode;
              d2 = b2.memoizedProps;
              if (c2 = Qb(a2, d2, b2, !Vd)) {
                if (e3 = Td, null !== e3)
                  switch (f2 = 0 !== (e3.mode & 1), e3.tag) {
                    case 3:
                      Yb(e3.stateNode.containerInfo, a2, d2, f2);
                      break;
                    case 5:
                      Zb(e3.type, e3.memoizedProps, e3.stateNode, a2, d2, f2);
                  }
              }
              c2 && Jf(b2);
            } else
              b2.stateNode = Pa(d2, a2, c2, b2);
          }
          P2(b2);
          return null;
        case 13:
          x2(J2);
          d2 = b2.memoizedState;
          if (I2 && null !== Ud && 0 !== (b2.mode & 1) && 0 === (b2.flags & 128)) {
            for (a2 = Ud; a2; )
              a2 = Lb(a2);
            de();
            b2.flags |= 98560;
            return b2;
          }
          if (null !== d2 && null !== d2.dehydrated) {
            d2 = ce2(b2);
            if (null === a2) {
              if (!d2)
                throw Error(n2(318));
              if (!p2)
                throw Error(n2(344));
              a2 = b2.memoizedState;
              a2 = null !== a2 ? a2.dehydrated : null;
              if (!a2)
                throw Error(n2(317));
              Rb(a2, b2);
            } else
              de(), 0 === (b2.flags & 128) && (b2.memoizedState = null), b2.flags |= 4;
            P2(b2);
            return null;
          }
          null !== Wd && (Sf(Wd), Wd = null);
          if (0 !== (b2.flags & 128))
            return b2.lanes = c2, b2;
          d2 = null !== d2;
          c2 = false;
          null === a2 ? ce2(b2) : c2 = null !== a2.memoizedState;
          d2 && !c2 && (b2.child.flags |= 8192, 0 !== (b2.mode & 1) && (null === a2 || 0 !== (J2.current & 1) ? 0 === Q2 && (Q2 = 3) : Tf()));
          null !== b2.updateQueue && (b2.flags |= 4);
          P2(b2);
          return null;
        case 4:
          return we(), Mf(a2, b2), null === a2 && Xa(b2.stateNode.containerInfo), P2(b2), null;
        case 10:
          return hd(b2.type._context), P2(b2), null;
        case 17:
          return C2(b2.type) && kc(), P2(b2), null;
        case 19:
          x2(J2);
          e3 = b2.memoizedState;
          if (null === e3)
            return P2(b2), null;
          d2 = 0 !== (b2.flags & 128);
          f2 = e3.rendering;
          if (null === f2)
            if (d2)
              Qf(e3, false);
            else {
              if (0 !== Q2 || null !== a2 && 0 !== (a2.flags & 128))
                for (a2 = b2.child; null !== a2; ) {
                  f2 = ze(a2);
                  if (null !== f2) {
                    b2.flags |= 128;
                    Qf(e3, false);
                    a2 = f2.updateQueue;
                    null !== a2 && (b2.updateQueue = a2, b2.flags |= 4);
                    b2.subtreeFlags = 0;
                    a2 = c2;
                    for (d2 = b2.child; null !== d2; )
                      c2 = d2, e3 = a2, c2.flags &= 14680066, f2 = c2.alternate, null === f2 ? (c2.childLanes = 0, c2.lanes = e3, c2.child = null, c2.subtreeFlags = 0, c2.memoizedProps = null, c2.memoizedState = null, c2.updateQueue = null, c2.dependencies = null, c2.stateNode = null) : (c2.childLanes = f2.childLanes, c2.lanes = f2.lanes, c2.child = f2.child, c2.subtreeFlags = 0, c2.deletions = null, c2.memoizedProps = f2.memoizedProps, c2.memoizedState = f2.memoizedState, c2.updateQueue = f2.updateQueue, c2.type = f2.type, e3 = f2.dependencies, c2.dependencies = null === e3 ? null : { lanes: e3.lanes, firstContext: e3.firstContext }), d2 = d2.sibling;
                    y2(J2, J2.current & 1 | 2);
                    return b2.child;
                  }
                  a2 = a2.sibling;
                }
              null !== e3.tail && E3() > Uf && (b2.flags |= 128, d2 = true, Qf(e3, false), b2.lanes = 4194304);
            }
          else {
            if (!d2)
              if (a2 = ze(f2), null !== a2) {
                if (b2.flags |= 128, d2 = true, a2 = a2.updateQueue, null !== a2 && (b2.updateQueue = a2, b2.flags |= 4), Qf(e3, true), null === e3.tail && "hidden" === e3.tailMode && !f2.alternate && !I2)
                  return P2(b2), null;
              } else
                2 * E3() - e3.renderingStartTime > Uf && 1073741824 !== c2 && (b2.flags |= 128, d2 = true, Qf(e3, false), b2.lanes = 4194304);
            e3.isBackwards ? (f2.sibling = b2.child, b2.child = f2) : (a2 = e3.last, null !== a2 ? a2.sibling = f2 : b2.child = f2, e3.last = f2);
          }
          if (null !== e3.tail)
            return b2 = e3.tail, e3.rendering = b2, e3.tail = b2.sibling, e3.renderingStartTime = E3(), b2.sibling = null, a2 = J2.current, y2(J2, d2 ? a2 & 1 | 2 : a2 & 1), b2;
          P2(b2);
          return null;
        case 22:
        case 23:
          return Vf(), d2 = null !== b2.memoizedState, null !== a2 && null !== a2.memoizedState !== d2 && (b2.flags |= 8192), d2 && 0 !== (b2.mode & 1) ? 0 !== (Wf & 1073741824) && (P2(b2), Ua && b2.subtreeFlags & 6 && (b2.flags |= 8192)) : P2(b2), null;
        case 24:
          return null;
        case 25:
          return null;
      }
      throw Error(n2(156, b2.tag));
    }
    var Xf = ea.ReactCurrentOwner, kd = false;
    function R2(a2, b2, c2, d2) {
      b2.child = null === a2 ? pe(b2, null, c2, d2) : oe(b2, a2.child, c2, d2);
    }
    function Yf(a2, b2, c2, d2, e3) {
      c2 = c2.render;
      var f2 = b2.ref;
      jd(b2, e3);
      d2 = Ke(a2, b2, c2, d2, f2, e3);
      c2 = Pe();
      if (null !== a2 && !kd)
        return b2.updateQueue = a2.updateQueue, b2.flags &= -2053, a2.lanes &= ~e3, Zf(a2, b2, e3);
      I2 && c2 && Rd(b2);
      b2.flags |= 1;
      R2(a2, b2, d2, e3);
      return b2.child;
    }
    function $f(a2, b2, c2, d2, e3) {
      if (null === a2) {
        var f2 = c2.type;
        if ("function" === typeof f2 && !ag2(f2) && void 0 === f2.defaultProps && null === c2.compare && void 0 === c2.defaultProps)
          return b2.tag = 15, b2.type = f2, bg2(a2, b2, f2, d2, e3);
        a2 = le2(c2.type, null, d2, b2, b2.mode, e3);
        a2.ref = b2.ref;
        a2.return = b2;
        return b2.child = a2;
      }
      f2 = a2.child;
      if (0 === (a2.lanes & e3)) {
        var g2 = f2.memoizedProps;
        c2 = c2.compare;
        c2 = null !== c2 ? c2 : Zc;
        if (c2(g2, d2) && a2.ref === b2.ref)
          return Zf(a2, b2, e3);
      }
      b2.flags |= 1;
      a2 = je(f2, d2);
      a2.ref = b2.ref;
      a2.return = b2;
      return b2.child = a2;
    }
    function bg2(a2, b2, c2, d2, e3) {
      if (null !== a2 && Zc(a2.memoizedProps, d2) && a2.ref === b2.ref)
        if (kd = false, 0 !== (a2.lanes & e3))
          0 !== (a2.flags & 131072) && (kd = true);
        else
          return b2.lanes = a2.lanes, Zf(a2, b2, e3);
      return cg2(a2, b2, c2, d2, e3);
    }
    function dg(a2, b2, c2) {
      var d2 = b2.pendingProps, e3 = d2.children, f2 = null !== a2 ? a2.memoizedState : null;
      if ("hidden" === d2.mode)
        if (0 === (b2.mode & 1))
          b2.memoizedState = { baseLanes: 0, cachePool: null }, y2(eg, Wf), Wf |= c2;
        else if (0 !== (c2 & 1073741824))
          b2.memoizedState = { baseLanes: 0, cachePool: null }, d2 = null !== f2 ? f2.baseLanes : c2, y2(eg, Wf), Wf |= d2;
        else
          return a2 = null !== f2 ? f2.baseLanes | c2 : c2, b2.lanes = b2.childLanes = 1073741824, b2.memoizedState = { baseLanes: a2, cachePool: null }, b2.updateQueue = null, y2(eg, Wf), Wf |= a2, null;
      else
        null !== f2 ? (d2 = f2.baseLanes | c2, b2.memoizedState = null) : d2 = c2, y2(eg, Wf), Wf |= d2;
      R2(a2, b2, e3, c2);
      return b2.child;
    }
    function fg(a2, b2) {
      var c2 = b2.ref;
      if (null === a2 && null !== c2 || null !== a2 && a2.ref !== c2)
        b2.flags |= 512, b2.flags |= 2097152;
    }
    function cg2(a2, b2, c2, d2, e3) {
      var f2 = C2(c2) ? ic : A2.current;
      f2 = jc(b2, f2);
      jd(b2, e3);
      c2 = Ke(a2, b2, c2, d2, f2, e3);
      d2 = Pe();
      if (null !== a2 && !kd)
        return b2.updateQueue = a2.updateQueue, b2.flags &= -2053, a2.lanes &= ~e3, Zf(a2, b2, e3);
      I2 && d2 && Rd(b2);
      b2.flags |= 1;
      R2(a2, b2, c2, e3);
      return b2.child;
    }
    function gg2(a2, b2, c2, d2, e3) {
      if (C2(c2)) {
        var f2 = true;
        nc(b2);
      } else
        f2 = false;
      jd(b2, e3);
      if (null === b2.stateNode)
        null !== a2 && (a2.alternate = null, b2.alternate = null, b2.flags |= 2), Dd(b2, c2, d2), Fd(b2, c2, d2, e3), d2 = true;
      else if (null === a2) {
        var g2 = b2.stateNode, h2 = b2.memoizedProps;
        g2.props = h2;
        var k2 = g2.context, l2 = c2.contextType;
        "object" === typeof l2 && null !== l2 ? l2 = ld(l2) : (l2 = C2(c2) ? ic : A2.current, l2 = jc(b2, l2));
        var m2 = c2.getDerivedStateFromProps, v5 = "function" === typeof m2 || "function" === typeof g2.getSnapshotBeforeUpdate;
        v5 || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== d2 || k2 !== l2) && Ed(b2, g2, d2, l2);
        nd = false;
        var r2 = b2.memoizedState;
        g2.state = r2;
        ud(b2, d2, g2, e3);
        k2 = b2.memoizedState;
        h2 !== d2 || r2 !== k2 || B2.current || nd ? ("function" === typeof m2 && (yd(b2, c2, m2, d2), k2 = b2.memoizedState), (h2 = nd || Cd(b2, c2, h2, d2, r2, k2, l2)) ? (v5 || "function" !== typeof g2.UNSAFE_componentWillMount && "function" !== typeof g2.componentWillMount || ("function" === typeof g2.componentWillMount && g2.componentWillMount(), "function" === typeof g2.UNSAFE_componentWillMount && g2.UNSAFE_componentWillMount()), "function" === typeof g2.componentDidMount && (b2.flags |= 4194308)) : ("function" === typeof g2.componentDidMount && (b2.flags |= 4194308), b2.memoizedProps = d2, b2.memoizedState = k2), g2.props = d2, g2.state = k2, g2.context = l2, d2 = h2) : ("function" === typeof g2.componentDidMount && (b2.flags |= 4194308), d2 = false);
      } else {
        g2 = b2.stateNode;
        pd(a2, b2);
        h2 = b2.memoizedProps;
        l2 = b2.type === b2.elementType ? h2 : ad2(b2.type, h2);
        g2.props = l2;
        v5 = b2.pendingProps;
        r2 = g2.context;
        k2 = c2.contextType;
        "object" === typeof k2 && null !== k2 ? k2 = ld(k2) : (k2 = C2(c2) ? ic : A2.current, k2 = jc(b2, k2));
        var z2 = c2.getDerivedStateFromProps;
        (m2 = "function" === typeof z2 || "function" === typeof g2.getSnapshotBeforeUpdate) || "function" !== typeof g2.UNSAFE_componentWillReceiveProps && "function" !== typeof g2.componentWillReceiveProps || (h2 !== v5 || r2 !== k2) && Ed(b2, g2, d2, k2);
        nd = false;
        r2 = b2.memoizedState;
        g2.state = r2;
        ud(b2, d2, g2, e3);
        var q2 = b2.memoizedState;
        h2 !== v5 || r2 !== q2 || B2.current || nd ? ("function" === typeof z2 && (yd(b2, c2, z2, d2), q2 = b2.memoizedState), (l2 = nd || Cd(b2, c2, l2, d2, r2, q2, k2) || false) ? (m2 || "function" !== typeof g2.UNSAFE_componentWillUpdate && "function" !== typeof g2.componentWillUpdate || ("function" === typeof g2.componentWillUpdate && g2.componentWillUpdate(
          d2,
          q2,
          k2
        ), "function" === typeof g2.UNSAFE_componentWillUpdate && g2.UNSAFE_componentWillUpdate(d2, q2, k2)), "function" === typeof g2.componentDidUpdate && (b2.flags |= 4), "function" === typeof g2.getSnapshotBeforeUpdate && (b2.flags |= 1024)) : ("function" !== typeof g2.componentDidUpdate || h2 === a2.memoizedProps && r2 === a2.memoizedState || (b2.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a2.memoizedProps && r2 === a2.memoizedState || (b2.flags |= 1024), b2.memoizedProps = d2, b2.memoizedState = q2), g2.props = d2, g2.state = q2, g2.context = k2, d2 = l2) : ("function" !== typeof g2.componentDidUpdate || h2 === a2.memoizedProps && r2 === a2.memoizedState || (b2.flags |= 4), "function" !== typeof g2.getSnapshotBeforeUpdate || h2 === a2.memoizedProps && r2 === a2.memoizedState || (b2.flags |= 1024), d2 = false);
      }
      return hg(a2, b2, c2, d2, f2, e3);
    }
    function hg(a2, b2, c2, d2, e3, f2) {
      fg(a2, b2);
      var g2 = 0 !== (b2.flags & 128);
      if (!d2 && !g2)
        return e3 && oc(b2, c2, false), Zf(a2, b2, f2);
      d2 = b2.stateNode;
      Xf.current = b2;
      var h2 = g2 && "function" !== typeof c2.getDerivedStateFromError ? null : d2.render();
      b2.flags |= 1;
      null !== a2 && g2 ? (b2.child = oe(b2, a2.child, null, f2), b2.child = oe(b2, null, h2, f2)) : R2(a2, b2, h2, f2);
      b2.memoizedState = d2.state;
      e3 && oc(b2, c2, true);
      return b2.child;
    }
    function ig(a2) {
      var b2 = a2.stateNode;
      b2.pendingContext ? lc(a2, b2.pendingContext, b2.pendingContext !== b2.context) : b2.context && lc(a2, b2.context, false);
      ve(a2, b2.containerInfo);
    }
    function jg(a2, b2, c2, d2, e3) {
      de();
      ee(e3);
      b2.flags |= 256;
      R2(a2, b2, c2, d2);
      return b2.child;
    }
    var kg = { dehydrated: null, treeContext: null, retryLane: 0 };
    function lg(a2) {
      return { baseLanes: a2, cachePool: null };
    }
    function mg(a2, b2, c2) {
      var d2 = b2.pendingProps, e3 = J2.current, f2 = false, g2 = 0 !== (b2.flags & 128), h2;
      (h2 = g2) || (h2 = null !== a2 && null === a2.memoizedState ? false : 0 !== (e3 & 2));
      if (h2)
        f2 = true, b2.flags &= -129;
      else if (null === a2 || null !== a2.memoizedState)
        e3 |= 1;
      y2(J2, e3 & 1);
      if (null === a2) {
        ae2(b2);
        a2 = b2.memoizedState;
        if (null !== a2 && (a2 = a2.dehydrated, null !== a2))
          return 0 === (b2.mode & 1) ? b2.lanes = 1 : Jb(a2) ? b2.lanes = 8 : b2.lanes = 1073741824, null;
        e3 = d2.children;
        a2 = d2.fallback;
        return f2 ? (d2 = b2.mode, f2 = b2.child, e3 = { mode: "hidden", children: e3 }, 0 === (d2 & 1) && null !== f2 ? (f2.childLanes = 0, f2.pendingProps = e3) : f2 = ng(e3, d2, 0, null), a2 = ne(a2, d2, c2, null), f2.return = b2, a2.return = b2, f2.sibling = a2, b2.child = f2, b2.child.memoizedState = lg(c2), b2.memoizedState = kg, a2) : og(b2, e3);
      }
      e3 = a2.memoizedState;
      if (null !== e3) {
        h2 = e3.dehydrated;
        if (null !== h2) {
          if (g2) {
            if (b2.flags & 256)
              return b2.flags &= -257, pg(a2, b2, c2, Error(n2(422)));
            if (null !== b2.memoizedState)
              return b2.child = a2.child, b2.flags |= 128, null;
            f2 = d2.fallback;
            e3 = b2.mode;
            d2 = ng({ mode: "visible", children: d2.children }, e3, 0, null);
            f2 = ne(f2, e3, c2, null);
            f2.flags |= 2;
            d2.return = b2;
            f2.return = b2;
            d2.sibling = f2;
            b2.child = d2;
            0 !== (b2.mode & 1) && oe(
              b2,
              a2.child,
              null,
              c2
            );
            b2.child.memoizedState = lg(c2);
            b2.memoizedState = kg;
            return f2;
          }
          if (0 === (b2.mode & 1))
            b2 = pg(a2, b2, c2, null);
          else if (Jb(h2))
            b2 = pg(a2, b2, c2, Error(n2(419)));
          else if (d2 = 0 !== (c2 & a2.childLanes), kd || d2) {
            d2 = F2;
            if (null !== d2) {
              switch (c2 & -c2) {
                case 4:
                  f2 = 2;
                  break;
                case 16:
                  f2 = 8;
                  break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                  f2 = 32;
                  break;
                case 536870912:
                  f2 = 268435456;
                  break;
                default:
                  f2 = 0;
              }
              d2 = 0 !== (f2 & (d2.suspendedLanes | c2)) ? 0 : f2;
              0 !== d2 && d2 !== e3.retryLane && (e3.retryLane = d2, Ad(a2, d2, -1));
            }
            Tf();
            b2 = pg(a2, b2, c2, Error(n2(421)));
          } else
            Ib(h2) ? (b2.flags |= 128, b2.child = a2.child, b2 = qg.bind(null, a2), Kb(h2, b2), b2 = null) : (c2 = e3.treeContext, p2 && (Ud = Ob(h2), Td = b2, I2 = true, Wd = null, Vd = false, null !== c2 && (Kd[Ld++] = Nd, Kd[Ld++] = Od, Kd[Ld++] = Md, Nd = c2.id, Od = c2.overflow, Md = b2)), b2 = og(b2, b2.pendingProps.children), b2.flags |= 4096);
          return b2;
        }
        if (f2)
          return d2 = rg(a2, b2, d2.children, d2.fallback, c2), f2 = b2.child, e3 = a2.child.memoizedState, f2.memoizedState = null === e3 ? lg(c2) : { baseLanes: e3.baseLanes | c2, cachePool: null }, f2.childLanes = a2.childLanes & ~c2, b2.memoizedState = kg, d2;
        c2 = sg(a2, b2, d2.children, c2);
        b2.memoizedState = null;
        return c2;
      }
      if (f2)
        return d2 = rg(a2, b2, d2.children, d2.fallback, c2), f2 = b2.child, e3 = a2.child.memoizedState, f2.memoizedState = null === e3 ? lg(c2) : { baseLanes: e3.baseLanes | c2, cachePool: null }, f2.childLanes = a2.childLanes & ~c2, b2.memoizedState = kg, d2;
      c2 = sg(a2, b2, d2.children, c2);
      b2.memoizedState = null;
      return c2;
    }
    function og(a2, b2) {
      b2 = ng({ mode: "visible", children: b2 }, a2.mode, 0, null);
      b2.return = a2;
      return a2.child = b2;
    }
    function sg(a2, b2, c2, d2) {
      var e3 = a2.child;
      a2 = e3.sibling;
      c2 = je(e3, { mode: "visible", children: c2 });
      0 === (b2.mode & 1) && (c2.lanes = d2);
      c2.return = b2;
      c2.sibling = null;
      null !== a2 && (d2 = b2.deletions, null === d2 ? (b2.deletions = [a2], b2.flags |= 16) : d2.push(a2));
      return b2.child = c2;
    }
    function rg(a2, b2, c2, d2, e3) {
      var f2 = b2.mode;
      a2 = a2.child;
      var g2 = a2.sibling, h2 = { mode: "hidden", children: c2 };
      0 === (f2 & 1) && b2.child !== a2 ? (c2 = b2.child, c2.childLanes = 0, c2.pendingProps = h2, b2.deletions = null) : (c2 = je(a2, h2), c2.subtreeFlags = a2.subtreeFlags & 14680064);
      null !== g2 ? d2 = je(g2, d2) : (d2 = ne(d2, f2, e3, null), d2.flags |= 2);
      d2.return = b2;
      c2.return = b2;
      c2.sibling = d2;
      b2.child = c2;
      return d2;
    }
    function pg(a2, b2, c2, d2) {
      null !== d2 && ee(d2);
      oe(b2, a2.child, null, c2);
      a2 = og(b2, b2.pendingProps.children);
      a2.flags |= 2;
      b2.memoizedState = null;
      return a2;
    }
    function tg(a2, b2, c2) {
      a2.lanes |= b2;
      var d2 = a2.alternate;
      null !== d2 && (d2.lanes |= b2);
      id(a2.return, b2, c2);
    }
    function ug(a2, b2, c2, d2, e3) {
      var f2 = a2.memoizedState;
      null === f2 ? a2.memoizedState = { isBackwards: b2, rendering: null, renderingStartTime: 0, last: d2, tail: c2, tailMode: e3 } : (f2.isBackwards = b2, f2.rendering = null, f2.renderingStartTime = 0, f2.last = d2, f2.tail = c2, f2.tailMode = e3);
    }
    function vg(a2, b2, c2) {
      var d2 = b2.pendingProps, e3 = d2.revealOrder, f2 = d2.tail;
      R2(a2, b2, d2.children, c2);
      d2 = J2.current;
      if (0 !== (d2 & 2))
        d2 = d2 & 1 | 2, b2.flags |= 128;
      else {
        if (null !== a2 && 0 !== (a2.flags & 128))
          a:
            for (a2 = b2.child; null !== a2; ) {
              if (13 === a2.tag)
                null !== a2.memoizedState && tg(a2, c2, b2);
              else if (19 === a2.tag)
                tg(a2, c2, b2);
              else if (null !== a2.child) {
                a2.child.return = a2;
                a2 = a2.child;
                continue;
              }
              if (a2 === b2)
                break a;
              for (; null === a2.sibling; ) {
                if (null === a2.return || a2.return === b2)
                  break a;
                a2 = a2.return;
              }
              a2.sibling.return = a2.return;
              a2 = a2.sibling;
            }
        d2 &= 1;
      }
      y2(J2, d2);
      if (0 === (b2.mode & 1))
        b2.memoizedState = null;
      else
        switch (e3) {
          case "forwards":
            c2 = b2.child;
            for (e3 = null; null !== c2; )
              a2 = c2.alternate, null !== a2 && null === ze(a2) && (e3 = c2), c2 = c2.sibling;
            c2 = e3;
            null === c2 ? (e3 = b2.child, b2.child = null) : (e3 = c2.sibling, c2.sibling = null);
            ug(b2, false, e3, c2, f2);
            break;
          case "backwards":
            c2 = null;
            e3 = b2.child;
            for (b2.child = null; null !== e3; ) {
              a2 = e3.alternate;
              if (null !== a2 && null === ze(a2)) {
                b2.child = e3;
                break;
              }
              a2 = e3.sibling;
              e3.sibling = c2;
              c2 = e3;
              e3 = a2;
            }
            ug(b2, true, c2, null, f2);
            break;
          case "together":
            ug(b2, false, null, null, void 0);
            break;
          default:
            b2.memoizedState = null;
        }
      return b2.child;
    }
    function Zf(a2, b2, c2) {
      null !== a2 && (b2.dependencies = a2.dependencies);
      vd |= b2.lanes;
      if (0 === (c2 & b2.childLanes))
        return null;
      if (null !== a2 && b2.child !== a2.child)
        throw Error(n2(153));
      if (null !== b2.child) {
        a2 = b2.child;
        c2 = je(a2, a2.pendingProps);
        b2.child = c2;
        for (c2.return = b2; null !== a2.sibling; )
          a2 = a2.sibling, c2 = c2.sibling = je(a2, a2.pendingProps), c2.return = b2;
        c2.sibling = null;
      }
      return b2.child;
    }
    function wg(a2, b2, c2) {
      switch (b2.tag) {
        case 3:
          ig(b2);
          de();
          break;
        case 5:
          xe(b2);
          break;
        case 1:
          C2(b2.type) && nc(b2);
          break;
        case 4:
          ve(b2, b2.stateNode.containerInfo);
          break;
        case 10:
          gd(b2, b2.type._context, b2.memoizedProps.value);
          break;
        case 13:
          var d2 = b2.memoizedState;
          if (null !== d2) {
            if (null !== d2.dehydrated)
              return y2(J2, J2.current & 1), b2.flags |= 128, null;
            if (0 !== (c2 & b2.child.childLanes))
              return mg(a2, b2, c2);
            y2(J2, J2.current & 1);
            a2 = Zf(a2, b2, c2);
            return null !== a2 ? a2.sibling : null;
          }
          y2(J2, J2.current & 1);
          break;
        case 19:
          d2 = 0 !== (c2 & b2.childLanes);
          if (0 !== (a2.flags & 128)) {
            if (d2)
              return vg(
                a2,
                b2,
                c2
              );
            b2.flags |= 128;
          }
          var e3 = b2.memoizedState;
          null !== e3 && (e3.rendering = null, e3.tail = null, e3.lastEffect = null);
          y2(J2, J2.current);
          if (d2)
            break;
          else
            return null;
        case 22:
        case 23:
          return b2.lanes = 0, dg(a2, b2, c2);
      }
      return Zf(a2, b2, c2);
    }
    function xg(a2, b2) {
      Sd(b2);
      switch (b2.tag) {
        case 1:
          return C2(b2.type) && kc(), a2 = b2.flags, a2 & 65536 ? (b2.flags = a2 & -65537 | 128, b2) : null;
        case 3:
          return we(), x2(B2), x2(A2), Be(), a2 = b2.flags, 0 !== (a2 & 65536) && 0 === (a2 & 128) ? (b2.flags = a2 & -65537 | 128, b2) : null;
        case 5:
          return ye(b2), null;
        case 13:
          x2(J2);
          a2 = b2.memoizedState;
          if (null !== a2 && null !== a2.dehydrated) {
            if (null === b2.alternate)
              throw Error(n2(340));
            de();
          }
          a2 = b2.flags;
          return a2 & 65536 ? (b2.flags = a2 & -65537 | 128, b2) : null;
        case 19:
          return x2(J2), null;
        case 4:
          return we(), null;
        case 10:
          return hd(b2.type._context), null;
        case 22:
        case 23:
          return Vf(), null;
        case 24:
          return null;
        default:
          return null;
      }
    }
    var yg = false, zg = false, Ag = "function" === typeof WeakSet ? WeakSet : Set, S2 = null;
    function Bg(a2, b2) {
      var c2 = a2.ref;
      if (null !== c2)
        if ("function" === typeof c2)
          try {
            c2(null);
          } catch (d2) {
            T2(a2, b2, d2);
          }
        else
          c2.current = null;
    }
    function Cg(a2, b2, c2) {
      try {
        c2();
      } catch (d2) {
        T2(a2, b2, d2);
      }
    }
    var Dg = false;
    function Eg(a2, b2) {
      Ia(a2.containerInfo);
      for (S2 = b2; null !== S2; )
        if (a2 = S2, b2 = a2.child, 0 !== (a2.subtreeFlags & 1028) && null !== b2)
          b2.return = a2, S2 = b2;
        else
          for (; null !== S2; ) {
            a2 = S2;
            try {
              var c2 = a2.alternate;
              if (0 !== (a2.flags & 1024))
                switch (a2.tag) {
                  case 0:
                  case 11:
                  case 15:
                    break;
                  case 1:
                    if (null !== c2) {
                      var d2 = c2.memoizedProps, e3 = c2.memoizedState, f2 = a2.stateNode, g2 = f2.getSnapshotBeforeUpdate(a2.elementType === a2.type ? d2 : ad2(a2.type, d2), e3);
                      f2.__reactInternalSnapshotBeforeUpdate = g2;
                    }
                    break;
                  case 3:
                    Ua && xb(a2.stateNode.containerInfo);
                    break;
                  case 5:
                  case 6:
                  case 4:
                  case 17:
                    break;
                  default:
                    throw Error(n2(163));
                }
            } catch (h2) {
              T2(a2, a2.return, h2);
            }
            b2 = a2.sibling;
            if (null !== b2) {
              b2.return = a2.return;
              S2 = b2;
              break;
            }
            S2 = a2.return;
          }
      c2 = Dg;
      Dg = false;
      return c2;
    }
    function Fg(a2, b2, c2) {
      var d2 = b2.updateQueue;
      d2 = null !== d2 ? d2.lastEffect : null;
      if (null !== d2) {
        var e3 = d2 = d2.next;
        do {
          if ((e3.tag & a2) === a2) {
            var f2 = e3.destroy;
            e3.destroy = void 0;
            void 0 !== f2 && Cg(b2, c2, f2);
          }
          e3 = e3.next;
        } while (e3 !== d2);
      }
    }
    function Gg(a2, b2) {
      b2 = b2.updateQueue;
      b2 = null !== b2 ? b2.lastEffect : null;
      if (null !== b2) {
        var c2 = b2 = b2.next;
        do {
          if ((c2.tag & a2) === a2) {
            var d2 = c2.create;
            c2.destroy = d2();
          }
          c2 = c2.next;
        } while (c2 !== b2);
      }
    }
    function Hg(a2) {
      var b2 = a2.ref;
      if (null !== b2) {
        var c2 = a2.stateNode;
        switch (a2.tag) {
          case 5:
            a2 = Fa(c2);
            break;
          default:
            a2 = c2;
        }
        "function" === typeof b2 ? b2(a2) : b2.current = a2;
      }
    }
    function Ig(a2, b2, c2) {
      if (Oc && "function" === typeof Oc.onCommitFiberUnmount)
        try {
          Oc.onCommitFiberUnmount(Nc, b2);
        } catch (g2) {
        }
      switch (b2.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          a2 = b2.updateQueue;
          if (null !== a2 && (a2 = a2.lastEffect, null !== a2)) {
            var d2 = a2 = a2.next;
            do {
              var e3 = d2, f2 = e3.destroy;
              e3 = e3.tag;
              void 0 !== f2 && (0 !== (e3 & 2) ? Cg(b2, c2, f2) : 0 !== (e3 & 4) && Cg(b2, c2, f2));
              d2 = d2.next;
            } while (d2 !== a2);
          }
          break;
        case 1:
          Bg(b2, c2);
          a2 = b2.stateNode;
          if ("function" === typeof a2.componentWillUnmount)
            try {
              a2.props = b2.memoizedProps, a2.state = b2.memoizedState, a2.componentWillUnmount();
            } catch (g2) {
              T2(
                b2,
                c2,
                g2
              );
            }
          break;
        case 5:
          Bg(b2, c2);
          break;
        case 4:
          Ua ? Jg(a2, b2, c2) : Va && Va && (b2 = b2.stateNode.containerInfo, c2 = zb(b2), Cb(b2, c2));
      }
    }
    function Kg(a2, b2, c2) {
      for (var d2 = b2; ; )
        if (Ig(a2, d2, c2), null === d2.child || Ua && 4 === d2.tag) {
          if (d2 === b2)
            break;
          for (; null === d2.sibling; ) {
            if (null === d2.return || d2.return === b2)
              return;
            d2 = d2.return;
          }
          d2.sibling.return = d2.return;
          d2 = d2.sibling;
        } else
          d2.child.return = d2, d2 = d2.child;
    }
    function Lg(a2) {
      var b2 = a2.alternate;
      null !== b2 && (a2.alternate = null, Lg(b2));
      a2.child = null;
      a2.deletions = null;
      a2.sibling = null;
      5 === a2.tag && (b2 = a2.stateNode, null !== b2 && Za(b2));
      a2.stateNode = null;
      a2.return = null;
      a2.dependencies = null;
      a2.memoizedProps = null;
      a2.memoizedState = null;
      a2.pendingProps = null;
      a2.stateNode = null;
      a2.updateQueue = null;
    }
    function Mg(a2) {
      return 5 === a2.tag || 3 === a2.tag || 4 === a2.tag;
    }
    function Ng(a2) {
      a:
        for (; ; ) {
          for (; null === a2.sibling; ) {
            if (null === a2.return || Mg(a2.return))
              return null;
            a2 = a2.return;
          }
          a2.sibling.return = a2.return;
          for (a2 = a2.sibling; 5 !== a2.tag && 6 !== a2.tag && 18 !== a2.tag; ) {
            if (a2.flags & 2)
              continue a;
            if (null === a2.child || 4 === a2.tag)
              continue a;
            else
              a2.child.return = a2, a2 = a2.child;
          }
          if (!(a2.flags & 2))
            return a2.stateNode;
        }
    }
    function Og(a2) {
      if (Ua) {
        a: {
          for (var b2 = a2.return; null !== b2; ) {
            if (Mg(b2))
              break a;
            b2 = b2.return;
          }
          throw Error(n2(160));
        }
        var c2 = b2;
        switch (c2.tag) {
          case 5:
            b2 = c2.stateNode;
            c2.flags & 32 && (sb(b2), c2.flags &= -33);
            c2 = Ng(a2);
            Pg(a2, c2, b2);
            break;
          case 3:
          case 4:
            b2 = c2.stateNode.containerInfo;
            c2 = Ng(a2);
            Qg(a2, c2, b2);
            break;
          default:
            throw Error(n2(161));
        }
      }
    }
    function Qg(a2, b2, c2) {
      var d2 = a2.tag;
      if (5 === d2 || 6 === d2)
        a2 = a2.stateNode, b2 ? pb(c2, a2, b2) : kb(c2, a2);
      else if (4 !== d2 && (a2 = a2.child, null !== a2))
        for (Qg(a2, b2, c2), a2 = a2.sibling; null !== a2; )
          Qg(a2, b2, c2), a2 = a2.sibling;
    }
    function Pg(a2, b2, c2) {
      var d2 = a2.tag;
      if (5 === d2 || 6 === d2)
        a2 = a2.stateNode, b2 ? ob(c2, a2, b2) : jb(c2, a2);
      else if (4 !== d2 && (a2 = a2.child, null !== a2))
        for (Pg(a2, b2, c2), a2 = a2.sibling; null !== a2; )
          Pg(a2, b2, c2), a2 = a2.sibling;
    }
    function Jg(a2, b2, c2) {
      for (var d2 = b2, e3 = false, f2, g2; ; ) {
        if (!e3) {
          e3 = d2.return;
          a:
            for (; ; ) {
              if (null === e3)
                throw Error(n2(160));
              f2 = e3.stateNode;
              switch (e3.tag) {
                case 5:
                  g2 = false;
                  break a;
                case 3:
                  f2 = f2.containerInfo;
                  g2 = true;
                  break a;
                case 4:
                  f2 = f2.containerInfo;
                  g2 = true;
                  break a;
              }
              e3 = e3.return;
            }
          e3 = true;
        }
        if (5 === d2.tag || 6 === d2.tag)
          Kg(a2, d2, c2), g2 ? rb(f2, d2.stateNode) : qb(f2, d2.stateNode);
        else if (18 === d2.tag)
          g2 ? Wb(f2, d2.stateNode) : Vb(f2, d2.stateNode);
        else if (4 === d2.tag) {
          if (null !== d2.child) {
            f2 = d2.stateNode.containerInfo;
            g2 = true;
            d2.child.return = d2;
            d2 = d2.child;
            continue;
          }
        } else if (Ig(a2, d2, c2), null !== d2.child) {
          d2.child.return = d2;
          d2 = d2.child;
          continue;
        }
        if (d2 === b2)
          break;
        for (; null === d2.sibling; ) {
          if (null === d2.return || d2.return === b2)
            return;
          d2 = d2.return;
          4 === d2.tag && (e3 = false);
        }
        d2.sibling.return = d2.return;
        d2 = d2.sibling;
      }
    }
    function Rg(a2, b2) {
      if (Ua) {
        switch (b2.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
            Fg(3, b2, b2.return);
            Gg(3, b2);
            Fg(5, b2, b2.return);
            return;
          case 1:
            return;
          case 5:
            var c2 = b2.stateNode;
            if (null != c2) {
              var d2 = b2.memoizedProps;
              a2 = null !== a2 ? a2.memoizedProps : d2;
              var e3 = b2.type, f2 = b2.updateQueue;
              b2.updateQueue = null;
              null !== f2 && nb(c2, f2, e3, a2, d2, b2);
            }
            return;
          case 6:
            if (null === b2.stateNode)
              throw Error(n2(162));
            c2 = b2.memoizedProps;
            lb(b2.stateNode, null !== a2 ? a2.memoizedProps : c2, c2);
            return;
          case 3:
            p2 && null !== a2 && a2.memoizedState.isDehydrated && Tb(b2.stateNode.containerInfo);
            return;
          case 12:
            return;
          case 13:
            Sg(b2);
            return;
          case 19:
            Sg(b2);
            return;
          case 17:
            return;
        }
        throw Error(n2(163));
      }
      switch (b2.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Fg(3, b2, b2.return);
          Gg(3, b2);
          Fg(5, b2, b2.return);
          return;
        case 12:
          return;
        case 13:
          Sg(b2);
          return;
        case 19:
          Sg(b2);
          return;
        case 3:
          p2 && null !== a2 && a2.memoizedState.isDehydrated && Tb(b2.stateNode.containerInfo);
          break;
        case 22:
        case 23:
          return;
      }
      a:
        if (Va) {
          switch (b2.tag) {
            case 1:
            case 5:
            case 6:
              break a;
            case 3:
            case 4:
              b2 = b2.stateNode;
              Cb(b2.containerInfo, b2.pendingChildren);
              break a;
          }
          throw Error(n2(163));
        }
    }
    function Sg(a2) {
      var b2 = a2.updateQueue;
      if (null !== b2) {
        a2.updateQueue = null;
        var c2 = a2.stateNode;
        null === c2 && (c2 = a2.stateNode = new Ag());
        b2.forEach(function(b3) {
          var d2 = Tg.bind(null, a2, b3);
          c2.has(b3) || (c2.add(b3), b3.then(d2, d2));
        });
      }
    }
    function Ug(a2, b2) {
      for (S2 = b2; null !== S2; ) {
        b2 = S2;
        var c2 = b2.deletions;
        if (null !== c2)
          for (var d2 = 0; d2 < c2.length; d2++) {
            var e3 = c2[d2];
            try {
              var f2 = a2;
              Ua ? Jg(f2, e3, b2) : Kg(f2, e3, b2);
              var g2 = e3.alternate;
              null !== g2 && (g2.return = null);
              e3.return = null;
            } catch (wa) {
              T2(e3, b2, wa);
            }
          }
        c2 = b2.child;
        if (0 !== (b2.subtreeFlags & 12854) && null !== c2)
          c2.return = b2, S2 = c2;
        else
          for (; null !== S2; ) {
            b2 = S2;
            try {
              var h2 = b2.flags;
              h2 & 32 && Ua && sb(b2.stateNode);
              if (h2 & 512) {
                var k2 = b2.alternate;
                if (null !== k2) {
                  var l2 = k2.ref;
                  null !== l2 && ("function" === typeof l2 ? l2(null) : l2.current = null);
                }
              }
              if (h2 & 8192)
                switch (b2.tag) {
                  case 13:
                    if (null !== b2.memoizedState) {
                      var m2 = b2.alternate;
                      if (null === m2 || null === m2.memoizedState)
                        Vg = E3();
                    }
                    break;
                  case 22:
                    var v5 = null !== b2.memoizedState, r2 = b2.alternate, z2 = null !== r2 && null !== r2.memoizedState;
                    c2 = b2;
                    if (Ua) {
                      a:
                        if (d2 = c2, e3 = v5, f2 = null, Ua)
                          for (var q2 = d2; ; ) {
                            if (5 === q2.tag) {
                              if (null === f2) {
                                f2 = q2;
                                var N2 = q2.stateNode;
                                e3 ? tb(N2) : vb(q2.stateNode, q2.memoizedProps);
                              }
                            } else if (6 === q2.tag) {
                              if (null === f2) {
                                var da = q2.stateNode;
                                e3 ? ub(da) : wb(da, q2.memoizedProps);
                              }
                            } else if ((22 !== q2.tag && 23 !== q2.tag || null === q2.memoizedState || q2 === d2) && null !== q2.child) {
                              q2.child.return = q2;
                              q2 = q2.child;
                              continue;
                            }
                            if (q2 === d2)
                              break;
                            for (; null === q2.sibling; ) {
                              if (null === q2.return || q2.return === d2)
                                break a;
                              f2 === q2 && (f2 = null);
                              q2 = q2.return;
                            }
                            f2 === q2 && (f2 = null);
                            q2.sibling.return = q2.return;
                            q2 = q2.sibling;
                          }
                    }
                    if (v5 && !z2 && 0 !== (c2.mode & 1)) {
                      S2 = c2;
                      for (var t2 = c2.child; null !== t2; ) {
                        for (c2 = S2 = t2; null !== S2; ) {
                          d2 = S2;
                          var w2 = d2.child;
                          switch (d2.tag) {
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                              Fg(4, d2, d2.return);
                              break;
                            case 1:
                              Bg(d2, d2.return);
                              var u2 = d2.stateNode;
                              if ("function" === typeof u2.componentWillUnmount) {
                                var V2 = d2.return;
                                try {
                                  u2.props = d2.memoizedProps, u2.state = d2.memoizedState, u2.componentWillUnmount();
                                } catch (wa) {
                                  T2(
                                    d2,
                                    V2,
                                    wa
                                  );
                                }
                              }
                              break;
                            case 5:
                              Bg(d2, d2.return);
                              break;
                            case 22:
                              if (null !== d2.memoizedState) {
                                Wg(c2);
                                continue;
                              }
                          }
                          null !== w2 ? (w2.return = d2, S2 = w2) : Wg(c2);
                        }
                        t2 = t2.sibling;
                      }
                    }
                }
              switch (h2 & 4102) {
                case 2:
                  Og(b2);
                  b2.flags &= -3;
                  break;
                case 6:
                  Og(b2);
                  b2.flags &= -3;
                  Rg(b2.alternate, b2);
                  break;
                case 4096:
                  b2.flags &= -4097;
                  break;
                case 4100:
                  b2.flags &= -4097;
                  Rg(b2.alternate, b2);
                  break;
                case 4:
                  Rg(b2.alternate, b2);
              }
            } catch (wa) {
              T2(b2, b2.return, wa);
            }
            c2 = b2.sibling;
            if (null !== c2) {
              c2.return = b2.return;
              S2 = c2;
              break;
            }
            S2 = b2.return;
          }
      }
    }
    function Xg(a2, b2, c2) {
      S2 = a2;
      Yg(a2);
    }
    function Yg(a2, b2, c2) {
      for (var d2 = 0 !== (a2.mode & 1); null !== S2; ) {
        var e3 = S2, f2 = e3.child;
        if (22 === e3.tag && d2) {
          var g2 = null !== e3.memoizedState || yg;
          if (!g2) {
            var h2 = e3.alternate, k2 = null !== h2 && null !== h2.memoizedState || zg;
            h2 = yg;
            var l2 = zg;
            yg = g2;
            if ((zg = k2) && !l2)
              for (S2 = e3; null !== S2; )
                g2 = S2, k2 = g2.child, 22 === g2.tag && null !== g2.memoizedState ? Zg(e3) : null !== k2 ? (k2.return = g2, S2 = k2) : Zg(e3);
            for (; null !== f2; )
              S2 = f2, Yg(f2), f2 = f2.sibling;
            S2 = e3;
            yg = h2;
            zg = l2;
          }
          $g(a2);
        } else
          0 !== (e3.subtreeFlags & 8772) && null !== f2 ? (f2.return = e3, S2 = f2) : $g(a2);
      }
    }
    function $g(a2) {
      for (; null !== S2; ) {
        var b2 = S2;
        if (0 !== (b2.flags & 8772)) {
          var c2 = b2.alternate;
          try {
            if (0 !== (b2.flags & 8772))
              switch (b2.tag) {
                case 0:
                case 11:
                case 15:
                  zg || Gg(5, b2);
                  break;
                case 1:
                  var d2 = b2.stateNode;
                  if (b2.flags & 4 && !zg)
                    if (null === c2)
                      d2.componentDidMount();
                    else {
                      var e3 = b2.elementType === b2.type ? c2.memoizedProps : ad2(b2.type, c2.memoizedProps);
                      d2.componentDidUpdate(e3, c2.memoizedState, d2.__reactInternalSnapshotBeforeUpdate);
                    }
                  var f2 = b2.updateQueue;
                  null !== f2 && wd(b2, f2, d2);
                  break;
                case 3:
                  var g2 = b2.updateQueue;
                  if (null !== g2) {
                    c2 = null;
                    if (null !== b2.child)
                      switch (b2.child.tag) {
                        case 5:
                          c2 = Fa(b2.child.stateNode);
                          break;
                        case 1:
                          c2 = b2.child.stateNode;
                      }
                    wd(b2, g2, c2);
                  }
                  break;
                case 5:
                  var h2 = b2.stateNode;
                  null === c2 && b2.flags & 4 && mb(h2, b2.type, b2.memoizedProps, b2);
                  break;
                case 6:
                  break;
                case 4:
                  break;
                case 12:
                  break;
                case 13:
                  if (p2 && null === b2.memoizedState) {
                    var k2 = b2.alternate;
                    if (null !== k2) {
                      var l2 = k2.memoizedState;
                      if (null !== l2) {
                        var m2 = l2.dehydrated;
                        null !== m2 && Ub(m2);
                      }
                    }
                  }
                  break;
                case 19:
                case 17:
                case 21:
                case 22:
                case 23:
                  break;
                default:
                  throw Error(n2(163));
              }
            zg || b2.flags & 512 && Hg(b2);
          } catch (v5) {
            T2(b2, b2.return, v5);
          }
        }
        if (b2 === a2) {
          S2 = null;
          break;
        }
        c2 = b2.sibling;
        if (null !== c2) {
          c2.return = b2.return;
          S2 = c2;
          break;
        }
        S2 = b2.return;
      }
    }
    function Wg(a2) {
      for (; null !== S2; ) {
        var b2 = S2;
        if (b2 === a2) {
          S2 = null;
          break;
        }
        var c2 = b2.sibling;
        if (null !== c2) {
          c2.return = b2.return;
          S2 = c2;
          break;
        }
        S2 = b2.return;
      }
    }
    function Zg(a2) {
      for (; null !== S2; ) {
        var b2 = S2;
        try {
          switch (b2.tag) {
            case 0:
            case 11:
            case 15:
              var c2 = b2.return;
              try {
                Gg(4, b2);
              } catch (k2) {
                T2(b2, c2, k2);
              }
              break;
            case 1:
              var d2 = b2.stateNode;
              if ("function" === typeof d2.componentDidMount) {
                var e3 = b2.return;
                try {
                  d2.componentDidMount();
                } catch (k2) {
                  T2(b2, e3, k2);
                }
              }
              var f2 = b2.return;
              try {
                Hg(b2);
              } catch (k2) {
                T2(b2, f2, k2);
              }
              break;
            case 5:
              var g2 = b2.return;
              try {
                Hg(b2);
              } catch (k2) {
                T2(b2, g2, k2);
              }
          }
        } catch (k2) {
          T2(b2, b2.return, k2);
        }
        if (b2 === a2) {
          S2 = null;
          break;
        }
        var h2 = b2.sibling;
        if (null !== h2) {
          h2.return = b2.return;
          S2 = h2;
          break;
        }
        S2 = b2.return;
      }
    }
    var ah2 = 0, bh2 = 1, ch2 = 2, dh = 3, eh = 4;
    if ("function" === typeof Symbol && Symbol.for) {
      var fh = Symbol.for;
      ah2 = fh("selector.component");
      bh2 = fh("selector.has_pseudo_class");
      ch2 = fh("selector.role");
      dh = fh("selector.test_id");
      eh = fh("selector.text");
    }
    function gh(a2) {
      var b2 = Wa(a2);
      if (null != b2) {
        if ("string" !== typeof b2.memoizedProps["data-testname"])
          throw Error(n2(364));
        return b2;
      }
      a2 = cb2(a2);
      if (null === a2)
        throw Error(n2(362));
      return a2.stateNode.current;
    }
    function hh2(a2, b2) {
      switch (b2.$$typeof) {
        case ah2:
          if (a2.type === b2.value)
            return true;
          break;
        case bh2:
          a: {
            b2 = b2.value;
            a2 = [a2, 0];
            for (var c2 = 0; c2 < a2.length; ) {
              var d2 = a2[c2++], e3 = a2[c2++], f2 = b2[e3];
              if (5 !== d2.tag || !fb(d2)) {
                for (; null != f2 && hh2(d2, f2); )
                  e3++, f2 = b2[e3];
                if (e3 === b2.length) {
                  b2 = true;
                  break a;
                } else
                  for (d2 = d2.child; null !== d2; )
                    a2.push(d2, e3), d2 = d2.sibling;
              }
            }
            b2 = false;
          }
          return b2;
        case ch2:
          if (5 === a2.tag && gb(a2.stateNode, b2.value))
            return true;
          break;
        case eh:
          if (5 === a2.tag || 6 === a2.tag) {
            if (a2 = eb(a2), null !== a2 && 0 <= a2.indexOf(b2.value))
              return true;
          }
          break;
        case dh:
          if (5 === a2.tag && (a2 = a2.memoizedProps["data-testname"], "string" === typeof a2 && a2.toLowerCase() === b2.value.toLowerCase()))
            return true;
          break;
        default:
          throw Error(n2(365));
      }
      return false;
    }
    function ih(a2) {
      switch (a2.$$typeof) {
        case ah2:
          return "<" + (va(a2.value) || "Unknown") + ">";
        case bh2:
          return ":has(" + (ih(a2) || "") + ")";
        case ch2:
          return '[role="' + a2.value + '"]';
        case eh:
          return '"' + a2.value + '"';
        case dh:
          return '[data-testname="' + a2.value + '"]';
        default:
          throw Error(n2(365));
      }
    }
    function jh(a2, b2) {
      var c2 = [];
      a2 = [a2, 0];
      for (var d2 = 0; d2 < a2.length; ) {
        var e3 = a2[d2++], f2 = a2[d2++], g2 = b2[f2];
        if (5 !== e3.tag || !fb(e3)) {
          for (; null != g2 && hh2(e3, g2); )
            f2++, g2 = b2[f2];
          if (f2 === b2.length)
            c2.push(e3);
          else
            for (e3 = e3.child; null !== e3; )
              a2.push(e3, f2), e3 = e3.sibling;
        }
      }
      return c2;
    }
    function kh(a2, b2) {
      if (!bb2)
        throw Error(n2(363));
      a2 = gh(a2);
      a2 = jh(a2, b2);
      b2 = [];
      a2 = Array.from(a2);
      for (var c2 = 0; c2 < a2.length; ) {
        var d2 = a2[c2++];
        if (5 === d2.tag)
          fb(d2) || b2.push(d2.stateNode);
        else
          for (d2 = d2.child; null !== d2; )
            a2.push(d2), d2 = d2.sibling;
      }
      return b2;
    }
    var lh = Math.ceil, mh = ea.ReactCurrentDispatcher, nh = ea.ReactCurrentOwner, U2 = ea.ReactCurrentBatchConfig, G2 = 0, F2 = null, W2 = null, X2 = 0, Wf = 0, eg = gc(0), Q2 = 0, oh = null, vd = 0, ph = 0, qh = 0, rh = null, Y2 = null, Vg = 0, Uf = Infinity;
    function sh() {
      Uf = E3() + 500;
    }
    var Bf = false, Cf = null, Ef = null, th = false, uh = null, vh = 0, wh = 0, xh = null, yh = -1, zh = 0;
    function H2() {
      return 0 !== (G2 & 6) ? E3() : -1 !== yh ? yh : yh = E3();
    }
    function zd(a2) {
      if (0 === (a2.mode & 1))
        return 1;
      if (0 !== (G2 & 2) && 0 !== X2)
        return X2 & -X2;
      if (null !== Yc.transition)
        return 0 === zh && (a2 = tc, tc <<= 1, 0 === (tc & 4194240) && (tc = 64), zh = a2), zh;
      a2 = D2;
      return 0 !== a2 ? a2 : Ya();
    }
    function Ad(a2, b2, c2) {
      if (50 < wh)
        throw wh = 0, xh = null, Error(n2(185));
      var d2 = Ah(a2, b2);
      if (null === d2)
        return null;
      Bc(d2, b2, c2);
      if (0 === (G2 & 2) || d2 !== F2)
        d2 === F2 && (0 === (G2 & 2) && (ph |= b2), 4 === Q2 && Bh(d2, X2)), Z2(d2, c2), 1 === b2 && 0 === G2 && 0 === (a2.mode & 1) && (sh(), Tc && Xc());
      return d2;
    }
    function Ah(a2, b2) {
      a2.lanes |= b2;
      var c2 = a2.alternate;
      null !== c2 && (c2.lanes |= b2);
      c2 = a2;
      for (a2 = a2.return; null !== a2; )
        a2.childLanes |= b2, c2 = a2.alternate, null !== c2 && (c2.childLanes |= b2), c2 = a2, a2 = a2.return;
      return 3 === c2.tag ? c2.stateNode : null;
    }
    function Z2(a2, b2) {
      var c2 = a2.callbackNode;
      yc(a2, b2);
      var d2 = wc(a2, a2 === F2 ? X2 : 0);
      if (0 === d2)
        null !== c2 && Gc(c2), a2.callbackNode = null, a2.callbackPriority = 0;
      else if (b2 = d2 & -d2, a2.callbackPriority !== b2) {
        null != c2 && Gc(c2);
        if (1 === b2)
          0 === a2.tag ? Wc(Ch.bind(null, a2)) : Vc(Ch.bind(null, a2)), $a ? ab2(function() {
            0 === G2 && Xc();
          }) : Fc(Jc, Xc), c2 = null;
        else {
          switch (Ec(d2)) {
            case 1:
              c2 = Jc;
              break;
            case 4:
              c2 = Kc;
              break;
            case 16:
              c2 = Lc;
              break;
            case 536870912:
              c2 = Mc;
              break;
            default:
              c2 = Lc;
          }
          c2 = Dh(c2, Eh.bind(null, a2));
        }
        a2.callbackPriority = b2;
        a2.callbackNode = c2;
      }
    }
    function Eh(a2, b2) {
      yh = -1;
      zh = 0;
      if (0 !== (G2 & 6))
        throw Error(n2(327));
      var c2 = a2.callbackNode;
      if (Fh() && a2.callbackNode !== c2)
        return null;
      var d2 = wc(a2, a2 === F2 ? X2 : 0);
      if (0 === d2)
        return null;
      if (0 !== (d2 & 30) || 0 !== (d2 & a2.expiredLanes) || b2)
        b2 = Gh(a2, d2);
      else {
        b2 = d2;
        var e3 = G2;
        G2 |= 2;
        var f2 = Hh();
        if (F2 !== a2 || X2 !== b2)
          sh(), Ih(a2, b2);
        do
          try {
            Jh();
            break;
          } catch (h2) {
            Kh(a2, h2);
          }
        while (1);
        fd();
        mh.current = f2;
        G2 = e3;
        null !== W2 ? b2 = 0 : (F2 = null, X2 = 0, b2 = Q2);
      }
      if (0 !== b2) {
        2 === b2 && (e3 = zc(a2), 0 !== e3 && (d2 = e3, b2 = Lh(a2, e3)));
        if (1 === b2)
          throw c2 = oh, Ih(a2, 0), Bh(a2, d2), Z2(a2, E3()), c2;
        if (6 === b2)
          Bh(a2, d2);
        else {
          e3 = a2.current.alternate;
          if (0 === (d2 & 30) && !Mh(e3) && (b2 = Gh(a2, d2), 2 === b2 && (f2 = zc(a2), 0 !== f2 && (d2 = f2, b2 = Lh(a2, f2))), 1 === b2))
            throw c2 = oh, Ih(a2, 0), Bh(a2, d2), Z2(a2, E3()), c2;
          a2.finishedWork = e3;
          a2.finishedLanes = d2;
          switch (b2) {
            case 0:
            case 1:
              throw Error(n2(345));
            case 2:
              Nh(a2, Y2);
              break;
            case 3:
              Bh(a2, d2);
              if ((d2 & 130023424) === d2 && (b2 = Vg + 500 - E3(), 10 < b2)) {
                if (0 !== wc(a2, 0))
                  break;
                e3 = a2.suspendedLanes;
                if ((e3 & d2) !== d2) {
                  H2();
                  a2.pingedLanes |= a2.suspendedLanes & e3;
                  break;
                }
                a2.timeoutHandle = Qa(Nh.bind(null, a2, Y2), b2);
                break;
              }
              Nh(a2, Y2);
              break;
            case 4:
              Bh(a2, d2);
              if ((d2 & 4194240) === d2)
                break;
              b2 = a2.eventTimes;
              for (e3 = -1; 0 < d2; ) {
                var g2 = 31 - qc(d2);
                f2 = 1 << g2;
                g2 = b2[g2];
                g2 > e3 && (e3 = g2);
                d2 &= ~f2;
              }
              d2 = e3;
              d2 = E3() - d2;
              d2 = (120 > d2 ? 120 : 480 > d2 ? 480 : 1080 > d2 ? 1080 : 1920 > d2 ? 1920 : 3e3 > d2 ? 3e3 : 4320 > d2 ? 4320 : 1960 * lh(d2 / 1960)) - d2;
              if (10 < d2) {
                a2.timeoutHandle = Qa(Nh.bind(null, a2, Y2), d2);
                break;
              }
              Nh(a2, Y2);
              break;
            case 5:
              Nh(a2, Y2);
              break;
            default:
              throw Error(n2(329));
          }
        }
      }
      Z2(a2, E3());
      return a2.callbackNode === c2 ? Eh.bind(null, a2) : null;
    }
    function Lh(a2, b2) {
      var c2 = rh;
      a2.current.memoizedState.isDehydrated && (Ih(a2, b2).flags |= 256);
      a2 = Gh(a2, b2);
      2 !== a2 && (b2 = Y2, Y2 = c2, null !== b2 && Sf(b2));
      return a2;
    }
    function Sf(a2) {
      null === Y2 ? Y2 = a2 : Y2.push.apply(Y2, a2);
    }
    function Mh(a2) {
      for (var b2 = a2; ; ) {
        if (b2.flags & 16384) {
          var c2 = b2.updateQueue;
          if (null !== c2 && (c2 = c2.stores, null !== c2))
            for (var d2 = 0; d2 < c2.length; d2++) {
              var e3 = c2[d2], f2 = e3.getSnapshot;
              e3 = e3.value;
              try {
                if (!Rc(f2(), e3))
                  return false;
              } catch (g2) {
                return false;
              }
            }
        }
        c2 = b2.child;
        if (b2.subtreeFlags & 16384 && null !== c2)
          c2.return = b2, b2 = c2;
        else {
          if (b2 === a2)
            break;
          for (; null === b2.sibling; ) {
            if (null === b2.return || b2.return === a2)
              return true;
            b2 = b2.return;
          }
          b2.sibling.return = b2.return;
          b2 = b2.sibling;
        }
      }
      return true;
    }
    function Bh(a2, b2) {
      b2 &= ~qh;
      b2 &= ~ph;
      a2.suspendedLanes |= b2;
      a2.pingedLanes &= ~b2;
      for (a2 = a2.expirationTimes; 0 < b2; ) {
        var c2 = 31 - qc(b2), d2 = 1 << c2;
        a2[c2] = -1;
        b2 &= ~d2;
      }
    }
    function Ch(a2) {
      if (0 !== (G2 & 6))
        throw Error(n2(327));
      Fh();
      var b2 = wc(a2, 0);
      if (0 === (b2 & 1))
        return Z2(a2, E3()), null;
      var c2 = Gh(a2, b2);
      if (0 !== a2.tag && 2 === c2) {
        var d2 = zc(a2);
        0 !== d2 && (b2 = d2, c2 = Lh(a2, d2));
      }
      if (1 === c2)
        throw c2 = oh, Ih(a2, 0), Bh(a2, b2), Z2(a2, E3()), c2;
      if (6 === c2)
        throw Error(n2(345));
      a2.finishedWork = a2.current.alternate;
      a2.finishedLanes = b2;
      Nh(a2, Y2);
      Z2(a2, E3());
      return null;
    }
    function Oh(a2) {
      null !== uh && 0 === uh.tag && 0 === (G2 & 6) && Fh();
      var b2 = G2;
      G2 |= 1;
      var c2 = U2.transition, d2 = D2;
      try {
        if (U2.transition = null, D2 = 1, a2)
          return a2();
      } finally {
        D2 = d2, U2.transition = c2, G2 = b2, 0 === (G2 & 6) && Xc();
      }
    }
    function Vf() {
      Wf = eg.current;
      x2(eg);
    }
    function Ih(a2, b2) {
      a2.finishedWork = null;
      a2.finishedLanes = 0;
      var c2 = a2.timeoutHandle;
      c2 !== Sa && (a2.timeoutHandle = Sa, Ra(c2));
      if (null !== W2)
        for (c2 = W2.return; null !== c2; ) {
          var d2 = c2;
          Sd(d2);
          switch (d2.tag) {
            case 1:
              d2 = d2.type.childContextTypes;
              null !== d2 && void 0 !== d2 && kc();
              break;
            case 3:
              we();
              x2(B2);
              x2(A2);
              Be();
              break;
            case 5:
              ye(d2);
              break;
            case 4:
              we();
              break;
            case 13:
              x2(J2);
              break;
            case 19:
              x2(J2);
              break;
            case 10:
              hd(d2.type._context);
              break;
            case 22:
            case 23:
              Vf();
          }
          c2 = c2.return;
        }
      F2 = a2;
      W2 = a2 = je(a2.current, null);
      X2 = Wf = b2;
      Q2 = 0;
      oh = null;
      qh = ph = vd = 0;
      Y2 = rh = null;
      if (null !== md) {
        for (b2 = 0; b2 < md.length; b2++)
          if (c2 = md[b2], d2 = c2.interleaved, null !== d2) {
            c2.interleaved = null;
            var e3 = d2.next, f2 = c2.pending;
            if (null !== f2) {
              var g2 = f2.next;
              f2.next = e3;
              d2.next = g2;
            }
            c2.pending = d2;
          }
        md = null;
      }
      return a2;
    }
    function Kh(a2, b2) {
      do {
        var c2 = W2;
        try {
          fd();
          Ce.current = Oe;
          if (Fe) {
            for (var d2 = K2.memoizedState; null !== d2; ) {
              var e3 = d2.queue;
              null !== e3 && (e3.pending = null);
              d2 = d2.next;
            }
            Fe = false;
          }
          Ee = 0;
          M2 = L2 = K2 = null;
          Ge = false;
          He = 0;
          nh.current = null;
          if (null === c2 || null === c2.return) {
            Q2 = 1;
            oh = b2;
            W2 = null;
            break;
          }
          a: {
            var f2 = a2, g2 = c2.return, h2 = c2, k2 = b2;
            b2 = X2;
            h2.flags |= 32768;
            if (null !== k2 && "object" === typeof k2 && "function" === typeof k2.then) {
              var l2 = k2, m2 = h2, v5 = m2.tag;
              if (0 === (m2.mode & 1) && (0 === v5 || 11 === v5 || 15 === v5)) {
                var r2 = m2.alternate;
                r2 ? (m2.updateQueue = r2.updateQueue, m2.memoizedState = r2.memoizedState, m2.lanes = r2.lanes) : (m2.updateQueue = null, m2.memoizedState = null);
              }
              var z2 = Hf(g2);
              if (null !== z2) {
                z2.flags &= -257;
                If2(z2, g2, h2, f2, b2);
                z2.mode & 1 && Ff(f2, l2, b2);
                b2 = z2;
                k2 = l2;
                var q2 = b2.updateQueue;
                if (null === q2) {
                  var N2 = /* @__PURE__ */ new Set();
                  N2.add(k2);
                  b2.updateQueue = N2;
                } else
                  q2.add(k2);
                break a;
              } else {
                if (0 === (b2 & 1)) {
                  Ff(f2, l2, b2);
                  Tf();
                  break a;
                }
                k2 = Error(n2(426));
              }
            } else if (I2 && h2.mode & 1) {
              var da = Hf(g2);
              if (null !== da) {
                0 === (da.flags & 65536) && (da.flags |= 256);
                If2(da, g2, h2, f2, b2);
                ee(k2);
                break a;
              }
            }
            f2 = k2;
            4 !== Q2 && (Q2 = 2);
            null === rh ? rh = [f2] : rh.push(f2);
            k2 = xf(k2, h2);
            h2 = g2;
            do {
              switch (h2.tag) {
                case 3:
                  h2.flags |= 65536;
                  b2 &= -b2;
                  h2.lanes |= b2;
                  var t2 = Af(h2, k2, b2);
                  td(h2, t2);
                  break a;
                case 1:
                  f2 = k2;
                  var w2 = h2.type, u2 = h2.stateNode;
                  if (0 === (h2.flags & 128) && ("function" === typeof w2.getDerivedStateFromError || null !== u2 && "function" === typeof u2.componentDidCatch && (null === Ef || !Ef.has(u2)))) {
                    h2.flags |= 65536;
                    b2 &= -b2;
                    h2.lanes |= b2;
                    var V2 = Df(h2, f2, b2);
                    td(h2, V2);
                    break a;
                  }
              }
              h2 = h2.return;
            } while (null !== h2);
          }
          Ph(c2);
        } catch (wa) {
          b2 = wa;
          W2 === c2 && null !== c2 && (W2 = c2 = c2.return);
          continue;
        }
        break;
      } while (1);
    }
    function Hh() {
      var a2 = mh.current;
      mh.current = Oe;
      return null === a2 ? Oe : a2;
    }
    function Tf() {
      if (0 === Q2 || 3 === Q2 || 2 === Q2)
        Q2 = 4;
      null === F2 || 0 === (vd & 268435455) && 0 === (ph & 268435455) || Bh(F2, X2);
    }
    function Gh(a2, b2) {
      var c2 = G2;
      G2 |= 2;
      var d2 = Hh();
      F2 === a2 && X2 === b2 || Ih(a2, b2);
      do
        try {
          Qh();
          break;
        } catch (e3) {
          Kh(a2, e3);
        }
      while (1);
      fd();
      G2 = c2;
      mh.current = d2;
      if (null !== W2)
        throw Error(n2(261));
      F2 = null;
      X2 = 0;
      return Q2;
    }
    function Qh() {
      for (; null !== W2; )
        Rh(W2);
    }
    function Jh() {
      for (; null !== W2 && !Hc(); )
        Rh(W2);
    }
    function Rh(a2) {
      var b2 = Sh(a2.alternate, a2, Wf);
      a2.memoizedProps = a2.pendingProps;
      null === b2 ? Ph(a2) : W2 = b2;
      nh.current = null;
    }
    function Ph(a2) {
      var b2 = a2;
      do {
        var c2 = b2.alternate;
        a2 = b2.return;
        if (0 === (b2.flags & 32768)) {
          if (c2 = Rf(c2, b2, Wf), null !== c2) {
            W2 = c2;
            return;
          }
        } else {
          c2 = xg(c2, b2);
          if (null !== c2) {
            c2.flags &= 32767;
            W2 = c2;
            return;
          }
          if (null !== a2)
            a2.flags |= 32768, a2.subtreeFlags = 0, a2.deletions = null;
          else {
            Q2 = 6;
            W2 = null;
            return;
          }
        }
        b2 = b2.sibling;
        if (null !== b2) {
          W2 = b2;
          return;
        }
        W2 = b2 = a2;
      } while (null !== b2);
      0 === Q2 && (Q2 = 5);
    }
    function Nh(a2, b2) {
      var c2 = D2, d2 = U2.transition;
      try {
        U2.transition = null, D2 = 1, Th(a2, b2, c2);
      } finally {
        U2.transition = d2, D2 = c2;
      }
      return null;
    }
    function Th(a2, b2, c2) {
      do
        Fh();
      while (null !== uh);
      if (0 !== (G2 & 6))
        throw Error(n2(327));
      var d2 = a2.finishedWork, e3 = a2.finishedLanes;
      if (null === d2)
        return null;
      a2.finishedWork = null;
      a2.finishedLanes = 0;
      if (d2 === a2.current)
        throw Error(n2(177));
      a2.callbackNode = null;
      a2.callbackPriority = 0;
      var f2 = d2.lanes | d2.childLanes;
      Cc(a2, f2);
      a2 === F2 && (W2 = F2 = null, X2 = 0);
      0 === (d2.subtreeFlags & 2064) && 0 === (d2.flags & 2064) || th || (th = true, Dh(Lc, function() {
        Fh();
        return null;
      }));
      f2 = 0 !== (d2.flags & 15990);
      if (0 !== (d2.subtreeFlags & 15990) || f2) {
        f2 = U2.transition;
        U2.transition = null;
        var g2 = D2;
        D2 = 1;
        var h2 = G2;
        G2 |= 4;
        nh.current = null;
        Eg(a2, d2);
        Ug(a2, d2);
        Ja(a2.containerInfo);
        a2.current = d2;
        Xg(d2);
        Ic();
        G2 = h2;
        D2 = g2;
        U2.transition = f2;
      } else
        a2.current = d2;
      th && (th = false, uh = a2, vh = e3);
      f2 = a2.pendingLanes;
      0 === f2 && (Ef = null);
      Pc(d2.stateNode);
      Z2(a2, E3());
      if (null !== b2)
        for (c2 = a2.onRecoverableError, d2 = 0; d2 < b2.length; d2++)
          c2(b2[d2]);
      if (Bf)
        throw Bf = false, a2 = Cf, Cf = null, a2;
      0 !== (vh & 1) && 0 !== a2.tag && Fh();
      f2 = a2.pendingLanes;
      0 !== (f2 & 1) ? a2 === xh ? wh++ : (wh = 0, xh = a2) : wh = 0;
      Xc();
      return null;
    }
    function Fh() {
      if (null !== uh) {
        var a2 = Ec(vh), b2 = U2.transition, c2 = D2;
        try {
          U2.transition = null;
          D2 = 16 > a2 ? 16 : a2;
          if (null === uh)
            var d2 = false;
          else {
            a2 = uh;
            uh = null;
            vh = 0;
            if (0 !== (G2 & 6))
              throw Error(n2(331));
            var e3 = G2;
            G2 |= 4;
            for (S2 = a2.current; null !== S2; ) {
              var f2 = S2, g2 = f2.child;
              if (0 !== (S2.flags & 16)) {
                var h2 = f2.deletions;
                if (null !== h2) {
                  for (var k2 = 0; k2 < h2.length; k2++) {
                    var l2 = h2[k2];
                    for (S2 = l2; null !== S2; ) {
                      var m2 = S2;
                      switch (m2.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Fg(8, m2, f2);
                      }
                      var v5 = m2.child;
                      if (null !== v5)
                        v5.return = m2, S2 = v5;
                      else
                        for (; null !== S2; ) {
                          m2 = S2;
                          var r2 = m2.sibling, z2 = m2.return;
                          Lg(m2);
                          if (m2 === l2) {
                            S2 = null;
                            break;
                          }
                          if (null !== r2) {
                            r2.return = z2;
                            S2 = r2;
                            break;
                          }
                          S2 = z2;
                        }
                    }
                  }
                  var q2 = f2.alternate;
                  if (null !== q2) {
                    var N2 = q2.child;
                    if (null !== N2) {
                      q2.child = null;
                      do {
                        var da = N2.sibling;
                        N2.sibling = null;
                        N2 = da;
                      } while (null !== N2);
                    }
                  }
                  S2 = f2;
                }
              }
              if (0 !== (f2.subtreeFlags & 2064) && null !== g2)
                g2.return = f2, S2 = g2;
              else
                b:
                  for (; null !== S2; ) {
                    f2 = S2;
                    if (0 !== (f2.flags & 2048))
                      switch (f2.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Fg(9, f2, f2.return);
                      }
                    var t2 = f2.sibling;
                    if (null !== t2) {
                      t2.return = f2.return;
                      S2 = t2;
                      break b;
                    }
                    S2 = f2.return;
                  }
            }
            var w2 = a2.current;
            for (S2 = w2; null !== S2; ) {
              g2 = S2;
              var u2 = g2.child;
              if (0 !== (g2.subtreeFlags & 2064) && null !== u2)
                u2.return = g2, S2 = u2;
              else
                b:
                  for (g2 = w2; null !== S2; ) {
                    h2 = S2;
                    if (0 !== (h2.flags & 2048))
                      try {
                        switch (h2.tag) {
                          case 0:
                          case 11:
                          case 15:
                            Gg(9, h2);
                        }
                      } catch (wa) {
                        T2(h2, h2.return, wa);
                      }
                    if (h2 === g2) {
                      S2 = null;
                      break b;
                    }
                    var V2 = h2.sibling;
                    if (null !== V2) {
                      V2.return = h2.return;
                      S2 = V2;
                      break b;
                    }
                    S2 = h2.return;
                  }
            }
            G2 = e3;
            Xc();
            if (Oc && "function" === typeof Oc.onPostCommitFiberRoot)
              try {
                Oc.onPostCommitFiberRoot(Nc, a2);
              } catch (wa) {
              }
            d2 = true;
          }
          return d2;
        } finally {
          D2 = c2, U2.transition = b2;
        }
      }
      return false;
    }
    function Uh(a2, b2, c2) {
      b2 = xf(c2, b2);
      b2 = Af(a2, b2, 1);
      rd(a2, b2);
      b2 = H2();
      a2 = Ah(a2, 1);
      null !== a2 && (Bc(a2, 1, b2), Z2(a2, b2));
    }
    function T2(a2, b2, c2) {
      if (3 === a2.tag)
        Uh(a2, a2, c2);
      else
        for (; null !== b2; ) {
          if (3 === b2.tag) {
            Uh(b2, a2, c2);
            break;
          } else if (1 === b2.tag) {
            var d2 = b2.stateNode;
            if ("function" === typeof b2.type.getDerivedStateFromError || "function" === typeof d2.componentDidCatch && (null === Ef || !Ef.has(d2))) {
              a2 = xf(c2, a2);
              a2 = Df(b2, a2, 1);
              rd(b2, a2);
              a2 = H2();
              b2 = Ah(b2, 1);
              null !== b2 && (Bc(b2, 1, a2), Z2(b2, a2));
              break;
            }
          }
          b2 = b2.return;
        }
    }
    function Gf(a2, b2, c2) {
      var d2 = a2.pingCache;
      null !== d2 && d2.delete(b2);
      b2 = H2();
      a2.pingedLanes |= a2.suspendedLanes & c2;
      F2 === a2 && (X2 & c2) === c2 && (4 === Q2 || 3 === Q2 && (X2 & 130023424) === X2 && 500 > E3() - Vg ? Ih(a2, 0) : qh |= c2);
      Z2(a2, b2);
    }
    function Vh(a2, b2) {
      0 === b2 && (0 === (a2.mode & 1) ? b2 = 1 : (b2 = uc, uc <<= 1, 0 === (uc & 130023424) && (uc = 4194304)));
      var c2 = H2();
      a2 = Ah(a2, b2);
      null !== a2 && (Bc(a2, b2, c2), Z2(a2, c2));
    }
    function qg(a2) {
      var b2 = a2.memoizedState, c2 = 0;
      null !== b2 && (c2 = b2.retryLane);
      Vh(a2, c2);
    }
    function Tg(a2, b2) {
      var c2 = 0;
      switch (a2.tag) {
        case 13:
          var d2 = a2.stateNode;
          var e3 = a2.memoizedState;
          null !== e3 && (c2 = e3.retryLane);
          break;
        case 19:
          d2 = a2.stateNode;
          break;
        default:
          throw Error(n2(314));
      }
      null !== d2 && d2.delete(b2);
      Vh(a2, c2);
    }
    var Sh;
    Sh = function(a2, b2, c2) {
      if (null !== a2)
        if (a2.memoizedProps !== b2.pendingProps || B2.current)
          kd = true;
        else {
          if (0 === (a2.lanes & c2) && 0 === (b2.flags & 128))
            return kd = false, wg(a2, b2, c2);
          kd = 0 !== (a2.flags & 131072) ? true : false;
        }
      else
        kd = false, I2 && 0 !== (b2.flags & 1048576) && Qd(b2, Jd, b2.index);
      b2.lanes = 0;
      switch (b2.tag) {
        case 2:
          var d2 = b2.type;
          null !== a2 && (a2.alternate = null, b2.alternate = null, b2.flags |= 2);
          a2 = b2.pendingProps;
          var e3 = jc(b2, A2.current);
          jd(b2, c2);
          e3 = Ke(null, b2, d2, a2, e3, c2);
          var f2 = Pe();
          b2.flags |= 1;
          "object" === typeof e3 && null !== e3 && "function" === typeof e3.render && void 0 === e3.$$typeof ? (b2.tag = 1, b2.memoizedState = null, b2.updateQueue = null, C2(d2) ? (f2 = true, nc(b2)) : f2 = false, b2.memoizedState = null !== e3.state && void 0 !== e3.state ? e3.state : null, od(b2), e3.updater = Bd, b2.stateNode = e3, e3._reactInternals = b2, Fd(b2, d2, a2, c2), b2 = hg(null, b2, d2, true, f2, c2)) : (b2.tag = 0, I2 && f2 && Rd(b2), R2(null, b2, e3, c2), b2 = b2.child);
          return b2;
        case 16:
          d2 = b2.elementType;
          a: {
            null !== a2 && (a2.alternate = null, b2.alternate = null, b2.flags |= 2);
            a2 = b2.pendingProps;
            e3 = d2._init;
            d2 = e3(d2._payload);
            b2.type = d2;
            e3 = b2.tag = Wh(d2);
            a2 = ad2(d2, a2);
            switch (e3) {
              case 0:
                b2 = cg2(null, b2, d2, a2, c2);
                break a;
              case 1:
                b2 = gg2(
                  null,
                  b2,
                  d2,
                  a2,
                  c2
                );
                break a;
              case 11:
                b2 = Yf(null, b2, d2, a2, c2);
                break a;
              case 14:
                b2 = $f(null, b2, d2, ad2(d2.type, a2), c2);
                break a;
            }
            throw Error(n2(306, d2, ""));
          }
          return b2;
        case 0:
          return d2 = b2.type, e3 = b2.pendingProps, e3 = b2.elementType === d2 ? e3 : ad2(d2, e3), cg2(a2, b2, d2, e3, c2);
        case 1:
          return d2 = b2.type, e3 = b2.pendingProps, e3 = b2.elementType === d2 ? e3 : ad2(d2, e3), gg2(a2, b2, d2, e3, c2);
        case 3:
          a: {
            ig(b2);
            if (null === a2)
              throw Error(n2(387));
            d2 = b2.pendingProps;
            f2 = b2.memoizedState;
            e3 = f2.element;
            pd(a2, b2);
            ud(b2, d2, null, c2);
            var g2 = b2.memoizedState;
            d2 = g2.element;
            if (p2 && f2.isDehydrated)
              if (f2 = {
                element: d2,
                isDehydrated: false,
                cache: g2.cache,
                transitions: g2.transitions
              }, b2.updateQueue.baseState = f2, b2.memoizedState = f2, b2.flags & 256) {
                e3 = Error(n2(423));
                b2 = jg(a2, b2, d2, c2, e3);
                break a;
              } else if (d2 !== e3) {
                e3 = Error(n2(424));
                b2 = jg(a2, b2, d2, c2, e3);
                break a;
              } else
                for (p2 && (Ud = Nb(b2.stateNode.containerInfo), Td = b2, I2 = true, Wd = null, Vd = false), c2 = pe(b2, null, d2, c2), b2.child = c2; c2; )
                  c2.flags = c2.flags & -3 | 4096, c2 = c2.sibling;
            else {
              de();
              if (d2 === e3) {
                b2 = Zf(a2, b2, c2);
                break a;
              }
              R2(a2, b2, d2, c2);
            }
            b2 = b2.child;
          }
          return b2;
        case 5:
          return xe(b2), null === a2 && ae2(b2), d2 = b2.type, e3 = b2.pendingProps, f2 = null !== a2 ? a2.memoizedProps : null, g2 = e3.children, Oa(d2, e3) ? g2 = null : null !== f2 && Oa(d2, f2) && (b2.flags |= 32), fg(a2, b2), R2(a2, b2, g2, c2), b2.child;
        case 6:
          return null === a2 && ae2(b2), null;
        case 13:
          return mg(a2, b2, c2);
        case 4:
          return ve(b2, b2.stateNode.containerInfo), d2 = b2.pendingProps, null === a2 ? b2.child = oe(b2, null, d2, c2) : R2(a2, b2, d2, c2), b2.child;
        case 11:
          return d2 = b2.type, e3 = b2.pendingProps, e3 = b2.elementType === d2 ? e3 : ad2(d2, e3), Yf(a2, b2, d2, e3, c2);
        case 7:
          return R2(a2, b2, b2.pendingProps, c2), b2.child;
        case 8:
          return R2(a2, b2, b2.pendingProps.children, c2), b2.child;
        case 12:
          return R2(a2, b2, b2.pendingProps.children, c2), b2.child;
        case 10:
          a: {
            d2 = b2.type._context;
            e3 = b2.pendingProps;
            f2 = b2.memoizedProps;
            g2 = e3.value;
            gd(b2, d2, g2);
            if (null !== f2)
              if (Rc(f2.value, g2)) {
                if (f2.children === e3.children && !B2.current) {
                  b2 = Zf(a2, b2, c2);
                  break a;
                }
              } else
                for (f2 = b2.child, null !== f2 && (f2.return = b2); null !== f2; ) {
                  var h2 = f2.dependencies;
                  if (null !== h2) {
                    g2 = f2.child;
                    for (var k2 = h2.firstContext; null !== k2; ) {
                      if (k2.context === d2) {
                        if (1 === f2.tag) {
                          k2 = qd(-1, c2 & -c2);
                          k2.tag = 2;
                          var l2 = f2.updateQueue;
                          if (null !== l2) {
                            l2 = l2.shared;
                            var m2 = l2.pending;
                            null === m2 ? k2.next = k2 : (k2.next = m2.next, m2.next = k2);
                            l2.pending = k2;
                          }
                        }
                        f2.lanes |= c2;
                        k2 = f2.alternate;
                        null !== k2 && (k2.lanes |= c2);
                        id(f2.return, c2, b2);
                        h2.lanes |= c2;
                        break;
                      }
                      k2 = k2.next;
                    }
                  } else if (10 === f2.tag)
                    g2 = f2.type === b2.type ? null : f2.child;
                  else if (18 === f2.tag) {
                    g2 = f2.return;
                    if (null === g2)
                      throw Error(n2(341));
                    g2.lanes |= c2;
                    h2 = g2.alternate;
                    null !== h2 && (h2.lanes |= c2);
                    id(g2, c2, b2);
                    g2 = f2.sibling;
                  } else
                    g2 = f2.child;
                  if (null !== g2)
                    g2.return = f2;
                  else
                    for (g2 = f2; null !== g2; ) {
                      if (g2 === b2) {
                        g2 = null;
                        break;
                      }
                      f2 = g2.sibling;
                      if (null !== f2) {
                        f2.return = g2.return;
                        g2 = f2;
                        break;
                      }
                      g2 = g2.return;
                    }
                  f2 = g2;
                }
            R2(a2, b2, e3.children, c2);
            b2 = b2.child;
          }
          return b2;
        case 9:
          return e3 = b2.type, d2 = b2.pendingProps.children, jd(b2, c2), e3 = ld(e3), d2 = d2(e3), b2.flags |= 1, R2(a2, b2, d2, c2), b2.child;
        case 14:
          return d2 = b2.type, e3 = ad2(d2, b2.pendingProps), e3 = ad2(d2.type, e3), $f(a2, b2, d2, e3, c2);
        case 15:
          return bg2(a2, b2, b2.type, b2.pendingProps, c2);
        case 17:
          return d2 = b2.type, e3 = b2.pendingProps, e3 = b2.elementType === d2 ? e3 : ad2(d2, e3), null !== a2 && (a2.alternate = null, b2.alternate = null, b2.flags |= 2), b2.tag = 1, C2(d2) ? (a2 = true, nc(b2)) : a2 = false, jd(b2, c2), Dd(b2, d2, e3), Fd(b2, d2, e3, c2), hg(null, b2, d2, true, a2, c2);
        case 19:
          return vg(a2, b2, c2);
        case 22:
          return dg(a2, b2, c2);
      }
      throw Error(n2(156, b2.tag));
    };
    function Dh(a2, b2) {
      return Fc(a2, b2);
    }
    function Xh(a2, b2, c2, d2) {
      this.tag = a2;
      this.key = c2;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.ref = null;
      this.pendingProps = b2;
      this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = d2;
      this.subtreeFlags = this.flags = 0;
      this.deletions = null;
      this.childLanes = this.lanes = 0;
      this.alternate = null;
    }
    function Yd(a2, b2, c2, d2) {
      return new Xh(a2, b2, c2, d2);
    }
    function ag2(a2) {
      a2 = a2.prototype;
      return !(!a2 || !a2.isReactComponent);
    }
    function Wh(a2) {
      if ("function" === typeof a2)
        return ag2(a2) ? 1 : 0;
      if (void 0 !== a2 && null !== a2) {
        a2 = a2.$$typeof;
        if (a2 === na)
          return 11;
        if (a2 === qa)
          return 14;
      }
      return 2;
    }
    function je(a2, b2) {
      var c2 = a2.alternate;
      null === c2 ? (c2 = Yd(a2.tag, b2, a2.key, a2.mode), c2.elementType = a2.elementType, c2.type = a2.type, c2.stateNode = a2.stateNode, c2.alternate = a2, a2.alternate = c2) : (c2.pendingProps = b2, c2.type = a2.type, c2.flags = 0, c2.subtreeFlags = 0, c2.deletions = null);
      c2.flags = a2.flags & 14680064;
      c2.childLanes = a2.childLanes;
      c2.lanes = a2.lanes;
      c2.child = a2.child;
      c2.memoizedProps = a2.memoizedProps;
      c2.memoizedState = a2.memoizedState;
      c2.updateQueue = a2.updateQueue;
      b2 = a2.dependencies;
      c2.dependencies = null === b2 ? null : { lanes: b2.lanes, firstContext: b2.firstContext };
      c2.sibling = a2.sibling;
      c2.index = a2.index;
      c2.ref = a2.ref;
      return c2;
    }
    function le2(a2, b2, c2, d2, e3, f2) {
      var g2 = 2;
      d2 = a2;
      if ("function" === typeof a2)
        ag2(a2) && (g2 = 1);
      else if ("string" === typeof a2)
        g2 = 5;
      else
        a:
          switch (a2) {
            case ia:
              return ne(c2.children, e3, f2, b2);
            case ja:
              g2 = 8;
              e3 |= 8;
              break;
            case ka:
              return a2 = Yd(12, c2, b2, e3 | 2), a2.elementType = ka, a2.lanes = f2, a2;
            case oa:
              return a2 = Yd(13, c2, b2, e3), a2.elementType = oa, a2.lanes = f2, a2;
            case pa:
              return a2 = Yd(19, c2, b2, e3), a2.elementType = pa, a2.lanes = f2, a2;
            case sa:
              return ng(c2, e3, f2, b2);
            default:
              if ("object" === typeof a2 && null !== a2)
                switch (a2.$$typeof) {
                  case la:
                    g2 = 10;
                    break a;
                  case ma:
                    g2 = 9;
                    break a;
                  case na:
                    g2 = 11;
                    break a;
                  case qa:
                    g2 = 14;
                    break a;
                  case ra:
                    g2 = 16;
                    d2 = null;
                    break a;
                }
              throw Error(n2(130, null == a2 ? a2 : typeof a2, ""));
          }
      b2 = Yd(g2, c2, b2, e3);
      b2.elementType = a2;
      b2.type = d2;
      b2.lanes = f2;
      return b2;
    }
    function ne(a2, b2, c2, d2) {
      a2 = Yd(7, a2, d2, b2);
      a2.lanes = c2;
      return a2;
    }
    function ng(a2, b2, c2, d2) {
      a2 = Yd(22, a2, d2, b2);
      a2.elementType = sa;
      a2.lanes = c2;
      a2.stateNode = {};
      return a2;
    }
    function ke(a2, b2, c2) {
      a2 = Yd(6, a2, null, b2);
      a2.lanes = c2;
      return a2;
    }
    function me(a2, b2, c2) {
      b2 = Yd(4, null !== a2.children ? a2.children : [], a2.key, b2);
      b2.lanes = c2;
      b2.stateNode = { containerInfo: a2.containerInfo, pendingChildren: null, implementation: a2.implementation };
      return b2;
    }
    function Yh(a2, b2, c2, d2, e3) {
      this.tag = b2;
      this.containerInfo = a2;
      this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
      this.timeoutHandle = Sa;
      this.callbackNode = this.pendingContext = this.context = null;
      this.callbackPriority = 0;
      this.eventTimes = Ac(0);
      this.expirationTimes = Ac(-1);
      this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
      this.entanglements = Ac(0);
      this.identifierPrefix = d2;
      this.onRecoverableError = e3;
      p2 && (this.mutableSourceEagerHydrationData = null);
    }
    function Zh(a2, b2, c2, d2, e3, f2, g2, h2, k2) {
      a2 = new Yh(a2, b2, c2, h2, k2);
      1 === b2 ? (b2 = 1, true === f2 && (b2 |= 8)) : b2 = 0;
      f2 = Yd(3, null, null, b2);
      a2.current = f2;
      f2.stateNode = a2;
      f2.memoizedState = { element: d2, isDehydrated: c2, cache: null, transitions: null };
      od(f2);
      return a2;
    }
    function $h(a2) {
      if (!a2)
        return hc;
      a2 = a2._reactInternals;
      a: {
        if (ya(a2) !== a2 || 1 !== a2.tag)
          throw Error(n2(170));
        var b2 = a2;
        do {
          switch (b2.tag) {
            case 3:
              b2 = b2.stateNode.context;
              break a;
            case 1:
              if (C2(b2.type)) {
                b2 = b2.stateNode.__reactInternalMemoizedMergedChildContext;
                break a;
              }
          }
          b2 = b2.return;
        } while (null !== b2);
        throw Error(n2(171));
      }
      if (1 === a2.tag) {
        var c2 = a2.type;
        if (C2(c2))
          return mc(a2, c2, b2);
      }
      return b2;
    }
    function ai2(a2) {
      var b2 = a2._reactInternals;
      if (void 0 === b2) {
        if ("function" === typeof a2.render)
          throw Error(n2(188));
        a2 = Object.keys(a2).join(",");
        throw Error(n2(268, a2));
      }
      a2 = Ba(b2);
      return null === a2 ? null : a2.stateNode;
    }
    function bi2(a2, b2) {
      a2 = a2.memoizedState;
      if (null !== a2 && null !== a2.dehydrated) {
        var c2 = a2.retryLane;
        a2.retryLane = 0 !== c2 && c2 < b2 ? c2 : b2;
      }
    }
    function ci2(a2, b2) {
      bi2(a2, b2);
      (a2 = a2.alternate) && bi2(a2, b2);
    }
    function di(a2) {
      a2 = Ba(a2);
      return null === a2 ? null : a2.stateNode;
    }
    function ei() {
      return null;
    }
    exports2.attemptContinuousHydration = function(a2) {
      if (13 === a2.tag) {
        var b2 = H2();
        Ad(a2, 134217728, b2);
        ci2(a2, 134217728);
      }
    };
    exports2.attemptHydrationAtCurrentPriority = function(a2) {
      if (13 === a2.tag) {
        var b2 = H2(), c2 = zd(a2);
        Ad(a2, c2, b2);
        ci2(a2, c2);
      }
    };
    exports2.attemptSynchronousHydration = function(a2) {
      switch (a2.tag) {
        case 3:
          var b2 = a2.stateNode;
          if (b2.current.memoizedState.isDehydrated) {
            var c2 = vc(b2.pendingLanes);
            0 !== c2 && (Dc(b2, c2 | 1), Z2(b2, E3()), 0 === (G2 & 6) && (sh(), Xc()));
          }
          break;
        case 13:
          var d2 = H2();
          Oh(function() {
            return Ad(a2, 1, d2);
          });
          ci2(a2, 1);
      }
    };
    exports2.batchedUpdates = function(a2, b2) {
      var c2 = G2;
      G2 |= 1;
      try {
        return a2(b2);
      } finally {
        G2 = c2, 0 === G2 && (sh(), Tc && Xc());
      }
    };
    exports2.createComponentSelector = function(a2) {
      return { $$typeof: ah2, value: a2 };
    };
    exports2.createContainer = function(a2, b2, c2, d2, e3, f2, g2) {
      return Zh(a2, b2, false, null, c2, d2, e3, f2, g2);
    };
    exports2.createHasPseudoClassSelector = function(a2) {
      return { $$typeof: bh2, value: a2 };
    };
    exports2.createHydrationContainer = function(a2, b2, c2, d2, e3, f2, g2, h2, k2) {
      a2 = Zh(c2, d2, true, a2, e3, f2, g2, h2, k2);
      a2.context = $h(null);
      c2 = a2.current;
      d2 = H2();
      e3 = zd(c2);
      f2 = qd(d2, e3);
      f2.callback = void 0 !== b2 && null !== b2 ? b2 : null;
      rd(c2, f2);
      a2.current.lanes = e3;
      Bc(a2, e3, d2);
      Z2(a2, d2);
      return a2;
    };
    exports2.createPortal = function(a2, b2, c2) {
      var d2 = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
      return { $$typeof: ha, key: null == d2 ? null : "" + d2, children: a2, containerInfo: b2, implementation: c2 };
    };
    exports2.createRoleSelector = function(a2) {
      return { $$typeof: ch2, value: a2 };
    };
    exports2.createTestNameSelector = function(a2) {
      return { $$typeof: dh, value: a2 };
    };
    exports2.createTextSelector = function(a2) {
      return { $$typeof: eh, value: a2 };
    };
    exports2.deferredUpdates = function(a2) {
      var b2 = D2, c2 = U2.transition;
      try {
        return U2.transition = null, D2 = 16, a2();
      } finally {
        D2 = b2, U2.transition = c2;
      }
    };
    exports2.discreteUpdates = function(a2, b2, c2, d2, e3) {
      var f2 = D2, g2 = U2.transition;
      try {
        return U2.transition = null, D2 = 1, a2(b2, c2, d2, e3);
      } finally {
        D2 = f2, U2.transition = g2, 0 === G2 && sh();
      }
    };
    exports2.findAllNodes = kh;
    exports2.findBoundingRects = function(a2, b2) {
      if (!bb2)
        throw Error(n2(363));
      b2 = kh(a2, b2);
      a2 = [];
      for (var c2 = 0; c2 < b2.length; c2++)
        a2.push(db(b2[c2]));
      for (b2 = a2.length - 1; 0 < b2; b2--) {
        c2 = a2[b2];
        for (var d2 = c2.x, e3 = d2 + c2.width, f2 = c2.y, g2 = f2 + c2.height, h2 = b2 - 1; 0 <= h2; h2--)
          if (b2 !== h2) {
            var k2 = a2[h2], l2 = k2.x, m2 = l2 + k2.width, v5 = k2.y, r2 = v5 + k2.height;
            if (d2 >= l2 && f2 >= v5 && e3 <= m2 && g2 <= r2) {
              a2.splice(b2, 1);
              break;
            } else if (!(d2 !== l2 || c2.width !== k2.width || r2 < f2 || v5 > g2)) {
              v5 > f2 && (k2.height += v5 - f2, k2.y = f2);
              r2 < g2 && (k2.height = g2 - v5);
              a2.splice(b2, 1);
              break;
            } else if (!(f2 !== v5 || c2.height !== k2.height || m2 < d2 || l2 > e3)) {
              l2 > d2 && (k2.width += l2 - d2, k2.x = d2);
              m2 < e3 && (k2.width = e3 - l2);
              a2.splice(b2, 1);
              break;
            }
          }
      }
      return a2;
    };
    exports2.findHostInstance = ai2;
    exports2.findHostInstanceWithNoPortals = function(a2) {
      a2 = Aa(a2);
      a2 = null !== a2 ? Da(a2) : null;
      return null === a2 ? null : a2.stateNode;
    };
    exports2.findHostInstanceWithWarning = function(a2) {
      return ai2(a2);
    };
    exports2.flushControlled = function(a2) {
      var b2 = G2;
      G2 |= 1;
      var c2 = U2.transition, d2 = D2;
      try {
        U2.transition = null, D2 = 1, a2();
      } finally {
        D2 = d2, U2.transition = c2, G2 = b2, 0 === G2 && (sh(), Xc());
      }
    };
    exports2.flushPassiveEffects = Fh;
    exports2.flushSync = Oh;
    exports2.focusWithin = function(a2, b2) {
      if (!bb2)
        throw Error(n2(363));
      a2 = gh(a2);
      b2 = jh(a2, b2);
      b2 = Array.from(b2);
      for (a2 = 0; a2 < b2.length; ) {
        var c2 = b2[a2++];
        if (!fb(c2)) {
          if (5 === c2.tag && hb(c2.stateNode))
            return true;
          for (c2 = c2.child; null !== c2; )
            b2.push(c2), c2 = c2.sibling;
        }
      }
      return false;
    };
    exports2.getCurrentUpdatePriority = function() {
      return D2;
    };
    exports2.getFindAllNodesFailureDescription = function(a2, b2) {
      if (!bb2)
        throw Error(n2(363));
      var c2 = 0, d2 = [];
      a2 = [gh(a2), 0];
      for (var e3 = 0; e3 < a2.length; ) {
        var f2 = a2[e3++], g2 = a2[e3++], h2 = b2[g2];
        if (5 !== f2.tag || !fb(f2)) {
          if (hh2(f2, h2) && (d2.push(ih(h2)), g2++, g2 > c2 && (c2 = g2)), g2 < b2.length)
            for (f2 = f2.child; null !== f2; )
              a2.push(f2, g2), f2 = f2.sibling;
        }
      }
      if (c2 < b2.length) {
        for (a2 = []; c2 < b2.length; c2++)
          a2.push(ih(b2[c2]));
        return "findAllNodes was able to match part of the selector:\n  " + (d2.join(" > ") + "\n\nNo matching component was found for:\n  ") + a2.join(" > ");
      }
      return null;
    };
    exports2.getPublicRootInstance = function(a2) {
      a2 = a2.current;
      if (!a2.child)
        return null;
      switch (a2.child.tag) {
        case 5:
          return Fa(a2.child.stateNode);
        default:
          return a2.child.stateNode;
      }
    };
    exports2.injectIntoDevTools = function(a2) {
      a2 = { bundleType: a2.bundleType, version: a2.version, rendererPackageName: a2.rendererPackageName, rendererConfig: a2.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ea.ReactCurrentDispatcher, findHostInstanceByFiber: di, findFiberByHostInstance: a2.findFiberByHostInstance || ei, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.0.0-fc46dba67-20220329" };
      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)
        a2 = false;
      else {
        var b2 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (b2.isDisabled || !b2.supportsFiber)
          a2 = true;
        else {
          try {
            Nc = b2.inject(a2), Oc = b2;
          } catch (c2) {
          }
          a2 = b2.checkDCE ? true : false;
        }
      }
      return a2;
    };
    exports2.isAlreadyRendering = function() {
      return false;
    };
    exports2.observeVisibleRects = function(a2, b2, c2, d2) {
      if (!bb2)
        throw Error(n2(363));
      a2 = kh(a2, b2);
      var e3 = ib(a2, c2, d2).disconnect;
      return { disconnect: function() {
        e3();
      } };
    };
    exports2.registerMutableSourceForHydration = function(a2, b2) {
      var c2 = b2._getVersion;
      c2 = c2(b2._source);
      null == a2.mutableSourceEagerHydrationData ? a2.mutableSourceEagerHydrationData = [b2, c2] : a2.mutableSourceEagerHydrationData.push(b2, c2);
    };
    exports2.runWithPriority = function(a2, b2) {
      var c2 = D2;
      try {
        return D2 = a2, b2();
      } finally {
        D2 = c2;
      }
    };
    exports2.shouldError = function() {
      return null;
    };
    exports2.shouldSuspend = function() {
      return false;
    };
    exports2.updateContainer = function(a2, b2, c2, d2) {
      var e3 = b2.current, f2 = H2(), g2 = zd(e3);
      c2 = $h(c2);
      null === b2.context ? b2.context = c2 : b2.pendingContext = c2;
      b2 = qd(f2, g2);
      b2.payload = { element: a2 };
      d2 = void 0 === d2 ? null : d2;
      null !== d2 && (b2.callback = d2);
      rd(e3, b2);
      a2 = Ad(e3, g2, f2);
      null !== a2 && sd(a2, e3, g2);
      return g2;
    };
    return exports2;
  };
  return reactReconciler_production_min;
}
var reactReconciler_developmentExports = {};
var reactReconciler_development = {
  get exports() {
    return reactReconciler_developmentExports;
  },
  set exports(v5) {
    reactReconciler_developmentExports = v5;
  }
};
/**
 * @license React
 * react-reconciler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactReconciler_development;
function requireReactReconciler_development() {
  if (hasRequiredReactReconciler_development)
    return reactReconciler_developmentExports;
  hasRequiredReactReconciler_development = 1;
  if (process.env.NODE_ENV !== "production") {
    reactReconciler_development.exports = function $$$reconciler($$$hostConfig) {
      var exports2 = {};
      var React2 = React__default;
      var Scheduler2 = schedulerExports;
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      var suppressWarning = false;
      function setSuppressWarning(newSuppressWarning) {
        {
          suppressWarning = newSuppressWarning;
        }
      }
      function warn(format) {
        {
          if (!suppressWarning) {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning("warn", format, args);
          }
        }
      }
      function error2(format) {
        {
          if (!suppressWarning) {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack2 = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack2 !== "") {
            format += "%s";
            args = args.concat([stack2]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var assign3 = Object.assign;
      function get6(key) {
        return key._reactInternals;
      }
      function set(key, value) {
        key._reactInternals = value;
      }
      var enablePersistentOffscreenHostContainer = false;
      var enableNewReconciler = false;
      var enableLazyContextPropagation = false;
      var enableLegacyHidden = false;
      var enableSuspenseAvoidThisFallback = false;
      var warnAboutStringRefs = false;
      var enableSchedulingProfiler = true;
      var enableProfilerTimer = true;
      var enableProfilerCommitHooks = true;
      var FunctionComponent = 0;
      var ClassComponent = 1;
      var IndeterminateComponent = 2;
      var HostRoot = 3;
      var HostPortal = 4;
      var HostComponent = 5;
      var HostText = 6;
      var Fragment2 = 7;
      var Mode = 8;
      var ContextConsumer = 9;
      var ContextProvider = 10;
      var ForwardRef = 11;
      var Profiler = 12;
      var SuspenseComponent = 13;
      var MemoComponent = 14;
      var SimpleMemoComponent = 15;
      var LazyComponent = 16;
      var IncompleteClassComponent = 17;
      var DehydratedFragment = 18;
      var SuspenseListComponent = 19;
      var ScopeComponent = 21;
      var OffscreenComponent = 22;
      var LegacyHiddenComponent = 23;
      var CacheComponent = 24;
      var TracingMarkerComponent = 25;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_SCOPE_TYPE = Symbol.for("react.scope");
      var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
      var REACT_CACHE_TYPE = Symbol.for("react.cache");
      var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error2("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context2 = type;
              return getContextName(context2) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init9 = lazyComponent._init;
              try {
                return getComponentNameFromType(init9(payload));
              } catch (x2) {
                return null;
              }
            }
          }
        }
        return null;
      }
      function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
      }
      function getContextName$1(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromFiber(fiber) {
        var tag2 = fiber.tag, type = fiber.type;
        switch (tag2) {
          case CacheComponent:
            return "Cache";
          case ContextConsumer:
            var context2 = type;
            return getContextName$1(context2) + ".Consumer";
          case ContextProvider:
            var provider = type;
            return getContextName$1(provider._context) + ".Provider";
          case DehydratedFragment:
            return "DehydratedFragment";
          case ForwardRef:
            return getWrappedName$1(type, type.render, "ForwardRef");
          case Fragment2:
            return "Fragment";
          case HostComponent:
            return type;
          case HostPortal:
            return "Portal";
          case HostRoot:
            return "Root";
          case HostText:
            return "Text";
          case LazyComponent:
            return getComponentNameFromType(type);
          case Mode:
            if (type === REACT_STRICT_MODE_TYPE) {
              return "StrictMode";
            }
            return "Mode";
          case OffscreenComponent:
            return "Offscreen";
          case Profiler:
            return "Profiler";
          case ScopeComponent:
            return "Scope";
          case SuspenseComponent:
            return "Suspense";
          case SuspenseListComponent:
            return "SuspenseList";
          case TracingMarkerComponent:
            return "TracingMarker";
          case ClassComponent:
          case FunctionComponent:
          case IncompleteClassComponent:
          case IndeterminateComponent:
          case MemoComponent:
          case SimpleMemoComponent:
            if (typeof type === "function") {
              return type.displayName || type.name || null;
            }
            if (typeof type === "string") {
              return type;
            }
            break;
        }
        return null;
      }
      var NoFlags = (
        /*                      */
        0
      );
      var PerformedWork = (
        /*                */
        1
      );
      var Placement = (
        /*                    */
        2
      );
      var Update = (
        /*                       */
        4
      );
      var PlacementAndUpdate = (
        /*           */
        Placement | Update
      );
      var ChildDeletion = (
        /*                */
        16
      );
      var ContentReset = (
        /*                 */
        32
      );
      var Callback = (
        /*                     */
        64
      );
      var DidCapture = (
        /*                   */
        128
      );
      var ForceClientRender = (
        /*            */
        256
      );
      var Ref = (
        /*                          */
        512
      );
      var Snapshot = (
        /*                     */
        1024
      );
      var Passive = (
        /*                      */
        2048
      );
      var Hydrating = (
        /*                    */
        4096
      );
      var HydratingAndUpdate = (
        /*           */
        Hydrating | Update
      );
      var Visibility = (
        /*                   */
        8192
      );
      var StoreConsistency = (
        /*             */
        16384
      );
      var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency;
      var HostEffectMask = (
        /*               */
        32767
      );
      var Incomplete = (
        /*                   */
        32768
      );
      var ShouldCapture = (
        /*                */
        65536
      );
      var ForceUpdateForLegacySuspense = (
        /* */
        131072
      );
      var Forked = (
        /*                       */
        1048576
      );
      var RefStatic = (
        /*                    */
        2097152
      );
      var LayoutStatic = (
        /*                 */
        4194304
      );
      var PassiveStatic = (
        /*                */
        8388608
      );
      var MountLayoutDev = (
        /*               */
        16777216
      );
      var MountPassiveDev = (
        /*              */
        33554432
      );
      var BeforeMutationMask = (
        // TODO: Remove Update flag from before mutation phase by re-landing Visibility
        // flag logic (see #20043)
        Update | Snapshot | 0
      );
      var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
      var LayoutMask = Update | Callback | Ref | Visibility;
      var PassiveMask = Passive | ChildDeletion;
      var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
          var nextNode = node;
          do {
            node = nextNode;
            if ((node.flags & (Placement | Hydrating)) !== NoFlags) {
              nearestMounted = node.return;
            }
            nextNode = node.return;
          } while (nextNode);
        } else {
          while (node.return) {
            node = node.return;
          }
        }
        if (node.tag === HostRoot) {
          return nearestMounted;
        }
        return null;
      }
      function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
      }
      function isMounted(component) {
        {
          var owner = ReactCurrentOwner.current;
          if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance2 = ownerFiber.stateNode;
            if (!instance2._warnedAboutRefsInRender) {
              error2("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            }
            instance2._warnedAboutRefsInRender = true;
          }
        }
        var fiber = get6(component);
        if (!fiber) {
          return false;
        }
        return getNearestMountedFiber(fiber) === fiber;
      }
      function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) {
          throw new Error("Unable to find node on an unmounted component.");
        }
      }
      function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
          var nearestMounted = getNearestMountedFiber(fiber);
          if (nearestMounted === null) {
            throw new Error("Unable to find node on an unmounted component.");
          }
          if (nearestMounted !== fiber) {
            return null;
          }
          return fiber;
        }
        var a2 = fiber;
        var b2 = alternate;
        while (true) {
          var parentA = a2.return;
          if (parentA === null) {
            break;
          }
          var parentB = parentA.alternate;
          if (parentB === null) {
            var nextParent = parentA.return;
            if (nextParent !== null) {
              a2 = b2 = nextParent;
              continue;
            }
            break;
          }
          if (parentA.child === parentB.child) {
            var child = parentA.child;
            while (child) {
              if (child === a2) {
                assertIsMounted(parentA);
                return fiber;
              }
              if (child === b2) {
                assertIsMounted(parentA);
                return alternate;
              }
              child = child.sibling;
            }
            throw new Error("Unable to find node on an unmounted component.");
          }
          if (a2.return !== b2.return) {
            a2 = parentA;
            b2 = parentB;
          } else {
            var didFindChild = false;
            var _child = parentA.child;
            while (_child) {
              if (_child === a2) {
                didFindChild = true;
                a2 = parentA;
                b2 = parentB;
                break;
              }
              if (_child === b2) {
                didFindChild = true;
                b2 = parentA;
                a2 = parentB;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild) {
              _child = parentB.child;
              while (_child) {
                if (_child === a2) {
                  didFindChild = true;
                  a2 = parentB;
                  b2 = parentA;
                  break;
                }
                if (_child === b2) {
                  didFindChild = true;
                  b2 = parentB;
                  a2 = parentA;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
              }
            }
          }
          if (a2.alternate !== b2) {
            throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        if (a2.tag !== HostRoot) {
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (a2.stateNode.current === a2) {
          return fiber;
        }
        return alternate;
      }
      function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
      }
      function findCurrentHostFiberImpl(node) {
        if (node.tag === HostComponent || node.tag === HostText) {
          return node;
        }
        var child = node.child;
        while (child !== null) {
          var match2 = findCurrentHostFiberImpl(child);
          if (match2 !== null) {
            return match2;
          }
          child = child.sibling;
        }
        return null;
      }
      function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
      }
      function findCurrentHostFiberWithNoPortalsImpl(node) {
        if (node.tag === HostComponent || node.tag === HostText) {
          return node;
        }
        var child = node.child;
        while (child !== null) {
          if (child.tag !== HostPortal) {
            var match2 = findCurrentHostFiberWithNoPortalsImpl(child);
            if (match2 !== null) {
              return match2;
            }
          }
          child = child.sibling;
        }
        return null;
      }
      var isArrayImpl = Array.isArray;
      function isArray3(a2) {
        return isArrayImpl(a2);
      }
      var getPublicInstance = $$$hostConfig.getPublicInstance;
      var getRootHostContext = $$$hostConfig.getRootHostContext;
      var getChildHostContext = $$$hostConfig.getChildHostContext;
      var prepareForCommit = $$$hostConfig.prepareForCommit;
      var resetAfterCommit = $$$hostConfig.resetAfterCommit;
      var createInstance = $$$hostConfig.createInstance;
      var appendInitialChild = $$$hostConfig.appendInitialChild;
      var finalizeInitialChildren = $$$hostConfig.finalizeInitialChildren;
      var prepareUpdate = $$$hostConfig.prepareUpdate;
      var shouldSetTextContent = $$$hostConfig.shouldSetTextContent;
      var createTextInstance = $$$hostConfig.createTextInstance;
      var scheduleTimeout = $$$hostConfig.scheduleTimeout;
      var cancelTimeout = $$$hostConfig.cancelTimeout;
      var noTimeout = $$$hostConfig.noTimeout;
      $$$hostConfig.now;
      var isPrimaryRenderer = $$$hostConfig.isPrimaryRenderer;
      var warnsIfNotActing = $$$hostConfig.warnsIfNotActing;
      var supportsMutation = $$$hostConfig.supportsMutation;
      var supportsPersistence = $$$hostConfig.supportsPersistence;
      var supportsHydration = $$$hostConfig.supportsHydration;
      var getInstanceFromNode = $$$hostConfig.getInstanceFromNode;
      $$$hostConfig.beforeActiveInstanceBlur;
      $$$hostConfig.afterActiveInstanceBlur;
      var preparePortalMount = $$$hostConfig.preparePortalMount;
      $$$hostConfig.preparePortalMount;
      $$$hostConfig.getInstanceFromScope;
      var getCurrentEventPriority = $$$hostConfig.getCurrentEventPriority;
      var detachDeletedInstance = $$$hostConfig.detachDeletedInstance;
      var supportsMicrotasks = $$$hostConfig.supportsMicrotasks;
      var scheduleMicrotask = $$$hostConfig.scheduleMicrotask;
      var supportsTestSelectors = $$$hostConfig.supportsTestSelectors;
      var findFiberRoot = $$$hostConfig.findFiberRoot;
      var getBoundingRect = $$$hostConfig.getBoundingRect;
      var getTextContent = $$$hostConfig.getTextContent;
      var isHiddenSubtree = $$$hostConfig.isHiddenSubtree;
      var matchAccessibilityRole = $$$hostConfig.matchAccessibilityRole;
      var setFocusIfFocusable = $$$hostConfig.setFocusIfFocusable;
      var setupIntersectionObserver = $$$hostConfig.setupIntersectionObserver;
      var appendChild = $$$hostConfig.appendChild;
      var appendChildToContainer = $$$hostConfig.appendChildToContainer;
      var commitTextUpdate = $$$hostConfig.commitTextUpdate;
      var commitMount = $$$hostConfig.commitMount;
      var commitUpdate = $$$hostConfig.commitUpdate;
      var insertBefore = $$$hostConfig.insertBefore;
      var insertInContainerBefore = $$$hostConfig.insertInContainerBefore;
      var removeChild = $$$hostConfig.removeChild;
      var removeChildFromContainer = $$$hostConfig.removeChildFromContainer;
      var resetTextContent = $$$hostConfig.resetTextContent;
      var hideInstance = $$$hostConfig.hideInstance;
      var hideTextInstance = $$$hostConfig.hideTextInstance;
      var unhideInstance = $$$hostConfig.unhideInstance;
      var unhideTextInstance = $$$hostConfig.unhideTextInstance;
      var clearContainer = $$$hostConfig.clearContainer;
      var cloneInstance = $$$hostConfig.cloneInstance;
      var createContainerChildSet = $$$hostConfig.createContainerChildSet;
      var appendChildToContainerChildSet = $$$hostConfig.appendChildToContainerChildSet;
      var finalizeContainerChildren = $$$hostConfig.finalizeContainerChildren;
      var replaceContainerChildren = $$$hostConfig.replaceContainerChildren;
      $$$hostConfig.getOffscreenContainerType;
      var getOffscreenContainerProps = $$$hostConfig.getOffscreenContainerProps;
      var cloneHiddenInstance = $$$hostConfig.cloneHiddenInstance;
      var cloneHiddenTextInstance = $$$hostConfig.cloneHiddenTextInstance;
      var canHydrateInstance = $$$hostConfig.canHydrateInstance;
      var canHydrateTextInstance = $$$hostConfig.canHydrateTextInstance;
      var canHydrateSuspenseInstance = $$$hostConfig.canHydrateSuspenseInstance;
      var isSuspenseInstancePending = $$$hostConfig.isSuspenseInstancePending;
      var isSuspenseInstanceFallback = $$$hostConfig.isSuspenseInstanceFallback;
      var registerSuspenseInstanceRetry = $$$hostConfig.registerSuspenseInstanceRetry;
      var getNextHydratableSibling = $$$hostConfig.getNextHydratableSibling;
      var getFirstHydratableChild = $$$hostConfig.getFirstHydratableChild;
      var getFirstHydratableChildWithinContainer = $$$hostConfig.getFirstHydratableChildWithinContainer;
      var getFirstHydratableChildWithinSuspenseInstance = $$$hostConfig.getFirstHydratableChildWithinSuspenseInstance;
      var hydrateInstance = $$$hostConfig.hydrateInstance;
      var hydrateTextInstance = $$$hostConfig.hydrateTextInstance;
      var hydrateSuspenseInstance = $$$hostConfig.hydrateSuspenseInstance;
      var getNextHydratableInstanceAfterSuspenseInstance = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance;
      var commitHydratedContainer = $$$hostConfig.commitHydratedContainer;
      var commitHydratedSuspenseInstance = $$$hostConfig.commitHydratedSuspenseInstance;
      var clearSuspenseBoundary = $$$hostConfig.clearSuspenseBoundary;
      var clearSuspenseBoundaryFromContainer = $$$hostConfig.clearSuspenseBoundaryFromContainer;
      var shouldDeleteUnhydratedTailInstances = $$$hostConfig.shouldDeleteUnhydratedTailInstances;
      var didNotMatchHydratedContainerTextInstance = $$$hostConfig.didNotMatchHydratedContainerTextInstance;
      var didNotMatchHydratedTextInstance = $$$hostConfig.didNotMatchHydratedTextInstance;
      var didNotHydrateInstanceWithinContainer = $$$hostConfig.didNotHydrateInstanceWithinContainer;
      var didNotHydrateInstanceWithinSuspenseInstance = $$$hostConfig.didNotHydrateInstanceWithinSuspenseInstance;
      var didNotHydrateInstance = $$$hostConfig.didNotHydrateInstance;
      var didNotFindHydratableInstanceWithinContainer = $$$hostConfig.didNotFindHydratableInstanceWithinContainer;
      var didNotFindHydratableTextInstanceWithinContainer = $$$hostConfig.didNotFindHydratableTextInstanceWithinContainer;
      var didNotFindHydratableSuspenseInstanceWithinContainer = $$$hostConfig.didNotFindHydratableSuspenseInstanceWithinContainer;
      var didNotFindHydratableInstanceWithinSuspenseInstance = $$$hostConfig.didNotFindHydratableInstanceWithinSuspenseInstance;
      var didNotFindHydratableTextInstanceWithinSuspenseInstance = $$$hostConfig.didNotFindHydratableTextInstanceWithinSuspenseInstance;
      var didNotFindHydratableSuspenseInstanceWithinSuspenseInstance = $$$hostConfig.didNotFindHydratableSuspenseInstanceWithinSuspenseInstance;
      var didNotFindHydratableInstance = $$$hostConfig.didNotFindHydratableInstance;
      var didNotFindHydratableTextInstance = $$$hostConfig.didNotFindHydratableTextInstance;
      var didNotFindHydratableSuspenseInstance = $$$hostConfig.didNotFindHydratableSuspenseInstance;
      var errorHydratingContainer = $$$hostConfig.errorHydratingContainer;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign3({}, props, {
                value: prevLog
              }),
              info: assign3({}, props, {
                value: prevInfo
              }),
              warn: assign3({}, props, {
                value: prevWarn
              }),
              error: assign3({}, props, {
                value: prevError
              }),
              group: assign3({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign3({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign3({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name2, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x2) {
              var match2 = x2.stack.trim().match(/\n( *(at )?)/);
              prefix = match2 && match2[1] || "";
            }
          }
          return "\n" + prefix + name2;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn2, construct) {
        if (!fn2 || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn2);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x2) {
                control = x2;
              }
              Reflect.construct(fn2, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x2) {
                control = x2;
              }
              fn2.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x2) {
              control = x2;
            }
            fn2();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s2 = sampleLines.length - 1;
            var c2 = controlLines.length - 1;
            while (s2 >= 1 && c2 >= 0 && sampleLines[s2] !== controlLines[c2]) {
              c2--;
            }
            for (; s2 >= 1 && c2 >= 0; s2--, c2--) {
              if (sampleLines[s2] !== controlLines[c2]) {
                if (s2 !== 1 || c2 !== 1) {
                  do {
                    s2--;
                    c2--;
                    if (c2 < 0 || sampleLines[s2] !== controlLines[c2]) {
                      var _frame = "\n" + sampleLines[s2].replace(" at new ", " at ");
                      if (fn2.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn2.displayName);
                      }
                      {
                        if (typeof fn2 === "function") {
                          componentFrameCache.set(fn2, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s2 >= 1 && c2 >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name2 = fn2 ? fn2.displayName || fn2.name : "";
        var syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
        {
          if (typeof fn2 === "function") {
            componentFrameCache.set(fn2, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeClassComponentFrame(ctor, source, ownerFn) {
        {
          return describeNativeComponentFrame(ctor, true);
        }
      }
      function describeFunctionComponentFrame(fn2, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn2, false);
        }
      }
      function shouldConstruct(Component2) {
        var prototype2 = Component2.prototype;
        return !!(prototype2 && prototype2.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init9 = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init9(payload), source, ownerFn);
              } catch (x2) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty2 = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack2 = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack2);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values4, location2, componentName, element) {
        {
          var has2 = Function.call.bind(hasOwnProperty2);
          for (var typeSpecName in typeSpecs) {
            if (has2(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values4, typeSpecName, componentName, location2, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location2, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error2("Failed %s type: %s", location2, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var valueStack = [];
      var fiberStack;
      {
        fiberStack = [];
      }
      var index2 = -1;
      function createCursor(defaultValue2) {
        return {
          current: defaultValue2
        };
      }
      function pop(cursor, fiber) {
        if (index2 < 0) {
          {
            error2("Unexpected pop.");
          }
          return;
        }
        {
          if (fiber !== fiberStack[index2]) {
            error2("Unexpected Fiber popped.");
          }
        }
        cursor.current = valueStack[index2];
        valueStack[index2] = null;
        {
          fiberStack[index2] = null;
        }
        index2--;
      }
      function push2(cursor, value, fiber) {
        index2++;
        valueStack[index2] = cursor.current;
        {
          fiberStack[index2] = fiber;
        }
        cursor.current = value;
      }
      var warnedAboutMissingGetChildContext;
      {
        warnedAboutMissingGetChildContext = {};
      }
      var emptyContextObject = {};
      {
        Object.freeze(emptyContextObject);
      }
      var contextStackCursor = createCursor(emptyContextObject);
      var didPerformWorkStackCursor = createCursor(false);
      var previousContext = emptyContextObject;
      function getUnmaskedContext(workInProgress2, Component2, didPushOwnContextIfProvider) {
        {
          if (didPushOwnContextIfProvider && isContextProvider(Component2)) {
            return previousContext;
          }
          return contextStackCursor.current;
        }
      }
      function cacheContext(workInProgress2, unmaskedContext, maskedContext) {
        {
          var instance2 = workInProgress2.stateNode;
          instance2.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
          instance2.__reactInternalMemoizedMaskedChildContext = maskedContext;
        }
      }
      function getMaskedContext(workInProgress2, unmaskedContext) {
        {
          var type = workInProgress2.type;
          var contextTypes = type.contextTypes;
          if (!contextTypes) {
            return emptyContextObject;
          }
          var instance2 = workInProgress2.stateNode;
          if (instance2 && instance2.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
            return instance2.__reactInternalMemoizedMaskedChildContext;
          }
          var context2 = {};
          for (var key in contextTypes) {
            context2[key] = unmaskedContext[key];
          }
          {
            var name2 = getComponentNameFromFiber(workInProgress2) || "Unknown";
            checkPropTypes(contextTypes, context2, "context", name2);
          }
          if (instance2) {
            cacheContext(workInProgress2, unmaskedContext, context2);
          }
          return context2;
        }
      }
      function hasContextChanged() {
        {
          return didPerformWorkStackCursor.current;
        }
      }
      function isContextProvider(type) {
        {
          var childContextTypes = type.childContextTypes;
          return childContextTypes !== null && childContextTypes !== void 0;
        }
      }
      function popContext(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function popTopLevelContextObject(fiber) {
        {
          pop(didPerformWorkStackCursor, fiber);
          pop(contextStackCursor, fiber);
        }
      }
      function pushTopLevelContextObject(fiber, context2, didChange) {
        {
          if (contextStackCursor.current !== emptyContextObject) {
            throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
          }
          push2(contextStackCursor, context2, fiber);
          push2(didPerformWorkStackCursor, didChange, fiber);
        }
      }
      function processChildContext(fiber, type, parentContext) {
        {
          var instance2 = fiber.stateNode;
          var childContextTypes = type.childContextTypes;
          if (typeof instance2.getChildContext !== "function") {
            {
              var componentName = getComponentNameFromFiber(fiber) || "Unknown";
              if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error2("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
              }
            }
            return parentContext;
          }
          var childContext = instance2.getChildContext();
          for (var contextKey in childContext) {
            if (!(contextKey in childContextTypes)) {
              throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
            }
          }
          {
            var name2 = getComponentNameFromFiber(fiber) || "Unknown";
            checkPropTypes(childContextTypes, childContext, "child context", name2);
          }
          return assign3({}, parentContext, childContext);
        }
      }
      function pushContextProvider(workInProgress2) {
        {
          var instance2 = workInProgress2.stateNode;
          var memoizedMergedChildContext = instance2 && instance2.__reactInternalMemoizedMergedChildContext || emptyContextObject;
          previousContext = contextStackCursor.current;
          push2(contextStackCursor, memoizedMergedChildContext, workInProgress2);
          push2(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress2);
          return true;
        }
      }
      function invalidateContextProvider(workInProgress2, type, didChange) {
        {
          var instance2 = workInProgress2.stateNode;
          if (!instance2) {
            throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
          }
          if (didChange) {
            var mergedContext = processChildContext(workInProgress2, type, previousContext);
            instance2.__reactInternalMemoizedMergedChildContext = mergedContext;
            pop(didPerformWorkStackCursor, workInProgress2);
            pop(contextStackCursor, workInProgress2);
            push2(contextStackCursor, mergedContext, workInProgress2);
            push2(didPerformWorkStackCursor, didChange, workInProgress2);
          } else {
            pop(didPerformWorkStackCursor, workInProgress2);
            push2(didPerformWorkStackCursor, didChange, workInProgress2);
          }
        }
      }
      function findCurrentUnmaskedContext(fiber) {
        {
          if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) {
            throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
          }
          var node = fiber;
          do {
            switch (node.tag) {
              case HostRoot:
                return node.stateNode.context;
              case ClassComponent: {
                var Component2 = node.type;
                if (isContextProvider(Component2)) {
                  return node.stateNode.__reactInternalMemoizedMergedChildContext;
                }
                break;
              }
            }
            node = node.return;
          } while (node !== null);
          throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      var LegacyRoot = 0;
      var ConcurrentRoot = 1;
      var NoMode = (
        /*                         */
        0
      );
      var ConcurrentMode = (
        /*                 */
        1
      );
      var ProfileMode = (
        /*                    */
        2
      );
      var StrictLegacyMode = (
        /*               */
        8
      );
      var StrictEffectsMode = (
        /*              */
        16
      );
      var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
      var log3 = Math.log;
      var LN2 = Math.LN2;
      function clz32Fallback(x2) {
        var asUint = x2 >>> 0;
        if (asUint === 0) {
          return 32;
        }
        return 31 - (log3(asUint) / LN2 | 0) | 0;
      }
      var TotalLanes = 31;
      var NoLanes = (
        /*                        */
        0
      );
      var NoLane = (
        /*                          */
        0
      );
      var SyncLane = (
        /*                        */
        1
      );
      var InputContinuousHydrationLane = (
        /*    */
        2
      );
      var InputContinuousLane = (
        /*            */
        4
      );
      var DefaultHydrationLane = (
        /*            */
        8
      );
      var DefaultLane = (
        /*                    */
        16
      );
      var TransitionHydrationLane = (
        /*                */
        32
      );
      var TransitionLanes = (
        /*                       */
        4194240
      );
      var TransitionLane1 = (
        /*                        */
        64
      );
      var TransitionLane2 = (
        /*                        */
        128
      );
      var TransitionLane3 = (
        /*                        */
        256
      );
      var TransitionLane4 = (
        /*                        */
        512
      );
      var TransitionLane5 = (
        /*                        */
        1024
      );
      var TransitionLane6 = (
        /*                        */
        2048
      );
      var TransitionLane7 = (
        /*                        */
        4096
      );
      var TransitionLane8 = (
        /*                        */
        8192
      );
      var TransitionLane9 = (
        /*                        */
        16384
      );
      var TransitionLane10 = (
        /*                       */
        32768
      );
      var TransitionLane11 = (
        /*                       */
        65536
      );
      var TransitionLane12 = (
        /*                       */
        131072
      );
      var TransitionLane13 = (
        /*                       */
        262144
      );
      var TransitionLane14 = (
        /*                       */
        524288
      );
      var TransitionLane15 = (
        /*                       */
        1048576
      );
      var TransitionLane16 = (
        /*                       */
        2097152
      );
      var RetryLanes = (
        /*                            */
        130023424
      );
      var RetryLane1 = (
        /*                             */
        4194304
      );
      var RetryLane2 = (
        /*                             */
        8388608
      );
      var RetryLane3 = (
        /*                             */
        16777216
      );
      var RetryLane4 = (
        /*                             */
        33554432
      );
      var RetryLane5 = (
        /*                             */
        67108864
      );
      var SomeRetryLane = RetryLane1;
      var SelectiveHydrationLane = (
        /*          */
        134217728
      );
      var NonIdleLanes = (
        /*                                 */
        268435455
      );
      var IdleHydrationLane = (
        /*               */
        268435456
      );
      var IdleLane = (
        /*                       */
        536870912
      );
      var OffscreenLane = (
        /*                   */
        1073741824
      );
      function getLabelForLane(lane) {
        {
          if (lane & SyncLane) {
            return "Sync";
          }
          if (lane & InputContinuousHydrationLane) {
            return "InputContinuousHydration";
          }
          if (lane & InputContinuousLane) {
            return "InputContinuous";
          }
          if (lane & DefaultHydrationLane) {
            return "DefaultHydration";
          }
          if (lane & DefaultLane) {
            return "Default";
          }
          if (lane & TransitionHydrationLane) {
            return "TransitionHydration";
          }
          if (lane & TransitionLanes) {
            return "Transition";
          }
          if (lane & RetryLanes) {
            return "Retry";
          }
          if (lane & SelectiveHydrationLane) {
            return "SelectiveHydration";
          }
          if (lane & IdleHydrationLane) {
            return "IdleHydration";
          }
          if (lane & IdleLane) {
            return "Idle";
          }
          if (lane & OffscreenLane) {
            return "Offscreen";
          }
        }
      }
      var NoTimestamp = -1;
      var nextTransitionLane = TransitionLane1;
      var nextRetryLane = RetryLane1;
      function getHighestPriorityLanes(lanes) {
        switch (getHighestPriorityLane(lanes)) {
          case SyncLane:
            return SyncLane;
          case InputContinuousHydrationLane:
            return InputContinuousHydrationLane;
          case InputContinuousLane:
            return InputContinuousLane;
          case DefaultHydrationLane:
            return DefaultHydrationLane;
          case DefaultLane:
            return DefaultLane;
          case TransitionHydrationLane:
            return TransitionHydrationLane;
          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
            return lanes & TransitionLanes;
          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            return lanes & RetryLanes;
          case SelectiveHydrationLane:
            return SelectiveHydrationLane;
          case IdleHydrationLane:
            return IdleHydrationLane;
          case IdleLane:
            return IdleLane;
          case OffscreenLane:
            return OffscreenLane;
          default:
            {
              error2("Should have found matching lanes. This is a bug in React.");
            }
            return lanes;
        }
      }
      function getNextLanes(root2, wipLanes) {
        var pendingLanes = root2.pendingLanes;
        if (pendingLanes === NoLanes) {
          return NoLanes;
        }
        var nextLanes = NoLanes;
        var suspendedLanes = root2.suspendedLanes;
        var pingedLanes = root2.pingedLanes;
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
          var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
          if (nonIdleUnblockedLanes !== NoLanes) {
            nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
          } else {
            var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
            if (nonIdlePingedLanes !== NoLanes) {
              nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
          }
        } else {
          var unblockedLanes = pendingLanes & ~suspendedLanes;
          if (unblockedLanes !== NoLanes) {
            nextLanes = getHighestPriorityLanes(unblockedLanes);
          } else {
            if (pingedLanes !== NoLanes) {
              nextLanes = getHighestPriorityLanes(pingedLanes);
            }
          }
        }
        if (nextLanes === NoLanes) {
          return NoLanes;
        }
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
          var nextLane = getHighestPriorityLane(nextLanes);
          var wipLane = getHighestPriorityLane(wipLanes);
          if (
            // Tests whether the next lane is equal or lower priority than the wip
            // one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes
          ) {
            return wipLanes;
          }
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) {
          nextLanes |= pendingLanes & DefaultLane;
        }
        var entangledLanes = root2.entangledLanes;
        if (entangledLanes !== NoLanes) {
          var entanglements = root2.entanglements;
          var lanes = nextLanes & entangledLanes;
          while (lanes > 0) {
            var index3 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index3;
            nextLanes |= entanglements[index3];
            lanes &= ~lane;
          }
        }
        return nextLanes;
      }
      function getMostRecentEventTime(root2, lanes) {
        var eventTimes = root2.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while (lanes > 0) {
          var index3 = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index3;
          var eventTime = eventTimes[index3];
          if (eventTime > mostRecentEventTime) {
            mostRecentEventTime = eventTime;
          }
          lanes &= ~lane;
        }
        return mostRecentEventTime;
      }
      function computeExpirationTime(lane, currentTime) {
        switch (lane) {
          case SyncLane:
          case InputContinuousHydrationLane:
          case InputContinuousLane:
            return currentTime + 250;
          case DefaultHydrationLane:
          case DefaultLane:
          case TransitionHydrationLane:
          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
            return currentTime + 5e3;
          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            return NoTimestamp;
          case SelectiveHydrationLane:
          case IdleHydrationLane:
          case IdleLane:
          case OffscreenLane:
            return NoTimestamp;
          default:
            {
              error2("Should have found matching lanes. This is a bug in React.");
            }
            return NoTimestamp;
        }
      }
      function markStarvedLanesAsExpired(root2, currentTime) {
        var pendingLanes = root2.pendingLanes;
        var suspendedLanes = root2.suspendedLanes;
        var pingedLanes = root2.pingedLanes;
        var expirationTimes = root2.expirationTimes;
        var lanes = pendingLanes;
        while (lanes > 0) {
          var index3 = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index3;
          var expirationTime = expirationTimes[index3];
          if (expirationTime === NoTimestamp) {
            if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
              expirationTimes[index3] = computeExpirationTime(lane, currentTime);
            }
          } else if (expirationTime <= currentTime) {
            root2.expiredLanes |= lane;
          }
          lanes &= ~lane;
        }
      }
      function getHighestPriorityPendingLanes(root2) {
        return getHighestPriorityLanes(root2.pendingLanes);
      }
      function getLanesToRetrySynchronouslyOnError(root2) {
        var everythingButOffscreen = root2.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) {
          return everythingButOffscreen;
        }
        if (everythingButOffscreen & OffscreenLane) {
          return OffscreenLane;
        }
        return NoLanes;
      }
      function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
      }
      function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
      }
      function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
      }
      function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
      }
      function includesBlockingLane(root2, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
      }
      function includesExpiredLane(root2, lanes) {
        return (lanes & root2.expiredLanes) !== NoLanes;
      }
      function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== 0;
      }
      function claimNextTransitionLane() {
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === 0) {
          nextTransitionLane = TransitionLane1;
        }
        return lane;
      }
      function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === 0) {
          nextRetryLane = RetryLane1;
        }
        return lane;
      }
      function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
      }
      function pickArbitraryLane(lanes) {
        return getHighestPriorityLane(lanes);
      }
      function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
      }
      function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
      }
      function includesSomeLane(a2, b2) {
        return (a2 & b2) !== NoLanes;
      }
      function isSubsetOfLanes(set2, subset) {
        return (set2 & subset) === subset;
      }
      function mergeLanes(a2, b2) {
        return a2 | b2;
      }
      function removeLanes(set2, subset) {
        return set2 & ~subset;
      }
      function intersectLanes(a2, b2) {
        return a2 & b2;
      }
      function laneToLanes(lane) {
        return lane;
      }
      function higherPriorityLane(a2, b2) {
        return a2 !== NoLane && a2 < b2 ? a2 : b2;
      }
      function createLaneMap(initial) {
        var laneMap = [];
        for (var i2 = 0; i2 < TotalLanes; i2++) {
          laneMap.push(initial);
        }
        return laneMap;
      }
      function markRootUpdated(root2, updateLane, eventTime) {
        root2.pendingLanes |= updateLane;
        if (updateLane !== IdleLane) {
          root2.suspendedLanes = NoLanes;
          root2.pingedLanes = NoLanes;
        }
        var eventTimes = root2.eventTimes;
        var index3 = laneToIndex(updateLane);
        eventTimes[index3] = eventTime;
      }
      function markRootSuspended(root2, suspendedLanes) {
        root2.suspendedLanes |= suspendedLanes;
        root2.pingedLanes &= ~suspendedLanes;
        var expirationTimes = root2.expirationTimes;
        var lanes = suspendedLanes;
        while (lanes > 0) {
          var index3 = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index3;
          expirationTimes[index3] = NoTimestamp;
          lanes &= ~lane;
        }
      }
      function markRootPinged(root2, pingedLanes, eventTime) {
        root2.pingedLanes |= root2.suspendedLanes & pingedLanes;
      }
      function markRootFinished(root2, remainingLanes) {
        var noLongerPendingLanes = root2.pendingLanes & ~remainingLanes;
        root2.pendingLanes = remainingLanes;
        root2.suspendedLanes = 0;
        root2.pingedLanes = 0;
        root2.expiredLanes &= remainingLanes;
        root2.mutableReadLanes &= remainingLanes;
        root2.entangledLanes &= remainingLanes;
        var entanglements = root2.entanglements;
        var eventTimes = root2.eventTimes;
        var expirationTimes = root2.expirationTimes;
        var lanes = noLongerPendingLanes;
        while (lanes > 0) {
          var index3 = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index3;
          entanglements[index3] = NoLanes;
          eventTimes[index3] = NoTimestamp;
          expirationTimes[index3] = NoTimestamp;
          lanes &= ~lane;
        }
      }
      function markRootEntangled(root2, entangledLanes) {
        var rootEntangledLanes = root2.entangledLanes |= entangledLanes;
        var entanglements = root2.entanglements;
        var lanes = rootEntangledLanes;
        while (lanes) {
          var index3 = pickArbitraryLaneIndex(lanes);
          var lane = 1 << index3;
          if (
            // Is this one of the newly entangled lanes?
            lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index3] & entangledLanes
          ) {
            entanglements[index3] |= entangledLanes;
          }
          lanes &= ~lane;
        }
      }
      function getBumpedLaneForHydration(root2, renderLanes2) {
        var renderLane = getHighestPriorityLane(renderLanes2);
        var lane;
        switch (renderLane) {
          case InputContinuousLane:
            lane = InputContinuousHydrationLane;
            break;
          case DefaultLane:
            lane = DefaultHydrationLane;
            break;
          case TransitionLane1:
          case TransitionLane2:
          case TransitionLane3:
          case TransitionLane4:
          case TransitionLane5:
          case TransitionLane6:
          case TransitionLane7:
          case TransitionLane8:
          case TransitionLane9:
          case TransitionLane10:
          case TransitionLane11:
          case TransitionLane12:
          case TransitionLane13:
          case TransitionLane14:
          case TransitionLane15:
          case TransitionLane16:
          case RetryLane1:
          case RetryLane2:
          case RetryLane3:
          case RetryLane4:
          case RetryLane5:
            lane = TransitionHydrationLane;
            break;
          case IdleLane:
            lane = IdleHydrationLane;
            break;
          default:
            lane = NoLane;
            break;
        }
        if ((lane & (root2.suspendedLanes | renderLanes2)) !== NoLane) {
          return NoLane;
        }
        return lane;
      }
      function addFiberToLanesMap(root2, fiber, lanes) {
        if (!isDevToolsPresent) {
          return;
        }
        var pendingUpdatersLaneMap = root2.pendingUpdatersLaneMap;
        while (lanes > 0) {
          var index3 = laneToIndex(lanes);
          var lane = 1 << index3;
          var updaters = pendingUpdatersLaneMap[index3];
          updaters.add(fiber);
          lanes &= ~lane;
        }
      }
      function movePendingFibersToMemoized(root2, lanes) {
        if (!isDevToolsPresent) {
          return;
        }
        var pendingUpdatersLaneMap = root2.pendingUpdatersLaneMap;
        var memoizedUpdaters = root2.memoizedUpdaters;
        while (lanes > 0) {
          var index3 = laneToIndex(lanes);
          var lane = 1 << index3;
          var updaters = pendingUpdatersLaneMap[index3];
          if (updaters.size > 0) {
            updaters.forEach(function(fiber) {
              var alternate = fiber.alternate;
              if (alternate === null || !memoizedUpdaters.has(alternate)) {
                memoizedUpdaters.add(fiber);
              }
            });
            updaters.clear();
          }
          lanes &= ~lane;
        }
      }
      var DiscreteEventPriority = SyncLane;
      var ContinuousEventPriority = InputContinuousLane;
      var DefaultEventPriority = DefaultLane;
      var IdleEventPriority = IdleLane;
      var currentUpdatePriority = NoLane;
      function getCurrentUpdatePriority() {
        return currentUpdatePriority;
      }
      function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
      }
      function runWithPriority(priority, fn2) {
        var previousPriority = currentUpdatePriority;
        try {
          currentUpdatePriority = priority;
          return fn2();
        } finally {
          currentUpdatePriority = previousPriority;
        }
      }
      function higherEventPriority(a2, b2) {
        return a2 !== 0 && a2 < b2 ? a2 : b2;
      }
      function lowerEventPriority(a2, b2) {
        return a2 === 0 || a2 > b2 ? a2 : b2;
      }
      function isHigherEventPriority(a2, b2) {
        return a2 !== 0 && a2 < b2;
      }
      function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) {
          return DiscreteEventPriority;
        }
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) {
          return ContinuousEventPriority;
        }
        if (includesNonIdleWork(lane)) {
          return DefaultEventPriority;
        }
        return IdleEventPriority;
      }
      var scheduleCallback = Scheduler2.unstable_scheduleCallback;
      var cancelCallback = Scheduler2.unstable_cancelCallback;
      var shouldYield = Scheduler2.unstable_shouldYield;
      var requestPaint = Scheduler2.unstable_requestPaint;
      var now$12 = Scheduler2.unstable_now;
      var ImmediatePriority = Scheduler2.unstable_ImmediatePriority;
      var UserBlockingPriority = Scheduler2.unstable_UserBlockingPriority;
      var NormalPriority = Scheduler2.unstable_NormalPriority;
      var IdlePriority = Scheduler2.unstable_IdlePriority;
      var unstable_yieldValue = Scheduler2.unstable_yieldValue;
      var unstable_setDisableYieldValue = Scheduler2.unstable_setDisableYieldValue;
      var rendererID = null;
      var injectedHook = null;
      var injectedProfilingHooks = null;
      var hasLoggedError = false;
      var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
      function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") {
          return false;
        }
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) {
          return true;
        }
        if (!hook.supportsFiber) {
          {
            error2("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
          }
          return true;
        }
        try {
          if (enableSchedulingProfiler) {
            internals = assign3({}, internals, {
              getLaneLabelMap,
              injectProfilingHooks
            });
          }
          rendererID = hook.inject(internals);
          injectedHook = hook;
        } catch (err) {
          {
            error2("React instrumentation encountered an error: %s.", err);
          }
        }
        if (hook.checkDCE) {
          return true;
        } else {
          return false;
        }
      }
      function onScheduleRoot(root2, children) {
        {
          if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") {
            try {
              injectedHook.onScheduleFiberRoot(rendererID, root2, children);
            } catch (err) {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error2("React instrumentation encountered an error: %s", err);
              }
            }
          }
        }
      }
      function onCommitRoot(root2, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") {
          try {
            var didError = (root2.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
              var schedulerPriority;
              switch (eventPriority) {
                case DiscreteEventPriority:
                  schedulerPriority = ImmediatePriority;
                  break;
                case ContinuousEventPriority:
                  schedulerPriority = UserBlockingPriority;
                  break;
                case DefaultEventPriority:
                  schedulerPriority = NormalPriority;
                  break;
                case IdleEventPriority:
                  schedulerPriority = IdlePriority;
                  break;
                default:
                  schedulerPriority = NormalPriority;
                  break;
              }
              injectedHook.onCommitFiberRoot(rendererID, root2, schedulerPriority, didError);
            }
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error2("React instrumentation encountered an error: %s", err);
              }
            }
          }
        }
      }
      function onPostCommitRoot(root2) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") {
          try {
            injectedHook.onPostCommitFiberRoot(rendererID, root2);
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error2("React instrumentation encountered an error: %s", err);
              }
            }
          }
        }
      }
      function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") {
          try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
          } catch (err) {
            {
              if (!hasLoggedError) {
                hasLoggedError = true;
                error2("React instrumentation encountered an error: %s", err);
              }
            }
          }
        }
      }
      function setIsStrictModeForDevtools(newIsStrictMode) {
        {
          if (typeof unstable_yieldValue === "function") {
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
          }
          if (injectedHook && typeof injectedHook.setStrictMode === "function") {
            try {
              injectedHook.setStrictMode(rendererID, newIsStrictMode);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error2("React instrumentation encountered an error: %s", err);
                }
              }
            }
          }
        }
      }
      function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
      }
      function getLaneLabelMap() {
        {
          var map5 = /* @__PURE__ */ new Map();
          var lane = 1;
          for (var index3 = 0; index3 < TotalLanes; index3++) {
            var label = getLabelForLane(lane);
            map5.set(lane, label);
            lane *= 2;
          }
          return map5;
        }
      }
      function markCommitStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") {
            injectedProfilingHooks.markCommitStarted(lanes);
          }
        }
      }
      function markCommitStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") {
            injectedProfilingHooks.markCommitStopped();
          }
        }
      }
      function markComponentRenderStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") {
            injectedProfilingHooks.markComponentRenderStarted(fiber);
          }
        }
      }
      function markComponentRenderStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") {
            injectedProfilingHooks.markComponentRenderStopped();
          }
        }
      }
      function markComponentPassiveEffectMountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") {
            injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
          }
        }
      }
      function markComponentPassiveEffectMountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") {
            injectedProfilingHooks.markComponentPassiveEffectMountStopped();
          }
        }
      }
      function markComponentPassiveEffectUnmountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") {
            injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
          }
        }
      }
      function markComponentPassiveEffectUnmountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") {
            injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
          }
        }
      }
      function markComponentLayoutEffectMountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") {
            injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
          }
        }
      }
      function markComponentLayoutEffectMountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") {
            injectedProfilingHooks.markComponentLayoutEffectMountStopped();
          }
        }
      }
      function markComponentLayoutEffectUnmountStarted(fiber) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") {
            injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
          }
        }
      }
      function markComponentLayoutEffectUnmountStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") {
            injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
          }
        }
      }
      function markComponentErrored(fiber, thrownValue, lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") {
            injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
          }
        }
      }
      function markComponentSuspended(fiber, wakeable, lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") {
            injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
          }
        }
      }
      function markLayoutEffectsStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") {
            injectedProfilingHooks.markLayoutEffectsStarted(lanes);
          }
        }
      }
      function markLayoutEffectsStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") {
            injectedProfilingHooks.markLayoutEffectsStopped();
          }
        }
      }
      function markPassiveEffectsStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") {
            injectedProfilingHooks.markPassiveEffectsStarted(lanes);
          }
        }
      }
      function markPassiveEffectsStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") {
            injectedProfilingHooks.markPassiveEffectsStopped();
          }
        }
      }
      function markRenderStarted(lanes) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") {
            injectedProfilingHooks.markRenderStarted(lanes);
          }
        }
      }
      function markRenderYielded() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") {
            injectedProfilingHooks.markRenderYielded();
          }
        }
      }
      function markRenderStopped() {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") {
            injectedProfilingHooks.markRenderStopped();
          }
        }
      }
      function markRenderScheduled(lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") {
            injectedProfilingHooks.markRenderScheduled(lane);
          }
        }
      }
      function markForceUpdateScheduled(fiber, lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") {
            injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
          }
        }
      }
      function markStateUpdateScheduled(fiber, lane) {
        {
          if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") {
            injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
          }
        }
      }
      function is3(x2, y2) {
        return x2 === y2 && (x2 !== 0 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
      }
      var objectIs2 = typeof Object.is === "function" ? Object.is : is3;
      var syncQueue = null;
      var includesLegacySyncCallbacks = false;
      var isFlushingSyncQueue = false;
      function scheduleSyncCallback(callback) {
        if (syncQueue === null) {
          syncQueue = [callback];
        } else {
          syncQueue.push(callback);
        }
      }
      function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
      }
      function flushSyncCallbacksOnlyInLegacyMode() {
        if (includesLegacySyncCallbacks) {
          flushSyncCallbacks();
        }
      }
      function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
          isFlushingSyncQueue = true;
          var i2 = 0;
          var previousUpdatePriority = getCurrentUpdatePriority();
          try {
            var isSync = true;
            var queue = syncQueue;
            setCurrentUpdatePriority(DiscreteEventPriority);
            for (; i2 < queue.length; i2++) {
              var callback = queue[i2];
              do {
                callback = callback(isSync);
              } while (callback !== null);
            }
            syncQueue = null;
            includesLegacySyncCallbacks = false;
          } catch (error3) {
            if (syncQueue !== null) {
              syncQueue = syncQueue.slice(i2 + 1);
            }
            scheduleCallback(ImmediatePriority, flushSyncCallbacks);
            throw error3;
          } finally {
            setCurrentUpdatePriority(previousUpdatePriority);
            isFlushingSyncQueue = false;
          }
        }
        return null;
      }
      function isRootDehydrated(root2) {
        var currentState = root2.current.memoizedState;
        return currentState.isDehydrated;
      }
      var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
      var NoTransition = null;
      function requestCurrentTransition() {
        return ReactCurrentBatchConfig.transition;
      }
      function shallowEqual(objA, objB) {
        if (objectIs2(objA, objB)) {
          return true;
        }
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
          return false;
        }
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
          return false;
        }
        for (var i2 = 0; i2 < keysA.length; i2++) {
          var currentKey = keysA[i2];
          if (!hasOwnProperty2.call(objB, currentKey) || !objectIs2(objA[currentKey], objB[currentKey])) {
            return false;
          }
        }
        return true;
      }
      function describeFiber(fiber) {
        fiber._debugOwner ? fiber._debugOwner.type : null;
        fiber._debugSource;
        switch (fiber.tag) {
          case HostComponent:
            return describeBuiltInComponentFrame(fiber.type);
          case LazyComponent:
            return describeBuiltInComponentFrame("Lazy");
          case SuspenseComponent:
            return describeBuiltInComponentFrame("Suspense");
          case SuspenseListComponent:
            return describeBuiltInComponentFrame("SuspenseList");
          case FunctionComponent:
          case IndeterminateComponent:
          case SimpleMemoComponent:
            return describeFunctionComponentFrame(fiber.type);
          case ForwardRef:
            return describeFunctionComponentFrame(fiber.type.render);
          case ClassComponent:
            return describeClassComponentFrame(fiber.type);
          default:
            return "";
        }
      }
      function getStackByFiberInDevAndProd(workInProgress2) {
        try {
          var info = "";
          var node = workInProgress2;
          do {
            info += describeFiber(node);
            node = node.return;
          } while (node);
          return info;
        } catch (x2) {
          return "\nError generating stack: " + x2.message + "\n" + x2.stack;
        }
      }
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      var current = null;
      var isRendering = false;
      function getCurrentFiberOwnerNameInDevOrNull() {
        {
          if (current === null) {
            return null;
          }
          var owner = current._debugOwner;
          if (owner !== null && typeof owner !== "undefined") {
            return getComponentNameFromFiber(owner);
          }
        }
        return null;
      }
      function getCurrentFiberStackInDev() {
        {
          if (current === null) {
            return "";
          }
          return getStackByFiberInDevAndProd(current);
        }
      }
      function resetCurrentFiber() {
        {
          ReactDebugCurrentFrame$1.getCurrentStack = null;
          current = null;
          isRendering = false;
        }
      }
      function setCurrentFiber(fiber) {
        {
          ReactDebugCurrentFrame$1.getCurrentStack = getCurrentFiberStackInDev;
          current = fiber;
          isRendering = false;
        }
      }
      function setIsRendering(rendering) {
        {
          isRendering = rendering;
        }
      }
      var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance2) {
        },
        flushPendingUnsafeLifecycleWarnings: function() {
        },
        recordLegacyContextWarning: function(fiber, instance2) {
        },
        flushLegacyContextWarning: function() {
        },
        discardPendingWarnings: function() {
        }
      };
      {
        var findStrictRoot = function(fiber) {
          var maybeStrictRoot = null;
          var node = fiber;
          while (node !== null) {
            if (node.mode & StrictLegacyMode) {
              maybeStrictRoot = node;
            }
            node = node.return;
          }
          return maybeStrictRoot;
        };
        var setToSortedString = function(set2) {
          var array2 = [];
          set2.forEach(function(value) {
            array2.push(value);
          });
          return array2.sort().join(", ");
        };
        var pendingComponentWillMountWarnings = [];
        var pendingUNSAFE_ComponentWillMountWarnings = [];
        var pendingComponentWillReceivePropsWarnings = [];
        var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        var pendingComponentWillUpdateWarnings = [];
        var pendingUNSAFE_ComponentWillUpdateWarnings = [];
        var didWarnAboutUnsafeLifecycles = /* @__PURE__ */ new Set();
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance2) {
          if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
            return;
          }
          if (typeof instance2.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
          instance2.componentWillMount.__suppressDeprecationWarning !== true) {
            pendingComponentWillMountWarnings.push(fiber);
          }
          if (fiber.mode & StrictLegacyMode && typeof instance2.UNSAFE_componentWillMount === "function") {
            pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
          }
          if (typeof instance2.componentWillReceiveProps === "function" && instance2.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
            pendingComponentWillReceivePropsWarnings.push(fiber);
          }
          if (fiber.mode & StrictLegacyMode && typeof instance2.UNSAFE_componentWillReceiveProps === "function") {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
          }
          if (typeof instance2.componentWillUpdate === "function" && instance2.componentWillUpdate.__suppressDeprecationWarning !== true) {
            pendingComponentWillUpdateWarnings.push(fiber);
          }
          if (fiber.mode & StrictLegacyMode && typeof instance2.UNSAFE_componentWillUpdate === "function") {
            pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
          var componentWillMountUniqueNames = /* @__PURE__ */ new Set();
          if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
              componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
          }
          var UNSAFE_componentWillMountUniqueNames = /* @__PURE__ */ new Set();
          if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
              UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
          }
          var componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
          if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
              componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
          }
          var UNSAFE_componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
          if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
              UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          }
          var componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
          if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
              componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
          }
          var UNSAFE_componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
          if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
              UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
              didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
          }
          if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error2("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
          }
          if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error2("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
          }
          if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error2("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
          }
          if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
          }
          if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
          }
          if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
          }
        };
        var pendingLegacyContextWarning = /* @__PURE__ */ new Map();
        var didWarnAboutLegacyContext = /* @__PURE__ */ new Set();
        ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance2) {
          var strictRoot = findStrictRoot(fiber);
          if (strictRoot === null) {
            error2("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
          }
          if (didWarnAboutLegacyContext.has(fiber.type)) {
            return;
          }
          var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
          if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance2 !== null && typeof instance2.getChildContext === "function") {
            if (warningsForRoot === void 0) {
              warningsForRoot = [];
              pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
          }
        };
        ReactStrictModeWarnings.flushLegacyContextWarning = function() {
          pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) {
              return;
            }
            var firstFiber = fiberArray[0];
            var uniqueNames = /* @__PURE__ */ new Set();
            fiberArray.forEach(function(fiber) {
              uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
              didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
              setCurrentFiber(firstFiber);
              error2("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally {
              resetCurrentFiber();
            }
          });
        };
        ReactStrictModeWarnings.discardPendingWarnings = function() {
          pendingComponentWillMountWarnings = [];
          pendingUNSAFE_ComponentWillMountWarnings = [];
          pendingComponentWillReceivePropsWarnings = [];
          pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          pendingComponentWillUpdateWarnings = [];
          pendingUNSAFE_ComponentWillUpdateWarnings = [];
          pendingLegacyContextWarning = /* @__PURE__ */ new Map();
        };
      }
      function typeName(value) {
        {
          var hasToStringTag2 = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag2 && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e3) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error2("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      function checkPropStringCoercion(value, propName2) {
        {
          if (willCoercionThrow(value)) {
            error2("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName2, typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      function resolveDefaultProps(Component2, baseProps) {
        if (Component2 && Component2.defaultProps) {
          var props = assign3({}, baseProps);
          var defaultProps2 = Component2.defaultProps;
          for (var propName2 in defaultProps2) {
            if (props[propName2] === void 0) {
              props[propName2] = defaultProps2[propName2];
            }
          }
          return props;
        }
        return baseProps;
      }
      var valueCursor = createCursor(null);
      var rendererSigil;
      {
        rendererSigil = {};
      }
      var currentlyRenderingFiber = null;
      var lastContextDependency = null;
      var lastFullyObservedContext = null;
      var isDisallowedContextReadInDEV = false;
      function resetContextDependencies() {
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function enterDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = true;
        }
      }
      function exitDisallowedContextReadInDEV() {
        {
          isDisallowedContextReadInDEV = false;
        }
      }
      function pushProvider(providerFiber, context2, nextValue) {
        if (isPrimaryRenderer) {
          push2(valueCursor, context2._currentValue, providerFiber);
          context2._currentValue = nextValue;
          {
            if (context2._currentRenderer !== void 0 && context2._currentRenderer !== null && context2._currentRenderer !== rendererSigil) {
              error2("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            }
            context2._currentRenderer = rendererSigil;
          }
        } else {
          push2(valueCursor, context2._currentValue2, providerFiber);
          context2._currentValue2 = nextValue;
          {
            if (context2._currentRenderer2 !== void 0 && context2._currentRenderer2 !== null && context2._currentRenderer2 !== rendererSigil) {
              error2("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
            }
            context2._currentRenderer2 = rendererSigil;
          }
        }
      }
      function popProvider(context2, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        if (isPrimaryRenderer) {
          {
            context2._currentValue = currentValue;
          }
        } else {
          {
            context2._currentValue2 = currentValue;
          }
        }
      }
      function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
        var node = parent;
        while (node !== null) {
          var alternate = node.alternate;
          if (!isSubsetOfLanes(node.childLanes, renderLanes2)) {
            node.childLanes = mergeLanes(node.childLanes, renderLanes2);
            if (alternate !== null) {
              alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes2);
            }
          } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes2)) {
            alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes2);
          }
          if (node === propagationRoot) {
            break;
          }
          node = node.return;
        }
        {
          if (node !== propagationRoot) {
            error2("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
      }
      function propagateContextChange(workInProgress2, context2, renderLanes2) {
        {
          propagateContextChange_eager(workInProgress2, context2, renderLanes2);
        }
      }
      function propagateContextChange_eager(workInProgress2, context2, renderLanes2) {
        var fiber = workInProgress2.child;
        if (fiber !== null) {
          fiber.return = workInProgress2;
        }
        while (fiber !== null) {
          var nextFiber = void 0;
          var list2 = fiber.dependencies;
          if (list2 !== null) {
            nextFiber = fiber.child;
            var dependency = list2.firstContext;
            while (dependency !== null) {
              if (dependency.context === context2) {
                if (fiber.tag === ClassComponent) {
                  var lane = pickArbitraryLane(renderLanes2);
                  var update = createUpdate(NoTimestamp, lane);
                  update.tag = ForceUpdate;
                  var updateQueue = fiber.updateQueue;
                  if (updateQueue === null)
                    ;
                  else {
                    var sharedQueue = updateQueue.shared;
                    var pending = sharedQueue.pending;
                    if (pending === null) {
                      update.next = update;
                    } else {
                      update.next = pending.next;
                      pending.next = update;
                    }
                    sharedQueue.pending = update;
                  }
                }
                fiber.lanes = mergeLanes(fiber.lanes, renderLanes2);
                var alternate = fiber.alternate;
                if (alternate !== null) {
                  alternate.lanes = mergeLanes(alternate.lanes, renderLanes2);
                }
                scheduleContextWorkOnParentPath(fiber.return, renderLanes2, workInProgress2);
                list2.lanes = mergeLanes(list2.lanes, renderLanes2);
                break;
              }
              dependency = dependency.next;
            }
          } else if (fiber.tag === ContextProvider) {
            nextFiber = fiber.type === workInProgress2.type ? null : fiber.child;
          } else if (fiber.tag === DehydratedFragment) {
            var parentSuspense = fiber.return;
            if (parentSuspense === null) {
              throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
            }
            parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes2);
            var _alternate = parentSuspense.alternate;
            if (_alternate !== null) {
              _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes2);
            }
            scheduleContextWorkOnParentPath(parentSuspense, renderLanes2, workInProgress2);
            nextFiber = fiber.sibling;
          } else {
            nextFiber = fiber.child;
          }
          if (nextFiber !== null) {
            nextFiber.return = fiber;
          } else {
            nextFiber = fiber;
            while (nextFiber !== null) {
              if (nextFiber === workInProgress2) {
                nextFiber = null;
                break;
              }
              var sibling = nextFiber.sibling;
              if (sibling !== null) {
                sibling.return = nextFiber.return;
                nextFiber = sibling;
                break;
              }
              nextFiber = nextFiber.return;
            }
          }
          fiber = nextFiber;
        }
      }
      function prepareToReadContext(workInProgress2, renderLanes2) {
        currentlyRenderingFiber = workInProgress2;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies2 = workInProgress2.dependencies;
        if (dependencies2 !== null) {
          {
            var firstContext = dependencies2.firstContext;
            if (firstContext !== null) {
              if (includesSomeLane(dependencies2.lanes, renderLanes2)) {
                markWorkInProgressReceivedUpdate();
              }
              dependencies2.firstContext = null;
            }
          }
        }
      }
      function readContext(context2) {
        {
          if (isDisallowedContextReadInDEV) {
            error2("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          }
        }
        var value = isPrimaryRenderer ? context2._currentValue : context2._currentValue2;
        if (lastFullyObservedContext === context2)
          ;
        else {
          var contextItem = {
            context: context2,
            memoizedValue: value,
            next: null
          };
          if (lastContextDependency === null) {
            if (currentlyRenderingFiber === null) {
              throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            }
            lastContextDependency = contextItem;
            currentlyRenderingFiber.dependencies = {
              lanes: NoLanes,
              firstContext: contextItem
            };
          } else {
            lastContextDependency = lastContextDependency.next = contextItem;
          }
        }
        return value;
      }
      var interleavedQueues = null;
      function pushInterleavedQueue(queue) {
        if (interleavedQueues === null) {
          interleavedQueues = [queue];
        } else {
          interleavedQueues.push(queue);
        }
      }
      function enqueueInterleavedUpdates() {
        if (interleavedQueues !== null) {
          for (var i2 = 0; i2 < interleavedQueues.length; i2++) {
            var queue = interleavedQueues[i2];
            var lastInterleavedUpdate = queue.interleaved;
            if (lastInterleavedUpdate !== null) {
              queue.interleaved = null;
              var firstInterleavedUpdate = lastInterleavedUpdate.next;
              var lastPendingUpdate = queue.pending;
              if (lastPendingUpdate !== null) {
                var firstPendingUpdate = lastPendingUpdate.next;
                lastPendingUpdate.next = firstInterleavedUpdate;
                lastInterleavedUpdate.next = firstPendingUpdate;
              }
              queue.pending = lastInterleavedUpdate;
            }
          }
          interleavedQueues = null;
        }
      }
      var UpdateState = 0;
      var ReplaceState = 1;
      var ForceUpdate = 2;
      var CaptureUpdate = 3;
      var hasForceUpdate = false;
      var didWarnUpdateInsideUpdate;
      var currentlyProcessingQueue;
      {
        didWarnUpdateInsideUpdate = false;
        currentlyProcessingQueue = null;
      }
      function initializeUpdateQueue(fiber) {
        var queue = {
          baseState: fiber.memoizedState,
          firstBaseUpdate: null,
          lastBaseUpdate: null,
          shared: {
            pending: null,
            interleaved: null,
            lanes: NoLanes
          },
          effects: null
        };
        fiber.updateQueue = queue;
      }
      function cloneUpdateQueue(current2, workInProgress2) {
        var queue = workInProgress2.updateQueue;
        var currentQueue = current2.updateQueue;
        if (queue === currentQueue) {
          var clone8 = {
            baseState: currentQueue.baseState,
            firstBaseUpdate: currentQueue.firstBaseUpdate,
            lastBaseUpdate: currentQueue.lastBaseUpdate,
            shared: currentQueue.shared,
            effects: currentQueue.effects
          };
          workInProgress2.updateQueue = clone8;
        }
      }
      function createUpdate(eventTime, lane) {
        var update = {
          eventTime,
          lane,
          tag: UpdateState,
          payload: null,
          callback: null,
          next: null
        };
        return update;
      }
      function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) {
          return;
        }
        var sharedQueue = updateQueue.shared;
        if (isInterleavedUpdate(fiber)) {
          var interleaved = sharedQueue.interleaved;
          if (interleaved === null) {
            update.next = update;
            pushInterleavedQueue(sharedQueue);
          } else {
            update.next = interleaved.next;
            interleaved.next = update;
          }
          sharedQueue.interleaved = update;
        } else {
          var pending = sharedQueue.pending;
          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }
          sharedQueue.pending = update;
        }
        {
          if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error2("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
          }
        }
      }
      function entangleTransitions(root2, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) {
          return;
        }
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
          var queueLanes = sharedQueue.lanes;
          queueLanes = intersectLanes(queueLanes, root2.pendingLanes);
          var newQueueLanes = mergeLanes(queueLanes, lane);
          sharedQueue.lanes = newQueueLanes;
          markRootEntangled(root2, newQueueLanes);
        }
      }
      function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
        var queue = workInProgress2.updateQueue;
        var current2 = workInProgress2.alternate;
        if (current2 !== null) {
          var currentQueue = current2.updateQueue;
          if (queue === currentQueue) {
            var newFirst = null;
            var newLast = null;
            var firstBaseUpdate = queue.firstBaseUpdate;
            if (firstBaseUpdate !== null) {
              var update = firstBaseUpdate;
              do {
                var clone8 = {
                  eventTime: update.eventTime,
                  lane: update.lane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                if (newLast === null) {
                  newFirst = newLast = clone8;
                } else {
                  newLast.next = clone8;
                  newLast = clone8;
                }
                update = update.next;
              } while (update !== null);
              if (newLast === null) {
                newFirst = newLast = capturedUpdate;
              } else {
                newLast.next = capturedUpdate;
                newLast = capturedUpdate;
              }
            } else {
              newFirst = newLast = capturedUpdate;
            }
            queue = {
              baseState: currentQueue.baseState,
              firstBaseUpdate: newFirst,
              lastBaseUpdate: newLast,
              shared: currentQueue.shared,
              effects: currentQueue.effects
            };
            workInProgress2.updateQueue = queue;
            return;
          }
        }
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) {
          queue.firstBaseUpdate = capturedUpdate;
        } else {
          lastBaseUpdate.next = capturedUpdate;
        }
        queue.lastBaseUpdate = capturedUpdate;
      }
      function getStateFromUpdate(workInProgress2, queue, update, prevState, nextProps, instance2) {
        switch (update.tag) {
          case ReplaceState: {
            var payload = update.payload;
            if (typeof payload === "function") {
              {
                enterDisallowedContextReadInDEV();
              }
              var nextState = payload.call(instance2, prevState, nextProps);
              {
                if (workInProgress2.mode & StrictLegacyMode) {
                  setIsStrictModeForDevtools(true);
                  try {
                    payload.call(instance2, prevState, nextProps);
                  } finally {
                    setIsStrictModeForDevtools(false);
                  }
                }
                exitDisallowedContextReadInDEV();
              }
              return nextState;
            }
            return payload;
          }
          case CaptureUpdate: {
            workInProgress2.flags = workInProgress2.flags & ~ShouldCapture | DidCapture;
          }
          case UpdateState: {
            var _payload = update.payload;
            var partialState;
            if (typeof _payload === "function") {
              {
                enterDisallowedContextReadInDEV();
              }
              partialState = _payload.call(instance2, prevState, nextProps);
              {
                if (workInProgress2.mode & StrictLegacyMode) {
                  setIsStrictModeForDevtools(true);
                  try {
                    _payload.call(instance2, prevState, nextProps);
                  } finally {
                    setIsStrictModeForDevtools(false);
                  }
                }
                exitDisallowedContextReadInDEV();
              }
            } else {
              partialState = _payload;
            }
            if (partialState === null || partialState === void 0) {
              return prevState;
            }
            return assign3({}, prevState, partialState);
          }
          case ForceUpdate: {
            hasForceUpdate = true;
            return prevState;
          }
        }
        return prevState;
      }
      function processUpdateQueue(workInProgress2, props, instance2, renderLanes2) {
        var queue = workInProgress2.updateQueue;
        hasForceUpdate = false;
        {
          currentlyProcessingQueue = queue.shared;
        }
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate;
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
          queue.shared.pending = null;
          var lastPendingUpdate = pendingQueue;
          var firstPendingUpdate = lastPendingUpdate.next;
          lastPendingUpdate.next = null;
          if (lastBaseUpdate === null) {
            firstBaseUpdate = firstPendingUpdate;
          } else {
            lastBaseUpdate.next = firstPendingUpdate;
          }
          lastBaseUpdate = lastPendingUpdate;
          var current2 = workInProgress2.alternate;
          if (current2 !== null) {
            var currentQueue = current2.updateQueue;
            var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
            if (currentLastBaseUpdate !== lastBaseUpdate) {
              if (currentLastBaseUpdate === null) {
                currentQueue.firstBaseUpdate = firstPendingUpdate;
              } else {
                currentLastBaseUpdate.next = firstPendingUpdate;
              }
              currentQueue.lastBaseUpdate = lastPendingUpdate;
            }
          }
        }
        if (firstBaseUpdate !== null) {
          var newState = queue.baseState;
          var newLanes = NoLanes;
          var newBaseState = null;
          var newFirstBaseUpdate = null;
          var newLastBaseUpdate = null;
          var update = firstBaseUpdate;
          do {
            var updateLane = update.lane;
            var updateEventTime = update.eventTime;
            if (!isSubsetOfLanes(renderLanes2, updateLane)) {
              var clone8 = {
                eventTime: updateEventTime,
                lane: updateLane,
                tag: update.tag,
                payload: update.payload,
                callback: update.callback,
                next: null
              };
              if (newLastBaseUpdate === null) {
                newFirstBaseUpdate = newLastBaseUpdate = clone8;
                newBaseState = newState;
              } else {
                newLastBaseUpdate = newLastBaseUpdate.next = clone8;
              }
              newLanes = mergeLanes(newLanes, updateLane);
            } else {
              if (newLastBaseUpdate !== null) {
                var _clone = {
                  eventTime: updateEventTime,
                  // This update is going to be committed so we never want uncommit
                  // it. Using NoLane works because 0 is a subset of all bitmasks, so
                  // this will never be skipped by the check above.
                  lane: NoLane,
                  tag: update.tag,
                  payload: update.payload,
                  callback: update.callback,
                  next: null
                };
                newLastBaseUpdate = newLastBaseUpdate.next = _clone;
              }
              newState = getStateFromUpdate(workInProgress2, queue, update, newState, props, instance2);
              var callback = update.callback;
              if (callback !== null && // If the update was already committed, we should not queue its
              // callback again.
              update.lane !== NoLane) {
                workInProgress2.flags |= Callback;
                var effects = queue.effects;
                if (effects === null) {
                  queue.effects = [update];
                } else {
                  effects.push(update);
                }
              }
            }
            update = update.next;
            if (update === null) {
              pendingQueue = queue.shared.pending;
              if (pendingQueue === null) {
                break;
              } else {
                var _lastPendingUpdate = pendingQueue;
                var _firstPendingUpdate = _lastPendingUpdate.next;
                _lastPendingUpdate.next = null;
                update = _firstPendingUpdate;
                queue.lastBaseUpdate = _lastPendingUpdate;
                queue.shared.pending = null;
              }
            }
          } while (true);
          if (newLastBaseUpdate === null) {
            newBaseState = newState;
          }
          queue.baseState = newBaseState;
          queue.firstBaseUpdate = newFirstBaseUpdate;
          queue.lastBaseUpdate = newLastBaseUpdate;
          var lastInterleaved = queue.shared.interleaved;
          if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
              newLanes = mergeLanes(newLanes, interleaved.lane);
              interleaved = interleaved.next;
            } while (interleaved !== lastInterleaved);
          } else if (firstBaseUpdate === null) {
            queue.shared.lanes = NoLanes;
          }
          markSkippedUpdateLanes(newLanes);
          workInProgress2.lanes = newLanes;
          workInProgress2.memoizedState = newState;
        }
        {
          currentlyProcessingQueue = null;
        }
      }
      function callCallback(callback, context2) {
        if (typeof callback !== "function") {
          throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        }
        callback.call(context2);
      }
      function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
      }
      function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
      }
      function commitUpdateQueue(finishedWork, finishedQueue, instance2) {
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) {
          for (var i2 = 0; i2 < effects.length; i2++) {
            var effect = effects[i2];
            var callback = effect.callback;
            if (callback !== null) {
              effect.callback = null;
              callCallback(callback, instance2);
            }
          }
        }
      }
      var fakeInternalInstance = {};
      var emptyRefsObject = new React2.Component().refs;
      var didWarnAboutStateAssignmentForComponent;
      var didWarnAboutUninitializedState;
      var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
      var didWarnAboutLegacyLifecyclesAndDerivedState;
      var didWarnAboutUndefinedDerivedState;
      var warnOnUndefinedDerivedState;
      var warnOnInvalidCallback;
      var didWarnAboutDirectlyAssigningPropsToState;
      var didWarnAboutContextTypeAndContextTypes;
      var didWarnAboutInvalidateContextType;
      {
        didWarnAboutStateAssignmentForComponent = /* @__PURE__ */ new Set();
        didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
        didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
        didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
        didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
        didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
        didWarnAboutContextTypeAndContextTypes = /* @__PURE__ */ new Set();
        didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
        var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
        warnOnInvalidCallback = function(callback, callerName) {
          if (callback === null || typeof callback === "function") {
            return;
          }
          var key = callerName + "_" + callback;
          if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error2("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
          }
        };
        warnOnUndefinedDerivedState = function(type, partialState) {
          if (partialState === void 0) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
              didWarnAboutUndefinedDerivedState.add(componentName);
              error2("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
          }
        };
        Object.defineProperty(fakeInternalInstance, "_processChildContext", {
          enumerable: false,
          value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
          }
        });
        Object.freeze(fakeInternalInstance);
      }
      function applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress2.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        {
          if (workInProgress2.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
              partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }
          warnOnUndefinedDerivedState(ctor, partialState);
        }
        var memoizedState = partialState === null || partialState === void 0 ? prevState : assign3({}, prevState, partialState);
        workInProgress2.memoizedState = memoizedState;
        if (workInProgress2.lanes === NoLanes) {
          var updateQueue = workInProgress2.updateQueue;
          updateQueue.baseState = memoizedState;
        }
      }
      var classComponentUpdater = {
        isMounted,
        enqueueSetState: function(inst, payload, callback) {
          var fiber = get6(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.payload = payload;
          if (callback !== void 0 && callback !== null) {
            {
              warnOnInvalidCallback(callback, "setState");
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          var root2 = scheduleUpdateOnFiber(fiber, lane, eventTime);
          if (root2 !== null) {
            entangleTransitions(root2, fiber, lane);
          }
          {
            markStateUpdateScheduled(fiber, lane);
          }
        },
        enqueueReplaceState: function(inst, payload, callback) {
          var fiber = get6(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.tag = ReplaceState;
          update.payload = payload;
          if (callback !== void 0 && callback !== null) {
            {
              warnOnInvalidCallback(callback, "replaceState");
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          var root2 = scheduleUpdateOnFiber(fiber, lane, eventTime);
          if (root2 !== null) {
            entangleTransitions(root2, fiber, lane);
          }
          {
            markStateUpdateScheduled(fiber, lane);
          }
        },
        enqueueForceUpdate: function(inst, callback) {
          var fiber = get6(inst);
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update = createUpdate(eventTime, lane);
          update.tag = ForceUpdate;
          if (callback !== void 0 && callback !== null) {
            {
              warnOnInvalidCallback(callback, "forceUpdate");
            }
            update.callback = callback;
          }
          enqueueUpdate(fiber, update);
          var root2 = scheduleUpdateOnFiber(fiber, lane, eventTime);
          if (root2 !== null) {
            entangleTransitions(root2, fiber, lane);
          }
          {
            markForceUpdateScheduled(fiber, lane);
          }
        }
      };
      function checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance2 = workInProgress2.stateNode;
        if (typeof instance2.shouldComponentUpdate === "function") {
          var shouldUpdate = instance2.shouldComponentUpdate(newProps, newState, nextContext);
          {
            if (workInProgress2.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);
              try {
                shouldUpdate = instance2.shouldComponentUpdate(newProps, newState, nextContext);
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }
            if (shouldUpdate === void 0) {
              error2("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            }
          }
          return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) {
          return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        }
        return true;
      }
      function checkClassInstance(workInProgress2, ctor, newProps) {
        var instance2 = workInProgress2.stateNode;
        {
          var name2 = getComponentNameFromType(ctor) || "Component";
          var renderPresent = instance2.render;
          if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") {
              error2("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name2);
            } else {
              error2("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name2);
            }
          }
          if (instance2.getInitialState && !instance2.getInitialState.isReactClassApproved && !instance2.state) {
            error2("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name2);
          }
          if (instance2.getDefaultProps && !instance2.getDefaultProps.isReactClassApproved) {
            error2("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name2);
          }
          if (instance2.propTypes) {
            error2("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name2);
          }
          if (instance2.contextType) {
            error2("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name2);
          }
          {
            if (instance2.contextTypes) {
              error2("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name2);
            }
            if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
              didWarnAboutContextTypeAndContextTypes.add(ctor);
              error2("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name2);
            }
          }
          if (typeof instance2.componentShouldUpdate === "function") {
            error2("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name2);
          }
          if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance2.shouldComponentUpdate !== "undefined") {
            error2("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
          }
          if (typeof instance2.componentDidUnmount === "function") {
            error2("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name2);
          }
          if (typeof instance2.componentDidReceiveProps === "function") {
            error2("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name2);
          }
          if (typeof instance2.componentWillRecieveProps === "function") {
            error2("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name2);
          }
          if (typeof instance2.UNSAFE_componentWillRecieveProps === "function") {
            error2("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name2);
          }
          var hasMutatedProps = instance2.props !== newProps;
          if (instance2.props !== void 0 && hasMutatedProps) {
            error2("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name2, name2);
          }
          if (instance2.defaultProps) {
            error2("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name2, name2);
          }
          if (typeof instance2.getSnapshotBeforeUpdate === "function" && typeof instance2.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error2("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
          }
          if (typeof instance2.getDerivedStateFromProps === "function") {
            error2("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name2);
          }
          if (typeof instance2.getDerivedStateFromError === "function") {
            error2("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name2);
          }
          if (typeof ctor.getSnapshotBeforeUpdate === "function") {
            error2("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name2);
          }
          var _state = instance2.state;
          if (_state && (typeof _state !== "object" || isArray3(_state))) {
            error2("%s.state: must be set to an object or null", name2);
          }
          if (typeof instance2.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
            error2("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name2);
          }
        }
      }
      function adoptClassInstance(workInProgress2, instance2) {
        instance2.updater = classComponentUpdater;
        workInProgress2.stateNode = instance2;
        set(instance2, workInProgress2);
        {
          instance2._reactInternalInstance = fakeInternalInstance;
        }
      }
      function constructClassInstance(workInProgress2, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context2 = emptyContextObject;
        var contextType = ctor.contextType;
        {
          if ("contextType" in ctor) {
            var isValid8 = (
              // Allow null for conditional declaration
              contextType === null || contextType !== void 0 && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === void 0
            );
            if (!isValid8 && !didWarnAboutInvalidateContextType.has(ctor)) {
              didWarnAboutInvalidateContextType.add(ctor);
              var addendum = "";
              if (contextType === void 0) {
                addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
              } else if (typeof contextType !== "object") {
                addendum = " However, it is set to a " + typeof contextType + ".";
              } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                addendum = " Did you accidentally pass the Context.Provider instead?";
              } else if (contextType._context !== void 0) {
                addendum = " Did you accidentally pass the Context.Consumer instead?";
              } else {
                addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
              }
              error2("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
          }
        }
        if (typeof contextType === "object" && contextType !== null) {
          context2 = readContext(contextType);
        } else {
          unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
          var contextTypes = ctor.contextTypes;
          isLegacyContextConsumer = contextTypes !== null && contextTypes !== void 0;
          context2 = isLegacyContextConsumer ? getMaskedContext(workInProgress2, unmaskedContext) : emptyContextObject;
        }
        var instance2 = new ctor(props, context2);
        {
          if (workInProgress2.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
              instance2 = new ctor(props, context2);
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }
        }
        var state = workInProgress2.memoizedState = instance2.state !== null && instance2.state !== void 0 ? instance2.state : null;
        adoptClassInstance(workInProgress2, instance2);
        {
          if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
              didWarnAboutUninitializedState.add(componentName);
              error2("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance2.state === null ? "null" : "undefined", componentName);
            }
          }
          if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance2.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance2.componentWillMount === "function" && instance2.componentWillMount.__suppressDeprecationWarning !== true) {
              foundWillMountName = "componentWillMount";
            } else if (typeof instance2.UNSAFE_componentWillMount === "function") {
              foundWillMountName = "UNSAFE_componentWillMount";
            }
            if (typeof instance2.componentWillReceiveProps === "function" && instance2.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              foundWillReceivePropsName = "componentWillReceiveProps";
            } else if (typeof instance2.UNSAFE_componentWillReceiveProps === "function") {
              foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            }
            if (typeof instance2.componentWillUpdate === "function" && instance2.componentWillUpdate.__suppressDeprecationWarning !== true) {
              foundWillUpdateName = "componentWillUpdate";
            } else if (typeof instance2.UNSAFE_componentWillUpdate === "function") {
              foundWillUpdateName = "UNSAFE_componentWillUpdate";
            }
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
              var _componentName = getComponentNameFromType(ctor) || "Component";
              var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
              if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                error2("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
              }
            }
          }
        }
        if (isLegacyContextConsumer) {
          cacheContext(workInProgress2, unmaskedContext, context2);
        }
        return instance2;
      }
      function callComponentWillMount(workInProgress2, instance2) {
        var oldState = instance2.state;
        if (typeof instance2.componentWillMount === "function") {
          instance2.componentWillMount();
        }
        if (typeof instance2.UNSAFE_componentWillMount === "function") {
          instance2.UNSAFE_componentWillMount();
        }
        if (oldState !== instance2.state) {
          {
            error2("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress2) || "Component");
          }
          classComponentUpdater.enqueueReplaceState(instance2, instance2.state, null);
        }
      }
      function callComponentWillReceiveProps(workInProgress2, instance2, newProps, nextContext) {
        var oldState = instance2.state;
        if (typeof instance2.componentWillReceiveProps === "function") {
          instance2.componentWillReceiveProps(newProps, nextContext);
        }
        if (typeof instance2.UNSAFE_componentWillReceiveProps === "function") {
          instance2.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        }
        if (instance2.state !== oldState) {
          {
            var componentName = getComponentNameFromFiber(workInProgress2) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
              didWarnAboutStateAssignmentForComponent.add(componentName);
              error2("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
          }
          classComponentUpdater.enqueueReplaceState(instance2, instance2.state, null);
        }
      }
      function mountClassInstance(workInProgress2, ctor, newProps, renderLanes2) {
        {
          checkClassInstance(workInProgress2, ctor, newProps);
        }
        var instance2 = workInProgress2.stateNode;
        instance2.props = newProps;
        instance2.state = workInProgress2.memoizedState;
        instance2.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress2);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) {
          instance2.context = readContext(contextType);
        } else {
          var unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
          instance2.context = getMaskedContext(workInProgress2, unmaskedContext);
        }
        {
          if (instance2.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
              didWarnAboutDirectlyAssigningPropsToState.add(componentName);
              error2("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
          }
          if (workInProgress2.mode & StrictLegacyMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, instance2);
          }
          {
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress2, instance2);
          }
        }
        instance2.state = workInProgress2.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
          applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
          instance2.state = workInProgress2.memoizedState;
        }
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance2.getSnapshotBeforeUpdate !== "function" && (typeof instance2.UNSAFE_componentWillMount === "function" || typeof instance2.componentWillMount === "function")) {
          callComponentWillMount(workInProgress2, instance2);
          processUpdateQueue(workInProgress2, newProps, instance2, renderLanes2);
          instance2.state = workInProgress2.memoizedState;
        }
        if (typeof instance2.componentDidMount === "function") {
          var fiberFlags = Update;
          {
            fiberFlags |= LayoutStatic;
          }
          if ((workInProgress2.mode & StrictEffectsMode) !== NoMode) {
            fiberFlags |= MountLayoutDev;
          }
          workInProgress2.flags |= fiberFlags;
        }
      }
      function resumeMountClassInstance(workInProgress2, ctor, newProps, renderLanes2) {
        var instance2 = workInProgress2.stateNode;
        var oldProps = workInProgress2.memoizedProps;
        instance2.props = oldProps;
        var oldContext = instance2.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) {
          nextContext = readContext(contextType);
        } else {
          var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
          nextContext = getMaskedContext(workInProgress2, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance2.getSnapshotBeforeUpdate === "function";
        if (!hasNewLifecycles && (typeof instance2.UNSAFE_componentWillReceiveProps === "function" || typeof instance2.componentWillReceiveProps === "function")) {
          if (oldProps !== newProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress2, instance2, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress2.memoizedState;
        var newState = instance2.state = oldState;
        processUpdateQueue(workInProgress2, newProps, instance2, renderLanes2);
        newState = workInProgress2.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
          if (typeof instance2.componentDidMount === "function") {
            var fiberFlags = Update;
            {
              fiberFlags |= LayoutStatic;
            }
            if ((workInProgress2.mode & StrictEffectsMode) !== NoMode) {
              fiberFlags |= MountLayoutDev;
            }
            workInProgress2.flags |= fiberFlags;
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
          applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress2.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
          if (!hasNewLifecycles && (typeof instance2.UNSAFE_componentWillMount === "function" || typeof instance2.componentWillMount === "function")) {
            if (typeof instance2.componentWillMount === "function") {
              instance2.componentWillMount();
            }
            if (typeof instance2.UNSAFE_componentWillMount === "function") {
              instance2.UNSAFE_componentWillMount();
            }
          }
          if (typeof instance2.componentDidMount === "function") {
            var _fiberFlags = Update;
            {
              _fiberFlags |= LayoutStatic;
            }
            if ((workInProgress2.mode & StrictEffectsMode) !== NoMode) {
              _fiberFlags |= MountLayoutDev;
            }
            workInProgress2.flags |= _fiberFlags;
          }
        } else {
          if (typeof instance2.componentDidMount === "function") {
            var _fiberFlags2 = Update;
            {
              _fiberFlags2 |= LayoutStatic;
            }
            if ((workInProgress2.mode & StrictEffectsMode) !== NoMode) {
              _fiberFlags2 |= MountLayoutDev;
            }
            workInProgress2.flags |= _fiberFlags2;
          }
          workInProgress2.memoizedProps = newProps;
          workInProgress2.memoizedState = newState;
        }
        instance2.props = newProps;
        instance2.state = newState;
        instance2.context = nextContext;
        return shouldUpdate;
      }
      function updateClassInstance(current2, workInProgress2, ctor, newProps, renderLanes2) {
        var instance2 = workInProgress2.stateNode;
        cloneUpdateQueue(current2, workInProgress2);
        var unresolvedOldProps = workInProgress2.memoizedProps;
        var oldProps = workInProgress2.type === workInProgress2.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress2.type, unresolvedOldProps);
        instance2.props = oldProps;
        var unresolvedNewProps = workInProgress2.pendingProps;
        var oldContext = instance2.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) {
          nextContext = readContext(contextType);
        } else {
          var nextUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
          nextContext = getMaskedContext(workInProgress2, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance2.getSnapshotBeforeUpdate === "function";
        if (!hasNewLifecycles && (typeof instance2.UNSAFE_componentWillReceiveProps === "function" || typeof instance2.componentWillReceiveProps === "function")) {
          if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
            callComponentWillReceiveProps(workInProgress2, instance2, newProps, nextContext);
          }
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress2.memoizedState;
        var newState = instance2.state = oldState;
        processUpdateQueue(workInProgress2, newProps, instance2, renderLanes2);
        newState = workInProgress2.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
          if (typeof instance2.componentDidUpdate === "function") {
            if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
              workInProgress2.flags |= Update;
            }
          }
          if (typeof instance2.getSnapshotBeforeUpdate === "function") {
            if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
              workInProgress2.flags |= Snapshot;
            }
          }
          return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
          applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
          newState = workInProgress2.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
          if (!hasNewLifecycles && (typeof instance2.UNSAFE_componentWillUpdate === "function" || typeof instance2.componentWillUpdate === "function")) {
            if (typeof instance2.componentWillUpdate === "function") {
              instance2.componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance2.UNSAFE_componentWillUpdate === "function") {
              instance2.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
          }
          if (typeof instance2.componentDidUpdate === "function") {
            workInProgress2.flags |= Update;
          }
          if (typeof instance2.getSnapshotBeforeUpdate === "function") {
            workInProgress2.flags |= Snapshot;
          }
        } else {
          if (typeof instance2.componentDidUpdate === "function") {
            if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
              workInProgress2.flags |= Update;
            }
          }
          if (typeof instance2.getSnapshotBeforeUpdate === "function") {
            if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
              workInProgress2.flags |= Snapshot;
            }
          }
          workInProgress2.memoizedProps = newProps;
          workInProgress2.memoizedState = newState;
        }
        instance2.props = newProps;
        instance2.state = newState;
        instance2.context = nextContext;
        return shouldUpdate;
      }
      var forkStack = [];
      var forkStackIndex = 0;
      var treeForkProvider = null;
      var treeForkCount = 0;
      var idStack = [];
      var idStackIndex = 0;
      var treeContextProvider = null;
      var treeContextId = 1;
      var treeContextOverflow = "";
      function isForkedChild(workInProgress2) {
        warnIfNotHydrating();
        return (workInProgress2.flags & Forked) !== NoFlags;
      }
      function getForksAtLevel(workInProgress2) {
        warnIfNotHydrating();
        return treeForkCount;
      }
      function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
      }
      function pushTreeFork(workInProgress2, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress2;
        treeForkCount = totalChildren;
      }
      function pushTreeId(workInProgress2, totalChildren, index3) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress2;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow;
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index3 + 1;
        var length2 = getBitLength(totalChildren) + baseLength;
        if (length2 > 30) {
          var numberOfOverflowBits = baseLength - baseLength % 5;
          var newOverflowBits = (1 << numberOfOverflowBits) - 1;
          var newOverflow = (baseId & newOverflowBits).toString(32);
          var restOfBaseId = baseId >> numberOfOverflowBits;
          var restOfBaseLength = baseLength - numberOfOverflowBits;
          var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
          var restOfNewBits = slot << restOfBaseLength;
          var id = restOfNewBits | restOfBaseId;
          var overflow = newOverflow + baseOverflow;
          treeContextId = 1 << restOfLength | id;
          treeContextOverflow = overflow;
        } else {
          var newBits = slot << baseLength;
          var _id2 = newBits | baseId;
          var _overflow = baseOverflow;
          treeContextId = 1 << length2 | _id2;
          treeContextOverflow = _overflow;
        }
      }
      function pushMaterializedTreeId(workInProgress2) {
        warnIfNotHydrating();
        var returnFiber = workInProgress2.return;
        if (returnFiber !== null) {
          var numberOfForks = 1;
          var slotIndex = 0;
          pushTreeFork(workInProgress2, numberOfForks);
          pushTreeId(workInProgress2, numberOfForks, slotIndex);
        }
      }
      function getBitLength(number2) {
        return 32 - clz32(number2);
      }
      function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
      }
      function popTreeContext(workInProgress2) {
        while (workInProgress2 === treeForkProvider) {
          treeForkProvider = forkStack[--forkStackIndex];
          forkStack[forkStackIndex] = null;
          treeForkCount = forkStack[--forkStackIndex];
          forkStack[forkStackIndex] = null;
        }
        while (workInProgress2 === treeContextProvider) {
          treeContextProvider = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
          treeContextOverflow = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
          treeContextId = idStack[--idStackIndex];
          idStack[idStackIndex] = null;
        }
      }
      function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) {
          return {
            id: treeContextId,
            overflow: treeContextOverflow
          };
        } else {
          return null;
        }
      }
      function restoreSuspendedTreeContext(workInProgress2, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress2;
      }
      function warnIfNotHydrating() {
        {
          if (!getIsHydrating()) {
            error2("Expected to be hydrating. This is a bug in React. Please file an issue.");
          }
        }
      }
      var hydrationParentFiber = null;
      var nextHydratableInstance = null;
      var isHydrating = false;
      var didSuspend = false;
      var hydrationErrors = null;
      function warnIfHydrating() {
        {
          if (isHydrating) {
            error2("We should not be hydrating here. This is a bug in React. Please file a bug.");
          }
        }
      }
      function markDidSuspendWhileHydratingDEV() {
        {
          didSuspend = true;
        }
      }
      function enterHydrationState(fiber) {
        if (!supportsHydration) {
          return false;
        }
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspend = false;
        return true;
      }
      function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        if (!supportsHydration) {
          return false;
        }
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspend = false;
        if (treeContext !== null) {
          restoreSuspendedTreeContext(fiber, treeContext);
        }
        return true;
      }
      function warnUnhydratedInstance(returnFiber, instance2) {
        {
          switch (returnFiber.tag) {
            case HostRoot:
              didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance2);
              break;
            case HostComponent:
              didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance2);
              break;
            case SuspenseComponent:
              var suspenseState = returnFiber.memoizedState;
              if (suspenseState.dehydrated !== null)
                didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance2);
              break;
          }
        }
      }
      function deleteHydratableInstance(returnFiber, instance2) {
        warnUnhydratedInstance(returnFiber, instance2);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance2;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
          returnFiber.deletions = [childToDelete];
          returnFiber.flags |= ChildDeletion;
        } else {
          deletions.push(childToDelete);
        }
      }
      function warnNonhydratedInstance(returnFiber, fiber) {
        {
          if (didSuspend) {
            return;
          }
          switch (returnFiber.tag) {
            case HostRoot: {
              var parentContainer = returnFiber.stateNode.containerInfo;
              switch (fiber.tag) {
                case HostComponent:
                  var type = fiber.type;
                  var props = fiber.pendingProps;
                  didNotFindHydratableInstanceWithinContainer(parentContainer, type, props);
                  break;
                case HostText:
                  var text = fiber.pendingProps;
                  didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                  break;
                case SuspenseComponent:
                  didNotFindHydratableSuspenseInstanceWithinContainer(parentContainer);
                  break;
              }
              break;
            }
            case HostComponent: {
              var parentType = returnFiber.type;
              var parentProps = returnFiber.memoizedProps;
              var parentInstance = returnFiber.stateNode;
              switch (fiber.tag) {
                case HostComponent:
                  var _type = fiber.type;
                  var _props = fiber.pendingProps;
                  didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props);
                  break;
                case HostText:
                  var _text = fiber.pendingProps;
                  didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                  break;
                case SuspenseComponent:
                  didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance);
                  break;
              }
              break;
            }
            case SuspenseComponent: {
              var suspenseState = returnFiber.memoizedState;
              var _parentInstance = suspenseState.dehydrated;
              if (_parentInstance !== null)
                switch (fiber.tag) {
                  case HostComponent:
                    var _type2 = fiber.type;
                    var _props2 = fiber.pendingProps;
                    didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2, _props2);
                    break;
                  case HostText:
                    var _text2 = fiber.pendingProps;
                    didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                    break;
                  case SuspenseComponent:
                    didNotFindHydratableSuspenseInstanceWithinSuspenseInstance(_parentInstance);
                    break;
                }
              break;
            }
            default:
              return;
          }
        }
      }
      function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
      }
      function tryHydrate(fiber, nextInstance) {
        switch (fiber.tag) {
          case HostComponent: {
            var type = fiber.type;
            var props = fiber.pendingProps;
            var instance2 = canHydrateInstance(nextInstance, type, props);
            if (instance2 !== null) {
              fiber.stateNode = instance2;
              hydrationParentFiber = fiber;
              nextHydratableInstance = getFirstHydratableChild(instance2);
              return true;
            }
            return false;
          }
          case HostText: {
            var text = fiber.pendingProps;
            var textInstance = canHydrateTextInstance(nextInstance, text);
            if (textInstance !== null) {
              fiber.stateNode = textInstance;
              hydrationParentFiber = fiber;
              nextHydratableInstance = null;
              return true;
            }
            return false;
          }
          case SuspenseComponent: {
            {
              var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
              if (suspenseInstance !== null) {
                var suspenseState = {
                  dehydrated: suspenseInstance,
                  treeContext: getSuspendedTreeContext(),
                  retryLane: OffscreenLane
                };
                fiber.memoizedState = suspenseState;
                var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                dehydratedFragment.return = fiber;
                fiber.child = dehydratedFragment;
                hydrationParentFiber = fiber;
                nextHydratableInstance = null;
                return true;
              }
            }
            return false;
          }
          default:
            return false;
        }
      }
      function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
      }
      function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
      }
      function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) {
          return;
        }
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
          if (shouldClientRenderOnMismatch(fiber)) {
            warnNonhydratedInstance(hydrationParentFiber, fiber);
            throwOnHydrationMismatch();
          }
          insertNonHydratedInstance(hydrationParentFiber, fiber);
          isHydrating = false;
          hydrationParentFiber = fiber;
          return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
          if (shouldClientRenderOnMismatch(fiber)) {
            warnNonhydratedInstance(hydrationParentFiber, fiber);
            throwOnHydrationMismatch();
          }
          nextInstance = getNextHydratableSibling(firstAttemptedInstance);
          var prevHydrationParentFiber = hydrationParentFiber;
          if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
          }
          deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
      }
      function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        if (!supportsHydration) {
          throw new Error("Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        }
        var instance2 = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspend;
        var updatePayload = hydrateInstance(instance2, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev);
        fiber.updateQueue = updatePayload;
        if (updatePayload !== null) {
          return true;
        }
        return false;
      }
      function prepareToHydrateHostTextInstance(fiber) {
        if (!supportsHydration) {
          throw new Error("Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        }
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldWarnIfMismatchDev = !didSuspend;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber, shouldWarnIfMismatchDev);
        if (shouldUpdate) {
          var returnFiber = hydrationParentFiber;
          if (returnFiber !== null) {
            var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
            switch (returnFiber.tag) {
              case HostRoot: {
                var parentContainer = returnFiber.stateNode.containerInfo;
                didNotMatchHydratedContainerTextInstance(
                  parentContainer,
                  textInstance,
                  textContent,
                  // TODO: Delete this argument when we remove the legacy root API.
                  isConcurrentMode
                );
                break;
              }
              case HostComponent: {
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                didNotMatchHydratedTextInstance(
                  parentType,
                  parentProps,
                  parentInstance,
                  textInstance,
                  textContent,
                  // TODO: Delete this argument when we remove the legacy root API.
                  isConcurrentMode
                );
                break;
              }
            }
          }
        }
        return shouldUpdate;
      }
      function prepareToHydrateHostSuspenseInstance(fiber) {
        if (!supportsHydration) {
          throw new Error("Expected prepareToHydrateHostSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        }
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) {
          throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        }
        hydrateSuspenseInstance(suspenseInstance, fiber);
      }
      function skipPastDehydratedSuspenseInstance(fiber) {
        if (!supportsHydration) {
          throw new Error("Expected skipPastDehydratedSuspenseInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
        }
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) {
          throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        }
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
      }
      function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while (parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent) {
          parent = parent.return;
        }
        hydrationParentFiber = parent;
      }
      function popHydrationState(fiber) {
        if (!supportsHydration) {
          return false;
        }
        if (fiber !== hydrationParentFiber) {
          return false;
        }
        if (!isHydrating) {
          popToNextHostParent(fiber);
          isHydrating = true;
          return false;
        }
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
          var nextInstance = nextHydratableInstance;
          if (nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
              warnIfUnhydratedTailNodes(fiber);
              throwOnHydrationMismatch();
            } else {
              while (nextInstance) {
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
              }
            }
          }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) {
          nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        } else {
          nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        }
        return true;
      }
      function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
      }
      function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while (nextInstance) {
          warnUnhydratedInstance(fiber, nextInstance);
          nextInstance = getNextHydratableSibling(nextInstance);
        }
      }
      function resetHydrationState() {
        if (!supportsHydration) {
          return;
        }
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspend = false;
      }
      function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
          queueRecoverableErrors(hydrationErrors);
          hydrationErrors = null;
        }
      }
      function getIsHydrating() {
        return isHydrating;
      }
      function queueHydrationError(error3) {
        if (hydrationErrors === null) {
          hydrationErrors = [error3];
        } else {
          hydrationErrors.push(error3);
        }
      }
      var didWarnAboutMaps;
      var didWarnAboutGenerators;
      var didWarnAboutStringRefs;
      var ownerHasKeyUseWarning;
      var ownerHasFunctionTypeWarning;
      var warnForMissingKey = function(child, returnFiber) {
      };
      {
        didWarnAboutMaps = false;
        didWarnAboutGenerators = false;
        didWarnAboutStringRefs = {};
        ownerHasKeyUseWarning = {};
        ownerHasFunctionTypeWarning = {};
        warnForMissingKey = function(child, returnFiber) {
          if (child === null || typeof child !== "object") {
            return;
          }
          if (!child._store || child._store.validated || child.key != null) {
            return;
          }
          if (typeof child._store !== "object") {
            throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
          }
          child._store.validated = true;
          var componentName = getComponentNameFromFiber(returnFiber) || "Component";
          if (ownerHasKeyUseWarning[componentName]) {
            return;
          }
          ownerHasKeyUseWarning[componentName] = true;
          error2('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
        };
      }
      function coerceRef(returnFiber, current2, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
          {
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
              var componentName = getComponentNameFromFiber(returnFiber) || "Component";
              if (!didWarnAboutStringRefs[componentName]) {
                {
                  error2('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                }
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
          if (element._owner) {
            var owner = element._owner;
            var inst;
            if (owner) {
              var ownerFiber = owner;
              if (ownerFiber.tag !== ClassComponent) {
                throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
              }
              inst = ownerFiber.stateNode;
            }
            if (!inst) {
              throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
            }
            var resolvedInst = inst;
            {
              checkPropStringCoercion(mixedRef, "ref");
            }
            var stringRef = "" + mixedRef;
            if (current2 !== null && current2.ref !== null && typeof current2.ref === "function" && current2.ref._stringRef === stringRef) {
              return current2.ref;
            }
            var ref = function(value) {
              var refs = resolvedInst.refs;
              if (refs === emptyRefsObject) {
                refs = resolvedInst.refs = {};
              }
              if (value === null) {
                delete refs[stringRef];
              } else {
                refs[stringRef] = value;
              }
            };
            ref._stringRef = stringRef;
            return ref;
          } else {
            if (typeof mixedRef !== "string") {
              throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
            }
            if (!element._owner) {
              throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
            }
          }
        }
        return mixedRef;
      }
      function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). If you meant to render a collection of children, use an array instead.");
      }
      function warnOnFunctionType(returnFiber) {
        {
          var componentName = getComponentNameFromFiber(returnFiber) || "Component";
          if (ownerHasFunctionTypeWarning[componentName]) {
            return;
          }
          ownerHasFunctionTypeWarning[componentName] = true;
          error2("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
        }
      }
      function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init9 = lazyType._init;
        return init9(payload);
      }
      function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
          if (!shouldTrackSideEffects) {
            return;
          }
          var deletions = returnFiber.deletions;
          if (deletions === null) {
            returnFiber.deletions = [childToDelete];
            returnFiber.flags |= ChildDeletion;
          } else {
            deletions.push(childToDelete);
          }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
          if (!shouldTrackSideEffects) {
            return null;
          }
          var childToDelete = currentFirstChild;
          while (childToDelete !== null) {
            deleteChild(returnFiber, childToDelete);
            childToDelete = childToDelete.sibling;
          }
          return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
          var existingChildren = /* @__PURE__ */ new Map();
          var existingChild = currentFirstChild;
          while (existingChild !== null) {
            if (existingChild.key !== null) {
              existingChildren.set(existingChild.key, existingChild);
            } else {
              existingChildren.set(existingChild.index, existingChild);
            }
            existingChild = existingChild.sibling;
          }
          return existingChildren;
        }
        function useFiber2(fiber, pendingProps) {
          var clone8 = createWorkInProgress(fiber, pendingProps);
          clone8.index = 0;
          clone8.sibling = null;
          return clone8;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
          newFiber.index = newIndex;
          if (!shouldTrackSideEffects) {
            newFiber.flags |= Forked;
            return lastPlacedIndex;
          }
          var current2 = newFiber.alternate;
          if (current2 !== null) {
            var oldIndex = current2.index;
            if (oldIndex < lastPlacedIndex) {
              newFiber.flags |= Placement;
              return lastPlacedIndex;
            } else {
              return oldIndex;
            }
          } else {
            newFiber.flags |= Placement;
            return lastPlacedIndex;
          }
        }
        function placeSingleChild(newFiber) {
          if (shouldTrackSideEffects && newFiber.alternate === null) {
            newFiber.flags |= Placement;
          }
          return newFiber;
        }
        function updateTextNode(returnFiber, current2, textContent, lanes) {
          if (current2 === null || current2.tag !== HostText) {
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          } else {
            var existing = useFiber2(current2, textContent);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateElement(returnFiber, current2, element, lanes) {
          var elementType = element.type;
          if (elementType === REACT_FRAGMENT_TYPE) {
            return updateFragment2(returnFiber, current2, element.props.children, lanes, element.key);
          }
          if (current2 !== null) {
            if (current2.elementType === elementType || // Keep this check inline so it only runs on the false path:
            isCompatibleFamilyForHotReloading(current2, element) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current2.type) {
              var existing = useFiber2(current2, element.props);
              existing.ref = coerceRef(returnFiber, current2, element);
              existing.return = returnFiber;
              {
                existing._debugSource = element._source;
                existing._debugOwner = element._owner;
              }
              return existing;
            }
          }
          var created = createFiberFromElement(element, returnFiber.mode, lanes);
          created.ref = coerceRef(returnFiber, current2, element);
          created.return = returnFiber;
          return created;
        }
        function updatePortal(returnFiber, current2, portal, lanes) {
          if (current2 === null || current2.tag !== HostPortal || current2.stateNode.containerInfo !== portal.containerInfo || current2.stateNode.implementation !== portal.implementation) {
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          } else {
            var existing = useFiber2(current2, portal.children || []);
            existing.return = returnFiber;
            return existing;
          }
        }
        function updateFragment2(returnFiber, current2, fragment2, lanes, key) {
          if (current2 === null || current2.tag !== Fragment2) {
            var created = createFiberFromFragment(fragment2, returnFiber.mode, lanes, key);
            created.return = returnFiber;
            return created;
          } else {
            var existing = useFiber2(current2, fragment2);
            existing.return = returnFiber;
            return existing;
          }
        }
        function createChild(returnFiber, newChild, lanes) {
          if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
            var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          }
          if (typeof newChild === "object" && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE: {
                var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                _created.ref = coerceRef(returnFiber, null, newChild);
                _created.return = returnFiber;
                return _created;
              }
              case REACT_PORTAL_TYPE: {
                var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                _created2.return = returnFiber;
                return _created2;
              }
              case REACT_LAZY_TYPE: {
                {
                  var payload = newChild._payload;
                  var init9 = newChild._init;
                  return createChild(returnFiber, init9(payload), lanes);
                }
              }
            }
            if (isArray3(newChild) || getIteratorFn(newChild)) {
              var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
              _created3.return = returnFiber;
              return _created3;
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === "function") {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
          var key = oldFiber !== null ? oldFiber.key : null;
          if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
            if (key !== null) {
              return null;
            }
            return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
          }
          if (typeof newChild === "object" && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE: {
                if (newChild.key === key) {
                  return updateElement(returnFiber, oldFiber, newChild, lanes);
                } else {
                  return null;
                }
              }
              case REACT_PORTAL_TYPE: {
                if (newChild.key === key) {
                  return updatePortal(returnFiber, oldFiber, newChild, lanes);
                } else {
                  return null;
                }
              }
              case REACT_LAZY_TYPE: {
                {
                  var payload = newChild._payload;
                  var init9 = newChild._init;
                  return updateSlot(returnFiber, oldFiber, init9(payload), lanes);
                }
              }
            }
            if (isArray3(newChild) || getIteratorFn(newChild)) {
              if (key !== null) {
                return null;
              }
              return updateFragment2(returnFiber, oldFiber, newChild, lanes, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === "function") {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
          if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
            var matchedFiber = existingChildren.get(newIdx) || null;
            return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
          }
          if (typeof newChild === "object" && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE: {
                var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                return updateElement(returnFiber, _matchedFiber, newChild, lanes);
              }
              case REACT_PORTAL_TYPE: {
                var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
              }
              case REACT_LAZY_TYPE: {
                var payload = newChild._payload;
                var init9 = newChild._init;
                return updateFromMap(existingChildren, returnFiber, newIdx, init9(payload), lanes);
              }
            }
            if (isArray3(newChild) || getIteratorFn(newChild)) {
              var _matchedFiber3 = existingChildren.get(newIdx) || null;
              return updateFragment2(returnFiber, _matchedFiber3, newChild, lanes, null);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          {
            if (typeof newChild === "function") {
              warnOnFunctionType(returnFiber);
            }
          }
          return null;
        }
        function warnOnInvalidKey(child, knownKeys, returnFiber) {
          {
            if (typeof child !== "object" || child === null) {
              return knownKeys;
            }
            switch (child.$$typeof) {
              case REACT_ELEMENT_TYPE:
              case REACT_PORTAL_TYPE:
                warnForMissingKey(child, returnFiber);
                var key = child.key;
                if (typeof key !== "string") {
                  break;
                }
                if (knownKeys === null) {
                  knownKeys = /* @__PURE__ */ new Set();
                  knownKeys.add(key);
                  break;
                }
                if (!knownKeys.has(key)) {
                  knownKeys.add(key);
                  break;
                }
                error2("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", key);
                break;
              case REACT_LAZY_TYPE: {
                var payload = child._payload;
                var init9 = child._init;
                warnOnInvalidKey(init9(payload), knownKeys, returnFiber);
                break;
              }
            }
          }
          return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
          {
            var knownKeys = null;
            for (var i2 = 0; i2 < newChildren.length; i2++) {
              var child = newChildren[i2];
              knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (newFiber === null) {
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              resultingFirstChild = newFiber;
            } else {
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (newIdx === newChildren.length) {
            deleteRemainingChildren(returnFiber, oldFiber);
            if (getIsHydrating()) {
              var numberOfForks = newIdx;
              pushTreeFork(returnFiber, numberOfForks);
            }
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
              if (_newFiber === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber;
              } else {
                previousNewFiber.sibling = _newFiber;
              }
              previousNewFiber = _newFiber;
            }
            if (getIsHydrating()) {
              var _numberOfForks = newIdx;
              pushTreeFork(returnFiber, _numberOfForks);
            }
            return resultingFirstChild;
          }
          var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
          for (; newIdx < newChildren.length; newIdx++) {
            var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
            if (_newFiber2 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber2.alternate !== null) {
                  existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber2;
              } else {
                previousNewFiber.sibling = _newFiber2;
              }
              previousNewFiber = _newFiber2;
            }
          }
          if (shouldTrackSideEffects) {
            existingChildren.forEach(function(child2) {
              return deleteChild(returnFiber, child2);
            });
          }
          if (getIsHydrating()) {
            var _numberOfForks2 = newIdx;
            pushTreeFork(returnFiber, _numberOfForks2);
          }
          return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
          var iteratorFn = getIteratorFn(newChildrenIterable);
          if (typeof iteratorFn !== "function") {
            throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
          }
          {
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
              if (!didWarnAboutGenerators) {
                error2("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
              }
              didWarnAboutGenerators = true;
            }
            if (newChildrenIterable.entries === iteratorFn) {
              if (!didWarnAboutMaps) {
                error2("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
              }
              didWarnAboutMaps = true;
            }
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
              var knownKeys = null;
              var _step = _newChildren.next();
              for (; !_step.done; _step = _newChildren.next()) {
                var child = _step.value;
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
              }
            }
          }
          var newChildren = iteratorFn.call(newChildrenIterable);
          if (newChildren == null) {
            throw new Error("An iterable object provided no iterator.");
          }
          var resultingFirstChild = null;
          var previousNewFiber = null;
          var oldFiber = currentFirstChild;
          var lastPlacedIndex = 0;
          var newIdx = 0;
          var nextOldFiber = null;
          var step = newChildren.next();
          for (; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()) {
            if (oldFiber.index > newIdx) {
              nextOldFiber = oldFiber;
              oldFiber = null;
            } else {
              nextOldFiber = oldFiber.sibling;
            }
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (newFiber === null) {
              if (oldFiber === null) {
                oldFiber = nextOldFiber;
              }
              break;
            }
            if (shouldTrackSideEffects) {
              if (oldFiber && newFiber.alternate === null) {
                deleteChild(returnFiber, oldFiber);
              }
            }
            lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
            if (previousNewFiber === null) {
              resultingFirstChild = newFiber;
            } else {
              previousNewFiber.sibling = newFiber;
            }
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
          }
          if (step.done) {
            deleteRemainingChildren(returnFiber, oldFiber);
            if (getIsHydrating()) {
              var numberOfForks = newIdx;
              pushTreeFork(returnFiber, numberOfForks);
            }
            return resultingFirstChild;
          }
          if (oldFiber === null) {
            for (; !step.done; newIdx++, step = newChildren.next()) {
              var _newFiber3 = createChild(returnFiber, step.value, lanes);
              if (_newFiber3 === null) {
                continue;
              }
              lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber3;
              } else {
                previousNewFiber.sibling = _newFiber3;
              }
              previousNewFiber = _newFiber3;
            }
            if (getIsHydrating()) {
              var _numberOfForks3 = newIdx;
              pushTreeFork(returnFiber, _numberOfForks3);
            }
            return resultingFirstChild;
          }
          var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
          for (; !step.done; newIdx++, step = newChildren.next()) {
            var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
            if (_newFiber4 !== null) {
              if (shouldTrackSideEffects) {
                if (_newFiber4.alternate !== null) {
                  existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                }
              }
              lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = _newFiber4;
              } else {
                previousNewFiber.sibling = _newFiber4;
              }
              previousNewFiber = _newFiber4;
            }
          }
          if (shouldTrackSideEffects) {
            existingChildren.forEach(function(child2) {
              return deleteChild(returnFiber, child2);
            });
          }
          if (getIsHydrating()) {
            var _numberOfForks4 = newIdx;
            pushTreeFork(returnFiber, _numberOfForks4);
          }
          return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
          if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
            var existing = useFiber2(currentFirstChild, textContent);
            existing.return = returnFiber;
            return existing;
          }
          deleteRemainingChildren(returnFiber, currentFirstChild);
          var created = createFiberFromText(textContent, returnFiber.mode, lanes);
          created.return = returnFiber;
          return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
          var key = element.key;
          var child = currentFirstChild;
          while (child !== null) {
            if (child.key === key) {
              var elementType = element.type;
              if (elementType === REACT_FRAGMENT_TYPE) {
                if (child.tag === Fragment2) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber2(child, element.props.children);
                  existing.return = returnFiber;
                  {
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                  }
                  return existing;
                }
              } else {
                if (child.elementType === elementType || // Keep this check inline so it only runs on the false path:
                isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var _existing = useFiber2(child, element.props);
                  _existing.ref = coerceRef(returnFiber, child, element);
                  _existing.return = returnFiber;
                  {
                    _existing._debugSource = element._source;
                    _existing._debugOwner = element._owner;
                  }
                  return _existing;
                }
              }
              deleteRemainingChildren(returnFiber, child);
              break;
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          if (element.type === REACT_FRAGMENT_TYPE) {
            var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
            created.return = returnFiber;
            return created;
          } else {
            var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
            _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
            _created4.return = returnFiber;
            return _created4;
          }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
          var key = portal.key;
          var child = currentFirstChild;
          while (child !== null) {
            if (child.key === key) {
              if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                deleteRemainingChildren(returnFiber, child.sibling);
                var existing = useFiber2(child, portal.children || []);
                existing.return = returnFiber;
                return existing;
              } else {
                deleteRemainingChildren(returnFiber, child);
                break;
              }
            } else {
              deleteChild(returnFiber, child);
            }
            child = child.sibling;
          }
          var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
          created.return = returnFiber;
          return created;
        }
        function reconcileChildFibers2(returnFiber, currentFirstChild, newChild, lanes) {
          var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
          if (isUnkeyedTopLevelFragment) {
            newChild = newChild.props.children;
          }
          if (typeof newChild === "object" && newChild !== null) {
            switch (newChild.$$typeof) {
              case REACT_ELEMENT_TYPE:
                return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
              case REACT_PORTAL_TYPE:
                return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
              case REACT_LAZY_TYPE: {
                var payload = newChild._payload;
                var init9 = newChild._init;
                return reconcileChildFibers2(returnFiber, currentFirstChild, init9(payload), lanes);
              }
            }
            if (isArray3(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            throwOnInvalidObjectType(returnFiber, newChild);
          }
          if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
            return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
          }
          {
            if (typeof newChild === "function") {
              warnOnFunctionType(returnFiber);
            }
          }
          return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers2;
      }
      var reconcileChildFibers = ChildReconciler(true);
      var mountChildFibers = ChildReconciler(false);
      function cloneChildFibers(current2, workInProgress2) {
        if (current2 !== null && workInProgress2.child !== current2.child) {
          throw new Error("Resuming work not yet implemented.");
        }
        if (workInProgress2.child === null) {
          return;
        }
        var currentChild = workInProgress2.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress2.child = newChild;
        newChild.return = workInProgress2;
        while (currentChild.sibling !== null) {
          currentChild = currentChild.sibling;
          newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
          newChild.return = workInProgress2;
        }
        newChild.sibling = null;
      }
      function resetChildFibers(workInProgress2, lanes) {
        var child = workInProgress2.child;
        while (child !== null) {
          resetWorkInProgress(child, lanes);
          child = child.sibling;
        }
      }
      var NO_CONTEXT = {};
      var contextStackCursor$1 = createCursor(NO_CONTEXT);
      var contextFiberStackCursor = createCursor(NO_CONTEXT);
      var rootInstanceStackCursor = createCursor(NO_CONTEXT);
      function requiredContext(c2) {
        if (c2 === NO_CONTEXT) {
          throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        }
        return c2;
      }
      function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
      }
      function pushHostContainer(fiber, nextRootInstance) {
        push2(rootInstanceStackCursor, nextRootInstance, fiber);
        push2(contextFiberStackCursor, fiber, fiber);
        push2(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance);
        pop(contextStackCursor$1, fiber);
        push2(contextStackCursor$1, nextRootContext, fiber);
      }
      function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
      }
      function getHostContext() {
        var context2 = requiredContext(contextStackCursor$1.current);
        return context2;
      }
      function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context2 = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context2, fiber.type, rootInstance);
        if (context2 === nextContext) {
          return;
        }
        push2(contextFiberStackCursor, fiber, fiber);
        push2(contextStackCursor$1, nextContext, fiber);
      }
      function popHostContext(fiber) {
        if (contextFiberStackCursor.current !== fiber) {
          return;
        }
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
      }
      var DefaultSuspenseContext = 0;
      var SubtreeSuspenseContextMask = 1;
      var InvisibleParentSuspenseContext = 1;
      var ForceSuspenseFallback = 2;
      var suspenseStackCursor = createCursor(DefaultSuspenseContext);
      function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
      }
      function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
      }
      function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
      }
      function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
      }
      function pushSuspenseContext(fiber, newContext) {
        push2(suspenseStackCursor, newContext, fiber);
      }
      function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
      }
      function shouldCaptureSuspense(workInProgress2, hasInvisibleParent) {
        var nextState = workInProgress2.memoizedState;
        if (nextState !== null) {
          if (nextState.dehydrated !== null) {
            return true;
          }
          return false;
        }
        workInProgress2.memoizedProps;
        {
          return true;
        }
      }
      function findFirstSuspended(row) {
        var node = row;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              var dehydrated = state.dehydrated;
              if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) {
                return node;
              }
            }
          } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
          // keep track of whether it suspended or not.
          node.memoizedProps.revealOrder !== void 0) {
            var didSuspend2 = (node.flags & DidCapture) !== NoFlags;
            if (didSuspend2) {
              return node;
            }
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === row) {
            return null;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === row) {
              return null;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
        return null;
      }
      var NoFlags$1 = (
        /*   */
        0
      );
      var HasEffect = (
        /* */
        1
      );
      var Insertion = (
        /*  */
        2
      );
      var Layout2 = (
        /*    */
        4
      );
      var Passive$1 = (
        /*   */
        8
      );
      var workInProgressSources = [];
      function resetWorkInProgressVersions() {
        for (var i2 = 0; i2 < workInProgressSources.length; i2++) {
          var mutableSource = workInProgressSources[i2];
          if (isPrimaryRenderer) {
            mutableSource._workInProgressVersionPrimary = null;
          } else {
            mutableSource._workInProgressVersionSecondary = null;
          }
        }
        workInProgressSources.length = 0;
      }
      function registerMutableSourceForHydration(root2, mutableSource) {
        var getVersion2 = mutableSource._getVersion;
        var version2 = getVersion2(mutableSource._source);
        if (root2.mutableSourceEagerHydrationData == null) {
          root2.mutableSourceEagerHydrationData = [mutableSource, version2];
        } else {
          root2.mutableSourceEagerHydrationData.push(mutableSource, version2);
        }
      }
      var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
      var didWarnAboutMismatchedHooksForComponent;
      var didWarnUncachedGetSnapshot;
      {
        didWarnAboutMismatchedHooksForComponent = /* @__PURE__ */ new Set();
      }
      var renderLanes = NoLanes;
      var currentlyRenderingFiber$1 = null;
      var currentHook = null;
      var workInProgressHook = null;
      var didScheduleRenderPhaseUpdate = false;
      var didScheduleRenderPhaseUpdateDuringThisPass = false;
      var localIdCounter = 0;
      var globalClientIdCounter = 0;
      var RE_RENDER_LIMIT = 25;
      var currentHookNameInDev = null;
      var hookTypesDev = null;
      var hookTypesUpdateIndexDev = -1;
      var ignorePreviousDependencies = false;
      function mountHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev === null) {
            hookTypesDev = [hookName];
          } else {
            hookTypesDev.push(hookName);
          }
        }
      }
      function updateHookTypesDev() {
        {
          var hookName = currentHookNameInDev;
          if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
              warnOnHookMismatchInDev(hookName);
            }
          }
        }
      }
      function checkDepsAreArrayDev(deps) {
        {
          if (deps !== void 0 && deps !== null && !isArray3(deps)) {
            error2("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
          }
        }
      }
      function warnOnHookMismatchInDev(currentHookName) {
        {
          var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
          if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
              var table = "";
              var secondColumnStart = 30;
              for (var i2 = 0; i2 <= hookTypesUpdateIndexDev; i2++) {
                var oldHookName = hookTypesDev[i2];
                var newHookName = i2 === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                var row = i2 + 1 + ". " + oldHookName;
                while (row.length < secondColumnStart) {
                  row += " ";
                }
                row += newHookName + "\n";
                table += row;
              }
              error2("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
          }
        }
      }
      function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
      }
      function areHookInputsEqual(nextDeps, prevDeps) {
        {
          if (ignorePreviousDependencies) {
            return false;
          }
        }
        if (prevDeps === null) {
          {
            error2("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
          }
          return false;
        }
        {
          if (nextDeps.length !== prevDeps.length) {
            error2("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
          }
        }
        for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++) {
          if (objectIs2(nextDeps[i2], prevDeps[i2])) {
            continue;
          }
          return false;
        }
        return true;
      }
      function renderWithHooks(current2, workInProgress2, Component2, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress2;
        {
          hookTypesDev = current2 !== null ? current2._debugHookTypes : null;
          hookTypesUpdateIndexDev = -1;
          ignorePreviousDependencies = current2 !== null && current2.type !== workInProgress2.type;
        }
        workInProgress2.memoizedState = null;
        workInProgress2.updateQueue = null;
        workInProgress2.lanes = NoLanes;
        {
          if (current2 !== null && current2.memoizedState !== null) {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
          } else if (hookTypesDev !== null) {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
          } else {
            ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
          }
        }
        var children = Component2(props, secondArg);
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
          var numberOfReRenders = 0;
          do {
            didScheduleRenderPhaseUpdateDuringThisPass = false;
            localIdCounter = 0;
            if (numberOfReRenders >= RE_RENDER_LIMIT) {
              throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            }
            numberOfReRenders += 1;
            {
              ignorePreviousDependencies = false;
            }
            currentHook = null;
            workInProgressHook = null;
            workInProgress2.updateQueue = null;
            {
              hookTypesUpdateIndexDev = -1;
            }
            ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
            children = Component2(props, secondArg);
          } while (didScheduleRenderPhaseUpdateDuringThisPass);
        }
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        {
          workInProgress2._debugHookTypes = hookTypesDev;
        }
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          currentHookNameInDev = null;
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
          if (current2 !== null && (current2.flags & StaticMask) !== (workInProgress2.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
          // and creates false positives. To make this work in legacy mode, we'd
          // need to mark fibers that commit in an incomplete state, somehow. For
          // now I'll disable the warning that most of the bugs that would trigger
          // it are either exclusive to concurrent mode or exist in both.
          (current2.mode & ConcurrentMode) !== NoMode) {
            error2("Internal React error: Expected static flag was missing. Please notify the React team.");
          }
        }
        didScheduleRenderPhaseUpdate = false;
        if (didRenderTooFewHooks) {
          throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        }
        return children;
      }
      function checkDidRenderIdHook() {
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
      }
      function bailoutHooks(current2, workInProgress2, lanes) {
        workInProgress2.updateQueue = current2.updateQueue;
        if ((workInProgress2.mode & StrictEffectsMode) !== NoMode) {
          workInProgress2.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        } else {
          workInProgress2.flags &= ~(Passive | Update);
        }
        current2.lanes = removeLanes(current2.lanes, lanes);
      }
      function resetHooksAfterThrow() {
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
          var hook = currentlyRenderingFiber$1.memoizedState;
          while (hook !== null) {
            var queue = hook.queue;
            if (queue !== null) {
              queue.pending = null;
            }
            hook = hook.next;
          }
          didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        {
          hookTypesDev = null;
          hookTypesUpdateIndexDev = -1;
          currentHookNameInDev = null;
          isUpdatingOpaqueValueInRenderPhase = false;
        }
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
      }
      function mountWorkInProgressHook() {
        var hook = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
        if (workInProgressHook === null) {
          currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        } else {
          workInProgressHook = workInProgressHook.next = hook;
        }
        return workInProgressHook;
      }
      function updateWorkInProgressHook() {
        var nextCurrentHook;
        if (currentHook === null) {
          var current2 = currentlyRenderingFiber$1.alternate;
          if (current2 !== null) {
            nextCurrentHook = current2.memoizedState;
          } else {
            nextCurrentHook = null;
          }
        } else {
          nextCurrentHook = currentHook.next;
        }
        var nextWorkInProgressHook;
        if (workInProgressHook === null) {
          nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        } else {
          nextWorkInProgressHook = workInProgressHook.next;
        }
        if (nextWorkInProgressHook !== null) {
          workInProgressHook = nextWorkInProgressHook;
          nextWorkInProgressHook = workInProgressHook.next;
          currentHook = nextCurrentHook;
        } else {
          if (nextCurrentHook === null) {
            throw new Error("Rendered more hooks than during the previous render.");
          }
          currentHook = nextCurrentHook;
          var newHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
          };
          if (workInProgressHook === null) {
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
          } else {
            workInProgressHook = workInProgressHook.next = newHook;
          }
        }
        return workInProgressHook;
      }
      function createFunctionComponentUpdateQueue() {
        return {
          lastEffect: null,
          stores: null
        };
      }
      function basicStateReducer(state, action) {
        return typeof action === "function" ? action(state) : action;
      }
      function mountReducer(reducer, initialArg, init9) {
        var hook = mountWorkInProgressHook();
        var initialState2;
        if (init9 !== void 0) {
          initialState2 = init9(initialArg);
        } else {
          initialState2 = initialArg;
        }
        hook.memoizedState = hook.baseState = initialState2;
        var queue = {
          pending: null,
          interleaved: null,
          lanes: NoLanes,
          dispatch: null,
          lastRenderedReducer: reducer,
          lastRenderedState: initialState2
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateReducer(reducer, initialArg, init9) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) {
          throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        }
        queue.lastRenderedReducer = reducer;
        var current2 = currentHook;
        var baseQueue = current2.baseQueue;
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
          if (baseQueue !== null) {
            var baseFirst = baseQueue.next;
            var pendingFirst = pendingQueue.next;
            baseQueue.next = pendingFirst;
            pendingQueue.next = baseFirst;
          }
          {
            if (current2.baseQueue !== baseQueue) {
              error2("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            }
          }
          current2.baseQueue = baseQueue = pendingQueue;
          queue.pending = null;
        }
        if (baseQueue !== null) {
          var first = baseQueue.next;
          var newState = current2.baseState;
          var newBaseState = null;
          var newBaseQueueFirst = null;
          var newBaseQueueLast = null;
          var update = first;
          do {
            var updateLane = update.lane;
            if (!isSubsetOfLanes(renderLanes, updateLane)) {
              var clone8 = {
                lane: updateLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              };
              if (newBaseQueueLast === null) {
                newBaseQueueFirst = newBaseQueueLast = clone8;
                newBaseState = newState;
              } else {
                newBaseQueueLast = newBaseQueueLast.next = clone8;
              }
              currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
              markSkippedUpdateLanes(updateLane);
            } else {
              if (newBaseQueueLast !== null) {
                var _clone = {
                  // This update is going to be committed so we never want uncommit
                  // it. Using NoLane works because 0 is a subset of all bitmasks, so
                  // this will never be skipped by the check above.
                  lane: NoLane,
                  action: update.action,
                  hasEagerState: update.hasEagerState,
                  eagerState: update.eagerState,
                  next: null
                };
                newBaseQueueLast = newBaseQueueLast.next = _clone;
              }
              if (update.hasEagerState) {
                newState = update.eagerState;
              } else {
                var action = update.action;
                newState = reducer(newState, action);
              }
            }
            update = update.next;
          } while (update !== null && update !== first);
          if (newBaseQueueLast === null) {
            newBaseState = newState;
          } else {
            newBaseQueueLast.next = newBaseQueueFirst;
          }
          if (!objectIs2(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState;
          hook.baseState = newBaseState;
          hook.baseQueue = newBaseQueueLast;
          queue.lastRenderedState = newState;
        }
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
          var interleaved = lastInterleaved;
          do {
            var interleavedLane = interleaved.lane;
            currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
            markSkippedUpdateLanes(interleavedLane);
            interleaved = interleaved.next;
          } while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) {
          queue.lanes = NoLanes;
        }
        var dispatch = queue.dispatch;
        return [hook.memoizedState, dispatch];
      }
      function rerenderReducer(reducer, initialArg, init9) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) {
          throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        }
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
          queue.pending = null;
          var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
          var update = firstRenderPhaseUpdate;
          do {
            var action = update.action;
            newState = reducer(newState, action);
            update = update.next;
          } while (update !== firstRenderPhaseUpdate);
          if (!objectIs2(newState, hook.memoizedState)) {
            markWorkInProgressReceivedUpdate();
          }
          hook.memoizedState = newState;
          if (hook.baseQueue === null) {
            hook.baseState = newState;
          }
          queue.lastRenderedState = newState;
        }
        return [newState, dispatch];
      }
      function mountMutableSource(source, getSnapshot, subscribe) {
        {
          return void 0;
        }
      }
      function updateMutableSource(source, getSnapshot, subscribe) {
        {
          return void 0;
        }
      }
      function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating2 = getIsHydrating();
        if (isHydrating2) {
          if (getServerSnapshot === void 0) {
            throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
          }
          nextSnapshot = getServerSnapshot();
          {
            if (!didWarnUncachedGetSnapshot) {
              if (nextSnapshot !== getServerSnapshot()) {
                error2("The result of getServerSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
              }
            }
          }
        } else {
          nextSnapshot = getSnapshot();
          {
            if (!didWarnUncachedGetSnapshot) {
              var cachedSnapshot = getSnapshot();
              if (!objectIs2(nextSnapshot, cachedSnapshot)) {
                error2("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
              }
            }
          }
          var root2 = getWorkInProgressRoot();
          if (root2 === null) {
            throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          }
          if (!includesBlockingLane(root2, renderLanes)) {
            pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
          }
        }
        hook.memoizedState = nextSnapshot;
        var inst = {
          value: nextSnapshot,
          getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [subscribe]);
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), void 0, null);
        return nextSnapshot;
      }
      function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook();
        var nextSnapshot = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs2(nextSnapshot, cachedSnapshot)) {
              error2("The result of getSnapshot should be cached to avoid an infinite loop");
              didWarnUncachedGetSnapshot = true;
            }
          }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs2(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
          hook.memoizedState = nextSnapshot;
          markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [subscribe]);
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
          fiber.flags |= Passive;
          pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), void 0, null);
          var root2 = getWorkInProgressRoot();
          if (root2 === null) {
            throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          }
          if (!includesBlockingLane(root2, renderLanes)) {
            pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
          }
        }
        return nextSnapshot;
      }
      function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
          getSnapshot,
          value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.stores = [check];
        } else {
          var stores = componentUpdateQueue.stores;
          if (stores === null) {
            componentUpdateQueue.stores = [check];
          } else {
            stores.push(check);
          }
        }
      }
      function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        if (checkIfSnapshotChanged(inst)) {
          forceStoreRerender(fiber);
        }
      }
      function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
          if (checkIfSnapshotChanged(inst)) {
            forceStoreRerender(fiber);
          }
        };
        return subscribe(handleStoreChange);
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs2(prevValue, nextValue);
        } catch (error3) {
          return true;
        }
      }
      function forceStoreRerender(fiber) {
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
      }
      function mountState(initialState2) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState2 === "function") {
          initialState2 = initialState2();
        }
        hook.memoizedState = hook.baseState = initialState2;
        var queue = {
          pending: null,
          interleaved: null,
          lanes: NoLanes,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialState2
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [hook.memoizedState, dispatch];
      }
      function updateState(initialState2) {
        return updateReducer(basicStateReducer);
      }
      function rerenderState(initialState2) {
        return rerenderReducer(basicStateReducer);
      }
      function pushEffect(tag2, create5, destroy2, deps) {
        var effect = {
          tag: tag2,
          create: create5,
          destroy: destroy2,
          deps,
          // Circular
          next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
          componentUpdateQueue = createFunctionComponentUpdateQueue();
          currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
          componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
          var lastEffect = componentUpdateQueue.lastEffect;
          if (lastEffect === null) {
            componentUpdateQueue.lastEffect = effect.next = effect;
          } else {
            var firstEffect = lastEffect.next;
            lastEffect.next = effect;
            effect.next = firstEffect;
            componentUpdateQueue.lastEffect = effect;
          }
        }
        return effect;
      }
      function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        {
          var _ref2 = {
            current: initialValue
          };
          hook.memoizedState = _ref2;
          return _ref2;
        }
      }
      function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
      }
      function mountEffectImpl(fiberFlags, hookFlags, create5, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create5, void 0, nextDeps);
      }
      function updateEffectImpl(fiberFlags, hookFlags, create5, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;
        var destroy2 = void 0;
        if (currentHook !== null) {
          var prevEffect = currentHook.memoizedState;
          destroy2 = prevEffect.destroy;
          if (nextDeps !== null) {
            var prevDeps = prevEffect.deps;
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              hook.memoizedState = pushEffect(hookFlags, create5, destroy2, nextDeps);
              return;
            }
          }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create5, destroy2, nextDeps);
      }
      function mountEffect(create5, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create5, deps);
        } else {
          return mountEffectImpl(Passive | PassiveStatic, Passive$1, create5, deps);
        }
      }
      function updateEffect(create5, deps) {
        return updateEffectImpl(Passive, Passive$1, create5, deps);
      }
      function mountInsertionEffect(create5, deps) {
        return mountEffectImpl(Update, Insertion, create5, deps);
      }
      function updateInsertionEffect(create5, deps) {
        return updateEffectImpl(Update, Insertion, create5, deps);
      }
      function mountLayoutEffect(create5, deps) {
        var fiberFlags = Update;
        {
          fiberFlags |= LayoutStatic;
        }
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          fiberFlags |= MountLayoutDev;
        }
        return mountEffectImpl(fiberFlags, Layout2, create5, deps);
      }
      function updateLayoutEffect(create5, deps) {
        return updateEffectImpl(Update, Layout2, create5, deps);
      }
      function imperativeHandleEffect(create5, ref) {
        if (typeof ref === "function") {
          var refCallback = ref;
          var _inst = create5();
          refCallback(_inst);
          return function() {
            refCallback(null);
          };
        } else if (ref !== null && ref !== void 0) {
          var refObject = ref;
          {
            if (!refObject.hasOwnProperty("current")) {
              error2("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            }
          }
          var _inst2 = create5();
          refObject.current = _inst2;
          return function() {
            refObject.current = null;
          };
        }
      }
      function mountImperativeHandle(ref, create5, deps) {
        {
          if (typeof create5 !== "function") {
            error2("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create5 !== null ? typeof create5 : "null");
          }
        }
        var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref]) : null;
        var fiberFlags = Update;
        {
          fiberFlags |= LayoutStatic;
        }
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) {
          fiberFlags |= MountLayoutDev;
        }
        return mountEffectImpl(fiberFlags, Layout2, imperativeHandleEffect.bind(null, create5, ref), effectDeps);
      }
      function updateImperativeHandle(ref, create5, deps) {
        {
          if (typeof create5 !== "function") {
            error2("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create5 !== null ? typeof create5 : "null");
          }
        }
        var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref]) : null;
        return updateEffectImpl(Update, Layout2, imperativeHandleEffect.bind(null, create5, ref), effectDeps);
      }
      function mountDebugValue(value, formatterFn) {
      }
      var updateDebugValue = mountDebugValue;
      function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        hook.memoizedState = [callback, nextDeps];
        return callback;
      }
      function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === void 0 ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
          if (nextDeps !== null) {
            var prevDeps = prevState[1];
            if (areHookInputsEqual(nextDeps, prevDeps)) {
              return prevState[0];
            }
          }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [nextValue, nextDeps];
        return nextValue;
      }
      function mountDeferredValue(value) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue2 = _mountState[1];
        mountEffect(function() {
          var prevTransition = ReactCurrentBatchConfig$1.transition;
          ReactCurrentBatchConfig$1.transition = {};
          try {
            setValue2(value);
          } finally {
            ReactCurrentBatchConfig$1.transition = prevTransition;
          }
        }, [value]);
        return prevValue;
      }
      function updateDeferredValue(value) {
        var _updateState = updateState(), prevValue = _updateState[0], setValue2 = _updateState[1];
        updateEffect(function() {
          var prevTransition = ReactCurrentBatchConfig$1.transition;
          ReactCurrentBatchConfig$1.transition = {};
          try {
            setValue2(value);
          } finally {
            ReactCurrentBatchConfig$1.transition = prevTransition;
          }
        }, [value]);
        return prevValue;
      }
      function rerenderDeferredValue(value) {
        var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue2 = _rerenderState[1];
        updateEffect(function() {
          var prevTransition = ReactCurrentBatchConfig$1.transition;
          ReactCurrentBatchConfig$1.transition = {};
          try {
            setValue2(value);
          } finally {
            ReactCurrentBatchConfig$1.transition = prevTransition;
          }
        }, [value]);
        return prevValue;
      }
      function startTransition(setPending, callback, options2) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$1.transition;
        ReactCurrentBatchConfig$1.transition = {};
        var currentTransition = ReactCurrentBatchConfig$1.transition;
        {
          ReactCurrentBatchConfig$1.transition._updatedFibers = /* @__PURE__ */ new Set();
        }
        try {
          setPending(false);
          callback();
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$1.transition = prevTransition;
          {
            if (prevTransition === null && currentTransition._updatedFibers) {
              var updatedFibersCount = currentTransition._updatedFibers.size;
              if (updatedFibersCount > 10) {
                warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
              }
              currentTransition._updatedFibers.clear();
            }
          }
        }
      }
      function mountTransition() {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
        var start2 = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start2;
        return [isPending, start2];
      }
      function updateTransition() {
        var _updateState2 = updateState(), isPending = _updateState2[0];
        var hook = updateWorkInProgressHook();
        var start2 = hook.memoizedState;
        return [isPending, start2];
      }
      function rerenderTransition() {
        var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
        var hook = updateWorkInProgressHook();
        var start2 = hook.memoizedState;
        return [isPending, start2];
      }
      var isUpdatingOpaqueValueInRenderPhase = false;
      function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        {
          return isUpdatingOpaqueValueInRenderPhase;
        }
      }
      function mountId() {
        var hook = mountWorkInProgressHook();
        var root2 = getWorkInProgressRoot();
        var identifierPrefix = root2.identifierPrefix;
        var id;
        if (getIsHydrating()) {
          var treeId = getTreeId();
          id = ":" + identifierPrefix + "R" + treeId;
          var localId = localIdCounter++;
          if (localId > 0) {
            id += "H" + localId.toString(32);
          }
          id += ":";
        } else {
          var globalClientId = globalClientIdCounter++;
          id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
      }
      function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
      }
      function dispatchReducerAction(fiber, queue, action) {
        {
          if (typeof arguments[3] === "function") {
            error2("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
          }
        }
        var lane = requestUpdateLane(fiber);
        var update = {
          lane,
          action,
          hasEagerState: false,
          eagerState: null,
          next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
          enqueueRenderPhaseUpdate(queue, update);
        } else {
          enqueueUpdate$1(fiber, queue, update);
          var eventTime = requestEventTime();
          var root2 = scheduleUpdateOnFiber(fiber, lane, eventTime);
          if (root2 !== null) {
            entangleTransitionUpdate(root2, queue, lane);
          }
        }
        markUpdateInDevTools(fiber, lane);
      }
      function dispatchSetState(fiber, queue, action) {
        {
          if (typeof arguments[3] === "function") {
            error2("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
          }
        }
        var lane = requestUpdateLane(fiber);
        var update = {
          lane,
          action,
          hasEagerState: false,
          eagerState: null,
          next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
          enqueueRenderPhaseUpdate(queue, update);
        } else {
          enqueueUpdate$1(fiber, queue, update);
          var alternate = fiber.alternate;
          if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
            var lastRenderedReducer = queue.lastRenderedReducer;
            if (lastRenderedReducer !== null) {
              var prevDispatcher;
              {
                prevDispatcher = ReactCurrentDispatcher$1.current;
                ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              }
              try {
                var currentState = queue.lastRenderedState;
                var eagerState = lastRenderedReducer(currentState, action);
                update.hasEagerState = true;
                update.eagerState = eagerState;
                if (objectIs2(eagerState, currentState)) {
                  return;
                }
              } catch (error3) {
              } finally {
                {
                  ReactCurrentDispatcher$1.current = prevDispatcher;
                }
              }
            }
          }
          var eventTime = requestEventTime();
          var root2 = scheduleUpdateOnFiber(fiber, lane, eventTime);
          if (root2 !== null) {
            entangleTransitionUpdate(root2, queue, lane);
          }
        }
        markUpdateInDevTools(fiber, lane);
      }
      function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
      }
      function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) {
          update.next = update;
        } else {
          update.next = pending.next;
          pending.next = update;
        }
        queue.pending = update;
      }
      function enqueueUpdate$1(fiber, queue, update, lane) {
        if (isInterleavedUpdate(fiber)) {
          var interleaved = queue.interleaved;
          if (interleaved === null) {
            update.next = update;
            pushInterleavedQueue(queue);
          } else {
            update.next = interleaved.next;
            interleaved.next = update;
          }
          queue.interleaved = update;
        } else {
          var pending = queue.pending;
          if (pending === null) {
            update.next = update;
          } else {
            update.next = pending.next;
            pending.next = update;
          }
          queue.pending = update;
        }
      }
      function entangleTransitionUpdate(root2, queue, lane) {
        if (isTransitionLane(lane)) {
          var queueLanes = queue.lanes;
          queueLanes = intersectLanes(queueLanes, root2.pendingLanes);
          var newQueueLanes = mergeLanes(queueLanes, lane);
          queue.lanes = newQueueLanes;
          markRootEntangled(root2, newQueueLanes);
        }
      }
      function markUpdateInDevTools(fiber, lane, action) {
        {
          markStateUpdateScheduled(fiber, lane);
        }
      }
      var ContextOnlyDispatcher = {
        readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
      };
      var HooksDispatcherOnMountInDEV = null;
      var HooksDispatcherOnMountWithHookTypesInDEV = null;
      var HooksDispatcherOnUpdateInDEV = null;
      var HooksDispatcherOnRerenderInDEV = null;
      var InvalidNestedHooksDispatcherOnMountInDEV = null;
      var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
      var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
      {
        var warnInvalidContextAccess = function() {
          error2("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        };
        var warnInvalidHookAccess = function() {
          error2("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
        HooksDispatcherOnMountInDEV = {
          readContext: function(context2) {
            return readContext(context2);
          },
          useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
          },
          useContext: function(context2) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context2);
          },
          useEffect: function(create5, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create5, deps);
          },
          useImperativeHandle: function(ref, create5, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create5, deps);
          },
          useInsertionEffect: function(create5, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create5, deps);
          },
          useLayoutEffect: function(create5, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create5, deps);
          },
          useMemo: function(create5, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create5, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function(reducer, initialArg, init9) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init9);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function(initialState2) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState2);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnMountWithHookTypesInDEV = {
          readContext: function(context2) {
            return readContext(context2);
          },
          useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function(context2) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context2);
          },
          useEffect: function(create5, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create5, deps);
          },
          useImperativeHandle: function(ref, create5, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create5, deps);
          },
          useInsertionEffect: function(create5, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create5, deps);
          },
          useLayoutEffect: function(create5, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create5, deps);
          },
          useMemo: function(create5, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create5, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function(reducer, initialArg, init9) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init9);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function(initialState2) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState2);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnUpdateInDEV = {
          readContext: function(context2) {
            return readContext(context2);
          },
          useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function(context2) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context2);
          },
          useEffect: function(create5, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create5, deps);
          },
          useImperativeHandle: function(ref, create5, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create5, deps);
          },
          useInsertionEffect: function(create5, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create5, deps);
          },
          useLayoutEffect: function(create5, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create5, deps);
          },
          useMemo: function(create5, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create5, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function(reducer, initialArg, init9) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init9);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
          },
          useState: function(initialState2) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState2);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
          },
          useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
          },
          useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        HooksDispatcherOnRerenderInDEV = {
          readContext: function(context2) {
            return readContext(context2);
          },
          useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function(context2) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context2);
          },
          useEffect: function(create5, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create5, deps);
          },
          useImperativeHandle: function(ref, create5, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create5, deps);
          },
          useInsertionEffect: function(create5, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create5, deps);
          },
          useLayoutEffect: function(create5, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create5, deps);
          },
          useMemo: function(create5, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return updateMemo(create5, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function(reducer, initialArg, init9) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init9);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
          },
          useState: function(initialState2) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
              return rerenderState(initialState2);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
          },
          useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
          },
          useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnMountInDEV = {
          readContext: function(context2) {
            warnInvalidContextAccess();
            return readContext(context2);
          },
          useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
          },
          useContext: function(context2) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context2);
          },
          useEffect: function(create5, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create5, deps);
          },
          useImperativeHandle: function(ref, create5, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create5, deps);
          },
          useInsertionEffect: function(create5, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create5, deps);
          },
          useLayoutEffect: function(create5, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create5, deps);
          },
          useMemo: function(create5, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountMemo(create5, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function(reducer, initialArg, init9) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountReducer(reducer, initialArg, init9);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
          },
          useState: function(initialState2) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
              return mountState(initialState2);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
          },
          useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
          },
          useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
          },
          useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
          },
          useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
          },
          useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnUpdateInDEV = {
          readContext: function(context2) {
            warnInvalidContextAccess();
            return readContext(context2);
          },
          useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function(context2) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context2);
          },
          useEffect: function(create5, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create5, deps);
          },
          useImperativeHandle: function(ref, create5, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create5, deps);
          },
          useInsertionEffect: function(create5, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create5, deps);
          },
          useLayoutEffect: function(create5, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create5, deps);
          },
          useMemo: function(create5, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create5, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function(reducer, initialArg, init9) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateReducer(reducer, initialArg, init9);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function(initialState2) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateState(initialState2);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
          },
          useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
          },
          useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
        InvalidNestedHooksDispatcherOnRerenderInDEV = {
          readContext: function(context2) {
            warnInvalidContextAccess();
            return readContext(context2);
          },
          useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
          },
          useContext: function(context2) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context2);
          },
          useEffect: function(create5, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create5, deps);
          },
          useImperativeHandle: function(ref, create5, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create5, deps);
          },
          useInsertionEffect: function(create5, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create5, deps);
          },
          useLayoutEffect: function(create5, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create5, deps);
          },
          useMemo: function(create5, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return updateMemo(create5, deps);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useReducer: function(reducer, initialArg, init9) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderReducer(reducer, initialArg, init9);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
          },
          useState: function(initialState2) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
              return rerenderState(initialState2);
            } finally {
              ReactCurrentDispatcher$1.current = prevDispatcher;
            }
          },
          useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
          },
          useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
          },
          useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
          },
          useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
          },
          useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
          },
          useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
          },
          unstable_isNewReconciler: enableNewReconciler
        };
      }
      var now$22 = Scheduler2.unstable_now;
      var commitTime = 0;
      var layoutEffectStartTime = -1;
      var profilerStartTime = -1;
      var passiveEffectStartTime = -1;
      var currentUpdateIsNested = false;
      var nestedUpdateScheduled = false;
      function isCurrentUpdateNested() {
        return currentUpdateIsNested;
      }
      function markNestedUpdateScheduled() {
        {
          nestedUpdateScheduled = true;
        }
      }
      function resetNestedUpdateFlag() {
        {
          currentUpdateIsNested = false;
          nestedUpdateScheduled = false;
        }
      }
      function syncNestedUpdateFlag() {
        {
          currentUpdateIsNested = nestedUpdateScheduled;
          nestedUpdateScheduled = false;
        }
      }
      function getCommitTime() {
        return commitTime;
      }
      function recordCommitTime() {
        commitTime = now$22();
      }
      function startProfilerTimer(fiber) {
        profilerStartTime = now$22();
        if (fiber.actualStartTime < 0) {
          fiber.actualStartTime = now$22();
        }
      }
      function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
      }
      function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
          var elapsedTime = now$22() - profilerStartTime;
          fiber.actualDuration += elapsedTime;
          if (overrideBaseTime) {
            fiber.selfBaseDuration = elapsedTime;
          }
          profilerStartTime = -1;
        }
      }
      function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
          var elapsedTime = now$22() - layoutEffectStartTime;
          layoutEffectStartTime = -1;
          var parentFiber = fiber.return;
          while (parentFiber !== null) {
            switch (parentFiber.tag) {
              case HostRoot:
                var root2 = parentFiber.stateNode;
                root2.effectDuration += elapsedTime;
                return;
              case Profiler:
                var parentStateNode = parentFiber.stateNode;
                parentStateNode.effectDuration += elapsedTime;
                return;
            }
            parentFiber = parentFiber.return;
          }
        }
      }
      function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
          var elapsedTime = now$22() - passiveEffectStartTime;
          passiveEffectStartTime = -1;
          var parentFiber = fiber.return;
          while (parentFiber !== null) {
            switch (parentFiber.tag) {
              case HostRoot:
                var root2 = parentFiber.stateNode;
                if (root2 !== null) {
                  root2.passiveEffectDuration += elapsedTime;
                }
                return;
              case Profiler:
                var parentStateNode = parentFiber.stateNode;
                if (parentStateNode !== null) {
                  parentStateNode.passiveEffectDuration += elapsedTime;
                }
                return;
            }
            parentFiber = parentFiber.return;
          }
        }
      }
      function startLayoutEffectTimer() {
        layoutEffectStartTime = now$22();
      }
      function startPassiveEffectTimer() {
        passiveEffectStartTime = now$22();
      }
      function transferActualDuration(fiber) {
        var child = fiber.child;
        while (child) {
          fiber.actualDuration += child.actualDuration;
          child = child.sibling;
        }
      }
      function createCapturedValue(value, source) {
        return {
          value,
          source,
          stack: getStackByFiberInDevAndProd(source)
        };
      }
      function showErrorDialog(boundary, errorInfo) {
        return true;
      }
      function logCapturedError(boundary, errorInfo) {
        try {
          var logError = showErrorDialog(boundary, errorInfo);
          if (logError === false) {
            return;
          }
          var error3 = errorInfo.value;
          if (true) {
            var source = errorInfo.source;
            var stack2 = errorInfo.stack;
            var componentStack = stack2 !== null ? stack2 : "";
            if (error3 != null && error3._suppressLogging) {
              if (boundary.tag === ClassComponent) {
                return;
              }
              console["error"](error3);
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) {
              errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            } else {
              var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
              errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage);
            console["error"](combinedMessage);
          }
        } catch (e3) {
          setTimeout(function() {
            throw e3;
          });
        }
      }
      var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
      function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        update.payload = {
          element: null
        };
        var error3 = errorInfo.value;
        update.callback = function() {
          onUncaughtError(error3);
          logCapturedError(fiber, errorInfo);
        };
        return update;
      }
      function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
          var error$1 = errorInfo.value;
          update.payload = function() {
            return getDerivedStateFromError(error$1);
          };
          update.callback = function() {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            logCapturedError(fiber, errorInfo);
          };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") {
          update.callback = function callback() {
            {
              markFailedErrorBoundaryForHotReloading(fiber);
            }
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") {
              markLegacyErrorBoundaryAsFailed(this);
            }
            var error$12 = errorInfo.value;
            var stack2 = errorInfo.stack;
            this.componentDidCatch(error$12, {
              componentStack: stack2 !== null ? stack2 : ""
            });
            {
              if (typeof getDerivedStateFromError !== "function") {
                if (!includesSomeLane(fiber.lanes, SyncLane)) {
                  error2("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
                }
              }
            }
          };
        }
        return update;
      }
      function attachPingListener(root2, wakeable, lanes) {
        var pingCache = root2.pingCache;
        var threadIDs;
        if (pingCache === null) {
          pingCache = root2.pingCache = new PossiblyWeakMap$1();
          threadIDs = /* @__PURE__ */ new Set();
          pingCache.set(wakeable, threadIDs);
        } else {
          threadIDs = pingCache.get(wakeable);
          if (threadIDs === void 0) {
            threadIDs = /* @__PURE__ */ new Set();
            pingCache.set(wakeable, threadIDs);
          }
        }
        if (!threadIDs.has(lanes)) {
          threadIDs.add(lanes);
          var ping = pingSuspendedRoot.bind(null, root2, wakeable, lanes);
          {
            if (isDevToolsPresent) {
              restorePendingUpdaters(root2, lanes);
            }
          }
          wakeable.then(ping, ping);
        }
      }
      function attachRetryListener(suspenseBoundary, root2, wakeable, lanes) {
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
          var updateQueue = /* @__PURE__ */ new Set();
          updateQueue.add(wakeable);
          suspenseBoundary.updateQueue = updateQueue;
        } else {
          wakeables.add(wakeable);
        }
      }
      function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        var tag2 = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag2 === FunctionComponent || tag2 === ForwardRef || tag2 === SimpleMemoComponent)) {
          var currentSource = sourceFiber.alternate;
          if (currentSource) {
            sourceFiber.updateQueue = currentSource.updateQueue;
            sourceFiber.memoizedState = currentSource.memoizedState;
            sourceFiber.lanes = currentSource.lanes;
          } else {
            sourceFiber.updateQueue = null;
            sourceFiber.memoizedState = null;
          }
        }
      }
      function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
          if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) {
            return node;
          }
          node = node.return;
        } while (node !== null);
        return null;
      }
      function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root2, rootRenderLanes) {
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
          if (suspenseBoundary === returnFiber) {
            suspenseBoundary.flags |= ShouldCapture;
          } else {
            suspenseBoundary.flags |= DidCapture;
            sourceFiber.flags |= ForceUpdateForLegacySuspense;
            sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
            if (supportsPersistence && enablePersistentOffscreenHostContainer) {
              var currentSuspenseBoundary = suspenseBoundary.alternate;
              if (currentSuspenseBoundary === null) {
                var offscreenFiber = suspenseBoundary.child;
                var offscreenContainer = offscreenFiber.child;
                if (offscreenContainer !== null) {
                  var children = offscreenContainer.memoizedProps.children;
                  var containerProps = getOffscreenContainerProps("hidden", children);
                  offscreenContainer.pendingProps = containerProps;
                  offscreenContainer.memoizedProps = containerProps;
                }
              }
            }
            if (sourceFiber.tag === ClassComponent) {
              var currentSourceFiber = sourceFiber.alternate;
              if (currentSourceFiber === null) {
                sourceFiber.tag = IncompleteClassComponent;
              } else {
                var update = createUpdate(NoTimestamp, SyncLane);
                update.tag = ForceUpdate;
                enqueueUpdate(sourceFiber, update);
              }
            }
            sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
          }
          return suspenseBoundary;
        }
        suspenseBoundary.flags |= ShouldCapture;
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
      }
      function throwException(root2, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= Incomplete;
        {
          if (isDevToolsPresent) {
            restorePendingUpdaters(root2, rootRenderLanes);
          }
        }
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
          var wakeable = value;
          resetSuspendedComponent(sourceFiber);
          var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
          if (suspenseBoundary !== null) {
            suspenseBoundary.flags &= ~ForceClientRender;
            markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root2, rootRenderLanes);
            if (suspenseBoundary.mode & ConcurrentMode) {
              attachPingListener(root2, wakeable, rootRenderLanes);
            }
            attachRetryListener(suspenseBoundary, root2, wakeable);
            return;
          } else {
            if (!includesSyncLane(rootRenderLanes)) {
              attachPingListener(root2, wakeable, rootRenderLanes);
              renderDidSuspendDelayIfPossible();
              return;
            }
            var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
            value = uncaughtSuspenseError;
          }
        } else {
          if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidSuspendWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (_suspenseBoundary !== null) {
              if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) {
                _suspenseBoundary.flags |= ForceClientRender;
              }
              markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root2, rootRenderLanes);
              queueHydrationError(value);
              return;
            }
          }
        }
        renderDidError(value);
        value = createCapturedValue(value, sourceFiber);
        var workInProgress2 = returnFiber;
        do {
          switch (workInProgress2.tag) {
            case HostRoot: {
              var _errorInfo = value;
              workInProgress2.flags |= ShouldCapture;
              var lane = pickArbitraryLane(rootRenderLanes);
              workInProgress2.lanes = mergeLanes(workInProgress2.lanes, lane);
              var update = createRootErrorUpdate(workInProgress2, _errorInfo, lane);
              enqueueCapturedUpdate(workInProgress2, update);
              return;
            }
            case ClassComponent:
              var errorInfo = value;
              var ctor = workInProgress2.type;
              var instance2 = workInProgress2.stateNode;
              if ((workInProgress2.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance2 !== null && typeof instance2.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance2))) {
                workInProgress2.flags |= ShouldCapture;
                var _lane = pickArbitraryLane(rootRenderLanes);
                workInProgress2.lanes = mergeLanes(workInProgress2.lanes, _lane);
                var _update = createClassErrorUpdate(workInProgress2, errorInfo, _lane);
                enqueueCapturedUpdate(workInProgress2, _update);
                return;
              }
              break;
          }
          workInProgress2 = workInProgress2.return;
        } while (workInProgress2 !== null);
      }
      function getSuspendedCache() {
        {
          return null;
        }
      }
      function markUpdate(workInProgress2) {
        workInProgress2.flags |= Update;
      }
      function markRef(workInProgress2) {
        workInProgress2.flags |= Ref;
        {
          workInProgress2.flags |= RefStatic;
        }
      }
      function hadNoMutationsEffects(current2, completedWork) {
        var didBailout = current2 !== null && current2.child === completedWork.child;
        if (didBailout) {
          return true;
        }
        if ((completedWork.flags & ChildDeletion) !== NoFlags) {
          return false;
        }
        var child = completedWork.child;
        while (child !== null) {
          if ((child.flags & MutationMask) !== NoFlags || (child.subtreeFlags & MutationMask) !== NoFlags) {
            return false;
          }
          child = child.sibling;
        }
        return true;
      }
      var appendAllChildren;
      var updateHostContainer;
      var updateHostComponent;
      var updateHostText;
      if (supportsMutation) {
        appendAllChildren = function(parent, workInProgress2, needsVisibilityToggle, isHidden2) {
          var node = workInProgress2.child;
          while (node !== null) {
            if (node.tag === HostComponent || node.tag === HostText) {
              appendInitialChild(parent, node.stateNode);
            } else if (node.tag === HostPortal)
              ;
            else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === workInProgress2) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress2) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        };
        updateHostContainer = function(current2, workInProgress2) {
        };
        updateHostComponent = function(current2, workInProgress2, type, newProps, rootContainerInstance) {
          var oldProps = current2.memoizedProps;
          if (oldProps === newProps) {
            return;
          }
          var instance2 = workInProgress2.stateNode;
          var currentHostContext = getHostContext();
          var updatePayload = prepareUpdate(instance2, type, oldProps, newProps, rootContainerInstance, currentHostContext);
          workInProgress2.updateQueue = updatePayload;
          if (updatePayload) {
            markUpdate(workInProgress2);
          }
        };
        updateHostText = function(current2, workInProgress2, oldText, newText) {
          if (oldText !== newText) {
            markUpdate(workInProgress2);
          }
        };
      } else if (supportsPersistence) {
        appendAllChildren = function(parent, workInProgress2, needsVisibilityToggle, isHidden2) {
          var node = workInProgress2.child;
          while (node !== null) {
            if (node.tag === HostComponent) {
              var instance2 = node.stateNode;
              if (needsVisibilityToggle && isHidden2) {
                var props = node.memoizedProps;
                var type = node.type;
                instance2 = cloneHiddenInstance(instance2, type, props, node);
              }
              appendInitialChild(parent, instance2);
            } else if (node.tag === HostText) {
              var _instance = node.stateNode;
              if (needsVisibilityToggle && isHidden2) {
                var text = node.memoizedProps;
                _instance = cloneHiddenTextInstance(_instance, text, node);
              }
              appendInitialChild(parent, _instance);
            } else if (node.tag === HostPortal)
              ;
            else if (node.tag === OffscreenComponent && node.memoizedState !== null) {
              var child = node.child;
              if (child !== null) {
                child.return = node;
              }
              {
                appendAllChildren(parent, node, true, true);
              }
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            node = node;
            if (node === workInProgress2) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress2) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        };
        var appendAllChildrenToContainer = function(containerChildSet, workInProgress2, needsVisibilityToggle, isHidden2) {
          var node = workInProgress2.child;
          while (node !== null) {
            if (node.tag === HostComponent) {
              var instance2 = node.stateNode;
              if (needsVisibilityToggle && isHidden2) {
                var props = node.memoizedProps;
                var type = node.type;
                instance2 = cloneHiddenInstance(instance2, type, props, node);
              }
              appendChildToContainerChildSet(containerChildSet, instance2);
            } else if (node.tag === HostText) {
              var _instance2 = node.stateNode;
              if (needsVisibilityToggle && isHidden2) {
                var text = node.memoizedProps;
                _instance2 = cloneHiddenTextInstance(_instance2, text, node);
              }
              appendChildToContainerChildSet(containerChildSet, _instance2);
            } else if (node.tag === HostPortal)
              ;
            else if (node.tag === OffscreenComponent && node.memoizedState !== null) {
              var child = node.child;
              if (child !== null) {
                child.return = node;
              }
              {
                appendAllChildrenToContainer(containerChildSet, node, true, true);
              }
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            node = node;
            if (node === workInProgress2) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === workInProgress2) {
                return;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        };
        updateHostContainer = function(current2, workInProgress2) {
          var portalOrRoot = workInProgress2.stateNode;
          var childrenUnchanged = hadNoMutationsEffects(current2, workInProgress2);
          if (childrenUnchanged)
            ;
          else {
            var container = portalOrRoot.containerInfo;
            var newChildSet = createContainerChildSet(container);
            appendAllChildrenToContainer(newChildSet, workInProgress2, false, false);
            portalOrRoot.pendingChildren = newChildSet;
            markUpdate(workInProgress2);
            finalizeContainerChildren(container, newChildSet);
          }
        };
        updateHostComponent = function(current2, workInProgress2, type, newProps, rootContainerInstance) {
          var currentInstance = current2.stateNode;
          var oldProps = current2.memoizedProps;
          var childrenUnchanged = hadNoMutationsEffects(current2, workInProgress2);
          if (childrenUnchanged && oldProps === newProps) {
            workInProgress2.stateNode = currentInstance;
            return;
          }
          var recyclableInstance = workInProgress2.stateNode;
          var currentHostContext = getHostContext();
          var updatePayload = null;
          if (oldProps !== newProps) {
            updatePayload = prepareUpdate(recyclableInstance, type, oldProps, newProps, rootContainerInstance, currentHostContext);
          }
          if (childrenUnchanged && updatePayload === null) {
            workInProgress2.stateNode = currentInstance;
            return;
          }
          var newInstance = cloneInstance(currentInstance, updatePayload, type, oldProps, newProps, workInProgress2, childrenUnchanged, recyclableInstance);
          if (finalizeInitialChildren(newInstance, type, newProps, rootContainerInstance, currentHostContext)) {
            markUpdate(workInProgress2);
          }
          workInProgress2.stateNode = newInstance;
          if (childrenUnchanged) {
            markUpdate(workInProgress2);
          } else {
            appendAllChildren(newInstance, workInProgress2, false, false);
          }
        };
        updateHostText = function(current2, workInProgress2, oldText, newText) {
          if (oldText !== newText) {
            var rootContainerInstance = getRootHostContainer();
            var currentHostContext = getHostContext();
            workInProgress2.stateNode = createTextInstance(newText, rootContainerInstance, currentHostContext, workInProgress2);
            markUpdate(workInProgress2);
          } else {
            workInProgress2.stateNode = current2.stateNode;
          }
        };
      } else {
        updateHostContainer = function(current2, workInProgress2) {
        };
        updateHostComponent = function(current2, workInProgress2, type, newProps, rootContainerInstance) {
        };
        updateHostText = function(current2, workInProgress2, oldText, newText) {
        };
      }
      function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) {
          return;
        }
        switch (renderState.tailMode) {
          case "hidden": {
            var tailNode = renderState.tail;
            var lastTailNode = null;
            while (tailNode !== null) {
              if (tailNode.alternate !== null) {
                lastTailNode = tailNode;
              }
              tailNode = tailNode.sibling;
            }
            if (lastTailNode === null) {
              renderState.tail = null;
            } else {
              lastTailNode.sibling = null;
            }
            break;
          }
          case "collapsed": {
            var _tailNode = renderState.tail;
            var _lastTailNode = null;
            while (_tailNode !== null) {
              if (_tailNode.alternate !== null) {
                _lastTailNode = _tailNode;
              }
              _tailNode = _tailNode.sibling;
            }
            if (_lastTailNode === null) {
              if (!hasRenderedATailFallback && renderState.tail !== null) {
                renderState.tail.sibling = null;
              } else {
                renderState.tail = null;
              }
            } else {
              _lastTailNode.sibling = null;
            }
            break;
          }
        }
      }
      function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration;
            var child = completedWork.child;
            while (child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
              subtreeFlags |= child.subtreeFlags;
              subtreeFlags |= child.flags;
              actualDuration += child.actualDuration;
              treeBaseDuration += child.treeBaseDuration;
              child = child.sibling;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
          } else {
            var _child = completedWork.child;
            while (_child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
              subtreeFlags |= _child.subtreeFlags;
              subtreeFlags |= _child.flags;
              _child.return = completedWork;
              _child = _child.sibling;
            }
          }
          completedWork.subtreeFlags |= subtreeFlags;
        } else {
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var _treeBaseDuration = completedWork.selfBaseDuration;
            var _child2 = completedWork.child;
            while (_child2 !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes));
              subtreeFlags |= _child2.subtreeFlags & StaticMask;
              subtreeFlags |= _child2.flags & StaticMask;
              _treeBaseDuration += _child2.treeBaseDuration;
              _child2 = _child2.sibling;
            }
            completedWork.treeBaseDuration = _treeBaseDuration;
          } else {
            var _child3 = completedWork.child;
            while (_child3 !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes));
              subtreeFlags |= _child3.subtreeFlags & StaticMask;
              subtreeFlags |= _child3.flags & StaticMask;
              _child3.return = completedWork;
              _child3 = _child3.sibling;
            }
          }
          completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
      }
      function completeWork(current2, workInProgress2, renderLanes2) {
        var newProps = workInProgress2.pendingProps;
        popTreeContext(workInProgress2);
        switch (workInProgress2.tag) {
          case IndeterminateComponent:
          case LazyComponent:
          case SimpleMemoComponent:
          case FunctionComponent:
          case ForwardRef:
          case Fragment2:
          case Mode:
          case Profiler:
          case ContextConsumer:
          case MemoComponent:
            bubbleProperties(workInProgress2);
            return null;
          case ClassComponent: {
            var Component2 = workInProgress2.type;
            if (isContextProvider(Component2)) {
              popContext(workInProgress2);
            }
            bubbleProperties(workInProgress2);
            return null;
          }
          case HostRoot: {
            var fiberRoot = workInProgress2.stateNode;
            popHostContainer(workInProgress2);
            popTopLevelContextObject(workInProgress2);
            resetWorkInProgressVersions();
            if (fiberRoot.pendingContext) {
              fiberRoot.context = fiberRoot.pendingContext;
              fiberRoot.pendingContext = null;
            }
            if (current2 === null || current2.child === null) {
              var wasHydrated = popHydrationState(workInProgress2);
              if (wasHydrated) {
                markUpdate(workInProgress2);
              } else {
                if (current2 !== null) {
                  var prevState = current2.memoizedState;
                  if (
                    // Check if this is a client root
                    !prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                    (workInProgress2.flags & ForceClientRender) !== NoFlags
                  ) {
                    workInProgress2.flags |= Snapshot;
                    upgradeHydrationErrorsToRecoverable();
                  }
                }
              }
            }
            updateHostContainer(current2, workInProgress2);
            bubbleProperties(workInProgress2);
            return null;
          }
          case HostComponent: {
            popHostContext(workInProgress2);
            var rootContainerInstance = getRootHostContainer();
            var type = workInProgress2.type;
            if (current2 !== null && workInProgress2.stateNode != null) {
              updateHostComponent(current2, workInProgress2, type, newProps, rootContainerInstance);
              if (current2.ref !== workInProgress2.ref) {
                markRef(workInProgress2);
              }
            } else {
              if (!newProps) {
                if (workInProgress2.stateNode === null) {
                  throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                }
                bubbleProperties(workInProgress2);
                return null;
              }
              var currentHostContext = getHostContext();
              var _wasHydrated = popHydrationState(workInProgress2);
              if (_wasHydrated) {
                if (prepareToHydrateHostInstance(workInProgress2, rootContainerInstance, currentHostContext)) {
                  markUpdate(workInProgress2);
                }
              } else {
                var instance2 = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress2);
                appendAllChildren(instance2, workInProgress2, false, false);
                workInProgress2.stateNode = instance2;
                if (finalizeInitialChildren(instance2, type, newProps, rootContainerInstance, currentHostContext)) {
                  markUpdate(workInProgress2);
                }
              }
              if (workInProgress2.ref !== null) {
                markRef(workInProgress2);
              }
            }
            bubbleProperties(workInProgress2);
            return null;
          }
          case HostText: {
            var newText = newProps;
            if (current2 && workInProgress2.stateNode != null) {
              var oldText = current2.memoizedProps;
              updateHostText(current2, workInProgress2, oldText, newText);
            } else {
              if (typeof newText !== "string") {
                if (workInProgress2.stateNode === null) {
                  throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var _rootContainerInstance = getRootHostContainer();
              var _currentHostContext = getHostContext();
              var _wasHydrated2 = popHydrationState(workInProgress2);
              if (_wasHydrated2) {
                if (prepareToHydrateHostTextInstance(workInProgress2)) {
                  markUpdate(workInProgress2);
                }
              } else {
                workInProgress2.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress2);
              }
            }
            bubbleProperties(workInProgress2);
            return null;
          }
          case SuspenseComponent: {
            popSuspenseContext(workInProgress2);
            var nextState = workInProgress2.memoizedState;
            {
              if (hasUnhydratedTailNodes() && (workInProgress2.mode & ConcurrentMode) !== NoMode && (workInProgress2.flags & DidCapture) === NoFlags) {
                warnIfUnhydratedTailNodes(workInProgress2);
                resetHydrationState();
                workInProgress2.flags |= ForceClientRender | Incomplete | ShouldCapture;
                return workInProgress2;
              }
              if (nextState !== null && nextState.dehydrated !== null) {
                var _wasHydrated3 = popHydrationState(workInProgress2);
                if (current2 === null) {
                  if (!_wasHydrated3) {
                    throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                  }
                  prepareToHydrateHostSuspenseInstance(workInProgress2);
                  bubbleProperties(workInProgress2);
                  {
                    if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                      var isTimedOutSuspense = nextState !== null;
                      if (isTimedOutSuspense) {
                        var primaryChildFragment = workInProgress2.child;
                        if (primaryChildFragment !== null) {
                          workInProgress2.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                        }
                      }
                    }
                  }
                  return null;
                } else {
                  resetHydrationState();
                  if ((workInProgress2.flags & DidCapture) === NoFlags) {
                    workInProgress2.memoizedState = null;
                  }
                  workInProgress2.flags |= Update;
                  bubbleProperties(workInProgress2);
                  {
                    if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                      var _isTimedOutSuspense = nextState !== null;
                      if (_isTimedOutSuspense) {
                        var _primaryChildFragment = workInProgress2.child;
                        if (_primaryChildFragment !== null) {
                          workInProgress2.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                        }
                      }
                    }
                  }
                  return null;
                }
              }
              upgradeHydrationErrorsToRecoverable();
            }
            if ((workInProgress2.flags & DidCapture) !== NoFlags) {
              workInProgress2.lanes = renderLanes2;
              if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                transferActualDuration(workInProgress2);
              }
              return workInProgress2;
            }
            var nextDidTimeout = nextState !== null;
            var prevDidTimeout = false;
            if (current2 === null) {
              popHydrationState(workInProgress2);
            } else {
              var _prevState = current2.memoizedState;
              prevDidTimeout = _prevState !== null;
            }
            if (nextDidTimeout && !prevDidTimeout) {
              var _offscreenFiber = workInProgress2.child;
              _offscreenFiber.flags |= Visibility;
              if ((workInProgress2.mode & ConcurrentMode) !== NoMode) {
                var hasInvisibleChildContext = current2 === null && (workInProgress2.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                  renderDidSuspend();
                } else {
                  renderDidSuspendDelayIfPossible();
                }
              }
            }
            var wakeables = workInProgress2.updateQueue;
            if (wakeables !== null) {
              workInProgress2.flags |= Update;
            }
            bubbleProperties(workInProgress2);
            {
              if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                if (nextDidTimeout) {
                  var _primaryChildFragment2 = workInProgress2.child;
                  if (_primaryChildFragment2 !== null) {
                    workInProgress2.treeBaseDuration -= _primaryChildFragment2.treeBaseDuration;
                  }
                }
              }
            }
            return null;
          }
          case HostPortal:
            popHostContainer(workInProgress2);
            updateHostContainer(current2, workInProgress2);
            if (current2 === null) {
              preparePortalMount(workInProgress2.stateNode.containerInfo);
            }
            bubbleProperties(workInProgress2);
            return null;
          case ContextProvider:
            var context2 = workInProgress2.type._context;
            popProvider(context2, workInProgress2);
            bubbleProperties(workInProgress2);
            return null;
          case IncompleteClassComponent: {
            var _Component2 = workInProgress2.type;
            if (isContextProvider(_Component2)) {
              popContext(workInProgress2);
            }
            bubbleProperties(workInProgress2);
            return null;
          }
          case SuspenseListComponent: {
            popSuspenseContext(workInProgress2);
            var renderState = workInProgress2.memoizedState;
            if (renderState === null) {
              bubbleProperties(workInProgress2);
              return null;
            }
            var didSuspendAlready = (workInProgress2.flags & DidCapture) !== NoFlags;
            var renderedTail = renderState.rendering;
            if (renderedTail === null) {
              if (!didSuspendAlready) {
                var cannotBeSuspended = renderHasNotSuspendedYet() && (current2 === null || (current2.flags & DidCapture) === NoFlags);
                if (!cannotBeSuspended) {
                  var row = workInProgress2.child;
                  while (row !== null) {
                    var suspended = findFirstSuspended(row);
                    if (suspended !== null) {
                      didSuspendAlready = true;
                      workInProgress2.flags |= DidCapture;
                      cutOffTailIfNeeded(renderState, false);
                      var newThenables = suspended.updateQueue;
                      if (newThenables !== null) {
                        workInProgress2.updateQueue = newThenables;
                        workInProgress2.flags |= Update;
                      }
                      workInProgress2.subtreeFlags = NoFlags;
                      resetChildFibers(workInProgress2, renderLanes2);
                      pushSuspenseContext(workInProgress2, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                      return workInProgress2.child;
                    }
                    row = row.sibling;
                  }
                }
                if (renderState.tail !== null && now$12() > getRenderTargetTime()) {
                  workInProgress2.flags |= DidCapture;
                  didSuspendAlready = true;
                  cutOffTailIfNeeded(renderState, false);
                  workInProgress2.lanes = SomeRetryLane;
                }
              } else {
                cutOffTailIfNeeded(renderState, false);
              }
            } else {
              if (!didSuspendAlready) {
                var _suspended = findFirstSuspended(renderedTail);
                if (_suspended !== null) {
                  workInProgress2.flags |= DidCapture;
                  didSuspendAlready = true;
                  var _newThenables = _suspended.updateQueue;
                  if (_newThenables !== null) {
                    workInProgress2.updateQueue = _newThenables;
                    workInProgress2.flags |= Update;
                  }
                  cutOffTailIfNeeded(renderState, true);
                  if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating()) {
                    bubbleProperties(workInProgress2);
                    return null;
                  }
                } else if (
                  // The time it took to render last row is greater than the remaining
                  // time we have to render. So rendering one more row would likely
                  // exceed it.
                  now$12() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes2 !== OffscreenLane
                ) {
                  workInProgress2.flags |= DidCapture;
                  didSuspendAlready = true;
                  cutOffTailIfNeeded(renderState, false);
                  workInProgress2.lanes = SomeRetryLane;
                }
              }
              if (renderState.isBackwards) {
                renderedTail.sibling = workInProgress2.child;
                workInProgress2.child = renderedTail;
              } else {
                var previousSibling = renderState.last;
                if (previousSibling !== null) {
                  previousSibling.sibling = renderedTail;
                } else {
                  workInProgress2.child = renderedTail;
                }
                renderState.last = renderedTail;
              }
            }
            if (renderState.tail !== null) {
              var next5 = renderState.tail;
              renderState.rendering = next5;
              renderState.tail = next5.sibling;
              renderState.renderingStartTime = now$12();
              next5.sibling = null;
              var suspenseContext = suspenseStackCursor.current;
              if (didSuspendAlready) {
                suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
              } else {
                suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
              }
              pushSuspenseContext(workInProgress2, suspenseContext);
              return next5;
            }
            bubbleProperties(workInProgress2);
            return null;
          }
          case ScopeComponent: {
            break;
          }
          case OffscreenComponent:
          case LegacyHiddenComponent: {
            popRenderLanes(workInProgress2);
            var _nextState = workInProgress2.memoizedState;
            var nextIsHidden = _nextState !== null;
            if (current2 !== null) {
              var _prevState2 = current2.memoizedState;
              var prevIsHidden = _prevState2 !== null;
              if (prevIsHidden !== nextIsHidden && // LegacyHidden doesn't do any hiding — it only pre-renders.
              !enableLegacyHidden) {
                workInProgress2.flags |= Visibility;
              }
            }
            if (!nextIsHidden || (workInProgress2.mode & ConcurrentMode) === NoMode) {
              bubbleProperties(workInProgress2);
            } else {
              if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                bubbleProperties(workInProgress2);
                if (supportsMutation) {
                  if (workInProgress2.subtreeFlags & (Placement | Update)) {
                    workInProgress2.flags |= Visibility;
                  }
                }
              }
            }
            return null;
          }
          case CacheComponent: {
            return null;
          }
          case TracingMarkerComponent: {
            return null;
          }
        }
        throw new Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var didReceiveUpdate = false;
      var didWarnAboutBadClass;
      var didWarnAboutModulePatternComponent;
      var didWarnAboutContextTypeOnFunctionComponent;
      var didWarnAboutGetDerivedStateOnFunctionComponent;
      var didWarnAboutFunctionRefs;
      var didWarnAboutReassigningProps;
      var didWarnAboutRevealOrder;
      var didWarnAboutTailOptions;
      {
        didWarnAboutBadClass = {};
        didWarnAboutModulePatternComponent = {};
        didWarnAboutContextTypeOnFunctionComponent = {};
        didWarnAboutGetDerivedStateOnFunctionComponent = {};
        didWarnAboutFunctionRefs = {};
        didWarnAboutReassigningProps = false;
        didWarnAboutRevealOrder = {};
        didWarnAboutTailOptions = {};
      }
      function reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2) {
        if (current2 === null) {
          workInProgress2.child = mountChildFibers(workInProgress2, null, nextChildren, renderLanes2);
        } else {
          workInProgress2.child = reconcileChildFibers(workInProgress2, current2.child, nextChildren, renderLanes2);
        }
      }
      function forceUnmountCurrentAndReconcile(current2, workInProgress2, nextChildren, renderLanes2) {
        workInProgress2.child = reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
        workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderLanes2);
      }
      function updateForwardRef(current2, workInProgress2, Component2, nextProps, renderLanes2) {
        {
          if (workInProgress2.type !== workInProgress2.elementType) {
            var innerPropTypes = Component2.propTypes;
            if (innerPropTypes) {
              checkPropTypes(
                innerPropTypes,
                nextProps,
                // Resolved props
                "prop",
                getComponentNameFromType(Component2)
              );
            }
          }
        }
        var render5 = Component2.render;
        var ref = workInProgress2.ref;
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress2, renderLanes2);
        {
          markComponentRenderStarted(workInProgress2);
        }
        {
          ReactCurrentOwner$1.current = workInProgress2;
          setIsRendering(true);
          nextChildren = renderWithHooks(current2, workInProgress2, render5, nextProps, ref, renderLanes2);
          hasId = checkDidRenderIdHook();
          if (workInProgress2.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
              nextChildren = renderWithHooks(current2, workInProgress2, render5, nextProps, ref, renderLanes2);
              hasId = checkDidRenderIdHook();
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        if (current2 !== null && !didReceiveUpdate) {
          bailoutHooks(current2, workInProgress2, renderLanes2);
          return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
        }
        if (getIsHydrating() && hasId) {
          pushMaterializedTreeId(workInProgress2);
        }
        workInProgress2.flags |= PerformedWork;
        reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        return workInProgress2.child;
      }
      function updateMemoComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
        if (current2 === null) {
          var type = Component2.type;
          if (isSimpleFunctionComponent(type) && Component2.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
          Component2.defaultProps === void 0) {
            var resolvedType = type;
            {
              resolvedType = resolveFunctionForHotReloading(type);
            }
            workInProgress2.tag = SimpleMemoComponent;
            workInProgress2.type = resolvedType;
            {
              validateFunctionComponentInDev(workInProgress2, type);
            }
            return updateSimpleMemoComponent(current2, workInProgress2, resolvedType, nextProps, renderLanes2);
          }
          {
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) {
              checkPropTypes(
                innerPropTypes,
                nextProps,
                // Resolved props
                "prop",
                getComponentNameFromType(type)
              );
            }
          }
          var child = createFiberFromTypeAndProps(Component2.type, null, nextProps, workInProgress2, workInProgress2.mode, renderLanes2);
          child.ref = workInProgress2.ref;
          child.return = workInProgress2;
          workInProgress2.child = child;
          return child;
        }
        {
          var _type = Component2.type;
          var _innerPropTypes = _type.propTypes;
          if (_innerPropTypes) {
            checkPropTypes(
              _innerPropTypes,
              nextProps,
              // Resolved props
              "prop",
              getComponentNameFromType(_type)
            );
          }
        }
        var currentChild = current2.child;
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current2, renderLanes2);
        if (!hasScheduledUpdateOrContext) {
          var prevProps = currentChild.memoizedProps;
          var compare12 = Component2.compare;
          compare12 = compare12 !== null ? compare12 : shallowEqual;
          if (compare12(prevProps, nextProps) && current2.ref === workInProgress2.ref) {
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
        }
        workInProgress2.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress2.ref;
        newChild.return = workInProgress2;
        workInProgress2.child = newChild;
        return newChild;
      }
      function updateSimpleMemoComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
        {
          if (workInProgress2.type !== workInProgress2.elementType) {
            var outerMemoType = workInProgress2.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
              var lazyComponent = outerMemoType;
              var payload = lazyComponent._payload;
              var init9 = lazyComponent._init;
              try {
                outerMemoType = init9(payload);
              } catch (x2) {
                outerMemoType = null;
              }
              var outerPropTypes = outerMemoType && outerMemoType.propTypes;
              if (outerPropTypes) {
                checkPropTypes(
                  outerPropTypes,
                  nextProps,
                  // Resolved (SimpleMemoComponent has no defaultProps)
                  "prop",
                  getComponentNameFromType(outerMemoType)
                );
              }
            }
          }
        }
        if (current2 !== null) {
          var prevProps = current2.memoizedProps;
          if (shallowEqual(prevProps, nextProps) && current2.ref === workInProgress2.ref && // Prevent bailout if the implementation changed due to hot reload.
          workInProgress2.type === current2.type) {
            didReceiveUpdate = false;
            if (!checkScheduledUpdateOrContext(current2, renderLanes2)) {
              workInProgress2.lanes = current2.lanes;
              return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
            } else if ((current2.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
              didReceiveUpdate = true;
            }
          }
        }
        return updateFunctionComponent(current2, workInProgress2, Component2, nextProps, renderLanes2);
      }
      function updateOffscreenComponent(current2, workInProgress2, renderLanes2) {
        var nextProps = workInProgress2.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current2 !== null ? current2.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
          if ((workInProgress2.mode & ConcurrentMode) === NoMode) {
            var nextState = {
              baseLanes: NoLanes,
              cachePool: null
            };
            workInProgress2.memoizedState = nextState;
            pushRenderLanes(workInProgress2, renderLanes2);
          } else if (!includesSomeLane(renderLanes2, OffscreenLane)) {
            var spawnedCachePool = null;
            var nextBaseLanes;
            if (prevState !== null) {
              var prevBaseLanes = prevState.baseLanes;
              nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes2);
            } else {
              nextBaseLanes = renderLanes2;
            }
            workInProgress2.lanes = workInProgress2.childLanes = laneToLanes(OffscreenLane);
            var _nextState = {
              baseLanes: nextBaseLanes,
              cachePool: spawnedCachePool
            };
            workInProgress2.memoizedState = _nextState;
            workInProgress2.updateQueue = null;
            pushRenderLanes(workInProgress2, nextBaseLanes);
            return null;
          } else {
            var _nextState2 = {
              baseLanes: NoLanes,
              cachePool: null
            };
            workInProgress2.memoizedState = _nextState2;
            var subtreeRenderLanes2 = prevState !== null ? prevState.baseLanes : renderLanes2;
            pushRenderLanes(workInProgress2, subtreeRenderLanes2);
          }
        } else {
          var _subtreeRenderLanes;
          if (prevState !== null) {
            _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes2);
            workInProgress2.memoizedState = null;
          } else {
            _subtreeRenderLanes = renderLanes2;
          }
          pushRenderLanes(workInProgress2, _subtreeRenderLanes);
        }
        {
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
      }
      function updateFragment(current2, workInProgress2, renderLanes2) {
        var nextChildren = workInProgress2.pendingProps;
        reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        return workInProgress2.child;
      }
      function updateMode(current2, workInProgress2, renderLanes2) {
        var nextChildren = workInProgress2.pendingProps.children;
        reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        return workInProgress2.child;
      }
      function updateProfiler(current2, workInProgress2, renderLanes2) {
        {
          workInProgress2.flags |= Update;
          {
            var stateNode = workInProgress2.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }
        }
        var nextProps = workInProgress2.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        return workInProgress2.child;
      }
      function markRef$1(current2, workInProgress2) {
        var ref = workInProgress2.ref;
        if (current2 === null && ref !== null || current2 !== null && current2.ref !== ref) {
          workInProgress2.flags |= Ref;
          {
            workInProgress2.flags |= RefStatic;
          }
        }
      }
      function updateFunctionComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
        {
          if (workInProgress2.type !== workInProgress2.elementType) {
            var innerPropTypes = Component2.propTypes;
            if (innerPropTypes) {
              checkPropTypes(
                innerPropTypes,
                nextProps,
                // Resolved props
                "prop",
                getComponentNameFromType(Component2)
              );
            }
          }
        }
        var context2;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress2, Component2, true);
          context2 = getMaskedContext(workInProgress2, unmaskedContext);
        }
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress2, renderLanes2);
        {
          markComponentRenderStarted(workInProgress2);
        }
        {
          ReactCurrentOwner$1.current = workInProgress2;
          setIsRendering(true);
          nextChildren = renderWithHooks(current2, workInProgress2, Component2, nextProps, context2, renderLanes2);
          hasId = checkDidRenderIdHook();
          if (workInProgress2.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
              nextChildren = renderWithHooks(current2, workInProgress2, Component2, nextProps, context2, renderLanes2);
              hasId = checkDidRenderIdHook();
            } finally {
              setIsStrictModeForDevtools(false);
            }
          }
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        if (current2 !== null && !didReceiveUpdate) {
          bailoutHooks(current2, workInProgress2, renderLanes2);
          return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
        }
        if (getIsHydrating() && hasId) {
          pushMaterializedTreeId(workInProgress2);
        }
        workInProgress2.flags |= PerformedWork;
        reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        return workInProgress2.child;
      }
      function updateClassComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
        {
          switch (shouldError(workInProgress2)) {
            case false: {
              var _instance = workInProgress2.stateNode;
              var ctor = workInProgress2.type;
              var tempInstance = new ctor(workInProgress2.memoizedProps, _instance.context);
              var state = tempInstance.state;
              _instance.updater.enqueueSetState(_instance, state, null);
              break;
            }
            case true: {
              workInProgress2.flags |= DidCapture;
              workInProgress2.flags |= ShouldCapture;
              var error$1 = new Error("Simulated error coming from DevTools");
              var lane = pickArbitraryLane(renderLanes2);
              workInProgress2.lanes = mergeLanes(workInProgress2.lanes, lane);
              var update = createClassErrorUpdate(workInProgress2, createCapturedValue(error$1, workInProgress2), lane);
              enqueueCapturedUpdate(workInProgress2, update);
              break;
            }
          }
          if (workInProgress2.type !== workInProgress2.elementType) {
            var innerPropTypes = Component2.propTypes;
            if (innerPropTypes) {
              checkPropTypes(
                innerPropTypes,
                nextProps,
                // Resolved props
                "prop",
                getComponentNameFromType(Component2)
              );
            }
          }
        }
        var hasContext;
        if (isContextProvider(Component2)) {
          hasContext = true;
          pushContextProvider(workInProgress2);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress2, renderLanes2);
        var instance2 = workInProgress2.stateNode;
        var shouldUpdate;
        if (instance2 === null) {
          if (current2 !== null) {
            current2.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.flags |= Placement;
          }
          constructClassInstance(workInProgress2, Component2, nextProps);
          mountClassInstance(workInProgress2, Component2, nextProps, renderLanes2);
          shouldUpdate = true;
        } else if (current2 === null) {
          shouldUpdate = resumeMountClassInstance(workInProgress2, Component2, nextProps, renderLanes2);
        } else {
          shouldUpdate = updateClassInstance(current2, workInProgress2, Component2, nextProps, renderLanes2);
        }
        var nextUnitOfWork = finishClassComponent(current2, workInProgress2, Component2, shouldUpdate, hasContext, renderLanes2);
        {
          var inst = workInProgress2.stateNode;
          if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) {
              error2("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress2) || "a component");
            }
            didWarnAboutReassigningProps = true;
          }
        }
        return nextUnitOfWork;
      }
      function finishClassComponent(current2, workInProgress2, Component2, shouldUpdate, hasContext, renderLanes2) {
        markRef$1(current2, workInProgress2);
        var didCaptureError = (workInProgress2.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
          if (hasContext) {
            invalidateContextProvider(workInProgress2, Component2, false);
          }
          return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
        }
        var instance2 = workInProgress2.stateNode;
        ReactCurrentOwner$1.current = workInProgress2;
        var nextChildren;
        if (didCaptureError && typeof Component2.getDerivedStateFromError !== "function") {
          nextChildren = null;
          {
            stopProfilerTimerIfRunning();
          }
        } else {
          {
            markComponentRenderStarted(workInProgress2);
          }
          {
            setIsRendering(true);
            nextChildren = instance2.render();
            if (workInProgress2.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);
              try {
                instance2.render();
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }
            setIsRendering(false);
          }
          {
            markComponentRenderStopped();
          }
        }
        workInProgress2.flags |= PerformedWork;
        if (current2 !== null && didCaptureError) {
          forceUnmountCurrentAndReconcile(current2, workInProgress2, nextChildren, renderLanes2);
        } else {
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        }
        workInProgress2.memoizedState = instance2.state;
        if (hasContext) {
          invalidateContextProvider(workInProgress2, Component2, true);
        }
        return workInProgress2.child;
      }
      function pushHostRootContext(workInProgress2) {
        var root2 = workInProgress2.stateNode;
        if (root2.pendingContext) {
          pushTopLevelContextObject(workInProgress2, root2.pendingContext, root2.pendingContext !== root2.context);
        } else if (root2.context) {
          pushTopLevelContextObject(workInProgress2, root2.context, false);
        }
        pushHostContainer(workInProgress2, root2.containerInfo);
      }
      function updateHostRoot(current2, workInProgress2, renderLanes2) {
        pushHostRootContext(workInProgress2);
        if (current2 === null) {
          throw new Error("Should have a current fiber. This is a bug in React.");
        }
        var nextProps = workInProgress2.pendingProps;
        var prevState = workInProgress2.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current2, workInProgress2);
        processUpdateQueue(workInProgress2, nextProps, null, renderLanes2);
        var nextState = workInProgress2.memoizedState;
        workInProgress2.stateNode;
        var nextChildren = nextState.element;
        if (supportsHydration && prevState.isDehydrated) {
          var overrideState = {
            element: nextChildren,
            isDehydrated: false,
            cache: nextState.cache,
            transitions: nextState.transitions
          };
          var updateQueue = workInProgress2.updateQueue;
          updateQueue.baseState = overrideState;
          workInProgress2.memoizedState = overrideState;
          if (workInProgress2.flags & ForceClientRender) {
            var recoverableError = new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.");
            return mountHostRootWithoutHydrating(current2, workInProgress2, nextChildren, renderLanes2, recoverableError);
          } else if (nextChildren !== prevChildren) {
            var _recoverableError = new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.");
            return mountHostRootWithoutHydrating(current2, workInProgress2, nextChildren, renderLanes2, _recoverableError);
          } else {
            enterHydrationState(workInProgress2);
            var child = mountChildFibers(workInProgress2, null, nextChildren, renderLanes2);
            workInProgress2.child = child;
            var node = child;
            while (node) {
              node.flags = node.flags & ~Placement | Hydrating;
              node = node.sibling;
            }
          }
        } else {
          resetHydrationState();
          if (nextChildren === prevChildren) {
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        }
        return workInProgress2.child;
      }
      function mountHostRootWithoutHydrating(current2, workInProgress2, nextChildren, renderLanes2, recoverableError) {
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress2.flags |= ForceClientRender;
        reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        return workInProgress2.child;
      }
      function updateHostComponent$1(current2, workInProgress2, renderLanes2) {
        pushHostContext(workInProgress2);
        if (current2 === null) {
          tryToClaimNextHydratableInstance(workInProgress2);
        }
        var type = workInProgress2.type;
        var nextProps = workInProgress2.pendingProps;
        var prevProps = current2 !== null ? current2.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) {
          nextChildren = null;
        } else if (prevProps !== null && shouldSetTextContent(type, prevProps)) {
          workInProgress2.flags |= ContentReset;
        }
        markRef$1(current2, workInProgress2);
        reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        return workInProgress2.child;
      }
      function updateHostText$1(current2, workInProgress2) {
        if (current2 === null) {
          tryToClaimNextHydratableInstance(workInProgress2);
        }
        return null;
      }
      function mountLazyComponent(_current, workInProgress2, elementType, renderLanes2) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress2.alternate = null;
          workInProgress2.flags |= Placement;
        }
        var props = workInProgress2.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init9 = lazyComponent._init;
        var Component2 = init9(payload);
        workInProgress2.type = Component2;
        var resolvedTag = workInProgress2.tag = resolveLazyComponentTag(Component2);
        var resolvedProps = resolveDefaultProps(Component2, props);
        var child;
        switch (resolvedTag) {
          case FunctionComponent: {
            {
              validateFunctionComponentInDev(workInProgress2, Component2);
              workInProgress2.type = Component2 = resolveFunctionForHotReloading(Component2);
            }
            child = updateFunctionComponent(null, workInProgress2, Component2, resolvedProps, renderLanes2);
            return child;
          }
          case ClassComponent: {
            {
              workInProgress2.type = Component2 = resolveClassForHotReloading(Component2);
            }
            child = updateClassComponent(null, workInProgress2, Component2, resolvedProps, renderLanes2);
            return child;
          }
          case ForwardRef: {
            {
              workInProgress2.type = Component2 = resolveForwardRefForHotReloading(Component2);
            }
            child = updateForwardRef(null, workInProgress2, Component2, resolvedProps, renderLanes2);
            return child;
          }
          case MemoComponent: {
            {
              if (workInProgress2.type !== workInProgress2.elementType) {
                var outerPropTypes = Component2.propTypes;
                if (outerPropTypes) {
                  checkPropTypes(
                    outerPropTypes,
                    resolvedProps,
                    // Resolved for outer only
                    "prop",
                    getComponentNameFromType(Component2)
                  );
                }
              }
            }
            child = updateMemoComponent(
              null,
              workInProgress2,
              Component2,
              resolveDefaultProps(Component2.type, resolvedProps),
              // The inner type can have defaults too
              renderLanes2
            );
            return child;
          }
        }
        var hint2 = "";
        {
          if (Component2 !== null && typeof Component2 === "object" && Component2.$$typeof === REACT_LAZY_TYPE) {
            hint2 = " Did you wrap a component in React.lazy() more than once?";
          }
        }
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component2 + ". " + ("Lazy element type must resolve to a class or function." + hint2));
      }
      function mountIncompleteClassComponent(_current, workInProgress2, Component2, nextProps, renderLanes2) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress2.alternate = null;
          workInProgress2.flags |= Placement;
        }
        workInProgress2.tag = ClassComponent;
        var hasContext;
        if (isContextProvider(Component2)) {
          hasContext = true;
          pushContextProvider(workInProgress2);
        } else {
          hasContext = false;
        }
        prepareToReadContext(workInProgress2, renderLanes2);
        constructClassInstance(workInProgress2, Component2, nextProps);
        mountClassInstance(workInProgress2, Component2, nextProps, renderLanes2);
        return finishClassComponent(null, workInProgress2, Component2, true, hasContext, renderLanes2);
      }
      function mountIndeterminateComponent(_current, workInProgress2, Component2, renderLanes2) {
        if (_current !== null) {
          _current.alternate = null;
          workInProgress2.alternate = null;
          workInProgress2.flags |= Placement;
        }
        var props = workInProgress2.pendingProps;
        var context2;
        {
          var unmaskedContext = getUnmaskedContext(workInProgress2, Component2, false);
          context2 = getMaskedContext(workInProgress2, unmaskedContext);
        }
        prepareToReadContext(workInProgress2, renderLanes2);
        var value;
        var hasId;
        {
          markComponentRenderStarted(workInProgress2);
        }
        {
          if (Component2.prototype && typeof Component2.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component2) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
              error2("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
              didWarnAboutBadClass[componentName] = true;
            }
          }
          if (workInProgress2.mode & StrictLegacyMode) {
            ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, null);
          }
          setIsRendering(true);
          ReactCurrentOwner$1.current = workInProgress2;
          value = renderWithHooks(null, workInProgress2, Component2, props, context2, renderLanes2);
          hasId = checkDidRenderIdHook();
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        workInProgress2.flags |= PerformedWork;
        {
          if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
            var _componentName = getComponentNameFromType(Component2) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
              error2("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
              didWarnAboutModulePatternComponent[_componentName] = true;
            }
          }
        }
        if (
          // Run these checks in production only if the flag is off.
          // Eventually we'll delete this branch altogether.
          typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0
        ) {
          {
            var _componentName2 = getComponentNameFromType(Component2) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
              error2("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
              didWarnAboutModulePatternComponent[_componentName2] = true;
            }
          }
          workInProgress2.tag = ClassComponent;
          workInProgress2.memoizedState = null;
          workInProgress2.updateQueue = null;
          var hasContext = false;
          if (isContextProvider(Component2)) {
            hasContext = true;
            pushContextProvider(workInProgress2);
          } else {
            hasContext = false;
          }
          workInProgress2.memoizedState = value.state !== null && value.state !== void 0 ? value.state : null;
          initializeUpdateQueue(workInProgress2);
          adoptClassInstance(workInProgress2, value);
          mountClassInstance(workInProgress2, Component2, props, renderLanes2);
          return finishClassComponent(null, workInProgress2, Component2, true, hasContext, renderLanes2);
        } else {
          workInProgress2.tag = FunctionComponent;
          {
            if (workInProgress2.mode & StrictLegacyMode) {
              setIsStrictModeForDevtools(true);
              try {
                value = renderWithHooks(null, workInProgress2, Component2, props, context2, renderLanes2);
                hasId = checkDidRenderIdHook();
              } finally {
                setIsStrictModeForDevtools(false);
              }
            }
          }
          if (getIsHydrating() && hasId) {
            pushMaterializedTreeId(workInProgress2);
          }
          reconcileChildren(null, workInProgress2, value, renderLanes2);
          {
            validateFunctionComponentInDev(workInProgress2, Component2);
          }
          return workInProgress2.child;
        }
      }
      function validateFunctionComponentInDev(workInProgress2, Component2) {
        {
          if (Component2) {
            if (Component2.childContextTypes) {
              error2("%s(...): childContextTypes cannot be defined on a function component.", Component2.displayName || Component2.name || "Component");
            }
          }
          if (workInProgress2.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) {
              info += "\n\nCheck the render method of `" + ownerName + "`.";
            }
            var warningKey = ownerName || "";
            var debugSource = workInProgress2._debugSource;
            if (debugSource) {
              warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            }
            if (!didWarnAboutFunctionRefs[warningKey]) {
              didWarnAboutFunctionRefs[warningKey] = true;
              error2("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
          }
          if (typeof Component2.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component2) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
              error2("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
              didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
          }
          if (typeof Component2.contextType === "object" && Component2.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component2) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
              error2("%s: Function components do not support contextType.", _componentName4);
              didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
          }
        }
      }
      var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
      };
      function mountSuspenseOffscreenState(renderLanes2) {
        return {
          baseLanes: renderLanes2,
          cachePool: getSuspendedCache()
        };
      }
      function updateSuspenseOffscreenState(prevOffscreenState, renderLanes2) {
        var cachePool = null;
        return {
          baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes2),
          cachePool
        };
      }
      function shouldRemainOnFallback(suspenseContext, current2, workInProgress2, renderLanes2) {
        if (current2 !== null) {
          var suspenseState = current2.memoizedState;
          if (suspenseState === null) {
            return false;
          }
        }
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
      }
      function getRemainingWorkInPrimaryTree(current2, renderLanes2) {
        return removeLanes(current2.childLanes, renderLanes2);
      }
      function updateSuspenseComponent(current2, workInProgress2, renderLanes2) {
        var nextProps = workInProgress2.pendingProps;
        {
          if (shouldSuspend(workInProgress2)) {
            workInProgress2.flags |= DidCapture;
          }
        }
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend2 = (workInProgress2.flags & DidCapture) !== NoFlags;
        if (didSuspend2 || shouldRemainOnFallback(suspenseContext, current2)) {
          showFallback = true;
          workInProgress2.flags &= ~DidCapture;
        } else {
          if (current2 === null || current2.memoizedState !== null) {
            {
              suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
          }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress2, suspenseContext);
        if (current2 === null) {
          tryToClaimNextHydratableInstance(workInProgress2);
          {
            var suspenseState = workInProgress2.memoizedState;
            if (suspenseState !== null) {
              var dehydrated = suspenseState.dehydrated;
              if (dehydrated !== null) {
                return mountDehydratedSuspenseComponent(workInProgress2, dehydrated);
              }
            }
          }
          var nextPrimaryChildren = nextProps.children;
          var nextFallbackChildren = nextProps.fallback;
          if (showFallback) {
            var fallbackFragment = mountSuspenseFallbackChildren(workInProgress2, nextPrimaryChildren, nextFallbackChildren, renderLanes2);
            var primaryChildFragment = workInProgress2.child;
            primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes2);
            workInProgress2.memoizedState = SUSPENDED_MARKER;
            return fallbackFragment;
          } else {
            return mountSuspensePrimaryChildren(workInProgress2, nextPrimaryChildren);
          }
        } else {
          var prevState = current2.memoizedState;
          if (prevState !== null) {
            {
              var _dehydrated = prevState.dehydrated;
              if (_dehydrated !== null) {
                if (!didSuspend2) {
                  return updateDehydratedSuspenseComponent(current2, workInProgress2, _dehydrated, prevState, renderLanes2);
                } else if (workInProgress2.flags & ForceClientRender) {
                  workInProgress2.flags &= ~ForceClientRender;
                  return retrySuspenseComponentWithoutHydrating(current2, workInProgress2, renderLanes2, new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                } else if (workInProgress2.memoizedState !== null) {
                  workInProgress2.child = current2.child;
                  workInProgress2.flags |= DidCapture;
                  return null;
                } else {
                  var _nextPrimaryChildren = nextProps.children;
                  var _nextFallbackChildren = nextProps.fallback;
                  var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current2, workInProgress2, _nextPrimaryChildren, _nextFallbackChildren, renderLanes2);
                  var _primaryChildFragment2 = workInProgress2.child;
                  _primaryChildFragment2.memoizedState = mountSuspenseOffscreenState(renderLanes2);
                  workInProgress2.memoizedState = SUSPENDED_MARKER;
                  return fallbackChildFragment;
                }
              }
            }
            if (showFallback) {
              var _nextFallbackChildren2 = nextProps.fallback;
              var _nextPrimaryChildren2 = nextProps.children;
              var _fallbackChildFragment = updateSuspenseFallbackChildren(current2, workInProgress2, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes2);
              var _primaryChildFragment3 = workInProgress2.child;
              var prevOffscreenState = current2.child.memoizedState;
              _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes2) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes2);
              _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current2, renderLanes2);
              workInProgress2.memoizedState = SUSPENDED_MARKER;
              return _fallbackChildFragment;
            } else {
              var _nextPrimaryChildren3 = nextProps.children;
              var _primaryChildFragment4 = updateSuspensePrimaryChildren(current2, workInProgress2, _nextPrimaryChildren3, renderLanes2);
              workInProgress2.memoizedState = null;
              return _primaryChildFragment4;
            }
          } else {
            if (showFallback) {
              var _nextFallbackChildren3 = nextProps.fallback;
              var _nextPrimaryChildren4 = nextProps.children;
              var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current2, workInProgress2, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes2);
              var _primaryChildFragment5 = workInProgress2.child;
              var _prevOffscreenState = current2.child.memoizedState;
              _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes2) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes2);
              _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current2, renderLanes2);
              workInProgress2.memoizedState = SUSPENDED_MARKER;
              return _fallbackChildFragment2;
            } else {
              var _nextPrimaryChildren5 = nextProps.children;
              var _primaryChildFragment6 = updateSuspensePrimaryChildren(current2, workInProgress2, _nextPrimaryChildren5, renderLanes2);
              workInProgress2.memoizedState = null;
              return _primaryChildFragment6;
            }
          }
        }
      }
      function mountSuspensePrimaryChildren(workInProgress2, primaryChildren, renderLanes2) {
        var mode2 = workInProgress2.mode;
        var primaryChildProps = {
          mode: "visible",
          children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode2);
        primaryChildFragment.return = workInProgress2;
        workInProgress2.child = primaryChildFragment;
        return primaryChildFragment;
      }
      function mountSuspenseFallbackChildren(workInProgress2, primaryChildren, fallbackChildren, renderLanes2) {
        var mode2 = workInProgress2.mode;
        var progressedPrimaryFragment = workInProgress2.child;
        var primaryChildProps = {
          mode: "hidden",
          children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode2 & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
          primaryChildFragment = progressedPrimaryFragment;
          primaryChildFragment.childLanes = NoLanes;
          primaryChildFragment.pendingProps = primaryChildProps;
          if (workInProgress2.mode & ProfileMode) {
            primaryChildFragment.actualDuration = 0;
            primaryChildFragment.actualStartTime = -1;
            primaryChildFragment.selfBaseDuration = 0;
            primaryChildFragment.treeBaseDuration = 0;
          }
          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode2, renderLanes2, null);
        } else {
          primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode2);
          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode2, renderLanes2, null);
        }
        primaryChildFragment.return = workInProgress2;
        fallbackChildFragment.return = workInProgress2;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress2.child = primaryChildFragment;
        return fallbackChildFragment;
      }
      function mountWorkInProgressOffscreenFiber(offscreenProps, mode2, renderLanes2) {
        return createFiberFromOffscreen(offscreenProps, mode2, NoLanes, null);
      }
      function updateWorkInProgressOffscreenFiber(current2, offscreenProps) {
        return createWorkInProgress(current2, offscreenProps);
      }
      function updateSuspensePrimaryChildren(current2, workInProgress2, primaryChildren, renderLanes2) {
        var currentPrimaryChildFragment = current2.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
          mode: "visible",
          children: primaryChildren
        });
        if ((workInProgress2.mode & ConcurrentMode) === NoMode) {
          primaryChildFragment.lanes = renderLanes2;
        }
        primaryChildFragment.return = workInProgress2;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
          var deletions = workInProgress2.deletions;
          if (deletions === null) {
            workInProgress2.deletions = [currentFallbackChildFragment];
            workInProgress2.flags |= ChildDeletion;
          } else {
            deletions.push(currentFallbackChildFragment);
          }
        }
        workInProgress2.child = primaryChildFragment;
        return primaryChildFragment;
      }
      function updateSuspenseFallbackChildren(current2, workInProgress2, primaryChildren, fallbackChildren, renderLanes2) {
        var mode2 = workInProgress2.mode;
        var currentPrimaryChildFragment = current2.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
          mode: "hidden",
          children: primaryChildren
        };
        var primaryChildFragment;
        if (
          // In legacy mode, we commit the primary tree as if it successfully
          // completed, even though it's in an inconsistent state.
          (mode2 & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
          // already cloned. In legacy mode, the only case where this isn't true is
          // when DevTools forces us to display a fallback; we skip the first render
          // pass entirely and go straight to rendering the fallback. (In Concurrent
          // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
          // only codepath.)
          workInProgress2.child !== currentPrimaryChildFragment
        ) {
          var progressedPrimaryFragment = workInProgress2.child;
          primaryChildFragment = progressedPrimaryFragment;
          primaryChildFragment.childLanes = NoLanes;
          primaryChildFragment.pendingProps = primaryChildProps;
          if (workInProgress2.mode & ProfileMode) {
            primaryChildFragment.actualDuration = 0;
            primaryChildFragment.actualStartTime = -1;
            primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
            primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
          }
          workInProgress2.deletions = null;
        } else {
          primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
          primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) {
          fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        } else {
          fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode2, renderLanes2, null);
          fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress2;
        primaryChildFragment.return = workInProgress2;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress2.child = primaryChildFragment;
        return fallbackChildFragment;
      }
      function retrySuspenseComponentWithoutHydrating(current2, workInProgress2, renderLanes2, recoverableError) {
        if (recoverableError !== null) {
          queueHydrationError(recoverableError);
        }
        reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
        var nextProps = workInProgress2.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress2, primaryChildren);
        primaryChildFragment.flags |= Placement;
        workInProgress2.memoizedState = null;
        return primaryChildFragment;
      }
      function mountSuspenseFallbackAfterRetryWithoutHydrating(current2, workInProgress2, primaryChildren, fallbackChildren, renderLanes2) {
        var fiberMode = workInProgress2.mode;
        var primaryChildProps = {
          mode: "visible",
          children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes2, null);
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress2;
        fallbackChildFragment.return = workInProgress2;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress2.child = primaryChildFragment;
        if ((workInProgress2.mode & ConcurrentMode) !== NoMode) {
          reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
        }
        return fallbackChildFragment;
      }
      function mountDehydratedSuspenseComponent(workInProgress2, suspenseInstance, renderLanes2) {
        if ((workInProgress2.mode & ConcurrentMode) === NoMode) {
          {
            error2("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
          }
          workInProgress2.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) {
          workInProgress2.lanes = laneToLanes(DefaultHydrationLane);
        } else {
          workInProgress2.lanes = laneToLanes(OffscreenLane);
        }
        return null;
      }
      function updateDehydratedSuspenseComponent(current2, workInProgress2, suspenseInstance, suspenseState, renderLanes2) {
        warnIfHydrating();
        if ((workInProgress2.mode & ConcurrentMode) === NoMode) {
          return retrySuspenseComponentWithoutHydrating(
            current2,
            workInProgress2,
            renderLanes2,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        }
        if (isSuspenseInstanceFallback(suspenseInstance)) {
          return retrySuspenseComponentWithoutHydrating(
            current2,
            workInProgress2,
            renderLanes2,
            // TODO: The server should serialize the error message so we can log it
            // here on the client. Or, in production, a hash/id that corresponds to
            // the error.
            new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.")
          );
        }
        var hasContextChanged2 = includesSomeLane(renderLanes2, current2.childLanes);
        if (didReceiveUpdate || hasContextChanged2) {
          var root2 = getWorkInProgressRoot();
          if (root2 !== null) {
            var attemptHydrationAtLane = getBumpedLaneForHydration(root2, renderLanes2);
            if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
              suspenseState.retryLane = attemptHydrationAtLane;
              var eventTime = NoTimestamp;
              scheduleUpdateOnFiber(current2, attemptHydrationAtLane, eventTime);
            }
          }
          renderDidSuspendDelayIfPossible();
          return retrySuspenseComponentWithoutHydrating(current2, workInProgress2, renderLanes2, new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
        } else if (isSuspenseInstancePending(suspenseInstance)) {
          workInProgress2.flags |= DidCapture;
          workInProgress2.child = current2.child;
          var retry = retryDehydratedSuspenseBoundary.bind(null, current2);
          registerSuspenseInstanceRetry(suspenseInstance, retry);
          return null;
        } else {
          reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress2, suspenseInstance, suspenseState.treeContext);
          var nextProps = workInProgress2.pendingProps;
          var primaryChildren = nextProps.children;
          var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress2, primaryChildren);
          primaryChildFragment.flags |= Hydrating;
          return primaryChildFragment;
        }
      }
      function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes2);
        var alternate = fiber.alternate;
        if (alternate !== null) {
          alternate.lanes = mergeLanes(alternate.lanes, renderLanes2);
        }
        scheduleContextWorkOnParentPath(fiber.return, renderLanes2, propagationRoot);
      }
      function propagateSuspenseContextChange(workInProgress2, firstChild, renderLanes2) {
        var node = firstChild;
        while (node !== null) {
          if (node.tag === SuspenseComponent) {
            var state = node.memoizedState;
            if (state !== null) {
              scheduleSuspenseWorkOnFiber(node, renderLanes2, workInProgress2);
            }
          } else if (node.tag === SuspenseListComponent) {
            scheduleSuspenseWorkOnFiber(node, renderLanes2, workInProgress2);
          } else if (node.child !== null) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === workInProgress2) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === workInProgress2) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function findLastContentRow(firstChild) {
        var row = firstChild;
        var lastContentRow = null;
        while (row !== null) {
          var currentRow = row.alternate;
          if (currentRow !== null && findFirstSuspended(currentRow) === null) {
            lastContentRow = row;
          }
          row = row.sibling;
        }
        return lastContentRow;
      }
      function validateRevealOrder(revealOrder) {
        {
          if (revealOrder !== void 0 && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") {
              switch (revealOrder.toLowerCase()) {
                case "together":
                case "forwards":
                case "backwards": {
                  error2('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                  break;
                }
                case "forward":
                case "backward": {
                  error2('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                  break;
                }
                default:
                  error2('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                  break;
              }
            } else {
              error2('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
            }
          }
        }
      }
      function validateTailOptions(tailMode, revealOrder) {
        {
          if (tailMode !== void 0 && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
              didWarnAboutTailOptions[tailMode] = true;
              error2('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
              didWarnAboutTailOptions[tailMode] = true;
              error2('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
          }
        }
      }
      function validateSuspenseListNestedChild(childSlot, index3) {
        {
          var isAnArray = isArray3(childSlot);
          var isIterable2 = !isAnArray && typeof getIteratorFn(childSlot) === "function";
          if (isAnArray || isIterable2) {
            var type = isAnArray ? "array" : "iterable";
            error2("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index3, type);
            return false;
          }
        }
        return true;
      }
      function validateSuspenseListChildren(children, revealOrder) {
        {
          if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== void 0 && children !== null && children !== false) {
            if (isArray3(children)) {
              for (var i2 = 0; i2 < children.length; i2++) {
                if (!validateSuspenseListNestedChild(children[i2], i2)) {
                  return;
                }
              }
            } else {
              var iteratorFn = getIteratorFn(children);
              if (typeof iteratorFn === "function") {
                var childrenIterator = iteratorFn.call(children);
                if (childrenIterator) {
                  var step = childrenIterator.next();
                  var _i = 0;
                  for (; !step.done; step = childrenIterator.next()) {
                    if (!validateSuspenseListNestedChild(step.value, _i)) {
                      return;
                    }
                    _i++;
                  }
                }
              } else {
                error2('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
              }
            }
          }
        }
      }
      function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress2.memoizedState;
        if (renderState === null) {
          workInProgress2.memoizedState = {
            isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail,
            tailMode
          };
        } else {
          renderState.isBackwards = isBackwards;
          renderState.rendering = null;
          renderState.renderingStartTime = 0;
          renderState.last = lastContentRow;
          renderState.tail = tail;
          renderState.tailMode = tailMode;
        }
      }
      function updateSuspenseListComponent(current2, workInProgress2, renderLanes2) {
        var nextProps = workInProgress2.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
          suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
          workInProgress2.flags |= DidCapture;
        } else {
          var didSuspendBefore = current2 !== null && (current2.flags & DidCapture) !== NoFlags;
          if (didSuspendBefore) {
            propagateSuspenseContextChange(workInProgress2, workInProgress2.child, renderLanes2);
          }
          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress2, suspenseContext);
        if ((workInProgress2.mode & ConcurrentMode) === NoMode) {
          workInProgress2.memoizedState = null;
        } else {
          switch (revealOrder) {
            case "forwards": {
              var lastContentRow = findLastContentRow(workInProgress2.child);
              var tail;
              if (lastContentRow === null) {
                tail = workInProgress2.child;
                workInProgress2.child = null;
              } else {
                tail = lastContentRow.sibling;
                lastContentRow.sibling = null;
              }
              initSuspenseListRenderState(
                workInProgress2,
                false,
                // isBackwards
                tail,
                lastContentRow,
                tailMode
              );
              break;
            }
            case "backwards": {
              var _tail = null;
              var row = workInProgress2.child;
              workInProgress2.child = null;
              while (row !== null) {
                var currentRow = row.alternate;
                if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                  workInProgress2.child = row;
                  break;
                }
                var nextRow = row.sibling;
                row.sibling = _tail;
                _tail = row;
                row = nextRow;
              }
              initSuspenseListRenderState(
                workInProgress2,
                true,
                // isBackwards
                _tail,
                null,
                // last
                tailMode
              );
              break;
            }
            case "together": {
              initSuspenseListRenderState(
                workInProgress2,
                false,
                // isBackwards
                null,
                // tail
                null,
                // last
                void 0
              );
              break;
            }
            default: {
              workInProgress2.memoizedState = null;
            }
          }
        }
        return workInProgress2.child;
      }
      function updatePortalComponent(current2, workInProgress2, renderLanes2) {
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        var nextChildren = workInProgress2.pendingProps;
        if (current2 === null) {
          workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderLanes2);
        } else {
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
        }
        return workInProgress2.child;
      }
      var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
      function updateContextProvider(current2, workInProgress2, renderLanes2) {
        var providerType = workInProgress2.type;
        var context2 = providerType._context;
        var newProps = workInProgress2.pendingProps;
        var oldProps = workInProgress2.memoizedProps;
        var newValue = newProps.value;
        {
          if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
              hasWarnedAboutUsingNoValuePropOnContextProvider = true;
              error2("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
          }
          var providerPropTypes = workInProgress2.type.propTypes;
          if (providerPropTypes) {
            checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
          }
        }
        pushProvider(workInProgress2, context2, newValue);
        {
          if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs2(oldValue, newValue)) {
              if (oldProps.children === newProps.children && !hasContextChanged()) {
                return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
              }
            } else {
              propagateContextChange(workInProgress2, context2, renderLanes2);
            }
          }
        }
        var newChildren = newProps.children;
        reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
        return workInProgress2.child;
      }
      var hasWarnedAboutUsingContextAsConsumer = false;
      function updateContextConsumer(current2, workInProgress2, renderLanes2) {
        var context2 = workInProgress2.type;
        {
          if (context2._context === void 0) {
            if (context2 !== context2.Consumer) {
              if (!hasWarnedAboutUsingContextAsConsumer) {
                hasWarnedAboutUsingContextAsConsumer = true;
                error2("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
              }
            }
          } else {
            context2 = context2._context;
          }
        }
        var newProps = workInProgress2.pendingProps;
        var render5 = newProps.children;
        {
          if (typeof render5 !== "function") {
            error2("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
          }
        }
        prepareToReadContext(workInProgress2, renderLanes2);
        var newValue = readContext(context2);
        {
          markComponentRenderStarted(workInProgress2);
        }
        var newChildren;
        {
          ReactCurrentOwner$1.current = workInProgress2;
          setIsRendering(true);
          newChildren = render5(newValue);
          setIsRendering(false);
        }
        {
          markComponentRenderStopped();
        }
        workInProgress2.flags |= PerformedWork;
        reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
        return workInProgress2.child;
      }
      function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
      }
      function bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2) {
        if (current2 !== null) {
          workInProgress2.dependencies = current2.dependencies;
        }
        {
          stopProfilerTimerIfRunning();
        }
        markSkippedUpdateLanes(workInProgress2.lanes);
        if (!includesSomeLane(renderLanes2, workInProgress2.childLanes)) {
          {
            return null;
          }
        }
        cloneChildFibers(current2, workInProgress2);
        return workInProgress2.child;
      }
      function remountFiber(current2, oldWorkInProgress, newWorkInProgress) {
        {
          var returnFiber = oldWorkInProgress.return;
          if (returnFiber === null) {
            throw new Error("Cannot swap the root fiber.");
          }
          current2.alternate = null;
          oldWorkInProgress.alternate = null;
          newWorkInProgress.index = oldWorkInProgress.index;
          newWorkInProgress.sibling = oldWorkInProgress.sibling;
          newWorkInProgress.return = oldWorkInProgress.return;
          newWorkInProgress.ref = oldWorkInProgress.ref;
          if (oldWorkInProgress === returnFiber.child) {
            returnFiber.child = newWorkInProgress;
          } else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) {
              throw new Error("Expected parent to have a child.");
            }
            while (prevSibling.sibling !== oldWorkInProgress) {
              prevSibling = prevSibling.sibling;
              if (prevSibling === null) {
                throw new Error("Expected to find the previous sibling.");
              }
            }
            prevSibling.sibling = newWorkInProgress;
          }
          var deletions = returnFiber.deletions;
          if (deletions === null) {
            returnFiber.deletions = [current2];
            returnFiber.flags |= ChildDeletion;
          } else {
            deletions.push(current2);
          }
          newWorkInProgress.flags |= Placement;
          return newWorkInProgress;
        }
      }
      function checkScheduledUpdateOrContext(current2, renderLanes2) {
        var updateLanes = current2.lanes;
        if (includesSomeLane(updateLanes, renderLanes2)) {
          return true;
        }
        return false;
      }
      function attemptEarlyBailoutIfNoScheduledUpdate(current2, workInProgress2, renderLanes2) {
        switch (workInProgress2.tag) {
          case HostRoot:
            pushHostRootContext(workInProgress2);
            workInProgress2.stateNode;
            resetHydrationState();
            break;
          case HostComponent:
            pushHostContext(workInProgress2);
            break;
          case ClassComponent: {
            var Component2 = workInProgress2.type;
            if (isContextProvider(Component2)) {
              pushContextProvider(workInProgress2);
            }
            break;
          }
          case HostPortal:
            pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
            break;
          case ContextProvider: {
            var newValue = workInProgress2.memoizedProps.value;
            var context2 = workInProgress2.type._context;
            pushProvider(workInProgress2, context2, newValue);
            break;
          }
          case Profiler:
            {
              var hasChildWork = includesSomeLane(renderLanes2, workInProgress2.childLanes);
              if (hasChildWork) {
                workInProgress2.flags |= Update;
              }
              {
                var stateNode = workInProgress2.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
              }
            }
            break;
          case SuspenseComponent: {
            var state = workInProgress2.memoizedState;
            if (state !== null) {
              {
                if (state.dehydrated !== null) {
                  pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  workInProgress2.flags |= DidCapture;
                  return null;
                }
              }
              var primaryChildFragment = workInProgress2.child;
              var primaryChildLanes = primaryChildFragment.childLanes;
              if (includesSomeLane(renderLanes2, primaryChildLanes)) {
                return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
              } else {
                pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                var child = bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
                if (child !== null) {
                  return child.sibling;
                } else {
                  return null;
                }
              }
            } else {
              pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
            }
            break;
          }
          case SuspenseListComponent: {
            var didSuspendBefore = (current2.flags & DidCapture) !== NoFlags;
            var _hasChildWork = includesSomeLane(renderLanes2, workInProgress2.childLanes);
            if (didSuspendBefore) {
              if (_hasChildWork) {
                return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
              }
              workInProgress2.flags |= DidCapture;
            }
            var renderState = workInProgress2.memoizedState;
            if (renderState !== null) {
              renderState.rendering = null;
              renderState.tail = null;
              renderState.lastEffect = null;
            }
            pushSuspenseContext(workInProgress2, suspenseStackCursor.current);
            if (_hasChildWork) {
              break;
            } else {
              return null;
            }
          }
          case OffscreenComponent:
          case LegacyHiddenComponent: {
            workInProgress2.lanes = NoLanes;
            return updateOffscreenComponent(current2, workInProgress2, renderLanes2);
          }
        }
        return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
      }
      function beginWork(current2, workInProgress2, renderLanes2) {
        {
          if (workInProgress2._debugNeedsRemount && current2 !== null) {
            return remountFiber(current2, workInProgress2, createFiberFromTypeAndProps(workInProgress2.type, workInProgress2.key, workInProgress2.pendingProps, workInProgress2._debugOwner || null, workInProgress2.mode, workInProgress2.lanes));
          }
        }
        if (current2 !== null) {
          var oldProps = current2.memoizedProps;
          var newProps = workInProgress2.pendingProps;
          if (oldProps !== newProps || hasContextChanged() || // Force a re-render if the implementation changed due to hot reload:
          workInProgress2.type !== current2.type) {
            didReceiveUpdate = true;
          } else {
            var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current2, renderLanes2);
            if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
            // may not be work scheduled on `current`, so we check for this flag.
            (workInProgress2.flags & DidCapture) === NoFlags) {
              didReceiveUpdate = false;
              return attemptEarlyBailoutIfNoScheduledUpdate(current2, workInProgress2, renderLanes2);
            }
            if ((current2.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
              didReceiveUpdate = true;
            } else {
              didReceiveUpdate = false;
            }
          }
        } else {
          didReceiveUpdate = false;
          if (getIsHydrating() && isForkedChild(workInProgress2)) {
            var slotIndex = workInProgress2.index;
            var numberOfForks = getForksAtLevel();
            pushTreeId(workInProgress2, numberOfForks, slotIndex);
          }
        }
        workInProgress2.lanes = NoLanes;
        switch (workInProgress2.tag) {
          case IndeterminateComponent: {
            return mountIndeterminateComponent(current2, workInProgress2, workInProgress2.type, renderLanes2);
          }
          case LazyComponent: {
            var elementType = workInProgress2.elementType;
            return mountLazyComponent(current2, workInProgress2, elementType, renderLanes2);
          }
          case FunctionComponent: {
            var Component2 = workInProgress2.type;
            var unresolvedProps = workInProgress2.pendingProps;
            var resolvedProps = workInProgress2.elementType === Component2 ? unresolvedProps : resolveDefaultProps(Component2, unresolvedProps);
            return updateFunctionComponent(current2, workInProgress2, Component2, resolvedProps, renderLanes2);
          }
          case ClassComponent: {
            var _Component2 = workInProgress2.type;
            var _unresolvedProps = workInProgress2.pendingProps;
            var _resolvedProps = workInProgress2.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
            return updateClassComponent(current2, workInProgress2, _Component2, _resolvedProps, renderLanes2);
          }
          case HostRoot:
            return updateHostRoot(current2, workInProgress2, renderLanes2);
          case HostComponent:
            return updateHostComponent$1(current2, workInProgress2, renderLanes2);
          case HostText:
            return updateHostText$1(current2, workInProgress2);
          case SuspenseComponent:
            return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
          case HostPortal:
            return updatePortalComponent(current2, workInProgress2, renderLanes2);
          case ForwardRef: {
            var type = workInProgress2.type;
            var _unresolvedProps2 = workInProgress2.pendingProps;
            var _resolvedProps2 = workInProgress2.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
            return updateForwardRef(current2, workInProgress2, type, _resolvedProps2, renderLanes2);
          }
          case Fragment2:
            return updateFragment(current2, workInProgress2, renderLanes2);
          case Mode:
            return updateMode(current2, workInProgress2, renderLanes2);
          case Profiler:
            return updateProfiler(current2, workInProgress2, renderLanes2);
          case ContextProvider:
            return updateContextProvider(current2, workInProgress2, renderLanes2);
          case ContextConsumer:
            return updateContextConsumer(current2, workInProgress2, renderLanes2);
          case MemoComponent: {
            var _type2 = workInProgress2.type;
            var _unresolvedProps3 = workInProgress2.pendingProps;
            var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
            {
              if (workInProgress2.type !== workInProgress2.elementType) {
                var outerPropTypes = _type2.propTypes;
                if (outerPropTypes) {
                  checkPropTypes(
                    outerPropTypes,
                    _resolvedProps3,
                    // Resolved for outer only
                    "prop",
                    getComponentNameFromType(_type2)
                  );
                }
              }
            }
            _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
            return updateMemoComponent(current2, workInProgress2, _type2, _resolvedProps3, renderLanes2);
          }
          case SimpleMemoComponent: {
            return updateSimpleMemoComponent(current2, workInProgress2, workInProgress2.type, workInProgress2.pendingProps, renderLanes2);
          }
          case IncompleteClassComponent: {
            var _Component22 = workInProgress2.type;
            var _unresolvedProps4 = workInProgress2.pendingProps;
            var _resolvedProps4 = workInProgress2.elementType === _Component22 ? _unresolvedProps4 : resolveDefaultProps(_Component22, _unresolvedProps4);
            return mountIncompleteClassComponent(current2, workInProgress2, _Component22, _resolvedProps4, renderLanes2);
          }
          case SuspenseListComponent: {
            return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
          }
          case ScopeComponent: {
            break;
          }
          case OffscreenComponent: {
            return updateOffscreenComponent(current2, workInProgress2, renderLanes2);
          }
        }
        throw new Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      function unwindWork(current2, workInProgress2, renderLanes2) {
        popTreeContext(workInProgress2);
        switch (workInProgress2.tag) {
          case ClassComponent: {
            var Component2 = workInProgress2.type;
            if (isContextProvider(Component2)) {
              popContext(workInProgress2);
            }
            var flags2 = workInProgress2.flags;
            if (flags2 & ShouldCapture) {
              workInProgress2.flags = flags2 & ~ShouldCapture | DidCapture;
              if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                transferActualDuration(workInProgress2);
              }
              return workInProgress2;
            }
            return null;
          }
          case HostRoot: {
            popHostContainer(workInProgress2);
            popTopLevelContextObject(workInProgress2);
            resetWorkInProgressVersions();
            var _flags = workInProgress2.flags;
            if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
              workInProgress2.flags = _flags & ~ShouldCapture | DidCapture;
              return workInProgress2;
            }
            return null;
          }
          case HostComponent: {
            popHostContext(workInProgress2);
            return null;
          }
          case SuspenseComponent: {
            popSuspenseContext(workInProgress2);
            {
              var suspenseState = workInProgress2.memoizedState;
              if (suspenseState !== null && suspenseState.dehydrated !== null) {
                if (workInProgress2.alternate === null) {
                  throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                }
                resetHydrationState();
              }
            }
            var _flags2 = workInProgress2.flags;
            if (_flags2 & ShouldCapture) {
              workInProgress2.flags = _flags2 & ~ShouldCapture | DidCapture;
              if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                transferActualDuration(workInProgress2);
              }
              return workInProgress2;
            }
            return null;
          }
          case SuspenseListComponent: {
            popSuspenseContext(workInProgress2);
            return null;
          }
          case HostPortal:
            popHostContainer(workInProgress2);
            return null;
          case ContextProvider:
            var context2 = workInProgress2.type._context;
            popProvider(context2, workInProgress2);
            return null;
          case OffscreenComponent:
          case LegacyHiddenComponent:
            popRenderLanes(workInProgress2);
            return null;
          case CacheComponent:
            return null;
          default:
            return null;
        }
      }
      function unwindInterruptedWork(current2, interruptedWork, renderLanes2) {
        popTreeContext(interruptedWork);
        switch (interruptedWork.tag) {
          case ClassComponent: {
            var childContextTypes = interruptedWork.type.childContextTypes;
            if (childContextTypes !== null && childContextTypes !== void 0) {
              popContext(interruptedWork);
            }
            break;
          }
          case HostRoot: {
            popHostContainer(interruptedWork);
            popTopLevelContextObject(interruptedWork);
            resetWorkInProgressVersions();
            break;
          }
          case HostComponent: {
            popHostContext(interruptedWork);
            break;
          }
          case HostPortal:
            popHostContainer(interruptedWork);
            break;
          case SuspenseComponent:
            popSuspenseContext(interruptedWork);
            break;
          case SuspenseListComponent:
            popSuspenseContext(interruptedWork);
            break;
          case ContextProvider:
            var context2 = interruptedWork.type._context;
            popProvider(context2, interruptedWork);
            break;
          case OffscreenComponent:
          case LegacyHiddenComponent:
            popRenderLanes(interruptedWork);
            break;
        }
      }
      function invokeGuardedCallbackProd(name2, func2, context2, a2, b2, c2, d2, e3, f2) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
          func2.apply(context2, funcArgs);
        } catch (error3) {
          this.onError(error3);
        }
      }
      var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
      {
        if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
          var fakeNode = document.createElement("react");
          invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name2, func2, context2, a2, b2, c2, d2, e3, f2) {
            if (typeof document === "undefined" || document === null) {
              throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            }
            var evt = document.createEvent("Event");
            var didCall = false;
            var didError = true;
            var windowEvent = window.event;
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
              fakeNode.removeEventListener(evtType, callCallback2, false);
              if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) {
                window.event = windowEvent;
              }
            }
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback2() {
              didCall = true;
              restoreAfterDispatch();
              func2.apply(context2, funcArgs);
              didError = false;
            }
            var error3;
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
              error3 = event.error;
              didSetError = true;
              if (error3 === null && event.colno === 0 && event.lineno === 0) {
                isCrossOriginError = true;
              }
              if (event.defaultPrevented) {
                if (error3 != null && typeof error3 === "object") {
                  try {
                    error3._suppressLogging = true;
                  } catch (inner) {
                  }
                }
              }
            }
            var evtType = "react-" + (name2 ? name2 : "invokeguardedcallback");
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback2, false);
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) {
              Object.defineProperty(window, "event", windowEventDescriptor);
            }
            if (didCall && didError) {
              if (!didSetError) {
                error3 = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`);
              } else if (isCrossOriginError) {
                error3 = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
              }
              this.onError(error3);
            }
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
              restoreAfterDispatch();
              return invokeGuardedCallbackProd.apply(this, arguments);
            }
          };
        }
      }
      var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
      var hasError = false;
      var caughtError = null;
      var reporter = {
        onError: function(error3) {
          hasError = true;
          caughtError = error3;
        }
      };
      function invokeGuardedCallback(name2, func2, context2, a2, b2, c2, d2, e3, f2) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
      }
      function hasCaughtError() {
        return hasError;
      }
      function clearCaughtError() {
        if (hasError) {
          var error3 = caughtError;
          hasError = false;
          caughtError = null;
          return error3;
        } else {
          throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
      {
        didWarnAboutUndefinedSnapshotBeforeUpdate = /* @__PURE__ */ new Set();
      }
      var offscreenSubtreeIsHidden = false;
      var offscreenSubtreeWasHidden = false;
      var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
      var nextEffect = null;
      var inProgressLanes = null;
      var inProgressRoot = null;
      function reportUncaughtErrorInDEV(error3) {
        {
          invokeGuardedCallback(null, function() {
            throw error3;
          });
          clearCaughtError();
        }
      }
      var callComponentWillUnmountWithTimer = function(current2, instance2) {
        instance2.props = current2.memoizedProps;
        instance2.state = current2.memoizedState;
        if (current2.mode & ProfileMode) {
          try {
            startLayoutEffectTimer();
            instance2.componentWillUnmount();
          } finally {
            recordLayoutEffectDuration(current2);
          }
        } else {
          instance2.componentWillUnmount();
        }
      };
      function safelyCallCommitHookLayoutEffectListMount(current2, nearestMountedAncestor) {
        try {
          commitHookEffectListMount(Layout2, current2);
        } catch (error3) {
          reportUncaughtErrorInDEV(error3);
          captureCommitPhaseError(current2, nearestMountedAncestor, error3);
        }
      }
      function safelyCallComponentWillUnmount(current2, nearestMountedAncestor, instance2) {
        try {
          callComponentWillUnmountWithTimer(current2, instance2);
        } catch (error3) {
          reportUncaughtErrorInDEV(error3);
          captureCommitPhaseError(current2, nearestMountedAncestor, error3);
        }
      }
      function safelyCallComponentDidMount(current2, nearestMountedAncestor, instance2) {
        try {
          instance2.componentDidMount();
        } catch (error3) {
          reportUncaughtErrorInDEV(error3);
          captureCommitPhaseError(current2, nearestMountedAncestor, error3);
        }
      }
      function safelyAttachRef(current2, nearestMountedAncestor) {
        try {
          commitAttachRef(current2);
        } catch (error3) {
          reportUncaughtErrorInDEV(error3);
          captureCommitPhaseError(current2, nearestMountedAncestor, error3);
        }
      }
      function safelyDetachRef(current2, nearestMountedAncestor) {
        var ref = current2.ref;
        if (ref !== null) {
          if (typeof ref === "function") {
            var retVal;
            try {
              if (enableProfilerTimer && enableProfilerCommitHooks && current2.mode & ProfileMode) {
                try {
                  startLayoutEffectTimer();
                  retVal = ref(null);
                } finally {
                  recordLayoutEffectDuration(current2);
                }
              } else {
                retVal = ref(null);
              }
            } catch (error3) {
              reportUncaughtErrorInDEV(error3);
              captureCommitPhaseError(current2, nearestMountedAncestor, error3);
            }
            {
              if (typeof retVal === "function") {
                error2("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current2));
              }
            }
          } else {
            ref.current = null;
          }
        }
      }
      function safelyCallDestroy(current2, nearestMountedAncestor, destroy2) {
        try {
          destroy2();
        } catch (error3) {
          reportUncaughtErrorInDEV(error3);
          captureCommitPhaseError(current2, nearestMountedAncestor, error3);
        }
      }
      var shouldFireAfterActiveInstanceBlur = false;
      function commitBeforeMutationEffects(root2, firstChild) {
        prepareForCommit(root2.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin();
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        return shouldFire;
      }
      function commitBeforeMutationEffects_begin() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var child = fiber.child;
          if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
            ensureCorrectReturnPointer(child, fiber);
            nextEffect = child;
          } else {
            commitBeforeMutationEffects_complete();
          }
        }
      }
      function commitBeforeMutationEffects_complete() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);
          try {
            commitBeforeMutationEffectsOnFiber(fiber);
          } catch (error3) {
            reportUncaughtErrorInDEV(error3);
            captureCommitPhaseError(fiber, fiber.return, error3);
          }
          resetCurrentFiber();
          var sibling = fiber.sibling;
          if (sibling !== null) {
            ensureCorrectReturnPointer(sibling, fiber.return);
            nextEffect = sibling;
            return;
          }
          nextEffect = fiber.return;
        }
      }
      function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current2 = finishedWork.alternate;
        var flags2 = finishedWork.flags;
        if ((flags2 & Snapshot) !== NoFlags) {
          setCurrentFiber(finishedWork);
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent: {
              break;
            }
            case ClassComponent: {
              if (current2 !== null) {
                var prevProps = current2.memoizedProps;
                var prevState = current2.memoizedState;
                var instance2 = finishedWork.stateNode;
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance2.props !== finishedWork.memoizedProps) {
                      error2("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    if (instance2.state !== finishedWork.memoizedState) {
                      error2("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                  }
                }
                var snapshot = instance2.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                {
                  var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                  if (snapshot === void 0 && !didWarnSet.has(finishedWork.type)) {
                    didWarnSet.add(finishedWork.type);
                    error2("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                  }
                }
                instance2.__reactInternalSnapshotBeforeUpdate = snapshot;
              }
              break;
            }
            case HostRoot: {
              if (supportsMutation) {
                var root2 = finishedWork.stateNode;
                clearContainer(root2.containerInfo);
              }
              break;
            }
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
              break;
            default: {
              throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          resetCurrentFiber();
        }
      }
      function commitHookEffectListUnmount(flags2, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & flags2) === flags2) {
              var destroy2 = effect.destroy;
              effect.destroy = void 0;
              if (destroy2 !== void 0) {
                {
                  if ((flags2 & Passive$1) !== NoFlags$1) {
                    markComponentPassiveEffectUnmountStarted(finishedWork);
                  } else if ((flags2 & Layout2) !== NoFlags$1) {
                    markComponentLayoutEffectUnmountStarted(finishedWork);
                  }
                }
                safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy2);
                {
                  if ((flags2 & Passive$1) !== NoFlags$1) {
                    markComponentPassiveEffectUnmountStopped();
                  } else if ((flags2 & Layout2) !== NoFlags$1) {
                    markComponentLayoutEffectUnmountStopped();
                  }
                }
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitHookEffectListMount(flags2, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
          var firstEffect = lastEffect.next;
          var effect = firstEffect;
          do {
            if ((effect.tag & flags2) === flags2) {
              {
                if ((flags2 & Passive$1) !== NoFlags$1) {
                  markComponentPassiveEffectMountStarted(finishedWork);
                } else if ((flags2 & Layout2) !== NoFlags$1) {
                  markComponentLayoutEffectMountStarted(finishedWork);
                }
              }
              var create5 = effect.create;
              effect.destroy = create5();
              {
                if ((flags2 & Passive$1) !== NoFlags$1) {
                  markComponentPassiveEffectMountStopped();
                } else if ((flags2 & Layout2) !== NoFlags$1) {
                  markComponentLayoutEffectMountStopped();
                }
              }
              {
                var destroy2 = effect.destroy;
                if (destroy2 !== void 0 && typeof destroy2 !== "function") {
                  var hookName = void 0;
                  if ((effect.tag & Layout2) !== NoFlags) {
                    hookName = "useLayoutEffect";
                  } else if ((effect.tag & Insertion) !== NoFlags) {
                    hookName = "useInsertionEffect";
                  } else {
                    hookName = "useEffect";
                  }
                  var addendum = void 0;
                  if (destroy2 === null) {
                    addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                  } else if (typeof destroy2.then === "function") {
                    addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                  } else {
                    addendum = " You returned: " + destroy2;
                  }
                  error2("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                }
              }
            }
            effect = effect.next;
          } while (effect !== firstEffect);
        }
      }
      function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        {
          if ((finishedWork.flags & Update) !== NoFlags) {
            switch (finishedWork.tag) {
              case Profiler: {
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit;
                var commitTime2 = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                {
                  if (isCurrentUpdateNested()) {
                    phase = "nested-update";
                  }
                }
                if (typeof onPostCommit === "function") {
                  onPostCommit(id, phase, passiveEffectDuration, commitTime2);
                }
                var parentFiber = finishedWork.return;
                outer:
                  while (parentFiber !== null) {
                    switch (parentFiber.tag) {
                      case HostRoot:
                        var root2 = parentFiber.stateNode;
                        root2.passiveEffectDuration += passiveEffectDuration;
                        break outer;
                      case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.passiveEffectDuration += passiveEffectDuration;
                        break outer;
                    }
                    parentFiber = parentFiber.return;
                  }
                break;
              }
            }
          }
        }
      }
      function commitLayoutEffectOnFiber(finishedRoot, current2, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent: {
              if (!offscreenSubtreeWasHidden) {
                if (finishedWork.mode & ProfileMode) {
                  try {
                    startLayoutEffectTimer();
                    commitHookEffectListMount(Layout2 | HasEffect, finishedWork);
                  } finally {
                    recordLayoutEffectDuration(finishedWork);
                  }
                } else {
                  commitHookEffectListMount(Layout2 | HasEffect, finishedWork);
                }
              }
              break;
            }
            case ClassComponent: {
              var instance2 = finishedWork.stateNode;
              if (finishedWork.flags & Update) {
                if (!offscreenSubtreeWasHidden) {
                  if (current2 === null) {
                    {
                      if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance2.props !== finishedWork.memoizedProps) {
                          error2("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        if (instance2.state !== finishedWork.memoizedState) {
                          error2("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                      }
                    }
                    if (finishedWork.mode & ProfileMode) {
                      try {
                        startLayoutEffectTimer();
                        instance2.componentDidMount();
                      } finally {
                        recordLayoutEffectDuration(finishedWork);
                      }
                    } else {
                      instance2.componentDidMount();
                    }
                  } else {
                    var prevProps = finishedWork.elementType === finishedWork.type ? current2.memoizedProps : resolveDefaultProps(finishedWork.type, current2.memoizedProps);
                    var prevState = current2.memoizedState;
                    {
                      if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance2.props !== finishedWork.memoizedProps) {
                          error2("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        if (instance2.state !== finishedWork.memoizedState) {
                          error2("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                      }
                    }
                    if (finishedWork.mode & ProfileMode) {
                      try {
                        startLayoutEffectTimer();
                        instance2.componentDidUpdate(prevProps, prevState, instance2.__reactInternalSnapshotBeforeUpdate);
                      } finally {
                        recordLayoutEffectDuration(finishedWork);
                      }
                    } else {
                      instance2.componentDidUpdate(prevProps, prevState, instance2.__reactInternalSnapshotBeforeUpdate);
                    }
                  }
                }
              }
              var updateQueue = finishedWork.updateQueue;
              if (updateQueue !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance2.props !== finishedWork.memoizedProps) {
                      error2("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    if (instance2.state !== finishedWork.memoizedState) {
                      error2("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                  }
                }
                commitUpdateQueue(finishedWork, updateQueue, instance2);
              }
              break;
            }
            case HostRoot: {
              var _updateQueue = finishedWork.updateQueue;
              if (_updateQueue !== null) {
                var _instance = null;
                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;
                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }
                commitUpdateQueue(finishedWork, _updateQueue, _instance);
              }
              break;
            }
            case HostComponent: {
              var _instance2 = finishedWork.stateNode;
              if (current2 === null && finishedWork.flags & Update) {
                var type = finishedWork.type;
                var props = finishedWork.memoizedProps;
                commitMount(_instance2, type, props, finishedWork);
              }
              break;
            }
            case HostText: {
              break;
            }
            case HostPortal: {
              break;
            }
            case Profiler: {
              {
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime2 = getCommitTime();
                var phase = current2 === null ? "mount" : "update";
                {
                  if (isCurrentUpdateNested()) {
                    phase = "nested-update";
                  }
                }
                if (typeof onRender === "function") {
                  onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime2);
                }
                {
                  if (typeof onCommit === "function") {
                    onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime2);
                  }
                  enqueuePendingPassiveProfilerEffect(finishedWork);
                  var parentFiber = finishedWork.return;
                  outer:
                    while (parentFiber !== null) {
                      switch (parentFiber.tag) {
                        case HostRoot:
                          var root2 = parentFiber.stateNode;
                          root2.effectDuration += effectDuration;
                          break outer;
                        case Profiler:
                          var parentStateNode = parentFiber.stateNode;
                          parentStateNode.effectDuration += effectDuration;
                          break outer;
                      }
                      parentFiber = parentFiber.return;
                    }
                }
              }
              break;
            }
            case SuspenseComponent: {
              commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
              break;
            }
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent: {
              break;
            }
            default:
              throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        }
        if (!offscreenSubtreeWasHidden) {
          {
            if (finishedWork.flags & Ref) {
              commitAttachRef(finishedWork);
            }
          }
        }
      }
      function reappearLayoutEffectsOnFiber(node) {
        switch (node.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent: {
            if (node.mode & ProfileMode) {
              try {
                startLayoutEffectTimer();
                safelyCallCommitHookLayoutEffectListMount(node, node.return);
              } finally {
                recordLayoutEffectDuration(node);
              }
            } else {
              safelyCallCommitHookLayoutEffectListMount(node, node.return);
            }
            break;
          }
          case ClassComponent: {
            var instance2 = node.stateNode;
            if (typeof instance2.componentDidMount === "function") {
              safelyCallComponentDidMount(node, node.return, instance2);
            }
            safelyAttachRef(node, node.return);
            break;
          }
          case HostComponent: {
            safelyAttachRef(node, node.return);
            break;
          }
        }
      }
      function hideOrUnhideAllChildren(finishedWork, isHidden2) {
        var hostSubtreeRoot = null;
        if (supportsMutation) {
          var node = finishedWork;
          while (true) {
            if (node.tag === HostComponent) {
              if (hostSubtreeRoot === null) {
                hostSubtreeRoot = node;
                var instance2 = node.stateNode;
                if (isHidden2) {
                  hideInstance(instance2);
                } else {
                  unhideInstance(node.stateNode, node.memoizedProps);
                }
              }
            } else if (node.tag === HostText) {
              if (hostSubtreeRoot === null) {
                var _instance3 = node.stateNode;
                if (isHidden2) {
                  hideTextInstance(_instance3);
                } else {
                  unhideTextInstance(_instance3, node.memoizedProps);
                }
              }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork)
              ;
            else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === finishedWork) {
              return;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === finishedWork) {
                return;
              }
              if (hostSubtreeRoot === node) {
                hostSubtreeRoot = null;
              }
              node = node.return;
            }
            if (hostSubtreeRoot === node) {
              hostSubtreeRoot = null;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
      }
      function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
          var instance2 = finishedWork.stateNode;
          var instanceToUse;
          switch (finishedWork.tag) {
            case HostComponent:
              instanceToUse = getPublicInstance(instance2);
              break;
            default:
              instanceToUse = instance2;
          }
          if (typeof ref === "function") {
            var retVal;
            if (finishedWork.mode & ProfileMode) {
              try {
                startLayoutEffectTimer();
                retVal = ref(instanceToUse);
              } finally {
                recordLayoutEffectDuration(finishedWork);
              }
            } else {
              retVal = ref(instanceToUse);
            }
            {
              if (typeof retVal === "function") {
                error2("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
              }
            }
          } else {
            {
              if (!ref.hasOwnProperty("current")) {
                error2("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
              }
            }
            ref.current = instanceToUse;
          }
        }
      }
      function commitDetachRef(current2) {
        var currentRef = current2.ref;
        if (currentRef !== null) {
          if (typeof currentRef === "function") {
            if (current2.mode & ProfileMode) {
              try {
                startLayoutEffectTimer();
                currentRef(null);
              } finally {
                recordLayoutEffectDuration(current2);
              }
            } else {
              currentRef(null);
            }
          } else {
            currentRef.current = null;
          }
        }
      }
      function commitUnmount(finishedRoot, current2, nearestMountedAncestor) {
        onCommitUnmount(current2);
        switch (current2.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent: {
            var updateQueue = current2.updateQueue;
            if (updateQueue !== null) {
              var lastEffect = updateQueue.lastEffect;
              if (lastEffect !== null) {
                var firstEffect = lastEffect.next;
                var effect = firstEffect;
                do {
                  var _effect = effect, destroy2 = _effect.destroy, tag2 = _effect.tag;
                  if (destroy2 !== void 0) {
                    if ((tag2 & Insertion) !== NoFlags$1) {
                      safelyCallDestroy(current2, nearestMountedAncestor, destroy2);
                    } else if ((tag2 & Layout2) !== NoFlags$1) {
                      {
                        markComponentLayoutEffectUnmountStarted(current2);
                      }
                      if (current2.mode & ProfileMode) {
                        startLayoutEffectTimer();
                        safelyCallDestroy(current2, nearestMountedAncestor, destroy2);
                        recordLayoutEffectDuration(current2);
                      } else {
                        safelyCallDestroy(current2, nearestMountedAncestor, destroy2);
                      }
                      {
                        markComponentLayoutEffectUnmountStopped();
                      }
                    }
                  }
                  effect = effect.next;
                } while (effect !== firstEffect);
              }
            }
            return;
          }
          case ClassComponent: {
            safelyDetachRef(current2, nearestMountedAncestor);
            var instance2 = current2.stateNode;
            if (typeof instance2.componentWillUnmount === "function") {
              safelyCallComponentWillUnmount(current2, nearestMountedAncestor, instance2);
            }
            return;
          }
          case HostComponent: {
            safelyDetachRef(current2, nearestMountedAncestor);
            return;
          }
          case HostPortal: {
            if (supportsMutation) {
              unmountHostComponents(finishedRoot, current2, nearestMountedAncestor);
            } else if (supportsPersistence) {
              emptyPortalContainer(current2);
            }
            return;
          }
          case DehydratedFragment: {
            return;
          }
          case ScopeComponent: {
            return;
          }
        }
      }
      function commitNestedUnmounts(finishedRoot, root2, nearestMountedAncestor) {
        var node = root2;
        while (true) {
          commitUnmount(finishedRoot, node, nearestMountedAncestor);
          if (node.child !== null && // If we use mutation we drill down into portals using commitUnmount above.
          // If we don't use mutation we drill down into portals here instead.
          (!supportsMutation || node.tag !== HostPortal)) {
            node.child.return = node;
            node = node.child;
            continue;
          }
          if (node === root2) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === root2) {
              return;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function detachFiberMutation(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
          alternate.return = null;
        }
        fiber.return = null;
      }
      function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
          fiber.alternate = null;
          detachFiberAfterEffects(alternate);
        }
        {
          fiber.child = null;
          fiber.deletions = null;
          fiber.sibling = null;
          if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) {
              detachDeletedInstance(hostInstance);
            }
          }
          fiber.stateNode = null;
          {
            fiber._debugOwner = null;
          }
          {
            fiber.return = null;
            fiber.dependencies = null;
            fiber.memoizedProps = null;
            fiber.memoizedState = null;
            fiber.pendingProps = null;
            fiber.stateNode = null;
            fiber.updateQueue = null;
          }
        }
      }
      function emptyPortalContainer(current2) {
        if (!supportsPersistence) {
          return;
        }
        var portal = current2.stateNode;
        var containerInfo = portal.containerInfo;
        var emptyChildSet = createContainerChildSet(containerInfo);
        replaceContainerChildren(containerInfo, emptyChildSet);
      }
      function commitContainer(finishedWork) {
        if (!supportsPersistence) {
          return;
        }
        switch (finishedWork.tag) {
          case ClassComponent:
          case HostComponent:
          case HostText: {
            return;
          }
          case HostRoot:
          case HostPortal: {
            var portalOrRoot = finishedWork.stateNode;
            var containerInfo = portalOrRoot.containerInfo, pendingChildren = portalOrRoot.pendingChildren;
            replaceContainerChildren(containerInfo, pendingChildren);
            return;
          }
        }
        throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
      function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while (parent !== null) {
          if (isHostParent(parent)) {
            return parent;
          }
          parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
      }
      function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
      }
      function getHostSibling(fiber) {
        var node = fiber;
        siblings:
          while (true) {
            while (node.sibling === null) {
              if (node.return === null || isHostParent(node.return)) {
                return null;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while (node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment) {
              if (node.flags & Placement) {
                continue siblings;
              }
              if (node.child === null || node.tag === HostPortal) {
                continue siblings;
              } else {
                node.child.return = node;
                node = node.child;
              }
            }
            if (!(node.flags & Placement)) {
              return node.stateNode;
            }
          }
      }
      function commitPlacement(finishedWork) {
        if (!supportsMutation) {
          return;
        }
        var parentFiber = getHostParentFiber(finishedWork);
        switch (parentFiber.tag) {
          case HostComponent: {
            var parent = parentFiber.stateNode;
            if (parentFiber.flags & ContentReset) {
              resetTextContent(parent);
              parentFiber.flags &= ~ContentReset;
            }
            var before = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before, parent);
            break;
          }
          case HostRoot:
          case HostPortal: {
            var _parent = parentFiber.stateNode.containerInfo;
            var _before = getHostSibling(finishedWork);
            insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
            break;
          }
          default:
            throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag2 = node.tag;
        var isHost = tag2 === HostComponent || tag2 === HostText;
        if (isHost) {
          var stateNode = node.stateNode;
          if (before) {
            insertInContainerBefore(parent, stateNode, before);
          } else {
            appendChildToContainer(parent, stateNode);
          }
        } else if (tag2 === HostPortal)
          ;
        else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNodeIntoContainer(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function insertOrAppendPlacementNode(node, before, parent) {
        var tag2 = node.tag;
        var isHost = tag2 === HostComponent || tag2 === HostText;
        if (isHost) {
          var stateNode = node.stateNode;
          if (before) {
            insertBefore(parent, stateNode, before);
          } else {
            appendChild(parent, stateNode);
          }
        } else if (tag2 === HostPortal)
          ;
        else {
          var child = node.child;
          if (child !== null) {
            insertOrAppendPlacementNode(child, before, parent);
            var sibling = child.sibling;
            while (sibling !== null) {
              insertOrAppendPlacementNode(sibling, before, parent);
              sibling = sibling.sibling;
            }
          }
        }
      }
      function unmountHostComponents(finishedRoot, current2, nearestMountedAncestor) {
        var node = current2;
        var currentParentIsValid = false;
        var currentParent;
        var currentParentIsContainer;
        while (true) {
          if (!currentParentIsValid) {
            var parent = node.return;
            findParent:
              while (true) {
                if (parent === null) {
                  throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                }
                var parentStateNode = parent.stateNode;
                switch (parent.tag) {
                  case HostComponent:
                    currentParent = parentStateNode;
                    currentParentIsContainer = false;
                    break findParent;
                  case HostRoot:
                    currentParent = parentStateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;
                  case HostPortal:
                    currentParent = parentStateNode.containerInfo;
                    currentParentIsContainer = true;
                    break findParent;
                }
                parent = parent.return;
              }
            currentParentIsValid = true;
          }
          if (node.tag === HostComponent || node.tag === HostText) {
            commitNestedUnmounts(finishedRoot, node, nearestMountedAncestor);
            if (currentParentIsContainer) {
              removeChildFromContainer(currentParent, node.stateNode);
            } else {
              removeChild(currentParent, node.stateNode);
            }
          } else if (node.tag === DehydratedFragment) {
            if (currentParentIsContainer) {
              clearSuspenseBoundaryFromContainer(currentParent, node.stateNode);
            } else {
              clearSuspenseBoundary(currentParent, node.stateNode);
            }
          } else if (node.tag === HostPortal) {
            if (node.child !== null) {
              currentParent = node.stateNode.containerInfo;
              currentParentIsContainer = true;
              node.child.return = node;
              node = node.child;
              continue;
            }
          } else {
            commitUnmount(finishedRoot, node, nearestMountedAncestor);
            if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
          }
          if (node === current2) {
            return;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === current2) {
              return;
            }
            node = node.return;
            if (node.tag === HostPortal) {
              currentParentIsValid = false;
            }
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      function commitDeletion(finishedRoot, current2, nearestMountedAncestor) {
        if (supportsMutation) {
          unmountHostComponents(finishedRoot, current2, nearestMountedAncestor);
        } else {
          commitNestedUnmounts(finishedRoot, current2, nearestMountedAncestor);
        }
        detachFiberMutation(current2);
      }
      function commitWork(current2, finishedWork) {
        if (!supportsMutation) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent: {
              commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
              commitHookEffectListMount(Insertion | HasEffect, finishedWork);
              if (finishedWork.mode & ProfileMode) {
                try {
                  startLayoutEffectTimer();
                  commitHookEffectListUnmount(Layout2 | HasEffect, finishedWork, finishedWork.return);
                } finally {
                  recordLayoutEffectDuration(finishedWork);
                }
              } else {
                commitHookEffectListUnmount(Layout2 | HasEffect, finishedWork, finishedWork.return);
              }
              return;
            }
            case Profiler: {
              return;
            }
            case SuspenseComponent: {
              commitSuspenseCallback(finishedWork);
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case SuspenseListComponent: {
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case HostRoot: {
              if (supportsHydration) {
                if (current2 !== null) {
                  var prevRootState = current2.memoizedState;
                  if (prevRootState.isDehydrated) {
                    var root2 = finishedWork.stateNode;
                    commitHydratedContainer(root2.containerInfo);
                  }
                }
              }
              break;
            }
            case OffscreenComponent:
            case LegacyHiddenComponent: {
              return;
            }
          }
          commitContainer(finishedWork);
          return;
        }
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case MemoComponent:
          case SimpleMemoComponent: {
            commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
            commitHookEffectListMount(Insertion | HasEffect, finishedWork);
            if (finishedWork.mode & ProfileMode) {
              try {
                startLayoutEffectTimer();
                commitHookEffectListUnmount(Layout2 | HasEffect, finishedWork, finishedWork.return);
              } finally {
                recordLayoutEffectDuration(finishedWork);
              }
            } else {
              commitHookEffectListUnmount(Layout2 | HasEffect, finishedWork, finishedWork.return);
            }
            return;
          }
          case ClassComponent: {
            return;
          }
          case HostComponent: {
            var instance2 = finishedWork.stateNode;
            if (instance2 != null) {
              var newProps = finishedWork.memoizedProps;
              var oldProps = current2 !== null ? current2.memoizedProps : newProps;
              var type = finishedWork.type;
              var updatePayload = finishedWork.updateQueue;
              finishedWork.updateQueue = null;
              if (updatePayload !== null) {
                commitUpdate(instance2, updatePayload, type, oldProps, newProps, finishedWork);
              }
            }
            return;
          }
          case HostText: {
            if (finishedWork.stateNode === null) {
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            }
            var textInstance = finishedWork.stateNode;
            var newText = finishedWork.memoizedProps;
            var oldText = current2 !== null ? current2.memoizedProps : newText;
            commitTextUpdate(textInstance, oldText, newText);
            return;
          }
          case HostRoot: {
            if (supportsHydration) {
              if (current2 !== null) {
                var _prevRootState = current2.memoizedState;
                if (_prevRootState.isDehydrated) {
                  var _root2 = finishedWork.stateNode;
                  commitHydratedContainer(_root2.containerInfo);
                }
              }
            }
            return;
          }
          case Profiler: {
            return;
          }
          case SuspenseComponent: {
            commitSuspenseCallback(finishedWork);
            attachSuspenseRetryListeners(finishedWork);
            return;
          }
          case SuspenseListComponent: {
            attachSuspenseRetryListeners(finishedWork);
            return;
          }
          case IncompleteClassComponent: {
            return;
          }
        }
        throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
      }
      function commitSuspenseCallback(finishedWork) {
        finishedWork.memoizedState;
      }
      function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (!supportsHydration) {
          return;
        }
        var newState = finishedWork.memoizedState;
        if (newState === null) {
          var current2 = finishedWork.alternate;
          if (current2 !== null) {
            var prevState = current2.memoizedState;
            if (prevState !== null) {
              var suspenseInstance = prevState.dehydrated;
              if (suspenseInstance !== null) {
                commitHydratedSuspenseInstance(suspenseInstance);
              }
            }
          }
        }
      }
      function attachSuspenseRetryListeners(finishedWork) {
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
          finishedWork.updateQueue = null;
          var retryCache = finishedWork.stateNode;
          if (retryCache === null) {
            retryCache = finishedWork.stateNode = new PossiblyWeakSet();
          }
          wakeables.forEach(function(wakeable) {
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
            if (!retryCache.has(wakeable)) {
              retryCache.add(wakeable);
              {
                if (isDevToolsPresent) {
                  if (inProgressLanes !== null && inProgressRoot !== null) {
                    restorePendingUpdaters(inProgressRoot, inProgressLanes);
                  } else {
                    throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                  }
                }
              }
              wakeable.then(retry, retry);
            }
          });
        }
      }
      function commitResetTextContent(current2) {
        if (!supportsMutation) {
          return;
        }
        resetTextContent(current2.stateNode);
      }
      function commitMutationEffects(root2, firstChild, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root2;
        nextEffect = firstChild;
        commitMutationEffects_begin(root2, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
      }
      function commitMutationEffects_begin(root2, lanes) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var deletions = fiber.deletions;
          if (deletions !== null) {
            for (var i2 = 0; i2 < deletions.length; i2++) {
              var childToDelete = deletions[i2];
              try {
                commitDeletion(root2, childToDelete, fiber);
              } catch (error3) {
                reportUncaughtErrorInDEV(error3);
                captureCommitPhaseError(childToDelete, fiber, error3);
              }
            }
          }
          var child = fiber.child;
          if ((fiber.subtreeFlags & MutationMask) !== NoFlags && child !== null) {
            ensureCorrectReturnPointer(child, fiber);
            nextEffect = child;
          } else {
            commitMutationEffects_complete(root2, lanes);
          }
        }
      }
      function commitMutationEffects_complete(root2, lanes) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);
          try {
            commitMutationEffectsOnFiber(fiber, root2, lanes);
          } catch (error3) {
            reportUncaughtErrorInDEV(error3);
            captureCommitPhaseError(fiber, fiber.return, error3);
          }
          resetCurrentFiber();
          var sibling = fiber.sibling;
          if (sibling !== null) {
            ensureCorrectReturnPointer(sibling, fiber.return);
            nextEffect = sibling;
            return;
          }
          nextEffect = fiber.return;
        }
      }
      function commitMutationEffectsOnFiber(finishedWork, root2, lanes) {
        var flags2 = finishedWork.flags;
        if (flags2 & ContentReset) {
          commitResetTextContent(finishedWork);
        }
        if (flags2 & Ref) {
          var current2 = finishedWork.alternate;
          if (current2 !== null) {
            commitDetachRef(current2);
          }
        }
        if (flags2 & Visibility) {
          switch (finishedWork.tag) {
            case SuspenseComponent: {
              var newState = finishedWork.memoizedState;
              var isHidden2 = newState !== null;
              if (isHidden2) {
                var _current = finishedWork.alternate;
                var wasHidden = _current !== null && _current.memoizedState !== null;
                if (!wasHidden) {
                  markCommitTimeOfFallback();
                }
              }
              break;
            }
            case OffscreenComponent: {
              var _newState = finishedWork.memoizedState;
              var _isHidden = _newState !== null;
              var _current2 = finishedWork.alternate;
              var _wasHidden = _current2 !== null && _current2.memoizedState !== null;
              var offscreenBoundary = finishedWork;
              if (supportsMutation) {
                hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
              }
              {
                if (_isHidden) {
                  if (!_wasHidden) {
                    if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                      nextEffect = offscreenBoundary;
                      var offscreenChild = offscreenBoundary.child;
                      while (offscreenChild !== null) {
                        nextEffect = offscreenChild;
                        disappearLayoutEffects_begin(offscreenChild);
                        offscreenChild = offscreenChild.sibling;
                      }
                    }
                  }
                }
                break;
              }
            }
          }
        }
        var primaryFlags = flags2 & (Placement | Update | Hydrating);
        switch (primaryFlags) {
          case Placement: {
            commitPlacement(finishedWork);
            finishedWork.flags &= ~Placement;
            break;
          }
          case PlacementAndUpdate: {
            commitPlacement(finishedWork);
            finishedWork.flags &= ~Placement;
            var _current3 = finishedWork.alternate;
            commitWork(_current3, finishedWork);
            break;
          }
          case Hydrating: {
            finishedWork.flags &= ~Hydrating;
            break;
          }
          case HydratingAndUpdate: {
            finishedWork.flags &= ~Hydrating;
            var _current4 = finishedWork.alternate;
            commitWork(_current4, finishedWork);
            break;
          }
          case Update: {
            var _current5 = finishedWork.alternate;
            commitWork(_current5, finishedWork);
            break;
          }
        }
      }
      function commitLayoutEffects(finishedWork, root2, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root2;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root2, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
      }
      function commitLayoutEffects_begin(subtreeRoot, root2, committedLanes) {
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;
          if (fiber.tag === OffscreenComponent && isModernRoot) {
            var isHidden2 = fiber.memoizedState !== null;
            var newOffscreenSubtreeIsHidden = isHidden2 || offscreenSubtreeIsHidden;
            if (newOffscreenSubtreeIsHidden) {
              commitLayoutMountEffects_complete(subtreeRoot, root2, committedLanes);
              continue;
            } else {
              var current2 = fiber.alternate;
              var wasHidden = current2 !== null && current2.memoizedState !== null;
              var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
              var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
              var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
              offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
              offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
              if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                nextEffect = fiber;
                reappearLayoutEffects_begin(fiber);
              }
              var child = firstChild;
              while (child !== null) {
                nextEffect = child;
                commitLayoutEffects_begin(
                  child,
                  // New root; bubble back up to here and stop.
                  root2,
                  committedLanes
                );
                child = child.sibling;
              }
              nextEffect = fiber;
              offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
              offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
              commitLayoutMountEffects_complete(subtreeRoot, root2, committedLanes);
              continue;
            }
          }
          if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
            ensureCorrectReturnPointer(firstChild, fiber);
            nextEffect = firstChild;
          } else {
            commitLayoutMountEffects_complete(subtreeRoot, root2, committedLanes);
          }
        }
      }
      function commitLayoutMountEffects_complete(subtreeRoot, root2, committedLanes) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          if ((fiber.flags & LayoutMask) !== NoFlags) {
            var current2 = fiber.alternate;
            setCurrentFiber(fiber);
            try {
              commitLayoutEffectOnFiber(root2, current2, fiber, committedLanes);
            } catch (error3) {
              reportUncaughtErrorInDEV(error3);
              captureCommitPhaseError(fiber, fiber.return, error3);
            }
            resetCurrentFiber();
          }
          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }
          var sibling = fiber.sibling;
          if (sibling !== null) {
            ensureCorrectReturnPointer(sibling, fiber.return);
            nextEffect = sibling;
            return;
          }
          nextEffect = fiber.return;
        }
      }
      function disappearLayoutEffects_begin(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent: {
              if (fiber.mode & ProfileMode) {
                try {
                  startLayoutEffectTimer();
                  commitHookEffectListUnmount(Layout2, fiber, fiber.return);
                } finally {
                  recordLayoutEffectDuration(fiber);
                }
              } else {
                commitHookEffectListUnmount(Layout2, fiber, fiber.return);
              }
              break;
            }
            case ClassComponent: {
              safelyDetachRef(fiber, fiber.return);
              var instance2 = fiber.stateNode;
              if (typeof instance2.componentWillUnmount === "function") {
                safelyCallComponentWillUnmount(fiber, fiber.return, instance2);
              }
              break;
            }
            case HostComponent: {
              safelyDetachRef(fiber, fiber.return);
              break;
            }
            case OffscreenComponent: {
              var isHidden2 = fiber.memoizedState !== null;
              if (isHidden2) {
                disappearLayoutEffects_complete(subtreeRoot);
                continue;
              }
              break;
            }
          }
          if (firstChild !== null) {
            firstChild.return = fiber;
            nextEffect = firstChild;
          } else {
            disappearLayoutEffects_complete(subtreeRoot);
          }
        }
      }
      function disappearLayoutEffects_complete(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }
          var sibling = fiber.sibling;
          if (sibling !== null) {
            sibling.return = fiber.return;
            nextEffect = sibling;
            return;
          }
          nextEffect = fiber.return;
        }
      }
      function reappearLayoutEffects_begin(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;
          if (fiber.tag === OffscreenComponent) {
            var isHidden2 = fiber.memoizedState !== null;
            if (isHidden2) {
              reappearLayoutEffects_complete(subtreeRoot);
              continue;
            }
          }
          if (firstChild !== null) {
            firstChild.return = fiber;
            nextEffect = firstChild;
          } else {
            reappearLayoutEffects_complete(subtreeRoot);
          }
        }
      }
      function reappearLayoutEffects_complete(subtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);
          try {
            reappearLayoutEffectsOnFiber(fiber);
          } catch (error3) {
            reportUncaughtErrorInDEV(error3);
            captureCommitPhaseError(fiber, fiber.return, error3);
          }
          resetCurrentFiber();
          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }
          var sibling = fiber.sibling;
          if (sibling !== null) {
            sibling.return = fiber.return;
            nextEffect = sibling;
            return;
          }
          nextEffect = fiber.return;
        }
      }
      function commitPassiveMountEffects(root2, finishedWork) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root2);
      }
      function commitPassiveMountEffects_begin(subtreeRoot, root2) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var firstChild = fiber.child;
          if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
            ensureCorrectReturnPointer(firstChild, fiber);
            nextEffect = firstChild;
          } else {
            commitPassiveMountEffects_complete(subtreeRoot, root2);
          }
        }
      }
      function commitPassiveMountEffects_complete(subtreeRoot, root2) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          if ((fiber.flags & Passive) !== NoFlags) {
            setCurrentFiber(fiber);
            try {
              commitPassiveMountOnFiber(root2, fiber);
            } catch (error3) {
              reportUncaughtErrorInDEV(error3);
              captureCommitPhaseError(fiber, fiber.return, error3);
            }
            resetCurrentFiber();
          }
          if (fiber === subtreeRoot) {
            nextEffect = null;
            return;
          }
          var sibling = fiber.sibling;
          if (sibling !== null) {
            ensureCorrectReturnPointer(sibling, fiber.return);
            nextEffect = sibling;
            return;
          }
          nextEffect = fiber.return;
        }
      }
      function commitPassiveMountOnFiber(finishedRoot, finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent: {
            if (finishedWork.mode & ProfileMode) {
              startPassiveEffectTimer();
              try {
                commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
              } finally {
                recordPassiveEffectDuration(finishedWork);
              }
            } else {
              commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
            }
            break;
          }
        }
      }
      function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
      }
      function commitPassiveUnmountEffects_begin() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var child = fiber.child;
          if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
            var deletions = fiber.deletions;
            if (deletions !== null) {
              for (var i2 = 0; i2 < deletions.length; i2++) {
                var fiberToDelete = deletions[i2];
                nextEffect = fiberToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
              }
              {
                var previousFiber = fiber.alternate;
                if (previousFiber !== null) {
                  var detachedChild = previousFiber.child;
                  if (detachedChild !== null) {
                    previousFiber.child = null;
                    do {
                      var detachedSibling = detachedChild.sibling;
                      detachedChild.sibling = null;
                      detachedChild = detachedSibling;
                    } while (detachedChild !== null);
                  }
                }
              }
              nextEffect = fiber;
            }
          }
          if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
            ensureCorrectReturnPointer(child, fiber);
            nextEffect = child;
          } else {
            commitPassiveUnmountEffects_complete();
          }
        }
      }
      function commitPassiveUnmountEffects_complete() {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          if ((fiber.flags & Passive) !== NoFlags) {
            setCurrentFiber(fiber);
            commitPassiveUnmountOnFiber(fiber);
            resetCurrentFiber();
          }
          var sibling = fiber.sibling;
          if (sibling !== null) {
            ensureCorrectReturnPointer(sibling, fiber.return);
            nextEffect = sibling;
            return;
          }
          nextEffect = fiber.return;
        }
      }
      function commitPassiveUnmountOnFiber(finishedWork) {
        switch (finishedWork.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent: {
            if (finishedWork.mode & ProfileMode) {
              startPassiveEffectTimer();
              commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
              recordPassiveEffectDuration(finishedWork);
            } else {
              commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
            }
            break;
          }
        }
      }
      function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          setCurrentFiber(fiber);
          commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
          resetCurrentFiber();
          var child = fiber.child;
          if (child !== null) {
            ensureCorrectReturnPointer(child, fiber);
            nextEffect = child;
          } else {
            commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
          }
        }
      }
      function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while (nextEffect !== null) {
          var fiber = nextEffect;
          var sibling = fiber.sibling;
          var returnFiber = fiber.return;
          {
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
              nextEffect = null;
              return;
            }
          }
          if (sibling !== null) {
            ensureCorrectReturnPointer(sibling, returnFiber);
            nextEffect = sibling;
            return;
          }
          nextEffect = returnFiber;
        }
      }
      function commitPassiveUnmountInsideDeletedTreeOnFiber(current2, nearestMountedAncestor) {
        switch (current2.tag) {
          case FunctionComponent:
          case ForwardRef:
          case SimpleMemoComponent: {
            if (current2.mode & ProfileMode) {
              startPassiveEffectTimer();
              commitHookEffectListUnmount(Passive$1, current2, nearestMountedAncestor);
              recordPassiveEffectDuration(current2);
            } else {
              commitHookEffectListUnmount(Passive$1, current2, nearestMountedAncestor);
            }
            break;
          }
        }
      }
      var didWarnWrongReturnPointer = false;
      function ensureCorrectReturnPointer(fiber, expectedReturnFiber) {
        {
          if (!didWarnWrongReturnPointer && fiber.return !== expectedReturnFiber) {
            didWarnWrongReturnPointer = true;
            error2("Internal React error: Return pointer is inconsistent with parent.");
          }
        }
        fiber.return = expectedReturnFiber;
      }
      function invokeLayoutEffectMountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent: {
              try {
                commitHookEffectListMount(Layout2 | HasEffect, fiber);
              } catch (error3) {
                reportUncaughtErrorInDEV(error3);
                captureCommitPhaseError(fiber, fiber.return, error3);
              }
              break;
            }
            case ClassComponent: {
              var instance2 = fiber.stateNode;
              try {
                instance2.componentDidMount();
              } catch (error3) {
                reportUncaughtErrorInDEV(error3);
                captureCommitPhaseError(fiber, fiber.return, error3);
              }
              break;
            }
          }
        }
      }
      function invokePassiveEffectMountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent: {
              try {
                commitHookEffectListMount(Passive$1 | HasEffect, fiber);
              } catch (error3) {
                reportUncaughtErrorInDEV(error3);
                captureCommitPhaseError(fiber, fiber.return, error3);
              }
              break;
            }
          }
        }
      }
      function invokeLayoutEffectUnmountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent: {
              try {
                commitHookEffectListUnmount(Layout2 | HasEffect, fiber, fiber.return);
              } catch (error3) {
                reportUncaughtErrorInDEV(error3);
                captureCommitPhaseError(fiber, fiber.return, error3);
              }
              break;
            }
            case ClassComponent: {
              var instance2 = fiber.stateNode;
              if (typeof instance2.componentWillUnmount === "function") {
                safelyCallComponentWillUnmount(fiber, fiber.return, instance2);
              }
              break;
            }
          }
        }
      }
      function invokePassiveEffectUnmountInDEV(fiber) {
        {
          switch (fiber.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent: {
              try {
                commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
              } catch (error3) {
                reportUncaughtErrorInDEV(error3);
                captureCommitPhaseError(fiber, fiber.return, error3);
              }
            }
          }
        }
      }
      var COMPONENT_TYPE = 0;
      var HAS_PSEUDO_CLASS_TYPE = 1;
      var ROLE_TYPE = 2;
      var TEST_NAME_TYPE = 3;
      var TEXT_TYPE = 4;
      if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
      }
      function createComponentSelector(component) {
        return {
          $$typeof: COMPONENT_TYPE,
          value: component
        };
      }
      function createHasPseudoClassSelector(selectors) {
        return {
          $$typeof: HAS_PSEUDO_CLASS_TYPE,
          value: selectors
        };
      }
      function createRoleSelector(role) {
        return {
          $$typeof: ROLE_TYPE,
          value: role
        };
      }
      function createTextSelector(text) {
        return {
          $$typeof: TEXT_TYPE,
          value: text
        };
      }
      function createTestNameSelector(id) {
        return {
          $$typeof: TEST_NAME_TYPE,
          value: id
        };
      }
      function findFiberRootForHostRoot(hostRoot) {
        var maybeFiber = getInstanceFromNode(hostRoot);
        if (maybeFiber != null) {
          if (typeof maybeFiber.memoizedProps["data-testname"] !== "string") {
            throw new Error("Invalid host root specified. Should be either a React container or a node with a testname attribute.");
          }
          return maybeFiber;
        } else {
          var fiberRoot = findFiberRoot(hostRoot);
          if (fiberRoot === null) {
            throw new Error("Could not find React container within specified host subtree.");
          }
          return fiberRoot.stateNode.current;
        }
      }
      function matchSelector(fiber, selector) {
        switch (selector.$$typeof) {
          case COMPONENT_TYPE:
            if (fiber.type === selector.value) {
              return true;
            }
            break;
          case HAS_PSEUDO_CLASS_TYPE:
            return hasMatchingPaths(fiber, selector.value);
          case ROLE_TYPE:
            if (fiber.tag === HostComponent) {
              var node = fiber.stateNode;
              if (matchAccessibilityRole(node, selector.value)) {
                return true;
              }
            }
            break;
          case TEXT_TYPE:
            if (fiber.tag === HostComponent || fiber.tag === HostText) {
              var textContent = getTextContent(fiber);
              if (textContent !== null && textContent.indexOf(selector.value) >= 0) {
                return true;
              }
            }
            break;
          case TEST_NAME_TYPE:
            if (fiber.tag === HostComponent) {
              var dataTestID = fiber.memoizedProps["data-testname"];
              if (typeof dataTestID === "string" && dataTestID.toLowerCase() === selector.value.toLowerCase()) {
                return true;
              }
            }
            break;
          default:
            throw new Error("Invalid selector type specified.");
        }
        return false;
      }
      function selectorToString(selector) {
        switch (selector.$$typeof) {
          case COMPONENT_TYPE:
            var displayName = getComponentNameFromType(selector.value) || "Unknown";
            return "<" + displayName + ">";
          case HAS_PSEUDO_CLASS_TYPE:
            return ":has(" + (selectorToString(selector) || "") + ")";
          case ROLE_TYPE:
            return '[role="' + selector.value + '"]';
          case TEXT_TYPE:
            return '"' + selector.value + '"';
          case TEST_NAME_TYPE:
            return '[data-testname="' + selector.value + '"]';
          default:
            throw new Error("Invalid selector type specified.");
        }
      }
      function findPaths(root2, selectors) {
        var matchingFibers = [];
        var stack2 = [root2, 0];
        var index3 = 0;
        while (index3 < stack2.length) {
          var fiber = stack2[index3++];
          var selectorIndex = stack2[index3++];
          var selector = selectors[selectorIndex];
          if (fiber.tag === HostComponent && isHiddenSubtree(fiber)) {
            continue;
          } else {
            while (selector != null && matchSelector(fiber, selector)) {
              selectorIndex++;
              selector = selectors[selectorIndex];
            }
          }
          if (selectorIndex === selectors.length) {
            matchingFibers.push(fiber);
          } else {
            var child = fiber.child;
            while (child !== null) {
              stack2.push(child, selectorIndex);
              child = child.sibling;
            }
          }
        }
        return matchingFibers;
      }
      function hasMatchingPaths(root2, selectors) {
        var stack2 = [root2, 0];
        var index3 = 0;
        while (index3 < stack2.length) {
          var fiber = stack2[index3++];
          var selectorIndex = stack2[index3++];
          var selector = selectors[selectorIndex];
          if (fiber.tag === HostComponent && isHiddenSubtree(fiber)) {
            continue;
          } else {
            while (selector != null && matchSelector(fiber, selector)) {
              selectorIndex++;
              selector = selectors[selectorIndex];
            }
          }
          if (selectorIndex === selectors.length) {
            return true;
          } else {
            var child = fiber.child;
            while (child !== null) {
              stack2.push(child, selectorIndex);
              child = child.sibling;
            }
          }
        }
        return false;
      }
      function findAllNodes(hostRoot, selectors) {
        if (!supportsTestSelectors) {
          throw new Error("Test selector API is not supported by this renderer.");
        }
        var root2 = findFiberRootForHostRoot(hostRoot);
        var matchingFibers = findPaths(root2, selectors);
        var instanceRoots = [];
        var stack2 = Array.from(matchingFibers);
        var index3 = 0;
        while (index3 < stack2.length) {
          var node = stack2[index3++];
          if (node.tag === HostComponent) {
            if (isHiddenSubtree(node)) {
              continue;
            }
            instanceRoots.push(node.stateNode);
          } else {
            var child = node.child;
            while (child !== null) {
              stack2.push(child);
              child = child.sibling;
            }
          }
        }
        return instanceRoots;
      }
      function getFindAllNodesFailureDescription(hostRoot, selectors) {
        if (!supportsTestSelectors) {
          throw new Error("Test selector API is not supported by this renderer.");
        }
        var root2 = findFiberRootForHostRoot(hostRoot);
        var maxSelectorIndex = 0;
        var matchedNames = [];
        var stack2 = [root2, 0];
        var index3 = 0;
        while (index3 < stack2.length) {
          var fiber = stack2[index3++];
          var selectorIndex = stack2[index3++];
          var selector = selectors[selectorIndex];
          if (fiber.tag === HostComponent && isHiddenSubtree(fiber)) {
            continue;
          } else if (matchSelector(fiber, selector)) {
            matchedNames.push(selectorToString(selector));
            selectorIndex++;
            if (selectorIndex > maxSelectorIndex) {
              maxSelectorIndex = selectorIndex;
            }
          }
          if (selectorIndex < selectors.length) {
            var child = fiber.child;
            while (child !== null) {
              stack2.push(child, selectorIndex);
              child = child.sibling;
            }
          }
        }
        if (maxSelectorIndex < selectors.length) {
          var unmatchedNames = [];
          for (var i2 = maxSelectorIndex; i2 < selectors.length; i2++) {
            unmatchedNames.push(selectorToString(selectors[i2]));
          }
          return "findAllNodes was able to match part of the selector:\n" + ("  " + matchedNames.join(" > ") + "\n\n") + "No matching component was found for:\n" + ("  " + unmatchedNames.join(" > "));
        }
        return null;
      }
      function findBoundingRects(hostRoot, selectors) {
        if (!supportsTestSelectors) {
          throw new Error("Test selector API is not supported by this renderer.");
        }
        var instanceRoots = findAllNodes(hostRoot, selectors);
        var boundingRects = [];
        for (var i2 = 0; i2 < instanceRoots.length; i2++) {
          boundingRects.push(getBoundingRect(instanceRoots[i2]));
        }
        for (var _i = boundingRects.length - 1; _i > 0; _i--) {
          var targetRect = boundingRects[_i];
          var targetLeft = targetRect.x;
          var targetRight = targetLeft + targetRect.width;
          var targetTop = targetRect.y;
          var targetBottom = targetTop + targetRect.height;
          for (var j2 = _i - 1; j2 >= 0; j2--) {
            if (_i !== j2) {
              var otherRect = boundingRects[j2];
              var otherLeft = otherRect.x;
              var otherRight = otherLeft + otherRect.width;
              var otherTop = otherRect.y;
              var otherBottom = otherTop + otherRect.height;
              if (targetLeft >= otherLeft && targetTop >= otherTop && targetRight <= otherRight && targetBottom <= otherBottom) {
                boundingRects.splice(_i, 1);
                break;
              } else if (targetLeft === otherLeft && targetRect.width === otherRect.width && !(otherBottom < targetTop) && !(otherTop > targetBottom)) {
                if (otherTop > targetTop) {
                  otherRect.height += otherTop - targetTop;
                  otherRect.y = targetTop;
                }
                if (otherBottom < targetBottom) {
                  otherRect.height = targetBottom - otherTop;
                }
                boundingRects.splice(_i, 1);
                break;
              } else if (targetTop === otherTop && targetRect.height === otherRect.height && !(otherRight < targetLeft) && !(otherLeft > targetRight)) {
                if (otherLeft > targetLeft) {
                  otherRect.width += otherLeft - targetLeft;
                  otherRect.x = targetLeft;
                }
                if (otherRight < targetRight) {
                  otherRect.width = targetRight - otherLeft;
                }
                boundingRects.splice(_i, 1);
                break;
              }
            }
          }
        }
        return boundingRects;
      }
      function focusWithin(hostRoot, selectors) {
        if (!supportsTestSelectors) {
          throw new Error("Test selector API is not supported by this renderer.");
        }
        var root2 = findFiberRootForHostRoot(hostRoot);
        var matchingFibers = findPaths(root2, selectors);
        var stack2 = Array.from(matchingFibers);
        var index3 = 0;
        while (index3 < stack2.length) {
          var fiber = stack2[index3++];
          if (isHiddenSubtree(fiber)) {
            continue;
          }
          if (fiber.tag === HostComponent) {
            var node = fiber.stateNode;
            if (setFocusIfFocusable(node)) {
              return true;
            }
          }
          var child = fiber.child;
          while (child !== null) {
            stack2.push(child);
            child = child.sibling;
          }
        }
        return false;
      }
      var commitHooks = [];
      function onCommitRoot$1() {
        if (supportsTestSelectors) {
          commitHooks.forEach(function(commitHook) {
            return commitHook();
          });
        }
      }
      function observeVisibleRects(hostRoot, selectors, callback, options2) {
        if (!supportsTestSelectors) {
          throw new Error("Test selector API is not supported by this renderer.");
        }
        var instanceRoots = findAllNodes(hostRoot, selectors);
        var _setupIntersectionObs = setupIntersectionObserver(instanceRoots, callback, options2), disconnect = _setupIntersectionObs.disconnect, observe = _setupIntersectionObs.observe, unobserve = _setupIntersectionObs.unobserve;
        var commitHook = function() {
          var nextInstanceRoots = findAllNodes(hostRoot, selectors);
          instanceRoots.forEach(function(target) {
            if (nextInstanceRoots.indexOf(target) < 0) {
              unobserve(target);
            }
          });
          nextInstanceRoots.forEach(function(target) {
            if (instanceRoots.indexOf(target) < 0) {
              observe(target);
            }
          });
        };
        commitHooks.push(commitHook);
        return {
          disconnect: function() {
            var index3 = commitHooks.indexOf(commitHook);
            if (index3 >= 0) {
              commitHooks.splice(index3, 1);
            }
            disconnect();
          }
        };
      }
      var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
      function isLegacyActEnvironment(fiber) {
        {
          var isReactActEnvironmentGlobal = (
            // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
            typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : void 0
          );
          var jestIsDefined = typeof jest !== "undefined";
          return warnsIfNotActing && jestIsDefined && isReactActEnvironmentGlobal !== false;
        }
      }
      function isConcurrentActEnvironment() {
        {
          var isReactActEnvironmentGlobal = (
            // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
            typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : void 0
          );
          if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) {
            error2("The current testing environment is not configured to support act(...)");
          }
          return isReactActEnvironmentGlobal;
        }
      }
      var ceil2 = Math.ceil;
      var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
      var NoContext = (
        /*             */
        0
      );
      var BatchedContext = (
        /*               */
        1
      );
      var RenderContext = (
        /*                */
        2
      );
      var CommitContext = (
        /*                */
        4
      );
      var RootInProgress = 0;
      var RootFatalErrored = 1;
      var RootErrored = 2;
      var RootSuspended = 3;
      var RootSuspendedWithDelay = 4;
      var RootCompleted = 5;
      var RootDidNotComplete = 6;
      var executionContext = NoContext;
      var workInProgressRoot = null;
      var workInProgress = null;
      var workInProgressRootRenderLanes = NoLanes;
      var subtreeRenderLanes = NoLanes;
      var subtreeRenderLanesCursor = createCursor(NoLanes);
      var workInProgressRootExitStatus = RootInProgress;
      var workInProgressRootFatalError = null;
      var workInProgressRootSkippedLanes = NoLanes;
      var workInProgressRootInterleavedUpdatedLanes = NoLanes;
      var workInProgressRootPingedLanes = NoLanes;
      var workInProgressRootConcurrentErrors = null;
      var workInProgressRootRecoverableErrors = null;
      var globalMostRecentFallbackTime = 0;
      var FALLBACK_THROTTLE_MS = 500;
      var workInProgressRootRenderTargetTime = Infinity;
      var RENDER_TIMEOUT_MS = 500;
      function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now$12() + RENDER_TIMEOUT_MS;
      }
      function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
      }
      var hasUncaughtError = false;
      var firstUncaughtError = null;
      var legacyErrorBoundariesThatAlreadyFailed = null;
      var rootDoesHavePassiveEffects = false;
      var rootWithPendingPassiveEffects = null;
      var pendingPassiveEffectsLanes = NoLanes;
      var pendingPassiveProfilerEffects = [];
      var NESTED_UPDATE_LIMIT = 50;
      var nestedUpdateCount = 0;
      var rootWithNestedUpdates = null;
      var NESTED_PASSIVE_UPDATE_LIMIT = 50;
      var nestedPassiveUpdateCount = 0;
      var currentEventTime = NoTimestamp;
      var currentEventTransitionLane = NoLanes;
      function getWorkInProgressRoot() {
        return workInProgressRoot;
      }
      function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          return now$12();
        }
        if (currentEventTime !== NoTimestamp) {
          return currentEventTime;
        }
        currentEventTime = now$12();
        return currentEventTime;
      }
      function requestUpdateLane(fiber) {
        var mode2 = fiber.mode;
        if ((mode2 & ConcurrentMode) === NoMode) {
          return SyncLane;
        } else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) {
          return pickArbitraryLane(workInProgressRootRenderLanes);
        }
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
          if (ReactCurrentBatchConfig$2.transition !== null) {
            var transition2 = ReactCurrentBatchConfig$2.transition;
            if (!transition2._updatedFibers) {
              transition2._updatedFibers = /* @__PURE__ */ new Set();
            }
            transition2._updatedFibers.add(fiber);
          }
          if (currentEventTransitionLane === NoLane) {
            currentEventTransitionLane = claimNextTransitionLane();
          }
          return currentEventTransitionLane;
        }
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) {
          return updateLane;
        }
        var eventLane = getCurrentEventPriority();
        return eventLane;
      }
      function requestRetryLane(fiber) {
        var mode2 = fiber.mode;
        if ((mode2 & ConcurrentMode) === NoMode) {
          return SyncLane;
        }
        return claimNextRetryLane();
      }
      function scheduleUpdateOnFiber(fiber, lane, eventTime) {
        checkForNestedUpdates();
        var root2 = markUpdateLaneFromFiberToRoot(fiber, lane);
        if (root2 === null) {
          return null;
        }
        markRootUpdated(root2, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root2 === workInProgressRoot) {
          warnAboutRenderPhaseUpdatesInDEV(fiber);
        } else {
          {
            if (isDevToolsPresent) {
              addFiberToLanesMap(root2, fiber, lane);
            }
          }
          warnIfUpdatesNotWrappedWithActDEV(fiber);
          if (root2 === workInProgressRoot) {
            if ((executionContext & RenderContext) === NoContext) {
              workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
            }
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              markRootSuspended$1(root2, workInProgressRootRenderLanes);
            }
          }
          ensureRootIsScheduled(root2, eventTime);
          if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
          !ReactCurrentActQueue$1.isBatchingLegacy) {
            resetRenderTimer();
            flushSyncCallbacksOnlyInLegacyMode();
          }
        }
        return root2;
      }
      function scheduleInitialHydrationOnRoot(root2, lane, eventTime) {
        var current2 = root2.current;
        current2.lanes = lane;
        markRootUpdated(root2, lane, eventTime);
        ensureRootIsScheduled(root2, eventTime);
      }
      function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) {
          alternate.lanes = mergeLanes(alternate.lanes, lane);
        }
        {
          if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
            warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
          }
        }
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while (parent !== null) {
          parent.childLanes = mergeLanes(parent.childLanes, lane);
          alternate = parent.alternate;
          if (alternate !== null) {
            alternate.childLanes = mergeLanes(alternate.childLanes, lane);
          } else {
            {
              if ((parent.flags & (Placement | Hydrating)) !== NoFlags) {
                warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
              }
            }
          }
          node = parent;
          parent = parent.return;
        }
        if (node.tag === HostRoot) {
          var root2 = node.stateNode;
          return root2;
        } else {
          return null;
        }
      }
      function isInterleavedUpdate(fiber, lane) {
        return (
          // TODO: Optimize slightly by comparing to root that fiber belongs to.
          // Requires some refactoring. Not a big deal though since it's rare for
          // concurrent apps to have more than a single root.
          workInProgressRoot !== null && (fiber.mode & ConcurrentMode) !== NoMode && // If this is a render phase update (i.e. UNSAFE_componentWillReceiveProps),
          // then don't treat this as an interleaved update. This pattern is
          // accompanied by a warning but we haven't fully deprecated it yet. We can
          // remove once the deferRenderPhaseUpdateToNextBatch flag is enabled.
          (executionContext & RenderContext) === NoContext
        );
      }
      function ensureRootIsScheduled(root2, currentTime) {
        var existingCallbackNode = root2.callbackNode;
        markStarvedLanesAsExpired(root2, currentTime);
        var nextLanes = getNextLanes(root2, root2 === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
          if (existingCallbackNode !== null) {
            cancelCallback$1(existingCallbackNode);
          }
          root2.callbackNode = null;
          root2.callbackPriority = NoLane;
          return;
        }
        var newCallbackPriority = getHighestPriorityLane(nextLanes);
        var existingCallbackPriority = root2.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
          {
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) {
              error2("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          return;
        }
        if (existingCallbackNode != null) {
          cancelCallback$1(existingCallbackNode);
        }
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
          if (root2.tag === LegacyRoot) {
            if (ReactCurrentActQueue$1.isBatchingLegacy !== null) {
              ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
            }
            scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root2));
          } else {
            scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root2));
          }
          if (supportsMicrotasks) {
            if (ReactCurrentActQueue$1.current !== null) {
              ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            } else {
              scheduleMicrotask(function() {
                if (executionContext === NoContext) {
                  flushSyncCallbacks();
                }
              });
            }
          } else {
            scheduleCallback$1(ImmediatePriority, flushSyncCallbacks);
          }
          newCallbackNode = null;
        } else {
          var schedulerPriorityLevel;
          switch (lanesToEventPriority(nextLanes)) {
            case DiscreteEventPriority:
              schedulerPriorityLevel = ImmediatePriority;
              break;
            case ContinuousEventPriority:
              schedulerPriorityLevel = UserBlockingPriority;
              break;
            case DefaultEventPriority:
              schedulerPriorityLevel = NormalPriority;
              break;
            case IdleEventPriority:
              schedulerPriorityLevel = IdlePriority;
              break;
            default:
              schedulerPriorityLevel = NormalPriority;
              break;
          }
          newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root2));
        }
        root2.callbackPriority = newCallbackPriority;
        root2.callbackNode = newCallbackNode;
      }
      function performConcurrentWorkOnRoot(root2, didTimeout) {
        {
          resetNestedUpdateFlag();
        }
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error("Should not already be working.");
        }
        var originalCallbackNode = root2.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
          if (root2.callbackNode !== originalCallbackNode) {
            return null;
          }
        }
        var lanes = getNextLanes(root2, root2 === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) {
          return null;
        }
        var shouldTimeSlice = !includesBlockingLane(root2, lanes) && !includesExpiredLane(root2, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root2, lanes) : renderRootSync(root2, lanes);
        if (exitStatus !== RootInProgress) {
          if (exitStatus === RootErrored) {
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root2);
            if (errorRetryLanes !== NoLanes) {
              lanes = errorRetryLanes;
              exitStatus = recoverFromConcurrentError(root2, errorRetryLanes);
            }
          }
          if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root2, NoLanes);
            markRootSuspended$1(root2, lanes);
            ensureRootIsScheduled(root2, now$12());
            throw fatalError;
          }
          if (exitStatus === RootDidNotComplete) {
            markRootSuspended$1(root2, lanes);
          } else {
            var renderWasConcurrent = !includesBlockingLane(root2, lanes);
            var finishedWork = root2.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
              exitStatus = renderRootSync(root2, lanes);
              if (exitStatus === RootErrored) {
                var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root2);
                if (_errorRetryLanes !== NoLanes) {
                  lanes = _errorRetryLanes;
                  exitStatus = recoverFromConcurrentError(root2, _errorRetryLanes);
                }
              }
              if (exitStatus === RootFatalErrored) {
                var _fatalError = workInProgressRootFatalError;
                prepareFreshStack(root2, NoLanes);
                markRootSuspended$1(root2, lanes);
                ensureRootIsScheduled(root2, now$12());
                throw _fatalError;
              }
            }
            root2.finishedWork = finishedWork;
            root2.finishedLanes = lanes;
            finishConcurrentRender(root2, exitStatus, lanes);
          }
        }
        ensureRootIsScheduled(root2, now$12());
        if (root2.callbackNode === originalCallbackNode) {
          return performConcurrentWorkOnRoot.bind(null, root2);
        }
        return null;
      }
      function recoverFromConcurrentError(root2, errorRetryLanes) {
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root2)) {
          var rootWorkInProgress = prepareFreshStack(root2, errorRetryLanes);
          rootWorkInProgress.flags |= ForceClientRender;
          {
            errorHydratingContainer(root2.containerInfo);
          }
        }
        var exitStatus = renderRootSync(root2, errorRetryLanes);
        if (exitStatus !== RootErrored) {
          var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
          workInProgressRootRecoverableErrors = errorsFromFirstAttempt;
          if (errorsFromSecondAttempt !== null) {
            queueRecoverableErrors(errorsFromSecondAttempt);
          }
        }
        return exitStatus;
      }
      function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) {
          workInProgressRootRecoverableErrors = errors;
        } else {
          workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
        }
      }
      function finishConcurrentRender(root2, exitStatus, lanes) {
        switch (exitStatus) {
          case RootInProgress:
          case RootFatalErrored: {
            throw new Error("Root did not complete. This is a bug in React.");
          }
          case RootErrored: {
            commitRoot(root2, workInProgressRootRecoverableErrors);
            break;
          }
          case RootSuspended: {
            markRootSuspended$1(root2, lanes);
            if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
            !shouldForceFlushFallbacksInDEV()) {
              var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$12();
              if (msUntilTimeout > 10) {
                var nextLanes = getNextLanes(root2, NoLanes);
                if (nextLanes !== NoLanes) {
                  break;
                }
                var suspendedLanes = root2.suspendedLanes;
                if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                  requestEventTime();
                  markRootPinged(root2, suspendedLanes);
                  break;
                }
                root2.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root2, workInProgressRootRecoverableErrors), msUntilTimeout);
                break;
              }
            }
            commitRoot(root2, workInProgressRootRecoverableErrors);
            break;
          }
          case RootSuspendedWithDelay: {
            markRootSuspended$1(root2, lanes);
            if (includesOnlyTransitions(lanes)) {
              break;
            }
            if (!shouldForceFlushFallbacksInDEV()) {
              var mostRecentEventTime = getMostRecentEventTime(root2, lanes);
              var eventTimeMs = mostRecentEventTime;
              var timeElapsedMs = now$12() - eventTimeMs;
              var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs;
              if (_msUntilTimeout > 10) {
                root2.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root2, workInProgressRootRecoverableErrors), _msUntilTimeout);
                break;
              }
            }
            commitRoot(root2, workInProgressRootRecoverableErrors);
            break;
          }
          case RootCompleted: {
            commitRoot(root2, workInProgressRootRecoverableErrors);
            break;
          }
          default: {
            throw new Error("Unknown root exit status.");
          }
        }
      }
      function isRenderConsistentWithExternalStores(finishedWork) {
        var node = finishedWork;
        while (true) {
          if (node.flags & StoreConsistency) {
            var updateQueue = node.updateQueue;
            if (updateQueue !== null) {
              var checks = updateQueue.stores;
              if (checks !== null) {
                for (var i2 = 0; i2 < checks.length; i2++) {
                  var check = checks[i2];
                  var getSnapshot = check.getSnapshot;
                  var renderedValue = check.value;
                  try {
                    if (!objectIs2(getSnapshot(), renderedValue)) {
                      return false;
                    }
                  } catch (error3) {
                    return false;
                  }
                }
              }
            }
          }
          var child = node.child;
          if (node.subtreeFlags & StoreConsistency && child !== null) {
            child.return = node;
            node = child;
            continue;
          }
          if (node === finishedWork) {
            return true;
          }
          while (node.sibling === null) {
            if (node.return === null || node.return === finishedWork) {
              return true;
            }
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
        return true;
      }
      function markRootSuspended$1(root2, suspendedLanes) {
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root2, suspendedLanes);
      }
      function performSyncWorkOnRoot(root2) {
        {
          syncNestedUpdateFlag();
        }
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error("Should not already be working.");
        }
        flushPassiveEffects();
        var lanes = getNextLanes(root2, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
          ensureRootIsScheduled(root2, now$12());
          return null;
        }
        var exitStatus = renderRootSync(root2, lanes);
        if (root2.tag !== LegacyRoot && exitStatus === RootErrored) {
          var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root2);
          if (errorRetryLanes !== NoLanes) {
            lanes = errorRetryLanes;
            exitStatus = recoverFromConcurrentError(root2, errorRetryLanes);
          }
        }
        if (exitStatus === RootFatalErrored) {
          var fatalError = workInProgressRootFatalError;
          prepareFreshStack(root2, NoLanes);
          markRootSuspended$1(root2, lanes);
          ensureRootIsScheduled(root2, now$12());
          throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) {
          throw new Error("Root did not complete. This is a bug in React.");
        }
        var finishedWork = root2.current.alternate;
        root2.finishedWork = finishedWork;
        root2.finishedLanes = lanes;
        commitRoot(root2, workInProgressRootRecoverableErrors);
        ensureRootIsScheduled(root2, now$12());
        return null;
      }
      function flushRoot(root2, lanes) {
        if (lanes !== NoLanes) {
          markRootEntangled(root2, mergeLanes(lanes, SyncLane));
          ensureRootIsScheduled(root2, now$12());
          if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
            resetRenderTimer();
            flushSyncCallbacks();
          }
        }
      }
      function deferredUpdates(fn2) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        try {
          ReactCurrentBatchConfig$2.transition = null;
          setCurrentUpdatePriority(DefaultEventPriority);
          return fn2();
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$2.transition = prevTransition;
        }
      }
      function batchedUpdates(fn2, a2) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
          return fn2(a2);
        } finally {
          executionContext = prevExecutionContext;
          if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
          !ReactCurrentActQueue$1.isBatchingLegacy) {
            resetRenderTimer();
            flushSyncCallbacksOnlyInLegacyMode();
          }
        }
      }
      function discreteUpdates(fn2, a2, b2, c2, d2) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        try {
          ReactCurrentBatchConfig$2.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          return fn2(a2, b2, c2, d2);
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$2.transition = prevTransition;
          if (executionContext === NoContext) {
            resetRenderTimer();
          }
        }
      }
      function flushSync(fn2) {
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) {
          flushPassiveEffects();
        }
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
          ReactCurrentBatchConfig$2.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          if (fn2) {
            return fn2();
          } else {
            return void 0;
          }
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$2.transition = prevTransition;
          executionContext = prevExecutionContext;
          if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
            flushSyncCallbacks();
          }
        }
      }
      function isAlreadyRendering() {
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
      }
      function flushControlled(fn2) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
          ReactCurrentBatchConfig$2.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          fn2();
        } finally {
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$2.transition = prevTransition;
          executionContext = prevExecutionContext;
          if (executionContext === NoContext) {
            resetRenderTimer();
            flushSyncCallbacks();
          }
        }
      }
      function pushRenderLanes(fiber, lanes) {
        push2(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
      }
      function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
      }
      function prepareFreshStack(root2, lanes) {
        root2.finishedWork = null;
        root2.finishedLanes = NoLanes;
        var timeoutHandle = root2.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
          root2.timeoutHandle = noTimeout;
          cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
          var interruptedWork = workInProgress.return;
          while (interruptedWork !== null) {
            var current2 = interruptedWork.alternate;
            unwindInterruptedWork(current2, interruptedWork);
            interruptedWork = interruptedWork.return;
          }
        }
        workInProgressRoot = root2;
        var rootWorkInProgress = createWorkInProgress(root2.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        enqueueInterleavedUpdates();
        {
          ReactStrictModeWarnings.discardPendingWarnings();
        }
        return rootWorkInProgress;
      }
      function handleError(root2, thrownValue) {
        do {
          var erroredWork = workInProgress;
          try {
            resetContextDependencies();
            resetHooksAfterThrow();
            resetCurrentFiber();
            ReactCurrentOwner$2.current = null;
            if (erroredWork === null || erroredWork.return === null) {
              workInProgressRootExitStatus = RootFatalErrored;
              workInProgressRootFatalError = thrownValue;
              workInProgress = null;
              return;
            }
            if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
              stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
            }
            if (enableSchedulingProfiler) {
              markComponentRenderStopped();
              if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                var wakeable = thrownValue;
                markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
              } else {
                markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
              }
            }
            throwException(root2, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
            completeUnitOfWork(erroredWork);
          } catch (yetAnotherThrownValue) {
            thrownValue = yetAnotherThrownValue;
            if (workInProgress === erroredWork && erroredWork !== null) {
              erroredWork = erroredWork.return;
              workInProgress = erroredWork;
            } else {
              erroredWork = workInProgress;
            }
            continue;
          }
          return;
        } while (true);
      }
      function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) {
          return ContextOnlyDispatcher;
        } else {
          return prevDispatcher;
        }
      }
      function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
      }
      function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now$12();
      }
      function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
      }
      function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) {
          workInProgressRootExitStatus = RootSuspended;
        }
      }
      function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) {
          workInProgressRootExitStatus = RootSuspendedWithDelay;
        }
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) {
          markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
        }
      }
      function renderDidError(error3) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) {
          workInProgressRootExitStatus = RootErrored;
        }
        if (workInProgressRootConcurrentErrors === null) {
          workInProgressRootConcurrentErrors = [error3];
        } else {
          workInProgressRootConcurrentErrors.push(error3);
        }
      }
      function renderHasNotSuspendedYet() {
        return workInProgressRootExitStatus === RootInProgress;
      }
      function renderRootSync(root2, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher();
        if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes) {
          {
            if (isDevToolsPresent) {
              var memoizedUpdaters = root2.memoizedUpdaters;
              if (memoizedUpdaters.size > 0) {
                restorePendingUpdaters(root2, workInProgressRootRenderLanes);
                memoizedUpdaters.clear();
              }
              movePendingFibersToMemoized(root2, lanes);
            }
          }
          prepareFreshStack(root2, lanes);
        }
        {
          markRenderStarted(lanes);
        }
        do {
          try {
            workLoopSync();
            break;
          } catch (thrownValue) {
            handleError(root2, thrownValue);
          }
        } while (true);
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) {
          throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        }
        {
          markRenderStopped();
        }
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
      }
      function workLoopSync() {
        while (workInProgress !== null) {
          performUnitOfWork(workInProgress);
        }
      }
      function renderRootConcurrent(root2, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher();
        if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes) {
          {
            if (isDevToolsPresent) {
              var memoizedUpdaters = root2.memoizedUpdaters;
              if (memoizedUpdaters.size > 0) {
                restorePendingUpdaters(root2, workInProgressRootRenderLanes);
                memoizedUpdaters.clear();
              }
              movePendingFibersToMemoized(root2, lanes);
            }
          }
          resetRenderTimer();
          prepareFreshStack(root2, lanes);
        }
        {
          markRenderStarted(lanes);
        }
        do {
          try {
            workLoopConcurrent();
            break;
          } catch (thrownValue) {
            handleError(root2, thrownValue);
          }
        } while (true);
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
          {
            markRenderYielded();
          }
          return RootInProgress;
        } else {
          {
            markRenderStopped();
          }
          workInProgressRoot = null;
          workInProgressRootRenderLanes = NoLanes;
          return workInProgressRootExitStatus;
        }
      }
      function workLoopConcurrent() {
        while (workInProgress !== null && !shouldYield()) {
          performUnitOfWork(workInProgress);
        }
      }
      function performUnitOfWork(unitOfWork) {
        var current2 = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next5;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          startProfilerTimer(unitOfWork);
          next5 = beginWork$1(current2, unitOfWork, subtreeRenderLanes);
          stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else {
          next5 = beginWork$1(current2, unitOfWork, subtreeRenderLanes);
        }
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next5 === null) {
          completeUnitOfWork(unitOfWork);
        } else {
          workInProgress = next5;
        }
        ReactCurrentOwner$2.current = null;
      }
      function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
          var current2 = completedWork.alternate;
          var returnFiber = completedWork.return;
          if ((completedWork.flags & Incomplete) === NoFlags) {
            setCurrentFiber(completedWork);
            var next5 = void 0;
            if ((completedWork.mode & ProfileMode) === NoMode) {
              next5 = completeWork(current2, completedWork, subtreeRenderLanes);
            } else {
              startProfilerTimer(completedWork);
              next5 = completeWork(current2, completedWork, subtreeRenderLanes);
              stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
            }
            resetCurrentFiber();
            if (next5 !== null) {
              workInProgress = next5;
              return;
            }
          } else {
            var _next = unwindWork(current2, completedWork);
            if (_next !== null) {
              _next.flags &= HostEffectMask;
              workInProgress = _next;
              return;
            }
            if ((completedWork.mode & ProfileMode) !== NoMode) {
              stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
              var actualDuration = completedWork.actualDuration;
              var child = completedWork.child;
              while (child !== null) {
                actualDuration += child.actualDuration;
                child = child.sibling;
              }
              completedWork.actualDuration = actualDuration;
            }
            if (returnFiber !== null) {
              returnFiber.flags |= Incomplete;
              returnFiber.subtreeFlags = NoFlags;
              returnFiber.deletions = null;
            } else {
              workInProgressRootExitStatus = RootDidNotComplete;
              workInProgress = null;
              return;
            }
          }
          var siblingFiber = completedWork.sibling;
          if (siblingFiber !== null) {
            workInProgress = siblingFiber;
            return;
          }
          completedWork = returnFiber;
          workInProgress = completedWork;
        } while (completedWork !== null);
        if (workInProgressRootExitStatus === RootInProgress) {
          workInProgressRootExitStatus = RootCompleted;
        }
      }
      function commitRoot(root2, recoverableErrors) {
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        try {
          ReactCurrentBatchConfig$2.transition = null;
          setCurrentUpdatePriority(DiscreteEventPriority);
          commitRootImpl(root2, recoverableErrors, previousUpdateLanePriority);
        } finally {
          ReactCurrentBatchConfig$2.transition = prevTransition;
          setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
      }
      function commitRootImpl(root2, recoverableErrors, renderPriorityLevel) {
        do {
          flushPassiveEffects();
        } while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error("Should not already be working.");
        }
        var finishedWork = root2.finishedWork;
        var lanes = root2.finishedLanes;
        {
          markCommitStarted(lanes);
        }
        if (finishedWork === null) {
          {
            markCommitStopped();
          }
          return null;
        } else {
          {
            if (lanes === NoLanes) {
              error2("root.finishedLanes should not be empty during a commit. This is a bug in React.");
            }
          }
        }
        root2.finishedWork = null;
        root2.finishedLanes = NoLanes;
        if (finishedWork === root2.current) {
          throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
        }
        root2.callbackNode = null;
        root2.callbackPriority = NoLane;
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root2, remainingLanes);
        if (root2 === workInProgressRoot) {
          workInProgressRoot = null;
          workInProgress = null;
          workInProgressRootRenderLanes = NoLanes;
        }
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
              flushPassiveEffects();
              return null;
            });
          }
        }
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
          var prevTransition = ReactCurrentBatchConfig$2.transition;
          ReactCurrentBatchConfig$2.transition = null;
          var previousPriority = getCurrentUpdatePriority();
          setCurrentUpdatePriority(DiscreteEventPriority);
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          ReactCurrentOwner$2.current = null;
          commitBeforeMutationEffects(root2, finishedWork);
          {
            recordCommitTime();
          }
          commitMutationEffects(root2, finishedWork, lanes);
          resetAfterCommit(root2.containerInfo);
          root2.current = finishedWork;
          {
            markLayoutEffectsStarted(lanes);
          }
          commitLayoutEffects(finishedWork, root2, lanes);
          {
            markLayoutEffectsStopped();
          }
          requestPaint();
          executionContext = prevExecutionContext;
          setCurrentUpdatePriority(previousPriority);
          ReactCurrentBatchConfig$2.transition = prevTransition;
        } else {
          root2.current = finishedWork;
          {
            recordCommitTime();
          }
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
          rootDoesHavePassiveEffects = false;
          rootWithPendingPassiveEffects = root2;
          pendingPassiveEffectsLanes = lanes;
        }
        remainingLanes = root2.pendingLanes;
        if (remainingLanes === NoLanes) {
          legacyErrorBoundariesThatAlreadyFailed = null;
        }
        {
          if (!rootDidHavePassiveEffects) {
            commitDoubleInvokeEffectsInDEV(root2.current, false);
          }
        }
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        {
          if (isDevToolsPresent) {
            root2.memoizedUpdaters.clear();
          }
        }
        {
          onCommitRoot$1();
        }
        ensureRootIsScheduled(root2, now$12());
        if (recoverableErrors !== null) {
          var onRecoverableError = root2.onRecoverableError;
          for (var i2 = 0; i2 < recoverableErrors.length; i2++) {
            var recoverableError = recoverableErrors[i2];
            onRecoverableError(recoverableError);
          }
        }
        if (hasUncaughtError) {
          hasUncaughtError = false;
          var error$1 = firstUncaughtError;
          firstUncaughtError = null;
          throw error$1;
        }
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root2.tag !== LegacyRoot) {
          flushPassiveEffects();
        }
        remainingLanes = root2.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
          {
            markNestedUpdateScheduled();
          }
          if (root2 === rootWithNestedUpdates) {
            nestedUpdateCount++;
          } else {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = root2;
          }
        } else {
          nestedUpdateCount = 0;
        }
        flushSyncCallbacks();
        {
          markCommitStopped();
        }
        return null;
      }
      function flushPassiveEffects() {
        if (rootWithPendingPassiveEffects !== null) {
          var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
          var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
          var prevTransition = ReactCurrentBatchConfig$2.transition;
          var previousPriority = getCurrentUpdatePriority();
          try {
            ReactCurrentBatchConfig$2.transition = null;
            setCurrentUpdatePriority(priority);
            return flushPassiveEffectsImpl();
          } finally {
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
          }
        }
        return false;
      }
      function enqueuePendingPassiveProfilerEffect(fiber) {
        {
          pendingPassiveProfilerEffects.push(fiber);
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
              flushPassiveEffects();
              return null;
            });
          }
        }
      }
      function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) {
          return false;
        }
        var root2 = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
          throw new Error("Cannot flush passive effects while already rendering.");
        }
        {
          markPassiveEffectsStarted(lanes);
        }
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root2.current);
        commitPassiveMountEffects(root2, root2.current);
        {
          var profilerEffects = pendingPassiveProfilerEffects;
          pendingPassiveProfilerEffects = [];
          for (var i2 = 0; i2 < profilerEffects.length; i2++) {
            var _fiber = profilerEffects[i2];
            commitPassiveEffectDurations(root2, _fiber);
          }
        }
        {
          markPassiveEffectsStopped();
        }
        {
          commitDoubleInvokeEffectsInDEV(root2.current, true);
        }
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        onPostCommitRoot(root2);
        {
          var stateNode = root2.current.stateNode;
          stateNode.effectDuration = 0;
          stateNode.passiveEffectDuration = 0;
        }
        return true;
      }
      function isAlreadyFailedLegacyErrorBoundary(instance2) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance2);
      }
      function markLegacyErrorBoundaryAsFailed(instance2) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) {
          legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([instance2]);
        } else {
          legacyErrorBoundariesThatAlreadyFailed.add(instance2);
        }
      }
      function prepareToThrowUncaughtError(error3) {
        if (!hasUncaughtError) {
          hasUncaughtError = true;
          firstUncaughtError = error3;
        }
      }
      var onUncaughtError = prepareToThrowUncaughtError;
      function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error3) {
        var errorInfo = createCapturedValue(error3, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        enqueueUpdate(rootFiber, update);
        var eventTime = requestEventTime();
        var root2 = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
        if (root2 !== null) {
          markRootUpdated(root2, SyncLane, eventTime);
          ensureRootIsScheduled(root2, eventTime);
        }
      }
      function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        if (sourceFiber.tag === HostRoot) {
          captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
          return;
        }
        var fiber = null;
        {
          fiber = nearestMountedAncestor;
        }
        while (fiber !== null) {
          if (fiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
            return;
          } else if (fiber.tag === ClassComponent) {
            var ctor = fiber.type;
            var instance2 = fiber.stateNode;
            if (typeof ctor.getDerivedStateFromError === "function" || typeof instance2.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance2)) {
              var errorInfo = createCapturedValue(error$1, sourceFiber);
              var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
              enqueueUpdate(fiber, update);
              var eventTime = requestEventTime();
              var root2 = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
              if (root2 !== null) {
                markRootUpdated(root2, SyncLane, eventTime);
                ensureRootIsScheduled(root2, eventTime);
              }
              return;
            }
          }
          fiber = fiber.return;
        }
        {
          error2("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
        }
      }
      function pingSuspendedRoot(root2, wakeable, pingedLanes) {
        var pingCache = root2.pingCache;
        if (pingCache !== null) {
          pingCache.delete(wakeable);
        }
        var eventTime = requestEventTime();
        markRootPinged(root2, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root2);
        if (workInProgressRoot === root2 && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
          if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now$12() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
            prepareFreshStack(root2, NoLanes);
          } else {
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
          }
        }
        ensureRootIsScheduled(root2, eventTime);
      }
      function retryTimedOutBoundary(boundaryFiber, retryLane) {
        if (retryLane === NoLane) {
          retryLane = requestRetryLane(boundaryFiber);
        }
        var eventTime = requestEventTime();
        var root2 = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
        if (root2 !== null) {
          markRootUpdated(root2, retryLane, eventTime);
          ensureRootIsScheduled(root2, eventTime);
        }
      }
      function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) {
          retryLane = suspenseState.retryLane;
        }
        retryTimedOutBoundary(boundaryFiber, retryLane);
      }
      function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane;
        var retryCache;
        {
          switch (boundaryFiber.tag) {
            case SuspenseComponent:
              retryCache = boundaryFiber.stateNode;
              var suspenseState = boundaryFiber.memoizedState;
              if (suspenseState !== null) {
                retryLane = suspenseState.retryLane;
              }
              break;
            case SuspenseListComponent:
              retryCache = boundaryFiber.stateNode;
              break;
            default:
              throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
          }
        }
        if (retryCache !== null) {
          retryCache.delete(wakeable);
        }
        retryTimedOutBoundary(boundaryFiber, retryLane);
      }
      function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3e3 ? 3e3 : timeElapsed < 4320 ? 4320 : ceil2(timeElapsed / 1960) * 1960;
      }
      function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
          nestedUpdateCount = 0;
          rootWithNestedUpdates = null;
          throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        {
          if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error2("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
          }
        }
      }
      function flushRenderPhaseStrictModeWarningsInDEV() {
        {
          ReactStrictModeWarnings.flushLegacyContextWarning();
          {
            ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
          }
        }
      }
      function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        {
          setCurrentFiber(fiber);
          invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
          if (hasPassiveEffects) {
            invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
          }
          invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
          if (hasPassiveEffects) {
            invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
          }
          resetCurrentFiber();
        }
      }
      function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        {
          var current2 = firstChild;
          var subtreeRoot = null;
          while (current2 !== null) {
            var primarySubtreeFlag = current2.subtreeFlags & fiberFlags;
            if (current2 !== subtreeRoot && current2.child !== null && primarySubtreeFlag !== NoFlags) {
              current2 = current2.child;
            } else {
              if ((current2.flags & fiberFlags) !== NoFlags) {
                invokeEffectFn(current2);
              }
              if (current2.sibling !== null) {
                current2 = current2.sibling;
              } else {
                current2 = subtreeRoot = current2.return;
              }
            }
          }
        }
      }
      var didWarnStateUpdateForNotYetMountedComponent = null;
      function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        {
          if ((executionContext & RenderContext) !== NoContext) {
            return;
          }
          if (!(fiber.mode & ConcurrentMode)) {
            return;
          }
          var tag2 = fiber.tag;
          if (tag2 !== IndeterminateComponent && tag2 !== HostRoot && tag2 !== ClassComponent && tag2 !== FunctionComponent && tag2 !== ForwardRef && tag2 !== MemoComponent && tag2 !== SimpleMemoComponent) {
            return;
          }
          var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
          if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
              return;
            }
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
          } else {
            didWarnStateUpdateForNotYetMountedComponent = /* @__PURE__ */ new Set([componentName]);
          }
          var previousFiber = current;
          try {
            setCurrentFiber(fiber);
            error2("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
          } finally {
            if (previousFiber) {
              setCurrentFiber(fiber);
            } else {
              resetCurrentFiber();
            }
          }
        }
      }
      var beginWork$1;
      {
        var dummyFiber = null;
        beginWork$1 = function(current2, unitOfWork, lanes) {
          var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
          try {
            return beginWork(current2, unitOfWork, lanes);
          } catch (originalError) {
            if (originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") {
              throw originalError;
            }
            resetContextDependencies();
            resetHooksAfterThrow();
            unwindInterruptedWork(current2, unitOfWork);
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) {
              startProfilerTimer(unitOfWork);
            }
            invokeGuardedCallback(null, beginWork, null, current2, unitOfWork, lanes);
            if (hasCaughtError()) {
              var replayError = clearCaughtError();
              if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) {
                originalError._suppressLogging = true;
              }
            }
            throw originalError;
          }
        };
      }
      var didWarnAboutUpdateInRender = false;
      var didWarnAboutUpdateInRenderForAnotherComponent;
      {
        didWarnAboutUpdateInRenderForAnotherComponent = /* @__PURE__ */ new Set();
      }
      function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        {
          if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
            switch (fiber.tag) {
              case FunctionComponent:
              case ForwardRef:
              case SimpleMemoComponent: {
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                  didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                  var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                  error2("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
              }
              case ClassComponent: {
                if (!didWarnAboutUpdateInRender) {
                  error2("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                  didWarnAboutUpdateInRender = true;
                }
                break;
              }
            }
          }
        }
      }
      function restorePendingUpdaters(root2, lanes) {
        {
          if (isDevToolsPresent) {
            var memoizedUpdaters = root2.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
              addFiberToLanesMap(root2, schedulingFiber, lanes);
            });
          }
        }
      }
      var fakeActCallbackNode = {};
      function scheduleCallback$1(priorityLevel, callback) {
        {
          var actQueue = ReactCurrentActQueue$1.current;
          if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
          } else {
            return scheduleCallback(priorityLevel, callback);
          }
        }
      }
      function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) {
          return;
        }
        return cancelCallback(callbackNode);
      }
      function shouldForceFlushFallbacksInDEV() {
        return ReactCurrentActQueue$1.current !== null;
      }
      function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        {
          if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) {
              return;
            }
          } else {
            if (!isLegacyActEnvironment()) {
              return;
            }
            if (executionContext !== NoContext) {
              return;
            }
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) {
              return;
            }
          }
          if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
              setCurrentFiber(fiber);
              error2("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally {
              if (previousFiber) {
                setCurrentFiber(fiber);
              } else {
                resetCurrentFiber();
              }
            }
          }
        }
      }
      function warnIfSuspenseResolutionNotWrappedWithActDEV(root2) {
        {
          if (root2.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) {
            error2("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
          }
        }
      }
      var resolveFamily = null;
      var failedBoundaries = null;
      var setRefreshHandler = function(handler) {
        {
          resolveFamily = handler;
        }
      };
      function resolveFunctionForHotReloading(type) {
        {
          if (resolveFamily === null) {
            return type;
          }
          var family = resolveFamily(type);
          if (family === void 0) {
            return type;
          }
          return family.current;
        }
      }
      function resolveClassForHotReloading(type) {
        return resolveFunctionForHotReloading(type);
      }
      function resolveForwardRefForHotReloading(type) {
        {
          if (resolveFamily === null) {
            return type;
          }
          var family = resolveFamily(type);
          if (family === void 0) {
            if (type !== null && type !== void 0 && typeof type.render === "function") {
              var currentRender = resolveFunctionForHotReloading(type.render);
              if (type.render !== currentRender) {
                var syntheticType = {
                  $$typeof: REACT_FORWARD_REF_TYPE,
                  render: currentRender
                };
                if (type.displayName !== void 0) {
                  syntheticType.displayName = type.displayName;
                }
                return syntheticType;
              }
            }
            return type;
          }
          return family.current;
        }
      }
      function isCompatibleFamilyForHotReloading(fiber, element) {
        {
          if (resolveFamily === null) {
            return false;
          }
          var prevType = fiber.elementType;
          var nextType = element.type;
          var needsCompareFamilies = false;
          var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
          switch (fiber.tag) {
            case ClassComponent: {
              if (typeof nextType === "function") {
                needsCompareFamilies = true;
              }
              break;
            }
            case FunctionComponent: {
              if (typeof nextType === "function") {
                needsCompareFamilies = true;
              } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                needsCompareFamilies = true;
              }
              break;
            }
            case ForwardRef: {
              if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                needsCompareFamilies = true;
              } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                needsCompareFamilies = true;
              }
              break;
            }
            case MemoComponent:
            case SimpleMemoComponent: {
              if ($$typeofNextType === REACT_MEMO_TYPE) {
                needsCompareFamilies = true;
              } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                needsCompareFamilies = true;
              }
              break;
            }
            default:
              return false;
          }
          if (needsCompareFamilies) {
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== void 0 && prevFamily === resolveFamily(nextType)) {
              return true;
            }
          }
          return false;
        }
      }
      function markFailedErrorBoundaryForHotReloading(fiber) {
        {
          if (resolveFamily === null) {
            return;
          }
          if (typeof WeakSet !== "function") {
            return;
          }
          if (failedBoundaries === null) {
            failedBoundaries = /* @__PURE__ */ new WeakSet();
          }
          failedBoundaries.add(fiber);
        }
      }
      var scheduleRefresh = function(root2, update) {
        {
          if (resolveFamily === null) {
            return;
          }
          var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
          flushPassiveEffects();
          flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root2.current, updatedFamilies, staleFamilies);
          });
        }
      };
      var scheduleRoot = function(root2, element) {
        {
          if (root2.context !== emptyContextObject) {
            return;
          }
          flushPassiveEffects();
          flushSync(function() {
            updateContainer(element, root2, null, null);
          });
        }
      };
      function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        {
          var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag2 = fiber.tag, type = fiber.type;
          var candidateType = null;
          switch (tag2) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          if (resolveFamily === null) {
            throw new Error("Expected resolveFamily to be set during hot reload.");
          }
          var needsRender = false;
          var needsRemount = false;
          if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== void 0) {
              if (staleFamilies.has(family)) {
                needsRemount = true;
              } else if (updatedFamilies.has(family)) {
                if (tag2 === ClassComponent) {
                  needsRemount = true;
                } else {
                  needsRender = true;
                }
              }
            }
          }
          if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
              needsRemount = true;
            }
          }
          if (needsRemount) {
            fiber._debugNeedsRemount = true;
          }
          if (needsRemount || needsRender) {
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
          if (child !== null && !needsRemount) {
            scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
          }
          if (sibling !== null) {
            scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
          }
        }
      }
      var findHostInstancesForRefresh = function(root2, families) {
        {
          var hostInstances = /* @__PURE__ */ new Set();
          var types2 = new Set(families.map(function(family) {
            return family.current;
          }));
          findHostInstancesForMatchingFibersRecursively(root2.current, types2, hostInstances);
          return hostInstances;
        }
      };
      function findHostInstancesForMatchingFibersRecursively(fiber, types2, hostInstances) {
        {
          var child = fiber.child, sibling = fiber.sibling, tag2 = fiber.tag, type = fiber.type;
          var candidateType = null;
          switch (tag2) {
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
              candidateType = type;
              break;
            case ForwardRef:
              candidateType = type.render;
              break;
          }
          var didMatch = false;
          if (candidateType !== null) {
            if (types2.has(candidateType)) {
              didMatch = true;
            }
          }
          if (didMatch) {
            findHostInstancesForFiberShallowly(fiber, hostInstances);
          } else {
            if (child !== null) {
              findHostInstancesForMatchingFibersRecursively(child, types2, hostInstances);
            }
          }
          if (sibling !== null) {
            findHostInstancesForMatchingFibersRecursively(sibling, types2, hostInstances);
          }
        }
      }
      function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
          if (foundHostInstances) {
            return;
          }
          var node = fiber;
          while (true) {
            switch (node.tag) {
              case HostComponent:
                hostInstances.add(node.stateNode);
                return;
              case HostPortal:
                hostInstances.add(node.stateNode.containerInfo);
                return;
              case HostRoot:
                hostInstances.add(node.stateNode.containerInfo);
                return;
            }
            if (node.return === null) {
              throw new Error("Expected to reach root first.");
            }
            node = node.return;
          }
        }
      }
      function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        {
          var node = fiber;
          var foundHostInstances = false;
          while (true) {
            if (node.tag === HostComponent) {
              foundHostInstances = true;
              hostInstances.add(node.stateNode);
            } else if (node.child !== null) {
              node.child.return = node;
              node = node.child;
              continue;
            }
            if (node === fiber) {
              return foundHostInstances;
            }
            while (node.sibling === null) {
              if (node.return === null || node.return === fiber) {
                return foundHostInstances;
              }
              node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
          }
        }
        return false;
      }
      var hasBadMapPolyfill;
      {
        hasBadMapPolyfill = false;
        try {
          var nonExtensibleObject = Object.preventExtensions({});
          /* @__PURE__ */ new Map([[nonExtensibleObject, null]]);
          /* @__PURE__ */ new Set([nonExtensibleObject]);
        } catch (e3) {
          hasBadMapPolyfill = true;
        }
      }
      function FiberNode(tag2, pendingProps, key, mode2) {
        this.tag = tag2;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null;
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode2;
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        {
          this.actualDuration = Number.NaN;
          this.actualStartTime = Number.NaN;
          this.selfBaseDuration = Number.NaN;
          this.treeBaseDuration = Number.NaN;
          this.actualDuration = 0;
          this.actualStartTime = -1;
          this.selfBaseDuration = 0;
          this.treeBaseDuration = 0;
        }
        {
          this._debugSource = null;
          this._debugOwner = null;
          this._debugNeedsRemount = false;
          this._debugHookTypes = null;
          if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") {
            Object.preventExtensions(this);
          }
        }
      }
      var createFiber = function(tag2, pendingProps, key, mode2) {
        return new FiberNode(tag2, pendingProps, key, mode2);
      };
      function shouldConstruct$1(Component2) {
        var prototype2 = Component2.prototype;
        return !!(prototype2 && prototype2.isReactComponent);
      }
      function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === void 0;
      }
      function resolveLazyComponentTag(Component2) {
        if (typeof Component2 === "function") {
          return shouldConstruct$1(Component2) ? ClassComponent : FunctionComponent;
        } else if (Component2 !== void 0 && Component2 !== null) {
          var $$typeof = Component2.$$typeof;
          if ($$typeof === REACT_FORWARD_REF_TYPE) {
            return ForwardRef;
          }
          if ($$typeof === REACT_MEMO_TYPE) {
            return MemoComponent;
          }
        }
        return IndeterminateComponent;
      }
      function createWorkInProgress(current2, pendingProps) {
        var workInProgress2 = current2.alternate;
        if (workInProgress2 === null) {
          workInProgress2 = createFiber(current2.tag, pendingProps, current2.key, current2.mode);
          workInProgress2.elementType = current2.elementType;
          workInProgress2.type = current2.type;
          workInProgress2.stateNode = current2.stateNode;
          {
            workInProgress2._debugSource = current2._debugSource;
            workInProgress2._debugOwner = current2._debugOwner;
            workInProgress2._debugHookTypes = current2._debugHookTypes;
          }
          workInProgress2.alternate = current2;
          current2.alternate = workInProgress2;
        } else {
          workInProgress2.pendingProps = pendingProps;
          workInProgress2.type = current2.type;
          workInProgress2.flags = NoFlags;
          workInProgress2.subtreeFlags = NoFlags;
          workInProgress2.deletions = null;
          {
            workInProgress2.actualDuration = 0;
            workInProgress2.actualStartTime = -1;
          }
        }
        workInProgress2.flags = current2.flags & StaticMask;
        workInProgress2.childLanes = current2.childLanes;
        workInProgress2.lanes = current2.lanes;
        workInProgress2.child = current2.child;
        workInProgress2.memoizedProps = current2.memoizedProps;
        workInProgress2.memoizedState = current2.memoizedState;
        workInProgress2.updateQueue = current2.updateQueue;
        var currentDependencies = current2.dependencies;
        workInProgress2.dependencies = currentDependencies === null ? null : {
          lanes: currentDependencies.lanes,
          firstContext: currentDependencies.firstContext
        };
        workInProgress2.sibling = current2.sibling;
        workInProgress2.index = current2.index;
        workInProgress2.ref = current2.ref;
        {
          workInProgress2.selfBaseDuration = current2.selfBaseDuration;
          workInProgress2.treeBaseDuration = current2.treeBaseDuration;
        }
        {
          workInProgress2._debugNeedsRemount = current2._debugNeedsRemount;
          switch (workInProgress2.tag) {
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
              workInProgress2.type = resolveFunctionForHotReloading(current2.type);
              break;
            case ClassComponent:
              workInProgress2.type = resolveClassForHotReloading(current2.type);
              break;
            case ForwardRef:
              workInProgress2.type = resolveForwardRefForHotReloading(current2.type);
              break;
          }
        }
        return workInProgress2;
      }
      function resetWorkInProgress(workInProgress2, renderLanes2) {
        workInProgress2.flags &= StaticMask | Placement;
        var current2 = workInProgress2.alternate;
        if (current2 === null) {
          workInProgress2.childLanes = NoLanes;
          workInProgress2.lanes = renderLanes2;
          workInProgress2.child = null;
          workInProgress2.subtreeFlags = NoFlags;
          workInProgress2.memoizedProps = null;
          workInProgress2.memoizedState = null;
          workInProgress2.updateQueue = null;
          workInProgress2.dependencies = null;
          workInProgress2.stateNode = null;
          {
            workInProgress2.selfBaseDuration = 0;
            workInProgress2.treeBaseDuration = 0;
          }
        } else {
          workInProgress2.childLanes = current2.childLanes;
          workInProgress2.lanes = current2.lanes;
          workInProgress2.child = current2.child;
          workInProgress2.subtreeFlags = NoFlags;
          workInProgress2.deletions = null;
          workInProgress2.memoizedProps = current2.memoizedProps;
          workInProgress2.memoizedState = current2.memoizedState;
          workInProgress2.updateQueue = current2.updateQueue;
          workInProgress2.type = current2.type;
          var currentDependencies = current2.dependencies;
          workInProgress2.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
          };
          {
            workInProgress2.selfBaseDuration = current2.selfBaseDuration;
            workInProgress2.treeBaseDuration = current2.treeBaseDuration;
          }
        }
        return workInProgress2;
      }
      function createHostRootFiber(tag2, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode2;
        if (tag2 === ConcurrentRoot) {
          mode2 = ConcurrentMode;
          if (isStrictMode === true) {
            mode2 |= StrictLegacyMode;
            {
              mode2 |= StrictEffectsMode;
            }
          }
        } else {
          mode2 = NoMode;
        }
        if (isDevToolsPresent) {
          mode2 |= ProfileMode;
        }
        return createFiber(HostRoot, null, null, mode2);
      }
      function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode2, lanes) {
        var fiberTag = IndeterminateComponent;
        var resolvedType = type;
        if (typeof type === "function") {
          if (shouldConstruct$1(type)) {
            fiberTag = ClassComponent;
            {
              resolvedType = resolveClassForHotReloading(resolvedType);
            }
          } else {
            {
              resolvedType = resolveFunctionForHotReloading(resolvedType);
            }
          }
        } else if (typeof type === "string") {
          fiberTag = HostComponent;
        } else {
          getTag:
            switch (type) {
              case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode2, lanes, key);
              case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode2 |= StrictLegacyMode;
                if ((mode2 & ConcurrentMode) !== NoMode) {
                  mode2 |= StrictEffectsMode;
                }
                break;
              case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode2, lanes, key);
              case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode2, lanes, key);
              case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode2, lanes, key);
              case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode2, lanes, key);
              case REACT_LEGACY_HIDDEN_TYPE:
              case REACT_SCOPE_TYPE:
              case REACT_CACHE_TYPE:
              case REACT_TRACING_MARKER_TYPE:
              case REACT_DEBUG_TRACING_MODE_TYPE:
              default: {
                if (typeof type === "object" && type !== null) {
                  switch (type.$$typeof) {
                    case REACT_PROVIDER_TYPE:
                      fiberTag = ContextProvider;
                      break getTag;
                    case REACT_CONTEXT_TYPE:
                      fiberTag = ContextConsumer;
                      break getTag;
                    case REACT_FORWARD_REF_TYPE:
                      fiberTag = ForwardRef;
                      {
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                      }
                      break getTag;
                    case REACT_MEMO_TYPE:
                      fiberTag = MemoComponent;
                      break getTag;
                    case REACT_LAZY_TYPE:
                      fiberTag = LazyComponent;
                      resolvedType = null;
                      break getTag;
                  }
                }
                var info = "";
                {
                  if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
                    info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                  }
                  var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                  if (ownerName) {
                    info += "\n\nCheck the render method of `" + ownerName + "`.";
                  }
                }
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
              }
            }
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode2);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        {
          fiber._debugOwner = owner;
        }
        return fiber;
      }
      function createFiberFromElement(element, mode2, lanes) {
        var owner = null;
        {
          owner = element._owner;
        }
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode2, lanes);
        {
          fiber._debugSource = element._source;
          fiber._debugOwner = element._owner;
        }
        return fiber;
      }
      function createFiberFromFragment(elements, mode2, lanes, key) {
        var fiber = createFiber(Fragment2, elements, key, mode2);
        fiber.lanes = lanes;
        return fiber;
      }
      function createFiberFromProfiler(pendingProps, mode2, lanes, key) {
        {
          if (typeof pendingProps.id !== "string") {
            error2('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
          }
        }
        var fiber = createFiber(Profiler, pendingProps, key, mode2 | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        {
          fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
          };
        }
        return fiber;
      }
      function createFiberFromSuspense(pendingProps, mode2, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode2);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
      }
      function createFiberFromSuspenseList(pendingProps, mode2, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode2);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
      }
      function createFiberFromOffscreen(pendingProps, mode2, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode2);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {};
        fiber.stateNode = primaryChildInstance;
        return fiber;
      }
      function createFiberFromText(content, mode2, lanes) {
        var fiber = createFiber(HostText, content, null, mode2);
        fiber.lanes = lanes;
        return fiber;
      }
      function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
      }
      function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
      }
      function createFiberFromPortal(portal, mode2, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode2);
        fiber.lanes = lanes;
        fiber.stateNode = {
          containerInfo: portal.containerInfo,
          pendingChildren: null,
          // Used by persistent updates
          implementation: portal.implementation
        };
        return fiber;
      }
      function assignFiberPropertiesInDEV(target, source) {
        if (target === null) {
          target = createFiber(IndeterminateComponent, null, null, NoMode);
        }
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        {
          target.actualDuration = source.actualDuration;
          target.actualStartTime = source.actualStartTime;
          target.selfBaseDuration = source.selfBaseDuration;
          target.treeBaseDuration = source.treeBaseDuration;
        }
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
      }
      function FiberRootNode(containerInfo, tag2, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag2;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        if (supportsHydration) {
          this.mutableSourceEagerHydrationData = null;
        }
        {
          this.effectDuration = 0;
          this.passiveEffectDuration = 0;
        }
        {
          this.memoizedUpdaters = /* @__PURE__ */ new Set();
          var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
          for (var _i = 0; _i < TotalLanes; _i++) {
            pendingUpdatersLaneMap.push(/* @__PURE__ */ new Set());
          }
        }
        {
          switch (tag2) {
            case ConcurrentRoot:
              this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
              break;
            case LegacyRoot:
              this._debugRootType = hydrate ? "hydrate()" : "render()";
              break;
          }
        }
      }
      function createFiberRoot(containerInfo, tag2, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root2 = new FiberRootNode(containerInfo, tag2, hydrate, identifierPrefix, onRecoverableError);
        var uninitializedFiber = createHostRootFiber(tag2, isStrictMode);
        root2.current = uninitializedFiber;
        uninitializedFiber.stateNode = root2;
        {
          var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null
          };
          uninitializedFiber.memoizedState = _initialState;
        }
        initializeUpdateQueue(uninitializedFiber);
        return root2;
      }
      var ReactVersion = "18.0.0-fc46dba67-20220329";
      function createPortal2(children, containerInfo, implementation2) {
        var key = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        {
          checkKeyStringCoercion(key);
        }
        return {
          // This tag allow us to uniquely identify this as a React Portal
          $$typeof: REACT_PORTAL_TYPE,
          key: key == null ? null : "" + key,
          children,
          containerInfo,
          implementation: implementation2
        };
      }
      var didWarnAboutNestedUpdates;
      var didWarnAboutFindNodeInStrictMode;
      {
        didWarnAboutNestedUpdates = false;
        didWarnAboutFindNodeInStrictMode = {};
      }
      function getContextForSubtree(parentComponent) {
        if (!parentComponent) {
          return emptyContextObject;
        }
        var fiber = get6(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
          var Component2 = fiber.type;
          if (isContextProvider(Component2)) {
            return processChildContext(fiber, Component2, parentContext);
          }
        }
        return parentContext;
      }
      function findHostInstance(component) {
        var fiber = get6(component);
        if (fiber === void 0) {
          if (typeof component.render === "function") {
            throw new Error("Unable to find node on an unmounted component.");
          } else {
            var keys4 = Object.keys(component).join(",");
            throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys4);
          }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) {
          return null;
        }
        return hostFiber.stateNode;
      }
      function findHostInstanceWithWarning(component, methodName) {
        {
          var fiber = get6(component);
          if (fiber === void 0) {
            if (typeof component.render === "function") {
              throw new Error("Unable to find node on an unmounted component.");
            } else {
              var keys4 = Object.keys(component).join(",");
              throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys4);
            }
          }
          var hostFiber = findCurrentHostFiber(fiber);
          if (hostFiber === null) {
            return null;
          }
          if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
              didWarnAboutFindNodeInStrictMode[componentName] = true;
              var previousFiber = current;
              try {
                setCurrentFiber(hostFiber);
                if (fiber.mode & StrictLegacyMode) {
                  error2("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } else {
                  error2("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                }
              } finally {
                if (previousFiber) {
                  setCurrentFiber(previousFiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
          return hostFiber.stateNode;
        }
      }
      function createContainer(containerInfo, tag2, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag2, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
      }
      function createHydrationContainer(initialChildren, callback, containerInfo, tag2, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root2 = createFiberRoot(containerInfo, tag2, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        root2.context = getContextForSubtree(null);
        var current2 = root2.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current2);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== void 0 && callback !== null ? callback : null;
        enqueueUpdate(current2, update);
        scheduleInitialHydrationOnRoot(root2, lane, eventTime);
        return root2;
      }
      function updateContainer(element, container, parentComponent, callback) {
        {
          onScheduleRoot(container, element);
        }
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        {
          markRenderScheduled(lane);
        }
        var context2 = getContextForSubtree(parentComponent);
        if (container.context === null) {
          container.context = context2;
        } else {
          container.pendingContext = context2;
        }
        {
          if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error2("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
          }
        }
        var update = createUpdate(eventTime, lane);
        update.payload = {
          element
        };
        callback = callback === void 0 ? null : callback;
        if (callback !== null) {
          {
            if (typeof callback !== "function") {
              error2("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            }
          }
          update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        var root2 = scheduleUpdateOnFiber(current$1, lane, eventTime);
        if (root2 !== null) {
          entangleTransitions(root2, current$1, lane);
        }
        return lane;
      }
      function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) {
          return null;
        }
        switch (containerFiber.child.tag) {
          case HostComponent:
            return getPublicInstance(containerFiber.child.stateNode);
          default:
            return containerFiber.child.stateNode;
        }
      }
      function attemptSynchronousHydration(fiber) {
        switch (fiber.tag) {
          case HostRoot:
            var root2 = fiber.stateNode;
            if (isRootDehydrated(root2)) {
              var lanes = getHighestPriorityPendingLanes(root2);
              flushRoot(root2, lanes);
            }
            break;
          case SuspenseComponent:
            var eventTime = requestEventTime();
            flushSync(function() {
              return scheduleUpdateOnFiber(fiber, SyncLane, eventTime);
            });
            var retryLane = SyncLane;
            markRetryLaneIfNotHydrated(fiber, retryLane);
            break;
        }
      }
      function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) {
          suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
        }
      }
      function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) {
          markRetryLaneImpl(alternate, retryLane);
        }
      }
      function attemptContinuousHydration(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          return;
        }
        var eventTime = requestEventTime();
        var lane = SelectiveHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
      }
      function attemptHydrationAtCurrentPriority(fiber) {
        if (fiber.tag !== SuspenseComponent) {
          return;
        }
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
      }
      function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) {
          return null;
        }
        return hostFiber.stateNode;
      }
      var shouldErrorImpl = function(fiber) {
        return null;
      };
      function shouldError(fiber) {
        return shouldErrorImpl(fiber);
      }
      var shouldSuspendImpl = function(fiber) {
        return false;
      };
      function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
      }
      var overrideHookState = null;
      var overrideHookStateDeletePath = null;
      var overrideHookStateRenamePath = null;
      var overrideProps = null;
      var overridePropsDeletePath = null;
      var overridePropsRenamePath = null;
      var scheduleUpdate = null;
      var setErrorHandler = null;
      var setSuspenseHandler = null;
      {
        var copyWithDeleteImpl = function(obj, path2, index3) {
          var key = path2[index3];
          var updated = isArray3(obj) ? obj.slice() : assign3({}, obj);
          if (index3 + 1 === path2.length) {
            if (isArray3(updated)) {
              updated.splice(key, 1);
            } else {
              delete updated[key];
            }
            return updated;
          }
          updated[key] = copyWithDeleteImpl(obj[key], path2, index3 + 1);
          return updated;
        };
        var copyWithDelete = function(obj, path2) {
          return copyWithDeleteImpl(obj, path2, 0);
        };
        var copyWithRenameImpl = function(obj, oldPath, newPath, index3) {
          var oldKey = oldPath[index3];
          var updated = isArray3(obj) ? obj.slice() : assign3({}, obj);
          if (index3 + 1 === oldPath.length) {
            var newKey = newPath[index3];
            updated[newKey] = updated[oldKey];
            if (isArray3(updated)) {
              updated.splice(oldKey, 1);
            } else {
              delete updated[oldKey];
            }
          } else {
            updated[oldKey] = copyWithRenameImpl(
              // $FlowFixMe number or string is fine here
              obj[oldKey],
              oldPath,
              newPath,
              index3 + 1
            );
          }
          return updated;
        };
        var copyWithRename = function(obj, oldPath, newPath) {
          if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
          } else {
            for (var i2 = 0; i2 < newPath.length - 1; i2++) {
              if (oldPath[i2] !== newPath[i2]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
              }
            }
          }
          return copyWithRenameImpl(obj, oldPath, newPath, 0);
        };
        var copyWithSetImpl = function(obj, path2, index3, value) {
          if (index3 >= path2.length) {
            return value;
          }
          var key = path2[index3];
          var updated = isArray3(obj) ? obj.slice() : assign3({}, obj);
          updated[key] = copyWithSetImpl(obj[key], path2, index3 + 1, value);
          return updated;
        };
        var copyWithSet = function(obj, path2, value) {
          return copyWithSetImpl(obj, path2, 0, value);
        };
        var findHook = function(fiber, id) {
          var currentHook2 = fiber.memoizedState;
          while (currentHook2 !== null && id > 0) {
            currentHook2 = currentHook2.next;
            id--;
          }
          return currentHook2;
        };
        overrideHookState = function(fiber, id, path2, value) {
          var hook = findHook(fiber, id);
          if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path2, value);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign3({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };
        overrideHookStateDeletePath = function(fiber, id, path2) {
          var hook = findHook(fiber, id);
          if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path2);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign3({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };
        overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
          var hook = findHook(fiber, id);
          if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState;
            fiber.memoizedProps = assign3({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          }
        };
        overrideProps = function(fiber, path2, value) {
          fiber.pendingProps = copyWithSet(fiber.memoizedProps, path2, value);
          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }
          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };
        overridePropsDeletePath = function(fiber, path2) {
          fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path2);
          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }
          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };
        overridePropsRenamePath = function(fiber, oldPath, newPath) {
          fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
          if (fiber.alternate) {
            fiber.alternate.pendingProps = fiber.pendingProps;
          }
          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };
        scheduleUpdate = function(fiber) {
          scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        };
        setErrorHandler = function(newShouldErrorImpl) {
          shouldErrorImpl = newShouldErrorImpl;
        };
        setSuspenseHandler = function(newShouldSuspendImpl) {
          shouldSuspendImpl = newShouldSuspendImpl;
        };
      }
      function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) {
          return null;
        }
        return hostFiber.stateNode;
      }
      function emptyFindFiberByHostInstance(instance2) {
        return null;
      }
      function getCurrentFiberForDevTools() {
        return current;
      }
      function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher2 = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
          bundleType: devToolsConfig.bundleType,
          version: devToolsConfig.version,
          rendererPackageName: devToolsConfig.rendererPackageName,
          rendererConfig: devToolsConfig.rendererConfig,
          overrideHookState,
          overrideHookStateDeletePath,
          overrideHookStateRenamePath,
          overrideProps,
          overridePropsDeletePath,
          overridePropsRenamePath,
          setErrorHandler,
          setSuspenseHandler,
          scheduleUpdate,
          currentDispatcherRef: ReactCurrentDispatcher2,
          findHostInstanceByFiber,
          findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
          // React Refresh
          findHostInstancesForRefresh,
          scheduleRefresh,
          scheduleRoot,
          setRefreshHandler,
          // Enables DevTools to append owner stacks to error messages in DEV mode.
          getCurrentFiber: getCurrentFiberForDevTools,
          // Enables DevTools to detect reconciler version rather than renderer version
          // which may not match for third party renderers.
          reconcilerVersion: ReactVersion
        });
      }
      exports2.attemptContinuousHydration = attemptContinuousHydration;
      exports2.attemptHydrationAtCurrentPriority = attemptHydrationAtCurrentPriority;
      exports2.attemptSynchronousHydration = attemptSynchronousHydration;
      exports2.batchedUpdates = batchedUpdates;
      exports2.createComponentSelector = createComponentSelector;
      exports2.createContainer = createContainer;
      exports2.createHasPseudoClassSelector = createHasPseudoClassSelector;
      exports2.createHydrationContainer = createHydrationContainer;
      exports2.createPortal = createPortal2;
      exports2.createRoleSelector = createRoleSelector;
      exports2.createTestNameSelector = createTestNameSelector;
      exports2.createTextSelector = createTextSelector;
      exports2.deferredUpdates = deferredUpdates;
      exports2.discreteUpdates = discreteUpdates;
      exports2.findAllNodes = findAllNodes;
      exports2.findBoundingRects = findBoundingRects;
      exports2.findHostInstance = findHostInstance;
      exports2.findHostInstanceWithNoPortals = findHostInstanceWithNoPortals;
      exports2.findHostInstanceWithWarning = findHostInstanceWithWarning;
      exports2.flushControlled = flushControlled;
      exports2.flushPassiveEffects = flushPassiveEffects;
      exports2.flushSync = flushSync;
      exports2.focusWithin = focusWithin;
      exports2.getCurrentUpdatePriority = getCurrentUpdatePriority;
      exports2.getFindAllNodesFailureDescription = getFindAllNodesFailureDescription;
      exports2.getPublicRootInstance = getPublicRootInstance;
      exports2.injectIntoDevTools = injectIntoDevTools;
      exports2.isAlreadyRendering = isAlreadyRendering;
      exports2.observeVisibleRects = observeVisibleRects;
      exports2.registerMutableSourceForHydration = registerMutableSourceForHydration;
      exports2.runWithPriority = runWithPriority;
      exports2.shouldError = shouldError;
      exports2.shouldSuspend = shouldSuspend;
      exports2.updateContainer = updateContainer;
      return exports2;
    };
  }
  return reactReconciler_developmentExports;
}
(function(module2) {
  if (process.env.NODE_ENV === "production") {
    module2.exports = requireReactReconciler_production_min();
  } else {
    module2.exports = requireReactReconciler_development();
  }
})(reactReconciler);
const Reconciler = /* @__PURE__ */ getDefaultExportFromCjs$1(reactReconcilerExports);
const catalogue = {};
const extend = (objects) => void Object.assign(catalogue, objects);
function createRenderer(_roots, _getEventPriority) {
  function createInstance(type, {
    args = [],
    attach: attach2,
    ...props
  }, root2) {
    let name2 = `${type[0].toUpperCase()}${type.slice(1)}`;
    let instance2;
    if (type === "primitive") {
      if (props.object === void 0)
        throw new Error("R3F: Primitives without 'object' are invalid!");
      const object2 = props.object;
      instance2 = prepare(object2, {
        type,
        root: root2,
        attach: attach2,
        primitive: true
      });
    } else {
      const target = catalogue[name2];
      if (!target) {
        throw new Error(`R3F: ${name2} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
      }
      if (!Array.isArray(args))
        throw new Error("R3F: The args prop must be an array!");
      instance2 = prepare(new target(...args), {
        type,
        root: root2,
        attach: attach2,
        // Save args in case we need to reconstruct later for HMR
        memoizedProps: {
          args
        }
      });
    }
    if (instance2.__r3f.attach === void 0) {
      if (instance2.isBufferGeometry)
        instance2.__r3f.attach = "geometry";
      else if (instance2.isMaterial)
        instance2.__r3f.attach = "material";
    }
    if (name2 !== "inject")
      applyProps$1(instance2, props);
    return instance2;
  }
  function appendChild(parentInstance, child) {
    let added = false;
    if (child) {
      var _child$__r3f, _parentInstance$__r3f;
      if ((_child$__r3f = child.__r3f) != null && _child$__r3f.attach) {
        attach(parentInstance, child, child.__r3f.attach);
      } else if (child.isObject3D && parentInstance.isObject3D) {
        parentInstance.add(child);
        added = true;
      }
      if (!added)
        (_parentInstance$__r3f = parentInstance.__r3f) == null ? void 0 : _parentInstance$__r3f.objects.push(child);
      if (!child.__r3f)
        prepare(child, {});
      child.__r3f.parent = parentInstance;
      updateInstance(child);
      invalidateInstance(child);
    }
  }
  function insertBefore(parentInstance, child, beforeChild) {
    let added = false;
    if (child) {
      var _child$__r3f2, _parentInstance$__r3f2;
      if ((_child$__r3f2 = child.__r3f) != null && _child$__r3f2.attach) {
        attach(parentInstance, child, child.__r3f.attach);
      } else if (child.isObject3D && parentInstance.isObject3D) {
        child.parent = parentInstance;
        child.dispatchEvent({
          type: "added"
        });
        parentInstance.dispatchEvent({
          type: "childadded",
          child
        });
        const restSiblings = parentInstance.children.filter((sibling) => sibling !== child);
        const index2 = restSiblings.indexOf(beforeChild);
        parentInstance.children = [...restSiblings.slice(0, index2), child, ...restSiblings.slice(index2)];
        added = true;
      }
      if (!added)
        (_parentInstance$__r3f2 = parentInstance.__r3f) == null ? void 0 : _parentInstance$__r3f2.objects.push(child);
      if (!child.__r3f)
        prepare(child, {});
      child.__r3f.parent = parentInstance;
      updateInstance(child);
      invalidateInstance(child);
    }
  }
  function removeRecursive(array2, parent, dispose2 = false) {
    if (array2)
      [...array2].forEach((child) => removeChild(parent, child, dispose2));
  }
  function removeChild(parentInstance, child, dispose2) {
    if (child) {
      var _parentInstance$__r3f3, _child$__r3f3, _child$__r3f5;
      if (child.__r3f)
        child.__r3f.parent = null;
      if ((_parentInstance$__r3f3 = parentInstance.__r3f) != null && _parentInstance$__r3f3.objects)
        parentInstance.__r3f.objects = parentInstance.__r3f.objects.filter((x2) => x2 !== child);
      if ((_child$__r3f3 = child.__r3f) != null && _child$__r3f3.attach) {
        detach(parentInstance, child, child.__r3f.attach);
      } else if (child.isObject3D && parentInstance.isObject3D) {
        var _child$__r3f4;
        parentInstance.remove(child);
        if ((_child$__r3f4 = child.__r3f) != null && _child$__r3f4.root) {
          removeInteractivity(findInitialRoot(child), child);
        }
      }
      const isPrimitive = (_child$__r3f5 = child.__r3f) == null ? void 0 : _child$__r3f5.primitive;
      const shouldDispose = !isPrimitive && (dispose2 === void 0 ? child.dispose !== null : dispose2);
      if (!isPrimitive) {
        var _child$__r3f6;
        removeRecursive((_child$__r3f6 = child.__r3f) == null ? void 0 : _child$__r3f6.objects, child, shouldDispose);
        removeRecursive(child.children, child, shouldDispose);
      }
      delete child.__r3f;
      if (shouldDispose && child.dispose && child.type !== "Scene") {
        const callback = () => {
          try {
            child.dispose();
          } catch (e3) {
          }
        };
        if (typeof IS_REACT_ACT_ENVIRONMENT === "undefined") {
          schedulerExports.unstable_scheduleCallback(schedulerExports.unstable_IdlePriority, callback);
        } else {
          callback();
        }
      }
      invalidateInstance(parentInstance);
    }
  }
  function switchInstance(instance2, type, newProps, fiber) {
    var _instance$__r3f;
    const parent = (_instance$__r3f = instance2.__r3f) == null ? void 0 : _instance$__r3f.parent;
    if (!parent)
      return;
    const newInstance = createInstance(type, newProps, instance2.__r3f.root);
    if (instance2.children) {
      for (const child of instance2.children) {
        if (child.__r3f)
          appendChild(newInstance, child);
      }
      instance2.children = instance2.children.filter((child) => !child.__r3f);
    }
    instance2.__r3f.objects.forEach((child) => appendChild(newInstance, child));
    instance2.__r3f.objects = [];
    if (!instance2.__r3f.autoRemovedBeforeAppend) {
      removeChild(parent, instance2);
    }
    if (newInstance.parent) {
      newInstance.__r3f.autoRemovedBeforeAppend = true;
    }
    appendChild(parent, newInstance);
    if (newInstance.raycast && newInstance.__r3f.eventCount) {
      const rootState = findInitialRoot(newInstance).getState();
      rootState.internal.interaction.push(newInstance);
    }
    [fiber, fiber.alternate].forEach((fiber2) => {
      if (fiber2 !== null) {
        fiber2.stateNode = newInstance;
        if (fiber2.ref) {
          if (typeof fiber2.ref === "function")
            fiber2.ref(newInstance);
          else
            fiber2.ref.current = newInstance;
        }
      }
    });
  }
  const handleTextInstance = () => {
  };
  const reconciler2 = Reconciler({
    createInstance,
    removeChild,
    appendChild,
    appendInitialChild: appendChild,
    insertBefore,
    supportsMutation: true,
    isPrimaryRenderer: false,
    supportsPersistence: false,
    supportsHydration: false,
    noTimeout: -1,
    appendChildToContainer: (container, child) => {
      if (!child)
        return;
      const scene = container.getState().scene;
      if (!scene.__r3f)
        return;
      scene.__r3f.root = container;
      appendChild(scene, child);
    },
    removeChildFromContainer: (container, child) => {
      if (!child)
        return;
      removeChild(container.getState().scene, child);
    },
    insertInContainerBefore: (container, child, beforeChild) => {
      if (!child || !beforeChild)
        return;
      const scene = container.getState().scene;
      if (!scene.__r3f)
        return;
      insertBefore(scene, child, beforeChild);
    },
    getRootHostContext: () => null,
    getChildHostContext: (parentHostContext) => parentHostContext,
    finalizeInitialChildren(instance2) {
      var _instance$__r3f2;
      const localState = (_instance$__r3f2 = instance2 == null ? void 0 : instance2.__r3f) != null ? _instance$__r3f2 : {};
      return Boolean(localState.handlers);
    },
    prepareUpdate(instance2, _type, oldProps, newProps) {
      var _instance$__r3f3;
      const localState = (_instance$__r3f3 = instance2 == null ? void 0 : instance2.__r3f) != null ? _instance$__r3f3 : {};
      if (localState.primitive && newProps.object && newProps.object !== instance2) {
        return [true];
      } else {
        const {
          args: argsNew = [],
          children: cN,
          ...restNew
        } = newProps;
        const {
          args: argsOld = [],
          children: cO,
          ...restOld
        } = oldProps;
        if (!Array.isArray(argsNew))
          throw new Error("R3F: the args prop must be an array!");
        if (argsNew.some((value, index2) => value !== argsOld[index2]))
          return [true];
        const diff2 = diffProps(instance2, restNew, restOld, true);
        if (diff2.changes.length)
          return [false, diff2];
        return null;
      }
    },
    commitUpdate(instance2, [reconstruct, diff2], type, _oldProps, newProps, fiber) {
      if (reconstruct)
        switchInstance(instance2, type, newProps, fiber);
      else
        applyProps$1(instance2, diff2);
    },
    commitMount(instance2, _type, _props, _int) {
      var _instance$__r3f4;
      const localState = (_instance$__r3f4 = instance2.__r3f) != null ? _instance$__r3f4 : {};
      if (instance2.raycast && localState.handlers && localState.eventCount) {
        findInitialRoot(instance2).getState().internal.interaction.push(instance2);
      }
    },
    getPublicInstance: (instance2) => instance2,
    prepareForCommit: () => null,
    preparePortalMount: (container) => prepare(container.getState().scene),
    resetAfterCommit: () => {
    },
    shouldSetTextContent: () => false,
    clearContainer: () => false,
    hideInstance(instance2) {
      var _instance$__r3f5;
      const {
        attach: type,
        parent
      } = (_instance$__r3f5 = instance2.__r3f) != null ? _instance$__r3f5 : {};
      if (type && parent)
        detach(parent, instance2, type);
      if (instance2.isObject3D)
        instance2.visible = false;
      invalidateInstance(instance2);
    },
    unhideInstance(instance2, props) {
      var _instance$__r3f6;
      const {
        attach: type,
        parent
      } = (_instance$__r3f6 = instance2.__r3f) != null ? _instance$__r3f6 : {};
      if (type && parent)
        attach(parent, instance2, type);
      if (instance2.isObject3D && props.visible == null || props.visible)
        instance2.visible = true;
      invalidateInstance(instance2);
    },
    createTextInstance: handleTextInstance,
    hideTextInstance: handleTextInstance,
    unhideTextInstance: handleTextInstance,
    // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r916356874
    // @ts-expect-error
    getCurrentEventPriority: () => _getEventPriority ? _getEventPriority() : constantsExports.DefaultEventPriority,
    beforeActiveInstanceBlur: () => {
    },
    afterActiveInstanceBlur: () => {
    },
    detachDeletedInstance: () => {
    },
    now: typeof performance !== "undefined" && is.fun(performance.now) ? performance.now : is.fun(Date.now) ? Date.now : () => 0,
    // https://github.com/pmndrs/react-three-fiber/pull/2360#discussion_r920883503
    scheduleTimeout: is.fun(setTimeout) ? setTimeout : void 0,
    cancelTimeout: is.fun(clearTimeout) ? clearTimeout : void 0
  });
  return {
    reconciler: reconciler2,
    applyProps: applyProps$1
  };
}
var _window$document, _window$navigator;
const hasColorSpace = (object2) => "colorSpace" in object2 || "outputColorSpace" in object2;
const getColorManagement = () => {
  var _ColorManagement;
  return (_ColorManagement = catalogue.ColorManagement) != null ? _ColorManagement : null;
};
const isOrthographicCamera = (def) => def && def.isOrthographicCamera;
const isRef = (obj) => obj && obj.hasOwnProperty("current");
const useIsomorphicLayoutEffect = typeof window !== "undefined" && ((_window$document = window.document) != null && _window$document.createElement || ((_window$navigator = window.navigator) == null ? void 0 : _window$navigator.product) === "ReactNative") ? React.useLayoutEffect : React.useEffect;
function useMutableCallback(fn2) {
  const ref = React.useRef(fn2);
  useIsomorphicLayoutEffect(() => void (ref.current = fn2), [fn2]);
  return ref;
}
function Block({
  set
}) {
  useIsomorphicLayoutEffect(() => {
    set(new Promise(() => null));
    return () => set(false);
  }, [set]);
  return null;
}
let ErrorBoundary$1 = class ErrorBoundary2 extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      error: false
    };
  }
  componentDidCatch(err) {
    this.props.set(err);
  }
  render() {
    return this.state.error ? null : this.props.children;
  }
};
ErrorBoundary$1.getDerivedStateFromError = () => ({
  error: true
});
const DEFAULT = "__default";
const DEFAULTS = /* @__PURE__ */ new Map();
const isDiffSet = (def) => def && !!def.memoized && !!def.changes;
function calculateDpr(dpr) {
  var _window$devicePixelRa;
  const target = typeof window !== "undefined" ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
  return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
const getRootState = (obj) => {
  var _r3f;
  return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
};
function findInitialRoot(child) {
  let root2 = child.__r3f.root;
  while (root2.getState().previousRoot)
    root2 = root2.getState().previousRoot;
  return root2;
}
const is = {
  obj: (a2) => a2 === Object(a2) && !is.arr(a2) && typeof a2 !== "function",
  fun: (a2) => typeof a2 === "function",
  str: (a2) => typeof a2 === "string",
  num: (a2) => typeof a2 === "number",
  boo: (a2) => typeof a2 === "boolean",
  und: (a2) => a2 === void 0,
  arr: (a2) => Array.isArray(a2),
  equ(a2, b2, {
    arrays = "shallow",
    objects = "reference",
    strict = true
  } = {}) {
    if (typeof a2 !== typeof b2 || !!a2 !== !!b2)
      return false;
    if (is.str(a2) || is.num(a2) || is.boo(a2))
      return a2 === b2;
    const isObj = is.obj(a2);
    if (isObj && objects === "reference")
      return a2 === b2;
    const isArr = is.arr(a2);
    if (isArr && arrays === "reference")
      return a2 === b2;
    if ((isArr || isObj) && a2 === b2)
      return true;
    let i2;
    for (i2 in a2)
      if (!(i2 in b2))
        return false;
    if (isObj && arrays === "shallow" && objects === "shallow") {
      for (i2 in strict ? b2 : a2)
        if (!is.equ(a2[i2], b2[i2], {
          strict,
          objects: "reference"
        }))
          return false;
    } else {
      for (i2 in strict ? b2 : a2)
        if (a2[i2] !== b2[i2])
          return false;
    }
    if (is.und(i2)) {
      if (isArr && a2.length === 0 && b2.length === 0)
        return true;
      if (isObj && Object.keys(a2).length === 0 && Object.keys(b2).length === 0)
        return true;
      if (a2 !== b2)
        return false;
    }
    return true;
  }
};
function buildGraph(object2) {
  const data2 = {
    nodes: {},
    materials: {}
  };
  if (object2) {
    object2.traverse((obj) => {
      if (obj.name)
        data2.nodes[obj.name] = obj;
      if (obj.material && !data2.materials[obj.material.name])
        data2.materials[obj.material.name] = obj.material;
    });
  }
  return data2;
}
function dispose(obj) {
  if (obj.dispose && obj.type !== "Scene")
    obj.dispose();
  for (const p2 in obj) {
    p2.dispose == null ? void 0 : p2.dispose();
    delete obj[p2];
  }
}
function prepare(object2, state) {
  const instance2 = object2;
  instance2.__r3f = {
    type: "",
    root: null,
    previousAttach: null,
    memoizedProps: {},
    eventCount: 0,
    handlers: {},
    objects: [],
    parent: null,
    ...state
  };
  return object2;
}
function resolve(instance2, key) {
  let target = instance2;
  if (key.includes("-")) {
    const entries = key.split("-");
    const last = entries.pop();
    target = entries.reduce((acc, key2) => acc[key2], instance2);
    return {
      target,
      key: last
    };
  } else
    return {
      target,
      key
    };
}
const INDEX_REGEX = /-\d+$/;
function attach(parent, child, type) {
  if (is.str(type)) {
    if (INDEX_REGEX.test(type)) {
      const root2 = type.replace(INDEX_REGEX, "");
      const {
        target: target2,
        key: key2
      } = resolve(parent, root2);
      if (!Array.isArray(target2[key2]))
        target2[key2] = [];
    }
    const {
      target,
      key
    } = resolve(parent, type);
    child.__r3f.previousAttach = target[key];
    target[key] = child;
  } else
    child.__r3f.previousAttach = type(parent, child);
}
function detach(parent, child, type) {
  var _child$__r3f, _child$__r3f2;
  if (is.str(type)) {
    const {
      target,
      key
    } = resolve(parent, type);
    const previous = child.__r3f.previousAttach;
    if (previous === void 0)
      delete target[key];
    else
      target[key] = previous;
  } else
    (_child$__r3f = child.__r3f) == null ? void 0 : _child$__r3f.previousAttach == null ? void 0 : _child$__r3f.previousAttach(parent, child);
  (_child$__r3f2 = child.__r3f) == null ? true : delete _child$__r3f2.previousAttach;
}
function diffProps(instance2, {
  children: cN,
  key: kN,
  ref: rN,
  ...props
}, {
  children: cP,
  key: kP,
  ref: rP,
  ...previous
} = {}, remove6 = false) {
  const localState = instance2.__r3f;
  const entries = Object.entries(props);
  const changes = [];
  if (remove6) {
    const previousKeys = Object.keys(previous);
    for (let i2 = 0; i2 < previousKeys.length; i2++) {
      if (!props.hasOwnProperty(previousKeys[i2]))
        entries.unshift([previousKeys[i2], DEFAULT + "remove"]);
    }
  }
  entries.forEach(([key, value]) => {
    var _instance$__r3f;
    if ((_instance$__r3f = instance2.__r3f) != null && _instance$__r3f.primitive && key === "object")
      return;
    if (is.equ(value, previous[key]))
      return;
    if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(key))
      return changes.push([key, value, true, []]);
    let entries2 = [];
    if (key.includes("-"))
      entries2 = key.split("-");
    changes.push([key, value, false, entries2]);
    for (const prop in props) {
      const value2 = props[prop];
      if (prop.startsWith(`${key}-`))
        changes.push([prop, value2, false, prop.split("-")]);
    }
  });
  const memoized = {
    ...props
  };
  if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.args)
    memoized.args = localState.memoizedProps.args;
  if (localState != null && localState.memoizedProps && localState != null && localState.memoizedProps.attach)
    memoized.attach = localState.memoizedProps.attach;
  return {
    memoized,
    changes
  };
}
const __DEV__ = typeof process !== "undefined" && process.env.NODE_ENV !== "production";
function applyProps$1(instance2, data2) {
  var _instance$__r3f2;
  const localState = instance2.__r3f;
  const root2 = localState == null ? void 0 : localState.root;
  const rootState = root2 == null ? void 0 : root2.getState == null ? void 0 : root2.getState();
  const {
    memoized,
    changes
  } = isDiffSet(data2) ? data2 : diffProps(instance2, data2);
  const prevHandlers = localState == null ? void 0 : localState.eventCount;
  if (instance2.__r3f)
    instance2.__r3f.memoizedProps = memoized;
  for (let i2 = 0; i2 < changes.length; i2++) {
    let [key, value, isEvent, keys4] = changes[i2];
    if (hasColorSpace(instance2)) {
      const sRGBEncoding2 = 3001;
      const SRGBColorSpace2 = "srgb";
      const LinearSRGBColorSpace2 = "srgb-linear";
      if (key === "encoding") {
        key = "colorSpace";
        value = value === sRGBEncoding2 ? SRGBColorSpace2 : LinearSRGBColorSpace2;
      } else if (key === "outputEncoding") {
        key = "outputColorSpace";
        value = value === sRGBEncoding2 ? SRGBColorSpace2 : LinearSRGBColorSpace2;
      }
    }
    let currentInstance = instance2;
    let targetProp = currentInstance[key];
    if (keys4.length) {
      targetProp = keys4.reduce((acc, key2) => acc[key2], instance2);
      if (!(targetProp && targetProp.set)) {
        const [name2, ...reverseEntries] = keys4.reverse();
        currentInstance = reverseEntries.reverse().reduce((acc, key2) => acc[key2], instance2);
        key = name2;
      }
    }
    if (value === DEFAULT + "remove") {
      if (currentInstance.constructor) {
        let ctor = DEFAULTS.get(currentInstance.constructor);
        if (!ctor) {
          ctor = new currentInstance.constructor();
          DEFAULTS.set(currentInstance.constructor, ctor);
        }
        value = ctor[key];
      } else {
        value = 0;
      }
    }
    if (isEvent && localState) {
      if (value)
        localState.handlers[key] = value;
      else
        delete localState.handlers[key];
      localState.eventCount = Object.keys(localState.handlers).length;
    } else if (targetProp && targetProp.set && (targetProp.copy || targetProp instanceof Layers)) {
      if (Array.isArray(value)) {
        if (targetProp.fromArray)
          targetProp.fromArray(value);
        else
          targetProp.set(...value);
      } else if (targetProp.copy && value && value.constructor && // Some environments may break strict identity checks by duplicating versions of three.js.
      // Loosen to unminified names, ignoring descendents.
      // https://github.com/pmndrs/react-three-fiber/issues/2856
      // TODO: fix upstream and remove in v9
      (__DEV__ ? targetProp.constructor.name === value.constructor.name : targetProp.constructor === value.constructor)) {
        targetProp.copy(value);
      } else if (value !== void 0) {
        var _targetProp;
        const isColor = (_targetProp = targetProp) == null ? void 0 : _targetProp.isColor;
        if (!isColor && targetProp.setScalar)
          targetProp.setScalar(value);
        else if (targetProp instanceof Layers && value instanceof Layers)
          targetProp.mask = value.mask;
        else
          targetProp.set(value);
        if (!getColorManagement() && rootState && !rootState.linear && isColor)
          targetProp.convertSRGBToLinear();
      }
    } else {
      var _currentInstance$key;
      currentInstance[key] = value;
      if ((_currentInstance$key = currentInstance[key]) != null && _currentInstance$key.isTexture && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
      currentInstance[key].format === RGBAFormat && currentInstance[key].type === UnsignedByteType && rootState) {
        const texture = currentInstance[key];
        if (hasColorSpace(texture) && hasColorSpace(rootState.gl))
          texture.colorSpace = rootState.gl.outputColorSpace;
        else
          texture.encoding = rootState.gl.outputEncoding;
      }
    }
    invalidateInstance(instance2);
  }
  if (localState && localState.parent && instance2.raycast && prevHandlers !== localState.eventCount) {
    const internal = findInitialRoot(instance2).getState().internal;
    const index2 = internal.interaction.indexOf(instance2);
    if (index2 > -1)
      internal.interaction.splice(index2, 1);
    if (localState.eventCount)
      internal.interaction.push(instance2);
  }
  const isCircular = changes.length === 1 && changes[0][0] === "onUpdate";
  if (!isCircular && changes.length && (_instance$__r3f2 = instance2.__r3f) != null && _instance$__r3f2.parent)
    updateInstance(instance2);
  return instance2;
}
function invalidateInstance(instance2) {
  var _instance$__r3f3, _instance$__r3f3$root;
  const state = (_instance$__r3f3 = instance2.__r3f) == null ? void 0 : (_instance$__r3f3$root = _instance$__r3f3.root) == null ? void 0 : _instance$__r3f3$root.getState == null ? void 0 : _instance$__r3f3$root.getState();
  if (state && state.internal.frames === 0)
    state.invalidate();
}
function updateInstance(instance2) {
  instance2.onUpdate == null ? void 0 : instance2.onUpdate(instance2);
}
function updateCamera(camera, size12) {
  if (!camera.manual) {
    if (isOrthographicCamera(camera)) {
      camera.left = size12.width / -2;
      camera.right = size12.width / 2;
      camera.top = size12.height / 2;
      camera.bottom = size12.height / -2;
    } else {
      camera.aspect = size12.width / size12.height;
    }
    camera.updateProjectionMatrix();
    camera.updateMatrixWorld();
  }
}
function makeId(event) {
  return (event.eventObject || event.object).uuid + "/" + event.index + event.instanceId;
}
function getEventPriority() {
  var _globalScope$event;
  const globalScope = typeof self !== "undefined" && self || typeof window !== "undefined" && window;
  if (!globalScope)
    return constantsExports.DefaultEventPriority;
  const name2 = (_globalScope$event = globalScope.event) == null ? void 0 : _globalScope$event.type;
  switch (name2) {
    case "click":
    case "contextmenu":
    case "dblclick":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
      return constantsExports.DiscreteEventPriority;
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "pointerenter":
    case "pointerleave":
    case "wheel":
      return constantsExports.ContinuousEventPriority;
    default:
      return constantsExports.DefaultEventPriority;
  }
}
function releaseInternalPointerCapture(capturedMap, obj, captures, pointerId2) {
  const captureData = captures.get(obj);
  if (captureData) {
    captures.delete(obj);
    if (captures.size === 0) {
      capturedMap.delete(pointerId2);
      captureData.target.releasePointerCapture(pointerId2);
    }
  }
}
function removeInteractivity(store2, object2) {
  const {
    internal
  } = store2.getState();
  internal.interaction = internal.interaction.filter((o2) => o2 !== object2);
  internal.initialHits = internal.initialHits.filter((o2) => o2 !== object2);
  internal.hovered.forEach((value, key) => {
    if (value.eventObject === object2 || value.object === object2) {
      internal.hovered.delete(key);
    }
  });
  internal.capturedMap.forEach((captures, pointerId2) => {
    releaseInternalPointerCapture(internal.capturedMap, object2, captures, pointerId2);
  });
}
function createEvents(store2) {
  function calculateDistance(event) {
    const {
      internal
    } = store2.getState();
    const dx = event.offsetX - internal.initialClick[0];
    const dy = event.offsetY - internal.initialClick[1];
    return Math.round(Math.sqrt(dx * dx + dy * dy));
  }
  function filterPointerEvents(objects) {
    return objects.filter((obj) => ["Move", "Over", "Enter", "Out", "Leave"].some((name2) => {
      var _r3f;
      return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers["onPointer" + name2];
    }));
  }
  function intersect2(event, filter17) {
    const state = store2.getState();
    const duplicates = /* @__PURE__ */ new Set();
    const intersections = [];
    const eventsObjects = filter17 ? filter17(state.internal.interaction) : state.internal.interaction;
    for (let i2 = 0; i2 < eventsObjects.length; i2++) {
      const state2 = getRootState(eventsObjects[i2]);
      if (state2) {
        state2.raycaster.camera = void 0;
      }
    }
    if (!state.previousRoot) {
      state.events.compute == null ? void 0 : state.events.compute(event, state);
    }
    function handleRaycast(obj) {
      const state2 = getRootState(obj);
      if (!state2 || !state2.events.enabled || state2.raycaster.camera === null)
        return [];
      if (state2.raycaster.camera === void 0) {
        var _state$previousRoot;
        state2.events.compute == null ? void 0 : state2.events.compute(event, state2, (_state$previousRoot = state2.previousRoot) == null ? void 0 : _state$previousRoot.getState());
        if (state2.raycaster.camera === void 0)
          state2.raycaster.camera = null;
      }
      return state2.raycaster.camera ? state2.raycaster.intersectObject(obj, true) : [];
    }
    let hits = eventsObjects.flatMap(handleRaycast).sort((a2, b2) => {
      const aState = getRootState(a2.object);
      const bState = getRootState(b2.object);
      if (!aState || !bState)
        return a2.distance - b2.distance;
      return bState.events.priority - aState.events.priority || a2.distance - b2.distance;
    }).filter((item) => {
      const id = makeId(item);
      if (duplicates.has(id))
        return false;
      duplicates.add(id);
      return true;
    });
    if (state.events.filter)
      hits = state.events.filter(hits, state);
    for (const hit of hits) {
      let eventObject = hit.object;
      while (eventObject) {
        var _r3f2;
        if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount)
          intersections.push({
            ...hit,
            eventObject
          });
        eventObject = eventObject.parent;
      }
    }
    if ("pointerId" in event && state.internal.capturedMap.has(event.pointerId)) {
      for (let captureData of state.internal.capturedMap.get(event.pointerId).values()) {
        if (!duplicates.has(makeId(captureData.intersection)))
          intersections.push(captureData.intersection);
      }
    }
    return intersections;
  }
  function handleIntersects(intersections, event, delta, callback) {
    const rootState = store2.getState();
    if (intersections.length) {
      const localState = {
        stopped: false
      };
      for (const hit of intersections) {
        const state = getRootState(hit.object) || rootState;
        const {
          raycaster,
          pointer,
          camera,
          internal
        } = state;
        const unprojectedPoint = new Vector3$1(pointer.x, pointer.y, 0).unproject(camera);
        const hasPointerCapture = (id) => {
          var _internal$capturedMap, _internal$capturedMap2;
          return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
        };
        const setPointerCapture = (id) => {
          const captureData = {
            intersection: hit,
            target: event.target
          };
          if (internal.capturedMap.has(id)) {
            internal.capturedMap.get(id).set(hit.eventObject, captureData);
          } else {
            internal.capturedMap.set(id, /* @__PURE__ */ new Map([[hit.eventObject, captureData]]));
          }
          event.target.setPointerCapture(id);
        };
        const releasePointerCapture = (id) => {
          const captures = internal.capturedMap.get(id);
          if (captures) {
            releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
          }
        };
        let extractEventProps = {};
        for (let prop in event) {
          let property2 = event[prop];
          if (typeof property2 !== "function")
            extractEventProps[prop] = property2;
        }
        let raycastEvent = {
          ...hit,
          ...extractEventProps,
          pointer,
          intersections,
          stopped: localState.stopped,
          delta,
          unprojectedPoint,
          ray: raycaster.ray,
          camera,
          // Hijack stopPropagation, which just sets a flag
          stopPropagation() {
            const capturesForPointer = "pointerId" in event && internal.capturedMap.get(event.pointerId);
            if (
              // ...if this pointer hasn't been captured
              !capturesForPointer || // ... or if the hit object is capturing the pointer
              capturesForPointer.has(hit.eventObject)
            ) {
              raycastEvent.stopped = localState.stopped = true;
              if (internal.hovered.size && Array.from(internal.hovered.values()).find((i2) => i2.eventObject === hit.eventObject)) {
                const higher = intersections.slice(0, intersections.indexOf(hit));
                cancelPointer([...higher, hit]);
              }
            }
          },
          // there should be a distinction between target and currentTarget
          target: {
            hasPointerCapture,
            setPointerCapture,
            releasePointerCapture
          },
          currentTarget: {
            hasPointerCapture,
            setPointerCapture,
            releasePointerCapture
          },
          nativeEvent: event
        };
        callback(raycastEvent);
        if (localState.stopped === true)
          break;
      }
    }
    return intersections;
  }
  function cancelPointer(intersections) {
    const {
      internal
    } = store2.getState();
    for (const hoveredObj of internal.hovered.values()) {
      if (!intersections.length || !intersections.find((hit) => hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
        const eventObject = hoveredObj.eventObject;
        const instance2 = eventObject.__r3f;
        const handlers2 = instance2 == null ? void 0 : instance2.handlers;
        internal.hovered.delete(makeId(hoveredObj));
        if (instance2 != null && instance2.eventCount) {
          const data2 = {
            ...hoveredObj,
            intersections
          };
          handlers2.onPointerOut == null ? void 0 : handlers2.onPointerOut(data2);
          handlers2.onPointerLeave == null ? void 0 : handlers2.onPointerLeave(data2);
        }
      }
    }
  }
  function pointerMissed(event, objects) {
    for (let i2 = 0; i2 < objects.length; i2++) {
      const instance2 = objects[i2].__r3f;
      instance2 == null ? void 0 : instance2.handlers.onPointerMissed == null ? void 0 : instance2.handlers.onPointerMissed(event);
    }
  }
  function handlePointer(name2) {
    switch (name2) {
      case "onPointerLeave":
      case "onPointerCancel":
        return () => cancelPointer([]);
      case "onLostPointerCapture":
        return (event) => {
          const {
            internal
          } = store2.getState();
          if ("pointerId" in event && internal.capturedMap.has(event.pointerId)) {
            requestAnimationFrame(() => {
              if (internal.capturedMap.has(event.pointerId)) {
                internal.capturedMap.delete(event.pointerId);
                cancelPointer([]);
              }
            });
          }
        };
    }
    return function handleEvent(event) {
      const {
        onPointerMissed,
        internal
      } = store2.getState();
      internal.lastEvent.current = event;
      const isPointerMove = name2 === "onPointerMove";
      const isClickEvent = name2 === "onClick" || name2 === "onContextMenu" || name2 === "onDoubleClick";
      const filter17 = isPointerMove ? filterPointerEvents : void 0;
      const hits = intersect2(event, filter17);
      const delta = isClickEvent ? calculateDistance(event) : 0;
      if (name2 === "onPointerDown") {
        internal.initialClick = [event.offsetX, event.offsetY];
        internal.initialHits = hits.map((hit) => hit.eventObject);
      }
      if (isClickEvent && !hits.length) {
        if (delta <= 2) {
          pointerMissed(event, internal.interaction);
          if (onPointerMissed)
            onPointerMissed(event);
        }
      }
      if (isPointerMove)
        cancelPointer(hits);
      function onIntersect(data2) {
        const eventObject = data2.eventObject;
        const instance2 = eventObject.__r3f;
        const handlers2 = instance2 == null ? void 0 : instance2.handlers;
        if (!(instance2 != null && instance2.eventCount))
          return;
        if (isPointerMove) {
          if (handlers2.onPointerOver || handlers2.onPointerEnter || handlers2.onPointerOut || handlers2.onPointerLeave) {
            const id = makeId(data2);
            const hoveredItem = internal.hovered.get(id);
            if (!hoveredItem) {
              internal.hovered.set(id, data2);
              handlers2.onPointerOver == null ? void 0 : handlers2.onPointerOver(data2);
              handlers2.onPointerEnter == null ? void 0 : handlers2.onPointerEnter(data2);
            } else if (hoveredItem.stopped) {
              data2.stopPropagation();
            }
          }
          handlers2.onPointerMove == null ? void 0 : handlers2.onPointerMove(data2);
        } else {
          const handler = handlers2[name2];
          if (handler) {
            if (!isClickEvent || internal.initialHits.includes(eventObject)) {
              pointerMissed(event, internal.interaction.filter((object2) => !internal.initialHits.includes(object2)));
              handler(data2);
            }
          } else {
            if (isClickEvent && internal.initialHits.includes(eventObject)) {
              pointerMissed(event, internal.interaction.filter((object2) => !internal.initialHits.includes(object2)));
            }
          }
        }
      }
      handleIntersects(hits, event, delta, onIntersect);
    };
  }
  return {
    handlePointer
  };
}
const isRenderer = (def) => !!(def != null && def.render);
const context = /* @__PURE__ */ React.createContext(null);
const createStore = (invalidate2, advance2) => {
  const rootState = create((set, get6) => {
    const position = new Vector3$1();
    const defaultTarget = new Vector3$1();
    const tempTarget = new Vector3$1();
    function getCurrentViewport(camera = get6().camera, target = defaultTarget, size12 = get6().size) {
      const {
        width,
        height,
        top,
        left
      } = size12;
      const aspect2 = width / height;
      if (target.isVector3)
        tempTarget.copy(target);
      else
        tempTarget.set(...target);
      const distance11 = camera.getWorldPosition(position).distanceTo(tempTarget);
      if (isOrthographicCamera(camera)) {
        return {
          width: width / camera.zoom,
          height: height / camera.zoom,
          top,
          left,
          factor: 1,
          distance: distance11,
          aspect: aspect2
        };
      } else {
        const fov2 = camera.fov * Math.PI / 180;
        const h2 = 2 * Math.tan(fov2 / 2) * distance11;
        const w2 = h2 * (width / height);
        return {
          width: w2,
          height: h2,
          top,
          left,
          factor: width / w2,
          distance: distance11,
          aspect: aspect2
        };
      }
    }
    let performanceTimeout = void 0;
    const setPerformanceCurrent = (current) => set((state2) => ({
      performance: {
        ...state2.performance,
        current
      }
    }));
    const pointer = new Vector2$1();
    const rootState2 = {
      set,
      get: get6,
      // Mock objects that have to be configured
      gl: null,
      camera: null,
      raycaster: null,
      events: {
        priority: 1,
        enabled: true,
        connected: false
      },
      xr: null,
      scene: null,
      invalidate: (frames = 1) => invalidate2(get6(), frames),
      advance: (timestamp2, runGlobalEffects) => advance2(timestamp2, runGlobalEffects, get6()),
      legacy: false,
      linear: false,
      flat: false,
      controls: null,
      clock: new Clock(),
      pointer,
      mouse: pointer,
      frameloop: "always",
      onPointerMissed: void 0,
      performance: {
        current: 1,
        min: 0.5,
        max: 1,
        debounce: 200,
        regress: () => {
          const state2 = get6();
          if (performanceTimeout)
            clearTimeout(performanceTimeout);
          if (state2.performance.current !== state2.performance.min)
            setPerformanceCurrent(state2.performance.min);
          performanceTimeout = setTimeout(() => setPerformanceCurrent(get6().performance.max), state2.performance.debounce);
        }
      },
      size: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        updateStyle: false
      },
      viewport: {
        initialDpr: 0,
        dpr: 0,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        aspect: 0,
        distance: 0,
        factor: 0,
        getCurrentViewport
      },
      setEvents: (events2) => set((state2) => ({
        ...state2,
        events: {
          ...state2.events,
          ...events2
        }
      })),
      setSize: (width, height, updateStyle, top, left) => {
        const camera = get6().camera;
        const size12 = {
          width,
          height,
          top: top || 0,
          left: left || 0,
          updateStyle
        };
        set((state2) => ({
          size: size12,
          viewport: {
            ...state2.viewport,
            ...getCurrentViewport(camera, defaultTarget, size12)
          }
        }));
      },
      setDpr: (dpr) => set((state2) => {
        const resolved = calculateDpr(dpr);
        return {
          viewport: {
            ...state2.viewport,
            dpr: resolved,
            initialDpr: state2.viewport.initialDpr || resolved
          }
        };
      }),
      setFrameloop: (frameloop = "always") => {
        const clock = get6().clock;
        clock.stop();
        clock.elapsedTime = 0;
        if (frameloop !== "never") {
          clock.start();
          clock.elapsedTime = 0;
        }
        set(() => ({
          frameloop
        }));
      },
      previousRoot: void 0,
      internal: {
        active: false,
        priority: 0,
        frames: 0,
        lastEvent: /* @__PURE__ */ React.createRef(),
        interaction: [],
        hovered: /* @__PURE__ */ new Map(),
        subscribers: [],
        initialClick: [0, 0],
        initialHits: [],
        capturedMap: /* @__PURE__ */ new Map(),
        subscribe: (ref, priority, store2) => {
          const internal = get6().internal;
          internal.priority = internal.priority + (priority > 0 ? 1 : 0);
          internal.subscribers.push({
            ref,
            priority,
            store: store2
          });
          internal.subscribers = internal.subscribers.sort((a2, b2) => a2.priority - b2.priority);
          return () => {
            const internal2 = get6().internal;
            if (internal2 != null && internal2.subscribers) {
              internal2.priority = internal2.priority - (priority > 0 ? 1 : 0);
              internal2.subscribers = internal2.subscribers.filter((s2) => s2.ref !== ref);
            }
          };
        }
      }
    };
    return rootState2;
  });
  const state = rootState.getState();
  let oldSize = state.size;
  let oldDpr = state.viewport.dpr;
  let oldCamera = state.camera;
  rootState.subscribe(() => {
    const {
      camera,
      size: size12,
      viewport,
      gl,
      set
    } = rootState.getState();
    if (size12.width !== oldSize.width || size12.height !== oldSize.height || viewport.dpr !== oldDpr) {
      var _size$updateStyle;
      oldSize = size12;
      oldDpr = viewport.dpr;
      updateCamera(camera, size12);
      gl.setPixelRatio(viewport.dpr);
      const updateStyle = (_size$updateStyle = size12.updateStyle) != null ? _size$updateStyle : typeof HTMLCanvasElement !== "undefined" && gl.domElement instanceof HTMLCanvasElement;
      gl.setSize(size12.width, size12.height, updateStyle);
    }
    if (camera !== oldCamera) {
      oldCamera = camera;
      set((state2) => ({
        viewport: {
          ...state2.viewport,
          ...state2.viewport.getCurrentViewport(camera)
        }
      }));
    }
  });
  rootState.subscribe((state2) => invalidate2(state2));
  return rootState;
};
let i;
let globalEffects = /* @__PURE__ */ new Set();
let globalAfterEffects = /* @__PURE__ */ new Set();
let globalTailEffects = /* @__PURE__ */ new Set();
function run(effects, timestamp2) {
  if (!effects.size)
    return;
  for (const {
    callback
  } of effects.values()) {
    callback(timestamp2);
  }
}
function flushGlobalEffects(type, timestamp2) {
  switch (type) {
    case "before":
      return run(globalEffects, timestamp2);
    case "after":
      return run(globalAfterEffects, timestamp2);
    case "tail":
      return run(globalTailEffects, timestamp2);
  }
}
let subscribers;
let subscription;
function render$1(timestamp2, state, frame) {
  let delta = state.clock.getDelta();
  if (state.frameloop === "never" && typeof timestamp2 === "number") {
    delta = timestamp2 - state.clock.elapsedTime;
    state.clock.oldTime = state.clock.elapsedTime;
    state.clock.elapsedTime = timestamp2;
  }
  subscribers = state.internal.subscribers;
  for (i = 0; i < subscribers.length; i++) {
    subscription = subscribers[i];
    subscription.ref.current(subscription.store.getState(), delta, frame);
  }
  if (!state.internal.priority && state.gl.render)
    state.gl.render(state.scene, state.camera);
  state.internal.frames = Math.max(0, state.internal.frames - 1);
  return state.frameloop === "always" ? 1 : state.internal.frames;
}
function createLoop(roots2) {
  let running = false;
  let useFrameInProgress = false;
  let repeat;
  let frame;
  let state;
  function loop2(timestamp2) {
    frame = requestAnimationFrame(loop2);
    running = true;
    repeat = 0;
    flushGlobalEffects("before", timestamp2);
    useFrameInProgress = true;
    for (const root2 of roots2.values()) {
      var _state$gl$xr;
      state = root2.store.getState();
      if (state.internal.active && (state.frameloop === "always" || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) {
        repeat += render$1(timestamp2, state);
      }
    }
    useFrameInProgress = false;
    flushGlobalEffects("after", timestamp2);
    if (repeat === 0) {
      flushGlobalEffects("tail", timestamp2);
      running = false;
      return cancelAnimationFrame(frame);
    }
  }
  function invalidate2(state2, frames = 1) {
    var _state$gl$xr2;
    if (!state2)
      return roots2.forEach((root2) => invalidate2(root2.store.getState(), frames));
    if ((_state$gl$xr2 = state2.gl.xr) != null && _state$gl$xr2.isPresenting || !state2.internal.active || state2.frameloop === "never")
      return;
    if (frames > 1) {
      state2.internal.frames = Math.min(60, state2.internal.frames + frames);
    } else {
      if (useFrameInProgress) {
        state2.internal.frames = 2;
      } else {
        state2.internal.frames = 1;
      }
    }
    if (!running) {
      running = true;
      requestAnimationFrame(loop2);
    }
  }
  function advance2(timestamp2, runGlobalEffects = true, state2, frame2) {
    if (runGlobalEffects)
      flushGlobalEffects("before", timestamp2);
    if (!state2)
      for (const root2 of roots2.values())
        render$1(timestamp2, root2.store.getState());
    else
      render$1(timestamp2, state2, frame2);
    if (runGlobalEffects)
      flushGlobalEffects("after", timestamp2);
  }
  return {
    loop: loop2,
    invalidate: invalidate2,
    advance: advance2
  };
}
function useStore() {
  const store2 = React.useContext(context);
  if (!store2)
    throw new Error("R3F: Hooks can only be used within the Canvas component!");
  return store2;
}
function useThree(selector = (state) => state, equalityFn) {
  return useStore()(selector, equalityFn);
}
function useFrame(callback, renderPriority = 0) {
  const store2 = useStore();
  const subscribe = store2.getState().internal.subscribe;
  const ref = useMutableCallback(callback);
  useIsomorphicLayoutEffect(() => subscribe(ref, renderPriority, store2), [renderPriority, subscribe, store2]);
  return null;
}
const memoizedLoaders = /* @__PURE__ */ new WeakMap();
function loadingFn(extensions, onProgress) {
  return function(Proto, ...input) {
    let loader2 = memoizedLoaders.get(Proto);
    if (!loader2) {
      loader2 = new Proto();
      memoizedLoaders.set(Proto, loader2);
    }
    if (extensions)
      extensions(loader2);
    return Promise.all(input.map((input2) => new Promise((res, reject) => loader2.load(input2, (data2) => {
      if (data2.scene)
        Object.assign(data2, buildGraph(data2.scene));
      res(data2);
    }, onProgress, (error2) => reject(new Error(`Could not load ${input2}: ${error2 == null ? void 0 : error2.message}`))))));
  };
}
function useLoader(Proto, input, extensions, onProgress) {
  const keys4 = Array.isArray(input) ? input : [input];
  const results = suspend(loadingFn(extensions, onProgress), [Proto, ...keys4], {
    equal: is.equ
  });
  return Array.isArray(input) ? results : results[0];
}
useLoader.preload = function(Proto, input, extensions) {
  const keys4 = Array.isArray(input) ? input : [input];
  return preload(loadingFn(extensions), [Proto, ...keys4]);
};
useLoader.clear = function(Proto, input) {
  const keys4 = Array.isArray(input) ? input : [input];
  return clear([Proto, ...keys4]);
};
const roots = /* @__PURE__ */ new Map();
const {
  invalidate,
  advance
} = createLoop(roots);
const {
  reconciler,
  applyProps
} = createRenderer(roots, getEventPriority);
const shallowLoose = {
  objects: "shallow",
  strict: false
};
const createRendererInstance = (gl, canvas2) => {
  const customRenderer = typeof gl === "function" ? gl(canvas2) : gl;
  if (isRenderer(customRenderer))
    return customRenderer;
  else
    return new WebGLRenderer({
      powerPreference: "high-performance",
      canvas: canvas2,
      antialias: true,
      alpha: true,
      ...gl
    });
};
function computeInitialSize(canvas2, defaultSize) {
  const defaultStyle2 = typeof HTMLCanvasElement !== "undefined" && canvas2 instanceof HTMLCanvasElement;
  if (defaultSize) {
    const {
      width,
      height,
      top,
      left,
      updateStyle = defaultStyle2
    } = defaultSize;
    return {
      width,
      height,
      top,
      left,
      updateStyle
    };
  } else if (typeof HTMLCanvasElement !== "undefined" && canvas2 instanceof HTMLCanvasElement && canvas2.parentElement) {
    const {
      width,
      height,
      top,
      left
    } = canvas2.parentElement.getBoundingClientRect();
    return {
      width,
      height,
      top,
      left,
      updateStyle: defaultStyle2
    };
  } else if (typeof OffscreenCanvas !== "undefined" && canvas2 instanceof OffscreenCanvas) {
    return {
      width: canvas2.width,
      height: canvas2.height,
      top: 0,
      left: 0,
      updateStyle: defaultStyle2
    };
  }
  return {
    width: 0,
    height: 0,
    top: 0,
    left: 0
  };
}
function createRoot(canvas2) {
  const prevRoot = roots.get(canvas2);
  const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
  const prevStore = prevRoot == null ? void 0 : prevRoot.store;
  if (prevRoot)
    console.warn("R3F.createRoot should only be called once!");
  const logRecoverableError = typeof reportError === "function" ? (
    // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError
  ) : (
    // In older browsers and test environments, fallback to console.error.
    console.error
  );
  const store2 = prevStore || createStore(invalidate, advance);
  const fiber = prevFiber || reconciler.createContainer(store2, constantsExports.ConcurrentRoot, null, false, null, "", logRecoverableError, null);
  if (!prevRoot)
    roots.set(canvas2, {
      fiber,
      store: store2
    });
  let onCreated;
  let configured = false;
  let lastCamera;
  return {
    configure(props = {}) {
      let {
        gl: glConfig,
        size: propsSize,
        scene: sceneOptions,
        events: events2,
        onCreated: onCreatedCallback,
        shadows = false,
        linear = false,
        flat = false,
        legacy = false,
        orthographic = false,
        frameloop = "always",
        dpr = [1, 2],
        performance: performance2,
        raycaster: raycastOptions,
        camera: cameraOptions,
        onPointerMissed
      } = props;
      let state = store2.getState();
      let gl = state.gl;
      if (!state.gl)
        state.set({
          gl: gl = createRendererInstance(glConfig, canvas2)
        });
      let raycaster = state.raycaster;
      if (!raycaster)
        state.set({
          raycaster: raycaster = new Raycaster()
        });
      const {
        params: params2,
        ...options2
      } = raycastOptions || {};
      if (!is.equ(options2, raycaster, shallowLoose))
        applyProps(raycaster, {
          ...options2
        });
      if (!is.equ(params2, raycaster.params, shallowLoose))
        applyProps(raycaster, {
          params: {
            ...raycaster.params,
            ...params2
          }
        });
      if (!state.camera || state.camera === lastCamera && !is.equ(lastCamera, cameraOptions, shallowLoose)) {
        lastCamera = cameraOptions;
        const isCamera = cameraOptions instanceof Camera;
        const camera = isCamera ? cameraOptions : orthographic ? new OrthographicCamera(0, 0, 0, 0, 0.1, 1e3) : new PerspectiveCamera(75, 0, 0.1, 1e3);
        if (!isCamera) {
          camera.position.z = 5;
          if (cameraOptions) {
            applyProps(camera, cameraOptions);
            if ("aspect" in cameraOptions || "left" in cameraOptions || "right" in cameraOptions || "bottom" in cameraOptions || "top" in cameraOptions) {
              camera.manual = true;
              camera.updateProjectionMatrix();
            }
          }
          if (!state.camera && !(cameraOptions != null && cameraOptions.rotation))
            camera.lookAt(0, 0, 0);
        }
        state.set({
          camera
        });
        raycaster.camera = camera;
      }
      if (!state.scene) {
        let scene;
        if (sceneOptions != null && sceneOptions.isScene) {
          scene = sceneOptions;
        } else {
          scene = new Scene();
          if (sceneOptions)
            applyProps(scene, sceneOptions);
        }
        state.set({
          scene: prepare(scene)
        });
      }
      if (!state.xr) {
        var _gl$xr;
        const handleXRFrame = (timestamp2, frame) => {
          const state2 = store2.getState();
          if (state2.frameloop === "never")
            return;
          advance(timestamp2, true, state2, frame);
        };
        const handleSessionChange = () => {
          const state2 = store2.getState();
          state2.gl.xr.enabled = state2.gl.xr.isPresenting;
          state2.gl.xr.setAnimationLoop(state2.gl.xr.isPresenting ? handleXRFrame : null);
          if (!state2.gl.xr.isPresenting)
            invalidate(state2);
        };
        const xr = {
          connect() {
            const gl2 = store2.getState().gl;
            gl2.xr.addEventListener("sessionstart", handleSessionChange);
            gl2.xr.addEventListener("sessionend", handleSessionChange);
          },
          disconnect() {
            const gl2 = store2.getState().gl;
            gl2.xr.removeEventListener("sessionstart", handleSessionChange);
            gl2.xr.removeEventListener("sessionend", handleSessionChange);
          }
        };
        if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === "function")
          xr.connect();
        state.set({
          xr
        });
      }
      if (gl.shadowMap) {
        const oldEnabled = gl.shadowMap.enabled;
        const oldType = gl.shadowMap.type;
        gl.shadowMap.enabled = !!shadows;
        if (is.boo(shadows)) {
          gl.shadowMap.type = PCFSoftShadowMap;
        } else if (is.str(shadows)) {
          var _types$shadows;
          const types2 = {
            basic: BasicShadowMap,
            percentage: PCFShadowMap,
            soft: PCFSoftShadowMap,
            variance: VSMShadowMap
          };
          gl.shadowMap.type = (_types$shadows = types2[shadows]) != null ? _types$shadows : PCFSoftShadowMap;
        } else if (is.obj(shadows)) {
          Object.assign(gl.shadowMap, shadows);
        }
        if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type)
          gl.shadowMap.needsUpdate = true;
      }
      const ColorManagement2 = getColorManagement();
      if (ColorManagement2) {
        if ("enabled" in ColorManagement2)
          ColorManagement2.enabled = !legacy;
        else if ("legacyMode" in ColorManagement2)
          ColorManagement2.legacyMode = legacy;
      }
      if (!configured) {
        const LinearEncoding2 = 3e3;
        const sRGBEncoding2 = 3001;
        applyProps(gl, {
          outputEncoding: linear ? LinearEncoding2 : sRGBEncoding2,
          toneMapping: flat ? NoToneMapping : ACESFilmicToneMapping
        });
      }
      if (state.legacy !== legacy)
        state.set(() => ({
          legacy
        }));
      if (state.linear !== linear)
        state.set(() => ({
          linear
        }));
      if (state.flat !== flat)
        state.set(() => ({
          flat
        }));
      if (glConfig && !is.fun(glConfig) && !isRenderer(glConfig) && !is.equ(glConfig, gl, shallowLoose))
        applyProps(gl, glConfig);
      if (events2 && !state.events.handlers)
        state.set({
          events: events2(store2)
        });
      const size12 = computeInitialSize(canvas2, propsSize);
      if (!is.equ(size12, state.size, shallowLoose)) {
        state.setSize(size12.width, size12.height, size12.updateStyle, size12.top, size12.left);
      }
      if (dpr && state.viewport.dpr !== calculateDpr(dpr))
        state.setDpr(dpr);
      if (state.frameloop !== frameloop)
        state.setFrameloop(frameloop);
      if (!state.onPointerMissed)
        state.set({
          onPointerMissed
        });
      if (performance2 && !is.equ(performance2, state.performance, shallowLoose))
        state.set((state2) => ({
          performance: {
            ...state2.performance,
            ...performance2
          }
        }));
      onCreated = onCreatedCallback;
      configured = true;
      return this;
    },
    render(children) {
      if (!configured)
        this.configure();
      reconciler.updateContainer(/* @__PURE__ */ jsx(Provider, {
        store: store2,
        children,
        onCreated,
        rootElement: canvas2
      }), fiber, null, () => void 0);
      return store2;
    },
    unmount() {
      unmountComponentAtNode(canvas2);
    }
  };
}
function Provider({
  store: store2,
  children,
  onCreated,
  rootElement
}) {
  useIsomorphicLayoutEffect(() => {
    const state = store2.getState();
    state.set((state2) => ({
      internal: {
        ...state2.internal,
        active: true
      }
    }));
    if (onCreated)
      onCreated(state);
    if (!store2.getState().events.connected)
      state.events.connect == null ? void 0 : state.events.connect(rootElement);
  }, []);
  return /* @__PURE__ */ jsx(context.Provider, {
    value: store2,
    children
  });
}
function unmountComponentAtNode(canvas2, callback) {
  const root2 = roots.get(canvas2);
  const fiber = root2 == null ? void 0 : root2.fiber;
  if (fiber) {
    const state = root2 == null ? void 0 : root2.store.getState();
    if (state)
      state.internal.active = false;
    reconciler.updateContainer(null, fiber, null, () => {
      if (state) {
        setTimeout(() => {
          try {
            var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
            state.events.disconnect == null ? void 0 : state.events.disconnect();
            (_state$gl = state.gl) == null ? void 0 : (_state$gl$renderLists = _state$gl.renderLists) == null ? void 0 : _state$gl$renderLists.dispose == null ? void 0 : _state$gl$renderLists.dispose();
            (_state$gl2 = state.gl) == null ? void 0 : _state$gl2.forceContextLoss == null ? void 0 : _state$gl2.forceContextLoss();
            if ((_state$gl3 = state.gl) != null && _state$gl3.xr)
              state.xr.disconnect();
            dispose(state);
            roots.delete(canvas2);
            if (callback)
              callback(canvas2);
          } catch (e3) {
          }
        }, 500);
      }
    });
  }
}
reconciler.injectIntoDevTools({
  bundleType: process.env.NODE_ENV === "production" ? 0 : 1,
  rendererPackageName: "@react-three/fiber",
  version: React.version
});
const DOM_EVENTS = {
  onClick: ["click", false],
  onContextMenu: ["contextmenu", false],
  onDoubleClick: ["dblclick", false],
  onWheel: ["wheel", true],
  onPointerDown: ["pointerdown", true],
  onPointerUp: ["pointerup", true],
  onPointerLeave: ["pointerleave", true],
  onPointerMove: ["pointermove", true],
  onPointerCancel: ["pointercancel", true],
  onLostPointerCapture: ["lostpointercapture", true]
};
function createPointerEvents(store2) {
  const {
    handlePointer
  } = createEvents(store2);
  return {
    priority: 1,
    enabled: true,
    compute(event, state, previous) {
      state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
      state.raycaster.setFromCamera(state.pointer, state.camera);
    },
    connected: void 0,
    handlers: Object.keys(DOM_EVENTS).reduce((acc, key) => ({
      ...acc,
      [key]: handlePointer(key)
    }), {}),
    update: () => {
      var _internal$lastEvent;
      const {
        events: events2,
        internal
      } = store2.getState();
      if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events2.handlers)
        events2.handlers.onPointerMove(internal.lastEvent.current);
    },
    connect: (target) => {
      var _events$handlers;
      const {
        set,
        events: events2
      } = store2.getState();
      events2.disconnect == null ? void 0 : events2.disconnect();
      set((state) => ({
        events: {
          ...state.events,
          connected: target
        }
      }));
      Object.entries((_events$handlers = events2.handlers) != null ? _events$handlers : []).forEach(([name2, event]) => {
        const [eventName, passive] = DOM_EVENTS[name2];
        target.addEventListener(eventName, event, {
          passive
        });
      });
    },
    disconnect: () => {
      const {
        set,
        events: events2
      } = store2.getState();
      if (events2.connected) {
        var _events$handlers2;
        Object.entries((_events$handlers2 = events2.handlers) != null ? _events$handlers2 : []).forEach(([name2, event]) => {
          if (events2 && events2.connected instanceof HTMLElement) {
            const [eventName] = DOM_EVENTS[name2];
            events2.connected.removeEventListener(eventName, event);
          }
        });
        set((state) => ({
          events: {
            ...state.events,
            connected: void 0
          }
        }));
      }
    }
  };
}
function g$1(n2, t2) {
  let o2;
  return (...i2) => {
    window.clearTimeout(o2), o2 = window.setTimeout(() => n2(...i2), t2);
  };
}
function j({ debounce: n2, scroll: t2, polyfill: o2, offsetSize: i2 } = { debounce: 0, scroll: false, offsetSize: false }) {
  const a2 = o2 || (typeof window == "undefined" ? class {
  } : window.ResizeObserver);
  if (!a2)
    throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
  const [c2, h2] = useState({ left: 0, top: 0, width: 0, height: 0, bottom: 0, right: 0, x: 0, y: 0 }), e3 = useRef({ element: null, scrollContainers: null, resizeObserver: null, lastBounds: c2, orientationHandler: null }), d2 = n2 ? typeof n2 == "number" ? n2 : n2.scroll : null, f2 = n2 ? typeof n2 == "number" ? n2 : n2.resize : null, w2 = useRef(false);
  useEffect(() => (w2.current = true, () => void (w2.current = false)));
  const [z2, m2, s2] = useMemo(() => {
    const r2 = () => {
      if (!e3.current.element)
        return;
      const { left: y2, top: C2, width: H2, height: O2, bottom: S2, right: x2, x: B2, y: R2 } = e3.current.element.getBoundingClientRect(), l2 = { left: y2, top: C2, width: H2, height: O2, bottom: S2, right: x2, x: B2, y: R2 };
      e3.current.element instanceof HTMLElement && i2 && (l2.height = e3.current.element.offsetHeight, l2.width = e3.current.element.offsetWidth), Object.freeze(l2), w2.current && !D(e3.current.lastBounds, l2) && h2(e3.current.lastBounds = l2);
    };
    return [r2, f2 ? g$1(r2, f2) : r2, d2 ? g$1(r2, d2) : r2];
  }, [h2, i2, d2, f2]);
  function v5() {
    e3.current.scrollContainers && (e3.current.scrollContainers.forEach((r2) => r2.removeEventListener("scroll", s2, true)), e3.current.scrollContainers = null), e3.current.resizeObserver && (e3.current.resizeObserver.disconnect(), e3.current.resizeObserver = null), e3.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e3.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e3.current.orientationHandler));
  }
  function b2() {
    e3.current.element && (e3.current.resizeObserver = new a2(s2), e3.current.resizeObserver.observe(e3.current.element), t2 && e3.current.scrollContainers && e3.current.scrollContainers.forEach((r2) => r2.addEventListener("scroll", s2, { capture: true, passive: true })), e3.current.orientationHandler = () => {
      s2();
    }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e3.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e3.current.orientationHandler));
  }
  const L2 = (r2) => {
    !r2 || r2 === e3.current.element || (v5(), e3.current.element = r2, e3.current.scrollContainers = E(r2), b2());
  };
  return X(s2, !!t2), W(m2), useEffect(() => {
    v5(), b2();
  }, [t2, s2, m2]), useEffect(() => v5, []), [L2, c2, z2];
}
function W(n2) {
  useEffect(() => {
    const t2 = n2;
    return window.addEventListener("resize", t2), () => void window.removeEventListener("resize", t2);
  }, [n2]);
}
function X(n2, t2) {
  useEffect(() => {
    if (t2) {
      const o2 = n2;
      return window.addEventListener("scroll", o2, { capture: true, passive: true }), () => void window.removeEventListener("scroll", o2, true);
    }
  }, [n2, t2]);
}
function E(n2) {
  const t2 = [];
  if (!n2 || n2 === document.body)
    return t2;
  const { overflow: o2, overflowX: i2, overflowY: a2 } = window.getComputedStyle(n2);
  return [o2, i2, a2].some((c2) => c2 === "auto" || c2 === "scroll") && t2.push(n2), [...t2, ...E(n2.parentElement)];
}
const k = ["x", "y", "top", "bottom", "left", "right", "width", "height"], D = (n2, t2) => k.every((o2) => n2[o2] === t2[o2]);
var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a2, b2) => {
  for (var prop in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop))
      __defNormalProp$2(a2, prop, b2[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop))
        __defNormalProp$2(a2, prop, b2[prop]);
    }
  return a2;
};
var __spreadProps = (a2, b2) => __defProps(a2, __getOwnPropDescs(b2));
var _a, _b;
typeof window !== "undefined" && (((_a = window.document) == null ? void 0 : _a.createElement) || ((_b = window.navigator) == null ? void 0 : _b.product) === "ReactNative") ? React.useLayoutEffect : React.useEffect;
function traverseFiber(fiber, ascending2, selector) {
  if (!fiber)
    return;
  if (selector(fiber) === true)
    return fiber;
  let child = ascending2 ? fiber.return : fiber.child;
  while (child) {
    const match2 = traverseFiber(child, ascending2, selector);
    if (match2)
      return match2;
    child = ascending2 ? null : child.sibling;
  }
}
function wrapContext(context2) {
  try {
    return Object.defineProperties(context2, {
      _currentRenderer: {
        get() {
          return null;
        },
        set() {
        }
      },
      _currentRenderer2: {
        get() {
          return null;
        },
        set() {
        }
      }
    });
  } catch (_2) {
    return context2;
  }
}
const error = console.error;
console.error = function() {
  const message2 = [...arguments].join("");
  if ((message2 == null ? void 0 : message2.startsWith("Warning:")) && message2.includes("useContext")) {
    console.error = error;
    return;
  }
  return error.apply(this, arguments);
};
const FiberContext = wrapContext(React.createContext(null));
class FiberProvider extends React.Component {
  render() {
    return /* @__PURE__ */ React.createElement(FiberContext.Provider, {
      value: this._reactInternals
    }, this.props.children);
  }
}
function useFiber() {
  const root2 = React.useContext(FiberContext);
  if (root2 === null)
    throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
  const id = React.useId();
  const fiber = React.useMemo(() => {
    for (const maybeFiber of [root2, root2 == null ? void 0 : root2.alternate]) {
      if (!maybeFiber)
        continue;
      const fiber2 = traverseFiber(maybeFiber, false, (node) => {
        let state = node.memoizedState;
        while (state) {
          if (state.memoizedState === id)
            return true;
          state = state.next;
        }
      });
      if (fiber2)
        return fiber2;
    }
  }, [root2, id]);
  return fiber;
}
function useContextMap() {
  const fiber = useFiber();
  const [contextMap] = React.useState(() => /* @__PURE__ */ new Map());
  contextMap.clear();
  let node = fiber;
  while (node) {
    if (node.type && typeof node.type === "object") {
      const enableRenderableContext = node.type._context === void 0 && node.type.Provider === node.type;
      const context2 = enableRenderableContext ? node.type : node.type._context;
      if (context2 && context2 !== FiberContext && !contextMap.has(context2)) {
        contextMap.set(context2, React.useContext(wrapContext(context2)));
      }
    }
    node = node.return;
  }
  return contextMap;
}
function useContextBridge() {
  const contextMap = useContextMap();
  return React.useMemo(
    () => Array.from(contextMap.keys()).reduce(
      (Prev2, context2) => (props) => /* @__PURE__ */ React.createElement(Prev2, null, /* @__PURE__ */ React.createElement(context2.Provider, __spreadProps(__spreadValues({}, props), {
        value: contextMap.get(context2)
      }))),
      (props) => /* @__PURE__ */ React.createElement(FiberProvider, __spreadValues({}, props))
    ),
    [contextMap]
  );
}
const CanvasImpl = /* @__PURE__ */ React.forwardRef(function Canvas2({
  children,
  fallback,
  resize: resize2,
  style: style2,
  gl,
  events: events2 = createPointerEvents,
  eventSource,
  eventPrefix,
  shadows,
  linear,
  flat,
  legacy,
  orthographic,
  frameloop,
  dpr,
  performance: performance2,
  raycaster,
  camera,
  scene,
  onPointerMissed,
  onCreated,
  ...props
}, forwardedRef) {
  React.useMemo(() => extend(THREE), []);
  const Bridge = useContextBridge();
  const [containerRef, containerRect] = j({
    scroll: true,
    debounce: {
      scroll: 50,
      resize: 0
    },
    ...resize2
  });
  const canvasRef = React.useRef(null);
  const divRef = React.useRef(null);
  React.useImperativeHandle(forwardedRef, () => canvasRef.current);
  const handlePointerMissed = useMutableCallback(onPointerMissed);
  const [block, setBlock] = React.useState(false);
  const [error2, setError] = React.useState(false);
  if (block)
    throw block;
  if (error2)
    throw error2;
  const root2 = React.useRef(null);
  useIsomorphicLayoutEffect(() => {
    const canvas2 = canvasRef.current;
    if (containerRect.width > 0 && containerRect.height > 0 && canvas2) {
      if (!root2.current)
        root2.current = createRoot(canvas2);
      root2.current.configure({
        gl,
        events: events2,
        shadows,
        linear,
        flat,
        legacy,
        orthographic,
        frameloop,
        dpr,
        performance: performance2,
        raycaster,
        camera,
        scene,
        size: containerRect,
        // Pass mutable reference to onPointerMissed so it's free to update
        onPointerMissed: (...args) => handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
        onCreated: (state) => {
          state.events.connect == null ? void 0 : state.events.connect(eventSource ? isRef(eventSource) ? eventSource.current : eventSource : divRef.current);
          if (eventPrefix) {
            state.setEvents({
              compute: (event, state2) => {
                const x2 = event[eventPrefix + "X"];
                const y2 = event[eventPrefix + "Y"];
                state2.pointer.set(x2 / state2.size.width * 2 - 1, -(y2 / state2.size.height) * 2 + 1);
                state2.raycaster.setFromCamera(state2.pointer, state2.camera);
              }
            });
          }
          onCreated == null ? void 0 : onCreated(state);
        }
      });
      root2.current.render(/* @__PURE__ */ jsx(Bridge, {
        children: /* @__PURE__ */ jsx(ErrorBoundary$1, {
          set: setError,
          children: /* @__PURE__ */ jsx(React.Suspense, {
            fallback: /* @__PURE__ */ jsx(Block, {
              set: setBlock
            }),
            children: children != null ? children : null
          })
        })
      }));
    }
  });
  React.useEffect(() => {
    const canvas2 = canvasRef.current;
    if (canvas2)
      return () => unmountComponentAtNode(canvas2);
  }, []);
  const pointerEvents2 = eventSource ? "none" : "auto";
  return /* @__PURE__ */ jsx("div", {
    ref: divRef,
    style: {
      position: "relative",
      width: "100%",
      height: "100%",
      overflow: "hidden",
      pointerEvents: pointerEvents2,
      ...style2
    },
    ...props,
    children: /* @__PURE__ */ jsx("div", {
      ref: containerRef,
      style: {
        width: "100%",
        height: "100%"
      },
      children: /* @__PURE__ */ jsx("canvas", {
        ref: canvasRef,
        style: {
          display: "block"
        },
        children: fallback
      })
    })
  });
});
const Canvas = /* @__PURE__ */ React.forwardRef(function CanvasWrapper(props, ref) {
  return /* @__PURE__ */ jsx(FiberProvider, {
    children: /* @__PURE__ */ jsx(CanvasImpl, {
      ...props,
      ref
    })
  });
});
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e3 = 1; e3 < arguments.length; e3++) {
      var t2 = arguments[e3];
      for (var r2 in t2)
        ({}).hasOwnProperty.call(t2, r2) && (n2[r2] = t2[r2]);
    }
    return n2;
  }, _extends.apply(null, arguments);
}
const v1 = /* @__PURE__ */ new Vector3$1();
const v2 = /* @__PURE__ */ new Vector3$1();
const v3 = /* @__PURE__ */ new Vector3$1();
const v4 = /* @__PURE__ */ new Vector2$1();
function defaultCalculatePosition(el, camera, size12) {
  const objectPos = v1.setFromMatrixPosition(el.matrixWorld);
  objectPos.project(camera);
  const widthHalf = size12.width / 2;
  const heightHalf = size12.height / 2;
  return [objectPos.x * widthHalf + widthHalf, -(objectPos.y * heightHalf) + heightHalf];
}
function isObjectBehindCamera(el, camera) {
  const objectPos = v1.setFromMatrixPosition(el.matrixWorld);
  const cameraPos = v2.setFromMatrixPosition(camera.matrixWorld);
  const deltaCamObj = objectPos.sub(cameraPos);
  const camDir = camera.getWorldDirection(v3);
  return deltaCamObj.angleTo(camDir) > Math.PI / 2;
}
function isObjectVisible(el, camera, raycaster, occlude) {
  const elPos = v1.setFromMatrixPosition(el.matrixWorld);
  const screenPos = elPos.clone();
  screenPos.project(camera);
  v4.set(screenPos.x, screenPos.y);
  raycaster.setFromCamera(v4, camera);
  const intersects7 = raycaster.intersectObjects(occlude, true);
  if (intersects7.length) {
    const intersectionDistance = intersects7[0].distance;
    const pointDistance = elPos.distanceTo(raycaster.ray.origin);
    return pointDistance < intersectionDistance;
  }
  return true;
}
function objectScale(el, camera) {
  if (camera instanceof OrthographicCamera) {
    return camera.zoom;
  } else if (camera instanceof PerspectiveCamera) {
    const objectPos = v1.setFromMatrixPosition(el.matrixWorld);
    const cameraPos = v2.setFromMatrixPosition(camera.matrixWorld);
    const vFOV = camera.fov * Math.PI / 180;
    const dist2 = objectPos.distanceTo(cameraPos);
    const scaleFOV = 2 * Math.tan(vFOV / 2) * dist2;
    return 1 / scaleFOV;
  } else {
    return 1;
  }
}
function objectZIndex(el, camera, zIndexRange) {
  if (camera instanceof PerspectiveCamera || camera instanceof OrthographicCamera) {
    const objectPos = v1.setFromMatrixPosition(el.matrixWorld);
    const cameraPos = v2.setFromMatrixPosition(camera.matrixWorld);
    const dist2 = objectPos.distanceTo(cameraPos);
    const A2 = (zIndexRange[1] - zIndexRange[0]) / (camera.far - camera.near);
    const B2 = zIndexRange[1] - A2 * camera.far;
    return Math.round(A2 * dist2 + B2);
  }
  return void 0;
}
const epsilon = (value) => Math.abs(value) < 1e-10 ? 0 : value;
function getCSSMatrix(matrix, multipliers, prepend = "") {
  let matrix3d = "matrix3d(";
  for (let i2 = 0; i2 !== 16; i2++) {
    matrix3d += epsilon(multipliers[i2] * matrix.elements[i2]) + (i2 !== 15 ? "," : ")");
  }
  return prepend + matrix3d;
}
const getCameraCSSMatrix = ((multipliers) => {
  return (matrix) => getCSSMatrix(matrix, multipliers);
})([1, -1, 1, 1, 1, -1, 1, 1, 1, -1, 1, 1, 1, -1, 1, 1]);
const getObjectCSSMatrix = ((scaleMultipliers) => {
  return (matrix, factor) => getCSSMatrix(matrix, scaleMultipliers(factor), "translate(-50%,-50%)");
})((f2) => [1 / f2, 1 / f2, 1 / f2, 1, -1 / f2, -1 / f2, -1 / f2, -1, 1 / f2, 1 / f2, 1 / f2, 1, 1, 1, 1, 1]);
function isRefObject(ref) {
  return ref && typeof ref === "object" && "current" in ref;
}
const Html = /* @__PURE__ */ React.forwardRef(({
  children,
  eps = 1e-3,
  style: style2,
  className,
  prepend,
  center: center2,
  fullscreen,
  portal,
  distanceFactor,
  sprite = false,
  transform: transform4 = false,
  occlude,
  onOcclude,
  castShadow,
  receiveShadow,
  material,
  geometry: geometry2,
  zIndexRange = [16777271, 0],
  calculatePosition = defaultCalculatePosition,
  as: as2 = "div",
  wrapperClass,
  pointerEvents: pointerEvents2 = "auto",
  ...props
}, ref) => {
  const {
    gl,
    camera,
    scene,
    size: size12,
    raycaster,
    events: events2,
    viewport
  } = useThree();
  const [el] = React.useState(() => document.createElement(as2));
  const root2 = React.useRef();
  const group = React.useRef(null);
  const oldZoom = React.useRef(0);
  const oldPosition = React.useRef([0, 0]);
  const transformOuterRef = React.useRef(null);
  const transformInnerRef = React.useRef(null);
  const target = (portal == null ? void 0 : portal.current) || events2.connected || gl.domElement.parentNode;
  const occlusionMeshRef = React.useRef(null);
  const isMeshSizeSet = React.useRef(false);
  const isRayCastOcclusion = React.useMemo(() => {
    return occlude && occlude !== "blending" || Array.isArray(occlude) && occlude.length && isRefObject(occlude[0]);
  }, [occlude]);
  React.useLayoutEffect(() => {
    const el2 = gl.domElement;
    if (occlude && occlude === "blending") {
      el2.style.zIndex = `${Math.floor(zIndexRange[0] / 2)}`;
      el2.style.position = "absolute";
      el2.style.pointerEvents = "none";
    } else {
      el2.style.zIndex = null;
      el2.style.position = null;
      el2.style.pointerEvents = null;
    }
  }, [occlude]);
  React.useLayoutEffect(() => {
    if (group.current) {
      const currentRoot = root2.current = createRoot$1(el);
      scene.updateMatrixWorld();
      if (transform4) {
        el.style.cssText = `position:absolute;top:0;left:0;pointer-events:none;overflow:hidden;`;
      } else {
        const vec = calculatePosition(group.current, camera, size12);
        el.style.cssText = `position:absolute;top:0;left:0;transform:translate3d(${vec[0]}px,${vec[1]}px,0);transform-origin:0 0;`;
      }
      if (target) {
        if (prepend)
          target.prepend(el);
        else
          target.appendChild(el);
      }
      return () => {
        if (target)
          target.removeChild(el);
        currentRoot.unmount();
      };
    }
  }, [target, transform4]);
  React.useLayoutEffect(() => {
    if (wrapperClass)
      el.className = wrapperClass;
  }, [wrapperClass]);
  const styles2 = React.useMemo(() => {
    if (transform4) {
      return {
        position: "absolute",
        top: 0,
        left: 0,
        width: size12.width,
        height: size12.height,
        transformStyle: "preserve-3d",
        pointerEvents: "none"
      };
    } else {
      return {
        position: "absolute",
        transform: center2 ? "translate3d(-50%,-50%,0)" : "none",
        ...fullscreen && {
          top: -size12.height / 2,
          left: -size12.width / 2,
          width: size12.width,
          height: size12.height
        },
        ...style2
      };
    }
  }, [style2, center2, fullscreen, size12, transform4]);
  const transformInnerStyles = React.useMemo(() => ({
    position: "absolute",
    pointerEvents: pointerEvents2
  }), [pointerEvents2]);
  React.useLayoutEffect(() => {
    isMeshSizeSet.current = false;
    if (transform4) {
      var _root$current;
      (_root$current = root2.current) == null || _root$current.render(/* @__PURE__ */ React.createElement("div", {
        ref: transformOuterRef,
        style: styles2
      }, /* @__PURE__ */ React.createElement("div", {
        ref: transformInnerRef,
        style: transformInnerStyles
      }, /* @__PURE__ */ React.createElement("div", {
        ref,
        className,
        style: style2,
        children
      }))));
    } else {
      var _root$current2;
      (_root$current2 = root2.current) == null || _root$current2.render(/* @__PURE__ */ React.createElement("div", {
        ref,
        style: styles2,
        className,
        children
      }));
    }
  });
  const visible = React.useRef(true);
  useFrame((gl2) => {
    if (group.current) {
      camera.updateMatrixWorld();
      group.current.updateWorldMatrix(true, false);
      const vec = transform4 ? oldPosition.current : calculatePosition(group.current, camera, size12);
      if (transform4 || Math.abs(oldZoom.current - camera.zoom) > eps || Math.abs(oldPosition.current[0] - vec[0]) > eps || Math.abs(oldPosition.current[1] - vec[1]) > eps) {
        const isBehindCamera = isObjectBehindCamera(group.current, camera);
        let raytraceTarget = false;
        if (isRayCastOcclusion) {
          if (Array.isArray(occlude)) {
            raytraceTarget = occlude.map((item) => item.current);
          } else if (occlude !== "blending") {
            raytraceTarget = [scene];
          }
        }
        const previouslyVisible = visible.current;
        if (raytraceTarget) {
          const isvisible = isObjectVisible(group.current, camera, raycaster, raytraceTarget);
          visible.current = isvisible && !isBehindCamera;
        } else {
          visible.current = !isBehindCamera;
        }
        if (previouslyVisible !== visible.current) {
          if (onOcclude)
            onOcclude(!visible.current);
          else
            el.style.display = visible.current ? "block" : "none";
        }
        const halfRange = Math.floor(zIndexRange[0] / 2);
        const zRange = occlude ? isRayCastOcclusion ? [zIndexRange[0], halfRange] : [halfRange - 1, 0] : zIndexRange;
        el.style.zIndex = `${objectZIndex(group.current, camera, zRange)}`;
        if (transform4) {
          const [widthHalf, heightHalf] = [size12.width / 2, size12.height / 2];
          const fov2 = camera.projectionMatrix.elements[5] * heightHalf;
          const {
            isOrthographicCamera: isOrthographicCamera2,
            top,
            left,
            bottom,
            right
          } = camera;
          const cameraMatrix = getCameraCSSMatrix(camera.matrixWorldInverse);
          const cameraTransform = isOrthographicCamera2 ? `scale(${fov2})translate(${epsilon(-(right + left) / 2)}px,${epsilon((top + bottom) / 2)}px)` : `translateZ(${fov2}px)`;
          let matrix = group.current.matrixWorld;
          if (sprite) {
            matrix = camera.matrixWorldInverse.clone().transpose().copyPosition(matrix).scale(group.current.scale);
            matrix.elements[3] = matrix.elements[7] = matrix.elements[11] = 0;
            matrix.elements[15] = 1;
          }
          el.style.width = size12.width + "px";
          el.style.height = size12.height + "px";
          el.style.perspective = isOrthographicCamera2 ? "" : `${fov2}px`;
          if (transformOuterRef.current && transformInnerRef.current) {
            transformOuterRef.current.style.transform = `${cameraTransform}${cameraMatrix}translate(${widthHalf}px,${heightHalf}px)`;
            transformInnerRef.current.style.transform = getObjectCSSMatrix(matrix, 1 / ((distanceFactor || 10) / 400));
          }
        } else {
          const scale5 = distanceFactor === void 0 ? 1 : objectScale(group.current, camera) * distanceFactor;
          el.style.transform = `translate3d(${vec[0]}px,${vec[1]}px,0) scale(${scale5})`;
        }
        oldPosition.current = vec;
        oldZoom.current = camera.zoom;
      }
    }
    if (!isRayCastOcclusion && occlusionMeshRef.current && !isMeshSizeSet.current) {
      if (transform4) {
        if (transformOuterRef.current) {
          const el2 = transformOuterRef.current.children[0];
          if (el2 != null && el2.clientWidth && el2 != null && el2.clientHeight) {
            const {
              isOrthographicCamera: isOrthographicCamera2
            } = camera;
            if (isOrthographicCamera2 || geometry2) {
              if (props.scale) {
                if (!Array.isArray(props.scale)) {
                  occlusionMeshRef.current.scale.setScalar(1 / props.scale);
                } else if (props.scale instanceof Vector3$1) {
                  occlusionMeshRef.current.scale.copy(props.scale.clone().divideScalar(1));
                } else {
                  occlusionMeshRef.current.scale.set(1 / props.scale[0], 1 / props.scale[1], 1 / props.scale[2]);
                }
              }
            } else {
              const ratio = (distanceFactor || 10) / 400;
              const w2 = el2.clientWidth * ratio;
              const h2 = el2.clientHeight * ratio;
              occlusionMeshRef.current.scale.set(w2, h2, 1);
            }
            isMeshSizeSet.current = true;
          }
        }
      } else {
        const ele = el.children[0];
        if (ele != null && ele.clientWidth && ele != null && ele.clientHeight) {
          const ratio = 1 / viewport.factor;
          const w2 = ele.clientWidth * ratio;
          const h2 = ele.clientHeight * ratio;
          occlusionMeshRef.current.scale.set(w2, h2, 1);
          isMeshSizeSet.current = true;
        }
        occlusionMeshRef.current.lookAt(gl2.camera.position);
      }
    }
  });
  const shaders = React.useMemo(() => ({
    vertexShader: !transform4 ? (
      /* glsl */
      `
          /*
            This shader is from the THREE's SpriteMaterial.
            We need to turn the backing plane into a Sprite
            (make it always face the camera) if "transfrom"
            is false.
          */
          #include <common>

          void main() {
            vec2 center = vec2(0., 1.);
            float rotation = 0.0;

            // This is somewhat arbitrary, but it seems to work well
            // Need to figure out how to derive this dynamically if it even matters
            float size = 0.03;

            vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
            vec2 scale;
            scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
            scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );

            bool isPerspective = isPerspectiveMatrix( projectionMatrix );
            if ( isPerspective ) scale *= - mvPosition.z;

            vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale * size;
            vec2 rotatedPosition;
            rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
            rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
            mvPosition.xy += rotatedPosition;

            gl_Position = projectionMatrix * mvPosition;
          }
      `
    ) : void 0,
    fragmentShader: (
      /* glsl */
      `
        void main() {
          gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0);
        }
      `
    )
  }), [transform4]);
  return /* @__PURE__ */ React.createElement("group", _extends({}, props, {
    ref: group
  }), occlude && !isRayCastOcclusion && /* @__PURE__ */ React.createElement("mesh", {
    castShadow,
    receiveShadow,
    ref: occlusionMeshRef
  }, geometry2 || /* @__PURE__ */ React.createElement("planeGeometry", null), material || /* @__PURE__ */ React.createElement("shaderMaterial", {
    side: DoubleSide,
    vertexShader: shaders.vertexShader,
    fragmentShader: shaders.fragmentShader
  })));
});
function clamp(v5, min4, max3) {
  return Math.max(min4, Math.min(v5, max3));
}
const V = {
  toVector(v5, fallback) {
    if (v5 === void 0)
      v5 = fallback;
    return Array.isArray(v5) ? v5 : [v5, v5];
  },
  add(v12, v22) {
    return [v12[0] + v22[0], v12[1] + v22[1]];
  },
  sub(v12, v22) {
    return [v12[0] - v22[0], v12[1] - v22[1]];
  },
  addTo(v12, v22) {
    v12[0] += v22[0];
    v12[1] += v22[1];
  },
  subTo(v12, v22) {
    v12[0] -= v22[0];
    v12[1] -= v22[1];
  }
};
function rubberband(distance11, dimension, constant2) {
  if (dimension === 0 || Math.abs(dimension) === Infinity)
    return Math.pow(distance11, constant2 * 5);
  return distance11 * dimension * constant2 / (dimension + constant2 * distance11);
}
function rubberbandIfOutOfBounds(position, min4, max3, constant2 = 0.15) {
  if (constant2 === 0)
    return clamp(position, min4, max3);
  if (position < min4)
    return -rubberband(min4 - position, max3 - min4, constant2) + min4;
  if (position > max3)
    return +rubberband(position - max3, max3 - min4, constant2) + max3;
  return position;
}
function computeRubberband(bounds, [Vx, Vy], [Rx, Ry]) {
  const [[X0, X1], [Y0, Y1]] = bounds;
  return [rubberbandIfOutOfBounds(Vx, X0, X1, Rx), rubberbandIfOutOfBounds(Vy, Y0, Y1, Ry)];
}
function _toPrimitive(input, hint2) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint2 || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint2 === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(e3, r2) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e3);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e3, r3).enumerable;
    })), t2.push.apply(t2, o2);
  }
  return t2;
}
function _objectSpread2(e3) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t2 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t2), true).forEach(function(r3) {
      _defineProperty(e3, r3, t2[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function(r3) {
      Object.defineProperty(e3, r3, Object.getOwnPropertyDescriptor(t2, r3));
    });
  }
  return e3;
}
const EVENT_TYPE_MAP = {
  pointer: {
    start: "down",
    change: "move",
    end: "up"
  },
  mouse: {
    start: "down",
    change: "move",
    end: "up"
  },
  touch: {
    start: "start",
    change: "move",
    end: "end"
  },
  gesture: {
    start: "start",
    change: "change",
    end: "end"
  }
};
function capitalize(string3) {
  if (!string3)
    return "";
  return string3[0].toUpperCase() + string3.slice(1);
}
const actionsWithoutCaptureSupported = ["enter", "leave"];
function hasCapture(capture = false, actionKey) {
  return capture && !actionsWithoutCaptureSupported.includes(actionKey);
}
function toHandlerProp(device, action = "", capture = false) {
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action] || action : action;
  return "on" + capitalize(device) + capitalize(actionKey) + (hasCapture(capture, actionKey) ? "Capture" : "");
}
const pointerCaptureEvents = ["gotpointercapture", "lostpointercapture"];
function parseProp(prop) {
  let eventKey = prop.substring(2).toLowerCase();
  const passive = !!~eventKey.indexOf("passive");
  if (passive)
    eventKey = eventKey.replace("passive", "");
  const captureKey = pointerCaptureEvents.includes(eventKey) ? "capturecapture" : "capture";
  const capture = !!~eventKey.indexOf(captureKey);
  if (capture)
    eventKey = eventKey.replace("capture", "");
  return {
    device: eventKey,
    capture,
    passive
  };
}
function toDomEventType(device, action = "") {
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action] || action : action;
  return device + actionKey;
}
function isTouch(event) {
  return "touches" in event;
}
function getPointerType(event) {
  if (isTouch(event))
    return "touch";
  if ("pointerType" in event)
    return event.pointerType;
  return "mouse";
}
function getCurrentTargetTouchList(event) {
  return Array.from(event.touches).filter((e3) => {
    var _event$currentTarget, _event$currentTarget$;
    return e3.target === event.currentTarget || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e3.target));
  });
}
function getTouchList(event) {
  return event.type === "touchend" || event.type === "touchcancel" ? event.changedTouches : event.targetTouches;
}
function getValueEvent(event) {
  return isTouch(event) ? getTouchList(event)[0] : event;
}
function touchIds(event) {
  return getCurrentTargetTouchList(event).map((touch) => touch.identifier);
}
function pointerId(event) {
  const valueEvent = getValueEvent(event);
  return isTouch(event) ? valueEvent.identifier : valueEvent.pointerId;
}
function pointerValues(event) {
  const valueEvent = getValueEvent(event);
  return [valueEvent.clientX, valueEvent.clientY];
}
function getEventDetails(event) {
  const payload = {};
  if ("buttons" in event)
    payload.buttons = event.buttons;
  if ("shiftKey" in event) {
    const {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    } = event;
    Object.assign(payload, {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    });
  }
  return payload;
}
function call(v5, ...args) {
  if (typeof v5 === "function") {
    return v5(...args);
  } else {
    return v5;
  }
}
function noop() {
}
function chain(...fns) {
  if (fns.length === 0)
    return noop;
  if (fns.length === 1)
    return fns[0];
  return function() {
    let result;
    for (const fn2 of fns) {
      result = fn2.apply(this, arguments) || result;
    }
    return result;
  };
}
function assignDefault(value, fallback) {
  return Object.assign({}, fallback, value || {});
}
const BEFORE_LAST_KINEMATICS_DELAY = 32;
class Engine {
  constructor(ctrl, args, key) {
    this.ctrl = ctrl;
    this.args = args;
    this.key = key;
    if (!this.state) {
      this.state = {};
      this.computeValues([0, 0]);
      this.computeInitial();
      if (this.init)
        this.init();
      this.reset();
    }
  }
  get state() {
    return this.ctrl.state[this.key];
  }
  set state(state) {
    this.ctrl.state[this.key] = state;
  }
  get shared() {
    return this.ctrl.state.shared;
  }
  get eventStore() {
    return this.ctrl.gestureEventStores[this.key];
  }
  get timeoutStore() {
    return this.ctrl.gestureTimeoutStores[this.key];
  }
  get config() {
    return this.ctrl.config[this.key];
  }
  get sharedConfig() {
    return this.ctrl.config.shared;
  }
  get handler() {
    return this.ctrl.handlers[this.key];
  }
  reset() {
    const {
      state,
      shared,
      ingKey,
      args
    } = this;
    shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
    state._step = [false, false];
    state.intentional = false;
    state._movement = [0, 0];
    state._distance = [0, 0];
    state._direction = [0, 0];
    state._delta = [0, 0];
    state._bounds = [[-Infinity, Infinity], [-Infinity, Infinity]];
    state.args = args;
    state.axis = void 0;
    state.memo = void 0;
    state.elapsedTime = state.timeDelta = 0;
    state.direction = [0, 0];
    state.distance = [0, 0];
    state.overflow = [0, 0];
    state._movementBound = [false, false];
    state.velocity = [0, 0];
    state.movement = [0, 0];
    state.delta = [0, 0];
    state.timeStamp = 0;
  }
  start(event) {
    const state = this.state;
    const config2 = this.config;
    if (!state._active) {
      this.reset();
      this.computeInitial();
      state._active = true;
      state.target = event.target;
      state.currentTarget = event.currentTarget;
      state.lastOffset = config2.from ? call(config2.from, state) : state.offset;
      state.offset = state.lastOffset;
      state.startTime = state.timeStamp = event.timeStamp;
    }
  }
  computeValues(values4) {
    const state = this.state;
    state._values = values4;
    state.values = this.config.transform(values4);
  }
  computeInitial() {
    const state = this.state;
    state._initial = state._values;
    state.initial = state.values;
  }
  compute(event) {
    const {
      state,
      config: config2,
      shared
    } = this;
    state.args = this.args;
    let dt = 0;
    if (event) {
      state.event = event;
      if (config2.preventDefault && event.cancelable)
        state.event.preventDefault();
      state.type = event.type;
      shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
      shared.locked = !!document.pointerLockElement;
      Object.assign(shared, getEventDetails(event));
      shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
      dt = event.timeStamp - state.timeStamp;
      state.timeStamp = event.timeStamp;
      state.elapsedTime = state.timeStamp - state.startTime;
    }
    if (state._active) {
      const _absoluteDelta = state._delta.map(Math.abs);
      V.addTo(state._distance, _absoluteDelta);
    }
    if (this.axisIntent)
      this.axisIntent(event);
    const [_m0, _m12] = state._movement;
    const [t0, t1] = config2.threshold;
    const {
      _step,
      values: values4
    } = state;
    if (config2.hasCustomTransform) {
      if (_step[0] === false)
        _step[0] = Math.abs(_m0) >= t0 && values4[0];
      if (_step[1] === false)
        _step[1] = Math.abs(_m12) >= t1 && values4[1];
    } else {
      if (_step[0] === false)
        _step[0] = Math.abs(_m0) >= t0 && Math.sign(_m0) * t0;
      if (_step[1] === false)
        _step[1] = Math.abs(_m12) >= t1 && Math.sign(_m12) * t1;
    }
    state.intentional = _step[0] !== false || _step[1] !== false;
    if (!state.intentional)
      return;
    const movement = [0, 0];
    if (config2.hasCustomTransform) {
      const [v0, v12] = values4;
      movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? v12 - _step[1] : 0;
    } else {
      movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? _m12 - _step[1] : 0;
    }
    if (this.restrictToAxis && !state._blocked)
      this.restrictToAxis(movement);
    const previousOffset = state.offset;
    const gestureIsActive = state._active && !state._blocked || state.active;
    if (gestureIsActive) {
      state.first = state._active && !state.active;
      state.last = !state._active && state.active;
      state.active = shared[this.ingKey] = state._active;
      if (event) {
        if (state.first) {
          if ("bounds" in config2)
            state._bounds = call(config2.bounds, state);
          if (this.setup)
            this.setup();
        }
        state.movement = movement;
        this.computeOffset();
      }
    }
    const [ox, oy] = state.offset;
    const [[x02, x12], [y02, y12]] = state._bounds;
    state.overflow = [ox < x02 ? -1 : ox > x12 ? 1 : 0, oy < y02 ? -1 : oy > y12 ? 1 : 0];
    state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
    state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
    const rubberband2 = state._active ? config2.rubberband || [0, 0] : [0, 0];
    state.offset = computeRubberband(state._bounds, state.offset, rubberband2);
    state.delta = V.sub(state.offset, previousOffset);
    this.computeMovement();
    if (gestureIsActive && (!state.last || dt > BEFORE_LAST_KINEMATICS_DELAY)) {
      state.delta = V.sub(state.offset, previousOffset);
      const absoluteDelta = state.delta.map(Math.abs);
      V.addTo(state.distance, absoluteDelta);
      state.direction = state.delta.map(Math.sign);
      state._direction = state._delta.map(Math.sign);
      if (!state.first && dt > 0) {
        state.velocity = [absoluteDelta[0] / dt, absoluteDelta[1] / dt];
        state.timeDelta = dt;
      }
    }
  }
  emit() {
    const state = this.state;
    const shared = this.shared;
    const config2 = this.config;
    if (!state._active)
      this.clean();
    if ((state._blocked || !state.intentional) && !state._force && !config2.triggerAllEvents)
      return;
    const memo = this.handler(_objectSpread2(_objectSpread2(_objectSpread2({}, shared), state), {}, {
      [this.aliasKey]: state.values
    }));
    if (memo !== void 0)
      state.memo = memo;
  }
  clean() {
    this.eventStore.clean();
    this.timeoutStore.clean();
  }
}
function selectAxis([dx, dy], threshold2) {
  const absDx = Math.abs(dx);
  const absDy = Math.abs(dy);
  if (absDx > absDy && absDx > threshold2) {
    return "x";
  }
  if (absDy > absDx && absDy > threshold2) {
    return "y";
  }
  return void 0;
}
class CoordinatesEngine extends Engine {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "aliasKey", "xy");
  }
  reset() {
    super.reset();
    this.state.axis = void 0;
  }
  init() {
    this.state.offset = [0, 0];
    this.state.lastOffset = [0, 0];
  }
  computeOffset() {
    this.state.offset = V.add(this.state.lastOffset, this.state.movement);
  }
  computeMovement() {
    this.state.movement = V.sub(this.state.offset, this.state.lastOffset);
  }
  axisIntent(event) {
    const state = this.state;
    const config2 = this.config;
    if (!state.axis && event) {
      const threshold2 = typeof config2.axisThreshold === "object" ? config2.axisThreshold[getPointerType(event)] : config2.axisThreshold;
      state.axis = selectAxis(state._movement, threshold2);
    }
    state._blocked = (config2.lockDirection || !!config2.axis) && !state.axis || !!config2.axis && config2.axis !== state.axis;
  }
  restrictToAxis(v5) {
    if (this.config.axis || this.config.lockDirection) {
      switch (this.state.axis) {
        case "x":
          v5[1] = 0;
          break;
        case "y":
          v5[0] = 0;
          break;
      }
    }
  }
}
const identity = (v5) => v5;
const DEFAULT_RUBBERBAND = 0.15;
const commonConfigResolver = {
  enabled(value = true) {
    return value;
  },
  eventOptions(value, _k, config2) {
    return _objectSpread2(_objectSpread2({}, config2.shared.eventOptions), value);
  },
  preventDefault(value = false) {
    return value;
  },
  triggerAllEvents(value = false) {
    return value;
  },
  rubberband(value = 0) {
    switch (value) {
      case true:
        return [DEFAULT_RUBBERBAND, DEFAULT_RUBBERBAND];
      case false:
        return [0, 0];
      default:
        return V.toVector(value);
    }
  },
  from(value) {
    if (typeof value === "function")
      return value;
    if (value != null)
      return V.toVector(value);
  },
  transform(value, _k, config2) {
    const transform4 = value || config2.shared.transform;
    this.hasCustomTransform = !!transform4;
    if (process.env.NODE_ENV === "development") {
      const originalTransform = transform4 || identity;
      return (v5) => {
        const r2 = originalTransform(v5);
        if (!isFinite(r2[0]) || !isFinite(r2[1])) {
          console.warn(`[@use-gesture]: config.transform() must produce a valid result, but it was: [${r2[0]},${[1]}]`);
        }
        return r2;
      };
    }
    return transform4 || identity;
  },
  threshold(value) {
    return V.toVector(value, 0);
  }
};
if (process.env.NODE_ENV === "development") {
  Object.assign(commonConfigResolver, {
    domTarget(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);
      }
      return NaN;
    },
    lockDirection(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`lockDirection\` option has been merged with \`axis\`. Use it as in \`{ axis: 'lock' }\``);
      }
      return NaN;
    },
    initial(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`initial\` option has been renamed to \`from\`.`);
      }
      return NaN;
    }
  });
}
const DEFAULT_AXIS_THRESHOLD = 0;
const coordinatesConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  axis(_v, _k, {
    axis
  }) {
    this.lockDirection = axis === "lock";
    if (!this.lockDirection)
      return axis;
  },
  axisThreshold(value = DEFAULT_AXIS_THRESHOLD) {
    return value;
  },
  bounds(value = {}) {
    if (typeof value === "function") {
      return (state) => coordinatesConfigResolver.bounds(value(state));
    }
    if ("current" in value) {
      return () => value.current;
    }
    if (typeof HTMLElement === "function" && value instanceof HTMLElement) {
      return value;
    }
    const {
      left = -Infinity,
      right = Infinity,
      top = -Infinity,
      bottom = Infinity
    } = value;
    return [[left, right], [top, bottom]];
  }
});
const KEYS_DELTA_MAP = {
  ArrowRight: (displacement, factor = 1) => [displacement * factor, 0],
  ArrowLeft: (displacement, factor = 1) => [-1 * displacement * factor, 0],
  ArrowUp: (displacement, factor = 1) => [0, -1 * displacement * factor],
  ArrowDown: (displacement, factor = 1) => [0, displacement * factor]
};
class DragEngine extends CoordinatesEngine {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ingKey", "dragging");
  }
  reset() {
    super.reset();
    const state = this.state;
    state._pointerId = void 0;
    state._pointerActive = false;
    state._keyboardActive = false;
    state._preventScroll = false;
    state._delayed = false;
    state.swipe = [0, 0];
    state.tap = false;
    state.canceled = false;
    state.cancel = this.cancel.bind(this);
  }
  setup() {
    const state = this.state;
    if (state._bounds instanceof HTMLElement) {
      const boundRect = state._bounds.getBoundingClientRect();
      const targetRect = state.currentTarget.getBoundingClientRect();
      const _bounds = {
        left: boundRect.left - targetRect.left + state.offset[0],
        right: boundRect.right - targetRect.right + state.offset[0],
        top: boundRect.top - targetRect.top + state.offset[1],
        bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
      };
      state._bounds = coordinatesConfigResolver.bounds(_bounds);
    }
  }
  cancel() {
    const state = this.state;
    if (state.canceled)
      return;
    state.canceled = true;
    state._active = false;
    setTimeout(() => {
      this.compute();
      this.emit();
    }, 0);
  }
  setActive() {
    this.state._active = this.state._pointerActive || this.state._keyboardActive;
  }
  clean() {
    this.pointerClean();
    this.state._pointerActive = false;
    this.state._keyboardActive = false;
    super.clean();
  }
  pointerDown(event) {
    const config2 = this.config;
    const state = this.state;
    if (event.buttons != null && (Array.isArray(config2.pointerButtons) ? !config2.pointerButtons.includes(event.buttons) : config2.pointerButtons !== -1 && config2.pointerButtons !== event.buttons))
      return;
    const ctrlIds = this.ctrl.setEventIds(event);
    if (config2.pointerCapture) {
      event.target.setPointerCapture(event.pointerId);
    }
    if (ctrlIds && ctrlIds.size > 1 && state._pointerActive)
      return;
    this.start(event);
    this.setupPointer(event);
    state._pointerId = pointerId(event);
    state._pointerActive = true;
    this.computeValues(pointerValues(event));
    this.computeInitial();
    if (config2.preventScrollAxis && getPointerType(event) !== "mouse") {
      state._active = false;
      this.setupScrollPrevention(event);
    } else if (config2.delay > 0) {
      this.setupDelayTrigger(event);
      if (config2.triggerAllEvents) {
        this.compute(event);
        this.emit();
      }
    } else {
      this.startPointerDrag(event);
    }
  }
  startPointerDrag(event) {
    const state = this.state;
    state._active = true;
    state._preventScroll = true;
    state._delayed = false;
    this.compute(event);
    this.emit();
  }
  pointerMove(event) {
    const state = this.state;
    const config2 = this.config;
    if (!state._pointerActive)
      return;
    const id = pointerId(event);
    if (state._pointerId !== void 0 && id !== state._pointerId)
      return;
    const _values = pointerValues(event);
    if (document.pointerLockElement === event.target) {
      state._delta = [event.movementX, event.movementY];
    } else {
      state._delta = V.sub(_values, state._values);
      this.computeValues(_values);
    }
    V.addTo(state._movement, state._delta);
    this.compute(event);
    if (state._delayed && state.intentional) {
      this.timeoutStore.remove("dragDelay");
      state.active = false;
      this.startPointerDrag(event);
      return;
    }
    if (config2.preventScrollAxis && !state._preventScroll) {
      if (state.axis) {
        if (state.axis === config2.preventScrollAxis || config2.preventScrollAxis === "xy") {
          state._active = false;
          this.clean();
          return;
        } else {
          this.timeoutStore.remove("startPointerDrag");
          this.startPointerDrag(event);
          return;
        }
      } else {
        return;
      }
    }
    this.emit();
  }
  pointerUp(event) {
    this.ctrl.setEventIds(event);
    try {
      if (this.config.pointerCapture && event.target.hasPointerCapture(event.pointerId)) {
        ;
        event.target.releasePointerCapture(event.pointerId);
      }
    } catch (_unused) {
      if (process.env.NODE_ENV === "development") {
        console.warn(`[@use-gesture]: If you see this message, it's likely that you're using an outdated version of \`@react-three/fiber\`. 

Please upgrade to the latest version.`);
      }
    }
    const state = this.state;
    const config2 = this.config;
    if (!state._active || !state._pointerActive)
      return;
    const id = pointerId(event);
    if (state._pointerId !== void 0 && id !== state._pointerId)
      return;
    this.state._pointerActive = false;
    this.setActive();
    this.compute(event);
    const [dx, dy] = state._distance;
    state.tap = dx <= config2.tapsThreshold && dy <= config2.tapsThreshold;
    if (state.tap && config2.filterTaps) {
      state._force = true;
    } else {
      const [_dx, _dy] = state._delta;
      const [_mx, _my] = state._movement;
      const [svx, svy] = config2.swipe.velocity;
      const [sx, sy] = config2.swipe.distance;
      const sdt = config2.swipe.duration;
      if (state.elapsedTime < sdt) {
        const _vx = Math.abs(_dx / state.timeDelta);
        const _vy = Math.abs(_dy / state.timeDelta);
        if (_vx > svx && Math.abs(_mx) > sx)
          state.swipe[0] = Math.sign(_dx);
        if (_vy > svy && Math.abs(_my) > sy)
          state.swipe[1] = Math.sign(_dy);
      }
    }
    this.emit();
  }
  pointerClick(event) {
    if (!this.state.tap && event.detail > 0) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  setupPointer(event) {
    const config2 = this.config;
    const device = config2.device;
    if (process.env.NODE_ENV === "development") {
      try {
        if (device === "pointer" && config2.preventScrollDelay === void 0) {
          const currentTarget = "uv" in event ? event.sourceEvent.currentTarget : event.currentTarget;
          const style2 = window.getComputedStyle(currentTarget);
          if (style2.touchAction === "auto") {
            console.warn(`[@use-gesture]: The drag target has its \`touch-action\` style property set to \`auto\`. It is recommended to add \`touch-action: 'none'\` so that the drag gesture behaves correctly on touch-enabled devices. For more information read this: https://use-gesture.netlify.app/docs/extras/#touch-action.

This message will only show in development mode. It won't appear in production. If this is intended, you can ignore it.`, currentTarget);
          }
        }
      } catch (_unused2) {
      }
    }
    if (config2.pointerLock) {
      event.currentTarget.requestPointerLock();
    }
    if (!config2.pointerCapture) {
      this.eventStore.add(this.sharedConfig.window, device, "change", this.pointerMove.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, "end", this.pointerUp.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, "cancel", this.pointerUp.bind(this));
    }
  }
  pointerClean() {
    if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) {
      document.exitPointerLock();
    }
  }
  preventScroll(event) {
    if (this.state._preventScroll && event.cancelable) {
      event.preventDefault();
    }
  }
  setupScrollPrevention(event) {
    this.state._preventScroll = false;
    persistEvent(event);
    const remove6 = this.eventStore.add(this.sharedConfig.window, "touch", "change", this.preventScroll.bind(this), {
      passive: false
    });
    this.eventStore.add(this.sharedConfig.window, "touch", "end", remove6);
    this.eventStore.add(this.sharedConfig.window, "touch", "cancel", remove6);
    this.timeoutStore.add("startPointerDrag", this.startPointerDrag.bind(this), this.config.preventScrollDelay, event);
  }
  setupDelayTrigger(event) {
    this.state._delayed = true;
    this.timeoutStore.add("dragDelay", () => {
      this.state._step = [0, 0];
      this.startPointerDrag(event);
    }, this.config.delay);
  }
  keyDown(event) {
    const deltaFn = KEYS_DELTA_MAP[event.key];
    if (deltaFn) {
      const state = this.state;
      const factor = event.shiftKey ? 10 : event.altKey ? 0.1 : 1;
      this.start(event);
      state._delta = deltaFn(this.config.keyboardDisplacement, factor);
      state._keyboardActive = true;
      V.addTo(state._movement, state._delta);
      this.compute(event);
      this.emit();
    }
  }
  keyUp(event) {
    if (!(event.key in KEYS_DELTA_MAP))
      return;
    this.state._keyboardActive = false;
    this.setActive();
    this.compute(event);
    this.emit();
  }
  bind(bindFunction) {
    const device = this.config.device;
    bindFunction(device, "start", this.pointerDown.bind(this));
    if (this.config.pointerCapture) {
      bindFunction(device, "change", this.pointerMove.bind(this));
      bindFunction(device, "end", this.pointerUp.bind(this));
      bindFunction(device, "cancel", this.pointerUp.bind(this));
      bindFunction("lostPointerCapture", "", this.pointerUp.bind(this));
    }
    if (this.config.keys) {
      bindFunction("key", "down", this.keyDown.bind(this));
      bindFunction("key", "up", this.keyUp.bind(this));
    }
    if (this.config.filterTaps) {
      bindFunction("click", "", this.pointerClick.bind(this), {
        capture: true,
        passive: false
      });
    }
  }
}
function persistEvent(event) {
  "persist" in event && typeof event.persist === "function" && event.persist();
}
const isBrowser = typeof window !== "undefined" && window.document && window.document.createElement;
function supportsTouchEvents() {
  return isBrowser && "ontouchstart" in window;
}
function isTouchScreen() {
  return supportsTouchEvents() || isBrowser && window.navigator.maxTouchPoints > 1;
}
function supportsPointerEvents() {
  return isBrowser && "onpointerdown" in window;
}
function supportsPointerLock() {
  return isBrowser && "exitPointerLock" in window.document;
}
function supportsGestureEvents() {
  try {
    return "constructor" in GestureEvent;
  } catch (e3) {
    return false;
  }
}
const SUPPORT = {
  isBrowser,
  gesture: supportsGestureEvents(),
  touch: supportsTouchEvents(),
  touchscreen: isTouchScreen(),
  pointer: supportsPointerEvents(),
  pointerLock: supportsPointerLock()
};
const DEFAULT_PREVENT_SCROLL_DELAY = 250;
const DEFAULT_DRAG_DELAY = 180;
const DEFAULT_SWIPE_VELOCITY = 0.5;
const DEFAULT_SWIPE_DISTANCE = 50;
const DEFAULT_SWIPE_DURATION = 250;
const DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const DEFAULT_DRAG_AXIS_THRESHOLD = {
  mouse: 0,
  touch: 0,
  pen: 8
};
const dragConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  device(_v, _k, {
    pointer: {
      touch = false,
      lock = false,
      mouse = false
    } = {}
  }) {
    this.pointerLock = lock && SUPPORT.pointerLock;
    if (SUPPORT.touch && touch)
      return "touch";
    if (this.pointerLock)
      return "mouse";
    if (SUPPORT.pointer && !mouse)
      return "pointer";
    if (SUPPORT.touch)
      return "touch";
    return "mouse";
  },
  preventScrollAxis(value, _k, {
    preventScroll
  }) {
    this.preventScrollDelay = typeof preventScroll === "number" ? preventScroll : preventScroll || preventScroll === void 0 && value ? DEFAULT_PREVENT_SCROLL_DELAY : void 0;
    if (!SUPPORT.touchscreen || preventScroll === false)
      return void 0;
    return value ? value : preventScroll !== void 0 ? "y" : void 0;
  },
  pointerCapture(_v, _k, {
    pointer: {
      capture = true,
      buttons = 1,
      keys: keys4 = true
    } = {}
  }) {
    this.pointerButtons = buttons;
    this.keys = keys4;
    return !this.pointerLock && this.device === "pointer" && capture;
  },
  threshold(value, _k, {
    filterTaps = false,
    tapsThreshold = 3,
    axis = void 0
  }) {
    const threshold2 = V.toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
    this.filterTaps = filterTaps;
    this.tapsThreshold = tapsThreshold;
    return threshold2;
  },
  swipe({
    velocity = DEFAULT_SWIPE_VELOCITY,
    distance: distance11 = DEFAULT_SWIPE_DISTANCE,
    duration = DEFAULT_SWIPE_DURATION
  } = {}) {
    return {
      velocity: this.transform(V.toVector(velocity)),
      distance: this.transform(V.toVector(distance11)),
      duration
    };
  },
  delay(value = 0) {
    switch (value) {
      case true:
        return DEFAULT_DRAG_DELAY;
      case false:
        return 0;
      default:
        return value;
    }
  },
  axisThreshold(value) {
    if (!value)
      return DEFAULT_DRAG_AXIS_THRESHOLD;
    return _objectSpread2(_objectSpread2({}, DEFAULT_DRAG_AXIS_THRESHOLD), value);
  },
  keyboardDisplacement(value = DEFAULT_KEYBOARD_DISPLACEMENT) {
    return value;
  }
});
if (process.env.NODE_ENV === "development") {
  Object.assign(dragConfigResolver, {
    useTouch(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`useTouch\` option has been renamed to \`pointer.touch\`. Use it as in \`{ pointer: { touch: true } }\`.`);
      }
      return NaN;
    },
    experimental_preventWindowScrollY(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`experimental_preventWindowScrollY\` option has been renamed to \`preventScroll\`.`);
      }
      return NaN;
    },
    swipeVelocity(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeVelocity\` option has been renamed to \`swipe.velocity\`. Use it as in \`{ swipe: { velocity: 0.5 } }\`.`);
      }
      return NaN;
    },
    swipeDistance(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeDistance\` option has been renamed to \`swipe.distance\`. Use it as in \`{ swipe: { distance: 50 } }\`.`);
      }
      return NaN;
    },
    swipeDuration(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeDuration\` option has been renamed to \`swipe.duration\`. Use it as in \`{ swipe: { duration: 250 } }\`.`);
      }
      return NaN;
    }
  });
}
_objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  device(_v, _k, {
    shared,
    pointer: {
      touch = false
    } = {}
  }) {
    const sharedConfig = shared;
    if (sharedConfig.target && !SUPPORT.touch && SUPPORT.gesture)
      return "gesture";
    if (SUPPORT.touch && touch)
      return "touch";
    if (SUPPORT.touchscreen) {
      if (SUPPORT.pointer)
        return "pointer";
      if (SUPPORT.touch)
        return "touch";
    }
  },
  bounds(_v, _k, {
    scaleBounds = {},
    angleBounds = {}
  }) {
    const _scaleBounds = (state) => {
      const D2 = assignDefault(call(scaleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [D2.min, D2.max];
    };
    const _angleBounds = (state) => {
      const A2 = assignDefault(call(angleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [A2.min, A2.max];
    };
    if (typeof scaleBounds !== "function" && typeof angleBounds !== "function")
      return [_scaleBounds(), _angleBounds()];
    return (state) => [_scaleBounds(state), _angleBounds(state)];
  },
  threshold(value, _k, config2) {
    this.lockDirection = config2.axis === "lock";
    const threshold2 = V.toVector(value, this.lockDirection ? [0.1, 3] : 0);
    return threshold2;
  },
  modifierKey(value) {
    if (value === void 0)
      return "ctrlKey";
    return value;
  },
  pinchOnWheel(value = true) {
    return value;
  }
});
_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: (value = true) => value
});
_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: (value = true) => value
});
const EngineMap = /* @__PURE__ */ new Map();
const ConfigResolverMap = /* @__PURE__ */ new Map();
function registerAction(action) {
  EngineMap.set(action.key, action.engine);
  ConfigResolverMap.set(action.key, action.resolver);
}
const dragAction = {
  key: "drag",
  engine: DragEngine,
  resolver: dragConfigResolver
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
const sharedConfigResolver = {
  target(value) {
    if (value) {
      return () => "current" in value ? value.current : value;
    }
    return void 0;
  },
  enabled(value = true) {
    return value;
  },
  window(value = SUPPORT.isBrowser ? window : void 0) {
    return value;
  },
  eventOptions({
    passive = true,
    capture = false
  } = {}) {
    return {
      passive,
      capture
    };
  },
  transform(value) {
    return value;
  }
};
const _excluded = ["target", "eventOptions", "window", "enabled", "transform"];
function resolveWith(config2 = {}, resolvers) {
  const result = {};
  for (const [key, resolver] of Object.entries(resolvers)) {
    switch (typeof resolver) {
      case "function":
        if (process.env.NODE_ENV === "development") {
          const r2 = resolver.call(result, config2[key], key, config2);
          if (!Number.isNaN(r2))
            result[key] = r2;
        } else {
          result[key] = resolver.call(result, config2[key], key, config2);
        }
        break;
      case "object":
        result[key] = resolveWith(config2[key], resolver);
        break;
      case "boolean":
        if (resolver)
          result[key] = config2[key];
        break;
    }
  }
  return result;
}
function parse(newConfig, gestureKey, _config = {}) {
  const _ref2 = newConfig, {
    target,
    eventOptions,
    window: window2,
    enabled,
    transform: transform4
  } = _ref2, rest = _objectWithoutProperties(_ref2, _excluded);
  _config.shared = resolveWith({
    target,
    eventOptions,
    window: window2,
    enabled,
    transform: transform4
  }, sharedConfigResolver);
  if (gestureKey) {
    const resolver = ConfigResolverMap.get(gestureKey);
    _config[gestureKey] = resolveWith(_objectSpread2({
      shared: _config.shared
    }, rest), resolver);
  } else {
    for (const key in rest) {
      const resolver = ConfigResolverMap.get(key);
      if (resolver) {
        _config[key] = resolveWith(_objectSpread2({
          shared: _config.shared
        }, rest[key]), resolver);
      } else if (process.env.NODE_ENV === "development") {
        if (!["drag", "pinch", "scroll", "wheel", "move", "hover"].includes(key)) {
          if (key === "domTarget") {
            throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);
          }
          console.warn(`[@use-gesture]: Unknown config key \`${key}\` was used. Please read the documentation for further information.`);
        }
      }
    }
  }
  return _config;
}
class EventStore {
  constructor(ctrl, gestureKey) {
    _defineProperty(this, "_listeners", /* @__PURE__ */ new Set());
    this._ctrl = ctrl;
    this._gestureKey = gestureKey;
  }
  add(element, device, action, handler, options2) {
    const listeners2 = this._listeners;
    const type = toDomEventType(device, action);
    const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
    const eventOptions = _objectSpread2(_objectSpread2({}, _options), options2);
    element.addEventListener(type, handler, eventOptions);
    const remove6 = () => {
      element.removeEventListener(type, handler, eventOptions);
      listeners2.delete(remove6);
    };
    listeners2.add(remove6);
    return remove6;
  }
  clean() {
    this._listeners.forEach((remove6) => remove6());
    this._listeners.clear();
  }
}
class TimeoutStore {
  constructor() {
    _defineProperty(this, "_timeouts", /* @__PURE__ */ new Map());
  }
  add(key, callback, ms = 140, ...args) {
    this.remove(key);
    this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
  }
  remove(key) {
    const timeout = this._timeouts.get(key);
    if (timeout)
      window.clearTimeout(timeout);
  }
  clean() {
    this._timeouts.forEach((timeout) => void window.clearTimeout(timeout));
    this._timeouts.clear();
  }
}
class Controller {
  constructor(handlers2) {
    _defineProperty(this, "gestures", /* @__PURE__ */ new Set());
    _defineProperty(this, "_targetEventStore", new EventStore(this));
    _defineProperty(this, "gestureEventStores", {});
    _defineProperty(this, "gestureTimeoutStores", {});
    _defineProperty(this, "handlers", {});
    _defineProperty(this, "config", {});
    _defineProperty(this, "pointerIds", /* @__PURE__ */ new Set());
    _defineProperty(this, "touchIds", /* @__PURE__ */ new Set());
    _defineProperty(this, "state", {
      shared: {
        shiftKey: false,
        metaKey: false,
        ctrlKey: false,
        altKey: false
      }
    });
    resolveGestures(this, handlers2);
  }
  setEventIds(event) {
    if (isTouch(event)) {
      this.touchIds = new Set(touchIds(event));
      return this.touchIds;
    } else if ("pointerId" in event) {
      if (event.type === "pointerup" || event.type === "pointercancel")
        this.pointerIds.delete(event.pointerId);
      else if (event.type === "pointerdown")
        this.pointerIds.add(event.pointerId);
      return this.pointerIds;
    }
  }
  applyHandlers(handlers2, nativeHandlers) {
    this.handlers = handlers2;
    this.nativeHandlers = nativeHandlers;
  }
  applyConfig(config2, gestureKey) {
    this.config = parse(config2, gestureKey, this.config);
  }
  clean() {
    this._targetEventStore.clean();
    for (const key of this.gestures) {
      this.gestureEventStores[key].clean();
      this.gestureTimeoutStores[key].clean();
    }
  }
  effect() {
    if (this.config.shared.target)
      this.bind();
    return () => this._targetEventStore.clean();
  }
  bind(...args) {
    const sharedConfig = this.config.shared;
    const props = {};
    let target;
    if (sharedConfig.target) {
      target = sharedConfig.target();
      if (!target)
        return;
    }
    if (sharedConfig.enabled) {
      for (const gestureKey of this.gestures) {
        const gestureConfig = this.config[gestureKey];
        const bindFunction = bindToProps(props, gestureConfig.eventOptions, !!target);
        if (gestureConfig.enabled) {
          const Engine2 = EngineMap.get(gestureKey);
          new Engine2(this, args, gestureKey).bind(bindFunction);
        }
      }
      const nativeBindFunction = bindToProps(props, sharedConfig.eventOptions, !!target);
      for (const eventKey in this.nativeHandlers) {
        nativeBindFunction(eventKey, "", (event) => this.nativeHandlers[eventKey](_objectSpread2(_objectSpread2({}, this.state.shared), {}, {
          event,
          args
        })), void 0, true);
      }
    }
    for (const handlerProp in props) {
      props[handlerProp] = chain(...props[handlerProp]);
    }
    if (!target)
      return props;
    for (const handlerProp in props) {
      const {
        device,
        capture,
        passive
      } = parseProp(handlerProp);
      this._targetEventStore.add(target, device, "", props[handlerProp], {
        capture,
        passive
      });
    }
  }
}
function setupGesture(ctrl, gestureKey) {
  ctrl.gestures.add(gestureKey);
  ctrl.gestureEventStores[gestureKey] = new EventStore(ctrl, gestureKey);
  ctrl.gestureTimeoutStores[gestureKey] = new TimeoutStore();
}
function resolveGestures(ctrl, internalHandlers) {
  if (internalHandlers.drag)
    setupGesture(ctrl, "drag");
  if (internalHandlers.wheel)
    setupGesture(ctrl, "wheel");
  if (internalHandlers.scroll)
    setupGesture(ctrl, "scroll");
  if (internalHandlers.move)
    setupGesture(ctrl, "move");
  if (internalHandlers.pinch)
    setupGesture(ctrl, "pinch");
  if (internalHandlers.hover)
    setupGesture(ctrl, "hover");
}
const bindToProps = (props, eventOptions, withPassiveOption) => (device, action, handler, options2 = {}, isNative = false) => {
  var _options$capture, _options$passive;
  const capture = (_options$capture = options2.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
  const passive = (_options$passive = options2.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
  let handlerProp = isNative ? device : toHandlerProp(device, action, capture);
  if (withPassiveOption && passive)
    handlerProp += "Passive";
  props[handlerProp] = props[handlerProp] || [];
  props[handlerProp].push(handler);
};
function useRecognizers(handlers2, config2 = {}, gestureKey, nativeHandlers) {
  const ctrl = React__default.useMemo(() => new Controller(handlers2), []);
  ctrl.applyHandlers(handlers2, nativeHandlers);
  ctrl.applyConfig(config2, gestureKey);
  React__default.useEffect(ctrl.effect.bind(ctrl));
  React__default.useEffect(() => {
    return ctrl.clean.bind(ctrl);
  }, []);
  if (config2.target === void 0) {
    return ctrl.bind.bind(ctrl);
  }
  return void 0;
}
function useDrag(handler, config2) {
  registerAction(dragAction);
  return useRecognizers({
    drag: handler
  }, config2 || {}, "drag");
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class EventDispatcher {
  constructor() {
    __publicField$1(this, "_listeners");
  }
  /**
   * Adds a listener to an event type.
   * @param type The type of event to listen to.
   * @param listener The function that gets called when the event is fired.
   */
  addEventListener(type, listener) {
    if (this._listeners === void 0)
      this._listeners = {};
    const listeners2 = this._listeners;
    if (listeners2[type] === void 0) {
      listeners2[type] = [];
    }
    if (listeners2[type].indexOf(listener) === -1) {
      listeners2[type].push(listener);
    }
  }
  /**
      * Checks if listener is added to an event type.
      * @param type The type of event to listen to.
      * @param listener The function that gets called when the event is fired.
      */
  hasEventListener(type, listener) {
    if (this._listeners === void 0)
      return false;
    const listeners2 = this._listeners;
    return listeners2[type] !== void 0 && listeners2[type].indexOf(listener) !== -1;
  }
  /**
      * Removes a listener from an event type.
      * @param type The type of the listener that gets removed.
      * @param listener The listener function that gets removed.
      */
  removeEventListener(type, listener) {
    if (this._listeners === void 0)
      return;
    const listeners2 = this._listeners;
    const listenerArray = listeners2[type];
    if (listenerArray !== void 0) {
      const index2 = listenerArray.indexOf(listener);
      if (index2 !== -1) {
        listenerArray.splice(index2, 1);
      }
    }
  }
  /**
      * Fire an event type.
      * @param event The event that gets fired.
      */
  dispatchEvent(event) {
    if (this._listeners === void 0)
      return;
    const listeners2 = this._listeners;
    const listenerArray = listeners2[event.type];
    if (listenerArray !== void 0) {
      event.target = this;
      const array2 = listenerArray.slice(0);
      for (let i2 = 0, l2 = array2.length; i2 < l2; i2++) {
        array2[i2].call(this, event);
      }
      event.target = null;
    }
  }
}
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _ray = /* @__PURE__ */ new Ray();
const _plane = /* @__PURE__ */ new Plane$1();
const TILT_LIMIT = Math.cos(70 * (Math.PI / 180));
const moduloWrapAround = (offset, capacity) => (offset % capacity + capacity) % capacity;
let OrbitControls$1 = class OrbitControls2 extends EventDispatcher {
  constructor(object2, domElement) {
    super();
    __publicField(this, "object");
    __publicField(this, "domElement");
    __publicField(this, "enabled", true);
    __publicField(this, "target", new Vector3$1());
    __publicField(this, "minDistance", 0);
    __publicField(this, "maxDistance", Infinity);
    __publicField(this, "minZoom", 0);
    __publicField(this, "maxZoom", Infinity);
    __publicField(this, "minPolarAngle", 0);
    __publicField(this, "maxPolarAngle", Math.PI);
    __publicField(this, "minAzimuthAngle", -Infinity);
    __publicField(this, "maxAzimuthAngle", Infinity);
    __publicField(this, "enableDamping", false);
    __publicField(this, "dampingFactor", 0.05);
    __publicField(this, "enableZoom", true);
    __publicField(this, "zoomSpeed", 1);
    __publicField(this, "enableRotate", true);
    __publicField(this, "rotateSpeed", 1);
    __publicField(this, "enablePan", true);
    __publicField(this, "panSpeed", 1);
    __publicField(this, "screenSpacePanning", true);
    __publicField(this, "keyPanSpeed", 7);
    __publicField(this, "zoomToCursor", false);
    __publicField(this, "autoRotate", false);
    __publicField(this, "autoRotateSpeed", 2);
    __publicField(this, "reverseOrbit", false);
    __publicField(this, "reverseHorizontalOrbit", false);
    __publicField(this, "reverseVerticalOrbit", false);
    __publicField(this, "keys", { LEFT: "ArrowLeft", UP: "ArrowUp", RIGHT: "ArrowRight", BOTTOM: "ArrowDown" });
    __publicField(this, "mouseButtons", {
      LEFT: MOUSE.ROTATE,
      MIDDLE: MOUSE.DOLLY,
      RIGHT: MOUSE.PAN
    });
    __publicField(this, "touches", { ONE: TOUCH.ROTATE, TWO: TOUCH.DOLLY_PAN });
    __publicField(this, "target0");
    __publicField(this, "position0");
    __publicField(this, "zoom0");
    __publicField(this, "_domElementKeyEvents", null);
    __publicField(this, "getPolarAngle");
    __publicField(this, "getAzimuthalAngle");
    __publicField(this, "setPolarAngle");
    __publicField(this, "setAzimuthalAngle");
    __publicField(this, "getDistance");
    __publicField(this, "getZoomScale");
    __publicField(this, "listenToKeyEvents");
    __publicField(this, "stopListenToKeyEvents");
    __publicField(this, "saveState");
    __publicField(this, "reset");
    __publicField(this, "update");
    __publicField(this, "connect");
    __publicField(this, "dispose");
    __publicField(this, "dollyIn");
    __publicField(this, "dollyOut");
    __publicField(this, "getScale");
    __publicField(this, "setScale");
    this.object = object2;
    this.domElement = domElement;
    this.target0 = this.target.clone();
    this.position0 = this.object.position.clone();
    this.zoom0 = this.object.zoom;
    this.getPolarAngle = () => spherical2.phi;
    this.getAzimuthalAngle = () => spherical2.theta;
    this.setPolarAngle = (value) => {
      let phi = moduloWrapAround(value, 2 * Math.PI);
      let currentPhi = spherical2.phi;
      if (currentPhi < 0)
        currentPhi += 2 * Math.PI;
      if (phi < 0)
        phi += 2 * Math.PI;
      let phiDist = Math.abs(phi - currentPhi);
      if (2 * Math.PI - phiDist < phiDist) {
        if (phi < currentPhi) {
          phi += 2 * Math.PI;
        } else {
          currentPhi += 2 * Math.PI;
        }
      }
      sphericalDelta.phi = phi - currentPhi;
      scope.update();
    };
    this.setAzimuthalAngle = (value) => {
      let theta = moduloWrapAround(value, 2 * Math.PI);
      let currentTheta = spherical2.theta;
      if (currentTheta < 0)
        currentTheta += 2 * Math.PI;
      if (theta < 0)
        theta += 2 * Math.PI;
      let thetaDist = Math.abs(theta - currentTheta);
      if (2 * Math.PI - thetaDist < thetaDist) {
        if (theta < currentTheta) {
          theta += 2 * Math.PI;
        } else {
          currentTheta += 2 * Math.PI;
        }
      }
      sphericalDelta.theta = theta - currentTheta;
      scope.update();
    };
    this.getDistance = () => scope.object.position.distanceTo(scope.target);
    this.listenToKeyEvents = (domElement2) => {
      domElement2.addEventListener("keydown", onKeyDown);
      this._domElementKeyEvents = domElement2;
    };
    this.stopListenToKeyEvents = () => {
      this._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
      this._domElementKeyEvents = null;
    };
    this.saveState = () => {
      scope.target0.copy(scope.target);
      scope.position0.copy(scope.object.position);
      scope.zoom0 = scope.object.zoom;
    };
    this.reset = () => {
      scope.target.copy(scope.target0);
      scope.object.position.copy(scope.position0);
      scope.object.zoom = scope.zoom0;
      scope.object.updateProjectionMatrix();
      scope.dispatchEvent(changeEvent);
      scope.update();
      state = STATE.NONE;
    };
    this.update = (() => {
      const offset = new Vector3$1();
      const up = new Vector3$1(0, 1, 0);
      const quat = new Quaternion$1().setFromUnitVectors(object2.up, up);
      const quatInverse = quat.clone().invert();
      const lastPosition = new Vector3$1();
      const lastQuaternion = new Quaternion$1();
      const twoPI = 2 * Math.PI;
      return function update() {
        const position = scope.object.position;
        quat.setFromUnitVectors(object2.up, up);
        quatInverse.copy(quat).invert();
        offset.copy(position).sub(scope.target);
        offset.applyQuaternion(quat);
        spherical2.setFromVector3(offset);
        if (scope.autoRotate && state === STATE.NONE) {
          rotateLeft3(getAutoRotationAngle());
        }
        if (scope.enableDamping) {
          spherical2.theta += sphericalDelta.theta * scope.dampingFactor;
          spherical2.phi += sphericalDelta.phi * scope.dampingFactor;
        } else {
          spherical2.theta += sphericalDelta.theta;
          spherical2.phi += sphericalDelta.phi;
        }
        let min4 = scope.minAzimuthAngle;
        let max3 = scope.maxAzimuthAngle;
        if (isFinite(min4) && isFinite(max3)) {
          if (min4 < -Math.PI)
            min4 += twoPI;
          else if (min4 > Math.PI)
            min4 -= twoPI;
          if (max3 < -Math.PI)
            max3 += twoPI;
          else if (max3 > Math.PI)
            max3 -= twoPI;
          if (min4 <= max3) {
            spherical2.theta = Math.max(min4, Math.min(max3, spherical2.theta));
          } else {
            spherical2.theta = spherical2.theta > (min4 + max3) / 2 ? Math.max(min4, spherical2.theta) : Math.min(max3, spherical2.theta);
          }
        }
        spherical2.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical2.phi));
        spherical2.makeSafe();
        if (scope.enableDamping === true) {
          scope.target.addScaledVector(panOffset, scope.dampingFactor);
        } else {
          scope.target.add(panOffset);
        }
        if (scope.zoomToCursor && performCursorZoom || scope.object.isOrthographicCamera) {
          spherical2.radius = clampDistance(spherical2.radius);
        } else {
          spherical2.radius = clampDistance(spherical2.radius * scale5);
        }
        offset.setFromSpherical(spherical2);
        offset.applyQuaternion(quatInverse);
        position.copy(scope.target).add(offset);
        if (!scope.object.matrixAutoUpdate)
          scope.object.updateMatrix();
        scope.object.lookAt(scope.target);
        if (scope.enableDamping === true) {
          sphericalDelta.theta *= 1 - scope.dampingFactor;
          sphericalDelta.phi *= 1 - scope.dampingFactor;
          panOffset.multiplyScalar(1 - scope.dampingFactor);
        } else {
          sphericalDelta.set(0, 0, 0);
          panOffset.set(0, 0, 0);
        }
        let zoomChanged = false;
        if (scope.zoomToCursor && performCursorZoom) {
          let newRadius = null;
          if (scope.object instanceof PerspectiveCamera && scope.object.isPerspectiveCamera) {
            const prevRadius = offset.length();
            newRadius = clampDistance(prevRadius * scale5);
            const radiusDelta = prevRadius - newRadius;
            scope.object.position.addScaledVector(dollyDirection, radiusDelta);
            scope.object.updateMatrixWorld();
          } else if (scope.object.isOrthographicCamera) {
            const mouseBefore = new Vector3$1(mouse.x, mouse.y, 0);
            mouseBefore.unproject(scope.object);
            scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / scale5));
            scope.object.updateProjectionMatrix();
            zoomChanged = true;
            const mouseAfter = new Vector3$1(mouse.x, mouse.y, 0);
            mouseAfter.unproject(scope.object);
            scope.object.position.sub(mouseAfter).add(mouseBefore);
            scope.object.updateMatrixWorld();
            newRadius = offset.length();
          } else {
            console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.");
            scope.zoomToCursor = false;
          }
          if (newRadius !== null) {
            if (scope.screenSpacePanning) {
              scope.target.set(0, 0, -1).transformDirection(scope.object.matrix).multiplyScalar(newRadius).add(scope.object.position);
            } else {
              _ray.origin.copy(scope.object.position);
              _ray.direction.set(0, 0, -1).transformDirection(scope.object.matrix);
              if (Math.abs(scope.object.up.dot(_ray.direction)) < TILT_LIMIT) {
                object2.lookAt(scope.target);
              } else {
                _plane.setFromNormalAndCoplanarPoint(scope.object.up, scope.target);
                _ray.intersectPlane(_plane, scope.target);
              }
            }
          }
        } else if (scope.object instanceof OrthographicCamera && scope.object.isOrthographicCamera) {
          zoomChanged = scale5 !== 1;
          if (zoomChanged) {
            scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / scale5));
            scope.object.updateProjectionMatrix();
          }
        }
        scale5 = 1;
        performCursorZoom = false;
        if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
          scope.dispatchEvent(changeEvent);
          lastPosition.copy(scope.object.position);
          lastQuaternion.copy(scope.object.quaternion);
          zoomChanged = false;
          return true;
        }
        return false;
      };
    })();
    this.connect = (domElement2) => {
      scope.domElement = domElement2;
      scope.domElement.style.touchAction = "none";
      scope.domElement.addEventListener("contextmenu", onContextMenu);
      scope.domElement.addEventListener("pointerdown", onPointerDown2);
      scope.domElement.addEventListener("pointercancel", onPointerUp2);
      scope.domElement.addEventListener("wheel", onMouseWheel);
    };
    this.dispose = () => {
      var _a3, _b3, _c2, _d2, _e2, _f3;
      if (scope.domElement) {
        scope.domElement.style.touchAction = "auto";
      }
      (_a3 = scope.domElement) == null ? void 0 : _a3.removeEventListener("contextmenu", onContextMenu);
      (_b3 = scope.domElement) == null ? void 0 : _b3.removeEventListener("pointerdown", onPointerDown2);
      (_c2 = scope.domElement) == null ? void 0 : _c2.removeEventListener("pointercancel", onPointerUp2);
      (_d2 = scope.domElement) == null ? void 0 : _d2.removeEventListener("wheel", onMouseWheel);
      (_e2 = scope.domElement) == null ? void 0 : _e2.ownerDocument.removeEventListener("pointermove", onPointerMove2);
      (_f3 = scope.domElement) == null ? void 0 : _f3.ownerDocument.removeEventListener("pointerup", onPointerUp2);
      if (scope._domElementKeyEvents !== null) {
        scope._domElementKeyEvents.removeEventListener("keydown", onKeyDown);
      }
    };
    const scope = this;
    const changeEvent = { type: "change" };
    const startEvent = { type: "start" };
    const endEvent = { type: "end" };
    const STATE = {
      NONE: -1,
      ROTATE: 0,
      DOLLY: 1,
      PAN: 2,
      TOUCH_ROTATE: 3,
      TOUCH_PAN: 4,
      TOUCH_DOLLY_PAN: 5,
      TOUCH_DOLLY_ROTATE: 6
    };
    let state = STATE.NONE;
    const EPS = 1e-6;
    const spherical2 = new Spherical();
    const sphericalDelta = new Spherical();
    let scale5 = 1;
    const panOffset = new Vector3$1();
    const rotateStart = new Vector2$1();
    const rotateEnd = new Vector2$1();
    const rotateDelta = new Vector2$1();
    const panStart = new Vector2$1();
    const panEnd = new Vector2$1();
    const panDelta = new Vector2$1();
    const dollyStart = new Vector2$1();
    const dollyEnd = new Vector2$1();
    const dollyDelta = new Vector2$1();
    const dollyDirection = new Vector3$1();
    const mouse = new Vector2$1();
    let performCursorZoom = false;
    const pointers = [];
    const pointerPositions = {};
    function getAutoRotationAngle() {
      return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
    }
    function getZoomScale() {
      return Math.pow(0.95, scope.zoomSpeed);
    }
    function rotateLeft3(angle4) {
      if (scope.reverseOrbit || scope.reverseHorizontalOrbit) {
        sphericalDelta.theta += angle4;
      } else {
        sphericalDelta.theta -= angle4;
      }
    }
    function rotateUp(angle4) {
      if (scope.reverseOrbit || scope.reverseVerticalOrbit) {
        sphericalDelta.phi += angle4;
      } else {
        sphericalDelta.phi -= angle4;
      }
    }
    const panLeft = (() => {
      const v5 = new Vector3$1();
      return function panLeft2(distance11, objectMatrix) {
        v5.setFromMatrixColumn(objectMatrix, 0);
        v5.multiplyScalar(-distance11);
        panOffset.add(v5);
      };
    })();
    const panUp = (() => {
      const v5 = new Vector3$1();
      return function panUp2(distance11, objectMatrix) {
        if (scope.screenSpacePanning === true) {
          v5.setFromMatrixColumn(objectMatrix, 1);
        } else {
          v5.setFromMatrixColumn(objectMatrix, 0);
          v5.crossVectors(scope.object.up, v5);
        }
        v5.multiplyScalar(distance11);
        panOffset.add(v5);
      };
    })();
    const pan = (() => {
      const offset = new Vector3$1();
      return function pan2(deltaX, deltaY) {
        const element = scope.domElement;
        if (element && scope.object instanceof PerspectiveCamera && scope.object.isPerspectiveCamera) {
          const position = scope.object.position;
          offset.copy(position).sub(scope.target);
          let targetDistance = offset.length();
          targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180);
          panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
          panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
        } else if (element && scope.object instanceof OrthographicCamera && scope.object.isOrthographicCamera) {
          panLeft(
            deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth,
            scope.object.matrix
          );
          panUp(
            deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight,
            scope.object.matrix
          );
        } else {
          console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.");
          scope.enablePan = false;
        }
      };
    })();
    function setScale2(newScale) {
      if (scope.object instanceof PerspectiveCamera && scope.object.isPerspectiveCamera || scope.object instanceof OrthographicCamera && scope.object.isOrthographicCamera) {
        scale5 = newScale;
      } else {
        console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.");
        scope.enableZoom = false;
      }
    }
    function dollyOut(dollyScale) {
      setScale2(scale5 / dollyScale);
    }
    function dollyIn(dollyScale) {
      setScale2(scale5 * dollyScale);
    }
    function updateMouseParameters(event) {
      if (!scope.zoomToCursor || !scope.domElement) {
        return;
      }
      performCursorZoom = true;
      const rect = scope.domElement.getBoundingClientRect();
      const x2 = event.clientX - rect.left;
      const y2 = event.clientY - rect.top;
      const w2 = rect.width;
      const h2 = rect.height;
      mouse.x = x2 / w2 * 2 - 1;
      mouse.y = -(y2 / h2) * 2 + 1;
      dollyDirection.set(mouse.x, mouse.y, 1).unproject(scope.object).sub(scope.object.position).normalize();
    }
    function clampDistance(dist2) {
      return Math.max(scope.minDistance, Math.min(scope.maxDistance, dist2));
    }
    function handleMouseDownRotate(event) {
      rotateStart.set(event.clientX, event.clientY);
    }
    function handleMouseDownDolly(event) {
      updateMouseParameters(event);
      dollyStart.set(event.clientX, event.clientY);
    }
    function handleMouseDownPan(event) {
      panStart.set(event.clientX, event.clientY);
    }
    function handleMouseMoveRotate(event) {
      rotateEnd.set(event.clientX, event.clientY);
      rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
      const element = scope.domElement;
      if (element) {
        rotateLeft3(2 * Math.PI * rotateDelta.x / element.clientHeight);
        rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
      }
      rotateStart.copy(rotateEnd);
      scope.update();
    }
    function handleMouseMoveDolly(event) {
      dollyEnd.set(event.clientX, event.clientY);
      dollyDelta.subVectors(dollyEnd, dollyStart);
      if (dollyDelta.y > 0) {
        dollyOut(getZoomScale());
      } else if (dollyDelta.y < 0) {
        dollyIn(getZoomScale());
      }
      dollyStart.copy(dollyEnd);
      scope.update();
    }
    function handleMouseMovePan(event) {
      panEnd.set(event.clientX, event.clientY);
      panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
      pan(panDelta.x, panDelta.y);
      panStart.copy(panEnd);
      scope.update();
    }
    function handleMouseWheel(event) {
      updateMouseParameters(event);
      if (event.deltaY < 0) {
        dollyIn(getZoomScale());
      } else if (event.deltaY > 0) {
        dollyOut(getZoomScale());
      }
      scope.update();
    }
    function handleKeyDown(event) {
      let needsUpdate = false;
      switch (event.code) {
        case scope.keys.UP:
          pan(0, scope.keyPanSpeed);
          needsUpdate = true;
          break;
        case scope.keys.BOTTOM:
          pan(0, -scope.keyPanSpeed);
          needsUpdate = true;
          break;
        case scope.keys.LEFT:
          pan(scope.keyPanSpeed, 0);
          needsUpdate = true;
          break;
        case scope.keys.RIGHT:
          pan(-scope.keyPanSpeed, 0);
          needsUpdate = true;
          break;
      }
      if (needsUpdate) {
        event.preventDefault();
        scope.update();
      }
    }
    function handleTouchStartRotate() {
      if (pointers.length == 1) {
        rotateStart.set(pointers[0].pageX, pointers[0].pageY);
      } else {
        const x2 = 0.5 * (pointers[0].pageX + pointers[1].pageX);
        const y2 = 0.5 * (pointers[0].pageY + pointers[1].pageY);
        rotateStart.set(x2, y2);
      }
    }
    function handleTouchStartPan() {
      if (pointers.length == 1) {
        panStart.set(pointers[0].pageX, pointers[0].pageY);
      } else {
        const x2 = 0.5 * (pointers[0].pageX + pointers[1].pageX);
        const y2 = 0.5 * (pointers[0].pageY + pointers[1].pageY);
        panStart.set(x2, y2);
      }
    }
    function handleTouchStartDolly() {
      const dx = pointers[0].pageX - pointers[1].pageX;
      const dy = pointers[0].pageY - pointers[1].pageY;
      const distance11 = Math.sqrt(dx * dx + dy * dy);
      dollyStart.set(0, distance11);
    }
    function handleTouchStartDollyPan() {
      if (scope.enableZoom)
        handleTouchStartDolly();
      if (scope.enablePan)
        handleTouchStartPan();
    }
    function handleTouchStartDollyRotate() {
      if (scope.enableZoom)
        handleTouchStartDolly();
      if (scope.enableRotate)
        handleTouchStartRotate();
    }
    function handleTouchMoveRotate(event) {
      if (pointers.length == 1) {
        rotateEnd.set(event.pageX, event.pageY);
      } else {
        const position = getSecondPointerPosition(event);
        const x2 = 0.5 * (event.pageX + position.x);
        const y2 = 0.5 * (event.pageY + position.y);
        rotateEnd.set(x2, y2);
      }
      rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
      const element = scope.domElement;
      if (element) {
        rotateLeft3(2 * Math.PI * rotateDelta.x / element.clientHeight);
        rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
      }
      rotateStart.copy(rotateEnd);
    }
    function handleTouchMovePan(event) {
      if (pointers.length == 1) {
        panEnd.set(event.pageX, event.pageY);
      } else {
        const position = getSecondPointerPosition(event);
        const x2 = 0.5 * (event.pageX + position.x);
        const y2 = 0.5 * (event.pageY + position.y);
        panEnd.set(x2, y2);
      }
      panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
      pan(panDelta.x, panDelta.y);
      panStart.copy(panEnd);
    }
    function handleTouchMoveDolly(event) {
      const position = getSecondPointerPosition(event);
      const dx = event.pageX - position.x;
      const dy = event.pageY - position.y;
      const distance11 = Math.sqrt(dx * dx + dy * dy);
      dollyEnd.set(0, distance11);
      dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
      dollyOut(dollyDelta.y);
      dollyStart.copy(dollyEnd);
    }
    function handleTouchMoveDollyPan(event) {
      if (scope.enableZoom)
        handleTouchMoveDolly(event);
      if (scope.enablePan)
        handleTouchMovePan(event);
    }
    function handleTouchMoveDollyRotate(event) {
      if (scope.enableZoom)
        handleTouchMoveDolly(event);
      if (scope.enableRotate)
        handleTouchMoveRotate(event);
    }
    function onPointerDown2(event) {
      var _a3, _b3;
      if (scope.enabled === false)
        return;
      if (pointers.length === 0) {
        (_a3 = scope.domElement) == null ? void 0 : _a3.ownerDocument.addEventListener("pointermove", onPointerMove2);
        (_b3 = scope.domElement) == null ? void 0 : _b3.ownerDocument.addEventListener("pointerup", onPointerUp2);
      }
      addPointer(event);
      if (event.pointerType === "touch") {
        onTouchStart(event);
      } else {
        onMouseDown(event);
      }
    }
    function onPointerMove2(event) {
      if (scope.enabled === false)
        return;
      if (event.pointerType === "touch") {
        onTouchMove(event);
      } else {
        onMouseMove2(event);
      }
    }
    function onPointerUp2(event) {
      var _a3, _b3, _c2;
      removePointer(event);
      if (pointers.length === 0) {
        (_a3 = scope.domElement) == null ? void 0 : _a3.releasePointerCapture(event.pointerId);
        (_b3 = scope.domElement) == null ? void 0 : _b3.ownerDocument.removeEventListener("pointermove", onPointerMove2);
        (_c2 = scope.domElement) == null ? void 0 : _c2.ownerDocument.removeEventListener("pointerup", onPointerUp2);
      }
      scope.dispatchEvent(endEvent);
      state = STATE.NONE;
    }
    function onMouseDown(event) {
      let mouseAction;
      switch (event.button) {
        case 0:
          mouseAction = scope.mouseButtons.LEFT;
          break;
        case 1:
          mouseAction = scope.mouseButtons.MIDDLE;
          break;
        case 2:
          mouseAction = scope.mouseButtons.RIGHT;
          break;
        default:
          mouseAction = -1;
      }
      switch (mouseAction) {
        case MOUSE.DOLLY:
          if (scope.enableZoom === false)
            return;
          handleMouseDownDolly(event);
          state = STATE.DOLLY;
          break;
        case MOUSE.ROTATE:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (scope.enablePan === false)
              return;
            handleMouseDownPan(event);
            state = STATE.PAN;
          } else {
            if (scope.enableRotate === false)
              return;
            handleMouseDownRotate(event);
            state = STATE.ROTATE;
          }
          break;
        case MOUSE.PAN:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (scope.enableRotate === false)
              return;
            handleMouseDownRotate(event);
            state = STATE.ROTATE;
          } else {
            if (scope.enablePan === false)
              return;
            handleMouseDownPan(event);
            state = STATE.PAN;
          }
          break;
        default:
          state = STATE.NONE;
      }
      if (state !== STATE.NONE) {
        scope.dispatchEvent(startEvent);
      }
    }
    function onMouseMove2(event) {
      if (scope.enabled === false)
        return;
      switch (state) {
        case STATE.ROTATE:
          if (scope.enableRotate === false)
            return;
          handleMouseMoveRotate(event);
          break;
        case STATE.DOLLY:
          if (scope.enableZoom === false)
            return;
          handleMouseMoveDolly(event);
          break;
        case STATE.PAN:
          if (scope.enablePan === false)
            return;
          handleMouseMovePan(event);
          break;
      }
    }
    function onMouseWheel(event) {
      if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE && state !== STATE.ROTATE) {
        return;
      }
      event.preventDefault();
      scope.dispatchEvent(startEvent);
      handleMouseWheel(event);
      scope.dispatchEvent(endEvent);
    }
    function onKeyDown(event) {
      if (scope.enabled === false || scope.enablePan === false)
        return;
      handleKeyDown(event);
    }
    function onTouchStart(event) {
      trackPointer(event);
      switch (pointers.length) {
        case 1:
          switch (scope.touches.ONE) {
            case TOUCH.ROTATE:
              if (scope.enableRotate === false)
                return;
              handleTouchStartRotate();
              state = STATE.TOUCH_ROTATE;
              break;
            case TOUCH.PAN:
              if (scope.enablePan === false)
                return;
              handleTouchStartPan();
              state = STATE.TOUCH_PAN;
              break;
            default:
              state = STATE.NONE;
          }
          break;
        case 2:
          switch (scope.touches.TWO) {
            case TOUCH.DOLLY_PAN:
              if (scope.enableZoom === false && scope.enablePan === false)
                return;
              handleTouchStartDollyPan();
              state = STATE.TOUCH_DOLLY_PAN;
              break;
            case TOUCH.DOLLY_ROTATE:
              if (scope.enableZoom === false && scope.enableRotate === false)
                return;
              handleTouchStartDollyRotate();
              state = STATE.TOUCH_DOLLY_ROTATE;
              break;
            default:
              state = STATE.NONE;
          }
          break;
        default:
          state = STATE.NONE;
      }
      if (state !== STATE.NONE) {
        scope.dispatchEvent(startEvent);
      }
    }
    function onTouchMove(event) {
      trackPointer(event);
      switch (state) {
        case STATE.TOUCH_ROTATE:
          if (scope.enableRotate === false)
            return;
          handleTouchMoveRotate(event);
          scope.update();
          break;
        case STATE.TOUCH_PAN:
          if (scope.enablePan === false)
            return;
          handleTouchMovePan(event);
          scope.update();
          break;
        case STATE.TOUCH_DOLLY_PAN:
          if (scope.enableZoom === false && scope.enablePan === false)
            return;
          handleTouchMoveDollyPan(event);
          scope.update();
          break;
        case STATE.TOUCH_DOLLY_ROTATE:
          if (scope.enableZoom === false && scope.enableRotate === false)
            return;
          handleTouchMoveDollyRotate(event);
          scope.update();
          break;
        default:
          state = STATE.NONE;
      }
    }
    function onContextMenu(event) {
      if (scope.enabled === false)
        return;
      event.preventDefault();
    }
    function addPointer(event) {
      pointers.push(event);
    }
    function removePointer(event) {
      delete pointerPositions[event.pointerId];
      for (let i2 = 0; i2 < pointers.length; i2++) {
        if (pointers[i2].pointerId == event.pointerId) {
          pointers.splice(i2, 1);
          return;
        }
      }
    }
    function trackPointer(event) {
      let position = pointerPositions[event.pointerId];
      if (position === void 0) {
        position = new Vector2$1();
        pointerPositions[event.pointerId] = position;
      }
      position.set(event.pageX, event.pageY);
    }
    function getSecondPointerPosition(event) {
      const pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];
      return pointerPositions[pointer.pointerId];
    }
    this.dollyIn = (dollyScale = getZoomScale()) => {
      dollyIn(dollyScale);
      scope.update();
    };
    this.dollyOut = (dollyScale = getZoomScale()) => {
      dollyOut(dollyScale);
      scope.update();
    };
    this.getScale = () => {
      return scale5;
    };
    this.setScale = (newScale) => {
      setScale2(newScale);
      scope.update();
    };
    this.getZoomScale = () => {
      return getZoomScale();
    };
    if (domElement !== void 0)
      this.connect(domElement);
    this.update();
  }
};
const OrbitControls = /* @__PURE__ */ React.forwardRef(({
  makeDefault,
  camera,
  regress,
  domElement,
  enableDamping = true,
  keyEvents = false,
  onChange,
  onStart,
  onEnd,
  ...restProps
}, ref) => {
  const invalidate2 = useThree((state) => state.invalidate);
  const defaultCamera = useThree((state) => state.camera);
  const gl = useThree((state) => state.gl);
  const events2 = useThree((state) => state.events);
  const setEvents = useThree((state) => state.setEvents);
  const set = useThree((state) => state.set);
  const get6 = useThree((state) => state.get);
  const performance2 = useThree((state) => state.performance);
  const explCamera = camera || defaultCamera;
  const explDomElement = domElement || events2.connected || gl.domElement;
  const controls = React.useMemo(() => new OrbitControls$1(explCamera), [explCamera]);
  useFrame(() => {
    if (controls.enabled)
      controls.update();
  }, -1);
  React.useEffect(() => {
    if (keyEvents) {
      controls.connect(keyEvents === true ? explDomElement : keyEvents);
    }
    controls.connect(explDomElement);
    return () => void controls.dispose();
  }, [keyEvents, explDomElement, regress, controls, invalidate2]);
  React.useEffect(() => {
    const callback = (e3) => {
      invalidate2();
      if (regress)
        performance2.regress();
      if (onChange)
        onChange(e3);
    };
    const onStartCb = (e3) => {
      if (onStart)
        onStart(e3);
    };
    const onEndCb = (e3) => {
      if (onEnd)
        onEnd(e3);
    };
    controls.addEventListener("change", callback);
    controls.addEventListener("start", onStartCb);
    controls.addEventListener("end", onEndCb);
    return () => {
      controls.removeEventListener("start", onStartCb);
      controls.removeEventListener("end", onEndCb);
      controls.removeEventListener("change", callback);
    };
  }, [onChange, onStart, onEnd, controls, invalidate2, setEvents]);
  React.useEffect(() => {
    if (makeDefault) {
      const old = get6().controls;
      set({
        controls
      });
      return () => set({
        controls: old
      });
    }
  }, [makeDefault, controls]);
  return /* @__PURE__ */ React.createElement("primitive", _extends({
    ref,
    object: controls,
    enableDamping
  }, restProps));
});
const ESTIMATED_FONT_FACTOR$1 = 1 / 8e-4;
function Level(props) {
  const {
    coordinates: coordinates2,
    userData,
    onLoad,
    height,
    elevation,
    color,
    edgeColor,
    highlight,
    onClick: onClickIn,
    onPointerEnter: onPointerEnterIn,
    onPointerLeave: onPointerLeaveIn,
    hoverScaleFactor,
    hoverColor,
    hoverOpacity,
    opacity,
    label,
    legendProps,
    tooltipProps,
    ...restProps
  } = props;
  const groupRef = React__default.useRef(null);
  const [geometry2, setGeometry] = React__default.useState(null);
  const [labelSelected, setLabelSelected] = React__default.useState(false);
  React__default.useEffect(() => {
    const group = groupRef.current;
    if (group) {
      group.children.forEach((obj) => {
        var _a3;
        return (_a3 = obj.geometry) == null ? void 0 : _a3.computeBoundingBox();
      });
      group.userData = userData;
      onLoad(group);
    }
  }, [onLoad, userData]);
  const onClick2 = React__default.useCallback((event) => {
    event.stopPropagation();
    const object2 = event == null ? void 0 : event.eventObject;
    onClickIn(object2);
  }, [onClickIn]);
  const OnClickLabel = React__default.useCallback((event) => {
    event.stopPropagation();
    const group = groupRef.current;
    onClickIn(group);
  }, [onClickIn]);
  const onPointerEnter = React__default.useCallback((event) => {
    event.stopPropagation();
    const object2 = event == null ? void 0 : event.eventObject;
    if (object2) {
      onPointerEnterIn(object2);
    }
  }, [onPointerEnterIn]);
  const onPointerLeave = React__default.useCallback((event) => {
    event.stopPropagation();
    const object2 = event == null ? void 0 : event.eventObject;
    if (object2) {
      onPointerLeaveIn(object2);
    }
  }, [onPointerLeaveIn]);
  React__default.useLayoutEffect(() => {
    var _a3, _b3;
    const group = groupRef.current;
    if (highlight || labelSelected) {
      const child = (_a3 = group == null ? void 0 : group.children) == null ? void 0 : _a3[0];
      if (child.material) {
        child.material.color.set(hoverColor);
        child.material.opacity = hoverOpacity;
        child.material.needsUpdate = true;
      }
    } else {
      const child = (_b3 = group == null ? void 0 : group.children) == null ? void 0 : _b3[0];
      if (child.material) {
        child.material.color.setRGB(1, 1, 1);
        child.material.opacity = opacity;
        child.material.needsUpdate = true;
      }
    }
  }, [highlight, hoverColor, hoverOpacity, labelSelected, opacity]);
  const shape2 = React__default.useMemo(() => {
    const arrayofpoints = coordinates2 == null ? void 0 : coordinates2.map((coord) => new Vector2$1(coord[0], coord[1]));
    if ((arrayofpoints == null ? void 0 : arrayofpoints.length) > 0) {
      return new Shape(arrayofpoints);
    }
    return null;
  }, [coordinates2]);
  const extrudeSettings = React__default.useMemo(() => ({
    depth: height * (highlight ? hoverScaleFactor : 1),
    bevelEnabled: false
  }), [height, highlight, hoverScaleFactor]);
  const legendStyle = React__default.useMemo(() => {
    if (!legendProps)
      return null;
    const {
      color: color2 = "#ffffff",
      selectColor = "orange",
      hoverColor: hoverColor2 = "orange"
    } = legendProps;
    return {
      width: "110px",
      // eslint-disable-next-line no-nested-ternary
      color: labelSelected ? hoverColor2 : highlight ? selectColor : color2,
      fontWeight: 500,
      left: 115,
      cursor: "pointer"
    };
  }, [highlight, labelSelected, legendProps]);
  const tooltipStyle = React__default.useMemo(() => {
    if (!tooltipProps)
      return null;
    const {
      scale: scale5 = 1,
      textAlign = "center",
      background = "rgba(140,146,164,0.3)",
      color: color2 = "#000000",
      fontWeight = 800,
      padding = "4px",
      borderRadius: borderRadius2 = "4px",
      width = "80px",
      ...restProps2
    } = tooltipProps;
    return {
      transform: `translate3d(calc(50%), calc(-50%), 0) scale(${ESTIMATED_FONT_FACTOR$1 * scale5})`,
      textAlign,
      background,
      color: color2,
      fontWeight,
      padding,
      borderRadius: borderRadius2,
      width,
      userSelect: "none",
      ...restProps2
    };
  }, [tooltipProps]);
  if (!shape2)
    return null;
  return /* @__PURE__ */ jsxs("group", { ref: groupRef, position: [0, 0, elevation], onClick: onClick2, onPointerEnter, onPointerMove: onPointerEnter, onPointerLeave, ...restProps, children: [
    /* @__PURE__ */ jsxs("mesh", { frustumCulled: false, onPointerEnter: () => setLabelSelected(true), onPointerLeave: () => setLabelSelected(false), children: [
      /* @__PURE__ */ jsx("extrudeGeometry", { args: [shape2, extrudeSettings], attach: "geometry", onUpdate: setGeometry }),
      /* @__PURE__ */ jsx("meshLambertMaterial", { attach: "material", color, transparent: true, side: DoubleSide, opacity }),
      legendProps && /* @__PURE__ */ jsx(Html, { position: [0, 0, 10], style: legendStyle, children: /* @__PURE__ */ jsxs("div", { onClick: OnClickLabel, onMouseEnter: () => setLabelSelected(true), onMouseLeave: () => setLabelSelected(false), children: [
        "L: ",
        label
      ] }) }, `${label}-text`)
    ] }),
    !!geometry2 && /* @__PURE__ */ jsxs("lineSegments", { children: [
      /* @__PURE__ */ jsx("edgesGeometry", { args: [geometry2], attach: "geometry" }),
      /* @__PURE__ */ jsx("lineBasicMaterial", { attach: "material", color: edgeColor, transparent: true, opacity })
    ] }),
    tooltipProps && (highlight || labelSelected) && label && /* @__PURE__ */ jsx(Html, { distanceFactor: 0.3, zIndexRange: [1e3, 2e3], children: /* @__PURE__ */ jsxs("div", { style: tooltipStyle, children: [
      "Level: ",
      label
    ] }) }, label)
  ] });
}
Level.propTypes = {
  coordinates: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number)),
  userData: propTypesExports$1.object,
  onLoad: propTypesExports$1.func,
  onClick: propTypesExports$1.func,
  onPointerEnter: propTypesExports$1.func,
  onPointerLeave: propTypesExports$1.func,
  height: propTypesExports$1.number,
  elevation: propTypesExports$1.number,
  color: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  edgeColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  highlight: propTypesExports$1.bool,
  hoverColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  hoverScaleFactor: propTypesExports$1.number,
  hoverOpacity: propTypesExports$1.number,
  opacity: propTypesExports$1.number,
  label: propTypesExports$1.string,
  legendProps: propTypesExports$1.shape({
    color: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
    hoverColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
    selectColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
  }),
  tooltipProps: propTypesExports$1.shape({
    color: propTypesExports$1.string,
    scale: propTypesExports$1.number,
    textAlign: propTypesExports$1.string,
    background: propTypesExports$1.string,
    fontWeight: propTypesExports$1.number,
    padding: propTypesExports$1.string,
    borderRadius: propTypesExports$1.string,
    width: propTypesExports$1.string
  })
};
Level.defaultProps = {
  coordinates: [],
  userData: {},
  onLoad: () => {
  },
  onClick: () => {
  },
  onPointerEnter: () => {
  },
  onPointerLeave: () => {
  },
  height: 0,
  elevation: 0,
  color: "white",
  edgeColor: "black",
  highlight: false,
  hoverColor: "orange",
  hoverScaleFactor: 1.1,
  hoverOpacity: 1,
  opacity: 0.5,
  label: "",
  legendProps: {},
  tooltipProps: {}
};
const GeojsonLevels = React__default.forwardRef((props, ref) => {
  const {
    data: data2,
    onLoad,
    getHeight: getHeight2,
    getElevation,
    getColor: getColor2,
    onSelect,
    isSelected,
    getLabel: getLabel4,
    getCoordinates: getCoordinatesIn,
    ...restProps
  } = props;
  const features = data2 == null ? void 0 : data2.features;
  const counterRef = React__default.useRef(0);
  const [hovered, setHovered] = React__default.useState(null);
  const center2 = React__default.useMemo(() => {
    const center22 = [0, 0];
    let numCoords = 0;
    features == null ? void 0 : features.forEach((feature2) => {
      const coords = getCoordinatesIn(feature2);
      coords == null ? void 0 : coords.forEach((c2) => {
        center22[0] += c2[0];
        center22[1] += c2[1];
        numCoords += 1;
      });
    });
    if (numCoords) {
      center22[0] /= numCoords;
      center22[1] /= numCoords;
    }
    return center22;
  }, [features, getCoordinatesIn]);
  const getCoordinates12 = React__default.useCallback((feature2) => {
    const coords = getCoordinatesIn(feature2);
    coords == null ? void 0 : coords.forEach((c2) => {
      c2[0] -= center2[0];
      c2[1] -= center2[1];
    });
    return coords;
  }, [center2, getCoordinatesIn]);
  const onLoadLevel = React__default.useCallback(() => {
    counterRef.current += 1;
    if (counterRef.current === (features == null ? void 0 : features.length)) {
      onLoad();
    } else if (counterRef.current > (features == null ? void 0 : features.length)) {
      counterRef.current = 1;
    }
  }, [features == null ? void 0 : features.length, onLoad]);
  const onPointerEnter = React__default.useCallback((index2) => {
    setHovered(index2);
  }, []);
  const onPointerLeave = React__default.useCallback((index2) => {
    if (index2 === hovered)
      setHovered(null);
  }, [hovered]);
  const onClick2 = React__default.useCallback((object2) => {
    onSelect(object2 == null ? void 0 : object2.userData);
  }, [onSelect]);
  return /* @__PURE__ */ jsx("group", { ref, children: features == null ? void 0 : features.map((feature2, index2) => /* @__PURE__ */ jsx(
    Level,
    {
      coordinates: getCoordinates12(feature2),
      height: getHeight2(feature2),
      elevation: getElevation(feature2),
      label: getLabel4(feature2),
      color: getColor2(feature2),
      onLoad: onLoadLevel,
      highlight: hovered === index2 || isSelected(feature2),
      userData: feature2,
      onPointerEnter: () => onPointerEnter(index2),
      onPointerLeave: () => onPointerLeave(index2),
      onClick: onClick2,
      ...restProps
    },
    index2
  )) });
});
GeojsonLevels.propTypes = {
  data: propTypesExports$1.object,
  onLoad: propTypesExports$1.func,
  getCoordinates: propTypesExports$1.func,
  getLevel: propTypesExports$1.func,
  getLabel: propTypesExports$1.func,
  getHeight: propTypesExports$1.func,
  getElevation: propTypesExports$1.func,
  getColor: propTypesExports$1.func,
  onSelect: propTypesExports$1.func,
  isSelected: propTypesExports$1.func
};
GeojsonLevels.defaultProps = {
  data: {},
  onLoad: () => {
  },
  getCoordinates: (feature2) => {
    var _a3, _b3;
    return (_b3 = (_a3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a3.coordinates) == null ? void 0 : _b3[0];
  },
  getLevel: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.level;
  },
  getLabel: () => "",
  getHeight: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.height;
  },
  getElevation: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.elevation;
  },
  getColor: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.color;
  },
  onSelect: () => {
  },
  isSelected: () => false
};
const ESTIMATED_FONT_FACTOR = 1 / 454973e-9;
const GltfLevel = React__default.forwardRef((props, ref) => {
  const {
    url: url2,
    onLoad,
    color,
    edgeColor,
    opacity,
    label,
    highlight,
    hoverColor,
    hoverOpacity,
    hoverScaleFactor,
    userData,
    onClick: onClickIn,
    onPointerEnter: onPointerEnterIn,
    onPointerLeave: onPointerLeaveIn,
    labelColor,
    labelHoverColor,
    offsetZ,
    ...restProps
  } = props;
  const groupRef = React__default.useRef(null);
  const [labelSelected, setLabelSelected] = React__default.useState(false);
  const [geometries, setGeometries] = React__default.useState([]);
  const config2 = React__default.useCallback((loader2) => {
    const path2 = "https://www.gstatic.com/draco/versioned/decoders/1.4.0/";
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath(path2);
    loader2.setDRACOLoader(dracoLoader);
  }, []);
  const gltf = useLoader(GLTFLoader, url2, config2);
  const object2 = gltf == null ? void 0 : gltf.scene;
  const onClick2 = React__default.useCallback((event) => {
    event.stopPropagation();
    const object22 = event == null ? void 0 : event.eventObject;
    onClickIn(object22);
  }, [onClickIn]);
  const OnClickLabel = React__default.useCallback((event) => {
    event.stopPropagation();
    const group = groupRef.current;
    onClickIn(group);
  }, [onClickIn]);
  const onPointerEnter = React__default.useCallback((event) => {
    event.stopPropagation();
    const object22 = event == null ? void 0 : event.eventObject;
    if (object22) {
      onPointerEnterIn(object22);
    }
  }, [onPointerEnterIn]);
  const onPointerLeave = React__default.useCallback((event) => {
    event.stopPropagation();
    const object22 = event == null ? void 0 : event.eventObject;
    if (object22) {
      onPointerLeaveIn(object22);
    }
  }, [onPointerLeaveIn]);
  React__default.useEffect(() => {
    if (object2) {
      const geometries2 = [];
      object2.traverse((child) => {
        var _a3;
        if (child == null ? void 0 : child.isMesh) {
          if (child.geometry) {
            const cloned = child.geometry.clone();
            cloned.applyMatrix4(child.matrixWorld);
            geometries2.push(cloned);
          }
          child.material = new MeshLambertMaterial({
            color,
            side: DoubleSide,
            transparent: true,
            opacity
          });
          (_a3 = child.geometry) == null ? void 0 : _a3.computeBoundingBox();
        }
      });
      setGeometries(geometries2);
    }
  }, [color, object2, onLoad, opacity]);
  React__default.useEffect(() => {
    const group = groupRef.current;
    if (group) {
      group.userData = userData;
    }
  }, [onLoad, userData]);
  React__default.useEffect(() => {
    const group = groupRef.current;
    if (group) {
      onLoad(group);
    }
  }, [onLoad]);
  React__default.useLayoutEffect(() => {
    var _a3;
    const group = groupRef.current;
    const object22 = (_a3 = group == null ? void 0 : group.children) == null ? void 0 : _a3[0];
    if (highlight || labelSelected) {
      object22 == null ? void 0 : object22.traverse((child) => {
        if ((child == null ? void 0 : child.isMesh) && (child == null ? void 0 : child.material)) {
          child.material.color.set(hoverColor);
          child.material.opacity = hoverOpacity;
          child.material.needsUpdate = true;
        }
      });
    } else {
      object22 == null ? void 0 : object22.traverse((child) => {
        if ((child == null ? void 0 : child.isMesh) && (child == null ? void 0 : child.material)) {
          child.material.color.setRGB(1, 1, 1);
          child.material.opacity = opacity;
          child.material.needsUpdate = true;
        }
      });
    }
  }, [highlight, hoverColor, hoverOpacity, labelSelected, opacity]);
  const labelStyle = React__default.useMemo(() => ({
    width: "110px",
    color: labelSelected ? labelHoverColor : labelColor,
    fontWeight: 500,
    left: 115,
    cursor: "pointer"
  }), [labelColor, labelHoverColor, labelSelected]);
  const quaternion2 = React__default.useMemo(() => {
    const quaternion22 = new Quaternion$1();
    quaternion22.setFromUnitVectors(new Vector3$1(0, 1, 0), new Vector3$1(0, 0, 1));
    return quaternion22;
  }, []);
  return React__default.useMemo(() => /* @__PURE__ */ jsxs("group", { ref: groupRef, position: [0, 0, offsetZ], onClick: onClick2, onPointerEnter, onPointerMove: onPointerEnter, onPointerLeave, ...restProps, children: [
    /* @__PURE__ */ jsxs("group", { quaternion: quaternion2, children: [
      /* @__PURE__ */ jsx("primitive", { ref, object: object2, frustumCulled: false, onPointerEnter: () => setLabelSelected(true), onPointerLeave: () => setLabelSelected(false), ...restProps }),
      /* @__PURE__ */ jsx(Html, { position: [0, 0, 10], style: labelStyle, children: /* @__PURE__ */ jsxs("div", { onClick: OnClickLabel, onMouseEnter: () => setLabelSelected(true), onMouseLeave: () => setLabelSelected(false), children: [
        "L: ",
        label
      ] }) }, `${label}-text`)
    ] }),
    false,
    (highlight || labelSelected) && label && /* @__PURE__ */ jsx(Html, { distanceFactor: 0.3, zIndexRange: [1e3, 2e3], children: /* @__PURE__ */ jsxs("div", { style: {
      transform: `translate3d(calc(50%), calc(-50%), 0) scale(${ESTIMATED_FONT_FACTOR})`,
      textAlign: "center",
      background: "rgba(140,146,164,0.3)",
      color: "black",
      fontWeight: 1e3,
      padding: "4px 4px",
      borderRadius: "4px",
      userSelect: "none",
      width: "100px"
    }, children: [
      "Level: ",
      label
    ] }) }, label)
  ] }), [OnClickLabel, edgeColor, geometries, highlight, label, labelSelected, labelStyle, object2, offsetZ, onClick2, onPointerEnter, onPointerLeave, opacity, quaternion2, ref, restProps]);
});
GltfLevel.propTypes = {
  url: propTypesExports$1.string.isRequired,
  userData: propTypesExports$1.object,
  onLoad: propTypesExports$1.func,
  color: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  edgeColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  opacity: propTypesExports$1.number,
  highlight: propTypesExports$1.bool,
  hoverColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  hoverScaleFactor: propTypesExports$1.number,
  hoverOpacity: propTypesExports$1.number,
  label: propTypesExports$1.string,
  labelColor: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  labelHoverColor: propTypesExports$1.string,
  onClick: propTypesExports$1.func,
  onPointerEnter: propTypesExports$1.func,
  onPointerLeave: propTypesExports$1.func,
  offsetZ: propTypesExports$1.number
};
GltfLevel.defaultProps = {
  userData: {},
  onLoad: () => {
  },
  color: "white",
  edgeColor: "#F5F5F5",
  opacity: 0.5,
  highlight: false,
  hoverColor: "orange",
  hoverScaleFactor: 1.1,
  hoverOpacity: 1,
  label: "",
  labelColor: "#00f345",
  labelHoverColor: "#ffffff",
  onClick: () => {
  },
  onPointerEnter: () => {
  },
  onPointerLeave: () => {
  },
  offsetZ: 0
};
const GltfLevels = React__default.forwardRef((props, ref) => {
  const {
    data: data2,
    onLoad,
    getHeight: getHeight2,
    getElevation,
    getColor: getColor2,
    onSelect,
    isSelected,
    getLabel: getLabel4,
    spacing,
    getCoordinates: getCoordinatesIn,
    ...restProps
  } = props;
  const counterRef = React__default.useRef(0);
  const [hovered, setHovered] = React__default.useState(null);
  const isLoadedRef = React__default.useRef(false);
  const onLoadLevel = React__default.useCallback(() => {
    counterRef.current += 1;
    if (counterRef.current === (data2 == null ? void 0 : data2.length) && !isLoadedRef.current) {
      isLoadedRef.current = true;
      onLoad();
    } else if (counterRef.current > (data2 == null ? void 0 : data2.length)) {
      counterRef.current = 1;
    }
  }, [data2 == null ? void 0 : data2.length, onLoad]);
  const onPointerEnter = React__default.useCallback((index2) => {
    setHovered(index2);
  }, []);
  const onPointerLeave = React__default.useCallback((index2) => {
    if (index2 === hovered)
      setHovered(null);
  }, [hovered]);
  const onClick2 = React__default.useCallback((object2) => {
    onSelect(object2 == null ? void 0 : object2.userData);
  }, [onSelect]);
  return /* @__PURE__ */ jsx("group", { ref, children: data2 == null ? void 0 : data2.map((obj, index2) => /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(GltfLevel, { url: obj.url, onLoad: (obj2) => onLoadLevel(obj2, index2), userData: obj, color: getColor2(obj), label: getLabel4(obj), highlight: hovered === index2 || isSelected(obj), onPointerEnter: () => onPointerEnter(index2), onPointerLeave: () => onPointerLeave(index2), onClick: onClick2, offsetZ: spacing * index2, ...restProps }, index2) }, index2)) });
});
GltfLevels.propTypes = {
  data: propTypesExports$1.object,
  onLoad: propTypesExports$1.func,
  getCoordinates: propTypesExports$1.func,
  getLevel: propTypesExports$1.func,
  getLabel: propTypesExports$1.func,
  getHeight: propTypesExports$1.func,
  getElevation: propTypesExports$1.func,
  getColor: propTypesExports$1.func,
  onSelect: propTypesExports$1.func,
  isSelected: propTypesExports$1.func,
  spacing: propTypesExports$1.number
};
GltfLevels.defaultProps = {
  data: {},
  onLoad: () => {
  },
  getCoordinates: (feature2) => {
    var _a3, _b3;
    return (_b3 = (_a3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a3.coordinates) == null ? void 0 : _b3[0];
  },
  getLevel: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.level;
  },
  getLabel: () => "",
  getHeight: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.height;
  },
  getElevation: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.elevation;
  },
  getColor: (feature2) => {
    var _a3;
    return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.color;
  },
  onSelect: () => {
  },
  isSelected: () => false,
  spacing: 7
};
function CameraControls(props) {
  const controlsRef = React__default.useRef(null);
  const {
    camera,
    scene
  } = useThree();
  const computeBounds2 = React__default.useCallback(() => {
    try {
      const box = new Box3().setFromObject(scene);
      const center2 = box.getCenter(new Vector3$1());
      const size12 = box.getSize(new Vector3$1());
      return {
        center: center2,
        size: size12,
        box
      };
    } catch (error2) {
      console.warn(error2);
    }
    return {};
  }, [scene]);
  const computeParametersFromBounds = React__default.useCallback((bounds) => {
    const {
      center: center2,
      size: size12
    } = bounds || {};
    if (!center2 || !size12)
      return null;
    const max3 = Math.max(size12.x, size12.y, size12.z);
    const {
      x: x2,
      y: y2,
      z: z2
    } = center2;
    const {
      x: sx,
      y: sy,
      z: sz
    } = {
      x: 1,
      y: -0.45,
      z: 0.35
    };
    const factor = [1, 1, 1];
    return {
      position: {
        x: max3 * sx * factor[0] + x2,
        y: max3 * sy * factor[1] + y2,
        z: max3 * sz * factor[2] + z2
      },
      target: {
        x: x2,
        y: y2,
        z: z2
      }
    };
  }, []);
  const applyParameters = React__default.useCallback((params2 = {}) => {
    const {
      position,
      target,
      up
    } = params2;
    const controls = controlsRef.current;
    if (controls && camera && position && target) {
      const max3 = Math.max(Math.abs(position.x), Math.abs(position.y), Math.abs(position.z));
      const far = 10 * max3;
      if (camera.far < far)
        camera.far = far;
      camera.position.set(position.x, position.y, position.z);
      camera.zoom = 1;
      if (up)
        camera.up.set(up.x, up.y, up.z);
      controls.target.set(target.x, target.y, target.z);
      camera.updateProjectionMatrix();
      controls.update();
    }
  }, [camera]);
  React__default.useEffect(() => {
    const bounds = computeBounds2();
    const params2 = computeParametersFromBounds(bounds);
    applyParameters(params2);
  }, [applyParameters, computeBounds2, computeParametersFromBounds]);
  return /* @__PURE__ */ jsx(OrbitControls, { ref: controlsRef, makeDefault: true, ...props });
}
CameraControls.propTypes = {
  position: propTypesExports$1.arrayOf(propTypesExports$1.number),
  target: propTypesExports$1.arrayOf(propTypesExports$1.number)
};
CameraControls.defaultProps = {
  position: null,
  target: [0, 0, 0]
};
const MERCATOR_A = 6378137;
const WORLD_SIZE = MERCATOR_A * Math.PI * 2;
const PROJECTION_WORLD_SIZE = WORLD_SIZE / (MERCATOR_A * Math.PI * 2);
const DEG2RAD = Math.PI / 180;
const EARTH_CIRCUMFERENCE = 2 * Math.PI * MERCATOR_A;
class ProjectionUtil {
  static projectedUnitsPerMeter(latitude) {
    return Math.abs(WORLD_SIZE / Math.cos(DEG2RAD * latitude) / EARTH_CIRCUMFERENCE);
  }
  static projectToWorld(coords) {
    const projected = [MERCATOR_A * DEG2RAD * coords[0] * PROJECTION_WORLD_SIZE, MERCATOR_A * Math.log(Math.tan(Math.PI * 0.25 + 0.5 * DEG2RAD * coords[1])) * PROJECTION_WORLD_SIZE];
    if (!coords[2]) {
      projected.push(0);
    } else {
      const pixelsPerMeter = ProjectionUtil.projectedUnitsPerMeter(coords[1]);
      projected.push(coords[2] * pixelsPerMeter);
    }
    return projected;
  }
  static worldToCoords(projected) {
    const [x2, y2, z2] = projected;
    const unprojected = [x2 / MERCATOR_A / DEG2RAD / PROJECTION_WORLD_SIZE, (Math.atan(Math.exp(y2 / MERCATOR_A / PROJECTION_WORLD_SIZE)) - Math.PI * 0.25) / (0.5 * DEG2RAD)];
    if (typeof z2 === "number") {
      const pixelsPerMeter = ProjectionUtil.projectedUnitsPerMeter(unprojected[1]);
      unprojected.push(z2 / pixelsPerMeter);
    }
    return unprojected;
  }
}
const style = {
  height: "100%",
  width: "100%",
  background: "transparent",
  position: "absolute"
};
const cameraProps = {
  up: [0, 0, 1],
  far: 4500,
  fov: 90,
  apsect: 1,
  position: [1, 1, 1]
};
function LevelSelector(props) {
  const {
    data: dataIn,
    type,
    defaultHeight,
    defaultSpacing,
    getLevel: getLevel2,
    ...restProps
  } = props;
  const onceRef = React__default.useRef(false);
  const [data2, setData6] = React__default.useState(null);
  const [enableControls, setEnableControls] = React__default.useState(false);
  React__default.useEffect(() => {
    if (typeof dataIn === "object") {
      setData6(dataIn);
    } else if (typeof dataIn === "string") {
      const fetchData = async () => {
        if (onceRef.current)
          return;
        onceRef.current = true;
        const response = await fetch(dataIn);
        if (response.ok) {
          const data22 = await response.json();
          setData6(data22);
        }
      };
      fetchData();
    }
  }, [dataIn]);
  const getCoordinates12 = React__default.useCallback((feature2) => {
    var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h;
    const type2 = (_a3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a3.type;
    let coords = [];
    switch (type2) {
      case "Polygon": {
        coords = (_c2 = (_b3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _b3.coordinates) == null ? void 0 : _c2[0];
        break;
      }
      case "MultiPolygon": {
        (_e2 = (_d2 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _d2.coordinates) == null ? void 0 : _e2.forEach((p2) => {
          p2 == null ? void 0 : p2.forEach((c2) => {
            if (c2)
              coords.push(...c2);
          });
        });
        break;
      }
      case "MultiLineString": {
        coords = (_g = (_f3 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _f3.coordinates) == null ? void 0 : _g[0];
        break;
      }
      case "LineString": {
        coords = (_h = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _h.coordinates;
        break;
      }
    }
    return coords == null ? void 0 : coords.map((c2) => ProjectionUtil.projectToWorld(c2));
  }, []);
  const getHeight2 = React__default.useCallback((feature2) => {
    var _a3;
    if (type === "geojson")
      return ((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.height) || defaultHeight;
    return 0;
  }, [defaultHeight, type]);
  const getElevation = React__default.useCallback((feature2) => {
    if (type === "geojson") {
      const level = getLevel2(feature2);
      const height = getHeight2(feature2);
      return (level - 1) * (height + defaultSpacing);
    }
    return 0;
  }, [defaultSpacing, getHeight2, getLevel2, type]);
  const getColor2 = React__default.useCallback((feature2) => {
    var _a3;
    if (type === "geojson")
      return (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.color;
    return feature2 == null ? void 0 : feature2.color;
  }, [type]);
  if (!data2)
    return /* @__PURE__ */ jsx(Empty, { description: "No levels data" });
  return /* @__PURE__ */ jsxs(Canvas, { style, gl: {
    alpha: true,
    antialias: true
  }, camera: cameraProps, children: [
    /* @__PURE__ */ jsx("ambientLight", {}),
    type === "geojson" && /* @__PURE__ */ jsx(GeojsonLevels, { data: data2, onLoad: () => setEnableControls(true), getColor: getColor2, getLevel: getLevel2, getElevation, getHeight: getHeight2, getCoordinates: getCoordinates12, ...restProps }),
    type === "gltf" && /* @__PURE__ */ jsx(
      GltfLevels,
      {
        data: data2,
        onLoad: () => setEnableControls(true),
        getColor: getColor2,
        getLevel: getLevel2,
        spacing: defaultSpacing * 2,
        ...restProps
      }
    ),
    enableControls && /* @__PURE__ */ jsx(CameraControls, { enablePan: false, enableRotate: true, enableZoom: true })
  ] });
}
LevelSelector.propTypes = {
  data: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.string, propTypesExports$1.array]),
  type: propTypesExports$1.oneOf(["geojson", "gltf"]),
  defaultHeight: propTypesExports$1.number,
  defaultSpacing: propTypesExports$1.number,
  onSelect: propTypesExports$1.func,
  isSelected: propTypesExports$1.func,
  getLevel: propTypesExports$1.func
};
LevelSelector.defaultProps = {
  data: "",
  type: "geojson",
  defaultHeight: 7,
  defaultSpacing: 7,
  onSelect: () => {
  },
  isSelected: () => false,
  getLevel: (feature2) => {
    var _a3, _b3, _c2;
    const name2 = (_c2 = (_b3 = (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.NAME) == null ? void 0 : _b3.toLowerCase()) == null ? void 0 : _c2.replace("floor", "");
    if (name2)
      return Number(name2);
    return 0;
  }
};
function LevelSelector3Internal(props) {
  const {
    placement,
    width,
    height,
    marginHorizontal,
    marginVertical,
    levels,
    onLevelSelect,
    activeLevelId,
    initialCollapsed,
    styles: stylesIn,
    ...restProps
  } = props;
  const onLevelClicked = React__default.useCallback((feature2) => {
    var _a3;
    if ((feature2 == null ? void 0 : feature2.type) === "Feature") {
      onLevelSelect((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.id);
    }
  }, [onLevelSelect]);
  const isLevelSelected = React__default.useCallback((feature2) => {
    var _a3;
    return ((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.id) === activeLevelId;
  }, [activeLevelId]);
  const getLevel2 = React__default.useCallback((feature2) => {
    var _a3;
    const levelNumber = (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.levelNumber;
    if (levelNumber)
      return Number(levelNumber);
    return 0;
  }, []);
  const getLabel4 = React__default.useCallback((feature2) => {
    const levelNumber = getLevel2(feature2);
    return `${levelNumber}`;
  }, [getLevel2]);
  const geojson = React__default.useMemo(() => {
    if (!(levels == null ? void 0 : levels.length))
      return null;
    return {
      type: "FeatureCollection",
      features: levels
    };
  }, [levels]);
  if (!geojson)
    return null;
  return /* @__PURE__ */ jsx(CollapsibleOverlayPanel, { title: "Levels", placement, width, height: "auto", styles: {
    body: {
      height: `${height}px`,
      ...stylesIn
    }
  }, marginHorizontal, marginVertical, initialCollapsed, children: /* @__PURE__ */ jsx(LevelSelector, { data: geojson, type: "geojson", onSelect: onLevelClicked, getLevel: getLevel2, getLabel: getLabel4, isSelected: isLevelSelected, ...restProps }) });
}
LevelSelector3Internal.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  levels: propTypesExports$1.array,
  onLevelSelect: propTypesExports$1.func,
  activeLevelId: propTypesExports$1.string,
  initialCollapsed: propTypesExports$1.bool,
  styles: propTypesExports$1.object
};
LevelSelector3Internal.defaultProps = {
  placement: "top-left",
  marginHorizontal: 16,
  marginVertical: 16,
  width: 350,
  height: 400,
  levels: [],
  onLevelSelect: () => {
  },
  activeLevelId: "",
  initialCollapsed: false,
  styles: {}
};
function LevelSelector3(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { children: /* @__PURE__ */ jsx(LevelSelector3Internal, { ...props }) });
}
const mapProps$5 = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: false
  },
  tilesetUrl: MapTilesConstants.None.tilesetUrl,
  reuseMaps: false
};
const dropdownOptions$2 = [{
  label: "Fit Screen",
  key: "fitBounds"
}, {
  label: "Fit Height",
  key: "fitHeight"
}, {
  label: "Fit Width",
  key: "fitWidth"
}];
const {
  Option: Option$3
} = Select$1;
function StepScaleImageContent() {
  var _a3;
  const {
    allFormValues,
    croppedAssetData: asset,
    onScaleChange: onChange,
    helpButtonActive: showHelp,
    center: center2
  } = useImportDataContext();
  const imageUrl = (_a3 = asset == null ? void 0 : asset.sourceFile) == null ? void 0 : _a3.data;
  const {
    scaleType,
    horizontalLength,
    verticalLength,
    displayMeasurementUnit
  } = (allFormValues == null ? void 0 : allFormValues.scale) || {};
  const [unscaledBox, setUnscaledBox] = React__default.useState(null);
  const [bounds, setBounds] = React__default.useState({});
  const [fitOption, setFitOption] = React__default.useState("fitBounds");
  const [horizontalPoints, setHorizontalPoints] = React__default.useState(null);
  const [verticalPoints, setVerticalPoints] = React__default.useState(null);
  const {
    getDisplayLength
  } = useInputLength();
  const computeImageBox = React__default.useCallback(async () => {
    if (!imageUrl)
      return null;
    const box = await ImageUtil$1.computeImageBox(imageUrl, center2);
    return box;
  }, [center2, imageUrl]);
  React__default.useLayoutEffect(() => {
    if (!unscaledBox) {
      computeImageBox().then((box) => {
        if (!box)
          return;
        const distance11 = GeoUtil.distance(box[0], box[1]);
        const verticalEndPoint = GeoUtil.destination(box[0], distance11, 180);
        if (!verticalEndPoint)
          return;
        setHorizontalPoints({
          startPoint: [...box[0]],
          endPoint: [...box[1]],
          midPoint: GeoUtil.midpoint(box[0], box[1]),
          id: "draggable-line-horizontal",
          constraint: "lat"
        });
        setVerticalPoints({
          startPoint: [...box[0]],
          endPoint: verticalEndPoint,
          midPoint: GeoUtil.midpoint(box[0], verticalEndPoint),
          id: "draggable-line-vertical",
          constraint: "lng"
        });
        setUnscaledBox(box);
        onChange({
          box
        });
      });
    }
  }, [computeImageBox, onChange, unscaledBox]);
  const updateBox = React__default.useCallback(() => {
    if (!horizontalPoints || !verticalPoints || !horizontalLength || !verticalLength || !unscaledBox) {
      return;
    }
    const initHLength = GeoUtil.distance(unscaledBox[0], unscaledBox[1]);
    const initVLength = GeoUtil.distance(unscaledBox[3], unscaledBox[0]);
    const hpDist = GeoUtil.distance(horizontalPoints.startPoint, horizontalPoints.endPoint);
    const vpDist = GeoUtil.distance(verticalPoints.startPoint, verticalPoints.endPoint);
    const horizontalLengthInM = horizontalLength * initHLength / hpDist;
    const newVerticalLength = scaleType === "different" ? verticalLength : horizontalLength;
    const verticalLengthInM = newVerticalLength * initVLength / vpDist;
    const box = ImageUtil$1.computeScaledBox(center2, [horizontalLengthInM, verticalLengthInM]);
    onChange({
      box
    });
  }, [center2, horizontalLength, horizontalPoints, onChange, scaleType, verticalLength, verticalPoints, unscaledBox]);
  React__default.useEffect(() => {
    updateBox();
  }, [updateBox]);
  const value = React__default.useMemo(() => ({
    lines: [horizontalPoints, verticalPoints]
  }), [horizontalPoints, verticalPoints]);
  const onDraggableLineChange = React__default.useCallback((lines) => {
    lines == null ? void 0 : lines.forEach((line) => {
      switch (line.id) {
        case "draggable-line-horizontal":
          setHorizontalPoints(line);
          break;
        case "draggable-line-vertical":
          setVerticalPoints(line);
          break;
      }
    });
  }, []);
  React__default.useLayoutEffect(() => {
    if (!unscaledBox)
      return;
    const [west, south, east, north] = GeoUtil.computeRectangle(unscaledBox) || [];
    setBounds({
      west,
      south,
      east,
      north
    });
  }, [unscaledBox]);
  const sourceId = "step-scale-content-image";
  const layerId = `${sourceId}-layer`;
  const textCollection = React__default.useMemo(() => {
    if (!horizontalPoints || !verticalPoints)
      return null;
    return {
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [...horizontalPoints.midPoint]
        },
        properties: {
          "text-value": horizontalLength && displayMeasurementUnit ? `${getDisplayLength(horizontalLength, displayMeasurementUnit)} ${displayMeasurementUnit}` : null,
          "text-anchor": "bottom"
        }
      }, {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [...verticalPoints.midPoint]
        },
        properties: {
          "text-value": verticalLength && displayMeasurementUnit ? `${getDisplayLength(verticalLength, displayMeasurementUnit)} ${displayMeasurementUnit}` : null,
          "text-anchor": "right"
        }
      }]
    };
  }, [horizontalPoints, verticalPoints, horizontalLength, verticalLength, displayMeasurementUnit, getDisplayLength]);
  if (!imageUrl || !unscaledBox || !horizontalPoints || !verticalPoints)
    return null;
  return /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    height: "100%"
  }, children: [
    /* @__PURE__ */ jsx("div", { style: {
      paddingTop: "20px",
      marginLeft: "40px",
      marginBottom: "20px"
    }, children: /* @__PURE__ */ jsx(Select$1, { style: {
      width: 150
    }, defaultValue: "fitBounds", onChange: setFitOption, children: dropdownOptions$2.map((option) => /* @__PURE__ */ jsx(Option$3, { value: option.key, children: option.label }, option.key)) }) }),
    /* @__PURE__ */ jsx("div", { style: {
      height: "calc(100% - 72px)",
      width: "100%"
    }, children: /* @__PURE__ */ jsxs(LazyMap, { center: center2, ...mapProps$5, id: "scale-pane", children: [
      /* @__PURE__ */ jsx(MapResizer, { containerId: "scale-pane" }),
      /* @__PURE__ */ jsx(MapFitBounds, { ...bounds, fitOption }),
      /* @__PURE__ */ jsx(
        ImageLayer2,
        {
          sourceId,
          id: layerId,
          url: imageUrl,
          box: unscaledBox,
          opacity: 1
        }
      ),
      /* @__PURE__ */ jsx(DraggableLines, { onChange: onDraggableLineChange, value, same: scaleType === "same" || !scaleType }, scaleType),
      /* @__PURE__ */ jsx(GeojsonPointLayer, { id: "text-scale-image", data: textCollection, textValuePropName: "text-value", textColorPropName: "text-color", textAnchorPropName: "text-anchor", showText: true, showIcon: false }),
      showHelp && /* @__PURE__ */ jsx(StepScaleHelp, {})
    ] }) })
  ] });
}
function StepScaleSider(props) {
  const {
    disabled
  } = props;
  const [form] = Form.useForm();
  const {
    allFormValues,
    updateFormValues
  } = useImportDataContext();
  const valuesIn = React__default.useMemo(() => (allFormValues == null ? void 0 : allFormValues.scale) || {}, [allFormValues == null ? void 0 : allFormValues.scale]);
  const {
    getDisplayLength,
    getMeterLength
  } = useInputLength();
  const onChange = React__default.useCallback((data2) => updateFormValues("scale", data2), [updateFormValues]);
  const formValues = React__default.useMemo(() => {
    if (!valuesIn)
      return null;
    const formData = {
      ...valuesIn,
      horizontalDisplayLength: getDisplayLength(valuesIn == null ? void 0 : valuesIn.horizontalLength, valuesIn == null ? void 0 : valuesIn.displayMeasurementUnit),
      verticalDisplayLength: getDisplayLength(valuesIn == null ? void 0 : valuesIn.verticalLength, valuesIn == null ? void 0 : valuesIn.displayMeasurementUnit)
    };
    return formData;
  }, [getDisplayLength, valuesIn]);
  React__default.useLayoutEffect(() => {
    if (formValues && Object.keys(formValues).length) {
      form.setFieldsValue(formValues);
    }
  }, [form, formValues]);
  const onFormValuesChange = React__default.useCallback((changedData, allData) => {
    if (allData) {
      const data2 = {
        ...allData,
        horizontalLength: Object.keys(changedData).includes("horizontalDisplayLength") ? getMeterLength(changedData.horizontalDisplayLength, allData.displayMeasurementUnit) : formValues == null ? void 0 : formValues.horizontalLength,
        verticalLength: Object.keys(changedData).includes("verticalDisplayLength") ? getMeterLength(changedData.verticalDisplayLength, allData.displayMeasurementUnit) : formValues == null ? void 0 : formValues.verticalLength
      };
      delete data2.horizontalDisplayLength;
      delete data2.verticalDisplayLength;
      if (data2.scaleType === "same") {
        data2.verticalLength = data2.horizontalLength;
      }
      onChange(data2);
    }
  }, [formValues == null ? void 0 : formValues.horizontalLength, formValues == null ? void 0 : formValues.verticalLength, getMeterLength, onChange]);
  const onReset = React__default.useCallback(() => {
    if (disabled)
      return;
    onChange({
      scaleType: "different",
      horizontalLength: null,
      verticalLength: null,
      displayMeasurementUnit: "m"
    });
  }, [disabled, onChange]);
  return /* @__PURE__ */ jsxs(Form, { form, autoComplete: "off", layout: "vertical", style: {
    width: "100%",
    paddingLeft: "24px",
    paddingRight: "24px",
    borderRadius: 0,
    backdropFilter: "blur(5px)",
    labelAlign: "left"
  }, onValuesChange: onFormValuesChange, disabled, children: [
    /* @__PURE__ */ jsxs("div", { style: {
      height: "56px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: 400
      }, children: "Scale Configuration" }),
      /* @__PURE__ */ jsx(Tooltip$1, { title: "Configure the scale of the ruler. You can set the length of the ruler and the unit of measurement.", children: /* @__PURE__ */ jsx(QuestionCircleOutlined, { style: {
        fontSize: "15px"
      } }) })
    ] }),
    /* @__PURE__ */ jsx(Divider, { style: {
      margin: "0px -24px 16px -24px",
      width: "calc(100% + 48px)"
    } }),
    /* @__PURE__ */ jsx(Form.Item, { name: "scaleType", initialValue: "different", getValueFromEvent: (e3) => {
      var _a3;
      return (_a3 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a3.value;
    }, children: /* @__PURE__ */ jsx(Radio.Group, { children: /* @__PURE__ */ jsxs(Space, { direction: "vertical", size: "large", children: [
      /* @__PURE__ */ jsx(Radio, { value: "same", children: /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: "12px",
        lineHeight: "22px",
        fontWeight: 300
      }, children: "Same horizontal & vertical" }) }),
      /* @__PURE__ */ jsx(Radio, { value: "different", children: /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: "12px",
        lineHeight: "22px",
        fontWeight: 300
      }, children: "Different horizontal & vertical" }) })
    ] }) }) }),
    formValues.scaleType === "same" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Form.Item, { name: "displayMeasurementUnit", label: "Measurement Unit", initialValue: formValues.displayMeasurementUnit || "m", children: /* @__PURE__ */ jsx(UnitSelect, {}) }),
      /* @__PURE__ */ jsx(Form.Item, { name: "horizontalDisplayLength", label: "Ruler's Length", initialValue: formValues.horizontalDisplayLength, children: /* @__PURE__ */ jsx(InputNumber$1, { placeholder: "Enter length", size: "large", style: {
        width: "100%"
      }, min: 0 }) }),
      /* @__PURE__ */ jsx(Form.Item, { name: "rulerReset", children: /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, onClick: () => onReset(), children: "Reset Ruler Position" }) })
    ] }),
    formValues.scaleType === "different" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Divider, { style: {
        margin: "10px 0",
        width: "344px"
      } }),
      /* @__PURE__ */ jsx(Form.Item, { name: "displayMeasurementUnit", label: "Measurement Unit", initialValue: formValues.displayMeasurementUnit || "m", children: /* @__PURE__ */ jsx(UnitSelect, {}) }),
      /* @__PURE__ */ jsx(Form.Item, { name: "horizontalDisplayLength", label: "Horizontal Length", initialValue: formValues.horizontalDisplayLength, children: /* @__PURE__ */ jsx(InputNumber$1, { size: "large", style: {
        width: "100%"
      }, placeholder: "Enter Number", min: 0 }) }),
      /* @__PURE__ */ jsx(Form.Item, { name: "verticalDisplayLength", label: "Vertical Length", initialValue: formValues.verticalDisplayLength, children: /* @__PURE__ */ jsx(InputNumber$1, { size: "large", style: {
        width: "100%"
      }, placeholder: "Enter Number", min: 0 }) }),
      /* @__PURE__ */ jsx(Form.Item, { name: "rulerReset", children: /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, onClick: () => onReset(), children: "Reset Ruler Position" }) })
    ] })
  ] });
}
StepScaleSider.propTypes = {
  disabled: propTypesExports$1.bool
};
StepScaleSider.defaultProps = {
  disabled: false
};
const {
  Text: Text$c
} = Typography;
const {
  useToken: useToken$m
} = theme$2;
function ProgressBar(props) {
  const {
    onLoad
  } = props;
  const {
    token
  } = useToken$m();
  const [progress, setProgress] = React__default.useState(0);
  React__default.useLayoutEffect(() => {
    onLoad(true);
    const timer = setInterval(() => {
      setProgress((prevProgress) => prevProgress + 1);
    }, 40);
    return () => {
      onLoad(false);
      clearInterval(timer);
    };
  }, [onLoad]);
  return /* @__PURE__ */ jsx(Row, { justify: "center", align: "middle", style: {
    height: "100%",
    backgroundColor: token.colorFillAlter,
    padding: "9px",
    borderRadius: "8px",
    marginBottom: "5px"
  }, children: /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(Space, { direction: "vertical", align: "center", children: [
    /* @__PURE__ */ jsx(Progress, { type: "circle", showInfo: false, percent: progress % 100, strokeColor: token.colorPrimary, size: 80 }),
    /* @__PURE__ */ jsx(Text$c, { type: "secondary", style: {
      fontSize: "14px"
    }, children: "Processing the data" }),
    /* @__PURE__ */ jsx(Text$c, { className: "process-building-subtext", style: {
      color: token.colorTextTertiary,
      textAlign: "center"
    }, children: "This may take a few minutes..." })
  ] }) }) });
}
ProgressBar.propTypes = {
  onLoad: propTypesExports$1.func
};
ProgressBar.defaultProps = {
  onLoad: () => {
  }
};
function StepImportFile() {
  const {
    center: center2,
    uploadFileData: onLoad = () => {
    },
    renderProgressBar: progressBar
  } = useImportDataContext();
  const supportedFileFormats = useConfigStore((state) => state.supportedFileFormats);
  const [isPreparing, setIsPreparing] = React__default.useState(false);
  const onFileLoad = React__default.useCallback(async (data2) => {
    setIsPreparing(true);
    const result = await FileParserUtil.parseFile(data2, {
      extractSite: false,
      center: center2
    });
    if (!result)
      message$1.error("File parsing failed");
    setIsPreparing(false);
    onLoad(result);
  }, [center2, onLoad]);
  if (isPreparing && progressBar)
    return progressBar();
  return /* @__PURE__ */ jsx(UploadBox, { onLoad: onFileLoad, extensions: supportedFileFormats, progressBar });
}
const {
  useToken: useToken$l
} = theme$2;
function PageThumbnails(props) {
  const {
    thumbnails,
    onChange,
    activePageIndex
  } = props;
  const {
    token
  } = useToken$l();
  return /* @__PURE__ */ jsx(Space, { style: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxHeight: "calc(100vh - 262px)",
    overflowY: "scroll"
  }, direction: "vertical", children: thumbnails.map((url2, index2) => /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    alignItems: "center"
  }, children: [
    /* @__PURE__ */ jsx(Image$1, { src: url2, alt: `Thumbnail ${index2}`, style: {
      maxWidth: "154px",
      height: "auto",
      cursor: "pointer",
      border: activePageIndex === index2 ? `2px solid ${token.colorPrimary}` : null,
      boxShadow: activePageIndex === index2 ? `${token.colorPrimary} 0px 0px 2px 2px` : null
    }, onClick: () => onChange(index2), preview: false }),
    /* @__PURE__ */ jsx("p", { style: {
      fontSize: "12px",
      textAlign: "center",
      marginTop: "0px"
    }, children: `Page ${index2 + 1}` })
  ] }, index2)) });
}
PageThumbnails.propTypes = {
  thumbnails: propTypesExports$1.arrayOf(propTypesExports$1.string),
  onChange: propTypesExports$1.func,
  activePageIndex: propTypesExports$1.number
};
PageThumbnails.defaultProps = {
  thumbnails: [],
  onChange: () => {
  },
  activePageIndex: 0
};
const {
  useToken: useToken$k
} = theme$2;
function StepCropSider() {
  var _a3;
  const {
    allFormValues,
    fileData: asset,
    updateFormValues
  } = useImportDataContext();
  const {
    token
  } = useToken$k();
  const [showHelp, setShowHelp] = React__default.useState(true);
  const activePageIndex = ((_a3 = allFormValues == null ? void 0 : allFormValues.crop) == null ? void 0 : _a3.pageIndex) || 0;
  const onChangeIn = React__default.useCallback((data2) => updateFormValues("crop", data2), [updateFormValues]);
  const thumbnails = React__default.useMemo(() => {
    if ((asset == null ? void 0 : asset.type) === "IMAGE") {
      if (asset.thumbnail)
        return [asset.thumbnail];
    }
    if ((asset == null ? void 0 : asset.type) === "PDF") {
      return asset.thumbnails;
    }
    return [];
  }, [asset]);
  const onChange = React__default.useCallback((index2) => {
    onChangeIn({
      pageIndex: index2
    });
  }, [onChangeIn]);
  if (!(thumbnails == null ? void 0 : thumbnails.length))
    return null;
  return /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    paddingLeft: "24px",
    borderRadius: 0,
    backdropFilter: "blur(5px)",
    labelAlign: "left"
  }, children: [
    /* @__PURE__ */ jsxs(Space, { direction: "horizontal", style: {
      paddingRight: "24px",
      display: "flex",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { children: "Choose a page to add as a floor plan." }),
      /* @__PURE__ */ jsx(ConfigProvider, { theme: {
        components: {
          Select: {
            colorText: token.colorTextDescription
          }
        }
      }, children: /* @__PURE__ */ jsx(Select$1, { value: activePageIndex, onChange, style: {
        width: "86px"
      }, children: thumbnails == null ? void 0 : thumbnails.map((_2, index2) => /* @__PURE__ */ jsx(Select$1.Option, { value: index2, children: `${index2 + 1} / ${thumbnails.length}` }, index2)) }) })
    ] }),
    /* @__PURE__ */ jsx(Divider, { style: {
      margin: `16px 0px ${!showHelp ? 16 : 0}px -24px`,
      width: "calc(100% + 24px)"
    } }),
    showHelp && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Row, { style: {
        height: "40px",
        margin: "0px 0px 0px -24px",
        backgroundColor: token.colorBgContainer,
        padding: "0px 24px"
      }, justify: "space-between", align: "middle", children: [
        /* @__PURE__ */ jsx(Typography.Text, { children: "Crop the plan before placing on the map." }),
        /* @__PURE__ */ jsx(Button, { type: "text", size: "small", icon: /* @__PURE__ */ jsx(CloseOutlined, {}), onClick: () => setShowHelp(false) })
      ] }),
      /* @__PURE__ */ jsx(Divider, { style: {
        margin: "0px 0px 16px -24px",
        width: "calc(100% + 24px)"
      } })
    ] }),
    /* @__PURE__ */ jsx(PageThumbnails, { thumbnails, onChange, activePageIndex })
  ] });
}
const stepCropContent_module = {};
const {
  useToken: useToken$j
} = theme$2;
function StepCropContent() {
  const {
    token
  } = useToken$j();
  const {
    allFormValues,
    fileData: asset,
    onCropChange: onChange
  } = useImportDataContext();
  const image = React__default.useMemo(() => {
    var _a3;
    const {
      pageIndex = 0
    } = (allFormValues == null ? void 0 : allFormValues.crop) || {};
    if ((asset == null ? void 0 : asset.type) === "IMAGE") {
      return asset.thumbnail;
    }
    if ((asset == null ? void 0 : asset.type) === "PDF") {
      return (_a3 = asset.thumbnails) == null ? void 0 : _a3[pageIndex];
    }
    return null;
  }, [allFormValues == null ? void 0 : allFormValues.crop, asset]);
  if (!image)
    return null;
  return /* @__PURE__ */ jsx("div", { style: {
    width: "100%",
    height: "100%",
    backgroundColor: token.colorBgLayout
  }, children: /* @__PURE__ */ jsx(Cropper, { src: image, style: {
    width: "100%",
    height: "100%"
  }, onCrop: onChange }) });
}
function MapFitToBox(props) {
  const {
    box,
    containerId
  } = props;
  const [bounds, setBounds] = React__default.useState({});
  React__default.useLayoutEffect(() => {
    if (!box)
      return;
    const [west, south, east, north] = GeoUtil.computeRectangle(box) || [];
    setBounds({
      west,
      south,
      east,
      north
    });
  }, [box]);
  if (!box)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(MapResizer, { containerId }),
    /* @__PURE__ */ jsx(MapFitBounds, { ...bounds })
  ] });
}
MapFitToBox.propTypes = {
  containerId: propTypesExports$1.string,
  box: propTypesExports$1.arrayOf(propTypesExports$1.arrayOf(propTypesExports$1.number))
};
MapFitToBox.defaultProps = {
  containerId: "",
  box: null
};
const DraggableLinesContext = React__default.createContext();
function DualDraggableLinesProvider(props) {
  const {
    geojson,
    onChange,
    box,
    children
  } = props;
  const [leftPoints, setLeftPoints] = React__default.useState(null);
  const [rightPoints, setRightPoints] = React__default.useState(null);
  React__default.useLayoutEffect(() => {
    if (box == null ? void 0 : box.length) {
      setLeftPoints({
        startPoint: [...box[0]],
        endPoint: [...box[1]],
        midPoint: [(box[0][0] + box[1][0]) * 0.5, (box[0][1] + box[1][1]) * 0.5],
        id: "draggable-line-left"
      });
      setRightPoints({
        startPoint: [...box[0]],
        endPoint: [...box[1]],
        midPoint: [(box[0][0] + box[1][0]) * 0.5, (box[0][1] + box[1][1]) * 0.5],
        id: "draggable-line-right"
      });
    }
  }, [box]);
  const geojsonRef = useValueRef(geojson);
  const updateCallback = React__default.useCallback(() => {
    const geojson2 = geojsonRef.current;
    if (!leftPoints || !rightPoints || !(geojson2 == null ? void 0 : geojson2.features))
      return null;
    const updateGeojson = GeoUtil.performPlacing(geojson2, leftPoints, rightPoints);
    const azimuthAngle = GeoUtil.getAngleBetweenRefLines(leftPoints, rightPoints, false);
    if (updateGeojson) {
      return {
        geojson: updateGeojson,
        azimuth: azimuthAngle
      };
    }
    return null;
  }, [geojsonRef, leftPoints, rightPoints]);
  const onChangeMut = useMutableFunc(onChange);
  React__default.useLayoutEffect(() => {
    onChangeMut(() => updateCallback());
  }, [leftPoints, rightPoints, onChangeMut, updateCallback]);
  const value = React__default.useMemo(() => ({
    leftPoints,
    rightPoints,
    setLeftPoints,
    setRightPoints
  }), [leftPoints, rightPoints, setLeftPoints, setRightPoints]);
  return /* @__PURE__ */ jsx(DraggableLinesContext.Provider, { value, children });
}
DualDraggableLinesProvider.propTypes = {
  geojson: propTypesExports$1.object,
  onChange: propTypesExports$1.func,
  box: propTypesExports$1.array,
  children: propTypesExports$1.node
};
DualDraggableLinesProvider.defaultProps = {
  geojson: null,
  onChange: () => {
  },
  box: null,
  children: null
};
function DraggableLinesLeft() {
  const {
    setLeftPoints,
    leftPoints
  } = React__default.useContext(DraggableLinesContext);
  return /* @__PURE__ */ jsx(DraggableLines, { onChange: (lines) => setLeftPoints(lines == null ? void 0 : lines[0]), value: {
    lines: leftPoints ? [leftPoints] : []
  } });
}
function DraggableLinesRight() {
  const {
    setRightPoints,
    rightPoints
  } = React__default.useContext(DraggableLinesContext);
  return /* @__PURE__ */ jsx(DraggableLines, { onChange: (lines) => setRightPoints(lines == null ? void 0 : lines[0]), value: {
    lines: rightPoints ? [rightPoints] : []
  } });
}
const mapProps$4 = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: false
  },
  reuseMaps: false
};
const {
  useToken: useToken$i
} = theme$2;
function StepPlaceImageContent() {
  var _a3;
  const {
    token
  } = useToken$i();
  const {
    scaledData,
    center: center2,
    onPlaceChange,
    tilesetUrl,
    croppedAssetData: asset
  } = useImportDataContext();
  const box = scaledData == null ? void 0 : scaledData.box;
  const imageUrl = (_a3 = asset == null ? void 0 : asset.sourceFile) == null ? void 0 : _a3.data;
  const sourceId = "step-place-content-image";
  const layerId = `${sourceId}-layer`;
  const onDraggableLinesChange = React__default.useCallback((callback) => {
    const updateCallback = () => {
      const {
        geojson: geojson2,
        azimuth
      } = (callback == null ? void 0 : callback()) || {};
      if (geojson2) {
        const finalCoords = geojson2.features.map((f2) => f2.geometry.coordinates);
        return {
          box: finalCoords,
          azimuth
        };
      }
      return null;
    };
    onPlaceChange(() => updateCallback());
  }, [onPlaceChange]);
  const geojson = React__default.useMemo(() => {
    if (!box)
      return null;
    const geojson2 = {
      type: "FeatureCollection",
      features: box == null ? void 0 : box.map((coord) => ({
        type: "Feature",
        geometry: {
          coordinates: [...coord],
          type: "Point"
        },
        properties: {}
      }))
    };
    return geojson2;
  }, [box]);
  if (!imageUrl || !box)
    return null;
  return /* @__PURE__ */ jsx(DualDraggableLinesProvider, { geojson, onChange: onDraggableLinesChange, box, children: /* @__PURE__ */ jsxs(SplitPane, { style: {
    position: "relative"
  }, children: [
    /* @__PURE__ */ jsxs("div", { style: {
      width: "100%",
      height: "100%",
      backgroundColor: token.colorBgLayout
    }, children: [
      /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
        marginTop: "20px",
        marginLeft: "40px",
        marginBottom: "20px",
        height: "64px"
      }, children: [
        /* @__PURE__ */ jsx(Typography.Text, { strong: true, style: {
          fontSize: "18px"
        }, children: "Align and Geo-Reference your image." }),
        /* @__PURE__ */ jsx(Typography.Text, { children: "Place two ruler on the image, mark in on the map." })
      ] }),
      /* @__PURE__ */ jsx("div", { style: {
        width: "100%",
        height: "calc(100% - 104px)"
      }, children: /* @__PURE__ */ jsxs(LazyMap, { center: center2, ...mapProps$4, tilesetUrl: MapTilesConstants.None.tilesetUrl, id: "split-left", children: [
        /* @__PURE__ */ jsx(MapFitToBox, { containerId: "split-left", box }),
        /* @__PURE__ */ jsx(ImageLayer2, { sourceId, id: layerId, url: imageUrl, box, opacity: 1 }),
        /* @__PURE__ */ jsx(DraggableLinesLeft, {})
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs(LazyMap, { center: center2, ...mapProps$4, tilesetUrl: tilesetUrl === "custom" ? null : tilesetUrl || MapTilesConstants.Streets.tilesetUrl, id: "split-right", children: [
      /* @__PURE__ */ jsx(MapFitToBox, { containerId: "split-right", box }),
      /* @__PURE__ */ jsx(DraggableLinesRight, {})
    ] })
  ] }) });
}
const {
  useToken: useToken$h
} = theme$2;
const mapProps$3 = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: false
  },
  tilesetUrl: MapTilesConstants.None.tilesetUrl,
  reuseMaps: false
};
const dropdownOptions$1 = [{
  label: "Fit Screen",
  key: "fitBounds"
}, {
  label: "Fit Height",
  key: "fitHeight"
}, {
  label: "Fit Width",
  key: "fitWidth"
}];
const {
  Option: Option$2
} = Select$1;
function StepScaleCadContent() {
  var _a3;
  const {
    token
  } = useToken$h();
  const {
    allFormValues,
    assignData: unscaledGeojson,
    onScaleChange: onChange,
    helpButtonActive: showHelp,
    center: centerIn
  } = useImportDataContext();
  const {
    scaleType,
    horizontalLength,
    verticalLength,
    displayMeasurementUnit
  } = (allFormValues == null ? void 0 : allFormValues.scale) || {};
  const [unscaledBox, setUnscaledBox] = React__default.useState(null);
  const [horizontalPoints, setHorizontalPoints] = React__default.useState(null);
  const [verticalPoints, setVerticalPoints] = React__default.useState(null);
  const [bounds, setBounds] = React__default.useState({});
  const [fitOption, setFitOption] = React__default.useState("fitBounds");
  const {
    getDisplayLength
  } = useInputLength();
  const performScaling = React__default.useCallback((geojson, scale5 = [1, 1]) => {
    try {
      const scaledGeojson = GeoUtil.performScaling(geojson, scale5, centerIn);
      if (!scaledGeojson)
        return null;
      const bbox2 = GeoUtil.getBoundingBox(scaledGeojson);
      const [minX2, minY2, maxX2, maxY2] = bbox2;
      const box = [[minX2, maxY2], [maxX2, maxY2], [maxX2, minY2], [minX2, minY2]];
      return {
        box,
        geojson: scaledGeojson
      };
    } catch (error2) {
      console.error(error2);
    }
    return null;
  }, [centerIn]);
  React__default.useLayoutEffect(() => {
    var _a4;
    if (!unscaledBox && ((_a4 = unscaledGeojson == null ? void 0 : unscaledGeojson.features) == null ? void 0 : _a4.length)) {
      const bbox2 = GeoUtil.getBoundingBox(unscaledGeojson);
      if (!bbox2)
        return;
      const [minX2, minY2, maxX2, maxY2] = bbox2;
      const box = [[minX2, maxY2], [maxX2, maxY2], [maxX2, minY2], [minX2, minY2]];
      const distance11 = GeoUtil.distance(box[0], box[1]);
      const verticalEndPoint = GeoUtil.destination(box[0], distance11, 180);
      if (!verticalEndPoint)
        return;
      setHorizontalPoints({
        startPoint: [...box[0]],
        endPoint: [...box[1]],
        midPoint: GeoUtil.midpoint(box[0], box[1]),
        id: "draggable-line-horizontal",
        constraint: "lat"
      });
      setVerticalPoints({
        startPoint: [...box[0]],
        endPoint: verticalEndPoint,
        midPoint: GeoUtil.midpoint(box[0], verticalEndPoint),
        id: "draggable-line-vertical",
        constraint: "lng"
      });
      setUnscaledBox(box);
      const lazy = () => ({
        box,
        // initial box
        geojson: unscaledGeojson
        // initial geojson
      });
      onChange(() => lazy());
    }
  }, [unscaledBox, unscaledGeojson, onChange]);
  const updateGeojson = React__default.useCallback(() => {
    var _a4;
    if (!horizontalPoints || !verticalPoints || !horizontalLength || !verticalLength || !unscaledBox || !((_a4 = unscaledGeojson == null ? void 0 : unscaledGeojson.features) == null ? void 0 : _a4.length)) {
      return null;
    }
    const hpDist = GeoUtil.distance(horizontalPoints.startPoint, horizontalPoints.endPoint);
    const vpDist = GeoUtil.distance(verticalPoints.startPoint, verticalPoints.endPoint);
    const hScale = horizontalLength / hpDist;
    const vScale = scaleType === "different" ? verticalLength / vpDist : hScale;
    const scale5 = [hScale, vScale];
    const result = performScaling(unscaledGeojson, scale5);
    return result;
  }, [
    unscaledBox,
    //
    performScaling,
    unscaledGeojson,
    //
    horizontalLength,
    horizontalPoints,
    scaleType,
    verticalLength,
    verticalPoints
  ]);
  React__default.useEffect(() => {
    onChange(() => updateGeojson());
  }, [onChange, updateGeojson]);
  const value = React__default.useMemo(() => ({
    lines: [horizontalPoints, verticalPoints]
  }), [horizontalPoints, verticalPoints]);
  const onDraggableLineChange = React__default.useCallback((lines) => {
    lines == null ? void 0 : lines.forEach((line) => {
      switch (line.id) {
        case "draggable-line-horizontal":
          setHorizontalPoints(line);
          break;
        case "draggable-line-vertical":
          setVerticalPoints(line);
          break;
      }
    });
  }, []);
  React__default.useLayoutEffect(() => {
    if (!unscaledBox)
      return;
    const [west, south, east, north] = GeoUtil.computeRectangle(unscaledBox) || [];
    setBounds({
      west,
      south,
      east,
      north
    });
  }, [unscaledBox]);
  const textCollection = React__default.useMemo(() => {
    if (!horizontalPoints || !verticalPoints)
      return null;
    return {
      type: "FeatureCollection",
      features: [{
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [...horizontalPoints.midPoint]
        },
        properties: {
          "text-value": horizontalLength && displayMeasurementUnit ? `${getDisplayLength(horizontalLength, displayMeasurementUnit)} ${displayMeasurementUnit}` : null,
          "text-anchor": "bottom"
        }
      }, {
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [...verticalPoints.midPoint]
        },
        properties: {
          "text-value": verticalLength && displayMeasurementUnit ? `${getDisplayLength(verticalLength, displayMeasurementUnit)} ${displayMeasurementUnit}` : null,
          "text-anchor": "right"
        }
      }]
    };
  }, [horizontalPoints, verticalPoints, horizontalLength, verticalLength, displayMeasurementUnit, getDisplayLength]);
  if (!unscaledBox || !horizontalPoints || !verticalPoints)
    return null;
  return /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    height: "100%",
    backgroundColor: token.colorBgContainer
  }, children: [
    /* @__PURE__ */ jsx("div", { style: {
      paddingTop: "20px",
      marginLeft: "40px",
      marginBottom: "20px"
    }, children: /* @__PURE__ */ jsx(Select$1, { style: {
      width: 150
    }, defaultValue: "fitBounds", onChange: setFitOption, children: dropdownOptions$1.map((option) => /* @__PURE__ */ jsx(Option$2, { value: option.key, children: option.label }, option.key)) }) }),
    /* @__PURE__ */ jsx("div", { style: {
      height: "calc(100% - 72px)",
      width: "100%"
    }, children: /* @__PURE__ */ jsxs(LazyMap, { center: centerIn, ...mapProps$3, id: "scale-pane", children: [
      /* @__PURE__ */ jsx(MapResizer, { containerId: "scale-pane" }),
      /* @__PURE__ */ jsx(MapFitBounds, { ...bounds, fitOption }),
      ((_a3 = unscaledGeojson == null ? void 0 : unscaledGeojson.features) == null ? void 0 : _a3.length) && /* @__PURE__ */ jsx(FeaturesView, { drawMode: "noselect", features: unscaledGeojson == null ? void 0 : unscaledGeojson.features, displayMode: "2d" }),
      /* @__PURE__ */ jsx(DraggableLines, { onChange: onDraggableLineChange, value, same: scaleType === "same" || !scaleType }, scaleType),
      /* @__PURE__ */ jsx(GeojsonPointLayer, { id: "text-scale-cad", data: textCollection, textValuePropName: "text-value", textColorPropName: "text-color", textAnchorPropName: "text-anchor", showText: true, showIcon: false }),
      showHelp && /* @__PURE__ */ jsx(StepScaleHelp, {})
    ] }) })
  ] });
}
const useMapConfigStore = create$6((set) => ({
  config: {},
  setConfig: (config2) => {
    set(() => ({
      config: config2 || {}
    }));
  }
}));
function MapConfigProvider(props) {
  const {
    children,
    env,
    ...configProps
  } = props;
  const setConfig = useMapConfigStore((state) => state.setConfig);
  React__default.useLayoutEffect(() => {
    setConfig(configProps);
  }, [configProps, setConfig]);
  return /* @__PURE__ */ jsx(ConfigProvider, { ...configProps, children: /* @__PURE__ */ jsx(LazyMap.Provider, { env, children }) });
}
MapConfigProvider.propTypes = {
  theme: propTypesExports$1.object,
  children: propTypesExports$1.node,
  env: propTypesExports$1.object
};
MapConfigProvider.defaultProps = {
  theme: void 0,
  children: null,
  env: {}
};
const {
  useToken: useToken$g
} = theme$2;
const ID = "cad-content-features";
const mapProps$2 = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: false
  },
  tilesetUrl: MapTilesConstants.None.tilesetUrl,
  reuseMaps: false
};
const dropdownOptions = [{
  label: "Fit Screen",
  key: "fitBounds"
}, {
  label: "Fit Height",
  key: "fitHeight"
}, {
  label: "Fit Width",
  key: "fitWidth"
}];
const {
  Option: Option$1
} = Select$1;
function StepCadContent() {
  var _a3;
  const {
    token
  } = useToken$g();
  const {
    allFormValues,
    assignData: unscaledGeojson,
    onAssignChange,
    onPlaceChange: onChange,
    helpButtonActive: showHelp,
    center: centerIn,
    tilesetUrl,
    fileData: data2,
    materials
  } = useImportDataContext();
  const selectedLayers = React__default.useMemo(() => (allFormValues == null ? void 0 : allFormValues.cleanup) || [], [allFormValues == null ? void 0 : allFormValues.cleanup]);
  const features = React__default.useMemo(() => (data2 == null ? void 0 : data2.features) || [], [data2 == null ? void 0 : data2.features]);
  const [selectedFeatures, setSelectedFeatures] = React__default.useState(null);
  const layer2MaterialIdMap = React__default.useMemo(() => (allFormValues == null ? void 0 : allFormValues.assign) || {}, [allFormValues == null ? void 0 : allFormValues.assign]);
  React__default.useLayoutEffect(() => {
    const layer2MaterialMap = {};
    if (layer2MaterialIdMap) {
      Object.keys(layer2MaterialIdMap).forEach((layerName) => {
        const materialId2 = layer2MaterialIdMap[layerName];
        if (materialId2) {
          const material = materials.find((m2) => m2.id === materialId2);
          if (material) {
            layer2MaterialMap[layerName] = {
              materialId: materialId2,
              fill: material.color,
              stroke: material.color,
              "fill-opacity": material.opacity > 1 ? material.opacity / 100 : material.opacity,
              // TODO opacity should be in decimal in material store - FIX IT
              "stroke-opacity": material.opacity > 1 ? material.opacity / 100 : material.opacity
              // TODO opacity should be in decimal in material store - FIX IT
            };
          }
        }
      });
    }
    const selectedFeatures2 = [];
    const layerNames = selectedLayers == null ? void 0 : selectedLayers.map((l2) => l2.name);
    features == null ? void 0 : features.forEach((f2) => {
      const layerName = f2.properties.layer;
      if (layerNames == null ? void 0 : layerNames.includes(f2.properties.layer)) {
        const material = layer2MaterialMap[layerName];
        if (material) {
          f2.properties = {
            ...f2.properties,
            ...material
          };
        }
        selectedFeatures2.push(f2);
      }
    });
    setSelectedFeatures(selectedFeatures2);
    onAssignChange({
      type: "FeatureCollection",
      features: selectedFeatures2
    });
  }, [features, layer2MaterialIdMap, materials, onAssignChange, onChange, selectedLayers]);
  const config2 = useMapConfigStore((state) => state.config);
  const [unscaledBox, setUnscaledBox] = React__default.useState(null);
  const [bounds, setBounds] = React__default.useState({});
  const [fitOption, setFitOption] = React__default.useState("fitBounds");
  React__default.useLayoutEffect(() => {
    var _a4;
    if ((_a4 = unscaledGeojson == null ? void 0 : unscaledGeojson.features) == null ? void 0 : _a4.length) {
      const bbox2 = GeoUtil.getBoundingBox(unscaledGeojson);
      if (!bbox2)
        return;
      const [minX2, minY2, maxX2, maxY2] = bbox2;
      const box = [[minX2, maxY2], [maxX2, maxY2], [maxX2, minY2], [minX2, minY2]];
      setUnscaledBox(box);
      const lazy = () => ({
        box,
        // initial box
        geojson: unscaledGeojson
        // initial geojson
      });
      onChange(() => lazy());
    }
  }, [unscaledGeojson, onChange]);
  const onCadChange = React__default.useCallback((data22) => {
    const {
      sources: sources2,
      box,
      azimuth
    } = data22 || {};
    if (!sources2 || !box || !box[0])
      return;
    const features2 = [];
    Object.keys(sources2).forEach((key) => {
      pushArray(features2, sources2[key]);
    });
    if (!features2.length)
      return;
    const geojson = {
      type: "FeatureCollection",
      features: features2
    };
    onChange(() => ({
      geojson,
      box,
      azimuth
    }));
  }, [onChange]);
  React__default.useLayoutEffect(() => {
    if (unscaledBox) {
      const [west, south, east, north] = GeoUtil.computeRectangle(unscaledBox) || [];
      setBounds({
        west,
        south,
        east,
        north
      });
    } else if (selectedFeatures == null ? void 0 : selectedFeatures.length) {
      const bbox2 = GeoUtil.getBoundingBox({
        type: "FeatureCollection",
        features: selectedFeatures
      });
      if (!bbox2)
        return {};
      const [west, south, east, north] = bbox2;
      setBounds({
        west,
        south,
        east,
        north
      });
    }
    return () => {
    };
  }, [selectedFeatures, unscaledBox]);
  const containerId = "place-cad-pane";
  return /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    height: "100%",
    backgroundColor: token.colorBgContainer
  }, children: [
    /* @__PURE__ */ jsx("div", { style: {
      paddingTop: "20px",
      marginLeft: "40px",
      marginBottom: "20px"
    }, children: /* @__PURE__ */ jsx(Select$1, { style: {
      width: 150
    }, defaultValue: "fitBounds", onChange: setFitOption, children: dropdownOptions.map((option) => /* @__PURE__ */ jsx(Option$1, { value: option.key, children: option.label }, option.key)) }) }),
    /* @__PURE__ */ jsx("div", { style: {
      height: "calc(100% - 72px)",
      width: "100%"
    }, children: /* @__PURE__ */ jsxs(LazyMap, { center: centerIn, ...mapProps$2, id: containerId, tilesetUrl: tilesetUrl === "custom" ? null : tilesetUrl || MapTilesConstants.Streets.tilesetUrl, children: [
      /* @__PURE__ */ jsx(MapResizer, { containerId }),
      /* @__PURE__ */ jsx(MapFitBounds, { ...bounds, fitOption }),
      ((_a3 = unscaledGeojson == null ? void 0 : unscaledGeojson.features) == null ? void 0 : _a3.length) && /* @__PURE__ */ jsx(FeaturesView, { id: ID, drawMode: "noselect", features: (unscaledGeojson == null ? void 0 : unscaledGeojson.features) || selectedFeatures, displayMode: "2d" }),
      unscaledBox && /* @__PURE__ */ jsx(BoxEditableLayer, { id: "cad-box-editable", box: unscaledBox, editableSourceId: [`${ID}-2d-fill-source`, `${ID}-2d-line-source`, `${ID}-2d-point-source`, `${ID}-2d-extrusion-source`], onChange: onCadChange, containerId, config: config2, enableMenu: true }),
      showHelp && /* @__PURE__ */ jsx(StepScaleHelp, {})
    ] }) })
  ] });
}
const mapProps$1 = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: false
  },
  reuseMaps: false
};
const {
  useToken: useToken$f
} = theme$2;
function StepPlaceCadContent() {
  var _a3;
  const {
    token
  } = useToken$f();
  const {
    scaledData,
    center: center2,
    onPlaceChange,
    tilesetUrl
  } = useImportDataContext();
  const box = scaledData == null ? void 0 : scaledData.box;
  const geojson = scaledData == null ? void 0 : scaledData.geojson;
  if (!box)
    return null;
  return /* @__PURE__ */ jsx(DualDraggableLinesProvider, { geojson, onChange: onPlaceChange, box, children: /* @__PURE__ */ jsxs(SplitPane, { style: {
    position: "relative"
  }, children: [
    /* @__PURE__ */ jsxs("div", { style: {
      width: "100%",
      height: "100%",
      backgroundColor: token.colorBgLayout
    }, children: [
      /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
        marginTop: "20px",
        marginLeft: "40px",
        marginBottom: "20px",
        height: "64px"
      }, children: [
        /* @__PURE__ */ jsx(Typography.Text, { strong: true, style: {
          fontSize: "20px",
          lineHeight: "32px",
          fontWeight: 500
        }, children: "Align and Geo-Reference your image." }),
        /* @__PURE__ */ jsx(Typography.Text, { style: {
          fontWeight: 300,
          fontSize: "14px",
          lineHeight: "22.4px",
          color: token.colorTextSecondary
        }, children: "Place two ruler on the image, mark in on the map." })
      ] }),
      /* @__PURE__ */ jsx("div", { style: {
        width: "100%",
        height: "calc(100% - 104px)"
      }, children: /* @__PURE__ */ jsxs(LazyMap, { center: center2, ...mapProps$1, tilesetUrl: MapTilesConstants.None.tilesetUrl, id: "split-left", children: [
        /* @__PURE__ */ jsx(MapFitToBox, { containerId: "split-left", box }),
        ((_a3 = geojson == null ? void 0 : geojson.features) == null ? void 0 : _a3.length) && /* @__PURE__ */ jsx(FeaturesView, { drawMode: "noselect", features: geojson == null ? void 0 : geojson.features, displayMode: "2d" }),
        /* @__PURE__ */ jsx(DraggableLinesLeft, {})
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs(LazyMap, { center: center2, ...mapProps$1, tilesetUrl: tilesetUrl === "custom" ? null : tilesetUrl || MapTilesConstants.Streets.tilesetUrl, id: "split-right", children: [
      /* @__PURE__ */ jsx(MapFitToBox, { containerId: "split-right", box }),
      /* @__PURE__ */ jsx(DraggableLinesRight, {})
    ] })
  ] }) });
}
function PiCube(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 256 256", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "d": "M223.68,66.15,135.68,18h0a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32h0l80.34,44L128,120,47.66,76ZM40,90l80,43.78v85.79L40,175.82Zm96,129.57V133.82L216,90v85.78Z" } }] })(props);
}
const {
  Text: Text$b
} = Typography;
const {
  useToken: useToken$e
} = theme$2;
function FailedImport() {
  const {
    token
  } = useToken$e();
  return /* @__PURE__ */ jsx(Row, { justify: "center", align: "middle", style: {
    height: "100%",
    backgroundColor: token.colorBgContainer,
    padding: "20px"
  }, children: /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsxs(Space, { direction: "vertical", align: "center", children: [
    /* @__PURE__ */ jsx(PiCube, { style: {
      width: "80px",
      height: "85px"
    } }),
    /* @__PURE__ */ jsx(Text$b, { style: {
      color: token.colorWarningText,
      fontWeight: "500",
      fontSize: "18px",
      textAlign: "center"
    }, children: "Oops, something went wrong." }),
    /* @__PURE__ */ jsx(Text$b, { className: "process-building-subtext", style: {
      color: token.colorWarningText,
      textAlign: "center"
    }, children: "Please try again importing other data." })
  ] }) }) });
}
const {
  useToken: useToken$d
} = theme$2;
const mapProps = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: false
  },
  tilesetUrl: MapTilesConstants.None.tilesetUrl,
  reuseMaps: false
};
function StepImageContent() {
  const {
    token
  } = useToken$d();
  const config2 = useMapConfigStore((state) => state.config);
  const imageSourceId = "image-source";
  const layerId = "sample";
  const {
    tilesetUrl,
    allFormValues,
    fileData,
    onCropChange,
    onPlaceChange,
    helpButtonActive: showHelp,
    center: centerIn
  } = useImportDataContext();
  const [bounds, setBounds] = React__default.useState();
  const imageUrl = React__default.useMemo(() => {
    var _a3;
    const {
      pageIndex = 0
    } = (allFormValues == null ? void 0 : allFormValues.crop) || {};
    if ((fileData == null ? void 0 : fileData.type) === "IMAGE") {
      return fileData.thumbnail;
    }
    if ((fileData == null ? void 0 : fileData.type) === "PDF") {
      return (_a3 = fileData.thumbnails) == null ? void 0 : _a3[pageIndex];
    }
    return null;
  }, [allFormValues == null ? void 0 : allFormValues.crop, fileData]);
  const onImageChange = React__default.useCallback((data2) => {
    const {
      box,
      azimuth,
      opacity,
      imageUrl: imageUrl2
    } = data2 || {};
    if (!box || !box[0])
      return;
    if (!bounds) {
      const [west, south, east, north] = GeoUtil.computeRectangle(box) || [];
      setBounds({
        west,
        south,
        east,
        north
      });
    }
    onCropChange(imageUrl2);
    onPlaceChange(() => ({
      box,
      azimuth,
      opacity
    }));
  }, [bounds, onCropChange, onPlaceChange]);
  const containerId = "place-image-pane";
  return /* @__PURE__ */ jsx("div", { style: {
    width: "100%",
    height: "100%",
    backgroundColor: token.colorBgContainer
  }, children: /* @__PURE__ */ jsx("div", { style: {
    height: "100%",
    width: "100%"
  }, children: /* @__PURE__ */ jsxs(LazyMap, { center: centerIn, ...mapProps, id: containerId, tilesetUrl: tilesetUrl === "custom" ? null : tilesetUrl || MapTilesConstants.Streets.tilesetUrl, children: [
    /* @__PURE__ */ jsx(MapResizer, { containerId }),
    bounds && /* @__PURE__ */ jsx(MapFitBounds, { ...bounds }),
    /* @__PURE__ */ jsx(
      ImageLayer,
      {
        sourceId: imageSourceId,
        id: layerId,
        center: centerIn,
        url: imageUrl,
        opacity: 1,
        containerId,
        onChange: onImageChange,
        config: config2,
        enableMenu: true
      }
    ),
    showHelp && /* @__PURE__ */ jsx(StepScaleHelp, {})
  ] }) }) });
}
const {
  useToken: useToken$c
} = theme$2;
function StepImageSider() {
  var _a3;
  const {
    allFormValues,
    fileData: asset,
    updateFormValues
  } = useImportDataContext();
  const {
    token
  } = useToken$c();
  const [showHelp, setShowHelp] = React__default.useState(true);
  const activePageIndex = ((_a3 = allFormValues == null ? void 0 : allFormValues.crop) == null ? void 0 : _a3.pageIndex) || 0;
  const onChangeIn = React__default.useCallback((data2) => updateFormValues("crop", data2), [updateFormValues]);
  const thumbnails = React__default.useMemo(() => {
    if ((asset == null ? void 0 : asset.type) === "IMAGE") {
      if (asset.thumbnail)
        return [asset.thumbnail];
    }
    if ((asset == null ? void 0 : asset.type) === "PDF") {
      return asset.thumbnails;
    }
    return [];
  }, [asset]);
  const onChange = React__default.useCallback((index2) => {
    onChangeIn({
      pageIndex: index2
    });
  }, [onChangeIn]);
  if (!(thumbnails == null ? void 0 : thumbnails.length))
    return null;
  return /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    paddingLeft: "24px",
    borderRadius: 0,
    backdropFilter: "blur(5px)",
    labelAlign: "left"
  }, children: [
    /* @__PURE__ */ jsxs(Space, { direction: "horizontal", style: {
      paddingRight: "24px",
      display: "flex",
      justifyContent: "space-between"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { children: "Choose a page to add as a floor plan." }),
      /* @__PURE__ */ jsx(ConfigProvider, { theme: {
        components: {
          Select: {
            colorText: token.colorTextDescription
          }
        }
      }, children: /* @__PURE__ */ jsx(Select$1, { value: activePageIndex, onChange, style: {
        width: "86px"
      }, children: thumbnails == null ? void 0 : thumbnails.map((_2, index2) => /* @__PURE__ */ jsx(Select$1.Option, { value: index2, children: `${index2 + 1} / ${thumbnails.length}` }, index2)) }) })
    ] }),
    /* @__PURE__ */ jsx(Divider, { style: {
      margin: `16px 0px ${!showHelp ? 16 : 0}px -24px`,
      width: "calc(100% + 24px)"
    } }),
    showHelp && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs(Row, { style: {
        height: "40px",
        margin: "0px 0px 0px -24px",
        backgroundColor: token.colorBgContainer,
        padding: "0px 24px"
      }, justify: "space-between", align: "middle", children: [
        /* @__PURE__ */ jsx(Typography.Text, { children: "Crop and scale the plan before placing on the map." }),
        /* @__PURE__ */ jsx(Button, { type: "text", size: "small", icon: /* @__PURE__ */ jsx(CloseOutlined, {}), onClick: () => setShowHelp(false) })
      ] }),
      /* @__PURE__ */ jsx(Divider, { style: {
        margin: "0px 0px 16px -24px",
        width: "calc(100% + 24px)"
      } })
    ] }),
    /* @__PURE__ */ jsx(PageThumbnails, { thumbnails, onChange, activePageIndex })
  ] });
}
const list_select_options = "_list_select_options_10mbr_1";
const styles$5 = {
  list_select_options
};
const {
  Option
} = Select$1;
function StepCadAssignSider(props) {
  const {
    disabled
  } = props;
  const {
    allFormValues,
    fileData,
    materials,
    updateFormValues
  } = useImportDataContext();
  const [form] = Form.useForm();
  const layers = React__default.useMemo(() => (allFormValues == null ? void 0 : allFormValues.cleanup) || [], [allFormValues == null ? void 0 : allFormValues.cleanup]);
  const layer2MaterialMap = allFormValues == null ? void 0 : allFormValues.assign;
  const allLayers = React__default.useMemo(() => (fileData == null ? void 0 : fileData.layers) || [], [fileData == null ? void 0 : fileData.layers]);
  const onChange = React__default.useCallback((data2) => updateFormValues("cleanup", data2), [updateFormValues]);
  const isSelectedLayer = React__default.useCallback((layerName) => !!layers.find((l2) => l2.name === layerName), [layers]);
  const handleLayerChange = React__default.useCallback((layerName) => {
    const updatedSelection = layers.filter((l2) => l2.name !== layerName);
    if (updatedSelection.length !== layers.length) {
      onChange(updatedSelection);
      return;
    }
    onChange([...layers, ...allLayers.filter((l2) => l2.name === layerName)]);
  }, [allLayers, onChange, layers]);
  const handleSelectAll = React__default.useCallback((e3) => {
    form.setFieldsValue({
      layers: e3.target.checked ? allLayers.map((layer) => layer.name) : []
    });
    onChange(e3.target.checked ? allLayers : []);
  }, [allLayers, form, onChange]);
  const onMaterialChange = React__default.useCallback((data2) => updateFormValues("assign", data2), [updateFormValues]);
  const materialOption = React__default.useCallback((option) => /* @__PURE__ */ jsxs("div", { style: {
    display: "flex",
    justifyContent: "space-between"
  }, children: [
    /* @__PURE__ */ jsx("span", { style: {
      flex: 1
    }, children: option.name }),
    /* @__PURE__ */ jsx("span", { style: {
      textAlign: "right"
    }, children: `/${option.attenuation}${option.attenuationUnit}` })
  ] }), []);
  const colorAndText = React__default.useCallback((color, text, prefix = null) => /* @__PURE__ */ jsxs("div", { style: {
    display: "flex",
    alignItems: "center"
  }, children: [
    prefix,
    /* @__PURE__ */ jsx("div", { style: {
      width: "10px",
      height: "10px",
      backgroundColor: color,
      borderRadius: "50%",
      marginRight: "8px",
      marginLeft: "8px"
    } }),
    /* @__PURE__ */ jsx(Tooltip$1, { title: text, children: /* @__PURE__ */ jsx(Typography.Text, { style: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: "120px"
    }, children: text }) })
  ] }), []);
  const getMaterialObject = React__default.useCallback((key) => {
    const materialObject = materials.find((m2) => m2.name === key);
    if (!materialObject)
      return null;
    return materialObject;
  }, [materials]);
  const onAssignMaterial = React__default.useCallback((layerIn, material) => {
    const matKey = material.key || material.value;
    const matObject = getMaterialObject(matKey);
    if (!matObject)
      return;
    const finalData = {
      ...layer2MaterialMap || {},
      [layerIn.name]: matObject.id
    };
    onMaterialChange(finalData);
  }, [getMaterialObject, layer2MaterialMap, onMaterialChange]);
  return /* @__PURE__ */ jsxs(Form, { form, autoComplete: "off", layout: "vertical", style: {
    width: "100%",
    paddingLeft: "24px",
    borderRadius: 0,
    backdropFilter: "blur(5px)",
    labelAlign: "left"
  }, initialValues: {
    layers
  }, children: [
    /* @__PURE__ */ jsx("div", { style: {
      height: "56px",
      display: "flex",
      alignItems: "center"
    }, children: /* @__PURE__ */ jsx(Typography.Text, { style: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 400
    }, children: "CAD Files" }) }),
    /* @__PURE__ */ jsx(Divider, { style: {
      margin: "0px 0px 16px -24px",
      width: "calc(100% + 24px)"
    } }),
    /* @__PURE__ */ jsx(Checkbox, { style: {
      marginBottom: "8px",
      fontSize: "14px"
    }, onChange: handleSelectAll, checked: (allLayers == null ? void 0 : allLayers.length) === (layers == null ? void 0 : layers.length), children: "All Layers" }),
    /* @__PURE__ */ jsx(List$3, { dataSource: allLayers, className: styles$5.list_select_options, style: {
      maxHeight: "calc(100vh - 212px)",
      overflowY: "auto"
    }, renderItem: (layer) => /* @__PURE__ */ jsxs(List$3.Item, { style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      border: "none",
      fontSize: "6px",
      overflowY: "auto",
      paddingRight: "12px"
    }, children: [
      colorAndText(layer.stroke || layer.fill, layer.name, /* @__PURE__ */ jsx(Checkbox, { checked: isSelectedLayer(layer.name), onChange: () => handleLayerChange(layer.name) })),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Button, { type: "text", icon: /* @__PURE__ */ jsx(RightCircleFilled, {}), style: {
          opacity: 0.3
        } }),
        /* @__PURE__ */ jsx(Select$1, { placeholder: "Select Material", labelInValue: true, optionLabelProp: "label", dropdownStyle: {
          width: "200px",
          boxShadow: "none"
        }, style: {
          width: "116px"
        }, onChange: (material) => onAssignMaterial(layer, material), popupClassName: styles$5.list_select_dropdown, disabled, children: materials.map((item) => /* @__PURE__ */ jsx(Option, { value: item.name, label: colorAndText(item.color, item.name), children: materialOption(item) }, item.name)) })
      ] })
    ] }) })
  ] });
}
StepCadAssignSider.propTypes = {
  disabled: propTypesExports$1.bool
};
StepCadAssignSider.defaultProps = {
  disabled: false
};
const {
  Header,
  Footer,
  Sider,
  Content
} = Layout;
const SIDER_WIDTH = 372;
const headerStyle = {
  width: `${SIDER_WIDTH}px`,
  height: "84px",
  paddingInline: 0,
  padding: 0
};
const footerStyle = {
  paddingInline: 0,
  width: `${SIDER_WIDTH}px`,
  height: "64px",
  padding: 0
};
const ALL_IMPORT_STEPS = [{
  key: "upload",
  title: "Import Data",
  sider: null,
  header: false,
  footer: false,
  content: null,
  showClose: true
}, {
  key: "failed",
  title: "Import Failed",
  sider: null,
  header: false,
  footer: false,
  content: /* @__PURE__ */ jsx(FailedImport, {})
}, {
  key: "crop",
  title: "Edit",
  sider: null,
  header: true,
  footer: true,
  // backText: 'Back',
  nextText: "Crop",
  content: null,
  extensions: [
    // ...useConfigStore.getState().supportedImageFileFormats,
    // 'pdf'
  ]
  // disabled workflow
}, {
  key: "scale",
  hasHelp: true,
  title: "Scale",
  sider: null,
  header: true,
  footer: true,
  backText: "Back",
  nextText: "Scale",
  content: null,
  extensions: [
    // ...useConfigStore.getState().supportedCadFileFormats,
    // ...useConfigStore.getState().supportedImageFileFormats,
    // 'pdf',
  ]
}, {
  key: "place",
  title: "Place",
  sider: null,
  header: true,
  footer: true,
  content: null,
  backText: "Back",
  nextText: "Place",
  extensions: [
    // ...useConfigStore.getState().supportedCadFileFormats,
    // ...useConfigStore.getState().supportedImageFileFormats,
    // 'pdf',
  ]
}, {
  key: "georeference",
  hasHelp: true,
  title: "GeoReference",
  sider: null,
  header: true,
  footer: true,
  backText: "",
  nextText: "Save",
  content: null,
  extensions: [...useConfigStore.getState().supportedCadFileFormats, ...useConfigStore.getState().supportedImageFileFormats, "pdf"]
}];
function ImportData(props) {
  var _a3, _b3;
  const {
    onDone: onDoneIn,
    extensions,
    title: subTitle,
    center: center2,
    materials,
    tilesetUrl,
    ...restProps
  } = props;
  const [activeStepIndex, setActiveStepIndex] = React__default.useState(0);
  const [activeStep, setActiveStep] = React__default.useState({});
  const [steps, setSteps] = React__default.useState([]);
  const [fileData, setFileData] = useState(null);
  const [croppedAssetData, setCroppedAssetData] = useState(null);
  const [assignData, setAssignData] = React__default.useState(null);
  const scalingFuncRef = React__default.useRef(null);
  const [scaledData, setScaledData] = useState(null);
  const placingFuncRef = React__default.useRef(null);
  const [finalData, setFinalData] = React__default.useState(null);
  const [disableFooterActions, setDisableFooterActions] = React__default.useState(false);
  const [allFormValues, setAllFormValues] = React__default.useState({
    scale: {
      scaleType: "different",
      // change default to 'different'
      horizontalLength: null,
      verticalLength: null,
      displayMeasurementUnit: "m"
    }
  });
  const [helpButtonActive, setHelpButtonActive] = useState(false);
  const extension = (_a3 = fileData == null ? void 0 : fileData.sourceFile) == null ? void 0 : _a3.extension;
  React__default.useLayoutEffect(() => {
    setActiveStep(steps[activeStepIndex] || {});
  }, [activeStepIndex, steps]);
  const onDone = React__default.useCallback((saveOrCancel, finalDataIn) => {
    debounce$3(() => {
      if (saveOrCancel && (finalDataIn || finalData)) {
        onDoneIn(finalDataIn || finalData);
      } else {
        onDoneIn(null);
      }
    }, 100)();
  }, [finalData, onDoneIn]);
  const onPlaceDataChange = React__default.useCallback((data2) => {
    let finalData2 = null;
    if (croppedAssetData && (data2 == null ? void 0 : data2.box)) {
      const assets = [{
        ...croppedAssetData,
        box: data2.box,
        opacity: (data2 == null ? void 0 : data2.opacity) || 1
      }];
      finalData2 = {
        assets,
        azimuth: data2 == null ? void 0 : data2.azimuth
      };
    } else if (data2 == null ? void 0 : data2.geojson) {
      finalData2 = {
        features: data2.geojson.features,
        azimuth: data2 == null ? void 0 : data2.azimuth
      };
    }
    if (finalData2)
      setFinalData(finalData2);
    return finalData2;
  }, [croppedAssetData]);
  const befNext = useCallback(() => {
    var _a4, _b4;
    let finalData2 = null;
    if ((activeStep == null ? void 0 : activeStep.key) === "scale") {
      const result = (_a4 = scalingFuncRef.current) == null ? void 0 : _a4.call(scalingFuncRef);
      if (result)
        setScaledData(result);
    } else if (["place", "georeference"].includes(activeStep == null ? void 0 : activeStep.key)) {
      const result = (_b4 = placingFuncRef.current) == null ? void 0 : _b4.call(placingFuncRef);
      if (result)
        finalData2 = onPlaceDataChange(result);
    }
    return finalData2;
  }, [activeStep == null ? void 0 : activeStep.key, onPlaceDataChange]);
  const beforeOnNext = useMutableFunc(befNext);
  const onNext = useCallback(() => {
    debounce$3(() => {
      const finalData2 = beforeOnNext();
      setActiveStepIndex((current) => {
        if (steps.length > current + 1)
          return current + 1;
        onDone(true, finalData2);
        return current;
      });
    }, 100)();
  }, [onDone, steps.length, beforeOnNext]);
  const onBack = useCallback(() => {
    debounce$3(() => {
      setActiveStepIndex((current) => {
        if (current - 1 > -1)
          return current - 1;
        return current;
      });
    }, 100)();
  }, []);
  const updateFormValues = useCallback((key, values4) => {
    setAllFormValues((previous) => ({
      ...previous,
      [key]: values4
    }));
  }, []);
  const uploadFileData = useCallback((data2) => {
    var _a4, _b4, _c2, _d2;
    setFileData(data2 || {
      error: true
    });
    if (data2.type === "STORE") {
      const extension2 = (_a4 = data2 == null ? void 0 : data2.sourceFile) == null ? void 0 : _a4.extension;
      if (["tiff", "tif"].includes(extension2)) {
        if ((_c2 = (_b4 = data2 == null ? void 0 : data2.assetStore) == null ? void 0 : _b4.assets) == null ? void 0 : _c2.length) {
          const georefAssets = [];
          const otherAssets = [];
          data2.assetStore.assets.forEach((asset) => {
            if (asset.box) {
              georefAssets.push(asset);
            } else {
              otherAssets.push(asset);
            }
          });
          if (georefAssets.length) {
            setFinalData({
              features: data2 == null ? void 0 : data2.features,
              assets: georefAssets,
              azimuth: 0
            });
          } else if (otherAssets.length) {
            setFileData(otherAssets[0]);
          } else {
            setFileData({
              error: true,
              message: "All GeoTIFF are not geo-referenced"
            });
          }
        }
      } else if (["geojson", "json", "kml", "kmz", "shp", "csv"].includes(extension2)) {
        setFinalData({
          features: data2 == null ? void 0 : data2.features,
          assets: (_d2 = data2 == null ? void 0 : data2.assetStore) == null ? void 0 : _d2.assets,
          azimuth: 0
        });
      } else if (["dxf", "dwg"].includes(extension2)) {
        updateFormValues("cleanup", (data2 == null ? void 0 : data2.layers) || []);
      }
    }
  }, [updateFormValues]);
  const onCropChange = React__default.useCallback((url2) => {
    const assetData = {
      id: generateUid(),
      type: "IMAGE",
      displayMode: "2d",
      sourceFile: {
        dataType: "dataUrl",
        data: url2
      },
      visible: true,
      thumbnail: url2
    };
    setCroppedAssetData(assetData);
  }, []);
  const onAssignChange = React__default.useCallback((geojson) => {
    setAssignData(geojson);
  }, []);
  const onScaleChange = React__default.useCallback((dataOrCallback) => {
    if (typeof dataOrCallback === "function") {
      scalingFuncRef.current = dataOrCallback;
    } else {
      setScaledData(dataOrCallback);
    }
  }, []);
  const onPlaceChange = React__default.useCallback((dataOrCallback) => {
    if (typeof dataOrCallback === "function") {
      placingFuncRef.current = dataOrCallback;
    } else {
      onPlaceDataChange(dataOrCallback);
    }
  }, [onPlaceDataChange]);
  const handleHelpButtonClick = useCallback((isActive) => {
    setHelpButtonActive(isActive);
  }, []);
  const resetAll = React__default.useCallback(() => {
    setActiveStepIndex(0);
    setActiveStep({});
    setFileData(null);
    setCroppedAssetData(null);
    scalingFuncRef.current = null;
    setScaledData(null);
    placingFuncRef.current = null;
    setFinalData(null);
    setHelpButtonActive(false);
  }, []);
  const {
    nextDisabled,
    backDisabled
  } = React__default.useMemo(() => {
    const isFirst = activeStepIndex === 0;
    const disableNextScale = activeStep.key === "scale" && (!allFormValues.scale.horizontalLength || !allFormValues.scale.verticalLength);
    return {
      nextDisabled: disableFooterActions || disableNextScale,
      backDisabled: isFirst || disableFooterActions
    };
  }, [activeStep.key, activeStepIndex, allFormValues.scale.horizontalLength, allFormValues.scale.verticalLength, disableFooterActions]);
  const renderProgressBar = React__default.useCallback(() => {
    const onProgressBarShow = (processing) => {
      if (processing)
        setDisableFooterActions(true);
      else
        setDisableFooterActions(false);
    };
    return /* @__PURE__ */ jsx(ProgressBar, { onLoad: onProgressBarShow });
  }, []);
  React__default.useLayoutEffect(() => {
    const steps2 = ALL_IMPORT_STEPS.map((stepIn, index2) => {
      if (stepIn.extensions && !stepIn.extensions.includes(extension)) {
        return null;
      }
      if (fileData == null ? void 0 : fileData.error) {
        if (!["upload", "failed"].includes(stepIn.key))
          return null;
      } else if (stepIn.key === "failed") {
        return null;
      }
      const step = {
        ...stepIn
      };
      if (step.footer) {
        step.footer = /* @__PURE__ */ jsx(FooterPanel, { onNext: step.nextText ? onNext : null, onBack: step.backText ? onBack : null, nextDisabled, backDisabled, backText: step.backText, nextText: step.nextText });
      }
      switch (step.key) {
        case "upload":
          step.content = /* @__PURE__ */ jsx(StepImportFile, {});
          break;
        case "crop":
          step.sider = /* @__PURE__ */ jsx(StepCropSider, {});
          step.content = /* @__PURE__ */ jsx(StepCropContent, {});
          break;
        case "scale":
          step.sider = /* @__PURE__ */ jsx(StepScaleSider, {});
          if (extension === "dxf" || extension === "dwg") {
            step.content = /* @__PURE__ */ jsx(StepScaleCadContent, {});
          } else {
            step.content = /* @__PURE__ */ jsx(StepScaleImageContent, {});
          }
          break;
        case "place":
          step.sider = /* @__PURE__ */ jsx(StepScaleSider, { disabled: true });
          if (extension === "dxf" || extension === "dwg") {
            step.content = /* @__PURE__ */ jsx(StepPlaceCadContent, {});
          } else {
            step.content = /* @__PURE__ */ jsx(StepPlaceImageContent, {});
          }
          break;
        case "georeference":
          step.backText = index2 > 0 ? "Back" : "";
          step.sider = /* @__PURE__ */ jsx(StepCadAssignSider, {});
          if (extension === "dxf" || extension === "dwg") {
            step.content = /* @__PURE__ */ jsx(StepCadContent, {});
          } else {
            step.content = /* @__PURE__ */ jsx(StepImageContent, {});
            step.sider = /* @__PURE__ */ jsx(StepImageSider, {});
          }
          break;
      }
      return step;
    }).filter((s2) => !!s2);
    setSteps(steps2);
  }, [backDisabled, extension, fileData == null ? void 0 : fileData.error, nextDisabled, onBack, onNext]);
  React__default.useLayoutEffect(() => {
    if (activeStepIndex === 0) {
      resetAll();
    }
  }, [activeStepIndex, resetAll]);
  const onNextMutable = useMutableFunc(onNext);
  React__default.useLayoutEffect(() => {
    if (activeStepIndex === 0 && fileData) {
      setTimeout(() => {
        onNextMutable();
      }, 10);
    }
  }, [activeStepIndex, fileData, onNextMutable]);
  const context2 = React__default.useMemo(() => ({
    allFormValues,
    fileData,
    center: center2,
    updateFormValues,
    scaledData,
    croppedAssetData,
    onPlaceChange,
    tilesetUrl,
    uploadFileData,
    renderProgressBar,
    materials,
    onAssignChange,
    onCropChange,
    assignData,
    onScaleChange,
    helpButtonActive
  }), [allFormValues, assignData, center2, croppedAssetData, fileData, helpButtonActive, materials, onAssignChange, onCropChange, onPlaceChange, onScaleChange, renderProgressBar, scaledData, tilesetUrl, updateFormValues, uploadFileData]);
  if (!center2)
    return null;
  if ((activeStep == null ? void 0 : activeStep.key) === "upload")
    return /* @__PURE__ */ jsx(Modal$1, { title: "Import File", open: true, onCancel: () => onDone(false), okText: "Next", children: /* @__PURE__ */ jsx(ImportDataContext, { ...context2, children: activeStep.content }) });
  return /* @__PURE__ */ jsx(FullModal, { open: true, closable: activeStep == null ? void 0 : activeStep.showClose, footer: null, zIndex: "1049", onCancel: () => onDone(false), children: /* @__PURE__ */ jsx(ImportDataContext, { ...context2, children: /* @__PURE__ */ jsx(Layout, { style: {
    width: "100%"
  }, children: /* @__PURE__ */ jsxs(Layout, { hasSider: !!activeStep.sider, children: [
    activeStep.sider && /* @__PURE__ */ jsxs(Sider, { width: SIDER_WIDTH, style: {
      height: "100vh",
      width: `${SIDER_WIDTH}px`
    }, children: [
      activeStep.header && /* @__PURE__ */ jsx(Header, { style: {
        ...headerStyle
      }, children: /* @__PURE__ */ jsx(HeaderContent, { title: (_b3 = fileData == null ? void 0 : fileData.sourceFile) == null ? void 0 : _b3.filename, subTitle, onClickHelp: handleHelpButtonClick, showHelp: activeStep.hasHelp, onDone, style: {
        borderBottom: 0,
        padding: "16px 24px",
        flexDirection: "row",
        alignItems: "end",
        height: "84px"
      }, ...restProps, showBack: true }) }),
      /* @__PURE__ */ jsx("div", { style: {
        maxHeight: "calc(100% - 148px)",
        height: "calc(100% - 148px)"
      }, children: activeStep.sider }),
      activeStep.footer && /* @__PURE__ */ jsx(Footer, { style: {
        ...footerStyle
      }, children: activeStep.footer })
    ] }),
    /* @__PURE__ */ jsx(Content, { style: {
      height: "100vh",
      padding: "0px"
    }, children: activeStep.content })
  ] }) }) }) });
}
ImportData.propTypes = {
  title: propTypesExports$1.string,
  onDone: propTypesExports$1.func,
  extensions: propTypesExports$1.arrayOf(propTypesExports$1.string),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  materials: propTypesExports$1.arrayOf(propTypesExports$1.object),
  tilesetUrl: propTypesExports$1.any
};
ImportData.defaultProps = {
  title: "",
  onDone: () => {
  },
  extensions: [],
  center: null,
  materials: [],
  tilesetUrl: null
};
function MapPortal(props) {
  const {
    containerId,
    containerClassName,
    children
  } = props;
  const elementRef = React__default.useRef(null);
  React__default.useMemo(() => {
    var _a3;
    if (!elementRef.current) {
      if (containerId)
        elementRef.current = document.getElementById(containerId);
      if (!elementRef.current)
        elementRef.current = (_a3 = document.getElementsByClassName(containerClassName)) == null ? void 0 : _a3[0];
    }
  }, [containerClassName, containerId]);
  if (!elementRef.current)
    return null;
  return createPortal(children, elementRef.current);
}
MapPortal.propTypes = {
  containerId: propTypesExports$1.string,
  containerClassName: propTypesExports$1.string,
  children: propTypesExports$1.node
};
MapPortal.defaultProps = {
  containerId: "",
  containerClassName: "mapboxgl-map",
  children: null
};
const {
  useToken: useToken$b
} = theme$2;
const MODES = [{
  mode: "noselect",
  title: "View",
  icon: Icons.ArrowCursor
}, {
  mode: "select",
  title: "Edit",
  icon: Icons.AllDirection
}, {
  mode: "point",
  title: "Point",
  icon: Icons.PenDraw
}, {
  mode: "polygon",
  title: "Polygon",
  icon: Icons.PolygonData
}, {
  mode: "line",
  title: "Line",
  icon: Icons.LineDraw
}, {
  mode: "rectangle",
  title: "Rectangle",
  icon: Icons.RectangleDraw
}, {
  mode: "circle",
  title: "Circle",
  icon: Icons.CircleDraw
}];
function DrawToolsMenu(props) {
  const {
    placement,
    marginHorizontal,
    marginVertical,
    setDrawMode,
    drawMode,
    hidden,
    disabled
  } = props;
  const {
    token
  } = useToken$b();
  const {
    iconStyle,
    selectedStyle,
    toolButtonStyle
  } = React__default.useMemo(() => {
    const toolItemCommon = {
      backgroundColor: token.colorBgContainer,
      width: "32px",
      height: "32px",
      borderRadius: "6px",
      border: `1px solid ${token.colorBorderSecondary}`
    };
    const selectedStyle2 = {
      ...toolItemCommon,
      textOverflow: "clip",
      backgroundColor: token.colorPrimary,
      border: `1px solid ${token.colorPrimary}`
    };
    const toolButtonStyle2 = {
      ...toolItemCommon,
      textOverflow: "clip"
    };
    const iconStyle2 = {
      fontSize: "16px",
      color: token == null ? void 0 : token.colorText,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%"
    };
    return {
      iconStyle: iconStyle2,
      toolButtonStyle: toolButtonStyle2,
      selectedStyle: selectedStyle2
    };
  }, [token == null ? void 0 : token.colorBgContainer, token == null ? void 0 : token.colorBorderSecondary, token == null ? void 0 : token.colorPrimary, token == null ? void 0 : token.colorText]);
  const menuItems = React__default.useMemo(() => MODES.map((item) => {
    if (hidden[item.mode]) {
      return null;
    }
    return {
      key: item.mode,
      icon: /* @__PURE__ */ jsx(Tooltip$1, { placement: "left", trigger: "hover", title: item.title, arrow: false, align: {
        offset: [-18, 0]
      }, children: /* @__PURE__ */ jsx(item.icon, { style: {
        ...iconStyle
      } }) }),
      style: drawMode === item.mode ? {
        ...selectedStyle
      } : {
        ...toolButtonStyle
      },
      disabled: disabled[item.mode]
    };
  }), [disabled, drawMode, hidden, iconStyle, selectedStyle, toolButtonStyle]);
  return /* @__PURE__ */ jsx(OverlayPanel, { placement, width: 50, height: "255px", marginHorizontal, marginVertical, children: /* @__PURE__ */ jsx(Menu, { onClick: (e3) => {
    setDrawMode(e3.key);
  }, selectedKeys: [drawMode], mode: "vertical", style: {
    width: "48px",
    backgroundColor: "transparent"
  }, items: menuItems }) });
}
DrawToolsMenu.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  setDrawMode: propTypesExports$1.func,
  drawMode: propTypesExports$1.string,
  hidden: propTypesExports$1.object,
  disabled: propTypesExports$1.object
};
DrawToolsMenu.defaultProps = {
  drawMode: "noselect",
  placement: "top-right",
  marginHorizontal: 0,
  marginVertical: 0,
  setDrawMode: () => {
  },
  hidden: {},
  disabled: {}
};
function AutoFocusSelector(props) {
  const {
    assets,
    features,
    featureId,
    layerId,
    levelId,
    buildingId,
    venueId,
    bearing: bearing2,
    forceUpdate,
    pitch,
    ...restProps
  } = props;
  const setAutoFocusItem = useViewStore((state) => state.setAutoFocusItem);
  const defaultCenter = useSiteStore((state) => state.defaultCenter);
  const defaultFeatureRef = React__default.useRef({
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: defaultCenter
    }
  });
  const isEqual3 = React__default.useCallback((a2, b2) => {
    if (a2 === b2)
      return true;
    if (!a2 || !b2)
      return false;
    if (typeof a2 !== typeof b2)
      return false;
    if ((a2 == null ? void 0 : a2.id) && (a2 == null ? void 0 : a2.id) === (b2 == null ? void 0 : b2.id))
      return true;
    if (Array.isArray(a2) && Array.isArray(b2)) {
      return a2.length === b2.length && a2.every((af2, index2) => {
        var _a3;
        return (af2 == null ? void 0 : af2.id) === ((_a3 = b2[index2]) == null ? void 0 : _a3.id);
      });
    }
    return false;
  }, []);
  React__default.useLayoutEffect(() => {
    defaultFeatureRef.current = {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: defaultCenter
      }
    };
  }, [defaultCenter]);
  React__default.useEffect(() => {
    let selectedFeature;
    if (featureId === "all") {
      selectedFeature = features;
    }
    if (layerId && !selectedFeature) {
      const filteredFeatures = features == null ? void 0 : features.flat().filter((feature2) => feature2.properties.layer === layerId);
      if (filteredFeatures == null ? void 0 : filteredFeatures.length) {
        selectedFeature = filteredFeatures;
      }
    }
    if (featureId && !selectedFeature) {
      const feature2 = features == null ? void 0 : features.find((feature22) => feature22.id === featureId);
      if (feature2) {
        selectedFeature = feature2;
      } else {
        const asset = assets == null ? void 0 : assets.find((asset2) => asset2.id === featureId);
        if (asset == null ? void 0 : asset.box) {
          selectedFeature = asset;
        }
      }
    }
    if (levelId && !selectedFeature) {
      const filteredFeatures = features == null ? void 0 : features.flat().filter((feature2) => feature2.properties.levelId === levelId || feature2.properties.parentId === levelId);
      if (filteredFeatures == null ? void 0 : filteredFeatures.length) {
        selectedFeature = filteredFeatures;
      }
    }
    if (buildingId && !selectedFeature) {
      const filteredFeatures = features == null ? void 0 : features.flat().filter((feature2) => feature2.properties.buildingId === buildingId || feature2.properties.parentId === buildingId);
      if (filteredFeatures == null ? void 0 : filteredFeatures.length) {
        selectedFeature = filteredFeatures;
      }
    }
    if (venueId && !selectedFeature) {
      const filteredFeatures = features == null ? void 0 : features.flat().filter((feature2) => feature2.properties.venueId === venueId || feature2.properties.parentId === venueId);
      if (filteredFeatures == null ? void 0 : filteredFeatures.length) {
        selectedFeature = filteredFeatures;
      }
    }
    if (!selectedFeature && forceUpdate) {
      selectedFeature = defaultFeatureRef.current;
    }
    const params2 = {
      bearing: bearing2,
      pitch,
      ...restProps
    };
    if (forceUpdate || !isEqual3(useViewStore.getState().autoFocusItem, selectedFeature)) {
      setAutoFocusItem(selectedFeature, params2, forceUpdate);
    }
  }, [featureId, assets, layerId, features, levelId, buildingId, venueId, setAutoFocusItem, bearing2, forceUpdate, pitch, restProps, isEqual3]);
  return null;
}
AutoFocusSelector.propTypes = {
  assets: propTypesExports$1.array,
  featureId: propTypesExports$1.string,
  layerId: propTypesExports$1.string,
  levelId: propTypesExports$1.string,
  buildingId: propTypesExports$1.string,
  venueId: propTypesExports$1.string,
  features: propTypesExports$1.array,
  bearing: propTypesExports$1.number,
  pitch: propTypesExports$1.number,
  forceUpdate: propTypesExports$1.bool
};
AutoFocusSelector.defaultProps = {
  assets: [],
  featureId: "",
  layerId: "",
  levelId: "",
  buildingId: "",
  venueId: "",
  features: [],
  bearing: 0,
  pitch: 0,
  forceUpdate: false
};
function MapAutoFocus(props) {
  const {
    enabled,
    features,
    forceUpdate
  } = props;
  const assets = useAssetStore((state) => state.assets);
  const activeFeatureId = useViewStore((state) => state.activeFeatureId);
  const activeLayerId = useViewStore((state) => state.activeLayerId);
  const activeLevelId = useViewStore((state) => state.activeLevelId);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const displayMode2 = useViewStore((state) => state.displayMode);
  const bearing2 = useSiteStore((state) => {
    var _a3;
    return ((_a3 = state.levels.find((l2) => l2.id === activeLevelId)) == null ? void 0 : _a3.azimuth) || 0;
  });
  const pitch = React__default.useMemo(() => displayMode2 === "3d" ? 60 : 0, [displayMode2]);
  const featureId = React__default.useMemo(() => activeFeatureId || activeLayerId || activeLevelId || activeBuildingId || activeVenueId ? activeFeatureId : "all", [activeBuildingId, activeFeatureId, activeLayerId, activeLevelId, activeVenueId]);
  if (!enabled)
    return null;
  return /* @__PURE__ */ jsx(AutoFocusSelector, { assets, features, featureId, layerId: activeLayerId, levelId: activeLevelId, buildingId: activeBuildingId, venueId: activeVenueId, bearing: bearing2, pitch, forceUpdate });
}
MapAutoFocus.propTypes = {
  enabled: propTypesExports$1.bool,
  features: propTypesExports$1.array,
  forceUpdate: propTypesExports$1.bool
};
MapAutoFocus.defaultProps = {
  enabled: false,
  features: [],
  forceUpdate: false
};
function AutoFocusOnSelectedItem(props) {
  const {
    enable: enable4
  } = props;
  const [forcedEnable, setForcedEnable] = React__default.useState(false);
  const feature2 = useViewStore((state) => state.autoFocusItem);
  const params2 = useViewStore((state) => state.autoFocusParams);
  const counter2 = useViewStore((state) => state.autoFocusForceCounter);
  React__default.useLayoutEffect(() => {
    setForcedEnable(true);
    setTimeout(() => {
      setForcedEnable(false);
    }, 500);
  }, [counter2]);
  if (!enable4 && !forcedEnable)
    return null;
  return /* @__PURE__ */ jsx(MapFitFeature, { feature: feature2, refreshCounter: counter2, ...params2 || {} });
}
AutoFocusOnSelectedItem.propTypes = {
  enable: propTypesExports$1.bool
};
AutoFocusOnSelectedItem.defaultProps = {
  enable: false
};
const {
  useToken: useToken$a
} = theme$2;
const {
  Dragger
} = Upload;
const {
  Title: Title$c,
  Text: Text$a,
  Link
} = Typography;
function ImportFile({
  onDownload = () => {
  },
  onFileUpload = () => {
  },
  onNext = () => {
  },
  onCancel = () => {
  },
  changeStatus = () => {
  },
  accept = ".csv",
  isError: isError2 = false
}) {
  const {
    token
  } = useToken$a();
  const [fileError, setFileError] = useState(null);
  const [isFileSelected, setIsFileSelected] = useState(false);
  const validateFileExtension = React__default.useCallback((file2) => {
    const acceptedExtensions = accept.split(",").map((ext) => ext.trim());
    const fileExtension = `.${file2.name.split(".").pop().toLowerCase()}`;
    return acceptedExtensions.includes(fileExtension);
  }, [accept]);
  const onCancelClicked = React__default.useCallback(() => {
    setIsFileSelected(false);
    onCancel();
  }, [onCancel]);
  const onDownloadClick = React__default.useCallback(() => {
    const text = onDownload();
    if (text) {
      FileUtil.downloadStringAsFile(text, "template.csv");
    }
  }, [onDownload]);
  const props = React__default.useMemo(() => ({
    name: "file",
    multiple: false,
    accept,
    beforeUpload(file2) {
      if (!validateFileExtension(file2)) {
        setFileError("Invalid file format. Please upload a CSV file.");
        message$1.error("Invalid file format. Please upload a CSV file.");
        return Upload.LIST_IGNORE;
      }
      setFileError(null);
      return true;
    },
    onChange(info) {
      const {
        status,
        percent,
        originFileObj
      } = info.file;
      if ((status === "done" || status === "uploading") && percent === 100) {
        setIsFileSelected(true);
        onFileUpload(originFileObj);
      }
    }
  }), [validateFileExtension, onFileUpload, setFileError, setIsFileSelected, accept]);
  const title = useMemo(() => {
    if (isError2) {
      return /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
        textAlign: "center"
      }, children: [
        /* @__PURE__ */ jsx(CloseCircleFilled, { style: {
          color: token.colorError,
          fontSize: 72
        } }),
        /* @__PURE__ */ jsx(Typography.Title, { level: 3, style: {
          marginBottom: 0
        }, children: "Dataset structure is wrong" }),
        /* @__PURE__ */ jsx(Typography.Text, { children: "The file you imported contains wrong structure. Please verify the data in the file. You can find example down below in Template." })
      ] });
    }
    return /* @__PURE__ */ jsx(Title$c, { level: 4, style: {
      marginTop: "0px",
      paddingTop: "0px"
    }, children: "Import File" });
  }, [isError2, token]);
  return /* @__PURE__ */ jsx(Space, { style: {
    paddingLeft: isError2 ? "30px" : "0",
    paddingRight: isError2 ? "30px" : "0",
    display: "block"
  }, children: /* @__PURE__ */ jsxs("div", { style: {
    width: "100%"
  }, children: [
    title,
    /* @__PURE__ */ jsxs("div", { style: {
      marginBottom: 10,
      width: "100%"
    }, children: [
      isError2 ? /* @__PURE__ */ jsx(Typography.Text, { strong: true, children: "Template File" }) : /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx("div", { style: {
          display: "inline-block",
          width: 24,
          height: 24,
          backgroundColor: token.colorPrimary,
          color: token.colorTextLightSolid,
          fontSize: token.fontSize,
          fontWeight: token.fontWeightNormal,
          borderRadius: "50%",
          textAlign: "center",
          lineHeight: "24px",
          marginRight: 10
        }, children: "1" }),
        /* @__PURE__ */ jsx(Text$a, { style: {
          fontWeight: token.fontWeightNormal
        }, children: "Download Template" })
      ] }),
      /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        alignItems: "center",
        marginTop: 8
      }, children: [
        /* @__PURE__ */ jsx(PaperClipOutlined, { style: {
          marginRight: 8,
          fontSize: "16px",
          color: token.colorTextDescription
        } }),
        /* @__PURE__ */ jsx(Link, { href: "/assets/template.csv", style: {
          marginRight: "auto",
          fontSize: token.fontSize
        }, children: "Template.csv" }),
        /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(DownloadOutlined, {}), type: "default", onClick: onDownloadClick, children: "Download" })
      ] })
    ] }),
    !isError2 && /* @__PURE__ */ jsxs("div", { style: {
      marginBottom: 20
    }, children: [
      /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        alignItems: "center",
        marginBottom: 10
      }, children: [
        /* @__PURE__ */ jsx("div", { style: {
          display: "inline-block",
          width: 24,
          height: 24,
          backgroundColor: token.colorPrimary,
          color: token.colorTextLightSolid,
          fontSize: token.fontSize,
          fontWeight: token.fontWeightNormal,
          borderRadius: "50%",
          textAlign: "center",
          lineHeight: "24px",
          marginRight: 10
        }, children: "2" }),
        /* @__PURE__ */ jsx(Text$a, { style: {
          fontWeight: token.fontWeightNormal
        }, children: "Upload data" })
      ] }),
      /* @__PURE__ */ jsxs(Dragger, { ...props, style: {
        padding: 20,
        border: "1px dashed #d9d9d9",
        backgroundColor: token.colorFillAlter
      }, children: [
        /* @__PURE__ */ jsx("p", { className: "ant-upload-drag-icon", children: /* @__PURE__ */ jsx(UploadOutlined, {}) }),
        /* @__PURE__ */ jsx("p", { className: "ant-upload-text", children: "Click or drag file to this area to upload" })
      ] }),
      fileError && /* @__PURE__ */ jsx(Text$a, { type: "danger", style: {
        marginTop: 8
      }, children: fileError })
    ] }),
    /* @__PURE__ */ jsx("div", { style: {
      textAlign: isError2 ? "center" : "right"
    }, children: isError2 ? /* @__PURE__ */ jsxs(Space, { children: [
      /* @__PURE__ */ jsx(Button, { onClick: onCancelClicked, children: "Close" }),
      /* @__PURE__ */ jsx(Button, { type: "primary", onClick: () => changeStatus(), children: "Import File" })
    ] }) : /* @__PURE__ */ jsxs(Space, { children: [
      /* @__PURE__ */ jsx(Button, { onClick: onCancelClicked, children: "Cancel" }),
      /* @__PURE__ */ jsx(Button, { type: "primary", onClick: onNext, disabled: !isFileSelected, children: "Next" })
    ] }) })
  ] }) });
}
ImportFile.defaultProps = {
  onDownload: () => {
  },
  onFileUpload: () => {
  },
  onNext: () => {
  },
  onCancel: () => {
  },
  isError: false,
  changeStatus: () => {
  },
  accept: ".csv"
};
ImportFile.propTypes = {
  onDownload: propTypesExports$1.func,
  onFileUpload: propTypesExports$1.func,
  onNext: propTypesExports$1.func,
  accept: propTypesExports$1.string,
  onCancel: propTypesExports$1.func,
  isError: propTypesExports$1.bool,
  changeStatus: propTypesExports$1.func
};
const {
  Title: Title$b,
  Text: Text$9
} = Typography;
const {
  useToken: useToken$9
} = theme$2;
function AddressConfig({
  onBack,
  onSubmit,
  count: count3 = 0
}) {
  var _a3, _b3, _c2, _d2, _e2, _f3;
  const {
    token
  } = useToken$9();
  const [form] = Form.useForm();
  const isManual = Form.useWatch("manualConfig", form);
  const region = Form.useWatch("region", form);
  const market = Form.useWatch("market", form);
  const cluster = Form.useWatch("cluster", form);
  const venue = Form.useWatch("venue", form);
  const building = Form.useWatch("building", form);
  const [isLoading, setIsLoading] = React__default.useState(false);
  const dataHook = useSiteStore((state) => ({
    regions: state.regions,
    markets: state.markets,
    clusters: state.clusters,
    venues: state.venues,
    buildings: state.buildings,
    levels: state.levels
  }));
  const activeRegionId = useViewStore((state) => state.activeRegionId);
  const activeMarketId = useViewStore((state) => state.activeMarketId);
  const activeClusterId = useViewStore((state) => state.activeClusterId);
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const activeLevelId = useViewStore((state) => state.activeLevelId);
  const regions = React__default.useMemo(() => {
    var _a4;
    return ((_a4 = dataHook.regions) == null ? void 0 : _a4.map((i2) => ({
      value: i2.id,
      label: i2.name
    }))) || [];
  }, [dataHook]);
  const markets = React__default.useMemo(() => {
    var _a4, _b4;
    return ((_b4 = (_a4 = dataHook.markets) == null ? void 0 : _a4.filter((i2) => region ? i2.regionId === region : !isManual || !regions.length)) == null ? void 0 : _b4.map((i2) => ({
      value: i2.id,
      label: i2.name
    }))) || [];
  }, [dataHook, region, isManual, regions]);
  const clusters = React__default.useMemo(() => {
    var _a4, _b4;
    return ((_b4 = (_a4 = dataHook.clusters) == null ? void 0 : _a4.filter((i2) => market ? i2.marketId === market : !isManual || !markets.length)) == null ? void 0 : _b4.map((i2) => ({
      value: i2.id,
      label: i2.name
    }))) || [];
  }, [dataHook, market, isManual, markets]);
  const venues = React__default.useMemo(() => {
    var _a4, _b4;
    return ((_b4 = (_a4 = dataHook.venues) == null ? void 0 : _a4.filter((i2) => cluster ? i2.clusterId === cluster : !isManual || !clusters.length)) == null ? void 0 : _b4.map((i2) => ({
      value: i2.id,
      label: i2.name
    }))) || [];
  }, [dataHook, cluster, isManual, clusters]);
  const buildings = React__default.useMemo(() => {
    var _a4, _b4;
    return ((_b4 = (_a4 = dataHook.buildings) == null ? void 0 : _a4.filter((i2) => venue ? i2.venueId === venue : !isManual || !venues.length)) == null ? void 0 : _b4.map((i2) => ({
      value: i2.id,
      label: i2.name
    }))) || [];
  }, [dataHook, venue, isManual, venues]);
  const levels = React__default.useMemo(() => {
    var _a4, _b4;
    return ((_b4 = (_a4 = dataHook.levels) == null ? void 0 : _a4.filter((i2) => building ? i2.buildingId === building : !isManual)) == null ? void 0 : _b4.map((i2) => ({
      value: i2.id,
      label: i2.name
    }))) || [];
  }, [dataHook, building, isManual]);
  React__default.useEffect(() => {
    if (!isManual) {
      form.setFieldsValue({
        region: activeRegionId,
        market: activeMarketId,
        cluster: activeClusterId,
        venue: activeVenueId,
        building: activeBuildingId,
        level: activeLevelId
      });
    }
  }, [isManual, form, activeRegionId, activeMarketId, activeClusterId, activeVenueId, activeBuildingId, activeLevelId]);
  const handleSubmit = useCallback(async () => {
    const values4 = await form.validateFields();
    try {
      setIsLoading(true);
      const hirarchy = ["region", "market", "cluster", "venue", "building", "level"];
      const importedTree = hirarchy.map((key) => {
        const id = values4[key];
        if (!id)
          return null;
        const item = dataHook[`${key}s`].find((i2) => i2.id === id);
        return {
          id,
          name: item.name,
          type: item.type
        };
      }).filter(Boolean);
      await onSubmit({
        parentId: values4.level,
        parentType: "level",
        importedTree
      });
    } catch (err) {
      console.log(err);
    }
    setIsLoading(false);
  }, [form, onSubmit, dataHook, setIsLoading]);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(Title$b, { level: 4, children: "Configure address" }),
    /* @__PURE__ */ jsx(Text$9, { style: {
      fontSize: token.fontSize,
      fontWeight: token.fontWeightNormal,
      fontFamily: token.fontFamily,
      lineHeight: token.lineHeight
    }, children: "You're about to assign the selected assets to a specific address. This action will help organize and categorize assets within the designated location." }),
    /* @__PURE__ */ jsx(Alert, { message: /* @__PURE__ */ jsxs(Text$9, { children: [
      count3,
      " Assets added. Please assign the Address to all Assets"
    ] }), type: "info", showIcon: true, style: {
      margin: "15px 0",
      marginBottom: "0px",
      height: "38px",
      padding: `${token.paddingContentVerticalSM}px ${token.paddingSM}px`,
      backgroundColor: token.colorInfoBg,
      color: token.colorInfoText
    } }),
    /* @__PURE__ */ jsxs(Form, { form, layout: "vertical", children: [
      /* @__PURE__ */ jsxs(Form.Item, { label: /* @__PURE__ */ jsx(Title$b, { level: 5, style: {
        marginTop: "10px"
      }, children: "Address settings" }), children: [
        (activeRegionId || isManual) && /* @__PURE__ */ jsx(Form.Item, { name: "region", style: {
          marginBottom: 10
        }, initialValue: (_a3 = regions.find((region2) => region2.value === activeRegionId)) == null ? void 0 : _a3.value, children: /* @__PURE__ */ jsx(Select$1, { placeholder: "Select Region", options: regions, disabled: !isManual, onChange: () => {
          form.setFieldsValue({
            market: void 0,
            cluster: void 0,
            venue: void 0,
            building: void 0,
            level: void 0
          });
        } }) }),
        (activeMarketId || isManual) && /* @__PURE__ */ jsx(Form.Item, { name: "market", style: {
          marginBottom: 10
        }, initialValue: (_b3 = markets.find((market2) => market2.value === activeMarketId)) == null ? void 0 : _b3.value, children: /* @__PURE__ */ jsx(Select$1, { placeholder: "Select Market", options: markets, disabled: !isManual, onChange: () => {
          form.setFieldsValue({
            cluster: void 0,
            venue: void 0,
            building: void 0,
            level: void 0
          });
        } }) }),
        (activeClusterId || isManual) && /* @__PURE__ */ jsx(Form.Item, { name: "cluster", style: {
          marginBottom: 10
        }, initialValue: (_c2 = clusters.find((cluster2) => cluster2.value === activeClusterId)) == null ? void 0 : _c2.value, children: /* @__PURE__ */ jsx(Select$1, { placeholder: "Select Cluster", options: clusters, disabled: !isManual, onChange: () => {
          form.setFieldsValue({
            venue: void 0,
            building: void 0,
            level: void 0
          });
        } }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "venue", style: {
          marginBottom: 10
        }, initialValue: (_d2 = venues.find((venue2) => venue2.value === activeVenueId)) == null ? void 0 : _d2.value, children: /* @__PURE__ */ jsx(Select$1, { placeholder: "Select Venue", options: venues, disabled: !isManual, onChange: () => {
          form.setFieldsValue({
            building: void 0,
            level: void 0
          });
        } }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "building", style: {
          marginBottom: 10
        }, initialValue: (_e2 = buildings.find((building2) => building2.value === activeBuildingId)) == null ? void 0 : _e2.value, children: /* @__PURE__ */ jsx(Select$1, { placeholder: "Select Building", options: buildings, disabled: !isManual, onChange: () => {
          form.setFieldsValue({
            level: void 0
          });
        } }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "level", style: {
          marginBottom: 0
        }, initialValue: (_f3 = levels.find((level) => level.value === activeLevelId)) == null ? void 0 : _f3.value, children: /* @__PURE__ */ jsx(Select$1, { placeholder: "Select Floor", options: levels, disabled: !isManual }) })
      ] }),
      /* @__PURE__ */ jsx(Form.Item, { name: "manualConfig", valuePropName: "checked", style: {
        marginBottom: 20,
        marginTop: 0
      }, children: /* @__PURE__ */ jsx(Checkbox, { style: {
        marginTop: 0
      }, children: "Configure manually each asset" }) }),
      /* @__PURE__ */ jsxs(Space, { style: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 20
      }, children: [
        /* @__PURE__ */ jsx(Button, { onClick: onBack, children: "Back" }),
        /* @__PURE__ */ jsx(Button, { type: "primary", onClick: handleSubmit, loading: isLoading, children: "Submit" })
      ] })
    ] })
  ] });
}
AddressConfig.defaultProps = {
  count: 0
};
AddressConfig.propTypes = {
  onBack: propTypesExports$1.func.isRequired,
  onSubmit: propTypesExports$1.func.isRequired,
  count: propTypesExports$1.number
};
const {
  useToken: useToken$8
} = theme$2;
const {
  Title: Title$a,
  Text: Text$8
} = Typography;
function ImportSuccess(props) {
  const {
    onDone,
    successMessage,
    assetDetails,
    importedAtType,
    importedAtName
  } = props;
  const {
    token
  } = useToken$8();
  return /* @__PURE__ */ jsxs("div", { style: {
    alignItems: "center",
    padding: "15px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, children: [
    /* @__PURE__ */ jsx(CheckCircleFilled, { style: {
      fontSize: 63,
      color: token.colorSuccess,
      marginBottom: "0px"
    } }),
    /* @__PURE__ */ jsx(Title$a, { level: 3, children: "Asset Successfully Imported" }),
    /* @__PURE__ */ jsxs(Text$8, { style: {
      fontSize: token.fontSize,
      color: token.colorTextSecondary,
      textAlign: "center",
      alignItems: "center"
    }, children: [
      "The selected asset has been successfully assigned to the ",
      importedAtType,
      " “",
      importedAtName,
      "“."
    ] }),
    /* @__PURE__ */ jsxs(Space, { style: {
      margin: "10px",
      padding: "10px",
      backgroundColor: token.colorSuccessBg,
      border: `1px solid ${token.colorSuccessBorder}`,
      borderRadius: token.borderRadiusLG,
      display: "flex",
      justifyContent: "left",
      alignItems: "left",
      width: "95%"
    }, children: [
      /* @__PURE__ */ jsx(CheckCircleFilled, { style: {
        fontSize: "16px",
        color: token.colorSuccess
      } }),
      /* @__PURE__ */ jsx(Text$8, { style: {
        marginLeft: "10px",
        textAlign: "left",
        fontSize: token.fontSize,
        color: token.colorTextHeading
      }, children: successMessage })
    ] }),
    /* @__PURE__ */ jsx(Space, { direction: "vertical", style: {
      width: "100%",
      marginTop: "0px"
    }, children: assetDetails.map((asset) => /* @__PURE__ */ jsxs(Row, { align: "middle", style: {
      padding: "5px 10px",
      backgroundColor: token.colorBgContainer,
      borderRadius: "6px"
    }, children: [
      /* @__PURE__ */ jsx(Col, { span: 2, children: asset.icon }),
      /* @__PURE__ */ jsx(Col, { span: 22, children: /* @__PURE__ */ jsx(Text$8, { type: "secondary", children: asset.label }) })
    ] }, asset.id)) }),
    /* @__PURE__ */ jsxs(Space, { style: {
      width: "100%",
      justifyContent: "space-between",
      marginTop: "20px"
    }, children: [
      /* @__PURE__ */ jsx(Button, { onClick: onDone, size: "large", children: "Cancel" }),
      /* @__PURE__ */ jsx(Button, { onClick: onDone, type: "primary", size: "large", children: "Done" })
    ] })
  ] });
}
ImportSuccess.defaultProps = {
  onDone: () => {
  },
  successMessage: "",
  assetDetails: [],
  importedAtType: "",
  importedAtName: ""
};
ImportSuccess.propTypes = {
  onDone: propTypesExports$1.func,
  successMessage: propTypesExports$1.string,
  assetDetails: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    id: propTypesExports$1.string,
    icon: propTypesExports$1.node,
    label: propTypesExports$1.string
  })),
  importedAtType: propTypesExports$1.string,
  importedAtName: propTypesExports$1.string
};
const AssetTemplate = {
  sample: {
    type: "Feature",
    drawMode: "point",
    category: "accessPoint",
    fill: "#0166FF",
    "fill-opacity": "0.7",
    stroke: "#0166FF",
    "stroke-opacity": "1",
    "stroke-width": "1",
    "stroke-dasharray": "1-0",
    "hide-when-zoomed-in": "1",
    name: "sample ap",
    assetType: "Hub",
    latitude: "40.74936535239951",
    longitude: "-73.84478467967863",
    "address.addressLine1": "addressLine1",
    "address.addressLine2": "addressLine2",
    "address.country": "",
    "address.postalCode": "212",
    parentType: "level"
  },
  get header() {
    return Object.keys(this.sample);
  },
  get values() {
    return Object.values(this.sample);
  },
  required: ["type", (object2) => object2.properties.category, (object2) => object2.properties.name, (object2) => object2.properties.assetType, (object2) => object2.geometry.coordinates.length]
};
const Status = {
  FILE_SELECTION: 1,
  PROCESSING: 2,
  CONFIGURE_ADDRESS: 3,
  SUCCESS: 4,
  FAILURE: 5,
  ERROR: 6
};
function ImportAssets({
  isModalOpen,
  handleCloseModal,
  onSubmit = () => {
  }
}) {
  const [status, setStatus] = useState(Status.FILE_SELECTION);
  const [parsedData, setParsedData] = useState([]);
  const [importedHirarchy, setImportedHirarchy] = useState([]);
  const [preparedAps, setPreparedAps] = useState([]);
  const validateFields = React__default.useCallback((dataIn) => {
    const data2 = dataIn;
    const requiredFields = AssetTemplate.required;
    data2.features = data2.features.filter((feature2) => {
      const headers = feature2;
      return requiredFields.every((field) => typeof field === "string" ? headers[field] : field(headers));
    });
    return data2.features.length > 0;
  }, []);
  const onSelect = React__default.useCallback(async (file2) => {
    try {
      const text = await FileUtil.importFromFile(file2, "text");
      const result = await FileParserUtil.parseFile(text, {});
      const validationResult = validateFields(result);
      if (result.type !== "STORE" || !validationResult) {
        message$1.error(result.type !== "STORE" ? "Invalid file format. Please upload a valid file." : "No valid data found in the file. Please upload a valid file.");
        setStatus(Status.ERROR);
        handleCloseModal();
        return;
      }
      setParsedData(result);
    } catch (e3) {
      setStatus(Status.ERROR);
      console.error(e3);
    }
  }, [setParsedData, setStatus, validateFields, handleCloseModal]);
  useEffect(() => {
    if (isModalOpen) {
      setStatus(Status.FILE_SELECTION);
    }
  }, [isModalOpen, setStatus]);
  const getTemplateData = React__default.useCallback(() => {
    const csvRows = [];
    csvRows.push(AssetTemplate.header.join(","));
    csvRows.push(AssetTemplate.values.join(","));
    return csvRows.join("\n");
  }, []);
  const handleNextClick = React__default.useCallback(() => {
    setStatus(Status.CONFIGURE_ADDRESS);
  }, [setStatus]);
  const handleAddressConfig = (hierarchy) => {
    try {
      const {
        importedTree,
        ...rest
      } = hierarchy;
      setStatus(Status.PROCESSING);
      prepareAps(rest);
      setImportedHirarchy(importedTree);
      setStatus(Status.SUCCESS);
    } catch (err) {
      setStatus(Status.ERROR);
      console.error(err);
    }
  };
  const prepareAps = React__default.useCallback((data2) => {
    const {
      parentType,
      parentId
    } = data2;
    const aps = [];
    parsedData.features.forEach((feature2) => {
      const ap2 = {
        ...feature2,
        parentId,
        type: "Feature",
        name: feature2.properties.name,
        properties: {
          ...feature2.properties,
          parentId,
          parentType,
          [`${parentType}Id`]: parentId
        }
      };
      if (ap2.properties["stroke-dasharray"] && ap2.properties["stroke-dasharray"].includes("-")) {
        ap2.properties["stroke-dasharray"] = ap2.properties["stroke-dasharray"].split("-").map(Number);
      }
      aps.push(ap2);
    });
    setPreparedAps(aps);
  }, [parsedData, setPreparedAps]);
  const handleBackFromAddressConfig = React__default.useCallback(() => {
    setStatus(Status.FILE_SELECTION);
  }, [setStatus]);
  const renderContent = () => {
    var _a3, _b3, _c2;
    switch (status) {
      case Status.FILE_SELECTION:
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          ImportFile,
          {
            isError: status === Status.FAILURE,
            onDownload: getTemplateData,
            onCancel: handleCloseModal,
            onFileUpload: onSelect,
            onNext: handleNextClick,
            accept: ".csv"
          }
        ) });
      case Status.PROCESSING:
        return /* @__PURE__ */ jsx(ProgressBar, {});
      case Status.CONFIGURE_ADDRESS:
        return /* @__PURE__ */ jsx(AddressConfig, { count: parsedData.features.length, onBack: handleBackFromAddressConfig, onSubmit: handleAddressConfig });
      case Status.SUCCESS:
        return /* @__PURE__ */ jsx(ImportSuccess, { onDone: () => onSubmit(preparedAps), successMessage: `${(_a3 = parsedData == null ? void 0 : parsedData.features) == null ? void 0 : _a3.length} Assets imported successfully!`, importedAtType: (_b3 = importedHirarchy[0]) == null ? void 0 : _b3.type, importedAtName: (_c2 = importedHirarchy[0]) == null ? void 0 : _c2.name, assetDetails: importedHirarchy.map((item) => ({
          ...item,
          icon: ICONS[item.type] || /* @__PURE__ */ jsx(EnvironmentOutlined, {}),
          label: item.name
        })) });
      case Status.FAILURE:
        return /* @__PURE__ */ jsx("div", { style: {
          color: "red"
        }, children: "Import Failed. Please try again." });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ jsx(ModalPopup, { showCloseIcon: false, open: true, handleClose: handleCloseModal, centered: true, children: renderContent() });
}
function ModalPopup({
  open: open2 = false,
  children = null,
  closeIcon = true,
  centered = true,
  handleClose = () => {
  },
  style: style2 = {},
  className = "",
  showCloseIcon = true
}) {
  return /* @__PURE__ */ jsx(Modal$1, { wrapClassName: className, title: null, open: open2, closeIcon: showCloseIcon ? closeIcon : null, onCancel: handleClose, centered, style: {
    style: style2
  }, footer: null, children });
}
ImportAssets.defaultProps = {
  isModalOpen: false,
  handleCloseModal: () => {
  },
  onSubmit: () => {
  }
};
ImportAssets.propTypes = {
  isModalOpen: propTypesExports$1.bool,
  handleCloseModal: propTypesExports$1.func,
  onSubmit: propTypesExports$1.func
};
ModalPopup.defaultProps = {
  open: false,
  closeIcon: true,
  centered: true,
  className: "",
  children: null,
  handleClose: () => {
  },
  style: {},
  showCloseIcon: true
};
ModalPopup.propTypes = {
  open: propTypesExports$1.bool,
  closeIcon: propTypesExports$1.bool,
  centered: propTypesExports$1.bool,
  className: propTypesExports$1.string,
  children: propTypesExports$1.node,
  handleClose: propTypesExports$1.func,
  style: propTypesExports$1.object,
  showCloseIcon: propTypesExports$1.bool
};
const displayMode = "2d";
function MapToolForm(props) {
  const {
    children,
    containerId,
    component: Form2,
    subComponent: SubForm,
    componentProps: formProps,
    subComponentProps: subFormPropsIn,
    embedSubComponent,
    initialValue,
    overrideValue,
    // use for overriding initialValue and current formValue
    subInitialValue,
    noSubFormCancel,
    features,
    onDone: onDoneIn,
    onFormChange: onFormChangeIn,
    onFeaturesImport: onFeaturesImportIn,
    onFeatureSelect: onFeatureSelectIn,
    onFeatureChange: onFeatureChangeIn,
    onFeaturesDelete: onFeaturesDeleteIn,
    onSubFormChange: onSubFormChangeIn,
    center: center2,
    showDrawTools,
    materials,
    tilesetUrl,
    territoryType,
    setTerritoryType,
    drawMode: drawModeIn,
    initialUploadExtensions,
    drawToolsMenuProps,
    territoryPropName,
    deviceTypes,
    ...restProps
  } = props;
  const setDisplayMode = useViewStore((state) => state.setDisplayMode);
  const [drawMode, setDrawMode] = React__default.useState("noselect");
  const [formValue, setFormValue] = React__default.useState(initialValue);
  const [subFormValue, setSubFormValue] = React__default.useState(subInitialValue);
  const [isSubFormOpen, setIsSubFormOpen] = React__default.useState(false);
  const [isDrawToolOn, setIsDrawToolOn] = React__default.useState(!!(subFormPropsIn == null ? void 0 : subFormPropsIn.isDrawToolOn));
  const [uploadableExtensions, setUploadableExtensions] = React__default.useState(initialUploadExtensions);
  const elementRef = React__default.useRef(null);
  const [updatedFeatures, setUpdatedFeatures] = React__default.useState([]);
  const [importData, setImportData] = React__default.useState(null);
  const [clickedFeatureId, setClickedFeatureId] = React__default.useState(null);
  const [enableAutoFocus, setEnableAutoFocus] = React__default.useState(false);
  const autoFocusRef = React__default.useRef(false);
  const {
    activeLayerId
  } = formProps;
  const isAssetImport = React__default.useMemo(() => (uploadableExtensions == null ? void 0 : uploadableExtensions.length) === 1 && uploadableExtensions[0] === "csv", [uploadableExtensions]);
  React__default.useEffect(() => {
    setDisplayMode(displayMode);
    if ((formValue == null ? void 0 : formValue.id) !== (initialValue == null ? void 0 : initialValue.id))
      setFormValue(initialValue);
  }, [formValue == null ? void 0 : formValue.id, initialValue, setDisplayMode]);
  React__default.useEffect(() => {
    setDrawMode(drawModeIn === "select-country" ? "point" : "noselect");
  }, [drawModeIn]);
  React__default.useEffect(() => {
    setIsDrawToolOn(!!(subFormPropsIn == null ? void 0 : subFormPropsIn.isDrawToolOn));
  }, [subFormPropsIn == null ? void 0 : subFormPropsIn.isDrawToolOn]);
  const onFormValueChange = React__default.useCallback((newValue) => {
    setFormValue((prev) => ({
      ...prev || {},
      ...newValue || {}
    }));
    onFormChangeIn(newValue);
  }, [onFormChangeIn, setFormValue]);
  const onSubFormValueChange = React__default.useCallback((newValue) => {
    setSubFormValue((prev) => ({
      ...prev || {},
      ...newValue || {}
    }));
  }, []);
  const onFeatureSelect = React__default.useCallback((feature2) => {
    setClickedFeatureId(feature2 == null ? void 0 : feature2.id);
    const [updatedSubFormValue] = onFeatureSelectIn(feature2, subFormValue) || [];
    if (updatedSubFormValue)
      onSubFormValueChange(updatedSubFormValue);
  }, [onFeatureSelectIn, onSubFormValueChange, subFormValue]);
  const getRealDrawMode = React__default.useCallback((feature2, drawMode2) => {
    let drawModeOut = drawMode2;
    if (drawMode2 === "select" && (feature2 == null ? void 0 : feature2.id) === clickedFeatureId) {
      if (feature2.properties.category === "footprint")
        drawModeOut = "polygon";
      else if (feature2.properties.category === "marker")
        drawModeOut = "point";
    }
    return drawModeOut;
  }, [clickedFeatureId]);
  const onFeaturesDelete = React__default.useCallback((deletedFeatures) => {
    setClickedFeatureId(null);
    const updatedFeaturesIn = pushArray([], updatedFeatures);
    const importedFeaturesIn = pushArray([], importData == null ? void 0 : importData.features);
    const formValueIn = {
      ...formValue
    };
    deletedFeatures == null ? void 0 : deletedFeatures.forEach((feature2) => {
      let index2 = -1;
      if (feature2.id)
        index2 = updatedFeaturesIn == null ? void 0 : updatedFeaturesIn.findIndex((f2) => f2.id === feature2.id);
      if (index2 < 0)
        index2 = updatedFeaturesIn == null ? void 0 : updatedFeaturesIn.findIndex((f2) => f2.geometry.type === feature2.geometry.type);
      if (index2 > -1) {
        updatedFeaturesIn.splice(index2, 1);
      } else {
        index2 = importedFeaturesIn == null ? void 0 : importedFeaturesIn.findIndex((f2) => f2.id === feature2.id);
        if (index2 > -1) {
          importedFeaturesIn.splice(index2, 1);
        }
      }
    });
    if (updatedFeatures)
      setUpdatedFeatures(updatedFeaturesIn);
    if (importData == null ? void 0 : importData.features)
      setImportData({
        ...importData,
        features: importedFeaturesIn
      });
    if (deletedFeatures == null ? void 0 : deletedFeatures.length) {
      const drawModeOut = getRealDrawMode(deletedFeatures[0], drawMode);
      const result = onFeaturesDeleteIn(deletedFeatures, drawModeOut);
      if (result) {
        const changedFormValue = result[0];
        if (changedFormValue) {
          Object.keys(changedFormValue).forEach((key) => {
            formValueIn[key] = changedFormValue[key];
          });
        }
        const changedDrawMode = result[1];
        if (changedDrawMode) {
          setDrawMode("");
          setTimeout(() => setDrawMode(changedDrawMode), 50);
        }
      }
    }
    onFormValueChange(formValueIn);
  }, [updatedFeatures, importData, formValue, onFormValueChange, getRealDrawMode, drawMode, onFeaturesDeleteIn]);
  const onDrawPressed = React__default.useCallback((drawMode2) => {
    let featureFound = null;
    if (drawMode2 === "polygon")
      ;
    else if (drawMode2 === "point") {
      featureFound = (features == null ? void 0 : features.find((f2) => f2.properties.category === "marker")) || (updatedFeatures == null ? void 0 : updatedFeatures.find((f2) => f2.properties.category === "marker"));
    } else if (drawMode2 === "select" && activeLayerId) {
      featureFound = features == null ? void 0 : features.find((f2) => f2.properties.layer === activeLayerId);
    }
    if (featureFound) {
      onFeatureSelect(featureFound);
      setDrawMode("select");
      setTerritoryType("");
    } else if (drawMode2 === "select-country") {
      setDrawMode("point");
      setTerritoryType("country");
    } else {
      setDrawMode(drawMode2);
      setTerritoryType("");
    }
  }, [activeLayerId, features, updatedFeatures, onFeatureSelect, setTerritoryType]);
  const onDrawModeChange = React__default.useCallback((mode2) => {
    if (mode2 === "export")
      return;
    onDrawPressed(mode2);
  }, [onDrawPressed]);
  const toogleIsDrawToolOn = React__default.useCallback(() => {
    setIsDrawToolOn((previous) => {
      const enableDraw = !previous;
      onDrawPressed((enableDraw ? drawModeIn : "") || "noselect");
      return enableDraw;
    });
  }, [drawModeIn, onDrawPressed]);
  const onUploadPressed = React__default.useCallback((extensions) => {
    setUploadableExtensions(extensions);
  }, []);
  const mergeFeatures = React__default.useCallback((features1In, features2In) => {
    const features1 = features1In && !Array.isArray(features1In) ? [features1In] : features1In;
    const features2 = features2In && !Array.isArray(features2In) ? [features2In] : features2In;
    if (!(features2 == null ? void 0 : features2.length))
      return features1;
    if (!(features1 == null ? void 0 : features1.length))
      return features2;
    const featuresMap = /* @__PURE__ */ new Map();
    features1.forEach((f1) => featuresMap.set(f1.id, f1));
    features2.forEach((f2) => featuresMap.set(f2.id, f2));
    return Array.from(featuresMap.values());
  }, []);
  const allButImportFeatures = React__default.useMemo(() => mergeFeatures(features, updatedFeatures), [features, mergeFeatures, updatedFeatures]);
  const onFeatureChange = React__default.useCallback((feature2) => {
    const drawModeOut = getRealDrawMode(feature2, drawMode);
    const [formValue2, updatedFeature] = onFeatureChangeIn(feature2, drawModeOut, subFormValue, allButImportFeatures) || [];
    onFormValueChange(formValue2);
    if (updatedFeature)
      setUpdatedFeatures((features2) => mergeFeatures(features2, [updatedFeature]));
  }, [allButImportFeatures, drawMode, getRealDrawMode, mergeFeatures, onFeatureChangeIn, onFormValueChange, subFormValue]);
  const onSubFormChange = React__default.useCallback((newSubFormValue) => {
    const theFeature = updatedFeatures.find((f2) => f2.id === clickedFeatureId) || (features == null ? void 0 : features.find((f2) => f2.id === clickedFeatureId)) || pushArray([], updatedFeatures).reverse().find((f2) => f2.properties.drawMode === drawMode);
    onSubFormValueChange(newSubFormValue);
    if (theFeature) {
      const [subFormValue2, updatedFeature] = onSubFormChangeIn(newSubFormValue, theFeature, drawMode) || [];
      onSubFormValueChange(subFormValue2);
      if (updatedFeature) {
        setUpdatedFeatures((features2) => mergeFeatures(features2, updatedFeature));
      }
    } else if (["rectangle", "circle", "polygon", "noselect"].includes(drawMode)) {
      const allUpdatedFeatures = [];
      let subFormValue2;
      allButImportFeatures == null ? void 0 : allButImportFeatures.forEach((theFeature2) => {
        const [returnedSubFormValue, updatedFeature] = onSubFormChangeIn(newSubFormValue, theFeature2, drawMode) || [];
        subFormValue2 = returnedSubFormValue;
        if (updatedFeature) {
          allUpdatedFeatures.push(updatedFeature);
        }
      });
      onSubFormValueChange(subFormValue2);
      setUpdatedFeatures(allUpdatedFeatures);
    }
    setImportData((importData2) => {
      var _a3;
      if (!importData2)
        return importData2;
      const importedFeatures = [];
      let subFormValue2;
      (_a3 = importData2 == null ? void 0 : importData2.features) == null ? void 0 : _a3.forEach((theFeature2) => {
        const [returnedSubFormValue, updatedImportFeature] = onSubFormChangeIn(newSubFormValue, theFeature2, drawMode) || [];
        subFormValue2 = returnedSubFormValue;
        if (updatedImportFeature) {
          importedFeatures.push(updatedImportFeature);
        }
      });
      onSubFormValueChange(subFormValue2);
      return {
        ...importData2,
        features: importedFeatures
      };
    });
  }, [updatedFeatures, features, onSubFormValueChange, drawMode, clickedFeatureId, onSubFormChangeIn, mergeFeatures, allButImportFeatures]);
  const onBoundarySelectorChangeRaw = React__default.useCallback((name2, data2) => {
    if (data2 == null ? void 0 : data2.pointFeature) {
      onFeatureChange({
        ...data2.pointFeature,
        properties: {
          ...data2.pointFeature.properties,
          drawMode: "point"
        }
      });
    }
  }, [onFeatureChange]);
  const onTerritoryChange = useMutableFunc(onBoundarySelectorChangeRaw);
  React__default.useMemo(() => {
    var _a3;
    if (!elementRef.current) {
      if (containerId)
        elementRef.current = document.getElementById(containerId);
      if (!elementRef.current)
        elementRef.current = (_a3 = document.getElementsByClassName("mapboxgl-map")) == null ? void 0 : _a3[0];
    }
  }, [containerId]);
  const {
    toolFeatures,
    allFeatures,
    assets,
    azimuth
  } = React__default.useMemo(() => {
    const {
      assets: assets2,
      features: importedFeatures,
      azimuth: azimuth2
    } = importData || {};
    const allFeatures2 = [...importedFeatures || []];
    allFeatures2.push(...mergeFeatures(features, updatedFeatures) || []);
    const toolFeatures2 = [];
    if (drawMode === "select") {
      if (clickedFeatureId) {
        toolFeatures2.push(...(allFeatures2 || []).filter((f2) => f2.id === clickedFeatureId));
      } else {
        toolFeatures2.push(...allFeatures2 || []);
      }
    } else {
      allFeatures2 == null ? void 0 : allFeatures2.forEach((f2) => {
        var _a3;
        if (((_a3 = f2.properties) == null ? void 0 : _a3.drawMode) === drawMode)
          toolFeatures2.push(f2);
      });
    }
    return {
      toolFeatures: toolFeatures2,
      allFeatures: allFeatures2,
      assets: assets2,
      azimuth: azimuth2
    };
  }, [importData, mergeFeatures, features, updatedFeatures, drawMode, clickedFeatureId]);
  const onFormDone = React__default.useCallback((data2, isCreate) => {
    if (!data2)
      onDoneIn();
    else {
      onDoneIn({
        formValue: data2,
        features: allFeatures,
        subFormValue,
        assets,
        azimuth
      });
      if (data2.objectType) {
        const content = isCreate ? `New ${data2.objectType} has been successfully added` : `${data2.objectType} has been successfully updated`;
        showMessageBox({
          content
        });
      }
    }
  }, [allFeatures, assets, azimuth, onDoneIn, subFormValue]);
  const onSubFormDone = React__default.useCallback((data2) => {
    if (data2)
      onSubFormValueChange(data2);
    else if (!noSubFormCancel)
      onSubFormValueChange(subInitialValue);
    setIsSubFormOpen(false);
  }, [onSubFormValueChange, noSubFormCancel, subInitialValue, setIsSubFormOpen]);
  const onImportDone = React__default.useCallback((data2) => {
    let importData2 = data2;
    if (importData2) {
      if (isAssetImport) {
        onFeaturesImportIn(importData2);
      } else {
        importData2 = {
          ...importData2,
          features: onFeaturesImportIn(importData2.features)
        };
        setImportData(importData2);
      }
    }
    setUploadableExtensions([]);
    setEnableAutoFocus(!!importData2);
    autoFocusRef.current = !!importData2;
    if (isAssetImport && !importData2) {
      onDoneIn();
    }
  }, [onFeaturesImportIn, isAssetImport, onDoneIn]);
  const subFormProps = React__default.useMemo(() => ({
    ...subFormPropsIn || {},
    isDrawToolOn,
    toogleIsDrawToolOn,
    value: subFormValue,
    onChange: onSubFormChange,
    open: isSubFormOpen,
    setOpen: (open2) => {
      setIsSubFormOpen(open2);
      if (open2 && isDrawToolOn) {
        onDrawPressed(drawModeIn || "noselect");
      }
    }
  }), [subFormPropsIn, isDrawToolOn, toogleIsDrawToolOn, subFormValue, onSubFormChange, isSubFormOpen, onDrawPressed, drawModeIn]);
  const extraFormProps = React__default.useMemo(() => {
    if (!embedSubComponent)
      return {};
    return {
      subForm: SubForm,
      subFormProps
    };
  }, [SubForm, embedSubComponent, subFormProps]);
  const territoryStyle = React__default.useMemo(() => {
    const object2 = {};
    if (subFormValue) {
      object2.opacity = subFormValue["fill-opacity"];
      object2.color = subFormValue.fill;
      object2.hoverColor = subFormValue.fill;
      object2.selectColor = subFormValue.fill;
      object2.hoverOpacity = object2.opacity / 3;
      object2.selectOpacity = object2.opacity / 2;
    }
    return object2;
  }, [subFormValue]);
  const hasFeatures = !!(allFeatures == null ? void 0 : allFeatures.length);
  React__default.useLayoutEffect(() => {
    var _a3;
    let values4 = {
      hasFeatures
    };
    if (overrideValue && ((_a3 = Object.keys(overrideValue)) == null ? void 0 : _a3.length)) {
      values4 = {
        hasFeatures,
        ...overrideValue
      };
    }
    onFormValueChange(values4);
  }, [hasFeatures, onFormValueChange, overrideValue]);
  React__default.useEffect(() => {
    if (enableAutoFocus) {
      autoFocusRef.current = false;
      setTimeout(() => setEnableAutoFocus(false), 10);
    }
  }, [enableAutoFocus]);
  const nonTerritories = allFeatures == null ? void 0 : allFeatures.filter((f2) => {
    var _a3;
    return !((_a3 = f2.properties) == null ? void 0 : _a3[territoryPropName]);
  });
  if (!elementRef.current)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    (!SubForm || embedSubComponent || !isSubFormOpen) && createPortal(/* @__PURE__ */ jsx(Form2, { onDone: onFormDone, onDraw: onDrawPressed, onUpload: onUploadPressed, value: formValue, onChange: onFormValueChange, ...extraFormProps, ...formProps }), elementRef.current),
    isSubFormOpen && !embedSubComponent && SubForm && createPortal(/* @__PURE__ */ jsx(SubForm, { onDone: onSubFormDone, value: subFormValue, onChange: onSubFormChange, ...subFormProps, toogleIsDrawToolOn }), elementRef.current),
    drawMode && /* @__PURE__ */ jsx(FeaturesView, { id: "sai-features-view-map-tool-form", drawMode, onChange: onFeatureChange, onSelect: onFeatureSelect, onDelete: onFeaturesDelete, features: nonTerritories, editableFeatures: toolFeatures, displayMode, deviceTypes, ...restProps, children: (isSubFormOpen || !embedSubComponent) && showDrawTools && isDrawToolOn && /* @__PURE__ */ jsx(MapPortal, { containerId, children: /* @__PURE__ */ jsx(DrawToolsMenu, { placement: "top-right", marginVertical: 10, marginHorizontal: 0, drawMode, setDrawMode: onDrawModeChange, ...drawToolsMenuProps }) }) }, drawMode),
    drawMode && (assets == null ? void 0 : assets.map((asset) => /* @__PURE__ */ jsx(
      GeoreferencedAsset,
      {
        drawMode,
        displayMode,
        data: asset,
        enableEdit: false
      },
      asset.id
    ))),
    (uploadableExtensions == null ? void 0 : uploadableExtensions.length) && !isAssetImport && createPortal(/* @__PURE__ */ jsx(ImportData, { onDone: onImportDone, extensions: uploadableExtensions, title: `Floor ${formValue == null ? void 0 : formValue.levelNumber}`, center: center2, materials, tilesetUrl }), elementRef.current),
    isAssetImport && /* @__PURE__ */ jsx(ImportAssets, { isModalOpen: true, handleCloseModal: () => onImportDone(null), onSubmit: onImportDone }),
    territoryType && /* @__PURE__ */ jsx(TerritorySelector, { value: formValue.name, territoryType, onChange: onTerritoryChange, ...territoryStyle }),
    children,
    /* @__PURE__ */ jsx(MapAutoFocus, { enabled: enableAutoFocus, features: allFeatures })
  ] });
}
MapToolForm.propTypes = {
  children: propTypesExports$1.node,
  component: propTypesExports$1.func,
  // form
  subComponent: propTypesExports$1.func,
  embedSubComponent: propTypesExports$1.bool,
  componentProps: propTypesExports$1.object,
  subComponentProps: propTypesExports$1.object,
  noSubFormCancel: propTypesExports$1.bool,
  containerId: propTypesExports$1.string,
  features: propTypesExports$1.array,
  onDone: propTypesExports$1.func,
  onFeaturesImport: propTypesExports$1.func,
  onFeatureSelect: propTypesExports$1.func,
  onFeatureChange: propTypesExports$1.func,
  onFeaturesDelete: propTypesExports$1.func,
  initialValue: propTypesExports$1.object,
  overrideValue: propTypesExports$1.object,
  subInitialValue: propTypesExports$1.object,
  onFormChange: propTypesExports$1.func,
  onSubFormChange: propTypesExports$1.func,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  materials: propTypesExports$1.arrayOf(propTypesExports$1.object),
  showDrawTools: propTypesExports$1.bool,
  tilesetUrl: propTypesExports$1.any,
  territoryType: propTypesExports$1.string,
  setTerritoryType: propTypesExports$1.func,
  territoryPropName: propTypesExports$1.string,
  drawMode: propTypesExports$1.string,
  initialUploadExtensions: propTypesExports$1.array,
  drawToolsMenuProps: propTypesExports$1.object,
  deviceTypes: propTypesExports$1.array
};
MapToolForm.defaultProps = {
  children: null,
  component: null,
  subComponent: null,
  embedSubComponent: false,
  componentProps: {},
  subComponentProps: {},
  noSubFormCancel: false,
  containerId: "",
  features: [],
  onDone: () => {
  },
  onFeaturesImport: (features) => features,
  onFeatureSelect: () => {
  },
  onFeatureChange: () => {
  },
  onFeaturesDelete: () => {
  },
  initialValue: {},
  overrideValue: {},
  subInitialValue: {},
  onFormChange: () => {
  },
  onSubFormChange: () => {
  },
  center: null,
  materials: [],
  showDrawTools: false,
  tilesetUrl: null,
  territoryType: "",
  setTerritoryType: () => {
  },
  territoryPropName: "",
  drawMode: "",
  initialUploadExtensions: [],
  drawToolsMenuProps: {},
  deviceTypes: []
};
const defaultStyleValue = {
  fill: "#0166FF",
  "fill-opacity": 0.6,
  stroke: "#0166FF",
  "stroke-opacity": 1,
  "stroke-width": 1,
  "stroke-dasharray": [1, 0]
};
const markerUrl = Images$1.MapPin;
const newObjectId = "newObject";
function BaseTool(props) {
  var _a3;
  const {
    containerId,
    object: object2,
    onDone: onDoneIn,
    objectType: initialObjectType,
    setObjectType,
    objectTypes,
    getFeatures,
    getFormValue,
    validator: validator2,
    enableBulkUpload,
    getTerritorialFeature,
    componentProps,
    exportType,
    onImport,
    ...restProps
  } = props;
  const activeCountryId = useViewStore((state) => state.activeCountryId);
  const activeRegionId = useViewStore((state) => state.activeRegionId);
  const activeMarketId = useViewStore((state) => state.activeMarketId);
  const activeClusterId = useViewStore((state) => state.activeClusterId);
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const activeLevelId = useViewStore((state) => state.activeLevelId);
  const activeZoneId = useViewStore((state) => state.activeZoneId);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const setActiveFormControl = useViewStore((state) => state.setActiveFormControl);
  const activeFormControl = useViewStore((state) => state.activeFormControl);
  const activeCountry = useSiteStore((state) => {
    var _a4;
    return ((_a4 = state.countries.find((c2) => c2.id === activeCountryId)) == null ? void 0 : _a4.name) || null;
  });
  const deleteFilteredFeatures = useSiteStore((state) => state.deleteFilteredFeatures);
  const mode2 = React__default.useMemo(() => {
    if (activeSubTool == null ? void 0 : activeSubTool.startsWith("create"))
      return "Add";
    if (activeSubTool == null ? void 0 : activeSubTool.startsWith("edit"))
      return "Edit";
    return "";
  }, [activeSubTool]);
  const activeParentIds = useViewStore((state) => state.getActiveParentIds());
  const modeBasedParentIds = mode2 === "Add" || activeSubTool === "editAccessPoint" ? activeParentIds : (_a3 = activeParentIds == null ? void 0 : activeParentIds.slice) == null ? void 0 : _a3.call(activeParentIds, 1);
  const parentBoundaries = useSiteStore((state) => state.getObjectsFootprints(modeBasedParentIds));
  const isUpload = React__default.useMemo(() => !!(activeSubTool == null ? void 0 : activeSubTool.endsWith("Upload")), [activeSubTool]);
  const {
    formValue,
    isCreate,
    id,
    features,
    subFormValue,
    center: center2
  } = React__default.useMemo(() => {
    const isCreate2 = !object2 || !object2.id;
    const id2 = isCreate2 ? newObjectId : object2.id;
    const features2 = getFeatures(isCreate2, object2);
    const styledFeature = (features2 == null ? void 0 : features2.find((feature2) => {
      var _a4;
      return ((_a4 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a4.category) === "footprint";
    })) || (features2 == null ? void 0 : features2.find((feature2) => {
      var _a4;
      return ((_a4 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a4.category) === "marker";
    }));
    const style2 = styledFeature ? {
      ...defaultStyleValue,
      ...getFeatureStyle(styledFeature)
    } : defaultStyleValue;
    const objectType = (object2 == null ? void 0 : object2.objectType) || initialObjectType;
    const formValue2 = getFormValue(isCreate2, object2, {
      country: activeCountry,
      objectType,
      isBulkUpload: enableBulkUpload
    });
    return {
      id: id2,
      isCreate: isCreate2,
      formValue: formValue2,
      features: features2,
      subFormValue: style2,
      center: object2 == null ? void 0 : object2.center
    };
  }, [object2, getFeatures, initialObjectType, getFormValue, activeCountry, enableBulkUpload]);
  const [isBulkUpload, setIsBulkUpload] = React__default.useState(isCreate && enableBulkUpload);
  const isCountry = (formValue == null ? void 0 : formValue.objectType) === "country";
  const isNoUpload = isCountry;
  const overrideValue = React__default.useMemo(() => {
    if (activeFormControl == null ? void 0 : activeFormControl[initialObjectType]) {
      return {
        name: activeFormControl[initialObjectType]
      };
    }
    if (isUpload && (activeFormControl == null ? void 0 : activeFormControl.upload)) {
      return {
        name: activeFormControl.upload
      };
    }
    return {};
  }, [activeFormControl, initialObjectType, isUpload]);
  const disabled = React__default.useMemo(() => ({
    objectType: !isCreate
    // disable change of object type in 'Edit'
  }), [isCreate]);
  const hidden = React__default.useMemo(() => ({
    name: true,
    // isBulkUpload && !isNoUpload,
    isBulkUpload: true,
    // Probably, there is no need for user input
    upload: isNoUpload
  }), [isNoUpload]);
  const getKnownFeatureIds = React__default.useCallback((feature2) => {
    const tempMarkerId = `${id}-temp-marker`;
    const tempFootprintId = `${id}-temp-footprint`;
    const existingMarker = features == null ? void 0 : features.find((f2) => f2.id === feature2.id && f2.properties.category === "marker");
    const existingFootprint = features == null ? void 0 : features.find((f2) => f2.id === feature2.id && f2.properties.category === "footprint");
    return {
      markerId: (existingMarker == null ? void 0 : existingMarker.id) || tempMarkerId,
      footprintId: (existingFootprint == null ? void 0 : existingFootprint.id) || tempFootprintId,
      tempFootprintId,
      tempMarkerId
    };
  }, [features, id]);
  const onFeaturesImport = React__default.useCallback((featuresIn) => {
    var _a4;
    if (!(featuresIn == null ? void 0 : featuresIn.length)) {
      return featuresIn;
    }
    const features2 = featuresIn.map((f2) => {
      var _a5;
      const feature22 = {
        ...f2,
        properties: {
          ...f2.properties
        }
      };
      if (feature22.geometry.type === "Point" && !((_a5 = feature22 == null ? void 0 : feature22.properties) == null ? void 0 : _a5.territoryType)) {
        feature22.properties.category = "marker";
      } else if (feature22.geometry.type === "Polygon") {
        feature22.properties.category = "footprint";
      } else if (feature22.geometry.type === "LineString")
        ;
      if (feature22.name || feature22.properties.name) {
        feature22.name = feature22.name || feature22.properties.name;
      }
      return feature22;
    });
    if ((features2 == null ? void 0 : features2.length) === 1) {
      return features2;
    }
    if (isBulkUpload) {
      return features2;
    }
    const feature2 = features2.find((f2) => f2.geometry.type !== "Point") || features2[0];
    const {
      tempFootprintId,
      tempMarkerId
    } = getKnownFeatureIds(feature2);
    if (feature2.geometry.type === "Point") {
      feature2.id = tempMarkerId;
      if (!((_a4 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a4.territoryType))
        feature2.properties.category = "marker";
    } else if (feature2.geometry.type === "Polygon") {
      feature2.id = tempFootprintId;
      feature2.properties.category = "footprint";
    }
    return [feature2];
  }, [getKnownFeatureIds, isBulkUpload]);
  const onObjectTypeChange = React__default.useCallback((data2) => {
    if (!isCreate)
      return;
    if (!(data2 == null ? void 0 : data2.objectType))
      return;
    setObjectType(data2.objectType);
    if (enableBulkUpload)
      setIsBulkUpload(data2.isBulkUpload);
    if (data2.name) {
      setActiveFormControl(data2.objectType, data2.name);
    }
  }, [enableBulkUpload, isCreate, setObjectType, setActiveFormControl]);
  const onStyleChange = React__default.useCallback((style2, feature2) => {
    if (!style2 || !feature2)
      return [style2, feature2];
    if (feature2) {
      let updatedStyle;
      if (feature2.properties.category === "marker" || feature2.properties.type === "point") {
        updatedStyle = {
          // stroke: '#0166FF',
          // 'stroke-opacity': 1.0,
          // 'fill-opacity': 1.0,
          // fill: 'blue',
          // 'stroke-width': 2,
          "marker-symbol": markerUrl
        };
      } else {
        updatedStyle = {
          stroke: style2 == null ? void 0 : style2.stroke,
          "stroke-opacity": style2 == null ? void 0 : style2["stroke-opacity"],
          "fill-opacity": style2 == null ? void 0 : style2["fill-opacity"],
          fill: style2 == null ? void 0 : style2.fill,
          "stroke-width": style2 == null ? void 0 : style2["stroke-width"],
          "stroke-dasharray": style2 == null ? void 0 : style2["stroke-dasharray"]
        };
      }
      feature2 = {
        ...feature2
      };
      feature2.properties = {
        ...feature2.properties || {},
        ...updatedStyle
      };
    }
    return [style2, feature2];
  }, []);
  const onFeatureSelect = React__default.useCallback((feature2, style2) => {
    if (!feature2)
      return null;
    if (!style2)
      return [{}, feature2];
    return [getFeatureStyle(feature2), feature2];
  }, []);
  const onFeatureChange = React__default.useCallback((feature2, drawMode, style2, allFeatures) => {
    var _a4, _b3, _c2;
    if (!feature2)
      return null;
    const {
      markerId,
      footprintId
    } = getKnownFeatureIds(feature2);
    feature2.properties.drawMode = drawMode;
    if ((parentBoundaries == null ? void 0 : parentBoundaries.length) && !FeatureHelper.isFeatureInBoundaries(feature2, parentBoundaries)) {
      message$1.error("Ensure that feature(s) are within limits");
      return null;
    }
    if (drawMode === "point") {
      const coord = ((_a4 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a4.type) === "Point" ? feature2.geometry.coordinates : null;
      if (coord) {
        feature2.id = markerId;
        if ((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.territoryType) {
          feature2.properties.category = "footprint";
          feature2.properties.visible = false;
          const name2 = (_c2 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _c2.name;
          if (name2) {
            setActiveFormControl(feature2.properties.territoryType, name2);
            return [{
              name: name2
            }, feature2];
          }
        } else {
          feature2.properties.category = "marker";
          feature2.properties["marker-symbol"] = markerUrl;
          const position = {
            longitude: truncateDecimal(coord[0]),
            latitude: truncateDecimal(coord[1])
          };
          return [position, feature2];
        }
      }
    } else if (["rectangle", "circle", "polygon"].includes(drawMode)) {
      const foundFootprint = allFeatures == null ? void 0 : allFeatures.find((f2) => f2.properties.category === "footprint");
      feature2.id = (foundFootprint == null ? void 0 : foundFootprint.id) || footprintId;
      feature2.properties.category = "footprint";
      return onStyleChange(style2, feature2);
    } else if (drawMode === "select") {
      if (!feature2)
        return null;
      return onStyleChange(style2, feature2);
    }
    return null;
  }, [getKnownFeatureIds, onStyleChange, setActiveFormControl, parentBoundaries]);
  const onFeaturesDelete = React__default.useCallback((features2, drawMode) => {
    if (!(features2 == null ? void 0 : features2.length))
      return [];
    let result = [];
    if (drawMode === "point") {
      const formValue2 = {
        longitude: void 0,
        latitude: void 0
      };
      result = [formValue2, "point"];
    } else if (drawMode === "polygon") {
      result = [null, "polygon"];
    }
    const {
      id: id2,
      type
    } = object2 || {};
    const filter17 = (feature2) => !!features2.find((f2) => f2.id === feature2.id);
    if (id2 && type)
      deleteFilteredFeatures({
        parentId: id2,
        parentType: type
      }, filter17);
    return result;
  }, [deleteFilteredFeatures, object2]);
  const onExport = React__default.useCallback(() => {
    setActiveSubTool(exportType);
  }, [setActiveSubTool, exportType]);
  const onDone = React__default.useCallback((data2) => {
    const {
      formValue: values4,
      features: allFeatures,
      subFormValue: subFormValue2,
      assets
    } = data2 || {};
    const isBulkUpload2 = enableBulkUpload && (values4 == null ? void 0 : values4.isBulkUpload);
    if ((values4 == null ? void 0 : values4.name) || isBulkUpload2) {
      const {
        objectType
      } = values4;
      if (objectType === "country") {
        const feature2 = getTerritorialFeature(values4);
        if (feature2) {
          const {
            footprintId
          } = getKnownFeatureIds(feature2);
          feature2.id = footprintId;
          allFeatures.unshift(feature2);
        }
      }
      const features2 = [];
      let isInLimits = true;
      allFeatures.forEach((afeature, index2) => {
        if (objectType === "country" && index2 > 0)
          return;
        const feature2 = {
          ...afeature,
          properties: {
            ...afeature.properties
          }
        };
        const {
          footprintId,
          markerId,
          tempMarkerId,
          tempFootprintId
        } = getKnownFeatureIds(feature2);
        const isFootprint = feature2.id === footprintId;
        const isCenter = feature2.id === markerId;
        if (isFootprint || isCenter || isBulkUpload2 || isUpload) {
          if (feature2.id === tempMarkerId || feature2.id === tempFootprintId) {
            feature2.id = generateUid();
          }
          const style2 = {
            ...defaultStyleValue,
            ...subFormValue2 || {}
          };
          applyFeatureStyle(feature2, style2);
          if (isCenter) {
            if (objectType !== "accessPoint") {
              STYLE_PROPS.forEach((s2) => {
                delete feature2.properties[s2];
              });
            }
            feature2.properties["marker-symbol"] = markerUrl;
          }
          if (isFootprint) {
            STYLE_PROPS.forEach((s2) => {
              if (s2.startsWith("marker") || s2.startsWith("text")) {
                delete feature2.properties[s2];
              }
            });
          }
          if ((parentBoundaries == null ? void 0 : parentBoundaries.length) && !FeatureHelper.isFeatureInBoundaries(feature2, parentBoundaries)) {
            isInLimits = false;
          }
          features2.push(feature2);
        }
      });
      if (!isInLimits) {
        message$1.error("Ensure that feature(s) are within limits");
        return;
      }
      const ids = {
        countryId: activeCountryId,
        regionId: activeRegionId,
        marketId: activeMarketId,
        clusterId: activeClusterId,
        venueId: activeVenueId,
        buildingId: activeBuildingId,
        levelId: activeLevelId,
        zoneId: activeZoneId
      };
      Object.keys(ids).forEach((key) => {
        if (!ids[key]) {
          delete ids[key];
        } else if (key === `${objectType}Id`) {
          delete ids[key];
        }
      });
      ids.id = isCreate ? null : id;
      const objects = isBulkUpload2 && features2.length ? features2.map((obj) => ({
        ...values4,
        // values are coming from form
        ...obj,
        // obj/feature might have name and id
        features: [obj]
      })) : [{
        ...values4,
        features: features2,
        assets
      }];
      onDoneIn(objects, ids);
    } else {
      onDoneIn();
    }
  }, [enableBulkUpload, activeCountryId, activeRegionId, activeMarketId, activeClusterId, activeVenueId, activeBuildingId, activeLevelId, activeZoneId, getTerritorialFeature, isCreate, onDoneIn, id, getKnownFeatureIds, isUpload, parentBoundaries]);
  return /* @__PURE__ */ jsx(
    MapToolForm,
    {
      containerId,
      embedSubComponent: true,
      initialValue: formValue,
      overrideValue,
      subInitialValue: subFormValue,
      center: center2,
      componentProps: {
        mode: mode2,
        objectTypes,
        disabled,
        hidden,
        validator: validator2,
        onExport,
        ...componentProps
      },
      subComponentProps: {
        isDrawToolOn: isCreate && !isCountry,
        hidden: {
          edit: isCreate || isCountry
        }
      },
      features,
      onDone,
      onFeaturesImport: onImport ?? onFeaturesImport,
      onFeatureSelect,
      onFeatureChange,
      onFeaturesDelete,
      onFormChange: onObjectTypeChange,
      onSubFormChange: onStyleChange,
      ...restProps
    }
  );
}
BaseTool.propTypes = {
  containerId: propTypesExports$1.string,
  object: propTypesExports$1.object,
  componentProps: propTypesExports$1.object,
  onDone: propTypesExports$1.func,
  objectType: propTypesExports$1.string,
  setObjectType: propTypesExports$1.func,
  objectTypes: propTypesExports$1.array,
  transformObjectToFormValue: propTypesExports$1.func,
  getTerritorialFeature: propTypesExports$1.func,
  validator: propTypesExports$1.func,
  enableBulkUpload: propTypesExports$1.bool,
  drawMode: propTypesExports$1.string,
  showDrawTools: propTypesExports$1.bool,
  drawToolsMenuProps: propTypesExports$1.object,
  getFeatures: propTypesExports$1.func,
  getFormValue: propTypesExports$1.func,
  exportType: propTypesExports$1.string,
  onImport: propTypesExports$1.func
};
BaseTool.defaultProps = {
  containerId: "",
  object: null,
  componentProps: {},
  onDone: () => {
  },
  objectType: "venue",
  setObjectType: () => {
  },
  objectTypes: [],
  transformObjectToFormValue: (obj) => obj,
  getTerritorialFeature: () => {
  },
  validator: () => {
  },
  enableBulkUpload: false,
  drawMode: "polygon",
  showDrawTools: true,
  drawToolsMenuProps: {
    hidden: {
      line: true,
      point: true,
      noselect: true
    }
  },
  getFeatures: () => [],
  getFormValue: () => ({}),
  exportType: "exportMcr",
  onImport: null
};
function VenueTool(props) {
  const {
    onDone: onDoneIn,
    ...restProps
  } = props;
  const addToCollection = useSiteStore((state) => state.addToCollection);
  const updateFeature = useSiteStore((state) => state.updateFeature);
  const setActiveVenueId = useViewStore((state) => state.setActiveVenueId);
  const setEnableVenueSubTree = useViewStore((state) => state.setEnableVenueSubTree);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const loadBulkAssets = useAssetStore((state) => state.loadUpdate);
  const createBuildingActionRef = React__default.useRef(false);
  const afterDoneAction = React__default.useCallback(() => {
    if (createBuildingActionRef.current) {
      setEnableVenueSubTree(true);
      setActiveSubTool("createBuilding");
    }
  }, [setActiveSubTool, setEnableVenueSubTree]);
  const getFeatures = React__default.useCallback((isCreate, object2) => {
    const features = isCreate ? void 0 : object2 == null ? void 0 : object2.allFeatures;
    return features;
  }, []);
  const getFormValue = React__default.useCallback((isCreate, object2, defaultValue2) => {
    const formValue = isCreate ? defaultValue2 : VenueInfo.getFormValues(object2);
    return formValue;
  }, []);
  const onDone = React__default.useCallback((objects, ids) => {
    if (!(objects == null ? void 0 : objects.length)) {
      onDoneIn();
      return;
    }
    objects.forEach((values4, index2, array2) => {
      addToCollection("venue", {
        ...ids,
        name: values4.name || "Untitled",
        center: [values4.longitude, values4.latitude],
        venueType: values4.venueType,
        address: {
          addressLine1: values4.addressLine1,
          addressLine2: values4.addressLine2,
          city: values4.city,
          country: values4.country,
          postalCode: values4.postalCode,
          state: values4.state
        },
        thumbnail: values4.thumbnail,
        temporaryEvent: values4.temporaryEvent
      }, (venueId) => {
        var _a3;
        loadBulkAssets({
          assets: (_a3 = values4.assets) == null ? void 0 : _a3.map((asset) => ({
            ...asset,
            parentId: venueId,
            parentType: "venue",
            category: "asset"
          }))
        });
        values4.features.forEach((feature2) => {
          feature2.properties.parentId = venueId;
          feature2.properties.parentType = "venue";
          updateFeature({
            feature: feature2,
            parentId: venueId,
            category: feature2.properties.category,
            parentType: "venue"
          });
        });
        if (array2.length - 1 === index2) {
          setActiveVenueId(venueId);
          onDoneIn(venueId);
          afterDoneAction();
        }
      });
    });
  }, [onDoneIn, addToCollection, loadBulkAssets, updateFeature, setActiveVenueId, afterDoneAction]);
  const onAddBuilding = React__default.useCallback(() => {
    createBuildingActionRef.current = true;
  }, []);
  return /* @__PURE__ */ jsx(BaseTool, { component: VenueForm, subComponent: StyleForm, getFeatures, getFormValue, onDone, enableBulkUpload: false, componentProps: {
    onAddBuilding
  }, ...restProps });
}
VenueTool.propTypes = {
  onDone: propTypesExports$1.func,
  objectType: propTypesExports$1.string
};
VenueTool.defaultProps = {
  onDone: () => {
  },
  objectType: "venue"
};
function IoCheckboxOutline(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M352 176L217.6 336 160 272" } }, { "tag": "rect", "attr": { "width": "384", "height": "384", "x": "64", "y": "64", "fill": "none", "strokeLinejoin": "round", "strokeWidth": "32", "rx": "48", "ry": "48" } }] })(props);
}
function IoImageOutline(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "rect", "attr": { "width": "416", "height": "352", "x": "48", "y": "80", "fill": "none", "strokeLinejoin": "round", "strokeWidth": "32", "rx": "48", "ry": "48" } }, { "tag": "circle", "attr": { "cx": "336", "cy": "176", "r": "32", "fill": "none", "strokeMiterlimit": "10", "strokeWidth": "32" } }, { "tag": "path", "attr": { "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M304 335.79l-90.66-90.49a32 32 0 00-43.87-1.3L48 352m176 80l123.34-123.34a32 32 0 0143.11-2L464 368" } }] })(props);
}
const {
  Title: Title$9
} = Typography;
const {
  useToken: useToken$7
} = theme$2;
const otherAreasOptions = [{
  key: "basement",
  label: "Basement",
  value: "basement"
}, {
  key: "parking",
  label: "Parking",
  value: "parking"
}, {
  key: "rooftop",
  label: "Rooftop",
  value: "rooftop"
}, {
  key: "attic",
  label: "Attic",
  value: "attic"
}, {
  key: "terrace",
  label: "Terrace",
  value: "terrace"
}];
const EXTENSIONS$3 = ["png", "jpg"];
function BuildingForm(props) {
  const {
    onDone,
    onDraw,
    value: valueIn,
    onChange,
    onUpload,
    mode: mode2,
    subForm: SubForm,
    subFormProps,
    disabled,
    hidden,
    objectTypes,
    onExport
  } = props;
  const {
    token
  } = useToken$7();
  const isCreate = mode2 === "Add";
  const formTitle = React__default.useMemo(() => {
    if (!mode2)
      return null;
    const mode22 = isCreate ? "New" : mode2;
    return isCreate ? mode22 : `${mode22} Building`;
  }, [mode2, isCreate]);
  const data2 = React__default.useMemo(() => {
    if (!valueIn)
      return null;
    const formData = {
      ...valueIn,
      heightInputLength: {
        lengthInMeter: valueIn == null ? void 0 : valueIn.height,
        displayUnit: (valueIn == null ? void 0 : valueIn.heightUnit) || "m"
      },
      elevationInputLength: {
        lengthInMeter: valueIn == null ? void 0 : valueIn.elevation,
        displayUnit: (valueIn == null ? void 0 : valueIn.elevationUnit) || "m"
      }
    };
    return formData;
  }, [valueIn]);
  const getHeightElevationInfo = React__default.useCallback((data22) => {
    const {
      lengthInMeter: height,
      displayUnit: heightUnit
    } = (data22 == null ? void 0 : data22.heightInputLength) || {};
    const {
      lengthInMeter: elevation,
      displayUnit: elevationUnit
    } = (data22 == null ? void 0 : data22.elevationInputLength) || {};
    return {
      height,
      heightUnit,
      elevation,
      elevationUnit
    };
  }, []);
  const onFormValuesChange = React__default.useCallback((data22) => {
    const {
      height,
      heightUnit,
      elevation,
      elevationUnit
    } = getHeightElevationInfo(data22);
    onChange({
      ...data22 || {},
      height,
      heightUnit,
      elevation,
      elevationUnit
    });
  }, [onChange, getHeightElevationInfo]);
  const onSubmit = React__default.useCallback((values4) => {
    const {
      height,
      heightUnit,
      elevation,
      elevationUnit
    } = getHeightElevationInfo(values4);
    const finalValues = {
      ...values4 || {},
      height,
      heightUnit,
      elevation,
      elevationUnit
    };
    delete finalValues.heightInputLength;
    delete finalValues.elevationInputLength;
    onDone(finalValues, mode2 === "Add");
  }, [getHeightElevationInfo, onDone, mode2]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title$9, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: formTitle }), [formTitle]);
  const validateBuildingData = React__default.useCallback(async () => {
    if (data2.numLevelsInUse > data2.numLevels) {
      throw new Error("Value exceeded total number of floors");
    }
    if (data2.numLevelsInUse < 0) {
      throw new Error("Negative value not allowed");
    }
    if (data2.height < data2.elevation) {
      throw new Error("Elevation cannot be greater than height");
    }
  }, [data2]);
  const validateHasFeatures = React__default.useCallback(async () => {
    if (data2 == null ? void 0 : data2.hasFeatures)
      return;
    throw new Error("Draw or Import new features to the layer");
  }, [data2 == null ? void 0 : data2.hasFeatures]);
  const component = React__default.useCallback((params2) => {
    const newParams = {
      ...params2,
      exportDetails: !isCreate ? {
        onClick: onExport,
        hidden: hidden.download,
        disabled: disabled.download,
        rules: [{
          validator: validateHasFeatures
        }]
      } : null,
      importDetails: isCreate ? {
        onClick: () => onUpload(EXTENSIONS$3),
        hidden: hidden.upload,
        disabled: disabled.upload,
        rules: [{
          validator: validateHasFeatures
        }]
      } : null
    };
    return /* @__PURE__ */ jsx(RightPanel, { ...newParams, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}) });
  }, [isCreate, onUpload, hidden.download, disabled.download, hidden.upload, disabled.upload, onExport, validateHasFeatures]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(
    ModalForm,
    {
      component,
      title,
      onCancel: () => onDone(),
      onSubmit,
      active: true,
      showErrors: true,
      formValues: data2,
      onChange: onFormValuesChange,
      marginVertical: 0,
      marginHorizontal: 0,
      bodyStyle: {
        padding: "8px 0px 0px 0px"
      },
      footerStyle: {
        width: "100%",
        padding: "0px 24px"
      },
      children: [
        /* @__PURE__ */ jsx(Section, { border: false, children: /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", initialValue: "building", hidden: hidden.objectType, children: /* @__PURE__ */ jsx(Select, { placeholder: "Layer Type", data: objectTypes, value: data2.objectType, disabled: disabled.objectType }) }) }),
        /* @__PURE__ */ jsxs(Section, { title: SubForm ? "Building Boundaries" : "Building Settings", children: [
          SubForm && /* @__PURE__ */ jsx(SubForm, { ...subFormProps }),
          !(subFormProps == null ? void 0 : subFormProps.open) && /* @__PURE__ */ jsx(Form.Item, { name: "draw", style: {
            marginBottom: "8px"
          }, children: /* @__PURE__ */ jsxs(Button, { type: "primary", ghost: true, icon: /* @__PURE__ */ jsx(Icons.PenIconDark, { style: {
            fontSize: "15px",
            color: "transparent"
          } }), onClick: () => {
            var _a3;
            return (_a3 = subFormProps == null ? void 0 : subFormProps.setOpen) == null ? void 0 : _a3.call(subFormProps, true);
          }, children: [
            mode2 === "Add" ? "Draw" : "Show",
            " boundaries"
          ] }) }),
          /* @__PURE__ */ jsx(Form.Item, { name: "import", children: /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, icon: /* @__PURE__ */ jsx(DownloadOutlined, { style: {
            fontSize: "15px",
            color: token.colorPrimary
          } }), onClick: () => onUpload(EXTENSIONS$3), children: "Import 3D Model" }) })
        ] }),
        /* @__PURE__ */ jsx(Section, { border: false, children: /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Building Name", rules: [{
          required: true
        }], hidden: hidden.name, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter name", filled: true }) }) }),
        /* @__PURE__ */ jsxs(Section, { title: "Building Configuration", children: [
          /* @__PURE__ */ jsxs(Row, { gutter: 8, children: [
            /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsx(Form.Item, { name: "numLevels", label: "Total Floors", rules: [{
              required: true
            }], children: /* @__PURE__ */ jsx(InputNumber, { style: {
              width: "100%"
            }, filled: true }) }) }),
            /* @__PURE__ */ jsx(Col, { span: 12, children: /* @__PURE__ */ jsx(Form.Item, { name: "numLevelsInUse", label: "Floors in Use", rules: [{
              required: true
            }, {
              validator: validateBuildingData
            }], children: /* @__PURE__ */ jsx(InputNumber, { style: {
              width: "100%"
            }, filled: true }) }) })
          ] }),
          /* @__PURE__ */ jsx(Form.Item, { name: "heightInputLength", label: /* @__PURE__ */ jsxs(Row, { children: [
            /* @__PURE__ */ jsx(Typography.Text, { children: "Building Height" }),
            /* @__PURE__ */ jsx(Typography.Text, { style: {
              color: token.colorTextDescription,
              paddingLeft: "4px"
            }, children: "(optional)" })
          ] }), children: /* @__PURE__ */ jsx(InputLength, { parentId: "building-height", filled: true }) }),
          /* @__PURE__ */ jsx(Form.Item, { name: "elevationInputLength", label: /* @__PURE__ */ jsxs(Row, { children: [
            /* @__PURE__ */ jsx(Typography.Text, { children: "Elevation" }),
            /* @__PURE__ */ jsx(Tooltip$1, { title: "Building Elevation", children: /* @__PURE__ */ jsx(QuestionCircleOutlined, { style: {
              color: token.colorIcon,
              paddingLeft: "4px"
            } }) })
          ] }), rules: [{
            validator: validateBuildingData
          }], children: /* @__PURE__ */ jsx(InputLength, { parentId: "building-elevation", filled: true }) }),
          /* @__PURE__ */ jsx(Form.Item, { name: "otherAreas", label: /* @__PURE__ */ jsxs(Row, { children: [
            /* @__PURE__ */ jsx(Typography.Text, { children: "Other Areas" }),
            /* @__PURE__ */ jsx(Typography.Text, { style: {
              color: token.colorTextDescription,
              paddingLeft: "4px"
            }, children: "(optional)" })
          ] }), children: /* @__PURE__ */ jsx(Select, { style: {
            width: "100%"
          }, mode: "multiple", allowClear: true, showSearch: true, data: otherAreasOptions, menuItemSelectedIcon: /* @__PURE__ */ jsx(IoCheckboxOutline, {}), placeholder: "Specify other areas" }) })
        ] }),
        /* @__PURE__ */ jsx(Section, { border: false, children: /* @__PURE__ */ jsx(
          AddressPicker,
          {
            onDraw,
            value: data2,
            onChange: onFormValuesChange,
            disableCountry: true,
            disableCity: true,
            disableState: true
          }
        ) })
      ]
    }
  );
}
BuildingForm.propTypes = {
  onDone: propTypesExports$1.func,
  onDraw: propTypesExports$1.func,
  onUpload: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object,
  mode: propTypesExports$1.string,
  subForm: propTypesExports$1.any,
  subFormProps: propTypesExports$1.object,
  disabled: propTypesExports$1.object,
  hidden: propTypesExports$1.object,
  objectTypes: propTypesExports$1.array,
  onExport: propTypesExports$1.func
};
BuildingForm.defaultProps = {
  onDone: () => {
  },
  onDraw: () => {
  },
  onUpload: () => {
  },
  onChange: () => {
  },
  onExport: () => {
  },
  value: {},
  mode: null,
  subForm: null,
  subFormProps: {},
  disabled: {},
  hidden: {},
  objectTypes: []
};
function Section(props) {
  const {
    title,
    children,
    border
  } = props;
  const {
    token
  } = useToken$7();
  return /* @__PURE__ */ jsx("div", { style: {
    padding: "0px 24px",
    borderBottom: border ? `1px solid ${token.colorSplit}` : "none"
  }, children: /* @__PURE__ */ jsxs("div", { style: {
    marginBottom: border ? "16px" : "0px"
  }, children: [
    /* @__PURE__ */ jsx(Row, { style: {
      height: border ? "32px" : null,
      padding: "4px 0px"
    }, children: title && /* @__PURE__ */ jsx(Typography.Text, { style: {
      fontColor: token.colorTextSecondary,
      fontWeight: token.fontWeightStrong,
      fontSize: "14px"
    }, children: title }) }),
    children
  ] }) });
}
Section.propTypes = {
  title: propTypesExports$1.string,
  children: propTypesExports$1.any,
  border: propTypesExports$1.bool
};
Section.defaultProps = {
  title: null,
  children: null,
  border: true
};
const {
  Text: Text$7
} = Typography;
const textColor$3 = {
  border: "none"
};
function getFormValues$3(object2) {
  var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h;
  if (!object2)
    return {};
  return {
    id: object2.id,
    objectType: object2.objectType,
    name: object2.name,
    buildingType: object2.buildingType,
    longitude: (_a3 = object2.center) == null ? void 0 : _a3[0],
    latitude: (_b3 = object2.center) == null ? void 0 : _b3[1],
    venueId: object2.venueId,
    addressLine1: (_c2 = object2.address) == null ? void 0 : _c2.addressLine1,
    addressLine2: (_d2 = object2.address) == null ? void 0 : _d2.addressLine2,
    city: (_e2 = object2.address) == null ? void 0 : _e2.city,
    country: (_f3 = object2.address) == null ? void 0 : _f3.country,
    postalCode: (_g = object2.address) == null ? void 0 : _g.postalCode,
    state: (_h = object2.address) == null ? void 0 : _h.state,
    numLevels: object2.numLevels,
    numLevelsInUse: object2.numLevelsInUse,
    otherAreas: object2.otherAreas,
    height: object2.height,
    heightUnit: object2.heightUnit,
    elevation: object2.elevation,
    elevationUnit: object2.elevationUnit
  };
}
function BuildingInfo(props) {
  const {
    onDone,
    object: object2
  } = props;
  const {
    formValue,
    id
  } = React__default.useMemo(() => {
    if (!object2)
      return {};
    const formValue2 = getFormValues$3(object2);
    return {
      id: object2.id,
      formValue: formValue2
    };
  }, [object2]);
  if (!formValue) {
    return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Building Information", onDone, children: [
      /* @__PURE__ */ jsx(Empty, {}),
      " "
    ] }, "null");
  }
  return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Building Information", onDone, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", children: /* @__PURE__ */ jsx(Text$7, { style: {
      ...textColor$3
    }, children: formValue.objectType }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Building Name", children: /* @__PURE__ */ jsx(Text$7, { style: {
      ...textColor$3
    }, children: formValue.name }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "addressLine1", label: "Address 1", children: /* @__PURE__ */ jsxs(Text$7, { style: {
      ...textColor$3
    }, children: [
      formValue.addressLine1 && `${formValue.addressLine1}, `,
      formValue.addressLine2 && `${formValue.addressLine2}, `,
      formValue.postalCode
    ] }) }),
    /* @__PURE__ */ jsxs(Row, { gutter: [16, 16], children: [
      /* @__PURE__ */ jsxs(Col, { span: 12, children: [
        /* @__PURE__ */ jsx(Form.Item, { name: "latitude", label: "Latitude", children: /* @__PURE__ */ jsx(Text$7, { style: {
          ...textColor$3
        }, children: formValue.latitude }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "numLevels", label: "Total Floors", children: /* @__PURE__ */ jsx(Text$7, { style: {
          ...textColor$3
        }, children: formValue.numLevels }) })
      ] }),
      /* @__PURE__ */ jsxs(Col, { span: 12, children: [
        /* @__PURE__ */ jsx(Form.Item, { name: "longitude", label: "Longitude", children: /* @__PURE__ */ jsx(Text$7, { style: {
          ...textColor$3
        }, children: formValue.longitude }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "numLevelsInUse", label: "Floors in Use", children: /* @__PURE__ */ jsx(Text$7, { style: {
          ...textColor$3
        }, children: formValue.numLevelsInUse }) })
      ] })
    ] })
  ] }, id);
}
BuildingInfo.propTypes = {
  onDone: propTypesExports$1.func,
  object: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    name: propTypesExports$1.string,
    venueId: propTypesExports$1.string,
    center: propTypesExports$1.array,
    elevation: propTypesExports$1.number,
    elevationUnit: propTypesExports$1.string,
    allFeatures: propTypesExports$1.array,
    height: propTypesExports$1.number,
    heightUnit: propTypesExports$1.string,
    address: propTypesExports$1.object,
    otherAreas: propTypesExports$1.string,
    buildingType: propTypesExports$1.string,
    numLevels: propTypesExports$1.number,
    numLevelsInUse: propTypesExports$1.number,
    visibleFeatures: propTypesExports$1.array
  })
};
BuildingInfo.defaultProps = {
  onDone: () => {
  },
  object: {}
};
BuildingInfo.getFormValues = getFormValues$3;
function BuildingTool(props) {
  const {
    onDone: onDoneIn,
    ...restProps
  } = props;
  const addToCollection = useSiteStore((state) => state.addToCollection);
  const updateFeature = useSiteStore((state) => state.updateFeature);
  const setActiveBuildingId = useViewStore((state) => state.setActiveBuildingId);
  const setActiveLevelId = useViewStore((state) => state.setActiveLevelId);
  const loadBulkAssets = useAssetStore((state) => state.loadUpdate);
  const getFeatures = React__default.useCallback((isCreate, object2) => {
    const features = isCreate ? void 0 : object2 == null ? void 0 : object2.allFeatures;
    return features;
  }, []);
  const getFormValue = React__default.useCallback((isCreate, object2, defaultValue2) => {
    const formValue = isCreate ? defaultValue2 : BuildingInfo.getFormValues(object2);
    return formValue;
  }, []);
  const onDone = React__default.useCallback((objects, ids) => {
    if (!(objects == null ? void 0 : objects.length)) {
      onDoneIn();
      return;
    }
    objects.forEach((values4, index2, array2) => {
      var _a3, _b3;
      const {
        id
      } = ids;
      const existingLevelsInUse = !id ? 0 : ((_b3 = (_a3 = useSiteStore.getState().levels) == null ? void 0 : _a3.filter((l2) => l2.buildingId === id)) == null ? void 0 : _b3.length) || 0;
      const requestedNumLevelsInUse = values4.numLevelsInUse || 0;
      const numLevelsInUse = Math.max(requestedNumLevelsInUse, existingLevelsInUse);
      const newLevelsInUse = numLevelsInUse - existingLevelsInUse;
      const numLevels = Math.max(numLevelsInUse, values4.numLevels);
      if (requestedNumLevelsInUse < existingLevelsInUse) {
        message$1.warning("To reduce the Floors in Use delete the specific floor");
      } else if (values4.numLevels < numLevels) {
        message$1.warning("Total Floors cannot be smaller than Floors in Use");
      }
      addToCollection("building", {
        ...ids,
        name: values4.name,
        center: [values4.longitude, values4.latitude],
        address: {
          addressLine1: values4.addressLine1,
          addressLine2: values4.addressLine2,
          postalCode: values4.postalCode
        },
        numLevels,
        otherAreas: values4.otherAreas,
        height: values4.height,
        heightUnit: values4.heightUnit,
        elevation: values4.elevation,
        elevationUnit: values4.elevationUnit
      }, (buildingId) => {
        var _a4;
        loadBulkAssets({
          assets: (_a4 = values4.assets) == null ? void 0 : _a4.map((asset) => ({
            ...asset,
            parentId: buildingId,
            parentType: "building",
            category: "asset"
          }))
        });
        values4.features.forEach((feature2) => {
          feature2.properties.parentId = buildingId;
          feature2.properties.parentType = "building";
          updateFeature({
            feature: feature2,
            parentId: buildingId,
            category: feature2.properties.category,
            parentType: "building"
          });
        });
        let recentLevelId = -1;
        for (let i2 = 0; i2 < newLevelsInUse; i2 += 1) {
          addToCollection(
            "level",
            {
              ...ids,
              name: `Floor`,
              buildingId
            },
            // eslint-disable-next-line no-loop-func
            (levelId) => {
              recentLevelId = levelId;
            }
          );
        }
        if (array2.length - 1 === index2) {
          const enableAutoFloorActivation = false;
          if (recentLevelId !== -1 && enableAutoFloorActivation)
            setActiveLevelId(recentLevelId);
          setActiveBuildingId(buildingId);
          onDoneIn(buildingId);
        }
      });
    });
  }, [onDoneIn, addToCollection, loadBulkAssets, updateFeature, setActiveLevelId, setActiveBuildingId]);
  return /* @__PURE__ */ jsx(BaseTool, { component: BuildingForm, subComponent: StyleForm, getFeatures, getFormValue, onDone, enableBulkUpload: false, exportType: "exportBuilding", ...restProps });
}
BuildingTool.propTypes = {
  onDone: propTypesExports$1.func,
  objectType: propTypesExports$1.string
};
BuildingTool.defaultProps = {
  onDone: () => {
  },
  objectType: "building"
};
const {
  Title: Title$8
} = Typography;
const EXTENSIONS$2 = ["png", "jpg", "pdf"];
function AccessPointForm(props) {
  var _a3, _b3;
  const {
    onDone,
    onDraw,
    value: data2,
    onChange,
    onUpload,
    mode: mode2,
    subForm: SubForm,
    subFormProps,
    disabled,
    hidden,
    objectTypes,
    levels,
    buildings,
    zones,
    heading,
    deviceTypes: deviceTypesIn
  } = props;
  const {
    token
  } = theme$2.useToken();
  const formTitle = React__default.useMemo(() => {
    if (!mode2)
      return null;
    return "Point";
  }, [mode2]);
  const [helperData, setHelperData] = React__default.useState({});
  const onFormValuesChange = React__default.useCallback((data22) => {
    onChange(data22);
  }, [onChange]);
  const onSubmit = React__default.useCallback((values4) => {
    onDone(values4, mode2 === "Add");
  }, [mode2, onDone]);
  const deviceTypes = React__default.useMemo(() => deviceTypesIn.map((item) => ({
    key: item.key,
    value: item.value,
    label: item.label,
    icon: /* @__PURE__ */ jsx(item.Icon, {})
  })), [deviceTypesIn]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title$8, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: formTitle }), [formTitle]);
  const component = React__default.useCallback((params2) => {
    const isCreate = mode2 === "Add";
    const newParams = {
      ...params2,
      importDetails: isCreate ? {
        onClick: () => onUpload(EXTENSIONS$2),
        hidden: hidden.upload,
        disabled: disabled.upload
      } : null
    };
    return /* @__PURE__ */ jsx(RightPanel, { ...newParams, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, { style: {
      color: token.colorIcon
    } }) });
  }, [mode2, hidden.upload, disabled.upload, token.colorIcon, onUpload]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { component, title, onCancel: () => onDone(), onSubmit, active: true, formValues: data2, onChange: onFormValuesChange, marginVertical: 0, marginHorizontal: 0, bodyStyle: {
    padding: "8px 24px 0px 24px"
  }, footerStyle: {
    width: "100%",
    padding: 0
  }, children: [
    /* @__PURE__ */ jsx(AddressSelector, { onChange: setHelperData, value: helperData, country: (_a3 = helperData == null ? void 0 : helperData.countries) == null ? void 0 : _a3.find((item) => item.label === (data2 == null ? void 0 : data2.country)), state: (_b3 = helperData == null ? void 0 : helperData.states) == null ? void 0 : _b3.find((item) => item.label === (data2 == null ? void 0 : data2.state)) }),
    heading && /* @__PURE__ */ jsx("div", { style: {
      padding: "4px 0px"
    }, children: /* @__PURE__ */ jsx(Typography.Text, { strong: true, children: heading }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", initialValue: "accessPoint", hidden: hidden.objectType, children: /* @__PURE__ */ jsx(Select, { placeholder: "Layer Type", data: objectTypes, value: data2.objectType, disabled: disabled.objectType }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Select Point", rules: [{
      required: true
    }], hidden: hidden.name, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Access Point Name", disabled: disabled.name }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "assetType", label: "Select Device", rules: [{
      required: true
    }], hidden: hidden.assetType, initialValue: "Other", children: /* @__PURE__ */ jsx(Select, { placeholder: "Choose device type", showSearch: true, data: deviceTypes, disabled: disabled.assetType }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "buildingId", label: "Building", hidden: hidden.buildingId, children: /* @__PURE__ */ jsx(Select, { placeholder: "Choose building", showSearch: true, data: buildings, disabled: disabled.buildingId }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "levelId", label: "Floor", hidden: hidden.levelId, children: /* @__PURE__ */ jsx(Select, { placeholder: "Choose level", showSearch: true, data: levels, disabled: disabled.levelId }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "draw", label: /* @__PURE__ */ jsx(Typography.Text, { strong: true, style: {
      paddingBottom: "8px"
    }, children: "Icon Style" }), hidden: !!SubForm && !!(subFormProps == null ? void 0 : subFormProps.open), children: /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, style: {
      height: "32px"
    }, icon: /* @__PURE__ */ jsx(Icons.PenIconDark, { style: {
      fontSize: "15px",
      color: "transparent"
    } }), onClick: () => {
      var _a4;
      return (_a4 = subFormProps == null ? void 0 : subFormProps.setOpen) == null ? void 0 : _a4.call(subFormProps, true);
    }, children: "Show Icon" }) }),
    SubForm && /* @__PURE__ */ jsx(SubForm, { ...subFormProps }),
    /* @__PURE__ */ jsx(Form.Item, { name: "zones", label: "Zone", children: /* @__PURE__ */ jsx(Select, { style: {
      width: "100%"
    }, mode: "multiple", allowClear: true, showSearch: true, data: zones, menuItemSelectedIcon: /* @__PURE__ */ jsx(IoCheckboxOutline, {}), placeholder: "Specify zones" }) }),
    /* @__PURE__ */ jsx(FormItemLatLon, { onPickerClick: () => onDraw("point") }),
    /* @__PURE__ */ jsx(Form.Item, { name: "addressLine1", label: "Address 1", hidden: hidden.addressLine1, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Address 1" }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "addressLine2", label: "Address 2", hidden: hidden.addressLine2, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Address 2" }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "postalCode", label: "Zip Code", getValueFromEvent: (e3) => {
      var _a4;
      return (_a4 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a4.value;
    }, hidden: hidden.postalCode, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Zip Code" }) })
  ] });
}
AccessPointForm.propTypes = {
  onDone: propTypesExports$1.func,
  onDraw: propTypesExports$1.func,
  onUpload: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object,
  mode: propTypesExports$1.string,
  subForm: propTypesExports$1.any,
  subFormProps: propTypesExports$1.object,
  disabled: propTypesExports$1.object,
  hidden: propTypesExports$1.object,
  objectTypes: propTypesExports$1.array,
  levels: propTypesExports$1.array,
  buildings: propTypesExports$1.array,
  zones: propTypesExports$1.array,
  heading: propTypesExports$1.string,
  deviceTypes: propTypesExports$1.array
};
AccessPointForm.defaultProps = {
  onDone: () => {
  },
  onDraw: () => {
  },
  onUpload: () => {
  },
  onChange: () => {
  },
  value: {},
  mode: null,
  subForm: null,
  subFormProps: {},
  disabled: {},
  hidden: {},
  objectTypes: [],
  levels: [],
  buildings: [],
  zones: [],
  heading: "Access Point",
  deviceTypes: []
};
function AccessPointTool(props) {
  const {
    containerId,
    object: object2,
    onDone: onDoneIn,
    objectType,
    setObjectType,
    objectTypes,
    ...restProps
  } = props;
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const updateFeature = useSiteStore((state) => state.updateFeature);
  const updateFeatures = useSiteStore((state) => state.updateFeatures);
  const activeCountryId = useViewStore((state) => state.activeCountryId);
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const activeLevelId = useViewStore((state) => state.activeLevelId);
  const setActiveApFeatureId = useViewStore((state) => state.setActiveApFeatureId);
  const deviceTypes = useDeviceTypeStore((state) => state.deviceTypes);
  const buildings = useSiteStore((state) => state.buildings);
  const levels = useSiteStore((state) => state.levels);
  const zones = useSiteStore((state) => state.zones);
  const activeCountry = useSiteStore((state) => {
    var _a3;
    return ((_a3 = state.countries.find((c2) => c2.id === activeCountryId)) == null ? void 0 : _a3.name) || null;
  });
  const getFeatures = React__default.useCallback((isCreate, object22) => {
    var _a3;
    if (isCreate)
      return [];
    if (((_a3 = object22 == null ? void 0 : object22.geometry) == null ? void 0 : _a3.type) !== "Point")
      return [];
    const cloned = {
      ...object22,
      properties: {
        ...object22.properties,
        category: "marker"
      }
    };
    delete cloned.name;
    return [cloned];
  }, []);
  const getFormValue = React__default.useCallback((isCreate, object22, other) => {
    var _a3, _b3;
    const feature2 = object22 || {};
    const formValue = {
      objectType: "accessPoint",
      buildingId: activeBuildingId,
      levelId: activeLevelId,
      country: activeCountry,
      name: feature2 == null ? void 0 : feature2.name,
      ...(feature2 == null ? void 0 : feature2.properties) || {},
      ...((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.address) || {},
      isBulkUpload: other.isBulkUpload,
      zones: ((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.zoneIds) || []
    };
    delete formValue.address;
    delete formValue.zoneIds;
    return formValue;
  }, [activeBuildingId, activeCountry, activeLevelId]);
  const {
    buildingsData,
    levelsData,
    zonesData
  } = React__default.useMemo(() => {
    const buildingsData2 = [];
    buildings == null ? void 0 : buildings.forEach((building) => {
      if (building.venueId === activeVenueId) {
        const buildingT = {
          key: building.id,
          value: building.id,
          label: building.name
        };
        buildingsData2.push(buildingT);
      }
    });
    const levelsData2 = [];
    levels == null ? void 0 : levels.forEach((level) => {
      if (level.buildingId === activeBuildingId) {
        const levelT = {
          key: level.id,
          value: level.id,
          label: level.name
        };
        levelsData2.push(levelT);
      } else if (!activeBuildingId && level.venueId === activeVenueId) {
        const levelT = {
          key: level.id,
          value: level.id,
          label: level.name
        };
        levelsData2.push(levelT);
      }
    });
    const zonesData2 = [];
    zones == null ? void 0 : zones.forEach((zone) => {
      if (zone.levelId === activeLevelId) {
        const zoneT = {
          key: zone.id,
          value: zone.id,
          label: zone.name
        };
        zonesData2.push(zoneT);
      }
    });
    return {
      buildingsData: buildingsData2,
      levelsData: levelsData2,
      zonesData: zonesData2
    };
  }, [activeBuildingId, activeVenueId, buildings, levels, activeLevelId, zones]);
  const onDone = React__default.useCallback((objects, ids) => {
    if (!(objects == null ? void 0 : objects.length)) {
      onDoneIn();
      return;
    }
    let pointObject = null;
    objects == null ? void 0 : objects.some((obj) => {
      obj.features.some((f2) => {
        if (f2.geometry.type === "Point") {
          pointObject = obj;
          return true;
        }
        return false;
      });
      return !!pointObject;
    });
    if (!pointObject) {
      message$1.error("Submit Failed");
      onDoneIn();
      return;
    }
    const pointFeature = pointObject.features[0];
    let parentId;
    let parentType;
    ["level", "building", "venue", "cluster", "market", "region"].some((type) => {
      const key = `${type}Id`;
      if (ids[key]) {
        parentId = ids[key];
        parentType = type;
        return true;
      }
      return false;
    });
    if (!parentId) {
      message$1.error("Submit Failed");
      return;
    }
    pointFeature.properties = {
      ...pointFeature.properties,
      ...pointObject,
      address: {
        addressLine1: pointObject.addressLine1,
        addressLine2: pointObject.addressLine2,
        city: pointObject.city,
        state: pointObject.state,
        country: pointObject.country,
        postalCode: pointObject.postalCode
      },
      category: "accessPoint",
      parentId,
      parentType,
      zoneIds: [...pointObject.zones || []]
      // Temporarily to show in UI - give a layer name
      // layer: 'Access Points',
    };
    delete pointFeature.properties.id;
    delete pointFeature.properties.objectType;
    delete pointFeature.properties.draw;
    delete pointFeature.properties.addressLine1;
    delete pointFeature.properties.addressLine2;
    delete pointFeature.properties.country;
    delete pointFeature.properties.state;
    delete pointFeature.properties.city;
    delete pointFeature.properties.postalCode;
    delete pointFeature.properties.upload;
    delete pointFeature.properties.zones;
    delete pointFeature.properties.features;
    if (pointFeature.properties.name)
      pointFeature.name = pointFeature.properties.name;
    delete pointFeature.properties["marker-symbol"];
    updateFeature({
      feature: pointFeature,
      parentId,
      category: "accessPoint",
      parentType
    });
    setActiveApFeatureId(pointFeature.id);
    onDoneIn(pointFeature.id);
  }, [onDoneIn, setActiveApFeatureId, updateFeature]);
  const onImport = React__default.useCallback((preparedAssets) => {
    const {
      parentType,
      parentId
    } = preparedAssets[0].properties;
    updateFeatures({
      features: preparedAssets,
      category: "accessPoint",
      parentId,
      parentType
    }, (addedAssets) => {
      const [first] = addedAssets;
      setActiveApFeatureId(first);
      onDoneIn(first);
    });
  }, [updateFeatures, onDoneIn, setActiveApFeatureId]);
  return /* @__PURE__ */ jsx(BaseTool, { component: AccessPointForm, subComponent: StyleForm, componentProps: {
    levels: levelsData,
    buildings: buildingsData,
    zones: zonesData,
    deviceTypes,
    isBulkUpload: activeSubTool === "createUploadAssets"
  }, getFeatures, getFormValue, onDone, drawMode: "point", showDrawTools: false, object: object2, objectType, objectTypes, setObjectType, enableBulkUpload: activeSubTool === "createUploadAssets", onImport, ...restProps });
}
AccessPointTool.propTypes = {
  containerId: propTypesExports$1.string,
  object: propTypesExports$1.object,
  onDone: propTypesExports$1.func,
  objectType: propTypesExports$1.string,
  setObjectType: propTypesExports$1.func,
  objectTypes: propTypesExports$1.array
};
AccessPointTool.defaultProps = {
  containerId: "",
  object: null,
  onDone: () => {
  },
  objectType: "accessPoint",
  setObjectType: () => {
  },
  objectTypes: []
};
const index_module = {};
function MdCheckBoxOutlineBlank(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" } }] })(props);
}
function MdOutlineFileUpload(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5-5 5z" } }] })(props);
}
function MdOutlineLayers(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0V0z" } }, { "tag": "path", "attr": { "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53z" } }] })(props);
}
function MdOutlineWindow(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" } }, { "tag": "path", "attr": { "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-6V5h6v6zm-8-6v6H5V5h6zm-6 8h6v6H5v-6zm8 6v-6h6v6h-6z" } }] })(props);
}
const {
  Title: Title$7
} = Typography;
const FloorTypes = [{
  id: "standard",
  label: "Standard (for regular floors)",
  value: "Standard (for regular floors)"
}, {
  id: "basement",
  label: "Basement",
  value: "Basement"
}, {
  id: "parking",
  label: "Parking",
  value: "Parking"
}, {
  id: "rooftop",
  label: "Rooftop",
  value: "Rooftop"
}, {
  id: "attic",
  label: "Attic",
  value: "Attic"
}, {
  id: "terrace",
  label: "Terrace",
  value: "Terrace"
}];
const EXTENSIONS$1 = ["png", "jpg", "pdf"];
function LevelForm(props) {
  const {
    onDone,
    value: valueIn,
    onChange,
    onUpload,
    onDraw,
    building,
    levels,
    mode: mode2,
    disabled,
    hidden,
    objectTypes
  } = props;
  const {
    token
  } = theme$2.useToken();
  const [floorNumberEntered, setFloorNumberEntered] = React__default.useState(typeof valueIn.levelNumber === "number");
  const data2 = React__default.useMemo(() => {
    if (!valueIn)
      return null;
    const formData = {
      ...valueIn,
      objectType: "level",
      heightInputLength: {
        lengthInMeter: valueIn == null ? void 0 : valueIn.height,
        displayUnit: (valueIn == null ? void 0 : valueIn.heightUnit) || "m"
      },
      elevationInputLength: {
        lengthInMeter: valueIn == null ? void 0 : valueIn.elevation,
        displayUnit: (valueIn == null ? void 0 : valueIn.elevationUnit) || "m"
      }
    };
    return formData;
  }, [valueIn]);
  const validateFloorHeight = React__default.useCallback(async () => {
    if (building && data2.height > building.height) {
      throw new Error("Floor height exceeds building height");
    }
  }, [data2, building]);
  const validateFloorElevation = React__default.useCallback(async () => {
    const lowerLevelNumber = data2.levelNumber - 1;
    const lowerLevel = levels == null ? void 0 : levels.find((level) => level.levelNumber === lowerLevelNumber);
    if (lowerLevel) {
      const lowerHeight = lowerLevel.height || 0;
      const lowerElevation = lowerLevel.elevation || 0;
      const elevation = data2.elevation || 0;
      if (elevation !== lowerHeight + lowerElevation) {
        throw new Error("Floor elevation should match with lower floor height");
      }
    }
  }, [data2.elevation, data2.levelNumber, levels]);
  const validateFloorNumber = React__default.useCallback(async () => {
    if (!data2)
      return;
    const inputLevelNumber = data2.levelNumber;
    const existingLevel = levels == null ? void 0 : levels.find((level) => level.levelNumber === inputLevelNumber);
    if (existingLevel && data2.id !== existingLevel.id) {
      throw new Error("Floor Number is already present.");
    }
  }, [data2, levels]);
  const getHeightElevationInfo = React__default.useCallback((data22) => {
    const {
      lengthInMeter: height,
      displayUnit: heightUnit
    } = (data22 == null ? void 0 : data22.heightInputLength) || {};
    const {
      lengthInMeter: elevation,
      displayUnit: elevationUnit
    } = (data22 == null ? void 0 : data22.elevationInputLength) || {};
    return {
      height,
      heightUnit,
      elevation,
      elevationUnit
    };
  }, []);
  const onFormValuesChange = React__default.useCallback((data22) => {
    const {
      height,
      heightUnit,
      elevation,
      elevationUnit
    } = getHeightElevationInfo(data22);
    onChange({
      ...data22 || {},
      height,
      heightUnit,
      elevation,
      elevationUnit
    });
  }, [onChange, getHeightElevationInfo]);
  const onSubmit = React__default.useCallback((values4) => {
    const {
      height,
      heightUnit,
      elevation,
      elevationUnit
    } = getHeightElevationInfo(values4);
    const finalValues = {
      ...values4 || {},
      height,
      heightUnit,
      elevation,
      elevationUnit
    };
    delete finalValues.heightInputLength;
    delete finalValues.elevationInputLength;
    onDone(finalValues, mode2 === "Add");
  }, [getHeightElevationInfo, onDone, mode2]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title$7, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: "Floor" }), []);
  const component = React__default.useCallback((params2) => /* @__PURE__ */ jsx(RightPanel, { ...params2, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}) }), []);
  React__default.useEffect(() => {
    const materialForm = false;
    if (!data2 || !materialForm)
      return;
    onDraw("polygon", true);
  }, [data2, onDraw]);
  const handleFloorNumberChange = React__default.useCallback((enteredNumber) => {
    setFloorNumberEntered(typeof enteredNumber === "number");
  }, []);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { component, title, onCancel: () => onDone(), onSubmit, active: true, formValues: data2, onChange: onFormValuesChange, marginVertical: 0, marginHorizontal: 0, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", initialValue: "level", hidden: hidden.objectType, children: /* @__PURE__ */ jsx(Select, { placeholder: "Layer Type", data: objectTypes, value: data2.objectType, disabled: disabled.objectType }) }),
    /* @__PURE__ */ jsxs(Row, { gutter: 8, children: [
      /* @__PURE__ */ jsx(Col, { span: 10, children: /* @__PURE__ */ jsx(Form.Item, { name: "levelNumber", label: "Floor Number", rules: [{
        required: true
      }, {
        validator: validateFloorNumber
      }], children: /* @__PURE__ */ jsx(InputNumber, { controls: false, style: {
        width: "100%"
      }, block: 1, placeholder: "Enter Number", filled: true, onChange: handleFloorNumberChange }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 14, children: /* @__PURE__ */ jsx(Form.Item, { name: "heightInputLength", label: /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(Typography.Text, { children: "Floor Height" }),
        /* @__PURE__ */ jsx(Tooltip$1, { title: "Floor Height", children: /* @__PURE__ */ jsx(QuestionCircleOutlined, { style: {
          color: token.colorIcon,
          paddingLeft: "4px"
        } }) })
      ] }), rules: [{
        validator: validateFloorHeight
      }], children: /* @__PURE__ */ jsx(InputLength, { parentId: "level-height", filled: true, inputNumberProps: {
        controls: false,
        style: {
          width: "100%"
        },
        placeholder: "Enter Height"
      } }) }) })
    ] }),
    /* @__PURE__ */ jsx(Form.Item, { name: "levelType", label: /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsx(Typography.Text, { children: "Floor Type" }),
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        color: token.colorTextDescription,
        paddingLeft: "4px"
      }, children: "(optional)" })
    ] }), children: /* @__PURE__ */ jsx(Select, { data: FloorTypes, placeholder: "Select floor type", allowClear: true, showSearch: true }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "elevationInputLength", label: /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsx(Typography.Text, { children: "Elevation" }),
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        color: token.colorTextDescription,
        paddingLeft: "4px"
      }, children: "(optional)" })
    ] }), rules: [{
      validator: validateFloorElevation
    }], children: /* @__PURE__ */ jsx(InputLength, { parentId: "building-elevation", filled: true, inputNumberProps: {
      controls: false,
      style: {
        width: "100%"
      },
      block: 1,
      placeholder: "Enter number"
    } }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "upload", label: "Floor Plan", children: /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, icon: /* @__PURE__ */ jsx(MdOutlineFileUpload, {}), onClick: () => onUpload(EXTENSIONS$1), disabled: !floorNumberEntered, children: "Import" }) })
  ] });
}
LevelForm.propTypes = {
  onDone: propTypesExports$1.func,
  onDraw: propTypesExports$1.func,
  onUpload: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object,
  building: propTypesExports$1.object,
  levels: propTypesExports$1.array,
  mode: propTypesExports$1.string,
  disabled: propTypesExports$1.object,
  hidden: propTypesExports$1.object,
  objectTypes: propTypesExports$1.array
};
LevelForm.defaultProps = {
  onDone: () => {
  },
  onDraw: () => {
  },
  onUpload: () => {
  },
  onChange: () => {
  },
  value: {},
  building: null,
  levels: null,
  mode: "",
  disabled: {},
  hidden: {},
  objectTypes: []
};
const {
  Text: Text$6
} = Typography;
const textColor$2 = {
  border: "none",
  paddingLeft: "12px"
};
function getFormValues$2(object2) {
  if (!object2)
    return {};
  return {
    id: object2.id,
    objectType: object2.objectType,
    name: object2.name,
    levelNumber: object2.levelNumber,
    height: object2.height,
    heightUnit: object2.heightUnit,
    levelType: object2.levelType,
    elevation: object2.elevation,
    elevationUnit: object2.elevationUnit,
    buildingId: object2.buildingId
  };
}
function LevelInfo(props) {
  const {
    onDone,
    object: object2
  } = props;
  const {
    formValue,
    id
  } = React__default.useMemo(() => {
    if (!object2)
      return {};
    const formValue2 = getFormValues$2(object2);
    return {
      id: object2.id,
      formValue: formValue2
    };
  }, [object2]);
  if (!formValue) {
    return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Venue Information", onDone, children: [
      /* @__PURE__ */ jsx(Empty, {}),
      " "
    ] }, "null");
  }
  return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Floor Information", onDone, children: [
    /* @__PURE__ */ jsxs(Row, { gutter: 8, children: [
      /* @__PURE__ */ jsx(Col, { span: 10, children: /* @__PURE__ */ jsx(Form.Item, { name: "levelNumber", label: "Floor Number", children: /* @__PURE__ */ jsx(Text$6, { style: {
        ...textColor$2
      }, children: formValue.levelNumber }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 10, children: /* @__PURE__ */ jsx(Form.Item, { name: "height", label: "Floor Height", children: /* @__PURE__ */ jsx(Text$6, { style: {
        ...textColor$2
      }, children: formValue.height }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 4, children: /* @__PURE__ */ jsx(Form.Item, { name: "heightUnit", label: " ", children: /* @__PURE__ */ jsx(Text$6, { style: {
        ...textColor$2
      }, children: formValue.heightUnit }) }) })
    ] }),
    /* @__PURE__ */ jsx(Form.Item, { name: "levelType", label: "Floor Type", children: /* @__PURE__ */ jsx(Text$6, { style: {
      ...textColor$2
    }, children: formValue.levelType }) }),
    /* @__PURE__ */ jsxs(Row, { gutter: 8, children: [
      /* @__PURE__ */ jsx(Col, { span: 20, children: /* @__PURE__ */ jsx(Form.Item, { name: "elevation", label: "Base Height", children: /* @__PURE__ */ jsx(Text$6, { style: {
        ...textColor$2
      }, children: formValue.elevation }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 4, children: /* @__PURE__ */ jsx(Form.Item, { name: "elevationUnit", label: " ", children: /* @__PURE__ */ jsx(Text$6, { style: {
        ...textColor$2
      }, children: formValue.elevationUnit }) }) })
    ] })
  ] }, id);
}
LevelInfo.propTypes = {
  onDone: propTypesExports$1.func,
  object: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    name: propTypesExports$1.string,
    levelNumber: propTypesExports$1.number,
    height: propTypesExports$1.number,
    heightUnit: propTypesExports$1.string,
    levelType: propTypesExports$1.string,
    elevation: propTypesExports$1.number,
    elevationUnit: propTypesExports$1.string
  })
};
LevelInfo.defaultProps = {
  onDone: () => {
  },
  object: {}
};
LevelInfo.getFormValues = getFormValues$2;
const {
  Title: Title$6
} = Typography;
const {
  useToken: useToken$6
} = theme$2;
function MaterialPropForm(props) {
  const {
    token: {
      activeColor
    }
  } = useToken$6();
  const {
    onDone,
    value: data2,
    onChange,
    mode: mode2,
    onCancel,
    onDelete
  } = props;
  const {
    colors,
    attenuationUnits,
    heightUnits,
    addColor: addColor2
  } = useMaterialPropStore();
  const {
    objectSubTypes
  } = useMaterialStore();
  const isEdit = mode2 === "edit";
  React__default.useEffect(() => {
    if (isEdit) {
      const hasColor = colors.filter((c2) => c2 === data2.color);
      if (hasColor.length === 0) {
        addColor2(data2.color);
      }
    }
  }, [addColor2, colors, data2.color, isEdit]);
  const onSubmit = React__default.useCallback((values4) => {
    const newVal = {
      ...values4
    };
    if (!isEdit) {
      newVal.id = `${values4.name}_${Math.floor(Math.random() * 10)}`;
      newVal.typeId = values4.objectType;
      newVal.subtypeId = values4.objSubType;
      newVal.heightUnit = newVal.heightUnit ? newVal.heightUnit : heightUnits[0].value;
      newVal.attenuationUnit = newVal.attenuationUnit ? newVal.attenuationUnit : attenuationUnits[0].value;
    }
    onDone(newVal);
  }, [onDone, attenuationUnits, heightUnits, isEdit]);
  const renderTitle = React__default.useCallback(() => /* @__PURE__ */ jsxs(Flex, { justify: "space-between", children: [
    /* @__PURE__ */ jsx(LeftOutlined, { onClick: () => onCancel() }),
    /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Title$6, { strong: true, level: 4, style: {
      marginTop: "8px",
      marginBottom: "14px"
    }, children: (data2 == null ? void 0 : data2.name) || "Material" }) }),
    isEdit ? /* @__PURE__ */ jsx(DeleteOutlined, { onClick: () => onDelete() }) : /* @__PURE__ */ jsx("div", {})
  ] }), [data2 == null ? void 0 : data2.name, isEdit, onCancel, onDelete]);
  const ColorComponent = React__default.useCallback(({
    isSelected,
    color
  }) => /* @__PURE__ */ jsx("div", { role: "button", tabIndex: 0, style: {
    backgroundColor: color ?? activeColor,
    width: `22px`,
    height: `22px`,
    borderRadius: "14px",
    borderStyle: "solid",
    borderWidth: "2px",
    borderColor: isSelected ? activeColor : "transparent",
    textAlign: "center"
  }, onClick: () => {
    onChange({
      ...data2,
      color
    });
  }, onKeyDown: (e3) => {
    if (e3.key === "Enter" || e3.key === " ") {
      onChange({
        ...data2,
        color
      });
    }
  }, children: isSelected ? /* @__PURE__ */ jsx(CheckOutlined, { style: {
    height: "12px"
  } }) : null }), [activeColor, data2, onChange]);
  const onValuesChange = React__default.useCallback((values4) => {
    const newValues = {
      ...values4
    };
    onChange(newValues);
  }, [onChange]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { component: RightPanel, title: renderTitle(), onCancel, onSubmit, active: true, okText: isEdit ? "Save" : "Add", formValues: data2, onChange: onValuesChange, marginVertical: 0, marginHorizontal: 0, placement: "top-right", children: [
    !isEdit && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Object Type", rules: [{
        required: false
      }], children: /* @__PURE__ */ jsx(Flex, { gap: "small", wrap: "wrap", justify: "space-between", style: {
        paddingBottom: "10px"
      }, children: ObjectTypes.map((objType) => /* @__PURE__ */ jsx(Flex, { vertical: true, justify: "center", align: "center", children: /* @__PURE__ */ jsx(ObjectButton, { isActive: (data2 == null ? void 0 : data2.objectType) === objType.id, onClick: () => onChange({
        ...data2,
        objectType: objType.id
      }), icon: objType.icon, label: objType.label }) })) }) }),
      /* @__PURE__ */ jsx(Form.Item, { name: "objSubType", label: "Object Subtype", rules: [{
        required: false
      }], children: /* @__PURE__ */ jsx(Select, { placeholder: "Choose Subtype", className: "bottom-border-input", bordered: 0, data: objectSubTypes.filter((st) => st.typeId === (data2 == null ? void 0 : data2.objectType)).map((i2) => ({
        ...i2,
        key: i2.id
      })) }) })
    ] }),
    /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Name", rules: [{
      required: true
    }], children: /* @__PURE__ */ jsx(Input$1, { placeholder: "name" }) }),
    /* @__PURE__ */ jsxs(Row, { gutter: 2, justify: "space-between", children: [
      /* @__PURE__ */ jsx(Col, { span: 15, children: /* @__PURE__ */ jsx(Form.Item, { name: "attenuation", label: "Attenuation", rules: [{
        required: true
      }], children: /* @__PURE__ */ jsx(Input$1, { type: "number", placeholder: "", style: {
        width: "100%"
      } }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 7, children: /* @__PURE__ */ jsx(Form.Item, { name: "attenuationUnit", label: " ", rules: [{
        required: false
      }], children: /* @__PURE__ */ jsx(Select, { placeholder: "db/m", defaultValue: isEdit ? null : attenuationUnits[0], data: attenuationUnits }) }) })
    ] }),
    /* @__PURE__ */ jsxs(Row, { gutter: 2, justify: "space-between", children: [
      /* @__PURE__ */ jsx(Col, { span: 15, children: /* @__PURE__ */ jsx(Form.Item, { name: "height", label: "Height", rules: [{
        required: true
      }], children: /* @__PURE__ */ jsx(Input$1, { type: "number", placeholder: "Height", style: {
        width: "100%"
      } }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 7, children: /* @__PURE__ */ jsx(Form.Item, { name: "heightUnit", label: " ", rules: [{
        required: false
      }], children: /* @__PURE__ */ jsx(Select, { placeholder: "m", defaultValue: isEdit ? null : heightUnits[0], data: heightUnits }) }) })
    ] }),
    /* @__PURE__ */ jsx(Form.Item, { name: "color", label: "Color", rules: [{
      required: false
    }], children: /* @__PURE__ */ jsxs(Flex, { gap: "small", wrap: "wrap", children: [
      colors.map((color) => /* @__PURE__ */ jsx(Flex, { vertical: true, justify: "center", align: "center", children: /* @__PURE__ */ jsx(ColorComponent, { color, isSelected: (data2 == null ? void 0 : data2.color) === color }) })),
      /* @__PURE__ */ jsx(ColorPicker, { disabledAlpha: true, onChangeComplete: (c2) => addColor2(c2.toHexString()), children: /* @__PURE__ */ jsx("div", { style: {
        backgroundColor: activeColor,
        width: `24px`,
        height: `24px`,
        borderRadius: "14px",
        textAlign: "center"
      }, children: /* @__PURE__ */ jsx(PlusOutlined, { style: {
        height: "12px"
      } }) }) })
    ] }) }),
    /* @__PURE__ */ jsxs(Row, { align: "bottom", gutter: 1, justify: "space-between", children: [
      /* @__PURE__ */ jsx(Col, { span: 16, children: /* @__PURE__ */ jsx(Form.Item, { name: "opacity", label: "Opacity", children: /* @__PURE__ */ jsx(Slider$1, { max: 100, min: 0, step: 1 }) }) }),
      /* @__PURE__ */ jsx(Col, { span: 7, children: /* @__PURE__ */ jsx(Form.Item, { name: "opacity", label: "", children: /* @__PURE__ */ jsx(InputNumber$1, { min: 0, max: 100, step: 1, addonAfter: "%" }) }) })
    ] })
  ] });
}
MaterialPropForm.propTypes = {
  onDone: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  onCancel: propTypesExports$1.func,
  onDelete: propTypesExports$1.func,
  mode: propTypesExports$1.oneOf(["add", "edit"]).isRequired,
  value: propTypesExports$1.object
};
MaterialPropForm.defaultProps = {
  onDone: () => {
  },
  onChange: () => {
  },
  onCancel: () => {
  },
  onDelete: () => {
  },
  value: {}
};
const {
  Text: Text$5,
  Title: Title$5
} = Typography;
function MaterialForm(props) {
  const {
    onDone,
    value: data2,
    onChange,
    onAdvanceViewClick
  } = props;
  const {
    objectSubTypes,
    materials,
    addMaterial,
    deleteMaterial,
    updateMaterial
  } = useMaterialStore();
  const [materialToOpen, setMaterialToOpen] = React__default.useState(null);
  const renderTitle = React__default.useCallback(() => /* @__PURE__ */ jsxs(Flex, { justify: "space-between", children: [
    /* @__PURE__ */ jsx(Flex, { children: /* @__PURE__ */ jsx(Title$5, { strong: true, level: 4, style: {
      marginTop: "8px",
      marginBottom: "14px"
    }, children: "Material" }) }),
    /* @__PURE__ */ jsx(RightOutlined, { onClick: () => onDone() })
  ] }), [onDone]);
  const renderOk = React__default.useCallback(() => /* @__PURE__ */ jsxs(Row, { justify: "center", children: [
    /* @__PURE__ */ jsx(PlusOutlined, { style: {
      padding: "5px 10px"
    } }),
    /* @__PURE__ */ jsx(Text$5, { children: "Add Material" })
  ] }), []);
  const renderCancel = React__default.useCallback(() => /* @__PURE__ */ jsxs(Row, { justify: "center", children: [
    /* @__PURE__ */ jsx(AppstoreOutlined, { style: {
      padding: "5px 10px"
    } }),
    /* @__PURE__ */ jsx(Text$5, { children: "Advance View" })
  ] }), []);
  const materialOption = React__default.useCallback((material) => ({
    items: [{
      label: /* @__PURE__ */ jsxs(Row, { style: {
        width: "100px"
      }, onClick: () => setMaterialToOpen({
        material,
        mode: "edit"
      }), children: [
        /* @__PURE__ */ jsx(EditOutlined, { style: {
          padding: "5px 10px 5px 10px"
        } }),
        /* @__PURE__ */ jsx(Text$5, { children: "Modify" })
      ] }),
      key: `edit_${material.id}`
    }, {
      label: /* @__PURE__ */ jsxs(Row, { style: {
        width: "100px"
      }, onClick: () => deleteMaterial(material), children: [
        /* @__PURE__ */ jsx(DeleteOutlined, { style: {
          padding: "5px 10px 5px 10px"
        } }),
        /* @__PURE__ */ jsx(Text$5, { children: "Delete" })
      ] }),
      key: `delete_${material.id}`
    }]
  }), [deleteMaterial]);
  const addNew = React__default.useCallback(() => {
    setMaterialToOpen({
      material: {},
      mode: "add"
    });
  }, []);
  const onValuesChange = React__default.useCallback((values4) => {
    const newValues = {
      ...values4
    };
    onChange(newValues);
  }, [onChange]);
  if (materialToOpen) {
    return /* @__PURE__ */ jsx(MaterialPropForm, { value: materialToOpen.material, mode: materialToOpen.mode, onDone: (updatedMaterial) => {
      if (materialToOpen.mode === "edit") {
        updateMaterial({
          ...materialToOpen.material,
          ...updatedMaterial
        });
      } else {
        addMaterial(updatedMaterial);
      }
      setMaterialToOpen(null);
    }, onCancel: () => {
      setMaterialToOpen(null);
    }, onChange: (value) => {
      setMaterialToOpen((prev) => ({
        ...prev,
        material: {
          ...prev.material,
          ...value
        }
      }));
    }, onDelete: () => {
      deleteMaterial(materialToOpen.material);
      setMaterialToOpen(null);
    } });
  }
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(
    ModalForm,
    {
      component: RightPanel,
      title: renderTitle(),
      onCancel: () => addNew(),
      onSubmit: () => onAdvanceViewClick(),
      active: true,
      formValues: data2,
      onChange: onValuesChange,
      marginVertical: 0,
      marginHorizontal: 0,
      okText: renderCancel(),
      cancelText: renderOk(),
      verticalAction: true,
      placement: "top-right",
      ignoreValidation: true,
      children: [
        /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Object Type", rules: [{
          required: false
        }], children: /* @__PURE__ */ jsx(Flex, { gap: "small", wrap: "wrap", justify: "space-between", style: {
          paddingBottom: "10px"
        }, children: ObjectTypes.map((objType) => /* @__PURE__ */ jsx(Flex, { vertical: true, justify: "center", align: "center", children: /* @__PURE__ */ jsx(ObjectButton, { isActive: (data2 == null ? void 0 : data2.objectType) === objType.id, onClick: () => onValuesChange({
          ...data2,
          objectType: objType.id
        }), icon: objType.icon, label: objType.label }) })) }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "objSubType", label: "Object Subtype", rules: [{
          required: false
        }], children: /* @__PURE__ */ jsx(Select, { placeholder: "Choose Subtype", className: "bottom-border-input", bordered: 0, data: objectSubTypes.filter((st) => st.typeId === (data2 == null ? void 0 : data2.objectType)).map((i2) => ({
          ...i2,
          key: i2.id
        })) }) }),
        /* @__PURE__ */ jsx(Form.Item, { name: "material", label: "Material Type", rules: [{
          required: true
        }], children: /* @__PURE__ */ jsx(Radio.Group, { onChange, optionType: "button", buttonStyle: "solid", style: {
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          width: "100%"
        }, children: materials.filter((m2) => m2.subtypeId === (data2 == null ? void 0 : data2.objSubType) && m2.typeId === (data2 == null ? void 0 : data2.objectType)).map((item) => /* @__PURE__ */ jsx(Radio.Button, { style: {
          width: "100%"
        }, value: item.id, children: /* @__PURE__ */ jsxs(Row, { justify: "space-between", children: [
          /* @__PURE__ */ jsxs(Row, { align: "middle", children: [
            /* @__PURE__ */ jsx(Badge, { style: {
              padding: "0px 10px 2px 0px"
            }, color: item.color }),
            /* @__PURE__ */ jsx(Text$5, { children: item.name }),
            /* @__PURE__ */ jsxs(Text$5, { type: "secondary", children: [
              "  /",
              item.attenuation,
              item.attenuationUnit
            ] })
          ] }),
          /* @__PURE__ */ jsxs(Row, { align: "middle", children: [
            item.isFav ? /* @__PURE__ */ jsx(StarOutlined, { style: {
              paddingRight: "10px"
            } }) : null,
            /* @__PURE__ */ jsx(Dropdown, { menu: materialOption(item), children: /* @__PURE__ */ jsx(MoreOutlined, { style: {
              padding: "5px"
            } }) })
          ] })
        ] }) })) }) })
      ]
    }
  );
}
MaterialForm.propTypes = {
  onDone: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  onAdvanceViewClick: propTypesExports$1.func,
  value: propTypesExports$1.object
};
MaterialForm.defaultProps = {
  onDone: () => {
  },
  onChange: () => {
  },
  onAdvanceViewClick: () => {
  },
  value: {}
};
function LevelTool(props) {
  const {
    containerId,
    object: object2,
    onDone: onDoneIn,
    objectType,
    setObjectType,
    objectTypes,
    bearing: viewAzimuth,
    ...restProps
  } = props;
  const [showDrawTools] = React__default.useState(true);
  const materials = useMaterialStore((state) => state.materials);
  const addToCollection = useSiteStore((state) => state.addToCollection);
  const updateFeatures = useSiteStore((state) => state.updateFeatures);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const activeFormControl = useViewStore((state) => state.activeFormControl);
  const setActiveLevelId = useViewStore((state) => state.setActiveLevelId);
  const activeCountryId = useViewStore((state) => state.activeCountryId);
  const activeRegionId = useViewStore((state) => state.activeRegionId);
  const activeMarketId = useViewStore((state) => state.activeMarketId);
  const activeClusterId = useViewStore((state) => state.activeClusterId);
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const loadBulkAssets = useAssetStore((state) => state.loadUpdate);
  const levels = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.levels) == null ? void 0 : _a3.filter((level) => level.buildingId === activeBuildingId);
  });
  const activeBuilding = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.buildings) == null ? void 0 : _a3.find((building) => building.id === activeBuildingId);
  });
  const mode2 = React__default.useMemo(() => {
    if (activeSubTool === "createLevel")
      return "Add";
    if (activeSubTool === "editLevel")
      return "Edit";
    return "";
  }, [activeSubTool]);
  const {
    formValue,
    isCreate,
    id,
    features,
    subFormValue,
    center: center2
  } = React__default.useMemo(() => {
    const isCreate2 = !object2 || !object2.id;
    const id2 = isCreate2 ? "newObject" : object2.id;
    const features2 = isCreate2 ? void 0 : object2.allFeatures;
    const formValue2 = isCreate2 ? {} : LevelInfo.getFormValues(object2);
    return {
      id: id2,
      isCreate: isCreate2,
      formValue: formValue2,
      features: features2,
      subFormValue: {},
      center: object2 == null ? void 0 : object2.center
    };
  }, [object2]);
  const overrideValue = React__default.useMemo(() => {
    if (activeFormControl == null ? void 0 : activeFormControl.level) {
      return {
        name: activeFormControl.level
      };
    }
    return {};
  }, [activeFormControl == null ? void 0 : activeFormControl.level]);
  const getCategory = React__default.useCallback((drawMode) => {
    switch (drawMode) {
      case "point":
        return "accessPoint";
      case "line":
        return "wall";
      case "circle":
      case "rectangle":
      case "polygon":
        return "room";
      default:
        return "custom";
    }
  }, []);
  const onFeatureSelect = React__default.useCallback((feature2, materialData) => {
    var _a3;
    const materialId2 = (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.materialId;
    if (!materialId2)
      return [{}, feature2];
    const material = materials.find((m2) => (m2 == null ? void 0 : m2.id) === materialId2);
    if (!material)
      return [materialData, feature2];
    return [{
      material: material.id,
      objectType: material.typeId,
      objSubType: material.subtypeId
    }, feature2];
  }, [materials]);
  const onObjectTypeChange = React__default.useCallback((data2) => {
    if (!isCreate)
      return;
    if (!(data2 == null ? void 0 : data2.objectType))
      return;
    setObjectType(data2 == null ? void 0 : data2.objectType);
  }, [isCreate, setObjectType]);
  const onMaterialChange = React__default.useCallback((materialData, feature2, drawMode) => {
    var _a3;
    const materialId2 = ((_a3 = materialData == null ? void 0 : materialData.target) == null ? void 0 : _a3.value) || (materialData == null ? void 0 : materialData.material);
    const material = materials.find((m2) => (m2 == null ? void 0 : m2.id) === materialId2);
    if (!material)
      return [materialData, feature2];
    const style2 = {
      stroke: material.color,
      "stroke-opacity": material.opacity / 100,
      "fill-opacity": material.opacity / 100,
      fill: material.color
    };
    if (feature2) {
      feature2 = {
        ...feature2
      };
      feature2.properties = {
        ...feature2.properties || {},
        ...material,
        materialId: materialId2,
        drawMode,
        category: getCategory(drawMode),
        ...style2
        // apply style to the feature
      };
    }
    return [materialData, feature2];
  }, [getCategory, materials]);
  const onFeatureChange = React__default.useCallback((feature2, drawMode, materialData) => {
    if (!feature2)
      return null;
    if (!feature2.id)
      feature2.id = generateUid();
    feature2.properties.drawMode = drawMode;
    feature2.properties.category = getCategory(drawMode);
    return onMaterialChange(materialData, feature2, drawMode);
  }, [getCategory, onMaterialChange]);
  const onDone = React__default.useCallback((data2) => {
    const {
      formValue: values4,
      features: allFeatures,
      assets,
      azimuth
    } = data2 || {};
    if (!values4 || typeof (values4 == null ? void 0 : values4.levelNumber) !== "number") {
      onDoneIn();
      return;
    }
    const features2 = [];
    allFeatures == null ? void 0 : allFeatures.forEach((afeature) => {
      const feature2 = {
        ...afeature,
        properties: {
          ...afeature.properties
        }
      };
      if (!feature2.id)
        feature2.id = generateUid();
      if (!feature2.properties.category || feature2.properties.category === "orphan")
        feature2.properties.category = "custom";
      if (!feature2.properties.layer)
        feature2.properties.layer = "undefined";
      features2.push(feature2);
    });
    const ids = {
      countryId: activeCountryId,
      regionId: activeRegionId,
      marketId: activeMarketId,
      clusterId: activeClusterId,
      venueId: activeVenueId,
      buildingId: activeBuildingId
    };
    Object.keys(ids).forEach((key) => {
      if (!ids[key])
        delete ids[key];
    });
    const finalAzimuth = typeof azimuth === "number" ? azimuth : viewAzimuth;
    addToCollection("level", {
      ...ids,
      id: isCreate ? null : id,
      name: `Floor ${values4.levelNumber}`,
      // as of now floor form do not have name field
      levelType: values4.levelType,
      levelNumber: values4.levelNumber,
      height: values4.height,
      heightUnit: values4.heightUnit,
      elevation: values4.elevation,
      elevationUnit: values4.elevationUnit,
      azimuth: finalAzimuth
    }, (levelId) => {
      var _a3, _b3;
      loadBulkAssets({
        assets: assets == null ? void 0 : assets.map((asset) => ({
          ...asset,
          parentId: levelId,
          parentType: "level",
          category: "asset"
        }))
      });
      updateFeatures({
        features: features2,
        parentId: levelId,
        parentType: "level"
      });
      if (isCreate && activeBuilding) {
        const numNewLevelsInUse = ((_b3 = (_a3 = useSiteStore.getState().levels) == null ? void 0 : _a3.filter((l2) => l2.buildingId === activeBuildingId)) == null ? void 0 : _b3.length) || 0;
        const {
          numLevels
        } = activeBuilding;
        if (numLevels < numNewLevelsInUse) {
          addToCollection("building", {
            ...activeBuilding,
            numLevels: numLevels + 1
          });
          message$1.warning("Updated Total Floors count for the Building");
        }
      }
      setActiveLevelId(levelId);
      onDoneIn(levelId);
    });
  }, [loadBulkAssets, addToCollection, isCreate, id, activeBuilding, activeVenueId, activeClusterId, activeCountryId, activeMarketId, activeRegionId, activeBuildingId, onDoneIn, setActiveLevelId, updateFeatures, viewAzimuth]);
  return /* @__PURE__ */ jsx(MapToolForm, { containerId, component: LevelForm, subComponent: MaterialForm, initialValue: formValue, overrideValue, componentProps: {
    levels,
    building: activeBuilding,
    disabled: {
      objectType: !isCreate
    },
    mode: mode2,
    objectTypes
  }, subComponentProps: {
    isDrawToolOn: true
  }, subInitialValue: subFormValue, noSubFormCancel: true, features, onDone, onFeatureSelect, onFeatureChange, onFormChange: onObjectTypeChange, onSubFormChange: onMaterialChange, center: center2, materials, showDrawTools, ...restProps });
}
LevelTool.propTypes = {
  containerId: propTypesExports$1.string,
  object: propTypesExports$1.object,
  onDone: propTypesExports$1.func,
  objectType: propTypesExports$1.string,
  setObjectType: propTypesExports$1.func,
  objectTypes: propTypesExports$1.array,
  bearing: propTypesExports$1.number
};
LevelTool.defaultProps = {
  containerId: "",
  object: null,
  onDone: () => {
  },
  objectType: "level",
  setObjectType: () => {
  },
  objectTypes: [],
  bearing: 0
};
function ExportTool(props) {
  const {
    onDone,
    active: active3,
    outputFilename,
    activeId
  } = props;
  const {
    siteState,
    assetState,
    projectState
  } = useJsonExporter();
  const getData6 = React__default.useCallback((format) => ExportUtil.exportToFormat(siteState, assetState, projectState, format, activeId), [activeId, assetState, siteState, projectState]);
  return /* @__PURE__ */ jsx(TextFileExporter, { onCancel: onDone, outputFilename, formats: ["geojson", "json", "kml/kmz"], active: active3, onDone, data: getData6 });
}
ExportTool.propTypes = {
  onDone: propTypesExports$1.func,
  active: propTypesExports$1.bool,
  outputFilename: propTypesExports$1.string,
  // without extension
  activeId: propTypesExports$1.string
};
ExportTool.defaultProps = {
  onDone: () => {
  },
  active: false,
  outputFilename: "All",
  activeId: null
};
function LevelConfig() {
  const updateCategoryVisibility = useViewStore((state) => state.updateCategoryVisibility);
  const setActiveTiles = useViewStore((state) => state.setActiveTiles);
  const activeLevelId = useViewStore((state) => state.activeLevelId);
  const defaultTiles = useViewStore((state) => state.defaultTiles);
  const defaultTilesRef = useValueRef(defaultTiles);
  const levels = useSiteStore((state) => state.levels);
  const assets = useAssetStore((state) => state.assets);
  const {
    map: map5
  } = useMapbox();
  const {
    hasAnyLevelActive,
    bearing: bearing2,
    level,
    levelAssets
  } = React__default.useMemo(() => {
    if (!activeLevelId)
      return {
        hasAnyLevelActive: false,
        bearing: 0
      };
    const level2 = levels == null ? void 0 : levels.find((level3) => level3.id === activeLevelId);
    const levelAssets2 = assets == null ? void 0 : assets.filter((asset) => asset.parentId === activeLevelId);
    return {
      hasAnyLevelActive: !!level2,
      bearing: (level2 == null ? void 0 : level2.azimuth) || 0,
      level: level2,
      levelAssets: levelAssets2
    };
  }, [activeLevelId, assets, levels]);
  React__default.useLayoutEffect(() => {
    if (hasAnyLevelActive) {
      setActiveTiles("");
    } else {
      setActiveTiles(defaultTilesRef.current);
    }
  }, [hasAnyLevelActive, setActiveTiles, defaultTilesRef]);
  React__default.useLayoutEffect(() => {
    if (hasAnyLevelActive) {
      map5.setBearing(bearing2);
    } else {
      map5.setBearing(0);
    }
  }, [bearing2, hasAnyLevelActive, map5]);
  const [bounds, setBounds] = React__default.useState(null);
  React__default.useLayoutEffect(() => {
    if (hasAnyLevelActive) {
      updateCategoryVisibility("venue", false);
    } else {
      updateCategoryVisibility("venue", true);
    }
  }, [hasAnyLevelActive, updateCategoryVisibility]);
  React__default.useLayoutEffect(() => {
    var _a3;
    setBounds(null);
    if (!hasAnyLevelActive || !level)
      return;
    const boxes = [];
    if ((_a3 = level.features) == null ? void 0 : _a3.length) {
      const bbox22 = GeoUtil.getBoundingBox({
        type: "FeatureCollection",
        features: level.features
      });
      boxes.push(bbox22);
    }
    levelAssets == null ? void 0 : levelAssets.forEach((asset) => {
      if (asset == null ? void 0 : asset.box) {
        const bbox22 = GeoUtil.computeRectangle(asset.box);
        boxes.push(bbox22);
      }
    });
    if (!boxes.length)
      return;
    const bbox2 = GeoUtil.combineRectangles(boxes);
    const [west, south, east, north] = bbox2 || [];
    if (west && south && east && north)
      setBounds({
        west,
        south,
        east,
        north
      });
  }, [hasAnyLevelActive, level, levelAssets]);
  if (!bounds)
    return null;
  return /* @__PURE__ */ jsx(MapFitBounds, { ...bounds, bearing: bearing2 }, activeLevelId);
}
const {
  Title: Title$4
} = Typography;
function LayerForm(props) {
  const {
    onDone,
    value: data2,
    onChange,
    onDraw,
    mode: mode2,
    disabled,
    hidden,
    objectTypes
  } = props;
  const onSubmit = React__default.useCallback((values4) => {
    const finalValues = {
      ...values4 || {}
    };
    onDone(finalValues, mode2 === "Add");
  }, [mode2, onDone]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title$4, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: "Layer" }), []);
  const component = React__default.useCallback((params2) => /* @__PURE__ */ jsx(RightPanel, { ...params2, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}) }), []);
  React__default.useEffect(() => {
    const materialForm = false;
    if (!data2 || !materialForm)
      return;
    onDraw("polygon", true);
  }, [data2, onDraw]);
  const validateHasFeatures = React__default.useCallback(async () => {
    if (data2 == null ? void 0 : data2.hasFeatures)
      return;
    throw new Error("Add new features to the layer.");
  }, [data2]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { component, title, onCancel: () => onDone(), onSubmit, active: true, formValues: data2, onChange, marginVertical: 0, marginHorizontal: 0, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", initialValue: "layer", hidden: hidden.objectType, children: /* @__PURE__ */ jsx(Select, { placeholder: "Layer Type", data: objectTypes, value: data2.objectType, disabled: disabled.objectType }) }),
    /* @__PURE__ */ jsx(Row, { gutter: 8, children: /* @__PURE__ */ jsxs(Col, { span: 10, children: [
      /* @__PURE__ */ jsx(Form.Item, { name: "layerName", label: "Building Component Type", rules: [{
        required: true
      }, {
        validator: validateHasFeatures
      }], children: /* @__PURE__ */ jsx(Input$1, { controls: false, style: {
        width: "100%"
      }, block: 1, placeholder: "Enter Building Component Type" }) }),
      /* @__PURE__ */ jsx(Form.Item, { name: "hasFeatures", hidden: true })
    ] }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "buildingComponentName", label: "Building Component Name", children: /* @__PURE__ */ jsx(Input$1, { controls: false, style: {
      width: "100%"
    }, block: 1, placeholder: "Enter Building Component Name" }) })
  ] });
}
LayerForm.propTypes = {
  onDone: propTypesExports$1.func,
  onDraw: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object,
  mode: propTypesExports$1.string,
  disabled: propTypesExports$1.object,
  hidden: propTypesExports$1.object,
  objectTypes: propTypesExports$1.array
};
LayerForm.defaultProps = {
  onDone: () => {
  },
  onDraw: () => {
  },
  onChange: () => {
  },
  value: {},
  mode: "",
  disabled: {},
  hidden: {},
  objectTypes: []
};
const {
  Text: Text$4
} = Typography;
const textColor$1 = {
  border: "none",
  paddingLeft: "12px"
};
function getFormValues$1(object2) {
  if (!object2)
    return {};
  return {
    id: object2.id,
    layerName: object2.layerName
  };
}
function LayerInfo(props) {
  const {
    onDone,
    object: object2
  } = props;
  const {
    formValue,
    id
  } = React__default.useMemo(() => {
    if (!object2)
      return {};
    const formValue2 = getFormValues$1(object2);
    return {
      id: object2.id,
      formValue: formValue2
    };
  }, [object2]);
  if (!formValue) {
    return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Venue Information", onDone, children: [
      /* @__PURE__ */ jsx(Empty, {}),
      " "
    ] }, "null");
  }
  return /* @__PURE__ */ jsx(MapToolInfo, { title: "Floor Information", onDone, children: /* @__PURE__ */ jsx(Row, { gutter: 8, children: /* @__PURE__ */ jsx(Col, { span: 10, children: /* @__PURE__ */ jsx(Form.Item, { name: "layerName", label: "Layer Name", children: /* @__PURE__ */ jsx(Text$4, { style: {
    ...textColor$1
  }, children: formValue.layerName }) }) }) }) }, id);
}
LayerInfo.propTypes = {
  onDone: propTypesExports$1.func,
  object: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    layerName: propTypesExports$1.string
  })
};
LayerInfo.defaultProps = {
  onDone: () => {
  },
  object: {}
};
LayerInfo.getFormValues = getFormValues$1;
function LayerTool(props) {
  const {
    containerId,
    object: object2,
    onDone: onDoneIn,
    objectType,
    setObjectType,
    objectTypes,
    ...restProps
  } = props;
  const [showDrawTools] = React__default.useState(true);
  const materials = useMaterialStore((state) => state.materials);
  const updateFeatures = useSiteStore((state) => state.updateFeatures);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const activeLayerId = useViewStore((state) => state.activeLayerId);
  const levels = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.levels) == null ? void 0 : _a3.filter((level) => level.buildingId === activeBuildingId);
  });
  const activeBuilding = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.buildings) == null ? void 0 : _a3.find((building) => building.id === activeBuildingId);
  });
  const deleteFilteredFeatures = useSiteStore((state) => state.deleteFilteredFeatures);
  const mode2 = React__default.useMemo(() => {
    if (activeSubTool === "createLayer")
      return "Add";
    if (activeSubTool === "editLayer")
      return "Edit";
    return "";
  }, [activeSubTool]);
  const {
    formValue,
    id,
    features,
    subFormValue,
    center: center2,
    isCreate
  } = React__default.useMemo(() => {
    const isCreate2 = !object2 || !object2.id;
    const id2 = isCreate2 ? "newObject" : object2.id;
    const features2 = isCreate2 ? void 0 : object2.activeLayerFeatures;
    const hasFeatures = !!(features2 == null ? void 0 : features2.length);
    const formValue2 = isCreate2 ? {} : {
      ...LayerInfo.getFormValues(object2),
      layerName: activeLayerId,
      hasFeatures
    };
    return {
      id: id2,
      formValue: formValue2,
      features: features2,
      subFormValue: {},
      center: object2 == null ? void 0 : object2.center,
      isCreate: isCreate2
    };
  }, [object2, activeLayerId]);
  const onObjectTypeChange = React__default.useCallback((data2) => {
    if (!isCreate)
      return;
    if (!(data2 == null ? void 0 : data2.objectType))
      return;
    setObjectType(data2 == null ? void 0 : data2.objectType);
  }, [isCreate, setObjectType]);
  const onFeatureSelect = React__default.useCallback((feature2, materialData) => {
    var _a3;
    const materialId2 = (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.materialId;
    if (!materialId2)
      return [{}, feature2];
    const material = materials.find((m2) => (m2 == null ? void 0 : m2.id) === materialId2);
    if (!material)
      return [materialData, feature2];
    return [{
      material: material.id,
      objectType: material.typeId,
      objSubType: material.subtypeId
    }, feature2];
  }, [materials]);
  const onFeaturesDelete = React__default.useCallback((features2) => {
    if (!(features2 == null ? void 0 : features2.length))
      return null;
    const {
      id: id2,
      type
    } = object2 || {};
    const filter17 = (feature2) => !!features2.find((f2) => f2.id === feature2.id);
    if (id2 && type)
      deleteFilteredFeatures({
        parentId: id2,
        parentType: type
      }, filter17);
    return null;
  }, [deleteFilteredFeatures, object2]);
  const updateFeatureProperties = React__default.useCallback((feature2, properties) => {
    if (!feature2)
      return feature2;
    const updatedFeature = {
      ...feature2
    };
    updatedFeature.properties = {
      ...feature2.properties || {},
      ...properties || {}
    };
    return updatedFeature;
  }, []);
  const onMaterialChange = React__default.useCallback((materialData, feature2, drawMode) => {
    var _a3;
    const materialId2 = ((_a3 = materialData == null ? void 0 : materialData.target) == null ? void 0 : _a3.value) || (materialData == null ? void 0 : materialData.material);
    const material = materials.find((m2) => (m2 == null ? void 0 : m2.id) === materialId2);
    if (!material)
      return [materialData, feature2];
    const style2 = {
      stroke: material.color,
      "stroke-opacity": material.opacity / 100,
      "fill-opacity": material.opacity / 100,
      fill: material.color
    };
    const properties = {
      ...material,
      materialId: materialId2,
      drawMode,
      category: material.typeId,
      ...style2
      // apply style to the feature
    };
    const updateFeatures2 = features && features.length > 1 ? features == null ? void 0 : features.map((f2) => updateFeatureProperties(f2, properties)) : updateFeatureProperties(feature2, properties);
    return [materialData, updateFeatures2];
  }, [materials, updateFeatureProperties, features]);
  const onFeatureChange = React__default.useCallback((feature2, drawMode, materialData) => {
    var _a3, _b3;
    const materialId2 = ((_a3 = materialData == null ? void 0 : materialData.target) == null ? void 0 : _a3.value) || (materialData == null ? void 0 : materialData.material);
    const material = materials.find((m2) => (m2 == null ? void 0 : m2.id) === materialId2);
    if (!feature2)
      return null;
    if (!feature2.id)
      feature2.id = generateUid();
    feature2.properties.drawMode = drawMode;
    feature2.properties.category = material == null ? void 0 : material.typeId;
    const updatedFeature = (_b3 = onMaterialChange(materialData, feature2, drawMode)) == null ? void 0 : _b3[1];
    return [{
      hasFeatures: !!updatedFeature
    }, updatedFeature];
  }, [materials, onMaterialChange]);
  const onDone = React__default.useCallback((data2) => {
    const {
      formValue: values4,
      features: allFeatures
    } = data2 || {};
    if (!values4 || !(values4 == null ? void 0 : values4.layerName)) {
      onDoneIn();
      return;
    }
    const features2 = [];
    allFeatures == null ? void 0 : allFeatures.forEach((afeature) => {
      const feature2 = {
        ...afeature,
        properties: {
          ...afeature.properties
        }
      };
      if (!feature2.id)
        feature2.id = generateUid();
      if (!feature2.properties.category || feature2.properties.category === "orphan")
        feature2.properties.category = "custom";
      feature2.properties.layer = values4.layerName;
      features2.push(feature2);
    });
    updateFeatures({
      features: features2,
      parentId: id,
      parentType: "level"
    });
    onDoneIn();
  }, [id, onDoneIn, updateFeatures]);
  return /* @__PURE__ */ jsx(MapToolForm, { containerId, component: LayerForm, subComponent: MaterialForm, initialValue: formValue, componentProps: {
    levels,
    building: activeBuilding,
    activeLayerId,
    disabled: {
      objectType: !isCreate
    },
    objectTypes,
    mode: mode2
  }, subInitialValue: subFormValue, noSubFormCancel: true, features, onDone, onFeatureSelect, onFeaturesDelete, onFeatureChange, onFormChange: onObjectTypeChange, onSubFormChange: onMaterialChange, center: center2, materials, showDrawTools, ...restProps });
}
LayerTool.propTypes = {
  containerId: propTypesExports$1.string,
  object: propTypesExports$1.object,
  onDone: propTypesExports$1.func,
  objectType: propTypesExports$1.string,
  setObjectType: propTypesExports$1.func,
  objectTypes: propTypesExports$1.array
};
LayerTool.defaultProps = {
  containerId: "",
  object: null,
  onDone: () => {
  },
  objectType: "layer",
  // cad-layer
  setObjectType: () => {
  },
  objectTypes: []
};
const {
  Title: Title$3
} = Typography;
function AssetForm(props) {
  const {
    onDone,
    value,
    onChange
  } = props;
  const data2 = React__default.useMemo(() => {
    if (!value)
      return value;
    return {
      opacity: typeof value.opacity === "number" ? value.opacity * 100 : 100,
      name: value.name
    };
  }, [value]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title$3, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: "Edit Image" }), []);
  const onSubmit = React__default.useCallback((values4) => {
    const newValues = {
      opacity: typeof values4.opacity === "number" ? Math.round(values4.opacity) / 100 : 1,
      name: values4.name
    };
    onDone(newValues);
  }, [onDone]);
  const onValuesChange = React__default.useCallback((values4) => {
    const newValues = {
      opacity: typeof values4.opacity === "number" ? Math.round(values4.opacity) / 100 : 1,
      name: values4.name
    };
    onChange(newValues);
  }, [onChange]);
  const component = React__default.useCallback((params2) => /* @__PURE__ */ jsx(RightPanel, { ...params2, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}) }), []);
  if (!value)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { component, title, onCancel: () => onDone(), onSubmit, active: true, formValues: data2, onChange: onValuesChange, marginVertical: 0, marginHorizontal: 0, footerStyle: {
    marginLeft: 0,
    position: "absolute",
    bottom: 0,
    marginBottom: "10px",
    width: "calc(100% - 60px)"
  }, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Name", children: /* @__PURE__ */ jsx(Input$2, {}) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "opacity", label: "Opacity", children: /* @__PURE__ */ jsx(NumberSlider, { min: 0, max: 100, step: 1 }) })
  ] });
}
AssetForm.propTypes = {
  onDone: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object
};
AssetForm.defaultProps = {
  onDone: () => {
  },
  onChange: () => {
  },
  value: {}
};
function AssetTool(props) {
  const {
    containerId,
    object: object2,
    onDone: onDoneIn,
    ...restProps
  } = props;
  const getAsset = useAssetStore((state) => state.getAsset);
  const updateAssetInStore = useAssetStore((state) => state.updateAsset);
  const {
    formValue,
    assetId
  } = React__default.useMemo(() => {
    const formValue2 = object2 || {};
    const assetId2 = object2 == null ? void 0 : object2.id;
    return {
      formValue: formValue2,
      assetId: assetId2
    };
  }, [object2]);
  const updateAsset = React__default.useCallback((values4) => {
    if (!values4)
      return null;
    const asset = getAsset(assetId);
    if (!asset)
      return null;
    const {
      opacity,
      name: name2
    } = values4;
    const updatedAsset = {
      ...asset
    };
    if (typeof opacity === "number")
      updatedAsset.opacity = opacity;
    if (typeof name2 === "string")
      updatedAsset.name = name2;
    return updatedAsset;
  }, [assetId, getAsset]);
  const onFormChange = React__default.useCallback((values4) => {
    const updatedAsset = updateAsset(values4);
    return [values4, updatedAsset];
  }, [updateAsset]);
  const onDone = React__default.useCallback((data2) => {
    const {
      formValue: values4
    } = data2 || {};
    const updatedAsset = updateAsset(values4);
    updateAssetInStore(updatedAsset);
    onDoneIn();
  }, [onDoneIn, updateAsset, updateAssetInStore]);
  return /* @__PURE__ */ jsx(MapToolForm, { containerId, component: AssetForm, initialValue: formValue, onDone, onFormChange, ...restProps });
}
AssetTool.propTypes = {
  containerId: propTypesExports$1.string,
  object: propTypesExports$1.object,
  onDone: propTypesExports$1.func
};
AssetTool.defaultProps = {
  containerId: "",
  object: null,
  onDone: () => {
  }
};
const {
  Title: Title$2
} = Typography;
function FeatureForm(props) {
  const {
    onDone,
    value,
    onChange
  } = props;
  const data2 = React__default.useMemo(() => {
    if (!value)
      return value;
    return {
      name: value.name
    };
  }, [value]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title$2, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: "Rename Feature" }), []);
  const onSubmit = React__default.useCallback((values4) => {
    onDone(values4);
  }, [onDone]);
  const onValuesChange = React__default.useCallback((values4) => {
    onChange(values4);
  }, [onChange]);
  const component = React__default.useCallback((params2) => /* @__PURE__ */ jsx(RightPanel, { ...params2, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, {}) }), []);
  if (!value)
    return null;
  return /* @__PURE__ */ jsx(ModalForm, { component, title, onCancel: () => onDone(), onSubmit, active: true, formValues: data2, onChange: onValuesChange, marginVertical: 0, marginHorizontal: 0, footerStyle: {
    marginLeft: 0,
    position: "absolute",
    bottom: 0,
    marginBottom: "10px",
    width: "calc(100% - 60px)"
  }, children: /* @__PURE__ */ jsx(Form.Item, { name: "name", label: "Name", children: /* @__PURE__ */ jsx(Input$2, {}) }) });
}
FeatureForm.propTypes = {
  onDone: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object
};
FeatureForm.defaultProps = {
  onDone: () => {
  },
  onChange: () => {
  },
  value: {}
};
function FeatureTool(props) {
  const {
    containerId,
    object: object2,
    onDone: onDoneIn,
    ...restProps
  } = props;
  const updateFeature = useSiteStore((state) => state.updateFeature);
  const formValue = React__default.useMemo(() => ({
    name: object2.name
  }), [object2]);
  const onDone = React__default.useCallback((data2) => {
    const {
      formValue: values4
    } = data2 || {};
    if (values4 == null ? void 0 : values4.name) {
      const feature2 = {
        ...object2,
        name: values4.name,
        properties: {
          ...object2.properties,
          ...values4
        }
      };
      updateFeature({
        feature: feature2,
        parentId: feature2.properties.parentId,
        category: feature2.properties.category,
        parentType: feature2.properties.parentType
      });
    }
    onDoneIn();
  }, [onDoneIn, updateFeature, object2]);
  return /* @__PURE__ */ jsx(MapToolForm, { containerId, component: FeatureForm, initialValue: formValue, onDone, ...restProps });
}
FeatureTool.propTypes = {
  containerId: propTypesExports$1.string,
  object: propTypesExports$1.object,
  onDone: propTypesExports$1.func
};
FeatureTool.defaultProps = {
  containerId: "",
  object: null,
  onDone: () => {
  }
};
const {
  Text: Text$2
} = Typography;
const textColor = {
  border: "none",
  paddingLeft: "12px"
};
function getFormValues(object2) {
  if (!object2)
    return {};
  return {
    id: object2.id,
    objectType: object2.objectType,
    name: object2.name
  };
}
function GenericInfo(props) {
  const {
    onDone,
    object: object2
  } = props;
  const {
    formValue,
    id
  } = React__default.useMemo(() => {
    if (!object2)
      return {};
    const formValue2 = getFormValues(object2);
    return {
      id: object2.id,
      formValue: formValue2
    };
  }, [object2]);
  if (!formValue) {
    return /* @__PURE__ */ jsxs(MapToolInfo, { title: "Venue Information", onDone, children: [
      /* @__PURE__ */ jsx(Empty, {}),
      " "
    ] }, "null");
  }
  return /* @__PURE__ */ jsxs(MapToolInfo, { title: formValue.name || "", onDone, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", children: /* @__PURE__ */ jsx(Text$2, { style: {
      ...textColor
    }, children: formValue.objectType }) }),
    /* @__PURE__ */ jsx(Form.Item, { name: "name", label: `${formValue.objectType} Name`, children: /* @__PURE__ */ jsx(Text$2, { style: {
      ...textColor
    }, children: formValue.name }) })
  ] }, id);
}
GenericInfo.propTypes = {
  onDone: propTypesExports$1.func,
  object: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    name: propTypesExports$1.string,
    venueType: propTypesExports$1.string,
    center: propTypesExports$1.array,
    address: propTypesExports$1.object,
    temporaryEvent: propTypesExports$1.bool,
    thumbnail: propTypesExports$1.string,
    numBuildings: propTypesExports$1.number,
    numDevices: propTypesExports$1.number,
    numLevels: propTypesExports$1.number
  })
};
GenericInfo.defaultProps = {
  onDone: () => {
  },
  object: {}
};
GenericInfo.getFormValues = getFormValues;
const {
  Title
} = Typography;
const EXTENSIONS = ["png", "jpg"];
function GenericForm(props) {
  const {
    onDone,
    value: data2,
    onChange,
    onUpload,
    mode: mode2,
    subForm: SubForm,
    subFormProps,
    disabled,
    hidden,
    objectTypes,
    validator: validator2,
    onExport
  } = props;
  const {
    token
  } = theme$2.useToken();
  const [helperData, setHelperData] = React__default.useState({});
  const objectLabel = React__default.useMemo(() => {
    const {
      objectType
    } = data2 || {
      objectType: ""
    };
    return makeFirstLetterCapital(objectType);
  }, [data2]);
  const isCreate = mode2 === "Add";
  const formTitle = React__default.useMemo(() => {
    if (!mode2)
      return null;
    const mode22 = isCreate ? "New" : mode2;
    return `${mode22} ${objectLabel}`;
  }, [isCreate, mode2, objectLabel]);
  const onFormValuesChange = React__default.useCallback((data22) => {
    onChange(data22);
  }, [onChange]);
  const onSubmit = React__default.useCallback((values4) => {
    onDone(values4, isCreate);
  }, [isCreate, onDone]);
  const title = React__default.useMemo(() => /* @__PURE__ */ jsx(Title, { strong: true, level: 4, style: {
    marginTop: "8px",
    marginBottom: "14px",
    border: "none"
  }, children: formTitle }), [formTitle]);
  const isCountryForm = (data2 == null ? void 0 : data2.objectType) === "country";
  const isZoneForm = (data2 == null ? void 0 : data2.objectType) === "zone";
  const drawButtonLabel = isCountryForm || (data2 == null ? void 0 : data2.hasFeatures) ? "Show boundaries" : "Draw boundaries";
  const drawButtonIcon = React__default.useMemo(() => {
    if (isCountryForm || (data2 == null ? void 0 : data2.hasFeatures)) {
      return /* @__PURE__ */ jsx(Icons.Polygon, { style: {
        fontSize: "20px",
        color: "transparent"
      } });
    }
    return /* @__PURE__ */ jsx(Icons.PenIconDark, { style: {
      fontSize: "20px",
      color: "transparent"
    } });
  }, [data2 == null ? void 0 : data2.hasFeatures, isCountryForm]);
  const validateHasFeatures = React__default.useCallback(async () => {
    if ((data2 == null ? void 0 : data2.hasFeatures) || isCountryForm)
      return;
    throw new Error("Draw or Import new features to the layer");
  }, [data2 == null ? void 0 : data2.hasFeatures, isCountryForm]);
  const component = React__default.useCallback((params2) => {
    const newParams = {
      ...params2,
      exportDetails: !isCreate ? {
        onClick: onExport,
        hidden: hidden.download,
        disabled: disabled.download,
        rules: [{
          validator: validateHasFeatures
        }]
      } : null,
      importDetails: isCreate ? {
        onClick: () => onUpload(EXTENSIONS),
        hidden: hidden.upload,
        disabled: disabled.upload,
        rules: [{
          validator: validateHasFeatures
        }]
      } : null
    };
    return /* @__PURE__ */ jsx(RightPanel, { ...newParams, closable: true, closeIcon: /* @__PURE__ */ jsx(CloseOutlined, { style: {
      color: token.colorIcon
    } }) });
  }, [token.colorIcon, isCreate, onUpload, hidden.download, disabled.download, hidden.upload, disabled.upload, onExport, validateHasFeatures]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsxs(ModalForm, { component, title, onCancel: () => onDone(), onSubmit, showErrors: true, active: true, formValues: data2, onChange: onFormValuesChange, marginVertical: 0, marginHorizontal: 0, bodyStyle: {
    padding: "8px 24px 0px 24px"
  }, footerStyle: {
    width: "100%",
    padding: 0
  }, children: [
    /* @__PURE__ */ jsx(Form.Item, { name: "objectType", label: "Layer Type", hidden: hidden.objectType, children: /* @__PURE__ */ jsx(Select, { placeholder: "Layer Type", data: objectTypes, value: data2.objectType, disabled: disabled.objectType }) }),
    isZoneForm && /* @__PURE__ */ jsx(Form.Item, { name: "zoneType", label: "Zone Type", hidden: hidden.zoneType, children: /* @__PURE__ */ jsx(Input$1, { placeholder: "Enter Zone Type", disabled: disabled.zoneType }) }),
    isCountryForm && /* @__PURE__ */ jsx(AddressSelector, { onChange: setHelperData, value: helperData }),
    /* @__PURE__ */ jsxs(Form.Item, { name: "name", label: `${objectLabel} Name`, rules: [{
      required: true,
      validator: () => validator2(data2)
    }], hidden: hidden.name, children: [
      !isCountryForm && /* @__PURE__ */ jsx(Input$1, { placeholder: `Enter ${objectLabel} Name`, disabled: disabled.name, filled: true }),
      isCountryForm && /* @__PURE__ */ jsx(
        Select,
        {
          placeholder: "Choose Country",
          showSearch: true,
          data: helperData == null ? void 0 : helperData.countries,
          disabled: disabled.name
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Form.Item, { name: "hasFeatures", hidden: true }),
    /* @__PURE__ */ jsx(Form.Item, { name: "draw", rules: [{
      validator: validateHasFeatures
    }], label: /* @__PURE__ */ jsxs(Typography.Text, { style: {
      paddingBottom: "8px"
    }, children: [
      objectLabel,
      " Boundaries"
    ] }), hidden: !!SubForm && !!(subFormProps == null ? void 0 : subFormProps.open), children: /* @__PURE__ */ jsx(Button, { type: "primary", size: "large", ghost: true, icon: drawButtonIcon, onClick: () => {
      var _a3;
      return (_a3 = subFormProps == null ? void 0 : subFormProps.setOpen) == null ? void 0 : _a3.call(subFormProps, true);
    }, children: drawButtonLabel }) }),
    SubForm && /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
      width: "100%"
    }, children: [
      !!(subFormProps == null ? void 0 : subFormProps.open) && /* @__PURE__ */ jsxs(Typography.Text, { style: {
        paddingBottom: "8px"
      }, children: [
        objectLabel,
        " Boundaries"
      ] }),
      /* @__PURE__ */ jsx(SubForm, { ...subFormProps })
    ] }),
    /* @__PURE__ */ jsx(Form.Item, { label: "Is Bulk Data?", name: "isBulkUpload", initialValue: false, valuePropName: "checked", hidden: hidden.isBulkUpload, children: /* @__PURE__ */ jsx(Switch$1, { disabled: disabled.isBulkUpload }) })
  ] }, objectLabel);
}
GenericForm.propTypes = {
  onDone: propTypesExports$1.func,
  onUpload: propTypesExports$1.func,
  onChange: propTypesExports$1.func,
  value: propTypesExports$1.object,
  mode: propTypesExports$1.string,
  subForm: propTypesExports$1.any,
  subFormProps: propTypesExports$1.object,
  disabled: propTypesExports$1.object,
  hidden: propTypesExports$1.object,
  objectTypes: propTypesExports$1.array,
  validator: propTypesExports$1.func,
  onExport: propTypesExports$1.func
};
GenericForm.defaultProps = {
  onDone: () => {
  },
  onUpload: () => {
  },
  onChange: () => {
  },
  value: {},
  mode: null,
  subForm: null,
  subFormProps: {},
  disabled: {},
  hidden: {},
  objectTypes: [],
  validator: () => {
  },
  onExport: () => {
  }
};
function GenericTool(props) {
  const {
    object: object2,
    objectType: initialObjectType,
    onDone: onDoneIn,
    territoryPropName,
    ...restProps
  } = props;
  const addToCollection = useSiteStore((state) => state.addToCollection);
  const updateFeature = useSiteStore((state) => state.updateFeature);
  const setActiveObjectId = useViewStore((state) => state.setActiveObjectId);
  const countries = useSiteStore((state) => state.countries);
  const [territoryType, setTerritoryType] = React__default.useState("");
  const {
    isCreate,
    objectType
  } = React__default.useMemo(() => {
    const isCreate2 = !object2 || !object2.id;
    const objectType2 = (object2 == null ? void 0 : object2.objectType) || initialObjectType;
    return {
      isCreate: isCreate2,
      objectType: objectType2
    };
  }, [initialObjectType, object2]);
  const isCountry = objectType === "country";
  React__default.useEffect(() => {
    if (isCountry) {
      setTerritoryType("country");
    } else {
      setTerritoryType("");
    }
  }, [isCountry, objectType]);
  const countryValidator = React__default.useCallback(async (data2) => {
    if (!data2)
      return;
    const {
      name: name2,
      objectType: objectType2,
      id
    } = data2;
    if (!name2) {
      throw new Error("Enter name");
    }
    if (objectType2 !== "country" || !name2)
      return;
    const found = countries == null ? void 0 : countries.find((country) => country.name === name2);
    if (found) {
      if (isCreate || found.id !== id) {
        throw new Error("Duplicate country cannot be created");
      }
    }
  }, [countries, isCreate]);
  const getTerritorialFeature = React__default.useCallback((values4) => {
    var _a3;
    const {
      objectType: objectType2,
      name: name2
    } = values4 || {};
    if (objectType2 === "country" && name2) {
      const country = Countries$1.find((item) => item.name === name2);
      if (country == null ? void 0 : country.bounding_box) {
        const [west, south, east, north] = country.bounding_box;
        const feature2 = {
          type: "Feature",
          properties: {
            category: "footprint",
            drawMode: "Polygon",
            filterKey: name2,
            name: name2,
            territoryType: "country",
            visible: false
          },
          geometry: {
            type: "Polygon",
            coordinates: [[
              [west, south],
              // Bottom-left corner
              [east, south],
              // Bottom-right corner
              [east, north],
              // Top-right corner
              [west, north],
              // Top-left corner
              [west, south]
              // Bottom-left corner
            ]]
          }
        };
        let found = null;
        if (object2 == null ? void 0 : object2.id) {
          found = countries == null ? void 0 : countries.find((country2) => country2.id === object2.id);
        }
        if (!found) {
          found = countries == null ? void 0 : countries.find((country2) => country2.name === name2);
        }
        if ((_a3 = found == null ? void 0 : found.features) == null ? void 0 : _a3.length) {
          feature2.id = found.features[0].id;
        }
        return feature2;
      }
    }
    return null;
  }, [countries, object2 == null ? void 0 : object2.id]);
  const getFeatures = React__default.useCallback((isCreate2, object22) => {
    const features = isCreate2 ? void 0 : object22 == null ? void 0 : object22.allFeatures;
    return features;
  }, []);
  const getFormValue = React__default.useCallback((isCreate2, object22, defaultValue2) => {
    const formValue = isCreate2 ? defaultValue2 : VenueInfo.getFormValues(object22);
    return formValue;
  }, []);
  const onDone = React__default.useCallback((objects, ids) => {
    if (!(objects == null ? void 0 : objects.length)) {
      onDoneIn();
      return;
    }
    objects.forEach((obj, index2, array2) => {
      const {
        objectType: objectType2,
        name: name2 = "Untitled"
      } = obj;
      const territoryProps = {};
      const zoneTypeProps = {};
      if (objectType2 === "country") {
        territoryProps.filterKey = name2;
        territoryProps[territoryPropName] = objectType2;
      } else if (objectType2 === "zone") {
        zoneTypeProps.zoneType = obj.zoneType || "";
      }
      addToCollection(objectType2, {
        name: name2,
        ...territoryProps,
        ...ids,
        ...zoneTypeProps
      }, (parentId) => {
        obj.features.forEach((feature2) => {
          feature2.properties.parentId = parentId;
          feature2.properties.parentType = objectType2;
          delete feature2.properties.visible;
          updateFeature({
            feature: feature2,
            parentId,
            category: feature2.properties.category,
            parentType: objectType2
          });
        });
        if (array2.length - 1 === index2) {
          setActiveObjectId(objectType2, parentId);
          onDoneIn(parentId);
        }
      });
    });
  }, [addToCollection, territoryPropName, updateFeature, setActiveObjectId, onDoneIn]);
  return /* @__PURE__ */ jsx(BaseTool, { component: GenericForm, subComponent: StyleForm, getFeatures, getFormValue, onDone, enableBulkUpload: isCreate, validator: countryValidator, drawMode: isCountry ? "select-country" : "polygon", showDrawTools: !isCountry, getTerritorialFeature, territoryType, setTerritoryType, object: object2, objectType, territoryPropName, ...restProps });
}
GenericTool.propTypes = {
  onDone: propTypesExports$1.func,
  object: propTypesExports$1.object,
  objectType: propTypesExports$1.string,
  territoryPropName: propTypesExports$1.string
};
GenericTool.defaultProps = {
  onDone: () => {
  },
  object: null,
  objectType: "country",
  territoryPropName: "territoryType"
};
function MapTools(props) {
  const {
    id: activeId,
    deviceTypes
  } = props;
  const setActiveFormFeatureIds = useViewStore((state) => state.setActiveFormFeatureIds);
  const activeSubToolIn = useViewStore((state) => state.activeSubTool);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const setActiveTool = useViewStore((state) => state.setActiveTool);
  const getDisplayMode = useViewStore((state) => () => state.displayMode);
  const resetActiveFormControl = useViewStore((state) => state.resetActiveFormControl);
  const activeFeatureId = useViewStore((state) => state.activeFeatureId);
  const activeApFeatureId = useViewStore((state) => state.activeApFeatureId);
  const editAssetId = useAssetStore((state) => state.editAssetId);
  const getAsset = useAssetStore((state) => state.getAsset);
  const tilesetUrl = useViewStore((state) => state.defaultTiles);
  const objectTypes = useSiteObjectTypes(true);
  const {
    viewInfo
  } = useMapbox({
    enableViewInfo: true
  });
  const {
    center: viewCenter,
    bearing: bearing2
  } = viewInfo || {};
  const viewCenterRef = useValueRef(viewCenter);
  const found = useFeatures({
    id: activeId,
    fallback: false,
    recursive: false
  });
  const {
    activeSubTool,
    isUpload,
    ...activeSubToolRest
  } = React__default.useMemo(() => {
    if (activeSubToolIn === "createUpload") {
      return {
        activeSubTool: "createRegion",
        isUpload: true
      };
    }
    if (activeSubToolIn === "createUploadAssets") {
      return {
        activeSubTool: "createAccessPoint",
        isUpload: true,
        isAssetsUpload: true
      };
    }
    return {
      activeSubTool: activeSubToolIn,
      isUpload: false
    };
  }, [activeSubToolIn]);
  const object2 = React__default.useMemo(() => {
    var _a3, _b3, _c2, _d2, _e2, _f3;
    if (!found)
      return null;
    if (found.id !== activeId)
      return null;
    if (activeSubTool === "editAsset") {
      return getAsset(editAssetId);
    }
    if (["renameFeature", "createAccessPoint", "editAccessPoint", "exportAccessPoint"].includes(activeSubTool)) {
      const feature2 = found.allFeatures.find((f2) => f2.id === activeFeatureId || f2.id === activeApFeatureId);
      return feature2 || null;
    }
    if (["country", "region", "market", "cluster", "zone"].includes(found.type)) {
      if (["viewCountry", "viewRegion", "viewMarket", "viewCluster", "viewZone", "editCountry", "editRegion", "editMarket", "editCluster", "editZone", "exportMcr"].includes(activeSubTool)) {
        return found;
      }
      if (["createCountry", "createRegion", "createMarket", "createCluster", "createZone"].includes(activeSubTool) && activeSubTool.toLowerCase().endsWith(found.type)) {
        return found;
      }
      return null;
    }
    if (found.type === "venue") {
      if (["viewVenue", "createVenue", "editVenue", "exportVenue"].includes(activeSubTool)) {
        const venueBuildingIds = (_b3 = (_a3 = useSiteStore.getState().buildings) == null ? void 0 : _a3.filter((b2) => b2.venueId === activeId)) == null ? void 0 : _b3.map((b2) => b2.id);
        const venueLevels = (_c2 = useSiteStore.getState().levels) == null ? void 0 : _c2.filter((l2) => venueBuildingIds.includes(l2.buildingId));
        return {
          ...found,
          numBuildings: (venueBuildingIds == null ? void 0 : venueBuildingIds.length) || 0,
          numLevels: (venueLevels == null ? void 0 : venueLevels.length) || 0
        };
      }
      return null;
    }
    if (found.type === "building") {
      if (["viewBuilding", "createBuilding", "editBuilding", "exportBuilding"].includes(activeSubTool)) {
        return {
          ...found,
          numLevelsInUse: ((_e2 = (_d2 = useSiteStore.getState().levels) == null ? void 0 : _d2.filter((l2) => l2.buildingId === activeId)) == null ? void 0 : _e2.length) || 0
        };
      }
      return null;
    }
    if (found.type === "level") {
      if (["viewLevel", "createLevel", "editLevel", "exportLevel", "editLayer", "createLayer"].includes(activeSubTool)) {
        const building = (_f3 = useSiteStore.getState().buildings) == null ? void 0 : _f3.find((b2) => b2.id === found.buildingId);
        return {
          ...found,
          center: building == null ? void 0 : building.center
        };
      }
      return null;
    }
    return null;
  }, [found, activeId, activeSubTool, getAsset, editAssetId, activeFeatureId, activeApFeatureId]);
  const onDone = React__default.useCallback(() => {
    setActiveSubTool(null);
    setActiveTool(null);
    resetActiveFormControl();
  }, [resetActiveFormControl, setActiveSubTool, setActiveTool]);
  const toolsProps = React__default.useMemo(() => {
    var _a3;
    const params2 = {
      getDisplayMode,
      onDone,
      tilesetUrl,
      object: {
        ...object2 || {}
      },
      objectTypes
    };
    if (activeSubTool == null ? void 0 : activeSubTool.startsWith("create")) {
      const objectType = makeFirstLetterSmall(activeSubTool.replace("create", ""));
      params2.objectType = objectType;
      params2.setObjectType = (newObjectType) => {
        if (!newObjectType || newObjectType === objectType)
          return;
        const newSubTool = `create${makeFirstLetterCapital(newObjectType)}`;
        setActiveSubTool(newSubTool);
      };
    } else if (activeSubTool == null ? void 0 : activeSubTool.startsWith("edit")) {
      params2.objectType = params2.object.type;
      if (params2.objectType === "Feature") {
        params2.objectType = (_a3 = params2.object.properties) == null ? void 0 : _a3.category;
      }
    }
    if (params2.objectType === "accessPoint") {
      delete params2.object.center;
      if (!Object.keys(params2.object).length) {
        params2.object = null;
      }
    } else if (!params2.object.center) {
      params2.object.center = viewCenterRef.current;
    }
    if (isUpload) {
      if (activeSubToolRest.isAssetsUpload) {
        params2.initialUploadExtensions = ["csv"];
      } else {
        params2.initialUploadExtensions = ["png", "jpeg"];
      }
    }
    return params2;
  }, [getDisplayMode, onDone, tilesetUrl, activeSubTool, objectTypes, object2, setActiveSubTool, viewCenterRef, isUpload, activeSubToolRest]);
  React__default.useLayoutEffect(() => {
    var _a3;
    if ((activeSubTool == null ? void 0 : activeSubTool.startsWith("edit")) || (activeSubTool == null ? void 0 : activeSubTool.startsWith("create"))) {
      const ids = (_a3 = object2 == null ? void 0 : object2.allFeatures) == null ? void 0 : _a3.map((f2) => f2.id);
      setActiveFormFeatureIds(ids);
    } else {
      setActiveFormFeatureIds();
    }
  }, [activeSubTool, object2 == null ? void 0 : object2.allFeatures, setActiveFormFeatureIds]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(LevelConfig, {}),
    ["viewZone", "viewRegion", "viewMarket", "viewCluster", "viewCountry"].includes(activeSubTool) && /* @__PURE__ */ jsx(GenericInfo, { object: object2, onDone }),
    ["editZone", "editRegion", "editMarket", "editCluster", "editCountry"].includes(activeSubTool) && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(GenericTool, { ...toolsProps }),
    ["createRegion", "createMarket", "createCluster", "createCountry", "createZone"].includes(activeSubTool) && /* @__PURE__ */ jsx(GenericTool, { ...toolsProps }),
    activeSubTool === "exportMcr" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(ExportTool, { onCancel: onDone, active: true, onDone, activeId: object2.id, outputFilename: object2.name }),
    activeSubTool === "viewVenue" && /* @__PURE__ */ jsx(VenueInfo, { object: object2, onDone }),
    activeSubTool === "editVenue" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(VenueTool, { ...toolsProps }),
    activeSubTool === "createVenue" && /* @__PURE__ */ jsx(VenueTool, { ...toolsProps }),
    activeSubTool === "exportVenue" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(ExportTool, { onCancel: onDone, active: true, onDone, activeId: object2.id, outputFilename: object2.name }),
    activeSubTool === "createBuilding" && /* @__PURE__ */ jsx(BuildingTool, { ...toolsProps }),
    activeSubTool === "editBuilding" && /* @__PURE__ */ jsx(BuildingTool, { ...toolsProps }),
    activeSubTool === "viewBuilding" && /* @__PURE__ */ jsx(BuildingInfo, { object: object2, onDone }),
    activeSubTool === "exportBuilding" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(ExportTool, { onCancel: onDone, active: true, onDone, activeId: object2.id, outputFilename: object2.name }),
    activeSubTool === "viewLevel" && /* @__PURE__ */ jsx(LevelInfo, { object: object2, onDone }),
    activeSubTool === "editLevel" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(LevelTool, { ...toolsProps, bearing: bearing2 }),
    activeSubTool === "createLevel" && /* @__PURE__ */ jsx(LevelTool, { ...toolsProps }),
    activeSubTool === "exportLevel" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(ExportTool, { onCancel: onDone, active: true, onDone, activeId: object2.id, outputFilename: object2.name }),
    activeSubTool === "editAccessPoint" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(AccessPointTool, { ...toolsProps }),
    activeSubTool === "createAccessPoint" && /* @__PURE__ */ jsx(AccessPointTool, { ...toolsProps }),
    activeSubTool === "exportAccessPoint" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(ExportTool, { onCancel: onDone, active: true, onDone, activeId: object2.id, outputFilename: object2.name }),
    activeSubTool === "renameFeature" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(FeatureTool, { ...toolsProps }),
    activeSubTool === "editLayer" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(LayerTool, { ...toolsProps }),
    activeSubTool === "editAsset" && (object2 == null ? void 0 : object2.id) && /* @__PURE__ */ jsx(AssetTool, { ...toolsProps, deviceTypes }),
    activeSubTool === "createLayer" && /* @__PURE__ */ jsx(LayerTool, { ...toolsProps })
  ] });
}
MapTools.propTypes = {
  id: propTypesExports$1.string,
  deviceTypes: propTypesExports$1.array
};
MapTools.defaultProps = {
  id: "",
  deviceTypes: []
};
const featuresMapView_module = {};
const KEY$1 = "showHideTile";
function MapTilesToggle(props) {
  const defaultTiles = useViewStore((state) => state.defaultTiles);
  const activeTiles = useViewStore((state) => state.activeTiles);
  const setActiveTiles = useViewStore((state) => state.setActiveTiles);
  const disabledToolButtons = useViewStore((state) => state.disabledToolButtons);
  const onToggle = React__default.useCallback((active3) => {
    if (active3) {
      setActiveTiles(defaultTiles);
    } else {
      setActiveTiles("");
    }
  }, [defaultTiles, setActiveTiles]);
  return /* @__PURE__ */ jsx(OverlayPanel, { width: 28, height: 28, marginVertical: 240, marginHorizontal: 12, placement: "bottom-right", ...props, children: /* @__PURE__ */ jsx(ToggleButton, { id: KEY$1, icon: /* @__PURE__ */ jsx(BsMap, {}), active: !!activeTiles, onToggle, disabled: disabledToolButtons == null ? void 0 : disabledToolButtons.includes(KEY$1), tooltip: "Tiles On/Off" }) });
}
const BASE_STYLE = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minWidth: "28px",
  minHeight: "28px",
  borderRadius: "7px",
  cursor: "pointer"
};
function DisplayModeToggle(props) {
  const {
    width,
    height,
    marginHorizontal,
    marginVertical,
    placement
  } = props;
  const selectedMode = useViewStore((state) => state.displayMode);
  const setDisplayMode = useViewStore((state) => state.setDisplayMode);
  const {
    token
  } = theme$2.useToken();
  const onButtonClick = React__default.useCallback((mode2) => {
    setDisplayMode(mode2);
  }, [setDisplayMode]);
  return /* @__PURE__ */ jsx(OverlayPanel, { width, height, marginHorizontal, marginVertical, placement, children: /* @__PURE__ */ jsx(Col, { gutter: 8, style: {
    width: "100%",
    height: "100%",
    margin: 0
  }, children: /* @__PURE__ */ jsxs(Col, { style: {
    backgroundColor: token.colorBgContainer,
    width: "28px",
    borderRadius: "7px"
  }, children: [
    /* @__PURE__ */ jsx(Col, { span: 12, style: {
      ...BASE_STYLE,
      backgroundColor: selectedMode === "3d" ? token.colorBgTextActive : ""
    }, onClick: () => onButtonClick("3d"), children: /* @__PURE__ */ jsx("span", { style: {
      fontSize: "small",
      color: token.colorText
    }, children: "3D" }) }),
    /* @__PURE__ */ jsx(Col, { span: 12, style: {
      ...BASE_STYLE,
      backgroundColor: selectedMode === "2d" ? token.colorBgTextActive : ""
    }, onClick: () => onButtonClick("2d"), children: /* @__PURE__ */ jsx("span", { style: {
      fontSize: "small",
      color: token.colorText
    }, children: "2D" }) })
  ] }) }) });
}
DisplayModeToggle.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
};
DisplayModeToggle.defaultProps = {
  placement: "top-right",
  width: 90,
  height: 40,
  marginHorizontal: 58,
  marginVertical: 20
};
function useLegend(props) {
  const {
    enableTypes = true,
    enableBoundaries = true,
    enableAlerts = true,
    enableBands = true,
    enableHeatmap = true,
    useActiveId = false,
    types: typesIn = [{
      name: "APs",
      color: "#0b58d9"
    }],
    boundaries: boundariesIn = [],
    alerts: alertsIn = [],
    bands: bandsIn = [],
    heatmap: heatmapIn = [{
      name: "Low",
      color: "#dfe8f6"
    }, {
      name: "High",
      color: "#327de7"
    }],
    ...restProps
  } = props || {};
  const venueBoundaries = useSiteStore((state) => state.venues.map((v5) => {
    var _a3;
    const {
      name: name2
    } = v5;
    const boundaryFeature = (_a3 = v5 == null ? void 0 : v5.features) == null ? void 0 : _a3.find((f2) => f2.properties.category === "footprint");
    if (!name2 || !boundaryFeature)
      return null;
    return {
      name: v5.name,
      color: boundaryFeature.properties.stroke || boundaryFeature.properties.fill
    };
  }));
  const buildingBoundaries = useSiteStore((state) => state.buildings.map((b2) => {
    var _a3;
    const {
      name: name2
    } = b2;
    const boundaryFeature = (_a3 = b2 == null ? void 0 : b2.features) == null ? void 0 : _a3.find((f2) => f2.properties.category === "footprint");
    if (!name2 || !boundaryFeature)
      return null;
    return {
      name: b2.name,
      color: boundaryFeature.properties.stroke || boundaryFeature.properties.fill
    };
  }));
  const activeId = useViewStore((state) => state.activeCollectionItemId);
  const {
    name: visibleBoundaryName,
    visibleFeatures
  } = useFeatures({
    id: activeId,
    fallback: false,
    recursive: true
  });
  const visibleFeaturesBoundaries = React__default.useMemo(() => {
    const name2 = visibleBoundaryName;
    const boundaryFeature = visibleFeatures == null ? void 0 : visibleFeatures.find((f2) => f2.properties.category === "footprint");
    if (!name2 || !boundaryFeature)
      return null;
    return {
      name: name2,
      color: boundaryFeature.properties.stroke || boundaryFeature.properties.fill
    };
  }, [visibleBoundaryName, visibleFeatures]);
  const boundaries = React__default.useMemo(() => useActiveId ? visibleFeaturesBoundaries : [...venueBoundaries || [], ...buildingBoundaries || []], [buildingBoundaries, venueBoundaries, useActiveId, visibleFeaturesBoundaries]);
  const legendProps = React__default.useMemo(() => {
    const legendProps2 = {};
    if (enableTypes)
      legendProps2.types = typesIn;
    if (enableBoundaries)
      legendProps2.boundaries = [...boundaries || [], ...boundariesIn || []];
    if (enableAlerts) {
      legendProps2.alerts = [];
      IconUtil.STATUS_SYMBOL_STYLE.forEach((item) => {
        if (item.isAlert) {
          legendProps2.alerts.push({
            name: item.label,
            color: item.color
          });
        }
      });
      legendProps2.alerts.push(...alertsIn);
    }
    if (enableBands) {
      legendProps2.bands = [];
      IconUtil.STATUS_SYMBOL_STYLE.forEach((item) => {
        if (item.isBand) {
          legendProps2.bands.push({
            name: item.label,
            color: item.color
          });
        }
      });
      legendProps2.bands.push(...bandsIn);
    }
    if (enableHeatmap) {
      legendProps2.heatmap = heatmapIn;
    }
    return legendProps2;
  }, [alertsIn, bandsIn, boundaries, boundariesIn, enableAlerts, enableBands, enableBoundaries, enableHeatmap, enableTypes, heatmapIn, typesIn]);
  return {
    ...restProps,
    ...legendProps
  };
}
const {
  Text: Text$1
} = Typography;
function LayerDropdown(props) {
  const {
    initialCollapsed,
    placement,
    marginHorizontal,
    marginVertical,
    enableViewContext,
    enableBoundaries,
    enableHeatmap,
    enableTopology,
    enableBands,
    enableVenues,
    enableApChannels,
    enableApGroups,
    width,
    onChange,
    viewContext,
    boundaries,
    heatmap,
    bands,
    venues,
    apChannels,
    apGroups,
    checked,
    defaultChecked
  } = props;
  const getValueFor = React__default.useCallback((key, object2) => {
    if (typeof (object2 == null ? void 0 : object2[key]) === "undefined")
      return true;
    return object2[key];
  }, []);
  const getValueForRadio = React__default.useCallback((keys4, object2) => {
    const radioOptions = keys4.reduce((acc, key) => {
      const isChecked = object2 == null ? void 0 : object2[key];
      const value = typeof isChecked === "undefined" ? "fallback" : !!isChecked;
      const {
        key: accKey,
        value: accValue
      } = acc;
      if (!accKey || !accValue || accValue === "fallback" && value === true) {
        acc.key = key;
        acc.value = value;
      }
      return acc;
    }, {});
    return radioOptions.key || (keys4 == null ? void 0 : keys4[0]) || "";
  }, []);
  const renderRadioGroup = React__default.useCallback((items, direction) => {
    const keys4 = items.map((i2) => i2.key);
    const radioValue = getValueForRadio(keys4, checked);
    const defaultValue2 = getValueForRadio(keys4, defaultChecked) || radioValue || "";
    const onValueChange = (event) => {
      const result = {};
      keys4.forEach((k2) => {
        var _a3;
        result[k2] = k2 === ((_a3 = event == null ? void 0 : event.target) == null ? void 0 : _a3.value);
      });
      onChange(result);
    };
    if (direction === "vertical") {
      return /* @__PURE__ */ jsx(Radio.Group, { onChange: onValueChange, value: radioValue, defaultValue: defaultValue2, children: items.map(({
        key,
        name: name2
      }) => /* @__PURE__ */ jsx(Radio, { value: key, children: /* @__PURE__ */ jsx(Text$1, { type: "secondary", children: name2 }) }, key)) });
    }
    const numItems = (items == null ? void 0 : items.length) || 0;
    const width2 = `${100 / (numItems || 1)}%`;
    const getButtonStyle = (index2) => {
      if (index2 === 0) {
        return {
          width: width2,
          borderRadius: "6px 0px 0px 6px"
        };
      }
      if (index2 === numItems - 1) {
        return {
          width: width2,
          borderRadius: "0px 6px 6px 0px"
        };
      }
      return {
        width: width2
      };
    };
    return /* @__PURE__ */ jsx(Radio.Group, { onChange: onValueChange, value: radioValue, defaultValue: defaultValue2, style: {
      width: "100%"
    }, children: items.map(({
      key,
      name: name2
    }, index2) => /* @__PURE__ */ jsx(Radio.Button, { value: key, style: getButtonStyle(index2), children: /* @__PURE__ */ jsx(Text$1, { children: name2 }) }, key)) });
  }, [checked, defaultChecked, getValueForRadio, onChange]);
  const renderCheckbox = React__default.useCallback(({
    key,
    name: name2
  }) => {
    const c2 = getValueFor(key, checked);
    const dc = getValueFor(key, defaultChecked);
    return /* @__PURE__ */ jsx(Checkbox, { defaultChecked: dc, checked: c2, onChange: (e3) => onChange({
      [key]: e3.target.checked
    }), children: /* @__PURE__ */ jsx(Text$1, { type: "secondary", children: name2 }) }, key);
  }, [checked, defaultChecked, getValueFor, onChange]);
  const renderGroupBlock = React__default.useCallback(({
    name: name2,
    key,
    title,
    showToggle,
    children
  }) => /* @__PURE__ */ jsxs(Space, { direction: "vertical", children: [
    /* @__PURE__ */ jsxs(Space, { direction: "horizontal", style: {
      justifyContent: "space-between",
      width: "160px"
    }, children: [
      /* @__PURE__ */ jsx(Text$1, { children: name2 }),
      showToggle && /* @__PURE__ */ jsx(Switch$1, { size: "small", defaultChecked: getValueFor(key, defaultChecked), checked: getValueFor(key, checked), onChange: (checked2) => onChange({
        [key]: checked2
      }) })
    ] }),
    title && /* @__PURE__ */ jsx(Text$1, { type: "secondary", children: title }),
    children
  ] }), [checked, defaultChecked, getValueFor, onChange]);
  const renderViewContext = React__default.useMemo(() => {
    if (!enableViewContext)
      return null;
    return renderRadioGroup(viewContext);
  }, [enableViewContext, renderRadioGroup, viewContext]);
  const renderBoundaries = React__default.useMemo(() => {
    if (!enableBoundaries)
      return null;
    const children = boundaries.map((v5) => renderCheckbox(v5));
    return renderGroupBlock({
      name: "Boundaries",
      key: "boundaries",
      title: "",
      showToggle: true,
      children
    });
  }, [boundaries, enableBoundaries, renderGroupBlock, renderCheckbox]);
  const renderHeatmap = React__default.useMemo(() => {
    if (!enableHeatmap)
      return null;
    return renderGroupBlock({
      name: "Heatmap",
      key: "heatmap",
      title: "",
      showToggle: true,
      children: renderRadioGroup(heatmap, "vertical")
    });
  }, [enableHeatmap, renderGroupBlock, renderRadioGroup, heatmap]);
  const renderTopology = React__default.useMemo(() => {
    if (!enableTopology)
      return null;
    const topologyItems = [];
    const children = topologyItems.map((v5) => renderCheckbox({
      key: v5.key,
      name: v5.name
    }));
    return renderGroupBlock({
      name: "Topology",
      key: "topology",
      title: "Physical topology on map",
      showToggle: true,
      children
    });
  }, [enableTopology, renderGroupBlock, renderCheckbox]);
  const renderCoverage = React__default.useMemo(() => {
    if (!enableBands)
      return null;
    const children = bands.map((v5) => renderCheckbox(v5));
    return renderGroupBlock({
      name: "Coverage",
      title: "",
      showToggle: true,
      key: "bands",
      children
    });
  }, [bands, enableBands, renderGroupBlock, renderCheckbox]);
  const renderVenues = React__default.useMemo(() => {
    if (!enableVenues)
      return null;
    const children = venues.map((v5) => renderCheckbox(v5));
    return renderGroupBlock({
      name: "Venues",
      key: "venues",
      title: "",
      showToggle: false,
      children
    });
  }, [venues, enableVenues, renderGroupBlock, renderCheckbox]);
  const renderAPChannelInfo = React__default.useMemo(() => {
    if (!enableApChannels)
      return null;
    const children = apChannels.map((v5) => renderCheckbox(v5));
    return renderGroupBlock({
      name: "AP Channel Info",
      key: "apChannelInfo",
      title: "",
      showToggle: true,
      children
    });
  }, [apChannels, enableApChannels, renderGroupBlock, renderCheckbox]);
  const renderAPGroup = React__default.useMemo(() => {
    if (!enableApGroups)
      return null;
    const children = apGroups.map((v5) => renderCheckbox(v5));
    return renderGroupBlock({
      name: "AP Group",
      key: "apGroups",
      title: "",
      showToggle: true,
      children
    });
  }, [apGroups, enableApGroups, renderGroupBlock, renderCheckbox]);
  return /* @__PURE__ */ jsx(CollapsibleOverlayPanel, { title: "Layers", placement, width, height: "auto", marginHorizontal, marginVertical, initialCollapsed, children: /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    width: "100%"
  }, children: [
    renderViewContext,
    renderBoundaries,
    renderHeatmap,
    renderTopology,
    renderCoverage,
    renderVenues,
    renderAPChannelInfo,
    renderAPGroup
  ] }) });
}
LayerDropdown.propTypes = {
  initialCollapsed: propTypesExports$1.bool,
  width: propTypesExports$1.number,
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  enableViewContext: propTypesExports$1.bool,
  enableBoundaries: propTypesExports$1.bool,
  enableHeatmap: propTypesExports$1.bool,
  enableTopology: propTypesExports$1.bool,
  enableBands: propTypesExports$1.bool,
  enableVenues: propTypesExports$1.bool,
  enableApChannels: propTypesExports$1.bool,
  enableApGroups: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  viewContext: propTypesExports$1.array,
  boundaries: propTypesExports$1.array,
  heatmap: propTypesExports$1.array,
  bands: propTypesExports$1.array,
  venues: propTypesExports$1.array,
  apChannels: propTypesExports$1.array,
  apGroups: propTypesExports$1.array,
  checked: propTypesExports$1.object,
  defaultChecked: propTypesExports$1.object
};
LayerDropdown.defaultProps = {
  initialCollapsed: true,
  width: 200,
  placement: "top-left",
  marginHorizontal: 16,
  marginVertical: 16,
  enableViewContext: true,
  enableBoundaries: true,
  enableHeatmap: false,
  enableTopology: false,
  enableBands: false,
  enableVenues: false,
  enableApChannels: false,
  enableApGroups: false,
  onChange: () => {
  },
  viewContext: [{
    name: "Boundaries",
    key: "venuesView"
  }, {
    name: "Zones",
    key: "zonesView"
  }],
  boundaries: [{
    name: "Markets",
    key: "market"
  }, {
    name: "Clusters",
    key: "cluster"
  }, {
    name: "Countries",
    key: "country"
  }],
  heatmap: [{
    name: "Single Color",
    key: "singleColor"
  }, {
    name: "Multi Color",
    key: "multiColor"
  }],
  bands: IconUtil.STATUS_SYMBOL_STYLE.filter((i2) => i2.isBand).map((i2) => ({
    name: i2.label,
    key: i2.type
  })),
  venues: [{
    name: "Campus",
    key: "venue"
  }, {
    name: "Buildings",
    key: "building"
  }, {
    name: "Parking APs",
    key: "accessPoint"
  }, {
    name: "Levels",
    key: "level"
  }],
  apChannels: [{
    name: "Name",
    key: "apChannelsName"
  }, {
    name: "Data Usage",
    key: "dataUsage"
  }, {
    name: "Band",
    key: "band"
  }],
  apGroups: [],
  checked: {},
  defaultChecked: {}
};
function MapFocus(props) {
  const {
    width,
    height,
    marginHorizontal,
    marginVertical,
    placement
  } = props;
  const [autoFocus, setAutoFocus] = React__default.useState(false);
  const activeId = useViewStore((state) => state.activeCollectionItemId);
  const {
    allFeatures
  } = useFeatures({
    id: activeId,
    fallback: false,
    recursive: false
  });
  const {
    token
  } = theme$2.useToken();
  const onButtonClick = React__default.useCallback(() => {
    setAutoFocus(true);
    setTimeout(() => {
      setAutoFocus(false);
    }, 500);
  }, []);
  return /* @__PURE__ */ jsx(OverlayPanel, { width, height, marginHorizontal, marginVertical, placement, children: /* @__PURE__ */ jsxs(Col, { gutter: 8, style: {
    width: "100%",
    height: "100%",
    margin: 0
  }, children: [
    /* @__PURE__ */ jsx(Col, { span: 12, style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "28px",
      minHeight: "28px",
      padding: "1px",
      backgroundColor: token.colorBgContainer,
      borderRadius: "7px",
      cursor: "pointer"
    }, onClick: () => onButtonClick(), children: /* @__PURE__ */ jsx(AimOutlined, { style: {
      fontSize: "small",
      color: token.colorText
    } }) }),
    autoFocus && /* @__PURE__ */ jsx(MapAutoFocus, { enabled: true, features: allFeatures, forceUpdate: true })
  ] }) });
}
MapFocus.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
};
MapFocus.defaultProps = {
  placement: "top-right",
  width: 90,
  height: 40,
  marginHorizontal: 58,
  marginVertical: 20
};
function TooltipHandler(props) {
  const {
    containerId,
    sources: sources2,
    mouseEnterDelay,
    render: renderTooltip
  } = props;
  const containerRef = React__default.useRef(null);
  const reactRootRef = React__default.useRef(null);
  const currentFeatureRef = React__default.useRef(null);
  const isMouseOnWidgetRef = React__default.useRef(false);
  const {
    map: map5
  } = useMapbox();
  const config2 = useMapConfigStore((state) => state.config);
  const getElement = React__default.useCallback(() => {
    let element = null;
    if (containerId) {
      element = document.getElementById(containerId);
    }
    if (!element) {
      element = map5 == null ? void 0 : map5.getContainer();
    }
    if (!element)
      return document.body;
    return element;
  }, [containerId, map5]);
  const onWidgetEnter = React__default.useCallback((event) => {
    event.stopPropagation();
    isMouseOnWidgetRef.current = true;
  }, []);
  const onWidgetLeave = React__default.useCallback((event) => {
    event.stopPropagation();
    isMouseOnWidgetRef.current = false;
  }, []);
  const sourceIds = React__default.useMemo(() => (sources2 == null ? void 0 : sources2.map((s2) => s2.sourceId)) || [], [sources2]);
  const onHoverIcon = React__default.useCallback((data2) => {
    const hideTooltip = () => {
      if (containerRef.current) {
        containerRef.current.style.display = "none";
        currentFeatureRef.current = null;
        isMouseOnWidgetRef.current = false;
      }
    };
    const {
      feature: feature2,
      position
    } = data2 || {};
    if (!feature2 || !position) {
      hideTooltip();
      return;
    }
    if (!sourceIds.includes(feature2.source)) {
      hideTooltip();
      return;
    }
    if (currentFeatureRef.current === feature2.properties.id)
      return;
    const showTooltip = () => {
      if (!containerRef.current) {
        containerRef.current = document.createElement("div");
        containerRef.current.style.display = "none";
        containerRef.current.style.position = "absolute";
        containerRef.current.style.backgroundColor = "transparent";
        containerRef.current.addEventListener("mouseenter", onWidgetEnter);
        containerRef.current.addEventListener("mouseleave", onWidgetLeave);
        getElement().appendChild(containerRef.current);
        reactRootRef.current = createRoot$1(containerRef.current);
      }
      if (!isMouseOnWidgetRef.current) {
        const {
          x: x2,
          y: y2
        } = map5.project(position);
        containerRef.current.style.left = `${x2}px`;
        containerRef.current.style.top = `${y2}px`;
        containerRef.current.style.display = "block";
        reactRootRef.current.render(/* @__PURE__ */ jsx(ConfigProvider, { ...config2 || {}, children: renderTooltip(feature2) }));
      }
    };
    const isMouseEnter = !currentFeatureRef.current;
    currentFeatureRef.current = feature2.properties.id;
    if (isMouseEnter && mouseEnterDelay > 0)
      setTimeout(() => showTooltip(), mouseEnterDelay);
    else
      showTooltip();
  }, [config2, getElement, map5, mouseEnterDelay, onWidgetEnter, onWidgetLeave, renderTooltip, sourceIds]);
  React__default.useLayoutEffect(() => () => {
    if (containerRef.current) {
      containerRef.current.removeEventListener("mouseenter", onWidgetEnter);
      containerRef.current.removeEventListener("mouseleave", onWidgetLeave);
      try {
        getElement().removeChild(containerRef.current);
      } catch (error2) {
        console.error(error2);
      }
      containerRef.current = null;
    }
  }, [getElement, onWidgetEnter, onWidgetLeave]);
  return /* @__PURE__ */ jsx(Fragment, { children: sources2.map((s2) => /* @__PURE__ */ jsx(Interactions, { ...s2, onHover: onHoverIcon, enableHover: true }, s2.sourceId)) });
}
TooltipHandler.propTypes = {
  containerId: propTypesExports$1.string,
  sources: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    layerIds: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.arrayOf(propTypesExports$1.string)]),
    sourceId: propTypesExports$1.string,
    sourceLayer: propTypesExports$1.string,
    isRaster: propTypesExports$1.bool
  })),
  render: propTypesExports$1.func,
  mouseEnterDelay: propTypesExports$1.number
};
TooltipHandler.defaultProps = {
  containerId: "",
  sources: [],
  render: () => {
  },
  mouseEnterDelay: 500
  // ms
};
function MapCompass({
  placement,
  marginHorizontal,
  marginVertical,
  onBearingChange
}) {
  const [open2, setOpen] = React__default.useState(false);
  const [bearing2, setBearing] = React__default.useState(0);
  const {
    map: map5
  } = useMapbox();
  React__default.useEffect(() => {
    if (map5) {
      const updateBearing = () => {
        setBearing(map5.getBearing());
      };
      map5.on("move", updateBearing);
      return () => map5.off("move", updateBearing);
    }
    return () => {
    };
  }, [map5]);
  const applyBearingChange = React__default.useCallback((value) => {
    if (map5) {
      map5.setBearing(value);
      onBearingChange(value);
    }
  }, [map5, onBearingChange]);
  const onValueChange = React__default.useCallback((value) => {
    let transformedValue = value;
    if (value < 360 && value >= 0) {
      transformedValue = value;
    } else if (value > 360) {
      transformedValue = 360;
    } else {
      transformedValue = 0;
    }
    if (transformedValue > 180) {
      transformedValue -= 360;
    }
    applyBearingChange(transformedValue);
  }, [applyBearingChange]);
  const resetToNorth = React__default.useCallback(() => {
    applyBearingChange(0);
  }, [applyBearingChange]);
  const displayBearing = React__default.useMemo(() => bearing2 < 0 ? 360 + bearing2 : bearing2, [bearing2]);
  const closeButton = React__default.useMemo(() => /* @__PURE__ */ jsx(Button, { type: "text", onClick: () => setOpen(false), icon: /* @__PURE__ */ jsx(CloseOutlined, {}) }), []);
  const content = /* @__PURE__ */ jsxs(Card, { title: "Heading", extra: closeButton, bordered: false, style: {
    width: "300px"
  }, children: [
    /* @__PURE__ */ jsxs(Row, { children: [
      /* @__PURE__ */ jsx(Col, { span: 14, children: /* @__PURE__ */ jsx(Slider$1, { min: 0, max: 360, onChange: onValueChange, value: displayBearing, tooltip: {
        formatter: null
      } }) }),
      /* @__PURE__ */ jsx(Col, { span: 4, children: /* @__PURE__ */ jsx(InputNumber$1, { min: 0, max: 360, style: {
        marginLeft: "22px"
      }, formatter: (value) => `${value}°`, parser: (value) => value.replace("°", ""), value: `${displayBearing}`, onChange: onValueChange }) })
    ] }),
    /* @__PURE__ */ jsx(Row, { justify: "end", children: /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Button, { onClick: resetToNorth, type: "primary", children: "Reset to North" }) }) })
  ] });
  return /* @__PURE__ */ jsx(OverlayPanel, { placement, width: 50, height: "auto", marginHorizontal, marginVertical, children: /* @__PURE__ */ jsx(Popover, { content, trigger: "click", placement: "bottomRight", open: open2, onOpenChange: setOpen, arrow: false, children: /* @__PURE__ */ jsx(Button, { type: open2 ? "primary" : "default", icon: /* @__PURE__ */ jsx(Icons.Compass, { style: {
    fontSize: 20
  } }), style: {
    height: "38px",
    width: "40px"
  }, onClick: () => setOpen(!open2) }) }) });
}
MapCompass.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  onBearingChange: propTypesExports$1.func
};
MapCompass.defaultProps = {
  placement: "top-right",
  marginHorizontal: 0,
  marginVertical: 0,
  onBearingChange: () => {
  }
};
function AttributionControls(props) {
  const {
    placement,
    style: styleIn,
    marginVertical,
    marginHorizontal,
    ...restProps
  } = props;
  const style2 = React__default.useMemo(() => {
    var _a3, _b3;
    const vertical = ((_a3 = placement == null ? void 0 : placement.split("-")) == null ? void 0 : _a3[0]) || "bottom";
    const horizontal = ((_b3 = placement == null ? void 0 : placement.split("-")) == null ? void 0 : _b3[1]) || "right";
    const parentPlacement = {};
    if (vertical === "top") {
      parentPlacement.marginTop = marginVertical;
    } else {
      parentPlacement.marginBottom = marginVertical;
    }
    if (horizontal === "left") {
      parentPlacement.marginLeft = marginHorizontal;
    } else {
      parentPlacement.marginRight = marginHorizontal;
    }
    return {
      ...parentPlacement,
      ...styleIn
    };
  }, [placement, styleIn, marginVertical, marginHorizontal]);
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(AttributionControl$1, { compact: true, ...restProps, position: placement, style: style2 }) });
}
AttributionControls.propTypes = {
  placement: propTypesExports$1.oneOf(["top-right", "top-left", "bottom-left", "bottom-right"]),
  compact: propTypesExports$1.bool,
  customAttribution: propTypesExports$1.string,
  style: propTypesExports$1.object,
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
};
AttributionControls.defaultProps = {
  placement: "bottom-right",
  compact: true,
  customAttribution: "",
  style: {},
  marginHorizontal: 10,
  marginVertical: 10
};
const KEY = "showHideUnderground";
function UndergroundViewToggle(props) {
  const {
    width,
    height,
    marginHorizontal,
    marginVertical,
    placement,
    onChange: setUndergroundView,
    value: undergroundView,
    disabled,
    ...restProps
  } = props;
  const onToggle = React__default.useCallback(() => {
    setUndergroundView((previous) => !previous);
  }, [setUndergroundView]);
  return /* @__PURE__ */ jsx(OverlayPanel, { width, height, marginHorizontal, marginVertical, placement, ...restProps, children: /* @__PURE__ */ jsx(ToggleButton, { id: KEY, icon: /* @__PURE__ */ jsx(UnderlineOutlined, {}), active: undergroundView, onToggle, disabled, tooltip: "Underground On/Off" }) });
}
UndergroundViewToggle.propTypes = {
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  width: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  height: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  value: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  disabled: propTypesExports$1.bool
};
UndergroundViewToggle.defaultProps = {
  placement: "top-right",
  width: 28,
  height: 28,
  marginHorizontal: 12,
  marginVertical: 240,
  value: false,
  onChange: () => {
  },
  disabled: false
};
const Z_PROPERTIES = [
  "model-translation",
  // back
  "fill-z-offset",
  "line-z-offset",
  "symbol-z-offset"
  // front
];
const PAINT_PROPERTIES = [
  // 'icon-opacity',
  // 'text-opacity',
  "line-opacity",
  "circle-opacity",
  "raster-opacity",
  "fill-opacity",
  "background-opacity"
];
function Underground(props) {
  const {
    id,
    opacity,
    enableView,
    setEnableView,
    buttonProps
  } = props;
  const {
    enable: enableButton,
    containerId,
    ...restButtonProps
  } = buttonProps || {};
  const {
    map: map5
  } = useMapbox();
  const movedOnceRef = React__default.useRef(false);
  const previousPaintOptionsRef = React__default.useRef(null);
  const getLayers = React__default.useCallback(() => {
    var _a3, _b3;
    return (_b3 = (_a3 = map5 == null ? void 0 : map5.getStyle()) == null ? void 0 : _a3.layers) == null ? void 0 : _b3.map((l2) => l2.id);
  }, [map5]);
  const getPaintPropertySafe = React__default.useCallback((layerId, prop) => {
    try {
      return map5.getPaintProperty(layerId, prop);
    } catch (error2) {
    }
    return void 0;
  }, [map5]);
  const moveLayerSafe = React__default.useCallback((layerId, beforeId) => {
    try {
      if (map5.getLayer(layerId)) {
        map5.moveLayer(layerId, beforeId);
      }
    } catch (error2) {
      console.error(error2);
    }
  }, [map5]);
  const getZOffset = React__default.useCallback((layerId) => {
    let zOffset;
    if (!layerId)
      return zOffset;
    Z_PROPERTIES.some((prop) => {
      const value = getPaintPropertySafe(layerId, prop);
      if (typeof value !== "undefined") {
        if (prop === "model-translation" && Array.isArray(value) && typeof value[2] === "number") {
          zOffset = value[2];
        } else if (typeof value === "number") {
          zOffset = value;
        }
      }
      return typeof zOffset !== "undefined";
    });
    return zOffset;
  }, [getPaintPropertySafe]);
  const applyUndergroundSorting = React__default.useCallback(() => {
    if (!movedOnceRef.current)
      return;
    const layers = getLayers();
    if (!(layers == null ? void 0 : layers.length) || !id)
      return;
    const sortedUndergroundLayers = layers.map((layerId) => ({
      layerId,
      zOffset: getZOffset(layerId)
    })).filter(({
      zOffset
    }) => typeof zOffset === "number" && zOffset < 0).sort((a2, b2) => a2.zOffset - b2.zOffset).map(({
      layerId
    }) => layerId).reverse();
    sortedUndergroundLayers.forEach((back, index2, array2) => {
      const front = index2 === 0 ? id : array2[index2 - 1];
      moveLayerSafe(back, front);
    });
  }, [getLayers, getZOffset, id, moveLayerSafe]);
  const applyGlassView = React__default.useCallback(() => {
    if (!map5)
      return;
    if (previousPaintOptionsRef.current)
      return;
    const layerIds = getLayers();
    previousPaintOptionsRef.current = {};
    const undergroundIndex = layerIds.findIndex((name2) => name2 === id);
    const len2 = layerIds.length;
    for (let i2 = undergroundIndex + 1; i2 < len2; i2 += 1) {
      const layerId = layerIds[i2];
      const layer = map5.getLayer(layerId);
      if (!(layer == null ? void 0 : layer.paint))
        return;
      PAINT_PROPERTIES.forEach((prop) => {
        try {
          const existingValue = map5.getPaintProperty(layerId, prop);
          previousPaintOptionsRef.current[layerId] = {
            ...previousPaintOptionsRef.current[layerId] || {},
            [prop]: existingValue
          };
          const modifiedValue = opacity;
          map5.setPaintProperty(layerId, prop, modifiedValue);
        } catch (error2) {
        }
      });
    }
  }, [getLayers, id, map5, opacity]);
  const revertGlassView = React__default.useCallback(() => {
    if (!map5)
      return;
    const layerPaintOptions = previousPaintOptionsRef.current;
    if (!layerPaintOptions)
      return;
    Object.keys(layerPaintOptions).forEach((layerId) => {
      const layer = map5.getLayer(layerId);
      if (!(layer == null ? void 0 : layer.paint))
        return;
      const paintOption = layerPaintOptions[layerId];
      Object.keys(paintOption).forEach((prop) => {
        try {
          map5.setPaintProperty(layerId, prop, paintOption[prop]);
        } catch (error2) {
        }
      });
    });
    previousPaintOptionsRef.current = null;
  }, [map5]);
  const placeUnderground = React__default.useCallback(() => {
    if (!map5)
      return;
    if (movedOnceRef.current)
      return;
    const layers = getLayers();
    if (!(layers == null ? void 0 : layers.length) || !id)
      return;
    const backgroundLayerId = layers.find((name2) => {
      var _a3;
      return ((_a3 = map5.getLayer(name2)) == null ? void 0 : _a3.type) === "background";
    });
    const newLayer = map5.getLayer(id);
    if (!newLayer || !backgroundLayerId)
      return;
    try {
      map5.moveLayer(id, backgroundLayerId);
      movedOnceRef.current = true;
    } catch (error2) {
      console.error(error2);
    }
  }, [getLayers, id, map5]);
  React__default.useEffect(() => {
    if (!map5) {
      return () => {
      };
    }
    const place = () => setTimeout(placeUnderground, 300);
    map5.on("styledata", place);
    return () => {
      map5.off("styledata", place);
    };
  }, [map5, placeUnderground]);
  const updateView = React__default.useCallback(() => {
    if (!movedOnceRef.current)
      return;
    if (enableView) {
      applyGlassView();
    } else {
      revertGlassView();
    }
  }, [applyGlassView, enableView, revertGlassView]);
  React__default.useEffect(() => {
    const handle = setInterval(() => {
      applyUndergroundSorting();
      if (movedOnceRef.current) {
        clearInterval(handle);
      }
    }, 100);
    return () => {
      clearInterval(handle);
    };
  }, [applyUndergroundSorting, enableView]);
  React__default.useEffect(() => {
    const handle = setInterval(() => {
      updateView();
      if (previousPaintOptionsRef.current) {
        clearInterval(handle);
      }
    }, 100);
    return () => {
      clearInterval(handle);
      revertGlassView();
    };
  }, [revertGlassView, updateView]);
  if (!id)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Layer$1, { id, type: "slot", metadata: {
      "mapbox:description": "Slot below the ground"
    } }),
    enableButton && createPortal(/* @__PURE__ */ jsx(UndergroundViewToggle, { ...restButtonProps, value: enableView, onChange: setEnableView }), document.getElementById(containerId) || document.body, `portal-underground-toggle${containerId}`)
  ] });
}
Underground.propTypes = {
  id: propTypesExports$1.string,
  opacity: propTypesExports$1.number,
  enableView: propTypesExports$1.bool,
  setEnableView: propTypesExports$1.func,
  buttonProps: propTypesExports$1.object
};
Underground.defaultProps = {
  id: "sai-underground-slot",
  opacity: 0.1,
  enableView: false,
  setEnableView: () => {
  },
  buttonProps: {}
};
function useSearchData(props) {
  const {
    searchables: searchablesIn,
    localGeocoder: localGeocoderIn,
    onSelect: onSelectIn,
    ...restProps
  } = props || {};
  const sites = useSiteStore((state) => ({
    countries: state.countries,
    venues: state.venues,
    regions: state.regions,
    markets: state.markets,
    clusters: state.clusters,
    zones: state.zones,
    buildings: state.buildings,
    levels: state.levels
  }));
  const subRootId = useViewStore((state) => state.enableVenueSubTree ? state.activeVenueId : null);
  const {
    subTypesMeta,
    mcrParentKeys
  } = useMCRTypesMeta(subRootId);
  const setActiveObject = useViewStore((state) => state.setActiveObject);
  const setActiveFeatureId = useViewStore((state) => state.setActiveFeatureId);
  const setActiveApFeatureId = useViewStore((state) => state.setActiveApFeatureId);
  const setActiveLayerId = useViewStore((state) => state.setActiveLayerId);
  const {
    map: map5
  } = useMapbox();
  const getFeatures = React__default.useCallback((sourceId, sourceLayer) => {
    var _a3;
    const result = [];
    const addFeature = (item) => {
      var _a4, _b3, _c2;
      if (!((_a4 = item.geometry) == null ? void 0 : _a4.coordinates))
        return;
      let placeName = item.properties.name || item.properties.entity_id || item.id;
      if (!placeName)
        return;
      if (item.properties.entity_type)
        placeName = `${placeName}, ${item.properties.entity_type}`;
      const feature2 = {
        ...item,
        properties: {
          ...item.properties,
          name: item.properties.name,
          type: "feature",
          category: item.properties.entity_type
        },
        place_name: placeName,
        place_type: [item.properties.entity_type],
        center: item.center || ((_c2 = (_b3 = GeoUtil.centroid(item)) == null ? void 0 : _b3.geometry) == null ? void 0 : _c2.coordinates),
        text: item.properties.name,
        // short name
        isSaiObject: true
      };
      result.push(feature2);
    };
    (_a3 = map5 == null ? void 0 : map5.querySourceFeatures(sourceId, {
      sourceLayer
    })) == null ? void 0 : _a3.forEach(addFeature);
    return result;
  }, [map5]);
  const prepareAP = React__default.useCallback((node) => {
    const {
      type,
      features
    } = node;
    if (!["zone", ...SiteStoreHelper.ACCESS_POINT_PARENTS].includes(type) || !(features == null ? void 0 : features.length)) {
      return [];
    }
    if (type === "venue" && !subRootId)
      return [];
    const apNodes = [];
    features.forEach((feature2) => {
      var _a3, _b3;
      if (((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.category) !== "accessPoint")
        return;
      const name2 = ((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.name) || (feature2 == null ? void 0 : feature2.name);
      apNodes.push({
        ...feature2,
        properties: {
          ...feature2.properties,
          name: name2,
          accessPointId: feature2.id,
          type: "feature",
          category: "accessPoint"
        },
        place_name: name2,
        place_type: ["accessPoint"],
        center: feature2.geometry.coordinates,
        text: name2,
        // short name
        isSaiObject: true
      });
    });
    return apNodes;
  }, [subRootId]);
  const prepareFootprint = React__default.useCallback((item) => {
    var _a3, _b3, _c2, _d2, _e2, _f3, _g, _h, _i, _j, _k, _l;
    const {
      id,
      name: name2,
      features,
      center: center2,
      type
    } = item || {};
    if (!id || !name2)
      return [];
    const footprints = features == null ? void 0 : features.filter((f2) => {
      var _a4;
      return ((_a4 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a4.category) === "footprint";
    });
    const markers = features == null ? void 0 : features.filter((f2) => {
      var _a4;
      return ((_a4 = f2 == null ? void 0 : f2.properties) == null ? void 0 : _a4.category) === "marker";
    });
    const selectedFeature = (footprints == null ? void 0 : footprints[0]) || (markers == null ? void 0 : markers[0]);
    let selectedGeometry = selectedFeature == null ? void 0 : selectedFeature.geometry;
    if (!selectedGeometry && center2) {
      selectedGeometry = {
        type: "Point",
        coordinates: [...center2]
      };
    }
    if (!selectedGeometry) {
      if (features == null ? void 0 : features.length) {
        console.debug("Skipping", item);
      }
      return [];
    }
    const finalFeature = {
      type: "Feature",
      geometry: selectedGeometry,
      properties: {
        id,
        name: name2,
        countryId: (_a3 = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _a3.countryId,
        regionId: (_b3 = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _b3.regionId,
        clusterId: (_c2 = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _c2.clusterId,
        marketId: (_d2 = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _d2.marketId,
        venueId: (_e2 = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _e2.venueId,
        buildingId: (_f3 = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _f3.buildingId,
        levelId: (_g = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _g.levelId,
        layerId: (_h = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _h.layerId,
        zoneId: (_i = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _i.zoneId,
        accessPointId: (_j = selectedFeature == null ? void 0 : selectedFeature.properties) == null ? void 0 : _j.accessPointId,
        [SiteStoreHelper.parentType2ParentIdName]: id,
        type: "category",
        category: type
      },
      place_name: name2,
      place_type: [type],
      text: name2,
      // short name
      isSaiObject: true
    };
    finalFeature.center = center2 || ((_l = (_k = GeoUtil.centroid(finalFeature)) == null ? void 0 : _k.geometry) == null ? void 0 : _l.coordinates);
    if (finalFeature.center) {
      return [finalFeature];
    }
    return [];
  }, []);
  const searchableFeatures = React__default.useMemo(() => {
    const flatData = [];
    const treeData = [];
    const searchables = [];
    const addSearchables = (item, treeParentArray, parentNode) => {
      const node = {
        children: [],
        type: "category",
        id: item.id,
        name: item.name,
        category: item.type
      };
      if (treeParentArray) {
        treeParentArray.push(node);
        flatData.push(node);
        const features = [];
        features.push(...prepareFootprint(item));
        features.push(...prepareAP(item));
        if (parentNode == null ? void 0 : parentNode.name) {
          features.forEach((f2) => {
            f2.place_name = `${f2.place_name}, ${parentNode.name}`;
          });
        }
        searchables.push(...features);
      }
    };
    subTypesMeta.forEach(({
      collectionName
    }) => {
      var _a3;
      (_a3 = sites == null ? void 0 : sites[collectionName]) == null ? void 0 : _a3.forEach((item) => {
        if (item.type === "zone") {
          const isInVenue = !!item.venueId || !!item.buildingId || !!item.levelId;
          if (subRootId && !isInVenue)
            return;
          if (!subRootId && isInVenue)
            return;
        }
        if (subRootId && item.type === "venue") {
          addSearchables(item, treeData);
        } else {
          const itemKeys = Object.keys(item);
          const parentKey = mcrParentKeys.find((key) => itemKeys.includes(key)) || "parentId";
          const parentId = item[parentKey];
          let parentArray = null;
          let parentNode = null;
          if (parentKey && parentId) {
            parentNode = flatData.find((aNode) => aNode.id === parentId);
            parentArray = parentNode == null ? void 0 : parentNode.children;
          }
          if (!parentArray) {
            if (!subRootId) {
              parentArray = treeData;
            } else if (["buildings", "zones", "accessPoints"].includes(collectionName) && subRootId === item.venueId) {
              parentArray = treeData;
            }
          }
          addSearchables(item, parentArray, parentNode);
        }
      });
    });
    searchablesIn == null ? void 0 : searchablesIn.forEach((layerOrFunc) => {
      if (typeof layerOrFunc === "function") {
        const moreFeatures = layerOrFunc();
        searchables.push(...moreFeatures || []);
      } else if (typeof layerOrFunc === "object") {
        const {
          sourceId,
          sourceLayer
        } = layerOrFunc || {};
        const moreFeatures = getFeatures(sourceId, sourceLayer);
        searchables.push(...moreFeatures || []);
      } else if (Array.isArray(layerOrFunc)) {
        searchables.push(...layerOrFunc);
      }
    }, []);
    return searchables;
  }, [subTypesMeta, searchablesIn, prepareFootprint, prepareAP, sites, subRootId, mcrParentKeys, getFeatures]);
  const customFeatureSearch = React__default.useCallback((query6) => {
    if (!query6)
      return [];
    const fallback = () => (localGeocoderIn == null ? void 0 : localGeocoderIn(query6)) || [];
    if (!(searchableFeatures == null ? void 0 : searchableFeatures.length))
      return fallback();
    const lowerQuery = query6.toLowerCase();
    const matchingFeatures = [];
    searchableFeatures.forEach((feature2) => {
      if (feature2.place_name.toLowerCase().includes(lowerQuery)) {
        matchingFeatures.push(feature2);
      }
    });
    if (matchingFeatures.length) {
      return matchingFeatures;
    }
    return fallback();
  }, [localGeocoderIn, searchableFeatures]);
  const onFeatureSearchSelect = React__default.useCallback((searchFeature) => {
    var _a3;
    if (searchFeature == null ? void 0 : searchFeature.isSaiObject) {
      if (searchFeature.properties.type === "category" || searchFeature.properties.category === "accessPoint") {
        const {
          countryId,
          regionId,
          marketId,
          clusterId,
          venueId,
          buildingId,
          levelId,
          layerId,
          zoneId,
          accessPointId
        } = searchFeature.properties;
        setActiveObject({
          countryId,
          regionId,
          marketId,
          clusterId,
          venueId,
          buildingId,
          levelId,
          layerId,
          zoneId,
          accessPointId
        });
        onSelectIn == null ? void 0 : onSelectIn(searchFeature);
      }
      const isFeature2 = searchFeature.properties.type === "feature";
      const isApFeature = isFeature2 && searchFeature.properties.category === "accessPoint";
      setActiveFeatureId(isFeature2 && searchFeature.properties.accessPointId);
      setActiveApFeatureId(isApFeature && searchFeature.properties.accessPointId);
      setActiveLayerId(searchFeature.properties.type === "layer" ? (_a3 = searchFeature.properties) == null ? void 0 : _a3.layerId : null);
    }
  }, [onSelectIn, setActiveApFeatureId, setActiveFeatureId, setActiveLayerId, setActiveObject]);
  const searchProps = React__default.useMemo(() => {
    const result = {
      ...restProps || {},
      localGeocoder: customFeatureSearch,
      onSelect: onFeatureSearchSelect
    };
    return result;
  }, [customFeatureSearch, onFeatureSearchSelect, restProps]);
  return searchProps;
}
function FeaturesControls(props) {
  const {
    containerId,
    enableSearch,
    searchPlacement,
    searchProps: searchPropsIn,
    enableFullscreen,
    fullscreenPlacement,
    fullscreenProps,
    enableZoom,
    zoomPlacement,
    zoomProps,
    enableTilesSelector,
    tilesSelectorPlacement,
    tilesSelectorProps,
    enableScale,
    scalePlacement,
    scaleProps,
    enableCompass,
    compassPlacement,
    compassProps,
    enableDisplayMode,
    displayModePlacement,
    displayModeProps,
    enableTilesToggle,
    tilesTogglePlacement,
    tilesToggleProps,
    enableLegend,
    legendPlacement,
    legendProps: legendPropsIn,
    enableLayer,
    layerPlacement,
    layerProps: layerPropsIn,
    enableMapFocus,
    mapFocusPlacement,
    mapFocusProps,
    enableTooltip,
    tooltipProps,
    enableLevelSelector,
    levelSelectorPlacement,
    levelSelectorProps,
    enableLevelSelector3,
    levelSelector3Placement,
    levelSelector3Props,
    enableAutoFocus,
    attributionPlacement,
    attributionProps,
    enableUnderground,
    undergroundPlacement,
    undergroundProps: undergroundPropsIn
  } = props;
  const {
    token
  } = theme$2.useToken();
  const undergroundView = useViewStore((state) => state.undergroundView);
  const setUndergroundView = useViewStore((state) => state.setUndergroundView);
  const activeTiles = useViewStore((state) => state.activeTiles);
  const defaultTiles = useViewStore((state) => state.defaultTiles);
  const setDefaultTiles = useViewStore((state) => state.setDefaultTiles);
  const activeTool = useViewStore((state) => state.activeTool);
  const setDefaultCenter = useSiteStore((state) => state.setDefaultCenter);
  const updateCategoryVisibility = useViewStore((state) => state.updateCategoryVisibility);
  const updateVisibilityFlags = useViewStore((state) => state.updateVisibilityFlags);
  const invisibleFlags = useViewStore((state) => state.invisibleFlags);
  const categories2 = useSiteStore((state) => state.categories.map((c2) => c2.id));
  const buildingId = useViewStore((state) => state.activeBuildingId);
  const levelsStr = useSiteStore((state) => state.levels.filter((l2) => l2.buildingId === buildingId));
  const searchProps = useSearchData(searchPropsIn);
  const {
    levels: levelsIn,
    ...restLevelSelectorProps
  } = levelSelectorProps;
  const levels = React__default.useMemo(() => [...levelsStr || [], ...levelsIn || []], [levelsIn, levelsStr]);
  const {
    levels: levels3In,
    ...restLevelSelector3Props
  } = levelSelector3Props;
  const levels3 = React__default.useMemo(() => {
    const levels2 = [...levelsStr || [], ...levelsIn || []];
    const filteredFeatures = [];
    levels2 == null ? void 0 : levels2.forEach((level) => {
      var _a3;
      (_a3 = level == null ? void 0 : level.features) == null ? void 0 : _a3.forEach((feature2) => {
        var _a4, _b3;
        if (((_a4 = feature2 == null ? void 0 : feature2.geometry) == null ? void 0 : _a4.type) === "Polygon" && !((_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.layer)) {
          filteredFeatures.push({
            ...feature2,
            properties: {
              ...feature2.properties,
              levelNumber: level.levelNumber,
              name: level.name,
              id: level.id
            }
          });
        }
      });
    });
    return filteredFeatures;
  }, [levelsIn, levelsStr]);
  const {
    buttonProps: undergroundButtonProps = {},
    ...undergroundProps
  } = undergroundPropsIn || {};
  const legendProps = useLegend(legendPropsIn);
  const onLocatonChange = React__default.useCallback((center2) => {
    if (!useSiteStore.getState().defaultCenter) {
      setDefaultCenter(center2);
    }
  }, [setDefaultCenter]);
  const onLayerChange = React__default.useCallback((input) => {
    Object.keys(input).forEach((key) => {
      var _a3;
      const isCategory = ["venue", "building", "level"].includes(key) || categories2.includes(key);
      const value = input[key];
      if (isCategory)
        updateCategoryVisibility(key, value);
      updateVisibilityFlags(key, value);
      (_a3 = layerPropsIn == null ? void 0 : layerPropsIn.onChange) == null ? void 0 : _a3.call(layerPropsIn, key, value);
    });
  }, [categories2, layerPropsIn, updateCategoryVisibility, updateVisibilityFlags]);
  const layerChecked = React__default.useMemo(() => {
    const checked = {};
    invisibleFlags == null ? void 0 : invisibleFlags.forEach((key) => {
      checked[key] = false;
    });
    const checkedIn = layerPropsIn == null ? void 0 : layerPropsIn.checked;
    if (checkedIn) {
      Object.keys(checkedIn).forEach((key) => {
        if (typeof checked[key] === "undefined") {
          checked[key] = checkedIn[key];
        }
      });
    }
    return checked;
  }, [invisibleFlags, layerPropsIn == null ? void 0 : layerPropsIn.checked]);
  React__default.useLayoutEffect(() => {
    document.documentElement.style.setProperty("--selected-button-color", token.activeColor);
    document.documentElement.style.setProperty("--background-container-color", token.colorBgContainer);
    document.documentElement.style.setProperty("--background-layout-color", token.colorBgLayout);
    document.documentElement.style.setProperty("--border-color", token.colorBorder);
    document.documentElement.style.setProperty("--color-text", token.colorText);
    document.documentElement.style.setProperty("--map-controls-filter", token.colorBgContainer === "#ffffff" ? "invert(1)" : "invert(0)");
    document.documentElement.style.setProperty("--color-bg-blur", token.colorBgBlur);
  }, [token]);
  const tiles = React__default.useMemo(() => {
    const tiles2 = {};
    const addTile = (tile) => {
      if (tile) {
        const splitted = tile.split("/");
        const key = splitted[splitted.length - 1];
        tiles2[key] = tile;
      }
    };
    addTile(defaultTiles);
    addTile(activeTiles);
    return tiles2;
  }, [activeTiles, defaultTiles]);
  if (!containerId)
    return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(AttributionControls, { placement: attributionPlacement, ...attributionProps }),
    /* @__PURE__ */ jsx(AutoFocusOnSelectedItem, { enable: enableAutoFocus }),
    enableFullscreen && /* @__PURE__ */ jsx(FullscreenControl$1, { position: fullscreenPlacement, ...fullscreenProps }),
    enableSearch && /* @__PURE__ */ jsx(GeocoderControl, { id: "geocoder", position: searchPlacement, onChange: onLocatonChange, ...searchProps }),
    /* @__PURE__ */ jsx(MapResizer, { containerId }),
    enableTooltip && /* @__PURE__ */ jsx(TooltipHandler, { containerId, ...tooltipProps }),
    enableZoom && /* @__PURE__ */ jsx(ZoomControls, { placement: zoomPlacement, ...zoomProps }),
    /* @__PURE__ */ jsx(TilesSelector, { tile: activeTool === "geoReferencing" && !activeTiles ? defaultTiles : activeTiles, onChange: (tiles2) => setDefaultTiles(tiles2, true), tiles, containerId, marginHorizontal: "10px", marginVertical: "20px", placement: tilesSelectorPlacement, enableControls: enableTilesSelector, ...tilesSelectorProps }),
    enableLegend && createPortal(/* @__PURE__ */ jsx(LegendInfo, { placement: legendPlacement, ...legendProps }), document.getElementById(containerId) || document.body, `portal-legend${containerId}`),
    enableLevelSelector && createPortal(/* @__PURE__ */ jsx(LevelSelector$1, { placement: levelSelectorPlacement, levels, ...restLevelSelectorProps }), document.getElementById(containerId) || document.body, `portal-level-selector${containerId}`),
    enableLevelSelector3 && createPortal(/* @__PURE__ */ jsx(LevelSelector3, { placement: levelSelector3Placement, levels: levels3, ...restLevelSelector3Props }), document.getElementById(containerId) || document.body, `portal-level-selector${containerId}`),
    enableLayer && createPortal(/* @__PURE__ */ jsx(LayerDropdown, { placement: layerPlacement, ...layerPropsIn, onChange: onLayerChange, checked: layerChecked }), document.getElementById(containerId) || document.body, `portal-layer${containerId}`),
    enableScale && /* @__PURE__ */ jsx(ScaleControl$1, { position: scalePlacement, ...scaleProps }),
    enableCompass && createPortal(/* @__PURE__ */ jsx(MapCompass, { placement: compassPlacement, marginHorizontal: 58, marginVertical: 21, ...compassProps }), document.getElementById(containerId) || document.body),
    enableDisplayMode && createPortal(/* @__PURE__ */ jsx(DisplayModeToggle, { width: 40, height: 64, marginVertical: 120, marginHorizontal: 0, placement: displayModePlacement, ...displayModeProps }), document.getElementById(containerId) || document.body, `portal-displaymode${containerId}`),
    enableMapFocus && createPortal(/* @__PURE__ */ jsx(MapFocus, { width: 40, height: 40, marginVertical: 185, marginHorizontal: 0, placement: mapFocusPlacement, ...mapFocusProps }), document.getElementById(containerId) || document.body),
    enableTilesToggle && createPortal(/* @__PURE__ */ jsx(MapTilesToggle, { placement: tilesTogglePlacement, ...tilesToggleProps }), document.getElementById(containerId) || document.body, `portal-maptiles${containerId}`),
    enableUnderground && /* @__PURE__ */ jsx(Underground, { opacity: 0.1, ...undergroundProps, enableView: undergroundView, setEnableView: setUndergroundView, buttonProps: {
      placement: undergroundPlacement,
      ...undergroundButtonProps
    } })
  ] });
}
FeaturesControls.propTypes = {
  containerId: propTypesExports$1.string.isRequired,
  enableSearch: propTypesExports$1.bool,
  searchPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left", "header"]),
  searchProps: propTypesExports$1.object,
  enableFullscreen: propTypesExports$1.bool,
  fullscreenPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  fullscreenProps: propTypesExports$1.object,
  enableZoom: propTypesExports$1.bool,
  zoomPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  zoomProps: propTypesExports$1.object,
  enableTilesSelector: propTypesExports$1.bool,
  tilesSelectorPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  tilesSelectorProps: propTypesExports$1.object,
  enableScale: propTypesExports$1.bool,
  scalePlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  scaleProps: propTypesExports$1.object,
  enableCompass: propTypesExports$1.bool,
  compassPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  compassProps: propTypesExports$1.object,
  enableDisplayMode: propTypesExports$1.bool,
  displayModePlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  displayModeProps: propTypesExports$1.object,
  enableTilesToggle: propTypesExports$1.bool,
  tilesTogglePlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  tilesToggleProps: propTypesExports$1.object,
  enableLegend: propTypesExports$1.bool,
  legendPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  legendProps: propTypesExports$1.object,
  enableLayer: propTypesExports$1.bool,
  layerPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  layerProps: propTypesExports$1.object,
  enableMapFocus: propTypesExports$1.bool,
  mapFocusPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  mapFocusProps: propTypesExports$1.object,
  enableTooltip: propTypesExports$1.bool,
  tooltipProps: propTypesExports$1.object,
  enableLevelSelector: propTypesExports$1.bool,
  levelSelectorPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  levelSelectorProps: propTypesExports$1.object,
  enableLevelSelector3: propTypesExports$1.bool,
  levelSelector3Placement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  levelSelector3Props: propTypesExports$1.object,
  enableAutoFocus: propTypesExports$1.bool,
  attributionPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  attributionProps: propTypesExports$1.object,
  enableUnderground: propTypesExports$1.bool,
  undergroundPlacement: propTypesExports$1.oneOf(["bottom-right", "top-right", "bottom-left", "top-left"]),
  undergroundProps: propTypesExports$1.object
};
FeaturesControls.defaultProps = {
  enableSearch: false,
  searchPlacement: "top-right",
  searchProps: {},
  enableFullscreen: false,
  fullscreenPlacement: "top-left",
  fullscreenProps: {},
  enableZoom: false,
  zoomPlacement: "bottom-right",
  zoomProps: {},
  enableTilesSelector: false,
  tilesSelectorPlacement: "top-right",
  tilesSelectorProps: {},
  enableScale: false,
  scalePlacement: "bottom-left",
  scaleProps: {},
  enableCompass: false,
  compassPlacement: "top-right",
  compassProps: {},
  enableDisplayMode: false,
  displayModePlacement: "bottom-right",
  displayModeProps: {},
  enableTilesToggle: false,
  tilesTogglePlacement: "bottom-right",
  tilesToggleProps: {},
  enableLegend: false,
  legendPlacement: "bottom-left",
  legendProps: {},
  enableLayer: false,
  layerPlacement: "bottom-left",
  layerProps: {},
  enableMapFocus: false,
  mapFocusPlacement: "bottom-right",
  mapFocusProps: {},
  enableTooltip: false,
  tooltipProps: {},
  enableLevelSelector: false,
  levelSelectorPlacement: "bottom-right",
  levelSelectorProps: {},
  enableLevelSelector3: false,
  levelSelector3Placement: "top-left",
  levelSelector3Props: {},
  enableAutoFocus: true,
  attributionPlacement: "bottom-right",
  attributionProps: {},
  enableUnderground: true,
  undergroundPlacement: "top-right",
  undergroundProps: {}
};
const MAP_PROPS$1 = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: true
  },
  tilesetUrl: MapTilesConstants.None.tilesetUrl,
  reuseMaps: false
};
const autoFocusEnabled$1 = true;
function FeaturesMapEdit(props) {
  const {
    id: containerId,
    activeId,
    onLoad,
    enableGeoreferencing,
    exportProps: exportPropsIn,
    camera,
    children,
    enableSearch,
    customIcon,
    overlay,
    onMapLoad,
    loading: loading2,
    interactions: interactions2,
    controls,
    minZoom,
    maxZoom,
    beforeId,
    mapProps: mapProps2
  } = props;
  const deviceTypes = useDeviceTypeStore((state) => state.deviceTypes);
  const [cameraResetEnabled, setCameraResetEnabled] = React__default.useState(true);
  const displayMode2 = useViewStore((state) => state.displayMode);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const toolDrawMode2 = "noselect";
  const activeItemId = useViewStore((state) => state.activeCollectionItemId);
  const {
    onLoad: onJsonLoad
  } = useJsonLoader();
  const windowSplit = useViewStore((state) => state.windowSplit);
  const setMapSnapPoints = useViewStore((state) => state.setMapSnapPoints);
  const disableToolButton = useViewStore((state) => state.disableToolButton);
  const enableToolButton = useViewStore((state) => state.enableToolButton);
  const activeLevelId = useViewStore((state) => state.activeLevelId);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const addAsset = useAssetStore((state) => state.addAsset);
  const setAssetVisibility = useAssetStore((state) => state.setVisibility);
  const assets = useAssetStore((state) => state.assets);
  const editAssetId = useAssetStore((state) => state.editAssetId);
  const updateAsset = useAssetStore((state) => state.updateAsset);
  const invisibleFlags = useViewStore((state) => state.invisibleFlags);
  const setActiveLevelId = useViewStore((state) => state.setActiveLevelId);
  const activeFormFeatureIds = useViewStore((state) => state.activeFormFeatureIds);
  const {
    allFeatures,
    territories
  } = useFeatures({
    id: activeId,
    fallback: false,
    recursive: false,
    fallbackToParent: true
  });
  const found = useFeaturesAdvanced({
    id: activeId,
    fallback: true,
    recursive: true,
    skipFeatures: activeFormFeatureIds
  });
  const {
    type: parentType,
    id: parentId,
    center: center2,
    visibleFeatures,
    flooredBuildings,
    singleFloorActive
  } = found || {};
  const numModels = (assets == null ? void 0 : assets.length) || 0;
  const numModelsLoadedRef = React__default.useRef(0);
  const onModel3dLoad = React__default.useCallback(() => {
    numModelsLoadedRef.current += 1;
    if (numModels === numModelsLoadedRef.current) {
      onLoad(numModels);
    }
  }, [numModels, onLoad]);
  const onConvertedFeatures = React__default.useCallback((features) => {
    if (!features)
      return;
    onJsonLoad({
      type: "FeatureCollection",
      features
    }, true, {
      parentId,
      parentType,
      category: "custom"
    });
    if (!useViewStore.getState().activeCollectionItemId) {
      useViewStore.getState().setActiveCollectionItemId(parentId);
    }
  }, [onJsonLoad, parentId, parentType]);
  const onOpacityDone = React__default.useCallback((data2) => {
    updateAsset(data2);
    setActiveSubTool(null);
  }, [setActiveSubTool, updateAsset]);
  const hasAnyActive = React__default.useMemo(() => parentType === "orphan" || activeItemId === parentId, [activeItemId, parentId, parentType]);
  React__default.useLayoutEffect(() => {
    const asset = assets.find((asset2) => asset2.id === editAssetId);
    const array2 = [
      // 'geoReferencing',
      "geoReferencingSnap",
      "geoReferencingSkew",
      "geoReferencingDrag",
      "geoReferencingRotate",
      "geoReferencingScale",
      "editFootprintOpacity",
      "removeAsset"
    ];
    if (["IMAGE", "GLTF", "DXF"].includes(asset == null ? void 0 : asset.type)) {
      array2.forEach(enableToolButton);
    } else {
      array2.forEach(disableToolButton);
    }
  }, [assets, disableToolButton, editAssetId, enableToolButton]);
  const onExportAsset = React__default.useCallback((exportResult, asset, onExportDoneIn) => {
    const {
      id,
      geojson,
      success,
      type,
      box,
      sourceFile,
      ...rest
    } = exportResult || {};
    if (id && success) {
      const newAsset = {
        type,
        id,
        displayMode: asset.displayMode,
        parentId: asset.parentId,
        parentType: asset.parentType
      };
      if (type === "IMAGE") {
        updateAsset({
          id,
          box
        });
      } else if (type === "GEOJSON") {
        onConvertedFeatures(geojson == null ? void 0 : geojson.features);
      } else if (type === "ION") {
        addAsset(newAsset);
      } else if (type === "GLTF") {
        newAsset.id = asset.id;
        newAsset.sourceFile = sourceFile;
        newAsset.center = rest.center;
        newAsset.azimuth = rest.azimuth;
        newAsset.dip = rest.dip;
        newAsset.head = rest.head;
        updateAsset(newAsset);
      }
      onExportDoneIn({
        id: newAsset.id,
        success: true
      });
      setTimeout(() => setAssetVisibility(asset, newAsset.type === asset.type), 100);
    } else {
      onExportDoneIn({
        id,
        success: false
      });
    }
  }, [addAsset, onConvertedFeatures, setAssetVisibility, updateAsset]);
  const exportProps = React__default.useCallback((asset) => {
    if (displayMode2 === asset.displayMode && exportPropsIn) {
      const {
        onExportDone,
        onExportProgress,
        onExportStart
      } = exportPropsIn;
      const NullFunc = () => {
      };
      return {
        onExportStart: onExportStart || NullFunc,
        onExportDone: (result) => onExportAsset(result, asset, onExportDone || NullFunc),
        onExportProgress: onExportProgress || NullFunc
      };
    }
    return {};
  }, [displayMode2, exportPropsIn, onExportAsset]);
  React__default.useEffect(() => {
    {
      const DELAY = 1e3;
      setTimeout(() => {
        setCameraResetEnabled(false);
      }, DELAY);
    }
  }, []);
  const enablePointPicker = windowSplit && activeSubTool === "geoReferencingSnapSplit";
  const filteredAssets = assets.filter((asset) => asset.parentId === activeItemId);
  if (!center2 || !parentId || !parentType)
    return null;
  return /* @__PURE__ */ jsxs(LazyMap, { center: center2, ...MAP_PROPS$1, camera: {
    ...MAP_PROPS$1.camera,
    enabled: cameraResetEnabled,
    pitchWithRotate: displayMode2 !== "2d",
    ...camera
  }, id: containerId, overlay, onLoad: onMapLoad, loading: loading2, ...mapProps2, children: [
    /* @__PURE__ */ jsx(FeaturesControls, { containerId, enableSearch, enableZoom: true, searchPlacement: "header", enableScale: true, enableMapFocus: true, enableDisplayMode: true, enableTilesToggle: !!activeLevelId, ...controls, enableLevelSelector3: (controls == null ? void 0 : controls.enableLevelSelector3) && !!activeBuildingId && displayMode2 === "3d", levelSelector3Props: {
      onLevelSelect: setActiveLevelId,
      activeLevelId,
      ...(controls == null ? void 0 : controls.levelSelectorProps) || {}
    } }),
    /* @__PURE__ */ jsx(MapAutoFocus, { enabled: autoFocusEnabled$1, features: allFeatures }),
    hasAnyActive && /* @__PURE__ */ jsx(
      FeaturesView,
      {
        id: "sai-features-view-global",
        singleFloorActive,
        drawMode: toolDrawMode2,
        flooredBuildings,
        features: visibleFeatures,
        deviceTypes,
        territories,
        displayMode: displayMode2,
        customIcon,
        minZoom,
        maxZoom,
        beforeId,
        showText: !(invisibleFlags == null ? void 0 : invisibleFlags.includes("apChannelsName"))
      }
    ),
    filteredAssets == null ? void 0 : filteredAssets.map((model3d) => /* @__PURE__ */ jsx(GeoreferencedAsset, { drawMode: toolDrawMode2, displayMode: displayMode2, data: model3d, onChange: updateAsset, onLoad: onModel3dLoad, enableEdit: parentId === model3d.parentId && displayMode2 === model3d.displayMode && enableGeoreferencing, exportProps: exportProps(model3d), onOpacityDone, minZoom, maxZoom, beforeId }, model3d.id)),
    /* @__PURE__ */ jsx(MapClickPointsReceiver, { active: enablePointPicker, updateClickPoints: setMapSnapPoints }),
    /* @__PURE__ */ jsx(Interactions, { ...interactions2 }),
    /* @__PURE__ */ jsx(MapTools, { id: activeItemId, deviceTypes }),
    children
  ] });
}
FeaturesMapEdit.propTypes = {
  id: propTypesExports$1.string,
  activeId: propTypesExports$1.string,
  onLoad: propTypesExports$1.func,
  enableGeoreferencing: propTypesExports$1.bool,
  exportProps: propTypesExports$1.object,
  enableSearch: propTypesExports$1.bool,
  children: propTypesExports$1.node,
  customIcon: propTypesExports$1.func,
  overlay: propTypesExports$1.bool,
  onMapLoad: propTypesExports$1.func,
  loading: propTypesExports$1.bool,
  camera: propTypesExports$1.object,
  interactions: propTypesExports$1.object,
  controls: propTypesExports$1.object,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  beforeId: propTypesExports$1.string,
  mapProps: propTypesExports$1.object
};
FeaturesMapEdit.defaultProps = {
  id: "featuresMapView",
  activeId: "",
  onLoad: () => {
  },
  enableGeoreferencing: false,
  exportProps: null,
  enableSearch: true,
  children: null,
  customIcon: null,
  overlay: false,
  onMapLoad: () => {
  },
  loading: false,
  camera: {},
  interactions: {},
  controls: {},
  minZoom: 0,
  maxZoom: 24,
  beforeId: "",
  mapProps: {}
};
function HiOutlineDotsVertical(props) {
  return GenIcon({ "tag": "svg", "attr": { "fill": "none", "viewBox": "0 0 24 24", "strokeWidth": "2", "stroke": "currentColor", "aria-hidden": "true" }, "child": [{ "tag": "path", "attr": { "strokeLinecap": "round", "strokeLinejoin": "round", "d": "M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" } }] })(props);
}
function PopOverActionButton(props) {
  const {
    actions,
    icon,
    onAction,
    disabled,
    ...restProps
  } = props;
  const menuItems = React__default.useMemo(() => actions.map((action) => ({
    key: action.key,
    label: /* @__PURE__ */ jsx(PopOverMenuItems, { label: action.label, itemKey: action.key, disabled: action.disabled, icon: action.icon, onAction: () => onAction(action.key) })
  })), [actions, onAction]);
  const menu = React__default.useMemo(() => /* @__PURE__ */ jsx(Menu, { onClick: (event) => {
    var _a3, _b3;
    (_b3 = (_a3 = event == null ? void 0 : event.domEvent) == null ? void 0 : _a3.stopPropagation) == null ? void 0 : _b3.call(_a3);
    onAction(event == null ? void 0 : event.key);
  }, style: {
    background: "transparent",
    width: "160px",
    borderRadius: 0
  }, mode: "vertical", selectable: false, items: menuItems }), [menuItems, onAction]);
  if (!(actions == null ? void 0 : actions.length))
    return null;
  return /* @__PURE__ */ jsx(Popover, { content: menu, placement: "bottomLeft", arrow: false, trigger: "hover", zIndex: 100, ...restProps, children: /* @__PURE__ */ jsx(Button, { type: "text", icon, size: "small", disabled }) });
}
PopOverActionButton.propTypes = {
  actions: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    label: propTypesExports$1.string.isRequired,
    key: propTypesExports$1.string.isRequired,
    icon: propTypesExports$1.node,
    disabled: propTypesExports$1.bool
  })),
  onAction: propTypesExports$1.func,
  icon: propTypesExports$1.node,
  disabled: propTypesExports$1.bool
};
PopOverActionButton.defaultProps = {
  actions: [],
  onAction: () => {
  },
  icon: /* @__PURE__ */ jsx(HiOutlineDotsVertical, {}),
  disabled: false
};
function TbGeometry(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "strokeWidth": "2", "stroke": "currentColor", "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "stroke": "none", "d": "M0 0h24v24H0z", "fill": "none" } }, { "tag": "path", "attr": { "d": "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714" } }, { "tag": "path", "attr": { "d": "M12 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" } }, { "tag": "path", "attr": { "d": "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5" } }, { "tag": "path", "attr": { "d": "M12 5v-2" } }] })(props);
}
function TbWall(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "strokeWidth": "2", "stroke": "currentColor", "fill": "none", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "path", "attr": { "stroke": "none", "d": "M0 0h24v24H0z", "fill": "none" } }, { "tag": "path", "attr": { "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" } }, { "tag": "path", "attr": { "d": "M4 8h16" } }, { "tag": "path", "attr": { "d": "M20 12h-16" } }, { "tag": "path", "attr": { "d": "M4 16h16" } }, { "tag": "path", "attr": { "d": "M9 4v4" } }, { "tag": "path", "attr": { "d": "M14 8v4" } }, { "tag": "path", "attr": { "d": "M8 12v4" } }, { "tag": "path", "attr": { "d": "M16 12v4" } }, { "tag": "path", "attr": { "d": "M11 16v4" } }] })(props);
}
function RxCube(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 15 15", "fill": "none" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "clipRule": "evenodd", "d": "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z", "fill": "currentColor" } }] })(props);
}
const {
  useToken: useToken$5
} = theme$2;
function TreeNodeItem(props) {
  const {
    node,
    onClick: onClick2,
    onAction: onActionIn,
    icon,
    style: style2,
    extra,
    color,
    actions
  } = props;
  const clickTimerRef = React__default.useRef(null);
  const rowRef = React__default.useRef(null);
  const [maxWidth, setMaxWidth] = React__default.useState("278px");
  const [isHover, setIsHover] = React__default.useState(false);
  React__default.useEffect(() => {
    if (!rowRef.current)
      return () => {
      };
    const observer = new ResizeObserver(() => {
      var _a3, _b3;
      const rect = (_b3 = (_a3 = rowRef.current) == null ? void 0 : _a3.getBoundingClientRect) == null ? void 0 : _b3.call(_a3);
      if (rect) {
        setMaxWidth(`${rect.width - 60}px`);
      }
    });
    observer.observe(rowRef.current);
    return () => rowRef.current && observer.unobserve(rowRef.current);
  }, []);
  const onAction = React__default.useCallback((action) => {
    if (action === "view") {
      onClick2({
        node
      });
    } else {
      onActionIn({
        action,
        node
      });
    }
  }, [node, onClick2, onActionIn]);
  const click = React__default.useCallback((event) => {
    event.stopPropagation();
    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current);
      clickTimerRef.current = null;
    } else {
      clickTimerRef.current = setTimeout(() => {
        onClick2({
          node
        });
        clickTimerRef.current = null;
      }, 300);
    }
  }, [node, onClick2]);
  const doubleClick = React__default.useCallback((event) => {
    event.stopPropagation();
    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current);
      clickTimerRef.current = null;
    }
    onActionIn({
      action: "edit",
      node
    });
  }, [node, onActionIn]);
  const onVenueEditMore = React__default.useCallback(() => {
    onClick2({
      node,
      byVenueEdit: true
    });
  }, [node, onClick2]);
  const containerStyle2 = React__default.useMemo(() => ({
    width: "100%",
    paddingLeft: (style2 == null ? void 0 : style2.borderLeft) ? "6px" : "4px",
    ...style2
  }), [style2]);
  return /* @__PURE__ */ jsxs(Row, { style: containerStyle2, ref: rowRef, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), children: [
    icon,
    /* @__PURE__ */ jsxs("div", { style: {
      flex: 1,
      display: "flex",
      marginLeft: "8px",
      marginRight: "8px",
      justifyContent: "space-between",
      alignItems: "center"
    }, children: [
      /* @__PURE__ */ jsx("div", { onClick: click, onDoubleClick: doubleClick, style: {
        flex: 1
      }, children: /* @__PURE__ */ jsxs("div", { style: {
        display: "flex",
        alignItems: "center"
      }, children: [
        color && /* @__PURE__ */ jsx("div", { style: {
          width: "10px",
          height: "10px",
          backgroundColor: color,
          borderRadius: "50%",
          marginRight: "5px"
        } }),
        /* @__PURE__ */ jsx(Tooltip$1, { title: node.label, children: /* @__PURE__ */ jsx(Typography.Text, { style: {
          maxWidth
        }, ellipsis: true, children: node.label }) })
      ] }) }),
      /* @__PURE__ */ jsxs(Space, { children: [
        extra,
        node.active && /* @__PURE__ */ jsx(PopOverActionButton, { actions, onAction, icon: /* @__PURE__ */ jsx(SettingOutlined, {}) }),
        node.category === "venue" && isHover && /* @__PURE__ */ jsx(Button, { type: "primary", icon: /* @__PURE__ */ jsx(PlusOutlined, { style: {
          fontSize: "10px"
        } }), style: {
          width: "24px",
          height: "24px",
          marginLeft: "5px",
          borderRadius: "4px"
        }, onClick: onVenueEditMore })
      ] })
    ] })
  ] });
}
TreeNodeItem.propTypes = {
  node: propTypesExports$1.shape({
    label: propTypesExports$1.string,
    active: propTypesExports$1.bool,
    category: propTypesExports$1.string
  }),
  onClick: propTypesExports$1.func,
  onAction: propTypesExports$1.func,
  actions: propTypesExports$1.array,
  icon: propTypesExports$1.node,
  style: propTypesExports$1.object,
  extra: propTypesExports$1.node,
  color: propTypesExports$1.string
};
TreeNodeItem.defaultProps = {
  node: {},
  onClick: () => {
  },
  onAction: () => {
  },
  actions: [],
  icon: null,
  style: {},
  extra: null,
  color: null
};
function DisplayTag({
  displayMode: displayMode2
}) {
  const {
    token
  } = useToken$5();
  return /* @__PURE__ */ jsx("div", { style: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "33px",
    height: "32px",
    borderRadius: "4px",
    border: `1px solid ${token.colorBorder}`,
    padding: "1 8px",
    fontSize: "12px"
  }, children: displayMode2.toUpperCase() });
}
DisplayTag.propTypes = {
  displayMode: propTypesExports$1.string
};
DisplayTag.defaultProps = {
  displayMode: null
};
const ACTIONS$1 = [
  {
    label: "Show/Hide",
    key: "show-or-hide"
  },
  {
    label: "Rename",
    key: "rename"
  },
  // either rename or edit
  {
    label: "Edit",
    key: "edit"
  },
  // either rename or edit
  {
    label: "Delete",
    key: "delete"
  }
];
const categories = [
  {
    id: "footprint",
    label: "Boundaries",
    icon: IoImageOutline
  },
  {
    id: "wall",
    label: "Walls",
    icon: TbWall
  },
  {
    id: "window",
    label: "Windows",
    icon: MdOutlineWindow
  },
  {
    id: "room",
    label: "Rooms",
    icon: MdCheckBoxOutlineBlank
  },
  {
    id: "attenuatingObject",
    label: "Attenuating Objects",
    icon: RxCube
  },
  {
    id: "custom",
    label: "Others",
    icon: TbGeometry
  },
  // { id: 'accessPoint', label: 'Access Points', icon: MdOutlineRoom }, // do not render accessPoint in FeatureTree
  {
    id: "asset",
    label: "Others",
    icon: TbGeometry
  },
  {
    id: "layer",
    label: "Layers",
    icon: MdOutlineWindow
  }
];
function useFeatureTree(props) {
  const {
    id: activeId,
    showIcons,
    showFeatures,
    showLayers,
    showAssets
  } = props || {};
  const invisibleLayers = useViewStore((state) => state.invisibleLayers);
  const updateLayerVisibility = useViewStore((state) => state.updateLayerVisibility);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const setActiveLayerId = useViewStore((state) => state.setActiveLayerId);
  const activeLayerId = useViewStore((state) => state.activeLayerId);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const deleteFilteredFeatures = useSiteStore((state) => state.deleteFilteredFeatures);
  const removeFromCollection = useSiteStore((state) => state.removeFromCollection);
  const [data2, setData6] = React__default.useState([]);
  const setAssetVisibility = useAssetStore((state) => state.setVisibility);
  const removeAsset = useAssetStore((state) => state.removeAsset);
  const getAsset = useAssetStore((state) => state.getAsset);
  const setEditAssetId = useAssetStore((state) => state.setEditAssetId);
  const updateFeature = useSiteStore((state) => state.updateFeature);
  const {
    allFeatures,
    id
  } = useFeatures({
    id: activeId,
    fallback: false,
    recursive: false
  });
  const assets = useAssets({
    id: activeId
  });
  const getFeatureColor = React__default.useCallback((feature2) => feature2.properties.stroke || feature2.properties.fill || "#FFFFFF", []);
  const renderColorDot = React__default.useCallback((color) => /* @__PURE__ */ jsx("div", { style: {
    width: "10px",
    height: "10px",
    backgroundColor: color,
    borderRadius: "50%",
    marginRight: "5px"
  } }), []);
  const colorAndText = React__default.useCallback((color, text, others = null) => {
    if (!color) {
      return /* @__PURE__ */ jsx(Typography.Text, { children: text });
    }
    return /* @__PURE__ */ jsxs("div", { style: {
      display: "flex",
      alignItems: "center"
    }, children: [
      renderColorDot(color),
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        marginLeft: "10px",
        width: "195px"
      }, children: text }),
      others
    ] });
  }, [renderColorDot]);
  const renderFeatureItem = React__default.useCallback(({
    feature: feature2,
    title,
    visible,
    active: active3,
    actions,
    onAction: onAction2,
    key
  }) => {
    const Icon2 = visible ? EyeOutlined : EyeInvisibleOutlined;
    const extra = /* @__PURE__ */ jsx(Icon2, { onClick: () => {
      onAction2("show-or-hide");
    } });
    return /* @__PURE__ */ jsx(TreeNodeItem, { color: getFeatureColor(feature2), node: {
      label: title,
      active: active3,
      key
    }, onAction: (data22) => {
      if ((data22 == null ? void 0 : data22.action) && (actions == null ? void 0 : actions.find((i2) => i2.key === data22.action))) {
        onAction2(data22.action);
      }
    }, actions, extra });
  }, [getFeatureColor]);
  const onAction = React__default.useCallback((layerOrAssetOrFeatureName, action, type) => {
    let asset = null;
    if (!layerOrAssetOrFeatureName || !action)
      return null;
    if (type === "layer") {
      const isInvisible = invisibleLayers == null ? void 0 : invisibleLayers.includes(layerOrAssetOrFeatureName);
      const filter17 = (feature2) => feature2.properties.layer === layerOrAssetOrFeatureName;
      switch (action) {
        case "show-or-hide":
          updateLayerVisibility(layerOrAssetOrFeatureName, isInvisible);
          break;
        case "edit":
          setActiveLayerId(layerOrAssetOrFeatureName);
          setActiveSubTool("editLayer");
          break;
        case "delete":
          removeFromCollection("layer", {
            id,
            filter: filter17
          });
          break;
      }
    } else if (type === "asset") {
      setEditAssetId(null);
      setEditAssetId(layerOrAssetOrFeatureName);
      switch (action) {
        case "show-or-hide":
          asset = getAsset(layerOrAssetOrFeatureName);
          setTimeout(() => setAssetVisibility(asset, !asset.visible), 100);
          break;
        case "edit":
          setActiveSubTool("editAsset");
          break;
        case "delete":
          removeAsset(layerOrAssetOrFeatureName);
          setEditAssetId(null);
          break;
      }
    } else if (type === "feature") {
      const found = allFeatures == null ? void 0 : allFeatures.find((f2) => f2.id === layerOrAssetOrFeatureName);
      const filter17 = (feature2) => feature2.id === layerOrAssetOrFeatureName;
      switch (action) {
        case "show-or-hide":
          updateFeature({
            feature: {
              ...found,
              properties: {
                ...found.properties,
                visible: typeof found.properties.visible === "boolean" ? !found.properties.visible : false
              }
            },
            parentId: found.properties.parentId,
            category: found.properties.category,
            parentType: found.properties.parentType
          });
          break;
        case "rename":
          setActiveSubTool("renameFeature");
          break;
        case "delete":
          deleteFilteredFeatures({
            parentId: found.properties.parentId,
            parentType: found.properties.parentType
          }, filter17);
          break;
      }
    }
    return null;
  }, [id, updateLayerVisibility, setActiveSubTool, setActiveLayerId, invisibleLayers, deleteFilteredFeatures, getAsset, removeAsset, setAssetVisibility, setEditAssetId, allFeatures, updateFeature, removeFromCollection]);
  const getCategoryTree = React__default.useCallback((parent) => {
    const childKeysSet = /* @__PURE__ */ new Set();
    const data22 = [];
    categories.forEach((category) => {
      var _a3;
      const categoryT = {
        key: `${parent.id}${category.id}`,
        title: colorAndText(null, `${category.label}`),
        children: [],
        type: "category",
        category: category.id,
        icon: showIcons ? category.icon : null
      };
      (_a3 = parent.features) == null ? void 0 : _a3.forEach((feature2) => {
        var _a4, _b3;
        if (((_a4 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a4.category) !== category.id)
          return;
        if (childKeysSet.has(feature2.id))
          return;
        const featureT = {
          key: feature2.id,
          title: renderFeatureItem({
            feature: feature2,
            title: ((_b3 = feature2.properties) == null ? void 0 : _b3.name) || feature2.name || feature2.id,
            visible: !("visible" in feature2.properties) || feature2.properties.visible,
            active: !activeSubTool,
            onAction: (action) => onAction(feature2.id, action, "feature"),
            actions: ACTIONS$1.filter((i2) => i2.key !== "edit"),
            key: feature2.id
          }),
          children: [],
          type: "feature"
        };
        if (showFeatures) {
          categoryT.children.push(featureT);
          childKeysSet.add(feature2.id);
        }
      });
      if (categoryT.children.length)
        data22.push(categoryT);
    });
    return data22;
  }, [colorAndText, showIcons, renderFeatureItem, activeSubTool, showFeatures, onAction]);
  const getLayerTree = React__default.useCallback((parent) => {
    var _a3;
    const childKeysSet = /* @__PURE__ */ new Set();
    const data22 = [];
    const layers = {};
    const layerT = {
      key: `${parent.id}layers`,
      title: colorAndText(null, `Layers`),
      children: [],
      type: "layers",
      icon: showIcons ? /* @__PURE__ */ jsx(MdOutlineLayers, {}) : null
    };
    (_a3 = parent.features) == null ? void 0 : _a3.forEach((feature2) => {
      var _a4, _b3;
      if (childKeysSet.has(feature2.id))
        return;
      const featureT = {
        key: feature2.id,
        title: colorAndText(getFeatureColor(feature2), ((_a4 = feature2.properties) == null ? void 0 : _a4.name) || feature2.name || feature2.id),
        children: [],
        type: "feature"
      };
      const layerName = (_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.layer;
      if (layerName) {
        if (!layers[layerName]) {
          layers[layerName] = {
            key: `${parent.id}${layerName}`,
            title: renderFeatureItem({
              feature: feature2,
              title: layerName,
              visible: !(invisibleLayers == null ? void 0 : invisibleLayers.includes(layerName)),
              active: !activeSubTool || layerName === activeLayerId,
              onAction: (action) => onAction(layerName, action, "layer"),
              actions: ACTIONS$1.filter((i2) => i2.key !== "rename"),
              key: `${parent.id}${layerName}`
            }),
            type: "layer",
            layerName,
            children: []
          };
        }
        if (showFeatures) {
          layers[layerName].children.push(featureT);
        }
      } else if (showFeatures) {
        layerT.children.push(featureT);
        childKeysSet.add(feature2.id);
      }
    });
    Object.keys(layers).forEach((layer) => {
      layerT.children.push(layers[layer]);
    });
    if (layerT.children.length)
      data22.push(layerT);
    return data22;
  }, [colorAndText, showIcons, getFeatureColor, showFeatures, renderFeatureItem, invisibleLayers, activeSubTool, activeLayerId, onAction]);
  const getAssetsTree = React__default.useCallback((parent, assets2) => {
    if (!showAssets)
      return [];
    const features = [];
    assets2 == null ? void 0 : assets2.forEach((asset) => {
      if (asset.type !== "IMAGE")
        return;
      const feature2 = AssetHelper.getAssetFeature(asset, false);
      if (feature2) {
        features.push(feature2);
      }
    });
    if (!features.length)
      return [];
    const childKeysSet = /* @__PURE__ */ new Set();
    const data22 = [];
    const assetsT = {
      key: `${parent.id}assets`,
      title: colorAndText(null, `Raster`),
      children: [],
      type: "assets",
      icon: showIcons ? /* @__PURE__ */ jsx(MdOutlineLayers, {}) : null
    };
    features == null ? void 0 : features.forEach((feature2) => {
      var _a3;
      if (childKeysSet.has(feature2.id))
        return;
      const featureT = {
        key: feature2.id,
        title: renderFeatureItem({
          feature: feature2,
          title: ((_a3 = feature2.properties) == null ? void 0 : _a3.name) || feature2.name || "Untitled",
          visible: !("visible" in feature2.properties) || feature2.properties.visible,
          active: !activeSubTool,
          onAction: (action) => onAction(feature2.id, action, "asset"),
          actions: ACTIONS$1.filter((i2) => i2.key !== "rename"),
          key: feature2.id
        }),
        children: [],
        type: "asset"
      };
      assetsT.children.push(featureT);
      childKeysSet.add(feature2.id);
    });
    if (assetsT.children.length)
      data22.push(assetsT);
    return data22;
  }, [showAssets, colorAndText, showIcons, renderFeatureItem, activeSubTool, onAction]);
  React__default.useLayoutEffect(() => {
    const data22 = getAssetsTree({
      id
    }, assets) || [];
    if (!showLayers) {
      const result = getCategoryTree({
        features: allFeatures,
        id
      });
      if (result)
        data22.push(...result);
    } else {
      const result = getLayerTree({
        features: allFeatures,
        id
      });
      if (result)
        data22.push(...result);
    }
    setData6(data22);
  }, [allFeatures, assets, getAssetsTree, getCategoryTree, getLayerTree, id, showLayers]);
  return data2;
}
function FeatureTreeView(props) {
  const {
    id: activeId,
    onSelect: onSelectIn,
    onCheck,
    height,
    showLayers,
    showFeatures,
    showAssets
  } = props;
  const data2 = useFeatureTree({
    id: activeId,
    showIcons: true,
    showFeatures,
    showLayers,
    showAssets
  });
  const onSelect = React__default.useCallback((_2, event) => {
    const {
      node
    } = event || {};
    if (!(node == null ? void 0 : node.key))
      return;
    const selectedKey = node.key;
    if (selectedKey) {
      const selected = {
        selectedId: selectedKey,
        parentId: activeId,
        type: node.type
      };
      if (node == null ? void 0 : node.category)
        selected.category = node.category;
      if (node == null ? void 0 : node.layerName)
        selected.layerName = node.layerName;
      onSelectIn(selected);
    }
  }, [activeId, onSelectIn]);
  if (!data2 || data2.length === 0)
    return null;
  return /* @__PURE__ */ jsx(
    Tree,
    {
      defaultExpandAll: true,
      onCheck,
      onSelect,
      treeData: data2,
      showIcon: true,
      height,
      switcherIcon: /* @__PURE__ */ jsx(DownOutlined, {})
    }
  );
}
FeatureTreeView.propTypes = {
  id: propTypesExports$1.string,
  onSelect: propTypesExports$1.func,
  onCheck: propTypesExports$1.func,
  height: propTypesExports$1.number,
  showLayers: propTypesExports$1.bool,
  showFeatures: propTypesExports$1.bool,
  showAssets: propTypesExports$1.bool
};
FeatureTreeView.defaultProps = {
  id: null,
  onSelect: () => {
  },
  onCheck: () => {
  },
  height: 700,
  showLayers: false,
  showFeatures: false,
  showAssets: false
};
const inputStyle = (isChild) => ({
  width: isChild ? "100%" : "230px",
  height: "32px"
});
const {
  useToken: useToken$4
} = theme$2;
function TreeNameInput(props) {
  const {
    isChild,
    value,
    icon,
    isCountry,
    onChange: onChangeIn,
    defaultValue: defaultValue2,
    style: style2
  } = props;
  const [helperData, setHelperData] = React__default.useState({});
  const {
    token
  } = useToken$4();
  const onChange = React__default.useCallback((e3) => {
    var _a3;
    const value2 = typeof e3 === "string" ? e3 : (_a3 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a3.value;
    onChangeIn(value2);
  }, [onChangeIn]);
  const containerStyle2 = React__default.useMemo(() => ({
    width: inputStyle(isChild).width,
    paddingLeft: (style2 == null ? void 0 : style2.borderLeft) ? "6px" : "4px",
    ...style2
  }), [style2, isChild]);
  return /* @__PURE__ */ jsxs("div", { style: containerStyle2, children: [
    isCountry && /* @__PURE__ */ jsx(AddressSelector, { onChange: setHelperData, value: helperData }),
    /* @__PURE__ */ jsxs(Space, { children: [
      icon,
      /* @__PURE__ */ jsxs("div", { style: {
        width: "100%"
      }, children: [
        !isCountry && /* @__PURE__ */ jsx(Input$2, { autoFocus: true, defaultValue: defaultValue2, value, style: {
          ...inputStyle(isChild),
          borderColor: token.activeColor
        }, onChange }),
        isCountry && /* @__PURE__ */ jsx(Select, { placeholder: "Choose Country", showSearch: true, defaultValue: defaultValue2, value, data: helperData == null ? void 0 : helperData.countries, onChange, style: {
          ...inputStyle(isChild),
          borderColor: token.activeColor
        } })
      ] })
    ] })
  ] });
}
TreeNameInput.propTypes = {
  isCountry: propTypesExports$1.bool,
  isChild: propTypesExports$1.bool,
  defaultValue: propTypesExports$1.string,
  value: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  icon: propTypesExports$1.node,
  style: propTypesExports$1.object
};
TreeNameInput.defaultProps = {
  isCountry: false,
  isChild: false,
  defaultValue: "",
  value: "",
  onChange: () => {
  },
  icon: null,
  style: {}
};
const ACTIONS = [
  // { label: 'View', key: 'view' },
  {
    label: "Edit",
    key: "edit"
  },
  {
    label: "Export",
    key: "export"
  },
  {
    label: "Delete",
    key: "delete"
  }
];
function useMcrTree(props = {}) {
  const {
    enableCreateNode,
    activeId,
    activeType,
    onSelect,
    onAction,
    enableEditNode
  } = props;
  const activeVenueId = useViewStore((state2) => state2.activeVenueId);
  const activeCollectionItemId = useViewStore((state2) => state2.activeCollectionItemId);
  const enableVenueSubTree = useViewStore((state2) => state2.enableVenueSubTree);
  const assets = useAssetStore((state2) => state2.assets);
  const state = useSiteStore((state2) => ({
    countries: state2.countries,
    venues: state2.venues,
    regions: state2.regions,
    markets: state2.markets,
    clusters: state2.clusters,
    zones: state2.zones,
    buildings: state2.buildings,
    levels: state2.levels
  }));
  const subRootId = enableVenueSubTree ? activeVenueId : null;
  const {
    mcrTypesMeta,
    subTypesMeta: meta2,
    mcrParentKeys
  } = useMCRTypesMeta(subRootId);
  const setActiveFormControl = useViewStore((state2) => state2.setActiveFormControl);
  const activeFormControl = useViewStore((state2) => state2.activeFormControl);
  const invisibleObjectIds = useViewStore((state2) => state2.invisibleObjectIds);
  const onNodeAction = React__default.useCallback((event) => {
    const {
      action,
      node
    } = event || {};
    if (!(node == null ? void 0 : node.key) || node.key === "add-new")
      return;
    onAction(node.key, node.category, action);
  }, [onAction]);
  const onNameInputChange = React__default.useCallback((value) => {
    setActiveFormControl(activeType, value || "");
  }, [activeType, setActiveFormControl]);
  const apIcon = React__default.useMemo(() => {
    var _a3;
    return (_a3 = mcrTypesMeta.find((item) => item.objectType === "accessPoint")) == null ? void 0 : _a3.icon;
  }, [mcrTypesMeta]);
  const handleEyeClick = React__default.useCallback((clonedNode) => {
    onNodeAction({
      action: "show-or-hide",
      node: clonedNode
    });
  }, [onNodeAction]);
  const assignTitle = React__default.useCallback((item, parentId, icon, node, style2) => {
    if (activeId === item.id && enableEditNode) {
      return /* @__PURE__ */ jsx(TreeNameInput, { isCountry: activeType === "country", isChild: !!parentId, value: (activeFormControl == null ? void 0 : activeFormControl[activeType]) || item.name, defaultValue: item.name, icon, onChange: onNameInputChange, style: style2 });
    }
    const clonedNode = {
      ...node || {},
      active: activeId === (node == null ? void 0 : node.key) && item.type !== "asset"
    };
    let extra = null;
    const actions = [...ACTIONS];
    if (node.type === "asset" && node.displayMode) {
      extra = /* @__PURE__ */ jsx(DisplayTag, { displayMode: item.displayMode });
    } else if (node.category === "level" && parentId === activeCollectionItemId || activeCollectionItemId === item.id) {
      actions.unshift({
        label: "Show/Hide",
        key: "show-or-hide"
      });
      const isHidden2 = invisibleObjectIds.includes(node == null ? void 0 : node.key);
      const Icon2 = isHidden2 ? EyeInvisibleOutlined : EyeOutlined;
      extra = /* @__PURE__ */ jsx(Icon2, { onClick: () => {
        handleEyeClick(clonedNode);
      } });
    }
    return /* @__PURE__ */ jsx(TreeNodeItem, { node: clonedNode, onClick: onSelect, onAction: onNodeAction, icon, style: style2, actions, extra });
  }, [activeId, enableEditNode, activeCollectionItemId, onSelect, onNodeAction, activeType, activeFormControl, onNameInputChange, invisibleObjectIds, handleEyeClick]);
  const prepareAP = React__default.useCallback((node) => {
    const {
      type,
      features,
      id: parentId
    } = node;
    if (!["zone", ...SiteStoreHelper.ACCESS_POINT_PARENTS].includes(type) || !(features == null ? void 0 : features.length)) {
      return [];
    }
    if (type === "venue" && !enableVenueSubTree)
      return [];
    let zoneFill = "";
    const apNodes = [];
    features.forEach((feature2) => {
      var _a3, _b3, _c2, _d2;
      if (type === "zone" && ((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.category) === "footprint") {
        zoneFill = (_b3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _b3.fill;
      }
      if (((_c2 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _c2.category) !== "accessPoint")
        return;
      const apNode = {
        label: feature2.name,
        key: feature2.id,
        type: "feature",
        icon: null,
        category: "accessPoint"
      };
      apNode.title = assignTitle({
        id: feature2.id,
        name: ((_d2 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _d2.name) || (feature2 == null ? void 0 : feature2.name)
      }, parentId, apIcon, apNode, zoneFill ? {
        borderLeft: `1px solid ${zoneFill}`
      } : {});
      apNodes.push(apNode);
    });
    return apNodes;
  }, [enableVenueSubTree, assignTitle, apIcon]);
  const prepareLevelSubList = React__default.useCallback((node) => {
    const {
      type,
      id
    } = node;
    if (type !== "level")
      return [];
    const levelsAssets = assets == null ? void 0 : assets.filter((asset) => asset.parentType === "level" && asset.parentId === id);
    if (levelsAssets == null ? void 0 : levelsAssets.length) {
      return levelsAssets.map((asset) => {
        const extension = getFileType(asset == null ? void 0 : asset.sourceFile);
        let name2 = asset.name ?? "Floor Plan";
        if (extension) {
          name2 = `${name2}.${extension}`;
        }
        const levelNode = {
          label: name2,
          key: asset.id,
          type: "asset",
          icon: null,
          category: asset.type,
          displayMode: asset.displayMode
        };
        levelNode.title = assignTitle(asset, id, /* @__PURE__ */ jsx(FileImageOutlined, {}), levelNode);
        return levelNode;
      });
    }
    return [];
  }, [assets, assignTitle]);
  return React__default.useMemo(() => {
    var _a3;
    const flatData = [];
    const treeData = [];
    const expandKeys = [];
    meta2.forEach(({
      collectionName,
      icon
    }) => {
      var _a4;
      (_a4 = state == null ? void 0 : state[collectionName]) == null ? void 0 : _a4.forEach((item) => {
        var _a5, _b3, _c2;
        if (item.type === "zone") {
          const isInVenue = !!item.venueId || !!item.buildingId || !!item.levelId;
          if (enableVenueSubTree && !isInVenue)
            return;
          if (!enableVenueSubTree && isInVenue)
            return;
        }
        if (enableVenueSubTree && item.type === "venue") {
          treeData.push(...prepareAP(item));
          return;
        }
        const itemKeys = Object.keys(item);
        const parentKey = mcrParentKeys.find((key) => itemKeys.includes(key)) || "parentId";
        const parentId = item[parentKey];
        const node = {
          label: item.name,
          key: item.id,
          children: [...prepareAP(item), ...prepareLevelSubList(item)],
          type: "category",
          icon: null,
          category: item.type,
          zoneColor: item.type === "zone" ? (_c2 = (_b3 = (_a5 = item == null ? void 0 : item.features) == null ? void 0 : _a5[0]) == null ? void 0 : _b3.properties) == null ? void 0 : _c2.fill : ""
        };
        node.title = assignTitle(item, parentId, icon, node);
        let parentArray = null;
        if (parentKey && parentId) {
          const parentNode = flatData.find((aNode) => aNode.key === parentId);
          parentArray = parentNode == null ? void 0 : parentNode.children;
        }
        if (!parentArray) {
          if (!subRootId) {
            parentArray = treeData;
          } else if (["buildings", "zones", "accessPoints"].includes(collectionName) && subRootId === item.venueId) {
            parentArray = treeData;
          }
        }
        if (parentArray) {
          parentArray.push(node);
          flatData.push(node);
          expandKeys.push(node.key);
        }
      });
    });
    if (enableCreateNode) {
      const activeNode = activeId ? flatData == null ? void 0 : flatData.find((aNode) => aNode.key === activeId) : null;
      const icon = (_a3 = meta2.find((item) => item.objectType === activeType)) == null ? void 0 : _a3.icon;
      if (activeNode) {
        activeNode.children.push({
          title: /* @__PURE__ */ jsx(TreeNameInput, { isCountry: activeType === "country", isChild: true, icon, value: activeFormControl == null ? void 0 : activeFormControl[activeType], onChange: onNameInputChange, style: (activeNode == null ? void 0 : activeNode.zoneColor) ? {
            borderLeft: `1px solid ${activeNode == null ? void 0 : activeNode.zoneColor}`
          } : {} }),
          key: "add-new",
          icon: null,
          type: "add-new"
        });
        const hierarchy = findHierarchy(treeData, activeNode.key);
        hierarchy == null ? void 0 : hierarchy.forEach((i2) => {
          if (i2)
            expandKeys.push(i2);
        });
      } else {
        treeData.push({
          title: /* @__PURE__ */ jsx(TreeNameInput, { isCountry: activeType === "country", isChild: false, icon, value: activeFormControl == null ? void 0 : activeFormControl[activeType], onChange: onNameInputChange }),
          key: "add-new",
          icon: null,
          type: "add-new"
        });
      }
    }
    return {
      treeData,
      expandKeys
    };
  }, [meta2, enableCreateNode, state, enableVenueSubTree, mcrParentKeys, prepareAP, prepareLevelSubList, assignTitle, subRootId, activeId, activeType, activeFormControl, onNameInputChange]);
}
const mcrTreeView = "";
const {
  useToken: useToken$3
} = theme$2;
function McrTreeView(props) {
  const {
    onSelect: onSelectIn,
    onCheck,
    height,
    id: activeId,
    enableCreateNode,
    activeType,
    onAction,
    enableEditNode
  } = props;
  const [expandedKeys, setExpandedKeys] = React__default.useState([]);
  const [autoExpandParent, setAutoExpandParent] = React__default.useState(true);
  const {
    token
  } = useToken$3();
  const selectedKeys = React__default.useMemo(() => {
    if (activeId)
      return [activeId];
    return [];
  }, [activeId]);
  const onSelect = React__default.useCallback((event) => {
    const {
      node,
      byVenueEdit
    } = event || {};
    if (!(node == null ? void 0 : node.key) || node.key === "add-new" || node.type === "asset")
      return;
    const selectedKey = node.key;
    const alreadySelected = selectedKeys.find((i2) => i2 === selectedKey);
    onSelectIn({
      deselect: alreadySelected && !byVenueEdit,
      // select or deselect
      selectedId: selectedKey,
      type: node.type,
      category: node.category,
      byVenueEdit
    });
  }, [onSelectIn, selectedKeys]);
  const {
    treeData: data2,
    expandKeys: expandedKeysIn
  } = useMcrTree({
    showIcons: true,
    activeType,
    enableCreateNode,
    activeId,
    onSelect,
    onAction,
    enableEditNode
  });
  const onExpand = React__default.useCallback((newExpandedKeys) => {
    setExpandedKeys(newExpandedKeys);
    setAutoExpandParent(false);
  }, []);
  React__default.useLayoutEffect(() => {
    if (enableCreateNode) {
      setAutoExpandParent(true);
    }
  }, [enableCreateNode]);
  const expandedKeysFinal = React__default.useMemo(() => {
    if (enableCreateNode || autoExpandParent)
      return expandedKeysIn || [];
    return expandedKeys || [];
  }, [autoExpandParent, enableCreateNode, expandedKeys, expandedKeysIn]);
  if (!data2 || data2.length === 0)
    return null;
  return /* @__PURE__ */ jsx(ConfigProvider, { theme: {
    components: {
      Tree: {
        /* here is your component tokens */
        nodeSelectedBg: token.colorFillSecondary
      }
    }
  }, children: /* @__PURE__ */ jsx(Tree, { defaultExpandAll: true, autoExpandParent, expandedKeys: expandedKeysFinal, onExpand, selectable: true, onCheck, treeData: data2, showIcon: true, height, switcherIcon: /* @__PURE__ */ jsx(CaretDownFilled, { style: {
    fontSize: "11px"
  } }), selectedKeys, style: {
    width: "100%"
  } }) });
}
McrTreeView.propTypes = {
  onSelect: propTypesExports$1.func,
  onAction: propTypesExports$1.func,
  onCheck: propTypesExports$1.func,
  height: propTypesExports$1.number,
  id: propTypesExports$1.string,
  enableCreateNode: propTypesExports$1.bool,
  enableEditNode: propTypesExports$1.bool,
  activeType: propTypesExports$1.string
};
McrTreeView.defaultProps = {
  onSelect: () => {
  },
  onAction: () => {
  },
  onCheck: () => {
  },
  height: 700,
  id: "",
  enableCreateNode: false,
  enableEditNode: false,
  activeType: null
};
const {
  useToken: useToken$2
} = theme$2;
function Notice(props) {
  const {
    content,
    enableClose,
    onClose
  } = props;
  const {
    token
  } = useToken$2();
  const [hide, setHide] = React__default.useState(false);
  const onClick2 = React__default.useCallback(() => {
    setHide(true);
    onClose();
  }, [onClose]);
  if (hide)
    return null;
  return /* @__PURE__ */ jsxs(Row, { style: {
    backgroundColor: token.colorBgBase,
    height: "76px",
    padding: "8px 10px",
    margin: "0px -10px",
    borderTop: `1px solid ${token.colorBorderSecondary}`,
    borderBottom: `1px solid ${token.colorBorderSecondary}`
  }, align: "top", justify: "center", children: [
    content,
    enableClose && /* @__PURE__ */ jsx(Row, { style: {
      flex: 1,
      padding: "5px"
    }, justify: "center", onClick: onClick2, children: /* @__PURE__ */ jsx(CloseOutlined, { style: {
      color: token.colorText
    } }) })
  ] });
}
Notice.propTypes = {
  content: propTypesExports$1.node,
  enableClose: propTypesExports$1.bool,
  onClose: propTypesExports$1.func
};
Notice.defaultProps = {
  content: null,
  enableClose: true,
  onClose: () => {
  }
};
const ABSOLUTE_BUTTON_STYLE = {
  bottom: 0,
  position: "absolute",
  width: "324px"
};
function ContextPane(props) {
  const {
    setHeader
  } = props;
  const setActiveObject = useViewStore((state) => state.setActiveObject);
  const activeCountryId = useViewStore((state) => state.activeCountryId);
  const setActiveCountryId = useViewStore((state) => state.setActiveCountryId);
  const activeRegionId = useViewStore((state) => state.activeRegionId);
  const setActiveRegionId = useViewStore((state) => state.setActiveRegionId);
  const activeClusterId = useViewStore((state) => state.activeClusterId);
  const setActiveClusterId = useViewStore((state) => state.setActiveClusterId);
  const activeMarketId = useViewStore((state) => state.activeMarketId);
  const setActiveMarketId = useViewStore((state) => state.setActiveMarketId);
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const setActiveVenueId = useViewStore((state) => state.setActiveVenueId);
  const activeBuildingId = useViewStore((state) => state.activeBuildingId);
  const setActiveBuildingId = useViewStore((state) => state.setActiveBuildingId);
  const activeLevelId = useViewStore((state) => state.activeLevelId);
  const activeLayerId = useViewStore((state) => state.activeLayerId);
  const setActiveLevelId = useViewStore((state) => state.setActiveLevelId);
  const activeZoneId = useViewStore((state) => state.activeZoneId);
  const setActiveZoneId = useViewStore((state) => state.setActiveZoneId);
  const activeApFeatureId = useViewStore((state) => state.activeApFeatureId);
  const setActiveApFeatureId = useViewStore((state) => state.setActiveApFeatureId);
  const setActiveFeatureId = useViewStore((state) => state.setActiveFeatureId);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const setActiveLayerId = useViewStore((state) => state.setActiveLayerId);
  const getObjectDetail = useSiteStore((state) => state.getObjectDetail);
  const venues = useSiteStore((state) => state.venues);
  const setEnableVenueSubTree = useViewStore((state) => state.setEnableVenueSubTree);
  const enableVenueSubTree = useViewStore((state) => state.enableVenueSubTree);
  const invisibleObjectIds = useViewStore((state) => state.invisibleObjectIds);
  const updateObjectVisibility = useViewStore((state) => state.updateObjectVisibility);
  const updateCategoryVisibility = useViewStore((state) => state.updateCategoryVisibility);
  const buildings = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.buildings) == null ? void 0 : _a3.filter((building) => building.venueId === activeVenueId);
  });
  const levels = useSiteStore((state) => {
    var _a3;
    return (_a3 = state.levels) == null ? void 0 : _a3.filter((level) => level.buildingId === activeBuildingId).sort((l1, l2) => {
      if (l1.levelNumber === l2.levelNumber)
        return 0;
      if (typeof l1.levelNumber !== "number")
        return -1;
      if (typeof l1.levelNumber !== "number")
        return 1;
      return l2.levelNumber - l1.levelNumber;
    });
  });
  const removeFromCollection = useSiteStore((state) => state.removeFromCollection);
  const {
    hasHierarchy
  } = useSiteObjectStatistics();
  const [mcrTreeActiveObject, setMcrTreeActiveObject] = React__default.useState(null);
  const indentation = React__default.useCallback((indentLevel) => `${15 * indentLevel}%`, []);
  const activeButton = React__default.useMemo(() => {
    if (["createAccessPoint", "createZone", "createLayer", "createLevel", "createBuilding", "createVenue", "createCountry", "createRegion", "createMarket", "createCluster"].includes(activeSubTool))
      return activeSubTool;
    if (activeSubTool === "createUpload") {
      return "createRegion";
    }
    const isEdit = activeSubTool == null ? void 0 : activeSubTool.includes("edit");
    if (activeApFeatureId)
      return isEdit ? "editAccessPoint" : "activeAccessPoint";
    if (activeZoneId)
      return isEdit ? "editZone" : "activeZone";
    if (activeLayerId)
      return isEdit ? "editLayer" : "activeLayer";
    if (activeLevelId)
      return isEdit ? "editLevel" : "activeLevel";
    if (activeBuildingId)
      return isEdit ? "editBuilding" : "activeBuilding";
    if (activeVenueId)
      return isEdit ? "editVenue" : "activeVenue";
    if (activeClusterId)
      return isEdit ? "editCluster" : "activeCluster";
    if (activeMarketId)
      return isEdit ? "editMarket" : "activeMarket";
    if (activeRegionId)
      return isEdit ? "editRegion" : "activeRegion";
    if (activeCountryId)
      return isEdit ? "editCountry" : "activeCountry";
    return "";
  }, [activeBuildingId, activeClusterId, activeLayerId, activeLevelId, activeZoneId, activeApFeatureId, activeMarketId, activeRegionId, activeSubTool, activeVenueId, activeCountryId]);
  const isCreateActive = activeButton == null ? void 0 : activeButton.includes("create");
  const isEditActive = activeButton == null ? void 0 : activeButton.includes("edit");
  const onTreeSelect = React__default.useCallback((feature2) => {
    if ((feature2 == null ? void 0 : feature2.type) === "category" || (feature2 == null ? void 0 : feature2.category) === "accessPoint") {
      setActiveSubTool(null);
      const selected = getObjectDetail(feature2.selectedId);
      const {
        countryId,
        regionId,
        marketId,
        clusterId,
        venueId,
        buildingId,
        levelId,
        layerId,
        zoneId,
        accessPointId
      } = selected || {};
      if (feature2.deselect) {
        if (useViewStore.getState().enableVenueSubTree) {
          setActiveObject({
            countryId,
            regionId,
            marketId,
            clusterId,
            venueId
          });
        } else {
          setActiveObject({});
        }
      } else {
        setActiveObject({
          countryId,
          regionId,
          marketId,
          clusterId,
          venueId,
          buildingId,
          levelId,
          layerId,
          zoneId,
          accessPointId
        });
      }
      if (feature2 == null ? void 0 : feature2.byVenueEdit) {
        setEnableVenueSubTree(true);
      }
    }
    const isFeature2 = (feature2 == null ? void 0 : feature2.type) === "feature" || (feature2 == null ? void 0 : feature2.type) === "asset";
    const isApFeature = isFeature2 && (feature2 == null ? void 0 : feature2.category) === "accessPoint";
    setActiveFeatureId(isFeature2 && !(feature2 == null ? void 0 : feature2.deselect) ? feature2 == null ? void 0 : feature2.selectedId : null);
    setActiveApFeatureId(isApFeature && !(feature2 == null ? void 0 : feature2.deselect) ? feature2 == null ? void 0 : feature2.selectedId : null);
    setActiveLayerId((feature2 == null ? void 0 : feature2.type) === "layer" ? feature2 == null ? void 0 : feature2.layerName : null);
  }, [getObjectDetail, setActiveFeatureId, setActiveApFeatureId, setActiveLayerId, setActiveObject, setEnableVenueSubTree, setActiveSubTool]);
  const activeVenue = React__default.useMemo(() => {
    if (!activeVenueId || !(venues == null ? void 0 : venues.length))
      return null;
    return venues.find((v5) => v5.id === activeVenueId);
  }, [activeVenueId, venues]);
  const activeBuilding = React__default.useMemo(() => {
    if (!activeBuildingId || !(buildings == null ? void 0 : buildings.length))
      return null;
    return buildings.find((v5) => v5.id === activeBuildingId);
  }, [activeBuildingId, buildings]);
  const activeLevel = React__default.useMemo(() => {
    if (!activeLevelId || !(levels == null ? void 0 : levels.length))
      return null;
    return levels.find((v5) => v5.id === activeLevelId);
  }, [activeLevelId, levels]);
  const {
    activeId,
    activeType
  } = React__default.useMemo(() => {
    if (activeButton == null ? void 0 : activeButton.endsWith("AccessPoint")) {
      return {
        activeType: "accessPoint",
        activeId: activeApFeatureId
      };
    }
    if (activeButton == null ? void 0 : activeButton.endsWith("Zone")) {
      return {
        activeType: "zone",
        activeId: activeZoneId
      };
    }
    if ((activeButton == null ? void 0 : activeButton.endsWith("Level")) || (activeButton == null ? void 0 : activeButton.endsWith("Layer"))) {
      return {
        activeType: "level",
        activeId: activeLevelId
      };
    }
    if (activeButton == null ? void 0 : activeButton.endsWith("Building")) {
      return {
        activeType: "building",
        activeId: activeBuildingId
      };
    }
    if (activeButton == null ? void 0 : activeButton.endsWith("Venue")) {
      return {
        activeType: "venue",
        activeId: activeVenueId
      };
    }
    if (activeButton == null ? void 0 : activeButton.endsWith("Cluster")) {
      return {
        activeType: "cluster",
        activeId: activeClusterId
      };
    }
    if (activeButton == null ? void 0 : activeButton.endsWith("Market")) {
      return {
        activeType: "market",
        activeId: activeMarketId
      };
    }
    if (activeButton == null ? void 0 : activeButton.endsWith("Region")) {
      return {
        activeType: "region",
        activeId: activeRegionId
      };
    }
    if (activeButton == null ? void 0 : activeButton.endsWith("Country")) {
      return {
        activeType: "country",
        activeId: activeCountryId
      };
    }
    return {};
  }, [activeBuildingId, activeButton, activeClusterId, activeLevelId, activeZoneId, activeApFeatureId, activeMarketId, activeRegionId, activeVenueId, activeCountryId]);
  React__default.useEffect(() => {
    if (activeId) {
      setMcrTreeActiveObject(activeId);
    }
    if (!activeId && !activeSubTool) {
      setMcrTreeActiveObject(null);
    }
  }, [activeId, activeSubTool]);
  const onAction = React__default.useCallback((type, id, action) => {
    const selection = action === "select" ? getObjectDetail(id) : null;
    switch (type) {
      case "country":
        if (action === "view") {
          setActiveSubTool("viewCountry");
          setActiveCountryId(id);
          setActiveRegionId(null);
          setActiveMarketId(null);
          setActiveClusterId(null);
          setActiveVenueId(null);
        } else if (action === "edit") {
          setActiveSubTool("editCountry");
          setActiveCountryId(id);
          setActiveRegionId(null);
          setActiveMarketId(null);
          setActiveClusterId(null);
          setActiveVenueId(null);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveCountryId(id);
          setActiveRegionId(null);
          setActiveMarketId(null);
          setActiveClusterId(null);
          setActiveVenueId(null);
          setActiveBuildingId(null);
          setActiveLevelId(null);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection(type, {
            id
          });
          if (activeCountryId === id) {
            setActiveCountryId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportMcr");
          setActiveCountryId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      case "region":
        if (action === "view") {
          setActiveSubTool("viewRegion");
          setActiveRegionId(id);
          setActiveMarketId(null);
          setActiveClusterId(null);
          setActiveVenueId(null);
        } else if (action === "edit") {
          setActiveSubTool("editRegion");
          setActiveRegionId(id);
          setActiveMarketId(null);
          setActiveClusterId(null);
          setActiveVenueId(null);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveRegionId(id);
          setActiveMarketId(null);
          setActiveClusterId(null);
          setActiveVenueId(null);
          setActiveBuildingId(null);
          setActiveLevelId(null);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection(type, {
            id
          });
          if (activeRegionId === id) {
            setActiveRegionId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportMcr");
          setActiveRegionId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      case "market":
        if (action === "view") {
          setActiveSubTool("viewMarket");
          setActiveMarketId(id);
          setActiveClusterId(null);
          setActiveVenueId(null);
        } else if (action === "edit") {
          setActiveSubTool("editMarket");
          setActiveMarketId(id);
          setActiveClusterId(null);
          setActiveVenueId(null);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveMarketId(id);
          setActiveClusterId(null);
          setActiveVenueId(null);
          setActiveBuildingId(null);
          setActiveLevelId(null);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection(type, {
            id
          });
          if (activeMarketId === id) {
            setActiveMarketId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportMcr");
          setActiveMarketId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      case "cluster":
        if (action === "view") {
          setActiveSubTool("viewCluster");
          setActiveClusterId(id);
          setActiveVenueId(null);
        } else if (action === "edit") {
          setActiveSubTool("editCluster");
          setActiveClusterId(id);
          setActiveVenueId(null);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveClusterId(id);
          setActiveVenueId(null);
          setActiveBuildingId(null);
          setActiveLevelId(null);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection(type, {
            id
          });
          if (activeClusterId === id) {
            setActiveClusterId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportMcr");
          setActiveClusterId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      case "venue":
        if (action === "view") {
          setActiveSubTool("viewVenue");
          setActiveVenueId(id);
        } else if (action === "edit") {
          setActiveSubTool("editVenue");
          setActiveVenueId(id);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveVenueId(id);
          setActiveBuildingId(null);
          setActiveLevelId(null);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection("venue", {
            id
          });
          if (activeVenueId === id) {
            setActiveVenueId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportVenue");
          setActiveVenueId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      case "building":
        if (action === "view") {
          setActiveSubTool("viewBuilding");
          setActiveBuildingId(id);
        } else if (action === "edit") {
          setActiveSubTool("editBuilding");
          setActiveBuildingId(id);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveVenueId(selection == null ? void 0 : selection.venueId);
          setActiveBuildingId(id);
          setActiveLevelId(null);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection("building", {
            id
          });
          if (activeBuildingId === id) {
            setActiveBuildingId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportBuilding");
          setActiveBuildingId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      case "level": {
        if (action === "view") {
          setActiveSubTool("viewLevel");
          setActiveLevelId(id);
        } else if (action === "edit") {
          setActiveSubTool("editLevel");
          setActiveLevelId(id);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveVenueId(selection == null ? void 0 : selection.venueId);
          setActiveBuildingId(selection == null ? void 0 : selection.buildingId);
          setActiveLevelId(id);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection("level", {
            id
          });
          if (activeLevelId === id) {
            setActiveLevelId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportLevel");
          setActiveLevelId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      }
      case "zone":
        if (action === "view") {
          setActiveSubTool("viewZone");
          setActiveZoneId(id);
        } else if (action === "edit") {
          setActiveSubTool("editZone");
          setActiveZoneId(id);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveZoneId(id);
          setActiveVenueId(selection == null ? void 0 : selection.venueId);
          setActiveBuildingId(selection == null ? void 0 : selection.buildingId);
          setActiveLevelId(selection == null ? void 0 : selection.levelId);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection(type, {
            id
          });
          if (activeZoneId === id) {
            setActiveZoneId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportMcr");
          setActiveZoneId(id);
        } else if (action === "show-or-hide") {
          updateObjectVisibility(id, invisibleObjectIds == null ? void 0 : invisibleObjectIds.includes(id));
        }
        break;
      case "accessPoint":
        if (action === "view") {
          setActiveSubTool("viewAccessPoint");
          setActiveApFeatureId(id);
        } else if (action === "edit") {
          setActiveSubTool("editAccessPoint");
          setActiveApFeatureId(id);
        } else if (action === "select") {
          setActiveSubTool(null);
          setActiveApFeatureId(id);
          setActiveZoneId(selection == null ? void 0 : selection.zoneId);
          setActiveVenueId(selection == null ? void 0 : selection.venueId);
          setActiveBuildingId(selection == null ? void 0 : selection.buildingId);
          setActiveLevelId(selection == null ? void 0 : selection.levelId);
          setActiveLayerId(null);
        } else if (action === "delete") {
          removeFromCollection(type, {
            id
          });
          if (activeZoneId === id) {
            setActiveApFeatureId(null);
          }
        } else if (action === "export") {
          setActiveSubTool("exportAccessPoint");
          setActiveApFeatureId(id);
        }
        break;
    }
  }, [getObjectDetail, setActiveSubTool, setActiveCountryId, setActiveRegionId, setActiveMarketId, setActiveClusterId, setActiveVenueId, setActiveBuildingId, setActiveLevelId, setActiveLayerId, removeFromCollection, activeCountryId, activeRegionId, activeMarketId, activeClusterId, activeVenueId, activeBuildingId, invisibleObjectIds, activeLevelId, updateObjectVisibility, setActiveZoneId, activeZoneId, setActiveApFeatureId]);
  const MAX_CONTAINER_HEIGHT = React__default.useMemo(() => window.innerHeight - 234, []);
  const venueButton = React__default.useMemo(() => {
    return null;
  }, [MAX_CONTAINER_HEIGHT, activeButton, activeSubTool, activeVenue, onAction, setActiveSubTool, venues]);
  const buildingButton = React__default.useMemo(() => {
    return null;
  }, [MAX_CONTAINER_HEIGHT, activeBuildingId, activeButton, activeSubTool, activeVenue, buildings, indentation, onAction, setActiveSubTool]);
  const levelButton = React__default.useMemo(() => {
    return null;
  }, [MAX_CONTAINER_HEIGHT, activeBuilding, activeButton, activeLevelId, activeSubTool, buildings == null ? void 0 : buildings.length, indentation, levels, onAction, setActiveSubTool]);
  const layerButton = React__default.useMemo(() => {
    return null;
  }, [activeButton, activeLayerId, activeLevel, activeSubTool, indentation, setActiveSubTool]);
  const showFeatureTree = enableVenueSubTree && (activeButton === "activeLayer" || activeButton === "activeLevel" || activeButton === "activeBuilding" || activeButton === "activeVenue" || activeButton === "activeAccessPoint");
  const showMcrTree = hasHierarchy || activeSubTool;
  const notice = React__default.useMemo(() => {
    if (activeSubTool)
      return null;
    if (!hasHierarchy) {
      return /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: "Start a new project by importing geospatial data to analyze and optimize your network infrastructure or add layers manually" }) });
    }
    if (activeVenue && enableVenueSubTree && !(buildings == null ? void 0 : buildings.length)) {
      return /* @__PURE__ */ jsx(Notice, { content: /* @__PURE__ */ jsx(Typography.Text, { style: {
        flex: 16,
        fontSize: "12px",
        paddingRight: "10px"
      }, children: "Add “Buildings” to the venue. Each building can have multiple floors with unique characteristics. You can divide these floors into different zones." }) });
    }
    return null;
  }, [activeSubTool, activeVenue, buildings == null ? void 0 : buildings.length, enableVenueSubTree, hasHierarchy]);
  React__default.useEffect(() => {
    if (!activeVenue || !enableVenueSubTree) {
      setHeader({
        title: "Layers",
        notice
      });
    } else {
      const items = [{
        key: "back",
        label: "Venue",
        enableClick: true,
        enableBack: true
      }, {
        key: "venue",
        label: activeVenue.name,
        enableClick: true
      }];
      if (activeBuilding) {
        items.push({
          key: "building",
          label: activeBuilding.name,
          enableClick: true
        });
      }
      if (activeLevel) {
        items.push({
          key: "level",
          label: activeLevel.name,
          enableClick: true
        });
      }
      items[items.length - 1].enableClick = false;
      const onClick2 = (key) => {
        switch (key) {
          case "building":
            setActiveLevelId(null);
            break;
          case "venue":
            setActiveBuildingId(null);
            setActiveLevelId(null);
            break;
          case "back":
            setEnableVenueSubTree(false);
            setActiveObject({});
            break;
        }
      };
      setHeader({
        title: activeVenue.name,
        breadcrumbsProps: {
          items,
          onClick: onClick2
        },
        notice
      });
    }
  }, [notice, activeBuilding, activeLevel, activeVenue, hasHierarchy, setActiveBuildingId, setActiveLevelId, setActiveVenueId, setHeader, showMcrTree, setEnableVenueSubTree, enableVenueSubTree, setActiveObject]);
  React__default.useEffect(() => {
    if (!activeVenueId) {
      setEnableVenueSubTree(false);
    }
  }, [activeVenueId, setEnableVenueSubTree]);
  React__default.useEffect(() => {
    const categories2 = ["country", "region", "market", "cluster"];
    categories2.forEach((category) => {
      updateCategoryVisibility(category, !enableVenueSubTree);
    });
  }, [enableVenueSubTree, updateCategoryVisibility]);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsxs("div", { style: {
      maxHeight: `${MAX_CONTAINER_HEIGHT}px`,
      overflowY: "auto"
    }, children: [
      showMcrTree && /* @__PURE__ */ jsx("div", { style: {
        marginTop: "16px"
      }, children: /* @__PURE__ */ jsx(McrTreeView, { onSelect: onTreeSelect, id: activeId || mcrTreeActiveObject, activeType, enableCreateNode: isCreateActive, enableEditNode: isEditActive, onAction: (id, type, action) => onAction(type, id, action) }) }),
      showFeatureTree && /* @__PURE__ */ jsxs(Fragment, { children: [
        venueButton,
        buildingButton,
        levelButton,
        /* @__PURE__ */ jsx("div", { style: {
          marginTop: "16px"
        }, children: /* @__PURE__ */ jsx(FeatureTreeView, { id: activeId, onSelect: onTreeSelect, showLayers: !!activeLevel, showFeatures: !activeLevel, showAssets: !!activeLevel }, activeId) })
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { style: ABSOLUTE_BUTTON_STYLE, children: layerButton }),
    !hasHierarchy && !activeButton && /* @__PURE__ */ jsxs(Row, { style: {
      marginTop: "10px"
    }, justify: "space-between", children: [
      /* @__PURE__ */ jsx(Button, { type: "default", style: {
        width: "48%"
      }, icon: /* @__PURE__ */ jsx(PlusOutlined, { style: {
        fontSize: "16px",
        marginRight: "5px"
      } }), onClick: () => setActiveSubTool("createCountry"), children: "Add New Layer" }),
      /* @__PURE__ */ jsx(Button, { type: "primary", ghost: true, style: {
        width: "48%"
      }, icon: /* @__PURE__ */ jsx(DownloadOutlined, { style: {
        fontSize: "16px",
        marginRight: "5px"
      } }), onClick: () => setActiveSubTool("createUpload"), children: "Import Data" })
    ] })
  ] });
}
ContextPane.propTypes = {
  setHeader: propTypesExports$1.func
};
ContextPane.defaultProps = {
  setHeader: () => {
  }
};
const styles$4 = {
  "custom-tab": "_custom-tab_1okcz_1",
  "ant-tabs": "_ant-tabs_1okcz_1",
  "ant-tabs-top": "_ant-tabs-top_1okcz_13",
  "ant-tabs-nav": "_ant-tabs-nav_1okcz_13",
  "ant-tabs-bottom": "_ant-tabs-bottom_1okcz_14",
  "project-search-icon-button": "_project-search-icon-button_1okcz_36"
};
const {
  useToken: useToken$1
} = theme$2;
function LayerMenu(props) {
  const {
    actions,
    onAction,
    showAll,
    onClose,
    hide,
    fullWidth
  } = props;
  const {
    token
  } = useToken$1();
  return /* @__PURE__ */ jsx(Col, { style: {
    background: token.colorBgElevated,
    width: fullWidth ? "100%" : "316px",
    borderRadius: token.borderRadiusLG,
    padding: token.paddingXXS,
    marginBottom: "4px",
    marginTop: "4px"
  }, children: actions.filter((s2) => showAll ? true : s2.description).filter((s2) => !hide.includes(s2.key)).map((action) => /* @__PURE__ */ jsxs(Row, { style: {
    background: token.colorBgElevated,
    height: "52px",
    padding: "5px 12px 5px 12px"
  }, onClick: () => {
    if (action.disabled)
      return;
    onClose();
    onAction(action.key);
  }, justify: "space-between", children: [
    /* @__PURE__ */ jsx(Col, { style: {
      paddingRight: "8px"
    }, children: action.icon }),
    /* @__PURE__ */ jsxs(Col, { style: {
      width: "260px"
    }, children: [
      /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Typography.Text, { disabled: action.disabled, children: action.label }) }),
      /* @__PURE__ */ jsx(Row, { children: /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: token.fontSizeSM,
        fontColor: token.colorTextTertiary
      }, disabled: action.disabled, type: "secondary", children: action.description }) })
    ] })
  ] }, action.key)) });
}
LayerMenu.propTypes = {
  actions: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    label: propTypesExports$1.string.isRequired,
    key: propTypesExports$1.string.isRequired,
    description: propTypesExports$1.string,
    icon: propTypesExports$1.node,
    disabled: propTypesExports$1.bool
  })),
  onAction: propTypesExports$1.func,
  showAll: propTypesExports$1.bool,
  onClose: propTypesExports$1.func,
  hide: propTypesExports$1.array,
  fullWidth: propTypesExports$1.bool
};
LayerMenu.defaultProps = {
  actions: [],
  onAction: () => {
  },
  showAll: false,
  onClose: () => {
  },
  hide: [],
  fullWidth: false
};
function LayerMenuPopup(props) {
  const {
    actions,
    icon,
    onAction,
    disabled,
    ...restProps
  } = props;
  const [visible, setVisible] = React__default.useState(false);
  const token = useToken$1();
  if (!(actions == null ? void 0 : actions.length))
    return null;
  return /* @__PURE__ */ jsx(Popover, { content: /* @__PURE__ */ jsx(LayerMenu, { ...props, onClose: () => setVisible(false) }), placement: "bottomRight", color: "transparent", arrow: false, trigger: "click", zIndex: 100, open: visible, onOpenChange: (v5) => setVisible(v5), style: {
    borderRadius: token.borderRadiusLG,
    padding: token.paddingXXS
  }, ...restProps, children: /* @__PURE__ */ jsx(Flex, { align: "center", children: /* @__PURE__ */ jsx(
    Button,
    {
      type: "primary",
      ghost: true,
      icon,
      disabled
    }
  ) }) });
}
LayerMenuPopup.propTypes = {
  actions: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    label: propTypesExports$1.string.isRequired,
    key: propTypesExports$1.string.isRequired,
    description: propTypesExports$1.string,
    icon: propTypesExports$1.node,
    disabled: propTypesExports$1.bool
  })),
  onAction: propTypesExports$1.func,
  icon: propTypesExports$1.node,
  disabled: propTypesExports$1.bool
};
LayerMenuPopup.defaultProps = {
  actions: [],
  onAction: () => {
  },
  icon: /* @__PURE__ */ jsx(HiOutlineDotsVertical, {}),
  disabled: false
};
function Breadcrumbs(props) {
  const {
    onClick: onClickIn,
    items
  } = props;
  return /* @__PURE__ */ jsx(Breadcrumb, { children: items.map(({
    key,
    label,
    enableClick,
    enableBack
  }) => /* @__PURE__ */ jsxs(Breadcrumb.Item, { ...enableClick && {
    onClick: () => onClickIn(key)
  } || {}, children: [
    enableBack && /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(LeftOutlined, {}), size: "small", type: "text" }),
    enableBack && label,
    !enableBack && label
  ] }, key)) });
}
Breadcrumbs.propTypes = {
  items: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    key: propTypesExports$1.string,
    label: propTypesExports$1.string,
    enableClick: propTypesExports$1.bool
  })),
  onClick: propTypesExports$1.func
};
Breadcrumbs.defaultProps = {
  items: [],
  onClick: () => {
  }
};
const searchIconClassName = styles$4["project-search-icon-button"];
function LeftContent() {
  const [header, setHeader] = React__default.useState({
    titile: "Layers"
  });
  const setActiveSubTool = useViewStore((state) => state.setActiveSubTool);
  const activeSubTool = useViewStore((state) => state.activeSubTool);
  const {
    hasHierarchy
  } = useSiteObjectStatistics();
  const actions = useSiteObjectTypes();
  const onAction = React__default.useCallback((key) => {
    if (key) {
      const tool = `create${makeFirstLetterCapital(key)}`;
      setActiveSubTool(tool);
    }
  }, [setActiveSubTool]);
  return /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    padding: "16px 24px 16px 24px",
    height: "100%",
    width: "100%"
  }, children: [
    header.breadcrumbsProps && /* @__PURE__ */ jsx(Breadcrumbs, { ...header.breadcrumbsProps }),
    /* @__PURE__ */ jsxs(Row, { justify: "space-between", style: {
      paddingTop: "5px",
      paddingBottom: "5px",
      alignItems: "anchor-center"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Title, { level: 5, style: {
        margin: 0
      }, children: header.title }),
      /* @__PURE__ */ jsxs(Row, { children: [
        /* @__PURE__ */ jsx(Button, { className: searchIconClassName, style: {
          width: "32px",
          height: "32px",
          padding: "0px"
        }, icon: /* @__PURE__ */ jsx(Icons.Search, { style: {
          fontSize: "12.5px",
          color: "transparent",
          marginRight: "5px"
        } }) }),
        (hasHierarchy || activeSubTool) && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { style: {
            width: "8px"
          } }),
          /* @__PURE__ */ jsx(LayerMenuPopup, { disabled: !!activeSubTool, actions, onAction, icon: /* @__PURE__ */ jsx(PlusOutlined, {}), trigger: "click", showAll: true })
        ] })
      ] })
    ] }),
    header.notice,
    !header.notice && /* @__PURE__ */ jsx(Divider, { style: {
      margin: "0px"
    } }),
    /* @__PURE__ */ jsx("div", { style: {
      width: "100%"
    }, children: /* @__PURE__ */ jsx(ContextPane, { setHeader }) }),
    false
  ] });
}
const styles$3 = {
  container: {
    width: "100%",
    height: "100%"
  }
};
const {
  useToken
} = theme$2;
function DesignerApp(props) {
  const {
    activeId,
    onSaveOrCancel,
    apps,
    logo: logo2,
    ...restProps
  } = props;
  const {
    ref: targetRef,
    height: windowHeight = 0,
    width: windowWidth = 0
  } = useLayoutDimensions();
  const [isRightPanelOn, setIsRightPanelOn] = React__default.useState(false);
  const {
    token
  } = useToken();
  const headerHeight = useConfigStore((state) => state.headerHeight);
  const footerHeight = useConfigStore((state) => state.footerHeight);
  const leftPanelWidth = useConfigStore((state) => state.leftPanelWidth);
  React__default.useEffect(() => {
    const observer = new MutationObserver(() => {
      const element = document.getElementById("right-panel");
      setIsRightPanelOn(!!element);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, []);
  const pixelSize = React__default.useMemo(() => {
    if (!windowHeight || !windowWidth)
      return null;
    const pixelSize2 = {
      header: {
        width: windowWidth,
        height: headerHeight
      },
      footer: {
        width: windowWidth,
        height: footerHeight
      },
      leftPanel: {
        width: leftPanelWidth,
        height: windowHeight
      },
      rightPanel: {
        width: isRightPanelOn ? leftPanelWidth : 0,
        height: windowHeight
      }
    };
    return pixelSize2;
  }, [windowHeight, windowWidth, headerHeight, footerHeight, leftPanelWidth, isRightPanelOn]);
  return /* @__PURE__ */ jsx("div", { ref: targetRef, style: styles$3.container, children: pixelSize && /* @__PURE__ */ jsx(MapLayout, { leftContent: /* @__PURE__ */ jsx(LeftContent, {}), rightContent: /* @__PURE__ */ jsx("div", { id: "right-panel-container" }), headerContent: /* @__PURE__ */ jsx(HeaderContent, { onDone: onSaveOrCancel, showSearch: true, showSave: true, apps, logo: logo2, style: {
    backgroundColor: token.colorBgBase
  } }), pixelSize, children: /* @__PURE__ */ jsx(FeaturesMapEdit, { activeId, ...restProps }) }) });
}
DesignerApp.propTypes = {
  activeId: propTypesExports$1.string,
  onSaveOrCancel: propTypesExports$1.func,
  apps: propTypesExports$1.node,
  logo: propTypesExports$1.node
};
DesignerApp.defaultProps = {
  activeId: "",
  onSaveOrCancel: () => {
  },
  apps: null,
  logo: null
};
function EditorImpl(props) {
  const {
    data: getData6,
    onClose: onCloseIn,
    tiles,
    displayMode: initialDisplayMode,
    saveAsGeoJson,
    center: center2,
    propertyKeys,
    fileFormats,
    children,
    readyOnly,
    legacy,
    enablePartialSave,
    enableCurrentState,
    deviceTypes,
    ...restProps
  } = props;
  const resetBuildingsStore = useSiteStore((state) => state.reset);
  const activeCollectionItemId = useViewStore((state) => state.activeCollectionItemId);
  const setDefaultTiles = useViewStore((state) => state.setDefaultTiles);
  const setDisplayMode = useViewStore((state) => state.setDisplayMode);
  const resetViewStore = useViewStore((state) => state.reset);
  const enableVenueSubTree = useViewStore((state) => state.enableVenueSubTree);
  const setDefaultCenter = useSiteStore((state) => state.setDefaultCenter);
  const closing = useViewStore((state) => state.closing);
  const saving = useViewStore((state) => state.saving);
  const setSaving = useViewStore((state) => state.setSaving);
  const setClosing = useViewStore((state) => state.setClosing);
  const addVisiblePropertyKey = useSiteStore((state) => state.addVisiblePropertyKey);
  const {
    onLoad: onJsonFileLoad
  } = useJsonLoader();
  const {
    onExport: onJsonExport
  } = useJsonExporter();
  const [data2, setData6] = React__default.useState(null);
  const setDeviceTypes = useDeviceTypeStore((state) => state.setDeviceTypes);
  const setSupportedFileFormats = useConfigStore((state) => state.setSupportedFileFormats);
  const {
    location: location2,
    loading: loading2
  } = useUserLocation();
  React__default.useLayoutEffect(() => {
    if (center2 || location2) {
      setDefaultCenter(location2 || center2);
    }
  }, [center2, location2, setDefaultCenter]);
  React__default.useLayoutEffect(() => {
    if (data2) {
      onJsonFileLoad(data2);
    }
  }, [data2, onJsonFileLoad]);
  React__default.useLayoutEffect(() => {
    if (deviceTypes) {
      setDeviceTypes(deviceTypes);
    }
  }, [deviceTypes, setDeviceTypes]);
  React__default.useEffect(() => {
    propertyKeys == null ? void 0 : propertyKeys.map((v5) => addVisiblePropertyKey(v5));
  }, [addVisiblePropertyKey, propertyKeys]);
  React__default.useEffect(() => {
    if (fileFormats == null ? void 0 : fileFormats.length) {
      const {
        supportedImageFileFormats,
        supportedCadFileFormats: supportedCadFileFormats2
      } = useConfigStore.getState();
      const supportedFileFormats = [...supportedImageFileFormats || [], ...supportedCadFileFormats2 || []];
      const supported = fileFormats.filter((f2) => supportedFileFormats.includes(f2.toLowerCase()));
      setSupportedFileFormats(supported);
    }
  }, [fileFormats, setSupportedFileFormats]);
  const onSaveOrCancel = React__default.useCallback((saveOrCancel) => {
    if (saveOrCancel)
      setSaving(true);
    else
      setClosing(true);
  }, [setClosing, setSaving]);
  React__default.useEffect(() => {
    if (tiles) {
      setDefaultTiles(tiles, true);
    }
  }, [setDefaultTiles, tiles]);
  React__default.useEffect(() => {
    setDisplayMode(initialDisplayMode);
  }, [initialDisplayMode, setDisplayMode]);
  const isPerformingRef = React__default.useRef(false);
  const performSaveOrCancel = React__default.useCallback(async (saving2, closing2, allowedCollectionTypes) => {
    var _a3;
    if (isPerformingRef.current)
      return;
    if (!saving2 && !closing2)
      return;
    isPerformingRef.current = true;
    if (saving2 && !readyOnly) {
      try {
        let json = onJsonExport({
          isGeoJson: saveAsGeoJson,
          allowedCollectionTypes
        });
        if (Array.isArray(json)) {
          json = {
            type: "FeatureCollection",
            features: json
          };
        }
        if ((_a3 = json == null ? void 0 : json.features) == null ? void 0 : _a3.length) {
          await (onCloseIn == null ? void 0 : onCloseIn(json));
        }
      } catch (error2) {
        console.error(error2);
      }
    } else if (closing2) {
      resetBuildingsStore();
      resetViewStore();
      await (onCloseIn == null ? void 0 : onCloseIn(null));
    }
    if (saving2)
      setSaving(false);
    if (closing2)
      setClosing(false);
    isPerformingRef.current = false;
  }, [onCloseIn, onJsonExport, readyOnly, resetBuildingsStore, resetViewStore, saveAsGeoJson, setClosing, setSaving]);
  React__default.useLayoutEffect(() => {
    performSaveOrCancel(saving, closing);
  }, [closing, performSaveOrCancel, saving]);
  const closingRef = useValueRef(closing);
  React__default.useEffect(() => {
    const closing2 = closingRef.current;
    return () => {
      if (closing2)
        return () => {
        };
      return () => performSaveOrCancel(false, true);
    };
  }, [closingRef, performSaveOrCancel]);
  React__default.useLayoutEffect(() => {
    if (typeof getData6 === "object") {
      setData6(getData6);
    }
  }, [getData6]);
  const isFetchingRef = React__default.useRef(false);
  React__default.useEffect(() => {
    if (typeof getData6 === "function" && !isFetchingRef.current && !isPerformingRef.current) {
      const doPatch = async () => {
        isFetchingRef.current = true;
        const context2 = useViewStore.getState().getActive();
        if (enablePartialSave) {
          let allowedCollectionTypes;
          if (context2.enableVenueSubTree) {
            allowedCollectionTypes = ["country", "region", "market", "cluster", "venue"];
          } else {
            allowedCollectionTypes = ["venue", "building", "level", "zone"];
          }
          await performSaveOrCancel(true, false, allowedCollectionTypes);
        }
        let currentState = null;
        if (enableCurrentState) {
          currentState = onJsonExport({
            isGeoJson: saveAsGeoJson
          });
          if (Array.isArray(currentState)) {
            currentState = {
              type: "FeatureCollection",
              features: currentState
            };
          }
        }
        const newData = await getData6(context2, currentState);
        setData6(newData);
        isFetchingRef.current = false;
      };
      doPatch();
    }
  }, [enableVenueSubTree, getData6, onJsonExport, performSaveOrCancel, saveAsGeoJson, enablePartialSave, enableCurrentState]);
  if (loading2)
    return null;
  return /* @__PURE__ */ jsx(DesignerApp, { activeId: activeCollectionItemId, onSaveOrCancel, ...restProps, children });
}
EditorImpl.propTypes = {
  data: propTypesExports$1.oneOfType([propTypesExports$1.object, propTypesExports$1.func]),
  onClose: propTypesExports$1.func,
  tiles: propTypesExports$1.string,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  saveAsGeoJson: propTypesExports$1.bool,
  enablePartialSave: propTypesExports$1.bool,
  enableCurrentState: propTypesExports$1.bool,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  propertyKeys: propTypesExports$1.arrayOf(propTypesExports$1.string),
  fileFormats: propTypesExports$1.arrayOf(propTypesExports$1.string),
  children: propTypesExports$1.node,
  readyOnly: propTypesExports$1.bool,
  legacy: propTypesExports$1.bool,
  // TOBE removed
  deviceTypes: propTypesExports$1.array
};
EditorImpl.defaultProps = {
  data: null,
  onClose: null,
  tiles: "",
  displayMode: "2d",
  saveAsGeoJson: false,
  enablePartialSave: false,
  enableCurrentState: false,
  center: null,
  // [longitude, latitude]
  propertyKeys: [],
  fileFormats: void 0,
  children: null,
  readyOnly: false,
  legacy: true,
  deviceTypes: []
};
const styles$2 = {
  container: {
    flex: 1,
    justifyContent: "center",
    width: "100%",
    height: "100%",
    position: "fixed"
  },
  modalContent: {
    flex: 1,
    justifyContent: "center",
    width: "100%",
    height: "calc(100vh - 120px)",
    overflow: "hidden"
  }
};
function FeatureEditor(props) {
  const {
    features,
    center: center2,
    onSaveFeatures,
    initialState: initialState2,
    ...restProps
  } = props;
  const [data2, setData6] = React__default.useState(null);
  const deepCopy = React__default.useCallback((coordinates2) => {
    if (!coordinates2)
      return coordinates2;
    if (Array.isArray(coordinates2)) {
      return coordinates2.map(deepCopy);
    }
    return coordinates2;
  }, []);
  const features2BuildingData = React__default.useCallback((features2, initialState22) => {
    if (initialState22)
      return initialState22;
    if (!(features2 == null ? void 0 : features2.length))
      return null;
    const venues = [];
    const buildings = [];
    const levels = [];
    let venueId = "0";
    let venue = null;
    features2.forEach((feature2) => {
      var _a3;
      const featureGeometry = feature2._geometry || feature2.geometry;
      const featureId = feature2.id;
      const category = feature2.properties.category || "footprint";
      const geometry2 = {
        type: featureGeometry.type,
        coordinates: deepCopy(featureGeometry.coordinates)
      };
      if (feature2.properties.venueId && !feature2.properties.levelId) {
        venueId = feature2.properties.venueId;
        venue = venues.find((v5) => v5.id === venueId);
        if (!venue) {
          venue = {
            name: `venue_${venueId}`,
            id: venueId,
            center: center2,
            features: []
          };
          venues.push(venue);
        }
        venue.features = venue.features || [];
        venue.features.push({
          id: featureId,
          name: `feature_${venue.features.length}`,
          type: "Feature",
          geometry: geometry2,
          properties: {
            category,
            venueId,
            mapboxProperties: {
              ...feature2.properties || {}
            }
          }
        });
      } else {
        const buildingId = `${feature2.properties.buildingId || ((_a3 = feature2.layer) == null ? void 0 : _a3.id) || "building"}`;
        const levelId = feature2.properties.levelId || generateUid();
        venueId = feature2.properties.venueId || "0";
        venue = venues.find((v5) => v5.id === venueId);
        if (!venue) {
          venue = {
            name: `venue_${venueId}`,
            id: venueId,
            center: center2,
            features: []
          };
          venues.push(venue);
        }
        if (!buildings.find((b2) => b2.id === buildingId)) {
          buildings.push({
            name: buildingId,
            id: buildingId,
            center: center2,
            venueId
          });
        }
        let level = levels.find((l2) => l2.id === levelId);
        if (!level) {
          level = {
            name: feature2.properties.NAME,
            id: levelId,
            type: "level",
            buildingId,
            features: [],
            elevation: feature2.properties.base_height,
            height: feature2.properties.height - feature2.properties.base_height
          };
          levels.push(level);
        }
        level.features = level.features || [];
        level.features.push({
          id: featureId,
          name: `feature_${level.features.length}`,
          type: "Feature",
          geometry: geometry2,
          properties: {
            category,
            buildingId,
            levelId,
            venueId,
            mapboxProperties: {
              ...feature2.properties || {}
            }
          }
        });
      }
    });
    return {
      venues,
      buildings,
      levels
    };
  }, [center2, deepCopy]);
  const buildingData2Features = React__default.useCallback((buildingData) => {
    const editedState = buildingData;
    const {
      levels,
      venues
    } = buildingData || {};
    const features2 = [];
    levels == null ? void 0 : levels.forEach((level) => {
      var _a3;
      (_a3 = level == null ? void 0 : level.features) == null ? void 0 : _a3.forEach((feature2) => {
        const copied = {
          ...feature2,
          properties: {
            ...feature2.properties,
            ...feature2.properties.mapboxProperties || {}
          }
        };
        features2.push(copied);
      });
    });
    venues == null ? void 0 : venues.forEach((venue) => {
      var _a3;
      (_a3 = venue == null ? void 0 : venue.features) == null ? void 0 : _a3.forEach((feature2) => {
        const copied = {
          ...feature2,
          properties: {
            ...feature2.properties,
            ...feature2.properties.mapboxProperties || {}
          }
        };
        features2.push(copied);
      });
    });
    return [features2, editedState];
  }, []);
  React__default.useLayoutEffect(() => {
    const buildingData = features2BuildingData(features, initialState2);
    setData6(buildingData);
  }, [center2, deepCopy, features, features2BuildingData, initialState2]);
  const onClose = React__default.useCallback((buildingData) => {
    const [features2, editedState] = buildingData2Features(buildingData) || [];
    onSaveFeatures(features2, editedState);
  }, [buildingData2Features, onSaveFeatures]);
  return /* @__PURE__ */ jsx("div", { style: styles$2.modalContent, children: /* @__PURE__ */ jsx(EditorImpl, { data: data2, center: center2, onClose, ...restProps }) });
}
FeatureEditor.propTypes = {
  features: propTypesExports$1.arrayOf(propTypesExports$1.object),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  onSaveFeatures: propTypesExports$1.func,
  initialState: propTypesExports$1.object
};
FeatureEditor.defaultProps = {
  features: [],
  center: null,
  onSaveFeatures: () => {
  },
  initialState: null
};
function GeojsonEditorInternal(props) {
  const {
    data: url2,
    setData: setData6,
    isFeatureEditable,
    initialState: initialState2,
    center: center2,
    ...restProps
  } = props;
  const json = useEditGeojson({
    data: url2
  });
  const allFeatures = React__default.useMemo(() => (json == null ? void 0 : json.features) || (json.type === "Feature" ? [json] : []), [json]);
  const updateData = React__default.useCallback((features, rawState) => {
    let newAllFeatures = pushArray([], allFeatures);
    features == null ? void 0 : features.forEach((feature2) => {
      const index2 = newAllFeatures.findIndex((f2) => f2.id === feature2.id);
      if (index2 > -1) {
        newAllFeatures = [...newAllFeatures.slice(0, index2), feature2, ...newAllFeatures.slice(index2 + 1, newAllFeatures.length)];
      } else {
        newAllFeatures.push(feature2);
      }
    });
    setData6({
      type: "FeatureCollection",
      features: newAllFeatures
    }, rawState);
  }, [allFeatures, setData6]);
  const editableFeatures = React__default.useMemo(() => (allFeatures == null ? void 0 : allFeatures.filter(isFeatureEditable)) || [], [allFeatures, isFeatureEditable]);
  return /* @__PURE__ */ jsx(FeatureEditor, { center: center2, features: editableFeatures, onSaveFeatures: updateData, initialState: initialState2, ...restProps });
}
GeojsonEditorInternal.propTypes = {
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  setData: propTypesExports$1.func,
  isFeatureEditable: propTypesExports$1.func,
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  initialState: propTypesExports$1.object
};
GeojsonEditorInternal.defaultProps = {
  data: null,
  setData: () => {
  },
  isFeatureEditable: () => true,
  center: null,
  initialState: null
};
function GeojsonEditor(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { children: /* @__PURE__ */ jsx(GeojsonEditorInternal, { ...props }) });
}
function GeojsonEditorModal(props) {
  const {
    onClose: onModalClose,
    title,
    okText,
    cancelText,
    bodyStyle,
    modalStyle,
    ...restProps
  } = props;
  const [isModalLoaded, setIsModalLoaded] = React__default.useState(false);
  React__default.useEffect(() => {
    setIsModalLoaded(true);
  }, []);
  return /* @__PURE__ */ jsx(Modal$1, { style: {
    top: 0,
    padding: 0,
    maxWidth: "100%",
    ...modalStyle
  }, width: "100%", open: true, title, okText, cancelText, onOk: (e3) => onModalClose("save", e3), onCancel: (e3) => onModalClose("cancel", e3), styles: {
    height: "calc(100vh - 116px)",
    ...bodyStyle
  }, children: isModalLoaded && /* @__PURE__ */ jsx(GeojsonEditor, { ...restProps }) });
}
GeojsonEditorModal.propTypes = {
  onClose: propTypesExports$1.func,
  title: propTypesExports$1.string,
  okText: propTypesExports$1.string,
  cancelText: propTypesExports$1.string,
  bodyStyle: propTypesExports$1.object,
  modalStyle: propTypesExports$1.object
};
GeojsonEditorModal.defaultProps = {
  onClose: () => {
  },
  title: "",
  okText: "Save",
  cancelText: "Cancel",
  bodyStyle: {},
  modalStyle: {}
};
const MAP_PROPS = {
  camera: {
    bearing: 0,
    zoom: 15.4,
    pitchWithRotate: false,
    enableRotate: true
  },
  tilesetUrl: MapTilesConstants.None.tilesetUrl,
  reuseMaps: false
};
const autoFocusEnabled = true;
const toolDrawMode = "noselect";
function FeaturesMapDisplay(props) {
  const {
    onLoad,
    children,
    customIcon,
    overlay,
    onMapLoad,
    loading: loading2,
    camera,
    interactions: interactions2,
    controls,
    minZoom,
    maxZoom,
    beforeId,
    mapProps: mapProps2
  } = props;
  const deviceTypes = useDeviceTypeStore((state) => state.deviceTypes);
  const [cameraResetEnabled, setCameraResetEnabled] = React__default.useState(true);
  const displayMode2 = useViewStore((state) => state.displayMode);
  const activeItemId = useViewStore((state) => state.activeCollectionItemId);
  const assets = useAssetStore((state) => state.assets);
  const updateAsset = useAssetStore((state) => state.updateAsset);
  const {
    center: center2,
    visibleFeatures,
    allFeatures
  } = useFeatures({
    all: true
  });
  const numModels = (assets == null ? void 0 : assets.length) || 0;
  const numModelsLoadedRef = React__default.useRef(0);
  const onModel3dLoad = React__default.useCallback(() => {
    numModelsLoadedRef.current += 1;
    if (numModels === numModelsLoadedRef.current) {
      onLoad(numModels);
    }
  }, [numModels, onLoad]);
  React__default.useEffect(() => {
    {
      const DELAY = 1e3;
      setTimeout(() => {
        setCameraResetEnabled(false);
      }, DELAY);
    }
  }, []);
  const containerId = "featuresMapDisplay";
  const filteredAssets = assets.filter((asset) => asset.parentId === activeItemId);
  if (!center2)
    return null;
  return /* @__PURE__ */ jsxs(LazyMap, { center: center2, ...MAP_PROPS, camera: {
    ...MAP_PROPS.camera,
    enabled: cameraResetEnabled,
    pitchWithRotate: displayMode2 !== "2d",
    ...camera
  }, id: containerId, overlay, onLoad: onMapLoad, loading: loading2, ...mapProps2, children: [
    /* @__PURE__ */ jsx(FeaturesControls, { containerId, enableSearch: true, enableLevelSelector: true, enableZoom: true, enableScale: true, enableDisplayMode: true, displayModePlacement: "bottom-right", searchPlacement: "top-right", enableLegend: true, enableMapFocus: true, ...controls }),
    /* @__PURE__ */ jsx(MapAutoFocus, { enabled: autoFocusEnabled, features: allFeatures }),
    /* @__PURE__ */ jsx(Interactions, { ...interactions2 }),
    /* @__PURE__ */ jsx(
      FeaturesView,
      {
        drawMode: toolDrawMode,
        features: visibleFeatures,
        deviceTypes,
        displayMode: displayMode2,
        customIcon,
        minZoom,
        maxZoom,
        beforeId
      }
    ),
    filteredAssets == null ? void 0 : filteredAssets.map((model3d) => /* @__PURE__ */ jsx(GeoreferencedAsset, { drawMode: toolDrawMode, displayMode: displayMode2, data: model3d, onChange: updateAsset, onLoad: onModel3dLoad, minZoom, maxZoom, beforeId }, model3d.id)),
    children
  ] });
}
FeaturesMapDisplay.propTypes = {
  activeId: propTypesExports$1.string,
  onLoad: propTypesExports$1.func,
  enableSearch: propTypesExports$1.bool,
  children: propTypesExports$1.node,
  customIcon: propTypesExports$1.func,
  overlay: propTypesExports$1.bool,
  onMapLoad: propTypesExports$1.func,
  loading: propTypesExports$1.bool,
  camera: propTypesExports$1.object,
  interactions: propTypesExports$1.object,
  controls: propTypesExports$1.object,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  beforeId: propTypesExports$1.string,
  mapProps: propTypesExports$1.object
};
FeaturesMapDisplay.defaultProps = {
  activeId: "",
  onLoad: () => {
  },
  enableSearch: true,
  children: null,
  customIcon: null,
  overlay: false,
  onMapLoad: () => {
  },
  loading: false,
  camera: {},
  interactions: {},
  controls: {},
  minZoom: 0,
  maxZoom: 24,
  beforeId: "",
  mapProps: {}
};
const styles$1 = {
  container: {
    width: "100%",
    height: "100%"
  }
};
function DisplayImpl(props) {
  const {
    data: dataIn,
    onClose: onCloseIn,
    tiles,
    displayMode: initialDisplayMode,
    center: center2,
    children,
    deviceTypes,
    ...restProps
  } = props;
  const resetBuildingsStore = useSiteStore((state) => state.reset);
  const setDefaultTiles = useViewStore((state) => state.setDefaultTiles);
  const setDisplayMode = useViewStore((state) => state.setDisplayMode);
  const resetViewStore = useViewStore((state) => state.reset);
  const setDefaultCenter = useSiteStore((state) => state.setDefaultCenter);
  const closing = useViewStore((state) => state.closing);
  const setClosing = useViewStore((state) => state.setClosing);
  const setDeviceTypes = useDeviceTypeStore((state) => state.setDeviceTypes);
  const {
    onLoad: onJsonFileLoad
  } = useJsonLoader();
  const {
    location: location2,
    loading: loading2
  } = useUserLocation();
  React__default.useLayoutEffect(() => {
    if (center2 || location2) {
      setDefaultCenter(location2 || center2);
    }
  }, [center2, location2, setDefaultCenter]);
  React__default.useLayoutEffect(() => {
    if (dataIn) {
      onJsonFileLoad(dataIn);
    }
  }, [dataIn, onJsonFileLoad]);
  React__default.useLayoutEffect(() => {
    if (deviceTypes) {
      setDeviceTypes(deviceTypes);
    }
  }, [deviceTypes, setDeviceTypes]);
  const onSaveOrCancel = React__default.useCallback(() => {
    setClosing(true);
  }, [setClosing]);
  React__default.useEffect(() => {
    if (tiles) {
      setDefaultTiles(tiles, true);
    }
  }, [setDefaultTiles, tiles]);
  React__default.useEffect(() => {
    setDisplayMode(initialDisplayMode);
  }, [initialDisplayMode, setDisplayMode]);
  const isPerformingRef = React__default.useRef(false);
  const performClosing = React__default.useCallback(async (closing2) => {
    if (isPerformingRef.current)
      return;
    if (!closing2)
      return;
    isPerformingRef.current = true;
    if (closing2) {
      resetBuildingsStore();
      resetViewStore();
      await (onCloseIn == null ? void 0 : onCloseIn(null));
    }
    if (closing2)
      setClosing(false);
    isPerformingRef.current = false;
  }, [onCloseIn, resetBuildingsStore, resetViewStore, setClosing]);
  React__default.useLayoutEffect(() => {
    performClosing(closing);
  }, [closing, performClosing]);
  const closingRef = useValueRef(closing);
  React__default.useEffect(() => {
    const closing2 = closingRef.current;
    return () => {
      if (closing2)
        return () => {
        };
      return () => performClosing(true);
    };
  }, [closingRef, performClosing]);
  if (loading2)
    return null;
  return /* @__PURE__ */ jsx("div", { style: styles$1.container, children: /* @__PURE__ */ jsx(FeaturesMapDisplay, { onSaveOrCancel, ...restProps, children }) });
}
DisplayImpl.propTypes = {
  data: propTypesExports$1.object,
  onClose: propTypesExports$1.func,
  tiles: propTypesExports$1.string,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  children: propTypesExports$1.node,
  deviceTypes: propTypesExports$1.array
};
DisplayImpl.defaultProps = {
  data: null,
  onClose: null,
  tiles: "",
  displayMode: "2d",
  center: null,
  // [longitude, latitude]
  children: null,
  deviceTypes: []
};
const useDragDropStore = createZustandStore((set) => ({
  item: "",
  // draggable/dropable item
  dragAction: null,
  // DRAG_START, DRAG_INPROGRSS , DRAG_STOP
  mouseDragPosition: null,
  setItem: (p2) => {
    set((state) => {
      state.item = p2;
    });
  },
  setDragAction: (action) => {
    set((state) => {
      state.dragAction = action;
    });
  },
  setMouseDragPosition: (position) => {
    set((state) => {
      state.mouseDragPosition = position;
    });
  },
  clearAll: () => {
    set((state) => {
      state.item = "";
      state.dragAction = null;
      state.mouseDragPosition = null;
    });
  }
}), "DragDropStore");
function MapboxDropAction(props) {
  const {
    onDrag,
    onDrop,
    enabled,
    layerIds,
    sourceId,
    sourceLayer
  } = props;
  const [offset, setOffset] = React__default.useState({
    x: 0,
    y: 0
  });
  const {
    map: map5
  } = useMapbox();
  const draggedItem = useDragDropStore((state) => state.item);
  const dragAction2 = useDragDropStore((state) => state.dragAction);
  const mouseDragPosition = useDragDropStore((state) => state.mouseDragPosition);
  const clearDragging = useDragDropStore((state) => state.clearAll);
  const {
    onListener: getSelectedFeature
  } = useMapListener({
    layerIds,
    sourceId,
    sourceLayer,
    stateKey: "select"
  });
  React__default.useEffect(() => {
    const onWindowResize = () => {
      var _a3;
      const rect = (_a3 = map5 == null ? void 0 : map5.getContainer()) == null ? void 0 : _a3.getBoundingClientRect();
      if (rect) {
        setOffset({
          x: -rect.left,
          y: -rect.top
        });
      }
    };
    onWindowResize();
    window.addEventListener("resize", onWindowResize, false);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, [map5]);
  const getDragData = React__default.useCallback((mouseDragPosition2) => {
    const mapPoint = [mouseDragPosition2.x + offset.x, mouseDragPosition2.y + offset.y];
    const lngLat = map5.unproject(mapPoint);
    const position = lngLat ? [lngLat.lng, lngLat.lat] : null;
    const event = {
      point: mapPoint,
      lngLat
    };
    const selection = getSelectedFeature(event, true);
    return {
      draggedItem,
      position,
      selection
    };
  }, [draggedItem, getSelectedFeature, map5, offset.x, offset.y]);
  const onDropItem = React__default.useCallback(() => {
    if (!mouseDragPosition)
      return;
    if (enabled) {
      onDrop(getDragData(mouseDragPosition));
    }
    clearDragging();
  }, [mouseDragPosition, enabled, clearDragging, onDrop, getDragData]);
  const onDragInAction = React__default.useCallback(() => {
    if (!mouseDragPosition || !onDrag)
      return;
    if (enabled) {
      onDrag(getDragData(mouseDragPosition));
    }
  }, [enabled, getDragData, mouseDragPosition, onDrag]);
  React__default.useEffect(() => {
    if (dragAction2) {
      if (dragAction2 === "DRAG_STOP") {
        onDropItem();
      } else if (dragAction2 === "DRAG_START") {
        onDragInAction();
      } else if (dragAction2 === "DRAG_INPROGRSS") {
        onDragInAction();
      }
    }
  }, [dragAction2, onDragInAction, onDropItem]);
  return null;
}
MapboxDropAction.propTypes = {
  enabled: propTypesExports$1.bool,
  onDrop: propTypesExports$1.func,
  onDrag: propTypesExports$1.func,
  layerIds: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.arrayOf(propTypesExports$1.string)]),
  sourceId: propTypesExports$1.string,
  sourceLayer: propTypesExports$1.string
};
MapboxDropAction.defaultProps = {
  enabled: false,
  onDrop: () => {
  },
  onDrag: null,
  layerIds: null,
  sourceId: null,
  sourceLayer: null
};
const CARDS_WIDTH = 150;
const DRAG_ICON_STYLE = {
  fontSize: "25px",
  color: "white",
  marginRight: "2px",
  marginLeft: "2px",
  width: "25px",
  height: "25px"
};
const BG_COLOR = "#232635";
const TEXT_COLOR = "#FFFFFF";
function DragCard(props) {
  const {
    property: property2
  } = props;
  return /* @__PURE__ */ jsxs("div", { style: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: `${CARDS_WIDTH}px`,
    background: BG_COLOR,
    margin: "0px",
    padding: "0px"
  }, children: [
    /* @__PURE__ */ jsx(Row, { align: "middle", style: {
      backgroundColor: BG_COLOR
    }, children: /* @__PURE__ */ jsx("div", { style: {
      display: "grid"
    }, children: /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(TextLabel, { style: {
      marginLeft: "5px",
      marginRight: "5px",
      color: TEXT_COLOR
    }, children: property2.name }) }) }) }),
    /* @__PURE__ */ jsx(Row, { align: "middle", style: {
      backgroundColor: "transparent",
      marginTop: "5px"
    }, children: /* @__PURE__ */ jsx(Col, { children: /* @__PURE__ */ jsx(Avatar, { icon: /* @__PURE__ */ jsx(DragOutlined, {}), style: DRAG_ICON_STYLE }) }) })
  ] });
}
DragCard.propTypes = {
  property: propTypesExports$1.object
};
DragCard.defaultProps = {
  property: {
    name: "name"
  }
};
const POINTER_CLASS = "pointer";
const useDragDropItem = (props) => {
  const {
    renderDragCard: renderElementIn,
    offset
  } = props || {};
  const setItem = useDragDropStore((state) => state.setItem);
  const setDragAction = useDragDropStore((state) => state.setDragAction);
  const setMouseDragPosition = useDragDropStore((state) => state.setMouseDragPosition);
  const pointerRef = React__default.useRef({});
  const rootRef = React__default.useRef(null);
  React__default.useEffect(() => {
    const checkPointer = document.getElementsByClassName(POINTER_CLASS);
    if (checkPointer.length === 0) {
      const pointer = document.createElement("div");
      pointer.classList.add(POINTER_CLASS);
      pointer.style.position = "absolute";
      pointer.style.height = "10px";
      pointer.style.width = "10px";
      pointer.style.left = "0px";
      pointer.style.top = "0px";
      pointer.style.zIndex = "10000";
      pointer.style.cursor = "grab";
      pointer.style.backgroundRepeat = "no-repeat";
      pointer.style.backgroundPosition = "center";
      pointer.style.backgroundSize = "10px 10px";
      pointer.style.color = "white";
      pointer.style.fontSize = "5px";
      pointer.style.display = "none";
      document.body.appendChild(pointer);
      pointerRef.current = pointer;
    }
    if (!pointerRef.current) {
      pointerRef.current = checkPointer[0];
    }
  }, []);
  const changeMouseStyle = React__default.useCallback((state) => {
    const {
      x: xOffset,
      y: yOffset
    } = offset || {
      x: 0,
      y: 0
    };
    const {
      mouseX: x2,
      mouseY: y2,
      hidden
    } = state;
    const pointer = document.getElementsByClassName(POINTER_CLASS)[0];
    pointerRef.current = pointer;
    pointerRef.current.style.left = `${x2 - xOffset}px`;
    pointerRef.current.style.top = `${y2 - yOffset}px`;
    pointerRef.current.style.display = hidden;
  }, [offset]);
  const renderDefaultElement = React__default.useCallback((property2) => /* @__PURE__ */ jsx(DragCard, { property: property2 }), []);
  const attachCard = React__default.useCallback((property2) => {
    const pointer = document.getElementsByClassName(POINTER_CLASS)[0];
    pointerRef.current = pointer;
    if (!rootRef.current) {
      rootRef.current = createRoot$1(pointer);
    }
    if (pointer) {
      const renderElement = renderElementIn || renderDefaultElement;
      rootRef.current.render(renderElement(property2));
    }
  }, [renderElementIn, renderDefaultElement]);
  const onDragStart = React__default.useCallback((state) => {
    const {
      args: [p2],
      target,
      xy,
      clientX,
      clientY
    } = state;
    if (target == null ? void 0 : target.style) {
      target.style.opacity = 0;
    }
    const mouseX = xy ? xy[0] : clientX;
    const mouseY = xy ? xy[1] : clientY;
    if (mouseX && mouseY) {
      changeMouseStyle({
        mouseX,
        mouseY,
        hidden: "grid",
        property: p2
      });
      setMouseDragPosition({
        x: mouseX,
        y: mouseY
      });
    }
    setItem(p2);
    attachCard(p2);
    setDragAction("DRAG_START");
  }, [attachCard, changeMouseStyle, setDragAction, setItem, setMouseDragPosition]);
  const onDragProgress = React__default.useCallback((state) => {
    const {
      xy,
      clientX,
      clientY,
      args: [q2]
    } = state;
    const mouseX = xy ? xy[0] : clientX;
    const mouseY = xy ? xy[1] : clientY;
    if (mouseX && mouseY) {
      changeMouseStyle({
        mouseX,
        mouseY,
        hidden: "grid",
        property: q2
      });
      setMouseDragPosition({
        x: mouseX,
        y: mouseY
      });
    }
    setDragAction("DRAG_INPROGRSS");
  }, [changeMouseStyle, setDragAction, setMouseDragPosition]);
  const onDragStop = React__default.useCallback((state) => {
    const {
      xy,
      target,
      clientX,
      clientY,
      args: [p2]
    } = state;
    const mouseX = xy ? xy[0] : clientX;
    const mouseY = xy ? xy[1] : clientY;
    changeMouseStyle({
      mouseX,
      mouseY,
      hidden: "none",
      property: p2
    });
    if (target == null ? void 0 : target.style) {
      target.style.opacity = 1;
    }
    setMouseDragPosition({
      x: mouseX,
      y: mouseY
    });
    setDragAction("DRAG_STOP");
  }, [changeMouseStyle, setDragAction, setMouseDragPosition]);
  const draggingCallback = React__default.useCallback((state) => {
    const {
      down
    } = state;
    const {
      dragAction: dragAction2
    } = useDragDropStore.getState();
    if (dragAction2 && dragAction2 !== "DRAG_STOP") {
      if (!down) {
        onDragStop(state);
      } else {
        onDragProgress(state);
      }
    } else if (down && !dragAction2) {
      onDragStart(state);
    }
  }, [onDragProgress, onDragStart, onDragStop]);
  const bindDropable = useDrag(draggingCallback, {
    threshold: 40
  });
  return bindDropable;
};
function VenueMapFragment(props) {
  const {
    data: data2,
    center: center2,
    enableOsm,
    enablePoi,
    onDoubleSelect: onDoubleSelectIn,
    clearSelections,
    onClearSelections
  } = props;
  const onDoubleSelect = React__default.useCallback((feature2) => {
    const isPoi = GeoUtil.isPointInsidePolygon(center2, feature2);
    if (isPoi) {
      onDoubleSelectIn(feature2);
    }
  }, [center2, onDoubleSelectIn]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    enablePoi && /* @__PURE__ */ jsx(FlooredBuilding, { id: "flooredBuilding", sourceId: "floorBuildingSource", data: data2, getLevel: (f2) => Number(f2.properties.NAME.replace("Floor", "")) - 1, color: "random" }),
    enablePoi && /* @__PURE__ */ jsx(Interactions, { sourceId: "floorBuildingSource", layerId: "flooredBuilding", onDoubleSelect, enableDoubleSelection: true, enableSelection: false, clearSelections, onClearSelections }),
    enableOsm && /* @__PURE__ */ jsx(OsmBuildingsPoi, { id: "osm", pointOfInterestPropName: "poi", center: center2, color: "cyan", hide: enablePoi })
  ] });
}
VenueMapFragment.propTypes = {
  data: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.object]),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  enableOsm: propTypesExports$1.bool,
  enablePoi: propTypesExports$1.bool,
  onDoubleSelect: propTypesExports$1.func,
  clearSelections: propTypesExports$1.bool,
  onClearSelections: propTypesExports$1.func
};
VenueMapFragment.defaultProps = {
  data: null,
  center: null,
  enableOsm: true,
  enablePoi: true,
  onDoubleSelect: () => {
  },
  clearSelections: false,
  onClearSelections: () => {
  }
};
const ErrorBoundaryContext = createContext(null);
const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends Component$1 {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error2) {
    return {
      didCatch: true,
      error: error2
    };
  }
  resetErrorBoundary() {
    const {
      error: error2
    } = this.state;
    if (error2 !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error2, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error2, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;
    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error: error2
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error: error2,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = createElement(FallbackComponent, props);
      } else if (fallback !== void 0) {
        childToRender = fallback;
      } else {
        throw error2;
      }
    }
    return createElement(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error: error2,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  let b2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return a2.length !== b2.length || a2.some((item, index2) => !Object.is(item, b2[index2]));
}
const DeviceTypesContextInstance = React__default.createContext();
const DeviceTypesContextInstance$1 = DeviceTypesContextInstance;
function useDeviceTypes() {
  const context2 = React__default.useContext(DeviceTypesContextInstance$1);
  if (!context2) {
    throw new Error("Cannot use `useDeviceTypes` outside of `DeviceTypesContext`");
  }
  return context2;
}
class DesignerUtil {
  constructor(token, endPoint) {
    this.accessToken = token;
    this.endPoint = `${endPoint}/v2/gis`;
  }
  async restoreDesignerData(id) {
    const idQuery = id ? `&id=${id}` : "";
    const response = await fetch(`${this.endPoint}/designer/?${idQuery}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    const result = await response.json();
    if (!response.ok)
      throw new Error(`API failed: ${result.detail}`);
    return result;
  }
  async saveDesignerData(data2) {
    const response = await fetch(`${this.endPoint}/designer/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(data2)
    });
    const result = await response.json();
    if (!response.ok)
      throw new Error(`API failed: ${result.detail}`);
    return result;
  }
}
const DEVICE_STATE_COLORS = IconUtil.DEVICE_DEPLOYMENT_STATUS;
const DEVICE_STATES = Object.keys(DEVICE_STATE_COLORS);
const DEVICE_STATE_OPTIONS = DEVICE_STATES.map((key) => ({
  label: DEVICE_STATE_COLORS[key].label,
  value: key
}));
const ALERT_STATUS = ["critical", "major", "minor"];
class DeviceUtil {
  constructor(token, endPoint) {
    this.token = token;
    this.endPoint = `${endPoint}/v2`;
  }
  // eslint-disable-next-line class-methods-use-this
  async parseResponse(response) {
    let errorDetail = "";
    try {
      const result = await response.json();
      if (!response.ok)
        errorDetail = result == null ? void 0 : result.detail;
      else
        return result;
    } catch (error2) {
      errorDetail = error2.message;
    }
    if (!response.ok || errorDetail)
      throw new Error(`API failed: ${errorDetail}`);
    return null;
  }
  // eslint-disable-next-line class-methods-use-this
  applyOptionsToUrl(urlIn, options2) {
    if (!options2)
      return urlIn;
    const {
      agentIds,
      includeStats,
      pageSize,
      page,
      filter: filter17,
      includeSectors
    } = options2;
    const url2 = new URL(urlIn);
    if (agentIds) {
      const agentIdsStr = agentIds ? agentIds.join(",") : "";
      url2.searchParams.append("agentIds", agentIdsStr);
    }
    if (includeStats) {
      url2.searchParams.append("include_stats", !!includeStats);
    }
    if (includeSectors) {
      url2.searchParams.append("include_sectors", !!includeSectors);
    }
    if (page) {
      url2.searchParams.append("page", page);
    }
    if (pageSize) {
      url2.searchParams.append("page_size", pageSize);
    }
    if (filter17) {
      url2.searchParams.append("filter_by", filter17);
    }
    return url2.toString();
  }
  async getStatistics(options2) {
    const url2 = this.applyOptionsToUrl(`${this.endPoint}/merged-assets/statistics`, options2);
    const response = await fetch(url2, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.token}`
      }
    });
    const statistics = await this.parseResponse(response);
    return statistics;
  }
  async getDevices(options2) {
    var _a3;
    const url2 = this.applyOptionsToUrl(`${this.endPoint}/merged-assets`, options2);
    const response = await fetch(url2, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.token}`
      }
    });
    const devicesRes = await this.parseResponse(response);
    const size12 = DEVICE_STATES.length;
    const {
      assets,
      statistics,
      count: count3
    } = devicesRes;
    const output2 = (_a3 = assets == null ? void 0 : assets.map((d2) => {
      if (!d2 || d2.deleted)
        return null;
      const obj = {
        ...d2,
        // Dummy
        isAccessPoint: d2.assetType === "WiFi AP",
        deploymentStatus: d2.deploymentStatus || DEVICE_STATES[Math.ceil(Math.random() * (size12 - 1))] || "Undefined",
        heatmapIntensity: Math.random() * 1e3
      };
      const alertStatus = d2.inventoryId ? ALERT_STATUS[Math.ceil(Math.random() * 2)] || "minor" : "";
      if (alertStatus)
        obj.alertStatus = alertStatus;
      return obj;
    })) == null ? void 0 : _a3.filter((d2) => !!d2);
    return {
      devices: output2,
      statistics,
      count: count3
    };
  }
  // delete devices
  async deleteDevice(deviceId) {
    if (!deviceId)
      throw new Error("No devices to delete");
    const url2 = `${this.endPoint}/merged-assets/${deviceId}`;
    const response = await fetch(url2, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.token}`
      }
    });
    const result = await this.parseResponse(response);
    return result;
  }
  async updateDevices(devices) {
    if (!devices)
      throw new Error("No devices to update");
    devices.forEach((d2) => {
      if (!d2.id && !d2.inventoryId)
        throw new Error("One of device id or inventoryId is mandatory");
    });
    const url2 = `${this.endPoint}/merged-assets/`;
    const response = await fetch(url2, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.token}`
      },
      body: JSON.stringify(devices)
    });
    const result = await this.parseResponse(response);
    return result;
  }
  // eslint-disable-next-line class-methods-use-this
  async createDevices(devices) {
    if (!devices)
      throw new Error("No devices to update");
    const url2 = `${this.endPoint}/merged-assets/`;
    const response = await fetch(url2, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.token}`
      },
      body: JSON.stringify(devices)
    });
    const result = await this.parseResponse(response);
    return result;
  }
  async getAssetTypes() {
    const response = await fetch(`${this.endPoint}/asset-types/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.token}`
      }
    });
    const result = await response.json();
    if (!response.ok)
      throw new Error(`API failed: ${result.detail}`);
    return result;
  }
}
DeviceUtil.DEVICE_STATES = DEVICE_STATES;
DeviceUtil.DEVICE_STATE_COLORS = DEVICE_STATE_COLORS;
DeviceUtil.DEVICE_STATE_OPTIONS = DEVICE_STATE_OPTIONS;
class S3Util {
  constructor(token, endPoint) {
    this.accessToken = token;
    this.endPoint = `${endPoint}/v2/gis`;
  }
  async uploadFile(file2, filepath = "") {
    const formData = new FormData();
    formData.append("file", file2);
    const res = await fetch(`${this.endPoint}/files?filepath=${filepath}`, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return res.json();
  }
  async getS3File(fileName) {
    try {
      const res = await fetch(`${this.endPoint}/files/download`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${this.accessToken}`,
          filename: fileName
        }
      });
      return await res.blob();
    } catch (error2) {
      console.error(error2);
    }
    return null;
  }
  async importFile(s3path, outputType) {
    if (!s3path)
      return [];
    const file2 = await this.getS3File(s3path);
    if (file2) {
      const result = await FileUtil.importFromFile(file2, outputType);
      if (result == null ? void 0 : result.data) {
        return [result.data, s3path];
      }
    }
    return [];
  }
}
class MiscUtil {
  static convertToFeature(item, prefix = "") {
    if (!item)
      return null;
    if (item.type === "Feature") {
      return item;
    }
    if (item.longitude && item.longitude) {
      return {
        id: `${prefix}${item.id}`,
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [Number(item.longitude), Number(item.latitude)]
        },
        properties: {
          ...item
        }
      };
    }
    return null;
  }
  static convertToGeoJson(symbols, prefix = "") {
    if (!symbols)
      return null;
    if (symbols.type === "FeatureCollection")
      return symbols;
    const features = [];
    if (symbols.type === "Feature") {
      features.push(symbols);
    } else if (Array.isArray(symbols) && symbols.length) {
      symbols.forEach((item) => {
        const feature2 = MiscUtil.convertToFeature(item, prefix);
        if (feature2)
          features.push(feature2);
      });
    }
    if (features.length)
      return {
        type: "FeatureCollection",
        features
      };
    return null;
  }
  static convertToFeatures(data2, prefix = "") {
    const geojson = MiscUtil.convertToGeoJson(data2, prefix);
    return (geojson == null ? void 0 : geojson.features) || [];
  }
}
function useSaiSession(fallback) {
  const [session, setSession] = React__default.useState();
  const [sessionPromise, setSessionPromise] = React__default.useState();
  const [isLoading, setIsLoading] = React__default.useState(true);
  const [forceUpdate, setForceUpdate] = React__default.useState(false);
  const getSaiSession = useEnvStore((state) => fallback || state.env.getSaiSession);
  const fetchToken = React__default.useCallback(async () => {
    var _a3, _b3;
    if (!forceUpdate && (session == null ? void 0 : session.accessToken))
      return session == null ? void 0 : session.accessToken;
    if (sessionPromise) {
      const result = await sessionPromise;
      if ((_a3 = result == null ? void 0 : result.data) == null ? void 0 : _a3.accessToken)
        return result.data.accessToken;
    }
    if (!getSaiSession || typeof getSaiSession !== "function")
      return null;
    setIsLoading(true);
    const promise = getSaiSession();
    setSessionPromise(promise);
    try {
      const result = await promise;
      setSession(result == null ? void 0 : result.data);
      setIsLoading(false);
      setForceUpdate(false);
      return (_b3 = result == null ? void 0 : result.data) == null ? void 0 : _b3.accessToken;
    } catch (error2) {
      console.error(error2);
      setSession(null);
      setIsLoading(false);
      setForceUpdate(false);
    }
    return null;
  }, [forceUpdate, getSaiSession, session == null ? void 0 : session.accessToken, sessionPromise]);
  React__default.useLayoutEffect(() => {
    fetchToken();
  }, [fetchToken, getSaiSession]);
  React__default.useEffect(() => {
    if (session == null ? void 0 : session.expires) {
      const maxDelay = Date.parse(session.expires) - Date.now();
      const interval = Math.min(1e3 * 60, maxDelay);
      const finalInterval = Math.max(0, interval);
      if (finalInterval > 0) {
        const handle = setInterval(() => {
          setForceUpdate(true);
          setSessionPromise(null);
        }, finalInterval);
        return () => {
          clearInterval(handle);
        };
      }
      setForceUpdate(true);
      setSessionPromise(null);
    }
    return () => {
    };
  }, [session == null ? void 0 : session.expires]);
  const getTokenFromSession = React__default.useCallback(() => session == null ? void 0 : session.accessToken, [session == null ? void 0 : session.accessToken]);
  const getAccessToken = useMutableFunc(getTokenFromSession);
  const getAccessTokenAsync = useMutableFunc(fetchToken);
  return {
    session,
    getAccessToken,
    isLoading,
    getAccessTokenAsync
  };
}
function useService(params2) {
  var _a3;
  const {
    client: Client2
  } = params2;
  const saiPostgresEndpoint = useEnvStore((state) => state.env.saiPostgresEndpoint);
  const {
    session,
    isLoading
  } = useSaiSession();
  const accessToken = session == null ? void 0 : session.accessToken;
  const tenantId = (_a3 = session == null ? void 0 : session.user) == null ? void 0 : _a3.tenant_id;
  return React__default.useMemo(() => {
    var _a4;
    if (!accessToken || !saiPostgresEndpoint || !Client2 || isLoading)
      return {};
    const apiClient = new Client2(accessToken, saiPostgresEndpoint);
    const clientName = ((_a4 = apiClient == null ? void 0 : apiClient.constructor) == null ? void 0 : _a4.name) || "";
    return {
      clientName,
      tenantId,
      apiClient
    };
  }, [accessToken, saiPostgresEndpoint, Client2, isLoading, tenantId]);
}
function apiQueryRequest(options2) {
  const {
    apiClient,
    clientName,
    method,
    tenantId,
    args = [],
    queryProps = {},
    transform: transform4 = (r2) => r2
  } = options2 || {};
  const queryKey = [clientName, tenantId, method, ...args, ...queryProps.queryKey || []];
  const enabled = typeof queryProps.enabled !== "undefined" ? queryProps.enabled : true;
  const result = {
    queryFn: async () => {
      var _a3;
      const response = await ((_a3 = apiClient == null ? void 0 : apiClient[method]) == null ? void 0 : _a3.call(apiClient, ...args));
      return transform4(response);
    },
    ...queryProps,
    queryKey,
    enabled: !!(enabled && clientName && method && apiClient)
  };
  return result;
}
function useApi(params2) {
  const {
    client: client2,
    ...restParams
  } = params2;
  const {
    clientName,
    tenantId,
    apiClient
  } = useService({
    client: client2
  });
  return useQuery(apiQueryRequest({
    ...restParams,
    clientName,
    tenantId,
    apiClient
  }));
}
function fetchQueryRequest(options2) {
  const {
    path: pathIn,
    fetchProps,
    queryProps = {},
    json = true,
    searchParams
  } = options2 || {};
  const getPath = () => {
    if (!searchParams)
      return pathIn;
    let path3 = `${pathIn}?`;
    Object.keys(searchParams).forEach((key, index2) => {
      const value = searchParams[key];
      if (value === null || value === void 0)
        return;
      path3 = `${path3}${index2 > 0 ? "&" : ""}${key}=${value}`;
    });
    return path3;
  };
  const path2 = getPath();
  const queryKey = [path2, ...queryProps.queryKey || []];
  const getData6 = async () => {
    const res = await fetch(path2, fetchProps);
    if (json) {
      return res.json();
    }
    return res;
  };
  const result = {
    queryFn: async () => getData6(),
    ...queryProps,
    queryKey
  };
  return result;
}
function useFetch(params2) {
  const result = useQuery(fetchQueryRequest(params2));
  return result;
}
function useParallelFetch(arrayOfParams) {
  const queries = arrayOfParams.map(fetchQueryRequest);
  const result = useQueries({
    queries
  });
  return result;
}
class UrlUtil {
  static finalizeOptions(options2) {
    if (!options2)
      return null;
    const keys4 = Object.keys(options2);
    if (!(keys4 == null ? void 0 : keys4.length))
      return null;
    const finalOptions = {};
    keys4.forEach((k2) => {
      const value = options2[k2];
      if (value || typeof value !== "object" && typeof value !== "undefined") {
        finalOptions[k2] = value;
      }
    });
    if (!Object.keys(finalOptions).length)
      return null;
    return finalOptions;
  }
  static addOptionsToUrl(url2, options2) {
    const finalOptions = UrlUtil.finalizeOptions(options2);
    if (!finalOptions)
      return url2;
    const queryParams = new URLSearchParams(finalOptions);
    return `${url2}?${queryParams.toString()}`;
  }
}
function lowerFirstLetter(str = "") {
  return str.charAt(0).toLowerCase() + str.slice(1);
}
class NeptuneUtil {
  constructor(token, endPoint) {
    this.accessToken = token;
    this.endPoint = `${endPoint}/v2/gis`;
  }
  parseKnownFields(key, value) {
    if (!this)
      return value;
    try {
      switch (key) {
        case "parentHierarchy":
          return value && typeof value === "string" ? JSON.parse(value) : value;
        default:
          return value;
      }
    } catch (error2) {
      console.error(error2);
    }
    return value;
  }
  parseNeptuneObject(data2) {
    if (!data2)
      return data2;
    const scope = this;
    if (Array.isArray(data2)) {
      return data2.map((item) => scope.parseNeptuneObject(item));
    }
    if (typeof data2 === "object") {
      const cloned = {};
      Object.keys(data2).forEach((key) => {
        const item = data2[key];
        let finalValue;
        if (typeof item === "object" && typeof (item == null ? void 0 : item.value) !== "undefined") {
          finalValue = item.value;
        } else {
          finalValue = scope.parseNeptuneObject(item);
        }
        const finalKey = lowerFirstLetter(key);
        cloned[finalKey] = scope.parseKnownFields(finalKey, finalValue);
      });
      return cloned;
    }
    return data2;
  }
  parseParentId(response) {
    if (!response)
      return response;
    if (Array.isArray(response)) {
      return response.map((item) => this.parseParentId(item));
    }
    if (typeof response === "object") {
      const {
        parentId,
        parentType
      } = response;
      if (parentId && parentType) {
        const parentKey = `${parentType}Id`;
        if (!response[parentKey]) {
          response[parentKey] = parentId;
        }
      }
    }
    return response;
  }
  async parseResponse(response) {
    const result = await response.json();
    if (!response.ok)
      throw new Error(`API failed: ${result.detail}`);
    return this.parseParentId(this.parseNeptuneObject(result));
  }
  async createVenue(venue) {
    const res = await fetch(`${this.endPoint}/entity/venues`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(venue)
    });
    return this.parseResponse(res);
  }
  async getAllMarkets(options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/markets`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getMarketById(marketId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/markets/${marketId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllMarketsByParentId(parentId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/markets/parent/${parentId}`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllVenues(options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/venues`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getDocumentsByParentId(parentId, topic) {
    if (!parentId)
      return [];
    let url2 = `${this.endPoint}/entity/documents/parent/${parentId}`;
    if (topic)
      url2 = `${url2}?topic=${topic}`;
    const res = await fetch(url2, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getVenueById(venueId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/venues/${venueId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getVenueByParentId(parentId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/venues/parent/${parentId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getVenueByName(venueName, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/venues/venue/${venueName}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async updateVenue(venue) {
    const res = await fetch(`${this.endPoint}/entity/venues`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(venue)
    });
    return this.parseResponse(res);
  }
  async deleteVenue(venueId) {
    const res = await fetch(`${this.endPoint}/entity/venues/${venueId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // building
  async createBuilding(building) {
    const res = await fetch(`${this.endPoint}/entity/buildings`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(building)
    });
    return this.parseResponse(res);
  }
  async getAllBuildings(venueId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/buildings/venue/${venueId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllBuildingsOnly(options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/buildings`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getBuildingById(buildingId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/buildings/${buildingId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getBuildingByName(buildingName, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/buildings/building/${buildingName}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async updateBuilding(building) {
    const res = await fetch(`${this.endPoint}/entity/buildings`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(building)
    });
    return this.parseResponse(res);
  }
  async deleteBuilding(buildingId) {
    const res = await fetch(`${this.endPoint}/entity/buildings/${buildingId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // level
  async createLevel(level) {
    const res = await fetch(`${this.endPoint}/entity/levels`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(level)
    });
    return this.parseResponse(res);
  }
  async getAllLevels(buildingId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/levels/building/${buildingId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  /* eslint-disable no-restricted-syntax */
  async getAllBuildingsLevels(buildingIds, options2) {
    const levels = [];
    for await (const buildingId of buildingIds) {
      try {
        const buildingLevels = await this.getAllLevels(buildingId, options2);
        if (buildingLevels == null ? void 0 : buildingLevels.length)
          levels.push(...buildingLevels);
      } catch (error2) {
        console.error(`Error fetching levels for building ID ${buildingId}:`, error2);
      }
    }
    return levels;
  }
  /* eslint-enable no-restricted-syntax */
  async getLevelById(levelId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/levels/${levelId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async updateLevel(level) {
    const res = await fetch(`${this.endPoint}/entity/levels`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(level)
    });
    return this.parseResponse(res);
  }
  async deleteLevel(levelId) {
    const res = await fetch(`${this.endPoint}/entity/levels/${levelId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // rooms
  async getAllRoomsByLevelId(levelId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/rooms/level/${levelId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getRoomById(roomId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/rooms/${roomId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // access points
  async createAccessPoint(accessPoint) {
    const res = await fetch(`${this.endPoint}/entity/access-points`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(accessPoint)
    });
    return this.parseResponse(res);
  }
  async updateAccessPoint(accessPoint) {
    const res = await fetch(`${this.endPoint}/entity/access-points`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(accessPoint)
    });
    return this.parseResponse(res);
  }
  async deleteAccessPoint(accessPointId) {
    const res = await fetch(`${this.endPoint}/entity/access-points/${accessPointId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllAccessPointsByParentId(parentId) {
    const res = await fetch(`${this.endPoint}/entity/access-points/parent/${parentId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAccessPointById(accessPointId) {
    const res = await fetch(`${this.endPoint}/entity/access-points/${accessPointId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // walls
  async getAllWallsByLevelId(levelId) {
    const res = await fetch(`${this.endPoint}/entity/walls/level/${levelId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getWallById(wallId) {
    const res = await fetch(`${this.endPoint}/entity/walls/${wallId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // building components
  async getAllBuildingComponentsByParentId(parentId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/building-components/parent/${parentId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getBuildingComponentById(id, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/building-components/${id}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async updateBuildingComponent(buildingComponent) {
    const res = await fetch(`${this.endPoint}/entity/building-components`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(buildingComponent)
    });
    return this.parseResponse(res);
  }
  async deleteBuildingComponent(id) {
    const res = await fetch(`${this.endPoint}/entity/building-components/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // zones
  async getAllZones(options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/zones`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllZonesByParentId(parentId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/zones/parent/${parentId}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getZoneById(id, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/zones/${id}`, options2), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async updateZone(zone) {
    const res = await fetch(`${this.endPoint}/entity/zones`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(zone)
    });
    return this.parseResponse(res);
  }
  async deleteZone(id) {
    const res = await fetch(`${this.endPoint}/entity/zones/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // documents
  async createDocument(document2) {
    const res = await fetch(`${this.endPoint}/entity/documents`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(document2)
    });
    return this.parseResponse(res);
  }
  async deleteDocument(documentId) {
    const res = await fetch(`${this.endPoint}/entity/documents/${documentId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllDocumentsByParentId(parentId) {
    const res = await fetch(`${this.endPoint}/entity/documents/parent/${parentId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // footprints
  async createFootprint(document2) {
    const res = await fetch(`${this.endPoint}/entity/footprints`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(document2)
    });
    return this.parseResponse(res);
  }
  // assets
  async createAsset(asset) {
    const res = await fetch(`${this.endPoint}/entity/assets`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(asset)
    });
    return this.parseResponse(res);
  }
  async updateAsset(asset) {
    const res = await fetch(`${this.endPoint}/entity/assets`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(asset)
    });
    return this.parseResponse(res);
  }
  async deleteAsset(assetId) {
    const res = await fetch(`${this.endPoint}/entity/assets/${assetId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllAssetsForCurrentTenant() {
    const res = await fetch(`${this.endPoint}/entity/assets`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAssetsByParentId(parentId) {
    const res = await fetch(`${this.endPoint}/entity/assets/parent/${parentId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAssetsByVenueId(venueId) {
    const res = await fetch(`${this.endPoint}/entity/assets/venue/${venueId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAssetById(assetId) {
    const res = await fetch(`${this.endPoint}/entity/assets/${assetId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // sectors
  async getSectorById(sectorId) {
    const res = await fetch(`${this.endPoint}/entity/sectors/${sectorId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getSectorsByAssetId(assetId) {
    const res = await fetch(`${this.endPoint}/entity/sectors/asset/${assetId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  // clusters
  async getClusterById(clusterId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/clusters/${clusterId}`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllClusters(options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/clusters`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllClustersByParentId(parentId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/clusters/parent/${parentId}`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAllRegions(options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/regions`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getRegionById(regionId, options2) {
    const res = await fetch(UrlUtil.addOptionsToUrl(`${this.endPoint}/entity/regions/${regionId}`, options2), {
      cache: "no-store",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getAssetClusters(zoomLevel, bbox2, minZoomDistance, maxZoomDistance, maxZoom = 18) {
    const res = await fetch(`${this.endPoint}/entity/clusters/asset?zoom_level=${zoomLevel}&bbox=${bbox2.toString()}&max_zoom=${maxZoom}&min_zoom_distance=${minZoomDistance}&max_zoom_distance=${maxZoomDistance}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getVenuesWithinRange(zoomLevel, bbox2) {
    const res = await fetch(`${this.endPoint}/entity/clusters/venue?zoom_level=${zoomLevel}&bbox=${bbox2.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async bulkLoadGeojson(data2) {
    const res = await fetch(`${this.endPoint}/geojson`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      },
      body: JSON.stringify(data2)
    });
    return this.parseResponse(res);
  }
  async hasBuildingModels() {
    var _a3;
    const res = await fetch(`${this.endPoint}/entity/buildings/count_model3d`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    const result = await this.parseResponse(res);
    return (_a3 = result == null ? void 0 : result.map((d2) => {
      if (d2.count > 0)
        return d2.buildingId;
      return null;
    })) == null ? void 0 : _a3.filter((d2) => !!d2);
  }
  async getBuildingCounts() {
    const res = await fetch(`${this.endPoint}/entity/buildings/count`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getLevelCounts() {
    const res = await fetch(`${this.endPoint}/entity/levels/count`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
  async getZoneTypes() {
    const res = await fetch(`${this.endPoint}/entity/zones/types/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${this.accessToken}`
      }
    });
    return this.parseResponse(res);
  }
}
class MapDataUtil {
  constructor(token, endPoint) {
    this.accessToken = token;
    this.endPoint = endPoint;
  }
  async getAllByType(type) {
    const neptune = new NeptuneUtil(this.accessToken, this.endPoint);
    switch (type) {
      case "region":
        return neptune.getAllRegions({
          geometry: true,
          center: true
        });
      case "market":
        return neptune.getAllMarkets({
          geometry: true,
          center: true
        });
      case "cluster":
        return neptune.getAllClusters({
          geometry: true,
          center: true
        });
      case "venue":
        return neptune.getAllVenues({
          geometry: true,
          center: true
        });
      case "zone":
        return neptune.getAllZones({
          geometry: true,
          center: true
        });
      default:
        return [];
    }
  }
  async getData(options2) {
    var _a3, _b3, _c2, _d2, _e2;
    const {
      type,
      id,
      nextType
    } = options2 || {};
    const neptune = new NeptuneUtil(this.accessToken, this.endPoint);
    const promises = {};
    if (!id) {
      promises.list = this.getAllByType(nextType);
    }
    if (nextType === "venue") {
      promises.counts = neptune.getBuildingCounts();
    }
    switch (type) {
      case "root":
        promises.list = neptune.getAllMarkets({
          geometry: true,
          center: true
        });
        break;
      case "region":
        if (id) {
          promises.object = neptune.getRegionById(id, {
            geometry: true,
            center: true
          });
          promises.list = Promise.all([neptune.getAllMarketsByParentId(id, {
            geometry: true,
            center: true
          }), neptune.getAllClustersByParentId(id, {
            geometry: true,
            center: true
          }), neptune.getVenueByParentId(id, {
            geometry: true,
            center: true
          })]).then((results) => results.flat());
        }
        break;
      case "market":
        if (id) {
          promises.object = neptune.getMarketById(id, {
            geometry: true,
            center: true
          });
          promises.list = Promise.all([neptune.getAllClustersByParentId(id, {
            geometry: true,
            center: true
          }), neptune.getVenueByParentId(id, {
            geometry: true,
            center: true
          })]).then((results) => results.flat());
        }
        break;
      case "cluster":
        if (id) {
          promises.object = neptune.getClusterById(id, {
            geometry: true,
            center: true
          });
          promises.list = neptune.getVenueByParentId(id, {
            geometry: true,
            center: true
          });
        }
        break;
      case "venue":
        if (id) {
          promises.list = neptune.getAllBuildings(id, {
            document: true,
            center: true
          });
          promises.counts = neptune.getLevelCounts();
          promises.object = neptune.getVenueById(id, {
            document: true,
            center: true
          });
        }
        break;
      case "building":
        if (id) {
          promises.list = neptune.getAllLevels(id, {
            document: true,
            center: true
          });
          promises.object = neptune.getBuildingById(id, {
            document: true,
            center: true
          });
        }
        break;
      case "level":
        if (id) {
          promises.object = neptune.getLevelById(id, {
            document: true,
            center: true
          });
        }
        break;
      case "device":
        if (id) {
          promises.object = neptune.getAssetById(id);
        }
        break;
    }
    const promiseKeys = Object.keys(promises) || [];
    const result = {};
    if (promiseKeys.length) {
      const promiseValues = promiseKeys.map((key) => promises[key]);
      const values4 = await Promise.all(promiseValues);
      promiseKeys.forEach((key, index2) => {
        result[key] = values4[index2];
      });
    }
    if (((_a3 = result.list) == null ? void 0 : _a3.length) && ["region", "cluster", "market", "venue", "building", "zone"].includes(type)) {
      result.symbols = [];
      const uniqueList = {};
      result.list.forEach((item) => {
        uniqueList[item.id] = item;
      });
      result.list = Object.values(uniqueList);
      (_b3 = result.list) == null ? void 0 : _b3.forEach((d2) => {
        var _a4, _b4, _c3, _d3, _e3, _f3, _g, _h;
        result.symbols.push({
          symbolViewContextType: type,
          symbolViewContextId: id || "",
          critical: 10,
          major: 5,
          minor: 7,
          "2.4ghz": 12,
          "5ghz": 18,
          "6ghz": 60,
          longitude: (_d3 = (_c3 = (_b4 = (_a4 = d2 == null ? void 0 : d2.geometry) == null ? void 0 : _a4.coordinates) == null ? void 0 : _b4[0]) == null ? void 0 : _c3[0]) == null ? void 0 : _d3[0],
          // Assuming polygon (applicable to zone)
          latitude: (_h = (_g = (_f3 = (_e3 = d2 == null ? void 0 : d2.geometry) == null ? void 0 : _e3.coordinates) == null ? void 0 : _f3[0]) == null ? void 0 : _g[0]) == null ? void 0 : _h[1],
          ...d2
        });
      });
    }
    if ((_c2 = result.counts) == null ? void 0 : _c2.length) {
      if (nextType === "venue") {
        (_d2 = result.list) == null ? void 0 : _d2.forEach((item) => {
          var _a4;
          item.numBuildings = Number(((_a4 = result.counts.find((b2) => b2.venueId === item.id)) == null ? void 0 : _a4.count) || 0);
        });
      } else if (nextType === "building") {
        (_e2 = result.list) == null ? void 0 : _e2.forEach((item) => {
          var _a4;
          item.numLevelInstances = Number(((_a4 = result.counts.find((b2) => b2.buildingId === item.id)) == null ? void 0 : _a4.count) || 0);
          item.numLevels = Number(item.noOfFloors || item.numLevels || 0);
          item.numLevels = Math.max(item.numLevels, item.numLevelInstances);
          delete item.noOfFloors;
        });
      }
      delete result.counts;
    }
    if (result.object) {
      result.object = Array.isArray(result.object) ? result.object[0] : result.object;
    }
    return result;
  }
}
class TextUtil {
  static toTitleCase(str) {
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }
  static toFirstUpperCase(str) {
    return str.charAt(0).toUpperCase() + str.substr(1);
  }
}
const useFetchMapData = ({
  type,
  id,
  nextType,
  enabled
}) => useApi({
  client: MapDataUtil,
  method: "getData",
  args: [{
    type,
    id,
    nextType
  }],
  queryProps: {
    enabled
  }
});
const useFilterMapData = (disabled) => {
  const [regionId, setRegionId] = React__default.useState(null);
  const [marketId, setMarketId] = React__default.useState(null);
  const [clusterId, setClusterId] = React__default.useState(null);
  const [venueId, setVenueId] = React__default.useState(null);
  const [buildingId, setBuildingId] = React__default.useState(null);
  const [levelId, setLevelId] = React__default.useState(null);
  const HIERARCHY = React__default.useMemo(() => ["regionId", "marketId", "clusterId", "venueId", "buildingId", "levelId"], []);
  const SETTERS = React__default.useMemo(() => ({
    regionId: setRegionId,
    marketId: setMarketId,
    clusterId: setClusterId,
    venueId: setVenueId,
    buildingId: setBuildingId,
    levelId: setLevelId
  }), [setRegionId, setMarketId, setClusterId, setVenueId, setBuildingId, setLevelId]);
  const {
    isLoading: isRegionDataLoading,
    data: regionsData = [],
    error: errorRegionData
  } = useFetchMapData({
    nextType: "region",
    enabled: !(disabled == null ? void 0 : disabled.region)
  });
  const {
    isLoading: isMarketDataLoading,
    data: marketsData = [],
    error: errorMarketData
  } = useFetchMapData({
    type: regionId ? "region" : "root",
    id: regionId,
    nextType: "market",
    enabled: !(disabled == null ? void 0 : disabled.market)
  });
  const {
    isLoading: isClusterDataLoading,
    data: clustersData = [],
    error: errorClusterData
  } = useFetchMapData({
    type: "market",
    id: marketId,
    nextType: "cluster",
    enabled: !(disabled == null ? void 0 : disabled.cluster)
  });
  const {
    isLoading: isVenueDataLoading,
    data: venuesData = [],
    error: errorVenueData
  } = useFetchMapData({
    type: clusterId ? "cluster" : "market",
    id: clusterId || marketId,
    nextType: "venue",
    enabled: !(disabled == null ? void 0 : disabled.venue)
  });
  const {
    isLoading: isBuildingDataLoading,
    data: buildingsData = [],
    error: errorBuildingData
  } = useFetchMapData({
    type: "venue",
    id: venueId,
    nextType: "building",
    enabled: !(disabled == null ? void 0 : disabled.building)
  });
  const {
    isLoading: isLevelDataLoading,
    data: levelsData = [],
    error: errorLevelData
  } = useFetchMapData({
    type: "building",
    id: buildingId,
    nextType: "level",
    enabled: !(disabled == null ? void 0 : disabled.level)
  });
  const activeMarket = React__default.useMemo(() => {
    var _a3;
    return (_a3 = marketsData == null ? void 0 : marketsData.list) == null ? void 0 : _a3.find((m2) => m2.id === marketId);
  }, [marketsData == null ? void 0 : marketsData.list, marketId]);
  const activeCluster = React__default.useMemo(() => {
    var _a3;
    return (_a3 = clustersData == null ? void 0 : clustersData.list) == null ? void 0 : _a3.find((c2) => c2.id === clusterId);
  }, [clustersData == null ? void 0 : clustersData.list, clusterId]);
  const activeVenue = React__default.useMemo(() => {
    var _a3;
    return (_a3 = venuesData == null ? void 0 : venuesData.list) == null ? void 0 : _a3.find((v5) => v5.id === venueId);
  }, [venuesData == null ? void 0 : venuesData.list, venueId]);
  const regions = React__default.useMemo(() => {
    var _a3;
    const list2 = activeMarket ? ((_a3 = regionsData == null ? void 0 : regionsData.list) == null ? void 0 : _a3.filter((r2) => r2.id === activeMarket.regionId)) || [] : !activeVenue && !activeCluster ? (regionsData == null ? void 0 : regionsData.list) || [] : [];
    return list2;
  }, [activeMarket, regionsData == null ? void 0 : regionsData.list, activeVenue, activeCluster]);
  const markets = React__default.useMemo(() => {
    var _a3, _b3, _c2;
    const list2 = regionId ? ((_a3 = marketsData == null ? void 0 : marketsData.list) == null ? void 0 : _a3.filter((m2) => m2.regionId === regionId)) || [] : activeCluster ? (_b3 = marketsData == null ? void 0 : marketsData.list) == null ? void 0 : _b3.filter((m2) => m2.id === activeCluster.marketId) : activeVenue ? (_c2 = marketsData == null ? void 0 : marketsData.list) == null ? void 0 : _c2.filter((m2) => m2.id === activeVenue.marketId) : (marketsData == null ? void 0 : marketsData.list) || [];
    return Array.from(new Map(list2.map((m2) => [m2.id, m2])).values());
  }, [activeCluster, marketsData == null ? void 0 : marketsData.list, regionId, activeVenue]);
  const clusters = React__default.useMemo(() => {
    var _a3, _b3;
    return marketId ? ((_a3 = clustersData == null ? void 0 : clustersData.list) == null ? void 0 : _a3.filter((c2) => c2.marketId === marketId)) || [] : activeVenue ? (_b3 = clustersData == null ? void 0 : clustersData.list) == null ? void 0 : _b3.filter((c2) => c2.id === activeVenue.clusterId) : (clustersData == null ? void 0 : clustersData.list) || [];
  }, [clustersData == null ? void 0 : clustersData.list, marketId, activeVenue]);
  const venues = React__default.useMemo(() => {
    var _a3, _b3;
    return clusterId ? ((_a3 = venuesData == null ? void 0 : venuesData.list) == null ? void 0 : _a3.filter((v5) => v5.clusterId === clusterId)) || [] : marketId ? ((_b3 = venuesData == null ? void 0 : venuesData.list) == null ? void 0 : _b3.filter((v5) => v5.marketId === marketId)) || [] : (venuesData == null ? void 0 : venuesData.list) || [];
  }, [venuesData == null ? void 0 : venuesData.list, clusterId, marketId]);
  const buildings = React__default.useMemo(() => {
    var _a3;
    return venueId ? ((_a3 = buildingsData == null ? void 0 : buildingsData.list) == null ? void 0 : _a3.filter((b2) => b2.venueId === venueId)) || [] : (buildingsData == null ? void 0 : buildingsData.list) || [];
  }, [buildingsData == null ? void 0 : buildingsData.list, venueId]);
  const levels = React__default.useMemo(() => {
    var _a3;
    return buildingId ? ((_a3 = levelsData == null ? void 0 : levelsData.list) == null ? void 0 : _a3.filter((l2) => l2.buildingId === buildingId)) || [] : (levelsData == null ? void 0 : levelsData.list) || [];
  }, [levelsData == null ? void 0 : levelsData.list, buildingId]);
  const filters = React__default.useMemo(() => [!(disabled == null ? void 0 : disabled.region) && {
    key: "region",
    label: "Region",
    options: regions.map((item) => ({
      label: item.name,
      value: item.id
    }))
  }, !(disabled == null ? void 0 : disabled.market) && {
    key: "market",
    label: "Market",
    options: markets.map((item) => ({
      label: item.name,
      value: item.id
    }))
  }, !(disabled == null ? void 0 : disabled.cluster) && {
    key: "cluster",
    label: "Cluster",
    options: clusters.filter((item) => item.category !== "venue").map((item) => ({
      label: item.name,
      value: item.id
    }))
  }, !(disabled == null ? void 0 : disabled.venue) && {
    key: "venue",
    label: "Venue",
    options: venues.filter((item) => item.category === "venue").map((item) => ({
      label: item.name,
      value: item.id
    }))
  }, !(disabled == null ? void 0 : disabled.building) && {
    key: "building",
    label: "Building",
    options: buildings.map((item) => ({
      label: item.name,
      value: item.id
    }))
  }, !(disabled == null ? void 0 : disabled.level) && {
    key: "level",
    label: "Level",
    options: levels.map((item) => ({
      label: item.name,
      value: item.id
    }))
  }].filter(Boolean), [disabled, regions, markets, clusters, venues, buildings, levels]);
  const handleFilterChange = React__default.useCallback((values4) => {
    let reset2 = false;
    HIERARCHY.forEach((key) => {
      if (key in values4) {
        const newValue = values4[key] || null;
        if (SETTERS[key])
          SETTERS[key](newValue);
        reset2 = true;
      } else if (reset2 && SETTERS[key]) {
        SETTERS[key](null);
      }
    });
  }, [HIERARCHY, SETTERS]);
  const handleOnClear = React__default.useCallback(() => {
    HIERARCHY.forEach((key) => SETTERS[key](null));
  }, [HIERARCHY, SETTERS]);
  const isLoading = isRegionDataLoading || isMarketDataLoading || isClusterDataLoading || isVenueDataLoading || isBuildingDataLoading || isLevelDataLoading;
  const errors = React__default.useMemo(() => [errorRegionData, errorMarketData, errorClusterData, errorVenueData, errorBuildingData, errorLevelData].filter(Boolean), [errorRegionData, errorMarketData, errorClusterData, errorVenueData, errorBuildingData, errorLevelData]);
  const hasError = errors.length > 0;
  return {
    filters,
    handleFilterChange,
    handleOnClear,
    selectedIds: {
      regionId,
      marketId,
      clusterId,
      venueId,
      buildingId,
      levelId
    },
    isLoading,
    hasError,
    errors
  };
};
function DeviceTypesLoaderInternal(props) {
  const {
    onChange
  } = props;
  const [deviceTypes, setDeviceTypes] = React__default.useState({});
  const {
    isLoading,
    data: data2,
    error: error2
  } = useApi({
    client: DeviceUtil,
    method: "getAssetTypes"
  });
  const assetTypes = React__default.useMemo(() => {
    if (isLoading || error2 || !data2)
      return [];
    return IconUtil.prepareDeviceIcons(data2);
  }, [data2, error2, isLoading]);
  React__default.useLayoutEffect(() => {
    const deviceTypes2 = {};
    assetTypes == null ? void 0 : assetTypes.forEach((item) => {
      const deviceType = item.value;
      deviceTypes2[deviceType] = {
        ...item,
        id: deviceType,
        name: deviceType,
        iconUrl: item.url,
        Icon: item.Icon
        // React component
      };
    });
    setDeviceTypes(deviceTypes2);
  }, [assetTypes, error2, isLoading]);
  const getDeviceIcon = React__default.useCallback((type, props2 = {}) => {
    const item = deviceTypes[type] || deviceTypes[`${type == null ? void 0 : type.toLowerCase()}`] || deviceTypes.Other;
    const Icon2 = item == null ? void 0 : item.Icon;
    if (Icon2)
      return /* @__PURE__ */ jsx(Icon2, { ...props2 });
    return null;
  }, [deviceTypes]);
  const getDeviceIconUrl = React__default.useCallback((type) => {
    const item = deviceTypes[type] || deviceTypes[`${type == null ? void 0 : type.toLowerCase()}`] || deviceTypes.unknown;
    return item == null ? void 0 : item.iconUrl;
  }, [deviceTypes]);
  const getTechnologyIcon = React__default.useCallback((type, props2 = {}) => {
    const tech2AssetType = {
      "5G": "Cellular 5G",
      "Wi-Fi": "WiFi AP"
    };
    const assetType = tech2AssetType[type] || type;
    return getDeviceIcon(assetType, props2);
  }, [getDeviceIcon]);
  const deviceTypesArray = React__default.useMemo(() => Object.values(deviceTypes), [deviceTypes]);
  React__default.useLayoutEffect(() => {
    onChange({
      deviceTypes: deviceTypesArray,
      getDeviceIcon,
      getDeviceIconUrl,
      getTechnologyIcon
    });
  }, [deviceTypesArray, getDeviceIcon, getDeviceIconUrl, getTechnologyIcon, onChange]);
  return null;
}
DeviceTypesLoaderInternal.propTypes = {
  onChange: propTypesExports$1.func
};
DeviceTypesLoaderInternal.defaultProps = {
  onChange: () => {
  }
};
function DeviceTypesLoader(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(DeviceTypesLoaderInternal, { ...props }) });
}
const DEFAULT_VALUE = {
  deviceTypes: [],
  getDeviceIcon: () => null,
  getDeviceIconUrl: () => null,
  getTechnologyIcon: () => null
};
function DeviceTypesContext(props) {
  const {
    children
  } = props;
  const [value, setValue2] = React__default.useState(DEFAULT_VALUE);
  const onChange = React__default.useCallback((value2) => {
    const finalValue = {
      ...DEFAULT_VALUE
    };
    const {
      deviceTypes,
      getDeviceIcon,
      getDeviceIconUrl,
      getTechnologyIcon
    } = value2 || {};
    if (deviceTypes && Array.isArray(deviceTypes))
      finalValue.deviceTypes = deviceTypes;
    if (getDeviceIcon && typeof getDeviceIcon === "function")
      finalValue.getDeviceIcon = getDeviceIcon;
    if (getDeviceIconUrl && typeof getDeviceIconUrl === "function")
      finalValue.getDeviceIconUrl = getDeviceIconUrl;
    if (getTechnologyIcon && typeof getTechnologyIcon === "function") {
      finalValue.getTechnologyIcon = getTechnologyIcon;
    }
    setValue2(finalValue);
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(DeviceTypesLoader, { onChange }),
    /* @__PURE__ */ jsx(DeviceTypesContextInstance$1.Provider, { value, children })
  ] });
}
DeviceTypesContext.propTypes = {
  children: propTypesExports$1.node
};
DeviceTypesContext.defaultProps = {
  children: null
};
function UseDeviceTypes(props) {
  const {
    onLoad
  } = props;
  const value = useDeviceTypes();
  React__default.useEffect(() => {
    onLoad(value);
  }, [onLoad, value]);
  return null;
}
UseDeviceTypes.propTypes = {
  onLoad: propTypesExports$1.func
};
UseDeviceTypes.defaultProps = {
  onLoad: () => {
  }
};
const MapDataContext = React__default.createContext();
function MapDataProvider(props) {
  var _a3, _b3, _c2, _d2, _e2, _f3;
  const {
    children,
    initialHierarchy,
    disabled,
    center: initialCenter,
    deviceSymbols: showDeviceSymbols,
    heatmapData,
    defaultView,
    defaultNavigation,
    enableRouterUpdate
  } = props;
  const [displayMode2, setDisplayMode] = React__default.useState("2d");
  const [data2, setData6] = React__default.useState({});
  const [center2, setCenter] = React__default.useState(initialCenter);
  const [currentHierarchy, setCurrentHierarchy] = React__default.useState({
    rootId: defaultView,
    regionId: null,
    marketId: null,
    clusterId: null,
    venueId: null,
    buildingId: null,
    levelId: null,
    deviceId: null
  });
  const [nextHierarchy, setNextHierarchy] = React__default.useState({
    rootId: defaultView,
    regionId: null,
    marketId: null,
    clusterId: null,
    venueId: null,
    buildingId: null,
    levelId: null,
    deviceId: null,
    ...initialHierarchy
  });
  const nextHierarchyRef = useValueRef(nextHierarchy);
  const updateRouter = React__default.useCallback((hierarchy) => {
    if (!enableRouterUpdate)
      return;
    const {
      venueId,
      buildingId,
      levelId
    } = hierarchy || {};
    let path2 = "/map";
    if (venueId) {
      path2 = `${path2}/v/${venueId}`;
      if (buildingId) {
        path2 = `${path2}/b/${buildingId}`;
        if (levelId) {
          path2 = `${path2}/l/${levelId}`;
        }
      }
    }
    window.history.pushState({}, "", path2);
  }, [enableRouterUpdate]);
  const getActiveItem = React__default.useCallback((hierarchy, filterType = "") => {
    var _a4, _b4, _c3, _d3;
    if (!hierarchy)
      return null;
    let activeId;
    let activeType;
    if (hierarchy.levelId && ((_b4 = (_a4 = data2 == null ? void 0 : data2.building) == null ? void 0 : _a4.object) == null ? void 0 : _b4.id) === hierarchy.buildingId) {
      activeId = hierarchy.levelId;
      activeType = "level";
    } else if (hierarchy.buildingId && ((_d3 = (_c3 = data2 == null ? void 0 : data2.venue) == null ? void 0 : _c3.object) == null ? void 0 : _d3.id) === hierarchy.venueId) {
      activeId = hierarchy.buildingId;
      activeType = "building";
    } else if (hierarchy.venueId) {
      activeId = hierarchy.venueId;
      activeType = "venue";
    } else if (hierarchy.clusterId) {
      activeId = hierarchy.clusterId;
      activeType = "cluster";
    } else if (hierarchy.marketId) {
      activeId = hierarchy.marketId;
      activeType = "market";
    } else if (hierarchy.regionId) {
      activeId = hierarchy.regionId;
      activeType = "region";
    } else {
      activeId = null;
      activeType = hierarchy.rootId;
    }
    if (filterType && activeType !== filterType)
      return {};
    return {
      id: activeId,
      type: activeType
    };
  }, [(_b3 = (_a3 = data2 == null ? void 0 : data2.building) == null ? void 0 : _a3.object) == null ? void 0 : _b3.id, (_d2 = (_c2 = data2 == null ? void 0 : data2.venue) == null ? void 0 : _c2.object) == null ? void 0 : _d2.id]);
  const getDataProps = React__default.useCallback((nextHierarchy2) => {
    const {
      id,
      type
    } = getActiveItem(nextHierarchy2) || {};
    const nextType = defaultNavigation[type];
    if (!nextType && !id) {
      return {
        enabled: false
      };
    }
    return {
      type,
      id,
      nextType,
      enabled: !!nextHierarchy2 && !(disabled == null ? void 0 : disabled.navigation) && !(disabled == null ? void 0 : disabled[nextType])
    };
  }, [defaultNavigation, disabled, getActiveItem]);
  const {
    isLoading: isMapDataLoading,
    data: mapData,
    error: errorMapData
  } = useFetchMapData(getDataProps(nextHierarchy));
  const {
    isLoading: isRootDataLoading,
    data: rootData,
    error: errorRootData
  } = useFetchMapData({
    nextType: "market",
    // TODO: parameterize this
    enabled: !!nextHierarchy && !(disabled == null ? void 0 : disabled.navigation)
  });
  const {
    isLoading: isZonesLoading,
    data: zonesData,
    error: errorZones
  } = useFetchMapData({
    nextType: "zone",
    enabled: !(disabled == null ? void 0 : disabled.zones)
  });
  const {
    isLoading: isDevicesLoading,
    data: assetsWithStatsData,
    error: errorDevices
  } = useApi({
    client: DeviceUtil,
    method: "getDevices",
    args: [{
      includeStats: true,
      includeSectors: true
    }],
    queryProps: {
      enabled: !(disabled == null ? void 0 : disabled.devices)
    }
  });
  const {
    devices: devicesIn
  } = assetsWithStatsData || {};
  const {
    isLoading: isZoneTypesLoading,
    data: zoneTypesData,
    error: errorZoneTypes
  } = useApi({
    client: NeptuneUtil,
    method: "getZoneTypes"
  });
  const {
    isLoading: has3dLoading,
    data: buildingsWith3d,
    error: error3d
  } = useApi({
    client: NeptuneUtil,
    method: "hasBuildingModels",
    queryProps: {
      enabled: !(disabled == null ? void 0 : disabled.model3d)
    }
  });
  React__default.useLayoutEffect(() => {
    if (!isMapDataLoading && !isRootDataLoading) {
      const {
        id,
        type: view22
      } = getActiveItem(nextHierarchyRef.current) || {};
      if (view22) {
        const uniqueRootData = (rootData == null ? void 0 : rootData.list) ? {
          ...rootData,
          list: Array.from(new Map(rootData.list.map((m2) => [m2.id, m2])).values())
        } : rootData;
        setData6((previous) => ({
          ...previous,
          root: {
            ...previous.root || {},
            ...uniqueRootData || {}
          },
          [view22]: {
            id,
            ...mapData || {}
          }
        }));
        setCurrentHierarchy(nextHierarchyRef.current);
        updateRouter(nextHierarchyRef.current);
      }
    }
  }, [mapData, rootData, getActiveItem, isMapDataLoading, nextHierarchyRef, updateRouter, isRootDataLoading]);
  React__default.useLayoutEffect(() => {
    if (!isDevicesLoading) {
      setData6((previous) => ({
        ...previous,
        devices: devicesIn
      }));
    }
  }, [devicesIn, isDevicesLoading]);
  React__default.useLayoutEffect(() => {
    if (!has3dLoading) {
      setData6((previous) => ({
        ...previous,
        buildingsWith3d
      }));
    }
  }, [has3dLoading, buildingsWith3d]);
  React__default.useLayoutEffect(() => {
    if (!isZonesLoading) {
      setData6((previous) => ({
        ...previous,
        zones: zonesData
      }));
    }
  }, [zonesData, isZonesLoading]);
  React__default.useLayoutEffect(() => {
    if (!isZoneTypesLoading) {
      setData6((previous) => ({
        ...previous,
        zoneTypes: zoneTypesData
      }));
    }
  }, [isZoneTypesLoading, zoneTypesData]);
  const navigateInHierarchy = React__default.useCallback((next5) => {
    const hierarchyOrder = ["rootId", "regionId", "marketId", "clusterId", "venueId", "buildingId", "levelId", "deviceId"];
    if (!next5) {
      const result = {
        rootId: defaultView
      };
      setNextHierarchy(result);
      nextHierarchyRef.current = result;
      return;
    }
    setNextHierarchy((previous) => {
      const result = {
        ...previous
      };
      let reset2 = false;
      for (const key of hierarchyOrder) {
        if (key in next5) {
          if (previous[key] !== next5[key]) {
            result[key] = next5[key];
            reset2 = true;
          }
        } else if (reset2) {
          result[key] = null;
        }
      }
      nextHierarchyRef.current = result;
      return result;
    });
  }, [defaultView, nextHierarchyRef]);
  const {
    activeList,
    activeItem,
    statusSymbols,
    view: view2,
    devices,
    deviceSymbols,
    zones,
    zoneTypes,
    zoneSymbols
  } = React__default.useMemo(() => {
    var _a4, _b4, _c3, _d3, _e3, _f4, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q2, _r, _s, _t, _u, _v;
    const {
      id,
      type: view22
    } = getActiveItem(currentHierarchy) || {};
    const {
      list: list2,
      symbols: statusSymbols2,
      object: object2
    } = (data2 == null ? void 0 : data2[view22]) || {};
    let zones2 = ((_a4 = data2 == null ? void 0 : data2.zones) == null ? void 0 : _a4.list) || [];
    let zoneSymbols2 = ((_b4 = data2 == null ? void 0 : data2.zones) == null ? void 0 : _b4.symbols) || [];
    let devices2 = [];
    let deviceSymbols2 = null;
    let activeList2 = list2;
    let activeItem2 = id === (object2 == null ? void 0 : object2.id) ? object2 : null;
    let models3d = [];
    if (view22 === "root") {
      const filterByMarket = (m2) => {
        var _a5;
        const d2 = (_a5 = data2 == null ? void 0 : data2.devices) == null ? void 0 : _a5.filter((d22) => (d22 == null ? void 0 : d22.marketId) === m2.id);
        if (d2)
          devices2.push(...d2);
        return d2;
      };
      activeList2 = list2 == null ? void 0 : list2.map((m2) => {
        var _a5;
        return {
          ...m2,
          numAps: ((_a5 = filterByMarket(m2)) == null ? void 0 : _a5.length) || 0
        };
      });
      if (showDeviceSymbols == null ? void 0 : showDeviceSymbols.root) {
        deviceSymbols2 = devices2;
      }
    } else if (["region", "market", "cluster"].includes(view22)) {
      const filterByVenue = (v5) => {
        var _a5;
        return (_a5 = data2 == null ? void 0 : data2.devices) == null ? void 0 : _a5.filter((d2) => (d2 == null ? void 0 : d2.venueId) === v5.id);
      };
      const venueIds = (list2 == null ? void 0 : list2.map((v5) => v5.id)) || [];
      devices2 = (_c3 = data2 == null ? void 0 : data2.devices) == null ? void 0 : _c3.filter((d2) => {
        let found = d2[`${view22}Id`] === id;
        if (!found && (d2 == null ? void 0 : d2.venueId)) {
          found = venueIds.includes(d2.venueId);
        }
        return !!found;
      });
      activeList2 = list2 == null ? void 0 : list2.map((v5) => {
        var _a5;
        return {
          ...v5,
          numAps: ((_a5 = filterByVenue(v5)) == null ? void 0 : _a5.length) || 0
        };
      });
      if (showDeviceSymbols == null ? void 0 : showDeviceSymbols[view22]) {
        deviceSymbols2 = devices2;
      }
    } else if (view22 === "venue" && id) {
      devices2 = (_d3 = data2 == null ? void 0 : data2.devices) == null ? void 0 : _d3.filter((d2) => (d2 == null ? void 0 : d2.venueId) === id);
      zoneSymbols2 = zoneSymbols2 == null ? void 0 : zoneSymbols2.filter((d2) => (d2 == null ? void 0 : d2.venueId) === id);
      zones2 = zones2 == null ? void 0 : zones2.filter((d2) => (d2 == null ? void 0 : d2.venueId) === id);
      activeList2 = list2 == null ? void 0 : list2.map((building) => {
        var _a5, _b5;
        return {
          ...building,
          numAps: ((_a5 = devices2 == null ? void 0 : devices2.filter((d2) => d2.isAccessPoint && (d2 == null ? void 0 : d2.buildingId) === building.id)) == null ? void 0 : _a5.length) || 0,
          hasModel3d: !!((_b5 = data2 == null ? void 0 : data2.buildingsWith3d) == null ? void 0 : _b5.includes(building.id))
        };
      });
      if (showDeviceSymbols == null ? void 0 : showDeviceSymbols.venue) {
        deviceSymbols2 = devices2;
      }
    } else if (view22 === "building" && id) {
      devices2 = (_e3 = data2 == null ? void 0 : data2.devices) == null ? void 0 : _e3.filter((d2) => (d2 == null ? void 0 : d2.buildingId) === id);
      zoneSymbols2 = zoneSymbols2 == null ? void 0 : zoneSymbols2.filter((d2) => (d2 == null ? void 0 : d2.buildingId) === id);
      zones2 = zones2 == null ? void 0 : zones2.filter((d2) => (d2 == null ? void 0 : d2.buildingId) === id);
      if (showDeviceSymbols == null ? void 0 : showDeviceSymbols.building) {
        deviceSymbols2 = devices2;
      }
      models3d = (_g = (_f4 = list2 == null ? void 0 : list2.map((l2) => {
        var _a5, _b5;
        {
          const found = (_a5 = l2.documents) == null ? void 0 : _a5.filter((d2) => d2.topic === "3dtiles");
          if (found == null ? void 0 : found.length)
            return found;
        }
        return (_b5 = l2.documents) == null ? void 0 : _b5.filter((d2) => d2.topic === "model3d");
      })) == null ? void 0 : _f4.flat()) == null ? void 0 : _g.filter((m2) => !!m2);
    } else if (view22 === "level" && id) {
      {
        models3d = (_h = activeItem2 == null ? void 0 : activeItem2.documents) == null ? void 0 : _h.filter((d2) => d2.topic === "3dtiles");
      }
      if (!(models3d == null ? void 0 : models3d.length)) {
        models3d = (_i = activeItem2 == null ? void 0 : activeItem2.documents) == null ? void 0 : _i.filter((d2) => d2.topic === "model3d");
      }
      zoneSymbols2 = zoneSymbols2 == null ? void 0 : zoneSymbols2.filter((d2) => (d2 == null ? void 0 : d2.levelId) === id);
      zones2 = zones2 == null ? void 0 : zones2.filter((d2) => (d2 == null ? void 0 : d2.levelId) === id);
      devices2 = (_j = data2 == null ? void 0 : data2.devices) == null ? void 0 : _j.filter((d2) => (d2 == null ? void 0 : d2.levelId) === id);
      if (showDeviceSymbols == null ? void 0 : showDeviceSymbols.level) {
        deviceSymbols2 = devices2;
      }
    }
    if (activeItem2) {
      let parentName;
      switch (view22) {
        case "region":
        case "market":
        case "cluster":
          parentName = (_l = (_k = data2 == null ? void 0 : data2.root) == null ? void 0 : _k.object) == null ? void 0 : _l.name;
          break;
        case "venue":
          parentName = (_n = (_m = data2 == null ? void 0 : data2.market) == null ? void 0 : _m.object) == null ? void 0 : _n.name;
          break;
        case "building":
          parentName = (_p = (_o = data2 == null ? void 0 : data2.venue) == null ? void 0 : _o.object) == null ? void 0 : _p.name;
          break;
        case "level":
          parentName = (_r = (_q2 = data2 == null ? void 0 : data2.building) == null ? void 0 : _q2.object) == null ? void 0 : _r.name;
          break;
      }
      const thumbnailPath2 = (_t = (_s = activeItem2 == null ? void 0 : activeItem2.documents) == null ? void 0 : _s.find((d2) => d2.topic === "thumbnail")) == null ? void 0 : _t.documentUrl;
      activeItem2 = {
        ...activeItem2,
        parentName,
        thumbnail: thumbnailPath2 ? (_u = data2 == null ? void 0 : data2.thumbnails) == null ? void 0 : _u[thumbnailPath2] : null,
        models3d,
        hasModel3d: !!((_v = data2 == null ? void 0 : data2.buildingsWith3d) == null ? void 0 : _v.includes(activeItem2.id)) || (models3d == null ? void 0 : models3d.length) > 0
      };
    }
    const zoneTypes2 = Array.from(new Set((zones2 == null ? void 0 : zones2.map((z2) => z2.type)) || []));
    return {
      activeItem: activeItem2,
      view: view22,
      statusSymbols: statusSymbols2,
      activeList: activeList2,
      devices: devices2,
      deviceSymbols: deviceSymbols2,
      zones: zones2,
      zoneTypes: zoneTypes2,
      zoneSymbols: zoneSymbols2
    };
  }, [currentHierarchy, data2, getActiveItem, showDeviceSymbols]);
  const thumbnailPath = (_f3 = (_e2 = activeItem == null ? void 0 : activeItem.documents) == null ? void 0 : _e2.find((d2) => d2.topic === "thumbnail")) == null ? void 0 : _f3.documentUrl;
  const {
    isLoading: loadingThumbnailContent,
    data: thumbnailContent,
    error: errorThumbnailContent
  } = useApi({
    client: S3Util,
    method: "importFile",
    args: [thumbnailPath, "dataUrl"],
    queryProps: {
      enabled: !(disabled == null ? void 0 : disabled.thumbnail)
    }
  });
  React__default.useLayoutEffect(() => {
    if (!loadingThumbnailContent && thumbnailContent) {
      const [dataUrl, s3path] = thumbnailContent;
      setData6((previous) => ({
        ...previous || {},
        thumbnails: {
          ...(previous == null ? void 0 : previous.thumbnails) || {},
          [s3path]: dataUrl
        }
      }));
    }
  }, [loadingThumbnailContent, thumbnailContent]);
  React__default.useLayoutEffect(() => {
    var _a4, _b4;
    const {
      venueId
    } = currentHierarchy || {};
    if ((_b4 = (_a4 = data2 == null ? void 0 : data2.market) == null ? void 0 : _a4.list) == null ? void 0 : _b4.length) {
      const venue = (venueId ? data2.market.list.find((v5) => v5.id === venueId) : null) || data2.market.list[0];
      if (venue && venue.longitude && venue.longitude) {
        const center22 = [Number(venue.longitude), Number(venue.latitude)];
        setCenter(center22);
      }
    } else if (initialCenter) {
      setCenter(initialCenter);
    }
  }, [currentHierarchy, data2, initialCenter]);
  const value = React__default.useMemo(() => ({
    data: data2,
    center: center2,
    hierarchy: currentHierarchy,
    nextHierarchy,
    activeItem,
    activeList,
    statusSymbols,
    deviceSymbols,
    heatmapData,
    activeView: view2,
    devices,
    zones,
    zoneTypes,
    zoneSymbols,
    onNavigate: navigateInHierarchy,
    displayMode: displayMode2,
    setDisplayMode,
    loading: {
      navigation: isMapDataLoading && isRootDataLoading,
      devices: isDevicesLoading,
      model3d: has3dLoading,
      thumbnail: loadingThumbnailContent,
      zoneTypes: isZoneTypesLoading,
      zones: isZonesLoading
    },
    error: {
      navigation: errorMapData && errorRootData,
      devices: errorDevices,
      model3d: error3d,
      thumbnail: errorThumbnailContent,
      zoneTypes: errorZoneTypes,
      zones: errorZones
    }
  }), [data2, center2, currentHierarchy, nextHierarchy, activeItem, activeList, statusSymbols, deviceSymbols, heatmapData, view2, devices, zones, zoneTypes, zoneSymbols, navigateInHierarchy, displayMode2, isMapDataLoading, isRootDataLoading, isDevicesLoading, has3dLoading, loadingThumbnailContent, isZoneTypesLoading, isZonesLoading, errorMapData, errorRootData, errorDevices, error3d, errorThumbnailContent, errorZoneTypes, errorZones]);
  console.debug("MapDataProvider", value);
  return /* @__PURE__ */ jsx(MapDataContext.Provider, { value, children });
}
MapDataProvider.propTypes = {
  children: propTypesExports$1.node,
  initialHierarchy: propTypesExports$1.object,
  defaultView: propTypesExports$1.oneOf(["root", "region", "market", "cluster", "venue", "building", "level"]),
  defaultNavigation: propTypesExports$1.object,
  disabled: propTypesExports$1.shape({
    navigation: propTypesExports$1.bool,
    devices: propTypesExports$1.bool,
    model3d: propTypesExports$1.bool,
    thumbnail: propTypesExports$1.bool,
    zones: propTypesExports$1.bool
  }),
  center: propTypesExports$1.arrayOf(propTypesExports$1.number),
  deviceSymbols: propTypesExports$1.shape({
    root: propTypesExports$1.bool,
    region: propTypesExports$1.bool,
    cluster: propTypesExports$1.bool,
    market: propTypesExports$1.bool,
    venue: propTypesExports$1.bool,
    building: propTypesExports$1.bool,
    level: propTypesExports$1.bool
  }),
  heatmapData: propTypesExports$1.object,
  enableRouterUpdate: propTypesExports$1.bool
};
MapDataProvider.defaultProps = {
  children: null,
  initialHierarchy: {},
  defaultView: "market",
  defaultNavigation: {
    // region: 'market',
    market: "venue",
    // cluster: 'venue',
    venue: "building",
    building: "level"
  },
  disabled: {},
  center: null,
  deviceSymbols: {
    building: true,
    level: true
  },
  heatmapData: null,
  enableRouterUpdate: false
};
const useMapDataProvider = () => React__default.useContext(MapDataContext);
function UseMapDataProvider(props) {
  const {
    onLoad
  } = props;
  const value = useMapDataProvider();
  React__default.useEffect(() => {
    onLoad(value);
  }, [onLoad, value]);
  return null;
}
UseMapDataProvider.propTypes = {
  onLoad: propTypesExports$1.func
};
UseMapDataProvider.defaultProps = {
  onLoad: () => {
  }
};
const containerStyle$1 = {
  flex: 1,
  justifyContent: "center",
  width: "100%",
  height: "100%",
  position: "relative",
  left: "0px",
  top: "0px"
};
const TILES = {
  light: "mapbox://styles/c3spectrainc/clyim2meo00ze01qp0e41571e",
  dark: "mapbox://styles/c3spectrainc/clyim1w9x00zi01nwgn86d6nq"
};
const defaultCameraProps$1 = {
  bearing: 0,
  zoom: 15.4
};
function SaiMapProvider(props) {
  const {
    center: center2,
    cameraProps: cameraProps2 = defaultCameraProps$1,
    recenterCounter,
    id,
    children,
    designer,
    env: clientEnv,
    activeTheme,
    configProps,
    ...restProps
  } = props;
  const [cameraResetEnabled, setCameraResetEnabled] = React__default.useState(true);
  const {
    getAccessToken: getSaiAccessToken
  } = useSaiSession(clientEnv == null ? void 0 : clientEnv.getSaiSession);
  const {
    saiPostgresEndpoint,
    getSaiSession,
    ...restEnv
  } = React__default.useMemo(() => ({
    ...clientEnv || {},
    activeTheme,
    getSaiAccessToken
  }), [activeTheme, clientEnv, getSaiAccessToken]);
  const tilesetUrl = TILES[activeTheme];
  const transformRequestImpl = React__default.useCallback((url2, resourceType) => {
    if (saiPostgresEndpoint && getSaiSession && resourceType === "Tile" && url2.startsWith(`${saiPostgresEndpoint}/v2/gis/tiles`)) {
      return {
        url: url2,
        headers: {
          Authorization: `Bearer ${getSaiAccessToken()}`
        }
      };
    }
    return void 0;
  }, [getSaiAccessToken, getSaiSession, saiPostgresEndpoint]);
  const transformRequest = useMutableFunc(transformRequestImpl);
  const env = React__default.useMemo(() => ({
    transformRequest,
    saiPostgresEndpoint,
    getSaiSession,
    ...restEnv
  }), [getSaiSession, restEnv, saiPostgresEndpoint, transformRequest]);
  const mapProps2 = React__default.useMemo(() => ({
    deckgl: {
      enable: true
    }
  }), []);
  React__default.useEffect(() => {
    setCameraResetEnabled(true);
  }, [recenterCounter]);
  React__default.useEffect(() => {
    const DELAY = 1e3;
    setTimeout(() => {
      setCameraResetEnabled(false);
    }, DELAY);
  }, [recenterCounter]);
  if (!id)
    return null;
  return /* @__PURE__ */ jsx("div", { style: containerStyle$1, children: /* @__PURE__ */ jsx(MapConfigProvider, { env, ...configProps || {}, children: /* @__PURE__ */ jsxs(ErrorBoundary, { fallbackRender: null, children: [
    designer && /* @__PURE__ */ jsx(EditorImpl, { id, camera: {
      ...cameraProps2,
      enabled: cameraResetEnabled
    }, center: center2, overlay: true, legacy: false, tiles: tilesetUrl, mapProps: mapProps2, ...restProps, children: /* @__PURE__ */ jsx(ErrorBoundary, { fallbackRender: null, children }) }),
    !designer && /* @__PURE__ */ jsx(DisplayImpl, { id, camera: {
      ...cameraProps2,
      enabled: cameraResetEnabled
    }, center: center2, overlay: true, tiles: tilesetUrl, mapProps: mapProps2, ...restProps, children: /* @__PURE__ */ jsx(ErrorBoundary, { fallbackRender: null, children }) })
  ] }) }) });
}
SaiMapProvider.propTypes = {
  center: propTypesExports$1.array,
  cameraProps: propTypesExports$1.object,
  id: propTypesExports$1.string,
  children: propTypesExports$1.node,
  designer: propTypesExports$1.bool,
  recenterCounter: propTypesExports$1.number,
  env: propTypesExports$1.shape({
    getSaiSession: propTypesExports$1.func,
    saiPostgresEndpoint: propTypesExports$1.string,
    mapboxToken: propTypesExports$1.string,
    cesiumToken: propTypesExports$1.string,
    bingApiKey: propTypesExports$1.string
  }),
  activeTheme: propTypesExports$1.string,
  configProps: propTypesExports$1.object
};
SaiMapProvider.defaultProps = {
  center: null,
  cameraProps: null,
  id: "",
  children: null,
  designer: false,
  recenterCounter: 0,
  env: {},
  activeTheme: "light",
  configProps: null
};
function MapViewController(props) {
  const {
    visibility,
    displayMode: displayMode2,
    hierarchy,
    setDisplayMode: setDisplayModeIn
  } = props;
  const setVisibilityChecker = useViewStore((state) => state.setVisibilityChecker);
  const setDisplayMode = useViewStore((state) => state.setDisplayMode);
  const setActiveVenueId = useViewStore((state) => state.setActiveVenueId);
  const setActiveBuildingId = useViewStore((state) => state.setActiveBuildingId);
  const setActiveLevelId = useViewStore((state) => state.setActiveLevelId);
  const {
    enableVenue,
    enableBuilding,
    enableLevel,
    ...restVisibility
  } = visibility || {};
  React__default.useLayoutEffect(() => {
    if ((hierarchy == null ? void 0 : hierarchy.venueId) && enableVenue) {
      setActiveVenueId(hierarchy.venueId);
    }
    if ((hierarchy == null ? void 0 : hierarchy.buildingId) && enableBuilding) {
      setActiveBuildingId(hierarchy.buildingId);
    }
    if ((hierarchy == null ? void 0 : hierarchy.levelId) && enableLevel) {
      setActiveLevelId(hierarchy.levelId);
    }
  }, [enableBuilding, enableLevel, enableVenue, hierarchy, setActiveBuildingId, setActiveLevelId, setActiveVenueId]);
  const restVisibilityRef = useValueRef(restVisibility);
  React__default.useLayoutEffect(() => {
    setVisibilityChecker((feature2) => {
      const restVisibility2 = restVisibilityRef.current;
      if (!restVisibility2 || !Object.keys(restVisibility2).length) {
        return true;
      }
      if (restVisibility2[feature2.id] || restVisibility2[feature2.properties.id] || restVisibility2[feature2.properties.levelId] || restVisibility2[feature2.properties.buildingId] || restVisibility2[feature2.properties.venueId]) {
        return true;
      }
      return false;
    });
  }, [restVisibilityRef, setVisibilityChecker]);
  const skipChangeRef = React__default.useRef(false);
  React__default.useLayoutEffect(() => {
    if (skipChangeRef.current)
      return;
    setDisplayMode(displayMode2);
  }, [displayMode2, setDisplayMode]);
  const displayModeCurrent = useViewStore((state) => state.displayMode);
  React__default.useLayoutEffect(() => {
    skipChangeRef.current = true;
    setDisplayModeIn == null ? void 0 : setDisplayModeIn(displayModeCurrent);
    setTimeout(() => {
      skipChangeRef.current = false;
    }, 500);
  }, [displayModeCurrent, setDisplayModeIn]);
  return null;
}
MapViewController.propTypes = {
  visibility: propTypesExports$1.object,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  setDisplayMode: propTypesExports$1.func,
  hierarchy: propTypesExports$1.object
};
MapViewController.defaultProps = {
  visibility: null,
  displayMode: "2d",
  setDisplayMode: null,
  hierarchy: null
};
function MapDroppable(props) {
  const {
    data: data2,
    icon,
    disabled,
    card,
    cardOffset
  } = props;
  const {
    token
  } = theme$2.useToken();
  const renderDragCard = React__default.useCallback(() => /* @__PURE__ */ jsxs("div", { style: {
    position: "relative"
  }, children: [
    /* @__PURE__ */ jsx("div", { style: {
      position: "absolute",
      top: 0,
      left: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      width: `128px`,
      height: "30px",
      backgroundColor: "#F5F5F5",
      borderRadius: "4px",
      border: `1px solid ${token.colorPrimaryBorder}`,
      zIndex: 2
    }, children: card || icon }),
    /* @__PURE__ */ jsx("div", { style: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      width: `128px`,
      height: "30px",
      backgroundColor: "#F5F5F5b3",
      borderRadius: "4px",
      border: `1px solid ${token.colorPrimaryBorder}`,
      top: "5px",
      left: "5px",
      zIndex: 1
    } }),
    /* @__PURE__ */ jsx("div", { style: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "start",
      width: `128px`,
      height: "30px",
      backgroundColor: "#F5F5F5b3",
      borderRadius: "4px",
      border: `1px solid ${token.colorPrimaryBorder}`,
      top: "10px",
      left: "10px",
      zIndex: 0
    } })
  ] }), [card, icon, token.colorPrimaryBorder]);
  const bindDropable = useDragDropItem({
    renderDragCard,
    offset: cardOffset
  });
  const bindProps = React__default.useMemo(() => {
    if (disabled)
      return {};
    return bindDropable(data2) || {};
  }, [bindDropable, data2, disabled]);
  return /* @__PURE__ */ jsx("span", { ...bindProps, disabled, children: /* @__PURE__ */ jsx(Button, { icon, draggable: false, size: "small", type: "text", disabled }) });
}
MapDroppable.propTypes = {
  data: propTypesExports$1.any,
  icon: propTypesExports$1.node,
  disabled: propTypesExports$1.bool,
  card: propTypesExports$1.node,
  cardOffset: propTypesExports$1.object
};
MapDroppable.defaultProps = {
  data: null,
  icon: /* @__PURE__ */ jsx(DragOutlined, {}),
  disabled: false,
  card: null,
  cardOffset: null
};
const PIN_3D_PATH = "/common/assets/pin3d.glb";
const PIXEL_RATIO = 3;
function DeviceSymbolsInternal(props) {
  const {
    id = "sai-device-symbols",
    symbols,
    displayMode: displayMode2,
    height: defaultHeight,
    minZoom,
    maxZoom,
    textMinZoom
  } = props;
  const invisibleFlags = useViewStore((state) => state.invisibleFlags);
  const {
    isLoading,
    data: importResult,
    error: error2
  } = useApi({
    client: S3Util,
    method: "importFile",
    args: [PIN_3D_PATH, "dataUrl"],
    queryProps: {
      enabled: displayMode2 === "3d"
    }
  });
  const data2 = React__default.useMemo(() => MiscUtil.convertToGeoJson(symbols, "sai-device-symbol-"), [symbols]);
  const {
    deviceTypes
  } = useDeviceTypes();
  const translation = React__default.useMemo(() => [0, 0, ["number", ["get", "deviceHeight"], defaultHeight]], [defaultHeight]);
  if (!data2)
    return null;
  if (displayMode2 === "3d") {
    if (isLoading || error2 || !(importResult == null ? void 0 : importResult[0]))
      return null;
    const dataUrl = importResult[0];
    return /* @__PURE__ */ jsx(GeojsonModelLayer, { id, modelId: dataUrl, data: data2, modelScale: [1, 1, 1], modelColor: "#FFFFFF", colorMixIntensity: 1, modelTranslation: translation });
  }
  return /* @__PURE__ */ jsx(AccessPoints, { id, features: data2, minZoom, maxZoom, textMinZoom, clusterZoom: 16, cluster: false, iconSize: 1 / PIXEL_RATIO, deviceTypes, showText: !(invisibleFlags == null ? void 0 : invisibleFlags.includes("apChannelsName")) });
}
DeviceSymbolsInternal.propTypes = {
  symbols: propTypesExports$1.oneOfType([propTypesExports$1.array, propTypesExports$1.object]),
  id: propTypesExports$1.string,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  height: propTypesExports$1.number,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  textMinZoom: propTypesExports$1.number
};
DeviceSymbolsInternal.defaultProps = {
  id: "sai-device-symbols",
  symbols: null,
  displayMode: "2d",
  height: 0,
  minZoom: 0,
  maxZoom: 24,
  textMinZoom: 20
};
function DeviceSymbols(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(DeviceSymbolsInternal, { ...props }) });
}
const BANDS = ["2.4ghz", "5ghz", "6ghz"];
function StatusSymbols(props) {
  const {
    id,
    symbols
  } = props;
  const invisibleFlags = useViewStore((state) => state.invisibleFlags);
  const data2 = React__default.useMemo(() => MiscUtil.convertToGeoJson(symbols, "sai-status-symbol-"), [symbols]);
  const customIconZoomedIn = React__default.useCallback((feature2) => {
    const isInvisible = BANDS.some((band) => {
      const isInvisible2 = invisibleFlags == null ? void 0 : invisibleFlags.includes(band);
      if (isInvisible2 && typeof feature2.properties[band] !== "undefined") {
        return true;
      }
      return false;
    });
    if (isInvisible)
      return false;
    const isBandInvisible = invisibleFlags.includes("bands");
    return IconUtil.createStatusSymbol({
      enableBands: !isBandInvisible,
      critical: feature2.properties.critical,
      major: feature2.properties.major,
      minor: feature2.properties.minor,
      "2.4ghz": feature2.properties["2.4ghz"],
      "5ghz": feature2.properties["5ghz"],
      "6ghz": feature2.properties["6ghz"],
      inactive1: feature2.properties.inactive1 || 2,
      inactive2: feature2.properties.inactive2 || 4
    }, "3fans");
  }, [invisibleFlags]);
  if (!data2)
    return null;
  return /* @__PURE__ */ jsx(ClusteredSymbols, { id, data: data2, customIcon: customIconZoomedIn, minZoom: 0, maxZoom: 24, clusterZoom: 15, cluster: false }, data2.features.length);
}
StatusSymbols.propTypes = {
  symbols: propTypesExports$1.oneOfType([propTypesExports$1.array, propTypesExports$1.object]),
  id: propTypesExports$1.string
};
StatusSymbols.defaultProps = {
  symbols: null,
  id: "sai-status-symbols"
};
function VectorTiles(props) {
  const {
    id = "sai-vector-tiles",
    type = "fill",
    entityType,
    entitySubType,
    entityId,
    parentId,
    rootEntityId,
    ...restProps
  } = props;
  const saiPostgresEndpoint = useEnvStore((state) => state.env.saiPostgresEndpoint);
  const url2 = React__default.useMemo(() => {
    var _a3;
    const tilesUrl = `${saiPostgresEndpoint}/v2/gis/tiles/entities/{z}/{x}/{y}.mvt`;
    const options2 = {
      entity_type: entityType,
      entity_sub_type: entitySubType,
      entity_id: entityId,
      parent_id: parentId,
      root_entity_id: rootEntityId
    };
    const filter17 = UrlUtil.finalizeOptions(options2 || {});
    if (!filter17)
      return tilesUrl;
    return UrlUtil.addOptionsToUrl(tilesUrl, {
      filters: ((_a3 = Object.keys(filter17)) == null ? void 0 : _a3.length) ? JSON.stringify(filter17) : void 0
    });
  }, [entityType, entitySubType, entityId, parentId, rootEntityId, saiPostgresEndpoint]);
  return /* @__PURE__ */ jsx(
    Tiles2dLayer,
    {
      type,
      url: url2,
      sourceLayer: "default",
      id,
      minZoom: 12,
      colorPropName: "fill",
      opacityPropName: "fill-opacity",
      outlinePropName: "stroke",
      outlineOpacityPropName: "stroke-opacity",
      outlineWidthPropName: "stroke-width",
      textColorPropName: "text-color",
      textOpacityPropName: "text-opacity",
      iconSizePropName: "marker-size",
      iconColorPropName: "marker-color",
      iconUrlPropName: "marker-symbol",
      ...restProps
    }
  );
}
VectorTiles.propTypes = {
  id: propTypesExports$1.string,
  type: propTypesExports$1.string,
  entityType: propTypesExports$1.string,
  entitySubType: propTypesExports$1.string,
  entityId: propTypesExports$1.string,
  parentId: propTypesExports$1.string,
  rootEntityId: propTypesExports$1.string
};
VectorTiles.defaultProps = {
  id: "sai-vector-tiles",
  type: "fill",
  entityType: "undefined",
  entitySubType: "default",
  entityId: "default",
  parentId: null,
  rootEntityId: null
};
function EntityIconInternal(props) {
  const {
    id,
    minZoom,
    maxZoom,
    entityType,
    iconSize: iconSize2,
    ...restProps
  } = props;
  const {
    map: map5
  } = useMapbox();
  const loadIcon = React__default.useCallback(async (type) => {
    const loc = IconUrls[type];
    if (loc) {
      const svg = await fetch(loc);
      const svgString = await svg.text();
      const url2 = ImageUtil$1.svgToUri(svgString, true);
      const image = await ImageUtil$1.imageFromUrl(url2);
      const canvas2 = document.createElement("canvas");
      canvas2.width = iconSize2;
      canvas2.height = iconSize2;
      const context2 = canvas2.getContext("2d", {
        alpha: true
      });
      context2.drawImage(image, 0, 0, canvas2.width, canvas2.height);
      const iconId2 = IconUtil.loadImageCanvasOnMap(map5, canvas2, `sai-entity-icon-${type}`);
      return iconId2;
    }
    return null;
  }, [map5, iconSize2]);
  const {
    data: iconId,
    isLoading,
    error: error2
  } = useQuery({
    queryFn: () => loadIcon(entityType),
    queryKey: ["entity-icon", entityType, iconSize2],
    enabled: !!map5,
    placeholderData: null
  });
  if (!iconId || isLoading || error2)
    return null;
  return /* @__PURE__ */ jsx(VectorTiles, { type: "symbol", id, entityType, entitySubType: "entityIcon", minZoom, maxZoom, iconId, ...restProps }, `${id}${minZoom}${maxZoom}-symbol`);
}
EntityIconInternal.propTypes = {
  id: propTypesExports$1.string,
  entityType: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  iconSize: propTypesExports$1.number
};
EntityIconInternal.defaultProps = {
  id: void 0,
  minZoom: void 0,
  maxZoom: void 0,
  entityType: void 0,
  iconSize: 20
};
function EntityIcon(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(EntityIconInternal, { ...props }) });
}
function Footprint(props) {
  const {
    id,
    opacity,
    outlineOpacity,
    minZoom,
    maxZoom,
    outlineDashArray,
    entityType,
    enableIcon,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(VectorTiles, { type: "fill", id, opacity, minZoom, maxZoom, entityType, ...restProps }, `${id}${minZoom}${maxZoom}-fill`),
    /* @__PURE__ */ jsx(VectorTiles, { type: "line", id, opacity: outlineOpacity, minZoom, maxZoom, outlineDashArray, entityType, ...restProps }, `${id}${minZoom}${maxZoom}-line`),
    enableIcon && /* @__PURE__ */ jsx(EntityIcon, { id: `${id}-entity-icon`, minZoom, maxZoom, entityType, ...restProps })
  ] });
}
Footprint.propTypes = {
  id: propTypesExports$1.string,
  opacity: propTypesExports$1.number,
  outlineOpacity: propTypesExports$1.number,
  entityType: propTypesExports$1.string,
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number,
  outlineDashArray: propTypesExports$1.array,
  enableIcon: propTypesExports$1.bool
};
Footprint.defaultProps = {
  id: null,
  opacity: void 0,
  outlineOpacity: void 0,
  minZoom: void 0,
  maxZoom: void 0,
  outlineDashArray: void 0,
  entityType: void 0,
  enableIcon: true
};
function ModelLoaderInternal(props) {
  const {
    documentUrl,
    id,
    name: name2,
    azimuth,
    longitude,
    latitude,
    tilt,
    head
  } = props;
  const extension = React__default.useMemo(() => {
    var _a3, _b3;
    return (_b3 = (_a3 = name2 == null ? void 0 : name2.split(".")) == null ? void 0 : _a3.pop()) == null ? void 0 : _b3.toLowerCase();
  }, [name2]);
  const [data2, setData6] = React__default.useState(null);
  const {
    isLoading,
    data: importResult,
    error: error2
  } = useApi({
    client: S3Util,
    method: "importFile",
    args: [documentUrl, extension === "ion" || extension === "json" ? "text" : "dataUrl"]
  });
  const saiPostgresEndpoint = useEnvStore((state) => state.env.saiPostgresEndpoint);
  const {
    session
  } = useSaiSession();
  const accessToken = session == null ? void 0 : session.accessToken;
  React__default.useLayoutEffect(() => {
    var _a3;
    let type = extension == null ? void 0 : extension.toUpperCase();
    if (type === "GLB")
      type = "GLTF";
    if (type === "JSON")
      type = "3DTILES";
    if (!["GLTF", "DXF", "ION", "3DTILES"].includes(type))
      return;
    if (!(importResult == null ? void 0 : importResult[0]))
      return;
    if (type === "3DTILES") {
      const json = JSON.parse(importResult[0]);
      if (json) {
        setData6({
          id,
          type,
          url: `${saiPostgresEndpoint}/v2/gis/files/proxy/${documentUrl}`
        });
      }
    } else if (type === "ION") {
      const assetId = (_a3 = JSON.parse(importResult[0])) == null ? void 0 : _a3.id;
      if (assetId) {
        setData6({
          id: assetId,
          type
        });
      }
    } else {
      setData6({
        id,
        type,
        center: [Number(longitude), Number(latitude)],
        // scale: [1, 1, 1],
        scale: [1.35, 1.35, 1.35],
        // TODO: fix this
        dip: Number(tilt || 0),
        head: Number(head || 0),
        azimuth: Number(azimuth || 0),
        sourceFile: {
          data: importResult[0],
          dataType: "dataUrl",
          extension
        }
      });
    }
  }, [extension, importResult, id, longitude, latitude, tilt, head, azimuth, documentUrl, saiPostgresEndpoint]);
  const extra = React__default.useMemo(() => {
    if ((data2 == null ? void 0 : data2.type) === "ION")
      return {
        version: "1.1"
      };
    if ((data2 == null ? void 0 : data2.type) === "3DTILES")
      return {
        version: "1.1",
        token: accessToken
      };
    return {
      // enableAuto3dTiles: false,
      // enableTransform: false,
      // recenterOnMass: false,
    };
  }, [accessToken, data2 == null ? void 0 : data2.type]);
  if (!data2 || error2 || isLoading)
    return null;
  return /* @__PURE__ */ jsx(CadLayer, { data: data2, ...extra }, id);
}
ModelLoaderInternal.propTypes = {
  documentUrl: propTypesExports$1.string,
  id: propTypesExports$1.string,
  name: propTypesExports$1.string,
  azimuth: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  longitude: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  latitude: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  tilt: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  head: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
};
ModelLoaderInternal.defaultProps = {
  documentUrl: "",
  id: "",
  name: "",
  azimuth: 0,
  longitude: 0,
  latitude: 0,
  tilt: 0,
  head: 0
};
function ModelLoader(props) {
  return /* @__PURE__ */ jsx(React__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(ModelLoaderInternal, { ...props }) });
}
function LayerTreeSelect(props) {
  const {
    enable: enable4,
    placement,
    data: data2,
    activeView,
    loading: loading2,
    error: error2,
    value,
    hierarchy,
    onChange: onNavigateIn,
    marginHorizontal,
    marginVertical,
    width,
    // height,
    containerId
  } = props;
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const isSpecificMarket = activeView === "market" && value;
  const isSpecificVenue = activeView === "venue" && value;
  const isSpecificBuilding = activeView === "building" && value;
  const isSpecificLevel = activeView === "level" && value;
  const isRoot = !isSpecificMarket && !isSpecificVenue && !isSpecificBuilding && !isSpecificLevel;
  const renderTitle = useCallback((strTitle, icon) => {
    let title = strTitle;
    if (searchValue && strTitle) {
      const index2 = strTitle.toLowerCase().indexOf(searchValue);
      if (index2 > -1) {
        const beforeStr = strTitle.substring(0, index2);
        const searchedStr = strTitle.substring(index2, index2 + searchValue.length);
        const afterStr = strTitle.slice(index2 + searchValue.length);
        title = /* @__PURE__ */ jsxs("span", { children: [
          /* @__PURE__ */ jsx(Typography.Text, { children: beforeStr }),
          /* @__PURE__ */ jsx(Typography.Text, { mark: true, children: searchedStr }),
          /* @__PURE__ */ jsx(Typography.Text, { children: afterStr })
        ] });
      } else {
        title = /* @__PURE__ */ jsx("span", { children: strTitle });
      }
    }
    if (!icon)
      return title;
    return /* @__PURE__ */ jsxs(Space, { direction: "horizontal", children: [
      icon,
      title
    ] });
  }, [searchValue]);
  const {
    treeData,
    navigateActions
  } = useMemo(() => {
    var _a3, _b3, _c2, _d2, _e2, _f3, _g;
    if (!enable4 || error2 || !data2)
      return {
        treeData: [],
        navigateActions: {}
      };
    let childData = null;
    let parentData = null;
    let parentIcon = null;
    let childIcon = null;
    let parentKey = null;
    let childKey = null;
    if (isRoot) {
      childData = (_a3 = data2.root) == null ? void 0 : _a3.list;
      parentIcon = /* @__PURE__ */ jsx(Icons.Market, { style: {
        color: "transparent"
      } });
      childIcon = /* @__PURE__ */ jsx(BuildOutlined, {});
      parentKey = "marketId";
      childKey = "marketId";
    } else if (isSpecificMarket) {
      childData = (_b3 = data2.market) == null ? void 0 : _b3.list;
      parentData = (_c2 = data2.market) == null ? void 0 : _c2.object;
      parentIcon = /* @__PURE__ */ jsx(Icons.Market, { style: {
        color: "transparent"
      } });
      childIcon = /* @__PURE__ */ jsx(BuildOutlined, {});
      parentKey = "marketId";
      childKey = "venueId";
    } else if (isSpecificVenue) {
      childData = (_d2 = data2.venue) == null ? void 0 : _d2.list;
      parentData = (_e2 = data2.venue) == null ? void 0 : _e2.object;
      parentIcon = /* @__PURE__ */ jsx(BuildOutlined, {});
      childIcon = /* @__PURE__ */ jsx(Icons.Building, { style: {
        color: "transparent"
      } });
      parentKey = "venueId";
      childKey = "buildingId";
    } else if (isSpecificBuilding || isSpecificLevel) {
      childData = (_f3 = data2.building) == null ? void 0 : _f3.list;
      parentData = (_g = data2.building) == null ? void 0 : _g.object;
      parentIcon = /* @__PURE__ */ jsx(Icons.Building, { style: {
        color: "transparent"
      } });
      childIcon = /* @__PURE__ */ jsx(Icons.Level, { style: {
        color: "transparent"
      } });
      parentKey = "buildingId";
      childKey = "levelId";
    }
    const isLeaf = isSpecificBuilding || isSpecificLevel;
    const navigateActions2 = {};
    const children = childData == null ? void 0 : childData.map((child) => {
      navigateActions2[child.id] = {
        [parentKey]: (parentData == null ? void 0 : parentData.id) || (isRoot ? "root" : ""),
        [childKey]: child.id
      };
      const obj = {
        title: renderTitle(child.name, isLeaf ? null : childIcon),
        key: child.id,
        value: child.id,
        icon: isLeaf ? childIcon : /* @__PURE__ */ jsx(CaretRightOutlined, {})
      };
      return obj;
    });
    let treeData2 = children;
    if (parentData) {
      navigateActions2[parentData.id] = {
        [parentKey]: null,
        [childKey]: null
      };
      const obj = {
        title: renderTitle(parentData.name),
        key: parentData.id,
        value: parentData.id,
        icon: parentIcon,
        children
      };
      treeData2 = [obj];
    }
    return {
      treeData: treeData2,
      navigateActions: navigateActions2
    };
  }, [data2, enable4, error2, isSpecificBuilding, isSpecificLevel, isSpecificVenue, isSpecificMarket, isRoot, renderTitle]);
  React__default.useEffect(() => {
    if (!navigateActions)
      setExpandedKeys([]);
    else
      setExpandedKeys(Object.keys(navigateActions));
    setAutoExpandParent(true);
  }, [navigateActions]);
  const selectedKeys = useMemo(() => {
    if (!hierarchy)
      return [];
    const {
      marketId,
      venueId,
      buildingId,
      levelId
    } = hierarchy;
    if (isSpecificMarket && marketId)
      return [marketId];
    if (isSpecificVenue && venueId)
      return [venueId];
    if (isSpecificBuilding && buildingId)
      return [buildingId];
    if (isSpecificLevel && levelId)
      return [levelId];
    return [];
  }, [hierarchy, isSpecificBuilding, isSpecificLevel, isSpecificVenue, isSpecificMarket]);
  const onSelect = useCallback((_2, event) => {
    const {
      node
    } = event || {};
    if (!(node == null ? void 0 : node.key))
      return;
    const id = node.key;
    const action = navigateActions[id];
    onNavigateIn == null ? void 0 : onNavigateIn(action || {});
  }, [navigateActions, onNavigateIn]);
  const onExpand = React__default.useCallback((newExpandedKeys) => {
    setExpandedKeys(newExpandedKeys);
    setAutoExpandParent(false);
  }, []);
  const onChange = React__default.useCallback((e3) => {
    const {
      value: value2
    } = e3.target;
    setSearchValue((value2 == null ? void 0 : value2.toLowerCase()) || "");
    setAutoExpandParent(true);
  }, []);
  if (!enable4)
    return null;
  return createPortal(/* @__PURE__ */ jsxs(
    CollapsibleOverlayPanel,
    {
      placement,
      width,
      height: "auto",
      marginHorizontal,
      marginVertical,
      title: "Markets",
      children: [
        error2 && /* @__PURE__ */ jsx(Empty, { description: "Error occurred", image: Empty.PRESENTED_IMAGE_SIMPLE }),
        !error2 && !loading2 && !(treeData == null ? void 0 : treeData.length) && /* @__PURE__ */ jsx(Empty, { description: "No data", image: Empty.PRESENTED_IMAGE_SIMPLE }),
        !error2 && treeData && /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
          width: "100%",
          height: "100%"
        }, children: [
          /* @__PURE__ */ jsx(Input$2.Search, { placeholder: "Search", onChange, allowClear: true }),
          /* @__PURE__ */ jsx(Spin, { spinning: loading2, children: /* @__PURE__ */ jsx(Tree, { style: {
            width: "100%"
          }, treeData, placeholder: "Search", treeExpandedKeys: value ? [value] : [], value, defaultExpandedKeys: expandedKeys, expandedKeys, autoExpandParent, defaultExpandAll: true, onSelect, showIcon: true, size: "middle", onExpand, switcherIcon: /* @__PURE__ */ jsx(CaretDownOutlined, {}), selectedKeys }) })
        ] })
      ]
    }
  ), document.getElementById(containerId) || document.body, `portal-entity-tree-selector${containerId}`);
}
LayerTreeSelect.propTypes = {
  enable: propTypesExports$1.bool,
  value: propTypesExports$1.string,
  onChange: propTypesExports$1.func,
  data: propTypesExports$1.object,
  activeView: propTypesExports$1.oneOf(["root", "market", "venue", "building", "level"]),
  loading: propTypesExports$1.bool,
  error: propTypesExports$1.bool,
  containerId: propTypesExports$1.string,
  width: propTypesExports$1.number,
  // height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  hierarchy: propTypesExports$1.object
};
LayerTreeSelect.defaultProps = {
  enable: false,
  value: "",
  onChange: null,
  data: null,
  activeView: void 0,
  loading: false,
  error: false,
  containerId: "featuresMapDisplay",
  width: 280,
  // height: 320,
  placement: "top-left",
  hierarchy: void 0,
  marginHorizontal: 16,
  marginVertical: 16
};
function LayerDropdownSelect(props) {
  const {
    enable: enable4,
    placement,
    data: data2,
    loading: loading2,
    error: error2,
    onChange: onApply,
    hierarchy,
    onSelect,
    onClear,
    marginHorizontal,
    marginVertical,
    width,
    height,
    containerId
  } = props;
  const [open2, setOpen] = React__default.useState(false);
  const [selectedValues, setSelectedValues] = React__default.useState({});
  const getPopoverPlacement = React__default.useCallback((placement2) => {
    switch (placement2) {
      case "top-left":
        return "bottomLeft";
      case "top-right":
        return "bottomRight";
      case "bottom-left":
        return "topLeft";
      case "bottom-right":
        return "topRight";
      default:
        return "bottomLeft";
    }
  }, []);
  const optionsByViews = React__default.useMemo(() => {
    if (!enable4 || error2)
      return [];
    return data2.map((filter17) => ({
      key: filter17 == null ? void 0 : filter17.key,
      label: filter17 == null ? void 0 : filter17.label,
      options: filter17 == null ? void 0 : filter17.options
    }));
  }, [data2, enable4, error2]);
  const handleSelectChange = React__default.useCallback((key, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [`${key}Id`]: value
    }));
  }, []);
  React__default.useEffect(() => {
    setSelectedValues(hierarchy);
  }, [hierarchy]);
  React__default.useEffect(() => {
    if (selectedValues) {
      onSelect == null ? void 0 : onSelect(selectedValues);
    }
  }, [selectedValues, onSelect]);
  const handleClear = React__default.useCallback(() => {
    setSelectedValues({});
    onClear == null ? void 0 : onClear(null);
    onApply == null ? void 0 : onApply(null);
  }, [onApply, onClear]);
  const handleApply = React__default.useCallback(() => {
    if (!selectedValues) {
      onApply == null ? void 0 : onApply(null);
      setOpen(false);
      return;
    }
    onApply == null ? void 0 : onApply(selectedValues);
    setOpen(false);
  }, [onApply, selectedValues]);
  if (!enable4)
    return null;
  return createPortal(/* @__PURE__ */ jsxs(OverlayPanel, { width, height, placement, marginHorizontal, marginVertical, style: {
    position: "relative"
  }, children: [
    error2 && /* @__PURE__ */ jsx(Empty, { description: "Error occurred", image: Empty.PRESENTED_IMAGE_SIMPLE }),
    !error2 && !loading2 && !(data2 == null ? void 0 : data2.length) && /* @__PURE__ */ jsx(Empty, { description: "No data", image: Empty.PRESENTED_IMAGE_SIMPLE }),
    !error2 && data2 && /* @__PURE__ */ jsx(Space, { style: {
      position: "absolute",
      inset: 0,
      display: "flex",
      justifyContent: placement.includes("right") ? "flex-end" : "flex-start",
      alignItems: placement.includes("bottom") ? "flex-end" : "flex-start"
    }, children: /* @__PURE__ */ jsx(Popover, { trigger: "click", arrow: false, placement: getPopoverPlacement(placement), open: open2, onOpenChange: setOpen, content: /* @__PURE__ */ jsx(Card, { style: {
      width
    }, children: /* @__PURE__ */ jsx(Spin, { spinning: loading2, children: /* @__PURE__ */ jsxs(Space, { direction: "vertical", size: "middle", style: {
      width: "100%"
    }, children: [
      optionsByViews.map(({
        key,
        label,
        options: options2
      }) => /* @__PURE__ */ jsx(Select$1, { placeholder: label, value: selectedValues[`${key}Id`], onChange: (val) => handleSelectChange(key, val), allowClear: true, showSearch: true, filterOption: false, style: {
        width: "100%"
      }, options: options2, notFoundContent: /* @__PURE__ */ jsx(Empty, { description: "No data", image: Empty.PRESENTED_IMAGE_SIMPLE }), suffixIcon: selectedValues[`${key}Id`] ? /* @__PURE__ */ jsx(CheckCircleFilled, { style: {
        color: "#52c41a"
      } }) : /* @__PURE__ */ jsx(CaretDownOutlined, {}) }, key)),
      /* @__PURE__ */ jsxs(Space, { align: "center", style: {
        width: "100%",
        justifyContent: "space-between"
      }, children: [
        /* @__PURE__ */ jsx(Button, { onClick: handleClear, children: "Clear all" }),
        /* @__PURE__ */ jsx(Button, { type: "primary", onClick: handleApply, children: "Apply" })
      ] })
    ] }) }) }), children: /* @__PURE__ */ jsx(Button, { size: "large", icon: /* @__PURE__ */ jsx(FilterOutlined, { style: {
      marginRight: "10px",
      fontSize: "12.5px"
    } }), onClick: () => setOpen(!open2), children: "Filter" }) }) })
  ] }), document.getElementById(containerId) || document.body);
}
LayerDropdownSelect.propTypes = {
  enable: propTypesExports$1.bool,
  onChange: propTypesExports$1.func,
  onSelect: propTypesExports$1.func,
  onClear: propTypesExports$1.func,
  data: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    key: propTypesExports$1.string.isRequired,
    label: propTypesExports$1.string.isRequired,
    options: propTypesExports$1.arrayOf(propTypesExports$1.object)
  })),
  loading: propTypesExports$1.bool,
  error: propTypesExports$1.bool,
  containerId: propTypesExports$1.string,
  hierarchy: propTypesExports$1.object,
  width: propTypesExports$1.number,
  height: propTypesExports$1.number,
  placement: propTypesExports$1.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  marginHorizontal: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
  marginVertical: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
};
LayerDropdownSelect.defaultProps = {
  enable: false,
  onChange: null,
  onSelect: null,
  onClear: null,
  data: [],
  loading: false,
  error: false,
  containerId: "featuresMapDisplay",
  hierarchy: void 0,
  width: 200,
  height: 500,
  placement: "top-right",
  marginHorizontal: 16,
  marginVertical: 16
};
function VectorHeatmap(props) {
  const {
    id,
    minZoom,
    valuePropName,
    searchParams,
    type,
    ...restProps
  } = props;
  const saiPostgresEndpoint = useEnvStore((state) => state.env.saiPostgresEndpoint);
  const url2 = React__default.useMemo(() => {
    var _a3;
    const tilesUrl = `${saiPostgresEndpoint}/v2/gis/tiles/aggregates/{z}/{x}/{y}.mvt`;
    const options2 = UrlUtil.finalizeOptions(searchParams || {});
    if (!options2)
      return tilesUrl;
    const {
      result_type,
      ...filters
    } = options2;
    return UrlUtil.addOptionsToUrl(tilesUrl, {
      // eslint-disable-next-line camelcase
      result_type,
      filters: ((_a3 = Object.keys(filters)) == null ? void 0 : _a3.length) ? JSON.stringify(filters) : void 0
    });
  }, [saiPostgresEndpoint, searchParams]);
  return /* @__PURE__ */ jsx(Tiles2dLayer, { type, url: url2, minZoom, id, sourceLayer: "default", valuePropName, ...restProps });
}
VectorHeatmap.propTypes = {
  id: propTypesExports$1.string,
  type: propTypesExports$1.oneOf(["heatmap", "heatmapfill", "h3map"]),
  minZoom: propTypesExports$1.number,
  valuePropName: propTypesExports$1.string,
  searchParams: propTypesExports$1.object
};
VectorHeatmap.defaultProps = {
  id: "heatmapDefaultLayerId",
  type: "heatmap",
  minZoom: 12,
  valuePropName: "defaultPropName",
  searchParams: {}
};
function VenuePathUpdater(props) {
  const {
    prefix,
    enabled
  } = props;
  const activeVenueId = useViewStore((state) => state.activeVenueId);
  const updatePathname = React__default.useCallback((id) => {
    let path2 = prefix;
    if (id) {
      path2 = `${prefix}/v/${id}`;
    }
    window.history.pushState({}, "", path2);
  }, [prefix]);
  React__default.useLayoutEffect(() => {
    if (enabled) {
      updatePathname(activeVenueId || void 0);
    } else {
      updatePathname();
    }
  }, [activeVenueId, enabled, updatePathname]);
  return null;
}
VenuePathUpdater.propTypes = {
  prefix: propTypesExports$1.string,
  enabled: propTypesExports$1.bool
};
VenuePathUpdater.defaultProps = {
  prefix: "/",
  enabled: true
};
function VectorTerritory(props) {
  const {
    id,
    searchParams,
    type,
    ...restProps
  } = props;
  const saiPostgresEndpoint = useEnvStore((state) => state.env.saiPostgresEndpoint);
  const url2 = React__default.useMemo(() => {
    var _a3;
    const tilesUrl = `${saiPostgresEndpoint}/v2/gis/tiles/territories/{z}/{x}/{y}.mvt`;
    const options2 = UrlUtil.finalizeOptions(searchParams || {});
    if (!options2)
      return tilesUrl;
    return UrlUtil.addOptionsToUrl(tilesUrl, {
      filters: ((_a3 = Object.keys(options2)) == null ? void 0 : _a3.length) ? JSON.stringify(options2) : void 0
    });
  }, [saiPostgresEndpoint, searchParams]);
  return /* @__PURE__ */ jsx(Tiles2dLayer, { type, url: url2, sourceLayer: "default", id, outlineColor: "#63A4FF", ...restProps });
}
VectorTerritory.propTypes = {
  id: propTypesExports$1.string,
  type: propTypesExports$1.oneOf(["line", "polygon"]),
  searchParams: propTypesExports$1.object
};
VectorTerritory.defaultProps = {
  id: "terriroties",
  type: "line",
  searchParams: {}
};
const COLOR_MAPS = {
  multi: [[255, 255, 178, 0], [254, 217, 118, 155], [254, 178, 76, 155], [253, 141, 60, 155], [240, 59, 32, 155], [189, 0, 38, 155]],
  single: [[22, 119, 255, 0], [22, 119, 255, 50], [22, 119, 255, 90], [22, 119, 255, 128], [22, 119, 255, 216]]
};
const COLOR_LEGENDS = {
  multi: [{
    name: "low",
    color: "#FFFFB2"
  }, {
    name: "high",
    color: "#BD0026"
  }],
  single: [{
    name: "low",
    color: "#dfe8f6"
  }, {
    name: "high",
    color: "#327de7"
  }]
};
function Heatmaps(props) {
  const {
    id = "sai-heatmap-",
    displayMode: displayMode2,
    enable: enable4 = true,
    data: dataIn,
    valuePropName = "heatmapIntensity",
    colorMap = "single",
    minValue,
    maxValue,
    minZoom = 14,
    maxZoom = 24,
    ...restProps
  } = props;
  const [transition2, setTransition] = React__default.useState(false);
  const type = React__default.useMemo(() => typeof dataIn === "object" && !!dataIn ? "geojson" : "vector", [dataIn]);
  const data2 = React__default.useMemo(() => {
    if (type === "vector")
      return dataIn;
    return MiscUtil.convertToGeoJson(dataIn, id);
  }, [dataIn, id, type]);
  const colorKey = colorMap || "single";
  const colorRange = COLOR_MAPS[colorMap];
  React__default.useEffect(() => {
    setTransition(true);
    setTimeout(() => {
      setTransition(false);
    }, 50);
  }, [colorKey]);
  if (!enable4 || transition2 || displayMode2 !== "2d")
    return null;
  if (type === "vector") {
    return /* @__PURE__ */ jsx(VectorHeatmap, { id, valuePropName, minZoom, maxZoom, colorMap: colorRange ? void 0 : colorMap, colorRange, minValue, maxValue, ...restProps }, colorKey);
  }
  if (!data2)
    return null;
  return /* @__PURE__ */ jsx(Heatmap, { id, data: data2, valuePropName, minZoom, maxZoom, colorRange, ...restProps }, colorKey);
}
Heatmaps.propTypes = {
  data: propTypesExports$1.any,
  id: propTypesExports$1.string,
  enable: propTypesExports$1.bool,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  valuePropName: propTypesExports$1.string,
  colorMap: propTypesExports$1.oneOf(["single", "multi"]),
  minValue: propTypesExports$1.number,
  // applicable only to vector type
  maxValue: propTypesExports$1.number,
  // applicable only to vector type
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number
};
Heatmaps.defaultProps = {
  data: null,
  id: "sai-heatmap-",
  enable: false,
  displayMode: "2d",
  valuePropName: "heatmapIntensity",
  colorMap: "single",
  minValue: void 0,
  // applicable only to vector type
  maxValue: void 0,
  // applicable only to vector type
  minZoom: 14,
  maxZoom: 24
};
Heatmaps.COLOR_LEGENDS = COLOR_LEGENDS;
Heatmaps.COLOR_MAPS = COLOR_MAPS;
var customParseFormatExports = {};
var customParseFormat$1 = {
  get exports() {
    return customParseFormatExports;
  },
  set exports(v5) {
    customParseFormatExports = v5;
  }
};
(function(module2, exports2) {
  !function(e3, t2) {
    module2.exports = t2();
  }(commonjsGlobal$1, function() {
    var e3 = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, t2 = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n2 = /\d/, r2 = /\d\d/, i2 = /\d\d?/, o2 = /\d*[^-_:/,()\s\d]+/, s2 = {}, a2 = function(e4) {
      return (e4 = +e4) + (e4 > 68 ? 1900 : 2e3);
    };
    var f2 = function(e4) {
      return function(t3) {
        this[e4] = +t3;
      };
    }, h2 = [/[+-]\d\d:?(\d\d)?|Z/, function(e4) {
      (this.zone || (this.zone = {})).offset = function(e5) {
        if (!e5)
          return 0;
        if ("Z" === e5)
          return 0;
        var t3 = e5.match(/([+-]|\d\d)/g), n3 = 60 * t3[1] + (+t3[2] || 0);
        return 0 === n3 ? 0 : "+" === t3[0] ? -n3 : n3;
      }(e4);
    }], u2 = function(e4) {
      var t3 = s2[e4];
      return t3 && (t3.indexOf ? t3 : t3.s.concat(t3.f));
    }, d2 = function(e4, t3) {
      var n3, r3 = s2.meridiem;
      if (r3) {
        for (var i3 = 1; i3 <= 24; i3 += 1)
          if (e4.indexOf(r3(i3, 0, t3)) > -1) {
            n3 = i3 > 12;
            break;
          }
      } else
        n3 = e4 === (t3 ? "pm" : "PM");
      return n3;
    }, c2 = { A: [o2, function(e4) {
      this.afternoon = d2(e4, false);
    }], a: [o2, function(e4) {
      this.afternoon = d2(e4, true);
    }], Q: [n2, function(e4) {
      this.month = 3 * (e4 - 1) + 1;
    }], S: [n2, function(e4) {
      this.milliseconds = 100 * +e4;
    }], SS: [r2, function(e4) {
      this.milliseconds = 10 * +e4;
    }], SSS: [/\d{3}/, function(e4) {
      this.milliseconds = +e4;
    }], s: [i2, f2("seconds")], ss: [i2, f2("seconds")], m: [i2, f2("minutes")], mm: [i2, f2("minutes")], H: [i2, f2("hours")], h: [i2, f2("hours")], HH: [i2, f2("hours")], hh: [i2, f2("hours")], D: [i2, f2("day")], DD: [r2, f2("day")], Do: [o2, function(e4) {
      var t3 = s2.ordinal, n3 = e4.match(/\d+/);
      if (this.day = n3[0], t3)
        for (var r3 = 1; r3 <= 31; r3 += 1)
          t3(r3).replace(/\[|\]/g, "") === e4 && (this.day = r3);
    }], w: [i2, f2("week")], ww: [r2, f2("week")], M: [i2, f2("month")], MM: [r2, f2("month")], MMM: [o2, function(e4) {
      var t3 = u2("months"), n3 = (u2("monthsShort") || t3.map(function(e5) {
        return e5.slice(0, 3);
      })).indexOf(e4) + 1;
      if (n3 < 1)
        throw new Error();
      this.month = n3 % 12 || n3;
    }], MMMM: [o2, function(e4) {
      var t3 = u2("months").indexOf(e4) + 1;
      if (t3 < 1)
        throw new Error();
      this.month = t3 % 12 || t3;
    }], Y: [/[+-]?\d+/, f2("year")], YY: [r2, function(e4) {
      this.year = a2(e4);
    }], YYYY: [/\d{4}/, f2("year")], Z: h2, ZZ: h2 };
    function l2(n3) {
      var r3, i3;
      r3 = n3, i3 = s2 && s2.formats;
      for (var o3 = (n3 = r3.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t3, n4, r4) {
        var o4 = r4 && r4.toUpperCase();
        return n4 || i3[r4] || e3[r4] || i3[o4].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e4, t4, n5) {
          return t4 || n5.slice(1);
        });
      })).match(t2), a3 = o3.length, f3 = 0; f3 < a3; f3 += 1) {
        var h3 = o3[f3], u3 = c2[h3], d3 = u3 && u3[0], l3 = u3 && u3[1];
        o3[f3] = l3 ? { regex: d3, parser: l3 } : h3.replace(/^\[|\]$/g, "");
      }
      return function(e4) {
        for (var t3 = {}, n4 = 0, r4 = 0; n4 < a3; n4 += 1) {
          var i4 = o3[n4];
          if ("string" == typeof i4)
            r4 += i4.length;
          else {
            var s3 = i4.regex, f4 = i4.parser, h4 = e4.slice(r4), u4 = s3.exec(h4)[0];
            f4.call(t3, u4), e4 = e4.replace(u4, "");
          }
        }
        return function(e5) {
          var t4 = e5.afternoon;
          if (void 0 !== t4) {
            var n5 = e5.hours;
            t4 ? n5 < 12 && (e5.hours += 12) : 12 === n5 && (e5.hours = 0), delete e5.afternoon;
          }
        }(t3), t3;
      };
    }
    return function(e4, t3, n3) {
      n3.p.customParseFormat = true, e4 && e4.parseTwoDigitYear && (a2 = e4.parseTwoDigitYear);
      var r3 = t3.prototype, i3 = r3.parse;
      r3.parse = function(e5) {
        var t4 = e5.date, r4 = e5.utc, o3 = e5.args;
        this.$u = r4;
        var a3 = o3[1];
        if ("string" == typeof a3) {
          var f3 = true === o3[2], h3 = true === o3[3], u3 = f3 || h3, d3 = o3[2];
          h3 && (d3 = o3[2]), s2 = this.$locale(), !f3 && d3 && (s2 = n3.Ls[d3]), this.$d = function(e6, t5, n4, r5) {
            try {
              if (["x", "X"].indexOf(t5) > -1)
                return new Date(("X" === t5 ? 1e3 : 1) * e6);
              var i4 = l2(t5)(e6), o4 = i4.year, s3 = i4.month, a4 = i4.day, f4 = i4.hours, h4 = i4.minutes, u4 = i4.seconds, d4 = i4.milliseconds, c4 = i4.zone, m3 = i4.week, M3 = /* @__PURE__ */ new Date(), Y2 = a4 || (o4 || s3 ? 1 : M3.getDate()), p2 = o4 || M3.getFullYear(), v5 = 0;
              o4 && !s3 || (v5 = s3 > 0 ? s3 - 1 : M3.getMonth());
              var D2, w2 = f4 || 0, g2 = h4 || 0, y2 = u4 || 0, L2 = d4 || 0;
              return c4 ? new Date(Date.UTC(p2, v5, Y2, w2, g2, y2, L2 + 60 * c4.offset * 1e3)) : n4 ? new Date(Date.UTC(p2, v5, Y2, w2, g2, y2, L2)) : (D2 = new Date(p2, v5, Y2, w2, g2, y2, L2), m3 && (D2 = r5(D2).week(m3).toDate()), D2);
            } catch (e7) {
              return /* @__PURE__ */ new Date("");
            }
          }(t4, a3, r4, n3), this.init(), d3 && true !== d3 && (this.$L = this.locale(d3).$L), u3 && t4 != this.format(a3) && (this.$d = /* @__PURE__ */ new Date("")), s2 = {};
        } else if (a3 instanceof Array)
          for (var c3 = a3.length, m2 = 1; m2 <= c3; m2 += 1) {
            o3[1] = a3[m2 - 1];
            var M2 = n3.apply(this, o3);
            if (M2.isValid()) {
              this.$d = M2.$d, this.$L = M2.$L, this.init();
              break;
            }
            m2 === c3 && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          i3.call(this, e5);
      };
    };
  });
})(customParseFormat$1);
const customParseFormat = customParseFormatExports;
var weekdayExports = {};
var weekday$1 = {
  get exports() {
    return weekdayExports;
  },
  set exports(v5) {
    weekdayExports = v5;
  }
};
(function(module2, exports2) {
  !function(e3, t2) {
    module2.exports = t2();
  }(commonjsGlobal$1, function() {
    return function(e3, t2) {
      t2.prototype.weekday = function(e4) {
        var t3 = this.$locale().weekStart || 0, i2 = this.$W, n2 = (i2 < t3 ? i2 + 7 : i2) - t3;
        return this.$utils().u(e4) ? n2 : this.subtract(n2, "day").add(e4, "day");
      };
    };
  });
})(weekday$1);
const weekday = weekdayExports;
var localeDataExports = {};
var localeData$1 = {
  get exports() {
    return localeDataExports;
  },
  set exports(v5) {
    localeDataExports = v5;
  }
};
(function(module2, exports2) {
  !function(n2, e3) {
    module2.exports = e3();
  }(commonjsGlobal$1, function() {
    return function(n2, e3, t2) {
      var r2 = e3.prototype, o2 = function(n3) {
        return n3 && (n3.indexOf ? n3 : n3.s);
      }, u2 = function(n3, e4, t3, r3, u3) {
        var i3 = n3.name ? n3 : n3.$locale(), a3 = o2(i3[e4]), s3 = o2(i3[t3]), f2 = a3 || s3.map(function(n4) {
          return n4.slice(0, r3);
        });
        if (!u3)
          return f2;
        var d2 = i3.weekStart;
        return f2.map(function(n4, e5) {
          return f2[(e5 + (d2 || 0)) % 7];
        });
      }, i2 = function() {
        return t2.Ls[t2.locale()];
      }, a2 = function(n3, e4) {
        return n3.formats[e4] || function(n4) {
          return n4.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n5, e5, t3) {
            return e5 || t3.slice(1);
          });
        }(n3.formats[e4.toUpperCase()]);
      }, s2 = function() {
        var n3 = this;
        return { months: function(e4) {
          return e4 ? e4.format("MMMM") : u2(n3, "months");
        }, monthsShort: function(e4) {
          return e4 ? e4.format("MMM") : u2(n3, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return n3.$locale().weekStart || 0;
        }, weekdays: function(e4) {
          return e4 ? e4.format("dddd") : u2(n3, "weekdays");
        }, weekdaysMin: function(e4) {
          return e4 ? e4.format("dd") : u2(n3, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(e4) {
          return e4 ? e4.format("ddd") : u2(n3, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(e4) {
          return a2(n3.$locale(), e4);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      r2.localeData = function() {
        return s2.bind(this)();
      }, t2.localeData = function() {
        var n3 = i2();
        return { firstDayOfWeek: function() {
          return n3.weekStart || 0;
        }, weekdays: function() {
          return t2.weekdays();
        }, weekdaysShort: function() {
          return t2.weekdaysShort();
        }, weekdaysMin: function() {
          return t2.weekdaysMin();
        }, months: function() {
          return t2.months();
        }, monthsShort: function() {
          return t2.monthsShort();
        }, longDateFormat: function(e4) {
          return a2(n3, e4);
        }, meridiem: n3.meridiem, ordinal: n3.ordinal };
      }, t2.months = function() {
        return u2(i2(), "months");
      }, t2.monthsShort = function() {
        return u2(i2(), "monthsShort", "months", 3);
      }, t2.weekdays = function(n3) {
        return u2(i2(), "weekdays", null, null, n3);
      }, t2.weekdaysShort = function(n3) {
        return u2(i2(), "weekdaysShort", "weekdays", 3, n3);
      }, t2.weekdaysMin = function(n3) {
        return u2(i2(), "weekdaysMin", "weekdays", 2, n3);
      };
    };
  });
})(localeData$1);
const localeData = localeDataExports;
React__default.createContext();
({ children: PropTypes.node, activeTheme: PropTypes.oneOf(["dark", "light"]), setActiveTheme: PropTypes.func, configProps: PropTypes.object });
({ items: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired, color: PropTypes.string.isRequired })).isRequired, style: PropTypes.object, formatter: PropTypes.func }, { containerStyle: PropTypes.object, style: PropTypes.object, notMerge: PropTypes.bool, tooltip: PropTypes.object, grid: PropTypes.object, legend: PropTypes.object, onEvents: PropTypes.object }), { data: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.number.isRequired, name: PropTypes.string.isRequired, color: PropTypes.string })).isRequired, titleText: PropTypes.string, titleSubtext: PropTypes.string, titlePosition: PropTypes.shape({ left: PropTypes.string, top: PropTypes.string }), tooltipTrigger: PropTypes.oneOf(["item", "axis", "none"]), legendOrient: PropTypes.oneOf(["horizontal", "vertical"]), legendPosition: PropTypes.shape({ left: PropTypes.string, right: PropTypes.string, top: PropTypes.string, bottom: PropTypes.string }), legendIcon: PropTypes.string, legendHeight: PropTypes.number, pieRadius: PropTypes.arrayOf(PropTypes.string), pieCenter: PropTypes.arrayOf(PropTypes.string), showLabels: PropTypes.bool, showLabelLine: PropTypes.bool, legendFormatter: PropTypes.string, titleTextStyle: PropTypes.object, subtitleTextStyle: PropTypes.object, legendTextStyle: PropTypes.object, showLegend: PropTypes.bool, itemGap: PropTypes.number, doughnutAngles: PropTypes.arrayOf(PropTypes.number), containerStyle: PropTypes.object }, { data: PropTypes.array, title: PropTypes.string };
({ xAxisData: PropTypes.array, yAxisData: PropTypes.array, seriesData: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired, data: PropTypes.array.isRequired, color: PropTypes.string.isRequired, line: PropTypes.bool, stack: PropTypes.string, yAxisIndex: PropTypes.number })).isRequired, smoothLine: PropTypes.bool, borderRadius: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]), xAxisType: PropTypes.oneOf(["value", "category", "time", "log"]), yAxisType: PropTypes.oneOf(["value", "category", "time", "log"]), barGap: PropTypes.string, barCategoryGap: PropTypes.string, xPrimaryLabelFormatter: PropTypes.func, xSecondaryLabelFormatter: PropTypes.func, xAxisSplitNumber: PropTypes.number, yAxisLabelFormatter: PropTypes.func, yAxisLabelFormatterB: PropTypes.func, yAxisLabelStyle: PropTypes.object, legendPosition: PropTypes.oneOf(["left", "right", "top", "bottom"]), legendTextStyle: PropTypes.object, showLegend: PropTypes.bool, xAxisPosition: PropTypes.oneOf(["top", "bottom"]), grid: PropTypes.object, xLabelMargin: PropTypes.number, yLabelMargin: PropTypes.number, legendFormatter: PropTypes.func, showAxisLine: PropTypes.bool, showSplitLine: PropTypes.bool, showAxisTick: PropTypes.bool, markPointProps: PropTypes.shape({ show: PropTypes.bool, symbol: PropTypes.string, symbolSize: PropTypes.oneOfType([PropTypes.number, PropTypes.array]), symbolOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.array]), label: PropTypes.object }), style: PropTypes.object, showDifferentXAxes: PropTypes.bool, opacity: PropTypes.number, barWidth: PropTypes.string, title: PropTypes.object, yAxisName: PropTypes.string }, { gaugeWidth: PropTypes.number, gaugeColor: PropTypes.string, titleColor: PropTypes.string, titleSize: PropTypes.number, subTitleSize: PropTypes.number, chartTitle: PropTypes.string, range: PropTypes.array, value: PropTypes.number });
function Indicator({ color: e3 = "red", size: t2 = 8, type: o2 = "dot", height: r2 = 2, alignSelf: s2 }) {
  return jsx("span", { style: { display: "inline-block", width: t2, height: "line" === o2 ? r2 : t2, backgroundColor: e3, borderRadius: "50%", marginRight: 4, alignSelf: s2 } });
}
({ xAxisData: PropTypes.arrayOf(PropTypes.string), yAxisData: PropTypes.arrayOf(PropTypes.string), data: PropTypes.arrayOf(PropTypes.object), dataStyle: PropTypes.object, formatTooltip: PropTypes.func }, { data: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, value: PropTypes.number, itemStyle: PropTypes.object })), title: PropTypes.string, style: PropTypes.object }), { title: PropTypes.string, data: PropTypes.array, columns: PropTypes.number }, { title: PropTypes.string, okText: PropTypes.string, cancelText: PropTypes.string, onOk: PropTypes.func, onCancel: PropTypes.func, styles: PropTypes.object, style: PropTypes.object, children: PropTypes.node }, Indicator.propTypes = { color: PropTypes.string, size: PropTypes.number, type: PropTypes.oneOf(["dot", "line"]), height: PropTypes.number, alignSelf: PropTypes.string };
const { Title: Title$1, Text: Text$3 } = Typography;
function ProgressBox(e3) {
  const { value: t2 = "", minWidth: o2 = "80px", label: r2 = "", strokeColor: s2 = {}, titleStyle: i2 = {}, strokeWidth: n2 = 10, size: l2 = 30, titleLevel: a2 = 3 } = e3;
  return jsxs(Space, { direction: "vertical", style: { gap: 0, minWidth: o2, marginLeft: "0px" }, children: [jsxs(Space, { direction: "horizontal", children: [jsx(Progress, { type: "circle", percent: t2, size: l2, strokeWidth: n2, strokeColor: { "0%": "#FAAD14", "100%": "#FAAD14", ...s2 }, format: () => "" }), jsxs(Title$1, { level: a2, style: { padding: 0, margin: 0, minWidth: "50px", marginLeft: "5px", ...i2 }, children: [t2, "%"] })] }), jsx(Text$3, { type: "secondary", children: r2 })] });
}
ProgressBox.propTypes = { value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), strokeColor: PropTypes.object, titleStyle: PropTypes.object, strokeWidth: PropTypes.number, size: PropTypes.number, titleLevel: PropTypes.number, minWidth: PropTypes.string }, { title: PropTypes.string, actions: PropTypes.array, children: PropTypes.node, style: PropTypes.object, styles: PropTypes.object, defaults: PropTypes.object, containerStyle: PropTypes.object, loading: PropTypes.bool }, { value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), level: PropTypes.number, active: PropTypes.bool, indicator: PropTypes.shape({ color: PropTypes.string.isRequired }), styles: PropTypes.object, style: PropTypes.object, labelStyle: PropTypes.object, align: PropTypes.oneOf(["center", "left"]), labelAlign: PropTypes.oneOf(["center", "left"]), tag: PropTypes.string, showSeparator: PropTypes.bool, labelContainerStyle: PropTypes.object, seperatorStyle: PropTypes.object, loading: PropTypes.bool }, { children: PropTypes.node, backgroundColor: PropTypes.string, containerStyle: PropTypes.object, style: PropTypes.object }, { progresses: PropTypes.arrayOf(PropTypes.shape({ percent: PropTypes.number.isRequired, color: PropTypes.string.isRequired, label: PropTypes.string })).isRequired }, { options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string.isRequired, label: PropTypes.string.isRequired, icon: PropTypes.node })).isRequired, defaultValue: PropTypes.string, value: PropTypes.string.isRequired, onChange: PropTypes.func.isRequired, size: PropTypes.oneOf(["small", "large"]), activeTabBgColor: PropTypes.string, activeTabFontcolor: PropTypes.string };
({ Venue2: jsx(Image$1, { preview: false, src: IconUrls.venueDark, style: { fontSize: "16px", color: "transparent", marginRight: 7 } }), Venue2Disabled: jsx(Image$1, { preview: false, src: IconUrls.venueDark, style: { fontSize: "16px", color: "transparent", opacity: 0.5 } }), Agent2: jsx(Image$1, { preview: false, src: IconUrls.agentDark, style: { fontSize: "16px", color: "transparent", marginRight: 7 } }), Mapped: jsx(Image$1, { preview: false, src: IconUrls.mappedLocationDark }), Unmapped: jsx(Image$1, { preview: false, src: IconUrls.unMappedLocatonDark }), Details: jsx(Image$1, { preview: false, src: IconUrls.detailsDark, style: { fontSize: "20px" } }), World2: jsx(Image$1, { preview: false, src: IconUrls.worldDark, style: { fontSize: "20px", color: "transparent", marginRight: 7 } }) });
({ Venue2: jsx(Image$1, { preview: false, src: IconUrls.venueLight, style: { fontSize: "16px", color: "transparent", marginRight: 7 } }), Venue2Disabled: jsx(Image$1, { preview: false, src: IconUrls.venueLight, style: { fontSize: "16px", color: "transparent", opacity: 0.5 } }), Agent2: jsx(Image$1, { preview: false, src: IconUrls.agentLight, style: { fontSize: "16px", color: "transparent", marginRight: 7 } }), Mapped: jsx(Image$1, { preview: false, src: IconUrls.mappedLocatonLight }), Unmapped: jsx(Image$1, { preview: false, src: IconUrls.unMappedLocatonLight }), Details: jsx(Image$1, { preview: false, src: IconUrls.detailsLight, style: { fontSize: "20px" } }), World2: jsx(Image$1, { preview: false, src: IconUrls.worldLight, style: { fontSize: "20px", color: "transparent", marginRight: 7 } }) });
({ isSelected: PropTypes.bool, onSelect: PropTypes.func, outerSize: PropTypes.number, middleSize: PropTypes.number, innerSize: PropTypes.number, middleColor: PropTypes.string, innerColor: PropTypes.string });
({ details: PropTypes.shape({ data: PropTypes.any, labelSpan: PropTypes.any, title: PropTypes.any }) });
({ icon: PropTypes.node, title: PropTypes.string, stats: PropTypes.array, hideExtra: PropTypes.bool, headerStyle: PropTypes.object, loading: PropTypes.bool, error: PropTypes.bool, onClick: PropTypes.func }, { searchKey: PropTypes.string.isRequired, search: PropTypes.func.isRequired, searchValue: PropTypes.string, isFocused: PropTypes.bool }), { item: PropTypes.object, onRowAction: PropTypes.func, hidden: PropTypes.object };
({ content: PropTypes.node.isRequired, text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired }, { dataSource: PropTypes.array.isRequired, columns: PropTypes.array.isRequired, selectedRowKeys: PropTypes.array.isRequired, setSelectedRowKeys: PropTypes.func.isRequired, enableWidth: PropTypes.bool, loading: PropTypes.bool, pagination: PropTypes.bool, onRowAction: PropTypes.func, hiddenRowActions: PropTypes.object }), { imgSrc: PropTypes.string, onClick: PropTypes.func, style: PropTypes.object }, { text: PropTypes.string, onClick: PropTypes.func, styles: PropTypes.object, disabled: PropTypes.bool };
({ title: PropTypes.string, onClick: PropTypes.func, showBackIcon: PropTypes.bool }, { placeholder: PropTypes.string, onChange: PropTypes.func, customThemeSearch: PropTypes.bool, style: PropTypes.object, className: PropTypes.string }), { open: PropTypes.bool, closeIcon: PropTypes.bool, centered: PropTypes.bool, className: PropTypes.string, children: PropTypes.node, handleClose: PropTypes.func, style: PropTypes.object, showCloseIcon: PropTypes.bool }, { children: PropTypes.node, style: PropTypes.object, onClick: PropTypes.func, ellipsis: PropTypes.bool, enabled: PropTypes.bool }, { items: PropTypes.array, btnStyle: PropTypes.object, text: PropTypes.string, icon: PropTypes.node, headerText: PropTypes.string, onChange: PropTypes.func, value: PropTypes.array, showdownArrow: PropTypes.bool, sufixIcon: PropTypes.node, showAllSelect: PropTypes.bool, placement: PropTypes.string }, { label: PropTypes.string, value: PropTypes.string, closable: PropTypes.bool, onClose: PropTypes.func }, { items: PropTypes.array, value: PropTypes.string, defaultValue: PropTypes.string, placeHolder: PropTypes.string, mode: PropTypes.string, allowClear: PropTypes.bool, useTagRender: PropTypes.bool, className: PropTypes.string, popUpClassName: PropTypes.string, bordered: PropTypes.bool, dropdownStyle: PropTypes.object, style: PropTypes.object, onChange: PropTypes.func, fieldNames: PropTypes.object }, { onSelect: PropTypes.func, onSearch: PropTypes.func, placeholder: PropTypes.string, style: PropTypes.object, options: PropTypes.array }, dayjs.extend(customParseFormat), dayjs.extend(weekday), dayjs.extend(localeData), { onChange: PropTypes.func, style: PropTypes.object, dateFormat: PropTypes.string, pastDate: PropTypes.string, disableEndDate: PropTypes.bool, separator: PropTypes.object, startDate: PropTypes.string, endDate: PropTypes.string }, { onChange: () => {
}, style: {}, dateFormat: "YYYY-MM-DD", pastDate: moment().subtract(14, "days").format("YYYY-MM-DD"), disableEndDate: false, separator: jsx(SwapRightOutlined, {}), startDate: null, endDate: null }, { placeholder: PropTypes.string, onChange: PropTypes.func, customThemeSearch: PropTypes.bool, style: PropTypes.object, dateFormat: PropTypes.string }, { items: PropTypes.array };
({ title: PropTypes.string, steps: PropTypes.array, data: PropTypes.object, renderContent: PropTypes.func, visible: PropTypes.bool, onClose: PropTypes.func, onSubmit: PropTypes.func, importButtonText: PropTypes.string, openImportAssetsModal: PropTypes.func });
({ notifications: PropTypes.array, loading: PropTypes.bool });
const levelColors = {
  1: "red",
  2: "orange",
  3: "yellow",
  4: "blue",
  5: "green"
};
const DUMMY$1 = {
  levels: [{
    level: 1
  }, {
    level: 2
  }, {
    level: 3
  }, {
    level: 4
  }],
  devices: [{
    name: "AP name 1",
    critical: 2,
    major: 3,
    minor: 1
  }, {
    name: "AP name 2",
    critical: 3,
    major: 2,
    minor: 5
  }, {
    name: "AP name 3",
    critical: 1,
    major: 4,
    minor: 6
  }, {
    name: "AP name 4",
    critical: 4,
    major: 1,
    minor: 7
  }]
};
function BuildingTooltip(props) {
  const {
    title,
    levels,
    devices
  } = props;
  const {
    token
  } = theme$2.useToken();
  const expandContent = React__default.useCallback((critical, major, minor) => {
    const cardsData = [{
      value: critical,
      title: "Critical",
      indicator: {
        color: "#dc4446"
      }
    }, {
      value: major,
      title: "Major",
      indicator: {
        color: "#d89614"
      }
    }, {
      value: minor,
      title: "Minor",
      indicator: {
        color: "#3c8618"
      }
    }];
    return /* @__PURE__ */ jsx("div", { style: {
      display: "flex",
      margin: 0,
      padding: 0
    }, children: cardsData.map((card) => {
      var _a3;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Card, { id: card.title, bordered: false, style: {
          boxShadow: "none"
        }, styles: {
          body: {
            padding: 0,
            margin: 0
          }
        }, children: /* @__PURE__ */ jsxs("div", { style: {
          display: "flex",
          justifyContent: "center",
          flexDirection: "column"
        }, children: [
          /* @__PURE__ */ jsxs("div", { style: {
            margin: 0,
            padding: 0,
            display: "ruby"
          }, children: [
            typeof ((_a3 = card.indicator) == null ? void 0 : _a3.color) === "string" && /* @__PURE__ */ jsx(Indicator, { color: card.indicator.color }),
            /* @__PURE__ */ jsx(Typography.Title, { level: 5, style: {
              margin: 0,
              padding: 0
            }, children: card.value })
          ] }),
          /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: card.title })
        ] }) }),
        card.title !== "Minor" && /* @__PURE__ */ jsx(Divider, { type: "vertical", dashed: true, style: {
          height: "auto",
          margin: "8px"
        } })
      ] });
    }) });
  }, []);
  const customExpandIcon = React__default.useCallback(({
    isActive
  }) => isActive ? /* @__PURE__ */ jsx(UpOutlined, {}) : /* @__PURE__ */ jsx(DownOutlined, {}), []);
  return /* @__PURE__ */ jsx(Card, { style: {
    borderRadius: "10px",
    width: "300px",
    display: "flex",
    flexDirection: "column",
    height: "100%"
  }, children: /* @__PURE__ */ jsx(Card.Meta, { description: /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    display: "flex",
    flexDirection: "row"
  }, children: [
    /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
      width: "35%"
    }, children: [
      /* @__PURE__ */ jsx(Tooltip$1, { title, color: token.colorBgContainer, children: /* @__PURE__ */ jsx(Typography.Title, { level: 5, style: {
        margin: "0 0 10px 0"
      }, ellipsis: {
        rows: 1
      }, children: title }) }),
      /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: "Levels" }),
      /* @__PURE__ */ jsx(List$3, { split: false, itemLayout: "vertical", dataSource: levels, renderItem: (item) => /* @__PURE__ */ jsx(List$3.Item, { style: {
        margin: 0,
        padding: 0
      }, children: /* @__PURE__ */ jsxs(Space, { style: {
        display: "flex",
        alignItems: "center"
      }, children: [
        /* @__PURE__ */ jsx(Indicator, { color: levelColors[item.level], size: 9 }),
        item.level,
        " Level"
      ] }) }) })
    ] }),
    /* @__PURE__ */ jsx(Divider, { type: "vertical", style: {
      height: "auto"
    } }),
    /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
      width: "60%",
      gap: 0,
      paddingInline: "4px",
      justifyContent: "space-between",
      flexGrow: 1
    }, children: [
      /* @__PURE__ */ jsx("div", { style: {
        width: "100%",
        maxHeight: "120px",
        overflow: "auto",
        scrollbarWidth: "none"
      }, children: /* @__PURE__ */ jsx(Collapse, { ghost: true, expandIcon: customExpandIcon, expandIconPosition: "end", style: {
        marginBottom: "0px",
        width: "100%"
      }, items: devices.map((ap2, index2) => {
        const key = index2;
        const label = /* @__PURE__ */ jsxs(Space, { direction: "horizontal", style: {
          width: "100%",
          justifyContent: "space-between"
        }, children: [
          /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: ap2.name }),
          /* @__PURE__ */ jsx(Tag, { icon: /* @__PURE__ */ jsx(ExclamationCircleFilled, {}), color: "error", style: {
            width: "50px",
            margin: 0
          }, children: ap2.critical + ap2.major + ap2.minor }, ap2.name)
        ] });
        const children = expandContent(ap2.critical, ap2.major, ap2.minor);
        return {
          key,
          label,
          children,
          style: {
            margin: -4,
            padding: "0px"
          }
        };
      }), size: "small" }) }),
      /* @__PURE__ */ jsx(Button, { size: "medium", style: {
        width: "100%",
        borderRadius: "5px",
        alignSelf: "flex-end"
      }, type: "primary", children: "Explore" })
    ] })
  ] }) }) });
}
BuildingTooltip.propTypes = {
  title: propTypesExports$1.string,
  levels: propTypesExports$1.array,
  devices: propTypesExports$1.array
};
BuildingTooltip.defaultProps = {
  title: "",
  levels: DUMMY$1.levels,
  devices: DUMMY$1.devices
};
const alertIndicatorColor = {
  minor: "#3c8618",
  major: "#d89614",
  critical: "#dc4446"
};
const DUMMY = {
  alerts: [{
    type: "critical",
    value: 10
  }, {
    type: "major",
    value: 2
  }, {
    type: "minor",
    value: 12
  }],
  title: "Wifi Name",
  data: [{
    title: "Tonnage",
    value: "288GB"
  }, {
    title: "AVG User throughput",
    value: "35Mbps"
  }]
};
function AlertStatusTooltip(props) {
  const {
    alerts,
    title,
    data: data2,
    cardStyle
  } = props;
  return /* @__PURE__ */ jsx(Card, { style: {
    width: "fit-content",
    minWidth: "180px",
    borderRadius: "10px",
    padding: "0px",
    ...cardStyle
  }, children: /* @__PURE__ */ jsx(Card.Meta, { title, description: /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    width: "100%"
  }, children: [
    /* @__PURE__ */ jsx(Space, { style: {
      gap: "15px",
      width: "100%"
    }, children: data2.map(({
      title: subtitle,
      value
    }) => /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
      gap: 0,
      width: "100%"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", style: {
        whiteSpace: "nowrap"
      }, children: subtitle }),
      /* @__PURE__ */ jsx(Typography.Title, { level: 5, style: {
        margin: 0
      }, children: value })
    ] })) }),
    /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
      width: "100%"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: "Alerts" }),
      /* @__PURE__ */ jsx(List$3, { split: false, itemLayout: "horizontal", dataSource: alerts, renderItem: (item) => /* @__PURE__ */ jsx(List$3.Item, { style: {
        margin: 0,
        padding: 0
      }, children: /* @__PURE__ */ jsxs(Space, { style: {
        gap: "3px",
        width: "100%"
      }, children: [
        /* @__PURE__ */ jsx(Indicator, { color: alertIndicatorColor[item.type], size: 9 }),
        /* @__PURE__ */ jsx(Typography.Text, { strong: true, children: item.value }),
        /* @__PURE__ */ jsx(Typography.Text, { children: `${item.type.charAt(0).toUpperCase() + item.type.slice(1)}` })
      ] }) }) }),
      /* @__PURE__ */ jsx(Button, { type: "primary", style: {
        width: "100%",
        borderRadius: "5px",
        margin: 0,
        padding: 0,
        letterSpacing: "0.75px",
        fontSize: "14px"
      }, children: "Explore" })
    ] })
  ] }) }) });
}
AlertStatusTooltip.propTypes = {
  alerts: propTypesExports$1.string,
  title: propTypesExports$1.string,
  data: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    title: propTypesExports$1.string,
    value: propTypesExports$1.string
  })),
  cardStyle: propTypesExports$1.object
};
AlertStatusTooltip.defaultProps = {
  alerts: DUMMY.alerts,
  title: DUMMY.title,
  data: DUMMY.data,
  cardStyle: {}
};
const IDS$1 = {
  marketTiles: "sai-entity-markets-tiles",
  venueTiles: "sai-entity-venues-tiles",
  buildingTiles: "sai-entity-buildings-tiles",
  levelTiles: "sai-entity-levels-tiles"
};
const STYLES$1 = {
  market: {
    color: "#63A4FF",
    outlineColor: "#63A4FF",
    opacity: 0.1,
    outlineOpacity: 0.5
  },
  venue: {
    color: "#13C2C2",
    outlineColor: "#13C2C2",
    opacity: 0.1,
    outlineOpacity: 1,
    outlineDashArray: [3, 3]
  },
  building: {
    color: "#1677FF",
    outlineColor: "#1677FF",
    opacity: 0.2,
    outlineOpacity: 0.2
  },
  level: {
    color: "#0958D9",
    outlineColor: "#0958D9",
    opacity: 0.3,
    outlineOpacity: 1
  }
};
function Footprints(props) {
  const {
    hierarchy,
    visibility,
    enableAutoFocus,
    activeItem,
    autoFocusPadding,
    displayMode: displayMode2,
    enableEntityIcon,
    onLoad
  } = props;
  const [autoFocusSourceId, setAutoFocusSourceId] = React__default.useState(null);
  const [autoFocusParams, setAutoFocusParams] = React__default.useState({});
  const autoFocusFeatureId = activeItem == null ? void 0 : activeItem.id;
  const [seedPoint, setSeedPoint] = React__default.useState(null);
  const [refreshCounter, setRefreshCounter] = React__default.useState({
    key: "",
    counter: 0
  });
  const {
    regionId,
    marketId,
    clusterId,
    venueId,
    buildingId,
    levelId
  } = hierarchy || {};
  const {
    enableVenue,
    enableBuilding,
    enableLevel,
    enableZones
  } = visibility || {};
  const {
    rootEntityId,
    enableMarket,
    enableCluster,
    enableRegion
  } = React__default.useMemo(() => {
    const rootEntityId2 = regionId || marketId || clusterId || venueId;
    let enableMarket2 = visibility == null ? void 0 : visibility.enableMarket;
    let enableCluster2 = visibility == null ? void 0 : visibility.enableCluster;
    let enableRegion2 = visibility == null ? void 0 : visibility.enableRegion;
    if (rootEntityId2 && rootEntityId2 === venueId) {
      enableMarket2 = false;
      enableRegion2 = false;
      enableCluster2 = false;
    }
    return {
      enableMarket: enableMarket2,
      enableRegion: enableRegion2,
      enableCluster: enableCluster2,
      rootEntityId: rootEntityId2
    };
  }, [clusterId, marketId, regionId, venueId, visibility == null ? void 0 : visibility.enableCluster, visibility == null ? void 0 : visibility.enableMarket, visibility == null ? void 0 : visibility.enableRegion]);
  const setAutoFocus = React__default.useCallback((id) => {
    if (!id) {
      setAutoFocusSourceId("");
      return;
    }
    const sourceId = `${id}-source`;
    setAutoFocusSourceId(sourceId);
  }, []);
  React__default.useEffect(() => {
    const {
      longitude,
      latitude,
      geometry: geometry2
    } = activeItem || {};
    if (geometry2) {
      setSeedPoint({
        type: "Feature",
        geometry: geometry2
      });
    } else if (longitude && latitude) {
      setSeedPoint({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [Number(longitude), Number(latitude)]
        }
      });
    } else {
      setSeedPoint(null);
    }
  }, [activeItem]);
  React__default.useEffect(() => {
    setRefreshCounter((prev) => {
      const {
        key,
        counter: counter2
      } = prev || {};
      const newKey = `${marketId}${venueId}${buildingId}${levelId}`;
      if (key !== newKey) {
        return {
          key: newKey,
          counter: counter2 + 1
        };
      }
      return prev;
    });
  }, [marketId, venueId, buildingId, levelId]);
  React__default.useEffect(() => {
    let bearing2 = 0;
    const pitch = displayMode2 === "3d" ? 60 : 0;
    if (levelId) {
      bearing2 = (activeItem == null ? void 0 : activeItem.bearing) || 0;
      setAutoFocus(IDS$1.levelTiles);
    } else if (buildingId) {
      setAutoFocus(IDS$1.buildingTiles);
    } else if (venueId) {
      setAutoFocus(IDS$1.venueTiles);
    } else if (marketId) {
      setAutoFocus(IDS$1.marketTiles);
    } else if (clusterId) {
      setAutoFocus(IDS$1.clusterTiles);
    } else if (regionId) {
      setAutoFocus(IDS$1.regionTiles);
    }
    setAutoFocusParams({
      bearing: bearing2,
      pitch
    });
  }, [marketId, venueId, buildingId, levelId, setAutoFocus, activeItem == null ? void 0 : activeItem.bearing, displayMode2, clusterId, regionId]);
  const autoFocusFilterRaw = React__default.useCallback((feature2) => {
    var _a3;
    if (!autoFocusFeatureId)
      return false;
    return ((_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.entity_id) === autoFocusFeatureId;
  }, [autoFocusFeatureId]);
  const autoFocusFilter = useMutableFunc(autoFocusFilterRaw);
  const venueMaxZoom = buildingId ? levelId ? 16 : 18 : 24;
  const buildingMaxZoom = levelId ? 18 : 24;
  const {
    zoneRendering,
    zoneIds
  } = React__default.useMemo(() => {
    if (!enableZones)
      return {};
    const zoneIds2 = [];
    const vals = Object.entries(enableZones).map(([key, value]) => {
      if (value === false) {
        return null;
      }
      const id = `sai-entity-zones-${key}-tiles`;
      zoneIds2.push(id);
      return /* @__PURE__ */ jsx(Footprint, { id, entityType: "zone", entitySubType: `${key}`, ...STYLES$1.level, minZoom: 15, maxZoom: 24, parentId: activeItem == null ? void 0 : activeItem.id, rootEntityId });
    });
    return {
      zoneRendering: vals,
      zoneIds: zoneIds2
    };
  }, [enableZones, activeItem == null ? void 0 : activeItem.id, rootEntityId]);
  React__default.useEffect(() => {
    const layers = [];
    if (enableRegion) {
      layers.push(IDS$1.regionTiles);
    }
    if (enableMarket) {
      layers.push(IDS$1.marketTiles);
    }
    if (enableCluster) {
      layers.push(IDS$1.clusterTiles);
    }
    if (enableVenue) {
      layers.push(IDS$1.venueTiles);
    }
    if (enableBuilding) {
      layers.push(IDS$1.buildingTiles);
    }
    if (enableLevel) {
      layers.push(IDS$1.levelTiles);
    }
    if (enableZones) {
      layers.push(...zoneIds || []);
    }
    onLoad(layers);
  }, [enableBuilding, enableCluster, enableLevel, enableMarket, enableRegion, enableVenue, enableZones, onLoad, zoneIds]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    enableRegion && /* @__PURE__ */ jsx(
      Footprint,
      {
        id: IDS$1.regionTiles,
        entityType: "region",
        entityId: regionId,
        ...STYLES$1.region,
        minZoom: 5,
        maxZoom: 15,
        enableIcon: enableEntityIcon
      }
    ),
    enableMarket && /* @__PURE__ */ jsx(Footprint, { id: IDS$1.marketTiles, entityType: "market", entityId: marketId, ...STYLES$1.market, minZoom: 5, maxZoom: 15, enableIcon: enableEntityIcon }),
    enableCluster && /* @__PURE__ */ jsx(
      Footprint,
      {
        id: IDS$1.clusterTiles,
        entityType: "cluster",
        entityId: clusterId,
        ...STYLES$1.cluster,
        minZoom: 5,
        maxZoom: 15,
        enableIcon: enableEntityIcon
      }
    ),
    enableVenue && /* @__PURE__ */ jsx(Footprint, { id: IDS$1.venueTiles, entityType: "venue", entityId: venueId, ...STYLES$1.venue, minZoom: 14, maxZoom: venueMaxZoom, enableIcon: enableEntityIcon, rootEntityId: rootEntityId === venueId ? void 0 : rootEntityId }),
    enableBuilding && /* @__PURE__ */ jsx(Footprint, { id: IDS$1.buildingTiles, entityType: "building", ...STYLES$1.building, minZoom: 15, maxZoom: buildingMaxZoom, enableIcon: enableEntityIcon, rootEntityId }),
    enableLevel && /* @__PURE__ */ jsx(Footprint, { id: IDS$1.levelTiles, entityType: "level", entityId: levelId, ...STYLES$1.level, minZoom: 15, maxZoom: 24, enableIcon: enableEntityIcon, rootEntityId }),
    zoneRendering,
    enableAutoFocus && !!autoFocusSourceId && /* @__PURE__ */ jsx(
      MapFitSourceLayer,
      {
        enable: true,
        sourceId: autoFocusSourceId,
        sourceLayer: "default",
        filter: autoFocusFilter,
        padding: autoFocusPadding,
        seedFeature: seedPoint,
        linear: true,
        duration: 500,
        maxDuration: 3e3,
        refreshCounter: refreshCounter == null ? void 0 : refreshCounter.counter,
        ...autoFocusParams
      },
      autoFocusSourceId || levelId || buildingId || venueId || clusterId || marketId || regionId || "none"
    )
  ] });
}
Footprints.propTypes = {
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  hierarchy: propTypesExports$1.object,
  visibility: propTypesExports$1.object,
  enableAutoFocus: propTypesExports$1.bool,
  activeItem: propTypesExports$1.object,
  autoFocusPadding: propTypesExports$1.object,
  enableEntityIcon: propTypesExports$1.bool,
  onLoad: propTypesExports$1.func
};
Footprints.defaultProps = {
  displayMode: "2d",
  hierarchy: {},
  visibility: {},
  enableAutoFocus: false,
  activeItem: null,
  autoFocusPadding: false,
  enableEntityIcon: false,
  onLoad: () => {
  }
};
function Models3d(props) {
  const {
    activeItem,
    displayMode: displayMode2
  } = props;
  const {
    models3d
  } = activeItem || {};
  if (displayMode2 !== "3d")
    return null;
  return /* @__PURE__ */ jsx(Fragment, { children: models3d == null ? void 0 : models3d.map((item) => /* @__PURE__ */ jsx(ModelLoader, { ...item }, item == null ? void 0 : item.id)) });
}
Models3d.propTypes = {
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  hierarchy: propTypesExports$1.object,
  enableAutoFocus: propTypesExports$1.bool,
  activeItem: propTypesExports$1.shape({
    models3d: propTypesExports$1.array
  }),
  autoFocusPadding: propTypesExports$1.object
};
Models3d.defaultProps = {
  displayMode: "2d",
  hierarchy: {},
  enableAutoFocus: false,
  activeItem: null,
  autoFocusPadding: {}
};
function CustomDataView(props) {
  const {
    id,
    data: data2,
    type,
    enable: enable4,
    minZoom,
    maxZoom,
    displayMode: displayMode2,
    ...restProps
  } = props;
  const isHeatmap = React__default.useMemo(() => ["heatmap", "heatmapfill", "h3map"].includes(type), [type]);
  const isTerritory = type === "territory";
  const features = React__default.useMemo(() => {
    if (isHeatmap || isTerritory)
      return null;
    return MiscUtil.convertToFeatures(data2, id);
  }, [data2, id, isHeatmap, isTerritory]);
  if (isTerritory && enable4) {
    return /* @__PURE__ */ jsx(VectorTerritory, { id, type: "line", ...restProps });
  }
  if (isHeatmap) {
    return /* @__PURE__ */ jsx(Heatmaps, { id, type, displayMode: displayMode2, minZoom, maxZoom, data: data2, enable: enable4, ...restProps });
  }
  if (enable4)
    return /* @__PURE__ */ jsx(
      FeaturesView,
      {
        id,
        features,
        displayMode: displayMode2,
        minZoom,
        maxZoom,
        ...restProps
      }
    );
  return null;
}
CustomDataView.propTypes = {
  id: propTypesExports$1.string,
  type: propTypesExports$1.oneOf(["heatmap", "heatmapfill", "h3map", "territory"]),
  data: propTypesExports$1.any,
  isHeatmap: propTypesExports$1.bool,
  enable: propTypesExports$1.bool,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  minZoom: propTypesExports$1.number,
  maxZoom: propTypesExports$1.number
};
CustomDataView.defaultProps = {
  data: null,
  type: null,
  id: null,
  enable: false,
  displayMode: "2d",
  isHeatmap: false,
  minZoom: 0,
  maxZoom: 24
};
function CustomDataViews(props) {
  const {
    customData,
    ...restProps
  } = props;
  if (!customData)
    return null;
  return /* @__PURE__ */ jsx(Fragment, { children: customData.map((dataItem, index2) => {
    const {
      id,
      data: data2,
      ...otherProps
    } = dataItem;
    return /* @__PURE__ */ jsx(CustomDataView, { id, data: data2, ...restProps, ...otherProps }, id || index2);
  }) });
}
CustomDataViews.propTypes = {
  customData: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    id: propTypesExports$1.string,
    data: propTypesExports$1.any,
    enable: propTypesExports$1.bool,
    displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
    minZoom: propTypesExports$1.number,
    maxZoom: propTypesExports$1.number
  }))
};
CustomDataViews.defaultProps = {
  customData: []
};
const IDS = {
  statusSymbol: "sai-status-symbols",
  deviceSymbol: "sai-device-symbols",
  entityIcon: "sai-entity-icons"
};
const HEATMAP_MAX_ZOOM = 13;
function MapSection(props) {
  var _a3, _b3;
  const {
    children,
    statusSymbols,
    onSymbolSelect,
    deviceSymbols,
    heatmapData,
    customData: customDataIn,
    viewControls,
    controls: controlsIn,
    dragDrop,
    ...restProps
  } = props;
  const interactables = React__default.useMemo(() => ["statusSymbol", "deviceSymbol"], []);
  const [footprintLayers, setFootprintLayers] = React__default.useState([]);
  const {
    filters,
    handleFilterChange,
    handleOnClear,
    isLoading,
    errors
  } = useFilterMapData((_a3 = controlsIn == null ? void 0 : controlsIn.layerDropdownSelectProps) == null ? void 0 : _a3.disabled);
  const getInteractableId = React__default.useCallback((feature2) => {
    const id = interactables.find((key) => {
      const sourceId = `${IDS[key]}-point-source`;
      if ((feature2 == null ? void 0 : feature2.source) === sourceId)
        return true;
      return false;
    });
    return id;
  }, [interactables]);
  const onSelect = React__default.useCallback((feature2) => {
    const id = getInteractableId(feature2);
    console.debug("onSelect", feature2);
    if (id) {
      onSymbolSelect(feature2, id);
    }
  }, [getInteractableId, onSymbolSelect]);
  const customData = React__default.useMemo(() => (customDataIn == null ? void 0 : customDataIn.map((item, index2) => {
    var _a4, _b4;
    const name2 = item.name || `Custom Data ${index2 + 1}`;
    const id = item.id || name2;
    const key = `enable${id}`;
    const checked = (_b4 = (_a4 = controlsIn == null ? void 0 : controlsIn.layerProps) == null ? void 0 : _a4.checked) == null ? void 0 : _b4[key];
    const enable4 = typeof checked === "undefined" ? true : checked;
    return {
      ...item,
      enable: enable4,
      name: name2,
      id,
      key: `enable${id}`
    };
  })) || [], [(_b3 = controlsIn == null ? void 0 : controlsIn.layerProps) == null ? void 0 : _b3.checked, customDataIn]);
  const renderTooltip = React__default.useCallback((feature2) => {
    var _a4;
    const id = getInteractableId(feature2);
    if (id === "statusSymbol") {
      const {
        name: name2,
        symbolViewContextType
      } = feature2.properties;
      if (symbolViewContextType === "market") {
        return /* @__PURE__ */ jsx(AlertStatusTooltip, { title: name2, data: [] });
      }
      if (symbolViewContextType === "venue") {
        return /* @__PURE__ */ jsx(BuildingTooltip, { title: name2 });
      }
    } else if (id === "deviceSymbol") {
      const {
        name: name2
      } = feature2.properties;
      return /* @__PURE__ */ jsx(AlertStatusTooltip, { title: name2 });
    } else if ((_a4 = controlsIn == null ? void 0 : controlsIn.tooltipProps) == null ? void 0 : _a4.render) {
      return controlsIn.tooltipProps.render(feature2);
    }
    return null;
  }, [controlsIn.tooltipProps, getInteractableId]);
  const interactions2 = React__default.useMemo(() => {
    const interactions22 = {};
    if (onSymbolSelect) {
      interactions22.enableSelection = true;
      interactions22.onSelect = onSelect;
    }
    return interactions22;
  }, [onSelect, onSymbolSelect]);
  const {
    controls,
    layerTreeSelectControls,
    layerDropdownSelectControls
  } = React__default.useMemo(() => {
    var _a4, _b4, _c2, _d2;
    const obj = {
      enableTooltip: true,
      ...controlsIn,
      tooltipProps: {
        sources: [...interactables.map((key) => ({
          sourceId: `${IDS[key]}-point-source`
        })), ...((_a4 = controlsIn.tooltipProps) == null ? void 0 : _a4.sources) || []],
        render: renderTooltip,
        mouseEnterDelay: ((_b4 = controlsIn.tooltipProps) == null ? void 0 : _b4.mouseEnterDelay) || 900
      }
    };
    const {
      enableLayerTreeSelect,
      layertTreeSelectPlacement,
      layerTreeSelectProps,
      enableLayerDropdownSelect,
      layerDropdownSelectPlacement,
      layerDropdownSelectProps,
      ...controlsParams
    } = obj;
    const layerTreeSelectControls2 = {
      enable: enableLayerTreeSelect,
      placement: layertTreeSelectPlacement,
      ...layerTreeSelectProps || {}
    };
    const layerDropdownSelectControls2 = {
      enable: enableLayerDropdownSelect,
      placement: layerDropdownSelectPlacement,
      data: filters,
      ...layerDropdownSelectProps || {}
    };
    const existingBoundaries = ((_c2 = controlsIn == null ? void 0 : controlsIn.layerProps) == null ? void 0 : _c2.boundaries) || [];
    const customLayerBoundaries = customData.map((item) => ({
      name: item.name,
      key: item.key
    }));
    const mergedBoundaries = [...existingBoundaries, ...customLayerBoundaries];
    const controls2 = {
      ...controlsParams,
      layerProps: {
        ...controlsIn == null ? void 0 : controlsIn.layerProps,
        boundaries: mergedBoundaries
      },
      searchProps: {
        ...controlsParams.searchProps || {},
        searchables: [...((_d2 = controlsParams.searchProps) == null ? void 0 : _d2.searchables) || [], ...(footprintLayers || []).map((layerId) => ({
          layerId,
          sourceId: `${layerId}-source`,
          sourceLayer: "default"
        }))]
      }
    };
    return {
      controls: controls2,
      layerTreeSelectControls: layerTreeSelectControls2,
      layerDropdownSelectControls: layerDropdownSelectControls2
    };
  }, [controlsIn, customData, filters, footprintLayers, interactables, renderTooltip]);
  const isHeatmapEnabled = viewControls == null ? void 0 : viewControls.enableHeatmap;
  return /* @__PURE__ */ jsx("div", { style: {
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  }, children: /* @__PURE__ */ jsxs(SaiMapProvider, { beforeId: "waterway-label", ...restProps, interactions: interactions2, controls, children: [
    /* @__PURE__ */ jsx(CustomDataViews, { customData }, `customData-${(customData == null ? void 0 : customData.length) || 0}`),
    /* @__PURE__ */ jsx(LayerDropdownSelect, { onSelect: handleFilterChange, onClear: handleOnClear, loading: isLoading, error: errors, ...layerDropdownSelectControls }),
    /* @__PURE__ */ jsx(LayerTreeSelect, { ...layerTreeSelectControls }),
    /* @__PURE__ */ jsx(Footprints, { ...viewControls, onLoad: setFootprintLayers }),
    /* @__PURE__ */ jsx(Heatmaps, { minZoom: 0, maxZoom: HEATMAP_MAX_ZOOM, ...heatmapData || {}, enable: isHeatmapEnabled, displayMode: viewControls.displayMode, colorMap: viewControls.heatmapColor }),
    (viewControls == null ? void 0 : viewControls.enableStatusSymbol) && /* @__PURE__ */ jsx(StatusSymbols, { id: IDS.statusSymbol, symbols: statusSymbols }),
    /* @__PURE__ */ jsx(MapViewController, { ...viewControls }),
    /* @__PURE__ */ jsx(Models3d, { ...viewControls }),
    (dragDrop == null ? void 0 : dragDrop.enabled) && /* @__PURE__ */ jsx(MapboxDropAction, { ...dragDrop }),
    children,
    (viewControls == null ? void 0 : viewControls.enableDeviceSymbol) && /* @__PURE__ */ jsx(DeviceSymbols, { id: IDS.deviceSymbol, symbols: deviceSymbols, displayMode: viewControls == null ? void 0 : viewControls.displayMode, minZoom: 10, maxZoom: 24, textMinZoom: 14 }),
    /* @__PURE__ */ jsx(LayerSorter, { filter: (id) => id.startsWith("sai-") }, `refresh${isHeatmapEnabled}${viewControls.heatmapColor}`)
  ] }) });
}
MapSection.propTypes = {
  statusSymbols: propTypesExports$1.array,
  deviceSymbols: propTypesExports$1.array,
  heatmapData: propTypesExports$1.object,
  onSymbolSelect: propTypesExports$1.func,
  customData: propTypesExports$1.array,
  viewControls: propTypesExports$1.object,
  controls: propTypesExports$1.object,
  dragDrop: propTypesExports$1.shape({
    enabled: propTypesExports$1.bool,
    onDrag: propTypesExports$1.func,
    onDrop: propTypesExports$1.func
  }),
  children: propTypesExports$1.node
};
MapSection.defaultProps = {
  statusSymbols: null,
  deviceSymbols: null,
  heatmapData: null,
  onSymbolSelect: () => {
  },
  customData: null,
  viewControls: {},
  controls: {},
  dragDrop: null,
  children: null
};
const INDICATOR_STYLE = [{
  type: "minor",
  color: "#389E0D",
  opacity: "0.3"
}, {
  type: "major",
  color: "#FAAD14",
  opacity: "0.4"
}, {
  type: "critical",
  color: "#FF4D4F",
  opacity: 1
}];
function useFilters(props) {
  var _a3;
  const {
    rawData = {},
    rawHierarchy = {},
    activeList: listData = [],
    devices: allDevices = [],
    activeView,
    activeItem
  } = props;
  const [activeFilter, setActiveFilter] = React__default.useState();
  const [filters, setFilters] = React__default.useState({
    building: {
      status: "",
      deviceType: ""
    }
  });
  const applyFilters = useCallback((filterFor, appliedFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterFor]: appliedFilters
    }));
  }, [setFilters]);
  const clearFilters = useCallback((filterFor) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterFor]: {
        status: "",
        deviceType: ""
      }
    }));
  }, [setFilters]);
  const [sortBy, setSortBy] = React__default.useState("numAlerts");
  const isMarketsVenues = activeView === "root" || activeView === "market" && !activeItem;
  const isSpecificMarket = activeView === "market" && activeItem;
  const isSpecificVenue = activeView === "venue" && activeItem;
  const isSpecificBuilding = activeView === "building" && activeItem;
  const isSpecificLevel = activeView === "level" && activeItem;
  const {
    aps,
    devices
  } = React__default.useMemo(() => {
    const aps2 = [];
    const devices2 = [];
    allDevices == null ? void 0 : allDevices.forEach((d2) => {
      if (d2.isAccessPoint)
        aps2.push(d2);
      else
        devices2.push(d2);
    });
    return {
      aps: aps2,
      devices: devices2
    };
  }, [allDevices]);
  const apsStatuses = React__default.useMemo(() => [...new Set(devices.map((item) => item.networkStatus).filter((i2) => !!i2))], [devices]);
  const deviceTypes = React__default.useMemo(() => [...new Set(devices.map((item) => item.assetType).filter((i2) => !!i2))], [devices]);
  const marketsOrVenuesData = React__default.useMemo(() => {
    if (!isMarketsVenues)
      return null;
    let data22 = listData || [];
    const counts2 = {
      all: listData.length || 0
    };
    const favorites = listData.filter((item) => item.isFavorite);
    const filtered = activeFilter === "favorites" ? favorites : listData;
    data22 = filtered.sort((a2, b2) => b2[sortBy] - a2[sortBy]);
    counts2.favorites = favorites.length || 0;
    return {
      data: data22.map((item) => {
        var _a4;
        return {
          ...item,
          indicator: ((_a4 = INDICATOR_STYLE.find((i2) => i2.type === item.type)) == null ? void 0 : _a4.color) || "#FF4D4F"
        };
      }),
      counts: counts2
    };
  }, [activeFilter, isMarketsVenues, listData, sortBy]);
  const marketsOrVenuesExtra = React__default.useMemo(() => {
    if (!isMarketsVenues)
      return null;
    return /* @__PURE__ */ jsxs(Space, { size: "small", children: [
      /* @__PURE__ */ jsx(Typography.Text, { children: "Sort by" }),
      /* @__PURE__ */ jsx(Select$1, { value: sortBy, onChange: setSortBy, variant: "borderless", style: {
        width: 90
      }, options: [{
        value: "numAlerts",
        label: "Alerts"
      }, {
        value: "numBuildings",
        label: "Buildings"
      }, {
        value: "numAps",
        label: "APs"
      }] }),
      /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(SearchOutlined, {}), type: "text" })
    ] });
  }, [isMarketsVenues, sortBy]);
  const marketData = React__default.useMemo(() => {
    if (!isSpecificMarket)
      return null;
    return null;
  }, [isSpecificMarket]);
  const venueData = React__default.useMemo(() => {
    if (!isSpecificVenue)
      return null;
    const counts2 = {
      buildings: listData.length || 0,
      aps: aps.length || 0,
      devices: devices.length || 0
    };
    let data22 = [];
    let isDevices2 = false;
    if (activeFilter === "aps") {
      data22 = aps;
      isDevices2 = true;
    } else if (activeFilter === "devices") {
      data22 = devices;
      isDevices2 = true;
    } else {
      data22 = listData;
      isDevices2 = false;
    }
    return {
      data: data22.map((item) => ({
        ...item
        // indicator: INDICATOR_STYLE.find((i) => i.type === item.type)?.color || '#FF4D4F',
      })),
      isDevices: isDevices2,
      counts: counts2,
      items: [{
        key: "buildings",
        label: "Buildings"
      }, {
        key: "aps",
        label: "APs"
      }, {
        key: "devices",
        label: "Devices"
      }],
      subTitle: activeItem.name
    };
  }, [isSpecificVenue, listData, aps, devices, activeFilter, activeItem]);
  const getLevelsFor = React__default.useCallback((allLevels, buildingId) => allLevels == null ? void 0 : allLevels.filter((l2) => l2.buildingId === buildingId).sort((a2, b2) => Number(b2.levelNumber) - Number(a2.levelNumber)), []);
  const buildingData = React__default.useMemo(() => {
    if (!isSpecificBuilding)
      return null;
    const counts2 = {
      aps: (aps == null ? void 0 : aps.length) || 0,
      devices: (devices == null ? void 0 : devices.length) || 0
    };
    let data22 = [];
    let isDevices2 = false;
    data22 = aps == null ? void 0 : aps.filter((item) => {
      var _a4, _b3;
      return !((_a4 = filters == null ? void 0 : filters.building) == null ? void 0 : _a4.status) || item.networkStatus === ((_b3 = filters == null ? void 0 : filters.building) == null ? void 0 : _b3.status);
    });
    if (activeFilter === "devices") {
      data22 = devices;
      data22 = devices == null ? void 0 : devices.filter((item) => {
        var _a4, _b3;
        return !((_a4 = filters == null ? void 0 : filters.building) == null ? void 0 : _a4.status) || item.networkStatus === ((_b3 = filters == null ? void 0 : filters.building) == null ? void 0 : _b3.status);
      });
      data22 = devices == null ? void 0 : devices.filter((item) => {
        var _a4, _b3;
        return !((_a4 = filters == null ? void 0 : filters.building) == null ? void 0 : _a4.deviceType) || item.assetType === ((_b3 = filters == null ? void 0 : filters.building) == null ? void 0 : _b3.deviceType);
      });
      isDevices2 = true;
    } else {
      data22 = aps == null ? void 0 : aps.filter((item) => {
        var _a4, _b3;
        return !((_a4 = filters == null ? void 0 : filters.building) == null ? void 0 : _a4.status) || item.networkStatus === ((_b3 = filters == null ? void 0 : filters.building) == null ? void 0 : _b3.status);
      });
      isDevices2 = true;
    }
    return {
      header: {
        ...activeItem,
        buildingId: activeItem.id,
        title: "Building Overview",
        enableHealth: true,
        health: activeItem.health || 85
      },
      levels: getLevelsFor(listData, activeItem.id),
      data: data22,
      // devices
      isDevices: isDevices2,
      counts: counts2,
      items: [{
        key: "aps",
        label: "APs"
      }, {
        key: "devices",
        label: "Devices"
      }],
      subTitle: activeItem.name
    };
  }, [activeFilter, filters, activeItem, aps, devices, getLevelsFor, isSpecificBuilding, listData]);
  const levelData = React__default.useMemo(() => {
    var _a4;
    if (!isSpecificLevel)
      return null;
    const counts2 = {
      aps: (aps == null ? void 0 : aps.length) || 0,
      devices: (devices == null ? void 0 : devices.length) || 0
    };
    let data22 = [];
    let isDevices2 = false;
    if (activeFilter === "devices") {
      data22 = devices;
      isDevices2 = true;
    } else {
      data22 = aps;
      isDevices2 = true;
    }
    const levels2 = getLevelsFor((_a4 = rawData == null ? void 0 : rawData.building) == null ? void 0 : _a4.list, rawHierarchy == null ? void 0 : rawHierarchy.buildingId);
    return {
      header: {
        ...activeItem,
        title: activeItem.name,
        buildingId: rawHierarchy == null ? void 0 : rawHierarchy.buildingId
      },
      levels: levels2,
      data: data22,
      // devices
      isDevices: isDevices2,
      counts: counts2,
      items: [{
        key: "aps",
        label: "APs"
      }, {
        key: "devices",
        label: "Devices"
      }],
      subTitle: activeItem.parentName
    };
  }, [activeFilter, activeItem, aps, devices, getLevelsFor, isSpecificLevel, (_a3 = rawData == null ? void 0 : rawData.building) == null ? void 0 : _a3.list, rawHierarchy == null ? void 0 : rawHierarchy.buildingId]);
  const {
    data: data2,
    counts,
    items,
    extra,
    isDevices,
    levels,
    header,
    subTitle
  } = React__default.useMemo(() => {
    if (isMarketsVenues) {
      return {
        ...marketsOrVenuesData || {},
        extra: marketsOrVenuesExtra,
        items: [{
          key: "all",
          label: "All"
        }, {
          key: "favorites",
          label: "Favorites"
        }],
        subTitle: activeItem == null ? void 0 : activeItem.name
      };
    }
    if (isSpecificMarket) {
      return {
        ...marketData || {},
        extra: marketsOrVenuesExtra,
        items: [{
          key: "venues",
          label: "Venues"
        }, {
          key: "others",
          label: "Others"
        }],
        subTitle: activeItem == null ? void 0 : activeItem.name
      };
    }
    if (isSpecificVenue) {
      return venueData || {};
    }
    if (isSpecificBuilding) {
      return buildingData || {};
    }
    if (isSpecificLevel) {
      return levelData || {};
    }
    return {};
  }, [buildingData, isMarketsVenues, isSpecificBuilding, isSpecificMarket, isSpecificVenue, isSpecificLevel, marketData, marketsOrVenuesData, marketsOrVenuesExtra, venueData, levelData, activeItem]);
  return {
    listData: data2,
    subTitle,
    isDevices,
    activeFilter,
    setActiveFilter,
    counts,
    extra,
    items,
    header,
    filters,
    apsStatuses,
    deviceTypes,
    applyFilters,
    clearFilters,
    levels
  };
}
function useVisibility(props) {
  const {
    hierarchy = {},
    visibility: visibilityIn = {}
  } = props;
  const {
    regionId,
    marketId,
    clusterId,
    venueId,
    buildingId,
    levelId
  } = hierarchy || {};
  const {
    heatmap: enableHeatmap = false,
    singleColor = true
  } = visibilityIn;
  const {
    enableRegion,
    enableMarket,
    enableCluster,
    enableVenue,
    enableBuilding,
    enableLevel,
    enableZones
  } = React__default.useMemo(() => {
    const {
      enableRegion: enableRegion2 = true,
      enableMarket: enableMarket2 = true,
      enableCluster: enableCluster2 = true,
      enableVenue: enableVenue2 = true,
      enableBuilding: enableBuilding2 = true,
      enableLevel: enableLevel2 = true,
      boundaries = true,
      // topology = true,
      enableZonesTab = false,
      ...others
    } = visibilityIn || {};
    const enableZones2 = {};
    Object.keys(others).forEach((key) => {
      if (key.startsWith("enableZone-")) {
        const zoneType = key.split("enableZone-")[1];
        if (zoneType)
          enableZones2[zoneType] = others[key] && boundaries && enableZonesTab;
      }
    });
    if (boundaries === false) {
      return {
        enableZones: enableZones2,
        enableRegion: false,
        enableMarket: false,
        enableCluster: false,
        enableVenue: false,
        enableBuilding: false,
        enableLevel: false
      };
    }
    if (enableZonesTab) {
      return {
        enableZones: enableZones2,
        enableRegion: enableRegion2,
        enableMarket: enableMarket2,
        enableCluster: enableCluster2,
        enableVenue: false,
        enableBuilding: false,
        enableLevel: false
      };
    }
    if (levelId) {
      return {
        enableZones: enableZones2,
        enableLevel: enableLevel2,
        enableBuilding: enableBuilding2,
        enableVenue: enableVenue2,
        enableMarket: false,
        enableCluster: false,
        enableRegion: false
      };
    }
    if (buildingId) {
      return {
        enableZones: enableZones2,
        enableLevel: false,
        enableBuilding: enableBuilding2,
        enableVenue: enableVenue2,
        enableCluster: enableCluster2,
        enableMarket: enableMarket2,
        enableRegion: false
      };
    }
    if (venueId) {
      return {
        enableZones: enableZones2,
        enableLevel: false,
        enableBuilding: enableBuilding2,
        enableVenue: enableVenue2,
        enableCluster: enableCluster2,
        enableMarket: enableMarket2,
        enableRegion: enableRegion2
      };
    }
    if (clusterId) {
      return {
        enableZones: enableZones2,
        enableLevel: false,
        enableBuilding: false,
        enableVenue: enableVenue2,
        enableCluster: enableCluster2,
        enableMarket: enableMarket2,
        enableRegion: enableRegion2
      };
    }
    if (marketId) {
      return {
        enableZones: enableZones2,
        enableLevel: false,
        enableBuilding: false,
        enableVenue: enableVenue2,
        enableCluster: enableCluster2,
        enableMarket: enableMarket2,
        enableRegion: enableRegion2
      };
    }
    if (regionId) {
      return {
        enableZones: enableZones2,
        enableLevel: false,
        enableBuilding: false,
        enableVenue: enableVenue2,
        enableCluster: enableCluster2,
        enableMarket: enableMarket2,
        enableRegion: enableRegion2
      };
    }
    return {
      enableZones: enableZones2,
      enableLevel: false,
      enableBuilding: false,
      enableVenue: false,
      enableCluster: enableCluster2,
      enableMarket: enableMarket2,
      enableRegion: enableRegion2
    };
  }, [visibilityIn, levelId, buildingId, venueId, clusterId, marketId, regionId]);
  const levelVisibility = React__default.useMemo(() => {
    const extra = {};
    if (levelId)
      extra[levelId] = enableLevel;
    return extra;
  }, [enableLevel, levelId]);
  return {
    ...visibilityIn || {},
    enableZones,
    enableRegion,
    enableMarket,
    enableCluster,
    enableVenue,
    enableBuilding,
    enableLevel,
    enableHeatmap,
    heatmapColor: singleColor ? "single" : "multi",
    ...levelVisibility
  };
}
const styles = {
  "right-pane-toggle-button": "_right-pane-toggle-button_1ksde_1"
};
function RightPaneToggleButton({
  collapsed,
  onToggle
}) {
  return /* @__PURE__ */ jsx("div", { style: {
    position: "absolute",
    bottom: "50%",
    right: collapsed ? 10 : 382,
    zIndex: 5e3
  }, children: /* @__PURE__ */ jsx(Button, { bordered: false, onClick: onToggle, className: styles["right-pane-toggle-button"], icon: collapsed ? /* @__PURE__ */ jsx(LeftOutlined, {}) : /* @__PURE__ */ jsx(RightOutlined, {}) }) });
}
RightPaneToggleButton.propTypes = {
  collapsed: propTypesExports$1.bool,
  onToggle: propTypesExports$1.func
};
RightPaneToggleButton.defaultProps = {
  collapsed: false,
  onToggle: () => {
  }
};
const STYLES = [{
  type: "minor",
  color: "#389E0D",
  opacity: "0.3",
  borderColor: "#00",
  borderWidth: 1
}, {
  type: "major",
  color: "#FAAD14",
  opacity: "0.4",
  borderColor: "#00",
  borderWidth: 1
}, {
  type: "critical",
  color: "#FF4D4F",
  opacity: 1,
  borderColor: "#00",
  borderWidth: 1
}];
const LEVEL_CONTAINER = "level_container_selector_right_bottom";
const HEIGHT = 36;
const MOUSE_WHEEL_SPEED = 5;
function SideList(props) {
  const {
    data: data2,
    styles: styles2,
    onClick: onClick2
  } = props;
  const {
    token
  } = theme$2.useToken();
  const onMouseWheel = React__default.useCallback((event) => {
    const container = document.getElementById(LEVEL_CONTAINER);
    const topPosition = container.scrollTop;
    if (!container)
      return;
    if (event.deltaY < 0) {
      if (topPosition > 0) {
        container.scrollTop -= HEIGHT * MOUSE_WHEEL_SPEED;
      }
    } else if (event.deltaY > 0) {
      container.scrollTop += HEIGHT * MOUSE_WHEEL_SPEED;
    }
  }, []);
  const renderItem = React__default.useCallback((item) => {
    var _a3;
    return /* @__PURE__ */ jsxs(List$3.Item, { onWheel: onMouseWheel, style: {
      backgroundColor: ((_a3 = styles2.find((i2) => i2.type === item.value)) == null ? void 0 : _a3.color) || token.colorBgBase,
      justifyContent: "center",
      marginBottom: "1px",
      position: "relative",
      padding: 4
    }, children: [
      /* @__PURE__ */ jsx(Button, { type: "ghost", style: {
        padding: 0,
        margin: 0
      }, onClick: () => onClick2(item.id), children: item.label }),
      item.badge && /* @__PURE__ */ jsx("div", { style: {
        position: "absolute",
        top: "0px",
        right: "0px",
        backgroundColor: token.colorBgBase,
        borderRadius: "0 0 0 4px",
        width: "16px",
        height: "12px",
        justifyContent: "center",
        alignItems: "center",
        display: "flex"
      }, children: /* @__PURE__ */ jsx(Typography.Text, { style: {
        fontSize: "8px"
      }, children: item.badge }) })
    ] });
  }, [onClick2, styles2, onMouseWheel, token.colorBgBase]);
  return /* @__PURE__ */ jsx(List$3, { id: LEVEL_CONTAINER, itemLayout: "horizontal", dataSource: data2, renderItem });
}
SideList.propTypes = {
  data: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    value: propTypesExports$1.string,
    label: propTypesExports$1.string,
    badge: propTypesExports$1.string
  }),
  styles: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    type: propTypesExports$1.string,
    // matched with item value
    color: propTypesExports$1.string
  })),
  onClick: propTypesExports$1.func
};
SideList.defaultProps = {
  data: [],
  styles: STYLES,
  onClick: () => {
  }
};
const breadcrumb = "";
const {
  Text
} = Typography;
function DynamicBreadcrumb(props) {
  const {
    onClick: onClickIn = () => {
    },
    items = [],
    hideBackBtn = false
  } = props;
  const activeTheme = useEnvStore((state) => state.env.activeTheme);
  const lastIndex = React__default.useMemo(() => items.length - 1, [items]);
  const onClick2 = React__default.useCallback((key) => {
    if (!key) {
      onClickIn(null);
    } else {
      const input = {};
      switch (key) {
        case "market":
          input.venueId = null;
          break;
        case "venue":
          input.buildingId = null;
          break;
        case "building":
          input.levelId = null;
          break;
      }
      onClickIn(input);
    }
  }, [onClickIn]);
  const renderBreadcrumb = React__default.useMemo(() => {
    const breadcrumbItems = items.length > 2 ? [{
      key: "parent",
      label: "..."
    }, ...items.slice(-2)] : items;
    return /* @__PURE__ */ jsxs(Breadcrumb, { children: [
      !hideBackBtn && /* @__PURE__ */ jsx(Breadcrumb.Item, { onClick: () => onClick2(), children: /* @__PURE__ */ jsx(Text, { type: "secondary", className: "my-breadcrumb", children: "Back" }) }),
      breadcrumbItems.map(({
        key,
        label
      }, index2) => {
        const isParentItem = key === "parent";
        const isLastItem = index2 === lastIndex;
        return /* @__PURE__ */ jsx(Breadcrumb.Item, { ...!isLastItem && !isParentItem && {
          onClick: () => onClick2(key)
        }, children: /* @__PURE__ */ jsx(Text, { type: "secondary", className: isLastItem ? `my-breadcrumb-lastItem ${activeTheme}-theme` : `my-breadcrumb ${activeTheme}-theme`, children: isLastItem ? TextUtil.toTitleCase(`${key} details`) : TextUtil.toTitleCase(label) }) }, key);
      })
    ] });
  }, [hideBackBtn, items, onClick2, activeTheme, lastIndex]);
  return renderBreadcrumb;
}
DynamicBreadcrumb.propTypes = {
  items: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    key: propTypesExports$1.string,
    label: propTypesExports$1.string
  })),
  onClick: propTypesExports$1.func,
  hideBackBtn: propTypesExports$1.bool
};
function Center(props) {
  const {
    style: style2,
    children
  } = props;
  return /* @__PURE__ */ jsx("div", { style: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    ...style2
  }, children });
}
Center.propTypes = {
  style: propTypesExports$1.object,
  children: propTypesExports$1.node
};
Center.defaultProps = {
  style: {},
  children: null
};
const tabItems = [{
  key: "markets",
  label: "Markets"
}, {
  key: "venues",
  label: "Venues"
}];
function MarketsVenuesRadio({
  value: activeTab,
  onChange: onTabChange
}) {
  return /* @__PURE__ */ jsx(Center, { children: /* @__PURE__ */ jsx(Radio.Group, { value: activeTab, onChange: (e3) => onTabChange(e3.target.value), disabled: true, children: tabItems.map((item) => /* @__PURE__ */ jsx(Radio.Button, { value: item.key, style: {
    width: "162px"
  }, children: /* @__PURE__ */ jsx(Center, { children: item.label }) }, item.key)) }) });
}
MarketsVenuesRadio.propTypes = {
  value: propTypesExports$1.string.isRequired,
  onChange: propTypesExports$1.func.isRequired
};
const SUPPORTED_TAGS = {
  important: {
    icon: /* @__PURE__ */ jsx(ExclamationCircleOutlined, {}),
    color: "warning",
    label: "Important"
  },
  active: {
    icon: /* @__PURE__ */ jsx(CheckCircleOutlined, {}),
    color: "success",
    label: "Active"
  },
  inactive: {
    icon: /* @__PURE__ */ jsx(CloseCircleOutlined, {}),
    color: "error",
    label: "Inactive"
  }
};
function ItemCard(props) {
  const {
    id,
    title,
    summary,
    description: description2,
    loading: loading2,
    tags,
    isFavorite,
    enableFavorite,
    toggleFavorite,
    thumbnail,
    icon,
    onInfoClick,
    button,
    hoverOnly,
    bordered,
    hoverable,
    children,
    descriptionStyle,
    titleStyle,
    extra
  } = props;
  const [showButton, setShowButton] = React__default.useState(false);
  const [showDescription, setShowDescription] = React__default.useState(false);
  const {
    token
  } = theme$2.useToken();
  const toggleDescription = React__default.useCallback(() => {
    setShowDescription((previous) => {
      onInfoClick(id, !previous);
      return !previous;
    });
  }, [id, onInfoClick]);
  const avatar = React__default.useMemo(() => {
    if (icon)
      return icon;
    if (thumbnail)
      return /* @__PURE__ */ jsx(Image$1, { preview: false, alt: "building", src: thumbnail, width: 40, height: 40, style: {
        marginTop: "6px"
      } });
    return null;
  }, [icon, thumbnail]);
  const cardTitle = React__default.useMemo(() => /* @__PURE__ */ jsxs(Space, { style: {
    justifyContent: "space-between",
    width: "100%",
    ...titleStyle
  }, children: [
    /* @__PURE__ */ jsxs(Typography.Text, { ellipsis: true, children: [
      " ",
      title
    ] }),
    /* @__PURE__ */ jsxs(Space, { children: [
      tags.map((key) => {
        const {
          icon: icon2,
          color,
          label
        } = SUPPORTED_TAGS[key] || {};
        if (!label)
          return null;
        return /* @__PURE__ */ jsx(Tag, { icon: icon2, color, children: label }, key);
      }),
      enableFavorite && /* @__PURE__ */ jsx(Button, { type: "text", icon: isFavorite ? /* @__PURE__ */ jsx(StarFilled, { style: {
        color: token.colorPrimaryActive
      } }) : /* @__PURE__ */ jsx(StarFilled, { style: {
        color: token.colorBorder
      } }), onClick: () => toggleFavorite(id) })
    ] })
  ] }), [titleStyle, title, tags, enableFavorite, isFavorite, token.colorPrimaryActive, token.colorBorder, toggleFavorite, id]);
  const infoblock = React__default.useMemo(() => {
    if (!description2)
      return null;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      showDescription && description2,
      /* @__PURE__ */ jsxs(Space, { style: {
        display: "flex",
        justifyContent: "space-between"
      }, children: [
        /* @__PURE__ */ jsx(Button, { type: "link", style: {
          display: "block",
          border: "none",
          boxShadow: "none",
          padding: 0,
          margin: 0
        }, onClick: toggleDescription, children: showDescription ? "Hide info" : "More info" }),
        showDescription && /* @__PURE__ */ jsxs(Button, { size: "medium", style: {
          margin: 0,
          padding: 0,
          width: "80px"
        }, type: "primary", children: [
          /* @__PURE__ */ jsx(RightCircleFilled, {}),
          "Explore"
        ] })
      ] })
    ] });
  }, [description2, showDescription, toggleDescription]);
  const renderContent = React__default.useMemo(() => {
    const content = /* @__PURE__ */ jsx(Card, { style: {
      borderRadius: 0,
      backgroundColor: "transparent",
      flex: 1
    }, bordered: false, styles: {
      body: {
        padding: `16px 0px ${showDescription ? 8 : 0}px 16px`
      }
    }, children: /* @__PURE__ */ jsx(Card.Meta, { style: {
      marginInline: "6px"
    }, avatar, title: cardTitle, description: /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: descriptionStyle, children: [
      summary,
      infoblock,
      children
    ] }) }) });
    if (!extra)
      return content;
    return /* @__PURE__ */ jsxs(Space, { style: {
      justifyContent: "space-around",
      width: "100%"
    }, children: [
      content,
      extra
    ] });
  }, [showDescription, avatar, cardTitle, descriptionStyle, summary, infoblock, children, extra]);
  return /* @__PURE__ */ jsxs(Card, { style: {
    width: "100%",
    height: "100%",
    backgroundColor: hoverable && showButton ? token.colorFillQuaternary : "transparent",
    borderRadius: 0
  }, styles: {
    body: {
      padding: 0,
      margin: 0,
      display: "flex"
    }
  }, onMouseEnter: () => setShowButton(true), onMouseLeave: () => setShowButton(false), loading: loading2, hoverable, bordered, children: [
    renderContent,
    (showButton || !hoverOnly) && !showDescription ? button : void 0
  ] });
}
ItemCard.propTypes = {
  id: propTypesExports$1.string.isRequired,
  title: propTypesExports$1.string,
  button: propTypesExports$1.node,
  hoverOnly: propTypesExports$1.bool,
  // show button only on hover
  loading: propTypesExports$1.bool,
  thumbnail: propTypesExports$1.any,
  icon: propTypesExports$1.node,
  isFavorite: propTypesExports$1.bool,
  tags: propTypesExports$1.arrayOf(propTypesExports$1.oneOf(Object.keys(SUPPORTED_TAGS))),
  enableFavorite: propTypesExports$1.bool,
  toggleFavorite: propTypesExports$1.func,
  summary: propTypesExports$1.any,
  description: propTypesExports$1.any,
  onInfoClick: propTypesExports$1.func,
  bordered: propTypesExports$1.bool,
  hoverable: propTypesExports$1.bool,
  children: propTypesExports$1.node,
  descriptionStyle: propTypesExports$1.object,
  titleStyle: propTypesExports$1.object,
  extra: propTypesExports$1.node
};
ItemCard.defaultProps = {
  title: "",
  summary: "",
  description: "",
  loading: false,
  tags: [],
  isFavorite: false,
  enableFavorite: false,
  toggleFavorite: () => {
  },
  thumbnail: null,
  icon: null,
  onInfoClick: () => {
  },
  button: null,
  hoverOnly: false,
  bordered: true,
  hoverable: true,
  children: null,
  descriptionStyle: {},
  titleStyle: {},
  extra: null
};
const DETAILS = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.";
function MarketCard(props) {
  const {
    id,
    numBuildings,
    numAps,
    numAlerts,
    indicator,
    details,
    onClick: onClick2,
    ...restProps
  } = props;
  const summary = React__default.useMemo(() => /* @__PURE__ */ jsxs(Typography.Text, { type: "secondary", children: [
    numBuildings,
    " buildings / ",
    numAps,
    " APs",
    numAlerts > 0 && typeof indicator === "string" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { children: " / " }),
      /* @__PURE__ */ jsx(Indicator, { color: indicator, size: 9, style: {
        marginLeft: "5px"
      } }),
      /* @__PURE__ */ jsxs("span", { style: {
        color: indicator
      }, children: [
        numAlerts,
        " Alerts"
      ] })
    ] })
  ] }), [indicator, numAlerts, numAps, numBuildings]);
  const button = React__default.useMemo(() => /* @__PURE__ */ jsx(Button, { type: "link", icon: /* @__PURE__ */ jsx(RightCircleFilled, {}), onClick: () => onClick2(id), style: {
    height: "auto"
  } }), [id, onClick2]);
  return /* @__PURE__ */ jsx(ItemCard, { id, button, summary, description: details, hoverOnly: true, ...restProps, tags: [] });
}
MarketCard.propTypes = {
  id: propTypesExports$1.string.isRequired,
  details: propTypesExports$1.string,
  numBuildings: propTypesExports$1.number,
  numAps: propTypesExports$1.number,
  numAlerts: propTypesExports$1.number,
  indicator: propTypesExports$1.string,
  onClick: propTypesExports$1.func
};
MarketCard.defaultProps = {
  details: DETAILS,
  numBuildings: 0,
  numAps: 0,
  numAlerts: 0,
  indicator: null,
  onClick: () => {
  }
};
function VenueCard(props) {
  const {
    id,
    numBuildings,
    numAps,
    numAlerts,
    indicator,
    isImportant,
    description: description2,
    onClick: onClick2,
    ...restProps
  } = props;
  const summary = React__default.useMemo(() => /* @__PURE__ */ jsxs(Typography.Text, { type: "secondary", children: [
    numBuildings,
    " buildings / ",
    numAps,
    " APs",
    numAlerts > 0 && typeof indicator === "string" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { children: " / " }),
      /* @__PURE__ */ jsx(Indicator, { color: indicator, size: 9, style: {
        marginLeft: "5px"
      } }),
      /* @__PURE__ */ jsxs("span", { style: {
        color: indicator
      }, children: [
        numAlerts,
        " Alerts"
      ] })
    ] })
  ] }), [indicator, numAlerts, numAps, numBuildings]);
  const button = React__default.useMemo(() => /* @__PURE__ */ jsx(Button, { type: "link", icon: /* @__PURE__ */ jsx(RightCircleFilled, {}), onClick: () => onClick2(id), style: {
    height: "auto"
  } }), [id, onClick2]);
  const tags = React__default.useMemo(() => isImportant ? ["important"] : [], [isImportant]);
  return /* @__PURE__ */ jsx(ItemCard, { id, summary, description: description2 || "-", enableFavorite: true, button, hoverOnly: true, ...restProps, tags });
}
VenueCard.propTypes = {
  id: propTypesExports$1.string.isRequired,
  description: propTypesExports$1.string,
  numBuildings: propTypesExports$1.number,
  numAps: propTypesExports$1.number,
  numAlerts: propTypesExports$1.number,
  indicator: propTypesExports$1.string,
  isImportant: propTypesExports$1.bool,
  onClick: propTypesExports$1.func
};
VenueCard.defaultProps = {
  description: "",
  numBuildings: 0,
  numAps: 0,
  numAlerts: 0,
  indicator: null,
  isImportant: false,
  onClick: () => {
  }
};
function BuildingCard(props) {
  const {
    id,
    numLevels,
    numAps,
    numAlerts,
    indicator,
    isImportant,
    onClick: onClick2,
    hasModel3d,
    ...restProps
  } = props;
  const {
    token
  } = theme$2.useToken();
  const summary = React__default.useMemo(() => /* @__PURE__ */ jsxs(Typography.Text, { type: "secondary", children: [
    numLevels,
    " levels / ",
    numAps,
    " APs",
    numAlerts > 0 && typeof indicator === "string" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("span", { children: " / " }),
      /* @__PURE__ */ jsx(Indicator, { color: indicator, size: 9, style: {
        marginLeft: "5px"
      } }),
      /* @__PURE__ */ jsxs("span", { style: {
        color: indicator
      }, children: [
        numAlerts,
        " Alerts"
      ] })
    ] })
  ] }), [indicator, numAlerts, numAps, numLevels]);
  const tags = React__default.useMemo(() => isImportant ? ["important"] : [], [isImportant]);
  const button = React__default.useMemo(() => /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    gap: 0,
    height: "76px",
    justifyContent: "space-between"
  }, children: [
    /* @__PURE__ */ jsx(Button, { type: "link", onClick: () => onClick2(id, "2d"), style: {
      height: "38px",
      borderColor: token.colorBorder,
      borderRadius: 0,
      borderTopStyle: "none"
    }, children: "2D" }),
    /* @__PURE__ */ jsx(Button, { type: "link", onClick: () => onClick2(id, "3d"), style: {
      height: "38px",
      borderColor: token.colorBorder,
      borderRadius: 0,
      borderTopStyle: "none",
      borderBottomStyle: "none"
    }, disabled: !hasModel3d, children: "3D" })
  ] }), [id, token, onClick2, hasModel3d]);
  return /* @__PURE__ */ jsx(ItemCard, { summary, button, enableFavorite: true, ...restProps, description: null, tags });
}
BuildingCard.propTypes = {
  id: propTypesExports$1.string.isRequired,
  numLevels: propTypesExports$1.number,
  numAps: propTypesExports$1.number,
  numAlerts: propTypesExports$1.number,
  hasModel3d: propTypesExports$1.bool,
  indicator: propTypesExports$1.string,
  isImportant: propTypesExports$1.bool,
  onClick: propTypesExports$1.func
};
BuildingCard.defaultProps = {
  numLevels: 0,
  numAps: 0,
  numAlerts: 0,
  indicator: null,
  isImportant: false,
  onClick: () => {
  },
  hasModel3d: false
};
const DETAILED_INFO = {
  name: {
    label: "Device Name"
  },
  deploymentStatus: {
    label: "Deployment Status"
  },
  assetMappingState: {
    label: "GIS Status"
  },
  macAddress: {
    label: "MAC Address"
  },
  ipAddress: {
    label: "IP Address"
  }
};
function DeviceCard(props) {
  const {
    id,
    isImportant,
    onInfoClick,
    onClick: onClick2,
    getDeviceIcon,
    ...attributes
  } = props;
  const description2 = React__default.useMemo(() => /* @__PURE__ */ jsx(Fragment, { children: Object.keys(DETAILED_INFO).map((key) => /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(Space, { style: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    }, children: [
      /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", style: {
        margin: 0,
        padding: 0
      }, children: DETAILED_INFO[key].label }),
      /* @__PURE__ */ jsx(Typography.Text, { style: {
        margin: 0,
        padding: 0
      }, children: attributes[key] || "-" })
    ] }),
    /* @__PURE__ */ jsx(Divider, { dashed: true, style: {
      margin: 0,
      padding: 0
    } })
  ] })) }), [attributes]);
  const status = React__default.useMemo(() => (attributes == null ? void 0 : attributes.networkStatus) || "", [attributes]);
  const tags = React__default.useMemo(() => {
    const result = isImportant ? ["important"] : [];
    if (status === "active")
      result.push("active");
    if (status === "inactive")
      result.push("inactive");
    return result;
  }, [isImportant, status]);
  const icon = React__default.useMemo(() => getDeviceIcon == null ? void 0 : getDeviceIcon(attributes == null ? void 0 : attributes.assetType), [attributes == null ? void 0 : attributes.assetType, getDeviceIcon]);
  return /* @__PURE__ */ jsx(ItemCard, { title: `ID - ${attributes.serialNumber || "NA"}`, summary: attributes.assetType || "Undefined", description: description2, descriptionStyle: {
    width: "100%",
    paddingRight: "8px"
  }, tags, icon: /* @__PURE__ */ jsx(Button, { icon, type: "default" }), onClick: onClick2, onInfoClick }, id);
}
DeviceCard.propTypes = {
  id: propTypesExports$1.string,
  isImportant: propTypesExports$1.bool,
  onInfoClick: propTypesExports$1.func,
  onClick: propTypesExports$1.func,
  getDeviceIcon: propTypesExports$1.func
};
DeviceCard.defaultProps = {
  id: "",
  isImportant: false,
  onInfoClick: () => {
  },
  onClick: () => {
  },
  getDeviceIcon: () => null
};
function VscSettings(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 16 16", "fill": "currentColor" }, "child": [{ "tag": "path", "attr": { "fillRule": "evenodd", "clipRule": "evenodd", "d": "M3.5 2h-1v5h1V2zm6.1 5H6.4L6 6.45v-1L6.4 5h3.2l.4.5v1l-.4.5zm-5 3H1.4L1 9.5v-1l.4-.5h3.2l.4.5v1l-.4.5zm3.9-8h-1v2h1V2zm-1 6h1v6h-1V8zm-4 3h-1v3h1v-3zm7.9 0h3.19l.4-.5v-.95l-.4-.5H11.4l-.4.5v.95l.4.5zm2.1-9h-1v6h1V2zm-1 10h1v2h-1v-2z" } }] })(props);
}
const STATUS_STYLE = {
  active: "#389E0D",
  inactive: "#FF4D4F"
};
function BuildingHeaderCard(props) {
  const {
    id,
    buildingId,
    title,
    numActive,
    numInactive,
    displayMode: displayMode2,
    setDisplayMode,
    children,
    enableHealth,
    health,
    onNavigate,
    filters,
    applyFilters,
    clearFilters,
    deviceTypes,
    apsStatuses,
    hasModel3d,
    ...restProps
  } = props;
  const {
    token
  } = theme$2.useToken();
  const [localFilters, setLocalFilters] = useState(filters);
  const handleFilterChange = React__default.useCallback((key, value) => {
    setLocalFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value
    }));
  }, []);
  const handleApplyFilters = React__default.useCallback(() => {
    applyFilters("building", {
      ...localFilters
    });
  }, [applyFilters, localFilters]);
  const handleClearFilters = React__default.useCallback(() => {
    clearFilters("building");
    setLocalFilters(filters);
  }, [clearFilters, filters]);
  const summary = useMemo(() => /* @__PURE__ */ jsx(Typography.Text, { type: "secondary", children: /* @__PURE__ */ jsxs(Space, { size: "large", children: [
    /* @__PURE__ */ jsxs("span", { style: {
      color: STATUS_STYLE.active
    }, children: [
      numActive,
      " active"
    ] }),
    /* @__PURE__ */ jsxs("span", { style: {
      color: STATUS_STYLE.inactive
    }, children: [
      numInactive,
      " inactive"
    ] })
  ] }) }), [numActive, numInactive]);
  const filterContent = React__default.useMemo(() => /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    gap: "10px",
    margin: 0,
    padding: "10px",
    alignContent: "center"
  }, children: [
    /* @__PURE__ */ jsxs(Select$1, { style: {
      width: "190px",
      height: "40px"
    }, placeholder: "Status", suffixIcon: /* @__PURE__ */ jsx(CaretDownFilled, {}), value: localFilters.status || "", onChange: (value) => handleFilterChange("status", value), children: [
      /* @__PURE__ */ jsx(Select$1.Option, { value: "", children: "All" }),
      apsStatuses.map((status) => /* @__PURE__ */ jsx(Select$1.Option, { value: status, children: status.charAt(0).toUpperCase() + status.slice(1) }, status))
    ] }),
    /* @__PURE__ */ jsxs(Select$1, { style: {
      width: "190px",
      height: "40px"
    }, placeholder: "Device Type", suffixIcon: /* @__PURE__ */ jsx(CaretDownFilled, {}), value: localFilters.deviceType || "", onChange: (value) => handleFilterChange("deviceType", value), children: [
      /* @__PURE__ */ jsx(Select$1.Option, { value: "", children: "All" }),
      deviceTypes.map((type) => /* @__PURE__ */ jsx(Select$1.Option, { value: type, children: type.charAt(0).toUpperCase() + type.slice(1) }, type))
    ] }),
    /* @__PURE__ */ jsx(Button, { type: "primary", style: {
      width: "190px",
      height: "33px"
    }, onClick: handleApplyFilters, children: "Apply Filters" }),
    /* @__PURE__ */ jsx(Button, { type: "default", style: {
      width: "190px",
      height: "33px"
    }, onClick: handleClearFilters, children: "Clear Filters" })
  ] }), [apsStatuses, deviceTypes, handleApplyFilters, handleClearFilters, handleFilterChange, localFilters]);
  const button = useMemo(() => /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
    gap: 0,
    height: "114px"
  }, children: [
    /* @__PURE__ */ jsx(Button, { type: "link", onClick: () => setDisplayMode("2d"), style: {
      height: "38px",
      borderColor: token.colorBorder,
      borderRadius: 0,
      borderTopStyle: "none",
      backgroundColor: displayMode2 === "2d" ? "rgba(255,255,255,0.15)" : void 0
    }, children: "2D" }),
    /* @__PURE__ */ jsx(Button, { type: "link", onClick: () => setDisplayMode("3d"), style: {
      height: "38px",
      borderColor: token.colorBorder,
      borderRadius: 0,
      borderTopStyle: "none",
      borderBottomStyle: "none",
      backgroundColor: displayMode2 === "3d" ? "rgba(255,255,255,0.15)" : void 0
    }, disabled: !hasModel3d, children: "3D" }),
    /* @__PURE__ */ jsx(Popover, { content: filterContent, trigger: "click", children: /* @__PURE__ */ jsx(Button, { type: "link", style: {
      height: "38px",
      borderColor: token.colorBorder,
      borderRadius: 0,
      borderBottomStyle: "none"
    }, icon: /* @__PURE__ */ jsx(VscSettings, { fontSize: "20px", style: {
      transform: "rotate(90deg)"
    } }), block: true }) })
  ] }), [token == null ? void 0 : token.colorBorder, displayMode2, hasModel3d, filterContent, setDisplayMode]);
  return /* @__PURE__ */ jsxs("div", { style: {
    width: "100%",
    display: "flex"
  }, children: [
    /* @__PURE__ */ jsx(Card, { style: {
      width: "36px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 0,
      background: "transparent",
      padding: 0,
      margin: 0
    }, styles: {
      body: {
        padding: 0,
        margin: 0
      }
    }, children: /* @__PURE__ */ jsx(Button, { type: "text", icon: /* @__PURE__ */ jsx(HomeFilled, {}), onClick: () => onNavigate({
      buildingId,
      levelId: null
    }) }) }),
    /* @__PURE__ */ jsx("div", { style: {
      width: "inherit"
    }, children: /* @__PURE__ */ jsx(ItemCard, { title, summary, button, hoverable: false, descriptionStyle: {
      justifyContent: "space-between",
      height: "74px"
    }, extra: enableHealth && /* @__PURE__ */ jsx("div", { style: {
      marginTop: "-22px"
    }, children: /* @__PURE__ */ jsx(ProgressBox, { value: health, label: "Health Rate", strokeColor: {
      "0%": "#52C41A",
      "100%": "#52C41A"
    } }) }), ...restProps, description: null, tags: [], children }) })
  ] });
}
BuildingHeaderCard.propTypes = {
  id: propTypesExports$1.string.isRequired,
  buildingId: propTypesExports$1.string,
  title: propTypesExports$1.string,
  numActive: propTypesExports$1.number,
  numInactive: propTypesExports$1.number,
  setDisplayMode: propTypesExports$1.func,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  children: propTypesExports$1.node,
  enableHealth: propTypesExports$1.bool,
  health: propTypesExports$1.number,
  onNavigate: propTypesExports$1.func,
  filters: propTypesExports$1.object.isRequired,
  hasModel3d: propTypesExports$1.bool,
  applyFilters: propTypesExports$1.func.isRequired,
  clearFilters: propTypesExports$1.func.isRequired,
  deviceTypes: propTypesExports$1.array,
  apsStatuses: propTypesExports$1.array
};
BuildingHeaderCard.defaultProps = {
  buildingId: "",
  title: "",
  numActive: 0,
  numInactive: 0,
  displayMode: "2d",
  setDisplayMode: () => {
  },
  children: null,
  enableHealth: false,
  health: 0,
  onNavigate: () => {
  },
  deviceTypes: [],
  apsStatuses: [],
  hasModel3d: false
};
function TheFilter({
  value,
  onChange,
  counts,
  extra,
  items
}) {
  var _a3;
  const getLabel4 = React__default.useCallback((item) => {
    const {
      label,
      key
    } = item;
    let finalLabel;
    if (!counts) {
      finalLabel = label;
    } else {
      const count3 = counts[key];
      if (typeof count3 === "undefined")
        finalLabel = label;
      else
        finalLabel = `${label} (${count3 || 0})`;
    }
    return /* @__PURE__ */ jsx(Typography.Text, { children: finalLabel });
  }, [counts]);
  return /* @__PURE__ */ jsx(Tabs, { activeKey: value, defaultActiveKey: ((_a3 = Object.keys(items)) == null ? void 0 : _a3[0]) || "", onChange, items: items.map((item) => ({
    key: item.key,
    label: getLabel4(item)
  })), renderTabBar: (props, DefaultTabBar) => /* @__PURE__ */ jsx(DefaultTabBar, { ...props, style: {
    margin: 0,
    borderBottom: "none"
  } }), tabBarExtraContent: extra });
}
TheFilter.propTypes = {
  extra: propTypesExports$1.node,
  value: propTypesExports$1.string.isRequired,
  onChange: propTypesExports$1.func.isRequired,
  counts: propTypesExports$1.shape({
    all: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number]),
    favorites: propTypesExports$1.oneOfType([propTypesExports$1.string, propTypesExports$1.number])
  }),
  items: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    key: propTypesExports$1.string,
    label: propTypesExports$1.string
  }))
};
TheFilter.defaultProps = {
  counts: {},
  extra: null,
  items: []
};
function Filters(props) {
  const {
    items,
    activeFilter,
    setActiveFilter,
    counts,
    extra,
    header,
    displayMode: displayMode2,
    setDisplayMode,
    onNavigate,
    filters,
    apsStatuses,
    deviceTypes,
    applyFilters,
    clearFilters
  } = props;
  const filter17 = React__default.useMemo(() => items && /* @__PURE__ */ jsx(TheFilter, { value: activeFilter, onChange: setActiveFilter, counts, extra, items }), [activeFilter, counts, extra, items, setActiveFilter]);
  if (header) {
    return /* @__PURE__ */ jsx(BuildingHeaderCard, { ...header, displayMode: displayMode2, setDisplayMode, onNavigate, filters, apsStatuses, deviceTypes, applyFilters, clearFilters, children: filter17 });
  }
  return /* @__PURE__ */ jsx("div", { style: {
    marginInline: "24px"
  }, children: filter17 });
}
Filters.propTypes = {
  items: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    key: propTypesExports$1.string,
    label: propTypesExports$1.string
  })),
  activeFilter: propTypesExports$1.string,
  setActiveFilter: propTypesExports$1.func,
  counts: propTypesExports$1.object,
  extra: propTypesExports$1.node,
  header: propTypesExports$1.object,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  setDisplayMode: propTypesExports$1.func,
  onNavigate: propTypesExports$1.func,
  filters: propTypesExports$1.object,
  apsStatuses: propTypesExports$1.array,
  deviceTypes: propTypesExports$1.array,
  applyFilters: propTypesExports$1.func,
  clearFilters: propTypesExports$1.func
};
Filters.defaultProps = {
  items: [],
  activeFilter: "",
  setActiveFilter: () => {
  },
  counts: {},
  extra: null,
  header: null,
  displayMode: "2d",
  setDisplayMode: () => {
  },
  onNavigate: () => {
  },
  filters: {},
  apsStatuses: [],
  deviceTypes: [],
  applyFilters: () => {
  },
  clearFilters: () => {
  }
};
const logo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0MjNfNjUyMikiPgo8cGF0aCBkPSJNMzcuNjE4NyA5Ljg4NDc3TDMxLjI2NzkgMTMuNTEyOEwzMS4yNjc5IDMzLjY0OTFMMzcuNjE4NyAyOS45MTlMMzcuNjE4NyA5Ljg4NDc3WiIgZmlsbD0iIzMzNERFRiIvPgo8cGF0aCBkPSJNMzEuMTE1IDI2LjQyNzdMMzcuNDY1OCAzMC4wNjQxTDIwLjI1NzIgNDBMMTMuOTU3NiAzNi4zMTI1TDMxLjExNSAyNi40Mjc3WiIgZmlsbD0iIzI2M0NDNyIvPgo8cGF0aCBkPSJNMjAuNDY0MSAxOS44NzIxTDI2LjgxNDkgMjMuNTA4NEw5LjYwNjMxIDMzLjQ0NDRMMy4zMDY3MyAyOS43NTY4TDIwLjQ2NDEgMTkuODcyMVoiIGZpbGw9IiMyNjNDQzciLz4KPHBhdGggZD0iTTMuMDAwMDMgOS44ODQ3N0w5LjM1MDgzIDEzLjUxMjhMOS4zNTA4MyAzMy42NDkxTDMuMDAwMDMgMjkuOTE5TDMuMDAwMDMgOS44ODQ3N1oiIGZpbGw9IiMzMzRERUYiLz4KPHBhdGggZD0iTTIwLjI1NTggLTIuNTM1NzJlLTA4TDI2LjYwNjYgMy42MzYzNUw5LjM5Nzk0IDEzLjU3MjNMMy4wOTgzNSA5Ljg4NDcyTDIwLjI1NTggLTIuNTM1NzJlLTA4WiIgZmlsbD0iIzQ0NzNGNSIvPgo8cGF0aCBkPSJNMzEuMzIwMSA2LjQwMjM0TDM3LjY3MDkgMTAuMDM4N0wyMC40NjIzIDE5Ljk3NDZMMTQuMTYyNyAxNi4yODcxTDMxLjMyMDEgNi40MDIzNFoiIGZpbGw9IiM0NDczRjUiLz4KPHBhdGggZD0iTTI4LjE5NTEgMjIuNzkyMkwzNy42MTg4IDE3LjM2MzNWMjMuNzE0MUwyOC4xOTUxIDI5LjE0M1YyMi43OTIyWiIgZmlsbD0iIzQ0NzNGNSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE0MjNfNjUyMiI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
const Images = {
  logo
};
const MAX_CARD_HEIGHT = 90;
function MarketsVenues(props) {
  const {
    title,
    onClose,
    loading: loading2,
    error: error2,
    activeView,
    activeItem,
    onNavigate,
    setDisplayMode,
    listData,
    isDevices,
    levels,
    subTitle,
    data: data2,
    hierarchy,
    ...filterProps2
  } = props;
  const [currentPage, setCurrentPage] = React__default.useState(1);
  const [pageSize, setPageSize] = React__default.useState(5);
  const [maxListHeight, setMaxListHeight] = React__default.useState("100%");
  useLayoutEffect$1(() => {
    const handleResize = () => {
      const maxListHeight2 = window.innerHeight - 242;
      const pageSize2 = Math.floor(maxListHeight2 / MAX_CARD_HEIGHT);
      setPageSize(pageSize2);
      setMaxListHeight(`${maxListHeight2}px`);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  React__default.useEffect(() => {
    setCurrentPage(1);
  }, [activeView, isDevices]);
  const paginatedData = useMemo(() => {
    const start2 = (currentPage - 1) * pageSize;
    return listData == null ? void 0 : listData.slice(start2, start2 + pageSize);
  }, [listData, currentPage, pageSize]);
  const pageHeight = React__default.useMemo(() => pageSize * MAX_CARD_HEIGHT, [pageSize]);
  const onPageChange = React__default.useCallback((page) => {
    setCurrentPage(page);
  }, []);
  const totalItems = (listData == null ? void 0 : listData.length) || 0;
  const totalPages = Math.ceil(totalItems / pageSize);
  const isMarketsVenues = activeView === "root" || activeView === "market" && !activeItem;
  const {
    getDeviceIcon
  } = useDeviceTypes();
  const showSideList = React__default.useMemo(() => ["building", "level"].includes(activeView) && (levels == null ? void 0 : levels.length) > 0, [activeView, levels == null ? void 0 : levels.length]);
  const isLoading = React__default.useMemo(() => {
    if (isDevices)
      return loading2 == null ? void 0 : loading2.devices;
    return loading2 == null ? void 0 : loading2.navigation;
  }, [isDevices, loading2 == null ? void 0 : loading2.devices, loading2 == null ? void 0 : loading2.navigation]);
  const hasError = React__default.useMemo(() => {
    if (isDevices)
      return error2 == null ? void 0 : error2.devices;
    return error2 == null ? void 0 : error2.navigation;
  }, [isDevices, error2 == null ? void 0 : error2.devices, error2 == null ? void 0 : error2.navigation]);
  const renderCardList = React__default.useMemo(() => /* @__PURE__ */ jsxs("div", { style: {
    height: `${pageHeight}px`,
    maxHeight: maxListHeight,
    overflowY: "auto"
  }, children: [
    !isLoading && !(paginatedData == null ? void 0 : paginatedData.length) && /* @__PURE__ */ jsx(Empty, { description: hasError ? "Error occurred" : "No data" }),
    /* @__PURE__ */ jsx(List$3, { loading: isLoading, children: paginatedData == null ? void 0 : paginatedData.map((item) => /* @__PURE__ */ jsxs(List$3.Item, { style: {
      padding: 0,
      margin: 0,
      width: "100%",
      border: "0px"
    }, children: [
      !isDevices && activeView === "root" && /* @__PURE__ */ jsx(MarketCard, { id: item.id, title: item.name, description: item.description, numBuildings: item.numBuildings, numAps: item.numAps, numAlerts: item.numAlerts, indicator: item.indicator, onClick: (id) => onNavigate({
        marketId: id
      }) }, item.id),
      !isDevices && activeView === "market" && /* @__PURE__ */ jsx(VenueCard, { id: item.id, title: item.name, description: item.description, numBuildings: item.numBuildings, numAps: item.numAps, numAlerts: item.numAlerts, indicator: item.indicator, isFavorite: item.isFavorite, isImportant: item.isImportant, thumbnail: Images.logo, onClick: (id) => onNavigate({
        venueId: id
      }) }, item.id),
      !isDevices && activeView === "venue" && /* @__PURE__ */ jsx(BuildingCard, { id: item.id, title: item.name, description: item.description, numLevels: item.numLevels, numAps: item.numAps, numAlerts: item.numAlerts, hasModel3d: item.hasModel3d, indicator: item.indicator, isFavorite: item.isFavorite, isImportant: item.isImportant, onClick: (id, displayMode2) => {
        onNavigate({
          buildingId: id
        });
        setDisplayMode(displayMode2);
      } }, item.id),
      isDevices && /* @__PURE__ */ jsx(DeviceCard, { getDeviceIcon, ...item }, item.id)
    ] }, item.name)) }, `${activeView}-${isDevices}`)
  ] }), [pageHeight, maxListHeight, isLoading, paginatedData, hasError, activeView, isDevices, getDeviceIcon, onNavigate, setDisplayMode]);
  const getCriticalityStatus = React__default.useCallback((level) => {
    if (!level)
      return "";
    return level.levelNumber % 3 ? "critical" : "minor";
  }, []);
  const breadcrumbItems = React__default.useMemo(() => ["market", "venue", "building", "level"].map((key) => {
    var _a3, _b3, _c2, _d2;
    return hierarchy[`${key}Id`] && ((_b3 = (_a3 = data2[key]) == null ? void 0 : _a3.object) == null ? void 0 : _b3.name) ? {
      key,
      label: (_d2 = (_c2 = data2[key]) == null ? void 0 : _c2.object) == null ? void 0 : _d2.name
    } : void 0;
  }).filter((item) => !!item), [data2, hierarchy]);
  return /* @__PURE__ */ jsxs("div", { style: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    backgroundColor: "transparent",
    height: "100%"
  }, children: [
    /* @__PURE__ */ jsxs(Space, { direction: "vertical", style: {
      width: "100%",
      height: "100%"
    }, children: [
      /* @__PURE__ */ jsxs(Space, { style: {
        alignItems: "baseline",
        marginLeft: "24px"
      }, size: "large", children: [
        /* @__PURE__ */ jsx(Button, { icon: /* @__PURE__ */ jsx(ArrowLeftOutlined, {}), onClick: onClose }),
        /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Typography.Title, { level: 3, children: "Map" }) }),
        /* @__PURE__ */ jsx(Tag, { bordered: false, color: "blue", children: title })
      ] }),
      activeItem && /* @__PURE__ */ jsxs(Space, { style: {
        alignItems: "baseline",
        paddingInline: "24px",
        width: "100%",
        justifyContent: "space-between",
        flexDirection: "column"
      }, children: [
        /* @__PURE__ */ jsx("div", { style: {
          width: "100%"
        }, children: /* @__PURE__ */ jsx(DynamicBreadcrumb, { items: breadcrumbItems, onClick: onNavigate }) }),
        /* @__PURE__ */ jsxs(Space, { style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%"
        }, children: [
          /* @__PURE__ */ jsx(Typography.Title, { level: 4, style: {
            margin: 0
          }, children: subTitle }),
          activeItem.numAlerts > 0 && /* @__PURE__ */ jsx(Tag, { bordered: false, color: "error", icon: /* @__PURE__ */ jsx(ExclamationCircleFilled, {}), children: activeItem.numAlerts })
        ] })
      ] }),
      isMarketsVenues && /* @__PURE__ */ jsx(MarketsVenuesRadio, { value: activeView === "root" ? "markets" : "venues", onChange: (view2) => onNavigate({
        rootTabId: view2
      }) }),
      /* @__PURE__ */ jsx(Filters, { setDisplayMode, onNavigate, ...filterProps2 }),
      showSideList && /* @__PURE__ */ jsxs("div", { style: {
        width: "100%",
        alignItems: "start",
        display: "flex"
      }, children: [
        /* @__PURE__ */ jsx("div", { style: {
          width: "36px"
        }, children: /* @__PURE__ */ jsx(SideList, { data: levels == null ? void 0 : levels.map((l2) => ({
          label: l2.levelNumber,
          value: getCriticalityStatus(l2),
          badge: "2D",
          id: l2.id
        })), onClick: (id) => onNavigate({
          levelId: id
        }) }) }),
        /* @__PURE__ */ jsx("div", { style: {
          width: "inherit"
        }, children: renderCardList })
      ] }),
      !showSideList && renderCardList
    ] }),
    !isLoading && totalPages > 1 && /* @__PURE__ */ jsx("div", { style: {
      width: "100%",
      padding: "16px",
      display: "flex",
      justifyContent: "center",
      marginTop: "auto"
    }, children: /* @__PURE__ */ jsx(Pagination, { align: "center", showSizeChanger: false, onChange: onPageChange, total: totalItems, pageSize, current: currentPage, showLessItems: true }) })
  ] });
}
MarketsVenues.propTypes = {
  title: propTypesExports$1.string,
  subTitle: propTypesExports$1.string,
  onClose: propTypesExports$1.func,
  loading: propTypesExports$1.object,
  error: propTypesExports$1.object,
  activeView: propTypesExports$1.oneOf(["root", "market", "venue", "building", "level"]),
  activeItem: propTypesExports$1.shape({
    id: propTypesExports$1.string,
    name: propTypesExports$1.string,
    numAlerts: propTypesExports$1.oneOf([propTypesExports$1.number, propTypesExports$1.string])
  }),
  listData: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    id: propTypesExports$1.string,
    isFavorite: propTypesExports$1.bool,
    numAlerts: propTypesExports$1.number,
    numBuildings: propTypesExports$1.number,
    numAps: propTypesExports$1.number,
    name: propTypesExports$1.string
  })),
  levels: propTypesExports$1.arrayOf(propTypesExports$1.shape({
    id: propTypesExports$1.string,
    isFavorite: propTypesExports$1.bool,
    numAlerts: propTypesExports$1.number,
    numBuildings: propTypesExports$1.number,
    numAps: propTypesExports$1.number,
    name: propTypesExports$1.string
  })),
  isDevices: propTypesExports$1.bool,
  onNavigate: propTypesExports$1.func,
  setDisplayMode: propTypesExports$1.func,
  displayMode: propTypesExports$1.oneOf(["2d", "3d"]),
  data: propTypesExports$1.object,
  hierarchy: propTypesExports$1.any
};
MarketsVenues.defaultProps = {
  title: "",
  subTitle: "",
  onClose: () => {
  },
  loading: {},
  error: {},
  activeView: void 0,
  activeItem: void 0,
  onNavigate: () => {
  },
  setDisplayMode: () => {
  },
  displayMode: "2d",
  listData: [],
  isDevices: false,
  levels: [],
  data: {},
  hierarchy: null
};
const MINIMIZED_HEIGHT = 220;
const EXPANDED_HEIGHT = 310;
const OFFSET = EXPANDED_HEIGHT - MINIMIZED_HEIGHT;
const layoutStyle = {
  width: "100%",
  height: "100%",
  overflow: "hidden"
};
const BOUNDARIES = [{
  name: "Market",
  color: "#63A4FF"
}, {
  name: "Venue",
  color: "#13C2C2"
}, {
  name: "Building",
  color: "#1677FF"
}, {
  name: "Level",
  color: "#0958D9"
}];
function MapWidget(props) {
  const {
    id,
    leftPane: leftPaneIn,
    rightPane,
    bottomPane,
    controls: controlsIn,
    viewControls: viewControlsIn,
    dragDrop,
    children,
    urlPrefix,
    initialVisibility = {},
    onSelect,
    onClose,
    ...restProps
  } = props;
  const activeTheme = useEnvStore((state) => state.env.activeTheme);
  const [isRightPaneCollapsed, setIsRightPaneCollapsed] = React__default.useState(false);
  const [isBottomPaneExpanded, setIsBottomPaneExpanded] = React__default.useState(false);
  const [layerSelection, setLayerSelection] = React__default.useState(initialVisibility || {});
  const leftPane = React__default.useMemo(() => {
    if (!leftPaneIn)
      return null;
    if (typeof leftPaneIn === "boolean" && leftPaneIn)
      return /* @__PURE__ */ jsx(MarketsVenues, {});
    return leftPaneIn;
  }, [leftPaneIn]);
  const toggleRightPane = React__default.useCallback(() => {
    setIsRightPaneCollapsed((prev) => !prev);
  }, []);
  const {
    data: data2,
    hierarchy,
    activeItem,
    activeList,
    statusSymbols,
    deviceSymbols,
    heatmapData,
    activeView,
    devices,
    zoneTypes,
    // zones,
    zoneSymbols,
    onNavigate,
    displayMode: displayMode2,
    setDisplayMode,
    center: center2,
    loading: loading2,
    error: error2
  } = useMapDataProvider();
  const {
    levels,
    ...leftPaneProps
  } = useFilters({
    rawData: data2,
    rawHierarchy: hierarchy,
    activeList,
    activeView,
    activeItem,
    devices,
    setDisplayMode,
    displayMode: displayMode2,
    onNavigate
  });
  const visibility = useVisibility({
    hierarchy,
    visibility: layerSelection
  });
  const [recenterCounter, setRecenterCounter] = React__default.useState(0);
  React__default.useEffect(() => {
    if (hierarchy == null ? void 0 : hierarchy.venueId) {
      setTimeout(() => {
        setRecenterCounter((prev) => prev + 1);
      }, 500);
    }
  }, [hierarchy == null ? void 0 : hierarchy.venueId]);
  const onLayerVisiblityChange = React__default.useCallback((key, value) => {
    setLayerSelection((prev) => ({
      ...prev,
      [key]: value
    }));
  }, []);
  const onSymbolSelect = React__default.useCallback((feature2, type) => {
    var _a3;
    const id2 = (_a3 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a3.id;
    if (!id2)
      return;
    if (type === "deviceSymbol") {
      onSelect({
        feature: feature2
      });
    } else if (type === "statusSymbol") {
      switch (feature2.properties.symbolViewContextType) {
        case "market":
          onNavigate({
            venueId: id2
          });
          onSelect({
            venueId: id2
          });
          break;
        case "venue":
          onNavigate({
            buildingId: id2
          });
          onSelect({
            buildingId: id2
          });
          break;
      }
    }
  }, [onNavigate, onSelect]);
  React__default.useEffect(() => {
    const handleResize = () => {
      window.dispatchEvent(new Event("resize"));
    };
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isRightPaneCollapsed]);
  const boundariesLegend = React__default.useMemo(() => {
    const {
      venueId,
      buildingId,
      levelId
    } = hierarchy || {};
    if (levelId) {
      return ["venue", "building", "level"].map((k2) => BOUNDARIES.find((b2) => b2.name.toLowerCase() === k2));
    }
    if (buildingId || venueId) {
      return ["market", "venue", "building"].map((k2) => BOUNDARIES.find((b2) => b2.name.toLowerCase() === k2));
    }
    return ["market", "venue"].map((k2) => BOUNDARIES.find((b2) => b2.name.toLowerCase() === k2));
  }, [hierarchy]);
  const zoneLayerProps = React__default.useMemo(() => (zoneTypes == null ? void 0 : zoneTypes.map((zoneType) => ({
    name: `${zoneType}`,
    key: `enableZone-${zoneType}`
  }))) || [], [zoneTypes]);
  const getSearchableFeatures = React__default.useCallback((data22) => {
    const searchableFeatures = [];
    const stack2 = Object.values(data22 || {});
    while (stack2.length > 0) {
      const entity = stack2.pop();
      if (!entity)
        continue;
      if (Array.isArray(entity)) {
        stack2.push(...entity);
      } else if (typeof entity === "object") {
        if (entity.id && (entity.geometry || entity.geoId || entity.venueId)) {
          searchableFeatures.push(entity);
        }
        if (entity.list && (Array.isArray(entity.list) || typeof entity.list === "object")) {
          stack2.push(entity.list);
        }
      }
    }
    return searchableFeatures;
  }, []);
  const getAllSearchableFeatures = React__default.useCallback(() => {
    const features = [];
    const addFeature = (item) => {
      var _a3, _b3;
      if (!((item == null ? void 0 : item.latitude) || ((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3.latitude) || (item == null ? void 0 : item.geometry)) || !((item == null ? void 0 : item.longitude) || ((_b3 = item == null ? void 0 : item.properties) == null ? void 0 : _b3.longitude) || (item == null ? void 0 : item.geometry)) || !item.name)
        return;
      const hasProps = !!item.properties;
      const {
        properties = {},
        geometry: geometry2,
        id: id2,
        assetType
      } = item;
      const props2 = hasProps ? {
        ...properties,
        name: properties.name,
        type: "feature",
        category: properties.entity_type
      } : {
        ...item
      };
      const coords = [props2.longitude, props2.latitude];
      let placeName = props2.name || props2.entity_id || id2;
      const finalGeometry = geometry2 || {
        type: "Point",
        coordinates: coords
      };
      if (props2.entity_type)
        placeName = `${placeName}, ${props2.entity_type}`;
      const feature2 = {
        ...hasProps ? item : {},
        type: "Feature",
        geometry: finalGeometry,
        properties: props2,
        place_name: placeName,
        place_type: [assetType || props2.entity_type],
        center: coords,
        text: props2.name || placeName,
        isSaiObject: true
      };
      features.push(feature2);
    };
    deviceSymbols == null ? void 0 : deviceSymbols.forEach(addFeature);
    getSearchableFeatures(data2).forEach(addFeature);
    return features;
  }, [deviceSymbols, getSearchableFeatures, data2]);
  const onFeatureSearchSelect = React__default.useCallback((searchFeature) => {
    if (searchFeature == null ? void 0 : searchFeature.isSaiObject) {
      onSelect({
        feature: searchFeature
      });
    }
  }, [onSelect]);
  const initializeZoneVisibilityOnceRef = React__default.useRef(false);
  React__default.useLayoutEffect(() => {
    if (!(zoneLayerProps == null ? void 0 : zoneLayerProps.length))
      return;
    if (initializeZoneVisibilityOnceRef.current)
      return;
    initializeZoneVisibilityOnceRef.current = true;
    const initialZoneVisibility = {};
    zoneLayerProps == null ? void 0 : zoneLayerProps.forEach(({
      key
    }) => {
      initialZoneVisibility[key] = true;
    });
    setLayerSelection((prev) => ({
      ...prev,
      ...initialZoneVisibility
    }));
  }, [zoneLayerProps]);
  const heightOffset = bottomPane ? isBottomPaneExpanded ? 0 : OFFSET : EXPANDED_HEIGHT - 48;
  const enableHeatmap = !!heatmapData;
  const showHeatmap = visibility == null ? void 0 : visibility.enableHeatmap;
  const enableAlerts = !(hierarchy == null ? void 0 : hierarchy.levelId) && !(hierarchy == null ? void 0 : hierarchy.buildingId);
  const commonPaneContext = React__default.useMemo(() => ({
    data: data2,
    error: error2,
    loading: loading2,
    activeItem,
    activeView,
    onNavigate,
    onSelect,
    devices,
    displayMode: displayMode2,
    setDisplayMode,
    levels,
    hierarchy
  }), [activeItem, activeView, data2, devices, displayMode2, error2, hierarchy, levels, loading2, onNavigate, onSelect, setDisplayMode]);
  const leftPaneContext = React__default.useMemo(() => ({
    ...commonPaneContext,
    ...leftPaneProps,
    onClose
  }), [commonPaneContext, leftPaneProps, onClose]);
  const rightPaneContext = React__default.useMemo(() => ({
    ...commonPaneContext,
    onClose: () => setIsRightPaneCollapsed(true)
  }), [commonPaneContext]);
  const bottomPaneContext = React__default.useMemo(() => ({
    ...commonPaneContext,
    expanded: isBottomPaneExpanded,
    setExpanded: setIsBottomPaneExpanded
  }), [commonPaneContext, isBottomPaneExpanded]);
  return /* @__PURE__ */ jsxs(Layout, { style: layoutStyle, children: [
    leftPane && /* @__PURE__ */ jsx(Layout.Sider, { height: "100%", width: "372px", theme: activeTheme, style: {
      background: "transparent"
    }, children: React__default.Children.map(leftPane, (child) => React__default.cloneElement(child, leftPaneContext)) }),
    /* @__PURE__ */ jsxs(Layout.Content, { children: [
      urlPrefix && /* @__PURE__ */ jsx(VenuePathUpdater, { prefix: urlPrefix }),
      /* @__PURE__ */ jsx(MapSection, { id, center: center2, statusSymbols: (visibility == null ? void 0 : visibility.enableZonesTab) ? zoneSymbols : statusSymbols, deviceSymbols, heatmapData, minZoom: 15, recenterCounter, dragDrop, viewControls: {
        visibility,
        displayMode: displayMode2,
        setDisplayMode,
        hierarchy,
        activeItem,
        enableAutoFocus: true,
        enableDeviceSymbol: true,
        enableStatusSymbol: true,
        enableEntityIcon: true,
        heatmapColor: visibility == null ? void 0 : visibility.heatmapColor,
        autoFocusPadding: {
          top: 50,
          bottom: 50 + bottomPane ? isBottomPaneExpanded ? EXPANDED_HEIGHT : MINIMIZED_HEIGHT : 0,
          left: 50,
          right: 50
        },
        ...viewControlsIn,
        enableHeatmap: !!enableHeatmap && !!showHeatmap
        // enable heatmap
      }, onSymbolSelect, controls: {
        enableAutoFocus: false,
        // disable inbuilt map auto focus
        enableDisplayMode: true,
        zoomProps: {
          marginVertical: 280 - heightOffset,
          marginHorizontal: 15
        },
        displayModeProps: {
          marginVertical: 404 - heightOffset,
          marginHorizontal: 3
        },
        enableLevelSelector: !!(levels == null ? void 0 : levels.length),
        levelSelectorProps: {
          marginVertical: 296 - heightOffset,
          marginHorizontal: 60,
          levels,
          onLevelSelect: (id2) => onNavigate({
            levelId: id2
          }),
          activeLevelId: hierarchy == null ? void 0 : hierarchy.levelId
        },
        enableMapFocus: true,
        mapFocusProps: {
          marginVertical: 468 - heightOffset,
          marginHorizontal: 3
        },
        attributionProps: {
          compact: !!bottomPane
        },
        enableLegend: true,
        legendPlacement: "bottom-left",
        enableLayer: true,
        layerPlacement: "top-left",
        enableLayerTreeSelect: false,
        enableLayerDropdownSelect: false,
        layertTreeSelectPlacement: "top-left",
        layerDropdownSelectPlacement: "top-right",
        ...controlsIn,
        searchProps: {
          searchables: [getAllSearchableFeatures],
          zoom: 20,
          enableMarker: false,
          onSelect: onFeatureSearchSelect
        },
        legendProps: {
          marginVertical: 324 - heightOffset,
          enableTypes: !!(deviceSymbols == null ? void 0 : deviceSymbols.length),
          // showing any AP?
          enableBands: !!(deviceSymbols == null ? void 0 : deviceSymbols.length),
          // showing any AP?
          enableBoundaries: true,
          enableAlerts,
          enableHeatmap,
          types: [{
            name: "AP",
            color: "#0b58d9"
          }],
          boundaries: boundariesLegend,
          heatmap: Heatmaps.COLOR_LEGENDS[(visibility == null ? void 0 : visibility.heatmapColor) || "single"],
          ...(controlsIn == null ? void 0 : controlsIn.legendProps) || {}
        },
        layerProps: {
          enableVenues: false,
          // removed in new figma
          enableApChannels: false,
          // removed in new figma
          enableBoundaries: true,
          enableTopology: true,
          enableHeatmap,
          enableBands: !enableAlerts,
          onChange: onLayerVisiblityChange,
          checked: visibility,
          defaultChecked: visibility,
          viewContext: [{
            name: "Buildings",
            key: "enableBuildingsTab"
          }, {
            name: "Zones",
            key: "enableZonesTab"
          }],
          boundaries: (visibility == null ? void 0 : visibility.enableZonesTab) ? zoneLayerProps || [] : [{
            name: "Markets",
            key: "enableMarket"
          }, {
            name: "Clusters",
            key: "enableCluster"
          }, {
            name: "Venues",
            key: "enableVenue"
          }, {
            name: "Buildings",
            key: "enableBuilding"
          }, {
            name: "Levels",
            key: "enableLevel"
          }],
          heatmap: [{
            name: "Single Color",
            key: "singleColor"
          }, {
            name: "Multi Color",
            key: "multiColor"
          }],
          ...(controlsIn == null ? void 0 : controlsIn.layerProps) || {}
        },
        layerTreeSelectProps: {
          marginVertical: 16,
          marginHorizontal: 16,
          data: data2,
          activeView,
          hierarchy,
          value: activeItem == null ? void 0 : activeItem.id,
          onChange: onNavigate,
          loading: loading2 == null ? void 0 : loading2.navigation,
          error: error2 == null ? void 0 : error2.navigation,
          ...(controlsIn == null ? void 0 : controlsIn.layerTreeSelectProps) || {}
        },
        layerDropdownSelectProps: {
          marginVertical: 16,
          marginHorizontal: 16,
          onChange: onNavigate,
          hierarchy,
          loading: loading2 == null ? void 0 : loading2.navigation,
          error: error2 == null ? void 0 : error2.navigation,
          ...(controlsIn == null ? void 0 : controlsIn.layerDropdownSelectProps) || {}
        }
      }, ...restProps, children }),
      rightPane && isRightPaneCollapsed && /* @__PURE__ */ jsx(RightPaneToggleButton, { onToggle: toggleRightPane, collapsed: isRightPaneCollapsed }),
      bottomPane && /* @__PURE__ */ jsx("div", { style: {
        position: "relative",
        width: "100%",
        margin: "auto"
      }, children: React__default.Children.map(bottomPane, (child) => React__default.cloneElement(child, bottomPaneContext)) })
    ] }),
    rightPane && !isRightPaneCollapsed ? /* @__PURE__ */ jsx(Layout.Sider, { height: "100%", width: "372px", theme: activeTheme, style: {
      background: "transparent",
      overflow: "scroll"
    }, children: /* @__PURE__ */ jsx("div", { style: {
      height: "100%",
      overflowY: "auto"
    }, children: React__default.Children.map(rightPane, (child) => React__default.cloneElement(child, rightPaneContext)) }) }) : null
  ] });
}
MapWidget.propTypes = {
  id: propTypesExports$1.string,
  leftPane: propTypesExports$1.node,
  rightPane: propTypesExports$1.node,
  bottomPane: propTypesExports$1.node,
  initialVisibility: propTypesExports$1.object,
  controls: propTypesExports$1.object,
  viewControls: propTypesExports$1.object,
  dragDrop: propTypesExports$1.object,
  children: propTypesExports$1.node,
  urlPrefix: propTypesExports$1.string,
  onSelect: propTypesExports$1.func,
  onClose: propTypesExports$1.func
};
MapWidget.defaultProps = {
  id: "default-id-devices-map",
  leftPane: null,
  rightPane: null,
  bottomPane: null,
  initialVisibility: {},
  controls: {},
  viewControls: {},
  dragDrop: null,
  children: null,
  urlPrefix: "",
  onSelect: () => {
  },
  onClose: () => {
  }
};
function useDesignerData(clientEnv) {
  const [isLoading, setIsLoading] = React__default.useState(false);
  const [isSaving, setIsSaving] = React__default.useState(false);
  const [hasBuildingData, setHasBuildingData] = React__default.useState([]);
  const isLoadingRef = React__default.useRef(false);
  const isSavingRef = React__default.useRef(false);
  const fetchOnceRef = React__default.useRef(false);
  const {
    saiPostgresEndpoint,
    getSaiSession
  } = clientEnv || {};
  const {
    getAccessTokenAsync
  } = useSaiSession(getSaiSession);
  const needsReload = React__default.useCallback(() => {
    fetchOnceRef.current = false;
  }, []);
  const extractHasBuildingData = React__default.useCallback((json) => {
    var _a3;
    if (!((_a3 = json == null ? void 0 : json.features) == null ? void 0 : _a3.length))
      return;
    const filteredIds = [];
    json.features.forEach((feature2) => {
      var _a4;
      if ((_a4 = feature2 == null ? void 0 : feature2.properties) == null ? void 0 : _a4.has_building_data) {
        filteredIds.push(feature2.id);
      }
    });
    setHasBuildingData((previous) => {
      const current = [...previous];
      filteredIds.forEach((id) => {
        if (!previous.includes(id)) {
          current.push(id);
        }
      });
      return current;
    });
  }, []);
  const applyHasBuildingData = React__default.useCallback((json) => {
    var _a3;
    if (!((_a3 = json == null ? void 0 : json.features) == null ? void 0 : _a3.length))
      return json;
    json.features.forEach((feature2) => {
      if (hasBuildingData.includes(feature2.id)) {
        feature2.properties.has_building_data = true;
      }
    });
    return json;
  }, [hasBuildingData]);
  const loadData = React__default.useCallback(async (id) => {
    if (fetchOnceRef.current || isLoadingRef.current)
      return null;
    isLoadingRef.current = true;
    setIsLoading(true);
    try {
      const token = await getAccessTokenAsync();
      const designerUtil = new DesignerUtil(token, saiPostgresEndpoint);
      const geojsonData = await designerUtil.restoreDesignerData(id);
      extractHasBuildingData(geojsonData);
      return geojsonData;
    } finally {
      setIsLoading(false);
      isLoadingRef.current = false;
      fetchOnceRef.current = true;
    }
  }, [getAccessTokenAsync, saiPostgresEndpoint, extractHasBuildingData]);
  const saveData = React__default.useCallback(async (jsonData) => {
    if (!fetchOnceRef.current)
      return;
    if (isSavingRef.current)
      return;
    isSavingRef.current = true;
    try {
      setIsSaving(true);
      if (jsonData) {
        const token = await getAccessTokenAsync();
        const designerUtil = new DesignerUtil(token, saiPostgresEndpoint);
        const modifiedJsonData = applyHasBuildingData(jsonData);
        await designerUtil.saveDesignerData(modifiedJsonData);
        message$1.success("Saved successfully!");
      }
    } catch (error2) {
      message$1.error("Saving failed!");
      throw error2;
    } finally {
      setIsSaving(false);
      isSavingRef.current = false;
    }
  }, [getAccessTokenAsync, saiPostgresEndpoint, applyHasBuildingData]);
  return {
    isLoading,
    isSaving,
    loadData: useMutableFunc(loadData),
    saveData: useMutableFunc(saveData),
    needsReload: useMutableFunc(needsReload)
  };
}
function DesignerStudioPath() {
  const enableVenueSubTree = useViewStore((state) => state.enableVenueSubTree);
  return /* @__PURE__ */ jsx(VenuePathUpdater, { prefix: "/designer", enabled: enableVenueSubTree });
}
const containerStyle = {
  flex: 1,
  justifyContent: "center",
  width: "100%",
  height: "100%",
  position: "fixed",
  left: "0px",
  top: "0px"
};
const spinnerStyle = {
  position: "absolute",
  textAlign: "center",
  zIndex: 1e4,
  width: "100vw",
  height: "100vh",
  paddingTop: "20%",
  backgroundColor: "rgba(0, 0, 0, 0.10)"
};
const defaultCameraProps = {
  bearing: 0,
  zoom: 15.4
};
const imageStyle = {
  // width: '21px',
  // height: '24px',
  // margin: '20px 0px 0px 0px',
  // border: 'none',
};
function DesignStudioWidget(props) {
  const {
    center: centerIn,
    cameraProps: cameraProps2 = defaultCameraProps,
    id: editDataId = null,
    onError,
    onClose: onCloseIn,
    children,
    apps,
    env,
    activeTheme,
    configProps
  } = props;
  const {
    isLoading,
    isSaving,
    saveData,
    loadData,
    needsReload
  } = useDesignerData(env);
  const {
    deviceTypes
  } = useDeviceTypes();
  const [center2] = React__default.useState(centerIn);
  const [data2, setData6] = React__default.useState();
  React__default.useLayoutEffect(() => {
    const safeLoadData = async (id) => {
      try {
        needsReload();
        return await loadData(id);
      } catch (error2) {
        console.error(`Error in Loading data: `, error2);
        onError(error2);
      }
      return null;
    };
    if (editDataId) {
      safeLoadData(editDataId).then(setData6);
    } else {
      const dynamicLoadData = (context2) => {
        const {
          enableVenueSubTree,
          activeVenueId
        } = context2 || {};
        let id = null;
        if (enableVenueSubTree && activeVenueId) {
          id = activeVenueId;
        }
        return safeLoadData(id);
      };
      setData6(() => dynamicLoadData);
    }
  }, [loadData, editDataId, needsReload, onError]);
  const onClose = React__default.useCallback(async (jsonData) => {
    if (!jsonData) {
      onCloseIn();
    } else {
      try {
        await saveData(jsonData);
      } catch (err) {
        console.error(`Error in saving data: `, err);
      }
    }
  }, [onCloseIn, saveData]);
  const isBusy = isLoading || isSaving;
  return /* @__PURE__ */ jsxs("div", { style: containerStyle, children: [
    /* @__PURE__ */ jsx("div", { style: {
      ...spinnerStyle,
      display: isBusy ? "block" : "none"
    }, children: /* @__PURE__ */ jsx(Spin, { spinning: isBusy }) }),
    /* @__PURE__ */ jsxs(SaiMapProvider, { id: `design-studio-${editDataId}`, data: data2, camera: cameraProps2, center: center2, saveAsGeoJson: true, onClose, designer: true, legacy: false, logo: /* @__PURE__ */ jsx(Image$1, { preview: false, style: imageStyle, src: Images.logo, alt: "logo", width: 21, height: 24 }), apps, minZoom: 0, maxZoom: 24, env, activeTheme, configProps, deviceTypes, children: [
      children,
      /* @__PURE__ */ jsx(DesignerStudioPath, {}),
      /* @__PURE__ */ jsx(LayerSorter, { filter: (id) => id.startsWith("sai-") })
    ] })
  ] });
}
DesignStudioWidget.propTypes = {
  center: propTypesExports$1.array,
  cameraProps: propTypesExports$1.object,
  id: propTypesExports$1.string,
  // Neptune objectid
  children: propTypesExports$1.node,
  onError: propTypesExports$1.func,
  onClose: propTypesExports$1.func,
  apps: propTypesExports$1.node,
  env: propTypesExports$1.shape({
    getSaiSession: propTypesExports$1.func,
    saiPostgresEndpoint: propTypesExports$1.string,
    mapboxToken: propTypesExports$1.string,
    cesiumToken: propTypesExports$1.string,
    bingApiKey: propTypesExports$1.string
  }),
  activeTheme: propTypesExports$1.string,
  configProps: propTypesExports$1.object
};
DesignStudioWidget.defaultProps = {
  center: null,
  cameraProps: defaultCameraProps,
  id: null,
  children: null,
  onError: () => {
  },
  onClose: () => {
  },
  apps: null,
  env: {},
  activeTheme: "light",
  configProps: null
};
export {
  GeoJsonLayer as $,
  AutoFocusSelector as A,
  useDeviceTypeStore as B,
  MapboxDropAction as C,
  DisplayImpl as D,
  ExtrudeGeometry as E,
  FeatureEditor as F,
  GeojsonEditor as G,
  useDragDropItem as H,
  ICONS as I,
  ObjectTypeIcons as J,
  LazyMap as K,
  LercParameters as L,
  MapConfigProvider as M,
  useCursor as N,
  ObjectTypes as O,
  MapResizer as P,
  OsmBuildingsPoi as Q,
  OsmBuildings as R,
  TilesSelector as S,
  TooltipHandler as T,
  CameraFocus as U,
  VenueMapFragment as V,
  FlooredBuilding as W,
  ExtrusionLayer as X,
  FillLayer as Y,
  GeoJsonExtrusionLayer as Z,
  GeoJsonFillLayer as _,
  LercAddCompression as a,
  Fonts as a$,
  ThreeLoaderLayer as a0,
  ImageLayer as a1,
  ImageLayer2 as a2,
  LineLayer as a3,
  Tiles2dLayer as a4,
  Tiles3dLayer as a5,
  CadLayer as a6,
  CesiumIonAssetLayer as a7,
  CircleLayer as a8,
  ClusterSource as a9,
  DownloadControls as aA,
  DrawControls as aB,
  DxfToGeoJson as aC,
  GeocoderControl as aD,
  BoxDragControls as aE,
  BoxRotateControls as aF,
  BoxScaleControls as aG,
  BoxLayer as aH,
  BoxEditableLayer as aI,
  BoxEditMenu as aJ,
  OpacitySlider as aK,
  BoxOpacityControls as aL,
  ImageSkewControls as aM,
  ImageSnapControls as aN,
  MapButtonControl as aO,
  MapClickPointsReceiver as aP,
  Object3dExportToGlbCesium as aQ,
  OpenFileControls as aR,
  PropertySetterControls as aS,
  SplitPane as aT,
  SymbolDragControls as aU,
  TextFileExporter as aV,
  TilesControls as aW,
  TransformControls as aX,
  ZoomControls as aY,
  LayerSorter as aZ,
  Images$1 as a_,
  ExtrusionLayer2 as aa,
  FillLayer2 as ab,
  HeatmapLayer as ac,
  LineLayer2 as ad,
  PointLayer2 as ae,
  SymbolLayer as af,
  ModelLayer as ag,
  GeojsonModelLayer as ah,
  Interactions as ai,
  useDoubleSelection as aj,
  useHover as ak,
  useSelection as al,
  MapFitBounds as am,
  MapTilesConstants as an,
  useEnvStore as ao,
  MapFitFeature as ap,
  MapFitSourceLayer as aq,
  Tiles3dLayer$2 as ar,
  DeckGlOverlay as as,
  Heatmap as at,
  ScatterPlot as au,
  useMapboxDeckGlOverlay as av,
  MapboxDeckGlOverlayProvider as aw,
  Hexmap as ax,
  Quadmap as ay,
  H3Map as az,
  EditorImpl as b,
  hashCode as b$,
  LevelSelector3 as b0,
  AccessPoints as b1,
  FeaturesView as b2,
  ArrayInput as b3,
  ColorInput as b4,
  MapLayout as b5,
  MenuBar as b6,
  ModalForm as b7,
  TextLabel as b8,
  ToggleButton as b9,
  useMapbox as bA,
  useValueRef as bB,
  useMutableFunc as bC,
  useUserLocation as bD,
  CoordinateUtil as bE,
  FileUtil as bF,
  GeoUtil as bG,
  generateUid as bH,
  CesiumIonUtil as bI,
  ColorUtil as bJ,
  ImageUtil$1 as bK,
  GltfUtil as bL,
  PdfUtil as bM,
  ImportUtil as bN,
  FileParserUtil as bO,
  debounce$3 as bP,
  DxfUtil as bQ,
  STYLE_PROPS as bR,
  getFeatureStyle as bS,
  applyFeatureStyle as bT,
  applyPaintProperty as bU,
  DRAW_POINT_STYLE as bV,
  DRAW_POLYGON_STYLE as bW,
  truncateDecimal as bX,
  pushArray as bY,
  mergeArray as bZ,
  uniqueArray as b_,
  UploadBox as ba,
  Input$1 as bb,
  InputNumber as bc,
  Select as bd,
  Modal as be,
  FullModal as bf,
  showMessageBox as bg,
  NoModalOverlay as bh,
  UnitSelect as bi,
  InputLength as bj,
  useInputLength as bk,
  NumberSlider as bl,
  FormItemLatLon as bm,
  Indicator$1 as bn,
  LegendInfo as bo,
  RightPanel as bp,
  AlphaPicker as bq,
  CollapsibleOverlayPanel as br,
  LevelSelector$1 as bs,
  NoModalNoOverlay as bt,
  NonBlockingModal as bu,
  ObjectButton as bv,
  OverlayPanel as bw,
  PopOverMenuItems as bx,
  useEditGeojson as by,
  useLayoutDimensions as bz,
  GeojsonEditorModal as c,
  removeArray as c0,
  makeFirstLetterCapital as c1,
  makeFirstLetterSmall as c2,
  parsePadding as c3,
  getFileType as c4,
  toCamelCase as c5,
  GeocoderUtil as c6,
  SaiMapProvider as c7,
  MapViewController as c8,
  MapDroppable as c9,
  MapDataUtil as cA,
  TextUtil as cB,
  useSaiSession as cC,
  useFilterMapData as cD,
  useFetchMapData as cE,
  MapDataProvider as cF,
  useMapDataProvider as cG,
  UseMapDataProvider as cH,
  DeviceSymbols as ca,
  StatusSymbols as cb,
  VectorTiles as cc,
  Footprint as cd,
  ModelLoader as ce,
  LayerTreeSelect as cf,
  LayerDropdownSelect as cg,
  VectorHeatmap as ch,
  VenuePathUpdater as ci,
  VectorTerritory as cj,
  MapWidget as ck,
  MapSection as cl,
  DesignStudioWidget as cm,
  useDeviceTypes as cn,
  DeviceTypesContext as co,
  UseDeviceTypes as cp,
  DesignerUtil as cq,
  DeviceUtil as cr,
  S3Util as cs,
  MiscUtil as ct,
  useService as cu,
  useApi as cv,
  useFetch as cw,
  useParallelFetch as cx,
  NeptuneUtil as cy,
  UrlUtil as cz,
  useJsonExporter as d,
  useJsonLoader as e,
  FeaturesControls as f,
  MapAutoFocus as g,
  AutoFocusOnSelectedItem as h,
  index$3 as i,
  useSiteStore as j,
  useViewStore as k,
  useAssetStore as l,
  useConfigStore as m,
  useMaterialStore as n,
  useFeatures as o,
  useFeaturesAdvanced as p,
  useAssets as q,
  AssetHelper as r,
  snap_svg$1 as s,
  useProjectStore as t,
  useMapConfigStore as u,
  useMaterialPropStore as v,
  useSiteObjectTypes as w,
  useSiteObjectStatistics as x,
  useMCRTypesMeta as y,
  findHierarchy as z
};
